/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
(function(global, factory) { /* global define, require, module */

    /* AMD */ if (typeof define === 'function' && define.amd)
        define(["protobufjs/minimal"], factory);

    /* CommonJS */ else if (typeof require === 'function' && typeof module === 'object' && module && module.exports)
        module.exports = factory(require("protobufjs/minimal"));

})(this, function($protobuf) {
    "use strict";

    // Common aliases
    var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;
    
    // Exported root namespace
    var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});
    
    $root.palexy = (function() {
    
        /**
         * Namespace palexy.
         * @exports palexy
         * @namespace
         */
        var palexy = {};
    
        palexy.sherlock = (function() {
    
            /**
             * Namespace sherlock.
             * @memberof palexy
             * @namespace
             */
            var sherlock = {};
    
            sherlock.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.sherlock
                 * @namespace
                 */
                var v1 = {};
    
                v1.SherlockTask = (function() {
    
                    /**
                     * Properties of a SherlockTask.
                     * @memberof palexy.sherlock.v1
                     * @interface ISherlockTask
                     * @property {palexy.sherlock.v1.ITaskAdvanceInfo|null} [taskAdvanceInfo] SherlockTask taskAdvanceInfo
                     * @property {palexy.sherlock.v1.SherlockTask.TaskStatus|null} [taskStatus] SherlockTask taskStatus
                     * @property {google.protobuf.ITimestamp|null} [createTime] SherlockTask createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] SherlockTask lastUpdateTime
                     * @property {google.protobuf.ITimestamp|null} [startProcessingTime] SherlockTask startProcessingTime
                     * @property {google.protobuf.ITimestamp|null} [endProcessingTime] SherlockTask endProcessingTime
                     * @property {boolean|null} [generateBbLevelDetail] SherlockTask generateBbLevelDetail
                     * @property {string|null} [name] SherlockTask name
                     * @property {palexy.sherlock.v1.SherlockTask.TaskType|null} [taskType] SherlockTask taskType
                     * @property {string|null} [displayName] SherlockTask displayName
                     * @property {number|null} [id] SherlockTask id
                     * @property {number|null} [storeConfigId] SherlockTask storeConfigId
                     * @property {Array.<palexy.sherlock.v1.ISherlockTaskResult>|null} [taskResults] SherlockTask taskResults
                     */
    
                    /**
                     * Constructs a new SherlockTask.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a SherlockTask.
                     * @implements ISherlockTask
                     * @constructor
                     * @param {palexy.sherlock.v1.ISherlockTask=} [properties] Properties to set
                     */
                    function SherlockTask(properties) {
                        this.taskResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SherlockTask taskAdvanceInfo.
                     * @member {palexy.sherlock.v1.ITaskAdvanceInfo|null|undefined} taskAdvanceInfo
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.taskAdvanceInfo = null;
    
                    /**
                     * SherlockTask taskStatus.
                     * @member {palexy.sherlock.v1.SherlockTask.TaskStatus} taskStatus
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.taskStatus = 0;
    
                    /**
                     * SherlockTask createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.createTime = null;
    
                    /**
                     * SherlockTask lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.lastUpdateTime = null;
    
                    /**
                     * SherlockTask startProcessingTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} startProcessingTime
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.startProcessingTime = null;
    
                    /**
                     * SherlockTask endProcessingTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} endProcessingTime
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.endProcessingTime = null;
    
                    /**
                     * SherlockTask generateBbLevelDetail.
                     * @member {boolean} generateBbLevelDetail
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.generateBbLevelDetail = false;
    
                    /**
                     * SherlockTask name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.name = "";
    
                    /**
                     * SherlockTask taskType.
                     * @member {palexy.sherlock.v1.SherlockTask.TaskType} taskType
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.taskType = 0;
    
                    /**
                     * SherlockTask displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.displayName = "";
    
                    /**
                     * SherlockTask id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SherlockTask storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SherlockTask taskResults.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTaskResult>} taskResults
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     */
                    SherlockTask.prototype.taskResults = $util.emptyArray;
    
                    /**
                     * Creates a new SherlockTask instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTask=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.SherlockTask} SherlockTask instance
                     */
                    SherlockTask.create = function create(properties) {
                        return new SherlockTask(properties);
                    };
    
                    /**
                     * Encodes the specified SherlockTask message. Does not implicitly {@link palexy.sherlock.v1.SherlockTask.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTask} message SherlockTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTask.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskAdvanceInfo != null && Object.hasOwnProperty.call(message, "taskAdvanceInfo"))
                            $root.palexy.sherlock.v1.TaskAdvanceInfo.encode(message.taskAdvanceInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.taskStatus != null && Object.hasOwnProperty.call(message, "taskStatus"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.taskStatus);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.startProcessingTime != null && Object.hasOwnProperty.call(message, "startProcessingTime"))
                            $root.google.protobuf.Timestamp.encode(message.startProcessingTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.endProcessingTime != null && Object.hasOwnProperty.call(message, "endProcessingTime"))
                            $root.google.protobuf.Timestamp.encode(message.endProcessingTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.generateBbLevelDetail != null && Object.hasOwnProperty.call(message, "generateBbLevelDetail"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.generateBbLevelDetail);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.name);
                        if (message.taskType != null && Object.hasOwnProperty.call(message, "taskType"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.taskType);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.displayName);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.id);
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.storeConfigId);
                        if (message.taskResults != null && message.taskResults.length)
                            for (var i = 0; i < message.taskResults.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTaskResult.encode(message.taskResults[i], writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SherlockTask message, length delimited. Does not implicitly {@link palexy.sherlock.v1.SherlockTask.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTask} message SherlockTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTask.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SherlockTask message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.SherlockTask} SherlockTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTask.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.SherlockTask();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskAdvanceInfo = $root.palexy.sherlock.v1.TaskAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.taskStatus = reader.int32();
                                break;
                            case 3:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.startProcessingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.endProcessingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.generateBbLevelDetail = reader.bool();
                                break;
                            case 8:
                                message.name = reader.string();
                                break;
                            case 9:
                                message.taskType = reader.int32();
                                break;
                            case 10:
                                message.displayName = reader.string();
                                break;
                            case 11:
                                message.id = reader.int64();
                                break;
                            case 12:
                                message.storeConfigId = reader.int64();
                                break;
                            case 13:
                                if (!(message.taskResults && message.taskResults.length))
                                    message.taskResults = [];
                                message.taskResults.push($root.palexy.sherlock.v1.SherlockTaskResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SherlockTask message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.SherlockTask} SherlockTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTask.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SherlockTask message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SherlockTask.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskAdvanceInfo != null && message.hasOwnProperty("taskAdvanceInfo")) {
                            var error = $root.palexy.sherlock.v1.TaskAdvanceInfo.verify(message.taskAdvanceInfo);
                            if (error)
                                return "taskAdvanceInfo." + error;
                        }
                        if (message.taskStatus != null && message.hasOwnProperty("taskStatus"))
                            switch (message.taskStatus) {
                            default:
                                return "taskStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.startProcessingTime != null && message.hasOwnProperty("startProcessingTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.startProcessingTime);
                            if (error)
                                return "startProcessingTime." + error;
                        }
                        if (message.endProcessingTime != null && message.hasOwnProperty("endProcessingTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.endProcessingTime);
                            if (error)
                                return "endProcessingTime." + error;
                        }
                        if (message.generateBbLevelDetail != null && message.hasOwnProperty("generateBbLevelDetail"))
                            if (typeof message.generateBbLevelDetail !== "boolean")
                                return "generateBbLevelDetail: boolean expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            switch (message.taskType) {
                            default:
                                return "taskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                                break;
                            }
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.taskResults != null && message.hasOwnProperty("taskResults")) {
                            if (!Array.isArray(message.taskResults))
                                return "taskResults: array expected";
                            for (var i = 0; i < message.taskResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTaskResult.verify(message.taskResults[i]);
                                if (error)
                                    return "taskResults." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SherlockTask message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.SherlockTask} SherlockTask
                     */
                    SherlockTask.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.SherlockTask)
                            return object;
                        var message = new $root.palexy.sherlock.v1.SherlockTask();
                        if (object.taskAdvanceInfo != null) {
                            if (typeof object.taskAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.taskAdvanceInfo: object expected");
                            message.taskAdvanceInfo = $root.palexy.sherlock.v1.TaskAdvanceInfo.fromObject(object.taskAdvanceInfo);
                        }
                        switch (object.taskStatus) {
                        case "STATUS_UNKNOWN":
                        case 0:
                            message.taskStatus = 0;
                            break;
                        case "STATUS_CREATED":
                        case 1:
                            message.taskStatus = 1;
                            break;
                        case "STATUS_DONE":
                        case 2:
                            message.taskStatus = 2;
                            break;
                        case "STATUS_FAILED":
                        case 3:
                            message.taskStatus = 3;
                            break;
                        }
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        if (object.startProcessingTime != null) {
                            if (typeof object.startProcessingTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.startProcessingTime: object expected");
                            message.startProcessingTime = $root.google.protobuf.Timestamp.fromObject(object.startProcessingTime);
                        }
                        if (object.endProcessingTime != null) {
                            if (typeof object.endProcessingTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.endProcessingTime: object expected");
                            message.endProcessingTime = $root.google.protobuf.Timestamp.fromObject(object.endProcessingTime);
                        }
                        if (object.generateBbLevelDetail != null)
                            message.generateBbLevelDetail = Boolean(object.generateBbLevelDetail);
                        if (object.name != null)
                            message.name = String(object.name);
                        switch (object.taskType) {
                        case "TYPE_UNKNOWN":
                        case 0:
                            message.taskType = 0;
                            break;
                        case "TYPE_TEST":
                        case 1:
                            message.taskType = 1;
                            break;
                        case "TYPE_DEBUG_PERSON":
                        case 2:
                            message.taskType = 2;
                            break;
                        case "TYPE_EXTRACT_TRACKLET":
                        case 3:
                            message.taskType = 3;
                            break;
                        case "TYPE_DELETE_TASK_FILES":
                        case 4:
                            message.taskType = 4;
                            break;
                        case "TYPE_CALCULATE_MERGE_ACCURACY":
                        case 5:
                            message.taskType = 5;
                            break;
                        case "TYPE_EXECUTE_POST_MERGE_CONFIG":
                        case 6:
                            message.taskType = 6;
                            break;
                        case "TYPE_SCAN_MERGE_CONFIG":
                        case 7:
                            message.taskType = 7;
                            break;
                        case "TYPE_RERUN_MERGE_CONFIG":
                        case 8:
                            message.taskType = 8;
                            break;
                        case "TYPE_DEBUG_EXPERIMENT":
                        case 9:
                            message.taskType = 9;
                            break;
                        case "TYPE_PREPARE_QC_VIDEOS":
                        case 10:
                            message.taskType = 10;
                            break;
                        case "TYPE_HS_COLLECT_REID":
                        case 11:
                            message.taskType = 11;
                            break;
                        case "TYPE_TINKER_POST_PROCESS":
                        case 12:
                            message.taskType = 12;
                            break;
                        case "TYPE_FORECAST_GENERATE":
                        case 13:
                            message.taskType = 13;
                            break;
                        case "TYPE_EXPORT_HAKUHODO":
                        case 14:
                            message.taskType = 14;
                            break;
                        case "TYPE_EXPORT_OSOOL_EVENTS":
                        case 15:
                            message.taskType = 15;
                            break;
                        case "TYPE_HAKUHODO_JOIN_PARTIAL_MERGING_RESULTS":
                        case 16:
                            message.taskType = 16;
                            break;
                        case "TYPE_HAKUHODO_EDIT_TRAFFIC":
                        case 17:
                            message.taskType = 17;
                            break;
                        case "TYPE_HAKUHODO_EXTRAPOLATE_DEMOGRAPHY":
                        case 18:
                            message.taskType = 18;
                            break;
                        case "TYPE_BATCH_DELETE_VIDEOS":
                        case 19:
                            message.taskType = 19;
                            break;
                        case "TYPE_BUILD_SEED":
                        case 20:
                            message.taskType = 20;
                            break;
                        case "TYPE_FINE_TUNE_HAKUHODO_STORE":
                        case 21:
                            message.taskType = 21;
                            break;
                        }
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        if (object.taskResults) {
                            if (!Array.isArray(object.taskResults))
                                throw TypeError(".palexy.sherlock.v1.SherlockTask.taskResults: array expected");
                            message.taskResults = [];
                            for (var i = 0; i < object.taskResults.length; ++i) {
                                if (typeof object.taskResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.SherlockTask.taskResults: object expected");
                                message.taskResults[i] = $root.palexy.sherlock.v1.SherlockTaskResult.fromObject(object.taskResults[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SherlockTask message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @static
                     * @param {palexy.sherlock.v1.SherlockTask} message SherlockTask
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SherlockTask.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskResults = [];
                        if (options.defaults) {
                            object.taskAdvanceInfo = null;
                            object.taskStatus = options.enums === String ? "STATUS_UNKNOWN" : 0;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            object.startProcessingTime = null;
                            object.endProcessingTime = null;
                            object.generateBbLevelDetail = false;
                            object.name = "";
                            object.taskType = options.enums === String ? "TYPE_UNKNOWN" : 0;
                            object.displayName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                        }
                        if (message.taskAdvanceInfo != null && message.hasOwnProperty("taskAdvanceInfo"))
                            object.taskAdvanceInfo = $root.palexy.sherlock.v1.TaskAdvanceInfo.toObject(message.taskAdvanceInfo, options);
                        if (message.taskStatus != null && message.hasOwnProperty("taskStatus"))
                            object.taskStatus = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.TaskStatus[message.taskStatus] : message.taskStatus;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.startProcessingTime != null && message.hasOwnProperty("startProcessingTime"))
                            object.startProcessingTime = $root.google.protobuf.Timestamp.toObject(message.startProcessingTime, options);
                        if (message.endProcessingTime != null && message.hasOwnProperty("endProcessingTime"))
                            object.endProcessingTime = $root.google.protobuf.Timestamp.toObject(message.endProcessingTime, options);
                        if (message.generateBbLevelDetail != null && message.hasOwnProperty("generateBbLevelDetail"))
                            object.generateBbLevelDetail = message.generateBbLevelDetail;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            object.taskType = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.TaskType[message.taskType] : message.taskType;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.taskResults && message.taskResults.length) {
                            object.taskResults = [];
                            for (var j = 0; j < message.taskResults.length; ++j)
                                object.taskResults[j] = $root.palexy.sherlock.v1.SherlockTaskResult.toObject(message.taskResults[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SherlockTask to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.SherlockTask
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SherlockTask.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * TaskType enum.
                     * @name palexy.sherlock.v1.SherlockTask.TaskType
                     * @enum {number}
                     * @property {number} TYPE_UNKNOWN=0 TYPE_UNKNOWN value
                     * @property {number} TYPE_TEST=1 TYPE_TEST value
                     * @property {number} TYPE_DEBUG_PERSON=2 TYPE_DEBUG_PERSON value
                     * @property {number} TYPE_EXTRACT_TRACKLET=3 TYPE_EXTRACT_TRACKLET value
                     * @property {number} TYPE_DELETE_TASK_FILES=4 TYPE_DELETE_TASK_FILES value
                     * @property {number} TYPE_CALCULATE_MERGE_ACCURACY=5 TYPE_CALCULATE_MERGE_ACCURACY value
                     * @property {number} TYPE_EXECUTE_POST_MERGE_CONFIG=6 TYPE_EXECUTE_POST_MERGE_CONFIG value
                     * @property {number} TYPE_SCAN_MERGE_CONFIG=7 TYPE_SCAN_MERGE_CONFIG value
                     * @property {number} TYPE_RERUN_MERGE_CONFIG=8 TYPE_RERUN_MERGE_CONFIG value
                     * @property {number} TYPE_DEBUG_EXPERIMENT=9 TYPE_DEBUG_EXPERIMENT value
                     * @property {number} TYPE_PREPARE_QC_VIDEOS=10 TYPE_PREPARE_QC_VIDEOS value
                     * @property {number} TYPE_HS_COLLECT_REID=11 TYPE_HS_COLLECT_REID value
                     * @property {number} TYPE_TINKER_POST_PROCESS=12 TYPE_TINKER_POST_PROCESS value
                     * @property {number} TYPE_FORECAST_GENERATE=13 TYPE_FORECAST_GENERATE value
                     * @property {number} TYPE_EXPORT_HAKUHODO=14 TYPE_EXPORT_HAKUHODO value
                     * @property {number} TYPE_EXPORT_OSOOL_EVENTS=15 TYPE_EXPORT_OSOOL_EVENTS value
                     * @property {number} TYPE_HAKUHODO_JOIN_PARTIAL_MERGING_RESULTS=16 TYPE_HAKUHODO_JOIN_PARTIAL_MERGING_RESULTS value
                     * @property {number} TYPE_HAKUHODO_EDIT_TRAFFIC=17 TYPE_HAKUHODO_EDIT_TRAFFIC value
                     * @property {number} TYPE_HAKUHODO_EXTRAPOLATE_DEMOGRAPHY=18 TYPE_HAKUHODO_EXTRAPOLATE_DEMOGRAPHY value
                     * @property {number} TYPE_BATCH_DELETE_VIDEOS=19 TYPE_BATCH_DELETE_VIDEOS value
                     * @property {number} TYPE_BUILD_SEED=20 TYPE_BUILD_SEED value
                     * @property {number} TYPE_FINE_TUNE_HAKUHODO_STORE=21 TYPE_FINE_TUNE_HAKUHODO_STORE value
                     */
                    SherlockTask.TaskType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "TYPE_TEST"] = 1;
                        values[valuesById[2] = "TYPE_DEBUG_PERSON"] = 2;
                        values[valuesById[3] = "TYPE_EXTRACT_TRACKLET"] = 3;
                        values[valuesById[4] = "TYPE_DELETE_TASK_FILES"] = 4;
                        values[valuesById[5] = "TYPE_CALCULATE_MERGE_ACCURACY"] = 5;
                        values[valuesById[6] = "TYPE_EXECUTE_POST_MERGE_CONFIG"] = 6;
                        values[valuesById[7] = "TYPE_SCAN_MERGE_CONFIG"] = 7;
                        values[valuesById[8] = "TYPE_RERUN_MERGE_CONFIG"] = 8;
                        values[valuesById[9] = "TYPE_DEBUG_EXPERIMENT"] = 9;
                        values[valuesById[10] = "TYPE_PREPARE_QC_VIDEOS"] = 10;
                        values[valuesById[11] = "TYPE_HS_COLLECT_REID"] = 11;
                        values[valuesById[12] = "TYPE_TINKER_POST_PROCESS"] = 12;
                        values[valuesById[13] = "TYPE_FORECAST_GENERATE"] = 13;
                        values[valuesById[14] = "TYPE_EXPORT_HAKUHODO"] = 14;
                        values[valuesById[15] = "TYPE_EXPORT_OSOOL_EVENTS"] = 15;
                        values[valuesById[16] = "TYPE_HAKUHODO_JOIN_PARTIAL_MERGING_RESULTS"] = 16;
                        values[valuesById[17] = "TYPE_HAKUHODO_EDIT_TRAFFIC"] = 17;
                        values[valuesById[18] = "TYPE_HAKUHODO_EXTRAPOLATE_DEMOGRAPHY"] = 18;
                        values[valuesById[19] = "TYPE_BATCH_DELETE_VIDEOS"] = 19;
                        values[valuesById[20] = "TYPE_BUILD_SEED"] = 20;
                        values[valuesById[21] = "TYPE_FINE_TUNE_HAKUHODO_STORE"] = 21;
                        return values;
                    })();
    
                    /**
                     * TaskStatus enum.
                     * @name palexy.sherlock.v1.SherlockTask.TaskStatus
                     * @enum {number}
                     * @property {number} STATUS_UNKNOWN=0 STATUS_UNKNOWN value
                     * @property {number} STATUS_CREATED=1 STATUS_CREATED value
                     * @property {number} STATUS_DONE=2 STATUS_DONE value
                     * @property {number} STATUS_FAILED=3 STATUS_FAILED value
                     */
                    SherlockTask.TaskStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATUS_UNKNOWN"] = 0;
                        values[valuesById[1] = "STATUS_CREATED"] = 1;
                        values[valuesById[2] = "STATUS_DONE"] = 2;
                        values[valuesById[3] = "STATUS_FAILED"] = 3;
                        return values;
                    })();
    
                    /**
                     * StorageProvider enum.
                     * @name palexy.sherlock.v1.SherlockTask.StorageProvider
                     * @enum {number}
                     * @property {number} UNKNOWN_PROVIDER=0 UNKNOWN_PROVIDER value
                     * @property {number} GCP=1 GCP value
                     * @property {number} GOOGLE_DRIVE=2 GOOGLE_DRIVE value
                     */
                    SherlockTask.StorageProvider = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_PROVIDER"] = 0;
                        values[valuesById[1] = "GCP"] = 1;
                        values[valuesById[2] = "GOOGLE_DRIVE"] = 2;
                        return values;
                    })();
    
                    return SherlockTask;
                })();
    
                v1.TaskAdvanceInfo = (function() {
    
                    /**
                     * Properties of a TaskAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface ITaskAdvanceInfo
                     * @property {palexy.sherlock.v1.IDebugPersonAdvanceInfo|null} [debugPersonAdvanceInfo] TaskAdvanceInfo debugPersonAdvanceInfo
                     * @property {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo|null} [calculateMergeAccuracyAdvanceInfo] TaskAdvanceInfo calculateMergeAccuracyAdvanceInfo
                     * @property {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo|null} [executePostMergeConfigAdvanceInfo] TaskAdvanceInfo executePostMergeConfigAdvanceInfo
                     * @property {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo|null} [deleteTaskFilesAdvanceInfo] TaskAdvanceInfo deleteTaskFilesAdvanceInfo
                     * @property {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo|null} [scanMergeConfigAdvanceInfo] TaskAdvanceInfo scanMergeConfigAdvanceInfo
                     * @property {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo|null} [rerunMergeConfigAdvanceInfo] TaskAdvanceInfo rerunMergeConfigAdvanceInfo
                     * @property {palexy.sherlock.v1.IDebugExperimentAdvanceInfo|null} [debugExperimentAdvanceInfo] TaskAdvanceInfo debugExperimentAdvanceInfo
                     * @property {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo|null} [prepareQcVideosAdvanceInfo] TaskAdvanceInfo prepareQcVideosAdvanceInfo
                     * @property {palexy.sherlock.v1.IHSCollectReidAdvanceInfo|null} [hsCollectReidAdvanceInfo] TaskAdvanceInfo hsCollectReidAdvanceInfo
                     * @property {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo|null} [tinkerPostProcessAdvanceInfo] TaskAdvanceInfo tinkerPostProcessAdvanceInfo
                     * @property {palexy.sherlock.v1.IForecastGenerateAdvanceInfo|null} [forecastGenerateAdvanceInfo] TaskAdvanceInfo forecastGenerateAdvanceInfo
                     * @property {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo|null} [exportHakuhodoAdvanceInfo] TaskAdvanceInfo exportHakuhodoAdvanceInfo
                     * @property {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo|null} [exportOsoolEventsAdvanceInfo] TaskAdvanceInfo exportOsoolEventsAdvanceInfo
                     * @property {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo|null} [hakuhodoJoinPartialMergingResultsAdvanceInfo] TaskAdvanceInfo hakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @property {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo|null} [hakuhodoEditTrafficAdvanceInfo] TaskAdvanceInfo hakuhodoEditTrafficAdvanceInfo
                     * @property {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo|null} [hakuhodoExtrapolateDemographyAdvanceInfo] TaskAdvanceInfo hakuhodoExtrapolateDemographyAdvanceInfo
                     * @property {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo|null} [batchDeleteVideosAdvanceInfo] TaskAdvanceInfo batchDeleteVideosAdvanceInfo
                     * @property {palexy.sherlock.v1.IBuildSeedAdvanceInfo|null} [buildSeedAdvanceInfo] TaskAdvanceInfo buildSeedAdvanceInfo
                     * @property {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo|null} [fineTuneHakuhodoStoreAdvanceInfo] TaskAdvanceInfo fineTuneHakuhodoStoreAdvanceInfo
                     */
    
                    /**
                     * Constructs a new TaskAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a TaskAdvanceInfo.
                     * @implements ITaskAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.ITaskAdvanceInfo=} [properties] Properties to set
                     */
                    function TaskAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskAdvanceInfo debugPersonAdvanceInfo.
                     * @member {palexy.sherlock.v1.IDebugPersonAdvanceInfo|null|undefined} debugPersonAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.debugPersonAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo calculateMergeAccuracyAdvanceInfo.
                     * @member {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo|null|undefined} calculateMergeAccuracyAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.calculateMergeAccuracyAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo executePostMergeConfigAdvanceInfo.
                     * @member {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo|null|undefined} executePostMergeConfigAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.executePostMergeConfigAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo deleteTaskFilesAdvanceInfo.
                     * @member {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo|null|undefined} deleteTaskFilesAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.deleteTaskFilesAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo scanMergeConfigAdvanceInfo.
                     * @member {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo|null|undefined} scanMergeConfigAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.scanMergeConfigAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo rerunMergeConfigAdvanceInfo.
                     * @member {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo|null|undefined} rerunMergeConfigAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.rerunMergeConfigAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo debugExperimentAdvanceInfo.
                     * @member {palexy.sherlock.v1.IDebugExperimentAdvanceInfo|null|undefined} debugExperimentAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.debugExperimentAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo prepareQcVideosAdvanceInfo.
                     * @member {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo|null|undefined} prepareQcVideosAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.prepareQcVideosAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo hsCollectReidAdvanceInfo.
                     * @member {palexy.sherlock.v1.IHSCollectReidAdvanceInfo|null|undefined} hsCollectReidAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.hsCollectReidAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo tinkerPostProcessAdvanceInfo.
                     * @member {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo|null|undefined} tinkerPostProcessAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.tinkerPostProcessAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo forecastGenerateAdvanceInfo.
                     * @member {palexy.sherlock.v1.IForecastGenerateAdvanceInfo|null|undefined} forecastGenerateAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.forecastGenerateAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo exportHakuhodoAdvanceInfo.
                     * @member {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo|null|undefined} exportHakuhodoAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.exportHakuhodoAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo exportOsoolEventsAdvanceInfo.
                     * @member {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo|null|undefined} exportOsoolEventsAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.exportOsoolEventsAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo hakuhodoJoinPartialMergingResultsAdvanceInfo.
                     * @member {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo|null|undefined} hakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.hakuhodoJoinPartialMergingResultsAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo hakuhodoEditTrafficAdvanceInfo.
                     * @member {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo|null|undefined} hakuhodoEditTrafficAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.hakuhodoEditTrafficAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo hakuhodoExtrapolateDemographyAdvanceInfo.
                     * @member {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo|null|undefined} hakuhodoExtrapolateDemographyAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.hakuhodoExtrapolateDemographyAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo batchDeleteVideosAdvanceInfo.
                     * @member {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo|null|undefined} batchDeleteVideosAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.batchDeleteVideosAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo buildSeedAdvanceInfo.
                     * @member {palexy.sherlock.v1.IBuildSeedAdvanceInfo|null|undefined} buildSeedAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.buildSeedAdvanceInfo = null;
    
                    /**
                     * TaskAdvanceInfo fineTuneHakuhodoStoreAdvanceInfo.
                     * @member {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo|null|undefined} fineTuneHakuhodoStoreAdvanceInfo
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    TaskAdvanceInfo.prototype.fineTuneHakuhodoStoreAdvanceInfo = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * TaskAdvanceInfo advanceInfoOneof.
                     * @member {"debugPersonAdvanceInfo"|"calculateMergeAccuracyAdvanceInfo"|"executePostMergeConfigAdvanceInfo"|"deleteTaskFilesAdvanceInfo"|"scanMergeConfigAdvanceInfo"|"rerunMergeConfigAdvanceInfo"|"debugExperimentAdvanceInfo"|"prepareQcVideosAdvanceInfo"|"hsCollectReidAdvanceInfo"|"tinkerPostProcessAdvanceInfo"|"forecastGenerateAdvanceInfo"|"exportHakuhodoAdvanceInfo"|"exportOsoolEventsAdvanceInfo"|"hakuhodoJoinPartialMergingResultsAdvanceInfo"|"hakuhodoEditTrafficAdvanceInfo"|"hakuhodoExtrapolateDemographyAdvanceInfo"|"batchDeleteVideosAdvanceInfo"|"buildSeedAdvanceInfo"|"fineTuneHakuhodoStoreAdvanceInfo"|undefined} advanceInfoOneof
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     */
                    Object.defineProperty(TaskAdvanceInfo.prototype, "advanceInfoOneof", {
                        get: $util.oneOfGetter($oneOfFields = ["debugPersonAdvanceInfo", "calculateMergeAccuracyAdvanceInfo", "executePostMergeConfigAdvanceInfo", "deleteTaskFilesAdvanceInfo", "scanMergeConfigAdvanceInfo", "rerunMergeConfigAdvanceInfo", "debugExperimentAdvanceInfo", "prepareQcVideosAdvanceInfo", "hsCollectReidAdvanceInfo", "tinkerPostProcessAdvanceInfo", "forecastGenerateAdvanceInfo", "exportHakuhodoAdvanceInfo", "exportOsoolEventsAdvanceInfo", "hakuhodoJoinPartialMergingResultsAdvanceInfo", "hakuhodoEditTrafficAdvanceInfo", "hakuhodoExtrapolateDemographyAdvanceInfo", "batchDeleteVideosAdvanceInfo", "buildSeedAdvanceInfo", "fineTuneHakuhodoStoreAdvanceInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new TaskAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITaskAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.TaskAdvanceInfo} TaskAdvanceInfo instance
                     */
                    TaskAdvanceInfo.create = function create(properties) {
                        return new TaskAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified TaskAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.TaskAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITaskAdvanceInfo} message TaskAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.debugPersonAdvanceInfo != null && Object.hasOwnProperty.call(message, "debugPersonAdvanceInfo"))
                            $root.palexy.sherlock.v1.DebugPersonAdvanceInfo.encode(message.debugPersonAdvanceInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.calculateMergeAccuracyAdvanceInfo != null && Object.hasOwnProperty.call(message, "calculateMergeAccuracyAdvanceInfo"))
                            $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.encode(message.calculateMergeAccuracyAdvanceInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.executePostMergeConfigAdvanceInfo != null && Object.hasOwnProperty.call(message, "executePostMergeConfigAdvanceInfo"))
                            $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.encode(message.executePostMergeConfigAdvanceInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.deleteTaskFilesAdvanceInfo != null && Object.hasOwnProperty.call(message, "deleteTaskFilesAdvanceInfo"))
                            $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.encode(message.deleteTaskFilesAdvanceInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.scanMergeConfigAdvanceInfo != null && Object.hasOwnProperty.call(message, "scanMergeConfigAdvanceInfo"))
                            $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.encode(message.scanMergeConfigAdvanceInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.rerunMergeConfigAdvanceInfo != null && Object.hasOwnProperty.call(message, "rerunMergeConfigAdvanceInfo"))
                            $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.encode(message.rerunMergeConfigAdvanceInfo, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.debugExperimentAdvanceInfo != null && Object.hasOwnProperty.call(message, "debugExperimentAdvanceInfo"))
                            $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo.encode(message.debugExperimentAdvanceInfo, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.prepareQcVideosAdvanceInfo != null && Object.hasOwnProperty.call(message, "prepareQcVideosAdvanceInfo"))
                            $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.encode(message.prepareQcVideosAdvanceInfo, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.hsCollectReidAdvanceInfo != null && Object.hasOwnProperty.call(message, "hsCollectReidAdvanceInfo"))
                            $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo.encode(message.hsCollectReidAdvanceInfo, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.tinkerPostProcessAdvanceInfo != null && Object.hasOwnProperty.call(message, "tinkerPostProcessAdvanceInfo"))
                            $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.encode(message.tinkerPostProcessAdvanceInfo, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.forecastGenerateAdvanceInfo != null && Object.hasOwnProperty.call(message, "forecastGenerateAdvanceInfo"))
                            $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo.encode(message.forecastGenerateAdvanceInfo, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.exportHakuhodoAdvanceInfo != null && Object.hasOwnProperty.call(message, "exportHakuhodoAdvanceInfo"))
                            $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.encode(message.exportHakuhodoAdvanceInfo, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.exportOsoolEventsAdvanceInfo != null && Object.hasOwnProperty.call(message, "exportOsoolEventsAdvanceInfo"))
                            $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.encode(message.exportOsoolEventsAdvanceInfo, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.hakuhodoJoinPartialMergingResultsAdvanceInfo != null && Object.hasOwnProperty.call(message, "hakuhodoJoinPartialMergingResultsAdvanceInfo"))
                            $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.encode(message.hakuhodoJoinPartialMergingResultsAdvanceInfo, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.hakuhodoEditTrafficAdvanceInfo != null && Object.hasOwnProperty.call(message, "hakuhodoEditTrafficAdvanceInfo"))
                            $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.encode(message.hakuhodoEditTrafficAdvanceInfo, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.hakuhodoExtrapolateDemographyAdvanceInfo != null && Object.hasOwnProperty.call(message, "hakuhodoExtrapolateDemographyAdvanceInfo"))
                            $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.encode(message.hakuhodoExtrapolateDemographyAdvanceInfo, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.batchDeleteVideosAdvanceInfo != null && Object.hasOwnProperty.call(message, "batchDeleteVideosAdvanceInfo"))
                            $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.encode(message.batchDeleteVideosAdvanceInfo, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.buildSeedAdvanceInfo != null && Object.hasOwnProperty.call(message, "buildSeedAdvanceInfo"))
                            $root.palexy.sherlock.v1.BuildSeedAdvanceInfo.encode(message.buildSeedAdvanceInfo, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.fineTuneHakuhodoStoreAdvanceInfo != null && Object.hasOwnProperty.call(message, "fineTuneHakuhodoStoreAdvanceInfo"))
                            $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.encode(message.fineTuneHakuhodoStoreAdvanceInfo, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TaskAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITaskAdvanceInfo} message TaskAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.TaskAdvanceInfo} TaskAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TaskAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.debugPersonAdvanceInfo = $root.palexy.sherlock.v1.DebugPersonAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.calculateMergeAccuracyAdvanceInfo = $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.executePostMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.deleteTaskFilesAdvanceInfo = $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.scanMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.rerunMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.debugExperimentAdvanceInfo = $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.prepareQcVideosAdvanceInfo = $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.hsCollectReidAdvanceInfo = $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.tinkerPostProcessAdvanceInfo = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.forecastGenerateAdvanceInfo = $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.exportHakuhodoAdvanceInfo = $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.exportOsoolEventsAdvanceInfo = $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.hakuhodoJoinPartialMergingResultsAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.hakuhodoEditTrafficAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.hakuhodoExtrapolateDemographyAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.batchDeleteVideosAdvanceInfo = $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.buildSeedAdvanceInfo = $root.palexy.sherlock.v1.BuildSeedAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            case 19:
                                message.fineTuneHakuhodoStoreAdvanceInfo = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.TaskAdvanceInfo} TaskAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.debugPersonAdvanceInfo != null && message.hasOwnProperty("debugPersonAdvanceInfo")) {
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.DebugPersonAdvanceInfo.verify(message.debugPersonAdvanceInfo);
                                if (error)
                                    return "debugPersonAdvanceInfo." + error;
                            }
                        }
                        if (message.calculateMergeAccuracyAdvanceInfo != null && message.hasOwnProperty("calculateMergeAccuracyAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.verify(message.calculateMergeAccuracyAdvanceInfo);
                                if (error)
                                    return "calculateMergeAccuracyAdvanceInfo." + error;
                            }
                        }
                        if (message.executePostMergeConfigAdvanceInfo != null && message.hasOwnProperty("executePostMergeConfigAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.verify(message.executePostMergeConfigAdvanceInfo);
                                if (error)
                                    return "executePostMergeConfigAdvanceInfo." + error;
                            }
                        }
                        if (message.deleteTaskFilesAdvanceInfo != null && message.hasOwnProperty("deleteTaskFilesAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.verify(message.deleteTaskFilesAdvanceInfo);
                                if (error)
                                    return "deleteTaskFilesAdvanceInfo." + error;
                            }
                        }
                        if (message.scanMergeConfigAdvanceInfo != null && message.hasOwnProperty("scanMergeConfigAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.verify(message.scanMergeConfigAdvanceInfo);
                                if (error)
                                    return "scanMergeConfigAdvanceInfo." + error;
                            }
                        }
                        if (message.rerunMergeConfigAdvanceInfo != null && message.hasOwnProperty("rerunMergeConfigAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.verify(message.rerunMergeConfigAdvanceInfo);
                                if (error)
                                    return "rerunMergeConfigAdvanceInfo." + error;
                            }
                        }
                        if (message.debugExperimentAdvanceInfo != null && message.hasOwnProperty("debugExperimentAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo.verify(message.debugExperimentAdvanceInfo);
                                if (error)
                                    return "debugExperimentAdvanceInfo." + error;
                            }
                        }
                        if (message.prepareQcVideosAdvanceInfo != null && message.hasOwnProperty("prepareQcVideosAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.verify(message.prepareQcVideosAdvanceInfo);
                                if (error)
                                    return "prepareQcVideosAdvanceInfo." + error;
                            }
                        }
                        if (message.hsCollectReidAdvanceInfo != null && message.hasOwnProperty("hsCollectReidAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo.verify(message.hsCollectReidAdvanceInfo);
                                if (error)
                                    return "hsCollectReidAdvanceInfo." + error;
                            }
                        }
                        if (message.tinkerPostProcessAdvanceInfo != null && message.hasOwnProperty("tinkerPostProcessAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.verify(message.tinkerPostProcessAdvanceInfo);
                                if (error)
                                    return "tinkerPostProcessAdvanceInfo." + error;
                            }
                        }
                        if (message.forecastGenerateAdvanceInfo != null && message.hasOwnProperty("forecastGenerateAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo.verify(message.forecastGenerateAdvanceInfo);
                                if (error)
                                    return "forecastGenerateAdvanceInfo." + error;
                            }
                        }
                        if (message.exportHakuhodoAdvanceInfo != null && message.hasOwnProperty("exportHakuhodoAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.verify(message.exportHakuhodoAdvanceInfo);
                                if (error)
                                    return "exportHakuhodoAdvanceInfo." + error;
                            }
                        }
                        if (message.exportOsoolEventsAdvanceInfo != null && message.hasOwnProperty("exportOsoolEventsAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.verify(message.exportOsoolEventsAdvanceInfo);
                                if (error)
                                    return "exportOsoolEventsAdvanceInfo." + error;
                            }
                        }
                        if (message.hakuhodoJoinPartialMergingResultsAdvanceInfo != null && message.hasOwnProperty("hakuhodoJoinPartialMergingResultsAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.verify(message.hakuhodoJoinPartialMergingResultsAdvanceInfo);
                                if (error)
                                    return "hakuhodoJoinPartialMergingResultsAdvanceInfo." + error;
                            }
                        }
                        if (message.hakuhodoEditTrafficAdvanceInfo != null && message.hasOwnProperty("hakuhodoEditTrafficAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.verify(message.hakuhodoEditTrafficAdvanceInfo);
                                if (error)
                                    return "hakuhodoEditTrafficAdvanceInfo." + error;
                            }
                        }
                        if (message.hakuhodoExtrapolateDemographyAdvanceInfo != null && message.hasOwnProperty("hakuhodoExtrapolateDemographyAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.verify(message.hakuhodoExtrapolateDemographyAdvanceInfo);
                                if (error)
                                    return "hakuhodoExtrapolateDemographyAdvanceInfo." + error;
                            }
                        }
                        if (message.batchDeleteVideosAdvanceInfo != null && message.hasOwnProperty("batchDeleteVideosAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.verify(message.batchDeleteVideosAdvanceInfo);
                                if (error)
                                    return "batchDeleteVideosAdvanceInfo." + error;
                            }
                        }
                        if (message.buildSeedAdvanceInfo != null && message.hasOwnProperty("buildSeedAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.BuildSeedAdvanceInfo.verify(message.buildSeedAdvanceInfo);
                                if (error)
                                    return "buildSeedAdvanceInfo." + error;
                            }
                        }
                        if (message.fineTuneHakuhodoStoreAdvanceInfo != null && message.hasOwnProperty("fineTuneHakuhodoStoreAdvanceInfo")) {
                            if (properties.advanceInfoOneof === 1)
                                return "advanceInfoOneof: multiple values";
                            properties.advanceInfoOneof = 1;
                            {
                                var error = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.verify(message.fineTuneHakuhodoStoreAdvanceInfo);
                                if (error)
                                    return "fineTuneHakuhodoStoreAdvanceInfo." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TaskAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.TaskAdvanceInfo} TaskAdvanceInfo
                     */
                    TaskAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.TaskAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.TaskAdvanceInfo();
                        if (object.debugPersonAdvanceInfo != null) {
                            if (typeof object.debugPersonAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.debugPersonAdvanceInfo: object expected");
                            message.debugPersonAdvanceInfo = $root.palexy.sherlock.v1.DebugPersonAdvanceInfo.fromObject(object.debugPersonAdvanceInfo);
                        }
                        if (object.calculateMergeAccuracyAdvanceInfo != null) {
                            if (typeof object.calculateMergeAccuracyAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.calculateMergeAccuracyAdvanceInfo: object expected");
                            message.calculateMergeAccuracyAdvanceInfo = $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.fromObject(object.calculateMergeAccuracyAdvanceInfo);
                        }
                        if (object.executePostMergeConfigAdvanceInfo != null) {
                            if (typeof object.executePostMergeConfigAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.executePostMergeConfigAdvanceInfo: object expected");
                            message.executePostMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.fromObject(object.executePostMergeConfigAdvanceInfo);
                        }
                        if (object.deleteTaskFilesAdvanceInfo != null) {
                            if (typeof object.deleteTaskFilesAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.deleteTaskFilesAdvanceInfo: object expected");
                            message.deleteTaskFilesAdvanceInfo = $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.fromObject(object.deleteTaskFilesAdvanceInfo);
                        }
                        if (object.scanMergeConfigAdvanceInfo != null) {
                            if (typeof object.scanMergeConfigAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.scanMergeConfigAdvanceInfo: object expected");
                            message.scanMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.fromObject(object.scanMergeConfigAdvanceInfo);
                        }
                        if (object.rerunMergeConfigAdvanceInfo != null) {
                            if (typeof object.rerunMergeConfigAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.rerunMergeConfigAdvanceInfo: object expected");
                            message.rerunMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.fromObject(object.rerunMergeConfigAdvanceInfo);
                        }
                        if (object.debugExperimentAdvanceInfo != null) {
                            if (typeof object.debugExperimentAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.debugExperimentAdvanceInfo: object expected");
                            message.debugExperimentAdvanceInfo = $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo.fromObject(object.debugExperimentAdvanceInfo);
                        }
                        if (object.prepareQcVideosAdvanceInfo != null) {
                            if (typeof object.prepareQcVideosAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.prepareQcVideosAdvanceInfo: object expected");
                            message.prepareQcVideosAdvanceInfo = $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.fromObject(object.prepareQcVideosAdvanceInfo);
                        }
                        if (object.hsCollectReidAdvanceInfo != null) {
                            if (typeof object.hsCollectReidAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.hsCollectReidAdvanceInfo: object expected");
                            message.hsCollectReidAdvanceInfo = $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo.fromObject(object.hsCollectReidAdvanceInfo);
                        }
                        if (object.tinkerPostProcessAdvanceInfo != null) {
                            if (typeof object.tinkerPostProcessAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.tinkerPostProcessAdvanceInfo: object expected");
                            message.tinkerPostProcessAdvanceInfo = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.fromObject(object.tinkerPostProcessAdvanceInfo);
                        }
                        if (object.forecastGenerateAdvanceInfo != null) {
                            if (typeof object.forecastGenerateAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.forecastGenerateAdvanceInfo: object expected");
                            message.forecastGenerateAdvanceInfo = $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo.fromObject(object.forecastGenerateAdvanceInfo);
                        }
                        if (object.exportHakuhodoAdvanceInfo != null) {
                            if (typeof object.exportHakuhodoAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.exportHakuhodoAdvanceInfo: object expected");
                            message.exportHakuhodoAdvanceInfo = $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.fromObject(object.exportHakuhodoAdvanceInfo);
                        }
                        if (object.exportOsoolEventsAdvanceInfo != null) {
                            if (typeof object.exportOsoolEventsAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.exportOsoolEventsAdvanceInfo: object expected");
                            message.exportOsoolEventsAdvanceInfo = $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.fromObject(object.exportOsoolEventsAdvanceInfo);
                        }
                        if (object.hakuhodoJoinPartialMergingResultsAdvanceInfo != null) {
                            if (typeof object.hakuhodoJoinPartialMergingResultsAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.hakuhodoJoinPartialMergingResultsAdvanceInfo: object expected");
                            message.hakuhodoJoinPartialMergingResultsAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.fromObject(object.hakuhodoJoinPartialMergingResultsAdvanceInfo);
                        }
                        if (object.hakuhodoEditTrafficAdvanceInfo != null) {
                            if (typeof object.hakuhodoEditTrafficAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.hakuhodoEditTrafficAdvanceInfo: object expected");
                            message.hakuhodoEditTrafficAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.fromObject(object.hakuhodoEditTrafficAdvanceInfo);
                        }
                        if (object.hakuhodoExtrapolateDemographyAdvanceInfo != null) {
                            if (typeof object.hakuhodoExtrapolateDemographyAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.hakuhodoExtrapolateDemographyAdvanceInfo: object expected");
                            message.hakuhodoExtrapolateDemographyAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.fromObject(object.hakuhodoExtrapolateDemographyAdvanceInfo);
                        }
                        if (object.batchDeleteVideosAdvanceInfo != null) {
                            if (typeof object.batchDeleteVideosAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.batchDeleteVideosAdvanceInfo: object expected");
                            message.batchDeleteVideosAdvanceInfo = $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.fromObject(object.batchDeleteVideosAdvanceInfo);
                        }
                        if (object.buildSeedAdvanceInfo != null) {
                            if (typeof object.buildSeedAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.buildSeedAdvanceInfo: object expected");
                            message.buildSeedAdvanceInfo = $root.palexy.sherlock.v1.BuildSeedAdvanceInfo.fromObject(object.buildSeedAdvanceInfo);
                        }
                        if (object.fineTuneHakuhodoStoreAdvanceInfo != null) {
                            if (typeof object.fineTuneHakuhodoStoreAdvanceInfo !== "object")
                                throw TypeError(".palexy.sherlock.v1.TaskAdvanceInfo.fineTuneHakuhodoStoreAdvanceInfo: object expected");
                            message.fineTuneHakuhodoStoreAdvanceInfo = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.fromObject(object.fineTuneHakuhodoStoreAdvanceInfo);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.TaskAdvanceInfo} message TaskAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.debugPersonAdvanceInfo != null && message.hasOwnProperty("debugPersonAdvanceInfo")) {
                            object.debugPersonAdvanceInfo = $root.palexy.sherlock.v1.DebugPersonAdvanceInfo.toObject(message.debugPersonAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "debugPersonAdvanceInfo";
                        }
                        if (message.calculateMergeAccuracyAdvanceInfo != null && message.hasOwnProperty("calculateMergeAccuracyAdvanceInfo")) {
                            object.calculateMergeAccuracyAdvanceInfo = $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.toObject(message.calculateMergeAccuracyAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "calculateMergeAccuracyAdvanceInfo";
                        }
                        if (message.executePostMergeConfigAdvanceInfo != null && message.hasOwnProperty("executePostMergeConfigAdvanceInfo")) {
                            object.executePostMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.toObject(message.executePostMergeConfigAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "executePostMergeConfigAdvanceInfo";
                        }
                        if (message.deleteTaskFilesAdvanceInfo != null && message.hasOwnProperty("deleteTaskFilesAdvanceInfo")) {
                            object.deleteTaskFilesAdvanceInfo = $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.toObject(message.deleteTaskFilesAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "deleteTaskFilesAdvanceInfo";
                        }
                        if (message.scanMergeConfigAdvanceInfo != null && message.hasOwnProperty("scanMergeConfigAdvanceInfo")) {
                            object.scanMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.toObject(message.scanMergeConfigAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "scanMergeConfigAdvanceInfo";
                        }
                        if (message.rerunMergeConfigAdvanceInfo != null && message.hasOwnProperty("rerunMergeConfigAdvanceInfo")) {
                            object.rerunMergeConfigAdvanceInfo = $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.toObject(message.rerunMergeConfigAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "rerunMergeConfigAdvanceInfo";
                        }
                        if (message.debugExperimentAdvanceInfo != null && message.hasOwnProperty("debugExperimentAdvanceInfo")) {
                            object.debugExperimentAdvanceInfo = $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo.toObject(message.debugExperimentAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "debugExperimentAdvanceInfo";
                        }
                        if (message.prepareQcVideosAdvanceInfo != null && message.hasOwnProperty("prepareQcVideosAdvanceInfo")) {
                            object.prepareQcVideosAdvanceInfo = $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.toObject(message.prepareQcVideosAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "prepareQcVideosAdvanceInfo";
                        }
                        if (message.hsCollectReidAdvanceInfo != null && message.hasOwnProperty("hsCollectReidAdvanceInfo")) {
                            object.hsCollectReidAdvanceInfo = $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo.toObject(message.hsCollectReidAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "hsCollectReidAdvanceInfo";
                        }
                        if (message.tinkerPostProcessAdvanceInfo != null && message.hasOwnProperty("tinkerPostProcessAdvanceInfo")) {
                            object.tinkerPostProcessAdvanceInfo = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.toObject(message.tinkerPostProcessAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "tinkerPostProcessAdvanceInfo";
                        }
                        if (message.forecastGenerateAdvanceInfo != null && message.hasOwnProperty("forecastGenerateAdvanceInfo")) {
                            object.forecastGenerateAdvanceInfo = $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo.toObject(message.forecastGenerateAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "forecastGenerateAdvanceInfo";
                        }
                        if (message.exportHakuhodoAdvanceInfo != null && message.hasOwnProperty("exportHakuhodoAdvanceInfo")) {
                            object.exportHakuhodoAdvanceInfo = $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.toObject(message.exportHakuhodoAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "exportHakuhodoAdvanceInfo";
                        }
                        if (message.exportOsoolEventsAdvanceInfo != null && message.hasOwnProperty("exportOsoolEventsAdvanceInfo")) {
                            object.exportOsoolEventsAdvanceInfo = $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.toObject(message.exportOsoolEventsAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "exportOsoolEventsAdvanceInfo";
                        }
                        if (message.hakuhodoJoinPartialMergingResultsAdvanceInfo != null && message.hasOwnProperty("hakuhodoJoinPartialMergingResultsAdvanceInfo")) {
                            object.hakuhodoJoinPartialMergingResultsAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.toObject(message.hakuhodoJoinPartialMergingResultsAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "hakuhodoJoinPartialMergingResultsAdvanceInfo";
                        }
                        if (message.hakuhodoEditTrafficAdvanceInfo != null && message.hasOwnProperty("hakuhodoEditTrafficAdvanceInfo")) {
                            object.hakuhodoEditTrafficAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.toObject(message.hakuhodoEditTrafficAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "hakuhodoEditTrafficAdvanceInfo";
                        }
                        if (message.hakuhodoExtrapolateDemographyAdvanceInfo != null && message.hasOwnProperty("hakuhodoExtrapolateDemographyAdvanceInfo")) {
                            object.hakuhodoExtrapolateDemographyAdvanceInfo = $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.toObject(message.hakuhodoExtrapolateDemographyAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "hakuhodoExtrapolateDemographyAdvanceInfo";
                        }
                        if (message.batchDeleteVideosAdvanceInfo != null && message.hasOwnProperty("batchDeleteVideosAdvanceInfo")) {
                            object.batchDeleteVideosAdvanceInfo = $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.toObject(message.batchDeleteVideosAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "batchDeleteVideosAdvanceInfo";
                        }
                        if (message.buildSeedAdvanceInfo != null && message.hasOwnProperty("buildSeedAdvanceInfo")) {
                            object.buildSeedAdvanceInfo = $root.palexy.sherlock.v1.BuildSeedAdvanceInfo.toObject(message.buildSeedAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "buildSeedAdvanceInfo";
                        }
                        if (message.fineTuneHakuhodoStoreAdvanceInfo != null && message.hasOwnProperty("fineTuneHakuhodoStoreAdvanceInfo")) {
                            object.fineTuneHakuhodoStoreAdvanceInfo = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.toObject(message.fineTuneHakuhodoStoreAdvanceInfo, options);
                            if (options.oneofs)
                                object.advanceInfoOneof = "fineTuneHakuhodoStoreAdvanceInfo";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TaskAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.TaskAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskAdvanceInfo;
                })();
    
                v1.DebugPersonAdvanceInfo = (function() {
    
                    /**
                     * Properties of a DebugPersonAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IDebugPersonAdvanceInfo
                     * @property {palexy.sherlock.v1.IPersonFilter|null} [personFilter] DebugPersonAdvanceInfo personFilter
                     * @property {boolean|null} [includeFfmpegResults] DebugPersonAdvanceInfo includeFfmpegResults
                     */
    
                    /**
                     * Constructs a new DebugPersonAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DebugPersonAdvanceInfo.
                     * @implements IDebugPersonAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IDebugPersonAdvanceInfo=} [properties] Properties to set
                     */
                    function DebugPersonAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DebugPersonAdvanceInfo personFilter.
                     * @member {palexy.sherlock.v1.IPersonFilter|null|undefined} personFilter
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @instance
                     */
                    DebugPersonAdvanceInfo.prototype.personFilter = null;
    
                    /**
                     * DebugPersonAdvanceInfo includeFfmpegResults.
                     * @member {boolean} includeFfmpegResults
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @instance
                     */
                    DebugPersonAdvanceInfo.prototype.includeFfmpegResults = false;
    
                    /**
                     * Creates a new DebugPersonAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DebugPersonAdvanceInfo} DebugPersonAdvanceInfo instance
                     */
                    DebugPersonAdvanceInfo.create = function create(properties) {
                        return new DebugPersonAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified DebugPersonAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.DebugPersonAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonAdvanceInfo} message DebugPersonAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugPersonAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.personFilter != null && Object.hasOwnProperty.call(message, "personFilter"))
                            $root.palexy.sherlock.v1.PersonFilter.encode(message.personFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.includeFfmpegResults != null && Object.hasOwnProperty.call(message, "includeFfmpegResults"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeFfmpegResults);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DebugPersonAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DebugPersonAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonAdvanceInfo} message DebugPersonAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugPersonAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DebugPersonAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DebugPersonAdvanceInfo} DebugPersonAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugPersonAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DebugPersonAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.personFilter = $root.palexy.sherlock.v1.PersonFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.includeFfmpegResults = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DebugPersonAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DebugPersonAdvanceInfo} DebugPersonAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugPersonAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DebugPersonAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DebugPersonAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.personFilter != null && message.hasOwnProperty("personFilter")) {
                            var error = $root.palexy.sherlock.v1.PersonFilter.verify(message.personFilter);
                            if (error)
                                return "personFilter." + error;
                        }
                        if (message.includeFfmpegResults != null && message.hasOwnProperty("includeFfmpegResults"))
                            if (typeof message.includeFfmpegResults !== "boolean")
                                return "includeFfmpegResults: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a DebugPersonAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DebugPersonAdvanceInfo} DebugPersonAdvanceInfo
                     */
                    DebugPersonAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DebugPersonAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DebugPersonAdvanceInfo();
                        if (object.personFilter != null) {
                            if (typeof object.personFilter !== "object")
                                throw TypeError(".palexy.sherlock.v1.DebugPersonAdvanceInfo.personFilter: object expected");
                            message.personFilter = $root.palexy.sherlock.v1.PersonFilter.fromObject(object.personFilter);
                        }
                        if (object.includeFfmpegResults != null)
                            message.includeFfmpegResults = Boolean(object.includeFfmpegResults);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DebugPersonAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.DebugPersonAdvanceInfo} message DebugPersonAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DebugPersonAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.personFilter = null;
                            object.includeFfmpegResults = false;
                        }
                        if (message.personFilter != null && message.hasOwnProperty("personFilter"))
                            object.personFilter = $root.palexy.sherlock.v1.PersonFilter.toObject(message.personFilter, options);
                        if (message.includeFfmpegResults != null && message.hasOwnProperty("includeFfmpegResults"))
                            object.includeFfmpegResults = message.includeFfmpegResults;
                        return object;
                    };
    
                    /**
                     * Converts this DebugPersonAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DebugPersonAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DebugPersonAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DebugPersonAdvanceInfo;
                })();
    
                v1.DebugExperimentAdvanceInfo = (function() {
    
                    /**
                     * Properties of a DebugExperimentAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IDebugExperimentAdvanceInfo
                     * @property {palexy.sherlock.v1.IExperimentFilter|null} [experimentFilter] DebugExperimentAdvanceInfo experimentFilter
                     */
    
                    /**
                     * Constructs a new DebugExperimentAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DebugExperimentAdvanceInfo.
                     * @implements IDebugExperimentAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IDebugExperimentAdvanceInfo=} [properties] Properties to set
                     */
                    function DebugExperimentAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DebugExperimentAdvanceInfo experimentFilter.
                     * @member {palexy.sherlock.v1.IExperimentFilter|null|undefined} experimentFilter
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @instance
                     */
                    DebugExperimentAdvanceInfo.prototype.experimentFilter = null;
    
                    /**
                     * Creates a new DebugExperimentAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DebugExperimentAdvanceInfo} DebugExperimentAdvanceInfo instance
                     */
                    DebugExperimentAdvanceInfo.create = function create(properties) {
                        return new DebugExperimentAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified DebugExperimentAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.DebugExperimentAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentAdvanceInfo} message DebugExperimentAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugExperimentAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experimentFilter != null && Object.hasOwnProperty.call(message, "experimentFilter"))
                            $root.palexy.sherlock.v1.ExperimentFilter.encode(message.experimentFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DebugExperimentAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DebugExperimentAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentAdvanceInfo} message DebugExperimentAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugExperimentAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DebugExperimentAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DebugExperimentAdvanceInfo} DebugExperimentAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugExperimentAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experimentFilter = $root.palexy.sherlock.v1.ExperimentFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DebugExperimentAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DebugExperimentAdvanceInfo} DebugExperimentAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugExperimentAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DebugExperimentAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DebugExperimentAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experimentFilter != null && message.hasOwnProperty("experimentFilter")) {
                            var error = $root.palexy.sherlock.v1.ExperimentFilter.verify(message.experimentFilter);
                            if (error)
                                return "experimentFilter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DebugExperimentAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DebugExperimentAdvanceInfo} DebugExperimentAdvanceInfo
                     */
                    DebugExperimentAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DebugExperimentAdvanceInfo();
                        if (object.experimentFilter != null) {
                            if (typeof object.experimentFilter !== "object")
                                throw TypeError(".palexy.sherlock.v1.DebugExperimentAdvanceInfo.experimentFilter: object expected");
                            message.experimentFilter = $root.palexy.sherlock.v1.ExperimentFilter.fromObject(object.experimentFilter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DebugExperimentAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.DebugExperimentAdvanceInfo} message DebugExperimentAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DebugExperimentAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experimentFilter = null;
                        if (message.experimentFilter != null && message.hasOwnProperty("experimentFilter"))
                            object.experimentFilter = $root.palexy.sherlock.v1.ExperimentFilter.toObject(message.experimentFilter, options);
                        return object;
                    };
    
                    /**
                     * Converts this DebugExperimentAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DebugExperimentAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DebugExperimentAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DebugExperimentAdvanceInfo;
                })();
    
                v1.CalculateMergeAccuracyAdvanceInfo = (function() {
    
                    /**
                     * Properties of a CalculateMergeAccuracyAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface ICalculateMergeAccuracyAdvanceInfo
                     * @property {Array.<palexy.sherlock.v1.IPredictedAndLabelItem>|null} [predictAndLabelItems] CalculateMergeAccuracyAdvanceInfo predictAndLabelItems
                     */
    
                    /**
                     * Constructs a new CalculateMergeAccuracyAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CalculateMergeAccuracyAdvanceInfo.
                     * @implements ICalculateMergeAccuracyAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo=} [properties] Properties to set
                     */
                    function CalculateMergeAccuracyAdvanceInfo(properties) {
                        this.predictAndLabelItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateMergeAccuracyAdvanceInfo predictAndLabelItems.
                     * @member {Array.<palexy.sherlock.v1.IPredictedAndLabelItem>} predictAndLabelItems
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @instance
                     */
                    CalculateMergeAccuracyAdvanceInfo.prototype.predictAndLabelItems = $util.emptyArray;
    
                    /**
                     * Creates a new CalculateMergeAccuracyAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo} CalculateMergeAccuracyAdvanceInfo instance
                     */
                    CalculateMergeAccuracyAdvanceInfo.create = function create(properties) {
                        return new CalculateMergeAccuracyAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateMergeAccuracyAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo} message CalculateMergeAccuracyAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateMergeAccuracyAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.predictAndLabelItems != null && message.predictAndLabelItems.length)
                            for (var i = 0; i < message.predictAndLabelItems.length; ++i)
                                $root.palexy.sherlock.v1.PredictedAndLabelItem.encode(message.predictAndLabelItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateMergeAccuracyAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateMergeAccuracyAdvanceInfo} message CalculateMergeAccuracyAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateMergeAccuracyAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateMergeAccuracyAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo} CalculateMergeAccuracyAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateMergeAccuracyAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.predictAndLabelItems && message.predictAndLabelItems.length))
                                    message.predictAndLabelItems = [];
                                message.predictAndLabelItems.push($root.palexy.sherlock.v1.PredictedAndLabelItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateMergeAccuracyAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo} CalculateMergeAccuracyAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateMergeAccuracyAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateMergeAccuracyAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateMergeAccuracyAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.predictAndLabelItems != null && message.hasOwnProperty("predictAndLabelItems")) {
                            if (!Array.isArray(message.predictAndLabelItems))
                                return "predictAndLabelItems: array expected";
                            for (var i = 0; i < message.predictAndLabelItems.length; ++i) {
                                var error = $root.palexy.sherlock.v1.PredictedAndLabelItem.verify(message.predictAndLabelItems[i]);
                                if (error)
                                    return "predictAndLabelItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateMergeAccuracyAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo} CalculateMergeAccuracyAdvanceInfo
                     */
                    CalculateMergeAccuracyAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo();
                        if (object.predictAndLabelItems) {
                            if (!Array.isArray(object.predictAndLabelItems))
                                throw TypeError(".palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.predictAndLabelItems: array expected");
                            message.predictAndLabelItems = [];
                            for (var i = 0; i < object.predictAndLabelItems.length; ++i) {
                                if (typeof object.predictAndLabelItems[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo.predictAndLabelItems: object expected");
                                message.predictAndLabelItems[i] = $root.palexy.sherlock.v1.PredictedAndLabelItem.fromObject(object.predictAndLabelItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateMergeAccuracyAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo} message CalculateMergeAccuracyAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateMergeAccuracyAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.predictAndLabelItems = [];
                        if (message.predictAndLabelItems && message.predictAndLabelItems.length) {
                            object.predictAndLabelItems = [];
                            for (var j = 0; j < message.predictAndLabelItems.length; ++j)
                                object.predictAndLabelItems[j] = $root.palexy.sherlock.v1.PredictedAndLabelItem.toObject(message.predictAndLabelItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CalculateMergeAccuracyAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CalculateMergeAccuracyAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateMergeAccuracyAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateMergeAccuracyAdvanceInfo;
                })();
    
                v1.ExecutePostMergeConfigAdvanceInfo = (function() {
    
                    /**
                     * Properties of an ExecutePostMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IExecutePostMergeConfigAdvanceInfo
                     * @property {string|null} [mergeFileLink] ExecutePostMergeConfigAdvanceInfo mergeFileLink
                     * @property {string|null} [allBbLink] ExecutePostMergeConfigAdvanceInfo allBbLink
                     * @property {palexy.streaming.v1.IPostMergeConfig|null} [config] ExecutePostMergeConfigAdvanceInfo config
                     * @property {number|null} [storeConfigItemId] ExecutePostMergeConfigAdvanceInfo storeConfigItemId
                     */
    
                    /**
                     * Constructs a new ExecutePostMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExecutePostMergeConfigAdvanceInfo.
                     * @implements IExecutePostMergeConfigAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo=} [properties] Properties to set
                     */
                    function ExecutePostMergeConfigAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExecutePostMergeConfigAdvanceInfo mergeFileLink.
                     * @member {string} mergeFileLink
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @instance
                     */
                    ExecutePostMergeConfigAdvanceInfo.prototype.mergeFileLink = "";
    
                    /**
                     * ExecutePostMergeConfigAdvanceInfo allBbLink.
                     * @member {string} allBbLink
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @instance
                     */
                    ExecutePostMergeConfigAdvanceInfo.prototype.allBbLink = "";
    
                    /**
                     * ExecutePostMergeConfigAdvanceInfo config.
                     * @member {palexy.streaming.v1.IPostMergeConfig|null|undefined} config
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @instance
                     */
                    ExecutePostMergeConfigAdvanceInfo.prototype.config = null;
    
                    /**
                     * ExecutePostMergeConfigAdvanceInfo storeConfigItemId.
                     * @member {number} storeConfigItemId
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @instance
                     */
                    ExecutePostMergeConfigAdvanceInfo.prototype.storeConfigItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ExecutePostMergeConfigAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo} ExecutePostMergeConfigAdvanceInfo instance
                     */
                    ExecutePostMergeConfigAdvanceInfo.create = function create(properties) {
                        return new ExecutePostMergeConfigAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ExecutePostMergeConfigAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo} message ExecutePostMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExecutePostMergeConfigAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeFileLink != null && Object.hasOwnProperty.call(message, "mergeFileLink"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.mergeFileLink);
                        if (message.allBbLink != null && Object.hasOwnProperty.call(message, "allBbLink"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.allBbLink);
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.PostMergeConfig.encode(message.config, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.storeConfigItemId != null && Object.hasOwnProperty.call(message, "storeConfigItemId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.storeConfigItemId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExecutePostMergeConfigAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExecutePostMergeConfigAdvanceInfo} message ExecutePostMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExecutePostMergeConfigAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExecutePostMergeConfigAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo} ExecutePostMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExecutePostMergeConfigAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergeFileLink = reader.string();
                                break;
                            case 2:
                                message.allBbLink = reader.string();
                                break;
                            case 3:
                                message.config = $root.palexy.streaming.v1.PostMergeConfig.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.storeConfigItemId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExecutePostMergeConfigAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo} ExecutePostMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExecutePostMergeConfigAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExecutePostMergeConfigAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExecutePostMergeConfigAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeFileLink != null && message.hasOwnProperty("mergeFileLink"))
                            if (!$util.isString(message.mergeFileLink))
                                return "mergeFileLink: string expected";
                        if (message.allBbLink != null && message.hasOwnProperty("allBbLink"))
                            if (!$util.isString(message.allBbLink))
                                return "allBbLink: string expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.PostMergeConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.storeConfigItemId != null && message.hasOwnProperty("storeConfigItemId"))
                            if (!$util.isInteger(message.storeConfigItemId) && !(message.storeConfigItemId && $util.isInteger(message.storeConfigItemId.low) && $util.isInteger(message.storeConfigItemId.high)))
                                return "storeConfigItemId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExecutePostMergeConfigAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo} ExecutePostMergeConfigAdvanceInfo
                     */
                    ExecutePostMergeConfigAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo();
                        if (object.mergeFileLink != null)
                            message.mergeFileLink = String(object.mergeFileLink);
                        if (object.allBbLink != null)
                            message.allBbLink = String(object.allBbLink);
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo.config: object expected");
                            message.config = $root.palexy.streaming.v1.PostMergeConfig.fromObject(object.config);
                        }
                        if (object.storeConfigItemId != null)
                            if ($util.Long)
                                (message.storeConfigItemId = $util.Long.fromValue(object.storeConfigItemId)).unsigned = false;
                            else if (typeof object.storeConfigItemId === "string")
                                message.storeConfigItemId = parseInt(object.storeConfigItemId, 10);
                            else if (typeof object.storeConfigItemId === "number")
                                message.storeConfigItemId = object.storeConfigItemId;
                            else if (typeof object.storeConfigItemId === "object")
                                message.storeConfigItemId = new $util.LongBits(object.storeConfigItemId.low >>> 0, object.storeConfigItemId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExecutePostMergeConfigAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo} message ExecutePostMergeConfigAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExecutePostMergeConfigAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mergeFileLink = "";
                            object.allBbLink = "";
                            object.config = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigItemId = options.longs === String ? "0" : 0;
                        }
                        if (message.mergeFileLink != null && message.hasOwnProperty("mergeFileLink"))
                            object.mergeFileLink = message.mergeFileLink;
                        if (message.allBbLink != null && message.hasOwnProperty("allBbLink"))
                            object.allBbLink = message.allBbLink;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.PostMergeConfig.toObject(message.config, options);
                        if (message.storeConfigItemId != null && message.hasOwnProperty("storeConfigItemId"))
                            if (typeof message.storeConfigItemId === "number")
                                object.storeConfigItemId = options.longs === String ? String(message.storeConfigItemId) : message.storeConfigItemId;
                            else
                                object.storeConfigItemId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigItemId) : options.longs === Number ? new $util.LongBits(message.storeConfigItemId.low >>> 0, message.storeConfigItemId.high >>> 0).toNumber() : message.storeConfigItemId;
                        return object;
                    };
    
                    /**
                     * Converts this ExecutePostMergeConfigAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExecutePostMergeConfigAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExecutePostMergeConfigAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExecutePostMergeConfigAdvanceInfo;
                })();
    
                v1.DeleteTaskFilesAdvanceInfo = (function() {
    
                    /**
                     * Properties of a DeleteTaskFilesAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteTaskFilesAdvanceInfo
                     * @property {string|null} [taskName] DeleteTaskFilesAdvanceInfo taskName
                     * @property {Array.<palexy.sherlock.v1.IGoogleCloudStorageFile>|null} [googleCloudStorageFiles] DeleteTaskFilesAdvanceInfo googleCloudStorageFiles
                     * @property {Array.<palexy.sherlock.v1.IGoogleDriveFile>|null} [googleDriveFiles] DeleteTaskFilesAdvanceInfo googleDriveFiles
                     * @property {string|null} [googleDriveTaskResultDirId] DeleteTaskFilesAdvanceInfo googleDriveTaskResultDirId
                     */
    
                    /**
                     * Constructs a new DeleteTaskFilesAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteTaskFilesAdvanceInfo.
                     * @implements IDeleteTaskFilesAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo=} [properties] Properties to set
                     */
                    function DeleteTaskFilesAdvanceInfo(properties) {
                        this.googleCloudStorageFiles = [];
                        this.googleDriveFiles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTaskFilesAdvanceInfo taskName.
                     * @member {string} taskName
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @instance
                     */
                    DeleteTaskFilesAdvanceInfo.prototype.taskName = "";
    
                    /**
                     * DeleteTaskFilesAdvanceInfo googleCloudStorageFiles.
                     * @member {Array.<palexy.sherlock.v1.IGoogleCloudStorageFile>} googleCloudStorageFiles
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @instance
                     */
                    DeleteTaskFilesAdvanceInfo.prototype.googleCloudStorageFiles = $util.emptyArray;
    
                    /**
                     * DeleteTaskFilesAdvanceInfo googleDriveFiles.
                     * @member {Array.<palexy.sherlock.v1.IGoogleDriveFile>} googleDriveFiles
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @instance
                     */
                    DeleteTaskFilesAdvanceInfo.prototype.googleDriveFiles = $util.emptyArray;
    
                    /**
                     * DeleteTaskFilesAdvanceInfo googleDriveTaskResultDirId.
                     * @member {string} googleDriveTaskResultDirId
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @instance
                     */
                    DeleteTaskFilesAdvanceInfo.prototype.googleDriveTaskResultDirId = "";
    
                    /**
                     * Creates a new DeleteTaskFilesAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo} DeleteTaskFilesAdvanceInfo instance
                     */
                    DeleteTaskFilesAdvanceInfo.create = function create(properties) {
                        return new DeleteTaskFilesAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTaskFilesAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo} message DeleteTaskFilesAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskFilesAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskName != null && Object.hasOwnProperty.call(message, "taskName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.taskName);
                        if (message.googleCloudStorageFiles != null && message.googleCloudStorageFiles.length)
                            for (var i = 0; i < message.googleCloudStorageFiles.length; ++i)
                                $root.palexy.sherlock.v1.GoogleCloudStorageFile.encode(message.googleCloudStorageFiles[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.googleDriveFiles != null && message.googleDriveFiles.length)
                            for (var i = 0; i < message.googleDriveFiles.length; ++i)
                                $root.palexy.sherlock.v1.GoogleDriveFile.encode(message.googleDriveFiles[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.googleDriveTaskResultDirId != null && Object.hasOwnProperty.call(message, "googleDriveTaskResultDirId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.googleDriveTaskResultDirId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTaskFilesAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskFilesAdvanceInfo} message DeleteTaskFilesAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskFilesAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTaskFilesAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo} DeleteTaskFilesAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskFilesAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskName = reader.string();
                                break;
                            case 2:
                                if (!(message.googleCloudStorageFiles && message.googleCloudStorageFiles.length))
                                    message.googleCloudStorageFiles = [];
                                message.googleCloudStorageFiles.push($root.palexy.sherlock.v1.GoogleCloudStorageFile.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.googleDriveFiles && message.googleDriveFiles.length))
                                    message.googleDriveFiles = [];
                                message.googleDriveFiles.push($root.palexy.sherlock.v1.GoogleDriveFile.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.googleDriveTaskResultDirId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTaskFilesAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo} DeleteTaskFilesAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskFilesAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTaskFilesAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTaskFilesAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskName != null && message.hasOwnProperty("taskName"))
                            if (!$util.isString(message.taskName))
                                return "taskName: string expected";
                        if (message.googleCloudStorageFiles != null && message.hasOwnProperty("googleCloudStorageFiles")) {
                            if (!Array.isArray(message.googleCloudStorageFiles))
                                return "googleCloudStorageFiles: array expected";
                            for (var i = 0; i < message.googleCloudStorageFiles.length; ++i) {
                                var error = $root.palexy.sherlock.v1.GoogleCloudStorageFile.verify(message.googleCloudStorageFiles[i]);
                                if (error)
                                    return "googleCloudStorageFiles." + error;
                            }
                        }
                        if (message.googleDriveFiles != null && message.hasOwnProperty("googleDriveFiles")) {
                            if (!Array.isArray(message.googleDriveFiles))
                                return "googleDriveFiles: array expected";
                            for (var i = 0; i < message.googleDriveFiles.length; ++i) {
                                var error = $root.palexy.sherlock.v1.GoogleDriveFile.verify(message.googleDriveFiles[i]);
                                if (error)
                                    return "googleDriveFiles." + error;
                            }
                        }
                        if (message.googleDriveTaskResultDirId != null && message.hasOwnProperty("googleDriveTaskResultDirId"))
                            if (!$util.isString(message.googleDriveTaskResultDirId))
                                return "googleDriveTaskResultDirId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTaskFilesAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo} DeleteTaskFilesAdvanceInfo
                     */
                    DeleteTaskFilesAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo();
                        if (object.taskName != null)
                            message.taskName = String(object.taskName);
                        if (object.googleCloudStorageFiles) {
                            if (!Array.isArray(object.googleCloudStorageFiles))
                                throw TypeError(".palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.googleCloudStorageFiles: array expected");
                            message.googleCloudStorageFiles = [];
                            for (var i = 0; i < object.googleCloudStorageFiles.length; ++i) {
                                if (typeof object.googleCloudStorageFiles[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.googleCloudStorageFiles: object expected");
                                message.googleCloudStorageFiles[i] = $root.palexy.sherlock.v1.GoogleCloudStorageFile.fromObject(object.googleCloudStorageFiles[i]);
                            }
                        }
                        if (object.googleDriveFiles) {
                            if (!Array.isArray(object.googleDriveFiles))
                                throw TypeError(".palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.googleDriveFiles: array expected");
                            message.googleDriveFiles = [];
                            for (var i = 0; i < object.googleDriveFiles.length; ++i) {
                                if (typeof object.googleDriveFiles[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo.googleDriveFiles: object expected");
                                message.googleDriveFiles[i] = $root.palexy.sherlock.v1.GoogleDriveFile.fromObject(object.googleDriveFiles[i]);
                            }
                        }
                        if (object.googleDriveTaskResultDirId != null)
                            message.googleDriveTaskResultDirId = String(object.googleDriveTaskResultDirId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTaskFilesAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo} message DeleteTaskFilesAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTaskFilesAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.googleCloudStorageFiles = [];
                            object.googleDriveFiles = [];
                        }
                        if (options.defaults) {
                            object.taskName = "";
                            object.googleDriveTaskResultDirId = "";
                        }
                        if (message.taskName != null && message.hasOwnProperty("taskName"))
                            object.taskName = message.taskName;
                        if (message.googleCloudStorageFiles && message.googleCloudStorageFiles.length) {
                            object.googleCloudStorageFiles = [];
                            for (var j = 0; j < message.googleCloudStorageFiles.length; ++j)
                                object.googleCloudStorageFiles[j] = $root.palexy.sherlock.v1.GoogleCloudStorageFile.toObject(message.googleCloudStorageFiles[j], options);
                        }
                        if (message.googleDriveFiles && message.googleDriveFiles.length) {
                            object.googleDriveFiles = [];
                            for (var j = 0; j < message.googleDriveFiles.length; ++j)
                                object.googleDriveFiles[j] = $root.palexy.sherlock.v1.GoogleDriveFile.toObject(message.googleDriveFiles[j], options);
                        }
                        if (message.googleDriveTaskResultDirId != null && message.hasOwnProperty("googleDriveTaskResultDirId"))
                            object.googleDriveTaskResultDirId = message.googleDriveTaskResultDirId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTaskFilesAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteTaskFilesAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTaskFilesAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTaskFilesAdvanceInfo;
                })();
    
                v1.BatchDeleteVideosAdvanceInfo = (function() {
    
                    /**
                     * Properties of a BatchDeleteVideosAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchDeleteVideosAdvanceInfo
                     * @property {Array.<string>|null} [names] BatchDeleteVideosAdvanceInfo names
                     */
    
                    /**
                     * Constructs a new BatchDeleteVideosAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchDeleteVideosAdvanceInfo.
                     * @implements IBatchDeleteVideosAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo=} [properties] Properties to set
                     */
                    function BatchDeleteVideosAdvanceInfo(properties) {
                        this.names = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteVideosAdvanceInfo names.
                     * @member {Array.<string>} names
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @instance
                     */
                    BatchDeleteVideosAdvanceInfo.prototype.names = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDeleteVideosAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo} BatchDeleteVideosAdvanceInfo instance
                     */
                    BatchDeleteVideosAdvanceInfo.create = function create(properties) {
                        return new BatchDeleteVideosAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteVideosAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo} message BatchDeleteVideosAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteVideosAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.names != null && message.names.length)
                            for (var i = 0; i < message.names.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.names[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteVideosAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteVideosAdvanceInfo} message BatchDeleteVideosAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteVideosAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteVideosAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo} BatchDeleteVideosAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteVideosAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.names && message.names.length))
                                    message.names = [];
                                message.names.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteVideosAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo} BatchDeleteVideosAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteVideosAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteVideosAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteVideosAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.names != null && message.hasOwnProperty("names")) {
                            if (!Array.isArray(message.names))
                                return "names: array expected";
                            for (var i = 0; i < message.names.length; ++i)
                                if (!$util.isString(message.names[i]))
                                    return "names: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteVideosAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo} BatchDeleteVideosAdvanceInfo
                     */
                    BatchDeleteVideosAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo();
                        if (object.names) {
                            if (!Array.isArray(object.names))
                                throw TypeError(".palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo.names: array expected");
                            message.names = [];
                            for (var i = 0; i < object.names.length; ++i)
                                message.names[i] = String(object.names[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteVideosAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo} message BatchDeleteVideosAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteVideosAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.names = [];
                        if (message.names && message.names.length) {
                            object.names = [];
                            for (var j = 0; j < message.names.length; ++j)
                                object.names[j] = message.names[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteVideosAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchDeleteVideosAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteVideosAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteVideosAdvanceInfo;
                })();
    
                v1.PrepareQcVideosAdvanceInfo = (function() {
    
                    /**
                     * Properties of a PrepareQcVideosAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IPrepareQcVideosAdvanceInfo
                     * @property {number|null} [storeId] PrepareQcVideosAdvanceInfo storeId
                     * @property {string|null} [dateId] PrepareQcVideosAdvanceInfo dateId
                     * @property {number|null} [startHour] PrepareQcVideosAdvanceInfo startHour
                     * @property {number|null} [endHour] PrepareQcVideosAdvanceInfo endHour
                     * @property {Array.<string>|null} [cameraIds] PrepareQcVideosAdvanceInfo cameraIds
                     * @property {boolean|null} [compressVideo] PrepareQcVideosAdvanceInfo compressVideo
                     * @property {Array.<string>|null} [notificationEmails] PrepareQcVideosAdvanceInfo notificationEmails
                     * @property {palexy.sherlock.v1.SherlockTask.StorageProvider|null} [storageProvider] PrepareQcVideosAdvanceInfo storageProvider
                     * @property {boolean|null} [anonymizeFace] PrepareQcVideosAdvanceInfo anonymizeFace
                     * @property {number|null} [fps] PrepareQcVideosAdvanceInfo fps
                     */
    
                    /**
                     * Constructs a new PrepareQcVideosAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a PrepareQcVideosAdvanceInfo.
                     * @implements IPrepareQcVideosAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo=} [properties] Properties to set
                     */
                    function PrepareQcVideosAdvanceInfo(properties) {
                        this.cameraIds = [];
                        this.notificationEmails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PrepareQcVideosAdvanceInfo storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PrepareQcVideosAdvanceInfo dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.dateId = "";
    
                    /**
                     * PrepareQcVideosAdvanceInfo startHour.
                     * @member {number} startHour
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.startHour = 0;
    
                    /**
                     * PrepareQcVideosAdvanceInfo endHour.
                     * @member {number} endHour
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.endHour = 0;
    
                    /**
                     * PrepareQcVideosAdvanceInfo cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * PrepareQcVideosAdvanceInfo compressVideo.
                     * @member {boolean} compressVideo
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.compressVideo = false;
    
                    /**
                     * PrepareQcVideosAdvanceInfo notificationEmails.
                     * @member {Array.<string>} notificationEmails
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.notificationEmails = $util.emptyArray;
    
                    /**
                     * PrepareQcVideosAdvanceInfo storageProvider.
                     * @member {palexy.sherlock.v1.SherlockTask.StorageProvider} storageProvider
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.storageProvider = 0;
    
                    /**
                     * PrepareQcVideosAdvanceInfo anonymizeFace.
                     * @member {boolean} anonymizeFace
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.anonymizeFace = false;
    
                    /**
                     * PrepareQcVideosAdvanceInfo fps.
                     * @member {number} fps
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     */
                    PrepareQcVideosAdvanceInfo.prototype.fps = 0;
    
                    /**
                     * Creates a new PrepareQcVideosAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.PrepareQcVideosAdvanceInfo} PrepareQcVideosAdvanceInfo instance
                     */
                    PrepareQcVideosAdvanceInfo.create = function create(properties) {
                        return new PrepareQcVideosAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified PrepareQcVideosAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo} message PrepareQcVideosAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PrepareQcVideosAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.startHour != null && Object.hasOwnProperty.call(message, "startHour"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startHour);
                        if (message.endHour != null && Object.hasOwnProperty.call(message, "endHour"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endHour);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cameraIds[i]);
                        if (message.compressVideo != null && Object.hasOwnProperty.call(message, "compressVideo"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.compressVideo);
                        if (message.notificationEmails != null && message.notificationEmails.length)
                            for (var i = 0; i < message.notificationEmails.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.notificationEmails[i]);
                        if (message.storageProvider != null && Object.hasOwnProperty.call(message, "storageProvider"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.storageProvider);
                        if (message.anonymizeFace != null && Object.hasOwnProperty.call(message, "anonymizeFace"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.anonymizeFace);
                        if (message.fps != null && Object.hasOwnProperty.call(message, "fps"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.fps);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PrepareQcVideosAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosAdvanceInfo} message PrepareQcVideosAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PrepareQcVideosAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PrepareQcVideosAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.PrepareQcVideosAdvanceInfo} PrepareQcVideosAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PrepareQcVideosAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.startHour = reader.int32();
                                break;
                            case 4:
                                message.endHour = reader.int32();
                                break;
                            case 5:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 6:
                                message.compressVideo = reader.bool();
                                break;
                            case 7:
                                if (!(message.notificationEmails && message.notificationEmails.length))
                                    message.notificationEmails = [];
                                message.notificationEmails.push(reader.string());
                                break;
                            case 8:
                                message.storageProvider = reader.int32();
                                break;
                            case 9:
                                message.anonymizeFace = reader.bool();
                                break;
                            case 10:
                                message.fps = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PrepareQcVideosAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.PrepareQcVideosAdvanceInfo} PrepareQcVideosAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PrepareQcVideosAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PrepareQcVideosAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PrepareQcVideosAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            if (!$util.isInteger(message.startHour))
                                return "startHour: integer expected";
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            if (!$util.isInteger(message.endHour))
                                return "endHour: integer expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.compressVideo != null && message.hasOwnProperty("compressVideo"))
                            if (typeof message.compressVideo !== "boolean")
                                return "compressVideo: boolean expected";
                        if (message.notificationEmails != null && message.hasOwnProperty("notificationEmails")) {
                            if (!Array.isArray(message.notificationEmails))
                                return "notificationEmails: array expected";
                            for (var i = 0; i < message.notificationEmails.length; ++i)
                                if (!$util.isString(message.notificationEmails[i]))
                                    return "notificationEmails: string[] expected";
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            switch (message.storageProvider) {
                            default:
                                return "storageProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.anonymizeFace != null && message.hasOwnProperty("anonymizeFace"))
                            if (typeof message.anonymizeFace !== "boolean")
                                return "anonymizeFace: boolean expected";
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            if (!$util.isInteger(message.fps))
                                return "fps: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a PrepareQcVideosAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.PrepareQcVideosAdvanceInfo} PrepareQcVideosAdvanceInfo
                     */
                    PrepareQcVideosAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.PrepareQcVideosAdvanceInfo();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startHour != null)
                            message.startHour = object.startHour | 0;
                        if (object.endHour != null)
                            message.endHour = object.endHour | 0;
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.compressVideo != null)
                            message.compressVideo = Boolean(object.compressVideo);
                        if (object.notificationEmails) {
                            if (!Array.isArray(object.notificationEmails))
                                throw TypeError(".palexy.sherlock.v1.PrepareQcVideosAdvanceInfo.notificationEmails: array expected");
                            message.notificationEmails = [];
                            for (var i = 0; i < object.notificationEmails.length; ++i)
                                message.notificationEmails[i] = String(object.notificationEmails[i]);
                        }
                        switch (object.storageProvider) {
                        case "UNKNOWN_PROVIDER":
                        case 0:
                            message.storageProvider = 0;
                            break;
                        case "GCP":
                        case 1:
                            message.storageProvider = 1;
                            break;
                        case "GOOGLE_DRIVE":
                        case 2:
                            message.storageProvider = 2;
                            break;
                        }
                        if (object.anonymizeFace != null)
                            message.anonymizeFace = Boolean(object.anonymizeFace);
                        if (object.fps != null)
                            message.fps = object.fps | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PrepareQcVideosAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.PrepareQcVideosAdvanceInfo} message PrepareQcVideosAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PrepareQcVideosAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.cameraIds = [];
                            object.notificationEmails = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startHour = 0;
                            object.endHour = 0;
                            object.compressVideo = false;
                            object.storageProvider = options.enums === String ? "UNKNOWN_PROVIDER" : 0;
                            object.anonymizeFace = false;
                            object.fps = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            object.startHour = message.startHour;
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            object.endHour = message.endHour;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.compressVideo != null && message.hasOwnProperty("compressVideo"))
                            object.compressVideo = message.compressVideo;
                        if (message.notificationEmails && message.notificationEmails.length) {
                            object.notificationEmails = [];
                            for (var j = 0; j < message.notificationEmails.length; ++j)
                                object.notificationEmails[j] = message.notificationEmails[j];
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            object.storageProvider = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.StorageProvider[message.storageProvider] : message.storageProvider;
                        if (message.anonymizeFace != null && message.hasOwnProperty("anonymizeFace"))
                            object.anonymizeFace = message.anonymizeFace;
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            object.fps = message.fps;
                        return object;
                    };
    
                    /**
                     * Converts this PrepareQcVideosAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.PrepareQcVideosAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PrepareQcVideosAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PrepareQcVideosAdvanceInfo;
                })();
    
                v1.HSCollectReidAdvanceInfo = (function() {
    
                    /**
                     * Properties of a HSCollectReidAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IHSCollectReidAdvanceInfo
                     * @property {string|null} [humanSupervisorTaskName] HSCollectReidAdvanceInfo humanSupervisorTaskName
                     */
    
                    /**
                     * Constructs a new HSCollectReidAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a HSCollectReidAdvanceInfo.
                     * @implements IHSCollectReidAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IHSCollectReidAdvanceInfo=} [properties] Properties to set
                     */
                    function HSCollectReidAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * HSCollectReidAdvanceInfo humanSupervisorTaskName.
                     * @member {string} humanSupervisorTaskName
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @instance
                     */
                    HSCollectReidAdvanceInfo.prototype.humanSupervisorTaskName = "";
    
                    /**
                     * Creates a new HSCollectReidAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHSCollectReidAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.HSCollectReidAdvanceInfo} HSCollectReidAdvanceInfo instance
                     */
                    HSCollectReidAdvanceInfo.create = function create(properties) {
                        return new HSCollectReidAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified HSCollectReidAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.HSCollectReidAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHSCollectReidAdvanceInfo} message HSCollectReidAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HSCollectReidAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.humanSupervisorTaskName != null && Object.hasOwnProperty.call(message, "humanSupervisorTaskName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.humanSupervisorTaskName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified HSCollectReidAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HSCollectReidAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHSCollectReidAdvanceInfo} message HSCollectReidAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HSCollectReidAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a HSCollectReidAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.HSCollectReidAdvanceInfo} HSCollectReidAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HSCollectReidAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.humanSupervisorTaskName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a HSCollectReidAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.HSCollectReidAdvanceInfo} HSCollectReidAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HSCollectReidAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a HSCollectReidAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HSCollectReidAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.humanSupervisorTaskName != null && message.hasOwnProperty("humanSupervisorTaskName"))
                            if (!$util.isString(message.humanSupervisorTaskName))
                                return "humanSupervisorTaskName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a HSCollectReidAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.HSCollectReidAdvanceInfo} HSCollectReidAdvanceInfo
                     */
                    HSCollectReidAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.HSCollectReidAdvanceInfo();
                        if (object.humanSupervisorTaskName != null)
                            message.humanSupervisorTaskName = String(object.humanSupervisorTaskName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a HSCollectReidAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.HSCollectReidAdvanceInfo} message HSCollectReidAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HSCollectReidAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.humanSupervisorTaskName = "";
                        if (message.humanSupervisorTaskName != null && message.hasOwnProperty("humanSupervisorTaskName"))
                            object.humanSupervisorTaskName = message.humanSupervisorTaskName;
                        return object;
                    };
    
                    /**
                     * Converts this HSCollectReidAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.HSCollectReidAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HSCollectReidAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return HSCollectReidAdvanceInfo;
                })();
    
                v1.TinkerPostProcessAdvanceInfo = (function() {
    
                    /**
                     * Properties of a TinkerPostProcessAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface ITinkerPostProcessAdvanceInfo
                     * @property {number|null} [tinkerTaskId] TinkerPostProcessAdvanceInfo tinkerTaskId
                     * @property {Array.<palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink>|null} [cameraLinks] TinkerPostProcessAdvanceInfo cameraLinks
                     * @property {Array.<palexy.dvr.v1.IDVR>|null} [dvrs] TinkerPostProcessAdvanceInfo dvrs
                     */
    
                    /**
                     * Constructs a new TinkerPostProcessAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a TinkerPostProcessAdvanceInfo.
                     * @implements ITinkerPostProcessAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo=} [properties] Properties to set
                     */
                    function TinkerPostProcessAdvanceInfo(properties) {
                        this.cameraLinks = [];
                        this.dvrs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TinkerPostProcessAdvanceInfo tinkerTaskId.
                     * @member {number} tinkerTaskId
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @instance
                     */
                    TinkerPostProcessAdvanceInfo.prototype.tinkerTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TinkerPostProcessAdvanceInfo cameraLinks.
                     * @member {Array.<palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink>} cameraLinks
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @instance
                     */
                    TinkerPostProcessAdvanceInfo.prototype.cameraLinks = $util.emptyArray;
    
                    /**
                     * TinkerPostProcessAdvanceInfo dvrs.
                     * @member {Array.<palexy.dvr.v1.IDVR>} dvrs
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @instance
                     */
                    TinkerPostProcessAdvanceInfo.prototype.dvrs = $util.emptyArray;
    
                    /**
                     * Creates a new TinkerPostProcessAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo} TinkerPostProcessAdvanceInfo instance
                     */
                    TinkerPostProcessAdvanceInfo.create = function create(properties) {
                        return new TinkerPostProcessAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified TinkerPostProcessAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo} message TinkerPostProcessAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TinkerPostProcessAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tinkerTaskId != null && Object.hasOwnProperty.call(message, "tinkerTaskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.tinkerTaskId);
                        if (message.cameraLinks != null && message.cameraLinks.length)
                            for (var i = 0; i < message.cameraLinks.length; ++i)
                                $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.encode(message.cameraLinks[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.dvrs != null && message.dvrs.length)
                            for (var i = 0; i < message.dvrs.length; ++i)
                                $root.palexy.dvr.v1.DVR.encode(message.dvrs[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TinkerPostProcessAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ITinkerPostProcessAdvanceInfo} message TinkerPostProcessAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TinkerPostProcessAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TinkerPostProcessAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo} TinkerPostProcessAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TinkerPostProcessAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.tinkerTaskId = reader.int64();
                                break;
                            case 2:
                                if (!(message.cameraLinks && message.cameraLinks.length))
                                    message.cameraLinks = [];
                                message.cameraLinks.push($root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.dvrs && message.dvrs.length))
                                    message.dvrs = [];
                                message.dvrs.push($root.palexy.dvr.v1.DVR.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TinkerPostProcessAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo} TinkerPostProcessAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TinkerPostProcessAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TinkerPostProcessAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TinkerPostProcessAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tinkerTaskId != null && message.hasOwnProperty("tinkerTaskId"))
                            if (!$util.isInteger(message.tinkerTaskId) && !(message.tinkerTaskId && $util.isInteger(message.tinkerTaskId.low) && $util.isInteger(message.tinkerTaskId.high)))
                                return "tinkerTaskId: integer|Long expected";
                        if (message.cameraLinks != null && message.hasOwnProperty("cameraLinks")) {
                            if (!Array.isArray(message.cameraLinks))
                                return "cameraLinks: array expected";
                            for (var i = 0; i < message.cameraLinks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.verify(message.cameraLinks[i]);
                                if (error)
                                    return "cameraLinks." + error;
                            }
                        }
                        if (message.dvrs != null && message.hasOwnProperty("dvrs")) {
                            if (!Array.isArray(message.dvrs))
                                return "dvrs: array expected";
                            for (var i = 0; i < message.dvrs.length; ++i) {
                                var error = $root.palexy.dvr.v1.DVR.verify(message.dvrs[i]);
                                if (error)
                                    return "dvrs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TinkerPostProcessAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo} TinkerPostProcessAdvanceInfo
                     */
                    TinkerPostProcessAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo();
                        if (object.tinkerTaskId != null)
                            if ($util.Long)
                                (message.tinkerTaskId = $util.Long.fromValue(object.tinkerTaskId)).unsigned = false;
                            else if (typeof object.tinkerTaskId === "string")
                                message.tinkerTaskId = parseInt(object.tinkerTaskId, 10);
                            else if (typeof object.tinkerTaskId === "number")
                                message.tinkerTaskId = object.tinkerTaskId;
                            else if (typeof object.tinkerTaskId === "object")
                                message.tinkerTaskId = new $util.LongBits(object.tinkerTaskId.low >>> 0, object.tinkerTaskId.high >>> 0).toNumber();
                        if (object.cameraLinks) {
                            if (!Array.isArray(object.cameraLinks))
                                throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.cameraLinks: array expected");
                            message.cameraLinks = [];
                            for (var i = 0; i < object.cameraLinks.length; ++i) {
                                if (typeof object.cameraLinks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.cameraLinks: object expected");
                                message.cameraLinks[i] = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.fromObject(object.cameraLinks[i]);
                            }
                        }
                        if (object.dvrs) {
                            if (!Array.isArray(object.dvrs))
                                throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.dvrs: array expected");
                            message.dvrs = [];
                            for (var i = 0; i < object.dvrs.length; ++i) {
                                if (typeof object.dvrs[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.dvrs: object expected");
                                message.dvrs[i] = $root.palexy.dvr.v1.DVR.fromObject(object.dvrs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TinkerPostProcessAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo} message TinkerPostProcessAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TinkerPostProcessAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.cameraLinks = [];
                            object.dvrs = [];
                        }
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.tinkerTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.tinkerTaskId = options.longs === String ? "0" : 0;
                        if (message.tinkerTaskId != null && message.hasOwnProperty("tinkerTaskId"))
                            if (typeof message.tinkerTaskId === "number")
                                object.tinkerTaskId = options.longs === String ? String(message.tinkerTaskId) : message.tinkerTaskId;
                            else
                                object.tinkerTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.tinkerTaskId) : options.longs === Number ? new $util.LongBits(message.tinkerTaskId.low >>> 0, message.tinkerTaskId.high >>> 0).toNumber() : message.tinkerTaskId;
                        if (message.cameraLinks && message.cameraLinks.length) {
                            object.cameraLinks = [];
                            for (var j = 0; j < message.cameraLinks.length; ++j)
                                object.cameraLinks[j] = $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.toObject(message.cameraLinks[j], options);
                        }
                        if (message.dvrs && message.dvrs.length) {
                            object.dvrs = [];
                            for (var j = 0; j < message.dvrs.length; ++j)
                                object.dvrs[j] = $root.palexy.dvr.v1.DVR.toObject(message.dvrs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TinkerPostProcessAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TinkerPostProcessAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    TinkerPostProcessAdvanceInfo.CameraLink = (function() {
    
                        /**
                         * Properties of a CameraLink.
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                         * @interface ICameraLink
                         * @property {palexy.dvr.v1.IDVRCamera|null} [dvrCamera] CameraLink dvrCamera
                         * @property {palexy.streaming.v1.ICamera|null} [camera] CameraLink camera
                         */
    
                        /**
                         * Constructs a new CameraLink.
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo
                         * @classdesc Represents a CameraLink.
                         * @implements ICameraLink
                         * @constructor
                         * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink=} [properties] Properties to set
                         */
                        function CameraLink(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CameraLink dvrCamera.
                         * @member {palexy.dvr.v1.IDVRCamera|null|undefined} dvrCamera
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @instance
                         */
                        CameraLink.prototype.dvrCamera = null;
    
                        /**
                         * CameraLink camera.
                         * @member {palexy.streaming.v1.ICamera|null|undefined} camera
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @instance
                         */
                        CameraLink.prototype.camera = null;
    
                        /**
                         * Creates a new CameraLink instance using the specified properties.
                         * @function create
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink=} [properties] Properties to set
                         * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink} CameraLink instance
                         */
                        CameraLink.create = function create(properties) {
                            return new CameraLink(properties);
                        };
    
                        /**
                         * Encodes the specified CameraLink message. Does not implicitly {@link palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink} message CameraLink message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CameraLink.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dvrCamera != null && Object.hasOwnProperty.call(message, "dvrCamera"))
                                $root.palexy.dvr.v1.DVRCamera.encode(message.dvrCamera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                                $root.palexy.streaming.v1.Camera.encode(message.camera, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CameraLink message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.ICameraLink} message CameraLink message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CameraLink.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CameraLink message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink} CameraLink
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CameraLink.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.camera = $root.palexy.streaming.v1.Camera.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CameraLink message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink} CameraLink
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CameraLink.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CameraLink message.
                         * @function verify
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CameraLink.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera")) {
                                var error = $root.palexy.dvr.v1.DVRCamera.verify(message.dvrCamera);
                                if (error)
                                    return "dvrCamera." + error;
                            }
                            if (message.camera != null && message.hasOwnProperty("camera")) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.camera);
                                if (error)
                                    return "camera." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CameraLink message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink} CameraLink
                         */
                        CameraLink.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink)
                                return object;
                            var message = new $root.palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink();
                            if (object.dvrCamera != null) {
                                if (typeof object.dvrCamera !== "object")
                                    throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.dvrCamera: object expected");
                                message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.fromObject(object.dvrCamera);
                            }
                            if (object.camera != null) {
                                if (typeof object.camera !== "object")
                                    throw TypeError(".palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink.camera: object expected");
                                message.camera = $root.palexy.streaming.v1.Camera.fromObject(object.camera);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CameraLink message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @static
                         * @param {palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink} message CameraLink
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CameraLink.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.dvrCamera = null;
                                object.camera = null;
                            }
                            if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera"))
                                object.dvrCamera = $root.palexy.dvr.v1.DVRCamera.toObject(message.dvrCamera, options);
                            if (message.camera != null && message.hasOwnProperty("camera"))
                                object.camera = $root.palexy.streaming.v1.Camera.toObject(message.camera, options);
                            return object;
                        };
    
                        /**
                         * Converts this CameraLink to JSON.
                         * @function toJSON
                         * @memberof palexy.sherlock.v1.TinkerPostProcessAdvanceInfo.CameraLink
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CameraLink.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return CameraLink;
                    })();
    
                    return TinkerPostProcessAdvanceInfo;
                })();
    
                v1.ForecastGenerateAdvanceInfo = (function() {
    
                    /**
                     * Properties of a ForecastGenerateAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IForecastGenerateAdvanceInfo
                     * @property {number|null} [dateId] ForecastGenerateAdvanceInfo dateId
                     * @property {Array.<number>|null} [storeIds] ForecastGenerateAdvanceInfo storeIds
                     * @property {number|null} [forecastModelId] ForecastGenerateAdvanceInfo forecastModelId
                     * @property {number|null} [forecastModelVersionId] ForecastGenerateAdvanceInfo forecastModelVersionId
                     * @property {number|null} [forecastingHorizon] ForecastGenerateAdvanceInfo forecastingHorizon
                     * @property {number|null} [storeId] ForecastGenerateAdvanceInfo storeId
                     */
    
                    /**
                     * Constructs a new ForecastGenerateAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ForecastGenerateAdvanceInfo.
                     * @implements IForecastGenerateAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IForecastGenerateAdvanceInfo=} [properties] Properties to set
                     */
                    function ForecastGenerateAdvanceInfo(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastGenerateAdvanceInfo dateId.
                     * @member {number} dateId
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.dateId = 0;
    
                    /**
                     * ForecastGenerateAdvanceInfo storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ForecastGenerateAdvanceInfo forecastModelId.
                     * @member {number} forecastModelId
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.forecastModelId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastGenerateAdvanceInfo forecastModelVersionId.
                     * @member {number} forecastModelVersionId
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.forecastModelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastGenerateAdvanceInfo forecastingHorizon.
                     * @member {number} forecastingHorizon
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.forecastingHorizon = 0;
    
                    /**
                     * ForecastGenerateAdvanceInfo storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     */
                    ForecastGenerateAdvanceInfo.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ForecastGenerateAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IForecastGenerateAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ForecastGenerateAdvanceInfo} ForecastGenerateAdvanceInfo instance
                     */
                    ForecastGenerateAdvanceInfo.create = function create(properties) {
                        return new ForecastGenerateAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastGenerateAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.ForecastGenerateAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IForecastGenerateAdvanceInfo} message ForecastGenerateAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastGenerateAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.forecastModelId != null && Object.hasOwnProperty.call(message, "forecastModelId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.forecastModelId);
                        if (message.forecastModelVersionId != null && Object.hasOwnProperty.call(message, "forecastModelVersionId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.forecastModelVersionId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.forecastingHorizon != null && Object.hasOwnProperty.call(message, "forecastingHorizon"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.forecastingHorizon);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastGenerateAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ForecastGenerateAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IForecastGenerateAdvanceInfo} message ForecastGenerateAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastGenerateAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastGenerateAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ForecastGenerateAdvanceInfo} ForecastGenerateAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastGenerateAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 3:
                                message.forecastModelId = reader.int64();
                                break;
                            case 4:
                                message.forecastModelVersionId = reader.int64();
                                break;
                            case 6:
                                message.forecastingHorizon = reader.int32();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastGenerateAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ForecastGenerateAdvanceInfo} ForecastGenerateAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastGenerateAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastGenerateAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastGenerateAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (!$util.isInteger(message.forecastModelId) && !(message.forecastModelId && $util.isInteger(message.forecastModelId.low) && $util.isInteger(message.forecastModelId.high)))
                                return "forecastModelId: integer|Long expected";
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (!$util.isInteger(message.forecastModelVersionId) && !(message.forecastModelVersionId && $util.isInteger(message.forecastModelVersionId.low) && $util.isInteger(message.forecastModelVersionId.high)))
                                return "forecastModelVersionId: integer|Long expected";
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            if (!$util.isInteger(message.forecastingHorizon))
                                return "forecastingHorizon: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastGenerateAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ForecastGenerateAdvanceInfo} ForecastGenerateAdvanceInfo
                     */
                    ForecastGenerateAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ForecastGenerateAdvanceInfo();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.sherlock.v1.ForecastGenerateAdvanceInfo.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.forecastModelId != null)
                            if ($util.Long)
                                (message.forecastModelId = $util.Long.fromValue(object.forecastModelId)).unsigned = false;
                            else if (typeof object.forecastModelId === "string")
                                message.forecastModelId = parseInt(object.forecastModelId, 10);
                            else if (typeof object.forecastModelId === "number")
                                message.forecastModelId = object.forecastModelId;
                            else if (typeof object.forecastModelId === "object")
                                message.forecastModelId = new $util.LongBits(object.forecastModelId.low >>> 0, object.forecastModelId.high >>> 0).toNumber();
                        if (object.forecastModelVersionId != null)
                            if ($util.Long)
                                (message.forecastModelVersionId = $util.Long.fromValue(object.forecastModelVersionId)).unsigned = false;
                            else if (typeof object.forecastModelVersionId === "string")
                                message.forecastModelVersionId = parseInt(object.forecastModelVersionId, 10);
                            else if (typeof object.forecastModelVersionId === "number")
                                message.forecastModelVersionId = object.forecastModelVersionId;
                            else if (typeof object.forecastModelVersionId === "object")
                                message.forecastModelVersionId = new $util.LongBits(object.forecastModelVersionId.low >>> 0, object.forecastModelVersionId.high >>> 0).toNumber();
                        if (object.forecastingHorizon != null)
                            message.forecastingHorizon = object.forecastingHorizon | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastGenerateAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ForecastGenerateAdvanceInfo} message ForecastGenerateAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastGenerateAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.dateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelVersionId = options.longs === String ? "0" : 0;
                            object.forecastingHorizon = 0;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (typeof message.forecastModelId === "number")
                                object.forecastModelId = options.longs === String ? String(message.forecastModelId) : message.forecastModelId;
                            else
                                object.forecastModelId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelId) : options.longs === Number ? new $util.LongBits(message.forecastModelId.low >>> 0, message.forecastModelId.high >>> 0).toNumber() : message.forecastModelId;
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (typeof message.forecastModelVersionId === "number")
                                object.forecastModelVersionId = options.longs === String ? String(message.forecastModelVersionId) : message.forecastModelVersionId;
                            else
                                object.forecastModelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelVersionId) : options.longs === Number ? new $util.LongBits(message.forecastModelVersionId.low >>> 0, message.forecastModelVersionId.high >>> 0).toNumber() : message.forecastModelVersionId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            object.forecastingHorizon = message.forecastingHorizon;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastGenerateAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ForecastGenerateAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastGenerateAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastGenerateAdvanceInfo;
                })();
    
                v1.ExportHakuhodoAdvanceInfo = (function() {
    
                    /**
                     * Properties of an ExportHakuhodoAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IExportHakuhodoAdvanceInfo
                     * @property {number|null} [startDateIdInclusive] ExportHakuhodoAdvanceInfo startDateIdInclusive
                     * @property {number|null} [endDateIdInclusive] ExportHakuhodoAdvanceInfo endDateIdInclusive
                     * @property {number|null} [storeId] ExportHakuhodoAdvanceInfo storeId
                     * @property {number|null} [directionalPassByStoreId] ExportHakuhodoAdvanceInfo directionalPassByStoreId
                     * @property {boolean|null} [keepSectionVisitOnly] ExportHakuhodoAdvanceInfo keepSectionVisitOnly
                     * @property {boolean|null} [exportToHakuhodoBucket] ExportHakuhodoAdvanceInfo exportToHakuhodoBucket
                     */
    
                    /**
                     * Constructs a new ExportHakuhodoAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExportHakuhodoAdvanceInfo.
                     * @implements IExportHakuhodoAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo=} [properties] Properties to set
                     */
                    function ExportHakuhodoAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportHakuhodoAdvanceInfo startDateIdInclusive.
                     * @member {number} startDateIdInclusive
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.startDateIdInclusive = 0;
    
                    /**
                     * ExportHakuhodoAdvanceInfo endDateIdInclusive.
                     * @member {number} endDateIdInclusive
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.endDateIdInclusive = 0;
    
                    /**
                     * ExportHakuhodoAdvanceInfo storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportHakuhodoAdvanceInfo directionalPassByStoreId.
                     * @member {number} directionalPassByStoreId
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.directionalPassByStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportHakuhodoAdvanceInfo keepSectionVisitOnly.
                     * @member {boolean} keepSectionVisitOnly
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.keepSectionVisitOnly = false;
    
                    /**
                     * ExportHakuhodoAdvanceInfo exportToHakuhodoBucket.
                     * @member {boolean} exportToHakuhodoBucket
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     */
                    ExportHakuhodoAdvanceInfo.prototype.exportToHakuhodoBucket = false;
    
                    /**
                     * Creates a new ExportHakuhodoAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExportHakuhodoAdvanceInfo} ExportHakuhodoAdvanceInfo instance
                     */
                    ExportHakuhodoAdvanceInfo.create = function create(properties) {
                        return new ExportHakuhodoAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ExportHakuhodoAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo} message ExportHakuhodoAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportHakuhodoAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateIdInclusive != null && Object.hasOwnProperty.call(message, "startDateIdInclusive"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateIdInclusive);
                        if (message.endDateIdInclusive != null && Object.hasOwnProperty.call(message, "endDateIdInclusive"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateIdInclusive);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.directionalPassByStoreId != null && Object.hasOwnProperty.call(message, "directionalPassByStoreId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.directionalPassByStoreId);
                        if (message.keepSectionVisitOnly != null && Object.hasOwnProperty.call(message, "keepSectionVisitOnly"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.keepSectionVisitOnly);
                        if (message.exportToHakuhodoBucket != null && Object.hasOwnProperty.call(message, "exportToHakuhodoBucket"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.exportToHakuhodoBucket);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportHakuhodoAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExportHakuhodoAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoAdvanceInfo} message ExportHakuhodoAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportHakuhodoAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportHakuhodoAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExportHakuhodoAdvanceInfo} ExportHakuhodoAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportHakuhodoAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateIdInclusive = reader.int32();
                                break;
                            case 2:
                                message.endDateIdInclusive = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.directionalPassByStoreId = reader.int64();
                                break;
                            case 5:
                                message.keepSectionVisitOnly = reader.bool();
                                break;
                            case 6:
                                message.exportToHakuhodoBucket = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportHakuhodoAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExportHakuhodoAdvanceInfo} ExportHakuhodoAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportHakuhodoAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportHakuhodoAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportHakuhodoAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            if (!$util.isInteger(message.startDateIdInclusive))
                                return "startDateIdInclusive: integer expected";
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            if (!$util.isInteger(message.endDateIdInclusive))
                                return "endDateIdInclusive: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.directionalPassByStoreId != null && message.hasOwnProperty("directionalPassByStoreId"))
                            if (!$util.isInteger(message.directionalPassByStoreId) && !(message.directionalPassByStoreId && $util.isInteger(message.directionalPassByStoreId.low) && $util.isInteger(message.directionalPassByStoreId.high)))
                                return "directionalPassByStoreId: integer|Long expected";
                        if (message.keepSectionVisitOnly != null && message.hasOwnProperty("keepSectionVisitOnly"))
                            if (typeof message.keepSectionVisitOnly !== "boolean")
                                return "keepSectionVisitOnly: boolean expected";
                        if (message.exportToHakuhodoBucket != null && message.hasOwnProperty("exportToHakuhodoBucket"))
                            if (typeof message.exportToHakuhodoBucket !== "boolean")
                                return "exportToHakuhodoBucket: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportHakuhodoAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExportHakuhodoAdvanceInfo} ExportHakuhodoAdvanceInfo
                     */
                    ExportHakuhodoAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExportHakuhodoAdvanceInfo();
                        if (object.startDateIdInclusive != null)
                            message.startDateIdInclusive = object.startDateIdInclusive | 0;
                        if (object.endDateIdInclusive != null)
                            message.endDateIdInclusive = object.endDateIdInclusive | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.directionalPassByStoreId != null)
                            if ($util.Long)
                                (message.directionalPassByStoreId = $util.Long.fromValue(object.directionalPassByStoreId)).unsigned = false;
                            else if (typeof object.directionalPassByStoreId === "string")
                                message.directionalPassByStoreId = parseInt(object.directionalPassByStoreId, 10);
                            else if (typeof object.directionalPassByStoreId === "number")
                                message.directionalPassByStoreId = object.directionalPassByStoreId;
                            else if (typeof object.directionalPassByStoreId === "object")
                                message.directionalPassByStoreId = new $util.LongBits(object.directionalPassByStoreId.low >>> 0, object.directionalPassByStoreId.high >>> 0).toNumber();
                        if (object.keepSectionVisitOnly != null)
                            message.keepSectionVisitOnly = Boolean(object.keepSectionVisitOnly);
                        if (object.exportToHakuhodoBucket != null)
                            message.exportToHakuhodoBucket = Boolean(object.exportToHakuhodoBucket);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportHakuhodoAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ExportHakuhodoAdvanceInfo} message ExportHakuhodoAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportHakuhodoAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateIdInclusive = 0;
                            object.endDateIdInclusive = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.directionalPassByStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.directionalPassByStoreId = options.longs === String ? "0" : 0;
                            object.keepSectionVisitOnly = false;
                            object.exportToHakuhodoBucket = false;
                        }
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            object.startDateIdInclusive = message.startDateIdInclusive;
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            object.endDateIdInclusive = message.endDateIdInclusive;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.directionalPassByStoreId != null && message.hasOwnProperty("directionalPassByStoreId"))
                            if (typeof message.directionalPassByStoreId === "number")
                                object.directionalPassByStoreId = options.longs === String ? String(message.directionalPassByStoreId) : message.directionalPassByStoreId;
                            else
                                object.directionalPassByStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.directionalPassByStoreId) : options.longs === Number ? new $util.LongBits(message.directionalPassByStoreId.low >>> 0, message.directionalPassByStoreId.high >>> 0).toNumber() : message.directionalPassByStoreId;
                        if (message.keepSectionVisitOnly != null && message.hasOwnProperty("keepSectionVisitOnly"))
                            object.keepSectionVisitOnly = message.keepSectionVisitOnly;
                        if (message.exportToHakuhodoBucket != null && message.hasOwnProperty("exportToHakuhodoBucket"))
                            object.exportToHakuhodoBucket = message.exportToHakuhodoBucket;
                        return object;
                    };
    
                    /**
                     * Converts this ExportHakuhodoAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExportHakuhodoAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportHakuhodoAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportHakuhodoAdvanceInfo;
                })();
    
                v1.HakuhodoJoinPartialMergingResultsAdvanceInfo = (function() {
    
                    /**
                     * Properties of a HakuhodoJoinPartialMergingResultsAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IHakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @property {number|null} [startDateIdInclusive] HakuhodoJoinPartialMergingResultsAdvanceInfo startDateIdInclusive
                     * @property {number|null} [endDateIdInclusive] HakuhodoJoinPartialMergingResultsAdvanceInfo endDateIdInclusive
                     * @property {Array.<number>|null} [storeIds] HakuhodoJoinPartialMergingResultsAdvanceInfo storeIds
                     */
    
                    /**
                     * Constructs a new HakuhodoJoinPartialMergingResultsAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a HakuhodoJoinPartialMergingResultsAdvanceInfo.
                     * @implements IHakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo=} [properties] Properties to set
                     */
                    function HakuhodoJoinPartialMergingResultsAdvanceInfo(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * HakuhodoJoinPartialMergingResultsAdvanceInfo startDateIdInclusive.
                     * @member {number} startDateIdInclusive
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @instance
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.prototype.startDateIdInclusive = 0;
    
                    /**
                     * HakuhodoJoinPartialMergingResultsAdvanceInfo endDateIdInclusive.
                     * @member {number} endDateIdInclusive
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @instance
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.prototype.endDateIdInclusive = 0;
    
                    /**
                     * HakuhodoJoinPartialMergingResultsAdvanceInfo storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @instance
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * Creates a new HakuhodoJoinPartialMergingResultsAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo} HakuhodoJoinPartialMergingResultsAdvanceInfo instance
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.create = function create(properties) {
                        return new HakuhodoJoinPartialMergingResultsAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified HakuhodoJoinPartialMergingResultsAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo} message HakuhodoJoinPartialMergingResultsAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateIdInclusive != null && Object.hasOwnProperty.call(message, "startDateIdInclusive"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateIdInclusive);
                        if (message.endDateIdInclusive != null && Object.hasOwnProperty.call(message, "endDateIdInclusive"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateIdInclusive);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified HakuhodoJoinPartialMergingResultsAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoJoinPartialMergingResultsAdvanceInfo} message HakuhodoJoinPartialMergingResultsAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a HakuhodoJoinPartialMergingResultsAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo} HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateIdInclusive = reader.int32();
                                break;
                            case 2:
                                message.endDateIdInclusive = reader.int32();
                                break;
                            case 3:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a HakuhodoJoinPartialMergingResultsAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo} HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a HakuhodoJoinPartialMergingResultsAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            if (!$util.isInteger(message.startDateIdInclusive))
                                return "startDateIdInclusive: integer expected";
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            if (!$util.isInteger(message.endDateIdInclusive))
                                return "endDateIdInclusive: integer expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a HakuhodoJoinPartialMergingResultsAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo} HakuhodoJoinPartialMergingResultsAdvanceInfo
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo();
                        if (object.startDateIdInclusive != null)
                            message.startDateIdInclusive = object.startDateIdInclusive | 0;
                        if (object.endDateIdInclusive != null)
                            message.endDateIdInclusive = object.endDateIdInclusive | 0;
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a HakuhodoJoinPartialMergingResultsAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo} message HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDateIdInclusive = 0;
                            object.endDateIdInclusive = 0;
                        }
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            object.startDateIdInclusive = message.startDateIdInclusive;
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            object.endDateIdInclusive = message.endDateIdInclusive;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this HakuhodoJoinPartialMergingResultsAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.HakuhodoJoinPartialMergingResultsAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HakuhodoJoinPartialMergingResultsAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return HakuhodoJoinPartialMergingResultsAdvanceInfo;
                })();
    
                v1.HakuhodoEditTrafficAdvanceInfo = (function() {
    
                    /**
                     * Properties of a HakuhodoEditTrafficAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IHakuhodoEditTrafficAdvanceInfo
                     * @property {Array.<palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit>|null} [trafficEdits] HakuhodoEditTrafficAdvanceInfo trafficEdits
                     * @property {Array.<palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit>|null} [passByEdits] HakuhodoEditTrafficAdvanceInfo passByEdits
                     */
    
                    /**
                     * Constructs a new HakuhodoEditTrafficAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a HakuhodoEditTrafficAdvanceInfo.
                     * @implements IHakuhodoEditTrafficAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo=} [properties] Properties to set
                     */
                    function HakuhodoEditTrafficAdvanceInfo(properties) {
                        this.trafficEdits = [];
                        this.passByEdits = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * HakuhodoEditTrafficAdvanceInfo trafficEdits.
                     * @member {Array.<palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit>} trafficEdits
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @instance
                     */
                    HakuhodoEditTrafficAdvanceInfo.prototype.trafficEdits = $util.emptyArray;
    
                    /**
                     * HakuhodoEditTrafficAdvanceInfo passByEdits.
                     * @member {Array.<palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit>} passByEdits
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @instance
                     */
                    HakuhodoEditTrafficAdvanceInfo.prototype.passByEdits = $util.emptyArray;
    
                    /**
                     * Creates a new HakuhodoEditTrafficAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo} HakuhodoEditTrafficAdvanceInfo instance
                     */
                    HakuhodoEditTrafficAdvanceInfo.create = function create(properties) {
                        return new HakuhodoEditTrafficAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified HakuhodoEditTrafficAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo} message HakuhodoEditTrafficAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoEditTrafficAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.trafficEdits != null && message.trafficEdits.length)
                            for (var i = 0; i < message.trafficEdits.length; ++i)
                                $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.encode(message.trafficEdits[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.passByEdits != null && message.passByEdits.length)
                            for (var i = 0; i < message.passByEdits.length; ++i)
                                $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.encode(message.passByEdits[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified HakuhodoEditTrafficAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoEditTrafficAdvanceInfo} message HakuhodoEditTrafficAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoEditTrafficAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a HakuhodoEditTrafficAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo} HakuhodoEditTrafficAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoEditTrafficAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.trafficEdits && message.trafficEdits.length))
                                    message.trafficEdits = [];
                                message.trafficEdits.push($root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.passByEdits && message.passByEdits.length))
                                    message.passByEdits = [];
                                message.passByEdits.push($root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a HakuhodoEditTrafficAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo} HakuhodoEditTrafficAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoEditTrafficAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a HakuhodoEditTrafficAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HakuhodoEditTrafficAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.trafficEdits != null && message.hasOwnProperty("trafficEdits")) {
                            if (!Array.isArray(message.trafficEdits))
                                return "trafficEdits: array expected";
                            for (var i = 0; i < message.trafficEdits.length; ++i) {
                                var error = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.verify(message.trafficEdits[i]);
                                if (error)
                                    return "trafficEdits." + error;
                            }
                        }
                        if (message.passByEdits != null && message.hasOwnProperty("passByEdits")) {
                            if (!Array.isArray(message.passByEdits))
                                return "passByEdits: array expected";
                            for (var i = 0; i < message.passByEdits.length; ++i) {
                                var error = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.verify(message.passByEdits[i]);
                                if (error)
                                    return "passByEdits." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a HakuhodoEditTrafficAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo} HakuhodoEditTrafficAdvanceInfo
                     */
                    HakuhodoEditTrafficAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo();
                        if (object.trafficEdits) {
                            if (!Array.isArray(object.trafficEdits))
                                throw TypeError(".palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.trafficEdits: array expected");
                            message.trafficEdits = [];
                            for (var i = 0; i < object.trafficEdits.length; ++i) {
                                if (typeof object.trafficEdits[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.trafficEdits: object expected");
                                message.trafficEdits[i] = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.fromObject(object.trafficEdits[i]);
                            }
                        }
                        if (object.passByEdits) {
                            if (!Array.isArray(object.passByEdits))
                                throw TypeError(".palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.passByEdits: array expected");
                            message.passByEdits = [];
                            for (var i = 0; i < object.passByEdits.length; ++i) {
                                if (typeof object.passByEdits[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.passByEdits: object expected");
                                message.passByEdits[i] = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.fromObject(object.passByEdits[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a HakuhodoEditTrafficAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo} message HakuhodoEditTrafficAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HakuhodoEditTrafficAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.trafficEdits = [];
                            object.passByEdits = [];
                        }
                        if (message.trafficEdits && message.trafficEdits.length) {
                            object.trafficEdits = [];
                            for (var j = 0; j < message.trafficEdits.length; ++j)
                                object.trafficEdits[j] = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.toObject(message.trafficEdits[j], options);
                        }
                        if (message.passByEdits && message.passByEdits.length) {
                            object.passByEdits = [];
                            for (var j = 0; j < message.passByEdits.length; ++j)
                                object.passByEdits[j] = $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.toObject(message.passByEdits[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this HakuhodoEditTrafficAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HakuhodoEditTrafficAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    HakuhodoEditTrafficAdvanceInfo.TrafficEdit = (function() {
    
                        /**
                         * Properties of a TrafficEdit.
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                         * @interface ITrafficEdit
                         * @property {number|null} [storeId] TrafficEdit storeId
                         * @property {number|null} [dateId] TrafficEdit dateId
                         * @property {number|null} [value] TrafficEdit value
                         */
    
                        /**
                         * Constructs a new TrafficEdit.
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                         * @classdesc Represents a TrafficEdit.
                         * @implements ITrafficEdit
                         * @constructor
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit=} [properties] Properties to set
                         */
                        function TrafficEdit(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TrafficEdit storeId.
                         * @member {number} storeId
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @instance
                         */
                        TrafficEdit.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * TrafficEdit dateId.
                         * @member {number} dateId
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @instance
                         */
                        TrafficEdit.prototype.dateId = 0;
    
                        /**
                         * TrafficEdit value.
                         * @member {number} value
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @instance
                         */
                        TrafficEdit.prototype.value = 0;
    
                        /**
                         * Creates a new TrafficEdit instance using the specified properties.
                         * @function create
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit=} [properties] Properties to set
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit} TrafficEdit instance
                         */
                        TrafficEdit.create = function create(properties) {
                            return new TrafficEdit(properties);
                        };
    
                        /**
                         * Encodes the specified TrafficEdit message. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit} message TrafficEdit message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TrafficEdit.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.value);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TrafficEdit message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.ITrafficEdit} message TrafficEdit message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TrafficEdit.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TrafficEdit message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit} TrafficEdit
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TrafficEdit.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.int32();
                                    break;
                                case 3:
                                    message.value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TrafficEdit message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit} TrafficEdit
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TrafficEdit.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TrafficEdit message.
                         * @function verify
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TrafficEdit.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isInteger(message.dateId))
                                    return "dateId: integer expected";
                            if (message.value != null && message.hasOwnProperty("value"))
                                if (!$util.isInteger(message.value))
                                    return "value: integer expected";
                            return null;
                        };
    
                        /**
                         * Creates a TrafficEdit message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit} TrafficEdit
                         */
                        TrafficEdit.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit)
                                return object;
                            var message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = object.dateId | 0;
                            if (object.value != null)
                                message.value = object.value | 0;
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TrafficEdit message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit} message TrafficEdit
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TrafficEdit.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = 0;
                                object.value = 0;
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            if (message.value != null && message.hasOwnProperty("value"))
                                object.value = message.value;
                            return object;
                        };
    
                        /**
                         * Converts this TrafficEdit to JSON.
                         * @function toJSON
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.TrafficEdit
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TrafficEdit.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TrafficEdit;
                    })();
    
                    HakuhodoEditTrafficAdvanceInfo.PassByEdit = (function() {
    
                        /**
                         * Properties of a PassByEdit.
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                         * @interface IPassByEdit
                         * @property {number|null} [storeId] PassByEdit storeId
                         * @property {number|null} [dateId] PassByEdit dateId
                         * @property {number|null} [hour] PassByEdit hour
                         * @property {number|null} [value] PassByEdit value
                         */
    
                        /**
                         * Constructs a new PassByEdit.
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo
                         * @classdesc Represents a PassByEdit.
                         * @implements IPassByEdit
                         * @constructor
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit=} [properties] Properties to set
                         */
                        function PassByEdit(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * PassByEdit storeId.
                         * @member {number} storeId
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @instance
                         */
                        PassByEdit.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * PassByEdit dateId.
                         * @member {number} dateId
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @instance
                         */
                        PassByEdit.prototype.dateId = 0;
    
                        /**
                         * PassByEdit hour.
                         * @member {number} hour
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @instance
                         */
                        PassByEdit.prototype.hour = 0;
    
                        /**
                         * PassByEdit value.
                         * @member {number} value
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @instance
                         */
                        PassByEdit.prototype.value = 0;
    
                        /**
                         * Creates a new PassByEdit instance using the specified properties.
                         * @function create
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit=} [properties] Properties to set
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit} PassByEdit instance
                         */
                        PassByEdit.create = function create(properties) {
                            return new PassByEdit(properties);
                        };
    
                        /**
                         * Encodes the specified PassByEdit message. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit} message PassByEdit message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PassByEdit.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                            if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.hour);
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.value);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified PassByEdit message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.IPassByEdit} message PassByEdit message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PassByEdit.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a PassByEdit message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit} PassByEdit
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PassByEdit.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.int32();
                                    break;
                                case 3:
                                    message.hour = reader.int32();
                                    break;
                                case 4:
                                    message.value = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a PassByEdit message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit} PassByEdit
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PassByEdit.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a PassByEdit message.
                         * @function verify
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PassByEdit.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isInteger(message.dateId))
                                    return "dateId: integer expected";
                            if (message.hour != null && message.hasOwnProperty("hour"))
                                if (!$util.isInteger(message.hour))
                                    return "hour: integer expected";
                            if (message.value != null && message.hasOwnProperty("value"))
                                if (!$util.isInteger(message.value))
                                    return "value: integer expected";
                            return null;
                        };
    
                        /**
                         * Creates a PassByEdit message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit} PassByEdit
                         */
                        PassByEdit.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit)
                                return object;
                            var message = new $root.palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = object.dateId | 0;
                            if (object.hour != null)
                                message.hour = object.hour | 0;
                            if (object.value != null)
                                message.value = object.value | 0;
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a PassByEdit message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @static
                         * @param {palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit} message PassByEdit
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PassByEdit.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = 0;
                                object.hour = 0;
                                object.value = 0;
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            if (message.hour != null && message.hasOwnProperty("hour"))
                                object.hour = message.hour;
                            if (message.value != null && message.hasOwnProperty("value"))
                                object.value = message.value;
                            return object;
                        };
    
                        /**
                         * Converts this PassByEdit to JSON.
                         * @function toJSON
                         * @memberof palexy.sherlock.v1.HakuhodoEditTrafficAdvanceInfo.PassByEdit
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PassByEdit.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return PassByEdit;
                    })();
    
                    return HakuhodoEditTrafficAdvanceInfo;
                })();
    
                v1.HakuhodoExtrapolateDemographyAdvanceInfo = (function() {
    
                    /**
                     * Properties of a HakuhodoExtrapolateDemographyAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IHakuhodoExtrapolateDemographyAdvanceInfo
                     * @property {number|null} [startDateIdInclusive] HakuhodoExtrapolateDemographyAdvanceInfo startDateIdInclusive
                     * @property {number|null} [endDateIdInclusive] HakuhodoExtrapolateDemographyAdvanceInfo endDateIdInclusive
                     * @property {number|null} [storeId] HakuhodoExtrapolateDemographyAdvanceInfo storeId
                     */
    
                    /**
                     * Constructs a new HakuhodoExtrapolateDemographyAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a HakuhodoExtrapolateDemographyAdvanceInfo.
                     * @implements IHakuhodoExtrapolateDemographyAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo=} [properties] Properties to set
                     */
                    function HakuhodoExtrapolateDemographyAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * HakuhodoExtrapolateDemographyAdvanceInfo startDateIdInclusive.
                     * @member {number} startDateIdInclusive
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @instance
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.prototype.startDateIdInclusive = 0;
    
                    /**
                     * HakuhodoExtrapolateDemographyAdvanceInfo endDateIdInclusive.
                     * @member {number} endDateIdInclusive
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @instance
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.prototype.endDateIdInclusive = 0;
    
                    /**
                     * HakuhodoExtrapolateDemographyAdvanceInfo storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @instance
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new HakuhodoExtrapolateDemographyAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo} HakuhodoExtrapolateDemographyAdvanceInfo instance
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.create = function create(properties) {
                        return new HakuhodoExtrapolateDemographyAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified HakuhodoExtrapolateDemographyAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo} message HakuhodoExtrapolateDemographyAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateIdInclusive != null && Object.hasOwnProperty.call(message, "startDateIdInclusive"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateIdInclusive);
                        if (message.endDateIdInclusive != null && Object.hasOwnProperty.call(message, "endDateIdInclusive"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateIdInclusive);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified HakuhodoExtrapolateDemographyAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IHakuhodoExtrapolateDemographyAdvanceInfo} message HakuhodoExtrapolateDemographyAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a HakuhodoExtrapolateDemographyAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo} HakuhodoExtrapolateDemographyAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateIdInclusive = reader.int32();
                                break;
                            case 2:
                                message.endDateIdInclusive = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a HakuhodoExtrapolateDemographyAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo} HakuhodoExtrapolateDemographyAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a HakuhodoExtrapolateDemographyAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            if (!$util.isInteger(message.startDateIdInclusive))
                                return "startDateIdInclusive: integer expected";
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            if (!$util.isInteger(message.endDateIdInclusive))
                                return "endDateIdInclusive: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a HakuhodoExtrapolateDemographyAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo} HakuhodoExtrapolateDemographyAdvanceInfo
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo();
                        if (object.startDateIdInclusive != null)
                            message.startDateIdInclusive = object.startDateIdInclusive | 0;
                        if (object.endDateIdInclusive != null)
                            message.endDateIdInclusive = object.endDateIdInclusive | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a HakuhodoExtrapolateDemographyAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo} message HakuhodoExtrapolateDemographyAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateIdInclusive = 0;
                            object.endDateIdInclusive = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            object.startDateIdInclusive = message.startDateIdInclusive;
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            object.endDateIdInclusive = message.endDateIdInclusive;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this HakuhodoExtrapolateDemographyAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.HakuhodoExtrapolateDemographyAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HakuhodoExtrapolateDemographyAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return HakuhodoExtrapolateDemographyAdvanceInfo;
                })();
    
                v1.FineTuneHakuhodoStoreAdvanceInfo = (function() {
    
                    /**
                     * Properties of a FineTuneHakuhodoStoreAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IFineTuneHakuhodoStoreAdvanceInfo
                     * @property {number|null} [startDateIdInclusive] FineTuneHakuhodoStoreAdvanceInfo startDateIdInclusive
                     * @property {number|null} [endDateIdInclusive] FineTuneHakuhodoStoreAdvanceInfo endDateIdInclusive
                     * @property {number|null} [storeId] FineTuneHakuhodoStoreAdvanceInfo storeId
                     * @property {number|null} [directionalPassByStoreId] FineTuneHakuhodoStoreAdvanceInfo directionalPassByStoreId
                     * @property {Array.<palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour>|null} [trafficQc] FineTuneHakuhodoStoreAdvanceInfo trafficQc
                     * @property {Array.<palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour>|null} [passByQc] FineTuneHakuhodoStoreAdvanceInfo passByQc
                     * @property {boolean|null} [keepSectionVisitOnly] FineTuneHakuhodoStoreAdvanceInfo keepSectionVisitOnly
                     * @property {boolean|null} [exportToHakuhodoBucket] FineTuneHakuhodoStoreAdvanceInfo exportToHakuhodoBucket
                     */
    
                    /**
                     * Constructs a new FineTuneHakuhodoStoreAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FineTuneHakuhodoStoreAdvanceInfo.
                     * @implements IFineTuneHakuhodoStoreAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo=} [properties] Properties to set
                     */
                    function FineTuneHakuhodoStoreAdvanceInfo(properties) {
                        this.trafficQc = [];
                        this.passByQc = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo startDateIdInclusive.
                     * @member {number} startDateIdInclusive
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.startDateIdInclusive = 0;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo endDateIdInclusive.
                     * @member {number} endDateIdInclusive
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.endDateIdInclusive = 0;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo directionalPassByStoreId.
                     * @member {number} directionalPassByStoreId
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.directionalPassByStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo trafficQc.
                     * @member {Array.<palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour>} trafficQc
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.trafficQc = $util.emptyArray;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo passByQc.
                     * @member {Array.<palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour>} passByQc
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.passByQc = $util.emptyArray;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo keepSectionVisitOnly.
                     * @member {boolean} keepSectionVisitOnly
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.keepSectionVisitOnly = false;
    
                    /**
                     * FineTuneHakuhodoStoreAdvanceInfo exportToHakuhodoBucket.
                     * @member {boolean} exportToHakuhodoBucket
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.exportToHakuhodoBucket = false;
    
                    /**
                     * Creates a new FineTuneHakuhodoStoreAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo} FineTuneHakuhodoStoreAdvanceInfo instance
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.create = function create(properties) {
                        return new FineTuneHakuhodoStoreAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified FineTuneHakuhodoStoreAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo} message FineTuneHakuhodoStoreAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateIdInclusive != null && Object.hasOwnProperty.call(message, "startDateIdInclusive"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateIdInclusive);
                        if (message.endDateIdInclusive != null && Object.hasOwnProperty.call(message, "endDateIdInclusive"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateIdInclusive);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.directionalPassByStoreId != null && Object.hasOwnProperty.call(message, "directionalPassByStoreId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.directionalPassByStoreId);
                        if (message.trafficQc != null && message.trafficQc.length)
                            for (var i = 0; i < message.trafficQc.length; ++i)
                                $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.encode(message.trafficQc[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.passByQc != null && message.passByQc.length)
                            for (var i = 0; i < message.passByQc.length; ++i)
                                $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.encode(message.passByQc[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.keepSectionVisitOnly != null && Object.hasOwnProperty.call(message, "keepSectionVisitOnly"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.keepSectionVisitOnly);
                        if (message.exportToHakuhodoBucket != null && Object.hasOwnProperty.call(message, "exportToHakuhodoBucket"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.exportToHakuhodoBucket);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FineTuneHakuhodoStoreAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreAdvanceInfo} message FineTuneHakuhodoStoreAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FineTuneHakuhodoStoreAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo} FineTuneHakuhodoStoreAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateIdInclusive = reader.int32();
                                break;
                            case 2:
                                message.endDateIdInclusive = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.directionalPassByStoreId = reader.int64();
                                break;
                            case 5:
                                if (!(message.trafficQc && message.trafficQc.length))
                                    message.trafficQc = [];
                                message.trafficQc.push($root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                if (!(message.passByQc && message.passByQc.length))
                                    message.passByQc = [];
                                message.passByQc.push($root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.decode(reader, reader.uint32()));
                                break;
                            case 7:
                                message.keepSectionVisitOnly = reader.bool();
                                break;
                            case 8:
                                message.exportToHakuhodoBucket = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FineTuneHakuhodoStoreAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo} FineTuneHakuhodoStoreAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FineTuneHakuhodoStoreAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            if (!$util.isInteger(message.startDateIdInclusive))
                                return "startDateIdInclusive: integer expected";
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            if (!$util.isInteger(message.endDateIdInclusive))
                                return "endDateIdInclusive: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.directionalPassByStoreId != null && message.hasOwnProperty("directionalPassByStoreId"))
                            if (!$util.isInteger(message.directionalPassByStoreId) && !(message.directionalPassByStoreId && $util.isInteger(message.directionalPassByStoreId.low) && $util.isInteger(message.directionalPassByStoreId.high)))
                                return "directionalPassByStoreId: integer|Long expected";
                        if (message.trafficQc != null && message.hasOwnProperty("trafficQc")) {
                            if (!Array.isArray(message.trafficQc))
                                return "trafficQc: array expected";
                            for (var i = 0; i < message.trafficQc.length; ++i) {
                                var error = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.verify(message.trafficQc[i]);
                                if (error)
                                    return "trafficQc." + error;
                            }
                        }
                        if (message.passByQc != null && message.hasOwnProperty("passByQc")) {
                            if (!Array.isArray(message.passByQc))
                                return "passByQc: array expected";
                            for (var i = 0; i < message.passByQc.length; ++i) {
                                var error = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.verify(message.passByQc[i]);
                                if (error)
                                    return "passByQc." + error;
                            }
                        }
                        if (message.keepSectionVisitOnly != null && message.hasOwnProperty("keepSectionVisitOnly"))
                            if (typeof message.keepSectionVisitOnly !== "boolean")
                                return "keepSectionVisitOnly: boolean expected";
                        if (message.exportToHakuhodoBucket != null && message.hasOwnProperty("exportToHakuhodoBucket"))
                            if (typeof message.exportToHakuhodoBucket !== "boolean")
                                return "exportToHakuhodoBucket: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a FineTuneHakuhodoStoreAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo} FineTuneHakuhodoStoreAdvanceInfo
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo();
                        if (object.startDateIdInclusive != null)
                            message.startDateIdInclusive = object.startDateIdInclusive | 0;
                        if (object.endDateIdInclusive != null)
                            message.endDateIdInclusive = object.endDateIdInclusive | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.directionalPassByStoreId != null)
                            if ($util.Long)
                                (message.directionalPassByStoreId = $util.Long.fromValue(object.directionalPassByStoreId)).unsigned = false;
                            else if (typeof object.directionalPassByStoreId === "string")
                                message.directionalPassByStoreId = parseInt(object.directionalPassByStoreId, 10);
                            else if (typeof object.directionalPassByStoreId === "number")
                                message.directionalPassByStoreId = object.directionalPassByStoreId;
                            else if (typeof object.directionalPassByStoreId === "object")
                                message.directionalPassByStoreId = new $util.LongBits(object.directionalPassByStoreId.low >>> 0, object.directionalPassByStoreId.high >>> 0).toNumber();
                        if (object.trafficQc) {
                            if (!Array.isArray(object.trafficQc))
                                throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.trafficQc: array expected");
                            message.trafficQc = [];
                            for (var i = 0; i < object.trafficQc.length; ++i) {
                                if (typeof object.trafficQc[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.trafficQc: object expected");
                                message.trafficQc[i] = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.fromObject(object.trafficQc[i]);
                            }
                        }
                        if (object.passByQc) {
                            if (!Array.isArray(object.passByQc))
                                throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.passByQc: array expected");
                            message.passByQc = [];
                            for (var i = 0; i < object.passByQc.length; ++i) {
                                if (typeof object.passByQc[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.passByQc: object expected");
                                message.passByQc[i] = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.fromObject(object.passByQc[i]);
                            }
                        }
                        if (object.keepSectionVisitOnly != null)
                            message.keepSectionVisitOnly = Boolean(object.keepSectionVisitOnly);
                        if (object.exportToHakuhodoBucket != null)
                            message.exportToHakuhodoBucket = Boolean(object.exportToHakuhodoBucket);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FineTuneHakuhodoStoreAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo} message FineTuneHakuhodoStoreAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.trafficQc = [];
                            object.passByQc = [];
                        }
                        if (options.defaults) {
                            object.startDateIdInclusive = 0;
                            object.endDateIdInclusive = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.directionalPassByStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.directionalPassByStoreId = options.longs === String ? "0" : 0;
                            object.keepSectionVisitOnly = false;
                            object.exportToHakuhodoBucket = false;
                        }
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            object.startDateIdInclusive = message.startDateIdInclusive;
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            object.endDateIdInclusive = message.endDateIdInclusive;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.directionalPassByStoreId != null && message.hasOwnProperty("directionalPassByStoreId"))
                            if (typeof message.directionalPassByStoreId === "number")
                                object.directionalPassByStoreId = options.longs === String ? String(message.directionalPassByStoreId) : message.directionalPassByStoreId;
                            else
                                object.directionalPassByStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.directionalPassByStoreId) : options.longs === Number ? new $util.LongBits(message.directionalPassByStoreId.low >>> 0, message.directionalPassByStoreId.high >>> 0).toNumber() : message.directionalPassByStoreId;
                        if (message.trafficQc && message.trafficQc.length) {
                            object.trafficQc = [];
                            for (var j = 0; j < message.trafficQc.length; ++j)
                                object.trafficQc[j] = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.toObject(message.trafficQc[j], options);
                        }
                        if (message.passByQc && message.passByQc.length) {
                            object.passByQc = [];
                            for (var j = 0; j < message.passByQc.length; ++j)
                                object.passByQc[j] = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.toObject(message.passByQc[j], options);
                        }
                        if (message.keepSectionVisitOnly != null && message.hasOwnProperty("keepSectionVisitOnly"))
                            object.keepSectionVisitOnly = message.keepSectionVisitOnly;
                        if (message.exportToHakuhodoBucket != null && message.hasOwnProperty("exportToHakuhodoBucket"))
                            object.exportToHakuhodoBucket = message.exportToHakuhodoBucket;
                        return object;
                    };
    
                    /**
                     * Converts this FineTuneHakuhodoStoreAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FineTuneHakuhodoStoreAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour = (function() {
    
                        /**
                         * Properties of a QcMetricByHour.
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                         * @interface IQcMetricByHour
                         * @property {number|null} [dateId] QcMetricByHour dateId
                         * @property {Object.<string,number>|null} [hourToValue] QcMetricByHour hourToValue
                         */
    
                        /**
                         * Constructs a new QcMetricByHour.
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo
                         * @classdesc Represents a QcMetricByHour.
                         * @implements IQcMetricByHour
                         * @constructor
                         * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour=} [properties] Properties to set
                         */
                        function QcMetricByHour(properties) {
                            this.hourToValue = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * QcMetricByHour dateId.
                         * @member {number} dateId
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @instance
                         */
                        QcMetricByHour.prototype.dateId = 0;
    
                        /**
                         * QcMetricByHour hourToValue.
                         * @member {Object.<string,number>} hourToValue
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @instance
                         */
                        QcMetricByHour.prototype.hourToValue = $util.emptyObject;
    
                        /**
                         * Creates a new QcMetricByHour instance using the specified properties.
                         * @function create
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour=} [properties] Properties to set
                         * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour} QcMetricByHour instance
                         */
                        QcMetricByHour.create = function create(properties) {
                            return new QcMetricByHour(properties);
                        };
    
                        /**
                         * Encodes the specified QcMetricByHour message. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour} message QcMetricByHour message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        QcMetricByHour.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                            if (message.hourToValue != null && Object.hasOwnProperty.call(message, "hourToValue"))
                                for (var keys = Object.keys(message.hourToValue), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 0 =*/8).int32(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.hourToValue[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified QcMetricByHour message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.IQcMetricByHour} message QcMetricByHour message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        QcMetricByHour.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a QcMetricByHour message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour} QcMetricByHour
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        QcMetricByHour.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dateId = reader.int32();
                                    break;
                                case 2:
                                    if (message.hourToValue === $util.emptyObject)
                                        message.hourToValue = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = 0;
                                    value = 0;
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.int32();
                                            break;
                                        case 2:
                                            value = reader.int32();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.hourToValue[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a QcMetricByHour message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour} QcMetricByHour
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        QcMetricByHour.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a QcMetricByHour message.
                         * @function verify
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        QcMetricByHour.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isInteger(message.dateId))
                                    return "dateId: integer expected";
                            if (message.hourToValue != null && message.hasOwnProperty("hourToValue")) {
                                if (!$util.isObject(message.hourToValue))
                                    return "hourToValue: object expected";
                                var key = Object.keys(message.hourToValue);
                                for (var i = 0; i < key.length; ++i) {
                                    if (!$util.key32Re.test(key[i]))
                                        return "hourToValue: integer key{k:int32} expected";
                                    if (!$util.isInteger(message.hourToValue[key[i]]))
                                        return "hourToValue: integer{k:int32} expected";
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a QcMetricByHour message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour} QcMetricByHour
                         */
                        QcMetricByHour.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour)
                                return object;
                            var message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour();
                            if (object.dateId != null)
                                message.dateId = object.dateId | 0;
                            if (object.hourToValue) {
                                if (typeof object.hourToValue !== "object")
                                    throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour.hourToValue: object expected");
                                message.hourToValue = {};
                                for (var keys = Object.keys(object.hourToValue), i = 0; i < keys.length; ++i)
                                    message.hourToValue[keys[i]] = object.hourToValue[keys[i]] | 0;
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a QcMetricByHour message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @static
                         * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour} message QcMetricByHour
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        QcMetricByHour.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.hourToValue = {};
                            if (options.defaults)
                                object.dateId = 0;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            var keys2;
                            if (message.hourToValue && (keys2 = Object.keys(message.hourToValue)).length) {
                                object.hourToValue = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.hourToValue[keys2[j]] = message.hourToValue[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this QcMetricByHour to JSON.
                         * @function toJSON
                         * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreAdvanceInfo.QcMetricByHour
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        QcMetricByHour.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return QcMetricByHour;
                    })();
    
                    return FineTuneHakuhodoStoreAdvanceInfo;
                })();
    
                v1.ExportOsoolEventsAdvanceInfo = (function() {
    
                    /**
                     * Properties of an ExportOsoolEventsAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IExportOsoolEventsAdvanceInfo
                     * @property {number|null} [startDateIdInclusive] ExportOsoolEventsAdvanceInfo startDateIdInclusive
                     * @property {number|null} [endDateIdInclusive] ExportOsoolEventsAdvanceInfo endDateIdInclusive
                     */
    
                    /**
                     * Constructs a new ExportOsoolEventsAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExportOsoolEventsAdvanceInfo.
                     * @implements IExportOsoolEventsAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo=} [properties] Properties to set
                     */
                    function ExportOsoolEventsAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportOsoolEventsAdvanceInfo startDateIdInclusive.
                     * @member {number} startDateIdInclusive
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @instance
                     */
                    ExportOsoolEventsAdvanceInfo.prototype.startDateIdInclusive = 0;
    
                    /**
                     * ExportOsoolEventsAdvanceInfo endDateIdInclusive.
                     * @member {number} endDateIdInclusive
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @instance
                     */
                    ExportOsoolEventsAdvanceInfo.prototype.endDateIdInclusive = 0;
    
                    /**
                     * Creates a new ExportOsoolEventsAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo} ExportOsoolEventsAdvanceInfo instance
                     */
                    ExportOsoolEventsAdvanceInfo.create = function create(properties) {
                        return new ExportOsoolEventsAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ExportOsoolEventsAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo} message ExportOsoolEventsAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportOsoolEventsAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateIdInclusive != null && Object.hasOwnProperty.call(message, "startDateIdInclusive"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateIdInclusive);
                        if (message.endDateIdInclusive != null && Object.hasOwnProperty.call(message, "endDateIdInclusive"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateIdInclusive);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportOsoolEventsAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsAdvanceInfo} message ExportOsoolEventsAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportOsoolEventsAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportOsoolEventsAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo} ExportOsoolEventsAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportOsoolEventsAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateIdInclusive = reader.int32();
                                break;
                            case 2:
                                message.endDateIdInclusive = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportOsoolEventsAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo} ExportOsoolEventsAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportOsoolEventsAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportOsoolEventsAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportOsoolEventsAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            if (!$util.isInteger(message.startDateIdInclusive))
                                return "startDateIdInclusive: integer expected";
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            if (!$util.isInteger(message.endDateIdInclusive))
                                return "endDateIdInclusive: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportOsoolEventsAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo} ExportOsoolEventsAdvanceInfo
                     */
                    ExportOsoolEventsAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo();
                        if (object.startDateIdInclusive != null)
                            message.startDateIdInclusive = object.startDateIdInclusive | 0;
                        if (object.endDateIdInclusive != null)
                            message.endDateIdInclusive = object.endDateIdInclusive | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportOsoolEventsAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo} message ExportOsoolEventsAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportOsoolEventsAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateIdInclusive = 0;
                            object.endDateIdInclusive = 0;
                        }
                        if (message.startDateIdInclusive != null && message.hasOwnProperty("startDateIdInclusive"))
                            object.startDateIdInclusive = message.startDateIdInclusive;
                        if (message.endDateIdInclusive != null && message.hasOwnProperty("endDateIdInclusive"))
                            object.endDateIdInclusive = message.endDateIdInclusive;
                        return object;
                    };
    
                    /**
                     * Converts this ExportOsoolEventsAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportOsoolEventsAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportOsoolEventsAdvanceInfo;
                })();
    
                v1.BuildSeedAdvanceInfo = (function() {
    
                    /**
                     * Properties of a BuildSeedAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IBuildSeedAdvanceInfo
                     * @property {number|null} [seedVersionId] BuildSeedAdvanceInfo seedVersionId
                     */
    
                    /**
                     * Constructs a new BuildSeedAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BuildSeedAdvanceInfo.
                     * @implements IBuildSeedAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IBuildSeedAdvanceInfo=} [properties] Properties to set
                     */
                    function BuildSeedAdvanceInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BuildSeedAdvanceInfo seedVersionId.
                     * @member {number} seedVersionId
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @instance
                     */
                    BuildSeedAdvanceInfo.prototype.seedVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new BuildSeedAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBuildSeedAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BuildSeedAdvanceInfo} BuildSeedAdvanceInfo instance
                     */
                    BuildSeedAdvanceInfo.create = function create(properties) {
                        return new BuildSeedAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified BuildSeedAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.BuildSeedAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBuildSeedAdvanceInfo} message BuildSeedAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuildSeedAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.seedVersionId != null && Object.hasOwnProperty.call(message, "seedVersionId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seedVersionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BuildSeedAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BuildSeedAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IBuildSeedAdvanceInfo} message BuildSeedAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BuildSeedAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BuildSeedAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BuildSeedAdvanceInfo} BuildSeedAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuildSeedAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BuildSeedAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.seedVersionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BuildSeedAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BuildSeedAdvanceInfo} BuildSeedAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BuildSeedAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BuildSeedAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BuildSeedAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.seedVersionId != null && message.hasOwnProperty("seedVersionId"))
                            if (!$util.isInteger(message.seedVersionId) && !(message.seedVersionId && $util.isInteger(message.seedVersionId.low) && $util.isInteger(message.seedVersionId.high)))
                                return "seedVersionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a BuildSeedAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BuildSeedAdvanceInfo} BuildSeedAdvanceInfo
                     */
                    BuildSeedAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BuildSeedAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BuildSeedAdvanceInfo();
                        if (object.seedVersionId != null)
                            if ($util.Long)
                                (message.seedVersionId = $util.Long.fromValue(object.seedVersionId)).unsigned = false;
                            else if (typeof object.seedVersionId === "string")
                                message.seedVersionId = parseInt(object.seedVersionId, 10);
                            else if (typeof object.seedVersionId === "number")
                                message.seedVersionId = object.seedVersionId;
                            else if (typeof object.seedVersionId === "object")
                                message.seedVersionId = new $util.LongBits(object.seedVersionId.low >>> 0, object.seedVersionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BuildSeedAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.BuildSeedAdvanceInfo} message BuildSeedAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BuildSeedAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.seedVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.seedVersionId = options.longs === String ? "0" : 0;
                        if (message.seedVersionId != null && message.hasOwnProperty("seedVersionId"))
                            if (typeof message.seedVersionId === "number")
                                object.seedVersionId = options.longs === String ? String(message.seedVersionId) : message.seedVersionId;
                            else
                                object.seedVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.seedVersionId) : options.longs === Number ? new $util.LongBits(message.seedVersionId.low >>> 0, message.seedVersionId.high >>> 0).toNumber() : message.seedVersionId;
                        return object;
                    };
    
                    /**
                     * Converts this BuildSeedAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BuildSeedAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BuildSeedAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BuildSeedAdvanceInfo;
                })();
    
                v1.PredictedAndLabelItem = (function() {
    
                    /**
                     * Properties of a PredictedAndLabelItem.
                     * @memberof palexy.sherlock.v1
                     * @interface IPredictedAndLabelItem
                     * @property {string|null} [predictedBbLink] PredictedAndLabelItem predictedBbLink
                     * @property {string|null} [humanLabelBbLink] PredictedAndLabelItem humanLabelBbLink
                     */
    
                    /**
                     * Constructs a new PredictedAndLabelItem.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a PredictedAndLabelItem.
                     * @implements IPredictedAndLabelItem
                     * @constructor
                     * @param {palexy.sherlock.v1.IPredictedAndLabelItem=} [properties] Properties to set
                     */
                    function PredictedAndLabelItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PredictedAndLabelItem predictedBbLink.
                     * @member {string} predictedBbLink
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @instance
                     */
                    PredictedAndLabelItem.prototype.predictedBbLink = "";
    
                    /**
                     * PredictedAndLabelItem humanLabelBbLink.
                     * @member {string} humanLabelBbLink
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @instance
                     */
                    PredictedAndLabelItem.prototype.humanLabelBbLink = "";
    
                    /**
                     * Creates a new PredictedAndLabelItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {palexy.sherlock.v1.IPredictedAndLabelItem=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.PredictedAndLabelItem} PredictedAndLabelItem instance
                     */
                    PredictedAndLabelItem.create = function create(properties) {
                        return new PredictedAndLabelItem(properties);
                    };
    
                    /**
                     * Encodes the specified PredictedAndLabelItem message. Does not implicitly {@link palexy.sherlock.v1.PredictedAndLabelItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {palexy.sherlock.v1.IPredictedAndLabelItem} message PredictedAndLabelItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PredictedAndLabelItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.predictedBbLink != null && Object.hasOwnProperty.call(message, "predictedBbLink"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.predictedBbLink);
                        if (message.humanLabelBbLink != null && Object.hasOwnProperty.call(message, "humanLabelBbLink"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.humanLabelBbLink);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PredictedAndLabelItem message, length delimited. Does not implicitly {@link palexy.sherlock.v1.PredictedAndLabelItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {palexy.sherlock.v1.IPredictedAndLabelItem} message PredictedAndLabelItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PredictedAndLabelItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PredictedAndLabelItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.PredictedAndLabelItem} PredictedAndLabelItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PredictedAndLabelItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.PredictedAndLabelItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.predictedBbLink = reader.string();
                                break;
                            case 2:
                                message.humanLabelBbLink = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PredictedAndLabelItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.PredictedAndLabelItem} PredictedAndLabelItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PredictedAndLabelItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PredictedAndLabelItem message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PredictedAndLabelItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.predictedBbLink != null && message.hasOwnProperty("predictedBbLink"))
                            if (!$util.isString(message.predictedBbLink))
                                return "predictedBbLink: string expected";
                        if (message.humanLabelBbLink != null && message.hasOwnProperty("humanLabelBbLink"))
                            if (!$util.isString(message.humanLabelBbLink))
                                return "humanLabelBbLink: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PredictedAndLabelItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.PredictedAndLabelItem} PredictedAndLabelItem
                     */
                    PredictedAndLabelItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.PredictedAndLabelItem)
                            return object;
                        var message = new $root.palexy.sherlock.v1.PredictedAndLabelItem();
                        if (object.predictedBbLink != null)
                            message.predictedBbLink = String(object.predictedBbLink);
                        if (object.humanLabelBbLink != null)
                            message.humanLabelBbLink = String(object.humanLabelBbLink);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PredictedAndLabelItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @static
                     * @param {palexy.sherlock.v1.PredictedAndLabelItem} message PredictedAndLabelItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PredictedAndLabelItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.predictedBbLink = "";
                            object.humanLabelBbLink = "";
                        }
                        if (message.predictedBbLink != null && message.hasOwnProperty("predictedBbLink"))
                            object.predictedBbLink = message.predictedBbLink;
                        if (message.humanLabelBbLink != null && message.hasOwnProperty("humanLabelBbLink"))
                            object.humanLabelBbLink = message.humanLabelBbLink;
                        return object;
                    };
    
                    /**
                     * Converts this PredictedAndLabelItem to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.PredictedAndLabelItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PredictedAndLabelItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PredictedAndLabelItem;
                })();
    
                v1.SherlockTaskResult = (function() {
    
                    /**
                     * Properties of a SherlockTaskResult.
                     * @memberof palexy.sherlock.v1
                     * @interface ISherlockTaskResult
                     * @property {number|null} [id] SherlockTaskResult id
                     * @property {google.protobuf.ITimestamp|null} [createTime] SherlockTaskResult createTime
                     * @property {number|null} [taskId] SherlockTaskResult taskId
                     * @property {palexy.sherlock.v1.ICoreSherlockTaskResult|null} [coreTaskResult] SherlockTaskResult coreTaskResult
                     */
    
                    /**
                     * Constructs a new SherlockTaskResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a SherlockTaskResult.
                     * @implements ISherlockTaskResult
                     * @constructor
                     * @param {palexy.sherlock.v1.ISherlockTaskResult=} [properties] Properties to set
                     */
                    function SherlockTaskResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SherlockTaskResult id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @instance
                     */
                    SherlockTaskResult.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SherlockTaskResult createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @instance
                     */
                    SherlockTaskResult.prototype.createTime = null;
    
                    /**
                     * SherlockTaskResult taskId.
                     * @member {number} taskId
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @instance
                     */
                    SherlockTaskResult.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SherlockTaskResult coreTaskResult.
                     * @member {palexy.sherlock.v1.ICoreSherlockTaskResult|null|undefined} coreTaskResult
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @instance
                     */
                    SherlockTaskResult.prototype.coreTaskResult = null;
    
                    /**
                     * Creates a new SherlockTaskResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.SherlockTaskResult} SherlockTaskResult instance
                     */
                    SherlockTaskResult.create = function create(properties) {
                        return new SherlockTaskResult(properties);
                    };
    
                    /**
                     * Encodes the specified SherlockTaskResult message. Does not implicitly {@link palexy.sherlock.v1.SherlockTaskResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskResult} message SherlockTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTaskResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.taskId);
                        if (message.coreTaskResult != null && Object.hasOwnProperty.call(message, "coreTaskResult"))
                            $root.palexy.sherlock.v1.CoreSherlockTaskResult.encode(message.coreTaskResult, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SherlockTaskResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.SherlockTaskResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskResult} message SherlockTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTaskResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SherlockTaskResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.SherlockTaskResult} SherlockTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTaskResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.SherlockTaskResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.taskId = reader.int64();
                                break;
                            case 4:
                                message.coreTaskResult = $root.palexy.sherlock.v1.CoreSherlockTaskResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SherlockTaskResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.SherlockTaskResult} SherlockTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTaskResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SherlockTaskResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SherlockTaskResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        if (message.coreTaskResult != null && message.hasOwnProperty("coreTaskResult")) {
                            var error = $root.palexy.sherlock.v1.CoreSherlockTaskResult.verify(message.coreTaskResult);
                            if (error)
                                return "coreTaskResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SherlockTaskResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.SherlockTaskResult} SherlockTaskResult
                     */
                    SherlockTaskResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.SherlockTaskResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.SherlockTaskResult();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTaskResult.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        if (object.coreTaskResult != null) {
                            if (typeof object.coreTaskResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTaskResult.coreTaskResult: object expected");
                            message.coreTaskResult = $root.palexy.sherlock.v1.CoreSherlockTaskResult.fromObject(object.coreTaskResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SherlockTaskResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.SherlockTaskResult} message SherlockTaskResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SherlockTaskResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                            object.coreTaskResult = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        if (message.coreTaskResult != null && message.hasOwnProperty("coreTaskResult"))
                            object.coreTaskResult = $root.palexy.sherlock.v1.CoreSherlockTaskResult.toObject(message.coreTaskResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this SherlockTaskResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.SherlockTaskResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SherlockTaskResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SherlockTaskResult;
                })();
    
                v1.CoreSherlockTaskResult = (function() {
    
                    /**
                     * Properties of a CoreSherlockTaskResult.
                     * @memberof palexy.sherlock.v1
                     * @interface ICoreSherlockTaskResult
                     * @property {palexy.sherlock.v1.IDebugPersonResult|null} [debugPersonResult] CoreSherlockTaskResult debugPersonResult
                     * @property {palexy.sherlock.v1.IMergeAccuracyResult|null} [mergeAccuracyResult] CoreSherlockTaskResult mergeAccuracyResult
                     * @property {palexy.sherlock.v1.IPostMergeResult|null} [postMergeResult] CoreSherlockTaskResult postMergeResult
                     * @property {palexy.sherlock.v1.IScanMergeConfigResult|null} [scanMergeConfigResult] CoreSherlockTaskResult scanMergeConfigResult
                     * @property {palexy.sherlock.v1.IRerunMergeConfigResult|null} [rerunMergeConfigResult] CoreSherlockTaskResult rerunMergeConfigResult
                     * @property {palexy.sherlock.v1.IDebugExperimentResult|null} [debugExperimentResult] CoreSherlockTaskResult debugExperimentResult
                     * @property {palexy.sherlock.v1.IPrepareQcVideosResult|null} [prepareQcVideosResult] CoreSherlockTaskResult prepareQcVideosResult
                     * @property {palexy.sherlock.v1.IExportHakuhodoResult|null} [exportHakuhodoResult] CoreSherlockTaskResult exportHakuhodoResult
                     * @property {palexy.sherlock.v1.IExportOsoolEventsResult|null} [exportOsoolEventsResult] CoreSherlockTaskResult exportOsoolEventsResult
                     * @property {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult|null} [fineTuneHakuhodoStoreResult] CoreSherlockTaskResult fineTuneHakuhodoStoreResult
                     */
    
                    /**
                     * Constructs a new CoreSherlockTaskResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CoreSherlockTaskResult.
                     * @implements ICoreSherlockTaskResult
                     * @constructor
                     * @param {palexy.sherlock.v1.ICoreSherlockTaskResult=} [properties] Properties to set
                     */
                    function CoreSherlockTaskResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CoreSherlockTaskResult debugPersonResult.
                     * @member {palexy.sherlock.v1.IDebugPersonResult|null|undefined} debugPersonResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.debugPersonResult = null;
    
                    /**
                     * CoreSherlockTaskResult mergeAccuracyResult.
                     * @member {palexy.sherlock.v1.IMergeAccuracyResult|null|undefined} mergeAccuracyResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.mergeAccuracyResult = null;
    
                    /**
                     * CoreSherlockTaskResult postMergeResult.
                     * @member {palexy.sherlock.v1.IPostMergeResult|null|undefined} postMergeResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.postMergeResult = null;
    
                    /**
                     * CoreSherlockTaskResult scanMergeConfigResult.
                     * @member {palexy.sherlock.v1.IScanMergeConfigResult|null|undefined} scanMergeConfigResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.scanMergeConfigResult = null;
    
                    /**
                     * CoreSherlockTaskResult rerunMergeConfigResult.
                     * @member {palexy.sherlock.v1.IRerunMergeConfigResult|null|undefined} rerunMergeConfigResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.rerunMergeConfigResult = null;
    
                    /**
                     * CoreSherlockTaskResult debugExperimentResult.
                     * @member {palexy.sherlock.v1.IDebugExperimentResult|null|undefined} debugExperimentResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.debugExperimentResult = null;
    
                    /**
                     * CoreSherlockTaskResult prepareQcVideosResult.
                     * @member {palexy.sherlock.v1.IPrepareQcVideosResult|null|undefined} prepareQcVideosResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.prepareQcVideosResult = null;
    
                    /**
                     * CoreSherlockTaskResult exportHakuhodoResult.
                     * @member {palexy.sherlock.v1.IExportHakuhodoResult|null|undefined} exportHakuhodoResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.exportHakuhodoResult = null;
    
                    /**
                     * CoreSherlockTaskResult exportOsoolEventsResult.
                     * @member {palexy.sherlock.v1.IExportOsoolEventsResult|null|undefined} exportOsoolEventsResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.exportOsoolEventsResult = null;
    
                    /**
                     * CoreSherlockTaskResult fineTuneHakuhodoStoreResult.
                     * @member {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult|null|undefined} fineTuneHakuhodoStoreResult
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    CoreSherlockTaskResult.prototype.fineTuneHakuhodoStoreResult = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * CoreSherlockTaskResult result.
                     * @member {"debugPersonResult"|"mergeAccuracyResult"|"postMergeResult"|"scanMergeConfigResult"|"rerunMergeConfigResult"|"debugExperimentResult"|"prepareQcVideosResult"|"exportHakuhodoResult"|"exportOsoolEventsResult"|"fineTuneHakuhodoStoreResult"|undefined} result
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     */
                    Object.defineProperty(CoreSherlockTaskResult.prototype, "result", {
                        get: $util.oneOfGetter($oneOfFields = ["debugPersonResult", "mergeAccuracyResult", "postMergeResult", "scanMergeConfigResult", "rerunMergeConfigResult", "debugExperimentResult", "prepareQcVideosResult", "exportHakuhodoResult", "exportOsoolEventsResult", "fineTuneHakuhodoStoreResult"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new CoreSherlockTaskResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ICoreSherlockTaskResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CoreSherlockTaskResult} CoreSherlockTaskResult instance
                     */
                    CoreSherlockTaskResult.create = function create(properties) {
                        return new CoreSherlockTaskResult(properties);
                    };
    
                    /**
                     * Encodes the specified CoreSherlockTaskResult message. Does not implicitly {@link palexy.sherlock.v1.CoreSherlockTaskResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ICoreSherlockTaskResult} message CoreSherlockTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CoreSherlockTaskResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.debugPersonResult != null && Object.hasOwnProperty.call(message, "debugPersonResult"))
                            $root.palexy.sherlock.v1.DebugPersonResult.encode(message.debugPersonResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.mergeAccuracyResult != null && Object.hasOwnProperty.call(message, "mergeAccuracyResult"))
                            $root.palexy.sherlock.v1.MergeAccuracyResult.encode(message.mergeAccuracyResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.postMergeResult != null && Object.hasOwnProperty.call(message, "postMergeResult"))
                            $root.palexy.sherlock.v1.PostMergeResult.encode(message.postMergeResult, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.scanMergeConfigResult != null && Object.hasOwnProperty.call(message, "scanMergeConfigResult"))
                            $root.palexy.sherlock.v1.ScanMergeConfigResult.encode(message.scanMergeConfigResult, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.rerunMergeConfigResult != null && Object.hasOwnProperty.call(message, "rerunMergeConfigResult"))
                            $root.palexy.sherlock.v1.RerunMergeConfigResult.encode(message.rerunMergeConfigResult, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.debugExperimentResult != null && Object.hasOwnProperty.call(message, "debugExperimentResult"))
                            $root.palexy.sherlock.v1.DebugExperimentResult.encode(message.debugExperimentResult, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.prepareQcVideosResult != null && Object.hasOwnProperty.call(message, "prepareQcVideosResult"))
                            $root.palexy.sherlock.v1.PrepareQcVideosResult.encode(message.prepareQcVideosResult, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.exportHakuhodoResult != null && Object.hasOwnProperty.call(message, "exportHakuhodoResult"))
                            $root.palexy.sherlock.v1.ExportHakuhodoResult.encode(message.exportHakuhodoResult, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.exportOsoolEventsResult != null && Object.hasOwnProperty.call(message, "exportOsoolEventsResult"))
                            $root.palexy.sherlock.v1.ExportOsoolEventsResult.encode(message.exportOsoolEventsResult, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.fineTuneHakuhodoStoreResult != null && Object.hasOwnProperty.call(message, "fineTuneHakuhodoStoreResult"))
                            $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult.encode(message.fineTuneHakuhodoStoreResult, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CoreSherlockTaskResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CoreSherlockTaskResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.ICoreSherlockTaskResult} message CoreSherlockTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CoreSherlockTaskResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CoreSherlockTaskResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CoreSherlockTaskResult} CoreSherlockTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CoreSherlockTaskResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CoreSherlockTaskResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.mergeAccuracyResult = $root.palexy.sherlock.v1.MergeAccuracyResult.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.postMergeResult = $root.palexy.sherlock.v1.PostMergeResult.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.scanMergeConfigResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.rerunMergeConfigResult = $root.palexy.sherlock.v1.RerunMergeConfigResult.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.debugExperimentResult = $root.palexy.sherlock.v1.DebugExperimentResult.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.prepareQcVideosResult = $root.palexy.sherlock.v1.PrepareQcVideosResult.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.exportHakuhodoResult = $root.palexy.sherlock.v1.ExportHakuhodoResult.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.exportOsoolEventsResult = $root.palexy.sherlock.v1.ExportOsoolEventsResult.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.fineTuneHakuhodoStoreResult = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CoreSherlockTaskResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CoreSherlockTaskResult} CoreSherlockTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CoreSherlockTaskResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CoreSherlockTaskResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CoreSherlockTaskResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.debugPersonResult != null && message.hasOwnProperty("debugPersonResult")) {
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.DebugPersonResult.verify(message.debugPersonResult);
                                if (error)
                                    return "debugPersonResult." + error;
                            }
                        }
                        if (message.mergeAccuracyResult != null && message.hasOwnProperty("mergeAccuracyResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.MergeAccuracyResult.verify(message.mergeAccuracyResult);
                                if (error)
                                    return "mergeAccuracyResult." + error;
                            }
                        }
                        if (message.postMergeResult != null && message.hasOwnProperty("postMergeResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.PostMergeResult.verify(message.postMergeResult);
                                if (error)
                                    return "postMergeResult." + error;
                            }
                        }
                        if (message.scanMergeConfigResult != null && message.hasOwnProperty("scanMergeConfigResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ScanMergeConfigResult.verify(message.scanMergeConfigResult);
                                if (error)
                                    return "scanMergeConfigResult." + error;
                            }
                        }
                        if (message.rerunMergeConfigResult != null && message.hasOwnProperty("rerunMergeConfigResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.RerunMergeConfigResult.verify(message.rerunMergeConfigResult);
                                if (error)
                                    return "rerunMergeConfigResult." + error;
                            }
                        }
                        if (message.debugExperimentResult != null && message.hasOwnProperty("debugExperimentResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.DebugExperimentResult.verify(message.debugExperimentResult);
                                if (error)
                                    return "debugExperimentResult." + error;
                            }
                        }
                        if (message.prepareQcVideosResult != null && message.hasOwnProperty("prepareQcVideosResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.PrepareQcVideosResult.verify(message.prepareQcVideosResult);
                                if (error)
                                    return "prepareQcVideosResult." + error;
                            }
                        }
                        if (message.exportHakuhodoResult != null && message.hasOwnProperty("exportHakuhodoResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ExportHakuhodoResult.verify(message.exportHakuhodoResult);
                                if (error)
                                    return "exportHakuhodoResult." + error;
                            }
                        }
                        if (message.exportOsoolEventsResult != null && message.hasOwnProperty("exportOsoolEventsResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.ExportOsoolEventsResult.verify(message.exportOsoolEventsResult);
                                if (error)
                                    return "exportOsoolEventsResult." + error;
                            }
                        }
                        if (message.fineTuneHakuhodoStoreResult != null && message.hasOwnProperty("fineTuneHakuhodoStoreResult")) {
                            if (properties.result === 1)
                                return "result: multiple values";
                            properties.result = 1;
                            {
                                var error = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult.verify(message.fineTuneHakuhodoStoreResult);
                                if (error)
                                    return "fineTuneHakuhodoStoreResult." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CoreSherlockTaskResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CoreSherlockTaskResult} CoreSherlockTaskResult
                     */
                    CoreSherlockTaskResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CoreSherlockTaskResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CoreSherlockTaskResult();
                        if (object.debugPersonResult != null) {
                            if (typeof object.debugPersonResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.debugPersonResult: object expected");
                            message.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.fromObject(object.debugPersonResult);
                        }
                        if (object.mergeAccuracyResult != null) {
                            if (typeof object.mergeAccuracyResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.mergeAccuracyResult: object expected");
                            message.mergeAccuracyResult = $root.palexy.sherlock.v1.MergeAccuracyResult.fromObject(object.mergeAccuracyResult);
                        }
                        if (object.postMergeResult != null) {
                            if (typeof object.postMergeResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.postMergeResult: object expected");
                            message.postMergeResult = $root.palexy.sherlock.v1.PostMergeResult.fromObject(object.postMergeResult);
                        }
                        if (object.scanMergeConfigResult != null) {
                            if (typeof object.scanMergeConfigResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.scanMergeConfigResult: object expected");
                            message.scanMergeConfigResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.fromObject(object.scanMergeConfigResult);
                        }
                        if (object.rerunMergeConfigResult != null) {
                            if (typeof object.rerunMergeConfigResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.rerunMergeConfigResult: object expected");
                            message.rerunMergeConfigResult = $root.palexy.sherlock.v1.RerunMergeConfigResult.fromObject(object.rerunMergeConfigResult);
                        }
                        if (object.debugExperimentResult != null) {
                            if (typeof object.debugExperimentResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.debugExperimentResult: object expected");
                            message.debugExperimentResult = $root.palexy.sherlock.v1.DebugExperimentResult.fromObject(object.debugExperimentResult);
                        }
                        if (object.prepareQcVideosResult != null) {
                            if (typeof object.prepareQcVideosResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.prepareQcVideosResult: object expected");
                            message.prepareQcVideosResult = $root.palexy.sherlock.v1.PrepareQcVideosResult.fromObject(object.prepareQcVideosResult);
                        }
                        if (object.exportHakuhodoResult != null) {
                            if (typeof object.exportHakuhodoResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.exportHakuhodoResult: object expected");
                            message.exportHakuhodoResult = $root.palexy.sherlock.v1.ExportHakuhodoResult.fromObject(object.exportHakuhodoResult);
                        }
                        if (object.exportOsoolEventsResult != null) {
                            if (typeof object.exportOsoolEventsResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.exportOsoolEventsResult: object expected");
                            message.exportOsoolEventsResult = $root.palexy.sherlock.v1.ExportOsoolEventsResult.fromObject(object.exportOsoolEventsResult);
                        }
                        if (object.fineTuneHakuhodoStoreResult != null) {
                            if (typeof object.fineTuneHakuhodoStoreResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CoreSherlockTaskResult.fineTuneHakuhodoStoreResult: object expected");
                            message.fineTuneHakuhodoStoreResult = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult.fromObject(object.fineTuneHakuhodoStoreResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CoreSherlockTaskResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @static
                     * @param {palexy.sherlock.v1.CoreSherlockTaskResult} message CoreSherlockTaskResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CoreSherlockTaskResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.debugPersonResult != null && message.hasOwnProperty("debugPersonResult")) {
                            object.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.toObject(message.debugPersonResult, options);
                            if (options.oneofs)
                                object.result = "debugPersonResult";
                        }
                        if (message.mergeAccuracyResult != null && message.hasOwnProperty("mergeAccuracyResult")) {
                            object.mergeAccuracyResult = $root.palexy.sherlock.v1.MergeAccuracyResult.toObject(message.mergeAccuracyResult, options);
                            if (options.oneofs)
                                object.result = "mergeAccuracyResult";
                        }
                        if (message.postMergeResult != null && message.hasOwnProperty("postMergeResult")) {
                            object.postMergeResult = $root.palexy.sherlock.v1.PostMergeResult.toObject(message.postMergeResult, options);
                            if (options.oneofs)
                                object.result = "postMergeResult";
                        }
                        if (message.scanMergeConfigResult != null && message.hasOwnProperty("scanMergeConfigResult")) {
                            object.scanMergeConfigResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.toObject(message.scanMergeConfigResult, options);
                            if (options.oneofs)
                                object.result = "scanMergeConfigResult";
                        }
                        if (message.rerunMergeConfigResult != null && message.hasOwnProperty("rerunMergeConfigResult")) {
                            object.rerunMergeConfigResult = $root.palexy.sherlock.v1.RerunMergeConfigResult.toObject(message.rerunMergeConfigResult, options);
                            if (options.oneofs)
                                object.result = "rerunMergeConfigResult";
                        }
                        if (message.debugExperimentResult != null && message.hasOwnProperty("debugExperimentResult")) {
                            object.debugExperimentResult = $root.palexy.sherlock.v1.DebugExperimentResult.toObject(message.debugExperimentResult, options);
                            if (options.oneofs)
                                object.result = "debugExperimentResult";
                        }
                        if (message.prepareQcVideosResult != null && message.hasOwnProperty("prepareQcVideosResult")) {
                            object.prepareQcVideosResult = $root.palexy.sherlock.v1.PrepareQcVideosResult.toObject(message.prepareQcVideosResult, options);
                            if (options.oneofs)
                                object.result = "prepareQcVideosResult";
                        }
                        if (message.exportHakuhodoResult != null && message.hasOwnProperty("exportHakuhodoResult")) {
                            object.exportHakuhodoResult = $root.palexy.sherlock.v1.ExportHakuhodoResult.toObject(message.exportHakuhodoResult, options);
                            if (options.oneofs)
                                object.result = "exportHakuhodoResult";
                        }
                        if (message.exportOsoolEventsResult != null && message.hasOwnProperty("exportOsoolEventsResult")) {
                            object.exportOsoolEventsResult = $root.palexy.sherlock.v1.ExportOsoolEventsResult.toObject(message.exportOsoolEventsResult, options);
                            if (options.oneofs)
                                object.result = "exportOsoolEventsResult";
                        }
                        if (message.fineTuneHakuhodoStoreResult != null && message.hasOwnProperty("fineTuneHakuhodoStoreResult")) {
                            object.fineTuneHakuhodoStoreResult = $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult.toObject(message.fineTuneHakuhodoStoreResult, options);
                            if (options.oneofs)
                                object.result = "fineTuneHakuhodoStoreResult";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CoreSherlockTaskResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CoreSherlockTaskResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CoreSherlockTaskResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CoreSherlockTaskResult;
                })();
    
                v1.PostMergeResult = (function() {
    
                    /**
                     * Properties of a PostMergeResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IPostMergeResult
                     * @property {palexy.sherlock.v1.IDebugPersonResult|null} [debugPersonResult] PostMergeResult debugPersonResult
                     */
    
                    /**
                     * Constructs a new PostMergeResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a PostMergeResult.
                     * @implements IPostMergeResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IPostMergeResult=} [properties] Properties to set
                     */
                    function PostMergeResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PostMergeResult debugPersonResult.
                     * @member {palexy.sherlock.v1.IDebugPersonResult|null|undefined} debugPersonResult
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @instance
                     */
                    PostMergeResult.prototype.debugPersonResult = null;
    
                    /**
                     * Creates a new PostMergeResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {palexy.sherlock.v1.IPostMergeResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.PostMergeResult} PostMergeResult instance
                     */
                    PostMergeResult.create = function create(properties) {
                        return new PostMergeResult(properties);
                    };
    
                    /**
                     * Encodes the specified PostMergeResult message. Does not implicitly {@link palexy.sherlock.v1.PostMergeResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {palexy.sherlock.v1.IPostMergeResult} message PostMergeResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostMergeResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.debugPersonResult != null && Object.hasOwnProperty.call(message, "debugPersonResult"))
                            $root.palexy.sherlock.v1.DebugPersonResult.encode(message.debugPersonResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PostMergeResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.PostMergeResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {palexy.sherlock.v1.IPostMergeResult} message PostMergeResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostMergeResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PostMergeResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.PostMergeResult} PostMergeResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostMergeResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.PostMergeResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PostMergeResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.PostMergeResult} PostMergeResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostMergeResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PostMergeResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PostMergeResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.debugPersonResult != null && message.hasOwnProperty("debugPersonResult")) {
                            var error = $root.palexy.sherlock.v1.DebugPersonResult.verify(message.debugPersonResult);
                            if (error)
                                return "debugPersonResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PostMergeResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.PostMergeResult} PostMergeResult
                     */
                    PostMergeResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.PostMergeResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.PostMergeResult();
                        if (object.debugPersonResult != null) {
                            if (typeof object.debugPersonResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.PostMergeResult.debugPersonResult: object expected");
                            message.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.fromObject(object.debugPersonResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PostMergeResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @static
                     * @param {palexy.sherlock.v1.PostMergeResult} message PostMergeResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PostMergeResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.debugPersonResult = null;
                        if (message.debugPersonResult != null && message.hasOwnProperty("debugPersonResult"))
                            object.debugPersonResult = $root.palexy.sherlock.v1.DebugPersonResult.toObject(message.debugPersonResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this PostMergeResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.PostMergeResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PostMergeResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PostMergeResult;
                })();
    
                v1.DebugPersonResult = (function() {
    
                    /**
                     * Properties of a DebugPersonResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IDebugPersonResult
                     * @property {palexy.sherlock.v1.IGeneralPersonInfoResult|null} [generalPersonInfoResult] DebugPersonResult generalPersonInfoResult
                     * @property {palexy.sherlock.v1.IExtractBBResult|null} [extractBbResult] DebugPersonResult extractBbResult
                     */
    
                    /**
                     * Constructs a new DebugPersonResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DebugPersonResult.
                     * @implements IDebugPersonResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IDebugPersonResult=} [properties] Properties to set
                     */
                    function DebugPersonResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DebugPersonResult generalPersonInfoResult.
                     * @member {palexy.sherlock.v1.IGeneralPersonInfoResult|null|undefined} generalPersonInfoResult
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @instance
                     */
                    DebugPersonResult.prototype.generalPersonInfoResult = null;
    
                    /**
                     * DebugPersonResult extractBbResult.
                     * @member {palexy.sherlock.v1.IExtractBBResult|null|undefined} extractBbResult
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @instance
                     */
                    DebugPersonResult.prototype.extractBbResult = null;
    
                    /**
                     * Creates a new DebugPersonResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DebugPersonResult} DebugPersonResult instance
                     */
                    DebugPersonResult.create = function create(properties) {
                        return new DebugPersonResult(properties);
                    };
    
                    /**
                     * Encodes the specified DebugPersonResult message. Does not implicitly {@link palexy.sherlock.v1.DebugPersonResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonResult} message DebugPersonResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugPersonResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.generalPersonInfoResult != null && Object.hasOwnProperty.call(message, "generalPersonInfoResult"))
                            $root.palexy.sherlock.v1.GeneralPersonInfoResult.encode(message.generalPersonInfoResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.extractBbResult != null && Object.hasOwnProperty.call(message, "extractBbResult"))
                            $root.palexy.sherlock.v1.ExtractBBResult.encode(message.extractBbResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DebugPersonResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DebugPersonResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugPersonResult} message DebugPersonResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugPersonResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DebugPersonResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DebugPersonResult} DebugPersonResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugPersonResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DebugPersonResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.generalPersonInfoResult = $root.palexy.sherlock.v1.GeneralPersonInfoResult.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DebugPersonResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DebugPersonResult} DebugPersonResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugPersonResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DebugPersonResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DebugPersonResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.generalPersonInfoResult != null && message.hasOwnProperty("generalPersonInfoResult")) {
                            var error = $root.palexy.sherlock.v1.GeneralPersonInfoResult.verify(message.generalPersonInfoResult);
                            if (error)
                                return "generalPersonInfoResult." + error;
                        }
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult")) {
                            var error = $root.palexy.sherlock.v1.ExtractBBResult.verify(message.extractBbResult);
                            if (error)
                                return "extractBbResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DebugPersonResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DebugPersonResult} DebugPersonResult
                     */
                    DebugPersonResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DebugPersonResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DebugPersonResult();
                        if (object.generalPersonInfoResult != null) {
                            if (typeof object.generalPersonInfoResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.DebugPersonResult.generalPersonInfoResult: object expected");
                            message.generalPersonInfoResult = $root.palexy.sherlock.v1.GeneralPersonInfoResult.fromObject(object.generalPersonInfoResult);
                        }
                        if (object.extractBbResult != null) {
                            if (typeof object.extractBbResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.DebugPersonResult.extractBbResult: object expected");
                            message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.fromObject(object.extractBbResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DebugPersonResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @static
                     * @param {palexy.sherlock.v1.DebugPersonResult} message DebugPersonResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DebugPersonResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.generalPersonInfoResult = null;
                            object.extractBbResult = null;
                        }
                        if (message.generalPersonInfoResult != null && message.hasOwnProperty("generalPersonInfoResult"))
                            object.generalPersonInfoResult = $root.palexy.sherlock.v1.GeneralPersonInfoResult.toObject(message.generalPersonInfoResult, options);
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult"))
                            object.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.toObject(message.extractBbResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this DebugPersonResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DebugPersonResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DebugPersonResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DebugPersonResult;
                })();
    
                v1.DebugExperimentResult = (function() {
    
                    /**
                     * Properties of a DebugExperimentResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IDebugExperimentResult
                     * @property {string|null} [trackingDataLink] DebugExperimentResult trackingDataLink
                     */
    
                    /**
                     * Constructs a new DebugExperimentResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DebugExperimentResult.
                     * @implements IDebugExperimentResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IDebugExperimentResult=} [properties] Properties to set
                     */
                    function DebugExperimentResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DebugExperimentResult trackingDataLink.
                     * @member {string} trackingDataLink
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @instance
                     */
                    DebugExperimentResult.prototype.trackingDataLink = "";
    
                    /**
                     * Creates a new DebugExperimentResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DebugExperimentResult} DebugExperimentResult instance
                     */
                    DebugExperimentResult.create = function create(properties) {
                        return new DebugExperimentResult(properties);
                    };
    
                    /**
                     * Encodes the specified DebugExperimentResult message. Does not implicitly {@link palexy.sherlock.v1.DebugExperimentResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentResult} message DebugExperimentResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugExperimentResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.trackingDataLink != null && Object.hasOwnProperty.call(message, "trackingDataLink"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.trackingDataLink);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DebugExperimentResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DebugExperimentResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {palexy.sherlock.v1.IDebugExperimentResult} message DebugExperimentResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DebugExperimentResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DebugExperimentResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DebugExperimentResult} DebugExperimentResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugExperimentResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DebugExperimentResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.trackingDataLink = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DebugExperimentResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DebugExperimentResult} DebugExperimentResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DebugExperimentResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DebugExperimentResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DebugExperimentResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.trackingDataLink != null && message.hasOwnProperty("trackingDataLink"))
                            if (!$util.isString(message.trackingDataLink))
                                return "trackingDataLink: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DebugExperimentResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DebugExperimentResult} DebugExperimentResult
                     */
                    DebugExperimentResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DebugExperimentResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DebugExperimentResult();
                        if (object.trackingDataLink != null)
                            message.trackingDataLink = String(object.trackingDataLink);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DebugExperimentResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @static
                     * @param {palexy.sherlock.v1.DebugExperimentResult} message DebugExperimentResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DebugExperimentResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.trackingDataLink = "";
                        if (message.trackingDataLink != null && message.hasOwnProperty("trackingDataLink"))
                            object.trackingDataLink = message.trackingDataLink;
                        return object;
                    };
    
                    /**
                     * Converts this DebugExperimentResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DebugExperimentResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DebugExperimentResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DebugExperimentResult;
                })();
    
                v1.PrepareQcVideosResult = (function() {
    
                    /**
                     * Properties of a PrepareQcVideosResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IPrepareQcVideosResult
                     * @property {Array.<palexy.sherlock.v1.IRemoteFile>|null} [qcVideos] PrepareQcVideosResult qcVideos
                     * @property {palexy.sherlock.v1.SherlockTask.StorageProvider|null} [storageProvider] PrepareQcVideosResult storageProvider
                     * @property {string|null} [googleDriveTaskResultDirId] PrepareQcVideosResult googleDriveTaskResultDirId
                     * @property {string|null} [googleDriveTaskResultWebViewLink] PrepareQcVideosResult googleDriveTaskResultWebViewLink
                     */
    
                    /**
                     * Constructs a new PrepareQcVideosResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a PrepareQcVideosResult.
                     * @implements IPrepareQcVideosResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IPrepareQcVideosResult=} [properties] Properties to set
                     */
                    function PrepareQcVideosResult(properties) {
                        this.qcVideos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PrepareQcVideosResult qcVideos.
                     * @member {Array.<palexy.sherlock.v1.IRemoteFile>} qcVideos
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @instance
                     */
                    PrepareQcVideosResult.prototype.qcVideos = $util.emptyArray;
    
                    /**
                     * PrepareQcVideosResult storageProvider.
                     * @member {palexy.sherlock.v1.SherlockTask.StorageProvider} storageProvider
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @instance
                     */
                    PrepareQcVideosResult.prototype.storageProvider = 0;
    
                    /**
                     * PrepareQcVideosResult googleDriveTaskResultDirId.
                     * @member {string} googleDriveTaskResultDirId
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @instance
                     */
                    PrepareQcVideosResult.prototype.googleDriveTaskResultDirId = "";
    
                    /**
                     * PrepareQcVideosResult googleDriveTaskResultWebViewLink.
                     * @member {string} googleDriveTaskResultWebViewLink
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @instance
                     */
                    PrepareQcVideosResult.prototype.googleDriveTaskResultWebViewLink = "";
    
                    /**
                     * Creates a new PrepareQcVideosResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.PrepareQcVideosResult} PrepareQcVideosResult instance
                     */
                    PrepareQcVideosResult.create = function create(properties) {
                        return new PrepareQcVideosResult(properties);
                    };
    
                    /**
                     * Encodes the specified PrepareQcVideosResult message. Does not implicitly {@link palexy.sherlock.v1.PrepareQcVideosResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosResult} message PrepareQcVideosResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PrepareQcVideosResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcVideos != null && message.qcVideos.length)
                            for (var i = 0; i < message.qcVideos.length; ++i)
                                $root.palexy.sherlock.v1.RemoteFile.encode(message.qcVideos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.storageProvider != null && Object.hasOwnProperty.call(message, "storageProvider"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.storageProvider);
                        if (message.googleDriveTaskResultDirId != null && Object.hasOwnProperty.call(message, "googleDriveTaskResultDirId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.googleDriveTaskResultDirId);
                        if (message.googleDriveTaskResultWebViewLink != null && Object.hasOwnProperty.call(message, "googleDriveTaskResultWebViewLink"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.googleDriveTaskResultWebViewLink);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PrepareQcVideosResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.PrepareQcVideosResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {palexy.sherlock.v1.IPrepareQcVideosResult} message PrepareQcVideosResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PrepareQcVideosResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PrepareQcVideosResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.PrepareQcVideosResult} PrepareQcVideosResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PrepareQcVideosResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.PrepareQcVideosResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.qcVideos && message.qcVideos.length))
                                    message.qcVideos = [];
                                message.qcVideos.push($root.palexy.sherlock.v1.RemoteFile.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.storageProvider = reader.int32();
                                break;
                            case 3:
                                message.googleDriveTaskResultDirId = reader.string();
                                break;
                            case 4:
                                message.googleDriveTaskResultWebViewLink = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PrepareQcVideosResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.PrepareQcVideosResult} PrepareQcVideosResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PrepareQcVideosResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PrepareQcVideosResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PrepareQcVideosResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcVideos != null && message.hasOwnProperty("qcVideos")) {
                            if (!Array.isArray(message.qcVideos))
                                return "qcVideos: array expected";
                            for (var i = 0; i < message.qcVideos.length; ++i) {
                                var error = $root.palexy.sherlock.v1.RemoteFile.verify(message.qcVideos[i]);
                                if (error)
                                    return "qcVideos." + error;
                            }
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            switch (message.storageProvider) {
                            default:
                                return "storageProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.googleDriveTaskResultDirId != null && message.hasOwnProperty("googleDriveTaskResultDirId"))
                            if (!$util.isString(message.googleDriveTaskResultDirId))
                                return "googleDriveTaskResultDirId: string expected";
                        if (message.googleDriveTaskResultWebViewLink != null && message.hasOwnProperty("googleDriveTaskResultWebViewLink"))
                            if (!$util.isString(message.googleDriveTaskResultWebViewLink))
                                return "googleDriveTaskResultWebViewLink: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PrepareQcVideosResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.PrepareQcVideosResult} PrepareQcVideosResult
                     */
                    PrepareQcVideosResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.PrepareQcVideosResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.PrepareQcVideosResult();
                        if (object.qcVideos) {
                            if (!Array.isArray(object.qcVideos))
                                throw TypeError(".palexy.sherlock.v1.PrepareQcVideosResult.qcVideos: array expected");
                            message.qcVideos = [];
                            for (var i = 0; i < object.qcVideos.length; ++i) {
                                if (typeof object.qcVideos[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.PrepareQcVideosResult.qcVideos: object expected");
                                message.qcVideos[i] = $root.palexy.sherlock.v1.RemoteFile.fromObject(object.qcVideos[i]);
                            }
                        }
                        switch (object.storageProvider) {
                        case "UNKNOWN_PROVIDER":
                        case 0:
                            message.storageProvider = 0;
                            break;
                        case "GCP":
                        case 1:
                            message.storageProvider = 1;
                            break;
                        case "GOOGLE_DRIVE":
                        case 2:
                            message.storageProvider = 2;
                            break;
                        }
                        if (object.googleDriveTaskResultDirId != null)
                            message.googleDriveTaskResultDirId = String(object.googleDriveTaskResultDirId);
                        if (object.googleDriveTaskResultWebViewLink != null)
                            message.googleDriveTaskResultWebViewLink = String(object.googleDriveTaskResultWebViewLink);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PrepareQcVideosResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @static
                     * @param {palexy.sherlock.v1.PrepareQcVideosResult} message PrepareQcVideosResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PrepareQcVideosResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.qcVideos = [];
                        if (options.defaults) {
                            object.storageProvider = options.enums === String ? "UNKNOWN_PROVIDER" : 0;
                            object.googleDriveTaskResultDirId = "";
                            object.googleDriveTaskResultWebViewLink = "";
                        }
                        if (message.qcVideos && message.qcVideos.length) {
                            object.qcVideos = [];
                            for (var j = 0; j < message.qcVideos.length; ++j)
                                object.qcVideos[j] = $root.palexy.sherlock.v1.RemoteFile.toObject(message.qcVideos[j], options);
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            object.storageProvider = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.StorageProvider[message.storageProvider] : message.storageProvider;
                        if (message.googleDriveTaskResultDirId != null && message.hasOwnProperty("googleDriveTaskResultDirId"))
                            object.googleDriveTaskResultDirId = message.googleDriveTaskResultDirId;
                        if (message.googleDriveTaskResultWebViewLink != null && message.hasOwnProperty("googleDriveTaskResultWebViewLink"))
                            object.googleDriveTaskResultWebViewLink = message.googleDriveTaskResultWebViewLink;
                        return object;
                    };
    
                    /**
                     * Converts this PrepareQcVideosResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.PrepareQcVideosResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PrepareQcVideosResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PrepareQcVideosResult;
                })();
    
                v1.ExportHakuhodoResult = (function() {
    
                    /**
                     * Properties of an ExportHakuhodoResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IExportHakuhodoResult
                     * @property {string|null} [googleDriveTaskResultWebViewLink] ExportHakuhodoResult googleDriveTaskResultWebViewLink
                     */
    
                    /**
                     * Constructs a new ExportHakuhodoResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExportHakuhodoResult.
                     * @implements IExportHakuhodoResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IExportHakuhodoResult=} [properties] Properties to set
                     */
                    function ExportHakuhodoResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportHakuhodoResult googleDriveTaskResultWebViewLink.
                     * @member {string} googleDriveTaskResultWebViewLink
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @instance
                     */
                    ExportHakuhodoResult.prototype.googleDriveTaskResultWebViewLink = "";
    
                    /**
                     * Creates a new ExportHakuhodoResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExportHakuhodoResult} ExportHakuhodoResult instance
                     */
                    ExportHakuhodoResult.create = function create(properties) {
                        return new ExportHakuhodoResult(properties);
                    };
    
                    /**
                     * Encodes the specified ExportHakuhodoResult message. Does not implicitly {@link palexy.sherlock.v1.ExportHakuhodoResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoResult} message ExportHakuhodoResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportHakuhodoResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.googleDriveTaskResultWebViewLink != null && Object.hasOwnProperty.call(message, "googleDriveTaskResultWebViewLink"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.googleDriveTaskResultWebViewLink);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportHakuhodoResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExportHakuhodoResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportHakuhodoResult} message ExportHakuhodoResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportHakuhodoResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportHakuhodoResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExportHakuhodoResult} ExportHakuhodoResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportHakuhodoResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExportHakuhodoResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.googleDriveTaskResultWebViewLink = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportHakuhodoResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExportHakuhodoResult} ExportHakuhodoResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportHakuhodoResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportHakuhodoResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportHakuhodoResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.googleDriveTaskResultWebViewLink != null && message.hasOwnProperty("googleDriveTaskResultWebViewLink"))
                            if (!$util.isString(message.googleDriveTaskResultWebViewLink))
                                return "googleDriveTaskResultWebViewLink: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportHakuhodoResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExportHakuhodoResult} ExportHakuhodoResult
                     */
                    ExportHakuhodoResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExportHakuhodoResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExportHakuhodoResult();
                        if (object.googleDriveTaskResultWebViewLink != null)
                            message.googleDriveTaskResultWebViewLink = String(object.googleDriveTaskResultWebViewLink);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportHakuhodoResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @static
                     * @param {palexy.sherlock.v1.ExportHakuhodoResult} message ExportHakuhodoResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportHakuhodoResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.googleDriveTaskResultWebViewLink = "";
                        if (message.googleDriveTaskResultWebViewLink != null && message.hasOwnProperty("googleDriveTaskResultWebViewLink"))
                            object.googleDriveTaskResultWebViewLink = message.googleDriveTaskResultWebViewLink;
                        return object;
                    };
    
                    /**
                     * Converts this ExportHakuhodoResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExportHakuhodoResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportHakuhodoResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportHakuhodoResult;
                })();
    
                v1.ExportOsoolEventsResult = (function() {
    
                    /**
                     * Properties of an ExportOsoolEventsResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IExportOsoolEventsResult
                     * @property {string|null} [output] ExportOsoolEventsResult output
                     */
    
                    /**
                     * Constructs a new ExportOsoolEventsResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExportOsoolEventsResult.
                     * @implements IExportOsoolEventsResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IExportOsoolEventsResult=} [properties] Properties to set
                     */
                    function ExportOsoolEventsResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportOsoolEventsResult output.
                     * @member {string} output
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @instance
                     */
                    ExportOsoolEventsResult.prototype.output = "";
    
                    /**
                     * Creates a new ExportOsoolEventsResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsResult} ExportOsoolEventsResult instance
                     */
                    ExportOsoolEventsResult.create = function create(properties) {
                        return new ExportOsoolEventsResult(properties);
                    };
    
                    /**
                     * Encodes the specified ExportOsoolEventsResult message. Does not implicitly {@link palexy.sherlock.v1.ExportOsoolEventsResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsResult} message ExportOsoolEventsResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportOsoolEventsResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.output != null && Object.hasOwnProperty.call(message, "output"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.output);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportOsoolEventsResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExportOsoolEventsResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {palexy.sherlock.v1.IExportOsoolEventsResult} message ExportOsoolEventsResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportOsoolEventsResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportOsoolEventsResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsResult} ExportOsoolEventsResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportOsoolEventsResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExportOsoolEventsResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.output = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportOsoolEventsResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsResult} ExportOsoolEventsResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportOsoolEventsResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportOsoolEventsResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportOsoolEventsResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.output != null && message.hasOwnProperty("output"))
                            if (!$util.isString(message.output))
                                return "output: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportOsoolEventsResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExportOsoolEventsResult} ExportOsoolEventsResult
                     */
                    ExportOsoolEventsResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExportOsoolEventsResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExportOsoolEventsResult();
                        if (object.output != null)
                            message.output = String(object.output);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportOsoolEventsResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @static
                     * @param {palexy.sherlock.v1.ExportOsoolEventsResult} message ExportOsoolEventsResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportOsoolEventsResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.output = "";
                        if (message.output != null && message.hasOwnProperty("output"))
                            object.output = message.output;
                        return object;
                    };
    
                    /**
                     * Converts this ExportOsoolEventsResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExportOsoolEventsResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportOsoolEventsResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportOsoolEventsResult;
                })();
    
                v1.FineTuneHakuhodoStoreResult = (function() {
    
                    /**
                     * Properties of a FineTuneHakuhodoStoreResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IFineTuneHakuhodoStoreResult
                     * @property {Array.<string>|null} [tunedMessages] FineTuneHakuhodoStoreResult tunedMessages
                     */
    
                    /**
                     * Constructs a new FineTuneHakuhodoStoreResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FineTuneHakuhodoStoreResult.
                     * @implements IFineTuneHakuhodoStoreResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult=} [properties] Properties to set
                     */
                    function FineTuneHakuhodoStoreResult(properties) {
                        this.tunedMessages = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FineTuneHakuhodoStoreResult tunedMessages.
                     * @member {Array.<string>} tunedMessages
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @instance
                     */
                    FineTuneHakuhodoStoreResult.prototype.tunedMessages = $util.emptyArray;
    
                    /**
                     * Creates a new FineTuneHakuhodoStoreResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreResult} FineTuneHakuhodoStoreResult instance
                     */
                    FineTuneHakuhodoStoreResult.create = function create(properties) {
                        return new FineTuneHakuhodoStoreResult(properties);
                    };
    
                    /**
                     * Encodes the specified FineTuneHakuhodoStoreResult message. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult} message FineTuneHakuhodoStoreResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FineTuneHakuhodoStoreResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tunedMessages != null && message.tunedMessages.length)
                            for (var i = 0; i < message.tunedMessages.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.tunedMessages[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FineTuneHakuhodoStoreResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FineTuneHakuhodoStoreResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {palexy.sherlock.v1.IFineTuneHakuhodoStoreResult} message FineTuneHakuhodoStoreResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FineTuneHakuhodoStoreResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FineTuneHakuhodoStoreResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreResult} FineTuneHakuhodoStoreResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FineTuneHakuhodoStoreResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tunedMessages && message.tunedMessages.length))
                                    message.tunedMessages = [];
                                message.tunedMessages.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FineTuneHakuhodoStoreResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreResult} FineTuneHakuhodoStoreResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FineTuneHakuhodoStoreResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FineTuneHakuhodoStoreResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FineTuneHakuhodoStoreResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tunedMessages != null && message.hasOwnProperty("tunedMessages")) {
                            if (!Array.isArray(message.tunedMessages))
                                return "tunedMessages: array expected";
                            for (var i = 0; i < message.tunedMessages.length; ++i)
                                if (!$util.isString(message.tunedMessages[i]))
                                    return "tunedMessages: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FineTuneHakuhodoStoreResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FineTuneHakuhodoStoreResult} FineTuneHakuhodoStoreResult
                     */
                    FineTuneHakuhodoStoreResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FineTuneHakuhodoStoreResult();
                        if (object.tunedMessages) {
                            if (!Array.isArray(object.tunedMessages))
                                throw TypeError(".palexy.sherlock.v1.FineTuneHakuhodoStoreResult.tunedMessages: array expected");
                            message.tunedMessages = [];
                            for (var i = 0; i < object.tunedMessages.length; ++i)
                                message.tunedMessages[i] = String(object.tunedMessages[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FineTuneHakuhodoStoreResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @static
                     * @param {palexy.sherlock.v1.FineTuneHakuhodoStoreResult} message FineTuneHakuhodoStoreResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FineTuneHakuhodoStoreResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tunedMessages = [];
                        if (message.tunedMessages && message.tunedMessages.length) {
                            object.tunedMessages = [];
                            for (var j = 0; j < message.tunedMessages.length; ++j)
                                object.tunedMessages[j] = message.tunedMessages[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FineTuneHakuhodoStoreResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FineTuneHakuhodoStoreResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FineTuneHakuhodoStoreResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FineTuneHakuhodoStoreResult;
                })();
    
                v1.GoogleCloudStorageFile = (function() {
    
                    /**
                     * Properties of a GoogleCloudStorageFile.
                     * @memberof palexy.sherlock.v1
                     * @interface IGoogleCloudStorageFile
                     * @property {string|null} [bucket] GoogleCloudStorageFile bucket
                     * @property {string|null} [object] GoogleCloudStorageFile object
                     * @property {string|null} [resourceUrl] GoogleCloudStorageFile resourceUrl
                     * @property {string|null} [downloadableUrl] GoogleCloudStorageFile downloadableUrl
                     */
    
                    /**
                     * Constructs a new GoogleCloudStorageFile.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GoogleCloudStorageFile.
                     * @implements IGoogleCloudStorageFile
                     * @constructor
                     * @param {palexy.sherlock.v1.IGoogleCloudStorageFile=} [properties] Properties to set
                     */
                    function GoogleCloudStorageFile(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GoogleCloudStorageFile bucket.
                     * @member {string} bucket
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @instance
                     */
                    GoogleCloudStorageFile.prototype.bucket = "";
    
                    /**
                     * GoogleCloudStorageFile object.
                     * @member {string} object
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @instance
                     */
                    GoogleCloudStorageFile.prototype.object = "";
    
                    /**
                     * GoogleCloudStorageFile resourceUrl.
                     * @member {string} resourceUrl
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @instance
                     */
                    GoogleCloudStorageFile.prototype.resourceUrl = "";
    
                    /**
                     * GoogleCloudStorageFile downloadableUrl.
                     * @member {string} downloadableUrl
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @instance
                     */
                    GoogleCloudStorageFile.prototype.downloadableUrl = "";
    
                    /**
                     * Creates a new GoogleCloudStorageFile instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleCloudStorageFile=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GoogleCloudStorageFile} GoogleCloudStorageFile instance
                     */
                    GoogleCloudStorageFile.create = function create(properties) {
                        return new GoogleCloudStorageFile(properties);
                    };
    
                    /**
                     * Encodes the specified GoogleCloudStorageFile message. Does not implicitly {@link palexy.sherlock.v1.GoogleCloudStorageFile.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleCloudStorageFile} message GoogleCloudStorageFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudStorageFile.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bucket);
                        if (message.object != null && Object.hasOwnProperty.call(message, "object"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.object);
                        if (message.resourceUrl != null && Object.hasOwnProperty.call(message, "resourceUrl"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.resourceUrl);
                        if (message.downloadableUrl != null && Object.hasOwnProperty.call(message, "downloadableUrl"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.downloadableUrl);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GoogleCloudStorageFile message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GoogleCloudStorageFile.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleCloudStorageFile} message GoogleCloudStorageFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleCloudStorageFile.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GoogleCloudStorageFile message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GoogleCloudStorageFile} GoogleCloudStorageFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudStorageFile.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GoogleCloudStorageFile();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.bucket = reader.string();
                                break;
                            case 2:
                                message.object = reader.string();
                                break;
                            case 3:
                                message.resourceUrl = reader.string();
                                break;
                            case 4:
                                message.downloadableUrl = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GoogleCloudStorageFile message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GoogleCloudStorageFile} GoogleCloudStorageFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleCloudStorageFile.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GoogleCloudStorageFile message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GoogleCloudStorageFile.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            if (!$util.isString(message.bucket))
                                return "bucket: string expected";
                        if (message.object != null && message.hasOwnProperty("object"))
                            if (!$util.isString(message.object))
                                return "object: string expected";
                        if (message.resourceUrl != null && message.hasOwnProperty("resourceUrl"))
                            if (!$util.isString(message.resourceUrl))
                                return "resourceUrl: string expected";
                        if (message.downloadableUrl != null && message.hasOwnProperty("downloadableUrl"))
                            if (!$util.isString(message.downloadableUrl))
                                return "downloadableUrl: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GoogleCloudStorageFile message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GoogleCloudStorageFile} GoogleCloudStorageFile
                     */
                    GoogleCloudStorageFile.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GoogleCloudStorageFile)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GoogleCloudStorageFile();
                        if (object.bucket != null)
                            message.bucket = String(object.bucket);
                        if (object.object != null)
                            message.object = String(object.object);
                        if (object.resourceUrl != null)
                            message.resourceUrl = String(object.resourceUrl);
                        if (object.downloadableUrl != null)
                            message.downloadableUrl = String(object.downloadableUrl);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GoogleCloudStorageFile message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @static
                     * @param {palexy.sherlock.v1.GoogleCloudStorageFile} message GoogleCloudStorageFile
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GoogleCloudStorageFile.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.bucket = "";
                            object.object = "";
                            object.resourceUrl = "";
                            object.downloadableUrl = "";
                        }
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            object.bucket = message.bucket;
                        if (message.object != null && message.hasOwnProperty("object"))
                            object.object = message.object;
                        if (message.resourceUrl != null && message.hasOwnProperty("resourceUrl"))
                            object.resourceUrl = message.resourceUrl;
                        if (message.downloadableUrl != null && message.hasOwnProperty("downloadableUrl"))
                            object.downloadableUrl = message.downloadableUrl;
                        return object;
                    };
    
                    /**
                     * Converts this GoogleCloudStorageFile to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GoogleCloudStorageFile
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GoogleCloudStorageFile.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GoogleCloudStorageFile;
                })();
    
                v1.GoogleDriveFile = (function() {
    
                    /**
                     * Properties of a GoogleDriveFile.
                     * @memberof palexy.sherlock.v1
                     * @interface IGoogleDriveFile
                     * @property {string|null} [owner] GoogleDriveFile owner
                     * @property {string|null} [fileId] GoogleDriveFile fileId
                     * @property {string|null} [resourceUrl] GoogleDriveFile resourceUrl
                     * @property {string|null} [downloadableUrl] GoogleDriveFile downloadableUrl
                     */
    
                    /**
                     * Constructs a new GoogleDriveFile.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GoogleDriveFile.
                     * @implements IGoogleDriveFile
                     * @constructor
                     * @param {palexy.sherlock.v1.IGoogleDriveFile=} [properties] Properties to set
                     */
                    function GoogleDriveFile(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GoogleDriveFile owner.
                     * @member {string} owner
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @instance
                     */
                    GoogleDriveFile.prototype.owner = "";
    
                    /**
                     * GoogleDriveFile fileId.
                     * @member {string} fileId
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @instance
                     */
                    GoogleDriveFile.prototype.fileId = "";
    
                    /**
                     * GoogleDriveFile resourceUrl.
                     * @member {string} resourceUrl
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @instance
                     */
                    GoogleDriveFile.prototype.resourceUrl = "";
    
                    /**
                     * GoogleDriveFile downloadableUrl.
                     * @member {string} downloadableUrl
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @instance
                     */
                    GoogleDriveFile.prototype.downloadableUrl = "";
    
                    /**
                     * Creates a new GoogleDriveFile instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleDriveFile=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GoogleDriveFile} GoogleDriveFile instance
                     */
                    GoogleDriveFile.create = function create(properties) {
                        return new GoogleDriveFile(properties);
                    };
    
                    /**
                     * Encodes the specified GoogleDriveFile message. Does not implicitly {@link palexy.sherlock.v1.GoogleDriveFile.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleDriveFile} message GoogleDriveFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleDriveFile.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.owner != null && Object.hasOwnProperty.call(message, "owner"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.owner);
                        if (message.fileId != null && Object.hasOwnProperty.call(message, "fileId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileId);
                        if (message.resourceUrl != null && Object.hasOwnProperty.call(message, "resourceUrl"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.resourceUrl);
                        if (message.downloadableUrl != null && Object.hasOwnProperty.call(message, "downloadableUrl"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.downloadableUrl);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GoogleDriveFile message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GoogleDriveFile.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {palexy.sherlock.v1.IGoogleDriveFile} message GoogleDriveFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GoogleDriveFile.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GoogleDriveFile message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GoogleDriveFile} GoogleDriveFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleDriveFile.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GoogleDriveFile();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.owner = reader.string();
                                break;
                            case 2:
                                message.fileId = reader.string();
                                break;
                            case 3:
                                message.resourceUrl = reader.string();
                                break;
                            case 4:
                                message.downloadableUrl = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GoogleDriveFile message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GoogleDriveFile} GoogleDriveFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GoogleDriveFile.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GoogleDriveFile message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GoogleDriveFile.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.owner != null && message.hasOwnProperty("owner"))
                            if (!$util.isString(message.owner))
                                return "owner: string expected";
                        if (message.fileId != null && message.hasOwnProperty("fileId"))
                            if (!$util.isString(message.fileId))
                                return "fileId: string expected";
                        if (message.resourceUrl != null && message.hasOwnProperty("resourceUrl"))
                            if (!$util.isString(message.resourceUrl))
                                return "resourceUrl: string expected";
                        if (message.downloadableUrl != null && message.hasOwnProperty("downloadableUrl"))
                            if (!$util.isString(message.downloadableUrl))
                                return "downloadableUrl: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GoogleDriveFile message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GoogleDriveFile} GoogleDriveFile
                     */
                    GoogleDriveFile.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GoogleDriveFile)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GoogleDriveFile();
                        if (object.owner != null)
                            message.owner = String(object.owner);
                        if (object.fileId != null)
                            message.fileId = String(object.fileId);
                        if (object.resourceUrl != null)
                            message.resourceUrl = String(object.resourceUrl);
                        if (object.downloadableUrl != null)
                            message.downloadableUrl = String(object.downloadableUrl);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GoogleDriveFile message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @static
                     * @param {palexy.sherlock.v1.GoogleDriveFile} message GoogleDriveFile
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GoogleDriveFile.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.owner = "";
                            object.fileId = "";
                            object.resourceUrl = "";
                            object.downloadableUrl = "";
                        }
                        if (message.owner != null && message.hasOwnProperty("owner"))
                            object.owner = message.owner;
                        if (message.fileId != null && message.hasOwnProperty("fileId"))
                            object.fileId = message.fileId;
                        if (message.resourceUrl != null && message.hasOwnProperty("resourceUrl"))
                            object.resourceUrl = message.resourceUrl;
                        if (message.downloadableUrl != null && message.hasOwnProperty("downloadableUrl"))
                            object.downloadableUrl = message.downloadableUrl;
                        return object;
                    };
    
                    /**
                     * Converts this GoogleDriveFile to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GoogleDriveFile
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GoogleDriveFile.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GoogleDriveFile;
                })();
    
                v1.RemoteFile = (function() {
    
                    /**
                     * Properties of a RemoteFile.
                     * @memberof palexy.sherlock.v1
                     * @interface IRemoteFile
                     * @property {string|null} [filename] RemoteFile filename
                     * @property {palexy.sherlock.v1.IGoogleCloudStorageFile|null} [googleCloudStorageFile] RemoteFile googleCloudStorageFile
                     * @property {palexy.sherlock.v1.IGoogleDriveFile|null} [googleDriveFile] RemoteFile googleDriveFile
                     */
    
                    /**
                     * Constructs a new RemoteFile.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RemoteFile.
                     * @implements IRemoteFile
                     * @constructor
                     * @param {palexy.sherlock.v1.IRemoteFile=} [properties] Properties to set
                     */
                    function RemoteFile(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RemoteFile filename.
                     * @member {string} filename
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @instance
                     */
                    RemoteFile.prototype.filename = "";
    
                    /**
                     * RemoteFile googleCloudStorageFile.
                     * @member {palexy.sherlock.v1.IGoogleCloudStorageFile|null|undefined} googleCloudStorageFile
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @instance
                     */
                    RemoteFile.prototype.googleCloudStorageFile = null;
    
                    /**
                     * RemoteFile googleDriveFile.
                     * @member {palexy.sherlock.v1.IGoogleDriveFile|null|undefined} googleDriveFile
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @instance
                     */
                    RemoteFile.prototype.googleDriveFile = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * RemoteFile resource.
                     * @member {"googleCloudStorageFile"|"googleDriveFile"|undefined} resource
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @instance
                     */
                    Object.defineProperty(RemoteFile.prototype, "resource", {
                        get: $util.oneOfGetter($oneOfFields = ["googleCloudStorageFile", "googleDriveFile"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new RemoteFile instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {palexy.sherlock.v1.IRemoteFile=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RemoteFile} RemoteFile instance
                     */
                    RemoteFile.create = function create(properties) {
                        return new RemoteFile(properties);
                    };
    
                    /**
                     * Encodes the specified RemoteFile message. Does not implicitly {@link palexy.sherlock.v1.RemoteFile.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {palexy.sherlock.v1.IRemoteFile} message RemoteFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoteFile.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filename != null && Object.hasOwnProperty.call(message, "filename"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.filename);
                        if (message.googleCloudStorageFile != null && Object.hasOwnProperty.call(message, "googleCloudStorageFile"))
                            $root.palexy.sherlock.v1.GoogleCloudStorageFile.encode(message.googleCloudStorageFile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.googleDriveFile != null && Object.hasOwnProperty.call(message, "googleDriveFile"))
                            $root.palexy.sherlock.v1.GoogleDriveFile.encode(message.googleDriveFile, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoteFile message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RemoteFile.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {palexy.sherlock.v1.IRemoteFile} message RemoteFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoteFile.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoteFile message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RemoteFile} RemoteFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoteFile.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RemoteFile();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filename = reader.string();
                                break;
                            case 2:
                                message.googleCloudStorageFile = $root.palexy.sherlock.v1.GoogleCloudStorageFile.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.googleDriveFile = $root.palexy.sherlock.v1.GoogleDriveFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoteFile message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RemoteFile} RemoteFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoteFile.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoteFile message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoteFile.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.filename != null && message.hasOwnProperty("filename"))
                            if (!$util.isString(message.filename))
                                return "filename: string expected";
                        if (message.googleCloudStorageFile != null && message.hasOwnProperty("googleCloudStorageFile")) {
                            properties.resource = 1;
                            {
                                var error = $root.palexy.sherlock.v1.GoogleCloudStorageFile.verify(message.googleCloudStorageFile);
                                if (error)
                                    return "googleCloudStorageFile." + error;
                            }
                        }
                        if (message.googleDriveFile != null && message.hasOwnProperty("googleDriveFile")) {
                            if (properties.resource === 1)
                                return "resource: multiple values";
                            properties.resource = 1;
                            {
                                var error = $root.palexy.sherlock.v1.GoogleDriveFile.verify(message.googleDriveFile);
                                if (error)
                                    return "googleDriveFile." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RemoteFile message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RemoteFile} RemoteFile
                     */
                    RemoteFile.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RemoteFile)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RemoteFile();
                        if (object.filename != null)
                            message.filename = String(object.filename);
                        if (object.googleCloudStorageFile != null) {
                            if (typeof object.googleCloudStorageFile !== "object")
                                throw TypeError(".palexy.sherlock.v1.RemoteFile.googleCloudStorageFile: object expected");
                            message.googleCloudStorageFile = $root.palexy.sherlock.v1.GoogleCloudStorageFile.fromObject(object.googleCloudStorageFile);
                        }
                        if (object.googleDriveFile != null) {
                            if (typeof object.googleDriveFile !== "object")
                                throw TypeError(".palexy.sherlock.v1.RemoteFile.googleDriveFile: object expected");
                            message.googleDriveFile = $root.palexy.sherlock.v1.GoogleDriveFile.fromObject(object.googleDriveFile);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RemoteFile message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @static
                     * @param {palexy.sherlock.v1.RemoteFile} message RemoteFile
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoteFile.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.filename = "";
                        if (message.filename != null && message.hasOwnProperty("filename"))
                            object.filename = message.filename;
                        if (message.googleCloudStorageFile != null && message.hasOwnProperty("googleCloudStorageFile")) {
                            object.googleCloudStorageFile = $root.palexy.sherlock.v1.GoogleCloudStorageFile.toObject(message.googleCloudStorageFile, options);
                            if (options.oneofs)
                                object.resource = "googleCloudStorageFile";
                        }
                        if (message.googleDriveFile != null && message.hasOwnProperty("googleDriveFile")) {
                            object.googleDriveFile = $root.palexy.sherlock.v1.GoogleDriveFile.toObject(message.googleDriveFile, options);
                            if (options.oneofs)
                                object.resource = "googleDriveFile";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RemoteFile to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RemoteFile
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoteFile.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoteFile;
                })();
    
                v1.GeneralPersonInfoResult = (function() {
    
                    /**
                     * Properties of a GeneralPersonInfoResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IGeneralPersonInfoResult
                     * @property {Array.<palexy.streaming.v1.IRawICASummaryRecord>|null} [icaSummaryRecords] GeneralPersonInfoResult icaSummaryRecords
                     */
    
                    /**
                     * Constructs a new GeneralPersonInfoResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GeneralPersonInfoResult.
                     * @implements IGeneralPersonInfoResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IGeneralPersonInfoResult=} [properties] Properties to set
                     */
                    function GeneralPersonInfoResult(properties) {
                        this.icaSummaryRecords = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GeneralPersonInfoResult icaSummaryRecords.
                     * @member {Array.<palexy.streaming.v1.IRawICASummaryRecord>} icaSummaryRecords
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @instance
                     */
                    GeneralPersonInfoResult.prototype.icaSummaryRecords = $util.emptyArray;
    
                    /**
                     * Creates a new GeneralPersonInfoResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {palexy.sherlock.v1.IGeneralPersonInfoResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GeneralPersonInfoResult} GeneralPersonInfoResult instance
                     */
                    GeneralPersonInfoResult.create = function create(properties) {
                        return new GeneralPersonInfoResult(properties);
                    };
    
                    /**
                     * Encodes the specified GeneralPersonInfoResult message. Does not implicitly {@link palexy.sherlock.v1.GeneralPersonInfoResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {palexy.sherlock.v1.IGeneralPersonInfoResult} message GeneralPersonInfoResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneralPersonInfoResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.icaSummaryRecords != null && message.icaSummaryRecords.length)
                            for (var i = 0; i < message.icaSummaryRecords.length; ++i)
                                $root.palexy.streaming.v1.RawICASummaryRecord.encode(message.icaSummaryRecords[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GeneralPersonInfoResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GeneralPersonInfoResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {palexy.sherlock.v1.IGeneralPersonInfoResult} message GeneralPersonInfoResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneralPersonInfoResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GeneralPersonInfoResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GeneralPersonInfoResult} GeneralPersonInfoResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneralPersonInfoResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GeneralPersonInfoResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.icaSummaryRecords && message.icaSummaryRecords.length))
                                    message.icaSummaryRecords = [];
                                message.icaSummaryRecords.push($root.palexy.streaming.v1.RawICASummaryRecord.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GeneralPersonInfoResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GeneralPersonInfoResult} GeneralPersonInfoResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneralPersonInfoResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GeneralPersonInfoResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GeneralPersonInfoResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.icaSummaryRecords != null && message.hasOwnProperty("icaSummaryRecords")) {
                            if (!Array.isArray(message.icaSummaryRecords))
                                return "icaSummaryRecords: array expected";
                            for (var i = 0; i < message.icaSummaryRecords.length; ++i) {
                                var error = $root.palexy.streaming.v1.RawICASummaryRecord.verify(message.icaSummaryRecords[i]);
                                if (error)
                                    return "icaSummaryRecords." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GeneralPersonInfoResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GeneralPersonInfoResult} GeneralPersonInfoResult
                     */
                    GeneralPersonInfoResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GeneralPersonInfoResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GeneralPersonInfoResult();
                        if (object.icaSummaryRecords) {
                            if (!Array.isArray(object.icaSummaryRecords))
                                throw TypeError(".palexy.sherlock.v1.GeneralPersonInfoResult.icaSummaryRecords: array expected");
                            message.icaSummaryRecords = [];
                            for (var i = 0; i < object.icaSummaryRecords.length; ++i) {
                                if (typeof object.icaSummaryRecords[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.GeneralPersonInfoResult.icaSummaryRecords: object expected");
                                message.icaSummaryRecords[i] = $root.palexy.streaming.v1.RawICASummaryRecord.fromObject(object.icaSummaryRecords[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GeneralPersonInfoResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @static
                     * @param {palexy.sherlock.v1.GeneralPersonInfoResult} message GeneralPersonInfoResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GeneralPersonInfoResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.icaSummaryRecords = [];
                        if (message.icaSummaryRecords && message.icaSummaryRecords.length) {
                            object.icaSummaryRecords = [];
                            for (var j = 0; j < message.icaSummaryRecords.length; ++j)
                                object.icaSummaryRecords[j] = $root.palexy.streaming.v1.RawICASummaryRecord.toObject(message.icaSummaryRecords[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GeneralPersonInfoResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GeneralPersonInfoResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GeneralPersonInfoResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GeneralPersonInfoResult;
                })();
    
                v1.PersonFilter = (function() {
    
                    /**
                     * Properties of a PersonFilter.
                     * @memberof palexy.sherlock.v1
                     * @interface IPersonFilter
                     * @property {number|null} [storeId] PersonFilter storeId
                     * @property {string|null} [startDateTime] PersonFilter startDateTime
                     * @property {string|null} [endDateTime] PersonFilter endDateTime
                     */
    
                    /**
                     * Constructs a new PersonFilter.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a PersonFilter.
                     * @implements IPersonFilter
                     * @constructor
                     * @param {palexy.sherlock.v1.IPersonFilter=} [properties] Properties to set
                     */
                    function PersonFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PersonFilter storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @instance
                     */
                    PersonFilter.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PersonFilter startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @instance
                     */
                    PersonFilter.prototype.startDateTime = "";
    
                    /**
                     * PersonFilter endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @instance
                     */
                    PersonFilter.prototype.endDateTime = "";
    
                    /**
                     * Creates a new PersonFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {palexy.sherlock.v1.IPersonFilter=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.PersonFilter} PersonFilter instance
                     */
                    PersonFilter.create = function create(properties) {
                        return new PersonFilter(properties);
                    };
    
                    /**
                     * Encodes the specified PersonFilter message. Does not implicitly {@link palexy.sherlock.v1.PersonFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {palexy.sherlock.v1.IPersonFilter} message PersonFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PersonFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PersonFilter message, length delimited. Does not implicitly {@link palexy.sherlock.v1.PersonFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {palexy.sherlock.v1.IPersonFilter} message PersonFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PersonFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PersonFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.PersonFilter} PersonFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PersonFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.PersonFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateTime = reader.string();
                                break;
                            case 3:
                                message.endDateTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PersonFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.PersonFilter} PersonFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PersonFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PersonFilter message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PersonFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PersonFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.PersonFilter} PersonFilter
                     */
                    PersonFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.PersonFilter)
                            return object;
                        var message = new $root.palexy.sherlock.v1.PersonFilter();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PersonFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @static
                     * @param {palexy.sherlock.v1.PersonFilter} message PersonFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PersonFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        return object;
                    };
    
                    /**
                     * Converts this PersonFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.PersonFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PersonFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PersonFilter;
                })();
    
                v1.ExperimentFilter = (function() {
    
                    /**
                     * Properties of an ExperimentFilter.
                     * @memberof palexy.sherlock.v1
                     * @interface IExperimentFilter
                     * @property {number|null} [storeId] ExperimentFilter storeId
                     * @property {string|null} [startDateTime] ExperimentFilter startDateTime
                     * @property {string|null} [endDateTime] ExperimentFilter endDateTime
                     * @property {string|null} [experimentName] ExperimentFilter experimentName
                     */
    
                    /**
                     * Constructs a new ExperimentFilter.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExperimentFilter.
                     * @implements IExperimentFilter
                     * @constructor
                     * @param {palexy.sherlock.v1.IExperimentFilter=} [properties] Properties to set
                     */
                    function ExperimentFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExperimentFilter storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @instance
                     */
                    ExperimentFilter.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExperimentFilter startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @instance
                     */
                    ExperimentFilter.prototype.startDateTime = "";
    
                    /**
                     * ExperimentFilter endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @instance
                     */
                    ExperimentFilter.prototype.endDateTime = "";
    
                    /**
                     * ExperimentFilter experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @instance
                     */
                    ExperimentFilter.prototype.experimentName = "";
    
                    /**
                     * Creates a new ExperimentFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentFilter=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExperimentFilter} ExperimentFilter instance
                     */
                    ExperimentFilter.create = function create(properties) {
                        return new ExperimentFilter(properties);
                    };
    
                    /**
                     * Encodes the specified ExperimentFilter message. Does not implicitly {@link palexy.sherlock.v1.ExperimentFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentFilter} message ExperimentFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExperimentFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateTime);
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.experimentName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExperimentFilter message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExperimentFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentFilter} message ExperimentFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExperimentFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExperimentFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExperimentFilter} ExperimentFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExperimentFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExperimentFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateTime = reader.string();
                                break;
                            case 3:
                                message.endDateTime = reader.string();
                                break;
                            case 5:
                                message.experimentName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExperimentFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExperimentFilter} ExperimentFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExperimentFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExperimentFilter message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExperimentFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExperimentFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExperimentFilter} ExperimentFilter
                     */
                    ExperimentFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExperimentFilter)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExperimentFilter();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExperimentFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @static
                     * @param {palexy.sherlock.v1.ExperimentFilter} message ExperimentFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExperimentFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                            object.experimentName = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        return object;
                    };
    
                    /**
                     * Converts this ExperimentFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExperimentFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExperimentFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExperimentFilter;
                })();
    
                v1.ExtractBBResult = (function() {
    
                    /**
                     * Properties of an ExtractBBResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IExtractBBResult
                     * @property {Array.<palexy.sherlock.v1.IDetailResult>|null} [detailResults] ExtractBBResult detailResults
                     * @property {string|null} [allBbDataLink] ExtractBBResult allBbDataLink
                     * @property {string|null} [humanLabelLink] ExtractBBResult humanLabelLink
                     * @property {string|null} [reconstructedMergeFileLink] ExtractBBResult reconstructedMergeFileLink
                     * @property {string|null} [trackingDataLink] ExtractBBResult trackingDataLink
                     */
    
                    /**
                     * Constructs a new ExtractBBResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExtractBBResult.
                     * @implements IExtractBBResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IExtractBBResult=} [properties] Properties to set
                     */
                    function ExtractBBResult(properties) {
                        this.detailResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExtractBBResult detailResults.
                     * @member {Array.<palexy.sherlock.v1.IDetailResult>} detailResults
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     */
                    ExtractBBResult.prototype.detailResults = $util.emptyArray;
    
                    /**
                     * ExtractBBResult allBbDataLink.
                     * @member {string} allBbDataLink
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     */
                    ExtractBBResult.prototype.allBbDataLink = "";
    
                    /**
                     * ExtractBBResult humanLabelLink.
                     * @member {string} humanLabelLink
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     */
                    ExtractBBResult.prototype.humanLabelLink = "";
    
                    /**
                     * ExtractBBResult reconstructedMergeFileLink.
                     * @member {string} reconstructedMergeFileLink
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     */
                    ExtractBBResult.prototype.reconstructedMergeFileLink = "";
    
                    /**
                     * ExtractBBResult trackingDataLink.
                     * @member {string} trackingDataLink
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     */
                    ExtractBBResult.prototype.trackingDataLink = "";
    
                    /**
                     * Creates a new ExtractBBResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {palexy.sherlock.v1.IExtractBBResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExtractBBResult} ExtractBBResult instance
                     */
                    ExtractBBResult.create = function create(properties) {
                        return new ExtractBBResult(properties);
                    };
    
                    /**
                     * Encodes the specified ExtractBBResult message. Does not implicitly {@link palexy.sherlock.v1.ExtractBBResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {palexy.sherlock.v1.IExtractBBResult} message ExtractBBResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtractBBResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.detailResults != null && message.detailResults.length)
                            for (var i = 0; i < message.detailResults.length; ++i)
                                $root.palexy.sherlock.v1.DetailResult.encode(message.detailResults[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.allBbDataLink != null && Object.hasOwnProperty.call(message, "allBbDataLink"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.allBbDataLink);
                        if (message.humanLabelLink != null && Object.hasOwnProperty.call(message, "humanLabelLink"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.humanLabelLink);
                        if (message.reconstructedMergeFileLink != null && Object.hasOwnProperty.call(message, "reconstructedMergeFileLink"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.reconstructedMergeFileLink);
                        if (message.trackingDataLink != null && Object.hasOwnProperty.call(message, "trackingDataLink"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.trackingDataLink);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExtractBBResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExtractBBResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {palexy.sherlock.v1.IExtractBBResult} message ExtractBBResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtractBBResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExtractBBResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExtractBBResult} ExtractBBResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtractBBResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExtractBBResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.detailResults && message.detailResults.length))
                                    message.detailResults = [];
                                message.detailResults.push($root.palexy.sherlock.v1.DetailResult.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.allBbDataLink = reader.string();
                                break;
                            case 3:
                                message.humanLabelLink = reader.string();
                                break;
                            case 4:
                                message.reconstructedMergeFileLink = reader.string();
                                break;
                            case 5:
                                message.trackingDataLink = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExtractBBResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExtractBBResult} ExtractBBResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtractBBResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExtractBBResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExtractBBResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.detailResults != null && message.hasOwnProperty("detailResults")) {
                            if (!Array.isArray(message.detailResults))
                                return "detailResults: array expected";
                            for (var i = 0; i < message.detailResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.DetailResult.verify(message.detailResults[i]);
                                if (error)
                                    return "detailResults." + error;
                            }
                        }
                        if (message.allBbDataLink != null && message.hasOwnProperty("allBbDataLink"))
                            if (!$util.isString(message.allBbDataLink))
                                return "allBbDataLink: string expected";
                        if (message.humanLabelLink != null && message.hasOwnProperty("humanLabelLink"))
                            if (!$util.isString(message.humanLabelLink))
                                return "humanLabelLink: string expected";
                        if (message.reconstructedMergeFileLink != null && message.hasOwnProperty("reconstructedMergeFileLink"))
                            if (!$util.isString(message.reconstructedMergeFileLink))
                                return "reconstructedMergeFileLink: string expected";
                        if (message.trackingDataLink != null && message.hasOwnProperty("trackingDataLink"))
                            if (!$util.isString(message.trackingDataLink))
                                return "trackingDataLink: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExtractBBResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExtractBBResult} ExtractBBResult
                     */
                    ExtractBBResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExtractBBResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExtractBBResult();
                        if (object.detailResults) {
                            if (!Array.isArray(object.detailResults))
                                throw TypeError(".palexy.sherlock.v1.ExtractBBResult.detailResults: array expected");
                            message.detailResults = [];
                            for (var i = 0; i < object.detailResults.length; ++i) {
                                if (typeof object.detailResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ExtractBBResult.detailResults: object expected");
                                message.detailResults[i] = $root.palexy.sherlock.v1.DetailResult.fromObject(object.detailResults[i]);
                            }
                        }
                        if (object.allBbDataLink != null)
                            message.allBbDataLink = String(object.allBbDataLink);
                        if (object.humanLabelLink != null)
                            message.humanLabelLink = String(object.humanLabelLink);
                        if (object.reconstructedMergeFileLink != null)
                            message.reconstructedMergeFileLink = String(object.reconstructedMergeFileLink);
                        if (object.trackingDataLink != null)
                            message.trackingDataLink = String(object.trackingDataLink);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExtractBBResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @static
                     * @param {palexy.sherlock.v1.ExtractBBResult} message ExtractBBResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExtractBBResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.detailResults = [];
                        if (options.defaults) {
                            object.allBbDataLink = "";
                            object.humanLabelLink = "";
                            object.reconstructedMergeFileLink = "";
                            object.trackingDataLink = "";
                        }
                        if (message.detailResults && message.detailResults.length) {
                            object.detailResults = [];
                            for (var j = 0; j < message.detailResults.length; ++j)
                                object.detailResults[j] = $root.palexy.sherlock.v1.DetailResult.toObject(message.detailResults[j], options);
                        }
                        if (message.allBbDataLink != null && message.hasOwnProperty("allBbDataLink"))
                            object.allBbDataLink = message.allBbDataLink;
                        if (message.humanLabelLink != null && message.hasOwnProperty("humanLabelLink"))
                            object.humanLabelLink = message.humanLabelLink;
                        if (message.reconstructedMergeFileLink != null && message.hasOwnProperty("reconstructedMergeFileLink"))
                            object.reconstructedMergeFileLink = message.reconstructedMergeFileLink;
                        if (message.trackingDataLink != null && message.hasOwnProperty("trackingDataLink"))
                            object.trackingDataLink = message.trackingDataLink;
                        return object;
                    };
    
                    /**
                     * Converts this ExtractBBResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExtractBBResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExtractBBResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExtractBBResult;
                })();
    
                v1.DetailResult = (function() {
    
                    /**
                     * Properties of a DetailResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IDetailResult
                     * @property {string|null} [personId] DetailResult personId
                     * @property {Array.<palexy.sherlock.v1.IActionSummaryEntry>|null} [actionSummaryEntries] DetailResult actionSummaryEntries
                     * @property {string|null} [gender] DetailResult gender
                     * @property {number|null} [ageRange] DetailResult ageRange
                     * @property {string|null} [startTime] DetailResult startTime
                     * @property {string|null} [endTime] DetailResult endTime
                     * @property {number|null} [durationInSeconds] DetailResult durationInSeconds
                     * @property {number|null} [totalBb] DetailResult totalBb
                     */
    
                    /**
                     * Constructs a new DetailResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DetailResult.
                     * @implements IDetailResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IDetailResult=} [properties] Properties to set
                     */
                    function DetailResult(properties) {
                        this.actionSummaryEntries = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DetailResult personId.
                     * @member {string} personId
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.personId = "";
    
                    /**
                     * DetailResult actionSummaryEntries.
                     * @member {Array.<palexy.sherlock.v1.IActionSummaryEntry>} actionSummaryEntries
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.actionSummaryEntries = $util.emptyArray;
    
                    /**
                     * DetailResult gender.
                     * @member {string} gender
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.gender = "";
    
                    /**
                     * DetailResult ageRange.
                     * @member {number} ageRange
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.ageRange = 0;
    
                    /**
                     * DetailResult startTime.
                     * @member {string} startTime
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.startTime = "";
    
                    /**
                     * DetailResult endTime.
                     * @member {string} endTime
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.endTime = "";
    
                    /**
                     * DetailResult durationInSeconds.
                     * @member {number} durationInSeconds
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.durationInSeconds = 0;
    
                    /**
                     * DetailResult totalBb.
                     * @member {number} totalBb
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     */
                    DetailResult.prototype.totalBb = 0;
    
                    /**
                     * Creates a new DetailResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {palexy.sherlock.v1.IDetailResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DetailResult} DetailResult instance
                     */
                    DetailResult.create = function create(properties) {
                        return new DetailResult(properties);
                    };
    
                    /**
                     * Encodes the specified DetailResult message. Does not implicitly {@link palexy.sherlock.v1.DetailResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {palexy.sherlock.v1.IDetailResult} message DetailResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetailResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.personId != null && Object.hasOwnProperty.call(message, "personId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.personId);
                        if (message.actionSummaryEntries != null && message.actionSummaryEntries.length)
                            for (var i = 0; i < message.actionSummaryEntries.length; ++i)
                                $root.palexy.sherlock.v1.ActionSummaryEntry.encode(message.actionSummaryEntries[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.gender);
                        if (message.ageRange != null && Object.hasOwnProperty.call(message, "ageRange"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ageRange);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endTime);
                        if (message.durationInSeconds != null && Object.hasOwnProperty.call(message, "durationInSeconds"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.durationInSeconds);
                        if (message.totalBb != null && Object.hasOwnProperty.call(message, "totalBb"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.totalBb);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DetailResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DetailResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {palexy.sherlock.v1.IDetailResult} message DetailResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetailResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DetailResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DetailResult} DetailResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetailResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DetailResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.personId = reader.string();
                                break;
                            case 2:
                                if (!(message.actionSummaryEntries && message.actionSummaryEntries.length))
                                    message.actionSummaryEntries = [];
                                message.actionSummaryEntries.push($root.palexy.sherlock.v1.ActionSummaryEntry.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.gender = reader.string();
                                break;
                            case 4:
                                message.ageRange = reader.int32();
                                break;
                            case 5:
                                message.startTime = reader.string();
                                break;
                            case 6:
                                message.endTime = reader.string();
                                break;
                            case 7:
                                message.durationInSeconds = reader.int32();
                                break;
                            case 8:
                                message.totalBb = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DetailResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DetailResult} DetailResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetailResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DetailResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DetailResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            if (!$util.isString(message.personId))
                                return "personId: string expected";
                        if (message.actionSummaryEntries != null && message.hasOwnProperty("actionSummaryEntries")) {
                            if (!Array.isArray(message.actionSummaryEntries))
                                return "actionSummaryEntries: array expected";
                            for (var i = 0; i < message.actionSummaryEntries.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ActionSummaryEntry.verify(message.actionSummaryEntries[i]);
                                if (error)
                                    return "actionSummaryEntries." + error;
                            }
                        }
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            if (!$util.isString(message.gender))
                                return "gender: string expected";
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            if (!$util.isInteger(message.ageRange))
                                return "ageRange: integer expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                            if (!$util.isInteger(message.durationInSeconds))
                                return "durationInSeconds: integer expected";
                        if (message.totalBb != null && message.hasOwnProperty("totalBb"))
                            if (!$util.isInteger(message.totalBb))
                                return "totalBb: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a DetailResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DetailResult} DetailResult
                     */
                    DetailResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DetailResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DetailResult();
                        if (object.personId != null)
                            message.personId = String(object.personId);
                        if (object.actionSummaryEntries) {
                            if (!Array.isArray(object.actionSummaryEntries))
                                throw TypeError(".palexy.sherlock.v1.DetailResult.actionSummaryEntries: array expected");
                            message.actionSummaryEntries = [];
                            for (var i = 0; i < object.actionSummaryEntries.length; ++i) {
                                if (typeof object.actionSummaryEntries[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.DetailResult.actionSummaryEntries: object expected");
                                message.actionSummaryEntries[i] = $root.palexy.sherlock.v1.ActionSummaryEntry.fromObject(object.actionSummaryEntries[i]);
                            }
                        }
                        if (object.gender != null)
                            message.gender = String(object.gender);
                        if (object.ageRange != null)
                            message.ageRange = object.ageRange | 0;
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.durationInSeconds != null)
                            message.durationInSeconds = object.durationInSeconds | 0;
                        if (object.totalBb != null)
                            message.totalBb = object.totalBb | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DetailResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @static
                     * @param {palexy.sherlock.v1.DetailResult} message DetailResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DetailResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.actionSummaryEntries = [];
                        if (options.defaults) {
                            object.personId = "";
                            object.gender = "";
                            object.ageRange = 0;
                            object.startTime = "";
                            object.endTime = "";
                            object.durationInSeconds = 0;
                            object.totalBb = 0;
                        }
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            object.personId = message.personId;
                        if (message.actionSummaryEntries && message.actionSummaryEntries.length) {
                            object.actionSummaryEntries = [];
                            for (var j = 0; j < message.actionSummaryEntries.length; ++j)
                                object.actionSummaryEntries[j] = $root.palexy.sherlock.v1.ActionSummaryEntry.toObject(message.actionSummaryEntries[j], options);
                        }
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            object.gender = message.gender;
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            object.ageRange = message.ageRange;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                            object.durationInSeconds = message.durationInSeconds;
                        if (message.totalBb != null && message.hasOwnProperty("totalBb"))
                            object.totalBb = message.totalBb;
                        return object;
                    };
    
                    /**
                     * Converts this DetailResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DetailResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DetailResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DetailResult;
                })();
    
                v1.ActionSummaryEntry = (function() {
    
                    /**
                     * Properties of an ActionSummaryEntry.
                     * @memberof palexy.sherlock.v1
                     * @interface IActionSummaryEntry
                     * @property {string|null} [actionType] ActionSummaryEntry actionType
                     * @property {Array.<string>|null} [bbImageLinks] ActionSummaryEntry bbImageLinks
                     */
    
                    /**
                     * Constructs a new ActionSummaryEntry.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ActionSummaryEntry.
                     * @implements IActionSummaryEntry
                     * @constructor
                     * @param {palexy.sherlock.v1.IActionSummaryEntry=} [properties] Properties to set
                     */
                    function ActionSummaryEntry(properties) {
                        this.bbImageLinks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ActionSummaryEntry actionType.
                     * @member {string} actionType
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @instance
                     */
                    ActionSummaryEntry.prototype.actionType = "";
    
                    /**
                     * ActionSummaryEntry bbImageLinks.
                     * @member {Array.<string>} bbImageLinks
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @instance
                     */
                    ActionSummaryEntry.prototype.bbImageLinks = $util.emptyArray;
    
                    /**
                     * Creates a new ActionSummaryEntry instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {palexy.sherlock.v1.IActionSummaryEntry=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ActionSummaryEntry} ActionSummaryEntry instance
                     */
                    ActionSummaryEntry.create = function create(properties) {
                        return new ActionSummaryEntry(properties);
                    };
    
                    /**
                     * Encodes the specified ActionSummaryEntry message. Does not implicitly {@link palexy.sherlock.v1.ActionSummaryEntry.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {palexy.sherlock.v1.IActionSummaryEntry} message ActionSummaryEntry message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ActionSummaryEntry.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.actionType);
                        if (message.bbImageLinks != null && message.bbImageLinks.length)
                            for (var i = 0; i < message.bbImageLinks.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.bbImageLinks[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ActionSummaryEntry message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ActionSummaryEntry.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {palexy.sherlock.v1.IActionSummaryEntry} message ActionSummaryEntry message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ActionSummaryEntry.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ActionSummaryEntry message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ActionSummaryEntry} ActionSummaryEntry
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ActionSummaryEntry.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ActionSummaryEntry();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.actionType = reader.string();
                                break;
                            case 2:
                                if (!(message.bbImageLinks && message.bbImageLinks.length))
                                    message.bbImageLinks = [];
                                message.bbImageLinks.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ActionSummaryEntry message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ActionSummaryEntry} ActionSummaryEntry
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ActionSummaryEntry.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ActionSummaryEntry message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ActionSummaryEntry.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            if (!$util.isString(message.actionType))
                                return "actionType: string expected";
                        if (message.bbImageLinks != null && message.hasOwnProperty("bbImageLinks")) {
                            if (!Array.isArray(message.bbImageLinks))
                                return "bbImageLinks: array expected";
                            for (var i = 0; i < message.bbImageLinks.length; ++i)
                                if (!$util.isString(message.bbImageLinks[i]))
                                    return "bbImageLinks: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ActionSummaryEntry message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ActionSummaryEntry} ActionSummaryEntry
                     */
                    ActionSummaryEntry.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ActionSummaryEntry)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ActionSummaryEntry();
                        if (object.actionType != null)
                            message.actionType = String(object.actionType);
                        if (object.bbImageLinks) {
                            if (!Array.isArray(object.bbImageLinks))
                                throw TypeError(".palexy.sherlock.v1.ActionSummaryEntry.bbImageLinks: array expected");
                            message.bbImageLinks = [];
                            for (var i = 0; i < object.bbImageLinks.length; ++i)
                                message.bbImageLinks[i] = String(object.bbImageLinks[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ActionSummaryEntry message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @static
                     * @param {palexy.sherlock.v1.ActionSummaryEntry} message ActionSummaryEntry
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ActionSummaryEntry.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.bbImageLinks = [];
                        if (options.defaults)
                            object.actionType = "";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = message.actionType;
                        if (message.bbImageLinks && message.bbImageLinks.length) {
                            object.bbImageLinks = [];
                            for (var j = 0; j < message.bbImageLinks.length; ++j)
                                object.bbImageLinks[j] = message.bbImageLinks[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ActionSummaryEntry to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ActionSummaryEntry
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ActionSummaryEntry.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ActionSummaryEntry;
                })();
    
                v1.AddtionalActionInfo = (function() {
    
                    /**
                     * Properties of an AddtionalActionInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IAddtionalActionInfo
                     * @property {string|null} [cameraId] AddtionalActionInfo cameraId
                     * @property {number|null} [coordinateX] AddtionalActionInfo coordinateX
                     * @property {number|null} [coordinateY] AddtionalActionInfo coordinateY
                     * @property {string|null} [recordingDateTime] AddtionalActionInfo recordingDateTime
                     */
    
                    /**
                     * Constructs a new AddtionalActionInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AddtionalActionInfo.
                     * @implements IAddtionalActionInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IAddtionalActionInfo=} [properties] Properties to set
                     */
                    function AddtionalActionInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AddtionalActionInfo cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @instance
                     */
                    AddtionalActionInfo.prototype.cameraId = "";
    
                    /**
                     * AddtionalActionInfo coordinateX.
                     * @member {number} coordinateX
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @instance
                     */
                    AddtionalActionInfo.prototype.coordinateX = 0;
    
                    /**
                     * AddtionalActionInfo coordinateY.
                     * @member {number} coordinateY
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @instance
                     */
                    AddtionalActionInfo.prototype.coordinateY = 0;
    
                    /**
                     * AddtionalActionInfo recordingDateTime.
                     * @member {string} recordingDateTime
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @instance
                     */
                    AddtionalActionInfo.prototype.recordingDateTime = "";
    
                    /**
                     * Creates a new AddtionalActionInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {palexy.sherlock.v1.IAddtionalActionInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AddtionalActionInfo} AddtionalActionInfo instance
                     */
                    AddtionalActionInfo.create = function create(properties) {
                        return new AddtionalActionInfo(properties);
                    };
    
                    /**
                     * Encodes the specified AddtionalActionInfo message. Does not implicitly {@link palexy.sherlock.v1.AddtionalActionInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {palexy.sherlock.v1.IAddtionalActionInfo} message AddtionalActionInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddtionalActionInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.coordinateX != null && Object.hasOwnProperty.call(message, "coordinateX"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.coordinateX);
                        if (message.coordinateY != null && Object.hasOwnProperty.call(message, "coordinateY"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.coordinateY);
                        if (message.recordingDateTime != null && Object.hasOwnProperty.call(message, "recordingDateTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.recordingDateTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddtionalActionInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AddtionalActionInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {palexy.sherlock.v1.IAddtionalActionInfo} message AddtionalActionInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddtionalActionInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddtionalActionInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AddtionalActionInfo} AddtionalActionInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddtionalActionInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AddtionalActionInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.coordinateX = reader.float();
                                break;
                            case 3:
                                message.coordinateY = reader.float();
                                break;
                            case 4:
                                message.recordingDateTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddtionalActionInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AddtionalActionInfo} AddtionalActionInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddtionalActionInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddtionalActionInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddtionalActionInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.coordinateX != null && message.hasOwnProperty("coordinateX"))
                            if (typeof message.coordinateX !== "number")
                                return "coordinateX: number expected";
                        if (message.coordinateY != null && message.hasOwnProperty("coordinateY"))
                            if (typeof message.coordinateY !== "number")
                                return "coordinateY: number expected";
                        if (message.recordingDateTime != null && message.hasOwnProperty("recordingDateTime"))
                            if (!$util.isString(message.recordingDateTime))
                                return "recordingDateTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an AddtionalActionInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AddtionalActionInfo} AddtionalActionInfo
                     */
                    AddtionalActionInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AddtionalActionInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.AddtionalActionInfo();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.coordinateX != null)
                            message.coordinateX = Number(object.coordinateX);
                        if (object.coordinateY != null)
                            message.coordinateY = Number(object.coordinateY);
                        if (object.recordingDateTime != null)
                            message.recordingDateTime = String(object.recordingDateTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AddtionalActionInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @static
                     * @param {palexy.sherlock.v1.AddtionalActionInfo} message AddtionalActionInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddtionalActionInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraId = "";
                            object.coordinateX = 0;
                            object.coordinateY = 0;
                            object.recordingDateTime = "";
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.coordinateX != null && message.hasOwnProperty("coordinateX"))
                            object.coordinateX = options.json && !isFinite(message.coordinateX) ? String(message.coordinateX) : message.coordinateX;
                        if (message.coordinateY != null && message.hasOwnProperty("coordinateY"))
                            object.coordinateY = options.json && !isFinite(message.coordinateY) ? String(message.coordinateY) : message.coordinateY;
                        if (message.recordingDateTime != null && message.hasOwnProperty("recordingDateTime"))
                            object.recordingDateTime = message.recordingDateTime;
                        return object;
                    };
    
                    /**
                     * Converts this AddtionalActionInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AddtionalActionInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddtionalActionInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddtionalActionInfo;
                })();
    
                v1.MergeAccuracyResult = (function() {
    
                    /**
                     * Properties of a MergeAccuracyResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IMergeAccuracyResult
                     * @property {Array.<palexy.sherlock.v1.IMergeAccuracyResultItem>|null} [mergeAccuracyResultItems] MergeAccuracyResult mergeAccuracyResultItems
                     * @property {number|null} [avgPrecision] MergeAccuracyResult avgPrecision
                     * @property {number|null} [avgRecall] MergeAccuracyResult avgRecall
                     * @property {number|null} [avgF1] MergeAccuracyResult avgF1
                     */
    
                    /**
                     * Constructs a new MergeAccuracyResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a MergeAccuracyResult.
                     * @implements IMergeAccuracyResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IMergeAccuracyResult=} [properties] Properties to set
                     */
                    function MergeAccuracyResult(properties) {
                        this.mergeAccuracyResultItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergeAccuracyResult mergeAccuracyResultItems.
                     * @member {Array.<palexy.sherlock.v1.IMergeAccuracyResultItem>} mergeAccuracyResultItems
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @instance
                     */
                    MergeAccuracyResult.prototype.mergeAccuracyResultItems = $util.emptyArray;
    
                    /**
                     * MergeAccuracyResult avgPrecision.
                     * @member {number} avgPrecision
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @instance
                     */
                    MergeAccuracyResult.prototype.avgPrecision = 0;
    
                    /**
                     * MergeAccuracyResult avgRecall.
                     * @member {number} avgRecall
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @instance
                     */
                    MergeAccuracyResult.prototype.avgRecall = 0;
    
                    /**
                     * MergeAccuracyResult avgF1.
                     * @member {number} avgF1
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @instance
                     */
                    MergeAccuracyResult.prototype.avgF1 = 0;
    
                    /**
                     * Creates a new MergeAccuracyResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.MergeAccuracyResult} MergeAccuracyResult instance
                     */
                    MergeAccuracyResult.create = function create(properties) {
                        return new MergeAccuracyResult(properties);
                    };
    
                    /**
                     * Encodes the specified MergeAccuracyResult message. Does not implicitly {@link palexy.sherlock.v1.MergeAccuracyResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResult} message MergeAccuracyResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeAccuracyResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeAccuracyResultItems != null && message.mergeAccuracyResultItems.length)
                            for (var i = 0; i < message.mergeAccuracyResultItems.length; ++i)
                                $root.palexy.sherlock.v1.MergeAccuracyResultItem.encode(message.mergeAccuracyResultItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.avgPrecision != null && Object.hasOwnProperty.call(message, "avgPrecision"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.avgPrecision);
                        if (message.avgRecall != null && Object.hasOwnProperty.call(message, "avgRecall"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.avgRecall);
                        if (message.avgF1 != null && Object.hasOwnProperty.call(message, "avgF1"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.avgF1);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergeAccuracyResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.MergeAccuracyResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResult} message MergeAccuracyResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeAccuracyResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergeAccuracyResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.MergeAccuracyResult} MergeAccuracyResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeAccuracyResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.MergeAccuracyResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergeAccuracyResultItems && message.mergeAccuracyResultItems.length))
                                    message.mergeAccuracyResultItems = [];
                                message.mergeAccuracyResultItems.push($root.palexy.sherlock.v1.MergeAccuracyResultItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.avgPrecision = reader.float();
                                break;
                            case 3:
                                message.avgRecall = reader.float();
                                break;
                            case 4:
                                message.avgF1 = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergeAccuracyResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.MergeAccuracyResult} MergeAccuracyResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeAccuracyResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergeAccuracyResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergeAccuracyResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeAccuracyResultItems != null && message.hasOwnProperty("mergeAccuracyResultItems")) {
                            if (!Array.isArray(message.mergeAccuracyResultItems))
                                return "mergeAccuracyResultItems: array expected";
                            for (var i = 0; i < message.mergeAccuracyResultItems.length; ++i) {
                                var error = $root.palexy.sherlock.v1.MergeAccuracyResultItem.verify(message.mergeAccuracyResultItems[i]);
                                if (error)
                                    return "mergeAccuracyResultItems." + error;
                            }
                        }
                        if (message.avgPrecision != null && message.hasOwnProperty("avgPrecision"))
                            if (typeof message.avgPrecision !== "number")
                                return "avgPrecision: number expected";
                        if (message.avgRecall != null && message.hasOwnProperty("avgRecall"))
                            if (typeof message.avgRecall !== "number")
                                return "avgRecall: number expected";
                        if (message.avgF1 != null && message.hasOwnProperty("avgF1"))
                            if (typeof message.avgF1 !== "number")
                                return "avgF1: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergeAccuracyResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.MergeAccuracyResult} MergeAccuracyResult
                     */
                    MergeAccuracyResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.MergeAccuracyResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.MergeAccuracyResult();
                        if (object.mergeAccuracyResultItems) {
                            if (!Array.isArray(object.mergeAccuracyResultItems))
                                throw TypeError(".palexy.sherlock.v1.MergeAccuracyResult.mergeAccuracyResultItems: array expected");
                            message.mergeAccuracyResultItems = [];
                            for (var i = 0; i < object.mergeAccuracyResultItems.length; ++i) {
                                if (typeof object.mergeAccuracyResultItems[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.MergeAccuracyResult.mergeAccuracyResultItems: object expected");
                                message.mergeAccuracyResultItems[i] = $root.palexy.sherlock.v1.MergeAccuracyResultItem.fromObject(object.mergeAccuracyResultItems[i]);
                            }
                        }
                        if (object.avgPrecision != null)
                            message.avgPrecision = Number(object.avgPrecision);
                        if (object.avgRecall != null)
                            message.avgRecall = Number(object.avgRecall);
                        if (object.avgF1 != null)
                            message.avgF1 = Number(object.avgF1);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergeAccuracyResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.MergeAccuracyResult} message MergeAccuracyResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergeAccuracyResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergeAccuracyResultItems = [];
                        if (options.defaults) {
                            object.avgPrecision = 0;
                            object.avgRecall = 0;
                            object.avgF1 = 0;
                        }
                        if (message.mergeAccuracyResultItems && message.mergeAccuracyResultItems.length) {
                            object.mergeAccuracyResultItems = [];
                            for (var j = 0; j < message.mergeAccuracyResultItems.length; ++j)
                                object.mergeAccuracyResultItems[j] = $root.palexy.sherlock.v1.MergeAccuracyResultItem.toObject(message.mergeAccuracyResultItems[j], options);
                        }
                        if (message.avgPrecision != null && message.hasOwnProperty("avgPrecision"))
                            object.avgPrecision = options.json && !isFinite(message.avgPrecision) ? String(message.avgPrecision) : message.avgPrecision;
                        if (message.avgRecall != null && message.hasOwnProperty("avgRecall"))
                            object.avgRecall = options.json && !isFinite(message.avgRecall) ? String(message.avgRecall) : message.avgRecall;
                        if (message.avgF1 != null && message.hasOwnProperty("avgF1"))
                            object.avgF1 = options.json && !isFinite(message.avgF1) ? String(message.avgF1) : message.avgF1;
                        return object;
                    };
    
                    /**
                     * Converts this MergeAccuracyResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.MergeAccuracyResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergeAccuracyResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergeAccuracyResult;
                })();
    
                v1.MergeAccuracyResultItem = (function() {
    
                    /**
                     * Properties of a MergeAccuracyResultItem.
                     * @memberof palexy.sherlock.v1
                     * @interface IMergeAccuracyResultItem
                     * @property {palexy.sherlock.v1.IPredictedAndLabelItem|null} [predictedAndLabelItem] MergeAccuracyResultItem predictedAndLabelItem
                     * @property {number|null} [precision] MergeAccuracyResultItem precision
                     * @property {number|null} [recall] MergeAccuracyResultItem recall
                     * @property {number|null} [f1] MergeAccuracyResultItem f1
                     */
    
                    /**
                     * Constructs a new MergeAccuracyResultItem.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a MergeAccuracyResultItem.
                     * @implements IMergeAccuracyResultItem
                     * @constructor
                     * @param {palexy.sherlock.v1.IMergeAccuracyResultItem=} [properties] Properties to set
                     */
                    function MergeAccuracyResultItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergeAccuracyResultItem predictedAndLabelItem.
                     * @member {palexy.sherlock.v1.IPredictedAndLabelItem|null|undefined} predictedAndLabelItem
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @instance
                     */
                    MergeAccuracyResultItem.prototype.predictedAndLabelItem = null;
    
                    /**
                     * MergeAccuracyResultItem precision.
                     * @member {number} precision
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @instance
                     */
                    MergeAccuracyResultItem.prototype.precision = 0;
    
                    /**
                     * MergeAccuracyResultItem recall.
                     * @member {number} recall
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @instance
                     */
                    MergeAccuracyResultItem.prototype.recall = 0;
    
                    /**
                     * MergeAccuracyResultItem f1.
                     * @member {number} f1
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @instance
                     */
                    MergeAccuracyResultItem.prototype.f1 = 0;
    
                    /**
                     * Creates a new MergeAccuracyResultItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResultItem=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.MergeAccuracyResultItem} MergeAccuracyResultItem instance
                     */
                    MergeAccuracyResultItem.create = function create(properties) {
                        return new MergeAccuracyResultItem(properties);
                    };
    
                    /**
                     * Encodes the specified MergeAccuracyResultItem message. Does not implicitly {@link palexy.sherlock.v1.MergeAccuracyResultItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResultItem} message MergeAccuracyResultItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeAccuracyResultItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.predictedAndLabelItem != null && Object.hasOwnProperty.call(message, "predictedAndLabelItem"))
                            $root.palexy.sherlock.v1.PredictedAndLabelItem.encode(message.predictedAndLabelItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.precision != null && Object.hasOwnProperty.call(message, "precision"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.precision);
                        if (message.recall != null && Object.hasOwnProperty.call(message, "recall"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.recall);
                        if (message.f1 != null && Object.hasOwnProperty.call(message, "f1"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.f1);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergeAccuracyResultItem message, length delimited. Does not implicitly {@link palexy.sherlock.v1.MergeAccuracyResultItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IMergeAccuracyResultItem} message MergeAccuracyResultItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeAccuracyResultItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergeAccuracyResultItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.MergeAccuracyResultItem} MergeAccuracyResultItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeAccuracyResultItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.MergeAccuracyResultItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.predictedAndLabelItem = $root.palexy.sherlock.v1.PredictedAndLabelItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.precision = reader.float();
                                break;
                            case 3:
                                message.recall = reader.float();
                                break;
                            case 4:
                                message.f1 = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergeAccuracyResultItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.MergeAccuracyResultItem} MergeAccuracyResultItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeAccuracyResultItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergeAccuracyResultItem message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergeAccuracyResultItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.predictedAndLabelItem != null && message.hasOwnProperty("predictedAndLabelItem")) {
                            var error = $root.palexy.sherlock.v1.PredictedAndLabelItem.verify(message.predictedAndLabelItem);
                            if (error)
                                return "predictedAndLabelItem." + error;
                        }
                        if (message.precision != null && message.hasOwnProperty("precision"))
                            if (typeof message.precision !== "number")
                                return "precision: number expected";
                        if (message.recall != null && message.hasOwnProperty("recall"))
                            if (typeof message.recall !== "number")
                                return "recall: number expected";
                        if (message.f1 != null && message.hasOwnProperty("f1"))
                            if (typeof message.f1 !== "number")
                                return "f1: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergeAccuracyResultItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.MergeAccuracyResultItem} MergeAccuracyResultItem
                     */
                    MergeAccuracyResultItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.MergeAccuracyResultItem)
                            return object;
                        var message = new $root.palexy.sherlock.v1.MergeAccuracyResultItem();
                        if (object.predictedAndLabelItem != null) {
                            if (typeof object.predictedAndLabelItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.MergeAccuracyResultItem.predictedAndLabelItem: object expected");
                            message.predictedAndLabelItem = $root.palexy.sherlock.v1.PredictedAndLabelItem.fromObject(object.predictedAndLabelItem);
                        }
                        if (object.precision != null)
                            message.precision = Number(object.precision);
                        if (object.recall != null)
                            message.recall = Number(object.recall);
                        if (object.f1 != null)
                            message.f1 = Number(object.f1);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergeAccuracyResultItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @static
                     * @param {palexy.sherlock.v1.MergeAccuracyResultItem} message MergeAccuracyResultItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergeAccuracyResultItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.predictedAndLabelItem = null;
                            object.precision = 0;
                            object.recall = 0;
                            object.f1 = 0;
                        }
                        if (message.predictedAndLabelItem != null && message.hasOwnProperty("predictedAndLabelItem"))
                            object.predictedAndLabelItem = $root.palexy.sherlock.v1.PredictedAndLabelItem.toObject(message.predictedAndLabelItem, options);
                        if (message.precision != null && message.hasOwnProperty("precision"))
                            object.precision = options.json && !isFinite(message.precision) ? String(message.precision) : message.precision;
                        if (message.recall != null && message.hasOwnProperty("recall"))
                            object.recall = options.json && !isFinite(message.recall) ? String(message.recall) : message.recall;
                        if (message.f1 != null && message.hasOwnProperty("f1"))
                            object.f1 = options.json && !isFinite(message.f1) ? String(message.f1) : message.f1;
                        return object;
                    };
    
                    /**
                     * Converts this MergeAccuracyResultItem to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.MergeAccuracyResultItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergeAccuracyResultItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergeAccuracyResultItem;
                })();
    
                v1.RerunMergeConfigAdvanceInfo = (function() {
    
                    /**
                     * Properties of a RerunMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IRerunMergeConfigAdvanceInfo
                     * @property {Array.<palexy.sherlock.v1.IRerunMergeConfigDebugData>|null} [debugData] RerunMergeConfigAdvanceInfo debugData
                     * @property {palexy.streaming.v1.IMergingConfig|null} [mergingConfig] RerunMergeConfigAdvanceInfo mergingConfig
                     */
    
                    /**
                     * Constructs a new RerunMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RerunMergeConfigAdvanceInfo.
                     * @implements IRerunMergeConfigAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo=} [properties] Properties to set
                     */
                    function RerunMergeConfigAdvanceInfo(properties) {
                        this.debugData = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergeConfigAdvanceInfo debugData.
                     * @member {Array.<palexy.sherlock.v1.IRerunMergeConfigDebugData>} debugData
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @instance
                     */
                    RerunMergeConfigAdvanceInfo.prototype.debugData = $util.emptyArray;
    
                    /**
                     * RerunMergeConfigAdvanceInfo mergingConfig.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} mergingConfig
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @instance
                     */
                    RerunMergeConfigAdvanceInfo.prototype.mergingConfig = null;
    
                    /**
                     * Creates a new RerunMergeConfigAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RerunMergeConfigAdvanceInfo} RerunMergeConfigAdvanceInfo instance
                     */
                    RerunMergeConfigAdvanceInfo.create = function create(properties) {
                        return new RerunMergeConfigAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo} message RerunMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.debugData != null && message.debugData.length)
                            for (var i = 0; i < message.debugData.length; ++i)
                                $root.palexy.sherlock.v1.RerunMergeConfigDebugData.encode(message.debugData[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.mergingConfig != null && Object.hasOwnProperty.call(message, "mergingConfig"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.mergingConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigAdvanceInfo} message RerunMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergeConfigAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RerunMergeConfigAdvanceInfo} RerunMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.debugData && message.debugData.length))
                                    message.debugData = [];
                                message.debugData.push($root.palexy.sherlock.v1.RerunMergeConfigDebugData.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.mergingConfig = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergeConfigAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RerunMergeConfigAdvanceInfo} RerunMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergeConfigAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergeConfigAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.debugData != null && message.hasOwnProperty("debugData")) {
                            if (!Array.isArray(message.debugData))
                                return "debugData: array expected";
                            for (var i = 0; i < message.debugData.length; ++i) {
                                var error = $root.palexy.sherlock.v1.RerunMergeConfigDebugData.verify(message.debugData[i]);
                                if (error)
                                    return "debugData." + error;
                            }
                        }
                        if (message.mergingConfig != null && message.hasOwnProperty("mergingConfig")) {
                            var error = $root.palexy.streaming.v1.MergingConfig.verify(message.mergingConfig);
                            if (error)
                                return "mergingConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergeConfigAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RerunMergeConfigAdvanceInfo} RerunMergeConfigAdvanceInfo
                     */
                    RerunMergeConfigAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RerunMergeConfigAdvanceInfo();
                        if (object.debugData) {
                            if (!Array.isArray(object.debugData))
                                throw TypeError(".palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.debugData: array expected");
                            message.debugData = [];
                            for (var i = 0; i < object.debugData.length; ++i) {
                                if (typeof object.debugData[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.debugData: object expected");
                                message.debugData[i] = $root.palexy.sherlock.v1.RerunMergeConfigDebugData.fromObject(object.debugData[i]);
                            }
                        }
                        if (object.mergingConfig != null) {
                            if (typeof object.mergingConfig !== "object")
                                throw TypeError(".palexy.sherlock.v1.RerunMergeConfigAdvanceInfo.mergingConfig: object expected");
                            message.mergingConfig = $root.palexy.streaming.v1.MergingConfig.fromObject(object.mergingConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergeConfigAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.RerunMergeConfigAdvanceInfo} message RerunMergeConfigAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergeConfigAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.debugData = [];
                        if (options.defaults)
                            object.mergingConfig = null;
                        if (message.debugData && message.debugData.length) {
                            object.debugData = [];
                            for (var j = 0; j < message.debugData.length; ++j)
                                object.debugData[j] = $root.palexy.sherlock.v1.RerunMergeConfigDebugData.toObject(message.debugData[j], options);
                        }
                        if (message.mergingConfig != null && message.hasOwnProperty("mergingConfig"))
                            object.mergingConfig = $root.palexy.streaming.v1.MergingConfig.toObject(message.mergingConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergeConfigAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RerunMergeConfigAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergeConfigAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergeConfigAdvanceInfo;
                })();
    
                v1.RerunMergeConfigDebugData = (function() {
    
                    /**
                     * Properties of a RerunMergeConfigDebugData.
                     * @memberof palexy.sherlock.v1
                     * @interface IRerunMergeConfigDebugData
                     * @property {string|null} [displayName] RerunMergeConfigDebugData displayName
                     * @property {palexy.sherlock.v1.IExtractBBResult|null} [extractBbResult] RerunMergeConfigDebugData extractBbResult
                     */
    
                    /**
                     * Constructs a new RerunMergeConfigDebugData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RerunMergeConfigDebugData.
                     * @implements IRerunMergeConfigDebugData
                     * @constructor
                     * @param {palexy.sherlock.v1.IRerunMergeConfigDebugData=} [properties] Properties to set
                     */
                    function RerunMergeConfigDebugData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergeConfigDebugData displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @instance
                     */
                    RerunMergeConfigDebugData.prototype.displayName = "";
    
                    /**
                     * RerunMergeConfigDebugData extractBbResult.
                     * @member {palexy.sherlock.v1.IExtractBBResult|null|undefined} extractBbResult
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @instance
                     */
                    RerunMergeConfigDebugData.prototype.extractBbResult = null;
    
                    /**
                     * Creates a new RerunMergeConfigDebugData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigDebugData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RerunMergeConfigDebugData} RerunMergeConfigDebugData instance
                     */
                    RerunMergeConfigDebugData.create = function create(properties) {
                        return new RerunMergeConfigDebugData(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigDebugData message. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigDebugData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigDebugData} message RerunMergeConfigDebugData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigDebugData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.displayName);
                        if (message.extractBbResult != null && Object.hasOwnProperty.call(message, "extractBbResult"))
                            $root.palexy.sherlock.v1.ExtractBBResult.encode(message.extractBbResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigDebugData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigDebugData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigDebugData} message RerunMergeConfigDebugData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigDebugData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergeConfigDebugData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RerunMergeConfigDebugData} RerunMergeConfigDebugData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigDebugData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RerunMergeConfigDebugData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.displayName = reader.string();
                                break;
                            case 2:
                                message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergeConfigDebugData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RerunMergeConfigDebugData} RerunMergeConfigDebugData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigDebugData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergeConfigDebugData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergeConfigDebugData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult")) {
                            var error = $root.palexy.sherlock.v1.ExtractBBResult.verify(message.extractBbResult);
                            if (error)
                                return "extractBbResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergeConfigDebugData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RerunMergeConfigDebugData} RerunMergeConfigDebugData
                     */
                    RerunMergeConfigDebugData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RerunMergeConfigDebugData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RerunMergeConfigDebugData();
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.extractBbResult != null) {
                            if (typeof object.extractBbResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.RerunMergeConfigDebugData.extractBbResult: object expected");
                            message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.fromObject(object.extractBbResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergeConfigDebugData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.RerunMergeConfigDebugData} message RerunMergeConfigDebugData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergeConfigDebugData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.displayName = "";
                            object.extractBbResult = null;
                        }
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult"))
                            object.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.toObject(message.extractBbResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergeConfigDebugData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RerunMergeConfigDebugData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergeConfigDebugData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergeConfigDebugData;
                })();
    
                v1.RerunMergeConfigResult = (function() {
    
                    /**
                     * Properties of a RerunMergeConfigResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IRerunMergeConfigResult
                     * @property {Array.<string>|null} [mergingResultLinks] RerunMergeConfigResult mergingResultLinks
                     */
    
                    /**
                     * Constructs a new RerunMergeConfigResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RerunMergeConfigResult.
                     * @implements IRerunMergeConfigResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IRerunMergeConfigResult=} [properties] Properties to set
                     */
                    function RerunMergeConfigResult(properties) {
                        this.mergingResultLinks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergeConfigResult mergingResultLinks.
                     * @member {Array.<string>} mergingResultLinks
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @instance
                     */
                    RerunMergeConfigResult.prototype.mergingResultLinks = $util.emptyArray;
    
                    /**
                     * Creates a new RerunMergeConfigResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RerunMergeConfigResult} RerunMergeConfigResult instance
                     */
                    RerunMergeConfigResult.create = function create(properties) {
                        return new RerunMergeConfigResult(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigResult message. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigResult} message RerunMergeConfigResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingResultLinks != null && message.mergingResultLinks.length)
                            for (var i = 0; i < message.mergingResultLinks.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.mergingResultLinks[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergeConfigResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RerunMergeConfigResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IRerunMergeConfigResult} message RerunMergeConfigResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergeConfigResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergeConfigResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RerunMergeConfigResult} RerunMergeConfigResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RerunMergeConfigResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergingResultLinks && message.mergingResultLinks.length))
                                    message.mergingResultLinks = [];
                                message.mergingResultLinks.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergeConfigResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RerunMergeConfigResult} RerunMergeConfigResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergeConfigResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergeConfigResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergeConfigResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingResultLinks != null && message.hasOwnProperty("mergingResultLinks")) {
                            if (!Array.isArray(message.mergingResultLinks))
                                return "mergingResultLinks: array expected";
                            for (var i = 0; i < message.mergingResultLinks.length; ++i)
                                if (!$util.isString(message.mergingResultLinks[i]))
                                    return "mergingResultLinks: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergeConfigResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RerunMergeConfigResult} RerunMergeConfigResult
                     */
                    RerunMergeConfigResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RerunMergeConfigResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RerunMergeConfigResult();
                        if (object.mergingResultLinks) {
                            if (!Array.isArray(object.mergingResultLinks))
                                throw TypeError(".palexy.sherlock.v1.RerunMergeConfigResult.mergingResultLinks: array expected");
                            message.mergingResultLinks = [];
                            for (var i = 0; i < object.mergingResultLinks.length; ++i)
                                message.mergingResultLinks[i] = String(object.mergingResultLinks[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergeConfigResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.RerunMergeConfigResult} message RerunMergeConfigResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergeConfigResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergingResultLinks = [];
                        if (message.mergingResultLinks && message.mergingResultLinks.length) {
                            object.mergingResultLinks = [];
                            for (var j = 0; j < message.mergingResultLinks.length; ++j)
                                object.mergingResultLinks[j] = message.mergingResultLinks[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergeConfigResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RerunMergeConfigResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergeConfigResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergeConfigResult;
                })();
    
                v1.ScanMergeConfigAdvanceInfo = (function() {
    
                    /**
                     * Properties of a ScanMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @interface IScanMergeConfigAdvanceInfo
                     * @property {Array.<palexy.sherlock.v1.IScanMergeConfigDebugData>|null} [debugData] ScanMergeConfigAdvanceInfo debugData
                     * @property {palexy.streaming.v1.IMergingConfig|null} [defaultConfig] ScanMergeConfigAdvanceInfo defaultConfig
                     * @property {Array.<palexy.sherlock.v1.IParameter>|null} [scanParameters] ScanMergeConfigAdvanceInfo scanParameters
                     * @property {palexy.sherlock.v1.IScanMergeConfigState|null} [state] ScanMergeConfigAdvanceInfo state
                     */
    
                    /**
                     * Constructs a new ScanMergeConfigAdvanceInfo.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ScanMergeConfigAdvanceInfo.
                     * @implements IScanMergeConfigAdvanceInfo
                     * @constructor
                     * @param {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo=} [properties] Properties to set
                     */
                    function ScanMergeConfigAdvanceInfo(properties) {
                        this.debugData = [];
                        this.scanParameters = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScanMergeConfigAdvanceInfo debugData.
                     * @member {Array.<palexy.sherlock.v1.IScanMergeConfigDebugData>} debugData
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @instance
                     */
                    ScanMergeConfigAdvanceInfo.prototype.debugData = $util.emptyArray;
    
                    /**
                     * ScanMergeConfigAdvanceInfo defaultConfig.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} defaultConfig
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @instance
                     */
                    ScanMergeConfigAdvanceInfo.prototype.defaultConfig = null;
    
                    /**
                     * ScanMergeConfigAdvanceInfo scanParameters.
                     * @member {Array.<palexy.sherlock.v1.IParameter>} scanParameters
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @instance
                     */
                    ScanMergeConfigAdvanceInfo.prototype.scanParameters = $util.emptyArray;
    
                    /**
                     * ScanMergeConfigAdvanceInfo state.
                     * @member {palexy.sherlock.v1.IScanMergeConfigState|null|undefined} state
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @instance
                     */
                    ScanMergeConfigAdvanceInfo.prototype.state = null;
    
                    /**
                     * Creates a new ScanMergeConfigAdvanceInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ScanMergeConfigAdvanceInfo} ScanMergeConfigAdvanceInfo instance
                     */
                    ScanMergeConfigAdvanceInfo.create = function create(properties) {
                        return new ScanMergeConfigAdvanceInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigAdvanceInfo message. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo} message ScanMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigAdvanceInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.debugData != null && message.debugData.length)
                            for (var i = 0; i < message.debugData.length; ++i)
                                $root.palexy.sherlock.v1.ScanMergeConfigDebugData.encode(message.debugData[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.defaultConfig != null && Object.hasOwnProperty.call(message, "defaultConfig"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.defaultConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.scanParameters != null && message.scanParameters.length)
                            for (var i = 0; i < message.scanParameters.length; ++i)
                                $root.palexy.sherlock.v1.Parameter.encode(message.scanParameters[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            $root.palexy.sherlock.v1.ScanMergeConfigState.encode(message.state, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigAdvanceInfo message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigAdvanceInfo} message ScanMergeConfigAdvanceInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigAdvanceInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScanMergeConfigAdvanceInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ScanMergeConfigAdvanceInfo} ScanMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigAdvanceInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.debugData && message.debugData.length))
                                    message.debugData = [];
                                message.debugData.push($root.palexy.sherlock.v1.ScanMergeConfigDebugData.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.defaultConfig = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            case 3:
                                if (!(message.scanParameters && message.scanParameters.length))
                                    message.scanParameters = [];
                                message.scanParameters.push($root.palexy.sherlock.v1.Parameter.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.state = $root.palexy.sherlock.v1.ScanMergeConfigState.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScanMergeConfigAdvanceInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ScanMergeConfigAdvanceInfo} ScanMergeConfigAdvanceInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigAdvanceInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScanMergeConfigAdvanceInfo message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScanMergeConfigAdvanceInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.debugData != null && message.hasOwnProperty("debugData")) {
                            if (!Array.isArray(message.debugData))
                                return "debugData: array expected";
                            for (var i = 0; i < message.debugData.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ScanMergeConfigDebugData.verify(message.debugData[i]);
                                if (error)
                                    return "debugData." + error;
                            }
                        }
                        if (message.defaultConfig != null && message.hasOwnProperty("defaultConfig")) {
                            var error = $root.palexy.streaming.v1.MergingConfig.verify(message.defaultConfig);
                            if (error)
                                return "defaultConfig." + error;
                        }
                        if (message.scanParameters != null && message.hasOwnProperty("scanParameters")) {
                            if (!Array.isArray(message.scanParameters))
                                return "scanParameters: array expected";
                            for (var i = 0; i < message.scanParameters.length; ++i) {
                                var error = $root.palexy.sherlock.v1.Parameter.verify(message.scanParameters[i]);
                                if (error)
                                    return "scanParameters." + error;
                            }
                        }
                        if (message.state != null && message.hasOwnProperty("state")) {
                            var error = $root.palexy.sherlock.v1.ScanMergeConfigState.verify(message.state);
                            if (error)
                                return "state." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScanMergeConfigAdvanceInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ScanMergeConfigAdvanceInfo} ScanMergeConfigAdvanceInfo
                     */
                    ScanMergeConfigAdvanceInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ScanMergeConfigAdvanceInfo();
                        if (object.debugData) {
                            if (!Array.isArray(object.debugData))
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.debugData: array expected");
                            message.debugData = [];
                            for (var i = 0; i < object.debugData.length; ++i) {
                                if (typeof object.debugData[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.debugData: object expected");
                                message.debugData[i] = $root.palexy.sherlock.v1.ScanMergeConfigDebugData.fromObject(object.debugData[i]);
                            }
                        }
                        if (object.defaultConfig != null) {
                            if (typeof object.defaultConfig !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.defaultConfig: object expected");
                            message.defaultConfig = $root.palexy.streaming.v1.MergingConfig.fromObject(object.defaultConfig);
                        }
                        if (object.scanParameters) {
                            if (!Array.isArray(object.scanParameters))
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.scanParameters: array expected");
                            message.scanParameters = [];
                            for (var i = 0; i < object.scanParameters.length; ++i) {
                                if (typeof object.scanParameters[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.scanParameters: object expected");
                                message.scanParameters[i] = $root.palexy.sherlock.v1.Parameter.fromObject(object.scanParameters[i]);
                            }
                        }
                        if (object.state != null) {
                            if (typeof object.state !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigAdvanceInfo.state: object expected");
                            message.state = $root.palexy.sherlock.v1.ScanMergeConfigState.fromObject(object.state);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScanMergeConfigAdvanceInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @static
                     * @param {palexy.sherlock.v1.ScanMergeConfigAdvanceInfo} message ScanMergeConfigAdvanceInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScanMergeConfigAdvanceInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.debugData = [];
                            object.scanParameters = [];
                        }
                        if (options.defaults) {
                            object.defaultConfig = null;
                            object.state = null;
                        }
                        if (message.debugData && message.debugData.length) {
                            object.debugData = [];
                            for (var j = 0; j < message.debugData.length; ++j)
                                object.debugData[j] = $root.palexy.sherlock.v1.ScanMergeConfigDebugData.toObject(message.debugData[j], options);
                        }
                        if (message.defaultConfig != null && message.hasOwnProperty("defaultConfig"))
                            object.defaultConfig = $root.palexy.streaming.v1.MergingConfig.toObject(message.defaultConfig, options);
                        if (message.scanParameters && message.scanParameters.length) {
                            object.scanParameters = [];
                            for (var j = 0; j < message.scanParameters.length; ++j)
                                object.scanParameters[j] = $root.palexy.sherlock.v1.Parameter.toObject(message.scanParameters[j], options);
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = $root.palexy.sherlock.v1.ScanMergeConfigState.toObject(message.state, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScanMergeConfigAdvanceInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ScanMergeConfigAdvanceInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScanMergeConfigAdvanceInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScanMergeConfigAdvanceInfo;
                })();
    
                v1.ScanMergeConfigDebugData = (function() {
    
                    /**
                     * Properties of a ScanMergeConfigDebugData.
                     * @memberof palexy.sherlock.v1
                     * @interface IScanMergeConfigDebugData
                     * @property {string|null} [displayName] ScanMergeConfigDebugData displayName
                     * @property {palexy.sherlock.v1.IExtractBBResult|null} [extractBbResult] ScanMergeConfigDebugData extractBbResult
                     */
    
                    /**
                     * Constructs a new ScanMergeConfigDebugData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ScanMergeConfigDebugData.
                     * @implements IScanMergeConfigDebugData
                     * @constructor
                     * @param {palexy.sherlock.v1.IScanMergeConfigDebugData=} [properties] Properties to set
                     */
                    function ScanMergeConfigDebugData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScanMergeConfigDebugData displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @instance
                     */
                    ScanMergeConfigDebugData.prototype.displayName = "";
    
                    /**
                     * ScanMergeConfigDebugData extractBbResult.
                     * @member {palexy.sherlock.v1.IExtractBBResult|null|undefined} extractBbResult
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @instance
                     */
                    ScanMergeConfigDebugData.prototype.extractBbResult = null;
    
                    /**
                     * Creates a new ScanMergeConfigDebugData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigDebugData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ScanMergeConfigDebugData} ScanMergeConfigDebugData instance
                     */
                    ScanMergeConfigDebugData.create = function create(properties) {
                        return new ScanMergeConfigDebugData(properties);
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigDebugData message. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigDebugData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigDebugData} message ScanMergeConfigDebugData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigDebugData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.displayName);
                        if (message.extractBbResult != null && Object.hasOwnProperty.call(message, "extractBbResult"))
                            $root.palexy.sherlock.v1.ExtractBBResult.encode(message.extractBbResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigDebugData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigDebugData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigDebugData} message ScanMergeConfigDebugData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigDebugData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScanMergeConfigDebugData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ScanMergeConfigDebugData} ScanMergeConfigDebugData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigDebugData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ScanMergeConfigDebugData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.displayName = reader.string();
                                break;
                            case 2:
                                message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScanMergeConfigDebugData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ScanMergeConfigDebugData} ScanMergeConfigDebugData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigDebugData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScanMergeConfigDebugData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScanMergeConfigDebugData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult")) {
                            var error = $root.palexy.sherlock.v1.ExtractBBResult.verify(message.extractBbResult);
                            if (error)
                                return "extractBbResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScanMergeConfigDebugData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ScanMergeConfigDebugData} ScanMergeConfigDebugData
                     */
                    ScanMergeConfigDebugData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ScanMergeConfigDebugData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ScanMergeConfigDebugData();
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.extractBbResult != null) {
                            if (typeof object.extractBbResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigDebugData.extractBbResult: object expected");
                            message.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.fromObject(object.extractBbResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScanMergeConfigDebugData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @static
                     * @param {palexy.sherlock.v1.ScanMergeConfigDebugData} message ScanMergeConfigDebugData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScanMergeConfigDebugData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.displayName = "";
                            object.extractBbResult = null;
                        }
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.extractBbResult != null && message.hasOwnProperty("extractBbResult"))
                            object.extractBbResult = $root.palexy.sherlock.v1.ExtractBBResult.toObject(message.extractBbResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScanMergeConfigDebugData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ScanMergeConfigDebugData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScanMergeConfigDebugData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScanMergeConfigDebugData;
                })();
    
                v1.Parameter = (function() {
    
                    /**
                     * Properties of a Parameter.
                     * @memberof palexy.sherlock.v1
                     * @interface IParameter
                     * @property {string|null} [name] Parameter name
                     * @property {palexy.sherlock.v1.IParameterRange|null} [range] Parameter range
                     */
    
                    /**
                     * Constructs a new Parameter.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a Parameter.
                     * @implements IParameter
                     * @constructor
                     * @param {palexy.sherlock.v1.IParameter=} [properties] Properties to set
                     */
                    function Parameter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Parameter name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.Parameter
                     * @instance
                     */
                    Parameter.prototype.name = "";
    
                    /**
                     * Parameter range.
                     * @member {palexy.sherlock.v1.IParameterRange|null|undefined} range
                     * @memberof palexy.sherlock.v1.Parameter
                     * @instance
                     */
                    Parameter.prototype.range = null;
    
                    /**
                     * Creates a new Parameter instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {palexy.sherlock.v1.IParameter=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.Parameter} Parameter instance
                     */
                    Parameter.create = function create(properties) {
                        return new Parameter(properties);
                    };
    
                    /**
                     * Encodes the specified Parameter message. Does not implicitly {@link palexy.sherlock.v1.Parameter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {palexy.sherlock.v1.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.range != null && Object.hasOwnProperty.call(message, "range"))
                            $root.palexy.sherlock.v1.ParameterRange.encode(message.range, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Parameter message, length delimited. Does not implicitly {@link palexy.sherlock.v1.Parameter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {palexy.sherlock.v1.IParameter} message Parameter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Parameter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Parameter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.Parameter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.range = $root.palexy.sherlock.v1.ParameterRange.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Parameter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.Parameter} Parameter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Parameter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Parameter message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Parameter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.range != null && message.hasOwnProperty("range")) {
                            var error = $root.palexy.sherlock.v1.ParameterRange.verify(message.range);
                            if (error)
                                return "range." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Parameter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.Parameter} Parameter
                     */
                    Parameter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.Parameter)
                            return object;
                        var message = new $root.palexy.sherlock.v1.Parameter();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.range != null) {
                            if (typeof object.range !== "object")
                                throw TypeError(".palexy.sherlock.v1.Parameter.range: object expected");
                            message.range = $root.palexy.sherlock.v1.ParameterRange.fromObject(object.range);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Parameter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.Parameter
                     * @static
                     * @param {palexy.sherlock.v1.Parameter} message Parameter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Parameter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.range = null;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.range != null && message.hasOwnProperty("range"))
                            object.range = $root.palexy.sherlock.v1.ParameterRange.toObject(message.range, options);
                        return object;
                    };
    
                    /**
                     * Converts this Parameter to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.Parameter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Parameter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Parameter;
                })();
    
                v1.ParameterRange = (function() {
    
                    /**
                     * Properties of a ParameterRange.
                     * @memberof palexy.sherlock.v1
                     * @interface IParameterRange
                     * @property {number|null} [min] ParameterRange min
                     * @property {number|null} [max] ParameterRange max
                     * @property {number|null} [step] ParameterRange step
                     */
    
                    /**
                     * Constructs a new ParameterRange.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ParameterRange.
                     * @implements IParameterRange
                     * @constructor
                     * @param {palexy.sherlock.v1.IParameterRange=} [properties] Properties to set
                     */
                    function ParameterRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ParameterRange min.
                     * @member {number} min
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @instance
                     */
                    ParameterRange.prototype.min = 0;
    
                    /**
                     * ParameterRange max.
                     * @member {number} max
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @instance
                     */
                    ParameterRange.prototype.max = 0;
    
                    /**
                     * ParameterRange step.
                     * @member {number} step
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @instance
                     */
                    ParameterRange.prototype.step = 0;
    
                    /**
                     * Creates a new ParameterRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {palexy.sherlock.v1.IParameterRange=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ParameterRange} ParameterRange instance
                     */
                    ParameterRange.create = function create(properties) {
                        return new ParameterRange(properties);
                    };
    
                    /**
                     * Encodes the specified ParameterRange message. Does not implicitly {@link palexy.sherlock.v1.ParameterRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {palexy.sherlock.v1.IParameterRange} message ParameterRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.min);
                        if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.max);
                        if (message.step != null && Object.hasOwnProperty.call(message, "step"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.step);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ParameterRange message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ParameterRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {palexy.sherlock.v1.IParameterRange} message ParameterRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParameterRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ParameterRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ParameterRange} ParameterRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ParameterRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.min = reader.float();
                                break;
                            case 2:
                                message.max = reader.float();
                                break;
                            case 3:
                                message.step = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ParameterRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ParameterRange} ParameterRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParameterRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ParameterRange message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ParameterRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.min != null && message.hasOwnProperty("min"))
                            if (typeof message.min !== "number")
                                return "min: number expected";
                        if (message.max != null && message.hasOwnProperty("max"))
                            if (typeof message.max !== "number")
                                return "max: number expected";
                        if (message.step != null && message.hasOwnProperty("step"))
                            if (typeof message.step !== "number")
                                return "step: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a ParameterRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ParameterRange} ParameterRange
                     */
                    ParameterRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ParameterRange)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ParameterRange();
                        if (object.min != null)
                            message.min = Number(object.min);
                        if (object.max != null)
                            message.max = Number(object.max);
                        if (object.step != null)
                            message.step = Number(object.step);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ParameterRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @static
                     * @param {palexy.sherlock.v1.ParameterRange} message ParameterRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ParameterRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.min = 0;
                            object.max = 0;
                            object.step = 0;
                        }
                        if (message.min != null && message.hasOwnProperty("min"))
                            object.min = options.json && !isFinite(message.min) ? String(message.min) : message.min;
                        if (message.max != null && message.hasOwnProperty("max"))
                            object.max = options.json && !isFinite(message.max) ? String(message.max) : message.max;
                        if (message.step != null && message.hasOwnProperty("step"))
                            object.step = options.json && !isFinite(message.step) ? String(message.step) : message.step;
                        return object;
                    };
    
                    /**
                     * Converts this ParameterRange to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ParameterRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ParameterRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ParameterRange;
                })();
    
                v1.ScanMergeConfigState = (function() {
    
                    /**
                     * Properties of a ScanMergeConfigState.
                     * @memberof palexy.sherlock.v1
                     * @interface IScanMergeConfigState
                     * @property {palexy.streaming.v1.IMergingConfig|null} [processingConfig] ScanMergeConfigState processingConfig
                     * @property {palexy.sherlock.v1.IScanMergeConfigResult|null} [currentResult] ScanMergeConfigState currentResult
                     */
    
                    /**
                     * Constructs a new ScanMergeConfigState.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ScanMergeConfigState.
                     * @implements IScanMergeConfigState
                     * @constructor
                     * @param {palexy.sherlock.v1.IScanMergeConfigState=} [properties] Properties to set
                     */
                    function ScanMergeConfigState(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScanMergeConfigState processingConfig.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} processingConfig
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @instance
                     */
                    ScanMergeConfigState.prototype.processingConfig = null;
    
                    /**
                     * ScanMergeConfigState currentResult.
                     * @member {palexy.sherlock.v1.IScanMergeConfigResult|null|undefined} currentResult
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @instance
                     */
                    ScanMergeConfigState.prototype.currentResult = null;
    
                    /**
                     * Creates a new ScanMergeConfigState instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigState=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ScanMergeConfigState} ScanMergeConfigState instance
                     */
                    ScanMergeConfigState.create = function create(properties) {
                        return new ScanMergeConfigState(properties);
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigState message. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigState.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigState} message ScanMergeConfigState message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigState.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.processingConfig != null && Object.hasOwnProperty.call(message, "processingConfig"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.processingConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.currentResult != null && Object.hasOwnProperty.call(message, "currentResult"))
                            $root.palexy.sherlock.v1.ScanMergeConfigResult.encode(message.currentResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigState message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigState.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigState} message ScanMergeConfigState message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigState.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScanMergeConfigState message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ScanMergeConfigState} ScanMergeConfigState
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigState.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ScanMergeConfigState();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.processingConfig = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.currentResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScanMergeConfigState message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ScanMergeConfigState} ScanMergeConfigState
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigState.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScanMergeConfigState message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScanMergeConfigState.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.processingConfig != null && message.hasOwnProperty("processingConfig")) {
                            var error = $root.palexy.streaming.v1.MergingConfig.verify(message.processingConfig);
                            if (error)
                                return "processingConfig." + error;
                        }
                        if (message.currentResult != null && message.hasOwnProperty("currentResult")) {
                            var error = $root.palexy.sherlock.v1.ScanMergeConfigResult.verify(message.currentResult);
                            if (error)
                                return "currentResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScanMergeConfigState message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ScanMergeConfigState} ScanMergeConfigState
                     */
                    ScanMergeConfigState.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ScanMergeConfigState)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ScanMergeConfigState();
                        if (object.processingConfig != null) {
                            if (typeof object.processingConfig !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigState.processingConfig: object expected");
                            message.processingConfig = $root.palexy.streaming.v1.MergingConfig.fromObject(object.processingConfig);
                        }
                        if (object.currentResult != null) {
                            if (typeof object.currentResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigState.currentResult: object expected");
                            message.currentResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.fromObject(object.currentResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScanMergeConfigState message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @static
                     * @param {palexy.sherlock.v1.ScanMergeConfigState} message ScanMergeConfigState
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScanMergeConfigState.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.processingConfig = null;
                            object.currentResult = null;
                        }
                        if (message.processingConfig != null && message.hasOwnProperty("processingConfig"))
                            object.processingConfig = $root.palexy.streaming.v1.MergingConfig.toObject(message.processingConfig, options);
                        if (message.currentResult != null && message.hasOwnProperty("currentResult"))
                            object.currentResult = $root.palexy.sherlock.v1.ScanMergeConfigResult.toObject(message.currentResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScanMergeConfigState to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ScanMergeConfigState
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScanMergeConfigState.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScanMergeConfigState;
                })();
    
                v1.ScanMergeConfigResult = (function() {
    
                    /**
                     * Properties of a ScanMergeConfigResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IScanMergeConfigResult
                     * @property {palexy.sherlock.v1.IScanMergeConfigResultItem|null} [referenceItem] ScanMergeConfigResult referenceItem
                     * @property {Array.<palexy.sherlock.v1.IScanMergeConfigResultItem>|null} [items] ScanMergeConfigResult items
                     */
    
                    /**
                     * Constructs a new ScanMergeConfigResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ScanMergeConfigResult.
                     * @implements IScanMergeConfigResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IScanMergeConfigResult=} [properties] Properties to set
                     */
                    function ScanMergeConfigResult(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScanMergeConfigResult referenceItem.
                     * @member {palexy.sherlock.v1.IScanMergeConfigResultItem|null|undefined} referenceItem
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @instance
                     */
                    ScanMergeConfigResult.prototype.referenceItem = null;
    
                    /**
                     * ScanMergeConfigResult items.
                     * @member {Array.<palexy.sherlock.v1.IScanMergeConfigResultItem>} items
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @instance
                     */
                    ScanMergeConfigResult.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new ScanMergeConfigResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResult} ScanMergeConfigResult instance
                     */
                    ScanMergeConfigResult.create = function create(properties) {
                        return new ScanMergeConfigResult(properties);
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigResult message. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResult} message ScanMergeConfigResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.referenceItem != null && Object.hasOwnProperty.call(message, "referenceItem"))
                            $root.palexy.sherlock.v1.ScanMergeConfigResultItem.encode(message.referenceItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.sherlock.v1.ScanMergeConfigResultItem.encode(message.items[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResult} message ScanMergeConfigResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScanMergeConfigResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResult} ScanMergeConfigResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ScanMergeConfigResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.referenceItem = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.sherlock.v1.ScanMergeConfigResultItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScanMergeConfigResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResult} ScanMergeConfigResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScanMergeConfigResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScanMergeConfigResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.referenceItem != null && message.hasOwnProperty("referenceItem")) {
                            var error = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.verify(message.referenceItem);
                            if (error)
                                return "referenceItem." + error;
                        }
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScanMergeConfigResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResult} ScanMergeConfigResult
                     */
                    ScanMergeConfigResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ScanMergeConfigResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ScanMergeConfigResult();
                        if (object.referenceItem != null) {
                            if (typeof object.referenceItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigResult.referenceItem: object expected");
                            message.referenceItem = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.fromObject(object.referenceItem);
                        }
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigResult.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ScanMergeConfigResult.items: object expected");
                                message.items[i] = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScanMergeConfigResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @static
                     * @param {palexy.sherlock.v1.ScanMergeConfigResult} message ScanMergeConfigResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScanMergeConfigResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults)
                            object.referenceItem = null;
                        if (message.referenceItem != null && message.hasOwnProperty("referenceItem"))
                            object.referenceItem = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.toObject(message.referenceItem, options);
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.sherlock.v1.ScanMergeConfigResultItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ScanMergeConfigResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScanMergeConfigResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScanMergeConfigResult;
                })();
    
                v1.ScanMergeConfigResultItem = (function() {
    
                    /**
                     * Properties of a ScanMergeConfigResultItem.
                     * @memberof palexy.sherlock.v1
                     * @interface IScanMergeConfigResultItem
                     * @property {palexy.sherlock.v1.IMergeAccuracyResult|null} [result] ScanMergeConfigResultItem result
                     * @property {palexy.streaming.v1.IMergingConfig|null} [config] ScanMergeConfigResultItem config
                     */
    
                    /**
                     * Constructs a new ScanMergeConfigResultItem.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ScanMergeConfigResultItem.
                     * @implements IScanMergeConfigResultItem
                     * @constructor
                     * @param {palexy.sherlock.v1.IScanMergeConfigResultItem=} [properties] Properties to set
                     */
                    function ScanMergeConfigResultItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScanMergeConfigResultItem result.
                     * @member {palexy.sherlock.v1.IMergeAccuracyResult|null|undefined} result
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @instance
                     */
                    ScanMergeConfigResultItem.prototype.result = null;
    
                    /**
                     * ScanMergeConfigResultItem config.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} config
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @instance
                     */
                    ScanMergeConfigResultItem.prototype.config = null;
    
                    /**
                     * Creates a new ScanMergeConfigResultItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResultItem=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResultItem} ScanMergeConfigResultItem instance
                     */
                    ScanMergeConfigResultItem.create = function create(properties) {
                        return new ScanMergeConfigResultItem(properties);
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigResultItem message. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigResultItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResultItem} message ScanMergeConfigResultItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigResultItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                            $root.palexy.sherlock.v1.MergeAccuracyResult.encode(message.result, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.config, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScanMergeConfigResultItem message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ScanMergeConfigResultItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {palexy.sherlock.v1.IScanMergeConfigResultItem} message ScanMergeConfigResultItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScanMergeConfigResultItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScanMergeConfigResultItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResultItem} ScanMergeConfigResultItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigResultItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ScanMergeConfigResultItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.result = $root.palexy.sherlock.v1.MergeAccuracyResult.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.config = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScanMergeConfigResultItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResultItem} ScanMergeConfigResultItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScanMergeConfigResultItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScanMergeConfigResultItem message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScanMergeConfigResultItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.result != null && message.hasOwnProperty("result")) {
                            var error = $root.palexy.sherlock.v1.MergeAccuracyResult.verify(message.result);
                            if (error)
                                return "result." + error;
                        }
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.MergingConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScanMergeConfigResultItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ScanMergeConfigResultItem} ScanMergeConfigResultItem
                     */
                    ScanMergeConfigResultItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ScanMergeConfigResultItem)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ScanMergeConfigResultItem();
                        if (object.result != null) {
                            if (typeof object.result !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigResultItem.result: object expected");
                            message.result = $root.palexy.sherlock.v1.MergeAccuracyResult.fromObject(object.result);
                        }
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.sherlock.v1.ScanMergeConfigResultItem.config: object expected");
                            message.config = $root.palexy.streaming.v1.MergingConfig.fromObject(object.config);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScanMergeConfigResultItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @static
                     * @param {palexy.sherlock.v1.ScanMergeConfigResultItem} message ScanMergeConfigResultItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScanMergeConfigResultItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.result = null;
                            object.config = null;
                        }
                        if (message.result != null && message.hasOwnProperty("result"))
                            object.result = $root.palexy.sherlock.v1.MergeAccuracyResult.toObject(message.result, options);
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.MergingConfig.toObject(message.config, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScanMergeConfigResultItem to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ScanMergeConfigResultItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScanMergeConfigResultItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScanMergeConfigResultItem;
                })();
    
                v1.SherlockTaskService = (function() {
    
                    /**
                     * Constructs a new SherlockTaskService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a SherlockTaskService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function SherlockTaskService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (SherlockTaskService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = SherlockTaskService;
    
                    /**
                     * Creates new SherlockTaskService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {SherlockTaskService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    SherlockTaskService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#listTasks}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef ListTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListTasksResponse} [response] ListTasksResponse
                     */
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTasksRequest} request ListTasksRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.ListTasksCallback} callback Node-style callback called with the error, if any, and ListTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.listTasks = function listTasks(request, callback) {
                        return this.rpcCall(listTasks, $root.palexy.sherlock.v1.ListTasksRequest, $root.palexy.sherlock.v1.ListTasksResponse, request, callback);
                    }, "name", { value: "ListTasks" });
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTasksRequest} request ListTasksRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.SherlockTask} [response] SherlockTask
                     */
    
                    /**
                     * Calls CreateTask.
                     * @function createTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTaskRequest} request CreateTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateTaskCallback} callback Node-style callback called with the error, if any, and SherlockTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createTask = function createTask(request, callback) {
                        return this.rpcCall(createTask, $root.palexy.sherlock.v1.CreateTaskRequest, $root.palexy.sherlock.v1.SherlockTask, request, callback);
                    }, "name", { value: "CreateTask" });
    
                    /**
                     * Calls CreateTask.
                     * @function createTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTaskRequest} request CreateTaskRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.SherlockTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#batchCreateTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef BatchCreateTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.BatchCreateTaskResponse} [response] BatchCreateTaskResponse
                     */
    
                    /**
                     * Calls BatchCreateTask.
                     * @function batchCreateTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest} request BatchCreateTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.BatchCreateTaskCallback} callback Node-style callback called with the error, if any, and BatchCreateTaskResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.batchCreateTask = function batchCreateTask(request, callback) {
                        return this.rpcCall(batchCreateTask, $root.palexy.sherlock.v1.BatchCreateTaskRequest, $root.palexy.sherlock.v1.BatchCreateTaskResponse, request, callback);
                    }, "name", { value: "BatchCreateTask" });
    
                    /**
                     * Calls BatchCreateTask.
                     * @function batchCreateTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest} request BatchCreateTaskRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.BatchCreateTaskResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#updateTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef UpdateTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.SherlockTask} [response] SherlockTask
                     */
    
                    /**
                     * Calls UpdateTask.
                     * @function updateTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest} request UpdateTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.UpdateTaskCallback} callback Node-style callback called with the error, if any, and SherlockTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.updateTask = function updateTask(request, callback) {
                        return this.rpcCall(updateTask, $root.palexy.sherlock.v1.UpdateTaskRequest, $root.palexy.sherlock.v1.SherlockTask, request, callback);
                    }, "name", { value: "UpdateTask" });
    
                    /**
                     * Calls UpdateTask.
                     * @function updateTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest} request UpdateTaskRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.SherlockTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#retryTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef RetryTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls RetryTask.
                     * @function retryTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IRetryTaskRequest} request RetryTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.RetryTaskCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.retryTask = function retryTask(request, callback) {
                        return this.rpcCall(retryTask, $root.palexy.sherlock.v1.RetryTaskRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "RetryTask" });
    
                    /**
                     * Calls RetryTask.
                     * @function retryTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IRetryTaskRequest} request RetryTaskRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#getTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef GetTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.SherlockTask} [response] SherlockTask
                     */
    
                    /**
                     * Calls GetTask.
                     * @function getTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetTaskRequest} request GetTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.GetTaskCallback} callback Node-style callback called with the error, if any, and SherlockTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.getTask = function getTask(request, callback) {
                        return this.rpcCall(getTask, $root.palexy.sherlock.v1.GetTaskRequest, $root.palexy.sherlock.v1.SherlockTask, request, callback);
                    }, "name", { value: "GetTask" });
    
                    /**
                     * Calls GetTask.
                     * @function getTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetTaskRequest} request GetTaskRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.SherlockTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#deleteTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef DeleteTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteTask.
                     * @function deleteTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest} request DeleteTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.DeleteTaskCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.deleteTask = function deleteTask(request, callback) {
                        return this.rpcCall(deleteTask, $root.palexy.sherlock.v1.DeleteTaskRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteTask" });
    
                    /**
                     * Calls DeleteTask.
                     * @function deleteTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest} request DeleteTaskRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createDebugTaskForStoreConfig}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateDebugTaskForStoreConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} [response] CreateDebugTaskForStoreConfigResponse
                     */
    
                    /**
                     * Calls CreateDebugTaskForStoreConfig.
                     * @function createDebugTaskForStoreConfig
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest} request CreateDebugTaskForStoreConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateDebugTaskForStoreConfigCallback} callback Node-style callback called with the error, if any, and CreateDebugTaskForStoreConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createDebugTaskForStoreConfig = function createDebugTaskForStoreConfig(request, callback) {
                        return this.rpcCall(createDebugTaskForStoreConfig, $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest, $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse, request, callback);
                    }, "name", { value: "CreateDebugTaskForStoreConfig" });
    
                    /**
                     * Calls CreateDebugTaskForStoreConfig.
                     * @function createDebugTaskForStoreConfig
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest} request CreateDebugTaskForStoreConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createDebugTaskForExperiment}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateDebugTaskForExperimentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} [response] CreateDebugTaskForExperimentResponse
                     */
    
                    /**
                     * Calls CreateDebugTaskForExperiment.
                     * @function createDebugTaskForExperiment
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest} request CreateDebugTaskForExperimentRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateDebugTaskForExperimentCallback} callback Node-style callback called with the error, if any, and CreateDebugTaskForExperimentResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createDebugTaskForExperiment = function createDebugTaskForExperiment(request, callback) {
                        return this.rpcCall(createDebugTaskForExperiment, $root.palexy.sherlock.v1.CreateDebugTaskForExperimentRequest, $root.palexy.sherlock.v1.CreateDebugTaskForExperimentResponse, request, callback);
                    }, "name", { value: "CreateDebugTaskForExperiment" });
    
                    /**
                     * Calls CreateDebugTaskForExperiment.
                     * @function createDebugTaskForExperiment
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest} request CreateDebugTaskForExperimentRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateDebugTaskForExperimentResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createAccuracyTasksForStoreConfig}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateAccuracyTasksForStoreConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} [response] CreateAccuracyTasksForStoreConfigResponse
                     */
    
                    /**
                     * Calls CreateAccuracyTasksForStoreConfig.
                     * @function createAccuracyTasksForStoreConfig
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest} request CreateAccuracyTasksForStoreConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateAccuracyTasksForStoreConfigCallback} callback Node-style callback called with the error, if any, and CreateAccuracyTasksForStoreConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createAccuracyTasksForStoreConfig = function createAccuracyTasksForStoreConfig(request, callback) {
                        return this.rpcCall(createAccuracyTasksForStoreConfig, $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest, $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse, request, callback);
                    }, "name", { value: "CreateAccuracyTasksForStoreConfig" });
    
                    /**
                     * Calls CreateAccuracyTasksForStoreConfig.
                     * @function createAccuracyTasksForStoreConfig
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest} request CreateAccuracyTasksForStoreConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createTasksForConfigItem}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateTasksForConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateTasksForConfigItemResponse} [response] CreateTasksForConfigItemResponse
                     */
    
                    /**
                     * Calls CreateTasksForConfigItem.
                     * @function createTasksForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest} request CreateTasksForConfigItemRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateTasksForConfigItemCallback} callback Node-style callback called with the error, if any, and CreateTasksForConfigItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createTasksForConfigItem = function createTasksForConfigItem(request, callback) {
                        return this.rpcCall(createTasksForConfigItem, $root.palexy.sherlock.v1.CreateTasksForConfigItemRequest, $root.palexy.sherlock.v1.CreateTasksForConfigItemResponse, request, callback);
                    }, "name", { value: "CreateTasksForConfigItem" });
    
                    /**
                     * Calls CreateTasksForConfigItem.
                     * @function createTasksForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest} request CreateTasksForConfigItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateTasksForConfigItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createScanningTaskForConfigItem}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateScanningTaskForConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} [response] CreateScanningTaskForConfigItemResponse
                     */
    
                    /**
                     * Calls CreateScanningTaskForConfigItem.
                     * @function createScanningTaskForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest} request CreateScanningTaskForConfigItemRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateScanningTaskForConfigItemCallback} callback Node-style callback called with the error, if any, and CreateScanningTaskForConfigItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createScanningTaskForConfigItem = function createScanningTaskForConfigItem(request, callback) {
                        return this.rpcCall(createScanningTaskForConfigItem, $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest, $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse, request, callback);
                    }, "name", { value: "CreateScanningTaskForConfigItem" });
    
                    /**
                     * Calls CreateScanningTaskForConfigItem.
                     * @function createScanningTaskForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest} request CreateScanningTaskForConfigItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createRerunningTaskForConfigItem}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreateRerunningTaskForConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} [response] CreateRerunningTaskForConfigItemResponse
                     */
    
                    /**
                     * Calls CreateRerunningTaskForConfigItem.
                     * @function createRerunningTaskForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest} request CreateRerunningTaskForConfigItemRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreateRerunningTaskForConfigItemCallback} callback Node-style callback called with the error, if any, and CreateRerunningTaskForConfigItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createRerunningTaskForConfigItem = function createRerunningTaskForConfigItem(request, callback) {
                        return this.rpcCall(createRerunningTaskForConfigItem, $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest, $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse, request, callback);
                    }, "name", { value: "CreateRerunningTaskForConfigItem" });
    
                    /**
                     * Calls CreateRerunningTaskForConfigItem.
                     * @function createRerunningTaskForConfigItem
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest} request CreateRerunningTaskForConfigItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskService#createPrepareQcVideosTask}.
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @typedef CreatePrepareQcVideosTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} [response] CreatePrepareQcVideosTaskResponse
                     */
    
                    /**
                     * Calls CreatePrepareQcVideosTask.
                     * @function createPrepareQcVideosTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest} request CreatePrepareQcVideosTaskRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskService.CreatePrepareQcVideosTaskCallback} callback Node-style callback called with the error, if any, and CreatePrepareQcVideosTaskResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskService.prototype.createPrepareQcVideosTask = function createPrepareQcVideosTask(request, callback) {
                        return this.rpcCall(createPrepareQcVideosTask, $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest, $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse, request, callback);
                    }, "name", { value: "CreatePrepareQcVideosTask" });
    
                    /**
                     * Calls CreatePrepareQcVideosTask.
                     * @function createPrepareQcVideosTask
                     * @memberof palexy.sherlock.v1.SherlockTaskService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest} request CreatePrepareQcVideosTaskRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse>} Promise
                     * @variation 2
                     */
    
                    return SherlockTaskService;
                })();
    
                v1.SherlockTaskResultService = (function() {
    
                    /**
                     * Constructs a new SherlockTaskResultService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a SherlockTaskResultService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function SherlockTaskResultService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (SherlockTaskResultService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = SherlockTaskResultService;
    
                    /**
                     * Creates new SherlockTaskResultService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {SherlockTaskResultService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    SherlockTaskResultService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskResultService#listTaskResults}.
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @typedef ListTaskResultsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListTaskResultsResponse} [response] ListTaskResultsResponse
                     */
    
                    /**
                     * Calls ListTaskResults.
                     * @function listTaskResults
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest} request ListTaskResultsRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskResultService.ListTaskResultsCallback} callback Node-style callback called with the error, if any, and ListTaskResultsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskResultService.prototype.listTaskResults = function listTaskResults(request, callback) {
                        return this.rpcCall(listTaskResults, $root.palexy.sherlock.v1.ListTaskResultsRequest, $root.palexy.sherlock.v1.ListTaskResultsResponse, request, callback);
                    }, "name", { value: "ListTaskResults" });
    
                    /**
                     * Calls ListTaskResults.
                     * @function listTaskResults
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest} request ListTaskResultsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListTaskResultsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskResultService#createTaskResult}.
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @typedef CreateTaskResultCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.SherlockTaskResult} [response] SherlockTaskResult
                     */
    
                    /**
                     * Calls CreateTaskResult.
                     * @function createTaskResult
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest} request CreateTaskResultRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskResultService.CreateTaskResultCallback} callback Node-style callback called with the error, if any, and SherlockTaskResult
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskResultService.prototype.createTaskResult = function createTaskResult(request, callback) {
                        return this.rpcCall(createTaskResult, $root.palexy.sherlock.v1.CreateTaskResultRequest, $root.palexy.sherlock.v1.SherlockTaskResult, request, callback);
                    }, "name", { value: "CreateTaskResult" });
    
                    /**
                     * Calls CreateTaskResult.
                     * @function createTaskResult
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest} request CreateTaskResultRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.SherlockTaskResult>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.SherlockTaskResultService#updateHumanLabelLink}.
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @typedef UpdateHumanLabelLinkCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.SherlockTaskResult} [response] SherlockTaskResult
                     */
    
                    /**
                     * Calls UpdateHumanLabelLink.
                     * @function updateHumanLabelLink
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest} request UpdateHumanLabelLinkRequest message or plain object
                     * @param {palexy.sherlock.v1.SherlockTaskResultService.UpdateHumanLabelLinkCallback} callback Node-style callback called with the error, if any, and SherlockTaskResult
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(SherlockTaskResultService.prototype.updateHumanLabelLink = function updateHumanLabelLink(request, callback) {
                        return this.rpcCall(updateHumanLabelLink, $root.palexy.sherlock.v1.UpdateHumanLabelLinkRequest, $root.palexy.sherlock.v1.SherlockTaskResult, request, callback);
                    }, "name", { value: "UpdateHumanLabelLink" });
    
                    /**
                     * Calls UpdateHumanLabelLink.
                     * @function updateHumanLabelLink
                     * @memberof palexy.sherlock.v1.SherlockTaskResultService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest} request UpdateHumanLabelLinkRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.SherlockTaskResult>} Promise
                     * @variation 2
                     */
    
                    return SherlockTaskResultService;
                })();
    
                v1.ListTaskResultsRequest = (function() {
    
                    /**
                     * Properties of a ListTaskResultsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTaskResultsRequest
                     * @property {string|null} [task] ListTaskResultsRequest task
                     */
    
                    /**
                     * Constructs a new ListTaskResultsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTaskResultsRequest.
                     * @implements IListTaskResultsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest=} [properties] Properties to set
                     */
                    function ListTaskResultsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskResultsRequest task.
                     * @member {string} task
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @instance
                     */
                    ListTaskResultsRequest.prototype.task = "";
    
                    /**
                     * Creates a new ListTaskResultsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTaskResultsRequest} ListTaskResultsRequest instance
                     */
                    ListTaskResultsRequest.create = function create(properties) {
                        return new ListTaskResultsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskResultsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListTaskResultsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest} message ListTaskResultsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskResultsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.task);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskResultsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTaskResultsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsRequest} message ListTaskResultsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskResultsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskResultsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTaskResultsRequest} ListTaskResultsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskResultsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTaskResultsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskResultsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTaskResultsRequest} ListTaskResultsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskResultsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskResultsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskResultsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task"))
                            if (!$util.isString(message.task))
                                return "task: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskResultsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTaskResultsRequest} ListTaskResultsRequest
                     */
                    ListTaskResultsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTaskResultsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTaskResultsRequest();
                        if (object.task != null)
                            message.task = String(object.task);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskResultsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListTaskResultsRequest} message ListTaskResultsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskResultsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.task = "";
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = message.task;
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskResultsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTaskResultsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskResultsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskResultsRequest;
                })();
    
                v1.ListTaskResultsResponse = (function() {
    
                    /**
                     * Properties of a ListTaskResultsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTaskResultsResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTaskResult>|null} [taskResults] ListTaskResultsResponse taskResults
                     */
    
                    /**
                     * Constructs a new ListTaskResultsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTaskResultsResponse.
                     * @implements IListTaskResultsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTaskResultsResponse=} [properties] Properties to set
                     */
                    function ListTaskResultsResponse(properties) {
                        this.taskResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskResultsResponse taskResults.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTaskResult>} taskResults
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @instance
                     */
                    ListTaskResultsResponse.prototype.taskResults = $util.emptyArray;
    
                    /**
                     * Creates a new ListTaskResultsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTaskResultsResponse} ListTaskResultsResponse instance
                     */
                    ListTaskResultsResponse.create = function create(properties) {
                        return new ListTaskResultsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskResultsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListTaskResultsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsResponse} message ListTaskResultsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskResultsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskResults != null && message.taskResults.length)
                            for (var i = 0; i < message.taskResults.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTaskResult.encode(message.taskResults[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskResultsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTaskResultsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTaskResultsResponse} message ListTaskResultsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskResultsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskResultsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTaskResultsResponse} ListTaskResultsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskResultsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTaskResultsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.taskResults && message.taskResults.length))
                                    message.taskResults = [];
                                message.taskResults.push($root.palexy.sherlock.v1.SherlockTaskResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskResultsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTaskResultsResponse} ListTaskResultsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskResultsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskResultsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskResultsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskResults != null && message.hasOwnProperty("taskResults")) {
                            if (!Array.isArray(message.taskResults))
                                return "taskResults: array expected";
                            for (var i = 0; i < message.taskResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTaskResult.verify(message.taskResults[i]);
                                if (error)
                                    return "taskResults." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskResultsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTaskResultsResponse} ListTaskResultsResponse
                     */
                    ListTaskResultsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTaskResultsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTaskResultsResponse();
                        if (object.taskResults) {
                            if (!Array.isArray(object.taskResults))
                                throw TypeError(".palexy.sherlock.v1.ListTaskResultsResponse.taskResults: array expected");
                            message.taskResults = [];
                            for (var i = 0; i < object.taskResults.length; ++i) {
                                if (typeof object.taskResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListTaskResultsResponse.taskResults: object expected");
                                message.taskResults[i] = $root.palexy.sherlock.v1.SherlockTaskResult.fromObject(object.taskResults[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskResultsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListTaskResultsResponse} message ListTaskResultsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskResultsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskResults = [];
                        if (message.taskResults && message.taskResults.length) {
                            object.taskResults = [];
                            for (var j = 0; j < message.taskResults.length; ++j)
                                object.taskResults[j] = $root.palexy.sherlock.v1.SherlockTaskResult.toObject(message.taskResults[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskResultsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTaskResultsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskResultsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskResultsResponse;
                })();
    
                v1.CreateTaskResultRequest = (function() {
    
                    /**
                     * Properties of a CreateTaskResultRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTaskResultRequest
                     * @property {string|null} [parent] CreateTaskResultRequest parent
                     * @property {palexy.sherlock.v1.ISherlockTaskResult|null} [taskResult] CreateTaskResultRequest taskResult
                     */
    
                    /**
                     * Constructs a new CreateTaskResultRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTaskResultRequest.
                     * @implements ICreateTaskResultRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest=} [properties] Properties to set
                     */
                    function CreateTaskResultRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTaskResultRequest parent.
                     * @member {string} parent
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @instance
                     */
                    CreateTaskResultRequest.prototype.parent = "";
    
                    /**
                     * CreateTaskResultRequest taskResult.
                     * @member {palexy.sherlock.v1.ISherlockTaskResult|null|undefined} taskResult
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @instance
                     */
                    CreateTaskResultRequest.prototype.taskResult = null;
    
                    /**
                     * Creates a new CreateTaskResultRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTaskResultRequest} CreateTaskResultRequest instance
                     */
                    CreateTaskResultRequest.create = function create(properties) {
                        return new CreateTaskResultRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTaskResultRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateTaskResultRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest} message CreateTaskResultRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskResultRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                        if (message.taskResult != null && Object.hasOwnProperty.call(message, "taskResult"))
                            $root.palexy.sherlock.v1.SherlockTaskResult.encode(message.taskResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTaskResultRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTaskResultRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskResultRequest} message CreateTaskResultRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskResultRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTaskResultRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTaskResultRequest} CreateTaskResultRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskResultRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTaskResultRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.parent = reader.string();
                                break;
                            case 2:
                                message.taskResult = $root.palexy.sherlock.v1.SherlockTaskResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTaskResultRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTaskResultRequest} CreateTaskResultRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskResultRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTaskResultRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTaskResultRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            if (!$util.isString(message.parent))
                                return "parent: string expected";
                        if (message.taskResult != null && message.hasOwnProperty("taskResult")) {
                            var error = $root.palexy.sherlock.v1.SherlockTaskResult.verify(message.taskResult);
                            if (error)
                                return "taskResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTaskResultRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTaskResultRequest} CreateTaskResultRequest
                     */
                    CreateTaskResultRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTaskResultRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTaskResultRequest();
                        if (object.parent != null)
                            message.parent = String(object.parent);
                        if (object.taskResult != null) {
                            if (typeof object.taskResult !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateTaskResultRequest.taskResult: object expected");
                            message.taskResult = $root.palexy.sherlock.v1.SherlockTaskResult.fromObject(object.taskResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTaskResultRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateTaskResultRequest} message CreateTaskResultRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTaskResultRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.parent = "";
                            object.taskResult = null;
                        }
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            object.parent = message.parent;
                        if (message.taskResult != null && message.hasOwnProperty("taskResult"))
                            object.taskResult = $root.palexy.sherlock.v1.SherlockTaskResult.toObject(message.taskResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTaskResultRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTaskResultRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTaskResultRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTaskResultRequest;
                })();
    
                v1.CreateTaskRequest = (function() {
    
                    /**
                     * Properties of a CreateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTaskRequest
                     * @property {palexy.sherlock.v1.ISherlockTask|null} [sherlockTask] CreateTaskRequest sherlockTask
                     */
    
                    /**
                     * Constructs a new CreateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTaskRequest.
                     * @implements ICreateTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTaskRequest=} [properties] Properties to set
                     */
                    function CreateTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTaskRequest sherlockTask.
                     * @member {palexy.sherlock.v1.ISherlockTask|null|undefined} sherlockTask
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @instance
                     */
                    CreateTaskRequest.prototype.sherlockTask = null;
    
                    /**
                     * Creates a new CreateTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTaskRequest} CreateTaskRequest instance
                     */
                    CreateTaskRequest.create = function create(properties) {
                        return new CreateTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskRequest} message CreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sherlockTask != null && Object.hasOwnProperty.call(message, "sherlockTask"))
                            $root.palexy.sherlock.v1.SherlockTask.encode(message.sherlockTask, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTaskRequest} message CreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTaskRequest} CreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sherlockTask = $root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTaskRequest} CreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sherlockTask != null && message.hasOwnProperty("sherlockTask")) {
                            var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.sherlockTask);
                            if (error)
                                return "sherlockTask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTaskRequest} CreateTaskRequest
                     */
                    CreateTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTaskRequest();
                        if (object.sherlockTask != null) {
                            if (typeof object.sherlockTask !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateTaskRequest.sherlockTask: object expected");
                            message.sherlockTask = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.sherlockTask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateTaskRequest} message CreateTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.sherlockTask = null;
                        if (message.sherlockTask != null && message.hasOwnProperty("sherlockTask"))
                            object.sherlockTask = $root.palexy.sherlock.v1.SherlockTask.toObject(message.sherlockTask, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTaskRequest;
                })();
    
                v1.BatchCreateTaskRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateTaskRequest
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [sherlockTasks] BatchCreateTaskRequest sherlockTasks
                     */
    
                    /**
                     * Constructs a new BatchCreateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateTaskRequest.
                     * @implements IBatchCreateTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest=} [properties] Properties to set
                     */
                    function BatchCreateTaskRequest(properties) {
                        this.sherlockTasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateTaskRequest sherlockTasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} sherlockTasks
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @instance
                     */
                    BatchCreateTaskRequest.prototype.sherlockTasks = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateTaskRequest} BatchCreateTaskRequest instance
                     */
                    BatchCreateTaskRequest.create = function create(properties) {
                        return new BatchCreateTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest} message BatchCreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sherlockTasks != null && message.sherlockTasks.length)
                            for (var i = 0; i < message.sherlockTasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.sherlockTasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskRequest} message BatchCreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateTaskRequest} BatchCreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sherlockTasks && message.sherlockTasks.length))
                                    message.sherlockTasks = [];
                                message.sherlockTasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateTaskRequest} BatchCreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sherlockTasks != null && message.hasOwnProperty("sherlockTasks")) {
                            if (!Array.isArray(message.sherlockTasks))
                                return "sherlockTasks: array expected";
                            for (var i = 0; i < message.sherlockTasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.sherlockTasks[i]);
                                if (error)
                                    return "sherlockTasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateTaskRequest} BatchCreateTaskRequest
                     */
                    BatchCreateTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateTaskRequest();
                        if (object.sherlockTasks) {
                            if (!Array.isArray(object.sherlockTasks))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateTaskRequest.sherlockTasks: array expected");
                            message.sherlockTasks = [];
                            for (var i = 0; i < object.sherlockTasks.length; ++i) {
                                if (typeof object.sherlockTasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCreateTaskRequest.sherlockTasks: object expected");
                                message.sherlockTasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.sherlockTasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateTaskRequest} message BatchCreateTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sherlockTasks = [];
                        if (message.sherlockTasks && message.sherlockTasks.length) {
                            object.sherlockTasks = [];
                            for (var j = 0; j < message.sherlockTasks.length; ++j)
                                object.sherlockTasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.sherlockTasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateTaskRequest;
                })();
    
                v1.BatchCreateTaskResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateTaskResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateTaskResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [sherlockTask] BatchCreateTaskResponse sherlockTask
                     */
    
                    /**
                     * Constructs a new BatchCreateTaskResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateTaskResponse.
                     * @implements IBatchCreateTaskResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateTaskResponse=} [properties] Properties to set
                     */
                    function BatchCreateTaskResponse(properties) {
                        this.sherlockTask = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateTaskResponse sherlockTask.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} sherlockTask
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @instance
                     */
                    BatchCreateTaskResponse.prototype.sherlockTask = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateTaskResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateTaskResponse} BatchCreateTaskResponse instance
                     */
                    BatchCreateTaskResponse.create = function create(properties) {
                        return new BatchCreateTaskResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateTaskResponse message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTaskResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskResponse} message BatchCreateTaskResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTaskResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sherlockTask != null && message.sherlockTask.length)
                            for (var i = 0; i < message.sherlockTask.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.sherlockTask[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateTaskResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTaskResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTaskResponse} message BatchCreateTaskResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTaskResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateTaskResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateTaskResponse} BatchCreateTaskResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTaskResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateTaskResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sherlockTask && message.sherlockTask.length))
                                    message.sherlockTask = [];
                                message.sherlockTask.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateTaskResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateTaskResponse} BatchCreateTaskResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTaskResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateTaskResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateTaskResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sherlockTask != null && message.hasOwnProperty("sherlockTask")) {
                            if (!Array.isArray(message.sherlockTask))
                                return "sherlockTask: array expected";
                            for (var i = 0; i < message.sherlockTask.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.sherlockTask[i]);
                                if (error)
                                    return "sherlockTask." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateTaskResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateTaskResponse} BatchCreateTaskResponse
                     */
                    BatchCreateTaskResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateTaskResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateTaskResponse();
                        if (object.sherlockTask) {
                            if (!Array.isArray(object.sherlockTask))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateTaskResponse.sherlockTask: array expected");
                            message.sherlockTask = [];
                            for (var i = 0; i < object.sherlockTask.length; ++i) {
                                if (typeof object.sherlockTask[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCreateTaskResponse.sherlockTask: object expected");
                                message.sherlockTask[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.sherlockTask[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateTaskResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateTaskResponse} message BatchCreateTaskResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateTaskResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sherlockTask = [];
                        if (message.sherlockTask && message.sherlockTask.length) {
                            object.sherlockTask = [];
                            for (var j = 0; j < message.sherlockTask.length; ++j)
                                object.sherlockTask[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.sherlockTask[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateTaskResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateTaskResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateTaskResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateTaskResponse;
                })();
    
                v1.ListTasksRequest = (function() {
    
                    /**
                     * Properties of a ListTasksRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTasksRequest
                     * @property {palexy.sherlock.v1.ITaskFilter|null} [taskFilter] ListTasksRequest taskFilter
                     * @property {boolean|null} [includeTaskResults] ListTasksRequest includeTaskResults
                     * @property {number|null} [pageSize] ListTasksRequest pageSize
                     * @property {number|null} [pageIndex] ListTasksRequest pageIndex
                     */
    
                    /**
                     * Constructs a new ListTasksRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTasksRequest.
                     * @implements IListTasksRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTasksRequest=} [properties] Properties to set
                     */
                    function ListTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTasksRequest taskFilter.
                     * @member {palexy.sherlock.v1.ITaskFilter|null|undefined} taskFilter
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.taskFilter = null;
    
                    /**
                     * ListTasksRequest includeTaskResults.
                     * @member {boolean} includeTaskResults
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.includeTaskResults = false;
    
                    /**
                     * ListTasksRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.pageSize = 0;
    
                    /**
                     * ListTasksRequest pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.pageIndex = 0;
    
                    /**
                     * Creates a new ListTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTasksRequest} ListTasksRequest instance
                     */
                    ListTasksRequest.create = function create(properties) {
                        return new ListTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTasksRequest message. Does not implicitly {@link palexy.sherlock.v1.ListTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksRequest} message ListTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskFilter != null && Object.hasOwnProperty.call(message, "taskFilter"))
                            $root.palexy.sherlock.v1.TaskFilter.encode(message.taskFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.includeTaskResults != null && Object.hasOwnProperty.call(message, "includeTaskResults"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeTaskResults);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTasksRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksRequest} message ListTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTasksRequest} ListTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskFilter = $root.palexy.sherlock.v1.TaskFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.includeTaskResults = reader.bool();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTasksRequest} ListTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTasksRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskFilter != null && message.hasOwnProperty("taskFilter")) {
                            var error = $root.palexy.sherlock.v1.TaskFilter.verify(message.taskFilter);
                            if (error)
                                return "taskFilter." + error;
                        }
                        if (message.includeTaskResults != null && message.hasOwnProperty("includeTaskResults"))
                            if (typeof message.includeTaskResults !== "boolean")
                                return "includeTaskResults: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTasksRequest} ListTasksRequest
                     */
                    ListTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTasksRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTasksRequest();
                        if (object.taskFilter != null) {
                            if (typeof object.taskFilter !== "object")
                                throw TypeError(".palexy.sherlock.v1.ListTasksRequest.taskFilter: object expected");
                            message.taskFilter = $root.palexy.sherlock.v1.TaskFilter.fromObject(object.taskFilter);
                        }
                        if (object.includeTaskResults != null)
                            message.includeTaskResults = Boolean(object.includeTaskResults);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListTasksRequest} message ListTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.taskFilter = null;
                            object.includeTaskResults = false;
                            object.pageSize = 0;
                            object.pageIndex = 0;
                        }
                        if (message.taskFilter != null && message.hasOwnProperty("taskFilter"))
                            object.taskFilter = $root.palexy.sherlock.v1.TaskFilter.toObject(message.taskFilter, options);
                        if (message.includeTaskResults != null && message.hasOwnProperty("includeTaskResults"))
                            object.includeTaskResults = message.includeTaskResults;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        return object;
                    };
    
                    /**
                     * Converts this ListTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTasksRequest;
                })();
    
                v1.TaskFilter = (function() {
    
                    /**
                     * Properties of a TaskFilter.
                     * @memberof palexy.sherlock.v1
                     * @interface ITaskFilter
                     * @property {palexy.sherlock.v1.SherlockTask.TaskStatus|null} [taskStatus] TaskFilter taskStatus
                     * @property {number|null} [storeConfigId] TaskFilter storeConfigId
                     * @property {palexy.sherlock.v1.SherlockTask.TaskType|null} [taskType] TaskFilter taskType
                     */
    
                    /**
                     * Constructs a new TaskFilter.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a TaskFilter.
                     * @implements ITaskFilter
                     * @constructor
                     * @param {palexy.sherlock.v1.ITaskFilter=} [properties] Properties to set
                     */
                    function TaskFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskFilter taskStatus.
                     * @member {palexy.sherlock.v1.SherlockTask.TaskStatus} taskStatus
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.taskStatus = 0;
    
                    /**
                     * TaskFilter storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter taskType.
                     * @member {palexy.sherlock.v1.SherlockTask.TaskType} taskType
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.taskType = 0;
    
                    /**
                     * Creates a new TaskFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {palexy.sherlock.v1.ITaskFilter=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.TaskFilter} TaskFilter instance
                     */
                    TaskFilter.create = function create(properties) {
                        return new TaskFilter(properties);
                    };
    
                    /**
                     * Encodes the specified TaskFilter message. Does not implicitly {@link palexy.sherlock.v1.TaskFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {palexy.sherlock.v1.ITaskFilter} message TaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskStatus != null && Object.hasOwnProperty.call(message, "taskStatus"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.taskStatus);
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeConfigId);
                        if (message.taskType != null && Object.hasOwnProperty.call(message, "taskType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.taskType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskFilter message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TaskFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {palexy.sherlock.v1.ITaskFilter} message TaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.TaskFilter} TaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TaskFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskStatus = reader.int32();
                                break;
                            case 2:
                                message.storeConfigId = reader.int64();
                                break;
                            case 3:
                                message.taskType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.TaskFilter} TaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskFilter message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskStatus != null && message.hasOwnProperty("taskStatus"))
                            switch (message.taskStatus) {
                            default:
                                return "taskStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            switch (message.taskType) {
                            default:
                                return "taskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a TaskFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.TaskFilter} TaskFilter
                     */
                    TaskFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.TaskFilter)
                            return object;
                        var message = new $root.palexy.sherlock.v1.TaskFilter();
                        switch (object.taskStatus) {
                        case "STATUS_UNKNOWN":
                        case 0:
                            message.taskStatus = 0;
                            break;
                        case "STATUS_CREATED":
                        case 1:
                            message.taskStatus = 1;
                            break;
                        case "STATUS_DONE":
                        case 2:
                            message.taskStatus = 2;
                            break;
                        case "STATUS_FAILED":
                        case 3:
                            message.taskStatus = 3;
                            break;
                        }
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        switch (object.taskType) {
                        case "TYPE_UNKNOWN":
                        case 0:
                            message.taskType = 0;
                            break;
                        case "TYPE_TEST":
                        case 1:
                            message.taskType = 1;
                            break;
                        case "TYPE_DEBUG_PERSON":
                        case 2:
                            message.taskType = 2;
                            break;
                        case "TYPE_EXTRACT_TRACKLET":
                        case 3:
                            message.taskType = 3;
                            break;
                        case "TYPE_DELETE_TASK_FILES":
                        case 4:
                            message.taskType = 4;
                            break;
                        case "TYPE_CALCULATE_MERGE_ACCURACY":
                        case 5:
                            message.taskType = 5;
                            break;
                        case "TYPE_EXECUTE_POST_MERGE_CONFIG":
                        case 6:
                            message.taskType = 6;
                            break;
                        case "TYPE_SCAN_MERGE_CONFIG":
                        case 7:
                            message.taskType = 7;
                            break;
                        case "TYPE_RERUN_MERGE_CONFIG":
                        case 8:
                            message.taskType = 8;
                            break;
                        case "TYPE_DEBUG_EXPERIMENT":
                        case 9:
                            message.taskType = 9;
                            break;
                        case "TYPE_PREPARE_QC_VIDEOS":
                        case 10:
                            message.taskType = 10;
                            break;
                        case "TYPE_HS_COLLECT_REID":
                        case 11:
                            message.taskType = 11;
                            break;
                        case "TYPE_TINKER_POST_PROCESS":
                        case 12:
                            message.taskType = 12;
                            break;
                        case "TYPE_FORECAST_GENERATE":
                        case 13:
                            message.taskType = 13;
                            break;
                        case "TYPE_EXPORT_HAKUHODO":
                        case 14:
                            message.taskType = 14;
                            break;
                        case "TYPE_EXPORT_OSOOL_EVENTS":
                        case 15:
                            message.taskType = 15;
                            break;
                        case "TYPE_HAKUHODO_JOIN_PARTIAL_MERGING_RESULTS":
                        case 16:
                            message.taskType = 16;
                            break;
                        case "TYPE_HAKUHODO_EDIT_TRAFFIC":
                        case 17:
                            message.taskType = 17;
                            break;
                        case "TYPE_HAKUHODO_EXTRAPOLATE_DEMOGRAPHY":
                        case 18:
                            message.taskType = 18;
                            break;
                        case "TYPE_BATCH_DELETE_VIDEOS":
                        case 19:
                            message.taskType = 19;
                            break;
                        case "TYPE_BUILD_SEED":
                        case 20:
                            message.taskType = 20;
                            break;
                        case "TYPE_FINE_TUNE_HAKUHODO_STORE":
                        case 21:
                            message.taskType = 21;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @static
                     * @param {palexy.sherlock.v1.TaskFilter} message TaskFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.taskStatus = options.enums === String ? "STATUS_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                            object.taskType = options.enums === String ? "TYPE_UNKNOWN" : 0;
                        }
                        if (message.taskStatus != null && message.hasOwnProperty("taskStatus"))
                            object.taskStatus = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.TaskStatus[message.taskStatus] : message.taskStatus;
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            object.taskType = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.TaskType[message.taskType] : message.taskType;
                        return object;
                    };
    
                    /**
                     * Converts this TaskFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.TaskFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskFilter;
                })();
    
                v1.ListTasksResponse = (function() {
    
                    /**
                     * Properties of a ListTasksResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTasksResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [sherlockTasks] ListTasksResponse sherlockTasks
                     * @property {number|null} [pageSize] ListTasksResponse pageSize
                     * @property {number|null} [pageIndex] ListTasksResponse pageIndex
                     * @property {number|null} [totalElements] ListTasksResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListTasksResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTasksResponse.
                     * @implements IListTasksResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTasksResponse=} [properties] Properties to set
                     */
                    function ListTasksResponse(properties) {
                        this.sherlockTasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTasksResponse sherlockTasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} sherlockTasks
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.sherlockTasks = $util.emptyArray;
    
                    /**
                     * ListTasksResponse pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.pageSize = 0;
    
                    /**
                     * ListTasksResponse pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.pageIndex = 0;
    
                    /**
                     * ListTasksResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTasksResponse} ListTasksResponse instance
                     */
                    ListTasksResponse.create = function create(properties) {
                        return new ListTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTasksResponse message. Does not implicitly {@link palexy.sherlock.v1.ListTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksResponse} message ListTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sherlockTasks != null && message.sherlockTasks.length)
                            for (var i = 0; i < message.sherlockTasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.sherlockTasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageIndex);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTasksResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTasksResponse} message ListTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTasksResponse} ListTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sherlockTasks && message.sherlockTasks.length))
                                    message.sherlockTasks = [];
                                message.sherlockTasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageIndex = reader.int32();
                                break;
                            case 4:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTasksResponse} ListTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTasksResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sherlockTasks != null && message.hasOwnProperty("sherlockTasks")) {
                            if (!Array.isArray(message.sherlockTasks))
                                return "sherlockTasks: array expected";
                            for (var i = 0; i < message.sherlockTasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.sherlockTasks[i]);
                                if (error)
                                    return "sherlockTasks." + error;
                            }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTasksResponse} ListTasksResponse
                     */
                    ListTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTasksResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTasksResponse();
                        if (object.sherlockTasks) {
                            if (!Array.isArray(object.sherlockTasks))
                                throw TypeError(".palexy.sherlock.v1.ListTasksResponse.sherlockTasks: array expected");
                            message.sherlockTasks = [];
                            for (var i = 0; i < object.sherlockTasks.length; ++i) {
                                if (typeof object.sherlockTasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListTasksResponse.sherlockTasks: object expected");
                                message.sherlockTasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.sherlockTasks[i]);
                            }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListTasksResponse} message ListTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sherlockTasks = [];
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageIndex = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.sherlockTasks && message.sherlockTasks.length) {
                            object.sherlockTasks = [];
                            for (var j = 0; j < message.sherlockTasks.length; ++j)
                                object.sherlockTasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.sherlockTasks[j], options);
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTasksResponse;
                })();
    
                v1.SherlockTaskAndAckId = (function() {
    
                    /**
                     * Properties of a SherlockTaskAndAckId.
                     * @memberof palexy.sherlock.v1
                     * @interface ISherlockTaskAndAckId
                     * @property {palexy.sherlock.v1.ISherlockTask|null} [task] SherlockTaskAndAckId task
                     * @property {string|null} [ackId] SherlockTaskAndAckId ackId
                     */
    
                    /**
                     * Constructs a new SherlockTaskAndAckId.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a SherlockTaskAndAckId.
                     * @implements ISherlockTaskAndAckId
                     * @constructor
                     * @param {palexy.sherlock.v1.ISherlockTaskAndAckId=} [properties] Properties to set
                     */
                    function SherlockTaskAndAckId(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SherlockTaskAndAckId task.
                     * @member {palexy.sherlock.v1.ISherlockTask|null|undefined} task
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @instance
                     */
                    SherlockTaskAndAckId.prototype.task = null;
    
                    /**
                     * SherlockTaskAndAckId ackId.
                     * @member {string} ackId
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @instance
                     */
                    SherlockTaskAndAckId.prototype.ackId = "";
    
                    /**
                     * Creates a new SherlockTaskAndAckId instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskAndAckId=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.SherlockTaskAndAckId} SherlockTaskAndAckId instance
                     */
                    SherlockTaskAndAckId.create = function create(properties) {
                        return new SherlockTaskAndAckId(properties);
                    };
    
                    /**
                     * Encodes the specified SherlockTaskAndAckId message. Does not implicitly {@link palexy.sherlock.v1.SherlockTaskAndAckId.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskAndAckId} message SherlockTaskAndAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTaskAndAckId.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            $root.palexy.sherlock.v1.SherlockTask.encode(message.task, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.ackId != null && Object.hasOwnProperty.call(message, "ackId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ackId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SherlockTaskAndAckId message, length delimited. Does not implicitly {@link palexy.sherlock.v1.SherlockTaskAndAckId.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {palexy.sherlock.v1.ISherlockTaskAndAckId} message SherlockTaskAndAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SherlockTaskAndAckId.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SherlockTaskAndAckId message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.SherlockTaskAndAckId} SherlockTaskAndAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTaskAndAckId.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.SherlockTaskAndAckId();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = $root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.ackId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SherlockTaskAndAckId message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.SherlockTaskAndAckId} SherlockTaskAndAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SherlockTaskAndAckId.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SherlockTaskAndAckId message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SherlockTaskAndAckId.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task")) {
                            var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.task);
                            if (error)
                                return "task." + error;
                        }
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            if (!$util.isString(message.ackId))
                                return "ackId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SherlockTaskAndAckId message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.SherlockTaskAndAckId} SherlockTaskAndAckId
                     */
                    SherlockTaskAndAckId.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.SherlockTaskAndAckId)
                            return object;
                        var message = new $root.palexy.sherlock.v1.SherlockTaskAndAckId();
                        if (object.task != null) {
                            if (typeof object.task !== "object")
                                throw TypeError(".palexy.sherlock.v1.SherlockTaskAndAckId.task: object expected");
                            message.task = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.task);
                        }
                        if (object.ackId != null)
                            message.ackId = String(object.ackId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SherlockTaskAndAckId message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @static
                     * @param {palexy.sherlock.v1.SherlockTaskAndAckId} message SherlockTaskAndAckId
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SherlockTaskAndAckId.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.task = null;
                            object.ackId = "";
                        }
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = $root.palexy.sherlock.v1.SherlockTask.toObject(message.task, options);
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            object.ackId = message.ackId;
                        return object;
                    };
    
                    /**
                     * Converts this SherlockTaskAndAckId to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.SherlockTaskAndAckId
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SherlockTaskAndAckId.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SherlockTaskAndAckId;
                })();
    
                v1.UpdateTaskRequest = (function() {
    
                    /**
                     * Properties of an UpdateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateTaskRequest
                     * @property {palexy.sherlock.v1.ISherlockTask|null} [task] UpdateTaskRequest task
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateTaskRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateTaskRequest.
                     * @implements IUpdateTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest=} [properties] Properties to set
                     */
                    function UpdateTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateTaskRequest task.
                     * @member {palexy.sherlock.v1.ISherlockTask|null|undefined} task
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @instance
                     */
                    UpdateTaskRequest.prototype.task = null;
    
                    /**
                     * UpdateTaskRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @instance
                     */
                    UpdateTaskRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateTaskRequest} UpdateTaskRequest instance
                     */
                    UpdateTaskRequest.create = function create(properties) {
                        return new UpdateTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest} message UpdateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            $root.palexy.sherlock.v1.SherlockTask.encode(message.task, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateTaskRequest} message UpdateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateTaskRequest} UpdateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = $root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateTaskRequest} UpdateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task")) {
                            var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.task);
                            if (error)
                                return "task." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateTaskRequest} UpdateTaskRequest
                     */
                    UpdateTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateTaskRequest();
                        if (object.task != null) {
                            if (typeof object.task !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateTaskRequest.task: object expected");
                            message.task = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.task);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateTaskRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateTaskRequest} message UpdateTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.task = null;
                            object.updateMask = null;
                        }
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = $root.palexy.sherlock.v1.SherlockTask.toObject(message.task, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateTaskRequest;
                })();
    
                v1.GetTaskRequest = (function() {
    
                    /**
                     * Properties of a GetTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IGetTaskRequest
                     * @property {string|null} [name] GetTaskRequest name
                     */
    
                    /**
                     * Constructs a new GetTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GetTaskRequest.
                     * @implements IGetTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IGetTaskRequest=} [properties] Properties to set
                     */
                    function GetTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTaskRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @instance
                     */
                    GetTaskRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GetTaskRequest} GetTaskRequest instance
                     */
                    GetTaskRequest.create = function create(properties) {
                        return new GetTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.GetTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetTaskRequest} message GetTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GetTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetTaskRequest} message GetTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GetTaskRequest} GetTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GetTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GetTaskRequest} GetTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GetTaskRequest} GetTaskRequest
                     */
                    GetTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GetTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GetTaskRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.GetTaskRequest} message GetTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GetTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTaskRequest;
                })();
    
                v1.DeleteTaskRequest = (function() {
    
                    /**
                     * Properties of a DeleteTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteTaskRequest
                     * @property {string|null} [name] DeleteTaskRequest name
                     */
    
                    /**
                     * Constructs a new DeleteTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteTaskRequest.
                     * @implements IDeleteTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest=} [properties] Properties to set
                     */
                    function DeleteTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTaskRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @instance
                     */
                    DeleteTaskRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteTaskRequest} DeleteTaskRequest instance
                     */
                    DeleteTaskRequest.create = function create(properties) {
                        return new DeleteTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.DeleteTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest} message DeleteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteTaskRequest} message DeleteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteTaskRequest} DeleteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteTaskRequest} DeleteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteTaskRequest} DeleteTaskRequest
                     */
                    DeleteTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DeleteTaskRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.DeleteTaskRequest} message DeleteTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTaskRequest;
                })();
    
                v1.CreateDebugTaskForStoreConfigResponse = (function() {
    
                    /**
                     * Properties of a CreateDebugTaskForStoreConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateDebugTaskForStoreConfigResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateDebugTaskForStoreConfigResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateDebugTaskForStoreConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateDebugTaskForStoreConfigResponse.
                     * @implements ICreateDebugTaskForStoreConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigResponse=} [properties] Properties to set
                     */
                    function CreateDebugTaskForStoreConfigResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDebugTaskForStoreConfigResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateDebugTaskForStoreConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} CreateDebugTaskForStoreConfigResponse instance
                     */
                    CreateDebugTaskForStoreConfigResponse.create = function create(properties) {
                        return new CreateDebugTaskForStoreConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForStoreConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigResponse} message CreateDebugTaskForStoreConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForStoreConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForStoreConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigResponse} message CreateDebugTaskForStoreConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForStoreConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForStoreConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} CreateDebugTaskForStoreConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForStoreConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForStoreConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} CreateDebugTaskForStoreConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForStoreConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDebugTaskForStoreConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDebugTaskForStoreConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateDebugTaskForStoreConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} CreateDebugTaskForStoreConfigResponse
                     */
                    CreateDebugTaskForStoreConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDebugTaskForStoreConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse} message CreateDebugTaskForStoreConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDebugTaskForStoreConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateDebugTaskForStoreConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDebugTaskForStoreConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDebugTaskForStoreConfigResponse;
                })();
    
                v1.CreateDebugTaskForExperimentResponse = (function() {
    
                    /**
                     * Properties of a CreateDebugTaskForExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateDebugTaskForExperimentResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateDebugTaskForExperimentResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateDebugTaskForExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateDebugTaskForExperimentResponse.
                     * @implements ICreateDebugTaskForExperimentResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentResponse=} [properties] Properties to set
                     */
                    function CreateDebugTaskForExperimentResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDebugTaskForExperimentResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @instance
                     */
                    CreateDebugTaskForExperimentResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateDebugTaskForExperimentResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} CreateDebugTaskForExperimentResponse instance
                     */
                    CreateDebugTaskForExperimentResponse.create = function create(properties) {
                        return new CreateDebugTaskForExperimentResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForExperimentResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForExperimentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentResponse} message CreateDebugTaskForExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForExperimentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForExperimentResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForExperimentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentResponse} message CreateDebugTaskForExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForExperimentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForExperimentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} CreateDebugTaskForExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForExperimentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateDebugTaskForExperimentResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForExperimentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} CreateDebugTaskForExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForExperimentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDebugTaskForExperimentResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDebugTaskForExperimentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateDebugTaskForExperimentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} CreateDebugTaskForExperimentResponse
                     */
                    CreateDebugTaskForExperimentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateDebugTaskForExperimentResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateDebugTaskForExperimentResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateDebugTaskForExperimentResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateDebugTaskForExperimentResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDebugTaskForExperimentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateDebugTaskForExperimentResponse} message CreateDebugTaskForExperimentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDebugTaskForExperimentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateDebugTaskForExperimentResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDebugTaskForExperimentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDebugTaskForExperimentResponse;
                })();
    
                v1.CreateDebugTaskForStoreConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateDebugTaskForStoreConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateDebugTaskForStoreConfigRequest
                     * @property {number|null} [storeConfigId] CreateDebugTaskForStoreConfigRequest storeConfigId
                     * @property {number|null} [storeId] CreateDebugTaskForStoreConfigRequest storeId
                     * @property {string|null} [dateId] CreateDebugTaskForStoreConfigRequest dateId
                     * @property {number|null} [startHour] CreateDebugTaskForStoreConfigRequest startHour
                     * @property {number|null} [endHour] CreateDebugTaskForStoreConfigRequest endHour
                     * @property {number|null} [maxHoursToSplit] CreateDebugTaskForStoreConfigRequest maxHoursToSplit
                     * @property {boolean|null} [includeFfmpegResults] CreateDebugTaskForStoreConfigRequest includeFfmpegResults
                     * @property {boolean|null} [generateBbLevelDetail] CreateDebugTaskForStoreConfigRequest generateBbLevelDetail
                     */
    
                    /**
                     * Constructs a new CreateDebugTaskForStoreConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateDebugTaskForStoreConfigRequest.
                     * @implements ICreateDebugTaskForStoreConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest=} [properties] Properties to set
                     */
                    function CreateDebugTaskForStoreConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.dateId = "";
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest startHour.
                     * @member {number} startHour
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.startHour = 0;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest endHour.
                     * @member {number} endHour
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.endHour = 0;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest maxHoursToSplit.
                     * @member {number} maxHoursToSplit
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.maxHoursToSplit = 0;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest includeFfmpegResults.
                     * @member {boolean} includeFfmpegResults
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.includeFfmpegResults = false;
    
                    /**
                     * CreateDebugTaskForStoreConfigRequest generateBbLevelDetail.
                     * @member {boolean} generateBbLevelDetail
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.generateBbLevelDetail = false;
    
                    /**
                     * Creates a new CreateDebugTaskForStoreConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest} CreateDebugTaskForStoreConfigRequest instance
                     */
                    CreateDebugTaskForStoreConfigRequest.create = function create(properties) {
                        return new CreateDebugTaskForStoreConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForStoreConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest} message CreateDebugTaskForStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForStoreConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeConfigId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        if (message.startHour != null && Object.hasOwnProperty.call(message, "startHour"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.startHour);
                        if (message.endHour != null && Object.hasOwnProperty.call(message, "endHour"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.endHour);
                        if (message.maxHoursToSplit != null && Object.hasOwnProperty.call(message, "maxHoursToSplit"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxHoursToSplit);
                        if (message.includeFfmpegResults != null && Object.hasOwnProperty.call(message, "includeFfmpegResults"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeFfmpegResults);
                        if (message.generateBbLevelDetail != null && Object.hasOwnProperty.call(message, "generateBbLevelDetail"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.generateBbLevelDetail);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForStoreConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForStoreConfigRequest} message CreateDebugTaskForStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForStoreConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForStoreConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest} CreateDebugTaskForStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForStoreConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfigId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            case 4:
                                message.startHour = reader.int32();
                                break;
                            case 5:
                                message.endHour = reader.int32();
                                break;
                            case 6:
                                message.maxHoursToSplit = reader.int32();
                                break;
                            case 7:
                                message.includeFfmpegResults = reader.bool();
                                break;
                            case 8:
                                message.generateBbLevelDetail = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForStoreConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest} CreateDebugTaskForStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForStoreConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDebugTaskForStoreConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDebugTaskForStoreConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            if (!$util.isInteger(message.startHour))
                                return "startHour: integer expected";
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            if (!$util.isInteger(message.endHour))
                                return "endHour: integer expected";
                        if (message.maxHoursToSplit != null && message.hasOwnProperty("maxHoursToSplit"))
                            if (!$util.isInteger(message.maxHoursToSplit))
                                return "maxHoursToSplit: integer expected";
                        if (message.includeFfmpegResults != null && message.hasOwnProperty("includeFfmpegResults"))
                            if (typeof message.includeFfmpegResults !== "boolean")
                                return "includeFfmpegResults: boolean expected";
                        if (message.generateBbLevelDetail != null && message.hasOwnProperty("generateBbLevelDetail"))
                            if (typeof message.generateBbLevelDetail !== "boolean")
                                return "generateBbLevelDetail: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateDebugTaskForStoreConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest} CreateDebugTaskForStoreConfigRequest
                     */
                    CreateDebugTaskForStoreConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest();
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startHour != null)
                            message.startHour = object.startHour | 0;
                        if (object.endHour != null)
                            message.endHour = object.endHour | 0;
                        if (object.maxHoursToSplit != null)
                            message.maxHoursToSplit = object.maxHoursToSplit | 0;
                        if (object.includeFfmpegResults != null)
                            message.includeFfmpegResults = Boolean(object.includeFfmpegResults);
                        if (object.generateBbLevelDetail != null)
                            message.generateBbLevelDetail = Boolean(object.generateBbLevelDetail);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDebugTaskForStoreConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest} message CreateDebugTaskForStoreConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDebugTaskForStoreConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startHour = 0;
                            object.endHour = 0;
                            object.maxHoursToSplit = 0;
                            object.includeFfmpegResults = false;
                            object.generateBbLevelDetail = false;
                        }
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            object.startHour = message.startHour;
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            object.endHour = message.endHour;
                        if (message.maxHoursToSplit != null && message.hasOwnProperty("maxHoursToSplit"))
                            object.maxHoursToSplit = message.maxHoursToSplit;
                        if (message.includeFfmpegResults != null && message.hasOwnProperty("includeFfmpegResults"))
                            object.includeFfmpegResults = message.includeFfmpegResults;
                        if (message.generateBbLevelDetail != null && message.hasOwnProperty("generateBbLevelDetail"))
                            object.generateBbLevelDetail = message.generateBbLevelDetail;
                        return object;
                    };
    
                    /**
                     * Converts this CreateDebugTaskForStoreConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForStoreConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDebugTaskForStoreConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDebugTaskForStoreConfigRequest;
                })();
    
                v1.CreateDebugTaskForExperimentRequest = (function() {
    
                    /**
                     * Properties of a CreateDebugTaskForExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateDebugTaskForExperimentRequest
                     * @property {number|null} [storeConfigId] CreateDebugTaskForExperimentRequest storeConfigId
                     * @property {number|null} [storeId] CreateDebugTaskForExperimentRequest storeId
                     * @property {string|null} [dateId] CreateDebugTaskForExperimentRequest dateId
                     * @property {number|null} [startHour] CreateDebugTaskForExperimentRequest startHour
                     * @property {number|null} [endHour] CreateDebugTaskForExperimentRequest endHour
                     * @property {number|null} [maxHoursToSplit] CreateDebugTaskForExperimentRequest maxHoursToSplit
                     * @property {string|null} [experimentName] CreateDebugTaskForExperimentRequest experimentName
                     */
    
                    /**
                     * Constructs a new CreateDebugTaskForExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateDebugTaskForExperimentRequest.
                     * @implements ICreateDebugTaskForExperimentRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest=} [properties] Properties to set
                     */
                    function CreateDebugTaskForExperimentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDebugTaskForExperimentRequest storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateDebugTaskForExperimentRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateDebugTaskForExperimentRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.dateId = "";
    
                    /**
                     * CreateDebugTaskForExperimentRequest startHour.
                     * @member {number} startHour
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.startHour = 0;
    
                    /**
                     * CreateDebugTaskForExperimentRequest endHour.
                     * @member {number} endHour
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.endHour = 0;
    
                    /**
                     * CreateDebugTaskForExperimentRequest maxHoursToSplit.
                     * @member {number} maxHoursToSplit
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.maxHoursToSplit = 0;
    
                    /**
                     * CreateDebugTaskForExperimentRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     */
                    CreateDebugTaskForExperimentRequest.prototype.experimentName = "";
    
                    /**
                     * Creates a new CreateDebugTaskForExperimentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentRequest} CreateDebugTaskForExperimentRequest instance
                     */
                    CreateDebugTaskForExperimentRequest.create = function create(properties) {
                        return new CreateDebugTaskForExperimentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForExperimentRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForExperimentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest} message CreateDebugTaskForExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForExperimentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeConfigId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        if (message.startHour != null && Object.hasOwnProperty.call(message, "startHour"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.startHour);
                        if (message.endHour != null && Object.hasOwnProperty.call(message, "endHour"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.endHour);
                        if (message.maxHoursToSplit != null && Object.hasOwnProperty.call(message, "maxHoursToSplit"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxHoursToSplit);
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.experimentName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDebugTaskForExperimentRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateDebugTaskForExperimentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateDebugTaskForExperimentRequest} message CreateDebugTaskForExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDebugTaskForExperimentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForExperimentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentRequest} CreateDebugTaskForExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForExperimentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateDebugTaskForExperimentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfigId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            case 4:
                                message.startHour = reader.int32();
                                break;
                            case 5:
                                message.endHour = reader.int32();
                                break;
                            case 6:
                                message.maxHoursToSplit = reader.int32();
                                break;
                            case 7:
                                message.experimentName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDebugTaskForExperimentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentRequest} CreateDebugTaskForExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDebugTaskForExperimentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDebugTaskForExperimentRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDebugTaskForExperimentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            if (!$util.isInteger(message.startHour))
                                return "startHour: integer expected";
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            if (!$util.isInteger(message.endHour))
                                return "endHour: integer expected";
                        if (message.maxHoursToSplit != null && message.hasOwnProperty("maxHoursToSplit"))
                            if (!$util.isInteger(message.maxHoursToSplit))
                                return "maxHoursToSplit: integer expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateDebugTaskForExperimentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateDebugTaskForExperimentRequest} CreateDebugTaskForExperimentRequest
                     */
                    CreateDebugTaskForExperimentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateDebugTaskForExperimentRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateDebugTaskForExperimentRequest();
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startHour != null)
                            message.startHour = object.startHour | 0;
                        if (object.endHour != null)
                            message.endHour = object.endHour | 0;
                        if (object.maxHoursToSplit != null)
                            message.maxHoursToSplit = object.maxHoursToSplit | 0;
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDebugTaskForExperimentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateDebugTaskForExperimentRequest} message CreateDebugTaskForExperimentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDebugTaskForExperimentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startHour = 0;
                            object.endHour = 0;
                            object.maxHoursToSplit = 0;
                            object.experimentName = "";
                        }
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            object.startHour = message.startHour;
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            object.endHour = message.endHour;
                        if (message.maxHoursToSplit != null && message.hasOwnProperty("maxHoursToSplit"))
                            object.maxHoursToSplit = message.maxHoursToSplit;
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        return object;
                    };
    
                    /**
                     * Converts this CreateDebugTaskForExperimentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateDebugTaskForExperimentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDebugTaskForExperimentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDebugTaskForExperimentRequest;
                })();
    
                v1.UpdateHumanLabelLinkRequest = (function() {
    
                    /**
                     * Properties of an UpdateHumanLabelLinkRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateHumanLabelLinkRequest
                     * @property {string|null} [humanLabelLink] UpdateHumanLabelLinkRequest humanLabelLink
                     * @property {string|null} [taskResult] UpdateHumanLabelLinkRequest taskResult
                     */
    
                    /**
                     * Constructs a new UpdateHumanLabelLinkRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateHumanLabelLinkRequest.
                     * @implements IUpdateHumanLabelLinkRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest=} [properties] Properties to set
                     */
                    function UpdateHumanLabelLinkRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateHumanLabelLinkRequest humanLabelLink.
                     * @member {string} humanLabelLink
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @instance
                     */
                    UpdateHumanLabelLinkRequest.prototype.humanLabelLink = "";
    
                    /**
                     * UpdateHumanLabelLinkRequest taskResult.
                     * @member {string} taskResult
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @instance
                     */
                    UpdateHumanLabelLinkRequest.prototype.taskResult = "";
    
                    /**
                     * Creates a new UpdateHumanLabelLinkRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateHumanLabelLinkRequest} UpdateHumanLabelLinkRequest instance
                     */
                    UpdateHumanLabelLinkRequest.create = function create(properties) {
                        return new UpdateHumanLabelLinkRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateHumanLabelLinkRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateHumanLabelLinkRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest} message UpdateHumanLabelLinkRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateHumanLabelLinkRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.humanLabelLink != null && Object.hasOwnProperty.call(message, "humanLabelLink"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.humanLabelLink);
                        if (message.taskResult != null && Object.hasOwnProperty.call(message, "taskResult"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.taskResult);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateHumanLabelLinkRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateHumanLabelLinkRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateHumanLabelLinkRequest} message UpdateHumanLabelLinkRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateHumanLabelLinkRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateHumanLabelLinkRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateHumanLabelLinkRequest} UpdateHumanLabelLinkRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateHumanLabelLinkRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateHumanLabelLinkRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.humanLabelLink = reader.string();
                                break;
                            case 2:
                                message.taskResult = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateHumanLabelLinkRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateHumanLabelLinkRequest} UpdateHumanLabelLinkRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateHumanLabelLinkRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateHumanLabelLinkRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateHumanLabelLinkRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.humanLabelLink != null && message.hasOwnProperty("humanLabelLink"))
                            if (!$util.isString(message.humanLabelLink))
                                return "humanLabelLink: string expected";
                        if (message.taskResult != null && message.hasOwnProperty("taskResult"))
                            if (!$util.isString(message.taskResult))
                                return "taskResult: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateHumanLabelLinkRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateHumanLabelLinkRequest} UpdateHumanLabelLinkRequest
                     */
                    UpdateHumanLabelLinkRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateHumanLabelLinkRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateHumanLabelLinkRequest();
                        if (object.humanLabelLink != null)
                            message.humanLabelLink = String(object.humanLabelLink);
                        if (object.taskResult != null)
                            message.taskResult = String(object.taskResult);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateHumanLabelLinkRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateHumanLabelLinkRequest} message UpdateHumanLabelLinkRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateHumanLabelLinkRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.humanLabelLink = "";
                            object.taskResult = "";
                        }
                        if (message.humanLabelLink != null && message.hasOwnProperty("humanLabelLink"))
                            object.humanLabelLink = message.humanLabelLink;
                        if (message.taskResult != null && message.hasOwnProperty("taskResult"))
                            object.taskResult = message.taskResult;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateHumanLabelLinkRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateHumanLabelLinkRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateHumanLabelLinkRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateHumanLabelLinkRequest;
                })();
    
                v1.RetryTaskRequest = (function() {
    
                    /**
                     * Properties of a RetryTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IRetryTaskRequest
                     * @property {string|null} [task] RetryTaskRequest task
                     */
    
                    /**
                     * Constructs a new RetryTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RetryTaskRequest.
                     * @implements IRetryTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IRetryTaskRequest=} [properties] Properties to set
                     */
                    function RetryTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RetryTaskRequest task.
                     * @member {string} task
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @instance
                     */
                    RetryTaskRequest.prototype.task = "";
    
                    /**
                     * Creates a new RetryTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRetryTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RetryTaskRequest} RetryTaskRequest instance
                     */
                    RetryTaskRequest.create = function create(properties) {
                        return new RetryTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RetryTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.RetryTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRetryTaskRequest} message RetryTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RetryTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.task);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RetryTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RetryTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRetryTaskRequest} message RetryTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RetryTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RetryTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RetryTaskRequest} RetryTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RetryTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RetryTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RetryTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RetryTaskRequest} RetryTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RetryTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RetryTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RetryTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task"))
                            if (!$util.isString(message.task))
                                return "task: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RetryTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RetryTaskRequest} RetryTaskRequest
                     */
                    RetryTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RetryTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RetryTaskRequest();
                        if (object.task != null)
                            message.task = String(object.task);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RetryTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.RetryTaskRequest} message RetryTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RetryTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.task = "";
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = message.task;
                        return object;
                    };
    
                    /**
                     * Converts this RetryTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RetryTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RetryTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RetryTaskRequest;
                })();
    
                v1.CreateAccuracyTasksForStoreConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateAccuracyTasksForStoreConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateAccuracyTasksForStoreConfigRequest
                     * @property {number|null} [storeConfigId] CreateAccuracyTasksForStoreConfigRequest storeConfigId
                     * @property {number|null} [postMergeStoreConfigItemId] CreateAccuracyTasksForStoreConfigRequest postMergeStoreConfigItemId
                     */
    
                    /**
                     * Constructs a new CreateAccuracyTasksForStoreConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateAccuracyTasksForStoreConfigRequest.
                     * @implements ICreateAccuracyTasksForStoreConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest=} [properties] Properties to set
                     */
                    function CreateAccuracyTasksForStoreConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateAccuracyTasksForStoreConfigRequest storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @instance
                     */
                    CreateAccuracyTasksForStoreConfigRequest.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateAccuracyTasksForStoreConfigRequest postMergeStoreConfigItemId.
                     * @member {number} postMergeStoreConfigItemId
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @instance
                     */
                    CreateAccuracyTasksForStoreConfigRequest.prototype.postMergeStoreConfigItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CreateAccuracyTasksForStoreConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest} CreateAccuracyTasksForStoreConfigRequest instance
                     */
                    CreateAccuracyTasksForStoreConfigRequest.create = function create(properties) {
                        return new CreateAccuracyTasksForStoreConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateAccuracyTasksForStoreConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest} message CreateAccuracyTasksForStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateAccuracyTasksForStoreConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeConfigId);
                        if (message.postMergeStoreConfigItemId != null && Object.hasOwnProperty.call(message, "postMergeStoreConfigItemId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.postMergeStoreConfigItemId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateAccuracyTasksForStoreConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigRequest} message CreateAccuracyTasksForStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateAccuracyTasksForStoreConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateAccuracyTasksForStoreConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest} CreateAccuracyTasksForStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateAccuracyTasksForStoreConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfigId = reader.int64();
                                break;
                            case 2:
                                message.postMergeStoreConfigItemId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateAccuracyTasksForStoreConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest} CreateAccuracyTasksForStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateAccuracyTasksForStoreConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateAccuracyTasksForStoreConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateAccuracyTasksForStoreConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.postMergeStoreConfigItemId != null && message.hasOwnProperty("postMergeStoreConfigItemId"))
                            if (!$util.isInteger(message.postMergeStoreConfigItemId) && !(message.postMergeStoreConfigItemId && $util.isInteger(message.postMergeStoreConfigItemId.low) && $util.isInteger(message.postMergeStoreConfigItemId.high)))
                                return "postMergeStoreConfigItemId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateAccuracyTasksForStoreConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest} CreateAccuracyTasksForStoreConfigRequest
                     */
                    CreateAccuracyTasksForStoreConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest();
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        if (object.postMergeStoreConfigItemId != null)
                            if ($util.Long)
                                (message.postMergeStoreConfigItemId = $util.Long.fromValue(object.postMergeStoreConfigItemId)).unsigned = false;
                            else if (typeof object.postMergeStoreConfigItemId === "string")
                                message.postMergeStoreConfigItemId = parseInt(object.postMergeStoreConfigItemId, 10);
                            else if (typeof object.postMergeStoreConfigItemId === "number")
                                message.postMergeStoreConfigItemId = object.postMergeStoreConfigItemId;
                            else if (typeof object.postMergeStoreConfigItemId === "object")
                                message.postMergeStoreConfigItemId = new $util.LongBits(object.postMergeStoreConfigItemId.low >>> 0, object.postMergeStoreConfigItemId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateAccuracyTasksForStoreConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest} message CreateAccuracyTasksForStoreConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateAccuracyTasksForStoreConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.postMergeStoreConfigItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.postMergeStoreConfigItemId = options.longs === String ? "0" : 0;
                        }
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.postMergeStoreConfigItemId != null && message.hasOwnProperty("postMergeStoreConfigItemId"))
                            if (typeof message.postMergeStoreConfigItemId === "number")
                                object.postMergeStoreConfigItemId = options.longs === String ? String(message.postMergeStoreConfigItemId) : message.postMergeStoreConfigItemId;
                            else
                                object.postMergeStoreConfigItemId = options.longs === String ? $util.Long.prototype.toString.call(message.postMergeStoreConfigItemId) : options.longs === Number ? new $util.LongBits(message.postMergeStoreConfigItemId.low >>> 0, message.postMergeStoreConfigItemId.high >>> 0).toNumber() : message.postMergeStoreConfigItemId;
                        return object;
                    };
    
                    /**
                     * Converts this CreateAccuracyTasksForStoreConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateAccuracyTasksForStoreConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateAccuracyTasksForStoreConfigRequest;
                })();
    
                v1.CreateAccuracyTasksForStoreConfigResponse = (function() {
    
                    /**
                     * Properties of a CreateAccuracyTasksForStoreConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateAccuracyTasksForStoreConfigResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateAccuracyTasksForStoreConfigResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateAccuracyTasksForStoreConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateAccuracyTasksForStoreConfigResponse.
                     * @implements ICreateAccuracyTasksForStoreConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigResponse=} [properties] Properties to set
                     */
                    function CreateAccuracyTasksForStoreConfigResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateAccuracyTasksForStoreConfigResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @instance
                     */
                    CreateAccuracyTasksForStoreConfigResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateAccuracyTasksForStoreConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} CreateAccuracyTasksForStoreConfigResponse instance
                     */
                    CreateAccuracyTasksForStoreConfigResponse.create = function create(properties) {
                        return new CreateAccuracyTasksForStoreConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateAccuracyTasksForStoreConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigResponse} message CreateAccuracyTasksForStoreConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateAccuracyTasksForStoreConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateAccuracyTasksForStoreConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateAccuracyTasksForStoreConfigResponse} message CreateAccuracyTasksForStoreConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateAccuracyTasksForStoreConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateAccuracyTasksForStoreConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} CreateAccuracyTasksForStoreConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateAccuracyTasksForStoreConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateAccuracyTasksForStoreConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} CreateAccuracyTasksForStoreConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateAccuracyTasksForStoreConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateAccuracyTasksForStoreConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateAccuracyTasksForStoreConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateAccuracyTasksForStoreConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} CreateAccuracyTasksForStoreConfigResponse
                     */
                    CreateAccuracyTasksForStoreConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateAccuracyTasksForStoreConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse} message CreateAccuracyTasksForStoreConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateAccuracyTasksForStoreConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateAccuracyTasksForStoreConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateAccuracyTasksForStoreConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateAccuracyTasksForStoreConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateAccuracyTasksForStoreConfigResponse;
                })();
    
                v1.CreateTasksForConfigItemRequest = (function() {
    
                    /**
                     * Properties of a CreateTasksForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTasksForConfigItemRequest
                     * @property {palexy.streaming.v1.IStoreConfigItem|null} [configItem] CreateTasksForConfigItemRequest configItem
                     */
    
                    /**
                     * Constructs a new CreateTasksForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTasksForConfigItemRequest.
                     * @implements ICreateTasksForConfigItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest=} [properties] Properties to set
                     */
                    function CreateTasksForConfigItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTasksForConfigItemRequest configItem.
                     * @member {palexy.streaming.v1.IStoreConfigItem|null|undefined} configItem
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @instance
                     */
                    CreateTasksForConfigItemRequest.prototype.configItem = null;
    
                    /**
                     * Creates a new CreateTasksForConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemRequest} CreateTasksForConfigItemRequest instance
                     */
                    CreateTasksForConfigItemRequest.create = function create(properties) {
                        return new CreateTasksForConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTasksForConfigItemRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateTasksForConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest} message CreateTasksForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTasksForConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configItem != null && Object.hasOwnProperty.call(message, "configItem"))
                            $root.palexy.streaming.v1.StoreConfigItem.encode(message.configItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTasksForConfigItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTasksForConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemRequest} message CreateTasksForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTasksForConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTasksForConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemRequest} CreateTasksForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTasksForConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTasksForConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configItem = $root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTasksForConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemRequest} CreateTasksForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTasksForConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTasksForConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTasksForConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configItem != null && message.hasOwnProperty("configItem")) {
                            var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.configItem);
                            if (error)
                                return "configItem." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTasksForConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemRequest} CreateTasksForConfigItemRequest
                     */
                    CreateTasksForConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTasksForConfigItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTasksForConfigItemRequest();
                        if (object.configItem != null) {
                            if (typeof object.configItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateTasksForConfigItemRequest.configItem: object expected");
                            message.configItem = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.configItem);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTasksForConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateTasksForConfigItemRequest} message CreateTasksForConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTasksForConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.configItem = null;
                        if (message.configItem != null && message.hasOwnProperty("configItem"))
                            object.configItem = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.configItem, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTasksForConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTasksForConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTasksForConfigItemRequest;
                })();
    
                v1.CreateTasksForConfigItemResponse = (function() {
    
                    /**
                     * Properties of a CreateTasksForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTasksForConfigItemResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateTasksForConfigItemResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateTasksForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTasksForConfigItemResponse.
                     * @implements ICreateTasksForConfigItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemResponse=} [properties] Properties to set
                     */
                    function CreateTasksForConfigItemResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTasksForConfigItemResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @instance
                     */
                    CreateTasksForConfigItemResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateTasksForConfigItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemResponse} CreateTasksForConfigItemResponse instance
                     */
                    CreateTasksForConfigItemResponse.create = function create(properties) {
                        return new CreateTasksForConfigItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTasksForConfigItemResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateTasksForConfigItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemResponse} message CreateTasksForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTasksForConfigItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTasksForConfigItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTasksForConfigItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTasksForConfigItemResponse} message CreateTasksForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTasksForConfigItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTasksForConfigItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemResponse} CreateTasksForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTasksForConfigItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTasksForConfigItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTasksForConfigItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemResponse} CreateTasksForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTasksForConfigItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTasksForConfigItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTasksForConfigItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTasksForConfigItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTasksForConfigItemResponse} CreateTasksForConfigItemResponse
                     */
                    CreateTasksForConfigItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTasksForConfigItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTasksForConfigItemResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateTasksForConfigItemResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateTasksForConfigItemResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTasksForConfigItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateTasksForConfigItemResponse} message CreateTasksForConfigItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTasksForConfigItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateTasksForConfigItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTasksForConfigItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTasksForConfigItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTasksForConfigItemResponse;
                })();
    
                v1.CreateScanningTaskForConfigItemRequest = (function() {
    
                    /**
                     * Properties of a CreateScanningTaskForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateScanningTaskForConfigItemRequest
                     * @property {palexy.streaming.v1.IStoreConfigItem|null} [configItem] CreateScanningTaskForConfigItemRequest configItem
                     * @property {Array.<number>|null} [debugTaskIds] CreateScanningTaskForConfigItemRequest debugTaskIds
                     * @property {Array.<palexy.sherlock.v1.IParameter>|null} [params] CreateScanningTaskForConfigItemRequest params
                     */
    
                    /**
                     * Constructs a new CreateScanningTaskForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateScanningTaskForConfigItemRequest.
                     * @implements ICreateScanningTaskForConfigItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest=} [properties] Properties to set
                     */
                    function CreateScanningTaskForConfigItemRequest(properties) {
                        this.debugTaskIds = [];
                        this.params = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateScanningTaskForConfigItemRequest configItem.
                     * @member {palexy.streaming.v1.IStoreConfigItem|null|undefined} configItem
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @instance
                     */
                    CreateScanningTaskForConfigItemRequest.prototype.configItem = null;
    
                    /**
                     * CreateScanningTaskForConfigItemRequest debugTaskIds.
                     * @member {Array.<number>} debugTaskIds
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @instance
                     */
                    CreateScanningTaskForConfigItemRequest.prototype.debugTaskIds = $util.emptyArray;
    
                    /**
                     * CreateScanningTaskForConfigItemRequest params.
                     * @member {Array.<palexy.sherlock.v1.IParameter>} params
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @instance
                     */
                    CreateScanningTaskForConfigItemRequest.prototype.params = $util.emptyArray;
    
                    /**
                     * Creates a new CreateScanningTaskForConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest} CreateScanningTaskForConfigItemRequest instance
                     */
                    CreateScanningTaskForConfigItemRequest.create = function create(properties) {
                        return new CreateScanningTaskForConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateScanningTaskForConfigItemRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest} message CreateScanningTaskForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScanningTaskForConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configItem != null && Object.hasOwnProperty.call(message, "configItem"))
                            $root.palexy.streaming.v1.StoreConfigItem.encode(message.configItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.debugTaskIds != null && message.debugTaskIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.debugTaskIds.length; ++i)
                                writer.int64(message.debugTaskIds[i]);
                            writer.ldelim();
                        }
                        if (message.params != null && message.params.length)
                            for (var i = 0; i < message.params.length; ++i)
                                $root.palexy.sherlock.v1.Parameter.encode(message.params[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateScanningTaskForConfigItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemRequest} message CreateScanningTaskForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScanningTaskForConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateScanningTaskForConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest} CreateScanningTaskForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScanningTaskForConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configItem = $root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.debugTaskIds && message.debugTaskIds.length))
                                    message.debugTaskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.debugTaskIds.push(reader.int64());
                                } else
                                    message.debugTaskIds.push(reader.int64());
                                break;
                            case 3:
                                if (!(message.params && message.params.length))
                                    message.params = [];
                                message.params.push($root.palexy.sherlock.v1.Parameter.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateScanningTaskForConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest} CreateScanningTaskForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScanningTaskForConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateScanningTaskForConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateScanningTaskForConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configItem != null && message.hasOwnProperty("configItem")) {
                            var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.configItem);
                            if (error)
                                return "configItem." + error;
                        }
                        if (message.debugTaskIds != null && message.hasOwnProperty("debugTaskIds")) {
                            if (!Array.isArray(message.debugTaskIds))
                                return "debugTaskIds: array expected";
                            for (var i = 0; i < message.debugTaskIds.length; ++i)
                                if (!$util.isInteger(message.debugTaskIds[i]) && !(message.debugTaskIds[i] && $util.isInteger(message.debugTaskIds[i].low) && $util.isInteger(message.debugTaskIds[i].high)))
                                    return "debugTaskIds: integer|Long[] expected";
                        }
                        if (message.params != null && message.hasOwnProperty("params")) {
                            if (!Array.isArray(message.params))
                                return "params: array expected";
                            for (var i = 0; i < message.params.length; ++i) {
                                var error = $root.palexy.sherlock.v1.Parameter.verify(message.params[i]);
                                if (error)
                                    return "params." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateScanningTaskForConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest} CreateScanningTaskForConfigItemRequest
                     */
                    CreateScanningTaskForConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest();
                        if (object.configItem != null) {
                            if (typeof object.configItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.configItem: object expected");
                            message.configItem = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.configItem);
                        }
                        if (object.debugTaskIds) {
                            if (!Array.isArray(object.debugTaskIds))
                                throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.debugTaskIds: array expected");
                            message.debugTaskIds = [];
                            for (var i = 0; i < object.debugTaskIds.length; ++i)
                                if ($util.Long)
                                    (message.debugTaskIds[i] = $util.Long.fromValue(object.debugTaskIds[i])).unsigned = false;
                                else if (typeof object.debugTaskIds[i] === "string")
                                    message.debugTaskIds[i] = parseInt(object.debugTaskIds[i], 10);
                                else if (typeof object.debugTaskIds[i] === "number")
                                    message.debugTaskIds[i] = object.debugTaskIds[i];
                                else if (typeof object.debugTaskIds[i] === "object")
                                    message.debugTaskIds[i] = new $util.LongBits(object.debugTaskIds[i].low >>> 0, object.debugTaskIds[i].high >>> 0).toNumber();
                        }
                        if (object.params) {
                            if (!Array.isArray(object.params))
                                throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.params: array expected");
                            message.params = [];
                            for (var i = 0; i < object.params.length; ++i) {
                                if (typeof object.params[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest.params: object expected");
                                message.params[i] = $root.palexy.sherlock.v1.Parameter.fromObject(object.params[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateScanningTaskForConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest} message CreateScanningTaskForConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateScanningTaskForConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.debugTaskIds = [];
                            object.params = [];
                        }
                        if (options.defaults)
                            object.configItem = null;
                        if (message.configItem != null && message.hasOwnProperty("configItem"))
                            object.configItem = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.configItem, options);
                        if (message.debugTaskIds && message.debugTaskIds.length) {
                            object.debugTaskIds = [];
                            for (var j = 0; j < message.debugTaskIds.length; ++j)
                                if (typeof message.debugTaskIds[j] === "number")
                                    object.debugTaskIds[j] = options.longs === String ? String(message.debugTaskIds[j]) : message.debugTaskIds[j];
                                else
                                    object.debugTaskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.debugTaskIds[j]) : options.longs === Number ? new $util.LongBits(message.debugTaskIds[j].low >>> 0, message.debugTaskIds[j].high >>> 0).toNumber() : message.debugTaskIds[j];
                        }
                        if (message.params && message.params.length) {
                            object.params = [];
                            for (var j = 0; j < message.params.length; ++j)
                                object.params[j] = $root.palexy.sherlock.v1.Parameter.toObject(message.params[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateScanningTaskForConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateScanningTaskForConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateScanningTaskForConfigItemRequest;
                })();
    
                v1.CreateScanningTaskForConfigItemResponse = (function() {
    
                    /**
                     * Properties of a CreateScanningTaskForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateScanningTaskForConfigItemResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateScanningTaskForConfigItemResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateScanningTaskForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateScanningTaskForConfigItemResponse.
                     * @implements ICreateScanningTaskForConfigItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemResponse=} [properties] Properties to set
                     */
                    function CreateScanningTaskForConfigItemResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateScanningTaskForConfigItemResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @instance
                     */
                    CreateScanningTaskForConfigItemResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateScanningTaskForConfigItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} CreateScanningTaskForConfigItemResponse instance
                     */
                    CreateScanningTaskForConfigItemResponse.create = function create(properties) {
                        return new CreateScanningTaskForConfigItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateScanningTaskForConfigItemResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemResponse} message CreateScanningTaskForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScanningTaskForConfigItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateScanningTaskForConfigItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateScanningTaskForConfigItemResponse} message CreateScanningTaskForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScanningTaskForConfigItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateScanningTaskForConfigItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} CreateScanningTaskForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScanningTaskForConfigItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateScanningTaskForConfigItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} CreateScanningTaskForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScanningTaskForConfigItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateScanningTaskForConfigItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateScanningTaskForConfigItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateScanningTaskForConfigItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} CreateScanningTaskForConfigItemResponse
                     */
                    CreateScanningTaskForConfigItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateScanningTaskForConfigItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse} message CreateScanningTaskForConfigItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateScanningTaskForConfigItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateScanningTaskForConfigItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateScanningTaskForConfigItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateScanningTaskForConfigItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateScanningTaskForConfigItemResponse;
                })();
    
                v1.CreateRerunningTaskForConfigItemRequest = (function() {
    
                    /**
                     * Properties of a CreateRerunningTaskForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateRerunningTaskForConfigItemRequest
                     * @property {palexy.streaming.v1.IStoreConfigItem|null} [configItem] CreateRerunningTaskForConfigItemRequest configItem
                     * @property {Array.<number>|null} [debugTaskIds] CreateRerunningTaskForConfigItemRequest debugTaskIds
                     */
    
                    /**
                     * Constructs a new CreateRerunningTaskForConfigItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateRerunningTaskForConfigItemRequest.
                     * @implements ICreateRerunningTaskForConfigItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest=} [properties] Properties to set
                     */
                    function CreateRerunningTaskForConfigItemRequest(properties) {
                        this.debugTaskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateRerunningTaskForConfigItemRequest configItem.
                     * @member {palexy.streaming.v1.IStoreConfigItem|null|undefined} configItem
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @instance
                     */
                    CreateRerunningTaskForConfigItemRequest.prototype.configItem = null;
    
                    /**
                     * CreateRerunningTaskForConfigItemRequest debugTaskIds.
                     * @member {Array.<number>} debugTaskIds
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @instance
                     */
                    CreateRerunningTaskForConfigItemRequest.prototype.debugTaskIds = $util.emptyArray;
    
                    /**
                     * Creates a new CreateRerunningTaskForConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest} CreateRerunningTaskForConfigItemRequest instance
                     */
                    CreateRerunningTaskForConfigItemRequest.create = function create(properties) {
                        return new CreateRerunningTaskForConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateRerunningTaskForConfigItemRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest} message CreateRerunningTaskForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRerunningTaskForConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configItem != null && Object.hasOwnProperty.call(message, "configItem"))
                            $root.palexy.streaming.v1.StoreConfigItem.encode(message.configItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.debugTaskIds != null && message.debugTaskIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.debugTaskIds.length; ++i)
                                writer.int64(message.debugTaskIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateRerunningTaskForConfigItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemRequest} message CreateRerunningTaskForConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRerunningTaskForConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateRerunningTaskForConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest} CreateRerunningTaskForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRerunningTaskForConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configItem = $root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.debugTaskIds && message.debugTaskIds.length))
                                    message.debugTaskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.debugTaskIds.push(reader.int64());
                                } else
                                    message.debugTaskIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateRerunningTaskForConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest} CreateRerunningTaskForConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRerunningTaskForConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateRerunningTaskForConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateRerunningTaskForConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configItem != null && message.hasOwnProperty("configItem")) {
                            var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.configItem);
                            if (error)
                                return "configItem." + error;
                        }
                        if (message.debugTaskIds != null && message.hasOwnProperty("debugTaskIds")) {
                            if (!Array.isArray(message.debugTaskIds))
                                return "debugTaskIds: array expected";
                            for (var i = 0; i < message.debugTaskIds.length; ++i)
                                if (!$util.isInteger(message.debugTaskIds[i]) && !(message.debugTaskIds[i] && $util.isInteger(message.debugTaskIds[i].low) && $util.isInteger(message.debugTaskIds[i].high)))
                                    return "debugTaskIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateRerunningTaskForConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest} CreateRerunningTaskForConfigItemRequest
                     */
                    CreateRerunningTaskForConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest();
                        if (object.configItem != null) {
                            if (typeof object.configItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest.configItem: object expected");
                            message.configItem = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.configItem);
                        }
                        if (object.debugTaskIds) {
                            if (!Array.isArray(object.debugTaskIds))
                                throw TypeError(".palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest.debugTaskIds: array expected");
                            message.debugTaskIds = [];
                            for (var i = 0; i < object.debugTaskIds.length; ++i)
                                if ($util.Long)
                                    (message.debugTaskIds[i] = $util.Long.fromValue(object.debugTaskIds[i])).unsigned = false;
                                else if (typeof object.debugTaskIds[i] === "string")
                                    message.debugTaskIds[i] = parseInt(object.debugTaskIds[i], 10);
                                else if (typeof object.debugTaskIds[i] === "number")
                                    message.debugTaskIds[i] = object.debugTaskIds[i];
                                else if (typeof object.debugTaskIds[i] === "object")
                                    message.debugTaskIds[i] = new $util.LongBits(object.debugTaskIds[i].low >>> 0, object.debugTaskIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateRerunningTaskForConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest} message CreateRerunningTaskForConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateRerunningTaskForConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.debugTaskIds = [];
                        if (options.defaults)
                            object.configItem = null;
                        if (message.configItem != null && message.hasOwnProperty("configItem"))
                            object.configItem = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.configItem, options);
                        if (message.debugTaskIds && message.debugTaskIds.length) {
                            object.debugTaskIds = [];
                            for (var j = 0; j < message.debugTaskIds.length; ++j)
                                if (typeof message.debugTaskIds[j] === "number")
                                    object.debugTaskIds[j] = options.longs === String ? String(message.debugTaskIds[j]) : message.debugTaskIds[j];
                                else
                                    object.debugTaskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.debugTaskIds[j]) : options.longs === Number ? new $util.LongBits(message.debugTaskIds[j].low >>> 0, message.debugTaskIds[j].high >>> 0).toNumber() : message.debugTaskIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateRerunningTaskForConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateRerunningTaskForConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateRerunningTaskForConfigItemRequest;
                })();
    
                v1.CreateRerunningTaskForConfigItemResponse = (function() {
    
                    /**
                     * Properties of a CreateRerunningTaskForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateRerunningTaskForConfigItemResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreateRerunningTaskForConfigItemResponse tasks
                     */
    
                    /**
                     * Constructs a new CreateRerunningTaskForConfigItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateRerunningTaskForConfigItemResponse.
                     * @implements ICreateRerunningTaskForConfigItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemResponse=} [properties] Properties to set
                     */
                    function CreateRerunningTaskForConfigItemResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateRerunningTaskForConfigItemResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @instance
                     */
                    CreateRerunningTaskForConfigItemResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreateRerunningTaskForConfigItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} CreateRerunningTaskForConfigItemResponse instance
                     */
                    CreateRerunningTaskForConfigItemResponse.create = function create(properties) {
                        return new CreateRerunningTaskForConfigItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateRerunningTaskForConfigItemResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemResponse} message CreateRerunningTaskForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRerunningTaskForConfigItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateRerunningTaskForConfigItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateRerunningTaskForConfigItemResponse} message CreateRerunningTaskForConfigItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRerunningTaskForConfigItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateRerunningTaskForConfigItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} CreateRerunningTaskForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRerunningTaskForConfigItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateRerunningTaskForConfigItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} CreateRerunningTaskForConfigItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRerunningTaskForConfigItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateRerunningTaskForConfigItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateRerunningTaskForConfigItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateRerunningTaskForConfigItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} CreateRerunningTaskForConfigItemResponse
                     */
                    CreateRerunningTaskForConfigItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateRerunningTaskForConfigItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse} message CreateRerunningTaskForConfigItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateRerunningTaskForConfigItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateRerunningTaskForConfigItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateRerunningTaskForConfigItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateRerunningTaskForConfigItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateRerunningTaskForConfigItemResponse;
                })();
    
                v1.CreatePrepareQcVideosTaskRequest = (function() {
    
                    /**
                     * Properties of a CreatePrepareQcVideosTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreatePrepareQcVideosTaskRequest
                     * @property {number|null} [storeId] CreatePrepareQcVideosTaskRequest storeId
                     * @property {string|null} [dateId] CreatePrepareQcVideosTaskRequest dateId
                     * @property {number|null} [startHour] CreatePrepareQcVideosTaskRequest startHour
                     * @property {number|null} [endHour] CreatePrepareQcVideosTaskRequest endHour
                     * @property {Array.<string>|null} [cameraIds] CreatePrepareQcVideosTaskRequest cameraIds
                     * @property {boolean|null} [compressVideo] CreatePrepareQcVideosTaskRequest compressVideo
                     * @property {Array.<string>|null} [notificationEmails] CreatePrepareQcVideosTaskRequest notificationEmails
                     * @property {palexy.sherlock.v1.SherlockTask.StorageProvider|null} [storageProvider] CreatePrepareQcVideosTaskRequest storageProvider
                     * @property {boolean|null} [anonymizeFace] CreatePrepareQcVideosTaskRequest anonymizeFace
                     * @property {number|null} [fps] CreatePrepareQcVideosTaskRequest fps
                     * @property {boolean|null} [createQcPlan] CreatePrepareQcVideosTaskRequest createQcPlan
                     */
    
                    /**
                     * Constructs a new CreatePrepareQcVideosTaskRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreatePrepareQcVideosTaskRequest.
                     * @implements ICreatePrepareQcVideosTaskRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest=} [properties] Properties to set
                     */
                    function CreatePrepareQcVideosTaskRequest(properties) {
                        this.cameraIds = [];
                        this.notificationEmails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreatePrepareQcVideosTaskRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.dateId = "";
    
                    /**
                     * CreatePrepareQcVideosTaskRequest startHour.
                     * @member {number} startHour
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.startHour = 0;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest endHour.
                     * @member {number} endHour
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.endHour = 0;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest compressVideo.
                     * @member {boolean} compressVideo
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.compressVideo = false;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest notificationEmails.
                     * @member {Array.<string>} notificationEmails
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.notificationEmails = $util.emptyArray;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest storageProvider.
                     * @member {palexy.sherlock.v1.SherlockTask.StorageProvider} storageProvider
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.storageProvider = 0;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest anonymizeFace.
                     * @member {boolean} anonymizeFace
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.anonymizeFace = false;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest fps.
                     * @member {number} fps
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.fps = 0;
    
                    /**
                     * CreatePrepareQcVideosTaskRequest createQcPlan.
                     * @member {boolean} createQcPlan
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.createQcPlan = false;
    
                    /**
                     * Creates a new CreatePrepareQcVideosTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest} CreatePrepareQcVideosTaskRequest instance
                     */
                    CreatePrepareQcVideosTaskRequest.create = function create(properties) {
                        return new CreatePrepareQcVideosTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreatePrepareQcVideosTaskRequest message. Does not implicitly {@link palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest} message CreatePrepareQcVideosTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreatePrepareQcVideosTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.startHour != null && Object.hasOwnProperty.call(message, "startHour"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startHour);
                        if (message.endHour != null && Object.hasOwnProperty.call(message, "endHour"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endHour);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cameraIds[i]);
                        if (message.compressVideo != null && Object.hasOwnProperty.call(message, "compressVideo"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.compressVideo);
                        if (message.notificationEmails != null && message.notificationEmails.length)
                            for (var i = 0; i < message.notificationEmails.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.notificationEmails[i]);
                        if (message.storageProvider != null && Object.hasOwnProperty.call(message, "storageProvider"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.storageProvider);
                        if (message.anonymizeFace != null && Object.hasOwnProperty.call(message, "anonymizeFace"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.anonymizeFace);
                        if (message.fps != null && Object.hasOwnProperty.call(message, "fps"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.fps);
                        if (message.createQcPlan != null && Object.hasOwnProperty.call(message, "createQcPlan"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.createQcPlan);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreatePrepareQcVideosTaskRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskRequest} message CreatePrepareQcVideosTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreatePrepareQcVideosTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreatePrepareQcVideosTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest} CreatePrepareQcVideosTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreatePrepareQcVideosTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.startHour = reader.int32();
                                break;
                            case 4:
                                message.endHour = reader.int32();
                                break;
                            case 5:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 6:
                                message.compressVideo = reader.bool();
                                break;
                            case 7:
                                if (!(message.notificationEmails && message.notificationEmails.length))
                                    message.notificationEmails = [];
                                message.notificationEmails.push(reader.string());
                                break;
                            case 8:
                                message.storageProvider = reader.int32();
                                break;
                            case 9:
                                message.anonymizeFace = reader.bool();
                                break;
                            case 10:
                                message.fps = reader.int32();
                                break;
                            case 11:
                                message.createQcPlan = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreatePrepareQcVideosTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest} CreatePrepareQcVideosTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreatePrepareQcVideosTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreatePrepareQcVideosTaskRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreatePrepareQcVideosTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            if (!$util.isInteger(message.startHour))
                                return "startHour: integer expected";
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            if (!$util.isInteger(message.endHour))
                                return "endHour: integer expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.compressVideo != null && message.hasOwnProperty("compressVideo"))
                            if (typeof message.compressVideo !== "boolean")
                                return "compressVideo: boolean expected";
                        if (message.notificationEmails != null && message.hasOwnProperty("notificationEmails")) {
                            if (!Array.isArray(message.notificationEmails))
                                return "notificationEmails: array expected";
                            for (var i = 0; i < message.notificationEmails.length; ++i)
                                if (!$util.isString(message.notificationEmails[i]))
                                    return "notificationEmails: string[] expected";
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            switch (message.storageProvider) {
                            default:
                                return "storageProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.anonymizeFace != null && message.hasOwnProperty("anonymizeFace"))
                            if (typeof message.anonymizeFace !== "boolean")
                                return "anonymizeFace: boolean expected";
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            if (!$util.isInteger(message.fps))
                                return "fps: integer expected";
                        if (message.createQcPlan != null && message.hasOwnProperty("createQcPlan"))
                            if (typeof message.createQcPlan !== "boolean")
                                return "createQcPlan: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreatePrepareQcVideosTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest} CreatePrepareQcVideosTaskRequest
                     */
                    CreatePrepareQcVideosTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startHour != null)
                            message.startHour = object.startHour | 0;
                        if (object.endHour != null)
                            message.endHour = object.endHour | 0;
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.compressVideo != null)
                            message.compressVideo = Boolean(object.compressVideo);
                        if (object.notificationEmails) {
                            if (!Array.isArray(object.notificationEmails))
                                throw TypeError(".palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest.notificationEmails: array expected");
                            message.notificationEmails = [];
                            for (var i = 0; i < object.notificationEmails.length; ++i)
                                message.notificationEmails[i] = String(object.notificationEmails[i]);
                        }
                        switch (object.storageProvider) {
                        case "UNKNOWN_PROVIDER":
                        case 0:
                            message.storageProvider = 0;
                            break;
                        case "GCP":
                        case 1:
                            message.storageProvider = 1;
                            break;
                        case "GOOGLE_DRIVE":
                        case 2:
                            message.storageProvider = 2;
                            break;
                        }
                        if (object.anonymizeFace != null)
                            message.anonymizeFace = Boolean(object.anonymizeFace);
                        if (object.fps != null)
                            message.fps = object.fps | 0;
                        if (object.createQcPlan != null)
                            message.createQcPlan = Boolean(object.createQcPlan);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreatePrepareQcVideosTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest} message CreatePrepareQcVideosTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreatePrepareQcVideosTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.cameraIds = [];
                            object.notificationEmails = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startHour = 0;
                            object.endHour = 0;
                            object.compressVideo = false;
                            object.storageProvider = options.enums === String ? "UNKNOWN_PROVIDER" : 0;
                            object.anonymizeFace = false;
                            object.fps = 0;
                            object.createQcPlan = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            object.startHour = message.startHour;
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            object.endHour = message.endHour;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.compressVideo != null && message.hasOwnProperty("compressVideo"))
                            object.compressVideo = message.compressVideo;
                        if (message.notificationEmails && message.notificationEmails.length) {
                            object.notificationEmails = [];
                            for (var j = 0; j < message.notificationEmails.length; ++j)
                                object.notificationEmails[j] = message.notificationEmails[j];
                        }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            object.storageProvider = options.enums === String ? $root.palexy.sherlock.v1.SherlockTask.StorageProvider[message.storageProvider] : message.storageProvider;
                        if (message.anonymizeFace != null && message.hasOwnProperty("anonymizeFace"))
                            object.anonymizeFace = message.anonymizeFace;
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            object.fps = message.fps;
                        if (message.createQcPlan != null && message.hasOwnProperty("createQcPlan"))
                            object.createQcPlan = message.createQcPlan;
                        return object;
                    };
    
                    /**
                     * Converts this CreatePrepareQcVideosTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreatePrepareQcVideosTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreatePrepareQcVideosTaskRequest;
                })();
    
                v1.CreatePrepareQcVideosTaskResponse = (function() {
    
                    /**
                     * Properties of a CreatePrepareQcVideosTaskResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreatePrepareQcVideosTaskResponse
                     * @property {Array.<palexy.sherlock.v1.ISherlockTask>|null} [tasks] CreatePrepareQcVideosTaskResponse tasks
                     */
    
                    /**
                     * Constructs a new CreatePrepareQcVideosTaskResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreatePrepareQcVideosTaskResponse.
                     * @implements ICreatePrepareQcVideosTaskResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskResponse=} [properties] Properties to set
                     */
                    function CreatePrepareQcVideosTaskResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreatePrepareQcVideosTaskResponse tasks.
                     * @member {Array.<palexy.sherlock.v1.ISherlockTask>} tasks
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @instance
                     */
                    CreatePrepareQcVideosTaskResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new CreatePrepareQcVideosTaskResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} CreatePrepareQcVideosTaskResponse instance
                     */
                    CreatePrepareQcVideosTaskResponse.create = function create(properties) {
                        return new CreatePrepareQcVideosTaskResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreatePrepareQcVideosTaskResponse message. Does not implicitly {@link palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskResponse} message CreatePrepareQcVideosTaskResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreatePrepareQcVideosTaskResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.sherlock.v1.SherlockTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreatePrepareQcVideosTaskResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreatePrepareQcVideosTaskResponse} message CreatePrepareQcVideosTaskResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreatePrepareQcVideosTaskResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreatePrepareQcVideosTaskResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} CreatePrepareQcVideosTaskResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreatePrepareQcVideosTaskResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.sherlock.v1.SherlockTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreatePrepareQcVideosTaskResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} CreatePrepareQcVideosTaskResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreatePrepareQcVideosTaskResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreatePrepareQcVideosTaskResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreatePrepareQcVideosTaskResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.sherlock.v1.SherlockTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreatePrepareQcVideosTaskResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} CreatePrepareQcVideosTaskResponse
                     */
                    CreatePrepareQcVideosTaskResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.sherlock.v1.SherlockTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreatePrepareQcVideosTaskResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse} message CreatePrepareQcVideosTaskResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreatePrepareQcVideosTaskResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.sherlock.v1.SherlockTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreatePrepareQcVideosTaskResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreatePrepareQcVideosTaskResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreatePrepareQcVideosTaskResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreatePrepareQcVideosTaskResponse;
                })();
    
                v1.GoogleCloudService = (function() {
    
                    /**
                     * Constructs a new GoogleCloudService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GoogleCloudService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function GoogleCloudService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (GoogleCloudService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = GoogleCloudService;
    
                    /**
                     * Creates new GoogleCloudService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.GoogleCloudService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {GoogleCloudService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    GoogleCloudService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.GoogleCloudService#generateSignedUrl}.
                     * @memberof palexy.sherlock.v1.GoogleCloudService
                     * @typedef GenerateSignedUrlCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.GenerateSignedUrlResponse} [response] GenerateSignedUrlResponse
                     */
    
                    /**
                     * Calls GenerateSignedUrl.
                     * @function generateSignedUrl
                     * @memberof palexy.sherlock.v1.GoogleCloudService
                     * @instance
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest} request GenerateSignedUrlRequest message or plain object
                     * @param {palexy.sherlock.v1.GoogleCloudService.GenerateSignedUrlCallback} callback Node-style callback called with the error, if any, and GenerateSignedUrlResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(GoogleCloudService.prototype.generateSignedUrl = function generateSignedUrl(request, callback) {
                        return this.rpcCall(generateSignedUrl, $root.palexy.sherlock.v1.GenerateSignedUrlRequest, $root.palexy.sherlock.v1.GenerateSignedUrlResponse, request, callback);
                    }, "name", { value: "GenerateSignedUrl" });
    
                    /**
                     * Calls GenerateSignedUrl.
                     * @function generateSignedUrl
                     * @memberof palexy.sherlock.v1.GoogleCloudService
                     * @instance
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest} request GenerateSignedUrlRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.GenerateSignedUrlResponse>} Promise
                     * @variation 2
                     */
    
                    return GoogleCloudService;
                })();
    
                v1.GenerateSignedUrlRequest = (function() {
    
                    /**
                     * Properties of a GenerateSignedUrlRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IGenerateSignedUrlRequest
                     * @property {string|null} [bucketName] GenerateSignedUrlRequest bucketName
                     * @property {string|null} [objectName] GenerateSignedUrlRequest objectName
                     * @property {number|null} [expiration] GenerateSignedUrlRequest expiration
                     */
    
                    /**
                     * Constructs a new GenerateSignedUrlRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GenerateSignedUrlRequest.
                     * @implements IGenerateSignedUrlRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest=} [properties] Properties to set
                     */
                    function GenerateSignedUrlRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateSignedUrlRequest bucketName.
                     * @member {string} bucketName
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @instance
                     */
                    GenerateSignedUrlRequest.prototype.bucketName = "";
    
                    /**
                     * GenerateSignedUrlRequest objectName.
                     * @member {string} objectName
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @instance
                     */
                    GenerateSignedUrlRequest.prototype.objectName = "";
    
                    /**
                     * GenerateSignedUrlRequest expiration.
                     * @member {number} expiration
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @instance
                     */
                    GenerateSignedUrlRequest.prototype.expiration = 0;
    
                    /**
                     * Creates a new GenerateSignedUrlRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlRequest} GenerateSignedUrlRequest instance
                     */
                    GenerateSignedUrlRequest.create = function create(properties) {
                        return new GenerateSignedUrlRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateSignedUrlRequest message. Does not implicitly {@link palexy.sherlock.v1.GenerateSignedUrlRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest} message GenerateSignedUrlRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateSignedUrlRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.bucketName != null && Object.hasOwnProperty.call(message, "bucketName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.bucketName);
                        if (message.objectName != null && Object.hasOwnProperty.call(message, "objectName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.objectName);
                        if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.expiration);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateSignedUrlRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GenerateSignedUrlRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlRequest} message GenerateSignedUrlRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateSignedUrlRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateSignedUrlRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlRequest} GenerateSignedUrlRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateSignedUrlRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GenerateSignedUrlRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.bucketName = reader.string();
                                break;
                            case 2:
                                message.objectName = reader.string();
                                break;
                            case 3:
                                message.expiration = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateSignedUrlRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlRequest} GenerateSignedUrlRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateSignedUrlRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateSignedUrlRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateSignedUrlRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.bucketName != null && message.hasOwnProperty("bucketName"))
                            if (!$util.isString(message.bucketName))
                                return "bucketName: string expected";
                        if (message.objectName != null && message.hasOwnProperty("objectName"))
                            if (!$util.isString(message.objectName))
                                return "objectName: string expected";
                        if (message.expiration != null && message.hasOwnProperty("expiration"))
                            if (!$util.isInteger(message.expiration))
                                return "expiration: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a GenerateSignedUrlRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlRequest} GenerateSignedUrlRequest
                     */
                    GenerateSignedUrlRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GenerateSignedUrlRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GenerateSignedUrlRequest();
                        if (object.bucketName != null)
                            message.bucketName = String(object.bucketName);
                        if (object.objectName != null)
                            message.objectName = String(object.objectName);
                        if (object.expiration != null)
                            message.expiration = object.expiration | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateSignedUrlRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @static
                     * @param {palexy.sherlock.v1.GenerateSignedUrlRequest} message GenerateSignedUrlRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateSignedUrlRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.bucketName = "";
                            object.objectName = "";
                            object.expiration = 0;
                        }
                        if (message.bucketName != null && message.hasOwnProperty("bucketName"))
                            object.bucketName = message.bucketName;
                        if (message.objectName != null && message.hasOwnProperty("objectName"))
                            object.objectName = message.objectName;
                        if (message.expiration != null && message.hasOwnProperty("expiration"))
                            object.expiration = message.expiration;
                        return object;
                    };
    
                    /**
                     * Converts this GenerateSignedUrlRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateSignedUrlRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateSignedUrlRequest;
                })();
    
                v1.GenerateSignedUrlResponse = (function() {
    
                    /**
                     * Properties of a GenerateSignedUrlResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IGenerateSignedUrlResponse
                     * @property {string|null} [url] GenerateSignedUrlResponse url
                     * @property {number|null} [expiration] GenerateSignedUrlResponse expiration
                     */
    
                    /**
                     * Constructs a new GenerateSignedUrlResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GenerateSignedUrlResponse.
                     * @implements IGenerateSignedUrlResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlResponse=} [properties] Properties to set
                     */
                    function GenerateSignedUrlResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateSignedUrlResponse url.
                     * @member {string} url
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @instance
                     */
                    GenerateSignedUrlResponse.prototype.url = "";
    
                    /**
                     * GenerateSignedUrlResponse expiration.
                     * @member {number} expiration
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @instance
                     */
                    GenerateSignedUrlResponse.prototype.expiration = 0;
    
                    /**
                     * Creates a new GenerateSignedUrlResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlResponse} GenerateSignedUrlResponse instance
                     */
                    GenerateSignedUrlResponse.create = function create(properties) {
                        return new GenerateSignedUrlResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateSignedUrlResponse message. Does not implicitly {@link palexy.sherlock.v1.GenerateSignedUrlResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlResponse} message GenerateSignedUrlResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateSignedUrlResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.url != null && Object.hasOwnProperty.call(message, "url"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.url);
                        if (message.expiration != null && Object.hasOwnProperty.call(message, "expiration"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.expiration);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateSignedUrlResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GenerateSignedUrlResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGenerateSignedUrlResponse} message GenerateSignedUrlResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateSignedUrlResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateSignedUrlResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlResponse} GenerateSignedUrlResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateSignedUrlResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GenerateSignedUrlResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.url = reader.string();
                                break;
                            case 2:
                                message.expiration = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateSignedUrlResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlResponse} GenerateSignedUrlResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateSignedUrlResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateSignedUrlResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateSignedUrlResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.url != null && message.hasOwnProperty("url"))
                            if (!$util.isString(message.url))
                                return "url: string expected";
                        if (message.expiration != null && message.hasOwnProperty("expiration"))
                            if (!$util.isInteger(message.expiration))
                                return "expiration: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a GenerateSignedUrlResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GenerateSignedUrlResponse} GenerateSignedUrlResponse
                     */
                    GenerateSignedUrlResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GenerateSignedUrlResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GenerateSignedUrlResponse();
                        if (object.url != null)
                            message.url = String(object.url);
                        if (object.expiration != null)
                            message.expiration = object.expiration | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateSignedUrlResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @static
                     * @param {palexy.sherlock.v1.GenerateSignedUrlResponse} message GenerateSignedUrlResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateSignedUrlResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.url = "";
                            object.expiration = 0;
                        }
                        if (message.url != null && message.hasOwnProperty("url"))
                            object.url = message.url;
                        if (message.expiration != null && message.hasOwnProperty("expiration"))
                            object.expiration = message.expiration;
                        return object;
                    };
    
                    /**
                     * Converts this GenerateSignedUrlResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GenerateSignedUrlResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateSignedUrlResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateSignedUrlResponse;
                })();
    
                v1.QcDataService = (function() {
    
                    /**
                     * Constructs a new QcDataService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcDataService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function QcDataService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (QcDataService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = QcDataService;
    
                    /**
                     * Creates new QcDataService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {QcDataService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    QcDataService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcDataService#uploadQcFile}.
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @typedef UploadQcFileCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.UploadQcFileResponse} [response] UploadQcFileResponse
                     */
    
                    /**
                     * Calls UploadQcFile.
                     * @function uploadQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest} request UploadQcFileRequest message or plain object
                     * @param {palexy.sherlock.v1.QcDataService.UploadQcFileCallback} callback Node-style callback called with the error, if any, and UploadQcFileResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcDataService.prototype.uploadQcFile = function uploadQcFile(request, callback) {
                        return this.rpcCall(uploadQcFile, $root.palexy.sherlock.v1.UploadQcFileRequest, $root.palexy.sherlock.v1.UploadQcFileResponse, request, callback);
                    }, "name", { value: "UploadQcFile" });
    
                    /**
                     * Calls UploadQcFile.
                     * @function uploadQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest} request UploadQcFileRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.UploadQcFileResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcDataService#createQcFile}.
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @typedef CreateQcFileCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.QcFile} [response] QcFile
                     */
    
                    /**
                     * Calls CreateQcFile.
                     * @function createQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IQcFile} request QcFile message or plain object
                     * @param {palexy.sherlock.v1.QcDataService.CreateQcFileCallback} callback Node-style callback called with the error, if any, and QcFile
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcDataService.prototype.createQcFile = function createQcFile(request, callback) {
                        return this.rpcCall(createQcFile, $root.palexy.sherlock.v1.QcFile, $root.palexy.sherlock.v1.QcFile, request, callback);
                    }, "name", { value: "CreateQcFile" });
    
                    /**
                     * Calls CreateQcFile.
                     * @function createQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IQcFile} request QcFile message or plain object
                     * @returns {Promise<palexy.sherlock.v1.QcFile>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcDataService#listQcFiles}.
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @typedef ListQcFilesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListQcFilesResponse} [response] ListQcFilesResponse
                     */
    
                    /**
                     * Calls ListQcFiles.
                     * @function listQcFiles
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcFilesRequest} request ListQcFilesRequest message or plain object
                     * @param {palexy.sherlock.v1.QcDataService.ListQcFilesCallback} callback Node-style callback called with the error, if any, and ListQcFilesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcDataService.prototype.listQcFiles = function listQcFiles(request, callback) {
                        return this.rpcCall(listQcFiles, $root.palexy.sherlock.v1.ListQcFilesRequest, $root.palexy.sherlock.v1.ListQcFilesResponse, request, callback);
                    }, "name", { value: "ListQcFiles" });
    
                    /**
                     * Calls ListQcFiles.
                     * @function listQcFiles
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcFilesRequest} request ListQcFilesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListQcFilesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcDataService#getQcFile}.
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @typedef GetQcFileCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.GetQcFileResponse} [response] GetQcFileResponse
                     */
    
                    /**
                     * Calls GetQcFile.
                     * @function getQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetQcFileRequest} request GetQcFileRequest message or plain object
                     * @param {palexy.sherlock.v1.QcDataService.GetQcFileCallback} callback Node-style callback called with the error, if any, and GetQcFileResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcDataService.prototype.getQcFile = function getQcFile(request, callback) {
                        return this.rpcCall(getQcFile, $root.palexy.sherlock.v1.GetQcFileRequest, $root.palexy.sherlock.v1.GetQcFileResponse, request, callback);
                    }, "name", { value: "GetQcFile" });
    
                    /**
                     * Calls GetQcFile.
                     * @function getQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetQcFileRequest} request GetQcFileRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.GetQcFileResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcDataService#deleteQcFile}.
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @typedef DeleteQcFileCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.DeleteQcFileResponse} [response] DeleteQcFileResponse
                     */
    
                    /**
                     * Calls DeleteQcFile.
                     * @function deleteQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest} request DeleteQcFileRequest message or plain object
                     * @param {palexy.sherlock.v1.QcDataService.DeleteQcFileCallback} callback Node-style callback called with the error, if any, and DeleteQcFileResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcDataService.prototype.deleteQcFile = function deleteQcFile(request, callback) {
                        return this.rpcCall(deleteQcFile, $root.palexy.sherlock.v1.DeleteQcFileRequest, $root.palexy.sherlock.v1.DeleteQcFileResponse, request, callback);
                    }, "name", { value: "DeleteQcFile" });
    
                    /**
                     * Calls DeleteQcFile.
                     * @function deleteQcFile
                     * @memberof palexy.sherlock.v1.QcDataService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest} request DeleteQcFileRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.DeleteQcFileResponse>} Promise
                     * @variation 2
                     */
    
                    return QcDataService;
                })();
    
                v1.UploadQcFileRequest = (function() {
    
                    /**
                     * Properties of an UploadQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUploadQcFileRequest
                     * @property {Uint8Array|null} [content] UploadQcFileRequest content
                     * @property {palexy.sherlock.v1.IQcFile|null} [qcFile] UploadQcFileRequest qcFile
                     */
    
                    /**
                     * Constructs a new UploadQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UploadQcFileRequest.
                     * @implements IUploadQcFileRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest=} [properties] Properties to set
                     */
                    function UploadQcFileRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UploadQcFileRequest content.
                     * @member {Uint8Array} content
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @instance
                     */
                    UploadQcFileRequest.prototype.content = $util.newBuffer([]);
    
                    /**
                     * UploadQcFileRequest qcFile.
                     * @member {palexy.sherlock.v1.IQcFile|null|undefined} qcFile
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @instance
                     */
                    UploadQcFileRequest.prototype.qcFile = null;
    
                    /**
                     * Creates a new UploadQcFileRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UploadQcFileRequest} UploadQcFileRequest instance
                     */
                    UploadQcFileRequest.create = function create(properties) {
                        return new UploadQcFileRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UploadQcFileRequest message. Does not implicitly {@link palexy.sherlock.v1.UploadQcFileRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest} message UploadQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadQcFileRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                            writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.content);
                        if (message.qcFile != null && Object.hasOwnProperty.call(message, "qcFile"))
                            $root.palexy.sherlock.v1.QcFile.encode(message.qcFile, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UploadQcFileRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UploadQcFileRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileRequest} message UploadQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadQcFileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UploadQcFileRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UploadQcFileRequest} UploadQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadQcFileRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UploadQcFileRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.content = reader.bytes();
                                break;
                            case 2:
                                message.qcFile = $root.palexy.sherlock.v1.QcFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UploadQcFileRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UploadQcFileRequest} UploadQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadQcFileRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UploadQcFileRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UploadQcFileRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.content != null && message.hasOwnProperty("content"))
                            if (!(message.content && typeof message.content.length === "number" || $util.isString(message.content)))
                                return "content: buffer expected";
                        if (message.qcFile != null && message.hasOwnProperty("qcFile")) {
                            var error = $root.palexy.sherlock.v1.QcFile.verify(message.qcFile);
                            if (error)
                                return "qcFile." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UploadQcFileRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UploadQcFileRequest} UploadQcFileRequest
                     */
                    UploadQcFileRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UploadQcFileRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UploadQcFileRequest();
                        if (object.content != null)
                            if (typeof object.content === "string")
                                $util.base64.decode(object.content, message.content = $util.newBuffer($util.base64.length(object.content)), 0);
                            else if (object.content.length)
                                message.content = object.content;
                        if (object.qcFile != null) {
                            if (typeof object.qcFile !== "object")
                                throw TypeError(".palexy.sherlock.v1.UploadQcFileRequest.qcFile: object expected");
                            message.qcFile = $root.palexy.sherlock.v1.QcFile.fromObject(object.qcFile);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UploadQcFileRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.UploadQcFileRequest} message UploadQcFileRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UploadQcFileRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if (options.bytes === String)
                                object.content = "";
                            else {
                                object.content = [];
                                if (options.bytes !== Array)
                                    object.content = $util.newBuffer(object.content);
                            }
                            object.qcFile = null;
                        }
                        if (message.content != null && message.hasOwnProperty("content"))
                            object.content = options.bytes === String ? $util.base64.encode(message.content, 0, message.content.length) : options.bytes === Array ? Array.prototype.slice.call(message.content) : message.content;
                        if (message.qcFile != null && message.hasOwnProperty("qcFile"))
                            object.qcFile = $root.palexy.sherlock.v1.QcFile.toObject(message.qcFile, options);
                        return object;
                    };
    
                    /**
                     * Converts this UploadQcFileRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UploadQcFileRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UploadQcFileRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UploadQcFileRequest;
                })();
    
                v1.UploadQcFileResponse = (function() {
    
                    /**
                     * Properties of an UploadQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IUploadQcFileResponse
                     * @property {palexy.sherlock.v1.IQcFile|null} [qcFile] UploadQcFileResponse qcFile
                     */
    
                    /**
                     * Constructs a new UploadQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UploadQcFileResponse.
                     * @implements IUploadQcFileResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IUploadQcFileResponse=} [properties] Properties to set
                     */
                    function UploadQcFileResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UploadQcFileResponse qcFile.
                     * @member {palexy.sherlock.v1.IQcFile|null|undefined} qcFile
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @instance
                     */
                    UploadQcFileResponse.prototype.qcFile = null;
    
                    /**
                     * Creates a new UploadQcFileResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UploadQcFileResponse} UploadQcFileResponse instance
                     */
                    UploadQcFileResponse.create = function create(properties) {
                        return new UploadQcFileResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UploadQcFileResponse message. Does not implicitly {@link palexy.sherlock.v1.UploadQcFileResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileResponse} message UploadQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadQcFileResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFile != null && Object.hasOwnProperty.call(message, "qcFile"))
                            $root.palexy.sherlock.v1.QcFile.encode(message.qcFile, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UploadQcFileResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UploadQcFileResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUploadQcFileResponse} message UploadQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadQcFileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UploadQcFileResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UploadQcFileResponse} UploadQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadQcFileResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UploadQcFileResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.qcFile = $root.palexy.sherlock.v1.QcFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UploadQcFileResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UploadQcFileResponse} UploadQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadQcFileResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UploadQcFileResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UploadQcFileResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFile != null && message.hasOwnProperty("qcFile")) {
                            var error = $root.palexy.sherlock.v1.QcFile.verify(message.qcFile);
                            if (error)
                                return "qcFile." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UploadQcFileResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UploadQcFileResponse} UploadQcFileResponse
                     */
                    UploadQcFileResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UploadQcFileResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UploadQcFileResponse();
                        if (object.qcFile != null) {
                            if (typeof object.qcFile !== "object")
                                throw TypeError(".palexy.sherlock.v1.UploadQcFileResponse.qcFile: object expected");
                            message.qcFile = $root.palexy.sherlock.v1.QcFile.fromObject(object.qcFile);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UploadQcFileResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.UploadQcFileResponse} message UploadQcFileResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UploadQcFileResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.qcFile = null;
                        if (message.qcFile != null && message.hasOwnProperty("qcFile"))
                            object.qcFile = $root.palexy.sherlock.v1.QcFile.toObject(message.qcFile, options);
                        return object;
                    };
    
                    /**
                     * Converts this UploadQcFileResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UploadQcFileResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UploadQcFileResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UploadQcFileResponse;
                })();
    
                v1.QcFile = (function() {
    
                    /**
                     * Properties of a QcFile.
                     * @memberof palexy.sherlock.v1
                     * @interface IQcFile
                     * @property {string|null} [name] QcFile name
                     * @property {palexy.sherlock.v1.QcFile.FileType|null} [fileType] QcFile fileType
                     * @property {number|null} [storeId] QcFile storeId
                     * @property {string|null} [fileName] QcFile fileName
                     * @property {palexy.sherlock.v1.QcFile.QcType|null} [qcType] QcFile qcType
                     * @property {string|null} [dateId] QcFile dateId
                     * @property {palexy.sherlock.v1.IQcFileData|null} [qcFileData] QcFile qcFileData
                     * @property {number|null} [createTimeMs] QcFile createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] QcFile lastUpdateTimeMs
                     * @property {number|null} [id] QcFile id
                     * @property {number|null} [startHour] QcFile startHour
                     * @property {number|null} [endHour] QcFile endHour
                     */
    
                    /**
                     * Constructs a new QcFile.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcFile.
                     * @implements IQcFile
                     * @constructor
                     * @param {palexy.sherlock.v1.IQcFile=} [properties] Properties to set
                     */
                    function QcFile(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QcFile name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.name = "";
    
                    /**
                     * QcFile fileType.
                     * @member {palexy.sherlock.v1.QcFile.FileType} fileType
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.fileType = 0;
    
                    /**
                     * QcFile storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcFile fileName.
                     * @member {string} fileName
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.fileName = "";
    
                    /**
                     * QcFile qcType.
                     * @member {palexy.sherlock.v1.QcFile.QcType} qcType
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.qcType = 0;
    
                    /**
                     * QcFile dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.dateId = "";
    
                    /**
                     * QcFile qcFileData.
                     * @member {palexy.sherlock.v1.IQcFileData|null|undefined} qcFileData
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.qcFileData = null;
    
                    /**
                     * QcFile createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcFile lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcFile id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcFile startHour.
                     * @member {number} startHour
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.startHour = 0;
    
                    /**
                     * QcFile endHour.
                     * @member {number} endHour
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     */
                    QcFile.prototype.endHour = 0;
    
                    /**
                     * Creates a new QcFile instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {palexy.sherlock.v1.IQcFile=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.QcFile} QcFile instance
                     */
                    QcFile.create = function create(properties) {
                        return new QcFile(properties);
                    };
    
                    /**
                     * Encodes the specified QcFile message. Does not implicitly {@link palexy.sherlock.v1.QcFile.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {palexy.sherlock.v1.IQcFile} message QcFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcFile.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.fileType);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fileName);
                        if (message.qcType != null && Object.hasOwnProperty.call(message, "qcType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.qcType);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.dateId);
                        if (message.qcFileData != null && Object.hasOwnProperty.call(message, "qcFileData"))
                            $root.palexy.sherlock.v1.QcFileData.encode(message.qcFileData, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.id);
                        if (message.startHour != null && Object.hasOwnProperty.call(message, "startHour"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.startHour);
                        if (message.endHour != null && Object.hasOwnProperty.call(message, "endHour"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.endHour);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QcFile message, length delimited. Does not implicitly {@link palexy.sherlock.v1.QcFile.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {palexy.sherlock.v1.IQcFile} message QcFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcFile.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QcFile message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.QcFile} QcFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcFile.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.QcFile();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.fileType = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.fileName = reader.string();
                                break;
                            case 5:
                                message.qcType = reader.int32();
                                break;
                            case 6:
                                message.dateId = reader.string();
                                break;
                            case 7:
                                message.qcFileData = $root.palexy.sherlock.v1.QcFileData.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.createTimeMs = reader.int64();
                                break;
                            case 9:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 10:
                                message.id = reader.int64();
                                break;
                            case 11:
                                message.startHour = reader.int32();
                                break;
                            case 12:
                                message.endHour = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QcFile message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.QcFile} QcFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcFile.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QcFile message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QcFile.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.fileType != null && message.hasOwnProperty("fileType"))
                            switch (message.fileType) {
                            default:
                                return "fileType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            switch (message.qcType) {
                            default:
                                return "qcType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.qcFileData != null && message.hasOwnProperty("qcFileData")) {
                            var error = $root.palexy.sherlock.v1.QcFileData.verify(message.qcFileData);
                            if (error)
                                return "qcFileData." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            if (!$util.isInteger(message.startHour))
                                return "startHour: integer expected";
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            if (!$util.isInteger(message.endHour))
                                return "endHour: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a QcFile message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.QcFile} QcFile
                     */
                    QcFile.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.QcFile)
                            return object;
                        var message = new $root.palexy.sherlock.v1.QcFile();
                        if (object.name != null)
                            message.name = String(object.name);
                        switch (object.fileType) {
                        case "UNKNOWN":
                        case 0:
                            message.fileType = 0;
                            break;
                        case "CSV":
                        case 1:
                            message.fileType = 1;
                            break;
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        switch (object.qcType) {
                        case "QC_TYPE_UNKNOWN":
                        case 0:
                            message.qcType = 0;
                            break;
                        case "ICA_STANDARD_COUNTING":
                        case 1:
                            message.qcType = 1;
                            break;
                        case "ICA_CUSTOMER_JOURNEY":
                        case 2:
                            message.qcType = 2;
                            break;
                        case "ICA_ENTRANCE_COUNTING":
                        case 3:
                            message.qcType = 3;
                            break;
                        case "ICA_PASSBY_COUNTING":
                        case 4:
                            message.qcType = 4;
                            break;
                        case "ICA_FNB_QUEUE_METRIC":
                        case 5:
                            message.qcType = 5;
                            break;
                        case "ICA_FNB_QUEUE_METRIC_PER_PERSON":
                        case 6:
                            message.qcType = 6;
                            break;
                        }
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.qcFileData != null) {
                            if (typeof object.qcFileData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFile.qcFileData: object expected");
                            message.qcFileData = $root.palexy.sherlock.v1.QcFileData.fromObject(object.qcFileData);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.startHour != null)
                            message.startHour = object.startHour | 0;
                        if (object.endHour != null)
                            message.endHour = object.endHour | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QcFile message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.QcFile
                     * @static
                     * @param {palexy.sherlock.v1.QcFile} message QcFile
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QcFile.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.fileType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.fileName = "";
                            object.qcType = options.enums === String ? "QC_TYPE_UNKNOWN" : 0;
                            object.dateId = "";
                            object.qcFileData = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.startHour = 0;
                            object.endHour = 0;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.fileType != null && message.hasOwnProperty("fileType"))
                            object.fileType = options.enums === String ? $root.palexy.sherlock.v1.QcFile.FileType[message.fileType] : message.fileType;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            object.qcType = options.enums === String ? $root.palexy.sherlock.v1.QcFile.QcType[message.qcType] : message.qcType;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.qcFileData != null && message.hasOwnProperty("qcFileData"))
                            object.qcFileData = $root.palexy.sherlock.v1.QcFileData.toObject(message.qcFileData, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.startHour != null && message.hasOwnProperty("startHour"))
                            object.startHour = message.startHour;
                        if (message.endHour != null && message.hasOwnProperty("endHour"))
                            object.endHour = message.endHour;
                        return object;
                    };
    
                    /**
                     * Converts this QcFile to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.QcFile
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QcFile.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FileType enum.
                     * @name palexy.sherlock.v1.QcFile.FileType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} CSV=1 CSV value
                     */
                    QcFile.FileType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "CSV"] = 1;
                        return values;
                    })();
    
                    /**
                     * QcType enum.
                     * @name palexy.sherlock.v1.QcFile.QcType
                     * @enum {number}
                     * @property {number} QC_TYPE_UNKNOWN=0 QC_TYPE_UNKNOWN value
                     * @property {number} ICA_STANDARD_COUNTING=1 ICA_STANDARD_COUNTING value
                     * @property {number} ICA_CUSTOMER_JOURNEY=2 ICA_CUSTOMER_JOURNEY value
                     * @property {number} ICA_ENTRANCE_COUNTING=3 ICA_ENTRANCE_COUNTING value
                     * @property {number} ICA_PASSBY_COUNTING=4 ICA_PASSBY_COUNTING value
                     * @property {number} ICA_FNB_QUEUE_METRIC=5 ICA_FNB_QUEUE_METRIC value
                     * @property {number} ICA_FNB_QUEUE_METRIC_PER_PERSON=6 ICA_FNB_QUEUE_METRIC_PER_PERSON value
                     */
                    QcFile.QcType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "QC_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "ICA_STANDARD_COUNTING"] = 1;
                        values[valuesById[2] = "ICA_CUSTOMER_JOURNEY"] = 2;
                        values[valuesById[3] = "ICA_ENTRANCE_COUNTING"] = 3;
                        values[valuesById[4] = "ICA_PASSBY_COUNTING"] = 4;
                        values[valuesById[5] = "ICA_FNB_QUEUE_METRIC"] = 5;
                        values[valuesById[6] = "ICA_FNB_QUEUE_METRIC_PER_PERSON"] = 6;
                        return values;
                    })();
    
                    return QcFile;
                })();
    
                v1.QcFileData = (function() {
    
                    /**
                     * Properties of a QcFileData.
                     * @memberof palexy.sherlock.v1
                     * @interface IQcFileData
                     * @property {palexy.sherlock.v1.IIcaStandardCountingData|null} [icaStandarCountingData] QcFileData icaStandarCountingData
                     * @property {palexy.sherlock.v1.IIcaCustomerJourneyData|null} [icaCustomerJourneyData] QcFileData icaCustomerJourneyData
                     * @property {palexy.sherlock.v1.IIcaEntranceCountingData|null} [icaEntranceCountingData] QcFileData icaEntranceCountingData
                     * @property {palexy.sherlock.v1.IIcaPassbyCountingData|null} [icaPassbyCountingData] QcFileData icaPassbyCountingData
                     * @property {palexy.sherlock.v1.IIcaFnBQueueMetricData|null} [icaFnbQueueMetricData] QcFileData icaFnbQueueMetricData
                     */
    
                    /**
                     * Constructs a new QcFileData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcFileData.
                     * @implements IQcFileData
                     * @constructor
                     * @param {palexy.sherlock.v1.IQcFileData=} [properties] Properties to set
                     */
                    function QcFileData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QcFileData icaStandarCountingData.
                     * @member {palexy.sherlock.v1.IIcaStandardCountingData|null|undefined} icaStandarCountingData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    QcFileData.prototype.icaStandarCountingData = null;
    
                    /**
                     * QcFileData icaCustomerJourneyData.
                     * @member {palexy.sherlock.v1.IIcaCustomerJourneyData|null|undefined} icaCustomerJourneyData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    QcFileData.prototype.icaCustomerJourneyData = null;
    
                    /**
                     * QcFileData icaEntranceCountingData.
                     * @member {palexy.sherlock.v1.IIcaEntranceCountingData|null|undefined} icaEntranceCountingData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    QcFileData.prototype.icaEntranceCountingData = null;
    
                    /**
                     * QcFileData icaPassbyCountingData.
                     * @member {palexy.sherlock.v1.IIcaPassbyCountingData|null|undefined} icaPassbyCountingData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    QcFileData.prototype.icaPassbyCountingData = null;
    
                    /**
                     * QcFileData icaFnbQueueMetricData.
                     * @member {palexy.sherlock.v1.IIcaFnBQueueMetricData|null|undefined} icaFnbQueueMetricData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    QcFileData.prototype.icaFnbQueueMetricData = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * QcFileData qcFileDetailData.
                     * @member {"icaStandarCountingData"|"icaCustomerJourneyData"|"icaEntranceCountingData"|"icaPassbyCountingData"|"icaFnbQueueMetricData"|undefined} qcFileDetailData
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     */
                    Object.defineProperty(QcFileData.prototype, "qcFileDetailData", {
                        get: $util.oneOfGetter($oneOfFields = ["icaStandarCountingData", "icaCustomerJourneyData", "icaEntranceCountingData", "icaPassbyCountingData", "icaFnbQueueMetricData"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new QcFileData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {palexy.sherlock.v1.IQcFileData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.QcFileData} QcFileData instance
                     */
                    QcFileData.create = function create(properties) {
                        return new QcFileData(properties);
                    };
    
                    /**
                     * Encodes the specified QcFileData message. Does not implicitly {@link palexy.sherlock.v1.QcFileData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {palexy.sherlock.v1.IQcFileData} message QcFileData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcFileData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.icaStandarCountingData != null && Object.hasOwnProperty.call(message, "icaStandarCountingData"))
                            $root.palexy.sherlock.v1.IcaStandardCountingData.encode(message.icaStandarCountingData, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.icaCustomerJourneyData != null && Object.hasOwnProperty.call(message, "icaCustomerJourneyData"))
                            $root.palexy.sherlock.v1.IcaCustomerJourneyData.encode(message.icaCustomerJourneyData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.icaEntranceCountingData != null && Object.hasOwnProperty.call(message, "icaEntranceCountingData"))
                            $root.palexy.sherlock.v1.IcaEntranceCountingData.encode(message.icaEntranceCountingData, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.icaPassbyCountingData != null && Object.hasOwnProperty.call(message, "icaPassbyCountingData"))
                            $root.palexy.sherlock.v1.IcaPassbyCountingData.encode(message.icaPassbyCountingData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.icaFnbQueueMetricData != null && Object.hasOwnProperty.call(message, "icaFnbQueueMetricData"))
                            $root.palexy.sherlock.v1.IcaFnBQueueMetricData.encode(message.icaFnbQueueMetricData, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QcFileData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.QcFileData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {palexy.sherlock.v1.IQcFileData} message QcFileData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcFileData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QcFileData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.QcFileData} QcFileData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcFileData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.QcFileData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.icaStandarCountingData = $root.palexy.sherlock.v1.IcaStandardCountingData.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.icaCustomerJourneyData = $root.palexy.sherlock.v1.IcaCustomerJourneyData.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.icaEntranceCountingData = $root.palexy.sherlock.v1.IcaEntranceCountingData.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.icaPassbyCountingData = $root.palexy.sherlock.v1.IcaPassbyCountingData.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.icaFnbQueueMetricData = $root.palexy.sherlock.v1.IcaFnBQueueMetricData.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QcFileData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.QcFileData} QcFileData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcFileData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QcFileData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QcFileData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.icaStandarCountingData != null && message.hasOwnProperty("icaStandarCountingData")) {
                            properties.qcFileDetailData = 1;
                            {
                                var error = $root.palexy.sherlock.v1.IcaStandardCountingData.verify(message.icaStandarCountingData);
                                if (error)
                                    return "icaStandarCountingData." + error;
                            }
                        }
                        if (message.icaCustomerJourneyData != null && message.hasOwnProperty("icaCustomerJourneyData")) {
                            if (properties.qcFileDetailData === 1)
                                return "qcFileDetailData: multiple values";
                            properties.qcFileDetailData = 1;
                            {
                                var error = $root.palexy.sherlock.v1.IcaCustomerJourneyData.verify(message.icaCustomerJourneyData);
                                if (error)
                                    return "icaCustomerJourneyData." + error;
                            }
                        }
                        if (message.icaEntranceCountingData != null && message.hasOwnProperty("icaEntranceCountingData")) {
                            if (properties.qcFileDetailData === 1)
                                return "qcFileDetailData: multiple values";
                            properties.qcFileDetailData = 1;
                            {
                                var error = $root.palexy.sherlock.v1.IcaEntranceCountingData.verify(message.icaEntranceCountingData);
                                if (error)
                                    return "icaEntranceCountingData." + error;
                            }
                        }
                        if (message.icaPassbyCountingData != null && message.hasOwnProperty("icaPassbyCountingData")) {
                            if (properties.qcFileDetailData === 1)
                                return "qcFileDetailData: multiple values";
                            properties.qcFileDetailData = 1;
                            {
                                var error = $root.palexy.sherlock.v1.IcaPassbyCountingData.verify(message.icaPassbyCountingData);
                                if (error)
                                    return "icaPassbyCountingData." + error;
                            }
                        }
                        if (message.icaFnbQueueMetricData != null && message.hasOwnProperty("icaFnbQueueMetricData")) {
                            if (properties.qcFileDetailData === 1)
                                return "qcFileDetailData: multiple values";
                            properties.qcFileDetailData = 1;
                            {
                                var error = $root.palexy.sherlock.v1.IcaFnBQueueMetricData.verify(message.icaFnbQueueMetricData);
                                if (error)
                                    return "icaFnbQueueMetricData." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a QcFileData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.QcFileData} QcFileData
                     */
                    QcFileData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.QcFileData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.QcFileData();
                        if (object.icaStandarCountingData != null) {
                            if (typeof object.icaStandarCountingData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFileData.icaStandarCountingData: object expected");
                            message.icaStandarCountingData = $root.palexy.sherlock.v1.IcaStandardCountingData.fromObject(object.icaStandarCountingData);
                        }
                        if (object.icaCustomerJourneyData != null) {
                            if (typeof object.icaCustomerJourneyData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFileData.icaCustomerJourneyData: object expected");
                            message.icaCustomerJourneyData = $root.palexy.sherlock.v1.IcaCustomerJourneyData.fromObject(object.icaCustomerJourneyData);
                        }
                        if (object.icaEntranceCountingData != null) {
                            if (typeof object.icaEntranceCountingData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFileData.icaEntranceCountingData: object expected");
                            message.icaEntranceCountingData = $root.palexy.sherlock.v1.IcaEntranceCountingData.fromObject(object.icaEntranceCountingData);
                        }
                        if (object.icaPassbyCountingData != null) {
                            if (typeof object.icaPassbyCountingData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFileData.icaPassbyCountingData: object expected");
                            message.icaPassbyCountingData = $root.palexy.sherlock.v1.IcaPassbyCountingData.fromObject(object.icaPassbyCountingData);
                        }
                        if (object.icaFnbQueueMetricData != null) {
                            if (typeof object.icaFnbQueueMetricData !== "object")
                                throw TypeError(".palexy.sherlock.v1.QcFileData.icaFnbQueueMetricData: object expected");
                            message.icaFnbQueueMetricData = $root.palexy.sherlock.v1.IcaFnBQueueMetricData.fromObject(object.icaFnbQueueMetricData);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QcFileData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @static
                     * @param {palexy.sherlock.v1.QcFileData} message QcFileData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QcFileData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.icaStandarCountingData != null && message.hasOwnProperty("icaStandarCountingData")) {
                            object.icaStandarCountingData = $root.palexy.sherlock.v1.IcaStandardCountingData.toObject(message.icaStandarCountingData, options);
                            if (options.oneofs)
                                object.qcFileDetailData = "icaStandarCountingData";
                        }
                        if (message.icaCustomerJourneyData != null && message.hasOwnProperty("icaCustomerJourneyData")) {
                            object.icaCustomerJourneyData = $root.palexy.sherlock.v1.IcaCustomerJourneyData.toObject(message.icaCustomerJourneyData, options);
                            if (options.oneofs)
                                object.qcFileDetailData = "icaCustomerJourneyData";
                        }
                        if (message.icaEntranceCountingData != null && message.hasOwnProperty("icaEntranceCountingData")) {
                            object.icaEntranceCountingData = $root.palexy.sherlock.v1.IcaEntranceCountingData.toObject(message.icaEntranceCountingData, options);
                            if (options.oneofs)
                                object.qcFileDetailData = "icaEntranceCountingData";
                        }
                        if (message.icaPassbyCountingData != null && message.hasOwnProperty("icaPassbyCountingData")) {
                            object.icaPassbyCountingData = $root.palexy.sherlock.v1.IcaPassbyCountingData.toObject(message.icaPassbyCountingData, options);
                            if (options.oneofs)
                                object.qcFileDetailData = "icaPassbyCountingData";
                        }
                        if (message.icaFnbQueueMetricData != null && message.hasOwnProperty("icaFnbQueueMetricData")) {
                            object.icaFnbQueueMetricData = $root.palexy.sherlock.v1.IcaFnBQueueMetricData.toObject(message.icaFnbQueueMetricData, options);
                            if (options.oneofs)
                                object.qcFileDetailData = "icaFnbQueueMetricData";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this QcFileData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.QcFileData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QcFileData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QcFileData;
                })();
    
                v1.IcaStandardCountingData = (function() {
    
                    /**
                     * Properties of an IcaStandardCountingData.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaStandardCountingData
                     * @property {Array.<palexy.sherlock.v1.IIcaStandardCountingDataRow>|null} [rows] IcaStandardCountingData rows
                     */
    
                    /**
                     * Constructs a new IcaStandardCountingData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaStandardCountingData.
                     * @implements IIcaStandardCountingData
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaStandardCountingData=} [properties] Properties to set
                     */
                    function IcaStandardCountingData(properties) {
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaStandardCountingData rows.
                     * @member {Array.<palexy.sherlock.v1.IIcaStandardCountingDataRow>} rows
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @instance
                     */
                    IcaStandardCountingData.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new IcaStandardCountingData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaStandardCountingData} IcaStandardCountingData instance
                     */
                    IcaStandardCountingData.create = function create(properties) {
                        return new IcaStandardCountingData(properties);
                    };
    
                    /**
                     * Encodes the specified IcaStandardCountingData message. Does not implicitly {@link palexy.sherlock.v1.IcaStandardCountingData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingData} message IcaStandardCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaStandardCountingData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.sherlock.v1.IcaStandardCountingDataRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaStandardCountingData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaStandardCountingData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingData} message IcaStandardCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaStandardCountingData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaStandardCountingData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaStandardCountingData} IcaStandardCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaStandardCountingData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaStandardCountingData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.sherlock.v1.IcaStandardCountingDataRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaStandardCountingData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaStandardCountingData} IcaStandardCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaStandardCountingData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaStandardCountingData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaStandardCountingData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.sherlock.v1.IcaStandardCountingDataRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IcaStandardCountingData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaStandardCountingData} IcaStandardCountingData
                     */
                    IcaStandardCountingData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaStandardCountingData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaStandardCountingData();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.sherlock.v1.IcaStandardCountingData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.IcaStandardCountingData.rows: object expected");
                                message.rows[i] = $root.palexy.sherlock.v1.IcaStandardCountingDataRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaStandardCountingData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IcaStandardCountingData} message IcaStandardCountingData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaStandardCountingData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rows = [];
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.sherlock.v1.IcaStandardCountingDataRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IcaStandardCountingData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaStandardCountingData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaStandardCountingData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaStandardCountingData;
                })();
    
                v1.IcaStandardCountingDataRow = (function() {
    
                    /**
                     * Properties of an IcaStandardCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaStandardCountingDataRow
                     * @property {string|null} [visitorId] IcaStandardCountingDataRow visitorId
                     * @property {palexy.sherlock.v1.IcaStandardCountingDataRow.Gender|null} [gender] IcaStandardCountingDataRow gender
                     * @property {palexy.streaming.v1.AgeGroup|null} [ageGroup] IcaStandardCountingDataRow ageGroup
                     * @property {string|null} [startTime] IcaStandardCountingDataRow startTime
                     * @property {string|null} [endTime] IcaStandardCountingDataRow endTime
                     * @property {palexy.sherlock.v1.IcaStandardCountingDataRow.PurchaseType|null} [purchaseType] IcaStandardCountingDataRow purchaseType
                     * @property {boolean|null} [hasInteraction] IcaStandardCountingDataRow hasInteraction
                     * @property {boolean|null} [isStaff] IcaStandardCountingDataRow isStaff
                     * @property {string|null} [groupId] IcaStandardCountingDataRow groupId
                     * @property {string|null} [firstInteractionTime] IcaStandardCountingDataRow firstInteractionTime
                     * @property {string|null} [firstGreetingTime] IcaStandardCountingDataRow firstGreetingTime
                     */
    
                    /**
                     * Constructs a new IcaStandardCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaStandardCountingDataRow.
                     * @implements IIcaStandardCountingDataRow
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaStandardCountingDataRow=} [properties] Properties to set
                     */
                    function IcaStandardCountingDataRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaStandardCountingDataRow visitorId.
                     * @member {string} visitorId
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.visitorId = "";
    
                    /**
                     * IcaStandardCountingDataRow gender.
                     * @member {palexy.sherlock.v1.IcaStandardCountingDataRow.Gender} gender
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.gender = 0;
    
                    /**
                     * IcaStandardCountingDataRow ageGroup.
                     * @member {palexy.streaming.v1.AgeGroup} ageGroup
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.ageGroup = 0;
    
                    /**
                     * IcaStandardCountingDataRow startTime.
                     * @member {string} startTime
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.startTime = "";
    
                    /**
                     * IcaStandardCountingDataRow endTime.
                     * @member {string} endTime
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.endTime = "";
    
                    /**
                     * IcaStandardCountingDataRow purchaseType.
                     * @member {palexy.sherlock.v1.IcaStandardCountingDataRow.PurchaseType} purchaseType
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.purchaseType = 0;
    
                    /**
                     * IcaStandardCountingDataRow hasInteraction.
                     * @member {boolean} hasInteraction
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.hasInteraction = false;
    
                    /**
                     * IcaStandardCountingDataRow isStaff.
                     * @member {boolean} isStaff
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.isStaff = false;
    
                    /**
                     * IcaStandardCountingDataRow groupId.
                     * @member {string} groupId
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.groupId = "";
    
                    /**
                     * IcaStandardCountingDataRow firstInteractionTime.
                     * @member {string} firstInteractionTime
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.firstInteractionTime = "";
    
                    /**
                     * IcaStandardCountingDataRow firstGreetingTime.
                     * @member {string} firstGreetingTime
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     */
                    IcaStandardCountingDataRow.prototype.firstGreetingTime = "";
    
                    /**
                     * Creates a new IcaStandardCountingDataRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingDataRow=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaStandardCountingDataRow} IcaStandardCountingDataRow instance
                     */
                    IcaStandardCountingDataRow.create = function create(properties) {
                        return new IcaStandardCountingDataRow(properties);
                    };
    
                    /**
                     * Encodes the specified IcaStandardCountingDataRow message. Does not implicitly {@link palexy.sherlock.v1.IcaStandardCountingDataRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingDataRow} message IcaStandardCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaStandardCountingDataRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.visitorId != null && Object.hasOwnProperty.call(message, "visitorId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.visitorId);
                        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.gender);
                        if (message.ageGroup != null && Object.hasOwnProperty.call(message, "ageGroup"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ageGroup);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.endTime);
                        if (message.purchaseType != null && Object.hasOwnProperty.call(message, "purchaseType"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.purchaseType);
                        if (message.hasInteraction != null && Object.hasOwnProperty.call(message, "hasInteraction"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.hasInteraction);
                        if (message.isStaff != null && Object.hasOwnProperty.call(message, "isStaff"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isStaff);
                        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.groupId);
                        if (message.firstInteractionTime != null && Object.hasOwnProperty.call(message, "firstInteractionTime"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.firstInteractionTime);
                        if (message.firstGreetingTime != null && Object.hasOwnProperty.call(message, "firstGreetingTime"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.firstGreetingTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaStandardCountingDataRow message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaStandardCountingDataRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaStandardCountingDataRow} message IcaStandardCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaStandardCountingDataRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaStandardCountingDataRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaStandardCountingDataRow} IcaStandardCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaStandardCountingDataRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaStandardCountingDataRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.visitorId = reader.string();
                                break;
                            case 2:
                                message.gender = reader.int32();
                                break;
                            case 3:
                                message.ageGroup = reader.int32();
                                break;
                            case 4:
                                message.startTime = reader.string();
                                break;
                            case 5:
                                message.endTime = reader.string();
                                break;
                            case 6:
                                message.purchaseType = reader.int32();
                                break;
                            case 7:
                                message.hasInteraction = reader.bool();
                                break;
                            case 8:
                                message.isStaff = reader.bool();
                                break;
                            case 9:
                                message.groupId = reader.string();
                                break;
                            case 10:
                                message.firstInteractionTime = reader.string();
                                break;
                            case 11:
                                message.firstGreetingTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaStandardCountingDataRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaStandardCountingDataRow} IcaStandardCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaStandardCountingDataRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaStandardCountingDataRow message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaStandardCountingDataRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            if (!$util.isString(message.visitorId))
                                return "visitorId: string expected";
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            switch (message.gender) {
                            default:
                                return "gender: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.ageGroup != null && message.hasOwnProperty("ageGroup"))
                            switch (message.ageGroup) {
                            default:
                                return "ageGroup: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.purchaseType != null && message.hasOwnProperty("purchaseType"))
                            switch (message.purchaseType) {
                            default:
                                return "purchaseType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.hasInteraction != null && message.hasOwnProperty("hasInteraction"))
                            if (typeof message.hasInteraction !== "boolean")
                                return "hasInteraction: boolean expected";
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            if (typeof message.isStaff !== "boolean")
                                return "isStaff: boolean expected";
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            if (!$util.isString(message.groupId))
                                return "groupId: string expected";
                        if (message.firstInteractionTime != null && message.hasOwnProperty("firstInteractionTime"))
                            if (!$util.isString(message.firstInteractionTime))
                                return "firstInteractionTime: string expected";
                        if (message.firstGreetingTime != null && message.hasOwnProperty("firstGreetingTime"))
                            if (!$util.isString(message.firstGreetingTime))
                                return "firstGreetingTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an IcaStandardCountingDataRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaStandardCountingDataRow} IcaStandardCountingDataRow
                     */
                    IcaStandardCountingDataRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaStandardCountingDataRow)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaStandardCountingDataRow();
                        if (object.visitorId != null)
                            message.visitorId = String(object.visitorId);
                        switch (object.gender) {
                        case "U":
                        case 0:
                            message.gender = 0;
                            break;
                        case "F":
                        case 1:
                            message.gender = 1;
                            break;
                        case "M":
                        case 2:
                            message.gender = 2;
                            break;
                        }
                        switch (object.ageGroup) {
                        case "UNKNOWN_AGE_GROUP":
                        case 0:
                            message.ageGroup = 0;
                            break;
                        case "G_LESS_THAN_12":
                        case 1:
                            message.ageGroup = 1;
                            break;
                        case "G_12_20":
                        case 2:
                            message.ageGroup = 2;
                            break;
                        case "G_20_30":
                        case 3:
                            message.ageGroup = 3;
                            break;
                        case "G_30_40":
                        case 4:
                            message.ageGroup = 4;
                            break;
                        case "G_GREATER_THAN_40":
                        case 5:
                            message.ageGroup = 5;
                            break;
                        }
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        switch (object.purchaseType) {
                        case "PURCHASE_TYPE_UNKNOWN":
                        case 0:
                            message.purchaseType = 0;
                            break;
                        case "HAS_PURCHASE":
                        case 1:
                            message.purchaseType = 1;
                            break;
                        case "NO_PURCHASE":
                        case 2:
                            message.purchaseType = 2;
                            break;
                        case "GROUP_PURCHASE":
                        case 3:
                            message.purchaseType = 3;
                            break;
                        }
                        if (object.hasInteraction != null)
                            message.hasInteraction = Boolean(object.hasInteraction);
                        if (object.isStaff != null)
                            message.isStaff = Boolean(object.isStaff);
                        if (object.groupId != null)
                            message.groupId = String(object.groupId);
                        if (object.firstInteractionTime != null)
                            message.firstInteractionTime = String(object.firstInteractionTime);
                        if (object.firstGreetingTime != null)
                            message.firstGreetingTime = String(object.firstGreetingTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaStandardCountingDataRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IcaStandardCountingDataRow} message IcaStandardCountingDataRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaStandardCountingDataRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.visitorId = "";
                            object.gender = options.enums === String ? "U" : 0;
                            object.ageGroup = options.enums === String ? "UNKNOWN_AGE_GROUP" : 0;
                            object.startTime = "";
                            object.endTime = "";
                            object.purchaseType = options.enums === String ? "PURCHASE_TYPE_UNKNOWN" : 0;
                            object.hasInteraction = false;
                            object.isStaff = false;
                            object.groupId = "";
                            object.firstInteractionTime = "";
                            object.firstGreetingTime = "";
                        }
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            object.visitorId = message.visitorId;
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            object.gender = options.enums === String ? $root.palexy.sherlock.v1.IcaStandardCountingDataRow.Gender[message.gender] : message.gender;
                        if (message.ageGroup != null && message.hasOwnProperty("ageGroup"))
                            object.ageGroup = options.enums === String ? $root.palexy.streaming.v1.AgeGroup[message.ageGroup] : message.ageGroup;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.purchaseType != null && message.hasOwnProperty("purchaseType"))
                            object.purchaseType = options.enums === String ? $root.palexy.sherlock.v1.IcaStandardCountingDataRow.PurchaseType[message.purchaseType] : message.purchaseType;
                        if (message.hasInteraction != null && message.hasOwnProperty("hasInteraction"))
                            object.hasInteraction = message.hasInteraction;
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            object.isStaff = message.isStaff;
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            object.groupId = message.groupId;
                        if (message.firstInteractionTime != null && message.hasOwnProperty("firstInteractionTime"))
                            object.firstInteractionTime = message.firstInteractionTime;
                        if (message.firstGreetingTime != null && message.hasOwnProperty("firstGreetingTime"))
                            object.firstGreetingTime = message.firstGreetingTime;
                        return object;
                    };
    
                    /**
                     * Converts this IcaStandardCountingDataRow to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaStandardCountingDataRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaStandardCountingDataRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Gender enum.
                     * @name palexy.sherlock.v1.IcaStandardCountingDataRow.Gender
                     * @enum {number}
                     * @property {number} U=0 U value
                     * @property {number} F=1 F value
                     * @property {number} M=2 M value
                     */
                    IcaStandardCountingDataRow.Gender = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "U"] = 0;
                        values[valuesById[1] = "F"] = 1;
                        values[valuesById[2] = "M"] = 2;
                        return values;
                    })();
    
                    /**
                     * PurchaseType enum.
                     * @name palexy.sherlock.v1.IcaStandardCountingDataRow.PurchaseType
                     * @enum {number}
                     * @property {number} PURCHASE_TYPE_UNKNOWN=0 PURCHASE_TYPE_UNKNOWN value
                     * @property {number} HAS_PURCHASE=1 HAS_PURCHASE value
                     * @property {number} NO_PURCHASE=2 NO_PURCHASE value
                     * @property {number} GROUP_PURCHASE=3 GROUP_PURCHASE value
                     */
                    IcaStandardCountingDataRow.PurchaseType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PURCHASE_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "HAS_PURCHASE"] = 1;
                        values[valuesById[2] = "NO_PURCHASE"] = 2;
                        values[valuesById[3] = "GROUP_PURCHASE"] = 3;
                        return values;
                    })();
    
                    return IcaStandardCountingDataRow;
                })();
    
                v1.IcaCustomerJourneyData = (function() {
    
                    /**
                     * Properties of an IcaCustomerJourneyData.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaCustomerJourneyData
                     * @property {Array.<palexy.sherlock.v1.IIcaCustomerJourneyDataRow>|null} [rows] IcaCustomerJourneyData rows
                     * @property {Array.<string>|null} [sections] IcaCustomerJourneyData sections
                     */
    
                    /**
                     * Constructs a new IcaCustomerJourneyData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaCustomerJourneyData.
                     * @implements IIcaCustomerJourneyData
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyData=} [properties] Properties to set
                     */
                    function IcaCustomerJourneyData(properties) {
                        this.rows = [];
                        this.sections = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaCustomerJourneyData rows.
                     * @member {Array.<palexy.sherlock.v1.IIcaCustomerJourneyDataRow>} rows
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @instance
                     */
                    IcaCustomerJourneyData.prototype.rows = $util.emptyArray;
    
                    /**
                     * IcaCustomerJourneyData sections.
                     * @member {Array.<string>} sections
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @instance
                     */
                    IcaCustomerJourneyData.prototype.sections = $util.emptyArray;
    
                    /**
                     * Creates a new IcaCustomerJourneyData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyData} IcaCustomerJourneyData instance
                     */
                    IcaCustomerJourneyData.create = function create(properties) {
                        return new IcaCustomerJourneyData(properties);
                    };
    
                    /**
                     * Encodes the specified IcaCustomerJourneyData message. Does not implicitly {@link palexy.sherlock.v1.IcaCustomerJourneyData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyData} message IcaCustomerJourneyData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaCustomerJourneyData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.sections != null && message.sections.length)
                            for (var i = 0; i < message.sections.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.sections[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaCustomerJourneyData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaCustomerJourneyData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyData} message IcaCustomerJourneyData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaCustomerJourneyData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaCustomerJourneyData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyData} IcaCustomerJourneyData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaCustomerJourneyData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaCustomerJourneyData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.sherlock.v1.IcaCustomerJourneyDataRow.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.sections && message.sections.length))
                                    message.sections = [];
                                message.sections.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaCustomerJourneyData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyData} IcaCustomerJourneyData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaCustomerJourneyData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaCustomerJourneyData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaCustomerJourneyData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        if (message.sections != null && message.hasOwnProperty("sections")) {
                            if (!Array.isArray(message.sections))
                                return "sections: array expected";
                            for (var i = 0; i < message.sections.length; ++i)
                                if (!$util.isString(message.sections[i]))
                                    return "sections: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IcaCustomerJourneyData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyData} IcaCustomerJourneyData
                     */
                    IcaCustomerJourneyData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaCustomerJourneyData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaCustomerJourneyData();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.sherlock.v1.IcaCustomerJourneyData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.IcaCustomerJourneyData.rows: object expected");
                                message.rows[i] = $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow.fromObject(object.rows[i]);
                            }
                        }
                        if (object.sections) {
                            if (!Array.isArray(object.sections))
                                throw TypeError(".palexy.sherlock.v1.IcaCustomerJourneyData.sections: array expected");
                            message.sections = [];
                            for (var i = 0; i < object.sections.length; ++i)
                                message.sections[i] = String(object.sections[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaCustomerJourneyData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @static
                     * @param {palexy.sherlock.v1.IcaCustomerJourneyData} message IcaCustomerJourneyData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaCustomerJourneyData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.rows = [];
                            object.sections = [];
                        }
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow.toObject(message.rows[j], options);
                        }
                        if (message.sections && message.sections.length) {
                            object.sections = [];
                            for (var j = 0; j < message.sections.length; ++j)
                                object.sections[j] = message.sections[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IcaCustomerJourneyData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaCustomerJourneyData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaCustomerJourneyData;
                })();
    
                v1.IcaCustomerJourneyDataRow = (function() {
    
                    /**
                     * Properties of an IcaCustomerJourneyDataRow.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaCustomerJourneyDataRow
                     * @property {string|null} [visitorId] IcaCustomerJourneyDataRow visitorId
                     * @property {string|null} [section] IcaCustomerJourneyDataRow section
                     * @property {string|null} [startTime] IcaCustomerJourneyDataRow startTime
                     * @property {string|null} [endTime] IcaCustomerJourneyDataRow endTime
                     * @property {boolean|null} [interested] IcaCustomerJourneyDataRow interested
                     * @property {boolean|null} [isStaff] IcaCustomerJourneyDataRow isStaff
                     */
    
                    /**
                     * Constructs a new IcaCustomerJourneyDataRow.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaCustomerJourneyDataRow.
                     * @implements IIcaCustomerJourneyDataRow
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyDataRow=} [properties] Properties to set
                     */
                    function IcaCustomerJourneyDataRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaCustomerJourneyDataRow visitorId.
                     * @member {string} visitorId
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.visitorId = "";
    
                    /**
                     * IcaCustomerJourneyDataRow section.
                     * @member {string} section
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.section = "";
    
                    /**
                     * IcaCustomerJourneyDataRow startTime.
                     * @member {string} startTime
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.startTime = "";
    
                    /**
                     * IcaCustomerJourneyDataRow endTime.
                     * @member {string} endTime
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.endTime = "";
    
                    /**
                     * IcaCustomerJourneyDataRow interested.
                     * @member {boolean} interested
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.interested = false;
    
                    /**
                     * IcaCustomerJourneyDataRow isStaff.
                     * @member {boolean} isStaff
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     */
                    IcaCustomerJourneyDataRow.prototype.isStaff = false;
    
                    /**
                     * Creates a new IcaCustomerJourneyDataRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyDataRow=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyDataRow} IcaCustomerJourneyDataRow instance
                     */
                    IcaCustomerJourneyDataRow.create = function create(properties) {
                        return new IcaCustomerJourneyDataRow(properties);
                    };
    
                    /**
                     * Encodes the specified IcaCustomerJourneyDataRow message. Does not implicitly {@link palexy.sherlock.v1.IcaCustomerJourneyDataRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyDataRow} message IcaCustomerJourneyDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaCustomerJourneyDataRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.visitorId != null && Object.hasOwnProperty.call(message, "visitorId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.visitorId);
                        if (message.section != null && Object.hasOwnProperty.call(message, "section"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.section);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endTime);
                        if (message.interested != null && Object.hasOwnProperty.call(message, "interested"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.interested);
                        if (message.isStaff != null && Object.hasOwnProperty.call(message, "isStaff"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isStaff);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaCustomerJourneyDataRow message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaCustomerJourneyDataRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaCustomerJourneyDataRow} message IcaCustomerJourneyDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaCustomerJourneyDataRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaCustomerJourneyDataRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyDataRow} IcaCustomerJourneyDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaCustomerJourneyDataRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.visitorId = reader.string();
                                break;
                            case 2:
                                message.section = reader.string();
                                break;
                            case 3:
                                message.startTime = reader.string();
                                break;
                            case 4:
                                message.endTime = reader.string();
                                break;
                            case 5:
                                message.interested = reader.bool();
                                break;
                            case 6:
                                message.isStaff = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaCustomerJourneyDataRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyDataRow} IcaCustomerJourneyDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaCustomerJourneyDataRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaCustomerJourneyDataRow message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaCustomerJourneyDataRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            if (!$util.isString(message.visitorId))
                                return "visitorId: string expected";
                        if (message.section != null && message.hasOwnProperty("section"))
                            if (!$util.isString(message.section))
                                return "section: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.interested != null && message.hasOwnProperty("interested"))
                            if (typeof message.interested !== "boolean")
                                return "interested: boolean expected";
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            if (typeof message.isStaff !== "boolean")
                                return "isStaff: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an IcaCustomerJourneyDataRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaCustomerJourneyDataRow} IcaCustomerJourneyDataRow
                     */
                    IcaCustomerJourneyDataRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaCustomerJourneyDataRow();
                        if (object.visitorId != null)
                            message.visitorId = String(object.visitorId);
                        if (object.section != null)
                            message.section = String(object.section);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.interested != null)
                            message.interested = Boolean(object.interested);
                        if (object.isStaff != null)
                            message.isStaff = Boolean(object.isStaff);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaCustomerJourneyDataRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IcaCustomerJourneyDataRow} message IcaCustomerJourneyDataRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaCustomerJourneyDataRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.visitorId = "";
                            object.section = "";
                            object.startTime = "";
                            object.endTime = "";
                            object.interested = false;
                            object.isStaff = false;
                        }
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            object.visitorId = message.visitorId;
                        if (message.section != null && message.hasOwnProperty("section"))
                            object.section = message.section;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.interested != null && message.hasOwnProperty("interested"))
                            object.interested = message.interested;
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            object.isStaff = message.isStaff;
                        return object;
                    };
    
                    /**
                     * Converts this IcaCustomerJourneyDataRow to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaCustomerJourneyDataRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaCustomerJourneyDataRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaCustomerJourneyDataRow;
                })();
    
                v1.IcaEntranceCountingData = (function() {
    
                    /**
                     * Properties of an IcaEntranceCountingData.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaEntranceCountingData
                     * @property {Array.<palexy.sherlock.v1.IIcaEntranceCountingDataRow>|null} [rows] IcaEntranceCountingData rows
                     */
    
                    /**
                     * Constructs a new IcaEntranceCountingData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaEntranceCountingData.
                     * @implements IIcaEntranceCountingData
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingData=} [properties] Properties to set
                     */
                    function IcaEntranceCountingData(properties) {
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaEntranceCountingData rows.
                     * @member {Array.<palexy.sherlock.v1.IIcaEntranceCountingDataRow>} rows
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @instance
                     */
                    IcaEntranceCountingData.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new IcaEntranceCountingData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingData} IcaEntranceCountingData instance
                     */
                    IcaEntranceCountingData.create = function create(properties) {
                        return new IcaEntranceCountingData(properties);
                    };
    
                    /**
                     * Encodes the specified IcaEntranceCountingData message. Does not implicitly {@link palexy.sherlock.v1.IcaEntranceCountingData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingData} message IcaEntranceCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaEntranceCountingData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.sherlock.v1.IcaEntranceCountingDataRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaEntranceCountingData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaEntranceCountingData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingData} message IcaEntranceCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaEntranceCountingData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaEntranceCountingData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingData} IcaEntranceCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaEntranceCountingData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaEntranceCountingData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.sherlock.v1.IcaEntranceCountingDataRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaEntranceCountingData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingData} IcaEntranceCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaEntranceCountingData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaEntranceCountingData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaEntranceCountingData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.sherlock.v1.IcaEntranceCountingDataRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IcaEntranceCountingData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingData} IcaEntranceCountingData
                     */
                    IcaEntranceCountingData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaEntranceCountingData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaEntranceCountingData();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.sherlock.v1.IcaEntranceCountingData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.IcaEntranceCountingData.rows: object expected");
                                message.rows[i] = $root.palexy.sherlock.v1.IcaEntranceCountingDataRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaEntranceCountingData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IcaEntranceCountingData} message IcaEntranceCountingData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaEntranceCountingData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rows = [];
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.sherlock.v1.IcaEntranceCountingDataRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IcaEntranceCountingData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaEntranceCountingData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaEntranceCountingData;
                })();
    
                v1.IcaEntranceCountingDataRow = (function() {
    
                    /**
                     * Properties of an IcaEntranceCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaEntranceCountingDataRow
                     * @property {string|null} [cameraId] IcaEntranceCountingDataRow cameraId
                     * @property {number|null} [hour] IcaEntranceCountingDataRow hour
                     * @property {number|null} [numVisitors] IcaEntranceCountingDataRow numVisitors
                     */
    
                    /**
                     * Constructs a new IcaEntranceCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaEntranceCountingDataRow.
                     * @implements IIcaEntranceCountingDataRow
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingDataRow=} [properties] Properties to set
                     */
                    function IcaEntranceCountingDataRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaEntranceCountingDataRow cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @instance
                     */
                    IcaEntranceCountingDataRow.prototype.cameraId = "";
    
                    /**
                     * IcaEntranceCountingDataRow hour.
                     * @member {number} hour
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @instance
                     */
                    IcaEntranceCountingDataRow.prototype.hour = 0;
    
                    /**
                     * IcaEntranceCountingDataRow numVisitors.
                     * @member {number} numVisitors
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @instance
                     */
                    IcaEntranceCountingDataRow.prototype.numVisitors = 0;
    
                    /**
                     * Creates a new IcaEntranceCountingDataRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingDataRow=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingDataRow} IcaEntranceCountingDataRow instance
                     */
                    IcaEntranceCountingDataRow.create = function create(properties) {
                        return new IcaEntranceCountingDataRow(properties);
                    };
    
                    /**
                     * Encodes the specified IcaEntranceCountingDataRow message. Does not implicitly {@link palexy.sherlock.v1.IcaEntranceCountingDataRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingDataRow} message IcaEntranceCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaEntranceCountingDataRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.hour);
                        if (message.numVisitors != null && Object.hasOwnProperty.call(message, "numVisitors"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.numVisitors);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaEntranceCountingDataRow message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaEntranceCountingDataRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaEntranceCountingDataRow} message IcaEntranceCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaEntranceCountingDataRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaEntranceCountingDataRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingDataRow} IcaEntranceCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaEntranceCountingDataRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaEntranceCountingDataRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.hour = reader.int32();
                                break;
                            case 3:
                                message.numVisitors = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaEntranceCountingDataRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingDataRow} IcaEntranceCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaEntranceCountingDataRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaEntranceCountingDataRow message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaEntranceCountingDataRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            if (!$util.isInteger(message.hour))
                                return "hour: integer expected";
                        if (message.numVisitors != null && message.hasOwnProperty("numVisitors"))
                            if (!$util.isInteger(message.numVisitors))
                                return "numVisitors: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an IcaEntranceCountingDataRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaEntranceCountingDataRow} IcaEntranceCountingDataRow
                     */
                    IcaEntranceCountingDataRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaEntranceCountingDataRow)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaEntranceCountingDataRow();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.hour != null)
                            message.hour = object.hour | 0;
                        if (object.numVisitors != null)
                            message.numVisitors = object.numVisitors | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaEntranceCountingDataRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IcaEntranceCountingDataRow} message IcaEntranceCountingDataRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaEntranceCountingDataRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraId = "";
                            object.hour = 0;
                            object.numVisitors = 0;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            object.hour = message.hour;
                        if (message.numVisitors != null && message.hasOwnProperty("numVisitors"))
                            object.numVisitors = message.numVisitors;
                        return object;
                    };
    
                    /**
                     * Converts this IcaEntranceCountingDataRow to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaEntranceCountingDataRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaEntranceCountingDataRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaEntranceCountingDataRow;
                })();
    
                v1.IcaPassbyCountingData = (function() {
    
                    /**
                     * Properties of an IcaPassbyCountingData.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaPassbyCountingData
                     * @property {Array.<palexy.sherlock.v1.IIcaPassbyCountingDataRow>|null} [rows] IcaPassbyCountingData rows
                     */
    
                    /**
                     * Constructs a new IcaPassbyCountingData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaPassbyCountingData.
                     * @implements IIcaPassbyCountingData
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingData=} [properties] Properties to set
                     */
                    function IcaPassbyCountingData(properties) {
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaPassbyCountingData rows.
                     * @member {Array.<palexy.sherlock.v1.IIcaPassbyCountingDataRow>} rows
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @instance
                     */
                    IcaPassbyCountingData.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new IcaPassbyCountingData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingData} IcaPassbyCountingData instance
                     */
                    IcaPassbyCountingData.create = function create(properties) {
                        return new IcaPassbyCountingData(properties);
                    };
    
                    /**
                     * Encodes the specified IcaPassbyCountingData message. Does not implicitly {@link palexy.sherlock.v1.IcaPassbyCountingData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingData} message IcaPassbyCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaPassbyCountingData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.sherlock.v1.IcaPassbyCountingDataRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaPassbyCountingData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaPassbyCountingData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingData} message IcaPassbyCountingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaPassbyCountingData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaPassbyCountingData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingData} IcaPassbyCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaPassbyCountingData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaPassbyCountingData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.sherlock.v1.IcaPassbyCountingDataRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaPassbyCountingData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingData} IcaPassbyCountingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaPassbyCountingData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaPassbyCountingData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaPassbyCountingData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.sherlock.v1.IcaPassbyCountingDataRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IcaPassbyCountingData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingData} IcaPassbyCountingData
                     */
                    IcaPassbyCountingData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaPassbyCountingData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaPassbyCountingData();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.sherlock.v1.IcaPassbyCountingData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.IcaPassbyCountingData.rows: object expected");
                                message.rows[i] = $root.palexy.sherlock.v1.IcaPassbyCountingDataRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaPassbyCountingData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @static
                     * @param {palexy.sherlock.v1.IcaPassbyCountingData} message IcaPassbyCountingData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaPassbyCountingData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rows = [];
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.sherlock.v1.IcaPassbyCountingDataRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IcaPassbyCountingData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaPassbyCountingData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaPassbyCountingData;
                })();
    
                v1.IcaPassbyCountingDataRow = (function() {
    
                    /**
                     * Properties of an IcaPassbyCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaPassbyCountingDataRow
                     * @property {number|null} [hour] IcaPassbyCountingDataRow hour
                     * @property {number|null} [numVisitors] IcaPassbyCountingDataRow numVisitors
                     */
    
                    /**
                     * Constructs a new IcaPassbyCountingDataRow.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaPassbyCountingDataRow.
                     * @implements IIcaPassbyCountingDataRow
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingDataRow=} [properties] Properties to set
                     */
                    function IcaPassbyCountingDataRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaPassbyCountingDataRow hour.
                     * @member {number} hour
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @instance
                     */
                    IcaPassbyCountingDataRow.prototype.hour = 0;
    
                    /**
                     * IcaPassbyCountingDataRow numVisitors.
                     * @member {number} numVisitors
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @instance
                     */
                    IcaPassbyCountingDataRow.prototype.numVisitors = 0;
    
                    /**
                     * Creates a new IcaPassbyCountingDataRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingDataRow=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingDataRow} IcaPassbyCountingDataRow instance
                     */
                    IcaPassbyCountingDataRow.create = function create(properties) {
                        return new IcaPassbyCountingDataRow(properties);
                    };
    
                    /**
                     * Encodes the specified IcaPassbyCountingDataRow message. Does not implicitly {@link palexy.sherlock.v1.IcaPassbyCountingDataRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingDataRow} message IcaPassbyCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaPassbyCountingDataRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.hour);
                        if (message.numVisitors != null && Object.hasOwnProperty.call(message, "numVisitors"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numVisitors);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaPassbyCountingDataRow message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaPassbyCountingDataRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaPassbyCountingDataRow} message IcaPassbyCountingDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaPassbyCountingDataRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaPassbyCountingDataRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingDataRow} IcaPassbyCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaPassbyCountingDataRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaPassbyCountingDataRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.hour = reader.int32();
                                break;
                            case 2:
                                message.numVisitors = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaPassbyCountingDataRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingDataRow} IcaPassbyCountingDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaPassbyCountingDataRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaPassbyCountingDataRow message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaPassbyCountingDataRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            if (!$util.isInteger(message.hour))
                                return "hour: integer expected";
                        if (message.numVisitors != null && message.hasOwnProperty("numVisitors"))
                            if (!$util.isInteger(message.numVisitors))
                                return "numVisitors: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an IcaPassbyCountingDataRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaPassbyCountingDataRow} IcaPassbyCountingDataRow
                     */
                    IcaPassbyCountingDataRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaPassbyCountingDataRow)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaPassbyCountingDataRow();
                        if (object.hour != null)
                            message.hour = object.hour | 0;
                        if (object.numVisitors != null)
                            message.numVisitors = object.numVisitors | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaPassbyCountingDataRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IcaPassbyCountingDataRow} message IcaPassbyCountingDataRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaPassbyCountingDataRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.hour = 0;
                            object.numVisitors = 0;
                        }
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            object.hour = message.hour;
                        if (message.numVisitors != null && message.hasOwnProperty("numVisitors"))
                            object.numVisitors = message.numVisitors;
                        return object;
                    };
    
                    /**
                     * Converts this IcaPassbyCountingDataRow to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaPassbyCountingDataRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaPassbyCountingDataRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaPassbyCountingDataRow;
                })();
    
                v1.IcaFnBQueueMetricData = (function() {
    
                    /**
                     * Properties of an IcaFnBQueueMetricData.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaFnBQueueMetricData
                     * @property {Array.<palexy.sherlock.v1.IIcaFnBQueueMetricDataRow>|null} [rows] IcaFnBQueueMetricData rows
                     */
    
                    /**
                     * Constructs a new IcaFnBQueueMetricData.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaFnBQueueMetricData.
                     * @implements IIcaFnBQueueMetricData
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricData=} [properties] Properties to set
                     */
                    function IcaFnBQueueMetricData(properties) {
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaFnBQueueMetricData rows.
                     * @member {Array.<palexy.sherlock.v1.IIcaFnBQueueMetricDataRow>} rows
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @instance
                     */
                    IcaFnBQueueMetricData.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new IcaFnBQueueMetricData instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricData=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricData} IcaFnBQueueMetricData instance
                     */
                    IcaFnBQueueMetricData.create = function create(properties) {
                        return new IcaFnBQueueMetricData(properties);
                    };
    
                    /**
                     * Encodes the specified IcaFnBQueueMetricData message. Does not implicitly {@link palexy.sherlock.v1.IcaFnBQueueMetricData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricData} message IcaFnBQueueMetricData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaFnBQueueMetricData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaFnBQueueMetricData message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaFnBQueueMetricData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricData} message IcaFnBQueueMetricData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaFnBQueueMetricData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaFnBQueueMetricData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricData} IcaFnBQueueMetricData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaFnBQueueMetricData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaFnBQueueMetricData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaFnBQueueMetricData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricData} IcaFnBQueueMetricData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaFnBQueueMetricData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaFnBQueueMetricData message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaFnBQueueMetricData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IcaFnBQueueMetricData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricData} IcaFnBQueueMetricData
                     */
                    IcaFnBQueueMetricData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaFnBQueueMetricData)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaFnBQueueMetricData();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.sherlock.v1.IcaFnBQueueMetricData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.IcaFnBQueueMetricData.rows: object expected");
                                message.rows[i] = $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaFnBQueueMetricData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @static
                     * @param {palexy.sherlock.v1.IcaFnBQueueMetricData} message IcaFnBQueueMetricData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaFnBQueueMetricData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rows = [];
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IcaFnBQueueMetricData to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaFnBQueueMetricData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaFnBQueueMetricData;
                })();
    
                v1.IcaFnBQueueMetricDataRow = (function() {
    
                    /**
                     * Properties of an IcaFnBQueueMetricDataRow.
                     * @memberof palexy.sherlock.v1
                     * @interface IIcaFnBQueueMetricDataRow
                     * @property {string|null} [visitorId] IcaFnBQueueMetricDataRow visitorId
                     * @property {string|null} [groupId] IcaFnBQueueMetricDataRow groupId
                     * @property {string|null} [startQueueTime] IcaFnBQueueMetricDataRow startQueueTime
                     * @property {number|null} [queueLength] IcaFnBQueueMetricDataRow queueLength
                     * @property {string|null} [startTransactionTime] IcaFnBQueueMetricDataRow startTransactionTime
                     * @property {string|null} [endTransactionTime] IcaFnBQueueMetricDataRow endTransactionTime
                     * @property {string|null} [pickupTime] IcaFnBQueueMetricDataRow pickupTime
                     * @property {boolean|null} [isShipper] IcaFnBQueueMetricDataRow isShipper
                     * @property {string|null} [minStartQueueTime] IcaFnBQueueMetricDataRow minStartQueueTime
                     * @property {string|null} [maxStartQueueTime] IcaFnBQueueMetricDataRow maxStartQueueTime
                     * @property {string|null} [minEndTransactionTime] IcaFnBQueueMetricDataRow minEndTransactionTime
                     * @property {string|null} [maxEndTransactionTime] IcaFnBQueueMetricDataRow maxEndTransactionTime
                     */
    
                    /**
                     * Constructs a new IcaFnBQueueMetricDataRow.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an IcaFnBQueueMetricDataRow.
                     * @implements IIcaFnBQueueMetricDataRow
                     * @constructor
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricDataRow=} [properties] Properties to set
                     */
                    function IcaFnBQueueMetricDataRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IcaFnBQueueMetricDataRow visitorId.
                     * @member {string} visitorId
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.visitorId = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow groupId.
                     * @member {string} groupId
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.groupId = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow startQueueTime.
                     * @member {string} startQueueTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.startQueueTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow queueLength.
                     * @member {number} queueLength
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.queueLength = 0;
    
                    /**
                     * IcaFnBQueueMetricDataRow startTransactionTime.
                     * @member {string} startTransactionTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.startTransactionTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow endTransactionTime.
                     * @member {string} endTransactionTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.endTransactionTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow pickupTime.
                     * @member {string} pickupTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.pickupTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow isShipper.
                     * @member {boolean} isShipper
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.isShipper = false;
    
                    /**
                     * IcaFnBQueueMetricDataRow minStartQueueTime.
                     * @member {string} minStartQueueTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.minStartQueueTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow maxStartQueueTime.
                     * @member {string} maxStartQueueTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.maxStartQueueTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow minEndTransactionTime.
                     * @member {string} minEndTransactionTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.minEndTransactionTime = "";
    
                    /**
                     * IcaFnBQueueMetricDataRow maxEndTransactionTime.
                     * @member {string} maxEndTransactionTime
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     */
                    IcaFnBQueueMetricDataRow.prototype.maxEndTransactionTime = "";
    
                    /**
                     * Creates a new IcaFnBQueueMetricDataRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricDataRow=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricDataRow} IcaFnBQueueMetricDataRow instance
                     */
                    IcaFnBQueueMetricDataRow.create = function create(properties) {
                        return new IcaFnBQueueMetricDataRow(properties);
                    };
    
                    /**
                     * Encodes the specified IcaFnBQueueMetricDataRow message. Does not implicitly {@link palexy.sherlock.v1.IcaFnBQueueMetricDataRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricDataRow} message IcaFnBQueueMetricDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaFnBQueueMetricDataRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.visitorId != null && Object.hasOwnProperty.call(message, "visitorId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.visitorId);
                        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.groupId);
                        if (message.startQueueTime != null && Object.hasOwnProperty.call(message, "startQueueTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startQueueTime);
                        if (message.queueLength != null && Object.hasOwnProperty.call(message, "queueLength"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.queueLength);
                        if (message.startTransactionTime != null && Object.hasOwnProperty.call(message, "startTransactionTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startTransactionTime);
                        if (message.endTransactionTime != null && Object.hasOwnProperty.call(message, "endTransactionTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endTransactionTime);
                        if (message.pickupTime != null && Object.hasOwnProperty.call(message, "pickupTime"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.pickupTime);
                        if (message.isShipper != null && Object.hasOwnProperty.call(message, "isShipper"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isShipper);
                        if (message.minStartQueueTime != null && Object.hasOwnProperty.call(message, "minStartQueueTime"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.minStartQueueTime);
                        if (message.maxStartQueueTime != null && Object.hasOwnProperty.call(message, "maxStartQueueTime"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.maxStartQueueTime);
                        if (message.minEndTransactionTime != null && Object.hasOwnProperty.call(message, "minEndTransactionTime"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.minEndTransactionTime);
                        if (message.maxEndTransactionTime != null && Object.hasOwnProperty.call(message, "maxEndTransactionTime"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.maxEndTransactionTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IcaFnBQueueMetricDataRow message, length delimited. Does not implicitly {@link palexy.sherlock.v1.IcaFnBQueueMetricDataRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IIcaFnBQueueMetricDataRow} message IcaFnBQueueMetricDataRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IcaFnBQueueMetricDataRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IcaFnBQueueMetricDataRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricDataRow} IcaFnBQueueMetricDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaFnBQueueMetricDataRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.visitorId = reader.string();
                                break;
                            case 2:
                                message.groupId = reader.string();
                                break;
                            case 3:
                                message.startQueueTime = reader.string();
                                break;
                            case 4:
                                message.queueLength = reader.int32();
                                break;
                            case 5:
                                message.startTransactionTime = reader.string();
                                break;
                            case 6:
                                message.endTransactionTime = reader.string();
                                break;
                            case 7:
                                message.pickupTime = reader.string();
                                break;
                            case 8:
                                message.isShipper = reader.bool();
                                break;
                            case 9:
                                message.minStartQueueTime = reader.string();
                                break;
                            case 10:
                                message.maxStartQueueTime = reader.string();
                                break;
                            case 11:
                                message.minEndTransactionTime = reader.string();
                                break;
                            case 12:
                                message.maxEndTransactionTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IcaFnBQueueMetricDataRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricDataRow} IcaFnBQueueMetricDataRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IcaFnBQueueMetricDataRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IcaFnBQueueMetricDataRow message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IcaFnBQueueMetricDataRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            if (!$util.isString(message.visitorId))
                                return "visitorId: string expected";
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            if (!$util.isString(message.groupId))
                                return "groupId: string expected";
                        if (message.startQueueTime != null && message.hasOwnProperty("startQueueTime"))
                            if (!$util.isString(message.startQueueTime))
                                return "startQueueTime: string expected";
                        if (message.queueLength != null && message.hasOwnProperty("queueLength"))
                            if (!$util.isInteger(message.queueLength))
                                return "queueLength: integer expected";
                        if (message.startTransactionTime != null && message.hasOwnProperty("startTransactionTime"))
                            if (!$util.isString(message.startTransactionTime))
                                return "startTransactionTime: string expected";
                        if (message.endTransactionTime != null && message.hasOwnProperty("endTransactionTime"))
                            if (!$util.isString(message.endTransactionTime))
                                return "endTransactionTime: string expected";
                        if (message.pickupTime != null && message.hasOwnProperty("pickupTime"))
                            if (!$util.isString(message.pickupTime))
                                return "pickupTime: string expected";
                        if (message.isShipper != null && message.hasOwnProperty("isShipper"))
                            if (typeof message.isShipper !== "boolean")
                                return "isShipper: boolean expected";
                        if (message.minStartQueueTime != null && message.hasOwnProperty("minStartQueueTime"))
                            if (!$util.isString(message.minStartQueueTime))
                                return "minStartQueueTime: string expected";
                        if (message.maxStartQueueTime != null && message.hasOwnProperty("maxStartQueueTime"))
                            if (!$util.isString(message.maxStartQueueTime))
                                return "maxStartQueueTime: string expected";
                        if (message.minEndTransactionTime != null && message.hasOwnProperty("minEndTransactionTime"))
                            if (!$util.isString(message.minEndTransactionTime))
                                return "minEndTransactionTime: string expected";
                        if (message.maxEndTransactionTime != null && message.hasOwnProperty("maxEndTransactionTime"))
                            if (!$util.isString(message.maxEndTransactionTime))
                                return "maxEndTransactionTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an IcaFnBQueueMetricDataRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.IcaFnBQueueMetricDataRow} IcaFnBQueueMetricDataRow
                     */
                    IcaFnBQueueMetricDataRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow)
                            return object;
                        var message = new $root.palexy.sherlock.v1.IcaFnBQueueMetricDataRow();
                        if (object.visitorId != null)
                            message.visitorId = String(object.visitorId);
                        if (object.groupId != null)
                            message.groupId = String(object.groupId);
                        if (object.startQueueTime != null)
                            message.startQueueTime = String(object.startQueueTime);
                        if (object.queueLength != null)
                            message.queueLength = object.queueLength | 0;
                        if (object.startTransactionTime != null)
                            message.startTransactionTime = String(object.startTransactionTime);
                        if (object.endTransactionTime != null)
                            message.endTransactionTime = String(object.endTransactionTime);
                        if (object.pickupTime != null)
                            message.pickupTime = String(object.pickupTime);
                        if (object.isShipper != null)
                            message.isShipper = Boolean(object.isShipper);
                        if (object.minStartQueueTime != null)
                            message.minStartQueueTime = String(object.minStartQueueTime);
                        if (object.maxStartQueueTime != null)
                            message.maxStartQueueTime = String(object.maxStartQueueTime);
                        if (object.minEndTransactionTime != null)
                            message.minEndTransactionTime = String(object.minEndTransactionTime);
                        if (object.maxEndTransactionTime != null)
                            message.maxEndTransactionTime = String(object.maxEndTransactionTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IcaFnBQueueMetricDataRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @static
                     * @param {palexy.sherlock.v1.IcaFnBQueueMetricDataRow} message IcaFnBQueueMetricDataRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IcaFnBQueueMetricDataRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.visitorId = "";
                            object.groupId = "";
                            object.startQueueTime = "";
                            object.queueLength = 0;
                            object.startTransactionTime = "";
                            object.endTransactionTime = "";
                            object.pickupTime = "";
                            object.isShipper = false;
                            object.minStartQueueTime = "";
                            object.maxStartQueueTime = "";
                            object.minEndTransactionTime = "";
                            object.maxEndTransactionTime = "";
                        }
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            object.visitorId = message.visitorId;
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            object.groupId = message.groupId;
                        if (message.startQueueTime != null && message.hasOwnProperty("startQueueTime"))
                            object.startQueueTime = message.startQueueTime;
                        if (message.queueLength != null && message.hasOwnProperty("queueLength"))
                            object.queueLength = message.queueLength;
                        if (message.startTransactionTime != null && message.hasOwnProperty("startTransactionTime"))
                            object.startTransactionTime = message.startTransactionTime;
                        if (message.endTransactionTime != null && message.hasOwnProperty("endTransactionTime"))
                            object.endTransactionTime = message.endTransactionTime;
                        if (message.pickupTime != null && message.hasOwnProperty("pickupTime"))
                            object.pickupTime = message.pickupTime;
                        if (message.isShipper != null && message.hasOwnProperty("isShipper"))
                            object.isShipper = message.isShipper;
                        if (message.minStartQueueTime != null && message.hasOwnProperty("minStartQueueTime"))
                            object.minStartQueueTime = message.minStartQueueTime;
                        if (message.maxStartQueueTime != null && message.hasOwnProperty("maxStartQueueTime"))
                            object.maxStartQueueTime = message.maxStartQueueTime;
                        if (message.minEndTransactionTime != null && message.hasOwnProperty("minEndTransactionTime"))
                            object.minEndTransactionTime = message.minEndTransactionTime;
                        if (message.maxEndTransactionTime != null && message.hasOwnProperty("maxEndTransactionTime"))
                            object.maxEndTransactionTime = message.maxEndTransactionTime;
                        return object;
                    };
    
                    /**
                     * Converts this IcaFnBQueueMetricDataRow to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.IcaFnBQueueMetricDataRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IcaFnBQueueMetricDataRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IcaFnBQueueMetricDataRow;
                })();
    
                v1.ListQcFilesRequest = (function() {
    
                    /**
                     * Properties of a ListQcFilesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcFilesRequest
                     * @property {Array.<number>|null} [storeIds] ListQcFilesRequest storeIds
                     * @property {string|null} [startDate] ListQcFilesRequest startDate
                     * @property {string|null} [endDate] ListQcFilesRequest endDate
                     * @property {string|null} [pageToken] ListQcFilesRequest pageToken
                     * @property {number|null} [pageSize] ListQcFilesRequest pageSize
                     * @property {boolean|null} [excludeQcFileData] ListQcFilesRequest excludeQcFileData
                     */
    
                    /**
                     * Constructs a new ListQcFilesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcFilesRequest.
                     * @implements IListQcFilesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcFilesRequest=} [properties] Properties to set
                     */
                    function ListQcFilesRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcFilesRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListQcFilesRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.startDate = "";
    
                    /**
                     * ListQcFilesRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.endDate = "";
    
                    /**
                     * ListQcFilesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.pageToken = "";
    
                    /**
                     * ListQcFilesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListQcFilesRequest excludeQcFileData.
                     * @member {boolean} excludeQcFileData
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     */
                    ListQcFilesRequest.prototype.excludeQcFileData = false;
    
                    /**
                     * Creates a new ListQcFilesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcFilesRequest} ListQcFilesRequest instance
                     */
                    ListQcFilesRequest.create = function create(properties) {
                        return new ListQcFilesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcFilesRequest message. Does not implicitly {@link palexy.sherlock.v1.ListQcFilesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesRequest} message ListQcFilesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcFilesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDate);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.excludeQcFileData != null && Object.hasOwnProperty.call(message, "excludeQcFileData"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.excludeQcFileData);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcFilesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcFilesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesRequest} message ListQcFilesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcFilesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcFilesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcFilesRequest} ListQcFilesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcFilesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcFilesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDate = reader.string();
                                break;
                            case 3:
                                message.endDate = reader.string();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.excludeQcFileData = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcFilesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcFilesRequest} ListQcFilesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcFilesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcFilesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcFilesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.excludeQcFileData != null && message.hasOwnProperty("excludeQcFileData"))
                            if (typeof message.excludeQcFileData !== "boolean")
                                return "excludeQcFileData: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListQcFilesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcFilesRequest} ListQcFilesRequest
                     */
                    ListQcFilesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcFilesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcFilesRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.sherlock.v1.ListQcFilesRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.excludeQcFileData != null)
                            message.excludeQcFileData = Boolean(object.excludeQcFileData);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcFilesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListQcFilesRequest} message ListQcFilesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcFilesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDate = "";
                            object.endDate = "";
                            object.pageToken = "";
                            object.pageSize = 0;
                            object.excludeQcFileData = false;
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.excludeQcFileData != null && message.hasOwnProperty("excludeQcFileData"))
                            object.excludeQcFileData = message.excludeQcFileData;
                        return object;
                    };
    
                    /**
                     * Converts this ListQcFilesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcFilesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcFilesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcFilesRequest;
                })();
    
                v1.ListQcFilesResponse = (function() {
    
                    /**
                     * Properties of a ListQcFilesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcFilesResponse
                     * @property {Array.<palexy.sherlock.v1.IQcFile>|null} [qcFiles] ListQcFilesResponse qcFiles
                     * @property {string|null} [nextPageToken] ListQcFilesResponse nextPageToken
                     * @property {number|null} [totalElements] ListQcFilesResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListQcFilesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcFilesResponse.
                     * @implements IListQcFilesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcFilesResponse=} [properties] Properties to set
                     */
                    function ListQcFilesResponse(properties) {
                        this.qcFiles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcFilesResponse qcFiles.
                     * @member {Array.<palexy.sherlock.v1.IQcFile>} qcFiles
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @instance
                     */
                    ListQcFilesResponse.prototype.qcFiles = $util.emptyArray;
    
                    /**
                     * ListQcFilesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @instance
                     */
                    ListQcFilesResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListQcFilesResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @instance
                     */
                    ListQcFilesResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListQcFilesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcFilesResponse} ListQcFilesResponse instance
                     */
                    ListQcFilesResponse.create = function create(properties) {
                        return new ListQcFilesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcFilesResponse message. Does not implicitly {@link palexy.sherlock.v1.ListQcFilesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesResponse} message ListQcFilesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcFilesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFiles != null && message.qcFiles.length)
                            for (var i = 0; i < message.qcFiles.length; ++i)
                                $root.palexy.sherlock.v1.QcFile.encode(message.qcFiles[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcFilesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcFilesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcFilesResponse} message ListQcFilesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcFilesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcFilesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcFilesResponse} ListQcFilesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcFilesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcFilesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.qcFiles && message.qcFiles.length))
                                    message.qcFiles = [];
                                message.qcFiles.push($root.palexy.sherlock.v1.QcFile.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcFilesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcFilesResponse} ListQcFilesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcFilesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcFilesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcFilesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFiles != null && message.hasOwnProperty("qcFiles")) {
                            if (!Array.isArray(message.qcFiles))
                                return "qcFiles: array expected";
                            for (var i = 0; i < message.qcFiles.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcFile.verify(message.qcFiles[i]);
                                if (error)
                                    return "qcFiles." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListQcFilesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcFilesResponse} ListQcFilesResponse
                     */
                    ListQcFilesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcFilesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcFilesResponse();
                        if (object.qcFiles) {
                            if (!Array.isArray(object.qcFiles))
                                throw TypeError(".palexy.sherlock.v1.ListQcFilesResponse.qcFiles: array expected");
                            message.qcFiles = [];
                            for (var i = 0; i < object.qcFiles.length; ++i) {
                                if (typeof object.qcFiles[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListQcFilesResponse.qcFiles: object expected");
                                message.qcFiles[i] = $root.palexy.sherlock.v1.QcFile.fromObject(object.qcFiles[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcFilesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListQcFilesResponse} message ListQcFilesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcFilesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.qcFiles = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.qcFiles && message.qcFiles.length) {
                            object.qcFiles = [];
                            for (var j = 0; j < message.qcFiles.length; ++j)
                                object.qcFiles[j] = $root.palexy.sherlock.v1.QcFile.toObject(message.qcFiles[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListQcFilesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcFilesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcFilesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcFilesResponse;
                })();
    
                v1.GetQcFileRequest = (function() {
    
                    /**
                     * Properties of a GetQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IGetQcFileRequest
                     * @property {string|null} [name] GetQcFileRequest name
                     */
    
                    /**
                     * Constructs a new GetQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GetQcFileRequest.
                     * @implements IGetQcFileRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IGetQcFileRequest=} [properties] Properties to set
                     */
                    function GetQcFileRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetQcFileRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @instance
                     */
                    GetQcFileRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetQcFileRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GetQcFileRequest} GetQcFileRequest instance
                     */
                    GetQcFileRequest.create = function create(properties) {
                        return new GetQcFileRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetQcFileRequest message. Does not implicitly {@link palexy.sherlock.v1.GetQcFileRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileRequest} message GetQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetQcFileRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetQcFileRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GetQcFileRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileRequest} message GetQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetQcFileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetQcFileRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GetQcFileRequest} GetQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetQcFileRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GetQcFileRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetQcFileRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GetQcFileRequest} GetQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetQcFileRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetQcFileRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetQcFileRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetQcFileRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GetQcFileRequest} GetQcFileRequest
                     */
                    GetQcFileRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GetQcFileRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GetQcFileRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetQcFileRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.GetQcFileRequest} message GetQcFileRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetQcFileRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetQcFileRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GetQcFileRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetQcFileRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetQcFileRequest;
                })();
    
                v1.GetQcFileResponse = (function() {
    
                    /**
                     * Properties of a GetQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IGetQcFileResponse
                     * @property {palexy.sherlock.v1.IQcFile|null} [qcFile] GetQcFileResponse qcFile
                     */
    
                    /**
                     * Constructs a new GetQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GetQcFileResponse.
                     * @implements IGetQcFileResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IGetQcFileResponse=} [properties] Properties to set
                     */
                    function GetQcFileResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetQcFileResponse qcFile.
                     * @member {palexy.sherlock.v1.IQcFile|null|undefined} qcFile
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @instance
                     */
                    GetQcFileResponse.prototype.qcFile = null;
    
                    /**
                     * Creates a new GetQcFileResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GetQcFileResponse} GetQcFileResponse instance
                     */
                    GetQcFileResponse.create = function create(properties) {
                        return new GetQcFileResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetQcFileResponse message. Does not implicitly {@link palexy.sherlock.v1.GetQcFileResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileResponse} message GetQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetQcFileResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFile != null && Object.hasOwnProperty.call(message, "qcFile"))
                            $root.palexy.sherlock.v1.QcFile.encode(message.qcFile, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetQcFileResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GetQcFileResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetQcFileResponse} message GetQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetQcFileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetQcFileResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GetQcFileResponse} GetQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetQcFileResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GetQcFileResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.qcFile = $root.palexy.sherlock.v1.QcFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetQcFileResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GetQcFileResponse} GetQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetQcFileResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetQcFileResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetQcFileResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFile != null && message.hasOwnProperty("qcFile")) {
                            var error = $root.palexy.sherlock.v1.QcFile.verify(message.qcFile);
                            if (error)
                                return "qcFile." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetQcFileResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GetQcFileResponse} GetQcFileResponse
                     */
                    GetQcFileResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GetQcFileResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GetQcFileResponse();
                        if (object.qcFile != null) {
                            if (typeof object.qcFile !== "object")
                                throw TypeError(".palexy.sherlock.v1.GetQcFileResponse.qcFile: object expected");
                            message.qcFile = $root.palexy.sherlock.v1.QcFile.fromObject(object.qcFile);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetQcFileResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.GetQcFileResponse} message GetQcFileResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetQcFileResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.qcFile = null;
                        if (message.qcFile != null && message.hasOwnProperty("qcFile"))
                            object.qcFile = $root.palexy.sherlock.v1.QcFile.toObject(message.qcFile, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetQcFileResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GetQcFileResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetQcFileResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetQcFileResponse;
                })();
    
                v1.DeleteQcFileRequest = (function() {
    
                    /**
                     * Properties of a DeleteQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcFileRequest
                     * @property {string|null} [name] DeleteQcFileRequest name
                     */
    
                    /**
                     * Constructs a new DeleteQcFileRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcFileRequest.
                     * @implements IDeleteQcFileRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest=} [properties] Properties to set
                     */
                    function DeleteQcFileRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteQcFileRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @instance
                     */
                    DeleteQcFileRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteQcFileRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcFileRequest} DeleteQcFileRequest instance
                     */
                    DeleteQcFileRequest.create = function create(properties) {
                        return new DeleteQcFileRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcFileRequest message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcFileRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest} message DeleteQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcFileRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcFileRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcFileRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileRequest} message DeleteQcFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcFileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcFileRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcFileRequest} DeleteQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcFileRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcFileRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcFileRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcFileRequest} DeleteQcFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcFileRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcFileRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcFileRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcFileRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcFileRequest} DeleteQcFileRequest
                     */
                    DeleteQcFileRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcFileRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DeleteQcFileRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcFileRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcFileRequest} message DeleteQcFileRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcFileRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteQcFileRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcFileRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcFileRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcFileRequest;
                })();
    
                v1.DeleteQcFileResponse = (function() {
    
                    /**
                     * Properties of a DeleteQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcFileResponse
                     */
    
                    /**
                     * Constructs a new DeleteQcFileResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcFileResponse.
                     * @implements IDeleteQcFileResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcFileResponse=} [properties] Properties to set
                     */
                    function DeleteQcFileResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new DeleteQcFileResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcFileResponse} DeleteQcFileResponse instance
                     */
                    DeleteQcFileResponse.create = function create(properties) {
                        return new DeleteQcFileResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcFileResponse message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcFileResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileResponse} message DeleteQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcFileResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcFileResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcFileResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcFileResponse} message DeleteQcFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcFileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcFileResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcFileResponse} DeleteQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcFileResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcFileResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcFileResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcFileResponse} DeleteQcFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcFileResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcFileResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcFileResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcFileResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcFileResponse} DeleteQcFileResponse
                     */
                    DeleteQcFileResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcFileResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.DeleteQcFileResponse();
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcFileResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcFileResponse} message DeleteQcFileResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcFileResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this DeleteQcFileResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcFileResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcFileResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcFileResponse;
                })();
    
                v1.AccuracyService = (function() {
    
                    /**
                     * Constructs a new AccuracyService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AccuracyService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function AccuracyService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (AccuracyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AccuracyService;
    
                    /**
                     * Creates new AccuracyService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {AccuracyService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    AccuracyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.AccuracyService#calculateAndSaveAccuracy}.
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @typedef CalculateAndSaveAccuracyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} [response] CalculateAndSaveAccuracyResponse
                     */
    
                    /**
                     * Calls CalculateAndSaveAccuracy.
                     * @function calculateAndSaveAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest} request CalculateAndSaveAccuracyRequest message or plain object
                     * @param {palexy.sherlock.v1.AccuracyService.CalculateAndSaveAccuracyCallback} callback Node-style callback called with the error, if any, and CalculateAndSaveAccuracyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccuracyService.prototype.calculateAndSaveAccuracy = function calculateAndSaveAccuracy(request, callback) {
                        return this.rpcCall(calculateAndSaveAccuracy, $root.palexy.sherlock.v1.CalculateAndSaveAccuracyRequest, $root.palexy.sherlock.v1.CalculateAndSaveAccuracyResponse, request, callback);
                    }, "name", { value: "CalculateAndSaveAccuracy" });
    
                    /**
                     * Calls CalculateAndSaveAccuracy.
                     * @function calculateAndSaveAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest} request CalculateAndSaveAccuracyRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CalculateAndSaveAccuracyResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.AccuracyService#batchCalculateAndSaveAccuracy}.
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @typedef BatchCalculateAndSaveAccuracyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} [response] BatchCalculateAndSaveAccuracyResponse
                     */
    
                    /**
                     * Calls BatchCalculateAndSaveAccuracy.
                     * @function batchCalculateAndSaveAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest} request BatchCalculateAndSaveAccuracyRequest message or plain object
                     * @param {palexy.sherlock.v1.AccuracyService.BatchCalculateAndSaveAccuracyCallback} callback Node-style callback called with the error, if any, and BatchCalculateAndSaveAccuracyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccuracyService.prototype.batchCalculateAndSaveAccuracy = function batchCalculateAndSaveAccuracy(request, callback) {
                        return this.rpcCall(batchCalculateAndSaveAccuracy, $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest, $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse, request, callback);
                    }, "name", { value: "BatchCalculateAndSaveAccuracy" });
    
                    /**
                     * Calls BatchCalculateAndSaveAccuracy.
                     * @function batchCalculateAndSaveAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest} request BatchCalculateAndSaveAccuracyRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.AccuracyService#listAccuracyResults}.
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @typedef ListAccuracyResultsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListAccuracyResultsResponse} [response] ListAccuracyResultsResponse
                     */
    
                    /**
                     * Calls ListAccuracyResults.
                     * @function listAccuracyResults
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest} request ListAccuracyResultsRequest message or plain object
                     * @param {palexy.sherlock.v1.AccuracyService.ListAccuracyResultsCallback} callback Node-style callback called with the error, if any, and ListAccuracyResultsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccuracyService.prototype.listAccuracyResults = function listAccuracyResults(request, callback) {
                        return this.rpcCall(listAccuracyResults, $root.palexy.sherlock.v1.ListAccuracyResultsRequest, $root.palexy.sherlock.v1.ListAccuracyResultsResponse, request, callback);
                    }, "name", { value: "ListAccuracyResults" });
    
                    /**
                     * Calls ListAccuracyResults.
                     * @function listAccuracyResults
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest} request ListAccuracyResultsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListAccuracyResultsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.AccuracyService#calculateAndSaveExperimentAccuracy}.
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @typedef CalculateAndSaveExperimentAccuracyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} [response] CalculateAndSaveExperimentAccuracyResponse
                     */
    
                    /**
                     * Calls CalculateAndSaveExperimentAccuracy.
                     * @function calculateAndSaveExperimentAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest} request CalculateAndSaveExperimentAccuracyRequest message or plain object
                     * @param {palexy.sherlock.v1.AccuracyService.CalculateAndSaveExperimentAccuracyCallback} callback Node-style callback called with the error, if any, and CalculateAndSaveExperimentAccuracyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccuracyService.prototype.calculateAndSaveExperimentAccuracy = function calculateAndSaveExperimentAccuracy(request, callback) {
                        return this.rpcCall(calculateAndSaveExperimentAccuracy, $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest, $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse, request, callback);
                    }, "name", { value: "CalculateAndSaveExperimentAccuracy" });
    
                    /**
                     * Calls CalculateAndSaveExperimentAccuracy.
                     * @function calculateAndSaveExperimentAccuracy
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest} request CalculateAndSaveExperimentAccuracyRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.AccuracyService#listFnbVisitMatches}.
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @typedef ListFnbVisitMatchesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListFnbVisitMatchesResponse} [response] ListFnbVisitMatchesResponse
                     */
    
                    /**
                     * Calls ListFnbVisitMatches.
                     * @function listFnbVisitMatches
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest} request ListFnbVisitMatchesRequest message or plain object
                     * @param {palexy.sherlock.v1.AccuracyService.ListFnbVisitMatchesCallback} callback Node-style callback called with the error, if any, and ListFnbVisitMatchesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccuracyService.prototype.listFnbVisitMatches = function listFnbVisitMatches(request, callback) {
                        return this.rpcCall(listFnbVisitMatches, $root.palexy.sherlock.v1.ListFnbVisitMatchesRequest, $root.palexy.sherlock.v1.ListFnbVisitMatchesResponse, request, callback);
                    }, "name", { value: "ListFnbVisitMatches" });
    
                    /**
                     * Calls ListFnbVisitMatches.
                     * @function listFnbVisitMatches
                     * @memberof palexy.sherlock.v1.AccuracyService
                     * @instance
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest} request ListFnbVisitMatchesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListFnbVisitMatchesResponse>} Promise
                     * @variation 2
                     */
    
                    return AccuracyService;
                })();
    
                v1.CalculateAndSaveAccuracyRequest = (function() {
    
                    /**
                     * Properties of a CalculateAndSaveAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICalculateAndSaveAccuracyRequest
                     * @property {number|null} [storeId] CalculateAndSaveAccuracyRequest storeId
                     * @property {string|null} [dateId] CalculateAndSaveAccuracyRequest dateId
                     * @property {palexy.sherlock.v1.QcFile.QcType|null} [qcType] CalculateAndSaveAccuracyRequest qcType
                     */
    
                    /**
                     * Constructs a new CalculateAndSaveAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CalculateAndSaveAccuracyRequest.
                     * @implements ICalculateAndSaveAccuracyRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest=} [properties] Properties to set
                     */
                    function CalculateAndSaveAccuracyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateAndSaveAccuracyRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveAccuracyRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CalculateAndSaveAccuracyRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveAccuracyRequest.prototype.dateId = "";
    
                    /**
                     * CalculateAndSaveAccuracyRequest qcType.
                     * @member {palexy.sherlock.v1.QcFile.QcType} qcType
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveAccuracyRequest.prototype.qcType = 0;
    
                    /**
                     * Creates a new CalculateAndSaveAccuracyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyRequest} CalculateAndSaveAccuracyRequest instance
                     */
                    CalculateAndSaveAccuracyRequest.create = function create(properties) {
                        return new CalculateAndSaveAccuracyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveAccuracyRequest message. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveAccuracyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest} message CalculateAndSaveAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveAccuracyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.qcType != null && Object.hasOwnProperty.call(message, "qcType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.qcType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveAccuracyRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveAccuracyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyRequest} message CalculateAndSaveAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveAccuracyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateAndSaveAccuracyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyRequest} CalculateAndSaveAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveAccuracyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CalculateAndSaveAccuracyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.qcType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateAndSaveAccuracyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyRequest} CalculateAndSaveAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveAccuracyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateAndSaveAccuracyRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateAndSaveAccuracyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            switch (message.qcType) {
                            default:
                                return "qcType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateAndSaveAccuracyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyRequest} CalculateAndSaveAccuracyRequest
                     */
                    CalculateAndSaveAccuracyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CalculateAndSaveAccuracyRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CalculateAndSaveAccuracyRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        switch (object.qcType) {
                        case "QC_TYPE_UNKNOWN":
                        case 0:
                            message.qcType = 0;
                            break;
                        case "ICA_STANDARD_COUNTING":
                        case 1:
                            message.qcType = 1;
                            break;
                        case "ICA_CUSTOMER_JOURNEY":
                        case 2:
                            message.qcType = 2;
                            break;
                        case "ICA_ENTRANCE_COUNTING":
                        case 3:
                            message.qcType = 3;
                            break;
                        case "ICA_PASSBY_COUNTING":
                        case 4:
                            message.qcType = 4;
                            break;
                        case "ICA_FNB_QUEUE_METRIC":
                        case 5:
                            message.qcType = 5;
                            break;
                        case "ICA_FNB_QUEUE_METRIC_PER_PERSON":
                        case 6:
                            message.qcType = 6;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateAndSaveAccuracyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.CalculateAndSaveAccuracyRequest} message CalculateAndSaveAccuracyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateAndSaveAccuracyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.qcType = options.enums === String ? "QC_TYPE_UNKNOWN" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            object.qcType = options.enums === String ? $root.palexy.sherlock.v1.QcFile.QcType[message.qcType] : message.qcType;
                        return object;
                    };
    
                    /**
                     * Converts this CalculateAndSaveAccuracyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateAndSaveAccuracyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateAndSaveAccuracyRequest;
                })();
    
                v1.CalculateAndSaveAccuracyResponse = (function() {
    
                    /**
                     * Properties of a CalculateAndSaveAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICalculateAndSaveAccuracyResponse
                     * @property {Array.<palexy.sherlock.v1.IAccuracyResult>|null} [accuracyResults] CalculateAndSaveAccuracyResponse accuracyResults
                     */
    
                    /**
                     * Constructs a new CalculateAndSaveAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CalculateAndSaveAccuracyResponse.
                     * @implements ICalculateAndSaveAccuracyResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyResponse=} [properties] Properties to set
                     */
                    function CalculateAndSaveAccuracyResponse(properties) {
                        this.accuracyResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateAndSaveAccuracyResponse accuracyResults.
                     * @member {Array.<palexy.sherlock.v1.IAccuracyResult>} accuracyResults
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @instance
                     */
                    CalculateAndSaveAccuracyResponse.prototype.accuracyResults = $util.emptyArray;
    
                    /**
                     * Creates a new CalculateAndSaveAccuracyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} CalculateAndSaveAccuracyResponse instance
                     */
                    CalculateAndSaveAccuracyResponse.create = function create(properties) {
                        return new CalculateAndSaveAccuracyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveAccuracyResponse message. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveAccuracyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyResponse} message CalculateAndSaveAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveAccuracyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accuracyResults != null && message.accuracyResults.length)
                            for (var i = 0; i < message.accuracyResults.length; ++i)
                                $root.palexy.sherlock.v1.AccuracyResult.encode(message.accuracyResults[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveAccuracyResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveAccuracyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveAccuracyResponse} message CalculateAndSaveAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveAccuracyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateAndSaveAccuracyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} CalculateAndSaveAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveAccuracyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CalculateAndSaveAccuracyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.accuracyResults && message.accuracyResults.length))
                                    message.accuracyResults = [];
                                message.accuracyResults.push($root.palexy.sherlock.v1.AccuracyResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateAndSaveAccuracyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} CalculateAndSaveAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveAccuracyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateAndSaveAccuracyResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateAndSaveAccuracyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accuracyResults != null && message.hasOwnProperty("accuracyResults")) {
                            if (!Array.isArray(message.accuracyResults))
                                return "accuracyResults: array expected";
                            for (var i = 0; i < message.accuracyResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.AccuracyResult.verify(message.accuracyResults[i]);
                                if (error)
                                    return "accuracyResults." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateAndSaveAccuracyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} CalculateAndSaveAccuracyResponse
                     */
                    CalculateAndSaveAccuracyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CalculateAndSaveAccuracyResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CalculateAndSaveAccuracyResponse();
                        if (object.accuracyResults) {
                            if (!Array.isArray(object.accuracyResults))
                                throw TypeError(".palexy.sherlock.v1.CalculateAndSaveAccuracyResponse.accuracyResults: array expected");
                            message.accuracyResults = [];
                            for (var i = 0; i < object.accuracyResults.length; ++i) {
                                if (typeof object.accuracyResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CalculateAndSaveAccuracyResponse.accuracyResults: object expected");
                                message.accuracyResults[i] = $root.palexy.sherlock.v1.AccuracyResult.fromObject(object.accuracyResults[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateAndSaveAccuracyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.CalculateAndSaveAccuracyResponse} message CalculateAndSaveAccuracyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateAndSaveAccuracyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.accuracyResults = [];
                        if (message.accuracyResults && message.accuracyResults.length) {
                            object.accuracyResults = [];
                            for (var j = 0; j < message.accuracyResults.length; ++j)
                                object.accuracyResults[j] = $root.palexy.sherlock.v1.AccuracyResult.toObject(message.accuracyResults[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CalculateAndSaveAccuracyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CalculateAndSaveAccuracyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateAndSaveAccuracyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateAndSaveAccuracyResponse;
                })();
    
                /**
                 * AccuracyType enum.
                 * @name palexy.sherlock.v1.AccuracyType
                 * @enum {number}
                 * @property {number} UNKNOWN=0 UNKNOWN value
                 * @property {number} VISITOR_COUNTING_FOR_1H_SLOT=1 VISITOR_COUNTING_FOR_1H_SLOT value
                 * @property {number} VISITOR_COUNTING_FOR_WHOLE_DAY=2 VISITOR_COUNTING_FOR_WHOLE_DAY value
                 * @property {number} CONVERSION_RATE_FOR_WHOLE_DAY=3 CONVERSION_RATE_FOR_WHOLE_DAY value
                 * @property {number} INTERACTION_RATE_FOR_WHOLE_DAY=4 INTERACTION_RATE_FOR_WHOLE_DAY value
                 * @property {number} AGE_DISTRIBUTION_FOR_WHOLE_DAY=5 AGE_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} GENDER_DISTRIBUTION_FOR_WHOLE_DAY=6 GENDER_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} STAFF_CONVERSION_RATE_FOR_WHOLE_DAY=7 STAFF_CONVERSION_RATE_FOR_WHOLE_DAY value
                 * @property {number} VISITOR_COUNTING_FOR_1H_SLOT_INCLUDE_LONG_STAFF=8 VISITOR_COUNTING_FOR_1H_SLOT_INCLUDE_LONG_STAFF value
                 * @property {number} VISITOR_COUNTING_FOR_WHOLE_DAY_INCLUDE_LONG_STAFF=9 VISITOR_COUNTING_FOR_WHOLE_DAY_INCLUDE_LONG_STAFF value
                 * @property {number} DWELL_TIME_FOR_WHOLE_DAY=10 DWELL_TIME_FOR_WHOLE_DAY value
                 * @property {number} BUYER_DWELL_TIME_FOR_WHOLE_DAY=11 BUYER_DWELL_TIME_FOR_WHOLE_DAY value
                 * @property {number} VISITOR_COUNTING_ON_SECTION_FOR_WHOLE_DAY=12 VISITOR_COUNTING_ON_SECTION_FOR_WHOLE_DAY value
                 * @property {number} VISITOR_COUNTING_ON_SECTION_FOR_1H_SLOT=13 VISITOR_COUNTING_ON_SECTION_FOR_1H_SLOT value
                 * @property {number} GROUP_COUNTING_FOR_1H_SLOT=14 GROUP_COUNTING_FOR_1H_SLOT value
                 * @property {number} GROUP_COUNTING_FOR_WHOLE_DAY=15 GROUP_COUNTING_FOR_WHOLE_DAY value
                 * @property {number} TIME_TO_FIRST_INTERACTION_DISTRIBUTION_FOR_WHOLE_DAY=16 TIME_TO_FIRST_INTERACTION_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} TIME_TO_FIRST_INTERACTION_MEDIAN_FOR_WHOLE_DAY=17 TIME_TO_FIRST_INTERACTION_MEDIAN_FOR_WHOLE_DAY value
                 * @property {number} TIME_TO_FIRST_GREETING_DISTRIBUTION_FOR_WHOLE_DAY=18 TIME_TO_FIRST_GREETING_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} TIME_TO_FIRST_GREETING_MEDIAN_FOR_WHOLE_DAY=19 TIME_TO_FIRST_GREETING_MEDIAN_FOR_WHOLE_DAY value
                 * @property {number} GREETING_RATE_FOR_WHOLE_DAY=20 GREETING_RATE_FOR_WHOLE_DAY value
                 * @property {number} GROUP_RATE_FOR_WHOLE_DAY=21 GROUP_RATE_FOR_WHOLE_DAY value
                 * @property {number} GROUP_WITH_KID_RATE_FOR_WHOLE_DAY=22 GROUP_WITH_KID_RATE_FOR_WHOLE_DAY value
                 * @property {number} ENTRANCE_COUNTING_BY_CAMERA_FOR_1H_SLOT=23 ENTRANCE_COUNTING_BY_CAMERA_FOR_1H_SLOT value
                 * @property {number} ENTRANCE_COUNTING_FOR_1H_SLOT=24 ENTRANCE_COUNTING_FOR_1H_SLOT value
                 * @property {number} PASSBY_COUNTING_FOR_1H_SLOT=25 PASSBY_COUNTING_FOR_1H_SLOT value
                 * @property {number} PASSBY_COUNTING_FOR_WHOLE_DAY=26 PASSBY_COUNTING_FOR_WHOLE_DAY value
                 * @property {number} FNB_IN_QUEUE_VISITOR_COUNTING_FOR_1H_SLOT=27 FNB_IN_QUEUE_VISITOR_COUNTING_FOR_1H_SLOT value
                 * @property {number} FNB_IN_QUEUE_VISITOR_COUNTING_FOR_WHOLE_DAY=28 FNB_IN_QUEUE_VISITOR_COUNTING_FOR_WHOLE_DAY value
                 * @property {number} FNB_AVERAGE_QUEUE_TIME_FOR_WHOLE_DAY=29 FNB_AVERAGE_QUEUE_TIME_FOR_WHOLE_DAY value
                 * @property {number} FNB_QUEUE_TIME_DISTRIBUTION_FOR_WHOLE_DAY=30 FNB_QUEUE_TIME_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} FNB_AVERAGE_QUEUE_LENGTH_FOR_WHOLE_DAY=31 FNB_AVERAGE_QUEUE_LENGTH_FOR_WHOLE_DAY value
                 * @property {number} FNB_AVERAGE_TRANSACTION_TIME_FOR_WHOLE_DAY=32 FNB_AVERAGE_TRANSACTION_TIME_FOR_WHOLE_DAY value
                 * @property {number} FNB_TRANSACTION_TIME_DISTRIBUTION_FOR_WHOLE_DAY=33 FNB_TRANSACTION_TIME_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} FNB_AVERAGE_ORDER_PREPARATION_TIME_FOR_WHOLE_DAY=34 FNB_AVERAGE_ORDER_PREPARATION_TIME_FOR_WHOLE_DAY value
                 * @property {number} FNB_ORDER_PREPARATION_TIME_DISTRIBUTION_FOR_WHOLE_DAY=35 FNB_ORDER_PREPARATION_TIME_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} FNB_AVERAGE_TOTAL_SERVICE_TIME_FOR_WHOLE_DAY=36 FNB_AVERAGE_TOTAL_SERVICE_TIME_FOR_WHOLE_DAY value
                 * @property {number} FNB_TOTAL_SERVICE_TIME_DISTRIBUTION_FOR_WHOLE_DAY=37 FNB_TOTAL_SERVICE_TIME_DISTRIBUTION_FOR_WHOLE_DAY value
                 * @property {number} FNB_SAMPLE_RATE_FOR_WHOLE_DAY=38 FNB_SAMPLE_RATE_FOR_WHOLE_DAY value
                 * @property {number} FNB_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_FOR_WHOLE_DAY=39 FNB_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_FOR_WHOLE_DAY value
                 * @property {number} FNB_VISIT_PRECISION_FOR_WHOLE_DAY=40 FNB_VISIT_PRECISION_FOR_WHOLE_DAY value
                 * @property {number} FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY=41 FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY value
                 * @property {number} FNB_VISIT_RECALL_FOR_WHOLE_DAY=42 FNB_VISIT_RECALL_FOR_WHOLE_DAY value
                 * @property {number} FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY=43 FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY=44 FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY=45 FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY=46 FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY=47 FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY=48 FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY=49 FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY=50 FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY=51 FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY=52 FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY=53 FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY=54 FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY=55 FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY=56 FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY=57 FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY=58 FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY value
                 * @property {number} FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY=59 FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY value
                 */
                v1.AccuracyType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN"] = 0;
                    values[valuesById[1] = "VISITOR_COUNTING_FOR_1H_SLOT"] = 1;
                    values[valuesById[2] = "VISITOR_COUNTING_FOR_WHOLE_DAY"] = 2;
                    values[valuesById[3] = "CONVERSION_RATE_FOR_WHOLE_DAY"] = 3;
                    values[valuesById[4] = "INTERACTION_RATE_FOR_WHOLE_DAY"] = 4;
                    values[valuesById[5] = "AGE_DISTRIBUTION_FOR_WHOLE_DAY"] = 5;
                    values[valuesById[6] = "GENDER_DISTRIBUTION_FOR_WHOLE_DAY"] = 6;
                    values[valuesById[7] = "STAFF_CONVERSION_RATE_FOR_WHOLE_DAY"] = 7;
                    values[valuesById[8] = "VISITOR_COUNTING_FOR_1H_SLOT_INCLUDE_LONG_STAFF"] = 8;
                    values[valuesById[9] = "VISITOR_COUNTING_FOR_WHOLE_DAY_INCLUDE_LONG_STAFF"] = 9;
                    values[valuesById[10] = "DWELL_TIME_FOR_WHOLE_DAY"] = 10;
                    values[valuesById[11] = "BUYER_DWELL_TIME_FOR_WHOLE_DAY"] = 11;
                    values[valuesById[12] = "VISITOR_COUNTING_ON_SECTION_FOR_WHOLE_DAY"] = 12;
                    values[valuesById[13] = "VISITOR_COUNTING_ON_SECTION_FOR_1H_SLOT"] = 13;
                    values[valuesById[14] = "GROUP_COUNTING_FOR_1H_SLOT"] = 14;
                    values[valuesById[15] = "GROUP_COUNTING_FOR_WHOLE_DAY"] = 15;
                    values[valuesById[16] = "TIME_TO_FIRST_INTERACTION_DISTRIBUTION_FOR_WHOLE_DAY"] = 16;
                    values[valuesById[17] = "TIME_TO_FIRST_INTERACTION_MEDIAN_FOR_WHOLE_DAY"] = 17;
                    values[valuesById[18] = "TIME_TO_FIRST_GREETING_DISTRIBUTION_FOR_WHOLE_DAY"] = 18;
                    values[valuesById[19] = "TIME_TO_FIRST_GREETING_MEDIAN_FOR_WHOLE_DAY"] = 19;
                    values[valuesById[20] = "GREETING_RATE_FOR_WHOLE_DAY"] = 20;
                    values[valuesById[21] = "GROUP_RATE_FOR_WHOLE_DAY"] = 21;
                    values[valuesById[22] = "GROUP_WITH_KID_RATE_FOR_WHOLE_DAY"] = 22;
                    values[valuesById[23] = "ENTRANCE_COUNTING_BY_CAMERA_FOR_1H_SLOT"] = 23;
                    values[valuesById[24] = "ENTRANCE_COUNTING_FOR_1H_SLOT"] = 24;
                    values[valuesById[25] = "PASSBY_COUNTING_FOR_1H_SLOT"] = 25;
                    values[valuesById[26] = "PASSBY_COUNTING_FOR_WHOLE_DAY"] = 26;
                    values[valuesById[27] = "FNB_IN_QUEUE_VISITOR_COUNTING_FOR_1H_SLOT"] = 27;
                    values[valuesById[28] = "FNB_IN_QUEUE_VISITOR_COUNTING_FOR_WHOLE_DAY"] = 28;
                    values[valuesById[29] = "FNB_AVERAGE_QUEUE_TIME_FOR_WHOLE_DAY"] = 29;
                    values[valuesById[30] = "FNB_QUEUE_TIME_DISTRIBUTION_FOR_WHOLE_DAY"] = 30;
                    values[valuesById[31] = "FNB_AVERAGE_QUEUE_LENGTH_FOR_WHOLE_DAY"] = 31;
                    values[valuesById[32] = "FNB_AVERAGE_TRANSACTION_TIME_FOR_WHOLE_DAY"] = 32;
                    values[valuesById[33] = "FNB_TRANSACTION_TIME_DISTRIBUTION_FOR_WHOLE_DAY"] = 33;
                    values[valuesById[34] = "FNB_AVERAGE_ORDER_PREPARATION_TIME_FOR_WHOLE_DAY"] = 34;
                    values[valuesById[35] = "FNB_ORDER_PREPARATION_TIME_DISTRIBUTION_FOR_WHOLE_DAY"] = 35;
                    values[valuesById[36] = "FNB_AVERAGE_TOTAL_SERVICE_TIME_FOR_WHOLE_DAY"] = 36;
                    values[valuesById[37] = "FNB_TOTAL_SERVICE_TIME_DISTRIBUTION_FOR_WHOLE_DAY"] = 37;
                    values[valuesById[38] = "FNB_SAMPLE_RATE_FOR_WHOLE_DAY"] = 38;
                    values[valuesById[39] = "FNB_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_FOR_WHOLE_DAY"] = 39;
                    values[valuesById[40] = "FNB_VISIT_PRECISION_FOR_WHOLE_DAY"] = 40;
                    values[valuesById[41] = "FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY"] = 41;
                    values[valuesById[42] = "FNB_VISIT_RECALL_FOR_WHOLE_DAY"] = 42;
                    values[valuesById[43] = "FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY"] = 43;
                    values[valuesById[44] = "FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY"] = 44;
                    values[valuesById[45] = "FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY"] = 45;
                    values[valuesById[46] = "FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY"] = 46;
                    values[valuesById[47] = "FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY"] = 47;
                    values[valuesById[48] = "FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY"] = 48;
                    values[valuesById[49] = "FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY"] = 49;
                    values[valuesById[50] = "FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY"] = 50;
                    values[valuesById[51] = "FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY"] = 51;
                    values[valuesById[52] = "FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY"] = 52;
                    values[valuesById[53] = "FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY"] = 53;
                    values[valuesById[54] = "FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY"] = 54;
                    values[valuesById[55] = "FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY"] = 55;
                    values[valuesById[56] = "FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY"] = 56;
                    values[valuesById[57] = "FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY"] = 57;
                    values[valuesById[58] = "FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY"] = 58;
                    values[valuesById[59] = "FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY"] = 59;
                    return values;
                })();
    
                v1.FnbVisitMatch = (function() {
    
                    /**
                     * Properties of a FnbVisitMatch.
                     * @memberof palexy.sherlock.v1
                     * @interface IFnbVisitMatch
                     * @property {palexy.sherlock.v1.FnbVisitMatch.State|null} [state] FnbVisitMatch state
                     * @property {string|null} [systemPersonId] FnbVisitMatch systemPersonId
                     * @property {string|null} [systemStartQueueTime] FnbVisitMatch systemStartQueueTime
                     * @property {string|null} [systemStartTransactionTime] FnbVisitMatch systemStartTransactionTime
                     * @property {string|null} [systemEndTransactionTime] FnbVisitMatch systemEndTransactionTime
                     * @property {string|null} [systemPickupTime] FnbVisitMatch systemPickupTime
                     * @property {string|null} [qcVisitorId] FnbVisitMatch qcVisitorId
                     * @property {string|null} [qcGroupId] FnbVisitMatch qcGroupId
                     * @property {string|null} [qcMinStartQueueTime] FnbVisitMatch qcMinStartQueueTime
                     * @property {string|null} [qcMaxStartQueueTime] FnbVisitMatch qcMaxStartQueueTime
                     * @property {string|null} [qcStartTransactionTime] FnbVisitMatch qcStartTransactionTime
                     * @property {string|null} [qcMinEndTransactionTime] FnbVisitMatch qcMinEndTransactionTime
                     * @property {string|null} [qcMaxEndTransactionTime] FnbVisitMatch qcMaxEndTransactionTime
                     * @property {string|null} [qcPickupTime] FnbVisitMatch qcPickupTime
                     * @property {palexy.sherlock.v1.IFnbVisitDuration|null} [queueTime] FnbVisitMatch queueTime
                     * @property {palexy.sherlock.v1.IFnbVisitDuration|null} [transactionTime] FnbVisitMatch transactionTime
                     * @property {palexy.sherlock.v1.IFnbVisitDuration|null} [orderPreparationTime] FnbVisitMatch orderPreparationTime
                     * @property {palexy.sherlock.v1.IFnbVisitDuration|null} [totalServiceTime] FnbVisitMatch totalServiceTime
                     */
    
                    /**
                     * Constructs a new FnbVisitMatch.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FnbVisitMatch.
                     * @implements IFnbVisitMatch
                     * @constructor
                     * @param {palexy.sherlock.v1.IFnbVisitMatch=} [properties] Properties to set
                     */
                    function FnbVisitMatch(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FnbVisitMatch state.
                     * @member {palexy.sherlock.v1.FnbVisitMatch.State} state
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.state = 0;
    
                    /**
                     * FnbVisitMatch systemPersonId.
                     * @member {string} systemPersonId
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.systemPersonId = "";
    
                    /**
                     * FnbVisitMatch systemStartQueueTime.
                     * @member {string} systemStartQueueTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.systemStartQueueTime = "";
    
                    /**
                     * FnbVisitMatch systemStartTransactionTime.
                     * @member {string} systemStartTransactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.systemStartTransactionTime = "";
    
                    /**
                     * FnbVisitMatch systemEndTransactionTime.
                     * @member {string} systemEndTransactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.systemEndTransactionTime = "";
    
                    /**
                     * FnbVisitMatch systemPickupTime.
                     * @member {string} systemPickupTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.systemPickupTime = "";
    
                    /**
                     * FnbVisitMatch qcVisitorId.
                     * @member {string} qcVisitorId
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcVisitorId = "";
    
                    /**
                     * FnbVisitMatch qcGroupId.
                     * @member {string} qcGroupId
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcGroupId = "";
    
                    /**
                     * FnbVisitMatch qcMinStartQueueTime.
                     * @member {string} qcMinStartQueueTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcMinStartQueueTime = "";
    
                    /**
                     * FnbVisitMatch qcMaxStartQueueTime.
                     * @member {string} qcMaxStartQueueTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcMaxStartQueueTime = "";
    
                    /**
                     * FnbVisitMatch qcStartTransactionTime.
                     * @member {string} qcStartTransactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcStartTransactionTime = "";
    
                    /**
                     * FnbVisitMatch qcMinEndTransactionTime.
                     * @member {string} qcMinEndTransactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcMinEndTransactionTime = "";
    
                    /**
                     * FnbVisitMatch qcMaxEndTransactionTime.
                     * @member {string} qcMaxEndTransactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcMaxEndTransactionTime = "";
    
                    /**
                     * FnbVisitMatch qcPickupTime.
                     * @member {string} qcPickupTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.qcPickupTime = "";
    
                    /**
                     * FnbVisitMatch queueTime.
                     * @member {palexy.sherlock.v1.IFnbVisitDuration|null|undefined} queueTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.queueTime = null;
    
                    /**
                     * FnbVisitMatch transactionTime.
                     * @member {palexy.sherlock.v1.IFnbVisitDuration|null|undefined} transactionTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.transactionTime = null;
    
                    /**
                     * FnbVisitMatch orderPreparationTime.
                     * @member {palexy.sherlock.v1.IFnbVisitDuration|null|undefined} orderPreparationTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.orderPreparationTime = null;
    
                    /**
                     * FnbVisitMatch totalServiceTime.
                     * @member {palexy.sherlock.v1.IFnbVisitDuration|null|undefined} totalServiceTime
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     */
                    FnbVisitMatch.prototype.totalServiceTime = null;
    
                    /**
                     * Creates a new FnbVisitMatch instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitMatch=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FnbVisitMatch} FnbVisitMatch instance
                     */
                    FnbVisitMatch.create = function create(properties) {
                        return new FnbVisitMatch(properties);
                    };
    
                    /**
                     * Encodes the specified FnbVisitMatch message. Does not implicitly {@link palexy.sherlock.v1.FnbVisitMatch.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitMatch} message FnbVisitMatch message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FnbVisitMatch.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                        if (message.systemPersonId != null && Object.hasOwnProperty.call(message, "systemPersonId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.systemPersonId);
                        if (message.systemStartQueueTime != null && Object.hasOwnProperty.call(message, "systemStartQueueTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.systemStartQueueTime);
                        if (message.systemStartTransactionTime != null && Object.hasOwnProperty.call(message, "systemStartTransactionTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.systemStartTransactionTime);
                        if (message.systemEndTransactionTime != null && Object.hasOwnProperty.call(message, "systemEndTransactionTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.systemEndTransactionTime);
                        if (message.systemPickupTime != null && Object.hasOwnProperty.call(message, "systemPickupTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.systemPickupTime);
                        if (message.qcVisitorId != null && Object.hasOwnProperty.call(message, "qcVisitorId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.qcVisitorId);
                        if (message.qcGroupId != null && Object.hasOwnProperty.call(message, "qcGroupId"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.qcGroupId);
                        if (message.qcMinStartQueueTime != null && Object.hasOwnProperty.call(message, "qcMinStartQueueTime"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.qcMinStartQueueTime);
                        if (message.qcMaxStartQueueTime != null && Object.hasOwnProperty.call(message, "qcMaxStartQueueTime"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.qcMaxStartQueueTime);
                        if (message.qcStartTransactionTime != null && Object.hasOwnProperty.call(message, "qcStartTransactionTime"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.qcStartTransactionTime);
                        if (message.qcMinEndTransactionTime != null && Object.hasOwnProperty.call(message, "qcMinEndTransactionTime"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.qcMinEndTransactionTime);
                        if (message.qcMaxEndTransactionTime != null && Object.hasOwnProperty.call(message, "qcMaxEndTransactionTime"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.qcMaxEndTransactionTime);
                        if (message.qcPickupTime != null && Object.hasOwnProperty.call(message, "qcPickupTime"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.qcPickupTime);
                        if (message.queueTime != null && Object.hasOwnProperty.call(message, "queueTime"))
                            $root.palexy.sherlock.v1.FnbVisitDuration.encode(message.queueTime, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
                            $root.palexy.sherlock.v1.FnbVisitDuration.encode(message.transactionTime, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.orderPreparationTime != null && Object.hasOwnProperty.call(message, "orderPreparationTime"))
                            $root.palexy.sherlock.v1.FnbVisitDuration.encode(message.orderPreparationTime, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.totalServiceTime != null && Object.hasOwnProperty.call(message, "totalServiceTime"))
                            $root.palexy.sherlock.v1.FnbVisitDuration.encode(message.totalServiceTime, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FnbVisitMatch message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FnbVisitMatch.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitMatch} message FnbVisitMatch message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FnbVisitMatch.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FnbVisitMatch message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FnbVisitMatch} FnbVisitMatch
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FnbVisitMatch.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FnbVisitMatch();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.state = reader.int32();
                                break;
                            case 2:
                                message.systemPersonId = reader.string();
                                break;
                            case 3:
                                message.systemStartQueueTime = reader.string();
                                break;
                            case 4:
                                message.systemStartTransactionTime = reader.string();
                                break;
                            case 5:
                                message.systemEndTransactionTime = reader.string();
                                break;
                            case 6:
                                message.systemPickupTime = reader.string();
                                break;
                            case 7:
                                message.qcVisitorId = reader.string();
                                break;
                            case 8:
                                message.qcGroupId = reader.string();
                                break;
                            case 9:
                                message.qcMinStartQueueTime = reader.string();
                                break;
                            case 10:
                                message.qcMaxStartQueueTime = reader.string();
                                break;
                            case 11:
                                message.qcStartTransactionTime = reader.string();
                                break;
                            case 12:
                                message.qcMinEndTransactionTime = reader.string();
                                break;
                            case 13:
                                message.qcMaxEndTransactionTime = reader.string();
                                break;
                            case 14:
                                message.qcPickupTime = reader.string();
                                break;
                            case 15:
                                message.queueTime = $root.palexy.sherlock.v1.FnbVisitDuration.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.transactionTime = $root.palexy.sherlock.v1.FnbVisitDuration.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.orderPreparationTime = $root.palexy.sherlock.v1.FnbVisitDuration.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.totalServiceTime = $root.palexy.sherlock.v1.FnbVisitDuration.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FnbVisitMatch message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FnbVisitMatch} FnbVisitMatch
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FnbVisitMatch.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FnbVisitMatch message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FnbVisitMatch.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.systemPersonId != null && message.hasOwnProperty("systemPersonId"))
                            if (!$util.isString(message.systemPersonId))
                                return "systemPersonId: string expected";
                        if (message.systemStartQueueTime != null && message.hasOwnProperty("systemStartQueueTime"))
                            if (!$util.isString(message.systemStartQueueTime))
                                return "systemStartQueueTime: string expected";
                        if (message.systemStartTransactionTime != null && message.hasOwnProperty("systemStartTransactionTime"))
                            if (!$util.isString(message.systemStartTransactionTime))
                                return "systemStartTransactionTime: string expected";
                        if (message.systemEndTransactionTime != null && message.hasOwnProperty("systemEndTransactionTime"))
                            if (!$util.isString(message.systemEndTransactionTime))
                                return "systemEndTransactionTime: string expected";
                        if (message.systemPickupTime != null && message.hasOwnProperty("systemPickupTime"))
                            if (!$util.isString(message.systemPickupTime))
                                return "systemPickupTime: string expected";
                        if (message.qcVisitorId != null && message.hasOwnProperty("qcVisitorId"))
                            if (!$util.isString(message.qcVisitorId))
                                return "qcVisitorId: string expected";
                        if (message.qcGroupId != null && message.hasOwnProperty("qcGroupId"))
                            if (!$util.isString(message.qcGroupId))
                                return "qcGroupId: string expected";
                        if (message.qcMinStartQueueTime != null && message.hasOwnProperty("qcMinStartQueueTime"))
                            if (!$util.isString(message.qcMinStartQueueTime))
                                return "qcMinStartQueueTime: string expected";
                        if (message.qcMaxStartQueueTime != null && message.hasOwnProperty("qcMaxStartQueueTime"))
                            if (!$util.isString(message.qcMaxStartQueueTime))
                                return "qcMaxStartQueueTime: string expected";
                        if (message.qcStartTransactionTime != null && message.hasOwnProperty("qcStartTransactionTime"))
                            if (!$util.isString(message.qcStartTransactionTime))
                                return "qcStartTransactionTime: string expected";
                        if (message.qcMinEndTransactionTime != null && message.hasOwnProperty("qcMinEndTransactionTime"))
                            if (!$util.isString(message.qcMinEndTransactionTime))
                                return "qcMinEndTransactionTime: string expected";
                        if (message.qcMaxEndTransactionTime != null && message.hasOwnProperty("qcMaxEndTransactionTime"))
                            if (!$util.isString(message.qcMaxEndTransactionTime))
                                return "qcMaxEndTransactionTime: string expected";
                        if (message.qcPickupTime != null && message.hasOwnProperty("qcPickupTime"))
                            if (!$util.isString(message.qcPickupTime))
                                return "qcPickupTime: string expected";
                        if (message.queueTime != null && message.hasOwnProperty("queueTime")) {
                            var error = $root.palexy.sherlock.v1.FnbVisitDuration.verify(message.queueTime);
                            if (error)
                                return "queueTime." + error;
                        }
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime")) {
                            var error = $root.palexy.sherlock.v1.FnbVisitDuration.verify(message.transactionTime);
                            if (error)
                                return "transactionTime." + error;
                        }
                        if (message.orderPreparationTime != null && message.hasOwnProperty("orderPreparationTime")) {
                            var error = $root.palexy.sherlock.v1.FnbVisitDuration.verify(message.orderPreparationTime);
                            if (error)
                                return "orderPreparationTime." + error;
                        }
                        if (message.totalServiceTime != null && message.hasOwnProperty("totalServiceTime")) {
                            var error = $root.palexy.sherlock.v1.FnbVisitDuration.verify(message.totalServiceTime);
                            if (error)
                                return "totalServiceTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FnbVisitMatch message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FnbVisitMatch} FnbVisitMatch
                     */
                    FnbVisitMatch.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FnbVisitMatch)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FnbVisitMatch();
                        switch (object.state) {
                        case "STATE_UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "MATCHED":
                        case 1:
                            message.state = 1;
                            break;
                        case "MATCHED_LOOSE":
                        case 2:
                            message.state = 2;
                            break;
                        case "SYSTEM_ONLY":
                        case 3:
                            message.state = 3;
                            break;
                        case "QC_ONLY":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        if (object.systemPersonId != null)
                            message.systemPersonId = String(object.systemPersonId);
                        if (object.systemStartQueueTime != null)
                            message.systemStartQueueTime = String(object.systemStartQueueTime);
                        if (object.systemStartTransactionTime != null)
                            message.systemStartTransactionTime = String(object.systemStartTransactionTime);
                        if (object.systemEndTransactionTime != null)
                            message.systemEndTransactionTime = String(object.systemEndTransactionTime);
                        if (object.systemPickupTime != null)
                            message.systemPickupTime = String(object.systemPickupTime);
                        if (object.qcVisitorId != null)
                            message.qcVisitorId = String(object.qcVisitorId);
                        if (object.qcGroupId != null)
                            message.qcGroupId = String(object.qcGroupId);
                        if (object.qcMinStartQueueTime != null)
                            message.qcMinStartQueueTime = String(object.qcMinStartQueueTime);
                        if (object.qcMaxStartQueueTime != null)
                            message.qcMaxStartQueueTime = String(object.qcMaxStartQueueTime);
                        if (object.qcStartTransactionTime != null)
                            message.qcStartTransactionTime = String(object.qcStartTransactionTime);
                        if (object.qcMinEndTransactionTime != null)
                            message.qcMinEndTransactionTime = String(object.qcMinEndTransactionTime);
                        if (object.qcMaxEndTransactionTime != null)
                            message.qcMaxEndTransactionTime = String(object.qcMaxEndTransactionTime);
                        if (object.qcPickupTime != null)
                            message.qcPickupTime = String(object.qcPickupTime);
                        if (object.queueTime != null) {
                            if (typeof object.queueTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.FnbVisitMatch.queueTime: object expected");
                            message.queueTime = $root.palexy.sherlock.v1.FnbVisitDuration.fromObject(object.queueTime);
                        }
                        if (object.transactionTime != null) {
                            if (typeof object.transactionTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.FnbVisitMatch.transactionTime: object expected");
                            message.transactionTime = $root.palexy.sherlock.v1.FnbVisitDuration.fromObject(object.transactionTime);
                        }
                        if (object.orderPreparationTime != null) {
                            if (typeof object.orderPreparationTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.FnbVisitMatch.orderPreparationTime: object expected");
                            message.orderPreparationTime = $root.palexy.sherlock.v1.FnbVisitDuration.fromObject(object.orderPreparationTime);
                        }
                        if (object.totalServiceTime != null) {
                            if (typeof object.totalServiceTime !== "object")
                                throw TypeError(".palexy.sherlock.v1.FnbVisitMatch.totalServiceTime: object expected");
                            message.totalServiceTime = $root.palexy.sherlock.v1.FnbVisitDuration.fromObject(object.totalServiceTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FnbVisitMatch message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @static
                     * @param {palexy.sherlock.v1.FnbVisitMatch} message FnbVisitMatch
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FnbVisitMatch.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.state = options.enums === String ? "STATE_UNKNOWN" : 0;
                            object.systemPersonId = "";
                            object.systemStartQueueTime = "";
                            object.systemStartTransactionTime = "";
                            object.systemEndTransactionTime = "";
                            object.systemPickupTime = "";
                            object.qcVisitorId = "";
                            object.qcGroupId = "";
                            object.qcMinStartQueueTime = "";
                            object.qcMaxStartQueueTime = "";
                            object.qcStartTransactionTime = "";
                            object.qcMinEndTransactionTime = "";
                            object.qcMaxEndTransactionTime = "";
                            object.qcPickupTime = "";
                            object.queueTime = null;
                            object.transactionTime = null;
                            object.orderPreparationTime = null;
                            object.totalServiceTime = null;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.sherlock.v1.FnbVisitMatch.State[message.state] : message.state;
                        if (message.systemPersonId != null && message.hasOwnProperty("systemPersonId"))
                            object.systemPersonId = message.systemPersonId;
                        if (message.systemStartQueueTime != null && message.hasOwnProperty("systemStartQueueTime"))
                            object.systemStartQueueTime = message.systemStartQueueTime;
                        if (message.systemStartTransactionTime != null && message.hasOwnProperty("systemStartTransactionTime"))
                            object.systemStartTransactionTime = message.systemStartTransactionTime;
                        if (message.systemEndTransactionTime != null && message.hasOwnProperty("systemEndTransactionTime"))
                            object.systemEndTransactionTime = message.systemEndTransactionTime;
                        if (message.systemPickupTime != null && message.hasOwnProperty("systemPickupTime"))
                            object.systemPickupTime = message.systemPickupTime;
                        if (message.qcVisitorId != null && message.hasOwnProperty("qcVisitorId"))
                            object.qcVisitorId = message.qcVisitorId;
                        if (message.qcGroupId != null && message.hasOwnProperty("qcGroupId"))
                            object.qcGroupId = message.qcGroupId;
                        if (message.qcMinStartQueueTime != null && message.hasOwnProperty("qcMinStartQueueTime"))
                            object.qcMinStartQueueTime = message.qcMinStartQueueTime;
                        if (message.qcMaxStartQueueTime != null && message.hasOwnProperty("qcMaxStartQueueTime"))
                            object.qcMaxStartQueueTime = message.qcMaxStartQueueTime;
                        if (message.qcStartTransactionTime != null && message.hasOwnProperty("qcStartTransactionTime"))
                            object.qcStartTransactionTime = message.qcStartTransactionTime;
                        if (message.qcMinEndTransactionTime != null && message.hasOwnProperty("qcMinEndTransactionTime"))
                            object.qcMinEndTransactionTime = message.qcMinEndTransactionTime;
                        if (message.qcMaxEndTransactionTime != null && message.hasOwnProperty("qcMaxEndTransactionTime"))
                            object.qcMaxEndTransactionTime = message.qcMaxEndTransactionTime;
                        if (message.qcPickupTime != null && message.hasOwnProperty("qcPickupTime"))
                            object.qcPickupTime = message.qcPickupTime;
                        if (message.queueTime != null && message.hasOwnProperty("queueTime"))
                            object.queueTime = $root.palexy.sherlock.v1.FnbVisitDuration.toObject(message.queueTime, options);
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
                            object.transactionTime = $root.palexy.sherlock.v1.FnbVisitDuration.toObject(message.transactionTime, options);
                        if (message.orderPreparationTime != null && message.hasOwnProperty("orderPreparationTime"))
                            object.orderPreparationTime = $root.palexy.sherlock.v1.FnbVisitDuration.toObject(message.orderPreparationTime, options);
                        if (message.totalServiceTime != null && message.hasOwnProperty("totalServiceTime"))
                            object.totalServiceTime = $root.palexy.sherlock.v1.FnbVisitDuration.toObject(message.totalServiceTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this FnbVisitMatch to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FnbVisitMatch
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FnbVisitMatch.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * State enum.
                     * @name palexy.sherlock.v1.FnbVisitMatch.State
                     * @enum {number}
                     * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
                     * @property {number} MATCHED=1 MATCHED value
                     * @property {number} MATCHED_LOOSE=2 MATCHED_LOOSE value
                     * @property {number} SYSTEM_ONLY=3 SYSTEM_ONLY value
                     * @property {number} QC_ONLY=4 QC_ONLY value
                     */
                    FnbVisitMatch.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATE_UNKNOWN"] = 0;
                        values[valuesById[1] = "MATCHED"] = 1;
                        values[valuesById[2] = "MATCHED_LOOSE"] = 2;
                        values[valuesById[3] = "SYSTEM_ONLY"] = 3;
                        values[valuesById[4] = "QC_ONLY"] = 4;
                        return values;
                    })();
    
                    return FnbVisitMatch;
                })();
    
                v1.FnbVisitDuration = (function() {
    
                    /**
                     * Properties of a FnbVisitDuration.
                     * @memberof palexy.sherlock.v1
                     * @interface IFnbVisitDuration
                     * @property {boolean|null} [hasSystem] FnbVisitDuration hasSystem
                     * @property {number|null} [systemSeconds] FnbVisitDuration systemSeconds
                     * @property {boolean|null} [hasQc] FnbVisitDuration hasQc
                     * @property {number|null} [qcMinSeconds] FnbVisitDuration qcMinSeconds
                     * @property {number|null} [qcMaxSeconds] FnbVisitDuration qcMaxSeconds
                     */
    
                    /**
                     * Constructs a new FnbVisitDuration.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FnbVisitDuration.
                     * @implements IFnbVisitDuration
                     * @constructor
                     * @param {palexy.sherlock.v1.IFnbVisitDuration=} [properties] Properties to set
                     */
                    function FnbVisitDuration(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FnbVisitDuration hasSystem.
                     * @member {boolean} hasSystem
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     */
                    FnbVisitDuration.prototype.hasSystem = false;
    
                    /**
                     * FnbVisitDuration systemSeconds.
                     * @member {number} systemSeconds
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     */
                    FnbVisitDuration.prototype.systemSeconds = 0;
    
                    /**
                     * FnbVisitDuration hasQc.
                     * @member {boolean} hasQc
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     */
                    FnbVisitDuration.prototype.hasQc = false;
    
                    /**
                     * FnbVisitDuration qcMinSeconds.
                     * @member {number} qcMinSeconds
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     */
                    FnbVisitDuration.prototype.qcMinSeconds = 0;
    
                    /**
                     * FnbVisitDuration qcMaxSeconds.
                     * @member {number} qcMaxSeconds
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     */
                    FnbVisitDuration.prototype.qcMaxSeconds = 0;
    
                    /**
                     * Creates a new FnbVisitDuration instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitDuration=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FnbVisitDuration} FnbVisitDuration instance
                     */
                    FnbVisitDuration.create = function create(properties) {
                        return new FnbVisitDuration(properties);
                    };
    
                    /**
                     * Encodes the specified FnbVisitDuration message. Does not implicitly {@link palexy.sherlock.v1.FnbVisitDuration.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitDuration} message FnbVisitDuration message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FnbVisitDuration.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.hasSystem != null && Object.hasOwnProperty.call(message, "hasSystem"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.hasSystem);
                        if (message.systemSeconds != null && Object.hasOwnProperty.call(message, "systemSeconds"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.systemSeconds);
                        if (message.hasQc != null && Object.hasOwnProperty.call(message, "hasQc"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.hasQc);
                        if (message.qcMinSeconds != null && Object.hasOwnProperty.call(message, "qcMinSeconds"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.qcMinSeconds);
                        if (message.qcMaxSeconds != null && Object.hasOwnProperty.call(message, "qcMaxSeconds"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.qcMaxSeconds);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FnbVisitDuration message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FnbVisitDuration.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {palexy.sherlock.v1.IFnbVisitDuration} message FnbVisitDuration message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FnbVisitDuration.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FnbVisitDuration message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FnbVisitDuration} FnbVisitDuration
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FnbVisitDuration.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FnbVisitDuration();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.hasSystem = reader.bool();
                                break;
                            case 2:
                                message.systemSeconds = reader.int32();
                                break;
                            case 3:
                                message.hasQc = reader.bool();
                                break;
                            case 4:
                                message.qcMinSeconds = reader.int32();
                                break;
                            case 5:
                                message.qcMaxSeconds = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FnbVisitDuration message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FnbVisitDuration} FnbVisitDuration
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FnbVisitDuration.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FnbVisitDuration message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FnbVisitDuration.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.hasSystem != null && message.hasOwnProperty("hasSystem"))
                            if (typeof message.hasSystem !== "boolean")
                                return "hasSystem: boolean expected";
                        if (message.systemSeconds != null && message.hasOwnProperty("systemSeconds"))
                            if (!$util.isInteger(message.systemSeconds))
                                return "systemSeconds: integer expected";
                        if (message.hasQc != null && message.hasOwnProperty("hasQc"))
                            if (typeof message.hasQc !== "boolean")
                                return "hasQc: boolean expected";
                        if (message.qcMinSeconds != null && message.hasOwnProperty("qcMinSeconds"))
                            if (!$util.isInteger(message.qcMinSeconds))
                                return "qcMinSeconds: integer expected";
                        if (message.qcMaxSeconds != null && message.hasOwnProperty("qcMaxSeconds"))
                            if (!$util.isInteger(message.qcMaxSeconds))
                                return "qcMaxSeconds: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a FnbVisitDuration message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FnbVisitDuration} FnbVisitDuration
                     */
                    FnbVisitDuration.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FnbVisitDuration)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FnbVisitDuration();
                        if (object.hasSystem != null)
                            message.hasSystem = Boolean(object.hasSystem);
                        if (object.systemSeconds != null)
                            message.systemSeconds = object.systemSeconds | 0;
                        if (object.hasQc != null)
                            message.hasQc = Boolean(object.hasQc);
                        if (object.qcMinSeconds != null)
                            message.qcMinSeconds = object.qcMinSeconds | 0;
                        if (object.qcMaxSeconds != null)
                            message.qcMaxSeconds = object.qcMaxSeconds | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FnbVisitDuration message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @static
                     * @param {palexy.sherlock.v1.FnbVisitDuration} message FnbVisitDuration
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FnbVisitDuration.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.hasSystem = false;
                            object.systemSeconds = 0;
                            object.hasQc = false;
                            object.qcMinSeconds = 0;
                            object.qcMaxSeconds = 0;
                        }
                        if (message.hasSystem != null && message.hasOwnProperty("hasSystem"))
                            object.hasSystem = message.hasSystem;
                        if (message.systemSeconds != null && message.hasOwnProperty("systemSeconds"))
                            object.systemSeconds = message.systemSeconds;
                        if (message.hasQc != null && message.hasOwnProperty("hasQc"))
                            object.hasQc = message.hasQc;
                        if (message.qcMinSeconds != null && message.hasOwnProperty("qcMinSeconds"))
                            object.qcMinSeconds = message.qcMinSeconds;
                        if (message.qcMaxSeconds != null && message.hasOwnProperty("qcMaxSeconds"))
                            object.qcMaxSeconds = message.qcMaxSeconds;
                        return object;
                    };
    
                    /**
                     * Converts this FnbVisitDuration to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FnbVisitDuration
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FnbVisitDuration.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FnbVisitDuration;
                })();
    
                v1.AccuracyResult = (function() {
    
                    /**
                     * Properties of an AccuracyResult.
                     * @memberof palexy.sherlock.v1
                     * @interface IAccuracyResult
                     * @property {string|null} [name] AccuracyResult name
                     * @property {palexy.sherlock.v1.AccuracyType|null} [accuracyType] AccuracyResult accuracyType
                     * @property {number|null} [storeId] AccuracyResult storeId
                     * @property {number|null} [accuracyNumber] AccuracyResult accuracyNumber
                     * @property {string|null} [dateId] AccuracyResult dateId
                     * @property {number|null} [createTimeMs] AccuracyResult createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] AccuracyResult lastUpdateTimeMs
                     * @property {string|null} [additionalData] AccuracyResult additionalData
                     * @property {number|null} [qcFileId] AccuracyResult qcFileId
                     * @property {number|null} [hourSlot] AccuracyResult hourSlot
                     * @property {number|null} [systemResult] AccuracyResult systemResult
                     * @property {number|null} [qcResultMin] AccuracyResult qcResultMin
                     * @property {number|null} [qcResultMax] AccuracyResult qcResultMax
                     * @property {string|null} [experimentProgrammingName] AccuracyResult experimentProgrammingName
                     * @property {string|null} [sectionName] AccuracyResult sectionName
                     * @property {string|null} [cameraId] AccuracyResult cameraId
                     */
    
                    /**
                     * Constructs a new AccuracyResult.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AccuracyResult.
                     * @implements IAccuracyResult
                     * @constructor
                     * @param {palexy.sherlock.v1.IAccuracyResult=} [properties] Properties to set
                     */
                    function AccuracyResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AccuracyResult name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.name = "";
    
                    /**
                     * AccuracyResult accuracyType.
                     * @member {palexy.sherlock.v1.AccuracyType} accuracyType
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.accuracyType = 0;
    
                    /**
                     * AccuracyResult storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AccuracyResult accuracyNumber.
                     * @member {number} accuracyNumber
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.accuracyNumber = 0;
    
                    /**
                     * AccuracyResult dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.dateId = "";
    
                    /**
                     * AccuracyResult createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AccuracyResult lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AccuracyResult additionalData.
                     * @member {string} additionalData
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.additionalData = "";
    
                    /**
                     * AccuracyResult qcFileId.
                     * @member {number} qcFileId
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.qcFileId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AccuracyResult hourSlot.
                     * @member {number} hourSlot
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.hourSlot = 0;
    
                    /**
                     * AccuracyResult systemResult.
                     * @member {number} systemResult
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.systemResult = 0;
    
                    /**
                     * AccuracyResult qcResultMin.
                     * @member {number} qcResultMin
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.qcResultMin = 0;
    
                    /**
                     * AccuracyResult qcResultMax.
                     * @member {number} qcResultMax
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.qcResultMax = 0;
    
                    /**
                     * AccuracyResult experimentProgrammingName.
                     * @member {string} experimentProgrammingName
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.experimentProgrammingName = "";
    
                    /**
                     * AccuracyResult sectionName.
                     * @member {string} sectionName
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.sectionName = "";
    
                    /**
                     * AccuracyResult cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     */
                    AccuracyResult.prototype.cameraId = "";
    
                    /**
                     * Creates a new AccuracyResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IAccuracyResult=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AccuracyResult} AccuracyResult instance
                     */
                    AccuracyResult.create = function create(properties) {
                        return new AccuracyResult(properties);
                    };
    
                    /**
                     * Encodes the specified AccuracyResult message. Does not implicitly {@link palexy.sherlock.v1.AccuracyResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IAccuracyResult} message AccuracyResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AccuracyResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.accuracyType != null && Object.hasOwnProperty.call(message, "accuracyType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.accuracyType);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.accuracyNumber != null && Object.hasOwnProperty.call(message, "accuracyNumber"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.accuracyNumber);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.dateId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.additionalData != null && Object.hasOwnProperty.call(message, "additionalData"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.additionalData);
                        if (message.qcFileId != null && Object.hasOwnProperty.call(message, "qcFileId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.qcFileId);
                        if (message.hourSlot != null && Object.hasOwnProperty.call(message, "hourSlot"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.hourSlot);
                        if (message.systemResult != null && Object.hasOwnProperty.call(message, "systemResult"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.systemResult);
                        if (message.qcResultMin != null && Object.hasOwnProperty.call(message, "qcResultMin"))
                            writer.uint32(/* id 12, wireType 5 =*/101).float(message.qcResultMin);
                        if (message.qcResultMax != null && Object.hasOwnProperty.call(message, "qcResultMax"))
                            writer.uint32(/* id 13, wireType 5 =*/109).float(message.qcResultMax);
                        if (message.experimentProgrammingName != null && Object.hasOwnProperty.call(message, "experimentProgrammingName"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.experimentProgrammingName);
                        if (message.sectionName != null && Object.hasOwnProperty.call(message, "sectionName"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.sectionName);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.cameraId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AccuracyResult message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AccuracyResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.IAccuracyResult} message AccuracyResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AccuracyResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AccuracyResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AccuracyResult} AccuracyResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AccuracyResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AccuracyResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.accuracyType = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.accuracyNumber = reader.float();
                                break;
                            case 5:
                                message.dateId = reader.string();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.additionalData = reader.string();
                                break;
                            case 9:
                                message.qcFileId = reader.int64();
                                break;
                            case 10:
                                message.hourSlot = reader.int32();
                                break;
                            case 11:
                                message.systemResult = reader.float();
                                break;
                            case 12:
                                message.qcResultMin = reader.float();
                                break;
                            case 13:
                                message.qcResultMax = reader.float();
                                break;
                            case 14:
                                message.experimentProgrammingName = reader.string();
                                break;
                            case 15:
                                message.sectionName = reader.string();
                                break;
                            case 16:
                                message.cameraId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AccuracyResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AccuracyResult} AccuracyResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AccuracyResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AccuracyResult message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AccuracyResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.accuracyType != null && message.hasOwnProperty("accuracyType"))
                            switch (message.accuracyType) {
                            default:
                                return "accuracyType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                            case 25:
                            case 26:
                            case 27:
                            case 28:
                            case 29:
                            case 30:
                            case 31:
                            case 32:
                            case 33:
                            case 34:
                            case 35:
                            case 36:
                            case 37:
                            case 38:
                            case 39:
                            case 40:
                            case 41:
                            case 42:
                            case 43:
                            case 44:
                            case 45:
                            case 46:
                            case 47:
                            case 48:
                            case 49:
                            case 50:
                            case 51:
                            case 52:
                            case 53:
                            case 54:
                            case 55:
                            case 56:
                            case 57:
                            case 58:
                            case 59:
                                break;
                            }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.accuracyNumber != null && message.hasOwnProperty("accuracyNumber"))
                            if (typeof message.accuracyNumber !== "number")
                                return "accuracyNumber: number expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.additionalData != null && message.hasOwnProperty("additionalData"))
                            if (!$util.isString(message.additionalData))
                                return "additionalData: string expected";
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (!$util.isInteger(message.qcFileId) && !(message.qcFileId && $util.isInteger(message.qcFileId.low) && $util.isInteger(message.qcFileId.high)))
                                return "qcFileId: integer|Long expected";
                        if (message.hourSlot != null && message.hasOwnProperty("hourSlot"))
                            if (!$util.isInteger(message.hourSlot))
                                return "hourSlot: integer expected";
                        if (message.systemResult != null && message.hasOwnProperty("systemResult"))
                            if (typeof message.systemResult !== "number")
                                return "systemResult: number expected";
                        if (message.qcResultMin != null && message.hasOwnProperty("qcResultMin"))
                            if (typeof message.qcResultMin !== "number")
                                return "qcResultMin: number expected";
                        if (message.qcResultMax != null && message.hasOwnProperty("qcResultMax"))
                            if (typeof message.qcResultMax !== "number")
                                return "qcResultMax: number expected";
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            if (!$util.isString(message.experimentProgrammingName))
                                return "experimentProgrammingName: string expected";
                        if (message.sectionName != null && message.hasOwnProperty("sectionName"))
                            if (!$util.isString(message.sectionName))
                                return "sectionName: string expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an AccuracyResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AccuracyResult} AccuracyResult
                     */
                    AccuracyResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AccuracyResult)
                            return object;
                        var message = new $root.palexy.sherlock.v1.AccuracyResult();
                        if (object.name != null)
                            message.name = String(object.name);
                        switch (object.accuracyType) {
                        case "UNKNOWN":
                        case 0:
                            message.accuracyType = 0;
                            break;
                        case "VISITOR_COUNTING_FOR_1H_SLOT":
                        case 1:
                            message.accuracyType = 1;
                            break;
                        case "VISITOR_COUNTING_FOR_WHOLE_DAY":
                        case 2:
                            message.accuracyType = 2;
                            break;
                        case "CONVERSION_RATE_FOR_WHOLE_DAY":
                        case 3:
                            message.accuracyType = 3;
                            break;
                        case "INTERACTION_RATE_FOR_WHOLE_DAY":
                        case 4:
                            message.accuracyType = 4;
                            break;
                        case "AGE_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 5:
                            message.accuracyType = 5;
                            break;
                        case "GENDER_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 6:
                            message.accuracyType = 6;
                            break;
                        case "STAFF_CONVERSION_RATE_FOR_WHOLE_DAY":
                        case 7:
                            message.accuracyType = 7;
                            break;
                        case "VISITOR_COUNTING_FOR_1H_SLOT_INCLUDE_LONG_STAFF":
                        case 8:
                            message.accuracyType = 8;
                            break;
                        case "VISITOR_COUNTING_FOR_WHOLE_DAY_INCLUDE_LONG_STAFF":
                        case 9:
                            message.accuracyType = 9;
                            break;
                        case "DWELL_TIME_FOR_WHOLE_DAY":
                        case 10:
                            message.accuracyType = 10;
                            break;
                        case "BUYER_DWELL_TIME_FOR_WHOLE_DAY":
                        case 11:
                            message.accuracyType = 11;
                            break;
                        case "VISITOR_COUNTING_ON_SECTION_FOR_WHOLE_DAY":
                        case 12:
                            message.accuracyType = 12;
                            break;
                        case "VISITOR_COUNTING_ON_SECTION_FOR_1H_SLOT":
                        case 13:
                            message.accuracyType = 13;
                            break;
                        case "GROUP_COUNTING_FOR_1H_SLOT":
                        case 14:
                            message.accuracyType = 14;
                            break;
                        case "GROUP_COUNTING_FOR_WHOLE_DAY":
                        case 15:
                            message.accuracyType = 15;
                            break;
                        case "TIME_TO_FIRST_INTERACTION_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 16:
                            message.accuracyType = 16;
                            break;
                        case "TIME_TO_FIRST_INTERACTION_MEDIAN_FOR_WHOLE_DAY":
                        case 17:
                            message.accuracyType = 17;
                            break;
                        case "TIME_TO_FIRST_GREETING_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 18:
                            message.accuracyType = 18;
                            break;
                        case "TIME_TO_FIRST_GREETING_MEDIAN_FOR_WHOLE_DAY":
                        case 19:
                            message.accuracyType = 19;
                            break;
                        case "GREETING_RATE_FOR_WHOLE_DAY":
                        case 20:
                            message.accuracyType = 20;
                            break;
                        case "GROUP_RATE_FOR_WHOLE_DAY":
                        case 21:
                            message.accuracyType = 21;
                            break;
                        case "GROUP_WITH_KID_RATE_FOR_WHOLE_DAY":
                        case 22:
                            message.accuracyType = 22;
                            break;
                        case "ENTRANCE_COUNTING_BY_CAMERA_FOR_1H_SLOT":
                        case 23:
                            message.accuracyType = 23;
                            break;
                        case "ENTRANCE_COUNTING_FOR_1H_SLOT":
                        case 24:
                            message.accuracyType = 24;
                            break;
                        case "PASSBY_COUNTING_FOR_1H_SLOT":
                        case 25:
                            message.accuracyType = 25;
                            break;
                        case "PASSBY_COUNTING_FOR_WHOLE_DAY":
                        case 26:
                            message.accuracyType = 26;
                            break;
                        case "FNB_IN_QUEUE_VISITOR_COUNTING_FOR_1H_SLOT":
                        case 27:
                            message.accuracyType = 27;
                            break;
                        case "FNB_IN_QUEUE_VISITOR_COUNTING_FOR_WHOLE_DAY":
                        case 28:
                            message.accuracyType = 28;
                            break;
                        case "FNB_AVERAGE_QUEUE_TIME_FOR_WHOLE_DAY":
                        case 29:
                            message.accuracyType = 29;
                            break;
                        case "FNB_QUEUE_TIME_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 30:
                            message.accuracyType = 30;
                            break;
                        case "FNB_AVERAGE_QUEUE_LENGTH_FOR_WHOLE_DAY":
                        case 31:
                            message.accuracyType = 31;
                            break;
                        case "FNB_AVERAGE_TRANSACTION_TIME_FOR_WHOLE_DAY":
                        case 32:
                            message.accuracyType = 32;
                            break;
                        case "FNB_TRANSACTION_TIME_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 33:
                            message.accuracyType = 33;
                            break;
                        case "FNB_AVERAGE_ORDER_PREPARATION_TIME_FOR_WHOLE_DAY":
                        case 34:
                            message.accuracyType = 34;
                            break;
                        case "FNB_ORDER_PREPARATION_TIME_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 35:
                            message.accuracyType = 35;
                            break;
                        case "FNB_AVERAGE_TOTAL_SERVICE_TIME_FOR_WHOLE_DAY":
                        case 36:
                            message.accuracyType = 36;
                            break;
                        case "FNB_TOTAL_SERVICE_TIME_DISTRIBUTION_FOR_WHOLE_DAY":
                        case 37:
                            message.accuracyType = 37;
                            break;
                        case "FNB_SAMPLE_RATE_FOR_WHOLE_DAY":
                        case 38:
                            message.accuracyType = 38;
                            break;
                        case "FNB_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_FOR_WHOLE_DAY":
                        case 39:
                            message.accuracyType = 39;
                            break;
                        case "FNB_VISIT_PRECISION_FOR_WHOLE_DAY":
                        case 40:
                            message.accuracyType = 40;
                            break;
                        case "FNB_VISIT_FALSE_DISCOVERY_RATE_FOR_WHOLE_DAY":
                        case 41:
                            message.accuracyType = 41;
                            break;
                        case "FNB_VISIT_RECALL_FOR_WHOLE_DAY":
                        case 42:
                            message.accuracyType = 42;
                            break;
                        case "FNB_VISIT_MISS_RATE_FOR_WHOLE_DAY":
                        case 43:
                            message.accuracyType = 43;
                            break;
                        case "FNB_MATCHED_QUEUE_TIME_MAPE_FOR_WHOLE_DAY":
                        case 44:
                            message.accuracyType = 44;
                            break;
                        case "FNB_MATCHED_QUEUE_TIME_WMAPE_FOR_WHOLE_DAY":
                        case 45:
                            message.accuracyType = 45;
                            break;
                        case "FNB_MATCHED_QUEUE_TIME_BIAS_FOR_WHOLE_DAY":
                        case 46:
                            message.accuracyType = 46;
                            break;
                        case "FNB_MATCHED_QUEUE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY":
                        case 47:
                            message.accuracyType = 47;
                            break;
                        case "FNB_MATCHED_TRANSACTION_TIME_MAPE_FOR_WHOLE_DAY":
                        case 48:
                            message.accuracyType = 48;
                            break;
                        case "FNB_MATCHED_TRANSACTION_TIME_WMAPE_FOR_WHOLE_DAY":
                        case 49:
                            message.accuracyType = 49;
                            break;
                        case "FNB_MATCHED_TRANSACTION_TIME_BIAS_FOR_WHOLE_DAY":
                        case 50:
                            message.accuracyType = 50;
                            break;
                        case "FNB_MATCHED_TRANSACTION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY":
                        case 51:
                            message.accuracyType = 51;
                            break;
                        case "FNB_MATCHED_ORDER_PREPARATION_TIME_MAPE_FOR_WHOLE_DAY":
                        case 52:
                            message.accuracyType = 52;
                            break;
                        case "FNB_MATCHED_ORDER_PREPARATION_TIME_WMAPE_FOR_WHOLE_DAY":
                        case 53:
                            message.accuracyType = 53;
                            break;
                        case "FNB_MATCHED_ORDER_PREPARATION_TIME_BIAS_FOR_WHOLE_DAY":
                        case 54:
                            message.accuracyType = 54;
                            break;
                        case "FNB_MATCHED_ORDER_PREPARATION_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY":
                        case 55:
                            message.accuracyType = 55;
                            break;
                        case "FNB_MATCHED_TOTAL_SERVICE_TIME_MAPE_FOR_WHOLE_DAY":
                        case 56:
                            message.accuracyType = 56;
                            break;
                        case "FNB_MATCHED_TOTAL_SERVICE_TIME_WMAPE_FOR_WHOLE_DAY":
                        case 57:
                            message.accuracyType = 57;
                            break;
                        case "FNB_MATCHED_TOTAL_SERVICE_TIME_BIAS_FOR_WHOLE_DAY":
                        case 58:
                            message.accuracyType = 58;
                            break;
                        case "FNB_MATCHED_TOTAL_SERVICE_TIME_WEIGHTED_BIAS_FOR_WHOLE_DAY":
                        case 59:
                            message.accuracyType = 59;
                            break;
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.accuracyNumber != null)
                            message.accuracyNumber = Number(object.accuracyNumber);
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.additionalData != null)
                            message.additionalData = String(object.additionalData);
                        if (object.qcFileId != null)
                            if ($util.Long)
                                (message.qcFileId = $util.Long.fromValue(object.qcFileId)).unsigned = false;
                            else if (typeof object.qcFileId === "string")
                                message.qcFileId = parseInt(object.qcFileId, 10);
                            else if (typeof object.qcFileId === "number")
                                message.qcFileId = object.qcFileId;
                            else if (typeof object.qcFileId === "object")
                                message.qcFileId = new $util.LongBits(object.qcFileId.low >>> 0, object.qcFileId.high >>> 0).toNumber();
                        if (object.hourSlot != null)
                            message.hourSlot = object.hourSlot | 0;
                        if (object.systemResult != null)
                            message.systemResult = Number(object.systemResult);
                        if (object.qcResultMin != null)
                            message.qcResultMin = Number(object.qcResultMin);
                        if (object.qcResultMax != null)
                            message.qcResultMax = Number(object.qcResultMax);
                        if (object.experimentProgrammingName != null)
                            message.experimentProgrammingName = String(object.experimentProgrammingName);
                        if (object.sectionName != null)
                            message.sectionName = String(object.sectionName);
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AccuracyResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @static
                     * @param {palexy.sherlock.v1.AccuracyResult} message AccuracyResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AccuracyResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.accuracyType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.accuracyNumber = 0;
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.additionalData = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.qcFileId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.qcFileId = options.longs === String ? "0" : 0;
                            object.hourSlot = 0;
                            object.systemResult = 0;
                            object.qcResultMin = 0;
                            object.qcResultMax = 0;
                            object.experimentProgrammingName = "";
                            object.sectionName = "";
                            object.cameraId = "";
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.accuracyType != null && message.hasOwnProperty("accuracyType"))
                            object.accuracyType = options.enums === String ? $root.palexy.sherlock.v1.AccuracyType[message.accuracyType] : message.accuracyType;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.accuracyNumber != null && message.hasOwnProperty("accuracyNumber"))
                            object.accuracyNumber = options.json && !isFinite(message.accuracyNumber) ? String(message.accuracyNumber) : message.accuracyNumber;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.additionalData != null && message.hasOwnProperty("additionalData"))
                            object.additionalData = message.additionalData;
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (typeof message.qcFileId === "number")
                                object.qcFileId = options.longs === String ? String(message.qcFileId) : message.qcFileId;
                            else
                                object.qcFileId = options.longs === String ? $util.Long.prototype.toString.call(message.qcFileId) : options.longs === Number ? new $util.LongBits(message.qcFileId.low >>> 0, message.qcFileId.high >>> 0).toNumber() : message.qcFileId;
                        if (message.hourSlot != null && message.hasOwnProperty("hourSlot"))
                            object.hourSlot = message.hourSlot;
                        if (message.systemResult != null && message.hasOwnProperty("systemResult"))
                            object.systemResult = options.json && !isFinite(message.systemResult) ? String(message.systemResult) : message.systemResult;
                        if (message.qcResultMin != null && message.hasOwnProperty("qcResultMin"))
                            object.qcResultMin = options.json && !isFinite(message.qcResultMin) ? String(message.qcResultMin) : message.qcResultMin;
                        if (message.qcResultMax != null && message.hasOwnProperty("qcResultMax"))
                            object.qcResultMax = options.json && !isFinite(message.qcResultMax) ? String(message.qcResultMax) : message.qcResultMax;
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            object.experimentProgrammingName = message.experimentProgrammingName;
                        if (message.sectionName != null && message.hasOwnProperty("sectionName"))
                            object.sectionName = message.sectionName;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        return object;
                    };
    
                    /**
                     * Converts this AccuracyResult to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AccuracyResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AccuracyResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AccuracyResult;
                })();
    
                v1.BatchCalculateAndSaveAccuracyRequest = (function() {
    
                    /**
                     * Properties of a BatchCalculateAndSaveAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCalculateAndSaveAccuracyRequest
                     * @property {Array.<number>|null} [storeIds] BatchCalculateAndSaveAccuracyRequest storeIds
                     * @property {string|null} [startDate] BatchCalculateAndSaveAccuracyRequest startDate
                     * @property {string|null} [endDate] BatchCalculateAndSaveAccuracyRequest endDate
                     */
    
                    /**
                     * Constructs a new BatchCalculateAndSaveAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCalculateAndSaveAccuracyRequest.
                     * @implements IBatchCalculateAndSaveAccuracyRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest=} [properties] Properties to set
                     */
                    function BatchCalculateAndSaveAccuracyRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCalculateAndSaveAccuracyRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    BatchCalculateAndSaveAccuracyRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * BatchCalculateAndSaveAccuracyRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    BatchCalculateAndSaveAccuracyRequest.prototype.startDate = "";
    
                    /**
                     * BatchCalculateAndSaveAccuracyRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @instance
                     */
                    BatchCalculateAndSaveAccuracyRequest.prototype.endDate = "";
    
                    /**
                     * Creates a new BatchCalculateAndSaveAccuracyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest} BatchCalculateAndSaveAccuracyRequest instance
                     */
                    BatchCalculateAndSaveAccuracyRequest.create = function create(properties) {
                        return new BatchCalculateAndSaveAccuracyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCalculateAndSaveAccuracyRequest message. Does not implicitly {@link palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest} message BatchCalculateAndSaveAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCalculateAndSaveAccuracyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCalculateAndSaveAccuracyRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyRequest} message BatchCalculateAndSaveAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCalculateAndSaveAccuracyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCalculateAndSaveAccuracyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest} BatchCalculateAndSaveAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCalculateAndSaveAccuracyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDate = reader.string();
                                break;
                            case 3:
                                message.endDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCalculateAndSaveAccuracyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest} BatchCalculateAndSaveAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCalculateAndSaveAccuracyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCalculateAndSaveAccuracyRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCalculateAndSaveAccuracyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchCalculateAndSaveAccuracyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest} BatchCalculateAndSaveAccuracyRequest
                     */
                    BatchCalculateAndSaveAccuracyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCalculateAndSaveAccuracyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest} message BatchCalculateAndSaveAccuracyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCalculateAndSaveAccuracyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDate = "";
                            object.endDate = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        return object;
                    };
    
                    /**
                     * Converts this BatchCalculateAndSaveAccuracyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCalculateAndSaveAccuracyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCalculateAndSaveAccuracyRequest;
                })();
    
                v1.BatchCalculateAndSaveAccuracyResponse = (function() {
    
                    /**
                     * Properties of a BatchCalculateAndSaveAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCalculateAndSaveAccuracyResponse
                     * @property {Array.<palexy.sherlock.v1.IAccuracyResult>|null} [accuracyResults] BatchCalculateAndSaveAccuracyResponse accuracyResults
                     */
    
                    /**
                     * Constructs a new BatchCalculateAndSaveAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCalculateAndSaveAccuracyResponse.
                     * @implements IBatchCalculateAndSaveAccuracyResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyResponse=} [properties] Properties to set
                     */
                    function BatchCalculateAndSaveAccuracyResponse(properties) {
                        this.accuracyResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCalculateAndSaveAccuracyResponse accuracyResults.
                     * @member {Array.<palexy.sherlock.v1.IAccuracyResult>} accuracyResults
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @instance
                     */
                    BatchCalculateAndSaveAccuracyResponse.prototype.accuracyResults = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCalculateAndSaveAccuracyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} BatchCalculateAndSaveAccuracyResponse instance
                     */
                    BatchCalculateAndSaveAccuracyResponse.create = function create(properties) {
                        return new BatchCalculateAndSaveAccuracyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCalculateAndSaveAccuracyResponse message. Does not implicitly {@link palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyResponse} message BatchCalculateAndSaveAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCalculateAndSaveAccuracyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accuracyResults != null && message.accuracyResults.length)
                            for (var i = 0; i < message.accuracyResults.length; ++i)
                                $root.palexy.sherlock.v1.AccuracyResult.encode(message.accuracyResults[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCalculateAndSaveAccuracyResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCalculateAndSaveAccuracyResponse} message BatchCalculateAndSaveAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCalculateAndSaveAccuracyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCalculateAndSaveAccuracyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} BatchCalculateAndSaveAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCalculateAndSaveAccuracyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.accuracyResults && message.accuracyResults.length))
                                    message.accuracyResults = [];
                                message.accuracyResults.push($root.palexy.sherlock.v1.AccuracyResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCalculateAndSaveAccuracyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} BatchCalculateAndSaveAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCalculateAndSaveAccuracyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCalculateAndSaveAccuracyResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCalculateAndSaveAccuracyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accuracyResults != null && message.hasOwnProperty("accuracyResults")) {
                            if (!Array.isArray(message.accuracyResults))
                                return "accuracyResults: array expected";
                            for (var i = 0; i < message.accuracyResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.AccuracyResult.verify(message.accuracyResults[i]);
                                if (error)
                                    return "accuracyResults." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCalculateAndSaveAccuracyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} BatchCalculateAndSaveAccuracyResponse
                     */
                    BatchCalculateAndSaveAccuracyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse();
                        if (object.accuracyResults) {
                            if (!Array.isArray(object.accuracyResults))
                                throw TypeError(".palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse.accuracyResults: array expected");
                            message.accuracyResults = [];
                            for (var i = 0; i < object.accuracyResults.length; ++i) {
                                if (typeof object.accuracyResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse.accuracyResults: object expected");
                                message.accuracyResults[i] = $root.palexy.sherlock.v1.AccuracyResult.fromObject(object.accuracyResults[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCalculateAndSaveAccuracyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse} message BatchCalculateAndSaveAccuracyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCalculateAndSaveAccuracyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.accuracyResults = [];
                        if (message.accuracyResults && message.accuracyResults.length) {
                            object.accuracyResults = [];
                            for (var j = 0; j < message.accuracyResults.length; ++j)
                                object.accuracyResults[j] = $root.palexy.sherlock.v1.AccuracyResult.toObject(message.accuracyResults[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCalculateAndSaveAccuracyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCalculateAndSaveAccuracyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCalculateAndSaveAccuracyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCalculateAndSaveAccuracyResponse;
                })();
    
                v1.QcCountingConfig = (function() {
    
                    /**
                     * Properties of a QcCountingConfig.
                     * @memberof palexy.sherlock.v1
                     * @interface IQcCountingConfig
                     * @property {number|null} [minDurationSeconds_] QcCountingConfig minDurationSeconds_
                     * @property {number|null} [softMinDurationSeconds] QcCountingConfig softMinDurationSeconds
                     * @property {number|null} [softMaxDurationSeconds] QcCountingConfig softMaxDurationSeconds
                     * @property {boolean|null} [softNoUniformStaff] QcCountingConfig softNoUniformStaff
                     * @property {boolean|null} [removeUnderTwelve] QcCountingConfig removeUnderTwelve
                     * @property {boolean|null} [removeBetweenTwelveAndTwenty] QcCountingConfig removeBetweenTwelveAndTwenty
                     */
    
                    /**
                     * Constructs a new QcCountingConfig.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcCountingConfig.
                     * @implements IQcCountingConfig
                     * @constructor
                     * @param {palexy.sherlock.v1.IQcCountingConfig=} [properties] Properties to set
                     */
                    function QcCountingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QcCountingConfig minDurationSeconds_.
                     * @member {number} minDurationSeconds_
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.minDurationSeconds_ = 0;
    
                    /**
                     * QcCountingConfig softMinDurationSeconds.
                     * @member {number} softMinDurationSeconds
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.softMinDurationSeconds = 0;
    
                    /**
                     * QcCountingConfig softMaxDurationSeconds.
                     * @member {number} softMaxDurationSeconds
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.softMaxDurationSeconds = 0;
    
                    /**
                     * QcCountingConfig softNoUniformStaff.
                     * @member {boolean} softNoUniformStaff
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.softNoUniformStaff = false;
    
                    /**
                     * QcCountingConfig removeUnderTwelve.
                     * @member {boolean} removeUnderTwelve
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.removeUnderTwelve = false;
    
                    /**
                     * QcCountingConfig removeBetweenTwelveAndTwenty.
                     * @member {boolean} removeBetweenTwelveAndTwenty
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     */
                    QcCountingConfig.prototype.removeBetweenTwelveAndTwenty = false;
    
                    /**
                     * Creates a new QcCountingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcCountingConfig=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.QcCountingConfig} QcCountingConfig instance
                     */
                    QcCountingConfig.create = function create(properties) {
                        return new QcCountingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified QcCountingConfig message. Does not implicitly {@link palexy.sherlock.v1.QcCountingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcCountingConfig} message QcCountingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcCountingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minDurationSeconds_ != null && Object.hasOwnProperty.call(message, "minDurationSeconds_"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minDurationSeconds_);
                        if (message.softMinDurationSeconds != null && Object.hasOwnProperty.call(message, "softMinDurationSeconds"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.softMinDurationSeconds);
                        if (message.softMaxDurationSeconds != null && Object.hasOwnProperty.call(message, "softMaxDurationSeconds"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.softMaxDurationSeconds);
                        if (message.softNoUniformStaff != null && Object.hasOwnProperty.call(message, "softNoUniformStaff"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.softNoUniformStaff);
                        if (message.removeUnderTwelve != null && Object.hasOwnProperty.call(message, "removeUnderTwelve"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.removeUnderTwelve);
                        if (message.removeBetweenTwelveAndTwenty != null && Object.hasOwnProperty.call(message, "removeBetweenTwelveAndTwenty"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.removeBetweenTwelveAndTwenty);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QcCountingConfig message, length delimited. Does not implicitly {@link palexy.sherlock.v1.QcCountingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcCountingConfig} message QcCountingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcCountingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QcCountingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.QcCountingConfig} QcCountingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcCountingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.QcCountingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minDurationSeconds_ = reader.int32();
                                break;
                            case 2:
                                message.softMinDurationSeconds = reader.int32();
                                break;
                            case 3:
                                message.softMaxDurationSeconds = reader.int32();
                                break;
                            case 4:
                                message.softNoUniformStaff = reader.bool();
                                break;
                            case 5:
                                message.removeUnderTwelve = reader.bool();
                                break;
                            case 6:
                                message.removeBetweenTwelveAndTwenty = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QcCountingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.QcCountingConfig} QcCountingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcCountingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QcCountingConfig message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QcCountingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minDurationSeconds_ != null && message.hasOwnProperty("minDurationSeconds_"))
                            if (!$util.isInteger(message.minDurationSeconds_))
                                return "minDurationSeconds_: integer expected";
                        if (message.softMinDurationSeconds != null && message.hasOwnProperty("softMinDurationSeconds"))
                            if (!$util.isInteger(message.softMinDurationSeconds))
                                return "softMinDurationSeconds: integer expected";
                        if (message.softMaxDurationSeconds != null && message.hasOwnProperty("softMaxDurationSeconds"))
                            if (!$util.isInteger(message.softMaxDurationSeconds))
                                return "softMaxDurationSeconds: integer expected";
                        if (message.softNoUniformStaff != null && message.hasOwnProperty("softNoUniformStaff"))
                            if (typeof message.softNoUniformStaff !== "boolean")
                                return "softNoUniformStaff: boolean expected";
                        if (message.removeUnderTwelve != null && message.hasOwnProperty("removeUnderTwelve"))
                            if (typeof message.removeUnderTwelve !== "boolean")
                                return "removeUnderTwelve: boolean expected";
                        if (message.removeBetweenTwelveAndTwenty != null && message.hasOwnProperty("removeBetweenTwelveAndTwenty"))
                            if (typeof message.removeBetweenTwelveAndTwenty !== "boolean")
                                return "removeBetweenTwelveAndTwenty: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a QcCountingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.QcCountingConfig} QcCountingConfig
                     */
                    QcCountingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.QcCountingConfig)
                            return object;
                        var message = new $root.palexy.sherlock.v1.QcCountingConfig();
                        if (object.minDurationSeconds_ != null)
                            message.minDurationSeconds_ = object.minDurationSeconds_ | 0;
                        if (object.softMinDurationSeconds != null)
                            message.softMinDurationSeconds = object.softMinDurationSeconds | 0;
                        if (object.softMaxDurationSeconds != null)
                            message.softMaxDurationSeconds = object.softMaxDurationSeconds | 0;
                        if (object.softNoUniformStaff != null)
                            message.softNoUniformStaff = Boolean(object.softNoUniformStaff);
                        if (object.removeUnderTwelve != null)
                            message.removeUnderTwelve = Boolean(object.removeUnderTwelve);
                        if (object.removeBetweenTwelveAndTwenty != null)
                            message.removeBetweenTwelveAndTwenty = Boolean(object.removeBetweenTwelveAndTwenty);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QcCountingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @static
                     * @param {palexy.sherlock.v1.QcCountingConfig} message QcCountingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QcCountingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minDurationSeconds_ = 0;
                            object.softMinDurationSeconds = 0;
                            object.softMaxDurationSeconds = 0;
                            object.softNoUniformStaff = false;
                            object.removeUnderTwelve = false;
                            object.removeBetweenTwelveAndTwenty = false;
                        }
                        if (message.minDurationSeconds_ != null && message.hasOwnProperty("minDurationSeconds_"))
                            object.minDurationSeconds_ = message.minDurationSeconds_;
                        if (message.softMinDurationSeconds != null && message.hasOwnProperty("softMinDurationSeconds"))
                            object.softMinDurationSeconds = message.softMinDurationSeconds;
                        if (message.softMaxDurationSeconds != null && message.hasOwnProperty("softMaxDurationSeconds"))
                            object.softMaxDurationSeconds = message.softMaxDurationSeconds;
                        if (message.softNoUniformStaff != null && message.hasOwnProperty("softNoUniformStaff"))
                            object.softNoUniformStaff = message.softNoUniformStaff;
                        if (message.removeUnderTwelve != null && message.hasOwnProperty("removeUnderTwelve"))
                            object.removeUnderTwelve = message.removeUnderTwelve;
                        if (message.removeBetweenTwelveAndTwenty != null && message.hasOwnProperty("removeBetweenTwelveAndTwenty"))
                            object.removeBetweenTwelveAndTwenty = message.removeBetweenTwelveAndTwenty;
                        return object;
                    };
    
                    /**
                     * Converts this QcCountingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.QcCountingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QcCountingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QcCountingConfig;
                })();
    
                v1.ListAccuracyResultsRequest = (function() {
    
                    /**
                     * Properties of a ListAccuracyResultsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListAccuracyResultsRequest
                     * @property {number|null} [qcFileId] ListAccuracyResultsRequest qcFileId
                     * @property {string|null} [pageToken] ListAccuracyResultsRequest pageToken
                     * @property {number|null} [pageSize] ListAccuracyResultsRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListAccuracyResultsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListAccuracyResultsRequest.
                     * @implements IListAccuracyResultsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest=} [properties] Properties to set
                     */
                    function ListAccuracyResultsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccuracyResultsRequest qcFileId.
                     * @member {number} qcFileId
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @instance
                     */
                    ListAccuracyResultsRequest.prototype.qcFileId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListAccuracyResultsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @instance
                     */
                    ListAccuracyResultsRequest.prototype.pageToken = "";
    
                    /**
                     * ListAccuracyResultsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @instance
                     */
                    ListAccuracyResultsRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListAccuracyResultsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsRequest} ListAccuracyResultsRequest instance
                     */
                    ListAccuracyResultsRequest.create = function create(properties) {
                        return new ListAccuracyResultsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccuracyResultsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListAccuracyResultsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest} message ListAccuracyResultsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccuracyResultsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFileId != null && Object.hasOwnProperty.call(message, "qcFileId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.qcFileId);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccuracyResultsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListAccuracyResultsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsRequest} message ListAccuracyResultsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccuracyResultsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccuracyResultsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsRequest} ListAccuracyResultsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccuracyResultsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListAccuracyResultsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.qcFileId = reader.int64();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccuracyResultsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsRequest} ListAccuracyResultsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccuracyResultsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccuracyResultsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccuracyResultsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (!$util.isInteger(message.qcFileId) && !(message.qcFileId && $util.isInteger(message.qcFileId.low) && $util.isInteger(message.qcFileId.high)))
                                return "qcFileId: integer|Long expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAccuracyResultsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsRequest} ListAccuracyResultsRequest
                     */
                    ListAccuracyResultsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListAccuracyResultsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListAccuracyResultsRequest();
                        if (object.qcFileId != null)
                            if ($util.Long)
                                (message.qcFileId = $util.Long.fromValue(object.qcFileId)).unsigned = false;
                            else if (typeof object.qcFileId === "string")
                                message.qcFileId = parseInt(object.qcFileId, 10);
                            else if (typeof object.qcFileId === "number")
                                message.qcFileId = object.qcFileId;
                            else if (typeof object.qcFileId === "object")
                                message.qcFileId = new $util.LongBits(object.qcFileId.low >>> 0, object.qcFileId.high >>> 0).toNumber();
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccuracyResultsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListAccuracyResultsRequest} message ListAccuracyResultsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccuracyResultsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.qcFileId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.qcFileId = options.longs === String ? "0" : 0;
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (typeof message.qcFileId === "number")
                                object.qcFileId = options.longs === String ? String(message.qcFileId) : message.qcFileId;
                            else
                                object.qcFileId = options.longs === String ? $util.Long.prototype.toString.call(message.qcFileId) : options.longs === Number ? new $util.LongBits(message.qcFileId.low >>> 0, message.qcFileId.high >>> 0).toNumber() : message.qcFileId;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListAccuracyResultsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccuracyResultsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccuracyResultsRequest;
                })();
    
                v1.ListAccuracyResultsResponse = (function() {
    
                    /**
                     * Properties of a ListAccuracyResultsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListAccuracyResultsResponse
                     * @property {Array.<palexy.sherlock.v1.IAccuracyResult>|null} [results] ListAccuracyResultsResponse results
                     */
    
                    /**
                     * Constructs a new ListAccuracyResultsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListAccuracyResultsResponse.
                     * @implements IListAccuracyResultsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListAccuracyResultsResponse=} [properties] Properties to set
                     */
                    function ListAccuracyResultsResponse(properties) {
                        this.results = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccuracyResultsResponse results.
                     * @member {Array.<palexy.sherlock.v1.IAccuracyResult>} results
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @instance
                     */
                    ListAccuracyResultsResponse.prototype.results = $util.emptyArray;
    
                    /**
                     * Creates a new ListAccuracyResultsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsResponse} ListAccuracyResultsResponse instance
                     */
                    ListAccuracyResultsResponse.create = function create(properties) {
                        return new ListAccuracyResultsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccuracyResultsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListAccuracyResultsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsResponse} message ListAccuracyResultsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccuracyResultsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.results != null && message.results.length)
                            for (var i = 0; i < message.results.length; ++i)
                                $root.palexy.sherlock.v1.AccuracyResult.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccuracyResultsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListAccuracyResultsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListAccuracyResultsResponse} message ListAccuracyResultsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccuracyResultsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccuracyResultsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsResponse} ListAccuracyResultsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccuracyResultsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListAccuracyResultsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.results && message.results.length))
                                    message.results = [];
                                message.results.push($root.palexy.sherlock.v1.AccuracyResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccuracyResultsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsResponse} ListAccuracyResultsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccuracyResultsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccuracyResultsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccuracyResultsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.results != null && message.hasOwnProperty("results")) {
                            if (!Array.isArray(message.results))
                                return "results: array expected";
                            for (var i = 0; i < message.results.length; ++i) {
                                var error = $root.palexy.sherlock.v1.AccuracyResult.verify(message.results[i]);
                                if (error)
                                    return "results." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAccuracyResultsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListAccuracyResultsResponse} ListAccuracyResultsResponse
                     */
                    ListAccuracyResultsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListAccuracyResultsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListAccuracyResultsResponse();
                        if (object.results) {
                            if (!Array.isArray(object.results))
                                throw TypeError(".palexy.sherlock.v1.ListAccuracyResultsResponse.results: array expected");
                            message.results = [];
                            for (var i = 0; i < object.results.length; ++i) {
                                if (typeof object.results[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListAccuracyResultsResponse.results: object expected");
                                message.results[i] = $root.palexy.sherlock.v1.AccuracyResult.fromObject(object.results[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccuracyResultsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListAccuracyResultsResponse} message ListAccuracyResultsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccuracyResultsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.results = [];
                        if (message.results && message.results.length) {
                            object.results = [];
                            for (var j = 0; j < message.results.length; ++j)
                                object.results[j] = $root.palexy.sherlock.v1.AccuracyResult.toObject(message.results[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListAccuracyResultsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListAccuracyResultsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccuracyResultsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccuracyResultsResponse;
                })();
    
                v1.ListFnbVisitMatchesRequest = (function() {
    
                    /**
                     * Properties of a ListFnbVisitMatchesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListFnbVisitMatchesRequest
                     * @property {number|null} [qcFileId] ListFnbVisitMatchesRequest qcFileId
                     * @property {string|null} [experimentProgrammingName] ListFnbVisitMatchesRequest experimentProgrammingName
                     */
    
                    /**
                     * Constructs a new ListFnbVisitMatchesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListFnbVisitMatchesRequest.
                     * @implements IListFnbVisitMatchesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest=} [properties] Properties to set
                     */
                    function ListFnbVisitMatchesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFnbVisitMatchesRequest qcFileId.
                     * @member {number} qcFileId
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @instance
                     */
                    ListFnbVisitMatchesRequest.prototype.qcFileId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFnbVisitMatchesRequest experimentProgrammingName.
                     * @member {string} experimentProgrammingName
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @instance
                     */
                    ListFnbVisitMatchesRequest.prototype.experimentProgrammingName = "";
    
                    /**
                     * Creates a new ListFnbVisitMatchesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesRequest} ListFnbVisitMatchesRequest instance
                     */
                    ListFnbVisitMatchesRequest.create = function create(properties) {
                        return new ListFnbVisitMatchesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFnbVisitMatchesRequest message. Does not implicitly {@link palexy.sherlock.v1.ListFnbVisitMatchesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest} message ListFnbVisitMatchesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFnbVisitMatchesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFileId != null && Object.hasOwnProperty.call(message, "qcFileId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.qcFileId);
                        if (message.experimentProgrammingName != null && Object.hasOwnProperty.call(message, "experimentProgrammingName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.experimentProgrammingName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFnbVisitMatchesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListFnbVisitMatchesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesRequest} message ListFnbVisitMatchesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFnbVisitMatchesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFnbVisitMatchesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesRequest} ListFnbVisitMatchesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFnbVisitMatchesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListFnbVisitMatchesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.qcFileId = reader.int64();
                                break;
                            case 2:
                                message.experimentProgrammingName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFnbVisitMatchesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesRequest} ListFnbVisitMatchesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFnbVisitMatchesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFnbVisitMatchesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFnbVisitMatchesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (!$util.isInteger(message.qcFileId) && !(message.qcFileId && $util.isInteger(message.qcFileId.low) && $util.isInteger(message.qcFileId.high)))
                                return "qcFileId: integer|Long expected";
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            if (!$util.isString(message.experimentProgrammingName))
                                return "experimentProgrammingName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFnbVisitMatchesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesRequest} ListFnbVisitMatchesRequest
                     */
                    ListFnbVisitMatchesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListFnbVisitMatchesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListFnbVisitMatchesRequest();
                        if (object.qcFileId != null)
                            if ($util.Long)
                                (message.qcFileId = $util.Long.fromValue(object.qcFileId)).unsigned = false;
                            else if (typeof object.qcFileId === "string")
                                message.qcFileId = parseInt(object.qcFileId, 10);
                            else if (typeof object.qcFileId === "number")
                                message.qcFileId = object.qcFileId;
                            else if (typeof object.qcFileId === "object")
                                message.qcFileId = new $util.LongBits(object.qcFileId.low >>> 0, object.qcFileId.high >>> 0).toNumber();
                        if (object.experimentProgrammingName != null)
                            message.experimentProgrammingName = String(object.experimentProgrammingName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFnbVisitMatchesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListFnbVisitMatchesRequest} message ListFnbVisitMatchesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFnbVisitMatchesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.qcFileId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.qcFileId = options.longs === String ? "0" : 0;
                            object.experimentProgrammingName = "";
                        }
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (typeof message.qcFileId === "number")
                                object.qcFileId = options.longs === String ? String(message.qcFileId) : message.qcFileId;
                            else
                                object.qcFileId = options.longs === String ? $util.Long.prototype.toString.call(message.qcFileId) : options.longs === Number ? new $util.LongBits(message.qcFileId.low >>> 0, message.qcFileId.high >>> 0).toNumber() : message.qcFileId;
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            object.experimentProgrammingName = message.experimentProgrammingName;
                        return object;
                    };
    
                    /**
                     * Converts this ListFnbVisitMatchesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFnbVisitMatchesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFnbVisitMatchesRequest;
                })();
    
                v1.ListFnbVisitMatchesResponse = (function() {
    
                    /**
                     * Properties of a ListFnbVisitMatchesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListFnbVisitMatchesResponse
                     * @property {Array.<palexy.sherlock.v1.IFnbVisitMatch>|null} [matches] ListFnbVisitMatchesResponse matches
                     */
    
                    /**
                     * Constructs a new ListFnbVisitMatchesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListFnbVisitMatchesResponse.
                     * @implements IListFnbVisitMatchesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesResponse=} [properties] Properties to set
                     */
                    function ListFnbVisitMatchesResponse(properties) {
                        this.matches = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFnbVisitMatchesResponse matches.
                     * @member {Array.<palexy.sherlock.v1.IFnbVisitMatch>} matches
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @instance
                     */
                    ListFnbVisitMatchesResponse.prototype.matches = $util.emptyArray;
    
                    /**
                     * Creates a new ListFnbVisitMatchesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesResponse} ListFnbVisitMatchesResponse instance
                     */
                    ListFnbVisitMatchesResponse.create = function create(properties) {
                        return new ListFnbVisitMatchesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFnbVisitMatchesResponse message. Does not implicitly {@link palexy.sherlock.v1.ListFnbVisitMatchesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesResponse} message ListFnbVisitMatchesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFnbVisitMatchesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.matches != null && message.matches.length)
                            for (var i = 0; i < message.matches.length; ++i)
                                $root.palexy.sherlock.v1.FnbVisitMatch.encode(message.matches[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFnbVisitMatchesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListFnbVisitMatchesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListFnbVisitMatchesResponse} message ListFnbVisitMatchesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFnbVisitMatchesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFnbVisitMatchesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesResponse} ListFnbVisitMatchesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFnbVisitMatchesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListFnbVisitMatchesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.matches && message.matches.length))
                                    message.matches = [];
                                message.matches.push($root.palexy.sherlock.v1.FnbVisitMatch.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFnbVisitMatchesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesResponse} ListFnbVisitMatchesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFnbVisitMatchesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFnbVisitMatchesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFnbVisitMatchesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.matches != null && message.hasOwnProperty("matches")) {
                            if (!Array.isArray(message.matches))
                                return "matches: array expected";
                            for (var i = 0; i < message.matches.length; ++i) {
                                var error = $root.palexy.sherlock.v1.FnbVisitMatch.verify(message.matches[i]);
                                if (error)
                                    return "matches." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFnbVisitMatchesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListFnbVisitMatchesResponse} ListFnbVisitMatchesResponse
                     */
                    ListFnbVisitMatchesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListFnbVisitMatchesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListFnbVisitMatchesResponse();
                        if (object.matches) {
                            if (!Array.isArray(object.matches))
                                throw TypeError(".palexy.sherlock.v1.ListFnbVisitMatchesResponse.matches: array expected");
                            message.matches = [];
                            for (var i = 0; i < object.matches.length; ++i) {
                                if (typeof object.matches[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListFnbVisitMatchesResponse.matches: object expected");
                                message.matches[i] = $root.palexy.sherlock.v1.FnbVisitMatch.fromObject(object.matches[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFnbVisitMatchesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListFnbVisitMatchesResponse} message ListFnbVisitMatchesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFnbVisitMatchesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.matches = [];
                        if (message.matches && message.matches.length) {
                            object.matches = [];
                            for (var j = 0; j < message.matches.length; ++j)
                                object.matches[j] = $root.palexy.sherlock.v1.FnbVisitMatch.toObject(message.matches[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFnbVisitMatchesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListFnbVisitMatchesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFnbVisitMatchesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFnbVisitMatchesResponse;
                })();
    
                v1.CalculateAndSaveExperimentAccuracyRequest = (function() {
    
                    /**
                     * Properties of a CalculateAndSaveExperimentAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICalculateAndSaveExperimentAccuracyRequest
                     * @property {number|null} [storeId] CalculateAndSaveExperimentAccuracyRequest storeId
                     * @property {string|null} [dateId] CalculateAndSaveExperimentAccuracyRequest dateId
                     * @property {string|null} [experimentProgrammingName] CalculateAndSaveExperimentAccuracyRequest experimentProgrammingName
                     * @property {string|null} [mergeResultFileName] CalculateAndSaveExperimentAccuracyRequest mergeResultFileName
                     * @property {string|null} [mergeResultBucket] CalculateAndSaveExperimentAccuracyRequest mergeResultBucket
                     * @property {palexy.sherlock.v1.QcFile.QcType|null} [qcType] CalculateAndSaveExperimentAccuracyRequest qcType
                     */
    
                    /**
                     * Constructs a new CalculateAndSaveExperimentAccuracyRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CalculateAndSaveExperimentAccuracyRequest.
                     * @implements ICalculateAndSaveExperimentAccuracyRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest=} [properties] Properties to set
                     */
                    function CalculateAndSaveExperimentAccuracyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.dateId = "";
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest experimentProgrammingName.
                     * @member {string} experimentProgrammingName
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.experimentProgrammingName = "";
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest mergeResultFileName.
                     * @member {string} mergeResultFileName
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.mergeResultFileName = "";
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest mergeResultBucket.
                     * @member {string} mergeResultBucket
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.mergeResultBucket = "";
    
                    /**
                     * CalculateAndSaveExperimentAccuracyRequest qcType.
                     * @member {palexy.sherlock.v1.QcFile.QcType} qcType
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.qcType = 0;
    
                    /**
                     * Creates a new CalculateAndSaveExperimentAccuracyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest} CalculateAndSaveExperimentAccuracyRequest instance
                     */
                    CalculateAndSaveExperimentAccuracyRequest.create = function create(properties) {
                        return new CalculateAndSaveExperimentAccuracyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveExperimentAccuracyRequest message. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest} message CalculateAndSaveExperimentAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveExperimentAccuracyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.experimentProgrammingName != null && Object.hasOwnProperty.call(message, "experimentProgrammingName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.experimentProgrammingName);
                        if (message.mergeResultFileName != null && Object.hasOwnProperty.call(message, "mergeResultFileName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.mergeResultFileName);
                        if (message.mergeResultBucket != null && Object.hasOwnProperty.call(message, "mergeResultBucket"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mergeResultBucket);
                        if (message.qcType != null && Object.hasOwnProperty.call(message, "qcType"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.qcType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveExperimentAccuracyRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyRequest} message CalculateAndSaveExperimentAccuracyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveExperimentAccuracyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateAndSaveExperimentAccuracyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest} CalculateAndSaveExperimentAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveExperimentAccuracyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.experimentProgrammingName = reader.string();
                                break;
                            case 4:
                                message.mergeResultFileName = reader.string();
                                break;
                            case 5:
                                message.mergeResultBucket = reader.string();
                                break;
                            case 6:
                                message.qcType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateAndSaveExperimentAccuracyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest} CalculateAndSaveExperimentAccuracyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveExperimentAccuracyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateAndSaveExperimentAccuracyRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateAndSaveExperimentAccuracyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            if (!$util.isString(message.experimentProgrammingName))
                                return "experimentProgrammingName: string expected";
                        if (message.mergeResultFileName != null && message.hasOwnProperty("mergeResultFileName"))
                            if (!$util.isString(message.mergeResultFileName))
                                return "mergeResultFileName: string expected";
                        if (message.mergeResultBucket != null && message.hasOwnProperty("mergeResultBucket"))
                            if (!$util.isString(message.mergeResultBucket))
                                return "mergeResultBucket: string expected";
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            switch (message.qcType) {
                            default:
                                return "qcType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateAndSaveExperimentAccuracyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest} CalculateAndSaveExperimentAccuracyRequest
                     */
                    CalculateAndSaveExperimentAccuracyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.experimentProgrammingName != null)
                            message.experimentProgrammingName = String(object.experimentProgrammingName);
                        if (object.mergeResultFileName != null)
                            message.mergeResultFileName = String(object.mergeResultFileName);
                        if (object.mergeResultBucket != null)
                            message.mergeResultBucket = String(object.mergeResultBucket);
                        switch (object.qcType) {
                        case "QC_TYPE_UNKNOWN":
                        case 0:
                            message.qcType = 0;
                            break;
                        case "ICA_STANDARD_COUNTING":
                        case 1:
                            message.qcType = 1;
                            break;
                        case "ICA_CUSTOMER_JOURNEY":
                        case 2:
                            message.qcType = 2;
                            break;
                        case "ICA_ENTRANCE_COUNTING":
                        case 3:
                            message.qcType = 3;
                            break;
                        case "ICA_PASSBY_COUNTING":
                        case 4:
                            message.qcType = 4;
                            break;
                        case "ICA_FNB_QUEUE_METRIC":
                        case 5:
                            message.qcType = 5;
                            break;
                        case "ICA_FNB_QUEUE_METRIC_PER_PERSON":
                        case 6:
                            message.qcType = 6;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateAndSaveExperimentAccuracyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @static
                     * @param {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest} message CalculateAndSaveExperimentAccuracyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateAndSaveExperimentAccuracyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.experimentProgrammingName = "";
                            object.mergeResultFileName = "";
                            object.mergeResultBucket = "";
                            object.qcType = options.enums === String ? "QC_TYPE_UNKNOWN" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.experimentProgrammingName != null && message.hasOwnProperty("experimentProgrammingName"))
                            object.experimentProgrammingName = message.experimentProgrammingName;
                        if (message.mergeResultFileName != null && message.hasOwnProperty("mergeResultFileName"))
                            object.mergeResultFileName = message.mergeResultFileName;
                        if (message.mergeResultBucket != null && message.hasOwnProperty("mergeResultBucket"))
                            object.mergeResultBucket = message.mergeResultBucket;
                        if (message.qcType != null && message.hasOwnProperty("qcType"))
                            object.qcType = options.enums === String ? $root.palexy.sherlock.v1.QcFile.QcType[message.qcType] : message.qcType;
                        return object;
                    };
    
                    /**
                     * Converts this CalculateAndSaveExperimentAccuracyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateAndSaveExperimentAccuracyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateAndSaveExperimentAccuracyRequest;
                })();
    
                v1.CalculateAndSaveExperimentAccuracyResponse = (function() {
    
                    /**
                     * Properties of a CalculateAndSaveExperimentAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICalculateAndSaveExperimentAccuracyResponse
                     * @property {Array.<palexy.sherlock.v1.IAccuracyResult>|null} [accuracyResults] CalculateAndSaveExperimentAccuracyResponse accuracyResults
                     */
    
                    /**
                     * Constructs a new CalculateAndSaveExperimentAccuracyResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CalculateAndSaveExperimentAccuracyResponse.
                     * @implements ICalculateAndSaveExperimentAccuracyResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyResponse=} [properties] Properties to set
                     */
                    function CalculateAndSaveExperimentAccuracyResponse(properties) {
                        this.accuracyResults = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateAndSaveExperimentAccuracyResponse accuracyResults.
                     * @member {Array.<palexy.sherlock.v1.IAccuracyResult>} accuracyResults
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @instance
                     */
                    CalculateAndSaveExperimentAccuracyResponse.prototype.accuracyResults = $util.emptyArray;
    
                    /**
                     * Creates a new CalculateAndSaveExperimentAccuracyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} CalculateAndSaveExperimentAccuracyResponse instance
                     */
                    CalculateAndSaveExperimentAccuracyResponse.create = function create(properties) {
                        return new CalculateAndSaveExperimentAccuracyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveExperimentAccuracyResponse message. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyResponse} message CalculateAndSaveExperimentAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveExperimentAccuracyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accuracyResults != null && message.accuracyResults.length)
                            for (var i = 0; i < message.accuracyResults.length; ++i)
                                $root.palexy.sherlock.v1.AccuracyResult.encode(message.accuracyResults[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateAndSaveExperimentAccuracyResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICalculateAndSaveExperimentAccuracyResponse} message CalculateAndSaveExperimentAccuracyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateAndSaveExperimentAccuracyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateAndSaveExperimentAccuracyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} CalculateAndSaveExperimentAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveExperimentAccuracyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.accuracyResults && message.accuracyResults.length))
                                    message.accuracyResults = [];
                                message.accuracyResults.push($root.palexy.sherlock.v1.AccuracyResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateAndSaveExperimentAccuracyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} CalculateAndSaveExperimentAccuracyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateAndSaveExperimentAccuracyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateAndSaveExperimentAccuracyResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateAndSaveExperimentAccuracyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accuracyResults != null && message.hasOwnProperty("accuracyResults")) {
                            if (!Array.isArray(message.accuracyResults))
                                return "accuracyResults: array expected";
                            for (var i = 0; i < message.accuracyResults.length; ++i) {
                                var error = $root.palexy.sherlock.v1.AccuracyResult.verify(message.accuracyResults[i]);
                                if (error)
                                    return "accuracyResults." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateAndSaveExperimentAccuracyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} CalculateAndSaveExperimentAccuracyResponse
                     */
                    CalculateAndSaveExperimentAccuracyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse();
                        if (object.accuracyResults) {
                            if (!Array.isArray(object.accuracyResults))
                                throw TypeError(".palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse.accuracyResults: array expected");
                            message.accuracyResults = [];
                            for (var i = 0; i < object.accuracyResults.length; ++i) {
                                if (typeof object.accuracyResults[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse.accuracyResults: object expected");
                                message.accuracyResults[i] = $root.palexy.sherlock.v1.AccuracyResult.fromObject(object.accuracyResults[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateAndSaveExperimentAccuracyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @static
                     * @param {palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse} message CalculateAndSaveExperimentAccuracyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateAndSaveExperimentAccuracyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.accuracyResults = [];
                        if (message.accuracyResults && message.accuracyResults.length) {
                            object.accuracyResults = [];
                            for (var j = 0; j < message.accuracyResults.length; ++j)
                                object.accuracyResults[j] = $root.palexy.sherlock.v1.AccuracyResult.toObject(message.accuracyResults[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CalculateAndSaveExperimentAccuracyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CalculateAndSaveExperimentAccuracyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateAndSaveExperimentAccuracyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateAndSaveExperimentAccuracyResponse;
                })();
    
                v1.ExperimentService = (function() {
    
                    /**
                     * Constructs a new ExperimentService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExperimentService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ExperimentService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ExperimentService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ExperimentService;
    
                    /**
                     * Creates new ExperimentService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ExperimentService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ExperimentService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#batchCreateTestCases}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef BatchCreateTestCasesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.BatchCreateTestCasesResponse} [response] BatchCreateTestCasesResponse
                     */
    
                    /**
                     * Calls BatchCreateTestCases.
                     * @function batchCreateTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest} request BatchCreateTestCasesRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.BatchCreateTestCasesCallback} callback Node-style callback called with the error, if any, and BatchCreateTestCasesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.batchCreateTestCases = function batchCreateTestCases(request, callback) {
                        return this.rpcCall(batchCreateTestCases, $root.palexy.sherlock.v1.BatchCreateTestCasesRequest, $root.palexy.sherlock.v1.BatchCreateTestCasesResponse, request, callback);
                    }, "name", { value: "BatchCreateTestCases" });
    
                    /**
                     * Calls BatchCreateTestCases.
                     * @function batchCreateTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest} request BatchCreateTestCasesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.BatchCreateTestCasesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#createCache}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef CreateCacheCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateCacheResponse} [response] CreateCacheResponse
                     */
    
                    /**
                     * Calls CreateCache.
                     * @function createCache
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateCacheRequest} request CreateCacheRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.CreateCacheCallback} callback Node-style callback called with the error, if any, and CreateCacheResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.createCache = function createCache(request, callback) {
                        return this.rpcCall(createCache, $root.palexy.sherlock.v1.CreateCacheRequest, $root.palexy.sherlock.v1.CreateCacheResponse, request, callback);
                    }, "name", { value: "CreateCache" });
    
                    /**
                     * Calls CreateCache.
                     * @function createCache
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateCacheRequest} request CreateCacheRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateCacheResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#listCaches}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef ListCachesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListCachesResponse} [response] ListCachesResponse
                     */
    
                    /**
                     * Calls ListCaches.
                     * @function listCaches
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListCachesRequest} request ListCachesRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.ListCachesCallback} callback Node-style callback called with the error, if any, and ListCachesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.listCaches = function listCaches(request, callback) {
                        return this.rpcCall(listCaches, $root.palexy.sherlock.v1.ListCachesRequest, $root.palexy.sherlock.v1.ListCachesResponse, request, callback);
                    }, "name", { value: "ListCaches" });
    
                    /**
                     * Calls ListCaches.
                     * @function listCaches
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListCachesRequest} request ListCachesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListCachesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#addCacheItem}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef AddCacheItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.AddCacheItemResponse} [response] AddCacheItemResponse
                     */
    
                    /**
                     * Calls AddCacheItem.
                     * @function addCacheItem
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest} request AddCacheItemRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.AddCacheItemCallback} callback Node-style callback called with the error, if any, and AddCacheItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.addCacheItem = function addCacheItem(request, callback) {
                        return this.rpcCall(addCacheItem, $root.palexy.sherlock.v1.AddCacheItemRequest, $root.palexy.sherlock.v1.AddCacheItemResponse, request, callback);
                    }, "name", { value: "AddCacheItem" });
    
                    /**
                     * Calls AddCacheItem.
                     * @function addCacheItem
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest} request AddCacheItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.AddCacheItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#findCacheItemByFileName}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef FindCacheItemByFileNameCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.FindCacheItemByFileNameResponse} [response] FindCacheItemByFileNameResponse
                     */
    
                    /**
                     * Calls FindCacheItemByFileName.
                     * @function findCacheItemByFileName
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest} request FindCacheItemByFileNameRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.FindCacheItemByFileNameCallback} callback Node-style callback called with the error, if any, and FindCacheItemByFileNameResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.findCacheItemByFileName = function findCacheItemByFileName(request, callback) {
                        return this.rpcCall(findCacheItemByFileName, $root.palexy.sherlock.v1.FindCacheItemByFileNameRequest, $root.palexy.sherlock.v1.FindCacheItemByFileNameResponse, request, callback);
                    }, "name", { value: "FindCacheItemByFileName" });
    
                    /**
                     * Calls FindCacheItemByFileName.
                     * @function findCacheItemByFileName
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest} request FindCacheItemByFileNameRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.FindCacheItemByFileNameResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#createExperiment}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef CreateExperimentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateExperimentResponse} [response] CreateExperimentResponse
                     */
    
                    /**
                     * Calls CreateExperiment.
                     * @function createExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest} request CreateExperimentRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.CreateExperimentCallback} callback Node-style callback called with the error, if any, and CreateExperimentResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.createExperiment = function createExperiment(request, callback) {
                        return this.rpcCall(createExperiment, $root.palexy.sherlock.v1.CreateExperimentRequest, $root.palexy.sherlock.v1.CreateExperimentResponse, request, callback);
                    }, "name", { value: "CreateExperiment" });
    
                    /**
                     * Calls CreateExperiment.
                     * @function createExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest} request CreateExperimentRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateExperimentResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#getExperiment}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef GetExperimentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.GetExperimentResponse} [response] GetExperimentResponse
                     */
    
                    /**
                     * Calls GetExperiment.
                     * @function getExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetExperimentRequest} request GetExperimentRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.GetExperimentCallback} callback Node-style callback called with the error, if any, and GetExperimentResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.getExperiment = function getExperiment(request, callback) {
                        return this.rpcCall(getExperiment, $root.palexy.sherlock.v1.GetExperimentRequest, $root.palexy.sherlock.v1.GetExperimentResponse, request, callback);
                    }, "name", { value: "GetExperiment" });
    
                    /**
                     * Calls GetExperiment.
                     * @function getExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IGetExperimentRequest} request GetExperimentRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.GetExperimentResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#listExperiments}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef ListExperimentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListExperimentsResponse} [response] ListExperimentsResponse
                     */
    
                    /**
                     * Calls ListExperiments.
                     * @function listExperiments
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListExperimentsRequest} request ListExperimentsRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.ListExperimentsCallback} callback Node-style callback called with the error, if any, and ListExperimentsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.listExperiments = function listExperiments(request, callback) {
                        return this.rpcCall(listExperiments, $root.palexy.sherlock.v1.ListExperimentsRequest, $root.palexy.sherlock.v1.ListExperimentsResponse, request, callback);
                    }, "name", { value: "ListExperiments" });
    
                    /**
                     * Calls ListExperiments.
                     * @function listExperiments
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListExperimentsRequest} request ListExperimentsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListExperimentsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#updateExperiment}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef UpdateExperimentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.UpdateExperimentResponse} [response] UpdateExperimentResponse
                     */
    
                    /**
                     * Calls UpdateExperiment.
                     * @function updateExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest} request UpdateExperimentRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.UpdateExperimentCallback} callback Node-style callback called with the error, if any, and UpdateExperimentResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.updateExperiment = function updateExperiment(request, callback) {
                        return this.rpcCall(updateExperiment, $root.palexy.sherlock.v1.UpdateExperimentRequest, $root.palexy.sherlock.v1.UpdateExperimentResponse, request, callback);
                    }, "name", { value: "UpdateExperiment" });
    
                    /**
                     * Calls UpdateExperiment.
                     * @function updateExperiment
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest} request UpdateExperimentRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.UpdateExperimentResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#listExperimentTestCases}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef ListExperimentTestCasesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListExperimentTestCasesResponse} [response] ListExperimentTestCasesResponse
                     */
    
                    /**
                     * Calls ListExperimentTestCases.
                     * @function listExperimentTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest} request ListExperimentTestCasesRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.ListExperimentTestCasesCallback} callback Node-style callback called with the error, if any, and ListExperimentTestCasesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.listExperimentTestCases = function listExperimentTestCases(request, callback) {
                        return this.rpcCall(listExperimentTestCases, $root.palexy.sherlock.v1.ListExperimentTestCasesRequest, $root.palexy.sherlock.v1.ListExperimentTestCasesResponse, request, callback);
                    }, "name", { value: "ListExperimentTestCases" });
    
                    /**
                     * Calls ListExperimentTestCases.
                     * @function listExperimentTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest} request ListExperimentTestCasesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListExperimentTestCasesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#listTestCases}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef ListTestCasesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListTestCasesResponse} [response] ListTestCasesResponse
                     */
    
                    /**
                     * Calls ListTestCases.
                     * @function listTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTestCasesRequest} request ListTestCasesRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.ListTestCasesCallback} callback Node-style callback called with the error, if any, and ListTestCasesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.listTestCases = function listTestCases(request, callback) {
                        return this.rpcCall(listTestCases, $root.palexy.sherlock.v1.ListTestCasesRequest, $root.palexy.sherlock.v1.ListTestCasesResponse, request, callback);
                    }, "name", { value: "ListTestCases" });
    
                    /**
                     * Calls ListTestCases.
                     * @function listTestCases
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTestCasesRequest} request ListTestCasesRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListTestCasesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#updateExperimentTestCaseState}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef UpdateExperimentTestCaseStateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} [response] UpdateExperimentTestCaseStateResponse
                     */
    
                    /**
                     * Calls UpdateExperimentTestCaseState.
                     * @function updateExperimentTestCaseState
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest} request UpdateExperimentTestCaseStateRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.UpdateExperimentTestCaseStateCallback} callback Node-style callback called with the error, if any, and UpdateExperimentTestCaseStateResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.updateExperimentTestCaseState = function updateExperimentTestCaseState(request, callback) {
                        return this.rpcCall(updateExperimentTestCaseState, $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest, $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse, request, callback);
                    }, "name", { value: "UpdateExperimentTestCaseState" });
    
                    /**
                     * Calls UpdateExperimentTestCaseState.
                     * @function updateExperimentTestCaseState
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest} request UpdateExperimentTestCaseStateRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#createExperimentVideo}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef CreateExperimentVideoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateExperimentVideoResponse} [response] CreateExperimentVideoResponse
                     */
    
                    /**
                     * Calls CreateExperimentVideo.
                     * @function createExperimentVideo
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest} request CreateExperimentVideoRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.CreateExperimentVideoCallback} callback Node-style callback called with the error, if any, and CreateExperimentVideoResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.createExperimentVideo = function createExperimentVideo(request, callback) {
                        return this.rpcCall(createExperimentVideo, $root.palexy.sherlock.v1.CreateExperimentVideoRequest, $root.palexy.sherlock.v1.CreateExperimentVideoResponse, request, callback);
                    }, "name", { value: "CreateExperimentVideo" });
    
                    /**
                     * Calls CreateExperimentVideo.
                     * @function createExperimentVideo
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest} request CreateExperimentVideoRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateExperimentVideoResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#fetchExperimentVideosReadyForMerging}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef FetchExperimentVideosReadyForMergingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} [response] FetchExperimentVideosReadyForMergingResponse
                     */
    
                    /**
                     * Calls FetchExperimentVideosReadyForMerging.
                     * @function fetchExperimentVideosReadyForMerging
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest} request FetchExperimentVideosReadyForMergingRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.FetchExperimentVideosReadyForMergingCallback} callback Node-style callback called with the error, if any, and FetchExperimentVideosReadyForMergingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.fetchExperimentVideosReadyForMerging = function fetchExperimentVideosReadyForMerging(request, callback) {
                        return this.rpcCall(fetchExperimentVideosReadyForMerging, $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest, $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse, request, callback);
                    }, "name", { value: "FetchExperimentVideosReadyForMerging" });
    
                    /**
                     * Calls FetchExperimentVideosReadyForMerging.
                     * @function fetchExperimentVideosReadyForMerging
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest} request FetchExperimentVideosReadyForMergingRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#fetchExperimentVideosDoneMerging}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef FetchExperimentVideosDoneMergingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} [response] FetchExperimentVideosDoneMergingResponse
                     */
    
                    /**
                     * Calls FetchExperimentVideosDoneMerging.
                     * @function fetchExperimentVideosDoneMerging
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest} request FetchExperimentVideosDoneMergingRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.FetchExperimentVideosDoneMergingCallback} callback Node-style callback called with the error, if any, and FetchExperimentVideosDoneMergingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.fetchExperimentVideosDoneMerging = function fetchExperimentVideosDoneMerging(request, callback) {
                        return this.rpcCall(fetchExperimentVideosDoneMerging, $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest, $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse, request, callback);
                    }, "name", { value: "FetchExperimentVideosDoneMerging" });
    
                    /**
                     * Calls FetchExperimentVideosDoneMerging.
                     * @function fetchExperimentVideosDoneMerging
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest} request FetchExperimentVideosDoneMergingRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#createTestSet}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef CreateTestSetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateTestSetResponse} [response] CreateTestSetResponse
                     */
    
                    /**
                     * Calls CreateTestSet.
                     * @function createTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest} request CreateTestSetRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.CreateTestSetCallback} callback Node-style callback called with the error, if any, and CreateTestSetResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.createTestSet = function createTestSet(request, callback) {
                        return this.rpcCall(createTestSet, $root.palexy.sherlock.v1.CreateTestSetRequest, $root.palexy.sherlock.v1.CreateTestSetResponse, request, callback);
                    }, "name", { value: "CreateTestSet" });
    
                    /**
                     * Calls CreateTestSet.
                     * @function createTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest} request CreateTestSetRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateTestSetResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#listTestSets}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef ListTestSetsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListTestSetsResponse} [response] ListTestSetsResponse
                     */
    
                    /**
                     * Calls ListTestSets.
                     * @function listTestSets
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTestSetsRequest} request ListTestSetsRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.ListTestSetsCallback} callback Node-style callback called with the error, if any, and ListTestSetsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.listTestSets = function listTestSets(request, callback) {
                        return this.rpcCall(listTestSets, $root.palexy.sherlock.v1.ListTestSetsRequest, $root.palexy.sherlock.v1.ListTestSetsResponse, request, callback);
                    }, "name", { value: "ListTestSets" });
    
                    /**
                     * Calls ListTestSets.
                     * @function listTestSets
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IListTestSetsRequest} request ListTestSetsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListTestSetsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#addTestCaseToTestSet}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef AddTestCaseToTestSetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.AddTestCaseToTestSetResponse} [response] AddTestCaseToTestSetResponse
                     */
    
                    /**
                     * Calls AddTestCaseToTestSet.
                     * @function addTestCaseToTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest} request AddTestCaseToTestSetRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.AddTestCaseToTestSetCallback} callback Node-style callback called with the error, if any, and AddTestCaseToTestSetResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.addTestCaseToTestSet = function addTestCaseToTestSet(request, callback) {
                        return this.rpcCall(addTestCaseToTestSet, $root.palexy.sherlock.v1.AddTestCaseToTestSetRequest, $root.palexy.sherlock.v1.AddTestCaseToTestSetResponse, request, callback);
                    }, "name", { value: "AddTestCaseToTestSet" });
    
                    /**
                     * Calls AddTestCaseToTestSet.
                     * @function addTestCaseToTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest} request AddTestCaseToTestSetRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.AddTestCaseToTestSetResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.ExperimentService#removeTestCaseFromTestSet}.
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @typedef RemoveTestCaseFromTestSetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} [response] RemoveTestCaseFromTestSetResponse
                     */
    
                    /**
                     * Calls RemoveTestCaseFromTestSet.
                     * @function removeTestCaseFromTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest} request RemoveTestCaseFromTestSetRequest message or plain object
                     * @param {palexy.sherlock.v1.ExperimentService.RemoveTestCaseFromTestSetCallback} callback Node-style callback called with the error, if any, and RemoveTestCaseFromTestSetResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExperimentService.prototype.removeTestCaseFromTestSet = function removeTestCaseFromTestSet(request, callback) {
                        return this.rpcCall(removeTestCaseFromTestSet, $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest, $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse, request, callback);
                    }, "name", { value: "RemoveTestCaseFromTestSet" });
    
                    /**
                     * Calls RemoveTestCaseFromTestSet.
                     * @function removeTestCaseFromTestSet
                     * @memberof palexy.sherlock.v1.ExperimentService
                     * @instance
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest} request RemoveTestCaseFromTestSetRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse>} Promise
                     * @variation 2
                     */
    
                    return ExperimentService;
                })();
    
                v1.BatchCreateTestCasesRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateTestCasesRequest
                     * @property {Array.<number>|null} [qcFileIds] BatchCreateTestCasesRequest qcFileIds
                     * @property {boolean|null} [includeCurrentTrackingDataAsCache] BatchCreateTestCasesRequest includeCurrentTrackingDataAsCache
                     * @property {number|null} [resultCacheId] BatchCreateTestCasesRequest resultCacheId
                     * @property {string|null} [description] BatchCreateTestCasesRequest description
                     */
    
                    /**
                     * Constructs a new BatchCreateTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateTestCasesRequest.
                     * @implements IBatchCreateTestCasesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest=} [properties] Properties to set
                     */
                    function BatchCreateTestCasesRequest(properties) {
                        this.qcFileIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateTestCasesRequest qcFileIds.
                     * @member {Array.<number>} qcFileIds
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @instance
                     */
                    BatchCreateTestCasesRequest.prototype.qcFileIds = $util.emptyArray;
    
                    /**
                     * BatchCreateTestCasesRequest includeCurrentTrackingDataAsCache.
                     * @member {boolean} includeCurrentTrackingDataAsCache
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @instance
                     */
                    BatchCreateTestCasesRequest.prototype.includeCurrentTrackingDataAsCache = false;
    
                    /**
                     * BatchCreateTestCasesRequest resultCacheId.
                     * @member {number} resultCacheId
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @instance
                     */
                    BatchCreateTestCasesRequest.prototype.resultCacheId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchCreateTestCasesRequest description.
                     * @member {string} description
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @instance
                     */
                    BatchCreateTestCasesRequest.prototype.description = "";
    
                    /**
                     * Creates a new BatchCreateTestCasesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesRequest} BatchCreateTestCasesRequest instance
                     */
                    BatchCreateTestCasesRequest.create = function create(properties) {
                        return new BatchCreateTestCasesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateTestCasesRequest message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTestCasesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest} message BatchCreateTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTestCasesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcFileIds != null && message.qcFileIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.qcFileIds.length; ++i)
                                writer.int64(message.qcFileIds[i]);
                            writer.ldelim();
                        }
                        if (message.includeCurrentTrackingDataAsCache != null && Object.hasOwnProperty.call(message, "includeCurrentTrackingDataAsCache"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeCurrentTrackingDataAsCache);
                        if (message.resultCacheId != null && Object.hasOwnProperty.call(message, "resultCacheId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.resultCacheId);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateTestCasesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTestCasesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesRequest} message BatchCreateTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTestCasesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateTestCasesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesRequest} BatchCreateTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTestCasesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateTestCasesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.qcFileIds && message.qcFileIds.length))
                                    message.qcFileIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.qcFileIds.push(reader.int64());
                                } else
                                    message.qcFileIds.push(reader.int64());
                                break;
                            case 2:
                                message.includeCurrentTrackingDataAsCache = reader.bool();
                                break;
                            case 3:
                                message.resultCacheId = reader.int64();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateTestCasesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesRequest} BatchCreateTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTestCasesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateTestCasesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateTestCasesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcFileIds != null && message.hasOwnProperty("qcFileIds")) {
                            if (!Array.isArray(message.qcFileIds))
                                return "qcFileIds: array expected";
                            for (var i = 0; i < message.qcFileIds.length; ++i)
                                if (!$util.isInteger(message.qcFileIds[i]) && !(message.qcFileIds[i] && $util.isInteger(message.qcFileIds[i].low) && $util.isInteger(message.qcFileIds[i].high)))
                                    return "qcFileIds: integer|Long[] expected";
                        }
                        if (message.includeCurrentTrackingDataAsCache != null && message.hasOwnProperty("includeCurrentTrackingDataAsCache"))
                            if (typeof message.includeCurrentTrackingDataAsCache !== "boolean")
                                return "includeCurrentTrackingDataAsCache: boolean expected";
                        if (message.resultCacheId != null && message.hasOwnProperty("resultCacheId"))
                            if (!$util.isInteger(message.resultCacheId) && !(message.resultCacheId && $util.isInteger(message.resultCacheId.low) && $util.isInteger(message.resultCacheId.high)))
                                return "resultCacheId: integer|Long expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateTestCasesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesRequest} BatchCreateTestCasesRequest
                     */
                    BatchCreateTestCasesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateTestCasesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateTestCasesRequest();
                        if (object.qcFileIds) {
                            if (!Array.isArray(object.qcFileIds))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateTestCasesRequest.qcFileIds: array expected");
                            message.qcFileIds = [];
                            for (var i = 0; i < object.qcFileIds.length; ++i)
                                if ($util.Long)
                                    (message.qcFileIds[i] = $util.Long.fromValue(object.qcFileIds[i])).unsigned = false;
                                else if (typeof object.qcFileIds[i] === "string")
                                    message.qcFileIds[i] = parseInt(object.qcFileIds[i], 10);
                                else if (typeof object.qcFileIds[i] === "number")
                                    message.qcFileIds[i] = object.qcFileIds[i];
                                else if (typeof object.qcFileIds[i] === "object")
                                    message.qcFileIds[i] = new $util.LongBits(object.qcFileIds[i].low >>> 0, object.qcFileIds[i].high >>> 0).toNumber();
                        }
                        if (object.includeCurrentTrackingDataAsCache != null)
                            message.includeCurrentTrackingDataAsCache = Boolean(object.includeCurrentTrackingDataAsCache);
                        if (object.resultCacheId != null)
                            if ($util.Long)
                                (message.resultCacheId = $util.Long.fromValue(object.resultCacheId)).unsigned = false;
                            else if (typeof object.resultCacheId === "string")
                                message.resultCacheId = parseInt(object.resultCacheId, 10);
                            else if (typeof object.resultCacheId === "number")
                                message.resultCacheId = object.resultCacheId;
                            else if (typeof object.resultCacheId === "object")
                                message.resultCacheId = new $util.LongBits(object.resultCacheId.low >>> 0, object.resultCacheId.high >>> 0).toNumber();
                        if (object.description != null)
                            message.description = String(object.description);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateTestCasesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateTestCasesRequest} message BatchCreateTestCasesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateTestCasesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.qcFileIds = [];
                        if (options.defaults) {
                            object.includeCurrentTrackingDataAsCache = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.resultCacheId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.resultCacheId = options.longs === String ? "0" : 0;
                            object.description = "";
                        }
                        if (message.qcFileIds && message.qcFileIds.length) {
                            object.qcFileIds = [];
                            for (var j = 0; j < message.qcFileIds.length; ++j)
                                if (typeof message.qcFileIds[j] === "number")
                                    object.qcFileIds[j] = options.longs === String ? String(message.qcFileIds[j]) : message.qcFileIds[j];
                                else
                                    object.qcFileIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.qcFileIds[j]) : options.longs === Number ? new $util.LongBits(message.qcFileIds[j].low >>> 0, message.qcFileIds[j].high >>> 0).toNumber() : message.qcFileIds[j];
                        }
                        if (message.includeCurrentTrackingDataAsCache != null && message.hasOwnProperty("includeCurrentTrackingDataAsCache"))
                            object.includeCurrentTrackingDataAsCache = message.includeCurrentTrackingDataAsCache;
                        if (message.resultCacheId != null && message.hasOwnProperty("resultCacheId"))
                            if (typeof message.resultCacheId === "number")
                                object.resultCacheId = options.longs === String ? String(message.resultCacheId) : message.resultCacheId;
                            else
                                object.resultCacheId = options.longs === String ? $util.Long.prototype.toString.call(message.resultCacheId) : options.longs === Number ? new $util.LongBits(message.resultCacheId.low >>> 0, message.resultCacheId.high >>> 0).toNumber() : message.resultCacheId;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateTestCasesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateTestCasesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateTestCasesRequest;
                })();
    
                v1.BatchCreateTestCasesResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateTestCasesResponse
                     * @property {Array.<palexy.sherlock.v1.IExperimentTestCase>|null} [testCases] BatchCreateTestCasesResponse testCases
                     * @property {Array.<string>|null} [failedMessages] BatchCreateTestCasesResponse failedMessages
                     */
    
                    /**
                     * Constructs a new BatchCreateTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateTestCasesResponse.
                     * @implements IBatchCreateTestCasesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesResponse=} [properties] Properties to set
                     */
                    function BatchCreateTestCasesResponse(properties) {
                        this.testCases = [];
                        this.failedMessages = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateTestCasesResponse testCases.
                     * @member {Array.<palexy.sherlock.v1.IExperimentTestCase>} testCases
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @instance
                     */
                    BatchCreateTestCasesResponse.prototype.testCases = $util.emptyArray;
    
                    /**
                     * BatchCreateTestCasesResponse failedMessages.
                     * @member {Array.<string>} failedMessages
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @instance
                     */
                    BatchCreateTestCasesResponse.prototype.failedMessages = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateTestCasesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesResponse} BatchCreateTestCasesResponse instance
                     */
                    BatchCreateTestCasesResponse.create = function create(properties) {
                        return new BatchCreateTestCasesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateTestCasesResponse message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTestCasesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesResponse} message BatchCreateTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTestCasesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testCases != null && message.testCases.length)
                            for (var i = 0; i < message.testCases.length; ++i)
                                $root.palexy.sherlock.v1.ExperimentTestCase.encode(message.testCases[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.failedMessages != null && message.failedMessages.length)
                            for (var i = 0; i < message.failedMessages.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.failedMessages[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateTestCasesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateTestCasesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateTestCasesResponse} message BatchCreateTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateTestCasesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateTestCasesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesResponse} BatchCreateTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTestCasesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateTestCasesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.testCases && message.testCases.length))
                                    message.testCases = [];
                                message.testCases.push($root.palexy.sherlock.v1.ExperimentTestCase.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.failedMessages && message.failedMessages.length))
                                    message.failedMessages = [];
                                message.failedMessages.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateTestCasesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesResponse} BatchCreateTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateTestCasesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateTestCasesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateTestCasesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testCases != null && message.hasOwnProperty("testCases")) {
                            if (!Array.isArray(message.testCases))
                                return "testCases: array expected";
                            for (var i = 0; i < message.testCases.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ExperimentTestCase.verify(message.testCases[i]);
                                if (error)
                                    return "testCases." + error;
                            }
                        }
                        if (message.failedMessages != null && message.hasOwnProperty("failedMessages")) {
                            if (!Array.isArray(message.failedMessages))
                                return "failedMessages: array expected";
                            for (var i = 0; i < message.failedMessages.length; ++i)
                                if (!$util.isString(message.failedMessages[i]))
                                    return "failedMessages: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateTestCasesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateTestCasesResponse} BatchCreateTestCasesResponse
                     */
                    BatchCreateTestCasesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateTestCasesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateTestCasesResponse();
                        if (object.testCases) {
                            if (!Array.isArray(object.testCases))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateTestCasesResponse.testCases: array expected");
                            message.testCases = [];
                            for (var i = 0; i < object.testCases.length; ++i) {
                                if (typeof object.testCases[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCreateTestCasesResponse.testCases: object expected");
                                message.testCases[i] = $root.palexy.sherlock.v1.ExperimentTestCase.fromObject(object.testCases[i]);
                            }
                        }
                        if (object.failedMessages) {
                            if (!Array.isArray(object.failedMessages))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateTestCasesResponse.failedMessages: array expected");
                            message.failedMessages = [];
                            for (var i = 0; i < object.failedMessages.length; ++i)
                                message.failedMessages[i] = String(object.failedMessages[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateTestCasesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateTestCasesResponse} message BatchCreateTestCasesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateTestCasesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.testCases = [];
                            object.failedMessages = [];
                        }
                        if (message.testCases && message.testCases.length) {
                            object.testCases = [];
                            for (var j = 0; j < message.testCases.length; ++j)
                                object.testCases[j] = $root.palexy.sherlock.v1.ExperimentTestCase.toObject(message.testCases[j], options);
                        }
                        if (message.failedMessages && message.failedMessages.length) {
                            object.failedMessages = [];
                            for (var j = 0; j < message.failedMessages.length; ++j)
                                object.failedMessages[j] = message.failedMessages[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateTestCasesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateTestCasesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateTestCasesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateTestCasesResponse;
                })();
    
                v1.ExperimentTestCase = (function() {
    
                    /**
                     * Properties of an ExperimentTestCase.
                     * @memberof palexy.sherlock.v1
                     * @interface IExperimentTestCase
                     * @property {number|null} [id] ExperimentTestCase id
                     * @property {string|null} [name] ExperimentTestCase name
                     * @property {number|null} [storeId] ExperimentTestCase storeId
                     * @property {string|null} [dateId] ExperimentTestCase dateId
                     * @property {palexy.sherlock.v1.ITestCaseVideos|null} [videos] ExperimentTestCase videos
                     * @property {number|null} [qcFileId] ExperimentTestCase qcFileId
                     * @property {number|null} [createTimeMs] ExperimentTestCase createTimeMs
                     * @property {string|null} [description] ExperimentTestCase description
                     */
    
                    /**
                     * Constructs a new ExperimentTestCase.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an ExperimentTestCase.
                     * @implements IExperimentTestCase
                     * @constructor
                     * @param {palexy.sherlock.v1.IExperimentTestCase=} [properties] Properties to set
                     */
                    function ExperimentTestCase(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExperimentTestCase id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExperimentTestCase name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.name = "";
    
                    /**
                     * ExperimentTestCase storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExperimentTestCase dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.dateId = "";
    
                    /**
                     * ExperimentTestCase videos.
                     * @member {palexy.sherlock.v1.ITestCaseVideos|null|undefined} videos
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.videos = null;
    
                    /**
                     * ExperimentTestCase qcFileId.
                     * @member {number} qcFileId
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.qcFileId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExperimentTestCase createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExperimentTestCase description.
                     * @member {string} description
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     */
                    ExperimentTestCase.prototype.description = "";
    
                    /**
                     * Creates a new ExperimentTestCase instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentTestCase=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ExperimentTestCase} ExperimentTestCase instance
                     */
                    ExperimentTestCase.create = function create(properties) {
                        return new ExperimentTestCase(properties);
                    };
    
                    /**
                     * Encodes the specified ExperimentTestCase message. Does not implicitly {@link palexy.sherlock.v1.ExperimentTestCase.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentTestCase} message ExperimentTestCase message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExperimentTestCase.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.dateId);
                        if (message.videos != null && Object.hasOwnProperty.call(message, "videos"))
                            $root.palexy.sherlock.v1.TestCaseVideos.encode(message.videos, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.qcFileId != null && Object.hasOwnProperty.call(message, "qcFileId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.qcFileId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.description);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExperimentTestCase message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ExperimentTestCase.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {palexy.sherlock.v1.IExperimentTestCase} message ExperimentTestCase message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExperimentTestCase.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExperimentTestCase message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ExperimentTestCase} ExperimentTestCase
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExperimentTestCase.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ExperimentTestCase();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.string();
                                break;
                            case 5:
                                message.videos = $root.palexy.sherlock.v1.TestCaseVideos.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.qcFileId = reader.int64();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.description = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExperimentTestCase message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ExperimentTestCase} ExperimentTestCase
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExperimentTestCase.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExperimentTestCase message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExperimentTestCase.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.videos != null && message.hasOwnProperty("videos")) {
                            var error = $root.palexy.sherlock.v1.TestCaseVideos.verify(message.videos);
                            if (error)
                                return "videos." + error;
                        }
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (!$util.isInteger(message.qcFileId) && !(message.qcFileId && $util.isInteger(message.qcFileId.low) && $util.isInteger(message.qcFileId.high)))
                                return "qcFileId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExperimentTestCase message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ExperimentTestCase} ExperimentTestCase
                     */
                    ExperimentTestCase.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ExperimentTestCase)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ExperimentTestCase();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.videos != null) {
                            if (typeof object.videos !== "object")
                                throw TypeError(".palexy.sherlock.v1.ExperimentTestCase.videos: object expected");
                            message.videos = $root.palexy.sherlock.v1.TestCaseVideos.fromObject(object.videos);
                        }
                        if (object.qcFileId != null)
                            if ($util.Long)
                                (message.qcFileId = $util.Long.fromValue(object.qcFileId)).unsigned = false;
                            else if (typeof object.qcFileId === "string")
                                message.qcFileId = parseInt(object.qcFileId, 10);
                            else if (typeof object.qcFileId === "number")
                                message.qcFileId = object.qcFileId;
                            else if (typeof object.qcFileId === "object")
                                message.qcFileId = new $util.LongBits(object.qcFileId.low >>> 0, object.qcFileId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.description != null)
                            message.description = String(object.description);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExperimentTestCase message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @static
                     * @param {palexy.sherlock.v1.ExperimentTestCase} message ExperimentTestCase
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExperimentTestCase.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.videos = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.qcFileId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.qcFileId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            object.description = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.videos != null && message.hasOwnProperty("videos"))
                            object.videos = $root.palexy.sherlock.v1.TestCaseVideos.toObject(message.videos, options);
                        if (message.qcFileId != null && message.hasOwnProperty("qcFileId"))
                            if (typeof message.qcFileId === "number")
                                object.qcFileId = options.longs === String ? String(message.qcFileId) : message.qcFileId;
                            else
                                object.qcFileId = options.longs === String ? $util.Long.prototype.toString.call(message.qcFileId) : options.longs === Number ? new $util.LongBits(message.qcFileId.low >>> 0, message.qcFileId.high >>> 0).toNumber() : message.qcFileId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        return object;
                    };
    
                    /**
                     * Converts this ExperimentTestCase to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ExperimentTestCase
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExperimentTestCase.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExperimentTestCase;
                })();
    
                v1.TestCaseVideos = (function() {
    
                    /**
                     * Properties of a TestCaseVideos.
                     * @memberof palexy.sherlock.v1
                     * @interface ITestCaseVideos
                     * @property {Array.<palexy.streaming.v1.IVideo>|null} [videos] TestCaseVideos videos
                     */
    
                    /**
                     * Constructs a new TestCaseVideos.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a TestCaseVideos.
                     * @implements ITestCaseVideos
                     * @constructor
                     * @param {palexy.sherlock.v1.ITestCaseVideos=} [properties] Properties to set
                     */
                    function TestCaseVideos(properties) {
                        this.videos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TestCaseVideos videos.
                     * @member {Array.<palexy.streaming.v1.IVideo>} videos
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @instance
                     */
                    TestCaseVideos.prototype.videos = $util.emptyArray;
    
                    /**
                     * Creates a new TestCaseVideos instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {palexy.sherlock.v1.ITestCaseVideos=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.TestCaseVideos} TestCaseVideos instance
                     */
                    TestCaseVideos.create = function create(properties) {
                        return new TestCaseVideos(properties);
                    };
    
                    /**
                     * Encodes the specified TestCaseVideos message. Does not implicitly {@link palexy.sherlock.v1.TestCaseVideos.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {palexy.sherlock.v1.ITestCaseVideos} message TestCaseVideos message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestCaseVideos.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.videos != null && message.videos.length)
                            for (var i = 0; i < message.videos.length; ++i)
                                $root.palexy.streaming.v1.Video.encode(message.videos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TestCaseVideos message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TestCaseVideos.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {palexy.sherlock.v1.ITestCaseVideos} message TestCaseVideos message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestCaseVideos.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TestCaseVideos message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.TestCaseVideos} TestCaseVideos
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestCaseVideos.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TestCaseVideos();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.videos && message.videos.length))
                                    message.videos = [];
                                message.videos.push($root.palexy.streaming.v1.Video.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TestCaseVideos message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.TestCaseVideos} TestCaseVideos
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestCaseVideos.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TestCaseVideos message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TestCaseVideos.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.videos != null && message.hasOwnProperty("videos")) {
                            if (!Array.isArray(message.videos))
                                return "videos: array expected";
                            for (var i = 0; i < message.videos.length; ++i) {
                                var error = $root.palexy.streaming.v1.Video.verify(message.videos[i]);
                                if (error)
                                    return "videos." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TestCaseVideos message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.TestCaseVideos} TestCaseVideos
                     */
                    TestCaseVideos.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.TestCaseVideos)
                            return object;
                        var message = new $root.palexy.sherlock.v1.TestCaseVideos();
                        if (object.videos) {
                            if (!Array.isArray(object.videos))
                                throw TypeError(".palexy.sherlock.v1.TestCaseVideos.videos: array expected");
                            message.videos = [];
                            for (var i = 0; i < object.videos.length; ++i) {
                                if (typeof object.videos[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.TestCaseVideos.videos: object expected");
                                message.videos[i] = $root.palexy.streaming.v1.Video.fromObject(object.videos[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TestCaseVideos message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @static
                     * @param {palexy.sherlock.v1.TestCaseVideos} message TestCaseVideos
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TestCaseVideos.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.videos = [];
                        if (message.videos && message.videos.length) {
                            object.videos = [];
                            for (var j = 0; j < message.videos.length; ++j)
                                object.videos[j] = $root.palexy.streaming.v1.Video.toObject(message.videos[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TestCaseVideos to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.TestCaseVideos
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TestCaseVideos.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TestCaseVideos;
                })();
    
                v1.TestSet = (function() {
    
                    /**
                     * Properties of a TestSet.
                     * @memberof palexy.sherlock.v1
                     * @interface ITestSet
                     * @property {number|null} [id] TestSet id
                     * @property {string|null} [name] TestSet name
                     * @property {string|null} [displayName] TestSet displayName
                     * @property {string|null} [description] TestSet description
                     * @property {number|null} [createTimeMs] TestSet createTimeMs
                     * @property {number|null} [updateTimeMs] TestSet updateTimeMs
                     */
    
                    /**
                     * Constructs a new TestSet.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a TestSet.
                     * @implements ITestSet
                     * @constructor
                     * @param {palexy.sherlock.v1.ITestSet=} [properties] Properties to set
                     */
                    function TestSet(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TestSet id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TestSet name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.name = "";
    
                    /**
                     * TestSet displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.displayName = "";
    
                    /**
                     * TestSet description.
                     * @member {string} description
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.description = "";
    
                    /**
                     * TestSet createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TestSet updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     */
                    TestSet.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TestSet instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {palexy.sherlock.v1.ITestSet=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.TestSet} TestSet instance
                     */
                    TestSet.create = function create(properties) {
                        return new TestSet(properties);
                    };
    
                    /**
                     * Encodes the specified TestSet message. Does not implicitly {@link palexy.sherlock.v1.TestSet.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {palexy.sherlock.v1.ITestSet} message TestSet message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestSet.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.displayName);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TestSet message, length delimited. Does not implicitly {@link palexy.sherlock.v1.TestSet.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {palexy.sherlock.v1.ITestSet} message TestSet message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TestSet.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TestSet message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.TestSet} TestSet
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestSet.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.TestSet();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.displayName = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TestSet message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.TestSet} TestSet
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TestSet.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TestSet message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TestSet.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TestSet message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.TestSet} TestSet
                     */
                    TestSet.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.TestSet)
                            return object;
                        var message = new $root.palexy.sherlock.v1.TestSet();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TestSet message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.TestSet
                     * @static
                     * @param {palexy.sherlock.v1.TestSet} message TestSet
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TestSet.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.displayName = "";
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this TestSet to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.TestSet
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TestSet.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TestSet;
                })();
    
                v1.CreateTestSetRequest = (function() {
    
                    /**
                     * Properties of a CreateTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTestSetRequest
                     * @property {palexy.sherlock.v1.ITestSet|null} [testSet] CreateTestSetRequest testSet
                     */
    
                    /**
                     * Constructs a new CreateTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTestSetRequest.
                     * @implements ICreateTestSetRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest=} [properties] Properties to set
                     */
                    function CreateTestSetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTestSetRequest testSet.
                     * @member {palexy.sherlock.v1.ITestSet|null|undefined} testSet
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @instance
                     */
                    CreateTestSetRequest.prototype.testSet = null;
    
                    /**
                     * Creates a new CreateTestSetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTestSetRequest} CreateTestSetRequest instance
                     */
                    CreateTestSetRequest.create = function create(properties) {
                        return new CreateTestSetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTestSetRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateTestSetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest} message CreateTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTestSetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSet != null && Object.hasOwnProperty.call(message, "testSet"))
                            $root.palexy.sherlock.v1.TestSet.encode(message.testSet, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTestSetRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTestSetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetRequest} message CreateTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTestSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTestSetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTestSetRequest} CreateTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTestSetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTestSetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testSet = $root.palexy.sherlock.v1.TestSet.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTestSetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTestSetRequest} CreateTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTestSetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTestSetRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTestSetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSet != null && message.hasOwnProperty("testSet")) {
                            var error = $root.palexy.sherlock.v1.TestSet.verify(message.testSet);
                            if (error)
                                return "testSet." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTestSetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTestSetRequest} CreateTestSetRequest
                     */
                    CreateTestSetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTestSetRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTestSetRequest();
                        if (object.testSet != null) {
                            if (typeof object.testSet !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateTestSetRequest.testSet: object expected");
                            message.testSet = $root.palexy.sherlock.v1.TestSet.fromObject(object.testSet);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTestSetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateTestSetRequest} message CreateTestSetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTestSetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.testSet = null;
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            object.testSet = $root.palexy.sherlock.v1.TestSet.toObject(message.testSet, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTestSetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTestSetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTestSetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTestSetRequest;
                })();
    
                v1.CreateTestSetResponse = (function() {
    
                    /**
                     * Properties of a CreateTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateTestSetResponse
                     * @property {palexy.sherlock.v1.ITestSet|null} [testSet] CreateTestSetResponse testSet
                     */
    
                    /**
                     * Constructs a new CreateTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateTestSetResponse.
                     * @implements ICreateTestSetResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateTestSetResponse=} [properties] Properties to set
                     */
                    function CreateTestSetResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTestSetResponse testSet.
                     * @member {palexy.sherlock.v1.ITestSet|null|undefined} testSet
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @instance
                     */
                    CreateTestSetResponse.prototype.testSet = null;
    
                    /**
                     * Creates a new CreateTestSetResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateTestSetResponse} CreateTestSetResponse instance
                     */
                    CreateTestSetResponse.create = function create(properties) {
                        return new CreateTestSetResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTestSetResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateTestSetResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetResponse} message CreateTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTestSetResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSet != null && Object.hasOwnProperty.call(message, "testSet"))
                            $root.palexy.sherlock.v1.TestSet.encode(message.testSet, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTestSetResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateTestSetResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateTestSetResponse} message CreateTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTestSetResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTestSetResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateTestSetResponse} CreateTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTestSetResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateTestSetResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testSet = $root.palexy.sherlock.v1.TestSet.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTestSetResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateTestSetResponse} CreateTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTestSetResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTestSetResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTestSetResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSet != null && message.hasOwnProperty("testSet")) {
                            var error = $root.palexy.sherlock.v1.TestSet.verify(message.testSet);
                            if (error)
                                return "testSet." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTestSetResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateTestSetResponse} CreateTestSetResponse
                     */
                    CreateTestSetResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateTestSetResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateTestSetResponse();
                        if (object.testSet != null) {
                            if (typeof object.testSet !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateTestSetResponse.testSet: object expected");
                            message.testSet = $root.palexy.sherlock.v1.TestSet.fromObject(object.testSet);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTestSetResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateTestSetResponse} message CreateTestSetResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTestSetResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.testSet = null;
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            object.testSet = $root.palexy.sherlock.v1.TestSet.toObject(message.testSet, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTestSetResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateTestSetResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTestSetResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTestSetResponse;
                })();
    
                v1.ListTestSetsRequest = (function() {
    
                    /**
                     * Properties of a ListTestSetsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTestSetsRequest
                     * @property {string|null} [pageToken] ListTestSetsRequest pageToken
                     * @property {number|null} [pageSize] ListTestSetsRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListTestSetsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTestSetsRequest.
                     * @implements IListTestSetsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTestSetsRequest=} [properties] Properties to set
                     */
                    function ListTestSetsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTestSetsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @instance
                     */
                    ListTestSetsRequest.prototype.pageToken = "";
    
                    /**
                     * ListTestSetsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @instance
                     */
                    ListTestSetsRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListTestSetsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTestSetsRequest} ListTestSetsRequest instance
                     */
                    ListTestSetsRequest.create = function create(properties) {
                        return new ListTestSetsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTestSetsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListTestSetsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsRequest} message ListTestSetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestSetsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTestSetsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTestSetsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsRequest} message ListTestSetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestSetsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTestSetsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTestSetsRequest} ListTestSetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestSetsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTestSetsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageToken = reader.string();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTestSetsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTestSetsRequest} ListTestSetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestSetsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTestSetsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTestSetsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTestSetsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTestSetsRequest} ListTestSetsRequest
                     */
                    ListTestSetsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTestSetsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTestSetsRequest();
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTestSetsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListTestSetsRequest} message ListTestSetsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTestSetsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListTestSetsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTestSetsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTestSetsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTestSetsRequest;
                })();
    
                v1.ListTestSetsResponse = (function() {
    
                    /**
                     * Properties of a ListTestSetsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTestSetsResponse
                     * @property {Array.<palexy.sherlock.v1.ITestSet>|null} [testSets] ListTestSetsResponse testSets
                     * @property {string|null} [nextPageToken] ListTestSetsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListTestSetsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTestSetsResponse.
                     * @implements IListTestSetsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTestSetsResponse=} [properties] Properties to set
                     */
                    function ListTestSetsResponse(properties) {
                        this.testSets = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTestSetsResponse testSets.
                     * @member {Array.<palexy.sherlock.v1.ITestSet>} testSets
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @instance
                     */
                    ListTestSetsResponse.prototype.testSets = $util.emptyArray;
    
                    /**
                     * ListTestSetsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @instance
                     */
                    ListTestSetsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListTestSetsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTestSetsResponse} ListTestSetsResponse instance
                     */
                    ListTestSetsResponse.create = function create(properties) {
                        return new ListTestSetsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTestSetsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListTestSetsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsResponse} message ListTestSetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestSetsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSets != null && message.testSets.length)
                            for (var i = 0; i < message.testSets.length; ++i)
                                $root.palexy.sherlock.v1.TestSet.encode(message.testSets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTestSetsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTestSetsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestSetsResponse} message ListTestSetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestSetsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTestSetsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTestSetsResponse} ListTestSetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestSetsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTestSetsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.testSets && message.testSets.length))
                                    message.testSets = [];
                                message.testSets.push($root.palexy.sherlock.v1.TestSet.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTestSetsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTestSetsResponse} ListTestSetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestSetsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTestSetsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTestSetsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSets != null && message.hasOwnProperty("testSets")) {
                            if (!Array.isArray(message.testSets))
                                return "testSets: array expected";
                            for (var i = 0; i < message.testSets.length; ++i) {
                                var error = $root.palexy.sherlock.v1.TestSet.verify(message.testSets[i]);
                                if (error)
                                    return "testSets." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTestSetsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTestSetsResponse} ListTestSetsResponse
                     */
                    ListTestSetsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTestSetsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTestSetsResponse();
                        if (object.testSets) {
                            if (!Array.isArray(object.testSets))
                                throw TypeError(".palexy.sherlock.v1.ListTestSetsResponse.testSets: array expected");
                            message.testSets = [];
                            for (var i = 0; i < object.testSets.length; ++i) {
                                if (typeof object.testSets[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListTestSetsResponse.testSets: object expected");
                                message.testSets[i] = $root.palexy.sherlock.v1.TestSet.fromObject(object.testSets[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTestSetsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListTestSetsResponse} message ListTestSetsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTestSetsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.testSets = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.testSets && message.testSets.length) {
                            object.testSets = [];
                            for (var j = 0; j < message.testSets.length; ++j)
                                object.testSets[j] = $root.palexy.sherlock.v1.TestSet.toObject(message.testSets[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListTestSetsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTestSetsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTestSetsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTestSetsResponse;
                })();
    
                v1.AddTestCaseToTestSetRequest = (function() {
    
                    /**
                     * Properties of an AddTestCaseToTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IAddTestCaseToTestSetRequest
                     * @property {string|null} [testSet] AddTestCaseToTestSetRequest testSet
                     * @property {number|null} [testCaseId] AddTestCaseToTestSetRequest testCaseId
                     */
    
                    /**
                     * Constructs a new AddTestCaseToTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AddTestCaseToTestSetRequest.
                     * @implements IAddTestCaseToTestSetRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest=} [properties] Properties to set
                     */
                    function AddTestCaseToTestSetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AddTestCaseToTestSetRequest testSet.
                     * @member {string} testSet
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @instance
                     */
                    AddTestCaseToTestSetRequest.prototype.testSet = "";
    
                    /**
                     * AddTestCaseToTestSetRequest testCaseId.
                     * @member {number} testCaseId
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @instance
                     */
                    AddTestCaseToTestSetRequest.prototype.testCaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AddTestCaseToTestSetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetRequest} AddTestCaseToTestSetRequest instance
                     */
                    AddTestCaseToTestSetRequest.create = function create(properties) {
                        return new AddTestCaseToTestSetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AddTestCaseToTestSetRequest message. Does not implicitly {@link palexy.sherlock.v1.AddTestCaseToTestSetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest} message AddTestCaseToTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddTestCaseToTestSetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSet != null && Object.hasOwnProperty.call(message, "testSet"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.testSet);
                        if (message.testCaseId != null && Object.hasOwnProperty.call(message, "testCaseId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.testCaseId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddTestCaseToTestSetRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AddTestCaseToTestSetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetRequest} message AddTestCaseToTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddTestCaseToTestSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddTestCaseToTestSetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetRequest} AddTestCaseToTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddTestCaseToTestSetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AddTestCaseToTestSetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testSet = reader.string();
                                break;
                            case 2:
                                message.testCaseId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddTestCaseToTestSetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetRequest} AddTestCaseToTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddTestCaseToTestSetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddTestCaseToTestSetRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddTestCaseToTestSetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            if (!$util.isString(message.testSet))
                                return "testSet: string expected";
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (!$util.isInteger(message.testCaseId) && !(message.testCaseId && $util.isInteger(message.testCaseId.low) && $util.isInteger(message.testCaseId.high)))
                                return "testCaseId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AddTestCaseToTestSetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetRequest} AddTestCaseToTestSetRequest
                     */
                    AddTestCaseToTestSetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AddTestCaseToTestSetRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.AddTestCaseToTestSetRequest();
                        if (object.testSet != null)
                            message.testSet = String(object.testSet);
                        if (object.testCaseId != null)
                            if ($util.Long)
                                (message.testCaseId = $util.Long.fromValue(object.testCaseId)).unsigned = false;
                            else if (typeof object.testCaseId === "string")
                                message.testCaseId = parseInt(object.testCaseId, 10);
                            else if (typeof object.testCaseId === "number")
                                message.testCaseId = object.testCaseId;
                            else if (typeof object.testCaseId === "object")
                                message.testCaseId = new $util.LongBits(object.testCaseId.low >>> 0, object.testCaseId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AddTestCaseToTestSetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.AddTestCaseToTestSetRequest} message AddTestCaseToTestSetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddTestCaseToTestSetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.testSet = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testCaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testCaseId = options.longs === String ? "0" : 0;
                        }
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            object.testSet = message.testSet;
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (typeof message.testCaseId === "number")
                                object.testCaseId = options.longs === String ? String(message.testCaseId) : message.testCaseId;
                            else
                                object.testCaseId = options.longs === String ? $util.Long.prototype.toString.call(message.testCaseId) : options.longs === Number ? new $util.LongBits(message.testCaseId.low >>> 0, message.testCaseId.high >>> 0).toNumber() : message.testCaseId;
                        return object;
                    };
    
                    /**
                     * Converts this AddTestCaseToTestSetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddTestCaseToTestSetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddTestCaseToTestSetRequest;
                })();
    
                v1.AddTestCaseToTestSetResponse = (function() {
    
                    /**
                     * Properties of an AddTestCaseToTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IAddTestCaseToTestSetResponse
                     */
    
                    /**
                     * Constructs a new AddTestCaseToTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AddTestCaseToTestSetResponse.
                     * @implements IAddTestCaseToTestSetResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetResponse=} [properties] Properties to set
                     */
                    function AddTestCaseToTestSetResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new AddTestCaseToTestSetResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetResponse} AddTestCaseToTestSetResponse instance
                     */
                    AddTestCaseToTestSetResponse.create = function create(properties) {
                        return new AddTestCaseToTestSetResponse(properties);
                    };
    
                    /**
                     * Encodes the specified AddTestCaseToTestSetResponse message. Does not implicitly {@link palexy.sherlock.v1.AddTestCaseToTestSetResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetResponse} message AddTestCaseToTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddTestCaseToTestSetResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddTestCaseToTestSetResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AddTestCaseToTestSetResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddTestCaseToTestSetResponse} message AddTestCaseToTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddTestCaseToTestSetResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddTestCaseToTestSetResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetResponse} AddTestCaseToTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddTestCaseToTestSetResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AddTestCaseToTestSetResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddTestCaseToTestSetResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetResponse} AddTestCaseToTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddTestCaseToTestSetResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddTestCaseToTestSetResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddTestCaseToTestSetResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an AddTestCaseToTestSetResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AddTestCaseToTestSetResponse} AddTestCaseToTestSetResponse
                     */
                    AddTestCaseToTestSetResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AddTestCaseToTestSetResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.AddTestCaseToTestSetResponse();
                    };
    
                    /**
                     * Creates a plain object from an AddTestCaseToTestSetResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.AddTestCaseToTestSetResponse} message AddTestCaseToTestSetResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddTestCaseToTestSetResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this AddTestCaseToTestSetResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AddTestCaseToTestSetResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddTestCaseToTestSetResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddTestCaseToTestSetResponse;
                })();
    
                v1.RemoveTestCaseFromTestSetRequest = (function() {
    
                    /**
                     * Properties of a RemoveTestCaseFromTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IRemoveTestCaseFromTestSetRequest
                     * @property {string|null} [testSet] RemoveTestCaseFromTestSetRequest testSet
                     * @property {number|null} [testCaseId] RemoveTestCaseFromTestSetRequest testCaseId
                     */
    
                    /**
                     * Constructs a new RemoveTestCaseFromTestSetRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RemoveTestCaseFromTestSetRequest.
                     * @implements IRemoveTestCaseFromTestSetRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest=} [properties] Properties to set
                     */
                    function RemoveTestCaseFromTestSetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RemoveTestCaseFromTestSetRequest testSet.
                     * @member {string} testSet
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @instance
                     */
                    RemoveTestCaseFromTestSetRequest.prototype.testSet = "";
    
                    /**
                     * RemoveTestCaseFromTestSetRequest testCaseId.
                     * @member {number} testCaseId
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @instance
                     */
                    RemoveTestCaseFromTestSetRequest.prototype.testCaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new RemoveTestCaseFromTestSetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest} RemoveTestCaseFromTestSetRequest instance
                     */
                    RemoveTestCaseFromTestSetRequest.create = function create(properties) {
                        return new RemoveTestCaseFromTestSetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RemoveTestCaseFromTestSetRequest message. Does not implicitly {@link palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest} message RemoveTestCaseFromTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveTestCaseFromTestSetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSet != null && Object.hasOwnProperty.call(message, "testSet"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.testSet);
                        if (message.testCaseId != null && Object.hasOwnProperty.call(message, "testCaseId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.testCaseId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoveTestCaseFromTestSetRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetRequest} message RemoveTestCaseFromTestSetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveTestCaseFromTestSetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoveTestCaseFromTestSetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest} RemoveTestCaseFromTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveTestCaseFromTestSetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testSet = reader.string();
                                break;
                            case 2:
                                message.testCaseId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoveTestCaseFromTestSetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest} RemoveTestCaseFromTestSetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveTestCaseFromTestSetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoveTestCaseFromTestSetRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoveTestCaseFromTestSetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            if (!$util.isString(message.testSet))
                                return "testSet: string expected";
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (!$util.isInteger(message.testCaseId) && !(message.testCaseId && $util.isInteger(message.testCaseId.low) && $util.isInteger(message.testCaseId.high)))
                                return "testCaseId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a RemoveTestCaseFromTestSetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest} RemoveTestCaseFromTestSetRequest
                     */
                    RemoveTestCaseFromTestSetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest();
                        if (object.testSet != null)
                            message.testSet = String(object.testSet);
                        if (object.testCaseId != null)
                            if ($util.Long)
                                (message.testCaseId = $util.Long.fromValue(object.testCaseId)).unsigned = false;
                            else if (typeof object.testCaseId === "string")
                                message.testCaseId = parseInt(object.testCaseId, 10);
                            else if (typeof object.testCaseId === "number")
                                message.testCaseId = object.testCaseId;
                            else if (typeof object.testCaseId === "object")
                                message.testCaseId = new $util.LongBits(object.testCaseId.low >>> 0, object.testCaseId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RemoveTestCaseFromTestSetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @static
                     * @param {palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest} message RemoveTestCaseFromTestSetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoveTestCaseFromTestSetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.testSet = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testCaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testCaseId = options.longs === String ? "0" : 0;
                        }
                        if (message.testSet != null && message.hasOwnProperty("testSet"))
                            object.testSet = message.testSet;
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (typeof message.testCaseId === "number")
                                object.testCaseId = options.longs === String ? String(message.testCaseId) : message.testCaseId;
                            else
                                object.testCaseId = options.longs === String ? $util.Long.prototype.toString.call(message.testCaseId) : options.longs === Number ? new $util.LongBits(message.testCaseId.low >>> 0, message.testCaseId.high >>> 0).toNumber() : message.testCaseId;
                        return object;
                    };
    
                    /**
                     * Converts this RemoveTestCaseFromTestSetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoveTestCaseFromTestSetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoveTestCaseFromTestSetRequest;
                })();
    
                v1.RemoveTestCaseFromTestSetResponse = (function() {
    
                    /**
                     * Properties of a RemoveTestCaseFromTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IRemoveTestCaseFromTestSetResponse
                     */
    
                    /**
                     * Constructs a new RemoveTestCaseFromTestSetResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a RemoveTestCaseFromTestSetResponse.
                     * @implements IRemoveTestCaseFromTestSetResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetResponse=} [properties] Properties to set
                     */
                    function RemoveTestCaseFromTestSetResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new RemoveTestCaseFromTestSetResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} RemoveTestCaseFromTestSetResponse instance
                     */
                    RemoveTestCaseFromTestSetResponse.create = function create(properties) {
                        return new RemoveTestCaseFromTestSetResponse(properties);
                    };
    
                    /**
                     * Encodes the specified RemoveTestCaseFromTestSetResponse message. Does not implicitly {@link palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetResponse} message RemoveTestCaseFromTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveTestCaseFromTestSetResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoveTestCaseFromTestSetResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.IRemoveTestCaseFromTestSetResponse} message RemoveTestCaseFromTestSetResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveTestCaseFromTestSetResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoveTestCaseFromTestSetResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} RemoveTestCaseFromTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveTestCaseFromTestSetResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoveTestCaseFromTestSetResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} RemoveTestCaseFromTestSetResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveTestCaseFromTestSetResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoveTestCaseFromTestSetResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoveTestCaseFromTestSetResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a RemoveTestCaseFromTestSetResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} RemoveTestCaseFromTestSetResponse
                     */
                    RemoveTestCaseFromTestSetResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse();
                    };
    
                    /**
                     * Creates a plain object from a RemoveTestCaseFromTestSetResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @static
                     * @param {palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse} message RemoveTestCaseFromTestSetResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoveTestCaseFromTestSetResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this RemoveTestCaseFromTestSetResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.RemoveTestCaseFromTestSetResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoveTestCaseFromTestSetResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoveTestCaseFromTestSetResponse;
                })();
    
                v1.ListTestCasesRequest = (function() {
    
                    /**
                     * Properties of a ListTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTestCasesRequest
                     * @property {number|null} [testSetId] ListTestCasesRequest testSetId
                     * @property {string|null} [pageToken] ListTestCasesRequest pageToken
                     * @property {number|null} [pageSize] ListTestCasesRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTestCasesRequest.
                     * @implements IListTestCasesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTestCasesRequest=} [properties] Properties to set
                     */
                    function ListTestCasesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTestCasesRequest testSetId.
                     * @member {number} testSetId
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @instance
                     */
                    ListTestCasesRequest.prototype.testSetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListTestCasesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @instance
                     */
                    ListTestCasesRequest.prototype.pageToken = "";
    
                    /**
                     * ListTestCasesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @instance
                     */
                    ListTestCasesRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListTestCasesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTestCasesRequest} ListTestCasesRequest instance
                     */
                    ListTestCasesRequest.create = function create(properties) {
                        return new ListTestCasesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTestCasesRequest message. Does not implicitly {@link palexy.sherlock.v1.ListTestCasesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesRequest} message ListTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestCasesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testSetId != null && Object.hasOwnProperty.call(message, "testSetId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.testSetId);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTestCasesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTestCasesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesRequest} message ListTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestCasesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTestCasesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTestCasesRequest} ListTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestCasesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTestCasesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testSetId = reader.int64();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTestCasesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTestCasesRequest} ListTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestCasesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTestCasesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTestCasesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testSetId != null && message.hasOwnProperty("testSetId"))
                            if (!$util.isInteger(message.testSetId) && !(message.testSetId && $util.isInteger(message.testSetId.low) && $util.isInteger(message.testSetId.high)))
                                return "testSetId: integer|Long expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTestCasesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTestCasesRequest} ListTestCasesRequest
                     */
                    ListTestCasesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTestCasesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTestCasesRequest();
                        if (object.testSetId != null)
                            if ($util.Long)
                                (message.testSetId = $util.Long.fromValue(object.testSetId)).unsigned = false;
                            else if (typeof object.testSetId === "string")
                                message.testSetId = parseInt(object.testSetId, 10);
                            else if (typeof object.testSetId === "number")
                                message.testSetId = object.testSetId;
                            else if (typeof object.testSetId === "object")
                                message.testSetId = new $util.LongBits(object.testSetId.low >>> 0, object.testSetId.high >>> 0).toNumber();
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTestCasesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListTestCasesRequest} message ListTestCasesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTestCasesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testSetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testSetId = options.longs === String ? "0" : 0;
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.testSetId != null && message.hasOwnProperty("testSetId"))
                            if (typeof message.testSetId === "number")
                                object.testSetId = options.longs === String ? String(message.testSetId) : message.testSetId;
                            else
                                object.testSetId = options.longs === String ? $util.Long.prototype.toString.call(message.testSetId) : options.longs === Number ? new $util.LongBits(message.testSetId.low >>> 0, message.testSetId.high >>> 0).toNumber() : message.testSetId;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListTestCasesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTestCasesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTestCasesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTestCasesRequest;
                })();
    
                v1.ListTestCasesResponse = (function() {
    
                    /**
                     * Properties of a ListTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListTestCasesResponse
                     * @property {Array.<palexy.sherlock.v1.IExperimentTestCase>|null} [testCases] ListTestCasesResponse testCases
                     * @property {string|null} [nextPageToken] ListTestCasesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListTestCasesResponse.
                     * @implements IListTestCasesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListTestCasesResponse=} [properties] Properties to set
                     */
                    function ListTestCasesResponse(properties) {
                        this.testCases = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTestCasesResponse testCases.
                     * @member {Array.<palexy.sherlock.v1.IExperimentTestCase>} testCases
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @instance
                     */
                    ListTestCasesResponse.prototype.testCases = $util.emptyArray;
    
                    /**
                     * ListTestCasesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @instance
                     */
                    ListTestCasesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListTestCasesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListTestCasesResponse} ListTestCasesResponse instance
                     */
                    ListTestCasesResponse.create = function create(properties) {
                        return new ListTestCasesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTestCasesResponse message. Does not implicitly {@link palexy.sherlock.v1.ListTestCasesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesResponse} message ListTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestCasesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testCases != null && message.testCases.length)
                            for (var i = 0; i < message.testCases.length; ++i)
                                $root.palexy.sherlock.v1.ExperimentTestCase.encode(message.testCases[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTestCasesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListTestCasesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListTestCasesResponse} message ListTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTestCasesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTestCasesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListTestCasesResponse} ListTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestCasesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListTestCasesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.testCases && message.testCases.length))
                                    message.testCases = [];
                                message.testCases.push($root.palexy.sherlock.v1.ExperimentTestCase.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTestCasesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListTestCasesResponse} ListTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTestCasesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTestCasesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTestCasesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testCases != null && message.hasOwnProperty("testCases")) {
                            if (!Array.isArray(message.testCases))
                                return "testCases: array expected";
                            for (var i = 0; i < message.testCases.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ExperimentTestCase.verify(message.testCases[i]);
                                if (error)
                                    return "testCases." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTestCasesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListTestCasesResponse} ListTestCasesResponse
                     */
                    ListTestCasesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListTestCasesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListTestCasesResponse();
                        if (object.testCases) {
                            if (!Array.isArray(object.testCases))
                                throw TypeError(".palexy.sherlock.v1.ListTestCasesResponse.testCases: array expected");
                            message.testCases = [];
                            for (var i = 0; i < object.testCases.length; ++i) {
                                if (typeof object.testCases[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListTestCasesResponse.testCases: object expected");
                                message.testCases[i] = $root.palexy.sherlock.v1.ExperimentTestCase.fromObject(object.testCases[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTestCasesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListTestCasesResponse} message ListTestCasesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTestCasesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.testCases = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.testCases && message.testCases.length) {
                            object.testCases = [];
                            for (var j = 0; j < message.testCases.length; ++j)
                                object.testCases[j] = $root.palexy.sherlock.v1.ExperimentTestCase.toObject(message.testCases[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListTestCasesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListTestCasesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTestCasesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTestCasesResponse;
                })();
    
                v1.AddCacheItemRequest = (function() {
    
                    /**
                     * Properties of an AddCacheItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IAddCacheItemRequest
                     * @property {string|null} [cache] AddCacheItemRequest cache
                     * @property {palexy.sherlock.v1.IProcessingResultCacheItem|null} [cacheItem] AddCacheItemRequest cacheItem
                     * @property {Uint8Array|null} [fileContent] AddCacheItemRequest fileContent
                     */
    
                    /**
                     * Constructs a new AddCacheItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AddCacheItemRequest.
                     * @implements IAddCacheItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest=} [properties] Properties to set
                     */
                    function AddCacheItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AddCacheItemRequest cache.
                     * @member {string} cache
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @instance
                     */
                    AddCacheItemRequest.prototype.cache = "";
    
                    /**
                     * AddCacheItemRequest cacheItem.
                     * @member {palexy.sherlock.v1.IProcessingResultCacheItem|null|undefined} cacheItem
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @instance
                     */
                    AddCacheItemRequest.prototype.cacheItem = null;
    
                    /**
                     * AddCacheItemRequest fileContent.
                     * @member {Uint8Array} fileContent
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @instance
                     */
                    AddCacheItemRequest.prototype.fileContent = $util.newBuffer([]);
    
                    /**
                     * Creates a new AddCacheItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AddCacheItemRequest} AddCacheItemRequest instance
                     */
                    AddCacheItemRequest.create = function create(properties) {
                        return new AddCacheItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AddCacheItemRequest message. Does not implicitly {@link palexy.sherlock.v1.AddCacheItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest} message AddCacheItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCacheItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cache != null && Object.hasOwnProperty.call(message, "cache"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cache);
                        if (message.cacheItem != null && Object.hasOwnProperty.call(message, "cacheItem"))
                            $root.palexy.sherlock.v1.ProcessingResultCacheItem.encode(message.cacheItem, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.fileContent != null && Object.hasOwnProperty.call(message, "fileContent"))
                            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.fileContent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddCacheItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AddCacheItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemRequest} message AddCacheItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCacheItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddCacheItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AddCacheItemRequest} AddCacheItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCacheItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AddCacheItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cache = reader.string();
                                break;
                            case 2:
                                message.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.fileContent = reader.bytes();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddCacheItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AddCacheItemRequest} AddCacheItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCacheItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddCacheItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddCacheItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            if (!$util.isString(message.cache))
                                return "cache: string expected";
                        if (message.cacheItem != null && message.hasOwnProperty("cacheItem")) {
                            var error = $root.palexy.sherlock.v1.ProcessingResultCacheItem.verify(message.cacheItem);
                            if (error)
                                return "cacheItem." + error;
                        }
                        if (message.fileContent != null && message.hasOwnProperty("fileContent"))
                            if (!(message.fileContent && typeof message.fileContent.length === "number" || $util.isString(message.fileContent)))
                                return "fileContent: buffer expected";
                        return null;
                    };
    
                    /**
                     * Creates an AddCacheItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AddCacheItemRequest} AddCacheItemRequest
                     */
                    AddCacheItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AddCacheItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.AddCacheItemRequest();
                        if (object.cache != null)
                            message.cache = String(object.cache);
                        if (object.cacheItem != null) {
                            if (typeof object.cacheItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.AddCacheItemRequest.cacheItem: object expected");
                            message.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.fromObject(object.cacheItem);
                        }
                        if (object.fileContent != null)
                            if (typeof object.fileContent === "string")
                                $util.base64.decode(object.fileContent, message.fileContent = $util.newBuffer($util.base64.length(object.fileContent)), 0);
                            else if (object.fileContent.length)
                                message.fileContent = object.fileContent;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AddCacheItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.AddCacheItemRequest} message AddCacheItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddCacheItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cache = "";
                            object.cacheItem = null;
                            if (options.bytes === String)
                                object.fileContent = "";
                            else {
                                object.fileContent = [];
                                if (options.bytes !== Array)
                                    object.fileContent = $util.newBuffer(object.fileContent);
                            }
                        }
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            object.cache = message.cache;
                        if (message.cacheItem != null && message.hasOwnProperty("cacheItem"))
                            object.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.toObject(message.cacheItem, options);
                        if (message.fileContent != null && message.hasOwnProperty("fileContent"))
                            object.fileContent = options.bytes === String ? $util.base64.encode(message.fileContent, 0, message.fileContent.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileContent) : message.fileContent;
                        return object;
                    };
    
                    /**
                     * Converts this AddCacheItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AddCacheItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddCacheItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddCacheItemRequest;
                })();
    
                v1.AddCacheItemResponse = (function() {
    
                    /**
                     * Properties of an AddCacheItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IAddCacheItemResponse
                     * @property {palexy.sherlock.v1.IProcessingResultCacheItem|null} [cacheItem] AddCacheItemResponse cacheItem
                     */
    
                    /**
                     * Constructs a new AddCacheItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an AddCacheItemResponse.
                     * @implements IAddCacheItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IAddCacheItemResponse=} [properties] Properties to set
                     */
                    function AddCacheItemResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AddCacheItemResponse cacheItem.
                     * @member {palexy.sherlock.v1.IProcessingResultCacheItem|null|undefined} cacheItem
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @instance
                     */
                    AddCacheItemResponse.prototype.cacheItem = null;
    
                    /**
                     * Creates a new AddCacheItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.AddCacheItemResponse} AddCacheItemResponse instance
                     */
                    AddCacheItemResponse.create = function create(properties) {
                        return new AddCacheItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified AddCacheItemResponse message. Does not implicitly {@link palexy.sherlock.v1.AddCacheItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemResponse} message AddCacheItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCacheItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cacheItem != null && Object.hasOwnProperty.call(message, "cacheItem"))
                            $root.palexy.sherlock.v1.ProcessingResultCacheItem.encode(message.cacheItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddCacheItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.AddCacheItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IAddCacheItemResponse} message AddCacheItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCacheItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddCacheItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.AddCacheItemResponse} AddCacheItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCacheItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.AddCacheItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddCacheItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.AddCacheItemResponse} AddCacheItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCacheItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddCacheItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddCacheItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cacheItem != null && message.hasOwnProperty("cacheItem")) {
                            var error = $root.palexy.sherlock.v1.ProcessingResultCacheItem.verify(message.cacheItem);
                            if (error)
                                return "cacheItem." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AddCacheItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.AddCacheItemResponse} AddCacheItemResponse
                     */
                    AddCacheItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.AddCacheItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.AddCacheItemResponse();
                        if (object.cacheItem != null) {
                            if (typeof object.cacheItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.AddCacheItemResponse.cacheItem: object expected");
                            message.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.fromObject(object.cacheItem);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AddCacheItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.AddCacheItemResponse} message AddCacheItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddCacheItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cacheItem = null;
                        if (message.cacheItem != null && message.hasOwnProperty("cacheItem"))
                            object.cacheItem = $root.palexy.sherlock.v1.ProcessingResultCacheItem.toObject(message.cacheItem, options);
                        return object;
                    };
    
                    /**
                     * Converts this AddCacheItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.AddCacheItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddCacheItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddCacheItemResponse;
                })();
    
                v1.CreateCacheRequest = (function() {
    
                    /**
                     * Properties of a CreateCacheRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateCacheRequest
                     * @property {palexy.sherlock.v1.IProcessingResultCache|null} [cache] CreateCacheRequest cache
                     */
    
                    /**
                     * Constructs a new CreateCacheRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateCacheRequest.
                     * @implements ICreateCacheRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateCacheRequest=} [properties] Properties to set
                     */
                    function CreateCacheRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateCacheRequest cache.
                     * @member {palexy.sherlock.v1.IProcessingResultCache|null|undefined} cache
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @instance
                     */
                    CreateCacheRequest.prototype.cache = null;
    
                    /**
                     * Creates a new CreateCacheRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateCacheRequest} CreateCacheRequest instance
                     */
                    CreateCacheRequest.create = function create(properties) {
                        return new CreateCacheRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateCacheRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateCacheRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheRequest} message CreateCacheRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCacheRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cache != null && Object.hasOwnProperty.call(message, "cache"))
                            $root.palexy.sherlock.v1.ProcessingResultCache.encode(message.cache, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateCacheRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateCacheRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheRequest} message CreateCacheRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCacheRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateCacheRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateCacheRequest} CreateCacheRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCacheRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateCacheRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cache = $root.palexy.sherlock.v1.ProcessingResultCache.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateCacheRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateCacheRequest} CreateCacheRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCacheRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateCacheRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateCacheRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cache != null && message.hasOwnProperty("cache")) {
                            var error = $root.palexy.sherlock.v1.ProcessingResultCache.verify(message.cache);
                            if (error)
                                return "cache." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateCacheRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateCacheRequest} CreateCacheRequest
                     */
                    CreateCacheRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateCacheRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateCacheRequest();
                        if (object.cache != null) {
                            if (typeof object.cache !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateCacheRequest.cache: object expected");
                            message.cache = $root.palexy.sherlock.v1.ProcessingResultCache.fromObject(object.cache);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateCacheRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateCacheRequest} message CreateCacheRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateCacheRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cache = null;
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            object.cache = $root.palexy.sherlock.v1.ProcessingResultCache.toObject(message.cache, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateCacheRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateCacheRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateCacheRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateCacheRequest;
                })();
    
                v1.CreateCacheResponse = (function() {
    
                    /**
                     * Properties of a CreateCacheResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateCacheResponse
                     * @property {palexy.sherlock.v1.IProcessingResultCache|null} [cache] CreateCacheResponse cache
                     */
    
                    /**
                     * Constructs a new CreateCacheResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateCacheResponse.
                     * @implements ICreateCacheResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateCacheResponse=} [properties] Properties to set
                     */
                    function CreateCacheResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateCacheResponse cache.
                     * @member {palexy.sherlock.v1.IProcessingResultCache|null|undefined} cache
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @instance
                     */
                    CreateCacheResponse.prototype.cache = null;
    
                    /**
                     * Creates a new CreateCacheResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateCacheResponse} CreateCacheResponse instance
                     */
                    CreateCacheResponse.create = function create(properties) {
                        return new CreateCacheResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateCacheResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateCacheResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheResponse} message CreateCacheResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCacheResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cache != null && Object.hasOwnProperty.call(message, "cache"))
                            $root.palexy.sherlock.v1.ProcessingResultCache.encode(message.cache, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateCacheResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateCacheResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateCacheResponse} message CreateCacheResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCacheResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateCacheResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateCacheResponse} CreateCacheResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCacheResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateCacheResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cache = $root.palexy.sherlock.v1.ProcessingResultCache.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateCacheResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateCacheResponse} CreateCacheResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCacheResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateCacheResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateCacheResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cache != null && message.hasOwnProperty("cache")) {
                            var error = $root.palexy.sherlock.v1.ProcessingResultCache.verify(message.cache);
                            if (error)
                                return "cache." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateCacheResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateCacheResponse} CreateCacheResponse
                     */
                    CreateCacheResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateCacheResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateCacheResponse();
                        if (object.cache != null) {
                            if (typeof object.cache !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateCacheResponse.cache: object expected");
                            message.cache = $root.palexy.sherlock.v1.ProcessingResultCache.fromObject(object.cache);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateCacheResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateCacheResponse} message CreateCacheResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateCacheResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cache = null;
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            object.cache = $root.palexy.sherlock.v1.ProcessingResultCache.toObject(message.cache, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateCacheResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateCacheResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateCacheResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateCacheResponse;
                })();
    
                v1.ListCachesRequest = (function() {
    
                    /**
                     * Properties of a ListCachesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListCachesRequest
                     * @property {string|null} [pageToken] ListCachesRequest pageToken
                     * @property {number|null} [pageSize] ListCachesRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListCachesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListCachesRequest.
                     * @implements IListCachesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListCachesRequest=} [properties] Properties to set
                     */
                    function ListCachesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCachesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @instance
                     */
                    ListCachesRequest.prototype.pageToken = "";
    
                    /**
                     * ListCachesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @instance
                     */
                    ListCachesRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListCachesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListCachesRequest} ListCachesRequest instance
                     */
                    ListCachesRequest.create = function create(properties) {
                        return new ListCachesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCachesRequest message. Does not implicitly {@link palexy.sherlock.v1.ListCachesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesRequest} message ListCachesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCachesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCachesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListCachesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesRequest} message ListCachesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCachesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCachesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListCachesRequest} ListCachesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCachesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListCachesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageToken = reader.string();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCachesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListCachesRequest} ListCachesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCachesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCachesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCachesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCachesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListCachesRequest} ListCachesRequest
                     */
                    ListCachesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListCachesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListCachesRequest();
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCachesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListCachesRequest} message ListCachesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCachesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListCachesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListCachesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCachesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCachesRequest;
                })();
    
                v1.ListCachesResponse = (function() {
    
                    /**
                     * Properties of a ListCachesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListCachesResponse
                     * @property {Array.<palexy.sherlock.v1.IProcessingResultCache>|null} [caches] ListCachesResponse caches
                     * @property {string|null} [nextPageToken] ListCachesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListCachesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListCachesResponse.
                     * @implements IListCachesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListCachesResponse=} [properties] Properties to set
                     */
                    function ListCachesResponse(properties) {
                        this.caches = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCachesResponse caches.
                     * @member {Array.<palexy.sherlock.v1.IProcessingResultCache>} caches
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @instance
                     */
                    ListCachesResponse.prototype.caches = $util.emptyArray;
    
                    /**
                     * ListCachesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @instance
                     */
                    ListCachesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListCachesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListCachesResponse} ListCachesResponse instance
                     */
                    ListCachesResponse.create = function create(properties) {
                        return new ListCachesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCachesResponse message. Does not implicitly {@link palexy.sherlock.v1.ListCachesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesResponse} message ListCachesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCachesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.caches != null && message.caches.length)
                            for (var i = 0; i < message.caches.length; ++i)
                                $root.palexy.sherlock.v1.ProcessingResultCache.encode(message.caches[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCachesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListCachesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListCachesResponse} message ListCachesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCachesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCachesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListCachesResponse} ListCachesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCachesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListCachesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.caches && message.caches.length))
                                    message.caches = [];
                                message.caches.push($root.palexy.sherlock.v1.ProcessingResultCache.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCachesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListCachesResponse} ListCachesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCachesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCachesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCachesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.caches != null && message.hasOwnProperty("caches")) {
                            if (!Array.isArray(message.caches))
                                return "caches: array expected";
                            for (var i = 0; i < message.caches.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ProcessingResultCache.verify(message.caches[i]);
                                if (error)
                                    return "caches." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCachesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListCachesResponse} ListCachesResponse
                     */
                    ListCachesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListCachesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListCachesResponse();
                        if (object.caches) {
                            if (!Array.isArray(object.caches))
                                throw TypeError(".palexy.sherlock.v1.ListCachesResponse.caches: array expected");
                            message.caches = [];
                            for (var i = 0; i < object.caches.length; ++i) {
                                if (typeof object.caches[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListCachesResponse.caches: object expected");
                                message.caches[i] = $root.palexy.sherlock.v1.ProcessingResultCache.fromObject(object.caches[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCachesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListCachesResponse} message ListCachesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCachesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.caches = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.caches && message.caches.length) {
                            object.caches = [];
                            for (var j = 0; j < message.caches.length; ++j)
                                object.caches[j] = $root.palexy.sherlock.v1.ProcessingResultCache.toObject(message.caches[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCachesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListCachesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCachesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCachesResponse;
                })();
    
                v1.ProcessingResultCache = (function() {
    
                    /**
                     * Properties of a ProcessingResultCache.
                     * @memberof palexy.sherlock.v1
                     * @interface IProcessingResultCache
                     * @property {number|null} [id] ProcessingResultCache id
                     * @property {string|null} [name] ProcessingResultCache name
                     * @property {string|null} [displayName] ProcessingResultCache displayName
                     * @property {string|null} [cacheAgeGroupGenderVersion] ProcessingResultCache cacheAgeGroupGenderVersion
                     * @property {string|null} [cacheYoloVersion] ProcessingResultCache cacheYoloVersion
                     * @property {string|null} [cacheReidVersion] ProcessingResultCache cacheReidVersion
                     * @property {number|null} [createTimeMs] ProcessingResultCache createTimeMs
                     */
    
                    /**
                     * Constructs a new ProcessingResultCache.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ProcessingResultCache.
                     * @implements IProcessingResultCache
                     * @constructor
                     * @param {palexy.sherlock.v1.IProcessingResultCache=} [properties] Properties to set
                     */
                    function ProcessingResultCache(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProcessingResultCache id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProcessingResultCache name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.name = "";
    
                    /**
                     * ProcessingResultCache displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.displayName = "";
    
                    /**
                     * ProcessingResultCache cacheAgeGroupGenderVersion.
                     * @member {string} cacheAgeGroupGenderVersion
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.cacheAgeGroupGenderVersion = "";
    
                    /**
                     * ProcessingResultCache cacheYoloVersion.
                     * @member {string} cacheYoloVersion
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.cacheYoloVersion = "";
    
                    /**
                     * ProcessingResultCache cacheReidVersion.
                     * @member {string} cacheReidVersion
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.cacheReidVersion = "";
    
                    /**
                     * ProcessingResultCache createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     */
                    ProcessingResultCache.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ProcessingResultCache instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCache=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ProcessingResultCache} ProcessingResultCache instance
                     */
                    ProcessingResultCache.create = function create(properties) {
                        return new ProcessingResultCache(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessingResultCache message. Does not implicitly {@link palexy.sherlock.v1.ProcessingResultCache.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCache} message ProcessingResultCache message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessingResultCache.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.displayName);
                        if (message.cacheAgeGroupGenderVersion != null && Object.hasOwnProperty.call(message, "cacheAgeGroupGenderVersion"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.cacheAgeGroupGenderVersion);
                        if (message.cacheYoloVersion != null && Object.hasOwnProperty.call(message, "cacheYoloVersion"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.cacheYoloVersion);
                        if (message.cacheReidVersion != null && Object.hasOwnProperty.call(message, "cacheReidVersion"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.cacheReidVersion);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessingResultCache message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ProcessingResultCache.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCache} message ProcessingResultCache message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessingResultCache.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessingResultCache message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ProcessingResultCache} ProcessingResultCache
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessingResultCache.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ProcessingResultCache();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.displayName = reader.string();
                                break;
                            case 4:
                                message.cacheAgeGroupGenderVersion = reader.string();
                                break;
                            case 5:
                                message.cacheYoloVersion = reader.string();
                                break;
                            case 6:
                                message.cacheReidVersion = reader.string();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessingResultCache message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ProcessingResultCache} ProcessingResultCache
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessingResultCache.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessingResultCache message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessingResultCache.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.cacheAgeGroupGenderVersion != null && message.hasOwnProperty("cacheAgeGroupGenderVersion"))
                            if (!$util.isString(message.cacheAgeGroupGenderVersion))
                                return "cacheAgeGroupGenderVersion: string expected";
                        if (message.cacheYoloVersion != null && message.hasOwnProperty("cacheYoloVersion"))
                            if (!$util.isString(message.cacheYoloVersion))
                                return "cacheYoloVersion: string expected";
                        if (message.cacheReidVersion != null && message.hasOwnProperty("cacheReidVersion"))
                            if (!$util.isString(message.cacheReidVersion))
                                return "cacheReidVersion: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessingResultCache message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ProcessingResultCache} ProcessingResultCache
                     */
                    ProcessingResultCache.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ProcessingResultCache)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ProcessingResultCache();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.cacheAgeGroupGenderVersion != null)
                            message.cacheAgeGroupGenderVersion = String(object.cacheAgeGroupGenderVersion);
                        if (object.cacheYoloVersion != null)
                            message.cacheYoloVersion = String(object.cacheYoloVersion);
                        if (object.cacheReidVersion != null)
                            message.cacheReidVersion = String(object.cacheReidVersion);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProcessingResultCache message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @static
                     * @param {palexy.sherlock.v1.ProcessingResultCache} message ProcessingResultCache
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessingResultCache.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.displayName = "";
                            object.cacheAgeGroupGenderVersion = "";
                            object.cacheYoloVersion = "";
                            object.cacheReidVersion = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.cacheAgeGroupGenderVersion != null && message.hasOwnProperty("cacheAgeGroupGenderVersion"))
                            object.cacheAgeGroupGenderVersion = message.cacheAgeGroupGenderVersion;
                        if (message.cacheYoloVersion != null && message.hasOwnProperty("cacheYoloVersion"))
                            object.cacheYoloVersion = message.cacheYoloVersion;
                        if (message.cacheReidVersion != null && message.hasOwnProperty("cacheReidVersion"))
                            object.cacheReidVersion = message.cacheReidVersion;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ProcessingResultCache to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ProcessingResultCache
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessingResultCache.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessingResultCache;
                })();
    
                v1.ProcessingResultCacheItem = (function() {
    
                    /**
                     * Properties of a ProcessingResultCacheItem.
                     * @memberof palexy.sherlock.v1
                     * @interface IProcessingResultCacheItem
                     * @property {number|null} [id] ProcessingResultCacheItem id
                     * @property {string|null} [name] ProcessingResultCacheItem name
                     * @property {string|null} [originalFileName] ProcessingResultCacheItem originalFileName
                     * @property {string|null} [fileName] ProcessingResultCacheItem fileName
                     * @property {string|null} [bucket] ProcessingResultCacheItem bucket
                     * @property {string|null} [cloudProvider] ProcessingResultCacheItem cloudProvider
                     * @property {number|null} [createTimeMs] ProcessingResultCacheItem createTimeMs
                     * @property {number|null} [cacheId] ProcessingResultCacheItem cacheId
                     */
    
                    /**
                     * Constructs a new ProcessingResultCacheItem.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ProcessingResultCacheItem.
                     * @implements IProcessingResultCacheItem
                     * @constructor
                     * @param {palexy.sherlock.v1.IProcessingResultCacheItem=} [properties] Properties to set
                     */
                    function ProcessingResultCacheItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProcessingResultCacheItem id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProcessingResultCacheItem name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.name = "";
    
                    /**
                     * ProcessingResultCacheItem originalFileName.
                     * @member {string} originalFileName
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.originalFileName = "";
    
                    /**
                     * ProcessingResultCacheItem fileName.
                     * @member {string} fileName
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.fileName = "";
    
                    /**
                     * ProcessingResultCacheItem bucket.
                     * @member {string} bucket
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.bucket = "";
    
                    /**
                     * ProcessingResultCacheItem cloudProvider.
                     * @member {string} cloudProvider
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.cloudProvider = "";
    
                    /**
                     * ProcessingResultCacheItem createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProcessingResultCacheItem cacheId.
                     * @member {number} cacheId
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     */
                    ProcessingResultCacheItem.prototype.cacheId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ProcessingResultCacheItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCacheItem=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ProcessingResultCacheItem} ProcessingResultCacheItem instance
                     */
                    ProcessingResultCacheItem.create = function create(properties) {
                        return new ProcessingResultCacheItem(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessingResultCacheItem message. Does not implicitly {@link palexy.sherlock.v1.ProcessingResultCacheItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCacheItem} message ProcessingResultCacheItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessingResultCacheItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.originalFileName != null && Object.hasOwnProperty.call(message, "originalFileName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.originalFileName);
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fileName);
                        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.bucket);
                        if (message.cloudProvider != null && Object.hasOwnProperty.call(message, "cloudProvider"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.cloudProvider);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.cacheId != null && Object.hasOwnProperty.call(message, "cacheId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.cacheId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessingResultCacheItem message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ProcessingResultCacheItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {palexy.sherlock.v1.IProcessingResultCacheItem} message ProcessingResultCacheItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessingResultCacheItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessingResultCacheItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ProcessingResultCacheItem} ProcessingResultCacheItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessingResultCacheItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ProcessingResultCacheItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.originalFileName = reader.string();
                                break;
                            case 4:
                                message.fileName = reader.string();
                                break;
                            case 5:
                                message.bucket = reader.string();
                                break;
                            case 6:
                                message.cloudProvider = reader.string();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.cacheId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessingResultCacheItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ProcessingResultCacheItem} ProcessingResultCacheItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessingResultCacheItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessingResultCacheItem message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessingResultCacheItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.originalFileName != null && message.hasOwnProperty("originalFileName"))
                            if (!$util.isString(message.originalFileName))
                                return "originalFileName: string expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            if (!$util.isString(message.bucket))
                                return "bucket: string expected";
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            if (!$util.isString(message.cloudProvider))
                                return "cloudProvider: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.cacheId != null && message.hasOwnProperty("cacheId"))
                            if (!$util.isInteger(message.cacheId) && !(message.cacheId && $util.isInteger(message.cacheId.low) && $util.isInteger(message.cacheId.high)))
                                return "cacheId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessingResultCacheItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ProcessingResultCacheItem} ProcessingResultCacheItem
                     */
                    ProcessingResultCacheItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ProcessingResultCacheItem)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ProcessingResultCacheItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.originalFileName != null)
                            message.originalFileName = String(object.originalFileName);
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        if (object.bucket != null)
                            message.bucket = String(object.bucket);
                        if (object.cloudProvider != null)
                            message.cloudProvider = String(object.cloudProvider);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.cacheId != null)
                            if ($util.Long)
                                (message.cacheId = $util.Long.fromValue(object.cacheId)).unsigned = false;
                            else if (typeof object.cacheId === "string")
                                message.cacheId = parseInt(object.cacheId, 10);
                            else if (typeof object.cacheId === "number")
                                message.cacheId = object.cacheId;
                            else if (typeof object.cacheId === "object")
                                message.cacheId = new $util.LongBits(object.cacheId.low >>> 0, object.cacheId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProcessingResultCacheItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @static
                     * @param {palexy.sherlock.v1.ProcessingResultCacheItem} message ProcessingResultCacheItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessingResultCacheItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.originalFileName = "";
                            object.fileName = "";
                            object.bucket = "";
                            object.cloudProvider = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cacheId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cacheId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.originalFileName != null && message.hasOwnProperty("originalFileName"))
                            object.originalFileName = message.originalFileName;
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            object.bucket = message.bucket;
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            object.cloudProvider = message.cloudProvider;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.cacheId != null && message.hasOwnProperty("cacheId"))
                            if (typeof message.cacheId === "number")
                                object.cacheId = options.longs === String ? String(message.cacheId) : message.cacheId;
                            else
                                object.cacheId = options.longs === String ? $util.Long.prototype.toString.call(message.cacheId) : options.longs === Number ? new $util.LongBits(message.cacheId.low >>> 0, message.cacheId.high >>> 0).toNumber() : message.cacheId;
                        return object;
                    };
    
                    /**
                     * Converts this ProcessingResultCacheItem to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ProcessingResultCacheItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessingResultCacheItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessingResultCacheItem;
                })();
    
                v1.FindCacheItemByFileNameRequest = (function() {
    
                    /**
                     * Properties of a FindCacheItemByFileNameRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IFindCacheItemByFileNameRequest
                     * @property {string|null} [cache] FindCacheItemByFileNameRequest cache
                     * @property {string|null} [fileName] FindCacheItemByFileNameRequest fileName
                     */
    
                    /**
                     * Constructs a new FindCacheItemByFileNameRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FindCacheItemByFileNameRequest.
                     * @implements IFindCacheItemByFileNameRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest=} [properties] Properties to set
                     */
                    function FindCacheItemByFileNameRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCacheItemByFileNameRequest cache.
                     * @member {string} cache
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @instance
                     */
                    FindCacheItemByFileNameRequest.prototype.cache = "";
    
                    /**
                     * FindCacheItemByFileNameRequest fileName.
                     * @member {string} fileName
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @instance
                     */
                    FindCacheItemByFileNameRequest.prototype.fileName = "";
    
                    /**
                     * Creates a new FindCacheItemByFileNameRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameRequest} FindCacheItemByFileNameRequest instance
                     */
                    FindCacheItemByFileNameRequest.create = function create(properties) {
                        return new FindCacheItemByFileNameRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindCacheItemByFileNameRequest message. Does not implicitly {@link palexy.sherlock.v1.FindCacheItemByFileNameRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest} message FindCacheItemByFileNameRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCacheItemByFileNameRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cache != null && Object.hasOwnProperty.call(message, "cache"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cache);
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fileName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCacheItemByFileNameRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FindCacheItemByFileNameRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameRequest} message FindCacheItemByFileNameRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCacheItemByFileNameRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCacheItemByFileNameRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameRequest} FindCacheItemByFileNameRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCacheItemByFileNameRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FindCacheItemByFileNameRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cache = reader.string();
                                break;
                            case 2:
                                message.fileName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCacheItemByFileNameRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameRequest} FindCacheItemByFileNameRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCacheItemByFileNameRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCacheItemByFileNameRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCacheItemByFileNameRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            if (!$util.isString(message.cache))
                                return "cache: string expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindCacheItemByFileNameRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameRequest} FindCacheItemByFileNameRequest
                     */
                    FindCacheItemByFileNameRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FindCacheItemByFileNameRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FindCacheItemByFileNameRequest();
                        if (object.cache != null)
                            message.cache = String(object.cache);
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCacheItemByFileNameRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @static
                     * @param {palexy.sherlock.v1.FindCacheItemByFileNameRequest} message FindCacheItemByFileNameRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCacheItemByFileNameRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cache = "";
                            object.fileName = "";
                        }
                        if (message.cache != null && message.hasOwnProperty("cache"))
                            object.cache = message.cache;
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        return object;
                    };
    
                    /**
                     * Converts this FindCacheItemByFileNameRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCacheItemByFileNameRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindCacheItemByFileNameRequest;
                })();
    
                v1.FindCacheItemByFileNameResponse = (function() {
    
                    /**
                     * Properties of a FindCacheItemByFileNameResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IFindCacheItemByFileNameResponse
                     * @property {palexy.sherlock.v1.IProcessingResultCacheItem|null} [item] FindCacheItemByFileNameResponse item
                     */
    
                    /**
                     * Constructs a new FindCacheItemByFileNameResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FindCacheItemByFileNameResponse.
                     * @implements IFindCacheItemByFileNameResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameResponse=} [properties] Properties to set
                     */
                    function FindCacheItemByFileNameResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCacheItemByFileNameResponse item.
                     * @member {palexy.sherlock.v1.IProcessingResultCacheItem|null|undefined} item
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @instance
                     */
                    FindCacheItemByFileNameResponse.prototype.item = null;
    
                    /**
                     * Creates a new FindCacheItemByFileNameResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameResponse} FindCacheItemByFileNameResponse instance
                     */
                    FindCacheItemByFileNameResponse.create = function create(properties) {
                        return new FindCacheItemByFileNameResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FindCacheItemByFileNameResponse message. Does not implicitly {@link palexy.sherlock.v1.FindCacheItemByFileNameResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameResponse} message FindCacheItemByFileNameResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCacheItemByFileNameResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                            $root.palexy.sherlock.v1.ProcessingResultCacheItem.encode(message.item, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCacheItemByFileNameResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FindCacheItemByFileNameResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFindCacheItemByFileNameResponse} message FindCacheItemByFileNameResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCacheItemByFileNameResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCacheItemByFileNameResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameResponse} FindCacheItemByFileNameResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCacheItemByFileNameResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FindCacheItemByFileNameResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.item = $root.palexy.sherlock.v1.ProcessingResultCacheItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCacheItemByFileNameResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameResponse} FindCacheItemByFileNameResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCacheItemByFileNameResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCacheItemByFileNameResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCacheItemByFileNameResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.item != null && message.hasOwnProperty("item")) {
                            var error = $root.palexy.sherlock.v1.ProcessingResultCacheItem.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FindCacheItemByFileNameResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FindCacheItemByFileNameResponse} FindCacheItemByFileNameResponse
                     */
                    FindCacheItemByFileNameResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FindCacheItemByFileNameResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FindCacheItemByFileNameResponse();
                        if (object.item != null) {
                            if (typeof object.item !== "object")
                                throw TypeError(".palexy.sherlock.v1.FindCacheItemByFileNameResponse.item: object expected");
                            message.item = $root.palexy.sherlock.v1.ProcessingResultCacheItem.fromObject(object.item);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCacheItemByFileNameResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @static
                     * @param {palexy.sherlock.v1.FindCacheItemByFileNameResponse} message FindCacheItemByFileNameResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCacheItemByFileNameResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.item = null;
                        if (message.item != null && message.hasOwnProperty("item"))
                            object.item = $root.palexy.sherlock.v1.ProcessingResultCacheItem.toObject(message.item, options);
                        return object;
                    };
    
                    /**
                     * Converts this FindCacheItemByFileNameResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FindCacheItemByFileNameResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCacheItemByFileNameResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindCacheItemByFileNameResponse;
                })();
    
                v1.CreateExperimentRequest = (function() {
    
                    /**
                     * Properties of a CreateExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateExperimentRequest
                     * @property {palexy.sherlock.v1.IExperiment|null} [experiment] CreateExperimentRequest experiment
                     * @property {Array.<number>|null} [testCaseIds] CreateExperimentRequest testCaseIds
                     * @property {number|null} [testSetId] CreateExperimentRequest testSetId
                     */
    
                    /**
                     * Constructs a new CreateExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateExperimentRequest.
                     * @implements ICreateExperimentRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest=} [properties] Properties to set
                     */
                    function CreateExperimentRequest(properties) {
                        this.testCaseIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateExperimentRequest experiment.
                     * @member {palexy.sherlock.v1.IExperiment|null|undefined} experiment
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @instance
                     */
                    CreateExperimentRequest.prototype.experiment = null;
    
                    /**
                     * CreateExperimentRequest testCaseIds.
                     * @member {Array.<number>} testCaseIds
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @instance
                     */
                    CreateExperimentRequest.prototype.testCaseIds = $util.emptyArray;
    
                    /**
                     * CreateExperimentRequest testSetId.
                     * @member {number} testSetId
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @instance
                     */
                    CreateExperimentRequest.prototype.testSetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CreateExperimentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateExperimentRequest} CreateExperimentRequest instance
                     */
                    CreateExperimentRequest.create = function create(properties) {
                        return new CreateExperimentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateExperimentRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest} message CreateExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiment != null && Object.hasOwnProperty.call(message, "experiment"))
                            $root.palexy.sherlock.v1.Experiment.encode(message.experiment, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.testCaseIds != null && message.testCaseIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.testCaseIds.length; ++i)
                                writer.int64(message.testCaseIds[i]);
                            writer.ldelim();
                        }
                        if (message.testSetId != null && Object.hasOwnProperty.call(message, "testSetId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.testSetId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateExperimentRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentRequest} message CreateExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateExperimentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateExperimentRequest} CreateExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateExperimentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experiment = $root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.testCaseIds && message.testCaseIds.length))
                                    message.testCaseIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.testCaseIds.push(reader.int64());
                                } else
                                    message.testCaseIds.push(reader.int64());
                                break;
                            case 3:
                                message.testSetId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateExperimentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateExperimentRequest} CreateExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateExperimentRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateExperimentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiment != null && message.hasOwnProperty("experiment")) {
                            var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiment);
                            if (error)
                                return "experiment." + error;
                        }
                        if (message.testCaseIds != null && message.hasOwnProperty("testCaseIds")) {
                            if (!Array.isArray(message.testCaseIds))
                                return "testCaseIds: array expected";
                            for (var i = 0; i < message.testCaseIds.length; ++i)
                                if (!$util.isInteger(message.testCaseIds[i]) && !(message.testCaseIds[i] && $util.isInteger(message.testCaseIds[i].low) && $util.isInteger(message.testCaseIds[i].high)))
                                    return "testCaseIds: integer|Long[] expected";
                        }
                        if (message.testSetId != null && message.hasOwnProperty("testSetId"))
                            if (!$util.isInteger(message.testSetId) && !(message.testSetId && $util.isInteger(message.testSetId.low) && $util.isInteger(message.testSetId.high)))
                                return "testSetId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateExperimentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateExperimentRequest} CreateExperimentRequest
                     */
                    CreateExperimentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateExperimentRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateExperimentRequest();
                        if (object.experiment != null) {
                            if (typeof object.experiment !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateExperimentRequest.experiment: object expected");
                            message.experiment = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiment);
                        }
                        if (object.testCaseIds) {
                            if (!Array.isArray(object.testCaseIds))
                                throw TypeError(".palexy.sherlock.v1.CreateExperimentRequest.testCaseIds: array expected");
                            message.testCaseIds = [];
                            for (var i = 0; i < object.testCaseIds.length; ++i)
                                if ($util.Long)
                                    (message.testCaseIds[i] = $util.Long.fromValue(object.testCaseIds[i])).unsigned = false;
                                else if (typeof object.testCaseIds[i] === "string")
                                    message.testCaseIds[i] = parseInt(object.testCaseIds[i], 10);
                                else if (typeof object.testCaseIds[i] === "number")
                                    message.testCaseIds[i] = object.testCaseIds[i];
                                else if (typeof object.testCaseIds[i] === "object")
                                    message.testCaseIds[i] = new $util.LongBits(object.testCaseIds[i].low >>> 0, object.testCaseIds[i].high >>> 0).toNumber();
                        }
                        if (object.testSetId != null)
                            if ($util.Long)
                                (message.testSetId = $util.Long.fromValue(object.testSetId)).unsigned = false;
                            else if (typeof object.testSetId === "string")
                                message.testSetId = parseInt(object.testSetId, 10);
                            else if (typeof object.testSetId === "number")
                                message.testSetId = object.testSetId;
                            else if (typeof object.testSetId === "object")
                                message.testSetId = new $util.LongBits(object.testSetId.low >>> 0, object.testSetId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateExperimentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateExperimentRequest} message CreateExperimentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateExperimentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.testCaseIds = [];
                        if (options.defaults) {
                            object.experiment = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testSetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testSetId = options.longs === String ? "0" : 0;
                        }
                        if (message.experiment != null && message.hasOwnProperty("experiment"))
                            object.experiment = $root.palexy.sherlock.v1.Experiment.toObject(message.experiment, options);
                        if (message.testCaseIds && message.testCaseIds.length) {
                            object.testCaseIds = [];
                            for (var j = 0; j < message.testCaseIds.length; ++j)
                                if (typeof message.testCaseIds[j] === "number")
                                    object.testCaseIds[j] = options.longs === String ? String(message.testCaseIds[j]) : message.testCaseIds[j];
                                else
                                    object.testCaseIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.testCaseIds[j]) : options.longs === Number ? new $util.LongBits(message.testCaseIds[j].low >>> 0, message.testCaseIds[j].high >>> 0).toNumber() : message.testCaseIds[j];
                        }
                        if (message.testSetId != null && message.hasOwnProperty("testSetId"))
                            if (typeof message.testSetId === "number")
                                object.testSetId = options.longs === String ? String(message.testSetId) : message.testSetId;
                            else
                                object.testSetId = options.longs === String ? $util.Long.prototype.toString.call(message.testSetId) : options.longs === Number ? new $util.LongBits(message.testSetId.low >>> 0, message.testSetId.high >>> 0).toNumber() : message.testSetId;
                        return object;
                    };
    
                    /**
                     * Converts this CreateExperimentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateExperimentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateExperimentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateExperimentRequest;
                })();
    
                v1.CreateExperimentResponse = (function() {
    
                    /**
                     * Properties of a CreateExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateExperimentResponse
                     * @property {palexy.sherlock.v1.IExperiment|null} [experiment] CreateExperimentResponse experiment
                     */
    
                    /**
                     * Constructs a new CreateExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateExperimentResponse.
                     * @implements ICreateExperimentResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateExperimentResponse=} [properties] Properties to set
                     */
                    function CreateExperimentResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateExperimentResponse experiment.
                     * @member {palexy.sherlock.v1.IExperiment|null|undefined} experiment
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @instance
                     */
                    CreateExperimentResponse.prototype.experiment = null;
    
                    /**
                     * Creates a new CreateExperimentResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateExperimentResponse} CreateExperimentResponse instance
                     */
                    CreateExperimentResponse.create = function create(properties) {
                        return new CreateExperimentResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateExperimentResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentResponse} message CreateExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiment != null && Object.hasOwnProperty.call(message, "experiment"))
                            $root.palexy.sherlock.v1.Experiment.encode(message.experiment, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateExperimentResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentResponse} message CreateExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateExperimentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateExperimentResponse} CreateExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateExperimentResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experiment = $root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateExperimentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateExperimentResponse} CreateExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateExperimentResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateExperimentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiment != null && message.hasOwnProperty("experiment")) {
                            var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiment);
                            if (error)
                                return "experiment." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateExperimentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateExperimentResponse} CreateExperimentResponse
                     */
                    CreateExperimentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateExperimentResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateExperimentResponse();
                        if (object.experiment != null) {
                            if (typeof object.experiment !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateExperimentResponse.experiment: object expected");
                            message.experiment = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiment);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateExperimentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateExperimentResponse} message CreateExperimentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateExperimentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experiment = null;
                        if (message.experiment != null && message.hasOwnProperty("experiment"))
                            object.experiment = $root.palexy.sherlock.v1.Experiment.toObject(message.experiment, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateExperimentResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateExperimentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateExperimentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateExperimentResponse;
                })();
    
                v1.Experiment = (function() {
    
                    /**
                     * Properties of an Experiment.
                     * @memberof palexy.sherlock.v1
                     * @interface IExperiment
                     * @property {string|null} [programmaticName] Experiment programmaticName
                     * @property {string|null} [name] Experiment name
                     * @property {string|null} [description] Experiment description
                     * @property {string|null} [videoProcessorVersion] Experiment videoProcessorVersion
                     * @property {string|null} [trackingProcessorVersion] Experiment trackingProcessorVersion
                     * @property {string|null} [mergingProcessorVersion] Experiment mergingProcessorVersion
                     * @property {string|null} [cacheAgeGroupGenderVersion] Experiment cacheAgeGroupGenderVersion
                     * @property {string|null} [cacheYoloVersion] Experiment cacheYoloVersion
                     * @property {string|null} [cacheReidVersion] Experiment cacheReidVersion
                     * @property {palexy.sherlock.v1.IEnvironmentKVList|null} [processingEnvironmentKvs] Experiment processingEnvironmentKvs
                     * @property {palexy.sherlock.v1.IEnvironmentKVList|null} [trackingEnvironmentKvs] Experiment trackingEnvironmentKvs
                     * @property {palexy.sherlock.v1.IEnvironmentKVList|null} [mergingEnvironmentKvs] Experiment mergingEnvironmentKvs
                     * @property {number|null} [overrideMergingSingleCameraThreshold] Experiment overrideMergingSingleCameraThreshold
                     * @property {number|null} [overrideMergingCrossCameraThreshold] Experiment overrideMergingCrossCameraThreshold
                     * @property {number|null} [cacheId] Experiment cacheId
                     * @property {palexy.sherlock.v1.Experiment.ExperimentState|null} [state] Experiment state
                     * @property {number|null} [createTimeMs] Experiment createTimeMs
                     * @property {number|null} [updateTimeMs] Experiment updateTimeMs
                     */
    
                    /**
                     * Constructs a new Experiment.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an Experiment.
                     * @implements IExperiment
                     * @constructor
                     * @param {palexy.sherlock.v1.IExperiment=} [properties] Properties to set
                     */
                    function Experiment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Experiment programmaticName.
                     * @member {string} programmaticName
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.programmaticName = "";
    
                    /**
                     * Experiment name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.name = "";
    
                    /**
                     * Experiment description.
                     * @member {string} description
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.description = "";
    
                    /**
                     * Experiment videoProcessorVersion.
                     * @member {string} videoProcessorVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.videoProcessorVersion = "";
    
                    /**
                     * Experiment trackingProcessorVersion.
                     * @member {string} trackingProcessorVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.trackingProcessorVersion = "";
    
                    /**
                     * Experiment mergingProcessorVersion.
                     * @member {string} mergingProcessorVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.mergingProcessorVersion = "";
    
                    /**
                     * Experiment cacheAgeGroupGenderVersion.
                     * @member {string} cacheAgeGroupGenderVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.cacheAgeGroupGenderVersion = "";
    
                    /**
                     * Experiment cacheYoloVersion.
                     * @member {string} cacheYoloVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.cacheYoloVersion = "";
    
                    /**
                     * Experiment cacheReidVersion.
                     * @member {string} cacheReidVersion
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.cacheReidVersion = "";
    
                    /**
                     * Experiment processingEnvironmentKvs.
                     * @member {palexy.sherlock.v1.IEnvironmentKVList|null|undefined} processingEnvironmentKvs
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.processingEnvironmentKvs = null;
    
                    /**
                     * Experiment trackingEnvironmentKvs.
                     * @member {palexy.sherlock.v1.IEnvironmentKVList|null|undefined} trackingEnvironmentKvs
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.trackingEnvironmentKvs = null;
    
                    /**
                     * Experiment mergingEnvironmentKvs.
                     * @member {palexy.sherlock.v1.IEnvironmentKVList|null|undefined} mergingEnvironmentKvs
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.mergingEnvironmentKvs = null;
    
                    /**
                     * Experiment overrideMergingSingleCameraThreshold.
                     * @member {number} overrideMergingSingleCameraThreshold
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.overrideMergingSingleCameraThreshold = 0;
    
                    /**
                     * Experiment overrideMergingCrossCameraThreshold.
                     * @member {number} overrideMergingCrossCameraThreshold
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.overrideMergingCrossCameraThreshold = 0;
    
                    /**
                     * Experiment cacheId.
                     * @member {number} cacheId
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.cacheId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Experiment state.
                     * @member {palexy.sherlock.v1.Experiment.ExperimentState} state
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.state = 0;
    
                    /**
                     * Experiment createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Experiment updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     */
                    Experiment.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new Experiment instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {palexy.sherlock.v1.IExperiment=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.Experiment} Experiment instance
                     */
                    Experiment.create = function create(properties) {
                        return new Experiment(properties);
                    };
    
                    /**
                     * Encodes the specified Experiment message. Does not implicitly {@link palexy.sherlock.v1.Experiment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {palexy.sherlock.v1.IExperiment} message Experiment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Experiment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.programmaticName != null && Object.hasOwnProperty.call(message, "programmaticName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.programmaticName);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.videoProcessorVersion != null && Object.hasOwnProperty.call(message, "videoProcessorVersion"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.videoProcessorVersion);
                        if (message.trackingProcessorVersion != null && Object.hasOwnProperty.call(message, "trackingProcessorVersion"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.trackingProcessorVersion);
                        if (message.mergingProcessorVersion != null && Object.hasOwnProperty.call(message, "mergingProcessorVersion"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.mergingProcessorVersion);
                        if (message.cacheAgeGroupGenderVersion != null && Object.hasOwnProperty.call(message, "cacheAgeGroupGenderVersion"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.cacheAgeGroupGenderVersion);
                        if (message.cacheYoloVersion != null && Object.hasOwnProperty.call(message, "cacheYoloVersion"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.cacheYoloVersion);
                        if (message.cacheReidVersion != null && Object.hasOwnProperty.call(message, "cacheReidVersion"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.cacheReidVersion);
                        if (message.processingEnvironmentKvs != null && Object.hasOwnProperty.call(message, "processingEnvironmentKvs"))
                            $root.palexy.sherlock.v1.EnvironmentKVList.encode(message.processingEnvironmentKvs, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.trackingEnvironmentKvs != null && Object.hasOwnProperty.call(message, "trackingEnvironmentKvs"))
                            $root.palexy.sherlock.v1.EnvironmentKVList.encode(message.trackingEnvironmentKvs, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.mergingEnvironmentKvs != null && Object.hasOwnProperty.call(message, "mergingEnvironmentKvs"))
                            $root.palexy.sherlock.v1.EnvironmentKVList.encode(message.mergingEnvironmentKvs, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.overrideMergingSingleCameraThreshold != null && Object.hasOwnProperty.call(message, "overrideMergingSingleCameraThreshold"))
                            writer.uint32(/* id 13, wireType 5 =*/109).float(message.overrideMergingSingleCameraThreshold);
                        if (message.overrideMergingCrossCameraThreshold != null && Object.hasOwnProperty.call(message, "overrideMergingCrossCameraThreshold"))
                            writer.uint32(/* id 14, wireType 5 =*/117).float(message.overrideMergingCrossCameraThreshold);
                        if (message.cacheId != null && Object.hasOwnProperty.call(message, "cacheId"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int64(message.cacheId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.state);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Experiment message, length delimited. Does not implicitly {@link palexy.sherlock.v1.Experiment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {palexy.sherlock.v1.IExperiment} message Experiment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Experiment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Experiment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.Experiment} Experiment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Experiment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.Experiment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.programmaticName = reader.string();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.videoProcessorVersion = reader.string();
                                break;
                            case 5:
                                message.trackingProcessorVersion = reader.string();
                                break;
                            case 6:
                                message.mergingProcessorVersion = reader.string();
                                break;
                            case 7:
                                message.cacheAgeGroupGenderVersion = reader.string();
                                break;
                            case 8:
                                message.cacheYoloVersion = reader.string();
                                break;
                            case 9:
                                message.cacheReidVersion = reader.string();
                                break;
                            case 10:
                                message.processingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.trackingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.mergingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.overrideMergingSingleCameraThreshold = reader.float();
                                break;
                            case 14:
                                message.overrideMergingCrossCameraThreshold = reader.float();
                                break;
                            case 15:
                                message.cacheId = reader.int64();
                                break;
                            case 16:
                                message.state = reader.int32();
                                break;
                            case 17:
                                message.createTimeMs = reader.int64();
                                break;
                            case 18:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Experiment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.Experiment} Experiment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Experiment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Experiment message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Experiment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.programmaticName != null && message.hasOwnProperty("programmaticName"))
                            if (!$util.isString(message.programmaticName))
                                return "programmaticName: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.videoProcessorVersion != null && message.hasOwnProperty("videoProcessorVersion"))
                            if (!$util.isString(message.videoProcessorVersion))
                                return "videoProcessorVersion: string expected";
                        if (message.trackingProcessorVersion != null && message.hasOwnProperty("trackingProcessorVersion"))
                            if (!$util.isString(message.trackingProcessorVersion))
                                return "trackingProcessorVersion: string expected";
                        if (message.mergingProcessorVersion != null && message.hasOwnProperty("mergingProcessorVersion"))
                            if (!$util.isString(message.mergingProcessorVersion))
                                return "mergingProcessorVersion: string expected";
                        if (message.cacheAgeGroupGenderVersion != null && message.hasOwnProperty("cacheAgeGroupGenderVersion"))
                            if (!$util.isString(message.cacheAgeGroupGenderVersion))
                                return "cacheAgeGroupGenderVersion: string expected";
                        if (message.cacheYoloVersion != null && message.hasOwnProperty("cacheYoloVersion"))
                            if (!$util.isString(message.cacheYoloVersion))
                                return "cacheYoloVersion: string expected";
                        if (message.cacheReidVersion != null && message.hasOwnProperty("cacheReidVersion"))
                            if (!$util.isString(message.cacheReidVersion))
                                return "cacheReidVersion: string expected";
                        if (message.processingEnvironmentKvs != null && message.hasOwnProperty("processingEnvironmentKvs")) {
                            var error = $root.palexy.sherlock.v1.EnvironmentKVList.verify(message.processingEnvironmentKvs);
                            if (error)
                                return "processingEnvironmentKvs." + error;
                        }
                        if (message.trackingEnvironmentKvs != null && message.hasOwnProperty("trackingEnvironmentKvs")) {
                            var error = $root.palexy.sherlock.v1.EnvironmentKVList.verify(message.trackingEnvironmentKvs);
                            if (error)
                                return "trackingEnvironmentKvs." + error;
                        }
                        if (message.mergingEnvironmentKvs != null && message.hasOwnProperty("mergingEnvironmentKvs")) {
                            var error = $root.palexy.sherlock.v1.EnvironmentKVList.verify(message.mergingEnvironmentKvs);
                            if (error)
                                return "mergingEnvironmentKvs." + error;
                        }
                        if (message.overrideMergingSingleCameraThreshold != null && message.hasOwnProperty("overrideMergingSingleCameraThreshold"))
                            if (typeof message.overrideMergingSingleCameraThreshold !== "number")
                                return "overrideMergingSingleCameraThreshold: number expected";
                        if (message.overrideMergingCrossCameraThreshold != null && message.hasOwnProperty("overrideMergingCrossCameraThreshold"))
                            if (typeof message.overrideMergingCrossCameraThreshold !== "number")
                                return "overrideMergingCrossCameraThreshold: number expected";
                        if (message.cacheId != null && message.hasOwnProperty("cacheId"))
                            if (!$util.isInteger(message.cacheId) && !(message.cacheId && $util.isInteger(message.cacheId.low) && $util.isInteger(message.cacheId.high)))
                                return "cacheId: integer|Long expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an Experiment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.Experiment} Experiment
                     */
                    Experiment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.Experiment)
                            return object;
                        var message = new $root.palexy.sherlock.v1.Experiment();
                        if (object.programmaticName != null)
                            message.programmaticName = String(object.programmaticName);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.videoProcessorVersion != null)
                            message.videoProcessorVersion = String(object.videoProcessorVersion);
                        if (object.trackingProcessorVersion != null)
                            message.trackingProcessorVersion = String(object.trackingProcessorVersion);
                        if (object.mergingProcessorVersion != null)
                            message.mergingProcessorVersion = String(object.mergingProcessorVersion);
                        if (object.cacheAgeGroupGenderVersion != null)
                            message.cacheAgeGroupGenderVersion = String(object.cacheAgeGroupGenderVersion);
                        if (object.cacheYoloVersion != null)
                            message.cacheYoloVersion = String(object.cacheYoloVersion);
                        if (object.cacheReidVersion != null)
                            message.cacheReidVersion = String(object.cacheReidVersion);
                        if (object.processingEnvironmentKvs != null) {
                            if (typeof object.processingEnvironmentKvs !== "object")
                                throw TypeError(".palexy.sherlock.v1.Experiment.processingEnvironmentKvs: object expected");
                            message.processingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.fromObject(object.processingEnvironmentKvs);
                        }
                        if (object.trackingEnvironmentKvs != null) {
                            if (typeof object.trackingEnvironmentKvs !== "object")
                                throw TypeError(".palexy.sherlock.v1.Experiment.trackingEnvironmentKvs: object expected");
                            message.trackingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.fromObject(object.trackingEnvironmentKvs);
                        }
                        if (object.mergingEnvironmentKvs != null) {
                            if (typeof object.mergingEnvironmentKvs !== "object")
                                throw TypeError(".palexy.sherlock.v1.Experiment.mergingEnvironmentKvs: object expected");
                            message.mergingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.fromObject(object.mergingEnvironmentKvs);
                        }
                        if (object.overrideMergingSingleCameraThreshold != null)
                            message.overrideMergingSingleCameraThreshold = Number(object.overrideMergingSingleCameraThreshold);
                        if (object.overrideMergingCrossCameraThreshold != null)
                            message.overrideMergingCrossCameraThreshold = Number(object.overrideMergingCrossCameraThreshold);
                        if (object.cacheId != null)
                            if ($util.Long)
                                (message.cacheId = $util.Long.fromValue(object.cacheId)).unsigned = false;
                            else if (typeof object.cacheId === "string")
                                message.cacheId = parseInt(object.cacheId, 10);
                            else if (typeof object.cacheId === "number")
                                message.cacheId = object.cacheId;
                            else if (typeof object.cacheId === "object")
                                message.cacheId = new $util.LongBits(object.cacheId.low >>> 0, object.cacheId.high >>> 0).toNumber();
                        switch (object.state) {
                        case "UNKNOWN_STATE":
                        case 0:
                            message.state = 0;
                            break;
                        case "NEW":
                        case 1:
                            message.state = 1;
                            break;
                        case "SETTING_UP":
                        case 2:
                            message.state = 2;
                            break;
                        case "PROCESSING":
                        case 3:
                            message.state = 3;
                            break;
                        case "TEARING_DOWN":
                        case 4:
                            message.state = 4;
                            break;
                        case "DONE":
                        case 5:
                            message.state = 5;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Experiment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.Experiment
                     * @static
                     * @param {palexy.sherlock.v1.Experiment} message Experiment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Experiment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.programmaticName = "";
                            object.name = "";
                            object.description = "";
                            object.videoProcessorVersion = "";
                            object.trackingProcessorVersion = "";
                            object.mergingProcessorVersion = "";
                            object.cacheAgeGroupGenderVersion = "";
                            object.cacheYoloVersion = "";
                            object.cacheReidVersion = "";
                            object.processingEnvironmentKvs = null;
                            object.trackingEnvironmentKvs = null;
                            object.mergingEnvironmentKvs = null;
                            object.overrideMergingSingleCameraThreshold = 0;
                            object.overrideMergingCrossCameraThreshold = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cacheId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cacheId = options.longs === String ? "0" : 0;
                            object.state = options.enums === String ? "UNKNOWN_STATE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.programmaticName != null && message.hasOwnProperty("programmaticName"))
                            object.programmaticName = message.programmaticName;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.videoProcessorVersion != null && message.hasOwnProperty("videoProcessorVersion"))
                            object.videoProcessorVersion = message.videoProcessorVersion;
                        if (message.trackingProcessorVersion != null && message.hasOwnProperty("trackingProcessorVersion"))
                            object.trackingProcessorVersion = message.trackingProcessorVersion;
                        if (message.mergingProcessorVersion != null && message.hasOwnProperty("mergingProcessorVersion"))
                            object.mergingProcessorVersion = message.mergingProcessorVersion;
                        if (message.cacheAgeGroupGenderVersion != null && message.hasOwnProperty("cacheAgeGroupGenderVersion"))
                            object.cacheAgeGroupGenderVersion = message.cacheAgeGroupGenderVersion;
                        if (message.cacheYoloVersion != null && message.hasOwnProperty("cacheYoloVersion"))
                            object.cacheYoloVersion = message.cacheYoloVersion;
                        if (message.cacheReidVersion != null && message.hasOwnProperty("cacheReidVersion"))
                            object.cacheReidVersion = message.cacheReidVersion;
                        if (message.processingEnvironmentKvs != null && message.hasOwnProperty("processingEnvironmentKvs"))
                            object.processingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.toObject(message.processingEnvironmentKvs, options);
                        if (message.trackingEnvironmentKvs != null && message.hasOwnProperty("trackingEnvironmentKvs"))
                            object.trackingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.toObject(message.trackingEnvironmentKvs, options);
                        if (message.mergingEnvironmentKvs != null && message.hasOwnProperty("mergingEnvironmentKvs"))
                            object.mergingEnvironmentKvs = $root.palexy.sherlock.v1.EnvironmentKVList.toObject(message.mergingEnvironmentKvs, options);
                        if (message.overrideMergingSingleCameraThreshold != null && message.hasOwnProperty("overrideMergingSingleCameraThreshold"))
                            object.overrideMergingSingleCameraThreshold = options.json && !isFinite(message.overrideMergingSingleCameraThreshold) ? String(message.overrideMergingSingleCameraThreshold) : message.overrideMergingSingleCameraThreshold;
                        if (message.overrideMergingCrossCameraThreshold != null && message.hasOwnProperty("overrideMergingCrossCameraThreshold"))
                            object.overrideMergingCrossCameraThreshold = options.json && !isFinite(message.overrideMergingCrossCameraThreshold) ? String(message.overrideMergingCrossCameraThreshold) : message.overrideMergingCrossCameraThreshold;
                        if (message.cacheId != null && message.hasOwnProperty("cacheId"))
                            if (typeof message.cacheId === "number")
                                object.cacheId = options.longs === String ? String(message.cacheId) : message.cacheId;
                            else
                                object.cacheId = options.longs === String ? $util.Long.prototype.toString.call(message.cacheId) : options.longs === Number ? new $util.LongBits(message.cacheId.low >>> 0, message.cacheId.high >>> 0).toNumber() : message.cacheId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.sherlock.v1.Experiment.ExperimentState[message.state] : message.state;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this Experiment to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.Experiment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Experiment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ExperimentState enum.
                     * @name palexy.sherlock.v1.Experiment.ExperimentState
                     * @enum {number}
                     * @property {number} UNKNOWN_STATE=0 UNKNOWN_STATE value
                     * @property {number} NEW=1 NEW value
                     * @property {number} SETTING_UP=2 SETTING_UP value
                     * @property {number} PROCESSING=3 PROCESSING value
                     * @property {number} TEARING_DOWN=4 TEARING_DOWN value
                     * @property {number} DONE=5 DONE value
                     */
                    Experiment.ExperimentState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_STATE"] = 0;
                        values[valuesById[1] = "NEW"] = 1;
                        values[valuesById[2] = "SETTING_UP"] = 2;
                        values[valuesById[3] = "PROCESSING"] = 3;
                        values[valuesById[4] = "TEARING_DOWN"] = 4;
                        values[valuesById[5] = "DONE"] = 5;
                        return values;
                    })();
    
                    /**
                     * ExperimentTestCaseState enum.
                     * @name palexy.sherlock.v1.Experiment.ExperimentTestCaseState
                     * @enum {number}
                     * @property {number} TEST_UNKNOWN_STATE=0 TEST_UNKNOWN_STATE value
                     * @property {number} WAITING_FOR_SETTING_UP=1 WAITING_FOR_SETTING_UP value
                     * @property {number} EVALUATING=2 EVALUATING value
                     * @property {number} DONE_EVALUATION=3 DONE_EVALUATION value
                     */
                    Experiment.ExperimentTestCaseState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TEST_UNKNOWN_STATE"] = 0;
                        values[valuesById[1] = "WAITING_FOR_SETTING_UP"] = 1;
                        values[valuesById[2] = "EVALUATING"] = 2;
                        values[valuesById[3] = "DONE_EVALUATION"] = 3;
                        return values;
                    })();
    
                    return Experiment;
                })();
    
                v1.EnvironmentKVList = (function() {
    
                    /**
                     * Properties of an EnvironmentKVList.
                     * @memberof palexy.sherlock.v1
                     * @interface IEnvironmentKVList
                     * @property {Array.<palexy.sherlock.v1.IEnvironmentKV>|null} [kvList] EnvironmentKVList kvList
                     */
    
                    /**
                     * Constructs a new EnvironmentKVList.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an EnvironmentKVList.
                     * @implements IEnvironmentKVList
                     * @constructor
                     * @param {palexy.sherlock.v1.IEnvironmentKVList=} [properties] Properties to set
                     */
                    function EnvironmentKVList(properties) {
                        this.kvList = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EnvironmentKVList kvList.
                     * @member {Array.<palexy.sherlock.v1.IEnvironmentKV>} kvList
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @instance
                     */
                    EnvironmentKVList.prototype.kvList = $util.emptyArray;
    
                    /**
                     * Creates a new EnvironmentKVList instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKVList=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.EnvironmentKVList} EnvironmentKVList instance
                     */
                    EnvironmentKVList.create = function create(properties) {
                        return new EnvironmentKVList(properties);
                    };
    
                    /**
                     * Encodes the specified EnvironmentKVList message. Does not implicitly {@link palexy.sherlock.v1.EnvironmentKVList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKVList} message EnvironmentKVList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnvironmentKVList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.kvList != null && message.kvList.length)
                            for (var i = 0; i < message.kvList.length; ++i)
                                $root.palexy.sherlock.v1.EnvironmentKV.encode(message.kvList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EnvironmentKVList message, length delimited. Does not implicitly {@link palexy.sherlock.v1.EnvironmentKVList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKVList} message EnvironmentKVList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnvironmentKVList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EnvironmentKVList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.EnvironmentKVList} EnvironmentKVList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnvironmentKVList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.EnvironmentKVList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.kvList && message.kvList.length))
                                    message.kvList = [];
                                message.kvList.push($root.palexy.sherlock.v1.EnvironmentKV.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EnvironmentKVList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.EnvironmentKVList} EnvironmentKVList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnvironmentKVList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EnvironmentKVList message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EnvironmentKVList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.kvList != null && message.hasOwnProperty("kvList")) {
                            if (!Array.isArray(message.kvList))
                                return "kvList: array expected";
                            for (var i = 0; i < message.kvList.length; ++i) {
                                var error = $root.palexy.sherlock.v1.EnvironmentKV.verify(message.kvList[i]);
                                if (error)
                                    return "kvList." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an EnvironmentKVList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.EnvironmentKVList} EnvironmentKVList
                     */
                    EnvironmentKVList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.EnvironmentKVList)
                            return object;
                        var message = new $root.palexy.sherlock.v1.EnvironmentKVList();
                        if (object.kvList) {
                            if (!Array.isArray(object.kvList))
                                throw TypeError(".palexy.sherlock.v1.EnvironmentKVList.kvList: array expected");
                            message.kvList = [];
                            for (var i = 0; i < object.kvList.length; ++i) {
                                if (typeof object.kvList[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.EnvironmentKVList.kvList: object expected");
                                message.kvList[i] = $root.palexy.sherlock.v1.EnvironmentKV.fromObject(object.kvList[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EnvironmentKVList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @static
                     * @param {palexy.sherlock.v1.EnvironmentKVList} message EnvironmentKVList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EnvironmentKVList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.kvList = [];
                        if (message.kvList && message.kvList.length) {
                            object.kvList = [];
                            for (var j = 0; j < message.kvList.length; ++j)
                                object.kvList[j] = $root.palexy.sherlock.v1.EnvironmentKV.toObject(message.kvList[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this EnvironmentKVList to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.EnvironmentKVList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EnvironmentKVList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EnvironmentKVList;
                })();
    
                v1.EnvironmentKV = (function() {
    
                    /**
                     * Properties of an EnvironmentKV.
                     * @memberof palexy.sherlock.v1
                     * @interface IEnvironmentKV
                     * @property {string|null} [key] EnvironmentKV key
                     * @property {string|null} [value] EnvironmentKV value
                     */
    
                    /**
                     * Constructs a new EnvironmentKV.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an EnvironmentKV.
                     * @implements IEnvironmentKV
                     * @constructor
                     * @param {palexy.sherlock.v1.IEnvironmentKV=} [properties] Properties to set
                     */
                    function EnvironmentKV(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EnvironmentKV key.
                     * @member {string} key
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @instance
                     */
                    EnvironmentKV.prototype.key = "";
    
                    /**
                     * EnvironmentKV value.
                     * @member {string} value
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @instance
                     */
                    EnvironmentKV.prototype.value = "";
    
                    /**
                     * Creates a new EnvironmentKV instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKV=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.EnvironmentKV} EnvironmentKV instance
                     */
                    EnvironmentKV.create = function create(properties) {
                        return new EnvironmentKV(properties);
                    };
    
                    /**
                     * Encodes the specified EnvironmentKV message. Does not implicitly {@link palexy.sherlock.v1.EnvironmentKV.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKV} message EnvironmentKV message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnvironmentKV.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.key != null && Object.hasOwnProperty.call(message, "key"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.key);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EnvironmentKV message, length delimited. Does not implicitly {@link palexy.sherlock.v1.EnvironmentKV.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {palexy.sherlock.v1.IEnvironmentKV} message EnvironmentKV message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EnvironmentKV.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EnvironmentKV message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.EnvironmentKV} EnvironmentKV
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnvironmentKV.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.EnvironmentKV();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.key = reader.string();
                                break;
                            case 2:
                                message.value = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EnvironmentKV message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.EnvironmentKV} EnvironmentKV
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EnvironmentKV.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EnvironmentKV message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EnvironmentKV.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.key != null && message.hasOwnProperty("key"))
                            if (!$util.isString(message.key))
                                return "key: string expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an EnvironmentKV message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.EnvironmentKV} EnvironmentKV
                     */
                    EnvironmentKV.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.EnvironmentKV)
                            return object;
                        var message = new $root.palexy.sherlock.v1.EnvironmentKV();
                        if (object.key != null)
                            message.key = String(object.key);
                        if (object.value != null)
                            message.value = String(object.value);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EnvironmentKV message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @static
                     * @param {palexy.sherlock.v1.EnvironmentKV} message EnvironmentKV
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EnvironmentKV.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.key = "";
                            object.value = "";
                        }
                        if (message.key != null && message.hasOwnProperty("key"))
                            object.key = message.key;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        return object;
                    };
    
                    /**
                     * Converts this EnvironmentKV to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.EnvironmentKV
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EnvironmentKV.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EnvironmentKV;
                })();
    
                v1.ListExperimentsRequest = (function() {
    
                    /**
                     * Properties of a ListExperimentsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListExperimentsRequest
                     * @property {boolean|null} [onlyIncludeNotDone] ListExperimentsRequest onlyIncludeNotDone
                     * @property {string|null} [pageToken] ListExperimentsRequest pageToken
                     * @property {number|null} [pageSize] ListExperimentsRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListExperimentsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListExperimentsRequest.
                     * @implements IListExperimentsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListExperimentsRequest=} [properties] Properties to set
                     */
                    function ListExperimentsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExperimentsRequest onlyIncludeNotDone.
                     * @member {boolean} onlyIncludeNotDone
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @instance
                     */
                    ListExperimentsRequest.prototype.onlyIncludeNotDone = false;
    
                    /**
                     * ListExperimentsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @instance
                     */
                    ListExperimentsRequest.prototype.pageToken = "";
    
                    /**
                     * ListExperimentsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @instance
                     */
                    ListExperimentsRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListExperimentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListExperimentsRequest} ListExperimentsRequest instance
                     */
                    ListExperimentsRequest.create = function create(properties) {
                        return new ListExperimentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListExperimentsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListExperimentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsRequest} message ListExperimentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.onlyIncludeNotDone != null && Object.hasOwnProperty.call(message, "onlyIncludeNotDone"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.onlyIncludeNotDone);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExperimentsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListExperimentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsRequest} message ListExperimentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExperimentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListExperimentsRequest} ListExperimentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListExperimentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.onlyIncludeNotDone = reader.bool();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExperimentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListExperimentsRequest} ListExperimentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExperimentsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExperimentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.onlyIncludeNotDone != null && message.hasOwnProperty("onlyIncludeNotDone"))
                            if (typeof message.onlyIncludeNotDone !== "boolean")
                                return "onlyIncludeNotDone: boolean expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExperimentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListExperimentsRequest} ListExperimentsRequest
                     */
                    ListExperimentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListExperimentsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListExperimentsRequest();
                        if (object.onlyIncludeNotDone != null)
                            message.onlyIncludeNotDone = Boolean(object.onlyIncludeNotDone);
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExperimentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListExperimentsRequest} message ListExperimentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExperimentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.onlyIncludeNotDone = false;
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.onlyIncludeNotDone != null && message.hasOwnProperty("onlyIncludeNotDone"))
                            object.onlyIncludeNotDone = message.onlyIncludeNotDone;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListExperimentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListExperimentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExperimentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExperimentsRequest;
                })();
    
                v1.GetExperimentRequest = (function() {
    
                    /**
                     * Properties of a GetExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IGetExperimentRequest
                     * @property {string|null} [experimentName] GetExperimentRequest experimentName
                     */
    
                    /**
                     * Constructs a new GetExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GetExperimentRequest.
                     * @implements IGetExperimentRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IGetExperimentRequest=} [properties] Properties to set
                     */
                    function GetExperimentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetExperimentRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @instance
                     */
                    GetExperimentRequest.prototype.experimentName = "";
    
                    /**
                     * Creates a new GetExperimentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GetExperimentRequest} GetExperimentRequest instance
                     */
                    GetExperimentRequest.create = function create(properties) {
                        return new GetExperimentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetExperimentRequest message. Does not implicitly {@link palexy.sherlock.v1.GetExperimentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentRequest} message GetExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExperimentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.experimentName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetExperimentRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GetExperimentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentRequest} message GetExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExperimentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetExperimentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GetExperimentRequest} GetExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExperimentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GetExperimentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experimentName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetExperimentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GetExperimentRequest} GetExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExperimentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetExperimentRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetExperimentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetExperimentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GetExperimentRequest} GetExperimentRequest
                     */
                    GetExperimentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GetExperimentRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GetExperimentRequest();
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetExperimentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.GetExperimentRequest} message GetExperimentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetExperimentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experimentName = "";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        return object;
                    };
    
                    /**
                     * Converts this GetExperimentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GetExperimentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetExperimentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetExperimentRequest;
                })();
    
                v1.GetExperimentResponse = (function() {
    
                    /**
                     * Properties of a GetExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IGetExperimentResponse
                     * @property {palexy.sherlock.v1.IExperiment|null} [experiment] GetExperimentResponse experiment
                     */
    
                    /**
                     * Constructs a new GetExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GetExperimentResponse.
                     * @implements IGetExperimentResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IGetExperimentResponse=} [properties] Properties to set
                     */
                    function GetExperimentResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetExperimentResponse experiment.
                     * @member {palexy.sherlock.v1.IExperiment|null|undefined} experiment
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @instance
                     */
                    GetExperimentResponse.prototype.experiment = null;
    
                    /**
                     * Creates a new GetExperimentResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GetExperimentResponse} GetExperimentResponse instance
                     */
                    GetExperimentResponse.create = function create(properties) {
                        return new GetExperimentResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetExperimentResponse message. Does not implicitly {@link palexy.sherlock.v1.GetExperimentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentResponse} message GetExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExperimentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiment != null && Object.hasOwnProperty.call(message, "experiment"))
                            $root.palexy.sherlock.v1.Experiment.encode(message.experiment, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetExperimentResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GetExperimentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGetExperimentResponse} message GetExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExperimentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetExperimentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GetExperimentResponse} GetExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExperimentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GetExperimentResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experiment = $root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetExperimentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GetExperimentResponse} GetExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExperimentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetExperimentResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetExperimentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiment != null && message.hasOwnProperty("experiment")) {
                            var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiment);
                            if (error)
                                return "experiment." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetExperimentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GetExperimentResponse} GetExperimentResponse
                     */
                    GetExperimentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GetExperimentResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GetExperimentResponse();
                        if (object.experiment != null) {
                            if (typeof object.experiment !== "object")
                                throw TypeError(".palexy.sherlock.v1.GetExperimentResponse.experiment: object expected");
                            message.experiment = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiment);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetExperimentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.GetExperimentResponse} message GetExperimentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetExperimentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experiment = null;
                        if (message.experiment != null && message.hasOwnProperty("experiment"))
                            object.experiment = $root.palexy.sherlock.v1.Experiment.toObject(message.experiment, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetExperimentResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GetExperimentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetExperimentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetExperimentResponse;
                })();
    
                v1.ListExperimentsResponse = (function() {
    
                    /**
                     * Properties of a ListExperimentsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListExperimentsResponse
                     * @property {Array.<palexy.sherlock.v1.IExperiment>|null} [experiments] ListExperimentsResponse experiments
                     * @property {string|null} [nextPageToken] ListExperimentsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListExperimentsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListExperimentsResponse.
                     * @implements IListExperimentsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListExperimentsResponse=} [properties] Properties to set
                     */
                    function ListExperimentsResponse(properties) {
                        this.experiments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExperimentsResponse experiments.
                     * @member {Array.<palexy.sherlock.v1.IExperiment>} experiments
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @instance
                     */
                    ListExperimentsResponse.prototype.experiments = $util.emptyArray;
    
                    /**
                     * ListExperimentsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @instance
                     */
                    ListExperimentsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListExperimentsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListExperimentsResponse} ListExperimentsResponse instance
                     */
                    ListExperimentsResponse.create = function create(properties) {
                        return new ListExperimentsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListExperimentsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListExperimentsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsResponse} message ListExperimentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiments != null && message.experiments.length)
                            for (var i = 0; i < message.experiments.length; ++i)
                                $root.palexy.sherlock.v1.Experiment.encode(message.experiments[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExperimentsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListExperimentsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentsResponse} message ListExperimentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExperimentsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListExperimentsResponse} ListExperimentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListExperimentsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.experiments && message.experiments.length))
                                    message.experiments = [];
                                message.experiments.push($root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExperimentsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListExperimentsResponse} ListExperimentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExperimentsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExperimentsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiments != null && message.hasOwnProperty("experiments")) {
                            if (!Array.isArray(message.experiments))
                                return "experiments: array expected";
                            for (var i = 0; i < message.experiments.length; ++i) {
                                var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiments[i]);
                                if (error)
                                    return "experiments." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExperimentsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListExperimentsResponse} ListExperimentsResponse
                     */
                    ListExperimentsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListExperimentsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListExperimentsResponse();
                        if (object.experiments) {
                            if (!Array.isArray(object.experiments))
                                throw TypeError(".palexy.sherlock.v1.ListExperimentsResponse.experiments: array expected");
                            message.experiments = [];
                            for (var i = 0; i < object.experiments.length; ++i) {
                                if (typeof object.experiments[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListExperimentsResponse.experiments: object expected");
                                message.experiments[i] = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiments[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExperimentsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListExperimentsResponse} message ListExperimentsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExperimentsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.experiments = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.experiments && message.experiments.length) {
                            object.experiments = [];
                            for (var j = 0; j < message.experiments.length; ++j)
                                object.experiments[j] = $root.palexy.sherlock.v1.Experiment.toObject(message.experiments[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListExperimentsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListExperimentsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExperimentsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExperimentsResponse;
                })();
    
                v1.UpdateExperimentRequest = (function() {
    
                    /**
                     * Properties of an UpdateExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateExperimentRequest
                     * @property {palexy.sherlock.v1.IExperiment|null} [experiment] UpdateExperimentRequest experiment
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateExperimentRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateExperimentRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateExperimentRequest.
                     * @implements IUpdateExperimentRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest=} [properties] Properties to set
                     */
                    function UpdateExperimentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateExperimentRequest experiment.
                     * @member {palexy.sherlock.v1.IExperiment|null|undefined} experiment
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @instance
                     */
                    UpdateExperimentRequest.prototype.experiment = null;
    
                    /**
                     * UpdateExperimentRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @instance
                     */
                    UpdateExperimentRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateExperimentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateExperimentRequest} UpdateExperimentRequest instance
                     */
                    UpdateExperimentRequest.create = function create(properties) {
                        return new UpdateExperimentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest} message UpdateExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiment != null && Object.hasOwnProperty.call(message, "experiment"))
                            $root.palexy.sherlock.v1.Experiment.encode(message.experiment, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentRequest} message UpdateExperimentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateExperimentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateExperimentRequest} UpdateExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateExperimentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experiment = $root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateExperimentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateExperimentRequest} UpdateExperimentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateExperimentRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateExperimentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiment != null && message.hasOwnProperty("experiment")) {
                            var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiment);
                            if (error)
                                return "experiment." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateExperimentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateExperimentRequest} UpdateExperimentRequest
                     */
                    UpdateExperimentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateExperimentRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateExperimentRequest();
                        if (object.experiment != null) {
                            if (typeof object.experiment !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateExperimentRequest.experiment: object expected");
                            message.experiment = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiment);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateExperimentRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateExperimentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateExperimentRequest} message UpdateExperimentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateExperimentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.experiment = null;
                            object.updateMask = null;
                        }
                        if (message.experiment != null && message.hasOwnProperty("experiment"))
                            object.experiment = $root.palexy.sherlock.v1.Experiment.toObject(message.experiment, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateExperimentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateExperimentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateExperimentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateExperimentRequest;
                })();
    
                v1.UpdateExperimentResponse = (function() {
    
                    /**
                     * Properties of an UpdateExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateExperimentResponse
                     * @property {palexy.sherlock.v1.IExperiment|null} [experiment] UpdateExperimentResponse experiment
                     */
    
                    /**
                     * Constructs a new UpdateExperimentResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateExperimentResponse.
                     * @implements IUpdateExperimentResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateExperimentResponse=} [properties] Properties to set
                     */
                    function UpdateExperimentResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateExperimentResponse experiment.
                     * @member {palexy.sherlock.v1.IExperiment|null|undefined} experiment
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @instance
                     */
                    UpdateExperimentResponse.prototype.experiment = null;
    
                    /**
                     * Creates a new UpdateExperimentResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateExperimentResponse} UpdateExperimentResponse instance
                     */
                    UpdateExperimentResponse.create = function create(properties) {
                        return new UpdateExperimentResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentResponse message. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentResponse} message UpdateExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experiment != null && Object.hasOwnProperty.call(message, "experiment"))
                            $root.palexy.sherlock.v1.Experiment.encode(message.experiment, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentResponse} message UpdateExperimentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateExperimentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateExperimentResponse} UpdateExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateExperimentResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experiment = $root.palexy.sherlock.v1.Experiment.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateExperimentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateExperimentResponse} UpdateExperimentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateExperimentResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateExperimentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experiment != null && message.hasOwnProperty("experiment")) {
                            var error = $root.palexy.sherlock.v1.Experiment.verify(message.experiment);
                            if (error)
                                return "experiment." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateExperimentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateExperimentResponse} UpdateExperimentResponse
                     */
                    UpdateExperimentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateExperimentResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateExperimentResponse();
                        if (object.experiment != null) {
                            if (typeof object.experiment !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateExperimentResponse.experiment: object expected");
                            message.experiment = $root.palexy.sherlock.v1.Experiment.fromObject(object.experiment);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateExperimentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @static
                     * @param {palexy.sherlock.v1.UpdateExperimentResponse} message UpdateExperimentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateExperimentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experiment = null;
                        if (message.experiment != null && message.hasOwnProperty("experiment"))
                            object.experiment = $root.palexy.sherlock.v1.Experiment.toObject(message.experiment, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateExperimentResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateExperimentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateExperimentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateExperimentResponse;
                })();
    
                v1.ListExperimentTestCasesRequest = (function() {
    
                    /**
                     * Properties of a ListExperimentTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListExperimentTestCasesRequest
                     * @property {palexy.sherlock.v1.Experiment.ExperimentTestCaseState|null} [testCaseState] ListExperimentTestCasesRequest testCaseState
                     * @property {string|null} [experimentName] ListExperimentTestCasesRequest experimentName
                     * @property {string|null} [pageToken] ListExperimentTestCasesRequest pageToken
                     * @property {number|null} [pageSize] ListExperimentTestCasesRequest pageSize
                     * @property {string|null} [dateId] ListExperimentTestCasesRequest dateId
                     * @property {number|null} [storeId] ListExperimentTestCasesRequest storeId
                     */
    
                    /**
                     * Constructs a new ListExperimentTestCasesRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListExperimentTestCasesRequest.
                     * @implements IListExperimentTestCasesRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest=} [properties] Properties to set
                     */
                    function ListExperimentTestCasesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExperimentTestCasesRequest testCaseState.
                     * @member {palexy.sherlock.v1.Experiment.ExperimentTestCaseState} testCaseState
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.testCaseState = 0;
    
                    /**
                     * ListExperimentTestCasesRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.experimentName = "";
    
                    /**
                     * ListExperimentTestCasesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.pageToken = "";
    
                    /**
                     * ListExperimentTestCasesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListExperimentTestCasesRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.dateId = "";
    
                    /**
                     * ListExperimentTestCasesRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     */
                    ListExperimentTestCasesRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListExperimentTestCasesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesRequest} ListExperimentTestCasesRequest instance
                     */
                    ListExperimentTestCasesRequest.create = function create(properties) {
                        return new ListExperimentTestCasesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListExperimentTestCasesRequest message. Does not implicitly {@link palexy.sherlock.v1.ListExperimentTestCasesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest} message ListExperimentTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentTestCasesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testCaseState != null && Object.hasOwnProperty.call(message, "testCaseState"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.testCaseState);
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.experimentName);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.dateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExperimentTestCasesRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListExperimentTestCasesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesRequest} message ListExperimentTestCasesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentTestCasesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExperimentTestCasesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesRequest} ListExperimentTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentTestCasesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListExperimentTestCasesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.testCaseState = reader.int32();
                                break;
                            case 2:
                                message.experimentName = reader.string();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.dateId = reader.string();
                                break;
                            case 6:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExperimentTestCasesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesRequest} ListExperimentTestCasesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentTestCasesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExperimentTestCasesRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExperimentTestCasesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testCaseState != null && message.hasOwnProperty("testCaseState"))
                            switch (message.testCaseState) {
                            default:
                                return "testCaseState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExperimentTestCasesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesRequest} ListExperimentTestCasesRequest
                     */
                    ListExperimentTestCasesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListExperimentTestCasesRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListExperimentTestCasesRequest();
                        switch (object.testCaseState) {
                        case "TEST_UNKNOWN_STATE":
                        case 0:
                            message.testCaseState = 0;
                            break;
                        case "WAITING_FOR_SETTING_UP":
                        case 1:
                            message.testCaseState = 1;
                            break;
                        case "EVALUATING":
                        case 2:
                            message.testCaseState = 2;
                            break;
                        case "DONE_EVALUATION":
                        case 3:
                            message.testCaseState = 3;
                            break;
                        }
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExperimentTestCasesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListExperimentTestCasesRequest} message ListExperimentTestCasesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExperimentTestCasesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.testCaseState = options.enums === String ? "TEST_UNKNOWN_STATE" : 0;
                            object.experimentName = "";
                            object.pageToken = "";
                            object.pageSize = 0;
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.testCaseState != null && message.hasOwnProperty("testCaseState"))
                            object.testCaseState = options.enums === String ? $root.palexy.sherlock.v1.Experiment.ExperimentTestCaseState[message.testCaseState] : message.testCaseState;
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this ListExperimentTestCasesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExperimentTestCasesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExperimentTestCasesRequest;
                })();
    
                v1.ListExperimentTestCasesResponse = (function() {
    
                    /**
                     * Properties of a ListExperimentTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListExperimentTestCasesResponse
                     * @property {Array.<palexy.sherlock.v1.IExperimentTestCase>|null} [testCases] ListExperimentTestCasesResponse testCases
                     * @property {string|null} [nextPageToken] ListExperimentTestCasesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListExperimentTestCasesResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListExperimentTestCasesResponse.
                     * @implements IListExperimentTestCasesResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesResponse=} [properties] Properties to set
                     */
                    function ListExperimentTestCasesResponse(properties) {
                        this.testCases = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExperimentTestCasesResponse testCases.
                     * @member {Array.<palexy.sherlock.v1.IExperimentTestCase>} testCases
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @instance
                     */
                    ListExperimentTestCasesResponse.prototype.testCases = $util.emptyArray;
    
                    /**
                     * ListExperimentTestCasesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @instance
                     */
                    ListExperimentTestCasesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListExperimentTestCasesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesResponse} ListExperimentTestCasesResponse instance
                     */
                    ListExperimentTestCasesResponse.create = function create(properties) {
                        return new ListExperimentTestCasesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListExperimentTestCasesResponse message. Does not implicitly {@link palexy.sherlock.v1.ListExperimentTestCasesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesResponse} message ListExperimentTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentTestCasesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.testCases != null && message.testCases.length)
                            for (var i = 0; i < message.testCases.length; ++i)
                                $root.palexy.sherlock.v1.ExperimentTestCase.encode(message.testCases[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExperimentTestCasesResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListExperimentTestCasesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListExperimentTestCasesResponse} message ListExperimentTestCasesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExperimentTestCasesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExperimentTestCasesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesResponse} ListExperimentTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentTestCasesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListExperimentTestCasesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.testCases && message.testCases.length))
                                    message.testCases = [];
                                message.testCases.push($root.palexy.sherlock.v1.ExperimentTestCase.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExperimentTestCasesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesResponse} ListExperimentTestCasesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExperimentTestCasesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExperimentTestCasesResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExperimentTestCasesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.testCases != null && message.hasOwnProperty("testCases")) {
                            if (!Array.isArray(message.testCases))
                                return "testCases: array expected";
                            for (var i = 0; i < message.testCases.length; ++i) {
                                var error = $root.palexy.sherlock.v1.ExperimentTestCase.verify(message.testCases[i]);
                                if (error)
                                    return "testCases." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExperimentTestCasesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListExperimentTestCasesResponse} ListExperimentTestCasesResponse
                     */
                    ListExperimentTestCasesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListExperimentTestCasesResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListExperimentTestCasesResponse();
                        if (object.testCases) {
                            if (!Array.isArray(object.testCases))
                                throw TypeError(".palexy.sherlock.v1.ListExperimentTestCasesResponse.testCases: array expected");
                            message.testCases = [];
                            for (var i = 0; i < object.testCases.length; ++i) {
                                if (typeof object.testCases[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListExperimentTestCasesResponse.testCases: object expected");
                                message.testCases[i] = $root.palexy.sherlock.v1.ExperimentTestCase.fromObject(object.testCases[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExperimentTestCasesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListExperimentTestCasesResponse} message ListExperimentTestCasesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExperimentTestCasesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.testCases = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.testCases && message.testCases.length) {
                            object.testCases = [];
                            for (var j = 0; j < message.testCases.length; ++j)
                                object.testCases[j] = $root.palexy.sherlock.v1.ExperimentTestCase.toObject(message.testCases[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListExperimentTestCasesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListExperimentTestCasesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExperimentTestCasesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExperimentTestCasesResponse;
                })();
    
                v1.CreateExperimentVideoRequest = (function() {
    
                    /**
                     * Properties of a CreateExperimentVideoRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateExperimentVideoRequest
                     * @property {palexy.streaming.v1.IVideo|null} [video] CreateExperimentVideoRequest video
                     * @property {string|null} [experimentName] CreateExperimentVideoRequest experimentName
                     * @property {number|null} [storeId] CreateExperimentVideoRequest storeId
                     * @property {string|null} [processingQueueName] CreateExperimentVideoRequest processingQueueName
                     */
    
                    /**
                     * Constructs a new CreateExperimentVideoRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateExperimentVideoRequest.
                     * @implements ICreateExperimentVideoRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest=} [properties] Properties to set
                     */
                    function CreateExperimentVideoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateExperimentVideoRequest video.
                     * @member {palexy.streaming.v1.IVideo|null|undefined} video
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @instance
                     */
                    CreateExperimentVideoRequest.prototype.video = null;
    
                    /**
                     * CreateExperimentVideoRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @instance
                     */
                    CreateExperimentVideoRequest.prototype.experimentName = "";
    
                    /**
                     * CreateExperimentVideoRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @instance
                     */
                    CreateExperimentVideoRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateExperimentVideoRequest processingQueueName.
                     * @member {string} processingQueueName
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @instance
                     */
                    CreateExperimentVideoRequest.prototype.processingQueueName = "";
    
                    /**
                     * Creates a new CreateExperimentVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoRequest} CreateExperimentVideoRequest instance
                     */
                    CreateExperimentVideoRequest.create = function create(properties) {
                        return new CreateExperimentVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateExperimentVideoRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest} message CreateExperimentVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Video.encode(message.video, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.experimentName);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.processingQueueName != null && Object.hasOwnProperty.call(message, "processingQueueName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.processingQueueName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateExperimentVideoRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoRequest} message CreateExperimentVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateExperimentVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoRequest} CreateExperimentVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateExperimentVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.video = $root.palexy.streaming.v1.Video.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.experimentName = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.processingQueueName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateExperimentVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoRequest} CreateExperimentVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateExperimentVideoRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateExperimentVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Video.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.processingQueueName != null && message.hasOwnProperty("processingQueueName"))
                            if (!$util.isString(message.processingQueueName))
                                return "processingQueueName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateExperimentVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoRequest} CreateExperimentVideoRequest
                     */
                    CreateExperimentVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateExperimentVideoRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateExperimentVideoRequest();
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateExperimentVideoRequest.video: object expected");
                            message.video = $root.palexy.streaming.v1.Video.fromObject(object.video);
                        }
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.processingQueueName != null)
                            message.processingQueueName = String(object.processingQueueName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateExperimentVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateExperimentVideoRequest} message CreateExperimentVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateExperimentVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.video = null;
                            object.experimentName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.processingQueueName = "";
                        }
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Video.toObject(message.video, options);
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.processingQueueName != null && message.hasOwnProperty("processingQueueName"))
                            object.processingQueueName = message.processingQueueName;
                        return object;
                    };
    
                    /**
                     * Converts this CreateExperimentVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateExperimentVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateExperimentVideoRequest;
                })();
    
                v1.CreateExperimentVideoResponse = (function() {
    
                    /**
                     * Properties of a CreateExperimentVideoResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateExperimentVideoResponse
                     * @property {palexy.streaming.v1.IVideo|null} [video] CreateExperimentVideoResponse video
                     */
    
                    /**
                     * Constructs a new CreateExperimentVideoResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateExperimentVideoResponse.
                     * @implements ICreateExperimentVideoResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoResponse=} [properties] Properties to set
                     */
                    function CreateExperimentVideoResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateExperimentVideoResponse video.
                     * @member {palexy.streaming.v1.IVideo|null|undefined} video
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @instance
                     */
                    CreateExperimentVideoResponse.prototype.video = null;
    
                    /**
                     * Creates a new CreateExperimentVideoResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoResponse} CreateExperimentVideoResponse instance
                     */
                    CreateExperimentVideoResponse.create = function create(properties) {
                        return new CreateExperimentVideoResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateExperimentVideoResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentVideoResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoResponse} message CreateExperimentVideoResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentVideoResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Video.encode(message.video, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateExperimentVideoResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateExperimentVideoResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateExperimentVideoResponse} message CreateExperimentVideoResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateExperimentVideoResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateExperimentVideoResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoResponse} CreateExperimentVideoResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentVideoResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateExperimentVideoResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.video = $root.palexy.streaming.v1.Video.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateExperimentVideoResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoResponse} CreateExperimentVideoResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateExperimentVideoResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateExperimentVideoResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateExperimentVideoResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Video.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateExperimentVideoResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateExperimentVideoResponse} CreateExperimentVideoResponse
                     */
                    CreateExperimentVideoResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateExperimentVideoResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateExperimentVideoResponse();
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateExperimentVideoResponse.video: object expected");
                            message.video = $root.palexy.streaming.v1.Video.fromObject(object.video);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateExperimentVideoResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateExperimentVideoResponse} message CreateExperimentVideoResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateExperimentVideoResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.video = null;
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Video.toObject(message.video, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateExperimentVideoResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateExperimentVideoResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateExperimentVideoResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateExperimentVideoResponse;
                })();
    
                v1.UpdateExperimentTestCaseStateRequest = (function() {
    
                    /**
                     * Properties of an UpdateExperimentTestCaseStateRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateExperimentTestCaseStateRequest
                     * @property {string|null} [experimentName] UpdateExperimentTestCaseStateRequest experimentName
                     * @property {number|null} [testCaseId] UpdateExperimentTestCaseStateRequest testCaseId
                     * @property {palexy.sherlock.v1.Experiment.ExperimentTestCaseState|null} [newState] UpdateExperimentTestCaseStateRequest newState
                     */
    
                    /**
                     * Constructs a new UpdateExperimentTestCaseStateRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateExperimentTestCaseStateRequest.
                     * @implements IUpdateExperimentTestCaseStateRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest=} [properties] Properties to set
                     */
                    function UpdateExperimentTestCaseStateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateExperimentTestCaseStateRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @instance
                     */
                    UpdateExperimentTestCaseStateRequest.prototype.experimentName = "";
    
                    /**
                     * UpdateExperimentTestCaseStateRequest testCaseId.
                     * @member {number} testCaseId
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @instance
                     */
                    UpdateExperimentTestCaseStateRequest.prototype.testCaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateExperimentTestCaseStateRequest newState.
                     * @member {palexy.sherlock.v1.Experiment.ExperimentTestCaseState} newState
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @instance
                     */
                    UpdateExperimentTestCaseStateRequest.prototype.newState = 0;
    
                    /**
                     * Creates a new UpdateExperimentTestCaseStateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest} UpdateExperimentTestCaseStateRequest instance
                     */
                    UpdateExperimentTestCaseStateRequest.create = function create(properties) {
                        return new UpdateExperimentTestCaseStateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentTestCaseStateRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest} message UpdateExperimentTestCaseStateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentTestCaseStateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.experimentName);
                        if (message.testCaseId != null && Object.hasOwnProperty.call(message, "testCaseId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.testCaseId);
                        if (message.newState != null && Object.hasOwnProperty.call(message, "newState"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.newState);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentTestCaseStateRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateRequest} message UpdateExperimentTestCaseStateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentTestCaseStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateExperimentTestCaseStateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest} UpdateExperimentTestCaseStateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentTestCaseStateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experimentName = reader.string();
                                break;
                            case 2:
                                message.testCaseId = reader.int64();
                                break;
                            case 3:
                                message.newState = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateExperimentTestCaseStateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest} UpdateExperimentTestCaseStateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentTestCaseStateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateExperimentTestCaseStateRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateExperimentTestCaseStateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (!$util.isInteger(message.testCaseId) && !(message.testCaseId && $util.isInteger(message.testCaseId.low) && $util.isInteger(message.testCaseId.high)))
                                return "testCaseId: integer|Long expected";
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            switch (message.newState) {
                            default:
                                return "newState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateExperimentTestCaseStateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest} UpdateExperimentTestCaseStateRequest
                     */
                    UpdateExperimentTestCaseStateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest();
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        if (object.testCaseId != null)
                            if ($util.Long)
                                (message.testCaseId = $util.Long.fromValue(object.testCaseId)).unsigned = false;
                            else if (typeof object.testCaseId === "string")
                                message.testCaseId = parseInt(object.testCaseId, 10);
                            else if (typeof object.testCaseId === "number")
                                message.testCaseId = object.testCaseId;
                            else if (typeof object.testCaseId === "object")
                                message.testCaseId = new $util.LongBits(object.testCaseId.low >>> 0, object.testCaseId.high >>> 0).toNumber();
                        switch (object.newState) {
                        case "TEST_UNKNOWN_STATE":
                        case 0:
                            message.newState = 0;
                            break;
                        case "WAITING_FOR_SETTING_UP":
                        case 1:
                            message.newState = 1;
                            break;
                        case "EVALUATING":
                        case 2:
                            message.newState = 2;
                            break;
                        case "DONE_EVALUATION":
                        case 3:
                            message.newState = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateExperimentTestCaseStateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest} message UpdateExperimentTestCaseStateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateExperimentTestCaseStateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.experimentName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testCaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testCaseId = options.longs === String ? "0" : 0;
                            object.newState = options.enums === String ? "TEST_UNKNOWN_STATE" : 0;
                        }
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        if (message.testCaseId != null && message.hasOwnProperty("testCaseId"))
                            if (typeof message.testCaseId === "number")
                                object.testCaseId = options.longs === String ? String(message.testCaseId) : message.testCaseId;
                            else
                                object.testCaseId = options.longs === String ? $util.Long.prototype.toString.call(message.testCaseId) : options.longs === Number ? new $util.LongBits(message.testCaseId.low >>> 0, message.testCaseId.high >>> 0).toNumber() : message.testCaseId;
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            object.newState = options.enums === String ? $root.palexy.sherlock.v1.Experiment.ExperimentTestCaseState[message.newState] : message.newState;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateExperimentTestCaseStateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateExperimentTestCaseStateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateExperimentTestCaseStateRequest;
                })();
    
                v1.UpdateExperimentTestCaseStateResponse = (function() {
    
                    /**
                     * Properties of an UpdateExperimentTestCaseStateResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateExperimentTestCaseStateResponse
                     */
    
                    /**
                     * Constructs a new UpdateExperimentTestCaseStateResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateExperimentTestCaseStateResponse.
                     * @implements IUpdateExperimentTestCaseStateResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateResponse=} [properties] Properties to set
                     */
                    function UpdateExperimentTestCaseStateResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new UpdateExperimentTestCaseStateResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} UpdateExperimentTestCaseStateResponse instance
                     */
                    UpdateExperimentTestCaseStateResponse.create = function create(properties) {
                        return new UpdateExperimentTestCaseStateResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentTestCaseStateResponse message. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateResponse} message UpdateExperimentTestCaseStateResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentTestCaseStateResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateExperimentTestCaseStateResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateExperimentTestCaseStateResponse} message UpdateExperimentTestCaseStateResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExperimentTestCaseStateResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateExperimentTestCaseStateResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} UpdateExperimentTestCaseStateResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentTestCaseStateResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateExperimentTestCaseStateResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} UpdateExperimentTestCaseStateResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExperimentTestCaseStateResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateExperimentTestCaseStateResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateExperimentTestCaseStateResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateExperimentTestCaseStateResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} UpdateExperimentTestCaseStateResponse
                     */
                    UpdateExperimentTestCaseStateResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse();
                    };
    
                    /**
                     * Creates a plain object from an UpdateExperimentTestCaseStateResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @static
                     * @param {palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse} message UpdateExperimentTestCaseStateResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateExperimentTestCaseStateResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this UpdateExperimentTestCaseStateResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateExperimentTestCaseStateResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateExperimentTestCaseStateResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateExperimentTestCaseStateResponse;
                })();
    
                v1.FetchExperimentVideosReadyForMergingRequest = (function() {
    
                    /**
                     * Properties of a FetchExperimentVideosReadyForMergingRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IFetchExperimentVideosReadyForMergingRequest
                     * @property {string|null} [experimentName] FetchExperimentVideosReadyForMergingRequest experimentName
                     */
    
                    /**
                     * Constructs a new FetchExperimentVideosReadyForMergingRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FetchExperimentVideosReadyForMergingRequest.
                     * @implements IFetchExperimentVideosReadyForMergingRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest=} [properties] Properties to set
                     */
                    function FetchExperimentVideosReadyForMergingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExperimentVideosReadyForMergingRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @instance
                     */
                    FetchExperimentVideosReadyForMergingRequest.prototype.experimentName = "";
    
                    /**
                     * Creates a new FetchExperimentVideosReadyForMergingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest} FetchExperimentVideosReadyForMergingRequest instance
                     */
                    FetchExperimentVideosReadyForMergingRequest.create = function create(properties) {
                        return new FetchExperimentVideosReadyForMergingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosReadyForMergingRequest message. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest} message FetchExperimentVideosReadyForMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosReadyForMergingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.experimentName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosReadyForMergingRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingRequest} message FetchExperimentVideosReadyForMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosReadyForMergingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosReadyForMergingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest} FetchExperimentVideosReadyForMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosReadyForMergingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experimentName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosReadyForMergingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest} FetchExperimentVideosReadyForMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosReadyForMergingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExperimentVideosReadyForMergingRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExperimentVideosReadyForMergingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchExperimentVideosReadyForMergingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest} FetchExperimentVideosReadyForMergingRequest
                     */
                    FetchExperimentVideosReadyForMergingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest();
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExperimentVideosReadyForMergingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest} message FetchExperimentVideosReadyForMergingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExperimentVideosReadyForMergingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experimentName = "";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        return object;
                    };
    
                    /**
                     * Converts this FetchExperimentVideosReadyForMergingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExperimentVideosReadyForMergingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExperimentVideosReadyForMergingRequest;
                })();
    
                v1.FetchExperimentVideosReadyForMergingResponse = (function() {
    
                    /**
                     * Properties of a FetchExperimentVideosReadyForMergingResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IFetchExperimentVideosReadyForMergingResponse
                     * @property {Array.<palexy.streaming.v1.IMergeItem>|null} [mergeItems] FetchExperimentVideosReadyForMergingResponse mergeItems
                     */
    
                    /**
                     * Constructs a new FetchExperimentVideosReadyForMergingResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FetchExperimentVideosReadyForMergingResponse.
                     * @implements IFetchExperimentVideosReadyForMergingResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingResponse=} [properties] Properties to set
                     */
                    function FetchExperimentVideosReadyForMergingResponse(properties) {
                        this.mergeItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExperimentVideosReadyForMergingResponse mergeItems.
                     * @member {Array.<palexy.streaming.v1.IMergeItem>} mergeItems
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @instance
                     */
                    FetchExperimentVideosReadyForMergingResponse.prototype.mergeItems = $util.emptyArray;
    
                    /**
                     * Creates a new FetchExperimentVideosReadyForMergingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} FetchExperimentVideosReadyForMergingResponse instance
                     */
                    FetchExperimentVideosReadyForMergingResponse.create = function create(properties) {
                        return new FetchExperimentVideosReadyForMergingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosReadyForMergingResponse message. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingResponse} message FetchExperimentVideosReadyForMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosReadyForMergingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeItems != null && message.mergeItems.length)
                            for (var i = 0; i < message.mergeItems.length; ++i)
                                $root.palexy.streaming.v1.MergeItem.encode(message.mergeItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosReadyForMergingResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosReadyForMergingResponse} message FetchExperimentVideosReadyForMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosReadyForMergingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosReadyForMergingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} FetchExperimentVideosReadyForMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosReadyForMergingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergeItems && message.mergeItems.length))
                                    message.mergeItems = [];
                                message.mergeItems.push($root.palexy.streaming.v1.MergeItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosReadyForMergingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} FetchExperimentVideosReadyForMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosReadyForMergingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExperimentVideosReadyForMergingResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExperimentVideosReadyForMergingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeItems != null && message.hasOwnProperty("mergeItems")) {
                            if (!Array.isArray(message.mergeItems))
                                return "mergeItems: array expected";
                            for (var i = 0; i < message.mergeItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergeItem.verify(message.mergeItems[i]);
                                if (error)
                                    return "mergeItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchExperimentVideosReadyForMergingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} FetchExperimentVideosReadyForMergingResponse
                     */
                    FetchExperimentVideosReadyForMergingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse();
                        if (object.mergeItems) {
                            if (!Array.isArray(object.mergeItems))
                                throw TypeError(".palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse.mergeItems: array expected");
                            message.mergeItems = [];
                            for (var i = 0; i < object.mergeItems.length; ++i) {
                                if (typeof object.mergeItems[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse.mergeItems: object expected");
                                message.mergeItems[i] = $root.palexy.streaming.v1.MergeItem.fromObject(object.mergeItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExperimentVideosReadyForMergingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse} message FetchExperimentVideosReadyForMergingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExperimentVideosReadyForMergingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergeItems = [];
                        if (message.mergeItems && message.mergeItems.length) {
                            object.mergeItems = [];
                            for (var j = 0; j < message.mergeItems.length; ++j)
                                object.mergeItems[j] = $root.palexy.streaming.v1.MergeItem.toObject(message.mergeItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchExperimentVideosReadyForMergingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosReadyForMergingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExperimentVideosReadyForMergingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExperimentVideosReadyForMergingResponse;
                })();
    
                v1.FetchExperimentVideosDoneMergingRequest = (function() {
    
                    /**
                     * Properties of a FetchExperimentVideosDoneMergingRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IFetchExperimentVideosDoneMergingRequest
                     * @property {string|null} [experimentName] FetchExperimentVideosDoneMergingRequest experimentName
                     */
    
                    /**
                     * Constructs a new FetchExperimentVideosDoneMergingRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FetchExperimentVideosDoneMergingRequest.
                     * @implements IFetchExperimentVideosDoneMergingRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest=} [properties] Properties to set
                     */
                    function FetchExperimentVideosDoneMergingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExperimentVideosDoneMergingRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @instance
                     */
                    FetchExperimentVideosDoneMergingRequest.prototype.experimentName = "";
    
                    /**
                     * Creates a new FetchExperimentVideosDoneMergingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest} FetchExperimentVideosDoneMergingRequest instance
                     */
                    FetchExperimentVideosDoneMergingRequest.create = function create(properties) {
                        return new FetchExperimentVideosDoneMergingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosDoneMergingRequest message. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest} message FetchExperimentVideosDoneMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosDoneMergingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.experimentName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosDoneMergingRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingRequest} message FetchExperimentVideosDoneMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosDoneMergingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosDoneMergingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest} FetchExperimentVideosDoneMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosDoneMergingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.experimentName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosDoneMergingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest} FetchExperimentVideosDoneMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosDoneMergingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExperimentVideosDoneMergingRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExperimentVideosDoneMergingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchExperimentVideosDoneMergingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest} FetchExperimentVideosDoneMergingRequest
                     */
                    FetchExperimentVideosDoneMergingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest();
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExperimentVideosDoneMergingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @static
                     * @param {palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest} message FetchExperimentVideosDoneMergingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExperimentVideosDoneMergingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.experimentName = "";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        return object;
                    };
    
                    /**
                     * Converts this FetchExperimentVideosDoneMergingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExperimentVideosDoneMergingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExperimentVideosDoneMergingRequest;
                })();
    
                v1.FetchExperimentVideosDoneMergingResponse = (function() {
    
                    /**
                     * Properties of a FetchExperimentVideosDoneMergingResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IFetchExperimentVideosDoneMergingResponse
                     * @property {Array.<palexy.streaming.v1.IMergeItem>|null} [mergeItems] FetchExperimentVideosDoneMergingResponse mergeItems
                     */
    
                    /**
                     * Constructs a new FetchExperimentVideosDoneMergingResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a FetchExperimentVideosDoneMergingResponse.
                     * @implements IFetchExperimentVideosDoneMergingResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingResponse=} [properties] Properties to set
                     */
                    function FetchExperimentVideosDoneMergingResponse(properties) {
                        this.mergeItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExperimentVideosDoneMergingResponse mergeItems.
                     * @member {Array.<palexy.streaming.v1.IMergeItem>} mergeItems
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @instance
                     */
                    FetchExperimentVideosDoneMergingResponse.prototype.mergeItems = $util.emptyArray;
    
                    /**
                     * Creates a new FetchExperimentVideosDoneMergingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} FetchExperimentVideosDoneMergingResponse instance
                     */
                    FetchExperimentVideosDoneMergingResponse.create = function create(properties) {
                        return new FetchExperimentVideosDoneMergingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosDoneMergingResponse message. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingResponse} message FetchExperimentVideosDoneMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosDoneMergingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeItems != null && message.mergeItems.length)
                            for (var i = 0; i < message.mergeItems.length; ++i)
                                $root.palexy.streaming.v1.MergeItem.encode(message.mergeItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExperimentVideosDoneMergingResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.IFetchExperimentVideosDoneMergingResponse} message FetchExperimentVideosDoneMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExperimentVideosDoneMergingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosDoneMergingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} FetchExperimentVideosDoneMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosDoneMergingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergeItems && message.mergeItems.length))
                                    message.mergeItems = [];
                                message.mergeItems.push($root.palexy.streaming.v1.MergeItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExperimentVideosDoneMergingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} FetchExperimentVideosDoneMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExperimentVideosDoneMergingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExperimentVideosDoneMergingResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExperimentVideosDoneMergingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeItems != null && message.hasOwnProperty("mergeItems")) {
                            if (!Array.isArray(message.mergeItems))
                                return "mergeItems: array expected";
                            for (var i = 0; i < message.mergeItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergeItem.verify(message.mergeItems[i]);
                                if (error)
                                    return "mergeItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchExperimentVideosDoneMergingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} FetchExperimentVideosDoneMergingResponse
                     */
                    FetchExperimentVideosDoneMergingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse();
                        if (object.mergeItems) {
                            if (!Array.isArray(object.mergeItems))
                                throw TypeError(".palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse.mergeItems: array expected");
                            message.mergeItems = [];
                            for (var i = 0; i < object.mergeItems.length; ++i) {
                                if (typeof object.mergeItems[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse.mergeItems: object expected");
                                message.mergeItems[i] = $root.palexy.streaming.v1.MergeItem.fromObject(object.mergeItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExperimentVideosDoneMergingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @static
                     * @param {palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse} message FetchExperimentVideosDoneMergingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExperimentVideosDoneMergingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergeItems = [];
                        if (message.mergeItems && message.mergeItems.length) {
                            object.mergeItems = [];
                            for (var j = 0; j < message.mergeItems.length; ++j)
                                object.mergeItems[j] = $root.palexy.streaming.v1.MergeItem.toObject(message.mergeItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchExperimentVideosDoneMergingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.FetchExperimentVideosDoneMergingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExperimentVideosDoneMergingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExperimentVideosDoneMergingResponse;
                })();
    
                v1.QcPlannerService = (function() {
    
                    /**
                     * Constructs a new QcPlannerService service.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcPlannerService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function QcPlannerService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (QcPlannerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = QcPlannerService;
    
                    /**
                     * Creates new QcPlannerService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {QcPlannerService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    QcPlannerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#listQcPeriodConfigs}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef ListQcPeriodConfigsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListQcPeriodConfigsResponse} [response] ListQcPeriodConfigsResponse
                     */
    
                    /**
                     * Calls ListQcPeriodConfigs.
                     * @function listQcPeriodConfigs
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest} request ListQcPeriodConfigsRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.ListQcPeriodConfigsCallback} callback Node-style callback called with the error, if any, and ListQcPeriodConfigsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.listQcPeriodConfigs = function listQcPeriodConfigs(request, callback) {
                        return this.rpcCall(listQcPeriodConfigs, $root.palexy.sherlock.v1.ListQcPeriodConfigsRequest, $root.palexy.sherlock.v1.ListQcPeriodConfigsResponse, request, callback);
                    }, "name", { value: "ListQcPeriodConfigs" });
    
                    /**
                     * Calls ListQcPeriodConfigs.
                     * @function listQcPeriodConfigs
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest} request ListQcPeriodConfigsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListQcPeriodConfigsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#createQcPeriodConfig}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef CreateQcPeriodConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateQcPeriodConfigResponse} [response] CreateQcPeriodConfigResponse
                     */
    
                    /**
                     * Calls CreateQcPeriodConfig.
                     * @function createQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest} request CreateQcPeriodConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.CreateQcPeriodConfigCallback} callback Node-style callback called with the error, if any, and CreateQcPeriodConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.createQcPeriodConfig = function createQcPeriodConfig(request, callback) {
                        return this.rpcCall(createQcPeriodConfig, $root.palexy.sherlock.v1.CreateQcPeriodConfigRequest, $root.palexy.sherlock.v1.CreateQcPeriodConfigResponse, request, callback);
                    }, "name", { value: "CreateQcPeriodConfig" });
    
                    /**
                     * Calls CreateQcPeriodConfig.
                     * @function createQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest} request CreateQcPeriodConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateQcPeriodConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#deleteQcPeriodConfig}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef DeleteQcPeriodConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} [response] DeleteQcPeriodConfigResponse
                     */
    
                    /**
                     * Calls DeleteQcPeriodConfig.
                     * @function deleteQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest} request DeleteQcPeriodConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.DeleteQcPeriodConfigCallback} callback Node-style callback called with the error, if any, and DeleteQcPeriodConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.deleteQcPeriodConfig = function deleteQcPeriodConfig(request, callback) {
                        return this.rpcCall(deleteQcPeriodConfig, $root.palexy.sherlock.v1.DeleteQcPeriodConfigRequest, $root.palexy.sherlock.v1.DeleteQcPeriodConfigResponse, request, callback);
                    }, "name", { value: "DeleteQcPeriodConfig" });
    
                    /**
                     * Calls DeleteQcPeriodConfig.
                     * @function deleteQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest} request DeleteQcPeriodConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.DeleteQcPeriodConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#updateQcPeriodConfig}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef UpdateQcPeriodConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} [response] UpdateQcPeriodConfigResponse
                     */
    
                    /**
                     * Calls UpdateQcPeriodConfig.
                     * @function updateQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest} request UpdateQcPeriodConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.UpdateQcPeriodConfigCallback} callback Node-style callback called with the error, if any, and UpdateQcPeriodConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.updateQcPeriodConfig = function updateQcPeriodConfig(request, callback) {
                        return this.rpcCall(updateQcPeriodConfig, $root.palexy.sherlock.v1.UpdateQcPeriodConfigRequest, $root.palexy.sherlock.v1.UpdateQcPeriodConfigResponse, request, callback);
                    }, "name", { value: "UpdateQcPeriodConfig" });
    
                    /**
                     * Calls UpdateQcPeriodConfig.
                     * @function updateQcPeriodConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest} request UpdateQcPeriodConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.UpdateQcPeriodConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#generatePlanForConfig}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef GeneratePlanForConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.GeneratePlanForConfigResponse} [response] GeneratePlanForConfigResponse
                     */
    
                    /**
                     * Calls GeneratePlanForConfig.
                     * @function generatePlanForConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest} request GeneratePlanForConfigRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.GeneratePlanForConfigCallback} callback Node-style callback called with the error, if any, and GeneratePlanForConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.generatePlanForConfig = function generatePlanForConfig(request, callback) {
                        return this.rpcCall(generatePlanForConfig, $root.palexy.sherlock.v1.GeneratePlanForConfigRequest, $root.palexy.sherlock.v1.GeneratePlanForConfigResponse, request, callback);
                    }, "name", { value: "GeneratePlanForConfig" });
    
                    /**
                     * Calls GeneratePlanForConfig.
                     * @function generatePlanForConfig
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest} request GeneratePlanForConfigRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.GeneratePlanForConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#listQcPlanItems}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef ListQcPlanItemsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.ListQcPlanItemsResponse} [response] ListQcPlanItemsResponse
                     */
    
                    /**
                     * Calls ListQcPlanItems.
                     * @function listQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest} request ListQcPlanItemsRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.ListQcPlanItemsCallback} callback Node-style callback called with the error, if any, and ListQcPlanItemsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.listQcPlanItems = function listQcPlanItems(request, callback) {
                        return this.rpcCall(listQcPlanItems, $root.palexy.sherlock.v1.ListQcPlanItemsRequest, $root.palexy.sherlock.v1.ListQcPlanItemsResponse, request, callback);
                    }, "name", { value: "ListQcPlanItems" });
    
                    /**
                     * Calls ListQcPlanItems.
                     * @function listQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest} request ListQcPlanItemsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.ListQcPlanItemsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#createQcPlanItem}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef CreateQcPlanItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.CreateQcPlanItemResponse} [response] CreateQcPlanItemResponse
                     */
    
                    /**
                     * Calls CreateQcPlanItem.
                     * @function createQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest} request CreateQcPlanItemRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.CreateQcPlanItemCallback} callback Node-style callback called with the error, if any, and CreateQcPlanItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.createQcPlanItem = function createQcPlanItem(request, callback) {
                        return this.rpcCall(createQcPlanItem, $root.palexy.sherlock.v1.CreateQcPlanItemRequest, $root.palexy.sherlock.v1.CreateQcPlanItemResponse, request, callback);
                    }, "name", { value: "CreateQcPlanItem" });
    
                    /**
                     * Calls CreateQcPlanItem.
                     * @function createQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest} request CreateQcPlanItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.CreateQcPlanItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#batchCreateQcPlanItems}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef BatchCreateQcPlanItemsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} [response] BatchCreateQcPlanItemsResponse
                     */
    
                    /**
                     * Calls BatchCreateQcPlanItems.
                     * @function batchCreateQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest} request BatchCreateQcPlanItemsRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.BatchCreateQcPlanItemsCallback} callback Node-style callback called with the error, if any, and BatchCreateQcPlanItemsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.batchCreateQcPlanItems = function batchCreateQcPlanItems(request, callback) {
                        return this.rpcCall(batchCreateQcPlanItems, $root.palexy.sherlock.v1.BatchCreateQcPlanItemsRequest, $root.palexy.sherlock.v1.BatchCreateQcPlanItemsResponse, request, callback);
                    }, "name", { value: "BatchCreateQcPlanItems" });
    
                    /**
                     * Calls BatchCreateQcPlanItems.
                     * @function batchCreateQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest} request BatchCreateQcPlanItemsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.BatchCreateQcPlanItemsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#deleteQcPlanItem}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef DeleteQcPlanItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.DeleteQcPlanItemResponse} [response] DeleteQcPlanItemResponse
                     */
    
                    /**
                     * Calls DeleteQcPlanItem.
                     * @function deleteQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest} request DeleteQcPlanItemRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.DeleteQcPlanItemCallback} callback Node-style callback called with the error, if any, and DeleteQcPlanItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.deleteQcPlanItem = function deleteQcPlanItem(request, callback) {
                        return this.rpcCall(deleteQcPlanItem, $root.palexy.sherlock.v1.DeleteQcPlanItemRequest, $root.palexy.sherlock.v1.DeleteQcPlanItemResponse, request, callback);
                    }, "name", { value: "DeleteQcPlanItem" });
    
                    /**
                     * Calls DeleteQcPlanItem.
                     * @function deleteQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest} request DeleteQcPlanItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.DeleteQcPlanItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#updateVideoTableForQcPlanItem}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef UpdateVideoTableForQcPlanItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} [response] UpdateVideoTableForQcPlanItemResponse
                     */
    
                    /**
                     * Calls UpdateVideoTableForQcPlanItem.
                     * @function updateVideoTableForQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest} request UpdateVideoTableForQcPlanItemRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.UpdateVideoTableForQcPlanItemCallback} callback Node-style callback called with the error, if any, and UpdateVideoTableForQcPlanItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.updateVideoTableForQcPlanItem = function updateVideoTableForQcPlanItem(request, callback) {
                        return this.rpcCall(updateVideoTableForQcPlanItem, $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest, $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse, request, callback);
                    }, "name", { value: "UpdateVideoTableForQcPlanItem" });
    
                    /**
                     * Calls UpdateVideoTableForQcPlanItem.
                     * @function updateVideoTableForQcPlanItem
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest} request UpdateVideoTableForQcPlanItemRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.sherlock.v1.QcPlannerService#batchDeleteQcPlanItems}.
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @typedef BatchDeleteQcPlanItemsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} [response] BatchDeleteQcPlanItemsResponse
                     */
    
                    /**
                     * Calls BatchDeleteQcPlanItems.
                     * @function batchDeleteQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest} request BatchDeleteQcPlanItemsRequest message or plain object
                     * @param {palexy.sherlock.v1.QcPlannerService.BatchDeleteQcPlanItemsCallback} callback Node-style callback called with the error, if any, and BatchDeleteQcPlanItemsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(QcPlannerService.prototype.batchDeleteQcPlanItems = function batchDeleteQcPlanItems(request, callback) {
                        return this.rpcCall(batchDeleteQcPlanItems, $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest, $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse, request, callback);
                    }, "name", { value: "BatchDeleteQcPlanItems" });
    
                    /**
                     * Calls BatchDeleteQcPlanItems.
                     * @function batchDeleteQcPlanItems
                     * @memberof palexy.sherlock.v1.QcPlannerService
                     * @instance
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest} request BatchDeleteQcPlanItemsRequest message or plain object
                     * @returns {Promise<palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse>} Promise
                     * @variation 2
                     */
    
                    return QcPlannerService;
                })();
    
                v1.ListQcPeriodConfigsRequest = (function() {
    
                    /**
                     * Properties of a ListQcPeriodConfigsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcPeriodConfigsRequest
                     * @property {number|null} [companyId] ListQcPeriodConfigsRequest companyId
                     */
    
                    /**
                     * Constructs a new ListQcPeriodConfigsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcPeriodConfigsRequest.
                     * @implements IListQcPeriodConfigsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest=} [properties] Properties to set
                     */
                    function ListQcPeriodConfigsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcPeriodConfigsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @instance
                     */
                    ListQcPeriodConfigsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListQcPeriodConfigsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsRequest} ListQcPeriodConfigsRequest instance
                     */
                    ListQcPeriodConfigsRequest.create = function create(properties) {
                        return new ListQcPeriodConfigsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcPeriodConfigsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListQcPeriodConfigsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest} message ListQcPeriodConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPeriodConfigsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcPeriodConfigsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcPeriodConfigsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsRequest} message ListQcPeriodConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPeriodConfigsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcPeriodConfigsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsRequest} ListQcPeriodConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPeriodConfigsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcPeriodConfigsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcPeriodConfigsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsRequest} ListQcPeriodConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPeriodConfigsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcPeriodConfigsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcPeriodConfigsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListQcPeriodConfigsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsRequest} ListQcPeriodConfigsRequest
                     */
                    ListQcPeriodConfigsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcPeriodConfigsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcPeriodConfigsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcPeriodConfigsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListQcPeriodConfigsRequest} message ListQcPeriodConfigsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcPeriodConfigsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListQcPeriodConfigsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcPeriodConfigsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcPeriodConfigsRequest;
                })();
    
                v1.ListQcPeriodConfigsResponse = (function() {
    
                    /**
                     * Properties of a ListQcPeriodConfigsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcPeriodConfigsResponse
                     * @property {Array.<palexy.sherlock.v1.IQcPeriodConfig>|null} [qcPeriodConfigs] ListQcPeriodConfigsResponse qcPeriodConfigs
                     */
    
                    /**
                     * Constructs a new ListQcPeriodConfigsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcPeriodConfigsResponse.
                     * @implements IListQcPeriodConfigsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsResponse=} [properties] Properties to set
                     */
                    function ListQcPeriodConfigsResponse(properties) {
                        this.qcPeriodConfigs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcPeriodConfigsResponse qcPeriodConfigs.
                     * @member {Array.<palexy.sherlock.v1.IQcPeriodConfig>} qcPeriodConfigs
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @instance
                     */
                    ListQcPeriodConfigsResponse.prototype.qcPeriodConfigs = $util.emptyArray;
    
                    /**
                     * Creates a new ListQcPeriodConfigsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsResponse} ListQcPeriodConfigsResponse instance
                     */
                    ListQcPeriodConfigsResponse.create = function create(properties) {
                        return new ListQcPeriodConfigsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcPeriodConfigsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListQcPeriodConfigsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsResponse} message ListQcPeriodConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPeriodConfigsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.qcPeriodConfigs != null && message.qcPeriodConfigs.length)
                            for (var i = 0; i < message.qcPeriodConfigs.length; ++i)
                                $root.palexy.sherlock.v1.QcPeriodConfig.encode(message.qcPeriodConfigs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcPeriodConfigsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcPeriodConfigsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPeriodConfigsResponse} message ListQcPeriodConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPeriodConfigsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcPeriodConfigsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsResponse} ListQcPeriodConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPeriodConfigsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcPeriodConfigsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.qcPeriodConfigs && message.qcPeriodConfigs.length))
                                    message.qcPeriodConfigs = [];
                                message.qcPeriodConfigs.push($root.palexy.sherlock.v1.QcPeriodConfig.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcPeriodConfigsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsResponse} ListQcPeriodConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPeriodConfigsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcPeriodConfigsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcPeriodConfigsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.qcPeriodConfigs != null && message.hasOwnProperty("qcPeriodConfigs")) {
                            if (!Array.isArray(message.qcPeriodConfigs))
                                return "qcPeriodConfigs: array expected";
                            for (var i = 0; i < message.qcPeriodConfigs.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcPeriodConfig.verify(message.qcPeriodConfigs[i]);
                                if (error)
                                    return "qcPeriodConfigs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListQcPeriodConfigsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcPeriodConfigsResponse} ListQcPeriodConfigsResponse
                     */
                    ListQcPeriodConfigsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcPeriodConfigsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcPeriodConfigsResponse();
                        if (object.qcPeriodConfigs) {
                            if (!Array.isArray(object.qcPeriodConfigs))
                                throw TypeError(".palexy.sherlock.v1.ListQcPeriodConfigsResponse.qcPeriodConfigs: array expected");
                            message.qcPeriodConfigs = [];
                            for (var i = 0; i < object.qcPeriodConfigs.length; ++i) {
                                if (typeof object.qcPeriodConfigs[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListQcPeriodConfigsResponse.qcPeriodConfigs: object expected");
                                message.qcPeriodConfigs[i] = $root.palexy.sherlock.v1.QcPeriodConfig.fromObject(object.qcPeriodConfigs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcPeriodConfigsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListQcPeriodConfigsResponse} message ListQcPeriodConfigsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcPeriodConfigsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.qcPeriodConfigs = [];
                        if (message.qcPeriodConfigs && message.qcPeriodConfigs.length) {
                            object.qcPeriodConfigs = [];
                            for (var j = 0; j < message.qcPeriodConfigs.length; ++j)
                                object.qcPeriodConfigs[j] = $root.palexy.sherlock.v1.QcPeriodConfig.toObject(message.qcPeriodConfigs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListQcPeriodConfigsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcPeriodConfigsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcPeriodConfigsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcPeriodConfigsResponse;
                })();
    
                v1.QcPeriodConfig = (function() {
    
                    /**
                     * Properties of a QcPeriodConfig.
                     * @memberof palexy.sherlock.v1
                     * @interface IQcPeriodConfig
                     * @property {number|null} [id] QcPeriodConfig id
                     * @property {string|null} [name] QcPeriodConfig name
                     * @property {number|null} [companyId] QcPeriodConfig companyId
                     * @property {string|null} [startingDateId] QcPeriodConfig startingDateId
                     * @property {number|null} [numDaysInPeriod] QcPeriodConfig numDaysInPeriod
                     * @property {number|null} [percentageOfStore] QcPeriodConfig percentageOfStore
                     * @property {number|null} [numQcDaysPerStore] QcPeriodConfig numQcDaysPerStore
                     * @property {boolean|null} [isActive] QcPeriodConfig isActive
                     * @property {string|null} [creator] QcPeriodConfig creator
                     * @property {number|null} [createTimeMs] QcPeriodConfig createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] QcPeriodConfig lastUpdateTimeMs
                     * @property {string|null} [plannedUntilDateId] QcPeriodConfig plannedUntilDateId
                     * @property {number|null} [planDetailLastGenerateTimeMs] QcPeriodConfig planDetailLastGenerateTimeMs
                     * @property {string|null} [displayName] QcPeriodConfig displayName
                     */
    
                    /**
                     * Constructs a new QcPeriodConfig.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcPeriodConfig.
                     * @implements IQcPeriodConfig
                     * @constructor
                     * @param {palexy.sherlock.v1.IQcPeriodConfig=} [properties] Properties to set
                     */
                    function QcPeriodConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QcPeriodConfig id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPeriodConfig name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.name = "";
    
                    /**
                     * QcPeriodConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPeriodConfig startingDateId.
                     * @member {string} startingDateId
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.startingDateId = "";
    
                    /**
                     * QcPeriodConfig numDaysInPeriod.
                     * @member {number} numDaysInPeriod
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.numDaysInPeriod = 0;
    
                    /**
                     * QcPeriodConfig percentageOfStore.
                     * @member {number} percentageOfStore
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.percentageOfStore = 0;
    
                    /**
                     * QcPeriodConfig numQcDaysPerStore.
                     * @member {number} numQcDaysPerStore
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.numQcDaysPerStore = 0;
    
                    /**
                     * QcPeriodConfig isActive.
                     * @member {boolean} isActive
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.isActive = false;
    
                    /**
                     * QcPeriodConfig creator.
                     * @member {string} creator
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.creator = "";
    
                    /**
                     * QcPeriodConfig createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPeriodConfig lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPeriodConfig plannedUntilDateId.
                     * @member {string} plannedUntilDateId
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.plannedUntilDateId = "";
    
                    /**
                     * QcPeriodConfig planDetailLastGenerateTimeMs.
                     * @member {number} planDetailLastGenerateTimeMs
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.planDetailLastGenerateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPeriodConfig displayName.
                     * @member {string} displayName
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     */
                    QcPeriodConfig.prototype.displayName = "";
    
                    /**
                     * Creates a new QcPeriodConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcPeriodConfig=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.QcPeriodConfig} QcPeriodConfig instance
                     */
                    QcPeriodConfig.create = function create(properties) {
                        return new QcPeriodConfig(properties);
                    };
    
                    /**
                     * Encodes the specified QcPeriodConfig message. Does not implicitly {@link palexy.sherlock.v1.QcPeriodConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcPeriodConfig} message QcPeriodConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcPeriodConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.companyId);
                        if (message.startingDateId != null && Object.hasOwnProperty.call(message, "startingDateId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.startingDateId);
                        if (message.numDaysInPeriod != null && Object.hasOwnProperty.call(message, "numDaysInPeriod"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.numDaysInPeriod);
                        if (message.percentageOfStore != null && Object.hasOwnProperty.call(message, "percentageOfStore"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.percentageOfStore);
                        if (message.numQcDaysPerStore != null && Object.hasOwnProperty.call(message, "numQcDaysPerStore"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.numQcDaysPerStore);
                        if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isActive);
                        if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.creator);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.lastUpdateTimeMs);
                        if (message.plannedUntilDateId != null && Object.hasOwnProperty.call(message, "plannedUntilDateId"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.plannedUntilDateId);
                        if (message.planDetailLastGenerateTimeMs != null && Object.hasOwnProperty.call(message, "planDetailLastGenerateTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.planDetailLastGenerateTimeMs);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.displayName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QcPeriodConfig message, length delimited. Does not implicitly {@link palexy.sherlock.v1.QcPeriodConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {palexy.sherlock.v1.IQcPeriodConfig} message QcPeriodConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcPeriodConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QcPeriodConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.QcPeriodConfig} QcPeriodConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcPeriodConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.QcPeriodConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.companyId = reader.int64();
                                break;
                            case 4:
                                message.startingDateId = reader.string();
                                break;
                            case 5:
                                message.numDaysInPeriod = reader.int32();
                                break;
                            case 6:
                                message.percentageOfStore = reader.int32();
                                break;
                            case 7:
                                message.numQcDaysPerStore = reader.int32();
                                break;
                            case 8:
                                message.isActive = reader.bool();
                                break;
                            case 9:
                                message.creator = reader.string();
                                break;
                            case 10:
                                message.createTimeMs = reader.int64();
                                break;
                            case 11:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 12:
                                message.plannedUntilDateId = reader.string();
                                break;
                            case 13:
                                message.planDetailLastGenerateTimeMs = reader.int64();
                                break;
                            case 14:
                                message.displayName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QcPeriodConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.QcPeriodConfig} QcPeriodConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcPeriodConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QcPeriodConfig message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QcPeriodConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.startingDateId != null && message.hasOwnProperty("startingDateId"))
                            if (!$util.isString(message.startingDateId))
                                return "startingDateId: string expected";
                        if (message.numDaysInPeriod != null && message.hasOwnProperty("numDaysInPeriod"))
                            if (!$util.isInteger(message.numDaysInPeriod))
                                return "numDaysInPeriod: integer expected";
                        if (message.percentageOfStore != null && message.hasOwnProperty("percentageOfStore"))
                            if (!$util.isInteger(message.percentageOfStore))
                                return "percentageOfStore: integer expected";
                        if (message.numQcDaysPerStore != null && message.hasOwnProperty("numQcDaysPerStore"))
                            if (!$util.isInteger(message.numQcDaysPerStore))
                                return "numQcDaysPerStore: integer expected";
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            if (typeof message.isActive !== "boolean")
                                return "isActive: boolean expected";
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            if (!$util.isString(message.creator))
                                return "creator: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.plannedUntilDateId != null && message.hasOwnProperty("plannedUntilDateId"))
                            if (!$util.isString(message.plannedUntilDateId))
                                return "plannedUntilDateId: string expected";
                        if (message.planDetailLastGenerateTimeMs != null && message.hasOwnProperty("planDetailLastGenerateTimeMs"))
                            if (!$util.isInteger(message.planDetailLastGenerateTimeMs) && !(message.planDetailLastGenerateTimeMs && $util.isInteger(message.planDetailLastGenerateTimeMs.low) && $util.isInteger(message.planDetailLastGenerateTimeMs.high)))
                                return "planDetailLastGenerateTimeMs: integer|Long expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a QcPeriodConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.QcPeriodConfig} QcPeriodConfig
                     */
                    QcPeriodConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.QcPeriodConfig)
                            return object;
                        var message = new $root.palexy.sherlock.v1.QcPeriodConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.startingDateId != null)
                            message.startingDateId = String(object.startingDateId);
                        if (object.numDaysInPeriod != null)
                            message.numDaysInPeriod = object.numDaysInPeriod | 0;
                        if (object.percentageOfStore != null)
                            message.percentageOfStore = object.percentageOfStore | 0;
                        if (object.numQcDaysPerStore != null)
                            message.numQcDaysPerStore = object.numQcDaysPerStore | 0;
                        if (object.isActive != null)
                            message.isActive = Boolean(object.isActive);
                        if (object.creator != null)
                            message.creator = String(object.creator);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.plannedUntilDateId != null)
                            message.plannedUntilDateId = String(object.plannedUntilDateId);
                        if (object.planDetailLastGenerateTimeMs != null)
                            if ($util.Long)
                                (message.planDetailLastGenerateTimeMs = $util.Long.fromValue(object.planDetailLastGenerateTimeMs)).unsigned = false;
                            else if (typeof object.planDetailLastGenerateTimeMs === "string")
                                message.planDetailLastGenerateTimeMs = parseInt(object.planDetailLastGenerateTimeMs, 10);
                            else if (typeof object.planDetailLastGenerateTimeMs === "number")
                                message.planDetailLastGenerateTimeMs = object.planDetailLastGenerateTimeMs;
                            else if (typeof object.planDetailLastGenerateTimeMs === "object")
                                message.planDetailLastGenerateTimeMs = new $util.LongBits(object.planDetailLastGenerateTimeMs.low >>> 0, object.planDetailLastGenerateTimeMs.high >>> 0).toNumber();
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QcPeriodConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @static
                     * @param {palexy.sherlock.v1.QcPeriodConfig} message QcPeriodConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QcPeriodConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startingDateId = "";
                            object.numDaysInPeriod = 0;
                            object.percentageOfStore = 0;
                            object.numQcDaysPerStore = 0;
                            object.isActive = false;
                            object.creator = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.plannedUntilDateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.planDetailLastGenerateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.planDetailLastGenerateTimeMs = options.longs === String ? "0" : 0;
                            object.displayName = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.startingDateId != null && message.hasOwnProperty("startingDateId"))
                            object.startingDateId = message.startingDateId;
                        if (message.numDaysInPeriod != null && message.hasOwnProperty("numDaysInPeriod"))
                            object.numDaysInPeriod = message.numDaysInPeriod;
                        if (message.percentageOfStore != null && message.hasOwnProperty("percentageOfStore"))
                            object.percentageOfStore = message.percentageOfStore;
                        if (message.numQcDaysPerStore != null && message.hasOwnProperty("numQcDaysPerStore"))
                            object.numQcDaysPerStore = message.numQcDaysPerStore;
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            object.isActive = message.isActive;
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            object.creator = message.creator;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.plannedUntilDateId != null && message.hasOwnProperty("plannedUntilDateId"))
                            object.plannedUntilDateId = message.plannedUntilDateId;
                        if (message.planDetailLastGenerateTimeMs != null && message.hasOwnProperty("planDetailLastGenerateTimeMs"))
                            if (typeof message.planDetailLastGenerateTimeMs === "number")
                                object.planDetailLastGenerateTimeMs = options.longs === String ? String(message.planDetailLastGenerateTimeMs) : message.planDetailLastGenerateTimeMs;
                            else
                                object.planDetailLastGenerateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.planDetailLastGenerateTimeMs) : options.longs === Number ? new $util.LongBits(message.planDetailLastGenerateTimeMs.low >>> 0, message.planDetailLastGenerateTimeMs.high >>> 0).toNumber() : message.planDetailLastGenerateTimeMs;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        return object;
                    };
    
                    /**
                     * Converts this QcPeriodConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.QcPeriodConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QcPeriodConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QcPeriodConfig;
                })();
    
                v1.CreateQcPeriodConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateQcPeriodConfigRequest
                     * @property {palexy.sherlock.v1.IQcPeriodConfig|null} [periodConfig] CreateQcPeriodConfigRequest periodConfig
                     */
    
                    /**
                     * Constructs a new CreateQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateQcPeriodConfigRequest.
                     * @implements ICreateQcPeriodConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest=} [properties] Properties to set
                     */
                    function CreateQcPeriodConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateQcPeriodConfigRequest periodConfig.
                     * @member {palexy.sherlock.v1.IQcPeriodConfig|null|undefined} periodConfig
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @instance
                     */
                    CreateQcPeriodConfigRequest.prototype.periodConfig = null;
    
                    /**
                     * Creates a new CreateQcPeriodConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigRequest} CreateQcPeriodConfigRequest instance
                     */
                    CreateQcPeriodConfigRequest.create = function create(properties) {
                        return new CreateQcPeriodConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateQcPeriodConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateQcPeriodConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest} message CreateQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPeriodConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.periodConfig != null && Object.hasOwnProperty.call(message, "periodConfig"))
                            $root.palexy.sherlock.v1.QcPeriodConfig.encode(message.periodConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateQcPeriodConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateQcPeriodConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigRequest} message CreateQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPeriodConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateQcPeriodConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigRequest} CreateQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPeriodConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateQcPeriodConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateQcPeriodConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigRequest} CreateQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPeriodConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateQcPeriodConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateQcPeriodConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.periodConfig != null && message.hasOwnProperty("periodConfig")) {
                            var error = $root.palexy.sherlock.v1.QcPeriodConfig.verify(message.periodConfig);
                            if (error)
                                return "periodConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateQcPeriodConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigRequest} CreateQcPeriodConfigRequest
                     */
                    CreateQcPeriodConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateQcPeriodConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateQcPeriodConfigRequest();
                        if (object.periodConfig != null) {
                            if (typeof object.periodConfig !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateQcPeriodConfigRequest.periodConfig: object expected");
                            message.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.fromObject(object.periodConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateQcPeriodConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateQcPeriodConfigRequest} message CreateQcPeriodConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateQcPeriodConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.periodConfig = null;
                        if (message.periodConfig != null && message.hasOwnProperty("periodConfig"))
                            object.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.toObject(message.periodConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateQcPeriodConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateQcPeriodConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateQcPeriodConfigRequest;
                })();
    
                v1.CreateQcPeriodConfigResponse = (function() {
    
                    /**
                     * Properties of a CreateQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateQcPeriodConfigResponse
                     * @property {palexy.sherlock.v1.IQcPeriodConfig|null} [periodConfig] CreateQcPeriodConfigResponse periodConfig
                     */
    
                    /**
                     * Constructs a new CreateQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateQcPeriodConfigResponse.
                     * @implements ICreateQcPeriodConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigResponse=} [properties] Properties to set
                     */
                    function CreateQcPeriodConfigResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateQcPeriodConfigResponse periodConfig.
                     * @member {palexy.sherlock.v1.IQcPeriodConfig|null|undefined} periodConfig
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @instance
                     */
                    CreateQcPeriodConfigResponse.prototype.periodConfig = null;
    
                    /**
                     * Creates a new CreateQcPeriodConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigResponse} CreateQcPeriodConfigResponse instance
                     */
                    CreateQcPeriodConfigResponse.create = function create(properties) {
                        return new CreateQcPeriodConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateQcPeriodConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateQcPeriodConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigResponse} message CreateQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPeriodConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.periodConfig != null && Object.hasOwnProperty.call(message, "periodConfig"))
                            $root.palexy.sherlock.v1.QcPeriodConfig.encode(message.periodConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateQcPeriodConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateQcPeriodConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPeriodConfigResponse} message CreateQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPeriodConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateQcPeriodConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigResponse} CreateQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPeriodConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateQcPeriodConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateQcPeriodConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigResponse} CreateQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPeriodConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateQcPeriodConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateQcPeriodConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.periodConfig != null && message.hasOwnProperty("periodConfig")) {
                            var error = $root.palexy.sherlock.v1.QcPeriodConfig.verify(message.periodConfig);
                            if (error)
                                return "periodConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateQcPeriodConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateQcPeriodConfigResponse} CreateQcPeriodConfigResponse
                     */
                    CreateQcPeriodConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateQcPeriodConfigResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateQcPeriodConfigResponse();
                        if (object.periodConfig != null) {
                            if (typeof object.periodConfig !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateQcPeriodConfigResponse.periodConfig: object expected");
                            message.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.fromObject(object.periodConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateQcPeriodConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateQcPeriodConfigResponse} message CreateQcPeriodConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateQcPeriodConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.periodConfig = null;
                        if (message.periodConfig != null && message.hasOwnProperty("periodConfig"))
                            object.periodConfig = $root.palexy.sherlock.v1.QcPeriodConfig.toObject(message.periodConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateQcPeriodConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateQcPeriodConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateQcPeriodConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateQcPeriodConfigResponse;
                })();
    
                v1.DeleteQcPeriodConfigRequest = (function() {
    
                    /**
                     * Properties of a DeleteQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcPeriodConfigRequest
                     * @property {string|null} [name] DeleteQcPeriodConfigRequest name
                     */
    
                    /**
                     * Constructs a new DeleteQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcPeriodConfigRequest.
                     * @implements IDeleteQcPeriodConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest=} [properties] Properties to set
                     */
                    function DeleteQcPeriodConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteQcPeriodConfigRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @instance
                     */
                    DeleteQcPeriodConfigRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteQcPeriodConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigRequest} DeleteQcPeriodConfigRequest instance
                     */
                    DeleteQcPeriodConfigRequest.create = function create(properties) {
                        return new DeleteQcPeriodConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcPeriodConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPeriodConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest} message DeleteQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPeriodConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcPeriodConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPeriodConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigRequest} message DeleteQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPeriodConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcPeriodConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigRequest} DeleteQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPeriodConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcPeriodConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcPeriodConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigRequest} DeleteQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPeriodConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcPeriodConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcPeriodConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcPeriodConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigRequest} DeleteQcPeriodConfigRequest
                     */
                    DeleteQcPeriodConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcPeriodConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DeleteQcPeriodConfigRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcPeriodConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcPeriodConfigRequest} message DeleteQcPeriodConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcPeriodConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteQcPeriodConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcPeriodConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcPeriodConfigRequest;
                })();
    
                v1.DeleteQcPeriodConfigResponse = (function() {
    
                    /**
                     * Properties of a DeleteQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcPeriodConfigResponse
                     */
    
                    /**
                     * Constructs a new DeleteQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcPeriodConfigResponse.
                     * @implements IDeleteQcPeriodConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigResponse=} [properties] Properties to set
                     */
                    function DeleteQcPeriodConfigResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new DeleteQcPeriodConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} DeleteQcPeriodConfigResponse instance
                     */
                    DeleteQcPeriodConfigResponse.create = function create(properties) {
                        return new DeleteQcPeriodConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcPeriodConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPeriodConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigResponse} message DeleteQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPeriodConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcPeriodConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPeriodConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPeriodConfigResponse} message DeleteQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPeriodConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcPeriodConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} DeleteQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPeriodConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcPeriodConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcPeriodConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} DeleteQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPeriodConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcPeriodConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcPeriodConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcPeriodConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} DeleteQcPeriodConfigResponse
                     */
                    DeleteQcPeriodConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcPeriodConfigResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.DeleteQcPeriodConfigResponse();
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcPeriodConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcPeriodConfigResponse} message DeleteQcPeriodConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcPeriodConfigResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this DeleteQcPeriodConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcPeriodConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcPeriodConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcPeriodConfigResponse;
                })();
    
                v1.UpdateQcPeriodConfigRequest = (function() {
    
                    /**
                     * Properties of an UpdateQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateQcPeriodConfigRequest
                     * @property {palexy.sherlock.v1.IQcPeriodConfig|null} [config] UpdateQcPeriodConfigRequest config
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateQcPeriodConfigRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateQcPeriodConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateQcPeriodConfigRequest.
                     * @implements IUpdateQcPeriodConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest=} [properties] Properties to set
                     */
                    function UpdateQcPeriodConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateQcPeriodConfigRequest config.
                     * @member {palexy.sherlock.v1.IQcPeriodConfig|null|undefined} config
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @instance
                     */
                    UpdateQcPeriodConfigRequest.prototype.config = null;
    
                    /**
                     * UpdateQcPeriodConfigRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @instance
                     */
                    UpdateQcPeriodConfigRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateQcPeriodConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigRequest} UpdateQcPeriodConfigRequest instance
                     */
                    UpdateQcPeriodConfigRequest.create = function create(properties) {
                        return new UpdateQcPeriodConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateQcPeriodConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateQcPeriodConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest} message UpdateQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateQcPeriodConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.sherlock.v1.QcPeriodConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateQcPeriodConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateQcPeriodConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigRequest} message UpdateQcPeriodConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateQcPeriodConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateQcPeriodConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigRequest} UpdateQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateQcPeriodConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateQcPeriodConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.sherlock.v1.QcPeriodConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateQcPeriodConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigRequest} UpdateQcPeriodConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateQcPeriodConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateQcPeriodConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateQcPeriodConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.sherlock.v1.QcPeriodConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateQcPeriodConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigRequest} UpdateQcPeriodConfigRequest
                     */
                    UpdateQcPeriodConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateQcPeriodConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateQcPeriodConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateQcPeriodConfigRequest.config: object expected");
                            message.config = $root.palexy.sherlock.v1.QcPeriodConfig.fromObject(object.config);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateQcPeriodConfigRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateQcPeriodConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateQcPeriodConfigRequest} message UpdateQcPeriodConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateQcPeriodConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.config = null;
                            object.updateMask = null;
                        }
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.sherlock.v1.QcPeriodConfig.toObject(message.config, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateQcPeriodConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateQcPeriodConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateQcPeriodConfigRequest;
                })();
    
                v1.UpdateQcPeriodConfigResponse = (function() {
    
                    /**
                     * Properties of an UpdateQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateQcPeriodConfigResponse
                     * @property {palexy.sherlock.v1.IQcPeriodConfig|null} [config] UpdateQcPeriodConfigResponse config
                     */
    
                    /**
                     * Constructs a new UpdateQcPeriodConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateQcPeriodConfigResponse.
                     * @implements IUpdateQcPeriodConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigResponse=} [properties] Properties to set
                     */
                    function UpdateQcPeriodConfigResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateQcPeriodConfigResponse config.
                     * @member {palexy.sherlock.v1.IQcPeriodConfig|null|undefined} config
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @instance
                     */
                    UpdateQcPeriodConfigResponse.prototype.config = null;
    
                    /**
                     * Creates a new UpdateQcPeriodConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} UpdateQcPeriodConfigResponse instance
                     */
                    UpdateQcPeriodConfigResponse.create = function create(properties) {
                        return new UpdateQcPeriodConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateQcPeriodConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.UpdateQcPeriodConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigResponse} message UpdateQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateQcPeriodConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.sherlock.v1.QcPeriodConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateQcPeriodConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateQcPeriodConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateQcPeriodConfigResponse} message UpdateQcPeriodConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateQcPeriodConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateQcPeriodConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} UpdateQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateQcPeriodConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateQcPeriodConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.sherlock.v1.QcPeriodConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateQcPeriodConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} UpdateQcPeriodConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateQcPeriodConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateQcPeriodConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateQcPeriodConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.sherlock.v1.QcPeriodConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateQcPeriodConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} UpdateQcPeriodConfigResponse
                     */
                    UpdateQcPeriodConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateQcPeriodConfigResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateQcPeriodConfigResponse();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.sherlock.v1.UpdateQcPeriodConfigResponse.config: object expected");
                            message.config = $root.palexy.sherlock.v1.QcPeriodConfig.fromObject(object.config);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateQcPeriodConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.UpdateQcPeriodConfigResponse} message UpdateQcPeriodConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateQcPeriodConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.config = null;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.sherlock.v1.QcPeriodConfig.toObject(message.config, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateQcPeriodConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateQcPeriodConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateQcPeriodConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateQcPeriodConfigResponse;
                })();
    
                v1.QcPlanItem = (function() {
    
                    /**
                     * Properties of a QcPlanItem.
                     * @memberof palexy.sherlock.v1
                     * @interface IQcPlanItem
                     * @property {number|null} [id] QcPlanItem id
                     * @property {string|null} [name] QcPlanItem name
                     * @property {number|null} [periodConfigId] QcPlanItem periodConfigId
                     * @property {number|null} [companyId] QcPlanItem companyId
                     * @property {number|null} [storeId] QcPlanItem storeId
                     * @property {string|null} [dateId] QcPlanItem dateId
                     * @property {number|null} [createTimeMs] QcPlanItem createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] QcPlanItem lastUpdateTimeMs
                     * @property {boolean|null} [isCustomItem] QcPlanItem isCustomItem
                     * @property {boolean|null} [isAppliedToVideoTable] QcPlanItem isAppliedToVideoTable
                     * @property {number|null} [videoTableAppliedTimeMs] QcPlanItem videoTableAppliedTimeMs
                     */
    
                    /**
                     * Constructs a new QcPlanItem.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a QcPlanItem.
                     * @implements IQcPlanItem
                     * @constructor
                     * @param {palexy.sherlock.v1.IQcPlanItem=} [properties] Properties to set
                     */
                    function QcPlanItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QcPlanItem id.
                     * @member {number} id
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.name = "";
    
                    /**
                     * QcPlanItem periodConfigId.
                     * @member {number} periodConfigId
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.periodConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem companyId.
                     * @member {number} companyId
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem dateId.
                     * @member {string} dateId
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.dateId = "";
    
                    /**
                     * QcPlanItem createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * QcPlanItem isCustomItem.
                     * @member {boolean} isCustomItem
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.isCustomItem = false;
    
                    /**
                     * QcPlanItem isAppliedToVideoTable.
                     * @member {boolean} isAppliedToVideoTable
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.isAppliedToVideoTable = false;
    
                    /**
                     * QcPlanItem videoTableAppliedTimeMs.
                     * @member {number} videoTableAppliedTimeMs
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     */
                    QcPlanItem.prototype.videoTableAppliedTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new QcPlanItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {palexy.sherlock.v1.IQcPlanItem=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.QcPlanItem} QcPlanItem instance
                     */
                    QcPlanItem.create = function create(properties) {
                        return new QcPlanItem(properties);
                    };
    
                    /**
                     * Encodes the specified QcPlanItem message. Does not implicitly {@link palexy.sherlock.v1.QcPlanItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {palexy.sherlock.v1.IQcPlanItem} message QcPlanItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcPlanItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.periodConfigId != null && Object.hasOwnProperty.call(message, "periodConfigId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.periodConfigId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.dateId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                        if (message.isCustomItem != null && Object.hasOwnProperty.call(message, "isCustomItem"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isCustomItem);
                        if (message.isAppliedToVideoTable != null && Object.hasOwnProperty.call(message, "isAppliedToVideoTable"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isAppliedToVideoTable);
                        if (message.videoTableAppliedTimeMs != null && Object.hasOwnProperty.call(message, "videoTableAppliedTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.videoTableAppliedTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QcPlanItem message, length delimited. Does not implicitly {@link palexy.sherlock.v1.QcPlanItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {palexy.sherlock.v1.IQcPlanItem} message QcPlanItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QcPlanItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QcPlanItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.QcPlanItem} QcPlanItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcPlanItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.QcPlanItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.periodConfigId = reader.int64();
                                break;
                            case 4:
                                message.companyId = reader.int64();
                                break;
                            case 5:
                                message.storeId = reader.int64();
                                break;
                            case 6:
                                message.dateId = reader.string();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 9:
                                message.isCustomItem = reader.bool();
                                break;
                            case 10:
                                message.isAppliedToVideoTable = reader.bool();
                                break;
                            case 11:
                                message.videoTableAppliedTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QcPlanItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.QcPlanItem} QcPlanItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QcPlanItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QcPlanItem message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QcPlanItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (!$util.isInteger(message.periodConfigId) && !(message.periodConfigId && $util.isInteger(message.periodConfigId.low) && $util.isInteger(message.periodConfigId.high)))
                                return "periodConfigId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.isCustomItem != null && message.hasOwnProperty("isCustomItem"))
                            if (typeof message.isCustomItem !== "boolean")
                                return "isCustomItem: boolean expected";
                        if (message.isAppliedToVideoTable != null && message.hasOwnProperty("isAppliedToVideoTable"))
                            if (typeof message.isAppliedToVideoTable !== "boolean")
                                return "isAppliedToVideoTable: boolean expected";
                        if (message.videoTableAppliedTimeMs != null && message.hasOwnProperty("videoTableAppliedTimeMs"))
                            if (!$util.isInteger(message.videoTableAppliedTimeMs) && !(message.videoTableAppliedTimeMs && $util.isInteger(message.videoTableAppliedTimeMs.low) && $util.isInteger(message.videoTableAppliedTimeMs.high)))
                                return "videoTableAppliedTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a QcPlanItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.QcPlanItem} QcPlanItem
                     */
                    QcPlanItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.QcPlanItem)
                            return object;
                        var message = new $root.palexy.sherlock.v1.QcPlanItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.periodConfigId != null)
                            if ($util.Long)
                                (message.periodConfigId = $util.Long.fromValue(object.periodConfigId)).unsigned = false;
                            else if (typeof object.periodConfigId === "string")
                                message.periodConfigId = parseInt(object.periodConfigId, 10);
                            else if (typeof object.periodConfigId === "number")
                                message.periodConfigId = object.periodConfigId;
                            else if (typeof object.periodConfigId === "object")
                                message.periodConfigId = new $util.LongBits(object.periodConfigId.low >>> 0, object.periodConfigId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.isCustomItem != null)
                            message.isCustomItem = Boolean(object.isCustomItem);
                        if (object.isAppliedToVideoTable != null)
                            message.isAppliedToVideoTable = Boolean(object.isAppliedToVideoTable);
                        if (object.videoTableAppliedTimeMs != null)
                            if ($util.Long)
                                (message.videoTableAppliedTimeMs = $util.Long.fromValue(object.videoTableAppliedTimeMs)).unsigned = false;
                            else if (typeof object.videoTableAppliedTimeMs === "string")
                                message.videoTableAppliedTimeMs = parseInt(object.videoTableAppliedTimeMs, 10);
                            else if (typeof object.videoTableAppliedTimeMs === "number")
                                message.videoTableAppliedTimeMs = object.videoTableAppliedTimeMs;
                            else if (typeof object.videoTableAppliedTimeMs === "object")
                                message.videoTableAppliedTimeMs = new $util.LongBits(object.videoTableAppliedTimeMs.low >>> 0, object.videoTableAppliedTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QcPlanItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @static
                     * @param {palexy.sherlock.v1.QcPlanItem} message QcPlanItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QcPlanItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.periodConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.periodConfigId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.isCustomItem = false;
                            object.isAppliedToVideoTable = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.videoTableAppliedTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.videoTableAppliedTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (typeof message.periodConfigId === "number")
                                object.periodConfigId = options.longs === String ? String(message.periodConfigId) : message.periodConfigId;
                            else
                                object.periodConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.periodConfigId) : options.longs === Number ? new $util.LongBits(message.periodConfigId.low >>> 0, message.periodConfigId.high >>> 0).toNumber() : message.periodConfigId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.isCustomItem != null && message.hasOwnProperty("isCustomItem"))
                            object.isCustomItem = message.isCustomItem;
                        if (message.isAppliedToVideoTable != null && message.hasOwnProperty("isAppliedToVideoTable"))
                            object.isAppliedToVideoTable = message.isAppliedToVideoTable;
                        if (message.videoTableAppliedTimeMs != null && message.hasOwnProperty("videoTableAppliedTimeMs"))
                            if (typeof message.videoTableAppliedTimeMs === "number")
                                object.videoTableAppliedTimeMs = options.longs === String ? String(message.videoTableAppliedTimeMs) : message.videoTableAppliedTimeMs;
                            else
                                object.videoTableAppliedTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.videoTableAppliedTimeMs) : options.longs === Number ? new $util.LongBits(message.videoTableAppliedTimeMs.low >>> 0, message.videoTableAppliedTimeMs.high >>> 0).toNumber() : message.videoTableAppliedTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this QcPlanItem to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.QcPlanItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QcPlanItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QcPlanItem;
                })();
    
                v1.ListQcPlanItemsRequest = (function() {
    
                    /**
                     * Properties of a ListQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcPlanItemsRequest
                     * @property {number|null} [periodConfigId] ListQcPlanItemsRequest periodConfigId
                     * @property {number|null} [companyId] ListQcPlanItemsRequest companyId
                     * @property {palexy.sherlock.v1.IBoolValue|null} [isCustomItem] ListQcPlanItemsRequest isCustomItem
                     * @property {string|null} [fromDate] ListQcPlanItemsRequest fromDate
                     * @property {string|null} [toDate] ListQcPlanItemsRequest toDate
                     * @property {palexy.sherlock.v1.IBoolValue|null} [isAppliedToVideoTable] ListQcPlanItemsRequest isAppliedToVideoTable
                     * @property {number|null} [storeId] ListQcPlanItemsRequest storeId
                     */
    
                    /**
                     * Constructs a new ListQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcPlanItemsRequest.
                     * @implements IListQcPlanItemsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest=} [properties] Properties to set
                     */
                    function ListQcPlanItemsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcPlanItemsRequest periodConfigId.
                     * @member {number} periodConfigId
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.periodConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListQcPlanItemsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListQcPlanItemsRequest isCustomItem.
                     * @member {palexy.sherlock.v1.IBoolValue|null|undefined} isCustomItem
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.isCustomItem = null;
    
                    /**
                     * ListQcPlanItemsRequest fromDate.
                     * @member {string} fromDate
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.fromDate = "";
    
                    /**
                     * ListQcPlanItemsRequest toDate.
                     * @member {string} toDate
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.toDate = "";
    
                    /**
                     * ListQcPlanItemsRequest isAppliedToVideoTable.
                     * @member {palexy.sherlock.v1.IBoolValue|null|undefined} isAppliedToVideoTable
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.isAppliedToVideoTable = null;
    
                    /**
                     * ListQcPlanItemsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     */
                    ListQcPlanItemsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListQcPlanItemsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsRequest} ListQcPlanItemsRequest instance
                     */
                    ListQcPlanItemsRequest.create = function create(properties) {
                        return new ListQcPlanItemsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcPlanItemsRequest message. Does not implicitly {@link palexy.sherlock.v1.ListQcPlanItemsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest} message ListQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPlanItemsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.periodConfigId != null && Object.hasOwnProperty.call(message, "periodConfigId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.periodConfigId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.isCustomItem != null && Object.hasOwnProperty.call(message, "isCustomItem"))
                            $root.palexy.sherlock.v1.BoolValue.encode(message.isCustomItem, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fromDate);
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.toDate);
                        if (message.isAppliedToVideoTable != null && Object.hasOwnProperty.call(message, "isAppliedToVideoTable"))
                            $root.palexy.sherlock.v1.BoolValue.encode(message.isAppliedToVideoTable, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcPlanItemsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcPlanItemsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsRequest} message ListQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPlanItemsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcPlanItemsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsRequest} ListQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPlanItemsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcPlanItemsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.periodConfigId = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.isCustomItem = $root.palexy.sherlock.v1.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.fromDate = reader.string();
                                break;
                            case 5:
                                message.toDate = reader.string();
                                break;
                            case 6:
                                message.isAppliedToVideoTable = $root.palexy.sherlock.v1.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcPlanItemsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsRequest} ListQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPlanItemsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcPlanItemsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcPlanItemsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (!$util.isInteger(message.periodConfigId) && !(message.periodConfigId && $util.isInteger(message.periodConfigId.low) && $util.isInteger(message.periodConfigId.high)))
                                return "periodConfigId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.isCustomItem != null && message.hasOwnProperty("isCustomItem")) {
                            var error = $root.palexy.sherlock.v1.BoolValue.verify(message.isCustomItem);
                            if (error)
                                return "isCustomItem." + error;
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            if (!$util.isString(message.fromDate))
                                return "fromDate: string expected";
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            if (!$util.isString(message.toDate))
                                return "toDate: string expected";
                        if (message.isAppliedToVideoTable != null && message.hasOwnProperty("isAppliedToVideoTable")) {
                            var error = $root.palexy.sherlock.v1.BoolValue.verify(message.isAppliedToVideoTable);
                            if (error)
                                return "isAppliedToVideoTable." + error;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListQcPlanItemsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsRequest} ListQcPlanItemsRequest
                     */
                    ListQcPlanItemsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcPlanItemsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcPlanItemsRequest();
                        if (object.periodConfigId != null)
                            if ($util.Long)
                                (message.periodConfigId = $util.Long.fromValue(object.periodConfigId)).unsigned = false;
                            else if (typeof object.periodConfigId === "string")
                                message.periodConfigId = parseInt(object.periodConfigId, 10);
                            else if (typeof object.periodConfigId === "number")
                                message.periodConfigId = object.periodConfigId;
                            else if (typeof object.periodConfigId === "object")
                                message.periodConfigId = new $util.LongBits(object.periodConfigId.low >>> 0, object.periodConfigId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.isCustomItem != null) {
                            if (typeof object.isCustomItem !== "object")
                                throw TypeError(".palexy.sherlock.v1.ListQcPlanItemsRequest.isCustomItem: object expected");
                            message.isCustomItem = $root.palexy.sherlock.v1.BoolValue.fromObject(object.isCustomItem);
                        }
                        if (object.fromDate != null)
                            message.fromDate = String(object.fromDate);
                        if (object.toDate != null)
                            message.toDate = String(object.toDate);
                        if (object.isAppliedToVideoTable != null) {
                            if (typeof object.isAppliedToVideoTable !== "object")
                                throw TypeError(".palexy.sherlock.v1.ListQcPlanItemsRequest.isAppliedToVideoTable: object expected");
                            message.isAppliedToVideoTable = $root.palexy.sherlock.v1.BoolValue.fromObject(object.isAppliedToVideoTable);
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcPlanItemsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.ListQcPlanItemsRequest} message ListQcPlanItemsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcPlanItemsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.periodConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.periodConfigId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.isCustomItem = null;
                            object.fromDate = "";
                            object.toDate = "";
                            object.isAppliedToVideoTable = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (typeof message.periodConfigId === "number")
                                object.periodConfigId = options.longs === String ? String(message.periodConfigId) : message.periodConfigId;
                            else
                                object.periodConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.periodConfigId) : options.longs === Number ? new $util.LongBits(message.periodConfigId.low >>> 0, message.periodConfigId.high >>> 0).toNumber() : message.periodConfigId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.isCustomItem != null && message.hasOwnProperty("isCustomItem"))
                            object.isCustomItem = $root.palexy.sherlock.v1.BoolValue.toObject(message.isCustomItem, options);
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = message.fromDate;
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = message.toDate;
                        if (message.isAppliedToVideoTable != null && message.hasOwnProperty("isAppliedToVideoTable"))
                            object.isAppliedToVideoTable = $root.palexy.sherlock.v1.BoolValue.toObject(message.isAppliedToVideoTable, options);
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this ListQcPlanItemsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcPlanItemsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcPlanItemsRequest;
                })();
    
                v1.BoolValue = (function() {
    
                    /**
                     * Properties of a BoolValue.
                     * @memberof palexy.sherlock.v1
                     * @interface IBoolValue
                     * @property {boolean|null} [value] BoolValue value
                     */
    
                    /**
                     * Constructs a new BoolValue.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BoolValue.
                     * @implements IBoolValue
                     * @constructor
                     * @param {palexy.sherlock.v1.IBoolValue=} [properties] Properties to set
                     */
                    function BoolValue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BoolValue value.
                     * @member {boolean} value
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @instance
                     */
                    BoolValue.prototype.value = false;
    
                    /**
                     * Creates a new BoolValue instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {palexy.sherlock.v1.IBoolValue=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BoolValue} BoolValue instance
                     */
                    BoolValue.create = function create(properties) {
                        return new BoolValue(properties);
                    };
    
                    /**
                     * Encodes the specified BoolValue message. Does not implicitly {@link palexy.sherlock.v1.BoolValue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {palexy.sherlock.v1.IBoolValue} message BoolValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoolValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BoolValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {palexy.sherlock.v1.IBoolValue} message BoolValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BoolValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BoolValue} BoolValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoolValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BoolValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.value = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BoolValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BoolValue} BoolValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoolValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BoolValue message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BoolValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (typeof message.value !== "boolean")
                                return "value: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BoolValue} BoolValue
                     */
                    BoolValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BoolValue)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BoolValue();
                        if (object.value != null)
                            message.value = Boolean(object.value);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @static
                     * @param {palexy.sherlock.v1.BoolValue} message BoolValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BoolValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.value = false;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        return object;
                    };
    
                    /**
                     * Converts this BoolValue to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BoolValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BoolValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BoolValue;
                })();
    
                v1.ListQcPlanItemsResponse = (function() {
    
                    /**
                     * Properties of a ListQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IListQcPlanItemsResponse
                     * @property {Array.<palexy.sherlock.v1.IQcPlanItem>|null} [items] ListQcPlanItemsResponse items
                     */
    
                    /**
                     * Constructs a new ListQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a ListQcPlanItemsResponse.
                     * @implements IListQcPlanItemsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IListQcPlanItemsResponse=} [properties] Properties to set
                     */
                    function ListQcPlanItemsResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListQcPlanItemsResponse items.
                     * @member {Array.<palexy.sherlock.v1.IQcPlanItem>} items
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @instance
                     */
                    ListQcPlanItemsResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new ListQcPlanItemsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsResponse} ListQcPlanItemsResponse instance
                     */
                    ListQcPlanItemsResponse.create = function create(properties) {
                        return new ListQcPlanItemsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListQcPlanItemsResponse message. Does not implicitly {@link palexy.sherlock.v1.ListQcPlanItemsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsResponse} message ListQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPlanItemsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.sherlock.v1.QcPlanItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListQcPlanItemsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.ListQcPlanItemsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IListQcPlanItemsResponse} message ListQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListQcPlanItemsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListQcPlanItemsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsResponse} ListQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPlanItemsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.ListQcPlanItemsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListQcPlanItemsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsResponse} ListQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListQcPlanItemsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListQcPlanItemsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListQcPlanItemsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListQcPlanItemsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.ListQcPlanItemsResponse} ListQcPlanItemsResponse
                     */
                    ListQcPlanItemsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.ListQcPlanItemsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.ListQcPlanItemsResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.sherlock.v1.ListQcPlanItemsResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.ListQcPlanItemsResponse.items: object expected");
                                message.items[i] = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListQcPlanItemsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.ListQcPlanItemsResponse} message ListQcPlanItemsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListQcPlanItemsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListQcPlanItemsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.ListQcPlanItemsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListQcPlanItemsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListQcPlanItemsResponse;
                })();
    
                v1.CreateQcPlanItemRequest = (function() {
    
                    /**
                     * Properties of a CreateQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateQcPlanItemRequest
                     * @property {palexy.sherlock.v1.IQcPlanItem|null} [item] CreateQcPlanItemRequest item
                     */
    
                    /**
                     * Constructs a new CreateQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateQcPlanItemRequest.
                     * @implements ICreateQcPlanItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest=} [properties] Properties to set
                     */
                    function CreateQcPlanItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateQcPlanItemRequest item.
                     * @member {palexy.sherlock.v1.IQcPlanItem|null|undefined} item
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @instance
                     */
                    CreateQcPlanItemRequest.prototype.item = null;
    
                    /**
                     * Creates a new CreateQcPlanItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemRequest} CreateQcPlanItemRequest instance
                     */
                    CreateQcPlanItemRequest.create = function create(properties) {
                        return new CreateQcPlanItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateQcPlanItemRequest message. Does not implicitly {@link palexy.sherlock.v1.CreateQcPlanItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest} message CreateQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPlanItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                            $root.palexy.sherlock.v1.QcPlanItem.encode(message.item, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateQcPlanItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateQcPlanItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemRequest} message CreateQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPlanItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateQcPlanItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemRequest} CreateQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPlanItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateQcPlanItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.item = $root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateQcPlanItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemRequest} CreateQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPlanItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateQcPlanItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateQcPlanItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.item != null && message.hasOwnProperty("item")) {
                            var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateQcPlanItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemRequest} CreateQcPlanItemRequest
                     */
                    CreateQcPlanItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateQcPlanItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateQcPlanItemRequest();
                        if (object.item != null) {
                            if (typeof object.item !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateQcPlanItemRequest.item: object expected");
                            message.item = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.item);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateQcPlanItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.CreateQcPlanItemRequest} message CreateQcPlanItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateQcPlanItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.item = null;
                        if (message.item != null && message.hasOwnProperty("item"))
                            object.item = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.item, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateQcPlanItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateQcPlanItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateQcPlanItemRequest;
                })();
    
                v1.CreateQcPlanItemResponse = (function() {
    
                    /**
                     * Properties of a CreateQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface ICreateQcPlanItemResponse
                     * @property {palexy.sherlock.v1.IQcPlanItem|null} [item] CreateQcPlanItemResponse item
                     */
    
                    /**
                     * Constructs a new CreateQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a CreateQcPlanItemResponse.
                     * @implements ICreateQcPlanItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemResponse=} [properties] Properties to set
                     */
                    function CreateQcPlanItemResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateQcPlanItemResponse item.
                     * @member {palexy.sherlock.v1.IQcPlanItem|null|undefined} item
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @instance
                     */
                    CreateQcPlanItemResponse.prototype.item = null;
    
                    /**
                     * Creates a new CreateQcPlanItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemResponse} CreateQcPlanItemResponse instance
                     */
                    CreateQcPlanItemResponse.create = function create(properties) {
                        return new CreateQcPlanItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateQcPlanItemResponse message. Does not implicitly {@link palexy.sherlock.v1.CreateQcPlanItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemResponse} message CreateQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPlanItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.item != null && Object.hasOwnProperty.call(message, "item"))
                            $root.palexy.sherlock.v1.QcPlanItem.encode(message.item, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateQcPlanItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.CreateQcPlanItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.ICreateQcPlanItemResponse} message CreateQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateQcPlanItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateQcPlanItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemResponse} CreateQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPlanItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.CreateQcPlanItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.item = $root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateQcPlanItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemResponse} CreateQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateQcPlanItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateQcPlanItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateQcPlanItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.item != null && message.hasOwnProperty("item")) {
                            var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.item);
                            if (error)
                                return "item." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateQcPlanItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.CreateQcPlanItemResponse} CreateQcPlanItemResponse
                     */
                    CreateQcPlanItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.CreateQcPlanItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.CreateQcPlanItemResponse();
                        if (object.item != null) {
                            if (typeof object.item !== "object")
                                throw TypeError(".palexy.sherlock.v1.CreateQcPlanItemResponse.item: object expected");
                            message.item = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.item);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateQcPlanItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.CreateQcPlanItemResponse} message CreateQcPlanItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateQcPlanItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.item = null;
                        if (message.item != null && message.hasOwnProperty("item"))
                            object.item = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.item, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateQcPlanItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.CreateQcPlanItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateQcPlanItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateQcPlanItemResponse;
                })();
    
                v1.BatchCreateQcPlanItemsRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateQcPlanItemsRequest
                     * @property {Array.<palexy.sherlock.v1.IQcPlanItem>|null} [items] BatchCreateQcPlanItemsRequest items
                     */
    
                    /**
                     * Constructs a new BatchCreateQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateQcPlanItemsRequest.
                     * @implements IBatchCreateQcPlanItemsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest=} [properties] Properties to set
                     */
                    function BatchCreateQcPlanItemsRequest(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateQcPlanItemsRequest items.
                     * @member {Array.<palexy.sherlock.v1.IQcPlanItem>} items
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @instance
                     */
                    BatchCreateQcPlanItemsRequest.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateQcPlanItemsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsRequest} BatchCreateQcPlanItemsRequest instance
                     */
                    BatchCreateQcPlanItemsRequest.create = function create(properties) {
                        return new BatchCreateQcPlanItemsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateQcPlanItemsRequest message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateQcPlanItemsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest} message BatchCreateQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateQcPlanItemsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.sherlock.v1.QcPlanItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateQcPlanItemsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateQcPlanItemsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsRequest} message BatchCreateQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateQcPlanItemsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateQcPlanItemsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsRequest} BatchCreateQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateQcPlanItemsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateQcPlanItemsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateQcPlanItemsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsRequest} BatchCreateQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateQcPlanItemsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateQcPlanItemsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateQcPlanItemsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateQcPlanItemsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsRequest} BatchCreateQcPlanItemsRequest
                     */
                    BatchCreateQcPlanItemsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateQcPlanItemsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateQcPlanItemsRequest();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateQcPlanItemsRequest.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCreateQcPlanItemsRequest.items: object expected");
                                message.items[i] = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateQcPlanItemsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateQcPlanItemsRequest} message BatchCreateQcPlanItemsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateQcPlanItemsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateQcPlanItemsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateQcPlanItemsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateQcPlanItemsRequest;
                })();
    
                v1.BatchCreateQcPlanItemsResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchCreateQcPlanItemsResponse
                     * @property {Array.<palexy.sherlock.v1.IQcPlanItem>|null} [items] BatchCreateQcPlanItemsResponse items
                     */
    
                    /**
                     * Constructs a new BatchCreateQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchCreateQcPlanItemsResponse.
                     * @implements IBatchCreateQcPlanItemsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsResponse=} [properties] Properties to set
                     */
                    function BatchCreateQcPlanItemsResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateQcPlanItemsResponse items.
                     * @member {Array.<palexy.sherlock.v1.IQcPlanItem>} items
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @instance
                     */
                    BatchCreateQcPlanItemsResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateQcPlanItemsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} BatchCreateQcPlanItemsResponse instance
                     */
                    BatchCreateQcPlanItemsResponse.create = function create(properties) {
                        return new BatchCreateQcPlanItemsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateQcPlanItemsResponse message. Does not implicitly {@link palexy.sherlock.v1.BatchCreateQcPlanItemsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsResponse} message BatchCreateQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateQcPlanItemsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.sherlock.v1.QcPlanItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateQcPlanItemsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchCreateQcPlanItemsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchCreateQcPlanItemsResponse} message BatchCreateQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateQcPlanItemsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateQcPlanItemsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} BatchCreateQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateQcPlanItemsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchCreateQcPlanItemsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateQcPlanItemsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} BatchCreateQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateQcPlanItemsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateQcPlanItemsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateQcPlanItemsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateQcPlanItemsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} BatchCreateQcPlanItemsResponse
                     */
                    BatchCreateQcPlanItemsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchCreateQcPlanItemsResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchCreateQcPlanItemsResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.sherlock.v1.BatchCreateQcPlanItemsResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.BatchCreateQcPlanItemsResponse.items: object expected");
                                message.items[i] = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateQcPlanItemsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.BatchCreateQcPlanItemsResponse} message BatchCreateQcPlanItemsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateQcPlanItemsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateQcPlanItemsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchCreateQcPlanItemsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateQcPlanItemsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateQcPlanItemsResponse;
                })();
    
                v1.BatchDeleteQcPlanItemsRequest = (function() {
    
                    /**
                     * Properties of a BatchDeleteQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchDeleteQcPlanItemsRequest
                     * @property {string|null} [fromDateId] BatchDeleteQcPlanItemsRequest fromDateId
                     * @property {number|null} [companyId] BatchDeleteQcPlanItemsRequest companyId
                     * @property {number|null} [periodConfigId] BatchDeleteQcPlanItemsRequest periodConfigId
                     */
    
                    /**
                     * Constructs a new BatchDeleteQcPlanItemsRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchDeleteQcPlanItemsRequest.
                     * @implements IBatchDeleteQcPlanItemsRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest=} [properties] Properties to set
                     */
                    function BatchDeleteQcPlanItemsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteQcPlanItemsRequest fromDateId.
                     * @member {string} fromDateId
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @instance
                     */
                    BatchDeleteQcPlanItemsRequest.prototype.fromDateId = "";
    
                    /**
                     * BatchDeleteQcPlanItemsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @instance
                     */
                    BatchDeleteQcPlanItemsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchDeleteQcPlanItemsRequest periodConfigId.
                     * @member {number} periodConfigId
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @instance
                     */
                    BatchDeleteQcPlanItemsRequest.prototype.periodConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new BatchDeleteQcPlanItemsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest} BatchDeleteQcPlanItemsRequest instance
                     */
                    BatchDeleteQcPlanItemsRequest.create = function create(properties) {
                        return new BatchDeleteQcPlanItemsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteQcPlanItemsRequest message. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest} message BatchDeleteQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteQcPlanItemsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fromDateId != null && Object.hasOwnProperty.call(message, "fromDateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fromDateId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.periodConfigId != null && Object.hasOwnProperty.call(message, "periodConfigId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.periodConfigId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteQcPlanItemsRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsRequest} message BatchDeleteQcPlanItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteQcPlanItemsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteQcPlanItemsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest} BatchDeleteQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteQcPlanItemsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fromDateId = reader.string();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.periodConfigId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteQcPlanItemsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest} BatchDeleteQcPlanItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteQcPlanItemsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteQcPlanItemsRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteQcPlanItemsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fromDateId != null && message.hasOwnProperty("fromDateId"))
                            if (!$util.isString(message.fromDateId))
                                return "fromDateId: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (!$util.isInteger(message.periodConfigId) && !(message.periodConfigId && $util.isInteger(message.periodConfigId.low) && $util.isInteger(message.periodConfigId.high)))
                                return "periodConfigId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteQcPlanItemsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest} BatchDeleteQcPlanItemsRequest
                     */
                    BatchDeleteQcPlanItemsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest();
                        if (object.fromDateId != null)
                            message.fromDateId = String(object.fromDateId);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.periodConfigId != null)
                            if ($util.Long)
                                (message.periodConfigId = $util.Long.fromValue(object.periodConfigId)).unsigned = false;
                            else if (typeof object.periodConfigId === "string")
                                message.periodConfigId = parseInt(object.periodConfigId, 10);
                            else if (typeof object.periodConfigId === "number")
                                message.periodConfigId = object.periodConfigId;
                            else if (typeof object.periodConfigId === "object")
                                message.periodConfigId = new $util.LongBits(object.periodConfigId.low >>> 0, object.periodConfigId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteQcPlanItemsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @static
                     * @param {palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest} message BatchDeleteQcPlanItemsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteQcPlanItemsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fromDateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.periodConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.periodConfigId = options.longs === String ? "0" : 0;
                        }
                        if (message.fromDateId != null && message.hasOwnProperty("fromDateId"))
                            object.fromDateId = message.fromDateId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (typeof message.periodConfigId === "number")
                                object.periodConfigId = options.longs === String ? String(message.periodConfigId) : message.periodConfigId;
                            else
                                object.periodConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.periodConfigId) : options.longs === Number ? new $util.LongBits(message.periodConfigId.low >>> 0, message.periodConfigId.high >>> 0).toNumber() : message.periodConfigId;
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteQcPlanItemsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteQcPlanItemsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteQcPlanItemsRequest;
                })();
    
                v1.BatchDeleteQcPlanItemsResponse = (function() {
    
                    /**
                     * Properties of a BatchDeleteQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IBatchDeleteQcPlanItemsResponse
                     */
    
                    /**
                     * Constructs a new BatchDeleteQcPlanItemsResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a BatchDeleteQcPlanItemsResponse.
                     * @implements IBatchDeleteQcPlanItemsResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsResponse=} [properties] Properties to set
                     */
                    function BatchDeleteQcPlanItemsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new BatchDeleteQcPlanItemsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} BatchDeleteQcPlanItemsResponse instance
                     */
                    BatchDeleteQcPlanItemsResponse.create = function create(properties) {
                        return new BatchDeleteQcPlanItemsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteQcPlanItemsResponse message. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsResponse} message BatchDeleteQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteQcPlanItemsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteQcPlanItemsResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.IBatchDeleteQcPlanItemsResponse} message BatchDeleteQcPlanItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteQcPlanItemsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteQcPlanItemsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} BatchDeleteQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteQcPlanItemsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteQcPlanItemsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} BatchDeleteQcPlanItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteQcPlanItemsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteQcPlanItemsResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteQcPlanItemsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteQcPlanItemsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} BatchDeleteQcPlanItemsResponse
                     */
                    BatchDeleteQcPlanItemsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse();
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteQcPlanItemsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @static
                     * @param {palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse} message BatchDeleteQcPlanItemsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteQcPlanItemsResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this BatchDeleteQcPlanItemsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.BatchDeleteQcPlanItemsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteQcPlanItemsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteQcPlanItemsResponse;
                })();
    
                v1.UpdateVideoTableForQcPlanItemRequest = (function() {
    
                    /**
                     * Properties of an UpdateVideoTableForQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateVideoTableForQcPlanItemRequest
                     * @property {string|null} [name] UpdateVideoTableForQcPlanItemRequest name
                     */
    
                    /**
                     * Constructs a new UpdateVideoTableForQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateVideoTableForQcPlanItemRequest.
                     * @implements IUpdateVideoTableForQcPlanItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest=} [properties] Properties to set
                     */
                    function UpdateVideoTableForQcPlanItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateVideoTableForQcPlanItemRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @instance
                     */
                    UpdateVideoTableForQcPlanItemRequest.prototype.name = "";
    
                    /**
                     * Creates a new UpdateVideoTableForQcPlanItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest} UpdateVideoTableForQcPlanItemRequest instance
                     */
                    UpdateVideoTableForQcPlanItemRequest.create = function create(properties) {
                        return new UpdateVideoTableForQcPlanItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateVideoTableForQcPlanItemRequest message. Does not implicitly {@link palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest} message UpdateVideoTableForQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoTableForQcPlanItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateVideoTableForQcPlanItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemRequest} message UpdateVideoTableForQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoTableForQcPlanItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateVideoTableForQcPlanItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest} UpdateVideoTableForQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoTableForQcPlanItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateVideoTableForQcPlanItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest} UpdateVideoTableForQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoTableForQcPlanItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateVideoTableForQcPlanItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateVideoTableForQcPlanItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateVideoTableForQcPlanItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest} UpdateVideoTableForQcPlanItemRequest
                     */
                    UpdateVideoTableForQcPlanItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateVideoTableForQcPlanItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest} message UpdateVideoTableForQcPlanItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateVideoTableForQcPlanItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateVideoTableForQcPlanItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateVideoTableForQcPlanItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateVideoTableForQcPlanItemRequest;
                })();
    
                v1.UpdateVideoTableForQcPlanItemResponse = (function() {
    
                    /**
                     * Properties of an UpdateVideoTableForQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IUpdateVideoTableForQcPlanItemResponse
                     * @property {number|null} [numUpdateVideos] UpdateVideoTableForQcPlanItemResponse numUpdateVideos
                     */
    
                    /**
                     * Constructs a new UpdateVideoTableForQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents an UpdateVideoTableForQcPlanItemResponse.
                     * @implements IUpdateVideoTableForQcPlanItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemResponse=} [properties] Properties to set
                     */
                    function UpdateVideoTableForQcPlanItemResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateVideoTableForQcPlanItemResponse numUpdateVideos.
                     * @member {number} numUpdateVideos
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @instance
                     */
                    UpdateVideoTableForQcPlanItemResponse.prototype.numUpdateVideos = 0;
    
                    /**
                     * Creates a new UpdateVideoTableForQcPlanItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} UpdateVideoTableForQcPlanItemResponse instance
                     */
                    UpdateVideoTableForQcPlanItemResponse.create = function create(properties) {
                        return new UpdateVideoTableForQcPlanItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateVideoTableForQcPlanItemResponse message. Does not implicitly {@link palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemResponse} message UpdateVideoTableForQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoTableForQcPlanItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.numUpdateVideos != null && Object.hasOwnProperty.call(message, "numUpdateVideos"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.numUpdateVideos);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateVideoTableForQcPlanItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IUpdateVideoTableForQcPlanItemResponse} message UpdateVideoTableForQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoTableForQcPlanItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateVideoTableForQcPlanItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} UpdateVideoTableForQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoTableForQcPlanItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.numUpdateVideos = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateVideoTableForQcPlanItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} UpdateVideoTableForQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoTableForQcPlanItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateVideoTableForQcPlanItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateVideoTableForQcPlanItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.numUpdateVideos != null && message.hasOwnProperty("numUpdateVideos"))
                            if (!$util.isInteger(message.numUpdateVideos))
                                return "numUpdateVideos: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateVideoTableForQcPlanItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} UpdateVideoTableForQcPlanItemResponse
                     */
                    UpdateVideoTableForQcPlanItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse();
                        if (object.numUpdateVideos != null)
                            message.numUpdateVideos = object.numUpdateVideos | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateVideoTableForQcPlanItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse} message UpdateVideoTableForQcPlanItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateVideoTableForQcPlanItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.numUpdateVideos = 0;
                        if (message.numUpdateVideos != null && message.hasOwnProperty("numUpdateVideos"))
                            object.numUpdateVideos = message.numUpdateVideos;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateVideoTableForQcPlanItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.UpdateVideoTableForQcPlanItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateVideoTableForQcPlanItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateVideoTableForQcPlanItemResponse;
                })();
    
                v1.DeleteQcPlanItemRequest = (function() {
    
                    /**
                     * Properties of a DeleteQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcPlanItemRequest
                     * @property {string|null} [name] DeleteQcPlanItemRequest name
                     */
    
                    /**
                     * Constructs a new DeleteQcPlanItemRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcPlanItemRequest.
                     * @implements IDeleteQcPlanItemRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest=} [properties] Properties to set
                     */
                    function DeleteQcPlanItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteQcPlanItemRequest name.
                     * @member {string} name
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @instance
                     */
                    DeleteQcPlanItemRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteQcPlanItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemRequest} DeleteQcPlanItemRequest instance
                     */
                    DeleteQcPlanItemRequest.create = function create(properties) {
                        return new DeleteQcPlanItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcPlanItemRequest message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPlanItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest} message DeleteQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPlanItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcPlanItemRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPlanItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemRequest} message DeleteQcPlanItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPlanItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcPlanItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemRequest} DeleteQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPlanItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcPlanItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcPlanItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemRequest} DeleteQcPlanItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPlanItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcPlanItemRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcPlanItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcPlanItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemRequest} DeleteQcPlanItemRequest
                     */
                    DeleteQcPlanItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcPlanItemRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.DeleteQcPlanItemRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcPlanItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcPlanItemRequest} message DeleteQcPlanItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcPlanItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteQcPlanItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcPlanItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcPlanItemRequest;
                })();
    
                v1.DeleteQcPlanItemResponse = (function() {
    
                    /**
                     * Properties of a DeleteQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IDeleteQcPlanItemResponse
                     */
    
                    /**
                     * Constructs a new DeleteQcPlanItemResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a DeleteQcPlanItemResponse.
                     * @implements IDeleteQcPlanItemResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemResponse=} [properties] Properties to set
                     */
                    function DeleteQcPlanItemResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new DeleteQcPlanItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemResponse} DeleteQcPlanItemResponse instance
                     */
                    DeleteQcPlanItemResponse.create = function create(properties) {
                        return new DeleteQcPlanItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteQcPlanItemResponse message. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPlanItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemResponse} message DeleteQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPlanItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteQcPlanItemResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.DeleteQcPlanItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.IDeleteQcPlanItemResponse} message DeleteQcPlanItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteQcPlanItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteQcPlanItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemResponse} DeleteQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPlanItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.DeleteQcPlanItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteQcPlanItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemResponse} DeleteQcPlanItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteQcPlanItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteQcPlanItemResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteQcPlanItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteQcPlanItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.DeleteQcPlanItemResponse} DeleteQcPlanItemResponse
                     */
                    DeleteQcPlanItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.DeleteQcPlanItemResponse)
                            return object;
                        return new $root.palexy.sherlock.v1.DeleteQcPlanItemResponse();
                    };
    
                    /**
                     * Creates a plain object from a DeleteQcPlanItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @static
                     * @param {palexy.sherlock.v1.DeleteQcPlanItemResponse} message DeleteQcPlanItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteQcPlanItemResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this DeleteQcPlanItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.DeleteQcPlanItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteQcPlanItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteQcPlanItemResponse;
                })();
    
                v1.GeneratePlanForConfigRequest = (function() {
    
                    /**
                     * Properties of a GeneratePlanForConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @interface IGeneratePlanForConfigRequest
                     * @property {number|null} [periodConfigId] GeneratePlanForConfigRequest periodConfigId
                     * @property {string|null} [periodStartingDateId] GeneratePlanForConfigRequest periodStartingDateId
                     */
    
                    /**
                     * Constructs a new GeneratePlanForConfigRequest.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GeneratePlanForConfigRequest.
                     * @implements IGeneratePlanForConfigRequest
                     * @constructor
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest=} [properties] Properties to set
                     */
                    function GeneratePlanForConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GeneratePlanForConfigRequest periodConfigId.
                     * @member {number} periodConfigId
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @instance
                     */
                    GeneratePlanForConfigRequest.prototype.periodConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GeneratePlanForConfigRequest periodStartingDateId.
                     * @member {string} periodStartingDateId
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @instance
                     */
                    GeneratePlanForConfigRequest.prototype.periodStartingDateId = "";
    
                    /**
                     * Creates a new GeneratePlanForConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigRequest} GeneratePlanForConfigRequest instance
                     */
                    GeneratePlanForConfigRequest.create = function create(properties) {
                        return new GeneratePlanForConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GeneratePlanForConfigRequest message. Does not implicitly {@link palexy.sherlock.v1.GeneratePlanForConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest} message GeneratePlanForConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneratePlanForConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.periodConfigId != null && Object.hasOwnProperty.call(message, "periodConfigId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.periodConfigId);
                        if (message.periodStartingDateId != null && Object.hasOwnProperty.call(message, "periodStartingDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.periodStartingDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GeneratePlanForConfigRequest message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GeneratePlanForConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigRequest} message GeneratePlanForConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneratePlanForConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GeneratePlanForConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigRequest} GeneratePlanForConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneratePlanForConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GeneratePlanForConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.periodConfigId = reader.int64();
                                break;
                            case 2:
                                message.periodStartingDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GeneratePlanForConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigRequest} GeneratePlanForConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneratePlanForConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GeneratePlanForConfigRequest message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GeneratePlanForConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (!$util.isInteger(message.periodConfigId) && !(message.periodConfigId && $util.isInteger(message.periodConfigId.low) && $util.isInteger(message.periodConfigId.high)))
                                return "periodConfigId: integer|Long expected";
                        if (message.periodStartingDateId != null && message.hasOwnProperty("periodStartingDateId"))
                            if (!$util.isString(message.periodStartingDateId))
                                return "periodStartingDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GeneratePlanForConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigRequest} GeneratePlanForConfigRequest
                     */
                    GeneratePlanForConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GeneratePlanForConfigRequest)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GeneratePlanForConfigRequest();
                        if (object.periodConfigId != null)
                            if ($util.Long)
                                (message.periodConfigId = $util.Long.fromValue(object.periodConfigId)).unsigned = false;
                            else if (typeof object.periodConfigId === "string")
                                message.periodConfigId = parseInt(object.periodConfigId, 10);
                            else if (typeof object.periodConfigId === "number")
                                message.periodConfigId = object.periodConfigId;
                            else if (typeof object.periodConfigId === "object")
                                message.periodConfigId = new $util.LongBits(object.periodConfigId.low >>> 0, object.periodConfigId.high >>> 0).toNumber();
                        if (object.periodStartingDateId != null)
                            message.periodStartingDateId = String(object.periodStartingDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GeneratePlanForConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @static
                     * @param {palexy.sherlock.v1.GeneratePlanForConfigRequest} message GeneratePlanForConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GeneratePlanForConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.periodConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.periodConfigId = options.longs === String ? "0" : 0;
                            object.periodStartingDateId = "";
                        }
                        if (message.periodConfigId != null && message.hasOwnProperty("periodConfigId"))
                            if (typeof message.periodConfigId === "number")
                                object.periodConfigId = options.longs === String ? String(message.periodConfigId) : message.periodConfigId;
                            else
                                object.periodConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.periodConfigId) : options.longs === Number ? new $util.LongBits(message.periodConfigId.low >>> 0, message.periodConfigId.high >>> 0).toNumber() : message.periodConfigId;
                        if (message.periodStartingDateId != null && message.hasOwnProperty("periodStartingDateId"))
                            object.periodStartingDateId = message.periodStartingDateId;
                        return object;
                    };
    
                    /**
                     * Converts this GeneratePlanForConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GeneratePlanForConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GeneratePlanForConfigRequest;
                })();
    
                v1.GeneratePlanForConfigResponse = (function() {
    
                    /**
                     * Properties of a GeneratePlanForConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @interface IGeneratePlanForConfigResponse
                     * @property {Array.<palexy.sherlock.v1.IQcPlanItem>|null} [generatedItems] GeneratePlanForConfigResponse generatedItems
                     */
    
                    /**
                     * Constructs a new GeneratePlanForConfigResponse.
                     * @memberof palexy.sherlock.v1
                     * @classdesc Represents a GeneratePlanForConfigResponse.
                     * @implements IGeneratePlanForConfigResponse
                     * @constructor
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigResponse=} [properties] Properties to set
                     */
                    function GeneratePlanForConfigResponse(properties) {
                        this.generatedItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GeneratePlanForConfigResponse generatedItems.
                     * @member {Array.<palexy.sherlock.v1.IQcPlanItem>} generatedItems
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @instance
                     */
                    GeneratePlanForConfigResponse.prototype.generatedItems = $util.emptyArray;
    
                    /**
                     * Creates a new GeneratePlanForConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigResponse=} [properties] Properties to set
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigResponse} GeneratePlanForConfigResponse instance
                     */
                    GeneratePlanForConfigResponse.create = function create(properties) {
                        return new GeneratePlanForConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GeneratePlanForConfigResponse message. Does not implicitly {@link palexy.sherlock.v1.GeneratePlanForConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigResponse} message GeneratePlanForConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneratePlanForConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.generatedItems != null && message.generatedItems.length)
                            for (var i = 0; i < message.generatedItems.length; ++i)
                                $root.palexy.sherlock.v1.QcPlanItem.encode(message.generatedItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GeneratePlanForConfigResponse message, length delimited. Does not implicitly {@link palexy.sherlock.v1.GeneratePlanForConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.IGeneratePlanForConfigResponse} message GeneratePlanForConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeneratePlanForConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GeneratePlanForConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigResponse} GeneratePlanForConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneratePlanForConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.sherlock.v1.GeneratePlanForConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.generatedItems && message.generatedItems.length))
                                    message.generatedItems = [];
                                message.generatedItems.push($root.palexy.sherlock.v1.QcPlanItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GeneratePlanForConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigResponse} GeneratePlanForConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeneratePlanForConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GeneratePlanForConfigResponse message.
                     * @function verify
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GeneratePlanForConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.generatedItems != null && message.hasOwnProperty("generatedItems")) {
                            if (!Array.isArray(message.generatedItems))
                                return "generatedItems: array expected";
                            for (var i = 0; i < message.generatedItems.length; ++i) {
                                var error = $root.palexy.sherlock.v1.QcPlanItem.verify(message.generatedItems[i]);
                                if (error)
                                    return "generatedItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GeneratePlanForConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.sherlock.v1.GeneratePlanForConfigResponse} GeneratePlanForConfigResponse
                     */
                    GeneratePlanForConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.sherlock.v1.GeneratePlanForConfigResponse)
                            return object;
                        var message = new $root.palexy.sherlock.v1.GeneratePlanForConfigResponse();
                        if (object.generatedItems) {
                            if (!Array.isArray(object.generatedItems))
                                throw TypeError(".palexy.sherlock.v1.GeneratePlanForConfigResponse.generatedItems: array expected");
                            message.generatedItems = [];
                            for (var i = 0; i < object.generatedItems.length; ++i) {
                                if (typeof object.generatedItems[i] !== "object")
                                    throw TypeError(".palexy.sherlock.v1.GeneratePlanForConfigResponse.generatedItems: object expected");
                                message.generatedItems[i] = $root.palexy.sherlock.v1.QcPlanItem.fromObject(object.generatedItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GeneratePlanForConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @static
                     * @param {palexy.sherlock.v1.GeneratePlanForConfigResponse} message GeneratePlanForConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GeneratePlanForConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.generatedItems = [];
                        if (message.generatedItems && message.generatedItems.length) {
                            object.generatedItems = [];
                            for (var j = 0; j < message.generatedItems.length; ++j)
                                object.generatedItems[j] = $root.palexy.sherlock.v1.QcPlanItem.toObject(message.generatedItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GeneratePlanForConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.sherlock.v1.GeneratePlanForConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GeneratePlanForConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GeneratePlanForConfigResponse;
                })();
    
                return v1;
            })();
    
            return sherlock;
        })();
    
        palexy.streaming = (function() {
    
            /**
             * Namespace streaming.
             * @memberof palexy
             * @namespace
             */
            var streaming = {};
    
            streaming.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.streaming
                 * @namespace
                 */
                var v1 = {};
    
                v1.WorkerService = (function() {
    
                    /**
                     * Constructs a new WorkerService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WorkerService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function WorkerService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (WorkerService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = WorkerService;
    
                    /**
                     * Creates new WorkerService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.WorkerService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {WorkerService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    WorkerService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#createWorker}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef CreateWorkerCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Worker} [response] Worker
                     */
    
                    /**
                     * Calls CreateWorker.
                     * @function createWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IWorker} request Worker message or plain object
                     * @param {palexy.streaming.v1.WorkerService.CreateWorkerCallback} callback Node-style callback called with the error, if any, and Worker
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.createWorker = function createWorker(request, callback) {
                        return this.rpcCall(createWorker, $root.palexy.streaming.v1.Worker, $root.palexy.streaming.v1.Worker, request, callback);
                    }, "name", { value: "CreateWorker" });
    
                    /**
                     * Calls CreateWorker.
                     * @function createWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IWorker} request Worker message or plain object
                     * @returns {Promise<palexy.streaming.v1.Worker>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#listWorkerCameras}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef ListWorkerCamerasCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListWorkerCamerasResponse} [response] ListWorkerCamerasResponse
                     */
    
                    /**
                     * Calls ListWorkerCameras.
                     * @function listWorkerCameras
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest} request ListWorkerCamerasRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.ListWorkerCamerasCallback} callback Node-style callback called with the error, if any, and ListWorkerCamerasResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.listWorkerCameras = function listWorkerCameras(request, callback) {
                        return this.rpcCall(listWorkerCameras, $root.palexy.streaming.v1.ListWorkerCamerasRequest, $root.palexy.streaming.v1.ListWorkerCamerasResponse, request, callback);
                    }, "name", { value: "ListWorkerCameras" });
    
                    /**
                     * Calls ListWorkerCameras.
                     * @function listWorkerCameras
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest} request ListWorkerCamerasRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListWorkerCamerasResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#listWorkers}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef ListWorkersCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListWorkersResponse} [response] ListWorkersResponse
                     */
    
                    /**
                     * Calls ListWorkers.
                     * @function listWorkers
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListWorkersRequest} request ListWorkersRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.ListWorkersCallback} callback Node-style callback called with the error, if any, and ListWorkersResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.listWorkers = function listWorkers(request, callback) {
                        return this.rpcCall(listWorkers, $root.palexy.streaming.v1.ListWorkersRequest, $root.palexy.streaming.v1.ListWorkersResponse, request, callback);
                    }, "name", { value: "ListWorkers" });
    
                    /**
                     * Calls ListWorkers.
                     * @function listWorkers
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListWorkersRequest} request ListWorkersRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListWorkersResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#updateWorkerHeartbeat}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef UpdateWorkerHeartbeatCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls UpdateWorkerHeartbeat.
                     * @function updateWorkerHeartbeat
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest} request UpdateWorkerHeartbeatRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.UpdateWorkerHeartbeatCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.updateWorkerHeartbeat = function updateWorkerHeartbeat(request, callback) {
                        return this.rpcCall(updateWorkerHeartbeat, $root.palexy.streaming.v1.UpdateWorkerHeartbeatRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "UpdateWorkerHeartbeat" });
    
                    /**
                     * Calls UpdateWorkerHeartbeat.
                     * @function updateWorkerHeartbeat
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest} request UpdateWorkerHeartbeatRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#terminateWorker}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef TerminateWorkerCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls TerminateWorker.
                     * @function terminateWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest} request TerminateWorkerRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.TerminateWorkerCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.terminateWorker = function terminateWorker(request, callback) {
                        return this.rpcCall(terminateWorker, $root.palexy.streaming.v1.TerminateWorkerRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "TerminateWorker" });
    
                    /**
                     * Calls TerminateWorker.
                     * @function terminateWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest} request TerminateWorkerRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#updateWorkerCameraAssignments}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef UpdateWorkerCameraAssignmentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls UpdateWorkerCameraAssignments.
                     * @function updateWorkerCameraAssignments
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest} request UpdateWorkerCameraAssignmentsRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.UpdateWorkerCameraAssignmentsCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.updateWorkerCameraAssignments = function updateWorkerCameraAssignments(request, callback) {
                        return this.rpcCall(updateWorkerCameraAssignments, $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "UpdateWorkerCameraAssignments" });
    
                    /**
                     * Calls UpdateWorkerCameraAssignments.
                     * @function updateWorkerCameraAssignments
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest} request UpdateWorkerCameraAssignmentsRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#getWorker}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef GetWorkerCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Worker} [response] Worker
                     */
    
                    /**
                     * Calls GetWorker.
                     * @function getWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IGetWorkerRequest} request GetWorkerRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.GetWorkerCallback} callback Node-style callback called with the error, if any, and Worker
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.getWorker = function getWorker(request, callback) {
                        return this.rpcCall(getWorker, $root.palexy.streaming.v1.GetWorkerRequest, $root.palexy.streaming.v1.Worker, request, callback);
                    }, "name", { value: "GetWorker" });
    
                    /**
                     * Calls GetWorker.
                     * @function getWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IGetWorkerRequest} request GetWorkerRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Worker>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#upgradeWorker}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef UpgradeWorkerCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Worker} [response] Worker
                     */
    
                    /**
                     * Calls UpgradeWorker.
                     * @function upgradeWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest} request UpgradeWorkerRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.UpgradeWorkerCallback} callback Node-style callback called with the error, if any, and Worker
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.upgradeWorker = function upgradeWorker(request, callback) {
                        return this.rpcCall(upgradeWorker, $root.palexy.streaming.v1.UpgradeWorkerRequest, $root.palexy.streaming.v1.Worker, request, callback);
                    }, "name", { value: "UpgradeWorker" });
    
                    /**
                     * Calls UpgradeWorker.
                     * @function upgradeWorker
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest} request UpgradeWorkerRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Worker>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#listAvailableVersions}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef ListAvailableVersionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAvailableVersionsResponse} [response] ListAvailableVersionsResponse
                     */
    
                    /**
                     * Calls ListAvailableVersions.
                     * @function listAvailableVersions
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest} request ListAvailableVersionsRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.ListAvailableVersionsCallback} callback Node-style callback called with the error, if any, and ListAvailableVersionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.listAvailableVersions = function listAvailableVersions(request, callback) {
                        return this.rpcCall(listAvailableVersions, $root.palexy.streaming.v1.ListAvailableVersionsRequest, $root.palexy.streaming.v1.ListAvailableVersionsResponse, request, callback);
                    }, "name", { value: "ListAvailableVersions" });
    
                    /**
                     * Calls ListAvailableVersions.
                     * @function listAvailableVersions
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest} request ListAvailableVersionsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAvailableVersionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#markWorkerTerminating}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef MarkWorkerTerminatingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls MarkWorkerTerminating.
                     * @function markWorkerTerminating
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest} request MarkWorkerTerminatingRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.MarkWorkerTerminatingCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.markWorkerTerminating = function markWorkerTerminating(request, callback) {
                        return this.rpcCall(markWorkerTerminating, $root.palexy.streaming.v1.MarkWorkerTerminatingRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "MarkWorkerTerminating" });
    
                    /**
                     * Calls MarkWorkerTerminating.
                     * @function markWorkerTerminating
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest} request MarkWorkerTerminatingRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#batchUpdateWorkerAssignments}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef BatchUpdateWorkerAssignmentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls BatchUpdateWorkerAssignments.
                     * @function batchUpdateWorkerAssignments
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest} request BatchUpdateWorkerAssignmentsRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.BatchUpdateWorkerAssignmentsCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.batchUpdateWorkerAssignments = function batchUpdateWorkerAssignments(request, callback) {
                        return this.rpcCall(batchUpdateWorkerAssignments, $root.palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "BatchUpdateWorkerAssignments" });
    
                    /**
                     * Calls BatchUpdateWorkerAssignments.
                     * @function batchUpdateWorkerAssignments
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest} request BatchUpdateWorkerAssignmentsRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.WorkerService#reportEdgeBoxStatus}.
                     * @memberof palexy.streaming.v1.WorkerService
                     * @typedef ReportEdgeBoxStatusCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReportEdgeBoxStatusResponse} [response] ReportEdgeBoxStatusResponse
                     */
    
                    /**
                     * Calls ReportEdgeBoxStatus.
                     * @function reportEdgeBoxStatus
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest} request ReportEdgeBoxStatusRequest message or plain object
                     * @param {palexy.streaming.v1.WorkerService.ReportEdgeBoxStatusCallback} callback Node-style callback called with the error, if any, and ReportEdgeBoxStatusResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(WorkerService.prototype.reportEdgeBoxStatus = function reportEdgeBoxStatus(request, callback) {
                        return this.rpcCall(reportEdgeBoxStatus, $root.palexy.streaming.v1.ReportEdgeBoxStatusRequest, $root.palexy.streaming.v1.ReportEdgeBoxStatusResponse, request, callback);
                    }, "name", { value: "ReportEdgeBoxStatus" });
    
                    /**
                     * Calls ReportEdgeBoxStatus.
                     * @function reportEdgeBoxStatus
                     * @memberof palexy.streaming.v1.WorkerService
                     * @instance
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest} request ReportEdgeBoxStatusRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReportEdgeBoxStatusResponse>} Promise
                     * @variation 2
                     */
    
                    return WorkerService;
                })();
    
                v1.MarkWorkerTerminatingRequest = (function() {
    
                    /**
                     * Properties of a MarkWorkerTerminatingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IMarkWorkerTerminatingRequest
                     * @property {string|null} [worker] MarkWorkerTerminatingRequest worker
                     */
    
                    /**
                     * Constructs a new MarkWorkerTerminatingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MarkWorkerTerminatingRequest.
                     * @implements IMarkWorkerTerminatingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest=} [properties] Properties to set
                     */
                    function MarkWorkerTerminatingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MarkWorkerTerminatingRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @instance
                     */
                    MarkWorkerTerminatingRequest.prototype.worker = "";
    
                    /**
                     * Creates a new MarkWorkerTerminatingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MarkWorkerTerminatingRequest} MarkWorkerTerminatingRequest instance
                     */
                    MarkWorkerTerminatingRequest.create = function create(properties) {
                        return new MarkWorkerTerminatingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MarkWorkerTerminatingRequest message. Does not implicitly {@link palexy.streaming.v1.MarkWorkerTerminatingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest} message MarkWorkerTerminatingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkWorkerTerminatingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MarkWorkerTerminatingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.MarkWorkerTerminatingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkWorkerTerminatingRequest} message MarkWorkerTerminatingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkWorkerTerminatingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MarkWorkerTerminatingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MarkWorkerTerminatingRequest} MarkWorkerTerminatingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkWorkerTerminatingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MarkWorkerTerminatingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MarkWorkerTerminatingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MarkWorkerTerminatingRequest} MarkWorkerTerminatingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkWorkerTerminatingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MarkWorkerTerminatingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MarkWorkerTerminatingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a MarkWorkerTerminatingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MarkWorkerTerminatingRequest} MarkWorkerTerminatingRequest
                     */
                    MarkWorkerTerminatingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MarkWorkerTerminatingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.MarkWorkerTerminatingRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MarkWorkerTerminatingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @static
                     * @param {palexy.streaming.v1.MarkWorkerTerminatingRequest} message MarkWorkerTerminatingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MarkWorkerTerminatingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.worker = "";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        return object;
                    };
    
                    /**
                     * Converts this MarkWorkerTerminatingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MarkWorkerTerminatingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MarkWorkerTerminatingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MarkWorkerTerminatingRequest;
                })();
    
                v1.ListAvailableVersionsRequest = (function() {
    
                    /**
                     * Properties of a ListAvailableVersionsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListAvailableVersionsRequest
                     * @property {palexy.streaming.v1.BoxVersionType|null} [versionType] ListAvailableVersionsRequest versionType
                     */
    
                    /**
                     * Constructs a new ListAvailableVersionsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAvailableVersionsRequest.
                     * @implements IListAvailableVersionsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest=} [properties] Properties to set
                     */
                    function ListAvailableVersionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAvailableVersionsRequest versionType.
                     * @member {palexy.streaming.v1.BoxVersionType} versionType
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @instance
                     */
                    ListAvailableVersionsRequest.prototype.versionType = 0;
    
                    /**
                     * Creates a new ListAvailableVersionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAvailableVersionsRequest} ListAvailableVersionsRequest instance
                     */
                    ListAvailableVersionsRequest.create = function create(properties) {
                        return new ListAvailableVersionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAvailableVersionsRequest message. Does not implicitly {@link palexy.streaming.v1.ListAvailableVersionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest} message ListAvailableVersionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAvailableVersionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.versionType != null && Object.hasOwnProperty.call(message, "versionType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.versionType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAvailableVersionsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAvailableVersionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsRequest} message ListAvailableVersionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAvailableVersionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAvailableVersionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAvailableVersionsRequest} ListAvailableVersionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAvailableVersionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAvailableVersionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.versionType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAvailableVersionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAvailableVersionsRequest} ListAvailableVersionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAvailableVersionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAvailableVersionsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAvailableVersionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.versionType != null && message.hasOwnProperty("versionType"))
                            switch (message.versionType) {
                            default:
                                return "versionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ListAvailableVersionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAvailableVersionsRequest} ListAvailableVersionsRequest
                     */
                    ListAvailableVersionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAvailableVersionsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAvailableVersionsRequest();
                        switch (object.versionType) {
                        case "BOX_VERSION_TYPE_UNKNOWN":
                        case 0:
                            message.versionType = 0;
                            break;
                        case "DOCKER_IMAGE":
                        case 1:
                            message.versionType = 1;
                            break;
                        case "CLOUD_BINARY":
                        case 2:
                            message.versionType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAvailableVersionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListAvailableVersionsRequest} message ListAvailableVersionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAvailableVersionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.versionType = options.enums === String ? "BOX_VERSION_TYPE_UNKNOWN" : 0;
                        if (message.versionType != null && message.hasOwnProperty("versionType"))
                            object.versionType = options.enums === String ? $root.palexy.streaming.v1.BoxVersionType[message.versionType] : message.versionType;
                        return object;
                    };
    
                    /**
                     * Converts this ListAvailableVersionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAvailableVersionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAvailableVersionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAvailableVersionsRequest;
                })();
    
                v1.ListAvailableVersionsResponse = (function() {
    
                    /**
                     * Properties of a ListAvailableVersionsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListAvailableVersionsResponse
                     * @property {Array.<palexy.streaming.v1.IBoxAvailableVersion>|null} [versions] ListAvailableVersionsResponse versions
                     */
    
                    /**
                     * Constructs a new ListAvailableVersionsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAvailableVersionsResponse.
                     * @implements IListAvailableVersionsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListAvailableVersionsResponse=} [properties] Properties to set
                     */
                    function ListAvailableVersionsResponse(properties) {
                        this.versions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAvailableVersionsResponse versions.
                     * @member {Array.<palexy.streaming.v1.IBoxAvailableVersion>} versions
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @instance
                     */
                    ListAvailableVersionsResponse.prototype.versions = $util.emptyArray;
    
                    /**
                     * Creates a new ListAvailableVersionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAvailableVersionsResponse} ListAvailableVersionsResponse instance
                     */
                    ListAvailableVersionsResponse.create = function create(properties) {
                        return new ListAvailableVersionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAvailableVersionsResponse message. Does not implicitly {@link palexy.streaming.v1.ListAvailableVersionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsResponse} message ListAvailableVersionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAvailableVersionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.versions != null && message.versions.length)
                            for (var i = 0; i < message.versions.length; ++i)
                                $root.palexy.streaming.v1.BoxAvailableVersion.encode(message.versions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAvailableVersionsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAvailableVersionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAvailableVersionsResponse} message ListAvailableVersionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAvailableVersionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAvailableVersionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAvailableVersionsResponse} ListAvailableVersionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAvailableVersionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAvailableVersionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.versions && message.versions.length))
                                    message.versions = [];
                                message.versions.push($root.palexy.streaming.v1.BoxAvailableVersion.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAvailableVersionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAvailableVersionsResponse} ListAvailableVersionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAvailableVersionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAvailableVersionsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAvailableVersionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.versions != null && message.hasOwnProperty("versions")) {
                            if (!Array.isArray(message.versions))
                                return "versions: array expected";
                            for (var i = 0; i < message.versions.length; ++i) {
                                var error = $root.palexy.streaming.v1.BoxAvailableVersion.verify(message.versions[i]);
                                if (error)
                                    return "versions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAvailableVersionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAvailableVersionsResponse} ListAvailableVersionsResponse
                     */
                    ListAvailableVersionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAvailableVersionsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAvailableVersionsResponse();
                        if (object.versions) {
                            if (!Array.isArray(object.versions))
                                throw TypeError(".palexy.streaming.v1.ListAvailableVersionsResponse.versions: array expected");
                            message.versions = [];
                            for (var i = 0; i < object.versions.length; ++i) {
                                if (typeof object.versions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAvailableVersionsResponse.versions: object expected");
                                message.versions[i] = $root.palexy.streaming.v1.BoxAvailableVersion.fromObject(object.versions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAvailableVersionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListAvailableVersionsResponse} message ListAvailableVersionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAvailableVersionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.versions = [];
                        if (message.versions && message.versions.length) {
                            object.versions = [];
                            for (var j = 0; j < message.versions.length; ++j)
                                object.versions[j] = $root.palexy.streaming.v1.BoxAvailableVersion.toObject(message.versions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListAvailableVersionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAvailableVersionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAvailableVersionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAvailableVersionsResponse;
                })();
    
                /**
                 * EdgeWorkerComponentName enum.
                 * @name palexy.streaming.v1.EdgeWorkerComponentName
                 * @enum {number}
                 * @property {number} EDGE_WORKER_COMPONENT_NAME_UNKNOWN=0 EDGE_WORKER_COMPONENT_NAME_UNKNOWN value
                 * @property {number} STREAMING_WORKER=1 STREAMING_WORKER value
                 * @property {number} LOCAL_PREPROCESSING_WORKER=2 LOCAL_PREPROCESSING_WORKER value
                 * @property {number} VIDEO_DOCTOR=3 VIDEO_DOCTOR value
                 * @property {number} PREPROCESSING_COORDINATOR=4 PREPROCESSING_COORDINATOR value
                 * @property {number} LOCAL_PROCESSING_WORKER=5 LOCAL_PROCESSING_WORKER value
                 * @property {number} PROCESSING_COORDINATOR=6 PROCESSING_COORDINATOR value
                 * @property {number} LOCAL_POSTPROCESSING_WORKER=7 LOCAL_POSTPROCESSING_WORKER value
                 * @property {number} POSTPROCESSING_COORDINATOR=8 POSTPROCESSING_COORDINATOR value
                 * @property {number} HUMAN_SUPERVISOR_LOCAL_TASK_DISPATCHER=9 HUMAN_SUPERVISOR_LOCAL_TASK_DISPATCHER value
                 * @property {number} HUMAN_SUPERVISOR_TASK_EXECUTOR=10 HUMAN_SUPERVISOR_TASK_EXECUTOR value
                 * @property {number} LOCAL_STORAGE_MANAGER=11 LOCAL_STORAGE_MANAGER value
                 * @property {number} FFMPEG=12 FFMPEG value
                 */
                v1.EdgeWorkerComponentName = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "EDGE_WORKER_COMPONENT_NAME_UNKNOWN"] = 0;
                    values[valuesById[1] = "STREAMING_WORKER"] = 1;
                    values[valuesById[2] = "LOCAL_PREPROCESSING_WORKER"] = 2;
                    values[valuesById[3] = "VIDEO_DOCTOR"] = 3;
                    values[valuesById[4] = "PREPROCESSING_COORDINATOR"] = 4;
                    values[valuesById[5] = "LOCAL_PROCESSING_WORKER"] = 5;
                    values[valuesById[6] = "PROCESSING_COORDINATOR"] = 6;
                    values[valuesById[7] = "LOCAL_POSTPROCESSING_WORKER"] = 7;
                    values[valuesById[8] = "POSTPROCESSING_COORDINATOR"] = 8;
                    values[valuesById[9] = "HUMAN_SUPERVISOR_LOCAL_TASK_DISPATCHER"] = 9;
                    values[valuesById[10] = "HUMAN_SUPERVISOR_TASK_EXECUTOR"] = 10;
                    values[valuesById[11] = "LOCAL_STORAGE_MANAGER"] = 11;
                    values[valuesById[12] = "FFMPEG"] = 12;
                    return values;
                })();
    
                /**
                 * BoxVersionType enum.
                 * @name palexy.streaming.v1.BoxVersionType
                 * @enum {number}
                 * @property {number} BOX_VERSION_TYPE_UNKNOWN=0 BOX_VERSION_TYPE_UNKNOWN value
                 * @property {number} DOCKER_IMAGE=1 DOCKER_IMAGE value
                 * @property {number} CLOUD_BINARY=2 CLOUD_BINARY value
                 */
                v1.BoxVersionType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "BOX_VERSION_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "DOCKER_IMAGE"] = 1;
                    values[valuesById[2] = "CLOUD_BINARY"] = 2;
                    return values;
                })();
    
                v1.UpgradeWorkerRequest = (function() {
    
                    /**
                     * Properties of an UpgradeWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpgradeWorkerRequest
                     * @property {number|null} [workerId] UpgradeWorkerRequest workerId
                     * @property {string|null} [version] UpgradeWorkerRequest version
                     * @property {Object.<string,string>|null} [componentVersions] UpgradeWorkerRequest componentVersions
                     */
    
                    /**
                     * Constructs a new UpgradeWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpgradeWorkerRequest.
                     * @implements IUpgradeWorkerRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest=} [properties] Properties to set
                     */
                    function UpgradeWorkerRequest(properties) {
                        this.componentVersions = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpgradeWorkerRequest workerId.
                     * @member {number} workerId
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @instance
                     */
                    UpgradeWorkerRequest.prototype.workerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpgradeWorkerRequest version.
                     * @member {string} version
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @instance
                     */
                    UpgradeWorkerRequest.prototype.version = "";
    
                    /**
                     * UpgradeWorkerRequest componentVersions.
                     * @member {Object.<string,string>} componentVersions
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @instance
                     */
                    UpgradeWorkerRequest.prototype.componentVersions = $util.emptyObject;
    
                    /**
                     * Creates a new UpgradeWorkerRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpgradeWorkerRequest} UpgradeWorkerRequest instance
                     */
                    UpgradeWorkerRequest.create = function create(properties) {
                        return new UpgradeWorkerRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpgradeWorkerRequest message. Does not implicitly {@link palexy.streaming.v1.UpgradeWorkerRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest} message UpgradeWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpgradeWorkerRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.workerId != null && Object.hasOwnProperty.call(message, "workerId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.workerId);
                        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                        if (message.componentVersions != null && Object.hasOwnProperty.call(message, "componentVersions"))
                            for (var keys = Object.keys(message.componentVersions), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.componentVersions[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpgradeWorkerRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpgradeWorkerRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpgradeWorkerRequest} message UpgradeWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpgradeWorkerRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpgradeWorkerRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpgradeWorkerRequest} UpgradeWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpgradeWorkerRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpgradeWorkerRequest(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.workerId = reader.int64();
                                break;
                            case 2:
                                message.version = reader.string();
                                break;
                            case 3:
                                if (message.componentVersions === $util.emptyObject)
                                    message.componentVersions = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.componentVersions[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpgradeWorkerRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpgradeWorkerRequest} UpgradeWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpgradeWorkerRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpgradeWorkerRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpgradeWorkerRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.workerId != null && message.hasOwnProperty("workerId"))
                            if (!$util.isInteger(message.workerId) && !(message.workerId && $util.isInteger(message.workerId.low) && $util.isInteger(message.workerId.high)))
                                return "workerId: integer|Long expected";
                        if (message.version != null && message.hasOwnProperty("version"))
                            if (!$util.isString(message.version))
                                return "version: string expected";
                        if (message.componentVersions != null && message.hasOwnProperty("componentVersions")) {
                            if (!$util.isObject(message.componentVersions))
                                return "componentVersions: object expected";
                            var key = Object.keys(message.componentVersions);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.componentVersions[key[i]]))
                                    return "componentVersions: string{k:string} expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpgradeWorkerRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpgradeWorkerRequest} UpgradeWorkerRequest
                     */
                    UpgradeWorkerRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpgradeWorkerRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpgradeWorkerRequest();
                        if (object.workerId != null)
                            if ($util.Long)
                                (message.workerId = $util.Long.fromValue(object.workerId)).unsigned = false;
                            else if (typeof object.workerId === "string")
                                message.workerId = parseInt(object.workerId, 10);
                            else if (typeof object.workerId === "number")
                                message.workerId = object.workerId;
                            else if (typeof object.workerId === "object")
                                message.workerId = new $util.LongBits(object.workerId.low >>> 0, object.workerId.high >>> 0).toNumber();
                        if (object.version != null)
                            message.version = String(object.version);
                        if (object.componentVersions) {
                            if (typeof object.componentVersions !== "object")
                                throw TypeError(".palexy.streaming.v1.UpgradeWorkerRequest.componentVersions: object expected");
                            message.componentVersions = {};
                            for (var keys = Object.keys(object.componentVersions), i = 0; i < keys.length; ++i)
                                message.componentVersions[keys[i]] = String(object.componentVersions[keys[i]]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpgradeWorkerRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.UpgradeWorkerRequest} message UpgradeWorkerRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpgradeWorkerRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.componentVersions = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.workerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.workerId = options.longs === String ? "0" : 0;
                            object.version = "";
                        }
                        if (message.workerId != null && message.hasOwnProperty("workerId"))
                            if (typeof message.workerId === "number")
                                object.workerId = options.longs === String ? String(message.workerId) : message.workerId;
                            else
                                object.workerId = options.longs === String ? $util.Long.prototype.toString.call(message.workerId) : options.longs === Number ? new $util.LongBits(message.workerId.low >>> 0, message.workerId.high >>> 0).toNumber() : message.workerId;
                        if (message.version != null && message.hasOwnProperty("version"))
                            object.version = message.version;
                        var keys2;
                        if (message.componentVersions && (keys2 = Object.keys(message.componentVersions)).length) {
                            object.componentVersions = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.componentVersions[keys2[j]] = message.componentVersions[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this UpgradeWorkerRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpgradeWorkerRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpgradeWorkerRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpgradeWorkerRequest;
                })();
    
                v1.BoxAvailableVersion = (function() {
    
                    /**
                     * Properties of a BoxAvailableVersion.
                     * @memberof palexy.streaming.v1
                     * @interface IBoxAvailableVersion
                     * @property {number|null} [id] BoxAvailableVersion id
                     * @property {string|null} [version] BoxAvailableVersion version
                     * @property {string|null} [componentName] BoxAvailableVersion componentName
                     * @property {palexy.streaming.v1.BoxVersionType|null} [versionType] BoxAvailableVersion versionType
                     */
    
                    /**
                     * Constructs a new BoxAvailableVersion.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BoxAvailableVersion.
                     * @implements IBoxAvailableVersion
                     * @constructor
                     * @param {palexy.streaming.v1.IBoxAvailableVersion=} [properties] Properties to set
                     */
                    function BoxAvailableVersion(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BoxAvailableVersion id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @instance
                     */
                    BoxAvailableVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BoxAvailableVersion version.
                     * @member {string} version
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @instance
                     */
                    BoxAvailableVersion.prototype.version = "";
    
                    /**
                     * BoxAvailableVersion componentName.
                     * @member {string} componentName
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @instance
                     */
                    BoxAvailableVersion.prototype.componentName = "";
    
                    /**
                     * BoxAvailableVersion versionType.
                     * @member {palexy.streaming.v1.BoxVersionType} versionType
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @instance
                     */
                    BoxAvailableVersion.prototype.versionType = 0;
    
                    /**
                     * Creates a new BoxAvailableVersion instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {palexy.streaming.v1.IBoxAvailableVersion=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BoxAvailableVersion} BoxAvailableVersion instance
                     */
                    BoxAvailableVersion.create = function create(properties) {
                        return new BoxAvailableVersion(properties);
                    };
    
                    /**
                     * Encodes the specified BoxAvailableVersion message. Does not implicitly {@link palexy.streaming.v1.BoxAvailableVersion.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {palexy.streaming.v1.IBoxAvailableVersion} message BoxAvailableVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoxAvailableVersion.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                        if (message.componentName != null && Object.hasOwnProperty.call(message, "componentName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.componentName);
                        if (message.versionType != null && Object.hasOwnProperty.call(message, "versionType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.versionType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BoxAvailableVersion message, length delimited. Does not implicitly {@link palexy.streaming.v1.BoxAvailableVersion.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {palexy.streaming.v1.IBoxAvailableVersion} message BoxAvailableVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoxAvailableVersion.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BoxAvailableVersion message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BoxAvailableVersion} BoxAvailableVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoxAvailableVersion.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BoxAvailableVersion();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.version = reader.string();
                                break;
                            case 3:
                                message.componentName = reader.string();
                                break;
                            case 4:
                                message.versionType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BoxAvailableVersion message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BoxAvailableVersion} BoxAvailableVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoxAvailableVersion.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BoxAvailableVersion message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BoxAvailableVersion.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.version != null && message.hasOwnProperty("version"))
                            if (!$util.isString(message.version))
                                return "version: string expected";
                        if (message.componentName != null && message.hasOwnProperty("componentName"))
                            if (!$util.isString(message.componentName))
                                return "componentName: string expected";
                        if (message.versionType != null && message.hasOwnProperty("versionType"))
                            switch (message.versionType) {
                            default:
                                return "versionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a BoxAvailableVersion message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BoxAvailableVersion} BoxAvailableVersion
                     */
                    BoxAvailableVersion.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BoxAvailableVersion)
                            return object;
                        var message = new $root.palexy.streaming.v1.BoxAvailableVersion();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.version != null)
                            message.version = String(object.version);
                        if (object.componentName != null)
                            message.componentName = String(object.componentName);
                        switch (object.versionType) {
                        case "BOX_VERSION_TYPE_UNKNOWN":
                        case 0:
                            message.versionType = 0;
                            break;
                        case "DOCKER_IMAGE":
                        case 1:
                            message.versionType = 1;
                            break;
                        case "CLOUD_BINARY":
                        case 2:
                            message.versionType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BoxAvailableVersion message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @static
                     * @param {palexy.streaming.v1.BoxAvailableVersion} message BoxAvailableVersion
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BoxAvailableVersion.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.version = "";
                            object.componentName = "";
                            object.versionType = options.enums === String ? "BOX_VERSION_TYPE_UNKNOWN" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.version != null && message.hasOwnProperty("version"))
                            object.version = message.version;
                        if (message.componentName != null && message.hasOwnProperty("componentName"))
                            object.componentName = message.componentName;
                        if (message.versionType != null && message.hasOwnProperty("versionType"))
                            object.versionType = options.enums === String ? $root.palexy.streaming.v1.BoxVersionType[message.versionType] : message.versionType;
                        return object;
                    };
    
                    /**
                     * Converts this BoxAvailableVersion to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BoxAvailableVersion
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BoxAvailableVersion.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BoxAvailableVersion;
                })();
    
                v1.Worker = (function() {
    
                    /**
                     * Properties of a Worker.
                     * @memberof palexy.streaming.v1
                     * @interface IWorker
                     * @property {string|null} [name] Worker name
                     * @property {number|null} [maximumCapacity] Worker maximumCapacity
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [assignedCameras] Worker assignedCameras
                     * @property {google.protobuf.ITimestamp|null} [lastHeartbeatTime] Worker lastHeartbeatTime
                     * @property {string|null} [location] Worker location
                     * @property {palexy.streaming.v1.Worker.WorkerStatus|null} [status] Worker status
                     * @property {boolean|null} [strictlyMatchWithSameLocation] Worker strictlyMatchWithSameLocation
                     * @property {number|null} [id] Worker id
                     * @property {google.protobuf.ITimestamp|null} [createTime] Worker createTime
                     * @property {string|null} [runningVersion] Worker runningVersion
                     * @property {string|null} [desiredVersion] Worker desiredVersion
                     * @property {Object.<string,string>|null} [componentDesiredVersionByName] Worker componentDesiredVersionByName
                     * @property {Object.<string,string>|null} [componentRunningVersionByName] Worker componentRunningVersionByName
                     * @property {palexy.streaming.v1.IEdgeBoxStatus|null} [edgeBoxStatus] Worker edgeBoxStatus
                     */
    
                    /**
                     * Constructs a new Worker.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Worker.
                     * @implements IWorker
                     * @constructor
                     * @param {palexy.streaming.v1.IWorker=} [properties] Properties to set
                     */
                    function Worker(properties) {
                        this.assignedCameras = [];
                        this.componentDesiredVersionByName = {};
                        this.componentRunningVersionByName = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Worker name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.name = "";
    
                    /**
                     * Worker maximumCapacity.
                     * @member {number} maximumCapacity
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.maximumCapacity = 0;
    
                    /**
                     * Worker assignedCameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} assignedCameras
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.assignedCameras = $util.emptyArray;
    
                    /**
                     * Worker lastHeartbeatTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastHeartbeatTime
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.lastHeartbeatTime = null;
    
                    /**
                     * Worker location.
                     * @member {string} location
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.location = "";
    
                    /**
                     * Worker status.
                     * @member {palexy.streaming.v1.Worker.WorkerStatus} status
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.status = 0;
    
                    /**
                     * Worker strictlyMatchWithSameLocation.
                     * @member {boolean} strictlyMatchWithSameLocation
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.strictlyMatchWithSameLocation = false;
    
                    /**
                     * Worker id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Worker createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.createTime = null;
    
                    /**
                     * Worker runningVersion.
                     * @member {string} runningVersion
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.runningVersion = "";
    
                    /**
                     * Worker desiredVersion.
                     * @member {string} desiredVersion
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.desiredVersion = "";
    
                    /**
                     * Worker componentDesiredVersionByName.
                     * @member {Object.<string,string>} componentDesiredVersionByName
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.componentDesiredVersionByName = $util.emptyObject;
    
                    /**
                     * Worker componentRunningVersionByName.
                     * @member {Object.<string,string>} componentRunningVersionByName
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.componentRunningVersionByName = $util.emptyObject;
    
                    /**
                     * Worker edgeBoxStatus.
                     * @member {palexy.streaming.v1.IEdgeBoxStatus|null|undefined} edgeBoxStatus
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     */
                    Worker.prototype.edgeBoxStatus = null;
    
                    /**
                     * Creates a new Worker instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {palexy.streaming.v1.IWorker=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Worker} Worker instance
                     */
                    Worker.create = function create(properties) {
                        return new Worker(properties);
                    };
    
                    /**
                     * Encodes the specified Worker message. Does not implicitly {@link palexy.streaming.v1.Worker.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {palexy.streaming.v1.IWorker} message Worker message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Worker.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.maximumCapacity != null && Object.hasOwnProperty.call(message, "maximumCapacity"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maximumCapacity);
                        if (message.assignedCameras != null && message.assignedCameras.length)
                            for (var i = 0; i < message.assignedCameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.assignedCameras[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.lastHeartbeatTime != null && Object.hasOwnProperty.call(message, "lastHeartbeatTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastHeartbeatTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.location);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
                        if (message.strictlyMatchWithSameLocation != null && Object.hasOwnProperty.call(message, "strictlyMatchWithSameLocation"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.strictlyMatchWithSameLocation);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.id);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.runningVersion != null && Object.hasOwnProperty.call(message, "runningVersion"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.runningVersion);
                        if (message.desiredVersion != null && Object.hasOwnProperty.call(message, "desiredVersion"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.desiredVersion);
                        if (message.componentDesiredVersionByName != null && Object.hasOwnProperty.call(message, "componentDesiredVersionByName"))
                            for (var keys = Object.keys(message.componentDesiredVersionByName), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 12, wireType 2 =*/98).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.componentDesiredVersionByName[keys[i]]).ldelim();
                        if (message.componentRunningVersionByName != null && Object.hasOwnProperty.call(message, "componentRunningVersionByName"))
                            for (var keys = Object.keys(message.componentRunningVersionByName), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 13, wireType 2 =*/106).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.componentRunningVersionByName[keys[i]]).ldelim();
                        if (message.edgeBoxStatus != null && Object.hasOwnProperty.call(message, "edgeBoxStatus"))
                            $root.palexy.streaming.v1.EdgeBoxStatus.encode(message.edgeBoxStatus, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Worker message, length delimited. Does not implicitly {@link palexy.streaming.v1.Worker.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {palexy.streaming.v1.IWorker} message Worker message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Worker.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Worker message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Worker} Worker
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Worker.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Worker(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.maximumCapacity = reader.int32();
                                break;
                            case 3:
                                if (!(message.assignedCameras && message.assignedCameras.length))
                                    message.assignedCameras = [];
                                message.assignedCameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.lastHeartbeatTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.location = reader.string();
                                break;
                            case 6:
                                message.status = reader.int32();
                                break;
                            case 7:
                                message.strictlyMatchWithSameLocation = reader.bool();
                                break;
                            case 8:
                                message.id = reader.int64();
                                break;
                            case 9:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.runningVersion = reader.string();
                                break;
                            case 11:
                                message.desiredVersion = reader.string();
                                break;
                            case 12:
                                if (message.componentDesiredVersionByName === $util.emptyObject)
                                    message.componentDesiredVersionByName = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.componentDesiredVersionByName[key] = value;
                                break;
                            case 13:
                                if (message.componentRunningVersionByName === $util.emptyObject)
                                    message.componentRunningVersionByName = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.componentRunningVersionByName[key] = value;
                                break;
                            case 14:
                                message.edgeBoxStatus = $root.palexy.streaming.v1.EdgeBoxStatus.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Worker message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Worker} Worker
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Worker.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Worker message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Worker.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.maximumCapacity != null && message.hasOwnProperty("maximumCapacity"))
                            if (!$util.isInteger(message.maximumCapacity))
                                return "maximumCapacity: integer expected";
                        if (message.assignedCameras != null && message.hasOwnProperty("assignedCameras")) {
                            if (!Array.isArray(message.assignedCameras))
                                return "assignedCameras: array expected";
                            for (var i = 0; i < message.assignedCameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.assignedCameras[i]);
                                if (error)
                                    return "assignedCameras." + error;
                            }
                        }
                        if (message.lastHeartbeatTime != null && message.hasOwnProperty("lastHeartbeatTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastHeartbeatTime);
                            if (error)
                                return "lastHeartbeatTime." + error;
                        }
                        if (message.location != null && message.hasOwnProperty("location"))
                            if (!$util.isString(message.location))
                                return "location: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.strictlyMatchWithSameLocation != null && message.hasOwnProperty("strictlyMatchWithSameLocation"))
                            if (typeof message.strictlyMatchWithSameLocation !== "boolean")
                                return "strictlyMatchWithSameLocation: boolean expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.runningVersion != null && message.hasOwnProperty("runningVersion"))
                            if (!$util.isString(message.runningVersion))
                                return "runningVersion: string expected";
                        if (message.desiredVersion != null && message.hasOwnProperty("desiredVersion"))
                            if (!$util.isString(message.desiredVersion))
                                return "desiredVersion: string expected";
                        if (message.componentDesiredVersionByName != null && message.hasOwnProperty("componentDesiredVersionByName")) {
                            if (!$util.isObject(message.componentDesiredVersionByName))
                                return "componentDesiredVersionByName: object expected";
                            var key = Object.keys(message.componentDesiredVersionByName);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.componentDesiredVersionByName[key[i]]))
                                    return "componentDesiredVersionByName: string{k:string} expected";
                        }
                        if (message.componentRunningVersionByName != null && message.hasOwnProperty("componentRunningVersionByName")) {
                            if (!$util.isObject(message.componentRunningVersionByName))
                                return "componentRunningVersionByName: object expected";
                            var key = Object.keys(message.componentRunningVersionByName);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.componentRunningVersionByName[key[i]]))
                                    return "componentRunningVersionByName: string{k:string} expected";
                        }
                        if (message.edgeBoxStatus != null && message.hasOwnProperty("edgeBoxStatus")) {
                            var error = $root.palexy.streaming.v1.EdgeBoxStatus.verify(message.edgeBoxStatus);
                            if (error)
                                return "edgeBoxStatus." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Worker message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Worker} Worker
                     */
                    Worker.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Worker)
                            return object;
                        var message = new $root.palexy.streaming.v1.Worker();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.maximumCapacity != null)
                            message.maximumCapacity = object.maximumCapacity | 0;
                        if (object.assignedCameras) {
                            if (!Array.isArray(object.assignedCameras))
                                throw TypeError(".palexy.streaming.v1.Worker.assignedCameras: array expected");
                            message.assignedCameras = [];
                            for (var i = 0; i < object.assignedCameras.length; ++i) {
                                if (typeof object.assignedCameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Worker.assignedCameras: object expected");
                                message.assignedCameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.assignedCameras[i]);
                            }
                        }
                        if (object.lastHeartbeatTime != null) {
                            if (typeof object.lastHeartbeatTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Worker.lastHeartbeatTime: object expected");
                            message.lastHeartbeatTime = $root.google.protobuf.Timestamp.fromObject(object.lastHeartbeatTime);
                        }
                        if (object.location != null)
                            message.location = String(object.location);
                        switch (object.status) {
                        case "WORKER_STATUS_UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.status = 1;
                            break;
                        case "TERMINATING":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.strictlyMatchWithSameLocation != null)
                            message.strictlyMatchWithSameLocation = Boolean(object.strictlyMatchWithSameLocation);
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Worker.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.runningVersion != null)
                            message.runningVersion = String(object.runningVersion);
                        if (object.desiredVersion != null)
                            message.desiredVersion = String(object.desiredVersion);
                        if (object.componentDesiredVersionByName) {
                            if (typeof object.componentDesiredVersionByName !== "object")
                                throw TypeError(".palexy.streaming.v1.Worker.componentDesiredVersionByName: object expected");
                            message.componentDesiredVersionByName = {};
                            for (var keys = Object.keys(object.componentDesiredVersionByName), i = 0; i < keys.length; ++i)
                                message.componentDesiredVersionByName[keys[i]] = String(object.componentDesiredVersionByName[keys[i]]);
                        }
                        if (object.componentRunningVersionByName) {
                            if (typeof object.componentRunningVersionByName !== "object")
                                throw TypeError(".palexy.streaming.v1.Worker.componentRunningVersionByName: object expected");
                            message.componentRunningVersionByName = {};
                            for (var keys = Object.keys(object.componentRunningVersionByName), i = 0; i < keys.length; ++i)
                                message.componentRunningVersionByName[keys[i]] = String(object.componentRunningVersionByName[keys[i]]);
                        }
                        if (object.edgeBoxStatus != null) {
                            if (typeof object.edgeBoxStatus !== "object")
                                throw TypeError(".palexy.streaming.v1.Worker.edgeBoxStatus: object expected");
                            message.edgeBoxStatus = $root.palexy.streaming.v1.EdgeBoxStatus.fromObject(object.edgeBoxStatus);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Worker message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Worker
                     * @static
                     * @param {palexy.streaming.v1.Worker} message Worker
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Worker.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.assignedCameras = [];
                        if (options.objects || options.defaults) {
                            object.componentDesiredVersionByName = {};
                            object.componentRunningVersionByName = {};
                        }
                        if (options.defaults) {
                            object.name = "";
                            object.maximumCapacity = 0;
                            object.lastHeartbeatTime = null;
                            object.location = "";
                            object.status = options.enums === String ? "WORKER_STATUS_UNKNOWN" : 0;
                            object.strictlyMatchWithSameLocation = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.runningVersion = "";
                            object.desiredVersion = "";
                            object.edgeBoxStatus = null;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.maximumCapacity != null && message.hasOwnProperty("maximumCapacity"))
                            object.maximumCapacity = message.maximumCapacity;
                        if (message.assignedCameras && message.assignedCameras.length) {
                            object.assignedCameras = [];
                            for (var j = 0; j < message.assignedCameras.length; ++j)
                                object.assignedCameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.assignedCameras[j], options);
                        }
                        if (message.lastHeartbeatTime != null && message.hasOwnProperty("lastHeartbeatTime"))
                            object.lastHeartbeatTime = $root.google.protobuf.Timestamp.toObject(message.lastHeartbeatTime, options);
                        if (message.location != null && message.hasOwnProperty("location"))
                            object.location = message.location;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.Worker.WorkerStatus[message.status] : message.status;
                        if (message.strictlyMatchWithSameLocation != null && message.hasOwnProperty("strictlyMatchWithSameLocation"))
                            object.strictlyMatchWithSameLocation = message.strictlyMatchWithSameLocation;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.runningVersion != null && message.hasOwnProperty("runningVersion"))
                            object.runningVersion = message.runningVersion;
                        if (message.desiredVersion != null && message.hasOwnProperty("desiredVersion"))
                            object.desiredVersion = message.desiredVersion;
                        var keys2;
                        if (message.componentDesiredVersionByName && (keys2 = Object.keys(message.componentDesiredVersionByName)).length) {
                            object.componentDesiredVersionByName = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.componentDesiredVersionByName[keys2[j]] = message.componentDesiredVersionByName[keys2[j]];
                        }
                        if (message.componentRunningVersionByName && (keys2 = Object.keys(message.componentRunningVersionByName)).length) {
                            object.componentRunningVersionByName = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.componentRunningVersionByName[keys2[j]] = message.componentRunningVersionByName[keys2[j]];
                        }
                        if (message.edgeBoxStatus != null && message.hasOwnProperty("edgeBoxStatus"))
                            object.edgeBoxStatus = $root.palexy.streaming.v1.EdgeBoxStatus.toObject(message.edgeBoxStatus, options);
                        return object;
                    };
    
                    /**
                     * Converts this Worker to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Worker
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Worker.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * WorkerStatus enum.
                     * @name palexy.streaming.v1.Worker.WorkerStatus
                     * @enum {number}
                     * @property {number} WORKER_STATUS_UNKNOWN=0 WORKER_STATUS_UNKNOWN value
                     * @property {number} NORMAL=1 NORMAL value
                     * @property {number} TERMINATING=2 TERMINATING value
                     */
                    Worker.WorkerStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "WORKER_STATUS_UNKNOWN"] = 0;
                        values[valuesById[1] = "NORMAL"] = 1;
                        values[valuesById[2] = "TERMINATING"] = 2;
                        return values;
                    })();
    
                    return Worker;
                })();
    
                v1.EdgeBoxStatus = (function() {
    
                    /**
                     * Properties of an EdgeBoxStatus.
                     * @memberof palexy.streaming.v1
                     * @interface IEdgeBoxStatus
                     * @property {google.protobuf.ITimestamp|null} [lastReportedTime] EdgeBoxStatus lastReportedTime
                     * @property {palexy.streaming.v1.IStorageStatus|null} [storage] EdgeBoxStatus storage
                     * @property {Array.<palexy.streaming.v1.IComponentStatus>|null} [components] EdgeBoxStatus components
                     */
    
                    /**
                     * Constructs a new EdgeBoxStatus.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EdgeBoxStatus.
                     * @implements IEdgeBoxStatus
                     * @constructor
                     * @param {palexy.streaming.v1.IEdgeBoxStatus=} [properties] Properties to set
                     */
                    function EdgeBoxStatus(properties) {
                        this.components = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EdgeBoxStatus lastReportedTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastReportedTime
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @instance
                     */
                    EdgeBoxStatus.prototype.lastReportedTime = null;
    
                    /**
                     * EdgeBoxStatus storage.
                     * @member {palexy.streaming.v1.IStorageStatus|null|undefined} storage
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @instance
                     */
                    EdgeBoxStatus.prototype.storage = null;
    
                    /**
                     * EdgeBoxStatus components.
                     * @member {Array.<palexy.streaming.v1.IComponentStatus>} components
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @instance
                     */
                    EdgeBoxStatus.prototype.components = $util.emptyArray;
    
                    /**
                     * Creates a new EdgeBoxStatus instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {palexy.streaming.v1.IEdgeBoxStatus=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.EdgeBoxStatus} EdgeBoxStatus instance
                     */
                    EdgeBoxStatus.create = function create(properties) {
                        return new EdgeBoxStatus(properties);
                    };
    
                    /**
                     * Encodes the specified EdgeBoxStatus message. Does not implicitly {@link palexy.streaming.v1.EdgeBoxStatus.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {palexy.streaming.v1.IEdgeBoxStatus} message EdgeBoxStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EdgeBoxStatus.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.lastReportedTime != null && Object.hasOwnProperty.call(message, "lastReportedTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastReportedTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.storage != null && Object.hasOwnProperty.call(message, "storage"))
                            $root.palexy.streaming.v1.StorageStatus.encode(message.storage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.components != null && message.components.length)
                            for (var i = 0; i < message.components.length; ++i)
                                $root.palexy.streaming.v1.ComponentStatus.encode(message.components[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EdgeBoxStatus message, length delimited. Does not implicitly {@link palexy.streaming.v1.EdgeBoxStatus.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {palexy.streaming.v1.IEdgeBoxStatus} message EdgeBoxStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EdgeBoxStatus.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EdgeBoxStatus message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.EdgeBoxStatus} EdgeBoxStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EdgeBoxStatus.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.EdgeBoxStatus();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.lastReportedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.storage = $root.palexy.streaming.v1.StorageStatus.decode(reader, reader.uint32());
                                break;
                            case 3:
                                if (!(message.components && message.components.length))
                                    message.components = [];
                                message.components.push($root.palexy.streaming.v1.ComponentStatus.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EdgeBoxStatus message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.EdgeBoxStatus} EdgeBoxStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EdgeBoxStatus.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EdgeBoxStatus message.
                     * @function verify
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EdgeBoxStatus.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.lastReportedTime != null && message.hasOwnProperty("lastReportedTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastReportedTime);
                            if (error)
                                return "lastReportedTime." + error;
                        }
                        if (message.storage != null && message.hasOwnProperty("storage")) {
                            var error = $root.palexy.streaming.v1.StorageStatus.verify(message.storage);
                            if (error)
                                return "storage." + error;
                        }
                        if (message.components != null && message.hasOwnProperty("components")) {
                            if (!Array.isArray(message.components))
                                return "components: array expected";
                            for (var i = 0; i < message.components.length; ++i) {
                                var error = $root.palexy.streaming.v1.ComponentStatus.verify(message.components[i]);
                                if (error)
                                    return "components." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an EdgeBoxStatus message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.EdgeBoxStatus} EdgeBoxStatus
                     */
                    EdgeBoxStatus.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.EdgeBoxStatus)
                            return object;
                        var message = new $root.palexy.streaming.v1.EdgeBoxStatus();
                        if (object.lastReportedTime != null) {
                            if (typeof object.lastReportedTime !== "object")
                                throw TypeError(".palexy.streaming.v1.EdgeBoxStatus.lastReportedTime: object expected");
                            message.lastReportedTime = $root.google.protobuf.Timestamp.fromObject(object.lastReportedTime);
                        }
                        if (object.storage != null) {
                            if (typeof object.storage !== "object")
                                throw TypeError(".palexy.streaming.v1.EdgeBoxStatus.storage: object expected");
                            message.storage = $root.palexy.streaming.v1.StorageStatus.fromObject(object.storage);
                        }
                        if (object.components) {
                            if (!Array.isArray(object.components))
                                throw TypeError(".palexy.streaming.v1.EdgeBoxStatus.components: array expected");
                            message.components = [];
                            for (var i = 0; i < object.components.length; ++i) {
                                if (typeof object.components[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.EdgeBoxStatus.components: object expected");
                                message.components[i] = $root.palexy.streaming.v1.ComponentStatus.fromObject(object.components[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EdgeBoxStatus message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @static
                     * @param {palexy.streaming.v1.EdgeBoxStatus} message EdgeBoxStatus
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EdgeBoxStatus.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.components = [];
                        if (options.defaults) {
                            object.lastReportedTime = null;
                            object.storage = null;
                        }
                        if (message.lastReportedTime != null && message.hasOwnProperty("lastReportedTime"))
                            object.lastReportedTime = $root.google.protobuf.Timestamp.toObject(message.lastReportedTime, options);
                        if (message.storage != null && message.hasOwnProperty("storage"))
                            object.storage = $root.palexy.streaming.v1.StorageStatus.toObject(message.storage, options);
                        if (message.components && message.components.length) {
                            object.components = [];
                            for (var j = 0; j < message.components.length; ++j)
                                object.components[j] = $root.palexy.streaming.v1.ComponentStatus.toObject(message.components[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this EdgeBoxStatus to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.EdgeBoxStatus
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EdgeBoxStatus.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EdgeBoxStatus;
                })();
    
                v1.StorageStatus = (function() {
    
                    /**
                     * Properties of a StorageStatus.
                     * @memberof palexy.streaming.v1
                     * @interface IStorageStatus
                     * @property {palexy.streaming.v1.IVolumeUsage|null} [encryptedVolume] StorageStatus encryptedVolume
                     * @property {palexy.streaming.v1.IVolumeUsage|null} [dataVolume] StorageStatus dataVolume
                     * @property {number|null} [containerTotalBytes] StorageStatus containerTotalBytes
                     * @property {number|null} [containerFreeBytes] StorageStatus containerFreeBytes
                     * @property {number|null} [containerPurgeableBytes] StorageStatus containerPurgeableBytes
                     * @property {palexy.streaming.v1.IWorkspaceUsage|null} [workspace] StorageStatus workspace
                     */
    
                    /**
                     * Constructs a new StorageStatus.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StorageStatus.
                     * @implements IStorageStatus
                     * @constructor
                     * @param {palexy.streaming.v1.IStorageStatus=} [properties] Properties to set
                     */
                    function StorageStatus(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StorageStatus encryptedVolume.
                     * @member {palexy.streaming.v1.IVolumeUsage|null|undefined} encryptedVolume
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.encryptedVolume = null;
    
                    /**
                     * StorageStatus dataVolume.
                     * @member {palexy.streaming.v1.IVolumeUsage|null|undefined} dataVolume
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.dataVolume = null;
    
                    /**
                     * StorageStatus containerTotalBytes.
                     * @member {number} containerTotalBytes
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.containerTotalBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StorageStatus containerFreeBytes.
                     * @member {number} containerFreeBytes
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.containerFreeBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StorageStatus containerPurgeableBytes.
                     * @member {number} containerPurgeableBytes
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.containerPurgeableBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StorageStatus workspace.
                     * @member {palexy.streaming.v1.IWorkspaceUsage|null|undefined} workspace
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     */
                    StorageStatus.prototype.workspace = null;
    
                    /**
                     * Creates a new StorageStatus instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {palexy.streaming.v1.IStorageStatus=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StorageStatus} StorageStatus instance
                     */
                    StorageStatus.create = function create(properties) {
                        return new StorageStatus(properties);
                    };
    
                    /**
                     * Encodes the specified StorageStatus message. Does not implicitly {@link palexy.streaming.v1.StorageStatus.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {palexy.streaming.v1.IStorageStatus} message StorageStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StorageStatus.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.encryptedVolume != null && Object.hasOwnProperty.call(message, "encryptedVolume"))
                            $root.palexy.streaming.v1.VolumeUsage.encode(message.encryptedVolume, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.dataVolume != null && Object.hasOwnProperty.call(message, "dataVolume"))
                            $root.palexy.streaming.v1.VolumeUsage.encode(message.dataVolume, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.containerTotalBytes != null && Object.hasOwnProperty.call(message, "containerTotalBytes"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.containerTotalBytes);
                        if (message.containerFreeBytes != null && Object.hasOwnProperty.call(message, "containerFreeBytes"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.containerFreeBytes);
                        if (message.containerPurgeableBytes != null && Object.hasOwnProperty.call(message, "containerPurgeableBytes"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.containerPurgeableBytes);
                        if (message.workspace != null && Object.hasOwnProperty.call(message, "workspace"))
                            $root.palexy.streaming.v1.WorkspaceUsage.encode(message.workspace, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StorageStatus message, length delimited. Does not implicitly {@link palexy.streaming.v1.StorageStatus.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {palexy.streaming.v1.IStorageStatus} message StorageStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StorageStatus.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StorageStatus message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StorageStatus} StorageStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StorageStatus.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StorageStatus();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.encryptedVolume = $root.palexy.streaming.v1.VolumeUsage.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.dataVolume = $root.palexy.streaming.v1.VolumeUsage.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.containerTotalBytes = reader.int64();
                                break;
                            case 4:
                                message.containerFreeBytes = reader.int64();
                                break;
                            case 5:
                                message.containerPurgeableBytes = reader.int64();
                                break;
                            case 6:
                                message.workspace = $root.palexy.streaming.v1.WorkspaceUsage.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StorageStatus message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StorageStatus} StorageStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StorageStatus.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StorageStatus message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StorageStatus.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.encryptedVolume != null && message.hasOwnProperty("encryptedVolume")) {
                            var error = $root.palexy.streaming.v1.VolumeUsage.verify(message.encryptedVolume);
                            if (error)
                                return "encryptedVolume." + error;
                        }
                        if (message.dataVolume != null && message.hasOwnProperty("dataVolume")) {
                            var error = $root.palexy.streaming.v1.VolumeUsage.verify(message.dataVolume);
                            if (error)
                                return "dataVolume." + error;
                        }
                        if (message.containerTotalBytes != null && message.hasOwnProperty("containerTotalBytes"))
                            if (!$util.isInteger(message.containerTotalBytes) && !(message.containerTotalBytes && $util.isInteger(message.containerTotalBytes.low) && $util.isInteger(message.containerTotalBytes.high)))
                                return "containerTotalBytes: integer|Long expected";
                        if (message.containerFreeBytes != null && message.hasOwnProperty("containerFreeBytes"))
                            if (!$util.isInteger(message.containerFreeBytes) && !(message.containerFreeBytes && $util.isInteger(message.containerFreeBytes.low) && $util.isInteger(message.containerFreeBytes.high)))
                                return "containerFreeBytes: integer|Long expected";
                        if (message.containerPurgeableBytes != null && message.hasOwnProperty("containerPurgeableBytes"))
                            if (!$util.isInteger(message.containerPurgeableBytes) && !(message.containerPurgeableBytes && $util.isInteger(message.containerPurgeableBytes.low) && $util.isInteger(message.containerPurgeableBytes.high)))
                                return "containerPurgeableBytes: integer|Long expected";
                        if (message.workspace != null && message.hasOwnProperty("workspace")) {
                            var error = $root.palexy.streaming.v1.WorkspaceUsage.verify(message.workspace);
                            if (error)
                                return "workspace." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StorageStatus message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StorageStatus} StorageStatus
                     */
                    StorageStatus.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StorageStatus)
                            return object;
                        var message = new $root.palexy.streaming.v1.StorageStatus();
                        if (object.encryptedVolume != null) {
                            if (typeof object.encryptedVolume !== "object")
                                throw TypeError(".palexy.streaming.v1.StorageStatus.encryptedVolume: object expected");
                            message.encryptedVolume = $root.palexy.streaming.v1.VolumeUsage.fromObject(object.encryptedVolume);
                        }
                        if (object.dataVolume != null) {
                            if (typeof object.dataVolume !== "object")
                                throw TypeError(".palexy.streaming.v1.StorageStatus.dataVolume: object expected");
                            message.dataVolume = $root.palexy.streaming.v1.VolumeUsage.fromObject(object.dataVolume);
                        }
                        if (object.containerTotalBytes != null)
                            if ($util.Long)
                                (message.containerTotalBytes = $util.Long.fromValue(object.containerTotalBytes)).unsigned = false;
                            else if (typeof object.containerTotalBytes === "string")
                                message.containerTotalBytes = parseInt(object.containerTotalBytes, 10);
                            else if (typeof object.containerTotalBytes === "number")
                                message.containerTotalBytes = object.containerTotalBytes;
                            else if (typeof object.containerTotalBytes === "object")
                                message.containerTotalBytes = new $util.LongBits(object.containerTotalBytes.low >>> 0, object.containerTotalBytes.high >>> 0).toNumber();
                        if (object.containerFreeBytes != null)
                            if ($util.Long)
                                (message.containerFreeBytes = $util.Long.fromValue(object.containerFreeBytes)).unsigned = false;
                            else if (typeof object.containerFreeBytes === "string")
                                message.containerFreeBytes = parseInt(object.containerFreeBytes, 10);
                            else if (typeof object.containerFreeBytes === "number")
                                message.containerFreeBytes = object.containerFreeBytes;
                            else if (typeof object.containerFreeBytes === "object")
                                message.containerFreeBytes = new $util.LongBits(object.containerFreeBytes.low >>> 0, object.containerFreeBytes.high >>> 0).toNumber();
                        if (object.containerPurgeableBytes != null)
                            if ($util.Long)
                                (message.containerPurgeableBytes = $util.Long.fromValue(object.containerPurgeableBytes)).unsigned = false;
                            else if (typeof object.containerPurgeableBytes === "string")
                                message.containerPurgeableBytes = parseInt(object.containerPurgeableBytes, 10);
                            else if (typeof object.containerPurgeableBytes === "number")
                                message.containerPurgeableBytes = object.containerPurgeableBytes;
                            else if (typeof object.containerPurgeableBytes === "object")
                                message.containerPurgeableBytes = new $util.LongBits(object.containerPurgeableBytes.low >>> 0, object.containerPurgeableBytes.high >>> 0).toNumber();
                        if (object.workspace != null) {
                            if (typeof object.workspace !== "object")
                                throw TypeError(".palexy.streaming.v1.StorageStatus.workspace: object expected");
                            message.workspace = $root.palexy.streaming.v1.WorkspaceUsage.fromObject(object.workspace);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StorageStatus message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @static
                     * @param {palexy.streaming.v1.StorageStatus} message StorageStatus
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StorageStatus.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.encryptedVolume = null;
                            object.dataVolume = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.containerTotalBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.containerTotalBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.containerFreeBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.containerFreeBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.containerPurgeableBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.containerPurgeableBytes = options.longs === String ? "0" : 0;
                            object.workspace = null;
                        }
                        if (message.encryptedVolume != null && message.hasOwnProperty("encryptedVolume"))
                            object.encryptedVolume = $root.palexy.streaming.v1.VolumeUsage.toObject(message.encryptedVolume, options);
                        if (message.dataVolume != null && message.hasOwnProperty("dataVolume"))
                            object.dataVolume = $root.palexy.streaming.v1.VolumeUsage.toObject(message.dataVolume, options);
                        if (message.containerTotalBytes != null && message.hasOwnProperty("containerTotalBytes"))
                            if (typeof message.containerTotalBytes === "number")
                                object.containerTotalBytes = options.longs === String ? String(message.containerTotalBytes) : message.containerTotalBytes;
                            else
                                object.containerTotalBytes = options.longs === String ? $util.Long.prototype.toString.call(message.containerTotalBytes) : options.longs === Number ? new $util.LongBits(message.containerTotalBytes.low >>> 0, message.containerTotalBytes.high >>> 0).toNumber() : message.containerTotalBytes;
                        if (message.containerFreeBytes != null && message.hasOwnProperty("containerFreeBytes"))
                            if (typeof message.containerFreeBytes === "number")
                                object.containerFreeBytes = options.longs === String ? String(message.containerFreeBytes) : message.containerFreeBytes;
                            else
                                object.containerFreeBytes = options.longs === String ? $util.Long.prototype.toString.call(message.containerFreeBytes) : options.longs === Number ? new $util.LongBits(message.containerFreeBytes.low >>> 0, message.containerFreeBytes.high >>> 0).toNumber() : message.containerFreeBytes;
                        if (message.containerPurgeableBytes != null && message.hasOwnProperty("containerPurgeableBytes"))
                            if (typeof message.containerPurgeableBytes === "number")
                                object.containerPurgeableBytes = options.longs === String ? String(message.containerPurgeableBytes) : message.containerPurgeableBytes;
                            else
                                object.containerPurgeableBytes = options.longs === String ? $util.Long.prototype.toString.call(message.containerPurgeableBytes) : options.longs === Number ? new $util.LongBits(message.containerPurgeableBytes.low >>> 0, message.containerPurgeableBytes.high >>> 0).toNumber() : message.containerPurgeableBytes;
                        if (message.workspace != null && message.hasOwnProperty("workspace"))
                            object.workspace = $root.palexy.streaming.v1.WorkspaceUsage.toObject(message.workspace, options);
                        return object;
                    };
    
                    /**
                     * Converts this StorageStatus to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StorageStatus
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StorageStatus.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StorageStatus;
                })();
    
                v1.VolumeUsage = (function() {
    
                    /**
                     * Properties of a VolumeUsage.
                     * @memberof palexy.streaming.v1
                     * @interface IVolumeUsage
                     * @property {string|null} [mountPoint] VolumeUsage mountPoint
                     * @property {number|null} [totalBytes] VolumeUsage totalBytes
                     * @property {number|null} [usedBytes] VolumeUsage usedBytes
                     * @property {number|null} [freeBytes] VolumeUsage freeBytes
                     * @property {number|null} [purgeableBytes] VolumeUsage purgeableBytes
                     */
    
                    /**
                     * Constructs a new VolumeUsage.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VolumeUsage.
                     * @implements IVolumeUsage
                     * @constructor
                     * @param {palexy.streaming.v1.IVolumeUsage=} [properties] Properties to set
                     */
                    function VolumeUsage(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VolumeUsage mountPoint.
                     * @member {string} mountPoint
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     */
                    VolumeUsage.prototype.mountPoint = "";
    
                    /**
                     * VolumeUsage totalBytes.
                     * @member {number} totalBytes
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     */
                    VolumeUsage.prototype.totalBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * VolumeUsage usedBytes.
                     * @member {number} usedBytes
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     */
                    VolumeUsage.prototype.usedBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * VolumeUsage freeBytes.
                     * @member {number} freeBytes
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     */
                    VolumeUsage.prototype.freeBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * VolumeUsage purgeableBytes.
                     * @member {number} purgeableBytes
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     */
                    VolumeUsage.prototype.purgeableBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new VolumeUsage instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {palexy.streaming.v1.IVolumeUsage=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.VolumeUsage} VolumeUsage instance
                     */
                    VolumeUsage.create = function create(properties) {
                        return new VolumeUsage(properties);
                    };
    
                    /**
                     * Encodes the specified VolumeUsage message. Does not implicitly {@link palexy.streaming.v1.VolumeUsage.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {palexy.streaming.v1.IVolumeUsage} message VolumeUsage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VolumeUsage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mountPoint != null && Object.hasOwnProperty.call(message, "mountPoint"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.mountPoint);
                        if (message.totalBytes != null && Object.hasOwnProperty.call(message, "totalBytes"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalBytes);
                        if (message.usedBytes != null && Object.hasOwnProperty.call(message, "usedBytes"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.usedBytes);
                        if (message.freeBytes != null && Object.hasOwnProperty.call(message, "freeBytes"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.freeBytes);
                        if (message.purgeableBytes != null && Object.hasOwnProperty.call(message, "purgeableBytes"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.purgeableBytes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VolumeUsage message, length delimited. Does not implicitly {@link palexy.streaming.v1.VolumeUsage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {palexy.streaming.v1.IVolumeUsage} message VolumeUsage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VolumeUsage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VolumeUsage message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.VolumeUsage} VolumeUsage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VolumeUsage.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.VolumeUsage();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mountPoint = reader.string();
                                break;
                            case 2:
                                message.totalBytes = reader.int64();
                                break;
                            case 3:
                                message.usedBytes = reader.int64();
                                break;
                            case 4:
                                message.freeBytes = reader.int64();
                                break;
                            case 5:
                                message.purgeableBytes = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VolumeUsage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.VolumeUsage} VolumeUsage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VolumeUsage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VolumeUsage message.
                     * @function verify
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VolumeUsage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mountPoint != null && message.hasOwnProperty("mountPoint"))
                            if (!$util.isString(message.mountPoint))
                                return "mountPoint: string expected";
                        if (message.totalBytes != null && message.hasOwnProperty("totalBytes"))
                            if (!$util.isInteger(message.totalBytes) && !(message.totalBytes && $util.isInteger(message.totalBytes.low) && $util.isInteger(message.totalBytes.high)))
                                return "totalBytes: integer|Long expected";
                        if (message.usedBytes != null && message.hasOwnProperty("usedBytes"))
                            if (!$util.isInteger(message.usedBytes) && !(message.usedBytes && $util.isInteger(message.usedBytes.low) && $util.isInteger(message.usedBytes.high)))
                                return "usedBytes: integer|Long expected";
                        if (message.freeBytes != null && message.hasOwnProperty("freeBytes"))
                            if (!$util.isInteger(message.freeBytes) && !(message.freeBytes && $util.isInteger(message.freeBytes.low) && $util.isInteger(message.freeBytes.high)))
                                return "freeBytes: integer|Long expected";
                        if (message.purgeableBytes != null && message.hasOwnProperty("purgeableBytes"))
                            if (!$util.isInteger(message.purgeableBytes) && !(message.purgeableBytes && $util.isInteger(message.purgeableBytes.low) && $util.isInteger(message.purgeableBytes.high)))
                                return "purgeableBytes: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a VolumeUsage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.VolumeUsage} VolumeUsage
                     */
                    VolumeUsage.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.VolumeUsage)
                            return object;
                        var message = new $root.palexy.streaming.v1.VolumeUsage();
                        if (object.mountPoint != null)
                            message.mountPoint = String(object.mountPoint);
                        if (object.totalBytes != null)
                            if ($util.Long)
                                (message.totalBytes = $util.Long.fromValue(object.totalBytes)).unsigned = false;
                            else if (typeof object.totalBytes === "string")
                                message.totalBytes = parseInt(object.totalBytes, 10);
                            else if (typeof object.totalBytes === "number")
                                message.totalBytes = object.totalBytes;
                            else if (typeof object.totalBytes === "object")
                                message.totalBytes = new $util.LongBits(object.totalBytes.low >>> 0, object.totalBytes.high >>> 0).toNumber();
                        if (object.usedBytes != null)
                            if ($util.Long)
                                (message.usedBytes = $util.Long.fromValue(object.usedBytes)).unsigned = false;
                            else if (typeof object.usedBytes === "string")
                                message.usedBytes = parseInt(object.usedBytes, 10);
                            else if (typeof object.usedBytes === "number")
                                message.usedBytes = object.usedBytes;
                            else if (typeof object.usedBytes === "object")
                                message.usedBytes = new $util.LongBits(object.usedBytes.low >>> 0, object.usedBytes.high >>> 0).toNumber();
                        if (object.freeBytes != null)
                            if ($util.Long)
                                (message.freeBytes = $util.Long.fromValue(object.freeBytes)).unsigned = false;
                            else if (typeof object.freeBytes === "string")
                                message.freeBytes = parseInt(object.freeBytes, 10);
                            else if (typeof object.freeBytes === "number")
                                message.freeBytes = object.freeBytes;
                            else if (typeof object.freeBytes === "object")
                                message.freeBytes = new $util.LongBits(object.freeBytes.low >>> 0, object.freeBytes.high >>> 0).toNumber();
                        if (object.purgeableBytes != null)
                            if ($util.Long)
                                (message.purgeableBytes = $util.Long.fromValue(object.purgeableBytes)).unsigned = false;
                            else if (typeof object.purgeableBytes === "string")
                                message.purgeableBytes = parseInt(object.purgeableBytes, 10);
                            else if (typeof object.purgeableBytes === "number")
                                message.purgeableBytes = object.purgeableBytes;
                            else if (typeof object.purgeableBytes === "object")
                                message.purgeableBytes = new $util.LongBits(object.purgeableBytes.low >>> 0, object.purgeableBytes.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VolumeUsage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @static
                     * @param {palexy.streaming.v1.VolumeUsage} message VolumeUsage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VolumeUsage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mountPoint = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.usedBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.usedBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.freeBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.freeBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.purgeableBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.purgeableBytes = options.longs === String ? "0" : 0;
                        }
                        if (message.mountPoint != null && message.hasOwnProperty("mountPoint"))
                            object.mountPoint = message.mountPoint;
                        if (message.totalBytes != null && message.hasOwnProperty("totalBytes"))
                            if (typeof message.totalBytes === "number")
                                object.totalBytes = options.longs === String ? String(message.totalBytes) : message.totalBytes;
                            else
                                object.totalBytes = options.longs === String ? $util.Long.prototype.toString.call(message.totalBytes) : options.longs === Number ? new $util.LongBits(message.totalBytes.low >>> 0, message.totalBytes.high >>> 0).toNumber() : message.totalBytes;
                        if (message.usedBytes != null && message.hasOwnProperty("usedBytes"))
                            if (typeof message.usedBytes === "number")
                                object.usedBytes = options.longs === String ? String(message.usedBytes) : message.usedBytes;
                            else
                                object.usedBytes = options.longs === String ? $util.Long.prototype.toString.call(message.usedBytes) : options.longs === Number ? new $util.LongBits(message.usedBytes.low >>> 0, message.usedBytes.high >>> 0).toNumber() : message.usedBytes;
                        if (message.freeBytes != null && message.hasOwnProperty("freeBytes"))
                            if (typeof message.freeBytes === "number")
                                object.freeBytes = options.longs === String ? String(message.freeBytes) : message.freeBytes;
                            else
                                object.freeBytes = options.longs === String ? $util.Long.prototype.toString.call(message.freeBytes) : options.longs === Number ? new $util.LongBits(message.freeBytes.low >>> 0, message.freeBytes.high >>> 0).toNumber() : message.freeBytes;
                        if (message.purgeableBytes != null && message.hasOwnProperty("purgeableBytes"))
                            if (typeof message.purgeableBytes === "number")
                                object.purgeableBytes = options.longs === String ? String(message.purgeableBytes) : message.purgeableBytes;
                            else
                                object.purgeableBytes = options.longs === String ? $util.Long.prototype.toString.call(message.purgeableBytes) : options.longs === Number ? new $util.LongBits(message.purgeableBytes.low >>> 0, message.purgeableBytes.high >>> 0).toNumber() : message.purgeableBytes;
                        return object;
                    };
    
                    /**
                     * Converts this VolumeUsage to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.VolumeUsage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VolumeUsage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return VolumeUsage;
                })();
    
                v1.WorkspaceUsage = (function() {
    
                    /**
                     * Properties of a WorkspaceUsage.
                     * @memberof palexy.streaming.v1
                     * @interface IWorkspaceUsage
                     * @property {number|null} [videosCount] WorkspaceUsage videosCount
                     * @property {number|null} [videosBytes] WorkspaceUsage videosBytes
                     * @property {number|null} [trackingFilesCount] WorkspaceUsage trackingFilesCount
                     * @property {number|null} [trackingFilesBytes] WorkspaceUsage trackingFilesBytes
                     * @property {number|null} [totalBytes] WorkspaceUsage totalBytes
                     */
    
                    /**
                     * Constructs a new WorkspaceUsage.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WorkspaceUsage.
                     * @implements IWorkspaceUsage
                     * @constructor
                     * @param {palexy.streaming.v1.IWorkspaceUsage=} [properties] Properties to set
                     */
                    function WorkspaceUsage(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WorkspaceUsage videosCount.
                     * @member {number} videosCount
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     */
                    WorkspaceUsage.prototype.videosCount = 0;
    
                    /**
                     * WorkspaceUsage videosBytes.
                     * @member {number} videosBytes
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     */
                    WorkspaceUsage.prototype.videosBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * WorkspaceUsage trackingFilesCount.
                     * @member {number} trackingFilesCount
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     */
                    WorkspaceUsage.prototype.trackingFilesCount = 0;
    
                    /**
                     * WorkspaceUsage trackingFilesBytes.
                     * @member {number} trackingFilesBytes
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     */
                    WorkspaceUsage.prototype.trackingFilesBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * WorkspaceUsage totalBytes.
                     * @member {number} totalBytes
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     */
                    WorkspaceUsage.prototype.totalBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new WorkspaceUsage instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {palexy.streaming.v1.IWorkspaceUsage=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.WorkspaceUsage} WorkspaceUsage instance
                     */
                    WorkspaceUsage.create = function create(properties) {
                        return new WorkspaceUsage(properties);
                    };
    
                    /**
                     * Encodes the specified WorkspaceUsage message. Does not implicitly {@link palexy.streaming.v1.WorkspaceUsage.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {palexy.streaming.v1.IWorkspaceUsage} message WorkspaceUsage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WorkspaceUsage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.videosCount != null && Object.hasOwnProperty.call(message, "videosCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.videosCount);
                        if (message.videosBytes != null && Object.hasOwnProperty.call(message, "videosBytes"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.videosBytes);
                        if (message.trackingFilesCount != null && Object.hasOwnProperty.call(message, "trackingFilesCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.trackingFilesCount);
                        if (message.trackingFilesBytes != null && Object.hasOwnProperty.call(message, "trackingFilesBytes"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.trackingFilesBytes);
                        if (message.totalBytes != null && Object.hasOwnProperty.call(message, "totalBytes"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalBytes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WorkspaceUsage message, length delimited. Does not implicitly {@link palexy.streaming.v1.WorkspaceUsage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {palexy.streaming.v1.IWorkspaceUsage} message WorkspaceUsage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WorkspaceUsage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WorkspaceUsage message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.WorkspaceUsage} WorkspaceUsage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WorkspaceUsage.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.WorkspaceUsage();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.videosCount = reader.int32();
                                break;
                            case 2:
                                message.videosBytes = reader.int64();
                                break;
                            case 3:
                                message.trackingFilesCount = reader.int32();
                                break;
                            case 4:
                                message.trackingFilesBytes = reader.int64();
                                break;
                            case 5:
                                message.totalBytes = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WorkspaceUsage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.WorkspaceUsage} WorkspaceUsage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WorkspaceUsage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WorkspaceUsage message.
                     * @function verify
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WorkspaceUsage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.videosCount != null && message.hasOwnProperty("videosCount"))
                            if (!$util.isInteger(message.videosCount))
                                return "videosCount: integer expected";
                        if (message.videosBytes != null && message.hasOwnProperty("videosBytes"))
                            if (!$util.isInteger(message.videosBytes) && !(message.videosBytes && $util.isInteger(message.videosBytes.low) && $util.isInteger(message.videosBytes.high)))
                                return "videosBytes: integer|Long expected";
                        if (message.trackingFilesCount != null && message.hasOwnProperty("trackingFilesCount"))
                            if (!$util.isInteger(message.trackingFilesCount))
                                return "trackingFilesCount: integer expected";
                        if (message.trackingFilesBytes != null && message.hasOwnProperty("trackingFilesBytes"))
                            if (!$util.isInteger(message.trackingFilesBytes) && !(message.trackingFilesBytes && $util.isInteger(message.trackingFilesBytes.low) && $util.isInteger(message.trackingFilesBytes.high)))
                                return "trackingFilesBytes: integer|Long expected";
                        if (message.totalBytes != null && message.hasOwnProperty("totalBytes"))
                            if (!$util.isInteger(message.totalBytes) && !(message.totalBytes && $util.isInteger(message.totalBytes.low) && $util.isInteger(message.totalBytes.high)))
                                return "totalBytes: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a WorkspaceUsage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.WorkspaceUsage} WorkspaceUsage
                     */
                    WorkspaceUsage.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.WorkspaceUsage)
                            return object;
                        var message = new $root.palexy.streaming.v1.WorkspaceUsage();
                        if (object.videosCount != null)
                            message.videosCount = object.videosCount | 0;
                        if (object.videosBytes != null)
                            if ($util.Long)
                                (message.videosBytes = $util.Long.fromValue(object.videosBytes)).unsigned = false;
                            else if (typeof object.videosBytes === "string")
                                message.videosBytes = parseInt(object.videosBytes, 10);
                            else if (typeof object.videosBytes === "number")
                                message.videosBytes = object.videosBytes;
                            else if (typeof object.videosBytes === "object")
                                message.videosBytes = new $util.LongBits(object.videosBytes.low >>> 0, object.videosBytes.high >>> 0).toNumber();
                        if (object.trackingFilesCount != null)
                            message.trackingFilesCount = object.trackingFilesCount | 0;
                        if (object.trackingFilesBytes != null)
                            if ($util.Long)
                                (message.trackingFilesBytes = $util.Long.fromValue(object.trackingFilesBytes)).unsigned = false;
                            else if (typeof object.trackingFilesBytes === "string")
                                message.trackingFilesBytes = parseInt(object.trackingFilesBytes, 10);
                            else if (typeof object.trackingFilesBytes === "number")
                                message.trackingFilesBytes = object.trackingFilesBytes;
                            else if (typeof object.trackingFilesBytes === "object")
                                message.trackingFilesBytes = new $util.LongBits(object.trackingFilesBytes.low >>> 0, object.trackingFilesBytes.high >>> 0).toNumber();
                        if (object.totalBytes != null)
                            if ($util.Long)
                                (message.totalBytes = $util.Long.fromValue(object.totalBytes)).unsigned = false;
                            else if (typeof object.totalBytes === "string")
                                message.totalBytes = parseInt(object.totalBytes, 10);
                            else if (typeof object.totalBytes === "number")
                                message.totalBytes = object.totalBytes;
                            else if (typeof object.totalBytes === "object")
                                message.totalBytes = new $util.LongBits(object.totalBytes.low >>> 0, object.totalBytes.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WorkspaceUsage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @static
                     * @param {palexy.streaming.v1.WorkspaceUsage} message WorkspaceUsage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WorkspaceUsage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.videosCount = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.videosBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.videosBytes = options.longs === String ? "0" : 0;
                            object.trackingFilesCount = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.trackingFilesBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.trackingFilesBytes = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalBytes = options.longs === String ? "0" : 0;
                        }
                        if (message.videosCount != null && message.hasOwnProperty("videosCount"))
                            object.videosCount = message.videosCount;
                        if (message.videosBytes != null && message.hasOwnProperty("videosBytes"))
                            if (typeof message.videosBytes === "number")
                                object.videosBytes = options.longs === String ? String(message.videosBytes) : message.videosBytes;
                            else
                                object.videosBytes = options.longs === String ? $util.Long.prototype.toString.call(message.videosBytes) : options.longs === Number ? new $util.LongBits(message.videosBytes.low >>> 0, message.videosBytes.high >>> 0).toNumber() : message.videosBytes;
                        if (message.trackingFilesCount != null && message.hasOwnProperty("trackingFilesCount"))
                            object.trackingFilesCount = message.trackingFilesCount;
                        if (message.trackingFilesBytes != null && message.hasOwnProperty("trackingFilesBytes"))
                            if (typeof message.trackingFilesBytes === "number")
                                object.trackingFilesBytes = options.longs === String ? String(message.trackingFilesBytes) : message.trackingFilesBytes;
                            else
                                object.trackingFilesBytes = options.longs === String ? $util.Long.prototype.toString.call(message.trackingFilesBytes) : options.longs === Number ? new $util.LongBits(message.trackingFilesBytes.low >>> 0, message.trackingFilesBytes.high >>> 0).toNumber() : message.trackingFilesBytes;
                        if (message.totalBytes != null && message.hasOwnProperty("totalBytes"))
                            if (typeof message.totalBytes === "number")
                                object.totalBytes = options.longs === String ? String(message.totalBytes) : message.totalBytes;
                            else
                                object.totalBytes = options.longs === String ? $util.Long.prototype.toString.call(message.totalBytes) : options.longs === Number ? new $util.LongBits(message.totalBytes.low >>> 0, message.totalBytes.high >>> 0).toNumber() : message.totalBytes;
                        return object;
                    };
    
                    /**
                     * Converts this WorkspaceUsage to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.WorkspaceUsage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WorkspaceUsage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return WorkspaceUsage;
                })();
    
                v1.ComponentStatus = (function() {
    
                    /**
                     * Properties of a ComponentStatus.
                     * @memberof palexy.streaming.v1
                     * @interface IComponentStatus
                     * @property {string|null} [name] ComponentStatus name
                     * @property {palexy.streaming.v1.ComponentStatus.Health|null} [health] ComponentStatus health
                     * @property {google.protobuf.ITimestamp|null} [lastAliveSignalTime] ComponentStatus lastAliveSignalTime
                     */
    
                    /**
                     * Constructs a new ComponentStatus.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ComponentStatus.
                     * @implements IComponentStatus
                     * @constructor
                     * @param {palexy.streaming.v1.IComponentStatus=} [properties] Properties to set
                     */
                    function ComponentStatus(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ComponentStatus name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @instance
                     */
                    ComponentStatus.prototype.name = "";
    
                    /**
                     * ComponentStatus health.
                     * @member {palexy.streaming.v1.ComponentStatus.Health} health
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @instance
                     */
                    ComponentStatus.prototype.health = 0;
    
                    /**
                     * ComponentStatus lastAliveSignalTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastAliveSignalTime
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @instance
                     */
                    ComponentStatus.prototype.lastAliveSignalTime = null;
    
                    /**
                     * Creates a new ComponentStatus instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {palexy.streaming.v1.IComponentStatus=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ComponentStatus} ComponentStatus instance
                     */
                    ComponentStatus.create = function create(properties) {
                        return new ComponentStatus(properties);
                    };
    
                    /**
                     * Encodes the specified ComponentStatus message. Does not implicitly {@link palexy.streaming.v1.ComponentStatus.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {palexy.streaming.v1.IComponentStatus} message ComponentStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ComponentStatus.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.health != null && Object.hasOwnProperty.call(message, "health"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.health);
                        if (message.lastAliveSignalTime != null && Object.hasOwnProperty.call(message, "lastAliveSignalTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastAliveSignalTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ComponentStatus message, length delimited. Does not implicitly {@link palexy.streaming.v1.ComponentStatus.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {palexy.streaming.v1.IComponentStatus} message ComponentStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ComponentStatus.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ComponentStatus message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ComponentStatus} ComponentStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ComponentStatus.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ComponentStatus();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.health = reader.int32();
                                break;
                            case 3:
                                message.lastAliveSignalTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ComponentStatus message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ComponentStatus} ComponentStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ComponentStatus.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ComponentStatus message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ComponentStatus.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.health != null && message.hasOwnProperty("health"))
                            switch (message.health) {
                            default:
                                return "health: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.lastAliveSignalTime != null && message.hasOwnProperty("lastAliveSignalTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastAliveSignalTime);
                            if (error)
                                return "lastAliveSignalTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ComponentStatus message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ComponentStatus} ComponentStatus
                     */
                    ComponentStatus.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ComponentStatus)
                            return object;
                        var message = new $root.palexy.streaming.v1.ComponentStatus();
                        if (object.name != null)
                            message.name = String(object.name);
                        switch (object.health) {
                        case "HEALTH_UNKNOWN":
                        case 0:
                            message.health = 0;
                            break;
                        case "HEALTHY":
                        case 1:
                            message.health = 1;
                            break;
                        case "SLOW":
                        case 2:
                            message.health = 2;
                            break;
                        case "STALE":
                        case 3:
                            message.health = 3;
                            break;
                        case "CRASHED":
                        case 4:
                            message.health = 4;
                            break;
                        }
                        if (object.lastAliveSignalTime != null) {
                            if (typeof object.lastAliveSignalTime !== "object")
                                throw TypeError(".palexy.streaming.v1.ComponentStatus.lastAliveSignalTime: object expected");
                            message.lastAliveSignalTime = $root.google.protobuf.Timestamp.fromObject(object.lastAliveSignalTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ComponentStatus message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @static
                     * @param {palexy.streaming.v1.ComponentStatus} message ComponentStatus
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ComponentStatus.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.health = options.enums === String ? "HEALTH_UNKNOWN" : 0;
                            object.lastAliveSignalTime = null;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.health != null && message.hasOwnProperty("health"))
                            object.health = options.enums === String ? $root.palexy.streaming.v1.ComponentStatus.Health[message.health] : message.health;
                        if (message.lastAliveSignalTime != null && message.hasOwnProperty("lastAliveSignalTime"))
                            object.lastAliveSignalTime = $root.google.protobuf.Timestamp.toObject(message.lastAliveSignalTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this ComponentStatus to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ComponentStatus
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ComponentStatus.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Health enum.
                     * @name palexy.streaming.v1.ComponentStatus.Health
                     * @enum {number}
                     * @property {number} HEALTH_UNKNOWN=0 HEALTH_UNKNOWN value
                     * @property {number} HEALTHY=1 HEALTHY value
                     * @property {number} SLOW=2 SLOW value
                     * @property {number} STALE=3 STALE value
                     * @property {number} CRASHED=4 CRASHED value
                     */
                    ComponentStatus.Health = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "HEALTH_UNKNOWN"] = 0;
                        values[valuesById[1] = "HEALTHY"] = 1;
                        values[valuesById[2] = "SLOW"] = 2;
                        values[valuesById[3] = "STALE"] = 3;
                        values[valuesById[4] = "CRASHED"] = 4;
                        return values;
                    })();
    
                    return ComponentStatus;
                })();
    
                v1.ReportEdgeBoxStatusRequest = (function() {
    
                    /**
                     * Properties of a ReportEdgeBoxStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IReportEdgeBoxStatusRequest
                     * @property {string|null} [worker] ReportEdgeBoxStatusRequest worker
                     * @property {palexy.streaming.v1.IEdgeBoxStatus|null} [status] ReportEdgeBoxStatusRequest status
                     */
    
                    /**
                     * Constructs a new ReportEdgeBoxStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportEdgeBoxStatusRequest.
                     * @implements IReportEdgeBoxStatusRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest=} [properties] Properties to set
                     */
                    function ReportEdgeBoxStatusRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportEdgeBoxStatusRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @instance
                     */
                    ReportEdgeBoxStatusRequest.prototype.worker = "";
    
                    /**
                     * ReportEdgeBoxStatusRequest status.
                     * @member {palexy.streaming.v1.IEdgeBoxStatus|null|undefined} status
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @instance
                     */
                    ReportEdgeBoxStatusRequest.prototype.status = null;
    
                    /**
                     * Creates a new ReportEdgeBoxStatusRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusRequest} ReportEdgeBoxStatusRequest instance
                     */
                    ReportEdgeBoxStatusRequest.create = function create(properties) {
                        return new ReportEdgeBoxStatusRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ReportEdgeBoxStatusRequest message. Does not implicitly {@link palexy.streaming.v1.ReportEdgeBoxStatusRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest} message ReportEdgeBoxStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportEdgeBoxStatusRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            $root.palexy.streaming.v1.EdgeBoxStatus.encode(message.status, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportEdgeBoxStatusRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportEdgeBoxStatusRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusRequest} message ReportEdgeBoxStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportEdgeBoxStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportEdgeBoxStatusRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusRequest} ReportEdgeBoxStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportEdgeBoxStatusRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportEdgeBoxStatusRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            case 2:
                                message.status = $root.palexy.streaming.v1.EdgeBoxStatus.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportEdgeBoxStatusRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusRequest} ReportEdgeBoxStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportEdgeBoxStatusRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportEdgeBoxStatusRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportEdgeBoxStatusRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        if (message.status != null && message.hasOwnProperty("status")) {
                            var error = $root.palexy.streaming.v1.EdgeBoxStatus.verify(message.status);
                            if (error)
                                return "status." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ReportEdgeBoxStatusRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusRequest} ReportEdgeBoxStatusRequest
                     */
                    ReportEdgeBoxStatusRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportEdgeBoxStatusRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportEdgeBoxStatusRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        if (object.status != null) {
                            if (typeof object.status !== "object")
                                throw TypeError(".palexy.streaming.v1.ReportEdgeBoxStatusRequest.status: object expected");
                            message.status = $root.palexy.streaming.v1.EdgeBoxStatus.fromObject(object.status);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportEdgeBoxStatusRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.ReportEdgeBoxStatusRequest} message ReportEdgeBoxStatusRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportEdgeBoxStatusRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.worker = "";
                            object.status = null;
                        }
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = $root.palexy.streaming.v1.EdgeBoxStatus.toObject(message.status, options);
                        return object;
                    };
    
                    /**
                     * Converts this ReportEdgeBoxStatusRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportEdgeBoxStatusRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportEdgeBoxStatusRequest;
                })();
    
                v1.ReportEdgeBoxStatusResponse = (function() {
    
                    /**
                     * Properties of a ReportEdgeBoxStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IReportEdgeBoxStatusResponse
                     */
    
                    /**
                     * Constructs a new ReportEdgeBoxStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportEdgeBoxStatusResponse.
                     * @implements IReportEdgeBoxStatusResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusResponse=} [properties] Properties to set
                     */
                    function ReportEdgeBoxStatusResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ReportEdgeBoxStatusResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusResponse} ReportEdgeBoxStatusResponse instance
                     */
                    ReportEdgeBoxStatusResponse.create = function create(properties) {
                        return new ReportEdgeBoxStatusResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ReportEdgeBoxStatusResponse message. Does not implicitly {@link palexy.streaming.v1.ReportEdgeBoxStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusResponse} message ReportEdgeBoxStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportEdgeBoxStatusResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportEdgeBoxStatusResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportEdgeBoxStatusResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IReportEdgeBoxStatusResponse} message ReportEdgeBoxStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportEdgeBoxStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportEdgeBoxStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusResponse} ReportEdgeBoxStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportEdgeBoxStatusResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportEdgeBoxStatusResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportEdgeBoxStatusResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusResponse} ReportEdgeBoxStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportEdgeBoxStatusResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportEdgeBoxStatusResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportEdgeBoxStatusResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReportEdgeBoxStatusResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportEdgeBoxStatusResponse} ReportEdgeBoxStatusResponse
                     */
                    ReportEdgeBoxStatusResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportEdgeBoxStatusResponse)
                            return object;
                        return new $root.palexy.streaming.v1.ReportEdgeBoxStatusResponse();
                    };
    
                    /**
                     * Creates a plain object from a ReportEdgeBoxStatusResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.ReportEdgeBoxStatusResponse} message ReportEdgeBoxStatusResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportEdgeBoxStatusResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ReportEdgeBoxStatusResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportEdgeBoxStatusResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportEdgeBoxStatusResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportEdgeBoxStatusResponse;
                })();
    
                v1.GetWorkerRequest = (function() {
    
                    /**
                     * Properties of a GetWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetWorkerRequest
                     * @property {number|null} [workerId] GetWorkerRequest workerId
                     * @property {string|null} [workerName] GetWorkerRequest workerName
                     */
    
                    /**
                     * Constructs a new GetWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetWorkerRequest.
                     * @implements IGetWorkerRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetWorkerRequest=} [properties] Properties to set
                     */
                    function GetWorkerRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetWorkerRequest workerId.
                     * @member {number} workerId
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @instance
                     */
                    GetWorkerRequest.prototype.workerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetWorkerRequest workerName.
                     * @member {string} workerName
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @instance
                     */
                    GetWorkerRequest.prototype.workerName = "";
    
                    /**
                     * Creates a new GetWorkerRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetWorkerRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetWorkerRequest} GetWorkerRequest instance
                     */
                    GetWorkerRequest.create = function create(properties) {
                        return new GetWorkerRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetWorkerRequest message. Does not implicitly {@link palexy.streaming.v1.GetWorkerRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetWorkerRequest} message GetWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetWorkerRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.workerId != null && Object.hasOwnProperty.call(message, "workerId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.workerId);
                        if (message.workerName != null && Object.hasOwnProperty.call(message, "workerName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.workerName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetWorkerRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetWorkerRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetWorkerRequest} message GetWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetWorkerRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetWorkerRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetWorkerRequest} GetWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetWorkerRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetWorkerRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.workerId = reader.int64();
                                break;
                            case 2:
                                message.workerName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetWorkerRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetWorkerRequest} GetWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetWorkerRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetWorkerRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetWorkerRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.workerId != null && message.hasOwnProperty("workerId"))
                            if (!$util.isInteger(message.workerId) && !(message.workerId && $util.isInteger(message.workerId.low) && $util.isInteger(message.workerId.high)))
                                return "workerId: integer|Long expected";
                        if (message.workerName != null && message.hasOwnProperty("workerName"))
                            if (!$util.isString(message.workerName))
                                return "workerName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetWorkerRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetWorkerRequest} GetWorkerRequest
                     */
                    GetWorkerRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetWorkerRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetWorkerRequest();
                        if (object.workerId != null)
                            if ($util.Long)
                                (message.workerId = $util.Long.fromValue(object.workerId)).unsigned = false;
                            else if (typeof object.workerId === "string")
                                message.workerId = parseInt(object.workerId, 10);
                            else if (typeof object.workerId === "number")
                                message.workerId = object.workerId;
                            else if (typeof object.workerId === "object")
                                message.workerId = new $util.LongBits(object.workerId.low >>> 0, object.workerId.high >>> 0).toNumber();
                        if (object.workerName != null)
                            message.workerName = String(object.workerName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetWorkerRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.GetWorkerRequest} message GetWorkerRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetWorkerRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.workerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.workerId = options.longs === String ? "0" : 0;
                            object.workerName = "";
                        }
                        if (message.workerId != null && message.hasOwnProperty("workerId"))
                            if (typeof message.workerId === "number")
                                object.workerId = options.longs === String ? String(message.workerId) : message.workerId;
                            else
                                object.workerId = options.longs === String ? $util.Long.prototype.toString.call(message.workerId) : options.longs === Number ? new $util.LongBits(message.workerId.low >>> 0, message.workerId.high >>> 0).toNumber() : message.workerId;
                        if (message.workerName != null && message.hasOwnProperty("workerName"))
                            object.workerName = message.workerName;
                        return object;
                    };
    
                    /**
                     * Converts this GetWorkerRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetWorkerRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetWorkerRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetWorkerRequest;
                })();
    
                v1.ListWorkerCamerasRequest = (function() {
    
                    /**
                     * Properties of a ListWorkerCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListWorkerCamerasRequest
                     * @property {string|null} [worker] ListWorkerCamerasRequest worker
                     * @property {number|null} [pageSize] ListWorkerCamerasRequest pageSize
                     * @property {string|null} [pageToken] ListWorkerCamerasRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListWorkerCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListWorkerCamerasRequest.
                     * @implements IListWorkerCamerasRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest=} [properties] Properties to set
                     */
                    function ListWorkerCamerasRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListWorkerCamerasRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @instance
                     */
                    ListWorkerCamerasRequest.prototype.worker = "";
    
                    /**
                     * ListWorkerCamerasRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @instance
                     */
                    ListWorkerCamerasRequest.prototype.pageSize = 0;
    
                    /**
                     * ListWorkerCamerasRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @instance
                     */
                    ListWorkerCamerasRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListWorkerCamerasRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListWorkerCamerasRequest} ListWorkerCamerasRequest instance
                     */
                    ListWorkerCamerasRequest.create = function create(properties) {
                        return new ListWorkerCamerasRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListWorkerCamerasRequest message. Does not implicitly {@link palexy.streaming.v1.ListWorkerCamerasRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest} message ListWorkerCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkerCamerasRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListWorkerCamerasRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListWorkerCamerasRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasRequest} message ListWorkerCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkerCamerasRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListWorkerCamerasRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListWorkerCamerasRequest} ListWorkerCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkerCamerasRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListWorkerCamerasRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListWorkerCamerasRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListWorkerCamerasRequest} ListWorkerCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkerCamerasRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListWorkerCamerasRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListWorkerCamerasRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListWorkerCamerasRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListWorkerCamerasRequest} ListWorkerCamerasRequest
                     */
                    ListWorkerCamerasRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListWorkerCamerasRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListWorkerCamerasRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListWorkerCamerasRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.ListWorkerCamerasRequest} message ListWorkerCamerasRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListWorkerCamerasRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.worker = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListWorkerCamerasRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListWorkerCamerasRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListWorkerCamerasRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListWorkerCamerasRequest;
                })();
    
                v1.ListWorkerCamerasResponse = (function() {
    
                    /**
                     * Properties of a ListWorkerCamerasResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListWorkerCamerasResponse
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [cameras] ListWorkerCamerasResponse cameras
                     * @property {string|null} [nextPageToken] ListWorkerCamerasResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListWorkerCamerasResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListWorkerCamerasResponse.
                     * @implements IListWorkerCamerasResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListWorkerCamerasResponse=} [properties] Properties to set
                     */
                    function ListWorkerCamerasResponse(properties) {
                        this.cameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListWorkerCamerasResponse cameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} cameras
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @instance
                     */
                    ListWorkerCamerasResponse.prototype.cameras = $util.emptyArray;
    
                    /**
                     * ListWorkerCamerasResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @instance
                     */
                    ListWorkerCamerasResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListWorkerCamerasResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListWorkerCamerasResponse} ListWorkerCamerasResponse instance
                     */
                    ListWorkerCamerasResponse.create = function create(properties) {
                        return new ListWorkerCamerasResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListWorkerCamerasResponse message. Does not implicitly {@link palexy.streaming.v1.ListWorkerCamerasResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasResponse} message ListWorkerCamerasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkerCamerasResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameras != null && message.cameras.length)
                            for (var i = 0; i < message.cameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.cameras[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListWorkerCamerasResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListWorkerCamerasResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkerCamerasResponse} message ListWorkerCamerasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkerCamerasResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListWorkerCamerasResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListWorkerCamerasResponse} ListWorkerCamerasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkerCamerasResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListWorkerCamerasResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameras && message.cameras.length))
                                    message.cameras = [];
                                message.cameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListWorkerCamerasResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListWorkerCamerasResponse} ListWorkerCamerasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkerCamerasResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListWorkerCamerasResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListWorkerCamerasResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameras != null && message.hasOwnProperty("cameras")) {
                            if (!Array.isArray(message.cameras))
                                return "cameras: array expected";
                            for (var i = 0; i < message.cameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.cameras[i]);
                                if (error)
                                    return "cameras." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListWorkerCamerasResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListWorkerCamerasResponse} ListWorkerCamerasResponse
                     */
                    ListWorkerCamerasResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListWorkerCamerasResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListWorkerCamerasResponse();
                        if (object.cameras) {
                            if (!Array.isArray(object.cameras))
                                throw TypeError(".palexy.streaming.v1.ListWorkerCamerasResponse.cameras: array expected");
                            message.cameras = [];
                            for (var i = 0; i < object.cameras.length; ++i) {
                                if (typeof object.cameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListWorkerCamerasResponse.cameras: object expected");
                                message.cameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.cameras[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListWorkerCamerasResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.ListWorkerCamerasResponse} message ListWorkerCamerasResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListWorkerCamerasResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameras = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.cameras && message.cameras.length) {
                            object.cameras = [];
                            for (var j = 0; j < message.cameras.length; ++j)
                                object.cameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.cameras[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListWorkerCamerasResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListWorkerCamerasResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListWorkerCamerasResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListWorkerCamerasResponse;
                })();
    
                v1.ListWorkersRequest = (function() {
    
                    /**
                     * Properties of a ListWorkersRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListWorkersRequest
                     * @property {number|null} [pageSize] ListWorkersRequest pageSize
                     * @property {string|null} [pageToken] ListWorkersRequest pageToken
                     * @property {string|null} [location] ListWorkersRequest location
                     * @property {string|null} [searchKey] ListWorkersRequest searchKey
                     * @property {string|null} [sortBy] ListWorkersRequest sortBy
                     * @property {string|null} [sortDirection] ListWorkersRequest sortDirection
                     */
    
                    /**
                     * Constructs a new ListWorkersRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListWorkersRequest.
                     * @implements IListWorkersRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListWorkersRequest=} [properties] Properties to set
                     */
                    function ListWorkersRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListWorkersRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.pageSize = 0;
    
                    /**
                     * ListWorkersRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.pageToken = "";
    
                    /**
                     * ListWorkersRequest location.
                     * @member {string} location
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.location = "";
    
                    /**
                     * ListWorkersRequest searchKey.
                     * @member {string} searchKey
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.searchKey = "";
    
                    /**
                     * ListWorkersRequest sortBy.
                     * @member {string} sortBy
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.sortBy = "";
    
                    /**
                     * ListWorkersRequest sortDirection.
                     * @member {string} sortDirection
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     */
                    ListWorkersRequest.prototype.sortDirection = "";
    
                    /**
                     * Creates a new ListWorkersRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListWorkersRequest} ListWorkersRequest instance
                     */
                    ListWorkersRequest.create = function create(properties) {
                        return new ListWorkersRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListWorkersRequest message. Does not implicitly {@link palexy.streaming.v1.ListWorkersRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersRequest} message ListWorkersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkersRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.location != null && Object.hasOwnProperty.call(message, "location"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.location);
                        if (message.searchKey != null && Object.hasOwnProperty.call(message, "searchKey"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.searchKey);
                        if (message.sortBy != null && Object.hasOwnProperty.call(message, "sortBy"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.sortBy);
                        if (message.sortDirection != null && Object.hasOwnProperty.call(message, "sortDirection"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.sortDirection);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListWorkersRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListWorkersRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersRequest} message ListWorkersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkersRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListWorkersRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListWorkersRequest} ListWorkersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkersRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListWorkersRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.location = reader.string();
                                break;
                            case 4:
                                message.searchKey = reader.string();
                                break;
                            case 5:
                                message.sortBy = reader.string();
                                break;
                            case 6:
                                message.sortDirection = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListWorkersRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListWorkersRequest} ListWorkersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkersRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListWorkersRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListWorkersRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.location != null && message.hasOwnProperty("location"))
                            if (!$util.isString(message.location))
                                return "location: string expected";
                        if (message.searchKey != null && message.hasOwnProperty("searchKey"))
                            if (!$util.isString(message.searchKey))
                                return "searchKey: string expected";
                        if (message.sortBy != null && message.hasOwnProperty("sortBy"))
                            if (!$util.isString(message.sortBy))
                                return "sortBy: string expected";
                        if (message.sortDirection != null && message.hasOwnProperty("sortDirection"))
                            if (!$util.isString(message.sortDirection))
                                return "sortDirection: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListWorkersRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListWorkersRequest} ListWorkersRequest
                     */
                    ListWorkersRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListWorkersRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListWorkersRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.location != null)
                            message.location = String(object.location);
                        if (object.searchKey != null)
                            message.searchKey = String(object.searchKey);
                        if (object.sortBy != null)
                            message.sortBy = String(object.sortBy);
                        if (object.sortDirection != null)
                            message.sortDirection = String(object.sortDirection);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListWorkersRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @static
                     * @param {palexy.streaming.v1.ListWorkersRequest} message ListWorkersRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListWorkersRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.location = "";
                            object.searchKey = "";
                            object.sortBy = "";
                            object.sortDirection = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.location != null && message.hasOwnProperty("location"))
                            object.location = message.location;
                        if (message.searchKey != null && message.hasOwnProperty("searchKey"))
                            object.searchKey = message.searchKey;
                        if (message.sortBy != null && message.hasOwnProperty("sortBy"))
                            object.sortBy = message.sortBy;
                        if (message.sortDirection != null && message.hasOwnProperty("sortDirection"))
                            object.sortDirection = message.sortDirection;
                        return object;
                    };
    
                    /**
                     * Converts this ListWorkersRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListWorkersRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListWorkersRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListWorkersRequest;
                })();
    
                v1.ListWorkersResponse = (function() {
    
                    /**
                     * Properties of a ListWorkersResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListWorkersResponse
                     * @property {Array.<palexy.streaming.v1.IWorker>|null} [workers] ListWorkersResponse workers
                     * @property {string|null} [nextPageToken] ListWorkersResponse nextPageToken
                     * @property {number|null} [totalElements] ListWorkersResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListWorkersResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListWorkersResponse.
                     * @implements IListWorkersResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListWorkersResponse=} [properties] Properties to set
                     */
                    function ListWorkersResponse(properties) {
                        this.workers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListWorkersResponse workers.
                     * @member {Array.<palexy.streaming.v1.IWorker>} workers
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @instance
                     */
                    ListWorkersResponse.prototype.workers = $util.emptyArray;
    
                    /**
                     * ListWorkersResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @instance
                     */
                    ListWorkersResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListWorkersResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @instance
                     */
                    ListWorkersResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListWorkersResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListWorkersResponse} ListWorkersResponse instance
                     */
                    ListWorkersResponse.create = function create(properties) {
                        return new ListWorkersResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListWorkersResponse message. Does not implicitly {@link palexy.streaming.v1.ListWorkersResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersResponse} message ListWorkersResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkersResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.workers != null && message.workers.length)
                            for (var i = 0; i < message.workers.length; ++i)
                                $root.palexy.streaming.v1.Worker.encode(message.workers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListWorkersResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListWorkersResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {palexy.streaming.v1.IListWorkersResponse} message ListWorkersResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWorkersResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListWorkersResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListWorkersResponse} ListWorkersResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkersResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListWorkersResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.workers && message.workers.length))
                                    message.workers = [];
                                message.workers.push($root.palexy.streaming.v1.Worker.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListWorkersResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListWorkersResponse} ListWorkersResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWorkersResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListWorkersResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListWorkersResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.workers != null && message.hasOwnProperty("workers")) {
                            if (!Array.isArray(message.workers))
                                return "workers: array expected";
                            for (var i = 0; i < message.workers.length; ++i) {
                                var error = $root.palexy.streaming.v1.Worker.verify(message.workers[i]);
                                if (error)
                                    return "workers." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListWorkersResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListWorkersResponse} ListWorkersResponse
                     */
                    ListWorkersResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListWorkersResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListWorkersResponse();
                        if (object.workers) {
                            if (!Array.isArray(object.workers))
                                throw TypeError(".palexy.streaming.v1.ListWorkersResponse.workers: array expected");
                            message.workers = [];
                            for (var i = 0; i < object.workers.length; ++i) {
                                if (typeof object.workers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListWorkersResponse.workers: object expected");
                                message.workers[i] = $root.palexy.streaming.v1.Worker.fromObject(object.workers[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListWorkersResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @static
                     * @param {palexy.streaming.v1.ListWorkersResponse} message ListWorkersResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListWorkersResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.workers = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.workers && message.workers.length) {
                            object.workers = [];
                            for (var j = 0; j < message.workers.length; ++j)
                                object.workers[j] = $root.palexy.streaming.v1.Worker.toObject(message.workers[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListWorkersResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListWorkersResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListWorkersResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListWorkersResponse;
                })();
    
                v1.Camera = (function() {
    
                    /**
                     * Properties of a Camera.
                     * @memberof palexy.streaming.v1
                     * @interface ICamera
                     * @property {string|null} [name] Camera name
                     * @property {string|null} [username] Camera username
                     * @property {string|null} [password] Camera password
                     * @property {string|null} [rtspUrl] Camera rtspUrl
                     * @property {string|null} [cameraId] Camera cameraId
                     * @property {number|null} [cameraDatabaseId] Camera cameraDatabaseId
                     * @property {string|null} [startTime] Camera startTime
                     * @property {string|null} [endTime] Camera endTime
                     * @property {string|null} [timezone] Camera timezone
                     * @property {palexy.streaming.v1.ITransformationMatrix|null} [transformationMatrix] Camera transformationMatrix
                     * @property {palexy.streaming.v1.IExcludedAreas|null} [excludedAreas] Camera excludedAreas
                     * @property {number|null} [areaId] Camera areaId
                     * @property {palexy.streaming.v1.IArea|null} [area] Camera area
                     * @property {palexy.streaming.v1.Camera.StreamingState|null} [streamingState] Camera streamingState
                     * @property {string|null} [streamingStateStatusMessage] Camera streamingStateStatusMessage
                     * @property {google.protobuf.ITimestamp|null} [streamingStateLastUpdateTime] Camera streamingStateLastUpdateTime
                     * @property {google.protobuf.ITimestamp|null} [lastAlertTime] Camera lastAlertTime
                     * @property {number|null} [numAlert] Camera numAlert
                     * @property {string|null} [streamingWorkerName] Camera streamingWorkerName
                     * @property {google.protobuf.ITimestamp|null} [streamingWorkerLastUpdateTime] Camera streamingWorkerLastUpdateTime
                     * @property {number|null} [storeId] Camera storeId
                     * @property {number|null} [cameraResolutionWidth] Camera cameraResolutionWidth
                     * @property {number|null} [cameraResolutionHeight] Camera cameraResolutionHeight
                     * @property {number|null} [versionId] Camera versionId
                     * @property {palexy.streaming.v1.Camera.ShiftStatus|null} [shiftStatus] Camera shiftStatus
                     * @property {google.protobuf.ITimestamp|null} [lastShiftCheckingTime] Camera lastShiftCheckingTime
                     * @property {palexy.streaming.v1.IStore|null} [store] Camera store
                     * @property {string|null} [streamingLocation] Camera streamingLocation
                     * @property {palexy.streaming.v1.ICompany|null} [company] Camera company
                     * @property {Array.<palexy.streaming.v1.Camera.Action>|null} [actions] Camera actions
                     * @property {palexy.streaming.v1.Camera.Orientation|null} [orientation] Camera orientation
                     * @property {Array.<palexy.streaming.v1.IPreprocessingOption>|null} [preprocessingOptions] Camera preprocessingOptions
                     * @property {palexy.streaming.v1.Camera.Type|null} [type] Camera type
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [subviews] Camera subviews
                     * @property {string|null} [fps] Camera fps
                     * @property {boolean|null} [isDisabled] Camera isDisabled
                     * @property {boolean|null} [useWallclockAsTimestamps] Camera useWallclockAsTimestamps
                     * @property {google.protobuf.ITimestamp|null} [firstSentLevel_2NotificationTime] Camera firstSentLevel_2NotificationTime
                     * @property {number|null} [parentCameraDatabaseId] Camera parentCameraDatabaseId
                     * @property {palexy.streaming.v1.ICustomStreamingTime|null} [customStreamingTime] Camera customStreamingTime
                     * @property {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null} [listWeekdayCustomStreamingTime] Camera listWeekdayCustomStreamingTime
                     * @property {number|null} [dvrCameraId] Camera dvrCameraId
                     * @property {boolean|null} [isStreamingOnly] Camera isStreamingOnly
                     * @property {boolean|null} [isShifted] Camera isShifted
                     * @property {palexy.streaming.v1.Camera.RtspTransportProtocol|null} [rtspTransportProtocol] Camera rtspTransportProtocol
                     * @property {palexy.streaming.v1.Camera.DownloadStatus|null} [downloadStatus] Camera downloadStatus
                     * @property {palexy.streaming.v1.Camera.RetrieveVideoType|null} [retrieveVideoType] Camera retrieveVideoType
                     * @property {boolean|null} [useFfmpegSsFlag] Camera useFfmpegSsFlag
                     * @property {number|null} [referenceCameraId] Camera referenceCameraId
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [referencingCameras] Camera referencingCameras
                     * @property {boolean|null} [isEnableProcessing] Camera isEnableProcessing
                     * @property {boolean|null} [useStandardResolution] Camera useStandardResolution
                     * @property {Array.<palexy.streaming.v1.Camera.Tag>|null} [tags] Camera tags
                     */
    
                    /**
                     * Constructs a new Camera.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Camera.
                     * @implements ICamera
                     * @constructor
                     * @param {palexy.streaming.v1.ICamera=} [properties] Properties to set
                     */
                    function Camera(properties) {
                        this.actions = [];
                        this.preprocessingOptions = [];
                        this.subviews = [];
                        this.referencingCameras = [];
                        this.tags = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Camera name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.name = "";
    
                    /**
                     * Camera username.
                     * @member {string} username
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.username = "";
    
                    /**
                     * Camera password.
                     * @member {string} password
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.password = "";
    
                    /**
                     * Camera rtspUrl.
                     * @member {string} rtspUrl
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.rtspUrl = "";
    
                    /**
                     * Camera cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.cameraId = "";
    
                    /**
                     * Camera cameraDatabaseId.
                     * @member {number} cameraDatabaseId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.cameraDatabaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.startTime = "";
    
                    /**
                     * Camera endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.endTime = "";
    
                    /**
                     * Camera timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.timezone = "";
    
                    /**
                     * Camera transformationMatrix.
                     * @member {palexy.streaming.v1.ITransformationMatrix|null|undefined} transformationMatrix
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.transformationMatrix = null;
    
                    /**
                     * Camera excludedAreas.
                     * @member {palexy.streaming.v1.IExcludedAreas|null|undefined} excludedAreas
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.excludedAreas = null;
    
                    /**
                     * Camera areaId.
                     * @member {number} areaId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.areaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera area.
                     * @member {palexy.streaming.v1.IArea|null|undefined} area
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.area = null;
    
                    /**
                     * Camera streamingState.
                     * @member {palexy.streaming.v1.Camera.StreamingState} streamingState
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingState = 0;
    
                    /**
                     * Camera streamingStateStatusMessage.
                     * @member {string} streamingStateStatusMessage
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingStateStatusMessage = "";
    
                    /**
                     * Camera streamingStateLastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} streamingStateLastUpdateTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingStateLastUpdateTime = null;
    
                    /**
                     * Camera lastAlertTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastAlertTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.lastAlertTime = null;
    
                    /**
                     * Camera numAlert.
                     * @member {number} numAlert
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.numAlert = 0;
    
                    /**
                     * Camera streamingWorkerName.
                     * @member {string} streamingWorkerName
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingWorkerName = "";
    
                    /**
                     * Camera streamingWorkerLastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} streamingWorkerLastUpdateTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingWorkerLastUpdateTime = null;
    
                    /**
                     * Camera storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera cameraResolutionWidth.
                     * @member {number} cameraResolutionWidth
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.cameraResolutionWidth = 0;
    
                    /**
                     * Camera cameraResolutionHeight.
                     * @member {number} cameraResolutionHeight
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.cameraResolutionHeight = 0;
    
                    /**
                     * Camera versionId.
                     * @member {number} versionId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.versionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera shiftStatus.
                     * @member {palexy.streaming.v1.Camera.ShiftStatus} shiftStatus
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.shiftStatus = 0;
    
                    /**
                     * Camera lastShiftCheckingTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastShiftCheckingTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.lastShiftCheckingTime = null;
    
                    /**
                     * Camera store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.store = null;
    
                    /**
                     * Camera streamingLocation.
                     * @member {string} streamingLocation
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.streamingLocation = "";
    
                    /**
                     * Camera company.
                     * @member {palexy.streaming.v1.ICompany|null|undefined} company
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.company = null;
    
                    /**
                     * Camera actions.
                     * @member {Array.<palexy.streaming.v1.Camera.Action>} actions
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.actions = $util.emptyArray;
    
                    /**
                     * Camera orientation.
                     * @member {palexy.streaming.v1.Camera.Orientation} orientation
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.orientation = 0;
    
                    /**
                     * Camera preprocessingOptions.
                     * @member {Array.<palexy.streaming.v1.IPreprocessingOption>} preprocessingOptions
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.preprocessingOptions = $util.emptyArray;
    
                    /**
                     * Camera type.
                     * @member {palexy.streaming.v1.Camera.Type} type
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.type = 0;
    
                    /**
                     * Camera subviews.
                     * @member {Array.<palexy.streaming.v1.ICamera>} subviews
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.subviews = $util.emptyArray;
    
                    /**
                     * Camera fps.
                     * @member {string} fps
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.fps = "";
    
                    /**
                     * Camera isDisabled.
                     * @member {boolean} isDisabled
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.isDisabled = false;
    
                    /**
                     * Camera useWallclockAsTimestamps.
                     * @member {boolean} useWallclockAsTimestamps
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.useWallclockAsTimestamps = false;
    
                    /**
                     * Camera firstSentLevel_2NotificationTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} firstSentLevel_2NotificationTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.firstSentLevel_2NotificationTime = null;
    
                    /**
                     * Camera parentCameraDatabaseId.
                     * @member {number} parentCameraDatabaseId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.parentCameraDatabaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera customStreamingTime.
                     * @member {palexy.streaming.v1.ICustomStreamingTime|null|undefined} customStreamingTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.customStreamingTime = null;
    
                    /**
                     * Camera listWeekdayCustomStreamingTime.
                     * @member {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null|undefined} listWeekdayCustomStreamingTime
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.listWeekdayCustomStreamingTime = null;
    
                    /**
                     * Camera dvrCameraId.
                     * @member {number} dvrCameraId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.dvrCameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera isStreamingOnly.
                     * @member {boolean} isStreamingOnly
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.isStreamingOnly = false;
    
                    /**
                     * Camera isShifted.
                     * @member {boolean} isShifted
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.isShifted = false;
    
                    /**
                     * Camera rtspTransportProtocol.
                     * @member {palexy.streaming.v1.Camera.RtspTransportProtocol} rtspTransportProtocol
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.rtspTransportProtocol = 0;
    
                    /**
                     * Camera downloadStatus.
                     * @member {palexy.streaming.v1.Camera.DownloadStatus} downloadStatus
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.downloadStatus = 0;
    
                    /**
                     * Camera retrieveVideoType.
                     * @member {palexy.streaming.v1.Camera.RetrieveVideoType} retrieveVideoType
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.retrieveVideoType = 0;
    
                    /**
                     * Camera useFfmpegSsFlag.
                     * @member {boolean} useFfmpegSsFlag
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.useFfmpegSsFlag = false;
    
                    /**
                     * Camera referenceCameraId.
                     * @member {number} referenceCameraId
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.referenceCameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Camera referencingCameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} referencingCameras
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.referencingCameras = $util.emptyArray;
    
                    /**
                     * Camera isEnableProcessing.
                     * @member {boolean} isEnableProcessing
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.isEnableProcessing = false;
    
                    /**
                     * Camera useStandardResolution.
                     * @member {boolean} useStandardResolution
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.useStandardResolution = false;
    
                    /**
                     * Camera tags.
                     * @member {Array.<palexy.streaming.v1.Camera.Tag>} tags
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     */
                    Camera.prototype.tags = $util.emptyArray;
    
                    /**
                     * Creates a new Camera instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {palexy.streaming.v1.ICamera=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Camera} Camera instance
                     */
                    Camera.create = function create(properties) {
                        return new Camera(properties);
                    };
    
                    /**
                     * Encodes the specified Camera message. Does not implicitly {@link palexy.streaming.v1.Camera.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {palexy.streaming.v1.ICamera} message Camera message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Camera.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                        if (message.rtspUrl != null && Object.hasOwnProperty.call(message, "rtspUrl"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.rtspUrl);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.cameraId);
                        if (message.cameraDatabaseId != null && Object.hasOwnProperty.call(message, "cameraDatabaseId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.cameraDatabaseId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.endTime);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.timezone);
                        if (message.transformationMatrix != null && Object.hasOwnProperty.call(message, "transformationMatrix"))
                            $root.palexy.streaming.v1.TransformationMatrix.encode(message.transformationMatrix, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.excludedAreas != null && Object.hasOwnProperty.call(message, "excludedAreas"))
                            $root.palexy.streaming.v1.ExcludedAreas.encode(message.excludedAreas, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.areaId);
                        if (message.area != null && Object.hasOwnProperty.call(message, "area"))
                            $root.palexy.streaming.v1.Area.encode(message.area, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.streamingState != null && Object.hasOwnProperty.call(message, "streamingState"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.streamingState);
                        if (message.streamingStateStatusMessage != null && Object.hasOwnProperty.call(message, "streamingStateStatusMessage"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.streamingStateStatusMessage);
                        if (message.streamingStateLastUpdateTime != null && Object.hasOwnProperty.call(message, "streamingStateLastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.streamingStateLastUpdateTime, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.lastAlertTime != null && Object.hasOwnProperty.call(message, "lastAlertTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastAlertTime, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.numAlert != null && Object.hasOwnProperty.call(message, "numAlert"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.numAlert);
                        if (message.streamingWorkerName != null && Object.hasOwnProperty.call(message, "streamingWorkerName"))
                            writer.uint32(/* id 19, wireType 2 =*/154).string(message.streamingWorkerName);
                        if (message.streamingWorkerLastUpdateTime != null && Object.hasOwnProperty.call(message, "streamingWorkerLastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.streamingWorkerLastUpdateTime, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 21, wireType 0 =*/168).int64(message.storeId);
                        if (message.cameraResolutionWidth != null && Object.hasOwnProperty.call(message, "cameraResolutionWidth"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.cameraResolutionWidth);
                        if (message.cameraResolutionHeight != null && Object.hasOwnProperty.call(message, "cameraResolutionHeight"))
                            writer.uint32(/* id 23, wireType 0 =*/184).int32(message.cameraResolutionHeight);
                        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int64(message.versionId);
                        if (message.shiftStatus != null && Object.hasOwnProperty.call(message, "shiftStatus"))
                            writer.uint32(/* id 25, wireType 0 =*/200).int32(message.shiftStatus);
                        if (message.lastShiftCheckingTime != null && Object.hasOwnProperty.call(message, "lastShiftCheckingTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastShiftCheckingTime, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                        if (message.streamingLocation != null && Object.hasOwnProperty.call(message, "streamingLocation"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.streamingLocation);
                        if (message.company != null && Object.hasOwnProperty.call(message, "company"))
                            $root.palexy.streaming.v1.Company.encode(message.company, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                        if (message.actions != null && message.actions.length) {
                            writer.uint32(/* id 30, wireType 2 =*/242).fork();
                            for (var i = 0; i < message.actions.length; ++i)
                                writer.int32(message.actions[i]);
                            writer.ldelim();
                        }
                        if (message.orientation != null && Object.hasOwnProperty.call(message, "orientation"))
                            writer.uint32(/* id 31, wireType 0 =*/248).int32(message.orientation);
                        if (message.preprocessingOptions != null && message.preprocessingOptions.length)
                            for (var i = 0; i < message.preprocessingOptions.length; ++i)
                                $root.palexy.streaming.v1.PreprocessingOption.encode(message.preprocessingOptions[i], writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 33, wireType 0 =*/264).int32(message.type);
                        if (message.subviews != null && message.subviews.length)
                            for (var i = 0; i < message.subviews.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.subviews[i], writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.fps != null && Object.hasOwnProperty.call(message, "fps"))
                            writer.uint32(/* id 35, wireType 2 =*/282).string(message.fps);
                        if (message.isDisabled != null && Object.hasOwnProperty.call(message, "isDisabled"))
                            writer.uint32(/* id 36, wireType 0 =*/288).bool(message.isDisabled);
                        if (message.useWallclockAsTimestamps != null && Object.hasOwnProperty.call(message, "useWallclockAsTimestamps"))
                            writer.uint32(/* id 37, wireType 0 =*/296).bool(message.useWallclockAsTimestamps);
                        if (message.firstSentLevel_2NotificationTime != null && Object.hasOwnProperty.call(message, "firstSentLevel_2NotificationTime"))
                            $root.google.protobuf.Timestamp.encode(message.firstSentLevel_2NotificationTime, writer.uint32(/* id 38, wireType 2 =*/306).fork()).ldelim();
                        if (message.parentCameraDatabaseId != null && Object.hasOwnProperty.call(message, "parentCameraDatabaseId"))
                            writer.uint32(/* id 39, wireType 0 =*/312).int64(message.parentCameraDatabaseId);
                        if (message.customStreamingTime != null && Object.hasOwnProperty.call(message, "customStreamingTime"))
                            $root.palexy.streaming.v1.CustomStreamingTime.encode(message.customStreamingTime, writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
                        if (message.listWeekdayCustomStreamingTime != null && Object.hasOwnProperty.call(message, "listWeekdayCustomStreamingTime"))
                            $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.encode(message.listWeekdayCustomStreamingTime, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
                        if (message.dvrCameraId != null && Object.hasOwnProperty.call(message, "dvrCameraId"))
                            writer.uint32(/* id 42, wireType 0 =*/336).int64(message.dvrCameraId);
                        if (message.isStreamingOnly != null && Object.hasOwnProperty.call(message, "isStreamingOnly"))
                            writer.uint32(/* id 43, wireType 0 =*/344).bool(message.isStreamingOnly);
                        if (message.isShifted != null && Object.hasOwnProperty.call(message, "isShifted"))
                            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.isShifted);
                        if (message.rtspTransportProtocol != null && Object.hasOwnProperty.call(message, "rtspTransportProtocol"))
                            writer.uint32(/* id 45, wireType 0 =*/360).int32(message.rtspTransportProtocol);
                        if (message.downloadStatus != null && Object.hasOwnProperty.call(message, "downloadStatus"))
                            writer.uint32(/* id 46, wireType 0 =*/368).int32(message.downloadStatus);
                        if (message.retrieveVideoType != null && Object.hasOwnProperty.call(message, "retrieveVideoType"))
                            writer.uint32(/* id 47, wireType 0 =*/376).int32(message.retrieveVideoType);
                        if (message.useFfmpegSsFlag != null && Object.hasOwnProperty.call(message, "useFfmpegSsFlag"))
                            writer.uint32(/* id 48, wireType 0 =*/384).bool(message.useFfmpegSsFlag);
                        if (message.referenceCameraId != null && Object.hasOwnProperty.call(message, "referenceCameraId"))
                            writer.uint32(/* id 49, wireType 0 =*/392).int64(message.referenceCameraId);
                        if (message.referencingCameras != null && message.referencingCameras.length)
                            for (var i = 0; i < message.referencingCameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.referencingCameras[i], writer.uint32(/* id 50, wireType 2 =*/402).fork()).ldelim();
                        if (message.isEnableProcessing != null && Object.hasOwnProperty.call(message, "isEnableProcessing"))
                            writer.uint32(/* id 51, wireType 0 =*/408).bool(message.isEnableProcessing);
                        if (message.useStandardResolution != null && Object.hasOwnProperty.call(message, "useStandardResolution"))
                            writer.uint32(/* id 52, wireType 0 =*/416).bool(message.useStandardResolution);
                        if (message.tags != null && message.tags.length) {
                            writer.uint32(/* id 53, wireType 2 =*/426).fork();
                            for (var i = 0; i < message.tags.length; ++i)
                                writer.int32(message.tags[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Camera message, length delimited. Does not implicitly {@link palexy.streaming.v1.Camera.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {palexy.streaming.v1.ICamera} message Camera message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Camera.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Camera message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Camera} Camera
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Camera.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Camera();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            case 3:
                                message.password = reader.string();
                                break;
                            case 4:
                                message.rtspUrl = reader.string();
                                break;
                            case 5:
                                message.cameraId = reader.string();
                                break;
                            case 6:
                                message.cameraDatabaseId = reader.int64();
                                break;
                            case 7:
                                message.startTime = reader.string();
                                break;
                            case 8:
                                message.endTime = reader.string();
                                break;
                            case 9:
                                message.timezone = reader.string();
                                break;
                            case 10:
                                message.transformationMatrix = $root.palexy.streaming.v1.TransformationMatrix.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.excludedAreas = $root.palexy.streaming.v1.ExcludedAreas.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.areaId = reader.int64();
                                break;
                            case 13:
                                message.area = $root.palexy.streaming.v1.Area.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.streamingState = reader.int32();
                                break;
                            case 15:
                                message.streamingStateStatusMessage = reader.string();
                                break;
                            case 16:
                                message.streamingStateLastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.lastAlertTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.numAlert = reader.int32();
                                break;
                            case 19:
                                message.streamingWorkerName = reader.string();
                                break;
                            case 20:
                                message.streamingWorkerLastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 21:
                                message.storeId = reader.int64();
                                break;
                            case 22:
                                message.cameraResolutionWidth = reader.int32();
                                break;
                            case 23:
                                message.cameraResolutionHeight = reader.int32();
                                break;
                            case 24:
                                message.versionId = reader.int64();
                                break;
                            case 25:
                                message.shiftStatus = reader.int32();
                                break;
                            case 26:
                                message.lastShiftCheckingTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 27:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 28:
                                message.streamingLocation = reader.string();
                                break;
                            case 29:
                                message.company = $root.palexy.streaming.v1.Company.decode(reader, reader.uint32());
                                break;
                            case 30:
                                if (!(message.actions && message.actions.length))
                                    message.actions = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.actions.push(reader.int32());
                                } else
                                    message.actions.push(reader.int32());
                                break;
                            case 31:
                                message.orientation = reader.int32();
                                break;
                            case 32:
                                if (!(message.preprocessingOptions && message.preprocessingOptions.length))
                                    message.preprocessingOptions = [];
                                message.preprocessingOptions.push($root.palexy.streaming.v1.PreprocessingOption.decode(reader, reader.uint32()));
                                break;
                            case 33:
                                message.type = reader.int32();
                                break;
                            case 34:
                                if (!(message.subviews && message.subviews.length))
                                    message.subviews = [];
                                message.subviews.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 35:
                                message.fps = reader.string();
                                break;
                            case 36:
                                message.isDisabled = reader.bool();
                                break;
                            case 37:
                                message.useWallclockAsTimestamps = reader.bool();
                                break;
                            case 38:
                                message.firstSentLevel_2NotificationTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 39:
                                message.parentCameraDatabaseId = reader.int64();
                                break;
                            case 40:
                                message.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 41:
                                message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 42:
                                message.dvrCameraId = reader.int64();
                                break;
                            case 43:
                                message.isStreamingOnly = reader.bool();
                                break;
                            case 44:
                                message.isShifted = reader.bool();
                                break;
                            case 45:
                                message.rtspTransportProtocol = reader.int32();
                                break;
                            case 46:
                                message.downloadStatus = reader.int32();
                                break;
                            case 47:
                                message.retrieveVideoType = reader.int32();
                                break;
                            case 48:
                                message.useFfmpegSsFlag = reader.bool();
                                break;
                            case 49:
                                message.referenceCameraId = reader.int64();
                                break;
                            case 50:
                                if (!(message.referencingCameras && message.referencingCameras.length))
                                    message.referencingCameras = [];
                                message.referencingCameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 51:
                                message.isEnableProcessing = reader.bool();
                                break;
                            case 52:
                                message.useStandardResolution = reader.bool();
                                break;
                            case 53:
                                if (!(message.tags && message.tags.length))
                                    message.tags = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.tags.push(reader.int32());
                                } else
                                    message.tags.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Camera message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Camera} Camera
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Camera.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Camera message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Camera.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        if (message.rtspUrl != null && message.hasOwnProperty("rtspUrl"))
                            if (!$util.isString(message.rtspUrl))
                                return "rtspUrl: string expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                            if (!$util.isInteger(message.cameraDatabaseId) && !(message.cameraDatabaseId && $util.isInteger(message.cameraDatabaseId.low) && $util.isInteger(message.cameraDatabaseId.high)))
                                return "cameraDatabaseId: integer|Long expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.transformationMatrix != null && message.hasOwnProperty("transformationMatrix")) {
                            var error = $root.palexy.streaming.v1.TransformationMatrix.verify(message.transformationMatrix);
                            if (error)
                                return "transformationMatrix." + error;
                        }
                        if (message.excludedAreas != null && message.hasOwnProperty("excludedAreas")) {
                            var error = $root.palexy.streaming.v1.ExcludedAreas.verify(message.excludedAreas);
                            if (error)
                                return "excludedAreas." + error;
                        }
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (!$util.isInteger(message.areaId) && !(message.areaId && $util.isInteger(message.areaId.low) && $util.isInteger(message.areaId.high)))
                                return "areaId: integer|Long expected";
                        if (message.area != null && message.hasOwnProperty("area")) {
                            var error = $root.palexy.streaming.v1.Area.verify(message.area);
                            if (error)
                                return "area." + error;
                        }
                        if (message.streamingState != null && message.hasOwnProperty("streamingState"))
                            switch (message.streamingState) {
                            default:
                                return "streamingState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.streamingStateStatusMessage != null && message.hasOwnProperty("streamingStateStatusMessage"))
                            if (!$util.isString(message.streamingStateStatusMessage))
                                return "streamingStateStatusMessage: string expected";
                        if (message.streamingStateLastUpdateTime != null && message.hasOwnProperty("streamingStateLastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.streamingStateLastUpdateTime);
                            if (error)
                                return "streamingStateLastUpdateTime." + error;
                        }
                        if (message.lastAlertTime != null && message.hasOwnProperty("lastAlertTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastAlertTime);
                            if (error)
                                return "lastAlertTime." + error;
                        }
                        if (message.numAlert != null && message.hasOwnProperty("numAlert"))
                            if (!$util.isInteger(message.numAlert))
                                return "numAlert: integer expected";
                        if (message.streamingWorkerName != null && message.hasOwnProperty("streamingWorkerName"))
                            if (!$util.isString(message.streamingWorkerName))
                                return "streamingWorkerName: string expected";
                        if (message.streamingWorkerLastUpdateTime != null && message.hasOwnProperty("streamingWorkerLastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.streamingWorkerLastUpdateTime);
                            if (error)
                                return "streamingWorkerLastUpdateTime." + error;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.cameraResolutionWidth != null && message.hasOwnProperty("cameraResolutionWidth"))
                            if (!$util.isInteger(message.cameraResolutionWidth))
                                return "cameraResolutionWidth: integer expected";
                        if (message.cameraResolutionHeight != null && message.hasOwnProperty("cameraResolutionHeight"))
                            if (!$util.isInteger(message.cameraResolutionHeight))
                                return "cameraResolutionHeight: integer expected";
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (!$util.isInteger(message.versionId) && !(message.versionId && $util.isInteger(message.versionId.low) && $util.isInteger(message.versionId.high)))
                                return "versionId: integer|Long expected";
                        if (message.shiftStatus != null && message.hasOwnProperty("shiftStatus"))
                            switch (message.shiftStatus) {
                            default:
                                return "shiftStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.lastShiftCheckingTime != null && message.hasOwnProperty("lastShiftCheckingTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastShiftCheckingTime);
                            if (error)
                                return "lastShiftCheckingTime." + error;
                        }
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            if (!$util.isString(message.streamingLocation))
                                return "streamingLocation: string expected";
                        if (message.company != null && message.hasOwnProperty("company")) {
                            var error = $root.palexy.streaming.v1.Company.verify(message.company);
                            if (error)
                                return "company." + error;
                        }
                        if (message.actions != null && message.hasOwnProperty("actions")) {
                            if (!Array.isArray(message.actions))
                                return "actions: array expected";
                            for (var i = 0; i < message.actions.length; ++i)
                                switch (message.actions[i]) {
                                default:
                                    return "actions: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                    break;
                                }
                        }
                        if (message.orientation != null && message.hasOwnProperty("orientation"))
                            switch (message.orientation) {
                            default:
                                return "orientation: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.preprocessingOptions != null && message.hasOwnProperty("preprocessingOptions")) {
                            if (!Array.isArray(message.preprocessingOptions))
                                return "preprocessingOptions: array expected";
                            for (var i = 0; i < message.preprocessingOptions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PreprocessingOption.verify(message.preprocessingOptions[i]);
                                if (error)
                                    return "preprocessingOptions." + error;
                            }
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.subviews != null && message.hasOwnProperty("subviews")) {
                            if (!Array.isArray(message.subviews))
                                return "subviews: array expected";
                            for (var i = 0; i < message.subviews.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.subviews[i]);
                                if (error)
                                    return "subviews." + error;
                            }
                        }
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            if (!$util.isString(message.fps))
                                return "fps: string expected";
                        if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                            if (typeof message.isDisabled !== "boolean")
                                return "isDisabled: boolean expected";
                        if (message.useWallclockAsTimestamps != null && message.hasOwnProperty("useWallclockAsTimestamps"))
                            if (typeof message.useWallclockAsTimestamps !== "boolean")
                                return "useWallclockAsTimestamps: boolean expected";
                        if (message.firstSentLevel_2NotificationTime != null && message.hasOwnProperty("firstSentLevel_2NotificationTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.firstSentLevel_2NotificationTime);
                            if (error)
                                return "firstSentLevel_2NotificationTime." + error;
                        }
                        if (message.parentCameraDatabaseId != null && message.hasOwnProperty("parentCameraDatabaseId"))
                            if (!$util.isInteger(message.parentCameraDatabaseId) && !(message.parentCameraDatabaseId && $util.isInteger(message.parentCameraDatabaseId.low) && $util.isInteger(message.parentCameraDatabaseId.high)))
                                return "parentCameraDatabaseId: integer|Long expected";
                        if (message.customStreamingTime != null && message.hasOwnProperty("customStreamingTime")) {
                            var error = $root.palexy.streaming.v1.CustomStreamingTime.verify(message.customStreamingTime);
                            if (error)
                                return "customStreamingTime." + error;
                        }
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime")) {
                            var error = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify(message.listWeekdayCustomStreamingTime);
                            if (error)
                                return "listWeekdayCustomStreamingTime." + error;
                        }
                        if (message.dvrCameraId != null && message.hasOwnProperty("dvrCameraId"))
                            if (!$util.isInteger(message.dvrCameraId) && !(message.dvrCameraId && $util.isInteger(message.dvrCameraId.low) && $util.isInteger(message.dvrCameraId.high)))
                                return "dvrCameraId: integer|Long expected";
                        if (message.isStreamingOnly != null && message.hasOwnProperty("isStreamingOnly"))
                            if (typeof message.isStreamingOnly !== "boolean")
                                return "isStreamingOnly: boolean expected";
                        if (message.isShifted != null && message.hasOwnProperty("isShifted"))
                            if (typeof message.isShifted !== "boolean")
                                return "isShifted: boolean expected";
                        if (message.rtspTransportProtocol != null && message.hasOwnProperty("rtspTransportProtocol"))
                            switch (message.rtspTransportProtocol) {
                            default:
                                return "rtspTransportProtocol: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.downloadStatus != null && message.hasOwnProperty("downloadStatus"))
                            switch (message.downloadStatus) {
                            default:
                                return "downloadStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.retrieveVideoType != null && message.hasOwnProperty("retrieveVideoType"))
                            switch (message.retrieveVideoType) {
                            default:
                                return "retrieveVideoType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.useFfmpegSsFlag != null && message.hasOwnProperty("useFfmpegSsFlag"))
                            if (typeof message.useFfmpegSsFlag !== "boolean")
                                return "useFfmpegSsFlag: boolean expected";
                        if (message.referenceCameraId != null && message.hasOwnProperty("referenceCameraId"))
                            if (!$util.isInteger(message.referenceCameraId) && !(message.referenceCameraId && $util.isInteger(message.referenceCameraId.low) && $util.isInteger(message.referenceCameraId.high)))
                                return "referenceCameraId: integer|Long expected";
                        if (message.referencingCameras != null && message.hasOwnProperty("referencingCameras")) {
                            if (!Array.isArray(message.referencingCameras))
                                return "referencingCameras: array expected";
                            for (var i = 0; i < message.referencingCameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.referencingCameras[i]);
                                if (error)
                                    return "referencingCameras." + error;
                            }
                        }
                        if (message.isEnableProcessing != null && message.hasOwnProperty("isEnableProcessing"))
                            if (typeof message.isEnableProcessing !== "boolean")
                                return "isEnableProcessing: boolean expected";
                        if (message.useStandardResolution != null && message.hasOwnProperty("useStandardResolution"))
                            if (typeof message.useStandardResolution !== "boolean")
                                return "useStandardResolution: boolean expected";
                        if (message.tags != null && message.hasOwnProperty("tags")) {
                            if (!Array.isArray(message.tags))
                                return "tags: array expected";
                            for (var i = 0; i < message.tags.length; ++i)
                                switch (message.tags[i]) {
                                default:
                                    return "tags: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Camera message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Camera} Camera
                     */
                    Camera.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Camera)
                            return object;
                        var message = new $root.palexy.streaming.v1.Camera();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.password != null)
                            message.password = String(object.password);
                        if (object.rtspUrl != null)
                            message.rtspUrl = String(object.rtspUrl);
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.cameraDatabaseId != null)
                            if ($util.Long)
                                (message.cameraDatabaseId = $util.Long.fromValue(object.cameraDatabaseId)).unsigned = false;
                            else if (typeof object.cameraDatabaseId === "string")
                                message.cameraDatabaseId = parseInt(object.cameraDatabaseId, 10);
                            else if (typeof object.cameraDatabaseId === "number")
                                message.cameraDatabaseId = object.cameraDatabaseId;
                            else if (typeof object.cameraDatabaseId === "object")
                                message.cameraDatabaseId = new $util.LongBits(object.cameraDatabaseId.low >>> 0, object.cameraDatabaseId.high >>> 0).toNumber();
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.transformationMatrix != null) {
                            if (typeof object.transformationMatrix !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.transformationMatrix: object expected");
                            message.transformationMatrix = $root.palexy.streaming.v1.TransformationMatrix.fromObject(object.transformationMatrix);
                        }
                        if (object.excludedAreas != null) {
                            if (typeof object.excludedAreas !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.excludedAreas: object expected");
                            message.excludedAreas = $root.palexy.streaming.v1.ExcludedAreas.fromObject(object.excludedAreas);
                        }
                        if (object.areaId != null)
                            if ($util.Long)
                                (message.areaId = $util.Long.fromValue(object.areaId)).unsigned = false;
                            else if (typeof object.areaId === "string")
                                message.areaId = parseInt(object.areaId, 10);
                            else if (typeof object.areaId === "number")
                                message.areaId = object.areaId;
                            else if (typeof object.areaId === "object")
                                message.areaId = new $util.LongBits(object.areaId.low >>> 0, object.areaId.high >>> 0).toNumber();
                        if (object.area != null) {
                            if (typeof object.area !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.area: object expected");
                            message.area = $root.palexy.streaming.v1.Area.fromObject(object.area);
                        }
                        switch (object.streamingState) {
                        case "UNKNOWN":
                        case 0:
                            message.streamingState = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.streamingState = 1;
                            break;
                        case "BROKEN":
                        case 2:
                            message.streamingState = 2;
                            break;
                        }
                        if (object.streamingStateStatusMessage != null)
                            message.streamingStateStatusMessage = String(object.streamingStateStatusMessage);
                        if (object.streamingStateLastUpdateTime != null) {
                            if (typeof object.streamingStateLastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.streamingStateLastUpdateTime: object expected");
                            message.streamingStateLastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.streamingStateLastUpdateTime);
                        }
                        if (object.lastAlertTime != null) {
                            if (typeof object.lastAlertTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.lastAlertTime: object expected");
                            message.lastAlertTime = $root.google.protobuf.Timestamp.fromObject(object.lastAlertTime);
                        }
                        if (object.numAlert != null)
                            message.numAlert = object.numAlert | 0;
                        if (object.streamingWorkerName != null)
                            message.streamingWorkerName = String(object.streamingWorkerName);
                        if (object.streamingWorkerLastUpdateTime != null) {
                            if (typeof object.streamingWorkerLastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.streamingWorkerLastUpdateTime: object expected");
                            message.streamingWorkerLastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.streamingWorkerLastUpdateTime);
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.cameraResolutionWidth != null)
                            message.cameraResolutionWidth = object.cameraResolutionWidth | 0;
                        if (object.cameraResolutionHeight != null)
                            message.cameraResolutionHeight = object.cameraResolutionHeight | 0;
                        if (object.versionId != null)
                            if ($util.Long)
                                (message.versionId = $util.Long.fromValue(object.versionId)).unsigned = false;
                            else if (typeof object.versionId === "string")
                                message.versionId = parseInt(object.versionId, 10);
                            else if (typeof object.versionId === "number")
                                message.versionId = object.versionId;
                            else if (typeof object.versionId === "object")
                                message.versionId = new $util.LongBits(object.versionId.low >>> 0, object.versionId.high >>> 0).toNumber();
                        switch (object.shiftStatus) {
                        case "SHIFT_UNKNOWN":
                        case 0:
                            message.shiftStatus = 0;
                            break;
                        case "SHIFTED":
                        case 1:
                            message.shiftStatus = 1;
                            break;
                        case "NOT_SHIFTED":
                        case 2:
                            message.shiftStatus = 2;
                            break;
                        }
                        if (object.lastShiftCheckingTime != null) {
                            if (typeof object.lastShiftCheckingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.lastShiftCheckingTime: object expected");
                            message.lastShiftCheckingTime = $root.google.protobuf.Timestamp.fromObject(object.lastShiftCheckingTime);
                        }
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.streamingLocation != null)
                            message.streamingLocation = String(object.streamingLocation);
                        if (object.company != null) {
                            if (typeof object.company !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.company: object expected");
                            message.company = $root.palexy.streaming.v1.Company.fromObject(object.company);
                        }
                        if (object.actions) {
                            if (!Array.isArray(object.actions))
                                throw TypeError(".palexy.streaming.v1.Camera.actions: array expected");
                            message.actions = [];
                            for (var i = 0; i < object.actions.length; ++i)
                                switch (object.actions[i]) {
                                default:
                                case "ACTION_UNKNOWN":
                                case 0:
                                    message.actions[i] = 0;
                                    break;
                                case "ENTRANCE":
                                case 1:
                                    message.actions[i] = 1;
                                    break;
                                case "QUEUE_TIME":
                                case 2:
                                    message.actions[i] = 2;
                                    break;
                                case "SECTION":
                                case 3:
                                    message.actions[i] = 3;
                                    break;
                                case "PASS_BY":
                                case 4:
                                    message.actions[i] = 4;
                                    break;
                                case "DEFAULT":
                                case 5:
                                    message.actions[i] = 5;
                                    break;
                                case "WIDE_SPACE_ENTRANCE":
                                case 6:
                                    message.actions[i] = 6;
                                    break;
                                }
                        }
                        switch (object.orientation) {
                        case "ORIENTATION_UNKNOWN":
                        case 0:
                            message.orientation = 0;
                            break;
                        case "ROTATE_0":
                        case 1:
                            message.orientation = 1;
                            break;
                        case "ROTATE_90_CLOCKWISE":
                        case 2:
                            message.orientation = 2;
                            break;
                        case "ROTATE_90_COUNTERCLOCKWISE":
                        case 3:
                            message.orientation = 3;
                            break;
                        case "ROTATE_180":
                        case 4:
                            message.orientation = 4;
                            break;
                        }
                        if (object.preprocessingOptions) {
                            if (!Array.isArray(object.preprocessingOptions))
                                throw TypeError(".palexy.streaming.v1.Camera.preprocessingOptions: array expected");
                            message.preprocessingOptions = [];
                            for (var i = 0; i < object.preprocessingOptions.length; ++i) {
                                if (typeof object.preprocessingOptions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Camera.preprocessingOptions: object expected");
                                message.preprocessingOptions[i] = $root.palexy.streaming.v1.PreprocessingOption.fromObject(object.preprocessingOptions[i]);
                            }
                        }
                        switch (object.type) {
                        case "BASIC":
                        case 0:
                            message.type = 0;
                            break;
                        case "FISHEYE":
                        case 1:
                            message.type = 1;
                            break;
                        case "FISHEYE_SUBVIEW":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        if (object.subviews) {
                            if (!Array.isArray(object.subviews))
                                throw TypeError(".palexy.streaming.v1.Camera.subviews: array expected");
                            message.subviews = [];
                            for (var i = 0; i < object.subviews.length; ++i) {
                                if (typeof object.subviews[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Camera.subviews: object expected");
                                message.subviews[i] = $root.palexy.streaming.v1.Camera.fromObject(object.subviews[i]);
                            }
                        }
                        if (object.fps != null)
                            message.fps = String(object.fps);
                        if (object.isDisabled != null)
                            message.isDisabled = Boolean(object.isDisabled);
                        if (object.useWallclockAsTimestamps != null)
                            message.useWallclockAsTimestamps = Boolean(object.useWallclockAsTimestamps);
                        if (object.firstSentLevel_2NotificationTime != null) {
                            if (typeof object.firstSentLevel_2NotificationTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.firstSentLevel_2NotificationTime: object expected");
                            message.firstSentLevel_2NotificationTime = $root.google.protobuf.Timestamp.fromObject(object.firstSentLevel_2NotificationTime);
                        }
                        if (object.parentCameraDatabaseId != null)
                            if ($util.Long)
                                (message.parentCameraDatabaseId = $util.Long.fromValue(object.parentCameraDatabaseId)).unsigned = false;
                            else if (typeof object.parentCameraDatabaseId === "string")
                                message.parentCameraDatabaseId = parseInt(object.parentCameraDatabaseId, 10);
                            else if (typeof object.parentCameraDatabaseId === "number")
                                message.parentCameraDatabaseId = object.parentCameraDatabaseId;
                            else if (typeof object.parentCameraDatabaseId === "object")
                                message.parentCameraDatabaseId = new $util.LongBits(object.parentCameraDatabaseId.low >>> 0, object.parentCameraDatabaseId.high >>> 0).toNumber();
                        if (object.customStreamingTime != null) {
                            if (typeof object.customStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.customStreamingTime: object expected");
                            message.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.fromObject(object.customStreamingTime);
                        }
                        if (object.listWeekdayCustomStreamingTime != null) {
                            if (typeof object.listWeekdayCustomStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Camera.listWeekdayCustomStreamingTime: object expected");
                            message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.fromObject(object.listWeekdayCustomStreamingTime);
                        }
                        if (object.dvrCameraId != null)
                            if ($util.Long)
                                (message.dvrCameraId = $util.Long.fromValue(object.dvrCameraId)).unsigned = false;
                            else if (typeof object.dvrCameraId === "string")
                                message.dvrCameraId = parseInt(object.dvrCameraId, 10);
                            else if (typeof object.dvrCameraId === "number")
                                message.dvrCameraId = object.dvrCameraId;
                            else if (typeof object.dvrCameraId === "object")
                                message.dvrCameraId = new $util.LongBits(object.dvrCameraId.low >>> 0, object.dvrCameraId.high >>> 0).toNumber();
                        if (object.isStreamingOnly != null)
                            message.isStreamingOnly = Boolean(object.isStreamingOnly);
                        if (object.isShifted != null)
                            message.isShifted = Boolean(object.isShifted);
                        switch (object.rtspTransportProtocol) {
                        case "PROTOCOL_UNKNOWN":
                        case 0:
                            message.rtspTransportProtocol = 0;
                            break;
                        case "TCP":
                        case 1:
                            message.rtspTransportProtocol = 1;
                            break;
                        case "UDP":
                        case 2:
                            message.rtspTransportProtocol = 2;
                            break;
                        }
                        switch (object.downloadStatus) {
                        case "DOWNLOAD_STATUS_UNKNOWN":
                        case 0:
                            message.downloadStatus = 0;
                            break;
                        case "DOWNLOAD_NORMAL":
                        case 1:
                            message.downloadStatus = 1;
                            break;
                        case "DOWNLOAD_BROKEN":
                        case 2:
                            message.downloadStatus = 2;
                            break;
                        }
                        switch (object.retrieveVideoType) {
                        case "RETRIEVE_VIDEO_TYPE_UNKNOWN":
                        case 0:
                            message.retrieveVideoType = 0;
                            break;
                        case "RTSP":
                        case 1:
                            message.retrieveVideoType = 1;
                            break;
                        case "DOWNLOAD":
                        case 2:
                            message.retrieveVideoType = 2;
                            break;
                        }
                        if (object.useFfmpegSsFlag != null)
                            message.useFfmpegSsFlag = Boolean(object.useFfmpegSsFlag);
                        if (object.referenceCameraId != null)
                            if ($util.Long)
                                (message.referenceCameraId = $util.Long.fromValue(object.referenceCameraId)).unsigned = false;
                            else if (typeof object.referenceCameraId === "string")
                                message.referenceCameraId = parseInt(object.referenceCameraId, 10);
                            else if (typeof object.referenceCameraId === "number")
                                message.referenceCameraId = object.referenceCameraId;
                            else if (typeof object.referenceCameraId === "object")
                                message.referenceCameraId = new $util.LongBits(object.referenceCameraId.low >>> 0, object.referenceCameraId.high >>> 0).toNumber();
                        if (object.referencingCameras) {
                            if (!Array.isArray(object.referencingCameras))
                                throw TypeError(".palexy.streaming.v1.Camera.referencingCameras: array expected");
                            message.referencingCameras = [];
                            for (var i = 0; i < object.referencingCameras.length; ++i) {
                                if (typeof object.referencingCameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Camera.referencingCameras: object expected");
                                message.referencingCameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.referencingCameras[i]);
                            }
                        }
                        if (object.isEnableProcessing != null)
                            message.isEnableProcessing = Boolean(object.isEnableProcessing);
                        if (object.useStandardResolution != null)
                            message.useStandardResolution = Boolean(object.useStandardResolution);
                        if (object.tags) {
                            if (!Array.isArray(object.tags))
                                throw TypeError(".palexy.streaming.v1.Camera.tags: array expected");
                            message.tags = [];
                            for (var i = 0; i < object.tags.length; ++i)
                                switch (object.tags[i]) {
                                default:
                                case "TAG_UNKNOWN":
                                case 0:
                                    message.tags[i] = 0;
                                    break;
                                case "QC_VIDEO":
                                case 1:
                                    message.tags[i] = 1;
                                    break;
                                case "DEMO_EVENT":
                                case 2:
                                    message.tags[i] = 2;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Camera message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Camera
                     * @static
                     * @param {palexy.streaming.v1.Camera} message Camera
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Camera.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.actions = [];
                            object.preprocessingOptions = [];
                            object.subviews = [];
                            object.referencingCameras = [];
                            object.tags = [];
                        }
                        if (options.defaults) {
                            object.name = "";
                            object.username = "";
                            object.password = "";
                            object.rtspUrl = "";
                            object.cameraId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraDatabaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraDatabaseId = options.longs === String ? "0" : 0;
                            object.startTime = "";
                            object.endTime = "";
                            object.timezone = "";
                            object.transformationMatrix = null;
                            object.excludedAreas = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.areaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.areaId = options.longs === String ? "0" : 0;
                            object.area = null;
                            object.streamingState = options.enums === String ? "UNKNOWN" : 0;
                            object.streamingStateStatusMessage = "";
                            object.streamingStateLastUpdateTime = null;
                            object.lastAlertTime = null;
                            object.numAlert = 0;
                            object.streamingWorkerName = "";
                            object.streamingWorkerLastUpdateTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.cameraResolutionWidth = 0;
                            object.cameraResolutionHeight = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.versionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.versionId = options.longs === String ? "0" : 0;
                            object.shiftStatus = options.enums === String ? "SHIFT_UNKNOWN" : 0;
                            object.lastShiftCheckingTime = null;
                            object.store = null;
                            object.streamingLocation = "";
                            object.company = null;
                            object.orientation = options.enums === String ? "ORIENTATION_UNKNOWN" : 0;
                            object.type = options.enums === String ? "BASIC" : 0;
                            object.fps = "";
                            object.isDisabled = false;
                            object.useWallclockAsTimestamps = false;
                            object.firstSentLevel_2NotificationTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.parentCameraDatabaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.parentCameraDatabaseId = options.longs === String ? "0" : 0;
                            object.customStreamingTime = null;
                            object.listWeekdayCustomStreamingTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.dvrCameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.dvrCameraId = options.longs === String ? "0" : 0;
                            object.isStreamingOnly = false;
                            object.isShifted = false;
                            object.rtspTransportProtocol = options.enums === String ? "PROTOCOL_UNKNOWN" : 0;
                            object.downloadStatus = options.enums === String ? "DOWNLOAD_STATUS_UNKNOWN" : 0;
                            object.retrieveVideoType = options.enums === String ? "RETRIEVE_VIDEO_TYPE_UNKNOWN" : 0;
                            object.useFfmpegSsFlag = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.referenceCameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.referenceCameraId = options.longs === String ? "0" : 0;
                            object.isEnableProcessing = false;
                            object.useStandardResolution = false;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        if (message.rtspUrl != null && message.hasOwnProperty("rtspUrl"))
                            object.rtspUrl = message.rtspUrl;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                            if (typeof message.cameraDatabaseId === "number")
                                object.cameraDatabaseId = options.longs === String ? String(message.cameraDatabaseId) : message.cameraDatabaseId;
                            else
                                object.cameraDatabaseId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraDatabaseId) : options.longs === Number ? new $util.LongBits(message.cameraDatabaseId.low >>> 0, message.cameraDatabaseId.high >>> 0).toNumber() : message.cameraDatabaseId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.transformationMatrix != null && message.hasOwnProperty("transformationMatrix"))
                            object.transformationMatrix = $root.palexy.streaming.v1.TransformationMatrix.toObject(message.transformationMatrix, options);
                        if (message.excludedAreas != null && message.hasOwnProperty("excludedAreas"))
                            object.excludedAreas = $root.palexy.streaming.v1.ExcludedAreas.toObject(message.excludedAreas, options);
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (typeof message.areaId === "number")
                                object.areaId = options.longs === String ? String(message.areaId) : message.areaId;
                            else
                                object.areaId = options.longs === String ? $util.Long.prototype.toString.call(message.areaId) : options.longs === Number ? new $util.LongBits(message.areaId.low >>> 0, message.areaId.high >>> 0).toNumber() : message.areaId;
                        if (message.area != null && message.hasOwnProperty("area"))
                            object.area = $root.palexy.streaming.v1.Area.toObject(message.area, options);
                        if (message.streamingState != null && message.hasOwnProperty("streamingState"))
                            object.streamingState = options.enums === String ? $root.palexy.streaming.v1.Camera.StreamingState[message.streamingState] : message.streamingState;
                        if (message.streamingStateStatusMessage != null && message.hasOwnProperty("streamingStateStatusMessage"))
                            object.streamingStateStatusMessage = message.streamingStateStatusMessage;
                        if (message.streamingStateLastUpdateTime != null && message.hasOwnProperty("streamingStateLastUpdateTime"))
                            object.streamingStateLastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.streamingStateLastUpdateTime, options);
                        if (message.lastAlertTime != null && message.hasOwnProperty("lastAlertTime"))
                            object.lastAlertTime = $root.google.protobuf.Timestamp.toObject(message.lastAlertTime, options);
                        if (message.numAlert != null && message.hasOwnProperty("numAlert"))
                            object.numAlert = message.numAlert;
                        if (message.streamingWorkerName != null && message.hasOwnProperty("streamingWorkerName"))
                            object.streamingWorkerName = message.streamingWorkerName;
                        if (message.streamingWorkerLastUpdateTime != null && message.hasOwnProperty("streamingWorkerLastUpdateTime"))
                            object.streamingWorkerLastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.streamingWorkerLastUpdateTime, options);
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.cameraResolutionWidth != null && message.hasOwnProperty("cameraResolutionWidth"))
                            object.cameraResolutionWidth = message.cameraResolutionWidth;
                        if (message.cameraResolutionHeight != null && message.hasOwnProperty("cameraResolutionHeight"))
                            object.cameraResolutionHeight = message.cameraResolutionHeight;
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (typeof message.versionId === "number")
                                object.versionId = options.longs === String ? String(message.versionId) : message.versionId;
                            else
                                object.versionId = options.longs === String ? $util.Long.prototype.toString.call(message.versionId) : options.longs === Number ? new $util.LongBits(message.versionId.low >>> 0, message.versionId.high >>> 0).toNumber() : message.versionId;
                        if (message.shiftStatus != null && message.hasOwnProperty("shiftStatus"))
                            object.shiftStatus = options.enums === String ? $root.palexy.streaming.v1.Camera.ShiftStatus[message.shiftStatus] : message.shiftStatus;
                        if (message.lastShiftCheckingTime != null && message.hasOwnProperty("lastShiftCheckingTime"))
                            object.lastShiftCheckingTime = $root.google.protobuf.Timestamp.toObject(message.lastShiftCheckingTime, options);
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            object.streamingLocation = message.streamingLocation;
                        if (message.company != null && message.hasOwnProperty("company"))
                            object.company = $root.palexy.streaming.v1.Company.toObject(message.company, options);
                        if (message.actions && message.actions.length) {
                            object.actions = [];
                            for (var j = 0; j < message.actions.length; ++j)
                                object.actions[j] = options.enums === String ? $root.palexy.streaming.v1.Camera.Action[message.actions[j]] : message.actions[j];
                        }
                        if (message.orientation != null && message.hasOwnProperty("orientation"))
                            object.orientation = options.enums === String ? $root.palexy.streaming.v1.Camera.Orientation[message.orientation] : message.orientation;
                        if (message.preprocessingOptions && message.preprocessingOptions.length) {
                            object.preprocessingOptions = [];
                            for (var j = 0; j < message.preprocessingOptions.length; ++j)
                                object.preprocessingOptions[j] = $root.palexy.streaming.v1.PreprocessingOption.toObject(message.preprocessingOptions[j], options);
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.Camera.Type[message.type] : message.type;
                        if (message.subviews && message.subviews.length) {
                            object.subviews = [];
                            for (var j = 0; j < message.subviews.length; ++j)
                                object.subviews[j] = $root.palexy.streaming.v1.Camera.toObject(message.subviews[j], options);
                        }
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            object.fps = message.fps;
                        if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                            object.isDisabled = message.isDisabled;
                        if (message.useWallclockAsTimestamps != null && message.hasOwnProperty("useWallclockAsTimestamps"))
                            object.useWallclockAsTimestamps = message.useWallclockAsTimestamps;
                        if (message.firstSentLevel_2NotificationTime != null && message.hasOwnProperty("firstSentLevel_2NotificationTime"))
                            object.firstSentLevel_2NotificationTime = $root.google.protobuf.Timestamp.toObject(message.firstSentLevel_2NotificationTime, options);
                        if (message.parentCameraDatabaseId != null && message.hasOwnProperty("parentCameraDatabaseId"))
                            if (typeof message.parentCameraDatabaseId === "number")
                                object.parentCameraDatabaseId = options.longs === String ? String(message.parentCameraDatabaseId) : message.parentCameraDatabaseId;
                            else
                                object.parentCameraDatabaseId = options.longs === String ? $util.Long.prototype.toString.call(message.parentCameraDatabaseId) : options.longs === Number ? new $util.LongBits(message.parentCameraDatabaseId.low >>> 0, message.parentCameraDatabaseId.high >>> 0).toNumber() : message.parentCameraDatabaseId;
                        if (message.customStreamingTime != null && message.hasOwnProperty("customStreamingTime"))
                            object.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.toObject(message.customStreamingTime, options);
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime"))
                            object.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.toObject(message.listWeekdayCustomStreamingTime, options);
                        if (message.dvrCameraId != null && message.hasOwnProperty("dvrCameraId"))
                            if (typeof message.dvrCameraId === "number")
                                object.dvrCameraId = options.longs === String ? String(message.dvrCameraId) : message.dvrCameraId;
                            else
                                object.dvrCameraId = options.longs === String ? $util.Long.prototype.toString.call(message.dvrCameraId) : options.longs === Number ? new $util.LongBits(message.dvrCameraId.low >>> 0, message.dvrCameraId.high >>> 0).toNumber() : message.dvrCameraId;
                        if (message.isStreamingOnly != null && message.hasOwnProperty("isStreamingOnly"))
                            object.isStreamingOnly = message.isStreamingOnly;
                        if (message.isShifted != null && message.hasOwnProperty("isShifted"))
                            object.isShifted = message.isShifted;
                        if (message.rtspTransportProtocol != null && message.hasOwnProperty("rtspTransportProtocol"))
                            object.rtspTransportProtocol = options.enums === String ? $root.palexy.streaming.v1.Camera.RtspTransportProtocol[message.rtspTransportProtocol] : message.rtspTransportProtocol;
                        if (message.downloadStatus != null && message.hasOwnProperty("downloadStatus"))
                            object.downloadStatus = options.enums === String ? $root.palexy.streaming.v1.Camera.DownloadStatus[message.downloadStatus] : message.downloadStatus;
                        if (message.retrieveVideoType != null && message.hasOwnProperty("retrieveVideoType"))
                            object.retrieveVideoType = options.enums === String ? $root.palexy.streaming.v1.Camera.RetrieveVideoType[message.retrieveVideoType] : message.retrieveVideoType;
                        if (message.useFfmpegSsFlag != null && message.hasOwnProperty("useFfmpegSsFlag"))
                            object.useFfmpegSsFlag = message.useFfmpegSsFlag;
                        if (message.referenceCameraId != null && message.hasOwnProperty("referenceCameraId"))
                            if (typeof message.referenceCameraId === "number")
                                object.referenceCameraId = options.longs === String ? String(message.referenceCameraId) : message.referenceCameraId;
                            else
                                object.referenceCameraId = options.longs === String ? $util.Long.prototype.toString.call(message.referenceCameraId) : options.longs === Number ? new $util.LongBits(message.referenceCameraId.low >>> 0, message.referenceCameraId.high >>> 0).toNumber() : message.referenceCameraId;
                        if (message.referencingCameras && message.referencingCameras.length) {
                            object.referencingCameras = [];
                            for (var j = 0; j < message.referencingCameras.length; ++j)
                                object.referencingCameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.referencingCameras[j], options);
                        }
                        if (message.isEnableProcessing != null && message.hasOwnProperty("isEnableProcessing"))
                            object.isEnableProcessing = message.isEnableProcessing;
                        if (message.useStandardResolution != null && message.hasOwnProperty("useStandardResolution"))
                            object.useStandardResolution = message.useStandardResolution;
                        if (message.tags && message.tags.length) {
                            object.tags = [];
                            for (var j = 0; j < message.tags.length; ++j)
                                object.tags[j] = options.enums === String ? $root.palexy.streaming.v1.Camera.Tag[message.tags[j]] : message.tags[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Camera to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Camera
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Camera.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * RetrieveVideoType enum.
                     * @name palexy.streaming.v1.Camera.RetrieveVideoType
                     * @enum {number}
                     * @property {number} RETRIEVE_VIDEO_TYPE_UNKNOWN=0 RETRIEVE_VIDEO_TYPE_UNKNOWN value
                     * @property {number} RTSP=1 RTSP value
                     * @property {number} DOWNLOAD=2 DOWNLOAD value
                     */
                    Camera.RetrieveVideoType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "RETRIEVE_VIDEO_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "RTSP"] = 1;
                        values[valuesById[2] = "DOWNLOAD"] = 2;
                        return values;
                    })();
    
                    /**
                     * StreamingState enum.
                     * @name palexy.streaming.v1.Camera.StreamingState
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} NORMAL=1 NORMAL value
                     * @property {number} BROKEN=2 BROKEN value
                     */
                    Camera.StreamingState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "NORMAL"] = 1;
                        values[valuesById[2] = "BROKEN"] = 2;
                        return values;
                    })();
    
                    /**
                     * DownloadStatus enum.
                     * @name palexy.streaming.v1.Camera.DownloadStatus
                     * @enum {number}
                     * @property {number} DOWNLOAD_STATUS_UNKNOWN=0 DOWNLOAD_STATUS_UNKNOWN value
                     * @property {number} DOWNLOAD_NORMAL=1 DOWNLOAD_NORMAL value
                     * @property {number} DOWNLOAD_BROKEN=2 DOWNLOAD_BROKEN value
                     */
                    Camera.DownloadStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DOWNLOAD_STATUS_UNKNOWN"] = 0;
                        values[valuesById[1] = "DOWNLOAD_NORMAL"] = 1;
                        values[valuesById[2] = "DOWNLOAD_BROKEN"] = 2;
                        return values;
                    })();
    
                    /**
                     * ShiftStatus enum.
                     * @name palexy.streaming.v1.Camera.ShiftStatus
                     * @enum {number}
                     * @property {number} SHIFT_UNKNOWN=0 SHIFT_UNKNOWN value
                     * @property {number} SHIFTED=1 SHIFTED value
                     * @property {number} NOT_SHIFTED=2 NOT_SHIFTED value
                     */
                    Camera.ShiftStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SHIFT_UNKNOWN"] = 0;
                        values[valuesById[1] = "SHIFTED"] = 1;
                        values[valuesById[2] = "NOT_SHIFTED"] = 2;
                        return values;
                    })();
    
                    /**
                     * Action enum.
                     * @name palexy.streaming.v1.Camera.Action
                     * @enum {number}
                     * @property {number} ACTION_UNKNOWN=0 ACTION_UNKNOWN value
                     * @property {number} ENTRANCE=1 ENTRANCE value
                     * @property {number} QUEUE_TIME=2 QUEUE_TIME value
                     * @property {number} SECTION=3 SECTION value
                     * @property {number} PASS_BY=4 PASS_BY value
                     * @property {number} DEFAULT=5 DEFAULT value
                     * @property {number} WIDE_SPACE_ENTRANCE=6 WIDE_SPACE_ENTRANCE value
                     */
                    Camera.Action = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ACTION_UNKNOWN"] = 0;
                        values[valuesById[1] = "ENTRANCE"] = 1;
                        values[valuesById[2] = "QUEUE_TIME"] = 2;
                        values[valuesById[3] = "SECTION"] = 3;
                        values[valuesById[4] = "PASS_BY"] = 4;
                        values[valuesById[5] = "DEFAULT"] = 5;
                        values[valuesById[6] = "WIDE_SPACE_ENTRANCE"] = 6;
                        return values;
                    })();
    
                    /**
                     * Orientation enum.
                     * @name palexy.streaming.v1.Camera.Orientation
                     * @enum {number}
                     * @property {number} ORIENTATION_UNKNOWN=0 ORIENTATION_UNKNOWN value
                     * @property {number} ROTATE_0=1 ROTATE_0 value
                     * @property {number} ROTATE_90_CLOCKWISE=2 ROTATE_90_CLOCKWISE value
                     * @property {number} ROTATE_90_COUNTERCLOCKWISE=3 ROTATE_90_COUNTERCLOCKWISE value
                     * @property {number} ROTATE_180=4 ROTATE_180 value
                     */
                    Camera.Orientation = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ORIENTATION_UNKNOWN"] = 0;
                        values[valuesById[1] = "ROTATE_0"] = 1;
                        values[valuesById[2] = "ROTATE_90_CLOCKWISE"] = 2;
                        values[valuesById[3] = "ROTATE_90_COUNTERCLOCKWISE"] = 3;
                        values[valuesById[4] = "ROTATE_180"] = 4;
                        return values;
                    })();
    
                    /**
                     * Type enum.
                     * @name palexy.streaming.v1.Camera.Type
                     * @enum {number}
                     * @property {number} BASIC=0 BASIC value
                     * @property {number} FISHEYE=1 FISHEYE value
                     * @property {number} FISHEYE_SUBVIEW=2 FISHEYE_SUBVIEW value
                     */
                    Camera.Type = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "BASIC"] = 0;
                        values[valuesById[1] = "FISHEYE"] = 1;
                        values[valuesById[2] = "FISHEYE_SUBVIEW"] = 2;
                        return values;
                    })();
    
                    /**
                     * RtspTransportProtocol enum.
                     * @name palexy.streaming.v1.Camera.RtspTransportProtocol
                     * @enum {number}
                     * @property {number} PROTOCOL_UNKNOWN=0 PROTOCOL_UNKNOWN value
                     * @property {number} TCP=1 TCP value
                     * @property {number} UDP=2 UDP value
                     */
                    Camera.RtspTransportProtocol = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PROTOCOL_UNKNOWN"] = 0;
                        values[valuesById[1] = "TCP"] = 1;
                        values[valuesById[2] = "UDP"] = 2;
                        return values;
                    })();
    
                    /**
                     * Tag enum.
                     * @name palexy.streaming.v1.Camera.Tag
                     * @enum {number}
                     * @property {number} TAG_UNKNOWN=0 TAG_UNKNOWN value
                     * @property {number} QC_VIDEO=1 QC_VIDEO value
                     * @property {number} DEMO_EVENT=2 DEMO_EVENT value
                     */
                    Camera.Tag = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TAG_UNKNOWN"] = 0;
                        values[valuesById[1] = "QC_VIDEO"] = 1;
                        values[valuesById[2] = "DEMO_EVENT"] = 2;
                        return values;
                    })();
    
                    return Camera;
                })();
    
                v1.StreamingTime = (function() {
    
                    /**
                     * Properties of a StreamingTime.
                     * @memberof palexy.streaming.v1
                     * @interface IStreamingTime
                     * @property {string|null} [startTime] StreamingTime startTime
                     * @property {string|null} [endTime] StreamingTime endTime
                     */
    
                    /**
                     * Constructs a new StreamingTime.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StreamingTime.
                     * @implements IStreamingTime
                     * @constructor
                     * @param {palexy.streaming.v1.IStreamingTime=} [properties] Properties to set
                     */
                    function StreamingTime(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StreamingTime startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @instance
                     */
                    StreamingTime.prototype.startTime = "";
    
                    /**
                     * StreamingTime endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @instance
                     */
                    StreamingTime.prototype.endTime = "";
    
                    /**
                     * Creates a new StreamingTime instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IStreamingTime=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StreamingTime} StreamingTime instance
                     */
                    StreamingTime.create = function create(properties) {
                        return new StreamingTime(properties);
                    };
    
                    /**
                     * Encodes the specified StreamingTime message. Does not implicitly {@link palexy.streaming.v1.StreamingTime.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IStreamingTime} message StreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StreamingTime.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StreamingTime message, length delimited. Does not implicitly {@link palexy.streaming.v1.StreamingTime.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IStreamingTime} message StreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StreamingTime.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StreamingTime message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StreamingTime} StreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StreamingTime.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StreamingTime();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startTime = reader.string();
                                break;
                            case 2:
                                message.endTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StreamingTime message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StreamingTime} StreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StreamingTime.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StreamingTime message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StreamingTime.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StreamingTime message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StreamingTime} StreamingTime
                     */
                    StreamingTime.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StreamingTime)
                            return object;
                        var message = new $root.palexy.streaming.v1.StreamingTime();
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StreamingTime message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @static
                     * @param {palexy.streaming.v1.StreamingTime} message StreamingTime
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StreamingTime.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startTime = "";
                            object.endTime = "";
                        }
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        return object;
                    };
    
                    /**
                     * Converts this StreamingTime to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StreamingTime
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StreamingTime.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StreamingTime;
                })();
    
                v1.CustomStreamingTime = (function() {
    
                    /**
                     * Properties of a CustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [mondayStreamingTime] CustomStreamingTime mondayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [tuesdayStreamingTime] CustomStreamingTime tuesdayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [wednesdayStreamingTime] CustomStreamingTime wednesdayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [thursdayStreamingTime] CustomStreamingTime thursdayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [fridayStreamingTime] CustomStreamingTime fridayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [saturdayStreamingTime] CustomStreamingTime saturdayStreamingTime
                     * @property {palexy.streaming.v1.IStreamingTime|null} [sundayStreamingTime] CustomStreamingTime sundayStreamingTime
                     */
    
                    /**
                     * Constructs a new CustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomStreamingTime.
                     * @implements ICustomStreamingTime
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomStreamingTime=} [properties] Properties to set
                     */
                    function CustomStreamingTime(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomStreamingTime mondayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} mondayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.mondayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime tuesdayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} tuesdayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.tuesdayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime wednesdayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} wednesdayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.wednesdayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime thursdayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} thursdayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.thursdayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime fridayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} fridayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.fridayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime saturdayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} saturdayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.saturdayStreamingTime = null;
    
                    /**
                     * CustomStreamingTime sundayStreamingTime.
                     * @member {palexy.streaming.v1.IStreamingTime|null|undefined} sundayStreamingTime
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     */
                    CustomStreamingTime.prototype.sundayStreamingTime = null;
    
                    /**
                     * Creates a new CustomStreamingTime instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.ICustomStreamingTime=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomStreamingTime} CustomStreamingTime instance
                     */
                    CustomStreamingTime.create = function create(properties) {
                        return new CustomStreamingTime(properties);
                    };
    
                    /**
                     * Encodes the specified CustomStreamingTime message. Does not implicitly {@link palexy.streaming.v1.CustomStreamingTime.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.ICustomStreamingTime} message CustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomStreamingTime.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mondayStreamingTime != null && Object.hasOwnProperty.call(message, "mondayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.mondayStreamingTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.tuesdayStreamingTime != null && Object.hasOwnProperty.call(message, "tuesdayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.tuesdayStreamingTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.wednesdayStreamingTime != null && Object.hasOwnProperty.call(message, "wednesdayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.wednesdayStreamingTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.thursdayStreamingTime != null && Object.hasOwnProperty.call(message, "thursdayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.thursdayStreamingTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.fridayStreamingTime != null && Object.hasOwnProperty.call(message, "fridayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.fridayStreamingTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.saturdayStreamingTime != null && Object.hasOwnProperty.call(message, "saturdayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.saturdayStreamingTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.sundayStreamingTime != null && Object.hasOwnProperty.call(message, "sundayStreamingTime"))
                            $root.palexy.streaming.v1.StreamingTime.encode(message.sundayStreamingTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomStreamingTime message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomStreamingTime.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.ICustomStreamingTime} message CustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomStreamingTime.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomStreamingTime message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomStreamingTime} CustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomStreamingTime.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomStreamingTime();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mondayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.tuesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.wednesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.thursdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.fridayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.saturdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.sundayStreamingTime = $root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomStreamingTime message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomStreamingTime} CustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomStreamingTime.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomStreamingTime message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomStreamingTime.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mondayStreamingTime != null && message.hasOwnProperty("mondayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.mondayStreamingTime);
                            if (error)
                                return "mondayStreamingTime." + error;
                        }
                        if (message.tuesdayStreamingTime != null && message.hasOwnProperty("tuesdayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.tuesdayStreamingTime);
                            if (error)
                                return "tuesdayStreamingTime." + error;
                        }
                        if (message.wednesdayStreamingTime != null && message.hasOwnProperty("wednesdayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.wednesdayStreamingTime);
                            if (error)
                                return "wednesdayStreamingTime." + error;
                        }
                        if (message.thursdayStreamingTime != null && message.hasOwnProperty("thursdayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.thursdayStreamingTime);
                            if (error)
                                return "thursdayStreamingTime." + error;
                        }
                        if (message.fridayStreamingTime != null && message.hasOwnProperty("fridayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.fridayStreamingTime);
                            if (error)
                                return "fridayStreamingTime." + error;
                        }
                        if (message.saturdayStreamingTime != null && message.hasOwnProperty("saturdayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.saturdayStreamingTime);
                            if (error)
                                return "saturdayStreamingTime." + error;
                        }
                        if (message.sundayStreamingTime != null && message.hasOwnProperty("sundayStreamingTime")) {
                            var error = $root.palexy.streaming.v1.StreamingTime.verify(message.sundayStreamingTime);
                            if (error)
                                return "sundayStreamingTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CustomStreamingTime message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomStreamingTime} CustomStreamingTime
                     */
                    CustomStreamingTime.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomStreamingTime)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomStreamingTime();
                        if (object.mondayStreamingTime != null) {
                            if (typeof object.mondayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.mondayStreamingTime: object expected");
                            message.mondayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.mondayStreamingTime);
                        }
                        if (object.tuesdayStreamingTime != null) {
                            if (typeof object.tuesdayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.tuesdayStreamingTime: object expected");
                            message.tuesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.tuesdayStreamingTime);
                        }
                        if (object.wednesdayStreamingTime != null) {
                            if (typeof object.wednesdayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.wednesdayStreamingTime: object expected");
                            message.wednesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.wednesdayStreamingTime);
                        }
                        if (object.thursdayStreamingTime != null) {
                            if (typeof object.thursdayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.thursdayStreamingTime: object expected");
                            message.thursdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.thursdayStreamingTime);
                        }
                        if (object.fridayStreamingTime != null) {
                            if (typeof object.fridayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.fridayStreamingTime: object expected");
                            message.fridayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.fridayStreamingTime);
                        }
                        if (object.saturdayStreamingTime != null) {
                            if (typeof object.saturdayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.saturdayStreamingTime: object expected");
                            message.saturdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.saturdayStreamingTime);
                        }
                        if (object.sundayStreamingTime != null) {
                            if (typeof object.sundayStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStreamingTime.sundayStreamingTime: object expected");
                            message.sundayStreamingTime = $root.palexy.streaming.v1.StreamingTime.fromObject(object.sundayStreamingTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomStreamingTime message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.CustomStreamingTime} message CustomStreamingTime
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomStreamingTime.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mondayStreamingTime = null;
                            object.tuesdayStreamingTime = null;
                            object.wednesdayStreamingTime = null;
                            object.thursdayStreamingTime = null;
                            object.fridayStreamingTime = null;
                            object.saturdayStreamingTime = null;
                            object.sundayStreamingTime = null;
                        }
                        if (message.mondayStreamingTime != null && message.hasOwnProperty("mondayStreamingTime"))
                            object.mondayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.mondayStreamingTime, options);
                        if (message.tuesdayStreamingTime != null && message.hasOwnProperty("tuesdayStreamingTime"))
                            object.tuesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.tuesdayStreamingTime, options);
                        if (message.wednesdayStreamingTime != null && message.hasOwnProperty("wednesdayStreamingTime"))
                            object.wednesdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.wednesdayStreamingTime, options);
                        if (message.thursdayStreamingTime != null && message.hasOwnProperty("thursdayStreamingTime"))
                            object.thursdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.thursdayStreamingTime, options);
                        if (message.fridayStreamingTime != null && message.hasOwnProperty("fridayStreamingTime"))
                            object.fridayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.fridayStreamingTime, options);
                        if (message.saturdayStreamingTime != null && message.hasOwnProperty("saturdayStreamingTime"))
                            object.saturdayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.saturdayStreamingTime, options);
                        if (message.sundayStreamingTime != null && message.hasOwnProperty("sundayStreamingTime"))
                            object.sundayStreamingTime = $root.palexy.streaming.v1.StreamingTime.toObject(message.sundayStreamingTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this CustomStreamingTime to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomStreamingTime
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomStreamingTime.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomStreamingTime;
                })();
    
                v1.WeekdayCustomStreamingTime = (function() {
    
                    /**
                     * Properties of a WeekdayCustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @interface IWeekdayCustomStreamingTime
                     * @property {palexy.streaming.v1.WeekdayCustomStreamingTime.DayOfWeek|null} [dayOfWeek] WeekdayCustomStreamingTime dayOfWeek
                     * @property {Array.<palexy.streaming.v1.IStreamingTime>|null} [streamingTimes] WeekdayCustomStreamingTime streamingTimes
                     */
    
                    /**
                     * Constructs a new WeekdayCustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WeekdayCustomStreamingTime.
                     * @implements IWeekdayCustomStreamingTime
                     * @constructor
                     * @param {palexy.streaming.v1.IWeekdayCustomStreamingTime=} [properties] Properties to set
                     */
                    function WeekdayCustomStreamingTime(properties) {
                        this.streamingTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WeekdayCustomStreamingTime dayOfWeek.
                     * @member {palexy.streaming.v1.WeekdayCustomStreamingTime.DayOfWeek} dayOfWeek
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @instance
                     */
                    WeekdayCustomStreamingTime.prototype.dayOfWeek = 0;
    
                    /**
                     * WeekdayCustomStreamingTime streamingTimes.
                     * @member {Array.<palexy.streaming.v1.IStreamingTime>} streamingTimes
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @instance
                     */
                    WeekdayCustomStreamingTime.prototype.streamingTimes = $util.emptyArray;
    
                    /**
                     * Creates a new WeekdayCustomStreamingTime instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IWeekdayCustomStreamingTime=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.WeekdayCustomStreamingTime} WeekdayCustomStreamingTime instance
                     */
                    WeekdayCustomStreamingTime.create = function create(properties) {
                        return new WeekdayCustomStreamingTime(properties);
                    };
    
                    /**
                     * Encodes the specified WeekdayCustomStreamingTime message. Does not implicitly {@link palexy.streaming.v1.WeekdayCustomStreamingTime.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IWeekdayCustomStreamingTime} message WeekdayCustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WeekdayCustomStreamingTime.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dayOfWeek != null && Object.hasOwnProperty.call(message, "dayOfWeek"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dayOfWeek);
                        if (message.streamingTimes != null && message.streamingTimes.length)
                            for (var i = 0; i < message.streamingTimes.length; ++i)
                                $root.palexy.streaming.v1.StreamingTime.encode(message.streamingTimes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WeekdayCustomStreamingTime message, length delimited. Does not implicitly {@link palexy.streaming.v1.WeekdayCustomStreamingTime.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IWeekdayCustomStreamingTime} message WeekdayCustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WeekdayCustomStreamingTime.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WeekdayCustomStreamingTime message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.WeekdayCustomStreamingTime} WeekdayCustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WeekdayCustomStreamingTime.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.WeekdayCustomStreamingTime();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dayOfWeek = reader.int32();
                                break;
                            case 2:
                                if (!(message.streamingTimes && message.streamingTimes.length))
                                    message.streamingTimes = [];
                                message.streamingTimes.push($root.palexy.streaming.v1.StreamingTime.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WeekdayCustomStreamingTime message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.WeekdayCustomStreamingTime} WeekdayCustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WeekdayCustomStreamingTime.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WeekdayCustomStreamingTime message.
                     * @function verify
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WeekdayCustomStreamingTime.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                            switch (message.dayOfWeek) {
                            default:
                                return "dayOfWeek: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.streamingTimes != null && message.hasOwnProperty("streamingTimes")) {
                            if (!Array.isArray(message.streamingTimes))
                                return "streamingTimes: array expected";
                            for (var i = 0; i < message.streamingTimes.length; ++i) {
                                var error = $root.palexy.streaming.v1.StreamingTime.verify(message.streamingTimes[i]);
                                if (error)
                                    return "streamingTimes." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a WeekdayCustomStreamingTime message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.WeekdayCustomStreamingTime} WeekdayCustomStreamingTime
                     */
                    WeekdayCustomStreamingTime.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.WeekdayCustomStreamingTime)
                            return object;
                        var message = new $root.palexy.streaming.v1.WeekdayCustomStreamingTime();
                        switch (object.dayOfWeek) {
                        case "DAY_OF_WEEK_UNSPECIFIED":
                        case 0:
                            message.dayOfWeek = 0;
                            break;
                        case "MONDAY":
                        case 1:
                            message.dayOfWeek = 1;
                            break;
                        case "TUESDAY":
                        case 2:
                            message.dayOfWeek = 2;
                            break;
                        case "WEDNESDAY":
                        case 3:
                            message.dayOfWeek = 3;
                            break;
                        case "THURSDAY":
                        case 4:
                            message.dayOfWeek = 4;
                            break;
                        case "FRIDAY":
                        case 5:
                            message.dayOfWeek = 5;
                            break;
                        case "SATURDAY":
                        case 6:
                            message.dayOfWeek = 6;
                            break;
                        case "SUNDAY":
                        case 7:
                            message.dayOfWeek = 7;
                            break;
                        }
                        if (object.streamingTimes) {
                            if (!Array.isArray(object.streamingTimes))
                                throw TypeError(".palexy.streaming.v1.WeekdayCustomStreamingTime.streamingTimes: array expected");
                            message.streamingTimes = [];
                            for (var i = 0; i < object.streamingTimes.length; ++i) {
                                if (typeof object.streamingTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.WeekdayCustomStreamingTime.streamingTimes: object expected");
                                message.streamingTimes[i] = $root.palexy.streaming.v1.StreamingTime.fromObject(object.streamingTimes[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WeekdayCustomStreamingTime message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.WeekdayCustomStreamingTime} message WeekdayCustomStreamingTime
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WeekdayCustomStreamingTime.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.streamingTimes = [];
                        if (options.defaults)
                            object.dayOfWeek = options.enums === String ? "DAY_OF_WEEK_UNSPECIFIED" : 0;
                        if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                            object.dayOfWeek = options.enums === String ? $root.palexy.streaming.v1.WeekdayCustomStreamingTime.DayOfWeek[message.dayOfWeek] : message.dayOfWeek;
                        if (message.streamingTimes && message.streamingTimes.length) {
                            object.streamingTimes = [];
                            for (var j = 0; j < message.streamingTimes.length; ++j)
                                object.streamingTimes[j] = $root.palexy.streaming.v1.StreamingTime.toObject(message.streamingTimes[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this WeekdayCustomStreamingTime to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.WeekdayCustomStreamingTime
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WeekdayCustomStreamingTime.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * DayOfWeek enum.
                     * @name palexy.streaming.v1.WeekdayCustomStreamingTime.DayOfWeek
                     * @enum {number}
                     * @property {number} DAY_OF_WEEK_UNSPECIFIED=0 DAY_OF_WEEK_UNSPECIFIED value
                     * @property {number} MONDAY=1 MONDAY value
                     * @property {number} TUESDAY=2 TUESDAY value
                     * @property {number} WEDNESDAY=3 WEDNESDAY value
                     * @property {number} THURSDAY=4 THURSDAY value
                     * @property {number} FRIDAY=5 FRIDAY value
                     * @property {number} SATURDAY=6 SATURDAY value
                     * @property {number} SUNDAY=7 SUNDAY value
                     */
                    WeekdayCustomStreamingTime.DayOfWeek = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DAY_OF_WEEK_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "MONDAY"] = 1;
                        values[valuesById[2] = "TUESDAY"] = 2;
                        values[valuesById[3] = "WEDNESDAY"] = 3;
                        values[valuesById[4] = "THURSDAY"] = 4;
                        values[valuesById[5] = "FRIDAY"] = 5;
                        values[valuesById[6] = "SATURDAY"] = 6;
                        values[valuesById[7] = "SUNDAY"] = 7;
                        return values;
                    })();
    
                    return WeekdayCustomStreamingTime;
                })();
    
                v1.ListWeekdayCustomStreamingTime = (function() {
    
                    /**
                     * Properties of a ListWeekdayCustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @interface IListWeekdayCustomStreamingTime
                     * @property {Array.<palexy.streaming.v1.IWeekdayCustomStreamingTime>|null} [weekdayCustomStreamingTimes] ListWeekdayCustomStreamingTime weekdayCustomStreamingTimes
                     */
    
                    /**
                     * Constructs a new ListWeekdayCustomStreamingTime.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListWeekdayCustomStreamingTime.
                     * @implements IListWeekdayCustomStreamingTime
                     * @constructor
                     * @param {palexy.streaming.v1.IListWeekdayCustomStreamingTime=} [properties] Properties to set
                     */
                    function ListWeekdayCustomStreamingTime(properties) {
                        this.weekdayCustomStreamingTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListWeekdayCustomStreamingTime weekdayCustomStreamingTimes.
                     * @member {Array.<palexy.streaming.v1.IWeekdayCustomStreamingTime>} weekdayCustomStreamingTimes
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @instance
                     */
                    ListWeekdayCustomStreamingTime.prototype.weekdayCustomStreamingTimes = $util.emptyArray;
    
                    /**
                     * Creates a new ListWeekdayCustomStreamingTime instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IListWeekdayCustomStreamingTime=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListWeekdayCustomStreamingTime} ListWeekdayCustomStreamingTime instance
                     */
                    ListWeekdayCustomStreamingTime.create = function create(properties) {
                        return new ListWeekdayCustomStreamingTime(properties);
                    };
    
                    /**
                     * Encodes the specified ListWeekdayCustomStreamingTime message. Does not implicitly {@link palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IListWeekdayCustomStreamingTime} message ListWeekdayCustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWeekdayCustomStreamingTime.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.weekdayCustomStreamingTimes != null && message.weekdayCustomStreamingTimes.length)
                            for (var i = 0; i < message.weekdayCustomStreamingTimes.length; ++i)
                                $root.palexy.streaming.v1.WeekdayCustomStreamingTime.encode(message.weekdayCustomStreamingTimes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListWeekdayCustomStreamingTime message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.IListWeekdayCustomStreamingTime} message ListWeekdayCustomStreamingTime message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListWeekdayCustomStreamingTime.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListWeekdayCustomStreamingTime message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListWeekdayCustomStreamingTime} ListWeekdayCustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWeekdayCustomStreamingTime.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.weekdayCustomStreamingTimes && message.weekdayCustomStreamingTimes.length))
                                    message.weekdayCustomStreamingTimes = [];
                                message.weekdayCustomStreamingTimes.push($root.palexy.streaming.v1.WeekdayCustomStreamingTime.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListWeekdayCustomStreamingTime message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListWeekdayCustomStreamingTime} ListWeekdayCustomStreamingTime
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListWeekdayCustomStreamingTime.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListWeekdayCustomStreamingTime message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListWeekdayCustomStreamingTime.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.weekdayCustomStreamingTimes != null && message.hasOwnProperty("weekdayCustomStreamingTimes")) {
                            if (!Array.isArray(message.weekdayCustomStreamingTimes))
                                return "weekdayCustomStreamingTimes: array expected";
                            for (var i = 0; i < message.weekdayCustomStreamingTimes.length; ++i) {
                                var error = $root.palexy.streaming.v1.WeekdayCustomStreamingTime.verify(message.weekdayCustomStreamingTimes[i]);
                                if (error)
                                    return "weekdayCustomStreamingTimes." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListWeekdayCustomStreamingTime message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListWeekdayCustomStreamingTime} ListWeekdayCustomStreamingTime
                     */
                    ListWeekdayCustomStreamingTime.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime();
                        if (object.weekdayCustomStreamingTimes) {
                            if (!Array.isArray(object.weekdayCustomStreamingTimes))
                                throw TypeError(".palexy.streaming.v1.ListWeekdayCustomStreamingTime.weekdayCustomStreamingTimes: array expected");
                            message.weekdayCustomStreamingTimes = [];
                            for (var i = 0; i < object.weekdayCustomStreamingTimes.length; ++i) {
                                if (typeof object.weekdayCustomStreamingTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListWeekdayCustomStreamingTime.weekdayCustomStreamingTimes: object expected");
                                message.weekdayCustomStreamingTimes[i] = $root.palexy.streaming.v1.WeekdayCustomStreamingTime.fromObject(object.weekdayCustomStreamingTimes[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListWeekdayCustomStreamingTime message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @static
                     * @param {palexy.streaming.v1.ListWeekdayCustomStreamingTime} message ListWeekdayCustomStreamingTime
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListWeekdayCustomStreamingTime.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.weekdayCustomStreamingTimes = [];
                        if (message.weekdayCustomStreamingTimes && message.weekdayCustomStreamingTimes.length) {
                            object.weekdayCustomStreamingTimes = [];
                            for (var j = 0; j < message.weekdayCustomStreamingTimes.length; ++j)
                                object.weekdayCustomStreamingTimes[j] = $root.palexy.streaming.v1.WeekdayCustomStreamingTime.toObject(message.weekdayCustomStreamingTimes[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListWeekdayCustomStreamingTime to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListWeekdayCustomStreamingTime
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListWeekdayCustomStreamingTime.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListWeekdayCustomStreamingTime;
                })();
    
                v1.PreprocessingOption = (function() {
    
                    /**
                     * Properties of a PreprocessingOption.
                     * @memberof palexy.streaming.v1
                     * @interface IPreprocessingOption
                     * @property {palexy.streaming.v1.IWarpOption|null} [warpOption] PreprocessingOption warpOption
                     */
    
                    /**
                     * Constructs a new PreprocessingOption.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PreprocessingOption.
                     * @implements IPreprocessingOption
                     * @constructor
                     * @param {palexy.streaming.v1.IPreprocessingOption=} [properties] Properties to set
                     */
                    function PreprocessingOption(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PreprocessingOption warpOption.
                     * @member {palexy.streaming.v1.IWarpOption|null|undefined} warpOption
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @instance
                     */
                    PreprocessingOption.prototype.warpOption = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * PreprocessingOption option.
                     * @member {"warpOption"|undefined} option
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @instance
                     */
                    Object.defineProperty(PreprocessingOption.prototype, "option", {
                        get: $util.oneOfGetter($oneOfFields = ["warpOption"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new PreprocessingOption instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {palexy.streaming.v1.IPreprocessingOption=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PreprocessingOption} PreprocessingOption instance
                     */
                    PreprocessingOption.create = function create(properties) {
                        return new PreprocessingOption(properties);
                    };
    
                    /**
                     * Encodes the specified PreprocessingOption message. Does not implicitly {@link palexy.streaming.v1.PreprocessingOption.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {palexy.streaming.v1.IPreprocessingOption} message PreprocessingOption message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreprocessingOption.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.warpOption != null && Object.hasOwnProperty.call(message, "warpOption"))
                            $root.palexy.streaming.v1.WarpOption.encode(message.warpOption, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PreprocessingOption message, length delimited. Does not implicitly {@link palexy.streaming.v1.PreprocessingOption.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {palexy.streaming.v1.IPreprocessingOption} message PreprocessingOption message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreprocessingOption.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PreprocessingOption message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PreprocessingOption} PreprocessingOption
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreprocessingOption.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PreprocessingOption();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.warpOption = $root.palexy.streaming.v1.WarpOption.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PreprocessingOption message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PreprocessingOption} PreprocessingOption
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreprocessingOption.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PreprocessingOption message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PreprocessingOption.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.warpOption != null && message.hasOwnProperty("warpOption")) {
                            properties.option = 1;
                            {
                                var error = $root.palexy.streaming.v1.WarpOption.verify(message.warpOption);
                                if (error)
                                    return "warpOption." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PreprocessingOption message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PreprocessingOption} PreprocessingOption
                     */
                    PreprocessingOption.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PreprocessingOption)
                            return object;
                        var message = new $root.palexy.streaming.v1.PreprocessingOption();
                        if (object.warpOption != null) {
                            if (typeof object.warpOption !== "object")
                                throw TypeError(".palexy.streaming.v1.PreprocessingOption.warpOption: object expected");
                            message.warpOption = $root.palexy.streaming.v1.WarpOption.fromObject(object.warpOption);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PreprocessingOption message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @static
                     * @param {palexy.streaming.v1.PreprocessingOption} message PreprocessingOption
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PreprocessingOption.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.warpOption != null && message.hasOwnProperty("warpOption")) {
                            object.warpOption = $root.palexy.streaming.v1.WarpOption.toObject(message.warpOption, options);
                            if (options.oneofs)
                                object.option = "warpOption";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PreprocessingOption to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PreprocessingOption
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PreprocessingOption.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PreprocessingOption;
                })();
    
                v1.WarpOption = (function() {
    
                    /**
                     * Properties of a WarpOption.
                     * @memberof palexy.streaming.v1
                     * @interface IWarpOption
                     * @property {number|null} [ihFov] WarpOption ihFov
                     * @property {number|null} [ivFov] WarpOption ivFov
                     * @property {number|null} [hFov] WarpOption hFov
                     * @property {number|null} [vFov] WarpOption vFov
                     * @property {number|null} [width] WarpOption width
                     * @property {number|null} [height] WarpOption height
                     * @property {number|null} [yaw] WarpOption yaw
                     * @property {number|null} [pitch] WarpOption pitch
                     * @property {number|null} [roll] WarpOption roll
                     */
    
                    /**
                     * Constructs a new WarpOption.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WarpOption.
                     * @implements IWarpOption
                     * @constructor
                     * @param {palexy.streaming.v1.IWarpOption=} [properties] Properties to set
                     */
                    function WarpOption(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WarpOption ihFov.
                     * @member {number} ihFov
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.ihFov = 0;
    
                    /**
                     * WarpOption ivFov.
                     * @member {number} ivFov
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.ivFov = 0;
    
                    /**
                     * WarpOption hFov.
                     * @member {number} hFov
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.hFov = 0;
    
                    /**
                     * WarpOption vFov.
                     * @member {number} vFov
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.vFov = 0;
    
                    /**
                     * WarpOption width.
                     * @member {number} width
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.width = 0;
    
                    /**
                     * WarpOption height.
                     * @member {number} height
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.height = 0;
    
                    /**
                     * WarpOption yaw.
                     * @member {number} yaw
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.yaw = 0;
    
                    /**
                     * WarpOption pitch.
                     * @member {number} pitch
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.pitch = 0;
    
                    /**
                     * WarpOption roll.
                     * @member {number} roll
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     */
                    WarpOption.prototype.roll = 0;
    
                    /**
                     * Creates a new WarpOption instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {palexy.streaming.v1.IWarpOption=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.WarpOption} WarpOption instance
                     */
                    WarpOption.create = function create(properties) {
                        return new WarpOption(properties);
                    };
    
                    /**
                     * Encodes the specified WarpOption message. Does not implicitly {@link palexy.streaming.v1.WarpOption.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {palexy.streaming.v1.IWarpOption} message WarpOption message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WarpOption.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ihFov != null && Object.hasOwnProperty.call(message, "ihFov"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ihFov);
                        if (message.ivFov != null && Object.hasOwnProperty.call(message, "ivFov"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ivFov);
                        if (message.hFov != null && Object.hasOwnProperty.call(message, "hFov"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.hFov);
                        if (message.vFov != null && Object.hasOwnProperty.call(message, "vFov"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.vFov);
                        if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.width);
                        if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.height);
                        if (message.yaw != null && Object.hasOwnProperty.call(message, "yaw"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.yaw);
                        if (message.pitch != null && Object.hasOwnProperty.call(message, "pitch"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.pitch);
                        if (message.roll != null && Object.hasOwnProperty.call(message, "roll"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.roll);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WarpOption message, length delimited. Does not implicitly {@link palexy.streaming.v1.WarpOption.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {palexy.streaming.v1.IWarpOption} message WarpOption message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WarpOption.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WarpOption message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.WarpOption} WarpOption
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WarpOption.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.WarpOption();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.ihFov = reader.int32();
                                break;
                            case 2:
                                message.ivFov = reader.int32();
                                break;
                            case 3:
                                message.hFov = reader.int32();
                                break;
                            case 4:
                                message.vFov = reader.int32();
                                break;
                            case 5:
                                message.width = reader.int32();
                                break;
                            case 6:
                                message.height = reader.int32();
                                break;
                            case 7:
                                message.yaw = reader.int32();
                                break;
                            case 8:
                                message.pitch = reader.int32();
                                break;
                            case 9:
                                message.roll = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WarpOption message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.WarpOption} WarpOption
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WarpOption.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WarpOption message.
                     * @function verify
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WarpOption.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ihFov != null && message.hasOwnProperty("ihFov"))
                            if (!$util.isInteger(message.ihFov))
                                return "ihFov: integer expected";
                        if (message.ivFov != null && message.hasOwnProperty("ivFov"))
                            if (!$util.isInteger(message.ivFov))
                                return "ivFov: integer expected";
                        if (message.hFov != null && message.hasOwnProperty("hFov"))
                            if (!$util.isInteger(message.hFov))
                                return "hFov: integer expected";
                        if (message.vFov != null && message.hasOwnProperty("vFov"))
                            if (!$util.isInteger(message.vFov))
                                return "vFov: integer expected";
                        if (message.width != null && message.hasOwnProperty("width"))
                            if (!$util.isInteger(message.width))
                                return "width: integer expected";
                        if (message.height != null && message.hasOwnProperty("height"))
                            if (!$util.isInteger(message.height))
                                return "height: integer expected";
                        if (message.yaw != null && message.hasOwnProperty("yaw"))
                            if (!$util.isInteger(message.yaw))
                                return "yaw: integer expected";
                        if (message.pitch != null && message.hasOwnProperty("pitch"))
                            if (!$util.isInteger(message.pitch))
                                return "pitch: integer expected";
                        if (message.roll != null && message.hasOwnProperty("roll"))
                            if (!$util.isInteger(message.roll))
                                return "roll: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a WarpOption message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.WarpOption} WarpOption
                     */
                    WarpOption.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.WarpOption)
                            return object;
                        var message = new $root.palexy.streaming.v1.WarpOption();
                        if (object.ihFov != null)
                            message.ihFov = object.ihFov | 0;
                        if (object.ivFov != null)
                            message.ivFov = object.ivFov | 0;
                        if (object.hFov != null)
                            message.hFov = object.hFov | 0;
                        if (object.vFov != null)
                            message.vFov = object.vFov | 0;
                        if (object.width != null)
                            message.width = object.width | 0;
                        if (object.height != null)
                            message.height = object.height | 0;
                        if (object.yaw != null)
                            message.yaw = object.yaw | 0;
                        if (object.pitch != null)
                            message.pitch = object.pitch | 0;
                        if (object.roll != null)
                            message.roll = object.roll | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WarpOption message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.WarpOption
                     * @static
                     * @param {palexy.streaming.v1.WarpOption} message WarpOption
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WarpOption.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.ihFov = 0;
                            object.ivFov = 0;
                            object.hFov = 0;
                            object.vFov = 0;
                            object.width = 0;
                            object.height = 0;
                            object.yaw = 0;
                            object.pitch = 0;
                            object.roll = 0;
                        }
                        if (message.ihFov != null && message.hasOwnProperty("ihFov"))
                            object.ihFov = message.ihFov;
                        if (message.ivFov != null && message.hasOwnProperty("ivFov"))
                            object.ivFov = message.ivFov;
                        if (message.hFov != null && message.hasOwnProperty("hFov"))
                            object.hFov = message.hFov;
                        if (message.vFov != null && message.hasOwnProperty("vFov"))
                            object.vFov = message.vFov;
                        if (message.width != null && message.hasOwnProperty("width"))
                            object.width = message.width;
                        if (message.height != null && message.hasOwnProperty("height"))
                            object.height = message.height;
                        if (message.yaw != null && message.hasOwnProperty("yaw"))
                            object.yaw = message.yaw;
                        if (message.pitch != null && message.hasOwnProperty("pitch"))
                            object.pitch = message.pitch;
                        if (message.roll != null && message.hasOwnProperty("roll"))
                            object.roll = message.roll;
                        return object;
                    };
    
                    /**
                     * Converts this WarpOption to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.WarpOption
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WarpOption.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return WarpOption;
                })();
    
                v1.Area = (function() {
    
                    /**
                     * Properties of an Area.
                     * @memberof palexy.streaming.v1
                     * @interface IArea
                     * @property {string|null} [name] Area name
                     * @property {number|null} [storeId] Area storeId
                     * @property {number|null} [width] Area width
                     * @property {number|null} [height] Area height
                     * @property {number|null} [id] Area id
                     */
    
                    /**
                     * Constructs a new Area.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an Area.
                     * @implements IArea
                     * @constructor
                     * @param {palexy.streaming.v1.IArea=} [properties] Properties to set
                     */
                    function Area(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Area name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     */
                    Area.prototype.name = "";
    
                    /**
                     * Area storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     */
                    Area.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Area width.
                     * @member {number} width
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     */
                    Area.prototype.width = 0;
    
                    /**
                     * Area height.
                     * @member {number} height
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     */
                    Area.prototype.height = 0;
    
                    /**
                     * Area id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     */
                    Area.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new Area instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {palexy.streaming.v1.IArea=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Area} Area instance
                     */
                    Area.create = function create(properties) {
                        return new Area(properties);
                    };
    
                    /**
                     * Encodes the specified Area message. Does not implicitly {@link palexy.streaming.v1.Area.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {palexy.streaming.v1.IArea} message Area message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Area.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.width);
                        if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.height);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Area message, length delimited. Does not implicitly {@link palexy.streaming.v1.Area.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {palexy.streaming.v1.IArea} message Area message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Area.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Area message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Area} Area
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Area.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Area();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.width = reader.float();
                                break;
                            case 4:
                                message.height = reader.float();
                                break;
                            case 5:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Area message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Area} Area
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Area.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Area message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Area.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.width != null && message.hasOwnProperty("width"))
                            if (typeof message.width !== "number")
                                return "width: number expected";
                        if (message.height != null && message.hasOwnProperty("height"))
                            if (typeof message.height !== "number")
                                return "height: number expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an Area message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Area} Area
                     */
                    Area.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Area)
                            return object;
                        var message = new $root.palexy.streaming.v1.Area();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.width != null)
                            message.width = Number(object.width);
                        if (object.height != null)
                            message.height = Number(object.height);
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Area message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Area
                     * @static
                     * @param {palexy.streaming.v1.Area} message Area
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Area.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.width = 0;
                            object.height = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.width != null && message.hasOwnProperty("width"))
                            object.width = options.json && !isFinite(message.width) ? String(message.width) : message.width;
                        if (message.height != null && message.hasOwnProperty("height"))
                            object.height = options.json && !isFinite(message.height) ? String(message.height) : message.height;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this Area to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Area
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Area.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Area;
                })();
    
                v1.ExcludedAreas = (function() {
    
                    /**
                     * Properties of an ExcludedAreas.
                     * @memberof palexy.streaming.v1
                     * @interface IExcludedAreas
                     * @property {Array.<palexy.streaming.v1.IPolygon>|null} [polygons] ExcludedAreas polygons
                     */
    
                    /**
                     * Constructs a new ExcludedAreas.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExcludedAreas.
                     * @implements IExcludedAreas
                     * @constructor
                     * @param {palexy.streaming.v1.IExcludedAreas=} [properties] Properties to set
                     */
                    function ExcludedAreas(properties) {
                        this.polygons = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExcludedAreas polygons.
                     * @member {Array.<palexy.streaming.v1.IPolygon>} polygons
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @instance
                     */
                    ExcludedAreas.prototype.polygons = $util.emptyArray;
    
                    /**
                     * Creates a new ExcludedAreas instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {palexy.streaming.v1.IExcludedAreas=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExcludedAreas} ExcludedAreas instance
                     */
                    ExcludedAreas.create = function create(properties) {
                        return new ExcludedAreas(properties);
                    };
    
                    /**
                     * Encodes the specified ExcludedAreas message. Does not implicitly {@link palexy.streaming.v1.ExcludedAreas.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {palexy.streaming.v1.IExcludedAreas} message ExcludedAreas message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExcludedAreas.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.polygons != null && message.polygons.length)
                            for (var i = 0; i < message.polygons.length; ++i)
                                $root.palexy.streaming.v1.Polygon.encode(message.polygons[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExcludedAreas message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExcludedAreas.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {palexy.streaming.v1.IExcludedAreas} message ExcludedAreas message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExcludedAreas.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExcludedAreas message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExcludedAreas} ExcludedAreas
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExcludedAreas.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExcludedAreas();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.polygons && message.polygons.length))
                                    message.polygons = [];
                                message.polygons.push($root.palexy.streaming.v1.Polygon.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExcludedAreas message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExcludedAreas} ExcludedAreas
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExcludedAreas.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExcludedAreas message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExcludedAreas.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.polygons != null && message.hasOwnProperty("polygons")) {
                            if (!Array.isArray(message.polygons))
                                return "polygons: array expected";
                            for (var i = 0; i < message.polygons.length; ++i) {
                                var error = $root.palexy.streaming.v1.Polygon.verify(message.polygons[i]);
                                if (error)
                                    return "polygons." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExcludedAreas message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExcludedAreas} ExcludedAreas
                     */
                    ExcludedAreas.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExcludedAreas)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExcludedAreas();
                        if (object.polygons) {
                            if (!Array.isArray(object.polygons))
                                throw TypeError(".palexy.streaming.v1.ExcludedAreas.polygons: array expected");
                            message.polygons = [];
                            for (var i = 0; i < object.polygons.length; ++i) {
                                if (typeof object.polygons[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ExcludedAreas.polygons: object expected");
                                message.polygons[i] = $root.palexy.streaming.v1.Polygon.fromObject(object.polygons[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExcludedAreas message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @static
                     * @param {palexy.streaming.v1.ExcludedAreas} message ExcludedAreas
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExcludedAreas.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.polygons = [];
                        if (message.polygons && message.polygons.length) {
                            object.polygons = [];
                            for (var j = 0; j < message.polygons.length; ++j)
                                object.polygons[j] = $root.palexy.streaming.v1.Polygon.toObject(message.polygons[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExcludedAreas to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExcludedAreas
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExcludedAreas.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExcludedAreas;
                })();
    
                v1.Polygon = (function() {
    
                    /**
                     * Properties of a Polygon.
                     * @memberof palexy.streaming.v1
                     * @interface IPolygon
                     * @property {Array.<palexy.streaming.v1.IPoint>|null} [points] Polygon points
                     */
    
                    /**
                     * Constructs a new Polygon.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Polygon.
                     * @implements IPolygon
                     * @constructor
                     * @param {palexy.streaming.v1.IPolygon=} [properties] Properties to set
                     */
                    function Polygon(properties) {
                        this.points = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Polygon points.
                     * @member {Array.<palexy.streaming.v1.IPoint>} points
                     * @memberof palexy.streaming.v1.Polygon
                     * @instance
                     */
                    Polygon.prototype.points = $util.emptyArray;
    
                    /**
                     * Creates a new Polygon instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {palexy.streaming.v1.IPolygon=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Polygon} Polygon instance
                     */
                    Polygon.create = function create(properties) {
                        return new Polygon(properties);
                    };
    
                    /**
                     * Encodes the specified Polygon message. Does not implicitly {@link palexy.streaming.v1.Polygon.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {palexy.streaming.v1.IPolygon} message Polygon message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Polygon.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.points != null && message.points.length)
                            for (var i = 0; i < message.points.length; ++i)
                                $root.palexy.streaming.v1.Point.encode(message.points[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Polygon message, length delimited. Does not implicitly {@link palexy.streaming.v1.Polygon.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {palexy.streaming.v1.IPolygon} message Polygon message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Polygon.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Polygon message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Polygon} Polygon
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Polygon.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Polygon();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.points && message.points.length))
                                    message.points = [];
                                message.points.push($root.palexy.streaming.v1.Point.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Polygon message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Polygon} Polygon
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Polygon.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Polygon message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Polygon.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.points != null && message.hasOwnProperty("points")) {
                            if (!Array.isArray(message.points))
                                return "points: array expected";
                            for (var i = 0; i < message.points.length; ++i) {
                                var error = $root.palexy.streaming.v1.Point.verify(message.points[i]);
                                if (error)
                                    return "points." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Polygon message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Polygon} Polygon
                     */
                    Polygon.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Polygon)
                            return object;
                        var message = new $root.palexy.streaming.v1.Polygon();
                        if (object.points) {
                            if (!Array.isArray(object.points))
                                throw TypeError(".palexy.streaming.v1.Polygon.points: array expected");
                            message.points = [];
                            for (var i = 0; i < object.points.length; ++i) {
                                if (typeof object.points[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Polygon.points: object expected");
                                message.points[i] = $root.palexy.streaming.v1.Point.fromObject(object.points[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Polygon message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Polygon
                     * @static
                     * @param {palexy.streaming.v1.Polygon} message Polygon
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Polygon.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.points = [];
                        if (message.points && message.points.length) {
                            object.points = [];
                            for (var j = 0; j < message.points.length; ++j)
                                object.points[j] = $root.palexy.streaming.v1.Point.toObject(message.points[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Polygon to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Polygon
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Polygon.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Polygon;
                })();
    
                v1.TransformationMatrix = (function() {
    
                    /**
                     * Properties of a TransformationMatrix.
                     * @memberof palexy.streaming.v1
                     * @interface ITransformationMatrix
                     * @property {palexy.streaming.v1.ITransformationPair|null} [pair_1] TransformationMatrix pair_1
                     * @property {palexy.streaming.v1.ITransformationPair|null} [pair_2] TransformationMatrix pair_2
                     * @property {palexy.streaming.v1.ITransformationPair|null} [pair_3] TransformationMatrix pair_3
                     * @property {palexy.streaming.v1.ITransformationPair|null} [pair_4] TransformationMatrix pair_4
                     */
    
                    /**
                     * Constructs a new TransformationMatrix.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TransformationMatrix.
                     * @implements ITransformationMatrix
                     * @constructor
                     * @param {palexy.streaming.v1.ITransformationMatrix=} [properties] Properties to set
                     */
                    function TransformationMatrix(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TransformationMatrix pair_1.
                     * @member {palexy.streaming.v1.ITransformationPair|null|undefined} pair_1
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @instance
                     */
                    TransformationMatrix.prototype.pair_1 = null;
    
                    /**
                     * TransformationMatrix pair_2.
                     * @member {palexy.streaming.v1.ITransformationPair|null|undefined} pair_2
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @instance
                     */
                    TransformationMatrix.prototype.pair_2 = null;
    
                    /**
                     * TransformationMatrix pair_3.
                     * @member {palexy.streaming.v1.ITransformationPair|null|undefined} pair_3
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @instance
                     */
                    TransformationMatrix.prototype.pair_3 = null;
    
                    /**
                     * TransformationMatrix pair_4.
                     * @member {palexy.streaming.v1.ITransformationPair|null|undefined} pair_4
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @instance
                     */
                    TransformationMatrix.prototype.pair_4 = null;
    
                    /**
                     * Creates a new TransformationMatrix instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {palexy.streaming.v1.ITransformationMatrix=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TransformationMatrix} TransformationMatrix instance
                     */
                    TransformationMatrix.create = function create(properties) {
                        return new TransformationMatrix(properties);
                    };
    
                    /**
                     * Encodes the specified TransformationMatrix message. Does not implicitly {@link palexy.streaming.v1.TransformationMatrix.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {palexy.streaming.v1.ITransformationMatrix} message TransformationMatrix message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TransformationMatrix.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pair_1 != null && Object.hasOwnProperty.call(message, "pair_1"))
                            $root.palexy.streaming.v1.TransformationPair.encode(message.pair_1, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pair_2 != null && Object.hasOwnProperty.call(message, "pair_2"))
                            $root.palexy.streaming.v1.TransformationPair.encode(message.pair_2, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.pair_3 != null && Object.hasOwnProperty.call(message, "pair_3"))
                            $root.palexy.streaming.v1.TransformationPair.encode(message.pair_3, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.pair_4 != null && Object.hasOwnProperty.call(message, "pair_4"))
                            $root.palexy.streaming.v1.TransformationPair.encode(message.pair_4, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TransformationMatrix message, length delimited. Does not implicitly {@link palexy.streaming.v1.TransformationMatrix.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {palexy.streaming.v1.ITransformationMatrix} message TransformationMatrix message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TransformationMatrix.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TransformationMatrix message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TransformationMatrix} TransformationMatrix
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TransformationMatrix.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TransformationMatrix();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pair_1 = $root.palexy.streaming.v1.TransformationPair.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pair_2 = $root.palexy.streaming.v1.TransformationPair.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.pair_3 = $root.palexy.streaming.v1.TransformationPair.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.pair_4 = $root.palexy.streaming.v1.TransformationPair.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TransformationMatrix message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TransformationMatrix} TransformationMatrix
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TransformationMatrix.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TransformationMatrix message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TransformationMatrix.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pair_1 != null && message.hasOwnProperty("pair_1")) {
                            var error = $root.palexy.streaming.v1.TransformationPair.verify(message.pair_1);
                            if (error)
                                return "pair_1." + error;
                        }
                        if (message.pair_2 != null && message.hasOwnProperty("pair_2")) {
                            var error = $root.palexy.streaming.v1.TransformationPair.verify(message.pair_2);
                            if (error)
                                return "pair_2." + error;
                        }
                        if (message.pair_3 != null && message.hasOwnProperty("pair_3")) {
                            var error = $root.palexy.streaming.v1.TransformationPair.verify(message.pair_3);
                            if (error)
                                return "pair_3." + error;
                        }
                        if (message.pair_4 != null && message.hasOwnProperty("pair_4")) {
                            var error = $root.palexy.streaming.v1.TransformationPair.verify(message.pair_4);
                            if (error)
                                return "pair_4." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TransformationMatrix message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TransformationMatrix} TransformationMatrix
                     */
                    TransformationMatrix.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TransformationMatrix)
                            return object;
                        var message = new $root.palexy.streaming.v1.TransformationMatrix();
                        if (object.pair_1 != null) {
                            if (typeof object.pair_1 !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationMatrix.pair_1: object expected");
                            message.pair_1 = $root.palexy.streaming.v1.TransformationPair.fromObject(object.pair_1);
                        }
                        if (object.pair_2 != null) {
                            if (typeof object.pair_2 !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationMatrix.pair_2: object expected");
                            message.pair_2 = $root.palexy.streaming.v1.TransformationPair.fromObject(object.pair_2);
                        }
                        if (object.pair_3 != null) {
                            if (typeof object.pair_3 !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationMatrix.pair_3: object expected");
                            message.pair_3 = $root.palexy.streaming.v1.TransformationPair.fromObject(object.pair_3);
                        }
                        if (object.pair_4 != null) {
                            if (typeof object.pair_4 !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationMatrix.pair_4: object expected");
                            message.pair_4 = $root.palexy.streaming.v1.TransformationPair.fromObject(object.pair_4);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TransformationMatrix message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @static
                     * @param {palexy.streaming.v1.TransformationMatrix} message TransformationMatrix
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TransformationMatrix.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pair_1 = null;
                            object.pair_2 = null;
                            object.pair_3 = null;
                            object.pair_4 = null;
                        }
                        if (message.pair_1 != null && message.hasOwnProperty("pair_1"))
                            object.pair_1 = $root.palexy.streaming.v1.TransformationPair.toObject(message.pair_1, options);
                        if (message.pair_2 != null && message.hasOwnProperty("pair_2"))
                            object.pair_2 = $root.palexy.streaming.v1.TransformationPair.toObject(message.pair_2, options);
                        if (message.pair_3 != null && message.hasOwnProperty("pair_3"))
                            object.pair_3 = $root.palexy.streaming.v1.TransformationPair.toObject(message.pair_3, options);
                        if (message.pair_4 != null && message.hasOwnProperty("pair_4"))
                            object.pair_4 = $root.palexy.streaming.v1.TransformationPair.toObject(message.pair_4, options);
                        return object;
                    };
    
                    /**
                     * Converts this TransformationMatrix to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TransformationMatrix
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TransformationMatrix.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TransformationMatrix;
                })();
    
                v1.TransformationPair = (function() {
    
                    /**
                     * Properties of a TransformationPair.
                     * @memberof palexy.streaming.v1
                     * @interface ITransformationPair
                     * @property {palexy.streaming.v1.IPoint|null} [cameraPoint] TransformationPair cameraPoint
                     * @property {palexy.streaming.v1.IPoint|null} [floorPoint] TransformationPair floorPoint
                     */
    
                    /**
                     * Constructs a new TransformationPair.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TransformationPair.
                     * @implements ITransformationPair
                     * @constructor
                     * @param {palexy.streaming.v1.ITransformationPair=} [properties] Properties to set
                     */
                    function TransformationPair(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TransformationPair cameraPoint.
                     * @member {palexy.streaming.v1.IPoint|null|undefined} cameraPoint
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @instance
                     */
                    TransformationPair.prototype.cameraPoint = null;
    
                    /**
                     * TransformationPair floorPoint.
                     * @member {palexy.streaming.v1.IPoint|null|undefined} floorPoint
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @instance
                     */
                    TransformationPair.prototype.floorPoint = null;
    
                    /**
                     * Creates a new TransformationPair instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {palexy.streaming.v1.ITransformationPair=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TransformationPair} TransformationPair instance
                     */
                    TransformationPair.create = function create(properties) {
                        return new TransformationPair(properties);
                    };
    
                    /**
                     * Encodes the specified TransformationPair message. Does not implicitly {@link palexy.streaming.v1.TransformationPair.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {palexy.streaming.v1.ITransformationPair} message TransformationPair message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TransformationPair.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPoint != null && Object.hasOwnProperty.call(message, "cameraPoint"))
                            $root.palexy.streaming.v1.Point.encode(message.cameraPoint, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.floorPoint != null && Object.hasOwnProperty.call(message, "floorPoint"))
                            $root.palexy.streaming.v1.Point.encode(message.floorPoint, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TransformationPair message, length delimited. Does not implicitly {@link palexy.streaming.v1.TransformationPair.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {palexy.streaming.v1.ITransformationPair} message TransformationPair message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TransformationPair.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TransformationPair message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TransformationPair} TransformationPair
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TransformationPair.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TransformationPair();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPoint = $root.palexy.streaming.v1.Point.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.floorPoint = $root.palexy.streaming.v1.Point.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TransformationPair message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TransformationPair} TransformationPair
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TransformationPair.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TransformationPair message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TransformationPair.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPoint != null && message.hasOwnProperty("cameraPoint")) {
                            var error = $root.palexy.streaming.v1.Point.verify(message.cameraPoint);
                            if (error)
                                return "cameraPoint." + error;
                        }
                        if (message.floorPoint != null && message.hasOwnProperty("floorPoint")) {
                            var error = $root.palexy.streaming.v1.Point.verify(message.floorPoint);
                            if (error)
                                return "floorPoint." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TransformationPair message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TransformationPair} TransformationPair
                     */
                    TransformationPair.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TransformationPair)
                            return object;
                        var message = new $root.palexy.streaming.v1.TransformationPair();
                        if (object.cameraPoint != null) {
                            if (typeof object.cameraPoint !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationPair.cameraPoint: object expected");
                            message.cameraPoint = $root.palexy.streaming.v1.Point.fromObject(object.cameraPoint);
                        }
                        if (object.floorPoint != null) {
                            if (typeof object.floorPoint !== "object")
                                throw TypeError(".palexy.streaming.v1.TransformationPair.floorPoint: object expected");
                            message.floorPoint = $root.palexy.streaming.v1.Point.fromObject(object.floorPoint);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TransformationPair message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @static
                     * @param {palexy.streaming.v1.TransformationPair} message TransformationPair
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TransformationPair.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraPoint = null;
                            object.floorPoint = null;
                        }
                        if (message.cameraPoint != null && message.hasOwnProperty("cameraPoint"))
                            object.cameraPoint = $root.palexy.streaming.v1.Point.toObject(message.cameraPoint, options);
                        if (message.floorPoint != null && message.hasOwnProperty("floorPoint"))
                            object.floorPoint = $root.palexy.streaming.v1.Point.toObject(message.floorPoint, options);
                        return object;
                    };
    
                    /**
                     * Converts this TransformationPair to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TransformationPair
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TransformationPair.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TransformationPair;
                })();
    
                v1.Point = (function() {
    
                    /**
                     * Properties of a Point.
                     * @memberof palexy.streaming.v1
                     * @interface IPoint
                     * @property {number|null} [x] Point x
                     * @property {number|null} [y] Point y
                     */
    
                    /**
                     * Constructs a new Point.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Point.
                     * @implements IPoint
                     * @constructor
                     * @param {palexy.streaming.v1.IPoint=} [properties] Properties to set
                     */
                    function Point(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Point x.
                     * @member {number} x
                     * @memberof palexy.streaming.v1.Point
                     * @instance
                     */
                    Point.prototype.x = 0;
    
                    /**
                     * Point y.
                     * @member {number} y
                     * @memberof palexy.streaming.v1.Point
                     * @instance
                     */
                    Point.prototype.y = 0;
    
                    /**
                     * Creates a new Point instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {palexy.streaming.v1.IPoint=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Point} Point instance
                     */
                    Point.create = function create(properties) {
                        return new Point(properties);
                    };
    
                    /**
                     * Encodes the specified Point message. Does not implicitly {@link palexy.streaming.v1.Point.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {palexy.streaming.v1.IPoint} message Point message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Point.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.x != null && Object.hasOwnProperty.call(message, "x"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.x);
                        if (message.y != null && Object.hasOwnProperty.call(message, "y"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.y);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Point message, length delimited. Does not implicitly {@link palexy.streaming.v1.Point.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {palexy.streaming.v1.IPoint} message Point message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Point.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Point message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Point} Point
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Point.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Point();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.x = reader.float();
                                break;
                            case 2:
                                message.y = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Point message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Point} Point
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Point.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Point message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Point.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.x != null && message.hasOwnProperty("x"))
                            if (typeof message.x !== "number")
                                return "x: number expected";
                        if (message.y != null && message.hasOwnProperty("y"))
                            if (typeof message.y !== "number")
                                return "y: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a Point message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Point} Point
                     */
                    Point.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Point)
                            return object;
                        var message = new $root.palexy.streaming.v1.Point();
                        if (object.x != null)
                            message.x = Number(object.x);
                        if (object.y != null)
                            message.y = Number(object.y);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Point message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Point
                     * @static
                     * @param {palexy.streaming.v1.Point} message Point
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Point.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.x = 0;
                            object.y = 0;
                        }
                        if (message.x != null && message.hasOwnProperty("x"))
                            object.x = options.json && !isFinite(message.x) ? String(message.x) : message.x;
                        if (message.y != null && message.hasOwnProperty("y"))
                            object.y = options.json && !isFinite(message.y) ? String(message.y) : message.y;
                        return object;
                    };
    
                    /**
                     * Converts this Point to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Point
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Point.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Point;
                })();
    
                v1.UpdateWorkerHeartbeatRequest = (function() {
    
                    /**
                     * Properties of an UpdateWorkerHeartbeatRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateWorkerHeartbeatRequest
                     * @property {string|null} [worker] UpdateWorkerHeartbeatRequest worker
                     */
    
                    /**
                     * Constructs a new UpdateWorkerHeartbeatRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateWorkerHeartbeatRequest.
                     * @implements IUpdateWorkerHeartbeatRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest=} [properties] Properties to set
                     */
                    function UpdateWorkerHeartbeatRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateWorkerHeartbeatRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @instance
                     */
                    UpdateWorkerHeartbeatRequest.prototype.worker = "";
    
                    /**
                     * Creates a new UpdateWorkerHeartbeatRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateWorkerHeartbeatRequest} UpdateWorkerHeartbeatRequest instance
                     */
                    UpdateWorkerHeartbeatRequest.create = function create(properties) {
                        return new UpdateWorkerHeartbeatRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateWorkerHeartbeatRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateWorkerHeartbeatRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest} message UpdateWorkerHeartbeatRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateWorkerHeartbeatRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateWorkerHeartbeatRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateWorkerHeartbeatRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerHeartbeatRequest} message UpdateWorkerHeartbeatRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateWorkerHeartbeatRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateWorkerHeartbeatRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateWorkerHeartbeatRequest} UpdateWorkerHeartbeatRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateWorkerHeartbeatRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateWorkerHeartbeatRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateWorkerHeartbeatRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateWorkerHeartbeatRequest} UpdateWorkerHeartbeatRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateWorkerHeartbeatRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateWorkerHeartbeatRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateWorkerHeartbeatRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateWorkerHeartbeatRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateWorkerHeartbeatRequest} UpdateWorkerHeartbeatRequest
                     */
                    UpdateWorkerHeartbeatRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateWorkerHeartbeatRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateWorkerHeartbeatRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateWorkerHeartbeatRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateWorkerHeartbeatRequest} message UpdateWorkerHeartbeatRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateWorkerHeartbeatRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.worker = "";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateWorkerHeartbeatRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateWorkerHeartbeatRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateWorkerHeartbeatRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateWorkerHeartbeatRequest;
                })();
    
                v1.TerminateWorkerRequest = (function() {
    
                    /**
                     * Properties of a TerminateWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITerminateWorkerRequest
                     * @property {string|null} [worker] TerminateWorkerRequest worker
                     */
    
                    /**
                     * Constructs a new TerminateWorkerRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TerminateWorkerRequest.
                     * @implements ITerminateWorkerRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest=} [properties] Properties to set
                     */
                    function TerminateWorkerRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TerminateWorkerRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @instance
                     */
                    TerminateWorkerRequest.prototype.worker = "";
    
                    /**
                     * Creates a new TerminateWorkerRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TerminateWorkerRequest} TerminateWorkerRequest instance
                     */
                    TerminateWorkerRequest.create = function create(properties) {
                        return new TerminateWorkerRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TerminateWorkerRequest message. Does not implicitly {@link palexy.streaming.v1.TerminateWorkerRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest} message TerminateWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TerminateWorkerRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TerminateWorkerRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TerminateWorkerRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.ITerminateWorkerRequest} message TerminateWorkerRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TerminateWorkerRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TerminateWorkerRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TerminateWorkerRequest} TerminateWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TerminateWorkerRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TerminateWorkerRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TerminateWorkerRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TerminateWorkerRequest} TerminateWorkerRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TerminateWorkerRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TerminateWorkerRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TerminateWorkerRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a TerminateWorkerRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TerminateWorkerRequest} TerminateWorkerRequest
                     */
                    TerminateWorkerRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TerminateWorkerRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TerminateWorkerRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TerminateWorkerRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @static
                     * @param {palexy.streaming.v1.TerminateWorkerRequest} message TerminateWorkerRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TerminateWorkerRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.worker = "";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        return object;
                    };
    
                    /**
                     * Converts this TerminateWorkerRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TerminateWorkerRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TerminateWorkerRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TerminateWorkerRequest;
                })();
    
                v1.UpdateWorkerCameraAssignmentsRequest = (function() {
    
                    /**
                     * Properties of an UpdateWorkerCameraAssignmentsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateWorkerCameraAssignmentsRequest
                     * @property {string|null} [worker] UpdateWorkerCameraAssignmentsRequest worker
                     * @property {palexy.streaming.v1.IListAssignedCameras|null} [assignedCameras] UpdateWorkerCameraAssignmentsRequest assignedCameras
                     */
    
                    /**
                     * Constructs a new UpdateWorkerCameraAssignmentsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateWorkerCameraAssignmentsRequest.
                     * @implements IUpdateWorkerCameraAssignmentsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest=} [properties] Properties to set
                     */
                    function UpdateWorkerCameraAssignmentsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateWorkerCameraAssignmentsRequest worker.
                     * @member {string} worker
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @instance
                     */
                    UpdateWorkerCameraAssignmentsRequest.prototype.worker = "";
    
                    /**
                     * UpdateWorkerCameraAssignmentsRequest assignedCameras.
                     * @member {palexy.streaming.v1.IListAssignedCameras|null|undefined} assignedCameras
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @instance
                     */
                    UpdateWorkerCameraAssignmentsRequest.prototype.assignedCameras = null;
    
                    /**
                     * Creates a new UpdateWorkerCameraAssignmentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest} UpdateWorkerCameraAssignmentsRequest instance
                     */
                    UpdateWorkerCameraAssignmentsRequest.create = function create(properties) {
                        return new UpdateWorkerCameraAssignmentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateWorkerCameraAssignmentsRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest} message UpdateWorkerCameraAssignmentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateWorkerCameraAssignmentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.worker != null && Object.hasOwnProperty.call(message, "worker"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.worker);
                        if (message.assignedCameras != null && Object.hasOwnProperty.call(message, "assignedCameras"))
                            $root.palexy.streaming.v1.ListAssignedCameras.encode(message.assignedCameras, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateWorkerCameraAssignmentsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest} message UpdateWorkerCameraAssignmentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateWorkerCameraAssignmentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateWorkerCameraAssignmentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest} UpdateWorkerCameraAssignmentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateWorkerCameraAssignmentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.worker = reader.string();
                                break;
                            case 2:
                                message.assignedCameras = $root.palexy.streaming.v1.ListAssignedCameras.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateWorkerCameraAssignmentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest} UpdateWorkerCameraAssignmentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateWorkerCameraAssignmentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateWorkerCameraAssignmentsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateWorkerCameraAssignmentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            if (!$util.isString(message.worker))
                                return "worker: string expected";
                        if (message.assignedCameras != null && message.hasOwnProperty("assignedCameras")) {
                            var error = $root.palexy.streaming.v1.ListAssignedCameras.verify(message.assignedCameras);
                            if (error)
                                return "assignedCameras." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateWorkerCameraAssignmentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest} UpdateWorkerCameraAssignmentsRequest
                     */
                    UpdateWorkerCameraAssignmentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest();
                        if (object.worker != null)
                            message.worker = String(object.worker);
                        if (object.assignedCameras != null) {
                            if (typeof object.assignedCameras !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.assignedCameras: object expected");
                            message.assignedCameras = $root.palexy.streaming.v1.ListAssignedCameras.fromObject(object.assignedCameras);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateWorkerCameraAssignmentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest} message UpdateWorkerCameraAssignmentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateWorkerCameraAssignmentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.worker = "";
                            object.assignedCameras = null;
                        }
                        if (message.worker != null && message.hasOwnProperty("worker"))
                            object.worker = message.worker;
                        if (message.assignedCameras != null && message.hasOwnProperty("assignedCameras"))
                            object.assignedCameras = $root.palexy.streaming.v1.ListAssignedCameras.toObject(message.assignedCameras, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateWorkerCameraAssignmentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateWorkerCameraAssignmentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateWorkerCameraAssignmentsRequest;
                })();
    
                v1.ListAssignedCameras = (function() {
    
                    /**
                     * Properties of a ListAssignedCameras.
                     * @memberof palexy.streaming.v1
                     * @interface IListAssignedCameras
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [assignedCameras] ListAssignedCameras assignedCameras
                     */
    
                    /**
                     * Constructs a new ListAssignedCameras.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAssignedCameras.
                     * @implements IListAssignedCameras
                     * @constructor
                     * @param {palexy.streaming.v1.IListAssignedCameras=} [properties] Properties to set
                     */
                    function ListAssignedCameras(properties) {
                        this.assignedCameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAssignedCameras assignedCameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} assignedCameras
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @instance
                     */
                    ListAssignedCameras.prototype.assignedCameras = $util.emptyArray;
    
                    /**
                     * Creates a new ListAssignedCameras instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {palexy.streaming.v1.IListAssignedCameras=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAssignedCameras} ListAssignedCameras instance
                     */
                    ListAssignedCameras.create = function create(properties) {
                        return new ListAssignedCameras(properties);
                    };
    
                    /**
                     * Encodes the specified ListAssignedCameras message. Does not implicitly {@link palexy.streaming.v1.ListAssignedCameras.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {palexy.streaming.v1.IListAssignedCameras} message ListAssignedCameras message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAssignedCameras.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.assignedCameras != null && message.assignedCameras.length)
                            for (var i = 0; i < message.assignedCameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.assignedCameras[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAssignedCameras message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAssignedCameras.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {palexy.streaming.v1.IListAssignedCameras} message ListAssignedCameras message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAssignedCameras.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAssignedCameras message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAssignedCameras} ListAssignedCameras
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAssignedCameras.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAssignedCameras();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2:
                                if (!(message.assignedCameras && message.assignedCameras.length))
                                    message.assignedCameras = [];
                                message.assignedCameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAssignedCameras message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAssignedCameras} ListAssignedCameras
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAssignedCameras.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAssignedCameras message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAssignedCameras.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.assignedCameras != null && message.hasOwnProperty("assignedCameras")) {
                            if (!Array.isArray(message.assignedCameras))
                                return "assignedCameras: array expected";
                            for (var i = 0; i < message.assignedCameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.assignedCameras[i]);
                                if (error)
                                    return "assignedCameras." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAssignedCameras message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAssignedCameras} ListAssignedCameras
                     */
                    ListAssignedCameras.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAssignedCameras)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAssignedCameras();
                        if (object.assignedCameras) {
                            if (!Array.isArray(object.assignedCameras))
                                throw TypeError(".palexy.streaming.v1.ListAssignedCameras.assignedCameras: array expected");
                            message.assignedCameras = [];
                            for (var i = 0; i < object.assignedCameras.length; ++i) {
                                if (typeof object.assignedCameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAssignedCameras.assignedCameras: object expected");
                                message.assignedCameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.assignedCameras[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAssignedCameras message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @static
                     * @param {palexy.streaming.v1.ListAssignedCameras} message ListAssignedCameras
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAssignedCameras.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.assignedCameras = [];
                        if (message.assignedCameras && message.assignedCameras.length) {
                            object.assignedCameras = [];
                            for (var j = 0; j < message.assignedCameras.length; ++j)
                                object.assignedCameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.assignedCameras[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListAssignedCameras to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAssignedCameras
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAssignedCameras.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAssignedCameras;
                })();
    
                v1.BatchUpdateWorkerAssignmentsRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateWorkerAssignmentsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateWorkerAssignmentsRequest
                     * @property {Array.<palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest>|null} [cameraAssignmentsRequests] BatchUpdateWorkerAssignmentsRequest cameraAssignmentsRequests
                     * @property {Array.<palexy.streaming.v1.ITerminateWorkerRequest>|null} [terminateWorkerRequests] BatchUpdateWorkerAssignmentsRequest terminateWorkerRequests
                     */
    
                    /**
                     * Constructs a new BatchUpdateWorkerAssignmentsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateWorkerAssignmentsRequest.
                     * @implements IBatchUpdateWorkerAssignmentsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest=} [properties] Properties to set
                     */
                    function BatchUpdateWorkerAssignmentsRequest(properties) {
                        this.cameraAssignmentsRequests = [];
                        this.terminateWorkerRequests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateWorkerAssignmentsRequest cameraAssignmentsRequests.
                     * @member {Array.<palexy.streaming.v1.IUpdateWorkerCameraAssignmentsRequest>} cameraAssignmentsRequests
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @instance
                     */
                    BatchUpdateWorkerAssignmentsRequest.prototype.cameraAssignmentsRequests = $util.emptyArray;
    
                    /**
                     * BatchUpdateWorkerAssignmentsRequest terminateWorkerRequests.
                     * @member {Array.<palexy.streaming.v1.ITerminateWorkerRequest>} terminateWorkerRequests
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @instance
                     */
                    BatchUpdateWorkerAssignmentsRequest.prototype.terminateWorkerRequests = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateWorkerAssignmentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest} BatchUpdateWorkerAssignmentsRequest instance
                     */
                    BatchUpdateWorkerAssignmentsRequest.create = function create(properties) {
                        return new BatchUpdateWorkerAssignmentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateWorkerAssignmentsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest} message BatchUpdateWorkerAssignmentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateWorkerAssignmentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraAssignmentsRequests != null && message.cameraAssignmentsRequests.length)
                            for (var i = 0; i < message.cameraAssignmentsRequests.length; ++i)
                                $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.encode(message.cameraAssignmentsRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.terminateWorkerRequests != null && message.terminateWorkerRequests.length)
                            for (var i = 0; i < message.terminateWorkerRequests.length; ++i)
                                $root.palexy.streaming.v1.TerminateWorkerRequest.encode(message.terminateWorkerRequests[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateWorkerAssignmentsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateWorkerAssignmentsRequest} message BatchUpdateWorkerAssignmentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateWorkerAssignmentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateWorkerAssignmentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest} BatchUpdateWorkerAssignmentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateWorkerAssignmentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameraAssignmentsRequests && message.cameraAssignmentsRequests.length))
                                    message.cameraAssignmentsRequests = [];
                                message.cameraAssignmentsRequests.push($root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.terminateWorkerRequests && message.terminateWorkerRequests.length))
                                    message.terminateWorkerRequests = [];
                                message.terminateWorkerRequests.push($root.palexy.streaming.v1.TerminateWorkerRequest.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateWorkerAssignmentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest} BatchUpdateWorkerAssignmentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateWorkerAssignmentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateWorkerAssignmentsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateWorkerAssignmentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraAssignmentsRequests != null && message.hasOwnProperty("cameraAssignmentsRequests")) {
                            if (!Array.isArray(message.cameraAssignmentsRequests))
                                return "cameraAssignmentsRequests: array expected";
                            for (var i = 0; i < message.cameraAssignmentsRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.verify(message.cameraAssignmentsRequests[i]);
                                if (error)
                                    return "cameraAssignmentsRequests." + error;
                            }
                        }
                        if (message.terminateWorkerRequests != null && message.hasOwnProperty("terminateWorkerRequests")) {
                            if (!Array.isArray(message.terminateWorkerRequests))
                                return "terminateWorkerRequests: array expected";
                            for (var i = 0; i < message.terminateWorkerRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.TerminateWorkerRequest.verify(message.terminateWorkerRequests[i]);
                                if (error)
                                    return "terminateWorkerRequests." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateWorkerAssignmentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest} BatchUpdateWorkerAssignmentsRequest
                     */
                    BatchUpdateWorkerAssignmentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest();
                        if (object.cameraAssignmentsRequests) {
                            if (!Array.isArray(object.cameraAssignmentsRequests))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.cameraAssignmentsRequests: array expected");
                            message.cameraAssignmentsRequests = [];
                            for (var i = 0; i < object.cameraAssignmentsRequests.length; ++i) {
                                if (typeof object.cameraAssignmentsRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.cameraAssignmentsRequests: object expected");
                                message.cameraAssignmentsRequests[i] = $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.fromObject(object.cameraAssignmentsRequests[i]);
                            }
                        }
                        if (object.terminateWorkerRequests) {
                            if (!Array.isArray(object.terminateWorkerRequests))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.terminateWorkerRequests: array expected");
                            message.terminateWorkerRequests = [];
                            for (var i = 0; i < object.terminateWorkerRequests.length; ++i) {
                                if (typeof object.terminateWorkerRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest.terminateWorkerRequests: object expected");
                                message.terminateWorkerRequests[i] = $root.palexy.streaming.v1.TerminateWorkerRequest.fromObject(object.terminateWorkerRequests[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateWorkerAssignmentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest} message BatchUpdateWorkerAssignmentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateWorkerAssignmentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.cameraAssignmentsRequests = [];
                            object.terminateWorkerRequests = [];
                        }
                        if (message.cameraAssignmentsRequests && message.cameraAssignmentsRequests.length) {
                            object.cameraAssignmentsRequests = [];
                            for (var j = 0; j < message.cameraAssignmentsRequests.length; ++j)
                                object.cameraAssignmentsRequests[j] = $root.palexy.streaming.v1.UpdateWorkerCameraAssignmentsRequest.toObject(message.cameraAssignmentsRequests[j], options);
                        }
                        if (message.terminateWorkerRequests && message.terminateWorkerRequests.length) {
                            object.terminateWorkerRequests = [];
                            for (var j = 0; j < message.terminateWorkerRequests.length; ++j)
                                object.terminateWorkerRequests[j] = $root.palexy.streaming.v1.TerminateWorkerRequest.toObject(message.terminateWorkerRequests[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateWorkerAssignmentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateWorkerAssignmentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateWorkerAssignmentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateWorkerAssignmentsRequest;
                })();
    
                v1.CameraService = (function() {
    
                    /**
                     * Constructs a new CameraService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CameraService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CameraService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CameraService;
    
                    /**
                     * Creates new CameraService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CameraService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CameraService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#listCameras}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef ListCamerasCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCamerasResponse} [response] ListCamerasResponse
                     */
    
                    /**
                     * Calls ListCameras.
                     * @function listCameras
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IListCamerasRequest} request ListCamerasRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.ListCamerasCallback} callback Node-style callback called with the error, if any, and ListCamerasResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.listCameras = function listCameras(request, callback) {
                        return this.rpcCall(listCameras, $root.palexy.streaming.v1.ListCamerasRequest, $root.palexy.streaming.v1.ListCamerasResponse, request, callback);
                    }, "name", { value: "ListCameras" });
    
                    /**
                     * Calls ListCameras.
                     * @function listCameras
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IListCamerasRequest} request ListCamerasRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCamerasResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#getCamera}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef GetCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Camera} [response] Camera
                     */
    
                    /**
                     * Calls GetCamera.
                     * @function getCamera
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCameraRequest} request GetCameraRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.GetCameraCallback} callback Node-style callback called with the error, if any, and Camera
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.getCamera = function getCamera(request, callback) {
                        return this.rpcCall(getCamera, $root.palexy.streaming.v1.GetCameraRequest, $root.palexy.streaming.v1.Camera, request, callback);
                    }, "name", { value: "GetCamera" });
    
                    /**
                     * Calls GetCamera.
                     * @function getCamera
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCameraRequest} request GetCameraRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Camera>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#updateCamera}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef UpdateCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Camera} [response] Camera
                     */
    
                    /**
                     * Calls UpdateCamera.
                     * @function updateCamera
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateCameraRequest} request UpdateCameraRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.UpdateCameraCallback} callback Node-style callback called with the error, if any, and Camera
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.updateCamera = function updateCamera(request, callback) {
                        return this.rpcCall(updateCamera, $root.palexy.streaming.v1.UpdateCameraRequest, $root.palexy.streaming.v1.Camera, request, callback);
                    }, "name", { value: "UpdateCamera" });
    
                    /**
                     * Calls UpdateCamera.
                     * @function updateCamera
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateCameraRequest} request UpdateCameraRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Camera>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#reprocessCameraData}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef ReprocessCameraDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReprocessCameraDataResponse} [response] ReprocessCameraDataResponse
                     */
    
                    /**
                     * Calls ReprocessCameraData.
                     * @function reprocessCameraData
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest} request ReprocessCameraDataRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.ReprocessCameraDataCallback} callback Node-style callback called with the error, if any, and ReprocessCameraDataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.reprocessCameraData = function reprocessCameraData(request, callback) {
                        return this.rpcCall(reprocessCameraData, $root.palexy.streaming.v1.ReprocessCameraDataRequest, $root.palexy.streaming.v1.ReprocessCameraDataResponse, request, callback);
                    }, "name", { value: "ReprocessCameraData" });
    
                    /**
                     * Calls ReprocessCameraData.
                     * @function reprocessCameraData
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest} request ReprocessCameraDataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReprocessCameraDataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#detectCameraShift}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef DetectCameraShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.DetectCameraShiftResponse} [response] DetectCameraShiftResponse
                     */
    
                    /**
                     * Calls DetectCameraShift.
                     * @function detectCameraShift
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest} request DetectCameraShiftRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.DetectCameraShiftCallback} callback Node-style callback called with the error, if any, and DetectCameraShiftResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.detectCameraShift = function detectCameraShift(request, callback) {
                        return this.rpcCall(detectCameraShift, $root.palexy.streaming.v1.DetectCameraShiftRequest, $root.palexy.streaming.v1.DetectCameraShiftResponse, request, callback);
                    }, "name", { value: "DetectCameraShift" });
    
                    /**
                     * Calls DetectCameraShift.
                     * @function detectCameraShift
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest} request DetectCameraShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.DetectCameraShiftResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#getCameraFisheyePreview}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef GetCameraFisheyePreviewCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetCameraFisheyePreviewResponse} [response] GetCameraFisheyePreviewResponse
                     */
    
                    /**
                     * Calls GetCameraFisheyePreview.
                     * @function getCameraFisheyePreview
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest} request GetCameraFisheyePreviewRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.GetCameraFisheyePreviewCallback} callback Node-style callback called with the error, if any, and GetCameraFisheyePreviewResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.getCameraFisheyePreview = function getCameraFisheyePreview(request, callback) {
                        return this.rpcCall(getCameraFisheyePreview, $root.palexy.streaming.v1.GetCameraFisheyePreviewRequest, $root.palexy.streaming.v1.GetCameraFisheyePreviewResponse, request, callback);
                    }, "name", { value: "GetCameraFisheyePreview" });
    
                    /**
                     * Calls GetCameraFisheyePreview.
                     * @function getCameraFisheyePreview
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest} request GetCameraFisheyePreviewRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetCameraFisheyePreviewResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#takeSnapshot}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef TakeSnapshotCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.TakeSnapshotResponse} [response] TakeSnapshotResponse
                     */
    
                    /**
                     * Calls TakeSnapshot.
                     * @function takeSnapshot
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest} request TakeSnapshotRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.TakeSnapshotCallback} callback Node-style callback called with the error, if any, and TakeSnapshotResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.takeSnapshot = function takeSnapshot(request, callback) {
                        return this.rpcCall(takeSnapshot, $root.palexy.streaming.v1.TakeSnapshotRequest, $root.palexy.streaming.v1.TakeSnapshotResponse, request, callback);
                    }, "name", { value: "TakeSnapshot" });
    
                    /**
                     * Calls TakeSnapshot.
                     * @function takeSnapshot
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest} request TakeSnapshotRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.TakeSnapshotResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#uploadPhoto}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef UploadPhotoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.UploadPhotoResponse} [response] UploadPhotoResponse
                     */
    
                    /**
                     * Calls UploadPhoto.
                     * @function uploadPhoto
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUploadPhotoRequest} request UploadPhotoRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.UploadPhotoCallback} callback Node-style callback called with the error, if any, and UploadPhotoResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.uploadPhoto = function uploadPhoto(request, callback) {
                        return this.rpcCall(uploadPhoto, $root.palexy.streaming.v1.UploadPhotoRequest, $root.palexy.streaming.v1.UploadPhotoResponse, request, callback);
                    }, "name", { value: "UploadPhoto" });
    
                    /**
                     * Calls UploadPhoto.
                     * @function uploadPhoto
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUploadPhotoRequest} request UploadPhotoRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.UploadPhotoResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#fetchCamerasReadyToScheduleDownload}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef FetchCamerasReadyToScheduleDownloadCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} [response] FetchCamerasReadyToScheduleDownloadResponse
                     */
    
                    /**
                     * Calls FetchCamerasReadyToScheduleDownload.
                     * @function fetchCamerasReadyToScheduleDownload
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest} request FetchCamerasReadyToScheduleDownloadRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.FetchCamerasReadyToScheduleDownloadCallback} callback Node-style callback called with the error, if any, and FetchCamerasReadyToScheduleDownloadResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.fetchCamerasReadyToScheduleDownload = function fetchCamerasReadyToScheduleDownload(request, callback) {
                        return this.rpcCall(fetchCamerasReadyToScheduleDownload, $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest, $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse, request, callback);
                    }, "name", { value: "FetchCamerasReadyToScheduleDownload" });
    
                    /**
                     * Calls FetchCamerasReadyToScheduleDownload.
                     * @function fetchCamerasReadyToScheduleDownload
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest} request FetchCamerasReadyToScheduleDownloadRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#getAvailableShiftTestingImage}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef GetAvailableShiftTestingImageCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CameraPhoto} [response] CameraPhoto
                     */
    
                    /**
                     * Calls GetAvailableShiftTestingImage.
                     * @function getAvailableShiftTestingImage
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest} request GetAvailableShiftTestingImageRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.GetAvailableShiftTestingImageCallback} callback Node-style callback called with the error, if any, and CameraPhoto
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.getAvailableShiftTestingImage = function getAvailableShiftTestingImage(request, callback) {
                        return this.rpcCall(getAvailableShiftTestingImage, $root.palexy.streaming.v1.GetAvailableShiftTestingImageRequest, $root.palexy.streaming.v1.CameraPhoto, request, callback);
                    }, "name", { value: "GetAvailableShiftTestingImage" });
    
                    /**
                     * Calls GetAvailableShiftTestingImage.
                     * @function getAvailableShiftTestingImage
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest} request GetAvailableShiftTestingImageRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CameraPhoto>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraService#updateViewChangedCameras}.
                     * @memberof palexy.streaming.v1.CameraService
                     * @typedef UpdateViewChangedCamerasCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls UpdateViewChangedCameras.
                     * @function updateViewChangedCameras
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest} request UpdateViewChangedCamerasRequest message or plain object
                     * @param {palexy.streaming.v1.CameraService.UpdateViewChangedCamerasCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraService.prototype.updateViewChangedCameras = function updateViewChangedCameras(request, callback) {
                        return this.rpcCall(updateViewChangedCameras, $root.palexy.streaming.v1.UpdateViewChangedCamerasRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "UpdateViewChangedCameras" });
    
                    /**
                     * Calls UpdateViewChangedCameras.
                     * @function updateViewChangedCameras
                     * @memberof palexy.streaming.v1.CameraService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest} request UpdateViewChangedCamerasRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return CameraService;
                })();
    
                v1.GetAvailableShiftTestingImageRequest = (function() {
    
                    /**
                     * Properties of a GetAvailableShiftTestingImageRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetAvailableShiftTestingImageRequest
                     * @property {palexy.streaming.v1.ICamera|null} [camera] GetAvailableShiftTestingImageRequest camera
                     */
    
                    /**
                     * Constructs a new GetAvailableShiftTestingImageRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetAvailableShiftTestingImageRequest.
                     * @implements IGetAvailableShiftTestingImageRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest=} [properties] Properties to set
                     */
                    function GetAvailableShiftTestingImageRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAvailableShiftTestingImageRequest camera.
                     * @member {palexy.streaming.v1.ICamera|null|undefined} camera
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @instance
                     */
                    GetAvailableShiftTestingImageRequest.prototype.camera = null;
    
                    /**
                     * Creates a new GetAvailableShiftTestingImageRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetAvailableShiftTestingImageRequest} GetAvailableShiftTestingImageRequest instance
                     */
                    GetAvailableShiftTestingImageRequest.create = function create(properties) {
                        return new GetAvailableShiftTestingImageRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetAvailableShiftTestingImageRequest message. Does not implicitly {@link palexy.streaming.v1.GetAvailableShiftTestingImageRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest} message GetAvailableShiftTestingImageRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAvailableShiftTestingImageRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                            $root.palexy.streaming.v1.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAvailableShiftTestingImageRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetAvailableShiftTestingImageRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAvailableShiftTestingImageRequest} message GetAvailableShiftTestingImageRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAvailableShiftTestingImageRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAvailableShiftTestingImageRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetAvailableShiftTestingImageRequest} GetAvailableShiftTestingImageRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAvailableShiftTestingImageRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetAvailableShiftTestingImageRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.camera = $root.palexy.streaming.v1.Camera.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAvailableShiftTestingImageRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetAvailableShiftTestingImageRequest} GetAvailableShiftTestingImageRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAvailableShiftTestingImageRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAvailableShiftTestingImageRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAvailableShiftTestingImageRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.camera != null && message.hasOwnProperty("camera")) {
                            var error = $root.palexy.streaming.v1.Camera.verify(message.camera);
                            if (error)
                                return "camera." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetAvailableShiftTestingImageRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetAvailableShiftTestingImageRequest} GetAvailableShiftTestingImageRequest
                     */
                    GetAvailableShiftTestingImageRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetAvailableShiftTestingImageRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetAvailableShiftTestingImageRequest();
                        if (object.camera != null) {
                            if (typeof object.camera !== "object")
                                throw TypeError(".palexy.streaming.v1.GetAvailableShiftTestingImageRequest.camera: object expected");
                            message.camera = $root.palexy.streaming.v1.Camera.fromObject(object.camera);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAvailableShiftTestingImageRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @static
                     * @param {palexy.streaming.v1.GetAvailableShiftTestingImageRequest} message GetAvailableShiftTestingImageRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAvailableShiftTestingImageRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.camera = null;
                        if (message.camera != null && message.hasOwnProperty("camera"))
                            object.camera = $root.palexy.streaming.v1.Camera.toObject(message.camera, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetAvailableShiftTestingImageRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetAvailableShiftTestingImageRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAvailableShiftTestingImageRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAvailableShiftTestingImageRequest;
                })();
    
                v1.UpdateViewChangedCamerasRequest = (function() {
    
                    /**
                     * Properties of an UpdateViewChangedCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateViewChangedCamerasRequest
                     * @property {Array.<string>|null} [cameraIds] UpdateViewChangedCamerasRequest cameraIds
                     * @property {boolean|null} [shouldRaiseAdditionalStoreIssue] UpdateViewChangedCamerasRequest shouldRaiseAdditionalStoreIssue
                     * @property {palexy.store_issue.v1.IRaiseStoreIssueRequest|null} [additionalRaiseStoreIssueRequest] UpdateViewChangedCamerasRequest additionalRaiseStoreIssueRequest
                     */
    
                    /**
                     * Constructs a new UpdateViewChangedCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateViewChangedCamerasRequest.
                     * @implements IUpdateViewChangedCamerasRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest=} [properties] Properties to set
                     */
                    function UpdateViewChangedCamerasRequest(properties) {
                        this.cameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateViewChangedCamerasRequest cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @instance
                     */
                    UpdateViewChangedCamerasRequest.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * UpdateViewChangedCamerasRequest shouldRaiseAdditionalStoreIssue.
                     * @member {boolean} shouldRaiseAdditionalStoreIssue
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @instance
                     */
                    UpdateViewChangedCamerasRequest.prototype.shouldRaiseAdditionalStoreIssue = false;
    
                    /**
                     * UpdateViewChangedCamerasRequest additionalRaiseStoreIssueRequest.
                     * @member {palexy.store_issue.v1.IRaiseStoreIssueRequest|null|undefined} additionalRaiseStoreIssueRequest
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @instance
                     */
                    UpdateViewChangedCamerasRequest.prototype.additionalRaiseStoreIssueRequest = null;
    
                    /**
                     * Creates a new UpdateViewChangedCamerasRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateViewChangedCamerasRequest} UpdateViewChangedCamerasRequest instance
                     */
                    UpdateViewChangedCamerasRequest.create = function create(properties) {
                        return new UpdateViewChangedCamerasRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateViewChangedCamerasRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateViewChangedCamerasRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest} message UpdateViewChangedCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateViewChangedCamerasRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraIds[i]);
                        if (message.shouldRaiseAdditionalStoreIssue != null && Object.hasOwnProperty.call(message, "shouldRaiseAdditionalStoreIssue"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.shouldRaiseAdditionalStoreIssue);
                        if (message.additionalRaiseStoreIssueRequest != null && Object.hasOwnProperty.call(message, "additionalRaiseStoreIssueRequest"))
                            $root.palexy.store_issue.v1.RaiseStoreIssueRequest.encode(message.additionalRaiseStoreIssueRequest, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateViewChangedCamerasRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateViewChangedCamerasRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateViewChangedCamerasRequest} message UpdateViewChangedCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateViewChangedCamerasRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateViewChangedCamerasRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateViewChangedCamerasRequest} UpdateViewChangedCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateViewChangedCamerasRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateViewChangedCamerasRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 2:
                                message.shouldRaiseAdditionalStoreIssue = reader.bool();
                                break;
                            case 3:
                                message.additionalRaiseStoreIssueRequest = $root.palexy.store_issue.v1.RaiseStoreIssueRequest.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateViewChangedCamerasRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateViewChangedCamerasRequest} UpdateViewChangedCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateViewChangedCamerasRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateViewChangedCamerasRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateViewChangedCamerasRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.shouldRaiseAdditionalStoreIssue != null && message.hasOwnProperty("shouldRaiseAdditionalStoreIssue"))
                            if (typeof message.shouldRaiseAdditionalStoreIssue !== "boolean")
                                return "shouldRaiseAdditionalStoreIssue: boolean expected";
                        if (message.additionalRaiseStoreIssueRequest != null && message.hasOwnProperty("additionalRaiseStoreIssueRequest")) {
                            var error = $root.palexy.store_issue.v1.RaiseStoreIssueRequest.verify(message.additionalRaiseStoreIssueRequest);
                            if (error)
                                return "additionalRaiseStoreIssueRequest." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateViewChangedCamerasRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateViewChangedCamerasRequest} UpdateViewChangedCamerasRequest
                     */
                    UpdateViewChangedCamerasRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateViewChangedCamerasRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateViewChangedCamerasRequest();
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.UpdateViewChangedCamerasRequest.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.shouldRaiseAdditionalStoreIssue != null)
                            message.shouldRaiseAdditionalStoreIssue = Boolean(object.shouldRaiseAdditionalStoreIssue);
                        if (object.additionalRaiseStoreIssueRequest != null) {
                            if (typeof object.additionalRaiseStoreIssueRequest !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateViewChangedCamerasRequest.additionalRaiseStoreIssueRequest: object expected");
                            message.additionalRaiseStoreIssueRequest = $root.palexy.store_issue.v1.RaiseStoreIssueRequest.fromObject(object.additionalRaiseStoreIssueRequest);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateViewChangedCamerasRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateViewChangedCamerasRequest} message UpdateViewChangedCamerasRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateViewChangedCamerasRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameraIds = [];
                        if (options.defaults) {
                            object.shouldRaiseAdditionalStoreIssue = false;
                            object.additionalRaiseStoreIssueRequest = null;
                        }
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.shouldRaiseAdditionalStoreIssue != null && message.hasOwnProperty("shouldRaiseAdditionalStoreIssue"))
                            object.shouldRaiseAdditionalStoreIssue = message.shouldRaiseAdditionalStoreIssue;
                        if (message.additionalRaiseStoreIssueRequest != null && message.hasOwnProperty("additionalRaiseStoreIssueRequest"))
                            object.additionalRaiseStoreIssueRequest = $root.palexy.store_issue.v1.RaiseStoreIssueRequest.toObject(message.additionalRaiseStoreIssueRequest, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateViewChangedCamerasRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateViewChangedCamerasRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateViewChangedCamerasRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateViewChangedCamerasRequest;
                })();
    
                v1.ReprocessCameraDataRequest = (function() {
    
                    /**
                     * Properties of a ReprocessCameraDataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IReprocessCameraDataRequest
                     * @property {string|null} [fromDate] ReprocessCameraDataRequest fromDate
                     * @property {string|null} [toDate] ReprocessCameraDataRequest toDate
                     * @property {string|null} [cameraId] ReprocessCameraDataRequest cameraId
                     * @property {number|null} [companyId] ReprocessCameraDataRequest companyId
                     * @property {string|null} [processingQueueId] ReprocessCameraDataRequest processingQueueId
                     * @property {boolean|null} [skipFeatureExtraction] ReprocessCameraDataRequest skipFeatureExtraction
                     */
    
                    /**
                     * Constructs a new ReprocessCameraDataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReprocessCameraDataRequest.
                     * @implements IReprocessCameraDataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest=} [properties] Properties to set
                     */
                    function ReprocessCameraDataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReprocessCameraDataRequest fromDate.
                     * @member {string} fromDate
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.fromDate = "";
    
                    /**
                     * ReprocessCameraDataRequest toDate.
                     * @member {string} toDate
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.toDate = "";
    
                    /**
                     * ReprocessCameraDataRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.cameraId = "";
    
                    /**
                     * ReprocessCameraDataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReprocessCameraDataRequest processingQueueId.
                     * @member {string} processingQueueId
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.processingQueueId = "";
    
                    /**
                     * ReprocessCameraDataRequest skipFeatureExtraction.
                     * @member {boolean} skipFeatureExtraction
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     */
                    ReprocessCameraDataRequest.prototype.skipFeatureExtraction = false;
    
                    /**
                     * Creates a new ReprocessCameraDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReprocessCameraDataRequest} ReprocessCameraDataRequest instance
                     */
                    ReprocessCameraDataRequest.create = function create(properties) {
                        return new ReprocessCameraDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ReprocessCameraDataRequest message. Does not implicitly {@link palexy.streaming.v1.ReprocessCameraDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest} message ReprocessCameraDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReprocessCameraDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fromDate);
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.toDate);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.cameraId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.companyId);
                        if (message.processingQueueId != null && Object.hasOwnProperty.call(message, "processingQueueId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.processingQueueId);
                        if (message.skipFeatureExtraction != null && Object.hasOwnProperty.call(message, "skipFeatureExtraction"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.skipFeatureExtraction);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReprocessCameraDataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReprocessCameraDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataRequest} message ReprocessCameraDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReprocessCameraDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReprocessCameraDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReprocessCameraDataRequest} ReprocessCameraDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReprocessCameraDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReprocessCameraDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fromDate = reader.string();
                                break;
                            case 2:
                                message.toDate = reader.string();
                                break;
                            case 3:
                                message.cameraId = reader.string();
                                break;
                            case 4:
                                message.companyId = reader.int64();
                                break;
                            case 5:
                                message.processingQueueId = reader.string();
                                break;
                            case 6:
                                message.skipFeatureExtraction = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReprocessCameraDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReprocessCameraDataRequest} ReprocessCameraDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReprocessCameraDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReprocessCameraDataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReprocessCameraDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            if (!$util.isString(message.fromDate))
                                return "fromDate: string expected";
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            if (!$util.isString(message.toDate))
                                return "toDate: string expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.processingQueueId != null && message.hasOwnProperty("processingQueueId"))
                            if (!$util.isString(message.processingQueueId))
                                return "processingQueueId: string expected";
                        if (message.skipFeatureExtraction != null && message.hasOwnProperty("skipFeatureExtraction"))
                            if (typeof message.skipFeatureExtraction !== "boolean")
                                return "skipFeatureExtraction: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReprocessCameraDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReprocessCameraDataRequest} ReprocessCameraDataRequest
                     */
                    ReprocessCameraDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReprocessCameraDataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReprocessCameraDataRequest();
                        if (object.fromDate != null)
                            message.fromDate = String(object.fromDate);
                        if (object.toDate != null)
                            message.toDate = String(object.toDate);
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.processingQueueId != null)
                            message.processingQueueId = String(object.processingQueueId);
                        if (object.skipFeatureExtraction != null)
                            message.skipFeatureExtraction = Boolean(object.skipFeatureExtraction);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReprocessCameraDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ReprocessCameraDataRequest} message ReprocessCameraDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReprocessCameraDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fromDate = "";
                            object.toDate = "";
                            object.cameraId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.processingQueueId = "";
                            object.skipFeatureExtraction = false;
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = message.fromDate;
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = message.toDate;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.processingQueueId != null && message.hasOwnProperty("processingQueueId"))
                            object.processingQueueId = message.processingQueueId;
                        if (message.skipFeatureExtraction != null && message.hasOwnProperty("skipFeatureExtraction"))
                            object.skipFeatureExtraction = message.skipFeatureExtraction;
                        return object;
                    };
    
                    /**
                     * Converts this ReprocessCameraDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReprocessCameraDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReprocessCameraDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReprocessCameraDataRequest;
                })();
    
                v1.ReprocessCameraDataResponse = (function() {
    
                    /**
                     * Properties of a ReprocessCameraDataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IReprocessCameraDataResponse
                     * @property {string|null} [message] ReprocessCameraDataResponse message
                     */
    
                    /**
                     * Constructs a new ReprocessCameraDataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReprocessCameraDataResponse.
                     * @implements IReprocessCameraDataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IReprocessCameraDataResponse=} [properties] Properties to set
                     */
                    function ReprocessCameraDataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReprocessCameraDataResponse message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @instance
                     */
                    ReprocessCameraDataResponse.prototype.message = "";
    
                    /**
                     * Creates a new ReprocessCameraDataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReprocessCameraDataResponse} ReprocessCameraDataResponse instance
                     */
                    ReprocessCameraDataResponse.create = function create(properties) {
                        return new ReprocessCameraDataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ReprocessCameraDataResponse message. Does not implicitly {@link palexy.streaming.v1.ReprocessCameraDataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataResponse} message ReprocessCameraDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReprocessCameraDataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReprocessCameraDataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReprocessCameraDataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IReprocessCameraDataResponse} message ReprocessCameraDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReprocessCameraDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReprocessCameraDataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReprocessCameraDataResponse} ReprocessCameraDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReprocessCameraDataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReprocessCameraDataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.message = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReprocessCameraDataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReprocessCameraDataResponse} ReprocessCameraDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReprocessCameraDataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReprocessCameraDataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReprocessCameraDataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReprocessCameraDataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReprocessCameraDataResponse} ReprocessCameraDataResponse
                     */
                    ReprocessCameraDataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReprocessCameraDataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReprocessCameraDataResponse();
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReprocessCameraDataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ReprocessCameraDataResponse} message ReprocessCameraDataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReprocessCameraDataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.message = "";
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };
    
                    /**
                     * Converts this ReprocessCameraDataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReprocessCameraDataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReprocessCameraDataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReprocessCameraDataResponse;
                })();
    
                v1.UpdateCameraRequest = (function() {
    
                    /**
                     * Properties of an UpdateCameraRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateCameraRequest
                     * @property {palexy.streaming.v1.ICamera|null} [camera] UpdateCameraRequest camera
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateCameraRequest updateMask
                     * @property {string|null} [agent] UpdateCameraRequest agent
                     */
    
                    /**
                     * Constructs a new UpdateCameraRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateCameraRequest.
                     * @implements IUpdateCameraRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateCameraRequest=} [properties] Properties to set
                     */
                    function UpdateCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateCameraRequest camera.
                     * @member {palexy.streaming.v1.ICamera|null|undefined} camera
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @instance
                     */
                    UpdateCameraRequest.prototype.camera = null;
    
                    /**
                     * UpdateCameraRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @instance
                     */
                    UpdateCameraRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateCameraRequest agent.
                     * @member {string} agent
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @instance
                     */
                    UpdateCameraRequest.prototype.agent = "";
    
                    /**
                     * Creates a new UpdateCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateCameraRequest} UpdateCameraRequest instance
                     */
                    UpdateCameraRequest.create = function create(properties) {
                        return new UpdateCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateCameraRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraRequest} message UpdateCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                            $root.palexy.streaming.v1.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.agent != null && Object.hasOwnProperty.call(message, "agent"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.agent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateCameraRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraRequest} message UpdateCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateCameraRequest} UpdateCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.camera = $root.palexy.streaming.v1.Camera.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.agent = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateCameraRequest} UpdateCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateCameraRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.camera != null && message.hasOwnProperty("camera")) {
                            var error = $root.palexy.streaming.v1.Camera.verify(message.camera);
                            if (error)
                                return "camera." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.agent != null && message.hasOwnProperty("agent"))
                            if (!$util.isString(message.agent))
                                return "agent: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateCameraRequest} UpdateCameraRequest
                     */
                    UpdateCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateCameraRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateCameraRequest();
                        if (object.camera != null) {
                            if (typeof object.camera !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateCameraRequest.camera: object expected");
                            message.camera = $root.palexy.streaming.v1.Camera.fromObject(object.camera);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateCameraRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.agent != null)
                            message.agent = String(object.agent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateCameraRequest} message UpdateCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.camera = null;
                            object.updateMask = null;
                            object.agent = "";
                        }
                        if (message.camera != null && message.hasOwnProperty("camera"))
                            object.camera = $root.palexy.streaming.v1.Camera.toObject(message.camera, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.agent != null && message.hasOwnProperty("agent"))
                            object.agent = message.agent;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateCameraRequest;
                })();
    
                v1.GetCameraRequest = (function() {
    
                    /**
                     * Properties of a GetCameraRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCameraRequest
                     * @property {string|null} [name] GetCameraRequest name
                     * @property {boolean|null} [includeAreaData] GetCameraRequest includeAreaData
                     * @property {string|null} [versionDateTime] GetCameraRequest versionDateTime
                     * @property {boolean|null} [includeStoreData] GetCameraRequest includeStoreData
                     * @property {boolean|null} [includeCompanyConfig] GetCameraRequest includeCompanyConfig
                     * @property {boolean|null} [includeSubviews] GetCameraRequest includeSubviews
                     * @property {number|null} [cameraDatabaseId] GetCameraRequest cameraDatabaseId
                     * @property {boolean|null} [includeReferencingCameras] GetCameraRequest includeReferencingCameras
                     */
    
                    /**
                     * Constructs a new GetCameraRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCameraRequest.
                     * @implements IGetCameraRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCameraRequest=} [properties] Properties to set
                     */
                    function GetCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCameraRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.name = "";
    
                    /**
                     * GetCameraRequest includeAreaData.
                     * @member {boolean} includeAreaData
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.includeAreaData = false;
    
                    /**
                     * GetCameraRequest versionDateTime.
                     * @member {string} versionDateTime
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.versionDateTime = "";
    
                    /**
                     * GetCameraRequest includeStoreData.
                     * @member {boolean} includeStoreData
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.includeStoreData = false;
    
                    /**
                     * GetCameraRequest includeCompanyConfig.
                     * @member {boolean} includeCompanyConfig
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.includeCompanyConfig = false;
    
                    /**
                     * GetCameraRequest includeSubviews.
                     * @member {boolean} includeSubviews
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.includeSubviews = false;
    
                    /**
                     * GetCameraRequest cameraDatabaseId.
                     * @member {number} cameraDatabaseId
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.cameraDatabaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCameraRequest includeReferencingCameras.
                     * @member {boolean} includeReferencingCameras
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     */
                    GetCameraRequest.prototype.includeReferencingCameras = false;
    
                    /**
                     * Creates a new GetCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCameraRequest} GetCameraRequest instance
                     */
                    GetCameraRequest.create = function create(properties) {
                        return new GetCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCameraRequest message. Does not implicitly {@link palexy.streaming.v1.GetCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraRequest} message GetCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.includeAreaData != null && Object.hasOwnProperty.call(message, "includeAreaData"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeAreaData);
                        if (message.versionDateTime != null && Object.hasOwnProperty.call(message, "versionDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.versionDateTime);
                        if (message.includeStoreData != null && Object.hasOwnProperty.call(message, "includeStoreData"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeStoreData);
                        if (message.includeCompanyConfig != null && Object.hasOwnProperty.call(message, "includeCompanyConfig"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeCompanyConfig);
                        if (message.includeSubviews != null && Object.hasOwnProperty.call(message, "includeSubviews"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeSubviews);
                        if (message.cameraDatabaseId != null && Object.hasOwnProperty.call(message, "cameraDatabaseId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.cameraDatabaseId);
                        if (message.includeReferencingCameras != null && Object.hasOwnProperty.call(message, "includeReferencingCameras"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.includeReferencingCameras);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCameraRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraRequest} message GetCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCameraRequest} GetCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.includeAreaData = reader.bool();
                                break;
                            case 3:
                                message.versionDateTime = reader.string();
                                break;
                            case 4:
                                message.includeStoreData = reader.bool();
                                break;
                            case 5:
                                message.includeCompanyConfig = reader.bool();
                                break;
                            case 6:
                                message.includeSubviews = reader.bool();
                                break;
                            case 7:
                                message.cameraDatabaseId = reader.int64();
                                break;
                            case 8:
                                message.includeReferencingCameras = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCameraRequest} GetCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCameraRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.includeAreaData != null && message.hasOwnProperty("includeAreaData"))
                            if (typeof message.includeAreaData !== "boolean")
                                return "includeAreaData: boolean expected";
                        if (message.versionDateTime != null && message.hasOwnProperty("versionDateTime"))
                            if (!$util.isString(message.versionDateTime))
                                return "versionDateTime: string expected";
                        if (message.includeStoreData != null && message.hasOwnProperty("includeStoreData"))
                            if (typeof message.includeStoreData !== "boolean")
                                return "includeStoreData: boolean expected";
                        if (message.includeCompanyConfig != null && message.hasOwnProperty("includeCompanyConfig"))
                            if (typeof message.includeCompanyConfig !== "boolean")
                                return "includeCompanyConfig: boolean expected";
                        if (message.includeSubviews != null && message.hasOwnProperty("includeSubviews"))
                            if (typeof message.includeSubviews !== "boolean")
                                return "includeSubviews: boolean expected";
                        if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                            if (!$util.isInteger(message.cameraDatabaseId) && !(message.cameraDatabaseId && $util.isInteger(message.cameraDatabaseId.low) && $util.isInteger(message.cameraDatabaseId.high)))
                                return "cameraDatabaseId: integer|Long expected";
                        if (message.includeReferencingCameras != null && message.hasOwnProperty("includeReferencingCameras"))
                            if (typeof message.includeReferencingCameras !== "boolean")
                                return "includeReferencingCameras: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCameraRequest} GetCameraRequest
                     */
                    GetCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCameraRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCameraRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.includeAreaData != null)
                            message.includeAreaData = Boolean(object.includeAreaData);
                        if (object.versionDateTime != null)
                            message.versionDateTime = String(object.versionDateTime);
                        if (object.includeStoreData != null)
                            message.includeStoreData = Boolean(object.includeStoreData);
                        if (object.includeCompanyConfig != null)
                            message.includeCompanyConfig = Boolean(object.includeCompanyConfig);
                        if (object.includeSubviews != null)
                            message.includeSubviews = Boolean(object.includeSubviews);
                        if (object.cameraDatabaseId != null)
                            if ($util.Long)
                                (message.cameraDatabaseId = $util.Long.fromValue(object.cameraDatabaseId)).unsigned = false;
                            else if (typeof object.cameraDatabaseId === "string")
                                message.cameraDatabaseId = parseInt(object.cameraDatabaseId, 10);
                            else if (typeof object.cameraDatabaseId === "number")
                                message.cameraDatabaseId = object.cameraDatabaseId;
                            else if (typeof object.cameraDatabaseId === "object")
                                message.cameraDatabaseId = new $util.LongBits(object.cameraDatabaseId.low >>> 0, object.cameraDatabaseId.high >>> 0).toNumber();
                        if (object.includeReferencingCameras != null)
                            message.includeReferencingCameras = Boolean(object.includeReferencingCameras);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @static
                     * @param {palexy.streaming.v1.GetCameraRequest} message GetCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.includeAreaData = false;
                            object.versionDateTime = "";
                            object.includeStoreData = false;
                            object.includeCompanyConfig = false;
                            object.includeSubviews = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraDatabaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraDatabaseId = options.longs === String ? "0" : 0;
                            object.includeReferencingCameras = false;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.includeAreaData != null && message.hasOwnProperty("includeAreaData"))
                            object.includeAreaData = message.includeAreaData;
                        if (message.versionDateTime != null && message.hasOwnProperty("versionDateTime"))
                            object.versionDateTime = message.versionDateTime;
                        if (message.includeStoreData != null && message.hasOwnProperty("includeStoreData"))
                            object.includeStoreData = message.includeStoreData;
                        if (message.includeCompanyConfig != null && message.hasOwnProperty("includeCompanyConfig"))
                            object.includeCompanyConfig = message.includeCompanyConfig;
                        if (message.includeSubviews != null && message.hasOwnProperty("includeSubviews"))
                            object.includeSubviews = message.includeSubviews;
                        if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                            if (typeof message.cameraDatabaseId === "number")
                                object.cameraDatabaseId = options.longs === String ? String(message.cameraDatabaseId) : message.cameraDatabaseId;
                            else
                                object.cameraDatabaseId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraDatabaseId) : options.longs === Number ? new $util.LongBits(message.cameraDatabaseId.low >>> 0, message.cameraDatabaseId.high >>> 0).toNumber() : message.cameraDatabaseId;
                        if (message.includeReferencingCameras != null && message.hasOwnProperty("includeReferencingCameras"))
                            object.includeReferencingCameras = message.includeReferencingCameras;
                        return object;
                    };
    
                    /**
                     * Converts this GetCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCameraRequest;
                })();
    
                v1.ListCamerasRequest = (function() {
    
                    /**
                     * Properties of a ListCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCamerasRequest
                     * @property {number|null} [pageSize] ListCamerasRequest pageSize
                     * @property {string|null} [pageToken] ListCamerasRequest pageToken
                     * @property {palexy.streaming.v1.Camera.StreamingState|null} [streamingState] ListCamerasRequest streamingState
                     * @property {boolean|null} [uncheckedPerspective] ListCamerasRequest uncheckedPerspective
                     * @property {boolean|null} [includeNotProcessing] ListCamerasRequest includeNotProcessing
                     * @property {google.protobuf.IInt64Value|null} [storeId] ListCamerasRequest storeId
                     * @property {boolean|null} [includeDisabled] ListCamerasRequest includeDisabled
                     * @property {string|null} [streamingLocation] ListCamerasRequest streamingLocation
                     * @property {palexy.streaming.v1.Camera.RetrieveVideoType|null} [retrieveVideoType] ListCamerasRequest retrieveVideoType
                     * @property {google.protobuf.IBoolValue|null} [isReferencingCamera] ListCamerasRequest isReferencingCamera
                     * @property {google.protobuf.IBoolValue|null} [isShifted] ListCamerasRequest isShifted
                     */
    
                    /**
                     * Constructs a new ListCamerasRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCamerasRequest.
                     * @implements IListCamerasRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCamerasRequest=} [properties] Properties to set
                     */
                    function ListCamerasRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCamerasRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.pageSize = 0;
    
                    /**
                     * ListCamerasRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.pageToken = "";
    
                    /**
                     * ListCamerasRequest streamingState.
                     * @member {palexy.streaming.v1.Camera.StreamingState} streamingState
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.streamingState = 0;
    
                    /**
                     * ListCamerasRequest uncheckedPerspective.
                     * @member {boolean} uncheckedPerspective
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.uncheckedPerspective = false;
    
                    /**
                     * ListCamerasRequest includeNotProcessing.
                     * @member {boolean} includeNotProcessing
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.includeNotProcessing = false;
    
                    /**
                     * ListCamerasRequest storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.storeId = null;
    
                    /**
                     * ListCamerasRequest includeDisabled.
                     * @member {boolean} includeDisabled
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.includeDisabled = false;
    
                    /**
                     * ListCamerasRequest streamingLocation.
                     * @member {string} streamingLocation
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.streamingLocation = "";
    
                    /**
                     * ListCamerasRequest retrieveVideoType.
                     * @member {palexy.streaming.v1.Camera.RetrieveVideoType} retrieveVideoType
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.retrieveVideoType = 0;
    
                    /**
                     * ListCamerasRequest isReferencingCamera.
                     * @member {google.protobuf.IBoolValue|null|undefined} isReferencingCamera
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.isReferencingCamera = null;
    
                    /**
                     * ListCamerasRequest isShifted.
                     * @member {google.protobuf.IBoolValue|null|undefined} isShifted
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     */
                    ListCamerasRequest.prototype.isShifted = null;
    
                    /**
                     * Creates a new ListCamerasRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCamerasRequest} ListCamerasRequest instance
                     */
                    ListCamerasRequest.create = function create(properties) {
                        return new ListCamerasRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCamerasRequest message. Does not implicitly {@link palexy.streaming.v1.ListCamerasRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasRequest} message ListCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCamerasRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.streamingState != null && Object.hasOwnProperty.call(message, "streamingState"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.streamingState);
                        if (message.uncheckedPerspective != null && Object.hasOwnProperty.call(message, "uncheckedPerspective"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.uncheckedPerspective);
                        if (message.includeNotProcessing != null && Object.hasOwnProperty.call(message, "includeNotProcessing"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeNotProcessing);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.includeDisabled != null && Object.hasOwnProperty.call(message, "includeDisabled"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeDisabled);
                        if (message.streamingLocation != null && Object.hasOwnProperty.call(message, "streamingLocation"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.streamingLocation);
                        if (message.retrieveVideoType != null && Object.hasOwnProperty.call(message, "retrieveVideoType"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.retrieveVideoType);
                        if (message.isReferencingCamera != null && Object.hasOwnProperty.call(message, "isReferencingCamera"))
                            $root.google.protobuf.BoolValue.encode(message.isReferencingCamera, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.isShifted != null && Object.hasOwnProperty.call(message, "isShifted"))
                            $root.google.protobuf.BoolValue.encode(message.isShifted, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCamerasRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCamerasRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasRequest} message ListCamerasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCamerasRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCamerasRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCamerasRequest} ListCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCamerasRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCamerasRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.streamingState = reader.int32();
                                break;
                            case 4:
                                message.uncheckedPerspective = reader.bool();
                                break;
                            case 5:
                                message.includeNotProcessing = reader.bool();
                                break;
                            case 6:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.includeDisabled = reader.bool();
                                break;
                            case 8:
                                message.streamingLocation = reader.string();
                                break;
                            case 9:
                                message.retrieveVideoType = reader.int32();
                                break;
                            case 10:
                                message.isReferencingCamera = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.isShifted = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCamerasRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCamerasRequest} ListCamerasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCamerasRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCamerasRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCamerasRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.streamingState != null && message.hasOwnProperty("streamingState"))
                            switch (message.streamingState) {
                            default:
                                return "streamingState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.uncheckedPerspective != null && message.hasOwnProperty("uncheckedPerspective"))
                            if (typeof message.uncheckedPerspective !== "boolean")
                                return "uncheckedPerspective: boolean expected";
                        if (message.includeNotProcessing != null && message.hasOwnProperty("includeNotProcessing"))
                            if (typeof message.includeNotProcessing !== "boolean")
                                return "includeNotProcessing: boolean expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.includeDisabled != null && message.hasOwnProperty("includeDisabled"))
                            if (typeof message.includeDisabled !== "boolean")
                                return "includeDisabled: boolean expected";
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            if (!$util.isString(message.streamingLocation))
                                return "streamingLocation: string expected";
                        if (message.retrieveVideoType != null && message.hasOwnProperty("retrieveVideoType"))
                            switch (message.retrieveVideoType) {
                            default:
                                return "retrieveVideoType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.isReferencingCamera != null && message.hasOwnProperty("isReferencingCamera")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isReferencingCamera);
                            if (error)
                                return "isReferencingCamera." + error;
                        }
                        if (message.isShifted != null && message.hasOwnProperty("isShifted")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isShifted);
                            if (error)
                                return "isShifted." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCamerasRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCamerasRequest} ListCamerasRequest
                     */
                    ListCamerasRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCamerasRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCamerasRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        switch (object.streamingState) {
                        case "UNKNOWN":
                        case 0:
                            message.streamingState = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.streamingState = 1;
                            break;
                        case "BROKEN":
                        case 2:
                            message.streamingState = 2;
                            break;
                        }
                        if (object.uncheckedPerspective != null)
                            message.uncheckedPerspective = Boolean(object.uncheckedPerspective);
                        if (object.includeNotProcessing != null)
                            message.includeNotProcessing = Boolean(object.includeNotProcessing);
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCamerasRequest.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.includeDisabled != null)
                            message.includeDisabled = Boolean(object.includeDisabled);
                        if (object.streamingLocation != null)
                            message.streamingLocation = String(object.streamingLocation);
                        switch (object.retrieveVideoType) {
                        case "RETRIEVE_VIDEO_TYPE_UNKNOWN":
                        case 0:
                            message.retrieveVideoType = 0;
                            break;
                        case "RTSP":
                        case 1:
                            message.retrieveVideoType = 1;
                            break;
                        case "DOWNLOAD":
                        case 2:
                            message.retrieveVideoType = 2;
                            break;
                        }
                        if (object.isReferencingCamera != null) {
                            if (typeof object.isReferencingCamera !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCamerasRequest.isReferencingCamera: object expected");
                            message.isReferencingCamera = $root.google.protobuf.BoolValue.fromObject(object.isReferencingCamera);
                        }
                        if (object.isShifted != null) {
                            if (typeof object.isShifted !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCamerasRequest.isShifted: object expected");
                            message.isShifted = $root.google.protobuf.BoolValue.fromObject(object.isShifted);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCamerasRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCamerasRequest} message ListCamerasRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCamerasRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.streamingState = options.enums === String ? "UNKNOWN" : 0;
                            object.uncheckedPerspective = false;
                            object.includeNotProcessing = false;
                            object.storeId = null;
                            object.includeDisabled = false;
                            object.streamingLocation = "";
                            object.retrieveVideoType = options.enums === String ? "RETRIEVE_VIDEO_TYPE_UNKNOWN" : 0;
                            object.isReferencingCamera = null;
                            object.isShifted = null;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.streamingState != null && message.hasOwnProperty("streamingState"))
                            object.streamingState = options.enums === String ? $root.palexy.streaming.v1.Camera.StreamingState[message.streamingState] : message.streamingState;
                        if (message.uncheckedPerspective != null && message.hasOwnProperty("uncheckedPerspective"))
                            object.uncheckedPerspective = message.uncheckedPerspective;
                        if (message.includeNotProcessing != null && message.hasOwnProperty("includeNotProcessing"))
                            object.includeNotProcessing = message.includeNotProcessing;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.includeDisabled != null && message.hasOwnProperty("includeDisabled"))
                            object.includeDisabled = message.includeDisabled;
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            object.streamingLocation = message.streamingLocation;
                        if (message.retrieveVideoType != null && message.hasOwnProperty("retrieveVideoType"))
                            object.retrieveVideoType = options.enums === String ? $root.palexy.streaming.v1.Camera.RetrieveVideoType[message.retrieveVideoType] : message.retrieveVideoType;
                        if (message.isReferencingCamera != null && message.hasOwnProperty("isReferencingCamera"))
                            object.isReferencingCamera = $root.google.protobuf.BoolValue.toObject(message.isReferencingCamera, options);
                        if (message.isShifted != null && message.hasOwnProperty("isShifted"))
                            object.isShifted = $root.google.protobuf.BoolValue.toObject(message.isShifted, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListCamerasRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCamerasRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCamerasRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCamerasRequest;
                })();
    
                v1.ListCamerasResponse = (function() {
    
                    /**
                     * Properties of a ListCamerasResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCamerasResponse
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [cameras] ListCamerasResponse cameras
                     * @property {string|null} [nextPageToken] ListCamerasResponse nextPageToken
                     * @property {number|null} [totalElements] ListCamerasResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListCamerasResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCamerasResponse.
                     * @implements IListCamerasResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCamerasResponse=} [properties] Properties to set
                     */
                    function ListCamerasResponse(properties) {
                        this.cameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCamerasResponse cameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} cameras
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @instance
                     */
                    ListCamerasResponse.prototype.cameras = $util.emptyArray;
    
                    /**
                     * ListCamerasResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @instance
                     */
                    ListCamerasResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListCamerasResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @instance
                     */
                    ListCamerasResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListCamerasResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCamerasResponse} ListCamerasResponse instance
                     */
                    ListCamerasResponse.create = function create(properties) {
                        return new ListCamerasResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCamerasResponse message. Does not implicitly {@link palexy.streaming.v1.ListCamerasResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasResponse} message ListCamerasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCamerasResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameras != null && message.cameras.length)
                            for (var i = 0; i < message.cameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.cameras[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCamerasResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCamerasResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCamerasResponse} message ListCamerasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCamerasResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCamerasResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCamerasResponse} ListCamerasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCamerasResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCamerasResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameras && message.cameras.length))
                                    message.cameras = [];
                                message.cameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCamerasResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCamerasResponse} ListCamerasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCamerasResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCamerasResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCamerasResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameras != null && message.hasOwnProperty("cameras")) {
                            if (!Array.isArray(message.cameras))
                                return "cameras: array expected";
                            for (var i = 0; i < message.cameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.cameras[i]);
                                if (error)
                                    return "cameras." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCamerasResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCamerasResponse} ListCamerasResponse
                     */
                    ListCamerasResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCamerasResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCamerasResponse();
                        if (object.cameras) {
                            if (!Array.isArray(object.cameras))
                                throw TypeError(".palexy.streaming.v1.ListCamerasResponse.cameras: array expected");
                            message.cameras = [];
                            for (var i = 0; i < object.cameras.length; ++i) {
                                if (typeof object.cameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCamerasResponse.cameras: object expected");
                                message.cameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.cameras[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCamerasResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCamerasResponse} message ListCamerasResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCamerasResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameras = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.cameras && message.cameras.length) {
                            object.cameras = [];
                            for (var j = 0; j < message.cameras.length; ++j)
                                object.cameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.cameras[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListCamerasResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCamerasResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCamerasResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCamerasResponse;
                })();
    
                v1.GetCameraFisheyePreviewRequest = (function() {
    
                    /**
                     * Properties of a GetCameraFisheyePreviewRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCameraFisheyePreviewRequest
                     * @property {number|null} [cameraId] GetCameraFisheyePreviewRequest cameraId
                     * @property {number|null} [photoId] GetCameraFisheyePreviewRequest photoId
                     * @property {palexy.streaming.v1.IWarpOption|null} [warpOption] GetCameraFisheyePreviewRequest warpOption
                     */
    
                    /**
                     * Constructs a new GetCameraFisheyePreviewRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCameraFisheyePreviewRequest.
                     * @implements IGetCameraFisheyePreviewRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest=} [properties] Properties to set
                     */
                    function GetCameraFisheyePreviewRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCameraFisheyePreviewRequest cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @instance
                     */
                    GetCameraFisheyePreviewRequest.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCameraFisheyePreviewRequest photoId.
                     * @member {number} photoId
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @instance
                     */
                    GetCameraFisheyePreviewRequest.prototype.photoId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCameraFisheyePreviewRequest warpOption.
                     * @member {palexy.streaming.v1.IWarpOption|null|undefined} warpOption
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @instance
                     */
                    GetCameraFisheyePreviewRequest.prototype.warpOption = null;
    
                    /**
                     * Creates a new GetCameraFisheyePreviewRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewRequest} GetCameraFisheyePreviewRequest instance
                     */
                    GetCameraFisheyePreviewRequest.create = function create(properties) {
                        return new GetCameraFisheyePreviewRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCameraFisheyePreviewRequest message. Does not implicitly {@link palexy.streaming.v1.GetCameraFisheyePreviewRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest} message GetCameraFisheyePreviewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraFisheyePreviewRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraId);
                        if (message.photoId != null && Object.hasOwnProperty.call(message, "photoId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.photoId);
                        if (message.warpOption != null && Object.hasOwnProperty.call(message, "warpOption"))
                            $root.palexy.streaming.v1.WarpOption.encode(message.warpOption, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCameraFisheyePreviewRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCameraFisheyePreviewRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewRequest} message GetCameraFisheyePreviewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraFisheyePreviewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCameraFisheyePreviewRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewRequest} GetCameraFisheyePreviewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraFisheyePreviewRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCameraFisheyePreviewRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.int64();
                                break;
                            case 2:
                                message.photoId = reader.int64();
                                break;
                            case 3:
                                message.warpOption = $root.palexy.streaming.v1.WarpOption.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCameraFisheyePreviewRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewRequest} GetCameraFisheyePreviewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraFisheyePreviewRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCameraFisheyePreviewRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCameraFisheyePreviewRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (!$util.isInteger(message.photoId) && !(message.photoId && $util.isInteger(message.photoId.low) && $util.isInteger(message.photoId.high)))
                                return "photoId: integer|Long expected";
                        if (message.warpOption != null && message.hasOwnProperty("warpOption")) {
                            var error = $root.palexy.streaming.v1.WarpOption.verify(message.warpOption);
                            if (error)
                                return "warpOption." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetCameraFisheyePreviewRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewRequest} GetCameraFisheyePreviewRequest
                     */
                    GetCameraFisheyePreviewRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCameraFisheyePreviewRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCameraFisheyePreviewRequest();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.photoId != null)
                            if ($util.Long)
                                (message.photoId = $util.Long.fromValue(object.photoId)).unsigned = false;
                            else if (typeof object.photoId === "string")
                                message.photoId = parseInt(object.photoId, 10);
                            else if (typeof object.photoId === "number")
                                message.photoId = object.photoId;
                            else if (typeof object.photoId === "object")
                                message.photoId = new $util.LongBits(object.photoId.low >>> 0, object.photoId.high >>> 0).toNumber();
                        if (object.warpOption != null) {
                            if (typeof object.warpOption !== "object")
                                throw TypeError(".palexy.streaming.v1.GetCameraFisheyePreviewRequest.warpOption: object expected");
                            message.warpOption = $root.palexy.streaming.v1.WarpOption.fromObject(object.warpOption);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCameraFisheyePreviewRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @static
                     * @param {palexy.streaming.v1.GetCameraFisheyePreviewRequest} message GetCameraFisheyePreviewRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCameraFisheyePreviewRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.photoId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.photoId = options.longs === String ? "0" : 0;
                            object.warpOption = null;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (typeof message.photoId === "number")
                                object.photoId = options.longs === String ? String(message.photoId) : message.photoId;
                            else
                                object.photoId = options.longs === String ? $util.Long.prototype.toString.call(message.photoId) : options.longs === Number ? new $util.LongBits(message.photoId.low >>> 0, message.photoId.high >>> 0).toNumber() : message.photoId;
                        if (message.warpOption != null && message.hasOwnProperty("warpOption"))
                            object.warpOption = $root.palexy.streaming.v1.WarpOption.toObject(message.warpOption, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetCameraFisheyePreviewRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCameraFisheyePreviewRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCameraFisheyePreviewRequest;
                })();
    
                v1.GetCameraFisheyePreviewResponse = (function() {
    
                    /**
                     * Properties of a GetCameraFisheyePreviewResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCameraFisheyePreviewResponse
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [dewarpedImage] GetCameraFisheyePreviewResponse dewarpedImage
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [previewImage] GetCameraFisheyePreviewResponse previewImage
                     */
    
                    /**
                     * Constructs a new GetCameraFisheyePreviewResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCameraFisheyePreviewResponse.
                     * @implements IGetCameraFisheyePreviewResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewResponse=} [properties] Properties to set
                     */
                    function GetCameraFisheyePreviewResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCameraFisheyePreviewResponse dewarpedImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} dewarpedImage
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @instance
                     */
                    GetCameraFisheyePreviewResponse.prototype.dewarpedImage = null;
    
                    /**
                     * GetCameraFisheyePreviewResponse previewImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} previewImage
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @instance
                     */
                    GetCameraFisheyePreviewResponse.prototype.previewImage = null;
    
                    /**
                     * Creates a new GetCameraFisheyePreviewResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewResponse} GetCameraFisheyePreviewResponse instance
                     */
                    GetCameraFisheyePreviewResponse.create = function create(properties) {
                        return new GetCameraFisheyePreviewResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetCameraFisheyePreviewResponse message. Does not implicitly {@link palexy.streaming.v1.GetCameraFisheyePreviewResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewResponse} message GetCameraFisheyePreviewResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraFisheyePreviewResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dewarpedImage != null && Object.hasOwnProperty.call(message, "dewarpedImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.dewarpedImage, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.previewImage != null && Object.hasOwnProperty.call(message, "previewImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.previewImage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCameraFisheyePreviewResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCameraFisheyePreviewResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCameraFisheyePreviewResponse} message GetCameraFisheyePreviewResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCameraFisheyePreviewResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCameraFisheyePreviewResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewResponse} GetCameraFisheyePreviewResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraFisheyePreviewResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCameraFisheyePreviewResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dewarpedImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.previewImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCameraFisheyePreviewResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewResponse} GetCameraFisheyePreviewResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCameraFisheyePreviewResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCameraFisheyePreviewResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCameraFisheyePreviewResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dewarpedImage != null && message.hasOwnProperty("dewarpedImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.dewarpedImage);
                            if (error)
                                return "dewarpedImage." + error;
                        }
                        if (message.previewImage != null && message.hasOwnProperty("previewImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.previewImage);
                            if (error)
                                return "previewImage." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetCameraFisheyePreviewResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCameraFisheyePreviewResponse} GetCameraFisheyePreviewResponse
                     */
                    GetCameraFisheyePreviewResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCameraFisheyePreviewResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCameraFisheyePreviewResponse();
                        if (object.dewarpedImage != null) {
                            if (typeof object.dewarpedImage !== "object")
                                throw TypeError(".palexy.streaming.v1.GetCameraFisheyePreviewResponse.dewarpedImage: object expected");
                            message.dewarpedImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.dewarpedImage);
                        }
                        if (object.previewImage != null) {
                            if (typeof object.previewImage !== "object")
                                throw TypeError(".palexy.streaming.v1.GetCameraFisheyePreviewResponse.previewImage: object expected");
                            message.previewImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.previewImage);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCameraFisheyePreviewResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @static
                     * @param {palexy.streaming.v1.GetCameraFisheyePreviewResponse} message GetCameraFisheyePreviewResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCameraFisheyePreviewResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dewarpedImage = null;
                            object.previewImage = null;
                        }
                        if (message.dewarpedImage != null && message.hasOwnProperty("dewarpedImage"))
                            object.dewarpedImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.dewarpedImage, options);
                        if (message.previewImage != null && message.hasOwnProperty("previewImage"))
                            object.previewImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.previewImage, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetCameraFisheyePreviewResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCameraFisheyePreviewResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCameraFisheyePreviewResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCameraFisheyePreviewResponse;
                })();
    
                v1.TakeSnapshotRequest = (function() {
    
                    /**
                     * Properties of a TakeSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITakeSnapshotRequest
                     * @property {number|null} [cameraId] TakeSnapshotRequest cameraId
                     * @property {string|null} [type] TakeSnapshotRequest type
                     * @property {string|null} [ext] TakeSnapshotRequest ext
                     * @property {boolean|null} [skipProcessing] TakeSnapshotRequest skipProcessing
                     */
    
                    /**
                     * Constructs a new TakeSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TakeSnapshotRequest.
                     * @implements ITakeSnapshotRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest=} [properties] Properties to set
                     */
                    function TakeSnapshotRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TakeSnapshotRequest cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @instance
                     */
                    TakeSnapshotRequest.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TakeSnapshotRequest type.
                     * @member {string} type
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @instance
                     */
                    TakeSnapshotRequest.prototype.type = "";
    
                    /**
                     * TakeSnapshotRequest ext.
                     * @member {string} ext
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @instance
                     */
                    TakeSnapshotRequest.prototype.ext = "";
    
                    /**
                     * TakeSnapshotRequest skipProcessing.
                     * @member {boolean} skipProcessing
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @instance
                     */
                    TakeSnapshotRequest.prototype.skipProcessing = false;
    
                    /**
                     * Creates a new TakeSnapshotRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TakeSnapshotRequest} TakeSnapshotRequest instance
                     */
                    TakeSnapshotRequest.create = function create(properties) {
                        return new TakeSnapshotRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TakeSnapshotRequest message. Does not implicitly {@link palexy.streaming.v1.TakeSnapshotRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest} message TakeSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakeSnapshotRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.type);
                        if (message.ext != null && Object.hasOwnProperty.call(message, "ext"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ext);
                        if (message.skipProcessing != null && Object.hasOwnProperty.call(message, "skipProcessing"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.skipProcessing);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TakeSnapshotRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TakeSnapshotRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotRequest} message TakeSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakeSnapshotRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TakeSnapshotRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TakeSnapshotRequest} TakeSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakeSnapshotRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TakeSnapshotRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.int64();
                                break;
                            case 2:
                                message.type = reader.string();
                                break;
                            case 3:
                                message.ext = reader.string();
                                break;
                            case 4:
                                message.skipProcessing = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TakeSnapshotRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TakeSnapshotRequest} TakeSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakeSnapshotRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TakeSnapshotRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TakeSnapshotRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isString(message.type))
                                return "type: string expected";
                        if (message.ext != null && message.hasOwnProperty("ext"))
                            if (!$util.isString(message.ext))
                                return "ext: string expected";
                        if (message.skipProcessing != null && message.hasOwnProperty("skipProcessing"))
                            if (typeof message.skipProcessing !== "boolean")
                                return "skipProcessing: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a TakeSnapshotRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TakeSnapshotRequest} TakeSnapshotRequest
                     */
                    TakeSnapshotRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TakeSnapshotRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TakeSnapshotRequest();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.type != null)
                            message.type = String(object.type);
                        if (object.ext != null)
                            message.ext = String(object.ext);
                        if (object.skipProcessing != null)
                            message.skipProcessing = Boolean(object.skipProcessing);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TakeSnapshotRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.TakeSnapshotRequest} message TakeSnapshotRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TakeSnapshotRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            object.type = "";
                            object.ext = "";
                            object.skipProcessing = false;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        if (message.ext != null && message.hasOwnProperty("ext"))
                            object.ext = message.ext;
                        if (message.skipProcessing != null && message.hasOwnProperty("skipProcessing"))
                            object.skipProcessing = message.skipProcessing;
                        return object;
                    };
    
                    /**
                     * Converts this TakeSnapshotRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TakeSnapshotRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TakeSnapshotRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TakeSnapshotRequest;
                })();
    
                v1.TakeSnapshotResponse = (function() {
    
                    /**
                     * Properties of a TakeSnapshotResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ITakeSnapshotResponse
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [cameraPhoto] TakeSnapshotResponse cameraPhoto
                     */
    
                    /**
                     * Constructs a new TakeSnapshotResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TakeSnapshotResponse.
                     * @implements ITakeSnapshotResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ITakeSnapshotResponse=} [properties] Properties to set
                     */
                    function TakeSnapshotResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TakeSnapshotResponse cameraPhoto.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} cameraPhoto
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @instance
                     */
                    TakeSnapshotResponse.prototype.cameraPhoto = null;
    
                    /**
                     * Creates a new TakeSnapshotResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TakeSnapshotResponse} TakeSnapshotResponse instance
                     */
                    TakeSnapshotResponse.create = function create(properties) {
                        return new TakeSnapshotResponse(properties);
                    };
    
                    /**
                     * Encodes the specified TakeSnapshotResponse message. Does not implicitly {@link palexy.streaming.v1.TakeSnapshotResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotResponse} message TakeSnapshotResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakeSnapshotResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPhoto != null && Object.hasOwnProperty.call(message, "cameraPhoto"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.cameraPhoto, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TakeSnapshotResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.TakeSnapshotResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.ITakeSnapshotResponse} message TakeSnapshotResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakeSnapshotResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TakeSnapshotResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TakeSnapshotResponse} TakeSnapshotResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakeSnapshotResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TakeSnapshotResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TakeSnapshotResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TakeSnapshotResponse} TakeSnapshotResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakeSnapshotResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TakeSnapshotResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TakeSnapshotResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.cameraPhoto);
                            if (error)
                                return "cameraPhoto." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TakeSnapshotResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TakeSnapshotResponse} TakeSnapshotResponse
                     */
                    TakeSnapshotResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TakeSnapshotResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.TakeSnapshotResponse();
                        if (object.cameraPhoto != null) {
                            if (typeof object.cameraPhoto !== "object")
                                throw TypeError(".palexy.streaming.v1.TakeSnapshotResponse.cameraPhoto: object expected");
                            message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.cameraPhoto);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TakeSnapshotResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.TakeSnapshotResponse} message TakeSnapshotResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TakeSnapshotResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cameraPhoto = null;
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto"))
                            object.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.toObject(message.cameraPhoto, options);
                        return object;
                    };
    
                    /**
                     * Converts this TakeSnapshotResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TakeSnapshotResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TakeSnapshotResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TakeSnapshotResponse;
                })();
    
                v1.UploadPhotoRequest = (function() {
    
                    /**
                     * Properties of an UploadPhotoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUploadPhotoRequest
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [cameraPhoto] UploadPhotoRequest cameraPhoto
                     */
    
                    /**
                     * Constructs a new UploadPhotoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UploadPhotoRequest.
                     * @implements IUploadPhotoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUploadPhotoRequest=} [properties] Properties to set
                     */
                    function UploadPhotoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UploadPhotoRequest cameraPhoto.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} cameraPhoto
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @instance
                     */
                    UploadPhotoRequest.prototype.cameraPhoto = null;
    
                    /**
                     * Creates a new UploadPhotoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UploadPhotoRequest} UploadPhotoRequest instance
                     */
                    UploadPhotoRequest.create = function create(properties) {
                        return new UploadPhotoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UploadPhotoRequest message. Does not implicitly {@link palexy.streaming.v1.UploadPhotoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoRequest} message UploadPhotoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadPhotoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPhoto != null && Object.hasOwnProperty.call(message, "cameraPhoto"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.cameraPhoto, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UploadPhotoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UploadPhotoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoRequest} message UploadPhotoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadPhotoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UploadPhotoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UploadPhotoRequest} UploadPhotoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadPhotoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UploadPhotoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UploadPhotoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UploadPhotoRequest} UploadPhotoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadPhotoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UploadPhotoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UploadPhotoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.cameraPhoto);
                            if (error)
                                return "cameraPhoto." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UploadPhotoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UploadPhotoRequest} UploadPhotoRequest
                     */
                    UploadPhotoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UploadPhotoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UploadPhotoRequest();
                        if (object.cameraPhoto != null) {
                            if (typeof object.cameraPhoto !== "object")
                                throw TypeError(".palexy.streaming.v1.UploadPhotoRequest.cameraPhoto: object expected");
                            message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.cameraPhoto);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UploadPhotoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.UploadPhotoRequest} message UploadPhotoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UploadPhotoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cameraPhoto = null;
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto"))
                            object.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.toObject(message.cameraPhoto, options);
                        return object;
                    };
    
                    /**
                     * Converts this UploadPhotoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UploadPhotoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UploadPhotoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UploadPhotoRequest;
                })();
    
                v1.UploadPhotoResponse = (function() {
    
                    /**
                     * Properties of an UploadPhotoResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IUploadPhotoResponse
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [cameraPhoto] UploadPhotoResponse cameraPhoto
                     */
    
                    /**
                     * Constructs a new UploadPhotoResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UploadPhotoResponse.
                     * @implements IUploadPhotoResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IUploadPhotoResponse=} [properties] Properties to set
                     */
                    function UploadPhotoResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UploadPhotoResponse cameraPhoto.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} cameraPhoto
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @instance
                     */
                    UploadPhotoResponse.prototype.cameraPhoto = null;
    
                    /**
                     * Creates a new UploadPhotoResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UploadPhotoResponse} UploadPhotoResponse instance
                     */
                    UploadPhotoResponse.create = function create(properties) {
                        return new UploadPhotoResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UploadPhotoResponse message. Does not implicitly {@link palexy.streaming.v1.UploadPhotoResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoResponse} message UploadPhotoResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadPhotoResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPhoto != null && Object.hasOwnProperty.call(message, "cameraPhoto"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.cameraPhoto, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UploadPhotoResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.UploadPhotoResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {palexy.streaming.v1.IUploadPhotoResponse} message UploadPhotoResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadPhotoResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UploadPhotoResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UploadPhotoResponse} UploadPhotoResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadPhotoResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UploadPhotoResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UploadPhotoResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UploadPhotoResponse} UploadPhotoResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadPhotoResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UploadPhotoResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UploadPhotoResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.cameraPhoto);
                            if (error)
                                return "cameraPhoto." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UploadPhotoResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UploadPhotoResponse} UploadPhotoResponse
                     */
                    UploadPhotoResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UploadPhotoResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.UploadPhotoResponse();
                        if (object.cameraPhoto != null) {
                            if (typeof object.cameraPhoto !== "object")
                                throw TypeError(".palexy.streaming.v1.UploadPhotoResponse.cameraPhoto: object expected");
                            message.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.cameraPhoto);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UploadPhotoResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @static
                     * @param {palexy.streaming.v1.UploadPhotoResponse} message UploadPhotoResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UploadPhotoResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.cameraPhoto = null;
                        if (message.cameraPhoto != null && message.hasOwnProperty("cameraPhoto"))
                            object.cameraPhoto = $root.palexy.streaming.v1.CameraPhoto.toObject(message.cameraPhoto, options);
                        return object;
                    };
    
                    /**
                     * Converts this UploadPhotoResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UploadPhotoResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UploadPhotoResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UploadPhotoResponse;
                })();
    
                v1.FetchCamerasReadyToScheduleDownloadRequest = (function() {
    
                    /**
                     * Properties of a FetchCamerasReadyToScheduleDownloadRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchCamerasReadyToScheduleDownloadRequest
                     * @property {string|null} [dateId] FetchCamerasReadyToScheduleDownloadRequest dateId
                     * @property {string|null} [timezone] FetchCamerasReadyToScheduleDownloadRequest timezone
                     */
    
                    /**
                     * Constructs a new FetchCamerasReadyToScheduleDownloadRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchCamerasReadyToScheduleDownloadRequest.
                     * @implements IFetchCamerasReadyToScheduleDownloadRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest=} [properties] Properties to set
                     */
                    function FetchCamerasReadyToScheduleDownloadRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchCamerasReadyToScheduleDownloadRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @instance
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.prototype.dateId = "";
    
                    /**
                     * FetchCamerasReadyToScheduleDownloadRequest timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @instance
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.prototype.timezone = "";
    
                    /**
                     * Creates a new FetchCamerasReadyToScheduleDownloadRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest} FetchCamerasReadyToScheduleDownloadRequest instance
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.create = function create(properties) {
                        return new FetchCamerasReadyToScheduleDownloadRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchCamerasReadyToScheduleDownloadRequest message. Does not implicitly {@link palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest} message FetchCamerasReadyToScheduleDownloadRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.dateId);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.timezone);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchCamerasReadyToScheduleDownloadRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadRequest} message FetchCamerasReadyToScheduleDownloadRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchCamerasReadyToScheduleDownloadRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest} FetchCamerasReadyToScheduleDownloadRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.string();
                                break;
                            case 2:
                                message.timezone = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchCamerasReadyToScheduleDownloadRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest} FetchCamerasReadyToScheduleDownloadRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchCamerasReadyToScheduleDownloadRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchCamerasReadyToScheduleDownloadRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest} FetchCamerasReadyToScheduleDownloadRequest
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchCamerasReadyToScheduleDownloadRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest} message FetchCamerasReadyToScheduleDownloadRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dateId = "";
                            object.timezone = "";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        return object;
                    };
    
                    /**
                     * Converts this FetchCamerasReadyToScheduleDownloadRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchCamerasReadyToScheduleDownloadRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchCamerasReadyToScheduleDownloadRequest;
                })();
    
                v1.FetchCamerasReadyToScheduleDownloadResponse = (function() {
    
                    /**
                     * Properties of a FetchCamerasReadyToScheduleDownloadResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchCamerasReadyToScheduleDownloadResponse
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [cameras] FetchCamerasReadyToScheduleDownloadResponse cameras
                     */
    
                    /**
                     * Constructs a new FetchCamerasReadyToScheduleDownloadResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchCamerasReadyToScheduleDownloadResponse.
                     * @implements IFetchCamerasReadyToScheduleDownloadResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadResponse=} [properties] Properties to set
                     */
                    function FetchCamerasReadyToScheduleDownloadResponse(properties) {
                        this.cameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchCamerasReadyToScheduleDownloadResponse cameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} cameras
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @instance
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.prototype.cameras = $util.emptyArray;
    
                    /**
                     * Creates a new FetchCamerasReadyToScheduleDownloadResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} FetchCamerasReadyToScheduleDownloadResponse instance
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.create = function create(properties) {
                        return new FetchCamerasReadyToScheduleDownloadResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchCamerasReadyToScheduleDownloadResponse message. Does not implicitly {@link palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadResponse} message FetchCamerasReadyToScheduleDownloadResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameras != null && message.cameras.length)
                            for (var i = 0; i < message.cameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.cameras[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchCamerasReadyToScheduleDownloadResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchCamerasReadyToScheduleDownloadResponse} message FetchCamerasReadyToScheduleDownloadResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchCamerasReadyToScheduleDownloadResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} FetchCamerasReadyToScheduleDownloadResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameras && message.cameras.length))
                                    message.cameras = [];
                                message.cameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchCamerasReadyToScheduleDownloadResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} FetchCamerasReadyToScheduleDownloadResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchCamerasReadyToScheduleDownloadResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameras != null && message.hasOwnProperty("cameras")) {
                            if (!Array.isArray(message.cameras))
                                return "cameras: array expected";
                            for (var i = 0; i < message.cameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.cameras[i]);
                                if (error)
                                    return "cameras." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchCamerasReadyToScheduleDownloadResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} FetchCamerasReadyToScheduleDownloadResponse
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse();
                        if (object.cameras) {
                            if (!Array.isArray(object.cameras))
                                throw TypeError(".palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse.cameras: array expected");
                            message.cameras = [];
                            for (var i = 0; i < object.cameras.length; ++i) {
                                if (typeof object.cameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse.cameras: object expected");
                                message.cameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.cameras[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchCamerasReadyToScheduleDownloadResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse} message FetchCamerasReadyToScheduleDownloadResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameras = [];
                        if (message.cameras && message.cameras.length) {
                            object.cameras = [];
                            for (var j = 0; j < message.cameras.length; ++j)
                                object.cameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.cameras[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchCamerasReadyToScheduleDownloadResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchCamerasReadyToScheduleDownloadResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchCamerasReadyToScheduleDownloadResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchCamerasReadyToScheduleDownloadResponse;
                })();
    
                v1.VideoService = (function() {
    
                    /**
                     * Constructs a new VideoService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VideoService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function VideoService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (VideoService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = VideoService;
    
                    /**
                     * Creates new VideoService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.VideoService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {VideoService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    VideoService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#createVideo}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef CreateVideoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Video} [response] Video
                     */
    
                    /**
                     * Calls CreateVideo.
                     * @function createVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateVideoRequest} request CreateVideoRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.CreateVideoCallback} callback Node-style callback called with the error, if any, and Video
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.createVideo = function createVideo(request, callback) {
                        return this.rpcCall(createVideo, $root.palexy.streaming.v1.CreateVideoRequest, $root.palexy.streaming.v1.Video, request, callback);
                    }, "name", { value: "CreateVideo" });
    
                    /**
                     * Calls CreateVideo.
                     * @function createVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateVideoRequest} request CreateVideoRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Video>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#updateVideo}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef UpdateVideoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Video} [response] Video
                     */
    
                    /**
                     * Calls UpdateVideo.
                     * @function updateVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateVideoRequest} request UpdateVideoRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.UpdateVideoCallback} callback Node-style callback called with the error, if any, and Video
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.updateVideo = function updateVideo(request, callback) {
                        return this.rpcCall(updateVideo, $root.palexy.streaming.v1.UpdateVideoRequest, $root.palexy.streaming.v1.Video, request, callback);
                    }, "name", { value: "UpdateVideo" });
    
                    /**
                     * Calls UpdateVideo.
                     * @function updateVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateVideoRequest} request UpdateVideoRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Video>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#deleteVideo}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef DeleteVideoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteVideo.
                     * @function deleteVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteVideoRequest} request DeleteVideoRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.DeleteVideoCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.deleteVideo = function deleteVideo(request, callback) {
                        return this.rpcCall(deleteVideo, $root.palexy.streaming.v1.DeleteVideoRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteVideo" });
    
                    /**
                     * Calls DeleteVideo.
                     * @function deleteVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteVideoRequest} request DeleteVideoRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#submitDeleteVideoTasks}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef SubmitDeleteVideoTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SubmitDeleteVideoTasks.
                     * @function submitDeleteVideoTasks
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest} request SubmitDeleteVideoTasksRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.SubmitDeleteVideoTasksCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.submitDeleteVideoTasks = function submitDeleteVideoTasks(request, callback) {
                        return this.rpcCall(submitDeleteVideoTasks, $root.palexy.streaming.v1.SubmitDeleteVideoTasksRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SubmitDeleteVideoTasks" });
    
                    /**
                     * Calls SubmitDeleteVideoTasks.
                     * @function submitDeleteVideoTasks
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest} request SubmitDeleteVideoTasksRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#batchUpdateVideos}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef BatchUpdateVideosCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls BatchUpdateVideos.
                     * @function batchUpdateVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest} request BatchUpdateVideoRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.BatchUpdateVideosCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.batchUpdateVideos = function batchUpdateVideos(request, callback) {
                        return this.rpcCall(batchUpdateVideos, $root.palexy.streaming.v1.BatchUpdateVideoRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "BatchUpdateVideos" });
    
                    /**
                     * Calls BatchUpdateVideos.
                     * @function batchUpdateVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest} request BatchUpdateVideoRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchVideosReadyForMerge}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchVideosReadyForMergeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosReadyForMergeResponse} [response] FetchVideosReadyForMergeResponse
                     */
    
                    /**
                     * Calls FetchVideosReadyForMerge.
                     * @function fetchVideosReadyForMerge
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest} request FetchVideosReadyForMergeRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchVideosReadyForMergeCallback} callback Node-style callback called with the error, if any, and FetchVideosReadyForMergeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchVideosReadyForMerge = function fetchVideosReadyForMerge(request, callback) {
                        return this.rpcCall(fetchVideosReadyForMerge, $root.palexy.streaming.v1.FetchVideosReadyForMergeRequest, $root.palexy.streaming.v1.FetchVideosReadyForMergeResponse, request, callback);
                    }, "name", { value: "FetchVideosReadyForMerge" });
    
                    /**
                     * Calls FetchVideosReadyForMerge.
                     * @function fetchVideosReadyForMerge
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest} request FetchVideosReadyForMergeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosReadyForMergeResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchVideos}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchVideosCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosResponse} [response] FetchVideosResponse
                     */
    
                    /**
                     * Calls FetchVideos.
                     * @function fetchVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosRequest} request FetchVideosRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchVideosCallback} callback Node-style callback called with the error, if any, and FetchVideosResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchVideos = function fetchVideos(request, callback) {
                        return this.rpcCall(fetchVideos, $root.palexy.streaming.v1.FetchVideosRequest, $root.palexy.streaming.v1.FetchVideosResponse, request, callback);
                    }, "name", { value: "FetchVideos" });
    
                    /**
                     * Calls FetchVideos.
                     * @function fetchVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosRequest} request FetchVideosRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#getVideo}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef GetVideoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Video} [response] Video
                     */
    
                    /**
                     * Calls GetVideo.
                     * @function getVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IGetVideoRequest} request GetVideoRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.GetVideoCallback} callback Node-style callback called with the error, if any, and Video
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.getVideo = function getVideo(request, callback) {
                        return this.rpcCall(getVideo, $root.palexy.streaming.v1.GetVideoRequest, $root.palexy.streaming.v1.Video, request, callback);
                    }, "name", { value: "GetVideo" });
    
                    /**
                     * Calls GetVideo.
                     * @function getVideo
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IGetVideoRequest} request GetVideoRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Video>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchVideosReadyForPartialMerge}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchVideosReadyForPartialMergeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} [response] FetchVideosReadyForPartialMergeResponse
                     */
    
                    /**
                     * Calls FetchVideosReadyForPartialMerge.
                     * @function fetchVideosReadyForPartialMerge
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest} request FetchVideosReadyForPartialMergeRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchVideosReadyForPartialMergeCallback} callback Node-style callback called with the error, if any, and FetchVideosReadyForPartialMergeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchVideosReadyForPartialMerge = function fetchVideosReadyForPartialMerge(request, callback) {
                        return this.rpcCall(fetchVideosReadyForPartialMerge, $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest, $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse, request, callback);
                    }, "name", { value: "FetchVideosReadyForPartialMerge" });
    
                    /**
                     * Calls FetchVideosReadyForPartialMerge.
                     * @function fetchVideosReadyForPartialMerge
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest} request FetchVideosReadyForPartialMergeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchVideosForEarlyDelete}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchVideosForEarlyDeleteCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosResponse} [response] FetchVideosResponse
                     */
    
                    /**
                     * Calls FetchVideosForEarlyDelete.
                     * @function fetchVideosForEarlyDelete
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest} request FetchVideosForEarlyDeleteRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchVideosForEarlyDeleteCallback} callback Node-style callback called with the error, if any, and FetchVideosResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchVideosForEarlyDelete = function fetchVideosForEarlyDelete(request, callback) {
                        return this.rpcCall(fetchVideosForEarlyDelete, $root.palexy.streaming.v1.FetchVideosForEarlyDeleteRequest, $root.palexy.streaming.v1.FetchVideosResponse, request, callback);
                    }, "name", { value: "FetchVideosForEarlyDelete" });
    
                    /**
                     * Calls FetchVideosForEarlyDelete.
                     * @function fetchVideosForEarlyDelete
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest} request FetchVideosForEarlyDeleteRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchNonDeletedDataVideos}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchNonDeletedDataVideosCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosResponse} [response] FetchVideosResponse
                     */
    
                    /**
                     * Calls FetchNonDeletedDataVideos.
                     * @function fetchNonDeletedDataVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest} request FetchNonDeletedDataVideosRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchNonDeletedDataVideosCallback} callback Node-style callback called with the error, if any, and FetchVideosResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchNonDeletedDataVideos = function fetchNonDeletedDataVideos(request, callback) {
                        return this.rpcCall(fetchNonDeletedDataVideos, $root.palexy.streaming.v1.FetchNonDeletedDataVideosRequest, $root.palexy.streaming.v1.FetchVideosResponse, request, callback);
                    }, "name", { value: "FetchNonDeletedDataVideos" });
    
                    /**
                     * Calls FetchNonDeletedDataVideos.
                     * @function fetchNonDeletedDataVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest} request FetchNonDeletedDataVideosRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.VideoService#fetchNonArchivedDataVideos}.
                     * @memberof palexy.streaming.v1.VideoService
                     * @typedef FetchNonArchivedDataVideosCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchVideosResponse} [response] FetchVideosResponse
                     */
    
                    /**
                     * Calls FetchNonArchivedDataVideos.
                     * @function fetchNonArchivedDataVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest} request FetchNonArchivedDataVideosRequest message or plain object
                     * @param {palexy.streaming.v1.VideoService.FetchNonArchivedDataVideosCallback} callback Node-style callback called with the error, if any, and FetchVideosResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(VideoService.prototype.fetchNonArchivedDataVideos = function fetchNonArchivedDataVideos(request, callback) {
                        return this.rpcCall(fetchNonArchivedDataVideos, $root.palexy.streaming.v1.FetchNonArchivedDataVideosRequest, $root.palexy.streaming.v1.FetchVideosResponse, request, callback);
                    }, "name", { value: "FetchNonArchivedDataVideos" });
    
                    /**
                     * Calls FetchNonArchivedDataVideos.
                     * @function fetchNonArchivedDataVideos
                     * @memberof palexy.streaming.v1.VideoService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest} request FetchNonArchivedDataVideosRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchVideosResponse>} Promise
                     * @variation 2
                     */
    
                    return VideoService;
                })();
    
                v1.GetVideoRequest = (function() {
    
                    /**
                     * Properties of a GetVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetVideoRequest
                     * @property {string|null} [name] GetVideoRequest name
                     */
    
                    /**
                     * Constructs a new GetVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetVideoRequest.
                     * @implements IGetVideoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetVideoRequest=} [properties] Properties to set
                     */
                    function GetVideoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetVideoRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @instance
                     */
                    GetVideoRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetVideoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetVideoRequest} GetVideoRequest instance
                     */
                    GetVideoRequest.create = function create(properties) {
                        return new GetVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetVideoRequest message. Does not implicitly {@link palexy.streaming.v1.GetVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetVideoRequest} message GetVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetVideoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetVideoRequest} message GetVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetVideoRequest} GetVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetVideoRequest} GetVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetVideoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetVideoRequest} GetVideoRequest
                     */
                    GetVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetVideoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetVideoRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.GetVideoRequest} message GetVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetVideoRequest;
                })();
    
                v1.BatchUpdateVideoRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateVideoRequest
                     * @property {Array.<palexy.streaming.v1.IUpdateVideoRequest>|null} [updateVideoRequests] BatchUpdateVideoRequest updateVideoRequests
                     * @property {palexy.streaming.v1.ISendToQueueRequest|null} [sendToQueueRequest] BatchUpdateVideoRequest sendToQueueRequest
                     */
    
                    /**
                     * Constructs a new BatchUpdateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateVideoRequest.
                     * @implements IBatchUpdateVideoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest=} [properties] Properties to set
                     */
                    function BatchUpdateVideoRequest(properties) {
                        this.updateVideoRequests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateVideoRequest updateVideoRequests.
                     * @member {Array.<palexy.streaming.v1.IUpdateVideoRequest>} updateVideoRequests
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @instance
                     */
                    BatchUpdateVideoRequest.prototype.updateVideoRequests = $util.emptyArray;
    
                    /**
                     * BatchUpdateVideoRequest sendToQueueRequest.
                     * @member {palexy.streaming.v1.ISendToQueueRequest|null|undefined} sendToQueueRequest
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @instance
                     */
                    BatchUpdateVideoRequest.prototype.sendToQueueRequest = null;
    
                    /**
                     * Creates a new BatchUpdateVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateVideoRequest} BatchUpdateVideoRequest instance
                     */
                    BatchUpdateVideoRequest.create = function create(properties) {
                        return new BatchUpdateVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateVideoRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest} message BatchUpdateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.updateVideoRequests != null && message.updateVideoRequests.length)
                            for (var i = 0; i < message.updateVideoRequests.length; ++i)
                                $root.palexy.streaming.v1.UpdateVideoRequest.encode(message.updateVideoRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.sendToQueueRequest != null && Object.hasOwnProperty.call(message, "sendToQueueRequest"))
                            $root.palexy.streaming.v1.SendToQueueRequest.encode(message.sendToQueueRequest, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateVideoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateVideoRequest} message BatchUpdateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateVideoRequest} BatchUpdateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.updateVideoRequests && message.updateVideoRequests.length))
                                    message.updateVideoRequests = [];
                                message.updateVideoRequests.push($root.palexy.streaming.v1.UpdateVideoRequest.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.sendToQueueRequest = $root.palexy.streaming.v1.SendToQueueRequest.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateVideoRequest} BatchUpdateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateVideoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.updateVideoRequests != null && message.hasOwnProperty("updateVideoRequests")) {
                            if (!Array.isArray(message.updateVideoRequests))
                                return "updateVideoRequests: array expected";
                            for (var i = 0; i < message.updateVideoRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.UpdateVideoRequest.verify(message.updateVideoRequests[i]);
                                if (error)
                                    return "updateVideoRequests." + error;
                            }
                        }
                        if (message.sendToQueueRequest != null && message.hasOwnProperty("sendToQueueRequest")) {
                            var error = $root.palexy.streaming.v1.SendToQueueRequest.verify(message.sendToQueueRequest);
                            if (error)
                                return "sendToQueueRequest." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateVideoRequest} BatchUpdateVideoRequest
                     */
                    BatchUpdateVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateVideoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateVideoRequest();
                        if (object.updateVideoRequests) {
                            if (!Array.isArray(object.updateVideoRequests))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateVideoRequest.updateVideoRequests: array expected");
                            message.updateVideoRequests = [];
                            for (var i = 0; i < object.updateVideoRequests.length; ++i) {
                                if (typeof object.updateVideoRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateVideoRequest.updateVideoRequests: object expected");
                                message.updateVideoRequests[i] = $root.palexy.streaming.v1.UpdateVideoRequest.fromObject(object.updateVideoRequests[i]);
                            }
                        }
                        if (object.sendToQueueRequest != null) {
                            if (typeof object.sendToQueueRequest !== "object")
                                throw TypeError(".palexy.streaming.v1.BatchUpdateVideoRequest.sendToQueueRequest: object expected");
                            message.sendToQueueRequest = $root.palexy.streaming.v1.SendToQueueRequest.fromObject(object.sendToQueueRequest);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateVideoRequest} message BatchUpdateVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.updateVideoRequests = [];
                        if (options.defaults)
                            object.sendToQueueRequest = null;
                        if (message.updateVideoRequests && message.updateVideoRequests.length) {
                            object.updateVideoRequests = [];
                            for (var j = 0; j < message.updateVideoRequests.length; ++j)
                                object.updateVideoRequests[j] = $root.palexy.streaming.v1.UpdateVideoRequest.toObject(message.updateVideoRequests[j], options);
                        }
                        if (message.sendToQueueRequest != null && message.hasOwnProperty("sendToQueueRequest"))
                            object.sendToQueueRequest = $root.palexy.streaming.v1.SendToQueueRequest.toObject(message.sendToQueueRequest, options);
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateVideoRequest;
                })();
    
                v1.SendToQueueRequest = (function() {
    
                    /**
                     * Properties of a SendToQueueRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendToQueueRequest
                     * @property {string|null} [destinationQueueName] SendToQueueRequest destinationQueueName
                     * @property {Uint8Array|null} [messageContent] SendToQueueRequest messageContent
                     * @property {string|null} [traceId] SendToQueueRequest traceId
                     */
    
                    /**
                     * Constructs a new SendToQueueRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendToQueueRequest.
                     * @implements ISendToQueueRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendToQueueRequest=} [properties] Properties to set
                     */
                    function SendToQueueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendToQueueRequest destinationQueueName.
                     * @member {string} destinationQueueName
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @instance
                     */
                    SendToQueueRequest.prototype.destinationQueueName = "";
    
                    /**
                     * SendToQueueRequest messageContent.
                     * @member {Uint8Array} messageContent
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @instance
                     */
                    SendToQueueRequest.prototype.messageContent = $util.newBuffer([]);
    
                    /**
                     * SendToQueueRequest traceId.
                     * @member {string} traceId
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @instance
                     */
                    SendToQueueRequest.prototype.traceId = "";
    
                    /**
                     * Creates a new SendToQueueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendToQueueRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendToQueueRequest} SendToQueueRequest instance
                     */
                    SendToQueueRequest.create = function create(properties) {
                        return new SendToQueueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendToQueueRequest message. Does not implicitly {@link palexy.streaming.v1.SendToQueueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendToQueueRequest} message SendToQueueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendToQueueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.destinationQueueName != null && Object.hasOwnProperty.call(message, "destinationQueueName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.destinationQueueName);
                        if (message.messageContent != null && Object.hasOwnProperty.call(message, "messageContent"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.messageContent);
                        if (message.traceId != null && Object.hasOwnProperty.call(message, "traceId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.traceId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendToQueueRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendToQueueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendToQueueRequest} message SendToQueueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendToQueueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendToQueueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendToQueueRequest} SendToQueueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendToQueueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendToQueueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.destinationQueueName = reader.string();
                                break;
                            case 2:
                                message.messageContent = reader.bytes();
                                break;
                            case 3:
                                message.traceId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendToQueueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendToQueueRequest} SendToQueueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendToQueueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendToQueueRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendToQueueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.destinationQueueName != null && message.hasOwnProperty("destinationQueueName"))
                            if (!$util.isString(message.destinationQueueName))
                                return "destinationQueueName: string expected";
                        if (message.messageContent != null && message.hasOwnProperty("messageContent"))
                            if (!(message.messageContent && typeof message.messageContent.length === "number" || $util.isString(message.messageContent)))
                                return "messageContent: buffer expected";
                        if (message.traceId != null && message.hasOwnProperty("traceId"))
                            if (!$util.isString(message.traceId))
                                return "traceId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendToQueueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendToQueueRequest} SendToQueueRequest
                     */
                    SendToQueueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendToQueueRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendToQueueRequest();
                        if (object.destinationQueueName != null)
                            message.destinationQueueName = String(object.destinationQueueName);
                        if (object.messageContent != null)
                            if (typeof object.messageContent === "string")
                                $util.base64.decode(object.messageContent, message.messageContent = $util.newBuffer($util.base64.length(object.messageContent)), 0);
                            else if (object.messageContent.length)
                                message.messageContent = object.messageContent;
                        if (object.traceId != null)
                            message.traceId = String(object.traceId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendToQueueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @static
                     * @param {palexy.streaming.v1.SendToQueueRequest} message SendToQueueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendToQueueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.destinationQueueName = "";
                            if (options.bytes === String)
                                object.messageContent = "";
                            else {
                                object.messageContent = [];
                                if (options.bytes !== Array)
                                    object.messageContent = $util.newBuffer(object.messageContent);
                            }
                            object.traceId = "";
                        }
                        if (message.destinationQueueName != null && message.hasOwnProperty("destinationQueueName"))
                            object.destinationQueueName = message.destinationQueueName;
                        if (message.messageContent != null && message.hasOwnProperty("messageContent"))
                            object.messageContent = options.bytes === String ? $util.base64.encode(message.messageContent, 0, message.messageContent.length) : options.bytes === Array ? Array.prototype.slice.call(message.messageContent) : message.messageContent;
                        if (message.traceId != null && message.hasOwnProperty("traceId"))
                            object.traceId = message.traceId;
                        return object;
                    };
    
                    /**
                     * Converts this SendToQueueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendToQueueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendToQueueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendToQueueRequest;
                })();
    
                v1.FetchVideosRequest = (function() {
    
                    /**
                     * Properties of a FetchVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosRequest
                     * @property {palexy.streaming.v1.IVideoFilter|null} [filter] FetchVideosRequest filter
                     * @property {number|null} [pageSize] FetchVideosRequest pageSize
                     * @property {string|null} [pageToken] FetchVideosRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosRequest.
                     * @implements IFetchVideosRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosRequest=} [properties] Properties to set
                     */
                    function FetchVideosRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosRequest filter.
                     * @member {palexy.streaming.v1.IVideoFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @instance
                     */
                    FetchVideosRequest.prototype.filter = null;
    
                    /**
                     * FetchVideosRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @instance
                     */
                    FetchVideosRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchVideosRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @instance
                     */
                    FetchVideosRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchVideosRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosRequest} FetchVideosRequest instance
                     */
                    FetchVideosRequest.create = function create(properties) {
                        return new FetchVideosRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosRequest message. Does not implicitly {@link palexy.streaming.v1.FetchVideosRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosRequest} message FetchVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.VideoFilter.encode(message.filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosRequest} message FetchVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosRequest} FetchVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filter = $root.palexy.streaming.v1.VideoFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosRequest} FetchVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.VideoFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosRequest} FetchVideosRequest
                     */
                    FetchVideosRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosRequest();
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchVideosRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.VideoFilter.fromObject(object.filter);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosRequest} message FetchVideosRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.filter = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.VideoFilter.toObject(message.filter, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosRequest;
                })();
    
                v1.FetchVideosResponse = (function() {
    
                    /**
                     * Properties of a FetchVideosResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosResponse
                     * @property {Array.<palexy.streaming.v1.IVideo>|null} [videos] FetchVideosResponse videos
                     * @property {string|null} [nextPageToken] FetchVideosResponse nextPageToken
                     * @property {number|null} [totalElements] FetchVideosResponse totalElements
                     */
    
                    /**
                     * Constructs a new FetchVideosResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosResponse.
                     * @implements IFetchVideosResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosResponse=} [properties] Properties to set
                     */
                    function FetchVideosResponse(properties) {
                        this.videos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosResponse videos.
                     * @member {Array.<palexy.streaming.v1.IVideo>} videos
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @instance
                     */
                    FetchVideosResponse.prototype.videos = $util.emptyArray;
    
                    /**
                     * FetchVideosResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @instance
                     */
                    FetchVideosResponse.prototype.nextPageToken = "";
    
                    /**
                     * FetchVideosResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @instance
                     */
                    FetchVideosResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FetchVideosResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosResponse} FetchVideosResponse instance
                     */
                    FetchVideosResponse.create = function create(properties) {
                        return new FetchVideosResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosResponse message. Does not implicitly {@link palexy.streaming.v1.FetchVideosResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosResponse} message FetchVideosResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.videos != null && message.videos.length)
                            for (var i = 0; i < message.videos.length; ++i)
                                $root.palexy.streaming.v1.Video.encode(message.videos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosResponse} message FetchVideosResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosResponse} FetchVideosResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.videos && message.videos.length))
                                    message.videos = [];
                                message.videos.push($root.palexy.streaming.v1.Video.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosResponse} FetchVideosResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.videos != null && message.hasOwnProperty("videos")) {
                            if (!Array.isArray(message.videos))
                                return "videos: array expected";
                            for (var i = 0; i < message.videos.length; ++i) {
                                var error = $root.palexy.streaming.v1.Video.verify(message.videos[i]);
                                if (error)
                                    return "videos." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosResponse} FetchVideosResponse
                     */
                    FetchVideosResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosResponse();
                        if (object.videos) {
                            if (!Array.isArray(object.videos))
                                throw TypeError(".palexy.streaming.v1.FetchVideosResponse.videos: array expected");
                            message.videos = [];
                            for (var i = 0; i < object.videos.length; ++i) {
                                if (typeof object.videos[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchVideosResponse.videos: object expected");
                                message.videos[i] = $root.palexy.streaming.v1.Video.fromObject(object.videos[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosResponse} message FetchVideosResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.videos = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.videos && message.videos.length) {
                            object.videos = [];
                            for (var j = 0; j < message.videos.length; ++j)
                                object.videos[j] = $root.palexy.streaming.v1.Video.toObject(message.videos[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosResponse;
                })();
    
                v1.FetchStoreSnapshotsResponse = (function() {
    
                    /**
                     * Properties of a FetchStoreSnapshotsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchStoreSnapshotsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreSnapshot>|null} [storeSnapshots] FetchStoreSnapshotsResponse storeSnapshots
                     * @property {string|null} [nextPageToken] FetchStoreSnapshotsResponse nextPageToken
                     * @property {number|null} [totalElements] FetchStoreSnapshotsResponse totalElements
                     */
    
                    /**
                     * Constructs a new FetchStoreSnapshotsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchStoreSnapshotsResponse.
                     * @implements IFetchStoreSnapshotsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsResponse=} [properties] Properties to set
                     */
                    function FetchStoreSnapshotsResponse(properties) {
                        this.storeSnapshots = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchStoreSnapshotsResponse storeSnapshots.
                     * @member {Array.<palexy.streaming.v1.IStoreSnapshot>} storeSnapshots
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @instance
                     */
                    FetchStoreSnapshotsResponse.prototype.storeSnapshots = $util.emptyArray;
    
                    /**
                     * FetchStoreSnapshotsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @instance
                     */
                    FetchStoreSnapshotsResponse.prototype.nextPageToken = "";
    
                    /**
                     * FetchStoreSnapshotsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @instance
                     */
                    FetchStoreSnapshotsResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FetchStoreSnapshotsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsResponse} FetchStoreSnapshotsResponse instance
                     */
                    FetchStoreSnapshotsResponse.create = function create(properties) {
                        return new FetchStoreSnapshotsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchStoreSnapshotsResponse message. Does not implicitly {@link palexy.streaming.v1.FetchStoreSnapshotsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsResponse} message FetchStoreSnapshotsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreSnapshotsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeSnapshots != null && message.storeSnapshots.length)
                            for (var i = 0; i < message.storeSnapshots.length; ++i)
                                $root.palexy.streaming.v1.StoreSnapshot.encode(message.storeSnapshots[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchStoreSnapshotsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchStoreSnapshotsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsResponse} message FetchStoreSnapshotsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreSnapshotsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchStoreSnapshotsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsResponse} FetchStoreSnapshotsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreSnapshotsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchStoreSnapshotsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeSnapshots && message.storeSnapshots.length))
                                    message.storeSnapshots = [];
                                message.storeSnapshots.push($root.palexy.streaming.v1.StoreSnapshot.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchStoreSnapshotsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsResponse} FetchStoreSnapshotsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreSnapshotsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchStoreSnapshotsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchStoreSnapshotsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeSnapshots != null && message.hasOwnProperty("storeSnapshots")) {
                            if (!Array.isArray(message.storeSnapshots))
                                return "storeSnapshots: array expected";
                            for (var i = 0; i < message.storeSnapshots.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreSnapshot.verify(message.storeSnapshots[i]);
                                if (error)
                                    return "storeSnapshots." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchStoreSnapshotsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsResponse} FetchStoreSnapshotsResponse
                     */
                    FetchStoreSnapshotsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchStoreSnapshotsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchStoreSnapshotsResponse();
                        if (object.storeSnapshots) {
                            if (!Array.isArray(object.storeSnapshots))
                                throw TypeError(".palexy.streaming.v1.FetchStoreSnapshotsResponse.storeSnapshots: array expected");
                            message.storeSnapshots = [];
                            for (var i = 0; i < object.storeSnapshots.length; ++i) {
                                if (typeof object.storeSnapshots[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchStoreSnapshotsResponse.storeSnapshots: object expected");
                                message.storeSnapshots[i] = $root.palexy.streaming.v1.StoreSnapshot.fromObject(object.storeSnapshots[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchStoreSnapshotsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchStoreSnapshotsResponse} message FetchStoreSnapshotsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchStoreSnapshotsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeSnapshots = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.storeSnapshots && message.storeSnapshots.length) {
                            object.storeSnapshots = [];
                            for (var j = 0; j < message.storeSnapshots.length; ++j)
                                object.storeSnapshots[j] = $root.palexy.streaming.v1.StoreSnapshot.toObject(message.storeSnapshots[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this FetchStoreSnapshotsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchStoreSnapshotsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchStoreSnapshotsResponse;
                })();
    
                v1.VideoFilter = (function() {
    
                    /**
                     * Properties of a VideoFilter.
                     * @memberof palexy.streaming.v1
                     * @interface IVideoFilter
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] VideoFilter fromDate
                     * @property {palexy.streaming.v1.IDateFilter|null} [to] VideoFilter to
                     * @property {palexy.streaming.v1.Video.State|null} [state] VideoFilter state
                     * @property {boolean|null} [isAlreadyPurged] VideoFilter isAlreadyPurged
                     * @property {Array.<string>|null} [cameraIds] VideoFilter cameraIds
                     * @property {number|null} [storeId] VideoFilter storeId
                     * @property {boolean|null} [archived] VideoFilter archived
                     * @property {google.protobuf.IBoolValue|null} [isAlreadyPurgedValue] VideoFilter isAlreadyPurgedValue
                     * @property {google.protobuf.IBoolValue|null} [archivedValue] VideoFilter archivedValue
                     * @property {google.protobuf.IBoolValue|null} [isQcData] VideoFilter isQcData
                     * @property {google.protobuf.IBoolValue|null} [isVideoAlreadyPurged] VideoFilter isVideoAlreadyPurged
                     * @property {google.protobuf.IBoolValue|null} [isTrackingFileAlreadyPurged] VideoFilter isTrackingFileAlreadyPurged
                     * @property {google.protobuf.IBoolValue|null} [isVideoArchived] VideoFilter isVideoArchived
                     * @property {google.protobuf.IBoolValue|null} [isTrackingFileArchived] VideoFilter isTrackingFileArchived
                     * @property {string|null} [cloudProvider] VideoFilter cloudProvider
                     * @property {google.protobuf.IBoolValue|null} [isVideoPassedMinimumStorageDuration] VideoFilter isVideoPassedMinimumStorageDuration
                     * @property {google.protobuf.IBoolValue|null} [isTrackingFilePassedMinimumStorageDuration] VideoFilter isTrackingFilePassedMinimumStorageDuration
                     */
    
                    /**
                     * Constructs a new VideoFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VideoFilter.
                     * @implements IVideoFilter
                     * @constructor
                     * @param {palexy.streaming.v1.IVideoFilter=} [properties] Properties to set
                     */
                    function VideoFilter(properties) {
                        this.cameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VideoFilter fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.fromDate = null;
    
                    /**
                     * VideoFilter to.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} to
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.to = null;
    
                    /**
                     * VideoFilter state.
                     * @member {palexy.streaming.v1.Video.State} state
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.state = 0;
    
                    /**
                     * VideoFilter isAlreadyPurged.
                     * @member {boolean} isAlreadyPurged
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isAlreadyPurged = false;
    
                    /**
                     * VideoFilter cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * VideoFilter storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * VideoFilter archived.
                     * @member {boolean} archived
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.archived = false;
    
                    /**
                     * VideoFilter isAlreadyPurgedValue.
                     * @member {google.protobuf.IBoolValue|null|undefined} isAlreadyPurgedValue
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isAlreadyPurgedValue = null;
    
                    /**
                     * VideoFilter archivedValue.
                     * @member {google.protobuf.IBoolValue|null|undefined} archivedValue
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.archivedValue = null;
    
                    /**
                     * VideoFilter isQcData.
                     * @member {google.protobuf.IBoolValue|null|undefined} isQcData
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isQcData = null;
    
                    /**
                     * VideoFilter isVideoAlreadyPurged.
                     * @member {google.protobuf.IBoolValue|null|undefined} isVideoAlreadyPurged
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isVideoAlreadyPurged = null;
    
                    /**
                     * VideoFilter isTrackingFileAlreadyPurged.
                     * @member {google.protobuf.IBoolValue|null|undefined} isTrackingFileAlreadyPurged
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isTrackingFileAlreadyPurged = null;
    
                    /**
                     * VideoFilter isVideoArchived.
                     * @member {google.protobuf.IBoolValue|null|undefined} isVideoArchived
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isVideoArchived = null;
    
                    /**
                     * VideoFilter isTrackingFileArchived.
                     * @member {google.protobuf.IBoolValue|null|undefined} isTrackingFileArchived
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isTrackingFileArchived = null;
    
                    /**
                     * VideoFilter cloudProvider.
                     * @member {string} cloudProvider
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.cloudProvider = "";
    
                    /**
                     * VideoFilter isVideoPassedMinimumStorageDuration.
                     * @member {google.protobuf.IBoolValue|null|undefined} isVideoPassedMinimumStorageDuration
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isVideoPassedMinimumStorageDuration = null;
    
                    /**
                     * VideoFilter isTrackingFilePassedMinimumStorageDuration.
                     * @member {google.protobuf.IBoolValue|null|undefined} isTrackingFilePassedMinimumStorageDuration
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     */
                    VideoFilter.prototype.isTrackingFilePassedMinimumStorageDuration = null;
    
                    /**
                     * Creates a new VideoFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {palexy.streaming.v1.IVideoFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.VideoFilter} VideoFilter instance
                     */
                    VideoFilter.create = function create(properties) {
                        return new VideoFilter(properties);
                    };
    
                    /**
                     * Encodes the specified VideoFilter message. Does not implicitly {@link palexy.streaming.v1.VideoFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {palexy.streaming.v1.IVideoFilter} message VideoFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VideoFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.to, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                        if (message.isAlreadyPurged != null && Object.hasOwnProperty.call(message, "isAlreadyPurged"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isAlreadyPurged);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.cameraIds[i]);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.storeId);
                        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.archived);
                        if (message.isAlreadyPurgedValue != null && Object.hasOwnProperty.call(message, "isAlreadyPurgedValue"))
                            $root.google.protobuf.BoolValue.encode(message.isAlreadyPurgedValue, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.archivedValue != null && Object.hasOwnProperty.call(message, "archivedValue"))
                            $root.google.protobuf.BoolValue.encode(message.archivedValue, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.isTrackingFileAlreadyPurged != null && Object.hasOwnProperty.call(message, "isTrackingFileAlreadyPurged"))
                            $root.google.protobuf.BoolValue.encode(message.isTrackingFileAlreadyPurged, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.isQcData != null && Object.hasOwnProperty.call(message, "isQcData"))
                            $root.google.protobuf.BoolValue.encode(message.isQcData, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.isVideoAlreadyPurged != null && Object.hasOwnProperty.call(message, "isVideoAlreadyPurged"))
                            $root.google.protobuf.BoolValue.encode(message.isVideoAlreadyPurged, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.isVideoArchived != null && Object.hasOwnProperty.call(message, "isVideoArchived"))
                            $root.google.protobuf.BoolValue.encode(message.isVideoArchived, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.isTrackingFileArchived != null && Object.hasOwnProperty.call(message, "isTrackingFileArchived"))
                            $root.google.protobuf.BoolValue.encode(message.isTrackingFileArchived, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.cloudProvider != null && Object.hasOwnProperty.call(message, "cloudProvider"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.cloudProvider);
                        if (message.isVideoPassedMinimumStorageDuration != null && Object.hasOwnProperty.call(message, "isVideoPassedMinimumStorageDuration"))
                            $root.google.protobuf.BoolValue.encode(message.isVideoPassedMinimumStorageDuration, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.isTrackingFilePassedMinimumStorageDuration != null && Object.hasOwnProperty.call(message, "isTrackingFilePassedMinimumStorageDuration"))
                            $root.google.protobuf.BoolValue.encode(message.isTrackingFilePassedMinimumStorageDuration, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VideoFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.VideoFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {palexy.streaming.v1.IVideoFilter} message VideoFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VideoFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VideoFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.VideoFilter} VideoFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VideoFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.VideoFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.to = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.state = reader.int32();
                                break;
                            case 4:
                                message.isAlreadyPurged = reader.bool();
                                break;
                            case 5:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 6:
                                message.storeId = reader.int64();
                                break;
                            case 7:
                                message.archived = reader.bool();
                                break;
                            case 8:
                                message.isAlreadyPurgedValue = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.archivedValue = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.isQcData = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.isVideoAlreadyPurged = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.isTrackingFileAlreadyPurged = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.isVideoArchived = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.isTrackingFileArchived = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.cloudProvider = reader.string();
                                break;
                            case 16:
                                message.isVideoPassedMinimumStorageDuration = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.isTrackingFilePassedMinimumStorageDuration = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VideoFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.VideoFilter} VideoFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VideoFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VideoFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VideoFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.to);
                            if (error)
                                return "to." + error;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 7:
                            case 6:
                            case 1:
                            case 8:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.isAlreadyPurged != null && message.hasOwnProperty("isAlreadyPurged"))
                            if (typeof message.isAlreadyPurged !== "boolean")
                                return "isAlreadyPurged: boolean expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.archived != null && message.hasOwnProperty("archived"))
                            if (typeof message.archived !== "boolean")
                                return "archived: boolean expected";
                        if (message.isAlreadyPurgedValue != null && message.hasOwnProperty("isAlreadyPurgedValue")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isAlreadyPurgedValue);
                            if (error)
                                return "isAlreadyPurgedValue." + error;
                        }
                        if (message.archivedValue != null && message.hasOwnProperty("archivedValue")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.archivedValue);
                            if (error)
                                return "archivedValue." + error;
                        }
                        if (message.isQcData != null && message.hasOwnProperty("isQcData")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isQcData);
                            if (error)
                                return "isQcData." + error;
                        }
                        if (message.isVideoAlreadyPurged != null && message.hasOwnProperty("isVideoAlreadyPurged")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isVideoAlreadyPurged);
                            if (error)
                                return "isVideoAlreadyPurged." + error;
                        }
                        if (message.isTrackingFileAlreadyPurged != null && message.hasOwnProperty("isTrackingFileAlreadyPurged")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isTrackingFileAlreadyPurged);
                            if (error)
                                return "isTrackingFileAlreadyPurged." + error;
                        }
                        if (message.isVideoArchived != null && message.hasOwnProperty("isVideoArchived")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isVideoArchived);
                            if (error)
                                return "isVideoArchived." + error;
                        }
                        if (message.isTrackingFileArchived != null && message.hasOwnProperty("isTrackingFileArchived")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isTrackingFileArchived);
                            if (error)
                                return "isTrackingFileArchived." + error;
                        }
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            if (!$util.isString(message.cloudProvider))
                                return "cloudProvider: string expected";
                        if (message.isVideoPassedMinimumStorageDuration != null && message.hasOwnProperty("isVideoPassedMinimumStorageDuration")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isVideoPassedMinimumStorageDuration);
                            if (error)
                                return "isVideoPassedMinimumStorageDuration." + error;
                        }
                        if (message.isTrackingFilePassedMinimumStorageDuration != null && message.hasOwnProperty("isTrackingFilePassedMinimumStorageDuration")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isTrackingFilePassedMinimumStorageDuration);
                            if (error)
                                return "isTrackingFilePassedMinimumStorageDuration." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a VideoFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.VideoFilter} VideoFilter
                     */
                    VideoFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.VideoFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.VideoFilter();
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.to != null) {
                            if (typeof object.to !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.to: object expected");
                            message.to = $root.palexy.streaming.v1.DateFilter.fromObject(object.to);
                        }
                        switch (object.state) {
                        case "UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "WAITING_FOR_VIDEO_FILE":
                        case 7:
                            message.state = 7;
                            break;
                        case "WAITING_FOR_PREPROCESSING":
                        case 6:
                            message.state = 6;
                            break;
                        case "WAITING_FOR_PROCESSING":
                        case 1:
                            message.state = 1;
                            break;
                        case "WAITING_FOR_POSTPROCESSING":
                        case 8:
                            message.state = 8;
                            break;
                        case "DONE_TRACKING":
                        case 2:
                            message.state = 2;
                            break;
                        case "WAITING_FOR_MERGING":
                        case 3:
                            message.state = 3;
                            break;
                        case "DONE":
                        case 4:
                            message.state = 4;
                            break;
                        case "DONE_CALCULATING_ACCURACY":
                        case 5:
                            message.state = 5;
                            break;
                        }
                        if (object.isAlreadyPurged != null)
                            message.isAlreadyPurged = Boolean(object.isAlreadyPurged);
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.VideoFilter.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.archived != null)
                            message.archived = Boolean(object.archived);
                        if (object.isAlreadyPurgedValue != null) {
                            if (typeof object.isAlreadyPurgedValue !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isAlreadyPurgedValue: object expected");
                            message.isAlreadyPurgedValue = $root.google.protobuf.BoolValue.fromObject(object.isAlreadyPurgedValue);
                        }
                        if (object.archivedValue != null) {
                            if (typeof object.archivedValue !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.archivedValue: object expected");
                            message.archivedValue = $root.google.protobuf.BoolValue.fromObject(object.archivedValue);
                        }
                        if (object.isQcData != null) {
                            if (typeof object.isQcData !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isQcData: object expected");
                            message.isQcData = $root.google.protobuf.BoolValue.fromObject(object.isQcData);
                        }
                        if (object.isVideoAlreadyPurged != null) {
                            if (typeof object.isVideoAlreadyPurged !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isVideoAlreadyPurged: object expected");
                            message.isVideoAlreadyPurged = $root.google.protobuf.BoolValue.fromObject(object.isVideoAlreadyPurged);
                        }
                        if (object.isTrackingFileAlreadyPurged != null) {
                            if (typeof object.isTrackingFileAlreadyPurged !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isTrackingFileAlreadyPurged: object expected");
                            message.isTrackingFileAlreadyPurged = $root.google.protobuf.BoolValue.fromObject(object.isTrackingFileAlreadyPurged);
                        }
                        if (object.isVideoArchived != null) {
                            if (typeof object.isVideoArchived !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isVideoArchived: object expected");
                            message.isVideoArchived = $root.google.protobuf.BoolValue.fromObject(object.isVideoArchived);
                        }
                        if (object.isTrackingFileArchived != null) {
                            if (typeof object.isTrackingFileArchived !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isTrackingFileArchived: object expected");
                            message.isTrackingFileArchived = $root.google.protobuf.BoolValue.fromObject(object.isTrackingFileArchived);
                        }
                        if (object.cloudProvider != null)
                            message.cloudProvider = String(object.cloudProvider);
                        if (object.isVideoPassedMinimumStorageDuration != null) {
                            if (typeof object.isVideoPassedMinimumStorageDuration !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isVideoPassedMinimumStorageDuration: object expected");
                            message.isVideoPassedMinimumStorageDuration = $root.google.protobuf.BoolValue.fromObject(object.isVideoPassedMinimumStorageDuration);
                        }
                        if (object.isTrackingFilePassedMinimumStorageDuration != null) {
                            if (typeof object.isTrackingFilePassedMinimumStorageDuration !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoFilter.isTrackingFilePassedMinimumStorageDuration: object expected");
                            message.isTrackingFilePassedMinimumStorageDuration = $root.google.protobuf.BoolValue.fromObject(object.isTrackingFilePassedMinimumStorageDuration);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VideoFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @static
                     * @param {palexy.streaming.v1.VideoFilter} message VideoFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VideoFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameraIds = [];
                        if (options.defaults) {
                            object.fromDate = null;
                            object.to = null;
                            object.state = options.enums === String ? "UNKNOWN" : 0;
                            object.isAlreadyPurged = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.archived = false;
                            object.isAlreadyPurgedValue = null;
                            object.archivedValue = null;
                            object.isTrackingFileAlreadyPurged = null;
                            object.isQcData = null;
                            object.isVideoAlreadyPurged = null;
                            object.isVideoArchived = null;
                            object.isTrackingFileArchived = null;
                            object.cloudProvider = "";
                            object.isVideoPassedMinimumStorageDuration = null;
                            object.isTrackingFilePassedMinimumStorageDuration = null;
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.to != null && message.hasOwnProperty("to"))
                            object.to = $root.palexy.streaming.v1.DateFilter.toObject(message.to, options);
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.Video.State[message.state] : message.state;
                        if (message.isAlreadyPurged != null && message.hasOwnProperty("isAlreadyPurged"))
                            object.isAlreadyPurged = message.isAlreadyPurged;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.archived != null && message.hasOwnProperty("archived"))
                            object.archived = message.archived;
                        if (message.isAlreadyPurgedValue != null && message.hasOwnProperty("isAlreadyPurgedValue"))
                            object.isAlreadyPurgedValue = $root.google.protobuf.BoolValue.toObject(message.isAlreadyPurgedValue, options);
                        if (message.archivedValue != null && message.hasOwnProperty("archivedValue"))
                            object.archivedValue = $root.google.protobuf.BoolValue.toObject(message.archivedValue, options);
                        if (message.isTrackingFileAlreadyPurged != null && message.hasOwnProperty("isTrackingFileAlreadyPurged"))
                            object.isTrackingFileAlreadyPurged = $root.google.protobuf.BoolValue.toObject(message.isTrackingFileAlreadyPurged, options);
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            object.isQcData = $root.google.protobuf.BoolValue.toObject(message.isQcData, options);
                        if (message.isVideoAlreadyPurged != null && message.hasOwnProperty("isVideoAlreadyPurged"))
                            object.isVideoAlreadyPurged = $root.google.protobuf.BoolValue.toObject(message.isVideoAlreadyPurged, options);
                        if (message.isVideoArchived != null && message.hasOwnProperty("isVideoArchived"))
                            object.isVideoArchived = $root.google.protobuf.BoolValue.toObject(message.isVideoArchived, options);
                        if (message.isTrackingFileArchived != null && message.hasOwnProperty("isTrackingFileArchived"))
                            object.isTrackingFileArchived = $root.google.protobuf.BoolValue.toObject(message.isTrackingFileArchived, options);
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            object.cloudProvider = message.cloudProvider;
                        if (message.isVideoPassedMinimumStorageDuration != null && message.hasOwnProperty("isVideoPassedMinimumStorageDuration"))
                            object.isVideoPassedMinimumStorageDuration = $root.google.protobuf.BoolValue.toObject(message.isVideoPassedMinimumStorageDuration, options);
                        if (message.isTrackingFilePassedMinimumStorageDuration != null && message.hasOwnProperty("isTrackingFilePassedMinimumStorageDuration"))
                            object.isTrackingFilePassedMinimumStorageDuration = $root.google.protobuf.BoolValue.toObject(message.isTrackingFilePassedMinimumStorageDuration, options);
                        return object;
                    };
    
                    /**
                     * Converts this VideoFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.VideoFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VideoFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return VideoFilter;
                })();
    
                v1.FetchVideosReadyForMergeRequest = (function() {
    
                    /**
                     * Properties of a FetchVideosReadyForMergeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosReadyForMergeRequest
                     * @property {number|null} [maxNumberOfAreas] FetchVideosReadyForMergeRequest maxNumberOfAreas
                     * @property {string|null} [timezone] FetchVideosReadyForMergeRequest timezone
                     * @property {Array.<palexy.streaming.v1.IExcludeMergeItem>|null} [excludeMergeItems] FetchVideosReadyForMergeRequest excludeMergeItems
                     */
    
                    /**
                     * Constructs a new FetchVideosReadyForMergeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosReadyForMergeRequest.
                     * @implements IFetchVideosReadyForMergeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest=} [properties] Properties to set
                     */
                    function FetchVideosReadyForMergeRequest(properties) {
                        this.excludeMergeItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosReadyForMergeRequest maxNumberOfAreas.
                     * @member {number} maxNumberOfAreas
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForMergeRequest.prototype.maxNumberOfAreas = 0;
    
                    /**
                     * FetchVideosReadyForMergeRequest timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForMergeRequest.prototype.timezone = "";
    
                    /**
                     * FetchVideosReadyForMergeRequest excludeMergeItems.
                     * @member {Array.<palexy.streaming.v1.IExcludeMergeItem>} excludeMergeItems
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForMergeRequest.prototype.excludeMergeItems = $util.emptyArray;
    
                    /**
                     * Creates a new FetchVideosReadyForMergeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeRequest} FetchVideosReadyForMergeRequest instance
                     */
                    FetchVideosReadyForMergeRequest.create = function create(properties) {
                        return new FetchVideosReadyForMergeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForMergeRequest message. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForMergeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest} message FetchVideosReadyForMergeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForMergeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.maxNumberOfAreas != null && Object.hasOwnProperty.call(message, "maxNumberOfAreas"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.maxNumberOfAreas);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.timezone);
                        if (message.excludeMergeItems != null && message.excludeMergeItems.length)
                            for (var i = 0; i < message.excludeMergeItems.length; ++i)
                                $root.palexy.streaming.v1.ExcludeMergeItem.encode(message.excludeMergeItems[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForMergeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForMergeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeRequest} message FetchVideosReadyForMergeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForMergeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForMergeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeRequest} FetchVideosReadyForMergeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForMergeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosReadyForMergeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.maxNumberOfAreas = reader.int32();
                                break;
                            case 2:
                                message.timezone = reader.string();
                                break;
                            case 3:
                                if (!(message.excludeMergeItems && message.excludeMergeItems.length))
                                    message.excludeMergeItems = [];
                                message.excludeMergeItems.push($root.palexy.streaming.v1.ExcludeMergeItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForMergeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeRequest} FetchVideosReadyForMergeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForMergeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosReadyForMergeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosReadyForMergeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.maxNumberOfAreas != null && message.hasOwnProperty("maxNumberOfAreas"))
                            if (!$util.isInteger(message.maxNumberOfAreas))
                                return "maxNumberOfAreas: integer expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.excludeMergeItems != null && message.hasOwnProperty("excludeMergeItems")) {
                            if (!Array.isArray(message.excludeMergeItems))
                                return "excludeMergeItems: array expected";
                            for (var i = 0; i < message.excludeMergeItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.ExcludeMergeItem.verify(message.excludeMergeItems[i]);
                                if (error)
                                    return "excludeMergeItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosReadyForMergeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeRequest} FetchVideosReadyForMergeRequest
                     */
                    FetchVideosReadyForMergeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosReadyForMergeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosReadyForMergeRequest();
                        if (object.maxNumberOfAreas != null)
                            message.maxNumberOfAreas = object.maxNumberOfAreas | 0;
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.excludeMergeItems) {
                            if (!Array.isArray(object.excludeMergeItems))
                                throw TypeError(".palexy.streaming.v1.FetchVideosReadyForMergeRequest.excludeMergeItems: array expected");
                            message.excludeMergeItems = [];
                            for (var i = 0; i < object.excludeMergeItems.length; ++i) {
                                if (typeof object.excludeMergeItems[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchVideosReadyForMergeRequest.excludeMergeItems: object expected");
                                message.excludeMergeItems[i] = $root.palexy.streaming.v1.ExcludeMergeItem.fromObject(object.excludeMergeItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosReadyForMergeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosReadyForMergeRequest} message FetchVideosReadyForMergeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosReadyForMergeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.excludeMergeItems = [];
                        if (options.defaults) {
                            object.maxNumberOfAreas = 0;
                            object.timezone = "";
                        }
                        if (message.maxNumberOfAreas != null && message.hasOwnProperty("maxNumberOfAreas"))
                            object.maxNumberOfAreas = message.maxNumberOfAreas;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.excludeMergeItems && message.excludeMergeItems.length) {
                            object.excludeMergeItems = [];
                            for (var j = 0; j < message.excludeMergeItems.length; ++j)
                                object.excludeMergeItems[j] = $root.palexy.streaming.v1.ExcludeMergeItem.toObject(message.excludeMergeItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosReadyForMergeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosReadyForMergeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosReadyForMergeRequest;
                })();
    
                v1.FetchVideosReadyForMergeResponse = (function() {
    
                    /**
                     * Properties of a FetchVideosReadyForMergeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosReadyForMergeResponse
                     * @property {Array.<palexy.streaming.v1.IMergeItem>|null} [mergeItems] FetchVideosReadyForMergeResponse mergeItems
                     */
    
                    /**
                     * Constructs a new FetchVideosReadyForMergeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosReadyForMergeResponse.
                     * @implements IFetchVideosReadyForMergeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeResponse=} [properties] Properties to set
                     */
                    function FetchVideosReadyForMergeResponse(properties) {
                        this.mergeItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosReadyForMergeResponse mergeItems.
                     * @member {Array.<palexy.streaming.v1.IMergeItem>} mergeItems
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @instance
                     */
                    FetchVideosReadyForMergeResponse.prototype.mergeItems = $util.emptyArray;
    
                    /**
                     * Creates a new FetchVideosReadyForMergeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeResponse} FetchVideosReadyForMergeResponse instance
                     */
                    FetchVideosReadyForMergeResponse.create = function create(properties) {
                        return new FetchVideosReadyForMergeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForMergeResponse message. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForMergeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeResponse} message FetchVideosReadyForMergeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForMergeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeItems != null && message.mergeItems.length)
                            for (var i = 0; i < message.mergeItems.length; ++i)
                                $root.palexy.streaming.v1.MergeItem.encode(message.mergeItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForMergeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForMergeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForMergeResponse} message FetchVideosReadyForMergeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForMergeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForMergeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeResponse} FetchVideosReadyForMergeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForMergeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosReadyForMergeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergeItems && message.mergeItems.length))
                                    message.mergeItems = [];
                                message.mergeItems.push($root.palexy.streaming.v1.MergeItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForMergeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeResponse} FetchVideosReadyForMergeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForMergeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosReadyForMergeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosReadyForMergeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeItems != null && message.hasOwnProperty("mergeItems")) {
                            if (!Array.isArray(message.mergeItems))
                                return "mergeItems: array expected";
                            for (var i = 0; i < message.mergeItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergeItem.verify(message.mergeItems[i]);
                                if (error)
                                    return "mergeItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosReadyForMergeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosReadyForMergeResponse} FetchVideosReadyForMergeResponse
                     */
                    FetchVideosReadyForMergeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosReadyForMergeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosReadyForMergeResponse();
                        if (object.mergeItems) {
                            if (!Array.isArray(object.mergeItems))
                                throw TypeError(".palexy.streaming.v1.FetchVideosReadyForMergeResponse.mergeItems: array expected");
                            message.mergeItems = [];
                            for (var i = 0; i < object.mergeItems.length; ++i) {
                                if (typeof object.mergeItems[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchVideosReadyForMergeResponse.mergeItems: object expected");
                                message.mergeItems[i] = $root.palexy.streaming.v1.MergeItem.fromObject(object.mergeItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosReadyForMergeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosReadyForMergeResponse} message FetchVideosReadyForMergeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosReadyForMergeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergeItems = [];
                        if (message.mergeItems && message.mergeItems.length) {
                            object.mergeItems = [];
                            for (var j = 0; j < message.mergeItems.length; ++j)
                                object.mergeItems[j] = $root.palexy.streaming.v1.MergeItem.toObject(message.mergeItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosReadyForMergeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosReadyForMergeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosReadyForMergeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosReadyForMergeResponse;
                })();
    
                v1.FetchVideosReadyForPartialMergeRequest = (function() {
    
                    /**
                     * Properties of a FetchVideosReadyForPartialMergeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosReadyForPartialMergeRequest
                     * @property {number|null} [companyId] FetchVideosReadyForPartialMergeRequest companyId
                     * @property {string|null} [dateId] FetchVideosReadyForPartialMergeRequest dateId
                     * @property {string|null} [startTime] FetchVideosReadyForPartialMergeRequest startTime
                     * @property {string|null} [endTime] FetchVideosReadyForPartialMergeRequest endTime
                     * @property {string|null} [timezone] FetchVideosReadyForPartialMergeRequest timezone
                     * @property {number|null} [maxNumberOfItems] FetchVideosReadyForPartialMergeRequest maxNumberOfItems
                     * @property {number|null} [numSecondsToLookBack] FetchVideosReadyForPartialMergeRequest numSecondsToLookBack
                     */
    
                    /**
                     * Constructs a new FetchVideosReadyForPartialMergeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosReadyForPartialMergeRequest.
                     * @implements IFetchVideosReadyForPartialMergeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest=} [properties] Properties to set
                     */
                    function FetchVideosReadyForPartialMergeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.dateId = "";
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.startTime = "";
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.endTime = "";
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.timezone = "";
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest maxNumberOfItems.
                     * @member {number} maxNumberOfItems
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.maxNumberOfItems = 0;
    
                    /**
                     * FetchVideosReadyForPartialMergeRequest numSecondsToLookBack.
                     * @member {number} numSecondsToLookBack
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.numSecondsToLookBack = 0;
    
                    /**
                     * Creates a new FetchVideosReadyForPartialMergeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest} FetchVideosReadyForPartialMergeRequest instance
                     */
                    FetchVideosReadyForPartialMergeRequest.create = function create(properties) {
                        return new FetchVideosReadyForPartialMergeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForPartialMergeRequest message. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest} message FetchVideosReadyForPartialMergeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForPartialMergeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endTime);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.timezone);
                        if (message.maxNumberOfItems != null && Object.hasOwnProperty.call(message, "maxNumberOfItems"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.maxNumberOfItems);
                        if (message.numSecondsToLookBack != null && Object.hasOwnProperty.call(message, "numSecondsToLookBack"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.numSecondsToLookBack);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForPartialMergeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeRequest} message FetchVideosReadyForPartialMergeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForPartialMergeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForPartialMergeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest} FetchVideosReadyForPartialMergeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForPartialMergeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.startTime = reader.string();
                                break;
                            case 4:
                                message.endTime = reader.string();
                                break;
                            case 5:
                                message.timezone = reader.string();
                                break;
                            case 6:
                                message.maxNumberOfItems = reader.int32();
                                break;
                            case 7:
                                message.numSecondsToLookBack = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForPartialMergeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest} FetchVideosReadyForPartialMergeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForPartialMergeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosReadyForPartialMergeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosReadyForPartialMergeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.maxNumberOfItems != null && message.hasOwnProperty("maxNumberOfItems"))
                            if (!$util.isInteger(message.maxNumberOfItems))
                                return "maxNumberOfItems: integer expected";
                        if (message.numSecondsToLookBack != null && message.hasOwnProperty("numSecondsToLookBack"))
                            if (!$util.isInteger(message.numSecondsToLookBack))
                                return "numSecondsToLookBack: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosReadyForPartialMergeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest} FetchVideosReadyForPartialMergeRequest
                     */
                    FetchVideosReadyForPartialMergeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.maxNumberOfItems != null)
                            message.maxNumberOfItems = object.maxNumberOfItems | 0;
                        if (object.numSecondsToLookBack != null)
                            message.numSecondsToLookBack = object.numSecondsToLookBack | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosReadyForPartialMergeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest} message FetchVideosReadyForPartialMergeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosReadyForPartialMergeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startTime = "";
                            object.endTime = "";
                            object.timezone = "";
                            object.maxNumberOfItems = 0;
                            object.numSecondsToLookBack = 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.maxNumberOfItems != null && message.hasOwnProperty("maxNumberOfItems"))
                            object.maxNumberOfItems = message.maxNumberOfItems;
                        if (message.numSecondsToLookBack != null && message.hasOwnProperty("numSecondsToLookBack"))
                            object.numSecondsToLookBack = message.numSecondsToLookBack;
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosReadyForPartialMergeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosReadyForPartialMergeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosReadyForPartialMergeRequest;
                })();
    
                v1.FetchVideosReadyForPartialMergeResponse = (function() {
    
                    /**
                     * Properties of a FetchVideosReadyForPartialMergeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosReadyForPartialMergeResponse
                     * @property {Array.<palexy.streaming.v1.IMergeItem>|null} [mergeItems] FetchVideosReadyForPartialMergeResponse mergeItems
                     */
    
                    /**
                     * Constructs a new FetchVideosReadyForPartialMergeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosReadyForPartialMergeResponse.
                     * @implements IFetchVideosReadyForPartialMergeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeResponse=} [properties] Properties to set
                     */
                    function FetchVideosReadyForPartialMergeResponse(properties) {
                        this.mergeItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosReadyForPartialMergeResponse mergeItems.
                     * @member {Array.<palexy.streaming.v1.IMergeItem>} mergeItems
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @instance
                     */
                    FetchVideosReadyForPartialMergeResponse.prototype.mergeItems = $util.emptyArray;
    
                    /**
                     * Creates a new FetchVideosReadyForPartialMergeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} FetchVideosReadyForPartialMergeResponse instance
                     */
                    FetchVideosReadyForPartialMergeResponse.create = function create(properties) {
                        return new FetchVideosReadyForPartialMergeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForPartialMergeResponse message. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeResponse} message FetchVideosReadyForPartialMergeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForPartialMergeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeItems != null && message.mergeItems.length)
                            for (var i = 0; i < message.mergeItems.length; ++i)
                                $root.palexy.streaming.v1.MergeItem.encode(message.mergeItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosReadyForPartialMergeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosReadyForPartialMergeResponse} message FetchVideosReadyForPartialMergeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosReadyForPartialMergeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForPartialMergeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} FetchVideosReadyForPartialMergeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForPartialMergeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergeItems && message.mergeItems.length))
                                    message.mergeItems = [];
                                message.mergeItems.push($root.palexy.streaming.v1.MergeItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosReadyForPartialMergeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} FetchVideosReadyForPartialMergeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosReadyForPartialMergeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosReadyForPartialMergeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosReadyForPartialMergeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeItems != null && message.hasOwnProperty("mergeItems")) {
                            if (!Array.isArray(message.mergeItems))
                                return "mergeItems: array expected";
                            for (var i = 0; i < message.mergeItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergeItem.verify(message.mergeItems[i]);
                                if (error)
                                    return "mergeItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosReadyForPartialMergeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} FetchVideosReadyForPartialMergeResponse
                     */
                    FetchVideosReadyForPartialMergeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse();
                        if (object.mergeItems) {
                            if (!Array.isArray(object.mergeItems))
                                throw TypeError(".palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse.mergeItems: array expected");
                            message.mergeItems = [];
                            for (var i = 0; i < object.mergeItems.length; ++i) {
                                if (typeof object.mergeItems[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse.mergeItems: object expected");
                                message.mergeItems[i] = $root.palexy.streaming.v1.MergeItem.fromObject(object.mergeItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosReadyForPartialMergeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse} message FetchVideosReadyForPartialMergeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosReadyForPartialMergeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergeItems = [];
                        if (message.mergeItems && message.mergeItems.length) {
                            object.mergeItems = [];
                            for (var j = 0; j < message.mergeItems.length; ++j)
                                object.mergeItems[j] = $root.palexy.streaming.v1.MergeItem.toObject(message.mergeItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosReadyForPartialMergeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosReadyForPartialMergeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosReadyForPartialMergeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosReadyForPartialMergeResponse;
                })();
    
                v1.FetchVideosForEarlyDeleteRequest = (function() {
    
                    /**
                     * Properties of a FetchVideosForEarlyDeleteRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchVideosForEarlyDeleteRequest
                     * @property {Array.<number>|null} [storeIds] FetchVideosForEarlyDeleteRequest storeIds
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] FetchVideosForEarlyDeleteRequest fromDate
                     * @property {palexy.streaming.v1.IDateFilter|null} [toDate] FetchVideosForEarlyDeleteRequest toDate
                     * @property {number|null} [pageSize] FetchVideosForEarlyDeleteRequest pageSize
                     * @property {string|null} [pageToken] FetchVideosForEarlyDeleteRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchVideosForEarlyDeleteRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchVideosForEarlyDeleteRequest.
                     * @implements IFetchVideosForEarlyDeleteRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest=} [properties] Properties to set
                     */
                    function FetchVideosForEarlyDeleteRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchVideosForEarlyDeleteRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * FetchVideosForEarlyDeleteRequest fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.fromDate = null;
    
                    /**
                     * FetchVideosForEarlyDeleteRequest toDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} toDate
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.toDate = null;
    
                    /**
                     * FetchVideosForEarlyDeleteRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchVideosForEarlyDeleteRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchVideosForEarlyDeleteRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchVideosForEarlyDeleteRequest} FetchVideosForEarlyDeleteRequest instance
                     */
                    FetchVideosForEarlyDeleteRequest.create = function create(properties) {
                        return new FetchVideosForEarlyDeleteRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchVideosForEarlyDeleteRequest message. Does not implicitly {@link palexy.streaming.v1.FetchVideosForEarlyDeleteRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest} message FetchVideosForEarlyDeleteRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosForEarlyDeleteRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.toDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchVideosForEarlyDeleteRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchVideosForEarlyDeleteRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchVideosForEarlyDeleteRequest} message FetchVideosForEarlyDeleteRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchVideosForEarlyDeleteRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchVideosForEarlyDeleteRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchVideosForEarlyDeleteRequest} FetchVideosForEarlyDeleteRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosForEarlyDeleteRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchVideosForEarlyDeleteRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.toDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchVideosForEarlyDeleteRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchVideosForEarlyDeleteRequest} FetchVideosForEarlyDeleteRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchVideosForEarlyDeleteRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchVideosForEarlyDeleteRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchVideosForEarlyDeleteRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.toDate != null && message.hasOwnProperty("toDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.toDate);
                            if (error)
                                return "toDate." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchVideosForEarlyDeleteRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchVideosForEarlyDeleteRequest} FetchVideosForEarlyDeleteRequest
                     */
                    FetchVideosForEarlyDeleteRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchVideosForEarlyDeleteRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchVideosForEarlyDeleteRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.FetchVideosForEarlyDeleteRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchVideosForEarlyDeleteRequest.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.toDate != null) {
                            if (typeof object.toDate !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchVideosForEarlyDeleteRequest.toDate: object expected");
                            message.toDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.toDate);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchVideosForEarlyDeleteRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchVideosForEarlyDeleteRequest} message FetchVideosForEarlyDeleteRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchVideosForEarlyDeleteRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.fromDate = null;
                            object.toDate = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = $root.palexy.streaming.v1.DateFilter.toObject(message.toDate, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchVideosForEarlyDeleteRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchVideosForEarlyDeleteRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchVideosForEarlyDeleteRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchVideosForEarlyDeleteRequest;
                })();
    
                v1.FetchNonDeletedDataVideosRequest = (function() {
    
                    /**
                     * Properties of a FetchNonDeletedDataVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchNonDeletedDataVideosRequest
                     * @property {Array.<number>|null} [storeIds] FetchNonDeletedDataVideosRequest storeIds
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] FetchNonDeletedDataVideosRequest dateRange
                     * @property {boolean|null} [isTrackingFile] FetchNonDeletedDataVideosRequest isTrackingFile
                     * @property {boolean|null} [isQcData] FetchNonDeletedDataVideosRequest isQcData
                     * @property {number|null} [pageSize] FetchNonDeletedDataVideosRequest pageSize
                     * @property {string|null} [pageToken] FetchNonDeletedDataVideosRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchNonDeletedDataVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchNonDeletedDataVideosRequest.
                     * @implements IFetchNonDeletedDataVideosRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest=} [properties] Properties to set
                     */
                    function FetchNonDeletedDataVideosRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchNonDeletedDataVideosRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * FetchNonDeletedDataVideosRequest dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.dateRange = null;
    
                    /**
                     * FetchNonDeletedDataVideosRequest isTrackingFile.
                     * @member {boolean} isTrackingFile
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.isTrackingFile = false;
    
                    /**
                     * FetchNonDeletedDataVideosRequest isQcData.
                     * @member {boolean} isQcData
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.isQcData = false;
    
                    /**
                     * FetchNonDeletedDataVideosRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchNonDeletedDataVideosRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     */
                    FetchNonDeletedDataVideosRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchNonDeletedDataVideosRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchNonDeletedDataVideosRequest} FetchNonDeletedDataVideosRequest instance
                     */
                    FetchNonDeletedDataVideosRequest.create = function create(properties) {
                        return new FetchNonDeletedDataVideosRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchNonDeletedDataVideosRequest message. Does not implicitly {@link palexy.streaming.v1.FetchNonDeletedDataVideosRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest} message FetchNonDeletedDataVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchNonDeletedDataVideosRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.isTrackingFile != null && Object.hasOwnProperty.call(message, "isTrackingFile"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isTrackingFile);
                        if (message.isQcData != null && Object.hasOwnProperty.call(message, "isQcData"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isQcData);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchNonDeletedDataVideosRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchNonDeletedDataVideosRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonDeletedDataVideosRequest} message FetchNonDeletedDataVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchNonDeletedDataVideosRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchNonDeletedDataVideosRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchNonDeletedDataVideosRequest} FetchNonDeletedDataVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchNonDeletedDataVideosRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchNonDeletedDataVideosRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.isTrackingFile = reader.bool();
                                break;
                            case 4:
                                message.isQcData = reader.bool();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchNonDeletedDataVideosRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchNonDeletedDataVideosRequest} FetchNonDeletedDataVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchNonDeletedDataVideosRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchNonDeletedDataVideosRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchNonDeletedDataVideosRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.isTrackingFile != null && message.hasOwnProperty("isTrackingFile"))
                            if (typeof message.isTrackingFile !== "boolean")
                                return "isTrackingFile: boolean expected";
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            if (typeof message.isQcData !== "boolean")
                                return "isQcData: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchNonDeletedDataVideosRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchNonDeletedDataVideosRequest} FetchNonDeletedDataVideosRequest
                     */
                    FetchNonDeletedDataVideosRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchNonDeletedDataVideosRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchNonDeletedDataVideosRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.FetchNonDeletedDataVideosRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchNonDeletedDataVideosRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        if (object.isTrackingFile != null)
                            message.isTrackingFile = Boolean(object.isTrackingFile);
                        if (object.isQcData != null)
                            message.isQcData = Boolean(object.isQcData);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchNonDeletedDataVideosRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchNonDeletedDataVideosRequest} message FetchNonDeletedDataVideosRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchNonDeletedDataVideosRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.dateRange = null;
                            object.isTrackingFile = false;
                            object.isQcData = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                        if (message.isTrackingFile != null && message.hasOwnProperty("isTrackingFile"))
                            object.isTrackingFile = message.isTrackingFile;
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            object.isQcData = message.isQcData;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchNonDeletedDataVideosRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchNonDeletedDataVideosRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchNonDeletedDataVideosRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchNonDeletedDataVideosRequest;
                })();
    
                v1.FetchNonArchivedDataVideosRequest = (function() {
    
                    /**
                     * Properties of a FetchNonArchivedDataVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchNonArchivedDataVideosRequest
                     * @property {Array.<number>|null} [storeIds] FetchNonArchivedDataVideosRequest storeIds
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] FetchNonArchivedDataVideosRequest dateRange
                     * @property {boolean|null} [isTrackingFile] FetchNonArchivedDataVideosRequest isTrackingFile
                     * @property {boolean|null} [isQcData] FetchNonArchivedDataVideosRequest isQcData
                     * @property {number|null} [pageSize] FetchNonArchivedDataVideosRequest pageSize
                     * @property {string|null} [pageToken] FetchNonArchivedDataVideosRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchNonArchivedDataVideosRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchNonArchivedDataVideosRequest.
                     * @implements IFetchNonArchivedDataVideosRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest=} [properties] Properties to set
                     */
                    function FetchNonArchivedDataVideosRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchNonArchivedDataVideosRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * FetchNonArchivedDataVideosRequest dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.dateRange = null;
    
                    /**
                     * FetchNonArchivedDataVideosRequest isTrackingFile.
                     * @member {boolean} isTrackingFile
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.isTrackingFile = false;
    
                    /**
                     * FetchNonArchivedDataVideosRequest isQcData.
                     * @member {boolean} isQcData
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.isQcData = false;
    
                    /**
                     * FetchNonArchivedDataVideosRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchNonArchivedDataVideosRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     */
                    FetchNonArchivedDataVideosRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchNonArchivedDataVideosRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchNonArchivedDataVideosRequest} FetchNonArchivedDataVideosRequest instance
                     */
                    FetchNonArchivedDataVideosRequest.create = function create(properties) {
                        return new FetchNonArchivedDataVideosRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchNonArchivedDataVideosRequest message. Does not implicitly {@link palexy.streaming.v1.FetchNonArchivedDataVideosRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest} message FetchNonArchivedDataVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchNonArchivedDataVideosRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.isTrackingFile != null && Object.hasOwnProperty.call(message, "isTrackingFile"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isTrackingFile);
                        if (message.isQcData != null && Object.hasOwnProperty.call(message, "isQcData"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isQcData);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchNonArchivedDataVideosRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchNonArchivedDataVideosRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchNonArchivedDataVideosRequest} message FetchNonArchivedDataVideosRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchNonArchivedDataVideosRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchNonArchivedDataVideosRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchNonArchivedDataVideosRequest} FetchNonArchivedDataVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchNonArchivedDataVideosRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchNonArchivedDataVideosRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.isTrackingFile = reader.bool();
                                break;
                            case 4:
                                message.isQcData = reader.bool();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchNonArchivedDataVideosRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchNonArchivedDataVideosRequest} FetchNonArchivedDataVideosRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchNonArchivedDataVideosRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchNonArchivedDataVideosRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchNonArchivedDataVideosRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.isTrackingFile != null && message.hasOwnProperty("isTrackingFile"))
                            if (typeof message.isTrackingFile !== "boolean")
                                return "isTrackingFile: boolean expected";
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            if (typeof message.isQcData !== "boolean")
                                return "isQcData: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchNonArchivedDataVideosRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchNonArchivedDataVideosRequest} FetchNonArchivedDataVideosRequest
                     */
                    FetchNonArchivedDataVideosRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchNonArchivedDataVideosRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchNonArchivedDataVideosRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.FetchNonArchivedDataVideosRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchNonArchivedDataVideosRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        if (object.isTrackingFile != null)
                            message.isTrackingFile = Boolean(object.isTrackingFile);
                        if (object.isQcData != null)
                            message.isQcData = Boolean(object.isQcData);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchNonArchivedDataVideosRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchNonArchivedDataVideosRequest} message FetchNonArchivedDataVideosRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchNonArchivedDataVideosRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.dateRange = null;
                            object.isTrackingFile = false;
                            object.isQcData = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                        if (message.isTrackingFile != null && message.hasOwnProperty("isTrackingFile"))
                            object.isTrackingFile = message.isTrackingFile;
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            object.isQcData = message.isQcData;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchNonArchivedDataVideosRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchNonArchivedDataVideosRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchNonArchivedDataVideosRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchNonArchivedDataVideosRequest;
                })();
    
                v1.FetchStoreSnapshotsForCleaningUpRequest = (function() {
    
                    /**
                     * Properties of a FetchStoreSnapshotsForCleaningUpRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchStoreSnapshotsForCleaningUpRequest
                     * @property {number|null} [pageSize] FetchStoreSnapshotsForCleaningUpRequest pageSize
                     * @property {string|null} [pageToken] FetchStoreSnapshotsForCleaningUpRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchStoreSnapshotsForCleaningUpRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchStoreSnapshotsForCleaningUpRequest.
                     * @implements IFetchStoreSnapshotsForCleaningUpRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest=} [properties] Properties to set
                     */
                    function FetchStoreSnapshotsForCleaningUpRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchStoreSnapshotsForCleaningUpRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @instance
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchStoreSnapshotsForCleaningUpRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @instance
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchStoreSnapshotsForCleaningUpRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest} FetchStoreSnapshotsForCleaningUpRequest instance
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.create = function create(properties) {
                        return new FetchStoreSnapshotsForCleaningUpRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchStoreSnapshotsForCleaningUpRequest message. Does not implicitly {@link palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest} message FetchStoreSnapshotsForCleaningUpRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchStoreSnapshotsForCleaningUpRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest} message FetchStoreSnapshotsForCleaningUpRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchStoreSnapshotsForCleaningUpRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest} FetchStoreSnapshotsForCleaningUpRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchStoreSnapshotsForCleaningUpRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest} FetchStoreSnapshotsForCleaningUpRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchStoreSnapshotsForCleaningUpRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchStoreSnapshotsForCleaningUpRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest} FetchStoreSnapshotsForCleaningUpRequest
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchStoreSnapshotsForCleaningUpRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest} message FetchStoreSnapshotsForCleaningUpRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchStoreSnapshotsForCleaningUpRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchStoreSnapshotsForCleaningUpRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchStoreSnapshotsForCleaningUpRequest;
                })();
    
                v1.MergeItem = (function() {
    
                    /**
                     * Properties of a MergeItem.
                     * @memberof palexy.streaming.v1
                     * @interface IMergeItem
                     * @property {number|null} [areaId] MergeItem areaId
                     * @property {string|null} [dateId] MergeItem dateId
                     * @property {Array.<palexy.streaming.v1.IVideo>|null} [videos] MergeItem videos
                     * @property {number|null} [storeId] MergeItem storeId
                     * @property {palexy.streaming.v1.MergeItem.MergeType|null} [mergeType] MergeItem mergeType
                     * @property {string|null} [partialMergeStartTime] MergeItem partialMergeStartTime
                     * @property {string|null} [partialMergeEndTime] MergeItem partialMergeEndTime
                     * @property {string|null} [mergeId] MergeItem mergeId
                     */
    
                    /**
                     * Constructs a new MergeItem.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergeItem.
                     * @implements IMergeItem
                     * @constructor
                     * @param {palexy.streaming.v1.IMergeItem=} [properties] Properties to set
                     */
                    function MergeItem(properties) {
                        this.videos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergeItem areaId.
                     * @member {number} areaId
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.areaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergeItem dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.dateId = "";
    
                    /**
                     * MergeItem videos.
                     * @member {Array.<palexy.streaming.v1.IVideo>} videos
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.videos = $util.emptyArray;
    
                    /**
                     * MergeItem storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergeItem mergeType.
                     * @member {palexy.streaming.v1.MergeItem.MergeType} mergeType
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.mergeType = 0;
    
                    /**
                     * MergeItem partialMergeStartTime.
                     * @member {string} partialMergeStartTime
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.partialMergeStartTime = "";
    
                    /**
                     * MergeItem partialMergeEndTime.
                     * @member {string} partialMergeEndTime
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.partialMergeEndTime = "";
    
                    /**
                     * MergeItem mergeId.
                     * @member {string} mergeId
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     */
                    MergeItem.prototype.mergeId = "";
    
                    /**
                     * Creates a new MergeItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {palexy.streaming.v1.IMergeItem=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergeItem} MergeItem instance
                     */
                    MergeItem.create = function create(properties) {
                        return new MergeItem(properties);
                    };
    
                    /**
                     * Encodes the specified MergeItem message. Does not implicitly {@link palexy.streaming.v1.MergeItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {palexy.streaming.v1.IMergeItem} message MergeItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.areaId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.videos != null && message.videos.length)
                            for (var i = 0; i < message.videos.length; ++i)
                                $root.palexy.streaming.v1.Video.encode(message.videos[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.storeId);
                        if (message.mergeType != null && Object.hasOwnProperty.call(message, "mergeType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.mergeType);
                        if (message.partialMergeStartTime != null && Object.hasOwnProperty.call(message, "partialMergeStartTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.partialMergeStartTime);
                        if (message.partialMergeEndTime != null && Object.hasOwnProperty.call(message, "partialMergeEndTime"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.partialMergeEndTime);
                        if (message.mergeId != null && Object.hasOwnProperty.call(message, "mergeId"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.mergeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergeItem message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergeItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {palexy.streaming.v1.IMergeItem} message MergeItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergeItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergeItem} MergeItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergeItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.areaId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                if (!(message.videos && message.videos.length))
                                    message.videos = [];
                                message.videos.push($root.palexy.streaming.v1.Video.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.storeId = reader.int64();
                                break;
                            case 5:
                                message.mergeType = reader.int32();
                                break;
                            case 6:
                                message.partialMergeStartTime = reader.string();
                                break;
                            case 7:
                                message.partialMergeEndTime = reader.string();
                                break;
                            case 8:
                                message.mergeId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergeItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergeItem} MergeItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergeItem message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergeItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (!$util.isInteger(message.areaId) && !(message.areaId && $util.isInteger(message.areaId.low) && $util.isInteger(message.areaId.high)))
                                return "areaId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.videos != null && message.hasOwnProperty("videos")) {
                            if (!Array.isArray(message.videos))
                                return "videos: array expected";
                            for (var i = 0; i < message.videos.length; ++i) {
                                var error = $root.palexy.streaming.v1.Video.verify(message.videos[i]);
                                if (error)
                                    return "videos." + error;
                            }
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.mergeType != null && message.hasOwnProperty("mergeType"))
                            switch (message.mergeType) {
                            default:
                                return "mergeType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.partialMergeStartTime != null && message.hasOwnProperty("partialMergeStartTime"))
                            if (!$util.isString(message.partialMergeStartTime))
                                return "partialMergeStartTime: string expected";
                        if (message.partialMergeEndTime != null && message.hasOwnProperty("partialMergeEndTime"))
                            if (!$util.isString(message.partialMergeEndTime))
                                return "partialMergeEndTime: string expected";
                        if (message.mergeId != null && message.hasOwnProperty("mergeId"))
                            if (!$util.isString(message.mergeId))
                                return "mergeId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergeItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergeItem} MergeItem
                     */
                    MergeItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergeItem)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergeItem();
                        if (object.areaId != null)
                            if ($util.Long)
                                (message.areaId = $util.Long.fromValue(object.areaId)).unsigned = false;
                            else if (typeof object.areaId === "string")
                                message.areaId = parseInt(object.areaId, 10);
                            else if (typeof object.areaId === "number")
                                message.areaId = object.areaId;
                            else if (typeof object.areaId === "object")
                                message.areaId = new $util.LongBits(object.areaId.low >>> 0, object.areaId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.videos) {
                            if (!Array.isArray(object.videos))
                                throw TypeError(".palexy.streaming.v1.MergeItem.videos: array expected");
                            message.videos = [];
                            for (var i = 0; i < object.videos.length; ++i) {
                                if (typeof object.videos[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MergeItem.videos: object expected");
                                message.videos[i] = $root.palexy.streaming.v1.Video.fromObject(object.videos[i]);
                            }
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        switch (object.mergeType) {
                        case "UNKNOWN":
                        case 0:
                            message.mergeType = 0;
                            break;
                        case "FULL_DAY_MERGE":
                        case 1:
                            message.mergeType = 1;
                            break;
                        case "PARTIAL_MERGE":
                        case 2:
                            message.mergeType = 2;
                            break;
                        }
                        if (object.partialMergeStartTime != null)
                            message.partialMergeStartTime = String(object.partialMergeStartTime);
                        if (object.partialMergeEndTime != null)
                            message.partialMergeEndTime = String(object.partialMergeEndTime);
                        if (object.mergeId != null)
                            message.mergeId = String(object.mergeId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergeItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergeItem
                     * @static
                     * @param {palexy.streaming.v1.MergeItem} message MergeItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergeItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.videos = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.areaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.areaId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.mergeType = options.enums === String ? "UNKNOWN" : 0;
                            object.partialMergeStartTime = "";
                            object.partialMergeEndTime = "";
                            object.mergeId = "";
                        }
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (typeof message.areaId === "number")
                                object.areaId = options.longs === String ? String(message.areaId) : message.areaId;
                            else
                                object.areaId = options.longs === String ? $util.Long.prototype.toString.call(message.areaId) : options.longs === Number ? new $util.LongBits(message.areaId.low >>> 0, message.areaId.high >>> 0).toNumber() : message.areaId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.videos && message.videos.length) {
                            object.videos = [];
                            for (var j = 0; j < message.videos.length; ++j)
                                object.videos[j] = $root.palexy.streaming.v1.Video.toObject(message.videos[j], options);
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.mergeType != null && message.hasOwnProperty("mergeType"))
                            object.mergeType = options.enums === String ? $root.palexy.streaming.v1.MergeItem.MergeType[message.mergeType] : message.mergeType;
                        if (message.partialMergeStartTime != null && message.hasOwnProperty("partialMergeStartTime"))
                            object.partialMergeStartTime = message.partialMergeStartTime;
                        if (message.partialMergeEndTime != null && message.hasOwnProperty("partialMergeEndTime"))
                            object.partialMergeEndTime = message.partialMergeEndTime;
                        if (message.mergeId != null && message.hasOwnProperty("mergeId"))
                            object.mergeId = message.mergeId;
                        return object;
                    };
    
                    /**
                     * Converts this MergeItem to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergeItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergeItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * MergeType enum.
                     * @name palexy.streaming.v1.MergeItem.MergeType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} FULL_DAY_MERGE=1 FULL_DAY_MERGE value
                     * @property {number} PARTIAL_MERGE=2 PARTIAL_MERGE value
                     */
                    MergeItem.MergeType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "FULL_DAY_MERGE"] = 1;
                        values[valuesById[2] = "PARTIAL_MERGE"] = 2;
                        return values;
                    })();
    
                    return MergeItem;
                })();
    
                v1.ExcludeMergeItem = (function() {
    
                    /**
                     * Properties of an ExcludeMergeItem.
                     * @memberof palexy.streaming.v1
                     * @interface IExcludeMergeItem
                     * @property {string|null} [dateId] ExcludeMergeItem dateId
                     * @property {number|null} [storeId] ExcludeMergeItem storeId
                     */
    
                    /**
                     * Constructs a new ExcludeMergeItem.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExcludeMergeItem.
                     * @implements IExcludeMergeItem
                     * @constructor
                     * @param {palexy.streaming.v1.IExcludeMergeItem=} [properties] Properties to set
                     */
                    function ExcludeMergeItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExcludeMergeItem dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @instance
                     */
                    ExcludeMergeItem.prototype.dateId = "";
    
                    /**
                     * ExcludeMergeItem storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @instance
                     */
                    ExcludeMergeItem.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ExcludeMergeItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {palexy.streaming.v1.IExcludeMergeItem=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExcludeMergeItem} ExcludeMergeItem instance
                     */
                    ExcludeMergeItem.create = function create(properties) {
                        return new ExcludeMergeItem(properties);
                    };
    
                    /**
                     * Encodes the specified ExcludeMergeItem message. Does not implicitly {@link palexy.streaming.v1.ExcludeMergeItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {palexy.streaming.v1.IExcludeMergeItem} message ExcludeMergeItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExcludeMergeItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.dateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExcludeMergeItem message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExcludeMergeItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {palexy.streaming.v1.IExcludeMergeItem} message ExcludeMergeItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExcludeMergeItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExcludeMergeItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExcludeMergeItem} ExcludeMergeItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExcludeMergeItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExcludeMergeItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.string();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExcludeMergeItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExcludeMergeItem} ExcludeMergeItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExcludeMergeItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExcludeMergeItem message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExcludeMergeItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExcludeMergeItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExcludeMergeItem} ExcludeMergeItem
                     */
                    ExcludeMergeItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExcludeMergeItem)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExcludeMergeItem();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExcludeMergeItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @static
                     * @param {palexy.streaming.v1.ExcludeMergeItem} message ExcludeMergeItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExcludeMergeItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this ExcludeMergeItem to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExcludeMergeItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExcludeMergeItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExcludeMergeItem;
                })();
    
                v1.MergeItemWithAckId = (function() {
    
                    /**
                     * Properties of a MergeItemWithAckId.
                     * @memberof palexy.streaming.v1
                     * @interface IMergeItemWithAckId
                     * @property {palexy.streaming.v1.IMergeItem|null} [mergeItem] MergeItemWithAckId mergeItem
                     * @property {string|null} [ackId] MergeItemWithAckId ackId
                     */
    
                    /**
                     * Constructs a new MergeItemWithAckId.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergeItemWithAckId.
                     * @implements IMergeItemWithAckId
                     * @constructor
                     * @param {palexy.streaming.v1.IMergeItemWithAckId=} [properties] Properties to set
                     */
                    function MergeItemWithAckId(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergeItemWithAckId mergeItem.
                     * @member {palexy.streaming.v1.IMergeItem|null|undefined} mergeItem
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @instance
                     */
                    MergeItemWithAckId.prototype.mergeItem = null;
    
                    /**
                     * MergeItemWithAckId ackId.
                     * @member {string} ackId
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @instance
                     */
                    MergeItemWithAckId.prototype.ackId = "";
    
                    /**
                     * Creates a new MergeItemWithAckId instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {palexy.streaming.v1.IMergeItemWithAckId=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergeItemWithAckId} MergeItemWithAckId instance
                     */
                    MergeItemWithAckId.create = function create(properties) {
                        return new MergeItemWithAckId(properties);
                    };
    
                    /**
                     * Encodes the specified MergeItemWithAckId message. Does not implicitly {@link palexy.streaming.v1.MergeItemWithAckId.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {palexy.streaming.v1.IMergeItemWithAckId} message MergeItemWithAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeItemWithAckId.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergeItem != null && Object.hasOwnProperty.call(message, "mergeItem"))
                            $root.palexy.streaming.v1.MergeItem.encode(message.mergeItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.ackId != null && Object.hasOwnProperty.call(message, "ackId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ackId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergeItemWithAckId message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergeItemWithAckId.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {palexy.streaming.v1.IMergeItemWithAckId} message MergeItemWithAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeItemWithAckId.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergeItemWithAckId message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergeItemWithAckId} MergeItemWithAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeItemWithAckId.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergeItemWithAckId();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergeItem = $root.palexy.streaming.v1.MergeItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.ackId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergeItemWithAckId message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergeItemWithAckId} MergeItemWithAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeItemWithAckId.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergeItemWithAckId message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergeItemWithAckId.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergeItem != null && message.hasOwnProperty("mergeItem")) {
                            var error = $root.palexy.streaming.v1.MergeItem.verify(message.mergeItem);
                            if (error)
                                return "mergeItem." + error;
                        }
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            if (!$util.isString(message.ackId))
                                return "ackId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergeItemWithAckId message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergeItemWithAckId} MergeItemWithAckId
                     */
                    MergeItemWithAckId.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergeItemWithAckId)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergeItemWithAckId();
                        if (object.mergeItem != null) {
                            if (typeof object.mergeItem !== "object")
                                throw TypeError(".palexy.streaming.v1.MergeItemWithAckId.mergeItem: object expected");
                            message.mergeItem = $root.palexy.streaming.v1.MergeItem.fromObject(object.mergeItem);
                        }
                        if (object.ackId != null)
                            message.ackId = String(object.ackId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergeItemWithAckId message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @static
                     * @param {palexy.streaming.v1.MergeItemWithAckId} message MergeItemWithAckId
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergeItemWithAckId.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mergeItem = null;
                            object.ackId = "";
                        }
                        if (message.mergeItem != null && message.hasOwnProperty("mergeItem"))
                            object.mergeItem = $root.palexy.streaming.v1.MergeItem.toObject(message.mergeItem, options);
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            object.ackId = message.ackId;
                        return object;
                    };
    
                    /**
                     * Converts this MergeItemWithAckId to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergeItemWithAckId
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergeItemWithAckId.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergeItemWithAckId;
                })();
    
                v1.CreateVideoRequest = (function() {
    
                    /**
                     * Properties of a CreateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateVideoRequest
                     * @property {string|null} [parent] CreateVideoRequest parent
                     * @property {palexy.streaming.v1.IVideo|null} [video] CreateVideoRequest video
                     * @property {string|null} [processingQueueName] CreateVideoRequest processingQueueName
                     */
    
                    /**
                     * Constructs a new CreateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateVideoRequest.
                     * @implements ICreateVideoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateVideoRequest=} [properties] Properties to set
                     */
                    function CreateVideoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateVideoRequest parent.
                     * @member {string} parent
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @instance
                     */
                    CreateVideoRequest.prototype.parent = "";
    
                    /**
                     * CreateVideoRequest video.
                     * @member {palexy.streaming.v1.IVideo|null|undefined} video
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @instance
                     */
                    CreateVideoRequest.prototype.video = null;
    
                    /**
                     * CreateVideoRequest processingQueueName.
                     * @member {string} processingQueueName
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @instance
                     */
                    CreateVideoRequest.prototype.processingQueueName = "";
    
                    /**
                     * Creates a new CreateVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateVideoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateVideoRequest} CreateVideoRequest instance
                     */
                    CreateVideoRequest.create = function create(properties) {
                        return new CreateVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateVideoRequest message. Does not implicitly {@link palexy.streaming.v1.CreateVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateVideoRequest} message CreateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Video.encode(message.video, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.processingQueueName != null && Object.hasOwnProperty.call(message, "processingQueueName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.processingQueueName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateVideoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateVideoRequest} message CreateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateVideoRequest} CreateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.parent = reader.string();
                                break;
                            case 2:
                                message.video = $root.palexy.streaming.v1.Video.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.processingQueueName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateVideoRequest} CreateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateVideoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            if (!$util.isString(message.parent))
                                return "parent: string expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Video.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        if (message.processingQueueName != null && message.hasOwnProperty("processingQueueName"))
                            if (!$util.isString(message.processingQueueName))
                                return "processingQueueName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateVideoRequest} CreateVideoRequest
                     */
                    CreateVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateVideoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateVideoRequest();
                        if (object.parent != null)
                            message.parent = String(object.parent);
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateVideoRequest.video: object expected");
                            message.video = $root.palexy.streaming.v1.Video.fromObject(object.video);
                        }
                        if (object.processingQueueName != null)
                            message.processingQueueName = String(object.processingQueueName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateVideoRequest} message CreateVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.parent = "";
                            object.video = null;
                            object.processingQueueName = "";
                        }
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            object.parent = message.parent;
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Video.toObject(message.video, options);
                        if (message.processingQueueName != null && message.hasOwnProperty("processingQueueName"))
                            object.processingQueueName = message.processingQueueName;
                        return object;
                    };
    
                    /**
                     * Converts this CreateVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateVideoRequest;
                })();
    
                v1.UpdateVideoRequest = (function() {
    
                    /**
                     * Properties of an UpdateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateVideoRequest
                     * @property {palexy.streaming.v1.IVideo|null} [video] UpdateVideoRequest video
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateVideoRequest updateMask
                     * @property {boolean|null} [needPushToQueue] UpdateVideoRequest needPushToQueue
                     * @property {string|null} [queueName] UpdateVideoRequest queueName
                     * @property {Array.<palexy.streaming.v1.IVideo>|null} [additionalVideosToCreate] UpdateVideoRequest additionalVideosToCreate
                     */
    
                    /**
                     * Constructs a new UpdateVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateVideoRequest.
                     * @implements IUpdateVideoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateVideoRequest=} [properties] Properties to set
                     */
                    function UpdateVideoRequest(properties) {
                        this.additionalVideosToCreate = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateVideoRequest video.
                     * @member {palexy.streaming.v1.IVideo|null|undefined} video
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     */
                    UpdateVideoRequest.prototype.video = null;
    
                    /**
                     * UpdateVideoRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     */
                    UpdateVideoRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateVideoRequest needPushToQueue.
                     * @member {boolean} needPushToQueue
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     */
                    UpdateVideoRequest.prototype.needPushToQueue = false;
    
                    /**
                     * UpdateVideoRequest queueName.
                     * @member {string} queueName
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     */
                    UpdateVideoRequest.prototype.queueName = "";
    
                    /**
                     * UpdateVideoRequest additionalVideosToCreate.
                     * @member {Array.<palexy.streaming.v1.IVideo>} additionalVideosToCreate
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     */
                    UpdateVideoRequest.prototype.additionalVideosToCreate = $util.emptyArray;
    
                    /**
                     * Creates a new UpdateVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateVideoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateVideoRequest} UpdateVideoRequest instance
                     */
                    UpdateVideoRequest.create = function create(properties) {
                        return new UpdateVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateVideoRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateVideoRequest} message UpdateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Video.encode(message.video, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.needPushToQueue != null && Object.hasOwnProperty.call(message, "needPushToQueue"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.needPushToQueue);
                        if (message.queueName != null && Object.hasOwnProperty.call(message, "queueName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.queueName);
                        if (message.additionalVideosToCreate != null && message.additionalVideosToCreate.length)
                            for (var i = 0; i < message.additionalVideosToCreate.length; ++i)
                                $root.palexy.streaming.v1.Video.encode(message.additionalVideosToCreate[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateVideoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateVideoRequest} message UpdateVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateVideoRequest} UpdateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.video = $root.palexy.streaming.v1.Video.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.needPushToQueue = reader.bool();
                                break;
                            case 4:
                                message.queueName = reader.string();
                                break;
                            case 5:
                                if (!(message.additionalVideosToCreate && message.additionalVideosToCreate.length))
                                    message.additionalVideosToCreate = [];
                                message.additionalVideosToCreate.push($root.palexy.streaming.v1.Video.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateVideoRequest} UpdateVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateVideoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Video.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.needPushToQueue != null && message.hasOwnProperty("needPushToQueue"))
                            if (typeof message.needPushToQueue !== "boolean")
                                return "needPushToQueue: boolean expected";
                        if (message.queueName != null && message.hasOwnProperty("queueName"))
                            if (!$util.isString(message.queueName))
                                return "queueName: string expected";
                        if (message.additionalVideosToCreate != null && message.hasOwnProperty("additionalVideosToCreate")) {
                            if (!Array.isArray(message.additionalVideosToCreate))
                                return "additionalVideosToCreate: array expected";
                            for (var i = 0; i < message.additionalVideosToCreate.length; ++i) {
                                var error = $root.palexy.streaming.v1.Video.verify(message.additionalVideosToCreate[i]);
                                if (error)
                                    return "additionalVideosToCreate." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateVideoRequest} UpdateVideoRequest
                     */
                    UpdateVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateVideoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateVideoRequest();
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateVideoRequest.video: object expected");
                            message.video = $root.palexy.streaming.v1.Video.fromObject(object.video);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateVideoRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.needPushToQueue != null)
                            message.needPushToQueue = Boolean(object.needPushToQueue);
                        if (object.queueName != null)
                            message.queueName = String(object.queueName);
                        if (object.additionalVideosToCreate) {
                            if (!Array.isArray(object.additionalVideosToCreate))
                                throw TypeError(".palexy.streaming.v1.UpdateVideoRequest.additionalVideosToCreate: array expected");
                            message.additionalVideosToCreate = [];
                            for (var i = 0; i < object.additionalVideosToCreate.length; ++i) {
                                if (typeof object.additionalVideosToCreate[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.UpdateVideoRequest.additionalVideosToCreate: object expected");
                                message.additionalVideosToCreate[i] = $root.palexy.streaming.v1.Video.fromObject(object.additionalVideosToCreate[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateVideoRequest} message UpdateVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.additionalVideosToCreate = [];
                        if (options.defaults) {
                            object.video = null;
                            object.updateMask = null;
                            object.needPushToQueue = false;
                            object.queueName = "";
                        }
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Video.toObject(message.video, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.needPushToQueue != null && message.hasOwnProperty("needPushToQueue"))
                            object.needPushToQueue = message.needPushToQueue;
                        if (message.queueName != null && message.hasOwnProperty("queueName"))
                            object.queueName = message.queueName;
                        if (message.additionalVideosToCreate && message.additionalVideosToCreate.length) {
                            object.additionalVideosToCreate = [];
                            for (var j = 0; j < message.additionalVideosToCreate.length; ++j)
                                object.additionalVideosToCreate[j] = $root.palexy.streaming.v1.Video.toObject(message.additionalVideosToCreate[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this UpdateVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateVideoRequest;
                })();
    
                v1.DeleteVideoRequest = (function() {
    
                    /**
                     * Properties of a DeleteVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteVideoRequest
                     * @property {string|null} [name] DeleteVideoRequest name
                     */
    
                    /**
                     * Constructs a new DeleteVideoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteVideoRequest.
                     * @implements IDeleteVideoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteVideoRequest=} [properties] Properties to set
                     */
                    function DeleteVideoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteVideoRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @instance
                     */
                    DeleteVideoRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteVideoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteVideoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteVideoRequest} DeleteVideoRequest instance
                     */
                    DeleteVideoRequest.create = function create(properties) {
                        return new DeleteVideoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteVideoRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteVideoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteVideoRequest} message DeleteVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteVideoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteVideoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteVideoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteVideoRequest} message DeleteVideoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteVideoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteVideoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteVideoRequest} DeleteVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteVideoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteVideoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteVideoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteVideoRequest} DeleteVideoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteVideoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteVideoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteVideoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteVideoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteVideoRequest} DeleteVideoRequest
                     */
                    DeleteVideoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteVideoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteVideoRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteVideoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteVideoRequest} message DeleteVideoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteVideoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteVideoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteVideoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteVideoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteVideoRequest;
                })();
    
                v1.SubmitDeleteVideoTasksRequest = (function() {
    
                    /**
                     * Properties of a SubmitDeleteVideoTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISubmitDeleteVideoTasksRequest
                     * @property {Array.<string>|null} [names] SubmitDeleteVideoTasksRequest names
                     */
    
                    /**
                     * Constructs a new SubmitDeleteVideoTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SubmitDeleteVideoTasksRequest.
                     * @implements ISubmitDeleteVideoTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest=} [properties] Properties to set
                     */
                    function SubmitDeleteVideoTasksRequest(properties) {
                        this.names = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SubmitDeleteVideoTasksRequest names.
                     * @member {Array.<string>} names
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @instance
                     */
                    SubmitDeleteVideoTasksRequest.prototype.names = $util.emptyArray;
    
                    /**
                     * Creates a new SubmitDeleteVideoTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SubmitDeleteVideoTasksRequest} SubmitDeleteVideoTasksRequest instance
                     */
                    SubmitDeleteVideoTasksRequest.create = function create(properties) {
                        return new SubmitDeleteVideoTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SubmitDeleteVideoTasksRequest message. Does not implicitly {@link palexy.streaming.v1.SubmitDeleteVideoTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest} message SubmitDeleteVideoTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SubmitDeleteVideoTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.names != null && message.names.length)
                            for (var i = 0; i < message.names.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.names[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SubmitDeleteVideoTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SubmitDeleteVideoTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISubmitDeleteVideoTasksRequest} message SubmitDeleteVideoTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SubmitDeleteVideoTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SubmitDeleteVideoTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SubmitDeleteVideoTasksRequest} SubmitDeleteVideoTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SubmitDeleteVideoTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SubmitDeleteVideoTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.names && message.names.length))
                                    message.names = [];
                                message.names.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SubmitDeleteVideoTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SubmitDeleteVideoTasksRequest} SubmitDeleteVideoTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SubmitDeleteVideoTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SubmitDeleteVideoTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SubmitDeleteVideoTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.names != null && message.hasOwnProperty("names")) {
                            if (!Array.isArray(message.names))
                                return "names: array expected";
                            for (var i = 0; i < message.names.length; ++i)
                                if (!$util.isString(message.names[i]))
                                    return "names: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SubmitDeleteVideoTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SubmitDeleteVideoTasksRequest} SubmitDeleteVideoTasksRequest
                     */
                    SubmitDeleteVideoTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SubmitDeleteVideoTasksRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SubmitDeleteVideoTasksRequest();
                        if (object.names) {
                            if (!Array.isArray(object.names))
                                throw TypeError(".palexy.streaming.v1.SubmitDeleteVideoTasksRequest.names: array expected");
                            message.names = [];
                            for (var i = 0; i < object.names.length; ++i)
                                message.names[i] = String(object.names[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SubmitDeleteVideoTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.SubmitDeleteVideoTasksRequest} message SubmitDeleteVideoTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SubmitDeleteVideoTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.names = [];
                        if (message.names && message.names.length) {
                            object.names = [];
                            for (var j = 0; j < message.names.length; ++j)
                                object.names[j] = message.names[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SubmitDeleteVideoTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SubmitDeleteVideoTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SubmitDeleteVideoTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SubmitDeleteVideoTasksRequest;
                })();
    
                v1.Video = (function() {
    
                    /**
                     * Properties of a Video.
                     * @memberof palexy.streaming.v1
                     * @interface IVideo
                     * @property {string|null} [name] Video name
                     * @property {string|null} [bucket] Video bucket
                     * @property {string|null} [fileName] Video fileName
                     * @property {number|null} [sizeInBytes] Video sizeInBytes
                     * @property {google.protobuf.IDuration|null} [duration] Video duration
                     * @property {google.protobuf.ITimestamp|null} [createTime] Video createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] Video lastUpdateTime
                     * @property {palexy.streaming.v1.Video.State|null} [state] Video state
                     * @property {string|null} [cameraId] Video cameraId
                     * @property {string|null} [dateId] Video dateId
                     * @property {boolean|null} [isAlreadyPurged] Video isAlreadyPurged
                     * @property {google.protobuf.ITimestamp|null} [videoStartTime] Video videoStartTime
                     * @property {boolean|null} [archived] Video archived
                     * @property {string|null} [cloudProvider] Video cloudProvider
                     * @property {boolean|null} [skipFeatureExtraction] Video skipFeatureExtraction
                     * @property {boolean|null} [isTrackingFileAlreadyPurged] Video isTrackingFileAlreadyPurged
                     * @property {boolean|null} [isQcData] Video isQcData
                     * @property {google.protobuf.ITimestamp|null} [minimumVideoArchiveTime] Video minimumVideoArchiveTime
                     * @property {google.protobuf.ITimestamp|null} [minimumTrackingFileArchiveTime] Video minimumTrackingFileArchiveTime
                     * @property {palexy.streaming.v1.Video.PartialMergeState|null} [partialMergeState] Video partialMergeState
                     * @property {string|null} [partialMergeId] Video partialMergeId
                     * @property {google.protobuf.ITimestamp|null} [donePartialMergeTime] Video donePartialMergeTime
                     * @property {boolean|null} [isStreamingOnly] Video isStreamingOnly
                     * @property {number|null} [numBb] Video numBb
                     * @property {boolean|null} [isEarlyDelete] Video isEarlyDelete
                     * @property {boolean|null} [isFaceBlurred] Video isFaceBlurred
                     * @property {string|null} [trackingFileProvider] Video trackingFileProvider
                     */
    
                    /**
                     * Constructs a new Video.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Video.
                     * @implements IVideo
                     * @constructor
                     * @param {palexy.streaming.v1.IVideo=} [properties] Properties to set
                     */
                    function Video(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Video name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.name = "";
    
                    /**
                     * Video bucket.
                     * @member {string} bucket
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.bucket = "";
    
                    /**
                     * Video fileName.
                     * @member {string} fileName
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.fileName = "";
    
                    /**
                     * Video sizeInBytes.
                     * @member {number} sizeInBytes
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.sizeInBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Video duration.
                     * @member {google.protobuf.IDuration|null|undefined} duration
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.duration = null;
    
                    /**
                     * Video createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.createTime = null;
    
                    /**
                     * Video lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.lastUpdateTime = null;
    
                    /**
                     * Video state.
                     * @member {palexy.streaming.v1.Video.State} state
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.state = 0;
    
                    /**
                     * Video cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.cameraId = "";
    
                    /**
                     * Video dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.dateId = "";
    
                    /**
                     * Video isAlreadyPurged.
                     * @member {boolean} isAlreadyPurged
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isAlreadyPurged = false;
    
                    /**
                     * Video videoStartTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} videoStartTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.videoStartTime = null;
    
                    /**
                     * Video archived.
                     * @member {boolean} archived
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.archived = false;
    
                    /**
                     * Video cloudProvider.
                     * @member {string} cloudProvider
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.cloudProvider = "";
    
                    /**
                     * Video skipFeatureExtraction.
                     * @member {boolean} skipFeatureExtraction
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.skipFeatureExtraction = false;
    
                    /**
                     * Video isTrackingFileAlreadyPurged.
                     * @member {boolean} isTrackingFileAlreadyPurged
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isTrackingFileAlreadyPurged = false;
    
                    /**
                     * Video isQcData.
                     * @member {boolean} isQcData
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isQcData = false;
    
                    /**
                     * Video minimumVideoArchiveTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} minimumVideoArchiveTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.minimumVideoArchiveTime = null;
    
                    /**
                     * Video minimumTrackingFileArchiveTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} minimumTrackingFileArchiveTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.minimumTrackingFileArchiveTime = null;
    
                    /**
                     * Video partialMergeState.
                     * @member {palexy.streaming.v1.Video.PartialMergeState} partialMergeState
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.partialMergeState = 0;
    
                    /**
                     * Video partialMergeId.
                     * @member {string} partialMergeId
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.partialMergeId = "";
    
                    /**
                     * Video donePartialMergeTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} donePartialMergeTime
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.donePartialMergeTime = null;
    
                    /**
                     * Video isStreamingOnly.
                     * @member {boolean} isStreamingOnly
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isStreamingOnly = false;
    
                    /**
                     * Video numBb.
                     * @member {number} numBb
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.numBb = 0;
    
                    /**
                     * Video isEarlyDelete.
                     * @member {boolean} isEarlyDelete
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isEarlyDelete = false;
    
                    /**
                     * Video isFaceBlurred.
                     * @member {boolean} isFaceBlurred
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.isFaceBlurred = false;
    
                    /**
                     * Video trackingFileProvider.
                     * @member {string} trackingFileProvider
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     */
                    Video.prototype.trackingFileProvider = "";
    
                    /**
                     * Creates a new Video instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {palexy.streaming.v1.IVideo=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Video} Video instance
                     */
                    Video.create = function create(properties) {
                        return new Video(properties);
                    };
    
                    /**
                     * Encodes the specified Video message. Does not implicitly {@link palexy.streaming.v1.Video.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {palexy.streaming.v1.IVideo} message Video message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Video.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.bucket);
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fileName);
                        if (message.sizeInBytes != null && Object.hasOwnProperty.call(message, "sizeInBytes"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.sizeInBytes);
                        if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                            $root.google.protobuf.Duration.encode(message.duration, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.state);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.cameraId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.dateId);
                        if (message.isAlreadyPurged != null && Object.hasOwnProperty.call(message, "isAlreadyPurged"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isAlreadyPurged);
                        if (message.videoStartTime != null && Object.hasOwnProperty.call(message, "videoStartTime"))
                            $root.google.protobuf.Timestamp.encode(message.videoStartTime, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.archived != null && Object.hasOwnProperty.call(message, "archived"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.archived);
                        if (message.cloudProvider != null && Object.hasOwnProperty.call(message, "cloudProvider"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.cloudProvider);
                        if (message.skipFeatureExtraction != null && Object.hasOwnProperty.call(message, "skipFeatureExtraction"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.skipFeatureExtraction);
                        if (message.isTrackingFileAlreadyPurged != null && Object.hasOwnProperty.call(message, "isTrackingFileAlreadyPurged"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.isTrackingFileAlreadyPurged);
                        if (message.isQcData != null && Object.hasOwnProperty.call(message, "isQcData"))
                            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.isQcData);
                        if (message.minimumVideoArchiveTime != null && Object.hasOwnProperty.call(message, "minimumVideoArchiveTime"))
                            $root.google.protobuf.Timestamp.encode(message.minimumVideoArchiveTime, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.minimumTrackingFileArchiveTime != null && Object.hasOwnProperty.call(message, "minimumTrackingFileArchiveTime"))
                            $root.google.protobuf.Timestamp.encode(message.minimumTrackingFileArchiveTime, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.partialMergeState != null && Object.hasOwnProperty.call(message, "partialMergeState"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.partialMergeState);
                        if (message.partialMergeId != null && Object.hasOwnProperty.call(message, "partialMergeId"))
                            writer.uint32(/* id 21, wireType 2 =*/170).string(message.partialMergeId);
                        if (message.donePartialMergeTime != null && Object.hasOwnProperty.call(message, "donePartialMergeTime"))
                            $root.google.protobuf.Timestamp.encode(message.donePartialMergeTime, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                        if (message.isStreamingOnly != null && Object.hasOwnProperty.call(message, "isStreamingOnly"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.isStreamingOnly);
                        if (message.numBb != null && Object.hasOwnProperty.call(message, "numBb"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int32(message.numBb);
                        if (message.isEarlyDelete != null && Object.hasOwnProperty.call(message, "isEarlyDelete"))
                            writer.uint32(/* id 25, wireType 0 =*/200).bool(message.isEarlyDelete);
                        if (message.isFaceBlurred != null && Object.hasOwnProperty.call(message, "isFaceBlurred"))
                            writer.uint32(/* id 26, wireType 0 =*/208).bool(message.isFaceBlurred);
                        if (message.trackingFileProvider != null && Object.hasOwnProperty.call(message, "trackingFileProvider"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.trackingFileProvider);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Video message, length delimited. Does not implicitly {@link palexy.streaming.v1.Video.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {palexy.streaming.v1.IVideo} message Video message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Video.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Video message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Video} Video
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Video.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Video();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.bucket = reader.string();
                                break;
                            case 3:
                                message.fileName = reader.string();
                                break;
                            case 4:
                                message.sizeInBytes = reader.int64();
                                break;
                            case 5:
                                message.duration = $root.google.protobuf.Duration.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.state = reader.int32();
                                break;
                            case 9:
                                message.cameraId = reader.string();
                                break;
                            case 10:
                                message.dateId = reader.string();
                                break;
                            case 11:
                                message.isAlreadyPurged = reader.bool();
                                break;
                            case 12:
                                message.videoStartTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.archived = reader.bool();
                                break;
                            case 14:
                                message.cloudProvider = reader.string();
                                break;
                            case 15:
                                message.skipFeatureExtraction = reader.bool();
                                break;
                            case 16:
                                message.isTrackingFileAlreadyPurged = reader.bool();
                                break;
                            case 17:
                                message.isQcData = reader.bool();
                                break;
                            case 18:
                                message.minimumVideoArchiveTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 19:
                                message.minimumTrackingFileArchiveTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 20:
                                message.partialMergeState = reader.int32();
                                break;
                            case 21:
                                message.partialMergeId = reader.string();
                                break;
                            case 22:
                                message.donePartialMergeTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 23:
                                message.isStreamingOnly = reader.bool();
                                break;
                            case 24:
                                message.numBb = reader.int32();
                                break;
                            case 25:
                                message.isEarlyDelete = reader.bool();
                                break;
                            case 26:
                                message.isFaceBlurred = reader.bool();
                                break;
                            case 28:
                                message.trackingFileProvider = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Video message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Video} Video
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Video.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Video message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Video.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            if (!$util.isString(message.bucket))
                                return "bucket: string expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        if (message.sizeInBytes != null && message.hasOwnProperty("sizeInBytes"))
                            if (!$util.isInteger(message.sizeInBytes) && !(message.sizeInBytes && $util.isInteger(message.sizeInBytes.low) && $util.isInteger(message.sizeInBytes.high)))
                                return "sizeInBytes: integer|Long expected";
                        if (message.duration != null && message.hasOwnProperty("duration")) {
                            var error = $root.google.protobuf.Duration.verify(message.duration);
                            if (error)
                                return "duration." + error;
                        }
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 7:
                            case 6:
                            case 1:
                            case 8:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.isAlreadyPurged != null && message.hasOwnProperty("isAlreadyPurged"))
                            if (typeof message.isAlreadyPurged !== "boolean")
                                return "isAlreadyPurged: boolean expected";
                        if (message.videoStartTime != null && message.hasOwnProperty("videoStartTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.videoStartTime);
                            if (error)
                                return "videoStartTime." + error;
                        }
                        if (message.archived != null && message.hasOwnProperty("archived"))
                            if (typeof message.archived !== "boolean")
                                return "archived: boolean expected";
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            if (!$util.isString(message.cloudProvider))
                                return "cloudProvider: string expected";
                        if (message.skipFeatureExtraction != null && message.hasOwnProperty("skipFeatureExtraction"))
                            if (typeof message.skipFeatureExtraction !== "boolean")
                                return "skipFeatureExtraction: boolean expected";
                        if (message.isTrackingFileAlreadyPurged != null && message.hasOwnProperty("isTrackingFileAlreadyPurged"))
                            if (typeof message.isTrackingFileAlreadyPurged !== "boolean")
                                return "isTrackingFileAlreadyPurged: boolean expected";
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            if (typeof message.isQcData !== "boolean")
                                return "isQcData: boolean expected";
                        if (message.minimumVideoArchiveTime != null && message.hasOwnProperty("minimumVideoArchiveTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.minimumVideoArchiveTime);
                            if (error)
                                return "minimumVideoArchiveTime." + error;
                        }
                        if (message.minimumTrackingFileArchiveTime != null && message.hasOwnProperty("minimumTrackingFileArchiveTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.minimumTrackingFileArchiveTime);
                            if (error)
                                return "minimumTrackingFileArchiveTime." + error;
                        }
                        if (message.partialMergeState != null && message.hasOwnProperty("partialMergeState"))
                            switch (message.partialMergeState) {
                            default:
                                return "partialMergeState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.partialMergeId != null && message.hasOwnProperty("partialMergeId"))
                            if (!$util.isString(message.partialMergeId))
                                return "partialMergeId: string expected";
                        if (message.donePartialMergeTime != null && message.hasOwnProperty("donePartialMergeTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.donePartialMergeTime);
                            if (error)
                                return "donePartialMergeTime." + error;
                        }
                        if (message.isStreamingOnly != null && message.hasOwnProperty("isStreamingOnly"))
                            if (typeof message.isStreamingOnly !== "boolean")
                                return "isStreamingOnly: boolean expected";
                        if (message.numBb != null && message.hasOwnProperty("numBb"))
                            if (!$util.isInteger(message.numBb))
                                return "numBb: integer expected";
                        if (message.isEarlyDelete != null && message.hasOwnProperty("isEarlyDelete"))
                            if (typeof message.isEarlyDelete !== "boolean")
                                return "isEarlyDelete: boolean expected";
                        if (message.isFaceBlurred != null && message.hasOwnProperty("isFaceBlurred"))
                            if (typeof message.isFaceBlurred !== "boolean")
                                return "isFaceBlurred: boolean expected";
                        if (message.trackingFileProvider != null && message.hasOwnProperty("trackingFileProvider"))
                            if (!$util.isString(message.trackingFileProvider))
                                return "trackingFileProvider: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a Video message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Video} Video
                     */
                    Video.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Video)
                            return object;
                        var message = new $root.palexy.streaming.v1.Video();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.bucket != null)
                            message.bucket = String(object.bucket);
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        if (object.sizeInBytes != null)
                            if ($util.Long)
                                (message.sizeInBytes = $util.Long.fromValue(object.sizeInBytes)).unsigned = false;
                            else if (typeof object.sizeInBytes === "string")
                                message.sizeInBytes = parseInt(object.sizeInBytes, 10);
                            else if (typeof object.sizeInBytes === "number")
                                message.sizeInBytes = object.sizeInBytes;
                            else if (typeof object.sizeInBytes === "object")
                                message.sizeInBytes = new $util.LongBits(object.sizeInBytes.low >>> 0, object.sizeInBytes.high >>> 0).toNumber();
                        if (object.duration != null) {
                            if (typeof object.duration !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.duration: object expected");
                            message.duration = $root.google.protobuf.Duration.fromObject(object.duration);
                        }
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        switch (object.state) {
                        case "UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "WAITING_FOR_VIDEO_FILE":
                        case 7:
                            message.state = 7;
                            break;
                        case "WAITING_FOR_PREPROCESSING":
                        case 6:
                            message.state = 6;
                            break;
                        case "WAITING_FOR_PROCESSING":
                        case 1:
                            message.state = 1;
                            break;
                        case "WAITING_FOR_POSTPROCESSING":
                        case 8:
                            message.state = 8;
                            break;
                        case "DONE_TRACKING":
                        case 2:
                            message.state = 2;
                            break;
                        case "WAITING_FOR_MERGING":
                        case 3:
                            message.state = 3;
                            break;
                        case "DONE":
                        case 4:
                            message.state = 4;
                            break;
                        case "DONE_CALCULATING_ACCURACY":
                        case 5:
                            message.state = 5;
                            break;
                        }
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.isAlreadyPurged != null)
                            message.isAlreadyPurged = Boolean(object.isAlreadyPurged);
                        if (object.videoStartTime != null) {
                            if (typeof object.videoStartTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.videoStartTime: object expected");
                            message.videoStartTime = $root.google.protobuf.Timestamp.fromObject(object.videoStartTime);
                        }
                        if (object.archived != null)
                            message.archived = Boolean(object.archived);
                        if (object.cloudProvider != null)
                            message.cloudProvider = String(object.cloudProvider);
                        if (object.skipFeatureExtraction != null)
                            message.skipFeatureExtraction = Boolean(object.skipFeatureExtraction);
                        if (object.isTrackingFileAlreadyPurged != null)
                            message.isTrackingFileAlreadyPurged = Boolean(object.isTrackingFileAlreadyPurged);
                        if (object.isQcData != null)
                            message.isQcData = Boolean(object.isQcData);
                        if (object.minimumVideoArchiveTime != null) {
                            if (typeof object.minimumVideoArchiveTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.minimumVideoArchiveTime: object expected");
                            message.minimumVideoArchiveTime = $root.google.protobuf.Timestamp.fromObject(object.minimumVideoArchiveTime);
                        }
                        if (object.minimumTrackingFileArchiveTime != null) {
                            if (typeof object.minimumTrackingFileArchiveTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.minimumTrackingFileArchiveTime: object expected");
                            message.minimumTrackingFileArchiveTime = $root.google.protobuf.Timestamp.fromObject(object.minimumTrackingFileArchiveTime);
                        }
                        switch (object.partialMergeState) {
                        case "UNKNOWN_MERGE_STATE":
                        case 0:
                            message.partialMergeState = 0;
                            break;
                        case "DEFAULT_STATE":
                        case 1:
                            message.partialMergeState = 1;
                            break;
                        case "WAITING_FOR_PARTIALLY_MERGING":
                        case 2:
                            message.partialMergeState = 2;
                            break;
                        case "DONE_PARTIAL_MERGE":
                        case 3:
                            message.partialMergeState = 3;
                            break;
                        case "SKIP_MERGE":
                        case 4:
                            message.partialMergeState = 4;
                            break;
                        }
                        if (object.partialMergeId != null)
                            message.partialMergeId = String(object.partialMergeId);
                        if (object.donePartialMergeTime != null) {
                            if (typeof object.donePartialMergeTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Video.donePartialMergeTime: object expected");
                            message.donePartialMergeTime = $root.google.protobuf.Timestamp.fromObject(object.donePartialMergeTime);
                        }
                        if (object.isStreamingOnly != null)
                            message.isStreamingOnly = Boolean(object.isStreamingOnly);
                        if (object.numBb != null)
                            message.numBb = object.numBb | 0;
                        if (object.isEarlyDelete != null)
                            message.isEarlyDelete = Boolean(object.isEarlyDelete);
                        if (object.isFaceBlurred != null)
                            message.isFaceBlurred = Boolean(object.isFaceBlurred);
                        if (object.trackingFileProvider != null)
                            message.trackingFileProvider = String(object.trackingFileProvider);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Video message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Video
                     * @static
                     * @param {palexy.streaming.v1.Video} message Video
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Video.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.bucket = "";
                            object.fileName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sizeInBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sizeInBytes = options.longs === String ? "0" : 0;
                            object.duration = null;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            object.state = options.enums === String ? "UNKNOWN" : 0;
                            object.cameraId = "";
                            object.dateId = "";
                            object.isAlreadyPurged = false;
                            object.videoStartTime = null;
                            object.archived = false;
                            object.cloudProvider = "";
                            object.skipFeatureExtraction = false;
                            object.isTrackingFileAlreadyPurged = false;
                            object.isQcData = false;
                            object.minimumVideoArchiveTime = null;
                            object.minimumTrackingFileArchiveTime = null;
                            object.partialMergeState = options.enums === String ? "UNKNOWN_MERGE_STATE" : 0;
                            object.partialMergeId = "";
                            object.donePartialMergeTime = null;
                            object.isStreamingOnly = false;
                            object.numBb = 0;
                            object.isEarlyDelete = false;
                            object.isFaceBlurred = false;
                            object.trackingFileProvider = "";
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.bucket != null && message.hasOwnProperty("bucket"))
                            object.bucket = message.bucket;
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        if (message.sizeInBytes != null && message.hasOwnProperty("sizeInBytes"))
                            if (typeof message.sizeInBytes === "number")
                                object.sizeInBytes = options.longs === String ? String(message.sizeInBytes) : message.sizeInBytes;
                            else
                                object.sizeInBytes = options.longs === String ? $util.Long.prototype.toString.call(message.sizeInBytes) : options.longs === Number ? new $util.LongBits(message.sizeInBytes.low >>> 0, message.sizeInBytes.high >>> 0).toNumber() : message.sizeInBytes;
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            object.duration = $root.google.protobuf.Duration.toObject(message.duration, options);
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.Video.State[message.state] : message.state;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.isAlreadyPurged != null && message.hasOwnProperty("isAlreadyPurged"))
                            object.isAlreadyPurged = message.isAlreadyPurged;
                        if (message.videoStartTime != null && message.hasOwnProperty("videoStartTime"))
                            object.videoStartTime = $root.google.protobuf.Timestamp.toObject(message.videoStartTime, options);
                        if (message.archived != null && message.hasOwnProperty("archived"))
                            object.archived = message.archived;
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            object.cloudProvider = message.cloudProvider;
                        if (message.skipFeatureExtraction != null && message.hasOwnProperty("skipFeatureExtraction"))
                            object.skipFeatureExtraction = message.skipFeatureExtraction;
                        if (message.isTrackingFileAlreadyPurged != null && message.hasOwnProperty("isTrackingFileAlreadyPurged"))
                            object.isTrackingFileAlreadyPurged = message.isTrackingFileAlreadyPurged;
                        if (message.isQcData != null && message.hasOwnProperty("isQcData"))
                            object.isQcData = message.isQcData;
                        if (message.minimumVideoArchiveTime != null && message.hasOwnProperty("minimumVideoArchiveTime"))
                            object.minimumVideoArchiveTime = $root.google.protobuf.Timestamp.toObject(message.minimumVideoArchiveTime, options);
                        if (message.minimumTrackingFileArchiveTime != null && message.hasOwnProperty("minimumTrackingFileArchiveTime"))
                            object.minimumTrackingFileArchiveTime = $root.google.protobuf.Timestamp.toObject(message.minimumTrackingFileArchiveTime, options);
                        if (message.partialMergeState != null && message.hasOwnProperty("partialMergeState"))
                            object.partialMergeState = options.enums === String ? $root.palexy.streaming.v1.Video.PartialMergeState[message.partialMergeState] : message.partialMergeState;
                        if (message.partialMergeId != null && message.hasOwnProperty("partialMergeId"))
                            object.partialMergeId = message.partialMergeId;
                        if (message.donePartialMergeTime != null && message.hasOwnProperty("donePartialMergeTime"))
                            object.donePartialMergeTime = $root.google.protobuf.Timestamp.toObject(message.donePartialMergeTime, options);
                        if (message.isStreamingOnly != null && message.hasOwnProperty("isStreamingOnly"))
                            object.isStreamingOnly = message.isStreamingOnly;
                        if (message.numBb != null && message.hasOwnProperty("numBb"))
                            object.numBb = message.numBb;
                        if (message.isEarlyDelete != null && message.hasOwnProperty("isEarlyDelete"))
                            object.isEarlyDelete = message.isEarlyDelete;
                        if (message.isFaceBlurred != null && message.hasOwnProperty("isFaceBlurred"))
                            object.isFaceBlurred = message.isFaceBlurred;
                        if (message.trackingFileProvider != null && message.hasOwnProperty("trackingFileProvider"))
                            object.trackingFileProvider = message.trackingFileProvider;
                        return object;
                    };
    
                    /**
                     * Converts this Video to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Video
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Video.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * State enum.
                     * @name palexy.streaming.v1.Video.State
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} WAITING_FOR_VIDEO_FILE=7 WAITING_FOR_VIDEO_FILE value
                     * @property {number} WAITING_FOR_PREPROCESSING=6 WAITING_FOR_PREPROCESSING value
                     * @property {number} WAITING_FOR_PROCESSING=1 WAITING_FOR_PROCESSING value
                     * @property {number} WAITING_FOR_POSTPROCESSING=8 WAITING_FOR_POSTPROCESSING value
                     * @property {number} DONE_TRACKING=2 DONE_TRACKING value
                     * @property {number} WAITING_FOR_MERGING=3 WAITING_FOR_MERGING value
                     * @property {number} DONE=4 DONE value
                     * @property {number} DONE_CALCULATING_ACCURACY=5 DONE_CALCULATING_ACCURACY value
                     */
                    Video.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[7] = "WAITING_FOR_VIDEO_FILE"] = 7;
                        values[valuesById[6] = "WAITING_FOR_PREPROCESSING"] = 6;
                        values[valuesById[1] = "WAITING_FOR_PROCESSING"] = 1;
                        values[valuesById[8] = "WAITING_FOR_POSTPROCESSING"] = 8;
                        values[valuesById[2] = "DONE_TRACKING"] = 2;
                        values[valuesById[3] = "WAITING_FOR_MERGING"] = 3;
                        values[valuesById[4] = "DONE"] = 4;
                        values[valuesById[5] = "DONE_CALCULATING_ACCURACY"] = 5;
                        return values;
                    })();
    
                    /**
                     * PartialMergeState enum.
                     * @name palexy.streaming.v1.Video.PartialMergeState
                     * @enum {number}
                     * @property {number} UNKNOWN_MERGE_STATE=0 UNKNOWN_MERGE_STATE value
                     * @property {number} DEFAULT_STATE=1 DEFAULT_STATE value
                     * @property {number} WAITING_FOR_PARTIALLY_MERGING=2 WAITING_FOR_PARTIALLY_MERGING value
                     * @property {number} DONE_PARTIAL_MERGE=3 DONE_PARTIAL_MERGE value
                     * @property {number} SKIP_MERGE=4 SKIP_MERGE value
                     */
                    Video.PartialMergeState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_MERGE_STATE"] = 0;
                        values[valuesById[1] = "DEFAULT_STATE"] = 1;
                        values[valuesById[2] = "WAITING_FOR_PARTIALLY_MERGING"] = 2;
                        values[valuesById[3] = "DONE_PARTIAL_MERGE"] = 3;
                        values[valuesById[4] = "SKIP_MERGE"] = 4;
                        return values;
                    })();
    
                    return Video;
                })();
    
                v1.VideoAndAckId = (function() {
    
                    /**
                     * Properties of a VideoAndAckId.
                     * @memberof palexy.streaming.v1
                     * @interface IVideoAndAckId
                     * @property {palexy.streaming.v1.IVideo|null} [video] VideoAndAckId video
                     * @property {string|null} [ackId] VideoAndAckId ackId
                     */
    
                    /**
                     * Constructs a new VideoAndAckId.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VideoAndAckId.
                     * @implements IVideoAndAckId
                     * @constructor
                     * @param {palexy.streaming.v1.IVideoAndAckId=} [properties] Properties to set
                     */
                    function VideoAndAckId(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VideoAndAckId video.
                     * @member {palexy.streaming.v1.IVideo|null|undefined} video
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @instance
                     */
                    VideoAndAckId.prototype.video = null;
    
                    /**
                     * VideoAndAckId ackId.
                     * @member {string} ackId
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @instance
                     */
                    VideoAndAckId.prototype.ackId = "";
    
                    /**
                     * Creates a new VideoAndAckId instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {palexy.streaming.v1.IVideoAndAckId=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.VideoAndAckId} VideoAndAckId instance
                     */
                    VideoAndAckId.create = function create(properties) {
                        return new VideoAndAckId(properties);
                    };
    
                    /**
                     * Encodes the specified VideoAndAckId message. Does not implicitly {@link palexy.streaming.v1.VideoAndAckId.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {palexy.streaming.v1.IVideoAndAckId} message VideoAndAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VideoAndAckId.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Video.encode(message.video, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.ackId != null && Object.hasOwnProperty.call(message, "ackId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ackId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VideoAndAckId message, length delimited. Does not implicitly {@link palexy.streaming.v1.VideoAndAckId.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {palexy.streaming.v1.IVideoAndAckId} message VideoAndAckId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VideoAndAckId.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VideoAndAckId message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.VideoAndAckId} VideoAndAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VideoAndAckId.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.VideoAndAckId();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.video = $root.palexy.streaming.v1.Video.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.ackId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VideoAndAckId message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.VideoAndAckId} VideoAndAckId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VideoAndAckId.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VideoAndAckId message.
                     * @function verify
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VideoAndAckId.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Video.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            if (!$util.isString(message.ackId))
                                return "ackId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a VideoAndAckId message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.VideoAndAckId} VideoAndAckId
                     */
                    VideoAndAckId.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.VideoAndAckId)
                            return object;
                        var message = new $root.palexy.streaming.v1.VideoAndAckId();
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.streaming.v1.VideoAndAckId.video: object expected");
                            message.video = $root.palexy.streaming.v1.Video.fromObject(object.video);
                        }
                        if (object.ackId != null)
                            message.ackId = String(object.ackId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VideoAndAckId message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @static
                     * @param {palexy.streaming.v1.VideoAndAckId} message VideoAndAckId
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VideoAndAckId.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.video = null;
                            object.ackId = "";
                        }
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Video.toObject(message.video, options);
                        if (message.ackId != null && message.hasOwnProperty("ackId"))
                            object.ackId = message.ackId;
                        return object;
                    };
    
                    /**
                     * Converts this VideoAndAckId to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.VideoAndAckId
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VideoAndAckId.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return VideoAndAckId;
                })();
    
                v1.NotificationService = (function() {
    
                    /**
                     * Constructs a new NotificationService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a NotificationService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function NotificationService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (NotificationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NotificationService;
    
                    /**
                     * Creates new NotificationService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.NotificationService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {NotificationService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    NotificationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendCameraNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendCameraNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendCameraNotification.
                     * @function sendCameraNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ICameraNotificationRequest} request CameraNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendCameraNotificationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendCameraNotification = function sendCameraNotification(request, callback) {
                        return this.rpcCall(sendCameraNotification, $root.palexy.streaming.v1.CameraNotificationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendCameraNotification" });
    
                    /**
                     * Calls SendCameraNotification.
                     * @function sendCameraNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ICameraNotificationRequest} request CameraNotificationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#listNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef ListNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListNotificationResponse} [response] ListNotificationResponse
                     */
    
                    /**
                     * Calls ListNotification.
                     * @function listNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IListNotificationRequest} request ListNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.ListNotificationCallback} callback Node-style callback called with the error, if any, and ListNotificationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.listNotification = function listNotification(request, callback) {
                        return this.rpcCall(listNotification, $root.palexy.streaming.v1.ListNotificationRequest, $root.palexy.streaming.v1.ListNotificationResponse, request, callback);
                    }, "name", { value: "ListNotification" });
    
                    /**
                     * Calls ListNotification.
                     * @function listNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IListNotificationRequest} request ListNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListNotificationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#getNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef GetNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Notification} [response] Notification
                     */
    
                    /**
                     * Calls GetNotification.
                     * @function getNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IGetNotificationRequest} request GetNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.GetNotificationCallback} callback Node-style callback called with the error, if any, and Notification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.getNotification = function getNotification(request, callback) {
                        return this.rpcCall(getNotification, $root.palexy.streaming.v1.GetNotificationRequest, $root.palexy.streaming.v1.Notification, request, callback);
                    }, "name", { value: "GetNotification" });
    
                    /**
                     * Calls GetNotification.
                     * @function getNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IGetNotificationRequest} request GetNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Notification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#createNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef CreateNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Notification} [response] Notification
                     */
    
                    /**
                     * Calls CreateNotification.
                     * @function createNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.INotification} request Notification message or plain object
                     * @param {palexy.streaming.v1.NotificationService.CreateNotificationCallback} callback Node-style callback called with the error, if any, and Notification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.createNotification = function createNotification(request, callback) {
                        return this.rpcCall(createNotification, $root.palexy.streaming.v1.Notification, $root.palexy.streaming.v1.Notification, request, callback);
                    }, "name", { value: "CreateNotification" });
    
                    /**
                     * Calls CreateNotification.
                     * @function createNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.INotification} request Notification message or plain object
                     * @returns {Promise<palexy.streaming.v1.Notification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#batchCreateNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef BatchCreateNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateNotificationResponse} [response] BatchCreateNotificationResponse
                     */
    
                    /**
                     * Calls BatchCreateNotification.
                     * @function batchCreateNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest} request BatchCreateNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.BatchCreateNotificationCallback} callback Node-style callback called with the error, if any, and BatchCreateNotificationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.batchCreateNotification = function batchCreateNotification(request, callback) {
                        return this.rpcCall(batchCreateNotification, $root.palexy.streaming.v1.BatchCreateNotificationRequest, $root.palexy.streaming.v1.BatchCreateNotificationResponse, request, callback);
                    }, "name", { value: "BatchCreateNotification" });
    
                    /**
                     * Calls BatchCreateNotification.
                     * @function batchCreateNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest} request BatchCreateNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateNotificationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#markAllNotificationsAsRead}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef MarkAllNotificationsAsReadCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls MarkAllNotificationsAsRead.
                     * @function markAllNotificationsAsRead
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest} request MarkAllNotificationsAsReadRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.MarkAllNotificationsAsReadCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.markAllNotificationsAsRead = function markAllNotificationsAsRead(request, callback) {
                        return this.rpcCall(markAllNotificationsAsRead, $root.palexy.streaming.v1.MarkAllNotificationsAsReadRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "MarkAllNotificationsAsRead" });
    
                    /**
                     * Calls MarkAllNotificationsAsRead.
                     * @function markAllNotificationsAsRead
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest} request MarkAllNotificationsAsReadRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#updateNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef UpdateNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Notification} [response] Notification
                     */
    
                    /**
                     * Calls UpdateNotification.
                     * @function updateNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest} request UpdateNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.UpdateNotificationCallback} callback Node-style callback called with the error, if any, and Notification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.updateNotification = function updateNotification(request, callback) {
                        return this.rpcCall(updateNotification, $root.palexy.streaming.v1.UpdateNotificationRequest, $root.palexy.streaming.v1.Notification, request, callback);
                    }, "name", { value: "UpdateNotification" });
    
                    /**
                     * Calls UpdateNotification.
                     * @function updateNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest} request UpdateNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Notification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SendNotificationResponse} [response] SendNotificationResponse
                     */
    
                    /**
                     * Calls SendNotification.
                     * @function sendNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendNotificationRequest} request SendNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendNotificationCallback} callback Node-style callback called with the error, if any, and SendNotificationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendNotification = function sendNotification(request, callback) {
                        return this.rpcCall(sendNotification, $root.palexy.streaming.v1.SendNotificationRequest, $root.palexy.streaming.v1.SendNotificationResponse, request, callback);
                    }, "name", { value: "SendNotification" });
    
                    /**
                     * Calls SendNotification.
                     * @function sendNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendNotificationRequest} request SendNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SendNotificationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendExportRawICANotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendExportRawICANotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportRawICANotificationResponse} [response] ExportRawICANotificationResponse
                     */
    
                    /**
                     * Calls SendExportRawICANotification.
                     * @function sendExportRawICANotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest} request ExportRawICANotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendExportRawICANotificationCallback} callback Node-style callback called with the error, if any, and ExportRawICANotificationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendExportRawICANotification = function sendExportRawICANotification(request, callback) {
                        return this.rpcCall(sendExportRawICANotification, $root.palexy.streaming.v1.ExportRawICANotificationRequest, $root.palexy.streaming.v1.ExportRawICANotificationResponse, request, callback);
                    }, "name", { value: "SendExportRawICANotification" });
    
                    /**
                     * Calls SendExportRawICANotification.
                     * @function sendExportRawICANotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest} request ExportRawICANotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportRawICANotificationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendVerificationEmail}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendVerificationEmailCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendVerificationEmail.
                     * @function sendVerificationEmail
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest} request SendVerificationEmailRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendVerificationEmailCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendVerificationEmail = function sendVerificationEmail(request, callback) {
                        return this.rpcCall(sendVerificationEmail, $root.palexy.streaming.v1.SendVerificationEmailRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendVerificationEmail" });
    
                    /**
                     * Calls SendVerificationEmail.
                     * @function sendVerificationEmail
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest} request SendVerificationEmailRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendScheduledReportNotification}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendScheduledReportNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendScheduledReportNotification.
                     * @function sendScheduledReportNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest} request SendScheduledReportNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendScheduledReportNotificationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendScheduledReportNotification = function sendScheduledReportNotification(request, callback) {
                        return this.rpcCall(sendScheduledReportNotification, $root.palexy.streaming.v1.SendScheduledReportNotificationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendScheduledReportNotification" });
    
                    /**
                     * Calls SendScheduledReportNotification.
                     * @function sendScheduledReportNotification
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest} request SendScheduledReportNotificationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NotificationService#sendOtp}.
                     * @memberof palexy.streaming.v1.NotificationService
                     * @typedef SendOtpCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendOtp.
                     * @function sendOtp
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendOtpRequest} request SendOtpRequest message or plain object
                     * @param {palexy.streaming.v1.NotificationService.SendOtpCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NotificationService.prototype.sendOtp = function sendOtp(request, callback) {
                        return this.rpcCall(sendOtp, $root.palexy.streaming.v1.SendOtpRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendOtp" });
    
                    /**
                     * Calls SendOtp.
                     * @function sendOtp
                     * @memberof palexy.streaming.v1.NotificationService
                     * @instance
                     * @param {palexy.streaming.v1.ISendOtpRequest} request SendOtpRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return NotificationService;
                })();
    
                v1.CameraNotificationRequest = (function() {
    
                    /**
                     * Properties of a CameraNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraNotificationRequest
                     * @property {palexy.streaming.v1.CameraNotificationRequest.NotificationType|null} [notificationType] CameraNotificationRequest notificationType
                     * @property {string|null} [cameraId] CameraNotificationRequest cameraId
                     * @property {palexy.streaming.v1.ICameraEmptyVideoAlert|null} [cameraEmptyVideoAlert] CameraNotificationRequest cameraEmptyVideoAlert
                     */
    
                    /**
                     * Constructs a new CameraNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraNotificationRequest.
                     * @implements ICameraNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraNotificationRequest=} [properties] Properties to set
                     */
                    function CameraNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraNotificationRequest notificationType.
                     * @member {palexy.streaming.v1.CameraNotificationRequest.NotificationType} notificationType
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @instance
                     */
                    CameraNotificationRequest.prototype.notificationType = 0;
    
                    /**
                     * CameraNotificationRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @instance
                     */
                    CameraNotificationRequest.prototype.cameraId = "";
    
                    /**
                     * CameraNotificationRequest cameraEmptyVideoAlert.
                     * @member {palexy.streaming.v1.ICameraEmptyVideoAlert|null|undefined} cameraEmptyVideoAlert
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @instance
                     */
                    CameraNotificationRequest.prototype.cameraEmptyVideoAlert = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * CameraNotificationRequest notificationObject.
                     * @member {"cameraEmptyVideoAlert"|undefined} notificationObject
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @instance
                     */
                    Object.defineProperty(CameraNotificationRequest.prototype, "notificationObject", {
                        get: $util.oneOfGetter($oneOfFields = ["cameraEmptyVideoAlert"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new CameraNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ICameraNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraNotificationRequest} CameraNotificationRequest instance
                     */
                    CameraNotificationRequest.create = function create(properties) {
                        return new CameraNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CameraNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.CameraNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ICameraNotificationRequest} message CameraNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notificationType != null && Object.hasOwnProperty.call(message, "notificationType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.notificationType);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.cameraEmptyVideoAlert != null && Object.hasOwnProperty.call(message, "cameraEmptyVideoAlert"))
                            $root.palexy.streaming.v1.CameraEmptyVideoAlert.encode(message.cameraEmptyVideoAlert, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ICameraNotificationRequest} message CameraNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraNotificationRequest} CameraNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notificationType = reader.int32();
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.cameraEmptyVideoAlert = $root.palexy.streaming.v1.CameraEmptyVideoAlert.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraNotificationRequest} CameraNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.notificationType != null && message.hasOwnProperty("notificationType"))
                            switch (message.notificationType) {
                            default:
                                return "notificationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.cameraEmptyVideoAlert != null && message.hasOwnProperty("cameraEmptyVideoAlert")) {
                            properties.notificationObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.CameraEmptyVideoAlert.verify(message.cameraEmptyVideoAlert);
                                if (error)
                                    return "cameraEmptyVideoAlert." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CameraNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraNotificationRequest} CameraNotificationRequest
                     */
                    CameraNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraNotificationRequest();
                        switch (object.notificationType) {
                        case "UNKNOWN":
                        case 0:
                            message.notificationType = 0;
                            break;
                        case "CAMERA_BROKEN_ALERT_LEVEL_2":
                        case 1:
                            message.notificationType = 1;
                            break;
                        case "CAMERA_BROKEN_ALERT_LEVEL_1":
                        case 2:
                            message.notificationType = 2;
                            break;
                        case "CAMERA_EMPTY_VIDEO_ALERT":
                        case 3:
                            message.notificationType = 3;
                            break;
                        }
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.cameraEmptyVideoAlert != null) {
                            if (typeof object.cameraEmptyVideoAlert !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraNotificationRequest.cameraEmptyVideoAlert: object expected");
                            message.cameraEmptyVideoAlert = $root.palexy.streaming.v1.CameraEmptyVideoAlert.fromObject(object.cameraEmptyVideoAlert);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.CameraNotificationRequest} message CameraNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.notificationType = options.enums === String ? "UNKNOWN" : 0;
                            object.cameraId = "";
                        }
                        if (message.notificationType != null && message.hasOwnProperty("notificationType"))
                            object.notificationType = options.enums === String ? $root.palexy.streaming.v1.CameraNotificationRequest.NotificationType[message.notificationType] : message.notificationType;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.cameraEmptyVideoAlert != null && message.hasOwnProperty("cameraEmptyVideoAlert")) {
                            object.cameraEmptyVideoAlert = $root.palexy.streaming.v1.CameraEmptyVideoAlert.toObject(message.cameraEmptyVideoAlert, options);
                            if (options.oneofs)
                                object.notificationObject = "cameraEmptyVideoAlert";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CameraNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * NotificationType enum.
                     * @name palexy.streaming.v1.CameraNotificationRequest.NotificationType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} CAMERA_BROKEN_ALERT_LEVEL_2=1 CAMERA_BROKEN_ALERT_LEVEL_2 value
                     * @property {number} CAMERA_BROKEN_ALERT_LEVEL_1=2 CAMERA_BROKEN_ALERT_LEVEL_1 value
                     * @property {number} CAMERA_EMPTY_VIDEO_ALERT=3 CAMERA_EMPTY_VIDEO_ALERT value
                     */
                    CameraNotificationRequest.NotificationType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "CAMERA_BROKEN_ALERT_LEVEL_2"] = 1;
                        values[valuesById[2] = "CAMERA_BROKEN_ALERT_LEVEL_1"] = 2;
                        values[valuesById[3] = "CAMERA_EMPTY_VIDEO_ALERT"] = 3;
                        return values;
                    })();
    
                    return CameraNotificationRequest;
                })();
    
                v1.CameraEmptyVideoAlert = (function() {
    
                    /**
                     * Properties of a CameraEmptyVideoAlert.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraEmptyVideoAlert
                     * @property {string|null} [videoName] CameraEmptyVideoAlert videoName
                     */
    
                    /**
                     * Constructs a new CameraEmptyVideoAlert.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraEmptyVideoAlert.
                     * @implements ICameraEmptyVideoAlert
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraEmptyVideoAlert=} [properties] Properties to set
                     */
                    function CameraEmptyVideoAlert(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraEmptyVideoAlert videoName.
                     * @member {string} videoName
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @instance
                     */
                    CameraEmptyVideoAlert.prototype.videoName = "";
    
                    /**
                     * Creates a new CameraEmptyVideoAlert instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {palexy.streaming.v1.ICameraEmptyVideoAlert=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraEmptyVideoAlert} CameraEmptyVideoAlert instance
                     */
                    CameraEmptyVideoAlert.create = function create(properties) {
                        return new CameraEmptyVideoAlert(properties);
                    };
    
                    /**
                     * Encodes the specified CameraEmptyVideoAlert message. Does not implicitly {@link palexy.streaming.v1.CameraEmptyVideoAlert.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {palexy.streaming.v1.ICameraEmptyVideoAlert} message CameraEmptyVideoAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraEmptyVideoAlert.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.videoName != null && Object.hasOwnProperty.call(message, "videoName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.videoName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraEmptyVideoAlert message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraEmptyVideoAlert.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {palexy.streaming.v1.ICameraEmptyVideoAlert} message CameraEmptyVideoAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraEmptyVideoAlert.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraEmptyVideoAlert message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraEmptyVideoAlert} CameraEmptyVideoAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraEmptyVideoAlert.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraEmptyVideoAlert();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.videoName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraEmptyVideoAlert message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraEmptyVideoAlert} CameraEmptyVideoAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraEmptyVideoAlert.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraEmptyVideoAlert message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraEmptyVideoAlert.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.videoName != null && message.hasOwnProperty("videoName"))
                            if (!$util.isString(message.videoName))
                                return "videoName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CameraEmptyVideoAlert message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraEmptyVideoAlert} CameraEmptyVideoAlert
                     */
                    CameraEmptyVideoAlert.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraEmptyVideoAlert)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraEmptyVideoAlert();
                        if (object.videoName != null)
                            message.videoName = String(object.videoName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraEmptyVideoAlert message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @static
                     * @param {palexy.streaming.v1.CameraEmptyVideoAlert} message CameraEmptyVideoAlert
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraEmptyVideoAlert.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.videoName = "";
                        if (message.videoName != null && message.hasOwnProperty("videoName"))
                            object.videoName = message.videoName;
                        return object;
                    };
    
                    /**
                     * Converts this CameraEmptyVideoAlert to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraEmptyVideoAlert
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraEmptyVideoAlert.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CameraEmptyVideoAlert;
                })();
    
                v1.Notification = (function() {
    
                    /**
                     * Properties of a Notification.
                     * @memberof palexy.streaming.v1
                     * @interface INotification
                     * @property {number|null} [id] Notification id
                     * @property {number|null} [storeId] Notification storeId
                     * @property {number|null} [accountId] Notification accountId
                     * @property {palexy.streaming.v1.Notification.Type|null} [type] Notification type
                     * @property {string|null} [message] Notification message
                     * @property {boolean|null} [isRead] Notification isRead
                     * @property {google.protobuf.ITimestamp|null} [createTime] Notification createTime
                     * @property {google.protobuf.ITimestamp|null} [sentTime] Notification sentTime
                     * @property {palexy.streaming.v1.IDailyMetricDroppedAlert|null} [dailyTrafficDroppedAlert] Notification dailyTrafficDroppedAlert
                     * @property {palexy.streaming.v1.IDailyMetricDroppedAlert|null} [dailyCvrDroppedAlert] Notification dailyCvrDroppedAlert
                     * @property {palexy.streaming.v1.IShiftAlert|null} [shiftAlert] Notification shiftAlert
                     */
    
                    /**
                     * Constructs a new Notification.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Notification.
                     * @implements INotification
                     * @constructor
                     * @param {palexy.streaming.v1.INotification=} [properties] Properties to set
                     */
                    function Notification(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Notification id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Notification storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Notification accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Notification type.
                     * @member {palexy.streaming.v1.Notification.Type} type
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.type = 0;
    
                    /**
                     * Notification message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.message = "";
    
                    /**
                     * Notification isRead.
                     * @member {boolean} isRead
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.isRead = false;
    
                    /**
                     * Notification createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.createTime = null;
    
                    /**
                     * Notification sentTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} sentTime
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.sentTime = null;
    
                    /**
                     * Notification dailyTrafficDroppedAlert.
                     * @member {palexy.streaming.v1.IDailyMetricDroppedAlert|null|undefined} dailyTrafficDroppedAlert
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.dailyTrafficDroppedAlert = null;
    
                    /**
                     * Notification dailyCvrDroppedAlert.
                     * @member {palexy.streaming.v1.IDailyMetricDroppedAlert|null|undefined} dailyCvrDroppedAlert
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.dailyCvrDroppedAlert = null;
    
                    /**
                     * Notification shiftAlert.
                     * @member {palexy.streaming.v1.IShiftAlert|null|undefined} shiftAlert
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Notification.prototype.shiftAlert = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * Notification notificationObject.
                     * @member {"dailyTrafficDroppedAlert"|"dailyCvrDroppedAlert"|"shiftAlert"|undefined} notificationObject
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     */
                    Object.defineProperty(Notification.prototype, "notificationObject", {
                        get: $util.oneOfGetter($oneOfFields = ["dailyTrafficDroppedAlert", "dailyCvrDroppedAlert", "shiftAlert"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new Notification instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {palexy.streaming.v1.INotification=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Notification} Notification instance
                     */
                    Notification.create = function create(properties) {
                        return new Notification(properties);
                    };
    
                    /**
                     * Encodes the specified Notification message. Does not implicitly {@link palexy.streaming.v1.Notification.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {palexy.streaming.v1.INotification} message Notification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Notification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.accountId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
                        if (message.isRead != null && Object.hasOwnProperty.call(message, "isRead"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isRead);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.sentTime != null && Object.hasOwnProperty.call(message, "sentTime"))
                            $root.google.protobuf.Timestamp.encode(message.sentTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.dailyTrafficDroppedAlert != null && Object.hasOwnProperty.call(message, "dailyTrafficDroppedAlert"))
                            $root.palexy.streaming.v1.DailyMetricDroppedAlert.encode(message.dailyTrafficDroppedAlert, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.dailyCvrDroppedAlert != null && Object.hasOwnProperty.call(message, "dailyCvrDroppedAlert"))
                            $root.palexy.streaming.v1.DailyMetricDroppedAlert.encode(message.dailyCvrDroppedAlert, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.shiftAlert != null && Object.hasOwnProperty.call(message, "shiftAlert"))
                            $root.palexy.streaming.v1.ShiftAlert.encode(message.shiftAlert, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Notification message, length delimited. Does not implicitly {@link palexy.streaming.v1.Notification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {palexy.streaming.v1.INotification} message Notification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Notification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Notification message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Notification} Notification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Notification.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Notification();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.accountId = reader.int64();
                                break;
                            case 4:
                                message.type = reader.int32();
                                break;
                            case 5:
                                message.message = reader.string();
                                break;
                            case 6:
                                message.isRead = reader.bool();
                                break;
                            case 7:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.sentTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.dailyTrafficDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.dailyCvrDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.shiftAlert = $root.palexy.streaming.v1.ShiftAlert.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Notification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Notification} Notification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Notification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Notification message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Notification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.isRead != null && message.hasOwnProperty("isRead"))
                            if (typeof message.isRead !== "boolean")
                                return "isRead: boolean expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.sentTime != null && message.hasOwnProperty("sentTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.sentTime);
                            if (error)
                                return "sentTime." + error;
                        }
                        if (message.dailyTrafficDroppedAlert != null && message.hasOwnProperty("dailyTrafficDroppedAlert")) {
                            properties.notificationObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.DailyMetricDroppedAlert.verify(message.dailyTrafficDroppedAlert);
                                if (error)
                                    return "dailyTrafficDroppedAlert." + error;
                            }
                        }
                        if (message.dailyCvrDroppedAlert != null && message.hasOwnProperty("dailyCvrDroppedAlert")) {
                            if (properties.notificationObject === 1)
                                return "notificationObject: multiple values";
                            properties.notificationObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.DailyMetricDroppedAlert.verify(message.dailyCvrDroppedAlert);
                                if (error)
                                    return "dailyCvrDroppedAlert." + error;
                            }
                        }
                        if (message.shiftAlert != null && message.hasOwnProperty("shiftAlert")) {
                            if (properties.notificationObject === 1)
                                return "notificationObject: multiple values";
                            properties.notificationObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.ShiftAlert.verify(message.shiftAlert);
                                if (error)
                                    return "shiftAlert." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Notification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Notification} Notification
                     */
                    Notification.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Notification)
                            return object;
                        var message = new $root.palexy.streaming.v1.Notification();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "DAILY_TRAFFIC_DROPPED_ALERT":
                        case 1:
                            message.type = 1;
                            break;
                        case "DAILY_CVR_DROPPED_ALERT":
                        case 2:
                            message.type = 2;
                            break;
                        case "SHIFT_ALERT":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.isRead != null)
                            message.isRead = Boolean(object.isRead);
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Notification.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.sentTime != null) {
                            if (typeof object.sentTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Notification.sentTime: object expected");
                            message.sentTime = $root.google.protobuf.Timestamp.fromObject(object.sentTime);
                        }
                        if (object.dailyTrafficDroppedAlert != null) {
                            if (typeof object.dailyTrafficDroppedAlert !== "object")
                                throw TypeError(".palexy.streaming.v1.Notification.dailyTrafficDroppedAlert: object expected");
                            message.dailyTrafficDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.fromObject(object.dailyTrafficDroppedAlert);
                        }
                        if (object.dailyCvrDroppedAlert != null) {
                            if (typeof object.dailyCvrDroppedAlert !== "object")
                                throw TypeError(".palexy.streaming.v1.Notification.dailyCvrDroppedAlert: object expected");
                            message.dailyCvrDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.fromObject(object.dailyCvrDroppedAlert);
                        }
                        if (object.shiftAlert != null) {
                            if (typeof object.shiftAlert !== "object")
                                throw TypeError(".palexy.streaming.v1.Notification.shiftAlert: object expected");
                            message.shiftAlert = $root.palexy.streaming.v1.ShiftAlert.fromObject(object.shiftAlert);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Notification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Notification
                     * @static
                     * @param {palexy.streaming.v1.Notification} message Notification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Notification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.message = "";
                            object.isRead = false;
                            object.createTime = null;
                            object.sentTime = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.Notification.Type[message.type] : message.type;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.isRead != null && message.hasOwnProperty("isRead"))
                            object.isRead = message.isRead;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.sentTime != null && message.hasOwnProperty("sentTime"))
                            object.sentTime = $root.google.protobuf.Timestamp.toObject(message.sentTime, options);
                        if (message.dailyTrafficDroppedAlert != null && message.hasOwnProperty("dailyTrafficDroppedAlert")) {
                            object.dailyTrafficDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.toObject(message.dailyTrafficDroppedAlert, options);
                            if (options.oneofs)
                                object.notificationObject = "dailyTrafficDroppedAlert";
                        }
                        if (message.dailyCvrDroppedAlert != null && message.hasOwnProperty("dailyCvrDroppedAlert")) {
                            object.dailyCvrDroppedAlert = $root.palexy.streaming.v1.DailyMetricDroppedAlert.toObject(message.dailyCvrDroppedAlert, options);
                            if (options.oneofs)
                                object.notificationObject = "dailyCvrDroppedAlert";
                        }
                        if (message.shiftAlert != null && message.hasOwnProperty("shiftAlert")) {
                            object.shiftAlert = $root.palexy.streaming.v1.ShiftAlert.toObject(message.shiftAlert, options);
                            if (options.oneofs)
                                object.notificationObject = "shiftAlert";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Notification to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Notification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Notification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Type enum.
                     * @name palexy.streaming.v1.Notification.Type
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} DAILY_TRAFFIC_DROPPED_ALERT=1 DAILY_TRAFFIC_DROPPED_ALERT value
                     * @property {number} DAILY_CVR_DROPPED_ALERT=2 DAILY_CVR_DROPPED_ALERT value
                     * @property {number} SHIFT_ALERT=3 SHIFT_ALERT value
                     */
                    Notification.Type = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "DAILY_TRAFFIC_DROPPED_ALERT"] = 1;
                        values[valuesById[2] = "DAILY_CVR_DROPPED_ALERT"] = 2;
                        values[valuesById[3] = "SHIFT_ALERT"] = 3;
                        return values;
                    })();
    
                    return Notification;
                })();
    
                v1.ShiftAlert = (function() {
    
                    /**
                     * Properties of a ShiftAlert.
                     * @memberof palexy.streaming.v1
                     * @interface IShiftAlert
                     * @property {google.protobuf.ITimestamp|null} [eventCreateTime] ShiftAlert eventCreateTime
                     * @property {string|null} [cameraId] ShiftAlert cameraId
                     * @property {string|null} [currentStatus] ShiftAlert currentStatus
                     * @property {string|null} [subjectId] ShiftAlert subjectId
                     * @property {number|null} [alertLevel] ShiftAlert alertLevel
                     */
    
                    /**
                     * Constructs a new ShiftAlert.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ShiftAlert.
                     * @implements IShiftAlert
                     * @constructor
                     * @param {palexy.streaming.v1.IShiftAlert=} [properties] Properties to set
                     */
                    function ShiftAlert(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftAlert eventCreateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} eventCreateTime
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     */
                    ShiftAlert.prototype.eventCreateTime = null;
    
                    /**
                     * ShiftAlert cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     */
                    ShiftAlert.prototype.cameraId = "";
    
                    /**
                     * ShiftAlert currentStatus.
                     * @member {string} currentStatus
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     */
                    ShiftAlert.prototype.currentStatus = "";
    
                    /**
                     * ShiftAlert subjectId.
                     * @member {string} subjectId
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     */
                    ShiftAlert.prototype.subjectId = "";
    
                    /**
                     * ShiftAlert alertLevel.
                     * @member {number} alertLevel
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     */
                    ShiftAlert.prototype.alertLevel = 0;
    
                    /**
                     * Creates a new ShiftAlert instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {palexy.streaming.v1.IShiftAlert=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ShiftAlert} ShiftAlert instance
                     */
                    ShiftAlert.create = function create(properties) {
                        return new ShiftAlert(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftAlert message. Does not implicitly {@link palexy.streaming.v1.ShiftAlert.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {palexy.streaming.v1.IShiftAlert} message ShiftAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftAlert.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventCreateTime != null && Object.hasOwnProperty.call(message, "eventCreateTime"))
                            $root.google.protobuf.Timestamp.encode(message.eventCreateTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.currentStatus != null && Object.hasOwnProperty.call(message, "currentStatus"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.currentStatus);
                        if (message.subjectId != null && Object.hasOwnProperty.call(message, "subjectId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.subjectId);
                        if (message.alertLevel != null && Object.hasOwnProperty.call(message, "alertLevel"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.alertLevel);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftAlert message, length delimited. Does not implicitly {@link palexy.streaming.v1.ShiftAlert.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {palexy.streaming.v1.IShiftAlert} message ShiftAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftAlert.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftAlert message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ShiftAlert} ShiftAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftAlert.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ShiftAlert();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.eventCreateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.currentStatus = reader.string();
                                break;
                            case 4:
                                message.subjectId = reader.string();
                                break;
                            case 5:
                                message.alertLevel = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftAlert message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ShiftAlert} ShiftAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftAlert.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftAlert message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftAlert.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.eventCreateTime != null && message.hasOwnProperty("eventCreateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.eventCreateTime);
                            if (error)
                                return "eventCreateTime." + error;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.currentStatus != null && message.hasOwnProperty("currentStatus"))
                            if (!$util.isString(message.currentStatus))
                                return "currentStatus: string expected";
                        if (message.subjectId != null && message.hasOwnProperty("subjectId"))
                            if (!$util.isString(message.subjectId))
                                return "subjectId: string expected";
                        if (message.alertLevel != null && message.hasOwnProperty("alertLevel"))
                            if (!$util.isInteger(message.alertLevel))
                                return "alertLevel: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftAlert message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ShiftAlert} ShiftAlert
                     */
                    ShiftAlert.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ShiftAlert)
                            return object;
                        var message = new $root.palexy.streaming.v1.ShiftAlert();
                        if (object.eventCreateTime != null) {
                            if (typeof object.eventCreateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.ShiftAlert.eventCreateTime: object expected");
                            message.eventCreateTime = $root.google.protobuf.Timestamp.fromObject(object.eventCreateTime);
                        }
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.currentStatus != null)
                            message.currentStatus = String(object.currentStatus);
                        if (object.subjectId != null)
                            message.subjectId = String(object.subjectId);
                        if (object.alertLevel != null)
                            message.alertLevel = object.alertLevel | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftAlert message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @static
                     * @param {palexy.streaming.v1.ShiftAlert} message ShiftAlert
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftAlert.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.eventCreateTime = null;
                            object.cameraId = "";
                            object.currentStatus = "";
                            object.subjectId = "";
                            object.alertLevel = 0;
                        }
                        if (message.eventCreateTime != null && message.hasOwnProperty("eventCreateTime"))
                            object.eventCreateTime = $root.google.protobuf.Timestamp.toObject(message.eventCreateTime, options);
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.currentStatus != null && message.hasOwnProperty("currentStatus"))
                            object.currentStatus = message.currentStatus;
                        if (message.subjectId != null && message.hasOwnProperty("subjectId"))
                            object.subjectId = message.subjectId;
                        if (message.alertLevel != null && message.hasOwnProperty("alertLevel"))
                            object.alertLevel = message.alertLevel;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftAlert to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ShiftAlert
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftAlert.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftAlert;
                })();
    
                v1.DailyMetricDroppedAlert = (function() {
    
                    /**
                     * Properties of a DailyMetricDroppedAlert.
                     * @memberof palexy.streaming.v1
                     * @interface IDailyMetricDroppedAlert
                     * @property {string|null} [dateId] DailyMetricDroppedAlert dateId
                     * @property {number|null} [previousMetric] DailyMetricDroppedAlert previousMetric
                     * @property {number|null} [currentMetric] DailyMetricDroppedAlert currentMetric
                     */
    
                    /**
                     * Constructs a new DailyMetricDroppedAlert.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DailyMetricDroppedAlert.
                     * @implements IDailyMetricDroppedAlert
                     * @constructor
                     * @param {palexy.streaming.v1.IDailyMetricDroppedAlert=} [properties] Properties to set
                     */
                    function DailyMetricDroppedAlert(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DailyMetricDroppedAlert dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @instance
                     */
                    DailyMetricDroppedAlert.prototype.dateId = "";
    
                    /**
                     * DailyMetricDroppedAlert previousMetric.
                     * @member {number} previousMetric
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @instance
                     */
                    DailyMetricDroppedAlert.prototype.previousMetric = 0;
    
                    /**
                     * DailyMetricDroppedAlert currentMetric.
                     * @member {number} currentMetric
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @instance
                     */
                    DailyMetricDroppedAlert.prototype.currentMetric = 0;
    
                    /**
                     * Creates a new DailyMetricDroppedAlert instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {palexy.streaming.v1.IDailyMetricDroppedAlert=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DailyMetricDroppedAlert} DailyMetricDroppedAlert instance
                     */
                    DailyMetricDroppedAlert.create = function create(properties) {
                        return new DailyMetricDroppedAlert(properties);
                    };
    
                    /**
                     * Encodes the specified DailyMetricDroppedAlert message. Does not implicitly {@link palexy.streaming.v1.DailyMetricDroppedAlert.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {palexy.streaming.v1.IDailyMetricDroppedAlert} message DailyMetricDroppedAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DailyMetricDroppedAlert.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.dateId);
                        if (message.previousMetric != null && Object.hasOwnProperty.call(message, "previousMetric"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.previousMetric);
                        if (message.currentMetric != null && Object.hasOwnProperty.call(message, "currentMetric"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.currentMetric);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DailyMetricDroppedAlert message, length delimited. Does not implicitly {@link palexy.streaming.v1.DailyMetricDroppedAlert.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {palexy.streaming.v1.IDailyMetricDroppedAlert} message DailyMetricDroppedAlert message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DailyMetricDroppedAlert.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DailyMetricDroppedAlert message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DailyMetricDroppedAlert} DailyMetricDroppedAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DailyMetricDroppedAlert.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DailyMetricDroppedAlert();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.string();
                                break;
                            case 2:
                                message.previousMetric = reader.double();
                                break;
                            case 3:
                                message.currentMetric = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DailyMetricDroppedAlert message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DailyMetricDroppedAlert} DailyMetricDroppedAlert
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DailyMetricDroppedAlert.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DailyMetricDroppedAlert message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DailyMetricDroppedAlert.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.previousMetric != null && message.hasOwnProperty("previousMetric"))
                            if (typeof message.previousMetric !== "number")
                                return "previousMetric: number expected";
                        if (message.currentMetric != null && message.hasOwnProperty("currentMetric"))
                            if (typeof message.currentMetric !== "number")
                                return "currentMetric: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a DailyMetricDroppedAlert message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DailyMetricDroppedAlert} DailyMetricDroppedAlert
                     */
                    DailyMetricDroppedAlert.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DailyMetricDroppedAlert)
                            return object;
                        var message = new $root.palexy.streaming.v1.DailyMetricDroppedAlert();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.previousMetric != null)
                            message.previousMetric = Number(object.previousMetric);
                        if (object.currentMetric != null)
                            message.currentMetric = Number(object.currentMetric);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DailyMetricDroppedAlert message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @static
                     * @param {palexy.streaming.v1.DailyMetricDroppedAlert} message DailyMetricDroppedAlert
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DailyMetricDroppedAlert.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dateId = "";
                            object.previousMetric = 0;
                            object.currentMetric = 0;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.previousMetric != null && message.hasOwnProperty("previousMetric"))
                            object.previousMetric = options.json && !isFinite(message.previousMetric) ? String(message.previousMetric) : message.previousMetric;
                        if (message.currentMetric != null && message.hasOwnProperty("currentMetric"))
                            object.currentMetric = options.json && !isFinite(message.currentMetric) ? String(message.currentMetric) : message.currentMetric;
                        return object;
                    };
    
                    /**
                     * Converts this DailyMetricDroppedAlert to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DailyMetricDroppedAlert
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DailyMetricDroppedAlert.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DailyMetricDroppedAlert;
                })();
    
                v1.ListNotificationRequest = (function() {
    
                    /**
                     * Properties of a ListNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListNotificationRequest
                     * @property {number|null} [storeId] ListNotificationRequest storeId
                     * @property {number|null} [accountId] ListNotificationRequest accountId
                     * @property {google.protobuf.ITimestamp|null} [from] ListNotificationRequest from
                     * @property {google.protobuf.ITimestamp|null} [to] ListNotificationRequest to
                     * @property {palexy.streaming.v1.Notification.Type|null} [type] ListNotificationRequest type
                     * @property {google.protobuf.IBoolValue|null} [isRead] ListNotificationRequest isRead
                     * @property {google.protobuf.IBoolValue|null} [isSent] ListNotificationRequest isSent
                     * @property {number|null} [limit] ListNotificationRequest limit
                     * @property {google.protobuf.IFieldMask|null} [fieldMask] ListNotificationRequest fieldMask
                     */
    
                    /**
                     * Constructs a new ListNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListNotificationRequest.
                     * @implements IListNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListNotificationRequest=} [properties] Properties to set
                     */
                    function ListNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListNotificationRequest storeId.
                     * @member {number|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.storeId = null;
    
                    /**
                     * ListNotificationRequest accountId.
                     * @member {number|null|undefined} accountId
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.accountId = null;
    
                    /**
                     * ListNotificationRequest from.
                     * @member {google.protobuf.ITimestamp|null|undefined} from
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.from = null;
    
                    /**
                     * ListNotificationRequest to.
                     * @member {google.protobuf.ITimestamp|null|undefined} to
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.to = null;
    
                    /**
                     * ListNotificationRequest type.
                     * @member {palexy.streaming.v1.Notification.Type} type
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.type = 0;
    
                    /**
                     * ListNotificationRequest isRead.
                     * @member {google.protobuf.IBoolValue|null|undefined} isRead
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.isRead = null;
    
                    /**
                     * ListNotificationRequest isSent.
                     * @member {google.protobuf.IBoolValue|null|undefined} isSent
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.isSent = null;
    
                    /**
                     * ListNotificationRequest limit.
                     * @member {number} limit
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.limit = 0;
    
                    /**
                     * ListNotificationRequest fieldMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} fieldMask
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    ListNotificationRequest.prototype.fieldMask = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ListNotificationRequest ownerFilter.
                     * @member {"storeId"|"accountId"|undefined} ownerFilter
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     */
                    Object.defineProperty(ListNotificationRequest.prototype, "ownerFilter", {
                        get: $util.oneOfGetter($oneOfFields = ["storeId", "accountId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ListNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListNotificationRequest} ListNotificationRequest instance
                     */
                    ListNotificationRequest.create = function create(properties) {
                        return new ListNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.ListNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationRequest} message ListNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.accountId);
                        if (message.from != null && Object.hasOwnProperty.call(message, "from"))
                            $root.google.protobuf.Timestamp.encode(message.from, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.to != null && Object.hasOwnProperty.call(message, "to"))
                            $root.google.protobuf.Timestamp.encode(message.to, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                        if (message.isRead != null && Object.hasOwnProperty.call(message, "isRead"))
                            $root.google.protobuf.BoolValue.encode(message.isRead, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.isSent != null && Object.hasOwnProperty.call(message, "isSent"))
                            $root.google.protobuf.BoolValue.encode(message.isSent, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.limit);
                        if (message.fieldMask != null && Object.hasOwnProperty.call(message, "fieldMask"))
                            $root.google.protobuf.FieldMask.encode(message.fieldMask, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationRequest} message ListNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListNotificationRequest} ListNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.accountId = reader.int64();
                                break;
                            case 3:
                                message.from = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.to = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.type = reader.int32();
                                break;
                            case 6:
                                message.isRead = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.isSent = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.limit = reader.int32();
                                break;
                            case 9:
                                message.fieldMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListNotificationRequest} ListNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            properties.ownerFilter = 1;
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId")) {
                            if (properties.ownerFilter === 1)
                                return "ownerFilter: multiple values";
                            properties.ownerFilter = 1;
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        }
                        if (message.from != null && message.hasOwnProperty("from")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.from);
                            if (error)
                                return "from." + error;
                        }
                        if (message.to != null && message.hasOwnProperty("to")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.to);
                            if (error)
                                return "to." + error;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.isRead != null && message.hasOwnProperty("isRead")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isRead);
                            if (error)
                                return "isRead." + error;
                        }
                        if (message.isSent != null && message.hasOwnProperty("isSent")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isSent);
                            if (error)
                                return "isSent." + error;
                        }
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            if (!$util.isInteger(message.limit))
                                return "limit: integer expected";
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.fieldMask);
                            if (error)
                                return "fieldMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListNotificationRequest} ListNotificationRequest
                     */
                    ListNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListNotificationRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        if (object.from != null) {
                            if (typeof object.from !== "object")
                                throw TypeError(".palexy.streaming.v1.ListNotificationRequest.from: object expected");
                            message.from = $root.google.protobuf.Timestamp.fromObject(object.from);
                        }
                        if (object.to != null) {
                            if (typeof object.to !== "object")
                                throw TypeError(".palexy.streaming.v1.ListNotificationRequest.to: object expected");
                            message.to = $root.google.protobuf.Timestamp.fromObject(object.to);
                        }
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "DAILY_TRAFFIC_DROPPED_ALERT":
                        case 1:
                            message.type = 1;
                            break;
                        case "DAILY_CVR_DROPPED_ALERT":
                        case 2:
                            message.type = 2;
                            break;
                        case "SHIFT_ALERT":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        if (object.isRead != null) {
                            if (typeof object.isRead !== "object")
                                throw TypeError(".palexy.streaming.v1.ListNotificationRequest.isRead: object expected");
                            message.isRead = $root.google.protobuf.BoolValue.fromObject(object.isRead);
                        }
                        if (object.isSent != null) {
                            if (typeof object.isSent !== "object")
                                throw TypeError(".palexy.streaming.v1.ListNotificationRequest.isSent: object expected");
                            message.isSent = $root.google.protobuf.BoolValue.fromObject(object.isSent);
                        }
                        if (object.limit != null)
                            message.limit = object.limit | 0;
                        if (object.fieldMask != null) {
                            if (typeof object.fieldMask !== "object")
                                throw TypeError(".palexy.streaming.v1.ListNotificationRequest.fieldMask: object expected");
                            message.fieldMask = $root.google.protobuf.FieldMask.fromObject(object.fieldMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ListNotificationRequest} message ListNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.from = null;
                            object.to = null;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.isRead = null;
                            object.isSent = null;
                            object.limit = 0;
                            object.fieldMask = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (options.oneofs)
                                object.ownerFilter = "storeId";
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId")) {
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                            if (options.oneofs)
                                object.ownerFilter = "accountId";
                        }
                        if (message.from != null && message.hasOwnProperty("from"))
                            object.from = $root.google.protobuf.Timestamp.toObject(message.from, options);
                        if (message.to != null && message.hasOwnProperty("to"))
                            object.to = $root.google.protobuf.Timestamp.toObject(message.to, options);
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.Notification.Type[message.type] : message.type;
                        if (message.isRead != null && message.hasOwnProperty("isRead"))
                            object.isRead = $root.google.protobuf.BoolValue.toObject(message.isRead, options);
                        if (message.isSent != null && message.hasOwnProperty("isSent"))
                            object.isSent = $root.google.protobuf.BoolValue.toObject(message.isSent, options);
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            object.limit = message.limit;
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask"))
                            object.fieldMask = $root.google.protobuf.FieldMask.toObject(message.fieldMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListNotificationRequest;
                })();
    
                v1.ListNotificationResponse = (function() {
    
                    /**
                     * Properties of a ListNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListNotificationResponse
                     * @property {Array.<palexy.streaming.v1.INotification>|null} [notifications] ListNotificationResponse notifications
                     */
    
                    /**
                     * Constructs a new ListNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListNotificationResponse.
                     * @implements IListNotificationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListNotificationResponse=} [properties] Properties to set
                     */
                    function ListNotificationResponse(properties) {
                        this.notifications = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListNotificationResponse notifications.
                     * @member {Array.<palexy.streaming.v1.INotification>} notifications
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @instance
                     */
                    ListNotificationResponse.prototype.notifications = $util.emptyArray;
    
                    /**
                     * Creates a new ListNotificationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListNotificationResponse} ListNotificationResponse instance
                     */
                    ListNotificationResponse.create = function create(properties) {
                        return new ListNotificationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListNotificationResponse message. Does not implicitly {@link palexy.streaming.v1.ListNotificationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationResponse} message ListNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNotificationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notifications != null && message.notifications.length)
                            for (var i = 0; i < message.notifications.length; ++i)
                                $root.palexy.streaming.v1.Notification.encode(message.notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListNotificationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListNotificationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNotificationResponse} message ListNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNotificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListNotificationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListNotificationResponse} ListNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNotificationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListNotificationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.notifications && message.notifications.length))
                                    message.notifications = [];
                                message.notifications.push($root.palexy.streaming.v1.Notification.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListNotificationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListNotificationResponse} ListNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNotificationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListNotificationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListNotificationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notifications != null && message.hasOwnProperty("notifications")) {
                            if (!Array.isArray(message.notifications))
                                return "notifications: array expected";
                            for (var i = 0; i < message.notifications.length; ++i) {
                                var error = $root.palexy.streaming.v1.Notification.verify(message.notifications[i]);
                                if (error)
                                    return "notifications." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListNotificationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListNotificationResponse} ListNotificationResponse
                     */
                    ListNotificationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListNotificationResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListNotificationResponse();
                        if (object.notifications) {
                            if (!Array.isArray(object.notifications))
                                throw TypeError(".palexy.streaming.v1.ListNotificationResponse.notifications: array expected");
                            message.notifications = [];
                            for (var i = 0; i < object.notifications.length; ++i) {
                                if (typeof object.notifications[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListNotificationResponse.notifications: object expected");
                                message.notifications[i] = $root.palexy.streaming.v1.Notification.fromObject(object.notifications[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListNotificationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ListNotificationResponse} message ListNotificationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListNotificationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.notifications = [];
                        if (message.notifications && message.notifications.length) {
                            object.notifications = [];
                            for (var j = 0; j < message.notifications.length; ++j)
                                object.notifications[j] = $root.palexy.streaming.v1.Notification.toObject(message.notifications[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListNotificationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListNotificationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListNotificationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListNotificationResponse;
                })();
    
                v1.GetNotificationRequest = (function() {
    
                    /**
                     * Properties of a GetNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetNotificationRequest
                     * @property {number|null} [notificationId] GetNotificationRequest notificationId
                     */
    
                    /**
                     * Constructs a new GetNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetNotificationRequest.
                     * @implements IGetNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetNotificationRequest=} [properties] Properties to set
                     */
                    function GetNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetNotificationRequest notificationId.
                     * @member {number} notificationId
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @instance
                     */
                    GetNotificationRequest.prototype.notificationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetNotificationRequest} GetNotificationRequest instance
                     */
                    GetNotificationRequest.create = function create(properties) {
                        return new GetNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.GetNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNotificationRequest} message GetNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notificationId != null && Object.hasOwnProperty.call(message, "notificationId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.notificationId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNotificationRequest} message GetNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetNotificationRequest} GetNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notificationId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetNotificationRequest} GetNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (!$util.isInteger(message.notificationId) && !(message.notificationId && $util.isInteger(message.notificationId.low) && $util.isInteger(message.notificationId.high)))
                                return "notificationId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetNotificationRequest} GetNotificationRequest
                     */
                    GetNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetNotificationRequest();
                        if (object.notificationId != null)
                            if ($util.Long)
                                (message.notificationId = $util.Long.fromValue(object.notificationId)).unsigned = false;
                            else if (typeof object.notificationId === "string")
                                message.notificationId = parseInt(object.notificationId, 10);
                            else if (typeof object.notificationId === "number")
                                message.notificationId = object.notificationId;
                            else if (typeof object.notificationId === "object")
                                message.notificationId = new $util.LongBits(object.notificationId.low >>> 0, object.notificationId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.GetNotificationRequest} message GetNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.notificationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.notificationId = options.longs === String ? "0" : 0;
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (typeof message.notificationId === "number")
                                object.notificationId = options.longs === String ? String(message.notificationId) : message.notificationId;
                            else
                                object.notificationId = options.longs === String ? $util.Long.prototype.toString.call(message.notificationId) : options.longs === Number ? new $util.LongBits(message.notificationId.low >>> 0, message.notificationId.high >>> 0).toNumber() : message.notificationId;
                        return object;
                    };
    
                    /**
                     * Converts this GetNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetNotificationRequest;
                })();
    
                v1.BatchCreateNotificationRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateNotificationRequest
                     * @property {Array.<palexy.streaming.v1.INotification>|null} [notifications] BatchCreateNotificationRequest notifications
                     */
    
                    /**
                     * Constructs a new BatchCreateNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateNotificationRequest.
                     * @implements IBatchCreateNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest=} [properties] Properties to set
                     */
                    function BatchCreateNotificationRequest(properties) {
                        this.notifications = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateNotificationRequest notifications.
                     * @member {Array.<palexy.streaming.v1.INotification>} notifications
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @instance
                     */
                    BatchCreateNotificationRequest.prototype.notifications = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateNotificationRequest} BatchCreateNotificationRequest instance
                     */
                    BatchCreateNotificationRequest.create = function create(properties) {
                        return new BatchCreateNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest} message BatchCreateNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notifications != null && message.notifications.length)
                            for (var i = 0; i < message.notifications.length; ++i)
                                $root.palexy.streaming.v1.Notification.encode(message.notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationRequest} message BatchCreateNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateNotificationRequest} BatchCreateNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.notifications && message.notifications.length))
                                    message.notifications = [];
                                message.notifications.push($root.palexy.streaming.v1.Notification.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateNotificationRequest} BatchCreateNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notifications != null && message.hasOwnProperty("notifications")) {
                            if (!Array.isArray(message.notifications))
                                return "notifications: array expected";
                            for (var i = 0; i < message.notifications.length; ++i) {
                                var error = $root.palexy.streaming.v1.Notification.verify(message.notifications[i]);
                                if (error)
                                    return "notifications." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateNotificationRequest} BatchCreateNotificationRequest
                     */
                    BatchCreateNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateNotificationRequest();
                        if (object.notifications) {
                            if (!Array.isArray(object.notifications))
                                throw TypeError(".palexy.streaming.v1.BatchCreateNotificationRequest.notifications: array expected");
                            message.notifications = [];
                            for (var i = 0; i < object.notifications.length; ++i) {
                                if (typeof object.notifications[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateNotificationRequest.notifications: object expected");
                                message.notifications[i] = $root.palexy.streaming.v1.Notification.fromObject(object.notifications[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateNotificationRequest} message BatchCreateNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.notifications = [];
                        if (message.notifications && message.notifications.length) {
                            object.notifications = [];
                            for (var j = 0; j < message.notifications.length; ++j)
                                object.notifications[j] = $root.palexy.streaming.v1.Notification.toObject(message.notifications[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateNotificationRequest;
                })();
    
                v1.BatchCreateNotificationResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateNotificationResponse
                     * @property {Array.<palexy.streaming.v1.INotification>|null} [notifications] BatchCreateNotificationResponse notifications
                     */
    
                    /**
                     * Constructs a new BatchCreateNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateNotificationResponse.
                     * @implements IBatchCreateNotificationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateNotificationResponse=} [properties] Properties to set
                     */
                    function BatchCreateNotificationResponse(properties) {
                        this.notifications = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateNotificationResponse notifications.
                     * @member {Array.<palexy.streaming.v1.INotification>} notifications
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @instance
                     */
                    BatchCreateNotificationResponse.prototype.notifications = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateNotificationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateNotificationResponse} BatchCreateNotificationResponse instance
                     */
                    BatchCreateNotificationResponse.create = function create(properties) {
                        return new BatchCreateNotificationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateNotificationResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateNotificationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationResponse} message BatchCreateNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateNotificationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notifications != null && message.notifications.length)
                            for (var i = 0; i < message.notifications.length; ++i)
                                $root.palexy.streaming.v1.Notification.encode(message.notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateNotificationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateNotificationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateNotificationResponse} message BatchCreateNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateNotificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateNotificationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateNotificationResponse} BatchCreateNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateNotificationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateNotificationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.notifications && message.notifications.length))
                                    message.notifications = [];
                                message.notifications.push($root.palexy.streaming.v1.Notification.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateNotificationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateNotificationResponse} BatchCreateNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateNotificationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateNotificationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateNotificationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notifications != null && message.hasOwnProperty("notifications")) {
                            if (!Array.isArray(message.notifications))
                                return "notifications: array expected";
                            for (var i = 0; i < message.notifications.length; ++i) {
                                var error = $root.palexy.streaming.v1.Notification.verify(message.notifications[i]);
                                if (error)
                                    return "notifications." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateNotificationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateNotificationResponse} BatchCreateNotificationResponse
                     */
                    BatchCreateNotificationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateNotificationResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateNotificationResponse();
                        if (object.notifications) {
                            if (!Array.isArray(object.notifications))
                                throw TypeError(".palexy.streaming.v1.BatchCreateNotificationResponse.notifications: array expected");
                            message.notifications = [];
                            for (var i = 0; i < object.notifications.length; ++i) {
                                if (typeof object.notifications[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateNotificationResponse.notifications: object expected");
                                message.notifications[i] = $root.palexy.streaming.v1.Notification.fromObject(object.notifications[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateNotificationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateNotificationResponse} message BatchCreateNotificationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateNotificationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.notifications = [];
                        if (message.notifications && message.notifications.length) {
                            object.notifications = [];
                            for (var j = 0; j < message.notifications.length; ++j)
                                object.notifications[j] = $root.palexy.streaming.v1.Notification.toObject(message.notifications[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateNotificationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateNotificationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateNotificationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateNotificationResponse;
                })();
    
                v1.MarkAllNotificationsAsReadRequest = (function() {
    
                    /**
                     * Properties of a MarkAllNotificationsAsReadRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IMarkAllNotificationsAsReadRequest
                     * @property {number|null} [accountId] MarkAllNotificationsAsReadRequest accountId
                     */
    
                    /**
                     * Constructs a new MarkAllNotificationsAsReadRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MarkAllNotificationsAsReadRequest.
                     * @implements IMarkAllNotificationsAsReadRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest=} [properties] Properties to set
                     */
                    function MarkAllNotificationsAsReadRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MarkAllNotificationsAsReadRequest accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @instance
                     */
                    MarkAllNotificationsAsReadRequest.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new MarkAllNotificationsAsReadRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MarkAllNotificationsAsReadRequest} MarkAllNotificationsAsReadRequest instance
                     */
                    MarkAllNotificationsAsReadRequest.create = function create(properties) {
                        return new MarkAllNotificationsAsReadRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MarkAllNotificationsAsReadRequest message. Does not implicitly {@link palexy.streaming.v1.MarkAllNotificationsAsReadRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest} message MarkAllNotificationsAsReadRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkAllNotificationsAsReadRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.accountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MarkAllNotificationsAsReadRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.MarkAllNotificationsAsReadRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {palexy.streaming.v1.IMarkAllNotificationsAsReadRequest} message MarkAllNotificationsAsReadRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkAllNotificationsAsReadRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MarkAllNotificationsAsReadRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MarkAllNotificationsAsReadRequest} MarkAllNotificationsAsReadRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkAllNotificationsAsReadRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MarkAllNotificationsAsReadRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.accountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MarkAllNotificationsAsReadRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MarkAllNotificationsAsReadRequest} MarkAllNotificationsAsReadRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkAllNotificationsAsReadRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MarkAllNotificationsAsReadRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MarkAllNotificationsAsReadRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a MarkAllNotificationsAsReadRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MarkAllNotificationsAsReadRequest} MarkAllNotificationsAsReadRequest
                     */
                    MarkAllNotificationsAsReadRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MarkAllNotificationsAsReadRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.MarkAllNotificationsAsReadRequest();
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MarkAllNotificationsAsReadRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @static
                     * @param {palexy.streaming.v1.MarkAllNotificationsAsReadRequest} message MarkAllNotificationsAsReadRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MarkAllNotificationsAsReadRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        return object;
                    };
    
                    /**
                     * Converts this MarkAllNotificationsAsReadRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MarkAllNotificationsAsReadRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MarkAllNotificationsAsReadRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MarkAllNotificationsAsReadRequest;
                })();
    
                v1.UpdateNotificationRequest = (function() {
    
                    /**
                     * Properties of an UpdateNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateNotificationRequest
                     * @property {palexy.streaming.v1.INotification|null} [notification] UpdateNotificationRequest notification
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateNotificationRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateNotificationRequest.
                     * @implements IUpdateNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest=} [properties] Properties to set
                     */
                    function UpdateNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateNotificationRequest notification.
                     * @member {palexy.streaming.v1.INotification|null|undefined} notification
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @instance
                     */
                    UpdateNotificationRequest.prototype.notification = null;
    
                    /**
                     * UpdateNotificationRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @instance
                     */
                    UpdateNotificationRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateNotificationRequest} UpdateNotificationRequest instance
                     */
                    UpdateNotificationRequest.create = function create(properties) {
                        return new UpdateNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest} message UpdateNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notification != null && Object.hasOwnProperty.call(message, "notification"))
                            $root.palexy.streaming.v1.Notification.encode(message.notification, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNotificationRequest} message UpdateNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateNotificationRequest} UpdateNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notification = $root.palexy.streaming.v1.Notification.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateNotificationRequest} UpdateNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notification != null && message.hasOwnProperty("notification")) {
                            var error = $root.palexy.streaming.v1.Notification.verify(message.notification);
                            if (error)
                                return "notification." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateNotificationRequest} UpdateNotificationRequest
                     */
                    UpdateNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateNotificationRequest();
                        if (object.notification != null) {
                            if (typeof object.notification !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNotificationRequest.notification: object expected");
                            message.notification = $root.palexy.streaming.v1.Notification.fromObject(object.notification);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNotificationRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateNotificationRequest} message UpdateNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.notification = null;
                            object.updateMask = null;
                        }
                        if (message.notification != null && message.hasOwnProperty("notification"))
                            object.notification = $root.palexy.streaming.v1.Notification.toObject(message.notification, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateNotificationRequest;
                })();
    
                v1.SendNotificationRequest = (function() {
    
                    /**
                     * Properties of a SendNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendNotificationRequest
                     * @property {Array.<number>|null} [notificationIds] SendNotificationRequest notificationIds
                     */
    
                    /**
                     * Constructs a new SendNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendNotificationRequest.
                     * @implements ISendNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendNotificationRequest=} [properties] Properties to set
                     */
                    function SendNotificationRequest(properties) {
                        this.notificationIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendNotificationRequest notificationIds.
                     * @member {Array.<number>} notificationIds
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @instance
                     */
                    SendNotificationRequest.prototype.notificationIds = $util.emptyArray;
    
                    /**
                     * Creates a new SendNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendNotificationRequest} SendNotificationRequest instance
                     */
                    SendNotificationRequest.create = function create(properties) {
                        return new SendNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.SendNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationRequest} message SendNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notificationIds != null && message.notificationIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.notificationIds.length; ++i)
                                writer.int64(message.notificationIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationRequest} message SendNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendNotificationRequest} SendNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.notificationIds && message.notificationIds.length))
                                    message.notificationIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.notificationIds.push(reader.int64());
                                } else
                                    message.notificationIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendNotificationRequest} SendNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notificationIds != null && message.hasOwnProperty("notificationIds")) {
                            if (!Array.isArray(message.notificationIds))
                                return "notificationIds: array expected";
                            for (var i = 0; i < message.notificationIds.length; ++i)
                                if (!$util.isInteger(message.notificationIds[i]) && !(message.notificationIds[i] && $util.isInteger(message.notificationIds[i].low) && $util.isInteger(message.notificationIds[i].high)))
                                    return "notificationIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SendNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendNotificationRequest} SendNotificationRequest
                     */
                    SendNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendNotificationRequest();
                        if (object.notificationIds) {
                            if (!Array.isArray(object.notificationIds))
                                throw TypeError(".palexy.streaming.v1.SendNotificationRequest.notificationIds: array expected");
                            message.notificationIds = [];
                            for (var i = 0; i < object.notificationIds.length; ++i)
                                if ($util.Long)
                                    (message.notificationIds[i] = $util.Long.fromValue(object.notificationIds[i])).unsigned = false;
                                else if (typeof object.notificationIds[i] === "string")
                                    message.notificationIds[i] = parseInt(object.notificationIds[i], 10);
                                else if (typeof object.notificationIds[i] === "number")
                                    message.notificationIds[i] = object.notificationIds[i];
                                else if (typeof object.notificationIds[i] === "object")
                                    message.notificationIds[i] = new $util.LongBits(object.notificationIds[i].low >>> 0, object.notificationIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.SendNotificationRequest} message SendNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.notificationIds = [];
                        if (message.notificationIds && message.notificationIds.length) {
                            object.notificationIds = [];
                            for (var j = 0; j < message.notificationIds.length; ++j)
                                if (typeof message.notificationIds[j] === "number")
                                    object.notificationIds[j] = options.longs === String ? String(message.notificationIds[j]) : message.notificationIds[j];
                                else
                                    object.notificationIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.notificationIds[j]) : options.longs === Number ? new $util.LongBits(message.notificationIds[j].low >>> 0, message.notificationIds[j].high >>> 0).toNumber() : message.notificationIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SendNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendNotificationRequest;
                })();
    
                v1.SendNotificationResponse = (function() {
    
                    /**
                     * Properties of a SendNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISendNotificationResponse
                     * @property {number|null} [failedCount] SendNotificationResponse failedCount
                     */
    
                    /**
                     * Constructs a new SendNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendNotificationResponse.
                     * @implements ISendNotificationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISendNotificationResponse=} [properties] Properties to set
                     */
                    function SendNotificationResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendNotificationResponse failedCount.
                     * @member {number} failedCount
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @instance
                     */
                    SendNotificationResponse.prototype.failedCount = 0;
    
                    /**
                     * Creates a new SendNotificationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendNotificationResponse} SendNotificationResponse instance
                     */
                    SendNotificationResponse.create = function create(properties) {
                        return new SendNotificationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SendNotificationResponse message. Does not implicitly {@link palexy.streaming.v1.SendNotificationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationResponse} message SendNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendNotificationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.failedCount != null && Object.hasOwnProperty.call(message, "failedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.failedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendNotificationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendNotificationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendNotificationResponse} message SendNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendNotificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendNotificationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendNotificationResponse} SendNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendNotificationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendNotificationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.failedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendNotificationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendNotificationResponse} SendNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendNotificationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendNotificationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendNotificationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.failedCount != null && message.hasOwnProperty("failedCount"))
                            if (!$util.isInteger(message.failedCount))
                                return "failedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendNotificationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendNotificationResponse} SendNotificationResponse
                     */
                    SendNotificationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendNotificationResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendNotificationResponse();
                        if (object.failedCount != null)
                            message.failedCount = object.failedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendNotificationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.SendNotificationResponse} message SendNotificationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendNotificationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.failedCount = 0;
                        if (message.failedCount != null && message.hasOwnProperty("failedCount"))
                            object.failedCount = message.failedCount;
                        return object;
                    };
    
                    /**
                     * Converts this SendNotificationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendNotificationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendNotificationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendNotificationResponse;
                })();
    
                v1.ExportRawICANotificationRequest = (function() {
    
                    /**
                     * Properties of an ExportRawICANotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExportRawICANotificationRequest
                     * @property {number|null} [companyId] ExportRawICANotificationRequest companyId
                     * @property {number|null} [dataDateId] ExportRawICANotificationRequest dataDateId
                     * @property {Array.<palexy.streaming.v1.IExportedFile>|null} [files] ExportRawICANotificationRequest files
                     */
    
                    /**
                     * Constructs a new ExportRawICANotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportRawICANotificationRequest.
                     * @implements IExportRawICANotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest=} [properties] Properties to set
                     */
                    function ExportRawICANotificationRequest(properties) {
                        this.files = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportRawICANotificationRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @instance
                     */
                    ExportRawICANotificationRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportRawICANotificationRequest dataDateId.
                     * @member {number} dataDateId
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @instance
                     */
                    ExportRawICANotificationRequest.prototype.dataDateId = 0;
    
                    /**
                     * ExportRawICANotificationRequest files.
                     * @member {Array.<palexy.streaming.v1.IExportedFile>} files
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @instance
                     */
                    ExportRawICANotificationRequest.prototype.files = $util.emptyArray;
    
                    /**
                     * Creates a new ExportRawICANotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportRawICANotificationRequest} ExportRawICANotificationRequest instance
                     */
                    ExportRawICANotificationRequest.create = function create(properties) {
                        return new ExportRawICANotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExportRawICANotificationRequest message. Does not implicitly {@link palexy.streaming.v1.ExportRawICANotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest} message ExportRawICANotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportRawICANotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.dataDateId != null && Object.hasOwnProperty.call(message, "dataDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dataDateId);
                        if (message.files != null && message.files.length)
                            for (var i = 0; i < message.files.length; ++i)
                                $root.palexy.streaming.v1.ExportedFile.encode(message.files[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportRawICANotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportRawICANotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationRequest} message ExportRawICANotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportRawICANotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportRawICANotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportRawICANotificationRequest} ExportRawICANotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportRawICANotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportRawICANotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.dataDateId = reader.int32();
                                break;
                            case 3:
                                if (!(message.files && message.files.length))
                                    message.files = [];
                                message.files.push($root.palexy.streaming.v1.ExportedFile.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportRawICANotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportRawICANotificationRequest} ExportRawICANotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportRawICANotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportRawICANotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportRawICANotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.dataDateId != null && message.hasOwnProperty("dataDateId"))
                            if (!$util.isInteger(message.dataDateId))
                                return "dataDateId: integer expected";
                        if (message.files != null && message.hasOwnProperty("files")) {
                            if (!Array.isArray(message.files))
                                return "files: array expected";
                            for (var i = 0; i < message.files.length; ++i) {
                                var error = $root.palexy.streaming.v1.ExportedFile.verify(message.files[i]);
                                if (error)
                                    return "files." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExportRawICANotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportRawICANotificationRequest} ExportRawICANotificationRequest
                     */
                    ExportRawICANotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportRawICANotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportRawICANotificationRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.dataDateId != null)
                            message.dataDateId = object.dataDateId | 0;
                        if (object.files) {
                            if (!Array.isArray(object.files))
                                throw TypeError(".palexy.streaming.v1.ExportRawICANotificationRequest.files: array expected");
                            message.files = [];
                            for (var i = 0; i < object.files.length; ++i) {
                                if (typeof object.files[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ExportRawICANotificationRequest.files: object expected");
                                message.files[i] = $root.palexy.streaming.v1.ExportedFile.fromObject(object.files[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportRawICANotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ExportRawICANotificationRequest} message ExportRawICANotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportRawICANotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.files = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.dataDateId = 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.dataDateId != null && message.hasOwnProperty("dataDateId"))
                            object.dataDateId = message.dataDateId;
                        if (message.files && message.files.length) {
                            object.files = [];
                            for (var j = 0; j < message.files.length; ++j)
                                object.files[j] = $root.palexy.streaming.v1.ExportedFile.toObject(message.files[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExportRawICANotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportRawICANotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportRawICANotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportRawICANotificationRequest;
                })();
    
                v1.ExportRawICANotificationResponse = (function() {
    
                    /**
                     * Properties of an ExportRawICANotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IExportRawICANotificationResponse
                     */
    
                    /**
                     * Constructs a new ExportRawICANotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportRawICANotificationResponse.
                     * @implements IExportRawICANotificationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IExportRawICANotificationResponse=} [properties] Properties to set
                     */
                    function ExportRawICANotificationResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ExportRawICANotificationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportRawICANotificationResponse} ExportRawICANotificationResponse instance
                     */
                    ExportRawICANotificationResponse.create = function create(properties) {
                        return new ExportRawICANotificationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ExportRawICANotificationResponse message. Does not implicitly {@link palexy.streaming.v1.ExportRawICANotificationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationResponse} message ExportRawICANotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportRawICANotificationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportRawICANotificationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportRawICANotificationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportRawICANotificationResponse} message ExportRawICANotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportRawICANotificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportRawICANotificationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportRawICANotificationResponse} ExportRawICANotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportRawICANotificationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportRawICANotificationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportRawICANotificationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportRawICANotificationResponse} ExportRawICANotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportRawICANotificationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportRawICANotificationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportRawICANotificationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportRawICANotificationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportRawICANotificationResponse} ExportRawICANotificationResponse
                     */
                    ExportRawICANotificationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportRawICANotificationResponse)
                            return object;
                        return new $root.palexy.streaming.v1.ExportRawICANotificationResponse();
                    };
    
                    /**
                     * Creates a plain object from an ExportRawICANotificationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ExportRawICANotificationResponse} message ExportRawICANotificationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportRawICANotificationResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ExportRawICANotificationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportRawICANotificationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportRawICANotificationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportRawICANotificationResponse;
                })();
    
                v1.SendVerificationEmailRequest = (function() {
    
                    /**
                     * Properties of a SendVerificationEmailRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendVerificationEmailRequest
                     * @property {palexy.protobuf.EmailVerificationType|null} [verificationType] SendVerificationEmailRequest verificationType
                     * @property {string|null} [username] SendVerificationEmailRequest username
                     * @property {string|null} [email] SendVerificationEmailRequest email
                     * @property {string|null} [fullName] SendVerificationEmailRequest fullName
                     * @property {string|null} [verificationLink] SendVerificationEmailRequest verificationLink
                     * @property {string|null} [companyName] SendVerificationEmailRequest companyName
                     * @property {google.protobuf.ITimestamp|null} [expiryDateTime] SendVerificationEmailRequest expiryDateTime
                     * @property {palexy.streaming.v1.EmailLanguage|null} [locale] SendVerificationEmailRequest locale
                     */
    
                    /**
                     * Constructs a new SendVerificationEmailRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendVerificationEmailRequest.
                     * @implements ISendVerificationEmailRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest=} [properties] Properties to set
                     */
                    function SendVerificationEmailRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendVerificationEmailRequest verificationType.
                     * @member {palexy.protobuf.EmailVerificationType} verificationType
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.verificationType = 0;
    
                    /**
                     * SendVerificationEmailRequest username.
                     * @member {string} username
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.username = "";
    
                    /**
                     * SendVerificationEmailRequest email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.email = "";
    
                    /**
                     * SendVerificationEmailRequest fullName.
                     * @member {string} fullName
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.fullName = "";
    
                    /**
                     * SendVerificationEmailRequest verificationLink.
                     * @member {string} verificationLink
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.verificationLink = "";
    
                    /**
                     * SendVerificationEmailRequest companyName.
                     * @member {string} companyName
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.companyName = "";
    
                    /**
                     * SendVerificationEmailRequest expiryDateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} expiryDateTime
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.expiryDateTime = null;
    
                    /**
                     * SendVerificationEmailRequest locale.
                     * @member {palexy.streaming.v1.EmailLanguage} locale
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     */
                    SendVerificationEmailRequest.prototype.locale = 0;
    
                    /**
                     * Creates a new SendVerificationEmailRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendVerificationEmailRequest} SendVerificationEmailRequest instance
                     */
                    SendVerificationEmailRequest.create = function create(properties) {
                        return new SendVerificationEmailRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendVerificationEmailRequest message. Does not implicitly {@link palexy.streaming.v1.SendVerificationEmailRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest} message SendVerificationEmailRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendVerificationEmailRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.verificationType != null && Object.hasOwnProperty.call(message, "verificationType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.verificationType);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fullName);
                        if (message.verificationLink != null && Object.hasOwnProperty.call(message, "verificationLink"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.verificationLink);
                        if (message.expiryDateTime != null && Object.hasOwnProperty.call(message, "expiryDateTime"))
                            $root.google.protobuf.Timestamp.encode(message.expiryDateTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.companyName);
                        if (message.locale != null && Object.hasOwnProperty.call(message, "locale"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.locale);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendVerificationEmailRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendVerificationEmailRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendVerificationEmailRequest} message SendVerificationEmailRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendVerificationEmailRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendVerificationEmailRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendVerificationEmailRequest} SendVerificationEmailRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendVerificationEmailRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendVerificationEmailRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.verificationType = reader.int32();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.fullName = reader.string();
                                break;
                            case 5:
                                message.verificationLink = reader.string();
                                break;
                            case 7:
                                message.companyName = reader.string();
                                break;
                            case 6:
                                message.expiryDateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.locale = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendVerificationEmailRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendVerificationEmailRequest} SendVerificationEmailRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendVerificationEmailRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendVerificationEmailRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendVerificationEmailRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.verificationType != null && message.hasOwnProperty("verificationType"))
                            switch (message.verificationType) {
                            default:
                                return "verificationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        if (message.verificationLink != null && message.hasOwnProperty("verificationLink"))
                            if (!$util.isString(message.verificationLink))
                                return "verificationLink: string expected";
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            if (!$util.isString(message.companyName))
                                return "companyName: string expected";
                        if (message.expiryDateTime != null && message.hasOwnProperty("expiryDateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.expiryDateTime);
                            if (error)
                                return "expiryDateTime." + error;
                        }
                        if (message.locale != null && message.hasOwnProperty("locale"))
                            switch (message.locale) {
                            default:
                                return "locale: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a SendVerificationEmailRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendVerificationEmailRequest} SendVerificationEmailRequest
                     */
                    SendVerificationEmailRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendVerificationEmailRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendVerificationEmailRequest();
                        switch (object.verificationType) {
                        case "UNKNOWN_VERIFICATION_TYPE":
                        case 0:
                            message.verificationType = 0;
                            break;
                        case "ACCOUNT_CONFIRMATION":
                        case 1:
                            message.verificationType = 1;
                            break;
                        case "PASSWORD_RESET":
                        case 2:
                            message.verificationType = 2;
                            break;
                        case "EMAIL_VERIFICATION":
                        case 3:
                            message.verificationType = 3;
                            break;
                        case "STAFF_INVITATION":
                        case 4:
                            message.verificationType = 4;
                            break;
                        case "INVITE_STAFF_EMAIL":
                        case 5:
                            message.verificationType = 5;
                            break;
                        }
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        if (object.verificationLink != null)
                            message.verificationLink = String(object.verificationLink);
                        if (object.companyName != null)
                            message.companyName = String(object.companyName);
                        if (object.expiryDateTime != null) {
                            if (typeof object.expiryDateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.SendVerificationEmailRequest.expiryDateTime: object expected");
                            message.expiryDateTime = $root.google.protobuf.Timestamp.fromObject(object.expiryDateTime);
                        }
                        switch (object.locale) {
                        case "en":
                        case 0:
                            message.locale = 0;
                            break;
                        case "vi":
                        case 1:
                            message.locale = 1;
                            break;
                        case "th":
                        case 2:
                            message.locale = 2;
                            break;
                        case "ja":
                        case 3:
                            message.locale = 3;
                            break;
                        case "zh_hans":
                        case 4:
                            message.locale = 4;
                            break;
                        case "zh_hant":
                        case 5:
                            message.locale = 5;
                            break;
                        case "ko":
                        case 6:
                            message.locale = 6;
                            break;
                        case "id":
                        case 7:
                            message.locale = 7;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendVerificationEmailRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @static
                     * @param {palexy.streaming.v1.SendVerificationEmailRequest} message SendVerificationEmailRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendVerificationEmailRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.verificationType = options.enums === String ? "UNKNOWN_VERIFICATION_TYPE" : 0;
                            object.username = "";
                            object.email = "";
                            object.fullName = "";
                            object.verificationLink = "";
                            object.expiryDateTime = null;
                            object.companyName = "";
                            object.locale = options.enums === String ? "en" : 0;
                        }
                        if (message.verificationType != null && message.hasOwnProperty("verificationType"))
                            object.verificationType = options.enums === String ? $root.palexy.protobuf.EmailVerificationType[message.verificationType] : message.verificationType;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        if (message.verificationLink != null && message.hasOwnProperty("verificationLink"))
                            object.verificationLink = message.verificationLink;
                        if (message.expiryDateTime != null && message.hasOwnProperty("expiryDateTime"))
                            object.expiryDateTime = $root.google.protobuf.Timestamp.toObject(message.expiryDateTime, options);
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            object.companyName = message.companyName;
                        if (message.locale != null && message.hasOwnProperty("locale"))
                            object.locale = options.enums === String ? $root.palexy.streaming.v1.EmailLanguage[message.locale] : message.locale;
                        return object;
                    };
    
                    /**
                     * Converts this SendVerificationEmailRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendVerificationEmailRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendVerificationEmailRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendVerificationEmailRequest;
                })();
    
                v1.SendScheduledReportNotificationRequest = (function() {
    
                    /**
                     * Properties of a SendScheduledReportNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendScheduledReportNotificationRequest
                     * @property {palexy.streaming.v1.ReportSchedule.ScheduleType|null} [reportType] SendScheduledReportNotificationRequest reportType
                     * @property {number|null} [companyId] SendScheduledReportNotificationRequest companyId
                     * @property {string|null} [email] SendScheduledReportNotificationRequest email
                     * @property {palexy.streaming.v1.IEmailAttachment|null} [attachment] SendScheduledReportNotificationRequest attachment
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] SendScheduledReportNotificationRequest dateRange
                     * @property {number|null} [reportScheduleId] SendScheduledReportNotificationRequest reportScheduleId
                     */
    
                    /**
                     * Constructs a new SendScheduledReportNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendScheduledReportNotificationRequest.
                     * @implements ISendScheduledReportNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest=} [properties] Properties to set
                     */
                    function SendScheduledReportNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendScheduledReportNotificationRequest reportType.
                     * @member {palexy.streaming.v1.ReportSchedule.ScheduleType} reportType
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.reportType = 0;
    
                    /**
                     * SendScheduledReportNotificationRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SendScheduledReportNotificationRequest email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.email = "";
    
                    /**
                     * SendScheduledReportNotificationRequest attachment.
                     * @member {palexy.streaming.v1.IEmailAttachment|null|undefined} attachment
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.attachment = null;
    
                    /**
                     * SendScheduledReportNotificationRequest dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.dateRange = null;
    
                    /**
                     * SendScheduledReportNotificationRequest reportScheduleId.
                     * @member {number} reportScheduleId
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     */
                    SendScheduledReportNotificationRequest.prototype.reportScheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SendScheduledReportNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendScheduledReportNotificationRequest} SendScheduledReportNotificationRequest instance
                     */
                    SendScheduledReportNotificationRequest.create = function create(properties) {
                        return new SendScheduledReportNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendScheduledReportNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.SendScheduledReportNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest} message SendScheduledReportNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendScheduledReportNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reportType != null && Object.hasOwnProperty.call(message, "reportType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.reportType);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.attachment != null && Object.hasOwnProperty.call(message, "attachment"))
                            $root.palexy.streaming.v1.EmailAttachment.encode(message.attachment, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.reportScheduleId != null && Object.hasOwnProperty.call(message, "reportScheduleId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.reportScheduleId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendScheduledReportNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendScheduledReportNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendScheduledReportNotificationRequest} message SendScheduledReportNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendScheduledReportNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendScheduledReportNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendScheduledReportNotificationRequest} SendScheduledReportNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendScheduledReportNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendScheduledReportNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.reportType = reader.int32();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.attachment = $root.palexy.streaming.v1.EmailAttachment.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.reportScheduleId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendScheduledReportNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendScheduledReportNotificationRequest} SendScheduledReportNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendScheduledReportNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendScheduledReportNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendScheduledReportNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            switch (message.reportType) {
                            default:
                                return "reportType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.attachment != null && message.hasOwnProperty("attachment")) {
                            var error = $root.palexy.streaming.v1.EmailAttachment.verify(message.attachment);
                            if (error)
                                return "attachment." + error;
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.reportScheduleId != null && message.hasOwnProperty("reportScheduleId"))
                            if (!$util.isInteger(message.reportScheduleId) && !(message.reportScheduleId && $util.isInteger(message.reportScheduleId.low) && $util.isInteger(message.reportScheduleId.high)))
                                return "reportScheduleId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendScheduledReportNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendScheduledReportNotificationRequest} SendScheduledReportNotificationRequest
                     */
                    SendScheduledReportNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendScheduledReportNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendScheduledReportNotificationRequest();
                        switch (object.reportType) {
                        case "UNKNOWN":
                        case 0:
                            message.reportType = 0;
                            break;
                        case "WEEKLY":
                        case 1:
                            message.reportType = 1;
                            break;
                        case "MONTHLY":
                        case 2:
                            message.reportType = 2;
                            break;
                        case "DAILY":
                        case 3:
                            message.reportType = 3;
                            break;
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.attachment != null) {
                            if (typeof object.attachment !== "object")
                                throw TypeError(".palexy.streaming.v1.SendScheduledReportNotificationRequest.attachment: object expected");
                            message.attachment = $root.palexy.streaming.v1.EmailAttachment.fromObject(object.attachment);
                        }
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.SendScheduledReportNotificationRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        if (object.reportScheduleId != null)
                            if ($util.Long)
                                (message.reportScheduleId = $util.Long.fromValue(object.reportScheduleId)).unsigned = false;
                            else if (typeof object.reportScheduleId === "string")
                                message.reportScheduleId = parseInt(object.reportScheduleId, 10);
                            else if (typeof object.reportScheduleId === "number")
                                message.reportScheduleId = object.reportScheduleId;
                            else if (typeof object.reportScheduleId === "object")
                                message.reportScheduleId = new $util.LongBits(object.reportScheduleId.low >>> 0, object.reportScheduleId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendScheduledReportNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.SendScheduledReportNotificationRequest} message SendScheduledReportNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendScheduledReportNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.reportType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.email = "";
                            object.attachment = null;
                            object.dateRange = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.reportScheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.reportScheduleId = options.longs === String ? "0" : 0;
                        }
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            object.reportType = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ScheduleType[message.reportType] : message.reportType;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.attachment != null && message.hasOwnProperty("attachment"))
                            object.attachment = $root.palexy.streaming.v1.EmailAttachment.toObject(message.attachment, options);
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                        if (message.reportScheduleId != null && message.hasOwnProperty("reportScheduleId"))
                            if (typeof message.reportScheduleId === "number")
                                object.reportScheduleId = options.longs === String ? String(message.reportScheduleId) : message.reportScheduleId;
                            else
                                object.reportScheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.reportScheduleId) : options.longs === Number ? new $util.LongBits(message.reportScheduleId.low >>> 0, message.reportScheduleId.high >>> 0).toNumber() : message.reportScheduleId;
                        return object;
                    };
    
                    /**
                     * Converts this SendScheduledReportNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendScheduledReportNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendScheduledReportNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendScheduledReportNotificationRequest;
                })();
    
                v1.EmailAttachment = (function() {
    
                    /**
                     * Properties of an EmailAttachment.
                     * @memberof palexy.streaming.v1
                     * @interface IEmailAttachment
                     * @property {string|null} [fileName] EmailAttachment fileName
                     * @property {Uint8Array|null} [data] EmailAttachment data
                     */
    
                    /**
                     * Constructs a new EmailAttachment.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EmailAttachment.
                     * @implements IEmailAttachment
                     * @constructor
                     * @param {palexy.streaming.v1.IEmailAttachment=} [properties] Properties to set
                     */
                    function EmailAttachment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EmailAttachment fileName.
                     * @member {string} fileName
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @instance
                     */
                    EmailAttachment.prototype.fileName = "";
    
                    /**
                     * EmailAttachment data.
                     * @member {Uint8Array} data
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @instance
                     */
                    EmailAttachment.prototype.data = $util.newBuffer([]);
    
                    /**
                     * Creates a new EmailAttachment instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {palexy.streaming.v1.IEmailAttachment=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.EmailAttachment} EmailAttachment instance
                     */
                    EmailAttachment.create = function create(properties) {
                        return new EmailAttachment(properties);
                    };
    
                    /**
                     * Encodes the specified EmailAttachment message. Does not implicitly {@link palexy.streaming.v1.EmailAttachment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {palexy.streaming.v1.IEmailAttachment} message EmailAttachment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmailAttachment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fileName);
                        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.data);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EmailAttachment message, length delimited. Does not implicitly {@link palexy.streaming.v1.EmailAttachment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {palexy.streaming.v1.IEmailAttachment} message EmailAttachment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmailAttachment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EmailAttachment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.EmailAttachment} EmailAttachment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmailAttachment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.EmailAttachment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fileName = reader.string();
                                break;
                            case 2:
                                message.data = reader.bytes();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EmailAttachment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.EmailAttachment} EmailAttachment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmailAttachment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EmailAttachment message.
                     * @function verify
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EmailAttachment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        if (message.data != null && message.hasOwnProperty("data"))
                            if (!(message.data && typeof message.data.length === "number" || $util.isString(message.data)))
                                return "data: buffer expected";
                        return null;
                    };
    
                    /**
                     * Creates an EmailAttachment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.EmailAttachment} EmailAttachment
                     */
                    EmailAttachment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.EmailAttachment)
                            return object;
                        var message = new $root.palexy.streaming.v1.EmailAttachment();
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        if (object.data != null)
                            if (typeof object.data === "string")
                                $util.base64.decode(object.data, message.data = $util.newBuffer($util.base64.length(object.data)), 0);
                            else if (object.data.length)
                                message.data = object.data;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EmailAttachment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @static
                     * @param {palexy.streaming.v1.EmailAttachment} message EmailAttachment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EmailAttachment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fileName = "";
                            if (options.bytes === String)
                                object.data = "";
                            else {
                                object.data = [];
                                if (options.bytes !== Array)
                                    object.data = $util.newBuffer(object.data);
                            }
                        }
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        if (message.data != null && message.hasOwnProperty("data"))
                            object.data = options.bytes === String ? $util.base64.encode(message.data, 0, message.data.length) : options.bytes === Array ? Array.prototype.slice.call(message.data) : message.data;
                        return object;
                    };
    
                    /**
                     * Converts this EmailAttachment to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.EmailAttachment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EmailAttachment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EmailAttachment;
                })();
    
                v1.SendOtpRequest = (function() {
    
                    /**
                     * Properties of a SendOtpRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendOtpRequest
                     * @property {palexy.streaming.v1.SendOtpRequest.OtpType|null} [type] SendOtpRequest type
                     * @property {string|null} [otp] SendOtpRequest otp
                     * @property {google.protobuf.ITimestamp|null} [expiryDateTime] SendOtpRequest expiryDateTime
                     * @property {string|null} [email] SendOtpRequest email
                     * @property {string|null} [locale] SendOtpRequest locale
                     */
    
                    /**
                     * Constructs a new SendOtpRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendOtpRequest.
                     * @implements ISendOtpRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendOtpRequest=} [properties] Properties to set
                     */
                    function SendOtpRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendOtpRequest type.
                     * @member {palexy.streaming.v1.SendOtpRequest.OtpType} type
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    SendOtpRequest.prototype.type = 0;
    
                    /**
                     * SendOtpRequest otp.
                     * @member {string} otp
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    SendOtpRequest.prototype.otp = "";
    
                    /**
                     * SendOtpRequest expiryDateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} expiryDateTime
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    SendOtpRequest.prototype.expiryDateTime = null;
    
                    /**
                     * SendOtpRequest email.
                     * @member {string|null|undefined} email
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    SendOtpRequest.prototype.email = null;
    
                    /**
                     * SendOtpRequest locale.
                     * @member {string} locale
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    SendOtpRequest.prototype.locale = "";
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * SendOtpRequest receiver.
                     * @member {"email"|undefined} receiver
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     */
                    Object.defineProperty(SendOtpRequest.prototype, "receiver", {
                        get: $util.oneOfGetter($oneOfFields = ["email"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new SendOtpRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOtpRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendOtpRequest} SendOtpRequest instance
                     */
                    SendOtpRequest.create = function create(properties) {
                        return new SendOtpRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendOtpRequest message. Does not implicitly {@link palexy.streaming.v1.SendOtpRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOtpRequest} message SendOtpRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendOtpRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.otp != null && Object.hasOwnProperty.call(message, "otp"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.otp);
                        if (message.expiryDateTime != null && Object.hasOwnProperty.call(message, "expiryDateTime"))
                            $root.google.protobuf.Timestamp.encode(message.expiryDateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.email);
                        if (message.locale != null && Object.hasOwnProperty.call(message, "locale"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.locale);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendOtpRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendOtpRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOtpRequest} message SendOtpRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendOtpRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendOtpRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendOtpRequest} SendOtpRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendOtpRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendOtpRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.otp = reader.string();
                                break;
                            case 3:
                                message.expiryDateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.email = reader.string();
                                break;
                            case 6:
                                message.locale = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendOtpRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendOtpRequest} SendOtpRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendOtpRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendOtpRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendOtpRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.otp != null && message.hasOwnProperty("otp"))
                            if (!$util.isString(message.otp))
                                return "otp: string expected";
                        if (message.expiryDateTime != null && message.hasOwnProperty("expiryDateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.expiryDateTime);
                            if (error)
                                return "expiryDateTime." + error;
                        }
                        if (message.email != null && message.hasOwnProperty("email")) {
                            properties.receiver = 1;
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        }
                        if (message.locale != null && message.hasOwnProperty("locale"))
                            if (!$util.isString(message.locale))
                                return "locale: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendOtpRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendOtpRequest} SendOtpRequest
                     */
                    SendOtpRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendOtpRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendOtpRequest();
                        switch (object.type) {
                        case "OTP_TYPE_UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "MFA_SETUP":
                        case 1:
                            message.type = 1;
                            break;
                        case "MFA_LOGIN":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        if (object.otp != null)
                            message.otp = String(object.otp);
                        if (object.expiryDateTime != null) {
                            if (typeof object.expiryDateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.SendOtpRequest.expiryDateTime: object expected");
                            message.expiryDateTime = $root.google.protobuf.Timestamp.fromObject(object.expiryDateTime);
                        }
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.locale != null)
                            message.locale = String(object.locale);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendOtpRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @static
                     * @param {palexy.streaming.v1.SendOtpRequest} message SendOtpRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendOtpRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "OTP_TYPE_UNKNOWN" : 0;
                            object.otp = "";
                            object.expiryDateTime = null;
                            object.locale = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.SendOtpRequest.OtpType[message.type] : message.type;
                        if (message.otp != null && message.hasOwnProperty("otp"))
                            object.otp = message.otp;
                        if (message.expiryDateTime != null && message.hasOwnProperty("expiryDateTime"))
                            object.expiryDateTime = $root.google.protobuf.Timestamp.toObject(message.expiryDateTime, options);
                        if (message.email != null && message.hasOwnProperty("email")) {
                            object.email = message.email;
                            if (options.oneofs)
                                object.receiver = "email";
                        }
                        if (message.locale != null && message.hasOwnProperty("locale"))
                            object.locale = message.locale;
                        return object;
                    };
    
                    /**
                     * Converts this SendOtpRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendOtpRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendOtpRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * OtpType enum.
                     * @name palexy.streaming.v1.SendOtpRequest.OtpType
                     * @enum {number}
                     * @property {number} OTP_TYPE_UNKNOWN=0 OTP_TYPE_UNKNOWN value
                     * @property {number} MFA_SETUP=1 MFA_SETUP value
                     * @property {number} MFA_LOGIN=2 MFA_LOGIN value
                     */
                    SendOtpRequest.OtpType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "OTP_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "MFA_SETUP"] = 1;
                        values[valuesById[2] = "MFA_LOGIN"] = 2;
                        return values;
                    })();
    
                    return SendOtpRequest;
                })();
    
                v1.RawICASummaryRecord = (function() {
    
                    /**
                     * Properties of a RawICASummaryRecord.
                     * @memberof palexy.streaming.v1
                     * @interface IRawICASummaryRecord
                     * @property {string|null} [personId] RawICASummaryRecord personId
                     * @property {boolean|null} [isStaff] RawICASummaryRecord isStaff
                     * @property {string|null} [gender] RawICASummaryRecord gender
                     * @property {number|null} [ageRange] RawICASummaryRecord ageRange
                     * @property {number|null} [storeId] RawICASummaryRecord storeId
                     * @property {Array.<string>|null} [cameraIds] RawICASummaryRecord cameraIds
                     * @property {Array.<string>|null} [actionsInStore] RawICASummaryRecord actionsInStore
                     * @property {Array.<number>|null} [hours] RawICASummaryRecord hours
                     * @property {number|null} [storeVisitDuration] RawICASummaryRecord storeVisitDuration
                     * @property {Array.<palexy.streaming.v1.ITotalActionItem>|null} [totalActionsInStore] RawICASummaryRecord totalActionsInStore
                     * @property {Array.<palexy.streaming.v1.IMetadataDetail>|null} [metadataDetails] RawICASummaryRecord metadataDetails
                     */
    
                    /**
                     * Constructs a new RawICASummaryRecord.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICASummaryRecord.
                     * @implements IRawICASummaryRecord
                     * @constructor
                     * @param {palexy.streaming.v1.IRawICASummaryRecord=} [properties] Properties to set
                     */
                    function RawICASummaryRecord(properties) {
                        this.cameraIds = [];
                        this.actionsInStore = [];
                        this.hours = [];
                        this.totalActionsInStore = [];
                        this.metadataDetails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RawICASummaryRecord personId.
                     * @member {string} personId
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.personId = "";
    
                    /**
                     * RawICASummaryRecord isStaff.
                     * @member {boolean} isStaff
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.isStaff = false;
    
                    /**
                     * RawICASummaryRecord gender.
                     * @member {string} gender
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.gender = "";
    
                    /**
                     * RawICASummaryRecord ageRange.
                     * @member {number} ageRange
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.ageRange = 0;
    
                    /**
                     * RawICASummaryRecord storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICASummaryRecord cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * RawICASummaryRecord actionsInStore.
                     * @member {Array.<string>} actionsInStore
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.actionsInStore = $util.emptyArray;
    
                    /**
                     * RawICASummaryRecord hours.
                     * @member {Array.<number>} hours
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.hours = $util.emptyArray;
    
                    /**
                     * RawICASummaryRecord storeVisitDuration.
                     * @member {number} storeVisitDuration
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.storeVisitDuration = 0;
    
                    /**
                     * RawICASummaryRecord totalActionsInStore.
                     * @member {Array.<palexy.streaming.v1.ITotalActionItem>} totalActionsInStore
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.totalActionsInStore = $util.emptyArray;
    
                    /**
                     * RawICASummaryRecord metadataDetails.
                     * @member {Array.<palexy.streaming.v1.IMetadataDetail>} metadataDetails
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     */
                    RawICASummaryRecord.prototype.metadataDetails = $util.emptyArray;
    
                    /**
                     * Creates a new RawICASummaryRecord instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICASummaryRecord=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RawICASummaryRecord} RawICASummaryRecord instance
                     */
                    RawICASummaryRecord.create = function create(properties) {
                        return new RawICASummaryRecord(properties);
                    };
    
                    /**
                     * Encodes the specified RawICASummaryRecord message. Does not implicitly {@link palexy.streaming.v1.RawICASummaryRecord.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICASummaryRecord} message RawICASummaryRecord message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICASummaryRecord.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.personId != null && Object.hasOwnProperty.call(message, "personId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.personId);
                        if (message.isStaff != null && Object.hasOwnProperty.call(message, "isStaff"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isStaff);
                        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.gender);
                        if (message.ageRange != null && Object.hasOwnProperty.call(message, "ageRange"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ageRange);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.storeId);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.cameraIds[i]);
                        if (message.actionsInStore != null && message.actionsInStore.length)
                            for (var i = 0; i < message.actionsInStore.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.actionsInStore[i]);
                        if (message.hours != null && message.hours.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.hours.length; ++i)
                                writer.int32(message.hours[i]);
                            writer.ldelim();
                        }
                        if (message.storeVisitDuration != null && Object.hasOwnProperty.call(message, "storeVisitDuration"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.storeVisitDuration);
                        if (message.totalActionsInStore != null && message.totalActionsInStore.length)
                            for (var i = 0; i < message.totalActionsInStore.length; ++i)
                                $root.palexy.streaming.v1.TotalActionItem.encode(message.totalActionsInStore[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.metadataDetails != null && message.metadataDetails.length)
                            for (var i = 0; i < message.metadataDetails.length; ++i)
                                $root.palexy.streaming.v1.MetadataDetail.encode(message.metadataDetails[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RawICASummaryRecord message, length delimited. Does not implicitly {@link palexy.streaming.v1.RawICASummaryRecord.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICASummaryRecord} message RawICASummaryRecord message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICASummaryRecord.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RawICASummaryRecord message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RawICASummaryRecord} RawICASummaryRecord
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICASummaryRecord.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RawICASummaryRecord();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.personId = reader.string();
                                break;
                            case 2:
                                message.isStaff = reader.bool();
                                break;
                            case 3:
                                message.gender = reader.string();
                                break;
                            case 4:
                                message.ageRange = reader.int32();
                                break;
                            case 5:
                                message.storeId = reader.int64();
                                break;
                            case 6:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 7:
                                if (!(message.actionsInStore && message.actionsInStore.length))
                                    message.actionsInStore = [];
                                message.actionsInStore.push(reader.string());
                                break;
                            case 8:
                                if (!(message.hours && message.hours.length))
                                    message.hours = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.hours.push(reader.int32());
                                } else
                                    message.hours.push(reader.int32());
                                break;
                            case 9:
                                message.storeVisitDuration = reader.int32();
                                break;
                            case 10:
                                if (!(message.totalActionsInStore && message.totalActionsInStore.length))
                                    message.totalActionsInStore = [];
                                message.totalActionsInStore.push($root.palexy.streaming.v1.TotalActionItem.decode(reader, reader.uint32()));
                                break;
                            case 11:
                                if (!(message.metadataDetails && message.metadataDetails.length))
                                    message.metadataDetails = [];
                                message.metadataDetails.push($root.palexy.streaming.v1.MetadataDetail.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RawICASummaryRecord message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RawICASummaryRecord} RawICASummaryRecord
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICASummaryRecord.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RawICASummaryRecord message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RawICASummaryRecord.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            if (!$util.isString(message.personId))
                                return "personId: string expected";
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            if (typeof message.isStaff !== "boolean")
                                return "isStaff: boolean expected";
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            if (!$util.isString(message.gender))
                                return "gender: string expected";
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            if (!$util.isInteger(message.ageRange))
                                return "ageRange: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.actionsInStore != null && message.hasOwnProperty("actionsInStore")) {
                            if (!Array.isArray(message.actionsInStore))
                                return "actionsInStore: array expected";
                            for (var i = 0; i < message.actionsInStore.length; ++i)
                                if (!$util.isString(message.actionsInStore[i]))
                                    return "actionsInStore: string[] expected";
                        }
                        if (message.hours != null && message.hasOwnProperty("hours")) {
                            if (!Array.isArray(message.hours))
                                return "hours: array expected";
                            for (var i = 0; i < message.hours.length; ++i)
                                if (!$util.isInteger(message.hours[i]))
                                    return "hours: integer[] expected";
                        }
                        if (message.storeVisitDuration != null && message.hasOwnProperty("storeVisitDuration"))
                            if (!$util.isInteger(message.storeVisitDuration))
                                return "storeVisitDuration: integer expected";
                        if (message.totalActionsInStore != null && message.hasOwnProperty("totalActionsInStore")) {
                            if (!Array.isArray(message.totalActionsInStore))
                                return "totalActionsInStore: array expected";
                            for (var i = 0; i < message.totalActionsInStore.length; ++i) {
                                var error = $root.palexy.streaming.v1.TotalActionItem.verify(message.totalActionsInStore[i]);
                                if (error)
                                    return "totalActionsInStore." + error;
                            }
                        }
                        if (message.metadataDetails != null && message.hasOwnProperty("metadataDetails")) {
                            if (!Array.isArray(message.metadataDetails))
                                return "metadataDetails: array expected";
                            for (var i = 0; i < message.metadataDetails.length; ++i) {
                                var error = $root.palexy.streaming.v1.MetadataDetail.verify(message.metadataDetails[i]);
                                if (error)
                                    return "metadataDetails." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RawICASummaryRecord message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RawICASummaryRecord} RawICASummaryRecord
                     */
                    RawICASummaryRecord.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RawICASummaryRecord)
                            return object;
                        var message = new $root.palexy.streaming.v1.RawICASummaryRecord();
                        if (object.personId != null)
                            message.personId = String(object.personId);
                        if (object.isStaff != null)
                            message.isStaff = Boolean(object.isStaff);
                        if (object.gender != null)
                            message.gender = String(object.gender);
                        if (object.ageRange != null)
                            message.ageRange = object.ageRange | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.actionsInStore) {
                            if (!Array.isArray(object.actionsInStore))
                                throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.actionsInStore: array expected");
                            message.actionsInStore = [];
                            for (var i = 0; i < object.actionsInStore.length; ++i)
                                message.actionsInStore[i] = String(object.actionsInStore[i]);
                        }
                        if (object.hours) {
                            if (!Array.isArray(object.hours))
                                throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.hours: array expected");
                            message.hours = [];
                            for (var i = 0; i < object.hours.length; ++i)
                                message.hours[i] = object.hours[i] | 0;
                        }
                        if (object.storeVisitDuration != null)
                            message.storeVisitDuration = object.storeVisitDuration | 0;
                        if (object.totalActionsInStore) {
                            if (!Array.isArray(object.totalActionsInStore))
                                throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.totalActionsInStore: array expected");
                            message.totalActionsInStore = [];
                            for (var i = 0; i < object.totalActionsInStore.length; ++i) {
                                if (typeof object.totalActionsInStore[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.totalActionsInStore: object expected");
                                message.totalActionsInStore[i] = $root.palexy.streaming.v1.TotalActionItem.fromObject(object.totalActionsInStore[i]);
                            }
                        }
                        if (object.metadataDetails) {
                            if (!Array.isArray(object.metadataDetails))
                                throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.metadataDetails: array expected");
                            message.metadataDetails = [];
                            for (var i = 0; i < object.metadataDetails.length; ++i) {
                                if (typeof object.metadataDetails[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.RawICASummaryRecord.metadataDetails: object expected");
                                message.metadataDetails[i] = $root.palexy.streaming.v1.MetadataDetail.fromObject(object.metadataDetails[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RawICASummaryRecord message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @static
                     * @param {palexy.streaming.v1.RawICASummaryRecord} message RawICASummaryRecord
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawICASummaryRecord.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.cameraIds = [];
                            object.actionsInStore = [];
                            object.hours = [];
                            object.totalActionsInStore = [];
                            object.metadataDetails = [];
                        }
                        if (options.defaults) {
                            object.personId = "";
                            object.isStaff = false;
                            object.gender = "";
                            object.ageRange = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.storeVisitDuration = 0;
                        }
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            object.personId = message.personId;
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            object.isStaff = message.isStaff;
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            object.gender = message.gender;
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            object.ageRange = message.ageRange;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.actionsInStore && message.actionsInStore.length) {
                            object.actionsInStore = [];
                            for (var j = 0; j < message.actionsInStore.length; ++j)
                                object.actionsInStore[j] = message.actionsInStore[j];
                        }
                        if (message.hours && message.hours.length) {
                            object.hours = [];
                            for (var j = 0; j < message.hours.length; ++j)
                                object.hours[j] = message.hours[j];
                        }
                        if (message.storeVisitDuration != null && message.hasOwnProperty("storeVisitDuration"))
                            object.storeVisitDuration = message.storeVisitDuration;
                        if (message.totalActionsInStore && message.totalActionsInStore.length) {
                            object.totalActionsInStore = [];
                            for (var j = 0; j < message.totalActionsInStore.length; ++j)
                                object.totalActionsInStore[j] = $root.palexy.streaming.v1.TotalActionItem.toObject(message.totalActionsInStore[j], options);
                        }
                        if (message.metadataDetails && message.metadataDetails.length) {
                            object.metadataDetails = [];
                            for (var j = 0; j < message.metadataDetails.length; ++j)
                                object.metadataDetails[j] = $root.palexy.streaming.v1.MetadataDetail.toObject(message.metadataDetails[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RawICASummaryRecord to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RawICASummaryRecord
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawICASummaryRecord.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RawICASummaryRecord;
                })();
    
                v1.MetadataDetail = (function() {
    
                    /**
                     * Properties of a MetadataDetail.
                     * @memberof palexy.streaming.v1
                     * @interface IMetadataDetail
                     * @property {palexy.streaming.v1.ITotalActionItem|null} [totalActionItem] MetadataDetail totalActionItem
                     * @property {number|null} [metadataValueId] MetadataDetail metadataValueId
                     * @property {number|null} [metadataValue] MetadataDetail metadataValue
                     * @property {number|null} [totalDuration] MetadataDetail totalDuration
                     */
    
                    /**
                     * Constructs a new MetadataDetail.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MetadataDetail.
                     * @implements IMetadataDetail
                     * @constructor
                     * @param {palexy.streaming.v1.IMetadataDetail=} [properties] Properties to set
                     */
                    function MetadataDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MetadataDetail totalActionItem.
                     * @member {palexy.streaming.v1.ITotalActionItem|null|undefined} totalActionItem
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @instance
                     */
                    MetadataDetail.prototype.totalActionItem = null;
    
                    /**
                     * MetadataDetail metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @instance
                     */
                    MetadataDetail.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataDetail metadataValue.
                     * @member {number} metadataValue
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @instance
                     */
                    MetadataDetail.prototype.metadataValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataDetail totalDuration.
                     * @member {number} totalDuration
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @instance
                     */
                    MetadataDetail.prototype.totalDuration = 0;
    
                    /**
                     * Creates a new MetadataDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {palexy.streaming.v1.IMetadataDetail=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MetadataDetail} MetadataDetail instance
                     */
                    MetadataDetail.create = function create(properties) {
                        return new MetadataDetail(properties);
                    };
    
                    /**
                     * Encodes the specified MetadataDetail message. Does not implicitly {@link palexy.streaming.v1.MetadataDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {palexy.streaming.v1.IMetadataDetail} message MetadataDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.totalActionItem != null && Object.hasOwnProperty.call(message, "totalActionItem"))
                            $root.palexy.streaming.v1.TotalActionItem.encode(message.totalActionItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.metadataValueId);
                        if (message.metadataValue != null && Object.hasOwnProperty.call(message, "metadataValue"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.metadataValue);
                        if (message.totalDuration != null && Object.hasOwnProperty.call(message, "totalDuration"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.totalDuration);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MetadataDetail message, length delimited. Does not implicitly {@link palexy.streaming.v1.MetadataDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {palexy.streaming.v1.IMetadataDetail} message MetadataDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MetadataDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MetadataDetail} MetadataDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MetadataDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.totalActionItem = $root.palexy.streaming.v1.TotalActionItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.metadataValueId = reader.int64();
                                break;
                            case 3:
                                message.metadataValue = reader.int64();
                                break;
                            case 4:
                                message.totalDuration = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MetadataDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MetadataDetail} MetadataDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MetadataDetail message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MetadataDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.totalActionItem != null && message.hasOwnProperty("totalActionItem")) {
                            var error = $root.palexy.streaming.v1.TotalActionItem.verify(message.totalActionItem);
                            if (error)
                                return "totalActionItem." + error;
                        }
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            if (!$util.isInteger(message.metadataValue) && !(message.metadataValue && $util.isInteger(message.metadataValue.low) && $util.isInteger(message.metadataValue.high)))
                                return "metadataValue: integer|Long expected";
                        if (message.totalDuration != null && message.hasOwnProperty("totalDuration"))
                            if (!$util.isInteger(message.totalDuration))
                                return "totalDuration: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a MetadataDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MetadataDetail} MetadataDetail
                     */
                    MetadataDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MetadataDetail)
                            return object;
                        var message = new $root.palexy.streaming.v1.MetadataDetail();
                        if (object.totalActionItem != null) {
                            if (typeof object.totalActionItem !== "object")
                                throw TypeError(".palexy.streaming.v1.MetadataDetail.totalActionItem: object expected");
                            message.totalActionItem = $root.palexy.streaming.v1.TotalActionItem.fromObject(object.totalActionItem);
                        }
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.metadataValue != null)
                            if ($util.Long)
                                (message.metadataValue = $util.Long.fromValue(object.metadataValue)).unsigned = false;
                            else if (typeof object.metadataValue === "string")
                                message.metadataValue = parseInt(object.metadataValue, 10);
                            else if (typeof object.metadataValue === "number")
                                message.metadataValue = object.metadataValue;
                            else if (typeof object.metadataValue === "object")
                                message.metadataValue = new $util.LongBits(object.metadataValue.low >>> 0, object.metadataValue.high >>> 0).toNumber();
                        if (object.totalDuration != null)
                            message.totalDuration = object.totalDuration | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MetadataDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @static
                     * @param {palexy.streaming.v1.MetadataDetail} message MetadataDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MetadataDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.totalActionItem = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValue = options.longs === String ? "0" : 0;
                            object.totalDuration = 0;
                        }
                        if (message.totalActionItem != null && message.hasOwnProperty("totalActionItem"))
                            object.totalActionItem = $root.palexy.streaming.v1.TotalActionItem.toObject(message.totalActionItem, options);
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            if (typeof message.metadataValue === "number")
                                object.metadataValue = options.longs === String ? String(message.metadataValue) : message.metadataValue;
                            else
                                object.metadataValue = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValue) : options.longs === Number ? new $util.LongBits(message.metadataValue.low >>> 0, message.metadataValue.high >>> 0).toNumber() : message.metadataValue;
                        if (message.totalDuration != null && message.hasOwnProperty("totalDuration"))
                            object.totalDuration = message.totalDuration;
                        return object;
                    };
    
                    /**
                     * Converts this MetadataDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MetadataDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MetadataDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MetadataDetail;
                })();
    
                v1.TotalActionItem = (function() {
    
                    /**
                     * Properties of a TotalActionItem.
                     * @memberof palexy.streaming.v1
                     * @interface ITotalActionItem
                     * @property {string|null} [actionType] TotalActionItem actionType
                     * @property {number|null} [total] TotalActionItem total
                     */
    
                    /**
                     * Constructs a new TotalActionItem.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TotalActionItem.
                     * @implements ITotalActionItem
                     * @constructor
                     * @param {palexy.streaming.v1.ITotalActionItem=} [properties] Properties to set
                     */
                    function TotalActionItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TotalActionItem actionType.
                     * @member {string} actionType
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @instance
                     */
                    TotalActionItem.prototype.actionType = "";
    
                    /**
                     * TotalActionItem total.
                     * @member {number} total
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @instance
                     */
                    TotalActionItem.prototype.total = 0;
    
                    /**
                     * Creates a new TotalActionItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {palexy.streaming.v1.ITotalActionItem=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TotalActionItem} TotalActionItem instance
                     */
                    TotalActionItem.create = function create(properties) {
                        return new TotalActionItem(properties);
                    };
    
                    /**
                     * Encodes the specified TotalActionItem message. Does not implicitly {@link palexy.streaming.v1.TotalActionItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {palexy.streaming.v1.ITotalActionItem} message TotalActionItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TotalActionItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.actionType);
                        if (message.total != null && Object.hasOwnProperty.call(message, "total"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.total);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TotalActionItem message, length delimited. Does not implicitly {@link palexy.streaming.v1.TotalActionItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {palexy.streaming.v1.ITotalActionItem} message TotalActionItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TotalActionItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TotalActionItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TotalActionItem} TotalActionItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TotalActionItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TotalActionItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.actionType = reader.string();
                                break;
                            case 2:
                                message.total = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TotalActionItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TotalActionItem} TotalActionItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TotalActionItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TotalActionItem message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TotalActionItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            if (!$util.isString(message.actionType))
                                return "actionType: string expected";
                        if (message.total != null && message.hasOwnProperty("total"))
                            if (!$util.isInteger(message.total))
                                return "total: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a TotalActionItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TotalActionItem} TotalActionItem
                     */
                    TotalActionItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TotalActionItem)
                            return object;
                        var message = new $root.palexy.streaming.v1.TotalActionItem();
                        if (object.actionType != null)
                            message.actionType = String(object.actionType);
                        if (object.total != null)
                            message.total = object.total | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TotalActionItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @static
                     * @param {palexy.streaming.v1.TotalActionItem} message TotalActionItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TotalActionItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.actionType = "";
                            object.total = 0;
                        }
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = message.actionType;
                        if (message.total != null && message.hasOwnProperty("total"))
                            object.total = message.total;
                        return object;
                    };
    
                    /**
                     * Converts this TotalActionItem to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TotalActionItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TotalActionItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TotalActionItem;
                })();
    
                v1.RawICARecordService = (function() {
    
                    /**
                     * Constructs a new RawICARecordService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICARecordService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function RawICARecordService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (RawICARecordService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RawICARecordService;
    
                    /**
                     * Creates new RawICARecordService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICARecordService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {RawICARecordService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    RawICARecordService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICARecordService#listRecords}.
                     * @memberof palexy.streaming.v1.RawICARecordService
                     * @typedef ListRecordsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListRawICARecordsResponse} [response] ListRawICARecordsResponse
                     */
    
                    /**
                     * Calls ListRecords.
                     * @function listRecords
                     * @memberof palexy.streaming.v1.RawICARecordService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest} request ListRawICARecordsRequest message or plain object
                     * @param {palexy.streaming.v1.RawICARecordService.ListRecordsCallback} callback Node-style callback called with the error, if any, and ListRawICARecordsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICARecordService.prototype.listRecords = function listRecords(request, callback) {
                        return this.rpcCall(listRecords, $root.palexy.streaming.v1.ListRawICARecordsRequest, $root.palexy.streaming.v1.ListRawICARecordsResponse, request, callback);
                    }, "name", { value: "ListRecords" });
    
                    /**
                     * Calls ListRecords.
                     * @function listRecords
                     * @memberof palexy.streaming.v1.RawICARecordService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest} request ListRawICARecordsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListRawICARecordsResponse>} Promise
                     * @variation 2
                     */
    
                    return RawICARecordService;
                })();
    
                v1.ListRawICARecordsRequest = (function() {
    
                    /**
                     * Properties of a ListRawICARecordsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICARecordsRequest
                     * @property {palexy.streaming.v1.IFilter|null} [filter] ListRawICARecordsRequest filter
                     * @property {google.protobuf.IFieldMask|null} [getFields] ListRawICARecordsRequest getFields
                     */
    
                    /**
                     * Constructs a new ListRawICARecordsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICARecordsRequest.
                     * @implements IListRawICARecordsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest=} [properties] Properties to set
                     */
                    function ListRawICARecordsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICARecordsRequest filter.
                     * @member {palexy.streaming.v1.IFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @instance
                     */
                    ListRawICARecordsRequest.prototype.filter = null;
    
                    /**
                     * ListRawICARecordsRequest getFields.
                     * @member {google.protobuf.IFieldMask|null|undefined} getFields
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @instance
                     */
                    ListRawICARecordsRequest.prototype.getFields = null;
    
                    /**
                     * Creates a new ListRawICARecordsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICARecordsRequest} ListRawICARecordsRequest instance
                     */
                    ListRawICARecordsRequest.create = function create(properties) {
                        return new ListRawICARecordsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICARecordsRequest message. Does not implicitly {@link palexy.streaming.v1.ListRawICARecordsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest} message ListRawICARecordsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICARecordsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.Filter.encode(message.filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.getFields != null && Object.hasOwnProperty.call(message, "getFields"))
                            $root.google.protobuf.FieldMask.encode(message.getFields, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICARecordsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICARecordsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsRequest} message ListRawICARecordsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICARecordsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICARecordsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICARecordsRequest} ListRawICARecordsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICARecordsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICARecordsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filter = $root.palexy.streaming.v1.Filter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.getFields = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICARecordsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICARecordsRequest} ListRawICARecordsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICARecordsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICARecordsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICARecordsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.Filter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.getFields != null && message.hasOwnProperty("getFields")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.getFields);
                            if (error)
                                return "getFields." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICARecordsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICARecordsRequest} ListRawICARecordsRequest
                     */
                    ListRawICARecordsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICARecordsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICARecordsRequest();
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICARecordsRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.Filter.fromObject(object.filter);
                        }
                        if (object.getFields != null) {
                            if (typeof object.getFields !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICARecordsRequest.getFields: object expected");
                            message.getFields = $root.google.protobuf.FieldMask.fromObject(object.getFields);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICARecordsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListRawICARecordsRequest} message ListRawICARecordsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICARecordsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.filter = null;
                            object.getFields = null;
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.Filter.toObject(message.filter, options);
                        if (message.getFields != null && message.hasOwnProperty("getFields"))
                            object.getFields = $root.google.protobuf.FieldMask.toObject(message.getFields, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICARecordsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICARecordsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICARecordsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICARecordsRequest;
                })();
    
                v1.Filter = (function() {
    
                    /**
                     * Properties of a Filter.
                     * @memberof palexy.streaming.v1
                     * @interface IFilter
                     * @property {number|null} [storeId] Filter storeId
                     * @property {string|null} [startDateTime] Filter startDateTime
                     * @property {string|null} [endDateTime] Filter endDateTime
                     * @property {string|null} [cameraId] Filter cameraId
                     * @property {string|null} [actionType] Filter actionType
                     * @property {google.protobuf.IBoolValue|null} [isStaff] Filter isStaff
                     * @property {google.protobuf.IInt64Value|null} [limit] Filter limit
                     * @property {Array.<string>|null} [actionTypes] Filter actionTypes
                     * @property {boolean|null} [useIcaMergingBucket] Filter useIcaMergingBucket
                     */
    
                    /**
                     * Constructs a new Filter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Filter.
                     * @implements IFilter
                     * @constructor
                     * @param {palexy.streaming.v1.IFilter=} [properties] Properties to set
                     */
                    function Filter(properties) {
                        this.actionTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Filter storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Filter startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.startDateTime = "";
    
                    /**
                     * Filter endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.endDateTime = "";
    
                    /**
                     * Filter cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.cameraId = "";
    
                    /**
                     * Filter actionType.
                     * @member {string} actionType
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.actionType = "";
    
                    /**
                     * Filter isStaff.
                     * @member {google.protobuf.IBoolValue|null|undefined} isStaff
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.isStaff = null;
    
                    /**
                     * Filter limit.
                     * @member {google.protobuf.IInt64Value|null|undefined} limit
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.limit = null;
    
                    /**
                     * Filter actionTypes.
                     * @member {Array.<string>} actionTypes
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.actionTypes = $util.emptyArray;
    
                    /**
                     * Filter useIcaMergingBucket.
                     * @member {boolean} useIcaMergingBucket
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     */
                    Filter.prototype.useIcaMergingBucket = false;
    
                    /**
                     * Creates a new Filter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {palexy.streaming.v1.IFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Filter} Filter instance
                     */
                    Filter.create = function create(properties) {
                        return new Filter(properties);
                    };
    
                    /**
                     * Encodes the specified Filter message. Does not implicitly {@link palexy.streaming.v1.Filter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {palexy.streaming.v1.IFilter} message Filter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Filter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateTime);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.cameraId);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.actionType);
                        if (message.isStaff != null && Object.hasOwnProperty.call(message, "isStaff"))
                            $root.google.protobuf.BoolValue.encode(message.isStaff, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                            $root.google.protobuf.Int64Value.encode(message.limit, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.actionTypes != null && message.actionTypes.length)
                            for (var i = 0; i < message.actionTypes.length; ++i)
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.actionTypes[i]);
                        if (message.useIcaMergingBucket != null && Object.hasOwnProperty.call(message, "useIcaMergingBucket"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.useIcaMergingBucket);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Filter message, length delimited. Does not implicitly {@link palexy.streaming.v1.Filter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {palexy.streaming.v1.IFilter} message Filter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Filter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Filter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Filter} Filter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Filter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Filter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateTime = reader.string();
                                break;
                            case 3:
                                message.endDateTime = reader.string();
                                break;
                            case 4:
                                message.cameraId = reader.string();
                                break;
                            case 5:
                                message.actionType = reader.string();
                                break;
                            case 6:
                                message.isStaff = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.limit = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 8:
                                if (!(message.actionTypes && message.actionTypes.length))
                                    message.actionTypes = [];
                                message.actionTypes.push(reader.string());
                                break;
                            case 9:
                                message.useIcaMergingBucket = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Filter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Filter} Filter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Filter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Filter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Filter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            if (!$util.isString(message.actionType))
                                return "actionType: string expected";
                        if (message.isStaff != null && message.hasOwnProperty("isStaff")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isStaff);
                            if (error)
                                return "isStaff." + error;
                        }
                        if (message.limit != null && message.hasOwnProperty("limit")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.limit);
                            if (error)
                                return "limit." + error;
                        }
                        if (message.actionTypes != null && message.hasOwnProperty("actionTypes")) {
                            if (!Array.isArray(message.actionTypes))
                                return "actionTypes: array expected";
                            for (var i = 0; i < message.actionTypes.length; ++i)
                                if (!$util.isString(message.actionTypes[i]))
                                    return "actionTypes: string[] expected";
                        }
                        if (message.useIcaMergingBucket != null && message.hasOwnProperty("useIcaMergingBucket"))
                            if (typeof message.useIcaMergingBucket !== "boolean")
                                return "useIcaMergingBucket: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a Filter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Filter} Filter
                     */
                    Filter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Filter)
                            return object;
                        var message = new $root.palexy.streaming.v1.Filter();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.actionType != null)
                            message.actionType = String(object.actionType);
                        if (object.isStaff != null) {
                            if (typeof object.isStaff !== "object")
                                throw TypeError(".palexy.streaming.v1.Filter.isStaff: object expected");
                            message.isStaff = $root.google.protobuf.BoolValue.fromObject(object.isStaff);
                        }
                        if (object.limit != null) {
                            if (typeof object.limit !== "object")
                                throw TypeError(".palexy.streaming.v1.Filter.limit: object expected");
                            message.limit = $root.google.protobuf.Int64Value.fromObject(object.limit);
                        }
                        if (object.actionTypes) {
                            if (!Array.isArray(object.actionTypes))
                                throw TypeError(".palexy.streaming.v1.Filter.actionTypes: array expected");
                            message.actionTypes = [];
                            for (var i = 0; i < object.actionTypes.length; ++i)
                                message.actionTypes[i] = String(object.actionTypes[i]);
                        }
                        if (object.useIcaMergingBucket != null)
                            message.useIcaMergingBucket = Boolean(object.useIcaMergingBucket);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Filter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Filter
                     * @static
                     * @param {palexy.streaming.v1.Filter} message Filter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Filter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.actionTypes = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                            object.cameraId = "";
                            object.actionType = "";
                            object.isStaff = null;
                            object.limit = null;
                            object.useIcaMergingBucket = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = message.actionType;
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            object.isStaff = $root.google.protobuf.BoolValue.toObject(message.isStaff, options);
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            object.limit = $root.google.protobuf.Int64Value.toObject(message.limit, options);
                        if (message.actionTypes && message.actionTypes.length) {
                            object.actionTypes = [];
                            for (var j = 0; j < message.actionTypes.length; ++j)
                                object.actionTypes[j] = message.actionTypes[j];
                        }
                        if (message.useIcaMergingBucket != null && message.hasOwnProperty("useIcaMergingBucket"))
                            object.useIcaMergingBucket = message.useIcaMergingBucket;
                        return object;
                    };
    
                    /**
                     * Converts this Filter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Filter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Filter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Filter;
                })();
    
                v1.ListRawICARecordsResponse = (function() {
    
                    /**
                     * Properties of a ListRawICARecordsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICARecordsResponse
                     * @property {Array.<palexy.streaming.v1.IRawICARecord>|null} [records] ListRawICARecordsResponse records
                     */
    
                    /**
                     * Constructs a new ListRawICARecordsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICARecordsResponse.
                     * @implements IListRawICARecordsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICARecordsResponse=} [properties] Properties to set
                     */
                    function ListRawICARecordsResponse(properties) {
                        this.records = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICARecordsResponse records.
                     * @member {Array.<palexy.streaming.v1.IRawICARecord>} records
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @instance
                     */
                    ListRawICARecordsResponse.prototype.records = $util.emptyArray;
    
                    /**
                     * Creates a new ListRawICARecordsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICARecordsResponse} ListRawICARecordsResponse instance
                     */
                    ListRawICARecordsResponse.create = function create(properties) {
                        return new ListRawICARecordsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICARecordsResponse message. Does not implicitly {@link palexy.streaming.v1.ListRawICARecordsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsResponse} message ListRawICARecordsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICARecordsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.records != null && message.records.length)
                            for (var i = 0; i < message.records.length; ++i)
                                $root.palexy.streaming.v1.RawICARecord.encode(message.records[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICARecordsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICARecordsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICARecordsResponse} message ListRawICARecordsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICARecordsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICARecordsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICARecordsResponse} ListRawICARecordsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICARecordsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICARecordsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.records && message.records.length))
                                    message.records = [];
                                message.records.push($root.palexy.streaming.v1.RawICARecord.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICARecordsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICARecordsResponse} ListRawICARecordsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICARecordsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICARecordsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICARecordsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.records != null && message.hasOwnProperty("records")) {
                            if (!Array.isArray(message.records))
                                return "records: array expected";
                            for (var i = 0; i < message.records.length; ++i) {
                                var error = $root.palexy.streaming.v1.RawICARecord.verify(message.records[i]);
                                if (error)
                                    return "records." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICARecordsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICARecordsResponse} ListRawICARecordsResponse
                     */
                    ListRawICARecordsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICARecordsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICARecordsResponse();
                        if (object.records) {
                            if (!Array.isArray(object.records))
                                throw TypeError(".palexy.streaming.v1.ListRawICARecordsResponse.records: array expected");
                            message.records = [];
                            for (var i = 0; i < object.records.length; ++i) {
                                if (typeof object.records[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListRawICARecordsResponse.records: object expected");
                                message.records[i] = $root.palexy.streaming.v1.RawICARecord.fromObject(object.records[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICARecordsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListRawICARecordsResponse} message ListRawICARecordsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICARecordsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.records = [];
                        if (message.records && message.records.length) {
                            object.records = [];
                            for (var j = 0; j < message.records.length; ++j)
                                object.records[j] = $root.palexy.streaming.v1.RawICARecord.toObject(message.records[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICARecordsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICARecordsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICARecordsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICARecordsResponse;
                })();
    
                v1.MergeResult = (function() {
    
                    /**
                     * Properties of a MergeResult.
                     * @memberof palexy.streaming.v1
                     * @interface IMergeResult
                     * @property {Array.<palexy.streaming.v1.IRawICARecord>|null} [records] MergeResult records
                     * @property {string|null} [dateId] MergeResult dateId
                     * @property {number|null} [storeId] MergeResult storeId
                     */
    
                    /**
                     * Constructs a new MergeResult.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergeResult.
                     * @implements IMergeResult
                     * @constructor
                     * @param {palexy.streaming.v1.IMergeResult=} [properties] Properties to set
                     */
                    function MergeResult(properties) {
                        this.records = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergeResult records.
                     * @member {Array.<palexy.streaming.v1.IRawICARecord>} records
                     * @memberof palexy.streaming.v1.MergeResult
                     * @instance
                     */
                    MergeResult.prototype.records = $util.emptyArray;
    
                    /**
                     * MergeResult dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.MergeResult
                     * @instance
                     */
                    MergeResult.prototype.dateId = "";
    
                    /**
                     * MergeResult storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.MergeResult
                     * @instance
                     */
                    MergeResult.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new MergeResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {palexy.streaming.v1.IMergeResult=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergeResult} MergeResult instance
                     */
                    MergeResult.create = function create(properties) {
                        return new MergeResult(properties);
                    };
    
                    /**
                     * Encodes the specified MergeResult message. Does not implicitly {@link palexy.streaming.v1.MergeResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {palexy.streaming.v1.IMergeResult} message MergeResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.records != null && message.records.length)
                            for (var i = 0; i < message.records.length; ++i)
                                $root.palexy.streaming.v1.RawICARecord.encode(message.records[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergeResult message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergeResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {palexy.streaming.v1.IMergeResult} message MergeResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergeResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergeResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergeResult} MergeResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergeResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.records && message.records.length))
                                    message.records = [];
                                message.records.push($root.palexy.streaming.v1.RawICARecord.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergeResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergeResult} MergeResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergeResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergeResult message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergeResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.records != null && message.hasOwnProperty("records")) {
                            if (!Array.isArray(message.records))
                                return "records: array expected";
                            for (var i = 0; i < message.records.length; ++i) {
                                var error = $root.palexy.streaming.v1.RawICARecord.verify(message.records[i]);
                                if (error)
                                    return "records." + error;
                            }
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergeResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergeResult} MergeResult
                     */
                    MergeResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergeResult)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergeResult();
                        if (object.records) {
                            if (!Array.isArray(object.records))
                                throw TypeError(".palexy.streaming.v1.MergeResult.records: array expected");
                            message.records = [];
                            for (var i = 0; i < object.records.length; ++i) {
                                if (typeof object.records[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MergeResult.records: object expected");
                                message.records[i] = $root.palexy.streaming.v1.RawICARecord.fromObject(object.records[i]);
                            }
                        }
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergeResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergeResult
                     * @static
                     * @param {palexy.streaming.v1.MergeResult} message MergeResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergeResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.records = [];
                        if (options.defaults) {
                            object.dateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.records && message.records.length) {
                            object.records = [];
                            for (var j = 0; j < message.records.length; ++j)
                                object.records[j] = $root.palexy.streaming.v1.RawICARecord.toObject(message.records[j], options);
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this MergeResult to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergeResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergeResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergeResult;
                })();
    
                v1.StoreConfig = (function() {
    
                    /**
                     * Properties of a StoreConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreConfig
                     * @property {number|null} [id] StoreConfig id
                     * @property {string|null} [name] StoreConfig name
                     * @property {number|null} [storeId] StoreConfig storeId
                     * @property {google.protobuf.ITimestamp|null} [createTime] StoreConfig createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] StoreConfig lastUpdateTime
                     * @property {palexy.streaming.v1.IStore|null} [storeData] StoreConfig storeData
                     */
    
                    /**
                     * Constructs a new StoreConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreConfig.
                     * @implements IStoreConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreConfig=} [properties] Properties to set
                     */
                    function StoreConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreConfig name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.name = "";
    
                    /**
                     * StoreConfig storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreConfig createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.createTime = null;
    
                    /**
                     * StoreConfig lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.lastUpdateTime = null;
    
                    /**
                     * StoreConfig storeData.
                     * @member {palexy.streaming.v1.IStore|null|undefined} storeData
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     */
                    StoreConfig.prototype.storeData = null;
    
                    /**
                     * Creates a new StoreConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreConfig} StoreConfig instance
                     */
                    StoreConfig.create = function create(properties) {
                        return new StoreConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StoreConfig message. Does not implicitly {@link palexy.streaming.v1.StoreConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfig} message StoreConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.storeData != null && Object.hasOwnProperty.call(message, "storeData"))
                            $root.palexy.streaming.v1.Store.encode(message.storeData, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfig} message StoreConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreConfig} StoreConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.storeData = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreConfig} StoreConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.storeData != null && message.hasOwnProperty("storeData")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.storeData);
                            if (error)
                                return "storeData." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreConfig} StoreConfig
                     */
                    StoreConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfig.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfig.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        if (object.storeData != null) {
                            if (typeof object.storeData !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfig.storeData: object expected");
                            message.storeData = $root.palexy.streaming.v1.Store.fromObject(object.storeData);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @static
                     * @param {palexy.streaming.v1.StoreConfig} message StoreConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            object.storeData = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.storeData != null && message.hasOwnProperty("storeData"))
                            object.storeData = $root.palexy.streaming.v1.Store.toObject(message.storeData, options);
                        return object;
                    };
    
                    /**
                     * Converts this StoreConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreConfig;
                })();
    
                v1.StoreConfigItem = (function() {
    
                    /**
                     * Properties of a StoreConfigItem.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreConfigItem
                     * @property {number|null} [id] StoreConfigItem id
                     * @property {string|null} [name] StoreConfigItem name
                     * @property {palexy.streaming.v1.StoreConfigItem.StoreConfigType|null} [configType] StoreConfigItem configType
                     * @property {string|null} [displayName] StoreConfigItem displayName
                     * @property {google.protobuf.ITimestamp|null} [createTime] StoreConfigItem createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] StoreConfigItem lastUpdateTime
                     * @property {number|null} [storeConfigId] StoreConfigItem storeConfigId
                     * @property {palexy.streaming.v1.IConfigData|null} [configData] StoreConfigItem configData
                     * @property {string|null} [appliedDate] StoreConfigItem appliedDate
                     * @property {palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope|null} [appliedScope] StoreConfigItem appliedScope
                     * @property {string|null} [note] StoreConfigItem note
                     */
    
                    /**
                     * Constructs a new StoreConfigItem.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreConfigItem.
                     * @implements IStoreConfigItem
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreConfigItem=} [properties] Properties to set
                     */
                    function StoreConfigItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreConfigItem id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreConfigItem name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.name = "";
    
                    /**
                     * StoreConfigItem configType.
                     * @member {palexy.streaming.v1.StoreConfigItem.StoreConfigType} configType
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.configType = 0;
    
                    /**
                     * StoreConfigItem displayName.
                     * @member {string} displayName
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.displayName = "";
    
                    /**
                     * StoreConfigItem createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.createTime = null;
    
                    /**
                     * StoreConfigItem lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.lastUpdateTime = null;
    
                    /**
                     * StoreConfigItem storeConfigId.
                     * @member {number} storeConfigId
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.storeConfigId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreConfigItem configData.
                     * @member {palexy.streaming.v1.IConfigData|null|undefined} configData
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.configData = null;
    
                    /**
                     * StoreConfigItem appliedDate.
                     * @member {string} appliedDate
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.appliedDate = "";
    
                    /**
                     * StoreConfigItem appliedScope.
                     * @member {palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope} appliedScope
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.appliedScope = 0;
    
                    /**
                     * StoreConfigItem note.
                     * @member {string} note
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     */
                    StoreConfigItem.prototype.note = "";
    
                    /**
                     * Creates a new StoreConfigItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfigItem=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreConfigItem} StoreConfigItem instance
                     */
                    StoreConfigItem.create = function create(properties) {
                        return new StoreConfigItem(properties);
                    };
    
                    /**
                     * Encodes the specified StoreConfigItem message. Does not implicitly {@link palexy.streaming.v1.StoreConfigItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfigItem} message StoreConfigItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreConfigItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.configType != null && Object.hasOwnProperty.call(message, "configType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.configType);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.displayName);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.storeConfigId != null && Object.hasOwnProperty.call(message, "storeConfigId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.storeConfigId);
                        if (message.configData != null && Object.hasOwnProperty.call(message, "configData"))
                            $root.palexy.streaming.v1.ConfigData.encode(message.configData, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.appliedDate != null && Object.hasOwnProperty.call(message, "appliedDate"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.appliedDate);
                        if (message.appliedScope != null && Object.hasOwnProperty.call(message, "appliedScope"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.appliedScope);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.note);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreConfigItem message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreConfigItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {palexy.streaming.v1.IStoreConfigItem} message StoreConfigItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreConfigItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreConfigItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreConfigItem} StoreConfigItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreConfigItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreConfigItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.configType = reader.int32();
                                break;
                            case 4:
                                message.displayName = reader.string();
                                break;
                            case 5:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.storeConfigId = reader.int64();
                                break;
                            case 8:
                                message.configData = $root.palexy.streaming.v1.ConfigData.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.appliedDate = reader.string();
                                break;
                            case 10:
                                message.appliedScope = reader.int32();
                                break;
                            case 11:
                                message.note = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreConfigItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreConfigItem} StoreConfigItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreConfigItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreConfigItem message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreConfigItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.configType != null && message.hasOwnProperty("configType"))
                            switch (message.configType) {
                            default:
                                return "configType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (!$util.isInteger(message.storeConfigId) && !(message.storeConfigId && $util.isInteger(message.storeConfigId.low) && $util.isInteger(message.storeConfigId.high)))
                                return "storeConfigId: integer|Long expected";
                        if (message.configData != null && message.hasOwnProperty("configData")) {
                            var error = $root.palexy.streaming.v1.ConfigData.verify(message.configData);
                            if (error)
                                return "configData." + error;
                        }
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            if (!$util.isString(message.appliedDate))
                                return "appliedDate: string expected";
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            switch (message.appliedScope) {
                            default:
                                return "appliedScope: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreConfigItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreConfigItem} StoreConfigItem
                     */
                    StoreConfigItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreConfigItem)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreConfigItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        switch (object.configType) {
                        case "UNKNOWN_CONFIG":
                        case 0:
                            message.configType = 0;
                            break;
                        case "POST_MERGE_CONFIG":
                        case 1:
                            message.configType = 1;
                            break;
                        case "MERGING_CONFIG":
                        case 2:
                            message.configType = 2;
                            break;
                        case "TRACKING_CONFIG":
                        case 3:
                            message.configType = 3;
                            break;
                        case "PROCESSING_CONFIG":
                        case 4:
                            message.configType = 4;
                            break;
                        }
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfigItem.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfigItem.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        if (object.storeConfigId != null)
                            if ($util.Long)
                                (message.storeConfigId = $util.Long.fromValue(object.storeConfigId)).unsigned = false;
                            else if (typeof object.storeConfigId === "string")
                                message.storeConfigId = parseInt(object.storeConfigId, 10);
                            else if (typeof object.storeConfigId === "number")
                                message.storeConfigId = object.storeConfigId;
                            else if (typeof object.storeConfigId === "object")
                                message.storeConfigId = new $util.LongBits(object.storeConfigId.low >>> 0, object.storeConfigId.high >>> 0).toNumber();
                        if (object.configData != null) {
                            if (typeof object.configData !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreConfigItem.configData: object expected");
                            message.configData = $root.palexy.streaming.v1.ConfigData.fromObject(object.configData);
                        }
                        if (object.appliedDate != null)
                            message.appliedDate = String(object.appliedDate);
                        switch (object.appliedScope) {
                        case "UNKNOWN_SCOPE":
                        case 0:
                            message.appliedScope = 0;
                            break;
                        case "PRODUCTION":
                        case 1:
                            message.appliedScope = 1;
                            break;
                        case "EXPERIMENT":
                        case 2:
                            message.appliedScope = 2;
                            break;
                        }
                        if (object.note != null)
                            message.note = String(object.note);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreConfigItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @static
                     * @param {palexy.streaming.v1.StoreConfigItem} message StoreConfigItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreConfigItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.configType = options.enums === String ? "UNKNOWN_CONFIG" : 0;
                            object.displayName = "";
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeConfigId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeConfigId = options.longs === String ? "0" : 0;
                            object.configData = null;
                            object.appliedDate = "";
                            object.appliedScope = options.enums === String ? "UNKNOWN_SCOPE" : 0;
                            object.note = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.configType != null && message.hasOwnProperty("configType"))
                            object.configType = options.enums === String ? $root.palexy.streaming.v1.StoreConfigItem.StoreConfigType[message.configType] : message.configType;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.storeConfigId != null && message.hasOwnProperty("storeConfigId"))
                            if (typeof message.storeConfigId === "number")
                                object.storeConfigId = options.longs === String ? String(message.storeConfigId) : message.storeConfigId;
                            else
                                object.storeConfigId = options.longs === String ? $util.Long.prototype.toString.call(message.storeConfigId) : options.longs === Number ? new $util.LongBits(message.storeConfigId.low >>> 0, message.storeConfigId.high >>> 0).toNumber() : message.storeConfigId;
                        if (message.configData != null && message.hasOwnProperty("configData"))
                            object.configData = $root.palexy.streaming.v1.ConfigData.toObject(message.configData, options);
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            object.appliedDate = message.appliedDate;
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            object.appliedScope = options.enums === String ? $root.palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope[message.appliedScope] : message.appliedScope;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        return object;
                    };
    
                    /**
                     * Converts this StoreConfigItem to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreConfigItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreConfigItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * StoreConfigType enum.
                     * @name palexy.streaming.v1.StoreConfigItem.StoreConfigType
                     * @enum {number}
                     * @property {number} UNKNOWN_CONFIG=0 UNKNOWN_CONFIG value
                     * @property {number} POST_MERGE_CONFIG=1 POST_MERGE_CONFIG value
                     * @property {number} MERGING_CONFIG=2 MERGING_CONFIG value
                     * @property {number} TRACKING_CONFIG=3 TRACKING_CONFIG value
                     * @property {number} PROCESSING_CONFIG=4 PROCESSING_CONFIG value
                     */
                    StoreConfigItem.StoreConfigType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_CONFIG"] = 0;
                        values[valuesById[1] = "POST_MERGE_CONFIG"] = 1;
                        values[valuesById[2] = "MERGING_CONFIG"] = 2;
                        values[valuesById[3] = "TRACKING_CONFIG"] = 3;
                        values[valuesById[4] = "PROCESSING_CONFIG"] = 4;
                        return values;
                    })();
    
                    /**
                     * StoreConfigAppliedScope enum.
                     * @name palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope
                     * @enum {number}
                     * @property {number} UNKNOWN_SCOPE=0 UNKNOWN_SCOPE value
                     * @property {number} PRODUCTION=1 PRODUCTION value
                     * @property {number} EXPERIMENT=2 EXPERIMENT value
                     */
                    StoreConfigItem.StoreConfigAppliedScope = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_SCOPE"] = 0;
                        values[valuesById[1] = "PRODUCTION"] = 1;
                        values[valuesById[2] = "EXPERIMENT"] = 2;
                        return values;
                    })();
    
                    return StoreConfigItem;
                })();
    
                v1.ConfigData = (function() {
    
                    /**
                     * Properties of a ConfigData.
                     * @memberof palexy.streaming.v1
                     * @interface IConfigData
                     * @property {palexy.streaming.v1.IPostMergeConfig|null} [postMergeConfig] ConfigData postMergeConfig
                     * @property {palexy.streaming.v1.IMergingConfig|null} [mergingConfig] ConfigData mergingConfig
                     * @property {palexy.streaming.v1.IMergingConfigPreset|null} [mergingConfigPreset] ConfigData mergingConfigPreset
                     */
    
                    /**
                     * Constructs a new ConfigData.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ConfigData.
                     * @implements IConfigData
                     * @constructor
                     * @param {palexy.streaming.v1.IConfigData=} [properties] Properties to set
                     */
                    function ConfigData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ConfigData postMergeConfig.
                     * @member {palexy.streaming.v1.IPostMergeConfig|null|undefined} postMergeConfig
                     * @memberof palexy.streaming.v1.ConfigData
                     * @instance
                     */
                    ConfigData.prototype.postMergeConfig = null;
    
                    /**
                     * ConfigData mergingConfig.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} mergingConfig
                     * @memberof palexy.streaming.v1.ConfigData
                     * @instance
                     */
                    ConfigData.prototype.mergingConfig = null;
    
                    /**
                     * ConfigData mergingConfigPreset.
                     * @member {palexy.streaming.v1.IMergingConfigPreset|null|undefined} mergingConfigPreset
                     * @memberof palexy.streaming.v1.ConfigData
                     * @instance
                     */
                    ConfigData.prototype.mergingConfigPreset = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ConfigData configData.
                     * @member {"postMergeConfig"|"mergingConfig"|"mergingConfigPreset"|undefined} configData
                     * @memberof palexy.streaming.v1.ConfigData
                     * @instance
                     */
                    Object.defineProperty(ConfigData.prototype, "configData", {
                        get: $util.oneOfGetter($oneOfFields = ["postMergeConfig", "mergingConfig", "mergingConfigPreset"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ConfigData instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {palexy.streaming.v1.IConfigData=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ConfigData} ConfigData instance
                     */
                    ConfigData.create = function create(properties) {
                        return new ConfigData(properties);
                    };
    
                    /**
                     * Encodes the specified ConfigData message. Does not implicitly {@link palexy.streaming.v1.ConfigData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {palexy.streaming.v1.IConfigData} message ConfigData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConfigData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.postMergeConfig != null && Object.hasOwnProperty.call(message, "postMergeConfig"))
                            $root.palexy.streaming.v1.PostMergeConfig.encode(message.postMergeConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.mergingConfig != null && Object.hasOwnProperty.call(message, "mergingConfig"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.mergingConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.mergingConfigPreset != null && Object.hasOwnProperty.call(message, "mergingConfigPreset"))
                            $root.palexy.streaming.v1.MergingConfigPreset.encode(message.mergingConfigPreset, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ConfigData message, length delimited. Does not implicitly {@link palexy.streaming.v1.ConfigData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {palexy.streaming.v1.IConfigData} message ConfigData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConfigData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ConfigData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ConfigData} ConfigData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConfigData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ConfigData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.postMergeConfig = $root.palexy.streaming.v1.PostMergeConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.mergingConfig = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ConfigData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ConfigData} ConfigData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConfigData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ConfigData message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ConfigData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.postMergeConfig != null && message.hasOwnProperty("postMergeConfig")) {
                            properties.configData = 1;
                            {
                                var error = $root.palexy.streaming.v1.PostMergeConfig.verify(message.postMergeConfig);
                                if (error)
                                    return "postMergeConfig." + error;
                            }
                        }
                        if (message.mergingConfig != null && message.hasOwnProperty("mergingConfig")) {
                            if (properties.configData === 1)
                                return "configData: multiple values";
                            properties.configData = 1;
                            {
                                var error = $root.palexy.streaming.v1.MergingConfig.verify(message.mergingConfig);
                                if (error)
                                    return "mergingConfig." + error;
                            }
                        }
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset")) {
                            if (properties.configData === 1)
                                return "configData: multiple values";
                            properties.configData = 1;
                            {
                                var error = $root.palexy.streaming.v1.MergingConfigPreset.verify(message.mergingConfigPreset);
                                if (error)
                                    return "mergingConfigPreset." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ConfigData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ConfigData} ConfigData
                     */
                    ConfigData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ConfigData)
                            return object;
                        var message = new $root.palexy.streaming.v1.ConfigData();
                        if (object.postMergeConfig != null) {
                            if (typeof object.postMergeConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.ConfigData.postMergeConfig: object expected");
                            message.postMergeConfig = $root.palexy.streaming.v1.PostMergeConfig.fromObject(object.postMergeConfig);
                        }
                        if (object.mergingConfig != null) {
                            if (typeof object.mergingConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.ConfigData.mergingConfig: object expected");
                            message.mergingConfig = $root.palexy.streaming.v1.MergingConfig.fromObject(object.mergingConfig);
                        }
                        if (object.mergingConfigPreset != null) {
                            if (typeof object.mergingConfigPreset !== "object")
                                throw TypeError(".palexy.streaming.v1.ConfigData.mergingConfigPreset: object expected");
                            message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.fromObject(object.mergingConfigPreset);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ConfigData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ConfigData
                     * @static
                     * @param {palexy.streaming.v1.ConfigData} message ConfigData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ConfigData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.postMergeConfig != null && message.hasOwnProperty("postMergeConfig")) {
                            object.postMergeConfig = $root.palexy.streaming.v1.PostMergeConfig.toObject(message.postMergeConfig, options);
                            if (options.oneofs)
                                object.configData = "postMergeConfig";
                        }
                        if (message.mergingConfig != null && message.hasOwnProperty("mergingConfig")) {
                            object.mergingConfig = $root.palexy.streaming.v1.MergingConfig.toObject(message.mergingConfig, options);
                            if (options.oneofs)
                                object.configData = "mergingConfig";
                        }
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset")) {
                            object.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.toObject(message.mergingConfigPreset, options);
                            if (options.oneofs)
                                object.configData = "mergingConfigPreset";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ConfigData to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ConfigData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ConfigData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ConfigData;
                })();
    
                v1.PostMergeConfig = (function() {
    
                    /**
                     * Properties of a PostMergeConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IPostMergeConfig
                     * @property {boolean|null} [removeSingleCameraTracklet] PostMergeConfig removeSingleCameraTracklet
                     * @property {number|null} [minDurationInSeconds] PostMergeConfig minDurationInSeconds
                     * @property {number|null} [minNumBb] PostMergeConfig minNumBb
                     * @property {boolean|null} [enableSplitOvermerge] PostMergeConfig enableSplitOvermerge
                     * @property {number|null} [splitOvermergeInnerClusterMaxFeatureDistance] PostMergeConfig splitOvermergeInnerClusterMaxFeatureDistance
                     * @property {number|null} [splitOvermergeInnerClusterMaxSameCameraOverlap] PostMergeConfig splitOvermergeInnerClusterMaxSameCameraOverlap
                     * @property {number|null} [splitOvermergeInnerClusterMaxFloorDistanceCrossCamera] PostMergeConfig splitOvermergeInnerClusterMaxFloorDistanceCrossCamera
                     * @property {number|null} [splitOvermergeInnerClusterMaxTimeDistanceSeconds] PostMergeConfig splitOvermergeInnerClusterMaxTimeDistanceSeconds
                     * @property {number|null} [splitOvermergeMinBb] PostMergeConfig splitOvermergeMinBb
                     * @property {boolean|null} [enableRemerge] PostMergeConfig enableRemerge
                     * @property {number|null} [remergeMaxTimeDistanceSeconds] PostMergeConfig remergeMaxTimeDistanceSeconds
                     * @property {number|null} [remergeMinComponentSize] PostMergeConfig remergeMinComponentSize
                     * @property {number|null} [remergeFeatureDistanceThreshold] PostMergeConfig remergeFeatureDistanceThreshold
                     * @property {number|null} [maxSecondsPerBb] PostMergeConfig maxSecondsPerBb
                     */
    
                    /**
                     * Constructs a new PostMergeConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PostMergeConfig.
                     * @implements IPostMergeConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IPostMergeConfig=} [properties] Properties to set
                     */
                    function PostMergeConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PostMergeConfig removeSingleCameraTracklet.
                     * @member {boolean} removeSingleCameraTracklet
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.removeSingleCameraTracklet = false;
    
                    /**
                     * PostMergeConfig minDurationInSeconds.
                     * @member {number} minDurationInSeconds
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.minDurationInSeconds = 0;
    
                    /**
                     * PostMergeConfig minNumBb.
                     * @member {number} minNumBb
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.minNumBb = 0;
    
                    /**
                     * PostMergeConfig enableSplitOvermerge.
                     * @member {boolean} enableSplitOvermerge
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.enableSplitOvermerge = false;
    
                    /**
                     * PostMergeConfig splitOvermergeInnerClusterMaxFeatureDistance.
                     * @member {number} splitOvermergeInnerClusterMaxFeatureDistance
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.splitOvermergeInnerClusterMaxFeatureDistance = 0;
    
                    /**
                     * PostMergeConfig splitOvermergeInnerClusterMaxSameCameraOverlap.
                     * @member {number} splitOvermergeInnerClusterMaxSameCameraOverlap
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.splitOvermergeInnerClusterMaxSameCameraOverlap = 0;
    
                    /**
                     * PostMergeConfig splitOvermergeInnerClusterMaxFloorDistanceCrossCamera.
                     * @member {number} splitOvermergeInnerClusterMaxFloorDistanceCrossCamera
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera = 0;
    
                    /**
                     * PostMergeConfig splitOvermergeInnerClusterMaxTimeDistanceSeconds.
                     * @member {number} splitOvermergeInnerClusterMaxTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.splitOvermergeInnerClusterMaxTimeDistanceSeconds = 0;
    
                    /**
                     * PostMergeConfig splitOvermergeMinBb.
                     * @member {number} splitOvermergeMinBb
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.splitOvermergeMinBb = 0;
    
                    /**
                     * PostMergeConfig enableRemerge.
                     * @member {boolean} enableRemerge
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.enableRemerge = false;
    
                    /**
                     * PostMergeConfig remergeMaxTimeDistanceSeconds.
                     * @member {number} remergeMaxTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.remergeMaxTimeDistanceSeconds = 0;
    
                    /**
                     * PostMergeConfig remergeMinComponentSize.
                     * @member {number} remergeMinComponentSize
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.remergeMinComponentSize = 0;
    
                    /**
                     * PostMergeConfig remergeFeatureDistanceThreshold.
                     * @member {number} remergeFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.remergeFeatureDistanceThreshold = 0;
    
                    /**
                     * PostMergeConfig maxSecondsPerBb.
                     * @member {number} maxSecondsPerBb
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     */
                    PostMergeConfig.prototype.maxSecondsPerBb = 0;
    
                    /**
                     * Creates a new PostMergeConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {palexy.streaming.v1.IPostMergeConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PostMergeConfig} PostMergeConfig instance
                     */
                    PostMergeConfig.create = function create(properties) {
                        return new PostMergeConfig(properties);
                    };
    
                    /**
                     * Encodes the specified PostMergeConfig message. Does not implicitly {@link palexy.streaming.v1.PostMergeConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {palexy.streaming.v1.IPostMergeConfig} message PostMergeConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostMergeConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.removeSingleCameraTracklet != null && Object.hasOwnProperty.call(message, "removeSingleCameraTracklet"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.removeSingleCameraTracklet);
                        if (message.minDurationInSeconds != null && Object.hasOwnProperty.call(message, "minDurationInSeconds"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minDurationInSeconds);
                        if (message.minNumBb != null && Object.hasOwnProperty.call(message, "minNumBb"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.minNumBb);
                        if (message.enableSplitOvermerge != null && Object.hasOwnProperty.call(message, "enableSplitOvermerge"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.enableSplitOvermerge);
                        if (message.splitOvermergeInnerClusterMaxFeatureDistance != null && Object.hasOwnProperty.call(message, "splitOvermergeInnerClusterMaxFeatureDistance"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.splitOvermergeInnerClusterMaxFeatureDistance);
                        if (message.splitOvermergeInnerClusterMaxSameCameraOverlap != null && Object.hasOwnProperty.call(message, "splitOvermergeInnerClusterMaxSameCameraOverlap"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.splitOvermergeInnerClusterMaxSameCameraOverlap);
                        if (message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera != null && Object.hasOwnProperty.call(message, "splitOvermergeInnerClusterMaxFloorDistanceCrossCamera"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera);
                        if (message.splitOvermergeInnerClusterMaxTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "splitOvermergeInnerClusterMaxTimeDistanceSeconds"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.splitOvermergeInnerClusterMaxTimeDistanceSeconds);
                        if (message.splitOvermergeMinBb != null && Object.hasOwnProperty.call(message, "splitOvermergeMinBb"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.splitOvermergeMinBb);
                        if (message.enableRemerge != null && Object.hasOwnProperty.call(message, "enableRemerge"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.enableRemerge);
                        if (message.remergeMaxTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "remergeMaxTimeDistanceSeconds"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.remergeMaxTimeDistanceSeconds);
                        if (message.remergeMinComponentSize != null && Object.hasOwnProperty.call(message, "remergeMinComponentSize"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.remergeMinComponentSize);
                        if (message.remergeFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "remergeFeatureDistanceThreshold"))
                            writer.uint32(/* id 13, wireType 5 =*/109).float(message.remergeFeatureDistanceThreshold);
                        if (message.maxSecondsPerBb != null && Object.hasOwnProperty.call(message, "maxSecondsPerBb"))
                            writer.uint32(/* id 14, wireType 5 =*/117).float(message.maxSecondsPerBb);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PostMergeConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.PostMergeConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {palexy.streaming.v1.IPostMergeConfig} message PostMergeConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PostMergeConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PostMergeConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PostMergeConfig} PostMergeConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostMergeConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PostMergeConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.removeSingleCameraTracklet = reader.bool();
                                break;
                            case 2:
                                message.minDurationInSeconds = reader.int32();
                                break;
                            case 3:
                                message.minNumBb = reader.int32();
                                break;
                            case 4:
                                message.enableSplitOvermerge = reader.bool();
                                break;
                            case 5:
                                message.splitOvermergeInnerClusterMaxFeatureDistance = reader.float();
                                break;
                            case 6:
                                message.splitOvermergeInnerClusterMaxSameCameraOverlap = reader.int32();
                                break;
                            case 7:
                                message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera = reader.int32();
                                break;
                            case 8:
                                message.splitOvermergeInnerClusterMaxTimeDistanceSeconds = reader.int32();
                                break;
                            case 9:
                                message.splitOvermergeMinBb = reader.int32();
                                break;
                            case 10:
                                message.enableRemerge = reader.bool();
                                break;
                            case 11:
                                message.remergeMaxTimeDistanceSeconds = reader.int32();
                                break;
                            case 12:
                                message.remergeMinComponentSize = reader.int32();
                                break;
                            case 13:
                                message.remergeFeatureDistanceThreshold = reader.float();
                                break;
                            case 14:
                                message.maxSecondsPerBb = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PostMergeConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PostMergeConfig} PostMergeConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PostMergeConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PostMergeConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PostMergeConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.removeSingleCameraTracklet != null && message.hasOwnProperty("removeSingleCameraTracklet"))
                            if (typeof message.removeSingleCameraTracklet !== "boolean")
                                return "removeSingleCameraTracklet: boolean expected";
                        if (message.minDurationInSeconds != null && message.hasOwnProperty("minDurationInSeconds"))
                            if (!$util.isInteger(message.minDurationInSeconds))
                                return "minDurationInSeconds: integer expected";
                        if (message.minNumBb != null && message.hasOwnProperty("minNumBb"))
                            if (!$util.isInteger(message.minNumBb))
                                return "minNumBb: integer expected";
                        if (message.enableSplitOvermerge != null && message.hasOwnProperty("enableSplitOvermerge"))
                            if (typeof message.enableSplitOvermerge !== "boolean")
                                return "enableSplitOvermerge: boolean expected";
                        if (message.splitOvermergeInnerClusterMaxFeatureDistance != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxFeatureDistance"))
                            if (typeof message.splitOvermergeInnerClusterMaxFeatureDistance !== "number")
                                return "splitOvermergeInnerClusterMaxFeatureDistance: number expected";
                        if (message.splitOvermergeInnerClusterMaxSameCameraOverlap != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxSameCameraOverlap"))
                            if (!$util.isInteger(message.splitOvermergeInnerClusterMaxSameCameraOverlap))
                                return "splitOvermergeInnerClusterMaxSameCameraOverlap: integer expected";
                        if (message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxFloorDistanceCrossCamera"))
                            if (!$util.isInteger(message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera))
                                return "splitOvermergeInnerClusterMaxFloorDistanceCrossCamera: integer expected";
                        if (message.splitOvermergeInnerClusterMaxTimeDistanceSeconds != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxTimeDistanceSeconds"))
                            if (!$util.isInteger(message.splitOvermergeInnerClusterMaxTimeDistanceSeconds))
                                return "splitOvermergeInnerClusterMaxTimeDistanceSeconds: integer expected";
                        if (message.splitOvermergeMinBb != null && message.hasOwnProperty("splitOvermergeMinBb"))
                            if (!$util.isInteger(message.splitOvermergeMinBb))
                                return "splitOvermergeMinBb: integer expected";
                        if (message.enableRemerge != null && message.hasOwnProperty("enableRemerge"))
                            if (typeof message.enableRemerge !== "boolean")
                                return "enableRemerge: boolean expected";
                        if (message.remergeMaxTimeDistanceSeconds != null && message.hasOwnProperty("remergeMaxTimeDistanceSeconds"))
                            if (!$util.isInteger(message.remergeMaxTimeDistanceSeconds))
                                return "remergeMaxTimeDistanceSeconds: integer expected";
                        if (message.remergeMinComponentSize != null && message.hasOwnProperty("remergeMinComponentSize"))
                            if (!$util.isInteger(message.remergeMinComponentSize))
                                return "remergeMinComponentSize: integer expected";
                        if (message.remergeFeatureDistanceThreshold != null && message.hasOwnProperty("remergeFeatureDistanceThreshold"))
                            if (typeof message.remergeFeatureDistanceThreshold !== "number")
                                return "remergeFeatureDistanceThreshold: number expected";
                        if (message.maxSecondsPerBb != null && message.hasOwnProperty("maxSecondsPerBb"))
                            if (typeof message.maxSecondsPerBb !== "number")
                                return "maxSecondsPerBb: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a PostMergeConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PostMergeConfig} PostMergeConfig
                     */
                    PostMergeConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PostMergeConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.PostMergeConfig();
                        if (object.removeSingleCameraTracklet != null)
                            message.removeSingleCameraTracklet = Boolean(object.removeSingleCameraTracklet);
                        if (object.minDurationInSeconds != null)
                            message.minDurationInSeconds = object.minDurationInSeconds | 0;
                        if (object.minNumBb != null)
                            message.minNumBb = object.minNumBb | 0;
                        if (object.enableSplitOvermerge != null)
                            message.enableSplitOvermerge = Boolean(object.enableSplitOvermerge);
                        if (object.splitOvermergeInnerClusterMaxFeatureDistance != null)
                            message.splitOvermergeInnerClusterMaxFeatureDistance = Number(object.splitOvermergeInnerClusterMaxFeatureDistance);
                        if (object.splitOvermergeInnerClusterMaxSameCameraOverlap != null)
                            message.splitOvermergeInnerClusterMaxSameCameraOverlap = object.splitOvermergeInnerClusterMaxSameCameraOverlap | 0;
                        if (object.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera != null)
                            message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera = object.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera | 0;
                        if (object.splitOvermergeInnerClusterMaxTimeDistanceSeconds != null)
                            message.splitOvermergeInnerClusterMaxTimeDistanceSeconds = object.splitOvermergeInnerClusterMaxTimeDistanceSeconds | 0;
                        if (object.splitOvermergeMinBb != null)
                            message.splitOvermergeMinBb = object.splitOvermergeMinBb | 0;
                        if (object.enableRemerge != null)
                            message.enableRemerge = Boolean(object.enableRemerge);
                        if (object.remergeMaxTimeDistanceSeconds != null)
                            message.remergeMaxTimeDistanceSeconds = object.remergeMaxTimeDistanceSeconds | 0;
                        if (object.remergeMinComponentSize != null)
                            message.remergeMinComponentSize = object.remergeMinComponentSize | 0;
                        if (object.remergeFeatureDistanceThreshold != null)
                            message.remergeFeatureDistanceThreshold = Number(object.remergeFeatureDistanceThreshold);
                        if (object.maxSecondsPerBb != null)
                            message.maxSecondsPerBb = Number(object.maxSecondsPerBb);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PostMergeConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @static
                     * @param {palexy.streaming.v1.PostMergeConfig} message PostMergeConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PostMergeConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.removeSingleCameraTracklet = false;
                            object.minDurationInSeconds = 0;
                            object.minNumBb = 0;
                            object.enableSplitOvermerge = false;
                            object.splitOvermergeInnerClusterMaxFeatureDistance = 0;
                            object.splitOvermergeInnerClusterMaxSameCameraOverlap = 0;
                            object.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera = 0;
                            object.splitOvermergeInnerClusterMaxTimeDistanceSeconds = 0;
                            object.splitOvermergeMinBb = 0;
                            object.enableRemerge = false;
                            object.remergeMaxTimeDistanceSeconds = 0;
                            object.remergeMinComponentSize = 0;
                            object.remergeFeatureDistanceThreshold = 0;
                            object.maxSecondsPerBb = 0;
                        }
                        if (message.removeSingleCameraTracklet != null && message.hasOwnProperty("removeSingleCameraTracklet"))
                            object.removeSingleCameraTracklet = message.removeSingleCameraTracklet;
                        if (message.minDurationInSeconds != null && message.hasOwnProperty("minDurationInSeconds"))
                            object.minDurationInSeconds = message.minDurationInSeconds;
                        if (message.minNumBb != null && message.hasOwnProperty("minNumBb"))
                            object.minNumBb = message.minNumBb;
                        if (message.enableSplitOvermerge != null && message.hasOwnProperty("enableSplitOvermerge"))
                            object.enableSplitOvermerge = message.enableSplitOvermerge;
                        if (message.splitOvermergeInnerClusterMaxFeatureDistance != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxFeatureDistance"))
                            object.splitOvermergeInnerClusterMaxFeatureDistance = options.json && !isFinite(message.splitOvermergeInnerClusterMaxFeatureDistance) ? String(message.splitOvermergeInnerClusterMaxFeatureDistance) : message.splitOvermergeInnerClusterMaxFeatureDistance;
                        if (message.splitOvermergeInnerClusterMaxSameCameraOverlap != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxSameCameraOverlap"))
                            object.splitOvermergeInnerClusterMaxSameCameraOverlap = message.splitOvermergeInnerClusterMaxSameCameraOverlap;
                        if (message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxFloorDistanceCrossCamera"))
                            object.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera = message.splitOvermergeInnerClusterMaxFloorDistanceCrossCamera;
                        if (message.splitOvermergeInnerClusterMaxTimeDistanceSeconds != null && message.hasOwnProperty("splitOvermergeInnerClusterMaxTimeDistanceSeconds"))
                            object.splitOvermergeInnerClusterMaxTimeDistanceSeconds = message.splitOvermergeInnerClusterMaxTimeDistanceSeconds;
                        if (message.splitOvermergeMinBb != null && message.hasOwnProperty("splitOvermergeMinBb"))
                            object.splitOvermergeMinBb = message.splitOvermergeMinBb;
                        if (message.enableRemerge != null && message.hasOwnProperty("enableRemerge"))
                            object.enableRemerge = message.enableRemerge;
                        if (message.remergeMaxTimeDistanceSeconds != null && message.hasOwnProperty("remergeMaxTimeDistanceSeconds"))
                            object.remergeMaxTimeDistanceSeconds = message.remergeMaxTimeDistanceSeconds;
                        if (message.remergeMinComponentSize != null && message.hasOwnProperty("remergeMinComponentSize"))
                            object.remergeMinComponentSize = message.remergeMinComponentSize;
                        if (message.remergeFeatureDistanceThreshold != null && message.hasOwnProperty("remergeFeatureDistanceThreshold"))
                            object.remergeFeatureDistanceThreshold = options.json && !isFinite(message.remergeFeatureDistanceThreshold) ? String(message.remergeFeatureDistanceThreshold) : message.remergeFeatureDistanceThreshold;
                        if (message.maxSecondsPerBb != null && message.hasOwnProperty("maxSecondsPerBb"))
                            object.maxSecondsPerBb = options.json && !isFinite(message.maxSecondsPerBb) ? String(message.maxSecondsPerBb) : message.maxSecondsPerBb;
                        return object;
                    };
    
                    /**
                     * Converts this PostMergeConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PostMergeConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PostMergeConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PostMergeConfig;
                })();
    
                v1.StoreConfigService = (function() {
    
                    /**
                     * Constructs a new StoreConfigService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreConfigService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreConfigService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreConfigService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreConfigService;
    
                    /**
                     * Creates new StoreConfigService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreConfigService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreConfigService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#createStoreConfig}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef CreateStoreConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfig} [response] StoreConfig
                     */
    
                    /**
                     * Calls CreateStoreConfig.
                     * @function createStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest} request CreateStoreConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.CreateStoreConfigCallback} callback Node-style callback called with the error, if any, and StoreConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.createStoreConfig = function createStoreConfig(request, callback) {
                        return this.rpcCall(createStoreConfig, $root.palexy.streaming.v1.CreateStoreConfigRequest, $root.palexy.streaming.v1.StoreConfig, request, callback);
                    }, "name", { value: "CreateStoreConfig" });
    
                    /**
                     * Calls CreateStoreConfig.
                     * @function createStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest} request CreateStoreConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#listStoreConfigs}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef ListStoreConfigsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreConfigsResponse} [response] ListStoreConfigsResponse
                     */
    
                    /**
                     * Calls ListStoreConfigs.
                     * @function listStoreConfigs
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest} request ListStoreConfigsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.ListStoreConfigsCallback} callback Node-style callback called with the error, if any, and ListStoreConfigsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.listStoreConfigs = function listStoreConfigs(request, callback) {
                        return this.rpcCall(listStoreConfigs, $root.palexy.streaming.v1.ListStoreConfigsRequest, $root.palexy.streaming.v1.ListStoreConfigsResponse, request, callback);
                    }, "name", { value: "ListStoreConfigs" });
    
                    /**
                     * Calls ListStoreConfigs.
                     * @function listStoreConfigs
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest} request ListStoreConfigsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreConfigsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#getStoreConfig}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef GetStoreConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfig} [response] StoreConfig
                     */
    
                    /**
                     * Calls GetStoreConfig.
                     * @function getStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest} request GetStoreConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.GetStoreConfigCallback} callback Node-style callback called with the error, if any, and StoreConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.getStoreConfig = function getStoreConfig(request, callback) {
                        return this.rpcCall(getStoreConfig, $root.palexy.streaming.v1.GetStoreConfigRequest, $root.palexy.streaming.v1.StoreConfig, request, callback);
                    }, "name", { value: "GetStoreConfig" });
    
                    /**
                     * Calls GetStoreConfig.
                     * @function getStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest} request GetStoreConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#updateStoreConfig}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef UpdateStoreConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfig} [response] StoreConfig
                     */
    
                    /**
                     * Calls UpdateStoreConfig.
                     * @function updateStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest} request UpdateStoreConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.UpdateStoreConfigCallback} callback Node-style callback called with the error, if any, and StoreConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.updateStoreConfig = function updateStoreConfig(request, callback) {
                        return this.rpcCall(updateStoreConfig, $root.palexy.streaming.v1.UpdateStoreConfigRequest, $root.palexy.streaming.v1.StoreConfig, request, callback);
                    }, "name", { value: "UpdateStoreConfig" });
    
                    /**
                     * Calls UpdateStoreConfig.
                     * @function updateStoreConfig
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest} request UpdateStoreConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#createStoreConfigItem}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef CreateStoreConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfigItem} [response] StoreConfigItem
                     */
    
                    /**
                     * Calls CreateStoreConfigItem.
                     * @function createStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest} request CreateStoreConfigItemRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.CreateStoreConfigItemCallback} callback Node-style callback called with the error, if any, and StoreConfigItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.createStoreConfigItem = function createStoreConfigItem(request, callback) {
                        return this.rpcCall(createStoreConfigItem, $root.palexy.streaming.v1.CreateStoreConfigItemRequest, $root.palexy.streaming.v1.StoreConfigItem, request, callback);
                    }, "name", { value: "CreateStoreConfigItem" });
    
                    /**
                     * Calls CreateStoreConfigItem.
                     * @function createStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest} request CreateStoreConfigItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfigItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#listStoreConfigItems}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef ListStoreConfigItemsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreConfigItemsResponse} [response] ListStoreConfigItemsResponse
                     */
    
                    /**
                     * Calls ListStoreConfigItems.
                     * @function listStoreConfigItems
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest} request ListStoreConfigItemsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.ListStoreConfigItemsCallback} callback Node-style callback called with the error, if any, and ListStoreConfigItemsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.listStoreConfigItems = function listStoreConfigItems(request, callback) {
                        return this.rpcCall(listStoreConfigItems, $root.palexy.streaming.v1.ListStoreConfigItemsRequest, $root.palexy.streaming.v1.ListStoreConfigItemsResponse, request, callback);
                    }, "name", { value: "ListStoreConfigItems" });
    
                    /**
                     * Calls ListStoreConfigItems.
                     * @function listStoreConfigItems
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest} request ListStoreConfigItemsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreConfigItemsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#getStoreConfigItem}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef GetStoreConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfigItem} [response] StoreConfigItem
                     */
    
                    /**
                     * Calls GetStoreConfigItem.
                     * @function getStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest} request GetStoreConfigItemRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.GetStoreConfigItemCallback} callback Node-style callback called with the error, if any, and StoreConfigItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.getStoreConfigItem = function getStoreConfigItem(request, callback) {
                        return this.rpcCall(getStoreConfigItem, $root.palexy.streaming.v1.GetStoreConfigItemRequest, $root.palexy.streaming.v1.StoreConfigItem, request, callback);
                    }, "name", { value: "GetStoreConfigItem" });
    
                    /**
                     * Calls GetStoreConfigItem.
                     * @function getStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest} request GetStoreConfigItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfigItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#findProductionStoreConfigItemByCameraIdAndDateId}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef FindProductionStoreConfigItemByCameraIdAndDateIdCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfigItem} [response] StoreConfigItem
                     */
    
                    /**
                     * Calls FindProductionStoreConfigItemByCameraIdAndDateId.
                     * @function findProductionStoreConfigItemByCameraIdAndDateId
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest} request FindProductionStoreConfigItemByCameraIdAndDateIdRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.FindProductionStoreConfigItemByCameraIdAndDateIdCallback} callback Node-style callback called with the error, if any, and StoreConfigItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.findProductionStoreConfigItemByCameraIdAndDateId = function findProductionStoreConfigItemByCameraIdAndDateId(request, callback) {
                        return this.rpcCall(findProductionStoreConfigItemByCameraIdAndDateId, $root.palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest, $root.palexy.streaming.v1.StoreConfigItem, request, callback);
                    }, "name", { value: "FindProductionStoreConfigItemByCameraIdAndDateId" });
    
                    /**
                     * Calls FindProductionStoreConfigItemByCameraIdAndDateId.
                     * @function findProductionStoreConfigItemByCameraIdAndDateId
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest} request FindProductionStoreConfigItemByCameraIdAndDateIdRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfigItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#findProductionStoreConfigItemByStoreIdAndDateId}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef FindProductionStoreConfigItemByStoreIdAndDateIdCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfigItem} [response] StoreConfigItem
                     */
    
                    /**
                     * Calls FindProductionStoreConfigItemByStoreIdAndDateId.
                     * @function findProductionStoreConfigItemByStoreIdAndDateId
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest} request FindProductionStoreConfigItemByStoreIdAndDateIdRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.FindProductionStoreConfigItemByStoreIdAndDateIdCallback} callback Node-style callback called with the error, if any, and StoreConfigItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.findProductionStoreConfigItemByStoreIdAndDateId = function findProductionStoreConfigItemByStoreIdAndDateId(request, callback) {
                        return this.rpcCall(findProductionStoreConfigItemByStoreIdAndDateId, $root.palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest, $root.palexy.streaming.v1.StoreConfigItem, request, callback);
                    }, "name", { value: "FindProductionStoreConfigItemByStoreIdAndDateId" });
    
                    /**
                     * Calls FindProductionStoreConfigItemByStoreIdAndDateId.
                     * @function findProductionStoreConfigItemByStoreIdAndDateId
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest} request FindProductionStoreConfigItemByStoreIdAndDateIdRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfigItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#updateStoreConfigItem}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef UpdateStoreConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreConfigItem} [response] StoreConfigItem
                     */
    
                    /**
                     * Calls UpdateStoreConfigItem.
                     * @function updateStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest} request UpdateStoreConfigItemRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.UpdateStoreConfigItemCallback} callback Node-style callback called with the error, if any, and StoreConfigItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.updateStoreConfigItem = function updateStoreConfigItem(request, callback) {
                        return this.rpcCall(updateStoreConfigItem, $root.palexy.streaming.v1.UpdateStoreConfigItemRequest, $root.palexy.streaming.v1.StoreConfigItem, request, callback);
                    }, "name", { value: "UpdateStoreConfigItem" });
    
                    /**
                     * Calls UpdateStoreConfigItem.
                     * @function updateStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest} request UpdateStoreConfigItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreConfigItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#deleteStoreConfigItem}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef DeleteStoreConfigItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStoreConfigItem.
                     * @function deleteStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest} request DeleteStoreConfigItemRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.DeleteStoreConfigItemCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.deleteStoreConfigItem = function deleteStoreConfigItem(request, callback) {
                        return this.rpcCall(deleteStoreConfigItem, $root.palexy.streaming.v1.DeleteStoreConfigItemRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStoreConfigItem" });
    
                    /**
                     * Calls DeleteStoreConfigItem.
                     * @function deleteStoreConfigItem
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest} request DeleteStoreConfigItemRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#createMergingConfigPreset}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef CreateMergingConfigPresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MergingConfigPreset} [response] MergingConfigPreset
                     */
    
                    /**
                     * Calls CreateMergingConfigPreset.
                     * @function createMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest} request CreateMergingConfigPresetRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.CreateMergingConfigPresetCallback} callback Node-style callback called with the error, if any, and MergingConfigPreset
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.createMergingConfigPreset = function createMergingConfigPreset(request, callback) {
                        return this.rpcCall(createMergingConfigPreset, $root.palexy.streaming.v1.CreateMergingConfigPresetRequest, $root.palexy.streaming.v1.MergingConfigPreset, request, callback);
                    }, "name", { value: "CreateMergingConfigPreset" });
    
                    /**
                     * Calls CreateMergingConfigPreset.
                     * @function createMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest} request CreateMergingConfigPresetRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MergingConfigPreset>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#listMergingConfigPresets}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef ListMergingConfigPresetsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListMergingConfigPresetsResponse} [response] ListMergingConfigPresetsResponse
                     */
    
                    /**
                     * Calls ListMergingConfigPresets.
                     * @function listMergingConfigPresets
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest} request ListMergingConfigPresetsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.ListMergingConfigPresetsCallback} callback Node-style callback called with the error, if any, and ListMergingConfigPresetsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.listMergingConfigPresets = function listMergingConfigPresets(request, callback) {
                        return this.rpcCall(listMergingConfigPresets, $root.palexy.streaming.v1.ListMergingConfigPresetsRequest, $root.palexy.streaming.v1.ListMergingConfigPresetsResponse, request, callback);
                    }, "name", { value: "ListMergingConfigPresets" });
    
                    /**
                     * Calls ListMergingConfigPresets.
                     * @function listMergingConfigPresets
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest} request ListMergingConfigPresetsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListMergingConfigPresetsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#getMergingConfigPreset}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef GetMergingConfigPresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MergingConfigPreset} [response] MergingConfigPreset
                     */
    
                    /**
                     * Calls GetMergingConfigPreset.
                     * @function getMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest} request GetMergingConfigPresetRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.GetMergingConfigPresetCallback} callback Node-style callback called with the error, if any, and MergingConfigPreset
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.getMergingConfigPreset = function getMergingConfigPreset(request, callback) {
                        return this.rpcCall(getMergingConfigPreset, $root.palexy.streaming.v1.GetMergingConfigPresetRequest, $root.palexy.streaming.v1.MergingConfigPreset, request, callback);
                    }, "name", { value: "GetMergingConfigPreset" });
    
                    /**
                     * Calls GetMergingConfigPreset.
                     * @function getMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest} request GetMergingConfigPresetRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MergingConfigPreset>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#updateMergingConfigPreset}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef UpdateMergingConfigPresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MergingConfigPreset} [response] MergingConfigPreset
                     */
    
                    /**
                     * Calls UpdateMergingConfigPreset.
                     * @function updateMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest} request UpdateMergingConfigPresetRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.UpdateMergingConfigPresetCallback} callback Node-style callback called with the error, if any, and MergingConfigPreset
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.updateMergingConfigPreset = function updateMergingConfigPreset(request, callback) {
                        return this.rpcCall(updateMergingConfigPreset, $root.palexy.streaming.v1.UpdateMergingConfigPresetRequest, $root.palexy.streaming.v1.MergingConfigPreset, request, callback);
                    }, "name", { value: "UpdateMergingConfigPreset" });
    
                    /**
                     * Calls UpdateMergingConfigPreset.
                     * @function updateMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest} request UpdateMergingConfigPresetRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MergingConfigPreset>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreConfigService#deleteMergingConfigPreset}.
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @typedef DeleteMergingConfigPresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteMergingConfigPreset.
                     * @function deleteMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest} request DeleteMergingConfigPresetRequest message or plain object
                     * @param {palexy.streaming.v1.StoreConfigService.DeleteMergingConfigPresetCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreConfigService.prototype.deleteMergingConfigPreset = function deleteMergingConfigPreset(request, callback) {
                        return this.rpcCall(deleteMergingConfigPreset, $root.palexy.streaming.v1.DeleteMergingConfigPresetRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteMergingConfigPreset" });
    
                    /**
                     * Calls DeleteMergingConfigPreset.
                     * @function deleteMergingConfigPreset
                     * @memberof palexy.streaming.v1.StoreConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest} request DeleteMergingConfigPresetRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return StoreConfigService;
                })();
    
                v1.CreateMergingConfigPresetRequest = (function() {
    
                    /**
                     * Properties of a CreateMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateMergingConfigPresetRequest
                     * @property {palexy.streaming.v1.IMergingConfigPreset|null} [mergingConfigPreset] CreateMergingConfigPresetRequest mergingConfigPreset
                     */
    
                    /**
                     * Constructs a new CreateMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateMergingConfigPresetRequest.
                     * @implements ICreateMergingConfigPresetRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest=} [properties] Properties to set
                     */
                    function CreateMergingConfigPresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateMergingConfigPresetRequest mergingConfigPreset.
                     * @member {palexy.streaming.v1.IMergingConfigPreset|null|undefined} mergingConfigPreset
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @instance
                     */
                    CreateMergingConfigPresetRequest.prototype.mergingConfigPreset = null;
    
                    /**
                     * Creates a new CreateMergingConfigPresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateMergingConfigPresetRequest} CreateMergingConfigPresetRequest instance
                     */
                    CreateMergingConfigPresetRequest.create = function create(properties) {
                        return new CreateMergingConfigPresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateMergingConfigPresetRequest message. Does not implicitly {@link palexy.streaming.v1.CreateMergingConfigPresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest} message CreateMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateMergingConfigPresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingConfigPreset != null && Object.hasOwnProperty.call(message, "mergingConfigPreset"))
                            $root.palexy.streaming.v1.MergingConfigPreset.encode(message.mergingConfigPreset, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateMergingConfigPresetRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateMergingConfigPresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateMergingConfigPresetRequest} message CreateMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateMergingConfigPresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateMergingConfigPresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateMergingConfigPresetRequest} CreateMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateMergingConfigPresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateMergingConfigPresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateMergingConfigPresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateMergingConfigPresetRequest} CreateMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateMergingConfigPresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateMergingConfigPresetRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateMergingConfigPresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset")) {
                            var error = $root.palexy.streaming.v1.MergingConfigPreset.verify(message.mergingConfigPreset);
                            if (error)
                                return "mergingConfigPreset." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateMergingConfigPresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateMergingConfigPresetRequest} CreateMergingConfigPresetRequest
                     */
                    CreateMergingConfigPresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateMergingConfigPresetRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateMergingConfigPresetRequest();
                        if (object.mergingConfigPreset != null) {
                            if (typeof object.mergingConfigPreset !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateMergingConfigPresetRequest.mergingConfigPreset: object expected");
                            message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.fromObject(object.mergingConfigPreset);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateMergingConfigPresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateMergingConfigPresetRequest} message CreateMergingConfigPresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateMergingConfigPresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.mergingConfigPreset = null;
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset"))
                            object.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.toObject(message.mergingConfigPreset, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateMergingConfigPresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateMergingConfigPresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateMergingConfigPresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateMergingConfigPresetRequest;
                })();
    
                v1.ListMergingConfigPresetsRequest = (function() {
    
                    /**
                     * Properties of a ListMergingConfigPresetsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListMergingConfigPresetsRequest
                     * @property {google.protobuf.IInt64Value|null} [storeId] ListMergingConfigPresetsRequest storeId
                     * @property {boolean|null} [isForSuggestion] ListMergingConfigPresetsRequest isForSuggestion
                     */
    
                    /**
                     * Constructs a new ListMergingConfigPresetsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMergingConfigPresetsRequest.
                     * @implements IListMergingConfigPresetsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest=} [properties] Properties to set
                     */
                    function ListMergingConfigPresetsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMergingConfigPresetsRequest storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @instance
                     */
                    ListMergingConfigPresetsRequest.prototype.storeId = null;
    
                    /**
                     * ListMergingConfigPresetsRequest isForSuggestion.
                     * @member {boolean} isForSuggestion
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @instance
                     */
                    ListMergingConfigPresetsRequest.prototype.isForSuggestion = false;
    
                    /**
                     * Creates a new ListMergingConfigPresetsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsRequest} ListMergingConfigPresetsRequest instance
                     */
                    ListMergingConfigPresetsRequest.create = function create(properties) {
                        return new ListMergingConfigPresetsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListMergingConfigPresetsRequest message. Does not implicitly {@link palexy.streaming.v1.ListMergingConfigPresetsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest} message ListMergingConfigPresetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMergingConfigPresetsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.isForSuggestion != null && Object.hasOwnProperty.call(message, "isForSuggestion"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isForSuggestion);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMergingConfigPresetsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMergingConfigPresetsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsRequest} message ListMergingConfigPresetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMergingConfigPresetsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMergingConfigPresetsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsRequest} ListMergingConfigPresetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMergingConfigPresetsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMergingConfigPresetsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.isForSuggestion = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMergingConfigPresetsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsRequest} ListMergingConfigPresetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMergingConfigPresetsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMergingConfigPresetsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMergingConfigPresetsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.isForSuggestion != null && message.hasOwnProperty("isForSuggestion"))
                            if (typeof message.isForSuggestion !== "boolean")
                                return "isForSuggestion: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListMergingConfigPresetsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsRequest} ListMergingConfigPresetsRequest
                     */
                    ListMergingConfigPresetsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMergingConfigPresetsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMergingConfigPresetsRequest();
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListMergingConfigPresetsRequest.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.isForSuggestion != null)
                            message.isForSuggestion = Boolean(object.isForSuggestion);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMergingConfigPresetsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListMergingConfigPresetsRequest} message ListMergingConfigPresetsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMergingConfigPresetsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeId = null;
                            object.isForSuggestion = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.isForSuggestion != null && message.hasOwnProperty("isForSuggestion"))
                            object.isForSuggestion = message.isForSuggestion;
                        return object;
                    };
    
                    /**
                     * Converts this ListMergingConfigPresetsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMergingConfigPresetsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListMergingConfigPresetsRequest;
                })();
    
                v1.ListMergingConfigPresetsResponse = (function() {
    
                    /**
                     * Properties of a ListMergingConfigPresetsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListMergingConfigPresetsResponse
                     * @property {Array.<palexy.streaming.v1.IMergingConfigPreset>|null} [mergingConfigPresets] ListMergingConfigPresetsResponse mergingConfigPresets
                     */
    
                    /**
                     * Constructs a new ListMergingConfigPresetsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMergingConfigPresetsResponse.
                     * @implements IListMergingConfigPresetsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsResponse=} [properties] Properties to set
                     */
                    function ListMergingConfigPresetsResponse(properties) {
                        this.mergingConfigPresets = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMergingConfigPresetsResponse mergingConfigPresets.
                     * @member {Array.<palexy.streaming.v1.IMergingConfigPreset>} mergingConfigPresets
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @instance
                     */
                    ListMergingConfigPresetsResponse.prototype.mergingConfigPresets = $util.emptyArray;
    
                    /**
                     * Creates a new ListMergingConfigPresetsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsResponse} ListMergingConfigPresetsResponse instance
                     */
                    ListMergingConfigPresetsResponse.create = function create(properties) {
                        return new ListMergingConfigPresetsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListMergingConfigPresetsResponse message. Does not implicitly {@link palexy.streaming.v1.ListMergingConfigPresetsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsResponse} message ListMergingConfigPresetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMergingConfigPresetsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingConfigPresets != null && message.mergingConfigPresets.length)
                            for (var i = 0; i < message.mergingConfigPresets.length; ++i)
                                $root.palexy.streaming.v1.MergingConfigPreset.encode(message.mergingConfigPresets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMergingConfigPresetsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMergingConfigPresetsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMergingConfigPresetsResponse} message ListMergingConfigPresetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMergingConfigPresetsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMergingConfigPresetsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsResponse} ListMergingConfigPresetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMergingConfigPresetsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMergingConfigPresetsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.mergingConfigPresets && message.mergingConfigPresets.length))
                                    message.mergingConfigPresets = [];
                                message.mergingConfigPresets.push($root.palexy.streaming.v1.MergingConfigPreset.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMergingConfigPresetsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsResponse} ListMergingConfigPresetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMergingConfigPresetsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMergingConfigPresetsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMergingConfigPresetsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingConfigPresets != null && message.hasOwnProperty("mergingConfigPresets")) {
                            if (!Array.isArray(message.mergingConfigPresets))
                                return "mergingConfigPresets: array expected";
                            for (var i = 0; i < message.mergingConfigPresets.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergingConfigPreset.verify(message.mergingConfigPresets[i]);
                                if (error)
                                    return "mergingConfigPresets." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListMergingConfigPresetsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMergingConfigPresetsResponse} ListMergingConfigPresetsResponse
                     */
                    ListMergingConfigPresetsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMergingConfigPresetsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMergingConfigPresetsResponse();
                        if (object.mergingConfigPresets) {
                            if (!Array.isArray(object.mergingConfigPresets))
                                throw TypeError(".palexy.streaming.v1.ListMergingConfigPresetsResponse.mergingConfigPresets: array expected");
                            message.mergingConfigPresets = [];
                            for (var i = 0; i < object.mergingConfigPresets.length; ++i) {
                                if (typeof object.mergingConfigPresets[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListMergingConfigPresetsResponse.mergingConfigPresets: object expected");
                                message.mergingConfigPresets[i] = $root.palexy.streaming.v1.MergingConfigPreset.fromObject(object.mergingConfigPresets[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMergingConfigPresetsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListMergingConfigPresetsResponse} message ListMergingConfigPresetsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMergingConfigPresetsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.mergingConfigPresets = [];
                        if (message.mergingConfigPresets && message.mergingConfigPresets.length) {
                            object.mergingConfigPresets = [];
                            for (var j = 0; j < message.mergingConfigPresets.length; ++j)
                                object.mergingConfigPresets[j] = $root.palexy.streaming.v1.MergingConfigPreset.toObject(message.mergingConfigPresets[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListMergingConfigPresetsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMergingConfigPresetsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMergingConfigPresetsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListMergingConfigPresetsResponse;
                })();
    
                v1.GetMergingConfigPresetRequest = (function() {
    
                    /**
                     * Properties of a GetMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetMergingConfigPresetRequest
                     * @property {number|null} [mergingConfigPresetId] GetMergingConfigPresetRequest mergingConfigPresetId
                     */
    
                    /**
                     * Constructs a new GetMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetMergingConfigPresetRequest.
                     * @implements IGetMergingConfigPresetRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest=} [properties] Properties to set
                     */
                    function GetMergingConfigPresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetMergingConfigPresetRequest mergingConfigPresetId.
                     * @member {number} mergingConfigPresetId
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @instance
                     */
                    GetMergingConfigPresetRequest.prototype.mergingConfigPresetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetMergingConfigPresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetMergingConfigPresetRequest} GetMergingConfigPresetRequest instance
                     */
                    GetMergingConfigPresetRequest.create = function create(properties) {
                        return new GetMergingConfigPresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetMergingConfigPresetRequest message. Does not implicitly {@link palexy.streaming.v1.GetMergingConfigPresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest} message GetMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetMergingConfigPresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingConfigPresetId != null && Object.hasOwnProperty.call(message, "mergingConfigPresetId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.mergingConfigPresetId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetMergingConfigPresetRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetMergingConfigPresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMergingConfigPresetRequest} message GetMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetMergingConfigPresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetMergingConfigPresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetMergingConfigPresetRequest} GetMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetMergingConfigPresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetMergingConfigPresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergingConfigPresetId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetMergingConfigPresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetMergingConfigPresetRequest} GetMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetMergingConfigPresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetMergingConfigPresetRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetMergingConfigPresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingConfigPresetId != null && message.hasOwnProperty("mergingConfigPresetId"))
                            if (!$util.isInteger(message.mergingConfigPresetId) && !(message.mergingConfigPresetId && $util.isInteger(message.mergingConfigPresetId.low) && $util.isInteger(message.mergingConfigPresetId.high)))
                                return "mergingConfigPresetId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetMergingConfigPresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetMergingConfigPresetRequest} GetMergingConfigPresetRequest
                     */
                    GetMergingConfigPresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetMergingConfigPresetRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetMergingConfigPresetRequest();
                        if (object.mergingConfigPresetId != null)
                            if ($util.Long)
                                (message.mergingConfigPresetId = $util.Long.fromValue(object.mergingConfigPresetId)).unsigned = false;
                            else if (typeof object.mergingConfigPresetId === "string")
                                message.mergingConfigPresetId = parseInt(object.mergingConfigPresetId, 10);
                            else if (typeof object.mergingConfigPresetId === "number")
                                message.mergingConfigPresetId = object.mergingConfigPresetId;
                            else if (typeof object.mergingConfigPresetId === "object")
                                message.mergingConfigPresetId = new $util.LongBits(object.mergingConfigPresetId.low >>> 0, object.mergingConfigPresetId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetMergingConfigPresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.GetMergingConfigPresetRequest} message GetMergingConfigPresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetMergingConfigPresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.mergingConfigPresetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.mergingConfigPresetId = options.longs === String ? "0" : 0;
                        if (message.mergingConfigPresetId != null && message.hasOwnProperty("mergingConfigPresetId"))
                            if (typeof message.mergingConfigPresetId === "number")
                                object.mergingConfigPresetId = options.longs === String ? String(message.mergingConfigPresetId) : message.mergingConfigPresetId;
                            else
                                object.mergingConfigPresetId = options.longs === String ? $util.Long.prototype.toString.call(message.mergingConfigPresetId) : options.longs === Number ? new $util.LongBits(message.mergingConfigPresetId.low >>> 0, message.mergingConfigPresetId.high >>> 0).toNumber() : message.mergingConfigPresetId;
                        return object;
                    };
    
                    /**
                     * Converts this GetMergingConfigPresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetMergingConfigPresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetMergingConfigPresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetMergingConfigPresetRequest;
                })();
    
                v1.UpdateMergingConfigPresetRequest = (function() {
    
                    /**
                     * Properties of an UpdateMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateMergingConfigPresetRequest
                     * @property {palexy.streaming.v1.IMergingConfigPreset|null} [mergingConfigPreset] UpdateMergingConfigPresetRequest mergingConfigPreset
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateMergingConfigPresetRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateMergingConfigPresetRequest.
                     * @implements IUpdateMergingConfigPresetRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest=} [properties] Properties to set
                     */
                    function UpdateMergingConfigPresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateMergingConfigPresetRequest mergingConfigPreset.
                     * @member {palexy.streaming.v1.IMergingConfigPreset|null|undefined} mergingConfigPreset
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @instance
                     */
                    UpdateMergingConfigPresetRequest.prototype.mergingConfigPreset = null;
    
                    /**
                     * UpdateMergingConfigPresetRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @instance
                     */
                    UpdateMergingConfigPresetRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateMergingConfigPresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateMergingConfigPresetRequest} UpdateMergingConfigPresetRequest instance
                     */
                    UpdateMergingConfigPresetRequest.create = function create(properties) {
                        return new UpdateMergingConfigPresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateMergingConfigPresetRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateMergingConfigPresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest} message UpdateMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateMergingConfigPresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingConfigPreset != null && Object.hasOwnProperty.call(message, "mergingConfigPreset"))
                            $root.palexy.streaming.v1.MergingConfigPreset.encode(message.mergingConfigPreset, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateMergingConfigPresetRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateMergingConfigPresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMergingConfigPresetRequest} message UpdateMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateMergingConfigPresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateMergingConfigPresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateMergingConfigPresetRequest} UpdateMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateMergingConfigPresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateMergingConfigPresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateMergingConfigPresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateMergingConfigPresetRequest} UpdateMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateMergingConfigPresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateMergingConfigPresetRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateMergingConfigPresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset")) {
                            var error = $root.palexy.streaming.v1.MergingConfigPreset.verify(message.mergingConfigPreset);
                            if (error)
                                return "mergingConfigPreset." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateMergingConfigPresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateMergingConfigPresetRequest} UpdateMergingConfigPresetRequest
                     */
                    UpdateMergingConfigPresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateMergingConfigPresetRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateMergingConfigPresetRequest();
                        if (object.mergingConfigPreset != null) {
                            if (typeof object.mergingConfigPreset !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateMergingConfigPresetRequest.mergingConfigPreset: object expected");
                            message.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.fromObject(object.mergingConfigPreset);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateMergingConfigPresetRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateMergingConfigPresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateMergingConfigPresetRequest} message UpdateMergingConfigPresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateMergingConfigPresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mergingConfigPreset = null;
                            object.updateMask = null;
                        }
                        if (message.mergingConfigPreset != null && message.hasOwnProperty("mergingConfigPreset"))
                            object.mergingConfigPreset = $root.palexy.streaming.v1.MergingConfigPreset.toObject(message.mergingConfigPreset, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateMergingConfigPresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateMergingConfigPresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateMergingConfigPresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateMergingConfigPresetRequest;
                })();
    
                v1.DeleteMergingConfigPresetRequest = (function() {
    
                    /**
                     * Properties of a DeleteMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteMergingConfigPresetRequest
                     * @property {number|null} [mergingConfigPresetId] DeleteMergingConfigPresetRequest mergingConfigPresetId
                     */
    
                    /**
                     * Constructs a new DeleteMergingConfigPresetRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteMergingConfigPresetRequest.
                     * @implements IDeleteMergingConfigPresetRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest=} [properties] Properties to set
                     */
                    function DeleteMergingConfigPresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteMergingConfigPresetRequest mergingConfigPresetId.
                     * @member {number} mergingConfigPresetId
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @instance
                     */
                    DeleteMergingConfigPresetRequest.prototype.mergingConfigPresetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteMergingConfigPresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteMergingConfigPresetRequest} DeleteMergingConfigPresetRequest instance
                     */
                    DeleteMergingConfigPresetRequest.create = function create(properties) {
                        return new DeleteMergingConfigPresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteMergingConfigPresetRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteMergingConfigPresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest} message DeleteMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteMergingConfigPresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mergingConfigPresetId != null && Object.hasOwnProperty.call(message, "mergingConfigPresetId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.mergingConfigPresetId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteMergingConfigPresetRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteMergingConfigPresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMergingConfigPresetRequest} message DeleteMergingConfigPresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteMergingConfigPresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteMergingConfigPresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteMergingConfigPresetRequest} DeleteMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteMergingConfigPresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteMergingConfigPresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mergingConfigPresetId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteMergingConfigPresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteMergingConfigPresetRequest} DeleteMergingConfigPresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteMergingConfigPresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteMergingConfigPresetRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteMergingConfigPresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mergingConfigPresetId != null && message.hasOwnProperty("mergingConfigPresetId"))
                            if (!$util.isInteger(message.mergingConfigPresetId) && !(message.mergingConfigPresetId && $util.isInteger(message.mergingConfigPresetId.low) && $util.isInteger(message.mergingConfigPresetId.high)))
                                return "mergingConfigPresetId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteMergingConfigPresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteMergingConfigPresetRequest} DeleteMergingConfigPresetRequest
                     */
                    DeleteMergingConfigPresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteMergingConfigPresetRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteMergingConfigPresetRequest();
                        if (object.mergingConfigPresetId != null)
                            if ($util.Long)
                                (message.mergingConfigPresetId = $util.Long.fromValue(object.mergingConfigPresetId)).unsigned = false;
                            else if (typeof object.mergingConfigPresetId === "string")
                                message.mergingConfigPresetId = parseInt(object.mergingConfigPresetId, 10);
                            else if (typeof object.mergingConfigPresetId === "number")
                                message.mergingConfigPresetId = object.mergingConfigPresetId;
                            else if (typeof object.mergingConfigPresetId === "object")
                                message.mergingConfigPresetId = new $util.LongBits(object.mergingConfigPresetId.low >>> 0, object.mergingConfigPresetId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteMergingConfigPresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteMergingConfigPresetRequest} message DeleteMergingConfigPresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteMergingConfigPresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.mergingConfigPresetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.mergingConfigPresetId = options.longs === String ? "0" : 0;
                        if (message.mergingConfigPresetId != null && message.hasOwnProperty("mergingConfigPresetId"))
                            if (typeof message.mergingConfigPresetId === "number")
                                object.mergingConfigPresetId = options.longs === String ? String(message.mergingConfigPresetId) : message.mergingConfigPresetId;
                            else
                                object.mergingConfigPresetId = options.longs === String ? $util.Long.prototype.toString.call(message.mergingConfigPresetId) : options.longs === Number ? new $util.LongBits(message.mergingConfigPresetId.low >>> 0, message.mergingConfigPresetId.high >>> 0).toNumber() : message.mergingConfigPresetId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteMergingConfigPresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteMergingConfigPresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteMergingConfigPresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteMergingConfigPresetRequest;
                })();
    
                v1.DeleteStoreConfigItemRequest = (function() {
    
                    /**
                     * Properties of a DeleteStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStoreConfigItemRequest
                     * @property {string|null} [name] DeleteStoreConfigItemRequest name
                     */
    
                    /**
                     * Constructs a new DeleteStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStoreConfigItemRequest.
                     * @implements IDeleteStoreConfigItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest=} [properties] Properties to set
                     */
                    function DeleteStoreConfigItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStoreConfigItemRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @instance
                     */
                    DeleteStoreConfigItemRequest.prototype.name = "";
    
                    /**
                     * Creates a new DeleteStoreConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStoreConfigItemRequest} DeleteStoreConfigItemRequest instance
                     */
                    DeleteStoreConfigItemRequest.create = function create(properties) {
                        return new DeleteStoreConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStoreConfigItemRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStoreConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest} message DeleteStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStoreConfigItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStoreConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreConfigItemRequest} message DeleteStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStoreConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStoreConfigItemRequest} DeleteStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStoreConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStoreConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStoreConfigItemRequest} DeleteStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStoreConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStoreConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStoreConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStoreConfigItemRequest} DeleteStoreConfigItemRequest
                     */
                    DeleteStoreConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStoreConfigItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStoreConfigItemRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStoreConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStoreConfigItemRequest} message DeleteStoreConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStoreConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStoreConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStoreConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStoreConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStoreConfigItemRequest;
                })();
    
                v1.CreateStoreConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStoreConfigRequest
                     * @property {palexy.streaming.v1.IStoreConfig|null} [storeConfig] CreateStoreConfigRequest storeConfig
                     */
    
                    /**
                     * Constructs a new CreateStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStoreConfigRequest.
                     * @implements ICreateStoreConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest=} [properties] Properties to set
                     */
                    function CreateStoreConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStoreConfigRequest storeConfig.
                     * @member {palexy.streaming.v1.IStoreConfig|null|undefined} storeConfig
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @instance
                     */
                    CreateStoreConfigRequest.prototype.storeConfig = null;
    
                    /**
                     * Creates a new CreateStoreConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStoreConfigRequest} CreateStoreConfigRequest instance
                     */
                    CreateStoreConfigRequest.create = function create(properties) {
                        return new CreateStoreConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStoreConfigRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStoreConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest} message CreateStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfig != null && Object.hasOwnProperty.call(message, "storeConfig"))
                            $root.palexy.streaming.v1.StoreConfig.encode(message.storeConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStoreConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStoreConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigRequest} message CreateStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStoreConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStoreConfigRequest} CreateStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStoreConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfig = $root.palexy.streaming.v1.StoreConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStoreConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStoreConfigRequest} CreateStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStoreConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStoreConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfig != null && message.hasOwnProperty("storeConfig")) {
                            var error = $root.palexy.streaming.v1.StoreConfig.verify(message.storeConfig);
                            if (error)
                                return "storeConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStoreConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStoreConfigRequest} CreateStoreConfigRequest
                     */
                    CreateStoreConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStoreConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStoreConfigRequest();
                        if (object.storeConfig != null) {
                            if (typeof object.storeConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreConfigRequest.storeConfig: object expected");
                            message.storeConfig = $root.palexy.streaming.v1.StoreConfig.fromObject(object.storeConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStoreConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStoreConfigRequest} message CreateStoreConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStoreConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.storeConfig = null;
                        if (message.storeConfig != null && message.hasOwnProperty("storeConfig"))
                            object.storeConfig = $root.palexy.streaming.v1.StoreConfig.toObject(message.storeConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStoreConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStoreConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStoreConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStoreConfigRequest;
                })();
    
                v1.ListStoreConfigsRequest = (function() {
    
                    /**
                     * Properties of a ListStoreConfigsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreConfigsRequest
                     * @property {string|null} [cameraId] ListStoreConfigsRequest cameraId
                     * @property {string|null} [storeNameSearchValue] ListStoreConfigsRequest storeNameSearchValue
                     * @property {string|null} [pageToken] ListStoreConfigsRequest pageToken
                     * @property {number|null} [pageSize] ListStoreConfigsRequest pageSize
                     */
    
                    /**
                     * Constructs a new ListStoreConfigsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreConfigsRequest.
                     * @implements IListStoreConfigsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest=} [properties] Properties to set
                     */
                    function ListStoreConfigsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreConfigsRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @instance
                     */
                    ListStoreConfigsRequest.prototype.cameraId = "";
    
                    /**
                     * ListStoreConfigsRequest storeNameSearchValue.
                     * @member {string} storeNameSearchValue
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @instance
                     */
                    ListStoreConfigsRequest.prototype.storeNameSearchValue = "";
    
                    /**
                     * ListStoreConfigsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @instance
                     */
                    ListStoreConfigsRequest.prototype.pageToken = "";
    
                    /**
                     * ListStoreConfigsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @instance
                     */
                    ListStoreConfigsRequest.prototype.pageSize = 0;
    
                    /**
                     * Creates a new ListStoreConfigsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreConfigsRequest} ListStoreConfigsRequest instance
                     */
                    ListStoreConfigsRequest.create = function create(properties) {
                        return new ListStoreConfigsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest} message ListStoreConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.storeNameSearchValue != null && Object.hasOwnProperty.call(message, "storeNameSearchValue"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeNameSearchValue);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsRequest} message ListStoreConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreConfigsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreConfigsRequest} ListStoreConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreConfigsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.storeNameSearchValue = reader.string();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreConfigsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreConfigsRequest} ListStoreConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreConfigsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreConfigsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.storeNameSearchValue != null && message.hasOwnProperty("storeNameSearchValue"))
                            if (!$util.isString(message.storeNameSearchValue))
                                return "storeNameSearchValue: string expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreConfigsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreConfigsRequest} ListStoreConfigsRequest
                     */
                    ListStoreConfigsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreConfigsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreConfigsRequest();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.storeNameSearchValue != null)
                            message.storeNameSearchValue = String(object.storeNameSearchValue);
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreConfigsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreConfigsRequest} message ListStoreConfigsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreConfigsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraId = "";
                            object.storeNameSearchValue = "";
                            object.pageToken = "";
                            object.pageSize = 0;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.storeNameSearchValue != null && message.hasOwnProperty("storeNameSearchValue"))
                            object.storeNameSearchValue = message.storeNameSearchValue;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreConfigsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreConfigsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreConfigsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreConfigsRequest;
                })();
    
                v1.ListStoreConfigsResponse = (function() {
    
                    /**
                     * Properties of a ListStoreConfigsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreConfigsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreConfig>|null} [storeConfigs] ListStoreConfigsResponse storeConfigs
                     * @property {number|null} [totalElements] ListStoreConfigsResponse totalElements
                     * @property {string|null} [nextPageToken] ListStoreConfigsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListStoreConfigsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreConfigsResponse.
                     * @implements IListStoreConfigsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreConfigsResponse=} [properties] Properties to set
                     */
                    function ListStoreConfigsResponse(properties) {
                        this.storeConfigs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreConfigsResponse storeConfigs.
                     * @member {Array.<palexy.streaming.v1.IStoreConfig>} storeConfigs
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @instance
                     */
                    ListStoreConfigsResponse.prototype.storeConfigs = $util.emptyArray;
    
                    /**
                     * ListStoreConfigsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @instance
                     */
                    ListStoreConfigsResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreConfigsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @instance
                     */
                    ListStoreConfigsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListStoreConfigsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreConfigsResponse} ListStoreConfigsResponse instance
                     */
                    ListStoreConfigsResponse.create = function create(properties) {
                        return new ListStoreConfigsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsResponse} message ListStoreConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigs != null && message.storeConfigs.length)
                            for (var i = 0; i < message.storeConfigs.length; ++i)
                                $root.palexy.streaming.v1.StoreConfig.encode(message.storeConfigs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigsResponse} message ListStoreConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreConfigsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreConfigsResponse} ListStoreConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreConfigsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeConfigs && message.storeConfigs.length))
                                    message.storeConfigs = [];
                                message.storeConfigs.push($root.palexy.streaming.v1.StoreConfig.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreConfigsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreConfigsResponse} ListStoreConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreConfigsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreConfigsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigs != null && message.hasOwnProperty("storeConfigs")) {
                            if (!Array.isArray(message.storeConfigs))
                                return "storeConfigs: array expected";
                            for (var i = 0; i < message.storeConfigs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreConfig.verify(message.storeConfigs[i]);
                                if (error)
                                    return "storeConfigs." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreConfigsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreConfigsResponse} ListStoreConfigsResponse
                     */
                    ListStoreConfigsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreConfigsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreConfigsResponse();
                        if (object.storeConfigs) {
                            if (!Array.isArray(object.storeConfigs))
                                throw TypeError(".palexy.streaming.v1.ListStoreConfigsResponse.storeConfigs: array expected");
                            message.storeConfigs = [];
                            for (var i = 0; i < object.storeConfigs.length; ++i) {
                                if (typeof object.storeConfigs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreConfigsResponse.storeConfigs: object expected");
                                message.storeConfigs[i] = $root.palexy.streaming.v1.StoreConfig.fromObject(object.storeConfigs[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreConfigsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreConfigsResponse} message ListStoreConfigsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreConfigsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeConfigs = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.storeConfigs && message.storeConfigs.length) {
                            object.storeConfigs = [];
                            for (var j = 0; j < message.storeConfigs.length; ++j)
                                object.storeConfigs[j] = $root.palexy.streaming.v1.StoreConfig.toObject(message.storeConfigs[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreConfigsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreConfigsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreConfigsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreConfigsResponse;
                })();
    
                v1.GetStoreConfigRequest = (function() {
    
                    /**
                     * Properties of a GetStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreConfigRequest
                     * @property {string|null} [name] GetStoreConfigRequest name
                     */
    
                    /**
                     * Constructs a new GetStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreConfigRequest.
                     * @implements IGetStoreConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest=} [properties] Properties to set
                     */
                    function GetStoreConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreConfigRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @instance
                     */
                    GetStoreConfigRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetStoreConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreConfigRequest} GetStoreConfigRequest instance
                     */
                    GetStoreConfigRequest.create = function create(properties) {
                        return new GetStoreConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreConfigRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest} message GetStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigRequest} message GetStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreConfigRequest} GetStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreConfigRequest} GetStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreConfigRequest} GetStoreConfigRequest
                     */
                    GetStoreConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreConfigRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreConfigRequest} message GetStoreConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreConfigRequest;
                })();
    
                v1.UpdateStoreConfigRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreConfigRequest
                     * @property {palexy.streaming.v1.IStoreConfig|null} [storeConfig] UpdateStoreConfigRequest storeConfig
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreConfigRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreConfigRequest.
                     * @implements IUpdateStoreConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest=} [properties] Properties to set
                     */
                    function UpdateStoreConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreConfigRequest storeConfig.
                     * @member {palexy.streaming.v1.IStoreConfig|null|undefined} storeConfig
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @instance
                     */
                    UpdateStoreConfigRequest.prototype.storeConfig = null;
    
                    /**
                     * UpdateStoreConfigRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @instance
                     */
                    UpdateStoreConfigRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreConfigRequest} UpdateStoreConfigRequest instance
                     */
                    UpdateStoreConfigRequest.create = function create(properties) {
                        return new UpdateStoreConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreConfigRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest} message UpdateStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfig != null && Object.hasOwnProperty.call(message, "storeConfig"))
                            $root.palexy.streaming.v1.StoreConfig.encode(message.storeConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigRequest} message UpdateStoreConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreConfigRequest} UpdateStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfig = $root.palexy.streaming.v1.StoreConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreConfigRequest} UpdateStoreConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfig != null && message.hasOwnProperty("storeConfig")) {
                            var error = $root.palexy.streaming.v1.StoreConfig.verify(message.storeConfig);
                            if (error)
                                return "storeConfig." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreConfigRequest} UpdateStoreConfigRequest
                     */
                    UpdateStoreConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreConfigRequest();
                        if (object.storeConfig != null) {
                            if (typeof object.storeConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreConfigRequest.storeConfig: object expected");
                            message.storeConfig = $root.palexy.streaming.v1.StoreConfig.fromObject(object.storeConfig);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreConfigRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreConfigRequest} message UpdateStoreConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeConfig = null;
                            object.updateMask = null;
                        }
                        if (message.storeConfig != null && message.hasOwnProperty("storeConfig"))
                            object.storeConfig = $root.palexy.streaming.v1.StoreConfig.toObject(message.storeConfig, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreConfigRequest;
                })();
    
                v1.CreateStoreConfigItemRequest = (function() {
    
                    /**
                     * Properties of a CreateStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStoreConfigItemRequest
                     * @property {string|null} [parent] CreateStoreConfigItemRequest parent
                     * @property {palexy.streaming.v1.IStoreConfigItem|null} [storeConfigItem] CreateStoreConfigItemRequest storeConfigItem
                     */
    
                    /**
                     * Constructs a new CreateStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStoreConfigItemRequest.
                     * @implements ICreateStoreConfigItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest=} [properties] Properties to set
                     */
                    function CreateStoreConfigItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStoreConfigItemRequest parent.
                     * @member {string} parent
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @instance
                     */
                    CreateStoreConfigItemRequest.prototype.parent = "";
    
                    /**
                     * CreateStoreConfigItemRequest storeConfigItem.
                     * @member {palexy.streaming.v1.IStoreConfigItem|null|undefined} storeConfigItem
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @instance
                     */
                    CreateStoreConfigItemRequest.prototype.storeConfigItem = null;
    
                    /**
                     * Creates a new CreateStoreConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStoreConfigItemRequest} CreateStoreConfigItemRequest instance
                     */
                    CreateStoreConfigItemRequest.create = function create(properties) {
                        return new CreateStoreConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStoreConfigItemRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStoreConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest} message CreateStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                        if (message.storeConfigItem != null && Object.hasOwnProperty.call(message, "storeConfigItem"))
                            $root.palexy.streaming.v1.StoreConfigItem.encode(message.storeConfigItem, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStoreConfigItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStoreConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreConfigItemRequest} message CreateStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStoreConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStoreConfigItemRequest} CreateStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStoreConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.parent = reader.string();
                                break;
                            case 2:
                                message.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStoreConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStoreConfigItemRequest} CreateStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStoreConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStoreConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            if (!$util.isString(message.parent))
                                return "parent: string expected";
                        if (message.storeConfigItem != null && message.hasOwnProperty("storeConfigItem")) {
                            var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.storeConfigItem);
                            if (error)
                                return "storeConfigItem." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStoreConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStoreConfigItemRequest} CreateStoreConfigItemRequest
                     */
                    CreateStoreConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStoreConfigItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStoreConfigItemRequest();
                        if (object.parent != null)
                            message.parent = String(object.parent);
                        if (object.storeConfigItem != null) {
                            if (typeof object.storeConfigItem !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreConfigItemRequest.storeConfigItem: object expected");
                            message.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.storeConfigItem);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStoreConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStoreConfigItemRequest} message CreateStoreConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStoreConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.parent = "";
                            object.storeConfigItem = null;
                        }
                        if (message.parent != null && message.hasOwnProperty("parent"))
                            object.parent = message.parent;
                        if (message.storeConfigItem != null && message.hasOwnProperty("storeConfigItem"))
                            object.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.storeConfigItem, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStoreConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStoreConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStoreConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStoreConfigItemRequest;
                })();
    
                v1.ListStoreConfigItemsRequest = (function() {
    
                    /**
                     * Properties of a ListStoreConfigItemsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreConfigItemsRequest
                     * @property {string|null} [parent] ListStoreConfigItemsRequest parent
                     * @property {number|null} [storeId] ListStoreConfigItemsRequest storeId
                     * @property {palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope|null} [appliedScope] ListStoreConfigItemsRequest appliedScope
                     */
    
                    /**
                     * Constructs a new ListStoreConfigItemsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreConfigItemsRequest.
                     * @implements IListStoreConfigItemsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest=} [properties] Properties to set
                     */
                    function ListStoreConfigItemsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreConfigItemsRequest parent.
                     * @member {string|null|undefined} parent
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @instance
                     */
                    ListStoreConfigItemsRequest.prototype.parent = null;
    
                    /**
                     * ListStoreConfigItemsRequest storeId.
                     * @member {number|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @instance
                     */
                    ListStoreConfigItemsRequest.prototype.storeId = null;
    
                    /**
                     * ListStoreConfigItemsRequest appliedScope.
                     * @member {palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope} appliedScope
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @instance
                     */
                    ListStoreConfigItemsRequest.prototype.appliedScope = 0;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ListStoreConfigItemsRequest filter.
                     * @member {"parent"|"storeId"|undefined} filter
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @instance
                     */
                    Object.defineProperty(ListStoreConfigItemsRequest.prototype, "filter", {
                        get: $util.oneOfGetter($oneOfFields = ["parent", "storeId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ListStoreConfigItemsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsRequest} ListStoreConfigItemsRequest instance
                     */
                    ListStoreConfigItemsRequest.create = function create(properties) {
                        return new ListStoreConfigItemsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigItemsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigItemsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest} message ListStoreConfigItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigItemsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.parent != null && Object.hasOwnProperty.call(message, "parent"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.parent);
                        if (message.appliedScope != null && Object.hasOwnProperty.call(message, "appliedScope"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.appliedScope);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigItemsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigItemsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsRequest} message ListStoreConfigItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigItemsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreConfigItemsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsRequest} ListStoreConfigItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigItemsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreConfigItemsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.parent = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.appliedScope = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreConfigItemsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsRequest} ListStoreConfigItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigItemsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreConfigItemsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreConfigItemsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.parent != null && message.hasOwnProperty("parent")) {
                            properties.filter = 1;
                            if (!$util.isString(message.parent))
                                return "parent: string expected";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (properties.filter === 1)
                                return "filter: multiple values";
                            properties.filter = 1;
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        }
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            switch (message.appliedScope) {
                            default:
                                return "appliedScope: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreConfigItemsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsRequest} ListStoreConfigItemsRequest
                     */
                    ListStoreConfigItemsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreConfigItemsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreConfigItemsRequest();
                        if (object.parent != null)
                            message.parent = String(object.parent);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        switch (object.appliedScope) {
                        case "UNKNOWN_SCOPE":
                        case 0:
                            message.appliedScope = 0;
                            break;
                        case "PRODUCTION":
                        case 1:
                            message.appliedScope = 1;
                            break;
                        case "EXPERIMENT":
                        case 2:
                            message.appliedScope = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreConfigItemsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreConfigItemsRequest} message ListStoreConfigItemsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreConfigItemsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.appliedScope = options.enums === String ? "UNKNOWN_SCOPE" : 0;
                        if (message.parent != null && message.hasOwnProperty("parent")) {
                            object.parent = message.parent;
                            if (options.oneofs)
                                object.filter = "parent";
                        }
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            object.appliedScope = options.enums === String ? $root.palexy.streaming.v1.StoreConfigItem.StoreConfigAppliedScope[message.appliedScope] : message.appliedScope;
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (options.oneofs)
                                object.filter = "storeId";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreConfigItemsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreConfigItemsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreConfigItemsRequest;
                })();
    
                v1.ListStoreConfigItemsResponse = (function() {
    
                    /**
                     * Properties of a ListStoreConfigItemsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreConfigItemsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreConfigItem>|null} [storeConfigItem] ListStoreConfigItemsResponse storeConfigItem
                     */
    
                    /**
                     * Constructs a new ListStoreConfigItemsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreConfigItemsResponse.
                     * @implements IListStoreConfigItemsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreConfigItemsResponse=} [properties] Properties to set
                     */
                    function ListStoreConfigItemsResponse(properties) {
                        this.storeConfigItem = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreConfigItemsResponse storeConfigItem.
                     * @member {Array.<palexy.streaming.v1.IStoreConfigItem>} storeConfigItem
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @instance
                     */
                    ListStoreConfigItemsResponse.prototype.storeConfigItem = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreConfigItemsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsResponse} ListStoreConfigItemsResponse instance
                     */
                    ListStoreConfigItemsResponse.create = function create(properties) {
                        return new ListStoreConfigItemsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigItemsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigItemsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsResponse} message ListStoreConfigItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigItemsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigItem != null && message.storeConfigItem.length)
                            for (var i = 0; i < message.storeConfigItem.length; ++i)
                                $root.palexy.streaming.v1.StoreConfigItem.encode(message.storeConfigItem[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreConfigItemsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreConfigItemsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreConfigItemsResponse} message ListStoreConfigItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreConfigItemsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreConfigItemsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsResponse} ListStoreConfigItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigItemsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreConfigItemsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeConfigItem && message.storeConfigItem.length))
                                    message.storeConfigItem = [];
                                message.storeConfigItem.push($root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreConfigItemsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsResponse} ListStoreConfigItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreConfigItemsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreConfigItemsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreConfigItemsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigItem != null && message.hasOwnProperty("storeConfigItem")) {
                            if (!Array.isArray(message.storeConfigItem))
                                return "storeConfigItem: array expected";
                            for (var i = 0; i < message.storeConfigItem.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.storeConfigItem[i]);
                                if (error)
                                    return "storeConfigItem." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreConfigItemsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreConfigItemsResponse} ListStoreConfigItemsResponse
                     */
                    ListStoreConfigItemsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreConfigItemsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreConfigItemsResponse();
                        if (object.storeConfigItem) {
                            if (!Array.isArray(object.storeConfigItem))
                                throw TypeError(".palexy.streaming.v1.ListStoreConfigItemsResponse.storeConfigItem: array expected");
                            message.storeConfigItem = [];
                            for (var i = 0; i < object.storeConfigItem.length; ++i) {
                                if (typeof object.storeConfigItem[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreConfigItemsResponse.storeConfigItem: object expected");
                                message.storeConfigItem[i] = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.storeConfigItem[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreConfigItemsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreConfigItemsResponse} message ListStoreConfigItemsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreConfigItemsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeConfigItem = [];
                        if (message.storeConfigItem && message.storeConfigItem.length) {
                            object.storeConfigItem = [];
                            for (var j = 0; j < message.storeConfigItem.length; ++j)
                                object.storeConfigItem[j] = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.storeConfigItem[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreConfigItemsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreConfigItemsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreConfigItemsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreConfigItemsResponse;
                })();
    
                v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest = (function() {
    
                    /**
                     * Properties of a FindProductionStoreConfigItemByCameraIdAndDateIdRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @property {string|null} [cameraId] FindProductionStoreConfigItemByCameraIdAndDateIdRequest cameraId
                     * @property {string|null} [dateId] FindProductionStoreConfigItemByCameraIdAndDateIdRequest dateId
                     */
    
                    /**
                     * Constructs a new FindProductionStoreConfigItemByCameraIdAndDateIdRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindProductionStoreConfigItemByCameraIdAndDateIdRequest.
                     * @implements IFindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest=} [properties] Properties to set
                     */
                    function FindProductionStoreConfigItemByCameraIdAndDateIdRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindProductionStoreConfigItemByCameraIdAndDateIdRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @instance
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.prototype.cameraId = "";
    
                    /**
                     * FindProductionStoreConfigItemByCameraIdAndDateIdRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @instance
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new FindProductionStoreConfigItemByCameraIdAndDateIdRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest} FindProductionStoreConfigItemByCameraIdAndDateIdRequest instance
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.create = function create(properties) {
                        return new FindProductionStoreConfigItemByCameraIdAndDateIdRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindProductionStoreConfigItemByCameraIdAndDateIdRequest message. Does not implicitly {@link palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest} message FindProductionStoreConfigItemByCameraIdAndDateIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindProductionStoreConfigItemByCameraIdAndDateIdRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByCameraIdAndDateIdRequest} message FindProductionStoreConfigItemByCameraIdAndDateIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindProductionStoreConfigItemByCameraIdAndDateIdRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest} FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindProductionStoreConfigItemByCameraIdAndDateIdRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest} FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindProductionStoreConfigItemByCameraIdAndDateIdRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindProductionStoreConfigItemByCameraIdAndDateIdRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest} FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindProductionStoreConfigItemByCameraIdAndDateIdRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest} message FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraId = "";
                            object.dateId = "";
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this FindProductionStoreConfigItemByCameraIdAndDateIdRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByCameraIdAndDateIdRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindProductionStoreConfigItemByCameraIdAndDateIdRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindProductionStoreConfigItemByCameraIdAndDateIdRequest;
                })();
    
                v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest = (function() {
    
                    /**
                     * Properties of a FindProductionStoreConfigItemByStoreIdAndDateIdRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @property {number|null} [storeId] FindProductionStoreConfigItemByStoreIdAndDateIdRequest storeId
                     * @property {string|null} [dateId] FindProductionStoreConfigItemByStoreIdAndDateIdRequest dateId
                     */
    
                    /**
                     * Constructs a new FindProductionStoreConfigItemByStoreIdAndDateIdRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindProductionStoreConfigItemByStoreIdAndDateIdRequest.
                     * @implements IFindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest=} [properties] Properties to set
                     */
                    function FindProductionStoreConfigItemByStoreIdAndDateIdRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindProductionStoreConfigItemByStoreIdAndDateIdRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @instance
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FindProductionStoreConfigItemByStoreIdAndDateIdRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @instance
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new FindProductionStoreConfigItemByStoreIdAndDateIdRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest} FindProductionStoreConfigItemByStoreIdAndDateIdRequest instance
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.create = function create(properties) {
                        return new FindProductionStoreConfigItemByStoreIdAndDateIdRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindProductionStoreConfigItemByStoreIdAndDateIdRequest message. Does not implicitly {@link palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest} message FindProductionStoreConfigItemByStoreIdAndDateIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindProductionStoreConfigItemByStoreIdAndDateIdRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindProductionStoreConfigItemByStoreIdAndDateIdRequest} message FindProductionStoreConfigItemByStoreIdAndDateIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindProductionStoreConfigItemByStoreIdAndDateIdRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest} FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindProductionStoreConfigItemByStoreIdAndDateIdRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest} FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindProductionStoreConfigItemByStoreIdAndDateIdRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindProductionStoreConfigItemByStoreIdAndDateIdRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest} FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindProductionStoreConfigItemByStoreIdAndDateIdRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @static
                     * @param {palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest} message FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this FindProductionStoreConfigItemByStoreIdAndDateIdRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindProductionStoreConfigItemByStoreIdAndDateIdRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindProductionStoreConfigItemByStoreIdAndDateIdRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindProductionStoreConfigItemByStoreIdAndDateIdRequest;
                })();
    
                v1.GetStoreConfigItemRequest = (function() {
    
                    /**
                     * Properties of a GetStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreConfigItemRequest
                     * @property {string|null} [name] GetStoreConfigItemRequest name
                     */
    
                    /**
                     * Constructs a new GetStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreConfigItemRequest.
                     * @implements IGetStoreConfigItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest=} [properties] Properties to set
                     */
                    function GetStoreConfigItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreConfigItemRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @instance
                     */
                    GetStoreConfigItemRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetStoreConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreConfigItemRequest} GetStoreConfigItemRequest instance
                     */
                    GetStoreConfigItemRequest.create = function create(properties) {
                        return new GetStoreConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreConfigItemRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest} message GetStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreConfigItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreConfigItemRequest} message GetStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreConfigItemRequest} GetStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreConfigItemRequest} GetStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreConfigItemRequest} GetStoreConfigItemRequest
                     */
                    GetStoreConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreConfigItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreConfigItemRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreConfigItemRequest} message GetStoreConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreConfigItemRequest;
                })();
    
                v1.UpdateStoreConfigItemRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreConfigItemRequest
                     * @property {palexy.streaming.v1.IStoreConfigItem|null} [storeConfigItem] UpdateStoreConfigItemRequest storeConfigItem
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreConfigItemRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreConfigItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreConfigItemRequest.
                     * @implements IUpdateStoreConfigItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest=} [properties] Properties to set
                     */
                    function UpdateStoreConfigItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreConfigItemRequest storeConfigItem.
                     * @member {palexy.streaming.v1.IStoreConfigItem|null|undefined} storeConfigItem
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @instance
                     */
                    UpdateStoreConfigItemRequest.prototype.storeConfigItem = null;
    
                    /**
                     * UpdateStoreConfigItemRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @instance
                     */
                    UpdateStoreConfigItemRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreConfigItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreConfigItemRequest} UpdateStoreConfigItemRequest instance
                     */
                    UpdateStoreConfigItemRequest.create = function create(properties) {
                        return new UpdateStoreConfigItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreConfigItemRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreConfigItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest} message UpdateStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreConfigItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeConfigItem != null && Object.hasOwnProperty.call(message, "storeConfigItem"))
                            $root.palexy.streaming.v1.StoreConfigItem.encode(message.storeConfigItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreConfigItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreConfigItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreConfigItemRequest} message UpdateStoreConfigItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreConfigItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreConfigItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreConfigItemRequest} UpdateStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreConfigItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreConfigItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreConfigItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreConfigItemRequest} UpdateStoreConfigItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreConfigItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreConfigItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreConfigItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeConfigItem != null && message.hasOwnProperty("storeConfigItem")) {
                            var error = $root.palexy.streaming.v1.StoreConfigItem.verify(message.storeConfigItem);
                            if (error)
                                return "storeConfigItem." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreConfigItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreConfigItemRequest} UpdateStoreConfigItemRequest
                     */
                    UpdateStoreConfigItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreConfigItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreConfigItemRequest();
                        if (object.storeConfigItem != null) {
                            if (typeof object.storeConfigItem !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreConfigItemRequest.storeConfigItem: object expected");
                            message.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.fromObject(object.storeConfigItem);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreConfigItemRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreConfigItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreConfigItemRequest} message UpdateStoreConfigItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreConfigItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeConfigItem = null;
                            object.updateMask = null;
                        }
                        if (message.storeConfigItem != null && message.hasOwnProperty("storeConfigItem"))
                            object.storeConfigItem = $root.palexy.streaming.v1.StoreConfigItem.toObject(message.storeConfigItem, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreConfigItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreConfigItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreConfigItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreConfigItemRequest;
                })();
    
                v1.UpdateStoreRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreRequest
                     * @property {string|null} [name] UpdateStoreRequest name
                     * @property {palexy.streaming.v1.IStore|null} [store] UpdateStoreRequest store
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreRequest.
                     * @implements IUpdateStoreRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreRequest=} [properties] Properties to set
                     */
                    function UpdateStoreRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @instance
                     */
                    UpdateStoreRequest.prototype.name = "";
    
                    /**
                     * UpdateStoreRequest store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @instance
                     */
                    UpdateStoreRequest.prototype.store = null;
    
                    /**
                     * UpdateStoreRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @instance
                     */
                    UpdateStoreRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreRequest} UpdateStoreRequest instance
                     */
                    UpdateStoreRequest.create = function create(properties) {
                        return new UpdateStoreRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreRequest} message UpdateStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreRequest} message UpdateStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreRequest} UpdateStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreRequest} UpdateStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreRequest} UpdateStoreRequest
                     */
                    UpdateStoreRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreRequest.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreRequest} message UpdateStoreRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.store = null;
                            object.updateMask = null;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreRequest;
                })();
    
                v1.StoreService = (function() {
    
                    /**
                     * Constructs a new StoreService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreService;
    
                    /**
                     * Creates new StoreService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#getStore}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef GetStoreCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Store} [response] Store
                     */
    
                    /**
                     * Calls GetStore.
                     * @function getStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreRequest} request GetStoreRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.GetStoreCallback} callback Node-style callback called with the error, if any, and Store
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.getStore = function getStore(request, callback) {
                        return this.rpcCall(getStore, $root.palexy.streaming.v1.GetStoreRequest, $root.palexy.streaming.v1.Store, request, callback);
                    }, "name", { value: "GetStore" });
    
                    /**
                     * Calls GetStore.
                     * @function getStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreRequest} request GetStoreRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Store>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#listStores}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ListStoresCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoresResponse} [response] ListStoresResponse
                     */
    
                    /**
                     * Calls ListStores.
                     * @function listStores
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresRequest} request ListStoresRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ListStoresCallback} callback Node-style callback called with the error, if any, and ListStoresResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.listStores = function listStores(request, callback) {
                        return this.rpcCall(listStores, $root.palexy.streaming.v1.ListStoresRequest, $root.palexy.streaming.v1.ListStoresResponse, request, callback);
                    }, "name", { value: "ListStores" });
    
                    /**
                     * Calls ListStores.
                     * @function listStores
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresRequest} request ListStoresRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoresResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#updateStore}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef UpdateStoreCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Store} [response] Store
                     */
    
                    /**
                     * Calls UpdateStore.
                     * @function updateStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreRequest} request UpdateStoreRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.UpdateStoreCallback} callback Node-style callback called with the error, if any, and Store
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.updateStore = function updateStore(request, callback) {
                        return this.rpcCall(updateStore, $root.palexy.streaming.v1.UpdateStoreRequest, $root.palexy.streaming.v1.Store, request, callback);
                    }, "name", { value: "UpdateStore" });
    
                    /**
                     * Calls UpdateStore.
                     * @function updateStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreRequest} request UpdateStoreRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Store>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#listStoresForTrend}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ListStoresForTrendCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoresResponse} [response] ListStoresResponse
                     */
    
                    /**
                     * Calls ListStoresForTrend.
                     * @function listStoresForTrend
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest} request ListStoresForTrendRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ListStoresForTrendCallback} callback Node-style callback called with the error, if any, and ListStoresResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.listStoresForTrend = function listStoresForTrend(request, callback) {
                        return this.rpcCall(listStoresForTrend, $root.palexy.streaming.v1.ListStoresForTrendRequest, $root.palexy.streaming.v1.ListStoresResponse, request, callback);
                    }, "name", { value: "ListStoresForTrend" });
    
                    /**
                     * Calls ListStoresForTrend.
                     * @function listStoresForTrend
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest} request ListStoresForTrendRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoresResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#rerunMerging}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef RerunMergingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RerunMergingResponse} [response] RerunMergingResponse
                     */
    
                    /**
                     * Calls RerunMerging.
                     * @function rerunMerging
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IRerunMergingRequest} request RerunMergingRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.RerunMergingCallback} callback Node-style callback called with the error, if any, and RerunMergingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.rerunMerging = function rerunMerging(request, callback) {
                        return this.rpcCall(rerunMerging, $root.palexy.streaming.v1.RerunMergingRequest, $root.palexy.streaming.v1.RerunMergingResponse, request, callback);
                    }, "name", { value: "RerunMerging" });
    
                    /**
                     * Calls RerunMerging.
                     * @function rerunMerging
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IRerunMergingRequest} request RerunMergingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RerunMergingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#rerunMergingForChildStore}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef RerunMergingForChildStoreCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RerunMergingForChildStoreResponse} [response] RerunMergingForChildStoreResponse
                     */
    
                    /**
                     * Calls RerunMergingForChildStore.
                     * @function rerunMergingForChildStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest} request RerunMergingForChildStoreRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.RerunMergingForChildStoreCallback} callback Node-style callback called with the error, if any, and RerunMergingForChildStoreResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.rerunMergingForChildStore = function rerunMergingForChildStore(request, callback) {
                        return this.rpcCall(rerunMergingForChildStore, $root.palexy.streaming.v1.RerunMergingForChildStoreRequest, $root.palexy.streaming.v1.RerunMergingForChildStoreResponse, request, callback);
                    }, "name", { value: "RerunMergingForChildStore" });
    
                    /**
                     * Calls RerunMergingForChildStore.
                     * @function rerunMergingForChildStore
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest} request RerunMergingForChildStoreRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RerunMergingForChildStoreResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#validateStoreForRerunMerging}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ValidateStoreForRerunMergingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ValidateStoreForRerunMerging.
                     * @function validateStoreForRerunMerging
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest} request ValidateStoreForRerunMergingRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ValidateStoreForRerunMergingCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.validateStoreForRerunMerging = function validateStoreForRerunMerging(request, callback) {
                        return this.rpcCall(validateStoreForRerunMerging, $root.palexy.streaming.v1.ValidateStoreForRerunMergingRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ValidateStoreForRerunMerging" });
    
                    /**
                     * Calls ValidateStoreForRerunMerging.
                     * @function validateStoreForRerunMerging
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest} request ValidateStoreForRerunMergingRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#listStoreProcessingStatuses}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ListStoreProcessingStatusesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreProcessingStatusesResponse} [response] ListStoreProcessingStatusesResponse
                     */
    
                    /**
                     * Calls ListStoreProcessingStatuses.
                     * @function listStoreProcessingStatuses
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest} request ListStoreProcessingStatusesRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ListStoreProcessingStatusesCallback} callback Node-style callback called with the error, if any, and ListStoreProcessingStatusesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.listStoreProcessingStatuses = function listStoreProcessingStatuses(request, callback) {
                        return this.rpcCall(listStoreProcessingStatuses, $root.palexy.streaming.v1.ListStoreProcessingStatusesRequest, $root.palexy.streaming.v1.ListStoreProcessingStatusesResponse, request, callback);
                    }, "name", { value: "ListStoreProcessingStatuses" });
    
                    /**
                     * Calls ListStoreProcessingStatuses.
                     * @function listStoreProcessingStatuses
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest} request ListStoreProcessingStatusesRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreProcessingStatusesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#getStoresForLateVideoChecking}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef GetStoresForLateVideoCheckingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} [response] GetStoresForLateVideoCheckingResponse
                     */
    
                    /**
                     * Calls GetStoresForLateVideoChecking.
                     * @function getStoresForLateVideoChecking
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest} request GetStoresForLateVideoCheckingRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.GetStoresForLateVideoCheckingCallback} callback Node-style callback called with the error, if any, and GetStoresForLateVideoCheckingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.getStoresForLateVideoChecking = function getStoresForLateVideoChecking(request, callback) {
                        return this.rpcCall(getStoresForLateVideoChecking, $root.palexy.streaming.v1.GetStoresForLateVideoCheckingRequest, $root.palexy.streaming.v1.GetStoresForLateVideoCheckingResponse, request, callback);
                    }, "name", { value: "GetStoresForLateVideoChecking" });
    
                    /**
                     * Calls GetStoresForLateVideoChecking.
                     * @function getStoresForLateVideoChecking
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest} request GetStoresForLateVideoCheckingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetStoresForLateVideoCheckingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#listStoresOfWeatherIntegrationEnabled}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ListStoresOfWeatherIntegrationEnabledCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoresResponse} [response] ListStoresResponse
                     */
    
                    /**
                     * Calls ListStoresOfWeatherIntegrationEnabled.
                     * @function listStoresOfWeatherIntegrationEnabled
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest} request ListStoresOfWeatherIntegrationEnabledRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ListStoresOfWeatherIntegrationEnabledCallback} callback Node-style callback called with the error, if any, and ListStoresResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.listStoresOfWeatherIntegrationEnabled = function listStoresOfWeatherIntegrationEnabled(request, callback) {
                        return this.rpcCall(listStoresOfWeatherIntegrationEnabled, $root.palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest, $root.palexy.streaming.v1.ListStoresResponse, request, callback);
                    }, "name", { value: "ListStoresOfWeatherIntegrationEnabled" });
    
                    /**
                     * Calls ListStoresOfWeatherIntegrationEnabled.
                     * @function listStoresOfWeatherIntegrationEnabled
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest} request ListStoresOfWeatherIntegrationEnabledRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoresResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#listStoresToAdjustScheduleBudgetPlanning}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef ListStoresToAdjustScheduleBudgetPlanningCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoresResponse} [response] ListStoresResponse
                     */
    
                    /**
                     * Calls ListStoresToAdjustScheduleBudgetPlanning.
                     * @function listStoresToAdjustScheduleBudgetPlanning
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest} request ListStoresToAdjustScheduleBudgetPlanningRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.ListStoresToAdjustScheduleBudgetPlanningCallback} callback Node-style callback called with the error, if any, and ListStoresResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.listStoresToAdjustScheduleBudgetPlanning = function listStoresToAdjustScheduleBudgetPlanning(request, callback) {
                        return this.rpcCall(listStoresToAdjustScheduleBudgetPlanning, $root.palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest, $root.palexy.streaming.v1.ListStoresResponse, request, callback);
                    }, "name", { value: "ListStoresToAdjustScheduleBudgetPlanning" });
    
                    /**
                     * Calls ListStoresToAdjustScheduleBudgetPlanning.
                     * @function listStoresToAdjustScheduleBudgetPlanning
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest} request ListStoresToAdjustScheduleBudgetPlanningRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoresResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreService#findPlaceId}.
                     * @memberof palexy.streaming.v1.StoreService
                     * @typedef FindPlaceIdCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FindPlaceIdResponse} [response] FindPlaceIdResponse
                     */
    
                    /**
                     * Calls FindPlaceId.
                     * @function findPlaceId
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest} request FindPlaceIdRequest message or plain object
                     * @param {palexy.streaming.v1.StoreService.FindPlaceIdCallback} callback Node-style callback called with the error, if any, and FindPlaceIdResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreService.prototype.findPlaceId = function findPlaceId(request, callback) {
                        return this.rpcCall(findPlaceId, $root.palexy.streaming.v1.FindPlaceIdRequest, $root.palexy.streaming.v1.FindPlaceIdResponse, request, callback);
                    }, "name", { value: "FindPlaceId" });
    
                    /**
                     * Calls FindPlaceId.
                     * @function findPlaceId
                     * @memberof palexy.streaming.v1.StoreService
                     * @instance
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest} request FindPlaceIdRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FindPlaceIdResponse>} Promise
                     * @variation 2
                     */
    
                    return StoreService;
                })();
    
                v1.FindPlaceIdRequest = (function() {
    
                    /**
                     * Properties of a FindPlaceIdRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFindPlaceIdRequest
                     * @property {number|null} [latitude] FindPlaceIdRequest latitude
                     * @property {number|null} [longitude] FindPlaceIdRequest longitude
                     */
    
                    /**
                     * Constructs a new FindPlaceIdRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindPlaceIdRequest.
                     * @implements IFindPlaceIdRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest=} [properties] Properties to set
                     */
                    function FindPlaceIdRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindPlaceIdRequest latitude.
                     * @member {number} latitude
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @instance
                     */
                    FindPlaceIdRequest.prototype.latitude = 0;
    
                    /**
                     * FindPlaceIdRequest longitude.
                     * @member {number} longitude
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @instance
                     */
                    FindPlaceIdRequest.prototype.longitude = 0;
    
                    /**
                     * Creates a new FindPlaceIdRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindPlaceIdRequest} FindPlaceIdRequest instance
                     */
                    FindPlaceIdRequest.create = function create(properties) {
                        return new FindPlaceIdRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindPlaceIdRequest message. Does not implicitly {@link palexy.streaming.v1.FindPlaceIdRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest} message FindPlaceIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPlaceIdRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.latitude != null && Object.hasOwnProperty.call(message, "latitude"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.latitude);
                        if (message.longitude != null && Object.hasOwnProperty.call(message, "longitude"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.longitude);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindPlaceIdRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindPlaceIdRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdRequest} message FindPlaceIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPlaceIdRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindPlaceIdRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindPlaceIdRequest} FindPlaceIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPlaceIdRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindPlaceIdRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.latitude = reader.double();
                                break;
                            case 2:
                                message.longitude = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindPlaceIdRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindPlaceIdRequest} FindPlaceIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPlaceIdRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindPlaceIdRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindPlaceIdRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            if (typeof message.latitude !== "number")
                                return "latitude: number expected";
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            if (typeof message.longitude !== "number")
                                return "longitude: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindPlaceIdRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindPlaceIdRequest} FindPlaceIdRequest
                     */
                    FindPlaceIdRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindPlaceIdRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindPlaceIdRequest();
                        if (object.latitude != null)
                            message.latitude = Number(object.latitude);
                        if (object.longitude != null)
                            message.longitude = Number(object.longitude);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindPlaceIdRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @static
                     * @param {palexy.streaming.v1.FindPlaceIdRequest} message FindPlaceIdRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindPlaceIdRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.latitude = 0;
                            object.longitude = 0;
                        }
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
                        return object;
                    };
    
                    /**
                     * Converts this FindPlaceIdRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindPlaceIdRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindPlaceIdRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindPlaceIdRequest;
                })();
    
                v1.FindPlaceIdResponse = (function() {
    
                    /**
                     * Properties of a FindPlaceIdResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFindPlaceIdResponse
                     * @property {string|null} [placeId] FindPlaceIdResponse placeId
                     */
    
                    /**
                     * Constructs a new FindPlaceIdResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindPlaceIdResponse.
                     * @implements IFindPlaceIdResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFindPlaceIdResponse=} [properties] Properties to set
                     */
                    function FindPlaceIdResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindPlaceIdResponse placeId.
                     * @member {string} placeId
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @instance
                     */
                    FindPlaceIdResponse.prototype.placeId = "";
    
                    /**
                     * Creates a new FindPlaceIdResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindPlaceIdResponse} FindPlaceIdResponse instance
                     */
                    FindPlaceIdResponse.create = function create(properties) {
                        return new FindPlaceIdResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FindPlaceIdResponse message. Does not implicitly {@link palexy.streaming.v1.FindPlaceIdResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdResponse} message FindPlaceIdResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPlaceIdResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.placeId != null && Object.hasOwnProperty.call(message, "placeId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.placeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindPlaceIdResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindPlaceIdResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindPlaceIdResponse} message FindPlaceIdResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPlaceIdResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindPlaceIdResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindPlaceIdResponse} FindPlaceIdResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPlaceIdResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindPlaceIdResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.placeId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindPlaceIdResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindPlaceIdResponse} FindPlaceIdResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPlaceIdResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindPlaceIdResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindPlaceIdResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.placeId != null && message.hasOwnProperty("placeId"))
                            if (!$util.isString(message.placeId))
                                return "placeId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindPlaceIdResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindPlaceIdResponse} FindPlaceIdResponse
                     */
                    FindPlaceIdResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindPlaceIdResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindPlaceIdResponse();
                        if (object.placeId != null)
                            message.placeId = String(object.placeId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindPlaceIdResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @static
                     * @param {palexy.streaming.v1.FindPlaceIdResponse} message FindPlaceIdResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindPlaceIdResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.placeId = "";
                        if (message.placeId != null && message.hasOwnProperty("placeId"))
                            object.placeId = message.placeId;
                        return object;
                    };
    
                    /**
                     * Converts this FindPlaceIdResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindPlaceIdResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindPlaceIdResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindPlaceIdResponse;
                })();
    
                v1.GeoCoordinate = (function() {
    
                    /**
                     * Properties of a GeoCoordinate.
                     * @memberof palexy.streaming.v1
                     * @interface IGeoCoordinate
                     * @property {number|null} [latitude] GeoCoordinate latitude
                     * @property {number|null} [longitude] GeoCoordinate longitude
                     */
    
                    /**
                     * Constructs a new GeoCoordinate.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GeoCoordinate.
                     * @implements IGeoCoordinate
                     * @constructor
                     * @param {palexy.streaming.v1.IGeoCoordinate=} [properties] Properties to set
                     */
                    function GeoCoordinate(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GeoCoordinate latitude.
                     * @member {number} latitude
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @instance
                     */
                    GeoCoordinate.prototype.latitude = 0;
    
                    /**
                     * GeoCoordinate longitude.
                     * @member {number} longitude
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @instance
                     */
                    GeoCoordinate.prototype.longitude = 0;
    
                    /**
                     * Creates a new GeoCoordinate instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {palexy.streaming.v1.IGeoCoordinate=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GeoCoordinate} GeoCoordinate instance
                     */
                    GeoCoordinate.create = function create(properties) {
                        return new GeoCoordinate(properties);
                    };
    
                    /**
                     * Encodes the specified GeoCoordinate message. Does not implicitly {@link palexy.streaming.v1.GeoCoordinate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {palexy.streaming.v1.IGeoCoordinate} message GeoCoordinate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeoCoordinate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.latitude != null && Object.hasOwnProperty.call(message, "latitude"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.latitude);
                        if (message.longitude != null && Object.hasOwnProperty.call(message, "longitude"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.longitude);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GeoCoordinate message, length delimited. Does not implicitly {@link palexy.streaming.v1.GeoCoordinate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {palexy.streaming.v1.IGeoCoordinate} message GeoCoordinate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GeoCoordinate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GeoCoordinate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GeoCoordinate} GeoCoordinate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeoCoordinate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GeoCoordinate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.latitude = reader.double();
                                break;
                            case 2:
                                message.longitude = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GeoCoordinate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GeoCoordinate} GeoCoordinate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GeoCoordinate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GeoCoordinate message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GeoCoordinate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            if (typeof message.latitude !== "number")
                                return "latitude: number expected";
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            if (typeof message.longitude !== "number")
                                return "longitude: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a GeoCoordinate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GeoCoordinate} GeoCoordinate
                     */
                    GeoCoordinate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GeoCoordinate)
                            return object;
                        var message = new $root.palexy.streaming.v1.GeoCoordinate();
                        if (object.latitude != null)
                            message.latitude = Number(object.latitude);
                        if (object.longitude != null)
                            message.longitude = Number(object.longitude);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GeoCoordinate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @static
                     * @param {palexy.streaming.v1.GeoCoordinate} message GeoCoordinate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GeoCoordinate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.latitude = 0;
                            object.longitude = 0;
                        }
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
                        return object;
                    };
    
                    /**
                     * Converts this GeoCoordinate to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GeoCoordinate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GeoCoordinate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GeoCoordinate;
                })();
    
                v1.Store = (function() {
    
                    /**
                     * Properties of a Store.
                     * @memberof palexy.streaming.v1
                     * @interface IStore
                     * @property {number|null} [id] Store id
                     * @property {string|null} [name] Store name
                     * @property {string|null} [displayName] Store displayName
                     * @property {number|null} [retentionDays] Store retentionDays
                     * @property {number|null} [ownerId] Store ownerId
                     * @property {palexy.streaming.v1.Store.StoreType|null} [storeType] Store storeType
                     * @property {string|null} [openTime] Store openTime
                     * @property {string|null} [closeTime] Store closeTime
                     * @property {number|null} [companyId] Store companyId
                     * @property {palexy.streaming.v1.ICompany|null} [company] Store company
                     * @property {number|null} [trackingRetentionDays] Store trackingRetentionDays
                     * @property {palexy.streaming.v1.IStoreIntegrationConfig|null} [storeIntegrationConfig] Store storeIntegrationConfig
                     * @property {Array.<palexy.streaming.v1.IArea>|null} [areas] Store areas
                     * @property {palexy.streaming.v1.Store.StoreState|null} [storeState] Store storeState
                     * @property {string|null} [timezone] Store timezone
                     * @property {palexy.streaming.v1.ICustomStreamingTime|null} [customStreamingTime] Store customStreamingTime
                     * @property {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null} [listWeekdayCustomStreamingTime] Store listWeekdayCustomStreamingTime
                     * @property {string|null} [mergeQueueName] Store mergeQueueName
                     * @property {Array.<palexy.streaming.v1.ITimeRange>|null} [breakTimes] Store breakTimes
                     * @property {palexy.streaming.v1.IGeoCoordinate|null} [geoCoordinate] Store geoCoordinate
                     * @property {palexy.streaming.v1.Store.CountingType|null} [countingType] Store countingType
                     * @property {string|null} [defaultStreamingLocation] Store defaultStreamingLocation
                     * @property {string|null} [code] Store code
                     * @property {string|null} [staffingStoreCode] Store staffingStoreCode
                     * @property {string|null} [inventoryCode] Store inventoryCode
                     * @property {string|null} [country] Store country
                     * @property {string|null} [locality] Store locality
                     * @property {string|null} [addressPrimary] Store addressPrimary
                     * @property {string|null} [adminArea] Store adminArea
                     * @property {number|null} [onTimeGreetingThresholdSec] Store onTimeGreetingThresholdSec
                     * @property {boolean|null} [externalTrafficCountingEnabled] Store externalTrafficCountingEnabled
                     * @property {Array.<palexy.store_issue.v1.StoreIssueType>|null} [disabledIssueTypes] Store disabledIssueTypes
                     * @property {palexy.streaming.v1.Store.RelationshipType|null} [relationshipType] Store relationshipType
                     * @property {number|null} [parentStoreId] Store parentStoreId
                     * @property {number|null} [minVisitorDwellTimeInSeconds] Store minVisitorDwellTimeInSeconds
                     * @property {google.protobuf.ITimestamp|null} [nextViewChangeDetectionTime] Store nextViewChangeDetectionTime
                     * @property {string|null} [viewChangeDetectionCronExpression] Store viewChangeDetectionCronExpression
                     * @property {string|null} [region] Store region
                     * @property {string|null} [subRegion] Store subRegion
                     * @property {number|null} [mallId] Store mallId
                     * @property {Array.<palexy.streaming.v1.ICamera>|null} [cameras] Store cameras
                     * @property {palexy.streaming.v1.IAutoSchedulePreference|null} [autoSchedulePreference] Store autoSchedulePreference
                     * @property {Array.<palexy.streaming.v1.IStoreMetadata>|null} [metadataValues] Store metadataValues
                     * @property {number|null} [staffScheduleDemandCoverageThreshold] Store staffScheduleDemandCoverageThreshold
                     * @property {number|null} [staffScheduleLowerDemandCoverageThreshold] Store staffScheduleLowerDemandCoverageThreshold
                     * @property {string|null} [placeId] Store placeId
                     * @property {string|null} [googleMapsLink] Store googleMapsLink
                     * @property {string|null} [staffOpenTime] Store staffOpenTime
                     * @property {string|null} [staffCloseTime] Store staffCloseTime
                     * @property {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null} [listWeekdayCustomStaffOperationTime] Store listWeekdayCustomStaffOperationTime
                     * @property {palexy.streaming.v1.Store.ChangingRoomCopyMode|null} [changingRoomCopyMode] Store changingRoomCopyMode
                     */
    
                    /**
                     * Constructs a new Store.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Store.
                     * @implements IStore
                     * @constructor
                     * @param {palexy.streaming.v1.IStore=} [properties] Properties to set
                     */
                    function Store(properties) {
                        this.areas = [];
                        this.breakTimes = [];
                        this.disabledIssueTypes = [];
                        this.cameras = [];
                        this.metadataValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Store id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Store name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.name = "";
    
                    /**
                     * Store displayName.
                     * @member {string} displayName
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.displayName = "";
    
                    /**
                     * Store retentionDays.
                     * @member {number} retentionDays
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.retentionDays = 0;
    
                    /**
                     * Store ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Store storeType.
                     * @member {palexy.streaming.v1.Store.StoreType} storeType
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.storeType = 0;
    
                    /**
                     * Store openTime.
                     * @member {string} openTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.openTime = "";
    
                    /**
                     * Store closeTime.
                     * @member {string} closeTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.closeTime = "";
    
                    /**
                     * Store companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Store company.
                     * @member {palexy.streaming.v1.ICompany|null|undefined} company
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.company = null;
    
                    /**
                     * Store trackingRetentionDays.
                     * @member {number} trackingRetentionDays
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.trackingRetentionDays = 0;
    
                    /**
                     * Store storeIntegrationConfig.
                     * @member {palexy.streaming.v1.IStoreIntegrationConfig|null|undefined} storeIntegrationConfig
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.storeIntegrationConfig = null;
    
                    /**
                     * Store areas.
                     * @member {Array.<palexy.streaming.v1.IArea>} areas
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.areas = $util.emptyArray;
    
                    /**
                     * Store storeState.
                     * @member {palexy.streaming.v1.Store.StoreState} storeState
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.storeState = 0;
    
                    /**
                     * Store timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.timezone = "";
    
                    /**
                     * Store customStreamingTime.
                     * @member {palexy.streaming.v1.ICustomStreamingTime|null|undefined} customStreamingTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.customStreamingTime = null;
    
                    /**
                     * Store listWeekdayCustomStreamingTime.
                     * @member {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null|undefined} listWeekdayCustomStreamingTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.listWeekdayCustomStreamingTime = null;
    
                    /**
                     * Store mergeQueueName.
                     * @member {string} mergeQueueName
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.mergeQueueName = "";
    
                    /**
                     * Store breakTimes.
                     * @member {Array.<palexy.streaming.v1.ITimeRange>} breakTimes
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.breakTimes = $util.emptyArray;
    
                    /**
                     * Store geoCoordinate.
                     * @member {palexy.streaming.v1.IGeoCoordinate|null|undefined} geoCoordinate
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.geoCoordinate = null;
    
                    /**
                     * Store countingType.
                     * @member {palexy.streaming.v1.Store.CountingType} countingType
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.countingType = 0;
    
                    /**
                     * Store defaultStreamingLocation.
                     * @member {string} defaultStreamingLocation
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.defaultStreamingLocation = "";
    
                    /**
                     * Store code.
                     * @member {string} code
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.code = "";
    
                    /**
                     * Store staffingStoreCode.
                     * @member {string} staffingStoreCode
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.staffingStoreCode = "";
    
                    /**
                     * Store inventoryCode.
                     * @member {string} inventoryCode
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.inventoryCode = "";
    
                    /**
                     * Store country.
                     * @member {string} country
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.country = "";
    
                    /**
                     * Store locality.
                     * @member {string} locality
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.locality = "";
    
                    /**
                     * Store addressPrimary.
                     * @member {string} addressPrimary
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.addressPrimary = "";
    
                    /**
                     * Store adminArea.
                     * @member {string} adminArea
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.adminArea = "";
    
                    /**
                     * Store onTimeGreetingThresholdSec.
                     * @member {number} onTimeGreetingThresholdSec
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.onTimeGreetingThresholdSec = 0;
    
                    /**
                     * Store externalTrafficCountingEnabled.
                     * @member {boolean} externalTrafficCountingEnabled
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.externalTrafficCountingEnabled = false;
    
                    /**
                     * Store disabledIssueTypes.
                     * @member {Array.<palexy.store_issue.v1.StoreIssueType>} disabledIssueTypes
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.disabledIssueTypes = $util.emptyArray;
    
                    /**
                     * Store relationshipType.
                     * @member {palexy.streaming.v1.Store.RelationshipType} relationshipType
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.relationshipType = 0;
    
                    /**
                     * Store parentStoreId.
                     * @member {number} parentStoreId
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.parentStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Store minVisitorDwellTimeInSeconds.
                     * @member {number} minVisitorDwellTimeInSeconds
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.minVisitorDwellTimeInSeconds = 0;
    
                    /**
                     * Store nextViewChangeDetectionTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} nextViewChangeDetectionTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.nextViewChangeDetectionTime = null;
    
                    /**
                     * Store viewChangeDetectionCronExpression.
                     * @member {string} viewChangeDetectionCronExpression
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.viewChangeDetectionCronExpression = "";
    
                    /**
                     * Store region.
                     * @member {string} region
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.region = "";
    
                    /**
                     * Store subRegion.
                     * @member {string} subRegion
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.subRegion = "";
    
                    /**
                     * Store mallId.
                     * @member {number} mallId
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.mallId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Store cameras.
                     * @member {Array.<palexy.streaming.v1.ICamera>} cameras
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.cameras = $util.emptyArray;
    
                    /**
                     * Store autoSchedulePreference.
                     * @member {palexy.streaming.v1.IAutoSchedulePreference|null|undefined} autoSchedulePreference
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.autoSchedulePreference = null;
    
                    /**
                     * Store metadataValues.
                     * @member {Array.<palexy.streaming.v1.IStoreMetadata>} metadataValues
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.metadataValues = $util.emptyArray;
    
                    /**
                     * Store staffScheduleDemandCoverageThreshold.
                     * @member {number} staffScheduleDemandCoverageThreshold
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.staffScheduleDemandCoverageThreshold = 0;
    
                    /**
                     * Store staffScheduleLowerDemandCoverageThreshold.
                     * @member {number} staffScheduleLowerDemandCoverageThreshold
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.staffScheduleLowerDemandCoverageThreshold = 0;
    
                    /**
                     * Store placeId.
                     * @member {string} placeId
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.placeId = "";
    
                    /**
                     * Store googleMapsLink.
                     * @member {string} googleMapsLink
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.googleMapsLink = "";
    
                    /**
                     * Store staffOpenTime.
                     * @member {string} staffOpenTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.staffOpenTime = "";
    
                    /**
                     * Store staffCloseTime.
                     * @member {string} staffCloseTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.staffCloseTime = "";
    
                    /**
                     * Store listWeekdayCustomStaffOperationTime.
                     * @member {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null|undefined} listWeekdayCustomStaffOperationTime
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.listWeekdayCustomStaffOperationTime = null;
    
                    /**
                     * Store changingRoomCopyMode.
                     * @member {palexy.streaming.v1.Store.ChangingRoomCopyMode} changingRoomCopyMode
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     */
                    Store.prototype.changingRoomCopyMode = 0;
    
                    /**
                     * Creates a new Store instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {palexy.streaming.v1.IStore=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Store} Store instance
                     */
                    Store.create = function create(properties) {
                        return new Store(properties);
                    };
    
                    /**
                     * Encodes the specified Store message. Does not implicitly {@link palexy.streaming.v1.Store.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {palexy.streaming.v1.IStore} message Store message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Store.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.displayName != null && Object.hasOwnProperty.call(message, "displayName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.displayName);
                        if (message.retentionDays != null && Object.hasOwnProperty.call(message, "retentionDays"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.retentionDays);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.ownerId);
                        if (message.storeType != null && Object.hasOwnProperty.call(message, "storeType"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.storeType);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.companyId);
                        if (message.company != null && Object.hasOwnProperty.call(message, "company"))
                            $root.palexy.streaming.v1.Company.encode(message.company, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.trackingRetentionDays != null && Object.hasOwnProperty.call(message, "trackingRetentionDays"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.trackingRetentionDays);
                        if (message.storeIntegrationConfig != null && Object.hasOwnProperty.call(message, "storeIntegrationConfig"))
                            $root.palexy.streaming.v1.StoreIntegrationConfig.encode(message.storeIntegrationConfig, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.areas != null && message.areas.length)
                            for (var i = 0; i < message.areas.length; ++i)
                                $root.palexy.streaming.v1.Area.encode(message.areas[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.openTime != null && Object.hasOwnProperty.call(message, "openTime"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.openTime);
                        if (message.closeTime != null && Object.hasOwnProperty.call(message, "closeTime"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.closeTime);
                        if (message.storeState != null && Object.hasOwnProperty.call(message, "storeState"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.storeState);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.timezone);
                        if (message.customStreamingTime != null && Object.hasOwnProperty.call(message, "customStreamingTime"))
                            $root.palexy.streaming.v1.CustomStreamingTime.encode(message.customStreamingTime, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.listWeekdayCustomStreamingTime != null && Object.hasOwnProperty.call(message, "listWeekdayCustomStreamingTime"))
                            $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.encode(message.listWeekdayCustomStreamingTime, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.mergeQueueName != null && Object.hasOwnProperty.call(message, "mergeQueueName"))
                            writer.uint32(/* id 18, wireType 2 =*/146).string(message.mergeQueueName);
                        if (message.breakTimes != null && message.breakTimes.length)
                            for (var i = 0; i < message.breakTimes.length; ++i)
                                $root.palexy.streaming.v1.TimeRange.encode(message.breakTimes[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.geoCoordinate != null && Object.hasOwnProperty.call(message, "geoCoordinate"))
                            $root.palexy.streaming.v1.GeoCoordinate.encode(message.geoCoordinate, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.countingType != null && Object.hasOwnProperty.call(message, "countingType"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.countingType);
                        if (message.defaultStreamingLocation != null && Object.hasOwnProperty.call(message, "defaultStreamingLocation"))
                            writer.uint32(/* id 23, wireType 2 =*/186).string(message.defaultStreamingLocation);
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 24, wireType 2 =*/194).string(message.code);
                        if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                            writer.uint32(/* id 25, wireType 2 =*/202).string(message.country);
                        if (message.locality != null && Object.hasOwnProperty.call(message, "locality"))
                            writer.uint32(/* id 26, wireType 2 =*/210).string(message.locality);
                        if (message.addressPrimary != null && Object.hasOwnProperty.call(message, "addressPrimary"))
                            writer.uint32(/* id 27, wireType 2 =*/218).string(message.addressPrimary);
                        if (message.adminArea != null && Object.hasOwnProperty.call(message, "adminArea"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.adminArea);
                        if (message.onTimeGreetingThresholdSec != null && Object.hasOwnProperty.call(message, "onTimeGreetingThresholdSec"))
                            writer.uint32(/* id 29, wireType 0 =*/232).int32(message.onTimeGreetingThresholdSec);
                        if (message.externalTrafficCountingEnabled != null && Object.hasOwnProperty.call(message, "externalTrafficCountingEnabled"))
                            writer.uint32(/* id 30, wireType 0 =*/240).bool(message.externalTrafficCountingEnabled);
                        if (message.disabledIssueTypes != null && message.disabledIssueTypes.length) {
                            writer.uint32(/* id 31, wireType 2 =*/250).fork();
                            for (var i = 0; i < message.disabledIssueTypes.length; ++i)
                                writer.int32(message.disabledIssueTypes[i]);
                            writer.ldelim();
                        }
                        if (message.relationshipType != null && Object.hasOwnProperty.call(message, "relationshipType"))
                            writer.uint32(/* id 32, wireType 0 =*/256).int32(message.relationshipType);
                        if (message.parentStoreId != null && Object.hasOwnProperty.call(message, "parentStoreId"))
                            writer.uint32(/* id 33, wireType 0 =*/264).int64(message.parentStoreId);
                        if (message.nextViewChangeDetectionTime != null && Object.hasOwnProperty.call(message, "nextViewChangeDetectionTime"))
                            $root.google.protobuf.Timestamp.encode(message.nextViewChangeDetectionTime, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.viewChangeDetectionCronExpression != null && Object.hasOwnProperty.call(message, "viewChangeDetectionCronExpression"))
                            writer.uint32(/* id 35, wireType 2 =*/282).string(message.viewChangeDetectionCronExpression);
                        if (message.minVisitorDwellTimeInSeconds != null && Object.hasOwnProperty.call(message, "minVisitorDwellTimeInSeconds"))
                            writer.uint32(/* id 36, wireType 0 =*/288).int32(message.minVisitorDwellTimeInSeconds);
                        if (message.region != null && Object.hasOwnProperty.call(message, "region"))
                            writer.uint32(/* id 37, wireType 2 =*/298).string(message.region);
                        if (message.subRegion != null && Object.hasOwnProperty.call(message, "subRegion"))
                            writer.uint32(/* id 38, wireType 2 =*/306).string(message.subRegion);
                        if (message.mallId != null && Object.hasOwnProperty.call(message, "mallId"))
                            writer.uint32(/* id 39, wireType 0 =*/312).int64(message.mallId);
                        if (message.cameras != null && message.cameras.length)
                            for (var i = 0; i < message.cameras.length; ++i)
                                $root.palexy.streaming.v1.Camera.encode(message.cameras[i], writer.uint32(/* id 40, wireType 2 =*/322).fork()).ldelim();
                        if (message.staffingStoreCode != null && Object.hasOwnProperty.call(message, "staffingStoreCode"))
                            writer.uint32(/* id 41, wireType 2 =*/330).string(message.staffingStoreCode);
                        if (message.autoSchedulePreference != null && Object.hasOwnProperty.call(message, "autoSchedulePreference"))
                            $root.palexy.streaming.v1.AutoSchedulePreference.encode(message.autoSchedulePreference, writer.uint32(/* id 42, wireType 2 =*/338).fork()).ldelim();
                        if (message.metadataValues != null && message.metadataValues.length)
                            for (var i = 0; i < message.metadataValues.length; ++i)
                                $root.palexy.streaming.v1.StoreMetadata.encode(message.metadataValues[i], writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
                        if (message.staffScheduleDemandCoverageThreshold != null && Object.hasOwnProperty.call(message, "staffScheduleDemandCoverageThreshold"))
                            writer.uint32(/* id 44, wireType 1 =*/353).double(message.staffScheduleDemandCoverageThreshold);
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && Object.hasOwnProperty.call(message, "staffScheduleLowerDemandCoverageThreshold"))
                            writer.uint32(/* id 45, wireType 1 =*/361).double(message.staffScheduleLowerDemandCoverageThreshold);
                        if (message.inventoryCode != null && Object.hasOwnProperty.call(message, "inventoryCode"))
                            writer.uint32(/* id 46, wireType 2 =*/370).string(message.inventoryCode);
                        if (message.placeId != null && Object.hasOwnProperty.call(message, "placeId"))
                            writer.uint32(/* id 47, wireType 2 =*/378).string(message.placeId);
                        if (message.googleMapsLink != null && Object.hasOwnProperty.call(message, "googleMapsLink"))
                            writer.uint32(/* id 48, wireType 2 =*/386).string(message.googleMapsLink);
                        if (message.staffOpenTime != null && Object.hasOwnProperty.call(message, "staffOpenTime"))
                            writer.uint32(/* id 49, wireType 2 =*/394).string(message.staffOpenTime);
                        if (message.staffCloseTime != null && Object.hasOwnProperty.call(message, "staffCloseTime"))
                            writer.uint32(/* id 50, wireType 2 =*/402).string(message.staffCloseTime);
                        if (message.listWeekdayCustomStaffOperationTime != null && Object.hasOwnProperty.call(message, "listWeekdayCustomStaffOperationTime"))
                            $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.encode(message.listWeekdayCustomStaffOperationTime, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
                        if (message.changingRoomCopyMode != null && Object.hasOwnProperty.call(message, "changingRoomCopyMode"))
                            writer.uint32(/* id 52, wireType 0 =*/416).int32(message.changingRoomCopyMode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Store message, length delimited. Does not implicitly {@link palexy.streaming.v1.Store.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {palexy.streaming.v1.IStore} message Store message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Store.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Store message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Store} Store
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Store.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Store();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.displayName = reader.string();
                                break;
                            case 4:
                                message.retentionDays = reader.int32();
                                break;
                            case 5:
                                message.ownerId = reader.int64();
                                break;
                            case 6:
                                message.storeType = reader.int32();
                                break;
                            case 12:
                                message.openTime = reader.string();
                                break;
                            case 13:
                                message.closeTime = reader.string();
                                break;
                            case 7:
                                message.companyId = reader.int64();
                                break;
                            case 8:
                                message.company = $root.palexy.streaming.v1.Company.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.trackingRetentionDays = reader.int32();
                                break;
                            case 10:
                                message.storeIntegrationConfig = $root.palexy.streaming.v1.StoreIntegrationConfig.decode(reader, reader.uint32());
                                break;
                            case 11:
                                if (!(message.areas && message.areas.length))
                                    message.areas = [];
                                message.areas.push($root.palexy.streaming.v1.Area.decode(reader, reader.uint32()));
                                break;
                            case 14:
                                message.storeState = reader.int32();
                                break;
                            case 15:
                                message.timezone = reader.string();
                                break;
                            case 16:
                                message.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.mergeQueueName = reader.string();
                                break;
                            case 19:
                                if (!(message.breakTimes && message.breakTimes.length))
                                    message.breakTimes = [];
                                message.breakTimes.push($root.palexy.streaming.v1.TimeRange.decode(reader, reader.uint32()));
                                break;
                            case 21:
                                message.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.decode(reader, reader.uint32());
                                break;
                            case 22:
                                message.countingType = reader.int32();
                                break;
                            case 23:
                                message.defaultStreamingLocation = reader.string();
                                break;
                            case 24:
                                message.code = reader.string();
                                break;
                            case 41:
                                message.staffingStoreCode = reader.string();
                                break;
                            case 46:
                                message.inventoryCode = reader.string();
                                break;
                            case 25:
                                message.country = reader.string();
                                break;
                            case 26:
                                message.locality = reader.string();
                                break;
                            case 27:
                                message.addressPrimary = reader.string();
                                break;
                            case 28:
                                message.adminArea = reader.string();
                                break;
                            case 29:
                                message.onTimeGreetingThresholdSec = reader.int32();
                                break;
                            case 30:
                                message.externalTrafficCountingEnabled = reader.bool();
                                break;
                            case 31:
                                if (!(message.disabledIssueTypes && message.disabledIssueTypes.length))
                                    message.disabledIssueTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.disabledIssueTypes.push(reader.int32());
                                } else
                                    message.disabledIssueTypes.push(reader.int32());
                                break;
                            case 32:
                                message.relationshipType = reader.int32();
                                break;
                            case 33:
                                message.parentStoreId = reader.int64();
                                break;
                            case 36:
                                message.minVisitorDwellTimeInSeconds = reader.int32();
                                break;
                            case 34:
                                message.nextViewChangeDetectionTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 35:
                                message.viewChangeDetectionCronExpression = reader.string();
                                break;
                            case 37:
                                message.region = reader.string();
                                break;
                            case 38:
                                message.subRegion = reader.string();
                                break;
                            case 39:
                                message.mallId = reader.int64();
                                break;
                            case 40:
                                if (!(message.cameras && message.cameras.length))
                                    message.cameras = [];
                                message.cameras.push($root.palexy.streaming.v1.Camera.decode(reader, reader.uint32()));
                                break;
                            case 42:
                                message.autoSchedulePreference = $root.palexy.streaming.v1.AutoSchedulePreference.decode(reader, reader.uint32());
                                break;
                            case 43:
                                if (!(message.metadataValues && message.metadataValues.length))
                                    message.metadataValues = [];
                                message.metadataValues.push($root.palexy.streaming.v1.StoreMetadata.decode(reader, reader.uint32()));
                                break;
                            case 44:
                                message.staffScheduleDemandCoverageThreshold = reader.double();
                                break;
                            case 45:
                                message.staffScheduleLowerDemandCoverageThreshold = reader.double();
                                break;
                            case 47:
                                message.placeId = reader.string();
                                break;
                            case 48:
                                message.googleMapsLink = reader.string();
                                break;
                            case 49:
                                message.staffOpenTime = reader.string();
                                break;
                            case 50:
                                message.staffCloseTime = reader.string();
                                break;
                            case 51:
                                message.listWeekdayCustomStaffOperationTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 52:
                                message.changingRoomCopyMode = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Store message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Store} Store
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Store.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Store message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Store.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            if (!$util.isString(message.displayName))
                                return "displayName: string expected";
                        if (message.retentionDays != null && message.hasOwnProperty("retentionDays"))
                            if (!$util.isInteger(message.retentionDays))
                                return "retentionDays: integer expected";
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.storeType != null && message.hasOwnProperty("storeType"))
                            switch (message.storeType) {
                            default:
                                return "storeType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.openTime != null && message.hasOwnProperty("openTime"))
                            if (!$util.isString(message.openTime))
                                return "openTime: string expected";
                        if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                            if (!$util.isString(message.closeTime))
                                return "closeTime: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.company != null && message.hasOwnProperty("company")) {
                            var error = $root.palexy.streaming.v1.Company.verify(message.company);
                            if (error)
                                return "company." + error;
                        }
                        if (message.trackingRetentionDays != null && message.hasOwnProperty("trackingRetentionDays"))
                            if (!$util.isInteger(message.trackingRetentionDays))
                                return "trackingRetentionDays: integer expected";
                        if (message.storeIntegrationConfig != null && message.hasOwnProperty("storeIntegrationConfig")) {
                            var error = $root.palexy.streaming.v1.StoreIntegrationConfig.verify(message.storeIntegrationConfig);
                            if (error)
                                return "storeIntegrationConfig." + error;
                        }
                        if (message.areas != null && message.hasOwnProperty("areas")) {
                            if (!Array.isArray(message.areas))
                                return "areas: array expected";
                            for (var i = 0; i < message.areas.length; ++i) {
                                var error = $root.palexy.streaming.v1.Area.verify(message.areas[i]);
                                if (error)
                                    return "areas." + error;
                            }
                        }
                        if (message.storeState != null && message.hasOwnProperty("storeState"))
                            switch (message.storeState) {
                            default:
                                return "storeState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.customStreamingTime != null && message.hasOwnProperty("customStreamingTime")) {
                            var error = $root.palexy.streaming.v1.CustomStreamingTime.verify(message.customStreamingTime);
                            if (error)
                                return "customStreamingTime." + error;
                        }
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime")) {
                            var error = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify(message.listWeekdayCustomStreamingTime);
                            if (error)
                                return "listWeekdayCustomStreamingTime." + error;
                        }
                        if (message.mergeQueueName != null && message.hasOwnProperty("mergeQueueName"))
                            if (!$util.isString(message.mergeQueueName))
                                return "mergeQueueName: string expected";
                        if (message.breakTimes != null && message.hasOwnProperty("breakTimes")) {
                            if (!Array.isArray(message.breakTimes))
                                return "breakTimes: array expected";
                            for (var i = 0; i < message.breakTimes.length; ++i) {
                                var error = $root.palexy.streaming.v1.TimeRange.verify(message.breakTimes[i]);
                                if (error)
                                    return "breakTimes." + error;
                            }
                        }
                        if (message.geoCoordinate != null && message.hasOwnProperty("geoCoordinate")) {
                            var error = $root.palexy.streaming.v1.GeoCoordinate.verify(message.geoCoordinate);
                            if (error)
                                return "geoCoordinate." + error;
                        }
                        if (message.countingType != null && message.hasOwnProperty("countingType"))
                            switch (message.countingType) {
                            default:
                                return "countingType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.defaultStreamingLocation != null && message.hasOwnProperty("defaultStreamingLocation"))
                            if (!$util.isString(message.defaultStreamingLocation))
                                return "defaultStreamingLocation: string expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        if (message.staffingStoreCode != null && message.hasOwnProperty("staffingStoreCode"))
                            if (!$util.isString(message.staffingStoreCode))
                                return "staffingStoreCode: string expected";
                        if (message.inventoryCode != null && message.hasOwnProperty("inventoryCode"))
                            if (!$util.isString(message.inventoryCode))
                                return "inventoryCode: string expected";
                        if (message.country != null && message.hasOwnProperty("country"))
                            if (!$util.isString(message.country))
                                return "country: string expected";
                        if (message.locality != null && message.hasOwnProperty("locality"))
                            if (!$util.isString(message.locality))
                                return "locality: string expected";
                        if (message.addressPrimary != null && message.hasOwnProperty("addressPrimary"))
                            if (!$util.isString(message.addressPrimary))
                                return "addressPrimary: string expected";
                        if (message.adminArea != null && message.hasOwnProperty("adminArea"))
                            if (!$util.isString(message.adminArea))
                                return "adminArea: string expected";
                        if (message.onTimeGreetingThresholdSec != null && message.hasOwnProperty("onTimeGreetingThresholdSec"))
                            if (!$util.isInteger(message.onTimeGreetingThresholdSec))
                                return "onTimeGreetingThresholdSec: integer expected";
                        if (message.externalTrafficCountingEnabled != null && message.hasOwnProperty("externalTrafficCountingEnabled"))
                            if (typeof message.externalTrafficCountingEnabled !== "boolean")
                                return "externalTrafficCountingEnabled: boolean expected";
                        if (message.disabledIssueTypes != null && message.hasOwnProperty("disabledIssueTypes")) {
                            if (!Array.isArray(message.disabledIssueTypes))
                                return "disabledIssueTypes: array expected";
                            for (var i = 0; i < message.disabledIssueTypes.length; ++i)
                                switch (message.disabledIssueTypes[i]) {
                                default:
                                    return "disabledIssueTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        if (message.relationshipType != null && message.hasOwnProperty("relationshipType"))
                            switch (message.relationshipType) {
                            default:
                                return "relationshipType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.parentStoreId != null && message.hasOwnProperty("parentStoreId"))
                            if (!$util.isInteger(message.parentStoreId) && !(message.parentStoreId && $util.isInteger(message.parentStoreId.low) && $util.isInteger(message.parentStoreId.high)))
                                return "parentStoreId: integer|Long expected";
                        if (message.minVisitorDwellTimeInSeconds != null && message.hasOwnProperty("minVisitorDwellTimeInSeconds"))
                            if (!$util.isInteger(message.minVisitorDwellTimeInSeconds))
                                return "minVisitorDwellTimeInSeconds: integer expected";
                        if (message.nextViewChangeDetectionTime != null && message.hasOwnProperty("nextViewChangeDetectionTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.nextViewChangeDetectionTime);
                            if (error)
                                return "nextViewChangeDetectionTime." + error;
                        }
                        if (message.viewChangeDetectionCronExpression != null && message.hasOwnProperty("viewChangeDetectionCronExpression"))
                            if (!$util.isString(message.viewChangeDetectionCronExpression))
                                return "viewChangeDetectionCronExpression: string expected";
                        if (message.region != null && message.hasOwnProperty("region"))
                            if (!$util.isString(message.region))
                                return "region: string expected";
                        if (message.subRegion != null && message.hasOwnProperty("subRegion"))
                            if (!$util.isString(message.subRegion))
                                return "subRegion: string expected";
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (!$util.isInteger(message.mallId) && !(message.mallId && $util.isInteger(message.mallId.low) && $util.isInteger(message.mallId.high)))
                                return "mallId: integer|Long expected";
                        if (message.cameras != null && message.hasOwnProperty("cameras")) {
                            if (!Array.isArray(message.cameras))
                                return "cameras: array expected";
                            for (var i = 0; i < message.cameras.length; ++i) {
                                var error = $root.palexy.streaming.v1.Camera.verify(message.cameras[i]);
                                if (error)
                                    return "cameras." + error;
                            }
                        }
                        if (message.autoSchedulePreference != null && message.hasOwnProperty("autoSchedulePreference")) {
                            var error = $root.palexy.streaming.v1.AutoSchedulePreference.verify(message.autoSchedulePreference);
                            if (error)
                                return "autoSchedulePreference." + error;
                        }
                        if (message.metadataValues != null && message.hasOwnProperty("metadataValues")) {
                            if (!Array.isArray(message.metadataValues))
                                return "metadataValues: array expected";
                            for (var i = 0; i < message.metadataValues.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreMetadata.verify(message.metadataValues[i]);
                                if (error)
                                    return "metadataValues." + error;
                            }
                        }
                        if (message.staffScheduleDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleDemandCoverageThreshold"))
                            if (typeof message.staffScheduleDemandCoverageThreshold !== "number")
                                return "staffScheduleDemandCoverageThreshold: number expected";
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleLowerDemandCoverageThreshold"))
                            if (typeof message.staffScheduleLowerDemandCoverageThreshold !== "number")
                                return "staffScheduleLowerDemandCoverageThreshold: number expected";
                        if (message.placeId != null && message.hasOwnProperty("placeId"))
                            if (!$util.isString(message.placeId))
                                return "placeId: string expected";
                        if (message.googleMapsLink != null && message.hasOwnProperty("googleMapsLink"))
                            if (!$util.isString(message.googleMapsLink))
                                return "googleMapsLink: string expected";
                        if (message.staffOpenTime != null && message.hasOwnProperty("staffOpenTime"))
                            if (!$util.isString(message.staffOpenTime))
                                return "staffOpenTime: string expected";
                        if (message.staffCloseTime != null && message.hasOwnProperty("staffCloseTime"))
                            if (!$util.isString(message.staffCloseTime))
                                return "staffCloseTime: string expected";
                        if (message.listWeekdayCustomStaffOperationTime != null && message.hasOwnProperty("listWeekdayCustomStaffOperationTime")) {
                            var error = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify(message.listWeekdayCustomStaffOperationTime);
                            if (error)
                                return "listWeekdayCustomStaffOperationTime." + error;
                        }
                        if (message.changingRoomCopyMode != null && message.hasOwnProperty("changingRoomCopyMode"))
                            switch (message.changingRoomCopyMode) {
                            default:
                                return "changingRoomCopyMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a Store message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Store} Store
                     */
                    Store.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Store)
                            return object;
                        var message = new $root.palexy.streaming.v1.Store();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.displayName != null)
                            message.displayName = String(object.displayName);
                        if (object.retentionDays != null)
                            message.retentionDays = object.retentionDays | 0;
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        switch (object.storeType) {
                        case "UNKNOWN":
                        case 0:
                            message.storeType = 0;
                            break;
                        case "INDEPENDENT":
                        case 1:
                            message.storeType = 1;
                            break;
                        case "SHOPPING_MALL":
                        case 2:
                            message.storeType = 2;
                            break;
                        }
                        if (object.openTime != null)
                            message.openTime = String(object.openTime);
                        if (object.closeTime != null)
                            message.closeTime = String(object.closeTime);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.company != null) {
                            if (typeof object.company !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.company: object expected");
                            message.company = $root.palexy.streaming.v1.Company.fromObject(object.company);
                        }
                        if (object.trackingRetentionDays != null)
                            message.trackingRetentionDays = object.trackingRetentionDays | 0;
                        if (object.storeIntegrationConfig != null) {
                            if (typeof object.storeIntegrationConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.storeIntegrationConfig: object expected");
                            message.storeIntegrationConfig = $root.palexy.streaming.v1.StoreIntegrationConfig.fromObject(object.storeIntegrationConfig);
                        }
                        if (object.areas) {
                            if (!Array.isArray(object.areas))
                                throw TypeError(".palexy.streaming.v1.Store.areas: array expected");
                            message.areas = [];
                            for (var i = 0; i < object.areas.length; ++i) {
                                if (typeof object.areas[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Store.areas: object expected");
                                message.areas[i] = $root.palexy.streaming.v1.Area.fromObject(object.areas[i]);
                            }
                        }
                        switch (object.storeState) {
                        case "UNKNOWN_STATE":
                        case 0:
                            message.storeState = 0;
                            break;
                        case "TUNING":
                        case 1:
                            message.storeState = 1;
                            break;
                        case "PRODUCTION_LEVEL_1":
                        case 2:
                            message.storeState = 2;
                            break;
                        case "PRODUCTION_LEVEL_2":
                        case 3:
                            message.storeState = 3;
                            break;
                        case "PRODUCTION_LEVEL_1_RESPECTED_DATA_CONSISTENCY":
                        case 4:
                            message.storeState = 4;
                            break;
                        }
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.customStreamingTime != null) {
                            if (typeof object.customStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.customStreamingTime: object expected");
                            message.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.fromObject(object.customStreamingTime);
                        }
                        if (object.listWeekdayCustomStreamingTime != null) {
                            if (typeof object.listWeekdayCustomStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.listWeekdayCustomStreamingTime: object expected");
                            message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.fromObject(object.listWeekdayCustomStreamingTime);
                        }
                        if (object.mergeQueueName != null)
                            message.mergeQueueName = String(object.mergeQueueName);
                        if (object.breakTimes) {
                            if (!Array.isArray(object.breakTimes))
                                throw TypeError(".palexy.streaming.v1.Store.breakTimes: array expected");
                            message.breakTimes = [];
                            for (var i = 0; i < object.breakTimes.length; ++i) {
                                if (typeof object.breakTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Store.breakTimes: object expected");
                                message.breakTimes[i] = $root.palexy.streaming.v1.TimeRange.fromObject(object.breakTimes[i]);
                            }
                        }
                        if (object.geoCoordinate != null) {
                            if (typeof object.geoCoordinate !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.geoCoordinate: object expected");
                            message.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.fromObject(object.geoCoordinate);
                        }
                        switch (object.countingType) {
                        case "UNKNOWN_COUNTING_TYPE":
                        case 0:
                            message.countingType = 0;
                            break;
                        case "FULL_ANALYTIC":
                        case 1:
                            message.countingType = 1;
                            break;
                        case "TRAFFIC_COUNTING":
                        case 2:
                            message.countingType = 2;
                            break;
                        case "ENTRANCE_COUNTING":
                        case 3:
                            message.countingType = 3;
                            break;
                        case "MINIMAL_CAMERA_COUNTING":
                        case 4:
                            message.countingType = 4;
                            break;
                        case "ENTRANCE_ANCHOR_MERGING":
                        case 5:
                            message.countingType = 5;
                            break;
                        }
                        if (object.defaultStreamingLocation != null)
                            message.defaultStreamingLocation = String(object.defaultStreamingLocation);
                        if (object.code != null)
                            message.code = String(object.code);
                        if (object.staffingStoreCode != null)
                            message.staffingStoreCode = String(object.staffingStoreCode);
                        if (object.inventoryCode != null)
                            message.inventoryCode = String(object.inventoryCode);
                        if (object.country != null)
                            message.country = String(object.country);
                        if (object.locality != null)
                            message.locality = String(object.locality);
                        if (object.addressPrimary != null)
                            message.addressPrimary = String(object.addressPrimary);
                        if (object.adminArea != null)
                            message.adminArea = String(object.adminArea);
                        if (object.onTimeGreetingThresholdSec != null)
                            message.onTimeGreetingThresholdSec = object.onTimeGreetingThresholdSec | 0;
                        if (object.externalTrafficCountingEnabled != null)
                            message.externalTrafficCountingEnabled = Boolean(object.externalTrafficCountingEnabled);
                        if (object.disabledIssueTypes) {
                            if (!Array.isArray(object.disabledIssueTypes))
                                throw TypeError(".palexy.streaming.v1.Store.disabledIssueTypes: array expected");
                            message.disabledIssueTypes = [];
                            for (var i = 0; i < object.disabledIssueTypes.length; ++i)
                                switch (object.disabledIssueTypes[i]) {
                                default:
                                case "UNKNOWN_STORE_ISSUE_TYPE":
                                case 0:
                                    message.disabledIssueTypes[i] = 0;
                                    break;
                                case "SECTION_CONFIG":
                                case 1:
                                    message.disabledIssueTypes[i] = 1;
                                    break;
                                case "UPLOAD_VIDEOS":
                                case 2:
                                    message.disabledIssueTypes[i] = 2;
                                    break;
                                case "PREPROCESSING":
                                case 3:
                                    message.disabledIssueTypes[i] = 3;
                                    break;
                                case "CAMERA_VIEW_CHANGE":
                                case 4:
                                    message.disabledIssueTypes[i] = 4;
                                    break;
                                }
                        }
                        switch (object.relationshipType) {
                        case "UNKNOWN_RELATIONSHIP_TYPE":
                        case 0:
                            message.relationshipType = 0;
                            break;
                        case "NO_RELATIONSHIP":
                        case 1:
                            message.relationshipType = 1;
                            break;
                        case "PARENT":
                        case 2:
                            message.relationshipType = 2;
                            break;
                        case "CHILD":
                        case 3:
                            message.relationshipType = 3;
                            break;
                        }
                        if (object.parentStoreId != null)
                            if ($util.Long)
                                (message.parentStoreId = $util.Long.fromValue(object.parentStoreId)).unsigned = false;
                            else if (typeof object.parentStoreId === "string")
                                message.parentStoreId = parseInt(object.parentStoreId, 10);
                            else if (typeof object.parentStoreId === "number")
                                message.parentStoreId = object.parentStoreId;
                            else if (typeof object.parentStoreId === "object")
                                message.parentStoreId = new $util.LongBits(object.parentStoreId.low >>> 0, object.parentStoreId.high >>> 0).toNumber();
                        if (object.minVisitorDwellTimeInSeconds != null)
                            message.minVisitorDwellTimeInSeconds = object.minVisitorDwellTimeInSeconds | 0;
                        if (object.nextViewChangeDetectionTime != null) {
                            if (typeof object.nextViewChangeDetectionTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.nextViewChangeDetectionTime: object expected");
                            message.nextViewChangeDetectionTime = $root.google.protobuf.Timestamp.fromObject(object.nextViewChangeDetectionTime);
                        }
                        if (object.viewChangeDetectionCronExpression != null)
                            message.viewChangeDetectionCronExpression = String(object.viewChangeDetectionCronExpression);
                        if (object.region != null)
                            message.region = String(object.region);
                        if (object.subRegion != null)
                            message.subRegion = String(object.subRegion);
                        if (object.mallId != null)
                            if ($util.Long)
                                (message.mallId = $util.Long.fromValue(object.mallId)).unsigned = false;
                            else if (typeof object.mallId === "string")
                                message.mallId = parseInt(object.mallId, 10);
                            else if (typeof object.mallId === "number")
                                message.mallId = object.mallId;
                            else if (typeof object.mallId === "object")
                                message.mallId = new $util.LongBits(object.mallId.low >>> 0, object.mallId.high >>> 0).toNumber();
                        if (object.cameras) {
                            if (!Array.isArray(object.cameras))
                                throw TypeError(".palexy.streaming.v1.Store.cameras: array expected");
                            message.cameras = [];
                            for (var i = 0; i < object.cameras.length; ++i) {
                                if (typeof object.cameras[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Store.cameras: object expected");
                                message.cameras[i] = $root.palexy.streaming.v1.Camera.fromObject(object.cameras[i]);
                            }
                        }
                        if (object.autoSchedulePreference != null) {
                            if (typeof object.autoSchedulePreference !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.autoSchedulePreference: object expected");
                            message.autoSchedulePreference = $root.palexy.streaming.v1.AutoSchedulePreference.fromObject(object.autoSchedulePreference);
                        }
                        if (object.metadataValues) {
                            if (!Array.isArray(object.metadataValues))
                                throw TypeError(".palexy.streaming.v1.Store.metadataValues: array expected");
                            message.metadataValues = [];
                            for (var i = 0; i < object.metadataValues.length; ++i) {
                                if (typeof object.metadataValues[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Store.metadataValues: object expected");
                                message.metadataValues[i] = $root.palexy.streaming.v1.StoreMetadata.fromObject(object.metadataValues[i]);
                            }
                        }
                        if (object.staffScheduleDemandCoverageThreshold != null)
                            message.staffScheduleDemandCoverageThreshold = Number(object.staffScheduleDemandCoverageThreshold);
                        if (object.staffScheduleLowerDemandCoverageThreshold != null)
                            message.staffScheduleLowerDemandCoverageThreshold = Number(object.staffScheduleLowerDemandCoverageThreshold);
                        if (object.placeId != null)
                            message.placeId = String(object.placeId);
                        if (object.googleMapsLink != null)
                            message.googleMapsLink = String(object.googleMapsLink);
                        if (object.staffOpenTime != null)
                            message.staffOpenTime = String(object.staffOpenTime);
                        if (object.staffCloseTime != null)
                            message.staffCloseTime = String(object.staffCloseTime);
                        if (object.listWeekdayCustomStaffOperationTime != null) {
                            if (typeof object.listWeekdayCustomStaffOperationTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Store.listWeekdayCustomStaffOperationTime: object expected");
                            message.listWeekdayCustomStaffOperationTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.fromObject(object.listWeekdayCustomStaffOperationTime);
                        }
                        switch (object.changingRoomCopyMode) {
                        case "CHANGING_ROOM_COPY_MODE_UNSPECIFIED":
                        case 0:
                            message.changingRoomCopyMode = 0;
                            break;
                        case "CHANGING_ROOM_COPY_MODE_ON":
                        case 1:
                            message.changingRoomCopyMode = 1;
                            break;
                        case "CHANGING_ROOM_COPY_MODE_OFF":
                        case 2:
                            message.changingRoomCopyMode = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Store message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Store
                     * @static
                     * @param {palexy.streaming.v1.Store} message Store
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Store.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.areas = [];
                            object.breakTimes = [];
                            object.disabledIssueTypes = [];
                            object.cameras = [];
                            object.metadataValues = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.displayName = "";
                            object.retentionDays = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            object.storeType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.company = null;
                            object.trackingRetentionDays = 0;
                            object.storeIntegrationConfig = null;
                            object.openTime = "";
                            object.closeTime = "";
                            object.storeState = options.enums === String ? "UNKNOWN_STATE" : 0;
                            object.timezone = "";
                            object.customStreamingTime = null;
                            object.listWeekdayCustomStreamingTime = null;
                            object.mergeQueueName = "";
                            object.geoCoordinate = null;
                            object.countingType = options.enums === String ? "UNKNOWN_COUNTING_TYPE" : 0;
                            object.defaultStreamingLocation = "";
                            object.code = "";
                            object.country = "";
                            object.locality = "";
                            object.addressPrimary = "";
                            object.adminArea = "";
                            object.onTimeGreetingThresholdSec = 0;
                            object.externalTrafficCountingEnabled = false;
                            object.relationshipType = options.enums === String ? "UNKNOWN_RELATIONSHIP_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.parentStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.parentStoreId = options.longs === String ? "0" : 0;
                            object.nextViewChangeDetectionTime = null;
                            object.viewChangeDetectionCronExpression = "";
                            object.minVisitorDwellTimeInSeconds = 0;
                            object.region = "";
                            object.subRegion = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.mallId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.mallId = options.longs === String ? "0" : 0;
                            object.staffingStoreCode = "";
                            object.autoSchedulePreference = null;
                            object.staffScheduleDemandCoverageThreshold = 0;
                            object.staffScheduleLowerDemandCoverageThreshold = 0;
                            object.inventoryCode = "";
                            object.placeId = "";
                            object.googleMapsLink = "";
                            object.staffOpenTime = "";
                            object.staffCloseTime = "";
                            object.listWeekdayCustomStaffOperationTime = null;
                            object.changingRoomCopyMode = options.enums === String ? "CHANGING_ROOM_COPY_MODE_UNSPECIFIED" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.displayName != null && message.hasOwnProperty("displayName"))
                            object.displayName = message.displayName;
                        if (message.retentionDays != null && message.hasOwnProperty("retentionDays"))
                            object.retentionDays = message.retentionDays;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.storeType != null && message.hasOwnProperty("storeType"))
                            object.storeType = options.enums === String ? $root.palexy.streaming.v1.Store.StoreType[message.storeType] : message.storeType;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.company != null && message.hasOwnProperty("company"))
                            object.company = $root.palexy.streaming.v1.Company.toObject(message.company, options);
                        if (message.trackingRetentionDays != null && message.hasOwnProperty("trackingRetentionDays"))
                            object.trackingRetentionDays = message.trackingRetentionDays;
                        if (message.storeIntegrationConfig != null && message.hasOwnProperty("storeIntegrationConfig"))
                            object.storeIntegrationConfig = $root.palexy.streaming.v1.StoreIntegrationConfig.toObject(message.storeIntegrationConfig, options);
                        if (message.areas && message.areas.length) {
                            object.areas = [];
                            for (var j = 0; j < message.areas.length; ++j)
                                object.areas[j] = $root.palexy.streaming.v1.Area.toObject(message.areas[j], options);
                        }
                        if (message.openTime != null && message.hasOwnProperty("openTime"))
                            object.openTime = message.openTime;
                        if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                            object.closeTime = message.closeTime;
                        if (message.storeState != null && message.hasOwnProperty("storeState"))
                            object.storeState = options.enums === String ? $root.palexy.streaming.v1.Store.StoreState[message.storeState] : message.storeState;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.customStreamingTime != null && message.hasOwnProperty("customStreamingTime"))
                            object.customStreamingTime = $root.palexy.streaming.v1.CustomStreamingTime.toObject(message.customStreamingTime, options);
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime"))
                            object.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.toObject(message.listWeekdayCustomStreamingTime, options);
                        if (message.mergeQueueName != null && message.hasOwnProperty("mergeQueueName"))
                            object.mergeQueueName = message.mergeQueueName;
                        if (message.breakTimes && message.breakTimes.length) {
                            object.breakTimes = [];
                            for (var j = 0; j < message.breakTimes.length; ++j)
                                object.breakTimes[j] = $root.palexy.streaming.v1.TimeRange.toObject(message.breakTimes[j], options);
                        }
                        if (message.geoCoordinate != null && message.hasOwnProperty("geoCoordinate"))
                            object.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.toObject(message.geoCoordinate, options);
                        if (message.countingType != null && message.hasOwnProperty("countingType"))
                            object.countingType = options.enums === String ? $root.palexy.streaming.v1.Store.CountingType[message.countingType] : message.countingType;
                        if (message.defaultStreamingLocation != null && message.hasOwnProperty("defaultStreamingLocation"))
                            object.defaultStreamingLocation = message.defaultStreamingLocation;
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.country != null && message.hasOwnProperty("country"))
                            object.country = message.country;
                        if (message.locality != null && message.hasOwnProperty("locality"))
                            object.locality = message.locality;
                        if (message.addressPrimary != null && message.hasOwnProperty("addressPrimary"))
                            object.addressPrimary = message.addressPrimary;
                        if (message.adminArea != null && message.hasOwnProperty("adminArea"))
                            object.adminArea = message.adminArea;
                        if (message.onTimeGreetingThresholdSec != null && message.hasOwnProperty("onTimeGreetingThresholdSec"))
                            object.onTimeGreetingThresholdSec = message.onTimeGreetingThresholdSec;
                        if (message.externalTrafficCountingEnabled != null && message.hasOwnProperty("externalTrafficCountingEnabled"))
                            object.externalTrafficCountingEnabled = message.externalTrafficCountingEnabled;
                        if (message.disabledIssueTypes && message.disabledIssueTypes.length) {
                            object.disabledIssueTypes = [];
                            for (var j = 0; j < message.disabledIssueTypes.length; ++j)
                                object.disabledIssueTypes[j] = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueType[message.disabledIssueTypes[j]] : message.disabledIssueTypes[j];
                        }
                        if (message.relationshipType != null && message.hasOwnProperty("relationshipType"))
                            object.relationshipType = options.enums === String ? $root.palexy.streaming.v1.Store.RelationshipType[message.relationshipType] : message.relationshipType;
                        if (message.parentStoreId != null && message.hasOwnProperty("parentStoreId"))
                            if (typeof message.parentStoreId === "number")
                                object.parentStoreId = options.longs === String ? String(message.parentStoreId) : message.parentStoreId;
                            else
                                object.parentStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.parentStoreId) : options.longs === Number ? new $util.LongBits(message.parentStoreId.low >>> 0, message.parentStoreId.high >>> 0).toNumber() : message.parentStoreId;
                        if (message.nextViewChangeDetectionTime != null && message.hasOwnProperty("nextViewChangeDetectionTime"))
                            object.nextViewChangeDetectionTime = $root.google.protobuf.Timestamp.toObject(message.nextViewChangeDetectionTime, options);
                        if (message.viewChangeDetectionCronExpression != null && message.hasOwnProperty("viewChangeDetectionCronExpression"))
                            object.viewChangeDetectionCronExpression = message.viewChangeDetectionCronExpression;
                        if (message.minVisitorDwellTimeInSeconds != null && message.hasOwnProperty("minVisitorDwellTimeInSeconds"))
                            object.minVisitorDwellTimeInSeconds = message.minVisitorDwellTimeInSeconds;
                        if (message.region != null && message.hasOwnProperty("region"))
                            object.region = message.region;
                        if (message.subRegion != null && message.hasOwnProperty("subRegion"))
                            object.subRegion = message.subRegion;
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (typeof message.mallId === "number")
                                object.mallId = options.longs === String ? String(message.mallId) : message.mallId;
                            else
                                object.mallId = options.longs === String ? $util.Long.prototype.toString.call(message.mallId) : options.longs === Number ? new $util.LongBits(message.mallId.low >>> 0, message.mallId.high >>> 0).toNumber() : message.mallId;
                        if (message.cameras && message.cameras.length) {
                            object.cameras = [];
                            for (var j = 0; j < message.cameras.length; ++j)
                                object.cameras[j] = $root.palexy.streaming.v1.Camera.toObject(message.cameras[j], options);
                        }
                        if (message.staffingStoreCode != null && message.hasOwnProperty("staffingStoreCode"))
                            object.staffingStoreCode = message.staffingStoreCode;
                        if (message.autoSchedulePreference != null && message.hasOwnProperty("autoSchedulePreference"))
                            object.autoSchedulePreference = $root.palexy.streaming.v1.AutoSchedulePreference.toObject(message.autoSchedulePreference, options);
                        if (message.metadataValues && message.metadataValues.length) {
                            object.metadataValues = [];
                            for (var j = 0; j < message.metadataValues.length; ++j)
                                object.metadataValues[j] = $root.palexy.streaming.v1.StoreMetadata.toObject(message.metadataValues[j], options);
                        }
                        if (message.staffScheduleDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleDemandCoverageThreshold"))
                            object.staffScheduleDemandCoverageThreshold = options.json && !isFinite(message.staffScheduleDemandCoverageThreshold) ? String(message.staffScheduleDemandCoverageThreshold) : message.staffScheduleDemandCoverageThreshold;
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleLowerDemandCoverageThreshold"))
                            object.staffScheduleLowerDemandCoverageThreshold = options.json && !isFinite(message.staffScheduleLowerDemandCoverageThreshold) ? String(message.staffScheduleLowerDemandCoverageThreshold) : message.staffScheduleLowerDemandCoverageThreshold;
                        if (message.inventoryCode != null && message.hasOwnProperty("inventoryCode"))
                            object.inventoryCode = message.inventoryCode;
                        if (message.placeId != null && message.hasOwnProperty("placeId"))
                            object.placeId = message.placeId;
                        if (message.googleMapsLink != null && message.hasOwnProperty("googleMapsLink"))
                            object.googleMapsLink = message.googleMapsLink;
                        if (message.staffOpenTime != null && message.hasOwnProperty("staffOpenTime"))
                            object.staffOpenTime = message.staffOpenTime;
                        if (message.staffCloseTime != null && message.hasOwnProperty("staffCloseTime"))
                            object.staffCloseTime = message.staffCloseTime;
                        if (message.listWeekdayCustomStaffOperationTime != null && message.hasOwnProperty("listWeekdayCustomStaffOperationTime"))
                            object.listWeekdayCustomStaffOperationTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.toObject(message.listWeekdayCustomStaffOperationTime, options);
                        if (message.changingRoomCopyMode != null && message.hasOwnProperty("changingRoomCopyMode"))
                            object.changingRoomCopyMode = options.enums === String ? $root.palexy.streaming.v1.Store.ChangingRoomCopyMode[message.changingRoomCopyMode] : message.changingRoomCopyMode;
                        return object;
                    };
    
                    /**
                     * Converts this Store to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Store
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Store.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * StoreType enum.
                     * @name palexy.streaming.v1.Store.StoreType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} INDEPENDENT=1 INDEPENDENT value
                     * @property {number} SHOPPING_MALL=2 SHOPPING_MALL value
                     */
                    Store.StoreType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "INDEPENDENT"] = 1;
                        values[valuesById[2] = "SHOPPING_MALL"] = 2;
                        return values;
                    })();
    
                    /**
                     * StoreState enum.
                     * @name palexy.streaming.v1.Store.StoreState
                     * @enum {number}
                     * @property {number} UNKNOWN_STATE=0 UNKNOWN_STATE value
                     * @property {number} TUNING=1 TUNING value
                     * @property {number} PRODUCTION_LEVEL_1=2 PRODUCTION_LEVEL_1 value
                     * @property {number} PRODUCTION_LEVEL_2=3 PRODUCTION_LEVEL_2 value
                     * @property {number} PRODUCTION_LEVEL_1_RESPECTED_DATA_CONSISTENCY=4 PRODUCTION_LEVEL_1_RESPECTED_DATA_CONSISTENCY value
                     */
                    Store.StoreState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_STATE"] = 0;
                        values[valuesById[1] = "TUNING"] = 1;
                        values[valuesById[2] = "PRODUCTION_LEVEL_1"] = 2;
                        values[valuesById[3] = "PRODUCTION_LEVEL_2"] = 3;
                        values[valuesById[4] = "PRODUCTION_LEVEL_1_RESPECTED_DATA_CONSISTENCY"] = 4;
                        return values;
                    })();
    
                    /**
                     * CountingType enum.
                     * @name palexy.streaming.v1.Store.CountingType
                     * @enum {number}
                     * @property {number} UNKNOWN_COUNTING_TYPE=0 UNKNOWN_COUNTING_TYPE value
                     * @property {number} FULL_ANALYTIC=1 FULL_ANALYTIC value
                     * @property {number} TRAFFIC_COUNTING=2 TRAFFIC_COUNTING value
                     * @property {number} ENTRANCE_COUNTING=3 ENTRANCE_COUNTING value
                     * @property {number} MINIMAL_CAMERA_COUNTING=4 MINIMAL_CAMERA_COUNTING value
                     * @property {number} ENTRANCE_ANCHOR_MERGING=5 ENTRANCE_ANCHOR_MERGING value
                     */
                    Store.CountingType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_COUNTING_TYPE"] = 0;
                        values[valuesById[1] = "FULL_ANALYTIC"] = 1;
                        values[valuesById[2] = "TRAFFIC_COUNTING"] = 2;
                        values[valuesById[3] = "ENTRANCE_COUNTING"] = 3;
                        values[valuesById[4] = "MINIMAL_CAMERA_COUNTING"] = 4;
                        values[valuesById[5] = "ENTRANCE_ANCHOR_MERGING"] = 5;
                        return values;
                    })();
    
                    /**
                     * RelationshipType enum.
                     * @name palexy.streaming.v1.Store.RelationshipType
                     * @enum {number}
                     * @property {number} UNKNOWN_RELATIONSHIP_TYPE=0 UNKNOWN_RELATIONSHIP_TYPE value
                     * @property {number} NO_RELATIONSHIP=1 NO_RELATIONSHIP value
                     * @property {number} PARENT=2 PARENT value
                     * @property {number} CHILD=3 CHILD value
                     */
                    Store.RelationshipType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_RELATIONSHIP_TYPE"] = 0;
                        values[valuesById[1] = "NO_RELATIONSHIP"] = 1;
                        values[valuesById[2] = "PARENT"] = 2;
                        values[valuesById[3] = "CHILD"] = 3;
                        return values;
                    })();
    
                    /**
                     * ChangingRoomCopyMode enum.
                     * @name palexy.streaming.v1.Store.ChangingRoomCopyMode
                     * @enum {number}
                     * @property {number} CHANGING_ROOM_COPY_MODE_UNSPECIFIED=0 CHANGING_ROOM_COPY_MODE_UNSPECIFIED value
                     * @property {number} CHANGING_ROOM_COPY_MODE_ON=1 CHANGING_ROOM_COPY_MODE_ON value
                     * @property {number} CHANGING_ROOM_COPY_MODE_OFF=2 CHANGING_ROOM_COPY_MODE_OFF value
                     */
                    Store.ChangingRoomCopyMode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "CHANGING_ROOM_COPY_MODE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CHANGING_ROOM_COPY_MODE_ON"] = 1;
                        values[valuesById[2] = "CHANGING_ROOM_COPY_MODE_OFF"] = 2;
                        return values;
                    })();
    
                    return Store;
                })();
    
                v1.AutoSchedulePreference = (function() {
    
                    /**
                     * Properties of an AutoSchedulePreference.
                     * @memberof palexy.streaming.v1
                     * @interface IAutoSchedulePreference
                     * @property {Array.<number>|null} [shiftTemplateIds] AutoSchedulePreference shiftTemplateIds
                     * @property {number|null} [maxPartTimeHours] AutoSchedulePreference maxPartTimeHours
                     * @property {Array.<palexy.streaming.v1.AutoSchedulePreference.IAreaOption>|null} [areaAutoScheduleOptions] AutoSchedulePreference areaAutoScheduleOptions
                     * @property {boolean|null} [useScheduleTemplateForShiftGeneration] AutoSchedulePreference useScheduleTemplateForShiftGeneration
                     * @property {number|null} [maximumOverlappingWithUnavailabilityInMinutes] AutoSchedulePreference maximumOverlappingWithUnavailabilityInMinutes
                     * @property {boolean|null} [useHistoricalAsInferredPreference] AutoSchedulePreference useHistoricalAsInferredPreference
                     * @property {boolean|null} [allowShortShiftForFullTimeStaff] AutoSchedulePreference allowShortShiftForFullTimeStaff
                     * @property {boolean|null} [allowExistingPublishedShifts] AutoSchedulePreference allowExistingPublishedShifts
                     * @property {boolean|null} [hideStaffList] AutoSchedulePreference hideStaffList
                     * @property {boolean|null} [autoAssignStartTimeForBreaks] AutoSchedulePreference autoAssignStartTimeForBreaks
                     * @property {number|null} [modelScheduleId] AutoSchedulePreference modelScheduleId
                     */
    
                    /**
                     * Constructs a new AutoSchedulePreference.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AutoSchedulePreference.
                     * @implements IAutoSchedulePreference
                     * @constructor
                     * @param {palexy.streaming.v1.IAutoSchedulePreference=} [properties] Properties to set
                     */
                    function AutoSchedulePreference(properties) {
                        this.shiftTemplateIds = [];
                        this.areaAutoScheduleOptions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AutoSchedulePreference shiftTemplateIds.
                     * @member {Array.<number>} shiftTemplateIds
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.shiftTemplateIds = $util.emptyArray;
    
                    /**
                     * AutoSchedulePreference maxPartTimeHours.
                     * @member {number} maxPartTimeHours
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.maxPartTimeHours = 0;
    
                    /**
                     * AutoSchedulePreference areaAutoScheduleOptions.
                     * @member {Array.<palexy.streaming.v1.AutoSchedulePreference.IAreaOption>} areaAutoScheduleOptions
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.areaAutoScheduleOptions = $util.emptyArray;
    
                    /**
                     * AutoSchedulePreference useScheduleTemplateForShiftGeneration.
                     * @member {boolean} useScheduleTemplateForShiftGeneration
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.useScheduleTemplateForShiftGeneration = false;
    
                    /**
                     * AutoSchedulePreference maximumOverlappingWithUnavailabilityInMinutes.
                     * @member {number} maximumOverlappingWithUnavailabilityInMinutes
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.maximumOverlappingWithUnavailabilityInMinutes = 0;
    
                    /**
                     * AutoSchedulePreference useHistoricalAsInferredPreference.
                     * @member {boolean} useHistoricalAsInferredPreference
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.useHistoricalAsInferredPreference = false;
    
                    /**
                     * AutoSchedulePreference allowShortShiftForFullTimeStaff.
                     * @member {boolean} allowShortShiftForFullTimeStaff
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.allowShortShiftForFullTimeStaff = false;
    
                    /**
                     * AutoSchedulePreference allowExistingPublishedShifts.
                     * @member {boolean} allowExistingPublishedShifts
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.allowExistingPublishedShifts = false;
    
                    /**
                     * AutoSchedulePreference hideStaffList.
                     * @member {boolean} hideStaffList
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.hideStaffList = false;
    
                    /**
                     * AutoSchedulePreference autoAssignStartTimeForBreaks.
                     * @member {boolean} autoAssignStartTimeForBreaks
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.autoAssignStartTimeForBreaks = false;
    
                    /**
                     * AutoSchedulePreference modelScheduleId.
                     * @member {number} modelScheduleId
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     */
                    AutoSchedulePreference.prototype.modelScheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AutoSchedulePreference instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {palexy.streaming.v1.IAutoSchedulePreference=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AutoSchedulePreference} AutoSchedulePreference instance
                     */
                    AutoSchedulePreference.create = function create(properties) {
                        return new AutoSchedulePreference(properties);
                    };
    
                    /**
                     * Encodes the specified AutoSchedulePreference message. Does not implicitly {@link palexy.streaming.v1.AutoSchedulePreference.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {palexy.streaming.v1.IAutoSchedulePreference} message AutoSchedulePreference message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoSchedulePreference.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplateIds != null && message.shiftTemplateIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.shiftTemplateIds.length; ++i)
                                writer.int64(message.shiftTemplateIds[i]);
                            writer.ldelim();
                        }
                        if (message.maxPartTimeHours != null && Object.hasOwnProperty.call(message, "maxPartTimeHours"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.maxPartTimeHours);
                        if (message.areaAutoScheduleOptions != null && message.areaAutoScheduleOptions.length)
                            for (var i = 0; i < message.areaAutoScheduleOptions.length; ++i)
                                $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption.encode(message.areaAutoScheduleOptions[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.useScheduleTemplateForShiftGeneration != null && Object.hasOwnProperty.call(message, "useScheduleTemplateForShiftGeneration"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.useScheduleTemplateForShiftGeneration);
                        if (message.maximumOverlappingWithUnavailabilityInMinutes != null && Object.hasOwnProperty.call(message, "maximumOverlappingWithUnavailabilityInMinutes"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maximumOverlappingWithUnavailabilityInMinutes);
                        if (message.useHistoricalAsInferredPreference != null && Object.hasOwnProperty.call(message, "useHistoricalAsInferredPreference"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.useHistoricalAsInferredPreference);
                        if (message.allowShortShiftForFullTimeStaff != null && Object.hasOwnProperty.call(message, "allowShortShiftForFullTimeStaff"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.allowShortShiftForFullTimeStaff);
                        if (message.allowExistingPublishedShifts != null && Object.hasOwnProperty.call(message, "allowExistingPublishedShifts"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.allowExistingPublishedShifts);
                        if (message.hideStaffList != null && Object.hasOwnProperty.call(message, "hideStaffList"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.hideStaffList);
                        if (message.autoAssignStartTimeForBreaks != null && Object.hasOwnProperty.call(message, "autoAssignStartTimeForBreaks"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.autoAssignStartTimeForBreaks);
                        if (message.modelScheduleId != null && Object.hasOwnProperty.call(message, "modelScheduleId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.modelScheduleId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AutoSchedulePreference message, length delimited. Does not implicitly {@link palexy.streaming.v1.AutoSchedulePreference.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {palexy.streaming.v1.IAutoSchedulePreference} message AutoSchedulePreference message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoSchedulePreference.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AutoSchedulePreference message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AutoSchedulePreference} AutoSchedulePreference
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoSchedulePreference.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AutoSchedulePreference();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.shiftTemplateIds && message.shiftTemplateIds.length))
                                    message.shiftTemplateIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.shiftTemplateIds.push(reader.int64());
                                } else
                                    message.shiftTemplateIds.push(reader.int64());
                                break;
                            case 2:
                                message.maxPartTimeHours = reader.double();
                                break;
                            case 3:
                                if (!(message.areaAutoScheduleOptions && message.areaAutoScheduleOptions.length))
                                    message.areaAutoScheduleOptions = [];
                                message.areaAutoScheduleOptions.push($root.palexy.streaming.v1.AutoSchedulePreference.AreaOption.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.useScheduleTemplateForShiftGeneration = reader.bool();
                                break;
                            case 5:
                                message.maximumOverlappingWithUnavailabilityInMinutes = reader.int32();
                                break;
                            case 6:
                                message.useHistoricalAsInferredPreference = reader.bool();
                                break;
                            case 7:
                                message.allowShortShiftForFullTimeStaff = reader.bool();
                                break;
                            case 8:
                                message.allowExistingPublishedShifts = reader.bool();
                                break;
                            case 9:
                                message.hideStaffList = reader.bool();
                                break;
                            case 10:
                                message.autoAssignStartTimeForBreaks = reader.bool();
                                break;
                            case 11:
                                message.modelScheduleId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AutoSchedulePreference message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AutoSchedulePreference} AutoSchedulePreference
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoSchedulePreference.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AutoSchedulePreference message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AutoSchedulePreference.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplateIds != null && message.hasOwnProperty("shiftTemplateIds")) {
                            if (!Array.isArray(message.shiftTemplateIds))
                                return "shiftTemplateIds: array expected";
                            for (var i = 0; i < message.shiftTemplateIds.length; ++i)
                                if (!$util.isInteger(message.shiftTemplateIds[i]) && !(message.shiftTemplateIds[i] && $util.isInteger(message.shiftTemplateIds[i].low) && $util.isInteger(message.shiftTemplateIds[i].high)))
                                    return "shiftTemplateIds: integer|Long[] expected";
                        }
                        if (message.maxPartTimeHours != null && message.hasOwnProperty("maxPartTimeHours"))
                            if (typeof message.maxPartTimeHours !== "number")
                                return "maxPartTimeHours: number expected";
                        if (message.areaAutoScheduleOptions != null && message.hasOwnProperty("areaAutoScheduleOptions")) {
                            if (!Array.isArray(message.areaAutoScheduleOptions))
                                return "areaAutoScheduleOptions: array expected";
                            for (var i = 0; i < message.areaAutoScheduleOptions.length; ++i) {
                                var error = $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption.verify(message.areaAutoScheduleOptions[i]);
                                if (error)
                                    return "areaAutoScheduleOptions." + error;
                            }
                        }
                        if (message.useScheduleTemplateForShiftGeneration != null && message.hasOwnProperty("useScheduleTemplateForShiftGeneration"))
                            if (typeof message.useScheduleTemplateForShiftGeneration !== "boolean")
                                return "useScheduleTemplateForShiftGeneration: boolean expected";
                        if (message.maximumOverlappingWithUnavailabilityInMinutes != null && message.hasOwnProperty("maximumOverlappingWithUnavailabilityInMinutes"))
                            if (!$util.isInteger(message.maximumOverlappingWithUnavailabilityInMinutes))
                                return "maximumOverlappingWithUnavailabilityInMinutes: integer expected";
                        if (message.useHistoricalAsInferredPreference != null && message.hasOwnProperty("useHistoricalAsInferredPreference"))
                            if (typeof message.useHistoricalAsInferredPreference !== "boolean")
                                return "useHistoricalAsInferredPreference: boolean expected";
                        if (message.allowShortShiftForFullTimeStaff != null && message.hasOwnProperty("allowShortShiftForFullTimeStaff"))
                            if (typeof message.allowShortShiftForFullTimeStaff !== "boolean")
                                return "allowShortShiftForFullTimeStaff: boolean expected";
                        if (message.allowExistingPublishedShifts != null && message.hasOwnProperty("allowExistingPublishedShifts"))
                            if (typeof message.allowExistingPublishedShifts !== "boolean")
                                return "allowExistingPublishedShifts: boolean expected";
                        if (message.hideStaffList != null && message.hasOwnProperty("hideStaffList"))
                            if (typeof message.hideStaffList !== "boolean")
                                return "hideStaffList: boolean expected";
                        if (message.autoAssignStartTimeForBreaks != null && message.hasOwnProperty("autoAssignStartTimeForBreaks"))
                            if (typeof message.autoAssignStartTimeForBreaks !== "boolean")
                                return "autoAssignStartTimeForBreaks: boolean expected";
                        if (message.modelScheduleId != null && message.hasOwnProperty("modelScheduleId"))
                            if (!$util.isInteger(message.modelScheduleId) && !(message.modelScheduleId && $util.isInteger(message.modelScheduleId.low) && $util.isInteger(message.modelScheduleId.high)))
                                return "modelScheduleId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AutoSchedulePreference message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AutoSchedulePreference} AutoSchedulePreference
                     */
                    AutoSchedulePreference.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AutoSchedulePreference)
                            return object;
                        var message = new $root.palexy.streaming.v1.AutoSchedulePreference();
                        if (object.shiftTemplateIds) {
                            if (!Array.isArray(object.shiftTemplateIds))
                                throw TypeError(".palexy.streaming.v1.AutoSchedulePreference.shiftTemplateIds: array expected");
                            message.shiftTemplateIds = [];
                            for (var i = 0; i < object.shiftTemplateIds.length; ++i)
                                if ($util.Long)
                                    (message.shiftTemplateIds[i] = $util.Long.fromValue(object.shiftTemplateIds[i])).unsigned = false;
                                else if (typeof object.shiftTemplateIds[i] === "string")
                                    message.shiftTemplateIds[i] = parseInt(object.shiftTemplateIds[i], 10);
                                else if (typeof object.shiftTemplateIds[i] === "number")
                                    message.shiftTemplateIds[i] = object.shiftTemplateIds[i];
                                else if (typeof object.shiftTemplateIds[i] === "object")
                                    message.shiftTemplateIds[i] = new $util.LongBits(object.shiftTemplateIds[i].low >>> 0, object.shiftTemplateIds[i].high >>> 0).toNumber();
                        }
                        if (object.maxPartTimeHours != null)
                            message.maxPartTimeHours = Number(object.maxPartTimeHours);
                        if (object.areaAutoScheduleOptions) {
                            if (!Array.isArray(object.areaAutoScheduleOptions))
                                throw TypeError(".palexy.streaming.v1.AutoSchedulePreference.areaAutoScheduleOptions: array expected");
                            message.areaAutoScheduleOptions = [];
                            for (var i = 0; i < object.areaAutoScheduleOptions.length; ++i) {
                                if (typeof object.areaAutoScheduleOptions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AutoSchedulePreference.areaAutoScheduleOptions: object expected");
                                message.areaAutoScheduleOptions[i] = $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption.fromObject(object.areaAutoScheduleOptions[i]);
                            }
                        }
                        if (object.useScheduleTemplateForShiftGeneration != null)
                            message.useScheduleTemplateForShiftGeneration = Boolean(object.useScheduleTemplateForShiftGeneration);
                        if (object.maximumOverlappingWithUnavailabilityInMinutes != null)
                            message.maximumOverlappingWithUnavailabilityInMinutes = object.maximumOverlappingWithUnavailabilityInMinutes | 0;
                        if (object.useHistoricalAsInferredPreference != null)
                            message.useHistoricalAsInferredPreference = Boolean(object.useHistoricalAsInferredPreference);
                        if (object.allowShortShiftForFullTimeStaff != null)
                            message.allowShortShiftForFullTimeStaff = Boolean(object.allowShortShiftForFullTimeStaff);
                        if (object.allowExistingPublishedShifts != null)
                            message.allowExistingPublishedShifts = Boolean(object.allowExistingPublishedShifts);
                        if (object.hideStaffList != null)
                            message.hideStaffList = Boolean(object.hideStaffList);
                        if (object.autoAssignStartTimeForBreaks != null)
                            message.autoAssignStartTimeForBreaks = Boolean(object.autoAssignStartTimeForBreaks);
                        if (object.modelScheduleId != null)
                            if ($util.Long)
                                (message.modelScheduleId = $util.Long.fromValue(object.modelScheduleId)).unsigned = false;
                            else if (typeof object.modelScheduleId === "string")
                                message.modelScheduleId = parseInt(object.modelScheduleId, 10);
                            else if (typeof object.modelScheduleId === "number")
                                message.modelScheduleId = object.modelScheduleId;
                            else if (typeof object.modelScheduleId === "object")
                                message.modelScheduleId = new $util.LongBits(object.modelScheduleId.low >>> 0, object.modelScheduleId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AutoSchedulePreference message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @static
                     * @param {palexy.streaming.v1.AutoSchedulePreference} message AutoSchedulePreference
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AutoSchedulePreference.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.shiftTemplateIds = [];
                            object.areaAutoScheduleOptions = [];
                        }
                        if (options.defaults) {
                            object.maxPartTimeHours = 0;
                            object.useScheduleTemplateForShiftGeneration = false;
                            object.maximumOverlappingWithUnavailabilityInMinutes = 0;
                            object.useHistoricalAsInferredPreference = false;
                            object.allowShortShiftForFullTimeStaff = false;
                            object.allowExistingPublishedShifts = false;
                            object.hideStaffList = false;
                            object.autoAssignStartTimeForBreaks = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.modelScheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.modelScheduleId = options.longs === String ? "0" : 0;
                        }
                        if (message.shiftTemplateIds && message.shiftTemplateIds.length) {
                            object.shiftTemplateIds = [];
                            for (var j = 0; j < message.shiftTemplateIds.length; ++j)
                                if (typeof message.shiftTemplateIds[j] === "number")
                                    object.shiftTemplateIds[j] = options.longs === String ? String(message.shiftTemplateIds[j]) : message.shiftTemplateIds[j];
                                else
                                    object.shiftTemplateIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateIds[j]) : options.longs === Number ? new $util.LongBits(message.shiftTemplateIds[j].low >>> 0, message.shiftTemplateIds[j].high >>> 0).toNumber() : message.shiftTemplateIds[j];
                        }
                        if (message.maxPartTimeHours != null && message.hasOwnProperty("maxPartTimeHours"))
                            object.maxPartTimeHours = options.json && !isFinite(message.maxPartTimeHours) ? String(message.maxPartTimeHours) : message.maxPartTimeHours;
                        if (message.areaAutoScheduleOptions && message.areaAutoScheduleOptions.length) {
                            object.areaAutoScheduleOptions = [];
                            for (var j = 0; j < message.areaAutoScheduleOptions.length; ++j)
                                object.areaAutoScheduleOptions[j] = $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption.toObject(message.areaAutoScheduleOptions[j], options);
                        }
                        if (message.useScheduleTemplateForShiftGeneration != null && message.hasOwnProperty("useScheduleTemplateForShiftGeneration"))
                            object.useScheduleTemplateForShiftGeneration = message.useScheduleTemplateForShiftGeneration;
                        if (message.maximumOverlappingWithUnavailabilityInMinutes != null && message.hasOwnProperty("maximumOverlappingWithUnavailabilityInMinutes"))
                            object.maximumOverlappingWithUnavailabilityInMinutes = message.maximumOverlappingWithUnavailabilityInMinutes;
                        if (message.useHistoricalAsInferredPreference != null && message.hasOwnProperty("useHistoricalAsInferredPreference"))
                            object.useHistoricalAsInferredPreference = message.useHistoricalAsInferredPreference;
                        if (message.allowShortShiftForFullTimeStaff != null && message.hasOwnProperty("allowShortShiftForFullTimeStaff"))
                            object.allowShortShiftForFullTimeStaff = message.allowShortShiftForFullTimeStaff;
                        if (message.allowExistingPublishedShifts != null && message.hasOwnProperty("allowExistingPublishedShifts"))
                            object.allowExistingPublishedShifts = message.allowExistingPublishedShifts;
                        if (message.hideStaffList != null && message.hasOwnProperty("hideStaffList"))
                            object.hideStaffList = message.hideStaffList;
                        if (message.autoAssignStartTimeForBreaks != null && message.hasOwnProperty("autoAssignStartTimeForBreaks"))
                            object.autoAssignStartTimeForBreaks = message.autoAssignStartTimeForBreaks;
                        if (message.modelScheduleId != null && message.hasOwnProperty("modelScheduleId"))
                            if (typeof message.modelScheduleId === "number")
                                object.modelScheduleId = options.longs === String ? String(message.modelScheduleId) : message.modelScheduleId;
                            else
                                object.modelScheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.modelScheduleId) : options.longs === Number ? new $util.LongBits(message.modelScheduleId.low >>> 0, message.modelScheduleId.high >>> 0).toNumber() : message.modelScheduleId;
                        return object;
                    };
    
                    /**
                     * Converts this AutoSchedulePreference to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AutoSchedulePreference
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AutoSchedulePreference.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    AutoSchedulePreference.AreaOption = (function() {
    
                        /**
                         * Properties of an AreaOption.
                         * @memberof palexy.streaming.v1.AutoSchedulePreference
                         * @interface IAreaOption
                         * @property {number|null} [areaId] AreaOption areaId
                         * @property {boolean|null} [ignoreWhenAutoScheduling] AreaOption ignoreWhenAutoScheduling
                         * @property {boolean|null} [copyFromLastPeriod] AreaOption copyFromLastPeriod
                         */
    
                        /**
                         * Constructs a new AreaOption.
                         * @memberof palexy.streaming.v1.AutoSchedulePreference
                         * @classdesc Represents an AreaOption.
                         * @implements IAreaOption
                         * @constructor
                         * @param {palexy.streaming.v1.AutoSchedulePreference.IAreaOption=} [properties] Properties to set
                         */
                        function AreaOption(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AreaOption areaId.
                         * @member {number} areaId
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @instance
                         */
                        AreaOption.prototype.areaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AreaOption ignoreWhenAutoScheduling.
                         * @member {boolean} ignoreWhenAutoScheduling
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @instance
                         */
                        AreaOption.prototype.ignoreWhenAutoScheduling = false;
    
                        /**
                         * AreaOption copyFromLastPeriod.
                         * @member {boolean} copyFromLastPeriod
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @instance
                         */
                        AreaOption.prototype.copyFromLastPeriod = false;
    
                        /**
                         * Creates a new AreaOption instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {palexy.streaming.v1.AutoSchedulePreference.IAreaOption=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AutoSchedulePreference.AreaOption} AreaOption instance
                         */
                        AreaOption.create = function create(properties) {
                            return new AreaOption(properties);
                        };
    
                        /**
                         * Encodes the specified AreaOption message. Does not implicitly {@link palexy.streaming.v1.AutoSchedulePreference.AreaOption.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {palexy.streaming.v1.AutoSchedulePreference.IAreaOption} message AreaOption message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AreaOption.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.areaId);
                            if (message.ignoreWhenAutoScheduling != null && Object.hasOwnProperty.call(message, "ignoreWhenAutoScheduling"))
                                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.ignoreWhenAutoScheduling);
                            if (message.copyFromLastPeriod != null && Object.hasOwnProperty.call(message, "copyFromLastPeriod"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.copyFromLastPeriod);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AreaOption message, length delimited. Does not implicitly {@link palexy.streaming.v1.AutoSchedulePreference.AreaOption.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {palexy.streaming.v1.AutoSchedulePreference.IAreaOption} message AreaOption message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AreaOption.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AreaOption message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AutoSchedulePreference.AreaOption} AreaOption
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AreaOption.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.areaId = reader.int64();
                                    break;
                                case 2:
                                    message.ignoreWhenAutoScheduling = reader.bool();
                                    break;
                                case 3:
                                    message.copyFromLastPeriod = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AreaOption message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AutoSchedulePreference.AreaOption} AreaOption
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AreaOption.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AreaOption message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AreaOption.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.areaId != null && message.hasOwnProperty("areaId"))
                                if (!$util.isInteger(message.areaId) && !(message.areaId && $util.isInteger(message.areaId.low) && $util.isInteger(message.areaId.high)))
                                    return "areaId: integer|Long expected";
                            if (message.ignoreWhenAutoScheduling != null && message.hasOwnProperty("ignoreWhenAutoScheduling"))
                                if (typeof message.ignoreWhenAutoScheduling !== "boolean")
                                    return "ignoreWhenAutoScheduling: boolean expected";
                            if (message.copyFromLastPeriod != null && message.hasOwnProperty("copyFromLastPeriod"))
                                if (typeof message.copyFromLastPeriod !== "boolean")
                                    return "copyFromLastPeriod: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates an AreaOption message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AutoSchedulePreference.AreaOption} AreaOption
                         */
                        AreaOption.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption)
                                return object;
                            var message = new $root.palexy.streaming.v1.AutoSchedulePreference.AreaOption();
                            if (object.areaId != null)
                                if ($util.Long)
                                    (message.areaId = $util.Long.fromValue(object.areaId)).unsigned = false;
                                else if (typeof object.areaId === "string")
                                    message.areaId = parseInt(object.areaId, 10);
                                else if (typeof object.areaId === "number")
                                    message.areaId = object.areaId;
                                else if (typeof object.areaId === "object")
                                    message.areaId = new $util.LongBits(object.areaId.low >>> 0, object.areaId.high >>> 0).toNumber();
                            if (object.ignoreWhenAutoScheduling != null)
                                message.ignoreWhenAutoScheduling = Boolean(object.ignoreWhenAutoScheduling);
                            if (object.copyFromLastPeriod != null)
                                message.copyFromLastPeriod = Boolean(object.copyFromLastPeriod);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AreaOption message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @static
                         * @param {palexy.streaming.v1.AutoSchedulePreference.AreaOption} message AreaOption
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AreaOption.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.areaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.areaId = options.longs === String ? "0" : 0;
                                object.ignoreWhenAutoScheduling = false;
                                object.copyFromLastPeriod = false;
                            }
                            if (message.areaId != null && message.hasOwnProperty("areaId"))
                                if (typeof message.areaId === "number")
                                    object.areaId = options.longs === String ? String(message.areaId) : message.areaId;
                                else
                                    object.areaId = options.longs === String ? $util.Long.prototype.toString.call(message.areaId) : options.longs === Number ? new $util.LongBits(message.areaId.low >>> 0, message.areaId.high >>> 0).toNumber() : message.areaId;
                            if (message.ignoreWhenAutoScheduling != null && message.hasOwnProperty("ignoreWhenAutoScheduling"))
                                object.ignoreWhenAutoScheduling = message.ignoreWhenAutoScheduling;
                            if (message.copyFromLastPeriod != null && message.hasOwnProperty("copyFromLastPeriod"))
                                object.copyFromLastPeriod = message.copyFromLastPeriod;
                            return object;
                        };
    
                        /**
                         * Converts this AreaOption to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AutoSchedulePreference.AreaOption
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AreaOption.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AreaOption;
                    })();
    
                    return AutoSchedulePreference;
                })();
    
                v1.StoreIntegrationConfig = (function() {
    
                    /**
                     * Properties of a StoreIntegrationConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreIntegrationConfig
                     * @property {string|null} [posStoreCode] StoreIntegrationConfig posStoreCode
                     * @property {string|null} [staffingStoreCode] StoreIntegrationConfig staffingStoreCode
                     * @property {string|null} [externalTrafficStoreCode] StoreIntegrationConfig externalTrafficStoreCode
                     */
    
                    /**
                     * Constructs a new StoreIntegrationConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreIntegrationConfig.
                     * @implements IStoreIntegrationConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreIntegrationConfig=} [properties] Properties to set
                     */
                    function StoreIntegrationConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreIntegrationConfig posStoreCode.
                     * @member {string} posStoreCode
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @instance
                     */
                    StoreIntegrationConfig.prototype.posStoreCode = "";
    
                    /**
                     * StoreIntegrationConfig staffingStoreCode.
                     * @member {string} staffingStoreCode
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @instance
                     */
                    StoreIntegrationConfig.prototype.staffingStoreCode = "";
    
                    /**
                     * StoreIntegrationConfig externalTrafficStoreCode.
                     * @member {string} externalTrafficStoreCode
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @instance
                     */
                    StoreIntegrationConfig.prototype.externalTrafficStoreCode = "";
    
                    /**
                     * Creates a new StoreIntegrationConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreIntegrationConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreIntegrationConfig} StoreIntegrationConfig instance
                     */
                    StoreIntegrationConfig.create = function create(properties) {
                        return new StoreIntegrationConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StoreIntegrationConfig message. Does not implicitly {@link palexy.streaming.v1.StoreIntegrationConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreIntegrationConfig} message StoreIntegrationConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIntegrationConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posStoreCode != null && Object.hasOwnProperty.call(message, "posStoreCode"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.posStoreCode);
                        if (message.staffingStoreCode != null && Object.hasOwnProperty.call(message, "staffingStoreCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.staffingStoreCode);
                        if (message.externalTrafficStoreCode != null && Object.hasOwnProperty.call(message, "externalTrafficStoreCode"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.externalTrafficStoreCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreIntegrationConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreIntegrationConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreIntegrationConfig} message StoreIntegrationConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIntegrationConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreIntegrationConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreIntegrationConfig} StoreIntegrationConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIntegrationConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreIntegrationConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.posStoreCode = reader.string();
                                break;
                            case 2:
                                message.staffingStoreCode = reader.string();
                                break;
                            case 3:
                                message.externalTrafficStoreCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreIntegrationConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreIntegrationConfig} StoreIntegrationConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIntegrationConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreIntegrationConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreIntegrationConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posStoreCode != null && message.hasOwnProperty("posStoreCode"))
                            if (!$util.isString(message.posStoreCode))
                                return "posStoreCode: string expected";
                        if (message.staffingStoreCode != null && message.hasOwnProperty("staffingStoreCode"))
                            if (!$util.isString(message.staffingStoreCode))
                                return "staffingStoreCode: string expected";
                        if (message.externalTrafficStoreCode != null && message.hasOwnProperty("externalTrafficStoreCode"))
                            if (!$util.isString(message.externalTrafficStoreCode))
                                return "externalTrafficStoreCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreIntegrationConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreIntegrationConfig} StoreIntegrationConfig
                     */
                    StoreIntegrationConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreIntegrationConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreIntegrationConfig();
                        if (object.posStoreCode != null)
                            message.posStoreCode = String(object.posStoreCode);
                        if (object.staffingStoreCode != null)
                            message.staffingStoreCode = String(object.staffingStoreCode);
                        if (object.externalTrafficStoreCode != null)
                            message.externalTrafficStoreCode = String(object.externalTrafficStoreCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreIntegrationConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @static
                     * @param {palexy.streaming.v1.StoreIntegrationConfig} message StoreIntegrationConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreIntegrationConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.posStoreCode = "";
                            object.staffingStoreCode = "";
                            object.externalTrafficStoreCode = "";
                        }
                        if (message.posStoreCode != null && message.hasOwnProperty("posStoreCode"))
                            object.posStoreCode = message.posStoreCode;
                        if (message.staffingStoreCode != null && message.hasOwnProperty("staffingStoreCode"))
                            object.staffingStoreCode = message.staffingStoreCode;
                        if (message.externalTrafficStoreCode != null && message.hasOwnProperty("externalTrafficStoreCode"))
                            object.externalTrafficStoreCode = message.externalTrafficStoreCode;
                        return object;
                    };
    
                    /**
                     * Converts this StoreIntegrationConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreIntegrationConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreIntegrationConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreIntegrationConfig;
                })();
    
                v1.GetStoreRequest = (function() {
    
                    /**
                     * Properties of a GetStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreRequest
                     * @property {string|null} [name] GetStoreRequest name
                     * @property {number|null} [id] GetStoreRequest id
                     * @property {boolean|null} [includeCompanyInfo] GetStoreRequest includeCompanyInfo
                     * @property {boolean|null} [includeStoreIntegrationConfig] GetStoreRequest includeStoreIntegrationConfig
                     * @property {boolean|null} [includeAreaInfo] GetStoreRequest includeAreaInfo
                     * @property {google.protobuf.IFieldMask|null} [fieldMask] GetStoreRequest fieldMask
                     * @property {boolean|null} [includeCameraInfo] GetStoreRequest includeCameraInfo
                     */
    
                    /**
                     * Constructs a new GetStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreRequest.
                     * @implements IGetStoreRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreRequest=} [properties] Properties to set
                     */
                    function GetStoreRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.name = "";
    
                    /**
                     * GetStoreRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetStoreRequest includeCompanyInfo.
                     * @member {boolean} includeCompanyInfo
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.includeCompanyInfo = false;
    
                    /**
                     * GetStoreRequest includeStoreIntegrationConfig.
                     * @member {boolean} includeStoreIntegrationConfig
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.includeStoreIntegrationConfig = false;
    
                    /**
                     * GetStoreRequest includeAreaInfo.
                     * @member {boolean} includeAreaInfo
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.includeAreaInfo = false;
    
                    /**
                     * GetStoreRequest fieldMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} fieldMask
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.fieldMask = null;
    
                    /**
                     * GetStoreRequest includeCameraInfo.
                     * @member {boolean} includeCameraInfo
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     */
                    GetStoreRequest.prototype.includeCameraInfo = false;
    
                    /**
                     * Creates a new GetStoreRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreRequest} GetStoreRequest instance
                     */
                    GetStoreRequest.create = function create(properties) {
                        return new GetStoreRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreRequest} message GetStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.id);
                        if (message.includeCompanyInfo != null && Object.hasOwnProperty.call(message, "includeCompanyInfo"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeCompanyInfo);
                        if (message.includeStoreIntegrationConfig != null && Object.hasOwnProperty.call(message, "includeStoreIntegrationConfig"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeStoreIntegrationConfig);
                        if (message.includeAreaInfo != null && Object.hasOwnProperty.call(message, "includeAreaInfo"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeAreaInfo);
                        if (message.fieldMask != null && Object.hasOwnProperty.call(message, "fieldMask"))
                            $root.google.protobuf.FieldMask.encode(message.fieldMask, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.includeCameraInfo != null && Object.hasOwnProperty.call(message, "includeCameraInfo"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeCameraInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreRequest} message GetStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreRequest} GetStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.id = reader.int64();
                                break;
                            case 3:
                                message.includeCompanyInfo = reader.bool();
                                break;
                            case 4:
                                message.includeStoreIntegrationConfig = reader.bool();
                                break;
                            case 5:
                                message.includeAreaInfo = reader.bool();
                                break;
                            case 6:
                                message.fieldMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.includeCameraInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreRequest} GetStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            if (typeof message.includeCompanyInfo !== "boolean")
                                return "includeCompanyInfo: boolean expected";
                        if (message.includeStoreIntegrationConfig != null && message.hasOwnProperty("includeStoreIntegrationConfig"))
                            if (typeof message.includeStoreIntegrationConfig !== "boolean")
                                return "includeStoreIntegrationConfig: boolean expected";
                        if (message.includeAreaInfo != null && message.hasOwnProperty("includeAreaInfo"))
                            if (typeof message.includeAreaInfo !== "boolean")
                                return "includeAreaInfo: boolean expected";
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.fieldMask);
                            if (error)
                                return "fieldMask." + error;
                        }
                        if (message.includeCameraInfo != null && message.hasOwnProperty("includeCameraInfo"))
                            if (typeof message.includeCameraInfo !== "boolean")
                                return "includeCameraInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreRequest} GetStoreRequest
                     */
                    GetStoreRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.includeCompanyInfo != null)
                            message.includeCompanyInfo = Boolean(object.includeCompanyInfo);
                        if (object.includeStoreIntegrationConfig != null)
                            message.includeStoreIntegrationConfig = Boolean(object.includeStoreIntegrationConfig);
                        if (object.includeAreaInfo != null)
                            message.includeAreaInfo = Boolean(object.includeAreaInfo);
                        if (object.fieldMask != null) {
                            if (typeof object.fieldMask !== "object")
                                throw TypeError(".palexy.streaming.v1.GetStoreRequest.fieldMask: object expected");
                            message.fieldMask = $root.google.protobuf.FieldMask.fromObject(object.fieldMask);
                        }
                        if (object.includeCameraInfo != null)
                            message.includeCameraInfo = Boolean(object.includeCameraInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreRequest} message GetStoreRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.includeCompanyInfo = false;
                            object.includeStoreIntegrationConfig = false;
                            object.includeAreaInfo = false;
                            object.fieldMask = null;
                            object.includeCameraInfo = false;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            object.includeCompanyInfo = message.includeCompanyInfo;
                        if (message.includeStoreIntegrationConfig != null && message.hasOwnProperty("includeStoreIntegrationConfig"))
                            object.includeStoreIntegrationConfig = message.includeStoreIntegrationConfig;
                        if (message.includeAreaInfo != null && message.hasOwnProperty("includeAreaInfo"))
                            object.includeAreaInfo = message.includeAreaInfo;
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask"))
                            object.fieldMask = $root.google.protobuf.FieldMask.toObject(message.fieldMask, options);
                        if (message.includeCameraInfo != null && message.hasOwnProperty("includeCameraInfo"))
                            object.includeCameraInfo = message.includeCameraInfo;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreRequest;
                })();
    
                v1.ListStoresRequest = (function() {
    
                    /**
                     * Properties of a ListStoresRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoresRequest
                     * @property {boolean|null} [isProcessingOnly] ListStoresRequest isProcessingOnly
                     * @property {number|null} [companyId] ListStoresRequest companyId
                     * @property {boolean|null} [includeStoreIntegrationConfig] ListStoresRequest includeStoreIntegrationConfig
                     * @property {string|null} [streamingLocation] ListStoresRequest streamingLocation
                     * @property {number|null} [pageSize] ListStoresRequest pageSize
                     * @property {string|null} [pageToken] ListStoresRequest pageToken
                     * @property {boolean|null} [includeDeletedStores] ListStoresRequest includeDeletedStores
                     * @property {google.protobuf.IFieldMask|null} [fieldMask] ListStoresRequest fieldMask
                     * @property {google.protobuf.IBoolValue|null} [isReadyToCheckView] ListStoresRequest isReadyToCheckView
                     */
    
                    /**
                     * Constructs a new ListStoresRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoresRequest.
                     * @implements IListStoresRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoresRequest=} [properties] Properties to set
                     */
                    function ListStoresRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoresRequest isProcessingOnly.
                     * @member {boolean} isProcessingOnly
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.isProcessingOnly = false;
    
                    /**
                     * ListStoresRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoresRequest includeStoreIntegrationConfig.
                     * @member {boolean} includeStoreIntegrationConfig
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.includeStoreIntegrationConfig = false;
    
                    /**
                     * ListStoresRequest streamingLocation.
                     * @member {string} streamingLocation
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.streamingLocation = "";
    
                    /**
                     * ListStoresRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStoresRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.pageToken = "";
    
                    /**
                     * ListStoresRequest includeDeletedStores.
                     * @member {boolean} includeDeletedStores
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.includeDeletedStores = false;
    
                    /**
                     * ListStoresRequest fieldMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} fieldMask
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.fieldMask = null;
    
                    /**
                     * ListStoresRequest isReadyToCheckView.
                     * @member {google.protobuf.IBoolValue|null|undefined} isReadyToCheckView
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     */
                    ListStoresRequest.prototype.isReadyToCheckView = null;
    
                    /**
                     * Creates a new ListStoresRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoresRequest} ListStoresRequest instance
                     */
                    ListStoresRequest.create = function create(properties) {
                        return new ListStoresRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoresRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoresRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresRequest} message ListStoresRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isProcessingOnly != null && Object.hasOwnProperty.call(message, "isProcessingOnly"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.isProcessingOnly);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.includeStoreIntegrationConfig != null && Object.hasOwnProperty.call(message, "includeStoreIntegrationConfig"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeStoreIntegrationConfig);
                        if (message.streamingLocation != null && Object.hasOwnProperty.call(message, "streamingLocation"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.streamingLocation);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.fieldMask != null && Object.hasOwnProperty.call(message, "fieldMask"))
                            $root.google.protobuf.FieldMask.encode(message.fieldMask, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.isReadyToCheckView != null && Object.hasOwnProperty.call(message, "isReadyToCheckView"))
                            $root.google.protobuf.BoolValue.encode(message.isReadyToCheckView, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.includeDeletedStores != null && Object.hasOwnProperty.call(message, "includeDeletedStores"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.includeDeletedStores);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoresRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoresRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresRequest} message ListStoresRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoresRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoresRequest} ListStoresRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoresRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.isProcessingOnly = reader.bool();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.includeStoreIntegrationConfig = reader.bool();
                                break;
                            case 4:
                                message.streamingLocation = reader.string();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 9:
                                message.includeDeletedStores = reader.bool();
                                break;
                            case 7:
                                message.fieldMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.isReadyToCheckView = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoresRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoresRequest} ListStoresRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoresRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoresRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isProcessingOnly != null && message.hasOwnProperty("isProcessingOnly"))
                            if (typeof message.isProcessingOnly !== "boolean")
                                return "isProcessingOnly: boolean expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.includeStoreIntegrationConfig != null && message.hasOwnProperty("includeStoreIntegrationConfig"))
                            if (typeof message.includeStoreIntegrationConfig !== "boolean")
                                return "includeStoreIntegrationConfig: boolean expected";
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            if (!$util.isString(message.streamingLocation))
                                return "streamingLocation: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.includeDeletedStores != null && message.hasOwnProperty("includeDeletedStores"))
                            if (typeof message.includeDeletedStores !== "boolean")
                                return "includeDeletedStores: boolean expected";
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.fieldMask);
                            if (error)
                                return "fieldMask." + error;
                        }
                        if (message.isReadyToCheckView != null && message.hasOwnProperty("isReadyToCheckView")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isReadyToCheckView);
                            if (error)
                                return "isReadyToCheckView." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoresRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoresRequest} ListStoresRequest
                     */
                    ListStoresRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoresRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoresRequest();
                        if (object.isProcessingOnly != null)
                            message.isProcessingOnly = Boolean(object.isProcessingOnly);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.includeStoreIntegrationConfig != null)
                            message.includeStoreIntegrationConfig = Boolean(object.includeStoreIntegrationConfig);
                        if (object.streamingLocation != null)
                            message.streamingLocation = String(object.streamingLocation);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.includeDeletedStores != null)
                            message.includeDeletedStores = Boolean(object.includeDeletedStores);
                        if (object.fieldMask != null) {
                            if (typeof object.fieldMask !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStoresRequest.fieldMask: object expected");
                            message.fieldMask = $root.google.protobuf.FieldMask.fromObject(object.fieldMask);
                        }
                        if (object.isReadyToCheckView != null) {
                            if (typeof object.isReadyToCheckView !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStoresRequest.isReadyToCheckView: object expected");
                            message.isReadyToCheckView = $root.google.protobuf.BoolValue.fromObject(object.isReadyToCheckView);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoresRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoresRequest} message ListStoresRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoresRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.isProcessingOnly = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.includeStoreIntegrationConfig = false;
                            object.streamingLocation = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.fieldMask = null;
                            object.isReadyToCheckView = null;
                            object.includeDeletedStores = false;
                        }
                        if (message.isProcessingOnly != null && message.hasOwnProperty("isProcessingOnly"))
                            object.isProcessingOnly = message.isProcessingOnly;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.includeStoreIntegrationConfig != null && message.hasOwnProperty("includeStoreIntegrationConfig"))
                            object.includeStoreIntegrationConfig = message.includeStoreIntegrationConfig;
                        if (message.streamingLocation != null && message.hasOwnProperty("streamingLocation"))
                            object.streamingLocation = message.streamingLocation;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.fieldMask != null && message.hasOwnProperty("fieldMask"))
                            object.fieldMask = $root.google.protobuf.FieldMask.toObject(message.fieldMask, options);
                        if (message.isReadyToCheckView != null && message.hasOwnProperty("isReadyToCheckView"))
                            object.isReadyToCheckView = $root.google.protobuf.BoolValue.toObject(message.isReadyToCheckView, options);
                        if (message.includeDeletedStores != null && message.hasOwnProperty("includeDeletedStores"))
                            object.includeDeletedStores = message.includeDeletedStores;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoresRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoresRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoresRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoresRequest;
                })();
    
                v1.ListStoresForTrendRequest = (function() {
    
                    /**
                     * Properties of a ListStoresForTrendRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoresForTrendRequest
                     * @property {Array.<number>|null} [storeIds] ListStoresForTrendRequest storeIds
                     * @property {boolean|null} [includeOptedOutStores] ListStoresForTrendRequest includeOptedOutStores
                     */
    
                    /**
                     * Constructs a new ListStoresForTrendRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoresForTrendRequest.
                     * @implements IListStoresForTrendRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest=} [properties] Properties to set
                     */
                    function ListStoresForTrendRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoresForTrendRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @instance
                     */
                    ListStoresForTrendRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListStoresForTrendRequest includeOptedOutStores.
                     * @member {boolean} includeOptedOutStores
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @instance
                     */
                    ListStoresForTrendRequest.prototype.includeOptedOutStores = false;
    
                    /**
                     * Creates a new ListStoresForTrendRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoresForTrendRequest} ListStoresForTrendRequest instance
                     */
                    ListStoresForTrendRequest.create = function create(properties) {
                        return new ListStoresForTrendRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoresForTrendRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoresForTrendRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest} message ListStoresForTrendRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresForTrendRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.includeOptedOutStores != null && Object.hasOwnProperty.call(message, "includeOptedOutStores"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeOptedOutStores);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoresForTrendRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoresForTrendRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresForTrendRequest} message ListStoresForTrendRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresForTrendRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoresForTrendRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoresForTrendRequest} ListStoresForTrendRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresForTrendRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoresForTrendRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.includeOptedOutStores = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoresForTrendRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoresForTrendRequest} ListStoresForTrendRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresForTrendRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoresForTrendRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoresForTrendRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.includeOptedOutStores != null && message.hasOwnProperty("includeOptedOutStores"))
                            if (typeof message.includeOptedOutStores !== "boolean")
                                return "includeOptedOutStores: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoresForTrendRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoresForTrendRequest} ListStoresForTrendRequest
                     */
                    ListStoresForTrendRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoresForTrendRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoresForTrendRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListStoresForTrendRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.includeOptedOutStores != null)
                            message.includeOptedOutStores = Boolean(object.includeOptedOutStores);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoresForTrendRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoresForTrendRequest} message ListStoresForTrendRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoresForTrendRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults)
                            object.includeOptedOutStores = false;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.includeOptedOutStores != null && message.hasOwnProperty("includeOptedOutStores"))
                            object.includeOptedOutStores = message.includeOptedOutStores;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoresForTrendRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoresForTrendRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoresForTrendRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoresForTrendRequest;
                })();
    
                v1.ListStoresResponse = (function() {
    
                    /**
                     * Properties of a ListStoresResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoresResponse
                     * @property {Array.<palexy.streaming.v1.IStore>|null} [stores] ListStoresResponse stores
                     * @property {string|null} [nextPageToken] ListStoresResponse nextPageToken
                     * @property {number|null} [totalElements] ListStoresResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStoresResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoresResponse.
                     * @implements IListStoresResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoresResponse=} [properties] Properties to set
                     */
                    function ListStoresResponse(properties) {
                        this.stores = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoresResponse stores.
                     * @member {Array.<palexy.streaming.v1.IStore>} stores
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @instance
                     */
                    ListStoresResponse.prototype.stores = $util.emptyArray;
    
                    /**
                     * ListStoresResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @instance
                     */
                    ListStoresResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStoresResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @instance
                     */
                    ListStoresResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStoresResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoresResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoresResponse} ListStoresResponse instance
                     */
                    ListStoresResponse.create = function create(properties) {
                        return new ListStoresResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoresResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoresResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoresResponse} message ListStoresResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.stores != null && message.stores.length)
                            for (var i = 0; i < message.stores.length; ++i)
                                $root.palexy.streaming.v1.Store.encode(message.stores[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoresResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoresResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoresResponse} message ListStoresResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoresResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoresResponse} ListStoresResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoresResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.stores && message.stores.length))
                                    message.stores = [];
                                message.stores.push($root.palexy.streaming.v1.Store.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoresResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoresResponse} ListStoresResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoresResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoresResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.stores != null && message.hasOwnProperty("stores")) {
                            if (!Array.isArray(message.stores))
                                return "stores: array expected";
                            for (var i = 0; i < message.stores.length; ++i) {
                                var error = $root.palexy.streaming.v1.Store.verify(message.stores[i]);
                                if (error)
                                    return "stores." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoresResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoresResponse} ListStoresResponse
                     */
                    ListStoresResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoresResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoresResponse();
                        if (object.stores) {
                            if (!Array.isArray(object.stores))
                                throw TypeError(".palexy.streaming.v1.ListStoresResponse.stores: array expected");
                            message.stores = [];
                            for (var i = 0; i < object.stores.length; ++i) {
                                if (typeof object.stores[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoresResponse.stores: object expected");
                                message.stores[i] = $root.palexy.streaming.v1.Store.fromObject(object.stores[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoresResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoresResponse} message ListStoresResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoresResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.stores = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.stores && message.stores.length) {
                            object.stores = [];
                            for (var j = 0; j < message.stores.length; ++j)
                                object.stores[j] = $root.palexy.streaming.v1.Store.toObject(message.stores[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoresResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoresResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoresResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoresResponse;
                })();
    
                v1.ListStoresOfWeatherIntegrationEnabledRequest = (function() {
    
                    /**
                     * Properties of a ListStoresOfWeatherIntegrationEnabledRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoresOfWeatherIntegrationEnabledRequest
                     */
    
                    /**
                     * Constructs a new ListStoresOfWeatherIntegrationEnabledRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoresOfWeatherIntegrationEnabledRequest.
                     * @implements IListStoresOfWeatherIntegrationEnabledRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest=} [properties] Properties to set
                     */
                    function ListStoresOfWeatherIntegrationEnabledRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ListStoresOfWeatherIntegrationEnabledRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest} ListStoresOfWeatherIntegrationEnabledRequest instance
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.create = function create(properties) {
                        return new ListStoresOfWeatherIntegrationEnabledRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoresOfWeatherIntegrationEnabledRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest} message ListStoresOfWeatherIntegrationEnabledRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoresOfWeatherIntegrationEnabledRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresOfWeatherIntegrationEnabledRequest} message ListStoresOfWeatherIntegrationEnabledRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoresOfWeatherIntegrationEnabledRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest} ListStoresOfWeatherIntegrationEnabledRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoresOfWeatherIntegrationEnabledRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest} ListStoresOfWeatherIntegrationEnabledRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoresOfWeatherIntegrationEnabledRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoresOfWeatherIntegrationEnabledRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest} ListStoresOfWeatherIntegrationEnabledRequest
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest)
                            return object;
                        return new $root.palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest();
                    };
    
                    /**
                     * Creates a plain object from a ListStoresOfWeatherIntegrationEnabledRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest} message ListStoresOfWeatherIntegrationEnabledRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ListStoresOfWeatherIntegrationEnabledRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoresOfWeatherIntegrationEnabledRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoresOfWeatherIntegrationEnabledRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoresOfWeatherIntegrationEnabledRequest;
                })();
    
                v1.ListStoresToAdjustScheduleBudgetPlanningRequest = (function() {
    
                    /**
                     * Properties of a ListStoresToAdjustScheduleBudgetPlanningRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoresToAdjustScheduleBudgetPlanningRequest
                     */
    
                    /**
                     * Constructs a new ListStoresToAdjustScheduleBudgetPlanningRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoresToAdjustScheduleBudgetPlanningRequest.
                     * @implements IListStoresToAdjustScheduleBudgetPlanningRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest=} [properties] Properties to set
                     */
                    function ListStoresToAdjustScheduleBudgetPlanningRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ListStoresToAdjustScheduleBudgetPlanningRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest} ListStoresToAdjustScheduleBudgetPlanningRequest instance
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.create = function create(properties) {
                        return new ListStoresToAdjustScheduleBudgetPlanningRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoresToAdjustScheduleBudgetPlanningRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest} message ListStoresToAdjustScheduleBudgetPlanningRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoresToAdjustScheduleBudgetPlanningRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoresToAdjustScheduleBudgetPlanningRequest} message ListStoresToAdjustScheduleBudgetPlanningRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoresToAdjustScheduleBudgetPlanningRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest} ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoresToAdjustScheduleBudgetPlanningRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest} ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoresToAdjustScheduleBudgetPlanningRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoresToAdjustScheduleBudgetPlanningRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest} ListStoresToAdjustScheduleBudgetPlanningRequest
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest)
                            return object;
                        return new $root.palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest();
                    };
    
                    /**
                     * Creates a plain object from a ListStoresToAdjustScheduleBudgetPlanningRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest} message ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ListStoresToAdjustScheduleBudgetPlanningRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoresToAdjustScheduleBudgetPlanningRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoresToAdjustScheduleBudgetPlanningRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoresToAdjustScheduleBudgetPlanningRequest;
                })();
    
                v1.RerunMergingRequest = (function() {
    
                    /**
                     * Properties of a RerunMergingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IRerunMergingRequest
                     * @property {Array.<number>|null} [storeIds] RerunMergingRequest storeIds
                     * @property {Array.<palexy.streaming.v1.IDateRange>|null} [dateRanges] RerunMergingRequest dateRanges
                     */
    
                    /**
                     * Constructs a new RerunMergingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RerunMergingRequest.
                     * @implements IRerunMergingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IRerunMergingRequest=} [properties] Properties to set
                     */
                    function RerunMergingRequest(properties) {
                        this.storeIds = [];
                        this.dateRanges = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergingRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @instance
                     */
                    RerunMergingRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * RerunMergingRequest dateRanges.
                     * @member {Array.<palexy.streaming.v1.IDateRange>} dateRanges
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @instance
                     */
                    RerunMergingRequest.prototype.dateRanges = $util.emptyArray;
    
                    /**
                     * Creates a new RerunMergingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RerunMergingRequest} RerunMergingRequest instance
                     */
                    RerunMergingRequest.create = function create(properties) {
                        return new RerunMergingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergingRequest message. Does not implicitly {@link palexy.streaming.v1.RerunMergingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingRequest} message RerunMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.dateRanges != null && message.dateRanges.length)
                            for (var i = 0; i < message.dateRanges.length; ++i)
                                $root.palexy.streaming.v1.DateRange.encode(message.dateRanges[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.RerunMergingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingRequest} message RerunMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RerunMergingRequest} RerunMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RerunMergingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                if (!(message.dateRanges && message.dateRanges.length))
                                    message.dateRanges = [];
                                message.dateRanges.push($root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RerunMergingRequest} RerunMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.dateRanges != null && message.hasOwnProperty("dateRanges")) {
                            if (!Array.isArray(message.dateRanges))
                                return "dateRanges: array expected";
                            for (var i = 0; i < message.dateRanges.length; ++i) {
                                var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRanges[i]);
                                if (error)
                                    return "dateRanges." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RerunMergingRequest} RerunMergingRequest
                     */
                    RerunMergingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RerunMergingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.RerunMergingRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.RerunMergingRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.dateRanges) {
                            if (!Array.isArray(object.dateRanges))
                                throw TypeError(".palexy.streaming.v1.RerunMergingRequest.dateRanges: array expected");
                            message.dateRanges = [];
                            for (var i = 0; i < object.dateRanges.length; ++i) {
                                if (typeof object.dateRanges[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.RerunMergingRequest.dateRanges: object expected");
                                message.dateRanges[i] = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRanges[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.RerunMergingRequest} message RerunMergingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeIds = [];
                            object.dateRanges = [];
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.dateRanges && message.dateRanges.length) {
                            object.dateRanges = [];
                            for (var j = 0; j < message.dateRanges.length; ++j)
                                object.dateRanges[j] = $root.palexy.streaming.v1.DateRange.toObject(message.dateRanges[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RerunMergingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergingRequest;
                })();
    
                v1.RerunMergingResponse = (function() {
    
                    /**
                     * Properties of a RerunMergingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IRerunMergingResponse
                     * @property {number|null} [affectedRowsCount] RerunMergingResponse affectedRowsCount
                     */
    
                    /**
                     * Constructs a new RerunMergingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RerunMergingResponse.
                     * @implements IRerunMergingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IRerunMergingResponse=} [properties] Properties to set
                     */
                    function RerunMergingResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergingResponse affectedRowsCount.
                     * @member {number} affectedRowsCount
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @instance
                     */
                    RerunMergingResponse.prototype.affectedRowsCount = 0;
    
                    /**
                     * Creates a new RerunMergingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RerunMergingResponse} RerunMergingResponse instance
                     */
                    RerunMergingResponse.create = function create(properties) {
                        return new RerunMergingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergingResponse message. Does not implicitly {@link palexy.streaming.v1.RerunMergingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingResponse} message RerunMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.affectedRowsCount != null && Object.hasOwnProperty.call(message, "affectedRowsCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.affectedRowsCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.RerunMergingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingResponse} message RerunMergingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RerunMergingResponse} RerunMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RerunMergingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.affectedRowsCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RerunMergingResponse} RerunMergingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            if (!$util.isInteger(message.affectedRowsCount))
                                return "affectedRowsCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RerunMergingResponse} RerunMergingResponse
                     */
                    RerunMergingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RerunMergingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.RerunMergingResponse();
                        if (object.affectedRowsCount != null)
                            message.affectedRowsCount = object.affectedRowsCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @static
                     * @param {palexy.streaming.v1.RerunMergingResponse} message RerunMergingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.affectedRowsCount = 0;
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            object.affectedRowsCount = message.affectedRowsCount;
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RerunMergingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergingResponse;
                })();
    
                v1.RerunMergingForChildStoreRequest = (function() {
    
                    /**
                     * Properties of a RerunMergingForChildStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IRerunMergingForChildStoreRequest
                     * @property {number|null} [storeId] RerunMergingForChildStoreRequest storeId
                     * @property {string|null} [dateId] RerunMergingForChildStoreRequest dateId
                     */
    
                    /**
                     * Constructs a new RerunMergingForChildStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RerunMergingForChildStoreRequest.
                     * @implements IRerunMergingForChildStoreRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest=} [properties] Properties to set
                     */
                    function RerunMergingForChildStoreRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergingForChildStoreRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @instance
                     */
                    RerunMergingForChildStoreRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RerunMergingForChildStoreRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @instance
                     */
                    RerunMergingForChildStoreRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new RerunMergingForChildStoreRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreRequest} RerunMergingForChildStoreRequest instance
                     */
                    RerunMergingForChildStoreRequest.create = function create(properties) {
                        return new RerunMergingForChildStoreRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergingForChildStoreRequest message. Does not implicitly {@link palexy.streaming.v1.RerunMergingForChildStoreRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest} message RerunMergingForChildStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingForChildStoreRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergingForChildStoreRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.RerunMergingForChildStoreRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreRequest} message RerunMergingForChildStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingForChildStoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergingForChildStoreRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreRequest} RerunMergingForChildStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingForChildStoreRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RerunMergingForChildStoreRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergingForChildStoreRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreRequest} RerunMergingForChildStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingForChildStoreRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergingForChildStoreRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergingForChildStoreRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergingForChildStoreRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreRequest} RerunMergingForChildStoreRequest
                     */
                    RerunMergingForChildStoreRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RerunMergingForChildStoreRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.RerunMergingForChildStoreRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergingForChildStoreRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.RerunMergingForChildStoreRequest} message RerunMergingForChildStoreRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergingForChildStoreRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergingForChildStoreRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergingForChildStoreRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergingForChildStoreRequest;
                })();
    
                v1.RerunMergingForChildStoreResponse = (function() {
    
                    /**
                     * Properties of a RerunMergingForChildStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IRerunMergingForChildStoreResponse
                     * @property {number|null} [affectedVideosCount] RerunMergingForChildStoreResponse affectedVideosCount
                     */
    
                    /**
                     * Constructs a new RerunMergingForChildStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RerunMergingForChildStoreResponse.
                     * @implements IRerunMergingForChildStoreResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreResponse=} [properties] Properties to set
                     */
                    function RerunMergingForChildStoreResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunMergingForChildStoreResponse affectedVideosCount.
                     * @member {number} affectedVideosCount
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @instance
                     */
                    RerunMergingForChildStoreResponse.prototype.affectedVideosCount = 0;
    
                    /**
                     * Creates a new RerunMergingForChildStoreResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreResponse} RerunMergingForChildStoreResponse instance
                     */
                    RerunMergingForChildStoreResponse.create = function create(properties) {
                        return new RerunMergingForChildStoreResponse(properties);
                    };
    
                    /**
                     * Encodes the specified RerunMergingForChildStoreResponse message. Does not implicitly {@link palexy.streaming.v1.RerunMergingForChildStoreResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreResponse} message RerunMergingForChildStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingForChildStoreResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.affectedVideosCount != null && Object.hasOwnProperty.call(message, "affectedVideosCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.affectedVideosCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunMergingForChildStoreResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.RerunMergingForChildStoreResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRerunMergingForChildStoreResponse} message RerunMergingForChildStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunMergingForChildStoreResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunMergingForChildStoreResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreResponse} RerunMergingForChildStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingForChildStoreResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RerunMergingForChildStoreResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.affectedVideosCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunMergingForChildStoreResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreResponse} RerunMergingForChildStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunMergingForChildStoreResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunMergingForChildStoreResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunMergingForChildStoreResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.affectedVideosCount != null && message.hasOwnProperty("affectedVideosCount"))
                            if (!$util.isInteger(message.affectedVideosCount))
                                return "affectedVideosCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a RerunMergingForChildStoreResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RerunMergingForChildStoreResponse} RerunMergingForChildStoreResponse
                     */
                    RerunMergingForChildStoreResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RerunMergingForChildStoreResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.RerunMergingForChildStoreResponse();
                        if (object.affectedVideosCount != null)
                            message.affectedVideosCount = object.affectedVideosCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunMergingForChildStoreResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.RerunMergingForChildStoreResponse} message RerunMergingForChildStoreResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunMergingForChildStoreResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.affectedVideosCount = 0;
                        if (message.affectedVideosCount != null && message.hasOwnProperty("affectedVideosCount"))
                            object.affectedVideosCount = message.affectedVideosCount;
                        return object;
                    };
    
                    /**
                     * Converts this RerunMergingForChildStoreResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RerunMergingForChildStoreResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunMergingForChildStoreResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunMergingForChildStoreResponse;
                })();
    
                v1.ValidateStoreForRerunMergingRequest = (function() {
    
                    /**
                     * Properties of a ValidateStoreForRerunMergingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IValidateStoreForRerunMergingRequest
                     * @property {number|null} [storeId] ValidateStoreForRerunMergingRequest storeId
                     * @property {string|null} [dateId] ValidateStoreForRerunMergingRequest dateId
                     */
    
                    /**
                     * Constructs a new ValidateStoreForRerunMergingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ValidateStoreForRerunMergingRequest.
                     * @implements IValidateStoreForRerunMergingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest=} [properties] Properties to set
                     */
                    function ValidateStoreForRerunMergingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ValidateStoreForRerunMergingRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @instance
                     */
                    ValidateStoreForRerunMergingRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ValidateStoreForRerunMergingRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @instance
                     */
                    ValidateStoreForRerunMergingRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new ValidateStoreForRerunMergingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ValidateStoreForRerunMergingRequest} ValidateStoreForRerunMergingRequest instance
                     */
                    ValidateStoreForRerunMergingRequest.create = function create(properties) {
                        return new ValidateStoreForRerunMergingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ValidateStoreForRerunMergingRequest message. Does not implicitly {@link palexy.streaming.v1.ValidateStoreForRerunMergingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest} message ValidateStoreForRerunMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStoreForRerunMergingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ValidateStoreForRerunMergingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ValidateStoreForRerunMergingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStoreForRerunMergingRequest} message ValidateStoreForRerunMergingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStoreForRerunMergingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ValidateStoreForRerunMergingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ValidateStoreForRerunMergingRequest} ValidateStoreForRerunMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStoreForRerunMergingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ValidateStoreForRerunMergingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ValidateStoreForRerunMergingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ValidateStoreForRerunMergingRequest} ValidateStoreForRerunMergingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStoreForRerunMergingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ValidateStoreForRerunMergingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ValidateStoreForRerunMergingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ValidateStoreForRerunMergingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ValidateStoreForRerunMergingRequest} ValidateStoreForRerunMergingRequest
                     */
                    ValidateStoreForRerunMergingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ValidateStoreForRerunMergingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ValidateStoreForRerunMergingRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ValidateStoreForRerunMergingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @static
                     * @param {palexy.streaming.v1.ValidateStoreForRerunMergingRequest} message ValidateStoreForRerunMergingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ValidateStoreForRerunMergingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this ValidateStoreForRerunMergingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ValidateStoreForRerunMergingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ValidateStoreForRerunMergingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ValidateStoreForRerunMergingRequest;
                })();
    
                v1.ListStoreProcessingStatusesRequest = (function() {
    
                    /**
                     * Properties of a ListStoreProcessingStatusesRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreProcessingStatusesRequest
                     * @property {number|null} [companyId] ListStoreProcessingStatusesRequest companyId
                     * @property {Array.<number>|null} [storeIds] ListStoreProcessingStatusesRequest storeIds
                     */
    
                    /**
                     * Constructs a new ListStoreProcessingStatusesRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreProcessingStatusesRequest.
                     * @implements IListStoreProcessingStatusesRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest=} [properties] Properties to set
                     */
                    function ListStoreProcessingStatusesRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreProcessingStatusesRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @instance
                     */
                    ListStoreProcessingStatusesRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreProcessingStatusesRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @instance
                     */
                    ListStoreProcessingStatusesRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreProcessingStatusesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesRequest} ListStoreProcessingStatusesRequest instance
                     */
                    ListStoreProcessingStatusesRequest.create = function create(properties) {
                        return new ListStoreProcessingStatusesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreProcessingStatusesRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreProcessingStatusesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest} message ListStoreProcessingStatusesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreProcessingStatusesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreProcessingStatusesRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreProcessingStatusesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesRequest} message ListStoreProcessingStatusesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreProcessingStatusesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreProcessingStatusesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesRequest} ListStoreProcessingStatusesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreProcessingStatusesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreProcessingStatusesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreProcessingStatusesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesRequest} ListStoreProcessingStatusesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreProcessingStatusesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreProcessingStatusesRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreProcessingStatusesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreProcessingStatusesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesRequest} ListStoreProcessingStatusesRequest
                     */
                    ListStoreProcessingStatusesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreProcessingStatusesRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreProcessingStatusesRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListStoreProcessingStatusesRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreProcessingStatusesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreProcessingStatusesRequest} message ListStoreProcessingStatusesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreProcessingStatusesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreProcessingStatusesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreProcessingStatusesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreProcessingStatusesRequest;
                })();
    
                v1.ListStoreProcessingStatusesResponse = (function() {
    
                    /**
                     * Properties of a ListStoreProcessingStatusesResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreProcessingStatusesResponse
                     * @property {Array.<palexy.streaming.v1.IStoreProcessingStatus>|null} [storeStatuses] ListStoreProcessingStatusesResponse storeStatuses
                     */
    
                    /**
                     * Constructs a new ListStoreProcessingStatusesResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreProcessingStatusesResponse.
                     * @implements IListStoreProcessingStatusesResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesResponse=} [properties] Properties to set
                     */
                    function ListStoreProcessingStatusesResponse(properties) {
                        this.storeStatuses = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreProcessingStatusesResponse storeStatuses.
                     * @member {Array.<palexy.streaming.v1.IStoreProcessingStatus>} storeStatuses
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @instance
                     */
                    ListStoreProcessingStatusesResponse.prototype.storeStatuses = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreProcessingStatusesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesResponse} ListStoreProcessingStatusesResponse instance
                     */
                    ListStoreProcessingStatusesResponse.create = function create(properties) {
                        return new ListStoreProcessingStatusesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreProcessingStatusesResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreProcessingStatusesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesResponse} message ListStoreProcessingStatusesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreProcessingStatusesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeStatuses != null && message.storeStatuses.length)
                            for (var i = 0; i < message.storeStatuses.length; ++i)
                                $root.palexy.streaming.v1.StoreProcessingStatus.encode(message.storeStatuses[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreProcessingStatusesResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreProcessingStatusesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreProcessingStatusesResponse} message ListStoreProcessingStatusesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreProcessingStatusesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreProcessingStatusesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesResponse} ListStoreProcessingStatusesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreProcessingStatusesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreProcessingStatusesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeStatuses && message.storeStatuses.length))
                                    message.storeStatuses = [];
                                message.storeStatuses.push($root.palexy.streaming.v1.StoreProcessingStatus.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreProcessingStatusesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesResponse} ListStoreProcessingStatusesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreProcessingStatusesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreProcessingStatusesResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreProcessingStatusesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeStatuses != null && message.hasOwnProperty("storeStatuses")) {
                            if (!Array.isArray(message.storeStatuses))
                                return "storeStatuses: array expected";
                            for (var i = 0; i < message.storeStatuses.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreProcessingStatus.verify(message.storeStatuses[i]);
                                if (error)
                                    return "storeStatuses." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreProcessingStatusesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreProcessingStatusesResponse} ListStoreProcessingStatusesResponse
                     */
                    ListStoreProcessingStatusesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreProcessingStatusesResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreProcessingStatusesResponse();
                        if (object.storeStatuses) {
                            if (!Array.isArray(object.storeStatuses))
                                throw TypeError(".palexy.streaming.v1.ListStoreProcessingStatusesResponse.storeStatuses: array expected");
                            message.storeStatuses = [];
                            for (var i = 0; i < object.storeStatuses.length; ++i) {
                                if (typeof object.storeStatuses[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreProcessingStatusesResponse.storeStatuses: object expected");
                                message.storeStatuses[i] = $root.palexy.streaming.v1.StoreProcessingStatus.fromObject(object.storeStatuses[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreProcessingStatusesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreProcessingStatusesResponse} message ListStoreProcessingStatusesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreProcessingStatusesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeStatuses = [];
                        if (message.storeStatuses && message.storeStatuses.length) {
                            object.storeStatuses = [];
                            for (var j = 0; j < message.storeStatuses.length; ++j)
                                object.storeStatuses[j] = $root.palexy.streaming.v1.StoreProcessingStatus.toObject(message.storeStatuses[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreProcessingStatusesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreProcessingStatusesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreProcessingStatusesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreProcessingStatusesResponse;
                })();
    
                v1.StoreProcessingStatus = (function() {
    
                    /**
                     * Properties of a StoreProcessingStatus.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreProcessingStatus
                     * @property {palexy.streaming.v1.IStore|null} [store] StoreProcessingStatus store
                     * @property {google.protobuf.IInt64Value|null} [lastAggregateTimeMs] StoreProcessingStatus lastAggregateTimeMs
                     * @property {boolean|null} [ready] StoreProcessingStatus ready
                     * @property {string|null} [latestTimeSlot] StoreProcessingStatus latestTimeSlot
                     */
    
                    /**
                     * Constructs a new StoreProcessingStatus.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreProcessingStatus.
                     * @implements IStoreProcessingStatus
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreProcessingStatus=} [properties] Properties to set
                     */
                    function StoreProcessingStatus(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreProcessingStatus store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @instance
                     */
                    StoreProcessingStatus.prototype.store = null;
    
                    /**
                     * StoreProcessingStatus lastAggregateTimeMs.
                     * @member {google.protobuf.IInt64Value|null|undefined} lastAggregateTimeMs
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @instance
                     */
                    StoreProcessingStatus.prototype.lastAggregateTimeMs = null;
    
                    /**
                     * StoreProcessingStatus ready.
                     * @member {boolean} ready
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @instance
                     */
                    StoreProcessingStatus.prototype.ready = false;
    
                    /**
                     * StoreProcessingStatus latestTimeSlot.
                     * @member {string} latestTimeSlot
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @instance
                     */
                    StoreProcessingStatus.prototype.latestTimeSlot = "";
    
                    /**
                     * Creates a new StoreProcessingStatus instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {palexy.streaming.v1.IStoreProcessingStatus=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreProcessingStatus} StoreProcessingStatus instance
                     */
                    StoreProcessingStatus.create = function create(properties) {
                        return new StoreProcessingStatus(properties);
                    };
    
                    /**
                     * Encodes the specified StoreProcessingStatus message. Does not implicitly {@link palexy.streaming.v1.StoreProcessingStatus.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {palexy.streaming.v1.IStoreProcessingStatus} message StoreProcessingStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreProcessingStatus.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.lastAggregateTimeMs != null && Object.hasOwnProperty.call(message, "lastAggregateTimeMs"))
                            $root.google.protobuf.Int64Value.encode(message.lastAggregateTimeMs, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.ready != null && Object.hasOwnProperty.call(message, "ready"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.ready);
                        if (message.latestTimeSlot != null && Object.hasOwnProperty.call(message, "latestTimeSlot"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.latestTimeSlot);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreProcessingStatus message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreProcessingStatus.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {palexy.streaming.v1.IStoreProcessingStatus} message StoreProcessingStatus message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreProcessingStatus.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreProcessingStatus message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreProcessingStatus} StoreProcessingStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreProcessingStatus.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreProcessingStatus();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.lastAggregateTimeMs = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.ready = reader.bool();
                                break;
                            case 4:
                                message.latestTimeSlot = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreProcessingStatus message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreProcessingStatus} StoreProcessingStatus
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreProcessingStatus.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreProcessingStatus message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreProcessingStatus.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.lastAggregateTimeMs != null && message.hasOwnProperty("lastAggregateTimeMs")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.lastAggregateTimeMs);
                            if (error)
                                return "lastAggregateTimeMs." + error;
                        }
                        if (message.ready != null && message.hasOwnProperty("ready"))
                            if (typeof message.ready !== "boolean")
                                return "ready: boolean expected";
                        if (message.latestTimeSlot != null && message.hasOwnProperty("latestTimeSlot"))
                            if (!$util.isString(message.latestTimeSlot))
                                return "latestTimeSlot: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreProcessingStatus message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreProcessingStatus} StoreProcessingStatus
                     */
                    StoreProcessingStatus.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreProcessingStatus)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreProcessingStatus();
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreProcessingStatus.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.lastAggregateTimeMs != null) {
                            if (typeof object.lastAggregateTimeMs !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreProcessingStatus.lastAggregateTimeMs: object expected");
                            message.lastAggregateTimeMs = $root.google.protobuf.Int64Value.fromObject(object.lastAggregateTimeMs);
                        }
                        if (object.ready != null)
                            message.ready = Boolean(object.ready);
                        if (object.latestTimeSlot != null)
                            message.latestTimeSlot = String(object.latestTimeSlot);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreProcessingStatus message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @static
                     * @param {palexy.streaming.v1.StoreProcessingStatus} message StoreProcessingStatus
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreProcessingStatus.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.store = null;
                            object.lastAggregateTimeMs = null;
                            object.ready = false;
                            object.latestTimeSlot = "";
                        }
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.lastAggregateTimeMs != null && message.hasOwnProperty("lastAggregateTimeMs"))
                            object.lastAggregateTimeMs = $root.google.protobuf.Int64Value.toObject(message.lastAggregateTimeMs, options);
                        if (message.ready != null && message.hasOwnProperty("ready"))
                            object.ready = message.ready;
                        if (message.latestTimeSlot != null && message.hasOwnProperty("latestTimeSlot"))
                            object.latestTimeSlot = message.latestTimeSlot;
                        return object;
                    };
    
                    /**
                     * Converts this StoreProcessingStatus to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreProcessingStatus
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreProcessingStatus.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreProcessingStatus;
                })();
    
                v1.MetadataService = (function() {
    
                    /**
                     * Constructs a new MetadataService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MetadataService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function MetadataService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (MetadataService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MetadataService;
    
                    /**
                     * Creates new MetadataService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.MetadataService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {MetadataService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    MetadataService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MetadataService#listMetadataType}.
                     * @memberof palexy.streaming.v1.MetadataService
                     * @typedef ListMetadataTypeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListMetadataTypeResponse} [response] ListMetadataTypeResponse
                     */
    
                    /**
                     * Calls ListMetadataType.
                     * @function listMetadataType
                     * @memberof palexy.streaming.v1.MetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest} request ListMetadataTypeRequest message or plain object
                     * @param {palexy.streaming.v1.MetadataService.ListMetadataTypeCallback} callback Node-style callback called with the error, if any, and ListMetadataTypeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MetadataService.prototype.listMetadataType = function listMetadataType(request, callback) {
                        return this.rpcCall(listMetadataType, $root.palexy.streaming.v1.ListMetadataTypeRequest, $root.palexy.streaming.v1.ListMetadataTypeResponse, request, callback);
                    }, "name", { value: "ListMetadataType" });
    
                    /**
                     * Calls ListMetadataType.
                     * @function listMetadataType
                     * @memberof palexy.streaming.v1.MetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest} request ListMetadataTypeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListMetadataTypeResponse>} Promise
                     * @variation 2
                     */
    
                    return MetadataService;
                })();
    
                v1.MetadataType = (function() {
    
                    /**
                     * Properties of a MetadataType.
                     * @memberof palexy.streaming.v1
                     * @interface IMetadataType
                     * @property {number|null} [id] MetadataType id
                     * @property {string|null} [name] MetadataType name
                     * @property {boolean|null} [isSystem] MetadataType isSystem
                     * @property {string|null} [systemName] MetadataType systemName
                     * @property {string|null} [type] MetadataType type
                     * @property {number|null} [ownerId] MetadataType ownerId
                     * @property {boolean|null} [isDeleted] MetadataType isDeleted
                     * @property {Array.<palexy.streaming.v1.IMetadataValue>|null} [metadataValues] MetadataType metadataValues
                     * @property {boolean|null} [isDefault] MetadataType isDefault
                     * @property {palexy.streaming.v1.MetadataType.VisitActionType|null} [visitActionType] MetadataType visitActionType
                     * @property {boolean|null} [isDestination] MetadataType isDestination
                     */
    
                    /**
                     * Constructs a new MetadataType.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MetadataType.
                     * @implements IMetadataType
                     * @constructor
                     * @param {palexy.streaming.v1.IMetadataType=} [properties] Properties to set
                     */
                    function MetadataType(properties) {
                        this.metadataValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MetadataType id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataType name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.name = "";
    
                    /**
                     * MetadataType isSystem.
                     * @member {boolean} isSystem
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.isSystem = false;
    
                    /**
                     * MetadataType systemName.
                     * @member {string} systemName
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.systemName = "";
    
                    /**
                     * MetadataType type.
                     * @member {string} type
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.type = "";
    
                    /**
                     * MetadataType ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataType isDeleted.
                     * @member {boolean} isDeleted
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.isDeleted = false;
    
                    /**
                     * MetadataType metadataValues.
                     * @member {Array.<palexy.streaming.v1.IMetadataValue>} metadataValues
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.metadataValues = $util.emptyArray;
    
                    /**
                     * MetadataType isDefault.
                     * @member {boolean} isDefault
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.isDefault = false;
    
                    /**
                     * MetadataType visitActionType.
                     * @member {palexy.streaming.v1.MetadataType.VisitActionType} visitActionType
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.visitActionType = 0;
    
                    /**
                     * MetadataType isDestination.
                     * @member {boolean} isDestination
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     */
                    MetadataType.prototype.isDestination = false;
    
                    /**
                     * Creates a new MetadataType instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {palexy.streaming.v1.IMetadataType=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MetadataType} MetadataType instance
                     */
                    MetadataType.create = function create(properties) {
                        return new MetadataType(properties);
                    };
    
                    /**
                     * Encodes the specified MetadataType message. Does not implicitly {@link palexy.streaming.v1.MetadataType.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {palexy.streaming.v1.IMetadataType} message MetadataType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataType.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.isSystem != null && Object.hasOwnProperty.call(message, "isSystem"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isSystem);
                        if (message.systemName != null && Object.hasOwnProperty.call(message, "systemName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.systemName);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.type);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.ownerId);
                        if (message.isDeleted != null && Object.hasOwnProperty.call(message, "isDeleted"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isDeleted);
                        if (message.metadataValues != null && message.metadataValues.length)
                            for (var i = 0; i < message.metadataValues.length; ++i)
                                $root.palexy.streaming.v1.MetadataValue.encode(message.metadataValues[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.isDefault != null && Object.hasOwnProperty.call(message, "isDefault"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isDefault);
                        if (message.visitActionType != null && Object.hasOwnProperty.call(message, "visitActionType"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.visitActionType);
                        if (message.isDestination != null && Object.hasOwnProperty.call(message, "isDestination"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.isDestination);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MetadataType message, length delimited. Does not implicitly {@link palexy.streaming.v1.MetadataType.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {palexy.streaming.v1.IMetadataType} message MetadataType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataType.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MetadataType message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MetadataType} MetadataType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataType.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MetadataType();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.isSystem = reader.bool();
                                break;
                            case 4:
                                message.systemName = reader.string();
                                break;
                            case 5:
                                message.type = reader.string();
                                break;
                            case 6:
                                message.ownerId = reader.int64();
                                break;
                            case 7:
                                message.isDeleted = reader.bool();
                                break;
                            case 8:
                                if (!(message.metadataValues && message.metadataValues.length))
                                    message.metadataValues = [];
                                message.metadataValues.push($root.palexy.streaming.v1.MetadataValue.decode(reader, reader.uint32()));
                                break;
                            case 9:
                                message.isDefault = reader.bool();
                                break;
                            case 10:
                                message.visitActionType = reader.int32();
                                break;
                            case 11:
                                message.isDestination = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MetadataType message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MetadataType} MetadataType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataType.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MetadataType message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MetadataType.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            if (typeof message.isSystem !== "boolean")
                                return "isSystem: boolean expected";
                        if (message.systemName != null && message.hasOwnProperty("systemName"))
                            if (!$util.isString(message.systemName))
                                return "systemName: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isString(message.type))
                                return "type: string expected";
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            if (typeof message.isDeleted !== "boolean")
                                return "isDeleted: boolean expected";
                        if (message.metadataValues != null && message.hasOwnProperty("metadataValues")) {
                            if (!Array.isArray(message.metadataValues))
                                return "metadataValues: array expected";
                            for (var i = 0; i < message.metadataValues.length; ++i) {
                                var error = $root.palexy.streaming.v1.MetadataValue.verify(message.metadataValues[i]);
                                if (error)
                                    return "metadataValues." + error;
                            }
                        }
                        if (message.isDefault != null && message.hasOwnProperty("isDefault"))
                            if (typeof message.isDefault !== "boolean")
                                return "isDefault: boolean expected";
                        if (message.visitActionType != null && message.hasOwnProperty("visitActionType"))
                            switch (message.visitActionType) {
                            default:
                                return "visitActionType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.isDestination != null && message.hasOwnProperty("isDestination"))
                            if (typeof message.isDestination !== "boolean")
                                return "isDestination: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a MetadataType message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MetadataType} MetadataType
                     */
                    MetadataType.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MetadataType)
                            return object;
                        var message = new $root.palexy.streaming.v1.MetadataType();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.isSystem != null)
                            message.isSystem = Boolean(object.isSystem);
                        if (object.systemName != null)
                            message.systemName = String(object.systemName);
                        if (object.type != null)
                            message.type = String(object.type);
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        if (object.isDeleted != null)
                            message.isDeleted = Boolean(object.isDeleted);
                        if (object.metadataValues) {
                            if (!Array.isArray(object.metadataValues))
                                throw TypeError(".palexy.streaming.v1.MetadataType.metadataValues: array expected");
                            message.metadataValues = [];
                            for (var i = 0; i < object.metadataValues.length; ++i) {
                                if (typeof object.metadataValues[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MetadataType.metadataValues: object expected");
                                message.metadataValues[i] = $root.palexy.streaming.v1.MetadataValue.fromObject(object.metadataValues[i]);
                            }
                        }
                        if (object.isDefault != null)
                            message.isDefault = Boolean(object.isDefault);
                        switch (object.visitActionType) {
                        case "VISIT":
                        case 0:
                            message.visitActionType = 0;
                            break;
                        case "VISIT_SECTION":
                        case 1:
                            message.visitActionType = 1;
                            break;
                        }
                        if (object.isDestination != null)
                            message.isDestination = Boolean(object.isDestination);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MetadataType message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MetadataType
                     * @static
                     * @param {palexy.streaming.v1.MetadataType} message MetadataType
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MetadataType.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.metadataValues = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.isSystem = false;
                            object.systemName = "";
                            object.type = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            object.isDeleted = false;
                            object.isDefault = false;
                            object.visitActionType = options.enums === String ? "VISIT" : 0;
                            object.isDestination = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            object.isSystem = message.isSystem;
                        if (message.systemName != null && message.hasOwnProperty("systemName"))
                            object.systemName = message.systemName;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            object.isDeleted = message.isDeleted;
                        if (message.metadataValues && message.metadataValues.length) {
                            object.metadataValues = [];
                            for (var j = 0; j < message.metadataValues.length; ++j)
                                object.metadataValues[j] = $root.palexy.streaming.v1.MetadataValue.toObject(message.metadataValues[j], options);
                        }
                        if (message.isDefault != null && message.hasOwnProperty("isDefault"))
                            object.isDefault = message.isDefault;
                        if (message.visitActionType != null && message.hasOwnProperty("visitActionType"))
                            object.visitActionType = options.enums === String ? $root.palexy.streaming.v1.MetadataType.VisitActionType[message.visitActionType] : message.visitActionType;
                        if (message.isDestination != null && message.hasOwnProperty("isDestination"))
                            object.isDestination = message.isDestination;
                        return object;
                    };
    
                    /**
                     * Converts this MetadataType to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MetadataType
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MetadataType.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * VisitActionType enum.
                     * @name palexy.streaming.v1.MetadataType.VisitActionType
                     * @enum {number}
                     * @property {number} VISIT=0 VISIT value
                     * @property {number} VISIT_SECTION=1 VISIT_SECTION value
                     */
                    MetadataType.VisitActionType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "VISIT"] = 0;
                        values[valuesById[1] = "VISIT_SECTION"] = 1;
                        return values;
                    })();
    
                    return MetadataType;
                })();
    
                v1.MetadataValue = (function() {
    
                    /**
                     * Properties of a MetadataValue.
                     * @memberof palexy.streaming.v1
                     * @interface IMetadataValue
                     * @property {number|null} [id] MetadataValue id
                     * @property {string|null} [value] MetadataValue value
                     * @property {number|null} [ownerId] MetadataValue ownerId
                     * @property {number|null} [metadataTypeId] MetadataValue metadataTypeId
                     */
    
                    /**
                     * Constructs a new MetadataValue.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MetadataValue.
                     * @implements IMetadataValue
                     * @constructor
                     * @param {palexy.streaming.v1.IMetadataValue=} [properties] Properties to set
                     */
                    function MetadataValue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MetadataValue id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @instance
                     */
                    MetadataValue.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataValue value.
                     * @member {string} value
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @instance
                     */
                    MetadataValue.prototype.value = "";
    
                    /**
                     * MetadataValue ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @instance
                     */
                    MetadataValue.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MetadataValue metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @instance
                     */
                    MetadataValue.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new MetadataValue instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IMetadataValue=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MetadataValue} MetadataValue instance
                     */
                    MetadataValue.create = function create(properties) {
                        return new MetadataValue(properties);
                    };
    
                    /**
                     * Encodes the specified MetadataValue message. Does not implicitly {@link palexy.streaming.v1.MetadataValue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IMetadataValue} message MetadataValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.ownerId);
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.metadataTypeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MetadataValue message, length delimited. Does not implicitly {@link palexy.streaming.v1.MetadataValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IMetadataValue} message MetadataValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MetadataValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MetadataValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MetadataValue} MetadataValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MetadataValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.value = reader.string();
                                break;
                            case 3:
                                message.ownerId = reader.int64();
                                break;
                            case 4:
                                message.metadataTypeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MetadataValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MetadataValue} MetadataValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MetadataValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MetadataValue message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MetadataValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a MetadataValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MetadataValue} MetadataValue
                     */
                    MetadataValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MetadataValue)
                            return object;
                        var message = new $root.palexy.streaming.v1.MetadataValue();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.value != null)
                            message.value = String(object.value);
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MetadataValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @static
                     * @param {palexy.streaming.v1.MetadataValue} message MetadataValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MetadataValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.value = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        return object;
                    };
    
                    /**
                     * Converts this MetadataValue to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MetadataValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MetadataValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MetadataValue;
                })();
    
                v1.ListMetadataTypeRequest = (function() {
    
                    /**
                     * Properties of a ListMetadataTypeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListMetadataTypeRequest
                     * @property {number|null} [companyId] ListMetadataTypeRequest companyId
                     * @property {boolean|null} [isSystem] ListMetadataTypeRequest isSystem
                     * @property {boolean|null} [includeMetadataValues] ListMetadataTypeRequest includeMetadataValues
                     */
    
                    /**
                     * Constructs a new ListMetadataTypeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMetadataTypeRequest.
                     * @implements IListMetadataTypeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest=} [properties] Properties to set
                     */
                    function ListMetadataTypeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMetadataTypeRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @instance
                     */
                    ListMetadataTypeRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListMetadataTypeRequest isSystem.
                     * @member {boolean} isSystem
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @instance
                     */
                    ListMetadataTypeRequest.prototype.isSystem = false;
    
                    /**
                     * ListMetadataTypeRequest includeMetadataValues.
                     * @member {boolean} includeMetadataValues
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @instance
                     */
                    ListMetadataTypeRequest.prototype.includeMetadataValues = false;
    
                    /**
                     * Creates a new ListMetadataTypeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMetadataTypeRequest} ListMetadataTypeRequest instance
                     */
                    ListMetadataTypeRequest.create = function create(properties) {
                        return new ListMetadataTypeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListMetadataTypeRequest message. Does not implicitly {@link palexy.streaming.v1.ListMetadataTypeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest} message ListMetadataTypeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMetadataTypeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.isSystem != null && Object.hasOwnProperty.call(message, "isSystem"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isSystem);
                        if (message.includeMetadataValues != null && Object.hasOwnProperty.call(message, "includeMetadataValues"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeMetadataValues);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMetadataTypeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMetadataTypeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeRequest} message ListMetadataTypeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMetadataTypeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMetadataTypeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMetadataTypeRequest} ListMetadataTypeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMetadataTypeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMetadataTypeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.isSystem = reader.bool();
                                break;
                            case 3:
                                message.includeMetadataValues = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMetadataTypeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMetadataTypeRequest} ListMetadataTypeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMetadataTypeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMetadataTypeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMetadataTypeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            if (typeof message.isSystem !== "boolean")
                                return "isSystem: boolean expected";
                        if (message.includeMetadataValues != null && message.hasOwnProperty("includeMetadataValues"))
                            if (typeof message.includeMetadataValues !== "boolean")
                                return "includeMetadataValues: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListMetadataTypeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMetadataTypeRequest} ListMetadataTypeRequest
                     */
                    ListMetadataTypeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMetadataTypeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMetadataTypeRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.isSystem != null)
                            message.isSystem = Boolean(object.isSystem);
                        if (object.includeMetadataValues != null)
                            message.includeMetadataValues = Boolean(object.includeMetadataValues);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMetadataTypeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @static
                     * @param {palexy.streaming.v1.ListMetadataTypeRequest} message ListMetadataTypeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMetadataTypeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.isSystem = false;
                            object.includeMetadataValues = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            object.isSystem = message.isSystem;
                        if (message.includeMetadataValues != null && message.hasOwnProperty("includeMetadataValues"))
                            object.includeMetadataValues = message.includeMetadataValues;
                        return object;
                    };
    
                    /**
                     * Converts this ListMetadataTypeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMetadataTypeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMetadataTypeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListMetadataTypeRequest;
                })();
    
                v1.ListMetadataTypeResponse = (function() {
    
                    /**
                     * Properties of a ListMetadataTypeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListMetadataTypeResponse
                     * @property {Array.<palexy.streaming.v1.IMetadataType>|null} [metadataTypes] ListMetadataTypeResponse metadataTypes
                     */
    
                    /**
                     * Constructs a new ListMetadataTypeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMetadataTypeResponse.
                     * @implements IListMetadataTypeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListMetadataTypeResponse=} [properties] Properties to set
                     */
                    function ListMetadataTypeResponse(properties) {
                        this.metadataTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMetadataTypeResponse metadataTypes.
                     * @member {Array.<palexy.streaming.v1.IMetadataType>} metadataTypes
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @instance
                     */
                    ListMetadataTypeResponse.prototype.metadataTypes = $util.emptyArray;
    
                    /**
                     * Creates a new ListMetadataTypeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMetadataTypeResponse} ListMetadataTypeResponse instance
                     */
                    ListMetadataTypeResponse.create = function create(properties) {
                        return new ListMetadataTypeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListMetadataTypeResponse message. Does not implicitly {@link palexy.streaming.v1.ListMetadataTypeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeResponse} message ListMetadataTypeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMetadataTypeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataTypes != null && message.metadataTypes.length)
                            for (var i = 0; i < message.metadataTypes.length; ++i)
                                $root.palexy.streaming.v1.MetadataType.encode(message.metadataTypes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMetadataTypeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMetadataTypeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMetadataTypeResponse} message ListMetadataTypeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMetadataTypeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMetadataTypeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMetadataTypeResponse} ListMetadataTypeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMetadataTypeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMetadataTypeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.metadataTypes && message.metadataTypes.length))
                                    message.metadataTypes = [];
                                message.metadataTypes.push($root.palexy.streaming.v1.MetadataType.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMetadataTypeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMetadataTypeResponse} ListMetadataTypeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMetadataTypeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMetadataTypeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMetadataTypeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataTypes != null && message.hasOwnProperty("metadataTypes")) {
                            if (!Array.isArray(message.metadataTypes))
                                return "metadataTypes: array expected";
                            for (var i = 0; i < message.metadataTypes.length; ++i) {
                                var error = $root.palexy.streaming.v1.MetadataType.verify(message.metadataTypes[i]);
                                if (error)
                                    return "metadataTypes." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListMetadataTypeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMetadataTypeResponse} ListMetadataTypeResponse
                     */
                    ListMetadataTypeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMetadataTypeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMetadataTypeResponse();
                        if (object.metadataTypes) {
                            if (!Array.isArray(object.metadataTypes))
                                throw TypeError(".palexy.streaming.v1.ListMetadataTypeResponse.metadataTypes: array expected");
                            message.metadataTypes = [];
                            for (var i = 0; i < object.metadataTypes.length; ++i) {
                                if (typeof object.metadataTypes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListMetadataTypeResponse.metadataTypes: object expected");
                                message.metadataTypes[i] = $root.palexy.streaming.v1.MetadataType.fromObject(object.metadataTypes[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMetadataTypeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @static
                     * @param {palexy.streaming.v1.ListMetadataTypeResponse} message ListMetadataTypeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMetadataTypeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.metadataTypes = [];
                        if (message.metadataTypes && message.metadataTypes.length) {
                            object.metadataTypes = [];
                            for (var j = 0; j < message.metadataTypes.length; ++j)
                                object.metadataTypes[j] = $root.palexy.streaming.v1.MetadataType.toObject(message.metadataTypes[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListMetadataTypeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMetadataTypeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMetadataTypeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListMetadataTypeResponse;
                })();
    
                v1.LayoutChangedEventService = (function() {
    
                    /**
                     * Constructs a new LayoutChangedEventService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a LayoutChangedEventService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function LayoutChangedEventService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (LayoutChangedEventService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = LayoutChangedEventService;
    
                    /**
                     * Creates new LayoutChangedEventService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {LayoutChangedEventService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    LayoutChangedEventService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.LayoutChangedEventService#listLayoutChangedEvents}.
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @typedef ListLayoutChangedEventsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListLayoutChangedEventsResponse} [response] ListLayoutChangedEventsResponse
                     */
    
                    /**
                     * Calls ListLayoutChangedEvents.
                     * @function listLayoutChangedEvents
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest} request ListLayoutChangedEventsRequest message or plain object
                     * @param {palexy.streaming.v1.LayoutChangedEventService.ListLayoutChangedEventsCallback} callback Node-style callback called with the error, if any, and ListLayoutChangedEventsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(LayoutChangedEventService.prototype.listLayoutChangedEvents = function listLayoutChangedEvents(request, callback) {
                        return this.rpcCall(listLayoutChangedEvents, $root.palexy.streaming.v1.ListLayoutChangedEventsRequest, $root.palexy.streaming.v1.ListLayoutChangedEventsResponse, request, callback);
                    }, "name", { value: "ListLayoutChangedEvents" });
    
                    /**
                     * Calls ListLayoutChangedEvents.
                     * @function listLayoutChangedEvents
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest} request ListLayoutChangedEventsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListLayoutChangedEventsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.LayoutChangedEventService#createLayoutChangedEvent}.
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @typedef CreateLayoutChangedEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.LayoutChangedEvent} [response] LayoutChangedEvent
                     */
    
                    /**
                     * Calls CreateLayoutChangedEvent.
                     * @function createLayoutChangedEvent
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest} request CreateLayoutChangedEventRequest message or plain object
                     * @param {palexy.streaming.v1.LayoutChangedEventService.CreateLayoutChangedEventCallback} callback Node-style callback called with the error, if any, and LayoutChangedEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(LayoutChangedEventService.prototype.createLayoutChangedEvent = function createLayoutChangedEvent(request, callback) {
                        return this.rpcCall(createLayoutChangedEvent, $root.palexy.streaming.v1.CreateLayoutChangedEventRequest, $root.palexy.streaming.v1.LayoutChangedEvent, request, callback);
                    }, "name", { value: "CreateLayoutChangedEvent" });
    
                    /**
                     * Calls CreateLayoutChangedEvent.
                     * @function createLayoutChangedEvent
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest} request CreateLayoutChangedEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.LayoutChangedEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.LayoutChangedEventService#batchUpdateLayoutChangedEvents}.
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @typedef BatchUpdateLayoutChangedEventsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} [response] BatchUpdateLayoutChangedEventsResponse
                     */
    
                    /**
                     * Calls BatchUpdateLayoutChangedEvents.
                     * @function batchUpdateLayoutChangedEvents
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest} request BatchUpdateLayoutChangedEventsRequest message or plain object
                     * @param {palexy.streaming.v1.LayoutChangedEventService.BatchUpdateLayoutChangedEventsCallback} callback Node-style callback called with the error, if any, and BatchUpdateLayoutChangedEventsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(LayoutChangedEventService.prototype.batchUpdateLayoutChangedEvents = function batchUpdateLayoutChangedEvents(request, callback) {
                        return this.rpcCall(batchUpdateLayoutChangedEvents, $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest, $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse, request, callback);
                    }, "name", { value: "BatchUpdateLayoutChangedEvents" });
    
                    /**
                     * Calls BatchUpdateLayoutChangedEvents.
                     * @function batchUpdateLayoutChangedEvents
                     * @memberof palexy.streaming.v1.LayoutChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest} request BatchUpdateLayoutChangedEventsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse>} Promise
                     * @variation 2
                     */
    
                    return LayoutChangedEventService;
                })();
    
                v1.LayoutChangedEvent = (function() {
    
                    /**
                     * Properties of a LayoutChangedEvent.
                     * @memberof palexy.streaming.v1
                     * @interface ILayoutChangedEvent
                     * @property {number|null} [id] LayoutChangedEvent id
                     * @property {number|null} [storeId] LayoutChangedEvent storeId
                     * @property {string|null} [startDate] LayoutChangedEvent startDate
                     * @property {string|null} [endDate] LayoutChangedEvent endDate
                     * @property {palexy.streaming.v1.LayoutChangedEvent.Status|null} [status] LayoutChangedEvent status
                     * @property {number|null} [retryCount] LayoutChangedEvent retryCount
                     * @property {google.protobuf.ITimestamp|null} [createTime] LayoutChangedEvent createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] LayoutChangedEvent lastUpdateTime
                     */
    
                    /**
                     * Constructs a new LayoutChangedEvent.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a LayoutChangedEvent.
                     * @implements ILayoutChangedEvent
                     * @constructor
                     * @param {palexy.streaming.v1.ILayoutChangedEvent=} [properties] Properties to set
                     */
                    function LayoutChangedEvent(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * LayoutChangedEvent id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutChangedEvent storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutChangedEvent startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.startDate = "";
    
                    /**
                     * LayoutChangedEvent endDate.
                     * @member {string} endDate
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.endDate = "";
    
                    /**
                     * LayoutChangedEvent status.
                     * @member {palexy.streaming.v1.LayoutChangedEvent.Status} status
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.status = 0;
    
                    /**
                     * LayoutChangedEvent retryCount.
                     * @member {number} retryCount
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.retryCount = 0;
    
                    /**
                     * LayoutChangedEvent createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.createTime = null;
    
                    /**
                     * LayoutChangedEvent lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     */
                    LayoutChangedEvent.prototype.lastUpdateTime = null;
    
                    /**
                     * Creates a new LayoutChangedEvent instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.ILayoutChangedEvent=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.LayoutChangedEvent} LayoutChangedEvent instance
                     */
                    LayoutChangedEvent.create = function create(properties) {
                        return new LayoutChangedEvent(properties);
                    };
    
                    /**
                     * Encodes the specified LayoutChangedEvent message. Does not implicitly {@link palexy.streaming.v1.LayoutChangedEvent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.ILayoutChangedEvent} message LayoutChangedEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LayoutChangedEvent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDate);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.status);
                        if (message.retryCount != null && Object.hasOwnProperty.call(message, "retryCount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.retryCount);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified LayoutChangedEvent message, length delimited. Does not implicitly {@link palexy.streaming.v1.LayoutChangedEvent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.ILayoutChangedEvent} message LayoutChangedEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LayoutChangedEvent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a LayoutChangedEvent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.LayoutChangedEvent} LayoutChangedEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LayoutChangedEvent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.LayoutChangedEvent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.startDate = reader.string();
                                break;
                            case 4:
                                message.endDate = reader.string();
                                break;
                            case 5:
                                message.status = reader.int32();
                                break;
                            case 6:
                                message.retryCount = reader.int32();
                                break;
                            case 7:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a LayoutChangedEvent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.LayoutChangedEvent} LayoutChangedEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LayoutChangedEvent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a LayoutChangedEvent message.
                     * @function verify
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LayoutChangedEvent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.retryCount != null && message.hasOwnProperty("retryCount"))
                            if (!$util.isInteger(message.retryCount))
                                return "retryCount: integer expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a LayoutChangedEvent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.LayoutChangedEvent} LayoutChangedEvent
                     */
                    LayoutChangedEvent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.LayoutChangedEvent)
                            return object;
                        var message = new $root.palexy.streaming.v1.LayoutChangedEvent();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        switch (object.status) {
                        case "UNPROCESSED":
                        case 0:
                            message.status = 0;
                            break;
                        case "WAITING_FOR_RETRY":
                        case 1:
                            message.status = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        if (object.retryCount != null)
                            message.retryCount = object.retryCount | 0;
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.LayoutChangedEvent.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.LayoutChangedEvent.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a LayoutChangedEvent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.LayoutChangedEvent} message LayoutChangedEvent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LayoutChangedEvent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDate = "";
                            object.endDate = "";
                            object.status = options.enums === String ? "UNPROCESSED" : 0;
                            object.retryCount = 0;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.LayoutChangedEvent.Status[message.status] : message.status;
                        if (message.retryCount != null && message.hasOwnProperty("retryCount"))
                            object.retryCount = message.retryCount;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this LayoutChangedEvent to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.LayoutChangedEvent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LayoutChangedEvent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Status enum.
                     * @name palexy.streaming.v1.LayoutChangedEvent.Status
                     * @enum {number}
                     * @property {number} UNPROCESSED=0 UNPROCESSED value
                     * @property {number} WAITING_FOR_RETRY=1 WAITING_FOR_RETRY value
                     * @property {number} DONE=2 DONE value
                     */
                    LayoutChangedEvent.Status = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNPROCESSED"] = 0;
                        values[valuesById[1] = "WAITING_FOR_RETRY"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        return values;
                    })();
    
                    return LayoutChangedEvent;
                })();
    
                v1.ListLayoutChangedEventsRequest = (function() {
    
                    /**
                     * Properties of a ListLayoutChangedEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutChangedEventsRequest
                     */
    
                    /**
                     * Constructs a new ListLayoutChangedEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutChangedEventsRequest.
                     * @implements IListLayoutChangedEventsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest=} [properties] Properties to set
                     */
                    function ListLayoutChangedEventsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ListLayoutChangedEventsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsRequest} ListLayoutChangedEventsRequest instance
                     */
                    ListLayoutChangedEventsRequest.create = function create(properties) {
                        return new ListLayoutChangedEventsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutChangedEventsRequest message. Does not implicitly {@link palexy.streaming.v1.ListLayoutChangedEventsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest} message ListLayoutChangedEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutChangedEventsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutChangedEventsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutChangedEventsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsRequest} message ListLayoutChangedEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutChangedEventsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutChangedEventsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsRequest} ListLayoutChangedEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutChangedEventsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutChangedEventsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutChangedEventsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsRequest} ListLayoutChangedEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutChangedEventsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutChangedEventsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutChangedEventsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutChangedEventsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsRequest} ListLayoutChangedEventsRequest
                     */
                    ListLayoutChangedEventsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutChangedEventsRequest)
                            return object;
                        return new $root.palexy.streaming.v1.ListLayoutChangedEventsRequest();
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutChangedEventsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutChangedEventsRequest} message ListLayoutChangedEventsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutChangedEventsRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ListLayoutChangedEventsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutChangedEventsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutChangedEventsRequest;
                })();
    
                v1.ListLayoutChangedEventsResponse = (function() {
    
                    /**
                     * Properties of a ListLayoutChangedEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutChangedEventsResponse
                     * @property {Array.<palexy.streaming.v1.ILayoutChangedEvent>|null} [layoutChangedEvents] ListLayoutChangedEventsResponse layoutChangedEvents
                     */
    
                    /**
                     * Constructs a new ListLayoutChangedEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutChangedEventsResponse.
                     * @implements IListLayoutChangedEventsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsResponse=} [properties] Properties to set
                     */
                    function ListLayoutChangedEventsResponse(properties) {
                        this.layoutChangedEvents = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLayoutChangedEventsResponse layoutChangedEvents.
                     * @member {Array.<palexy.streaming.v1.ILayoutChangedEvent>} layoutChangedEvents
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @instance
                     */
                    ListLayoutChangedEventsResponse.prototype.layoutChangedEvents = $util.emptyArray;
    
                    /**
                     * Creates a new ListLayoutChangedEventsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsResponse} ListLayoutChangedEventsResponse instance
                     */
                    ListLayoutChangedEventsResponse.create = function create(properties) {
                        return new ListLayoutChangedEventsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutChangedEventsResponse message. Does not implicitly {@link palexy.streaming.v1.ListLayoutChangedEventsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsResponse} message ListLayoutChangedEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutChangedEventsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.layoutChangedEvents != null && message.layoutChangedEvents.length)
                            for (var i = 0; i < message.layoutChangedEvents.length; ++i)
                                $root.palexy.streaming.v1.LayoutChangedEvent.encode(message.layoutChangedEvents[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutChangedEventsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutChangedEventsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutChangedEventsResponse} message ListLayoutChangedEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutChangedEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutChangedEventsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsResponse} ListLayoutChangedEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutChangedEventsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutChangedEventsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.layoutChangedEvents && message.layoutChangedEvents.length))
                                    message.layoutChangedEvents = [];
                                message.layoutChangedEvents.push($root.palexy.streaming.v1.LayoutChangedEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutChangedEventsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsResponse} ListLayoutChangedEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutChangedEventsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutChangedEventsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutChangedEventsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.layoutChangedEvents != null && message.hasOwnProperty("layoutChangedEvents")) {
                            if (!Array.isArray(message.layoutChangedEvents))
                                return "layoutChangedEvents: array expected";
                            for (var i = 0; i < message.layoutChangedEvents.length; ++i) {
                                var error = $root.palexy.streaming.v1.LayoutChangedEvent.verify(message.layoutChangedEvents[i]);
                                if (error)
                                    return "layoutChangedEvents." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutChangedEventsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutChangedEventsResponse} ListLayoutChangedEventsResponse
                     */
                    ListLayoutChangedEventsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutChangedEventsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLayoutChangedEventsResponse();
                        if (object.layoutChangedEvents) {
                            if (!Array.isArray(object.layoutChangedEvents))
                                throw TypeError(".palexy.streaming.v1.ListLayoutChangedEventsResponse.layoutChangedEvents: array expected");
                            message.layoutChangedEvents = [];
                            for (var i = 0; i < object.layoutChangedEvents.length; ++i) {
                                if (typeof object.layoutChangedEvents[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListLayoutChangedEventsResponse.layoutChangedEvents: object expected");
                                message.layoutChangedEvents[i] = $root.palexy.streaming.v1.LayoutChangedEvent.fromObject(object.layoutChangedEvents[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutChangedEventsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutChangedEventsResponse} message ListLayoutChangedEventsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutChangedEventsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.layoutChangedEvents = [];
                        if (message.layoutChangedEvents && message.layoutChangedEvents.length) {
                            object.layoutChangedEvents = [];
                            for (var j = 0; j < message.layoutChangedEvents.length; ++j)
                                object.layoutChangedEvents[j] = $root.palexy.streaming.v1.LayoutChangedEvent.toObject(message.layoutChangedEvents[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListLayoutChangedEventsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutChangedEventsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutChangedEventsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutChangedEventsResponse;
                })();
    
                v1.CreateLayoutChangedEventRequest = (function() {
    
                    /**
                     * Properties of a CreateLayoutChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateLayoutChangedEventRequest
                     * @property {palexy.streaming.v1.ILayoutChangedEvent|null} [layoutChangedEvent] CreateLayoutChangedEventRequest layoutChangedEvent
                     */
    
                    /**
                     * Constructs a new CreateLayoutChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateLayoutChangedEventRequest.
                     * @implements ICreateLayoutChangedEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest=} [properties] Properties to set
                     */
                    function CreateLayoutChangedEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateLayoutChangedEventRequest layoutChangedEvent.
                     * @member {palexy.streaming.v1.ILayoutChangedEvent|null|undefined} layoutChangedEvent
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @instance
                     */
                    CreateLayoutChangedEventRequest.prototype.layoutChangedEvent = null;
    
                    /**
                     * Creates a new CreateLayoutChangedEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateLayoutChangedEventRequest} CreateLayoutChangedEventRequest instance
                     */
                    CreateLayoutChangedEventRequest.create = function create(properties) {
                        return new CreateLayoutChangedEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateLayoutChangedEventRequest message. Does not implicitly {@link palexy.streaming.v1.CreateLayoutChangedEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest} message CreateLayoutChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateLayoutChangedEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.layoutChangedEvent != null && Object.hasOwnProperty.call(message, "layoutChangedEvent"))
                            $root.palexy.streaming.v1.LayoutChangedEvent.encode(message.layoutChangedEvent, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateLayoutChangedEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateLayoutChangedEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateLayoutChangedEventRequest} message CreateLayoutChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateLayoutChangedEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateLayoutChangedEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateLayoutChangedEventRequest} CreateLayoutChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateLayoutChangedEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateLayoutChangedEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.layoutChangedEvent = $root.palexy.streaming.v1.LayoutChangedEvent.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateLayoutChangedEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateLayoutChangedEventRequest} CreateLayoutChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateLayoutChangedEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateLayoutChangedEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateLayoutChangedEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.layoutChangedEvent != null && message.hasOwnProperty("layoutChangedEvent")) {
                            var error = $root.palexy.streaming.v1.LayoutChangedEvent.verify(message.layoutChangedEvent);
                            if (error)
                                return "layoutChangedEvent." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateLayoutChangedEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateLayoutChangedEventRequest} CreateLayoutChangedEventRequest
                     */
                    CreateLayoutChangedEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateLayoutChangedEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateLayoutChangedEventRequest();
                        if (object.layoutChangedEvent != null) {
                            if (typeof object.layoutChangedEvent !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateLayoutChangedEventRequest.layoutChangedEvent: object expected");
                            message.layoutChangedEvent = $root.palexy.streaming.v1.LayoutChangedEvent.fromObject(object.layoutChangedEvent);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateLayoutChangedEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateLayoutChangedEventRequest} message CreateLayoutChangedEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateLayoutChangedEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.layoutChangedEvent = null;
                        if (message.layoutChangedEvent != null && message.hasOwnProperty("layoutChangedEvent"))
                            object.layoutChangedEvent = $root.palexy.streaming.v1.LayoutChangedEvent.toObject(message.layoutChangedEvent, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateLayoutChangedEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateLayoutChangedEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateLayoutChangedEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateLayoutChangedEventRequest;
                })();
    
                v1.BatchUpdateLayoutChangedEventsRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateLayoutChangedEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateLayoutChangedEventsRequest
                     * @property {Array.<number>|null} [layoutChangedEventIds] BatchUpdateLayoutChangedEventsRequest layoutChangedEventIds
                     * @property {palexy.streaming.v1.LayoutChangedEvent.Status|null} [status] BatchUpdateLayoutChangedEventsRequest status
                     */
    
                    /**
                     * Constructs a new BatchUpdateLayoutChangedEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateLayoutChangedEventsRequest.
                     * @implements IBatchUpdateLayoutChangedEventsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest=} [properties] Properties to set
                     */
                    function BatchUpdateLayoutChangedEventsRequest(properties) {
                        this.layoutChangedEventIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateLayoutChangedEventsRequest layoutChangedEventIds.
                     * @member {Array.<number>} layoutChangedEventIds
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @instance
                     */
                    BatchUpdateLayoutChangedEventsRequest.prototype.layoutChangedEventIds = $util.emptyArray;
    
                    /**
                     * BatchUpdateLayoutChangedEventsRequest status.
                     * @member {palexy.streaming.v1.LayoutChangedEvent.Status} status
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @instance
                     */
                    BatchUpdateLayoutChangedEventsRequest.prototype.status = 0;
    
                    /**
                     * Creates a new BatchUpdateLayoutChangedEventsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest} BatchUpdateLayoutChangedEventsRequest instance
                     */
                    BatchUpdateLayoutChangedEventsRequest.create = function create(properties) {
                        return new BatchUpdateLayoutChangedEventsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateLayoutChangedEventsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest} message BatchUpdateLayoutChangedEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateLayoutChangedEventsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.layoutChangedEventIds != null && message.layoutChangedEventIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.layoutChangedEventIds.length; ++i)
                                writer.int64(message.layoutChangedEventIds[i]);
                            writer.ldelim();
                        }
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateLayoutChangedEventsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsRequest} message BatchUpdateLayoutChangedEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateLayoutChangedEventsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateLayoutChangedEventsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest} BatchUpdateLayoutChangedEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateLayoutChangedEventsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.layoutChangedEventIds && message.layoutChangedEventIds.length))
                                    message.layoutChangedEventIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.layoutChangedEventIds.push(reader.int64());
                                } else
                                    message.layoutChangedEventIds.push(reader.int64());
                                break;
                            case 2:
                                message.status = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateLayoutChangedEventsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest} BatchUpdateLayoutChangedEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateLayoutChangedEventsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateLayoutChangedEventsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateLayoutChangedEventsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.layoutChangedEventIds != null && message.hasOwnProperty("layoutChangedEventIds")) {
                            if (!Array.isArray(message.layoutChangedEventIds))
                                return "layoutChangedEventIds: array expected";
                            for (var i = 0; i < message.layoutChangedEventIds.length; ++i)
                                if (!$util.isInteger(message.layoutChangedEventIds[i]) && !(message.layoutChangedEventIds[i] && $util.isInteger(message.layoutChangedEventIds[i].low) && $util.isInteger(message.layoutChangedEventIds[i].high)))
                                    return "layoutChangedEventIds: integer|Long[] expected";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateLayoutChangedEventsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest} BatchUpdateLayoutChangedEventsRequest
                     */
                    BatchUpdateLayoutChangedEventsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest();
                        if (object.layoutChangedEventIds) {
                            if (!Array.isArray(object.layoutChangedEventIds))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest.layoutChangedEventIds: array expected");
                            message.layoutChangedEventIds = [];
                            for (var i = 0; i < object.layoutChangedEventIds.length; ++i)
                                if ($util.Long)
                                    (message.layoutChangedEventIds[i] = $util.Long.fromValue(object.layoutChangedEventIds[i])).unsigned = false;
                                else if (typeof object.layoutChangedEventIds[i] === "string")
                                    message.layoutChangedEventIds[i] = parseInt(object.layoutChangedEventIds[i], 10);
                                else if (typeof object.layoutChangedEventIds[i] === "number")
                                    message.layoutChangedEventIds[i] = object.layoutChangedEventIds[i];
                                else if (typeof object.layoutChangedEventIds[i] === "object")
                                    message.layoutChangedEventIds[i] = new $util.LongBits(object.layoutChangedEventIds[i].low >>> 0, object.layoutChangedEventIds[i].high >>> 0).toNumber();
                        }
                        switch (object.status) {
                        case "UNPROCESSED":
                        case 0:
                            message.status = 0;
                            break;
                        case "WAITING_FOR_RETRY":
                        case 1:
                            message.status = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.status = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateLayoutChangedEventsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest} message BatchUpdateLayoutChangedEventsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateLayoutChangedEventsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.layoutChangedEventIds = [];
                        if (options.defaults)
                            object.status = options.enums === String ? "UNPROCESSED" : 0;
                        if (message.layoutChangedEventIds && message.layoutChangedEventIds.length) {
                            object.layoutChangedEventIds = [];
                            for (var j = 0; j < message.layoutChangedEventIds.length; ++j)
                                if (typeof message.layoutChangedEventIds[j] === "number")
                                    object.layoutChangedEventIds[j] = options.longs === String ? String(message.layoutChangedEventIds[j]) : message.layoutChangedEventIds[j];
                                else
                                    object.layoutChangedEventIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.layoutChangedEventIds[j]) : options.longs === Number ? new $util.LongBits(message.layoutChangedEventIds[j].low >>> 0, message.layoutChangedEventIds[j].high >>> 0).toNumber() : message.layoutChangedEventIds[j];
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.LayoutChangedEvent.Status[message.status] : message.status;
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateLayoutChangedEventsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateLayoutChangedEventsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateLayoutChangedEventsRequest;
                })();
    
                v1.BatchUpdateLayoutChangedEventsResponse = (function() {
    
                    /**
                     * Properties of a BatchUpdateLayoutChangedEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateLayoutChangedEventsResponse
                     */
    
                    /**
                     * Constructs a new BatchUpdateLayoutChangedEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateLayoutChangedEventsResponse.
                     * @implements IBatchUpdateLayoutChangedEventsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsResponse=} [properties] Properties to set
                     */
                    function BatchUpdateLayoutChangedEventsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new BatchUpdateLayoutChangedEventsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} BatchUpdateLayoutChangedEventsResponse instance
                     */
                    BatchUpdateLayoutChangedEventsResponse.create = function create(properties) {
                        return new BatchUpdateLayoutChangedEventsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateLayoutChangedEventsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsResponse} message BatchUpdateLayoutChangedEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateLayoutChangedEventsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateLayoutChangedEventsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateLayoutChangedEventsResponse} message BatchUpdateLayoutChangedEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateLayoutChangedEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateLayoutChangedEventsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} BatchUpdateLayoutChangedEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateLayoutChangedEventsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateLayoutChangedEventsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} BatchUpdateLayoutChangedEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateLayoutChangedEventsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateLayoutChangedEventsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateLayoutChangedEventsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateLayoutChangedEventsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} BatchUpdateLayoutChangedEventsResponse
                     */
                    BatchUpdateLayoutChangedEventsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse)
                            return object;
                        return new $root.palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse();
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateLayoutChangedEventsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse} message BatchUpdateLayoutChangedEventsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateLayoutChangedEventsResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this BatchUpdateLayoutChangedEventsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateLayoutChangedEventsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateLayoutChangedEventsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateLayoutChangedEventsResponse;
                })();
    
                v1.MergingConfigPreset = (function() {
    
                    /**
                     * Properties of a MergingConfigPreset.
                     * @memberof palexy.streaming.v1
                     * @interface IMergingConfigPreset
                     * @property {number|null} [id] MergingConfigPreset id
                     * @property {palexy.streaming.v1.IMergingConfig|null} [config] MergingConfigPreset config
                     * @property {string|null} [name] MergingConfigPreset name
                     * @property {string|null} [note] MergingConfigPreset note
                     * @property {number|null} [createTimeMs] MergingConfigPreset createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] MergingConfigPreset lastUpdateTimeMs
                     * @property {Array.<number>|null} [companyIds] MergingConfigPreset companyIds
                     * @property {Array.<palexy.streaming.v1.Store.StoreType>|null} [storeTypes] MergingConfigPreset storeTypes
                     * @property {Array.<palexy.streaming.v1.Store.CountingType>|null} [countingTypes] MergingConfigPreset countingTypes
                     * @property {boolean|null} [isEnabledForSuggestion] MergingConfigPreset isEnabledForSuggestion
                     */
    
                    /**
                     * Constructs a new MergingConfigPreset.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingConfigPreset.
                     * @implements IMergingConfigPreset
                     * @constructor
                     * @param {palexy.streaming.v1.IMergingConfigPreset=} [properties] Properties to set
                     */
                    function MergingConfigPreset(properties) {
                        this.companyIds = [];
                        this.storeTypes = [];
                        this.countingTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergingConfigPreset id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingConfigPreset config.
                     * @member {palexy.streaming.v1.IMergingConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.config = null;
    
                    /**
                     * MergingConfigPreset name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.name = "";
    
                    /**
                     * MergingConfigPreset note.
                     * @member {string} note
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.note = "";
    
                    /**
                     * MergingConfigPreset createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingConfigPreset lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingConfigPreset companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * MergingConfigPreset storeTypes.
                     * @member {Array.<palexy.streaming.v1.Store.StoreType>} storeTypes
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.storeTypes = $util.emptyArray;
    
                    /**
                     * MergingConfigPreset countingTypes.
                     * @member {Array.<palexy.streaming.v1.Store.CountingType>} countingTypes
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.countingTypes = $util.emptyArray;
    
                    /**
                     * MergingConfigPreset isEnabledForSuggestion.
                     * @member {boolean} isEnabledForSuggestion
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     */
                    MergingConfigPreset.prototype.isEnabledForSuggestion = false;
    
                    /**
                     * Creates a new MergingConfigPreset instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfigPreset=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergingConfigPreset} MergingConfigPreset instance
                     */
                    MergingConfigPreset.create = function create(properties) {
                        return new MergingConfigPreset(properties);
                    };
    
                    /**
                     * Encodes the specified MergingConfigPreset message. Does not implicitly {@link palexy.streaming.v1.MergingConfigPreset.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfigPreset} message MergingConfigPreset message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingConfigPreset.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.MergingConfig.encode(message.config, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.note);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        if (message.storeTypes != null && message.storeTypes.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.storeTypes.length; ++i)
                                writer.int32(message.storeTypes[i]);
                            writer.ldelim();
                        }
                        if (message.countingTypes != null && message.countingTypes.length) {
                            writer.uint32(/* id 9, wireType 2 =*/74).fork();
                            for (var i = 0; i < message.countingTypes.length; ++i)
                                writer.int32(message.countingTypes[i]);
                            writer.ldelim();
                        }
                        if (message.isEnabledForSuggestion != null && Object.hasOwnProperty.call(message, "isEnabledForSuggestion"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isEnabledForSuggestion);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergingConfigPreset message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergingConfigPreset.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfigPreset} message MergingConfigPreset message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingConfigPreset.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergingConfigPreset message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergingConfigPreset} MergingConfigPreset
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingConfigPreset.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergingConfigPreset();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.config = $root.palexy.streaming.v1.MergingConfig.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.note = reader.string();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 7:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            case 8:
                                if (!(message.storeTypes && message.storeTypes.length))
                                    message.storeTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeTypes.push(reader.int32());
                                } else
                                    message.storeTypes.push(reader.int32());
                                break;
                            case 9:
                                if (!(message.countingTypes && message.countingTypes.length))
                                    message.countingTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.countingTypes.push(reader.int32());
                                } else
                                    message.countingTypes.push(reader.int32());
                                break;
                            case 10:
                                message.isEnabledForSuggestion = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergingConfigPreset message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergingConfigPreset} MergingConfigPreset
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingConfigPreset.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergingConfigPreset message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergingConfigPreset.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.MergingConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        if (message.storeTypes != null && message.hasOwnProperty("storeTypes")) {
                            if (!Array.isArray(message.storeTypes))
                                return "storeTypes: array expected";
                            for (var i = 0; i < message.storeTypes.length; ++i)
                                switch (message.storeTypes[i]) {
                                default:
                                    return "storeTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                        }
                        if (message.countingTypes != null && message.hasOwnProperty("countingTypes")) {
                            if (!Array.isArray(message.countingTypes))
                                return "countingTypes: array expected";
                            for (var i = 0; i < message.countingTypes.length; ++i)
                                switch (message.countingTypes[i]) {
                                default:
                                    return "countingTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                        }
                        if (message.isEnabledForSuggestion != null && message.hasOwnProperty("isEnabledForSuggestion"))
                            if (typeof message.isEnabledForSuggestion !== "boolean")
                                return "isEnabledForSuggestion: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergingConfigPreset message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergingConfigPreset} MergingConfigPreset
                     */
                    MergingConfigPreset.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergingConfigPreset)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergingConfigPreset();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfigPreset.config: object expected");
                            message.config = $root.palexy.streaming.v1.MergingConfig.fromObject(object.config);
                        }
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.note != null)
                            message.note = String(object.note);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.MergingConfigPreset.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        if (object.storeTypes) {
                            if (!Array.isArray(object.storeTypes))
                                throw TypeError(".palexy.streaming.v1.MergingConfigPreset.storeTypes: array expected");
                            message.storeTypes = [];
                            for (var i = 0; i < object.storeTypes.length; ++i)
                                switch (object.storeTypes[i]) {
                                default:
                                case "UNKNOWN":
                                case 0:
                                    message.storeTypes[i] = 0;
                                    break;
                                case "INDEPENDENT":
                                case 1:
                                    message.storeTypes[i] = 1;
                                    break;
                                case "SHOPPING_MALL":
                                case 2:
                                    message.storeTypes[i] = 2;
                                    break;
                                }
                        }
                        if (object.countingTypes) {
                            if (!Array.isArray(object.countingTypes))
                                throw TypeError(".palexy.streaming.v1.MergingConfigPreset.countingTypes: array expected");
                            message.countingTypes = [];
                            for (var i = 0; i < object.countingTypes.length; ++i)
                                switch (object.countingTypes[i]) {
                                default:
                                case "UNKNOWN_COUNTING_TYPE":
                                case 0:
                                    message.countingTypes[i] = 0;
                                    break;
                                case "FULL_ANALYTIC":
                                case 1:
                                    message.countingTypes[i] = 1;
                                    break;
                                case "TRAFFIC_COUNTING":
                                case 2:
                                    message.countingTypes[i] = 2;
                                    break;
                                case "ENTRANCE_COUNTING":
                                case 3:
                                    message.countingTypes[i] = 3;
                                    break;
                                case "MINIMAL_CAMERA_COUNTING":
                                case 4:
                                    message.countingTypes[i] = 4;
                                    break;
                                case "ENTRANCE_ANCHOR_MERGING":
                                case 5:
                                    message.countingTypes[i] = 5;
                                    break;
                                }
                        }
                        if (object.isEnabledForSuggestion != null)
                            message.isEnabledForSuggestion = Boolean(object.isEnabledForSuggestion);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergingConfigPreset message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @static
                     * @param {palexy.streaming.v1.MergingConfigPreset} message MergingConfigPreset
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergingConfigPreset.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.companyIds = [];
                            object.storeTypes = [];
                            object.countingTypes = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.config = null;
                            object.name = "";
                            object.note = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.isEnabledForSuggestion = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.MergingConfig.toObject(message.config, options);
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        if (message.storeTypes && message.storeTypes.length) {
                            object.storeTypes = [];
                            for (var j = 0; j < message.storeTypes.length; ++j)
                                object.storeTypes[j] = options.enums === String ? $root.palexy.streaming.v1.Store.StoreType[message.storeTypes[j]] : message.storeTypes[j];
                        }
                        if (message.countingTypes && message.countingTypes.length) {
                            object.countingTypes = [];
                            for (var j = 0; j < message.countingTypes.length; ++j)
                                object.countingTypes[j] = options.enums === String ? $root.palexy.streaming.v1.Store.CountingType[message.countingTypes[j]] : message.countingTypes[j];
                        }
                        if (message.isEnabledForSuggestion != null && message.hasOwnProperty("isEnabledForSuggestion"))
                            object.isEnabledForSuggestion = message.isEnabledForSuggestion;
                        return object;
                    };
    
                    /**
                     * Converts this MergingConfigPreset to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergingConfigPreset
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergingConfigPreset.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergingConfigPreset;
                })();
    
                v1.MergingConfig = (function() {
    
                    /**
                     * Properties of a MergingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IMergingConfig
                     * @property {number|null} [singleCameraMaxFeatureDistanceThreshold] MergingConfig singleCameraMaxFeatureDistanceThreshold
                     * @property {number|null} [maxTimeDistanceInSeconds] MergingConfig maxTimeDistanceInSeconds
                     * @property {number|null} [maxCameraDistanceInPixels] MergingConfig maxCameraDistanceInPixels
                     * @property {boolean|null} [keepStaffTracklets] MergingConfig keepStaffTracklets
                     * @property {number|null} [minimumTrackletSize] MergingConfig minimumTrackletSize
                     * @property {palexy.streaming.v1.IOutlierFilteringConfig|null} [outlierFilterConfig] MergingConfig outlierFilterConfig
                     * @property {number|null} [globalViewMaxTimeDistanceInSeconds] MergingConfig globalViewMaxTimeDistanceInSeconds
                     * @property {number|null} [crossCameraMaxFeatureDistanceThreshold] MergingConfig crossCameraMaxFeatureDistanceThreshold
                     * @property {number|null} [globalViewMaxFeatureDistanceThreshold] MergingConfig globalViewMaxFeatureDistanceThreshold
                     * @property {number|null} [maxSameCameraOverlapRatio] MergingConfig maxSameCameraOverlapRatio
                     * @property {number|null} [maxCrossCameraOverlapRatio] MergingConfig maxCrossCameraOverlapRatio
                     * @property {number|null} [genderCheckingFeatureDistanceThreshold] MergingConfig genderCheckingFeatureDistanceThreshold
                     * @property {number|null} [featureDistancePercentileWhenCompareWithGroup] MergingConfig featureDistancePercentileWhenCompareWithGroup
                     * @property {boolean|null} [skipRefreshGroupCandidateEveryMerge] MergingConfig skipRefreshGroupCandidateEveryMerge
                     * @property {number|null} [nearnessCheckMaxCameraDistanceInPixels] MergingConfig nearnessCheckMaxCameraDistanceInPixels
                     * @property {boolean|null} [skipMergingByNearness] MergingConfig skipMergingByNearness
                     * @property {palexy.streaming.v1.IEntranceMergingConfig|null} [entranceMergingConfigInSupermarket] MergingConfig entranceMergingConfigInSupermarket
                     * @property {palexy.streaming.v1.IQueueTimeMergingConfig|null} [queueTimeMergingConfigInSupermarket] MergingConfig queueTimeMergingConfigInSupermarket
                     * @property {palexy.streaming.v1.ISectionMergingConfig|null} [sectionMergingConfigInSupermarket] MergingConfig sectionMergingConfigInSupermarket
                     * @property {boolean|null} [skipDetectingOutliers] MergingConfig skipDetectingOutliers
                     * @property {boolean|null} [mergeVisitorsAtWaitingArea] MergingConfig mergeVisitorsAtWaitingArea
                     * @property {boolean|null} [skipRemergeVeryCloseClustersByFeatureDistance] MergingConfig skipRemergeVeryCloseClustersByFeatureDistance
                     * @property {number|null} [maxTimeDistanceForRemerge] MergingConfig maxTimeDistanceForRemerge
                     * @property {number|null} [veryCloseFeatureDistanceThreshold] MergingConfig veryCloseFeatureDistanceThreshold
                     * @property {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig|null} [crossCameraAdjustByDensityConfig] MergingConfig crossCameraAdjustByDensityConfig
                     * @property {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig|null} [veryCloseThresAdjustByDensityConfig] MergingConfig veryCloseThresAdjustByDensityConfig
                     * @property {boolean|null} [disableDensityTrafficEstimator] MergingConfig disableDensityTrafficEstimator
                     * @property {palexy.streaming.v1.IWideSpaceEntranceConfig|null} [wideSpaceEntranceConfig] MergingConfig wideSpaceEntranceConfig
                     * @property {number|null} [veryVeryCloseFeatureDistanceForStaff] MergingConfig veryVeryCloseFeatureDistanceForStaff
                     * @property {number|null} [maxTimeDistanceForVeryVeryCloseForStaff] MergingConfig maxTimeDistanceForVeryVeryCloseForStaff
                     * @property {number|null} [maxPeopleToStillUseNearness] MergingConfig maxPeopleToStillUseNearness
                     * @property {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig|null} [singleCameraAdjustByDensityConfig] MergingConfig singleCameraAdjustByDensityConfig
                     * @property {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig|null} [globalViewThresAdjustByDensityConfig] MergingConfig globalViewThresAdjustByDensityConfig
                     * @property {palexy.streaming.v1.ICrossCameraDetectorConfig|null} [crossCameraDetectorConfig] MergingConfig crossCameraDetectorConfig
                     * @property {number|null} [maxInternalFeatureDistanceThreshold] MergingConfig maxInternalFeatureDistanceThreshold
                     * @property {number|null} [maxFeatureThresholdAtRefinementAfterMxnMatching] MergingConfig maxFeatureThresholdAtRefinementAfterMxnMatching
                     * @property {palexy.streaming.v1.IRerunSingleCameraTrackingConfig|null} [rerunSingleCameraTrackingConfig] MergingConfig rerunSingleCameraTrackingConfig
                     * @property {boolean|null} [skipMainMerging] MergingConfig skipMainMerging
                     * @property {palexy.streaming.v1.IRunMallMergingConfig|null} [runMallMergingConfig] MergingConfig runMallMergingConfig
                     * @property {boolean|null} [skipRunRefine] MergingConfig skipRunRefine
                     * @property {palexy.streaming.v1.IMinimalCameraCountingConfig|null} [minimalCameraCountingConfig] MergingConfig minimalCameraCountingConfig
                     * @property {string|null} [name] MergingConfig name
                     * @property {string|null} [version] MergingConfig version
                     */
    
                    /**
                     * Constructs a new MergingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingConfig.
                     * @implements IMergingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IMergingConfig=} [properties] Properties to set
                     */
                    function MergingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergingConfig singleCameraMaxFeatureDistanceThreshold.
                     * @member {number} singleCameraMaxFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.singleCameraMaxFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig maxTimeDistanceInSeconds.
                     * @member {number} maxTimeDistanceInSeconds
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxTimeDistanceInSeconds = 0;
    
                    /**
                     * MergingConfig maxCameraDistanceInPixels.
                     * @member {number} maxCameraDistanceInPixels
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxCameraDistanceInPixels = 0;
    
                    /**
                     * MergingConfig keepStaffTracklets.
                     * @member {boolean} keepStaffTracklets
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.keepStaffTracklets = false;
    
                    /**
                     * MergingConfig minimumTrackletSize.
                     * @member {number} minimumTrackletSize
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.minimumTrackletSize = 0;
    
                    /**
                     * MergingConfig outlierFilterConfig.
                     * @member {palexy.streaming.v1.IOutlierFilteringConfig|null|undefined} outlierFilterConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.outlierFilterConfig = null;
    
                    /**
                     * MergingConfig globalViewMaxTimeDistanceInSeconds.
                     * @member {number} globalViewMaxTimeDistanceInSeconds
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.globalViewMaxTimeDistanceInSeconds = 0;
    
                    /**
                     * MergingConfig crossCameraMaxFeatureDistanceThreshold.
                     * @member {number} crossCameraMaxFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.crossCameraMaxFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig globalViewMaxFeatureDistanceThreshold.
                     * @member {number} globalViewMaxFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.globalViewMaxFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig maxSameCameraOverlapRatio.
                     * @member {number} maxSameCameraOverlapRatio
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxSameCameraOverlapRatio = 0;
    
                    /**
                     * MergingConfig maxCrossCameraOverlapRatio.
                     * @member {number} maxCrossCameraOverlapRatio
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxCrossCameraOverlapRatio = 0;
    
                    /**
                     * MergingConfig genderCheckingFeatureDistanceThreshold.
                     * @member {number} genderCheckingFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.genderCheckingFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig featureDistancePercentileWhenCompareWithGroup.
                     * @member {number} featureDistancePercentileWhenCompareWithGroup
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.featureDistancePercentileWhenCompareWithGroup = 0;
    
                    /**
                     * MergingConfig skipRefreshGroupCandidateEveryMerge.
                     * @member {boolean} skipRefreshGroupCandidateEveryMerge
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipRefreshGroupCandidateEveryMerge = false;
    
                    /**
                     * MergingConfig nearnessCheckMaxCameraDistanceInPixels.
                     * @member {number} nearnessCheckMaxCameraDistanceInPixels
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.nearnessCheckMaxCameraDistanceInPixels = 0;
    
                    /**
                     * MergingConfig skipMergingByNearness.
                     * @member {boolean} skipMergingByNearness
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipMergingByNearness = false;
    
                    /**
                     * MergingConfig entranceMergingConfigInSupermarket.
                     * @member {palexy.streaming.v1.IEntranceMergingConfig|null|undefined} entranceMergingConfigInSupermarket
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.entranceMergingConfigInSupermarket = null;
    
                    /**
                     * MergingConfig queueTimeMergingConfigInSupermarket.
                     * @member {palexy.streaming.v1.IQueueTimeMergingConfig|null|undefined} queueTimeMergingConfigInSupermarket
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.queueTimeMergingConfigInSupermarket = null;
    
                    /**
                     * MergingConfig sectionMergingConfigInSupermarket.
                     * @member {palexy.streaming.v1.ISectionMergingConfig|null|undefined} sectionMergingConfigInSupermarket
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.sectionMergingConfigInSupermarket = null;
    
                    /**
                     * MergingConfig skipDetectingOutliers.
                     * @member {boolean} skipDetectingOutliers
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipDetectingOutliers = false;
    
                    /**
                     * MergingConfig mergeVisitorsAtWaitingArea.
                     * @member {boolean} mergeVisitorsAtWaitingArea
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.mergeVisitorsAtWaitingArea = false;
    
                    /**
                     * MergingConfig skipRemergeVeryCloseClustersByFeatureDistance.
                     * @member {boolean} skipRemergeVeryCloseClustersByFeatureDistance
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipRemergeVeryCloseClustersByFeatureDistance = false;
    
                    /**
                     * MergingConfig maxTimeDistanceForRemerge.
                     * @member {number} maxTimeDistanceForRemerge
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxTimeDistanceForRemerge = 0;
    
                    /**
                     * MergingConfig veryCloseFeatureDistanceThreshold.
                     * @member {number} veryCloseFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.veryCloseFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig crossCameraAdjustByDensityConfig.
                     * @member {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig|null|undefined} crossCameraAdjustByDensityConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.crossCameraAdjustByDensityConfig = null;
    
                    /**
                     * MergingConfig veryCloseThresAdjustByDensityConfig.
                     * @member {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig|null|undefined} veryCloseThresAdjustByDensityConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.veryCloseThresAdjustByDensityConfig = null;
    
                    /**
                     * MergingConfig disableDensityTrafficEstimator.
                     * @member {boolean} disableDensityTrafficEstimator
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.disableDensityTrafficEstimator = false;
    
                    /**
                     * MergingConfig wideSpaceEntranceConfig.
                     * @member {palexy.streaming.v1.IWideSpaceEntranceConfig|null|undefined} wideSpaceEntranceConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.wideSpaceEntranceConfig = null;
    
                    /**
                     * MergingConfig veryVeryCloseFeatureDistanceForStaff.
                     * @member {number} veryVeryCloseFeatureDistanceForStaff
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.veryVeryCloseFeatureDistanceForStaff = 0;
    
                    /**
                     * MergingConfig maxTimeDistanceForVeryVeryCloseForStaff.
                     * @member {number} maxTimeDistanceForVeryVeryCloseForStaff
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxTimeDistanceForVeryVeryCloseForStaff = 0;
    
                    /**
                     * MergingConfig maxPeopleToStillUseNearness.
                     * @member {number} maxPeopleToStillUseNearness
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxPeopleToStillUseNearness = 0;
    
                    /**
                     * MergingConfig singleCameraAdjustByDensityConfig.
                     * @member {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig|null|undefined} singleCameraAdjustByDensityConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.singleCameraAdjustByDensityConfig = null;
    
                    /**
                     * MergingConfig globalViewThresAdjustByDensityConfig.
                     * @member {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig|null|undefined} globalViewThresAdjustByDensityConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.globalViewThresAdjustByDensityConfig = null;
    
                    /**
                     * MergingConfig crossCameraDetectorConfig.
                     * @member {palexy.streaming.v1.ICrossCameraDetectorConfig|null|undefined} crossCameraDetectorConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.crossCameraDetectorConfig = null;
    
                    /**
                     * MergingConfig maxInternalFeatureDistanceThreshold.
                     * @member {number} maxInternalFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxInternalFeatureDistanceThreshold = 0;
    
                    /**
                     * MergingConfig maxFeatureThresholdAtRefinementAfterMxnMatching.
                     * @member {number} maxFeatureThresholdAtRefinementAfterMxnMatching
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.maxFeatureThresholdAtRefinementAfterMxnMatching = 0;
    
                    /**
                     * MergingConfig rerunSingleCameraTrackingConfig.
                     * @member {palexy.streaming.v1.IRerunSingleCameraTrackingConfig|null|undefined} rerunSingleCameraTrackingConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.rerunSingleCameraTrackingConfig = null;
    
                    /**
                     * MergingConfig skipMainMerging.
                     * @member {boolean} skipMainMerging
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipMainMerging = false;
    
                    /**
                     * MergingConfig runMallMergingConfig.
                     * @member {palexy.streaming.v1.IRunMallMergingConfig|null|undefined} runMallMergingConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.runMallMergingConfig = null;
    
                    /**
                     * MergingConfig skipRunRefine.
                     * @member {boolean} skipRunRefine
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.skipRunRefine = false;
    
                    /**
                     * MergingConfig minimalCameraCountingConfig.
                     * @member {palexy.streaming.v1.IMinimalCameraCountingConfig|null|undefined} minimalCameraCountingConfig
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.minimalCameraCountingConfig = null;
    
                    /**
                     * MergingConfig name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.name = "";
    
                    /**
                     * MergingConfig version.
                     * @member {string} version
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     */
                    MergingConfig.prototype.version = "";
    
                    /**
                     * Creates a new MergingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergingConfig} MergingConfig instance
                     */
                    MergingConfig.create = function create(properties) {
                        return new MergingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified MergingConfig message. Does not implicitly {@link palexy.streaming.v1.MergingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfig} message MergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.version != null && Object.hasOwnProperty.call(message, "version"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.version);
                        if (message.singleCameraMaxFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "singleCameraMaxFeatureDistanceThreshold"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.singleCameraMaxFeatureDistanceThreshold);
                        if (message.maxTimeDistanceInSeconds != null && Object.hasOwnProperty.call(message, "maxTimeDistanceInSeconds"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.maxTimeDistanceInSeconds);
                        if (message.maxCameraDistanceInPixels != null && Object.hasOwnProperty.call(message, "maxCameraDistanceInPixels"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.maxCameraDistanceInPixels);
                        if (message.keepStaffTracklets != null && Object.hasOwnProperty.call(message, "keepStaffTracklets"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.keepStaffTracklets);
                        if (message.minimumTrackletSize != null && Object.hasOwnProperty.call(message, "minimumTrackletSize"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.minimumTrackletSize);
                        if (message.outlierFilterConfig != null && Object.hasOwnProperty.call(message, "outlierFilterConfig"))
                            $root.palexy.streaming.v1.OutlierFilteringConfig.encode(message.outlierFilterConfig, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.globalViewMaxTimeDistanceInSeconds != null && Object.hasOwnProperty.call(message, "globalViewMaxTimeDistanceInSeconds"))
                            writer.uint32(/* id 9, wireType 5 =*/77).float(message.globalViewMaxTimeDistanceInSeconds);
                        if (message.crossCameraMaxFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "crossCameraMaxFeatureDistanceThreshold"))
                            writer.uint32(/* id 10, wireType 5 =*/85).float(message.crossCameraMaxFeatureDistanceThreshold);
                        if (message.globalViewMaxFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "globalViewMaxFeatureDistanceThreshold"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.globalViewMaxFeatureDistanceThreshold);
                        if (message.maxSameCameraOverlapRatio != null && Object.hasOwnProperty.call(message, "maxSameCameraOverlapRatio"))
                            writer.uint32(/* id 12, wireType 5 =*/101).float(message.maxSameCameraOverlapRatio);
                        if (message.maxCrossCameraOverlapRatio != null && Object.hasOwnProperty.call(message, "maxCrossCameraOverlapRatio"))
                            writer.uint32(/* id 13, wireType 5 =*/109).float(message.maxCrossCameraOverlapRatio);
                        if (message.genderCheckingFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "genderCheckingFeatureDistanceThreshold"))
                            writer.uint32(/* id 14, wireType 5 =*/117).float(message.genderCheckingFeatureDistanceThreshold);
                        if (message.featureDistancePercentileWhenCompareWithGroup != null && Object.hasOwnProperty.call(message, "featureDistancePercentileWhenCompareWithGroup"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.featureDistancePercentileWhenCompareWithGroup);
                        if (message.skipRefreshGroupCandidateEveryMerge != null && Object.hasOwnProperty.call(message, "skipRefreshGroupCandidateEveryMerge"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.skipRefreshGroupCandidateEveryMerge);
                        if (message.nearnessCheckMaxCameraDistanceInPixels != null && Object.hasOwnProperty.call(message, "nearnessCheckMaxCameraDistanceInPixels"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.nearnessCheckMaxCameraDistanceInPixels);
                        if (message.skipMergingByNearness != null && Object.hasOwnProperty.call(message, "skipMergingByNearness"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.skipMergingByNearness);
                        if (message.entranceMergingConfigInSupermarket != null && Object.hasOwnProperty.call(message, "entranceMergingConfigInSupermarket"))
                            $root.palexy.streaming.v1.EntranceMergingConfig.encode(message.entranceMergingConfigInSupermarket, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.queueTimeMergingConfigInSupermarket != null && Object.hasOwnProperty.call(message, "queueTimeMergingConfigInSupermarket"))
                            $root.palexy.streaming.v1.QueueTimeMergingConfig.encode(message.queueTimeMergingConfigInSupermarket, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.sectionMergingConfigInSupermarket != null && Object.hasOwnProperty.call(message, "sectionMergingConfigInSupermarket"))
                            $root.palexy.streaming.v1.SectionMergingConfig.encode(message.sectionMergingConfigInSupermarket, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.skipDetectingOutliers != null && Object.hasOwnProperty.call(message, "skipDetectingOutliers"))
                            writer.uint32(/* id 22, wireType 0 =*/176).bool(message.skipDetectingOutliers);
                        if (message.mergeVisitorsAtWaitingArea != null && Object.hasOwnProperty.call(message, "mergeVisitorsAtWaitingArea"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.mergeVisitorsAtWaitingArea);
                        if (message.skipRemergeVeryCloseClustersByFeatureDistance != null && Object.hasOwnProperty.call(message, "skipRemergeVeryCloseClustersByFeatureDistance"))
                            writer.uint32(/* id 24, wireType 0 =*/192).bool(message.skipRemergeVeryCloseClustersByFeatureDistance);
                        if (message.maxTimeDistanceForRemerge != null && Object.hasOwnProperty.call(message, "maxTimeDistanceForRemerge"))
                            writer.uint32(/* id 25, wireType 0 =*/200).int32(message.maxTimeDistanceForRemerge);
                        if (message.veryCloseFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "veryCloseFeatureDistanceThreshold"))
                            writer.uint32(/* id 26, wireType 5 =*/213).float(message.veryCloseFeatureDistanceThreshold);
                        if (message.crossCameraAdjustByDensityConfig != null && Object.hasOwnProperty.call(message, "crossCameraAdjustByDensityConfig"))
                            $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.encode(message.crossCameraAdjustByDensityConfig, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                        if (message.veryCloseThresAdjustByDensityConfig != null && Object.hasOwnProperty.call(message, "veryCloseThresAdjustByDensityConfig"))
                            $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.encode(message.veryCloseThresAdjustByDensityConfig, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                        if (message.disableDensityTrafficEstimator != null && Object.hasOwnProperty.call(message, "disableDensityTrafficEstimator"))
                            writer.uint32(/* id 29, wireType 0 =*/232).bool(message.disableDensityTrafficEstimator);
                        if (message.wideSpaceEntranceConfig != null && Object.hasOwnProperty.call(message, "wideSpaceEntranceConfig"))
                            $root.palexy.streaming.v1.WideSpaceEntranceConfig.encode(message.wideSpaceEntranceConfig, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                        if (message.veryVeryCloseFeatureDistanceForStaff != null && Object.hasOwnProperty.call(message, "veryVeryCloseFeatureDistanceForStaff"))
                            writer.uint32(/* id 31, wireType 5 =*/253).float(message.veryVeryCloseFeatureDistanceForStaff);
                        if (message.maxTimeDistanceForVeryVeryCloseForStaff != null && Object.hasOwnProperty.call(message, "maxTimeDistanceForVeryVeryCloseForStaff"))
                            writer.uint32(/* id 32, wireType 0 =*/256).int32(message.maxTimeDistanceForVeryVeryCloseForStaff);
                        if (message.maxPeopleToStillUseNearness != null && Object.hasOwnProperty.call(message, "maxPeopleToStillUseNearness"))
                            writer.uint32(/* id 33, wireType 0 =*/264).int32(message.maxPeopleToStillUseNearness);
                        if (message.singleCameraAdjustByDensityConfig != null && Object.hasOwnProperty.call(message, "singleCameraAdjustByDensityConfig"))
                            $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.encode(message.singleCameraAdjustByDensityConfig, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.globalViewThresAdjustByDensityConfig != null && Object.hasOwnProperty.call(message, "globalViewThresAdjustByDensityConfig"))
                            $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.encode(message.globalViewThresAdjustByDensityConfig, writer.uint32(/* id 35, wireType 2 =*/282).fork()).ldelim();
                        if (message.crossCameraDetectorConfig != null && Object.hasOwnProperty.call(message, "crossCameraDetectorConfig"))
                            $root.palexy.streaming.v1.CrossCameraDetectorConfig.encode(message.crossCameraDetectorConfig, writer.uint32(/* id 36, wireType 2 =*/290).fork()).ldelim();
                        if (message.maxInternalFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "maxInternalFeatureDistanceThreshold"))
                            writer.uint32(/* id 37, wireType 5 =*/301).float(message.maxInternalFeatureDistanceThreshold);
                        if (message.maxFeatureThresholdAtRefinementAfterMxnMatching != null && Object.hasOwnProperty.call(message, "maxFeatureThresholdAtRefinementAfterMxnMatching"))
                            writer.uint32(/* id 38, wireType 5 =*/309).float(message.maxFeatureThresholdAtRefinementAfterMxnMatching);
                        if (message.rerunSingleCameraTrackingConfig != null && Object.hasOwnProperty.call(message, "rerunSingleCameraTrackingConfig"))
                            $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig.encode(message.rerunSingleCameraTrackingConfig, writer.uint32(/* id 39, wireType 2 =*/314).fork()).ldelim();
                        if (message.skipMainMerging != null && Object.hasOwnProperty.call(message, "skipMainMerging"))
                            writer.uint32(/* id 40, wireType 0 =*/320).bool(message.skipMainMerging);
                        if (message.runMallMergingConfig != null && Object.hasOwnProperty.call(message, "runMallMergingConfig"))
                            $root.palexy.streaming.v1.RunMallMergingConfig.encode(message.runMallMergingConfig, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
                        if (message.skipRunRefine != null && Object.hasOwnProperty.call(message, "skipRunRefine"))
                            writer.uint32(/* id 42, wireType 0 =*/336).bool(message.skipRunRefine);
                        if (message.minimalCameraCountingConfig != null && Object.hasOwnProperty.call(message, "minimalCameraCountingConfig"))
                            $root.palexy.streaming.v1.MinimalCameraCountingConfig.encode(message.minimalCameraCountingConfig, writer.uint32(/* id 43, wireType 2 =*/346).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMergingConfig} message MergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergingConfig} MergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 3:
                                message.singleCameraMaxFeatureDistanceThreshold = reader.float();
                                break;
                            case 4:
                                message.maxTimeDistanceInSeconds = reader.float();
                                break;
                            case 5:
                                message.maxCameraDistanceInPixels = reader.float();
                                break;
                            case 6:
                                message.keepStaffTracklets = reader.bool();
                                break;
                            case 7:
                                message.minimumTrackletSize = reader.int32();
                                break;
                            case 8:
                                message.outlierFilterConfig = $root.palexy.streaming.v1.OutlierFilteringConfig.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.globalViewMaxTimeDistanceInSeconds = reader.float();
                                break;
                            case 10:
                                message.crossCameraMaxFeatureDistanceThreshold = reader.float();
                                break;
                            case 11:
                                message.globalViewMaxFeatureDistanceThreshold = reader.float();
                                break;
                            case 12:
                                message.maxSameCameraOverlapRatio = reader.float();
                                break;
                            case 13:
                                message.maxCrossCameraOverlapRatio = reader.float();
                                break;
                            case 14:
                                message.genderCheckingFeatureDistanceThreshold = reader.float();
                                break;
                            case 15:
                                message.featureDistancePercentileWhenCompareWithGroup = reader.int32();
                                break;
                            case 16:
                                message.skipRefreshGroupCandidateEveryMerge = reader.bool();
                                break;
                            case 17:
                                message.nearnessCheckMaxCameraDistanceInPixels = reader.int32();
                                break;
                            case 18:
                                message.skipMergingByNearness = reader.bool();
                                break;
                            case 19:
                                message.entranceMergingConfigInSupermarket = $root.palexy.streaming.v1.EntranceMergingConfig.decode(reader, reader.uint32());
                                break;
                            case 20:
                                message.queueTimeMergingConfigInSupermarket = $root.palexy.streaming.v1.QueueTimeMergingConfig.decode(reader, reader.uint32());
                                break;
                            case 21:
                                message.sectionMergingConfigInSupermarket = $root.palexy.streaming.v1.SectionMergingConfig.decode(reader, reader.uint32());
                                break;
                            case 22:
                                message.skipDetectingOutliers = reader.bool();
                                break;
                            case 23:
                                message.mergeVisitorsAtWaitingArea = reader.bool();
                                break;
                            case 24:
                                message.skipRemergeVeryCloseClustersByFeatureDistance = reader.bool();
                                break;
                            case 25:
                                message.maxTimeDistanceForRemerge = reader.int32();
                                break;
                            case 26:
                                message.veryCloseFeatureDistanceThreshold = reader.float();
                                break;
                            case 27:
                                message.crossCameraAdjustByDensityConfig = $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.decode(reader, reader.uint32());
                                break;
                            case 28:
                                message.veryCloseThresAdjustByDensityConfig = $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.decode(reader, reader.uint32());
                                break;
                            case 29:
                                message.disableDensityTrafficEstimator = reader.bool();
                                break;
                            case 30:
                                message.wideSpaceEntranceConfig = $root.palexy.streaming.v1.WideSpaceEntranceConfig.decode(reader, reader.uint32());
                                break;
                            case 31:
                                message.veryVeryCloseFeatureDistanceForStaff = reader.float();
                                break;
                            case 32:
                                message.maxTimeDistanceForVeryVeryCloseForStaff = reader.int32();
                                break;
                            case 33:
                                message.maxPeopleToStillUseNearness = reader.int32();
                                break;
                            case 34:
                                message.singleCameraAdjustByDensityConfig = $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.decode(reader, reader.uint32());
                                break;
                            case 35:
                                message.globalViewThresAdjustByDensityConfig = $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.decode(reader, reader.uint32());
                                break;
                            case 36:
                                message.crossCameraDetectorConfig = $root.palexy.streaming.v1.CrossCameraDetectorConfig.decode(reader, reader.uint32());
                                break;
                            case 37:
                                message.maxInternalFeatureDistanceThreshold = reader.float();
                                break;
                            case 38:
                                message.maxFeatureThresholdAtRefinementAfterMxnMatching = reader.float();
                                break;
                            case 39:
                                message.rerunSingleCameraTrackingConfig = $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig.decode(reader, reader.uint32());
                                break;
                            case 40:
                                message.skipMainMerging = reader.bool();
                                break;
                            case 41:
                                message.runMallMergingConfig = $root.palexy.streaming.v1.RunMallMergingConfig.decode(reader, reader.uint32());
                                break;
                            case 42:
                                message.skipRunRefine = reader.bool();
                                break;
                            case 43:
                                message.minimalCameraCountingConfig = $root.palexy.streaming.v1.MinimalCameraCountingConfig.decode(reader, reader.uint32());
                                break;
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.version = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergingConfig} MergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.singleCameraMaxFeatureDistanceThreshold != null && message.hasOwnProperty("singleCameraMaxFeatureDistanceThreshold"))
                            if (typeof message.singleCameraMaxFeatureDistanceThreshold !== "number")
                                return "singleCameraMaxFeatureDistanceThreshold: number expected";
                        if (message.maxTimeDistanceInSeconds != null && message.hasOwnProperty("maxTimeDistanceInSeconds"))
                            if (typeof message.maxTimeDistanceInSeconds !== "number")
                                return "maxTimeDistanceInSeconds: number expected";
                        if (message.maxCameraDistanceInPixels != null && message.hasOwnProperty("maxCameraDistanceInPixels"))
                            if (typeof message.maxCameraDistanceInPixels !== "number")
                                return "maxCameraDistanceInPixels: number expected";
                        if (message.keepStaffTracklets != null && message.hasOwnProperty("keepStaffTracklets"))
                            if (typeof message.keepStaffTracklets !== "boolean")
                                return "keepStaffTracklets: boolean expected";
                        if (message.minimumTrackletSize != null && message.hasOwnProperty("minimumTrackletSize"))
                            if (!$util.isInteger(message.minimumTrackletSize))
                                return "minimumTrackletSize: integer expected";
                        if (message.outlierFilterConfig != null && message.hasOwnProperty("outlierFilterConfig")) {
                            var error = $root.palexy.streaming.v1.OutlierFilteringConfig.verify(message.outlierFilterConfig);
                            if (error)
                                return "outlierFilterConfig." + error;
                        }
                        if (message.globalViewMaxTimeDistanceInSeconds != null && message.hasOwnProperty("globalViewMaxTimeDistanceInSeconds"))
                            if (typeof message.globalViewMaxTimeDistanceInSeconds !== "number")
                                return "globalViewMaxTimeDistanceInSeconds: number expected";
                        if (message.crossCameraMaxFeatureDistanceThreshold != null && message.hasOwnProperty("crossCameraMaxFeatureDistanceThreshold"))
                            if (typeof message.crossCameraMaxFeatureDistanceThreshold !== "number")
                                return "crossCameraMaxFeatureDistanceThreshold: number expected";
                        if (message.globalViewMaxFeatureDistanceThreshold != null && message.hasOwnProperty("globalViewMaxFeatureDistanceThreshold"))
                            if (typeof message.globalViewMaxFeatureDistanceThreshold !== "number")
                                return "globalViewMaxFeatureDistanceThreshold: number expected";
                        if (message.maxSameCameraOverlapRatio != null && message.hasOwnProperty("maxSameCameraOverlapRatio"))
                            if (typeof message.maxSameCameraOverlapRatio !== "number")
                                return "maxSameCameraOverlapRatio: number expected";
                        if (message.maxCrossCameraOverlapRatio != null && message.hasOwnProperty("maxCrossCameraOverlapRatio"))
                            if (typeof message.maxCrossCameraOverlapRatio !== "number")
                                return "maxCrossCameraOverlapRatio: number expected";
                        if (message.genderCheckingFeatureDistanceThreshold != null && message.hasOwnProperty("genderCheckingFeatureDistanceThreshold"))
                            if (typeof message.genderCheckingFeatureDistanceThreshold !== "number")
                                return "genderCheckingFeatureDistanceThreshold: number expected";
                        if (message.featureDistancePercentileWhenCompareWithGroup != null && message.hasOwnProperty("featureDistancePercentileWhenCompareWithGroup"))
                            if (!$util.isInteger(message.featureDistancePercentileWhenCompareWithGroup))
                                return "featureDistancePercentileWhenCompareWithGroup: integer expected";
                        if (message.skipRefreshGroupCandidateEveryMerge != null && message.hasOwnProperty("skipRefreshGroupCandidateEveryMerge"))
                            if (typeof message.skipRefreshGroupCandidateEveryMerge !== "boolean")
                                return "skipRefreshGroupCandidateEveryMerge: boolean expected";
                        if (message.nearnessCheckMaxCameraDistanceInPixels != null && message.hasOwnProperty("nearnessCheckMaxCameraDistanceInPixels"))
                            if (!$util.isInteger(message.nearnessCheckMaxCameraDistanceInPixels))
                                return "nearnessCheckMaxCameraDistanceInPixels: integer expected";
                        if (message.skipMergingByNearness != null && message.hasOwnProperty("skipMergingByNearness"))
                            if (typeof message.skipMergingByNearness !== "boolean")
                                return "skipMergingByNearness: boolean expected";
                        if (message.entranceMergingConfigInSupermarket != null && message.hasOwnProperty("entranceMergingConfigInSupermarket")) {
                            var error = $root.palexy.streaming.v1.EntranceMergingConfig.verify(message.entranceMergingConfigInSupermarket);
                            if (error)
                                return "entranceMergingConfigInSupermarket." + error;
                        }
                        if (message.queueTimeMergingConfigInSupermarket != null && message.hasOwnProperty("queueTimeMergingConfigInSupermarket")) {
                            var error = $root.palexy.streaming.v1.QueueTimeMergingConfig.verify(message.queueTimeMergingConfigInSupermarket);
                            if (error)
                                return "queueTimeMergingConfigInSupermarket." + error;
                        }
                        if (message.sectionMergingConfigInSupermarket != null && message.hasOwnProperty("sectionMergingConfigInSupermarket")) {
                            var error = $root.palexy.streaming.v1.SectionMergingConfig.verify(message.sectionMergingConfigInSupermarket);
                            if (error)
                                return "sectionMergingConfigInSupermarket." + error;
                        }
                        if (message.skipDetectingOutliers != null && message.hasOwnProperty("skipDetectingOutliers"))
                            if (typeof message.skipDetectingOutliers !== "boolean")
                                return "skipDetectingOutliers: boolean expected";
                        if (message.mergeVisitorsAtWaitingArea != null && message.hasOwnProperty("mergeVisitorsAtWaitingArea"))
                            if (typeof message.mergeVisitorsAtWaitingArea !== "boolean")
                                return "mergeVisitorsAtWaitingArea: boolean expected";
                        if (message.skipRemergeVeryCloseClustersByFeatureDistance != null && message.hasOwnProperty("skipRemergeVeryCloseClustersByFeatureDistance"))
                            if (typeof message.skipRemergeVeryCloseClustersByFeatureDistance !== "boolean")
                                return "skipRemergeVeryCloseClustersByFeatureDistance: boolean expected";
                        if (message.maxTimeDistanceForRemerge != null && message.hasOwnProperty("maxTimeDistanceForRemerge"))
                            if (!$util.isInteger(message.maxTimeDistanceForRemerge))
                                return "maxTimeDistanceForRemerge: integer expected";
                        if (message.veryCloseFeatureDistanceThreshold != null && message.hasOwnProperty("veryCloseFeatureDistanceThreshold"))
                            if (typeof message.veryCloseFeatureDistanceThreshold !== "number")
                                return "veryCloseFeatureDistanceThreshold: number expected";
                        if (message.crossCameraAdjustByDensityConfig != null && message.hasOwnProperty("crossCameraAdjustByDensityConfig")) {
                            var error = $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.verify(message.crossCameraAdjustByDensityConfig);
                            if (error)
                                return "crossCameraAdjustByDensityConfig." + error;
                        }
                        if (message.veryCloseThresAdjustByDensityConfig != null && message.hasOwnProperty("veryCloseThresAdjustByDensityConfig")) {
                            var error = $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.verify(message.veryCloseThresAdjustByDensityConfig);
                            if (error)
                                return "veryCloseThresAdjustByDensityConfig." + error;
                        }
                        if (message.disableDensityTrafficEstimator != null && message.hasOwnProperty("disableDensityTrafficEstimator"))
                            if (typeof message.disableDensityTrafficEstimator !== "boolean")
                                return "disableDensityTrafficEstimator: boolean expected";
                        if (message.wideSpaceEntranceConfig != null && message.hasOwnProperty("wideSpaceEntranceConfig")) {
                            var error = $root.palexy.streaming.v1.WideSpaceEntranceConfig.verify(message.wideSpaceEntranceConfig);
                            if (error)
                                return "wideSpaceEntranceConfig." + error;
                        }
                        if (message.veryVeryCloseFeatureDistanceForStaff != null && message.hasOwnProperty("veryVeryCloseFeatureDistanceForStaff"))
                            if (typeof message.veryVeryCloseFeatureDistanceForStaff !== "number")
                                return "veryVeryCloseFeatureDistanceForStaff: number expected";
                        if (message.maxTimeDistanceForVeryVeryCloseForStaff != null && message.hasOwnProperty("maxTimeDistanceForVeryVeryCloseForStaff"))
                            if (!$util.isInteger(message.maxTimeDistanceForVeryVeryCloseForStaff))
                                return "maxTimeDistanceForVeryVeryCloseForStaff: integer expected";
                        if (message.maxPeopleToStillUseNearness != null && message.hasOwnProperty("maxPeopleToStillUseNearness"))
                            if (!$util.isInteger(message.maxPeopleToStillUseNearness))
                                return "maxPeopleToStillUseNearness: integer expected";
                        if (message.singleCameraAdjustByDensityConfig != null && message.hasOwnProperty("singleCameraAdjustByDensityConfig")) {
                            var error = $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.verify(message.singleCameraAdjustByDensityConfig);
                            if (error)
                                return "singleCameraAdjustByDensityConfig." + error;
                        }
                        if (message.globalViewThresAdjustByDensityConfig != null && message.hasOwnProperty("globalViewThresAdjustByDensityConfig")) {
                            var error = $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.verify(message.globalViewThresAdjustByDensityConfig);
                            if (error)
                                return "globalViewThresAdjustByDensityConfig." + error;
                        }
                        if (message.crossCameraDetectorConfig != null && message.hasOwnProperty("crossCameraDetectorConfig")) {
                            var error = $root.palexy.streaming.v1.CrossCameraDetectorConfig.verify(message.crossCameraDetectorConfig);
                            if (error)
                                return "crossCameraDetectorConfig." + error;
                        }
                        if (message.maxInternalFeatureDistanceThreshold != null && message.hasOwnProperty("maxInternalFeatureDistanceThreshold"))
                            if (typeof message.maxInternalFeatureDistanceThreshold !== "number")
                                return "maxInternalFeatureDistanceThreshold: number expected";
                        if (message.maxFeatureThresholdAtRefinementAfterMxnMatching != null && message.hasOwnProperty("maxFeatureThresholdAtRefinementAfterMxnMatching"))
                            if (typeof message.maxFeatureThresholdAtRefinementAfterMxnMatching !== "number")
                                return "maxFeatureThresholdAtRefinementAfterMxnMatching: number expected";
                        if (message.rerunSingleCameraTrackingConfig != null && message.hasOwnProperty("rerunSingleCameraTrackingConfig")) {
                            var error = $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig.verify(message.rerunSingleCameraTrackingConfig);
                            if (error)
                                return "rerunSingleCameraTrackingConfig." + error;
                        }
                        if (message.skipMainMerging != null && message.hasOwnProperty("skipMainMerging"))
                            if (typeof message.skipMainMerging !== "boolean")
                                return "skipMainMerging: boolean expected";
                        if (message.runMallMergingConfig != null && message.hasOwnProperty("runMallMergingConfig")) {
                            var error = $root.palexy.streaming.v1.RunMallMergingConfig.verify(message.runMallMergingConfig);
                            if (error)
                                return "runMallMergingConfig." + error;
                        }
                        if (message.skipRunRefine != null && message.hasOwnProperty("skipRunRefine"))
                            if (typeof message.skipRunRefine !== "boolean")
                                return "skipRunRefine: boolean expected";
                        if (message.minimalCameraCountingConfig != null && message.hasOwnProperty("minimalCameraCountingConfig")) {
                            var error = $root.palexy.streaming.v1.MinimalCameraCountingConfig.verify(message.minimalCameraCountingConfig);
                            if (error)
                                return "minimalCameraCountingConfig." + error;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.version != null && message.hasOwnProperty("version"))
                            if (!$util.isString(message.version))
                                return "version: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergingConfig} MergingConfig
                     */
                    MergingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergingConfig();
                        if (object.singleCameraMaxFeatureDistanceThreshold != null)
                            message.singleCameraMaxFeatureDistanceThreshold = Number(object.singleCameraMaxFeatureDistanceThreshold);
                        if (object.maxTimeDistanceInSeconds != null)
                            message.maxTimeDistanceInSeconds = Number(object.maxTimeDistanceInSeconds);
                        if (object.maxCameraDistanceInPixels != null)
                            message.maxCameraDistanceInPixels = Number(object.maxCameraDistanceInPixels);
                        if (object.keepStaffTracklets != null)
                            message.keepStaffTracklets = Boolean(object.keepStaffTracklets);
                        if (object.minimumTrackletSize != null)
                            message.minimumTrackletSize = object.minimumTrackletSize | 0;
                        if (object.outlierFilterConfig != null) {
                            if (typeof object.outlierFilterConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.outlierFilterConfig: object expected");
                            message.outlierFilterConfig = $root.palexy.streaming.v1.OutlierFilteringConfig.fromObject(object.outlierFilterConfig);
                        }
                        if (object.globalViewMaxTimeDistanceInSeconds != null)
                            message.globalViewMaxTimeDistanceInSeconds = Number(object.globalViewMaxTimeDistanceInSeconds);
                        if (object.crossCameraMaxFeatureDistanceThreshold != null)
                            message.crossCameraMaxFeatureDistanceThreshold = Number(object.crossCameraMaxFeatureDistanceThreshold);
                        if (object.globalViewMaxFeatureDistanceThreshold != null)
                            message.globalViewMaxFeatureDistanceThreshold = Number(object.globalViewMaxFeatureDistanceThreshold);
                        if (object.maxSameCameraOverlapRatio != null)
                            message.maxSameCameraOverlapRatio = Number(object.maxSameCameraOverlapRatio);
                        if (object.maxCrossCameraOverlapRatio != null)
                            message.maxCrossCameraOverlapRatio = Number(object.maxCrossCameraOverlapRatio);
                        if (object.genderCheckingFeatureDistanceThreshold != null)
                            message.genderCheckingFeatureDistanceThreshold = Number(object.genderCheckingFeatureDistanceThreshold);
                        if (object.featureDistancePercentileWhenCompareWithGroup != null)
                            message.featureDistancePercentileWhenCompareWithGroup = object.featureDistancePercentileWhenCompareWithGroup | 0;
                        if (object.skipRefreshGroupCandidateEveryMerge != null)
                            message.skipRefreshGroupCandidateEveryMerge = Boolean(object.skipRefreshGroupCandidateEveryMerge);
                        if (object.nearnessCheckMaxCameraDistanceInPixels != null)
                            message.nearnessCheckMaxCameraDistanceInPixels = object.nearnessCheckMaxCameraDistanceInPixels | 0;
                        if (object.skipMergingByNearness != null)
                            message.skipMergingByNearness = Boolean(object.skipMergingByNearness);
                        if (object.entranceMergingConfigInSupermarket != null) {
                            if (typeof object.entranceMergingConfigInSupermarket !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.entranceMergingConfigInSupermarket: object expected");
                            message.entranceMergingConfigInSupermarket = $root.palexy.streaming.v1.EntranceMergingConfig.fromObject(object.entranceMergingConfigInSupermarket);
                        }
                        if (object.queueTimeMergingConfigInSupermarket != null) {
                            if (typeof object.queueTimeMergingConfigInSupermarket !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.queueTimeMergingConfigInSupermarket: object expected");
                            message.queueTimeMergingConfigInSupermarket = $root.palexy.streaming.v1.QueueTimeMergingConfig.fromObject(object.queueTimeMergingConfigInSupermarket);
                        }
                        if (object.sectionMergingConfigInSupermarket != null) {
                            if (typeof object.sectionMergingConfigInSupermarket !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.sectionMergingConfigInSupermarket: object expected");
                            message.sectionMergingConfigInSupermarket = $root.palexy.streaming.v1.SectionMergingConfig.fromObject(object.sectionMergingConfigInSupermarket);
                        }
                        if (object.skipDetectingOutliers != null)
                            message.skipDetectingOutliers = Boolean(object.skipDetectingOutliers);
                        if (object.mergeVisitorsAtWaitingArea != null)
                            message.mergeVisitorsAtWaitingArea = Boolean(object.mergeVisitorsAtWaitingArea);
                        if (object.skipRemergeVeryCloseClustersByFeatureDistance != null)
                            message.skipRemergeVeryCloseClustersByFeatureDistance = Boolean(object.skipRemergeVeryCloseClustersByFeatureDistance);
                        if (object.maxTimeDistanceForRemerge != null)
                            message.maxTimeDistanceForRemerge = object.maxTimeDistanceForRemerge | 0;
                        if (object.veryCloseFeatureDistanceThreshold != null)
                            message.veryCloseFeatureDistanceThreshold = Number(object.veryCloseFeatureDistanceThreshold);
                        if (object.crossCameraAdjustByDensityConfig != null) {
                            if (typeof object.crossCameraAdjustByDensityConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.crossCameraAdjustByDensityConfig: object expected");
                            message.crossCameraAdjustByDensityConfig = $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.fromObject(object.crossCameraAdjustByDensityConfig);
                        }
                        if (object.veryCloseThresAdjustByDensityConfig != null) {
                            if (typeof object.veryCloseThresAdjustByDensityConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.veryCloseThresAdjustByDensityConfig: object expected");
                            message.veryCloseThresAdjustByDensityConfig = $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.fromObject(object.veryCloseThresAdjustByDensityConfig);
                        }
                        if (object.disableDensityTrafficEstimator != null)
                            message.disableDensityTrafficEstimator = Boolean(object.disableDensityTrafficEstimator);
                        if (object.wideSpaceEntranceConfig != null) {
                            if (typeof object.wideSpaceEntranceConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.wideSpaceEntranceConfig: object expected");
                            message.wideSpaceEntranceConfig = $root.palexy.streaming.v1.WideSpaceEntranceConfig.fromObject(object.wideSpaceEntranceConfig);
                        }
                        if (object.veryVeryCloseFeatureDistanceForStaff != null)
                            message.veryVeryCloseFeatureDistanceForStaff = Number(object.veryVeryCloseFeatureDistanceForStaff);
                        if (object.maxTimeDistanceForVeryVeryCloseForStaff != null)
                            message.maxTimeDistanceForVeryVeryCloseForStaff = object.maxTimeDistanceForVeryVeryCloseForStaff | 0;
                        if (object.maxPeopleToStillUseNearness != null)
                            message.maxPeopleToStillUseNearness = object.maxPeopleToStillUseNearness | 0;
                        if (object.singleCameraAdjustByDensityConfig != null) {
                            if (typeof object.singleCameraAdjustByDensityConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.singleCameraAdjustByDensityConfig: object expected");
                            message.singleCameraAdjustByDensityConfig = $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.fromObject(object.singleCameraAdjustByDensityConfig);
                        }
                        if (object.globalViewThresAdjustByDensityConfig != null) {
                            if (typeof object.globalViewThresAdjustByDensityConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.globalViewThresAdjustByDensityConfig: object expected");
                            message.globalViewThresAdjustByDensityConfig = $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.fromObject(object.globalViewThresAdjustByDensityConfig);
                        }
                        if (object.crossCameraDetectorConfig != null) {
                            if (typeof object.crossCameraDetectorConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.crossCameraDetectorConfig: object expected");
                            message.crossCameraDetectorConfig = $root.palexy.streaming.v1.CrossCameraDetectorConfig.fromObject(object.crossCameraDetectorConfig);
                        }
                        if (object.maxInternalFeatureDistanceThreshold != null)
                            message.maxInternalFeatureDistanceThreshold = Number(object.maxInternalFeatureDistanceThreshold);
                        if (object.maxFeatureThresholdAtRefinementAfterMxnMatching != null)
                            message.maxFeatureThresholdAtRefinementAfterMxnMatching = Number(object.maxFeatureThresholdAtRefinementAfterMxnMatching);
                        if (object.rerunSingleCameraTrackingConfig != null) {
                            if (typeof object.rerunSingleCameraTrackingConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.rerunSingleCameraTrackingConfig: object expected");
                            message.rerunSingleCameraTrackingConfig = $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig.fromObject(object.rerunSingleCameraTrackingConfig);
                        }
                        if (object.skipMainMerging != null)
                            message.skipMainMerging = Boolean(object.skipMainMerging);
                        if (object.runMallMergingConfig != null) {
                            if (typeof object.runMallMergingConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.runMallMergingConfig: object expected");
                            message.runMallMergingConfig = $root.palexy.streaming.v1.RunMallMergingConfig.fromObject(object.runMallMergingConfig);
                        }
                        if (object.skipRunRefine != null)
                            message.skipRunRefine = Boolean(object.skipRunRefine);
                        if (object.minimalCameraCountingConfig != null) {
                            if (typeof object.minimalCameraCountingConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingConfig.minimalCameraCountingConfig: object expected");
                            message.minimalCameraCountingConfig = $root.palexy.streaming.v1.MinimalCameraCountingConfig.fromObject(object.minimalCameraCountingConfig);
                        }
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.version != null)
                            message.version = String(object.version);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @static
                     * @param {palexy.streaming.v1.MergingConfig} message MergingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.version = "";
                            object.singleCameraMaxFeatureDistanceThreshold = 0;
                            object.maxTimeDistanceInSeconds = 0;
                            object.maxCameraDistanceInPixels = 0;
                            object.keepStaffTracklets = false;
                            object.minimumTrackletSize = 0;
                            object.outlierFilterConfig = null;
                            object.globalViewMaxTimeDistanceInSeconds = 0;
                            object.crossCameraMaxFeatureDistanceThreshold = 0;
                            object.globalViewMaxFeatureDistanceThreshold = 0;
                            object.maxSameCameraOverlapRatio = 0;
                            object.maxCrossCameraOverlapRatio = 0;
                            object.genderCheckingFeatureDistanceThreshold = 0;
                            object.featureDistancePercentileWhenCompareWithGroup = 0;
                            object.skipRefreshGroupCandidateEveryMerge = false;
                            object.nearnessCheckMaxCameraDistanceInPixels = 0;
                            object.skipMergingByNearness = false;
                            object.entranceMergingConfigInSupermarket = null;
                            object.queueTimeMergingConfigInSupermarket = null;
                            object.sectionMergingConfigInSupermarket = null;
                            object.skipDetectingOutliers = false;
                            object.mergeVisitorsAtWaitingArea = false;
                            object.skipRemergeVeryCloseClustersByFeatureDistance = false;
                            object.maxTimeDistanceForRemerge = 0;
                            object.veryCloseFeatureDistanceThreshold = 0;
                            object.crossCameraAdjustByDensityConfig = null;
                            object.veryCloseThresAdjustByDensityConfig = null;
                            object.disableDensityTrafficEstimator = false;
                            object.wideSpaceEntranceConfig = null;
                            object.veryVeryCloseFeatureDistanceForStaff = 0;
                            object.maxTimeDistanceForVeryVeryCloseForStaff = 0;
                            object.maxPeopleToStillUseNearness = 0;
                            object.singleCameraAdjustByDensityConfig = null;
                            object.globalViewThresAdjustByDensityConfig = null;
                            object.crossCameraDetectorConfig = null;
                            object.maxInternalFeatureDistanceThreshold = 0;
                            object.maxFeatureThresholdAtRefinementAfterMxnMatching = 0;
                            object.rerunSingleCameraTrackingConfig = null;
                            object.skipMainMerging = false;
                            object.runMallMergingConfig = null;
                            object.skipRunRefine = false;
                            object.minimalCameraCountingConfig = null;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.version != null && message.hasOwnProperty("version"))
                            object.version = message.version;
                        if (message.singleCameraMaxFeatureDistanceThreshold != null && message.hasOwnProperty("singleCameraMaxFeatureDistanceThreshold"))
                            object.singleCameraMaxFeatureDistanceThreshold = options.json && !isFinite(message.singleCameraMaxFeatureDistanceThreshold) ? String(message.singleCameraMaxFeatureDistanceThreshold) : message.singleCameraMaxFeatureDistanceThreshold;
                        if (message.maxTimeDistanceInSeconds != null && message.hasOwnProperty("maxTimeDistanceInSeconds"))
                            object.maxTimeDistanceInSeconds = options.json && !isFinite(message.maxTimeDistanceInSeconds) ? String(message.maxTimeDistanceInSeconds) : message.maxTimeDistanceInSeconds;
                        if (message.maxCameraDistanceInPixels != null && message.hasOwnProperty("maxCameraDistanceInPixels"))
                            object.maxCameraDistanceInPixels = options.json && !isFinite(message.maxCameraDistanceInPixels) ? String(message.maxCameraDistanceInPixels) : message.maxCameraDistanceInPixels;
                        if (message.keepStaffTracklets != null && message.hasOwnProperty("keepStaffTracklets"))
                            object.keepStaffTracklets = message.keepStaffTracklets;
                        if (message.minimumTrackletSize != null && message.hasOwnProperty("minimumTrackletSize"))
                            object.minimumTrackletSize = message.minimumTrackletSize;
                        if (message.outlierFilterConfig != null && message.hasOwnProperty("outlierFilterConfig"))
                            object.outlierFilterConfig = $root.palexy.streaming.v1.OutlierFilteringConfig.toObject(message.outlierFilterConfig, options);
                        if (message.globalViewMaxTimeDistanceInSeconds != null && message.hasOwnProperty("globalViewMaxTimeDistanceInSeconds"))
                            object.globalViewMaxTimeDistanceInSeconds = options.json && !isFinite(message.globalViewMaxTimeDistanceInSeconds) ? String(message.globalViewMaxTimeDistanceInSeconds) : message.globalViewMaxTimeDistanceInSeconds;
                        if (message.crossCameraMaxFeatureDistanceThreshold != null && message.hasOwnProperty("crossCameraMaxFeatureDistanceThreshold"))
                            object.crossCameraMaxFeatureDistanceThreshold = options.json && !isFinite(message.crossCameraMaxFeatureDistanceThreshold) ? String(message.crossCameraMaxFeatureDistanceThreshold) : message.crossCameraMaxFeatureDistanceThreshold;
                        if (message.globalViewMaxFeatureDistanceThreshold != null && message.hasOwnProperty("globalViewMaxFeatureDistanceThreshold"))
                            object.globalViewMaxFeatureDistanceThreshold = options.json && !isFinite(message.globalViewMaxFeatureDistanceThreshold) ? String(message.globalViewMaxFeatureDistanceThreshold) : message.globalViewMaxFeatureDistanceThreshold;
                        if (message.maxSameCameraOverlapRatio != null && message.hasOwnProperty("maxSameCameraOverlapRatio"))
                            object.maxSameCameraOverlapRatio = options.json && !isFinite(message.maxSameCameraOverlapRatio) ? String(message.maxSameCameraOverlapRatio) : message.maxSameCameraOverlapRatio;
                        if (message.maxCrossCameraOverlapRatio != null && message.hasOwnProperty("maxCrossCameraOverlapRatio"))
                            object.maxCrossCameraOverlapRatio = options.json && !isFinite(message.maxCrossCameraOverlapRatio) ? String(message.maxCrossCameraOverlapRatio) : message.maxCrossCameraOverlapRatio;
                        if (message.genderCheckingFeatureDistanceThreshold != null && message.hasOwnProperty("genderCheckingFeatureDistanceThreshold"))
                            object.genderCheckingFeatureDistanceThreshold = options.json && !isFinite(message.genderCheckingFeatureDistanceThreshold) ? String(message.genderCheckingFeatureDistanceThreshold) : message.genderCheckingFeatureDistanceThreshold;
                        if (message.featureDistancePercentileWhenCompareWithGroup != null && message.hasOwnProperty("featureDistancePercentileWhenCompareWithGroup"))
                            object.featureDistancePercentileWhenCompareWithGroup = message.featureDistancePercentileWhenCompareWithGroup;
                        if (message.skipRefreshGroupCandidateEveryMerge != null && message.hasOwnProperty("skipRefreshGroupCandidateEveryMerge"))
                            object.skipRefreshGroupCandidateEveryMerge = message.skipRefreshGroupCandidateEveryMerge;
                        if (message.nearnessCheckMaxCameraDistanceInPixels != null && message.hasOwnProperty("nearnessCheckMaxCameraDistanceInPixels"))
                            object.nearnessCheckMaxCameraDistanceInPixels = message.nearnessCheckMaxCameraDistanceInPixels;
                        if (message.skipMergingByNearness != null && message.hasOwnProperty("skipMergingByNearness"))
                            object.skipMergingByNearness = message.skipMergingByNearness;
                        if (message.entranceMergingConfigInSupermarket != null && message.hasOwnProperty("entranceMergingConfigInSupermarket"))
                            object.entranceMergingConfigInSupermarket = $root.palexy.streaming.v1.EntranceMergingConfig.toObject(message.entranceMergingConfigInSupermarket, options);
                        if (message.queueTimeMergingConfigInSupermarket != null && message.hasOwnProperty("queueTimeMergingConfigInSupermarket"))
                            object.queueTimeMergingConfigInSupermarket = $root.palexy.streaming.v1.QueueTimeMergingConfig.toObject(message.queueTimeMergingConfigInSupermarket, options);
                        if (message.sectionMergingConfigInSupermarket != null && message.hasOwnProperty("sectionMergingConfigInSupermarket"))
                            object.sectionMergingConfigInSupermarket = $root.palexy.streaming.v1.SectionMergingConfig.toObject(message.sectionMergingConfigInSupermarket, options);
                        if (message.skipDetectingOutliers != null && message.hasOwnProperty("skipDetectingOutliers"))
                            object.skipDetectingOutliers = message.skipDetectingOutliers;
                        if (message.mergeVisitorsAtWaitingArea != null && message.hasOwnProperty("mergeVisitorsAtWaitingArea"))
                            object.mergeVisitorsAtWaitingArea = message.mergeVisitorsAtWaitingArea;
                        if (message.skipRemergeVeryCloseClustersByFeatureDistance != null && message.hasOwnProperty("skipRemergeVeryCloseClustersByFeatureDistance"))
                            object.skipRemergeVeryCloseClustersByFeatureDistance = message.skipRemergeVeryCloseClustersByFeatureDistance;
                        if (message.maxTimeDistanceForRemerge != null && message.hasOwnProperty("maxTimeDistanceForRemerge"))
                            object.maxTimeDistanceForRemerge = message.maxTimeDistanceForRemerge;
                        if (message.veryCloseFeatureDistanceThreshold != null && message.hasOwnProperty("veryCloseFeatureDistanceThreshold"))
                            object.veryCloseFeatureDistanceThreshold = options.json && !isFinite(message.veryCloseFeatureDistanceThreshold) ? String(message.veryCloseFeatureDistanceThreshold) : message.veryCloseFeatureDistanceThreshold;
                        if (message.crossCameraAdjustByDensityConfig != null && message.hasOwnProperty("crossCameraAdjustByDensityConfig"))
                            object.crossCameraAdjustByDensityConfig = $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.toObject(message.crossCameraAdjustByDensityConfig, options);
                        if (message.veryCloseThresAdjustByDensityConfig != null && message.hasOwnProperty("veryCloseThresAdjustByDensityConfig"))
                            object.veryCloseThresAdjustByDensityConfig = $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.toObject(message.veryCloseThresAdjustByDensityConfig, options);
                        if (message.disableDensityTrafficEstimator != null && message.hasOwnProperty("disableDensityTrafficEstimator"))
                            object.disableDensityTrafficEstimator = message.disableDensityTrafficEstimator;
                        if (message.wideSpaceEntranceConfig != null && message.hasOwnProperty("wideSpaceEntranceConfig"))
                            object.wideSpaceEntranceConfig = $root.palexy.streaming.v1.WideSpaceEntranceConfig.toObject(message.wideSpaceEntranceConfig, options);
                        if (message.veryVeryCloseFeatureDistanceForStaff != null && message.hasOwnProperty("veryVeryCloseFeatureDistanceForStaff"))
                            object.veryVeryCloseFeatureDistanceForStaff = options.json && !isFinite(message.veryVeryCloseFeatureDistanceForStaff) ? String(message.veryVeryCloseFeatureDistanceForStaff) : message.veryVeryCloseFeatureDistanceForStaff;
                        if (message.maxTimeDistanceForVeryVeryCloseForStaff != null && message.hasOwnProperty("maxTimeDistanceForVeryVeryCloseForStaff"))
                            object.maxTimeDistanceForVeryVeryCloseForStaff = message.maxTimeDistanceForVeryVeryCloseForStaff;
                        if (message.maxPeopleToStillUseNearness != null && message.hasOwnProperty("maxPeopleToStillUseNearness"))
                            object.maxPeopleToStillUseNearness = message.maxPeopleToStillUseNearness;
                        if (message.singleCameraAdjustByDensityConfig != null && message.hasOwnProperty("singleCameraAdjustByDensityConfig"))
                            object.singleCameraAdjustByDensityConfig = $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.toObject(message.singleCameraAdjustByDensityConfig, options);
                        if (message.globalViewThresAdjustByDensityConfig != null && message.hasOwnProperty("globalViewThresAdjustByDensityConfig"))
                            object.globalViewThresAdjustByDensityConfig = $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.toObject(message.globalViewThresAdjustByDensityConfig, options);
                        if (message.crossCameraDetectorConfig != null && message.hasOwnProperty("crossCameraDetectorConfig"))
                            object.crossCameraDetectorConfig = $root.palexy.streaming.v1.CrossCameraDetectorConfig.toObject(message.crossCameraDetectorConfig, options);
                        if (message.maxInternalFeatureDistanceThreshold != null && message.hasOwnProperty("maxInternalFeatureDistanceThreshold"))
                            object.maxInternalFeatureDistanceThreshold = options.json && !isFinite(message.maxInternalFeatureDistanceThreshold) ? String(message.maxInternalFeatureDistanceThreshold) : message.maxInternalFeatureDistanceThreshold;
                        if (message.maxFeatureThresholdAtRefinementAfterMxnMatching != null && message.hasOwnProperty("maxFeatureThresholdAtRefinementAfterMxnMatching"))
                            object.maxFeatureThresholdAtRefinementAfterMxnMatching = options.json && !isFinite(message.maxFeatureThresholdAtRefinementAfterMxnMatching) ? String(message.maxFeatureThresholdAtRefinementAfterMxnMatching) : message.maxFeatureThresholdAtRefinementAfterMxnMatching;
                        if (message.rerunSingleCameraTrackingConfig != null && message.hasOwnProperty("rerunSingleCameraTrackingConfig"))
                            object.rerunSingleCameraTrackingConfig = $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig.toObject(message.rerunSingleCameraTrackingConfig, options);
                        if (message.skipMainMerging != null && message.hasOwnProperty("skipMainMerging"))
                            object.skipMainMerging = message.skipMainMerging;
                        if (message.runMallMergingConfig != null && message.hasOwnProperty("runMallMergingConfig"))
                            object.runMallMergingConfig = $root.palexy.streaming.v1.RunMallMergingConfig.toObject(message.runMallMergingConfig, options);
                        if (message.skipRunRefine != null && message.hasOwnProperty("skipRunRefine"))
                            object.skipRunRefine = message.skipRunRefine;
                        if (message.minimalCameraCountingConfig != null && message.hasOwnProperty("minimalCameraCountingConfig"))
                            object.minimalCameraCountingConfig = $root.palexy.streaming.v1.MinimalCameraCountingConfig.toObject(message.minimalCameraCountingConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this MergingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergingConfig;
                })();
    
                v1.MinimalCameraCountingConfig = (function() {
    
                    /**
                     * Properties of a MinimalCameraCountingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IMinimalCameraCountingConfig
                     * @property {number|null} [walkingDistanceThreshold] MinimalCameraCountingConfig walkingDistanceThreshold
                     * @property {number|null} [goInAngleDegreeThreshold] MinimalCameraCountingConfig goInAngleDegreeThreshold
                     * @property {number|null} [goOutAngleDegreeThreshold] MinimalCameraCountingConfig goOutAngleDegreeThreshold
                     * @property {number|null} [consecutiveTrackletTimeThreshold] MinimalCameraCountingConfig consecutiveTrackletTimeThreshold
                     * @property {number|null} [remergeInAndOutFeatureDistanceThreshold] MinimalCameraCountingConfig remergeInAndOutFeatureDistanceThreshold
                     * @property {number|null} [remergeVeryCloseFeatureDistanceThreshold] MinimalCameraCountingConfig remergeVeryCloseFeatureDistanceThreshold
                     * @property {number|null} [remergeMaxTimeDistanceSeconds] MinimalCameraCountingConfig remergeMaxTimeDistanceSeconds
                     * @property {number|null} [remergeOverlapCameraFeatureDistanceThreshold] MinimalCameraCountingConfig remergeOverlapCameraFeatureDistanceThreshold
                     * @property {boolean|null} [skipEnsurePassingEntrance] MinimalCameraCountingConfig skipEnsurePassingEntrance
                     * @property {boolean|null} [allowAllToMergeNonAnchorPeople] MinimalCameraCountingConfig allowAllToMergeNonAnchorPeople
                     * @property {boolean|null} [removeGoOutImmediatelyPeople] MinimalCameraCountingConfig removeGoOutImmediatelyPeople
                     */
    
                    /**
                     * Constructs a new MinimalCameraCountingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MinimalCameraCountingConfig.
                     * @implements IMinimalCameraCountingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IMinimalCameraCountingConfig=} [properties] Properties to set
                     */
                    function MinimalCameraCountingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MinimalCameraCountingConfig walkingDistanceThreshold.
                     * @member {number} walkingDistanceThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.walkingDistanceThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig goInAngleDegreeThreshold.
                     * @member {number} goInAngleDegreeThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.goInAngleDegreeThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig goOutAngleDegreeThreshold.
                     * @member {number} goOutAngleDegreeThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.goOutAngleDegreeThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig consecutiveTrackletTimeThreshold.
                     * @member {number} consecutiveTrackletTimeThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.consecutiveTrackletTimeThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig remergeInAndOutFeatureDistanceThreshold.
                     * @member {number} remergeInAndOutFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.remergeInAndOutFeatureDistanceThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig remergeVeryCloseFeatureDistanceThreshold.
                     * @member {number} remergeVeryCloseFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.remergeVeryCloseFeatureDistanceThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig remergeMaxTimeDistanceSeconds.
                     * @member {number} remergeMaxTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.remergeMaxTimeDistanceSeconds = 0;
    
                    /**
                     * MinimalCameraCountingConfig remergeOverlapCameraFeatureDistanceThreshold.
                     * @member {number} remergeOverlapCameraFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.remergeOverlapCameraFeatureDistanceThreshold = 0;
    
                    /**
                     * MinimalCameraCountingConfig skipEnsurePassingEntrance.
                     * @member {boolean} skipEnsurePassingEntrance
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.skipEnsurePassingEntrance = false;
    
                    /**
                     * MinimalCameraCountingConfig allowAllToMergeNonAnchorPeople.
                     * @member {boolean} allowAllToMergeNonAnchorPeople
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.allowAllToMergeNonAnchorPeople = false;
    
                    /**
                     * MinimalCameraCountingConfig removeGoOutImmediatelyPeople.
                     * @member {boolean} removeGoOutImmediatelyPeople
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     */
                    MinimalCameraCountingConfig.prototype.removeGoOutImmediatelyPeople = false;
    
                    /**
                     * Creates a new MinimalCameraCountingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMinimalCameraCountingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MinimalCameraCountingConfig} MinimalCameraCountingConfig instance
                     */
                    MinimalCameraCountingConfig.create = function create(properties) {
                        return new MinimalCameraCountingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified MinimalCameraCountingConfig message. Does not implicitly {@link palexy.streaming.v1.MinimalCameraCountingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMinimalCameraCountingConfig} message MinimalCameraCountingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MinimalCameraCountingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.walkingDistanceThreshold != null && Object.hasOwnProperty.call(message, "walkingDistanceThreshold"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.walkingDistanceThreshold);
                        if (message.goInAngleDegreeThreshold != null && Object.hasOwnProperty.call(message, "goInAngleDegreeThreshold"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.goInAngleDegreeThreshold);
                        if (message.goOutAngleDegreeThreshold != null && Object.hasOwnProperty.call(message, "goOutAngleDegreeThreshold"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.goOutAngleDegreeThreshold);
                        if (message.consecutiveTrackletTimeThreshold != null && Object.hasOwnProperty.call(message, "consecutiveTrackletTimeThreshold"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.consecutiveTrackletTimeThreshold);
                        if (message.remergeInAndOutFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "remergeInAndOutFeatureDistanceThreshold"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.remergeInAndOutFeatureDistanceThreshold);
                        if (message.remergeVeryCloseFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "remergeVeryCloseFeatureDistanceThreshold"))
                            writer.uint32(/* id 6, wireType 5 =*/53).float(message.remergeVeryCloseFeatureDistanceThreshold);
                        if (message.remergeMaxTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "remergeMaxTimeDistanceSeconds"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.remergeMaxTimeDistanceSeconds);
                        if (message.remergeOverlapCameraFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "remergeOverlapCameraFeatureDistanceThreshold"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.remergeOverlapCameraFeatureDistanceThreshold);
                        if (message.skipEnsurePassingEntrance != null && Object.hasOwnProperty.call(message, "skipEnsurePassingEntrance"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.skipEnsurePassingEntrance);
                        if (message.allowAllToMergeNonAnchorPeople != null && Object.hasOwnProperty.call(message, "allowAllToMergeNonAnchorPeople"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.allowAllToMergeNonAnchorPeople);
                        if (message.removeGoOutImmediatelyPeople != null && Object.hasOwnProperty.call(message, "removeGoOutImmediatelyPeople"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.removeGoOutImmediatelyPeople);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MinimalCameraCountingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.MinimalCameraCountingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {palexy.streaming.v1.IMinimalCameraCountingConfig} message MinimalCameraCountingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MinimalCameraCountingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MinimalCameraCountingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MinimalCameraCountingConfig} MinimalCameraCountingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MinimalCameraCountingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MinimalCameraCountingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.walkingDistanceThreshold = reader.int32();
                                break;
                            case 2:
                                message.goInAngleDegreeThreshold = reader.int32();
                                break;
                            case 3:
                                message.goOutAngleDegreeThreshold = reader.int32();
                                break;
                            case 4:
                                message.consecutiveTrackletTimeThreshold = reader.int32();
                                break;
                            case 5:
                                message.remergeInAndOutFeatureDistanceThreshold = reader.float();
                                break;
                            case 6:
                                message.remergeVeryCloseFeatureDistanceThreshold = reader.float();
                                break;
                            case 7:
                                message.remergeMaxTimeDistanceSeconds = reader.int32();
                                break;
                            case 8:
                                message.remergeOverlapCameraFeatureDistanceThreshold = reader.int32();
                                break;
                            case 9:
                                message.skipEnsurePassingEntrance = reader.bool();
                                break;
                            case 10:
                                message.allowAllToMergeNonAnchorPeople = reader.bool();
                                break;
                            case 11:
                                message.removeGoOutImmediatelyPeople = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MinimalCameraCountingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MinimalCameraCountingConfig} MinimalCameraCountingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MinimalCameraCountingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MinimalCameraCountingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MinimalCameraCountingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.walkingDistanceThreshold != null && message.hasOwnProperty("walkingDistanceThreshold"))
                            if (!$util.isInteger(message.walkingDistanceThreshold))
                                return "walkingDistanceThreshold: integer expected";
                        if (message.goInAngleDegreeThreshold != null && message.hasOwnProperty("goInAngleDegreeThreshold"))
                            if (!$util.isInteger(message.goInAngleDegreeThreshold))
                                return "goInAngleDegreeThreshold: integer expected";
                        if (message.goOutAngleDegreeThreshold != null && message.hasOwnProperty("goOutAngleDegreeThreshold"))
                            if (!$util.isInteger(message.goOutAngleDegreeThreshold))
                                return "goOutAngleDegreeThreshold: integer expected";
                        if (message.consecutiveTrackletTimeThreshold != null && message.hasOwnProperty("consecutiveTrackletTimeThreshold"))
                            if (!$util.isInteger(message.consecutiveTrackletTimeThreshold))
                                return "consecutiveTrackletTimeThreshold: integer expected";
                        if (message.remergeInAndOutFeatureDistanceThreshold != null && message.hasOwnProperty("remergeInAndOutFeatureDistanceThreshold"))
                            if (typeof message.remergeInAndOutFeatureDistanceThreshold !== "number")
                                return "remergeInAndOutFeatureDistanceThreshold: number expected";
                        if (message.remergeVeryCloseFeatureDistanceThreshold != null && message.hasOwnProperty("remergeVeryCloseFeatureDistanceThreshold"))
                            if (typeof message.remergeVeryCloseFeatureDistanceThreshold !== "number")
                                return "remergeVeryCloseFeatureDistanceThreshold: number expected";
                        if (message.remergeMaxTimeDistanceSeconds != null && message.hasOwnProperty("remergeMaxTimeDistanceSeconds"))
                            if (!$util.isInteger(message.remergeMaxTimeDistanceSeconds))
                                return "remergeMaxTimeDistanceSeconds: integer expected";
                        if (message.remergeOverlapCameraFeatureDistanceThreshold != null && message.hasOwnProperty("remergeOverlapCameraFeatureDistanceThreshold"))
                            if (!$util.isInteger(message.remergeOverlapCameraFeatureDistanceThreshold))
                                return "remergeOverlapCameraFeatureDistanceThreshold: integer expected";
                        if (message.skipEnsurePassingEntrance != null && message.hasOwnProperty("skipEnsurePassingEntrance"))
                            if (typeof message.skipEnsurePassingEntrance !== "boolean")
                                return "skipEnsurePassingEntrance: boolean expected";
                        if (message.allowAllToMergeNonAnchorPeople != null && message.hasOwnProperty("allowAllToMergeNonAnchorPeople"))
                            if (typeof message.allowAllToMergeNonAnchorPeople !== "boolean")
                                return "allowAllToMergeNonAnchorPeople: boolean expected";
                        if (message.removeGoOutImmediatelyPeople != null && message.hasOwnProperty("removeGoOutImmediatelyPeople"))
                            if (typeof message.removeGoOutImmediatelyPeople !== "boolean")
                                return "removeGoOutImmediatelyPeople: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a MinimalCameraCountingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MinimalCameraCountingConfig} MinimalCameraCountingConfig
                     */
                    MinimalCameraCountingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MinimalCameraCountingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.MinimalCameraCountingConfig();
                        if (object.walkingDistanceThreshold != null)
                            message.walkingDistanceThreshold = object.walkingDistanceThreshold | 0;
                        if (object.goInAngleDegreeThreshold != null)
                            message.goInAngleDegreeThreshold = object.goInAngleDegreeThreshold | 0;
                        if (object.goOutAngleDegreeThreshold != null)
                            message.goOutAngleDegreeThreshold = object.goOutAngleDegreeThreshold | 0;
                        if (object.consecutiveTrackletTimeThreshold != null)
                            message.consecutiveTrackletTimeThreshold = object.consecutiveTrackletTimeThreshold | 0;
                        if (object.remergeInAndOutFeatureDistanceThreshold != null)
                            message.remergeInAndOutFeatureDistanceThreshold = Number(object.remergeInAndOutFeatureDistanceThreshold);
                        if (object.remergeVeryCloseFeatureDistanceThreshold != null)
                            message.remergeVeryCloseFeatureDistanceThreshold = Number(object.remergeVeryCloseFeatureDistanceThreshold);
                        if (object.remergeMaxTimeDistanceSeconds != null)
                            message.remergeMaxTimeDistanceSeconds = object.remergeMaxTimeDistanceSeconds | 0;
                        if (object.remergeOverlapCameraFeatureDistanceThreshold != null)
                            message.remergeOverlapCameraFeatureDistanceThreshold = object.remergeOverlapCameraFeatureDistanceThreshold | 0;
                        if (object.skipEnsurePassingEntrance != null)
                            message.skipEnsurePassingEntrance = Boolean(object.skipEnsurePassingEntrance);
                        if (object.allowAllToMergeNonAnchorPeople != null)
                            message.allowAllToMergeNonAnchorPeople = Boolean(object.allowAllToMergeNonAnchorPeople);
                        if (object.removeGoOutImmediatelyPeople != null)
                            message.removeGoOutImmediatelyPeople = Boolean(object.removeGoOutImmediatelyPeople);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MinimalCameraCountingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @static
                     * @param {palexy.streaming.v1.MinimalCameraCountingConfig} message MinimalCameraCountingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MinimalCameraCountingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.walkingDistanceThreshold = 0;
                            object.goInAngleDegreeThreshold = 0;
                            object.goOutAngleDegreeThreshold = 0;
                            object.consecutiveTrackletTimeThreshold = 0;
                            object.remergeInAndOutFeatureDistanceThreshold = 0;
                            object.remergeVeryCloseFeatureDistanceThreshold = 0;
                            object.remergeMaxTimeDistanceSeconds = 0;
                            object.remergeOverlapCameraFeatureDistanceThreshold = 0;
                            object.skipEnsurePassingEntrance = false;
                            object.allowAllToMergeNonAnchorPeople = false;
                            object.removeGoOutImmediatelyPeople = false;
                        }
                        if (message.walkingDistanceThreshold != null && message.hasOwnProperty("walkingDistanceThreshold"))
                            object.walkingDistanceThreshold = message.walkingDistanceThreshold;
                        if (message.goInAngleDegreeThreshold != null && message.hasOwnProperty("goInAngleDegreeThreshold"))
                            object.goInAngleDegreeThreshold = message.goInAngleDegreeThreshold;
                        if (message.goOutAngleDegreeThreshold != null && message.hasOwnProperty("goOutAngleDegreeThreshold"))
                            object.goOutAngleDegreeThreshold = message.goOutAngleDegreeThreshold;
                        if (message.consecutiveTrackletTimeThreshold != null && message.hasOwnProperty("consecutiveTrackletTimeThreshold"))
                            object.consecutiveTrackletTimeThreshold = message.consecutiveTrackletTimeThreshold;
                        if (message.remergeInAndOutFeatureDistanceThreshold != null && message.hasOwnProperty("remergeInAndOutFeatureDistanceThreshold"))
                            object.remergeInAndOutFeatureDistanceThreshold = options.json && !isFinite(message.remergeInAndOutFeatureDistanceThreshold) ? String(message.remergeInAndOutFeatureDistanceThreshold) : message.remergeInAndOutFeatureDistanceThreshold;
                        if (message.remergeVeryCloseFeatureDistanceThreshold != null && message.hasOwnProperty("remergeVeryCloseFeatureDistanceThreshold"))
                            object.remergeVeryCloseFeatureDistanceThreshold = options.json && !isFinite(message.remergeVeryCloseFeatureDistanceThreshold) ? String(message.remergeVeryCloseFeatureDistanceThreshold) : message.remergeVeryCloseFeatureDistanceThreshold;
                        if (message.remergeMaxTimeDistanceSeconds != null && message.hasOwnProperty("remergeMaxTimeDistanceSeconds"))
                            object.remergeMaxTimeDistanceSeconds = message.remergeMaxTimeDistanceSeconds;
                        if (message.remergeOverlapCameraFeatureDistanceThreshold != null && message.hasOwnProperty("remergeOverlapCameraFeatureDistanceThreshold"))
                            object.remergeOverlapCameraFeatureDistanceThreshold = message.remergeOverlapCameraFeatureDistanceThreshold;
                        if (message.skipEnsurePassingEntrance != null && message.hasOwnProperty("skipEnsurePassingEntrance"))
                            object.skipEnsurePassingEntrance = message.skipEnsurePassingEntrance;
                        if (message.allowAllToMergeNonAnchorPeople != null && message.hasOwnProperty("allowAllToMergeNonAnchorPeople"))
                            object.allowAllToMergeNonAnchorPeople = message.allowAllToMergeNonAnchorPeople;
                        if (message.removeGoOutImmediatelyPeople != null && message.hasOwnProperty("removeGoOutImmediatelyPeople"))
                            object.removeGoOutImmediatelyPeople = message.removeGoOutImmediatelyPeople;
                        return object;
                    };
    
                    /**
                     * Converts this MinimalCameraCountingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MinimalCameraCountingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MinimalCameraCountingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MinimalCameraCountingConfig;
                })();
    
                v1.RerunSingleCameraTrackingConfig = (function() {
    
                    /**
                     * Properties of a RerunSingleCameraTrackingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IRerunSingleCameraTrackingConfig
                     * @property {boolean|null} [skipRerunning] RerunSingleCameraTrackingConfig skipRerunning
                     * @property {number|null} [reidThreshold] RerunSingleCameraTrackingConfig reidThreshold
                     * @property {number|null} [maxTimeDistance] RerunSingleCameraTrackingConfig maxTimeDistance
                     * @property {number|null} [minNearIou] RerunSingleCameraTrackingConfig minNearIou
                     */
    
                    /**
                     * Constructs a new RerunSingleCameraTrackingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RerunSingleCameraTrackingConfig.
                     * @implements IRerunSingleCameraTrackingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IRerunSingleCameraTrackingConfig=} [properties] Properties to set
                     */
                    function RerunSingleCameraTrackingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RerunSingleCameraTrackingConfig skipRerunning.
                     * @member {boolean} skipRerunning
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @instance
                     */
                    RerunSingleCameraTrackingConfig.prototype.skipRerunning = false;
    
                    /**
                     * RerunSingleCameraTrackingConfig reidThreshold.
                     * @member {number} reidThreshold
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @instance
                     */
                    RerunSingleCameraTrackingConfig.prototype.reidThreshold = 0;
    
                    /**
                     * RerunSingleCameraTrackingConfig maxTimeDistance.
                     * @member {number} maxTimeDistance
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @instance
                     */
                    RerunSingleCameraTrackingConfig.prototype.maxTimeDistance = 0;
    
                    /**
                     * RerunSingleCameraTrackingConfig minNearIou.
                     * @member {number} minNearIou
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @instance
                     */
                    RerunSingleCameraTrackingConfig.prototype.minNearIou = 0;
    
                    /**
                     * Creates a new RerunSingleCameraTrackingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRerunSingleCameraTrackingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RerunSingleCameraTrackingConfig} RerunSingleCameraTrackingConfig instance
                     */
                    RerunSingleCameraTrackingConfig.create = function create(properties) {
                        return new RerunSingleCameraTrackingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified RerunSingleCameraTrackingConfig message. Does not implicitly {@link palexy.streaming.v1.RerunSingleCameraTrackingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRerunSingleCameraTrackingConfig} message RerunSingleCameraTrackingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunSingleCameraTrackingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.skipRerunning != null && Object.hasOwnProperty.call(message, "skipRerunning"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.skipRerunning);
                        if (message.reidThreshold != null && Object.hasOwnProperty.call(message, "reidThreshold"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.reidThreshold);
                        if (message.maxTimeDistance != null && Object.hasOwnProperty.call(message, "maxTimeDistance"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxTimeDistance);
                        if (message.minNearIou != null && Object.hasOwnProperty.call(message, "minNearIou"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.minNearIou);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RerunSingleCameraTrackingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.RerunSingleCameraTrackingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRerunSingleCameraTrackingConfig} message RerunSingleCameraTrackingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RerunSingleCameraTrackingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RerunSingleCameraTrackingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RerunSingleCameraTrackingConfig} RerunSingleCameraTrackingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunSingleCameraTrackingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.skipRerunning = reader.bool();
                                break;
                            case 2:
                                message.reidThreshold = reader.float();
                                break;
                            case 3:
                                message.maxTimeDistance = reader.int32();
                                break;
                            case 4:
                                message.minNearIou = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RerunSingleCameraTrackingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RerunSingleCameraTrackingConfig} RerunSingleCameraTrackingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RerunSingleCameraTrackingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RerunSingleCameraTrackingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RerunSingleCameraTrackingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.skipRerunning != null && message.hasOwnProperty("skipRerunning"))
                            if (typeof message.skipRerunning !== "boolean")
                                return "skipRerunning: boolean expected";
                        if (message.reidThreshold != null && message.hasOwnProperty("reidThreshold"))
                            if (typeof message.reidThreshold !== "number")
                                return "reidThreshold: number expected";
                        if (message.maxTimeDistance != null && message.hasOwnProperty("maxTimeDistance"))
                            if (!$util.isInteger(message.maxTimeDistance))
                                return "maxTimeDistance: integer expected";
                        if (message.minNearIou != null && message.hasOwnProperty("minNearIou"))
                            if (typeof message.minNearIou !== "number")
                                return "minNearIou: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a RerunSingleCameraTrackingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RerunSingleCameraTrackingConfig} RerunSingleCameraTrackingConfig
                     */
                    RerunSingleCameraTrackingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.RerunSingleCameraTrackingConfig();
                        if (object.skipRerunning != null)
                            message.skipRerunning = Boolean(object.skipRerunning);
                        if (object.reidThreshold != null)
                            message.reidThreshold = Number(object.reidThreshold);
                        if (object.maxTimeDistance != null)
                            message.maxTimeDistance = object.maxTimeDistance | 0;
                        if (object.minNearIou != null)
                            message.minNearIou = Number(object.minNearIou);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RerunSingleCameraTrackingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @static
                     * @param {palexy.streaming.v1.RerunSingleCameraTrackingConfig} message RerunSingleCameraTrackingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RerunSingleCameraTrackingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.skipRerunning = false;
                            object.reidThreshold = 0;
                            object.maxTimeDistance = 0;
                            object.minNearIou = 0;
                        }
                        if (message.skipRerunning != null && message.hasOwnProperty("skipRerunning"))
                            object.skipRerunning = message.skipRerunning;
                        if (message.reidThreshold != null && message.hasOwnProperty("reidThreshold"))
                            object.reidThreshold = options.json && !isFinite(message.reidThreshold) ? String(message.reidThreshold) : message.reidThreshold;
                        if (message.maxTimeDistance != null && message.hasOwnProperty("maxTimeDistance"))
                            object.maxTimeDistance = message.maxTimeDistance;
                        if (message.minNearIou != null && message.hasOwnProperty("minNearIou"))
                            object.minNearIou = options.json && !isFinite(message.minNearIou) ? String(message.minNearIou) : message.minNearIou;
                        return object;
                    };
    
                    /**
                     * Converts this RerunSingleCameraTrackingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RerunSingleCameraTrackingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RerunSingleCameraTrackingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RerunSingleCameraTrackingConfig;
                })();
    
                v1.CrossCameraDetectorConfig = (function() {
    
                    /**
                     * Properties of a CrossCameraDetectorConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ICrossCameraDetectorConfig
                     * @property {number|null} [crossCameraThres] CrossCameraDetectorConfig crossCameraThres
                     * @property {number|null} [groupDuration] CrossCameraDetectorConfig groupDuration
                     * @property {number|null} [maxDensity] CrossCameraDetectorConfig maxDensity
                     * @property {number|null} [minValidSlotsToNotOverlapping] CrossCameraDetectorConfig minValidSlotsToNotOverlapping
                     * @property {number|null} [veryCloseThres] CrossCameraDetectorConfig veryCloseThres
                     * @property {boolean|null} [useClusterForOverlappingDetector] CrossCameraDetectorConfig useClusterForOverlappingDetector
                     */
    
                    /**
                     * Constructs a new CrossCameraDetectorConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CrossCameraDetectorConfig.
                     * @implements ICrossCameraDetectorConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ICrossCameraDetectorConfig=} [properties] Properties to set
                     */
                    function CrossCameraDetectorConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrossCameraDetectorConfig crossCameraThres.
                     * @member {number} crossCameraThres
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.crossCameraThres = 0;
    
                    /**
                     * CrossCameraDetectorConfig groupDuration.
                     * @member {number} groupDuration
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.groupDuration = 0;
    
                    /**
                     * CrossCameraDetectorConfig maxDensity.
                     * @member {number} maxDensity
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.maxDensity = 0;
    
                    /**
                     * CrossCameraDetectorConfig minValidSlotsToNotOverlapping.
                     * @member {number} minValidSlotsToNotOverlapping
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.minValidSlotsToNotOverlapping = 0;
    
                    /**
                     * CrossCameraDetectorConfig veryCloseThres.
                     * @member {number} veryCloseThres
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.veryCloseThres = 0;
    
                    /**
                     * CrossCameraDetectorConfig useClusterForOverlappingDetector.
                     * @member {boolean} useClusterForOverlappingDetector
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     */
                    CrossCameraDetectorConfig.prototype.useClusterForOverlappingDetector = false;
    
                    /**
                     * Creates a new CrossCameraDetectorConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraDetectorConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CrossCameraDetectorConfig} CrossCameraDetectorConfig instance
                     */
                    CrossCameraDetectorConfig.create = function create(properties) {
                        return new CrossCameraDetectorConfig(properties);
                    };
    
                    /**
                     * Encodes the specified CrossCameraDetectorConfig message. Does not implicitly {@link palexy.streaming.v1.CrossCameraDetectorConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraDetectorConfig} message CrossCameraDetectorConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrossCameraDetectorConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.crossCameraThres != null && Object.hasOwnProperty.call(message, "crossCameraThres"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.crossCameraThres);
                        if (message.groupDuration != null && Object.hasOwnProperty.call(message, "groupDuration"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.groupDuration);
                        if (message.maxDensity != null && Object.hasOwnProperty.call(message, "maxDensity"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxDensity);
                        if (message.minValidSlotsToNotOverlapping != null && Object.hasOwnProperty.call(message, "minValidSlotsToNotOverlapping"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minValidSlotsToNotOverlapping);
                        if (message.veryCloseThres != null && Object.hasOwnProperty.call(message, "veryCloseThres"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.veryCloseThres);
                        if (message.useClusterForOverlappingDetector != null && Object.hasOwnProperty.call(message, "useClusterForOverlappingDetector"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.useClusterForOverlappingDetector);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrossCameraDetectorConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.CrossCameraDetectorConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraDetectorConfig} message CrossCameraDetectorConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrossCameraDetectorConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrossCameraDetectorConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CrossCameraDetectorConfig} CrossCameraDetectorConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrossCameraDetectorConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CrossCameraDetectorConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.crossCameraThres = reader.float();
                                break;
                            case 2:
                                message.groupDuration = reader.int32();
                                break;
                            case 3:
                                message.maxDensity = reader.int32();
                                break;
                            case 4:
                                message.minValidSlotsToNotOverlapping = reader.int32();
                                break;
                            case 5:
                                message.veryCloseThres = reader.float();
                                break;
                            case 6:
                                message.useClusterForOverlappingDetector = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrossCameraDetectorConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CrossCameraDetectorConfig} CrossCameraDetectorConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrossCameraDetectorConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrossCameraDetectorConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrossCameraDetectorConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.crossCameraThres != null && message.hasOwnProperty("crossCameraThres"))
                            if (typeof message.crossCameraThres !== "number")
                                return "crossCameraThres: number expected";
                        if (message.groupDuration != null && message.hasOwnProperty("groupDuration"))
                            if (!$util.isInteger(message.groupDuration))
                                return "groupDuration: integer expected";
                        if (message.maxDensity != null && message.hasOwnProperty("maxDensity"))
                            if (!$util.isInteger(message.maxDensity))
                                return "maxDensity: integer expected";
                        if (message.minValidSlotsToNotOverlapping != null && message.hasOwnProperty("minValidSlotsToNotOverlapping"))
                            if (!$util.isInteger(message.minValidSlotsToNotOverlapping))
                                return "minValidSlotsToNotOverlapping: integer expected";
                        if (message.veryCloseThres != null && message.hasOwnProperty("veryCloseThres"))
                            if (typeof message.veryCloseThres !== "number")
                                return "veryCloseThres: number expected";
                        if (message.useClusterForOverlappingDetector != null && message.hasOwnProperty("useClusterForOverlappingDetector"))
                            if (typeof message.useClusterForOverlappingDetector !== "boolean")
                                return "useClusterForOverlappingDetector: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrossCameraDetectorConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CrossCameraDetectorConfig} CrossCameraDetectorConfig
                     */
                    CrossCameraDetectorConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CrossCameraDetectorConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.CrossCameraDetectorConfig();
                        if (object.crossCameraThres != null)
                            message.crossCameraThres = Number(object.crossCameraThres);
                        if (object.groupDuration != null)
                            message.groupDuration = object.groupDuration | 0;
                        if (object.maxDensity != null)
                            message.maxDensity = object.maxDensity | 0;
                        if (object.minValidSlotsToNotOverlapping != null)
                            message.minValidSlotsToNotOverlapping = object.minValidSlotsToNotOverlapping | 0;
                        if (object.veryCloseThres != null)
                            message.veryCloseThres = Number(object.veryCloseThres);
                        if (object.useClusterForOverlappingDetector != null)
                            message.useClusterForOverlappingDetector = Boolean(object.useClusterForOverlappingDetector);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrossCameraDetectorConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @static
                     * @param {palexy.streaming.v1.CrossCameraDetectorConfig} message CrossCameraDetectorConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrossCameraDetectorConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.crossCameraThres = 0;
                            object.groupDuration = 0;
                            object.maxDensity = 0;
                            object.minValidSlotsToNotOverlapping = 0;
                            object.veryCloseThres = 0;
                            object.useClusterForOverlappingDetector = false;
                        }
                        if (message.crossCameraThres != null && message.hasOwnProperty("crossCameraThres"))
                            object.crossCameraThres = options.json && !isFinite(message.crossCameraThres) ? String(message.crossCameraThres) : message.crossCameraThres;
                        if (message.groupDuration != null && message.hasOwnProperty("groupDuration"))
                            object.groupDuration = message.groupDuration;
                        if (message.maxDensity != null && message.hasOwnProperty("maxDensity"))
                            object.maxDensity = message.maxDensity;
                        if (message.minValidSlotsToNotOverlapping != null && message.hasOwnProperty("minValidSlotsToNotOverlapping"))
                            object.minValidSlotsToNotOverlapping = message.minValidSlotsToNotOverlapping;
                        if (message.veryCloseThres != null && message.hasOwnProperty("veryCloseThres"))
                            object.veryCloseThres = options.json && !isFinite(message.veryCloseThres) ? String(message.veryCloseThres) : message.veryCloseThres;
                        if (message.useClusterForOverlappingDetector != null && message.hasOwnProperty("useClusterForOverlappingDetector"))
                            object.useClusterForOverlappingDetector = message.useClusterForOverlappingDetector;
                        return object;
                    };
    
                    /**
                     * Converts this CrossCameraDetectorConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CrossCameraDetectorConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrossCameraDetectorConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrossCameraDetectorConfig;
                })();
    
                v1.StaticObjectFilteringConfig = (function() {
    
                    /**
                     * Properties of a StaticObjectFilteringConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IStaticObjectFilteringConfig
                     * @property {number|null} [minItems] StaticObjectFilteringConfig minItems
                     * @property {number|null} [minBbIou] StaticObjectFilteringConfig minBbIou
                     * @property {number|null} [maxFeatureDistance] StaticObjectFilteringConfig maxFeatureDistance
                     * @property {number|null} [staticObjectWindowSize] StaticObjectFilteringConfig staticObjectWindowSize
                     * @property {number|null} [maxStaticObjectsPerCam] StaticObjectFilteringConfig maxStaticObjectsPerCam
                     * @property {number|null} [minDurationInStoreInSecond] StaticObjectFilteringConfig minDurationInStoreInSecond
                     * @property {number|null} [minPeakItems] StaticObjectFilteringConfig minPeakItems
                     */
    
                    /**
                     * Constructs a new StaticObjectFilteringConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaticObjectFilteringConfig.
                     * @implements IStaticObjectFilteringConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IStaticObjectFilteringConfig=} [properties] Properties to set
                     */
                    function StaticObjectFilteringConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaticObjectFilteringConfig minItems.
                     * @member {number} minItems
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.minItems = 0;
    
                    /**
                     * StaticObjectFilteringConfig minBbIou.
                     * @member {number} minBbIou
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.minBbIou = 0;
    
                    /**
                     * StaticObjectFilteringConfig maxFeatureDistance.
                     * @member {number} maxFeatureDistance
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.maxFeatureDistance = 0;
    
                    /**
                     * StaticObjectFilteringConfig staticObjectWindowSize.
                     * @member {number} staticObjectWindowSize
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.staticObjectWindowSize = 0;
    
                    /**
                     * StaticObjectFilteringConfig maxStaticObjectsPerCam.
                     * @member {number} maxStaticObjectsPerCam
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.maxStaticObjectsPerCam = 0;
    
                    /**
                     * StaticObjectFilteringConfig minDurationInStoreInSecond.
                     * @member {number} minDurationInStoreInSecond
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.minDurationInStoreInSecond = 0;
    
                    /**
                     * StaticObjectFilteringConfig minPeakItems.
                     * @member {number} minPeakItems
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     */
                    StaticObjectFilteringConfig.prototype.minPeakItems = 0;
    
                    /**
                     * Creates a new StaticObjectFilteringConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaticObjectFilteringConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaticObjectFilteringConfig} StaticObjectFilteringConfig instance
                     */
                    StaticObjectFilteringConfig.create = function create(properties) {
                        return new StaticObjectFilteringConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StaticObjectFilteringConfig message. Does not implicitly {@link palexy.streaming.v1.StaticObjectFilteringConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaticObjectFilteringConfig} message StaticObjectFilteringConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaticObjectFilteringConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minItems != null && Object.hasOwnProperty.call(message, "minItems"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minItems);
                        if (message.minBbIou != null && Object.hasOwnProperty.call(message, "minBbIou"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.minBbIou);
                        if (message.maxFeatureDistance != null && Object.hasOwnProperty.call(message, "maxFeatureDistance"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.maxFeatureDistance);
                        if (message.staticObjectWindowSize != null && Object.hasOwnProperty.call(message, "staticObjectWindowSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.staticObjectWindowSize);
                        if (message.maxStaticObjectsPerCam != null && Object.hasOwnProperty.call(message, "maxStaticObjectsPerCam"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.maxStaticObjectsPerCam);
                        if (message.minDurationInStoreInSecond != null && Object.hasOwnProperty.call(message, "minDurationInStoreInSecond"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.minDurationInStoreInSecond);
                        if (message.minPeakItems != null && Object.hasOwnProperty.call(message, "minPeakItems"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.minPeakItems);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaticObjectFilteringConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaticObjectFilteringConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaticObjectFilteringConfig} message StaticObjectFilteringConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaticObjectFilteringConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaticObjectFilteringConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaticObjectFilteringConfig} StaticObjectFilteringConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaticObjectFilteringConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaticObjectFilteringConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minItems = reader.int32();
                                break;
                            case 2:
                                message.minBbIou = reader.float();
                                break;
                            case 3:
                                message.maxFeatureDistance = reader.float();
                                break;
                            case 4:
                                message.staticObjectWindowSize = reader.int32();
                                break;
                            case 5:
                                message.maxStaticObjectsPerCam = reader.int32();
                                break;
                            case 6:
                                message.minDurationInStoreInSecond = reader.int32();
                                break;
                            case 7:
                                message.minPeakItems = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaticObjectFilteringConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaticObjectFilteringConfig} StaticObjectFilteringConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaticObjectFilteringConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaticObjectFilteringConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaticObjectFilteringConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minItems != null && message.hasOwnProperty("minItems"))
                            if (!$util.isInteger(message.minItems))
                                return "minItems: integer expected";
                        if (message.minBbIou != null && message.hasOwnProperty("minBbIou"))
                            if (typeof message.minBbIou !== "number")
                                return "minBbIou: number expected";
                        if (message.maxFeatureDistance != null && message.hasOwnProperty("maxFeatureDistance"))
                            if (typeof message.maxFeatureDistance !== "number")
                                return "maxFeatureDistance: number expected";
                        if (message.staticObjectWindowSize != null && message.hasOwnProperty("staticObjectWindowSize"))
                            if (!$util.isInteger(message.staticObjectWindowSize))
                                return "staticObjectWindowSize: integer expected";
                        if (message.maxStaticObjectsPerCam != null && message.hasOwnProperty("maxStaticObjectsPerCam"))
                            if (!$util.isInteger(message.maxStaticObjectsPerCam))
                                return "maxStaticObjectsPerCam: integer expected";
                        if (message.minDurationInStoreInSecond != null && message.hasOwnProperty("minDurationInStoreInSecond"))
                            if (!$util.isInteger(message.minDurationInStoreInSecond))
                                return "minDurationInStoreInSecond: integer expected";
                        if (message.minPeakItems != null && message.hasOwnProperty("minPeakItems"))
                            if (!$util.isInteger(message.minPeakItems))
                                return "minPeakItems: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaticObjectFilteringConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaticObjectFilteringConfig} StaticObjectFilteringConfig
                     */
                    StaticObjectFilteringConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaticObjectFilteringConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaticObjectFilteringConfig();
                        if (object.minItems != null)
                            message.minItems = object.minItems | 0;
                        if (object.minBbIou != null)
                            message.minBbIou = Number(object.minBbIou);
                        if (object.maxFeatureDistance != null)
                            message.maxFeatureDistance = Number(object.maxFeatureDistance);
                        if (object.staticObjectWindowSize != null)
                            message.staticObjectWindowSize = object.staticObjectWindowSize | 0;
                        if (object.maxStaticObjectsPerCam != null)
                            message.maxStaticObjectsPerCam = object.maxStaticObjectsPerCam | 0;
                        if (object.minDurationInStoreInSecond != null)
                            message.minDurationInStoreInSecond = object.minDurationInStoreInSecond | 0;
                        if (object.minPeakItems != null)
                            message.minPeakItems = object.minPeakItems | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaticObjectFilteringConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.StaticObjectFilteringConfig} message StaticObjectFilteringConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaticObjectFilteringConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minItems = 0;
                            object.minBbIou = 0;
                            object.maxFeatureDistance = 0;
                            object.staticObjectWindowSize = 0;
                            object.maxStaticObjectsPerCam = 0;
                            object.minDurationInStoreInSecond = 0;
                            object.minPeakItems = 0;
                        }
                        if (message.minItems != null && message.hasOwnProperty("minItems"))
                            object.minItems = message.minItems;
                        if (message.minBbIou != null && message.hasOwnProperty("minBbIou"))
                            object.minBbIou = options.json && !isFinite(message.minBbIou) ? String(message.minBbIou) : message.minBbIou;
                        if (message.maxFeatureDistance != null && message.hasOwnProperty("maxFeatureDistance"))
                            object.maxFeatureDistance = options.json && !isFinite(message.maxFeatureDistance) ? String(message.maxFeatureDistance) : message.maxFeatureDistance;
                        if (message.staticObjectWindowSize != null && message.hasOwnProperty("staticObjectWindowSize"))
                            object.staticObjectWindowSize = message.staticObjectWindowSize;
                        if (message.maxStaticObjectsPerCam != null && message.hasOwnProperty("maxStaticObjectsPerCam"))
                            object.maxStaticObjectsPerCam = message.maxStaticObjectsPerCam;
                        if (message.minDurationInStoreInSecond != null && message.hasOwnProperty("minDurationInStoreInSecond"))
                            object.minDurationInStoreInSecond = message.minDurationInStoreInSecond;
                        if (message.minPeakItems != null && message.hasOwnProperty("minPeakItems"))
                            object.minPeakItems = message.minPeakItems;
                        return object;
                    };
    
                    /**
                     * Converts this StaticObjectFilteringConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaticObjectFilteringConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaticObjectFilteringConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaticObjectFilteringConfig;
                })();
    
                v1.GlobalViewThresAdjustByDensityConfig = (function() {
    
                    /**
                     * Properties of a GlobalViewThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IGlobalViewThresAdjustByDensityConfig
                     * @property {number|null} [minNumPeopleToDecrease] GlobalViewThresAdjustByDensityConfig minNumPeopleToDecrease
                     * @property {number|null} [maxNumPeopleToStopDecrease] GlobalViewThresAdjustByDensityConfig maxNumPeopleToStopDecrease
                     * @property {number|null} [minimumTimeDistance] GlobalViewThresAdjustByDensityConfig minimumTimeDistance
                     * @property {number|null} [minimumFeatureThreshold] GlobalViewThresAdjustByDensityConfig minimumFeatureThreshold
                     */
    
                    /**
                     * Constructs a new GlobalViewThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GlobalViewThresAdjustByDensityConfig.
                     * @implements IGlobalViewThresAdjustByDensityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig=} [properties] Properties to set
                     */
                    function GlobalViewThresAdjustByDensityConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GlobalViewThresAdjustByDensityConfig minNumPeopleToDecrease.
                     * @member {number} minNumPeopleToDecrease
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @instance
                     */
                    GlobalViewThresAdjustByDensityConfig.prototype.minNumPeopleToDecrease = 0;
    
                    /**
                     * GlobalViewThresAdjustByDensityConfig maxNumPeopleToStopDecrease.
                     * @member {number} maxNumPeopleToStopDecrease
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @instance
                     */
                    GlobalViewThresAdjustByDensityConfig.prototype.maxNumPeopleToStopDecrease = 0;
    
                    /**
                     * GlobalViewThresAdjustByDensityConfig minimumTimeDistance.
                     * @member {number} minimumTimeDistance
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @instance
                     */
                    GlobalViewThresAdjustByDensityConfig.prototype.minimumTimeDistance = 0;
    
                    /**
                     * GlobalViewThresAdjustByDensityConfig minimumFeatureThreshold.
                     * @member {number} minimumFeatureThreshold
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @instance
                     */
                    GlobalViewThresAdjustByDensityConfig.prototype.minimumFeatureThreshold = 0;
    
                    /**
                     * Creates a new GlobalViewThresAdjustByDensityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig} GlobalViewThresAdjustByDensityConfig instance
                     */
                    GlobalViewThresAdjustByDensityConfig.create = function create(properties) {
                        return new GlobalViewThresAdjustByDensityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified GlobalViewThresAdjustByDensityConfig message. Does not implicitly {@link palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig} message GlobalViewThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GlobalViewThresAdjustByDensityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minNumPeopleToDecrease != null && Object.hasOwnProperty.call(message, "minNumPeopleToDecrease"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minNumPeopleToDecrease);
                        if (message.maxNumPeopleToStopDecrease != null && Object.hasOwnProperty.call(message, "maxNumPeopleToStopDecrease"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumPeopleToStopDecrease);
                        if (message.minimumTimeDistance != null && Object.hasOwnProperty.call(message, "minimumTimeDistance"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.minimumTimeDistance);
                        if (message.minimumFeatureThreshold != null && Object.hasOwnProperty.call(message, "minimumFeatureThreshold"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.minimumFeatureThreshold);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GlobalViewThresAdjustByDensityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IGlobalViewThresAdjustByDensityConfig} message GlobalViewThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GlobalViewThresAdjustByDensityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GlobalViewThresAdjustByDensityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig} GlobalViewThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GlobalViewThresAdjustByDensityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minNumPeopleToDecrease = reader.int32();
                                break;
                            case 2:
                                message.maxNumPeopleToStopDecrease = reader.int32();
                                break;
                            case 3:
                                message.minimumTimeDistance = reader.float();
                                break;
                            case 4:
                                message.minimumFeatureThreshold = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GlobalViewThresAdjustByDensityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig} GlobalViewThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GlobalViewThresAdjustByDensityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GlobalViewThresAdjustByDensityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GlobalViewThresAdjustByDensityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            if (!$util.isInteger(message.minNumPeopleToDecrease))
                                return "minNumPeopleToDecrease: integer expected";
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            if (!$util.isInteger(message.maxNumPeopleToStopDecrease))
                                return "maxNumPeopleToStopDecrease: integer expected";
                        if (message.minimumTimeDistance != null && message.hasOwnProperty("minimumTimeDistance"))
                            if (typeof message.minimumTimeDistance !== "number")
                                return "minimumTimeDistance: number expected";
                        if (message.minimumFeatureThreshold != null && message.hasOwnProperty("minimumFeatureThreshold"))
                            if (typeof message.minimumFeatureThreshold !== "number")
                                return "minimumFeatureThreshold: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a GlobalViewThresAdjustByDensityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig} GlobalViewThresAdjustByDensityConfig
                     */
                    GlobalViewThresAdjustByDensityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig();
                        if (object.minNumPeopleToDecrease != null)
                            message.minNumPeopleToDecrease = object.minNumPeopleToDecrease | 0;
                        if (object.maxNumPeopleToStopDecrease != null)
                            message.maxNumPeopleToStopDecrease = object.maxNumPeopleToStopDecrease | 0;
                        if (object.minimumTimeDistance != null)
                            message.minimumTimeDistance = Number(object.minimumTimeDistance);
                        if (object.minimumFeatureThreshold != null)
                            message.minimumFeatureThreshold = Number(object.minimumFeatureThreshold);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GlobalViewThresAdjustByDensityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig} message GlobalViewThresAdjustByDensityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GlobalViewThresAdjustByDensityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minNumPeopleToDecrease = 0;
                            object.maxNumPeopleToStopDecrease = 0;
                            object.minimumTimeDistance = 0;
                            object.minimumFeatureThreshold = 0;
                        }
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            object.minNumPeopleToDecrease = message.minNumPeopleToDecrease;
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            object.maxNumPeopleToStopDecrease = message.maxNumPeopleToStopDecrease;
                        if (message.minimumTimeDistance != null && message.hasOwnProperty("minimumTimeDistance"))
                            object.minimumTimeDistance = options.json && !isFinite(message.minimumTimeDistance) ? String(message.minimumTimeDistance) : message.minimumTimeDistance;
                        if (message.minimumFeatureThreshold != null && message.hasOwnProperty("minimumFeatureThreshold"))
                            object.minimumFeatureThreshold = options.json && !isFinite(message.minimumFeatureThreshold) ? String(message.minimumFeatureThreshold) : message.minimumFeatureThreshold;
                        return object;
                    };
    
                    /**
                     * Converts this GlobalViewThresAdjustByDensityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GlobalViewThresAdjustByDensityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GlobalViewThresAdjustByDensityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GlobalViewThresAdjustByDensityConfig;
                })();
    
                v1.CrossCameraThresAdjustByDensityConfig = (function() {
    
                    /**
                     * Properties of a CrossCameraThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ICrossCameraThresAdjustByDensityConfig
                     * @property {number|null} [minNumPeopleToDecrease] CrossCameraThresAdjustByDensityConfig minNumPeopleToDecrease
                     * @property {number|null} [maxNumPeopleToStopDecrease] CrossCameraThresAdjustByDensityConfig maxNumPeopleToStopDecrease
                     * @property {number|null} [minimumThreshold] CrossCameraThresAdjustByDensityConfig minimumThreshold
                     */
    
                    /**
                     * Constructs a new CrossCameraThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CrossCameraThresAdjustByDensityConfig.
                     * @implements ICrossCameraThresAdjustByDensityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig=} [properties] Properties to set
                     */
                    function CrossCameraThresAdjustByDensityConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrossCameraThresAdjustByDensityConfig minNumPeopleToDecrease.
                     * @member {number} minNumPeopleToDecrease
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    CrossCameraThresAdjustByDensityConfig.prototype.minNumPeopleToDecrease = 0;
    
                    /**
                     * CrossCameraThresAdjustByDensityConfig maxNumPeopleToStopDecrease.
                     * @member {number} maxNumPeopleToStopDecrease
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    CrossCameraThresAdjustByDensityConfig.prototype.maxNumPeopleToStopDecrease = 0;
    
                    /**
                     * CrossCameraThresAdjustByDensityConfig minimumThreshold.
                     * @member {number} minimumThreshold
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    CrossCameraThresAdjustByDensityConfig.prototype.minimumThreshold = 0;
    
                    /**
                     * Creates a new CrossCameraThresAdjustByDensityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig} CrossCameraThresAdjustByDensityConfig instance
                     */
                    CrossCameraThresAdjustByDensityConfig.create = function create(properties) {
                        return new CrossCameraThresAdjustByDensityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified CrossCameraThresAdjustByDensityConfig message. Does not implicitly {@link palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig} message CrossCameraThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrossCameraThresAdjustByDensityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minNumPeopleToDecrease != null && Object.hasOwnProperty.call(message, "minNumPeopleToDecrease"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minNumPeopleToDecrease);
                        if (message.maxNumPeopleToStopDecrease != null && Object.hasOwnProperty.call(message, "maxNumPeopleToStopDecrease"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumPeopleToStopDecrease);
                        if (message.minimumThreshold != null && Object.hasOwnProperty.call(message, "minimumThreshold"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.minimumThreshold);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrossCameraThresAdjustByDensityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ICrossCameraThresAdjustByDensityConfig} message CrossCameraThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrossCameraThresAdjustByDensityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrossCameraThresAdjustByDensityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig} CrossCameraThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrossCameraThresAdjustByDensityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minNumPeopleToDecrease = reader.int32();
                                break;
                            case 2:
                                message.maxNumPeopleToStopDecrease = reader.int32();
                                break;
                            case 3:
                                message.minimumThreshold = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrossCameraThresAdjustByDensityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig} CrossCameraThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrossCameraThresAdjustByDensityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrossCameraThresAdjustByDensityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrossCameraThresAdjustByDensityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            if (!$util.isInteger(message.minNumPeopleToDecrease))
                                return "minNumPeopleToDecrease: integer expected";
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            if (!$util.isInteger(message.maxNumPeopleToStopDecrease))
                                return "maxNumPeopleToStopDecrease: integer expected";
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            if (typeof message.minimumThreshold !== "number")
                                return "minimumThreshold: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrossCameraThresAdjustByDensityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig} CrossCameraThresAdjustByDensityConfig
                     */
                    CrossCameraThresAdjustByDensityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig();
                        if (object.minNumPeopleToDecrease != null)
                            message.minNumPeopleToDecrease = object.minNumPeopleToDecrease | 0;
                        if (object.maxNumPeopleToStopDecrease != null)
                            message.maxNumPeopleToStopDecrease = object.maxNumPeopleToStopDecrease | 0;
                        if (object.minimumThreshold != null)
                            message.minimumThreshold = Number(object.minimumThreshold);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrossCameraThresAdjustByDensityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig} message CrossCameraThresAdjustByDensityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrossCameraThresAdjustByDensityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minNumPeopleToDecrease = 0;
                            object.maxNumPeopleToStopDecrease = 0;
                            object.minimumThreshold = 0;
                        }
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            object.minNumPeopleToDecrease = message.minNumPeopleToDecrease;
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            object.maxNumPeopleToStopDecrease = message.maxNumPeopleToStopDecrease;
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            object.minimumThreshold = options.json && !isFinite(message.minimumThreshold) ? String(message.minimumThreshold) : message.minimumThreshold;
                        return object;
                    };
    
                    /**
                     * Converts this CrossCameraThresAdjustByDensityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CrossCameraThresAdjustByDensityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrossCameraThresAdjustByDensityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrossCameraThresAdjustByDensityConfig;
                })();
    
                v1.SingleCameraThresAdjustByDensityConfig = (function() {
    
                    /**
                     * Properties of a SingleCameraThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ISingleCameraThresAdjustByDensityConfig
                     * @property {number|null} [minNumPeopleToDecrease] SingleCameraThresAdjustByDensityConfig minNumPeopleToDecrease
                     * @property {number|null} [maxNumPeopleToStopDecrease] SingleCameraThresAdjustByDensityConfig maxNumPeopleToStopDecrease
                     * @property {number|null} [minimumThreshold] SingleCameraThresAdjustByDensityConfig minimumThreshold
                     */
    
                    /**
                     * Constructs a new SingleCameraThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SingleCameraThresAdjustByDensityConfig.
                     * @implements ISingleCameraThresAdjustByDensityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig=} [properties] Properties to set
                     */
                    function SingleCameraThresAdjustByDensityConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SingleCameraThresAdjustByDensityConfig minNumPeopleToDecrease.
                     * @member {number} minNumPeopleToDecrease
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    SingleCameraThresAdjustByDensityConfig.prototype.minNumPeopleToDecrease = 0;
    
                    /**
                     * SingleCameraThresAdjustByDensityConfig maxNumPeopleToStopDecrease.
                     * @member {number} maxNumPeopleToStopDecrease
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    SingleCameraThresAdjustByDensityConfig.prototype.maxNumPeopleToStopDecrease = 0;
    
                    /**
                     * SingleCameraThresAdjustByDensityConfig minimumThreshold.
                     * @member {number} minimumThreshold
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @instance
                     */
                    SingleCameraThresAdjustByDensityConfig.prototype.minimumThreshold = 0;
    
                    /**
                     * Creates a new SingleCameraThresAdjustByDensityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig} SingleCameraThresAdjustByDensityConfig instance
                     */
                    SingleCameraThresAdjustByDensityConfig.create = function create(properties) {
                        return new SingleCameraThresAdjustByDensityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified SingleCameraThresAdjustByDensityConfig message. Does not implicitly {@link palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig} message SingleCameraThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SingleCameraThresAdjustByDensityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minNumPeopleToDecrease != null && Object.hasOwnProperty.call(message, "minNumPeopleToDecrease"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minNumPeopleToDecrease);
                        if (message.maxNumPeopleToStopDecrease != null && Object.hasOwnProperty.call(message, "maxNumPeopleToStopDecrease"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumPeopleToStopDecrease);
                        if (message.minimumThreshold != null && Object.hasOwnProperty.call(message, "minimumThreshold"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.minimumThreshold);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SingleCameraThresAdjustByDensityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISingleCameraThresAdjustByDensityConfig} message SingleCameraThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SingleCameraThresAdjustByDensityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SingleCameraThresAdjustByDensityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig} SingleCameraThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SingleCameraThresAdjustByDensityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minNumPeopleToDecrease = reader.int32();
                                break;
                            case 2:
                                message.maxNumPeopleToStopDecrease = reader.int32();
                                break;
                            case 3:
                                message.minimumThreshold = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SingleCameraThresAdjustByDensityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig} SingleCameraThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SingleCameraThresAdjustByDensityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SingleCameraThresAdjustByDensityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SingleCameraThresAdjustByDensityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            if (!$util.isInteger(message.minNumPeopleToDecrease))
                                return "minNumPeopleToDecrease: integer expected";
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            if (!$util.isInteger(message.maxNumPeopleToStopDecrease))
                                return "maxNumPeopleToStopDecrease: integer expected";
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            if (typeof message.minimumThreshold !== "number")
                                return "minimumThreshold: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a SingleCameraThresAdjustByDensityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig} SingleCameraThresAdjustByDensityConfig
                     */
                    SingleCameraThresAdjustByDensityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig();
                        if (object.minNumPeopleToDecrease != null)
                            message.minNumPeopleToDecrease = object.minNumPeopleToDecrease | 0;
                        if (object.maxNumPeopleToStopDecrease != null)
                            message.maxNumPeopleToStopDecrease = object.maxNumPeopleToStopDecrease | 0;
                        if (object.minimumThreshold != null)
                            message.minimumThreshold = Number(object.minimumThreshold);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SingleCameraThresAdjustByDensityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig} message SingleCameraThresAdjustByDensityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SingleCameraThresAdjustByDensityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minNumPeopleToDecrease = 0;
                            object.maxNumPeopleToStopDecrease = 0;
                            object.minimumThreshold = 0;
                        }
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            object.minNumPeopleToDecrease = message.minNumPeopleToDecrease;
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            object.maxNumPeopleToStopDecrease = message.maxNumPeopleToStopDecrease;
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            object.minimumThreshold = options.json && !isFinite(message.minimumThreshold) ? String(message.minimumThreshold) : message.minimumThreshold;
                        return object;
                    };
    
                    /**
                     * Converts this SingleCameraThresAdjustByDensityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SingleCameraThresAdjustByDensityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SingleCameraThresAdjustByDensityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SingleCameraThresAdjustByDensityConfig;
                })();
    
                v1.VeryCloseThresAdjustByDensityConfig = (function() {
    
                    /**
                     * Properties of a VeryCloseThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IVeryCloseThresAdjustByDensityConfig
                     * @property {number|null} [minNumPeopleToDecrease] VeryCloseThresAdjustByDensityConfig minNumPeopleToDecrease
                     * @property {number|null} [maxNumPeopleToStopDecrease] VeryCloseThresAdjustByDensityConfig maxNumPeopleToStopDecrease
                     * @property {number|null} [minimumThreshold] VeryCloseThresAdjustByDensityConfig minimumThreshold
                     */
    
                    /**
                     * Constructs a new VeryCloseThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VeryCloseThresAdjustByDensityConfig.
                     * @implements IVeryCloseThresAdjustByDensityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig=} [properties] Properties to set
                     */
                    function VeryCloseThresAdjustByDensityConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VeryCloseThresAdjustByDensityConfig minNumPeopleToDecrease.
                     * @member {number} minNumPeopleToDecrease
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @instance
                     */
                    VeryCloseThresAdjustByDensityConfig.prototype.minNumPeopleToDecrease = 0;
    
                    /**
                     * VeryCloseThresAdjustByDensityConfig maxNumPeopleToStopDecrease.
                     * @member {number} maxNumPeopleToStopDecrease
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @instance
                     */
                    VeryCloseThresAdjustByDensityConfig.prototype.maxNumPeopleToStopDecrease = 0;
    
                    /**
                     * VeryCloseThresAdjustByDensityConfig minimumThreshold.
                     * @member {number} minimumThreshold
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @instance
                     */
                    VeryCloseThresAdjustByDensityConfig.prototype.minimumThreshold = 0;
    
                    /**
                     * Creates a new VeryCloseThresAdjustByDensityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig} VeryCloseThresAdjustByDensityConfig instance
                     */
                    VeryCloseThresAdjustByDensityConfig.create = function create(properties) {
                        return new VeryCloseThresAdjustByDensityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified VeryCloseThresAdjustByDensityConfig message. Does not implicitly {@link palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig} message VeryCloseThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VeryCloseThresAdjustByDensityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minNumPeopleToDecrease != null && Object.hasOwnProperty.call(message, "minNumPeopleToDecrease"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minNumPeopleToDecrease);
                        if (message.maxNumPeopleToStopDecrease != null && Object.hasOwnProperty.call(message, "maxNumPeopleToStopDecrease"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumPeopleToStopDecrease);
                        if (message.minimumThreshold != null && Object.hasOwnProperty.call(message, "minimumThreshold"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.minimumThreshold);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VeryCloseThresAdjustByDensityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.IVeryCloseThresAdjustByDensityConfig} message VeryCloseThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VeryCloseThresAdjustByDensityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VeryCloseThresAdjustByDensityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig} VeryCloseThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VeryCloseThresAdjustByDensityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minNumPeopleToDecrease = reader.int32();
                                break;
                            case 2:
                                message.maxNumPeopleToStopDecrease = reader.int32();
                                break;
                            case 3:
                                message.minimumThreshold = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VeryCloseThresAdjustByDensityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig} VeryCloseThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VeryCloseThresAdjustByDensityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VeryCloseThresAdjustByDensityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VeryCloseThresAdjustByDensityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            if (!$util.isInteger(message.minNumPeopleToDecrease))
                                return "minNumPeopleToDecrease: integer expected";
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            if (!$util.isInteger(message.maxNumPeopleToStopDecrease))
                                return "maxNumPeopleToStopDecrease: integer expected";
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            if (typeof message.minimumThreshold !== "number")
                                return "minimumThreshold: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a VeryCloseThresAdjustByDensityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig} VeryCloseThresAdjustByDensityConfig
                     */
                    VeryCloseThresAdjustByDensityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig();
                        if (object.minNumPeopleToDecrease != null)
                            message.minNumPeopleToDecrease = object.minNumPeopleToDecrease | 0;
                        if (object.maxNumPeopleToStopDecrease != null)
                            message.maxNumPeopleToStopDecrease = object.maxNumPeopleToStopDecrease | 0;
                        if (object.minimumThreshold != null)
                            message.minimumThreshold = Number(object.minimumThreshold);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VeryCloseThresAdjustByDensityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig} message VeryCloseThresAdjustByDensityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VeryCloseThresAdjustByDensityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minNumPeopleToDecrease = 0;
                            object.maxNumPeopleToStopDecrease = 0;
                            object.minimumThreshold = 0;
                        }
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            object.minNumPeopleToDecrease = message.minNumPeopleToDecrease;
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            object.maxNumPeopleToStopDecrease = message.maxNumPeopleToStopDecrease;
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            object.minimumThreshold = options.json && !isFinite(message.minimumThreshold) ? String(message.minimumThreshold) : message.minimumThreshold;
                        return object;
                    };
    
                    /**
                     * Converts this VeryCloseThresAdjustByDensityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.VeryCloseThresAdjustByDensityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VeryCloseThresAdjustByDensityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return VeryCloseThresAdjustByDensityConfig;
                })();
    
                v1.SuspectedStaffThresAdjustByDensityConfig = (function() {
    
                    /**
                     * Properties of a SuspectedStaffThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ISuspectedStaffThresAdjustByDensityConfig
                     * @property {number|null} [minNumPeopleToDecrease] SuspectedStaffThresAdjustByDensityConfig minNumPeopleToDecrease
                     * @property {number|null} [maxNumPeopleToStopDecrease] SuspectedStaffThresAdjustByDensityConfig maxNumPeopleToStopDecrease
                     * @property {number|null} [minimumThreshold] SuspectedStaffThresAdjustByDensityConfig minimumThreshold
                     */
    
                    /**
                     * Constructs a new SuspectedStaffThresAdjustByDensityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SuspectedStaffThresAdjustByDensityConfig.
                     * @implements ISuspectedStaffThresAdjustByDensityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig=} [properties] Properties to set
                     */
                    function SuspectedStaffThresAdjustByDensityConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SuspectedStaffThresAdjustByDensityConfig minNumPeopleToDecrease.
                     * @member {number} minNumPeopleToDecrease
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @instance
                     */
                    SuspectedStaffThresAdjustByDensityConfig.prototype.minNumPeopleToDecrease = 0;
    
                    /**
                     * SuspectedStaffThresAdjustByDensityConfig maxNumPeopleToStopDecrease.
                     * @member {number} maxNumPeopleToStopDecrease
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @instance
                     */
                    SuspectedStaffThresAdjustByDensityConfig.prototype.maxNumPeopleToStopDecrease = 0;
    
                    /**
                     * SuspectedStaffThresAdjustByDensityConfig minimumThreshold.
                     * @member {number} minimumThreshold
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @instance
                     */
                    SuspectedStaffThresAdjustByDensityConfig.prototype.minimumThreshold = 0;
    
                    /**
                     * Creates a new SuspectedStaffThresAdjustByDensityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig} SuspectedStaffThresAdjustByDensityConfig instance
                     */
                    SuspectedStaffThresAdjustByDensityConfig.create = function create(properties) {
                        return new SuspectedStaffThresAdjustByDensityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified SuspectedStaffThresAdjustByDensityConfig message. Does not implicitly {@link palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig} message SuspectedStaffThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SuspectedStaffThresAdjustByDensityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minNumPeopleToDecrease != null && Object.hasOwnProperty.call(message, "minNumPeopleToDecrease"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minNumPeopleToDecrease);
                        if (message.maxNumPeopleToStopDecrease != null && Object.hasOwnProperty.call(message, "maxNumPeopleToStopDecrease"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumPeopleToStopDecrease);
                        if (message.minimumThreshold != null && Object.hasOwnProperty.call(message, "minimumThreshold"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.minimumThreshold);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SuspectedStaffThresAdjustByDensityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig} message SuspectedStaffThresAdjustByDensityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SuspectedStaffThresAdjustByDensityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SuspectedStaffThresAdjustByDensityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig} SuspectedStaffThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SuspectedStaffThresAdjustByDensityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minNumPeopleToDecrease = reader.int32();
                                break;
                            case 2:
                                message.maxNumPeopleToStopDecrease = reader.int32();
                                break;
                            case 3:
                                message.minimumThreshold = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SuspectedStaffThresAdjustByDensityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig} SuspectedStaffThresAdjustByDensityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SuspectedStaffThresAdjustByDensityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SuspectedStaffThresAdjustByDensityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SuspectedStaffThresAdjustByDensityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            if (!$util.isInteger(message.minNumPeopleToDecrease))
                                return "minNumPeopleToDecrease: integer expected";
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            if (!$util.isInteger(message.maxNumPeopleToStopDecrease))
                                return "maxNumPeopleToStopDecrease: integer expected";
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            if (typeof message.minimumThreshold !== "number")
                                return "minimumThreshold: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a SuspectedStaffThresAdjustByDensityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig} SuspectedStaffThresAdjustByDensityConfig
                     */
                    SuspectedStaffThresAdjustByDensityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig();
                        if (object.minNumPeopleToDecrease != null)
                            message.minNumPeopleToDecrease = object.minNumPeopleToDecrease | 0;
                        if (object.maxNumPeopleToStopDecrease != null)
                            message.maxNumPeopleToStopDecrease = object.maxNumPeopleToStopDecrease | 0;
                        if (object.minimumThreshold != null)
                            message.minimumThreshold = Number(object.minimumThreshold);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SuspectedStaffThresAdjustByDensityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @static
                     * @param {palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig} message SuspectedStaffThresAdjustByDensityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SuspectedStaffThresAdjustByDensityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minNumPeopleToDecrease = 0;
                            object.maxNumPeopleToStopDecrease = 0;
                            object.minimumThreshold = 0;
                        }
                        if (message.minNumPeopleToDecrease != null && message.hasOwnProperty("minNumPeopleToDecrease"))
                            object.minNumPeopleToDecrease = message.minNumPeopleToDecrease;
                        if (message.maxNumPeopleToStopDecrease != null && message.hasOwnProperty("maxNumPeopleToStopDecrease"))
                            object.maxNumPeopleToStopDecrease = message.maxNumPeopleToStopDecrease;
                        if (message.minimumThreshold != null && message.hasOwnProperty("minimumThreshold"))
                            object.minimumThreshold = options.json && !isFinite(message.minimumThreshold) ? String(message.minimumThreshold) : message.minimumThreshold;
                        return object;
                    };
    
                    /**
                     * Converts this SuspectedStaffThresAdjustByDensityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SuspectedStaffThresAdjustByDensityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SuspectedStaffThresAdjustByDensityConfig;
                })();
    
                v1.OutlierFilteringConfig = (function() {
    
                    /**
                     * Properties of an OutlierFilteringConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IOutlierFilteringConfig
                     * @property {number|null} [minDurationInSeconds] OutlierFilteringConfig minDurationInSeconds
                     * @property {number|null} [minBb] OutlierFilteringConfig minBb
                     * @property {boolean|null} [filterByEntranceCameras] OutlierFilteringConfig filterByEntranceCameras
                     * @property {number|null} [numEntranceCameras] OutlierFilteringConfig numEntranceCameras
                     * @property {boolean|null} [filterBySuspectedStaffs] OutlierFilteringConfig filterBySuspectedStaffs
                     * @property {number|null} [minStaffClusterSize] OutlierFilteringConfig minStaffClusterSize
                     * @property {boolean|null} [prefilterByDetectStaticObjects] OutlierFilteringConfig prefilterByDetectStaticObjects
                     * @property {number|null} [prefilterByDetectStaticObjectsMinNumBoundingBox] OutlierFilteringConfig prefilterByDetectStaticObjectsMinNumBoundingBox
                     * @property {boolean|null} [filterByEntranceMetadataAppearances] OutlierFilteringConfig filterByEntranceMetadataAppearances
                     * @property {number|null} [maxDurationInSeconds] OutlierFilteringConfig maxDurationInSeconds
                     * @property {number|null} [minStaffClusterDurationInSeconds] OutlierFilteringConfig minStaffClusterDurationInSeconds
                     * @property {boolean|null} [removePeopleAtStaffSection] OutlierFilteringConfig removePeopleAtStaffSection
                     * @property {boolean|null} [useStdDerivedFloorDistanceToFilter] OutlierFilteringConfig useStdDerivedFloorDistanceToFilter
                     * @property {boolean|null} [skipStdDerivedFloorDistanceToFilter] OutlierFilteringConfig skipStdDerivedFloorDistanceToFilter
                     * @property {boolean|null} [skipStdDerivedCameraDistanceToFilter] OutlierFilteringConfig skipStdDerivedCameraDistanceToFilter
                     * @property {boolean|null} [removePeopleStartingNotFromEntrance] OutlierFilteringConfig removePeopleStartingNotFromEntrance
                     * @property {palexy.streaming.v1.IStaticObjectFilteringConfig|null} [staticObjectFilterConfig] OutlierFilteringConfig staticObjectFilterConfig
                     * @property {number|null} [minAvgValidBbProb] OutlierFilteringConfig minAvgValidBbProb
                     * @property {boolean|null} [skipRemoveClustersWithLowAvgValidBbsProb] OutlierFilteringConfig skipRemoveClustersWithLowAvgValidBbsProb
                     * @property {number|null} [maxClusterCamerasToRemovePeopleAtStaffSections] OutlierFilteringConfig maxClusterCamerasToRemovePeopleAtStaffSections
                     * @property {number|null} [maxItemsAtStaffSections] OutlierFilteringConfig maxItemsAtStaffSections
                     * @property {number|null} [suspectedStaffFeatureDistanceThreshold] OutlierFilteringConfig suspectedStaffFeatureDistanceThreshold
                     * @property {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig|null} [suspectedStaffThresAdjustByDensityConfig] OutlierFilteringConfig suspectedStaffThresAdjustByDensityConfig
                     * @property {number|null} [maxGapToAddDuration] OutlierFilteringConfig maxGapToAddDuration
                     * @property {boolean|null} [keepClusterWithConfidentBbProb] OutlierFilteringConfig keepClusterWithConfidentBbProb
                     * @property {boolean|null} [skipFilterByNumSecondsPerBb] OutlierFilteringConfig skipFilterByNumSecondsPerBb
                     * @property {boolean|null} [skipRemoveShortStayWhenMerge] OutlierFilteringConfig skipRemoveShortStayWhenMerge
                     */
    
                    /**
                     * Constructs a new OutlierFilteringConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an OutlierFilteringConfig.
                     * @implements IOutlierFilteringConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IOutlierFilteringConfig=} [properties] Properties to set
                     */
                    function OutlierFilteringConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * OutlierFilteringConfig minDurationInSeconds.
                     * @member {number} minDurationInSeconds
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.minDurationInSeconds = 0;
    
                    /**
                     * OutlierFilteringConfig minBb.
                     * @member {number} minBb
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.minBb = 0;
    
                    /**
                     * OutlierFilteringConfig filterByEntranceCameras.
                     * @member {boolean} filterByEntranceCameras
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.filterByEntranceCameras = false;
    
                    /**
                     * OutlierFilteringConfig numEntranceCameras.
                     * @member {number} numEntranceCameras
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.numEntranceCameras = 0;
    
                    /**
                     * OutlierFilteringConfig filterBySuspectedStaffs.
                     * @member {boolean} filterBySuspectedStaffs
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.filterBySuspectedStaffs = false;
    
                    /**
                     * OutlierFilteringConfig minStaffClusterSize.
                     * @member {number} minStaffClusterSize
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.minStaffClusterSize = 0;
    
                    /**
                     * OutlierFilteringConfig prefilterByDetectStaticObjects.
                     * @member {boolean} prefilterByDetectStaticObjects
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.prefilterByDetectStaticObjects = false;
    
                    /**
                     * OutlierFilteringConfig prefilterByDetectStaticObjectsMinNumBoundingBox.
                     * @member {number} prefilterByDetectStaticObjectsMinNumBoundingBox
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.prefilterByDetectStaticObjectsMinNumBoundingBox = 0;
    
                    /**
                     * OutlierFilteringConfig filterByEntranceMetadataAppearances.
                     * @member {boolean} filterByEntranceMetadataAppearances
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.filterByEntranceMetadataAppearances = false;
    
                    /**
                     * OutlierFilteringConfig maxDurationInSeconds.
                     * @member {number} maxDurationInSeconds
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.maxDurationInSeconds = 0;
    
                    /**
                     * OutlierFilteringConfig minStaffClusterDurationInSeconds.
                     * @member {number} minStaffClusterDurationInSeconds
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.minStaffClusterDurationInSeconds = 0;
    
                    /**
                     * OutlierFilteringConfig removePeopleAtStaffSection.
                     * @member {boolean} removePeopleAtStaffSection
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.removePeopleAtStaffSection = false;
    
                    /**
                     * OutlierFilteringConfig useStdDerivedFloorDistanceToFilter.
                     * @member {boolean} useStdDerivedFloorDistanceToFilter
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.useStdDerivedFloorDistanceToFilter = false;
    
                    /**
                     * OutlierFilteringConfig skipStdDerivedFloorDistanceToFilter.
                     * @member {boolean} skipStdDerivedFloorDistanceToFilter
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.skipStdDerivedFloorDistanceToFilter = false;
    
                    /**
                     * OutlierFilteringConfig skipStdDerivedCameraDistanceToFilter.
                     * @member {boolean} skipStdDerivedCameraDistanceToFilter
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.skipStdDerivedCameraDistanceToFilter = false;
    
                    /**
                     * OutlierFilteringConfig removePeopleStartingNotFromEntrance.
                     * @member {boolean} removePeopleStartingNotFromEntrance
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.removePeopleStartingNotFromEntrance = false;
    
                    /**
                     * OutlierFilteringConfig staticObjectFilterConfig.
                     * @member {palexy.streaming.v1.IStaticObjectFilteringConfig|null|undefined} staticObjectFilterConfig
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.staticObjectFilterConfig = null;
    
                    /**
                     * OutlierFilteringConfig minAvgValidBbProb.
                     * @member {number} minAvgValidBbProb
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.minAvgValidBbProb = 0;
    
                    /**
                     * OutlierFilteringConfig skipRemoveClustersWithLowAvgValidBbsProb.
                     * @member {boolean} skipRemoveClustersWithLowAvgValidBbsProb
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.skipRemoveClustersWithLowAvgValidBbsProb = false;
    
                    /**
                     * OutlierFilteringConfig maxClusterCamerasToRemovePeopleAtStaffSections.
                     * @member {number} maxClusterCamerasToRemovePeopleAtStaffSections
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.maxClusterCamerasToRemovePeopleAtStaffSections = 0;
    
                    /**
                     * OutlierFilteringConfig maxItemsAtStaffSections.
                     * @member {number} maxItemsAtStaffSections
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.maxItemsAtStaffSections = 0;
    
                    /**
                     * OutlierFilteringConfig suspectedStaffFeatureDistanceThreshold.
                     * @member {number} suspectedStaffFeatureDistanceThreshold
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.suspectedStaffFeatureDistanceThreshold = 0;
    
                    /**
                     * OutlierFilteringConfig suspectedStaffThresAdjustByDensityConfig.
                     * @member {palexy.streaming.v1.ISuspectedStaffThresAdjustByDensityConfig|null|undefined} suspectedStaffThresAdjustByDensityConfig
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.suspectedStaffThresAdjustByDensityConfig = null;
    
                    /**
                     * OutlierFilteringConfig maxGapToAddDuration.
                     * @member {number} maxGapToAddDuration
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.maxGapToAddDuration = 0;
    
                    /**
                     * OutlierFilteringConfig keepClusterWithConfidentBbProb.
                     * @member {boolean} keepClusterWithConfidentBbProb
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.keepClusterWithConfidentBbProb = false;
    
                    /**
                     * OutlierFilteringConfig skipFilterByNumSecondsPerBb.
                     * @member {boolean} skipFilterByNumSecondsPerBb
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.skipFilterByNumSecondsPerBb = false;
    
                    /**
                     * OutlierFilteringConfig skipRemoveShortStayWhenMerge.
                     * @member {boolean} skipRemoveShortStayWhenMerge
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     */
                    OutlierFilteringConfig.prototype.skipRemoveShortStayWhenMerge = false;
    
                    /**
                     * Creates a new OutlierFilteringConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IOutlierFilteringConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.OutlierFilteringConfig} OutlierFilteringConfig instance
                     */
                    OutlierFilteringConfig.create = function create(properties) {
                        return new OutlierFilteringConfig(properties);
                    };
    
                    /**
                     * Encodes the specified OutlierFilteringConfig message. Does not implicitly {@link palexy.streaming.v1.OutlierFilteringConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IOutlierFilteringConfig} message OutlierFilteringConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OutlierFilteringConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minDurationInSeconds != null && Object.hasOwnProperty.call(message, "minDurationInSeconds"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minDurationInSeconds);
                        if (message.minBb != null && Object.hasOwnProperty.call(message, "minBb"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minBb);
                        if (message.filterByEntranceCameras != null && Object.hasOwnProperty.call(message, "filterByEntranceCameras"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.filterByEntranceCameras);
                        if (message.numEntranceCameras != null && Object.hasOwnProperty.call(message, "numEntranceCameras"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.numEntranceCameras);
                        if (message.filterBySuspectedStaffs != null && Object.hasOwnProperty.call(message, "filterBySuspectedStaffs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.filterBySuspectedStaffs);
                        if (message.minStaffClusterSize != null && Object.hasOwnProperty.call(message, "minStaffClusterSize"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.minStaffClusterSize);
                        if (message.prefilterByDetectStaticObjects != null && Object.hasOwnProperty.call(message, "prefilterByDetectStaticObjects"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.prefilterByDetectStaticObjects);
                        if (message.prefilterByDetectStaticObjectsMinNumBoundingBox != null && Object.hasOwnProperty.call(message, "prefilterByDetectStaticObjectsMinNumBoundingBox"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.prefilterByDetectStaticObjectsMinNumBoundingBox);
                        if (message.filterByEntranceMetadataAppearances != null && Object.hasOwnProperty.call(message, "filterByEntranceMetadataAppearances"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.filterByEntranceMetadataAppearances);
                        if (message.maxDurationInSeconds != null && Object.hasOwnProperty.call(message, "maxDurationInSeconds"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.maxDurationInSeconds);
                        if (message.minStaffClusterDurationInSeconds != null && Object.hasOwnProperty.call(message, "minStaffClusterDurationInSeconds"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.minStaffClusterDurationInSeconds);
                        if (message.removePeopleAtStaffSection != null && Object.hasOwnProperty.call(message, "removePeopleAtStaffSection"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.removePeopleAtStaffSection);
                        if (message.useStdDerivedFloorDistanceToFilter != null && Object.hasOwnProperty.call(message, "useStdDerivedFloorDistanceToFilter"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.useStdDerivedFloorDistanceToFilter);
                        if (message.skipStdDerivedFloorDistanceToFilter != null && Object.hasOwnProperty.call(message, "skipStdDerivedFloorDistanceToFilter"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.skipStdDerivedFloorDistanceToFilter);
                        if (message.skipStdDerivedCameraDistanceToFilter != null && Object.hasOwnProperty.call(message, "skipStdDerivedCameraDistanceToFilter"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.skipStdDerivedCameraDistanceToFilter);
                        if (message.removePeopleStartingNotFromEntrance != null && Object.hasOwnProperty.call(message, "removePeopleStartingNotFromEntrance"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.removePeopleStartingNotFromEntrance);
                        if (message.staticObjectFilterConfig != null && Object.hasOwnProperty.call(message, "staticObjectFilterConfig"))
                            $root.palexy.streaming.v1.StaticObjectFilteringConfig.encode(message.staticObjectFilterConfig, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.minAvgValidBbProb != null && Object.hasOwnProperty.call(message, "minAvgValidBbProb"))
                            writer.uint32(/* id 18, wireType 5 =*/149).float(message.minAvgValidBbProb);
                        if (message.skipRemoveClustersWithLowAvgValidBbsProb != null && Object.hasOwnProperty.call(message, "skipRemoveClustersWithLowAvgValidBbsProb"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.skipRemoveClustersWithLowAvgValidBbsProb);
                        if (message.maxClusterCamerasToRemovePeopleAtStaffSections != null && Object.hasOwnProperty.call(message, "maxClusterCamerasToRemovePeopleAtStaffSections"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.maxClusterCamerasToRemovePeopleAtStaffSections);
                        if (message.maxItemsAtStaffSections != null && Object.hasOwnProperty.call(message, "maxItemsAtStaffSections"))
                            writer.uint32(/* id 21, wireType 0 =*/168).int32(message.maxItemsAtStaffSections);
                        if (message.suspectedStaffFeatureDistanceThreshold != null && Object.hasOwnProperty.call(message, "suspectedStaffFeatureDistanceThreshold"))
                            writer.uint32(/* id 22, wireType 5 =*/181).float(message.suspectedStaffFeatureDistanceThreshold);
                        if (message.suspectedStaffThresAdjustByDensityConfig != null && Object.hasOwnProperty.call(message, "suspectedStaffThresAdjustByDensityConfig"))
                            $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.encode(message.suspectedStaffThresAdjustByDensityConfig, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                        if (message.maxGapToAddDuration != null && Object.hasOwnProperty.call(message, "maxGapToAddDuration"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int32(message.maxGapToAddDuration);
                        if (message.keepClusterWithConfidentBbProb != null && Object.hasOwnProperty.call(message, "keepClusterWithConfidentBbProb"))
                            writer.uint32(/* id 25, wireType 0 =*/200).bool(message.keepClusterWithConfidentBbProb);
                        if (message.skipFilterByNumSecondsPerBb != null && Object.hasOwnProperty.call(message, "skipFilterByNumSecondsPerBb"))
                            writer.uint32(/* id 26, wireType 0 =*/208).bool(message.skipFilterByNumSecondsPerBb);
                        if (message.skipRemoveShortStayWhenMerge != null && Object.hasOwnProperty.call(message, "skipRemoveShortStayWhenMerge"))
                            writer.uint32(/* id 27, wireType 0 =*/216).bool(message.skipRemoveShortStayWhenMerge);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified OutlierFilteringConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.OutlierFilteringConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.IOutlierFilteringConfig} message OutlierFilteringConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OutlierFilteringConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an OutlierFilteringConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.OutlierFilteringConfig} OutlierFilteringConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OutlierFilteringConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.OutlierFilteringConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minDurationInSeconds = reader.int32();
                                break;
                            case 2:
                                message.minBb = reader.int32();
                                break;
                            case 3:
                                message.filterByEntranceCameras = reader.bool();
                                break;
                            case 4:
                                message.numEntranceCameras = reader.int32();
                                break;
                            case 5:
                                message.filterBySuspectedStaffs = reader.bool();
                                break;
                            case 6:
                                message.minStaffClusterSize = reader.int32();
                                break;
                            case 7:
                                message.prefilterByDetectStaticObjects = reader.bool();
                                break;
                            case 8:
                                message.prefilterByDetectStaticObjectsMinNumBoundingBox = reader.int32();
                                break;
                            case 9:
                                message.filterByEntranceMetadataAppearances = reader.bool();
                                break;
                            case 10:
                                message.maxDurationInSeconds = reader.int32();
                                break;
                            case 11:
                                message.minStaffClusterDurationInSeconds = reader.int32();
                                break;
                            case 12:
                                message.removePeopleAtStaffSection = reader.bool();
                                break;
                            case 13:
                                message.useStdDerivedFloorDistanceToFilter = reader.bool();
                                break;
                            case 14:
                                message.skipStdDerivedFloorDistanceToFilter = reader.bool();
                                break;
                            case 15:
                                message.skipStdDerivedCameraDistanceToFilter = reader.bool();
                                break;
                            case 16:
                                message.removePeopleStartingNotFromEntrance = reader.bool();
                                break;
                            case 17:
                                message.staticObjectFilterConfig = $root.palexy.streaming.v1.StaticObjectFilteringConfig.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.minAvgValidBbProb = reader.float();
                                break;
                            case 19:
                                message.skipRemoveClustersWithLowAvgValidBbsProb = reader.bool();
                                break;
                            case 20:
                                message.maxClusterCamerasToRemovePeopleAtStaffSections = reader.int32();
                                break;
                            case 21:
                                message.maxItemsAtStaffSections = reader.int32();
                                break;
                            case 22:
                                message.suspectedStaffFeatureDistanceThreshold = reader.float();
                                break;
                            case 23:
                                message.suspectedStaffThresAdjustByDensityConfig = $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.decode(reader, reader.uint32());
                                break;
                            case 24:
                                message.maxGapToAddDuration = reader.int32();
                                break;
                            case 25:
                                message.keepClusterWithConfidentBbProb = reader.bool();
                                break;
                            case 26:
                                message.skipFilterByNumSecondsPerBb = reader.bool();
                                break;
                            case 27:
                                message.skipRemoveShortStayWhenMerge = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an OutlierFilteringConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.OutlierFilteringConfig} OutlierFilteringConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OutlierFilteringConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an OutlierFilteringConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    OutlierFilteringConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minDurationInSeconds != null && message.hasOwnProperty("minDurationInSeconds"))
                            if (!$util.isInteger(message.minDurationInSeconds))
                                return "minDurationInSeconds: integer expected";
                        if (message.minBb != null && message.hasOwnProperty("minBb"))
                            if (!$util.isInteger(message.minBb))
                                return "minBb: integer expected";
                        if (message.filterByEntranceCameras != null && message.hasOwnProperty("filterByEntranceCameras"))
                            if (typeof message.filterByEntranceCameras !== "boolean")
                                return "filterByEntranceCameras: boolean expected";
                        if (message.numEntranceCameras != null && message.hasOwnProperty("numEntranceCameras"))
                            if (!$util.isInteger(message.numEntranceCameras))
                                return "numEntranceCameras: integer expected";
                        if (message.filterBySuspectedStaffs != null && message.hasOwnProperty("filterBySuspectedStaffs"))
                            if (typeof message.filterBySuspectedStaffs !== "boolean")
                                return "filterBySuspectedStaffs: boolean expected";
                        if (message.minStaffClusterSize != null && message.hasOwnProperty("minStaffClusterSize"))
                            if (!$util.isInteger(message.minStaffClusterSize))
                                return "minStaffClusterSize: integer expected";
                        if (message.prefilterByDetectStaticObjects != null && message.hasOwnProperty("prefilterByDetectStaticObjects"))
                            if (typeof message.prefilterByDetectStaticObjects !== "boolean")
                                return "prefilterByDetectStaticObjects: boolean expected";
                        if (message.prefilterByDetectStaticObjectsMinNumBoundingBox != null && message.hasOwnProperty("prefilterByDetectStaticObjectsMinNumBoundingBox"))
                            if (!$util.isInteger(message.prefilterByDetectStaticObjectsMinNumBoundingBox))
                                return "prefilterByDetectStaticObjectsMinNumBoundingBox: integer expected";
                        if (message.filterByEntranceMetadataAppearances != null && message.hasOwnProperty("filterByEntranceMetadataAppearances"))
                            if (typeof message.filterByEntranceMetadataAppearances !== "boolean")
                                return "filterByEntranceMetadataAppearances: boolean expected";
                        if (message.maxDurationInSeconds != null && message.hasOwnProperty("maxDurationInSeconds"))
                            if (!$util.isInteger(message.maxDurationInSeconds))
                                return "maxDurationInSeconds: integer expected";
                        if (message.minStaffClusterDurationInSeconds != null && message.hasOwnProperty("minStaffClusterDurationInSeconds"))
                            if (!$util.isInteger(message.minStaffClusterDurationInSeconds))
                                return "minStaffClusterDurationInSeconds: integer expected";
                        if (message.removePeopleAtStaffSection != null && message.hasOwnProperty("removePeopleAtStaffSection"))
                            if (typeof message.removePeopleAtStaffSection !== "boolean")
                                return "removePeopleAtStaffSection: boolean expected";
                        if (message.useStdDerivedFloorDistanceToFilter != null && message.hasOwnProperty("useStdDerivedFloorDistanceToFilter"))
                            if (typeof message.useStdDerivedFloorDistanceToFilter !== "boolean")
                                return "useStdDerivedFloorDistanceToFilter: boolean expected";
                        if (message.skipStdDerivedFloorDistanceToFilter != null && message.hasOwnProperty("skipStdDerivedFloorDistanceToFilter"))
                            if (typeof message.skipStdDerivedFloorDistanceToFilter !== "boolean")
                                return "skipStdDerivedFloorDistanceToFilter: boolean expected";
                        if (message.skipStdDerivedCameraDistanceToFilter != null && message.hasOwnProperty("skipStdDerivedCameraDistanceToFilter"))
                            if (typeof message.skipStdDerivedCameraDistanceToFilter !== "boolean")
                                return "skipStdDerivedCameraDistanceToFilter: boolean expected";
                        if (message.removePeopleStartingNotFromEntrance != null && message.hasOwnProperty("removePeopleStartingNotFromEntrance"))
                            if (typeof message.removePeopleStartingNotFromEntrance !== "boolean")
                                return "removePeopleStartingNotFromEntrance: boolean expected";
                        if (message.staticObjectFilterConfig != null && message.hasOwnProperty("staticObjectFilterConfig")) {
                            var error = $root.palexy.streaming.v1.StaticObjectFilteringConfig.verify(message.staticObjectFilterConfig);
                            if (error)
                                return "staticObjectFilterConfig." + error;
                        }
                        if (message.minAvgValidBbProb != null && message.hasOwnProperty("minAvgValidBbProb"))
                            if (typeof message.minAvgValidBbProb !== "number")
                                return "minAvgValidBbProb: number expected";
                        if (message.skipRemoveClustersWithLowAvgValidBbsProb != null && message.hasOwnProperty("skipRemoveClustersWithLowAvgValidBbsProb"))
                            if (typeof message.skipRemoveClustersWithLowAvgValidBbsProb !== "boolean")
                                return "skipRemoveClustersWithLowAvgValidBbsProb: boolean expected";
                        if (message.maxClusterCamerasToRemovePeopleAtStaffSections != null && message.hasOwnProperty("maxClusterCamerasToRemovePeopleAtStaffSections"))
                            if (!$util.isInteger(message.maxClusterCamerasToRemovePeopleAtStaffSections))
                                return "maxClusterCamerasToRemovePeopleAtStaffSections: integer expected";
                        if (message.maxItemsAtStaffSections != null && message.hasOwnProperty("maxItemsAtStaffSections"))
                            if (!$util.isInteger(message.maxItemsAtStaffSections))
                                return "maxItemsAtStaffSections: integer expected";
                        if (message.suspectedStaffFeatureDistanceThreshold != null && message.hasOwnProperty("suspectedStaffFeatureDistanceThreshold"))
                            if (typeof message.suspectedStaffFeatureDistanceThreshold !== "number")
                                return "suspectedStaffFeatureDistanceThreshold: number expected";
                        if (message.suspectedStaffThresAdjustByDensityConfig != null && message.hasOwnProperty("suspectedStaffThresAdjustByDensityConfig")) {
                            var error = $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.verify(message.suspectedStaffThresAdjustByDensityConfig);
                            if (error)
                                return "suspectedStaffThresAdjustByDensityConfig." + error;
                        }
                        if (message.maxGapToAddDuration != null && message.hasOwnProperty("maxGapToAddDuration"))
                            if (!$util.isInteger(message.maxGapToAddDuration))
                                return "maxGapToAddDuration: integer expected";
                        if (message.keepClusterWithConfidentBbProb != null && message.hasOwnProperty("keepClusterWithConfidentBbProb"))
                            if (typeof message.keepClusterWithConfidentBbProb !== "boolean")
                                return "keepClusterWithConfidentBbProb: boolean expected";
                        if (message.skipFilterByNumSecondsPerBb != null && message.hasOwnProperty("skipFilterByNumSecondsPerBb"))
                            if (typeof message.skipFilterByNumSecondsPerBb !== "boolean")
                                return "skipFilterByNumSecondsPerBb: boolean expected";
                        if (message.skipRemoveShortStayWhenMerge != null && message.hasOwnProperty("skipRemoveShortStayWhenMerge"))
                            if (typeof message.skipRemoveShortStayWhenMerge !== "boolean")
                                return "skipRemoveShortStayWhenMerge: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an OutlierFilteringConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.OutlierFilteringConfig} OutlierFilteringConfig
                     */
                    OutlierFilteringConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.OutlierFilteringConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.OutlierFilteringConfig();
                        if (object.minDurationInSeconds != null)
                            message.minDurationInSeconds = object.minDurationInSeconds | 0;
                        if (object.minBb != null)
                            message.minBb = object.minBb | 0;
                        if (object.filterByEntranceCameras != null)
                            message.filterByEntranceCameras = Boolean(object.filterByEntranceCameras);
                        if (object.numEntranceCameras != null)
                            message.numEntranceCameras = object.numEntranceCameras | 0;
                        if (object.filterBySuspectedStaffs != null)
                            message.filterBySuspectedStaffs = Boolean(object.filterBySuspectedStaffs);
                        if (object.minStaffClusterSize != null)
                            message.minStaffClusterSize = object.minStaffClusterSize | 0;
                        if (object.prefilterByDetectStaticObjects != null)
                            message.prefilterByDetectStaticObjects = Boolean(object.prefilterByDetectStaticObjects);
                        if (object.prefilterByDetectStaticObjectsMinNumBoundingBox != null)
                            message.prefilterByDetectStaticObjectsMinNumBoundingBox = object.prefilterByDetectStaticObjectsMinNumBoundingBox | 0;
                        if (object.filterByEntranceMetadataAppearances != null)
                            message.filterByEntranceMetadataAppearances = Boolean(object.filterByEntranceMetadataAppearances);
                        if (object.maxDurationInSeconds != null)
                            message.maxDurationInSeconds = object.maxDurationInSeconds | 0;
                        if (object.minStaffClusterDurationInSeconds != null)
                            message.minStaffClusterDurationInSeconds = object.minStaffClusterDurationInSeconds | 0;
                        if (object.removePeopleAtStaffSection != null)
                            message.removePeopleAtStaffSection = Boolean(object.removePeopleAtStaffSection);
                        if (object.useStdDerivedFloorDistanceToFilter != null)
                            message.useStdDerivedFloorDistanceToFilter = Boolean(object.useStdDerivedFloorDistanceToFilter);
                        if (object.skipStdDerivedFloorDistanceToFilter != null)
                            message.skipStdDerivedFloorDistanceToFilter = Boolean(object.skipStdDerivedFloorDistanceToFilter);
                        if (object.skipStdDerivedCameraDistanceToFilter != null)
                            message.skipStdDerivedCameraDistanceToFilter = Boolean(object.skipStdDerivedCameraDistanceToFilter);
                        if (object.removePeopleStartingNotFromEntrance != null)
                            message.removePeopleStartingNotFromEntrance = Boolean(object.removePeopleStartingNotFromEntrance);
                        if (object.staticObjectFilterConfig != null) {
                            if (typeof object.staticObjectFilterConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.OutlierFilteringConfig.staticObjectFilterConfig: object expected");
                            message.staticObjectFilterConfig = $root.palexy.streaming.v1.StaticObjectFilteringConfig.fromObject(object.staticObjectFilterConfig);
                        }
                        if (object.minAvgValidBbProb != null)
                            message.minAvgValidBbProb = Number(object.minAvgValidBbProb);
                        if (object.skipRemoveClustersWithLowAvgValidBbsProb != null)
                            message.skipRemoveClustersWithLowAvgValidBbsProb = Boolean(object.skipRemoveClustersWithLowAvgValidBbsProb);
                        if (object.maxClusterCamerasToRemovePeopleAtStaffSections != null)
                            message.maxClusterCamerasToRemovePeopleAtStaffSections = object.maxClusterCamerasToRemovePeopleAtStaffSections | 0;
                        if (object.maxItemsAtStaffSections != null)
                            message.maxItemsAtStaffSections = object.maxItemsAtStaffSections | 0;
                        if (object.suspectedStaffFeatureDistanceThreshold != null)
                            message.suspectedStaffFeatureDistanceThreshold = Number(object.suspectedStaffFeatureDistanceThreshold);
                        if (object.suspectedStaffThresAdjustByDensityConfig != null) {
                            if (typeof object.suspectedStaffThresAdjustByDensityConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.OutlierFilteringConfig.suspectedStaffThresAdjustByDensityConfig: object expected");
                            message.suspectedStaffThresAdjustByDensityConfig = $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.fromObject(object.suspectedStaffThresAdjustByDensityConfig);
                        }
                        if (object.maxGapToAddDuration != null)
                            message.maxGapToAddDuration = object.maxGapToAddDuration | 0;
                        if (object.keepClusterWithConfidentBbProb != null)
                            message.keepClusterWithConfidentBbProb = Boolean(object.keepClusterWithConfidentBbProb);
                        if (object.skipFilterByNumSecondsPerBb != null)
                            message.skipFilterByNumSecondsPerBb = Boolean(object.skipFilterByNumSecondsPerBb);
                        if (object.skipRemoveShortStayWhenMerge != null)
                            message.skipRemoveShortStayWhenMerge = Boolean(object.skipRemoveShortStayWhenMerge);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an OutlierFilteringConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @static
                     * @param {palexy.streaming.v1.OutlierFilteringConfig} message OutlierFilteringConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    OutlierFilteringConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minDurationInSeconds = 0;
                            object.minBb = 0;
                            object.filterByEntranceCameras = false;
                            object.numEntranceCameras = 0;
                            object.filterBySuspectedStaffs = false;
                            object.minStaffClusterSize = 0;
                            object.prefilterByDetectStaticObjects = false;
                            object.prefilterByDetectStaticObjectsMinNumBoundingBox = 0;
                            object.filterByEntranceMetadataAppearances = false;
                            object.maxDurationInSeconds = 0;
                            object.minStaffClusterDurationInSeconds = 0;
                            object.removePeopleAtStaffSection = false;
                            object.useStdDerivedFloorDistanceToFilter = false;
                            object.skipStdDerivedFloorDistanceToFilter = false;
                            object.skipStdDerivedCameraDistanceToFilter = false;
                            object.removePeopleStartingNotFromEntrance = false;
                            object.staticObjectFilterConfig = null;
                            object.minAvgValidBbProb = 0;
                            object.skipRemoveClustersWithLowAvgValidBbsProb = false;
                            object.maxClusterCamerasToRemovePeopleAtStaffSections = 0;
                            object.maxItemsAtStaffSections = 0;
                            object.suspectedStaffFeatureDistanceThreshold = 0;
                            object.suspectedStaffThresAdjustByDensityConfig = null;
                            object.maxGapToAddDuration = 0;
                            object.keepClusterWithConfidentBbProb = false;
                            object.skipFilterByNumSecondsPerBb = false;
                            object.skipRemoveShortStayWhenMerge = false;
                        }
                        if (message.minDurationInSeconds != null && message.hasOwnProperty("minDurationInSeconds"))
                            object.minDurationInSeconds = message.minDurationInSeconds;
                        if (message.minBb != null && message.hasOwnProperty("minBb"))
                            object.minBb = message.minBb;
                        if (message.filterByEntranceCameras != null && message.hasOwnProperty("filterByEntranceCameras"))
                            object.filterByEntranceCameras = message.filterByEntranceCameras;
                        if (message.numEntranceCameras != null && message.hasOwnProperty("numEntranceCameras"))
                            object.numEntranceCameras = message.numEntranceCameras;
                        if (message.filterBySuspectedStaffs != null && message.hasOwnProperty("filterBySuspectedStaffs"))
                            object.filterBySuspectedStaffs = message.filterBySuspectedStaffs;
                        if (message.minStaffClusterSize != null && message.hasOwnProperty("minStaffClusterSize"))
                            object.minStaffClusterSize = message.minStaffClusterSize;
                        if (message.prefilterByDetectStaticObjects != null && message.hasOwnProperty("prefilterByDetectStaticObjects"))
                            object.prefilterByDetectStaticObjects = message.prefilterByDetectStaticObjects;
                        if (message.prefilterByDetectStaticObjectsMinNumBoundingBox != null && message.hasOwnProperty("prefilterByDetectStaticObjectsMinNumBoundingBox"))
                            object.prefilterByDetectStaticObjectsMinNumBoundingBox = message.prefilterByDetectStaticObjectsMinNumBoundingBox;
                        if (message.filterByEntranceMetadataAppearances != null && message.hasOwnProperty("filterByEntranceMetadataAppearances"))
                            object.filterByEntranceMetadataAppearances = message.filterByEntranceMetadataAppearances;
                        if (message.maxDurationInSeconds != null && message.hasOwnProperty("maxDurationInSeconds"))
                            object.maxDurationInSeconds = message.maxDurationInSeconds;
                        if (message.minStaffClusterDurationInSeconds != null && message.hasOwnProperty("minStaffClusterDurationInSeconds"))
                            object.minStaffClusterDurationInSeconds = message.minStaffClusterDurationInSeconds;
                        if (message.removePeopleAtStaffSection != null && message.hasOwnProperty("removePeopleAtStaffSection"))
                            object.removePeopleAtStaffSection = message.removePeopleAtStaffSection;
                        if (message.useStdDerivedFloorDistanceToFilter != null && message.hasOwnProperty("useStdDerivedFloorDistanceToFilter"))
                            object.useStdDerivedFloorDistanceToFilter = message.useStdDerivedFloorDistanceToFilter;
                        if (message.skipStdDerivedFloorDistanceToFilter != null && message.hasOwnProperty("skipStdDerivedFloorDistanceToFilter"))
                            object.skipStdDerivedFloorDistanceToFilter = message.skipStdDerivedFloorDistanceToFilter;
                        if (message.skipStdDerivedCameraDistanceToFilter != null && message.hasOwnProperty("skipStdDerivedCameraDistanceToFilter"))
                            object.skipStdDerivedCameraDistanceToFilter = message.skipStdDerivedCameraDistanceToFilter;
                        if (message.removePeopleStartingNotFromEntrance != null && message.hasOwnProperty("removePeopleStartingNotFromEntrance"))
                            object.removePeopleStartingNotFromEntrance = message.removePeopleStartingNotFromEntrance;
                        if (message.staticObjectFilterConfig != null && message.hasOwnProperty("staticObjectFilterConfig"))
                            object.staticObjectFilterConfig = $root.palexy.streaming.v1.StaticObjectFilteringConfig.toObject(message.staticObjectFilterConfig, options);
                        if (message.minAvgValidBbProb != null && message.hasOwnProperty("minAvgValidBbProb"))
                            object.minAvgValidBbProb = options.json && !isFinite(message.minAvgValidBbProb) ? String(message.minAvgValidBbProb) : message.minAvgValidBbProb;
                        if (message.skipRemoveClustersWithLowAvgValidBbsProb != null && message.hasOwnProperty("skipRemoveClustersWithLowAvgValidBbsProb"))
                            object.skipRemoveClustersWithLowAvgValidBbsProb = message.skipRemoveClustersWithLowAvgValidBbsProb;
                        if (message.maxClusterCamerasToRemovePeopleAtStaffSections != null && message.hasOwnProperty("maxClusterCamerasToRemovePeopleAtStaffSections"))
                            object.maxClusterCamerasToRemovePeopleAtStaffSections = message.maxClusterCamerasToRemovePeopleAtStaffSections;
                        if (message.maxItemsAtStaffSections != null && message.hasOwnProperty("maxItemsAtStaffSections"))
                            object.maxItemsAtStaffSections = message.maxItemsAtStaffSections;
                        if (message.suspectedStaffFeatureDistanceThreshold != null && message.hasOwnProperty("suspectedStaffFeatureDistanceThreshold"))
                            object.suspectedStaffFeatureDistanceThreshold = options.json && !isFinite(message.suspectedStaffFeatureDistanceThreshold) ? String(message.suspectedStaffFeatureDistanceThreshold) : message.suspectedStaffFeatureDistanceThreshold;
                        if (message.suspectedStaffThresAdjustByDensityConfig != null && message.hasOwnProperty("suspectedStaffThresAdjustByDensityConfig"))
                            object.suspectedStaffThresAdjustByDensityConfig = $root.palexy.streaming.v1.SuspectedStaffThresAdjustByDensityConfig.toObject(message.suspectedStaffThresAdjustByDensityConfig, options);
                        if (message.maxGapToAddDuration != null && message.hasOwnProperty("maxGapToAddDuration"))
                            object.maxGapToAddDuration = message.maxGapToAddDuration;
                        if (message.keepClusterWithConfidentBbProb != null && message.hasOwnProperty("keepClusterWithConfidentBbProb"))
                            object.keepClusterWithConfidentBbProb = message.keepClusterWithConfidentBbProb;
                        if (message.skipFilterByNumSecondsPerBb != null && message.hasOwnProperty("skipFilterByNumSecondsPerBb"))
                            object.skipFilterByNumSecondsPerBb = message.skipFilterByNumSecondsPerBb;
                        if (message.skipRemoveShortStayWhenMerge != null && message.hasOwnProperty("skipRemoveShortStayWhenMerge"))
                            object.skipRemoveShortStayWhenMerge = message.skipRemoveShortStayWhenMerge;
                        return object;
                    };
    
                    /**
                     * Converts this OutlierFilteringConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.OutlierFilteringConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    OutlierFilteringConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return OutlierFilteringConfig;
                })();
    
                /**
                 * SystemTypeName enum.
                 * @name palexy.streaming.v1.SystemTypeName
                 * @enum {number}
                 * @property {number} UNKNOWN=0 UNKNOWN value
                 * @property {number} LYING=1 LYING value
                 * @property {number} ENTRANCE=2 ENTRANCE value
                 * @property {number} SUPERMARKET_ENTRANCE=3 SUPERMARKET_ENTRANCE value
                 * @property {number} STAFF=4 STAFF value
                 * @property {number} CASHIER=5 CASHIER value
                 * @property {number} CHANGING_ROOM=6 CHANGING_ROOM value
                 * @property {number} EXCLUDE=7 EXCLUDE value
                 * @property {number} ONLY_INCLUDE=8 ONLY_INCLUDE value
                 * @property {number} TRANSACTION=9 TRANSACTION value
                 * @property {number} VISITOR_WAITING_AREA=10 VISITOR_WAITING_AREA value
                 * @property {number} VISITOR_CHANGING_AREA=11 VISITOR_CHANGING_AREA value
                 * @property {number} VISITOR_MUST_APPEAR=12 VISITOR_MUST_APPEAR value
                 * @property {number} KEEP_TRACKLET_AREA=13 KEEP_TRACKLET_AREA value
                 * @property {number} SECTION_TESTING_AREA=14 SECTION_TESTING_AREA value
                 * @property {number} EXCLUDE_INTERACTION=15 EXCLUDE_INTERACTION value
                 * @property {number} PASS_BY_AREA=16 PASS_BY_AREA value
                 * @property {number} REMOVE_TRACKLET_AREA=17 REMOVE_TRACKLET_AREA value
                 * @property {number} WIDE_SPACE_ENTRANCE=18 WIDE_SPACE_ENTRANCE value
                 * @property {number} MALL_ENTRANCE=19 MALL_ENTRANCE value
                 * @property {number} REMOVE_VISITOR_STARTING_AREA=20 REMOVE_VISITOR_STARTING_AREA value
                 * @property {number} REMOVE_VISITOR_APPEAR_DISAPPEAR_AREA=21 REMOVE_VISITOR_APPEAR_DISAPPEAR_AREA value
                 * @property {number} HS_TAG=22 HS_TAG value
                 * @property {number} STAFF_REQUIRED_AREA=23 STAFF_REQUIRED_AREA value
                 * @property {number} SPECIAL_AREA=24 SPECIAL_AREA value
                 * @property {number} MUST_PASS=25 MUST_PASS value
                 * @property {number} ENTRANCE_ANCHOR=26 ENTRANCE_ANCHOR value
                 * @property {number} REMOVE_SHORT_STAY_VISITOR_AREA=27 REMOVE_SHORT_STAY_VISITOR_AREA value
                 * @property {number} VISITOR_INTEREST_AREA=28 VISITOR_INTEREST_AREA value
                 * @property {number} EXPECT_INTERACTION_AREA=29 EXPECT_INTERACTION_AREA value
                 * @property {number} IMAGE_BASED_EVENT=30 IMAGE_BASED_EVENT value
                 */
                v1.SystemTypeName = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN"] = 0;
                    values[valuesById[1] = "LYING"] = 1;
                    values[valuesById[2] = "ENTRANCE"] = 2;
                    values[valuesById[3] = "SUPERMARKET_ENTRANCE"] = 3;
                    values[valuesById[4] = "STAFF"] = 4;
                    values[valuesById[5] = "CASHIER"] = 5;
                    values[valuesById[6] = "CHANGING_ROOM"] = 6;
                    values[valuesById[7] = "EXCLUDE"] = 7;
                    values[valuesById[8] = "ONLY_INCLUDE"] = 8;
                    values[valuesById[9] = "TRANSACTION"] = 9;
                    values[valuesById[10] = "VISITOR_WAITING_AREA"] = 10;
                    values[valuesById[11] = "VISITOR_CHANGING_AREA"] = 11;
                    values[valuesById[12] = "VISITOR_MUST_APPEAR"] = 12;
                    values[valuesById[13] = "KEEP_TRACKLET_AREA"] = 13;
                    values[valuesById[14] = "SECTION_TESTING_AREA"] = 14;
                    values[valuesById[15] = "EXCLUDE_INTERACTION"] = 15;
                    values[valuesById[16] = "PASS_BY_AREA"] = 16;
                    values[valuesById[17] = "REMOVE_TRACKLET_AREA"] = 17;
                    values[valuesById[18] = "WIDE_SPACE_ENTRANCE"] = 18;
                    values[valuesById[19] = "MALL_ENTRANCE"] = 19;
                    values[valuesById[20] = "REMOVE_VISITOR_STARTING_AREA"] = 20;
                    values[valuesById[21] = "REMOVE_VISITOR_APPEAR_DISAPPEAR_AREA"] = 21;
                    values[valuesById[22] = "HS_TAG"] = 22;
                    values[valuesById[23] = "STAFF_REQUIRED_AREA"] = 23;
                    values[valuesById[24] = "SPECIAL_AREA"] = 24;
                    values[valuesById[25] = "MUST_PASS"] = 25;
                    values[valuesById[26] = "ENTRANCE_ANCHOR"] = 26;
                    values[valuesById[27] = "REMOVE_SHORT_STAY_VISITOR_AREA"] = 27;
                    values[valuesById[28] = "VISITOR_INTEREST_AREA"] = 28;
                    values[valuesById[29] = "EXPECT_INTERACTION_AREA"] = 29;
                    values[valuesById[30] = "IMAGE_BASED_EVENT"] = 30;
                    return values;
                })();
    
                /**
                 * UserTypeName enum.
                 * @name palexy.streaming.v1.UserTypeName
                 * @enum {number}
                 * @property {number} UNKNOWN_USER_TYPE=0 UNKNOWN_USER_TYPE value
                 * @property {number} SECTION=1 SECTION value
                 * @property {number} QUEUE=2 QUEUE value
                 * @property {number} FNB_QUEUE=3 FNB_QUEUE value
                 */
                v1.UserTypeName = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_USER_TYPE"] = 0;
                    values[valuesById[1] = "SECTION"] = 1;
                    values[valuesById[2] = "QUEUE"] = 2;
                    values[valuesById[3] = "FNB_QUEUE"] = 3;
                    return values;
                })();
    
                v1.CameraSectionService = (function() {
    
                    /**
                     * Constructs a new CameraSectionService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraSectionService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CameraSectionService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CameraSectionService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CameraSectionService;
    
                    /**
                     * Creates new CameraSectionService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CameraSectionService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CameraSectionService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraSectionService#createSystemCameraSectionVersion}.
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @typedef CreateSystemCameraSectionVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CameraSectionVersion} [response] CameraSectionVersion
                     */
    
                    /**
                     * Calls CreateSystemCameraSectionVersion.
                     * @function createSystemCameraSectionVersion
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest} request CreateSystemCameraSectionVersionRequest message or plain object
                     * @param {palexy.streaming.v1.CameraSectionService.CreateSystemCameraSectionVersionCallback} callback Node-style callback called with the error, if any, and CameraSectionVersion
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraSectionService.prototype.createSystemCameraSectionVersion = function createSystemCameraSectionVersion(request, callback) {
                        return this.rpcCall(createSystemCameraSectionVersion, $root.palexy.streaming.v1.CreateSystemCameraSectionVersionRequest, $root.palexy.streaming.v1.CameraSectionVersion, request, callback);
                    }, "name", { value: "CreateSystemCameraSectionVersion" });
    
                    /**
                     * Calls CreateSystemCameraSectionVersion.
                     * @function createSystemCameraSectionVersion
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest} request CreateSystemCameraSectionVersionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CameraSectionVersion>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraSectionService#listSystemCameraSectionVersion}.
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @typedef ListSystemCameraSectionVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCameraSectionVersionResponse} [response] ListCameraSectionVersionResponse
                     */
    
                    /**
                     * Calls ListSystemCameraSectionVersion.
                     * @function listSystemCameraSectionVersion
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest} request ListSystemCameraSectionVersionRequest message or plain object
                     * @param {palexy.streaming.v1.CameraSectionService.ListSystemCameraSectionVersionCallback} callback Node-style callback called with the error, if any, and ListCameraSectionVersionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraSectionService.prototype.listSystemCameraSectionVersion = function listSystemCameraSectionVersion(request, callback) {
                        return this.rpcCall(listSystemCameraSectionVersion, $root.palexy.streaming.v1.ListSystemCameraSectionVersionRequest, $root.palexy.streaming.v1.ListCameraSectionVersionResponse, request, callback);
                    }, "name", { value: "ListSystemCameraSectionVersion" });
    
                    /**
                     * Calls ListSystemCameraSectionVersion.
                     * @function listSystemCameraSectionVersion
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest} request ListSystemCameraSectionVersionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCameraSectionVersionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraSectionService#listSystemCameraSections}.
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @typedef ListSystemCameraSectionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCameraSectionsResponse} [response] ListCameraSectionsResponse
                     */
    
                    /**
                     * Calls ListSystemCameraSections.
                     * @function listSystemCameraSections
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest} request ListSystemCameraSectionsRequest message or plain object
                     * @param {palexy.streaming.v1.CameraSectionService.ListSystemCameraSectionsCallback} callback Node-style callback called with the error, if any, and ListCameraSectionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraSectionService.prototype.listSystemCameraSections = function listSystemCameraSections(request, callback) {
                        return this.rpcCall(listSystemCameraSections, $root.palexy.streaming.v1.ListSystemCameraSectionsRequest, $root.palexy.streaming.v1.ListCameraSectionsResponse, request, callback);
                    }, "name", { value: "ListSystemCameraSections" });
    
                    /**
                     * Calls ListSystemCameraSections.
                     * @function listSystemCameraSections
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest} request ListSystemCameraSectionsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCameraSectionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraSectionService#listCameraSections}.
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @typedef ListCameraSectionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCameraSectionsResponse} [response] ListCameraSectionsResponse
                     */
    
                    /**
                     * Calls ListCameraSections.
                     * @function listCameraSections
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest} request ListCameraSectionsRequest message or plain object
                     * @param {palexy.streaming.v1.CameraSectionService.ListCameraSectionsCallback} callback Node-style callback called with the error, if any, and ListCameraSectionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraSectionService.prototype.listCameraSections = function listCameraSections(request, callback) {
                        return this.rpcCall(listCameraSections, $root.palexy.streaming.v1.ListCameraSectionsRequest, $root.palexy.streaming.v1.ListCameraSectionsResponse, request, callback);
                    }, "name", { value: "ListCameraSections" });
    
                    /**
                     * Calls ListCameraSections.
                     * @function listCameraSections
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest} request ListCameraSectionsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCameraSectionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraSectionService#listCameraSectionsOfLayout}.
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @typedef ListCameraSectionsOfLayoutCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} [response] ListCameraSectionsOfLayoutResponse
                     */
    
                    /**
                     * Calls ListCameraSectionsOfLayout.
                     * @function listCameraSectionsOfLayout
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest} request ListCameraSectionsOfLayoutRequest message or plain object
                     * @param {palexy.streaming.v1.CameraSectionService.ListCameraSectionsOfLayoutCallback} callback Node-style callback called with the error, if any, and ListCameraSectionsOfLayoutResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraSectionService.prototype.listCameraSectionsOfLayout = function listCameraSectionsOfLayout(request, callback) {
                        return this.rpcCall(listCameraSectionsOfLayout, $root.palexy.streaming.v1.ListCameraSectionsOfLayoutRequest, $root.palexy.streaming.v1.ListCameraSectionsOfLayoutResponse, request, callback);
                    }, "name", { value: "ListCameraSectionsOfLayout" });
    
                    /**
                     * Calls ListCameraSectionsOfLayout.
                     * @function listCameraSectionsOfLayout
                     * @memberof palexy.streaming.v1.CameraSectionService
                     * @instance
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest} request ListCameraSectionsOfLayoutRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCameraSectionsOfLayoutResponse>} Promise
                     * @variation 2
                     */
    
                    return CameraSectionService;
                })();
    
                v1.CreateSystemCameraSectionVersionRequest = (function() {
    
                    /**
                     * Properties of a CreateSystemCameraSectionVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateSystemCameraSectionVersionRequest
                     * @property {number|null} [cameraId] CreateSystemCameraSectionVersionRequest cameraId
                     * @property {google.protobuf.ITimestamp|null} [appliedTime] CreateSystemCameraSectionVersionRequest appliedTime
                     */
    
                    /**
                     * Constructs a new CreateSystemCameraSectionVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateSystemCameraSectionVersionRequest.
                     * @implements ICreateSystemCameraSectionVersionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest=} [properties] Properties to set
                     */
                    function CreateSystemCameraSectionVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateSystemCameraSectionVersionRequest cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @instance
                     */
                    CreateSystemCameraSectionVersionRequest.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateSystemCameraSectionVersionRequest appliedTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} appliedTime
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @instance
                     */
                    CreateSystemCameraSectionVersionRequest.prototype.appliedTime = null;
    
                    /**
                     * Creates a new CreateSystemCameraSectionVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateSystemCameraSectionVersionRequest} CreateSystemCameraSectionVersionRequest instance
                     */
                    CreateSystemCameraSectionVersionRequest.create = function create(properties) {
                        return new CreateSystemCameraSectionVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateSystemCameraSectionVersionRequest message. Does not implicitly {@link palexy.streaming.v1.CreateSystemCameraSectionVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest} message CreateSystemCameraSectionVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSystemCameraSectionVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraId);
                        if (message.appliedTime != null && Object.hasOwnProperty.call(message, "appliedTime"))
                            $root.google.protobuf.Timestamp.encode(message.appliedTime, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateSystemCameraSectionVersionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateSystemCameraSectionVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSystemCameraSectionVersionRequest} message CreateSystemCameraSectionVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSystemCameraSectionVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateSystemCameraSectionVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateSystemCameraSectionVersionRequest} CreateSystemCameraSectionVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSystemCameraSectionVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateSystemCameraSectionVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.int64();
                                break;
                            case 2:
                                message.appliedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateSystemCameraSectionVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateSystemCameraSectionVersionRequest} CreateSystemCameraSectionVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSystemCameraSectionVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateSystemCameraSectionVersionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateSystemCameraSectionVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.appliedTime != null && message.hasOwnProperty("appliedTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.appliedTime);
                            if (error)
                                return "appliedTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateSystemCameraSectionVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateSystemCameraSectionVersionRequest} CreateSystemCameraSectionVersionRequest
                     */
                    CreateSystemCameraSectionVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateSystemCameraSectionVersionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateSystemCameraSectionVersionRequest();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.appliedTime != null) {
                            if (typeof object.appliedTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateSystemCameraSectionVersionRequest.appliedTime: object expected");
                            message.appliedTime = $root.google.protobuf.Timestamp.fromObject(object.appliedTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateSystemCameraSectionVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateSystemCameraSectionVersionRequest} message CreateSystemCameraSectionVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateSystemCameraSectionVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            object.appliedTime = null;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.appliedTime != null && message.hasOwnProperty("appliedTime"))
                            object.appliedTime = $root.google.protobuf.Timestamp.toObject(message.appliedTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateSystemCameraSectionVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateSystemCameraSectionVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateSystemCameraSectionVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateSystemCameraSectionVersionRequest;
                })();
    
                v1.CameraSectionVersion = (function() {
    
                    /**
                     * Properties of a CameraSectionVersion.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraSectionVersion
                     * @property {number|null} [id] CameraSectionVersion id
                     * @property {number|null} [cameraId] CameraSectionVersion cameraId
                     * @property {number|null} [photoId] CameraSectionVersion photoId
                     * @property {google.protobuf.ITimestamp|null} [createTime] CameraSectionVersion createTime
                     * @property {google.protobuf.ITimestamp|null} [appliedTime] CameraSectionVersion appliedTime
                     * @property {palexy.streaming.v1.ICameraSectionVersionData|null} [data] CameraSectionVersion data
                     */
    
                    /**
                     * Constructs a new CameraSectionVersion.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraSectionVersion.
                     * @implements ICameraSectionVersion
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraSectionVersion=} [properties] Properties to set
                     */
                    function CameraSectionVersion(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraSectionVersion id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionVersion cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionVersion photoId.
                     * @member {number} photoId
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.photoId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionVersion createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.createTime = null;
    
                    /**
                     * CameraSectionVersion appliedTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} appliedTime
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.appliedTime = null;
    
                    /**
                     * CameraSectionVersion data.
                     * @member {palexy.streaming.v1.ICameraSectionVersionData|null|undefined} data
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     */
                    CameraSectionVersion.prototype.data = null;
    
                    /**
                     * Creates a new CameraSectionVersion instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersion=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraSectionVersion} CameraSectionVersion instance
                     */
                    CameraSectionVersion.create = function create(properties) {
                        return new CameraSectionVersion(properties);
                    };
    
                    /**
                     * Encodes the specified CameraSectionVersion message. Does not implicitly {@link palexy.streaming.v1.CameraSectionVersion.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersion} message CameraSectionVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionVersion.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.cameraId);
                        if (message.photoId != null && Object.hasOwnProperty.call(message, "photoId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.photoId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.appliedTime != null && Object.hasOwnProperty.call(message, "appliedTime"))
                            $root.google.protobuf.Timestamp.encode(message.appliedTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                            $root.palexy.streaming.v1.CameraSectionVersionData.encode(message.data, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraSectionVersion message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraSectionVersion.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersion} message CameraSectionVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionVersion.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraSectionVersion message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraSectionVersion} CameraSectionVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionVersion.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraSectionVersion();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.int64();
                                break;
                            case 3:
                                message.photoId = reader.int64();
                                break;
                            case 4:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.appliedTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.data = $root.palexy.streaming.v1.CameraSectionVersionData.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraSectionVersion message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraSectionVersion} CameraSectionVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionVersion.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraSectionVersion message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraSectionVersion.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (!$util.isInteger(message.photoId) && !(message.photoId && $util.isInteger(message.photoId.low) && $util.isInteger(message.photoId.high)))
                                return "photoId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.appliedTime != null && message.hasOwnProperty("appliedTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.appliedTime);
                            if (error)
                                return "appliedTime." + error;
                        }
                        if (message.data != null && message.hasOwnProperty("data")) {
                            var error = $root.palexy.streaming.v1.CameraSectionVersionData.verify(message.data);
                            if (error)
                                return "data." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CameraSectionVersion message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraSectionVersion} CameraSectionVersion
                     */
                    CameraSectionVersion.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraSectionVersion)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraSectionVersion();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.photoId != null)
                            if ($util.Long)
                                (message.photoId = $util.Long.fromValue(object.photoId)).unsigned = false;
                            else if (typeof object.photoId === "string")
                                message.photoId = parseInt(object.photoId, 10);
                            else if (typeof object.photoId === "number")
                                message.photoId = object.photoId;
                            else if (typeof object.photoId === "object")
                                message.photoId = new $util.LongBits(object.photoId.low >>> 0, object.photoId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSectionVersion.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.appliedTime != null) {
                            if (typeof object.appliedTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSectionVersion.appliedTime: object expected");
                            message.appliedTime = $root.google.protobuf.Timestamp.fromObject(object.appliedTime);
                        }
                        if (object.data != null) {
                            if (typeof object.data !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSectionVersion.data: object expected");
                            message.data = $root.palexy.streaming.v1.CameraSectionVersionData.fromObject(object.data);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraSectionVersion message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @static
                     * @param {palexy.streaming.v1.CameraSectionVersion} message CameraSectionVersion
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraSectionVersion.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.photoId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.photoId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.appliedTime = null;
                            object.data = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (typeof message.photoId === "number")
                                object.photoId = options.longs === String ? String(message.photoId) : message.photoId;
                            else
                                object.photoId = options.longs === String ? $util.Long.prototype.toString.call(message.photoId) : options.longs === Number ? new $util.LongBits(message.photoId.low >>> 0, message.photoId.high >>> 0).toNumber() : message.photoId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.appliedTime != null && message.hasOwnProperty("appliedTime"))
                            object.appliedTime = $root.google.protobuf.Timestamp.toObject(message.appliedTime, options);
                        if (message.data != null && message.hasOwnProperty("data"))
                            object.data = $root.palexy.streaming.v1.CameraSectionVersionData.toObject(message.data, options);
                        return object;
                    };
    
                    /**
                     * Converts this CameraSectionVersion to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraSectionVersion
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraSectionVersion.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CameraSectionVersion;
                })();
    
                v1.ListSystemCameraSectionVersionRequest = (function() {
    
                    /**
                     * Properties of a ListSystemCameraSectionVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListSystemCameraSectionVersionRequest
                     * @property {number|null} [cameraId] ListSystemCameraSectionVersionRequest cameraId
                     * @property {google.protobuf.IFieldMask|null} [getFields] ListSystemCameraSectionVersionRequest getFields
                     */
    
                    /**
                     * Constructs a new ListSystemCameraSectionVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSystemCameraSectionVersionRequest.
                     * @implements IListSystemCameraSectionVersionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest=} [properties] Properties to set
                     */
                    function ListSystemCameraSectionVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSystemCameraSectionVersionRequest cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @instance
                     */
                    ListSystemCameraSectionVersionRequest.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListSystemCameraSectionVersionRequest getFields.
                     * @member {google.protobuf.IFieldMask|null|undefined} getFields
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @instance
                     */
                    ListSystemCameraSectionVersionRequest.prototype.getFields = null;
    
                    /**
                     * Creates a new ListSystemCameraSectionVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionVersionRequest} ListSystemCameraSectionVersionRequest instance
                     */
                    ListSystemCameraSectionVersionRequest.create = function create(properties) {
                        return new ListSystemCameraSectionVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListSystemCameraSectionVersionRequest message. Does not implicitly {@link palexy.streaming.v1.ListSystemCameraSectionVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest} message ListSystemCameraSectionVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSystemCameraSectionVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraId);
                        if (message.getFields != null && Object.hasOwnProperty.call(message, "getFields"))
                            $root.google.protobuf.FieldMask.encode(message.getFields, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSystemCameraSectionVersionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSystemCameraSectionVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionVersionRequest} message ListSystemCameraSectionVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSystemCameraSectionVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSystemCameraSectionVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionVersionRequest} ListSystemCameraSectionVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSystemCameraSectionVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSystemCameraSectionVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.int64();
                                break;
                            case 2:
                                message.getFields = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSystemCameraSectionVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionVersionRequest} ListSystemCameraSectionVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSystemCameraSectionVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSystemCameraSectionVersionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSystemCameraSectionVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.getFields != null && message.hasOwnProperty("getFields")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.getFields);
                            if (error)
                                return "getFields." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListSystemCameraSectionVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionVersionRequest} ListSystemCameraSectionVersionRequest
                     */
                    ListSystemCameraSectionVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSystemCameraSectionVersionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSystemCameraSectionVersionRequest();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.getFields != null) {
                            if (typeof object.getFields !== "object")
                                throw TypeError(".palexy.streaming.v1.ListSystemCameraSectionVersionRequest.getFields: object expected");
                            message.getFields = $root.google.protobuf.FieldMask.fromObject(object.getFields);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSystemCameraSectionVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.ListSystemCameraSectionVersionRequest} message ListSystemCameraSectionVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSystemCameraSectionVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            object.getFields = null;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.getFields != null && message.hasOwnProperty("getFields"))
                            object.getFields = $root.google.protobuf.FieldMask.toObject(message.getFields, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListSystemCameraSectionVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSystemCameraSectionVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSystemCameraSectionVersionRequest;
                })();
    
                v1.ListCameraSectionVersionResponse = (function() {
    
                    /**
                     * Properties of a ListCameraSectionVersionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCameraSectionVersionResponse
                     * @property {Array.<palexy.streaming.v1.ICameraSectionVersion>|null} [version] ListCameraSectionVersionResponse version
                     */
    
                    /**
                     * Constructs a new ListCameraSectionVersionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCameraSectionVersionResponse.
                     * @implements IListCameraSectionVersionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCameraSectionVersionResponse=} [properties] Properties to set
                     */
                    function ListCameraSectionVersionResponse(properties) {
                        this.version = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCameraSectionVersionResponse version.
                     * @member {Array.<palexy.streaming.v1.ICameraSectionVersion>} version
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @instance
                     */
                    ListCameraSectionVersionResponse.prototype.version = $util.emptyArray;
    
                    /**
                     * Creates a new ListCameraSectionVersionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionVersionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCameraSectionVersionResponse} ListCameraSectionVersionResponse instance
                     */
                    ListCameraSectionVersionResponse.create = function create(properties) {
                        return new ListCameraSectionVersionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionVersionResponse message. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionVersionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionVersionResponse} message ListCameraSectionVersionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionVersionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.version != null && message.version.length)
                            for (var i = 0; i < message.version.length; ++i)
                                $root.palexy.streaming.v1.CameraSectionVersion.encode(message.version[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionVersionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionVersionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionVersionResponse} message ListCameraSectionVersionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionVersionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCameraSectionVersionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCameraSectionVersionResponse} ListCameraSectionVersionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionVersionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCameraSectionVersionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.version && message.version.length))
                                    message.version = [];
                                message.version.push($root.palexy.streaming.v1.CameraSectionVersion.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCameraSectionVersionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCameraSectionVersionResponse} ListCameraSectionVersionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionVersionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCameraSectionVersionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCameraSectionVersionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.version != null && message.hasOwnProperty("version")) {
                            if (!Array.isArray(message.version))
                                return "version: array expected";
                            for (var i = 0; i < message.version.length; ++i) {
                                var error = $root.palexy.streaming.v1.CameraSectionVersion.verify(message.version[i]);
                                if (error)
                                    return "version." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCameraSectionVersionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCameraSectionVersionResponse} ListCameraSectionVersionResponse
                     */
                    ListCameraSectionVersionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCameraSectionVersionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCameraSectionVersionResponse();
                        if (object.version) {
                            if (!Array.isArray(object.version))
                                throw TypeError(".palexy.streaming.v1.ListCameraSectionVersionResponse.version: array expected");
                            message.version = [];
                            for (var i = 0; i < object.version.length; ++i) {
                                if (typeof object.version[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCameraSectionVersionResponse.version: object expected");
                                message.version[i] = $root.palexy.streaming.v1.CameraSectionVersion.fromObject(object.version[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCameraSectionVersionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCameraSectionVersionResponse} message ListCameraSectionVersionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCameraSectionVersionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.version = [];
                        if (message.version && message.version.length) {
                            object.version = [];
                            for (var j = 0; j < message.version.length; ++j)
                                object.version[j] = $root.palexy.streaming.v1.CameraSectionVersion.toObject(message.version[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCameraSectionVersionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCameraSectionVersionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCameraSectionVersionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCameraSectionVersionResponse;
                })();
    
                v1.CameraSectionVersionData = (function() {
    
                    /**
                     * Properties of a CameraSectionVersionData.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraSectionVersionData
                     * @property {Array.<palexy.streaming.v1.ICameraSection>|null} [section] CameraSectionVersionData section
                     */
    
                    /**
                     * Constructs a new CameraSectionVersionData.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraSectionVersionData.
                     * @implements ICameraSectionVersionData
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraSectionVersionData=} [properties] Properties to set
                     */
                    function CameraSectionVersionData(properties) {
                        this.section = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraSectionVersionData section.
                     * @member {Array.<palexy.streaming.v1.ICameraSection>} section
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @instance
                     */
                    CameraSectionVersionData.prototype.section = $util.emptyArray;
    
                    /**
                     * Creates a new CameraSectionVersionData instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersionData=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraSectionVersionData} CameraSectionVersionData instance
                     */
                    CameraSectionVersionData.create = function create(properties) {
                        return new CameraSectionVersionData(properties);
                    };
    
                    /**
                     * Encodes the specified CameraSectionVersionData message. Does not implicitly {@link palexy.streaming.v1.CameraSectionVersionData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersionData} message CameraSectionVersionData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionVersionData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.section != null && message.section.length)
                            for (var i = 0; i < message.section.length; ++i)
                                $root.palexy.streaming.v1.CameraSection.encode(message.section[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraSectionVersionData message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraSectionVersionData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionVersionData} message CameraSectionVersionData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionVersionData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraSectionVersionData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraSectionVersionData} CameraSectionVersionData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionVersionData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraSectionVersionData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2:
                                if (!(message.section && message.section.length))
                                    message.section = [];
                                message.section.push($root.palexy.streaming.v1.CameraSection.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraSectionVersionData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraSectionVersionData} CameraSectionVersionData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionVersionData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraSectionVersionData message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraSectionVersionData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.section != null && message.hasOwnProperty("section")) {
                            if (!Array.isArray(message.section))
                                return "section: array expected";
                            for (var i = 0; i < message.section.length; ++i) {
                                var error = $root.palexy.streaming.v1.CameraSection.verify(message.section[i]);
                                if (error)
                                    return "section." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CameraSectionVersionData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraSectionVersionData} CameraSectionVersionData
                     */
                    CameraSectionVersionData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraSectionVersionData)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraSectionVersionData();
                        if (object.section) {
                            if (!Array.isArray(object.section))
                                throw TypeError(".palexy.streaming.v1.CameraSectionVersionData.section: array expected");
                            message.section = [];
                            for (var i = 0; i < object.section.length; ++i) {
                                if (typeof object.section[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CameraSectionVersionData.section: object expected");
                                message.section[i] = $root.palexy.streaming.v1.CameraSection.fromObject(object.section[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraSectionVersionData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @static
                     * @param {palexy.streaming.v1.CameraSectionVersionData} message CameraSectionVersionData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraSectionVersionData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.section = [];
                        if (message.section && message.section.length) {
                            object.section = [];
                            for (var j = 0; j < message.section.length; ++j)
                                object.section[j] = $root.palexy.streaming.v1.CameraSection.toObject(message.section[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CameraSectionVersionData to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraSectionVersionData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraSectionVersionData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CameraSectionVersionData;
                })();
    
                v1.CameraSection = (function() {
    
                    /**
                     * Properties of a CameraSection.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraSection
                     * @property {number|null} [id] CameraSection id
                     * @property {number|null} [photoId] CameraSection photoId
                     * @property {number|null} [cameraId] CameraSection cameraId
                     * @property {palexy.streaming.v1.IPolygon|null} [polygon] CameraSection polygon
                     * @property {number|null} [metadataTypeId] CameraSection metadataTypeId
                     * @property {number|null} [metadataValueId] CameraSection metadataValueId
                     * @property {number|null} [layoutId] CameraSection layoutId
                     * @property {google.protobuf.ITimestamp|null} [createTime] CameraSection createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] CameraSection lastUpdateTime
                     * @property {boolean|null} [isSystem] CameraSection isSystem
                     * @property {boolean|null} [useVisitorDirection] CameraSection useVisitorDirection
                     * @property {string|null} [metadataTypeSystemName] CameraSection metadataTypeSystemName
                     * @property {string|null} [metadataValueName] CameraSection metadataValueName
                     */
    
                    /**
                     * Constructs a new CameraSection.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraSection.
                     * @implements ICameraSection
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraSection=} [properties] Properties to set
                     */
                    function CameraSection(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraSection id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection photoId.
                     * @member {number} photoId
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.photoId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection polygon.
                     * @member {palexy.streaming.v1.IPolygon|null|undefined} polygon
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.polygon = null;
    
                    /**
                     * CameraSection metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection layoutId.
                     * @member {number} layoutId
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.layoutId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSection createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.createTime = null;
    
                    /**
                     * CameraSection lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.lastUpdateTime = null;
    
                    /**
                     * CameraSection isSystem.
                     * @member {boolean} isSystem
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.isSystem = false;
    
                    /**
                     * CameraSection useVisitorDirection.
                     * @member {boolean} useVisitorDirection
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.useVisitorDirection = false;
    
                    /**
                     * CameraSection metadataTypeSystemName.
                     * @member {string} metadataTypeSystemName
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.metadataTypeSystemName = "";
    
                    /**
                     * CameraSection metadataValueName.
                     * @member {string} metadataValueName
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     */
                    CameraSection.prototype.metadataValueName = "";
    
                    /**
                     * Creates a new CameraSection instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {palexy.streaming.v1.ICameraSection=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraSection} CameraSection instance
                     */
                    CameraSection.create = function create(properties) {
                        return new CameraSection(properties);
                    };
    
                    /**
                     * Encodes the specified CameraSection message. Does not implicitly {@link palexy.streaming.v1.CameraSection.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {palexy.streaming.v1.ICameraSection} message CameraSection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSection.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.photoId != null && Object.hasOwnProperty.call(message, "photoId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.photoId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.cameraId);
                        if (message.polygon != null && Object.hasOwnProperty.call(message, "polygon"))
                            $root.palexy.streaming.v1.Polygon.encode(message.polygon, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.metadataTypeId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.metadataValueId);
                        if (message.layoutId != null && Object.hasOwnProperty.call(message, "layoutId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.layoutId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.isSystem != null && Object.hasOwnProperty.call(message, "isSystem"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isSystem);
                        if (message.metadataTypeSystemName != null && Object.hasOwnProperty.call(message, "metadataTypeSystemName"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.metadataTypeSystemName);
                        if (message.metadataValueName != null && Object.hasOwnProperty.call(message, "metadataValueName"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.metadataValueName);
                        if (message.useVisitorDirection != null && Object.hasOwnProperty.call(message, "useVisitorDirection"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.useVisitorDirection);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraSection message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraSection.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {palexy.streaming.v1.ICameraSection} message CameraSection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSection.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraSection message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraSection} CameraSection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSection.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraSection();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.photoId = reader.int64();
                                break;
                            case 3:
                                message.cameraId = reader.int64();
                                break;
                            case 4:
                                message.polygon = $root.palexy.streaming.v1.Polygon.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.metadataTypeId = reader.int64();
                                break;
                            case 6:
                                message.metadataValueId = reader.int64();
                                break;
                            case 7:
                                message.layoutId = reader.int64();
                                break;
                            case 8:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.isSystem = reader.bool();
                                break;
                            case 13:
                                message.useVisitorDirection = reader.bool();
                                break;
                            case 11:
                                message.metadataTypeSystemName = reader.string();
                                break;
                            case 12:
                                message.metadataValueName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraSection message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraSection} CameraSection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSection.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraSection message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraSection.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (!$util.isInteger(message.photoId) && !(message.photoId && $util.isInteger(message.photoId.low) && $util.isInteger(message.photoId.high)))
                                return "photoId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.polygon != null && message.hasOwnProperty("polygon")) {
                            var error = $root.palexy.streaming.v1.Polygon.verify(message.polygon);
                            if (error)
                                return "polygon." + error;
                        }
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (!$util.isInteger(message.layoutId) && !(message.layoutId && $util.isInteger(message.layoutId.low) && $util.isInteger(message.layoutId.high)))
                                return "layoutId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            if (typeof message.isSystem !== "boolean")
                                return "isSystem: boolean expected";
                        if (message.useVisitorDirection != null && message.hasOwnProperty("useVisitorDirection"))
                            if (typeof message.useVisitorDirection !== "boolean")
                                return "useVisitorDirection: boolean expected";
                        if (message.metadataTypeSystemName != null && message.hasOwnProperty("metadataTypeSystemName"))
                            if (!$util.isString(message.metadataTypeSystemName))
                                return "metadataTypeSystemName: string expected";
                        if (message.metadataValueName != null && message.hasOwnProperty("metadataValueName"))
                            if (!$util.isString(message.metadataValueName))
                                return "metadataValueName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CameraSection message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraSection} CameraSection
                     */
                    CameraSection.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraSection)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraSection();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.photoId != null)
                            if ($util.Long)
                                (message.photoId = $util.Long.fromValue(object.photoId)).unsigned = false;
                            else if (typeof object.photoId === "string")
                                message.photoId = parseInt(object.photoId, 10);
                            else if (typeof object.photoId === "number")
                                message.photoId = object.photoId;
                            else if (typeof object.photoId === "object")
                                message.photoId = new $util.LongBits(object.photoId.low >>> 0, object.photoId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.polygon != null) {
                            if (typeof object.polygon !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSection.polygon: object expected");
                            message.polygon = $root.palexy.streaming.v1.Polygon.fromObject(object.polygon);
                        }
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.layoutId != null)
                            if ($util.Long)
                                (message.layoutId = $util.Long.fromValue(object.layoutId)).unsigned = false;
                            else if (typeof object.layoutId === "string")
                                message.layoutId = parseInt(object.layoutId, 10);
                            else if (typeof object.layoutId === "number")
                                message.layoutId = object.layoutId;
                            else if (typeof object.layoutId === "object")
                                message.layoutId = new $util.LongBits(object.layoutId.low >>> 0, object.layoutId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSection.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraSection.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        if (object.isSystem != null)
                            message.isSystem = Boolean(object.isSystem);
                        if (object.useVisitorDirection != null)
                            message.useVisitorDirection = Boolean(object.useVisitorDirection);
                        if (object.metadataTypeSystemName != null)
                            message.metadataTypeSystemName = String(object.metadataTypeSystemName);
                        if (object.metadataValueName != null)
                            message.metadataValueName = String(object.metadataValueName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraSection message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraSection
                     * @static
                     * @param {palexy.streaming.v1.CameraSection} message CameraSection
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraSection.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.photoId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.photoId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            object.polygon = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.layoutId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.layoutId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            object.isSystem = false;
                            object.metadataTypeSystemName = "";
                            object.metadataValueName = "";
                            object.useVisitorDirection = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (typeof message.photoId === "number")
                                object.photoId = options.longs === String ? String(message.photoId) : message.photoId;
                            else
                                object.photoId = options.longs === String ? $util.Long.prototype.toString.call(message.photoId) : options.longs === Number ? new $util.LongBits(message.photoId.low >>> 0, message.photoId.high >>> 0).toNumber() : message.photoId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.polygon != null && message.hasOwnProperty("polygon"))
                            object.polygon = $root.palexy.streaming.v1.Polygon.toObject(message.polygon, options);
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (typeof message.layoutId === "number")
                                object.layoutId = options.longs === String ? String(message.layoutId) : message.layoutId;
                            else
                                object.layoutId = options.longs === String ? $util.Long.prototype.toString.call(message.layoutId) : options.longs === Number ? new $util.LongBits(message.layoutId.low >>> 0, message.layoutId.high >>> 0).toNumber() : message.layoutId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            object.isSystem = message.isSystem;
                        if (message.metadataTypeSystemName != null && message.hasOwnProperty("metadataTypeSystemName"))
                            object.metadataTypeSystemName = message.metadataTypeSystemName;
                        if (message.metadataValueName != null && message.hasOwnProperty("metadataValueName"))
                            object.metadataValueName = message.metadataValueName;
                        if (message.useVisitorDirection != null && message.hasOwnProperty("useVisitorDirection"))
                            object.useVisitorDirection = message.useVisitorDirection;
                        return object;
                    };
    
                    /**
                     * Converts this CameraSection to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraSection
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraSection.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CameraSection;
                })();
    
                v1.CameraSectionFilter = (function() {
    
                    /**
                     * Properties of a CameraSectionFilter.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraSectionFilter
                     * @property {number|null} [metadataTypeId] CameraSectionFilter metadataTypeId
                     * @property {number|null} [metadataValueId] CameraSectionFilter metadataValueId
                     * @property {string|null} [versionDateTime] CameraSectionFilter versionDateTime
                     * @property {number|null} [versionId] CameraSectionFilter versionId
                     * @property {string|null} [dateId] CameraSectionFilter dateId
                     * @property {boolean|null} [isSystem] CameraSectionFilter isSystem
                     */
    
                    /**
                     * Constructs a new CameraSectionFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraSectionFilter.
                     * @implements ICameraSectionFilter
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraSectionFilter=} [properties] Properties to set
                     */
                    function CameraSectionFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraSectionFilter metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionFilter metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionFilter versionDateTime.
                     * @member {string} versionDateTime
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.versionDateTime = "";
    
                    /**
                     * CameraSectionFilter versionId.
                     * @member {number} versionId
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.versionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraSectionFilter dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.dateId = "";
    
                    /**
                     * CameraSectionFilter isSystem.
                     * @member {boolean} isSystem
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     */
                    CameraSectionFilter.prototype.isSystem = false;
    
                    /**
                     * Creates a new CameraSectionFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraSectionFilter} CameraSectionFilter instance
                     */
                    CameraSectionFilter.create = function create(properties) {
                        return new CameraSectionFilter(properties);
                    };
    
                    /**
                     * Encodes the specified CameraSectionFilter message. Does not implicitly {@link palexy.streaming.v1.CameraSectionFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionFilter} message CameraSectionFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataTypeId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.metadataValueId);
                        if (message.versionDateTime != null && Object.hasOwnProperty.call(message, "versionDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.versionDateTime);
                        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.versionId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.dateId);
                        if (message.isSystem != null && Object.hasOwnProperty.call(message, "isSystem"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isSystem);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraSectionFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraSectionFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {palexy.streaming.v1.ICameraSectionFilter} message CameraSectionFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraSectionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraSectionFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraSectionFilter} CameraSectionFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraSectionFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataTypeId = reader.int64();
                                break;
                            case 2:
                                message.metadataValueId = reader.int64();
                                break;
                            case 3:
                                message.versionDateTime = reader.string();
                                break;
                            case 4:
                                message.versionId = reader.int64();
                                break;
                            case 5:
                                message.dateId = reader.string();
                                break;
                            case 6:
                                message.isSystem = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraSectionFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraSectionFilter} CameraSectionFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraSectionFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraSectionFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraSectionFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.versionDateTime != null && message.hasOwnProperty("versionDateTime"))
                            if (!$util.isString(message.versionDateTime))
                                return "versionDateTime: string expected";
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (!$util.isInteger(message.versionId) && !(message.versionId && $util.isInteger(message.versionId.low) && $util.isInteger(message.versionId.high)))
                                return "versionId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            if (typeof message.isSystem !== "boolean")
                                return "isSystem: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CameraSectionFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraSectionFilter} CameraSectionFilter
                     */
                    CameraSectionFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraSectionFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraSectionFilter();
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.versionDateTime != null)
                            message.versionDateTime = String(object.versionDateTime);
                        if (object.versionId != null)
                            if ($util.Long)
                                (message.versionId = $util.Long.fromValue(object.versionId)).unsigned = false;
                            else if (typeof object.versionId === "string")
                                message.versionId = parseInt(object.versionId, 10);
                            else if (typeof object.versionId === "number")
                                message.versionId = object.versionId;
                            else if (typeof object.versionId === "object")
                                message.versionId = new $util.LongBits(object.versionId.low >>> 0, object.versionId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.isSystem != null)
                            message.isSystem = Boolean(object.isSystem);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraSectionFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @static
                     * @param {palexy.streaming.v1.CameraSectionFilter} message CameraSectionFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraSectionFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            object.versionDateTime = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.versionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.versionId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.isSystem = false;
                        }
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.versionDateTime != null && message.hasOwnProperty("versionDateTime"))
                            object.versionDateTime = message.versionDateTime;
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (typeof message.versionId === "number")
                                object.versionId = options.longs === String ? String(message.versionId) : message.versionId;
                            else
                                object.versionId = options.longs === String ? $util.Long.prototype.toString.call(message.versionId) : options.longs === Number ? new $util.LongBits(message.versionId.low >>> 0, message.versionId.high >>> 0).toNumber() : message.versionId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.isSystem != null && message.hasOwnProperty("isSystem"))
                            object.isSystem = message.isSystem;
                        return object;
                    };
    
                    /**
                     * Converts this CameraSectionFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraSectionFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraSectionFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CameraSectionFilter;
                })();
    
                v1.ListSystemCameraSectionsRequest = (function() {
    
                    /**
                     * Properties of a ListSystemCameraSectionsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListSystemCameraSectionsRequest
                     * @property {number|null} [cameraPrimaryId] ListSystemCameraSectionsRequest cameraPrimaryId
                     * @property {string|null} [cameraId] ListSystemCameraSectionsRequest cameraId
                     * @property {palexy.streaming.v1.ICameraSectionFilter|null} [filter] ListSystemCameraSectionsRequest filter
                     */
    
                    /**
                     * Constructs a new ListSystemCameraSectionsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSystemCameraSectionsRequest.
                     * @implements IListSystemCameraSectionsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest=} [properties] Properties to set
                     */
                    function ListSystemCameraSectionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSystemCameraSectionsRequest cameraPrimaryId.
                     * @member {number} cameraPrimaryId
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @instance
                     */
                    ListSystemCameraSectionsRequest.prototype.cameraPrimaryId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListSystemCameraSectionsRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @instance
                     */
                    ListSystemCameraSectionsRequest.prototype.cameraId = "";
    
                    /**
                     * ListSystemCameraSectionsRequest filter.
                     * @member {palexy.streaming.v1.ICameraSectionFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @instance
                     */
                    ListSystemCameraSectionsRequest.prototype.filter = null;
    
                    /**
                     * Creates a new ListSystemCameraSectionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionsRequest} ListSystemCameraSectionsRequest instance
                     */
                    ListSystemCameraSectionsRequest.create = function create(properties) {
                        return new ListSystemCameraSectionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListSystemCameraSectionsRequest message. Does not implicitly {@link palexy.streaming.v1.ListSystemCameraSectionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest} message ListSystemCameraSectionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSystemCameraSectionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPrimaryId != null && Object.hasOwnProperty.call(message, "cameraPrimaryId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraPrimaryId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.CameraSectionFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSystemCameraSectionsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSystemCameraSectionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSystemCameraSectionsRequest} message ListSystemCameraSectionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSystemCameraSectionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSystemCameraSectionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionsRequest} ListSystemCameraSectionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSystemCameraSectionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSystemCameraSectionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPrimaryId = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.filter = $root.palexy.streaming.v1.CameraSectionFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSystemCameraSectionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionsRequest} ListSystemCameraSectionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSystemCameraSectionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSystemCameraSectionsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSystemCameraSectionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (!$util.isInteger(message.cameraPrimaryId) && !(message.cameraPrimaryId && $util.isInteger(message.cameraPrimaryId.low) && $util.isInteger(message.cameraPrimaryId.high)))
                                return "cameraPrimaryId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.CameraSectionFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListSystemCameraSectionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSystemCameraSectionsRequest} ListSystemCameraSectionsRequest
                     */
                    ListSystemCameraSectionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSystemCameraSectionsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSystemCameraSectionsRequest();
                        if (object.cameraPrimaryId != null)
                            if ($util.Long)
                                (message.cameraPrimaryId = $util.Long.fromValue(object.cameraPrimaryId)).unsigned = false;
                            else if (typeof object.cameraPrimaryId === "string")
                                message.cameraPrimaryId = parseInt(object.cameraPrimaryId, 10);
                            else if (typeof object.cameraPrimaryId === "number")
                                message.cameraPrimaryId = object.cameraPrimaryId;
                            else if (typeof object.cameraPrimaryId === "object")
                                message.cameraPrimaryId = new $util.LongBits(object.cameraPrimaryId.low >>> 0, object.cameraPrimaryId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListSystemCameraSectionsRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.CameraSectionFilter.fromObject(object.filter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSystemCameraSectionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListSystemCameraSectionsRequest} message ListSystemCameraSectionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSystemCameraSectionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraPrimaryId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraPrimaryId = options.longs === String ? "0" : 0;
                            object.cameraId = "";
                            object.filter = null;
                        }
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (typeof message.cameraPrimaryId === "number")
                                object.cameraPrimaryId = options.longs === String ? String(message.cameraPrimaryId) : message.cameraPrimaryId;
                            else
                                object.cameraPrimaryId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraPrimaryId) : options.longs === Number ? new $util.LongBits(message.cameraPrimaryId.low >>> 0, message.cameraPrimaryId.high >>> 0).toNumber() : message.cameraPrimaryId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.CameraSectionFilter.toObject(message.filter, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListSystemCameraSectionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSystemCameraSectionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSystemCameraSectionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSystemCameraSectionsRequest;
                })();
    
                v1.ListCameraSectionsRequest = (function() {
    
                    /**
                     * Properties of a ListCameraSectionsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCameraSectionsRequest
                     * @property {number|null} [cameraPrimaryId] ListCameraSectionsRequest cameraPrimaryId
                     * @property {string|null} [cameraId] ListCameraSectionsRequest cameraId
                     * @property {palexy.streaming.v1.ICameraSectionFilter|null} [filter] ListCameraSectionsRequest filter
                     */
    
                    /**
                     * Constructs a new ListCameraSectionsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCameraSectionsRequest.
                     * @implements IListCameraSectionsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest=} [properties] Properties to set
                     */
                    function ListCameraSectionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCameraSectionsRequest cameraPrimaryId.
                     * @member {number} cameraPrimaryId
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @instance
                     */
                    ListCameraSectionsRequest.prototype.cameraPrimaryId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListCameraSectionsRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @instance
                     */
                    ListCameraSectionsRequest.prototype.cameraId = "";
    
                    /**
                     * ListCameraSectionsRequest filter.
                     * @member {palexy.streaming.v1.ICameraSectionFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @instance
                     */
                    ListCameraSectionsRequest.prototype.filter = null;
    
                    /**
                     * Creates a new ListCameraSectionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCameraSectionsRequest} ListCameraSectionsRequest instance
                     */
                    ListCameraSectionsRequest.create = function create(properties) {
                        return new ListCameraSectionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsRequest message. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest} message ListCameraSectionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraPrimaryId != null && Object.hasOwnProperty.call(message, "cameraPrimaryId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cameraPrimaryId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.CameraSectionFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsRequest} message ListCameraSectionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCameraSectionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCameraSectionsRequest} ListCameraSectionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCameraSectionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraPrimaryId = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.filter = $root.palexy.streaming.v1.CameraSectionFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCameraSectionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCameraSectionsRequest} ListCameraSectionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCameraSectionsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCameraSectionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (!$util.isInteger(message.cameraPrimaryId) && !(message.cameraPrimaryId && $util.isInteger(message.cameraPrimaryId.low) && $util.isInteger(message.cameraPrimaryId.high)))
                                return "cameraPrimaryId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.CameraSectionFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCameraSectionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCameraSectionsRequest} ListCameraSectionsRequest
                     */
                    ListCameraSectionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCameraSectionsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCameraSectionsRequest();
                        if (object.cameraPrimaryId != null)
                            if ($util.Long)
                                (message.cameraPrimaryId = $util.Long.fromValue(object.cameraPrimaryId)).unsigned = false;
                            else if (typeof object.cameraPrimaryId === "string")
                                message.cameraPrimaryId = parseInt(object.cameraPrimaryId, 10);
                            else if (typeof object.cameraPrimaryId === "number")
                                message.cameraPrimaryId = object.cameraPrimaryId;
                            else if (typeof object.cameraPrimaryId === "object")
                                message.cameraPrimaryId = new $util.LongBits(object.cameraPrimaryId.low >>> 0, object.cameraPrimaryId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCameraSectionsRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.CameraSectionFilter.fromObject(object.filter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCameraSectionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCameraSectionsRequest} message ListCameraSectionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCameraSectionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraPrimaryId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraPrimaryId = options.longs === String ? "0" : 0;
                            object.cameraId = "";
                            object.filter = null;
                        }
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (typeof message.cameraPrimaryId === "number")
                                object.cameraPrimaryId = options.longs === String ? String(message.cameraPrimaryId) : message.cameraPrimaryId;
                            else
                                object.cameraPrimaryId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraPrimaryId) : options.longs === Number ? new $util.LongBits(message.cameraPrimaryId.low >>> 0, message.cameraPrimaryId.high >>> 0).toNumber() : message.cameraPrimaryId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.CameraSectionFilter.toObject(message.filter, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListCameraSectionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCameraSectionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCameraSectionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCameraSectionsRequest;
                })();
    
                v1.ListCameraSectionsResponse = (function() {
    
                    /**
                     * Properties of a ListCameraSectionsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCameraSectionsResponse
                     * @property {Array.<palexy.streaming.v1.ICameraSection>|null} [section] ListCameraSectionsResponse section
                     */
    
                    /**
                     * Constructs a new ListCameraSectionsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCameraSectionsResponse.
                     * @implements IListCameraSectionsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCameraSectionsResponse=} [properties] Properties to set
                     */
                    function ListCameraSectionsResponse(properties) {
                        this.section = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCameraSectionsResponse section.
                     * @member {Array.<palexy.streaming.v1.ICameraSection>} section
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @instance
                     */
                    ListCameraSectionsResponse.prototype.section = $util.emptyArray;
    
                    /**
                     * Creates a new ListCameraSectionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCameraSectionsResponse} ListCameraSectionsResponse instance
                     */
                    ListCameraSectionsResponse.create = function create(properties) {
                        return new ListCameraSectionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsResponse message. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsResponse} message ListCameraSectionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.section != null && message.section.length)
                            for (var i = 0; i < message.section.length; ++i)
                                $root.palexy.streaming.v1.CameraSection.encode(message.section[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsResponse} message ListCameraSectionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCameraSectionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCameraSectionsResponse} ListCameraSectionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCameraSectionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.section && message.section.length))
                                    message.section = [];
                                message.section.push($root.palexy.streaming.v1.CameraSection.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCameraSectionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCameraSectionsResponse} ListCameraSectionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCameraSectionsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCameraSectionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.section != null && message.hasOwnProperty("section")) {
                            if (!Array.isArray(message.section))
                                return "section: array expected";
                            for (var i = 0; i < message.section.length; ++i) {
                                var error = $root.palexy.streaming.v1.CameraSection.verify(message.section[i]);
                                if (error)
                                    return "section." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCameraSectionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCameraSectionsResponse} ListCameraSectionsResponse
                     */
                    ListCameraSectionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCameraSectionsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCameraSectionsResponse();
                        if (object.section) {
                            if (!Array.isArray(object.section))
                                throw TypeError(".palexy.streaming.v1.ListCameraSectionsResponse.section: array expected");
                            message.section = [];
                            for (var i = 0; i < object.section.length; ++i) {
                                if (typeof object.section[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCameraSectionsResponse.section: object expected");
                                message.section[i] = $root.palexy.streaming.v1.CameraSection.fromObject(object.section[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCameraSectionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCameraSectionsResponse} message ListCameraSectionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCameraSectionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.section = [];
                        if (message.section && message.section.length) {
                            object.section = [];
                            for (var j = 0; j < message.section.length; ++j)
                                object.section[j] = $root.palexy.streaming.v1.CameraSection.toObject(message.section[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCameraSectionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCameraSectionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCameraSectionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCameraSectionsResponse;
                })();
    
                v1.ListCameraSectionsOfLayoutRequest = (function() {
    
                    /**
                     * Properties of a ListCameraSectionsOfLayoutRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCameraSectionsOfLayoutRequest
                     * @property {string|null} [cameraId] ListCameraSectionsOfLayoutRequest cameraId
                     * @property {Array.<number>|null} [layoutIds] ListCameraSectionsOfLayoutRequest layoutIds
                     */
    
                    /**
                     * Constructs a new ListCameraSectionsOfLayoutRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCameraSectionsOfLayoutRequest.
                     * @implements IListCameraSectionsOfLayoutRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest=} [properties] Properties to set
                     */
                    function ListCameraSectionsOfLayoutRequest(properties) {
                        this.layoutIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCameraSectionsOfLayoutRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @instance
                     */
                    ListCameraSectionsOfLayoutRequest.prototype.cameraId = "";
    
                    /**
                     * ListCameraSectionsOfLayoutRequest layoutIds.
                     * @member {Array.<number>} layoutIds
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @instance
                     */
                    ListCameraSectionsOfLayoutRequest.prototype.layoutIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListCameraSectionsOfLayoutRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutRequest} ListCameraSectionsOfLayoutRequest instance
                     */
                    ListCameraSectionsOfLayoutRequest.create = function create(properties) {
                        return new ListCameraSectionsOfLayoutRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsOfLayoutRequest message. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsOfLayoutRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest} message ListCameraSectionsOfLayoutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsOfLayoutRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.layoutIds != null && message.layoutIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.layoutIds.length; ++i)
                                writer.int64(message.layoutIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsOfLayoutRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsOfLayoutRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutRequest} message ListCameraSectionsOfLayoutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsOfLayoutRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCameraSectionsOfLayoutRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutRequest} ListCameraSectionsOfLayoutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsOfLayoutRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCameraSectionsOfLayoutRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                if (!(message.layoutIds && message.layoutIds.length))
                                    message.layoutIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.layoutIds.push(reader.int64());
                                } else
                                    message.layoutIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCameraSectionsOfLayoutRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutRequest} ListCameraSectionsOfLayoutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsOfLayoutRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCameraSectionsOfLayoutRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCameraSectionsOfLayoutRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.layoutIds != null && message.hasOwnProperty("layoutIds")) {
                            if (!Array.isArray(message.layoutIds))
                                return "layoutIds: array expected";
                            for (var i = 0; i < message.layoutIds.length; ++i)
                                if (!$util.isInteger(message.layoutIds[i]) && !(message.layoutIds[i] && $util.isInteger(message.layoutIds[i].low) && $util.isInteger(message.layoutIds[i].high)))
                                    return "layoutIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCameraSectionsOfLayoutRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutRequest} ListCameraSectionsOfLayoutRequest
                     */
                    ListCameraSectionsOfLayoutRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCameraSectionsOfLayoutRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCameraSectionsOfLayoutRequest();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.layoutIds) {
                            if (!Array.isArray(object.layoutIds))
                                throw TypeError(".palexy.streaming.v1.ListCameraSectionsOfLayoutRequest.layoutIds: array expected");
                            message.layoutIds = [];
                            for (var i = 0; i < object.layoutIds.length; ++i)
                                if ($util.Long)
                                    (message.layoutIds[i] = $util.Long.fromValue(object.layoutIds[i])).unsigned = false;
                                else if (typeof object.layoutIds[i] === "string")
                                    message.layoutIds[i] = parseInt(object.layoutIds[i], 10);
                                else if (typeof object.layoutIds[i] === "number")
                                    message.layoutIds[i] = object.layoutIds[i];
                                else if (typeof object.layoutIds[i] === "object")
                                    message.layoutIds[i] = new $util.LongBits(object.layoutIds[i].low >>> 0, object.layoutIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCameraSectionsOfLayoutRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCameraSectionsOfLayoutRequest} message ListCameraSectionsOfLayoutRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCameraSectionsOfLayoutRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.layoutIds = [];
                        if (options.defaults)
                            object.cameraId = "";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.layoutIds && message.layoutIds.length) {
                            object.layoutIds = [];
                            for (var j = 0; j < message.layoutIds.length; ++j)
                                if (typeof message.layoutIds[j] === "number")
                                    object.layoutIds[j] = options.longs === String ? String(message.layoutIds[j]) : message.layoutIds[j];
                                else
                                    object.layoutIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.layoutIds[j]) : options.longs === Number ? new $util.LongBits(message.layoutIds[j].low >>> 0, message.layoutIds[j].high >>> 0).toNumber() : message.layoutIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCameraSectionsOfLayoutRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCameraSectionsOfLayoutRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCameraSectionsOfLayoutRequest;
                })();
    
                v1.ListCameraSectionsOfLayoutResponse = (function() {
    
                    /**
                     * Properties of a ListCameraSectionsOfLayoutResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCameraSectionsOfLayoutResponse
                     * @property {Array.<palexy.streaming.v1.ICameraSection>|null} [sections] ListCameraSectionsOfLayoutResponse sections
                     */
    
                    /**
                     * Constructs a new ListCameraSectionsOfLayoutResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCameraSectionsOfLayoutResponse.
                     * @implements IListCameraSectionsOfLayoutResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutResponse=} [properties] Properties to set
                     */
                    function ListCameraSectionsOfLayoutResponse(properties) {
                        this.sections = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCameraSectionsOfLayoutResponse sections.
                     * @member {Array.<palexy.streaming.v1.ICameraSection>} sections
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @instance
                     */
                    ListCameraSectionsOfLayoutResponse.prototype.sections = $util.emptyArray;
    
                    /**
                     * Creates a new ListCameraSectionsOfLayoutResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} ListCameraSectionsOfLayoutResponse instance
                     */
                    ListCameraSectionsOfLayoutResponse.create = function create(properties) {
                        return new ListCameraSectionsOfLayoutResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsOfLayoutResponse message. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsOfLayoutResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutResponse} message ListCameraSectionsOfLayoutResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsOfLayoutResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sections != null && message.sections.length)
                            for (var i = 0; i < message.sections.length; ++i)
                                $root.palexy.streaming.v1.CameraSection.encode(message.sections[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCameraSectionsOfLayoutResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCameraSectionsOfLayoutResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCameraSectionsOfLayoutResponse} message ListCameraSectionsOfLayoutResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCameraSectionsOfLayoutResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCameraSectionsOfLayoutResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} ListCameraSectionsOfLayoutResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsOfLayoutResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCameraSectionsOfLayoutResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sections && message.sections.length))
                                    message.sections = [];
                                message.sections.push($root.palexy.streaming.v1.CameraSection.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCameraSectionsOfLayoutResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} ListCameraSectionsOfLayoutResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCameraSectionsOfLayoutResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCameraSectionsOfLayoutResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCameraSectionsOfLayoutResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sections != null && message.hasOwnProperty("sections")) {
                            if (!Array.isArray(message.sections))
                                return "sections: array expected";
                            for (var i = 0; i < message.sections.length; ++i) {
                                var error = $root.palexy.streaming.v1.CameraSection.verify(message.sections[i]);
                                if (error)
                                    return "sections." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCameraSectionsOfLayoutResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} ListCameraSectionsOfLayoutResponse
                     */
                    ListCameraSectionsOfLayoutResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCameraSectionsOfLayoutResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCameraSectionsOfLayoutResponse();
                        if (object.sections) {
                            if (!Array.isArray(object.sections))
                                throw TypeError(".palexy.streaming.v1.ListCameraSectionsOfLayoutResponse.sections: array expected");
                            message.sections = [];
                            for (var i = 0; i < object.sections.length; ++i) {
                                if (typeof object.sections[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCameraSectionsOfLayoutResponse.sections: object expected");
                                message.sections[i] = $root.palexy.streaming.v1.CameraSection.fromObject(object.sections[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCameraSectionsOfLayoutResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCameraSectionsOfLayoutResponse} message ListCameraSectionsOfLayoutResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCameraSectionsOfLayoutResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sections = [];
                        if (message.sections && message.sections.length) {
                            object.sections = [];
                            for (var j = 0; j < message.sections.length; ++j)
                                object.sections[j] = $root.palexy.streaming.v1.CameraSection.toObject(message.sections[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCameraSectionsOfLayoutResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCameraSectionsOfLayoutResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCameraSectionsOfLayoutResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCameraSectionsOfLayoutResponse;
                })();
    
                v1.EntranceMergingConfig = (function() {
    
                    /**
                     * Properties of an EntranceMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IEntranceMergingConfig
                     * @property {number|null} [numHistoryItemsPerTracklet] EntranceMergingConfig numHistoryItemsPerTracklet
                     * @property {number|null} [maximumTimeDistanceSeconds] EntranceMergingConfig maximumTimeDistanceSeconds
                     * @property {number|null} [costThresholdToSplitNewPerson] EntranceMergingConfig costThresholdToSplitNewPerson
                     * @property {number|null} [maxIouOverlapping] EntranceMergingConfig maxIouOverlapping
                     * @property {number|null} [maxAngleToBeGoingIn] EntranceMergingConfig maxAngleToBeGoingIn
                     * @property {number|null} [percentageOfLessThanMaxAngle] EntranceMergingConfig percentageOfLessThanMaxAngle
                     */
    
                    /**
                     * Constructs a new EntranceMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EntranceMergingConfig.
                     * @implements IEntranceMergingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IEntranceMergingConfig=} [properties] Properties to set
                     */
                    function EntranceMergingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EntranceMergingConfig numHistoryItemsPerTracklet.
                     * @member {number} numHistoryItemsPerTracklet
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.numHistoryItemsPerTracklet = 0;
    
                    /**
                     * EntranceMergingConfig maximumTimeDistanceSeconds.
                     * @member {number} maximumTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.maximumTimeDistanceSeconds = 0;
    
                    /**
                     * EntranceMergingConfig costThresholdToSplitNewPerson.
                     * @member {number} costThresholdToSplitNewPerson
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.costThresholdToSplitNewPerson = 0;
    
                    /**
                     * EntranceMergingConfig maxIouOverlapping.
                     * @member {number} maxIouOverlapping
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.maxIouOverlapping = 0;
    
                    /**
                     * EntranceMergingConfig maxAngleToBeGoingIn.
                     * @member {number} maxAngleToBeGoingIn
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.maxAngleToBeGoingIn = 0;
    
                    /**
                     * EntranceMergingConfig percentageOfLessThanMaxAngle.
                     * @member {number} percentageOfLessThanMaxAngle
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     */
                    EntranceMergingConfig.prototype.percentageOfLessThanMaxAngle = 0;
    
                    /**
                     * Creates a new EntranceMergingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IEntranceMergingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.EntranceMergingConfig} EntranceMergingConfig instance
                     */
                    EntranceMergingConfig.create = function create(properties) {
                        return new EntranceMergingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified EntranceMergingConfig message. Does not implicitly {@link palexy.streaming.v1.EntranceMergingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IEntranceMergingConfig} message EntranceMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EntranceMergingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.numHistoryItemsPerTracklet != null && Object.hasOwnProperty.call(message, "numHistoryItemsPerTracklet"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.numHistoryItemsPerTracklet);
                        if (message.maximumTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "maximumTimeDistanceSeconds"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maximumTimeDistanceSeconds);
                        if (message.costThresholdToSplitNewPerson != null && Object.hasOwnProperty.call(message, "costThresholdToSplitNewPerson"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.costThresholdToSplitNewPerson);
                        if (message.maxIouOverlapping != null && Object.hasOwnProperty.call(message, "maxIouOverlapping"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.maxIouOverlapping);
                        if (message.maxAngleToBeGoingIn != null && Object.hasOwnProperty.call(message, "maxAngleToBeGoingIn"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.maxAngleToBeGoingIn);
                        if (message.percentageOfLessThanMaxAngle != null && Object.hasOwnProperty.call(message, "percentageOfLessThanMaxAngle"))
                            writer.uint32(/* id 6, wireType 5 =*/53).float(message.percentageOfLessThanMaxAngle);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EntranceMergingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.EntranceMergingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IEntranceMergingConfig} message EntranceMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EntranceMergingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EntranceMergingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.EntranceMergingConfig} EntranceMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EntranceMergingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.EntranceMergingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.numHistoryItemsPerTracklet = reader.int32();
                                break;
                            case 2:
                                message.maximumTimeDistanceSeconds = reader.int32();
                                break;
                            case 3:
                                message.costThresholdToSplitNewPerson = reader.float();
                                break;
                            case 4:
                                message.maxIouOverlapping = reader.float();
                                break;
                            case 5:
                                message.maxAngleToBeGoingIn = reader.float();
                                break;
                            case 6:
                                message.percentageOfLessThanMaxAngle = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EntranceMergingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.EntranceMergingConfig} EntranceMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EntranceMergingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EntranceMergingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EntranceMergingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            if (!$util.isInteger(message.numHistoryItemsPerTracklet))
                                return "numHistoryItemsPerTracklet: integer expected";
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            if (!$util.isInteger(message.maximumTimeDistanceSeconds))
                                return "maximumTimeDistanceSeconds: integer expected";
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            if (typeof message.costThresholdToSplitNewPerson !== "number")
                                return "costThresholdToSplitNewPerson: number expected";
                        if (message.maxIouOverlapping != null && message.hasOwnProperty("maxIouOverlapping"))
                            if (typeof message.maxIouOverlapping !== "number")
                                return "maxIouOverlapping: number expected";
                        if (message.maxAngleToBeGoingIn != null && message.hasOwnProperty("maxAngleToBeGoingIn"))
                            if (typeof message.maxAngleToBeGoingIn !== "number")
                                return "maxAngleToBeGoingIn: number expected";
                        if (message.percentageOfLessThanMaxAngle != null && message.hasOwnProperty("percentageOfLessThanMaxAngle"))
                            if (typeof message.percentageOfLessThanMaxAngle !== "number")
                                return "percentageOfLessThanMaxAngle: number expected";
                        return null;
                    };
    
                    /**
                     * Creates an EntranceMergingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.EntranceMergingConfig} EntranceMergingConfig
                     */
                    EntranceMergingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.EntranceMergingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.EntranceMergingConfig();
                        if (object.numHistoryItemsPerTracklet != null)
                            message.numHistoryItemsPerTracklet = object.numHistoryItemsPerTracklet | 0;
                        if (object.maximumTimeDistanceSeconds != null)
                            message.maximumTimeDistanceSeconds = object.maximumTimeDistanceSeconds | 0;
                        if (object.costThresholdToSplitNewPerson != null)
                            message.costThresholdToSplitNewPerson = Number(object.costThresholdToSplitNewPerson);
                        if (object.maxIouOverlapping != null)
                            message.maxIouOverlapping = Number(object.maxIouOverlapping);
                        if (object.maxAngleToBeGoingIn != null)
                            message.maxAngleToBeGoingIn = Number(object.maxAngleToBeGoingIn);
                        if (object.percentageOfLessThanMaxAngle != null)
                            message.percentageOfLessThanMaxAngle = Number(object.percentageOfLessThanMaxAngle);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EntranceMergingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.EntranceMergingConfig} message EntranceMergingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EntranceMergingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.numHistoryItemsPerTracklet = 0;
                            object.maximumTimeDistanceSeconds = 0;
                            object.costThresholdToSplitNewPerson = 0;
                            object.maxIouOverlapping = 0;
                            object.maxAngleToBeGoingIn = 0;
                            object.percentageOfLessThanMaxAngle = 0;
                        }
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            object.numHistoryItemsPerTracklet = message.numHistoryItemsPerTracklet;
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            object.maximumTimeDistanceSeconds = message.maximumTimeDistanceSeconds;
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            object.costThresholdToSplitNewPerson = options.json && !isFinite(message.costThresholdToSplitNewPerson) ? String(message.costThresholdToSplitNewPerson) : message.costThresholdToSplitNewPerson;
                        if (message.maxIouOverlapping != null && message.hasOwnProperty("maxIouOverlapping"))
                            object.maxIouOverlapping = options.json && !isFinite(message.maxIouOverlapping) ? String(message.maxIouOverlapping) : message.maxIouOverlapping;
                        if (message.maxAngleToBeGoingIn != null && message.hasOwnProperty("maxAngleToBeGoingIn"))
                            object.maxAngleToBeGoingIn = options.json && !isFinite(message.maxAngleToBeGoingIn) ? String(message.maxAngleToBeGoingIn) : message.maxAngleToBeGoingIn;
                        if (message.percentageOfLessThanMaxAngle != null && message.hasOwnProperty("percentageOfLessThanMaxAngle"))
                            object.percentageOfLessThanMaxAngle = options.json && !isFinite(message.percentageOfLessThanMaxAngle) ? String(message.percentageOfLessThanMaxAngle) : message.percentageOfLessThanMaxAngle;
                        return object;
                    };
    
                    /**
                     * Converts this EntranceMergingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.EntranceMergingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EntranceMergingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EntranceMergingConfig;
                })();
    
                v1.QueueTimeMergingConfig = (function() {
    
                    /**
                     * Properties of a QueueTimeMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IQueueTimeMergingConfig
                     * @property {number|null} [minIouOverlapping] QueueTimeMergingConfig minIouOverlapping
                     * @property {number|null} [numHistoryItemsPerTracklet] QueueTimeMergingConfig numHistoryItemsPerTracklet
                     * @property {number|null} [maximumTimeDistanceSeconds] QueueTimeMergingConfig maximumTimeDistanceSeconds
                     * @property {number|null} [costThresholdToSplitNewPerson] QueueTimeMergingConfig costThresholdToSplitNewPerson
                     * @property {number|null} [minimumLengthOfTrackletsPreFullMerging] QueueTimeMergingConfig minimumLengthOfTrackletsPreFullMerging
                     */
    
                    /**
                     * Constructs a new QueueTimeMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a QueueTimeMergingConfig.
                     * @implements IQueueTimeMergingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IQueueTimeMergingConfig=} [properties] Properties to set
                     */
                    function QueueTimeMergingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QueueTimeMergingConfig minIouOverlapping.
                     * @member {number} minIouOverlapping
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     */
                    QueueTimeMergingConfig.prototype.minIouOverlapping = 0;
    
                    /**
                     * QueueTimeMergingConfig numHistoryItemsPerTracklet.
                     * @member {number} numHistoryItemsPerTracklet
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     */
                    QueueTimeMergingConfig.prototype.numHistoryItemsPerTracklet = 0;
    
                    /**
                     * QueueTimeMergingConfig maximumTimeDistanceSeconds.
                     * @member {number} maximumTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     */
                    QueueTimeMergingConfig.prototype.maximumTimeDistanceSeconds = 0;
    
                    /**
                     * QueueTimeMergingConfig costThresholdToSplitNewPerson.
                     * @member {number} costThresholdToSplitNewPerson
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     */
                    QueueTimeMergingConfig.prototype.costThresholdToSplitNewPerson = 0;
    
                    /**
                     * QueueTimeMergingConfig minimumLengthOfTrackletsPreFullMerging.
                     * @member {number} minimumLengthOfTrackletsPreFullMerging
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     */
                    QueueTimeMergingConfig.prototype.minimumLengthOfTrackletsPreFullMerging = 0;
    
                    /**
                     * Creates a new QueueTimeMergingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IQueueTimeMergingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.QueueTimeMergingConfig} QueueTimeMergingConfig instance
                     */
                    QueueTimeMergingConfig.create = function create(properties) {
                        return new QueueTimeMergingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified QueueTimeMergingConfig message. Does not implicitly {@link palexy.streaming.v1.QueueTimeMergingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IQueueTimeMergingConfig} message QueueTimeMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QueueTimeMergingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minIouOverlapping != null && Object.hasOwnProperty.call(message, "minIouOverlapping"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.minIouOverlapping);
                        if (message.numHistoryItemsPerTracklet != null && Object.hasOwnProperty.call(message, "numHistoryItemsPerTracklet"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numHistoryItemsPerTracklet);
                        if (message.maximumTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "maximumTimeDistanceSeconds"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maximumTimeDistanceSeconds);
                        if (message.costThresholdToSplitNewPerson != null && Object.hasOwnProperty.call(message, "costThresholdToSplitNewPerson"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.costThresholdToSplitNewPerson);
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && Object.hasOwnProperty.call(message, "minimumLengthOfTrackletsPreFullMerging"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minimumLengthOfTrackletsPreFullMerging);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QueueTimeMergingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.QueueTimeMergingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IQueueTimeMergingConfig} message QueueTimeMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QueueTimeMergingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QueueTimeMergingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.QueueTimeMergingConfig} QueueTimeMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QueueTimeMergingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.QueueTimeMergingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minIouOverlapping = reader.float();
                                break;
                            case 2:
                                message.numHistoryItemsPerTracklet = reader.int32();
                                break;
                            case 3:
                                message.maximumTimeDistanceSeconds = reader.int32();
                                break;
                            case 4:
                                message.costThresholdToSplitNewPerson = reader.float();
                                break;
                            case 5:
                                message.minimumLengthOfTrackletsPreFullMerging = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QueueTimeMergingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.QueueTimeMergingConfig} QueueTimeMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QueueTimeMergingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QueueTimeMergingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QueueTimeMergingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minIouOverlapping != null && message.hasOwnProperty("minIouOverlapping"))
                            if (typeof message.minIouOverlapping !== "number")
                                return "minIouOverlapping: number expected";
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            if (!$util.isInteger(message.numHistoryItemsPerTracklet))
                                return "numHistoryItemsPerTracklet: integer expected";
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            if (!$util.isInteger(message.maximumTimeDistanceSeconds))
                                return "maximumTimeDistanceSeconds: integer expected";
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            if (typeof message.costThresholdToSplitNewPerson !== "number")
                                return "costThresholdToSplitNewPerson: number expected";
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && message.hasOwnProperty("minimumLengthOfTrackletsPreFullMerging"))
                            if (!$util.isInteger(message.minimumLengthOfTrackletsPreFullMerging))
                                return "minimumLengthOfTrackletsPreFullMerging: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a QueueTimeMergingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.QueueTimeMergingConfig} QueueTimeMergingConfig
                     */
                    QueueTimeMergingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.QueueTimeMergingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.QueueTimeMergingConfig();
                        if (object.minIouOverlapping != null)
                            message.minIouOverlapping = Number(object.minIouOverlapping);
                        if (object.numHistoryItemsPerTracklet != null)
                            message.numHistoryItemsPerTracklet = object.numHistoryItemsPerTracklet | 0;
                        if (object.maximumTimeDistanceSeconds != null)
                            message.maximumTimeDistanceSeconds = object.maximumTimeDistanceSeconds | 0;
                        if (object.costThresholdToSplitNewPerson != null)
                            message.costThresholdToSplitNewPerson = Number(object.costThresholdToSplitNewPerson);
                        if (object.minimumLengthOfTrackletsPreFullMerging != null)
                            message.minimumLengthOfTrackletsPreFullMerging = object.minimumLengthOfTrackletsPreFullMerging | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QueueTimeMergingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.QueueTimeMergingConfig} message QueueTimeMergingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QueueTimeMergingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minIouOverlapping = 0;
                            object.numHistoryItemsPerTracklet = 0;
                            object.maximumTimeDistanceSeconds = 0;
                            object.costThresholdToSplitNewPerson = 0;
                            object.minimumLengthOfTrackletsPreFullMerging = 0;
                        }
                        if (message.minIouOverlapping != null && message.hasOwnProperty("minIouOverlapping"))
                            object.minIouOverlapping = options.json && !isFinite(message.minIouOverlapping) ? String(message.minIouOverlapping) : message.minIouOverlapping;
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            object.numHistoryItemsPerTracklet = message.numHistoryItemsPerTracklet;
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            object.maximumTimeDistanceSeconds = message.maximumTimeDistanceSeconds;
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            object.costThresholdToSplitNewPerson = options.json && !isFinite(message.costThresholdToSplitNewPerson) ? String(message.costThresholdToSplitNewPerson) : message.costThresholdToSplitNewPerson;
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && message.hasOwnProperty("minimumLengthOfTrackletsPreFullMerging"))
                            object.minimumLengthOfTrackletsPreFullMerging = message.minimumLengthOfTrackletsPreFullMerging;
                        return object;
                    };
    
                    /**
                     * Converts this QueueTimeMergingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.QueueTimeMergingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QueueTimeMergingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QueueTimeMergingConfig;
                })();
    
                v1.SectionMergingConfig = (function() {
    
                    /**
                     * Properties of a SectionMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ISectionMergingConfig
                     * @property {number|null} [minIouOverlapping] SectionMergingConfig minIouOverlapping
                     * @property {number|null} [numHistoryItemsPerTracklet] SectionMergingConfig numHistoryItemsPerTracklet
                     * @property {number|null} [maximumTimeDistanceSeconds] SectionMergingConfig maximumTimeDistanceSeconds
                     * @property {number|null} [costThresholdToSplitNewPerson] SectionMergingConfig costThresholdToSplitNewPerson
                     * @property {number|null} [minimumLengthOfTrackletsPreFullMerging] SectionMergingConfig minimumLengthOfTrackletsPreFullMerging
                     */
    
                    /**
                     * Constructs a new SectionMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SectionMergingConfig.
                     * @implements ISectionMergingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ISectionMergingConfig=} [properties] Properties to set
                     */
                    function SectionMergingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SectionMergingConfig minIouOverlapping.
                     * @member {number} minIouOverlapping
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     */
                    SectionMergingConfig.prototype.minIouOverlapping = 0;
    
                    /**
                     * SectionMergingConfig numHistoryItemsPerTracklet.
                     * @member {number} numHistoryItemsPerTracklet
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     */
                    SectionMergingConfig.prototype.numHistoryItemsPerTracklet = 0;
    
                    /**
                     * SectionMergingConfig maximumTimeDistanceSeconds.
                     * @member {number} maximumTimeDistanceSeconds
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     */
                    SectionMergingConfig.prototype.maximumTimeDistanceSeconds = 0;
    
                    /**
                     * SectionMergingConfig costThresholdToSplitNewPerson.
                     * @member {number} costThresholdToSplitNewPerson
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     */
                    SectionMergingConfig.prototype.costThresholdToSplitNewPerson = 0;
    
                    /**
                     * SectionMergingConfig minimumLengthOfTrackletsPreFullMerging.
                     * @member {number} minimumLengthOfTrackletsPreFullMerging
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     */
                    SectionMergingConfig.prototype.minimumLengthOfTrackletsPreFullMerging = 0;
    
                    /**
                     * Creates a new SectionMergingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.ISectionMergingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SectionMergingConfig} SectionMergingConfig instance
                     */
                    SectionMergingConfig.create = function create(properties) {
                        return new SectionMergingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified SectionMergingConfig message. Does not implicitly {@link palexy.streaming.v1.SectionMergingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.ISectionMergingConfig} message SectionMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SectionMergingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minIouOverlapping != null && Object.hasOwnProperty.call(message, "minIouOverlapping"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.minIouOverlapping);
                        if (message.numHistoryItemsPerTracklet != null && Object.hasOwnProperty.call(message, "numHistoryItemsPerTracklet"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.numHistoryItemsPerTracklet);
                        if (message.maximumTimeDistanceSeconds != null && Object.hasOwnProperty.call(message, "maximumTimeDistanceSeconds"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maximumTimeDistanceSeconds);
                        if (message.costThresholdToSplitNewPerson != null && Object.hasOwnProperty.call(message, "costThresholdToSplitNewPerson"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.costThresholdToSplitNewPerson);
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && Object.hasOwnProperty.call(message, "minimumLengthOfTrackletsPreFullMerging"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.minimumLengthOfTrackletsPreFullMerging);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SectionMergingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.SectionMergingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.ISectionMergingConfig} message SectionMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SectionMergingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SectionMergingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SectionMergingConfig} SectionMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SectionMergingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SectionMergingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minIouOverlapping = reader.float();
                                break;
                            case 2:
                                message.numHistoryItemsPerTracklet = reader.int32();
                                break;
                            case 3:
                                message.maximumTimeDistanceSeconds = reader.int32();
                                break;
                            case 4:
                                message.costThresholdToSplitNewPerson = reader.float();
                                break;
                            case 5:
                                message.minimumLengthOfTrackletsPreFullMerging = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SectionMergingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SectionMergingConfig} SectionMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SectionMergingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SectionMergingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SectionMergingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minIouOverlapping != null && message.hasOwnProperty("minIouOverlapping"))
                            if (typeof message.minIouOverlapping !== "number")
                                return "minIouOverlapping: number expected";
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            if (!$util.isInteger(message.numHistoryItemsPerTracklet))
                                return "numHistoryItemsPerTracklet: integer expected";
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            if (!$util.isInteger(message.maximumTimeDistanceSeconds))
                                return "maximumTimeDistanceSeconds: integer expected";
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            if (typeof message.costThresholdToSplitNewPerson !== "number")
                                return "costThresholdToSplitNewPerson: number expected";
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && message.hasOwnProperty("minimumLengthOfTrackletsPreFullMerging"))
                            if (!$util.isInteger(message.minimumLengthOfTrackletsPreFullMerging))
                                return "minimumLengthOfTrackletsPreFullMerging: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a SectionMergingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SectionMergingConfig} SectionMergingConfig
                     */
                    SectionMergingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SectionMergingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.SectionMergingConfig();
                        if (object.minIouOverlapping != null)
                            message.minIouOverlapping = Number(object.minIouOverlapping);
                        if (object.numHistoryItemsPerTracklet != null)
                            message.numHistoryItemsPerTracklet = object.numHistoryItemsPerTracklet | 0;
                        if (object.maximumTimeDistanceSeconds != null)
                            message.maximumTimeDistanceSeconds = object.maximumTimeDistanceSeconds | 0;
                        if (object.costThresholdToSplitNewPerson != null)
                            message.costThresholdToSplitNewPerson = Number(object.costThresholdToSplitNewPerson);
                        if (object.minimumLengthOfTrackletsPreFullMerging != null)
                            message.minimumLengthOfTrackletsPreFullMerging = object.minimumLengthOfTrackletsPreFullMerging | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SectionMergingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.SectionMergingConfig} message SectionMergingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SectionMergingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minIouOverlapping = 0;
                            object.numHistoryItemsPerTracklet = 0;
                            object.maximumTimeDistanceSeconds = 0;
                            object.costThresholdToSplitNewPerson = 0;
                            object.minimumLengthOfTrackletsPreFullMerging = 0;
                        }
                        if (message.minIouOverlapping != null && message.hasOwnProperty("minIouOverlapping"))
                            object.minIouOverlapping = options.json && !isFinite(message.minIouOverlapping) ? String(message.minIouOverlapping) : message.minIouOverlapping;
                        if (message.numHistoryItemsPerTracklet != null && message.hasOwnProperty("numHistoryItemsPerTracklet"))
                            object.numHistoryItemsPerTracklet = message.numHistoryItemsPerTracklet;
                        if (message.maximumTimeDistanceSeconds != null && message.hasOwnProperty("maximumTimeDistanceSeconds"))
                            object.maximumTimeDistanceSeconds = message.maximumTimeDistanceSeconds;
                        if (message.costThresholdToSplitNewPerson != null && message.hasOwnProperty("costThresholdToSplitNewPerson"))
                            object.costThresholdToSplitNewPerson = options.json && !isFinite(message.costThresholdToSplitNewPerson) ? String(message.costThresholdToSplitNewPerson) : message.costThresholdToSplitNewPerson;
                        if (message.minimumLengthOfTrackletsPreFullMerging != null && message.hasOwnProperty("minimumLengthOfTrackletsPreFullMerging"))
                            object.minimumLengthOfTrackletsPreFullMerging = message.minimumLengthOfTrackletsPreFullMerging;
                        return object;
                    };
    
                    /**
                     * Converts this SectionMergingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SectionMergingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SectionMergingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SectionMergingConfig;
                })();
    
                v1.WideSpaceEntranceConfig = (function() {
    
                    /**
                     * Properties of a WideSpaceEntranceConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IWideSpaceEntranceConfig
                     * @property {number|null} [minInsideItems] WideSpaceEntranceConfig minInsideItems
                     * @property {number|null} [minOutsideThreshold] WideSpaceEntranceConfig minOutsideThreshold
                     * @property {number|null} [minNotInterestingItems] WideSpaceEntranceConfig minNotInterestingItems
                     * @property {boolean|null} [skipWideSpaceEntranceFiltering] WideSpaceEntranceConfig skipWideSpaceEntranceFiltering
                     */
    
                    /**
                     * Constructs a new WideSpaceEntranceConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WideSpaceEntranceConfig.
                     * @implements IWideSpaceEntranceConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IWideSpaceEntranceConfig=} [properties] Properties to set
                     */
                    function WideSpaceEntranceConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WideSpaceEntranceConfig minInsideItems.
                     * @member {number} minInsideItems
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @instance
                     */
                    WideSpaceEntranceConfig.prototype.minInsideItems = 0;
    
                    /**
                     * WideSpaceEntranceConfig minOutsideThreshold.
                     * @member {number} minOutsideThreshold
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @instance
                     */
                    WideSpaceEntranceConfig.prototype.minOutsideThreshold = 0;
    
                    /**
                     * WideSpaceEntranceConfig minNotInterestingItems.
                     * @member {number} minNotInterestingItems
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @instance
                     */
                    WideSpaceEntranceConfig.prototype.minNotInterestingItems = 0;
    
                    /**
                     * WideSpaceEntranceConfig skipWideSpaceEntranceFiltering.
                     * @member {boolean} skipWideSpaceEntranceFiltering
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @instance
                     */
                    WideSpaceEntranceConfig.prototype.skipWideSpaceEntranceFiltering = false;
    
                    /**
                     * Creates a new WideSpaceEntranceConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {palexy.streaming.v1.IWideSpaceEntranceConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.WideSpaceEntranceConfig} WideSpaceEntranceConfig instance
                     */
                    WideSpaceEntranceConfig.create = function create(properties) {
                        return new WideSpaceEntranceConfig(properties);
                    };
    
                    /**
                     * Encodes the specified WideSpaceEntranceConfig message. Does not implicitly {@link palexy.streaming.v1.WideSpaceEntranceConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {palexy.streaming.v1.IWideSpaceEntranceConfig} message WideSpaceEntranceConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WideSpaceEntranceConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minInsideItems != null && Object.hasOwnProperty.call(message, "minInsideItems"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minInsideItems);
                        if (message.minOutsideThreshold != null && Object.hasOwnProperty.call(message, "minOutsideThreshold"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.minOutsideThreshold);
                        if (message.minNotInterestingItems != null && Object.hasOwnProperty.call(message, "minNotInterestingItems"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.minNotInterestingItems);
                        if (message.skipWideSpaceEntranceFiltering != null && Object.hasOwnProperty.call(message, "skipWideSpaceEntranceFiltering"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.skipWideSpaceEntranceFiltering);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WideSpaceEntranceConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.WideSpaceEntranceConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {palexy.streaming.v1.IWideSpaceEntranceConfig} message WideSpaceEntranceConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WideSpaceEntranceConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WideSpaceEntranceConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.WideSpaceEntranceConfig} WideSpaceEntranceConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WideSpaceEntranceConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.WideSpaceEntranceConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minInsideItems = reader.int32();
                                break;
                            case 2:
                                message.minOutsideThreshold = reader.float();
                                break;
                            case 3:
                                message.minNotInterestingItems = reader.int32();
                                break;
                            case 4:
                                message.skipWideSpaceEntranceFiltering = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WideSpaceEntranceConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.WideSpaceEntranceConfig} WideSpaceEntranceConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WideSpaceEntranceConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WideSpaceEntranceConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WideSpaceEntranceConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minInsideItems != null && message.hasOwnProperty("minInsideItems"))
                            if (!$util.isInteger(message.minInsideItems))
                                return "minInsideItems: integer expected";
                        if (message.minOutsideThreshold != null && message.hasOwnProperty("minOutsideThreshold"))
                            if (typeof message.minOutsideThreshold !== "number")
                                return "minOutsideThreshold: number expected";
                        if (message.minNotInterestingItems != null && message.hasOwnProperty("minNotInterestingItems"))
                            if (!$util.isInteger(message.minNotInterestingItems))
                                return "minNotInterestingItems: integer expected";
                        if (message.skipWideSpaceEntranceFiltering != null && message.hasOwnProperty("skipWideSpaceEntranceFiltering"))
                            if (typeof message.skipWideSpaceEntranceFiltering !== "boolean")
                                return "skipWideSpaceEntranceFiltering: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a WideSpaceEntranceConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.WideSpaceEntranceConfig} WideSpaceEntranceConfig
                     */
                    WideSpaceEntranceConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.WideSpaceEntranceConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.WideSpaceEntranceConfig();
                        if (object.minInsideItems != null)
                            message.minInsideItems = object.minInsideItems | 0;
                        if (object.minOutsideThreshold != null)
                            message.minOutsideThreshold = Number(object.minOutsideThreshold);
                        if (object.minNotInterestingItems != null)
                            message.minNotInterestingItems = object.minNotInterestingItems | 0;
                        if (object.skipWideSpaceEntranceFiltering != null)
                            message.skipWideSpaceEntranceFiltering = Boolean(object.skipWideSpaceEntranceFiltering);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WideSpaceEntranceConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @static
                     * @param {palexy.streaming.v1.WideSpaceEntranceConfig} message WideSpaceEntranceConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WideSpaceEntranceConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minInsideItems = 0;
                            object.minOutsideThreshold = 0;
                            object.minNotInterestingItems = 0;
                            object.skipWideSpaceEntranceFiltering = false;
                        }
                        if (message.minInsideItems != null && message.hasOwnProperty("minInsideItems"))
                            object.minInsideItems = message.minInsideItems;
                        if (message.minOutsideThreshold != null && message.hasOwnProperty("minOutsideThreshold"))
                            object.minOutsideThreshold = options.json && !isFinite(message.minOutsideThreshold) ? String(message.minOutsideThreshold) : message.minOutsideThreshold;
                        if (message.minNotInterestingItems != null && message.hasOwnProperty("minNotInterestingItems"))
                            object.minNotInterestingItems = message.minNotInterestingItems;
                        if (message.skipWideSpaceEntranceFiltering != null && message.hasOwnProperty("skipWideSpaceEntranceFiltering"))
                            object.skipWideSpaceEntranceFiltering = message.skipWideSpaceEntranceFiltering;
                        return object;
                    };
    
                    /**
                     * Converts this WideSpaceEntranceConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.WideSpaceEntranceConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WideSpaceEntranceConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return WideSpaceEntranceConfig;
                })();
    
                v1.RunMallMergingConfig = (function() {
    
                    /**
                     * Properties of a RunMallMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IRunMallMergingConfig
                     * @property {number|null} [thresholdMergePersonInOut] RunMallMergingConfig thresholdMergePersonInOut
                     * @property {number|null} [thresholdDistanceForCompanion] RunMallMergingConfig thresholdDistanceForCompanion
                     * @property {number|null} [localVeryCloseFeatureDistance] RunMallMergingConfig localVeryCloseFeatureDistance
                     * @property {number|null} [localVeryCloseIndexDistance] RunMallMergingConfig localVeryCloseIndexDistance
                     * @property {boolean|null} [runMergeLocalVeryClose] RunMallMergingConfig runMergeLocalVeryClose
                     */
    
                    /**
                     * Constructs a new RunMallMergingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RunMallMergingConfig.
                     * @implements IRunMallMergingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IRunMallMergingConfig=} [properties] Properties to set
                     */
                    function RunMallMergingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RunMallMergingConfig thresholdMergePersonInOut.
                     * @member {number} thresholdMergePersonInOut
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     */
                    RunMallMergingConfig.prototype.thresholdMergePersonInOut = 0;
    
                    /**
                     * RunMallMergingConfig thresholdDistanceForCompanion.
                     * @member {number} thresholdDistanceForCompanion
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     */
                    RunMallMergingConfig.prototype.thresholdDistanceForCompanion = 0;
    
                    /**
                     * RunMallMergingConfig localVeryCloseFeatureDistance.
                     * @member {number} localVeryCloseFeatureDistance
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     */
                    RunMallMergingConfig.prototype.localVeryCloseFeatureDistance = 0;
    
                    /**
                     * RunMallMergingConfig localVeryCloseIndexDistance.
                     * @member {number} localVeryCloseIndexDistance
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     */
                    RunMallMergingConfig.prototype.localVeryCloseIndexDistance = 0;
    
                    /**
                     * RunMallMergingConfig runMergeLocalVeryClose.
                     * @member {boolean} runMergeLocalVeryClose
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     */
                    RunMallMergingConfig.prototype.runMergeLocalVeryClose = false;
    
                    /**
                     * Creates a new RunMallMergingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRunMallMergingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RunMallMergingConfig} RunMallMergingConfig instance
                     */
                    RunMallMergingConfig.create = function create(properties) {
                        return new RunMallMergingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified RunMallMergingConfig message. Does not implicitly {@link palexy.streaming.v1.RunMallMergingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRunMallMergingConfig} message RunMallMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RunMallMergingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.thresholdMergePersonInOut != null && Object.hasOwnProperty.call(message, "thresholdMergePersonInOut"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.thresholdMergePersonInOut);
                        if (message.thresholdDistanceForCompanion != null && Object.hasOwnProperty.call(message, "thresholdDistanceForCompanion"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.thresholdDistanceForCompanion);
                        if (message.localVeryCloseFeatureDistance != null && Object.hasOwnProperty.call(message, "localVeryCloseFeatureDistance"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.localVeryCloseFeatureDistance);
                        if (message.localVeryCloseIndexDistance != null && Object.hasOwnProperty.call(message, "localVeryCloseIndexDistance"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.localVeryCloseIndexDistance);
                        if (message.runMergeLocalVeryClose != null && Object.hasOwnProperty.call(message, "runMergeLocalVeryClose"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.runMergeLocalVeryClose);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RunMallMergingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.RunMallMergingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.IRunMallMergingConfig} message RunMallMergingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RunMallMergingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RunMallMergingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RunMallMergingConfig} RunMallMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RunMallMergingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RunMallMergingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.thresholdMergePersonInOut = reader.float();
                                break;
                            case 2:
                                message.thresholdDistanceForCompanion = reader.float();
                                break;
                            case 3:
                                message.localVeryCloseFeatureDistance = reader.float();
                                break;
                            case 4:
                                message.localVeryCloseIndexDistance = reader.int32();
                                break;
                            case 5:
                                message.runMergeLocalVeryClose = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RunMallMergingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RunMallMergingConfig} RunMallMergingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RunMallMergingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RunMallMergingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RunMallMergingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.thresholdMergePersonInOut != null && message.hasOwnProperty("thresholdMergePersonInOut"))
                            if (typeof message.thresholdMergePersonInOut !== "number")
                                return "thresholdMergePersonInOut: number expected";
                        if (message.thresholdDistanceForCompanion != null && message.hasOwnProperty("thresholdDistanceForCompanion"))
                            if (typeof message.thresholdDistanceForCompanion !== "number")
                                return "thresholdDistanceForCompanion: number expected";
                        if (message.localVeryCloseFeatureDistance != null && message.hasOwnProperty("localVeryCloseFeatureDistance"))
                            if (typeof message.localVeryCloseFeatureDistance !== "number")
                                return "localVeryCloseFeatureDistance: number expected";
                        if (message.localVeryCloseIndexDistance != null && message.hasOwnProperty("localVeryCloseIndexDistance"))
                            if (!$util.isInteger(message.localVeryCloseIndexDistance))
                                return "localVeryCloseIndexDistance: integer expected";
                        if (message.runMergeLocalVeryClose != null && message.hasOwnProperty("runMergeLocalVeryClose"))
                            if (typeof message.runMergeLocalVeryClose !== "boolean")
                                return "runMergeLocalVeryClose: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a RunMallMergingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RunMallMergingConfig} RunMallMergingConfig
                     */
                    RunMallMergingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RunMallMergingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.RunMallMergingConfig();
                        if (object.thresholdMergePersonInOut != null)
                            message.thresholdMergePersonInOut = Number(object.thresholdMergePersonInOut);
                        if (object.thresholdDistanceForCompanion != null)
                            message.thresholdDistanceForCompanion = Number(object.thresholdDistanceForCompanion);
                        if (object.localVeryCloseFeatureDistance != null)
                            message.localVeryCloseFeatureDistance = Number(object.localVeryCloseFeatureDistance);
                        if (object.localVeryCloseIndexDistance != null)
                            message.localVeryCloseIndexDistance = object.localVeryCloseIndexDistance | 0;
                        if (object.runMergeLocalVeryClose != null)
                            message.runMergeLocalVeryClose = Boolean(object.runMergeLocalVeryClose);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RunMallMergingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @static
                     * @param {palexy.streaming.v1.RunMallMergingConfig} message RunMallMergingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RunMallMergingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.thresholdMergePersonInOut = 0;
                            object.thresholdDistanceForCompanion = 0;
                            object.localVeryCloseFeatureDistance = 0;
                            object.localVeryCloseIndexDistance = 0;
                            object.runMergeLocalVeryClose = false;
                        }
                        if (message.thresholdMergePersonInOut != null && message.hasOwnProperty("thresholdMergePersonInOut"))
                            object.thresholdMergePersonInOut = options.json && !isFinite(message.thresholdMergePersonInOut) ? String(message.thresholdMergePersonInOut) : message.thresholdMergePersonInOut;
                        if (message.thresholdDistanceForCompanion != null && message.hasOwnProperty("thresholdDistanceForCompanion"))
                            object.thresholdDistanceForCompanion = options.json && !isFinite(message.thresholdDistanceForCompanion) ? String(message.thresholdDistanceForCompanion) : message.thresholdDistanceForCompanion;
                        if (message.localVeryCloseFeatureDistance != null && message.hasOwnProperty("localVeryCloseFeatureDistance"))
                            object.localVeryCloseFeatureDistance = options.json && !isFinite(message.localVeryCloseFeatureDistance) ? String(message.localVeryCloseFeatureDistance) : message.localVeryCloseFeatureDistance;
                        if (message.localVeryCloseIndexDistance != null && message.hasOwnProperty("localVeryCloseIndexDistance"))
                            object.localVeryCloseIndexDistance = message.localVeryCloseIndexDistance;
                        if (message.runMergeLocalVeryClose != null && message.hasOwnProperty("runMergeLocalVeryClose"))
                            object.runMergeLocalVeryClose = message.runMergeLocalVeryClose;
                        return object;
                    };
    
                    /**
                     * Converts this RunMallMergingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RunMallMergingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RunMallMergingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RunMallMergingConfig;
                })();
    
                v1.DetectCameraShiftRequest = (function() {
    
                    /**
                     * Properties of a DetectCameraShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDetectCameraShiftRequest
                     * @property {palexy.streaming.v1.ICamera|null} [camera] DetectCameraShiftRequest camera
                     */
    
                    /**
                     * Constructs a new DetectCameraShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DetectCameraShiftRequest.
                     * @implements IDetectCameraShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest=} [properties] Properties to set
                     */
                    function DetectCameraShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DetectCameraShiftRequest camera.
                     * @member {palexy.streaming.v1.ICamera|null|undefined} camera
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @instance
                     */
                    DetectCameraShiftRequest.prototype.camera = null;
    
                    /**
                     * Creates a new DetectCameraShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DetectCameraShiftRequest} DetectCameraShiftRequest instance
                     */
                    DetectCameraShiftRequest.create = function create(properties) {
                        return new DetectCameraShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DetectCameraShiftRequest message. Does not implicitly {@link palexy.streaming.v1.DetectCameraShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest} message DetectCameraShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetectCameraShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.camera != null && Object.hasOwnProperty.call(message, "camera"))
                            $root.palexy.streaming.v1.Camera.encode(message.camera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DetectCameraShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DetectCameraShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftRequest} message DetectCameraShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetectCameraShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DetectCameraShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DetectCameraShiftRequest} DetectCameraShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetectCameraShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DetectCameraShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.camera = $root.palexy.streaming.v1.Camera.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DetectCameraShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DetectCameraShiftRequest} DetectCameraShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetectCameraShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DetectCameraShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DetectCameraShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.camera != null && message.hasOwnProperty("camera")) {
                            var error = $root.palexy.streaming.v1.Camera.verify(message.camera);
                            if (error)
                                return "camera." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DetectCameraShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DetectCameraShiftRequest} DetectCameraShiftRequest
                     */
                    DetectCameraShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DetectCameraShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DetectCameraShiftRequest();
                        if (object.camera != null) {
                            if (typeof object.camera !== "object")
                                throw TypeError(".palexy.streaming.v1.DetectCameraShiftRequest.camera: object expected");
                            message.camera = $root.palexy.streaming.v1.Camera.fromObject(object.camera);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DetectCameraShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.DetectCameraShiftRequest} message DetectCameraShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DetectCameraShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.camera = null;
                        if (message.camera != null && message.hasOwnProperty("camera"))
                            object.camera = $root.palexy.streaming.v1.Camera.toObject(message.camera, options);
                        return object;
                    };
    
                    /**
                     * Converts this DetectCameraShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DetectCameraShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DetectCameraShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DetectCameraShiftRequest;
                })();
    
                v1.DetectCameraShiftResponse = (function() {
    
                    /**
                     * Properties of a DetectCameraShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IDetectCameraShiftResponse
                     * @property {string|null} [cameraId] DetectCameraShiftResponse cameraId
                     * @property {number|null} [cameraPrimaryId] DetectCameraShiftResponse cameraPrimaryId
                     * @property {palexy.streaming.v1.DetectCameraShiftResponse.CameraShiftStatus|null} [status] DetectCameraShiftResponse status
                     * @property {number|null} [referenceImageId] DetectCameraShiftResponse referenceImageId
                     * @property {number|null} [testImageId] DetectCameraShiftResponse testImageId
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [referenceImage] DetectCameraShiftResponse referenceImage
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [testImage] DetectCameraShiftResponse testImage
                     */
    
                    /**
                     * Constructs a new DetectCameraShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DetectCameraShiftResponse.
                     * @implements IDetectCameraShiftResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IDetectCameraShiftResponse=} [properties] Properties to set
                     */
                    function DetectCameraShiftResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DetectCameraShiftResponse cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.cameraId = "";
    
                    /**
                     * DetectCameraShiftResponse cameraPrimaryId.
                     * @member {number} cameraPrimaryId
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.cameraPrimaryId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DetectCameraShiftResponse status.
                     * @member {palexy.streaming.v1.DetectCameraShiftResponse.CameraShiftStatus} status
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.status = 0;
    
                    /**
                     * DetectCameraShiftResponse referenceImageId.
                     * @member {number} referenceImageId
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.referenceImageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DetectCameraShiftResponse testImageId.
                     * @member {number} testImageId
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.testImageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DetectCameraShiftResponse referenceImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} referenceImage
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.referenceImage = null;
    
                    /**
                     * DetectCameraShiftResponse testImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} testImage
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     */
                    DetectCameraShiftResponse.prototype.testImage = null;
    
                    /**
                     * Creates a new DetectCameraShiftResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DetectCameraShiftResponse} DetectCameraShiftResponse instance
                     */
                    DetectCameraShiftResponse.create = function create(properties) {
                        return new DetectCameraShiftResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DetectCameraShiftResponse message. Does not implicitly {@link palexy.streaming.v1.DetectCameraShiftResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftResponse} message DetectCameraShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetectCameraShiftResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.cameraPrimaryId != null && Object.hasOwnProperty.call(message, "cameraPrimaryId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.cameraPrimaryId);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.status);
                        if (message.referenceImageId != null && Object.hasOwnProperty.call(message, "referenceImageId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.referenceImageId);
                        if (message.testImageId != null && Object.hasOwnProperty.call(message, "testImageId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.testImageId);
                        if (message.referenceImage != null && Object.hasOwnProperty.call(message, "referenceImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.referenceImage, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.testImage != null && Object.hasOwnProperty.call(message, "testImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.testImage, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DetectCameraShiftResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.DetectCameraShiftResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDetectCameraShiftResponse} message DetectCameraShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DetectCameraShiftResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DetectCameraShiftResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DetectCameraShiftResponse} DetectCameraShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetectCameraShiftResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DetectCameraShiftResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.cameraPrimaryId = reader.int64();
                                break;
                            case 3:
                                message.status = reader.int32();
                                break;
                            case 4:
                                message.referenceImageId = reader.int64();
                                break;
                            case 5:
                                message.testImageId = reader.int64();
                                break;
                            case 6:
                                message.referenceImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.testImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DetectCameraShiftResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DetectCameraShiftResponse} DetectCameraShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DetectCameraShiftResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DetectCameraShiftResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DetectCameraShiftResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (!$util.isInteger(message.cameraPrimaryId) && !(message.cameraPrimaryId && $util.isInteger(message.cameraPrimaryId.low) && $util.isInteger(message.cameraPrimaryId.high)))
                                return "cameraPrimaryId: integer|Long expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.referenceImageId != null && message.hasOwnProperty("referenceImageId"))
                            if (!$util.isInteger(message.referenceImageId) && !(message.referenceImageId && $util.isInteger(message.referenceImageId.low) && $util.isInteger(message.referenceImageId.high)))
                                return "referenceImageId: integer|Long expected";
                        if (message.testImageId != null && message.hasOwnProperty("testImageId"))
                            if (!$util.isInteger(message.testImageId) && !(message.testImageId && $util.isInteger(message.testImageId.low) && $util.isInteger(message.testImageId.high)))
                                return "testImageId: integer|Long expected";
                        if (message.referenceImage != null && message.hasOwnProperty("referenceImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.referenceImage);
                            if (error)
                                return "referenceImage." + error;
                        }
                        if (message.testImage != null && message.hasOwnProperty("testImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.testImage);
                            if (error)
                                return "testImage." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DetectCameraShiftResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DetectCameraShiftResponse} DetectCameraShiftResponse
                     */
                    DetectCameraShiftResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DetectCameraShiftResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.DetectCameraShiftResponse();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.cameraPrimaryId != null)
                            if ($util.Long)
                                (message.cameraPrimaryId = $util.Long.fromValue(object.cameraPrimaryId)).unsigned = false;
                            else if (typeof object.cameraPrimaryId === "string")
                                message.cameraPrimaryId = parseInt(object.cameraPrimaryId, 10);
                            else if (typeof object.cameraPrimaryId === "number")
                                message.cameraPrimaryId = object.cameraPrimaryId;
                            else if (typeof object.cameraPrimaryId === "object")
                                message.cameraPrimaryId = new $util.LongBits(object.cameraPrimaryId.low >>> 0, object.cameraPrimaryId.high >>> 0).toNumber();
                        switch (object.status) {
                        case "UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "SHIFTED":
                        case 1:
                            message.status = 1;
                            break;
                        case "NOT_SHIFTED":
                        case 2:
                            message.status = 2;
                            break;
                        case "SUSPECTED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.referenceImageId != null)
                            if ($util.Long)
                                (message.referenceImageId = $util.Long.fromValue(object.referenceImageId)).unsigned = false;
                            else if (typeof object.referenceImageId === "string")
                                message.referenceImageId = parseInt(object.referenceImageId, 10);
                            else if (typeof object.referenceImageId === "number")
                                message.referenceImageId = object.referenceImageId;
                            else if (typeof object.referenceImageId === "object")
                                message.referenceImageId = new $util.LongBits(object.referenceImageId.low >>> 0, object.referenceImageId.high >>> 0).toNumber();
                        if (object.testImageId != null)
                            if ($util.Long)
                                (message.testImageId = $util.Long.fromValue(object.testImageId)).unsigned = false;
                            else if (typeof object.testImageId === "string")
                                message.testImageId = parseInt(object.testImageId, 10);
                            else if (typeof object.testImageId === "number")
                                message.testImageId = object.testImageId;
                            else if (typeof object.testImageId === "object")
                                message.testImageId = new $util.LongBits(object.testImageId.low >>> 0, object.testImageId.high >>> 0).toNumber();
                        if (object.referenceImage != null) {
                            if (typeof object.referenceImage !== "object")
                                throw TypeError(".palexy.streaming.v1.DetectCameraShiftResponse.referenceImage: object expected");
                            message.referenceImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.referenceImage);
                        }
                        if (object.testImage != null) {
                            if (typeof object.testImage !== "object")
                                throw TypeError(".palexy.streaming.v1.DetectCameraShiftResponse.testImage: object expected");
                            message.testImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.testImage);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DetectCameraShiftResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.DetectCameraShiftResponse} message DetectCameraShiftResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DetectCameraShiftResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.cameraId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraPrimaryId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraPrimaryId = options.longs === String ? "0" : 0;
                            object.status = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.referenceImageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.referenceImageId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testImageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testImageId = options.longs === String ? "0" : 0;
                            object.referenceImage = null;
                            object.testImage = null;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (typeof message.cameraPrimaryId === "number")
                                object.cameraPrimaryId = options.longs === String ? String(message.cameraPrimaryId) : message.cameraPrimaryId;
                            else
                                object.cameraPrimaryId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraPrimaryId) : options.longs === Number ? new $util.LongBits(message.cameraPrimaryId.low >>> 0, message.cameraPrimaryId.high >>> 0).toNumber() : message.cameraPrimaryId;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.DetectCameraShiftResponse.CameraShiftStatus[message.status] : message.status;
                        if (message.referenceImageId != null && message.hasOwnProperty("referenceImageId"))
                            if (typeof message.referenceImageId === "number")
                                object.referenceImageId = options.longs === String ? String(message.referenceImageId) : message.referenceImageId;
                            else
                                object.referenceImageId = options.longs === String ? $util.Long.prototype.toString.call(message.referenceImageId) : options.longs === Number ? new $util.LongBits(message.referenceImageId.low >>> 0, message.referenceImageId.high >>> 0).toNumber() : message.referenceImageId;
                        if (message.testImageId != null && message.hasOwnProperty("testImageId"))
                            if (typeof message.testImageId === "number")
                                object.testImageId = options.longs === String ? String(message.testImageId) : message.testImageId;
                            else
                                object.testImageId = options.longs === String ? $util.Long.prototype.toString.call(message.testImageId) : options.longs === Number ? new $util.LongBits(message.testImageId.low >>> 0, message.testImageId.high >>> 0).toNumber() : message.testImageId;
                        if (message.referenceImage != null && message.hasOwnProperty("referenceImage"))
                            object.referenceImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.referenceImage, options);
                        if (message.testImage != null && message.hasOwnProperty("testImage"))
                            object.testImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.testImage, options);
                        return object;
                    };
    
                    /**
                     * Converts this DetectCameraShiftResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DetectCameraShiftResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DetectCameraShiftResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * CameraShiftStatus enum.
                     * @name palexy.streaming.v1.DetectCameraShiftResponse.CameraShiftStatus
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} SHIFTED=1 SHIFTED value
                     * @property {number} NOT_SHIFTED=2 NOT_SHIFTED value
                     * @property {number} SUSPECTED=3 SUSPECTED value
                     */
                    DetectCameraShiftResponse.CameraShiftStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "SHIFTED"] = 1;
                        values[valuesById[2] = "NOT_SHIFTED"] = 2;
                        values[valuesById[3] = "SUSPECTED"] = 3;
                        return values;
                    })();
    
                    return DetectCameraShiftResponse;
                })();
    
                v1.CameraShiftEventService = (function() {
    
                    /**
                     * Constructs a new CameraShiftEventService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraShiftEventService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CameraShiftEventService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CameraShiftEventService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CameraShiftEventService;
    
                    /**
                     * Creates new CameraShiftEventService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CameraShiftEventService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CameraShiftEventService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraShiftEventService#createCameraShiftEvent}.
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @typedef CreateCameraShiftEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CameraShiftEvent} [response] CameraShiftEvent
                     */
    
                    /**
                     * Calls CreateCameraShiftEvent.
                     * @function createCameraShiftEvent
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICameraShiftEvent} request CameraShiftEvent message or plain object
                     * @param {palexy.streaming.v1.CameraShiftEventService.CreateCameraShiftEventCallback} callback Node-style callback called with the error, if any, and CameraShiftEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraShiftEventService.prototype.createCameraShiftEvent = function createCameraShiftEvent(request, callback) {
                        return this.rpcCall(createCameraShiftEvent, $root.palexy.streaming.v1.CameraShiftEvent, $root.palexy.streaming.v1.CameraShiftEvent, request, callback);
                    }, "name", { value: "CreateCameraShiftEvent" });
    
                    /**
                     * Calls CreateCameraShiftEvent.
                     * @function createCameraShiftEvent
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICameraShiftEvent} request CameraShiftEvent message or plain object
                     * @returns {Promise<palexy.streaming.v1.CameraShiftEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CameraShiftEventService#updateCameraShiftEvent}.
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @typedef UpdateCameraShiftEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CameraShiftEvent} [response] CameraShiftEvent
                     */
    
                    /**
                     * Calls UpdateCameraShiftEvent.
                     * @function updateCameraShiftEvent
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest} request UpdateCameraShiftEventRequest message or plain object
                     * @param {palexy.streaming.v1.CameraShiftEventService.UpdateCameraShiftEventCallback} callback Node-style callback called with the error, if any, and CameraShiftEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CameraShiftEventService.prototype.updateCameraShiftEvent = function updateCameraShiftEvent(request, callback) {
                        return this.rpcCall(updateCameraShiftEvent, $root.palexy.streaming.v1.UpdateCameraShiftEventRequest, $root.palexy.streaming.v1.CameraShiftEvent, request, callback);
                    }, "name", { value: "UpdateCameraShiftEvent" });
    
                    /**
                     * Calls UpdateCameraShiftEvent.
                     * @function updateCameraShiftEvent
                     * @memberof palexy.streaming.v1.CameraShiftEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest} request UpdateCameraShiftEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CameraShiftEvent>} Promise
                     * @variation 2
                     */
    
                    return CameraShiftEventService;
                })();
    
                v1.CameraShiftEvent = (function() {
    
                    /**
                     * Properties of a CameraShiftEvent.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraShiftEvent
                     * @property {number|null} [id] CameraShiftEvent id
                     * @property {string|null} [cameraId] CameraShiftEvent cameraId
                     * @property {number|null} [cameraPrimaryId] CameraShiftEvent cameraPrimaryId
                     * @property {number|null} [referenceImageId] CameraShiftEvent referenceImageId
                     * @property {number|null} [testImageId] CameraShiftEvent testImageId
                     * @property {palexy.streaming.v1.CameraShiftEvent.ShiftEventStatus|null} [status] CameraShiftEvent status
                     * @property {google.protobuf.ITimestamp|null} [createTime] CameraShiftEvent createTime
                     * @property {number|null} [activityLogId] CameraShiftEvent activityLogId
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [referenceImage] CameraShiftEvent referenceImage
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [testImage] CameraShiftEvent testImage
                     */
    
                    /**
                     * Constructs a new CameraShiftEvent.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraShiftEvent.
                     * @implements ICameraShiftEvent
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraShiftEvent=} [properties] Properties to set
                     */
                    function CameraShiftEvent(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraShiftEvent id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraShiftEvent cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.cameraId = "";
    
                    /**
                     * CameraShiftEvent cameraPrimaryId.
                     * @member {number} cameraPrimaryId
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.cameraPrimaryId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraShiftEvent referenceImageId.
                     * @member {number} referenceImageId
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.referenceImageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraShiftEvent testImageId.
                     * @member {number} testImageId
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.testImageId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraShiftEvent status.
                     * @member {palexy.streaming.v1.CameraShiftEvent.ShiftEventStatus} status
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.status = 0;
    
                    /**
                     * CameraShiftEvent createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.createTime = null;
    
                    /**
                     * CameraShiftEvent activityLogId.
                     * @member {number} activityLogId
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.activityLogId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraShiftEvent referenceImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} referenceImage
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.referenceImage = null;
    
                    /**
                     * CameraShiftEvent testImage.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} testImage
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     */
                    CameraShiftEvent.prototype.testImage = null;
    
                    /**
                     * Creates a new CameraShiftEvent instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {palexy.streaming.v1.ICameraShiftEvent=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraShiftEvent} CameraShiftEvent instance
                     */
                    CameraShiftEvent.create = function create(properties) {
                        return new CameraShiftEvent(properties);
                    };
    
                    /**
                     * Encodes the specified CameraShiftEvent message. Does not implicitly {@link palexy.streaming.v1.CameraShiftEvent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {palexy.streaming.v1.ICameraShiftEvent} message CameraShiftEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraShiftEvent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.cameraPrimaryId != null && Object.hasOwnProperty.call(message, "cameraPrimaryId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.cameraPrimaryId);
                        if (message.referenceImageId != null && Object.hasOwnProperty.call(message, "referenceImageId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.referenceImageId);
                        if (message.testImageId != null && Object.hasOwnProperty.call(message, "testImageId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.testImageId);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.status);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.activityLogId != null && Object.hasOwnProperty.call(message, "activityLogId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.activityLogId);
                        if (message.referenceImage != null && Object.hasOwnProperty.call(message, "referenceImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.referenceImage, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.testImage != null && Object.hasOwnProperty.call(message, "testImage"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.testImage, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraShiftEvent message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraShiftEvent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {palexy.streaming.v1.ICameraShiftEvent} message CameraShiftEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraShiftEvent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraShiftEvent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraShiftEvent} CameraShiftEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraShiftEvent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraShiftEvent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.cameraPrimaryId = reader.int64();
                                break;
                            case 4:
                                message.referenceImageId = reader.int64();
                                break;
                            case 5:
                                message.testImageId = reader.int64();
                                break;
                            case 6:
                                message.status = reader.int32();
                                break;
                            case 7:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.activityLogId = reader.int64();
                                break;
                            case 9:
                                message.referenceImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.testImage = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraShiftEvent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraShiftEvent} CameraShiftEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraShiftEvent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraShiftEvent message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraShiftEvent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (!$util.isInteger(message.cameraPrimaryId) && !(message.cameraPrimaryId && $util.isInteger(message.cameraPrimaryId.low) && $util.isInteger(message.cameraPrimaryId.high)))
                                return "cameraPrimaryId: integer|Long expected";
                        if (message.referenceImageId != null && message.hasOwnProperty("referenceImageId"))
                            if (!$util.isInteger(message.referenceImageId) && !(message.referenceImageId && $util.isInteger(message.referenceImageId.low) && $util.isInteger(message.referenceImageId.high)))
                                return "referenceImageId: integer|Long expected";
                        if (message.testImageId != null && message.hasOwnProperty("testImageId"))
                            if (!$util.isInteger(message.testImageId) && !(message.testImageId && $util.isInteger(message.testImageId.low) && $util.isInteger(message.testImageId.high)))
                                return "testImageId: integer|Long expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.activityLogId != null && message.hasOwnProperty("activityLogId"))
                            if (!$util.isInteger(message.activityLogId) && !(message.activityLogId && $util.isInteger(message.activityLogId.low) && $util.isInteger(message.activityLogId.high)))
                                return "activityLogId: integer|Long expected";
                        if (message.referenceImage != null && message.hasOwnProperty("referenceImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.referenceImage);
                            if (error)
                                return "referenceImage." + error;
                        }
                        if (message.testImage != null && message.hasOwnProperty("testImage")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.testImage);
                            if (error)
                                return "testImage." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CameraShiftEvent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraShiftEvent} CameraShiftEvent
                     */
                    CameraShiftEvent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraShiftEvent)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraShiftEvent();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.cameraPrimaryId != null)
                            if ($util.Long)
                                (message.cameraPrimaryId = $util.Long.fromValue(object.cameraPrimaryId)).unsigned = false;
                            else if (typeof object.cameraPrimaryId === "string")
                                message.cameraPrimaryId = parseInt(object.cameraPrimaryId, 10);
                            else if (typeof object.cameraPrimaryId === "number")
                                message.cameraPrimaryId = object.cameraPrimaryId;
                            else if (typeof object.cameraPrimaryId === "object")
                                message.cameraPrimaryId = new $util.LongBits(object.cameraPrimaryId.low >>> 0, object.cameraPrimaryId.high >>> 0).toNumber();
                        if (object.referenceImageId != null)
                            if ($util.Long)
                                (message.referenceImageId = $util.Long.fromValue(object.referenceImageId)).unsigned = false;
                            else if (typeof object.referenceImageId === "string")
                                message.referenceImageId = parseInt(object.referenceImageId, 10);
                            else if (typeof object.referenceImageId === "number")
                                message.referenceImageId = object.referenceImageId;
                            else if (typeof object.referenceImageId === "object")
                                message.referenceImageId = new $util.LongBits(object.referenceImageId.low >>> 0, object.referenceImageId.high >>> 0).toNumber();
                        if (object.testImageId != null)
                            if ($util.Long)
                                (message.testImageId = $util.Long.fromValue(object.testImageId)).unsigned = false;
                            else if (typeof object.testImageId === "string")
                                message.testImageId = parseInt(object.testImageId, 10);
                            else if (typeof object.testImageId === "number")
                                message.testImageId = object.testImageId;
                            else if (typeof object.testImageId === "object")
                                message.testImageId = new $util.LongBits(object.testImageId.low >>> 0, object.testImageId.high >>> 0).toNumber();
                        switch (object.status) {
                        case "UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "WAITING_FOR_REVIEW":
                        case 1:
                            message.status = 1;
                            break;
                        case "SHIFTED":
                        case 2:
                            message.status = 2;
                            break;
                        case "RESOLVED":
                        case 3:
                            message.status = 3;
                            break;
                        case "NOT_SHIFTED":
                        case 4:
                            message.status = 4;
                            break;
                        case "EXPIRED":
                        case 5:
                            message.status = 5;
                            break;
                        }
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraShiftEvent.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.activityLogId != null)
                            if ($util.Long)
                                (message.activityLogId = $util.Long.fromValue(object.activityLogId)).unsigned = false;
                            else if (typeof object.activityLogId === "string")
                                message.activityLogId = parseInt(object.activityLogId, 10);
                            else if (typeof object.activityLogId === "number")
                                message.activityLogId = object.activityLogId;
                            else if (typeof object.activityLogId === "object")
                                message.activityLogId = new $util.LongBits(object.activityLogId.low >>> 0, object.activityLogId.high >>> 0).toNumber();
                        if (object.referenceImage != null) {
                            if (typeof object.referenceImage !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraShiftEvent.referenceImage: object expected");
                            message.referenceImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.referenceImage);
                        }
                        if (object.testImage != null) {
                            if (typeof object.testImage !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraShiftEvent.testImage: object expected");
                            message.testImage = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.testImage);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraShiftEvent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @static
                     * @param {palexy.streaming.v1.CameraShiftEvent} message CameraShiftEvent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraShiftEvent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.cameraId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraPrimaryId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraPrimaryId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.referenceImageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.referenceImageId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.testImageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.testImageId = options.longs === String ? "0" : 0;
                            object.status = options.enums === String ? "UNKNOWN" : 0;
                            object.createTime = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.activityLogId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.activityLogId = options.longs === String ? "0" : 0;
                            object.referenceImage = null;
                            object.testImage = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.cameraPrimaryId != null && message.hasOwnProperty("cameraPrimaryId"))
                            if (typeof message.cameraPrimaryId === "number")
                                object.cameraPrimaryId = options.longs === String ? String(message.cameraPrimaryId) : message.cameraPrimaryId;
                            else
                                object.cameraPrimaryId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraPrimaryId) : options.longs === Number ? new $util.LongBits(message.cameraPrimaryId.low >>> 0, message.cameraPrimaryId.high >>> 0).toNumber() : message.cameraPrimaryId;
                        if (message.referenceImageId != null && message.hasOwnProperty("referenceImageId"))
                            if (typeof message.referenceImageId === "number")
                                object.referenceImageId = options.longs === String ? String(message.referenceImageId) : message.referenceImageId;
                            else
                                object.referenceImageId = options.longs === String ? $util.Long.prototype.toString.call(message.referenceImageId) : options.longs === Number ? new $util.LongBits(message.referenceImageId.low >>> 0, message.referenceImageId.high >>> 0).toNumber() : message.referenceImageId;
                        if (message.testImageId != null && message.hasOwnProperty("testImageId"))
                            if (typeof message.testImageId === "number")
                                object.testImageId = options.longs === String ? String(message.testImageId) : message.testImageId;
                            else
                                object.testImageId = options.longs === String ? $util.Long.prototype.toString.call(message.testImageId) : options.longs === Number ? new $util.LongBits(message.testImageId.low >>> 0, message.testImageId.high >>> 0).toNumber() : message.testImageId;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.CameraShiftEvent.ShiftEventStatus[message.status] : message.status;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.activityLogId != null && message.hasOwnProperty("activityLogId"))
                            if (typeof message.activityLogId === "number")
                                object.activityLogId = options.longs === String ? String(message.activityLogId) : message.activityLogId;
                            else
                                object.activityLogId = options.longs === String ? $util.Long.prototype.toString.call(message.activityLogId) : options.longs === Number ? new $util.LongBits(message.activityLogId.low >>> 0, message.activityLogId.high >>> 0).toNumber() : message.activityLogId;
                        if (message.referenceImage != null && message.hasOwnProperty("referenceImage"))
                            object.referenceImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.referenceImage, options);
                        if (message.testImage != null && message.hasOwnProperty("testImage"))
                            object.testImage = $root.palexy.streaming.v1.CameraPhoto.toObject(message.testImage, options);
                        return object;
                    };
    
                    /**
                     * Converts this CameraShiftEvent to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraShiftEvent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraShiftEvent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ShiftEventStatus enum.
                     * @name palexy.streaming.v1.CameraShiftEvent.ShiftEventStatus
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} WAITING_FOR_REVIEW=1 WAITING_FOR_REVIEW value
                     * @property {number} SHIFTED=2 SHIFTED value
                     * @property {number} RESOLVED=3 RESOLVED value
                     * @property {number} NOT_SHIFTED=4 NOT_SHIFTED value
                     * @property {number} EXPIRED=5 EXPIRED value
                     */
                    CameraShiftEvent.ShiftEventStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "WAITING_FOR_REVIEW"] = 1;
                        values[valuesById[2] = "SHIFTED"] = 2;
                        values[valuesById[3] = "RESOLVED"] = 3;
                        values[valuesById[4] = "NOT_SHIFTED"] = 4;
                        values[valuesById[5] = "EXPIRED"] = 5;
                        return values;
                    })();
    
                    return CameraShiftEvent;
                })();
    
                v1.CameraPhoto = (function() {
    
                    /**
                     * Properties of a CameraPhoto.
                     * @memberof palexy.streaming.v1
                     * @interface ICameraPhoto
                     * @property {number|null} [id] CameraPhoto id
                     * @property {number|null} [cameraId] CameraPhoto cameraId
                     * @property {google.protobuf.ITimestamp|null} [createTime] CameraPhoto createTime
                     * @property {Uint8Array|null} [source] CameraPhoto source
                     * @property {string|null} [ext] CameraPhoto ext
                     * @property {palexy.streaming.v1.CameraPhoto.CameraPhotoType|null} [type] CameraPhoto type
                     * @property {Uint8Array|null} [thumbnail] CameraPhoto thumbnail
                     */
    
                    /**
                     * Constructs a new CameraPhoto.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CameraPhoto.
                     * @implements ICameraPhoto
                     * @constructor
                     * @param {palexy.streaming.v1.ICameraPhoto=} [properties] Properties to set
                     */
                    function CameraPhoto(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraPhoto id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraPhoto cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CameraPhoto createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.createTime = null;
    
                    /**
                     * CameraPhoto source.
                     * @member {Uint8Array} source
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.source = $util.newBuffer([]);
    
                    /**
                     * CameraPhoto ext.
                     * @member {string} ext
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.ext = "";
    
                    /**
                     * CameraPhoto type.
                     * @member {palexy.streaming.v1.CameraPhoto.CameraPhotoType} type
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.type = 0;
    
                    /**
                     * CameraPhoto thumbnail.
                     * @member {Uint8Array} thumbnail
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     */
                    CameraPhoto.prototype.thumbnail = $util.newBuffer([]);
    
                    /**
                     * Creates a new CameraPhoto instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {palexy.streaming.v1.ICameraPhoto=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CameraPhoto} CameraPhoto instance
                     */
                    CameraPhoto.create = function create(properties) {
                        return new CameraPhoto(properties);
                    };
    
                    /**
                     * Encodes the specified CameraPhoto message. Does not implicitly {@link palexy.streaming.v1.CameraPhoto.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {palexy.streaming.v1.ICameraPhoto} message CameraPhoto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraPhoto.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.cameraId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.source);
                        if (message.ext != null && Object.hasOwnProperty.call(message, "ext"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.ext);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                        if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.thumbnail);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraPhoto message, length delimited. Does not implicitly {@link palexy.streaming.v1.CameraPhoto.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {palexy.streaming.v1.ICameraPhoto} message CameraPhoto message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraPhoto.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraPhoto message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CameraPhoto} CameraPhoto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraPhoto.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CameraPhoto();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.int64();
                                break;
                            case 3:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.source = reader.bytes();
                                break;
                            case 5:
                                message.ext = reader.string();
                                break;
                            case 6:
                                message.type = reader.int32();
                                break;
                            case 7:
                                message.thumbnail = reader.bytes();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraPhoto message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CameraPhoto} CameraPhoto
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraPhoto.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraPhoto message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraPhoto.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            if (!(message.source && typeof message.source.length === "number" || $util.isString(message.source)))
                                return "source: buffer expected";
                        if (message.ext != null && message.hasOwnProperty("ext"))
                            if (!$util.isString(message.ext))
                                return "ext: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                            if (!(message.thumbnail && typeof message.thumbnail.length === "number" || $util.isString(message.thumbnail)))
                                return "thumbnail: buffer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CameraPhoto message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CameraPhoto} CameraPhoto
                     */
                    CameraPhoto.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CameraPhoto)
                            return object;
                        var message = new $root.palexy.streaming.v1.CameraPhoto();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.CameraPhoto.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.source != null)
                            if (typeof object.source === "string")
                                $util.base64.decode(object.source, message.source = $util.newBuffer($util.base64.length(object.source)), 0);
                            else if (object.source.length)
                                message.source = object.source;
                        if (object.ext != null)
                            message.ext = String(object.ext);
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "BASIC":
                        case 1:
                            message.type = 1;
                            break;
                        case "SHIFT_REFERENCE":
                        case 2:
                            message.type = 2;
                            break;
                        case "SHIFT_TESTING":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        if (object.thumbnail != null)
                            if (typeof object.thumbnail === "string")
                                $util.base64.decode(object.thumbnail, message.thumbnail = $util.newBuffer($util.base64.length(object.thumbnail)), 0);
                            else if (object.thumbnail.length)
                                message.thumbnail = object.thumbnail;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraPhoto message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @static
                     * @param {palexy.streaming.v1.CameraPhoto} message CameraPhoto
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraPhoto.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            if (options.bytes === String)
                                object.source = "";
                            else {
                                object.source = [];
                                if (options.bytes !== Array)
                                    object.source = $util.newBuffer(object.source);
                            }
                            object.ext = "";
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            if (options.bytes === String)
                                object.thumbnail = "";
                            else {
                                object.thumbnail = [];
                                if (options.bytes !== Array)
                                    object.thumbnail = $util.newBuffer(object.thumbnail);
                            }
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.source != null && message.hasOwnProperty("source"))
                            object.source = options.bytes === String ? $util.base64.encode(message.source, 0, message.source.length) : options.bytes === Array ? Array.prototype.slice.call(message.source) : message.source;
                        if (message.ext != null && message.hasOwnProperty("ext"))
                            object.ext = message.ext;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.CameraPhoto.CameraPhotoType[message.type] : message.type;
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                            object.thumbnail = options.bytes === String ? $util.base64.encode(message.thumbnail, 0, message.thumbnail.length) : options.bytes === Array ? Array.prototype.slice.call(message.thumbnail) : message.thumbnail;
                        return object;
                    };
    
                    /**
                     * Converts this CameraPhoto to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CameraPhoto
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraPhoto.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * CameraPhotoType enum.
                     * @name palexy.streaming.v1.CameraPhoto.CameraPhotoType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} BASIC=1 BASIC value
                     * @property {number} SHIFT_REFERENCE=2 SHIFT_REFERENCE value
                     * @property {number} SHIFT_TESTING=3 SHIFT_TESTING value
                     */
                    CameraPhoto.CameraPhotoType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "BASIC"] = 1;
                        values[valuesById[2] = "SHIFT_REFERENCE"] = 2;
                        values[valuesById[3] = "SHIFT_TESTING"] = 3;
                        return values;
                    })();
    
                    return CameraPhoto;
                })();
    
                v1.UpdateCameraShiftEventRequest = (function() {
    
                    /**
                     * Properties of an UpdateCameraShiftEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateCameraShiftEventRequest
                     * @property {palexy.streaming.v1.ICameraShiftEvent|null} [event] UpdateCameraShiftEventRequest event
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateCameraShiftEventRequest updateMask
                     * @property {string|null} [informant] UpdateCameraShiftEventRequest informant
                     */
    
                    /**
                     * Constructs a new UpdateCameraShiftEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateCameraShiftEventRequest.
                     * @implements IUpdateCameraShiftEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest=} [properties] Properties to set
                     */
                    function UpdateCameraShiftEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateCameraShiftEventRequest event.
                     * @member {palexy.streaming.v1.ICameraShiftEvent|null|undefined} event
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @instance
                     */
                    UpdateCameraShiftEventRequest.prototype.event = null;
    
                    /**
                     * UpdateCameraShiftEventRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @instance
                     */
                    UpdateCameraShiftEventRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateCameraShiftEventRequest informant.
                     * @member {string} informant
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @instance
                     */
                    UpdateCameraShiftEventRequest.prototype.informant = "";
    
                    /**
                     * Creates a new UpdateCameraShiftEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateCameraShiftEventRequest} UpdateCameraShiftEventRequest instance
                     */
                    UpdateCameraShiftEventRequest.create = function create(properties) {
                        return new UpdateCameraShiftEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateCameraShiftEventRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateCameraShiftEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest} message UpdateCameraShiftEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCameraShiftEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                            $root.palexy.streaming.v1.CameraShiftEvent.encode(message.event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.informant != null && Object.hasOwnProperty.call(message, "informant"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.informant);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateCameraShiftEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateCameraShiftEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateCameraShiftEventRequest} message UpdateCameraShiftEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCameraShiftEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateCameraShiftEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateCameraShiftEventRequest} UpdateCameraShiftEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCameraShiftEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateCameraShiftEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.event = $root.palexy.streaming.v1.CameraShiftEvent.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.informant = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateCameraShiftEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateCameraShiftEventRequest} UpdateCameraShiftEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCameraShiftEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateCameraShiftEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateCameraShiftEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.event != null && message.hasOwnProperty("event")) {
                            var error = $root.palexy.streaming.v1.CameraShiftEvent.verify(message.event);
                            if (error)
                                return "event." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.informant != null && message.hasOwnProperty("informant"))
                            if (!$util.isString(message.informant))
                                return "informant: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateCameraShiftEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateCameraShiftEventRequest} UpdateCameraShiftEventRequest
                     */
                    UpdateCameraShiftEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateCameraShiftEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateCameraShiftEventRequest();
                        if (object.event != null) {
                            if (typeof object.event !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateCameraShiftEventRequest.event: object expected");
                            message.event = $root.palexy.streaming.v1.CameraShiftEvent.fromObject(object.event);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateCameraShiftEventRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.informant != null)
                            message.informant = String(object.informant);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateCameraShiftEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateCameraShiftEventRequest} message UpdateCameraShiftEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateCameraShiftEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.event = null;
                            object.updateMask = null;
                            object.informant = "";
                        }
                        if (message.event != null && message.hasOwnProperty("event"))
                            object.event = $root.palexy.streaming.v1.CameraShiftEvent.toObject(message.event, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.informant != null && message.hasOwnProperty("informant"))
                            object.informant = message.informant;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateCameraShiftEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateCameraShiftEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateCameraShiftEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateCameraShiftEventRequest;
                })();
    
                v1.ExportService = (function() {
    
                    /**
                     * Constructs a new ExportService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ExportService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ExportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ExportService;
    
                    /**
                     * Creates new ExportService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ExportService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ExportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportService#export_}.
                     * @memberof palexy.streaming.v1.ExportService
                     * @typedef ExportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportICADataResponse} [response] ExportICADataResponse
                     */
    
                    /**
                     * Calls Export.
                     * @function export
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IExportICADataRequest} request ExportICADataRequest message or plain object
                     * @param {palexy.streaming.v1.ExportService.ExportCallback} callback Node-style callback called with the error, if any, and ExportICADataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportService.prototype["export"] = function export_(request, callback) {
                        return this.rpcCall(export_, $root.palexy.streaming.v1.ExportICADataRequest, $root.palexy.streaming.v1.ExportICADataResponse, request, callback);
                    }, "name", { value: "Export" });
    
                    /**
                     * Calls Export.
                     * @function export
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IExportICADataRequest} request ExportICADataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportICADataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportService#deleteExportedICADataFile}.
                     * @memberof palexy.streaming.v1.ExportService
                     * @typedef DeleteExportedICADataFileCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.DeleteExportedICADataFileResponse} [response] DeleteExportedICADataFileResponse
                     */
    
                    /**
                     * Calls DeleteExportedICADataFile.
                     * @function deleteExportedICADataFile
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest} request DeleteExportedICADataFileRequest message or plain object
                     * @param {palexy.streaming.v1.ExportService.DeleteExportedICADataFileCallback} callback Node-style callback called with the error, if any, and DeleteExportedICADataFileResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportService.prototype.deleteExportedICADataFile = function deleteExportedICADataFile(request, callback) {
                        return this.rpcCall(deleteExportedICADataFile, $root.palexy.streaming.v1.DeleteExportedICADataFileRequest, $root.palexy.streaming.v1.DeleteExportedICADataFileResponse, request, callback);
                    }, "name", { value: "DeleteExportedICADataFile" });
    
                    /**
                     * Calls DeleteExportedICADataFile.
                     * @function deleteExportedICADataFile
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest} request DeleteExportedICADataFileRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.DeleteExportedICADataFileResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportService#exportReport}.
                     * @memberof palexy.streaming.v1.ExportService
                     * @typedef ExportReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportReportResponse} [response] ExportReportResponse
                     */
    
                    /**
                     * Calls ExportReport.
                     * @function exportReport
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IExportReportRequest} request ExportReportRequest message or plain object
                     * @param {palexy.streaming.v1.ExportService.ExportReportCallback} callback Node-style callback called with the error, if any, and ExportReportResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportService.prototype.exportReport = function exportReport(request, callback) {
                        return this.rpcCall(exportReport, $root.palexy.streaming.v1.ExportReportRequest, $root.palexy.streaming.v1.ExportReportResponse, request, callback);
                    }, "name", { value: "ExportReport" });
    
                    /**
                     * Calls ExportReport.
                     * @function exportReport
                     * @memberof palexy.streaming.v1.ExportService
                     * @instance
                     * @param {palexy.streaming.v1.IExportReportRequest} request ExportReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportReportResponse>} Promise
                     * @variation 2
                     */
    
                    return ExportService;
                })();
    
                v1.ExportICADataRequest = (function() {
    
                    /**
                     * Properties of an ExportICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExportICADataRequest
                     * @property {number|null} [companyId] ExportICADataRequest companyId
                     * @property {string|null} [dateId] ExportICADataRequest dateId
                     * @property {palexy.streaming.v1.ExportICADataRequest.FileFormat|null} [format] ExportICADataRequest format
                     * @property {Array.<string>|null} [actionTypes] ExportICADataRequest actionTypes
                     */
    
                    /**
                     * Constructs a new ExportICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportICADataRequest.
                     * @implements IExportICADataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExportICADataRequest=} [properties] Properties to set
                     */
                    function ExportICADataRequest(properties) {
                        this.actionTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportICADataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @instance
                     */
                    ExportICADataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportICADataRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @instance
                     */
                    ExportICADataRequest.prototype.dateId = "";
    
                    /**
                     * ExportICADataRequest format.
                     * @member {palexy.streaming.v1.ExportICADataRequest.FileFormat} format
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @instance
                     */
                    ExportICADataRequest.prototype.format = 0;
    
                    /**
                     * ExportICADataRequest actionTypes.
                     * @member {Array.<string>} actionTypes
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @instance
                     */
                    ExportICADataRequest.prototype.actionTypes = $util.emptyArray;
    
                    /**
                     * Creates a new ExportICADataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportICADataRequest} ExportICADataRequest instance
                     */
                    ExportICADataRequest.create = function create(properties) {
                        return new ExportICADataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExportICADataRequest message. Does not implicitly {@link palexy.streaming.v1.ExportICADataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataRequest} message ExportICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportICADataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.format);
                        if (message.actionTypes != null && message.actionTypes.length)
                            for (var i = 0; i < message.actionTypes.length; ++i)
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.actionTypes[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportICADataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportICADataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataRequest} message ExportICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportICADataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportICADataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportICADataRequest} ExportICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportICADataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportICADataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.format = reader.int32();
                                break;
                            case 4:
                                if (!(message.actionTypes && message.actionTypes.length))
                                    message.actionTypes = [];
                                message.actionTypes.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportICADataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportICADataRequest} ExportICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportICADataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportICADataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportICADataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.format != null && message.hasOwnProperty("format"))
                            switch (message.format) {
                            default:
                                return "format: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.actionTypes != null && message.hasOwnProperty("actionTypes")) {
                            if (!Array.isArray(message.actionTypes))
                                return "actionTypes: array expected";
                            for (var i = 0; i < message.actionTypes.length; ++i)
                                if (!$util.isString(message.actionTypes[i]))
                                    return "actionTypes: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExportICADataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportICADataRequest} ExportICADataRequest
                     */
                    ExportICADataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportICADataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportICADataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        switch (object.format) {
                        case "UNKNOWN":
                        case 0:
                            message.format = 0;
                            break;
                        case "CSV":
                        case 1:
                            message.format = 1;
                            break;
                        case "COMPRESSED_AVRO":
                        case 2:
                            message.format = 2;
                            break;
                        }
                        if (object.actionTypes) {
                            if (!Array.isArray(object.actionTypes))
                                throw TypeError(".palexy.streaming.v1.ExportICADataRequest.actionTypes: array expected");
                            message.actionTypes = [];
                            for (var i = 0; i < object.actionTypes.length; ++i)
                                message.actionTypes[i] = String(object.actionTypes[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportICADataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.ExportICADataRequest} message ExportICADataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportICADataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.actionTypes = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.format = options.enums === String ? "UNKNOWN" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.format != null && message.hasOwnProperty("format"))
                            object.format = options.enums === String ? $root.palexy.streaming.v1.ExportICADataRequest.FileFormat[message.format] : message.format;
                        if (message.actionTypes && message.actionTypes.length) {
                            object.actionTypes = [];
                            for (var j = 0; j < message.actionTypes.length; ++j)
                                object.actionTypes[j] = message.actionTypes[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExportICADataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportICADataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportICADataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FileFormat enum.
                     * @name palexy.streaming.v1.ExportICADataRequest.FileFormat
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} CSV=1 CSV value
                     * @property {number} COMPRESSED_AVRO=2 COMPRESSED_AVRO value
                     */
                    ExportICADataRequest.FileFormat = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "CSV"] = 1;
                        values[valuesById[2] = "COMPRESSED_AVRO"] = 2;
                        return values;
                    })();
    
                    return ExportICADataRequest;
                })();
    
                v1.ExportICADataResponse = (function() {
    
                    /**
                     * Properties of an ExportICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IExportICADataResponse
                     * @property {Array.<palexy.streaming.v1.IExportedFile>|null} [exportedFiles] ExportICADataResponse exportedFiles
                     */
    
                    /**
                     * Constructs a new ExportICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportICADataResponse.
                     * @implements IExportICADataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IExportICADataResponse=} [properties] Properties to set
                     */
                    function ExportICADataResponse(properties) {
                        this.exportedFiles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportICADataResponse exportedFiles.
                     * @member {Array.<palexy.streaming.v1.IExportedFile>} exportedFiles
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @instance
                     */
                    ExportICADataResponse.prototype.exportedFiles = $util.emptyArray;
    
                    /**
                     * Creates a new ExportICADataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportICADataResponse} ExportICADataResponse instance
                     */
                    ExportICADataResponse.create = function create(properties) {
                        return new ExportICADataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ExportICADataResponse message. Does not implicitly {@link palexy.streaming.v1.ExportICADataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataResponse} message ExportICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportICADataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.exportedFiles != null && message.exportedFiles.length)
                            for (var i = 0; i < message.exportedFiles.length; ++i)
                                $root.palexy.streaming.v1.ExportedFile.encode(message.exportedFiles[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportICADataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportICADataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportICADataResponse} message ExportICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportICADataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportICADataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportICADataResponse} ExportICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportICADataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportICADataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.exportedFiles && message.exportedFiles.length))
                                    message.exportedFiles = [];
                                message.exportedFiles.push($root.palexy.streaming.v1.ExportedFile.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportICADataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportICADataResponse} ExportICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportICADataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportICADataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportICADataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.exportedFiles != null && message.hasOwnProperty("exportedFiles")) {
                            if (!Array.isArray(message.exportedFiles))
                                return "exportedFiles: array expected";
                            for (var i = 0; i < message.exportedFiles.length; ++i) {
                                var error = $root.palexy.streaming.v1.ExportedFile.verify(message.exportedFiles[i]);
                                if (error)
                                    return "exportedFiles." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExportICADataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportICADataResponse} ExportICADataResponse
                     */
                    ExportICADataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportICADataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportICADataResponse();
                        if (object.exportedFiles) {
                            if (!Array.isArray(object.exportedFiles))
                                throw TypeError(".palexy.streaming.v1.ExportICADataResponse.exportedFiles: array expected");
                            message.exportedFiles = [];
                            for (var i = 0; i < object.exportedFiles.length; ++i) {
                                if (typeof object.exportedFiles[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ExportICADataResponse.exportedFiles: object expected");
                                message.exportedFiles[i] = $root.palexy.streaming.v1.ExportedFile.fromObject(object.exportedFiles[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportICADataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.ExportICADataResponse} message ExportICADataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportICADataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.exportedFiles = [];
                        if (message.exportedFiles && message.exportedFiles.length) {
                            object.exportedFiles = [];
                            for (var j = 0; j < message.exportedFiles.length; ++j)
                                object.exportedFiles[j] = $root.palexy.streaming.v1.ExportedFile.toObject(message.exportedFiles[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExportICADataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportICADataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportICADataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportICADataResponse;
                })();
    
                v1.ExportedFile = (function() {
    
                    /**
                     * Properties of an ExportedFile.
                     * @memberof palexy.streaming.v1
                     * @interface IExportedFile
                     * @property {string|null} [name] ExportedFile name
                     * @property {string|null} [linkUrl] ExportedFile linkUrl
                     * @property {number|null} [rowCount] ExportedFile rowCount
                     */
    
                    /**
                     * Constructs a new ExportedFile.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportedFile.
                     * @implements IExportedFile
                     * @constructor
                     * @param {palexy.streaming.v1.IExportedFile=} [properties] Properties to set
                     */
                    function ExportedFile(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportedFile name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @instance
                     */
                    ExportedFile.prototype.name = "";
    
                    /**
                     * ExportedFile linkUrl.
                     * @member {string} linkUrl
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @instance
                     */
                    ExportedFile.prototype.linkUrl = "";
    
                    /**
                     * ExportedFile rowCount.
                     * @member {number} rowCount
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @instance
                     */
                    ExportedFile.prototype.rowCount = 0;
    
                    /**
                     * Creates a new ExportedFile instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {palexy.streaming.v1.IExportedFile=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportedFile} ExportedFile instance
                     */
                    ExportedFile.create = function create(properties) {
                        return new ExportedFile(properties);
                    };
    
                    /**
                     * Encodes the specified ExportedFile message. Does not implicitly {@link palexy.streaming.v1.ExportedFile.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {palexy.streaming.v1.IExportedFile} message ExportedFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportedFile.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        if (message.linkUrl != null && Object.hasOwnProperty.call(message, "linkUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.linkUrl);
                        if (message.rowCount != null && Object.hasOwnProperty.call(message, "rowCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.rowCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportedFile message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportedFile.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {palexy.streaming.v1.IExportedFile} message ExportedFile message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportedFile.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportedFile message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportedFile} ExportedFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportedFile.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportedFile();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            case 2:
                                message.linkUrl = reader.string();
                                break;
                            case 3:
                                message.rowCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportedFile message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportedFile} ExportedFile
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportedFile.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportedFile message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportedFile.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.linkUrl != null && message.hasOwnProperty("linkUrl"))
                            if (!$util.isString(message.linkUrl))
                                return "linkUrl: string expected";
                        if (message.rowCount != null && message.hasOwnProperty("rowCount"))
                            if (!$util.isInteger(message.rowCount))
                                return "rowCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportedFile message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportedFile} ExportedFile
                     */
                    ExportedFile.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportedFile)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportedFile();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.linkUrl != null)
                            message.linkUrl = String(object.linkUrl);
                        if (object.rowCount != null)
                            message.rowCount = object.rowCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportedFile message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @static
                     * @param {palexy.streaming.v1.ExportedFile} message ExportedFile
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportedFile.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.name = "";
                            object.linkUrl = "";
                            object.rowCount = 0;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.linkUrl != null && message.hasOwnProperty("linkUrl"))
                            object.linkUrl = message.linkUrl;
                        if (message.rowCount != null && message.hasOwnProperty("rowCount"))
                            object.rowCount = message.rowCount;
                        return object;
                    };
    
                    /**
                     * Converts this ExportedFile to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportedFile
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportedFile.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportedFile;
                })();
    
                v1.DeleteExportedICADataFileRequest = (function() {
    
                    /**
                     * Properties of a DeleteExportedICADataFileRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteExportedICADataFileRequest
                     * @property {number|null} [companyId] DeleteExportedICADataFileRequest companyId
                     * @property {string|null} [startDateId] DeleteExportedICADataFileRequest startDateId
                     * @property {string|null} [endDateId] DeleteExportedICADataFileRequest endDateId
                     */
    
                    /**
                     * Constructs a new DeleteExportedICADataFileRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteExportedICADataFileRequest.
                     * @implements IDeleteExportedICADataFileRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest=} [properties] Properties to set
                     */
                    function DeleteExportedICADataFileRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteExportedICADataFileRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @instance
                     */
                    DeleteExportedICADataFileRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteExportedICADataFileRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @instance
                     */
                    DeleteExportedICADataFileRequest.prototype.startDateId = "";
    
                    /**
                     * DeleteExportedICADataFileRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @instance
                     */
                    DeleteExportedICADataFileRequest.prototype.endDateId = "";
    
                    /**
                     * Creates a new DeleteExportedICADataFileRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileRequest} DeleteExportedICADataFileRequest instance
                     */
                    DeleteExportedICADataFileRequest.create = function create(properties) {
                        return new DeleteExportedICADataFileRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteExportedICADataFileRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteExportedICADataFileRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest} message DeleteExportedICADataFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportedICADataFileRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteExportedICADataFileRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteExportedICADataFileRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileRequest} message DeleteExportedICADataFileRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportedICADataFileRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteExportedICADataFileRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileRequest} DeleteExportedICADataFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportedICADataFileRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteExportedICADataFileRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.string();
                                break;
                            case 3:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteExportedICADataFileRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileRequest} DeleteExportedICADataFileRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportedICADataFileRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteExportedICADataFileRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteExportedICADataFileRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteExportedICADataFileRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileRequest} DeleteExportedICADataFileRequest
                     */
                    DeleteExportedICADataFileRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteExportedICADataFileRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteExportedICADataFileRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteExportedICADataFileRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteExportedICADataFileRequest} message DeleteExportedICADataFileRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteExportedICADataFileRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteExportedICADataFileRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteExportedICADataFileRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteExportedICADataFileRequest;
                })();
    
                v1.DeleteExportedICADataFileResponse = (function() {
    
                    /**
                     * Properties of a DeleteExportedICADataFileResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteExportedICADataFileResponse
                     */
    
                    /**
                     * Constructs a new DeleteExportedICADataFileResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteExportedICADataFileResponse.
                     * @implements IDeleteExportedICADataFileResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileResponse=} [properties] Properties to set
                     */
                    function DeleteExportedICADataFileResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new DeleteExportedICADataFileResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileResponse} DeleteExportedICADataFileResponse instance
                     */
                    DeleteExportedICADataFileResponse.create = function create(properties) {
                        return new DeleteExportedICADataFileResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteExportedICADataFileResponse message. Does not implicitly {@link palexy.streaming.v1.DeleteExportedICADataFileResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileResponse} message DeleteExportedICADataFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportedICADataFileResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteExportedICADataFileResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteExportedICADataFileResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportedICADataFileResponse} message DeleteExportedICADataFileResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportedICADataFileResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteExportedICADataFileResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileResponse} DeleteExportedICADataFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportedICADataFileResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteExportedICADataFileResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteExportedICADataFileResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileResponse} DeleteExportedICADataFileResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportedICADataFileResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteExportedICADataFileResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteExportedICADataFileResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteExportedICADataFileResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteExportedICADataFileResponse} DeleteExportedICADataFileResponse
                     */
                    DeleteExportedICADataFileResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteExportedICADataFileResponse)
                            return object;
                        return new $root.palexy.streaming.v1.DeleteExportedICADataFileResponse();
                    };
    
                    /**
                     * Creates a plain object from a DeleteExportedICADataFileResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @static
                     * @param {palexy.streaming.v1.DeleteExportedICADataFileResponse} message DeleteExportedICADataFileResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteExportedICADataFileResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this DeleteExportedICADataFileResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteExportedICADataFileResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteExportedICADataFileResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteExportedICADataFileResponse;
                })();
    
                v1.ExportReportRequest = (function() {
    
                    /**
                     * Properties of an ExportReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExportReportRequest
                     * @property {number|null} [companyId] ExportReportRequest companyId
                     * @property {string|null} [dateId] ExportReportRequest dateId
                     */
    
                    /**
                     * Constructs a new ExportReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportReportRequest.
                     * @implements IExportReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExportReportRequest=} [properties] Properties to set
                     */
                    function ExportReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportReportRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @instance
                     */
                    ExportReportRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportReportRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @instance
                     */
                    ExportReportRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new ExportReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportReportRequest} ExportReportRequest instance
                     */
                    ExportReportRequest.create = function create(properties) {
                        return new ExportReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExportReportRequest message. Does not implicitly {@link palexy.streaming.v1.ExportReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportReportRequest} message ExportReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportReportRequest} message ExportReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportReportRequest} ExportReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportReportRequest} ExportReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportReportRequest} ExportReportRequest
                     */
                    ExportReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportReportRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ExportReportRequest} message ExportReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this ExportReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportReportRequest;
                })();
    
                v1.ExportReportResponse = (function() {
    
                    /**
                     * Properties of an ExportReportResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IExportReportResponse
                     * @property {Array.<palexy.streaming.v1.IExportedFile>|null} [exportedFiles] ExportReportResponse exportedFiles
                     */
    
                    /**
                     * Constructs a new ExportReportResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportReportResponse.
                     * @implements IExportReportResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IExportReportResponse=} [properties] Properties to set
                     */
                    function ExportReportResponse(properties) {
                        this.exportedFiles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportReportResponse exportedFiles.
                     * @member {Array.<palexy.streaming.v1.IExportedFile>} exportedFiles
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @instance
                     */
                    ExportReportResponse.prototype.exportedFiles = $util.emptyArray;
    
                    /**
                     * Creates a new ExportReportResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportReportResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportReportResponse} ExportReportResponse instance
                     */
                    ExportReportResponse.create = function create(properties) {
                        return new ExportReportResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ExportReportResponse message. Does not implicitly {@link palexy.streaming.v1.ExportReportResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportReportResponse} message ExportReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.exportedFiles != null && message.exportedFiles.length)
                            for (var i = 0; i < message.exportedFiles.length; ++i)
                                $root.palexy.streaming.v1.ExportedFile.encode(message.exportedFiles[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportReportResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportReportResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportReportResponse} message ExportReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportReportResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportReportResponse} ExportReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportReportResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.exportedFiles && message.exportedFiles.length))
                                    message.exportedFiles = [];
                                message.exportedFiles.push($root.palexy.streaming.v1.ExportedFile.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportReportResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportReportResponse} ExportReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportReportResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportReportResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.exportedFiles != null && message.hasOwnProperty("exportedFiles")) {
                            if (!Array.isArray(message.exportedFiles))
                                return "exportedFiles: array expected";
                            for (var i = 0; i < message.exportedFiles.length; ++i) {
                                var error = $root.palexy.streaming.v1.ExportedFile.verify(message.exportedFiles[i]);
                                if (error)
                                    return "exportedFiles." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExportReportResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportReportResponse} ExportReportResponse
                     */
                    ExportReportResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportReportResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportReportResponse();
                        if (object.exportedFiles) {
                            if (!Array.isArray(object.exportedFiles))
                                throw TypeError(".palexy.streaming.v1.ExportReportResponse.exportedFiles: array expected");
                            message.exportedFiles = [];
                            for (var i = 0; i < object.exportedFiles.length; ++i) {
                                if (typeof object.exportedFiles[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ExportReportResponse.exportedFiles: object expected");
                                message.exportedFiles[i] = $root.palexy.streaming.v1.ExportedFile.fromObject(object.exportedFiles[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportReportResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @static
                     * @param {palexy.streaming.v1.ExportReportResponse} message ExportReportResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportReportResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.exportedFiles = [];
                        if (message.exportedFiles && message.exportedFiles.length) {
                            object.exportedFiles = [];
                            for (var j = 0; j < message.exportedFiles.length; ++j)
                                object.exportedFiles[j] = $root.palexy.streaming.v1.ExportedFile.toObject(message.exportedFiles[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExportReportResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportReportResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportReportResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportReportResponse;
                })();
    
                v1.AsyncJobService = (function() {
    
                    /**
                     * Constructs a new AsyncJobService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncJobService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function AsyncJobService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (AsyncJobService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AsyncJobService;
    
                    /**
                     * Creates new AsyncJobService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {AsyncJobService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    AsyncJobService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#createAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef CreateAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AsyncJob} [response] AsyncJob
                     */
    
                    /**
                     * Calls CreateAsyncJob.
                     * @function createAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IAsyncJob} request AsyncJob message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.CreateAsyncJobCallback} callback Node-style callback called with the error, if any, and AsyncJob
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.createAsyncJob = function createAsyncJob(request, callback) {
                        return this.rpcCall(createAsyncJob, $root.palexy.streaming.v1.AsyncJob, $root.palexy.streaming.v1.AsyncJob, request, callback);
                    }, "name", { value: "CreateAsyncJob" });
    
                    /**
                     * Calls CreateAsyncJob.
                     * @function createAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IAsyncJob} request AsyncJob message or plain object
                     * @returns {Promise<palexy.streaming.v1.AsyncJob>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#getAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef GetAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AsyncJob} [response] AsyncJob
                     */
    
                    /**
                     * Calls GetAsyncJob.
                     * @function getAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest} request GetAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.GetAsyncJobCallback} callback Node-style callback called with the error, if any, and AsyncJob
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.getAsyncJob = function getAsyncJob(request, callback) {
                        return this.rpcCall(getAsyncJob, $root.palexy.streaming.v1.GetAsyncJobRequest, $root.palexy.streaming.v1.AsyncJob, request, callback);
                    }, "name", { value: "GetAsyncJob" });
    
                    /**
                     * Calls GetAsyncJob.
                     * @function getAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest} request GetAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AsyncJob>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#batchGetAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef BatchGetAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchGetAsyncJobResponse} [response] BatchGetAsyncJobResponse
                     */
    
                    /**
                     * Calls BatchGetAsyncJob.
                     * @function batchGetAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest} request BatchGetAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.BatchGetAsyncJobCallback} callback Node-style callback called with the error, if any, and BatchGetAsyncJobResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.batchGetAsyncJob = function batchGetAsyncJob(request, callback) {
                        return this.rpcCall(batchGetAsyncJob, $root.palexy.streaming.v1.BatchGetAsyncJobRequest, $root.palexy.streaming.v1.BatchGetAsyncJobResponse, request, callback);
                    }, "name", { value: "BatchGetAsyncJob" });
    
                    /**
                     * Calls BatchGetAsyncJob.
                     * @function batchGetAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest} request BatchGetAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchGetAsyncJobResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#cancelAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef CancelAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AsyncJob} [response] AsyncJob
                     */
    
                    /**
                     * Calls CancelAsyncJob.
                     * @function cancelAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest} request CancelAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.CancelAsyncJobCallback} callback Node-style callback called with the error, if any, and AsyncJob
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.cancelAsyncJob = function cancelAsyncJob(request, callback) {
                        return this.rpcCall(cancelAsyncJob, $root.palexy.streaming.v1.CancelAsyncJobRequest, $root.palexy.streaming.v1.AsyncJob, request, callback);
                    }, "name", { value: "CancelAsyncJob" });
    
                    /**
                     * Calls CancelAsyncJob.
                     * @function cancelAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest} request CancelAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AsyncJob>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#listAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef ListAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAsyncJobResponse} [response] ListAsyncJobResponse
                     */
    
                    /**
                     * Calls ListAsyncJob.
                     * @function listAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListAsyncJobRequest} request ListAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.ListAsyncJobCallback} callback Node-style callback called with the error, if any, and ListAsyncJobResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.listAsyncJob = function listAsyncJob(request, callback) {
                        return this.rpcCall(listAsyncJob, $root.palexy.streaming.v1.ListAsyncJobRequest, $root.palexy.streaming.v1.ListAsyncJobResponse, request, callback);
                    }, "name", { value: "ListAsyncJob" });
    
                    /**
                     * Calls ListAsyncJob.
                     * @function listAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListAsyncJobRequest} request ListAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAsyncJobResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#updateAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef UpdateAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AsyncJob} [response] AsyncJob
                     */
    
                    /**
                     * Calls UpdateAsyncJob.
                     * @function updateAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest} request UpdateAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.UpdateAsyncJobCallback} callback Node-style callback called with the error, if any, and AsyncJob
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.updateAsyncJob = function updateAsyncJob(request, callback) {
                        return this.rpcCall(updateAsyncJob, $root.palexy.streaming.v1.UpdateAsyncJobRequest, $root.palexy.streaming.v1.AsyncJob, request, callback);
                    }, "name", { value: "UpdateAsyncJob" });
    
                    /**
                     * Calls UpdateAsyncJob.
                     * @function updateAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest} request UpdateAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AsyncJob>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#batchCreateAsyncJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef BatchCreateAsyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateAsyncJobResponse} [response] BatchCreateAsyncJobResponse
                     */
    
                    /**
                     * Calls BatchCreateAsyncJob.
                     * @function batchCreateAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest} request BatchCreateAsyncJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.BatchCreateAsyncJobCallback} callback Node-style callback called with the error, if any, and BatchCreateAsyncJobResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.batchCreateAsyncJob = function batchCreateAsyncJob(request, callback) {
                        return this.rpcCall(batchCreateAsyncJob, $root.palexy.streaming.v1.BatchCreateAsyncJobRequest, $root.palexy.streaming.v1.BatchCreateAsyncJobResponse, request, callback);
                    }, "name", { value: "BatchCreateAsyncJob" });
    
                    /**
                     * Calls BatchCreateAsyncJob.
                     * @function batchCreateAsyncJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest} request BatchCreateAsyncJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateAsyncJobResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#listReadyScheduleTaskJob}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef ListReadyScheduleTaskJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAsyncJobResponse} [response] ListAsyncJobResponse
                     */
    
                    /**
                     * Calls ListReadyScheduleTaskJob.
                     * @function listReadyScheduleTaskJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest} request ListReadyScheduleTaskJobRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.ListReadyScheduleTaskJobCallback} callback Node-style callback called with the error, if any, and ListAsyncJobResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.listReadyScheduleTaskJob = function listReadyScheduleTaskJob(request, callback) {
                        return this.rpcCall(listReadyScheduleTaskJob, $root.palexy.streaming.v1.ListReadyScheduleTaskJobRequest, $root.palexy.streaming.v1.ListAsyncJobResponse, request, callback);
                    }, "name", { value: "ListReadyScheduleTaskJob" });
    
                    /**
                     * Calls ListReadyScheduleTaskJob.
                     * @function listReadyScheduleTaskJob
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest} request ListReadyScheduleTaskJobRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAsyncJobResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#listGoalGenerateTargetJobs}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef ListGoalGenerateTargetJobsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} [response] ListGoalGenerateTargetJobsResponse
                     */
    
                    /**
                     * Calls ListGoalGenerateTargetJobs.
                     * @function listGoalGenerateTargetJobs
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest} request ListGoalGenerateTargetJobsRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.ListGoalGenerateTargetJobsCallback} callback Node-style callback called with the error, if any, and ListGoalGenerateTargetJobsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.listGoalGenerateTargetJobs = function listGoalGenerateTargetJobs(request, callback) {
                        return this.rpcCall(listGoalGenerateTargetJobs, $root.palexy.streaming.v1.ListGoalGenerateTargetJobsRequest, $root.palexy.streaming.v1.ListGoalGenerateTargetJobsResponse, request, callback);
                    }, "name", { value: "ListGoalGenerateTargetJobs" });
    
                    /**
                     * Calls ListGoalGenerateTargetJobs.
                     * @function listGoalGenerateTargetJobs
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest} request ListGoalGenerateTargetJobsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListGoalGenerateTargetJobsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncJobService#cleanUpCompletedAsyncJobs}.
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @typedef CleanUpCompletedAsyncJobsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} [response] CleanUpCompletedAsyncJobsResponse
                     */
    
                    /**
                     * Calls CleanUpCompletedAsyncJobs.
                     * @function cleanUpCompletedAsyncJobs
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest} request CleanUpCompletedAsyncJobsRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncJobService.CleanUpCompletedAsyncJobsCallback} callback Node-style callback called with the error, if any, and CleanUpCompletedAsyncJobsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncJobService.prototype.cleanUpCompletedAsyncJobs = function cleanUpCompletedAsyncJobs(request, callback) {
                        return this.rpcCall(cleanUpCompletedAsyncJobs, $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest, $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse, request, callback);
                    }, "name", { value: "CleanUpCompletedAsyncJobs" });
    
                    /**
                     * Calls CleanUpCompletedAsyncJobs.
                     * @function cleanUpCompletedAsyncJobs
                     * @memberof palexy.streaming.v1.AsyncJobService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest} request CleanUpCompletedAsyncJobsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse>} Promise
                     * @variation 2
                     */
    
                    return AsyncJobService;
                })();
    
                v1.CleanUpCompletedAsyncJobsRequest = (function() {
    
                    /**
                     * Properties of a CleanUpCompletedAsyncJobsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICleanUpCompletedAsyncJobsRequest
                     * @property {number|null} [retentionDays] CleanUpCompletedAsyncJobsRequest retentionDays
                     * @property {number|null} [batchSize] CleanUpCompletedAsyncJobsRequest batchSize
                     */
    
                    /**
                     * Constructs a new CleanUpCompletedAsyncJobsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CleanUpCompletedAsyncJobsRequest.
                     * @implements ICleanUpCompletedAsyncJobsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest=} [properties] Properties to set
                     */
                    function CleanUpCompletedAsyncJobsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CleanUpCompletedAsyncJobsRequest retentionDays.
                     * @member {number} retentionDays
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @instance
                     */
                    CleanUpCompletedAsyncJobsRequest.prototype.retentionDays = 0;
    
                    /**
                     * CleanUpCompletedAsyncJobsRequest batchSize.
                     * @member {number} batchSize
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @instance
                     */
                    CleanUpCompletedAsyncJobsRequest.prototype.batchSize = 0;
    
                    /**
                     * Creates a new CleanUpCompletedAsyncJobsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest} CleanUpCompletedAsyncJobsRequest instance
                     */
                    CleanUpCompletedAsyncJobsRequest.create = function create(properties) {
                        return new CleanUpCompletedAsyncJobsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CleanUpCompletedAsyncJobsRequest message. Does not implicitly {@link palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest} message CleanUpCompletedAsyncJobsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpCompletedAsyncJobsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.retentionDays != null && Object.hasOwnProperty.call(message, "retentionDays"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.retentionDays);
                        if (message.batchSize != null && Object.hasOwnProperty.call(message, "batchSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.batchSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CleanUpCompletedAsyncJobsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsRequest} message CleanUpCompletedAsyncJobsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpCompletedAsyncJobsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CleanUpCompletedAsyncJobsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest} CleanUpCompletedAsyncJobsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpCompletedAsyncJobsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.retentionDays = reader.int32();
                                break;
                            case 2:
                                message.batchSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CleanUpCompletedAsyncJobsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest} CleanUpCompletedAsyncJobsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpCompletedAsyncJobsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CleanUpCompletedAsyncJobsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CleanUpCompletedAsyncJobsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.retentionDays != null && message.hasOwnProperty("retentionDays"))
                            if (!$util.isInteger(message.retentionDays))
                                return "retentionDays: integer expected";
                        if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                            if (!$util.isInteger(message.batchSize))
                                return "batchSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CleanUpCompletedAsyncJobsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest} CleanUpCompletedAsyncJobsRequest
                     */
                    CleanUpCompletedAsyncJobsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest();
                        if (object.retentionDays != null)
                            message.retentionDays = object.retentionDays | 0;
                        if (object.batchSize != null)
                            message.batchSize = object.batchSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CleanUpCompletedAsyncJobsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest} message CleanUpCompletedAsyncJobsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CleanUpCompletedAsyncJobsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.retentionDays = 0;
                            object.batchSize = 0;
                        }
                        if (message.retentionDays != null && message.hasOwnProperty("retentionDays"))
                            object.retentionDays = message.retentionDays;
                        if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                            object.batchSize = message.batchSize;
                        return object;
                    };
    
                    /**
                     * Converts this CleanUpCompletedAsyncJobsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CleanUpCompletedAsyncJobsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CleanUpCompletedAsyncJobsRequest;
                })();
    
                v1.CleanUpCompletedAsyncJobsResponse = (function() {
    
                    /**
                     * Properties of a CleanUpCompletedAsyncJobsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICleanUpCompletedAsyncJobsResponse
                     * @property {number|null} [deletedCount] CleanUpCompletedAsyncJobsResponse deletedCount
                     */
    
                    /**
                     * Constructs a new CleanUpCompletedAsyncJobsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CleanUpCompletedAsyncJobsResponse.
                     * @implements ICleanUpCompletedAsyncJobsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsResponse=} [properties] Properties to set
                     */
                    function CleanUpCompletedAsyncJobsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CleanUpCompletedAsyncJobsResponse deletedCount.
                     * @member {number} deletedCount
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @instance
                     */
                    CleanUpCompletedAsyncJobsResponse.prototype.deletedCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CleanUpCompletedAsyncJobsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} CleanUpCompletedAsyncJobsResponse instance
                     */
                    CleanUpCompletedAsyncJobsResponse.create = function create(properties) {
                        return new CleanUpCompletedAsyncJobsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CleanUpCompletedAsyncJobsResponse message. Does not implicitly {@link palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsResponse} message CleanUpCompletedAsyncJobsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpCompletedAsyncJobsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.deletedCount != null && Object.hasOwnProperty.call(message, "deletedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.deletedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CleanUpCompletedAsyncJobsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpCompletedAsyncJobsResponse} message CleanUpCompletedAsyncJobsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpCompletedAsyncJobsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CleanUpCompletedAsyncJobsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} CleanUpCompletedAsyncJobsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpCompletedAsyncJobsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.deletedCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CleanUpCompletedAsyncJobsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} CleanUpCompletedAsyncJobsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpCompletedAsyncJobsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CleanUpCompletedAsyncJobsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CleanUpCompletedAsyncJobsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.deletedCount != null && message.hasOwnProperty("deletedCount"))
                            if (!$util.isInteger(message.deletedCount) && !(message.deletedCount && $util.isInteger(message.deletedCount.low) && $util.isInteger(message.deletedCount.high)))
                                return "deletedCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CleanUpCompletedAsyncJobsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} CleanUpCompletedAsyncJobsResponse
                     */
                    CleanUpCompletedAsyncJobsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse();
                        if (object.deletedCount != null)
                            if ($util.Long)
                                (message.deletedCount = $util.Long.fromValue(object.deletedCount)).unsigned = false;
                            else if (typeof object.deletedCount === "string")
                                message.deletedCount = parseInt(object.deletedCount, 10);
                            else if (typeof object.deletedCount === "number")
                                message.deletedCount = object.deletedCount;
                            else if (typeof object.deletedCount === "object")
                                message.deletedCount = new $util.LongBits(object.deletedCount.low >>> 0, object.deletedCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CleanUpCompletedAsyncJobsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse} message CleanUpCompletedAsyncJobsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CleanUpCompletedAsyncJobsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.deletedCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.deletedCount = options.longs === String ? "0" : 0;
                        if (message.deletedCount != null && message.hasOwnProperty("deletedCount"))
                            if (typeof message.deletedCount === "number")
                                object.deletedCount = options.longs === String ? String(message.deletedCount) : message.deletedCount;
                            else
                                object.deletedCount = options.longs === String ? $util.Long.prototype.toString.call(message.deletedCount) : options.longs === Number ? new $util.LongBits(message.deletedCount.low >>> 0, message.deletedCount.high >>> 0).toNumber() : message.deletedCount;
                        return object;
                    };
    
                    /**
                     * Converts this CleanUpCompletedAsyncJobsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CleanUpCompletedAsyncJobsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CleanUpCompletedAsyncJobsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CleanUpCompletedAsyncJobsResponse;
                })();
    
                v1.AsyncJob = (function() {
    
                    /**
                     * Properties of an AsyncJob.
                     * @memberof palexy.streaming.v1
                     * @interface IAsyncJob
                     * @property {number|null} [id] AsyncJob id
                     * @property {number|null} [companyId] AsyncJob companyId
                     * @property {palexy.streaming.v1.AsyncJob.Type|null} [type] AsyncJob type
                     * @property {palexy.streaming.v1.AsyncJob.Status|null} [status] AsyncJob status
                     * @property {number|null} [ownerId] AsyncJob ownerId
                     * @property {google.protobuf.ITimestamp|null} [createTime] AsyncJob createTime
                     * @property {google.protobuf.ITimestamp|null} [lastUpdateTime] AsyncJob lastUpdateTime
                     * @property {number|null} [retryCount] AsyncJob retryCount
                     * @property {string|null} [lastErrorMessage] AsyncJob lastErrorMessage
                     * @property {palexy.streaming.v1.AsyncJob.IExport|null} [asyncExportJob] AsyncJob asyncExportJob
                     * @property {palexy.streaming.v1.AsyncJob.IPosMatching|null} [asyncPosMatchingJob] AsyncJob asyncPosMatchingJob
                     * @property {palexy.streaming.v1.AsyncJob.IPosImport|null} [asyncPosImportJob] AsyncJob asyncPosImportJob
                     * @property {palexy.streaming.v1.AsyncJob.IAggregate|null} [asyncAggregateJob] AsyncJob asyncAggregateJob
                     * @property {palexy.streaming.v1.AsyncJob.IAggregateLevel2|null} [asyncAggregateLevel_2Job] AsyncJob asyncAggregateLevel_2Job
                     * @property {palexy.streaming.v1.AsyncJob.ICalculateConsistency|null} [asyncCalculateConsistencyJob] AsyncJob asyncCalculateConsistencyJob
                     * @property {palexy.streaming.v1.AsyncJob.IScheduleTask|null} [asyncScheduleTaskJob] AsyncJob asyncScheduleTaskJob
                     * @property {palexy.streaming.v1.AsyncJob.IStaffImport|null} [staffImportJob] AsyncJob staffImportJob
                     * @property {palexy.streaming.v1.AsyncJob.IExportReport|null} [asyncExportReportJob] AsyncJob asyncExportReportJob
                     * @property {palexy.streaming.v1.AsyncJob.IUpdateWeatherData|null} [asyncUpdateWeatherDataJob] AsyncJob asyncUpdateWeatherDataJob
                     * @property {palexy.streaming.v1.AsyncJob.IGenerateInsight|null} [asyncGenerateInsightJob] AsyncJob asyncGenerateInsightJob
                     * @property {palexy.streaming.v1.AsyncJob.ISendReportSchedule|null} [asyncSendReportScheduleJob] AsyncJob asyncSendReportScheduleJob
                     * @property {palexy.streaming.v1.AsyncJob.IExternalTrafficImport|null} [asyncExternalTrafficImportJob] AsyncJob asyncExternalTrafficImportJob
                     * @property {palexy.streaming.v1.AsyncJob.IGenerateTrendReport|null} [asyncGenerateTrendReportJob] AsyncJob asyncGenerateTrendReportJob
                     * @property {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule|null} [asyncAggregateStaffScheduleJob] AsyncJob asyncAggregateStaffScheduleJob
                     * @property {palexy.streaming.v1.AsyncJob.IRerunMerging|null} [asyncRerunMergingJob] AsyncJob asyncRerunMergingJob
                     * @property {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget|null} [asyncAdjustScheduleBudgetJob] AsyncJob asyncAdjustScheduleBudgetJob
                     * @property {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget|null} [asyncGenerateGoalTargetJob] AsyncJob asyncGenerateGoalTargetJob
                     * @property {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance|null} [asyncEvaluateGoalPerformanceJob] AsyncJob asyncEvaluateGoalPerformanceJob
                     * @property {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember|null} [asyncSyncMatchingGroupMemberJob] AsyncJob asyncSyncMatchingGroupMemberJob
                     * @property {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction|null} [asyncEvaluateFormCustomActionJob] AsyncJob asyncEvaluateFormCustomActionJob
                     * @property {palexy.streaming.v1.AsyncJob.IAggregateAttendance|null} [asyncAggregateAttendanceJob] AsyncJob asyncAggregateAttendanceJob
                     * @property {palexy.streaming.v1.AsyncJob.ISyncReviews|null} [asyncSyncReviewsJob] AsyncJob asyncSyncReviewsJob
                     * @property {palexy.streaming.v1.AsyncJob.IAggregateReputation|null} [asyncAggregateReputationJob] AsyncJob asyncAggregateReputationJob
                     */
    
                    /**
                     * Constructs a new AsyncJob.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncJob.
                     * @implements IAsyncJob
                     * @constructor
                     * @param {palexy.streaming.v1.IAsyncJob=} [properties] Properties to set
                     */
                    function AsyncJob(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AsyncJob id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncJob companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncJob type.
                     * @member {palexy.streaming.v1.AsyncJob.Type} type
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.type = 0;
    
                    /**
                     * AsyncJob status.
                     * @member {palexy.streaming.v1.AsyncJob.Status} status
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.status = 0;
    
                    /**
                     * AsyncJob ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncJob createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.createTime = null;
    
                    /**
                     * AsyncJob lastUpdateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastUpdateTime
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.lastUpdateTime = null;
    
                    /**
                     * AsyncJob retryCount.
                     * @member {number} retryCount
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.retryCount = 0;
    
                    /**
                     * AsyncJob lastErrorMessage.
                     * @member {string} lastErrorMessage
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.lastErrorMessage = "";
    
                    /**
                     * AsyncJob asyncExportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IExport|null|undefined} asyncExportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncExportJob = null;
    
                    /**
                     * AsyncJob asyncPosMatchingJob.
                     * @member {palexy.streaming.v1.AsyncJob.IPosMatching|null|undefined} asyncPosMatchingJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncPosMatchingJob = null;
    
                    /**
                     * AsyncJob asyncPosImportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IPosImport|null|undefined} asyncPosImportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncPosImportJob = null;
    
                    /**
                     * AsyncJob asyncAggregateJob.
                     * @member {palexy.streaming.v1.AsyncJob.IAggregate|null|undefined} asyncAggregateJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAggregateJob = null;
    
                    /**
                     * AsyncJob asyncAggregateLevel_2Job.
                     * @member {palexy.streaming.v1.AsyncJob.IAggregateLevel2|null|undefined} asyncAggregateLevel_2Job
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAggregateLevel_2Job = null;
    
                    /**
                     * AsyncJob asyncCalculateConsistencyJob.
                     * @member {palexy.streaming.v1.AsyncJob.ICalculateConsistency|null|undefined} asyncCalculateConsistencyJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncCalculateConsistencyJob = null;
    
                    /**
                     * AsyncJob asyncScheduleTaskJob.
                     * @member {palexy.streaming.v1.AsyncJob.IScheduleTask|null|undefined} asyncScheduleTaskJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncScheduleTaskJob = null;
    
                    /**
                     * AsyncJob staffImportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IStaffImport|null|undefined} staffImportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.staffImportJob = null;
    
                    /**
                     * AsyncJob asyncExportReportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IExportReport|null|undefined} asyncExportReportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncExportReportJob = null;
    
                    /**
                     * AsyncJob asyncUpdateWeatherDataJob.
                     * @member {palexy.streaming.v1.AsyncJob.IUpdateWeatherData|null|undefined} asyncUpdateWeatherDataJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncUpdateWeatherDataJob = null;
    
                    /**
                     * AsyncJob asyncGenerateInsightJob.
                     * @member {palexy.streaming.v1.AsyncJob.IGenerateInsight|null|undefined} asyncGenerateInsightJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncGenerateInsightJob = null;
    
                    /**
                     * AsyncJob asyncSendReportScheduleJob.
                     * @member {palexy.streaming.v1.AsyncJob.ISendReportSchedule|null|undefined} asyncSendReportScheduleJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncSendReportScheduleJob = null;
    
                    /**
                     * AsyncJob asyncExternalTrafficImportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IExternalTrafficImport|null|undefined} asyncExternalTrafficImportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncExternalTrafficImportJob = null;
    
                    /**
                     * AsyncJob asyncGenerateTrendReportJob.
                     * @member {palexy.streaming.v1.AsyncJob.IGenerateTrendReport|null|undefined} asyncGenerateTrendReportJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncGenerateTrendReportJob = null;
    
                    /**
                     * AsyncJob asyncAggregateStaffScheduleJob.
                     * @member {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule|null|undefined} asyncAggregateStaffScheduleJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAggregateStaffScheduleJob = null;
    
                    /**
                     * AsyncJob asyncRerunMergingJob.
                     * @member {palexy.streaming.v1.AsyncJob.IRerunMerging|null|undefined} asyncRerunMergingJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncRerunMergingJob = null;
    
                    /**
                     * AsyncJob asyncAdjustScheduleBudgetJob.
                     * @member {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget|null|undefined} asyncAdjustScheduleBudgetJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAdjustScheduleBudgetJob = null;
    
                    /**
                     * AsyncJob asyncGenerateGoalTargetJob.
                     * @member {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget|null|undefined} asyncGenerateGoalTargetJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncGenerateGoalTargetJob = null;
    
                    /**
                     * AsyncJob asyncEvaluateGoalPerformanceJob.
                     * @member {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance|null|undefined} asyncEvaluateGoalPerformanceJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncEvaluateGoalPerformanceJob = null;
    
                    /**
                     * AsyncJob asyncSyncMatchingGroupMemberJob.
                     * @member {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember|null|undefined} asyncSyncMatchingGroupMemberJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncSyncMatchingGroupMemberJob = null;
    
                    /**
                     * AsyncJob asyncEvaluateFormCustomActionJob.
                     * @member {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction|null|undefined} asyncEvaluateFormCustomActionJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncEvaluateFormCustomActionJob = null;
    
                    /**
                     * AsyncJob asyncAggregateAttendanceJob.
                     * @member {palexy.streaming.v1.AsyncJob.IAggregateAttendance|null|undefined} asyncAggregateAttendanceJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAggregateAttendanceJob = null;
    
                    /**
                     * AsyncJob asyncSyncReviewsJob.
                     * @member {palexy.streaming.v1.AsyncJob.ISyncReviews|null|undefined} asyncSyncReviewsJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncSyncReviewsJob = null;
    
                    /**
                     * AsyncJob asyncAggregateReputationJob.
                     * @member {palexy.streaming.v1.AsyncJob.IAggregateReputation|null|undefined} asyncAggregateReputationJob
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    AsyncJob.prototype.asyncAggregateReputationJob = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * AsyncJob asyncJobObject.
                     * @member {"asyncExportJob"|"asyncPosMatchingJob"|"asyncPosImportJob"|"asyncAggregateJob"|"asyncAggregateLevel_2Job"|"asyncCalculateConsistencyJob"|"asyncScheduleTaskJob"|"staffImportJob"|"asyncExportReportJob"|"asyncUpdateWeatherDataJob"|"asyncGenerateInsightJob"|"asyncSendReportScheduleJob"|"asyncExternalTrafficImportJob"|"asyncGenerateTrendReportJob"|"asyncAggregateStaffScheduleJob"|"asyncRerunMergingJob"|"asyncAdjustScheduleBudgetJob"|"asyncGenerateGoalTargetJob"|"asyncEvaluateGoalPerformanceJob"|"asyncSyncMatchingGroupMemberJob"|"asyncEvaluateFormCustomActionJob"|"asyncAggregateAttendanceJob"|"asyncSyncReviewsJob"|"asyncAggregateReputationJob"|undefined} asyncJobObject
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     */
                    Object.defineProperty(AsyncJob.prototype, "asyncJobObject", {
                        get: $util.oneOfGetter($oneOfFields = ["asyncExportJob", "asyncPosMatchingJob", "asyncPosImportJob", "asyncAggregateJob", "asyncAggregateLevel_2Job", "asyncCalculateConsistencyJob", "asyncScheduleTaskJob", "staffImportJob", "asyncExportReportJob", "asyncUpdateWeatherDataJob", "asyncGenerateInsightJob", "asyncSendReportScheduleJob", "asyncExternalTrafficImportJob", "asyncGenerateTrendReportJob", "asyncAggregateStaffScheduleJob", "asyncRerunMergingJob", "asyncAdjustScheduleBudgetJob", "asyncGenerateGoalTargetJob", "asyncEvaluateGoalPerformanceJob", "asyncSyncMatchingGroupMemberJob", "asyncEvaluateFormCustomActionJob", "asyncAggregateAttendanceJob", "asyncSyncReviewsJob", "asyncAggregateReputationJob"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new AsyncJob instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJob=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AsyncJob} AsyncJob instance
                     */
                    AsyncJob.create = function create(properties) {
                        return new AsyncJob(properties);
                    };
    
                    /**
                     * Encodes the specified AsyncJob message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJob} message AsyncJob message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncJob.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.ownerId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.lastUpdateTime != null && Object.hasOwnProperty.call(message, "lastUpdateTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastUpdateTime, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.asyncExportJob != null && Object.hasOwnProperty.call(message, "asyncExportJob"))
                            $root.palexy.streaming.v1.AsyncJob.Export.encode(message.asyncExportJob, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.asyncPosMatchingJob != null && Object.hasOwnProperty.call(message, "asyncPosMatchingJob"))
                            $root.palexy.streaming.v1.AsyncJob.PosMatching.encode(message.asyncPosMatchingJob, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.asyncPosImportJob != null && Object.hasOwnProperty.call(message, "asyncPosImportJob"))
                            $root.palexy.streaming.v1.AsyncJob.PosImport.encode(message.asyncPosImportJob, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.asyncAggregateJob != null && Object.hasOwnProperty.call(message, "asyncAggregateJob"))
                            $root.palexy.streaming.v1.AsyncJob.Aggregate.encode(message.asyncAggregateJob, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.asyncAggregateLevel_2Job != null && Object.hasOwnProperty.call(message, "asyncAggregateLevel_2Job"))
                            $root.palexy.streaming.v1.AsyncJob.AggregateLevel2.encode(message.asyncAggregateLevel_2Job, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.retryCount != null && Object.hasOwnProperty.call(message, "retryCount"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.retryCount);
                        if (message.asyncCalculateConsistencyJob != null && Object.hasOwnProperty.call(message, "asyncCalculateConsistencyJob"))
                            $root.palexy.streaming.v1.AsyncJob.CalculateConsistency.encode(message.asyncCalculateConsistencyJob, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.asyncScheduleTaskJob != null && Object.hasOwnProperty.call(message, "asyncScheduleTaskJob"))
                            $root.palexy.streaming.v1.AsyncJob.ScheduleTask.encode(message.asyncScheduleTaskJob, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.staffImportJob != null && Object.hasOwnProperty.call(message, "staffImportJob"))
                            $root.palexy.streaming.v1.AsyncJob.StaffImport.encode(message.staffImportJob, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.asyncExportReportJob != null && Object.hasOwnProperty.call(message, "asyncExportReportJob"))
                            $root.palexy.streaming.v1.AsyncJob.ExportReport.encode(message.asyncExportReportJob, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.asyncUpdateWeatherDataJob != null && Object.hasOwnProperty.call(message, "asyncUpdateWeatherDataJob"))
                            $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData.encode(message.asyncUpdateWeatherDataJob, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.asyncGenerateInsightJob != null && Object.hasOwnProperty.call(message, "asyncGenerateInsightJob"))
                            $root.palexy.streaming.v1.AsyncJob.GenerateInsight.encode(message.asyncGenerateInsightJob, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.asyncSendReportScheduleJob != null && Object.hasOwnProperty.call(message, "asyncSendReportScheduleJob"))
                            $root.palexy.streaming.v1.AsyncJob.SendReportSchedule.encode(message.asyncSendReportScheduleJob, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.asyncExternalTrafficImportJob != null && Object.hasOwnProperty.call(message, "asyncExternalTrafficImportJob"))
                            $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport.encode(message.asyncExternalTrafficImportJob, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.asyncGenerateTrendReportJob != null && Object.hasOwnProperty.call(message, "asyncGenerateTrendReportJob"))
                            $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport.encode(message.asyncGenerateTrendReportJob, writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                        if (message.asyncAggregateStaffScheduleJob != null && Object.hasOwnProperty.call(message, "asyncAggregateStaffScheduleJob"))
                            $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.encode(message.asyncAggregateStaffScheduleJob, writer.uint32(/* id 23, wireType 2 =*/186).fork()).ldelim();
                        if (message.lastErrorMessage != null && Object.hasOwnProperty.call(message, "lastErrorMessage"))
                            writer.uint32(/* id 24, wireType 2 =*/194).string(message.lastErrorMessage);
                        if (message.asyncRerunMergingJob != null && Object.hasOwnProperty.call(message, "asyncRerunMergingJob"))
                            $root.palexy.streaming.v1.AsyncJob.RerunMerging.encode(message.asyncRerunMergingJob, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                        if (message.asyncAdjustScheduleBudgetJob != null && Object.hasOwnProperty.call(message, "asyncAdjustScheduleBudgetJob"))
                            $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.encode(message.asyncAdjustScheduleBudgetJob, writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                        if (message.asyncGenerateGoalTargetJob != null && Object.hasOwnProperty.call(message, "asyncGenerateGoalTargetJob"))
                            $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget.encode(message.asyncGenerateGoalTargetJob, writer.uint32(/* id 27, wireType 2 =*/218).fork()).ldelim();
                        if (message.asyncEvaluateGoalPerformanceJob != null && Object.hasOwnProperty.call(message, "asyncEvaluateGoalPerformanceJob"))
                            $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.encode(message.asyncEvaluateGoalPerformanceJob, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                        if (message.asyncSyncMatchingGroupMemberJob != null && Object.hasOwnProperty.call(message, "asyncSyncMatchingGroupMemberJob"))
                            $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.encode(message.asyncSyncMatchingGroupMemberJob, writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                        if (message.asyncEvaluateFormCustomActionJob != null && Object.hasOwnProperty.call(message, "asyncEvaluateFormCustomActionJob"))
                            $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.encode(message.asyncEvaluateFormCustomActionJob, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                        if (message.asyncAggregateAttendanceJob != null && Object.hasOwnProperty.call(message, "asyncAggregateAttendanceJob"))
                            $root.palexy.streaming.v1.AsyncJob.AggregateAttendance.encode(message.asyncAggregateAttendanceJob, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                        if (message.asyncSyncReviewsJob != null && Object.hasOwnProperty.call(message, "asyncSyncReviewsJob"))
                            $root.palexy.streaming.v1.AsyncJob.SyncReviews.encode(message.asyncSyncReviewsJob, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                        if (message.asyncAggregateReputationJob != null && Object.hasOwnProperty.call(message, "asyncAggregateReputationJob"))
                            $root.palexy.streaming.v1.AsyncJob.AggregateReputation.encode(message.asyncAggregateReputationJob, writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AsyncJob message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJob} message AsyncJob message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncJob.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AsyncJob message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AsyncJob} AsyncJob
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncJob.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.type = reader.int32();
                                break;
                            case 4:
                                message.status = reader.int32();
                                break;
                            case 5:
                                message.ownerId = reader.int64();
                                break;
                            case 6:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.lastUpdateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.retryCount = reader.int32();
                                break;
                            case 24:
                                message.lastErrorMessage = reader.string();
                                break;
                            case 8:
                                message.asyncExportJob = $root.palexy.streaming.v1.AsyncJob.Export.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.asyncPosMatchingJob = $root.palexy.streaming.v1.AsyncJob.PosMatching.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.asyncPosImportJob = $root.palexy.streaming.v1.AsyncJob.PosImport.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.asyncAggregateJob = $root.palexy.streaming.v1.AsyncJob.Aggregate.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.asyncAggregateLevel_2Job = $root.palexy.streaming.v1.AsyncJob.AggregateLevel2.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.asyncCalculateConsistencyJob = $root.palexy.streaming.v1.AsyncJob.CalculateConsistency.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.asyncScheduleTaskJob = $root.palexy.streaming.v1.AsyncJob.ScheduleTask.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.staffImportJob = $root.palexy.streaming.v1.AsyncJob.StaffImport.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.asyncExportReportJob = $root.palexy.streaming.v1.AsyncJob.ExportReport.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.asyncUpdateWeatherDataJob = $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData.decode(reader, reader.uint32());
                                break;
                            case 19:
                                message.asyncGenerateInsightJob = $root.palexy.streaming.v1.AsyncJob.GenerateInsight.decode(reader, reader.uint32());
                                break;
                            case 20:
                                message.asyncSendReportScheduleJob = $root.palexy.streaming.v1.AsyncJob.SendReportSchedule.decode(reader, reader.uint32());
                                break;
                            case 21:
                                message.asyncExternalTrafficImportJob = $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport.decode(reader, reader.uint32());
                                break;
                            case 22:
                                message.asyncGenerateTrendReportJob = $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport.decode(reader, reader.uint32());
                                break;
                            case 23:
                                message.asyncAggregateStaffScheduleJob = $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.decode(reader, reader.uint32());
                                break;
                            case 25:
                                message.asyncRerunMergingJob = $root.palexy.streaming.v1.AsyncJob.RerunMerging.decode(reader, reader.uint32());
                                break;
                            case 26:
                                message.asyncAdjustScheduleBudgetJob = $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.decode(reader, reader.uint32());
                                break;
                            case 27:
                                message.asyncGenerateGoalTargetJob = $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget.decode(reader, reader.uint32());
                                break;
                            case 28:
                                message.asyncEvaluateGoalPerformanceJob = $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.decode(reader, reader.uint32());
                                break;
                            case 29:
                                message.asyncSyncMatchingGroupMemberJob = $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.decode(reader, reader.uint32());
                                break;
                            case 30:
                                message.asyncEvaluateFormCustomActionJob = $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.decode(reader, reader.uint32());
                                break;
                            case 31:
                                message.asyncAggregateAttendanceJob = $root.palexy.streaming.v1.AsyncJob.AggregateAttendance.decode(reader, reader.uint32());
                                break;
                            case 32:
                                message.asyncSyncReviewsJob = $root.palexy.streaming.v1.AsyncJob.SyncReviews.decode(reader, reader.uint32());
                                break;
                            case 33:
                                message.asyncAggregateReputationJob = $root.palexy.streaming.v1.AsyncJob.AggregateReputation.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AsyncJob message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AsyncJob} AsyncJob
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncJob.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AsyncJob message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AsyncJob.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                                break;
                            }
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastUpdateTime);
                            if (error)
                                return "lastUpdateTime." + error;
                        }
                        if (message.retryCount != null && message.hasOwnProperty("retryCount"))
                            if (!$util.isInteger(message.retryCount))
                                return "retryCount: integer expected";
                        if (message.lastErrorMessage != null && message.hasOwnProperty("lastErrorMessage"))
                            if (!$util.isString(message.lastErrorMessage))
                                return "lastErrorMessage: string expected";
                        if (message.asyncExportJob != null && message.hasOwnProperty("asyncExportJob")) {
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.Export.verify(message.asyncExportJob);
                                if (error)
                                    return "asyncExportJob." + error;
                            }
                        }
                        if (message.asyncPosMatchingJob != null && message.hasOwnProperty("asyncPosMatchingJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.PosMatching.verify(message.asyncPosMatchingJob);
                                if (error)
                                    return "asyncPosMatchingJob." + error;
                            }
                        }
                        if (message.asyncPosImportJob != null && message.hasOwnProperty("asyncPosImportJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.PosImport.verify(message.asyncPosImportJob);
                                if (error)
                                    return "asyncPosImportJob." + error;
                            }
                        }
                        if (message.asyncAggregateJob != null && message.hasOwnProperty("asyncAggregateJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.Aggregate.verify(message.asyncAggregateJob);
                                if (error)
                                    return "asyncAggregateJob." + error;
                            }
                        }
                        if (message.asyncAggregateLevel_2Job != null && message.hasOwnProperty("asyncAggregateLevel_2Job")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.AggregateLevel2.verify(message.asyncAggregateLevel_2Job);
                                if (error)
                                    return "asyncAggregateLevel_2Job." + error;
                            }
                        }
                        if (message.asyncCalculateConsistencyJob != null && message.hasOwnProperty("asyncCalculateConsistencyJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.CalculateConsistency.verify(message.asyncCalculateConsistencyJob);
                                if (error)
                                    return "asyncCalculateConsistencyJob." + error;
                            }
                        }
                        if (message.asyncScheduleTaskJob != null && message.hasOwnProperty("asyncScheduleTaskJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.ScheduleTask.verify(message.asyncScheduleTaskJob);
                                if (error)
                                    return "asyncScheduleTaskJob." + error;
                            }
                        }
                        if (message.staffImportJob != null && message.hasOwnProperty("staffImportJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.StaffImport.verify(message.staffImportJob);
                                if (error)
                                    return "staffImportJob." + error;
                            }
                        }
                        if (message.asyncExportReportJob != null && message.hasOwnProperty("asyncExportReportJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.ExportReport.verify(message.asyncExportReportJob);
                                if (error)
                                    return "asyncExportReportJob." + error;
                            }
                        }
                        if (message.asyncUpdateWeatherDataJob != null && message.hasOwnProperty("asyncUpdateWeatherDataJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData.verify(message.asyncUpdateWeatherDataJob);
                                if (error)
                                    return "asyncUpdateWeatherDataJob." + error;
                            }
                        }
                        if (message.asyncGenerateInsightJob != null && message.hasOwnProperty("asyncGenerateInsightJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.GenerateInsight.verify(message.asyncGenerateInsightJob);
                                if (error)
                                    return "asyncGenerateInsightJob." + error;
                            }
                        }
                        if (message.asyncSendReportScheduleJob != null && message.hasOwnProperty("asyncSendReportScheduleJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.SendReportSchedule.verify(message.asyncSendReportScheduleJob);
                                if (error)
                                    return "asyncSendReportScheduleJob." + error;
                            }
                        }
                        if (message.asyncExternalTrafficImportJob != null && message.hasOwnProperty("asyncExternalTrafficImportJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport.verify(message.asyncExternalTrafficImportJob);
                                if (error)
                                    return "asyncExternalTrafficImportJob." + error;
                            }
                        }
                        if (message.asyncGenerateTrendReportJob != null && message.hasOwnProperty("asyncGenerateTrendReportJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport.verify(message.asyncGenerateTrendReportJob);
                                if (error)
                                    return "asyncGenerateTrendReportJob." + error;
                            }
                        }
                        if (message.asyncAggregateStaffScheduleJob != null && message.hasOwnProperty("asyncAggregateStaffScheduleJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.verify(message.asyncAggregateStaffScheduleJob);
                                if (error)
                                    return "asyncAggregateStaffScheduleJob." + error;
                            }
                        }
                        if (message.asyncRerunMergingJob != null && message.hasOwnProperty("asyncRerunMergingJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.RerunMerging.verify(message.asyncRerunMergingJob);
                                if (error)
                                    return "asyncRerunMergingJob." + error;
                            }
                        }
                        if (message.asyncAdjustScheduleBudgetJob != null && message.hasOwnProperty("asyncAdjustScheduleBudgetJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.verify(message.asyncAdjustScheduleBudgetJob);
                                if (error)
                                    return "asyncAdjustScheduleBudgetJob." + error;
                            }
                        }
                        if (message.asyncGenerateGoalTargetJob != null && message.hasOwnProperty("asyncGenerateGoalTargetJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget.verify(message.asyncGenerateGoalTargetJob);
                                if (error)
                                    return "asyncGenerateGoalTargetJob." + error;
                            }
                        }
                        if (message.asyncEvaluateGoalPerformanceJob != null && message.hasOwnProperty("asyncEvaluateGoalPerformanceJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.verify(message.asyncEvaluateGoalPerformanceJob);
                                if (error)
                                    return "asyncEvaluateGoalPerformanceJob." + error;
                            }
                        }
                        if (message.asyncSyncMatchingGroupMemberJob != null && message.hasOwnProperty("asyncSyncMatchingGroupMemberJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.verify(message.asyncSyncMatchingGroupMemberJob);
                                if (error)
                                    return "asyncSyncMatchingGroupMemberJob." + error;
                            }
                        }
                        if (message.asyncEvaluateFormCustomActionJob != null && message.hasOwnProperty("asyncEvaluateFormCustomActionJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.verify(message.asyncEvaluateFormCustomActionJob);
                                if (error)
                                    return "asyncEvaluateFormCustomActionJob." + error;
                            }
                        }
                        if (message.asyncAggregateAttendanceJob != null && message.hasOwnProperty("asyncAggregateAttendanceJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.AggregateAttendance.verify(message.asyncAggregateAttendanceJob);
                                if (error)
                                    return "asyncAggregateAttendanceJob." + error;
                            }
                        }
                        if (message.asyncSyncReviewsJob != null && message.hasOwnProperty("asyncSyncReviewsJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.SyncReviews.verify(message.asyncSyncReviewsJob);
                                if (error)
                                    return "asyncSyncReviewsJob." + error;
                            }
                        }
                        if (message.asyncAggregateReputationJob != null && message.hasOwnProperty("asyncAggregateReputationJob")) {
                            if (properties.asyncJobObject === 1)
                                return "asyncJobObject: multiple values";
                            properties.asyncJobObject = 1;
                            {
                                var error = $root.palexy.streaming.v1.AsyncJob.AggregateReputation.verify(message.asyncAggregateReputationJob);
                                if (error)
                                    return "asyncAggregateReputationJob." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AsyncJob message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AsyncJob} AsyncJob
                     */
                    AsyncJob.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AsyncJob)
                            return object;
                        var message = new $root.palexy.streaming.v1.AsyncJob();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "EXPORT":
                        case 1:
                            message.type = 1;
                            break;
                        case "POS_MATCHING":
                        case 2:
                            message.type = 2;
                            break;
                        case "POS_IMPORT":
                        case 3:
                            message.type = 3;
                            break;
                        case "AGGREGATE":
                        case 4:
                            message.type = 4;
                            break;
                        case "AGGREGATE_LEVEL_2":
                        case 5:
                            message.type = 5;
                            break;
                        case "CALCULATE_CONSISTENCY":
                        case 6:
                            message.type = 6;
                            break;
                        case "SCHEDULE_TASK":
                        case 7:
                            message.type = 7;
                            break;
                        case "STAFF_DATA_IMPORT":
                        case 8:
                            message.type = 8;
                            break;
                        case "EXPORT_REPORT":
                        case 9:
                            message.type = 9;
                            break;
                        case "UPDATE_WEATHER_DATA":
                        case 10:
                            message.type = 10;
                            break;
                        case "GENERATE_INSIGHT":
                        case 11:
                            message.type = 11;
                            break;
                        case "SEND_REPORT_SCHEDULE":
                        case 12:
                            message.type = 12;
                            break;
                        case "EXTERNAL_TRAFFIC_IMPORT":
                        case 13:
                            message.type = 13;
                            break;
                        case "GENERATE_TREND_REPORT":
                        case 14:
                            message.type = 14;
                            break;
                        case "AGGREGATE_STAFF_SCHEDULE":
                        case 15:
                            message.type = 15;
                            break;
                        case "RERUN_MERGING":
                        case 16:
                            message.type = 16;
                            break;
                        case "ADJUST_SCHEDULE_BUDGET":
                        case 17:
                            message.type = 17;
                            break;
                        case "GOAL_GENERATE_TARGET":
                        case 18:
                            message.type = 18;
                            break;
                        case "GOAL_EVALUATE_PERFORMANCE":
                        case 19:
                            message.type = 19;
                            break;
                        case "SYNC_MATCHING_GROUP_MEMBER":
                        case 20:
                            message.type = 20;
                            break;
                        case "EVALUATE_FORM_CUSTOM_ACTION":
                        case 21:
                            message.type = 21;
                            break;
                        case "AGGREGATE_ATTENDANCE":
                        case 22:
                            message.type = 22;
                            break;
                        case "SYNC_REVIEWS":
                        case 23:
                            message.type = 23;
                            break;
                        case "AGGREGATE_REPUTATION":
                        case 24:
                            message.type = 24;
                            break;
                        }
                        switch (object.status) {
                        case "UNPROCESSED":
                        case 0:
                            message.status = 0;
                            break;
                        case "PROCESSING":
                        case 1:
                            message.status = 1;
                            break;
                        case "WAIT_FOR_RETRYING":
                        case 2:
                            message.status = 2;
                            break;
                        case "DONE":
                        case 3:
                            message.status = 3;
                            break;
                        case "CANCELLED":
                        case 4:
                            message.status = 4;
                            break;
                        case "SKIPPED":
                        case 5:
                            message.status = 5;
                            break;
                        case "RECURRING":
                        case 6:
                            message.status = 6;
                            break;
                        }
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastUpdateTime != null) {
                            if (typeof object.lastUpdateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.lastUpdateTime: object expected");
                            message.lastUpdateTime = $root.google.protobuf.Timestamp.fromObject(object.lastUpdateTime);
                        }
                        if (object.retryCount != null)
                            message.retryCount = object.retryCount | 0;
                        if (object.lastErrorMessage != null)
                            message.lastErrorMessage = String(object.lastErrorMessage);
                        if (object.asyncExportJob != null) {
                            if (typeof object.asyncExportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncExportJob: object expected");
                            message.asyncExportJob = $root.palexy.streaming.v1.AsyncJob.Export.fromObject(object.asyncExportJob);
                        }
                        if (object.asyncPosMatchingJob != null) {
                            if (typeof object.asyncPosMatchingJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncPosMatchingJob: object expected");
                            message.asyncPosMatchingJob = $root.palexy.streaming.v1.AsyncJob.PosMatching.fromObject(object.asyncPosMatchingJob);
                        }
                        if (object.asyncPosImportJob != null) {
                            if (typeof object.asyncPosImportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncPosImportJob: object expected");
                            message.asyncPosImportJob = $root.palexy.streaming.v1.AsyncJob.PosImport.fromObject(object.asyncPosImportJob);
                        }
                        if (object.asyncAggregateJob != null) {
                            if (typeof object.asyncAggregateJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAggregateJob: object expected");
                            message.asyncAggregateJob = $root.palexy.streaming.v1.AsyncJob.Aggregate.fromObject(object.asyncAggregateJob);
                        }
                        if (object.asyncAggregateLevel_2Job != null) {
                            if (typeof object.asyncAggregateLevel_2Job !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAggregateLevel_2Job: object expected");
                            message.asyncAggregateLevel_2Job = $root.palexy.streaming.v1.AsyncJob.AggregateLevel2.fromObject(object.asyncAggregateLevel_2Job);
                        }
                        if (object.asyncCalculateConsistencyJob != null) {
                            if (typeof object.asyncCalculateConsistencyJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncCalculateConsistencyJob: object expected");
                            message.asyncCalculateConsistencyJob = $root.palexy.streaming.v1.AsyncJob.CalculateConsistency.fromObject(object.asyncCalculateConsistencyJob);
                        }
                        if (object.asyncScheduleTaskJob != null) {
                            if (typeof object.asyncScheduleTaskJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncScheduleTaskJob: object expected");
                            message.asyncScheduleTaskJob = $root.palexy.streaming.v1.AsyncJob.ScheduleTask.fromObject(object.asyncScheduleTaskJob);
                        }
                        if (object.staffImportJob != null) {
                            if (typeof object.staffImportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.staffImportJob: object expected");
                            message.staffImportJob = $root.palexy.streaming.v1.AsyncJob.StaffImport.fromObject(object.staffImportJob);
                        }
                        if (object.asyncExportReportJob != null) {
                            if (typeof object.asyncExportReportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncExportReportJob: object expected");
                            message.asyncExportReportJob = $root.palexy.streaming.v1.AsyncJob.ExportReport.fromObject(object.asyncExportReportJob);
                        }
                        if (object.asyncUpdateWeatherDataJob != null) {
                            if (typeof object.asyncUpdateWeatherDataJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncUpdateWeatherDataJob: object expected");
                            message.asyncUpdateWeatherDataJob = $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData.fromObject(object.asyncUpdateWeatherDataJob);
                        }
                        if (object.asyncGenerateInsightJob != null) {
                            if (typeof object.asyncGenerateInsightJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncGenerateInsightJob: object expected");
                            message.asyncGenerateInsightJob = $root.palexy.streaming.v1.AsyncJob.GenerateInsight.fromObject(object.asyncGenerateInsightJob);
                        }
                        if (object.asyncSendReportScheduleJob != null) {
                            if (typeof object.asyncSendReportScheduleJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncSendReportScheduleJob: object expected");
                            message.asyncSendReportScheduleJob = $root.palexy.streaming.v1.AsyncJob.SendReportSchedule.fromObject(object.asyncSendReportScheduleJob);
                        }
                        if (object.asyncExternalTrafficImportJob != null) {
                            if (typeof object.asyncExternalTrafficImportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncExternalTrafficImportJob: object expected");
                            message.asyncExternalTrafficImportJob = $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport.fromObject(object.asyncExternalTrafficImportJob);
                        }
                        if (object.asyncGenerateTrendReportJob != null) {
                            if (typeof object.asyncGenerateTrendReportJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncGenerateTrendReportJob: object expected");
                            message.asyncGenerateTrendReportJob = $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport.fromObject(object.asyncGenerateTrendReportJob);
                        }
                        if (object.asyncAggregateStaffScheduleJob != null) {
                            if (typeof object.asyncAggregateStaffScheduleJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAggregateStaffScheduleJob: object expected");
                            message.asyncAggregateStaffScheduleJob = $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.fromObject(object.asyncAggregateStaffScheduleJob);
                        }
                        if (object.asyncRerunMergingJob != null) {
                            if (typeof object.asyncRerunMergingJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncRerunMergingJob: object expected");
                            message.asyncRerunMergingJob = $root.palexy.streaming.v1.AsyncJob.RerunMerging.fromObject(object.asyncRerunMergingJob);
                        }
                        if (object.asyncAdjustScheduleBudgetJob != null) {
                            if (typeof object.asyncAdjustScheduleBudgetJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAdjustScheduleBudgetJob: object expected");
                            message.asyncAdjustScheduleBudgetJob = $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.fromObject(object.asyncAdjustScheduleBudgetJob);
                        }
                        if (object.asyncGenerateGoalTargetJob != null) {
                            if (typeof object.asyncGenerateGoalTargetJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncGenerateGoalTargetJob: object expected");
                            message.asyncGenerateGoalTargetJob = $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget.fromObject(object.asyncGenerateGoalTargetJob);
                        }
                        if (object.asyncEvaluateGoalPerformanceJob != null) {
                            if (typeof object.asyncEvaluateGoalPerformanceJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncEvaluateGoalPerformanceJob: object expected");
                            message.asyncEvaluateGoalPerformanceJob = $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.fromObject(object.asyncEvaluateGoalPerformanceJob);
                        }
                        if (object.asyncSyncMatchingGroupMemberJob != null) {
                            if (typeof object.asyncSyncMatchingGroupMemberJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncSyncMatchingGroupMemberJob: object expected");
                            message.asyncSyncMatchingGroupMemberJob = $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.fromObject(object.asyncSyncMatchingGroupMemberJob);
                        }
                        if (object.asyncEvaluateFormCustomActionJob != null) {
                            if (typeof object.asyncEvaluateFormCustomActionJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncEvaluateFormCustomActionJob: object expected");
                            message.asyncEvaluateFormCustomActionJob = $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.fromObject(object.asyncEvaluateFormCustomActionJob);
                        }
                        if (object.asyncAggregateAttendanceJob != null) {
                            if (typeof object.asyncAggregateAttendanceJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAggregateAttendanceJob: object expected");
                            message.asyncAggregateAttendanceJob = $root.palexy.streaming.v1.AsyncJob.AggregateAttendance.fromObject(object.asyncAggregateAttendanceJob);
                        }
                        if (object.asyncSyncReviewsJob != null) {
                            if (typeof object.asyncSyncReviewsJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncSyncReviewsJob: object expected");
                            message.asyncSyncReviewsJob = $root.palexy.streaming.v1.AsyncJob.SyncReviews.fromObject(object.asyncSyncReviewsJob);
                        }
                        if (object.asyncAggregateReputationJob != null) {
                            if (typeof object.asyncAggregateReputationJob !== "object")
                                throw TypeError(".palexy.streaming.v1.AsyncJob.asyncAggregateReputationJob: object expected");
                            message.asyncAggregateReputationJob = $root.palexy.streaming.v1.AsyncJob.AggregateReputation.fromObject(object.asyncAggregateReputationJob);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AsyncJob message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @static
                     * @param {palexy.streaming.v1.AsyncJob} message AsyncJob
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AsyncJob.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.status = options.enums === String ? "UNPROCESSED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.lastUpdateTime = null;
                            object.retryCount = 0;
                            object.lastErrorMessage = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Type[message.type] : message.type;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Status[message.status] : message.status;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastUpdateTime != null && message.hasOwnProperty("lastUpdateTime"))
                            object.lastUpdateTime = $root.google.protobuf.Timestamp.toObject(message.lastUpdateTime, options);
                        if (message.asyncExportJob != null && message.hasOwnProperty("asyncExportJob")) {
                            object.asyncExportJob = $root.palexy.streaming.v1.AsyncJob.Export.toObject(message.asyncExportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncExportJob";
                        }
                        if (message.asyncPosMatchingJob != null && message.hasOwnProperty("asyncPosMatchingJob")) {
                            object.asyncPosMatchingJob = $root.palexy.streaming.v1.AsyncJob.PosMatching.toObject(message.asyncPosMatchingJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncPosMatchingJob";
                        }
                        if (message.asyncPosImportJob != null && message.hasOwnProperty("asyncPosImportJob")) {
                            object.asyncPosImportJob = $root.palexy.streaming.v1.AsyncJob.PosImport.toObject(message.asyncPosImportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncPosImportJob";
                        }
                        if (message.asyncAggregateJob != null && message.hasOwnProperty("asyncAggregateJob")) {
                            object.asyncAggregateJob = $root.palexy.streaming.v1.AsyncJob.Aggregate.toObject(message.asyncAggregateJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAggregateJob";
                        }
                        if (message.asyncAggregateLevel_2Job != null && message.hasOwnProperty("asyncAggregateLevel_2Job")) {
                            object.asyncAggregateLevel_2Job = $root.palexy.streaming.v1.AsyncJob.AggregateLevel2.toObject(message.asyncAggregateLevel_2Job, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAggregateLevel_2Job";
                        }
                        if (message.retryCount != null && message.hasOwnProperty("retryCount"))
                            object.retryCount = message.retryCount;
                        if (message.asyncCalculateConsistencyJob != null && message.hasOwnProperty("asyncCalculateConsistencyJob")) {
                            object.asyncCalculateConsistencyJob = $root.palexy.streaming.v1.AsyncJob.CalculateConsistency.toObject(message.asyncCalculateConsistencyJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncCalculateConsistencyJob";
                        }
                        if (message.asyncScheduleTaskJob != null && message.hasOwnProperty("asyncScheduleTaskJob")) {
                            object.asyncScheduleTaskJob = $root.palexy.streaming.v1.AsyncJob.ScheduleTask.toObject(message.asyncScheduleTaskJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncScheduleTaskJob";
                        }
                        if (message.staffImportJob != null && message.hasOwnProperty("staffImportJob")) {
                            object.staffImportJob = $root.palexy.streaming.v1.AsyncJob.StaffImport.toObject(message.staffImportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "staffImportJob";
                        }
                        if (message.asyncExportReportJob != null && message.hasOwnProperty("asyncExportReportJob")) {
                            object.asyncExportReportJob = $root.palexy.streaming.v1.AsyncJob.ExportReport.toObject(message.asyncExportReportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncExportReportJob";
                        }
                        if (message.asyncUpdateWeatherDataJob != null && message.hasOwnProperty("asyncUpdateWeatherDataJob")) {
                            object.asyncUpdateWeatherDataJob = $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData.toObject(message.asyncUpdateWeatherDataJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncUpdateWeatherDataJob";
                        }
                        if (message.asyncGenerateInsightJob != null && message.hasOwnProperty("asyncGenerateInsightJob")) {
                            object.asyncGenerateInsightJob = $root.palexy.streaming.v1.AsyncJob.GenerateInsight.toObject(message.asyncGenerateInsightJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncGenerateInsightJob";
                        }
                        if (message.asyncSendReportScheduleJob != null && message.hasOwnProperty("asyncSendReportScheduleJob")) {
                            object.asyncSendReportScheduleJob = $root.palexy.streaming.v1.AsyncJob.SendReportSchedule.toObject(message.asyncSendReportScheduleJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncSendReportScheduleJob";
                        }
                        if (message.asyncExternalTrafficImportJob != null && message.hasOwnProperty("asyncExternalTrafficImportJob")) {
                            object.asyncExternalTrafficImportJob = $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport.toObject(message.asyncExternalTrafficImportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncExternalTrafficImportJob";
                        }
                        if (message.asyncGenerateTrendReportJob != null && message.hasOwnProperty("asyncGenerateTrendReportJob")) {
                            object.asyncGenerateTrendReportJob = $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport.toObject(message.asyncGenerateTrendReportJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncGenerateTrendReportJob";
                        }
                        if (message.asyncAggregateStaffScheduleJob != null && message.hasOwnProperty("asyncAggregateStaffScheduleJob")) {
                            object.asyncAggregateStaffScheduleJob = $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.toObject(message.asyncAggregateStaffScheduleJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAggregateStaffScheduleJob";
                        }
                        if (message.lastErrorMessage != null && message.hasOwnProperty("lastErrorMessage"))
                            object.lastErrorMessage = message.lastErrorMessage;
                        if (message.asyncRerunMergingJob != null && message.hasOwnProperty("asyncRerunMergingJob")) {
                            object.asyncRerunMergingJob = $root.palexy.streaming.v1.AsyncJob.RerunMerging.toObject(message.asyncRerunMergingJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncRerunMergingJob";
                        }
                        if (message.asyncAdjustScheduleBudgetJob != null && message.hasOwnProperty("asyncAdjustScheduleBudgetJob")) {
                            object.asyncAdjustScheduleBudgetJob = $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.toObject(message.asyncAdjustScheduleBudgetJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAdjustScheduleBudgetJob";
                        }
                        if (message.asyncGenerateGoalTargetJob != null && message.hasOwnProperty("asyncGenerateGoalTargetJob")) {
                            object.asyncGenerateGoalTargetJob = $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget.toObject(message.asyncGenerateGoalTargetJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncGenerateGoalTargetJob";
                        }
                        if (message.asyncEvaluateGoalPerformanceJob != null && message.hasOwnProperty("asyncEvaluateGoalPerformanceJob")) {
                            object.asyncEvaluateGoalPerformanceJob = $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.toObject(message.asyncEvaluateGoalPerformanceJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncEvaluateGoalPerformanceJob";
                        }
                        if (message.asyncSyncMatchingGroupMemberJob != null && message.hasOwnProperty("asyncSyncMatchingGroupMemberJob")) {
                            object.asyncSyncMatchingGroupMemberJob = $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.toObject(message.asyncSyncMatchingGroupMemberJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncSyncMatchingGroupMemberJob";
                        }
                        if (message.asyncEvaluateFormCustomActionJob != null && message.hasOwnProperty("asyncEvaluateFormCustomActionJob")) {
                            object.asyncEvaluateFormCustomActionJob = $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.toObject(message.asyncEvaluateFormCustomActionJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncEvaluateFormCustomActionJob";
                        }
                        if (message.asyncAggregateAttendanceJob != null && message.hasOwnProperty("asyncAggregateAttendanceJob")) {
                            object.asyncAggregateAttendanceJob = $root.palexy.streaming.v1.AsyncJob.AggregateAttendance.toObject(message.asyncAggregateAttendanceJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAggregateAttendanceJob";
                        }
                        if (message.asyncSyncReviewsJob != null && message.hasOwnProperty("asyncSyncReviewsJob")) {
                            object.asyncSyncReviewsJob = $root.palexy.streaming.v1.AsyncJob.SyncReviews.toObject(message.asyncSyncReviewsJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncSyncReviewsJob";
                        }
                        if (message.asyncAggregateReputationJob != null && message.hasOwnProperty("asyncAggregateReputationJob")) {
                            object.asyncAggregateReputationJob = $root.palexy.streaming.v1.AsyncJob.AggregateReputation.toObject(message.asyncAggregateReputationJob, options);
                            if (options.oneofs)
                                object.asyncJobObject = "asyncAggregateReputationJob";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AsyncJob to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AsyncJob
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AsyncJob.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Type enum.
                     * @name palexy.streaming.v1.AsyncJob.Type
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} EXPORT=1 EXPORT value
                     * @property {number} POS_MATCHING=2 POS_MATCHING value
                     * @property {number} POS_IMPORT=3 POS_IMPORT value
                     * @property {number} AGGREGATE=4 AGGREGATE value
                     * @property {number} AGGREGATE_LEVEL_2=5 AGGREGATE_LEVEL_2 value
                     * @property {number} CALCULATE_CONSISTENCY=6 CALCULATE_CONSISTENCY value
                     * @property {number} SCHEDULE_TASK=7 SCHEDULE_TASK value
                     * @property {number} STAFF_DATA_IMPORT=8 STAFF_DATA_IMPORT value
                     * @property {number} EXPORT_REPORT=9 EXPORT_REPORT value
                     * @property {number} UPDATE_WEATHER_DATA=10 UPDATE_WEATHER_DATA value
                     * @property {number} GENERATE_INSIGHT=11 GENERATE_INSIGHT value
                     * @property {number} SEND_REPORT_SCHEDULE=12 SEND_REPORT_SCHEDULE value
                     * @property {number} EXTERNAL_TRAFFIC_IMPORT=13 EXTERNAL_TRAFFIC_IMPORT value
                     * @property {number} GENERATE_TREND_REPORT=14 GENERATE_TREND_REPORT value
                     * @property {number} AGGREGATE_STAFF_SCHEDULE=15 AGGREGATE_STAFF_SCHEDULE value
                     * @property {number} RERUN_MERGING=16 RERUN_MERGING value
                     * @property {number} ADJUST_SCHEDULE_BUDGET=17 ADJUST_SCHEDULE_BUDGET value
                     * @property {number} GOAL_GENERATE_TARGET=18 GOAL_GENERATE_TARGET value
                     * @property {number} GOAL_EVALUATE_PERFORMANCE=19 GOAL_EVALUATE_PERFORMANCE value
                     * @property {number} SYNC_MATCHING_GROUP_MEMBER=20 SYNC_MATCHING_GROUP_MEMBER value
                     * @property {number} EVALUATE_FORM_CUSTOM_ACTION=21 EVALUATE_FORM_CUSTOM_ACTION value
                     * @property {number} AGGREGATE_ATTENDANCE=22 AGGREGATE_ATTENDANCE value
                     * @property {number} SYNC_REVIEWS=23 SYNC_REVIEWS value
                     * @property {number} AGGREGATE_REPUTATION=24 AGGREGATE_REPUTATION value
                     */
                    AsyncJob.Type = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "EXPORT"] = 1;
                        values[valuesById[2] = "POS_MATCHING"] = 2;
                        values[valuesById[3] = "POS_IMPORT"] = 3;
                        values[valuesById[4] = "AGGREGATE"] = 4;
                        values[valuesById[5] = "AGGREGATE_LEVEL_2"] = 5;
                        values[valuesById[6] = "CALCULATE_CONSISTENCY"] = 6;
                        values[valuesById[7] = "SCHEDULE_TASK"] = 7;
                        values[valuesById[8] = "STAFF_DATA_IMPORT"] = 8;
                        values[valuesById[9] = "EXPORT_REPORT"] = 9;
                        values[valuesById[10] = "UPDATE_WEATHER_DATA"] = 10;
                        values[valuesById[11] = "GENERATE_INSIGHT"] = 11;
                        values[valuesById[12] = "SEND_REPORT_SCHEDULE"] = 12;
                        values[valuesById[13] = "EXTERNAL_TRAFFIC_IMPORT"] = 13;
                        values[valuesById[14] = "GENERATE_TREND_REPORT"] = 14;
                        values[valuesById[15] = "AGGREGATE_STAFF_SCHEDULE"] = 15;
                        values[valuesById[16] = "RERUN_MERGING"] = 16;
                        values[valuesById[17] = "ADJUST_SCHEDULE_BUDGET"] = 17;
                        values[valuesById[18] = "GOAL_GENERATE_TARGET"] = 18;
                        values[valuesById[19] = "GOAL_EVALUATE_PERFORMANCE"] = 19;
                        values[valuesById[20] = "SYNC_MATCHING_GROUP_MEMBER"] = 20;
                        values[valuesById[21] = "EVALUATE_FORM_CUSTOM_ACTION"] = 21;
                        values[valuesById[22] = "AGGREGATE_ATTENDANCE"] = 22;
                        values[valuesById[23] = "SYNC_REVIEWS"] = 23;
                        values[valuesById[24] = "AGGREGATE_REPUTATION"] = 24;
                        return values;
                    })();
    
                    /**
                     * Status enum.
                     * @name palexy.streaming.v1.AsyncJob.Status
                     * @enum {number}
                     * @property {number} UNPROCESSED=0 UNPROCESSED value
                     * @property {number} PROCESSING=1 PROCESSING value
                     * @property {number} WAIT_FOR_RETRYING=2 WAIT_FOR_RETRYING value
                     * @property {number} DONE=3 DONE value
                     * @property {number} CANCELLED=4 CANCELLED value
                     * @property {number} SKIPPED=5 SKIPPED value
                     * @property {number} RECURRING=6 RECURRING value
                     */
                    AsyncJob.Status = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNPROCESSED"] = 0;
                        values[valuesById[1] = "PROCESSING"] = 1;
                        values[valuesById[2] = "WAIT_FOR_RETRYING"] = 2;
                        values[valuesById[3] = "DONE"] = 3;
                        values[valuesById[4] = "CANCELLED"] = 4;
                        values[valuesById[5] = "SKIPPED"] = 5;
                        values[valuesById[6] = "RECURRING"] = 6;
                        return values;
                    })();
    
                    AsyncJob.Export = (function() {
    
                        /**
                         * Properties of an Export.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IExport
                         * @property {string|null} [exportDate] Export exportDate
                         */
    
                        /**
                         * Constructs a new Export.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an Export.
                         * @implements IExport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IExport=} [properties] Properties to set
                         */
                        function Export(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Export exportDate.
                         * @member {string} exportDate
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @instance
                         */
                        Export.prototype.exportDate = "";
    
                        /**
                         * Creates a new Export instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.Export} Export instance
                         */
                        Export.create = function create(properties) {
                            return new Export(properties);
                        };
    
                        /**
                         * Encodes the specified Export message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.Export.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExport} message Export message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Export.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.exportDate != null && Object.hasOwnProperty.call(message, "exportDate"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.exportDate);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Export message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.Export.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExport} message Export message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Export.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an Export message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.Export} Export
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Export.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.Export();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.exportDate = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an Export message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.Export} Export
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Export.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an Export message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Export.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.exportDate != null && message.hasOwnProperty("exportDate"))
                                if (!$util.isString(message.exportDate))
                                    return "exportDate: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an Export message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.Export} Export
                         */
                        Export.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.Export)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.Export();
                            if (object.exportDate != null)
                                message.exportDate = String(object.exportDate);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an Export message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.Export} message Export
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Export.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.exportDate = "";
                            if (message.exportDate != null && message.hasOwnProperty("exportDate"))
                                object.exportDate = message.exportDate;
                            return object;
                        };
    
                        /**
                         * Converts this Export to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.Export
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Export.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Export;
                    })();
    
                    AsyncJob.PosMatching = (function() {
    
                        /**
                         * Properties of a PosMatching.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IPosMatching
                         * @property {number|null} [storeId] PosMatching storeId
                         * @property {string|null} [dateId] PosMatching dateId
                         */
    
                        /**
                         * Constructs a new PosMatching.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a PosMatching.
                         * @implements IPosMatching
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IPosMatching=} [properties] Properties to set
                         */
                        function PosMatching(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * PosMatching storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @instance
                         */
                        PosMatching.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * PosMatching dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @instance
                         */
                        PosMatching.prototype.dateId = "";
    
                        /**
                         * Creates a new PosMatching instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosMatching=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.PosMatching} PosMatching instance
                         */
                        PosMatching.create = function create(properties) {
                            return new PosMatching(properties);
                        };
    
                        /**
                         * Encodes the specified PosMatching message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.PosMatching.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosMatching} message PosMatching message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PosMatching.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified PosMatching message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.PosMatching.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosMatching} message PosMatching message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PosMatching.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a PosMatching message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.PosMatching} PosMatching
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PosMatching.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.PosMatching();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a PosMatching message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.PosMatching} PosMatching
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PosMatching.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a PosMatching message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PosMatching.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a PosMatching message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.PosMatching} PosMatching
                         */
                        PosMatching.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.PosMatching)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.PosMatching();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a PosMatching message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.PosMatching} message PosMatching
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PosMatching.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this PosMatching to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.PosMatching
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PosMatching.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return PosMatching;
                    })();
    
                    AsyncJob.PosImport = (function() {
    
                        /**
                         * Properties of a PosImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IPosImport
                         * @property {google.protobuf.IUInt64Value|null} [storeId] PosImport storeId
                         * @property {string|null} [dateId] PosImport dateId
                         */
    
                        /**
                         * Constructs a new PosImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a PosImport.
                         * @implements IPosImport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IPosImport=} [properties] Properties to set
                         */
                        function PosImport(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * PosImport storeId.
                         * @member {google.protobuf.IUInt64Value|null|undefined} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @instance
                         */
                        PosImport.prototype.storeId = null;
    
                        /**
                         * PosImport dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @instance
                         */
                        PosImport.prototype.dateId = "";
    
                        /**
                         * Creates a new PosImport instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosImport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.PosImport} PosImport instance
                         */
                        PosImport.create = function create(properties) {
                            return new PosImport(properties);
                        };
    
                        /**
                         * Encodes the specified PosImport message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.PosImport.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosImport} message PosImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PosImport.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                $root.google.protobuf.UInt64Value.encode(message.storeId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified PosImport message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.PosImport.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IPosImport} message PosImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        PosImport.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a PosImport message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.PosImport} PosImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PosImport.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.PosImport();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = $root.google.protobuf.UInt64Value.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a PosImport message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.PosImport} PosImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        PosImport.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a PosImport message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        PosImport.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId")) {
                                var error = $root.google.protobuf.UInt64Value.verify(message.storeId);
                                if (error)
                                    return "storeId." + error;
                            }
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a PosImport message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.PosImport} PosImport
                         */
                        PosImport.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.PosImport)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.PosImport();
                            if (object.storeId != null) {
                                if (typeof object.storeId !== "object")
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.PosImport.storeId: object expected");
                                message.storeId = $root.google.protobuf.UInt64Value.fromObject(object.storeId);
                            }
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a PosImport message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.PosImport} message PosImport
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        PosImport.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.storeId = null;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                object.storeId = $root.google.protobuf.UInt64Value.toObject(message.storeId, options);
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this PosImport to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.PosImport
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        PosImport.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return PosImport;
                    })();
    
                    AsyncJob.Aggregate = (function() {
    
                        /**
                         * Properties of an Aggregate.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAggregate
                         * @property {number|null} [storeId] Aggregate storeId
                         * @property {string|null} [dateId] Aggregate dateId
                         */
    
                        /**
                         * Constructs a new Aggregate.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an Aggregate.
                         * @implements IAggregate
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAggregate=} [properties] Properties to set
                         */
                        function Aggregate(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Aggregate storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @instance
                         */
                        Aggregate.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Aggregate dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @instance
                         */
                        Aggregate.prototype.dateId = "";
    
                        /**
                         * Creates a new Aggregate instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregate=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.Aggregate} Aggregate instance
                         */
                        Aggregate.create = function create(properties) {
                            return new Aggregate(properties);
                        };
    
                        /**
                         * Encodes the specified Aggregate message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.Aggregate.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregate} message Aggregate message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Aggregate.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Aggregate message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.Aggregate.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregate} message Aggregate message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Aggregate.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an Aggregate message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.Aggregate} Aggregate
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Aggregate.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.Aggregate();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an Aggregate message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.Aggregate} Aggregate
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Aggregate.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an Aggregate message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Aggregate.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an Aggregate message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.Aggregate} Aggregate
                         */
                        Aggregate.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.Aggregate)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.Aggregate();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an Aggregate message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.Aggregate} message Aggregate
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Aggregate.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this Aggregate to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.Aggregate
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Aggregate.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Aggregate;
                    })();
    
                    AsyncJob.AggregateLevel2 = (function() {
    
                        /**
                         * Properties of an AggregateLevel2.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAggregateLevel2
                         * @property {number|null} [storeId] AggregateLevel2 storeId
                         * @property {string|null} [dateId] AggregateLevel2 dateId
                         */
    
                        /**
                         * Constructs a new AggregateLevel2.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an AggregateLevel2.
                         * @implements IAggregateLevel2
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateLevel2=} [properties] Properties to set
                         */
                        function AggregateLevel2(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AggregateLevel2 storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @instance
                         */
                        AggregateLevel2.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AggregateLevel2 dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @instance
                         */
                        AggregateLevel2.prototype.dateId = "";
    
                        /**
                         * Creates a new AggregateLevel2 instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateLevel2=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateLevel2} AggregateLevel2 instance
                         */
                        AggregateLevel2.create = function create(properties) {
                            return new AggregateLevel2(properties);
                        };
    
                        /**
                         * Encodes the specified AggregateLevel2 message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateLevel2.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateLevel2} message AggregateLevel2 message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateLevel2.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AggregateLevel2 message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateLevel2.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateLevel2} message AggregateLevel2 message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateLevel2.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AggregateLevel2 message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateLevel2} AggregateLevel2
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateLevel2.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.AggregateLevel2();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AggregateLevel2 message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateLevel2} AggregateLevel2
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateLevel2.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AggregateLevel2 message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AggregateLevel2.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an AggregateLevel2 message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateLevel2} AggregateLevel2
                         */
                        AggregateLevel2.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.AggregateLevel2)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.AggregateLevel2();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AggregateLevel2 message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.AggregateLevel2} message AggregateLevel2
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AggregateLevel2.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this AggregateLevel2 to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateLevel2
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AggregateLevel2.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AggregateLevel2;
                    })();
    
                    AsyncJob.CalculateConsistency = (function() {
    
                        /**
                         * Properties of a CalculateConsistency.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface ICalculateConsistency
                         * @property {number|null} [storeId] CalculateConsistency storeId
                         * @property {string|null} [dateId] CalculateConsistency dateId
                         */
    
                        /**
                         * Constructs a new CalculateConsistency.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a CalculateConsistency.
                         * @implements ICalculateConsistency
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.ICalculateConsistency=} [properties] Properties to set
                         */
                        function CalculateConsistency(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CalculateConsistency storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @instance
                         */
                        CalculateConsistency.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * CalculateConsistency dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @instance
                         */
                        CalculateConsistency.prototype.dateId = "";
    
                        /**
                         * Creates a new CalculateConsistency instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ICalculateConsistency=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.CalculateConsistency} CalculateConsistency instance
                         */
                        CalculateConsistency.create = function create(properties) {
                            return new CalculateConsistency(properties);
                        };
    
                        /**
                         * Encodes the specified CalculateConsistency message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.CalculateConsistency.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ICalculateConsistency} message CalculateConsistency message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CalculateConsistency.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CalculateConsistency message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.CalculateConsistency.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ICalculateConsistency} message CalculateConsistency message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CalculateConsistency.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CalculateConsistency message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.CalculateConsistency} CalculateConsistency
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CalculateConsistency.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.CalculateConsistency();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CalculateConsistency message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.CalculateConsistency} CalculateConsistency
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CalculateConsistency.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CalculateConsistency message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CalculateConsistency.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a CalculateConsistency message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.CalculateConsistency} CalculateConsistency
                         */
                        CalculateConsistency.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.CalculateConsistency)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.CalculateConsistency();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CalculateConsistency message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.CalculateConsistency} message CalculateConsistency
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CalculateConsistency.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this CalculateConsistency to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.CalculateConsistency
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CalculateConsistency.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return CalculateConsistency;
                    })();
    
                    AsyncJob.ScheduleTask = (function() {
    
                        /**
                         * Properties of a ScheduleTask.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IScheduleTask
                         * @property {palexy.streaming.v1.AsyncJob.Type|null} [scheduleTaskType] ScheduleTask scheduleTaskType
                         * @property {string|null} [cronExpression] ScheduleTask cronExpression
                         * @property {string|null} [timezone] ScheduleTask timezone
                         * @property {number|null} [lastRecurringTimeMs] ScheduleTask lastRecurringTimeMs
                         * @property {number|null} [nextRecurringTimeMs] ScheduleTask nextRecurringTimeMs
                         * @property {Object.<string,string>|null} [additionalProperties] ScheduleTask additionalProperties
                         */
    
                        /**
                         * Constructs a new ScheduleTask.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a ScheduleTask.
                         * @implements IScheduleTask
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IScheduleTask=} [properties] Properties to set
                         */
                        function ScheduleTask(properties) {
                            this.additionalProperties = {};
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ScheduleTask scheduleTaskType.
                         * @member {palexy.streaming.v1.AsyncJob.Type} scheduleTaskType
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.scheduleTaskType = 0;
    
                        /**
                         * ScheduleTask cronExpression.
                         * @member {string} cronExpression
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.cronExpression = "";
    
                        /**
                         * ScheduleTask timezone.
                         * @member {string} timezone
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.timezone = "";
    
                        /**
                         * ScheduleTask lastRecurringTimeMs.
                         * @member {number} lastRecurringTimeMs
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.lastRecurringTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * ScheduleTask nextRecurringTimeMs.
                         * @member {number} nextRecurringTimeMs
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.nextRecurringTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * ScheduleTask additionalProperties.
                         * @member {Object.<string,string>} additionalProperties
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         */
                        ScheduleTask.prototype.additionalProperties = $util.emptyObject;
    
                        /**
                         * Creates a new ScheduleTask instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IScheduleTask=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.ScheduleTask} ScheduleTask instance
                         */
                        ScheduleTask.create = function create(properties) {
                            return new ScheduleTask(properties);
                        };
    
                        /**
                         * Encodes the specified ScheduleTask message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ScheduleTask.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IScheduleTask} message ScheduleTask message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ScheduleTask.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.scheduleTaskType != null && Object.hasOwnProperty.call(message, "scheduleTaskType"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scheduleTaskType);
                            if (message.cronExpression != null && Object.hasOwnProperty.call(message, "cronExpression"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.cronExpression);
                            if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.timezone);
                            if (message.lastRecurringTimeMs != null && Object.hasOwnProperty.call(message, "lastRecurringTimeMs"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastRecurringTimeMs);
                            if (message.nextRecurringTimeMs != null && Object.hasOwnProperty.call(message, "nextRecurringTimeMs"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int64(message.nextRecurringTimeMs);
                            if (message.additionalProperties != null && Object.hasOwnProperty.call(message, "additionalProperties"))
                                for (var keys = Object.keys(message.additionalProperties), i = 0; i < keys.length; ++i)
                                    writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalProperties[keys[i]]).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ScheduleTask message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ScheduleTask.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IScheduleTask} message ScheduleTask message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ScheduleTask.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ScheduleTask message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.ScheduleTask} ScheduleTask
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ScheduleTask.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.ScheduleTask(), key, value;
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.scheduleTaskType = reader.int32();
                                    break;
                                case 2:
                                    message.cronExpression = reader.string();
                                    break;
                                case 3:
                                    message.timezone = reader.string();
                                    break;
                                case 4:
                                    message.lastRecurringTimeMs = reader.int64();
                                    break;
                                case 5:
                                    message.nextRecurringTimeMs = reader.int64();
                                    break;
                                case 6:
                                    if (message.additionalProperties === $util.emptyObject)
                                        message.additionalProperties = {};
                                    var end2 = reader.uint32() + reader.pos;
                                    key = "";
                                    value = "";
                                    while (reader.pos < end2) {
                                        var tag2 = reader.uint32();
                                        switch (tag2 >>> 3) {
                                        case 1:
                                            key = reader.string();
                                            break;
                                        case 2:
                                            value = reader.string();
                                            break;
                                        default:
                                            reader.skipType(tag2 & 7);
                                            break;
                                        }
                                    }
                                    message.additionalProperties[key] = value;
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ScheduleTask message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.ScheduleTask} ScheduleTask
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ScheduleTask.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ScheduleTask message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ScheduleTask.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                                switch (message.scheduleTaskType) {
                                default:
                                    return "scheduleTaskType: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                    break;
                                }
                            if (message.cronExpression != null && message.hasOwnProperty("cronExpression"))
                                if (!$util.isString(message.cronExpression))
                                    return "cronExpression: string expected";
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                if (!$util.isString(message.timezone))
                                    return "timezone: string expected";
                            if (message.lastRecurringTimeMs != null && message.hasOwnProperty("lastRecurringTimeMs"))
                                if (!$util.isInteger(message.lastRecurringTimeMs) && !(message.lastRecurringTimeMs && $util.isInteger(message.lastRecurringTimeMs.low) && $util.isInteger(message.lastRecurringTimeMs.high)))
                                    return "lastRecurringTimeMs: integer|Long expected";
                            if (message.nextRecurringTimeMs != null && message.hasOwnProperty("nextRecurringTimeMs"))
                                if (!$util.isInteger(message.nextRecurringTimeMs) && !(message.nextRecurringTimeMs && $util.isInteger(message.nextRecurringTimeMs.low) && $util.isInteger(message.nextRecurringTimeMs.high)))
                                    return "nextRecurringTimeMs: integer|Long expected";
                            if (message.additionalProperties != null && message.hasOwnProperty("additionalProperties")) {
                                if (!$util.isObject(message.additionalProperties))
                                    return "additionalProperties: object expected";
                                var key = Object.keys(message.additionalProperties);
                                for (var i = 0; i < key.length; ++i)
                                    if (!$util.isString(message.additionalProperties[key[i]]))
                                        return "additionalProperties: string{k:string} expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a ScheduleTask message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.ScheduleTask} ScheduleTask
                         */
                        ScheduleTask.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.ScheduleTask)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.ScheduleTask();
                            switch (object.scheduleTaskType) {
                            case "UNKNOWN":
                            case 0:
                                message.scheduleTaskType = 0;
                                break;
                            case "EXPORT":
                            case 1:
                                message.scheduleTaskType = 1;
                                break;
                            case "POS_MATCHING":
                            case 2:
                                message.scheduleTaskType = 2;
                                break;
                            case "POS_IMPORT":
                            case 3:
                                message.scheduleTaskType = 3;
                                break;
                            case "AGGREGATE":
                            case 4:
                                message.scheduleTaskType = 4;
                                break;
                            case "AGGREGATE_LEVEL_2":
                            case 5:
                                message.scheduleTaskType = 5;
                                break;
                            case "CALCULATE_CONSISTENCY":
                            case 6:
                                message.scheduleTaskType = 6;
                                break;
                            case "SCHEDULE_TASK":
                            case 7:
                                message.scheduleTaskType = 7;
                                break;
                            case "STAFF_DATA_IMPORT":
                            case 8:
                                message.scheduleTaskType = 8;
                                break;
                            case "EXPORT_REPORT":
                            case 9:
                                message.scheduleTaskType = 9;
                                break;
                            case "UPDATE_WEATHER_DATA":
                            case 10:
                                message.scheduleTaskType = 10;
                                break;
                            case "GENERATE_INSIGHT":
                            case 11:
                                message.scheduleTaskType = 11;
                                break;
                            case "SEND_REPORT_SCHEDULE":
                            case 12:
                                message.scheduleTaskType = 12;
                                break;
                            case "EXTERNAL_TRAFFIC_IMPORT":
                            case 13:
                                message.scheduleTaskType = 13;
                                break;
                            case "GENERATE_TREND_REPORT":
                            case 14:
                                message.scheduleTaskType = 14;
                                break;
                            case "AGGREGATE_STAFF_SCHEDULE":
                            case 15:
                                message.scheduleTaskType = 15;
                                break;
                            case "RERUN_MERGING":
                            case 16:
                                message.scheduleTaskType = 16;
                                break;
                            case "ADJUST_SCHEDULE_BUDGET":
                            case 17:
                                message.scheduleTaskType = 17;
                                break;
                            case "GOAL_GENERATE_TARGET":
                            case 18:
                                message.scheduleTaskType = 18;
                                break;
                            case "GOAL_EVALUATE_PERFORMANCE":
                            case 19:
                                message.scheduleTaskType = 19;
                                break;
                            case "SYNC_MATCHING_GROUP_MEMBER":
                            case 20:
                                message.scheduleTaskType = 20;
                                break;
                            case "EVALUATE_FORM_CUSTOM_ACTION":
                            case 21:
                                message.scheduleTaskType = 21;
                                break;
                            case "AGGREGATE_ATTENDANCE":
                            case 22:
                                message.scheduleTaskType = 22;
                                break;
                            case "SYNC_REVIEWS":
                            case 23:
                                message.scheduleTaskType = 23;
                                break;
                            case "AGGREGATE_REPUTATION":
                            case 24:
                                message.scheduleTaskType = 24;
                                break;
                            }
                            if (object.cronExpression != null)
                                message.cronExpression = String(object.cronExpression);
                            if (object.timezone != null)
                                message.timezone = String(object.timezone);
                            if (object.lastRecurringTimeMs != null)
                                if ($util.Long)
                                    (message.lastRecurringTimeMs = $util.Long.fromValue(object.lastRecurringTimeMs)).unsigned = false;
                                else if (typeof object.lastRecurringTimeMs === "string")
                                    message.lastRecurringTimeMs = parseInt(object.lastRecurringTimeMs, 10);
                                else if (typeof object.lastRecurringTimeMs === "number")
                                    message.lastRecurringTimeMs = object.lastRecurringTimeMs;
                                else if (typeof object.lastRecurringTimeMs === "object")
                                    message.lastRecurringTimeMs = new $util.LongBits(object.lastRecurringTimeMs.low >>> 0, object.lastRecurringTimeMs.high >>> 0).toNumber();
                            if (object.nextRecurringTimeMs != null)
                                if ($util.Long)
                                    (message.nextRecurringTimeMs = $util.Long.fromValue(object.nextRecurringTimeMs)).unsigned = false;
                                else if (typeof object.nextRecurringTimeMs === "string")
                                    message.nextRecurringTimeMs = parseInt(object.nextRecurringTimeMs, 10);
                                else if (typeof object.nextRecurringTimeMs === "number")
                                    message.nextRecurringTimeMs = object.nextRecurringTimeMs;
                                else if (typeof object.nextRecurringTimeMs === "object")
                                    message.nextRecurringTimeMs = new $util.LongBits(object.nextRecurringTimeMs.low >>> 0, object.nextRecurringTimeMs.high >>> 0).toNumber();
                            if (object.additionalProperties) {
                                if (typeof object.additionalProperties !== "object")
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.ScheduleTask.additionalProperties: object expected");
                                message.additionalProperties = {};
                                for (var keys = Object.keys(object.additionalProperties), i = 0; i < keys.length; ++i)
                                    message.additionalProperties[keys[i]] = String(object.additionalProperties[keys[i]]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ScheduleTask message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ScheduleTask} message ScheduleTask
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ScheduleTask.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.objects || options.defaults)
                                object.additionalProperties = {};
                            if (options.defaults) {
                                object.scheduleTaskType = options.enums === String ? "UNKNOWN" : 0;
                                object.cronExpression = "";
                                object.timezone = "";
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.lastRecurringTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.lastRecurringTimeMs = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.nextRecurringTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.nextRecurringTimeMs = options.longs === String ? "0" : 0;
                            }
                            if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                                object.scheduleTaskType = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Type[message.scheduleTaskType] : message.scheduleTaskType;
                            if (message.cronExpression != null && message.hasOwnProperty("cronExpression"))
                                object.cronExpression = message.cronExpression;
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                object.timezone = message.timezone;
                            if (message.lastRecurringTimeMs != null && message.hasOwnProperty("lastRecurringTimeMs"))
                                if (typeof message.lastRecurringTimeMs === "number")
                                    object.lastRecurringTimeMs = options.longs === String ? String(message.lastRecurringTimeMs) : message.lastRecurringTimeMs;
                                else
                                    object.lastRecurringTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastRecurringTimeMs) : options.longs === Number ? new $util.LongBits(message.lastRecurringTimeMs.low >>> 0, message.lastRecurringTimeMs.high >>> 0).toNumber() : message.lastRecurringTimeMs;
                            if (message.nextRecurringTimeMs != null && message.hasOwnProperty("nextRecurringTimeMs"))
                                if (typeof message.nextRecurringTimeMs === "number")
                                    object.nextRecurringTimeMs = options.longs === String ? String(message.nextRecurringTimeMs) : message.nextRecurringTimeMs;
                                else
                                    object.nextRecurringTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.nextRecurringTimeMs) : options.longs === Number ? new $util.LongBits(message.nextRecurringTimeMs.low >>> 0, message.nextRecurringTimeMs.high >>> 0).toNumber() : message.nextRecurringTimeMs;
                            var keys2;
                            if (message.additionalProperties && (keys2 = Object.keys(message.additionalProperties)).length) {
                                object.additionalProperties = {};
                                for (var j = 0; j < keys2.length; ++j)
                                    object.additionalProperties[keys2[j]] = message.additionalProperties[keys2[j]];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this ScheduleTask to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.ScheduleTask
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ScheduleTask.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ScheduleTask;
                    })();
    
                    AsyncJob.StaffImport = (function() {
    
                        /**
                         * Properties of a StaffImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IStaffImport
                         * @property {string|null} [dateId] StaffImport dateId
                         */
    
                        /**
                         * Constructs a new StaffImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a StaffImport.
                         * @implements IStaffImport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IStaffImport=} [properties] Properties to set
                         */
                        function StaffImport(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * StaffImport dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @instance
                         */
                        StaffImport.prototype.dateId = "";
    
                        /**
                         * Creates a new StaffImport instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IStaffImport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.StaffImport} StaffImport instance
                         */
                        StaffImport.create = function create(properties) {
                            return new StaffImport(properties);
                        };
    
                        /**
                         * Encodes the specified StaffImport message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.StaffImport.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IStaffImport} message StaffImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StaffImport.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified StaffImport message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.StaffImport.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IStaffImport} message StaffImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StaffImport.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a StaffImport message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.StaffImport} StaffImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StaffImport.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.StaffImport();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a StaffImport message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.StaffImport} StaffImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StaffImport.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a StaffImport message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        StaffImport.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a StaffImport message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.StaffImport} StaffImport
                         */
                        StaffImport.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.StaffImport)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.StaffImport();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a StaffImport message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.StaffImport} message StaffImport
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        StaffImport.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.dateId = "";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this StaffImport to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.StaffImport
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        StaffImport.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return StaffImport;
                    })();
    
                    AsyncJob.ExportReport = (function() {
    
                        /**
                         * Properties of an ExportReport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IExportReport
                         * @property {string|null} [dateId] ExportReport dateId
                         */
    
                        /**
                         * Constructs a new ExportReport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an ExportReport.
                         * @implements IExportReport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IExportReport=} [properties] Properties to set
                         */
                        function ExportReport(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ExportReport dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @instance
                         */
                        ExportReport.prototype.dateId = "";
    
                        /**
                         * Creates a new ExportReport instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExportReport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.ExportReport} ExportReport instance
                         */
                        ExportReport.create = function create(properties) {
                            return new ExportReport(properties);
                        };
    
                        /**
                         * Encodes the specified ExportReport message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ExportReport.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExportReport} message ExportReport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExportReport.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ExportReport message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ExportReport.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExportReport} message ExportReport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExportReport.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an ExportReport message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.ExportReport} ExportReport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExportReport.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.ExportReport();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an ExportReport message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.ExportReport} ExportReport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExportReport.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an ExportReport message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ExportReport.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an ExportReport message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.ExportReport} ExportReport
                         */
                        ExportReport.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.ExportReport)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.ExportReport();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an ExportReport message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ExportReport} message ExportReport
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ExportReport.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.dateId = "";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this ExportReport to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.ExportReport
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ExportReport.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ExportReport;
                    })();
    
                    AsyncJob.UpdateWeatherData = (function() {
    
                        /**
                         * Properties of an UpdateWeatherData.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IUpdateWeatherData
                         * @property {number|null} [storeId] UpdateWeatherData storeId
                         * @property {string|null} [startDateId] UpdateWeatherData startDateId
                         * @property {string|null} [endDateId] UpdateWeatherData endDateId
                         */
    
                        /**
                         * Constructs a new UpdateWeatherData.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an UpdateWeatherData.
                         * @implements IUpdateWeatherData
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IUpdateWeatherData=} [properties] Properties to set
                         */
                        function UpdateWeatherData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * UpdateWeatherData storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @instance
                         */
                        UpdateWeatherData.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * UpdateWeatherData startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @instance
                         */
                        UpdateWeatherData.prototype.startDateId = "";
    
                        /**
                         * UpdateWeatherData endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @instance
                         */
                        UpdateWeatherData.prototype.endDateId = "";
    
                        /**
                         * Creates a new UpdateWeatherData instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IUpdateWeatherData=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.UpdateWeatherData} UpdateWeatherData instance
                         */
                        UpdateWeatherData.create = function create(properties) {
                            return new UpdateWeatherData(properties);
                        };
    
                        /**
                         * Encodes the specified UpdateWeatherData message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.UpdateWeatherData.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IUpdateWeatherData} message UpdateWeatherData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateWeatherData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified UpdateWeatherData message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.UpdateWeatherData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IUpdateWeatherData} message UpdateWeatherData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        UpdateWeatherData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an UpdateWeatherData message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.UpdateWeatherData} UpdateWeatherData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateWeatherData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateId = reader.string();
                                    break;
                                case 3:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an UpdateWeatherData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.UpdateWeatherData} UpdateWeatherData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        UpdateWeatherData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an UpdateWeatherData message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        UpdateWeatherData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an UpdateWeatherData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.UpdateWeatherData} UpdateWeatherData
                         */
                        UpdateWeatherData.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.UpdateWeatherData();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an UpdateWeatherData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.UpdateWeatherData} message UpdateWeatherData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        UpdateWeatherData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this UpdateWeatherData to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.UpdateWeatherData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        UpdateWeatherData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return UpdateWeatherData;
                    })();
    
                    AsyncJob.SendReportSchedule = (function() {
    
                        /**
                         * Properties of a SendReportSchedule.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface ISendReportSchedule
                         * @property {string|null} [email] SendReportSchedule email
                         * @property {number|null} [scheduleId] SendReportSchedule scheduleId
                         * @property {palexy.streaming.v1.IDateRange|null} [dateRange] SendReportSchedule dateRange
                         */
    
                        /**
                         * Constructs a new SendReportSchedule.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a SendReportSchedule.
                         * @implements ISendReportSchedule
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.ISendReportSchedule=} [properties] Properties to set
                         */
                        function SendReportSchedule(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SendReportSchedule email.
                         * @member {string} email
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @instance
                         */
                        SendReportSchedule.prototype.email = "";
    
                        /**
                         * SendReportSchedule scheduleId.
                         * @member {number} scheduleId
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @instance
                         */
                        SendReportSchedule.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * SendReportSchedule dateRange.
                         * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @instance
                         */
                        SendReportSchedule.prototype.dateRange = null;
    
                        /**
                         * Creates a new SendReportSchedule instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISendReportSchedule=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.SendReportSchedule} SendReportSchedule instance
                         */
                        SendReportSchedule.create = function create(properties) {
                            return new SendReportSchedule(properties);
                        };
    
                        /**
                         * Encodes the specified SendReportSchedule message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SendReportSchedule.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISendReportSchedule} message SendReportSchedule message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SendReportSchedule.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.email);
                            if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.scheduleId);
                            if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                                $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SendReportSchedule message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SendReportSchedule.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISendReportSchedule} message SendReportSchedule message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SendReportSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SendReportSchedule message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.SendReportSchedule} SendReportSchedule
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SendReportSchedule.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.SendReportSchedule();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.email = reader.string();
                                    break;
                                case 2:
                                    message.scheduleId = reader.int64();
                                    break;
                                case 3:
                                    message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SendReportSchedule message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.SendReportSchedule} SendReportSchedule
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SendReportSchedule.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SendReportSchedule message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SendReportSchedule.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.email != null && message.hasOwnProperty("email"))
                                if (!$util.isString(message.email))
                                    return "email: string expected";
                            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                                if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                    return "scheduleId: integer|Long expected";
                            if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                                var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                                if (error)
                                    return "dateRange." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a SendReportSchedule message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.SendReportSchedule} SendReportSchedule
                         */
                        SendReportSchedule.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.SendReportSchedule)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.SendReportSchedule();
                            if (object.email != null)
                                message.email = String(object.email);
                            if (object.scheduleId != null)
                                if ($util.Long)
                                    (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                                else if (typeof object.scheduleId === "string")
                                    message.scheduleId = parseInt(object.scheduleId, 10);
                                else if (typeof object.scheduleId === "number")
                                    message.scheduleId = object.scheduleId;
                                else if (typeof object.scheduleId === "object")
                                    message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                            if (object.dateRange != null) {
                                if (typeof object.dateRange !== "object")
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.SendReportSchedule.dateRange: object expected");
                                message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SendReportSchedule message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.SendReportSchedule} message SendReportSchedule
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SendReportSchedule.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.email = "";
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.scheduleId = options.longs === String ? "0" : 0;
                                object.dateRange = null;
                            }
                            if (message.email != null && message.hasOwnProperty("email"))
                                object.email = message.email;
                            if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                                if (typeof message.scheduleId === "number")
                                    object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                                else
                                    object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                            if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                                object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                            return object;
                        };
    
                        /**
                         * Converts this SendReportSchedule to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.SendReportSchedule
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SendReportSchedule.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SendReportSchedule;
                    })();
    
                    AsyncJob.GenerateInsight = (function() {
    
                        /**
                         * Properties of a GenerateInsight.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IGenerateInsight
                         * @property {Array.<number>|null} [storeIds] GenerateInsight storeIds
                         * @property {string|null} [insightType] GenerateInsight insightType
                         * @property {string|null} [startDateId] GenerateInsight startDateId
                         * @property {string|null} [endDateId] GenerateInsight endDateId
                         */
    
                        /**
                         * Constructs a new GenerateInsight.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a GenerateInsight.
                         * @implements IGenerateInsight
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateInsight=} [properties] Properties to set
                         */
                        function GenerateInsight(properties) {
                            this.storeIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GenerateInsight storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @instance
                         */
                        GenerateInsight.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * GenerateInsight insightType.
                         * @member {string} insightType
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @instance
                         */
                        GenerateInsight.prototype.insightType = "";
    
                        /**
                         * GenerateInsight startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @instance
                         */
                        GenerateInsight.prototype.startDateId = "";
    
                        /**
                         * GenerateInsight endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @instance
                         */
                        GenerateInsight.prototype.endDateId = "";
    
                        /**
                         * Creates a new GenerateInsight instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateInsight=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateInsight} GenerateInsight instance
                         */
                        GenerateInsight.create = function create(properties) {
                            return new GenerateInsight(properties);
                        };
    
                        /**
                         * Encodes the specified GenerateInsight message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateInsight.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateInsight} message GenerateInsight message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateInsight.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.insightType != null && Object.hasOwnProperty.call(message, "insightType"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.insightType);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GenerateInsight message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateInsight.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateInsight} message GenerateInsight message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateInsight.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GenerateInsight message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateInsight} GenerateInsight
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateInsight.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.GenerateInsight();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 2:
                                    message.insightType = reader.string();
                                    break;
                                case 3:
                                    message.startDateId = reader.string();
                                    break;
                                case 4:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GenerateInsight message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateInsight} GenerateInsight
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateInsight.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GenerateInsight message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GenerateInsight.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.insightType != null && message.hasOwnProperty("insightType"))
                                if (!$util.isString(message.insightType))
                                    return "insightType: string expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GenerateInsight message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateInsight} GenerateInsight
                         */
                        GenerateInsight.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.GenerateInsight)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.GenerateInsight();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.GenerateInsight.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.insightType != null)
                                message.insightType = String(object.insightType);
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GenerateInsight message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.GenerateInsight} message GenerateInsight
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GenerateInsight.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.storeIds = [];
                            if (options.defaults) {
                                object.insightType = "";
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.insightType != null && message.hasOwnProperty("insightType"))
                                object.insightType = message.insightType;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this GenerateInsight to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateInsight
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GenerateInsight.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GenerateInsight;
                    })();
    
                    AsyncJob.ExternalTrafficImport = (function() {
    
                        /**
                         * Properties of an ExternalTrafficImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IExternalTrafficImport
                         * @property {Array.<number>|null} [storeIds] ExternalTrafficImport storeIds
                         * @property {string|null} [dateId] ExternalTrafficImport dateId
                         */
    
                        /**
                         * Constructs a new ExternalTrafficImport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an ExternalTrafficImport.
                         * @implements IExternalTrafficImport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IExternalTrafficImport=} [properties] Properties to set
                         */
                        function ExternalTrafficImport(properties) {
                            this.storeIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ExternalTrafficImport storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @instance
                         */
                        ExternalTrafficImport.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * ExternalTrafficImport dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @instance
                         */
                        ExternalTrafficImport.prototype.dateId = "";
    
                        /**
                         * Creates a new ExternalTrafficImport instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExternalTrafficImport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.ExternalTrafficImport} ExternalTrafficImport instance
                         */
                        ExternalTrafficImport.create = function create(properties) {
                            return new ExternalTrafficImport(properties);
                        };
    
                        /**
                         * Encodes the specified ExternalTrafficImport message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ExternalTrafficImport.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExternalTrafficImport} message ExternalTrafficImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExternalTrafficImport.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ExternalTrafficImport message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.ExternalTrafficImport.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IExternalTrafficImport} message ExternalTrafficImport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExternalTrafficImport.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an ExternalTrafficImport message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.ExternalTrafficImport} ExternalTrafficImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExternalTrafficImport.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an ExternalTrafficImport message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.ExternalTrafficImport} ExternalTrafficImport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExternalTrafficImport.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an ExternalTrafficImport message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ExternalTrafficImport.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an ExternalTrafficImport message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.ExternalTrafficImport} ExternalTrafficImport
                         */
                        ExternalTrafficImport.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.ExternalTrafficImport();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.ExternalTrafficImport.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an ExternalTrafficImport message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ExternalTrafficImport} message ExternalTrafficImport
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ExternalTrafficImport.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.storeIds = [];
                            if (options.defaults)
                                object.dateId = "";
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this ExternalTrafficImport to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.ExternalTrafficImport
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ExternalTrafficImport.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ExternalTrafficImport;
                    })();
    
                    AsyncJob.GenerateTrendReport = (function() {
    
                        /**
                         * Properties of a GenerateTrendReport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IGenerateTrendReport
                         * @property {string|null} [reportType] GenerateTrendReport reportType
                         * @property {number|null} [storeSetId] GenerateTrendReport storeSetId
                         * @property {string|null} [startDateId] GenerateTrendReport startDateId
                         * @property {string|null} [endDateId] GenerateTrendReport endDateId
                         * @property {string|null} [countryCode] GenerateTrendReport countryCode
                         */
    
                        /**
                         * Constructs a new GenerateTrendReport.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a GenerateTrendReport.
                         * @implements IGenerateTrendReport
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateTrendReport=} [properties] Properties to set
                         */
                        function GenerateTrendReport(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GenerateTrendReport reportType.
                         * @member {string} reportType
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         */
                        GenerateTrendReport.prototype.reportType = "";
    
                        /**
                         * GenerateTrendReport storeSetId.
                         * @member {number} storeSetId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         */
                        GenerateTrendReport.prototype.storeSetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * GenerateTrendReport startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         */
                        GenerateTrendReport.prototype.startDateId = "";
    
                        /**
                         * GenerateTrendReport endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         */
                        GenerateTrendReport.prototype.endDateId = "";
    
                        /**
                         * GenerateTrendReport countryCode.
                         * @member {string} countryCode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         */
                        GenerateTrendReport.prototype.countryCode = "";
    
                        /**
                         * Creates a new GenerateTrendReport instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateTrendReport=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateTrendReport} GenerateTrendReport instance
                         */
                        GenerateTrendReport.create = function create(properties) {
                            return new GenerateTrendReport(properties);
                        };
    
                        /**
                         * Encodes the specified GenerateTrendReport message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateTrendReport.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateTrendReport} message GenerateTrendReport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateTrendReport.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.reportType != null && Object.hasOwnProperty.call(message, "reportType"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.reportType);
                            if (message.storeSetId != null && Object.hasOwnProperty.call(message, "storeSetId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeSetId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateId);
                            if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.countryCode);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GenerateTrendReport message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateTrendReport.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateTrendReport} message GenerateTrendReport message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateTrendReport.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GenerateTrendReport message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateTrendReport} GenerateTrendReport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateTrendReport.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.reportType = reader.string();
                                    break;
                                case 2:
                                    message.storeSetId = reader.int64();
                                    break;
                                case 3:
                                    message.startDateId = reader.string();
                                    break;
                                case 4:
                                    message.endDateId = reader.string();
                                    break;
                                case 5:
                                    message.countryCode = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GenerateTrendReport message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateTrendReport} GenerateTrendReport
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateTrendReport.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GenerateTrendReport message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GenerateTrendReport.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.reportType != null && message.hasOwnProperty("reportType"))
                                if (!$util.isString(message.reportType))
                                    return "reportType: string expected";
                            if (message.storeSetId != null && message.hasOwnProperty("storeSetId"))
                                if (!$util.isInteger(message.storeSetId) && !(message.storeSetId && $util.isInteger(message.storeSetId.low) && $util.isInteger(message.storeSetId.high)))
                                    return "storeSetId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                                if (!$util.isString(message.countryCode))
                                    return "countryCode: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GenerateTrendReport message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateTrendReport} GenerateTrendReport
                         */
                        GenerateTrendReport.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.GenerateTrendReport();
                            if (object.reportType != null)
                                message.reportType = String(object.reportType);
                            if (object.storeSetId != null)
                                if ($util.Long)
                                    (message.storeSetId = $util.Long.fromValue(object.storeSetId)).unsigned = false;
                                else if (typeof object.storeSetId === "string")
                                    message.storeSetId = parseInt(object.storeSetId, 10);
                                else if (typeof object.storeSetId === "number")
                                    message.storeSetId = object.storeSetId;
                                else if (typeof object.storeSetId === "object")
                                    message.storeSetId = new $util.LongBits(object.storeSetId.low >>> 0, object.storeSetId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            if (object.countryCode != null)
                                message.countryCode = String(object.countryCode);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GenerateTrendReport message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.GenerateTrendReport} message GenerateTrendReport
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GenerateTrendReport.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.reportType = "";
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeSetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeSetId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                                object.countryCode = "";
                            }
                            if (message.reportType != null && message.hasOwnProperty("reportType"))
                                object.reportType = message.reportType;
                            if (message.storeSetId != null && message.hasOwnProperty("storeSetId"))
                                if (typeof message.storeSetId === "number")
                                    object.storeSetId = options.longs === String ? String(message.storeSetId) : message.storeSetId;
                                else
                                    object.storeSetId = options.longs === String ? $util.Long.prototype.toString.call(message.storeSetId) : options.longs === Number ? new $util.LongBits(message.storeSetId.low >>> 0, message.storeSetId.high >>> 0).toNumber() : message.storeSetId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                                object.countryCode = message.countryCode;
                            return object;
                        };
    
                        /**
                         * Converts this GenerateTrendReport to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateTrendReport
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GenerateTrendReport.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GenerateTrendReport;
                    })();
    
                    AsyncJob.AggregateStaffSchedule = (function() {
    
                        /**
                         * Properties of an AggregateStaffSchedule.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAggregateStaffSchedule
                         * @property {number|null} [storeId] AggregateStaffSchedule storeId
                         * @property {string|null} [startDateId] AggregateStaffSchedule startDateId
                         * @property {string|null} [endDateId] AggregateStaffSchedule endDateId
                         */
    
                        /**
                         * Constructs a new AggregateStaffSchedule.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an AggregateStaffSchedule.
                         * @implements IAggregateStaffSchedule
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule=} [properties] Properties to set
                         */
                        function AggregateStaffSchedule(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AggregateStaffSchedule storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @instance
                         */
                        AggregateStaffSchedule.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AggregateStaffSchedule startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @instance
                         */
                        AggregateStaffSchedule.prototype.startDateId = "";
    
                        /**
                         * AggregateStaffSchedule endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @instance
                         */
                        AggregateStaffSchedule.prototype.endDateId = "";
    
                        /**
                         * Creates a new AggregateStaffSchedule instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateStaffSchedule} AggregateStaffSchedule instance
                         */
                        AggregateStaffSchedule.create = function create(properties) {
                            return new AggregateStaffSchedule(properties);
                        };
    
                        /**
                         * Encodes the specified AggregateStaffSchedule message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule} message AggregateStaffSchedule message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateStaffSchedule.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AggregateStaffSchedule message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateStaffSchedule.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateStaffSchedule} message AggregateStaffSchedule message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateStaffSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AggregateStaffSchedule message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateStaffSchedule} AggregateStaffSchedule
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateStaffSchedule.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateId = reader.string();
                                    break;
                                case 3:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AggregateStaffSchedule message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateStaffSchedule} AggregateStaffSchedule
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateStaffSchedule.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AggregateStaffSchedule message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AggregateStaffSchedule.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an AggregateStaffSchedule message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateStaffSchedule} AggregateStaffSchedule
                         */
                        AggregateStaffSchedule.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.AggregateStaffSchedule();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AggregateStaffSchedule message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.AggregateStaffSchedule} message AggregateStaffSchedule
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AggregateStaffSchedule.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this AggregateStaffSchedule to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateStaffSchedule
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AggregateStaffSchedule.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AggregateStaffSchedule;
                    })();
    
                    AsyncJob.AdjustScheduleBudget = (function() {
    
                        /**
                         * Properties of an AdjustScheduleBudget.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAdjustScheduleBudget
                         * @property {number|null} [storeId] AdjustScheduleBudget storeId
                         * @property {string|null} [startDateId] AdjustScheduleBudget startDateId
                         * @property {string|null} [endDateId] AdjustScheduleBudget endDateId
                         */
    
                        /**
                         * Constructs a new AdjustScheduleBudget.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an AdjustScheduleBudget.
                         * @implements IAdjustScheduleBudget
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget=} [properties] Properties to set
                         */
                        function AdjustScheduleBudget(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AdjustScheduleBudget storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @instance
                         */
                        AdjustScheduleBudget.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AdjustScheduleBudget startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @instance
                         */
                        AdjustScheduleBudget.prototype.startDateId = "";
    
                        /**
                         * AdjustScheduleBudget endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @instance
                         */
                        AdjustScheduleBudget.prototype.endDateId = "";
    
                        /**
                         * Creates a new AdjustScheduleBudget instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.AdjustScheduleBudget} AdjustScheduleBudget instance
                         */
                        AdjustScheduleBudget.create = function create(properties) {
                            return new AdjustScheduleBudget(properties);
                        };
    
                        /**
                         * Encodes the specified AdjustScheduleBudget message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget} message AdjustScheduleBudget message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AdjustScheduleBudget.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AdjustScheduleBudget message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AdjustScheduleBudget.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAdjustScheduleBudget} message AdjustScheduleBudget message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AdjustScheduleBudget.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AdjustScheduleBudget message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.AdjustScheduleBudget} AdjustScheduleBudget
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AdjustScheduleBudget.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateId = reader.string();
                                    break;
                                case 3:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AdjustScheduleBudget message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.AdjustScheduleBudget} AdjustScheduleBudget
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AdjustScheduleBudget.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AdjustScheduleBudget message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AdjustScheduleBudget.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an AdjustScheduleBudget message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.AdjustScheduleBudget} AdjustScheduleBudget
                         */
                        AdjustScheduleBudget.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.AdjustScheduleBudget();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AdjustScheduleBudget message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.AdjustScheduleBudget} message AdjustScheduleBudget
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AdjustScheduleBudget.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this AdjustScheduleBudget to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.AdjustScheduleBudget
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AdjustScheduleBudget.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AdjustScheduleBudget;
                    })();
    
                    AsyncJob.RerunMerging = (function() {
    
                        /**
                         * Properties of a RerunMerging.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IRerunMerging
                         * @property {number|null} [storeId] RerunMerging storeId
                         * @property {string|null} [dateId] RerunMerging dateId
                         */
    
                        /**
                         * Constructs a new RerunMerging.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a RerunMerging.
                         * @implements IRerunMerging
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IRerunMerging=} [properties] Properties to set
                         */
                        function RerunMerging(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * RerunMerging storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @instance
                         */
                        RerunMerging.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * RerunMerging dateId.
                         * @member {string} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @instance
                         */
                        RerunMerging.prototype.dateId = "";
    
                        /**
                         * Creates a new RerunMerging instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IRerunMerging=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.RerunMerging} RerunMerging instance
                         */
                        RerunMerging.create = function create(properties) {
                            return new RerunMerging(properties);
                        };
    
                        /**
                         * Encodes the specified RerunMerging message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.RerunMerging.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IRerunMerging} message RerunMerging message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        RerunMerging.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified RerunMerging message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.RerunMerging.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IRerunMerging} message RerunMerging message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        RerunMerging.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a RerunMerging message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.RerunMerging} RerunMerging
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        RerunMerging.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.RerunMerging();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a RerunMerging message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.RerunMerging} RerunMerging
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        RerunMerging.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a RerunMerging message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        RerunMerging.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isString(message.dateId))
                                    return "dateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a RerunMerging message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.RerunMerging} RerunMerging
                         */
                        RerunMerging.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.RerunMerging)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.RerunMerging();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = String(object.dateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a RerunMerging message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.RerunMerging} message RerunMerging
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        RerunMerging.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.dateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            return object;
                        };
    
                        /**
                         * Converts this RerunMerging to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.RerunMerging
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        RerunMerging.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return RerunMerging;
                    })();
    
                    AsyncJob.GenerateGoalTarget = (function() {
    
                        /**
                         * Properties of a GenerateGoalTarget.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IGenerateGoalTarget
                         * @property {number|null} [storeGoalId] GenerateGoalTarget storeGoalId
                         * @property {number|null} [targetDateId] GenerateGoalTarget targetDateId
                         * @property {string|null} [timezone] GenerateGoalTarget timezone
                         */
    
                        /**
                         * Constructs a new GenerateGoalTarget.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a GenerateGoalTarget.
                         * @implements IGenerateGoalTarget
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget=} [properties] Properties to set
                         */
                        function GenerateGoalTarget(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GenerateGoalTarget storeGoalId.
                         * @member {number} storeGoalId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @instance
                         */
                        GenerateGoalTarget.prototype.storeGoalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * GenerateGoalTarget targetDateId.
                         * @member {number} targetDateId
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @instance
                         */
                        GenerateGoalTarget.prototype.targetDateId = 0;
    
                        /**
                         * GenerateGoalTarget timezone.
                         * @member {string} timezone
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @instance
                         */
                        GenerateGoalTarget.prototype.timezone = "";
    
                        /**
                         * Creates a new GenerateGoalTarget instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateGoalTarget} GenerateGoalTarget instance
                         */
                        GenerateGoalTarget.create = function create(properties) {
                            return new GenerateGoalTarget(properties);
                        };
    
                        /**
                         * Encodes the specified GenerateGoalTarget message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateGoalTarget.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget} message GenerateGoalTarget message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateGoalTarget.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeGoalId != null && Object.hasOwnProperty.call(message, "storeGoalId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeGoalId);
                            if (message.targetDateId != null && Object.hasOwnProperty.call(message, "targetDateId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.targetDateId);
                            if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.timezone);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GenerateGoalTarget message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.GenerateGoalTarget.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IGenerateGoalTarget} message GenerateGoalTarget message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerateGoalTarget.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GenerateGoalTarget message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateGoalTarget} GenerateGoalTarget
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateGoalTarget.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeGoalId = reader.int64();
                                    break;
                                case 2:
                                    message.targetDateId = reader.int32();
                                    break;
                                case 3:
                                    message.timezone = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GenerateGoalTarget message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateGoalTarget} GenerateGoalTarget
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerateGoalTarget.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GenerateGoalTarget message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GenerateGoalTarget.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeGoalId != null && message.hasOwnProperty("storeGoalId"))
                                if (!$util.isInteger(message.storeGoalId) && !(message.storeGoalId && $util.isInteger(message.storeGoalId.low) && $util.isInteger(message.storeGoalId.high)))
                                    return "storeGoalId: integer|Long expected";
                            if (message.targetDateId != null && message.hasOwnProperty("targetDateId"))
                                if (!$util.isInteger(message.targetDateId))
                                    return "targetDateId: integer expected";
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                if (!$util.isString(message.timezone))
                                    return "timezone: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GenerateGoalTarget message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.GenerateGoalTarget} GenerateGoalTarget
                         */
                        GenerateGoalTarget.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.GenerateGoalTarget();
                            if (object.storeGoalId != null)
                                if ($util.Long)
                                    (message.storeGoalId = $util.Long.fromValue(object.storeGoalId)).unsigned = false;
                                else if (typeof object.storeGoalId === "string")
                                    message.storeGoalId = parseInt(object.storeGoalId, 10);
                                else if (typeof object.storeGoalId === "number")
                                    message.storeGoalId = object.storeGoalId;
                                else if (typeof object.storeGoalId === "object")
                                    message.storeGoalId = new $util.LongBits(object.storeGoalId.low >>> 0, object.storeGoalId.high >>> 0).toNumber();
                            if (object.targetDateId != null)
                                message.targetDateId = object.targetDateId | 0;
                            if (object.timezone != null)
                                message.timezone = String(object.timezone);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GenerateGoalTarget message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.GenerateGoalTarget} message GenerateGoalTarget
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GenerateGoalTarget.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeGoalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeGoalId = options.longs === String ? "0" : 0;
                                object.targetDateId = 0;
                                object.timezone = "";
                            }
                            if (message.storeGoalId != null && message.hasOwnProperty("storeGoalId"))
                                if (typeof message.storeGoalId === "number")
                                    object.storeGoalId = options.longs === String ? String(message.storeGoalId) : message.storeGoalId;
                                else
                                    object.storeGoalId = options.longs === String ? $util.Long.prototype.toString.call(message.storeGoalId) : options.longs === Number ? new $util.LongBits(message.storeGoalId.low >>> 0, message.storeGoalId.high >>> 0).toNumber() : message.storeGoalId;
                            if (message.targetDateId != null && message.hasOwnProperty("targetDateId"))
                                object.targetDateId = message.targetDateId;
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                object.timezone = message.timezone;
                            return object;
                        };
    
                        /**
                         * Converts this GenerateGoalTarget to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.GenerateGoalTarget
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GenerateGoalTarget.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GenerateGoalTarget;
                    })();
    
                    AsyncJob.EvaluateGoalPerformance = (function() {
    
                        /**
                         * Properties of an EvaluateGoalPerformance.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IEvaluateGoalPerformance
                         * @property {number|null} [storeGoalId] EvaluateGoalPerformance storeGoalId
                         * @property {number|null} [dateId] EvaluateGoalPerformance dateId
                         * @property {number|null} [storeId] EvaluateGoalPerformance storeId
                         * @property {number|null} [goalId] EvaluateGoalPerformance goalId
                         */
    
                        /**
                         * Constructs a new EvaluateGoalPerformance.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an EvaluateGoalPerformance.
                         * @implements IEvaluateGoalPerformance
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance=} [properties] Properties to set
                         */
                        function EvaluateGoalPerformance(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * EvaluateGoalPerformance storeGoalId.
                         * @member {number} storeGoalId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @instance
                         */
                        EvaluateGoalPerformance.prototype.storeGoalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * EvaluateGoalPerformance dateId.
                         * @member {number} dateId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @instance
                         */
                        EvaluateGoalPerformance.prototype.dateId = 0;
    
                        /**
                         * EvaluateGoalPerformance storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @instance
                         */
                        EvaluateGoalPerformance.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * EvaluateGoalPerformance goalId.
                         * @member {number} goalId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @instance
                         */
                        EvaluateGoalPerformance.prototype.goalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new EvaluateGoalPerformance instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance} EvaluateGoalPerformance instance
                         */
                        EvaluateGoalPerformance.create = function create(properties) {
                            return new EvaluateGoalPerformance(properties);
                        };
    
                        /**
                         * Encodes the specified EvaluateGoalPerformance message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance} message EvaluateGoalPerformance message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EvaluateGoalPerformance.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeGoalId != null && Object.hasOwnProperty.call(message, "storeGoalId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeGoalId);
                            if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                            if (message.goalId != null && Object.hasOwnProperty.call(message, "goalId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.goalId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified EvaluateGoalPerformance message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateGoalPerformance} message EvaluateGoalPerformance message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EvaluateGoalPerformance.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an EvaluateGoalPerformance message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance} EvaluateGoalPerformance
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EvaluateGoalPerformance.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeGoalId = reader.int64();
                                    break;
                                case 2:
                                    message.dateId = reader.int32();
                                    break;
                                case 3:
                                    message.storeId = reader.int64();
                                    break;
                                case 4:
                                    message.goalId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an EvaluateGoalPerformance message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance} EvaluateGoalPerformance
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EvaluateGoalPerformance.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an EvaluateGoalPerformance message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        EvaluateGoalPerformance.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeGoalId != null && message.hasOwnProperty("storeGoalId"))
                                if (!$util.isInteger(message.storeGoalId) && !(message.storeGoalId && $util.isInteger(message.storeGoalId.low) && $util.isInteger(message.storeGoalId.high)))
                                    return "storeGoalId: integer|Long expected";
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                if (!$util.isInteger(message.dateId))
                                    return "dateId: integer expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.goalId != null && message.hasOwnProperty("goalId"))
                                if (!$util.isInteger(message.goalId) && !(message.goalId && $util.isInteger(message.goalId.low) && $util.isInteger(message.goalId.high)))
                                    return "goalId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates an EvaluateGoalPerformance message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance} EvaluateGoalPerformance
                         */
                        EvaluateGoalPerformance.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance();
                            if (object.storeGoalId != null)
                                if ($util.Long)
                                    (message.storeGoalId = $util.Long.fromValue(object.storeGoalId)).unsigned = false;
                                else if (typeof object.storeGoalId === "string")
                                    message.storeGoalId = parseInt(object.storeGoalId, 10);
                                else if (typeof object.storeGoalId === "number")
                                    message.storeGoalId = object.storeGoalId;
                                else if (typeof object.storeGoalId === "object")
                                    message.storeGoalId = new $util.LongBits(object.storeGoalId.low >>> 0, object.storeGoalId.high >>> 0).toNumber();
                            if (object.dateId != null)
                                message.dateId = object.dateId | 0;
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.goalId != null)
                                if ($util.Long)
                                    (message.goalId = $util.Long.fromValue(object.goalId)).unsigned = false;
                                else if (typeof object.goalId === "string")
                                    message.goalId = parseInt(object.goalId, 10);
                                else if (typeof object.goalId === "number")
                                    message.goalId = object.goalId;
                                else if (typeof object.goalId === "object")
                                    message.goalId = new $util.LongBits(object.goalId.low >>> 0, object.goalId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an EvaluateGoalPerformance message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance} message EvaluateGoalPerformance
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        EvaluateGoalPerformance.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeGoalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeGoalId = options.longs === String ? "0" : 0;
                                object.dateId = 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.goalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.goalId = options.longs === String ? "0" : 0;
                            }
                            if (message.storeGoalId != null && message.hasOwnProperty("storeGoalId"))
                                if (typeof message.storeGoalId === "number")
                                    object.storeGoalId = options.longs === String ? String(message.storeGoalId) : message.storeGoalId;
                                else
                                    object.storeGoalId = options.longs === String ? $util.Long.prototype.toString.call(message.storeGoalId) : options.longs === Number ? new $util.LongBits(message.storeGoalId.low >>> 0, message.storeGoalId.high >>> 0).toNumber() : message.storeGoalId;
                            if (message.dateId != null && message.hasOwnProperty("dateId"))
                                object.dateId = message.dateId;
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.goalId != null && message.hasOwnProperty("goalId"))
                                if (typeof message.goalId === "number")
                                    object.goalId = options.longs === String ? String(message.goalId) : message.goalId;
                                else
                                    object.goalId = options.longs === String ? $util.Long.prototype.toString.call(message.goalId) : options.longs === Number ? new $util.LongBits(message.goalId.low >>> 0, message.goalId.high >>> 0).toNumber() : message.goalId;
                            return object;
                        };
    
                        /**
                         * Converts this EvaluateGoalPerformance to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateGoalPerformance
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        EvaluateGoalPerformance.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return EvaluateGoalPerformance;
                    })();
    
                    AsyncJob.EvaluateFormCustomAction = (function() {
    
                        /**
                         * Properties of an EvaluateFormCustomAction.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IEvaluateFormCustomAction
                         * @property {number|null} [submissionId] EvaluateFormCustomAction submissionId
                         * @property {number|null} [formId] EvaluateFormCustomAction formId
                         * @property {Array.<number>|null} [changedFormFieldIds] EvaluateFormCustomAction changedFormFieldIds
                         * @property {Array.<number>|null} [changedAttributeIds] EvaluateFormCustomAction changedAttributeIds
                         */
    
                        /**
                         * Constructs a new EvaluateFormCustomAction.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an EvaluateFormCustomAction.
                         * @implements IEvaluateFormCustomAction
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction=} [properties] Properties to set
                         */
                        function EvaluateFormCustomAction(properties) {
                            this.changedFormFieldIds = [];
                            this.changedAttributeIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * EvaluateFormCustomAction submissionId.
                         * @member {number} submissionId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @instance
                         */
                        EvaluateFormCustomAction.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * EvaluateFormCustomAction formId.
                         * @member {number} formId
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @instance
                         */
                        EvaluateFormCustomAction.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * EvaluateFormCustomAction changedFormFieldIds.
                         * @member {Array.<number>} changedFormFieldIds
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @instance
                         */
                        EvaluateFormCustomAction.prototype.changedFormFieldIds = $util.emptyArray;
    
                        /**
                         * EvaluateFormCustomAction changedAttributeIds.
                         * @member {Array.<number>} changedAttributeIds
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @instance
                         */
                        EvaluateFormCustomAction.prototype.changedAttributeIds = $util.emptyArray;
    
                        /**
                         * Creates a new EvaluateFormCustomAction instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction} EvaluateFormCustomAction instance
                         */
                        EvaluateFormCustomAction.create = function create(properties) {
                            return new EvaluateFormCustomAction(properties);
                        };
    
                        /**
                         * Encodes the specified EvaluateFormCustomAction message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction} message EvaluateFormCustomAction message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EvaluateFormCustomAction.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.submissionId);
                            if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                            if (message.changedFormFieldIds != null && message.changedFormFieldIds.length) {
                                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                                for (var i = 0; i < message.changedFormFieldIds.length; ++i)
                                    writer.int64(message.changedFormFieldIds[i]);
                                writer.ldelim();
                            }
                            if (message.changedAttributeIds != null && message.changedAttributeIds.length) {
                                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                                for (var i = 0; i < message.changedAttributeIds.length; ++i)
                                    writer.int64(message.changedAttributeIds[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified EvaluateFormCustomAction message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IEvaluateFormCustomAction} message EvaluateFormCustomAction message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EvaluateFormCustomAction.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an EvaluateFormCustomAction message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction} EvaluateFormCustomAction
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EvaluateFormCustomAction.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.submissionId = reader.int64();
                                    break;
                                case 2:
                                    message.formId = reader.int64();
                                    break;
                                case 3:
                                    if (!(message.changedFormFieldIds && message.changedFormFieldIds.length))
                                        message.changedFormFieldIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.changedFormFieldIds.push(reader.int64());
                                    } else
                                        message.changedFormFieldIds.push(reader.int64());
                                    break;
                                case 4:
                                    if (!(message.changedAttributeIds && message.changedAttributeIds.length))
                                        message.changedAttributeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.changedAttributeIds.push(reader.int64());
                                    } else
                                        message.changedAttributeIds.push(reader.int64());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an EvaluateFormCustomAction message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction} EvaluateFormCustomAction
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EvaluateFormCustomAction.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an EvaluateFormCustomAction message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        EvaluateFormCustomAction.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                                if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                    return "submissionId: integer|Long expected";
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                    return "formId: integer|Long expected";
                            if (message.changedFormFieldIds != null && message.hasOwnProperty("changedFormFieldIds")) {
                                if (!Array.isArray(message.changedFormFieldIds))
                                    return "changedFormFieldIds: array expected";
                                for (var i = 0; i < message.changedFormFieldIds.length; ++i)
                                    if (!$util.isInteger(message.changedFormFieldIds[i]) && !(message.changedFormFieldIds[i] && $util.isInteger(message.changedFormFieldIds[i].low) && $util.isInteger(message.changedFormFieldIds[i].high)))
                                        return "changedFormFieldIds: integer|Long[] expected";
                            }
                            if (message.changedAttributeIds != null && message.hasOwnProperty("changedAttributeIds")) {
                                if (!Array.isArray(message.changedAttributeIds))
                                    return "changedAttributeIds: array expected";
                                for (var i = 0; i < message.changedAttributeIds.length; ++i)
                                    if (!$util.isInteger(message.changedAttributeIds[i]) && !(message.changedAttributeIds[i] && $util.isInteger(message.changedAttributeIds[i].low) && $util.isInteger(message.changedAttributeIds[i].high)))
                                        return "changedAttributeIds: integer|Long[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates an EvaluateFormCustomAction message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction} EvaluateFormCustomAction
                         */
                        EvaluateFormCustomAction.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction();
                            if (object.submissionId != null)
                                if ($util.Long)
                                    (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                                else if (typeof object.submissionId === "string")
                                    message.submissionId = parseInt(object.submissionId, 10);
                                else if (typeof object.submissionId === "number")
                                    message.submissionId = object.submissionId;
                                else if (typeof object.submissionId === "object")
                                    message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                            if (object.formId != null)
                                if ($util.Long)
                                    (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                                else if (typeof object.formId === "string")
                                    message.formId = parseInt(object.formId, 10);
                                else if (typeof object.formId === "number")
                                    message.formId = object.formId;
                                else if (typeof object.formId === "object")
                                    message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                            if (object.changedFormFieldIds) {
                                if (!Array.isArray(object.changedFormFieldIds))
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.changedFormFieldIds: array expected");
                                message.changedFormFieldIds = [];
                                for (var i = 0; i < object.changedFormFieldIds.length; ++i)
                                    if ($util.Long)
                                        (message.changedFormFieldIds[i] = $util.Long.fromValue(object.changedFormFieldIds[i])).unsigned = false;
                                    else if (typeof object.changedFormFieldIds[i] === "string")
                                        message.changedFormFieldIds[i] = parseInt(object.changedFormFieldIds[i], 10);
                                    else if (typeof object.changedFormFieldIds[i] === "number")
                                        message.changedFormFieldIds[i] = object.changedFormFieldIds[i];
                                    else if (typeof object.changedFormFieldIds[i] === "object")
                                        message.changedFormFieldIds[i] = new $util.LongBits(object.changedFormFieldIds[i].low >>> 0, object.changedFormFieldIds[i].high >>> 0).toNumber();
                            }
                            if (object.changedAttributeIds) {
                                if (!Array.isArray(object.changedAttributeIds))
                                    throw TypeError(".palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction.changedAttributeIds: array expected");
                                message.changedAttributeIds = [];
                                for (var i = 0; i < object.changedAttributeIds.length; ++i)
                                    if ($util.Long)
                                        (message.changedAttributeIds[i] = $util.Long.fromValue(object.changedAttributeIds[i])).unsigned = false;
                                    else if (typeof object.changedAttributeIds[i] === "string")
                                        message.changedAttributeIds[i] = parseInt(object.changedAttributeIds[i], 10);
                                    else if (typeof object.changedAttributeIds[i] === "number")
                                        message.changedAttributeIds[i] = object.changedAttributeIds[i];
                                    else if (typeof object.changedAttributeIds[i] === "object")
                                        message.changedAttributeIds[i] = new $util.LongBits(object.changedAttributeIds[i].low >>> 0, object.changedAttributeIds[i].high >>> 0).toNumber();
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an EvaluateFormCustomAction message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction} message EvaluateFormCustomAction
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        EvaluateFormCustomAction.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.changedFormFieldIds = [];
                                object.changedAttributeIds = [];
                            }
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.submissionId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formId = options.longs === String ? "0" : 0;
                            }
                            if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                                if (typeof message.submissionId === "number")
                                    object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                                else
                                    object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (typeof message.formId === "number")
                                    object.formId = options.longs === String ? String(message.formId) : message.formId;
                                else
                                    object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                            if (message.changedFormFieldIds && message.changedFormFieldIds.length) {
                                object.changedFormFieldIds = [];
                                for (var j = 0; j < message.changedFormFieldIds.length; ++j)
                                    if (typeof message.changedFormFieldIds[j] === "number")
                                        object.changedFormFieldIds[j] = options.longs === String ? String(message.changedFormFieldIds[j]) : message.changedFormFieldIds[j];
                                    else
                                        object.changedFormFieldIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.changedFormFieldIds[j]) : options.longs === Number ? new $util.LongBits(message.changedFormFieldIds[j].low >>> 0, message.changedFormFieldIds[j].high >>> 0).toNumber() : message.changedFormFieldIds[j];
                            }
                            if (message.changedAttributeIds && message.changedAttributeIds.length) {
                                object.changedAttributeIds = [];
                                for (var j = 0; j < message.changedAttributeIds.length; ++j)
                                    if (typeof message.changedAttributeIds[j] === "number")
                                        object.changedAttributeIds[j] = options.longs === String ? String(message.changedAttributeIds[j]) : message.changedAttributeIds[j];
                                    else
                                        object.changedAttributeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.changedAttributeIds[j]) : options.longs === Number ? new $util.LongBits(message.changedAttributeIds[j].low >>> 0, message.changedAttributeIds[j].high >>> 0).toNumber() : message.changedAttributeIds[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this EvaluateFormCustomAction to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.EvaluateFormCustomAction
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        EvaluateFormCustomAction.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return EvaluateFormCustomAction;
                    })();
    
                    AsyncJob.SyncMatchingGroupMember = (function() {
    
                        /**
                         * Properties of a SyncMatchingGroupMember.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface ISyncMatchingGroupMember
                         * @property {number|null} [matchingGroupId] SyncMatchingGroupMember matchingGroupId
                         */
    
                        /**
                         * Constructs a new SyncMatchingGroupMember.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a SyncMatchingGroupMember.
                         * @implements ISyncMatchingGroupMember
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember=} [properties] Properties to set
                         */
                        function SyncMatchingGroupMember(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SyncMatchingGroupMember matchingGroupId.
                         * @member {number} matchingGroupId
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @instance
                         */
                        SyncMatchingGroupMember.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new SyncMatchingGroupMember instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember} SyncMatchingGroupMember instance
                         */
                        SyncMatchingGroupMember.create = function create(properties) {
                            return new SyncMatchingGroupMember(properties);
                        };
    
                        /**
                         * Encodes the specified SyncMatchingGroupMember message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember} message SyncMatchingGroupMember message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SyncMatchingGroupMember.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.matchingGroupId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SyncMatchingGroupMember message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncMatchingGroupMember} message SyncMatchingGroupMember message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SyncMatchingGroupMember.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SyncMatchingGroupMember message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember} SyncMatchingGroupMember
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SyncMatchingGroupMember.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.matchingGroupId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SyncMatchingGroupMember message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember} SyncMatchingGroupMember
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SyncMatchingGroupMember.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SyncMatchingGroupMember message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SyncMatchingGroupMember.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                                if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                    return "matchingGroupId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates a SyncMatchingGroupMember message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember} SyncMatchingGroupMember
                         */
                        SyncMatchingGroupMember.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember();
                            if (object.matchingGroupId != null)
                                if ($util.Long)
                                    (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                                else if (typeof object.matchingGroupId === "string")
                                    message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                                else if (typeof object.matchingGroupId === "number")
                                    message.matchingGroupId = object.matchingGroupId;
                                else if (typeof object.matchingGroupId === "object")
                                    message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SyncMatchingGroupMember message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember} message SyncMatchingGroupMember
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SyncMatchingGroupMember.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.matchingGroupId = options.longs === String ? "0" : 0;
                            if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                                if (typeof message.matchingGroupId === "number")
                                    object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                                else
                                    object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                            return object;
                        };
    
                        /**
                         * Converts this SyncMatchingGroupMember to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.SyncMatchingGroupMember
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SyncMatchingGroupMember.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SyncMatchingGroupMember;
                    })();
    
                    AsyncJob.AggregateAttendance = (function() {
    
                        /**
                         * Properties of an AggregateAttendance.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAggregateAttendance
                         * @property {number|null} [storeId] AggregateAttendance storeId
                         * @property {string|null} [startDateId] AggregateAttendance startDateId
                         * @property {string|null} [endDateId] AggregateAttendance endDateId
                         */
    
                        /**
                         * Constructs a new AggregateAttendance.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an AggregateAttendance.
                         * @implements IAggregateAttendance
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateAttendance=} [properties] Properties to set
                         */
                        function AggregateAttendance(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AggregateAttendance storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @instance
                         */
                        AggregateAttendance.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AggregateAttendance startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @instance
                         */
                        AggregateAttendance.prototype.startDateId = "";
    
                        /**
                         * AggregateAttendance endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @instance
                         */
                        AggregateAttendance.prototype.endDateId = "";
    
                        /**
                         * Creates a new AggregateAttendance instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateAttendance=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateAttendance} AggregateAttendance instance
                         */
                        AggregateAttendance.create = function create(properties) {
                            return new AggregateAttendance(properties);
                        };
    
                        /**
                         * Encodes the specified AggregateAttendance message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateAttendance.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateAttendance} message AggregateAttendance message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateAttendance.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AggregateAttendance message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateAttendance.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateAttendance} message AggregateAttendance message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateAttendance.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AggregateAttendance message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateAttendance} AggregateAttendance
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateAttendance.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.AggregateAttendance();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateId = reader.string();
                                    break;
                                case 3:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AggregateAttendance message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateAttendance} AggregateAttendance
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateAttendance.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AggregateAttendance message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AggregateAttendance.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an AggregateAttendance message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateAttendance} AggregateAttendance
                         */
                        AggregateAttendance.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.AggregateAttendance)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.AggregateAttendance();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AggregateAttendance message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.AggregateAttendance} message AggregateAttendance
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AggregateAttendance.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this AggregateAttendance to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateAttendance
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AggregateAttendance.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AggregateAttendance;
                    })();
    
                    AsyncJob.SyncReviews = (function() {
    
                        /**
                         * Properties of a SyncReviews.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface ISyncReviews
                         * @property {number|null} [formId] SyncReviews formId
                         * @property {number|null} [startDateMs] SyncReviews startDateMs
                         * @property {number|null} [endDateMs] SyncReviews endDateMs
                         * @property {number|null} [submitterId] SyncReviews submitterId
                         * @property {number|null} [storeId] SyncReviews storeId
                         */
    
                        /**
                         * Constructs a new SyncReviews.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents a SyncReviews.
                         * @implements ISyncReviews
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.ISyncReviews=} [properties] Properties to set
                         */
                        function SyncReviews(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SyncReviews formId.
                         * @member {number} formId
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         */
                        SyncReviews.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * SyncReviews startDateMs.
                         * @member {number} startDateMs
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         */
                        SyncReviews.prototype.startDateMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * SyncReviews endDateMs.
                         * @member {number} endDateMs
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         */
                        SyncReviews.prototype.endDateMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * SyncReviews submitterId.
                         * @member {number} submitterId
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         */
                        SyncReviews.prototype.submitterId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * SyncReviews storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         */
                        SyncReviews.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new SyncReviews instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncReviews=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.SyncReviews} SyncReviews instance
                         */
                        SyncReviews.create = function create(properties) {
                            return new SyncReviews(properties);
                        };
    
                        /**
                         * Encodes the specified SyncReviews message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SyncReviews.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncReviews} message SyncReviews message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SyncReviews.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                            if (message.startDateMs != null && Object.hasOwnProperty.call(message, "startDateMs"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.startDateMs);
                            if (message.endDateMs != null && Object.hasOwnProperty.call(message, "endDateMs"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int64(message.endDateMs);
                            if (message.submitterId != null && Object.hasOwnProperty.call(message, "submitterId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.submitterId);
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.storeId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SyncReviews message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.SyncReviews.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.ISyncReviews} message SyncReviews message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SyncReviews.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SyncReviews message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.SyncReviews} SyncReviews
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SyncReviews.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.SyncReviews();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.formId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateMs = reader.int64();
                                    break;
                                case 3:
                                    message.endDateMs = reader.int64();
                                    break;
                                case 4:
                                    message.submitterId = reader.int64();
                                    break;
                                case 7:
                                    message.storeId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SyncReviews message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.SyncReviews} SyncReviews
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SyncReviews.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SyncReviews message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SyncReviews.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                    return "formId: integer|Long expected";
                            if (message.startDateMs != null && message.hasOwnProperty("startDateMs"))
                                if (!$util.isInteger(message.startDateMs) && !(message.startDateMs && $util.isInteger(message.startDateMs.low) && $util.isInteger(message.startDateMs.high)))
                                    return "startDateMs: integer|Long expected";
                            if (message.endDateMs != null && message.hasOwnProperty("endDateMs"))
                                if (!$util.isInteger(message.endDateMs) && !(message.endDateMs && $util.isInteger(message.endDateMs.low) && $util.isInteger(message.endDateMs.high)))
                                    return "endDateMs: integer|Long expected";
                            if (message.submitterId != null && message.hasOwnProperty("submitterId"))
                                if (!$util.isInteger(message.submitterId) && !(message.submitterId && $util.isInteger(message.submitterId.low) && $util.isInteger(message.submitterId.high)))
                                    return "submitterId: integer|Long expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates a SyncReviews message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.SyncReviews} SyncReviews
                         */
                        SyncReviews.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.SyncReviews)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.SyncReviews();
                            if (object.formId != null)
                                if ($util.Long)
                                    (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                                else if (typeof object.formId === "string")
                                    message.formId = parseInt(object.formId, 10);
                                else if (typeof object.formId === "number")
                                    message.formId = object.formId;
                                else if (typeof object.formId === "object")
                                    message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                            if (object.startDateMs != null)
                                if ($util.Long)
                                    (message.startDateMs = $util.Long.fromValue(object.startDateMs)).unsigned = false;
                                else if (typeof object.startDateMs === "string")
                                    message.startDateMs = parseInt(object.startDateMs, 10);
                                else if (typeof object.startDateMs === "number")
                                    message.startDateMs = object.startDateMs;
                                else if (typeof object.startDateMs === "object")
                                    message.startDateMs = new $util.LongBits(object.startDateMs.low >>> 0, object.startDateMs.high >>> 0).toNumber();
                            if (object.endDateMs != null)
                                if ($util.Long)
                                    (message.endDateMs = $util.Long.fromValue(object.endDateMs)).unsigned = false;
                                else if (typeof object.endDateMs === "string")
                                    message.endDateMs = parseInt(object.endDateMs, 10);
                                else if (typeof object.endDateMs === "number")
                                    message.endDateMs = object.endDateMs;
                                else if (typeof object.endDateMs === "object")
                                    message.endDateMs = new $util.LongBits(object.endDateMs.low >>> 0, object.endDateMs.high >>> 0).toNumber();
                            if (object.submitterId != null)
                                if ($util.Long)
                                    (message.submitterId = $util.Long.fromValue(object.submitterId)).unsigned = false;
                                else if (typeof object.submitterId === "string")
                                    message.submitterId = parseInt(object.submitterId, 10);
                                else if (typeof object.submitterId === "number")
                                    message.submitterId = object.submitterId;
                                else if (typeof object.submitterId === "object")
                                    message.submitterId = new $util.LongBits(object.submitterId.low >>> 0, object.submitterId.high >>> 0).toNumber();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SyncReviews message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.SyncReviews} message SyncReviews
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SyncReviews.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.startDateMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.startDateMs = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.endDateMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.endDateMs = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.submitterId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.submitterId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                            }
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (typeof message.formId === "number")
                                    object.formId = options.longs === String ? String(message.formId) : message.formId;
                                else
                                    object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                            if (message.startDateMs != null && message.hasOwnProperty("startDateMs"))
                                if (typeof message.startDateMs === "number")
                                    object.startDateMs = options.longs === String ? String(message.startDateMs) : message.startDateMs;
                                else
                                    object.startDateMs = options.longs === String ? $util.Long.prototype.toString.call(message.startDateMs) : options.longs === Number ? new $util.LongBits(message.startDateMs.low >>> 0, message.startDateMs.high >>> 0).toNumber() : message.startDateMs;
                            if (message.endDateMs != null && message.hasOwnProperty("endDateMs"))
                                if (typeof message.endDateMs === "number")
                                    object.endDateMs = options.longs === String ? String(message.endDateMs) : message.endDateMs;
                                else
                                    object.endDateMs = options.longs === String ? $util.Long.prototype.toString.call(message.endDateMs) : options.longs === Number ? new $util.LongBits(message.endDateMs.low >>> 0, message.endDateMs.high >>> 0).toNumber() : message.endDateMs;
                            if (message.submitterId != null && message.hasOwnProperty("submitterId"))
                                if (typeof message.submitterId === "number")
                                    object.submitterId = options.longs === String ? String(message.submitterId) : message.submitterId;
                                else
                                    object.submitterId = options.longs === String ? $util.Long.prototype.toString.call(message.submitterId) : options.longs === Number ? new $util.LongBits(message.submitterId.low >>> 0, message.submitterId.high >>> 0).toNumber() : message.submitterId;
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            return object;
                        };
    
                        /**
                         * Converts this SyncReviews to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.SyncReviews
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SyncReviews.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SyncReviews;
                    })();
    
                    AsyncJob.AggregateReputation = (function() {
    
                        /**
                         * Properties of an AggregateReputation.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @interface IAggregateReputation
                         * @property {number|null} [storeId] AggregateReputation storeId
                         * @property {string|null} [startDateId] AggregateReputation startDateId
                         * @property {string|null} [endDateId] AggregateReputation endDateId
                         */
    
                        /**
                         * Constructs a new AggregateReputation.
                         * @memberof palexy.streaming.v1.AsyncJob
                         * @classdesc Represents an AggregateReputation.
                         * @implements IAggregateReputation
                         * @constructor
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateReputation=} [properties] Properties to set
                         */
                        function AggregateReputation(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * AggregateReputation storeId.
                         * @member {number} storeId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @instance
                         */
                        AggregateReputation.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * AggregateReputation startDateId.
                         * @member {string} startDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @instance
                         */
                        AggregateReputation.prototype.startDateId = "";
    
                        /**
                         * AggregateReputation endDateId.
                         * @member {string} endDateId
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @instance
                         */
                        AggregateReputation.prototype.endDateId = "";
    
                        /**
                         * Creates a new AggregateReputation instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateReputation=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateReputation} AggregateReputation instance
                         */
                        AggregateReputation.create = function create(properties) {
                            return new AggregateReputation(properties);
                        };
    
                        /**
                         * Encodes the specified AggregateReputation message. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateReputation.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateReputation} message AggregateReputation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateReputation.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                            if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified AggregateReputation message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJob.AggregateReputation.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.IAggregateReputation} message AggregateReputation message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        AggregateReputation.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an AggregateReputation message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateReputation} AggregateReputation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateReputation.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJob.AggregateReputation();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                case 2:
                                    message.startDateId = reader.string();
                                    break;
                                case 3:
                                    message.endDateId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an AggregateReputation message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateReputation} AggregateReputation
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        AggregateReputation.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an AggregateReputation message.
                         * @function verify
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        AggregateReputation.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                if (!$util.isString(message.startDateId))
                                    return "startDateId: string expected";
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                if (!$util.isString(message.endDateId))
                                    return "endDateId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates an AggregateReputation message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.AsyncJob.AggregateReputation} AggregateReputation
                         */
                        AggregateReputation.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.AsyncJob.AggregateReputation)
                                return object;
                            var message = new $root.palexy.streaming.v1.AsyncJob.AggregateReputation();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            if (object.startDateId != null)
                                message.startDateId = String(object.startDateId);
                            if (object.endDateId != null)
                                message.endDateId = String(object.endDateId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an AggregateReputation message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @static
                         * @param {palexy.streaming.v1.AsyncJob.AggregateReputation} message AggregateReputation
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        AggregateReputation.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                                object.startDateId = "";
                                object.endDateId = "";
                            }
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                                object.startDateId = message.startDateId;
                            if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                                object.endDateId = message.endDateId;
                            return object;
                        };
    
                        /**
                         * Converts this AggregateReputation to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.AsyncJob.AggregateReputation
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        AggregateReputation.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return AggregateReputation;
                    })();
    
                    return AsyncJob;
                })();
    
                v1.GetAsyncJobRequest = (function() {
    
                    /**
                     * Properties of a GetAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetAsyncJobRequest
                     * @property {number|null} [asyncJobId] GetAsyncJobRequest asyncJobId
                     */
    
                    /**
                     * Constructs a new GetAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetAsyncJobRequest.
                     * @implements IGetAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest=} [properties] Properties to set
                     */
                    function GetAsyncJobRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAsyncJobRequest asyncJobId.
                     * @member {number} asyncJobId
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @instance
                     */
                    GetAsyncJobRequest.prototype.asyncJobId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetAsyncJobRequest} GetAsyncJobRequest instance
                     */
                    GetAsyncJobRequest.create = function create(properties) {
                        return new GetAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.GetAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest} message GetAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobId != null && Object.hasOwnProperty.call(message, "asyncJobId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.asyncJobId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAsyncJobRequest} message GetAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetAsyncJobRequest} GetAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.asyncJobId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetAsyncJobRequest} GetAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobId != null && message.hasOwnProperty("asyncJobId"))
                            if (!$util.isInteger(message.asyncJobId) && !(message.asyncJobId && $util.isInteger(message.asyncJobId.low) && $util.isInteger(message.asyncJobId.high)))
                                return "asyncJobId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetAsyncJobRequest} GetAsyncJobRequest
                     */
                    GetAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetAsyncJobRequest();
                        if (object.asyncJobId != null)
                            if ($util.Long)
                                (message.asyncJobId = $util.Long.fromValue(object.asyncJobId)).unsigned = false;
                            else if (typeof object.asyncJobId === "string")
                                message.asyncJobId = parseInt(object.asyncJobId, 10);
                            else if (typeof object.asyncJobId === "number")
                                message.asyncJobId = object.asyncJobId;
                            else if (typeof object.asyncJobId === "object")
                                message.asyncJobId = new $util.LongBits(object.asyncJobId.low >>> 0, object.asyncJobId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.GetAsyncJobRequest} message GetAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.asyncJobId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.asyncJobId = options.longs === String ? "0" : 0;
                        if (message.asyncJobId != null && message.hasOwnProperty("asyncJobId"))
                            if (typeof message.asyncJobId === "number")
                                object.asyncJobId = options.longs === String ? String(message.asyncJobId) : message.asyncJobId;
                            else
                                object.asyncJobId = options.longs === String ? $util.Long.prototype.toString.call(message.asyncJobId) : options.longs === Number ? new $util.LongBits(message.asyncJobId.low >>> 0, message.asyncJobId.high >>> 0).toNumber() : message.asyncJobId;
                        return object;
                    };
    
                    /**
                     * Converts this GetAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAsyncJobRequest;
                })();
    
                v1.BatchGetAsyncJobRequest = (function() {
    
                    /**
                     * Properties of a BatchGetAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchGetAsyncJobRequest
                     * @property {Array.<number>|null} [asyncJobIds] BatchGetAsyncJobRequest asyncJobIds
                     */
    
                    /**
                     * Constructs a new BatchGetAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchGetAsyncJobRequest.
                     * @implements IBatchGetAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest=} [properties] Properties to set
                     */
                    function BatchGetAsyncJobRequest(properties) {
                        this.asyncJobIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchGetAsyncJobRequest asyncJobIds.
                     * @member {Array.<number>} asyncJobIds
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @instance
                     */
                    BatchGetAsyncJobRequest.prototype.asyncJobIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchGetAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobRequest} BatchGetAsyncJobRequest instance
                     */
                    BatchGetAsyncJobRequest.create = function create(properties) {
                        return new BatchGetAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchGetAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.BatchGetAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest} message BatchGetAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobIds != null && message.asyncJobIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.asyncJobIds.length; ++i)
                                writer.int64(message.asyncJobIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchGetAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchGetAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobRequest} message BatchGetAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchGetAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobRequest} BatchGetAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchGetAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobIds && message.asyncJobIds.length))
                                    message.asyncJobIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.asyncJobIds.push(reader.int64());
                                } else
                                    message.asyncJobIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchGetAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobRequest} BatchGetAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchGetAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchGetAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobIds != null && message.hasOwnProperty("asyncJobIds")) {
                            if (!Array.isArray(message.asyncJobIds))
                                return "asyncJobIds: array expected";
                            for (var i = 0; i < message.asyncJobIds.length; ++i)
                                if (!$util.isInteger(message.asyncJobIds[i]) && !(message.asyncJobIds[i] && $util.isInteger(message.asyncJobIds[i].low) && $util.isInteger(message.asyncJobIds[i].high)))
                                    return "asyncJobIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchGetAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobRequest} BatchGetAsyncJobRequest
                     */
                    BatchGetAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchGetAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchGetAsyncJobRequest();
                        if (object.asyncJobIds) {
                            if (!Array.isArray(object.asyncJobIds))
                                throw TypeError(".palexy.streaming.v1.BatchGetAsyncJobRequest.asyncJobIds: array expected");
                            message.asyncJobIds = [];
                            for (var i = 0; i < object.asyncJobIds.length; ++i)
                                if ($util.Long)
                                    (message.asyncJobIds[i] = $util.Long.fromValue(object.asyncJobIds[i])).unsigned = false;
                                else if (typeof object.asyncJobIds[i] === "string")
                                    message.asyncJobIds[i] = parseInt(object.asyncJobIds[i], 10);
                                else if (typeof object.asyncJobIds[i] === "number")
                                    message.asyncJobIds[i] = object.asyncJobIds[i];
                                else if (typeof object.asyncJobIds[i] === "object")
                                    message.asyncJobIds[i] = new $util.LongBits(object.asyncJobIds[i].low >>> 0, object.asyncJobIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchGetAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchGetAsyncJobRequest} message BatchGetAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchGetAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobIds = [];
                        if (message.asyncJobIds && message.asyncJobIds.length) {
                            object.asyncJobIds = [];
                            for (var j = 0; j < message.asyncJobIds.length; ++j)
                                if (typeof message.asyncJobIds[j] === "number")
                                    object.asyncJobIds[j] = options.longs === String ? String(message.asyncJobIds[j]) : message.asyncJobIds[j];
                                else
                                    object.asyncJobIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.asyncJobIds[j]) : options.longs === Number ? new $util.LongBits(message.asyncJobIds[j].low >>> 0, message.asyncJobIds[j].high >>> 0).toNumber() : message.asyncJobIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchGetAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchGetAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchGetAsyncJobRequest;
                })();
    
                v1.BatchGetAsyncJobResponse = (function() {
    
                    /**
                     * Properties of a BatchGetAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchGetAsyncJobResponse
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobs] BatchGetAsyncJobResponse asyncJobs
                     */
    
                    /**
                     * Constructs a new BatchGetAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchGetAsyncJobResponse.
                     * @implements IBatchGetAsyncJobResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobResponse=} [properties] Properties to set
                     */
                    function BatchGetAsyncJobResponse(properties) {
                        this.asyncJobs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchGetAsyncJobResponse asyncJobs.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobs
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @instance
                     */
                    BatchGetAsyncJobResponse.prototype.asyncJobs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchGetAsyncJobResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobResponse} BatchGetAsyncJobResponse instance
                     */
                    BatchGetAsyncJobResponse.create = function create(properties) {
                        return new BatchGetAsyncJobResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchGetAsyncJobResponse message. Does not implicitly {@link palexy.streaming.v1.BatchGetAsyncJobResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobResponse} message BatchGetAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetAsyncJobResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobs != null && message.asyncJobs.length)
                            for (var i = 0; i < message.asyncJobs.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchGetAsyncJobResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchGetAsyncJobResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchGetAsyncJobResponse} message BatchGetAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetAsyncJobResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchGetAsyncJobResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobResponse} BatchGetAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetAsyncJobResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchGetAsyncJobResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobs && message.asyncJobs.length))
                                    message.asyncJobs = [];
                                message.asyncJobs.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchGetAsyncJobResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobResponse} BatchGetAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetAsyncJobResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchGetAsyncJobResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchGetAsyncJobResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobs != null && message.hasOwnProperty("asyncJobs")) {
                            if (!Array.isArray(message.asyncJobs))
                                return "asyncJobs: array expected";
                            for (var i = 0; i < message.asyncJobs.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobs[i]);
                                if (error)
                                    return "asyncJobs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchGetAsyncJobResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchGetAsyncJobResponse} BatchGetAsyncJobResponse
                     */
                    BatchGetAsyncJobResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchGetAsyncJobResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchGetAsyncJobResponse();
                        if (object.asyncJobs) {
                            if (!Array.isArray(object.asyncJobs))
                                throw TypeError(".palexy.streaming.v1.BatchGetAsyncJobResponse.asyncJobs: array expected");
                            message.asyncJobs = [];
                            for (var i = 0; i < object.asyncJobs.length; ++i) {
                                if (typeof object.asyncJobs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchGetAsyncJobResponse.asyncJobs: object expected");
                                message.asyncJobs[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchGetAsyncJobResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchGetAsyncJobResponse} message BatchGetAsyncJobResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchGetAsyncJobResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobs = [];
                        if (message.asyncJobs && message.asyncJobs.length) {
                            object.asyncJobs = [];
                            for (var j = 0; j < message.asyncJobs.length; ++j)
                                object.asyncJobs[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchGetAsyncJobResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchGetAsyncJobResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchGetAsyncJobResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchGetAsyncJobResponse;
                })();
    
                v1.CancelAsyncJobRequest = (function() {
    
                    /**
                     * Properties of a CancelAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICancelAsyncJobRequest
                     * @property {number|null} [asyncJobId] CancelAsyncJobRequest asyncJobId
                     * @property {palexy.streaming.v1.AsyncJob.Status|null} [currentStatus] CancelAsyncJobRequest currentStatus
                     */
    
                    /**
                     * Constructs a new CancelAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CancelAsyncJobRequest.
                     * @implements ICancelAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest=} [properties] Properties to set
                     */
                    function CancelAsyncJobRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CancelAsyncJobRequest asyncJobId.
                     * @member {number} asyncJobId
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @instance
                     */
                    CancelAsyncJobRequest.prototype.asyncJobId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CancelAsyncJobRequest currentStatus.
                     * @member {palexy.streaming.v1.AsyncJob.Status} currentStatus
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @instance
                     */
                    CancelAsyncJobRequest.prototype.currentStatus = 0;
    
                    /**
                     * Creates a new CancelAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CancelAsyncJobRequest} CancelAsyncJobRequest instance
                     */
                    CancelAsyncJobRequest.create = function create(properties) {
                        return new CancelAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CancelAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.CancelAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest} message CancelAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobId != null && Object.hasOwnProperty.call(message, "asyncJobId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.asyncJobId);
                        if (message.currentStatus != null && Object.hasOwnProperty.call(message, "currentStatus"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.currentStatus);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CancelAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CancelAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.ICancelAsyncJobRequest} message CancelAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CancelAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CancelAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CancelAsyncJobRequest} CancelAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CancelAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.asyncJobId = reader.int64();
                                break;
                            case 2:
                                message.currentStatus = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CancelAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CancelAsyncJobRequest} CancelAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CancelAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CancelAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CancelAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobId != null && message.hasOwnProperty("asyncJobId"))
                            if (!$util.isInteger(message.asyncJobId) && !(message.asyncJobId && $util.isInteger(message.asyncJobId.low) && $util.isInteger(message.asyncJobId.high)))
                                return "asyncJobId: integer|Long expected";
                        if (message.currentStatus != null && message.hasOwnProperty("currentStatus"))
                            switch (message.currentStatus) {
                            default:
                                return "currentStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a CancelAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CancelAsyncJobRequest} CancelAsyncJobRequest
                     */
                    CancelAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CancelAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CancelAsyncJobRequest();
                        if (object.asyncJobId != null)
                            if ($util.Long)
                                (message.asyncJobId = $util.Long.fromValue(object.asyncJobId)).unsigned = false;
                            else if (typeof object.asyncJobId === "string")
                                message.asyncJobId = parseInt(object.asyncJobId, 10);
                            else if (typeof object.asyncJobId === "number")
                                message.asyncJobId = object.asyncJobId;
                            else if (typeof object.asyncJobId === "object")
                                message.asyncJobId = new $util.LongBits(object.asyncJobId.low >>> 0, object.asyncJobId.high >>> 0).toNumber();
                        switch (object.currentStatus) {
                        case "UNPROCESSED":
                        case 0:
                            message.currentStatus = 0;
                            break;
                        case "PROCESSING":
                        case 1:
                            message.currentStatus = 1;
                            break;
                        case "WAIT_FOR_RETRYING":
                        case 2:
                            message.currentStatus = 2;
                            break;
                        case "DONE":
                        case 3:
                            message.currentStatus = 3;
                            break;
                        case "CANCELLED":
                        case 4:
                            message.currentStatus = 4;
                            break;
                        case "SKIPPED":
                        case 5:
                            message.currentStatus = 5;
                            break;
                        case "RECURRING":
                        case 6:
                            message.currentStatus = 6;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CancelAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.CancelAsyncJobRequest} message CancelAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CancelAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.asyncJobId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.asyncJobId = options.longs === String ? "0" : 0;
                            object.currentStatus = options.enums === String ? "UNPROCESSED" : 0;
                        }
                        if (message.asyncJobId != null && message.hasOwnProperty("asyncJobId"))
                            if (typeof message.asyncJobId === "number")
                                object.asyncJobId = options.longs === String ? String(message.asyncJobId) : message.asyncJobId;
                            else
                                object.asyncJobId = options.longs === String ? $util.Long.prototype.toString.call(message.asyncJobId) : options.longs === Number ? new $util.LongBits(message.asyncJobId.low >>> 0, message.asyncJobId.high >>> 0).toNumber() : message.asyncJobId;
                        if (message.currentStatus != null && message.hasOwnProperty("currentStatus"))
                            object.currentStatus = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Status[message.currentStatus] : message.currentStatus;
                        return object;
                    };
    
                    /**
                     * Converts this CancelAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CancelAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CancelAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CancelAsyncJobRequest;
                })();
    
                v1.ListAsyncJobRequest = (function() {
    
                    /**
                     * Properties of a ListAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListAsyncJobRequest
                     * @property {number|null} [companyId] ListAsyncJobRequest companyId
                     * @property {number|null} [ownerId] ListAsyncJobRequest ownerId
                     * @property {palexy.streaming.v1.AsyncJob.Type|null} [type] ListAsyncJobRequest type
                     * @property {Array.<palexy.streaming.v1.AsyncJob.Status>|null} [statuses] ListAsyncJobRequest statuses
                     * @property {number|null} [pageSize] ListAsyncJobRequest pageSize
                     * @property {string|null} [pageToken] ListAsyncJobRequest pageToken
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] ListAsyncJobRequest fromDate
                     * @property {palexy.streaming.v1.IDateFilter|null} [toDate] ListAsyncJobRequest toDate
                     * @property {Array.<string>|null} [orderByFieldPaths] ListAsyncJobRequest orderByFieldPaths
                     * @property {number|null} [maxRetryBackoffTimeMinutes] ListAsyncJobRequest maxRetryBackoffTimeMinutes
                     */
    
                    /**
                     * Constructs a new ListAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAsyncJobRequest.
                     * @implements IListAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListAsyncJobRequest=} [properties] Properties to set
                     */
                    function ListAsyncJobRequest(properties) {
                        this.statuses = [];
                        this.orderByFieldPaths = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAsyncJobRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListAsyncJobRequest ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListAsyncJobRequest type.
                     * @member {palexy.streaming.v1.AsyncJob.Type} type
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.type = 0;
    
                    /**
                     * ListAsyncJobRequest statuses.
                     * @member {Array.<palexy.streaming.v1.AsyncJob.Status>} statuses
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.statuses = $util.emptyArray;
    
                    /**
                     * ListAsyncJobRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.pageSize = 0;
    
                    /**
                     * ListAsyncJobRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.pageToken = "";
    
                    /**
                     * ListAsyncJobRequest fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.fromDate = null;
    
                    /**
                     * ListAsyncJobRequest toDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} toDate
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.toDate = null;
    
                    /**
                     * ListAsyncJobRequest orderByFieldPaths.
                     * @member {Array.<string>} orderByFieldPaths
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.orderByFieldPaths = $util.emptyArray;
    
                    /**
                     * ListAsyncJobRequest maxRetryBackoffTimeMinutes.
                     * @member {number} maxRetryBackoffTimeMinutes
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     */
                    ListAsyncJobRequest.prototype.maxRetryBackoffTimeMinutes = 0;
    
                    /**
                     * Creates a new ListAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAsyncJobRequest} ListAsyncJobRequest instance
                     */
                    ListAsyncJobRequest.create = function create(properties) {
                        return new ListAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.ListAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobRequest} message ListAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.ownerId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                        if (message.statuses != null && message.statuses.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.statuses.length; ++i)
                                writer.int32(message.statuses[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.toDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.orderByFieldPaths != null && message.orderByFieldPaths.length)
                            for (var i = 0; i < message.orderByFieldPaths.length; ++i)
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.orderByFieldPaths[i]);
                        if (message.maxRetryBackoffTimeMinutes != null && Object.hasOwnProperty.call(message, "maxRetryBackoffTimeMinutes"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.maxRetryBackoffTimeMinutes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobRequest} message ListAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAsyncJobRequest} ListAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.ownerId = reader.int64();
                                break;
                            case 3:
                                message.type = reader.int32();
                                break;
                            case 4:
                                if (!(message.statuses && message.statuses.length))
                                    message.statuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.statuses.push(reader.int32());
                                } else
                                    message.statuses.push(reader.int32());
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 8:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.toDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 11:
                                if (!(message.orderByFieldPaths && message.orderByFieldPaths.length))
                                    message.orderByFieldPaths = [];
                                message.orderByFieldPaths.push(reader.string());
                                break;
                            case 12:
                                message.maxRetryBackoffTimeMinutes = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAsyncJobRequest} ListAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                                break;
                            }
                        if (message.statuses != null && message.hasOwnProperty("statuses")) {
                            if (!Array.isArray(message.statuses))
                                return "statuses: array expected";
                            for (var i = 0; i < message.statuses.length; ++i)
                                switch (message.statuses[i]) {
                                default:
                                    return "statuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                    break;
                                }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.toDate != null && message.hasOwnProperty("toDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.toDate);
                            if (error)
                                return "toDate." + error;
                        }
                        if (message.orderByFieldPaths != null && message.hasOwnProperty("orderByFieldPaths")) {
                            if (!Array.isArray(message.orderByFieldPaths))
                                return "orderByFieldPaths: array expected";
                            for (var i = 0; i < message.orderByFieldPaths.length; ++i)
                                if (!$util.isString(message.orderByFieldPaths[i]))
                                    return "orderByFieldPaths: string[] expected";
                        }
                        if (message.maxRetryBackoffTimeMinutes != null && message.hasOwnProperty("maxRetryBackoffTimeMinutes"))
                            if (!$util.isInteger(message.maxRetryBackoffTimeMinutes))
                                return "maxRetryBackoffTimeMinutes: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAsyncJobRequest} ListAsyncJobRequest
                     */
                    ListAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAsyncJobRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "EXPORT":
                        case 1:
                            message.type = 1;
                            break;
                        case "POS_MATCHING":
                        case 2:
                            message.type = 2;
                            break;
                        case "POS_IMPORT":
                        case 3:
                            message.type = 3;
                            break;
                        case "AGGREGATE":
                        case 4:
                            message.type = 4;
                            break;
                        case "AGGREGATE_LEVEL_2":
                        case 5:
                            message.type = 5;
                            break;
                        case "CALCULATE_CONSISTENCY":
                        case 6:
                            message.type = 6;
                            break;
                        case "SCHEDULE_TASK":
                        case 7:
                            message.type = 7;
                            break;
                        case "STAFF_DATA_IMPORT":
                        case 8:
                            message.type = 8;
                            break;
                        case "EXPORT_REPORT":
                        case 9:
                            message.type = 9;
                            break;
                        case "UPDATE_WEATHER_DATA":
                        case 10:
                            message.type = 10;
                            break;
                        case "GENERATE_INSIGHT":
                        case 11:
                            message.type = 11;
                            break;
                        case "SEND_REPORT_SCHEDULE":
                        case 12:
                            message.type = 12;
                            break;
                        case "EXTERNAL_TRAFFIC_IMPORT":
                        case 13:
                            message.type = 13;
                            break;
                        case "GENERATE_TREND_REPORT":
                        case 14:
                            message.type = 14;
                            break;
                        case "AGGREGATE_STAFF_SCHEDULE":
                        case 15:
                            message.type = 15;
                            break;
                        case "RERUN_MERGING":
                        case 16:
                            message.type = 16;
                            break;
                        case "ADJUST_SCHEDULE_BUDGET":
                        case 17:
                            message.type = 17;
                            break;
                        case "GOAL_GENERATE_TARGET":
                        case 18:
                            message.type = 18;
                            break;
                        case "GOAL_EVALUATE_PERFORMANCE":
                        case 19:
                            message.type = 19;
                            break;
                        case "SYNC_MATCHING_GROUP_MEMBER":
                        case 20:
                            message.type = 20;
                            break;
                        case "EVALUATE_FORM_CUSTOM_ACTION":
                        case 21:
                            message.type = 21;
                            break;
                        case "AGGREGATE_ATTENDANCE":
                        case 22:
                            message.type = 22;
                            break;
                        case "SYNC_REVIEWS":
                        case 23:
                            message.type = 23;
                            break;
                        case "AGGREGATE_REPUTATION":
                        case 24:
                            message.type = 24;
                            break;
                        }
                        if (object.statuses) {
                            if (!Array.isArray(object.statuses))
                                throw TypeError(".palexy.streaming.v1.ListAsyncJobRequest.statuses: array expected");
                            message.statuses = [];
                            for (var i = 0; i < object.statuses.length; ++i)
                                switch (object.statuses[i]) {
                                default:
                                case "UNPROCESSED":
                                case 0:
                                    message.statuses[i] = 0;
                                    break;
                                case "PROCESSING":
                                case 1:
                                    message.statuses[i] = 1;
                                    break;
                                case "WAIT_FOR_RETRYING":
                                case 2:
                                    message.statuses[i] = 2;
                                    break;
                                case "DONE":
                                case 3:
                                    message.statuses[i] = 3;
                                    break;
                                case "CANCELLED":
                                case 4:
                                    message.statuses[i] = 4;
                                    break;
                                case "SKIPPED":
                                case 5:
                                    message.statuses[i] = 5;
                                    break;
                                case "RECURRING":
                                case 6:
                                    message.statuses[i] = 6;
                                    break;
                                }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListAsyncJobRequest.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.toDate != null) {
                            if (typeof object.toDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListAsyncJobRequest.toDate: object expected");
                            message.toDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.toDate);
                        }
                        if (object.orderByFieldPaths) {
                            if (!Array.isArray(object.orderByFieldPaths))
                                throw TypeError(".palexy.streaming.v1.ListAsyncJobRequest.orderByFieldPaths: array expected");
                            message.orderByFieldPaths = [];
                            for (var i = 0; i < object.orderByFieldPaths.length; ++i)
                                message.orderByFieldPaths[i] = String(object.orderByFieldPaths[i]);
                        }
                        if (object.maxRetryBackoffTimeMinutes != null)
                            message.maxRetryBackoffTimeMinutes = object.maxRetryBackoffTimeMinutes | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.ListAsyncJobRequest} message ListAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.statuses = [];
                            object.orderByFieldPaths = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.fromDate = null;
                            object.toDate = null;
                            object.maxRetryBackoffTimeMinutes = 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Type[message.type] : message.type;
                        if (message.statuses && message.statuses.length) {
                            object.statuses = [];
                            for (var j = 0; j < message.statuses.length; ++j)
                                object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Status[message.statuses[j]] : message.statuses[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = $root.palexy.streaming.v1.DateFilter.toObject(message.toDate, options);
                        if (message.orderByFieldPaths && message.orderByFieldPaths.length) {
                            object.orderByFieldPaths = [];
                            for (var j = 0; j < message.orderByFieldPaths.length; ++j)
                                object.orderByFieldPaths[j] = message.orderByFieldPaths[j];
                        }
                        if (message.maxRetryBackoffTimeMinutes != null && message.hasOwnProperty("maxRetryBackoffTimeMinutes"))
                            object.maxRetryBackoffTimeMinutes = message.maxRetryBackoffTimeMinutes;
                        return object;
                    };
    
                    /**
                     * Converts this ListAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAsyncJobRequest;
                })();
    
                v1.ListAsyncJobResponse = (function() {
    
                    /**
                     * Properties of a ListAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListAsyncJobResponse
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobs] ListAsyncJobResponse asyncJobs
                     * @property {number|null} [totalElements] ListAsyncJobResponse totalElements
                     * @property {string|null} [nextPageToken] ListAsyncJobResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAsyncJobResponse.
                     * @implements IListAsyncJobResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListAsyncJobResponse=} [properties] Properties to set
                     */
                    function ListAsyncJobResponse(properties) {
                        this.asyncJobs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAsyncJobResponse asyncJobs.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobs
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @instance
                     */
                    ListAsyncJobResponse.prototype.asyncJobs = $util.emptyArray;
    
                    /**
                     * ListAsyncJobResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @instance
                     */
                    ListAsyncJobResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListAsyncJobResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @instance
                     */
                    ListAsyncJobResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListAsyncJobResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAsyncJobResponse} ListAsyncJobResponse instance
                     */
                    ListAsyncJobResponse.create = function create(properties) {
                        return new ListAsyncJobResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAsyncJobResponse message. Does not implicitly {@link palexy.streaming.v1.ListAsyncJobResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobResponse} message ListAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncJobResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobs != null && message.asyncJobs.length)
                            for (var i = 0; i < message.asyncJobs.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAsyncJobResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAsyncJobResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncJobResponse} message ListAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncJobResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAsyncJobResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAsyncJobResponse} ListAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncJobResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAsyncJobResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobs && message.asyncJobs.length))
                                    message.asyncJobs = [];
                                message.asyncJobs.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAsyncJobResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAsyncJobResponse} ListAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncJobResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAsyncJobResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAsyncJobResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobs != null && message.hasOwnProperty("asyncJobs")) {
                            if (!Array.isArray(message.asyncJobs))
                                return "asyncJobs: array expected";
                            for (var i = 0; i < message.asyncJobs.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobs[i]);
                                if (error)
                                    return "asyncJobs." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAsyncJobResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAsyncJobResponse} ListAsyncJobResponse
                     */
                    ListAsyncJobResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAsyncJobResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAsyncJobResponse();
                        if (object.asyncJobs) {
                            if (!Array.isArray(object.asyncJobs))
                                throw TypeError(".palexy.streaming.v1.ListAsyncJobResponse.asyncJobs: array expected");
                            message.asyncJobs = [];
                            for (var i = 0; i < object.asyncJobs.length; ++i) {
                                if (typeof object.asyncJobs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAsyncJobResponse.asyncJobs: object expected");
                                message.asyncJobs[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobs[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAsyncJobResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.ListAsyncJobResponse} message ListAsyncJobResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAsyncJobResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobs = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.asyncJobs && message.asyncJobs.length) {
                            object.asyncJobs = [];
                            for (var j = 0; j < message.asyncJobs.length; ++j)
                                object.asyncJobs[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobs[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListAsyncJobResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAsyncJobResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAsyncJobResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAsyncJobResponse;
                })();
    
                v1.UpdateAsyncJobRequest = (function() {
    
                    /**
                     * Properties of an UpdateAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateAsyncJobRequest
                     * @property {palexy.streaming.v1.IAsyncJob|null} [asyncJob] UpdateAsyncJobRequest asyncJob
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateAsyncJobRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateAsyncJobRequest.
                     * @implements IUpdateAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest=} [properties] Properties to set
                     */
                    function UpdateAsyncJobRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateAsyncJobRequest asyncJob.
                     * @member {palexy.streaming.v1.IAsyncJob|null|undefined} asyncJob
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @instance
                     */
                    UpdateAsyncJobRequest.prototype.asyncJob = null;
    
                    /**
                     * UpdateAsyncJobRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @instance
                     */
                    UpdateAsyncJobRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateAsyncJobRequest} UpdateAsyncJobRequest instance
                     */
                    UpdateAsyncJobRequest.create = function create(properties) {
                        return new UpdateAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest} message UpdateAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJob != null && Object.hasOwnProperty.call(message, "asyncJob"))
                            $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJob, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateAsyncJobRequest} message UpdateAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateAsyncJobRequest} UpdateAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.asyncJob = $root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateAsyncJobRequest} UpdateAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJob != null && message.hasOwnProperty("asyncJob")) {
                            var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJob);
                            if (error)
                                return "asyncJob." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateAsyncJobRequest} UpdateAsyncJobRequest
                     */
                    UpdateAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateAsyncJobRequest();
                        if (object.asyncJob != null) {
                            if (typeof object.asyncJob !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateAsyncJobRequest.asyncJob: object expected");
                            message.asyncJob = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJob);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateAsyncJobRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateAsyncJobRequest} message UpdateAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.asyncJob = null;
                            object.updateMask = null;
                        }
                        if (message.asyncJob != null && message.hasOwnProperty("asyncJob"))
                            object.asyncJob = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJob, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateAsyncJobRequest;
                })();
    
                v1.BatchCreateAsyncJobRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateAsyncJobRequest
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobs] BatchCreateAsyncJobRequest asyncJobs
                     */
    
                    /**
                     * Constructs a new BatchCreateAsyncJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateAsyncJobRequest.
                     * @implements IBatchCreateAsyncJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest=} [properties] Properties to set
                     */
                    function BatchCreateAsyncJobRequest(properties) {
                        this.asyncJobs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateAsyncJobRequest asyncJobs.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobs
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @instance
                     */
                    BatchCreateAsyncJobRequest.prototype.asyncJobs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateAsyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobRequest} BatchCreateAsyncJobRequest instance
                     */
                    BatchCreateAsyncJobRequest.create = function create(properties) {
                        return new BatchCreateAsyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateAsyncJobRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateAsyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest} message BatchCreateAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateAsyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobs != null && message.asyncJobs.length)
                            for (var i = 0; i < message.asyncJobs.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateAsyncJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateAsyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobRequest} message BatchCreateAsyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateAsyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateAsyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobRequest} BatchCreateAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateAsyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateAsyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobs && message.asyncJobs.length))
                                    message.asyncJobs = [];
                                message.asyncJobs.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateAsyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobRequest} BatchCreateAsyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateAsyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateAsyncJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateAsyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobs != null && message.hasOwnProperty("asyncJobs")) {
                            if (!Array.isArray(message.asyncJobs))
                                return "asyncJobs: array expected";
                            for (var i = 0; i < message.asyncJobs.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobs[i]);
                                if (error)
                                    return "asyncJobs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateAsyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobRequest} BatchCreateAsyncJobRequest
                     */
                    BatchCreateAsyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateAsyncJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateAsyncJobRequest();
                        if (object.asyncJobs) {
                            if (!Array.isArray(object.asyncJobs))
                                throw TypeError(".palexy.streaming.v1.BatchCreateAsyncJobRequest.asyncJobs: array expected");
                            message.asyncJobs = [];
                            for (var i = 0; i < object.asyncJobs.length; ++i) {
                                if (typeof object.asyncJobs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateAsyncJobRequest.asyncJobs: object expected");
                                message.asyncJobs[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateAsyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateAsyncJobRequest} message BatchCreateAsyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateAsyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobs = [];
                        if (message.asyncJobs && message.asyncJobs.length) {
                            object.asyncJobs = [];
                            for (var j = 0; j < message.asyncJobs.length; ++j)
                                object.asyncJobs[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateAsyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateAsyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateAsyncJobRequest;
                })();
    
                v1.BatchCreateAsyncJobResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateAsyncJobResponse
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobs] BatchCreateAsyncJobResponse asyncJobs
                     */
    
                    /**
                     * Constructs a new BatchCreateAsyncJobResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateAsyncJobResponse.
                     * @implements IBatchCreateAsyncJobResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobResponse=} [properties] Properties to set
                     */
                    function BatchCreateAsyncJobResponse(properties) {
                        this.asyncJobs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateAsyncJobResponse asyncJobs.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobs
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @instance
                     */
                    BatchCreateAsyncJobResponse.prototype.asyncJobs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateAsyncJobResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobResponse} BatchCreateAsyncJobResponse instance
                     */
                    BatchCreateAsyncJobResponse.create = function create(properties) {
                        return new BatchCreateAsyncJobResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateAsyncJobResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateAsyncJobResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobResponse} message BatchCreateAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateAsyncJobResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobs != null && message.asyncJobs.length)
                            for (var i = 0; i < message.asyncJobs.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateAsyncJobResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateAsyncJobResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateAsyncJobResponse} message BatchCreateAsyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateAsyncJobResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateAsyncJobResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobResponse} BatchCreateAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateAsyncJobResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateAsyncJobResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobs && message.asyncJobs.length))
                                    message.asyncJobs = [];
                                message.asyncJobs.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateAsyncJobResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobResponse} BatchCreateAsyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateAsyncJobResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateAsyncJobResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateAsyncJobResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobs != null && message.hasOwnProperty("asyncJobs")) {
                            if (!Array.isArray(message.asyncJobs))
                                return "asyncJobs: array expected";
                            for (var i = 0; i < message.asyncJobs.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobs[i]);
                                if (error)
                                    return "asyncJobs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateAsyncJobResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateAsyncJobResponse} BatchCreateAsyncJobResponse
                     */
                    BatchCreateAsyncJobResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateAsyncJobResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateAsyncJobResponse();
                        if (object.asyncJobs) {
                            if (!Array.isArray(object.asyncJobs))
                                throw TypeError(".palexy.streaming.v1.BatchCreateAsyncJobResponse.asyncJobs: array expected");
                            message.asyncJobs = [];
                            for (var i = 0; i < object.asyncJobs.length; ++i) {
                                if (typeof object.asyncJobs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateAsyncJobResponse.asyncJobs: object expected");
                                message.asyncJobs[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateAsyncJobResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateAsyncJobResponse} message BatchCreateAsyncJobResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateAsyncJobResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobs = [];
                        if (message.asyncJobs && message.asyncJobs.length) {
                            object.asyncJobs = [];
                            for (var j = 0; j < message.asyncJobs.length; ++j)
                                object.asyncJobs[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateAsyncJobResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateAsyncJobResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateAsyncJobResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateAsyncJobResponse;
                })();
    
                v1.ListReadyScheduleTaskJobRequest = (function() {
    
                    /**
                     * Properties of a ListReadyScheduleTaskJobRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListReadyScheduleTaskJobRequest
                     * @property {palexy.streaming.v1.AsyncJob.Type|null} [scheduleTaskType] ListReadyScheduleTaskJobRequest scheduleTaskType
                     * @property {Array.<string>|null} [orderByFieldPaths] ListReadyScheduleTaskJobRequest orderByFieldPaths
                     * @property {number|null} [pageSize] ListReadyScheduleTaskJobRequest pageSize
                     * @property {string|null} [pageToken] ListReadyScheduleTaskJobRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListReadyScheduleTaskJobRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListReadyScheduleTaskJobRequest.
                     * @implements IListReadyScheduleTaskJobRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest=} [properties] Properties to set
                     */
                    function ListReadyScheduleTaskJobRequest(properties) {
                        this.orderByFieldPaths = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReadyScheduleTaskJobRequest scheduleTaskType.
                     * @member {palexy.streaming.v1.AsyncJob.Type} scheduleTaskType
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @instance
                     */
                    ListReadyScheduleTaskJobRequest.prototype.scheduleTaskType = 0;
    
                    /**
                     * ListReadyScheduleTaskJobRequest orderByFieldPaths.
                     * @member {Array.<string>} orderByFieldPaths
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @instance
                     */
                    ListReadyScheduleTaskJobRequest.prototype.orderByFieldPaths = $util.emptyArray;
    
                    /**
                     * ListReadyScheduleTaskJobRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @instance
                     */
                    ListReadyScheduleTaskJobRequest.prototype.pageSize = 0;
    
                    /**
                     * ListReadyScheduleTaskJobRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @instance
                     */
                    ListReadyScheduleTaskJobRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListReadyScheduleTaskJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListReadyScheduleTaskJobRequest} ListReadyScheduleTaskJobRequest instance
                     */
                    ListReadyScheduleTaskJobRequest.create = function create(properties) {
                        return new ListReadyScheduleTaskJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListReadyScheduleTaskJobRequest message. Does not implicitly {@link palexy.streaming.v1.ListReadyScheduleTaskJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest} message ListReadyScheduleTaskJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReadyScheduleTaskJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleTaskType != null && Object.hasOwnProperty.call(message, "scheduleTaskType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scheduleTaskType);
                        if (message.orderByFieldPaths != null && message.orderByFieldPaths.length)
                            for (var i = 0; i < message.orderByFieldPaths.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.orderByFieldPaths[i]);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReadyScheduleTaskJobRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReadyScheduleTaskJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReadyScheduleTaskJobRequest} message ListReadyScheduleTaskJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReadyScheduleTaskJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReadyScheduleTaskJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListReadyScheduleTaskJobRequest} ListReadyScheduleTaskJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReadyScheduleTaskJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReadyScheduleTaskJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleTaskType = reader.int32();
                                break;
                            case 2:
                                if (!(message.orderByFieldPaths && message.orderByFieldPaths.length))
                                    message.orderByFieldPaths = [];
                                message.orderByFieldPaths.push(reader.string());
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReadyScheduleTaskJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListReadyScheduleTaskJobRequest} ListReadyScheduleTaskJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReadyScheduleTaskJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReadyScheduleTaskJobRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReadyScheduleTaskJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                            switch (message.scheduleTaskType) {
                            default:
                                return "scheduleTaskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 21:
                            case 22:
                            case 23:
                            case 24:
                                break;
                            }
                        if (message.orderByFieldPaths != null && message.hasOwnProperty("orderByFieldPaths")) {
                            if (!Array.isArray(message.orderByFieldPaths))
                                return "orderByFieldPaths: array expected";
                            for (var i = 0; i < message.orderByFieldPaths.length; ++i)
                                if (!$util.isString(message.orderByFieldPaths[i]))
                                    return "orderByFieldPaths: string[] expected";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReadyScheduleTaskJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListReadyScheduleTaskJobRequest} ListReadyScheduleTaskJobRequest
                     */
                    ListReadyScheduleTaskJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListReadyScheduleTaskJobRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListReadyScheduleTaskJobRequest();
                        switch (object.scheduleTaskType) {
                        case "UNKNOWN":
                        case 0:
                            message.scheduleTaskType = 0;
                            break;
                        case "EXPORT":
                        case 1:
                            message.scheduleTaskType = 1;
                            break;
                        case "POS_MATCHING":
                        case 2:
                            message.scheduleTaskType = 2;
                            break;
                        case "POS_IMPORT":
                        case 3:
                            message.scheduleTaskType = 3;
                            break;
                        case "AGGREGATE":
                        case 4:
                            message.scheduleTaskType = 4;
                            break;
                        case "AGGREGATE_LEVEL_2":
                        case 5:
                            message.scheduleTaskType = 5;
                            break;
                        case "CALCULATE_CONSISTENCY":
                        case 6:
                            message.scheduleTaskType = 6;
                            break;
                        case "SCHEDULE_TASK":
                        case 7:
                            message.scheduleTaskType = 7;
                            break;
                        case "STAFF_DATA_IMPORT":
                        case 8:
                            message.scheduleTaskType = 8;
                            break;
                        case "EXPORT_REPORT":
                        case 9:
                            message.scheduleTaskType = 9;
                            break;
                        case "UPDATE_WEATHER_DATA":
                        case 10:
                            message.scheduleTaskType = 10;
                            break;
                        case "GENERATE_INSIGHT":
                        case 11:
                            message.scheduleTaskType = 11;
                            break;
                        case "SEND_REPORT_SCHEDULE":
                        case 12:
                            message.scheduleTaskType = 12;
                            break;
                        case "EXTERNAL_TRAFFIC_IMPORT":
                        case 13:
                            message.scheduleTaskType = 13;
                            break;
                        case "GENERATE_TREND_REPORT":
                        case 14:
                            message.scheduleTaskType = 14;
                            break;
                        case "AGGREGATE_STAFF_SCHEDULE":
                        case 15:
                            message.scheduleTaskType = 15;
                            break;
                        case "RERUN_MERGING":
                        case 16:
                            message.scheduleTaskType = 16;
                            break;
                        case "ADJUST_SCHEDULE_BUDGET":
                        case 17:
                            message.scheduleTaskType = 17;
                            break;
                        case "GOAL_GENERATE_TARGET":
                        case 18:
                            message.scheduleTaskType = 18;
                            break;
                        case "GOAL_EVALUATE_PERFORMANCE":
                        case 19:
                            message.scheduleTaskType = 19;
                            break;
                        case "SYNC_MATCHING_GROUP_MEMBER":
                        case 20:
                            message.scheduleTaskType = 20;
                            break;
                        case "EVALUATE_FORM_CUSTOM_ACTION":
                        case 21:
                            message.scheduleTaskType = 21;
                            break;
                        case "AGGREGATE_ATTENDANCE":
                        case 22:
                            message.scheduleTaskType = 22;
                            break;
                        case "SYNC_REVIEWS":
                        case 23:
                            message.scheduleTaskType = 23;
                            break;
                        case "AGGREGATE_REPUTATION":
                        case 24:
                            message.scheduleTaskType = 24;
                            break;
                        }
                        if (object.orderByFieldPaths) {
                            if (!Array.isArray(object.orderByFieldPaths))
                                throw TypeError(".palexy.streaming.v1.ListReadyScheduleTaskJobRequest.orderByFieldPaths: array expected");
                            message.orderByFieldPaths = [];
                            for (var i = 0; i < object.orderByFieldPaths.length; ++i)
                                message.orderByFieldPaths[i] = String(object.orderByFieldPaths[i]);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReadyScheduleTaskJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @static
                     * @param {palexy.streaming.v1.ListReadyScheduleTaskJobRequest} message ListReadyScheduleTaskJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReadyScheduleTaskJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.orderByFieldPaths = [];
                        if (options.defaults) {
                            object.scheduleTaskType = options.enums === String ? "UNKNOWN" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                            object.scheduleTaskType = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Type[message.scheduleTaskType] : message.scheduleTaskType;
                        if (message.orderByFieldPaths && message.orderByFieldPaths.length) {
                            object.orderByFieldPaths = [];
                            for (var j = 0; j < message.orderByFieldPaths.length; ++j)
                                object.orderByFieldPaths[j] = message.orderByFieldPaths[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListReadyScheduleTaskJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListReadyScheduleTaskJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReadyScheduleTaskJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListReadyScheduleTaskJobRequest;
                })();
    
                v1.ListGoalGenerateTargetJobsRequest = (function() {
    
                    /**
                     * Properties of a ListGoalGenerateTargetJobsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListGoalGenerateTargetJobsRequest
                     * @property {string|null} [startDateId] ListGoalGenerateTargetJobsRequest startDateId
                     * @property {string|null} [endDateId] ListGoalGenerateTargetJobsRequest endDateId
                     * @property {Array.<palexy.streaming.v1.AsyncJob.Status>|null} [statuses] ListGoalGenerateTargetJobsRequest statuses
                     */
    
                    /**
                     * Constructs a new ListGoalGenerateTargetJobsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListGoalGenerateTargetJobsRequest.
                     * @implements IListGoalGenerateTargetJobsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest=} [properties] Properties to set
                     */
                    function ListGoalGenerateTargetJobsRequest(properties) {
                        this.statuses = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListGoalGenerateTargetJobsRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @instance
                     */
                    ListGoalGenerateTargetJobsRequest.prototype.startDateId = "";
    
                    /**
                     * ListGoalGenerateTargetJobsRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @instance
                     */
                    ListGoalGenerateTargetJobsRequest.prototype.endDateId = "";
    
                    /**
                     * ListGoalGenerateTargetJobsRequest statuses.
                     * @member {Array.<palexy.streaming.v1.AsyncJob.Status>} statuses
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @instance
                     */
                    ListGoalGenerateTargetJobsRequest.prototype.statuses = $util.emptyArray;
    
                    /**
                     * Creates a new ListGoalGenerateTargetJobsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsRequest} ListGoalGenerateTargetJobsRequest instance
                     */
                    ListGoalGenerateTargetJobsRequest.create = function create(properties) {
                        return new ListGoalGenerateTargetJobsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListGoalGenerateTargetJobsRequest message. Does not implicitly {@link palexy.streaming.v1.ListGoalGenerateTargetJobsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest} message ListGoalGenerateTargetJobsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListGoalGenerateTargetJobsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endDateId);
                        if (message.statuses != null && message.statuses.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.statuses.length; ++i)
                                writer.int32(message.statuses[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListGoalGenerateTargetJobsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListGoalGenerateTargetJobsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsRequest} message ListGoalGenerateTargetJobsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListGoalGenerateTargetJobsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListGoalGenerateTargetJobsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsRequest} ListGoalGenerateTargetJobsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListGoalGenerateTargetJobsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListGoalGenerateTargetJobsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateId = reader.string();
                                break;
                            case 2:
                                message.endDateId = reader.string();
                                break;
                            case 3:
                                if (!(message.statuses && message.statuses.length))
                                    message.statuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.statuses.push(reader.int32());
                                } else
                                    message.statuses.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListGoalGenerateTargetJobsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsRequest} ListGoalGenerateTargetJobsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListGoalGenerateTargetJobsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListGoalGenerateTargetJobsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListGoalGenerateTargetJobsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        if (message.statuses != null && message.hasOwnProperty("statuses")) {
                            if (!Array.isArray(message.statuses))
                                return "statuses: array expected";
                            for (var i = 0; i < message.statuses.length; ++i)
                                switch (message.statuses[i]) {
                                default:
                                    return "statuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListGoalGenerateTargetJobsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsRequest} ListGoalGenerateTargetJobsRequest
                     */
                    ListGoalGenerateTargetJobsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListGoalGenerateTargetJobsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListGoalGenerateTargetJobsRequest();
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        if (object.statuses) {
                            if (!Array.isArray(object.statuses))
                                throw TypeError(".palexy.streaming.v1.ListGoalGenerateTargetJobsRequest.statuses: array expected");
                            message.statuses = [];
                            for (var i = 0; i < object.statuses.length; ++i)
                                switch (object.statuses[i]) {
                                default:
                                case "UNPROCESSED":
                                case 0:
                                    message.statuses[i] = 0;
                                    break;
                                case "PROCESSING":
                                case 1:
                                    message.statuses[i] = 1;
                                    break;
                                case "WAIT_FOR_RETRYING":
                                case 2:
                                    message.statuses[i] = 2;
                                    break;
                                case "DONE":
                                case 3:
                                    message.statuses[i] = 3;
                                    break;
                                case "CANCELLED":
                                case 4:
                                    message.statuses[i] = 4;
                                    break;
                                case "SKIPPED":
                                case 5:
                                    message.statuses[i] = 5;
                                    break;
                                case "RECURRING":
                                case 6:
                                    message.statuses[i] = 6;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListGoalGenerateTargetJobsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListGoalGenerateTargetJobsRequest} message ListGoalGenerateTargetJobsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListGoalGenerateTargetJobsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.statuses = [];
                        if (options.defaults) {
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.statuses && message.statuses.length) {
                            object.statuses = [];
                            for (var j = 0; j < message.statuses.length; ++j)
                                object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.AsyncJob.Status[message.statuses[j]] : message.statuses[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListGoalGenerateTargetJobsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListGoalGenerateTargetJobsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListGoalGenerateTargetJobsRequest;
                })();
    
                v1.ListGoalGenerateTargetJobsResponse = (function() {
    
                    /**
                     * Properties of a ListGoalGenerateTargetJobsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListGoalGenerateTargetJobsResponse
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobs] ListGoalGenerateTargetJobsResponse asyncJobs
                     */
    
                    /**
                     * Constructs a new ListGoalGenerateTargetJobsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListGoalGenerateTargetJobsResponse.
                     * @implements IListGoalGenerateTargetJobsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsResponse=} [properties] Properties to set
                     */
                    function ListGoalGenerateTargetJobsResponse(properties) {
                        this.asyncJobs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListGoalGenerateTargetJobsResponse asyncJobs.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobs
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @instance
                     */
                    ListGoalGenerateTargetJobsResponse.prototype.asyncJobs = $util.emptyArray;
    
                    /**
                     * Creates a new ListGoalGenerateTargetJobsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} ListGoalGenerateTargetJobsResponse instance
                     */
                    ListGoalGenerateTargetJobsResponse.create = function create(properties) {
                        return new ListGoalGenerateTargetJobsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListGoalGenerateTargetJobsResponse message. Does not implicitly {@link palexy.streaming.v1.ListGoalGenerateTargetJobsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsResponse} message ListGoalGenerateTargetJobsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListGoalGenerateTargetJobsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.asyncJobs != null && message.asyncJobs.length)
                            for (var i = 0; i < message.asyncJobs.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListGoalGenerateTargetJobsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListGoalGenerateTargetJobsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListGoalGenerateTargetJobsResponse} message ListGoalGenerateTargetJobsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListGoalGenerateTargetJobsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListGoalGenerateTargetJobsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} ListGoalGenerateTargetJobsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListGoalGenerateTargetJobsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListGoalGenerateTargetJobsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.asyncJobs && message.asyncJobs.length))
                                    message.asyncJobs = [];
                                message.asyncJobs.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListGoalGenerateTargetJobsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} ListGoalGenerateTargetJobsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListGoalGenerateTargetJobsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListGoalGenerateTargetJobsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListGoalGenerateTargetJobsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.asyncJobs != null && message.hasOwnProperty("asyncJobs")) {
                            if (!Array.isArray(message.asyncJobs))
                                return "asyncJobs: array expected";
                            for (var i = 0; i < message.asyncJobs.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobs[i]);
                                if (error)
                                    return "asyncJobs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListGoalGenerateTargetJobsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} ListGoalGenerateTargetJobsResponse
                     */
                    ListGoalGenerateTargetJobsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListGoalGenerateTargetJobsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListGoalGenerateTargetJobsResponse();
                        if (object.asyncJobs) {
                            if (!Array.isArray(object.asyncJobs))
                                throw TypeError(".palexy.streaming.v1.ListGoalGenerateTargetJobsResponse.asyncJobs: array expected");
                            message.asyncJobs = [];
                            for (var i = 0; i < object.asyncJobs.length; ++i) {
                                if (typeof object.asyncJobs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListGoalGenerateTargetJobsResponse.asyncJobs: object expected");
                                message.asyncJobs[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListGoalGenerateTargetJobsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListGoalGenerateTargetJobsResponse} message ListGoalGenerateTargetJobsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListGoalGenerateTargetJobsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobs = [];
                        if (message.asyncJobs && message.asyncJobs.length) {
                            object.asyncJobs = [];
                            for (var j = 0; j < message.asyncJobs.length; ++j)
                                object.asyncJobs[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListGoalGenerateTargetJobsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListGoalGenerateTargetJobsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListGoalGenerateTargetJobsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListGoalGenerateTargetJobsResponse;
                })();
    
                v1.Company = (function() {
    
                    /**
                     * Properties of a Company.
                     * @memberof palexy.streaming.v1
                     * @interface ICompany
                     * @property {number|null} [id] Company id
                     * @property {string|null} [name] Company name
                     * @property {boolean|null} [transformationMatrixEnabled] Company transformationMatrixEnabled
                     * @property {boolean|null} [logicalLayoutEnabled] Company logicalLayoutEnabled
                     * @property {string|null} [awsBucket] Company awsBucket
                     * @property {string|null} [gcsBucket] Company gcsBucket
                     * @property {string|null} [companyCode] Company companyCode
                     * @property {string|null} [partnerCode] Company partnerCode
                     * @property {string|null} [description] Company description
                     * @property {boolean|null} [entranceCounting] Company entranceCounting
                     * @property {string|null} [entranceKeyword] Company entranceKeyword
                     * @property {string|null} [dwelltimeBuckets] Company dwelltimeBuckets
                     * @property {string|null} [ageRanges] Company ageRanges
                     * @property {number|null} [sectionVisitDurationLimit] Company sectionVisitDurationLimit
                     * @property {boolean|null} [dwelltimeMetricDisabled] Company dwelltimeMetricDisabled
                     * @property {boolean|null} [interactionMetricDisabled] Company interactionMetricDisabled
                     * @property {boolean|null} [transactionMetricDisabled] Company transactionMetricDisabled
                     * @property {boolean|null} [groupMetricEnabled] Company groupMetricEnabled
                     * @property {boolean|null} [lyingMetricEnabled] Company lyingMetricEnabled
                     * @property {boolean|null} [avgDwelltimeMetricDisabled] Company avgDwelltimeMetricDisabled
                     * @property {boolean|null} [layoutViewDisabled] Company layoutViewDisabled
                     * @property {boolean|null} [topSectionsViewDisabled] Company topSectionsViewDisabled
                     * @property {boolean|null} [dailyExport] Company dailyExport
                     * @property {number|null} [lastExportTimeMs] Company lastExportTimeMs
                     * @property {string|null} [exportBucket] Company exportBucket
                     * @property {string|null} [exportNotificationEmails] Company exportNotificationEmails
                     * @property {string|null} [exportNotifyUrl] Company exportNotifyUrl
                     * @property {string|null} [integrationUsername] Company integrationUsername
                     * @property {string|null} [integrationPassword] Company integrationPassword
                     * @property {number|null} [createTimeMs] Company createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Company lastUpdateTimeMs
                     * @property {boolean|null} [interactionLevelMetricEnabled] Company interactionLevelMetricEnabled
                     * @property {boolean|null} [visitorOccupancyMetricEnabled] Company visitorOccupancyMetricEnabled
                     * @property {string|null} [exportStorageProvider] Company exportStorageProvider
                     * @property {string|null} [exportBucketRegion] Company exportBucketRegion
                     * @property {string|null} [exportAccessKey] Company exportAccessKey
                     * @property {string|null} [exportSecretKey] Company exportSecretKey
                     * @property {palexy.streaming.v1.RawIcaStorageProvider|null} [rawIcaStorageProvider] Company rawIcaStorageProvider
                     * @property {string|null} [rawIcaBucketName] Company rawIcaBucketName
                     * @property {boolean|null} [exportPosMatchingResultEnabled] Company exportPosMatchingResultEnabled
                     * @property {boolean|null} [usePosData] Company usePosData
                     * @property {boolean|null} [salesAmountRelatedMetricsEnabled] Company salesAmountRelatedMetricsEnabled
                     * @property {boolean|null} [salesItemsRelatedMetricsEnabled] Company salesItemsRelatedMetricsEnabled
                     * @property {boolean|null} [useNetAmount] Company useNetAmount
                     * @property {boolean|null} [passbyMetricEnabled] Company passbyMetricEnabled
                     * @property {boolean|null} [createMatchingJobOnImportedPosDisabled] Company createMatchingJobOnImportedPosDisabled
                     * @property {string|null} [rawIcaMergingBucketName] Company rawIcaMergingBucketName
                     * @property {string|null} [nearRealTimeProcessingTimesOfDay] Company nearRealTimeProcessingTimesOfDay
                     * @property {boolean|null} [sectionInteractionMetricEnabled] Company sectionInteractionMetricEnabled
                     * @property {boolean|null} [sectionPosMetricEnabled] Company sectionPosMetricEnabled
                     * @property {boolean|null} [visitorDirectionFeatureEnabled] Company visitorDirectionFeatureEnabled
                     * @property {boolean|null} [interactionTimeMetricEnabled] Company interactionTimeMetricEnabled
                     * @property {number|null} [exportRewriteHistoricalStaffingDays] Company exportRewriteHistoricalStaffingDays
                     * @property {boolean|null} [exportOverwriteExistingFiles] Company exportOverwriteExistingFiles
                     * @property {boolean|null} [mfaRequired] Company mfaRequired
                     * @property {palexy.streaming.v1.Company.Industry|null} [industry] Company industry
                     * @property {boolean|null} [useSalesItemsAsNetSalesItems] Company useSalesItemsAsNetSalesItems
                     * @property {boolean|null} [staffPerformanceAnalysisMetricsEnabled] Company staffPerformanceAnalysisMetricsEnabled
                     * @property {boolean|null} [staffPerformanceAnalysisStaffingMetricsEnabled] Company staffPerformanceAnalysisStaffingMetricsEnabled
                     * @property {Array.<palexy.streaming.v1.StoreEventType>|null} [enabledStoreEventTypes] Company enabledStoreEventTypes
                     * @property {boolean|null} [estimatedTrafficMetricsEnabled] Company estimatedTrafficMetricsEnabled
                     * @property {boolean|null} [enableStoreSnapshot] Company enableStoreSnapshot
                     * @property {boolean|null} [enableForecast] Company enableForecast
                     * @property {boolean|null} [enableTargetTrackingForecast] Company enableTargetTrackingForecast
                     * @property {boolean|null} [strictReportConsistencyEnabled] Company strictReportConsistencyEnabled
                     * @property {Array.<string>|null} [storeSnapshotScheduledTimes] Company storeSnapshotScheduledTimes
                     * @property {number|null} [storeOpenTimeBufferInSeconds] Company storeOpenTimeBufferInSeconds
                     * @property {number|null} [storeCloseTimeBufferInSeconds] Company storeCloseTimeBufferInSeconds
                     * @property {number|null} [startOfWeek] Company startOfWeek
                     * @property {Array.<number>|null} [weekends] Company weekends
                     * @property {number|null} [storeSnapshotRetentionDays] Company storeSnapshotRetentionDays
                     * @property {number|null} [onTimeGreetingThresholdSec] Company onTimeGreetingThresholdSec
                     * @property {boolean|null} [productSalesAnalysisEnabled] Company productSalesAnalysisEnabled
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [defaultLandingMetrics] Company defaultLandingMetrics
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [enabledInputTargetMetrics] Company enabledInputTargetMetrics
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [enabledDisplayTargetMetrics] Company enabledDisplayTargetMetrics
                     * @property {Array.<string>|null} [enabledGenerateInsightTypes] Company enabledGenerateInsightTypes
                     * @property {Array.<string>|null} [enabledDisplayInsightTypes] Company enabledDisplayInsightTypes
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [threeWeeksTrendInsightMetrics] Company threeWeeksTrendInsightMetrics
                     * @property {Array.<palexy.streaming.v1.ScheduledTaskType>|null} [excludedScheduledTaskTypes] Company excludedScheduledTaskTypes
                     * @property {string|null} [videoGroupSizeBuckets] Company videoGroupSizeBuckets
                     * @property {Array.<palexy.streaming.v1.ICriticalHoursOfDayOfWeek>|null} [criticalHoursOfDaysOfWeek] Company criticalHoursOfDaysOfWeek
                     * @property {boolean|null} [posStaffSyncEnabled] Company posStaffSyncEnabled
                     * @property {boolean|null} [storeRelationshipEnabled] Company storeRelationshipEnabled
                     * @property {boolean|null} [discountMetricsEnabled] Company discountMetricsEnabled
                     * @property {string|null} [discountDistributionBuckets] Company discountDistributionBuckets
                     * @property {boolean|null} [includeReturningItemsForDiscountAnalysis] Company includeReturningItemsForDiscountAnalysis
                     * @property {number|null} [activityLogCleanUpIntervalInDays] Company activityLogCleanUpIntervalInDays
                     * @property {palexy.streaming.v1.TransactionCalculationMethod|null} [transactionCalculationMethod] Company transactionCalculationMethod
                     * @property {number|null} [staffScheduleDemandCoverageThreshold] Company staffScheduleDemandCoverageThreshold
                     * @property {number|null} [staffScheduleLowerDemandCoverageThreshold] Company staffScheduleLowerDemandCoverageThreshold
                     * @property {string|null} [genderAgeGroupModelName] Company genderAgeGroupModelName
                     * @property {Array.<number>|null} [ageGroupThresholds] Company ageGroupThresholds
                     * @property {boolean|null} [enableFaceBlurring] Company enableFaceBlurring
                     * @property {boolean|null} [enableCopyingChangingRoomActionToCustomAction] Company enableCopyingChangingRoomActionToCustomAction
                     * @property {Object.<string,number>|null} [forecastModelVersionIdByMetric] Company forecastModelVersionIdByMetric
                     * @property {number|null} [maxSessionInactiveIntervalInSeconds] Company maxSessionInactiveIntervalInSeconds
                     * @property {number|null} [rememberMeTokenMaxAgeInSeconds] Company rememberMeTokenMaxAgeInSeconds
                     * @property {string|null} [mainSchedulePerformanceMetric] Company mainSchedulePerformanceMetric
                     * @property {boolean|null} [excludeQueueTimeInTotalServiceTime] Company excludeQueueTimeInTotalServiceTime
                     * @property {number|null} [totalServiceTimeComplianceThreshold] Company totalServiceTimeComplianceThreshold
                     * @property {string|null} [defaultTimezone] Company defaultTimezone
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [dailyInsightMetrics] Company dailyInsightMetrics
                     * @property {string|null} [ibeImageBucket] Company ibeImageBucket
                     * @property {string|null} [checkoutTimeBuckets] Company checkoutTimeBuckets
                     * @property {boolean|null} [enableTaskManagement] Company enableTaskManagement
                     * @property {boolean|null} [enableFormManagement] Company enableFormManagement
                     * @property {boolean|null} [enableStoreOptimizer] Company enableStoreOptimizer
                     * @property {number|null} [forecastBias] Company forecastBias
                     * @property {Array.<number>|null} [sectionForecastMetadataTypeIds] Company sectionForecastMetadataTypeIds
                     * @property {boolean|null} [disabled] Company disabled
                     * @property {palexy.streaming.v1.IAccount|null} [ownerAccount] Company ownerAccount
                     * @property {Array.<string>|null} [storeTimezones] Company storeTimezones
                     * @property {palexy.streaming.v1.IBlurringVideoConfig|null} [blurringVideoConfig] Company blurringVideoConfig
                     */
    
                    /**
                     * Constructs a new Company.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Company.
                     * @implements ICompany
                     * @constructor
                     * @param {palexy.streaming.v1.ICompany=} [properties] Properties to set
                     */
                    function Company(properties) {
                        this.enabledStoreEventTypes = [];
                        this.storeSnapshotScheduledTimes = [];
                        this.weekends = [];
                        this.defaultLandingMetrics = [];
                        this.enabledInputTargetMetrics = [];
                        this.enabledDisplayTargetMetrics = [];
                        this.enabledGenerateInsightTypes = [];
                        this.enabledDisplayInsightTypes = [];
                        this.threeWeeksTrendInsightMetrics = [];
                        this.excludedScheduledTaskTypes = [];
                        this.criticalHoursOfDaysOfWeek = [];
                        this.ageGroupThresholds = [];
                        this.forecastModelVersionIdByMetric = {};
                        this.dailyInsightMetrics = [];
                        this.sectionForecastMetadataTypeIds = [];
                        this.storeTimezones = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Company id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Company name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.name = "";
    
                    /**
                     * Company transformationMatrixEnabled.
                     * @member {boolean} transformationMatrixEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.transformationMatrixEnabled = false;
    
                    /**
                     * Company logicalLayoutEnabled.
                     * @member {boolean} logicalLayoutEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.logicalLayoutEnabled = false;
    
                    /**
                     * Company awsBucket.
                     * @member {string} awsBucket
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.awsBucket = "";
    
                    /**
                     * Company gcsBucket.
                     * @member {string} gcsBucket
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.gcsBucket = "";
    
                    /**
                     * Company companyCode.
                     * @member {string} companyCode
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.companyCode = "";
    
                    /**
                     * Company partnerCode.
                     * @member {string} partnerCode
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.partnerCode = "";
    
                    /**
                     * Company description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.description = "";
    
                    /**
                     * Company entranceCounting.
                     * @member {boolean} entranceCounting
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.entranceCounting = false;
    
                    /**
                     * Company entranceKeyword.
                     * @member {string} entranceKeyword
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.entranceKeyword = "";
    
                    /**
                     * Company dwelltimeBuckets.
                     * @member {string} dwelltimeBuckets
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.dwelltimeBuckets = "";
    
                    /**
                     * Company ageRanges.
                     * @member {string} ageRanges
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.ageRanges = "";
    
                    /**
                     * Company sectionVisitDurationLimit.
                     * @member {number} sectionVisitDurationLimit
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.sectionVisitDurationLimit = 0;
    
                    /**
                     * Company dwelltimeMetricDisabled.
                     * @member {boolean} dwelltimeMetricDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.dwelltimeMetricDisabled = false;
    
                    /**
                     * Company interactionMetricDisabled.
                     * @member {boolean} interactionMetricDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.interactionMetricDisabled = false;
    
                    /**
                     * Company transactionMetricDisabled.
                     * @member {boolean} transactionMetricDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.transactionMetricDisabled = false;
    
                    /**
                     * Company groupMetricEnabled.
                     * @member {boolean} groupMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.groupMetricEnabled = false;
    
                    /**
                     * Company lyingMetricEnabled.
                     * @member {boolean} lyingMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.lyingMetricEnabled = false;
    
                    /**
                     * Company avgDwelltimeMetricDisabled.
                     * @member {boolean} avgDwelltimeMetricDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.avgDwelltimeMetricDisabled = false;
    
                    /**
                     * Company layoutViewDisabled.
                     * @member {boolean} layoutViewDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.layoutViewDisabled = false;
    
                    /**
                     * Company topSectionsViewDisabled.
                     * @member {boolean} topSectionsViewDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.topSectionsViewDisabled = false;
    
                    /**
                     * Company dailyExport.
                     * @member {boolean} dailyExport
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.dailyExport = false;
    
                    /**
                     * Company lastExportTimeMs.
                     * @member {number} lastExportTimeMs
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.lastExportTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Company exportBucket.
                     * @member {string} exportBucket
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportBucket = "";
    
                    /**
                     * Company exportNotificationEmails.
                     * @member {string} exportNotificationEmails
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportNotificationEmails = "";
    
                    /**
                     * Company exportNotifyUrl.
                     * @member {string} exportNotifyUrl
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportNotifyUrl = "";
    
                    /**
                     * Company integrationUsername.
                     * @member {string} integrationUsername
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.integrationUsername = "";
    
                    /**
                     * Company integrationPassword.
                     * @member {string} integrationPassword
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.integrationPassword = "";
    
                    /**
                     * Company createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Company lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Company interactionLevelMetricEnabled.
                     * @member {boolean} interactionLevelMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.interactionLevelMetricEnabled = false;
    
                    /**
                     * Company visitorOccupancyMetricEnabled.
                     * @member {boolean} visitorOccupancyMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.visitorOccupancyMetricEnabled = false;
    
                    /**
                     * Company exportStorageProvider.
                     * @member {string} exportStorageProvider
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportStorageProvider = "";
    
                    /**
                     * Company exportBucketRegion.
                     * @member {string} exportBucketRegion
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportBucketRegion = "";
    
                    /**
                     * Company exportAccessKey.
                     * @member {string} exportAccessKey
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportAccessKey = "";
    
                    /**
                     * Company exportSecretKey.
                     * @member {string} exportSecretKey
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportSecretKey = "";
    
                    /**
                     * Company rawIcaStorageProvider.
                     * @member {palexy.streaming.v1.RawIcaStorageProvider} rawIcaStorageProvider
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.rawIcaStorageProvider = 0;
    
                    /**
                     * Company rawIcaBucketName.
                     * @member {string} rawIcaBucketName
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.rawIcaBucketName = "";
    
                    /**
                     * Company exportPosMatchingResultEnabled.
                     * @member {boolean} exportPosMatchingResultEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportPosMatchingResultEnabled = false;
    
                    /**
                     * Company usePosData.
                     * @member {boolean} usePosData
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.usePosData = false;
    
                    /**
                     * Company salesAmountRelatedMetricsEnabled.
                     * @member {boolean} salesAmountRelatedMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.salesAmountRelatedMetricsEnabled = false;
    
                    /**
                     * Company salesItemsRelatedMetricsEnabled.
                     * @member {boolean} salesItemsRelatedMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.salesItemsRelatedMetricsEnabled = false;
    
                    /**
                     * Company useNetAmount.
                     * @member {boolean} useNetAmount
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.useNetAmount = false;
    
                    /**
                     * Company passbyMetricEnabled.
                     * @member {boolean} passbyMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.passbyMetricEnabled = false;
    
                    /**
                     * Company createMatchingJobOnImportedPosDisabled.
                     * @member {boolean} createMatchingJobOnImportedPosDisabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.createMatchingJobOnImportedPosDisabled = false;
    
                    /**
                     * Company rawIcaMergingBucketName.
                     * @member {string} rawIcaMergingBucketName
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.rawIcaMergingBucketName = "";
    
                    /**
                     * Company nearRealTimeProcessingTimesOfDay.
                     * @member {string} nearRealTimeProcessingTimesOfDay
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.nearRealTimeProcessingTimesOfDay = "";
    
                    /**
                     * Company sectionInteractionMetricEnabled.
                     * @member {boolean} sectionInteractionMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.sectionInteractionMetricEnabled = false;
    
                    /**
                     * Company sectionPosMetricEnabled.
                     * @member {boolean} sectionPosMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.sectionPosMetricEnabled = false;
    
                    /**
                     * Company visitorDirectionFeatureEnabled.
                     * @member {boolean} visitorDirectionFeatureEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.visitorDirectionFeatureEnabled = false;
    
                    /**
                     * Company interactionTimeMetricEnabled.
                     * @member {boolean} interactionTimeMetricEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.interactionTimeMetricEnabled = false;
    
                    /**
                     * Company exportRewriteHistoricalStaffingDays.
                     * @member {number} exportRewriteHistoricalStaffingDays
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportRewriteHistoricalStaffingDays = 0;
    
                    /**
                     * Company exportOverwriteExistingFiles.
                     * @member {boolean} exportOverwriteExistingFiles
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.exportOverwriteExistingFiles = false;
    
                    /**
                     * Company mfaRequired.
                     * @member {boolean} mfaRequired
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.mfaRequired = false;
    
                    /**
                     * Company industry.
                     * @member {palexy.streaming.v1.Company.Industry} industry
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.industry = 0;
    
                    /**
                     * Company useSalesItemsAsNetSalesItems.
                     * @member {boolean} useSalesItemsAsNetSalesItems
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.useSalesItemsAsNetSalesItems = false;
    
                    /**
                     * Company staffPerformanceAnalysisMetricsEnabled.
                     * @member {boolean} staffPerformanceAnalysisMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.staffPerformanceAnalysisMetricsEnabled = false;
    
                    /**
                     * Company staffPerformanceAnalysisStaffingMetricsEnabled.
                     * @member {boolean} staffPerformanceAnalysisStaffingMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.staffPerformanceAnalysisStaffingMetricsEnabled = false;
    
                    /**
                     * Company enabledStoreEventTypes.
                     * @member {Array.<palexy.streaming.v1.StoreEventType>} enabledStoreEventTypes
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enabledStoreEventTypes = $util.emptyArray;
    
                    /**
                     * Company estimatedTrafficMetricsEnabled.
                     * @member {boolean} estimatedTrafficMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.estimatedTrafficMetricsEnabled = false;
    
                    /**
                     * Company enableStoreSnapshot.
                     * @member {boolean} enableStoreSnapshot
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableStoreSnapshot = false;
    
                    /**
                     * Company enableForecast.
                     * @member {boolean} enableForecast
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableForecast = false;
    
                    /**
                     * Company enableTargetTrackingForecast.
                     * @member {boolean} enableTargetTrackingForecast
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableTargetTrackingForecast = false;
    
                    /**
                     * Company strictReportConsistencyEnabled.
                     * @member {boolean} strictReportConsistencyEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.strictReportConsistencyEnabled = false;
    
                    /**
                     * Company storeSnapshotScheduledTimes.
                     * @member {Array.<string>} storeSnapshotScheduledTimes
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeSnapshotScheduledTimes = $util.emptyArray;
    
                    /**
                     * Company storeOpenTimeBufferInSeconds.
                     * @member {number} storeOpenTimeBufferInSeconds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeOpenTimeBufferInSeconds = 0;
    
                    /**
                     * Company storeCloseTimeBufferInSeconds.
                     * @member {number} storeCloseTimeBufferInSeconds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeCloseTimeBufferInSeconds = 0;
    
                    /**
                     * Company startOfWeek.
                     * @member {number} startOfWeek
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.startOfWeek = 0;
    
                    /**
                     * Company weekends.
                     * @member {Array.<number>} weekends
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.weekends = $util.emptyArray;
    
                    /**
                     * Company storeSnapshotRetentionDays.
                     * @member {number} storeSnapshotRetentionDays
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeSnapshotRetentionDays = 0;
    
                    /**
                     * Company onTimeGreetingThresholdSec.
                     * @member {number} onTimeGreetingThresholdSec
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.onTimeGreetingThresholdSec = 0;
    
                    /**
                     * Company productSalesAnalysisEnabled.
                     * @member {boolean} productSalesAnalysisEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.productSalesAnalysisEnabled = false;
    
                    /**
                     * Company defaultLandingMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} defaultLandingMetrics
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.defaultLandingMetrics = $util.emptyArray;
    
                    /**
                     * Company enabledInputTargetMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} enabledInputTargetMetrics
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enabledInputTargetMetrics = $util.emptyArray;
    
                    /**
                     * Company enabledDisplayTargetMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} enabledDisplayTargetMetrics
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enabledDisplayTargetMetrics = $util.emptyArray;
    
                    /**
                     * Company enabledGenerateInsightTypes.
                     * @member {Array.<string>} enabledGenerateInsightTypes
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enabledGenerateInsightTypes = $util.emptyArray;
    
                    /**
                     * Company enabledDisplayInsightTypes.
                     * @member {Array.<string>} enabledDisplayInsightTypes
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enabledDisplayInsightTypes = $util.emptyArray;
    
                    /**
                     * Company threeWeeksTrendInsightMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} threeWeeksTrendInsightMetrics
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.threeWeeksTrendInsightMetrics = $util.emptyArray;
    
                    /**
                     * Company excludedScheduledTaskTypes.
                     * @member {Array.<palexy.streaming.v1.ScheduledTaskType>} excludedScheduledTaskTypes
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.excludedScheduledTaskTypes = $util.emptyArray;
    
                    /**
                     * Company videoGroupSizeBuckets.
                     * @member {string} videoGroupSizeBuckets
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.videoGroupSizeBuckets = "";
    
                    /**
                     * Company criticalHoursOfDaysOfWeek.
                     * @member {Array.<palexy.streaming.v1.ICriticalHoursOfDayOfWeek>} criticalHoursOfDaysOfWeek
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.criticalHoursOfDaysOfWeek = $util.emptyArray;
    
                    /**
                     * Company posStaffSyncEnabled.
                     * @member {boolean} posStaffSyncEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.posStaffSyncEnabled = false;
    
                    /**
                     * Company storeRelationshipEnabled.
                     * @member {boolean} storeRelationshipEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeRelationshipEnabled = false;
    
                    /**
                     * Company discountMetricsEnabled.
                     * @member {boolean} discountMetricsEnabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.discountMetricsEnabled = false;
    
                    /**
                     * Company discountDistributionBuckets.
                     * @member {string} discountDistributionBuckets
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.discountDistributionBuckets = "";
    
                    /**
                     * Company includeReturningItemsForDiscountAnalysis.
                     * @member {boolean} includeReturningItemsForDiscountAnalysis
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.includeReturningItemsForDiscountAnalysis = false;
    
                    /**
                     * Company activityLogCleanUpIntervalInDays.
                     * @member {number} activityLogCleanUpIntervalInDays
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.activityLogCleanUpIntervalInDays = 0;
    
                    /**
                     * Company transactionCalculationMethod.
                     * @member {palexy.streaming.v1.TransactionCalculationMethod} transactionCalculationMethod
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.transactionCalculationMethod = 0;
    
                    /**
                     * Company staffScheduleDemandCoverageThreshold.
                     * @member {number} staffScheduleDemandCoverageThreshold
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.staffScheduleDemandCoverageThreshold = 0;
    
                    /**
                     * Company staffScheduleLowerDemandCoverageThreshold.
                     * @member {number} staffScheduleLowerDemandCoverageThreshold
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.staffScheduleLowerDemandCoverageThreshold = 0;
    
                    /**
                     * Company genderAgeGroupModelName.
                     * @member {string} genderAgeGroupModelName
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.genderAgeGroupModelName = "";
    
                    /**
                     * Company ageGroupThresholds.
                     * @member {Array.<number>} ageGroupThresholds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.ageGroupThresholds = $util.emptyArray;
    
                    /**
                     * Company enableFaceBlurring.
                     * @member {boolean} enableFaceBlurring
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableFaceBlurring = false;
    
                    /**
                     * Company enableCopyingChangingRoomActionToCustomAction.
                     * @member {boolean} enableCopyingChangingRoomActionToCustomAction
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableCopyingChangingRoomActionToCustomAction = false;
    
                    /**
                     * Company forecastModelVersionIdByMetric.
                     * @member {Object.<string,number>} forecastModelVersionIdByMetric
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.forecastModelVersionIdByMetric = $util.emptyObject;
    
                    /**
                     * Company maxSessionInactiveIntervalInSeconds.
                     * @member {number} maxSessionInactiveIntervalInSeconds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.maxSessionInactiveIntervalInSeconds = 0;
    
                    /**
                     * Company rememberMeTokenMaxAgeInSeconds.
                     * @member {number} rememberMeTokenMaxAgeInSeconds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.rememberMeTokenMaxAgeInSeconds = 0;
    
                    /**
                     * Company mainSchedulePerformanceMetric.
                     * @member {string} mainSchedulePerformanceMetric
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.mainSchedulePerformanceMetric = "";
    
                    /**
                     * Company excludeQueueTimeInTotalServiceTime.
                     * @member {boolean} excludeQueueTimeInTotalServiceTime
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.excludeQueueTimeInTotalServiceTime = false;
    
                    /**
                     * Company totalServiceTimeComplianceThreshold.
                     * @member {number} totalServiceTimeComplianceThreshold
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.totalServiceTimeComplianceThreshold = 0;
    
                    /**
                     * Company defaultTimezone.
                     * @member {string} defaultTimezone
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.defaultTimezone = "";
    
                    /**
                     * Company dailyInsightMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} dailyInsightMetrics
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.dailyInsightMetrics = $util.emptyArray;
    
                    /**
                     * Company ibeImageBucket.
                     * @member {string} ibeImageBucket
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.ibeImageBucket = "";
    
                    /**
                     * Company checkoutTimeBuckets.
                     * @member {string} checkoutTimeBuckets
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.checkoutTimeBuckets = "";
    
                    /**
                     * Company enableTaskManagement.
                     * @member {boolean} enableTaskManagement
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableTaskManagement = false;
    
                    /**
                     * Company enableFormManagement.
                     * @member {boolean} enableFormManagement
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableFormManagement = false;
    
                    /**
                     * Company enableStoreOptimizer.
                     * @member {boolean} enableStoreOptimizer
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.enableStoreOptimizer = false;
    
                    /**
                     * Company forecastBias.
                     * @member {number} forecastBias
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.forecastBias = 0;
    
                    /**
                     * Company sectionForecastMetadataTypeIds.
                     * @member {Array.<number>} sectionForecastMetadataTypeIds
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.sectionForecastMetadataTypeIds = $util.emptyArray;
    
                    /**
                     * Company disabled.
                     * @member {boolean} disabled
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.disabled = false;
    
                    /**
                     * Company ownerAccount.
                     * @member {palexy.streaming.v1.IAccount|null|undefined} ownerAccount
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.ownerAccount = null;
    
                    /**
                     * Company storeTimezones.
                     * @member {Array.<string>} storeTimezones
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.storeTimezones = $util.emptyArray;
    
                    /**
                     * Company blurringVideoConfig.
                     * @member {palexy.streaming.v1.IBlurringVideoConfig|null|undefined} blurringVideoConfig
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Company.prototype.blurringVideoConfig = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * Company _blurringVideoConfig.
                     * @member {"blurringVideoConfig"|undefined} _blurringVideoConfig
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     */
                    Object.defineProperty(Company.prototype, "_blurringVideoConfig", {
                        get: $util.oneOfGetter($oneOfFields = ["blurringVideoConfig"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new Company instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {palexy.streaming.v1.ICompany=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Company} Company instance
                     */
                    Company.create = function create(properties) {
                        return new Company(properties);
                    };
    
                    /**
                     * Encodes the specified Company message. Does not implicitly {@link palexy.streaming.v1.Company.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {palexy.streaming.v1.ICompany} message Company message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Company.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.transformationMatrixEnabled != null && Object.hasOwnProperty.call(message, "transformationMatrixEnabled"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.transformationMatrixEnabled);
                        if (message.logicalLayoutEnabled != null && Object.hasOwnProperty.call(message, "logicalLayoutEnabled"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.logicalLayoutEnabled);
                        if (message.awsBucket != null && Object.hasOwnProperty.call(message, "awsBucket"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.awsBucket);
                        if (message.gcsBucket != null && Object.hasOwnProperty.call(message, "gcsBucket"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.gcsBucket);
                        if (message.companyCode != null && Object.hasOwnProperty.call(message, "companyCode"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.companyCode);
                        if (message.partnerCode != null && Object.hasOwnProperty.call(message, "partnerCode"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.partnerCode);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.description);
                        if (message.entranceCounting != null && Object.hasOwnProperty.call(message, "entranceCounting"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.entranceCounting);
                        if (message.entranceKeyword != null && Object.hasOwnProperty.call(message, "entranceKeyword"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.entranceKeyword);
                        if (message.dwelltimeBuckets != null && Object.hasOwnProperty.call(message, "dwelltimeBuckets"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.dwelltimeBuckets);
                        if (message.ageRanges != null && Object.hasOwnProperty.call(message, "ageRanges"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.ageRanges);
                        if (message.sectionVisitDurationLimit != null && Object.hasOwnProperty.call(message, "sectionVisitDurationLimit"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.sectionVisitDurationLimit);
                        if (message.dwelltimeMetricDisabled != null && Object.hasOwnProperty.call(message, "dwelltimeMetricDisabled"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.dwelltimeMetricDisabled);
                        if (message.interactionMetricDisabled != null && Object.hasOwnProperty.call(message, "interactionMetricDisabled"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.interactionMetricDisabled);
                        if (message.transactionMetricDisabled != null && Object.hasOwnProperty.call(message, "transactionMetricDisabled"))
                            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.transactionMetricDisabled);
                        if (message.groupMetricEnabled != null && Object.hasOwnProperty.call(message, "groupMetricEnabled"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.groupMetricEnabled);
                        if (message.lyingMetricEnabled != null && Object.hasOwnProperty.call(message, "lyingMetricEnabled"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.lyingMetricEnabled);
                        if (message.avgDwelltimeMetricDisabled != null && Object.hasOwnProperty.call(message, "avgDwelltimeMetricDisabled"))
                            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.avgDwelltimeMetricDisabled);
                        if (message.layoutViewDisabled != null && Object.hasOwnProperty.call(message, "layoutViewDisabled"))
                            writer.uint32(/* id 21, wireType 0 =*/168).bool(message.layoutViewDisabled);
                        if (message.topSectionsViewDisabled != null && Object.hasOwnProperty.call(message, "topSectionsViewDisabled"))
                            writer.uint32(/* id 22, wireType 0 =*/176).bool(message.topSectionsViewDisabled);
                        if (message.dailyExport != null && Object.hasOwnProperty.call(message, "dailyExport"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.dailyExport);
                        if (message.lastExportTimeMs != null && Object.hasOwnProperty.call(message, "lastExportTimeMs"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int64(message.lastExportTimeMs);
                        if (message.exportBucket != null && Object.hasOwnProperty.call(message, "exportBucket"))
                            writer.uint32(/* id 25, wireType 2 =*/202).string(message.exportBucket);
                        if (message.exportNotificationEmails != null && Object.hasOwnProperty.call(message, "exportNotificationEmails"))
                            writer.uint32(/* id 26, wireType 2 =*/210).string(message.exportNotificationEmails);
                        if (message.exportNotifyUrl != null && Object.hasOwnProperty.call(message, "exportNotifyUrl"))
                            writer.uint32(/* id 27, wireType 2 =*/218).string(message.exportNotifyUrl);
                        if (message.integrationUsername != null && Object.hasOwnProperty.call(message, "integrationUsername"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.integrationUsername);
                        if (message.rawIcaBucketName != null && Object.hasOwnProperty.call(message, "rawIcaBucketName"))
                            writer.uint32(/* id 29, wireType 2 =*/234).string(message.rawIcaBucketName);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 30, wireType 0 =*/240).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 31, wireType 0 =*/248).int64(message.lastUpdateTimeMs);
                        if (message.interactionLevelMetricEnabled != null && Object.hasOwnProperty.call(message, "interactionLevelMetricEnabled"))
                            writer.uint32(/* id 32, wireType 0 =*/256).bool(message.interactionLevelMetricEnabled);
                        if (message.visitorOccupancyMetricEnabled != null && Object.hasOwnProperty.call(message, "visitorOccupancyMetricEnabled"))
                            writer.uint32(/* id 33, wireType 0 =*/264).bool(message.visitorOccupancyMetricEnabled);
                        if (message.exportStorageProvider != null && Object.hasOwnProperty.call(message, "exportStorageProvider"))
                            writer.uint32(/* id 34, wireType 2 =*/274).string(message.exportStorageProvider);
                        if (message.exportBucketRegion != null && Object.hasOwnProperty.call(message, "exportBucketRegion"))
                            writer.uint32(/* id 35, wireType 2 =*/282).string(message.exportBucketRegion);
                        if (message.exportAccessKey != null && Object.hasOwnProperty.call(message, "exportAccessKey"))
                            writer.uint32(/* id 36, wireType 2 =*/290).string(message.exportAccessKey);
                        if (message.exportSecretKey != null && Object.hasOwnProperty.call(message, "exportSecretKey"))
                            writer.uint32(/* id 37, wireType 2 =*/298).string(message.exportSecretKey);
                        if (message.rawIcaStorageProvider != null && Object.hasOwnProperty.call(message, "rawIcaStorageProvider"))
                            writer.uint32(/* id 38, wireType 0 =*/304).int32(message.rawIcaStorageProvider);
                        if (message.integrationPassword != null && Object.hasOwnProperty.call(message, "integrationPassword"))
                            writer.uint32(/* id 39, wireType 2 =*/314).string(message.integrationPassword);
                        if (message.exportPosMatchingResultEnabled != null && Object.hasOwnProperty.call(message, "exportPosMatchingResultEnabled"))
                            writer.uint32(/* id 40, wireType 0 =*/320).bool(message.exportPosMatchingResultEnabled);
                        if (message.usePosData != null && Object.hasOwnProperty.call(message, "usePosData"))
                            writer.uint32(/* id 41, wireType 0 =*/328).bool(message.usePosData);
                        if (message.salesAmountRelatedMetricsEnabled != null && Object.hasOwnProperty.call(message, "salesAmountRelatedMetricsEnabled"))
                            writer.uint32(/* id 42, wireType 0 =*/336).bool(message.salesAmountRelatedMetricsEnabled);
                        if (message.salesItemsRelatedMetricsEnabled != null && Object.hasOwnProperty.call(message, "salesItemsRelatedMetricsEnabled"))
                            writer.uint32(/* id 43, wireType 0 =*/344).bool(message.salesItemsRelatedMetricsEnabled);
                        if (message.useNetAmount != null && Object.hasOwnProperty.call(message, "useNetAmount"))
                            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.useNetAmount);
                        if (message.passbyMetricEnabled != null && Object.hasOwnProperty.call(message, "passbyMetricEnabled"))
                            writer.uint32(/* id 45, wireType 0 =*/360).bool(message.passbyMetricEnabled);
                        if (message.createMatchingJobOnImportedPosDisabled != null && Object.hasOwnProperty.call(message, "createMatchingJobOnImportedPosDisabled"))
                            writer.uint32(/* id 46, wireType 0 =*/368).bool(message.createMatchingJobOnImportedPosDisabled);
                        if (message.rawIcaMergingBucketName != null && Object.hasOwnProperty.call(message, "rawIcaMergingBucketName"))
                            writer.uint32(/* id 47, wireType 2 =*/378).string(message.rawIcaMergingBucketName);
                        if (message.nearRealTimeProcessingTimesOfDay != null && Object.hasOwnProperty.call(message, "nearRealTimeProcessingTimesOfDay"))
                            writer.uint32(/* id 48, wireType 2 =*/386).string(message.nearRealTimeProcessingTimesOfDay);
                        if (message.sectionInteractionMetricEnabled != null && Object.hasOwnProperty.call(message, "sectionInteractionMetricEnabled"))
                            writer.uint32(/* id 49, wireType 0 =*/392).bool(message.sectionInteractionMetricEnabled);
                        if (message.sectionPosMetricEnabled != null && Object.hasOwnProperty.call(message, "sectionPosMetricEnabled"))
                            writer.uint32(/* id 50, wireType 0 =*/400).bool(message.sectionPosMetricEnabled);
                        if (message.visitorDirectionFeatureEnabled != null && Object.hasOwnProperty.call(message, "visitorDirectionFeatureEnabled"))
                            writer.uint32(/* id 51, wireType 0 =*/408).bool(message.visitorDirectionFeatureEnabled);
                        if (message.interactionTimeMetricEnabled != null && Object.hasOwnProperty.call(message, "interactionTimeMetricEnabled"))
                            writer.uint32(/* id 52, wireType 0 =*/416).bool(message.interactionTimeMetricEnabled);
                        if (message.exportRewriteHistoricalStaffingDays != null && Object.hasOwnProperty.call(message, "exportRewriteHistoricalStaffingDays"))
                            writer.uint32(/* id 53, wireType 0 =*/424).int32(message.exportRewriteHistoricalStaffingDays);
                        if (message.exportOverwriteExistingFiles != null && Object.hasOwnProperty.call(message, "exportOverwriteExistingFiles"))
                            writer.uint32(/* id 54, wireType 0 =*/432).bool(message.exportOverwriteExistingFiles);
                        if (message.mfaRequired != null && Object.hasOwnProperty.call(message, "mfaRequired"))
                            writer.uint32(/* id 55, wireType 0 =*/440).bool(message.mfaRequired);
                        if (message.industry != null && Object.hasOwnProperty.call(message, "industry"))
                            writer.uint32(/* id 56, wireType 0 =*/448).int32(message.industry);
                        if (message.useSalesItemsAsNetSalesItems != null && Object.hasOwnProperty.call(message, "useSalesItemsAsNetSalesItems"))
                            writer.uint32(/* id 58, wireType 0 =*/464).bool(message.useSalesItemsAsNetSalesItems);
                        if (message.staffPerformanceAnalysisMetricsEnabled != null && Object.hasOwnProperty.call(message, "staffPerformanceAnalysisMetricsEnabled"))
                            writer.uint32(/* id 59, wireType 0 =*/472).bool(message.staffPerformanceAnalysisMetricsEnabled);
                        if (message.staffPerformanceAnalysisStaffingMetricsEnabled != null && Object.hasOwnProperty.call(message, "staffPerformanceAnalysisStaffingMetricsEnabled"))
                            writer.uint32(/* id 60, wireType 0 =*/480).bool(message.staffPerformanceAnalysisStaffingMetricsEnabled);
                        if (message.enabledStoreEventTypes != null && message.enabledStoreEventTypes.length) {
                            writer.uint32(/* id 61, wireType 2 =*/490).fork();
                            for (var i = 0; i < message.enabledStoreEventTypes.length; ++i)
                                writer.int32(message.enabledStoreEventTypes[i]);
                            writer.ldelim();
                        }
                        if (message.estimatedTrafficMetricsEnabled != null && Object.hasOwnProperty.call(message, "estimatedTrafficMetricsEnabled"))
                            writer.uint32(/* id 62, wireType 0 =*/496).bool(message.estimatedTrafficMetricsEnabled);
                        if (message.enableStoreSnapshot != null && Object.hasOwnProperty.call(message, "enableStoreSnapshot"))
                            writer.uint32(/* id 63, wireType 0 =*/504).bool(message.enableStoreSnapshot);
                        if (message.enableForecast != null && Object.hasOwnProperty.call(message, "enableForecast"))
                            writer.uint32(/* id 64, wireType 0 =*/512).bool(message.enableForecast);
                        if (message.enableTargetTrackingForecast != null && Object.hasOwnProperty.call(message, "enableTargetTrackingForecast"))
                            writer.uint32(/* id 65, wireType 0 =*/520).bool(message.enableTargetTrackingForecast);
                        if (message.strictReportConsistencyEnabled != null && Object.hasOwnProperty.call(message, "strictReportConsistencyEnabled"))
                            writer.uint32(/* id 66, wireType 0 =*/528).bool(message.strictReportConsistencyEnabled);
                        if (message.storeSnapshotScheduledTimes != null && message.storeSnapshotScheduledTimes.length)
                            for (var i = 0; i < message.storeSnapshotScheduledTimes.length; ++i)
                                writer.uint32(/* id 67, wireType 2 =*/538).string(message.storeSnapshotScheduledTimes[i]);
                        if (message.storeOpenTimeBufferInSeconds != null && Object.hasOwnProperty.call(message, "storeOpenTimeBufferInSeconds"))
                            writer.uint32(/* id 68, wireType 0 =*/544).int32(message.storeOpenTimeBufferInSeconds);
                        if (message.storeCloseTimeBufferInSeconds != null && Object.hasOwnProperty.call(message, "storeCloseTimeBufferInSeconds"))
                            writer.uint32(/* id 69, wireType 0 =*/552).int32(message.storeCloseTimeBufferInSeconds);
                        if (message.startOfWeek != null && Object.hasOwnProperty.call(message, "startOfWeek"))
                            writer.uint32(/* id 70, wireType 0 =*/560).int32(message.startOfWeek);
                        if (message.weekends != null && message.weekends.length) {
                            writer.uint32(/* id 71, wireType 2 =*/570).fork();
                            for (var i = 0; i < message.weekends.length; ++i)
                                writer.int32(message.weekends[i]);
                            writer.ldelim();
                        }
                        if (message.storeSnapshotRetentionDays != null && Object.hasOwnProperty.call(message, "storeSnapshotRetentionDays"))
                            writer.uint32(/* id 72, wireType 0 =*/576).int32(message.storeSnapshotRetentionDays);
                        if (message.onTimeGreetingThresholdSec != null && Object.hasOwnProperty.call(message, "onTimeGreetingThresholdSec"))
                            writer.uint32(/* id 73, wireType 0 =*/584).int32(message.onTimeGreetingThresholdSec);
                        if (message.productSalesAnalysisEnabled != null && Object.hasOwnProperty.call(message, "productSalesAnalysisEnabled"))
                            writer.uint32(/* id 74, wireType 0 =*/592).bool(message.productSalesAnalysisEnabled);
                        if (message.defaultLandingMetrics != null && message.defaultLandingMetrics.length) {
                            writer.uint32(/* id 75, wireType 2 =*/602).fork();
                            for (var i = 0; i < message.defaultLandingMetrics.length; ++i)
                                writer.int32(message.defaultLandingMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.enabledInputTargetMetrics != null && message.enabledInputTargetMetrics.length) {
                            writer.uint32(/* id 76, wireType 2 =*/610).fork();
                            for (var i = 0; i < message.enabledInputTargetMetrics.length; ++i)
                                writer.int32(message.enabledInputTargetMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.enabledDisplayTargetMetrics != null && message.enabledDisplayTargetMetrics.length) {
                            writer.uint32(/* id 77, wireType 2 =*/618).fork();
                            for (var i = 0; i < message.enabledDisplayTargetMetrics.length; ++i)
                                writer.int32(message.enabledDisplayTargetMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.enabledGenerateInsightTypes != null && message.enabledGenerateInsightTypes.length)
                            for (var i = 0; i < message.enabledGenerateInsightTypes.length; ++i)
                                writer.uint32(/* id 78, wireType 2 =*/626).string(message.enabledGenerateInsightTypes[i]);
                        if (message.enabledDisplayInsightTypes != null && message.enabledDisplayInsightTypes.length)
                            for (var i = 0; i < message.enabledDisplayInsightTypes.length; ++i)
                                writer.uint32(/* id 79, wireType 2 =*/634).string(message.enabledDisplayInsightTypes[i]);
                        if (message.threeWeeksTrendInsightMetrics != null && message.threeWeeksTrendInsightMetrics.length) {
                            writer.uint32(/* id 80, wireType 2 =*/642).fork();
                            for (var i = 0; i < message.threeWeeksTrendInsightMetrics.length; ++i)
                                writer.int32(message.threeWeeksTrendInsightMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.excludedScheduledTaskTypes != null && message.excludedScheduledTaskTypes.length) {
                            writer.uint32(/* id 81, wireType 2 =*/650).fork();
                            for (var i = 0; i < message.excludedScheduledTaskTypes.length; ++i)
                                writer.int32(message.excludedScheduledTaskTypes[i]);
                            writer.ldelim();
                        }
                        if (message.videoGroupSizeBuckets != null && Object.hasOwnProperty.call(message, "videoGroupSizeBuckets"))
                            writer.uint32(/* id 82, wireType 2 =*/658).string(message.videoGroupSizeBuckets);
                        if (message.criticalHoursOfDaysOfWeek != null && message.criticalHoursOfDaysOfWeek.length)
                            for (var i = 0; i < message.criticalHoursOfDaysOfWeek.length; ++i)
                                $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek.encode(message.criticalHoursOfDaysOfWeek[i], writer.uint32(/* id 83, wireType 2 =*/666).fork()).ldelim();
                        if (message.posStaffSyncEnabled != null && Object.hasOwnProperty.call(message, "posStaffSyncEnabled"))
                            writer.uint32(/* id 84, wireType 0 =*/672).bool(message.posStaffSyncEnabled);
                        if (message.storeRelationshipEnabled != null && Object.hasOwnProperty.call(message, "storeRelationshipEnabled"))
                            writer.uint32(/* id 85, wireType 0 =*/680).bool(message.storeRelationshipEnabled);
                        if (message.discountMetricsEnabled != null && Object.hasOwnProperty.call(message, "discountMetricsEnabled"))
                            writer.uint32(/* id 86, wireType 0 =*/688).bool(message.discountMetricsEnabled);
                        if (message.discountDistributionBuckets != null && Object.hasOwnProperty.call(message, "discountDistributionBuckets"))
                            writer.uint32(/* id 87, wireType 2 =*/698).string(message.discountDistributionBuckets);
                        if (message.includeReturningItemsForDiscountAnalysis != null && Object.hasOwnProperty.call(message, "includeReturningItemsForDiscountAnalysis"))
                            writer.uint32(/* id 88, wireType 0 =*/704).bool(message.includeReturningItemsForDiscountAnalysis);
                        if (message.activityLogCleanUpIntervalInDays != null && Object.hasOwnProperty.call(message, "activityLogCleanUpIntervalInDays"))
                            writer.uint32(/* id 89, wireType 0 =*/712).int32(message.activityLogCleanUpIntervalInDays);
                        if (message.transactionCalculationMethod != null && Object.hasOwnProperty.call(message, "transactionCalculationMethod"))
                            writer.uint32(/* id 90, wireType 0 =*/720).int32(message.transactionCalculationMethod);
                        if (message.genderAgeGroupModelName != null && Object.hasOwnProperty.call(message, "genderAgeGroupModelName"))
                            writer.uint32(/* id 91, wireType 2 =*/730).string(message.genderAgeGroupModelName);
                        if (message.ageGroupThresholds != null && message.ageGroupThresholds.length) {
                            writer.uint32(/* id 92, wireType 2 =*/738).fork();
                            for (var i = 0; i < message.ageGroupThresholds.length; ++i)
                                writer.double(message.ageGroupThresholds[i]);
                            writer.ldelim();
                        }
                        if (message.enableFaceBlurring != null && Object.hasOwnProperty.call(message, "enableFaceBlurring"))
                            writer.uint32(/* id 93, wireType 0 =*/744).bool(message.enableFaceBlurring);
                        if (message.staffScheduleDemandCoverageThreshold != null && Object.hasOwnProperty.call(message, "staffScheduleDemandCoverageThreshold"))
                            writer.uint32(/* id 94, wireType 1 =*/753).double(message.staffScheduleDemandCoverageThreshold);
                        if (message.enableCopyingChangingRoomActionToCustomAction != null && Object.hasOwnProperty.call(message, "enableCopyingChangingRoomActionToCustomAction"))
                            writer.uint32(/* id 95, wireType 0 =*/760).bool(message.enableCopyingChangingRoomActionToCustomAction);
                        if (message.forecastModelVersionIdByMetric != null && Object.hasOwnProperty.call(message, "forecastModelVersionIdByMetric"))
                            for (var keys = Object.keys(message.forecastModelVersionIdByMetric), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 96, wireType 2 =*/770).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int64(message.forecastModelVersionIdByMetric[keys[i]]).ldelim();
                        if (message.maxSessionInactiveIntervalInSeconds != null && Object.hasOwnProperty.call(message, "maxSessionInactiveIntervalInSeconds"))
                            writer.uint32(/* id 97, wireType 0 =*/776).int32(message.maxSessionInactiveIntervalInSeconds);
                        if (message.rememberMeTokenMaxAgeInSeconds != null && Object.hasOwnProperty.call(message, "rememberMeTokenMaxAgeInSeconds"))
                            writer.uint32(/* id 98, wireType 0 =*/784).int32(message.rememberMeTokenMaxAgeInSeconds);
                        if (message.mainSchedulePerformanceMetric != null && Object.hasOwnProperty.call(message, "mainSchedulePerformanceMetric"))
                            writer.uint32(/* id 99, wireType 2 =*/794).string(message.mainSchedulePerformanceMetric);
                        if (message.disabled != null && Object.hasOwnProperty.call(message, "disabled"))
                            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.disabled);
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && Object.hasOwnProperty.call(message, "staffScheduleLowerDemandCoverageThreshold"))
                            writer.uint32(/* id 101, wireType 1 =*/809).double(message.staffScheduleLowerDemandCoverageThreshold);
                        if (message.excludeQueueTimeInTotalServiceTime != null && Object.hasOwnProperty.call(message, "excludeQueueTimeInTotalServiceTime"))
                            writer.uint32(/* id 102, wireType 0 =*/816).bool(message.excludeQueueTimeInTotalServiceTime);
                        if (message.totalServiceTimeComplianceThreshold != null && Object.hasOwnProperty.call(message, "totalServiceTimeComplianceThreshold"))
                            writer.uint32(/* id 103, wireType 0 =*/824).int32(message.totalServiceTimeComplianceThreshold);
                        if (message.defaultTimezone != null && Object.hasOwnProperty.call(message, "defaultTimezone"))
                            writer.uint32(/* id 104, wireType 2 =*/834).string(message.defaultTimezone);
                        if (message.dailyInsightMetrics != null && message.dailyInsightMetrics.length) {
                            writer.uint32(/* id 105, wireType 2 =*/842).fork();
                            for (var i = 0; i < message.dailyInsightMetrics.length; ++i)
                                writer.int32(message.dailyInsightMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.ibeImageBucket != null && Object.hasOwnProperty.call(message, "ibeImageBucket"))
                            writer.uint32(/* id 106, wireType 2 =*/850).string(message.ibeImageBucket);
                        if (message.checkoutTimeBuckets != null && Object.hasOwnProperty.call(message, "checkoutTimeBuckets"))
                            writer.uint32(/* id 107, wireType 2 =*/858).string(message.checkoutTimeBuckets);
                        if (message.enableTaskManagement != null && Object.hasOwnProperty.call(message, "enableTaskManagement"))
                            writer.uint32(/* id 108, wireType 0 =*/864).bool(message.enableTaskManagement);
                        if (message.enableFormManagement != null && Object.hasOwnProperty.call(message, "enableFormManagement"))
                            writer.uint32(/* id 109, wireType 0 =*/872).bool(message.enableFormManagement);
                        if (message.forecastBias != null && Object.hasOwnProperty.call(message, "forecastBias"))
                            writer.uint32(/* id 110, wireType 1 =*/881).double(message.forecastBias);
                        if (message.sectionForecastMetadataTypeIds != null && message.sectionForecastMetadataTypeIds.length) {
                            writer.uint32(/* id 111, wireType 2 =*/890).fork();
                            for (var i = 0; i < message.sectionForecastMetadataTypeIds.length; ++i)
                                writer.int64(message.sectionForecastMetadataTypeIds[i]);
                            writer.ldelim();
                        }
                        if (message.enableStoreOptimizer != null && Object.hasOwnProperty.call(message, "enableStoreOptimizer"))
                            writer.uint32(/* id 112, wireType 0 =*/896).bool(message.enableStoreOptimizer);
                        if (message.ownerAccount != null && Object.hasOwnProperty.call(message, "ownerAccount"))
                            $root.palexy.streaming.v1.Account.encode(message.ownerAccount, writer.uint32(/* id 1000, wireType 2 =*/8002).fork()).ldelim();
                        if (message.storeTimezones != null && message.storeTimezones.length)
                            for (var i = 0; i < message.storeTimezones.length; ++i)
                                writer.uint32(/* id 1001, wireType 2 =*/8010).string(message.storeTimezones[i]);
                        if (message.blurringVideoConfig != null && Object.hasOwnProperty.call(message, "blurringVideoConfig"))
                            $root.palexy.streaming.v1.BlurringVideoConfig.encode(message.blurringVideoConfig, writer.uint32(/* id 1002, wireType 2 =*/8018).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Company message, length delimited. Does not implicitly {@link palexy.streaming.v1.Company.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {palexy.streaming.v1.ICompany} message Company message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Company.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Company message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Company} Company
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Company.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Company(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.transformationMatrixEnabled = reader.bool();
                                break;
                            case 4:
                                message.logicalLayoutEnabled = reader.bool();
                                break;
                            case 5:
                                message.awsBucket = reader.string();
                                break;
                            case 6:
                                message.gcsBucket = reader.string();
                                break;
                            case 7:
                                message.companyCode = reader.string();
                                break;
                            case 8:
                                message.partnerCode = reader.string();
                                break;
                            case 9:
                                message.description = reader.string();
                                break;
                            case 10:
                                message.entranceCounting = reader.bool();
                                break;
                            case 11:
                                message.entranceKeyword = reader.string();
                                break;
                            case 12:
                                message.dwelltimeBuckets = reader.string();
                                break;
                            case 13:
                                message.ageRanges = reader.string();
                                break;
                            case 14:
                                message.sectionVisitDurationLimit = reader.int32();
                                break;
                            case 15:
                                message.dwelltimeMetricDisabled = reader.bool();
                                break;
                            case 16:
                                message.interactionMetricDisabled = reader.bool();
                                break;
                            case 17:
                                message.transactionMetricDisabled = reader.bool();
                                break;
                            case 18:
                                message.groupMetricEnabled = reader.bool();
                                break;
                            case 19:
                                message.lyingMetricEnabled = reader.bool();
                                break;
                            case 20:
                                message.avgDwelltimeMetricDisabled = reader.bool();
                                break;
                            case 21:
                                message.layoutViewDisabled = reader.bool();
                                break;
                            case 22:
                                message.topSectionsViewDisabled = reader.bool();
                                break;
                            case 23:
                                message.dailyExport = reader.bool();
                                break;
                            case 24:
                                message.lastExportTimeMs = reader.int64();
                                break;
                            case 25:
                                message.exportBucket = reader.string();
                                break;
                            case 26:
                                message.exportNotificationEmails = reader.string();
                                break;
                            case 27:
                                message.exportNotifyUrl = reader.string();
                                break;
                            case 28:
                                message.integrationUsername = reader.string();
                                break;
                            case 39:
                                message.integrationPassword = reader.string();
                                break;
                            case 30:
                                message.createTimeMs = reader.int64();
                                break;
                            case 31:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 32:
                                message.interactionLevelMetricEnabled = reader.bool();
                                break;
                            case 33:
                                message.visitorOccupancyMetricEnabled = reader.bool();
                                break;
                            case 34:
                                message.exportStorageProvider = reader.string();
                                break;
                            case 35:
                                message.exportBucketRegion = reader.string();
                                break;
                            case 36:
                                message.exportAccessKey = reader.string();
                                break;
                            case 37:
                                message.exportSecretKey = reader.string();
                                break;
                            case 38:
                                message.rawIcaStorageProvider = reader.int32();
                                break;
                            case 29:
                                message.rawIcaBucketName = reader.string();
                                break;
                            case 40:
                                message.exportPosMatchingResultEnabled = reader.bool();
                                break;
                            case 41:
                                message.usePosData = reader.bool();
                                break;
                            case 42:
                                message.salesAmountRelatedMetricsEnabled = reader.bool();
                                break;
                            case 43:
                                message.salesItemsRelatedMetricsEnabled = reader.bool();
                                break;
                            case 44:
                                message.useNetAmount = reader.bool();
                                break;
                            case 45:
                                message.passbyMetricEnabled = reader.bool();
                                break;
                            case 46:
                                message.createMatchingJobOnImportedPosDisabled = reader.bool();
                                break;
                            case 47:
                                message.rawIcaMergingBucketName = reader.string();
                                break;
                            case 48:
                                message.nearRealTimeProcessingTimesOfDay = reader.string();
                                break;
                            case 49:
                                message.sectionInteractionMetricEnabled = reader.bool();
                                break;
                            case 50:
                                message.sectionPosMetricEnabled = reader.bool();
                                break;
                            case 51:
                                message.visitorDirectionFeatureEnabled = reader.bool();
                                break;
                            case 52:
                                message.interactionTimeMetricEnabled = reader.bool();
                                break;
                            case 53:
                                message.exportRewriteHistoricalStaffingDays = reader.int32();
                                break;
                            case 54:
                                message.exportOverwriteExistingFiles = reader.bool();
                                break;
                            case 55:
                                message.mfaRequired = reader.bool();
                                break;
                            case 56:
                                message.industry = reader.int32();
                                break;
                            case 58:
                                message.useSalesItemsAsNetSalesItems = reader.bool();
                                break;
                            case 59:
                                message.staffPerformanceAnalysisMetricsEnabled = reader.bool();
                                break;
                            case 60:
                                message.staffPerformanceAnalysisStaffingMetricsEnabled = reader.bool();
                                break;
                            case 61:
                                if (!(message.enabledStoreEventTypes && message.enabledStoreEventTypes.length))
                                    message.enabledStoreEventTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.enabledStoreEventTypes.push(reader.int32());
                                } else
                                    message.enabledStoreEventTypes.push(reader.int32());
                                break;
                            case 62:
                                message.estimatedTrafficMetricsEnabled = reader.bool();
                                break;
                            case 63:
                                message.enableStoreSnapshot = reader.bool();
                                break;
                            case 64:
                                message.enableForecast = reader.bool();
                                break;
                            case 65:
                                message.enableTargetTrackingForecast = reader.bool();
                                break;
                            case 66:
                                message.strictReportConsistencyEnabled = reader.bool();
                                break;
                            case 67:
                                if (!(message.storeSnapshotScheduledTimes && message.storeSnapshotScheduledTimes.length))
                                    message.storeSnapshotScheduledTimes = [];
                                message.storeSnapshotScheduledTimes.push(reader.string());
                                break;
                            case 68:
                                message.storeOpenTimeBufferInSeconds = reader.int32();
                                break;
                            case 69:
                                message.storeCloseTimeBufferInSeconds = reader.int32();
                                break;
                            case 70:
                                message.startOfWeek = reader.int32();
                                break;
                            case 71:
                                if (!(message.weekends && message.weekends.length))
                                    message.weekends = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.weekends.push(reader.int32());
                                } else
                                    message.weekends.push(reader.int32());
                                break;
                            case 72:
                                message.storeSnapshotRetentionDays = reader.int32();
                                break;
                            case 73:
                                message.onTimeGreetingThresholdSec = reader.int32();
                                break;
                            case 74:
                                message.productSalesAnalysisEnabled = reader.bool();
                                break;
                            case 75:
                                if (!(message.defaultLandingMetrics && message.defaultLandingMetrics.length))
                                    message.defaultLandingMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.defaultLandingMetrics.push(reader.int32());
                                } else
                                    message.defaultLandingMetrics.push(reader.int32());
                                break;
                            case 76:
                                if (!(message.enabledInputTargetMetrics && message.enabledInputTargetMetrics.length))
                                    message.enabledInputTargetMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.enabledInputTargetMetrics.push(reader.int32());
                                } else
                                    message.enabledInputTargetMetrics.push(reader.int32());
                                break;
                            case 77:
                                if (!(message.enabledDisplayTargetMetrics && message.enabledDisplayTargetMetrics.length))
                                    message.enabledDisplayTargetMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.enabledDisplayTargetMetrics.push(reader.int32());
                                } else
                                    message.enabledDisplayTargetMetrics.push(reader.int32());
                                break;
                            case 78:
                                if (!(message.enabledGenerateInsightTypes && message.enabledGenerateInsightTypes.length))
                                    message.enabledGenerateInsightTypes = [];
                                message.enabledGenerateInsightTypes.push(reader.string());
                                break;
                            case 79:
                                if (!(message.enabledDisplayInsightTypes && message.enabledDisplayInsightTypes.length))
                                    message.enabledDisplayInsightTypes = [];
                                message.enabledDisplayInsightTypes.push(reader.string());
                                break;
                            case 80:
                                if (!(message.threeWeeksTrendInsightMetrics && message.threeWeeksTrendInsightMetrics.length))
                                    message.threeWeeksTrendInsightMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.threeWeeksTrendInsightMetrics.push(reader.int32());
                                } else
                                    message.threeWeeksTrendInsightMetrics.push(reader.int32());
                                break;
                            case 81:
                                if (!(message.excludedScheduledTaskTypes && message.excludedScheduledTaskTypes.length))
                                    message.excludedScheduledTaskTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.excludedScheduledTaskTypes.push(reader.int32());
                                } else
                                    message.excludedScheduledTaskTypes.push(reader.int32());
                                break;
                            case 82:
                                message.videoGroupSizeBuckets = reader.string();
                                break;
                            case 83:
                                if (!(message.criticalHoursOfDaysOfWeek && message.criticalHoursOfDaysOfWeek.length))
                                    message.criticalHoursOfDaysOfWeek = [];
                                message.criticalHoursOfDaysOfWeek.push($root.palexy.streaming.v1.CriticalHoursOfDayOfWeek.decode(reader, reader.uint32()));
                                break;
                            case 84:
                                message.posStaffSyncEnabled = reader.bool();
                                break;
                            case 85:
                                message.storeRelationshipEnabled = reader.bool();
                                break;
                            case 86:
                                message.discountMetricsEnabled = reader.bool();
                                break;
                            case 87:
                                message.discountDistributionBuckets = reader.string();
                                break;
                            case 88:
                                message.includeReturningItemsForDiscountAnalysis = reader.bool();
                                break;
                            case 89:
                                message.activityLogCleanUpIntervalInDays = reader.int32();
                                break;
                            case 90:
                                message.transactionCalculationMethod = reader.int32();
                                break;
                            case 94:
                                message.staffScheduleDemandCoverageThreshold = reader.double();
                                break;
                            case 101:
                                message.staffScheduleLowerDemandCoverageThreshold = reader.double();
                                break;
                            case 91:
                                message.genderAgeGroupModelName = reader.string();
                                break;
                            case 92:
                                if (!(message.ageGroupThresholds && message.ageGroupThresholds.length))
                                    message.ageGroupThresholds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ageGroupThresholds.push(reader.double());
                                } else
                                    message.ageGroupThresholds.push(reader.double());
                                break;
                            case 93:
                                message.enableFaceBlurring = reader.bool();
                                break;
                            case 95:
                                message.enableCopyingChangingRoomActionToCustomAction = reader.bool();
                                break;
                            case 96:
                                if (message.forecastModelVersionIdByMetric === $util.emptyObject)
                                    message.forecastModelVersionIdByMetric = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.int64();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.forecastModelVersionIdByMetric[key] = value;
                                break;
                            case 97:
                                message.maxSessionInactiveIntervalInSeconds = reader.int32();
                                break;
                            case 98:
                                message.rememberMeTokenMaxAgeInSeconds = reader.int32();
                                break;
                            case 99:
                                message.mainSchedulePerformanceMetric = reader.string();
                                break;
                            case 102:
                                message.excludeQueueTimeInTotalServiceTime = reader.bool();
                                break;
                            case 103:
                                message.totalServiceTimeComplianceThreshold = reader.int32();
                                break;
                            case 104:
                                message.defaultTimezone = reader.string();
                                break;
                            case 105:
                                if (!(message.dailyInsightMetrics && message.dailyInsightMetrics.length))
                                    message.dailyInsightMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.dailyInsightMetrics.push(reader.int32());
                                } else
                                    message.dailyInsightMetrics.push(reader.int32());
                                break;
                            case 106:
                                message.ibeImageBucket = reader.string();
                                break;
                            case 107:
                                message.checkoutTimeBuckets = reader.string();
                                break;
                            case 108:
                                message.enableTaskManagement = reader.bool();
                                break;
                            case 109:
                                message.enableFormManagement = reader.bool();
                                break;
                            case 112:
                                message.enableStoreOptimizer = reader.bool();
                                break;
                            case 110:
                                message.forecastBias = reader.double();
                                break;
                            case 111:
                                if (!(message.sectionForecastMetadataTypeIds && message.sectionForecastMetadataTypeIds.length))
                                    message.sectionForecastMetadataTypeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.sectionForecastMetadataTypeIds.push(reader.int64());
                                } else
                                    message.sectionForecastMetadataTypeIds.push(reader.int64());
                                break;
                            case 100:
                                message.disabled = reader.bool();
                                break;
                            case 1000:
                                message.ownerAccount = $root.palexy.streaming.v1.Account.decode(reader, reader.uint32());
                                break;
                            case 1001:
                                if (!(message.storeTimezones && message.storeTimezones.length))
                                    message.storeTimezones = [];
                                message.storeTimezones.push(reader.string());
                                break;
                            case 1002:
                                message.blurringVideoConfig = $root.palexy.streaming.v1.BlurringVideoConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Company message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Company} Company
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Company.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Company message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Company.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.transformationMatrixEnabled != null && message.hasOwnProperty("transformationMatrixEnabled"))
                            if (typeof message.transformationMatrixEnabled !== "boolean")
                                return "transformationMatrixEnabled: boolean expected";
                        if (message.logicalLayoutEnabled != null && message.hasOwnProperty("logicalLayoutEnabled"))
                            if (typeof message.logicalLayoutEnabled !== "boolean")
                                return "logicalLayoutEnabled: boolean expected";
                        if (message.awsBucket != null && message.hasOwnProperty("awsBucket"))
                            if (!$util.isString(message.awsBucket))
                                return "awsBucket: string expected";
                        if (message.gcsBucket != null && message.hasOwnProperty("gcsBucket"))
                            if (!$util.isString(message.gcsBucket))
                                return "gcsBucket: string expected";
                        if (message.companyCode != null && message.hasOwnProperty("companyCode"))
                            if (!$util.isString(message.companyCode))
                                return "companyCode: string expected";
                        if (message.partnerCode != null && message.hasOwnProperty("partnerCode"))
                            if (!$util.isString(message.partnerCode))
                                return "partnerCode: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.entranceCounting != null && message.hasOwnProperty("entranceCounting"))
                            if (typeof message.entranceCounting !== "boolean")
                                return "entranceCounting: boolean expected";
                        if (message.entranceKeyword != null && message.hasOwnProperty("entranceKeyword"))
                            if (!$util.isString(message.entranceKeyword))
                                return "entranceKeyword: string expected";
                        if (message.dwelltimeBuckets != null && message.hasOwnProperty("dwelltimeBuckets"))
                            if (!$util.isString(message.dwelltimeBuckets))
                                return "dwelltimeBuckets: string expected";
                        if (message.ageRanges != null && message.hasOwnProperty("ageRanges"))
                            if (!$util.isString(message.ageRanges))
                                return "ageRanges: string expected";
                        if (message.sectionVisitDurationLimit != null && message.hasOwnProperty("sectionVisitDurationLimit"))
                            if (!$util.isInteger(message.sectionVisitDurationLimit))
                                return "sectionVisitDurationLimit: integer expected";
                        if (message.dwelltimeMetricDisabled != null && message.hasOwnProperty("dwelltimeMetricDisabled"))
                            if (typeof message.dwelltimeMetricDisabled !== "boolean")
                                return "dwelltimeMetricDisabled: boolean expected";
                        if (message.interactionMetricDisabled != null && message.hasOwnProperty("interactionMetricDisabled"))
                            if (typeof message.interactionMetricDisabled !== "boolean")
                                return "interactionMetricDisabled: boolean expected";
                        if (message.transactionMetricDisabled != null && message.hasOwnProperty("transactionMetricDisabled"))
                            if (typeof message.transactionMetricDisabled !== "boolean")
                                return "transactionMetricDisabled: boolean expected";
                        if (message.groupMetricEnabled != null && message.hasOwnProperty("groupMetricEnabled"))
                            if (typeof message.groupMetricEnabled !== "boolean")
                                return "groupMetricEnabled: boolean expected";
                        if (message.lyingMetricEnabled != null && message.hasOwnProperty("lyingMetricEnabled"))
                            if (typeof message.lyingMetricEnabled !== "boolean")
                                return "lyingMetricEnabled: boolean expected";
                        if (message.avgDwelltimeMetricDisabled != null && message.hasOwnProperty("avgDwelltimeMetricDisabled"))
                            if (typeof message.avgDwelltimeMetricDisabled !== "boolean")
                                return "avgDwelltimeMetricDisabled: boolean expected";
                        if (message.layoutViewDisabled != null && message.hasOwnProperty("layoutViewDisabled"))
                            if (typeof message.layoutViewDisabled !== "boolean")
                                return "layoutViewDisabled: boolean expected";
                        if (message.topSectionsViewDisabled != null && message.hasOwnProperty("topSectionsViewDisabled"))
                            if (typeof message.topSectionsViewDisabled !== "boolean")
                                return "topSectionsViewDisabled: boolean expected";
                        if (message.dailyExport != null && message.hasOwnProperty("dailyExport"))
                            if (typeof message.dailyExport !== "boolean")
                                return "dailyExport: boolean expected";
                        if (message.lastExportTimeMs != null && message.hasOwnProperty("lastExportTimeMs"))
                            if (!$util.isInteger(message.lastExportTimeMs) && !(message.lastExportTimeMs && $util.isInteger(message.lastExportTimeMs.low) && $util.isInteger(message.lastExportTimeMs.high)))
                                return "lastExportTimeMs: integer|Long expected";
                        if (message.exportBucket != null && message.hasOwnProperty("exportBucket"))
                            if (!$util.isString(message.exportBucket))
                                return "exportBucket: string expected";
                        if (message.exportNotificationEmails != null && message.hasOwnProperty("exportNotificationEmails"))
                            if (!$util.isString(message.exportNotificationEmails))
                                return "exportNotificationEmails: string expected";
                        if (message.exportNotifyUrl != null && message.hasOwnProperty("exportNotifyUrl"))
                            if (!$util.isString(message.exportNotifyUrl))
                                return "exportNotifyUrl: string expected";
                        if (message.integrationUsername != null && message.hasOwnProperty("integrationUsername"))
                            if (!$util.isString(message.integrationUsername))
                                return "integrationUsername: string expected";
                        if (message.integrationPassword != null && message.hasOwnProperty("integrationPassword"))
                            if (!$util.isString(message.integrationPassword))
                                return "integrationPassword: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.interactionLevelMetricEnabled != null && message.hasOwnProperty("interactionLevelMetricEnabled"))
                            if (typeof message.interactionLevelMetricEnabled !== "boolean")
                                return "interactionLevelMetricEnabled: boolean expected";
                        if (message.visitorOccupancyMetricEnabled != null && message.hasOwnProperty("visitorOccupancyMetricEnabled"))
                            if (typeof message.visitorOccupancyMetricEnabled !== "boolean")
                                return "visitorOccupancyMetricEnabled: boolean expected";
                        if (message.exportStorageProvider != null && message.hasOwnProperty("exportStorageProvider"))
                            if (!$util.isString(message.exportStorageProvider))
                                return "exportStorageProvider: string expected";
                        if (message.exportBucketRegion != null && message.hasOwnProperty("exportBucketRegion"))
                            if (!$util.isString(message.exportBucketRegion))
                                return "exportBucketRegion: string expected";
                        if (message.exportAccessKey != null && message.hasOwnProperty("exportAccessKey"))
                            if (!$util.isString(message.exportAccessKey))
                                return "exportAccessKey: string expected";
                        if (message.exportSecretKey != null && message.hasOwnProperty("exportSecretKey"))
                            if (!$util.isString(message.exportSecretKey))
                                return "exportSecretKey: string expected";
                        if (message.rawIcaStorageProvider != null && message.hasOwnProperty("rawIcaStorageProvider"))
                            switch (message.rawIcaStorageProvider) {
                            default:
                                return "rawIcaStorageProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.rawIcaBucketName != null && message.hasOwnProperty("rawIcaBucketName"))
                            if (!$util.isString(message.rawIcaBucketName))
                                return "rawIcaBucketName: string expected";
                        if (message.exportPosMatchingResultEnabled != null && message.hasOwnProperty("exportPosMatchingResultEnabled"))
                            if (typeof message.exportPosMatchingResultEnabled !== "boolean")
                                return "exportPosMatchingResultEnabled: boolean expected";
                        if (message.usePosData != null && message.hasOwnProperty("usePosData"))
                            if (typeof message.usePosData !== "boolean")
                                return "usePosData: boolean expected";
                        if (message.salesAmountRelatedMetricsEnabled != null && message.hasOwnProperty("salesAmountRelatedMetricsEnabled"))
                            if (typeof message.salesAmountRelatedMetricsEnabled !== "boolean")
                                return "salesAmountRelatedMetricsEnabled: boolean expected";
                        if (message.salesItemsRelatedMetricsEnabled != null && message.hasOwnProperty("salesItemsRelatedMetricsEnabled"))
                            if (typeof message.salesItemsRelatedMetricsEnabled !== "boolean")
                                return "salesItemsRelatedMetricsEnabled: boolean expected";
                        if (message.useNetAmount != null && message.hasOwnProperty("useNetAmount"))
                            if (typeof message.useNetAmount !== "boolean")
                                return "useNetAmount: boolean expected";
                        if (message.passbyMetricEnabled != null && message.hasOwnProperty("passbyMetricEnabled"))
                            if (typeof message.passbyMetricEnabled !== "boolean")
                                return "passbyMetricEnabled: boolean expected";
                        if (message.createMatchingJobOnImportedPosDisabled != null && message.hasOwnProperty("createMatchingJobOnImportedPosDisabled"))
                            if (typeof message.createMatchingJobOnImportedPosDisabled !== "boolean")
                                return "createMatchingJobOnImportedPosDisabled: boolean expected";
                        if (message.rawIcaMergingBucketName != null && message.hasOwnProperty("rawIcaMergingBucketName"))
                            if (!$util.isString(message.rawIcaMergingBucketName))
                                return "rawIcaMergingBucketName: string expected";
                        if (message.nearRealTimeProcessingTimesOfDay != null && message.hasOwnProperty("nearRealTimeProcessingTimesOfDay"))
                            if (!$util.isString(message.nearRealTimeProcessingTimesOfDay))
                                return "nearRealTimeProcessingTimesOfDay: string expected";
                        if (message.sectionInteractionMetricEnabled != null && message.hasOwnProperty("sectionInteractionMetricEnabled"))
                            if (typeof message.sectionInteractionMetricEnabled !== "boolean")
                                return "sectionInteractionMetricEnabled: boolean expected";
                        if (message.sectionPosMetricEnabled != null && message.hasOwnProperty("sectionPosMetricEnabled"))
                            if (typeof message.sectionPosMetricEnabled !== "boolean")
                                return "sectionPosMetricEnabled: boolean expected";
                        if (message.visitorDirectionFeatureEnabled != null && message.hasOwnProperty("visitorDirectionFeatureEnabled"))
                            if (typeof message.visitorDirectionFeatureEnabled !== "boolean")
                                return "visitorDirectionFeatureEnabled: boolean expected";
                        if (message.interactionTimeMetricEnabled != null && message.hasOwnProperty("interactionTimeMetricEnabled"))
                            if (typeof message.interactionTimeMetricEnabled !== "boolean")
                                return "interactionTimeMetricEnabled: boolean expected";
                        if (message.exportRewriteHistoricalStaffingDays != null && message.hasOwnProperty("exportRewriteHistoricalStaffingDays"))
                            if (!$util.isInteger(message.exportRewriteHistoricalStaffingDays))
                                return "exportRewriteHistoricalStaffingDays: integer expected";
                        if (message.exportOverwriteExistingFiles != null && message.hasOwnProperty("exportOverwriteExistingFiles"))
                            if (typeof message.exportOverwriteExistingFiles !== "boolean")
                                return "exportOverwriteExistingFiles: boolean expected";
                        if (message.mfaRequired != null && message.hasOwnProperty("mfaRequired"))
                            if (typeof message.mfaRequired !== "boolean")
                                return "mfaRequired: boolean expected";
                        if (message.industry != null && message.hasOwnProperty("industry"))
                            switch (message.industry) {
                            default:
                                return "industry: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.useSalesItemsAsNetSalesItems != null && message.hasOwnProperty("useSalesItemsAsNetSalesItems"))
                            if (typeof message.useSalesItemsAsNetSalesItems !== "boolean")
                                return "useSalesItemsAsNetSalesItems: boolean expected";
                        if (message.staffPerformanceAnalysisMetricsEnabled != null && message.hasOwnProperty("staffPerformanceAnalysisMetricsEnabled"))
                            if (typeof message.staffPerformanceAnalysisMetricsEnabled !== "boolean")
                                return "staffPerformanceAnalysisMetricsEnabled: boolean expected";
                        if (message.staffPerformanceAnalysisStaffingMetricsEnabled != null && message.hasOwnProperty("staffPerformanceAnalysisStaffingMetricsEnabled"))
                            if (typeof message.staffPerformanceAnalysisStaffingMetricsEnabled !== "boolean")
                                return "staffPerformanceAnalysisStaffingMetricsEnabled: boolean expected";
                        if (message.enabledStoreEventTypes != null && message.hasOwnProperty("enabledStoreEventTypes")) {
                            if (!Array.isArray(message.enabledStoreEventTypes))
                                return "enabledStoreEventTypes: array expected";
                            for (var i = 0; i < message.enabledStoreEventTypes.length; ++i)
                                switch (message.enabledStoreEventTypes[i]) {
                                default:
                                    return "enabledStoreEventTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                    break;
                                }
                        }
                        if (message.estimatedTrafficMetricsEnabled != null && message.hasOwnProperty("estimatedTrafficMetricsEnabled"))
                            if (typeof message.estimatedTrafficMetricsEnabled !== "boolean")
                                return "estimatedTrafficMetricsEnabled: boolean expected";
                        if (message.enableStoreSnapshot != null && message.hasOwnProperty("enableStoreSnapshot"))
                            if (typeof message.enableStoreSnapshot !== "boolean")
                                return "enableStoreSnapshot: boolean expected";
                        if (message.enableForecast != null && message.hasOwnProperty("enableForecast"))
                            if (typeof message.enableForecast !== "boolean")
                                return "enableForecast: boolean expected";
                        if (message.enableTargetTrackingForecast != null && message.hasOwnProperty("enableTargetTrackingForecast"))
                            if (typeof message.enableTargetTrackingForecast !== "boolean")
                                return "enableTargetTrackingForecast: boolean expected";
                        if (message.strictReportConsistencyEnabled != null && message.hasOwnProperty("strictReportConsistencyEnabled"))
                            if (typeof message.strictReportConsistencyEnabled !== "boolean")
                                return "strictReportConsistencyEnabled: boolean expected";
                        if (message.storeSnapshotScheduledTimes != null && message.hasOwnProperty("storeSnapshotScheduledTimes")) {
                            if (!Array.isArray(message.storeSnapshotScheduledTimes))
                                return "storeSnapshotScheduledTimes: array expected";
                            for (var i = 0; i < message.storeSnapshotScheduledTimes.length; ++i)
                                if (!$util.isString(message.storeSnapshotScheduledTimes[i]))
                                    return "storeSnapshotScheduledTimes: string[] expected";
                        }
                        if (message.storeOpenTimeBufferInSeconds != null && message.hasOwnProperty("storeOpenTimeBufferInSeconds"))
                            if (!$util.isInteger(message.storeOpenTimeBufferInSeconds))
                                return "storeOpenTimeBufferInSeconds: integer expected";
                        if (message.storeCloseTimeBufferInSeconds != null && message.hasOwnProperty("storeCloseTimeBufferInSeconds"))
                            if (!$util.isInteger(message.storeCloseTimeBufferInSeconds))
                                return "storeCloseTimeBufferInSeconds: integer expected";
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            if (!$util.isInteger(message.startOfWeek))
                                return "startOfWeek: integer expected";
                        if (message.weekends != null && message.hasOwnProperty("weekends")) {
                            if (!Array.isArray(message.weekends))
                                return "weekends: array expected";
                            for (var i = 0; i < message.weekends.length; ++i)
                                if (!$util.isInteger(message.weekends[i]))
                                    return "weekends: integer[] expected";
                        }
                        if (message.storeSnapshotRetentionDays != null && message.hasOwnProperty("storeSnapshotRetentionDays"))
                            if (!$util.isInteger(message.storeSnapshotRetentionDays))
                                return "storeSnapshotRetentionDays: integer expected";
                        if (message.onTimeGreetingThresholdSec != null && message.hasOwnProperty("onTimeGreetingThresholdSec"))
                            if (!$util.isInteger(message.onTimeGreetingThresholdSec))
                                return "onTimeGreetingThresholdSec: integer expected";
                        if (message.productSalesAnalysisEnabled != null && message.hasOwnProperty("productSalesAnalysisEnabled"))
                            if (typeof message.productSalesAnalysisEnabled !== "boolean")
                                return "productSalesAnalysisEnabled: boolean expected";
                        if (message.defaultLandingMetrics != null && message.hasOwnProperty("defaultLandingMetrics")) {
                            if (!Array.isArray(message.defaultLandingMetrics))
                                return "defaultLandingMetrics: array expected";
                            for (var i = 0; i < message.defaultLandingMetrics.length; ++i)
                                switch (message.defaultLandingMetrics[i]) {
                                default:
                                    return "defaultLandingMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.enabledInputTargetMetrics != null && message.hasOwnProperty("enabledInputTargetMetrics")) {
                            if (!Array.isArray(message.enabledInputTargetMetrics))
                                return "enabledInputTargetMetrics: array expected";
                            for (var i = 0; i < message.enabledInputTargetMetrics.length; ++i)
                                switch (message.enabledInputTargetMetrics[i]) {
                                default:
                                    return "enabledInputTargetMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.enabledDisplayTargetMetrics != null && message.hasOwnProperty("enabledDisplayTargetMetrics")) {
                            if (!Array.isArray(message.enabledDisplayTargetMetrics))
                                return "enabledDisplayTargetMetrics: array expected";
                            for (var i = 0; i < message.enabledDisplayTargetMetrics.length; ++i)
                                switch (message.enabledDisplayTargetMetrics[i]) {
                                default:
                                    return "enabledDisplayTargetMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.enabledGenerateInsightTypes != null && message.hasOwnProperty("enabledGenerateInsightTypes")) {
                            if (!Array.isArray(message.enabledGenerateInsightTypes))
                                return "enabledGenerateInsightTypes: array expected";
                            for (var i = 0; i < message.enabledGenerateInsightTypes.length; ++i)
                                if (!$util.isString(message.enabledGenerateInsightTypes[i]))
                                    return "enabledGenerateInsightTypes: string[] expected";
                        }
                        if (message.enabledDisplayInsightTypes != null && message.hasOwnProperty("enabledDisplayInsightTypes")) {
                            if (!Array.isArray(message.enabledDisplayInsightTypes))
                                return "enabledDisplayInsightTypes: array expected";
                            for (var i = 0; i < message.enabledDisplayInsightTypes.length; ++i)
                                if (!$util.isString(message.enabledDisplayInsightTypes[i]))
                                    return "enabledDisplayInsightTypes: string[] expected";
                        }
                        if (message.threeWeeksTrendInsightMetrics != null && message.hasOwnProperty("threeWeeksTrendInsightMetrics")) {
                            if (!Array.isArray(message.threeWeeksTrendInsightMetrics))
                                return "threeWeeksTrendInsightMetrics: array expected";
                            for (var i = 0; i < message.threeWeeksTrendInsightMetrics.length; ++i)
                                switch (message.threeWeeksTrendInsightMetrics[i]) {
                                default:
                                    return "threeWeeksTrendInsightMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.excludedScheduledTaskTypes != null && message.hasOwnProperty("excludedScheduledTaskTypes")) {
                            if (!Array.isArray(message.excludedScheduledTaskTypes))
                                return "excludedScheduledTaskTypes: array expected";
                            for (var i = 0; i < message.excludedScheduledTaskTypes.length; ++i)
                                switch (message.excludedScheduledTaskTypes[i]) {
                                default:
                                    return "excludedScheduledTaskTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                    break;
                                }
                        }
                        if (message.videoGroupSizeBuckets != null && message.hasOwnProperty("videoGroupSizeBuckets"))
                            if (!$util.isString(message.videoGroupSizeBuckets))
                                return "videoGroupSizeBuckets: string expected";
                        if (message.criticalHoursOfDaysOfWeek != null && message.hasOwnProperty("criticalHoursOfDaysOfWeek")) {
                            if (!Array.isArray(message.criticalHoursOfDaysOfWeek))
                                return "criticalHoursOfDaysOfWeek: array expected";
                            for (var i = 0; i < message.criticalHoursOfDaysOfWeek.length; ++i) {
                                var error = $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek.verify(message.criticalHoursOfDaysOfWeek[i]);
                                if (error)
                                    return "criticalHoursOfDaysOfWeek." + error;
                            }
                        }
                        if (message.posStaffSyncEnabled != null && message.hasOwnProperty("posStaffSyncEnabled"))
                            if (typeof message.posStaffSyncEnabled !== "boolean")
                                return "posStaffSyncEnabled: boolean expected";
                        if (message.storeRelationshipEnabled != null && message.hasOwnProperty("storeRelationshipEnabled"))
                            if (typeof message.storeRelationshipEnabled !== "boolean")
                                return "storeRelationshipEnabled: boolean expected";
                        if (message.discountMetricsEnabled != null && message.hasOwnProperty("discountMetricsEnabled"))
                            if (typeof message.discountMetricsEnabled !== "boolean")
                                return "discountMetricsEnabled: boolean expected";
                        if (message.discountDistributionBuckets != null && message.hasOwnProperty("discountDistributionBuckets"))
                            if (!$util.isString(message.discountDistributionBuckets))
                                return "discountDistributionBuckets: string expected";
                        if (message.includeReturningItemsForDiscountAnalysis != null && message.hasOwnProperty("includeReturningItemsForDiscountAnalysis"))
                            if (typeof message.includeReturningItemsForDiscountAnalysis !== "boolean")
                                return "includeReturningItemsForDiscountAnalysis: boolean expected";
                        if (message.activityLogCleanUpIntervalInDays != null && message.hasOwnProperty("activityLogCleanUpIntervalInDays"))
                            if (!$util.isInteger(message.activityLogCleanUpIntervalInDays))
                                return "activityLogCleanUpIntervalInDays: integer expected";
                        if (message.transactionCalculationMethod != null && message.hasOwnProperty("transactionCalculationMethod"))
                            switch (message.transactionCalculationMethod) {
                            default:
                                return "transactionCalculationMethod: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.staffScheduleDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleDemandCoverageThreshold"))
                            if (typeof message.staffScheduleDemandCoverageThreshold !== "number")
                                return "staffScheduleDemandCoverageThreshold: number expected";
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleLowerDemandCoverageThreshold"))
                            if (typeof message.staffScheduleLowerDemandCoverageThreshold !== "number")
                                return "staffScheduleLowerDemandCoverageThreshold: number expected";
                        if (message.genderAgeGroupModelName != null && message.hasOwnProperty("genderAgeGroupModelName"))
                            if (!$util.isString(message.genderAgeGroupModelName))
                                return "genderAgeGroupModelName: string expected";
                        if (message.ageGroupThresholds != null && message.hasOwnProperty("ageGroupThresholds")) {
                            if (!Array.isArray(message.ageGroupThresholds))
                                return "ageGroupThresholds: array expected";
                            for (var i = 0; i < message.ageGroupThresholds.length; ++i)
                                if (typeof message.ageGroupThresholds[i] !== "number")
                                    return "ageGroupThresholds: number[] expected";
                        }
                        if (message.enableFaceBlurring != null && message.hasOwnProperty("enableFaceBlurring"))
                            if (typeof message.enableFaceBlurring !== "boolean")
                                return "enableFaceBlurring: boolean expected";
                        if (message.enableCopyingChangingRoomActionToCustomAction != null && message.hasOwnProperty("enableCopyingChangingRoomActionToCustomAction"))
                            if (typeof message.enableCopyingChangingRoomActionToCustomAction !== "boolean")
                                return "enableCopyingChangingRoomActionToCustomAction: boolean expected";
                        if (message.forecastModelVersionIdByMetric != null && message.hasOwnProperty("forecastModelVersionIdByMetric")) {
                            if (!$util.isObject(message.forecastModelVersionIdByMetric))
                                return "forecastModelVersionIdByMetric: object expected";
                            var key = Object.keys(message.forecastModelVersionIdByMetric);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isInteger(message.forecastModelVersionIdByMetric[key[i]]) && !(message.forecastModelVersionIdByMetric[key[i]] && $util.isInteger(message.forecastModelVersionIdByMetric[key[i]].low) && $util.isInteger(message.forecastModelVersionIdByMetric[key[i]].high)))
                                    return "forecastModelVersionIdByMetric: integer|Long{k:string} expected";
                        }
                        if (message.maxSessionInactiveIntervalInSeconds != null && message.hasOwnProperty("maxSessionInactiveIntervalInSeconds"))
                            if (!$util.isInteger(message.maxSessionInactiveIntervalInSeconds))
                                return "maxSessionInactiveIntervalInSeconds: integer expected";
                        if (message.rememberMeTokenMaxAgeInSeconds != null && message.hasOwnProperty("rememberMeTokenMaxAgeInSeconds"))
                            if (!$util.isInteger(message.rememberMeTokenMaxAgeInSeconds))
                                return "rememberMeTokenMaxAgeInSeconds: integer expected";
                        if (message.mainSchedulePerformanceMetric != null && message.hasOwnProperty("mainSchedulePerformanceMetric"))
                            if (!$util.isString(message.mainSchedulePerformanceMetric))
                                return "mainSchedulePerformanceMetric: string expected";
                        if (message.excludeQueueTimeInTotalServiceTime != null && message.hasOwnProperty("excludeQueueTimeInTotalServiceTime"))
                            if (typeof message.excludeQueueTimeInTotalServiceTime !== "boolean")
                                return "excludeQueueTimeInTotalServiceTime: boolean expected";
                        if (message.totalServiceTimeComplianceThreshold != null && message.hasOwnProperty("totalServiceTimeComplianceThreshold"))
                            if (!$util.isInteger(message.totalServiceTimeComplianceThreshold))
                                return "totalServiceTimeComplianceThreshold: integer expected";
                        if (message.defaultTimezone != null && message.hasOwnProperty("defaultTimezone"))
                            if (!$util.isString(message.defaultTimezone))
                                return "defaultTimezone: string expected";
                        if (message.dailyInsightMetrics != null && message.hasOwnProperty("dailyInsightMetrics")) {
                            if (!Array.isArray(message.dailyInsightMetrics))
                                return "dailyInsightMetrics: array expected";
                            for (var i = 0; i < message.dailyInsightMetrics.length; ++i)
                                switch (message.dailyInsightMetrics[i]) {
                                default:
                                    return "dailyInsightMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.ibeImageBucket != null && message.hasOwnProperty("ibeImageBucket"))
                            if (!$util.isString(message.ibeImageBucket))
                                return "ibeImageBucket: string expected";
                        if (message.checkoutTimeBuckets != null && message.hasOwnProperty("checkoutTimeBuckets"))
                            if (!$util.isString(message.checkoutTimeBuckets))
                                return "checkoutTimeBuckets: string expected";
                        if (message.enableTaskManagement != null && message.hasOwnProperty("enableTaskManagement"))
                            if (typeof message.enableTaskManagement !== "boolean")
                                return "enableTaskManagement: boolean expected";
                        if (message.enableFormManagement != null && message.hasOwnProperty("enableFormManagement"))
                            if (typeof message.enableFormManagement !== "boolean")
                                return "enableFormManagement: boolean expected";
                        if (message.enableStoreOptimizer != null && message.hasOwnProperty("enableStoreOptimizer"))
                            if (typeof message.enableStoreOptimizer !== "boolean")
                                return "enableStoreOptimizer: boolean expected";
                        if (message.forecastBias != null && message.hasOwnProperty("forecastBias"))
                            if (typeof message.forecastBias !== "number")
                                return "forecastBias: number expected";
                        if (message.sectionForecastMetadataTypeIds != null && message.hasOwnProperty("sectionForecastMetadataTypeIds")) {
                            if (!Array.isArray(message.sectionForecastMetadataTypeIds))
                                return "sectionForecastMetadataTypeIds: array expected";
                            for (var i = 0; i < message.sectionForecastMetadataTypeIds.length; ++i)
                                if (!$util.isInteger(message.sectionForecastMetadataTypeIds[i]) && !(message.sectionForecastMetadataTypeIds[i] && $util.isInteger(message.sectionForecastMetadataTypeIds[i].low) && $util.isInteger(message.sectionForecastMetadataTypeIds[i].high)))
                                    return "sectionForecastMetadataTypeIds: integer|Long[] expected";
                        }
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            if (typeof message.disabled !== "boolean")
                                return "disabled: boolean expected";
                        if (message.ownerAccount != null && message.hasOwnProperty("ownerAccount")) {
                            var error = $root.palexy.streaming.v1.Account.verify(message.ownerAccount);
                            if (error)
                                return "ownerAccount." + error;
                        }
                        if (message.storeTimezones != null && message.hasOwnProperty("storeTimezones")) {
                            if (!Array.isArray(message.storeTimezones))
                                return "storeTimezones: array expected";
                            for (var i = 0; i < message.storeTimezones.length; ++i)
                                if (!$util.isString(message.storeTimezones[i]))
                                    return "storeTimezones: string[] expected";
                        }
                        if (message.blurringVideoConfig != null && message.hasOwnProperty("blurringVideoConfig")) {
                            properties._blurringVideoConfig = 1;
                            {
                                var error = $root.palexy.streaming.v1.BlurringVideoConfig.verify(message.blurringVideoConfig);
                                if (error)
                                    return "blurringVideoConfig." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Company message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Company} Company
                     */
                    Company.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Company)
                            return object;
                        var message = new $root.palexy.streaming.v1.Company();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.transformationMatrixEnabled != null)
                            message.transformationMatrixEnabled = Boolean(object.transformationMatrixEnabled);
                        if (object.logicalLayoutEnabled != null)
                            message.logicalLayoutEnabled = Boolean(object.logicalLayoutEnabled);
                        if (object.awsBucket != null)
                            message.awsBucket = String(object.awsBucket);
                        if (object.gcsBucket != null)
                            message.gcsBucket = String(object.gcsBucket);
                        if (object.companyCode != null)
                            message.companyCode = String(object.companyCode);
                        if (object.partnerCode != null)
                            message.partnerCode = String(object.partnerCode);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.entranceCounting != null)
                            message.entranceCounting = Boolean(object.entranceCounting);
                        if (object.entranceKeyword != null)
                            message.entranceKeyword = String(object.entranceKeyword);
                        if (object.dwelltimeBuckets != null)
                            message.dwelltimeBuckets = String(object.dwelltimeBuckets);
                        if (object.ageRanges != null)
                            message.ageRanges = String(object.ageRanges);
                        if (object.sectionVisitDurationLimit != null)
                            message.sectionVisitDurationLimit = object.sectionVisitDurationLimit | 0;
                        if (object.dwelltimeMetricDisabled != null)
                            message.dwelltimeMetricDisabled = Boolean(object.dwelltimeMetricDisabled);
                        if (object.interactionMetricDisabled != null)
                            message.interactionMetricDisabled = Boolean(object.interactionMetricDisabled);
                        if (object.transactionMetricDisabled != null)
                            message.transactionMetricDisabled = Boolean(object.transactionMetricDisabled);
                        if (object.groupMetricEnabled != null)
                            message.groupMetricEnabled = Boolean(object.groupMetricEnabled);
                        if (object.lyingMetricEnabled != null)
                            message.lyingMetricEnabled = Boolean(object.lyingMetricEnabled);
                        if (object.avgDwelltimeMetricDisabled != null)
                            message.avgDwelltimeMetricDisabled = Boolean(object.avgDwelltimeMetricDisabled);
                        if (object.layoutViewDisabled != null)
                            message.layoutViewDisabled = Boolean(object.layoutViewDisabled);
                        if (object.topSectionsViewDisabled != null)
                            message.topSectionsViewDisabled = Boolean(object.topSectionsViewDisabled);
                        if (object.dailyExport != null)
                            message.dailyExport = Boolean(object.dailyExport);
                        if (object.lastExportTimeMs != null)
                            if ($util.Long)
                                (message.lastExportTimeMs = $util.Long.fromValue(object.lastExportTimeMs)).unsigned = false;
                            else if (typeof object.lastExportTimeMs === "string")
                                message.lastExportTimeMs = parseInt(object.lastExportTimeMs, 10);
                            else if (typeof object.lastExportTimeMs === "number")
                                message.lastExportTimeMs = object.lastExportTimeMs;
                            else if (typeof object.lastExportTimeMs === "object")
                                message.lastExportTimeMs = new $util.LongBits(object.lastExportTimeMs.low >>> 0, object.lastExportTimeMs.high >>> 0).toNumber();
                        if (object.exportBucket != null)
                            message.exportBucket = String(object.exportBucket);
                        if (object.exportNotificationEmails != null)
                            message.exportNotificationEmails = String(object.exportNotificationEmails);
                        if (object.exportNotifyUrl != null)
                            message.exportNotifyUrl = String(object.exportNotifyUrl);
                        if (object.integrationUsername != null)
                            message.integrationUsername = String(object.integrationUsername);
                        if (object.integrationPassword != null)
                            message.integrationPassword = String(object.integrationPassword);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.interactionLevelMetricEnabled != null)
                            message.interactionLevelMetricEnabled = Boolean(object.interactionLevelMetricEnabled);
                        if (object.visitorOccupancyMetricEnabled != null)
                            message.visitorOccupancyMetricEnabled = Boolean(object.visitorOccupancyMetricEnabled);
                        if (object.exportStorageProvider != null)
                            message.exportStorageProvider = String(object.exportStorageProvider);
                        if (object.exportBucketRegion != null)
                            message.exportBucketRegion = String(object.exportBucketRegion);
                        if (object.exportAccessKey != null)
                            message.exportAccessKey = String(object.exportAccessKey);
                        if (object.exportSecretKey != null)
                            message.exportSecretKey = String(object.exportSecretKey);
                        switch (object.rawIcaStorageProvider) {
                        case "RAW_PROVIDER_UNKNOWN":
                        case 0:
                            message.rawIcaStorageProvider = 0;
                            break;
                        case "DATABASE":
                        case 1:
                            message.rawIcaStorageProvider = 1;
                            break;
                        case "GCP":
                        case 2:
                            message.rawIcaStorageProvider = 2;
                            break;
                        }
                        if (object.rawIcaBucketName != null)
                            message.rawIcaBucketName = String(object.rawIcaBucketName);
                        if (object.exportPosMatchingResultEnabled != null)
                            message.exportPosMatchingResultEnabled = Boolean(object.exportPosMatchingResultEnabled);
                        if (object.usePosData != null)
                            message.usePosData = Boolean(object.usePosData);
                        if (object.salesAmountRelatedMetricsEnabled != null)
                            message.salesAmountRelatedMetricsEnabled = Boolean(object.salesAmountRelatedMetricsEnabled);
                        if (object.salesItemsRelatedMetricsEnabled != null)
                            message.salesItemsRelatedMetricsEnabled = Boolean(object.salesItemsRelatedMetricsEnabled);
                        if (object.useNetAmount != null)
                            message.useNetAmount = Boolean(object.useNetAmount);
                        if (object.passbyMetricEnabled != null)
                            message.passbyMetricEnabled = Boolean(object.passbyMetricEnabled);
                        if (object.createMatchingJobOnImportedPosDisabled != null)
                            message.createMatchingJobOnImportedPosDisabled = Boolean(object.createMatchingJobOnImportedPosDisabled);
                        if (object.rawIcaMergingBucketName != null)
                            message.rawIcaMergingBucketName = String(object.rawIcaMergingBucketName);
                        if (object.nearRealTimeProcessingTimesOfDay != null)
                            message.nearRealTimeProcessingTimesOfDay = String(object.nearRealTimeProcessingTimesOfDay);
                        if (object.sectionInteractionMetricEnabled != null)
                            message.sectionInteractionMetricEnabled = Boolean(object.sectionInteractionMetricEnabled);
                        if (object.sectionPosMetricEnabled != null)
                            message.sectionPosMetricEnabled = Boolean(object.sectionPosMetricEnabled);
                        if (object.visitorDirectionFeatureEnabled != null)
                            message.visitorDirectionFeatureEnabled = Boolean(object.visitorDirectionFeatureEnabled);
                        if (object.interactionTimeMetricEnabled != null)
                            message.interactionTimeMetricEnabled = Boolean(object.interactionTimeMetricEnabled);
                        if (object.exportRewriteHistoricalStaffingDays != null)
                            message.exportRewriteHistoricalStaffingDays = object.exportRewriteHistoricalStaffingDays | 0;
                        if (object.exportOverwriteExistingFiles != null)
                            message.exportOverwriteExistingFiles = Boolean(object.exportOverwriteExistingFiles);
                        if (object.mfaRequired != null)
                            message.mfaRequired = Boolean(object.mfaRequired);
                        switch (object.industry) {
                        case "OTHERS":
                        case 0:
                            message.industry = 0;
                            break;
                        case "FASHION":
                        case 1:
                            message.industry = 1;
                            break;
                        case "CVS":
                        case 2:
                            message.industry = 2;
                            break;
                        case "MALL":
                        case 3:
                            message.industry = 3;
                            break;
                        case "JEWELRY":
                        case 4:
                            message.industry = 4;
                            break;
                        case "DEPARTMENT_STORE":
                        case 5:
                            message.industry = 5;
                            break;
                        case "FNB":
                        case 6:
                            message.industry = 6;
                            break;
                        case "GROCERY_STORE":
                        case 7:
                            message.industry = 7;
                            break;
                        }
                        if (object.useSalesItemsAsNetSalesItems != null)
                            message.useSalesItemsAsNetSalesItems = Boolean(object.useSalesItemsAsNetSalesItems);
                        if (object.staffPerformanceAnalysisMetricsEnabled != null)
                            message.staffPerformanceAnalysisMetricsEnabled = Boolean(object.staffPerformanceAnalysisMetricsEnabled);
                        if (object.staffPerformanceAnalysisStaffingMetricsEnabled != null)
                            message.staffPerformanceAnalysisStaffingMetricsEnabled = Boolean(object.staffPerformanceAnalysisStaffingMetricsEnabled);
                        if (object.enabledStoreEventTypes) {
                            if (!Array.isArray(object.enabledStoreEventTypes))
                                throw TypeError(".palexy.streaming.v1.Company.enabledStoreEventTypes: array expected");
                            message.enabledStoreEventTypes = [];
                            for (var i = 0; i < object.enabledStoreEventTypes.length; ++i)
                                switch (object.enabledStoreEventTypes[i]) {
                                default:
                                case "UNKNOWN_STORE_EVENT_TYPE":
                                case 0:
                                    message.enabledStoreEventTypes[i] = 0;
                                    break;
                                case "MISSED_CUSTOMER_INTERACTION":
                                case 1:
                                    message.enabledStoreEventTypes[i] = 1;
                                    break;
                                case "SUSPICIOUS_CASHIER_ACTIVITY":
                                case 2:
                                    message.enabledStoreEventTypes[i] = 2;
                                    break;
                                case "SOP_NON_COMPLIANCE":
                                case 3:
                                    message.enabledStoreEventTypes[i] = 3;
                                    break;
                                case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                                case 4:
                                    message.enabledStoreEventTypes[i] = 4;
                                    break;
                                case "STAFF_GATHERING":
                                case 5:
                                    message.enabledStoreEventTypes[i] = 5;
                                    break;
                                case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                                case 6:
                                    message.enabledStoreEventTypes[i] = 6;
                                    break;
                                case "CUSTOMER_NEEDS_ASSISTANCE":
                                case 7:
                                    message.enabledStoreEventTypes[i] = 7;
                                    break;
                                case "STAFF_NOT_WEAR_GLOVE":
                                case 8:
                                    message.enabledStoreEventTypes[i] = 8;
                                    break;
                                case "NOT_GREETED_ON_TIME":
                                case 9:
                                    message.enabledStoreEventTypes[i] = 9;
                                    break;
                                case "STAFF_MISSING":
                                case 10:
                                    message.enabledStoreEventTypes[i] = 10;
                                    break;
                                case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                                case 11:
                                    message.enabledStoreEventTypes[i] = 11;
                                    break;
                                case "HIGH_TRAFFIC_CHECKOUT":
                                case 12:
                                    message.enabledStoreEventTypes[i] = 12;
                                    break;
                                case "LONG_TOTAL_SERVICE_TIME":
                                case 13:
                                    message.enabledStoreEventTypes[i] = 13;
                                    break;
                                case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                                case 14:
                                    message.enabledStoreEventTypes[i] = 14;
                                    break;
                                case "LATE_TABLE_CLEANING":
                                case 15:
                                    message.enabledStoreEventTypes[i] = 15;
                                    break;
                                case "SUSPICIOUS_BILL_CANCELLATION":
                                case 16:
                                    message.enabledStoreEventTypes[i] = 16;
                                    break;
                                case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                                case 17:
                                    message.enabledStoreEventTypes[i] = 17;
                                    break;
                                case "LONG_QUEUE":
                                case 18:
                                    message.enabledStoreEventTypes[i] = 18;
                                    break;
                                case "LONG_CHECKOUT_TIME":
                                case 19:
                                    message.enabledStoreEventTypes[i] = 19;
                                    break;
                                }
                        }
                        if (object.estimatedTrafficMetricsEnabled != null)
                            message.estimatedTrafficMetricsEnabled = Boolean(object.estimatedTrafficMetricsEnabled);
                        if (object.enableStoreSnapshot != null)
                            message.enableStoreSnapshot = Boolean(object.enableStoreSnapshot);
                        if (object.enableForecast != null)
                            message.enableForecast = Boolean(object.enableForecast);
                        if (object.enableTargetTrackingForecast != null)
                            message.enableTargetTrackingForecast = Boolean(object.enableTargetTrackingForecast);
                        if (object.strictReportConsistencyEnabled != null)
                            message.strictReportConsistencyEnabled = Boolean(object.strictReportConsistencyEnabled);
                        if (object.storeSnapshotScheduledTimes) {
                            if (!Array.isArray(object.storeSnapshotScheduledTimes))
                                throw TypeError(".palexy.streaming.v1.Company.storeSnapshotScheduledTimes: array expected");
                            message.storeSnapshotScheduledTimes = [];
                            for (var i = 0; i < object.storeSnapshotScheduledTimes.length; ++i)
                                message.storeSnapshotScheduledTimes[i] = String(object.storeSnapshotScheduledTimes[i]);
                        }
                        if (object.storeOpenTimeBufferInSeconds != null)
                            message.storeOpenTimeBufferInSeconds = object.storeOpenTimeBufferInSeconds | 0;
                        if (object.storeCloseTimeBufferInSeconds != null)
                            message.storeCloseTimeBufferInSeconds = object.storeCloseTimeBufferInSeconds | 0;
                        if (object.startOfWeek != null)
                            message.startOfWeek = object.startOfWeek | 0;
                        if (object.weekends) {
                            if (!Array.isArray(object.weekends))
                                throw TypeError(".palexy.streaming.v1.Company.weekends: array expected");
                            message.weekends = [];
                            for (var i = 0; i < object.weekends.length; ++i)
                                message.weekends[i] = object.weekends[i] | 0;
                        }
                        if (object.storeSnapshotRetentionDays != null)
                            message.storeSnapshotRetentionDays = object.storeSnapshotRetentionDays | 0;
                        if (object.onTimeGreetingThresholdSec != null)
                            message.onTimeGreetingThresholdSec = object.onTimeGreetingThresholdSec | 0;
                        if (object.productSalesAnalysisEnabled != null)
                            message.productSalesAnalysisEnabled = Boolean(object.productSalesAnalysisEnabled);
                        if (object.defaultLandingMetrics) {
                            if (!Array.isArray(object.defaultLandingMetrics))
                                throw TypeError(".palexy.streaming.v1.Company.defaultLandingMetrics: array expected");
                            message.defaultLandingMetrics = [];
                            for (var i = 0; i < object.defaultLandingMetrics.length; ++i)
                                switch (object.defaultLandingMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.defaultLandingMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.defaultLandingMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.defaultLandingMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.defaultLandingMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.defaultLandingMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.defaultLandingMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.defaultLandingMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.defaultLandingMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.defaultLandingMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.defaultLandingMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.defaultLandingMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.defaultLandingMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.defaultLandingMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.defaultLandingMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.defaultLandingMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.defaultLandingMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.defaultLandingMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.defaultLandingMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.defaultLandingMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.defaultLandingMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.defaultLandingMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.defaultLandingMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.defaultLandingMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.defaultLandingMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.defaultLandingMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.defaultLandingMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.defaultLandingMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.defaultLandingMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.defaultLandingMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.defaultLandingMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.defaultLandingMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.defaultLandingMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.defaultLandingMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.defaultLandingMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.defaultLandingMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.defaultLandingMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.defaultLandingMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.defaultLandingMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.defaultLandingMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.defaultLandingMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.defaultLandingMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.defaultLandingMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.defaultLandingMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.defaultLandingMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.defaultLandingMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.defaultLandingMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.defaultLandingMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.defaultLandingMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.defaultLandingMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.defaultLandingMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.defaultLandingMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.defaultLandingMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.defaultLandingMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.defaultLandingMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.defaultLandingMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.defaultLandingMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.defaultLandingMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.defaultLandingMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.defaultLandingMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.defaultLandingMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.defaultLandingMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.defaultLandingMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.defaultLandingMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.defaultLandingMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.defaultLandingMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.defaultLandingMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.defaultLandingMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.defaultLandingMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.defaultLandingMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.defaultLandingMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.defaultLandingMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.defaultLandingMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.defaultLandingMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.defaultLandingMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.defaultLandingMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.defaultLandingMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.defaultLandingMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.defaultLandingMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.defaultLandingMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.defaultLandingMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.defaultLandingMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.defaultLandingMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.defaultLandingMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.defaultLandingMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.defaultLandingMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.defaultLandingMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.defaultLandingMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.defaultLandingMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.defaultLandingMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.defaultLandingMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.defaultLandingMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.defaultLandingMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.defaultLandingMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.defaultLandingMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.defaultLandingMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.defaultLandingMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.defaultLandingMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.defaultLandingMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.defaultLandingMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.defaultLandingMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.defaultLandingMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.defaultLandingMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.defaultLandingMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.defaultLandingMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.defaultLandingMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.defaultLandingMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.defaultLandingMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.defaultLandingMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.defaultLandingMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.defaultLandingMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.defaultLandingMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.defaultLandingMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.defaultLandingMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.defaultLandingMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.defaultLandingMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.defaultLandingMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.defaultLandingMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.defaultLandingMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.defaultLandingMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.defaultLandingMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.defaultLandingMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.defaultLandingMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.defaultLandingMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.defaultLandingMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.defaultLandingMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.defaultLandingMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.defaultLandingMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.defaultLandingMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.defaultLandingMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.defaultLandingMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.defaultLandingMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.defaultLandingMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.defaultLandingMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.defaultLandingMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.defaultLandingMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.defaultLandingMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.defaultLandingMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.defaultLandingMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.defaultLandingMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.defaultLandingMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.defaultLandingMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.defaultLandingMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.defaultLandingMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.defaultLandingMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.defaultLandingMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.defaultLandingMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.defaultLandingMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.defaultLandingMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.defaultLandingMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.defaultLandingMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.defaultLandingMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.defaultLandingMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.defaultLandingMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.defaultLandingMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.defaultLandingMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.defaultLandingMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.defaultLandingMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.defaultLandingMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.defaultLandingMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.defaultLandingMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.defaultLandingMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.defaultLandingMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.defaultLandingMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.defaultLandingMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.defaultLandingMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.defaultLandingMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.defaultLandingMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.defaultLandingMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.defaultLandingMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.defaultLandingMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.defaultLandingMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.defaultLandingMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.defaultLandingMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.defaultLandingMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.defaultLandingMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.defaultLandingMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.defaultLandingMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.defaultLandingMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.defaultLandingMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.defaultLandingMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.defaultLandingMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.defaultLandingMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.defaultLandingMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.defaultLandingMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.defaultLandingMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.defaultLandingMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.defaultLandingMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.defaultLandingMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.defaultLandingMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.defaultLandingMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.defaultLandingMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.defaultLandingMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.defaultLandingMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.defaultLandingMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.defaultLandingMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.defaultLandingMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.defaultLandingMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.defaultLandingMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.defaultLandingMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.defaultLandingMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.defaultLandingMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.defaultLandingMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.defaultLandingMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.defaultLandingMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.defaultLandingMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.defaultLandingMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.defaultLandingMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.defaultLandingMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.defaultLandingMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.defaultLandingMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.defaultLandingMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.defaultLandingMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.defaultLandingMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.defaultLandingMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.defaultLandingMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.defaultLandingMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.defaultLandingMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.defaultLandingMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.defaultLandingMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.defaultLandingMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.defaultLandingMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.defaultLandingMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.defaultLandingMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.defaultLandingMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.defaultLandingMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.defaultLandingMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.defaultLandingMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.defaultLandingMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.defaultLandingMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.defaultLandingMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.defaultLandingMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.defaultLandingMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.defaultLandingMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.defaultLandingMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.defaultLandingMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.defaultLandingMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.defaultLandingMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.defaultLandingMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.defaultLandingMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.defaultLandingMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.defaultLandingMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.enabledInputTargetMetrics) {
                            if (!Array.isArray(object.enabledInputTargetMetrics))
                                throw TypeError(".palexy.streaming.v1.Company.enabledInputTargetMetrics: array expected");
                            message.enabledInputTargetMetrics = [];
                            for (var i = 0; i < object.enabledInputTargetMetrics.length; ++i)
                                switch (object.enabledInputTargetMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.enabledInputTargetMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.enabledInputTargetMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.enabledInputTargetMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.enabledInputTargetMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.enabledInputTargetMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.enabledInputTargetMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.enabledInputTargetMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.enabledInputTargetMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.enabledInputTargetMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.enabledInputTargetMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.enabledInputTargetMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.enabledInputTargetMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.enabledInputTargetMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.enabledInputTargetMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.enabledInputTargetMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.enabledInputTargetMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.enabledInputTargetMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.enabledInputTargetMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.enabledInputTargetMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.enabledInputTargetMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.enabledInputTargetMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.enabledInputTargetMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.enabledInputTargetMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.enabledInputTargetMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.enabledInputTargetMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.enabledInputTargetMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.enabledInputTargetMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.enabledInputTargetMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.enabledInputTargetMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.enabledInputTargetMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.enabledInputTargetMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.enabledInputTargetMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.enabledInputTargetMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.enabledInputTargetMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.enabledInputTargetMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.enabledInputTargetMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.enabledInputTargetMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.enabledInputTargetMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.enabledInputTargetMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.enabledInputTargetMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.enabledInputTargetMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.enabledInputTargetMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.enabledInputTargetMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.enabledInputTargetMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.enabledInputTargetMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.enabledInputTargetMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.enabledInputTargetMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.enabledInputTargetMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.enabledInputTargetMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.enabledInputTargetMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.enabledInputTargetMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.enabledInputTargetMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.enabledInputTargetMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.enabledInputTargetMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.enabledInputTargetMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.enabledInputTargetMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.enabledInputTargetMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.enabledInputTargetMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.enabledInputTargetMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.enabledInputTargetMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.enabledInputTargetMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.enabledInputTargetMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.enabledInputTargetMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.enabledInputTargetMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.enabledInputTargetMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.enabledInputTargetMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.enabledInputTargetMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.enabledInputTargetMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.enabledInputTargetMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.enabledInputTargetMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.enabledInputTargetMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.enabledInputTargetMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.enabledInputTargetMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.enabledInputTargetMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.enabledInputTargetMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.enabledInputTargetMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.enabledInputTargetMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.enabledInputTargetMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.enabledInputTargetMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.enabledInputTargetMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.enabledInputTargetMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.enabledInputTargetMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.enabledInputTargetMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.enabledInputTargetMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.enabledInputTargetMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.enabledInputTargetMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.enabledInputTargetMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.enabledInputTargetMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.enabledInputTargetMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.enabledInputTargetMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.enabledInputTargetMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.enabledInputTargetMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.enabledInputTargetMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.enabledInputTargetMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.enabledInputTargetMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.enabledInputTargetMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.enabledInputTargetMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.enabledInputTargetMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.enabledInputTargetMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.enabledInputTargetMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.enabledInputTargetMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.enabledInputTargetMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.enabledInputTargetMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.enabledInputTargetMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.enabledInputTargetMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.enabledInputTargetMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.enabledInputTargetMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.enabledInputTargetMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.enabledInputTargetMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.enabledInputTargetMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.enabledInputTargetMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.enabledInputTargetMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.enabledInputTargetMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.enabledInputTargetMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.enabledInputTargetMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.enabledInputTargetMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.enabledInputTargetMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.enabledInputTargetMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.enabledInputTargetMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.enabledInputTargetMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.enabledInputTargetMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.enabledInputTargetMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.enabledInputTargetMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.enabledInputTargetMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.enabledInputTargetMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.enabledInputTargetMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.enabledInputTargetMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.enabledInputTargetMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.enabledInputTargetMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.enabledInputTargetMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.enabledInputTargetMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.enabledInputTargetMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.enabledInputTargetMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.enabledInputTargetMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.enabledInputTargetMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.enabledInputTargetMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.enabledInputTargetMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.enabledInputTargetMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.enabledInputTargetMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.enabledInputTargetMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.enabledInputTargetMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.enabledInputTargetMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.enabledInputTargetMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.enabledInputTargetMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.enabledInputTargetMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.enabledInputTargetMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.enabledInputTargetMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.enabledInputTargetMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.enabledInputTargetMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.enabledInputTargetMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.enabledInputTargetMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.enabledInputTargetMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.enabledInputTargetMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.enabledInputTargetMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.enabledInputTargetMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.enabledInputTargetMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.enabledInputTargetMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.enabledInputTargetMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.enabledInputTargetMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.enabledInputTargetMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.enabledInputTargetMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.enabledInputTargetMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.enabledInputTargetMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.enabledInputTargetMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.enabledInputTargetMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.enabledInputTargetMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.enabledInputTargetMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.enabledInputTargetMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.enabledInputTargetMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.enabledInputTargetMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.enabledInputTargetMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.enabledInputTargetMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.enabledInputTargetMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.enabledInputTargetMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.enabledInputTargetMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.enabledInputTargetMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.enabledInputTargetMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.enabledInputTargetMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.enabledInputTargetMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.enabledInputTargetMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.enabledInputTargetMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.enabledInputTargetMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.enabledInputTargetMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.enabledInputTargetMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.enabledInputTargetMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.enabledInputTargetMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.enabledInputTargetMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.enabledInputTargetMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.enabledInputTargetMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.enabledInputTargetMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.enabledInputTargetMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.enabledInputTargetMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.enabledInputTargetMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.enabledInputTargetMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.enabledInputTargetMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.enabledInputTargetMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.enabledInputTargetMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.enabledInputTargetMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.enabledInputTargetMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.enabledInputTargetMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.enabledInputTargetMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.enabledInputTargetMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.enabledInputTargetMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.enabledInputTargetMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.enabledInputTargetMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.enabledInputTargetMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.enabledInputTargetMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.enabledInputTargetMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.enabledInputTargetMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.enabledInputTargetMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.enabledInputTargetMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.enabledInputTargetMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.enabledInputTargetMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.enabledInputTargetMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.enabledInputTargetMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.enabledInputTargetMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.enabledInputTargetMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.enabledInputTargetMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.enabledInputTargetMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.enabledInputTargetMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.enabledInputTargetMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.enabledInputTargetMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.enabledInputTargetMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.enabledInputTargetMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.enabledInputTargetMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.enabledInputTargetMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.enabledInputTargetMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.enabledInputTargetMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.enabledInputTargetMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.enabledInputTargetMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.enabledInputTargetMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.enabledInputTargetMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.enabledInputTargetMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.enabledInputTargetMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.enabledInputTargetMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.enabledInputTargetMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.enabledInputTargetMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.enabledInputTargetMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.enabledInputTargetMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.enabledInputTargetMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.enabledInputTargetMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.enabledDisplayTargetMetrics) {
                            if (!Array.isArray(object.enabledDisplayTargetMetrics))
                                throw TypeError(".palexy.streaming.v1.Company.enabledDisplayTargetMetrics: array expected");
                            message.enabledDisplayTargetMetrics = [];
                            for (var i = 0; i < object.enabledDisplayTargetMetrics.length; ++i)
                                switch (object.enabledDisplayTargetMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.enabledDisplayTargetMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.enabledDisplayTargetMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.enabledDisplayTargetMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.enabledDisplayTargetMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.enabledDisplayTargetMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.enabledDisplayTargetMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.enabledDisplayTargetMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.enabledDisplayTargetMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.enabledDisplayTargetMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.enabledDisplayTargetMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.enabledDisplayTargetMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.enabledDisplayTargetMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.enabledDisplayTargetMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.enabledDisplayTargetMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.enabledDisplayTargetMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.enabledDisplayTargetMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.enabledDisplayTargetMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.enabledDisplayTargetMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.enabledDisplayTargetMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.enabledDisplayTargetMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.enabledDisplayTargetMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.enabledDisplayTargetMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.enabledDisplayTargetMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.enabledDisplayTargetMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.enabledDisplayTargetMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.enabledDisplayTargetMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.enabledDisplayTargetMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.enabledDisplayTargetMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.enabledDisplayTargetMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.enabledDisplayTargetMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.enabledDisplayTargetMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.enabledDisplayTargetMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.enabledDisplayTargetMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.enabledDisplayTargetMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.enabledDisplayTargetMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.enabledDisplayTargetMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.enabledDisplayTargetMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.enabledDisplayTargetMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.enabledDisplayTargetMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.enabledDisplayTargetMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.enabledDisplayTargetMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.enabledDisplayTargetMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.enabledDisplayTargetMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.enabledDisplayTargetMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.enabledDisplayTargetMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.enabledDisplayTargetMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.enabledDisplayTargetMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.enabledDisplayTargetMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.enabledDisplayTargetMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.enabledDisplayTargetMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.enabledDisplayTargetMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.enabledDisplayTargetMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.enabledDisplayTargetMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.enabledDisplayTargetMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.enabledDisplayTargetMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.enabledDisplayTargetMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.enabledDisplayTargetMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.enabledDisplayTargetMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.enabledDisplayTargetMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.enabledDisplayTargetMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.enabledDisplayTargetMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.enabledDisplayTargetMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.enabledDisplayTargetMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.enabledDisplayTargetMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.enabledDisplayTargetMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.enabledDisplayTargetMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.enabledDisplayTargetMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.enabledDisplayTargetMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.enabledDisplayTargetMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.enabledDisplayTargetMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.enabledDisplayTargetMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.enabledDisplayTargetMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.enabledDisplayTargetMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.enabledDisplayTargetMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.enabledDisplayTargetMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.enabledDisplayTargetMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.enabledDisplayTargetMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.enabledDisplayTargetMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.enabledDisplayTargetMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.enabledDisplayTargetMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.enabledDisplayTargetMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.enabledDisplayTargetMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.enabledDisplayTargetMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.enabledDisplayTargetMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.enabledDisplayTargetMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.enabledDisplayTargetMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.enabledDisplayTargetMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.enabledDisplayTargetMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.enabledDisplayTargetMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.enabledDisplayTargetMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.enabledDisplayTargetMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.enabledDisplayTargetMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.enabledDisplayTargetMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.enabledDisplayTargetMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.enabledDisplayTargetMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.enabledDisplayTargetMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.enabledDisplayTargetMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.enabledDisplayTargetMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.enabledDisplayTargetMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.enabledDisplayTargetMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.enabledDisplayTargetMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.enabledDisplayTargetMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.enabledDisplayTargetMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.enabledDisplayTargetMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.enabledDisplayTargetMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.enabledDisplayTargetMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.enabledDisplayTargetMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.enabledDisplayTargetMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.enabledDisplayTargetMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.enabledDisplayTargetMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.enabledDisplayTargetMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.enabledDisplayTargetMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.enabledDisplayTargetMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.enabledDisplayTargetMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.enabledDisplayTargetMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.enabledDisplayTargetMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.enabledDisplayTargetMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.enabledDisplayTargetMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.enabledDisplayTargetMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.enabledDisplayTargetMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.enabledDisplayTargetMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.enabledDisplayTargetMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.enabledDisplayTargetMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.enabledDisplayTargetMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.enabledDisplayTargetMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.enabledDisplayTargetMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.enabledDisplayTargetMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.enabledDisplayTargetMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.enabledDisplayTargetMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.enabledDisplayTargetMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.enabledDisplayTargetMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.enabledDisplayTargetMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.enabledDisplayTargetMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.enabledDisplayTargetMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.enabledDisplayTargetMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.enabledDisplayTargetMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.enabledDisplayTargetMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.enabledDisplayTargetMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.enabledDisplayTargetMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.enabledDisplayTargetMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.enabledDisplayTargetMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.enabledDisplayTargetMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.enabledDisplayTargetMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.enabledDisplayTargetMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.enabledDisplayTargetMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.enabledDisplayTargetMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.enabledDisplayTargetMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.enabledDisplayTargetMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.enabledDisplayTargetMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.enabledDisplayTargetMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.enabledDisplayTargetMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.enabledDisplayTargetMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.enabledDisplayTargetMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.enabledDisplayTargetMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.enabledDisplayTargetMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.enabledDisplayTargetMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.enabledDisplayTargetMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.enabledDisplayTargetMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.enabledDisplayTargetMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.enabledDisplayTargetMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.enabledDisplayTargetMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.enabledDisplayTargetMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.enabledDisplayTargetMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.enabledDisplayTargetMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.enabledDisplayTargetMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.enabledDisplayTargetMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.enabledDisplayTargetMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.enabledDisplayTargetMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.enabledDisplayTargetMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.enabledDisplayTargetMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.enabledDisplayTargetMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.enabledDisplayTargetMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.enabledDisplayTargetMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.enabledDisplayTargetMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.enabledDisplayTargetMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.enabledDisplayTargetMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.enabledDisplayTargetMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.enabledDisplayTargetMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.enabledDisplayTargetMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.enabledDisplayTargetMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.enabledDisplayTargetMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.enabledDisplayTargetMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.enabledDisplayTargetMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.enabledDisplayTargetMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.enabledDisplayTargetMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.enabledDisplayTargetMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.enabledDisplayTargetMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.enabledDisplayTargetMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.enabledDisplayTargetMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.enabledDisplayTargetMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.enabledDisplayTargetMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.enabledDisplayTargetMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.enabledDisplayTargetMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.enabledDisplayTargetMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.enabledDisplayTargetMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.enabledDisplayTargetMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.enabledDisplayTargetMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.enabledDisplayTargetMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.enabledDisplayTargetMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.enabledDisplayTargetMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.enabledDisplayTargetMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.enabledDisplayTargetMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.enabledDisplayTargetMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.enabledDisplayTargetMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.enabledDisplayTargetMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.enabledDisplayTargetMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.enabledDisplayTargetMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.enabledDisplayTargetMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.enabledDisplayTargetMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.enabledDisplayTargetMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.enabledDisplayTargetMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.enabledDisplayTargetMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.enabledDisplayTargetMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.enabledDisplayTargetMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.enabledDisplayTargetMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.enabledDisplayTargetMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.enabledDisplayTargetMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.enabledDisplayTargetMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.enabledDisplayTargetMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.enabledDisplayTargetMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.enabledDisplayTargetMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.enabledDisplayTargetMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.enabledDisplayTargetMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.enabledDisplayTargetMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.enabledDisplayTargetMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.enabledDisplayTargetMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.enabledDisplayTargetMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.enabledDisplayTargetMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.enabledDisplayTargetMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.enabledDisplayTargetMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.enabledDisplayTargetMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.enabledDisplayTargetMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.enabledDisplayTargetMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.enabledDisplayTargetMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.enabledDisplayTargetMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.enabledDisplayTargetMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.enabledDisplayTargetMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.enabledDisplayTargetMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.enabledDisplayTargetMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.enabledDisplayTargetMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.enabledDisplayTargetMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.enabledGenerateInsightTypes) {
                            if (!Array.isArray(object.enabledGenerateInsightTypes))
                                throw TypeError(".palexy.streaming.v1.Company.enabledGenerateInsightTypes: array expected");
                            message.enabledGenerateInsightTypes = [];
                            for (var i = 0; i < object.enabledGenerateInsightTypes.length; ++i)
                                message.enabledGenerateInsightTypes[i] = String(object.enabledGenerateInsightTypes[i]);
                        }
                        if (object.enabledDisplayInsightTypes) {
                            if (!Array.isArray(object.enabledDisplayInsightTypes))
                                throw TypeError(".palexy.streaming.v1.Company.enabledDisplayInsightTypes: array expected");
                            message.enabledDisplayInsightTypes = [];
                            for (var i = 0; i < object.enabledDisplayInsightTypes.length; ++i)
                                message.enabledDisplayInsightTypes[i] = String(object.enabledDisplayInsightTypes[i]);
                        }
                        if (object.threeWeeksTrendInsightMetrics) {
                            if (!Array.isArray(object.threeWeeksTrendInsightMetrics))
                                throw TypeError(".palexy.streaming.v1.Company.threeWeeksTrendInsightMetrics: array expected");
                            message.threeWeeksTrendInsightMetrics = [];
                            for (var i = 0; i < object.threeWeeksTrendInsightMetrics.length; ++i)
                                switch (object.threeWeeksTrendInsightMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.threeWeeksTrendInsightMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.threeWeeksTrendInsightMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.threeWeeksTrendInsightMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.threeWeeksTrendInsightMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.threeWeeksTrendInsightMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.threeWeeksTrendInsightMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.threeWeeksTrendInsightMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.threeWeeksTrendInsightMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.threeWeeksTrendInsightMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.threeWeeksTrendInsightMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.threeWeeksTrendInsightMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.threeWeeksTrendInsightMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.threeWeeksTrendInsightMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.threeWeeksTrendInsightMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.threeWeeksTrendInsightMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.threeWeeksTrendInsightMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.threeWeeksTrendInsightMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.threeWeeksTrendInsightMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.threeWeeksTrendInsightMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.threeWeeksTrendInsightMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.threeWeeksTrendInsightMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.threeWeeksTrendInsightMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.threeWeeksTrendInsightMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.threeWeeksTrendInsightMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.threeWeeksTrendInsightMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.threeWeeksTrendInsightMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.threeWeeksTrendInsightMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.threeWeeksTrendInsightMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.threeWeeksTrendInsightMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.threeWeeksTrendInsightMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.threeWeeksTrendInsightMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.threeWeeksTrendInsightMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.threeWeeksTrendInsightMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.threeWeeksTrendInsightMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.threeWeeksTrendInsightMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.threeWeeksTrendInsightMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.threeWeeksTrendInsightMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.threeWeeksTrendInsightMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.threeWeeksTrendInsightMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.threeWeeksTrendInsightMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.threeWeeksTrendInsightMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.threeWeeksTrendInsightMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.threeWeeksTrendInsightMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.threeWeeksTrendInsightMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.threeWeeksTrendInsightMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.threeWeeksTrendInsightMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.threeWeeksTrendInsightMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.threeWeeksTrendInsightMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.threeWeeksTrendInsightMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.threeWeeksTrendInsightMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.threeWeeksTrendInsightMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.threeWeeksTrendInsightMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.threeWeeksTrendInsightMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.threeWeeksTrendInsightMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.threeWeeksTrendInsightMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.threeWeeksTrendInsightMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.threeWeeksTrendInsightMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.threeWeeksTrendInsightMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.threeWeeksTrendInsightMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.threeWeeksTrendInsightMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.threeWeeksTrendInsightMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.threeWeeksTrendInsightMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.threeWeeksTrendInsightMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.threeWeeksTrendInsightMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.threeWeeksTrendInsightMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.threeWeeksTrendInsightMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.threeWeeksTrendInsightMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.threeWeeksTrendInsightMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.threeWeeksTrendInsightMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.threeWeeksTrendInsightMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.threeWeeksTrendInsightMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.threeWeeksTrendInsightMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.threeWeeksTrendInsightMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.threeWeeksTrendInsightMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.threeWeeksTrendInsightMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.threeWeeksTrendInsightMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.threeWeeksTrendInsightMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.threeWeeksTrendInsightMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.threeWeeksTrendInsightMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.threeWeeksTrendInsightMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.threeWeeksTrendInsightMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.threeWeeksTrendInsightMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.threeWeeksTrendInsightMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.threeWeeksTrendInsightMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.threeWeeksTrendInsightMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.threeWeeksTrendInsightMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.threeWeeksTrendInsightMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.threeWeeksTrendInsightMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.threeWeeksTrendInsightMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.threeWeeksTrendInsightMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.threeWeeksTrendInsightMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.threeWeeksTrendInsightMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.threeWeeksTrendInsightMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.threeWeeksTrendInsightMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.threeWeeksTrendInsightMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.threeWeeksTrendInsightMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.threeWeeksTrendInsightMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.threeWeeksTrendInsightMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.threeWeeksTrendInsightMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.threeWeeksTrendInsightMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.threeWeeksTrendInsightMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.threeWeeksTrendInsightMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.threeWeeksTrendInsightMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.threeWeeksTrendInsightMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.threeWeeksTrendInsightMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.threeWeeksTrendInsightMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.threeWeeksTrendInsightMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.threeWeeksTrendInsightMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.threeWeeksTrendInsightMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.threeWeeksTrendInsightMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.threeWeeksTrendInsightMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.threeWeeksTrendInsightMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.threeWeeksTrendInsightMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.threeWeeksTrendInsightMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.threeWeeksTrendInsightMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.threeWeeksTrendInsightMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.threeWeeksTrendInsightMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.threeWeeksTrendInsightMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.threeWeeksTrendInsightMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.threeWeeksTrendInsightMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.threeWeeksTrendInsightMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.threeWeeksTrendInsightMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.threeWeeksTrendInsightMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.threeWeeksTrendInsightMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.threeWeeksTrendInsightMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.threeWeeksTrendInsightMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.threeWeeksTrendInsightMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.threeWeeksTrendInsightMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.threeWeeksTrendInsightMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.threeWeeksTrendInsightMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.threeWeeksTrendInsightMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.threeWeeksTrendInsightMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.threeWeeksTrendInsightMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.threeWeeksTrendInsightMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.threeWeeksTrendInsightMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.threeWeeksTrendInsightMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.threeWeeksTrendInsightMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.threeWeeksTrendInsightMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.threeWeeksTrendInsightMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.threeWeeksTrendInsightMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.threeWeeksTrendInsightMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.threeWeeksTrendInsightMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.threeWeeksTrendInsightMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.threeWeeksTrendInsightMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.threeWeeksTrendInsightMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.threeWeeksTrendInsightMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.threeWeeksTrendInsightMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.threeWeeksTrendInsightMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.threeWeeksTrendInsightMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.threeWeeksTrendInsightMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.threeWeeksTrendInsightMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.threeWeeksTrendInsightMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.threeWeeksTrendInsightMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.threeWeeksTrendInsightMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.threeWeeksTrendInsightMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.threeWeeksTrendInsightMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.threeWeeksTrendInsightMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.threeWeeksTrendInsightMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.threeWeeksTrendInsightMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.threeWeeksTrendInsightMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.threeWeeksTrendInsightMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.threeWeeksTrendInsightMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.threeWeeksTrendInsightMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.threeWeeksTrendInsightMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.threeWeeksTrendInsightMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.threeWeeksTrendInsightMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.threeWeeksTrendInsightMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.threeWeeksTrendInsightMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.threeWeeksTrendInsightMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.threeWeeksTrendInsightMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.threeWeeksTrendInsightMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.threeWeeksTrendInsightMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.threeWeeksTrendInsightMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.threeWeeksTrendInsightMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.threeWeeksTrendInsightMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.threeWeeksTrendInsightMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.threeWeeksTrendInsightMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.threeWeeksTrendInsightMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.threeWeeksTrendInsightMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.threeWeeksTrendInsightMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.threeWeeksTrendInsightMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.threeWeeksTrendInsightMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.threeWeeksTrendInsightMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.threeWeeksTrendInsightMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.threeWeeksTrendInsightMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.threeWeeksTrendInsightMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.threeWeeksTrendInsightMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.threeWeeksTrendInsightMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.threeWeeksTrendInsightMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.threeWeeksTrendInsightMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.threeWeeksTrendInsightMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.threeWeeksTrendInsightMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.threeWeeksTrendInsightMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.threeWeeksTrendInsightMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.threeWeeksTrendInsightMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.threeWeeksTrendInsightMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.threeWeeksTrendInsightMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.threeWeeksTrendInsightMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.threeWeeksTrendInsightMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.threeWeeksTrendInsightMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.threeWeeksTrendInsightMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.threeWeeksTrendInsightMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.threeWeeksTrendInsightMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.threeWeeksTrendInsightMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.threeWeeksTrendInsightMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.threeWeeksTrendInsightMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.threeWeeksTrendInsightMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.threeWeeksTrendInsightMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.threeWeeksTrendInsightMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.threeWeeksTrendInsightMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.threeWeeksTrendInsightMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.threeWeeksTrendInsightMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.threeWeeksTrendInsightMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.threeWeeksTrendInsightMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.threeWeeksTrendInsightMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.threeWeeksTrendInsightMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.threeWeeksTrendInsightMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.threeWeeksTrendInsightMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.threeWeeksTrendInsightMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.threeWeeksTrendInsightMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.threeWeeksTrendInsightMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.threeWeeksTrendInsightMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.threeWeeksTrendInsightMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.threeWeeksTrendInsightMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.threeWeeksTrendInsightMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.threeWeeksTrendInsightMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.threeWeeksTrendInsightMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.threeWeeksTrendInsightMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.threeWeeksTrendInsightMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.threeWeeksTrendInsightMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.threeWeeksTrendInsightMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.threeWeeksTrendInsightMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.threeWeeksTrendInsightMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.threeWeeksTrendInsightMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.threeWeeksTrendInsightMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.threeWeeksTrendInsightMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.threeWeeksTrendInsightMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.threeWeeksTrendInsightMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.threeWeeksTrendInsightMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.threeWeeksTrendInsightMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.threeWeeksTrendInsightMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.excludedScheduledTaskTypes) {
                            if (!Array.isArray(object.excludedScheduledTaskTypes))
                                throw TypeError(".palexy.streaming.v1.Company.excludedScheduledTaskTypes: array expected");
                            message.excludedScheduledTaskTypes = [];
                            for (var i = 0; i < object.excludedScheduledTaskTypes.length; ++i)
                                switch (object.excludedScheduledTaskTypes[i]) {
                                default:
                                case "SCHEDULED_TASK_TYPE_UNKNOWN":
                                case 0:
                                    message.excludedScheduledTaskTypes[i] = 0;
                                    break;
                                case "SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS":
                                case 1:
                                    message.excludedScheduledTaskTypes[i] = 1;
                                    break;
                                case "SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS":
                                case 2:
                                    message.excludedScheduledTaskTypes[i] = 2;
                                    break;
                                case "SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS":
                                case 3:
                                    message.excludedScheduledTaskTypes[i] = 3;
                                    break;
                                case "SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS":
                                case 4:
                                    message.excludedScheduledTaskTypes[i] = 4;
                                    break;
                                case "SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS":
                                case 5:
                                    message.excludedScheduledTaskTypes[i] = 5;
                                    break;
                                case "SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS":
                                case 6:
                                    message.excludedScheduledTaskTypes[i] = 6;
                                    break;
                                case "SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS":
                                case 7:
                                    message.excludedScheduledTaskTypes[i] = 7;
                                    break;
                                case "SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER":
                                case 8:
                                    message.excludedScheduledTaskTypes[i] = 8;
                                    break;
                                case "SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY":
                                case 9:
                                    message.excludedScheduledTaskTypes[i] = 9;
                                    break;
                                case "SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS":
                                case 10:
                                    message.excludedScheduledTaskTypes[i] = 10;
                                    break;
                                case "SCHEDULED_AVAILABILITY_AUTO_LOCK":
                                case 11:
                                    message.excludedScheduledTaskTypes[i] = 11;
                                    break;
                                case "SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS":
                                case 12:
                                    message.excludedScheduledTaskTypes[i] = 12;
                                    break;
                                case "SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS":
                                case 13:
                                    message.excludedScheduledTaskTypes[i] = 13;
                                    break;
                                case "SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER":
                                case 14:
                                    message.excludedScheduledTaskTypes[i] = 14;
                                    break;
                                case "SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER":
                                case 15:
                                    message.excludedScheduledTaskTypes[i] = 15;
                                    break;
                                }
                        }
                        if (object.videoGroupSizeBuckets != null)
                            message.videoGroupSizeBuckets = String(object.videoGroupSizeBuckets);
                        if (object.criticalHoursOfDaysOfWeek) {
                            if (!Array.isArray(object.criticalHoursOfDaysOfWeek))
                                throw TypeError(".palexy.streaming.v1.Company.criticalHoursOfDaysOfWeek: array expected");
                            message.criticalHoursOfDaysOfWeek = [];
                            for (var i = 0; i < object.criticalHoursOfDaysOfWeek.length; ++i) {
                                if (typeof object.criticalHoursOfDaysOfWeek[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Company.criticalHoursOfDaysOfWeek: object expected");
                                message.criticalHoursOfDaysOfWeek[i] = $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek.fromObject(object.criticalHoursOfDaysOfWeek[i]);
                            }
                        }
                        if (object.posStaffSyncEnabled != null)
                            message.posStaffSyncEnabled = Boolean(object.posStaffSyncEnabled);
                        if (object.storeRelationshipEnabled != null)
                            message.storeRelationshipEnabled = Boolean(object.storeRelationshipEnabled);
                        if (object.discountMetricsEnabled != null)
                            message.discountMetricsEnabled = Boolean(object.discountMetricsEnabled);
                        if (object.discountDistributionBuckets != null)
                            message.discountDistributionBuckets = String(object.discountDistributionBuckets);
                        if (object.includeReturningItemsForDiscountAnalysis != null)
                            message.includeReturningItemsForDiscountAnalysis = Boolean(object.includeReturningItemsForDiscountAnalysis);
                        if (object.activityLogCleanUpIntervalInDays != null)
                            message.activityLogCleanUpIntervalInDays = object.activityLogCleanUpIntervalInDays | 0;
                        switch (object.transactionCalculationMethod) {
                        case "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED":
                        case 0:
                            message.transactionCalculationMethod = 0;
                            break;
                        case "ALL_TRANSACTIONS":
                        case 1:
                            message.transactionCalculationMethod = 1;
                            break;
                        case "SALE_ONLY":
                        case 2:
                            message.transactionCalculationMethod = 2;
                            break;
                        case "SALE_MINUS_RETURN":
                        case 3:
                            message.transactionCalculationMethod = 3;
                            break;
                        }
                        if (object.staffScheduleDemandCoverageThreshold != null)
                            message.staffScheduleDemandCoverageThreshold = Number(object.staffScheduleDemandCoverageThreshold);
                        if (object.staffScheduleLowerDemandCoverageThreshold != null)
                            message.staffScheduleLowerDemandCoverageThreshold = Number(object.staffScheduleLowerDemandCoverageThreshold);
                        if (object.genderAgeGroupModelName != null)
                            message.genderAgeGroupModelName = String(object.genderAgeGroupModelName);
                        if (object.ageGroupThresholds) {
                            if (!Array.isArray(object.ageGroupThresholds))
                                throw TypeError(".palexy.streaming.v1.Company.ageGroupThresholds: array expected");
                            message.ageGroupThresholds = [];
                            for (var i = 0; i < object.ageGroupThresholds.length; ++i)
                                message.ageGroupThresholds[i] = Number(object.ageGroupThresholds[i]);
                        }
                        if (object.enableFaceBlurring != null)
                            message.enableFaceBlurring = Boolean(object.enableFaceBlurring);
                        if (object.enableCopyingChangingRoomActionToCustomAction != null)
                            message.enableCopyingChangingRoomActionToCustomAction = Boolean(object.enableCopyingChangingRoomActionToCustomAction);
                        if (object.forecastModelVersionIdByMetric) {
                            if (typeof object.forecastModelVersionIdByMetric !== "object")
                                throw TypeError(".palexy.streaming.v1.Company.forecastModelVersionIdByMetric: object expected");
                            message.forecastModelVersionIdByMetric = {};
                            for (var keys = Object.keys(object.forecastModelVersionIdByMetric), i = 0; i < keys.length; ++i)
                                if ($util.Long)
                                    (message.forecastModelVersionIdByMetric[keys[i]] = $util.Long.fromValue(object.forecastModelVersionIdByMetric[keys[i]])).unsigned = false;
                                else if (typeof object.forecastModelVersionIdByMetric[keys[i]] === "string")
                                    message.forecastModelVersionIdByMetric[keys[i]] = parseInt(object.forecastModelVersionIdByMetric[keys[i]], 10);
                                else if (typeof object.forecastModelVersionIdByMetric[keys[i]] === "number")
                                    message.forecastModelVersionIdByMetric[keys[i]] = object.forecastModelVersionIdByMetric[keys[i]];
                                else if (typeof object.forecastModelVersionIdByMetric[keys[i]] === "object")
                                    message.forecastModelVersionIdByMetric[keys[i]] = new $util.LongBits(object.forecastModelVersionIdByMetric[keys[i]].low >>> 0, object.forecastModelVersionIdByMetric[keys[i]].high >>> 0).toNumber();
                        }
                        if (object.maxSessionInactiveIntervalInSeconds != null)
                            message.maxSessionInactiveIntervalInSeconds = object.maxSessionInactiveIntervalInSeconds | 0;
                        if (object.rememberMeTokenMaxAgeInSeconds != null)
                            message.rememberMeTokenMaxAgeInSeconds = object.rememberMeTokenMaxAgeInSeconds | 0;
                        if (object.mainSchedulePerformanceMetric != null)
                            message.mainSchedulePerformanceMetric = String(object.mainSchedulePerformanceMetric);
                        if (object.excludeQueueTimeInTotalServiceTime != null)
                            message.excludeQueueTimeInTotalServiceTime = Boolean(object.excludeQueueTimeInTotalServiceTime);
                        if (object.totalServiceTimeComplianceThreshold != null)
                            message.totalServiceTimeComplianceThreshold = object.totalServiceTimeComplianceThreshold | 0;
                        if (object.defaultTimezone != null)
                            message.defaultTimezone = String(object.defaultTimezone);
                        if (object.dailyInsightMetrics) {
                            if (!Array.isArray(object.dailyInsightMetrics))
                                throw TypeError(".palexy.streaming.v1.Company.dailyInsightMetrics: array expected");
                            message.dailyInsightMetrics = [];
                            for (var i = 0; i < object.dailyInsightMetrics.length; ++i)
                                switch (object.dailyInsightMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.dailyInsightMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.dailyInsightMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.dailyInsightMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.dailyInsightMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.dailyInsightMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.dailyInsightMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.dailyInsightMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.dailyInsightMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.dailyInsightMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.dailyInsightMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.dailyInsightMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.dailyInsightMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.dailyInsightMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.dailyInsightMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.dailyInsightMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.dailyInsightMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.dailyInsightMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.dailyInsightMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.dailyInsightMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.dailyInsightMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.dailyInsightMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.dailyInsightMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.dailyInsightMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.dailyInsightMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.dailyInsightMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.dailyInsightMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.dailyInsightMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.dailyInsightMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.dailyInsightMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.dailyInsightMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.dailyInsightMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.dailyInsightMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.dailyInsightMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.dailyInsightMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.dailyInsightMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.dailyInsightMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.dailyInsightMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.dailyInsightMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.dailyInsightMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.dailyInsightMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.dailyInsightMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.dailyInsightMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.dailyInsightMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.dailyInsightMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.dailyInsightMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.dailyInsightMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.dailyInsightMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.dailyInsightMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.dailyInsightMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.dailyInsightMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.dailyInsightMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.dailyInsightMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.dailyInsightMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.dailyInsightMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.dailyInsightMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.dailyInsightMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.dailyInsightMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.dailyInsightMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.dailyInsightMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.dailyInsightMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.dailyInsightMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.dailyInsightMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.dailyInsightMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.dailyInsightMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.dailyInsightMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.dailyInsightMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.dailyInsightMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.dailyInsightMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.dailyInsightMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.dailyInsightMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.dailyInsightMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.dailyInsightMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.dailyInsightMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.dailyInsightMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.dailyInsightMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.dailyInsightMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.dailyInsightMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.dailyInsightMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.dailyInsightMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.dailyInsightMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.dailyInsightMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.dailyInsightMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.dailyInsightMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.dailyInsightMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.dailyInsightMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.dailyInsightMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.dailyInsightMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.dailyInsightMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.dailyInsightMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.dailyInsightMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.dailyInsightMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.dailyInsightMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.dailyInsightMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.dailyInsightMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.dailyInsightMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.dailyInsightMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.dailyInsightMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.dailyInsightMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.dailyInsightMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.dailyInsightMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.dailyInsightMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.dailyInsightMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.dailyInsightMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.dailyInsightMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.dailyInsightMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.dailyInsightMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.dailyInsightMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.dailyInsightMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.dailyInsightMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.dailyInsightMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.dailyInsightMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.dailyInsightMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.dailyInsightMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.dailyInsightMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.dailyInsightMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.dailyInsightMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.dailyInsightMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.dailyInsightMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.dailyInsightMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.dailyInsightMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.dailyInsightMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.dailyInsightMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.dailyInsightMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.dailyInsightMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.dailyInsightMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.dailyInsightMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.dailyInsightMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.dailyInsightMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.dailyInsightMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.dailyInsightMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.dailyInsightMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.dailyInsightMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.dailyInsightMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.dailyInsightMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.dailyInsightMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.dailyInsightMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.dailyInsightMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.dailyInsightMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.dailyInsightMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.dailyInsightMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.dailyInsightMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.dailyInsightMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.dailyInsightMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.dailyInsightMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.dailyInsightMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.dailyInsightMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.dailyInsightMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.dailyInsightMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.dailyInsightMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.dailyInsightMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.dailyInsightMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.dailyInsightMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.dailyInsightMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.dailyInsightMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.dailyInsightMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.dailyInsightMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.dailyInsightMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.dailyInsightMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.dailyInsightMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.dailyInsightMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.dailyInsightMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.dailyInsightMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.dailyInsightMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.dailyInsightMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.dailyInsightMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.dailyInsightMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.dailyInsightMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.dailyInsightMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.dailyInsightMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.dailyInsightMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.dailyInsightMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.dailyInsightMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.dailyInsightMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.dailyInsightMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.dailyInsightMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.dailyInsightMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.dailyInsightMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.dailyInsightMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.dailyInsightMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.dailyInsightMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.dailyInsightMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.dailyInsightMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.dailyInsightMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.dailyInsightMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.dailyInsightMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.dailyInsightMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.dailyInsightMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.dailyInsightMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.dailyInsightMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.dailyInsightMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.dailyInsightMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.dailyInsightMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.dailyInsightMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.dailyInsightMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.dailyInsightMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.dailyInsightMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.dailyInsightMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.dailyInsightMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.dailyInsightMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.dailyInsightMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.dailyInsightMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.dailyInsightMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.dailyInsightMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.dailyInsightMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.dailyInsightMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.dailyInsightMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.dailyInsightMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.dailyInsightMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.dailyInsightMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.dailyInsightMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.dailyInsightMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.dailyInsightMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.dailyInsightMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.dailyInsightMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.dailyInsightMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.dailyInsightMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.dailyInsightMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.dailyInsightMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.dailyInsightMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.dailyInsightMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.dailyInsightMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.dailyInsightMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.dailyInsightMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.dailyInsightMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.dailyInsightMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.dailyInsightMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.dailyInsightMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.dailyInsightMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.dailyInsightMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.dailyInsightMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.dailyInsightMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.dailyInsightMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.dailyInsightMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.dailyInsightMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.dailyInsightMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.dailyInsightMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.dailyInsightMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.dailyInsightMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.dailyInsightMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.dailyInsightMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.dailyInsightMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.ibeImageBucket != null)
                            message.ibeImageBucket = String(object.ibeImageBucket);
                        if (object.checkoutTimeBuckets != null)
                            message.checkoutTimeBuckets = String(object.checkoutTimeBuckets);
                        if (object.enableTaskManagement != null)
                            message.enableTaskManagement = Boolean(object.enableTaskManagement);
                        if (object.enableFormManagement != null)
                            message.enableFormManagement = Boolean(object.enableFormManagement);
                        if (object.enableStoreOptimizer != null)
                            message.enableStoreOptimizer = Boolean(object.enableStoreOptimizer);
                        if (object.forecastBias != null)
                            message.forecastBias = Number(object.forecastBias);
                        if (object.sectionForecastMetadataTypeIds) {
                            if (!Array.isArray(object.sectionForecastMetadataTypeIds))
                                throw TypeError(".palexy.streaming.v1.Company.sectionForecastMetadataTypeIds: array expected");
                            message.sectionForecastMetadataTypeIds = [];
                            for (var i = 0; i < object.sectionForecastMetadataTypeIds.length; ++i)
                                if ($util.Long)
                                    (message.sectionForecastMetadataTypeIds[i] = $util.Long.fromValue(object.sectionForecastMetadataTypeIds[i])).unsigned = false;
                                else if (typeof object.sectionForecastMetadataTypeIds[i] === "string")
                                    message.sectionForecastMetadataTypeIds[i] = parseInt(object.sectionForecastMetadataTypeIds[i], 10);
                                else if (typeof object.sectionForecastMetadataTypeIds[i] === "number")
                                    message.sectionForecastMetadataTypeIds[i] = object.sectionForecastMetadataTypeIds[i];
                                else if (typeof object.sectionForecastMetadataTypeIds[i] === "object")
                                    message.sectionForecastMetadataTypeIds[i] = new $util.LongBits(object.sectionForecastMetadataTypeIds[i].low >>> 0, object.sectionForecastMetadataTypeIds[i].high >>> 0).toNumber();
                        }
                        if (object.disabled != null)
                            message.disabled = Boolean(object.disabled);
                        if (object.ownerAccount != null) {
                            if (typeof object.ownerAccount !== "object")
                                throw TypeError(".palexy.streaming.v1.Company.ownerAccount: object expected");
                            message.ownerAccount = $root.palexy.streaming.v1.Account.fromObject(object.ownerAccount);
                        }
                        if (object.storeTimezones) {
                            if (!Array.isArray(object.storeTimezones))
                                throw TypeError(".palexy.streaming.v1.Company.storeTimezones: array expected");
                            message.storeTimezones = [];
                            for (var i = 0; i < object.storeTimezones.length; ++i)
                                message.storeTimezones[i] = String(object.storeTimezones[i]);
                        }
                        if (object.blurringVideoConfig != null) {
                            if (typeof object.blurringVideoConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.Company.blurringVideoConfig: object expected");
                            message.blurringVideoConfig = $root.palexy.streaming.v1.BlurringVideoConfig.fromObject(object.blurringVideoConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Company message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Company
                     * @static
                     * @param {palexy.streaming.v1.Company} message Company
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Company.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.enabledStoreEventTypes = [];
                            object.storeSnapshotScheduledTimes = [];
                            object.weekends = [];
                            object.defaultLandingMetrics = [];
                            object.enabledInputTargetMetrics = [];
                            object.enabledDisplayTargetMetrics = [];
                            object.enabledGenerateInsightTypes = [];
                            object.enabledDisplayInsightTypes = [];
                            object.threeWeeksTrendInsightMetrics = [];
                            object.excludedScheduledTaskTypes = [];
                            object.criticalHoursOfDaysOfWeek = [];
                            object.ageGroupThresholds = [];
                            object.dailyInsightMetrics = [];
                            object.sectionForecastMetadataTypeIds = [];
                            object.storeTimezones = [];
                        }
                        if (options.objects || options.defaults)
                            object.forecastModelVersionIdByMetric = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.transformationMatrixEnabled = false;
                            object.logicalLayoutEnabled = false;
                            object.awsBucket = "";
                            object.gcsBucket = "";
                            object.companyCode = "";
                            object.partnerCode = "";
                            object.description = "";
                            object.entranceCounting = false;
                            object.entranceKeyword = "";
                            object.dwelltimeBuckets = "";
                            object.ageRanges = "";
                            object.sectionVisitDurationLimit = 0;
                            object.dwelltimeMetricDisabled = false;
                            object.interactionMetricDisabled = false;
                            object.transactionMetricDisabled = false;
                            object.groupMetricEnabled = false;
                            object.lyingMetricEnabled = false;
                            object.avgDwelltimeMetricDisabled = false;
                            object.layoutViewDisabled = false;
                            object.topSectionsViewDisabled = false;
                            object.dailyExport = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastExportTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastExportTimeMs = options.longs === String ? "0" : 0;
                            object.exportBucket = "";
                            object.exportNotificationEmails = "";
                            object.exportNotifyUrl = "";
                            object.integrationUsername = "";
                            object.rawIcaBucketName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.interactionLevelMetricEnabled = false;
                            object.visitorOccupancyMetricEnabled = false;
                            object.exportStorageProvider = "";
                            object.exportBucketRegion = "";
                            object.exportAccessKey = "";
                            object.exportSecretKey = "";
                            object.rawIcaStorageProvider = options.enums === String ? "RAW_PROVIDER_UNKNOWN" : 0;
                            object.integrationPassword = "";
                            object.exportPosMatchingResultEnabled = false;
                            object.usePosData = false;
                            object.salesAmountRelatedMetricsEnabled = false;
                            object.salesItemsRelatedMetricsEnabled = false;
                            object.useNetAmount = false;
                            object.passbyMetricEnabled = false;
                            object.createMatchingJobOnImportedPosDisabled = false;
                            object.rawIcaMergingBucketName = "";
                            object.nearRealTimeProcessingTimesOfDay = "";
                            object.sectionInteractionMetricEnabled = false;
                            object.sectionPosMetricEnabled = false;
                            object.visitorDirectionFeatureEnabled = false;
                            object.interactionTimeMetricEnabled = false;
                            object.exportRewriteHistoricalStaffingDays = 0;
                            object.exportOverwriteExistingFiles = false;
                            object.mfaRequired = false;
                            object.industry = options.enums === String ? "OTHERS" : 0;
                            object.useSalesItemsAsNetSalesItems = false;
                            object.staffPerformanceAnalysisMetricsEnabled = false;
                            object.staffPerformanceAnalysisStaffingMetricsEnabled = false;
                            object.estimatedTrafficMetricsEnabled = false;
                            object.enableStoreSnapshot = false;
                            object.enableForecast = false;
                            object.enableTargetTrackingForecast = false;
                            object.strictReportConsistencyEnabled = false;
                            object.storeOpenTimeBufferInSeconds = 0;
                            object.storeCloseTimeBufferInSeconds = 0;
                            object.startOfWeek = 0;
                            object.storeSnapshotRetentionDays = 0;
                            object.onTimeGreetingThresholdSec = 0;
                            object.productSalesAnalysisEnabled = false;
                            object.videoGroupSizeBuckets = "";
                            object.posStaffSyncEnabled = false;
                            object.storeRelationshipEnabled = false;
                            object.discountMetricsEnabled = false;
                            object.discountDistributionBuckets = "";
                            object.includeReturningItemsForDiscountAnalysis = false;
                            object.activityLogCleanUpIntervalInDays = 0;
                            object.transactionCalculationMethod = options.enums === String ? "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED" : 0;
                            object.genderAgeGroupModelName = "";
                            object.enableFaceBlurring = false;
                            object.staffScheduleDemandCoverageThreshold = 0;
                            object.enableCopyingChangingRoomActionToCustomAction = false;
                            object.maxSessionInactiveIntervalInSeconds = 0;
                            object.rememberMeTokenMaxAgeInSeconds = 0;
                            object.mainSchedulePerformanceMetric = "";
                            object.disabled = false;
                            object.staffScheduleLowerDemandCoverageThreshold = 0;
                            object.excludeQueueTimeInTotalServiceTime = false;
                            object.totalServiceTimeComplianceThreshold = 0;
                            object.defaultTimezone = "";
                            object.ibeImageBucket = "";
                            object.checkoutTimeBuckets = "";
                            object.enableTaskManagement = false;
                            object.enableFormManagement = false;
                            object.forecastBias = 0;
                            object.enableStoreOptimizer = false;
                            object.ownerAccount = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.transformationMatrixEnabled != null && message.hasOwnProperty("transformationMatrixEnabled"))
                            object.transformationMatrixEnabled = message.transformationMatrixEnabled;
                        if (message.logicalLayoutEnabled != null && message.hasOwnProperty("logicalLayoutEnabled"))
                            object.logicalLayoutEnabled = message.logicalLayoutEnabled;
                        if (message.awsBucket != null && message.hasOwnProperty("awsBucket"))
                            object.awsBucket = message.awsBucket;
                        if (message.gcsBucket != null && message.hasOwnProperty("gcsBucket"))
                            object.gcsBucket = message.gcsBucket;
                        if (message.companyCode != null && message.hasOwnProperty("companyCode"))
                            object.companyCode = message.companyCode;
                        if (message.partnerCode != null && message.hasOwnProperty("partnerCode"))
                            object.partnerCode = message.partnerCode;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.entranceCounting != null && message.hasOwnProperty("entranceCounting"))
                            object.entranceCounting = message.entranceCounting;
                        if (message.entranceKeyword != null && message.hasOwnProperty("entranceKeyword"))
                            object.entranceKeyword = message.entranceKeyword;
                        if (message.dwelltimeBuckets != null && message.hasOwnProperty("dwelltimeBuckets"))
                            object.dwelltimeBuckets = message.dwelltimeBuckets;
                        if (message.ageRanges != null && message.hasOwnProperty("ageRanges"))
                            object.ageRanges = message.ageRanges;
                        if (message.sectionVisitDurationLimit != null && message.hasOwnProperty("sectionVisitDurationLimit"))
                            object.sectionVisitDurationLimit = message.sectionVisitDurationLimit;
                        if (message.dwelltimeMetricDisabled != null && message.hasOwnProperty("dwelltimeMetricDisabled"))
                            object.dwelltimeMetricDisabled = message.dwelltimeMetricDisabled;
                        if (message.interactionMetricDisabled != null && message.hasOwnProperty("interactionMetricDisabled"))
                            object.interactionMetricDisabled = message.interactionMetricDisabled;
                        if (message.transactionMetricDisabled != null && message.hasOwnProperty("transactionMetricDisabled"))
                            object.transactionMetricDisabled = message.transactionMetricDisabled;
                        if (message.groupMetricEnabled != null && message.hasOwnProperty("groupMetricEnabled"))
                            object.groupMetricEnabled = message.groupMetricEnabled;
                        if (message.lyingMetricEnabled != null && message.hasOwnProperty("lyingMetricEnabled"))
                            object.lyingMetricEnabled = message.lyingMetricEnabled;
                        if (message.avgDwelltimeMetricDisabled != null && message.hasOwnProperty("avgDwelltimeMetricDisabled"))
                            object.avgDwelltimeMetricDisabled = message.avgDwelltimeMetricDisabled;
                        if (message.layoutViewDisabled != null && message.hasOwnProperty("layoutViewDisabled"))
                            object.layoutViewDisabled = message.layoutViewDisabled;
                        if (message.topSectionsViewDisabled != null && message.hasOwnProperty("topSectionsViewDisabled"))
                            object.topSectionsViewDisabled = message.topSectionsViewDisabled;
                        if (message.dailyExport != null && message.hasOwnProperty("dailyExport"))
                            object.dailyExport = message.dailyExport;
                        if (message.lastExportTimeMs != null && message.hasOwnProperty("lastExportTimeMs"))
                            if (typeof message.lastExportTimeMs === "number")
                                object.lastExportTimeMs = options.longs === String ? String(message.lastExportTimeMs) : message.lastExportTimeMs;
                            else
                                object.lastExportTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastExportTimeMs) : options.longs === Number ? new $util.LongBits(message.lastExportTimeMs.low >>> 0, message.lastExportTimeMs.high >>> 0).toNumber() : message.lastExportTimeMs;
                        if (message.exportBucket != null && message.hasOwnProperty("exportBucket"))
                            object.exportBucket = message.exportBucket;
                        if (message.exportNotificationEmails != null && message.hasOwnProperty("exportNotificationEmails"))
                            object.exportNotificationEmails = message.exportNotificationEmails;
                        if (message.exportNotifyUrl != null && message.hasOwnProperty("exportNotifyUrl"))
                            object.exportNotifyUrl = message.exportNotifyUrl;
                        if (message.integrationUsername != null && message.hasOwnProperty("integrationUsername"))
                            object.integrationUsername = message.integrationUsername;
                        if (message.rawIcaBucketName != null && message.hasOwnProperty("rawIcaBucketName"))
                            object.rawIcaBucketName = message.rawIcaBucketName;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.interactionLevelMetricEnabled != null && message.hasOwnProperty("interactionLevelMetricEnabled"))
                            object.interactionLevelMetricEnabled = message.interactionLevelMetricEnabled;
                        if (message.visitorOccupancyMetricEnabled != null && message.hasOwnProperty("visitorOccupancyMetricEnabled"))
                            object.visitorOccupancyMetricEnabled = message.visitorOccupancyMetricEnabled;
                        if (message.exportStorageProvider != null && message.hasOwnProperty("exportStorageProvider"))
                            object.exportStorageProvider = message.exportStorageProvider;
                        if (message.exportBucketRegion != null && message.hasOwnProperty("exportBucketRegion"))
                            object.exportBucketRegion = message.exportBucketRegion;
                        if (message.exportAccessKey != null && message.hasOwnProperty("exportAccessKey"))
                            object.exportAccessKey = message.exportAccessKey;
                        if (message.exportSecretKey != null && message.hasOwnProperty("exportSecretKey"))
                            object.exportSecretKey = message.exportSecretKey;
                        if (message.rawIcaStorageProvider != null && message.hasOwnProperty("rawIcaStorageProvider"))
                            object.rawIcaStorageProvider = options.enums === String ? $root.palexy.streaming.v1.RawIcaStorageProvider[message.rawIcaStorageProvider] : message.rawIcaStorageProvider;
                        if (message.integrationPassword != null && message.hasOwnProperty("integrationPassword"))
                            object.integrationPassword = message.integrationPassword;
                        if (message.exportPosMatchingResultEnabled != null && message.hasOwnProperty("exportPosMatchingResultEnabled"))
                            object.exportPosMatchingResultEnabled = message.exportPosMatchingResultEnabled;
                        if (message.usePosData != null && message.hasOwnProperty("usePosData"))
                            object.usePosData = message.usePosData;
                        if (message.salesAmountRelatedMetricsEnabled != null && message.hasOwnProperty("salesAmountRelatedMetricsEnabled"))
                            object.salesAmountRelatedMetricsEnabled = message.salesAmountRelatedMetricsEnabled;
                        if (message.salesItemsRelatedMetricsEnabled != null && message.hasOwnProperty("salesItemsRelatedMetricsEnabled"))
                            object.salesItemsRelatedMetricsEnabled = message.salesItemsRelatedMetricsEnabled;
                        if (message.useNetAmount != null && message.hasOwnProperty("useNetAmount"))
                            object.useNetAmount = message.useNetAmount;
                        if (message.passbyMetricEnabled != null && message.hasOwnProperty("passbyMetricEnabled"))
                            object.passbyMetricEnabled = message.passbyMetricEnabled;
                        if (message.createMatchingJobOnImportedPosDisabled != null && message.hasOwnProperty("createMatchingJobOnImportedPosDisabled"))
                            object.createMatchingJobOnImportedPosDisabled = message.createMatchingJobOnImportedPosDisabled;
                        if (message.rawIcaMergingBucketName != null && message.hasOwnProperty("rawIcaMergingBucketName"))
                            object.rawIcaMergingBucketName = message.rawIcaMergingBucketName;
                        if (message.nearRealTimeProcessingTimesOfDay != null && message.hasOwnProperty("nearRealTimeProcessingTimesOfDay"))
                            object.nearRealTimeProcessingTimesOfDay = message.nearRealTimeProcessingTimesOfDay;
                        if (message.sectionInteractionMetricEnabled != null && message.hasOwnProperty("sectionInteractionMetricEnabled"))
                            object.sectionInteractionMetricEnabled = message.sectionInteractionMetricEnabled;
                        if (message.sectionPosMetricEnabled != null && message.hasOwnProperty("sectionPosMetricEnabled"))
                            object.sectionPosMetricEnabled = message.sectionPosMetricEnabled;
                        if (message.visitorDirectionFeatureEnabled != null && message.hasOwnProperty("visitorDirectionFeatureEnabled"))
                            object.visitorDirectionFeatureEnabled = message.visitorDirectionFeatureEnabled;
                        if (message.interactionTimeMetricEnabled != null && message.hasOwnProperty("interactionTimeMetricEnabled"))
                            object.interactionTimeMetricEnabled = message.interactionTimeMetricEnabled;
                        if (message.exportRewriteHistoricalStaffingDays != null && message.hasOwnProperty("exportRewriteHistoricalStaffingDays"))
                            object.exportRewriteHistoricalStaffingDays = message.exportRewriteHistoricalStaffingDays;
                        if (message.exportOverwriteExistingFiles != null && message.hasOwnProperty("exportOverwriteExistingFiles"))
                            object.exportOverwriteExistingFiles = message.exportOverwriteExistingFiles;
                        if (message.mfaRequired != null && message.hasOwnProperty("mfaRequired"))
                            object.mfaRequired = message.mfaRequired;
                        if (message.industry != null && message.hasOwnProperty("industry"))
                            object.industry = options.enums === String ? $root.palexy.streaming.v1.Company.Industry[message.industry] : message.industry;
                        if (message.useSalesItemsAsNetSalesItems != null && message.hasOwnProperty("useSalesItemsAsNetSalesItems"))
                            object.useSalesItemsAsNetSalesItems = message.useSalesItemsAsNetSalesItems;
                        if (message.staffPerformanceAnalysisMetricsEnabled != null && message.hasOwnProperty("staffPerformanceAnalysisMetricsEnabled"))
                            object.staffPerformanceAnalysisMetricsEnabled = message.staffPerformanceAnalysisMetricsEnabled;
                        if (message.staffPerformanceAnalysisStaffingMetricsEnabled != null && message.hasOwnProperty("staffPerformanceAnalysisStaffingMetricsEnabled"))
                            object.staffPerformanceAnalysisStaffingMetricsEnabled = message.staffPerformanceAnalysisStaffingMetricsEnabled;
                        if (message.enabledStoreEventTypes && message.enabledStoreEventTypes.length) {
                            object.enabledStoreEventTypes = [];
                            for (var j = 0; j < message.enabledStoreEventTypes.length; ++j)
                                object.enabledStoreEventTypes[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.enabledStoreEventTypes[j]] : message.enabledStoreEventTypes[j];
                        }
                        if (message.estimatedTrafficMetricsEnabled != null && message.hasOwnProperty("estimatedTrafficMetricsEnabled"))
                            object.estimatedTrafficMetricsEnabled = message.estimatedTrafficMetricsEnabled;
                        if (message.enableStoreSnapshot != null && message.hasOwnProperty("enableStoreSnapshot"))
                            object.enableStoreSnapshot = message.enableStoreSnapshot;
                        if (message.enableForecast != null && message.hasOwnProperty("enableForecast"))
                            object.enableForecast = message.enableForecast;
                        if (message.enableTargetTrackingForecast != null && message.hasOwnProperty("enableTargetTrackingForecast"))
                            object.enableTargetTrackingForecast = message.enableTargetTrackingForecast;
                        if (message.strictReportConsistencyEnabled != null && message.hasOwnProperty("strictReportConsistencyEnabled"))
                            object.strictReportConsistencyEnabled = message.strictReportConsistencyEnabled;
                        if (message.storeSnapshotScheduledTimes && message.storeSnapshotScheduledTimes.length) {
                            object.storeSnapshotScheduledTimes = [];
                            for (var j = 0; j < message.storeSnapshotScheduledTimes.length; ++j)
                                object.storeSnapshotScheduledTimes[j] = message.storeSnapshotScheduledTimes[j];
                        }
                        if (message.storeOpenTimeBufferInSeconds != null && message.hasOwnProperty("storeOpenTimeBufferInSeconds"))
                            object.storeOpenTimeBufferInSeconds = message.storeOpenTimeBufferInSeconds;
                        if (message.storeCloseTimeBufferInSeconds != null && message.hasOwnProperty("storeCloseTimeBufferInSeconds"))
                            object.storeCloseTimeBufferInSeconds = message.storeCloseTimeBufferInSeconds;
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            object.startOfWeek = message.startOfWeek;
                        if (message.weekends && message.weekends.length) {
                            object.weekends = [];
                            for (var j = 0; j < message.weekends.length; ++j)
                                object.weekends[j] = message.weekends[j];
                        }
                        if (message.storeSnapshotRetentionDays != null && message.hasOwnProperty("storeSnapshotRetentionDays"))
                            object.storeSnapshotRetentionDays = message.storeSnapshotRetentionDays;
                        if (message.onTimeGreetingThresholdSec != null && message.hasOwnProperty("onTimeGreetingThresholdSec"))
                            object.onTimeGreetingThresholdSec = message.onTimeGreetingThresholdSec;
                        if (message.productSalesAnalysisEnabled != null && message.hasOwnProperty("productSalesAnalysisEnabled"))
                            object.productSalesAnalysisEnabled = message.productSalesAnalysisEnabled;
                        if (message.defaultLandingMetrics && message.defaultLandingMetrics.length) {
                            object.defaultLandingMetrics = [];
                            for (var j = 0; j < message.defaultLandingMetrics.length; ++j)
                                object.defaultLandingMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.defaultLandingMetrics[j]] : message.defaultLandingMetrics[j];
                        }
                        if (message.enabledInputTargetMetrics && message.enabledInputTargetMetrics.length) {
                            object.enabledInputTargetMetrics = [];
                            for (var j = 0; j < message.enabledInputTargetMetrics.length; ++j)
                                object.enabledInputTargetMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.enabledInputTargetMetrics[j]] : message.enabledInputTargetMetrics[j];
                        }
                        if (message.enabledDisplayTargetMetrics && message.enabledDisplayTargetMetrics.length) {
                            object.enabledDisplayTargetMetrics = [];
                            for (var j = 0; j < message.enabledDisplayTargetMetrics.length; ++j)
                                object.enabledDisplayTargetMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.enabledDisplayTargetMetrics[j]] : message.enabledDisplayTargetMetrics[j];
                        }
                        if (message.enabledGenerateInsightTypes && message.enabledGenerateInsightTypes.length) {
                            object.enabledGenerateInsightTypes = [];
                            for (var j = 0; j < message.enabledGenerateInsightTypes.length; ++j)
                                object.enabledGenerateInsightTypes[j] = message.enabledGenerateInsightTypes[j];
                        }
                        if (message.enabledDisplayInsightTypes && message.enabledDisplayInsightTypes.length) {
                            object.enabledDisplayInsightTypes = [];
                            for (var j = 0; j < message.enabledDisplayInsightTypes.length; ++j)
                                object.enabledDisplayInsightTypes[j] = message.enabledDisplayInsightTypes[j];
                        }
                        if (message.threeWeeksTrendInsightMetrics && message.threeWeeksTrendInsightMetrics.length) {
                            object.threeWeeksTrendInsightMetrics = [];
                            for (var j = 0; j < message.threeWeeksTrendInsightMetrics.length; ++j)
                                object.threeWeeksTrendInsightMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.threeWeeksTrendInsightMetrics[j]] : message.threeWeeksTrendInsightMetrics[j];
                        }
                        if (message.excludedScheduledTaskTypes && message.excludedScheduledTaskTypes.length) {
                            object.excludedScheduledTaskTypes = [];
                            for (var j = 0; j < message.excludedScheduledTaskTypes.length; ++j)
                                object.excludedScheduledTaskTypes[j] = options.enums === String ? $root.palexy.streaming.v1.ScheduledTaskType[message.excludedScheduledTaskTypes[j]] : message.excludedScheduledTaskTypes[j];
                        }
                        if (message.videoGroupSizeBuckets != null && message.hasOwnProperty("videoGroupSizeBuckets"))
                            object.videoGroupSizeBuckets = message.videoGroupSizeBuckets;
                        if (message.criticalHoursOfDaysOfWeek && message.criticalHoursOfDaysOfWeek.length) {
                            object.criticalHoursOfDaysOfWeek = [];
                            for (var j = 0; j < message.criticalHoursOfDaysOfWeek.length; ++j)
                                object.criticalHoursOfDaysOfWeek[j] = $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek.toObject(message.criticalHoursOfDaysOfWeek[j], options);
                        }
                        if (message.posStaffSyncEnabled != null && message.hasOwnProperty("posStaffSyncEnabled"))
                            object.posStaffSyncEnabled = message.posStaffSyncEnabled;
                        if (message.storeRelationshipEnabled != null && message.hasOwnProperty("storeRelationshipEnabled"))
                            object.storeRelationshipEnabled = message.storeRelationshipEnabled;
                        if (message.discountMetricsEnabled != null && message.hasOwnProperty("discountMetricsEnabled"))
                            object.discountMetricsEnabled = message.discountMetricsEnabled;
                        if (message.discountDistributionBuckets != null && message.hasOwnProperty("discountDistributionBuckets"))
                            object.discountDistributionBuckets = message.discountDistributionBuckets;
                        if (message.includeReturningItemsForDiscountAnalysis != null && message.hasOwnProperty("includeReturningItemsForDiscountAnalysis"))
                            object.includeReturningItemsForDiscountAnalysis = message.includeReturningItemsForDiscountAnalysis;
                        if (message.activityLogCleanUpIntervalInDays != null && message.hasOwnProperty("activityLogCleanUpIntervalInDays"))
                            object.activityLogCleanUpIntervalInDays = message.activityLogCleanUpIntervalInDays;
                        if (message.transactionCalculationMethod != null && message.hasOwnProperty("transactionCalculationMethod"))
                            object.transactionCalculationMethod = options.enums === String ? $root.palexy.streaming.v1.TransactionCalculationMethod[message.transactionCalculationMethod] : message.transactionCalculationMethod;
                        if (message.genderAgeGroupModelName != null && message.hasOwnProperty("genderAgeGroupModelName"))
                            object.genderAgeGroupModelName = message.genderAgeGroupModelName;
                        if (message.ageGroupThresholds && message.ageGroupThresholds.length) {
                            object.ageGroupThresholds = [];
                            for (var j = 0; j < message.ageGroupThresholds.length; ++j)
                                object.ageGroupThresholds[j] = options.json && !isFinite(message.ageGroupThresholds[j]) ? String(message.ageGroupThresholds[j]) : message.ageGroupThresholds[j];
                        }
                        if (message.enableFaceBlurring != null && message.hasOwnProperty("enableFaceBlurring"))
                            object.enableFaceBlurring = message.enableFaceBlurring;
                        if (message.staffScheduleDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleDemandCoverageThreshold"))
                            object.staffScheduleDemandCoverageThreshold = options.json && !isFinite(message.staffScheduleDemandCoverageThreshold) ? String(message.staffScheduleDemandCoverageThreshold) : message.staffScheduleDemandCoverageThreshold;
                        if (message.enableCopyingChangingRoomActionToCustomAction != null && message.hasOwnProperty("enableCopyingChangingRoomActionToCustomAction"))
                            object.enableCopyingChangingRoomActionToCustomAction = message.enableCopyingChangingRoomActionToCustomAction;
                        var keys2;
                        if (message.forecastModelVersionIdByMetric && (keys2 = Object.keys(message.forecastModelVersionIdByMetric)).length) {
                            object.forecastModelVersionIdByMetric = {};
                            for (var j = 0; j < keys2.length; ++j)
                                if (typeof message.forecastModelVersionIdByMetric[keys2[j]] === "number")
                                    object.forecastModelVersionIdByMetric[keys2[j]] = options.longs === String ? String(message.forecastModelVersionIdByMetric[keys2[j]]) : message.forecastModelVersionIdByMetric[keys2[j]];
                                else
                                    object.forecastModelVersionIdByMetric[keys2[j]] = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelVersionIdByMetric[keys2[j]]) : options.longs === Number ? new $util.LongBits(message.forecastModelVersionIdByMetric[keys2[j]].low >>> 0, message.forecastModelVersionIdByMetric[keys2[j]].high >>> 0).toNumber() : message.forecastModelVersionIdByMetric[keys2[j]];
                        }
                        if (message.maxSessionInactiveIntervalInSeconds != null && message.hasOwnProperty("maxSessionInactiveIntervalInSeconds"))
                            object.maxSessionInactiveIntervalInSeconds = message.maxSessionInactiveIntervalInSeconds;
                        if (message.rememberMeTokenMaxAgeInSeconds != null && message.hasOwnProperty("rememberMeTokenMaxAgeInSeconds"))
                            object.rememberMeTokenMaxAgeInSeconds = message.rememberMeTokenMaxAgeInSeconds;
                        if (message.mainSchedulePerformanceMetric != null && message.hasOwnProperty("mainSchedulePerformanceMetric"))
                            object.mainSchedulePerformanceMetric = message.mainSchedulePerformanceMetric;
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            object.disabled = message.disabled;
                        if (message.staffScheduleLowerDemandCoverageThreshold != null && message.hasOwnProperty("staffScheduleLowerDemandCoverageThreshold"))
                            object.staffScheduleLowerDemandCoverageThreshold = options.json && !isFinite(message.staffScheduleLowerDemandCoverageThreshold) ? String(message.staffScheduleLowerDemandCoverageThreshold) : message.staffScheduleLowerDemandCoverageThreshold;
                        if (message.excludeQueueTimeInTotalServiceTime != null && message.hasOwnProperty("excludeQueueTimeInTotalServiceTime"))
                            object.excludeQueueTimeInTotalServiceTime = message.excludeQueueTimeInTotalServiceTime;
                        if (message.totalServiceTimeComplianceThreshold != null && message.hasOwnProperty("totalServiceTimeComplianceThreshold"))
                            object.totalServiceTimeComplianceThreshold = message.totalServiceTimeComplianceThreshold;
                        if (message.defaultTimezone != null && message.hasOwnProperty("defaultTimezone"))
                            object.defaultTimezone = message.defaultTimezone;
                        if (message.dailyInsightMetrics && message.dailyInsightMetrics.length) {
                            object.dailyInsightMetrics = [];
                            for (var j = 0; j < message.dailyInsightMetrics.length; ++j)
                                object.dailyInsightMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.dailyInsightMetrics[j]] : message.dailyInsightMetrics[j];
                        }
                        if (message.ibeImageBucket != null && message.hasOwnProperty("ibeImageBucket"))
                            object.ibeImageBucket = message.ibeImageBucket;
                        if (message.checkoutTimeBuckets != null && message.hasOwnProperty("checkoutTimeBuckets"))
                            object.checkoutTimeBuckets = message.checkoutTimeBuckets;
                        if (message.enableTaskManagement != null && message.hasOwnProperty("enableTaskManagement"))
                            object.enableTaskManagement = message.enableTaskManagement;
                        if (message.enableFormManagement != null && message.hasOwnProperty("enableFormManagement"))
                            object.enableFormManagement = message.enableFormManagement;
                        if (message.forecastBias != null && message.hasOwnProperty("forecastBias"))
                            object.forecastBias = options.json && !isFinite(message.forecastBias) ? String(message.forecastBias) : message.forecastBias;
                        if (message.sectionForecastMetadataTypeIds && message.sectionForecastMetadataTypeIds.length) {
                            object.sectionForecastMetadataTypeIds = [];
                            for (var j = 0; j < message.sectionForecastMetadataTypeIds.length; ++j)
                                if (typeof message.sectionForecastMetadataTypeIds[j] === "number")
                                    object.sectionForecastMetadataTypeIds[j] = options.longs === String ? String(message.sectionForecastMetadataTypeIds[j]) : message.sectionForecastMetadataTypeIds[j];
                                else
                                    object.sectionForecastMetadataTypeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.sectionForecastMetadataTypeIds[j]) : options.longs === Number ? new $util.LongBits(message.sectionForecastMetadataTypeIds[j].low >>> 0, message.sectionForecastMetadataTypeIds[j].high >>> 0).toNumber() : message.sectionForecastMetadataTypeIds[j];
                        }
                        if (message.enableStoreOptimizer != null && message.hasOwnProperty("enableStoreOptimizer"))
                            object.enableStoreOptimizer = message.enableStoreOptimizer;
                        if (message.ownerAccount != null && message.hasOwnProperty("ownerAccount"))
                            object.ownerAccount = $root.palexy.streaming.v1.Account.toObject(message.ownerAccount, options);
                        if (message.storeTimezones && message.storeTimezones.length) {
                            object.storeTimezones = [];
                            for (var j = 0; j < message.storeTimezones.length; ++j)
                                object.storeTimezones[j] = message.storeTimezones[j];
                        }
                        if (message.blurringVideoConfig != null && message.hasOwnProperty("blurringVideoConfig")) {
                            object.blurringVideoConfig = $root.palexy.streaming.v1.BlurringVideoConfig.toObject(message.blurringVideoConfig, options);
                            if (options.oneofs)
                                object._blurringVideoConfig = "blurringVideoConfig";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Company to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Company
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Company.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Industry enum.
                     * @name palexy.streaming.v1.Company.Industry
                     * @enum {number}
                     * @property {number} OTHERS=0 OTHERS value
                     * @property {number} FASHION=1 FASHION value
                     * @property {number} CVS=2 CVS value
                     * @property {number} MALL=3 MALL value
                     * @property {number} JEWELRY=4 JEWELRY value
                     * @property {number} DEPARTMENT_STORE=5 DEPARTMENT_STORE value
                     * @property {number} FNB=6 FNB value
                     * @property {number} GROCERY_STORE=7 GROCERY_STORE value
                     */
                    Company.Industry = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "OTHERS"] = 0;
                        values[valuesById[1] = "FASHION"] = 1;
                        values[valuesById[2] = "CVS"] = 2;
                        values[valuesById[3] = "MALL"] = 3;
                        values[valuesById[4] = "JEWELRY"] = 4;
                        values[valuesById[5] = "DEPARTMENT_STORE"] = 5;
                        values[valuesById[6] = "FNB"] = 6;
                        values[valuesById[7] = "GROCERY_STORE"] = 7;
                        return values;
                    })();
    
                    return Company;
                })();
    
                v1.BlurringVideoConfig = (function() {
    
                    /**
                     * Properties of a BlurringVideoConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IBlurringVideoConfig
                     * @property {number|null} [fps] BlurringVideoConfig fps
                     * @property {number|null} [resolutionWidth] BlurringVideoConfig resolutionWidth
                     * @property {number|null} [resolutionHeight] BlurringVideoConfig resolutionHeight
                     */
    
                    /**
                     * Constructs a new BlurringVideoConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BlurringVideoConfig.
                     * @implements IBlurringVideoConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IBlurringVideoConfig=} [properties] Properties to set
                     */
                    function BlurringVideoConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BlurringVideoConfig fps.
                     * @member {number} fps
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @instance
                     */
                    BlurringVideoConfig.prototype.fps = 0;
    
                    /**
                     * BlurringVideoConfig resolutionWidth.
                     * @member {number} resolutionWidth
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @instance
                     */
                    BlurringVideoConfig.prototype.resolutionWidth = 0;
    
                    /**
                     * BlurringVideoConfig resolutionHeight.
                     * @member {number} resolutionHeight
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @instance
                     */
                    BlurringVideoConfig.prototype.resolutionHeight = 0;
    
                    /**
                     * Creates a new BlurringVideoConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {palexy.streaming.v1.IBlurringVideoConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BlurringVideoConfig} BlurringVideoConfig instance
                     */
                    BlurringVideoConfig.create = function create(properties) {
                        return new BlurringVideoConfig(properties);
                    };
    
                    /**
                     * Encodes the specified BlurringVideoConfig message. Does not implicitly {@link palexy.streaming.v1.BlurringVideoConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {palexy.streaming.v1.IBlurringVideoConfig} message BlurringVideoConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BlurringVideoConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fps != null && Object.hasOwnProperty.call(message, "fps"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.fps);
                        if (message.resolutionWidth != null && Object.hasOwnProperty.call(message, "resolutionWidth"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.resolutionWidth);
                        if (message.resolutionHeight != null && Object.hasOwnProperty.call(message, "resolutionHeight"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.resolutionHeight);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BlurringVideoConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.BlurringVideoConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {palexy.streaming.v1.IBlurringVideoConfig} message BlurringVideoConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BlurringVideoConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BlurringVideoConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BlurringVideoConfig} BlurringVideoConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BlurringVideoConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BlurringVideoConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fps = reader.float();
                                break;
                            case 2:
                                message.resolutionWidth = reader.int32();
                                break;
                            case 3:
                                message.resolutionHeight = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BlurringVideoConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BlurringVideoConfig} BlurringVideoConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BlurringVideoConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BlurringVideoConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BlurringVideoConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            if (typeof message.fps !== "number")
                                return "fps: number expected";
                        if (message.resolutionWidth != null && message.hasOwnProperty("resolutionWidth"))
                            if (!$util.isInteger(message.resolutionWidth))
                                return "resolutionWidth: integer expected";
                        if (message.resolutionHeight != null && message.hasOwnProperty("resolutionHeight"))
                            if (!$util.isInteger(message.resolutionHeight))
                                return "resolutionHeight: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a BlurringVideoConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BlurringVideoConfig} BlurringVideoConfig
                     */
                    BlurringVideoConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BlurringVideoConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.BlurringVideoConfig();
                        if (object.fps != null)
                            message.fps = Number(object.fps);
                        if (object.resolutionWidth != null)
                            message.resolutionWidth = object.resolutionWidth | 0;
                        if (object.resolutionHeight != null)
                            message.resolutionHeight = object.resolutionHeight | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BlurringVideoConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @static
                     * @param {palexy.streaming.v1.BlurringVideoConfig} message BlurringVideoConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BlurringVideoConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fps = 0;
                            object.resolutionWidth = 0;
                            object.resolutionHeight = 0;
                        }
                        if (message.fps != null && message.hasOwnProperty("fps"))
                            object.fps = options.json && !isFinite(message.fps) ? String(message.fps) : message.fps;
                        if (message.resolutionWidth != null && message.hasOwnProperty("resolutionWidth"))
                            object.resolutionWidth = message.resolutionWidth;
                        if (message.resolutionHeight != null && message.hasOwnProperty("resolutionHeight"))
                            object.resolutionHeight = message.resolutionHeight;
                        return object;
                    };
    
                    /**
                     * Converts this BlurringVideoConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BlurringVideoConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BlurringVideoConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BlurringVideoConfig;
                })();
    
                v1.AdjustedMetricConfig = (function() {
    
                    /**
                     * Properties of an AdjustedMetricConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IAdjustedMetricConfig
                     * @property {number|null} [id] AdjustedMetricConfig id
                     * @property {number|null} [companyId] AdjustedMetricConfig companyId
                     * @property {Array.<string>|null} [enabledDisplayAdjustedMetrics] AdjustedMetricConfig enabledDisplayAdjustedMetrics
                     * @property {boolean|null} [adjustedNetSalesMetricEnabled] AdjustedMetricConfig adjustedNetSalesMetricEnabled
                     * @property {boolean|null} [adjustedNetSalesUseNetAmount] AdjustedMetricConfig adjustedNetSalesUseNetAmount
                     * @property {number|null} [adjustedNetSalesExcludedPosMetadataTypeId] AdjustedMetricConfig adjustedNetSalesExcludedPosMetadataTypeId
                     * @property {Array.<string>|null} [adjustedNetSalesExcludedPosMetadataValues] AdjustedMetricConfig adjustedNetSalesExcludedPosMetadataValues
                     * @property {boolean|null} [adjustedNetSalesItemsMetricEnabled] AdjustedMetricConfig adjustedNetSalesItemsMetricEnabled
                     * @property {boolean|null} [adjustedNetSalesItemsUseSalesItemsAsNetSalesItems] AdjustedMetricConfig adjustedNetSalesItemsUseSalesItemsAsNetSalesItems
                     * @property {number|null} [adjustedNetSalesItemsExcludedPosMetadataTypeId] AdjustedMetricConfig adjustedNetSalesItemsExcludedPosMetadataTypeId
                     * @property {Array.<string>|null} [adjustedNetSalesItemsExcludedPosMetadataValues] AdjustedMetricConfig adjustedNetSalesItemsExcludedPosMetadataValues
                     * @property {boolean|null} [adjustedTransactionMetricEnabled] AdjustedMetricConfig adjustedTransactionMetricEnabled
                     * @property {palexy.streaming.v1.TransactionCalculationMethod|null} [adjustedTransactionMetricCalculationMethod] AdjustedMetricConfig adjustedTransactionMetricCalculationMethod
                     * @property {number|null} [adjustedTransactionExcludedPosMetadataTypeId] AdjustedMetricConfig adjustedTransactionExcludedPosMetadataTypeId
                     * @property {Array.<string>|null} [adjustedTransactionExcludedPosMetadataValues] AdjustedMetricConfig adjustedTransactionExcludedPosMetadataValues
                     * @property {Array.<string>|null} [adjustedTransactionExcludedTransactionTypes] AdjustedMetricConfig adjustedTransactionExcludedTransactionTypes
                     * @property {boolean|null} [adjustedVisitMetricEnabled] AdjustedMetricConfig adjustedVisitMetricEnabled
                     * @property {palexy.streaming.v1.AdjustedVisitCalculationMethod|null} [adjustedVisitMetricCalculationMethod] AdjustedMetricConfig adjustedVisitMetricCalculationMethod
                     * @property {Array.<string>|null} [adjustedVisitExcludedTransactionTypes] AdjustedMetricConfig adjustedVisitExcludedTransactionTypes
                     */
    
                    /**
                     * Constructs a new AdjustedMetricConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AdjustedMetricConfig.
                     * @implements IAdjustedMetricConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IAdjustedMetricConfig=} [properties] Properties to set
                     */
                    function AdjustedMetricConfig(properties) {
                        this.enabledDisplayAdjustedMetrics = [];
                        this.adjustedNetSalesExcludedPosMetadataValues = [];
                        this.adjustedNetSalesItemsExcludedPosMetadataValues = [];
                        this.adjustedTransactionExcludedPosMetadataValues = [];
                        this.adjustedTransactionExcludedTransactionTypes = [];
                        this.adjustedVisitExcludedTransactionTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AdjustedMetricConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjustedMetricConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjustedMetricConfig enabledDisplayAdjustedMetrics.
                     * @member {Array.<string>} enabledDisplayAdjustedMetrics
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.enabledDisplayAdjustedMetrics = $util.emptyArray;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesMetricEnabled.
                     * @member {boolean} adjustedNetSalesMetricEnabled
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesMetricEnabled = false;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesUseNetAmount.
                     * @member {boolean} adjustedNetSalesUseNetAmount
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesUseNetAmount = false;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesExcludedPosMetadataTypeId.
                     * @member {number} adjustedNetSalesExcludedPosMetadataTypeId
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesExcludedPosMetadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesExcludedPosMetadataValues.
                     * @member {Array.<string>} adjustedNetSalesExcludedPosMetadataValues
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesExcludedPosMetadataValues = $util.emptyArray;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesItemsMetricEnabled.
                     * @member {boolean} adjustedNetSalesItemsMetricEnabled
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesItemsMetricEnabled = false;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesItemsUseSalesItemsAsNetSalesItems.
                     * @member {boolean} adjustedNetSalesItemsUseSalesItemsAsNetSalesItems
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems = false;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesItemsExcludedPosMetadataTypeId.
                     * @member {number} adjustedNetSalesItemsExcludedPosMetadataTypeId
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesItemsExcludedPosMetadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjustedMetricConfig adjustedNetSalesItemsExcludedPosMetadataValues.
                     * @member {Array.<string>} adjustedNetSalesItemsExcludedPosMetadataValues
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedNetSalesItemsExcludedPosMetadataValues = $util.emptyArray;
    
                    /**
                     * AdjustedMetricConfig adjustedTransactionMetricEnabled.
                     * @member {boolean} adjustedTransactionMetricEnabled
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedTransactionMetricEnabled = false;
    
                    /**
                     * AdjustedMetricConfig adjustedTransactionMetricCalculationMethod.
                     * @member {palexy.streaming.v1.TransactionCalculationMethod} adjustedTransactionMetricCalculationMethod
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedTransactionMetricCalculationMethod = 0;
    
                    /**
                     * AdjustedMetricConfig adjustedTransactionExcludedPosMetadataTypeId.
                     * @member {number} adjustedTransactionExcludedPosMetadataTypeId
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedTransactionExcludedPosMetadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjustedMetricConfig adjustedTransactionExcludedPosMetadataValues.
                     * @member {Array.<string>} adjustedTransactionExcludedPosMetadataValues
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedTransactionExcludedPosMetadataValues = $util.emptyArray;
    
                    /**
                     * AdjustedMetricConfig adjustedTransactionExcludedTransactionTypes.
                     * @member {Array.<string>} adjustedTransactionExcludedTransactionTypes
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedTransactionExcludedTransactionTypes = $util.emptyArray;
    
                    /**
                     * AdjustedMetricConfig adjustedVisitMetricEnabled.
                     * @member {boolean} adjustedVisitMetricEnabled
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedVisitMetricEnabled = false;
    
                    /**
                     * AdjustedMetricConfig adjustedVisitMetricCalculationMethod.
                     * @member {palexy.streaming.v1.AdjustedVisitCalculationMethod} adjustedVisitMetricCalculationMethod
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedVisitMetricCalculationMethod = 0;
    
                    /**
                     * AdjustedMetricConfig adjustedVisitExcludedTransactionTypes.
                     * @member {Array.<string>} adjustedVisitExcludedTransactionTypes
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     */
                    AdjustedMetricConfig.prototype.adjustedVisitExcludedTransactionTypes = $util.emptyArray;
    
                    /**
                     * Creates a new AdjustedMetricConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {palexy.streaming.v1.IAdjustedMetricConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AdjustedMetricConfig} AdjustedMetricConfig instance
                     */
                    AdjustedMetricConfig.create = function create(properties) {
                        return new AdjustedMetricConfig(properties);
                    };
    
                    /**
                     * Encodes the specified AdjustedMetricConfig message. Does not implicitly {@link palexy.streaming.v1.AdjustedMetricConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {palexy.streaming.v1.IAdjustedMetricConfig} message AdjustedMetricConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdjustedMetricConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.enabledDisplayAdjustedMetrics != null && message.enabledDisplayAdjustedMetrics.length)
                            for (var i = 0; i < message.enabledDisplayAdjustedMetrics.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.enabledDisplayAdjustedMetrics[i]);
                        if (message.adjustedNetSalesMetricEnabled != null && Object.hasOwnProperty.call(message, "adjustedNetSalesMetricEnabled"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.adjustedNetSalesMetricEnabled);
                        if (message.adjustedNetSalesUseNetAmount != null && Object.hasOwnProperty.call(message, "adjustedNetSalesUseNetAmount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.adjustedNetSalesUseNetAmount);
                        if (message.adjustedNetSalesExcludedPosMetadataTypeId != null && Object.hasOwnProperty.call(message, "adjustedNetSalesExcludedPosMetadataTypeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.adjustedNetSalesExcludedPosMetadataTypeId);
                        if (message.adjustedNetSalesExcludedPosMetadataValues != null && message.adjustedNetSalesExcludedPosMetadataValues.length)
                            for (var i = 0; i < message.adjustedNetSalesExcludedPosMetadataValues.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.adjustedNetSalesExcludedPosMetadataValues[i]);
                        if (message.adjustedNetSalesItemsMetricEnabled != null && Object.hasOwnProperty.call(message, "adjustedNetSalesItemsMetricEnabled"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.adjustedNetSalesItemsMetricEnabled);
                        if (message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems != null && Object.hasOwnProperty.call(message, "adjustedNetSalesItemsUseSalesItemsAsNetSalesItems"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems);
                        if (message.adjustedNetSalesItemsExcludedPosMetadataTypeId != null && Object.hasOwnProperty.call(message, "adjustedNetSalesItemsExcludedPosMetadataTypeId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.adjustedNetSalesItemsExcludedPosMetadataTypeId);
                        if (message.adjustedNetSalesItemsExcludedPosMetadataValues != null && message.adjustedNetSalesItemsExcludedPosMetadataValues.length)
                            for (var i = 0; i < message.adjustedNetSalesItemsExcludedPosMetadataValues.length; ++i)
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.adjustedNetSalesItemsExcludedPosMetadataValues[i]);
                        if (message.adjustedTransactionMetricEnabled != null && Object.hasOwnProperty.call(message, "adjustedTransactionMetricEnabled"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.adjustedTransactionMetricEnabled);
                        if (message.adjustedTransactionMetricCalculationMethod != null && Object.hasOwnProperty.call(message, "adjustedTransactionMetricCalculationMethod"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.adjustedTransactionMetricCalculationMethod);
                        if (message.adjustedTransactionExcludedPosMetadataTypeId != null && Object.hasOwnProperty.call(message, "adjustedTransactionExcludedPosMetadataTypeId"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.adjustedTransactionExcludedPosMetadataTypeId);
                        if (message.adjustedTransactionExcludedPosMetadataValues != null && message.adjustedTransactionExcludedPosMetadataValues.length)
                            for (var i = 0; i < message.adjustedTransactionExcludedPosMetadataValues.length; ++i)
                                writer.uint32(/* id 15, wireType 2 =*/122).string(message.adjustedTransactionExcludedPosMetadataValues[i]);
                        if (message.adjustedTransactionExcludedTransactionTypes != null && message.adjustedTransactionExcludedTransactionTypes.length)
                            for (var i = 0; i < message.adjustedTransactionExcludedTransactionTypes.length; ++i)
                                writer.uint32(/* id 16, wireType 2 =*/130).string(message.adjustedTransactionExcludedTransactionTypes[i]);
                        if (message.adjustedVisitMetricEnabled != null && Object.hasOwnProperty.call(message, "adjustedVisitMetricEnabled"))
                            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.adjustedVisitMetricEnabled);
                        if (message.adjustedVisitMetricCalculationMethod != null && Object.hasOwnProperty.call(message, "adjustedVisitMetricCalculationMethod"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.adjustedVisitMetricCalculationMethod);
                        if (message.adjustedVisitExcludedTransactionTypes != null && message.adjustedVisitExcludedTransactionTypes.length)
                            for (var i = 0; i < message.adjustedVisitExcludedTransactionTypes.length; ++i)
                                writer.uint32(/* id 19, wireType 2 =*/154).string(message.adjustedVisitExcludedTransactionTypes[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AdjustedMetricConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.AdjustedMetricConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {palexy.streaming.v1.IAdjustedMetricConfig} message AdjustedMetricConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdjustedMetricConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AdjustedMetricConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AdjustedMetricConfig} AdjustedMetricConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdjustedMetricConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AdjustedMetricConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                if (!(message.enabledDisplayAdjustedMetrics && message.enabledDisplayAdjustedMetrics.length))
                                    message.enabledDisplayAdjustedMetrics = [];
                                message.enabledDisplayAdjustedMetrics.push(reader.string());
                                break;
                            case 4:
                                message.adjustedNetSalesMetricEnabled = reader.bool();
                                break;
                            case 5:
                                message.adjustedNetSalesUseNetAmount = reader.bool();
                                break;
                            case 6:
                                message.adjustedNetSalesExcludedPosMetadataTypeId = reader.int64();
                                break;
                            case 7:
                                if (!(message.adjustedNetSalesExcludedPosMetadataValues && message.adjustedNetSalesExcludedPosMetadataValues.length))
                                    message.adjustedNetSalesExcludedPosMetadataValues = [];
                                message.adjustedNetSalesExcludedPosMetadataValues.push(reader.string());
                                break;
                            case 8:
                                message.adjustedNetSalesItemsMetricEnabled = reader.bool();
                                break;
                            case 9:
                                message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems = reader.bool();
                                break;
                            case 10:
                                message.adjustedNetSalesItemsExcludedPosMetadataTypeId = reader.int64();
                                break;
                            case 11:
                                if (!(message.adjustedNetSalesItemsExcludedPosMetadataValues && message.adjustedNetSalesItemsExcludedPosMetadataValues.length))
                                    message.adjustedNetSalesItemsExcludedPosMetadataValues = [];
                                message.adjustedNetSalesItemsExcludedPosMetadataValues.push(reader.string());
                                break;
                            case 12:
                                message.adjustedTransactionMetricEnabled = reader.bool();
                                break;
                            case 13:
                                message.adjustedTransactionMetricCalculationMethod = reader.int32();
                                break;
                            case 14:
                                message.adjustedTransactionExcludedPosMetadataTypeId = reader.int64();
                                break;
                            case 15:
                                if (!(message.adjustedTransactionExcludedPosMetadataValues && message.adjustedTransactionExcludedPosMetadataValues.length))
                                    message.adjustedTransactionExcludedPosMetadataValues = [];
                                message.adjustedTransactionExcludedPosMetadataValues.push(reader.string());
                                break;
                            case 16:
                                if (!(message.adjustedTransactionExcludedTransactionTypes && message.adjustedTransactionExcludedTransactionTypes.length))
                                    message.adjustedTransactionExcludedTransactionTypes = [];
                                message.adjustedTransactionExcludedTransactionTypes.push(reader.string());
                                break;
                            case 17:
                                message.adjustedVisitMetricEnabled = reader.bool();
                                break;
                            case 18:
                                message.adjustedVisitMetricCalculationMethod = reader.int32();
                                break;
                            case 19:
                                if (!(message.adjustedVisitExcludedTransactionTypes && message.adjustedVisitExcludedTransactionTypes.length))
                                    message.adjustedVisitExcludedTransactionTypes = [];
                                message.adjustedVisitExcludedTransactionTypes.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AdjustedMetricConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AdjustedMetricConfig} AdjustedMetricConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdjustedMetricConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AdjustedMetricConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AdjustedMetricConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.enabledDisplayAdjustedMetrics != null && message.hasOwnProperty("enabledDisplayAdjustedMetrics")) {
                            if (!Array.isArray(message.enabledDisplayAdjustedMetrics))
                                return "enabledDisplayAdjustedMetrics: array expected";
                            for (var i = 0; i < message.enabledDisplayAdjustedMetrics.length; ++i)
                                if (!$util.isString(message.enabledDisplayAdjustedMetrics[i]))
                                    return "enabledDisplayAdjustedMetrics: string[] expected";
                        }
                        if (message.adjustedNetSalesMetricEnabled != null && message.hasOwnProperty("adjustedNetSalesMetricEnabled"))
                            if (typeof message.adjustedNetSalesMetricEnabled !== "boolean")
                                return "adjustedNetSalesMetricEnabled: boolean expected";
                        if (message.adjustedNetSalesUseNetAmount != null && message.hasOwnProperty("adjustedNetSalesUseNetAmount"))
                            if (typeof message.adjustedNetSalesUseNetAmount !== "boolean")
                                return "adjustedNetSalesUseNetAmount: boolean expected";
                        if (message.adjustedNetSalesExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedNetSalesExcludedPosMetadataTypeId"))
                            if (!$util.isInteger(message.adjustedNetSalesExcludedPosMetadataTypeId) && !(message.adjustedNetSalesExcludedPosMetadataTypeId && $util.isInteger(message.adjustedNetSalesExcludedPosMetadataTypeId.low) && $util.isInteger(message.adjustedNetSalesExcludedPosMetadataTypeId.high)))
                                return "adjustedNetSalesExcludedPosMetadataTypeId: integer|Long expected";
                        if (message.adjustedNetSalesExcludedPosMetadataValues != null && message.hasOwnProperty("adjustedNetSalesExcludedPosMetadataValues")) {
                            if (!Array.isArray(message.adjustedNetSalesExcludedPosMetadataValues))
                                return "adjustedNetSalesExcludedPosMetadataValues: array expected";
                            for (var i = 0; i < message.adjustedNetSalesExcludedPosMetadataValues.length; ++i)
                                if (!$util.isString(message.adjustedNetSalesExcludedPosMetadataValues[i]))
                                    return "adjustedNetSalesExcludedPosMetadataValues: string[] expected";
                        }
                        if (message.adjustedNetSalesItemsMetricEnabled != null && message.hasOwnProperty("adjustedNetSalesItemsMetricEnabled"))
                            if (typeof message.adjustedNetSalesItemsMetricEnabled !== "boolean")
                                return "adjustedNetSalesItemsMetricEnabled: boolean expected";
                        if (message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems != null && message.hasOwnProperty("adjustedNetSalesItemsUseSalesItemsAsNetSalesItems"))
                            if (typeof message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems !== "boolean")
                                return "adjustedNetSalesItemsUseSalesItemsAsNetSalesItems: boolean expected";
                        if (message.adjustedNetSalesItemsExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedNetSalesItemsExcludedPosMetadataTypeId"))
                            if (!$util.isInteger(message.adjustedNetSalesItemsExcludedPosMetadataTypeId) && !(message.adjustedNetSalesItemsExcludedPosMetadataTypeId && $util.isInteger(message.adjustedNetSalesItemsExcludedPosMetadataTypeId.low) && $util.isInteger(message.adjustedNetSalesItemsExcludedPosMetadataTypeId.high)))
                                return "adjustedNetSalesItemsExcludedPosMetadataTypeId: integer|Long expected";
                        if (message.adjustedNetSalesItemsExcludedPosMetadataValues != null && message.hasOwnProperty("adjustedNetSalesItemsExcludedPosMetadataValues")) {
                            if (!Array.isArray(message.adjustedNetSalesItemsExcludedPosMetadataValues))
                                return "adjustedNetSalesItemsExcludedPosMetadataValues: array expected";
                            for (var i = 0; i < message.adjustedNetSalesItemsExcludedPosMetadataValues.length; ++i)
                                if (!$util.isString(message.adjustedNetSalesItemsExcludedPosMetadataValues[i]))
                                    return "adjustedNetSalesItemsExcludedPosMetadataValues: string[] expected";
                        }
                        if (message.adjustedTransactionMetricEnabled != null && message.hasOwnProperty("adjustedTransactionMetricEnabled"))
                            if (typeof message.adjustedTransactionMetricEnabled !== "boolean")
                                return "adjustedTransactionMetricEnabled: boolean expected";
                        if (message.adjustedTransactionMetricCalculationMethod != null && message.hasOwnProperty("adjustedTransactionMetricCalculationMethod"))
                            switch (message.adjustedTransactionMetricCalculationMethod) {
                            default:
                                return "adjustedTransactionMetricCalculationMethod: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.adjustedTransactionExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedTransactionExcludedPosMetadataTypeId"))
                            if (!$util.isInteger(message.adjustedTransactionExcludedPosMetadataTypeId) && !(message.adjustedTransactionExcludedPosMetadataTypeId && $util.isInteger(message.adjustedTransactionExcludedPosMetadataTypeId.low) && $util.isInteger(message.adjustedTransactionExcludedPosMetadataTypeId.high)))
                                return "adjustedTransactionExcludedPosMetadataTypeId: integer|Long expected";
                        if (message.adjustedTransactionExcludedPosMetadataValues != null && message.hasOwnProperty("adjustedTransactionExcludedPosMetadataValues")) {
                            if (!Array.isArray(message.adjustedTransactionExcludedPosMetadataValues))
                                return "adjustedTransactionExcludedPosMetadataValues: array expected";
                            for (var i = 0; i < message.adjustedTransactionExcludedPosMetadataValues.length; ++i)
                                if (!$util.isString(message.adjustedTransactionExcludedPosMetadataValues[i]))
                                    return "adjustedTransactionExcludedPosMetadataValues: string[] expected";
                        }
                        if (message.adjustedTransactionExcludedTransactionTypes != null && message.hasOwnProperty("adjustedTransactionExcludedTransactionTypes")) {
                            if (!Array.isArray(message.adjustedTransactionExcludedTransactionTypes))
                                return "adjustedTransactionExcludedTransactionTypes: array expected";
                            for (var i = 0; i < message.adjustedTransactionExcludedTransactionTypes.length; ++i)
                                if (!$util.isString(message.adjustedTransactionExcludedTransactionTypes[i]))
                                    return "adjustedTransactionExcludedTransactionTypes: string[] expected";
                        }
                        if (message.adjustedVisitMetricEnabled != null && message.hasOwnProperty("adjustedVisitMetricEnabled"))
                            if (typeof message.adjustedVisitMetricEnabled !== "boolean")
                                return "adjustedVisitMetricEnabled: boolean expected";
                        if (message.adjustedVisitMetricCalculationMethod != null && message.hasOwnProperty("adjustedVisitMetricCalculationMethod"))
                            switch (message.adjustedVisitMetricCalculationMethod) {
                            default:
                                return "adjustedVisitMetricCalculationMethod: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.adjustedVisitExcludedTransactionTypes != null && message.hasOwnProperty("adjustedVisitExcludedTransactionTypes")) {
                            if (!Array.isArray(message.adjustedVisitExcludedTransactionTypes))
                                return "adjustedVisitExcludedTransactionTypes: array expected";
                            for (var i = 0; i < message.adjustedVisitExcludedTransactionTypes.length; ++i)
                                if (!$util.isString(message.adjustedVisitExcludedTransactionTypes[i]))
                                    return "adjustedVisitExcludedTransactionTypes: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AdjustedMetricConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AdjustedMetricConfig} AdjustedMetricConfig
                     */
                    AdjustedMetricConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AdjustedMetricConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.AdjustedMetricConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.enabledDisplayAdjustedMetrics) {
                            if (!Array.isArray(object.enabledDisplayAdjustedMetrics))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.enabledDisplayAdjustedMetrics: array expected");
                            message.enabledDisplayAdjustedMetrics = [];
                            for (var i = 0; i < object.enabledDisplayAdjustedMetrics.length; ++i)
                                message.enabledDisplayAdjustedMetrics[i] = String(object.enabledDisplayAdjustedMetrics[i]);
                        }
                        if (object.adjustedNetSalesMetricEnabled != null)
                            message.adjustedNetSalesMetricEnabled = Boolean(object.adjustedNetSalesMetricEnabled);
                        if (object.adjustedNetSalesUseNetAmount != null)
                            message.adjustedNetSalesUseNetAmount = Boolean(object.adjustedNetSalesUseNetAmount);
                        if (object.adjustedNetSalesExcludedPosMetadataTypeId != null)
                            if ($util.Long)
                                (message.adjustedNetSalesExcludedPosMetadataTypeId = $util.Long.fromValue(object.adjustedNetSalesExcludedPosMetadataTypeId)).unsigned = false;
                            else if (typeof object.adjustedNetSalesExcludedPosMetadataTypeId === "string")
                                message.adjustedNetSalesExcludedPosMetadataTypeId = parseInt(object.adjustedNetSalesExcludedPosMetadataTypeId, 10);
                            else if (typeof object.adjustedNetSalesExcludedPosMetadataTypeId === "number")
                                message.adjustedNetSalesExcludedPosMetadataTypeId = object.adjustedNetSalesExcludedPosMetadataTypeId;
                            else if (typeof object.adjustedNetSalesExcludedPosMetadataTypeId === "object")
                                message.adjustedNetSalesExcludedPosMetadataTypeId = new $util.LongBits(object.adjustedNetSalesExcludedPosMetadataTypeId.low >>> 0, object.adjustedNetSalesExcludedPosMetadataTypeId.high >>> 0).toNumber();
                        if (object.adjustedNetSalesExcludedPosMetadataValues) {
                            if (!Array.isArray(object.adjustedNetSalesExcludedPosMetadataValues))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.adjustedNetSalesExcludedPosMetadataValues: array expected");
                            message.adjustedNetSalesExcludedPosMetadataValues = [];
                            for (var i = 0; i < object.adjustedNetSalesExcludedPosMetadataValues.length; ++i)
                                message.adjustedNetSalesExcludedPosMetadataValues[i] = String(object.adjustedNetSalesExcludedPosMetadataValues[i]);
                        }
                        if (object.adjustedNetSalesItemsMetricEnabled != null)
                            message.adjustedNetSalesItemsMetricEnabled = Boolean(object.adjustedNetSalesItemsMetricEnabled);
                        if (object.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems != null)
                            message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems = Boolean(object.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems);
                        if (object.adjustedNetSalesItemsExcludedPosMetadataTypeId != null)
                            if ($util.Long)
                                (message.adjustedNetSalesItemsExcludedPosMetadataTypeId = $util.Long.fromValue(object.adjustedNetSalesItemsExcludedPosMetadataTypeId)).unsigned = false;
                            else if (typeof object.adjustedNetSalesItemsExcludedPosMetadataTypeId === "string")
                                message.adjustedNetSalesItemsExcludedPosMetadataTypeId = parseInt(object.adjustedNetSalesItemsExcludedPosMetadataTypeId, 10);
                            else if (typeof object.adjustedNetSalesItemsExcludedPosMetadataTypeId === "number")
                                message.adjustedNetSalesItemsExcludedPosMetadataTypeId = object.adjustedNetSalesItemsExcludedPosMetadataTypeId;
                            else if (typeof object.adjustedNetSalesItemsExcludedPosMetadataTypeId === "object")
                                message.adjustedNetSalesItemsExcludedPosMetadataTypeId = new $util.LongBits(object.adjustedNetSalesItemsExcludedPosMetadataTypeId.low >>> 0, object.adjustedNetSalesItemsExcludedPosMetadataTypeId.high >>> 0).toNumber();
                        if (object.adjustedNetSalesItemsExcludedPosMetadataValues) {
                            if (!Array.isArray(object.adjustedNetSalesItemsExcludedPosMetadataValues))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.adjustedNetSalesItemsExcludedPosMetadataValues: array expected");
                            message.adjustedNetSalesItemsExcludedPosMetadataValues = [];
                            for (var i = 0; i < object.adjustedNetSalesItemsExcludedPosMetadataValues.length; ++i)
                                message.adjustedNetSalesItemsExcludedPosMetadataValues[i] = String(object.adjustedNetSalesItemsExcludedPosMetadataValues[i]);
                        }
                        if (object.adjustedTransactionMetricEnabled != null)
                            message.adjustedTransactionMetricEnabled = Boolean(object.adjustedTransactionMetricEnabled);
                        switch (object.adjustedTransactionMetricCalculationMethod) {
                        case "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED":
                        case 0:
                            message.adjustedTransactionMetricCalculationMethod = 0;
                            break;
                        case "ALL_TRANSACTIONS":
                        case 1:
                            message.adjustedTransactionMetricCalculationMethod = 1;
                            break;
                        case "SALE_ONLY":
                        case 2:
                            message.adjustedTransactionMetricCalculationMethod = 2;
                            break;
                        case "SALE_MINUS_RETURN":
                        case 3:
                            message.adjustedTransactionMetricCalculationMethod = 3;
                            break;
                        }
                        if (object.adjustedTransactionExcludedPosMetadataTypeId != null)
                            if ($util.Long)
                                (message.adjustedTransactionExcludedPosMetadataTypeId = $util.Long.fromValue(object.adjustedTransactionExcludedPosMetadataTypeId)).unsigned = false;
                            else if (typeof object.adjustedTransactionExcludedPosMetadataTypeId === "string")
                                message.adjustedTransactionExcludedPosMetadataTypeId = parseInt(object.adjustedTransactionExcludedPosMetadataTypeId, 10);
                            else if (typeof object.adjustedTransactionExcludedPosMetadataTypeId === "number")
                                message.adjustedTransactionExcludedPosMetadataTypeId = object.adjustedTransactionExcludedPosMetadataTypeId;
                            else if (typeof object.adjustedTransactionExcludedPosMetadataTypeId === "object")
                                message.adjustedTransactionExcludedPosMetadataTypeId = new $util.LongBits(object.adjustedTransactionExcludedPosMetadataTypeId.low >>> 0, object.adjustedTransactionExcludedPosMetadataTypeId.high >>> 0).toNumber();
                        if (object.adjustedTransactionExcludedPosMetadataValues) {
                            if (!Array.isArray(object.adjustedTransactionExcludedPosMetadataValues))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.adjustedTransactionExcludedPosMetadataValues: array expected");
                            message.adjustedTransactionExcludedPosMetadataValues = [];
                            for (var i = 0; i < object.adjustedTransactionExcludedPosMetadataValues.length; ++i)
                                message.adjustedTransactionExcludedPosMetadataValues[i] = String(object.adjustedTransactionExcludedPosMetadataValues[i]);
                        }
                        if (object.adjustedTransactionExcludedTransactionTypes) {
                            if (!Array.isArray(object.adjustedTransactionExcludedTransactionTypes))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.adjustedTransactionExcludedTransactionTypes: array expected");
                            message.adjustedTransactionExcludedTransactionTypes = [];
                            for (var i = 0; i < object.adjustedTransactionExcludedTransactionTypes.length; ++i)
                                message.adjustedTransactionExcludedTransactionTypes[i] = String(object.adjustedTransactionExcludedTransactionTypes[i]);
                        }
                        if (object.adjustedVisitMetricEnabled != null)
                            message.adjustedVisitMetricEnabled = Boolean(object.adjustedVisitMetricEnabled);
                        switch (object.adjustedVisitMetricCalculationMethod) {
                        case "ADJUSTED_VISIT_CALCULATION_METHOD_UNSPECIFIED":
                        case 0:
                            message.adjustedVisitMetricCalculationMethod = 0;
                            break;
                        case "TOTAL_VISIT_MINUS_FILTERED_TRANSACTIONS":
                        case 1:
                            message.adjustedVisitMetricCalculationMethod = 1;
                            break;
                        case "TOTAL_OPPORTUNITIES_MINUS_FILTERED_TRANSACTIONS":
                        case 2:
                            message.adjustedVisitMetricCalculationMethod = 2;
                            break;
                        }
                        if (object.adjustedVisitExcludedTransactionTypes) {
                            if (!Array.isArray(object.adjustedVisitExcludedTransactionTypes))
                                throw TypeError(".palexy.streaming.v1.AdjustedMetricConfig.adjustedVisitExcludedTransactionTypes: array expected");
                            message.adjustedVisitExcludedTransactionTypes = [];
                            for (var i = 0; i < object.adjustedVisitExcludedTransactionTypes.length; ++i)
                                message.adjustedVisitExcludedTransactionTypes[i] = String(object.adjustedVisitExcludedTransactionTypes[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AdjustedMetricConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @static
                     * @param {palexy.streaming.v1.AdjustedMetricConfig} message AdjustedMetricConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AdjustedMetricConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.enabledDisplayAdjustedMetrics = [];
                            object.adjustedNetSalesExcludedPosMetadataValues = [];
                            object.adjustedNetSalesItemsExcludedPosMetadataValues = [];
                            object.adjustedTransactionExcludedPosMetadataValues = [];
                            object.adjustedTransactionExcludedTransactionTypes = [];
                            object.adjustedVisitExcludedTransactionTypes = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.adjustedNetSalesMetricEnabled = false;
                            object.adjustedNetSalesUseNetAmount = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.adjustedNetSalesExcludedPosMetadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.adjustedNetSalesExcludedPosMetadataTypeId = options.longs === String ? "0" : 0;
                            object.adjustedNetSalesItemsMetricEnabled = false;
                            object.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.adjustedNetSalesItemsExcludedPosMetadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.adjustedNetSalesItemsExcludedPosMetadataTypeId = options.longs === String ? "0" : 0;
                            object.adjustedTransactionMetricEnabled = false;
                            object.adjustedTransactionMetricCalculationMethod = options.enums === String ? "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.adjustedTransactionExcludedPosMetadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.adjustedTransactionExcludedPosMetadataTypeId = options.longs === String ? "0" : 0;
                            object.adjustedVisitMetricEnabled = false;
                            object.adjustedVisitMetricCalculationMethod = options.enums === String ? "ADJUSTED_VISIT_CALCULATION_METHOD_UNSPECIFIED" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.enabledDisplayAdjustedMetrics && message.enabledDisplayAdjustedMetrics.length) {
                            object.enabledDisplayAdjustedMetrics = [];
                            for (var j = 0; j < message.enabledDisplayAdjustedMetrics.length; ++j)
                                object.enabledDisplayAdjustedMetrics[j] = message.enabledDisplayAdjustedMetrics[j];
                        }
                        if (message.adjustedNetSalesMetricEnabled != null && message.hasOwnProperty("adjustedNetSalesMetricEnabled"))
                            object.adjustedNetSalesMetricEnabled = message.adjustedNetSalesMetricEnabled;
                        if (message.adjustedNetSalesUseNetAmount != null && message.hasOwnProperty("adjustedNetSalesUseNetAmount"))
                            object.adjustedNetSalesUseNetAmount = message.adjustedNetSalesUseNetAmount;
                        if (message.adjustedNetSalesExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedNetSalesExcludedPosMetadataTypeId"))
                            if (typeof message.adjustedNetSalesExcludedPosMetadataTypeId === "number")
                                object.adjustedNetSalesExcludedPosMetadataTypeId = options.longs === String ? String(message.adjustedNetSalesExcludedPosMetadataTypeId) : message.adjustedNetSalesExcludedPosMetadataTypeId;
                            else
                                object.adjustedNetSalesExcludedPosMetadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.adjustedNetSalesExcludedPosMetadataTypeId) : options.longs === Number ? new $util.LongBits(message.adjustedNetSalesExcludedPosMetadataTypeId.low >>> 0, message.adjustedNetSalesExcludedPosMetadataTypeId.high >>> 0).toNumber() : message.adjustedNetSalesExcludedPosMetadataTypeId;
                        if (message.adjustedNetSalesExcludedPosMetadataValues && message.adjustedNetSalesExcludedPosMetadataValues.length) {
                            object.adjustedNetSalesExcludedPosMetadataValues = [];
                            for (var j = 0; j < message.adjustedNetSalesExcludedPosMetadataValues.length; ++j)
                                object.adjustedNetSalesExcludedPosMetadataValues[j] = message.adjustedNetSalesExcludedPosMetadataValues[j];
                        }
                        if (message.adjustedNetSalesItemsMetricEnabled != null && message.hasOwnProperty("adjustedNetSalesItemsMetricEnabled"))
                            object.adjustedNetSalesItemsMetricEnabled = message.adjustedNetSalesItemsMetricEnabled;
                        if (message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems != null && message.hasOwnProperty("adjustedNetSalesItemsUseSalesItemsAsNetSalesItems"))
                            object.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems = message.adjustedNetSalesItemsUseSalesItemsAsNetSalesItems;
                        if (message.adjustedNetSalesItemsExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedNetSalesItemsExcludedPosMetadataTypeId"))
                            if (typeof message.adjustedNetSalesItemsExcludedPosMetadataTypeId === "number")
                                object.adjustedNetSalesItemsExcludedPosMetadataTypeId = options.longs === String ? String(message.adjustedNetSalesItemsExcludedPosMetadataTypeId) : message.adjustedNetSalesItemsExcludedPosMetadataTypeId;
                            else
                                object.adjustedNetSalesItemsExcludedPosMetadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.adjustedNetSalesItemsExcludedPosMetadataTypeId) : options.longs === Number ? new $util.LongBits(message.adjustedNetSalesItemsExcludedPosMetadataTypeId.low >>> 0, message.adjustedNetSalesItemsExcludedPosMetadataTypeId.high >>> 0).toNumber() : message.adjustedNetSalesItemsExcludedPosMetadataTypeId;
                        if (message.adjustedNetSalesItemsExcludedPosMetadataValues && message.adjustedNetSalesItemsExcludedPosMetadataValues.length) {
                            object.adjustedNetSalesItemsExcludedPosMetadataValues = [];
                            for (var j = 0; j < message.adjustedNetSalesItemsExcludedPosMetadataValues.length; ++j)
                                object.adjustedNetSalesItemsExcludedPosMetadataValues[j] = message.adjustedNetSalesItemsExcludedPosMetadataValues[j];
                        }
                        if (message.adjustedTransactionMetricEnabled != null && message.hasOwnProperty("adjustedTransactionMetricEnabled"))
                            object.adjustedTransactionMetricEnabled = message.adjustedTransactionMetricEnabled;
                        if (message.adjustedTransactionMetricCalculationMethod != null && message.hasOwnProperty("adjustedTransactionMetricCalculationMethod"))
                            object.adjustedTransactionMetricCalculationMethod = options.enums === String ? $root.palexy.streaming.v1.TransactionCalculationMethod[message.adjustedTransactionMetricCalculationMethod] : message.adjustedTransactionMetricCalculationMethod;
                        if (message.adjustedTransactionExcludedPosMetadataTypeId != null && message.hasOwnProperty("adjustedTransactionExcludedPosMetadataTypeId"))
                            if (typeof message.adjustedTransactionExcludedPosMetadataTypeId === "number")
                                object.adjustedTransactionExcludedPosMetadataTypeId = options.longs === String ? String(message.adjustedTransactionExcludedPosMetadataTypeId) : message.adjustedTransactionExcludedPosMetadataTypeId;
                            else
                                object.adjustedTransactionExcludedPosMetadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.adjustedTransactionExcludedPosMetadataTypeId) : options.longs === Number ? new $util.LongBits(message.adjustedTransactionExcludedPosMetadataTypeId.low >>> 0, message.adjustedTransactionExcludedPosMetadataTypeId.high >>> 0).toNumber() : message.adjustedTransactionExcludedPosMetadataTypeId;
                        if (message.adjustedTransactionExcludedPosMetadataValues && message.adjustedTransactionExcludedPosMetadataValues.length) {
                            object.adjustedTransactionExcludedPosMetadataValues = [];
                            for (var j = 0; j < message.adjustedTransactionExcludedPosMetadataValues.length; ++j)
                                object.adjustedTransactionExcludedPosMetadataValues[j] = message.adjustedTransactionExcludedPosMetadataValues[j];
                        }
                        if (message.adjustedTransactionExcludedTransactionTypes && message.adjustedTransactionExcludedTransactionTypes.length) {
                            object.adjustedTransactionExcludedTransactionTypes = [];
                            for (var j = 0; j < message.adjustedTransactionExcludedTransactionTypes.length; ++j)
                                object.adjustedTransactionExcludedTransactionTypes[j] = message.adjustedTransactionExcludedTransactionTypes[j];
                        }
                        if (message.adjustedVisitMetricEnabled != null && message.hasOwnProperty("adjustedVisitMetricEnabled"))
                            object.adjustedVisitMetricEnabled = message.adjustedVisitMetricEnabled;
                        if (message.adjustedVisitMetricCalculationMethod != null && message.hasOwnProperty("adjustedVisitMetricCalculationMethod"))
                            object.adjustedVisitMetricCalculationMethod = options.enums === String ? $root.palexy.streaming.v1.AdjustedVisitCalculationMethod[message.adjustedVisitMetricCalculationMethod] : message.adjustedVisitMetricCalculationMethod;
                        if (message.adjustedVisitExcludedTransactionTypes && message.adjustedVisitExcludedTransactionTypes.length) {
                            object.adjustedVisitExcludedTransactionTypes = [];
                            for (var j = 0; j < message.adjustedVisitExcludedTransactionTypes.length; ++j)
                                object.adjustedVisitExcludedTransactionTypes[j] = message.adjustedVisitExcludedTransactionTypes[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AdjustedMetricConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AdjustedMetricConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AdjustedMetricConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AdjustedMetricConfig;
                })();
    
                /**
                 * TransactionCalculationMethod enum.
                 * @name palexy.streaming.v1.TransactionCalculationMethod
                 * @enum {number}
                 * @property {number} TRANSACTION_CALCULATION_METHOD_UNSPECIFIED=0 TRANSACTION_CALCULATION_METHOD_UNSPECIFIED value
                 * @property {number} ALL_TRANSACTIONS=1 ALL_TRANSACTIONS value
                 * @property {number} SALE_ONLY=2 SALE_ONLY value
                 * @property {number} SALE_MINUS_RETURN=3 SALE_MINUS_RETURN value
                 */
                v1.TransactionCalculationMethod = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "ALL_TRANSACTIONS"] = 1;
                    values[valuesById[2] = "SALE_ONLY"] = 2;
                    values[valuesById[3] = "SALE_MINUS_RETURN"] = 3;
                    return values;
                })();
    
                /**
                 * AdjustedVisitCalculationMethod enum.
                 * @name palexy.streaming.v1.AdjustedVisitCalculationMethod
                 * @enum {number}
                 * @property {number} ADJUSTED_VISIT_CALCULATION_METHOD_UNSPECIFIED=0 ADJUSTED_VISIT_CALCULATION_METHOD_UNSPECIFIED value
                 * @property {number} TOTAL_VISIT_MINUS_FILTERED_TRANSACTIONS=1 TOTAL_VISIT_MINUS_FILTERED_TRANSACTIONS value
                 * @property {number} TOTAL_OPPORTUNITIES_MINUS_FILTERED_TRANSACTIONS=2 TOTAL_OPPORTUNITIES_MINUS_FILTERED_TRANSACTIONS value
                 */
                v1.AdjustedVisitCalculationMethod = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "ADJUSTED_VISIT_CALCULATION_METHOD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "TOTAL_VISIT_MINUS_FILTERED_TRANSACTIONS"] = 1;
                    values[valuesById[2] = "TOTAL_OPPORTUNITIES_MINUS_FILTERED_TRANSACTIONS"] = 2;
                    return values;
                })();
    
                v1.CriticalHoursOfDayOfWeek = (function() {
    
                    /**
                     * Properties of a CriticalHoursOfDayOfWeek.
                     * @memberof palexy.streaming.v1
                     * @interface ICriticalHoursOfDayOfWeek
                     * @property {palexy.streaming.v1.DayOfWeek|null} [dayOfWeek] CriticalHoursOfDayOfWeek dayOfWeek
                     * @property {Array.<number>|null} [hours] CriticalHoursOfDayOfWeek hours
                     */
    
                    /**
                     * Constructs a new CriticalHoursOfDayOfWeek.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CriticalHoursOfDayOfWeek.
                     * @implements ICriticalHoursOfDayOfWeek
                     * @constructor
                     * @param {palexy.streaming.v1.ICriticalHoursOfDayOfWeek=} [properties] Properties to set
                     */
                    function CriticalHoursOfDayOfWeek(properties) {
                        this.hours = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CriticalHoursOfDayOfWeek dayOfWeek.
                     * @member {palexy.streaming.v1.DayOfWeek} dayOfWeek
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @instance
                     */
                    CriticalHoursOfDayOfWeek.prototype.dayOfWeek = 0;
    
                    /**
                     * CriticalHoursOfDayOfWeek hours.
                     * @member {Array.<number>} hours
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @instance
                     */
                    CriticalHoursOfDayOfWeek.prototype.hours = $util.emptyArray;
    
                    /**
                     * Creates a new CriticalHoursOfDayOfWeek instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {palexy.streaming.v1.ICriticalHoursOfDayOfWeek=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CriticalHoursOfDayOfWeek} CriticalHoursOfDayOfWeek instance
                     */
                    CriticalHoursOfDayOfWeek.create = function create(properties) {
                        return new CriticalHoursOfDayOfWeek(properties);
                    };
    
                    /**
                     * Encodes the specified CriticalHoursOfDayOfWeek message. Does not implicitly {@link palexy.streaming.v1.CriticalHoursOfDayOfWeek.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {palexy.streaming.v1.ICriticalHoursOfDayOfWeek} message CriticalHoursOfDayOfWeek message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CriticalHoursOfDayOfWeek.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dayOfWeek != null && Object.hasOwnProperty.call(message, "dayOfWeek"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dayOfWeek);
                        if (message.hours != null && message.hours.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.hours.length; ++i)
                                writer.int32(message.hours[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CriticalHoursOfDayOfWeek message, length delimited. Does not implicitly {@link palexy.streaming.v1.CriticalHoursOfDayOfWeek.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {palexy.streaming.v1.ICriticalHoursOfDayOfWeek} message CriticalHoursOfDayOfWeek message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CriticalHoursOfDayOfWeek.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CriticalHoursOfDayOfWeek message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CriticalHoursOfDayOfWeek} CriticalHoursOfDayOfWeek
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CriticalHoursOfDayOfWeek.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dayOfWeek = reader.int32();
                                break;
                            case 2:
                                if (!(message.hours && message.hours.length))
                                    message.hours = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.hours.push(reader.int32());
                                } else
                                    message.hours.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CriticalHoursOfDayOfWeek message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CriticalHoursOfDayOfWeek} CriticalHoursOfDayOfWeek
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CriticalHoursOfDayOfWeek.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CriticalHoursOfDayOfWeek message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CriticalHoursOfDayOfWeek.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                            switch (message.dayOfWeek) {
                            default:
                                return "dayOfWeek: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.hours != null && message.hasOwnProperty("hours")) {
                            if (!Array.isArray(message.hours))
                                return "hours: array expected";
                            for (var i = 0; i < message.hours.length; ++i)
                                if (!$util.isInteger(message.hours[i]))
                                    return "hours: integer[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CriticalHoursOfDayOfWeek message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CriticalHoursOfDayOfWeek} CriticalHoursOfDayOfWeek
                     */
                    CriticalHoursOfDayOfWeek.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek)
                            return object;
                        var message = new $root.palexy.streaming.v1.CriticalHoursOfDayOfWeek();
                        switch (object.dayOfWeek) {
                        case "DAY_OF_WEEK_UNSPECIFIED":
                        case 0:
                            message.dayOfWeek = 0;
                            break;
                        case "MONDAY":
                        case 1:
                            message.dayOfWeek = 1;
                            break;
                        case "TUESDAY":
                        case 2:
                            message.dayOfWeek = 2;
                            break;
                        case "WEDNESDAY":
                        case 3:
                            message.dayOfWeek = 3;
                            break;
                        case "THURSDAY":
                        case 4:
                            message.dayOfWeek = 4;
                            break;
                        case "FRIDAY":
                        case 5:
                            message.dayOfWeek = 5;
                            break;
                        case "SATURDAY":
                        case 6:
                            message.dayOfWeek = 6;
                            break;
                        case "SUNDAY":
                        case 7:
                            message.dayOfWeek = 7;
                            break;
                        }
                        if (object.hours) {
                            if (!Array.isArray(object.hours))
                                throw TypeError(".palexy.streaming.v1.CriticalHoursOfDayOfWeek.hours: array expected");
                            message.hours = [];
                            for (var i = 0; i < object.hours.length; ++i)
                                message.hours[i] = object.hours[i] | 0;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CriticalHoursOfDayOfWeek message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @static
                     * @param {palexy.streaming.v1.CriticalHoursOfDayOfWeek} message CriticalHoursOfDayOfWeek
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CriticalHoursOfDayOfWeek.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.hours = [];
                        if (options.defaults)
                            object.dayOfWeek = options.enums === String ? "DAY_OF_WEEK_UNSPECIFIED" : 0;
                        if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                            object.dayOfWeek = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.dayOfWeek] : message.dayOfWeek;
                        if (message.hours && message.hours.length) {
                            object.hours = [];
                            for (var j = 0; j < message.hours.length; ++j)
                                object.hours[j] = message.hours[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CriticalHoursOfDayOfWeek to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CriticalHoursOfDayOfWeek
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CriticalHoursOfDayOfWeek.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CriticalHoursOfDayOfWeek;
                })();
    
                v1.CompanyService = (function() {
    
                    /**
                     * Constructs a new CompanyService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CompanyService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CompanyService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CompanyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CompanyService;
    
                    /**
                     * Creates new CompanyService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CompanyService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CompanyService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CompanyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CompanyService#listCompanies}.
                     * @memberof palexy.streaming.v1.CompanyService
                     * @typedef ListCompaniesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCompaniesResponse} [response] ListCompaniesResponse
                     */
    
                    /**
                     * Calls ListCompanies.
                     * @function listCompanies
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompaniesRequest} request ListCompaniesRequest message or plain object
                     * @param {palexy.streaming.v1.CompanyService.ListCompaniesCallback} callback Node-style callback called with the error, if any, and ListCompaniesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyService.prototype.listCompanies = function listCompanies(request, callback) {
                        return this.rpcCall(listCompanies, $root.palexy.streaming.v1.ListCompaniesRequest, $root.palexy.streaming.v1.ListCompaniesResponse, request, callback);
                    }, "name", { value: "ListCompanies" });
    
                    /**
                     * Calls ListCompanies.
                     * @function listCompanies
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompaniesRequest} request ListCompaniesRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCompaniesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CompanyService#getCompany}.
                     * @memberof palexy.streaming.v1.CompanyService
                     * @typedef GetCompanyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Company} [response] Company
                     */
    
                    /**
                     * Calls GetCompany.
                     * @function getCompany
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCompanyRequest} request GetCompanyRequest message or plain object
                     * @param {palexy.streaming.v1.CompanyService.GetCompanyCallback} callback Node-style callback called with the error, if any, and Company
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyService.prototype.getCompany = function getCompany(request, callback) {
                        return this.rpcCall(getCompany, $root.palexy.streaming.v1.GetCompanyRequest, $root.palexy.streaming.v1.Company, request, callback);
                    }, "name", { value: "GetCompany" });
    
                    /**
                     * Calls GetCompany.
                     * @function getCompany
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCompanyRequest} request GetCompanyRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Company>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CompanyService#getCompanyCurrentTimesWithTimezone}.
                     * @memberof palexy.streaming.v1.CompanyService
                     * @typedef GetCompanyCurrentTimesWithTimezoneCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} [response] GetCompanyCurrentTimesWithTimezoneResponse
                     */
    
                    /**
                     * Calls GetCompanyCurrentTimesWithTimezone.
                     * @function getCompanyCurrentTimesWithTimezone
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest} request GetCompanyCurrentTimesWithTimezoneRequest message or plain object
                     * @param {palexy.streaming.v1.CompanyService.GetCompanyCurrentTimesWithTimezoneCallback} callback Node-style callback called with the error, if any, and GetCompanyCurrentTimesWithTimezoneResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyService.prototype.getCompanyCurrentTimesWithTimezone = function getCompanyCurrentTimesWithTimezone(request, callback) {
                        return this.rpcCall(getCompanyCurrentTimesWithTimezone, $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest, $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse, request, callback);
                    }, "name", { value: "GetCompanyCurrentTimesWithTimezone" });
    
                    /**
                     * Calls GetCompanyCurrentTimesWithTimezone.
                     * @function getCompanyCurrentTimesWithTimezone
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest} request GetCompanyCurrentTimesWithTimezoneRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CompanyService#findCompaniesReadyForTaskScheduling}.
                     * @memberof palexy.streaming.v1.CompanyService
                     * @typedef FindCompaniesReadyForTaskSchedulingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} [response] FindCompaniesReadyForTaskSchedulingResponse
                     */
    
                    /**
                     * Calls FindCompaniesReadyForTaskScheduling.
                     * @function findCompaniesReadyForTaskScheduling
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest} request FindCompaniesReadyForTaskSchedulingRequest message or plain object
                     * @param {palexy.streaming.v1.CompanyService.FindCompaniesReadyForTaskSchedulingCallback} callback Node-style callback called with the error, if any, and FindCompaniesReadyForTaskSchedulingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyService.prototype.findCompaniesReadyForTaskScheduling = function findCompaniesReadyForTaskScheduling(request, callback) {
                        return this.rpcCall(findCompaniesReadyForTaskScheduling, $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest, $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse, request, callback);
                    }, "name", { value: "FindCompaniesReadyForTaskScheduling" });
    
                    /**
                     * Calls FindCompaniesReadyForTaskScheduling.
                     * @function findCompaniesReadyForTaskScheduling
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest} request FindCompaniesReadyForTaskSchedulingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CompanyService#findCompaniesEligibleForEmployeePolicyRule}.
                     * @memberof palexy.streaming.v1.CompanyService
                     * @typedef FindCompaniesEligibleForEmployeePolicyRuleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} [response] FindCompaniesEligibleForEmployeePolicyRuleResponse
                     */
    
                    /**
                     * Calls FindCompaniesEligibleForEmployeePolicyRule.
                     * @function findCompaniesEligibleForEmployeePolicyRule
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest} request FindCompaniesEligibleForEmployeePolicyRuleRequest message or plain object
                     * @param {palexy.streaming.v1.CompanyService.FindCompaniesEligibleForEmployeePolicyRuleCallback} callback Node-style callback called with the error, if any, and FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyService.prototype.findCompaniesEligibleForEmployeePolicyRule = function findCompaniesEligibleForEmployeePolicyRule(request, callback) {
                        return this.rpcCall(findCompaniesEligibleForEmployeePolicyRule, $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest, $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse, request, callback);
                    }, "name", { value: "FindCompaniesEligibleForEmployeePolicyRule" });
    
                    /**
                     * Calls FindCompaniesEligibleForEmployeePolicyRule.
                     * @function findCompaniesEligibleForEmployeePolicyRule
                     * @memberof palexy.streaming.v1.CompanyService
                     * @instance
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest} request FindCompaniesEligibleForEmployeePolicyRuleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse>} Promise
                     * @variation 2
                     */
    
                    return CompanyService;
                })();
    
                v1.GetCompanyCurrentTimesWithTimezoneRequest = (function() {
    
                    /**
                     * Properties of a GetCompanyCurrentTimesWithTimezoneRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCompanyCurrentTimesWithTimezoneRequest
                     * @property {number|null} [id] GetCompanyCurrentTimesWithTimezoneRequest id
                     */
    
                    /**
                     * Constructs a new GetCompanyCurrentTimesWithTimezoneRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCompanyCurrentTimesWithTimezoneRequest.
                     * @implements IGetCompanyCurrentTimesWithTimezoneRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest=} [properties] Properties to set
                     */
                    function GetCompanyCurrentTimesWithTimezoneRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyCurrentTimesWithTimezoneRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @instance
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCompanyCurrentTimesWithTimezoneRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest} GetCompanyCurrentTimesWithTimezoneRequest instance
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.create = function create(properties) {
                        return new GetCompanyCurrentTimesWithTimezoneRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyCurrentTimesWithTimezoneRequest message. Does not implicitly {@link palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest} message GetCompanyCurrentTimesWithTimezoneRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyCurrentTimesWithTimezoneRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneRequest} message GetCompanyCurrentTimesWithTimezoneRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyCurrentTimesWithTimezoneRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest} GetCompanyCurrentTimesWithTimezoneRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyCurrentTimesWithTimezoneRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest} GetCompanyCurrentTimesWithTimezoneRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyCurrentTimesWithTimezoneRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyCurrentTimesWithTimezoneRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest} GetCompanyCurrentTimesWithTimezoneRequest
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyCurrentTimesWithTimezoneRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @static
                     * @param {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest} message GetCompanyCurrentTimesWithTimezoneRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyCurrentTimesWithTimezoneRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyCurrentTimesWithTimezoneRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyCurrentTimesWithTimezoneRequest;
                })();
    
                v1.GetCompanyCurrentTimesWithTimezoneResponse = (function() {
    
                    /**
                     * Properties of a GetCompanyCurrentTimesWithTimezoneResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCompanyCurrentTimesWithTimezoneResponse
                     * @property {Array.<string>|null} [currentTimes] GetCompanyCurrentTimesWithTimezoneResponse currentTimes
                     */
    
                    /**
                     * Constructs a new GetCompanyCurrentTimesWithTimezoneResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCompanyCurrentTimesWithTimezoneResponse.
                     * @implements IGetCompanyCurrentTimesWithTimezoneResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneResponse=} [properties] Properties to set
                     */
                    function GetCompanyCurrentTimesWithTimezoneResponse(properties) {
                        this.currentTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyCurrentTimesWithTimezoneResponse currentTimes.
                     * @member {Array.<string>} currentTimes
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @instance
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.prototype.currentTimes = $util.emptyArray;
    
                    /**
                     * Creates a new GetCompanyCurrentTimesWithTimezoneResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} GetCompanyCurrentTimesWithTimezoneResponse instance
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.create = function create(properties) {
                        return new GetCompanyCurrentTimesWithTimezoneResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyCurrentTimesWithTimezoneResponse message. Does not implicitly {@link palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneResponse} message GetCompanyCurrentTimesWithTimezoneResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.currentTimes != null && message.currentTimes.length)
                            for (var i = 0; i < message.currentTimes.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.currentTimes[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyCurrentTimesWithTimezoneResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyCurrentTimesWithTimezoneResponse} message GetCompanyCurrentTimesWithTimezoneResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyCurrentTimesWithTimezoneResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} GetCompanyCurrentTimesWithTimezoneResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.currentTimes && message.currentTimes.length))
                                    message.currentTimes = [];
                                message.currentTimes.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyCurrentTimesWithTimezoneResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} GetCompanyCurrentTimesWithTimezoneResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyCurrentTimesWithTimezoneResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.currentTimes != null && message.hasOwnProperty("currentTimes")) {
                            if (!Array.isArray(message.currentTimes))
                                return "currentTimes: array expected";
                            for (var i = 0; i < message.currentTimes.length; ++i)
                                if (!$util.isString(message.currentTimes[i]))
                                    return "currentTimes: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyCurrentTimesWithTimezoneResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} GetCompanyCurrentTimesWithTimezoneResponse
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse();
                        if (object.currentTimes) {
                            if (!Array.isArray(object.currentTimes))
                                throw TypeError(".palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse.currentTimes: array expected");
                            message.currentTimes = [];
                            for (var i = 0; i < object.currentTimes.length; ++i)
                                message.currentTimes[i] = String(object.currentTimes[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyCurrentTimesWithTimezoneResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @static
                     * @param {palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse} message GetCompanyCurrentTimesWithTimezoneResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.currentTimes = [];
                        if (message.currentTimes && message.currentTimes.length) {
                            object.currentTimes = [];
                            for (var j = 0; j < message.currentTimes.length; ++j)
                                object.currentTimes[j] = message.currentTimes[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyCurrentTimesWithTimezoneResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCompanyCurrentTimesWithTimezoneResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyCurrentTimesWithTimezoneResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyCurrentTimesWithTimezoneResponse;
                })();
    
                v1.ListCompaniesRequest = (function() {
    
                    /**
                     * Properties of a ListCompaniesRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompaniesRequest
                     * @property {google.protobuf.IBoolValue|null} [isNearRealTime] ListCompaniesRequest isNearRealTime
                     */
    
                    /**
                     * Constructs a new ListCompaniesRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompaniesRequest.
                     * @implements IListCompaniesRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompaniesRequest=} [properties] Properties to set
                     */
                    function ListCompaniesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompaniesRequest isNearRealTime.
                     * @member {google.protobuf.IBoolValue|null|undefined} isNearRealTime
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @instance
                     */
                    ListCompaniesRequest.prototype.isNearRealTime = null;
    
                    /**
                     * Creates a new ListCompaniesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompaniesRequest} ListCompaniesRequest instance
                     */
                    ListCompaniesRequest.create = function create(properties) {
                        return new ListCompaniesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompaniesRequest message. Does not implicitly {@link palexy.streaming.v1.ListCompaniesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesRequest} message ListCompaniesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompaniesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.isNearRealTime != null && Object.hasOwnProperty.call(message, "isNearRealTime"))
                            $root.google.protobuf.BoolValue.encode(message.isNearRealTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompaniesRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompaniesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesRequest} message ListCompaniesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompaniesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompaniesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompaniesRequest} ListCompaniesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompaniesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompaniesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.isNearRealTime = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompaniesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompaniesRequest} ListCompaniesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompaniesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompaniesRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompaniesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.isNearRealTime != null && message.hasOwnProperty("isNearRealTime")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isNearRealTime);
                            if (error)
                                return "isNearRealTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCompaniesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompaniesRequest} ListCompaniesRequest
                     */
                    ListCompaniesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompaniesRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompaniesRequest();
                        if (object.isNearRealTime != null) {
                            if (typeof object.isNearRealTime !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCompaniesRequest.isNearRealTime: object expected");
                            message.isNearRealTime = $root.google.protobuf.BoolValue.fromObject(object.isNearRealTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompaniesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCompaniesRequest} message ListCompaniesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompaniesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.isNearRealTime = null;
                        if (message.isNearRealTime != null && message.hasOwnProperty("isNearRealTime"))
                            object.isNearRealTime = $root.google.protobuf.BoolValue.toObject(message.isNearRealTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListCompaniesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompaniesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompaniesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompaniesRequest;
                })();
    
                v1.ListCompaniesResponse = (function() {
    
                    /**
                     * Properties of a ListCompaniesResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompaniesResponse
                     * @property {Array.<palexy.streaming.v1.ICompany>|null} [companies] ListCompaniesResponse companies
                     */
    
                    /**
                     * Constructs a new ListCompaniesResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompaniesResponse.
                     * @implements IListCompaniesResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompaniesResponse=} [properties] Properties to set
                     */
                    function ListCompaniesResponse(properties) {
                        this.companies = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompaniesResponse companies.
                     * @member {Array.<palexy.streaming.v1.ICompany>} companies
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @instance
                     */
                    ListCompaniesResponse.prototype.companies = $util.emptyArray;
    
                    /**
                     * Creates a new ListCompaniesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompaniesResponse} ListCompaniesResponse instance
                     */
                    ListCompaniesResponse.create = function create(properties) {
                        return new ListCompaniesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompaniesResponse message. Does not implicitly {@link palexy.streaming.v1.ListCompaniesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesResponse} message ListCompaniesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompaniesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companies != null && message.companies.length)
                            for (var i = 0; i < message.companies.length; ++i)
                                $root.palexy.streaming.v1.Company.encode(message.companies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompaniesResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompaniesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompaniesResponse} message ListCompaniesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompaniesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompaniesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompaniesResponse} ListCompaniesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompaniesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompaniesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companies && message.companies.length))
                                    message.companies = [];
                                message.companies.push($root.palexy.streaming.v1.Company.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompaniesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompaniesResponse} ListCompaniesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompaniesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompaniesResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompaniesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companies != null && message.hasOwnProperty("companies")) {
                            if (!Array.isArray(message.companies))
                                return "companies: array expected";
                            for (var i = 0; i < message.companies.length; ++i) {
                                var error = $root.palexy.streaming.v1.Company.verify(message.companies[i]);
                                if (error)
                                    return "companies." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCompaniesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompaniesResponse} ListCompaniesResponse
                     */
                    ListCompaniesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompaniesResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompaniesResponse();
                        if (object.companies) {
                            if (!Array.isArray(object.companies))
                                throw TypeError(".palexy.streaming.v1.ListCompaniesResponse.companies: array expected");
                            message.companies = [];
                            for (var i = 0; i < object.companies.length; ++i) {
                                if (typeof object.companies[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCompaniesResponse.companies: object expected");
                                message.companies[i] = $root.palexy.streaming.v1.Company.fromObject(object.companies[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompaniesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCompaniesResponse} message ListCompaniesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompaniesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companies = [];
                        if (message.companies && message.companies.length) {
                            object.companies = [];
                            for (var j = 0; j < message.companies.length; ++j)
                                object.companies[j] = $root.palexy.streaming.v1.Company.toObject(message.companies[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCompaniesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompaniesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompaniesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompaniesResponse;
                })();
    
                v1.FindCompaniesEligibleForEmployeePolicyRuleRequest = (function() {
    
                    /**
                     * Properties of a FindCompaniesEligibleForEmployeePolicyRuleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @property {palexy.protobuf.EmployeePolicyRule.RuleType|null} [ruleType] FindCompaniesEligibleForEmployeePolicyRuleRequest ruleType
                     */
    
                    /**
                     * Constructs a new FindCompaniesEligibleForEmployeePolicyRuleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindCompaniesEligibleForEmployeePolicyRuleRequest.
                     * @implements IFindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest=} [properties] Properties to set
                     */
                    function FindCompaniesEligibleForEmployeePolicyRuleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCompaniesEligibleForEmployeePolicyRuleRequest ruleType.
                     * @member {palexy.protobuf.EmployeePolicyRule.RuleType} ruleType
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @instance
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.prototype.ruleType = 0;
    
                    /**
                     * Creates a new FindCompaniesEligibleForEmployeePolicyRuleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest} FindCompaniesEligibleForEmployeePolicyRuleRequest instance
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.create = function create(properties) {
                        return new FindCompaniesEligibleForEmployeePolicyRuleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindCompaniesEligibleForEmployeePolicyRuleRequest message. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest} message FindCompaniesEligibleForEmployeePolicyRuleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ruleType != null && Object.hasOwnProperty.call(message, "ruleType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ruleType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCompaniesEligibleForEmployeePolicyRuleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleRequest} message FindCompaniesEligibleForEmployeePolicyRuleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCompaniesEligibleForEmployeePolicyRuleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest} FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.ruleType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCompaniesEligibleForEmployeePolicyRuleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest} FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCompaniesEligibleForEmployeePolicyRuleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                            switch (message.ruleType) {
                            default:
                                return "ruleType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a FindCompaniesEligibleForEmployeePolicyRuleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest} FindCompaniesEligibleForEmployeePolicyRuleRequest
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest();
                        switch (object.ruleType) {
                        case "RULE_TYPE_UNSPECIFIED":
                        case 0:
                            message.ruleType = 0;
                            break;
                        case "REQUIRE_CLOCKING":
                        case 1:
                            message.ruleType = 1;
                            break;
                        case "AUTO_GENERATE_SCHEDULE":
                        case 2:
                            message.ruleType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCompaniesEligibleForEmployeePolicyRuleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @static
                     * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest} message FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.ruleType = options.enums === String ? "RULE_TYPE_UNSPECIFIED" : 0;
                        if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                            object.ruleType = options.enums === String ? $root.palexy.protobuf.EmployeePolicyRule.RuleType[message.ruleType] : message.ruleType;
                        return object;
                    };
    
                    /**
                     * Converts this FindCompaniesEligibleForEmployeePolicyRuleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindCompaniesEligibleForEmployeePolicyRuleRequest;
                })();
    
                v1.FindCompaniesEligibleForEmployeePolicyRuleResponse = (function() {
    
                    /**
                     * Properties of a FindCompaniesEligibleForEmployeePolicyRuleResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @property {Array.<palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany>|null} [companies] FindCompaniesEligibleForEmployeePolicyRuleResponse companies
                     */
    
                    /**
                     * Constructs a new FindCompaniesEligibleForEmployeePolicyRuleResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindCompaniesEligibleForEmployeePolicyRuleResponse.
                     * @implements IFindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleResponse=} [properties] Properties to set
                     */
                    function FindCompaniesEligibleForEmployeePolicyRuleResponse(properties) {
                        this.companies = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCompaniesEligibleForEmployeePolicyRuleResponse companies.
                     * @member {Array.<palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany>} companies
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @instance
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.prototype.companies = $util.emptyArray;
    
                    /**
                     * Creates a new FindCompaniesEligibleForEmployeePolicyRuleResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} FindCompaniesEligibleForEmployeePolicyRuleResponse instance
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.create = function create(properties) {
                        return new FindCompaniesEligibleForEmployeePolicyRuleResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FindCompaniesEligibleForEmployeePolicyRuleResponse message. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleResponse} message FindCompaniesEligibleForEmployeePolicyRuleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companies != null && message.companies.length)
                            for (var i = 0; i < message.companies.length; ++i)
                                $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.encode(message.companies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCompaniesEligibleForEmployeePolicyRuleResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesEligibleForEmployeePolicyRuleResponse} message FindCompaniesEligibleForEmployeePolicyRuleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCompaniesEligibleForEmployeePolicyRuleResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companies && message.companies.length))
                                    message.companies = [];
                                message.companies.push($root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCompaniesEligibleForEmployeePolicyRuleResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCompaniesEligibleForEmployeePolicyRuleResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companies != null && message.hasOwnProperty("companies")) {
                            if (!Array.isArray(message.companies))
                                return "companies: array expected";
                            for (var i = 0; i < message.companies.length; ++i) {
                                var error = $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.verify(message.companies[i]);
                                if (error)
                                    return "companies." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FindCompaniesEligibleForEmployeePolicyRuleResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} FindCompaniesEligibleForEmployeePolicyRuleResponse
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse();
                        if (object.companies) {
                            if (!Array.isArray(object.companies))
                                throw TypeError(".palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.companies: array expected");
                            message.companies = [];
                            for (var i = 0; i < object.companies.length; ++i) {
                                if (typeof object.companies[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.companies: object expected");
                                message.companies[i] = $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.fromObject(object.companies[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCompaniesEligibleForEmployeePolicyRuleResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @static
                     * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse} message FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companies = [];
                        if (message.companies && message.companies.length) {
                            object.companies = [];
                            for (var j = 0; j < message.companies.length; ++j)
                                object.companies[j] = $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.toObject(message.companies[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FindCompaniesEligibleForEmployeePolicyRuleResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany = (function() {
    
                        /**
                         * Properties of an EligibleCompany.
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                         * @interface IEligibleCompany
                         * @property {number|null} [companyId] EligibleCompany companyId
                         * @property {string|null} [timezone] EligibleCompany timezone
                         * @property {number|null} [dayOfMonthToStartPayPeriod] EligibleCompany dayOfMonthToStartPayPeriod
                         */
    
                        /**
                         * Constructs a new EligibleCompany.
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse
                         * @classdesc Represents an EligibleCompany.
                         * @implements IEligibleCompany
                         * @constructor
                         * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany=} [properties] Properties to set
                         */
                        function EligibleCompany(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * EligibleCompany companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @instance
                         */
                        EligibleCompany.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * EligibleCompany timezone.
                         * @member {string} timezone
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @instance
                         */
                        EligibleCompany.prototype.timezone = "";
    
                        /**
                         * EligibleCompany dayOfMonthToStartPayPeriod.
                         * @member {number} dayOfMonthToStartPayPeriod
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @instance
                         */
                        EligibleCompany.prototype.dayOfMonthToStartPayPeriod = 0;
    
                        /**
                         * Creates a new EligibleCompany instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany} EligibleCompany instance
                         */
                        EligibleCompany.create = function create(properties) {
                            return new EligibleCompany(properties);
                        };
    
                        /**
                         * Encodes the specified EligibleCompany message. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany} message EligibleCompany message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EligibleCompany.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                            if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.timezone);
                            if (message.dayOfMonthToStartPayPeriod != null && Object.hasOwnProperty.call(message, "dayOfMonthToStartPayPeriod"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dayOfMonthToStartPayPeriod);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified EligibleCompany message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.IEligibleCompany} message EligibleCompany message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        EligibleCompany.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an EligibleCompany message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany} EligibleCompany
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EligibleCompany.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.companyId = reader.int64();
                                    break;
                                case 2:
                                    message.timezone = reader.string();
                                    break;
                                case 3:
                                    message.dayOfMonthToStartPayPeriod = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an EligibleCompany message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany} EligibleCompany
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        EligibleCompany.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an EligibleCompany message.
                         * @function verify
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        EligibleCompany.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                if (!$util.isString(message.timezone))
                                    return "timezone: string expected";
                            if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                                if (!$util.isInteger(message.dayOfMonthToStartPayPeriod))
                                    return "dayOfMonthToStartPayPeriod: integer expected";
                            return null;
                        };
    
                        /**
                         * Creates an EligibleCompany message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany} EligibleCompany
                         */
                        EligibleCompany.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany)
                                return object;
                            var message = new $root.palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany();
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            if (object.timezone != null)
                                message.timezone = String(object.timezone);
                            if (object.dayOfMonthToStartPayPeriod != null)
                                message.dayOfMonthToStartPayPeriod = object.dayOfMonthToStartPayPeriod | 0;
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an EligibleCompany message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @static
                         * @param {palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany} message EligibleCompany
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        EligibleCompany.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                                object.timezone = "";
                                object.dayOfMonthToStartPayPeriod = 0;
                            }
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (message.timezone != null && message.hasOwnProperty("timezone"))
                                object.timezone = message.timezone;
                            if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                                object.dayOfMonthToStartPayPeriod = message.dayOfMonthToStartPayPeriod;
                            return object;
                        };
    
                        /**
                         * Converts this EligibleCompany to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.FindCompaniesEligibleForEmployeePolicyRuleResponse.EligibleCompany
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        EligibleCompany.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return EligibleCompany;
                    })();
    
                    return FindCompaniesEligibleForEmployeePolicyRuleResponse;
                })();
    
                v1.GetCompanyRequest = (function() {
    
                    /**
                     * Properties of a GetCompanyRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetCompanyRequest
                     * @property {number|null} [id] GetCompanyRequest id
                     * @property {boolean|null} [fetchOwnerAccount] GetCompanyRequest fetchOwnerAccount
                     * @property {boolean|null} [fetchStoreTimezone] GetCompanyRequest fetchStoreTimezone
                     */
    
                    /**
                     * Constructs a new GetCompanyRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetCompanyRequest.
                     * @implements IGetCompanyRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetCompanyRequest=} [properties] Properties to set
                     */
                    function GetCompanyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @instance
                     */
                    GetCompanyRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCompanyRequest fetchOwnerAccount.
                     * @member {boolean} fetchOwnerAccount
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @instance
                     */
                    GetCompanyRequest.prototype.fetchOwnerAccount = false;
    
                    /**
                     * GetCompanyRequest fetchStoreTimezone.
                     * @member {boolean} fetchStoreTimezone
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @instance
                     */
                    GetCompanyRequest.prototype.fetchStoreTimezone = false;
    
                    /**
                     * Creates a new GetCompanyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetCompanyRequest} GetCompanyRequest instance
                     */
                    GetCompanyRequest.create = function create(properties) {
                        return new GetCompanyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyRequest message. Does not implicitly {@link palexy.streaming.v1.GetCompanyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyRequest} message GetCompanyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.fetchOwnerAccount != null && Object.hasOwnProperty.call(message, "fetchOwnerAccount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.fetchOwnerAccount);
                        if (message.fetchStoreTimezone != null && Object.hasOwnProperty.call(message, "fetchStoreTimezone"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.fetchStoreTimezone);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetCompanyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetCompanyRequest} message GetCompanyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetCompanyRequest} GetCompanyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetCompanyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.fetchOwnerAccount = reader.bool();
                                break;
                            case 3:
                                message.fetchStoreTimezone = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetCompanyRequest} GetCompanyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.fetchOwnerAccount != null && message.hasOwnProperty("fetchOwnerAccount"))
                            if (typeof message.fetchOwnerAccount !== "boolean")
                                return "fetchOwnerAccount: boolean expected";
                        if (message.fetchStoreTimezone != null && message.hasOwnProperty("fetchStoreTimezone"))
                            if (typeof message.fetchStoreTimezone !== "boolean")
                                return "fetchStoreTimezone: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetCompanyRequest} GetCompanyRequest
                     */
                    GetCompanyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetCompanyRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetCompanyRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.fetchOwnerAccount != null)
                            message.fetchOwnerAccount = Boolean(object.fetchOwnerAccount);
                        if (object.fetchStoreTimezone != null)
                            message.fetchStoreTimezone = Boolean(object.fetchStoreTimezone);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @static
                     * @param {palexy.streaming.v1.GetCompanyRequest} message GetCompanyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.fetchOwnerAccount = false;
                            object.fetchStoreTimezone = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.fetchOwnerAccount != null && message.hasOwnProperty("fetchOwnerAccount"))
                            object.fetchOwnerAccount = message.fetchOwnerAccount;
                        if (message.fetchStoreTimezone != null && message.hasOwnProperty("fetchStoreTimezone"))
                            object.fetchStoreTimezone = message.fetchStoreTimezone;
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetCompanyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyRequest;
                })();
    
                v1.FindCompaniesReadyForTaskSchedulingRequest = (function() {
    
                    /**
                     * Properties of a FindCompaniesReadyForTaskSchedulingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFindCompaniesReadyForTaskSchedulingRequest
                     * @property {string|null} [dueLocalDateTime] FindCompaniesReadyForTaskSchedulingRequest dueLocalDateTime
                     * @property {string|null} [eventDateId] FindCompaniesReadyForTaskSchedulingRequest eventDateId
                     * @property {palexy.streaming.v1.ScheduledTaskType|null} [scheduleTaskType] FindCompaniesReadyForTaskSchedulingRequest scheduleTaskType
                     * @property {number|null} [maxResults] FindCompaniesReadyForTaskSchedulingRequest maxResults
                     * @property {google.protobuf.IInt32Value|null} [startOfWeek] FindCompaniesReadyForTaskSchedulingRequest startOfWeek
                     */
    
                    /**
                     * Constructs a new FindCompaniesReadyForTaskSchedulingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindCompaniesReadyForTaskSchedulingRequest.
                     * @implements IFindCompaniesReadyForTaskSchedulingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest=} [properties] Properties to set
                     */
                    function FindCompaniesReadyForTaskSchedulingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingRequest dueLocalDateTime.
                     * @member {string} dueLocalDateTime
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.dueLocalDateTime = "";
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingRequest eventDateId.
                     * @member {string} eventDateId
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.eventDateId = "";
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingRequest scheduleTaskType.
                     * @member {palexy.streaming.v1.ScheduledTaskType} scheduleTaskType
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.scheduleTaskType = 0;
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingRequest maxResults.
                     * @member {number} maxResults
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.maxResults = 0;
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingRequest startOfWeek.
                     * @member {google.protobuf.IInt32Value|null|undefined} startOfWeek
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.startOfWeek = null;
    
                    /**
                     * Creates a new FindCompaniesReadyForTaskSchedulingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest} FindCompaniesReadyForTaskSchedulingRequest instance
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.create = function create(properties) {
                        return new FindCompaniesReadyForTaskSchedulingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindCompaniesReadyForTaskSchedulingRequest message. Does not implicitly {@link palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest} message FindCompaniesReadyForTaskSchedulingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dueLocalDateTime != null && Object.hasOwnProperty.call(message, "dueLocalDateTime"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.dueLocalDateTime);
                        if (message.eventDateId != null && Object.hasOwnProperty.call(message, "eventDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventDateId);
                        if (message.scheduleTaskType != null && Object.hasOwnProperty.call(message, "scheduleTaskType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.scheduleTaskType);
                        if (message.maxResults != null && Object.hasOwnProperty.call(message, "maxResults"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxResults);
                        if (message.startOfWeek != null && Object.hasOwnProperty.call(message, "startOfWeek"))
                            $root.google.protobuf.Int32Value.encode(message.startOfWeek, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCompaniesReadyForTaskSchedulingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingRequest} message FindCompaniesReadyForTaskSchedulingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCompaniesReadyForTaskSchedulingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest} FindCompaniesReadyForTaskSchedulingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dueLocalDateTime = reader.string();
                                break;
                            case 2:
                                message.eventDateId = reader.string();
                                break;
                            case 3:
                                message.scheduleTaskType = reader.int32();
                                break;
                            case 4:
                                message.maxResults = reader.int32();
                                break;
                            case 5:
                                message.startOfWeek = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCompaniesReadyForTaskSchedulingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest} FindCompaniesReadyForTaskSchedulingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCompaniesReadyForTaskSchedulingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dueLocalDateTime != null && message.hasOwnProperty("dueLocalDateTime"))
                            if (!$util.isString(message.dueLocalDateTime))
                                return "dueLocalDateTime: string expected";
                        if (message.eventDateId != null && message.hasOwnProperty("eventDateId"))
                            if (!$util.isString(message.eventDateId))
                                return "eventDateId: string expected";
                        if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                            switch (message.scheduleTaskType) {
                            default:
                                return "scheduleTaskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                                break;
                            }
                        if (message.maxResults != null && message.hasOwnProperty("maxResults"))
                            if (!$util.isInteger(message.maxResults))
                                return "maxResults: integer expected";
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek")) {
                            var error = $root.google.protobuf.Int32Value.verify(message.startOfWeek);
                            if (error)
                                return "startOfWeek." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FindCompaniesReadyForTaskSchedulingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest} FindCompaniesReadyForTaskSchedulingRequest
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest();
                        if (object.dueLocalDateTime != null)
                            message.dueLocalDateTime = String(object.dueLocalDateTime);
                        if (object.eventDateId != null)
                            message.eventDateId = String(object.eventDateId);
                        switch (object.scheduleTaskType) {
                        case "SCHEDULED_TASK_TYPE_UNKNOWN":
                        case 0:
                            message.scheduleTaskType = 0;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS":
                        case 1:
                            message.scheduleTaskType = 1;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS":
                        case 2:
                            message.scheduleTaskType = 2;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS":
                        case 3:
                            message.scheduleTaskType = 3;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS":
                        case 4:
                            message.scheduleTaskType = 4;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS":
                        case 5:
                            message.scheduleTaskType = 5;
                            break;
                        case "SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS":
                        case 6:
                            message.scheduleTaskType = 6;
                            break;
                        case "SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS":
                        case 7:
                            message.scheduleTaskType = 7;
                            break;
                        case "SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER":
                        case 8:
                            message.scheduleTaskType = 8;
                            break;
                        case "SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY":
                        case 9:
                            message.scheduleTaskType = 9;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS":
                        case 10:
                            message.scheduleTaskType = 10;
                            break;
                        case "SCHEDULED_AVAILABILITY_AUTO_LOCK":
                        case 11:
                            message.scheduleTaskType = 11;
                            break;
                        case "SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS":
                        case 12:
                            message.scheduleTaskType = 12;
                            break;
                        case "SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS":
                        case 13:
                            message.scheduleTaskType = 13;
                            break;
                        case "SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER":
                        case 14:
                            message.scheduleTaskType = 14;
                            break;
                        case "SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER":
                        case 15:
                            message.scheduleTaskType = 15;
                            break;
                        }
                        if (object.maxResults != null)
                            message.maxResults = object.maxResults | 0;
                        if (object.startOfWeek != null) {
                            if (typeof object.startOfWeek !== "object")
                                throw TypeError(".palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest.startOfWeek: object expected");
                            message.startOfWeek = $root.google.protobuf.Int32Value.fromObject(object.startOfWeek);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCompaniesReadyForTaskSchedulingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @static
                     * @param {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest} message FindCompaniesReadyForTaskSchedulingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dueLocalDateTime = "";
                            object.eventDateId = "";
                            object.scheduleTaskType = options.enums === String ? "SCHEDULED_TASK_TYPE_UNKNOWN" : 0;
                            object.maxResults = 0;
                            object.startOfWeek = null;
                        }
                        if (message.dueLocalDateTime != null && message.hasOwnProperty("dueLocalDateTime"))
                            object.dueLocalDateTime = message.dueLocalDateTime;
                        if (message.eventDateId != null && message.hasOwnProperty("eventDateId"))
                            object.eventDateId = message.eventDateId;
                        if (message.scheduleTaskType != null && message.hasOwnProperty("scheduleTaskType"))
                            object.scheduleTaskType = options.enums === String ? $root.palexy.streaming.v1.ScheduledTaskType[message.scheduleTaskType] : message.scheduleTaskType;
                        if (message.maxResults != null && message.hasOwnProperty("maxResults"))
                            object.maxResults = message.maxResults;
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            object.startOfWeek = $root.google.protobuf.Int32Value.toObject(message.startOfWeek, options);
                        return object;
                    };
    
                    /**
                     * Converts this FindCompaniesReadyForTaskSchedulingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCompaniesReadyForTaskSchedulingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindCompaniesReadyForTaskSchedulingRequest;
                })();
    
                v1.FindCompaniesReadyForTaskSchedulingResponse = (function() {
    
                    /**
                     * Properties of a FindCompaniesReadyForTaskSchedulingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFindCompaniesReadyForTaskSchedulingResponse
                     * @property {Array.<palexy.streaming.v1.ICompany>|null} [companies] FindCompaniesReadyForTaskSchedulingResponse companies
                     */
    
                    /**
                     * Constructs a new FindCompaniesReadyForTaskSchedulingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FindCompaniesReadyForTaskSchedulingResponse.
                     * @implements IFindCompaniesReadyForTaskSchedulingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingResponse=} [properties] Properties to set
                     */
                    function FindCompaniesReadyForTaskSchedulingResponse(properties) {
                        this.companies = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindCompaniesReadyForTaskSchedulingResponse companies.
                     * @member {Array.<palexy.streaming.v1.ICompany>} companies
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @instance
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.prototype.companies = $util.emptyArray;
    
                    /**
                     * Creates a new FindCompaniesReadyForTaskSchedulingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} FindCompaniesReadyForTaskSchedulingResponse instance
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.create = function create(properties) {
                        return new FindCompaniesReadyForTaskSchedulingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FindCompaniesReadyForTaskSchedulingResponse message. Does not implicitly {@link palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingResponse} message FindCompaniesReadyForTaskSchedulingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companies != null && message.companies.length)
                            for (var i = 0; i < message.companies.length; ++i)
                                $root.palexy.streaming.v1.Company.encode(message.companies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindCompaniesReadyForTaskSchedulingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {palexy.streaming.v1.IFindCompaniesReadyForTaskSchedulingResponse} message FindCompaniesReadyForTaskSchedulingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindCompaniesReadyForTaskSchedulingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} FindCompaniesReadyForTaskSchedulingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companies && message.companies.length))
                                    message.companies = [];
                                message.companies.push($root.palexy.streaming.v1.Company.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindCompaniesReadyForTaskSchedulingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} FindCompaniesReadyForTaskSchedulingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindCompaniesReadyForTaskSchedulingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companies != null && message.hasOwnProperty("companies")) {
                            if (!Array.isArray(message.companies))
                                return "companies: array expected";
                            for (var i = 0; i < message.companies.length; ++i) {
                                var error = $root.palexy.streaming.v1.Company.verify(message.companies[i]);
                                if (error)
                                    return "companies." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FindCompaniesReadyForTaskSchedulingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} FindCompaniesReadyForTaskSchedulingResponse
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse();
                        if (object.companies) {
                            if (!Array.isArray(object.companies))
                                throw TypeError(".palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse.companies: array expected");
                            message.companies = [];
                            for (var i = 0; i < object.companies.length; ++i) {
                                if (typeof object.companies[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse.companies: object expected");
                                message.companies[i] = $root.palexy.streaming.v1.Company.fromObject(object.companies[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindCompaniesReadyForTaskSchedulingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @static
                     * @param {palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse} message FindCompaniesReadyForTaskSchedulingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companies = [];
                        if (message.companies && message.companies.length) {
                            object.companies = [];
                            for (var j = 0; j < message.companies.length; ++j)
                                object.companies[j] = $root.palexy.streaming.v1.Company.toObject(message.companies[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FindCompaniesReadyForTaskSchedulingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FindCompaniesReadyForTaskSchedulingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindCompaniesReadyForTaskSchedulingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindCompaniesReadyForTaskSchedulingResponse;
                })();
    
                v1.PosService = (function() {
    
                    /**
                     * Constructs a new PosService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function PosService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (PosService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = PosService;
    
                    /**
                     * Creates new PosService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.PosService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {PosService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    PosService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getPosProduct}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetPosProductCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosProduct} [response] PosProduct
                     */
    
                    /**
                     * Calls GetPosProduct.
                     * @function getPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosProductRequest} request GetPosProductRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetPosProductCallback} callback Node-style callback called with the error, if any, and PosProduct
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getPosProduct = function getPosProduct(request, callback) {
                        return this.rpcCall(getPosProduct, $root.palexy.streaming.v1.GetPosProductRequest, $root.palexy.streaming.v1.PosProduct, request, callback);
                    }, "name", { value: "GetPosProduct" });
    
                    /**
                     * Calls GetPosProduct.
                     * @function getPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosProductRequest} request GetPosProductRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosProduct>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosProduct}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosProductCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosProductResponse} [response] ListPosProductResponse
                     */
    
                    /**
                     * Calls ListPosProduct.
                     * @function listPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosProductRequest} request ListPosProductRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosProductCallback} callback Node-style callback called with the error, if any, and ListPosProductResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosProduct = function listPosProduct(request, callback) {
                        return this.rpcCall(listPosProduct, $root.palexy.streaming.v1.ListPosProductRequest, $root.palexy.streaming.v1.ListPosProductResponse, request, callback);
                    }, "name", { value: "ListPosProduct" });
    
                    /**
                     * Calls ListPosProduct.
                     * @function listPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosProductRequest} request ListPosProductRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosProductResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosTransaction}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosTransactionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosTransactionResponse} [response] ListPosTransactionResponse
                     */
    
                    /**
                     * Calls ListPosTransaction.
                     * @function listPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionRequest} request ListPosTransactionRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosTransactionCallback} callback Node-style callback called with the error, if any, and ListPosTransactionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosTransaction = function listPosTransaction(request, callback) {
                        return this.rpcCall(listPosTransaction, $root.palexy.streaming.v1.ListPosTransactionRequest, $root.palexy.streaming.v1.ListPosTransactionResponse, request, callback);
                    }, "name", { value: "ListPosTransaction" });
    
                    /**
                     * Calls ListPosTransaction.
                     * @function listPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionRequest} request ListPosTransactionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosTransactionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#importPosProduct}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ImportPosProductCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ImportPosProductResponse} [response] ImportPosProductResponse
                     */
    
                    /**
                     * Calls ImportPosProduct.
                     * @function importPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportPosProductRequest} request ImportPosProductRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ImportPosProductCallback} callback Node-style callback called with the error, if any, and ImportPosProductResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.importPosProduct = function importPosProduct(request, callback) {
                        return this.rpcCall(importPosProduct, $root.palexy.streaming.v1.ImportPosProductRequest, $root.palexy.streaming.v1.ImportPosProductResponse, request, callback);
                    }, "name", { value: "ImportPosProduct" });
    
                    /**
                     * Calls ImportPosProduct.
                     * @function importPosProduct
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportPosProductRequest} request ImportPosProductRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ImportPosProductResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#importPosTransaction}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ImportPosTransactionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ImportPosTransactionResponse} [response] ImportPosTransactionResponse
                     */
    
                    /**
                     * Calls ImportPosTransaction.
                     * @function importPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest} request ImportPosTransactionRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ImportPosTransactionCallback} callback Node-style callback called with the error, if any, and ImportPosTransactionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.importPosTransaction = function importPosTransaction(request, callback) {
                        return this.rpcCall(importPosTransaction, $root.palexy.streaming.v1.ImportPosTransactionRequest, $root.palexy.streaming.v1.ImportPosTransactionResponse, request, callback);
                    }, "name", { value: "ImportPosTransaction" });
    
                    /**
                     * Calls ImportPosTransaction.
                     * @function importPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest} request ImportPosTransactionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ImportPosTransactionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#createPosMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CreatePosMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosMetadata} [response] PosMetadata
                     */
    
                    /**
                     * Calls CreatePosMetadata.
                     * @function createPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosMetadata} request PosMetadata message or plain object
                     * @param {palexy.streaming.v1.PosService.CreatePosMetadataCallback} callback Node-style callback called with the error, if any, and PosMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.createPosMetadata = function createPosMetadata(request, callback) {
                        return this.rpcCall(createPosMetadata, $root.palexy.streaming.v1.PosMetadata, $root.palexy.streaming.v1.PosMetadata, request, callback);
                    }, "name", { value: "CreatePosMetadata" });
    
                    /**
                     * Calls CreatePosMetadata.
                     * @function createPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosMetadata} request PosMetadata message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#updatePosMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef UpdatePosMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosMetadata} [response] PosMetadata
                     */
    
                    /**
                     * Calls UpdatePosMetadata.
                     * @function updatePosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosMetadata} request PosMetadata message or plain object
                     * @param {palexy.streaming.v1.PosService.UpdatePosMetadataCallback} callback Node-style callback called with the error, if any, and PosMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.updatePosMetadata = function updatePosMetadata(request, callback) {
                        return this.rpcCall(updatePosMetadata, $root.palexy.streaming.v1.PosMetadata, $root.palexy.streaming.v1.PosMetadata, request, callback);
                    }, "name", { value: "UpdatePosMetadata" });
    
                    /**
                     * Calls UpdatePosMetadata.
                     * @function updatePosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosMetadata} request PosMetadata message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#deletePosMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef DeletePosMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeletePosMetadata.
                     * @function deletePosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest} request DeletePosMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.DeletePosMetadataCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.deletePosMetadata = function deletePosMetadata(request, callback) {
                        return this.rpcCall(deletePosMetadata, $root.palexy.streaming.v1.DeletePosMetadataRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeletePosMetadata" });
    
                    /**
                     * Calls DeletePosMetadata.
                     * @function deletePosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest} request DeletePosMetadataRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getPosMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetPosMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosMetadata} [response] PosMetadata
                     */
    
                    /**
                     * Calls GetPosMetadata.
                     * @function getPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest} request GetPosMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetPosMetadataCallback} callback Node-style callback called with the error, if any, and PosMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getPosMetadata = function getPosMetadata(request, callback) {
                        return this.rpcCall(getPosMetadata, $root.palexy.streaming.v1.GetPosMetadataRequest, $root.palexy.streaming.v1.PosMetadata, request, callback);
                    }, "name", { value: "GetPosMetadata" });
    
                    /**
                     * Calls GetPosMetadata.
                     * @function getPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest} request GetPosMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosMetadataResponse} [response] ListPosMetadataResponse
                     */
    
                    /**
                     * Calls ListPosMetadata.
                     * @function listPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosMetadataRequest} request ListPosMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosMetadataCallback} callback Node-style callback called with the error, if any, and ListPosMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosMetadata = function listPosMetadata(request, callback) {
                        return this.rpcCall(listPosMetadata, $root.palexy.streaming.v1.ListPosMetadataRequest, $root.palexy.streaming.v1.ListPosMetadataResponse, request, callback);
                    }, "name", { value: "ListPosMetadata" });
    
                    /**
                     * Calls ListPosMetadata.
                     * @function listPosMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosMetadataRequest} request ListPosMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosMetadataValue}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosMetadataValueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosMetadataValueResponse} [response] ListPosMetadataValueResponse
                     */
    
                    /**
                     * Calls ListPosMetadataValue.
                     * @function listPosMetadataValue
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest} request ListPosMetadataValueRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosMetadataValueCallback} callback Node-style callback called with the error, if any, and ListPosMetadataValueResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosMetadataValue = function listPosMetadataValue(request, callback) {
                        return this.rpcCall(listPosMetadataValue, $root.palexy.streaming.v1.ListPosMetadataValueRequest, $root.palexy.streaming.v1.ListPosMetadataValueResponse, request, callback);
                    }, "name", { value: "ListPosMetadataValue" });
    
                    /**
                     * Calls ListPosMetadataValue.
                     * @function listPosMetadataValue
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest} request ListPosMetadataValueRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosMetadataValueResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#createPosImportConfig}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CreatePosImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosImportConfig} [response] PosImportConfig
                     */
    
                    /**
                     * Calls CreatePosImportConfig.
                     * @function createPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosImportConfig} request PosImportConfig message or plain object
                     * @param {palexy.streaming.v1.PosService.CreatePosImportConfigCallback} callback Node-style callback called with the error, if any, and PosImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.createPosImportConfig = function createPosImportConfig(request, callback) {
                        return this.rpcCall(createPosImportConfig, $root.palexy.streaming.v1.PosImportConfig, $root.palexy.streaming.v1.PosImportConfig, request, callback);
                    }, "name", { value: "CreatePosImportConfig" });
    
                    /**
                     * Calls CreatePosImportConfig.
                     * @function createPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosImportConfig} request PosImportConfig message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#updatePosImportConfig}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef UpdatePosImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosImportConfig} [response] PosImportConfig
                     */
    
                    /**
                     * Calls UpdatePosImportConfig.
                     * @function updatePosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosImportConfig} request PosImportConfig message or plain object
                     * @param {palexy.streaming.v1.PosService.UpdatePosImportConfigCallback} callback Node-style callback called with the error, if any, and PosImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.updatePosImportConfig = function updatePosImportConfig(request, callback) {
                        return this.rpcCall(updatePosImportConfig, $root.palexy.streaming.v1.PosImportConfig, $root.palexy.streaming.v1.PosImportConfig, request, callback);
                    }, "name", { value: "UpdatePosImportConfig" });
    
                    /**
                     * Calls UpdatePosImportConfig.
                     * @function updatePosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosImportConfig} request PosImportConfig message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getPosImportConfig}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetPosImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosImportConfig} [response] PosImportConfig
                     */
    
                    /**
                     * Calls GetPosImportConfig.
                     * @function getPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest} request GetPosImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetPosImportConfigCallback} callback Node-style callback called with the error, if any, and PosImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getPosImportConfig = function getPosImportConfig(request, callback) {
                        return this.rpcCall(getPosImportConfig, $root.palexy.streaming.v1.GetPosImportConfigRequest, $root.palexy.streaming.v1.PosImportConfig, request, callback);
                    }, "name", { value: "GetPosImportConfig" });
    
                    /**
                     * Calls GetPosImportConfig.
                     * @function getPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest} request GetPosImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosImportConfig}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosImportConfigResponse} [response] ListPosImportConfigResponse
                     */
    
                    /**
                     * Calls ListPosImportConfig.
                     * @function listPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest} request ListPosImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosImportConfigCallback} callback Node-style callback called with the error, if any, and ListPosImportConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosImportConfig = function listPosImportConfig(request, callback) {
                        return this.rpcCall(listPosImportConfig, $root.palexy.streaming.v1.ListPosImportConfigRequest, $root.palexy.streaming.v1.ListPosImportConfigResponse, request, callback);
                    }, "name", { value: "ListPosImportConfig" });
    
                    /**
                     * Calls ListPosImportConfig.
                     * @function listPosImportConfig
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest} request ListPosImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosImportConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#matchPosTransaction}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef MatchPosTransactionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MatchPosTransactionResponse} [response] MatchPosTransactionResponse
                     */
    
                    /**
                     * Calls MatchPosTransaction.
                     * @function matchPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest} request MatchPosTransactionRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.MatchPosTransactionCallback} callback Node-style callback called with the error, if any, and MatchPosTransactionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.matchPosTransaction = function matchPosTransaction(request, callback) {
                        return this.rpcCall(matchPosTransaction, $root.palexy.streaming.v1.MatchPosTransactionRequest, $root.palexy.streaming.v1.MatchPosTransactionResponse, request, callback);
                    }, "name", { value: "MatchPosTransaction" });
    
                    /**
                     * Calls MatchPosTransaction.
                     * @function matchPosTransaction
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest} request MatchPosTransactionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MatchPosTransactionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListSectionMappingResponse} [response] ListSectionMappingResponse
                     */
    
                    /**
                     * Calls ListSectionMapping.
                     * @function listSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListSectionMappingRequest} request ListSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListSectionMappingCallback} callback Node-style callback called with the error, if any, and ListSectionMappingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listSectionMapping = function listSectionMapping(request, callback) {
                        return this.rpcCall(listSectionMapping, $root.palexy.streaming.v1.ListSectionMappingRequest, $root.palexy.streaming.v1.ListSectionMappingResponse, request, callback);
                    }, "name", { value: "ListSectionMapping" });
    
                    /**
                     * Calls ListSectionMapping.
                     * @function listSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListSectionMappingRequest} request ListSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListSectionMappingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#createSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CreateSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMapping} [response] PosSectionMapping
                     */
    
                    /**
                     * Calls CreateSectionMapping.
                     * @function createSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest} request CreateSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.CreateSectionMappingCallback} callback Node-style callback called with the error, if any, and PosSectionMapping
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.createSectionMapping = function createSectionMapping(request, callback) {
                        return this.rpcCall(createSectionMapping, $root.palexy.streaming.v1.CreateSectionMappingRequest, $root.palexy.streaming.v1.PosSectionMapping, request, callback);
                    }, "name", { value: "CreateSectionMapping" });
    
                    /**
                     * Calls CreateSectionMapping.
                     * @function createSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest} request CreateSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMapping>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#updateSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef UpdateSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMapping} [response] PosSectionMapping
                     */
    
                    /**
                     * Calls UpdateSectionMapping.
                     * @function updateSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest} request UpdateSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.UpdateSectionMappingCallback} callback Node-style callback called with the error, if any, and PosSectionMapping
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.updateSectionMapping = function updateSectionMapping(request, callback) {
                        return this.rpcCall(updateSectionMapping, $root.palexy.streaming.v1.UpdateSectionMappingRequest, $root.palexy.streaming.v1.PosSectionMapping, request, callback);
                    }, "name", { value: "UpdateSectionMapping" });
    
                    /**
                     * Calls UpdateSectionMapping.
                     * @function updateSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest} request UpdateSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMapping>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#deleteSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef DeleteSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteSectionMapping.
                     * @function deleteSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest} request DeleteSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.DeleteSectionMappingCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.deleteSectionMapping = function deleteSectionMapping(request, callback) {
                        return this.rpcCall(deleteSectionMapping, $root.palexy.streaming.v1.DeleteSectionMappingRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteSectionMapping" });
    
                    /**
                     * Calls DeleteSectionMapping.
                     * @function deleteSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest} request DeleteSectionMappingRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMapping} [response] PosSectionMapping
                     */
    
                    /**
                     * Calls GetSectionMapping.
                     * @function getSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest} request GetSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetSectionMappingCallback} callback Node-style callback called with the error, if any, and PosSectionMapping
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getSectionMapping = function getSectionMapping(request, callback) {
                        return this.rpcCall(getSectionMapping, $root.palexy.streaming.v1.GetSectionMappingRequest, $root.palexy.streaming.v1.PosSectionMapping, request, callback);
                    }, "name", { value: "GetSectionMapping" });
    
                    /**
                     * Calls GetSectionMapping.
                     * @function getSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest} request GetSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMapping>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#cloneSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CloneSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMapping} [response] PosSectionMapping
                     */
    
                    /**
                     * Calls CloneSectionMapping.
                     * @function cloneSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest} request CloneSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.CloneSectionMappingCallback} callback Node-style callback called with the error, if any, and PosSectionMapping
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.cloneSectionMapping = function cloneSectionMapping(request, callback) {
                        return this.rpcCall(cloneSectionMapping, $root.palexy.streaming.v1.CloneSectionMappingRequest, $root.palexy.streaming.v1.PosSectionMapping, request, callback);
                    }, "name", { value: "CloneSectionMapping" });
    
                    /**
                     * Calls CloneSectionMapping.
                     * @function cloneSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest} request CloneSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMapping>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListSectionMappingItemResponse} [response] ListSectionMappingItemResponse
                     */
    
                    /**
                     * Calls ListSectionMappingItem.
                     * @function listSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest} request ListSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListSectionMappingItemCallback} callback Node-style callback called with the error, if any, and ListSectionMappingItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listSectionMappingItem = function listSectionMappingItem(request, callback) {
                        return this.rpcCall(listSectionMappingItem, $root.palexy.streaming.v1.ListSectionMappingItemRequest, $root.palexy.streaming.v1.ListSectionMappingItemResponse, request, callback);
                    }, "name", { value: "ListSectionMappingItem" });
    
                    /**
                     * Calls ListSectionMappingItem.
                     * @function listSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest} request ListSectionMappingItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListSectionMappingItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#createSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CreateSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMappingItem} [response] PosSectionMappingItem
                     */
    
                    /**
                     * Calls CreateSectionMappingItem.
                     * @function createSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest} request CreateSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.CreateSectionMappingItemCallback} callback Node-style callback called with the error, if any, and PosSectionMappingItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.createSectionMappingItem = function createSectionMappingItem(request, callback) {
                        return this.rpcCall(createSectionMappingItem, $root.palexy.streaming.v1.CreateSectionMappingItemRequest, $root.palexy.streaming.v1.PosSectionMappingItem, request, callback);
                    }, "name", { value: "CreateSectionMappingItem" });
    
                    /**
                     * Calls CreateSectionMappingItem.
                     * @function createSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest} request CreateSectionMappingItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMappingItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#updateSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef UpdateSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMappingItem} [response] PosSectionMappingItem
                     */
    
                    /**
                     * Calls UpdateSectionMappingItem.
                     * @function updateSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest} request UpdateSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.UpdateSectionMappingItemCallback} callback Node-style callback called with the error, if any, and PosSectionMappingItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.updateSectionMappingItem = function updateSectionMappingItem(request, callback) {
                        return this.rpcCall(updateSectionMappingItem, $root.palexy.streaming.v1.UpdateSectionMappingItemRequest, $root.palexy.streaming.v1.PosSectionMappingItem, request, callback);
                    }, "name", { value: "UpdateSectionMappingItem" });
    
                    /**
                     * Calls UpdateSectionMappingItem.
                     * @function updateSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest} request UpdateSectionMappingItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMappingItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosSectionMappingItem} [response] PosSectionMappingItem
                     */
    
                    /**
                     * Calls GetSectionMappingItem.
                     * @function getSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest} request GetSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetSectionMappingItemCallback} callback Node-style callback called with the error, if any, and PosSectionMappingItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getSectionMappingItem = function getSectionMappingItem(request, callback) {
                        return this.rpcCall(getSectionMappingItem, $root.palexy.streaming.v1.GetSectionMappingItemRequest, $root.palexy.streaming.v1.PosSectionMappingItem, request, callback);
                    }, "name", { value: "GetSectionMappingItem" });
    
                    /**
                     * Calls GetSectionMappingItem.
                     * @function getSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest} request GetSectionMappingItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosSectionMappingItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#deleteSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef DeleteSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteSectionMappingItem.
                     * @function deleteSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest} request DeleteSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.DeleteSectionMappingItemCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.deleteSectionMappingItem = function deleteSectionMappingItem(request, callback) {
                        return this.rpcCall(deleteSectionMappingItem, $root.palexy.streaming.v1.DeleteSectionMappingItemRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteSectionMappingItem" });
    
                    /**
                     * Calls DeleteSectionMappingItem.
                     * @function deleteSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest} request DeleteSectionMappingItemRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#importSectionMappingItem}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ImportSectionMappingItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ImportSectionMappingItemResponse} [response] ImportSectionMappingItemResponse
                     */
    
                    /**
                     * Calls ImportSectionMappingItem.
                     * @function importSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest} request ImportSectionMappingItemRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ImportSectionMappingItemCallback} callback Node-style callback called with the error, if any, and ImportSectionMappingItemResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.importSectionMappingItem = function importSectionMappingItem(request, callback) {
                        return this.rpcCall(importSectionMappingItem, $root.palexy.streaming.v1.ImportSectionMappingItemRequest, $root.palexy.streaming.v1.ImportSectionMappingItemResponse, request, callback);
                    }, "name", { value: "ImportSectionMappingItem" });
    
                    /**
                     * Calls ImportSectionMappingItem.
                     * @function importSectionMappingItem
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest} request ImportSectionMappingItemRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ImportSectionMappingItemResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listProductSectionMapping}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListProductSectionMappingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListProductSectionMappingResponse} [response] ListProductSectionMappingResponse
                     */
    
                    /**
                     * Calls ListProductSectionMapping.
                     * @function listProductSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest} request ListProductSectionMappingRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListProductSectionMappingCallback} callback Node-style callback called with the error, if any, and ListProductSectionMappingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listProductSectionMapping = function listProductSectionMapping(request, callback) {
                        return this.rpcCall(listProductSectionMapping, $root.palexy.streaming.v1.ListProductSectionMappingRequest, $root.palexy.streaming.v1.ListProductSectionMappingResponse, request, callback);
                    }, "name", { value: "ListProductSectionMapping" });
    
                    /**
                     * Calls ListProductSectionMapping.
                     * @function listProductSectionMapping
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest} request ListProductSectionMappingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListProductSectionMappingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listStoreActionMoment}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListStoreActionMomentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreActionMomentResponse} [response] ListStoreActionMomentResponse
                     */
    
                    /**
                     * Calls ListStoreActionMoment.
                     * @function listStoreActionMoment
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest} request ListStoreActionMomentRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListStoreActionMomentCallback} callback Node-style callback called with the error, if any, and ListStoreActionMomentResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listStoreActionMoment = function listStoreActionMoment(request, callback) {
                        return this.rpcCall(listStoreActionMoment, $root.palexy.streaming.v1.ListStoreActionMomentRequest, $root.palexy.streaming.v1.ListStoreActionMomentResponse, request, callback);
                    }, "name", { value: "ListStoreActionMoment" });
    
                    /**
                     * Calls ListStoreActionMoment.
                     * @function listStoreActionMoment
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest} request ListStoreActionMomentRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreActionMomentResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#importStoreActionMoments}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ImportStoreActionMomentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ImportStoreActionMomentsResponse} [response] ImportStoreActionMomentsResponse
                     */
    
                    /**
                     * Calls ImportStoreActionMoments.
                     * @function importStoreActionMoments
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest} request ImportStoreActionMomentsRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ImportStoreActionMomentsCallback} callback Node-style callback called with the error, if any, and ImportStoreActionMomentsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.importStoreActionMoments = function importStoreActionMoments(request, callback) {
                        return this.rpcCall(importStoreActionMoments, $root.palexy.streaming.v1.ImportStoreActionMomentsRequest, $root.palexy.streaming.v1.ImportStoreActionMomentsResponse, request, callback);
                    }, "name", { value: "ImportStoreActionMoments" });
    
                    /**
                     * Calls ImportStoreActionMoments.
                     * @function importStoreActionMoments
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest} request ImportStoreActionMomentsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ImportStoreActionMomentsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#createPosTransactionMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef CreatePosTransactionMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosTransactionMetadata} [response] PosTransactionMetadata
                     */
    
                    /**
                     * Calls CreatePosTransactionMetadata.
                     * @function createPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} request PosTransactionMetadata message or plain object
                     * @param {palexy.streaming.v1.PosService.CreatePosTransactionMetadataCallback} callback Node-style callback called with the error, if any, and PosTransactionMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.createPosTransactionMetadata = function createPosTransactionMetadata(request, callback) {
                        return this.rpcCall(createPosTransactionMetadata, $root.palexy.streaming.v1.PosTransactionMetadata, $root.palexy.streaming.v1.PosTransactionMetadata, request, callback);
                    }, "name", { value: "CreatePosTransactionMetadata" });
    
                    /**
                     * Calls CreatePosTransactionMetadata.
                     * @function createPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} request PosTransactionMetadata message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosTransactionMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#updatePosTransactionMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef UpdatePosTransactionMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosTransactionMetadata} [response] PosTransactionMetadata
                     */
    
                    /**
                     * Calls UpdatePosTransactionMetadata.
                     * @function updatePosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} request PosTransactionMetadata message or plain object
                     * @param {palexy.streaming.v1.PosService.UpdatePosTransactionMetadataCallback} callback Node-style callback called with the error, if any, and PosTransactionMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.updatePosTransactionMetadata = function updatePosTransactionMetadata(request, callback) {
                        return this.rpcCall(updatePosTransactionMetadata, $root.palexy.streaming.v1.PosTransactionMetadata, $root.palexy.streaming.v1.PosTransactionMetadata, request, callback);
                    }, "name", { value: "UpdatePosTransactionMetadata" });
    
                    /**
                     * Calls UpdatePosTransactionMetadata.
                     * @function updatePosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} request PosTransactionMetadata message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosTransactionMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#deletePosTransactionMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef DeletePosTransactionMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeletePosTransactionMetadata.
                     * @function deletePosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest} request DeletePosTransactionMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.DeletePosTransactionMetadataCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.deletePosTransactionMetadata = function deletePosTransactionMetadata(request, callback) {
                        return this.rpcCall(deletePosTransactionMetadata, $root.palexy.streaming.v1.DeletePosTransactionMetadataRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeletePosTransactionMetadata" });
    
                    /**
                     * Calls DeletePosTransactionMetadata.
                     * @function deletePosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest} request DeletePosTransactionMetadataRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getPosTransactionMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetPosTransactionMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PosTransactionMetadata} [response] PosTransactionMetadata
                     */
    
                    /**
                     * Calls GetPosTransactionMetadata.
                     * @function getPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest} request GetPosTransactionMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetPosTransactionMetadataCallback} callback Node-style callback called with the error, if any, and PosTransactionMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getPosTransactionMetadata = function getPosTransactionMetadata(request, callback) {
                        return this.rpcCall(getPosTransactionMetadata, $root.palexy.streaming.v1.GetPosTransactionMetadataRequest, $root.palexy.streaming.v1.PosTransactionMetadata, request, callback);
                    }, "name", { value: "GetPosTransactionMetadata" });
    
                    /**
                     * Calls GetPosTransactionMetadata.
                     * @function getPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest} request GetPosTransactionMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PosTransactionMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosTransactionMetadata}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosTransactionMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataResponse} [response] ListPosTransactionMetadataResponse
                     */
    
                    /**
                     * Calls ListPosTransactionMetadata.
                     * @function listPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest} request ListPosTransactionMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosTransactionMetadataCallback} callback Node-style callback called with the error, if any, and ListPosTransactionMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosTransactionMetadata = function listPosTransactionMetadata(request, callback) {
                        return this.rpcCall(listPosTransactionMetadata, $root.palexy.streaming.v1.ListPosTransactionMetadataRequest, $root.palexy.streaming.v1.ListPosTransactionMetadataResponse, request, callback);
                    }, "name", { value: "ListPosTransactionMetadata" });
    
                    /**
                     * Calls ListPosTransactionMetadata.
                     * @function listPosTransactionMetadata
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest} request ListPosTransactionMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosTransactionMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#listPosTransactionMetadataValue}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ListPosTransactionMetadataValueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} [response] ListPosTransactionMetadataValueResponse
                     */
    
                    /**
                     * Calls ListPosTransactionMetadataValue.
                     * @function listPosTransactionMetadataValue
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest} request ListPosTransactionMetadataValueRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ListPosTransactionMetadataValueCallback} callback Node-style callback called with the error, if any, and ListPosTransactionMetadataValueResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.listPosTransactionMetadataValue = function listPosTransactionMetadataValue(request, callback) {
                        return this.rpcCall(listPosTransactionMetadataValue, $root.palexy.streaming.v1.ListPosTransactionMetadataValueRequest, $root.palexy.streaming.v1.ListPosTransactionMetadataValueResponse, request, callback);
                    }, "name", { value: "ListPosTransactionMetadataValue" });
    
                    /**
                     * Calls ListPosTransactionMetadataValue.
                     * @function listPosTransactionMetadataValue
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest} request ListPosTransactionMetadataValueRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListPosTransactionMetadataValueResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#getPosLakeExportRange}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef GetPosLakeExportRangeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetPosLakeExportRangeResponse} [response] GetPosLakeExportRangeResponse
                     */
    
                    /**
                     * Calls GetPosLakeExportRange.
                     * @function getPosLakeExportRange
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest} request GetPosLakeExportRangeRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.GetPosLakeExportRangeCallback} callback Node-style callback called with the error, if any, and GetPosLakeExportRangeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.getPosLakeExportRange = function getPosLakeExportRange(request, callback) {
                        return this.rpcCall(getPosLakeExportRange, $root.palexy.streaming.v1.GetPosLakeExportRangeRequest, $root.palexy.streaming.v1.GetPosLakeExportRangeResponse, request, callback);
                    }, "name", { value: "GetPosLakeExportRange" });
    
                    /**
                     * Calls GetPosLakeExportRange.
                     * @function getPosLakeExportRange
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest} request GetPosLakeExportRangeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetPosLakeExportRangeResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.PosService#exportPosDataToLake}.
                     * @memberof palexy.streaming.v1.PosService
                     * @typedef ExportPosDataToLakeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportPosDataToLakeResponse} [response] ExportPosDataToLakeResponse
                     */
    
                    /**
                     * Calls ExportPosDataToLake.
                     * @function exportPosDataToLake
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest} request ExportPosDataToLakeRequest message or plain object
                     * @param {palexy.streaming.v1.PosService.ExportPosDataToLakeCallback} callback Node-style callback called with the error, if any, and ExportPosDataToLakeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(PosService.prototype.exportPosDataToLake = function exportPosDataToLake(request, callback) {
                        return this.rpcCall(exportPosDataToLake, $root.palexy.streaming.v1.ExportPosDataToLakeRequest, $root.palexy.streaming.v1.ExportPosDataToLakeResponse, request, callback);
                    }, "name", { value: "ExportPosDataToLake" });
    
                    /**
                     * Calls ExportPosDataToLake.
                     * @function exportPosDataToLake
                     * @memberof palexy.streaming.v1.PosService
                     * @instance
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest} request ExportPosDataToLakeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportPosDataToLakeResponse>} Promise
                     * @variation 2
                     */
    
                    return PosService;
                })();
    
                v1.GetPosLakeExportRangeRequest = (function() {
    
                    /**
                     * Properties of a GetPosLakeExportRangeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosLakeExportRangeRequest
                     * @property {number|null} [companyId] GetPosLakeExportRangeRequest companyId
                     */
    
                    /**
                     * Constructs a new GetPosLakeExportRangeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosLakeExportRangeRequest.
                     * @implements IGetPosLakeExportRangeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest=} [properties] Properties to set
                     */
                    function GetPosLakeExportRangeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosLakeExportRangeRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @instance
                     */
                    GetPosLakeExportRangeRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetPosLakeExportRangeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeRequest} GetPosLakeExportRangeRequest instance
                     */
                    GetPosLakeExportRangeRequest.create = function create(properties) {
                        return new GetPosLakeExportRangeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosLakeExportRangeRequest message. Does not implicitly {@link palexy.streaming.v1.GetPosLakeExportRangeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest} message GetPosLakeExportRangeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosLakeExportRangeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosLakeExportRangeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosLakeExportRangeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeRequest} message GetPosLakeExportRangeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosLakeExportRangeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosLakeExportRangeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeRequest} GetPosLakeExportRangeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosLakeExportRangeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosLakeExportRangeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosLakeExportRangeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeRequest} GetPosLakeExportRangeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosLakeExportRangeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosLakeExportRangeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosLakeExportRangeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosLakeExportRangeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeRequest} GetPosLakeExportRangeRequest
                     */
                    GetPosLakeExportRangeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosLakeExportRangeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosLakeExportRangeRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosLakeExportRangeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @static
                     * @param {palexy.streaming.v1.GetPosLakeExportRangeRequest} message GetPosLakeExportRangeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosLakeExportRangeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosLakeExportRangeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosLakeExportRangeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosLakeExportRangeRequest;
                })();
    
                v1.GetPosLakeExportRangeResponse = (function() {
    
                    /**
                     * Properties of a GetPosLakeExportRangeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosLakeExportRangeResponse
                     * @property {number|null} [minDateId] GetPosLakeExportRangeResponse minDateId
                     * @property {number|null} [maxDateId] GetPosLakeExportRangeResponse maxDateId
                     * @property {number|null} [transactionCount] GetPosLakeExportRangeResponse transactionCount
                     */
    
                    /**
                     * Constructs a new GetPosLakeExportRangeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosLakeExportRangeResponse.
                     * @implements IGetPosLakeExportRangeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeResponse=} [properties] Properties to set
                     */
                    function GetPosLakeExportRangeResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosLakeExportRangeResponse minDateId.
                     * @member {number} minDateId
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @instance
                     */
                    GetPosLakeExportRangeResponse.prototype.minDateId = 0;
    
                    /**
                     * GetPosLakeExportRangeResponse maxDateId.
                     * @member {number} maxDateId
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @instance
                     */
                    GetPosLakeExportRangeResponse.prototype.maxDateId = 0;
    
                    /**
                     * GetPosLakeExportRangeResponse transactionCount.
                     * @member {number} transactionCount
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @instance
                     */
                    GetPosLakeExportRangeResponse.prototype.transactionCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetPosLakeExportRangeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeResponse} GetPosLakeExportRangeResponse instance
                     */
                    GetPosLakeExportRangeResponse.create = function create(properties) {
                        return new GetPosLakeExportRangeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosLakeExportRangeResponse message. Does not implicitly {@link palexy.streaming.v1.GetPosLakeExportRangeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeResponse} message GetPosLakeExportRangeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosLakeExportRangeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.minDateId != null && Object.hasOwnProperty.call(message, "minDateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.minDateId);
                        if (message.maxDateId != null && Object.hasOwnProperty.call(message, "maxDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxDateId);
                        if (message.transactionCount != null && Object.hasOwnProperty.call(message, "transactionCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.transactionCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosLakeExportRangeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosLakeExportRangeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetPosLakeExportRangeResponse} message GetPosLakeExportRangeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosLakeExportRangeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosLakeExportRangeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeResponse} GetPosLakeExportRangeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosLakeExportRangeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosLakeExportRangeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.minDateId = reader.int32();
                                break;
                            case 2:
                                message.maxDateId = reader.int32();
                                break;
                            case 3:
                                message.transactionCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosLakeExportRangeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeResponse} GetPosLakeExportRangeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosLakeExportRangeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosLakeExportRangeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosLakeExportRangeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            if (!$util.isInteger(message.minDateId))
                                return "minDateId: integer expected";
                        if (message.maxDateId != null && message.hasOwnProperty("maxDateId"))
                            if (!$util.isInteger(message.maxDateId))
                                return "maxDateId: integer expected";
                        if (message.transactionCount != null && message.hasOwnProperty("transactionCount"))
                            if (!$util.isInteger(message.transactionCount) && !(message.transactionCount && $util.isInteger(message.transactionCount.low) && $util.isInteger(message.transactionCount.high)))
                                return "transactionCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosLakeExportRangeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosLakeExportRangeResponse} GetPosLakeExportRangeResponse
                     */
                    GetPosLakeExportRangeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosLakeExportRangeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosLakeExportRangeResponse();
                        if (object.minDateId != null)
                            message.minDateId = object.minDateId | 0;
                        if (object.maxDateId != null)
                            message.maxDateId = object.maxDateId | 0;
                        if (object.transactionCount != null)
                            if ($util.Long)
                                (message.transactionCount = $util.Long.fromValue(object.transactionCount)).unsigned = false;
                            else if (typeof object.transactionCount === "string")
                                message.transactionCount = parseInt(object.transactionCount, 10);
                            else if (typeof object.transactionCount === "number")
                                message.transactionCount = object.transactionCount;
                            else if (typeof object.transactionCount === "object")
                                message.transactionCount = new $util.LongBits(object.transactionCount.low >>> 0, object.transactionCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosLakeExportRangeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @static
                     * @param {palexy.streaming.v1.GetPosLakeExportRangeResponse} message GetPosLakeExportRangeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosLakeExportRangeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.minDateId = 0;
                            object.maxDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.transactionCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.transactionCount = options.longs === String ? "0" : 0;
                        }
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            object.minDateId = message.minDateId;
                        if (message.maxDateId != null && message.hasOwnProperty("maxDateId"))
                            object.maxDateId = message.maxDateId;
                        if (message.transactionCount != null && message.hasOwnProperty("transactionCount"))
                            if (typeof message.transactionCount === "number")
                                object.transactionCount = options.longs === String ? String(message.transactionCount) : message.transactionCount;
                            else
                                object.transactionCount = options.longs === String ? $util.Long.prototype.toString.call(message.transactionCount) : options.longs === Number ? new $util.LongBits(message.transactionCount.low >>> 0, message.transactionCount.high >>> 0).toNumber() : message.transactionCount;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosLakeExportRangeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosLakeExportRangeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosLakeExportRangeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosLakeExportRangeResponse;
                })();
    
                v1.ExportPosDataToLakeRequest = (function() {
    
                    /**
                     * Properties of an ExportPosDataToLakeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExportPosDataToLakeRequest
                     * @property {number|null} [companyId] ExportPosDataToLakeRequest companyId
                     * @property {number|null} [startDateId] ExportPosDataToLakeRequest startDateId
                     * @property {number|null} [endDateId] ExportPosDataToLakeRequest endDateId
                     * @property {boolean|null} [exportProductMaster] ExportPosDataToLakeRequest exportProductMaster
                     */
    
                    /**
                     * Constructs a new ExportPosDataToLakeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportPosDataToLakeRequest.
                     * @implements IExportPosDataToLakeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest=} [properties] Properties to set
                     */
                    function ExportPosDataToLakeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportPosDataToLakeRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @instance
                     */
                    ExportPosDataToLakeRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportPosDataToLakeRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @instance
                     */
                    ExportPosDataToLakeRequest.prototype.startDateId = 0;
    
                    /**
                     * ExportPosDataToLakeRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @instance
                     */
                    ExportPosDataToLakeRequest.prototype.endDateId = 0;
    
                    /**
                     * ExportPosDataToLakeRequest exportProductMaster.
                     * @member {boolean} exportProductMaster
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @instance
                     */
                    ExportPosDataToLakeRequest.prototype.exportProductMaster = false;
    
                    /**
                     * Creates a new ExportPosDataToLakeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeRequest} ExportPosDataToLakeRequest instance
                     */
                    ExportPosDataToLakeRequest.create = function create(properties) {
                        return new ExportPosDataToLakeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExportPosDataToLakeRequest message. Does not implicitly {@link palexy.streaming.v1.ExportPosDataToLakeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest} message ExportPosDataToLakeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportPosDataToLakeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.exportProductMaster != null && Object.hasOwnProperty.call(message, "exportProductMaster"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.exportProductMaster);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportPosDataToLakeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportPosDataToLakeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeRequest} message ExportPosDataToLakeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportPosDataToLakeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportPosDataToLakeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeRequest} ExportPosDataToLakeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportPosDataToLakeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportPosDataToLakeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.exportProductMaster = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportPosDataToLakeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeRequest} ExportPosDataToLakeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportPosDataToLakeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportPosDataToLakeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportPosDataToLakeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.exportProductMaster != null && message.hasOwnProperty("exportProductMaster"))
                            if (typeof message.exportProductMaster !== "boolean")
                                return "exportProductMaster: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportPosDataToLakeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeRequest} ExportPosDataToLakeRequest
                     */
                    ExportPosDataToLakeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportPosDataToLakeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportPosDataToLakeRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.exportProductMaster != null)
                            message.exportProductMaster = Boolean(object.exportProductMaster);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportPosDataToLakeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @static
                     * @param {palexy.streaming.v1.ExportPosDataToLakeRequest} message ExportPosDataToLakeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportPosDataToLakeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.exportProductMaster = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.exportProductMaster != null && message.hasOwnProperty("exportProductMaster"))
                            object.exportProductMaster = message.exportProductMaster;
                        return object;
                    };
    
                    /**
                     * Converts this ExportPosDataToLakeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportPosDataToLakeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportPosDataToLakeRequest;
                })();
    
                v1.ExportPosDataToLakeResponse = (function() {
    
                    /**
                     * Properties of an ExportPosDataToLakeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IExportPosDataToLakeResponse
                     * @property {number|null} [partitionsWritten] ExportPosDataToLakeResponse partitionsWritten
                     * @property {number|null} [factRows] ExportPosDataToLakeResponse factRows
                     * @property {number|null} [bytesWritten] ExportPosDataToLakeResponse bytesWritten
                     * @property {boolean|null} [productMasterExported] ExportPosDataToLakeResponse productMasterExported
                     * @property {number|null} [productRows] ExportPosDataToLakeResponse productRows
                     * @property {number|null} [elapsedMillis] ExportPosDataToLakeResponse elapsedMillis
                     */
    
                    /**
                     * Constructs a new ExportPosDataToLakeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportPosDataToLakeResponse.
                     * @implements IExportPosDataToLakeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IExportPosDataToLakeResponse=} [properties] Properties to set
                     */
                    function ExportPosDataToLakeResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportPosDataToLakeResponse partitionsWritten.
                     * @member {number} partitionsWritten
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.partitionsWritten = 0;
    
                    /**
                     * ExportPosDataToLakeResponse factRows.
                     * @member {number} factRows
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.factRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportPosDataToLakeResponse bytesWritten.
                     * @member {number} bytesWritten
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.bytesWritten = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportPosDataToLakeResponse productMasterExported.
                     * @member {boolean} productMasterExported
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.productMasterExported = false;
    
                    /**
                     * ExportPosDataToLakeResponse productRows.
                     * @member {number} productRows
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.productRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportPosDataToLakeResponse elapsedMillis.
                     * @member {number} elapsedMillis
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     */
                    ExportPosDataToLakeResponse.prototype.elapsedMillis = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ExportPosDataToLakeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeResponse} ExportPosDataToLakeResponse instance
                     */
                    ExportPosDataToLakeResponse.create = function create(properties) {
                        return new ExportPosDataToLakeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ExportPosDataToLakeResponse message. Does not implicitly {@link palexy.streaming.v1.ExportPosDataToLakeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeResponse} message ExportPosDataToLakeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportPosDataToLakeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.partitionsWritten != null && Object.hasOwnProperty.call(message, "partitionsWritten"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.partitionsWritten);
                        if (message.factRows != null && Object.hasOwnProperty.call(message, "factRows"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.factRows);
                        if (message.bytesWritten != null && Object.hasOwnProperty.call(message, "bytesWritten"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.bytesWritten);
                        if (message.productMasterExported != null && Object.hasOwnProperty.call(message, "productMasterExported"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.productMasterExported);
                        if (message.productRows != null && Object.hasOwnProperty.call(message, "productRows"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.productRows);
                        if (message.elapsedMillis != null && Object.hasOwnProperty.call(message, "elapsedMillis"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.elapsedMillis);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportPosDataToLakeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportPosDataToLakeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {palexy.streaming.v1.IExportPosDataToLakeResponse} message ExportPosDataToLakeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportPosDataToLakeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportPosDataToLakeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeResponse} ExportPosDataToLakeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportPosDataToLakeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportPosDataToLakeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.partitionsWritten = reader.int32();
                                break;
                            case 2:
                                message.factRows = reader.int64();
                                break;
                            case 3:
                                message.bytesWritten = reader.int64();
                                break;
                            case 4:
                                message.productMasterExported = reader.bool();
                                break;
                            case 5:
                                message.productRows = reader.int64();
                                break;
                            case 6:
                                message.elapsedMillis = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportPosDataToLakeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeResponse} ExportPosDataToLakeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportPosDataToLakeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportPosDataToLakeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportPosDataToLakeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.partitionsWritten != null && message.hasOwnProperty("partitionsWritten"))
                            if (!$util.isInteger(message.partitionsWritten))
                                return "partitionsWritten: integer expected";
                        if (message.factRows != null && message.hasOwnProperty("factRows"))
                            if (!$util.isInteger(message.factRows) && !(message.factRows && $util.isInteger(message.factRows.low) && $util.isInteger(message.factRows.high)))
                                return "factRows: integer|Long expected";
                        if (message.bytesWritten != null && message.hasOwnProperty("bytesWritten"))
                            if (!$util.isInteger(message.bytesWritten) && !(message.bytesWritten && $util.isInteger(message.bytesWritten.low) && $util.isInteger(message.bytesWritten.high)))
                                return "bytesWritten: integer|Long expected";
                        if (message.productMasterExported != null && message.hasOwnProperty("productMasterExported"))
                            if (typeof message.productMasterExported !== "boolean")
                                return "productMasterExported: boolean expected";
                        if (message.productRows != null && message.hasOwnProperty("productRows"))
                            if (!$util.isInteger(message.productRows) && !(message.productRows && $util.isInteger(message.productRows.low) && $util.isInteger(message.productRows.high)))
                                return "productRows: integer|Long expected";
                        if (message.elapsedMillis != null && message.hasOwnProperty("elapsedMillis"))
                            if (!$util.isInteger(message.elapsedMillis) && !(message.elapsedMillis && $util.isInteger(message.elapsedMillis.low) && $util.isInteger(message.elapsedMillis.high)))
                                return "elapsedMillis: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExportPosDataToLakeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportPosDataToLakeResponse} ExportPosDataToLakeResponse
                     */
                    ExportPosDataToLakeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportPosDataToLakeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportPosDataToLakeResponse();
                        if (object.partitionsWritten != null)
                            message.partitionsWritten = object.partitionsWritten | 0;
                        if (object.factRows != null)
                            if ($util.Long)
                                (message.factRows = $util.Long.fromValue(object.factRows)).unsigned = false;
                            else if (typeof object.factRows === "string")
                                message.factRows = parseInt(object.factRows, 10);
                            else if (typeof object.factRows === "number")
                                message.factRows = object.factRows;
                            else if (typeof object.factRows === "object")
                                message.factRows = new $util.LongBits(object.factRows.low >>> 0, object.factRows.high >>> 0).toNumber();
                        if (object.bytesWritten != null)
                            if ($util.Long)
                                (message.bytesWritten = $util.Long.fromValue(object.bytesWritten)).unsigned = false;
                            else if (typeof object.bytesWritten === "string")
                                message.bytesWritten = parseInt(object.bytesWritten, 10);
                            else if (typeof object.bytesWritten === "number")
                                message.bytesWritten = object.bytesWritten;
                            else if (typeof object.bytesWritten === "object")
                                message.bytesWritten = new $util.LongBits(object.bytesWritten.low >>> 0, object.bytesWritten.high >>> 0).toNumber();
                        if (object.productMasterExported != null)
                            message.productMasterExported = Boolean(object.productMasterExported);
                        if (object.productRows != null)
                            if ($util.Long)
                                (message.productRows = $util.Long.fromValue(object.productRows)).unsigned = false;
                            else if (typeof object.productRows === "string")
                                message.productRows = parseInt(object.productRows, 10);
                            else if (typeof object.productRows === "number")
                                message.productRows = object.productRows;
                            else if (typeof object.productRows === "object")
                                message.productRows = new $util.LongBits(object.productRows.low >>> 0, object.productRows.high >>> 0).toNumber();
                        if (object.elapsedMillis != null)
                            if ($util.Long)
                                (message.elapsedMillis = $util.Long.fromValue(object.elapsedMillis)).unsigned = false;
                            else if (typeof object.elapsedMillis === "string")
                                message.elapsedMillis = parseInt(object.elapsedMillis, 10);
                            else if (typeof object.elapsedMillis === "number")
                                message.elapsedMillis = object.elapsedMillis;
                            else if (typeof object.elapsedMillis === "object")
                                message.elapsedMillis = new $util.LongBits(object.elapsedMillis.low >>> 0, object.elapsedMillis.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportPosDataToLakeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @static
                     * @param {palexy.streaming.v1.ExportPosDataToLakeResponse} message ExportPosDataToLakeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportPosDataToLakeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.partitionsWritten = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.factRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.factRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.bytesWritten = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.bytesWritten = options.longs === String ? "0" : 0;
                            object.productMasterExported = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.productRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.productRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.elapsedMillis = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.elapsedMillis = options.longs === String ? "0" : 0;
                        }
                        if (message.partitionsWritten != null && message.hasOwnProperty("partitionsWritten"))
                            object.partitionsWritten = message.partitionsWritten;
                        if (message.factRows != null && message.hasOwnProperty("factRows"))
                            if (typeof message.factRows === "number")
                                object.factRows = options.longs === String ? String(message.factRows) : message.factRows;
                            else
                                object.factRows = options.longs === String ? $util.Long.prototype.toString.call(message.factRows) : options.longs === Number ? new $util.LongBits(message.factRows.low >>> 0, message.factRows.high >>> 0).toNumber() : message.factRows;
                        if (message.bytesWritten != null && message.hasOwnProperty("bytesWritten"))
                            if (typeof message.bytesWritten === "number")
                                object.bytesWritten = options.longs === String ? String(message.bytesWritten) : message.bytesWritten;
                            else
                                object.bytesWritten = options.longs === String ? $util.Long.prototype.toString.call(message.bytesWritten) : options.longs === Number ? new $util.LongBits(message.bytesWritten.low >>> 0, message.bytesWritten.high >>> 0).toNumber() : message.bytesWritten;
                        if (message.productMasterExported != null && message.hasOwnProperty("productMasterExported"))
                            object.productMasterExported = message.productMasterExported;
                        if (message.productRows != null && message.hasOwnProperty("productRows"))
                            if (typeof message.productRows === "number")
                                object.productRows = options.longs === String ? String(message.productRows) : message.productRows;
                            else
                                object.productRows = options.longs === String ? $util.Long.prototype.toString.call(message.productRows) : options.longs === Number ? new $util.LongBits(message.productRows.low >>> 0, message.productRows.high >>> 0).toNumber() : message.productRows;
                        if (message.elapsedMillis != null && message.hasOwnProperty("elapsedMillis"))
                            if (typeof message.elapsedMillis === "number")
                                object.elapsedMillis = options.longs === String ? String(message.elapsedMillis) : message.elapsedMillis;
                            else
                                object.elapsedMillis = options.longs === String ? $util.Long.prototype.toString.call(message.elapsedMillis) : options.longs === Number ? new $util.LongBits(message.elapsedMillis.low >>> 0, message.elapsedMillis.high >>> 0).toNumber() : message.elapsedMillis;
                        return object;
                    };
    
                    /**
                     * Converts this ExportPosDataToLakeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportPosDataToLakeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportPosDataToLakeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExportPosDataToLakeResponse;
                })();
    
                v1.ListProductSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a ListProductSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListProductSectionMappingRequest
                     * @property {number|null} [storeId] ListProductSectionMappingRequest storeId
                     * @property {number|null} [dateId] ListProductSectionMappingRequest dateId
                     */
    
                    /**
                     * Constructs a new ListProductSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListProductSectionMappingRequest.
                     * @implements IListProductSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest=} [properties] Properties to set
                     */
                    function ListProductSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProductSectionMappingRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @instance
                     */
                    ListProductSectionMappingRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListProductSectionMappingRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @instance
                     */
                    ListProductSectionMappingRequest.prototype.dateId = 0;
    
                    /**
                     * Creates a new ListProductSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListProductSectionMappingRequest} ListProductSectionMappingRequest instance
                     */
                    ListProductSectionMappingRequest.create = function create(properties) {
                        return new ListProductSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListProductSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.ListProductSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest} message ListProductSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProductSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProductSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListProductSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingRequest} message ListProductSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProductSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProductSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListProductSectionMappingRequest} ListProductSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProductSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListProductSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProductSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListProductSectionMappingRequest} ListProductSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProductSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProductSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProductSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListProductSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListProductSectionMappingRequest} ListProductSectionMappingRequest
                     */
                    ListProductSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListProductSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListProductSectionMappingRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProductSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListProductSectionMappingRequest} message ListProductSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProductSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this ListProductSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListProductSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProductSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProductSectionMappingRequest;
                })();
    
                v1.ListProductSectionMappingResponse = (function() {
    
                    /**
                     * Properties of a ListProductSectionMappingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListProductSectionMappingResponse
                     * @property {Array.<palexy.streaming.v1.IProductSectionMapping>|null} [productSectionMapping] ListProductSectionMappingResponse productSectionMapping
                     */
    
                    /**
                     * Constructs a new ListProductSectionMappingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListProductSectionMappingResponse.
                     * @implements IListProductSectionMappingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListProductSectionMappingResponse=} [properties] Properties to set
                     */
                    function ListProductSectionMappingResponse(properties) {
                        this.productSectionMapping = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProductSectionMappingResponse productSectionMapping.
                     * @member {Array.<palexy.streaming.v1.IProductSectionMapping>} productSectionMapping
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @instance
                     */
                    ListProductSectionMappingResponse.prototype.productSectionMapping = $util.emptyArray;
    
                    /**
                     * Creates a new ListProductSectionMappingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListProductSectionMappingResponse} ListProductSectionMappingResponse instance
                     */
                    ListProductSectionMappingResponse.create = function create(properties) {
                        return new ListProductSectionMappingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListProductSectionMappingResponse message. Does not implicitly {@link palexy.streaming.v1.ListProductSectionMappingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingResponse} message ListProductSectionMappingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProductSectionMappingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.productSectionMapping != null && message.productSectionMapping.length)
                            for (var i = 0; i < message.productSectionMapping.length; ++i)
                                $root.palexy.streaming.v1.ProductSectionMapping.encode(message.productSectionMapping[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProductSectionMappingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListProductSectionMappingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListProductSectionMappingResponse} message ListProductSectionMappingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProductSectionMappingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProductSectionMappingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListProductSectionMappingResponse} ListProductSectionMappingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProductSectionMappingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListProductSectionMappingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.productSectionMapping && message.productSectionMapping.length))
                                    message.productSectionMapping = [];
                                message.productSectionMapping.push($root.palexy.streaming.v1.ProductSectionMapping.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProductSectionMappingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListProductSectionMappingResponse} ListProductSectionMappingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProductSectionMappingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProductSectionMappingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProductSectionMappingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.productSectionMapping != null && message.hasOwnProperty("productSectionMapping")) {
                            if (!Array.isArray(message.productSectionMapping))
                                return "productSectionMapping: array expected";
                            for (var i = 0; i < message.productSectionMapping.length; ++i) {
                                var error = $root.palexy.streaming.v1.ProductSectionMapping.verify(message.productSectionMapping[i]);
                                if (error)
                                    return "productSectionMapping." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListProductSectionMappingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListProductSectionMappingResponse} ListProductSectionMappingResponse
                     */
                    ListProductSectionMappingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListProductSectionMappingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListProductSectionMappingResponse();
                        if (object.productSectionMapping) {
                            if (!Array.isArray(object.productSectionMapping))
                                throw TypeError(".palexy.streaming.v1.ListProductSectionMappingResponse.productSectionMapping: array expected");
                            message.productSectionMapping = [];
                            for (var i = 0; i < object.productSectionMapping.length; ++i) {
                                if (typeof object.productSectionMapping[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListProductSectionMappingResponse.productSectionMapping: object expected");
                                message.productSectionMapping[i] = $root.palexy.streaming.v1.ProductSectionMapping.fromObject(object.productSectionMapping[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProductSectionMappingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListProductSectionMappingResponse} message ListProductSectionMappingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProductSectionMappingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.productSectionMapping = [];
                        if (message.productSectionMapping && message.productSectionMapping.length) {
                            object.productSectionMapping = [];
                            for (var j = 0; j < message.productSectionMapping.length; ++j)
                                object.productSectionMapping[j] = $root.palexy.streaming.v1.ProductSectionMapping.toObject(message.productSectionMapping[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListProductSectionMappingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListProductSectionMappingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProductSectionMappingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProductSectionMappingResponse;
                })();
    
                v1.ProductSectionMapping = (function() {
    
                    /**
                     * Properties of a ProductSectionMapping.
                     * @memberof palexy.streaming.v1
                     * @interface IProductSectionMapping
                     * @property {number|null} [posProductId] ProductSectionMapping posProductId
                     * @property {number|null} [metadataValueId] ProductSectionMapping metadataValueId
                     */
    
                    /**
                     * Constructs a new ProductSectionMapping.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ProductSectionMapping.
                     * @implements IProductSectionMapping
                     * @constructor
                     * @param {palexy.streaming.v1.IProductSectionMapping=} [properties] Properties to set
                     */
                    function ProductSectionMapping(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProductSectionMapping posProductId.
                     * @member {number} posProductId
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @instance
                     */
                    ProductSectionMapping.prototype.posProductId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProductSectionMapping metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @instance
                     */
                    ProductSectionMapping.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ProductSectionMapping instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IProductSectionMapping=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ProductSectionMapping} ProductSectionMapping instance
                     */
                    ProductSectionMapping.create = function create(properties) {
                        return new ProductSectionMapping(properties);
                    };
    
                    /**
                     * Encodes the specified ProductSectionMapping message. Does not implicitly {@link palexy.streaming.v1.ProductSectionMapping.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IProductSectionMapping} message ProductSectionMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProductSectionMapping.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posProductId != null && Object.hasOwnProperty.call(message, "posProductId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.posProductId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.metadataValueId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProductSectionMapping message, length delimited. Does not implicitly {@link palexy.streaming.v1.ProductSectionMapping.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IProductSectionMapping} message ProductSectionMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProductSectionMapping.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProductSectionMapping message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ProductSectionMapping} ProductSectionMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProductSectionMapping.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ProductSectionMapping();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.posProductId = reader.int64();
                                break;
                            case 2:
                                message.metadataValueId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProductSectionMapping message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ProductSectionMapping} ProductSectionMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProductSectionMapping.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProductSectionMapping message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProductSectionMapping.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posProductId != null && message.hasOwnProperty("posProductId"))
                            if (!$util.isInteger(message.posProductId) && !(message.posProductId && $util.isInteger(message.posProductId.low) && $util.isInteger(message.posProductId.high)))
                                return "posProductId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProductSectionMapping message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ProductSectionMapping} ProductSectionMapping
                     */
                    ProductSectionMapping.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ProductSectionMapping)
                            return object;
                        var message = new $root.palexy.streaming.v1.ProductSectionMapping();
                        if (object.posProductId != null)
                            if ($util.Long)
                                (message.posProductId = $util.Long.fromValue(object.posProductId)).unsigned = false;
                            else if (typeof object.posProductId === "string")
                                message.posProductId = parseInt(object.posProductId, 10);
                            else if (typeof object.posProductId === "number")
                                message.posProductId = object.posProductId;
                            else if (typeof object.posProductId === "object")
                                message.posProductId = new $util.LongBits(object.posProductId.low >>> 0, object.posProductId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProductSectionMapping message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.ProductSectionMapping} message ProductSectionMapping
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProductSectionMapping.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.posProductId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.posProductId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                        }
                        if (message.posProductId != null && message.hasOwnProperty("posProductId"))
                            if (typeof message.posProductId === "number")
                                object.posProductId = options.longs === String ? String(message.posProductId) : message.posProductId;
                            else
                                object.posProductId = options.longs === String ? $util.Long.prototype.toString.call(message.posProductId) : options.longs === Number ? new $util.LongBits(message.posProductId.low >>> 0, message.posProductId.high >>> 0).toNumber() : message.posProductId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        return object;
                    };
    
                    /**
                     * Converts this ProductSectionMapping to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ProductSectionMapping
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProductSectionMapping.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProductSectionMapping;
                })();
    
                v1.GetPosProductRequest = (function() {
    
                    /**
                     * Properties of a GetPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosProductRequest
                     * @property {number|null} [productId] GetPosProductRequest productId
                     */
    
                    /**
                     * Constructs a new GetPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosProductRequest.
                     * @implements IGetPosProductRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosProductRequest=} [properties] Properties to set
                     */
                    function GetPosProductRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosProductRequest productId.
                     * @member {number} productId
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @instance
                     */
                    GetPosProductRequest.prototype.productId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetPosProductRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosProductRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosProductRequest} GetPosProductRequest instance
                     */
                    GetPosProductRequest.create = function create(properties) {
                        return new GetPosProductRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosProductRequest message. Does not implicitly {@link palexy.streaming.v1.GetPosProductRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosProductRequest} message GetPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosProductRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.productId != null && Object.hasOwnProperty.call(message, "productId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.productId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosProductRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosProductRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosProductRequest} message GetPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosProductRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosProductRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosProductRequest} GetPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosProductRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosProductRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.productId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosProductRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosProductRequest} GetPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosProductRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosProductRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosProductRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.productId != null && message.hasOwnProperty("productId"))
                            if (!$util.isInteger(message.productId) && !(message.productId && $util.isInteger(message.productId.low) && $util.isInteger(message.productId.high)))
                                return "productId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosProductRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosProductRequest} GetPosProductRequest
                     */
                    GetPosProductRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosProductRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosProductRequest();
                        if (object.productId != null)
                            if ($util.Long)
                                (message.productId = $util.Long.fromValue(object.productId)).unsigned = false;
                            else if (typeof object.productId === "string")
                                message.productId = parseInt(object.productId, 10);
                            else if (typeof object.productId === "number")
                                message.productId = object.productId;
                            else if (typeof object.productId === "object")
                                message.productId = new $util.LongBits(object.productId.low >>> 0, object.productId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosProductRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.GetPosProductRequest} message GetPosProductRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosProductRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.productId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.productId = options.longs === String ? "0" : 0;
                        if (message.productId != null && message.hasOwnProperty("productId"))
                            if (typeof message.productId === "number")
                                object.productId = options.longs === String ? String(message.productId) : message.productId;
                            else
                                object.productId = options.longs === String ? $util.Long.prototype.toString.call(message.productId) : options.longs === Number ? new $util.LongBits(message.productId.low >>> 0, message.productId.high >>> 0).toNumber() : message.productId;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosProductRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosProductRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosProductRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosProductRequest;
                })();
    
                v1.ListPosProductRequest = (function() {
    
                    /**
                     * Properties of a ListPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosProductRequest
                     * @property {number|null} [companyId] ListPosProductRequest companyId
                     * @property {string|null} [name] ListPosProductRequest name
                     * @property {string|null} [code] ListPosProductRequest code
                     * @property {boolean|null} [includeMetadataInfo] ListPosProductRequest includeMetadataInfo
                     * @property {number|null} [pageSize] ListPosProductRequest pageSize
                     * @property {string|null} [pageToken] ListPosProductRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosProductRequest.
                     * @implements IListPosProductRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosProductRequest=} [properties] Properties to set
                     */
                    function ListPosProductRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosProductRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosProductRequest name.
                     * @member {string|null|undefined} name
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.name = null;
    
                    /**
                     * ListPosProductRequest code.
                     * @member {string|null|undefined} code
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.code = null;
    
                    /**
                     * ListPosProductRequest includeMetadataInfo.
                     * @member {boolean} includeMetadataInfo
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.includeMetadataInfo = false;
    
                    /**
                     * ListPosProductRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosProductRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    ListPosProductRequest.prototype.pageToken = "";
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ListPosProductRequest productFilter.
                     * @member {"name"|"code"|undefined} productFilter
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     */
                    Object.defineProperty(ListPosProductRequest.prototype, "productFilter", {
                        get: $util.oneOfGetter($oneOfFields = ["name", "code"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ListPosProductRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosProductRequest} ListPosProductRequest instance
                     */
                    ListPosProductRequest.create = function create(properties) {
                        return new ListPosProductRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosProductRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductRequest} message ListPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosProductRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.code);
                        if (message.includeMetadataInfo != null && Object.hasOwnProperty.call(message, "includeMetadataInfo"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeMetadataInfo);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosProductRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductRequest} message ListPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosProductRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosProductRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosProductRequest} ListPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosProductRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosProductRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.code = reader.string();
                                break;
                            case 4:
                                message.includeMetadataInfo = reader.bool();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosProductRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosProductRequest} ListPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosProductRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosProductRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosProductRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name")) {
                            properties.productFilter = 1;
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        }
                        if (message.code != null && message.hasOwnProperty("code")) {
                            if (properties.productFilter === 1)
                                return "productFilter: multiple values";
                            properties.productFilter = 1;
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        }
                        if (message.includeMetadataInfo != null && message.hasOwnProperty("includeMetadataInfo"))
                            if (typeof message.includeMetadataInfo !== "boolean")
                                return "includeMetadataInfo: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosProductRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosProductRequest} ListPosProductRequest
                     */
                    ListPosProductRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosProductRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosProductRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.code != null)
                            message.code = String(object.code);
                        if (object.includeMetadataInfo != null)
                            message.includeMetadataInfo = Boolean(object.includeMetadataInfo);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosProductRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosProductRequest} message ListPosProductRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosProductRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.includeMetadataInfo = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name")) {
                            object.name = message.name;
                            if (options.oneofs)
                                object.productFilter = "name";
                        }
                        if (message.code != null && message.hasOwnProperty("code")) {
                            object.code = message.code;
                            if (options.oneofs)
                                object.productFilter = "code";
                        }
                        if (message.includeMetadataInfo != null && message.hasOwnProperty("includeMetadataInfo"))
                            object.includeMetadataInfo = message.includeMetadataInfo;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosProductRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosProductRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosProductRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListPosProductRequest.ProductIdsFilter = (function() {
    
                        /**
                         * Properties of a ProductIdsFilter.
                         * @memberof palexy.streaming.v1.ListPosProductRequest
                         * @interface IProductIdsFilter
                         * @property {Array.<number>|null} [productIds] ProductIdsFilter productIds
                         */
    
                        /**
                         * Constructs a new ProductIdsFilter.
                         * @memberof palexy.streaming.v1.ListPosProductRequest
                         * @classdesc Represents a ProductIdsFilter.
                         * @implements IProductIdsFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListPosProductRequest.IProductIdsFilter=} [properties] Properties to set
                         */
                        function ProductIdsFilter(properties) {
                            this.productIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ProductIdsFilter productIds.
                         * @member {Array.<number>} productIds
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @instance
                         */
                        ProductIdsFilter.prototype.productIds = $util.emptyArray;
    
                        /**
                         * Creates a new ProductIdsFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IProductIdsFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter} ProductIdsFilter instance
                         */
                        ProductIdsFilter.create = function create(properties) {
                            return new ProductIdsFilter(properties);
                        };
    
                        /**
                         * Encodes the specified ProductIdsFilter message. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IProductIdsFilter} message ProductIdsFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProductIdsFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.productIds != null && message.productIds.length) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                for (var i = 0; i < message.productIds.length; ++i)
                                    writer.int64(message.productIds[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ProductIdsFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IProductIdsFilter} message ProductIdsFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProductIdsFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ProductIdsFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter} ProductIdsFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProductIdsFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.productIds && message.productIds.length))
                                        message.productIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.productIds.push(reader.int64());
                                    } else
                                        message.productIds.push(reader.int64());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ProductIdsFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter} ProductIdsFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProductIdsFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ProductIdsFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProductIdsFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.productIds != null && message.hasOwnProperty("productIds")) {
                                if (!Array.isArray(message.productIds))
                                    return "productIds: array expected";
                                for (var i = 0; i < message.productIds.length; ++i)
                                    if (!$util.isInteger(message.productIds[i]) && !(message.productIds[i] && $util.isInteger(message.productIds[i].low) && $util.isInteger(message.productIds[i].high)))
                                        return "productIds: integer|Long[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a ProductIdsFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter} ProductIdsFilter
                         */
                        ProductIdsFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter();
                            if (object.productIds) {
                                if (!Array.isArray(object.productIds))
                                    throw TypeError(".palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter.productIds: array expected");
                                message.productIds = [];
                                for (var i = 0; i < object.productIds.length; ++i)
                                    if ($util.Long)
                                        (message.productIds[i] = $util.Long.fromValue(object.productIds[i])).unsigned = false;
                                    else if (typeof object.productIds[i] === "string")
                                        message.productIds[i] = parseInt(object.productIds[i], 10);
                                    else if (typeof object.productIds[i] === "number")
                                        message.productIds[i] = object.productIds[i];
                                    else if (typeof object.productIds[i] === "object")
                                        message.productIds[i] = new $util.LongBits(object.productIds[i].low >>> 0, object.productIds[i].high >>> 0).toNumber();
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ProductIdsFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter} message ProductIdsFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProductIdsFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.productIds = [];
                            if (message.productIds && message.productIds.length) {
                                object.productIds = [];
                                for (var j = 0; j < message.productIds.length; ++j)
                                    if (typeof message.productIds[j] === "number")
                                        object.productIds[j] = options.longs === String ? String(message.productIds[j]) : message.productIds[j];
                                    else
                                        object.productIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.productIds[j]) : options.longs === Number ? new $util.LongBits(message.productIds[j].low >>> 0, message.productIds[j].high >>> 0).toNumber() : message.productIds[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this ProductIdsFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListPosProductRequest.ProductIdsFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProductIdsFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ProductIdsFilter;
                    })();
    
                    ListPosProductRequest.MetadataFilter = (function() {
    
                        /**
                         * Properties of a MetadataFilter.
                         * @memberof palexy.streaming.v1.ListPosProductRequest
                         * @interface IMetadataFilter
                         * @property {number|null} [metadataId] MetadataFilter metadataId
                         * @property {string|null} [metadataValue] MetadataFilter metadataValue
                         */
    
                        /**
                         * Constructs a new MetadataFilter.
                         * @memberof palexy.streaming.v1.ListPosProductRequest
                         * @classdesc Represents a MetadataFilter.
                         * @implements IMetadataFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListPosProductRequest.IMetadataFilter=} [properties] Properties to set
                         */
                        function MetadataFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * MetadataFilter metadataId.
                         * @member {number} metadataId
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @instance
                         */
                        MetadataFilter.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * MetadataFilter metadataValue.
                         * @member {string} metadataValue
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @instance
                         */
                        MetadataFilter.prototype.metadataValue = "";
    
                        /**
                         * Creates a new MetadataFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IMetadataFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListPosProductRequest.MetadataFilter} MetadataFilter instance
                         */
                        MetadataFilter.create = function create(properties) {
                            return new MetadataFilter(properties);
                        };
    
                        /**
                         * Encodes the specified MetadataFilter message. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.MetadataFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IMetadataFilter} message MetadataFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MetadataFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                            if (message.metadataValue != null && Object.hasOwnProperty.call(message, "metadataValue"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataValue);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified MetadataFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosProductRequest.MetadataFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.IMetadataFilter} message MetadataFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MetadataFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a MetadataFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListPosProductRequest.MetadataFilter} MetadataFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MetadataFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosProductRequest.MetadataFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.metadataId = reader.int64();
                                    break;
                                case 2:
                                    message.metadataValue = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a MetadataFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListPosProductRequest.MetadataFilter} MetadataFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MetadataFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a MetadataFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MetadataFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                                if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                    return "metadataId: integer|Long expected";
                            if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                                if (!$util.isString(message.metadataValue))
                                    return "metadataValue: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a MetadataFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListPosProductRequest.MetadataFilter} MetadataFilter
                         */
                        MetadataFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListPosProductRequest.MetadataFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListPosProductRequest.MetadataFilter();
                            if (object.metadataId != null)
                                if ($util.Long)
                                    (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                                else if (typeof object.metadataId === "string")
                                    message.metadataId = parseInt(object.metadataId, 10);
                                else if (typeof object.metadataId === "number")
                                    message.metadataId = object.metadataId;
                                else if (typeof object.metadataId === "object")
                                    message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                            if (object.metadataValue != null)
                                message.metadataValue = String(object.metadataValue);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a MetadataFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @static
                         * @param {palexy.streaming.v1.ListPosProductRequest.MetadataFilter} message MetadataFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MetadataFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.metadataId = options.longs === String ? "0" : 0;
                                object.metadataValue = "";
                            }
                            if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                                if (typeof message.metadataId === "number")
                                    object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                                else
                                    object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                            if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                                object.metadataValue = message.metadataValue;
                            return object;
                        };
    
                        /**
                         * Converts this MetadataFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListPosProductRequest.MetadataFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MetadataFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return MetadataFilter;
                    })();
    
                    return ListPosProductRequest;
                })();
    
                v1.ListPosProductResponse = (function() {
    
                    /**
                     * Properties of a ListPosProductResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosProductResponse
                     * @property {Array.<palexy.streaming.v1.IPosProduct>|null} [posProducts] ListPosProductResponse posProducts
                     * @property {number|null} [totalElements] ListPosProductResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosProductResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosProductResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosProductResponse.
                     * @implements IListPosProductResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosProductResponse=} [properties] Properties to set
                     */
                    function ListPosProductResponse(properties) {
                        this.posProducts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosProductResponse posProducts.
                     * @member {Array.<palexy.streaming.v1.IPosProduct>} posProducts
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @instance
                     */
                    ListPosProductResponse.prototype.posProducts = $util.emptyArray;
    
                    /**
                     * ListPosProductResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @instance
                     */
                    ListPosProductResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosProductResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @instance
                     */
                    ListPosProductResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosProductResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosProductResponse} ListPosProductResponse instance
                     */
                    ListPosProductResponse.create = function create(properties) {
                        return new ListPosProductResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosProductResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosProductResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductResponse} message ListPosProductResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosProductResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posProducts != null && message.posProducts.length)
                            for (var i = 0; i < message.posProducts.length; ++i)
                                $root.palexy.streaming.v1.PosProduct.encode(message.posProducts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosProductResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosProductResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosProductResponse} message ListPosProductResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosProductResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosProductResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosProductResponse} ListPosProductResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosProductResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosProductResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posProducts && message.posProducts.length))
                                    message.posProducts = [];
                                message.posProducts.push($root.palexy.streaming.v1.PosProduct.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosProductResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosProductResponse} ListPosProductResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosProductResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosProductResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosProductResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posProducts != null && message.hasOwnProperty("posProducts")) {
                            if (!Array.isArray(message.posProducts))
                                return "posProducts: array expected";
                            for (var i = 0; i < message.posProducts.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosProduct.verify(message.posProducts[i]);
                                if (error)
                                    return "posProducts." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosProductResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosProductResponse} ListPosProductResponse
                     */
                    ListPosProductResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosProductResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosProductResponse();
                        if (object.posProducts) {
                            if (!Array.isArray(object.posProducts))
                                throw TypeError(".palexy.streaming.v1.ListPosProductResponse.posProducts: array expected");
                            message.posProducts = [];
                            for (var i = 0; i < object.posProducts.length; ++i) {
                                if (typeof object.posProducts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListPosProductResponse.posProducts: object expected");
                                message.posProducts[i] = $root.palexy.streaming.v1.PosProduct.fromObject(object.posProducts[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosProductResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosProductResponse} message ListPosProductResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosProductResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posProducts = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.posProducts && message.posProducts.length) {
                            object.posProducts = [];
                            for (var j = 0; j < message.posProducts.length; ++j)
                                object.posProducts[j] = $root.palexy.streaming.v1.PosProduct.toObject(message.posProducts[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosProductResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosProductResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosProductResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosProductResponse;
                })();
    
                v1.ListPosTransactionRequest = (function() {
    
                    /**
                     * Properties of a ListPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionRequest
                     * @property {Array.<number>|null} [storeIds] ListPosTransactionRequest storeIds
                     * @property {string|null} [startDate] ListPosTransactionRequest startDate
                     * @property {string|null} [endDate] ListPosTransactionRequest endDate
                     * @property {string|null} [externalTranId] ListPosTransactionRequest externalTranId
                     * @property {boolean|null} [includeProductInfo] ListPosTransactionRequest includeProductInfo
                     * @property {boolean|null} [includeBuyerInfo] ListPosTransactionRequest includeBuyerInfo
                     * @property {boolean|null} [includeProductMetadataInfo] ListPosTransactionRequest includeProductMetadataInfo
                     * @property {boolean|null} [includeTransactionMetadataInfo] ListPosTransactionRequest includeTransactionMetadataInfo
                     * @property {number|null} [pageSize] ListPosTransactionRequest pageSize
                     * @property {string|null} [pageToken] ListPosTransactionRequest pageToken
                     * @property {Array.<string>|null} [salesStaffId] ListPosTransactionRequest salesStaffId
                     * @property {Array.<string>|null} [externalTranIds] ListPosTransactionRequest externalTranIds
                     */
    
                    /**
                     * Constructs a new ListPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionRequest.
                     * @implements IListPosTransactionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionRequest=} [properties] Properties to set
                     */
                    function ListPosTransactionRequest(properties) {
                        this.storeIds = [];
                        this.salesStaffId = [];
                        this.externalTranIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListPosTransactionRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.startDate = "";
    
                    /**
                     * ListPosTransactionRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.endDate = "";
    
                    /**
                     * ListPosTransactionRequest externalTranId.
                     * @member {string} externalTranId
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.externalTranId = "";
    
                    /**
                     * ListPosTransactionRequest includeProductInfo.
                     * @member {boolean} includeProductInfo
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.includeProductInfo = false;
    
                    /**
                     * ListPosTransactionRequest includeBuyerInfo.
                     * @member {boolean} includeBuyerInfo
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.includeBuyerInfo = false;
    
                    /**
                     * ListPosTransactionRequest includeProductMetadataInfo.
                     * @member {boolean} includeProductMetadataInfo
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.includeProductMetadataInfo = false;
    
                    /**
                     * ListPosTransactionRequest includeTransactionMetadataInfo.
                     * @member {boolean} includeTransactionMetadataInfo
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.includeTransactionMetadataInfo = false;
    
                    /**
                     * ListPosTransactionRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosTransactionRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.pageToken = "";
    
                    /**
                     * ListPosTransactionRequest salesStaffId.
                     * @member {Array.<string>} salesStaffId
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.salesStaffId = $util.emptyArray;
    
                    /**
                     * ListPosTransactionRequest externalTranIds.
                     * @member {Array.<string>} externalTranIds
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     */
                    ListPosTransactionRequest.prototype.externalTranIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListPosTransactionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionRequest} ListPosTransactionRequest instance
                     */
                    ListPosTransactionRequest.create = function create(properties) {
                        return new ListPosTransactionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionRequest} message ListPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDate);
                        if (message.externalTranId != null && Object.hasOwnProperty.call(message, "externalTranId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.externalTranId);
                        if (message.includeProductInfo != null && Object.hasOwnProperty.call(message, "includeProductInfo"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeProductInfo);
                        if (message.includeBuyerInfo != null && Object.hasOwnProperty.call(message, "includeBuyerInfo"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeBuyerInfo);
                        if (message.includeProductMetadataInfo != null && Object.hasOwnProperty.call(message, "includeProductMetadataInfo"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeProductMetadataInfo);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.pageToken);
                        if (message.salesStaffId != null && message.salesStaffId.length)
                            for (var i = 0; i < message.salesStaffId.length; ++i)
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.salesStaffId[i]);
                        if (message.includeTransactionMetadataInfo != null && Object.hasOwnProperty.call(message, "includeTransactionMetadataInfo"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.includeTransactionMetadataInfo);
                        if (message.externalTranIds != null && message.externalTranIds.length)
                            for (var i = 0; i < message.externalTranIds.length; ++i)
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.externalTranIds[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionRequest} message ListPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionRequest} ListPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDate = reader.string();
                                break;
                            case 3:
                                message.endDate = reader.string();
                                break;
                            case 4:
                                message.externalTranId = reader.string();
                                break;
                            case 5:
                                message.includeProductInfo = reader.bool();
                                break;
                            case 6:
                                message.includeBuyerInfo = reader.bool();
                                break;
                            case 7:
                                message.includeProductMetadataInfo = reader.bool();
                                break;
                            case 11:
                                message.includeTransactionMetadataInfo = reader.bool();
                                break;
                            case 8:
                                message.pageSize = reader.int32();
                                break;
                            case 9:
                                message.pageToken = reader.string();
                                break;
                            case 10:
                                if (!(message.salesStaffId && message.salesStaffId.length))
                                    message.salesStaffId = [];
                                message.salesStaffId.push(reader.string());
                                break;
                            case 12:
                                if (!(message.externalTranIds && message.externalTranIds.length))
                                    message.externalTranIds = [];
                                message.externalTranIds.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionRequest} ListPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        if (message.externalTranId != null && message.hasOwnProperty("externalTranId"))
                            if (!$util.isString(message.externalTranId))
                                return "externalTranId: string expected";
                        if (message.includeProductInfo != null && message.hasOwnProperty("includeProductInfo"))
                            if (typeof message.includeProductInfo !== "boolean")
                                return "includeProductInfo: boolean expected";
                        if (message.includeBuyerInfo != null && message.hasOwnProperty("includeBuyerInfo"))
                            if (typeof message.includeBuyerInfo !== "boolean")
                                return "includeBuyerInfo: boolean expected";
                        if (message.includeProductMetadataInfo != null && message.hasOwnProperty("includeProductMetadataInfo"))
                            if (typeof message.includeProductMetadataInfo !== "boolean")
                                return "includeProductMetadataInfo: boolean expected";
                        if (message.includeTransactionMetadataInfo != null && message.hasOwnProperty("includeTransactionMetadataInfo"))
                            if (typeof message.includeTransactionMetadataInfo !== "boolean")
                                return "includeTransactionMetadataInfo: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.salesStaffId != null && message.hasOwnProperty("salesStaffId")) {
                            if (!Array.isArray(message.salesStaffId))
                                return "salesStaffId: array expected";
                            for (var i = 0; i < message.salesStaffId.length; ++i)
                                if (!$util.isString(message.salesStaffId[i]))
                                    return "salesStaffId: string[] expected";
                        }
                        if (message.externalTranIds != null && message.hasOwnProperty("externalTranIds")) {
                            if (!Array.isArray(message.externalTranIds))
                                return "externalTranIds: array expected";
                            for (var i = 0; i < message.externalTranIds.length; ++i)
                                if (!$util.isString(message.externalTranIds[i]))
                                    return "externalTranIds: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionRequest} ListPosTransactionRequest
                     */
                    ListPosTransactionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        if (object.externalTranId != null)
                            message.externalTranId = String(object.externalTranId);
                        if (object.includeProductInfo != null)
                            message.includeProductInfo = Boolean(object.includeProductInfo);
                        if (object.includeBuyerInfo != null)
                            message.includeBuyerInfo = Boolean(object.includeBuyerInfo);
                        if (object.includeProductMetadataInfo != null)
                            message.includeProductMetadataInfo = Boolean(object.includeProductMetadataInfo);
                        if (object.includeTransactionMetadataInfo != null)
                            message.includeTransactionMetadataInfo = Boolean(object.includeTransactionMetadataInfo);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.salesStaffId) {
                            if (!Array.isArray(object.salesStaffId))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionRequest.salesStaffId: array expected");
                            message.salesStaffId = [];
                            for (var i = 0; i < object.salesStaffId.length; ++i)
                                message.salesStaffId[i] = String(object.salesStaffId[i]);
                        }
                        if (object.externalTranIds) {
                            if (!Array.isArray(object.externalTranIds))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionRequest.externalTranIds: array expected");
                            message.externalTranIds = [];
                            for (var i = 0; i < object.externalTranIds.length; ++i)
                                message.externalTranIds[i] = String(object.externalTranIds[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionRequest} message ListPosTransactionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeIds = [];
                            object.salesStaffId = [];
                            object.externalTranIds = [];
                        }
                        if (options.defaults) {
                            object.startDate = "";
                            object.endDate = "";
                            object.externalTranId = "";
                            object.includeProductInfo = false;
                            object.includeBuyerInfo = false;
                            object.includeProductMetadataInfo = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeTransactionMetadataInfo = false;
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        if (message.externalTranId != null && message.hasOwnProperty("externalTranId"))
                            object.externalTranId = message.externalTranId;
                        if (message.includeProductInfo != null && message.hasOwnProperty("includeProductInfo"))
                            object.includeProductInfo = message.includeProductInfo;
                        if (message.includeBuyerInfo != null && message.hasOwnProperty("includeBuyerInfo"))
                            object.includeBuyerInfo = message.includeBuyerInfo;
                        if (message.includeProductMetadataInfo != null && message.hasOwnProperty("includeProductMetadataInfo"))
                            object.includeProductMetadataInfo = message.includeProductMetadataInfo;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.salesStaffId && message.salesStaffId.length) {
                            object.salesStaffId = [];
                            for (var j = 0; j < message.salesStaffId.length; ++j)
                                object.salesStaffId[j] = message.salesStaffId[j];
                        }
                        if (message.includeTransactionMetadataInfo != null && message.hasOwnProperty("includeTransactionMetadataInfo"))
                            object.includeTransactionMetadataInfo = message.includeTransactionMetadataInfo;
                        if (message.externalTranIds && message.externalTranIds.length) {
                            object.externalTranIds = [];
                            for (var j = 0; j < message.externalTranIds.length; ++j)
                                object.externalTranIds[j] = message.externalTranIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionRequest;
                })();
    
                v1.ListPosTransactionResponse = (function() {
    
                    /**
                     * Properties of a ListPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionResponse
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [posTransactions] ListPosTransactionResponse posTransactions
                     * @property {number|null} [totalElements] ListPosTransactionResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosTransactionResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionResponse.
                     * @implements IListPosTransactionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionResponse=} [properties] Properties to set
                     */
                    function ListPosTransactionResponse(properties) {
                        this.posTransactions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionResponse posTransactions.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} posTransactions
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @instance
                     */
                    ListPosTransactionResponse.prototype.posTransactions = $util.emptyArray;
    
                    /**
                     * ListPosTransactionResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @instance
                     */
                    ListPosTransactionResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosTransactionResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @instance
                     */
                    ListPosTransactionResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosTransactionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionResponse} ListPosTransactionResponse instance
                     */
                    ListPosTransactionResponse.create = function create(properties) {
                        return new ListPosTransactionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionResponse} message ListPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posTransactions != null && message.posTransactions.length)
                            for (var i = 0; i < message.posTransactions.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.posTransactions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionResponse} message ListPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionResponse} ListPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posTransactions && message.posTransactions.length))
                                    message.posTransactions = [];
                                message.posTransactions.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionResponse} ListPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posTransactions != null && message.hasOwnProperty("posTransactions")) {
                            if (!Array.isArray(message.posTransactions))
                                return "posTransactions: array expected";
                            for (var i = 0; i < message.posTransactions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.posTransactions[i]);
                                if (error)
                                    return "posTransactions." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionResponse} ListPosTransactionResponse
                     */
                    ListPosTransactionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionResponse();
                        if (object.posTransactions) {
                            if (!Array.isArray(object.posTransactions))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionResponse.posTransactions: array expected");
                            message.posTransactions = [];
                            for (var i = 0; i < object.posTransactions.length; ++i) {
                                if (typeof object.posTransactions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListPosTransactionResponse.posTransactions: object expected");
                                message.posTransactions[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.posTransactions[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionResponse} message ListPosTransactionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posTransactions = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.posTransactions && message.posTransactions.length) {
                            object.posTransactions = [];
                            for (var j = 0; j < message.posTransactions.length; ++j)
                                object.posTransactions[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.posTransactions[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionResponse;
                })();
    
                v1.ImportPosProductRequest = (function() {
    
                    /**
                     * Properties of an ImportPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IImportPosProductRequest
                     * @property {number|null} [companyId] ImportPosProductRequest companyId
                     * @property {boolean|null} [preview] ImportPosProductRequest preview
                     * @property {Uint8Array|null} [csvData] ImportPosProductRequest csvData
                     * @property {palexy.streaming.v1.IPosProductList|null} [productList] ImportPosProductRequest productList
                     */
    
                    /**
                     * Constructs a new ImportPosProductRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportPosProductRequest.
                     * @implements IImportPosProductRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IImportPosProductRequest=} [properties] Properties to set
                     */
                    function ImportPosProductRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportPosProductRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     */
                    ImportPosProductRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportPosProductRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     */
                    ImportPosProductRequest.prototype.preview = false;
    
                    /**
                     * ImportPosProductRequest csvData.
                     * @member {Uint8Array|null|undefined} csvData
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     */
                    ImportPosProductRequest.prototype.csvData = null;
    
                    /**
                     * ImportPosProductRequest productList.
                     * @member {palexy.streaming.v1.IPosProductList|null|undefined} productList
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     */
                    ImportPosProductRequest.prototype.productList = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ImportPosProductRequest sourceData.
                     * @member {"csvData"|"productList"|undefined} sourceData
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     */
                    Object.defineProperty(ImportPosProductRequest.prototype, "sourceData", {
                        get: $util.oneOfGetter($oneOfFields = ["csvData", "productList"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ImportPosProductRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportPosProductRequest} ImportPosProductRequest instance
                     */
                    ImportPosProductRequest.create = function create(properties) {
                        return new ImportPosProductRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportPosProductRequest message. Does not implicitly {@link palexy.streaming.v1.ImportPosProductRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductRequest} message ImportPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosProductRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.csvData != null && Object.hasOwnProperty.call(message, "csvData"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.csvData);
                        if (message.productList != null && Object.hasOwnProperty.call(message, "productList"))
                            $root.palexy.streaming.v1.PosProductList.encode(message.productList, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.preview);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportPosProductRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportPosProductRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductRequest} message ImportPosProductRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosProductRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportPosProductRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportPosProductRequest} ImportPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosProductRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportPosProductRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 4:
                                message.preview = reader.bool();
                                break;
                            case 2:
                                message.csvData = reader.bytes();
                                break;
                            case 3:
                                message.productList = $root.palexy.streaming.v1.PosProductList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportPosProductRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportPosProductRequest} ImportPosProductRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosProductRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportPosProductRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportPosProductRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.csvData != null && message.hasOwnProperty("csvData")) {
                            properties.sourceData = 1;
                            if (!(message.csvData && typeof message.csvData.length === "number" || $util.isString(message.csvData)))
                                return "csvData: buffer expected";
                        }
                        if (message.productList != null && message.hasOwnProperty("productList")) {
                            if (properties.sourceData === 1)
                                return "sourceData: multiple values";
                            properties.sourceData = 1;
                            {
                                var error = $root.palexy.streaming.v1.PosProductList.verify(message.productList);
                                if (error)
                                    return "productList." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportPosProductRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportPosProductRequest} ImportPosProductRequest
                     */
                    ImportPosProductRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportPosProductRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportPosProductRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.csvData != null)
                            if (typeof object.csvData === "string")
                                $util.base64.decode(object.csvData, message.csvData = $util.newBuffer($util.base64.length(object.csvData)), 0);
                            else if (object.csvData.length)
                                message.csvData = object.csvData;
                        if (object.productList != null) {
                            if (typeof object.productList !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosProductRequest.productList: object expected");
                            message.productList = $root.palexy.streaming.v1.PosProductList.fromObject(object.productList);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportPosProductRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @static
                     * @param {palexy.streaming.v1.ImportPosProductRequest} message ImportPosProductRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportPosProductRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.preview = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.csvData != null && message.hasOwnProperty("csvData")) {
                            object.csvData = options.bytes === String ? $util.base64.encode(message.csvData, 0, message.csvData.length) : options.bytes === Array ? Array.prototype.slice.call(message.csvData) : message.csvData;
                            if (options.oneofs)
                                object.sourceData = "csvData";
                        }
                        if (message.productList != null && message.hasOwnProperty("productList")) {
                            object.productList = $root.palexy.streaming.v1.PosProductList.toObject(message.productList, options);
                            if (options.oneofs)
                                object.sourceData = "productList";
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        return object;
                    };
    
                    /**
                     * Converts this ImportPosProductRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportPosProductRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportPosProductRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportPosProductRequest;
                })();
    
                v1.PosProductList = (function() {
    
                    /**
                     * Properties of a PosProductList.
                     * @memberof palexy.streaming.v1
                     * @interface IPosProductList
                     * @property {Array.<palexy.streaming.v1.IPosProduct>|null} [products] PosProductList products
                     */
    
                    /**
                     * Constructs a new PosProductList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosProductList.
                     * @implements IPosProductList
                     * @constructor
                     * @param {palexy.streaming.v1.IPosProductList=} [properties] Properties to set
                     */
                    function PosProductList(properties) {
                        this.products = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosProductList products.
                     * @member {Array.<palexy.streaming.v1.IPosProduct>} products
                     * @memberof palexy.streaming.v1.PosProductList
                     * @instance
                     */
                    PosProductList.prototype.products = $util.emptyArray;
    
                    /**
                     * Creates a new PosProductList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {palexy.streaming.v1.IPosProductList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosProductList} PosProductList instance
                     */
                    PosProductList.create = function create(properties) {
                        return new PosProductList(properties);
                    };
    
                    /**
                     * Encodes the specified PosProductList message. Does not implicitly {@link palexy.streaming.v1.PosProductList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {palexy.streaming.v1.IPosProductList} message PosProductList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProductList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.products != null && message.products.length)
                            for (var i = 0; i < message.products.length; ++i)
                                $root.palexy.streaming.v1.PosProduct.encode(message.products[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosProductList message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosProductList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {palexy.streaming.v1.IPosProductList} message PosProductList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProductList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosProductList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosProductList} PosProductList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProductList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosProductList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.products && message.products.length))
                                    message.products = [];
                                message.products.push($root.palexy.streaming.v1.PosProduct.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosProductList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosProductList} PosProductList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProductList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosProductList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosProductList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.products != null && message.hasOwnProperty("products")) {
                            if (!Array.isArray(message.products))
                                return "products: array expected";
                            for (var i = 0; i < message.products.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosProduct.verify(message.products[i]);
                                if (error)
                                    return "products." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosProductList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosProductList} PosProductList
                     */
                    PosProductList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosProductList)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosProductList();
                        if (object.products) {
                            if (!Array.isArray(object.products))
                                throw TypeError(".palexy.streaming.v1.PosProductList.products: array expected");
                            message.products = [];
                            for (var i = 0; i < object.products.length; ++i) {
                                if (typeof object.products[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosProductList.products: object expected");
                                message.products[i] = $root.palexy.streaming.v1.PosProduct.fromObject(object.products[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosProductList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosProductList
                     * @static
                     * @param {palexy.streaming.v1.PosProductList} message PosProductList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosProductList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.products = [];
                        if (message.products && message.products.length) {
                            object.products = [];
                            for (var j = 0; j < message.products.length; ++j)
                                object.products[j] = $root.palexy.streaming.v1.PosProduct.toObject(message.products[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosProductList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosProductList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosProductList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosProductList;
                })();
    
                v1.ImportPosProductResponse = (function() {
    
                    /**
                     * Properties of an ImportPosProductResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IImportPosProductResponse
                     * @property {palexy.streaming.v1.IImportResult|null} [productImportResult] ImportPosProductResponse productImportResult
                     * @property {Array.<palexy.streaming.v1.IPosProduct>|null} [previewResult] ImportPosProductResponse previewResult
                     */
    
                    /**
                     * Constructs a new ImportPosProductResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportPosProductResponse.
                     * @implements IImportPosProductResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IImportPosProductResponse=} [properties] Properties to set
                     */
                    function ImportPosProductResponse(properties) {
                        this.previewResult = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportPosProductResponse productImportResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} productImportResult
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @instance
                     */
                    ImportPosProductResponse.prototype.productImportResult = null;
    
                    /**
                     * ImportPosProductResponse previewResult.
                     * @member {Array.<palexy.streaming.v1.IPosProduct>} previewResult
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @instance
                     */
                    ImportPosProductResponse.prototype.previewResult = $util.emptyArray;
    
                    /**
                     * Creates a new ImportPosProductResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportPosProductResponse} ImportPosProductResponse instance
                     */
                    ImportPosProductResponse.create = function create(properties) {
                        return new ImportPosProductResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ImportPosProductResponse message. Does not implicitly {@link palexy.streaming.v1.ImportPosProductResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductResponse} message ImportPosProductResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosProductResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.productImportResult != null && Object.hasOwnProperty.call(message, "productImportResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.productImportResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.previewResult != null && message.previewResult.length)
                            for (var i = 0; i < message.previewResult.length; ++i)
                                $root.palexy.streaming.v1.PosProduct.encode(message.previewResult[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportPosProductResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportPosProductResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosProductResponse} message ImportPosProductResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosProductResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportPosProductResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportPosProductResponse} ImportPosProductResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosProductResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportPosProductResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.productImportResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            case 3:
                                if (!(message.previewResult && message.previewResult.length))
                                    message.previewResult = [];
                                message.previewResult.push($root.palexy.streaming.v1.PosProduct.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportPosProductResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportPosProductResponse} ImportPosProductResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosProductResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportPosProductResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportPosProductResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.productImportResult != null && message.hasOwnProperty("productImportResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.productImportResult);
                            if (error)
                                return "productImportResult." + error;
                        }
                        if (message.previewResult != null && message.hasOwnProperty("previewResult")) {
                            if (!Array.isArray(message.previewResult))
                                return "previewResult: array expected";
                            for (var i = 0; i < message.previewResult.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosProduct.verify(message.previewResult[i]);
                                if (error)
                                    return "previewResult." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportPosProductResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportPosProductResponse} ImportPosProductResponse
                     */
                    ImportPosProductResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportPosProductResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportPosProductResponse();
                        if (object.productImportResult != null) {
                            if (typeof object.productImportResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosProductResponse.productImportResult: object expected");
                            message.productImportResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.productImportResult);
                        }
                        if (object.previewResult) {
                            if (!Array.isArray(object.previewResult))
                                throw TypeError(".palexy.streaming.v1.ImportPosProductResponse.previewResult: array expected");
                            message.previewResult = [];
                            for (var i = 0; i < object.previewResult.length; ++i) {
                                if (typeof object.previewResult[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportPosProductResponse.previewResult: object expected");
                                message.previewResult[i] = $root.palexy.streaming.v1.PosProduct.fromObject(object.previewResult[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportPosProductResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @static
                     * @param {palexy.streaming.v1.ImportPosProductResponse} message ImportPosProductResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportPosProductResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.previewResult = [];
                        if (options.defaults)
                            object.productImportResult = null;
                        if (message.productImportResult != null && message.hasOwnProperty("productImportResult"))
                            object.productImportResult = $root.palexy.streaming.v1.ImportResult.toObject(message.productImportResult, options);
                        if (message.previewResult && message.previewResult.length) {
                            object.previewResult = [];
                            for (var j = 0; j < message.previewResult.length; ++j)
                                object.previewResult[j] = $root.palexy.streaming.v1.PosProduct.toObject(message.previewResult[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ImportPosProductResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportPosProductResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportPosProductResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportPosProductResponse;
                })();
    
                v1.ImportPosTransactionRequest = (function() {
    
                    /**
                     * Properties of an ImportPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IImportPosTransactionRequest
                     * @property {number|null} [companyId] ImportPosTransactionRequest companyId
                     * @property {Array.<number>|null} [storeIds] ImportPosTransactionRequest storeIds
                     * @property {string|null} [startDate] ImportPosTransactionRequest startDate
                     * @property {string|null} [endDate] ImportPosTransactionRequest endDate
                     * @property {boolean|null} [createProductIfNotExists] ImportPosTransactionRequest createProductIfNotExists
                     * @property {boolean|null} [deleteTransactionIfExists] ImportPosTransactionRequest deleteTransactionIfExists
                     * @property {number|null} [accountId] ImportPosTransactionRequest accountId
                     * @property {boolean|null} [preview] ImportPosTransactionRequest preview
                     * @property {string|null} [startDateTime] ImportPosTransactionRequest startDateTime
                     * @property {string|null} [endDateTime] ImportPosTransactionRequest endDateTime
                     * @property {Uint8Array|null} [csvData] ImportPosTransactionRequest csvData
                     * @property {palexy.streaming.v1.IPosTransactionList|null} [transactionList] ImportPosTransactionRequest transactionList
                     */
    
                    /**
                     * Constructs a new ImportPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportPosTransactionRequest.
                     * @implements IImportPosTransactionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest=} [properties] Properties to set
                     */
                    function ImportPosTransactionRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportPosTransactionRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportPosTransactionRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ImportPosTransactionRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.startDate = "";
    
                    /**
                     * ImportPosTransactionRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.endDate = "";
    
                    /**
                     * ImportPosTransactionRequest createProductIfNotExists.
                     * @member {boolean} createProductIfNotExists
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.createProductIfNotExists = false;
    
                    /**
                     * ImportPosTransactionRequest deleteTransactionIfExists.
                     * @member {boolean} deleteTransactionIfExists
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.deleteTransactionIfExists = false;
    
                    /**
                     * ImportPosTransactionRequest accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportPosTransactionRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.preview = false;
    
                    /**
                     * ImportPosTransactionRequest startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.startDateTime = "";
    
                    /**
                     * ImportPosTransactionRequest endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.endDateTime = "";
    
                    /**
                     * ImportPosTransactionRequest csvData.
                     * @member {Uint8Array|null|undefined} csvData
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.csvData = null;
    
                    /**
                     * ImportPosTransactionRequest transactionList.
                     * @member {palexy.streaming.v1.IPosTransactionList|null|undefined} transactionList
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    ImportPosTransactionRequest.prototype.transactionList = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ImportPosTransactionRequest sourceData.
                     * @member {"csvData"|"transactionList"|undefined} sourceData
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     */
                    Object.defineProperty(ImportPosTransactionRequest.prototype, "sourceData", {
                        get: $util.oneOfGetter($oneOfFields = ["csvData", "transactionList"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ImportPosTransactionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportPosTransactionRequest} ImportPosTransactionRequest instance
                     */
                    ImportPosTransactionRequest.create = function create(properties) {
                        return new ImportPosTransactionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportPosTransactionRequest message. Does not implicitly {@link palexy.streaming.v1.ImportPosTransactionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest} message ImportPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosTransactionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDate);
                        if (message.createProductIfNotExists != null && Object.hasOwnProperty.call(message, "createProductIfNotExists"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.createProductIfNotExists);
                        if (message.deleteTransactionIfExists != null && Object.hasOwnProperty.call(message, "deleteTransactionIfExists"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.deleteTransactionIfExists);
                        if (message.csvData != null && Object.hasOwnProperty.call(message, "csvData"))
                            writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.csvData);
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.accountId);
                        if (message.transactionList != null && Object.hasOwnProperty.call(message, "transactionList"))
                            $root.palexy.streaming.v1.PosTransactionList.encode(message.transactionList, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.endDateTime);
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.preview);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportPosTransactionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportPosTransactionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionRequest} message ImportPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosTransactionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportPosTransactionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportPosTransactionRequest} ImportPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosTransactionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportPosTransactionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 3:
                                message.startDate = reader.string();
                                break;
                            case 4:
                                message.endDate = reader.string();
                                break;
                            case 5:
                                message.createProductIfNotExists = reader.bool();
                                break;
                            case 6:
                                message.deleteTransactionIfExists = reader.bool();
                                break;
                            case 8:
                                message.accountId = reader.int64();
                                break;
                            case 12:
                                message.preview = reader.bool();
                                break;
                            case 10:
                                message.startDateTime = reader.string();
                                break;
                            case 11:
                                message.endDateTime = reader.string();
                                break;
                            case 7:
                                message.csvData = reader.bytes();
                                break;
                            case 9:
                                message.transactionList = $root.palexy.streaming.v1.PosTransactionList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportPosTransactionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportPosTransactionRequest} ImportPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosTransactionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportPosTransactionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportPosTransactionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        if (message.createProductIfNotExists != null && message.hasOwnProperty("createProductIfNotExists"))
                            if (typeof message.createProductIfNotExists !== "boolean")
                                return "createProductIfNotExists: boolean expected";
                        if (message.deleteTransactionIfExists != null && message.hasOwnProperty("deleteTransactionIfExists"))
                            if (typeof message.deleteTransactionIfExists !== "boolean")
                                return "deleteTransactionIfExists: boolean expected";
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        if (message.csvData != null && message.hasOwnProperty("csvData")) {
                            properties.sourceData = 1;
                            if (!(message.csvData && typeof message.csvData.length === "number" || $util.isString(message.csvData)))
                                return "csvData: buffer expected";
                        }
                        if (message.transactionList != null && message.hasOwnProperty("transactionList")) {
                            if (properties.sourceData === 1)
                                return "sourceData: multiple values";
                            properties.sourceData = 1;
                            {
                                var error = $root.palexy.streaming.v1.PosTransactionList.verify(message.transactionList);
                                if (error)
                                    return "transactionList." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportPosTransactionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportPosTransactionRequest} ImportPosTransactionRequest
                     */
                    ImportPosTransactionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportPosTransactionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportPosTransactionRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        if (object.createProductIfNotExists != null)
                            message.createProductIfNotExists = Boolean(object.createProductIfNotExists);
                        if (object.deleteTransactionIfExists != null)
                            message.deleteTransactionIfExists = Boolean(object.deleteTransactionIfExists);
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        if (object.csvData != null)
                            if (typeof object.csvData === "string")
                                $util.base64.decode(object.csvData, message.csvData = $util.newBuffer($util.base64.length(object.csvData)), 0);
                            else if (object.csvData.length)
                                message.csvData = object.csvData;
                        if (object.transactionList != null) {
                            if (typeof object.transactionList !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionRequest.transactionList: object expected");
                            message.transactionList = $root.palexy.streaming.v1.PosTransactionList.fromObject(object.transactionList);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportPosTransactionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.ImportPosTransactionRequest} message ImportPosTransactionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportPosTransactionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDate = "";
                            object.endDate = "";
                            object.createProductIfNotExists = false;
                            object.deleteTransactionIfExists = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                            object.preview = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        if (message.createProductIfNotExists != null && message.hasOwnProperty("createProductIfNotExists"))
                            object.createProductIfNotExists = message.createProductIfNotExists;
                        if (message.deleteTransactionIfExists != null && message.hasOwnProperty("deleteTransactionIfExists"))
                            object.deleteTransactionIfExists = message.deleteTransactionIfExists;
                        if (message.csvData != null && message.hasOwnProperty("csvData")) {
                            object.csvData = options.bytes === String ? $util.base64.encode(message.csvData, 0, message.csvData.length) : options.bytes === Array ? Array.prototype.slice.call(message.csvData) : message.csvData;
                            if (options.oneofs)
                                object.sourceData = "csvData";
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        if (message.transactionList != null && message.hasOwnProperty("transactionList")) {
                            object.transactionList = $root.palexy.streaming.v1.PosTransactionList.toObject(message.transactionList, options);
                            if (options.oneofs)
                                object.sourceData = "transactionList";
                        }
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        return object;
                    };
    
                    /**
                     * Converts this ImportPosTransactionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportPosTransactionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportPosTransactionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportPosTransactionRequest;
                })();
    
                v1.PosTransactionList = (function() {
    
                    /**
                     * Properties of a PosTransactionList.
                     * @memberof palexy.streaming.v1
                     * @interface IPosTransactionList
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [transactions] PosTransactionList transactions
                     */
    
                    /**
                     * Constructs a new PosTransactionList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosTransactionList.
                     * @implements IPosTransactionList
                     * @constructor
                     * @param {palexy.streaming.v1.IPosTransactionList=} [properties] Properties to set
                     */
                    function PosTransactionList(properties) {
                        this.transactions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosTransactionList transactions.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} transactions
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @instance
                     */
                    PosTransactionList.prototype.transactions = $util.emptyArray;
    
                    /**
                     * Creates a new PosTransactionList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosTransactionList} PosTransactionList instance
                     */
                    PosTransactionList.create = function create(properties) {
                        return new PosTransactionList(properties);
                    };
    
                    /**
                     * Encodes the specified PosTransactionList message. Does not implicitly {@link palexy.streaming.v1.PosTransactionList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionList} message PosTransactionList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.transactions != null && message.transactions.length)
                            for (var i = 0; i < message.transactions.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.transactions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosTransactionList message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosTransactionList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionList} message PosTransactionList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosTransactionList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosTransactionList} PosTransactionList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosTransactionList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.transactions && message.transactions.length))
                                    message.transactions = [];
                                message.transactions.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosTransactionList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosTransactionList} PosTransactionList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosTransactionList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosTransactionList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.transactions != null && message.hasOwnProperty("transactions")) {
                            if (!Array.isArray(message.transactions))
                                return "transactions: array expected";
                            for (var i = 0; i < message.transactions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.transactions[i]);
                                if (error)
                                    return "transactions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosTransactionList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosTransactionList} PosTransactionList
                     */
                    PosTransactionList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosTransactionList)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosTransactionList();
                        if (object.transactions) {
                            if (!Array.isArray(object.transactions))
                                throw TypeError(".palexy.streaming.v1.PosTransactionList.transactions: array expected");
                            message.transactions = [];
                            for (var i = 0; i < object.transactions.length; ++i) {
                                if (typeof object.transactions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransactionList.transactions: object expected");
                                message.transactions[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.transactions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosTransactionList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @static
                     * @param {palexy.streaming.v1.PosTransactionList} message PosTransactionList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosTransactionList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.transactions = [];
                        if (message.transactions && message.transactions.length) {
                            object.transactions = [];
                            for (var j = 0; j < message.transactions.length; ++j)
                                object.transactions[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.transactions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosTransactionList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosTransactionList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosTransactionList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosTransactionList;
                })();
    
                v1.ImportPosTransactionResponse = (function() {
    
                    /**
                     * Properties of an ImportPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IImportPosTransactionResponse
                     * @property {palexy.streaming.v1.IImportPosProductResponse|null} [importProductResponse] ImportPosTransactionResponse importProductResponse
                     * @property {palexy.streaming.v1.IImportResult|null} [transactionImportResult] ImportPosTransactionResponse transactionImportResult
                     * @property {palexy.streaming.v1.IImportResult|null} [transactionProductImportResult] ImportPosTransactionResponse transactionProductImportResult
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [previewResult] ImportPosTransactionResponse previewResult
                     * @property {palexy.streaming.v1.IImportResult|null} [posStaffImportResult] ImportPosTransactionResponse posStaffImportResult
                     */
    
                    /**
                     * Constructs a new ImportPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportPosTransactionResponse.
                     * @implements IImportPosTransactionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IImportPosTransactionResponse=} [properties] Properties to set
                     */
                    function ImportPosTransactionResponse(properties) {
                        this.previewResult = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportPosTransactionResponse importProductResponse.
                     * @member {palexy.streaming.v1.IImportPosProductResponse|null|undefined} importProductResponse
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     */
                    ImportPosTransactionResponse.prototype.importProductResponse = null;
    
                    /**
                     * ImportPosTransactionResponse transactionImportResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} transactionImportResult
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     */
                    ImportPosTransactionResponse.prototype.transactionImportResult = null;
    
                    /**
                     * ImportPosTransactionResponse transactionProductImportResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} transactionProductImportResult
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     */
                    ImportPosTransactionResponse.prototype.transactionProductImportResult = null;
    
                    /**
                     * ImportPosTransactionResponse previewResult.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} previewResult
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     */
                    ImportPosTransactionResponse.prototype.previewResult = $util.emptyArray;
    
                    /**
                     * ImportPosTransactionResponse posStaffImportResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} posStaffImportResult
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     */
                    ImportPosTransactionResponse.prototype.posStaffImportResult = null;
    
                    /**
                     * Creates a new ImportPosTransactionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportPosTransactionResponse} ImportPosTransactionResponse instance
                     */
                    ImportPosTransactionResponse.create = function create(properties) {
                        return new ImportPosTransactionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ImportPosTransactionResponse message. Does not implicitly {@link palexy.streaming.v1.ImportPosTransactionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionResponse} message ImportPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosTransactionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.importProductResponse != null && Object.hasOwnProperty.call(message, "importProductResponse"))
                            $root.palexy.streaming.v1.ImportPosProductResponse.encode(message.importProductResponse, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.transactionImportResult != null && Object.hasOwnProperty.call(message, "transactionImportResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.transactionImportResult, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.transactionProductImportResult != null && Object.hasOwnProperty.call(message, "transactionProductImportResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.transactionProductImportResult, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.previewResult != null && message.previewResult.length)
                            for (var i = 0; i < message.previewResult.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.previewResult[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.posStaffImportResult != null && Object.hasOwnProperty.call(message, "posStaffImportResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.posStaffImportResult, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportPosTransactionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportPosTransactionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportPosTransactionResponse} message ImportPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportPosTransactionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportPosTransactionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportPosTransactionResponse} ImportPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosTransactionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportPosTransactionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.importProductResponse = $root.palexy.streaming.v1.ImportPosProductResponse.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.transactionImportResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.transactionProductImportResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            case 4:
                                if (!(message.previewResult && message.previewResult.length))
                                    message.previewResult = [];
                                message.previewResult.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.posStaffImportResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportPosTransactionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportPosTransactionResponse} ImportPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportPosTransactionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportPosTransactionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportPosTransactionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.importProductResponse != null && message.hasOwnProperty("importProductResponse")) {
                            var error = $root.palexy.streaming.v1.ImportPosProductResponse.verify(message.importProductResponse);
                            if (error)
                                return "importProductResponse." + error;
                        }
                        if (message.transactionImportResult != null && message.hasOwnProperty("transactionImportResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.transactionImportResult);
                            if (error)
                                return "transactionImportResult." + error;
                        }
                        if (message.transactionProductImportResult != null && message.hasOwnProperty("transactionProductImportResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.transactionProductImportResult);
                            if (error)
                                return "transactionProductImportResult." + error;
                        }
                        if (message.previewResult != null && message.hasOwnProperty("previewResult")) {
                            if (!Array.isArray(message.previewResult))
                                return "previewResult: array expected";
                            for (var i = 0; i < message.previewResult.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.previewResult[i]);
                                if (error)
                                    return "previewResult." + error;
                            }
                        }
                        if (message.posStaffImportResult != null && message.hasOwnProperty("posStaffImportResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.posStaffImportResult);
                            if (error)
                                return "posStaffImportResult." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportPosTransactionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportPosTransactionResponse} ImportPosTransactionResponse
                     */
                    ImportPosTransactionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportPosTransactionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportPosTransactionResponse();
                        if (object.importProductResponse != null) {
                            if (typeof object.importProductResponse !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.importProductResponse: object expected");
                            message.importProductResponse = $root.palexy.streaming.v1.ImportPosProductResponse.fromObject(object.importProductResponse);
                        }
                        if (object.transactionImportResult != null) {
                            if (typeof object.transactionImportResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.transactionImportResult: object expected");
                            message.transactionImportResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.transactionImportResult);
                        }
                        if (object.transactionProductImportResult != null) {
                            if (typeof object.transactionProductImportResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.transactionProductImportResult: object expected");
                            message.transactionProductImportResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.transactionProductImportResult);
                        }
                        if (object.previewResult) {
                            if (!Array.isArray(object.previewResult))
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.previewResult: array expected");
                            message.previewResult = [];
                            for (var i = 0; i < object.previewResult.length; ++i) {
                                if (typeof object.previewResult[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.previewResult: object expected");
                                message.previewResult[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.previewResult[i]);
                            }
                        }
                        if (object.posStaffImportResult != null) {
                            if (typeof object.posStaffImportResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportPosTransactionResponse.posStaffImportResult: object expected");
                            message.posStaffImportResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.posStaffImportResult);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportPosTransactionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.ImportPosTransactionResponse} message ImportPosTransactionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportPosTransactionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.previewResult = [];
                        if (options.defaults) {
                            object.importProductResponse = null;
                            object.transactionImportResult = null;
                            object.transactionProductImportResult = null;
                            object.posStaffImportResult = null;
                        }
                        if (message.importProductResponse != null && message.hasOwnProperty("importProductResponse"))
                            object.importProductResponse = $root.palexy.streaming.v1.ImportPosProductResponse.toObject(message.importProductResponse, options);
                        if (message.transactionImportResult != null && message.hasOwnProperty("transactionImportResult"))
                            object.transactionImportResult = $root.palexy.streaming.v1.ImportResult.toObject(message.transactionImportResult, options);
                        if (message.transactionProductImportResult != null && message.hasOwnProperty("transactionProductImportResult"))
                            object.transactionProductImportResult = $root.palexy.streaming.v1.ImportResult.toObject(message.transactionProductImportResult, options);
                        if (message.previewResult && message.previewResult.length) {
                            object.previewResult = [];
                            for (var j = 0; j < message.previewResult.length; ++j)
                                object.previewResult[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.previewResult[j], options);
                        }
                        if (message.posStaffImportResult != null && message.hasOwnProperty("posStaffImportResult"))
                            object.posStaffImportResult = $root.palexy.streaming.v1.ImportResult.toObject(message.posStaffImportResult, options);
                        return object;
                    };
    
                    /**
                     * Converts this ImportPosTransactionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportPosTransactionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportPosTransactionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportPosTransactionResponse;
                })();
    
                v1.DeletePosMetadataRequest = (function() {
    
                    /**
                     * Properties of a DeletePosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeletePosMetadataRequest
                     * @property {number|null} [metadataId] DeletePosMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new DeletePosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeletePosMetadataRequest.
                     * @implements IDeletePosMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest=} [properties] Properties to set
                     */
                    function DeletePosMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeletePosMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @instance
                     */
                    DeletePosMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeletePosMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeletePosMetadataRequest} DeletePosMetadataRequest instance
                     */
                    DeletePosMetadataRequest.create = function create(properties) {
                        return new DeletePosMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeletePosMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.DeletePosMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest} message DeletePosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeletePosMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeletePosMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeletePosMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosMetadataRequest} message DeletePosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeletePosMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeletePosMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeletePosMetadataRequest} DeletePosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeletePosMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeletePosMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeletePosMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeletePosMetadataRequest} DeletePosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeletePosMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeletePosMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeletePosMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeletePosMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeletePosMetadataRequest} DeletePosMetadataRequest
                     */
                    DeletePosMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeletePosMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeletePosMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeletePosMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.DeletePosMetadataRequest} message DeletePosMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeletePosMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this DeletePosMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeletePosMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeletePosMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeletePosMetadataRequest;
                })();
    
                v1.GetPosMetadataRequest = (function() {
    
                    /**
                     * Properties of a GetPosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosMetadataRequest
                     * @property {number|null} [metadataId] GetPosMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new GetPosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosMetadataRequest.
                     * @implements IGetPosMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest=} [properties] Properties to set
                     */
                    function GetPosMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @instance
                     */
                    GetPosMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetPosMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosMetadataRequest} GetPosMetadataRequest instance
                     */
                    GetPosMetadataRequest.create = function create(properties) {
                        return new GetPosMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.GetPosMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest} message GetPosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosMetadataRequest} message GetPosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosMetadataRequest} GetPosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosMetadataRequest} GetPosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosMetadataRequest} GetPosMetadataRequest
                     */
                    GetPosMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.GetPosMetadataRequest} message GetPosMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosMetadataRequest;
                })();
    
                v1.ListPosMetadataRequest = (function() {
    
                    /**
                     * Properties of a ListPosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosMetadataRequest
                     * @property {number|null} [companyId] ListPosMetadataRequest companyId
                     * @property {string|null} [name] ListPosMetadataRequest name
                     * @property {number|null} [pageSize] ListPosMetadataRequest pageSize
                     * @property {string|null} [pageToken] ListPosMetadataRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListPosMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosMetadataRequest.
                     * @implements IListPosMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosMetadataRequest=} [properties] Properties to set
                     */
                    function ListPosMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosMetadataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @instance
                     */
                    ListPosMetadataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosMetadataRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @instance
                     */
                    ListPosMetadataRequest.prototype.name = "";
    
                    /**
                     * ListPosMetadataRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @instance
                     */
                    ListPosMetadataRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosMetadataRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @instance
                     */
                    ListPosMetadataRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListPosMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosMetadataRequest} ListPosMetadataRequest instance
                     */
                    ListPosMetadataRequest.create = function create(properties) {
                        return new ListPosMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataRequest} message ListPosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataRequest} message ListPosMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosMetadataRequest} ListPosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosMetadataRequest} ListPosMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosMetadataRequest} ListPosMetadataRequest
                     */
                    ListPosMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosMetadataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosMetadataRequest} message ListPosMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosMetadataRequest;
                })();
    
                v1.ListPosMetadataResponse = (function() {
    
                    /**
                     * Properties of a ListPosMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosMetadataResponse
                     * @property {Array.<palexy.streaming.v1.IPosMetadata>|null} [posMetadata] ListPosMetadataResponse posMetadata
                     * @property {number|null} [totalElements] ListPosMetadataResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosMetadataResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosMetadataResponse.
                     * @implements IListPosMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosMetadataResponse=} [properties] Properties to set
                     */
                    function ListPosMetadataResponse(properties) {
                        this.posMetadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosMetadataResponse posMetadata.
                     * @member {Array.<palexy.streaming.v1.IPosMetadata>} posMetadata
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @instance
                     */
                    ListPosMetadataResponse.prototype.posMetadata = $util.emptyArray;
    
                    /**
                     * ListPosMetadataResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @instance
                     */
                    ListPosMetadataResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosMetadataResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @instance
                     */
                    ListPosMetadataResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosMetadataResponse} ListPosMetadataResponse instance
                     */
                    ListPosMetadataResponse.create = function create(properties) {
                        return new ListPosMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataResponse} message ListPosMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posMetadata != null && message.posMetadata.length)
                            for (var i = 0; i < message.posMetadata.length; ++i)
                                $root.palexy.streaming.v1.PosMetadata.encode(message.posMetadata[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataResponse} message ListPosMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosMetadataResponse} ListPosMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posMetadata && message.posMetadata.length))
                                    message.posMetadata = [];
                                message.posMetadata.push($root.palexy.streaming.v1.PosMetadata.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosMetadataResponse} ListPosMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posMetadata != null && message.hasOwnProperty("posMetadata")) {
                            if (!Array.isArray(message.posMetadata))
                                return "posMetadata: array expected";
                            for (var i = 0; i < message.posMetadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosMetadata.verify(message.posMetadata[i]);
                                if (error)
                                    return "posMetadata." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosMetadataResponse} ListPosMetadataResponse
                     */
                    ListPosMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosMetadataResponse();
                        if (object.posMetadata) {
                            if (!Array.isArray(object.posMetadata))
                                throw TypeError(".palexy.streaming.v1.ListPosMetadataResponse.posMetadata: array expected");
                            message.posMetadata = [];
                            for (var i = 0; i < object.posMetadata.length; ++i) {
                                if (typeof object.posMetadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListPosMetadataResponse.posMetadata: object expected");
                                message.posMetadata[i] = $root.palexy.streaming.v1.PosMetadata.fromObject(object.posMetadata[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosMetadataResponse} message ListPosMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posMetadata = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.posMetadata && message.posMetadata.length) {
                            object.posMetadata = [];
                            for (var j = 0; j < message.posMetadata.length; ++j)
                                object.posMetadata[j] = $root.palexy.streaming.v1.PosMetadata.toObject(message.posMetadata[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosMetadataResponse;
                })();
    
                v1.ListPosMetadataValueRequest = (function() {
    
                    /**
                     * Properties of a ListPosMetadataValueRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosMetadataValueRequest
                     * @property {number|null} [metadataId] ListPosMetadataValueRequest metadataId
                     * @property {number|null} [pageSize] ListPosMetadataValueRequest pageSize
                     * @property {string|null} [pageToken] ListPosMetadataValueRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListPosMetadataValueRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosMetadataValueRequest.
                     * @implements IListPosMetadataValueRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest=} [properties] Properties to set
                     */
                    function ListPosMetadataValueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosMetadataValueRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @instance
                     */
                    ListPosMetadataValueRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosMetadataValueRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @instance
                     */
                    ListPosMetadataValueRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosMetadataValueRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @instance
                     */
                    ListPosMetadataValueRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListPosMetadataValueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosMetadataValueRequest} ListPosMetadataValueRequest instance
                     */
                    ListPosMetadataValueRequest.create = function create(properties) {
                        return new ListPosMetadataValueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataValueRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataValueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest} message ListPosMetadataValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataValueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataValueRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataValueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueRequest} message ListPosMetadataValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosMetadataValueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosMetadataValueRequest} ListPosMetadataValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataValueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosMetadataValueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosMetadataValueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosMetadataValueRequest} ListPosMetadataValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataValueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosMetadataValueRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosMetadataValueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosMetadataValueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosMetadataValueRequest} ListPosMetadataValueRequest
                     */
                    ListPosMetadataValueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosMetadataValueRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosMetadataValueRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosMetadataValueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosMetadataValueRequest} message ListPosMetadataValueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosMetadataValueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosMetadataValueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosMetadataValueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosMetadataValueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosMetadataValueRequest;
                })();
    
                v1.ListPosMetadataValueResponse = (function() {
    
                    /**
                     * Properties of a ListPosMetadataValueResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosMetadataValueResponse
                     * @property {Array.<string>|null} [values] ListPosMetadataValueResponse values
                     * @property {number|null} [totalElements] ListPosMetadataValueResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosMetadataValueResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosMetadataValueResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosMetadataValueResponse.
                     * @implements IListPosMetadataValueResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosMetadataValueResponse=} [properties] Properties to set
                     */
                    function ListPosMetadataValueResponse(properties) {
                        this.values = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosMetadataValueResponse values.
                     * @member {Array.<string>} values
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @instance
                     */
                    ListPosMetadataValueResponse.prototype.values = $util.emptyArray;
    
                    /**
                     * ListPosMetadataValueResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @instance
                     */
                    ListPosMetadataValueResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosMetadataValueResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @instance
                     */
                    ListPosMetadataValueResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosMetadataValueResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosMetadataValueResponse} ListPosMetadataValueResponse instance
                     */
                    ListPosMetadataValueResponse.create = function create(properties) {
                        return new ListPosMetadataValueResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataValueResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataValueResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueResponse} message ListPosMetadataValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataValueResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.values != null && message.values.length)
                            for (var i = 0; i < message.values.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.values[i]);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosMetadataValueResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosMetadataValueResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosMetadataValueResponse} message ListPosMetadataValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosMetadataValueResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosMetadataValueResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosMetadataValueResponse} ListPosMetadataValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataValueResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosMetadataValueResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.values && message.values.length))
                                    message.values = [];
                                message.values.push(reader.string());
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosMetadataValueResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosMetadataValueResponse} ListPosMetadataValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosMetadataValueResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosMetadataValueResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosMetadataValueResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.values != null && message.hasOwnProperty("values")) {
                            if (!Array.isArray(message.values))
                                return "values: array expected";
                            for (var i = 0; i < message.values.length; ++i)
                                if (!$util.isString(message.values[i]))
                                    return "values: string[] expected";
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosMetadataValueResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosMetadataValueResponse} ListPosMetadataValueResponse
                     */
                    ListPosMetadataValueResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosMetadataValueResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosMetadataValueResponse();
                        if (object.values) {
                            if (!Array.isArray(object.values))
                                throw TypeError(".palexy.streaming.v1.ListPosMetadataValueResponse.values: array expected");
                            message.values = [];
                            for (var i = 0; i < object.values.length; ++i)
                                message.values[i] = String(object.values[i]);
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosMetadataValueResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosMetadataValueResponse} message ListPosMetadataValueResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosMetadataValueResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.values = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.values && message.values.length) {
                            object.values = [];
                            for (var j = 0; j < message.values.length; ++j)
                                object.values[j] = message.values[j];
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosMetadataValueResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosMetadataValueResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosMetadataValueResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosMetadataValueResponse;
                })();
    
                v1.PosProduct = (function() {
    
                    /**
                     * Properties of a PosProduct.
                     * @memberof palexy.streaming.v1
                     * @interface IPosProduct
                     * @property {number|null} [id] PosProduct id
                     * @property {number|null} [companyId] PosProduct companyId
                     * @property {string|null} [name] PosProduct name
                     * @property {string|null} [code] PosProduct code
                     * @property {string|null} [description] PosProduct description
                     * @property {number|null} [createTimeMs] PosProduct createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosProduct lastUpdateTimeMs
                     * @property {Array.<palexy.streaming.v1.IPosProductMetadata>|null} [metadata] PosProduct metadata
                     */
    
                    /**
                     * Constructs a new PosProduct.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosProduct.
                     * @implements IPosProduct
                     * @constructor
                     * @param {palexy.streaming.v1.IPosProduct=} [properties] Properties to set
                     */
                    function PosProduct(properties) {
                        this.metadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosProduct id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosProduct companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosProduct name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.name = "";
    
                    /**
                     * PosProduct code.
                     * @member {string} code
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.code = "";
    
                    /**
                     * PosProduct description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.description = "";
    
                    /**
                     * PosProduct createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosProduct lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosProduct metadata.
                     * @member {Array.<palexy.streaming.v1.IPosProductMetadata>} metadata
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     */
                    PosProduct.prototype.metadata = $util.emptyArray;
    
                    /**
                     * Creates a new PosProduct instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosProduct=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosProduct} PosProduct instance
                     */
                    PosProduct.create = function create(properties) {
                        return new PosProduct(properties);
                    };
    
                    /**
                     * Encodes the specified PosProduct message. Does not implicitly {@link palexy.streaming.v1.PosProduct.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosProduct} message PosProduct message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProduct.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.code);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.metadata != null && message.metadata.length)
                            for (var i = 0; i < message.metadata.length; ++i)
                                $root.palexy.streaming.v1.PosProductMetadata.encode(message.metadata[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosProduct message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosProduct.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosProduct} message PosProduct message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProduct.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosProduct message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosProduct} PosProduct
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProduct.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosProduct();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.code = reader.string();
                                break;
                            case 5:
                                message.description = reader.string();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                if (!(message.metadata && message.metadata.length))
                                    message.metadata = [];
                                message.metadata.push($root.palexy.streaming.v1.PosProductMetadata.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosProduct message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosProduct} PosProduct
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProduct.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosProduct message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosProduct.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.metadata != null && message.hasOwnProperty("metadata")) {
                            if (!Array.isArray(message.metadata))
                                return "metadata: array expected";
                            for (var i = 0; i < message.metadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosProductMetadata.verify(message.metadata[i]);
                                if (error)
                                    return "metadata." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosProduct message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosProduct} PosProduct
                     */
                    PosProduct.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosProduct)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosProduct();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.code != null)
                            message.code = String(object.code);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.metadata) {
                            if (!Array.isArray(object.metadata))
                                throw TypeError(".palexy.streaming.v1.PosProduct.metadata: array expected");
                            message.metadata = [];
                            for (var i = 0; i < object.metadata.length; ++i) {
                                if (typeof object.metadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosProduct.metadata: object expected");
                                message.metadata[i] = $root.palexy.streaming.v1.PosProductMetadata.fromObject(object.metadata[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosProduct message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosProduct
                     * @static
                     * @param {palexy.streaming.v1.PosProduct} message PosProduct
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosProduct.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.metadata = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.code = "";
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.metadata && message.metadata.length) {
                            object.metadata = [];
                            for (var j = 0; j < message.metadata.length; ++j)
                                object.metadata[j] = $root.palexy.streaming.v1.PosProductMetadata.toObject(message.metadata[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosProduct to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosProduct
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosProduct.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosProduct;
                })();
    
                v1.PosMetadata = (function() {
    
                    /**
                     * Properties of a PosMetadata.
                     * @memberof palexy.streaming.v1
                     * @interface IPosMetadata
                     * @property {number|null} [id] PosMetadata id
                     * @property {number|null} [companyId] PosMetadata companyId
                     * @property {string|null} [name] PosMetadata name
                     * @property {string|null} [description] PosMetadata description
                     * @property {palexy.streaming.v1.PosMetadata.DataType|null} [dataType] PosMetadata dataType
                     * @property {number|null} [createTimeMs] PosMetadata createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosMetadata lastUpdateTimeMs
                     * @property {number|null} [dimensionIndex] PosMetadata dimensionIndex
                     */
    
                    /**
                     * Constructs a new PosMetadata.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosMetadata.
                     * @implements IPosMetadata
                     * @constructor
                     * @param {palexy.streaming.v1.IPosMetadata=} [properties] Properties to set
                     */
                    function PosMetadata(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosMetadata id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMetadata companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMetadata name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.name = "";
    
                    /**
                     * PosMetadata description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.description = "";
    
                    /**
                     * PosMetadata dataType.
                     * @member {palexy.streaming.v1.PosMetadata.DataType} dataType
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.dataType = 0;
    
                    /**
                     * PosMetadata createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMetadata lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMetadata dimensionIndex.
                     * @member {number} dimensionIndex
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     */
                    PosMetadata.prototype.dimensionIndex = 0;
    
                    /**
                     * Creates a new PosMetadata instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosMetadata=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosMetadata} PosMetadata instance
                     */
                    PosMetadata.create = function create(properties) {
                        return new PosMetadata(properties);
                    };
    
                    /**
                     * Encodes the specified PosMetadata message. Does not implicitly {@link palexy.streaming.v1.PosMetadata.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosMetadata} message PosMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosMetadata.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.dataType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.dimensionIndex != null && Object.hasOwnProperty.call(message, "dimensionIndex"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.dimensionIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosMetadata.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosMetadata} message PosMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosMetadata message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosMetadata} PosMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosMetadata.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosMetadata();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 5:
                                message.dataType = reader.int32();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.dimensionIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosMetadata message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosMetadata} PosMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosMetadata.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosMetadata message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosMetadata.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            switch (message.dataType) {
                            default:
                                return "dataType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            if (!$util.isInteger(message.dimensionIndex))
                                return "dimensionIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosMetadata message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosMetadata} PosMetadata
                     */
                    PosMetadata.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosMetadata)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosMetadata();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        switch (object.dataType) {
                        case "DATA_TYPE_UNKNOWN":
                        case 0:
                            message.dataType = 0;
                            break;
                        case "TEXT":
                        case 1:
                            message.dataType = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.dimensionIndex != null)
                            message.dimensionIndex = object.dimensionIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosMetadata message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @static
                     * @param {palexy.streaming.v1.PosMetadata} message PosMetadata
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosMetadata.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            object.dataType = options.enums === String ? "DATA_TYPE_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.dimensionIndex = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            object.dataType = options.enums === String ? $root.palexy.streaming.v1.PosMetadata.DataType[message.dataType] : message.dataType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            object.dimensionIndex = message.dimensionIndex;
                        return object;
                    };
    
                    /**
                     * Converts this PosMetadata to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosMetadata
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosMetadata.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * DataType enum.
                     * @name palexy.streaming.v1.PosMetadata.DataType
                     * @enum {number}
                     * @property {number} DATA_TYPE_UNKNOWN=0 DATA_TYPE_UNKNOWN value
                     * @property {number} TEXT=1 TEXT value
                     */
                    PosMetadata.DataType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DATA_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "TEXT"] = 1;
                        return values;
                    })();
    
                    return PosMetadata;
                })();
    
                v1.PosProductMetadata = (function() {
    
                    /**
                     * Properties of a PosProductMetadata.
                     * @memberof palexy.streaming.v1
                     * @interface IPosProductMetadata
                     * @property {string|null} [metadataName] PosProductMetadata metadataName
                     * @property {string|null} [metadataValue] PosProductMetadata metadataValue
                     * @property {number|null} [metadataId] PosProductMetadata metadataId
                     */
    
                    /**
                     * Constructs a new PosProductMetadata.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosProductMetadata.
                     * @implements IPosProductMetadata
                     * @constructor
                     * @param {palexy.streaming.v1.IPosProductMetadata=} [properties] Properties to set
                     */
                    function PosProductMetadata(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosProductMetadata metadataName.
                     * @member {string} metadataName
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @instance
                     */
                    PosProductMetadata.prototype.metadataName = "";
    
                    /**
                     * PosProductMetadata metadataValue.
                     * @member {string} metadataValue
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @instance
                     */
                    PosProductMetadata.prototype.metadataValue = "";
    
                    /**
                     * PosProductMetadata metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @instance
                     */
                    PosProductMetadata.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new PosProductMetadata instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosProductMetadata=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosProductMetadata} PosProductMetadata instance
                     */
                    PosProductMetadata.create = function create(properties) {
                        return new PosProductMetadata(properties);
                    };
    
                    /**
                     * Encodes the specified PosProductMetadata message. Does not implicitly {@link palexy.streaming.v1.PosProductMetadata.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosProductMetadata} message PosProductMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProductMetadata.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataName != null && Object.hasOwnProperty.call(message, "metadataName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.metadataName);
                        if (message.metadataValue != null && Object.hasOwnProperty.call(message, "metadataValue"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataValue);
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosProductMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosProductMetadata.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosProductMetadata} message PosProductMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosProductMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosProductMetadata message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosProductMetadata} PosProductMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProductMetadata.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosProductMetadata();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataName = reader.string();
                                break;
                            case 2:
                                message.metadataValue = reader.string();
                                break;
                            case 3:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosProductMetadata message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosProductMetadata} PosProductMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosProductMetadata.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosProductMetadata message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosProductMetadata.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                            if (!$util.isString(message.metadataName))
                                return "metadataName: string expected";
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            if (!$util.isString(message.metadataValue))
                                return "metadataValue: string expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosProductMetadata message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosProductMetadata} PosProductMetadata
                     */
                    PosProductMetadata.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosProductMetadata)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosProductMetadata();
                        if (object.metadataName != null)
                            message.metadataName = String(object.metadataName);
                        if (object.metadataValue != null)
                            message.metadataValue = String(object.metadataValue);
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosProductMetadata message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @static
                     * @param {palexy.streaming.v1.PosProductMetadata} message PosProductMetadata
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosProductMetadata.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.metadataName = "";
                            object.metadataValue = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        }
                        if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                            object.metadataName = message.metadataName;
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            object.metadataValue = message.metadataValue;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this PosProductMetadata to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosProductMetadata
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosProductMetadata.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosProductMetadata;
                })();
    
                v1.PosTransaction = (function() {
    
                    /**
                     * Properties of a PosTransaction.
                     * @memberof palexy.streaming.v1
                     * @interface IPosTransaction
                     * @property {number|null} [id] PosTransaction id
                     * @property {number|null} [storeId] PosTransaction storeId
                     * @property {number|null} [dateId] PosTransaction dateId
                     * @property {number|null} [ownerId] PosTransaction ownerId
                     * @property {string|null} [tranid] PosTransaction tranid
                     * @property {string|null} [currency] PosTransaction currency
                     * @property {string|null} [transactionTime] PosTransaction transactionTime
                     * @property {number|null} [insertedDateTimeMs] PosTransaction insertedDateTimeMs
                     * @property {string|null} [membershipCard] PosTransaction membershipCard
                     * @property {string|null} [externalCustomerId] PosTransaction externalCustomerId
                     * @property {string|null} [terminalId] PosTransaction terminalId
                     * @property {string|null} [salesStaffId] PosTransaction salesStaffId
                     * @property {Object.<string,string>|null} [additionalProperties] PosTransaction additionalProperties
                     * @property {Array.<palexy.streaming.v1.IPosTransactionProduct>|null} [products] PosTransaction products
                     * @property {Array.<palexy.streaming.v1.IPosCustomerTransaction>|null} [customers] PosTransaction customers
                     * @property {Array.<palexy.streaming.v1.IStaff>|null} [staffs] PosTransaction staffs
                     * @property {Array.<string>|null} [posExternalStaffIds] PosTransaction posExternalStaffIds
                     * @property {string|null} [transactionType] PosTransaction transactionType
                     * @property {Array.<palexy.streaming.v1.IPosTransactionMetadataValue>|null} [transactionMetadataValues] PosTransaction transactionMetadataValues
                     */
    
                    /**
                     * Constructs a new PosTransaction.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosTransaction.
                     * @implements IPosTransaction
                     * @constructor
                     * @param {palexy.streaming.v1.IPosTransaction=} [properties] Properties to set
                     */
                    function PosTransaction(properties) {
                        this.additionalProperties = {};
                        this.products = [];
                        this.customers = [];
                        this.staffs = [];
                        this.posExternalStaffIds = [];
                        this.transactionMetadataValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosTransaction id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransaction storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransaction dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.dateId = 0;
    
                    /**
                     * PosTransaction ownerId.
                     * @member {number} ownerId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.ownerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransaction tranid.
                     * @member {string} tranid
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.tranid = "";
    
                    /**
                     * PosTransaction currency.
                     * @member {string} currency
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.currency = "";
    
                    /**
                     * PosTransaction transactionTime.
                     * @member {string} transactionTime
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.transactionTime = "";
    
                    /**
                     * PosTransaction insertedDateTimeMs.
                     * @member {number} insertedDateTimeMs
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.insertedDateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransaction membershipCard.
                     * @member {string} membershipCard
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.membershipCard = "";
    
                    /**
                     * PosTransaction externalCustomerId.
                     * @member {string} externalCustomerId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.externalCustomerId = "";
    
                    /**
                     * PosTransaction terminalId.
                     * @member {string} terminalId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.terminalId = "";
    
                    /**
                     * PosTransaction salesStaffId.
                     * @member {string} salesStaffId
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.salesStaffId = "";
    
                    /**
                     * PosTransaction additionalProperties.
                     * @member {Object.<string,string>} additionalProperties
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.additionalProperties = $util.emptyObject;
    
                    /**
                     * PosTransaction products.
                     * @member {Array.<palexy.streaming.v1.IPosTransactionProduct>} products
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.products = $util.emptyArray;
    
                    /**
                     * PosTransaction customers.
                     * @member {Array.<palexy.streaming.v1.IPosCustomerTransaction>} customers
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.customers = $util.emptyArray;
    
                    /**
                     * PosTransaction staffs.
                     * @member {Array.<palexy.streaming.v1.IStaff>} staffs
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.staffs = $util.emptyArray;
    
                    /**
                     * PosTransaction posExternalStaffIds.
                     * @member {Array.<string>} posExternalStaffIds
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.posExternalStaffIds = $util.emptyArray;
    
                    /**
                     * PosTransaction transactionType.
                     * @member {string} transactionType
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.transactionType = "";
    
                    /**
                     * PosTransaction transactionMetadataValues.
                     * @member {Array.<palexy.streaming.v1.IPosTransactionMetadataValue>} transactionMetadataValues
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     */
                    PosTransaction.prototype.transactionMetadataValues = $util.emptyArray;
    
                    /**
                     * Creates a new PosTransaction instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosTransaction=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosTransaction} PosTransaction instance
                     */
                    PosTransaction.create = function create(properties) {
                        return new PosTransaction(properties);
                    };
    
                    /**
                     * Encodes the specified PosTransaction message. Does not implicitly {@link palexy.streaming.v1.PosTransaction.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosTransaction} message PosTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransaction.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.ownerId != null && Object.hasOwnProperty.call(message, "ownerId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.ownerId);
                        if (message.tranid != null && Object.hasOwnProperty.call(message, "tranid"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.tranid);
                        if (message.currency != null && Object.hasOwnProperty.call(message, "currency"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.currency);
                        if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.transactionTime);
                        if (message.insertedDateTimeMs != null && Object.hasOwnProperty.call(message, "insertedDateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.insertedDateTimeMs);
                        if (message.products != null && message.products.length)
                            for (var i = 0; i < message.products.length; ++i)
                                $root.palexy.streaming.v1.PosTransactionProduct.encode(message.products[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.customers != null && message.customers.length)
                            for (var i = 0; i < message.customers.length; ++i)
                                $root.palexy.streaming.v1.PosCustomerTransaction.encode(message.customers[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.membershipCard != null && Object.hasOwnProperty.call(message, "membershipCard"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.membershipCard);
                        if (message.externalCustomerId != null && Object.hasOwnProperty.call(message, "externalCustomerId"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.externalCustomerId);
                        if (message.terminalId != null && Object.hasOwnProperty.call(message, "terminalId"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.terminalId);
                        if (message.salesStaffId != null && Object.hasOwnProperty.call(message, "salesStaffId"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.salesStaffId);
                        if (message.additionalProperties != null && Object.hasOwnProperty.call(message, "additionalProperties"))
                            for (var keys = Object.keys(message.additionalProperties), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 15, wireType 2 =*/122).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalProperties[keys[i]]).ldelim();
                        if (message.staffs != null && message.staffs.length)
                            for (var i = 0; i < message.staffs.length; ++i)
                                $root.palexy.streaming.v1.Staff.encode(message.staffs[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.posExternalStaffIds != null && message.posExternalStaffIds.length)
                            for (var i = 0; i < message.posExternalStaffIds.length; ++i)
                                writer.uint32(/* id 17, wireType 2 =*/138).string(message.posExternalStaffIds[i]);
                        if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
                            writer.uint32(/* id 18, wireType 2 =*/146).string(message.transactionType);
                        if (message.transactionMetadataValues != null && message.transactionMetadataValues.length)
                            for (var i = 0; i < message.transactionMetadataValues.length; ++i)
                                $root.palexy.streaming.v1.PosTransactionMetadataValue.encode(message.transactionMetadataValues[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosTransaction message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosTransaction.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosTransaction} message PosTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransaction.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosTransaction message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosTransaction} PosTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransaction.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosTransaction(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.ownerId = reader.int64();
                                break;
                            case 5:
                                message.tranid = reader.string();
                                break;
                            case 6:
                                message.currency = reader.string();
                                break;
                            case 7:
                                message.transactionTime = reader.string();
                                break;
                            case 8:
                                message.insertedDateTimeMs = reader.int64();
                                break;
                            case 11:
                                message.membershipCard = reader.string();
                                break;
                            case 12:
                                message.externalCustomerId = reader.string();
                                break;
                            case 13:
                                message.terminalId = reader.string();
                                break;
                            case 14:
                                message.salesStaffId = reader.string();
                                break;
                            case 15:
                                if (message.additionalProperties === $util.emptyObject)
                                    message.additionalProperties = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.additionalProperties[key] = value;
                                break;
                            case 9:
                                if (!(message.products && message.products.length))
                                    message.products = [];
                                message.products.push($root.palexy.streaming.v1.PosTransactionProduct.decode(reader, reader.uint32()));
                                break;
                            case 10:
                                if (!(message.customers && message.customers.length))
                                    message.customers = [];
                                message.customers.push($root.palexy.streaming.v1.PosCustomerTransaction.decode(reader, reader.uint32()));
                                break;
                            case 16:
                                if (!(message.staffs && message.staffs.length))
                                    message.staffs = [];
                                message.staffs.push($root.palexy.streaming.v1.Staff.decode(reader, reader.uint32()));
                                break;
                            case 17:
                                if (!(message.posExternalStaffIds && message.posExternalStaffIds.length))
                                    message.posExternalStaffIds = [];
                                message.posExternalStaffIds.push(reader.string());
                                break;
                            case 18:
                                message.transactionType = reader.string();
                                break;
                            case 19:
                                if (!(message.transactionMetadataValues && message.transactionMetadataValues.length))
                                    message.transactionMetadataValues = [];
                                message.transactionMetadataValues.push($root.palexy.streaming.v1.PosTransactionMetadataValue.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosTransaction message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosTransaction} PosTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransaction.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosTransaction message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosTransaction.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (!$util.isInteger(message.ownerId) && !(message.ownerId && $util.isInteger(message.ownerId.low) && $util.isInteger(message.ownerId.high)))
                                return "ownerId: integer|Long expected";
                        if (message.tranid != null && message.hasOwnProperty("tranid"))
                            if (!$util.isString(message.tranid))
                                return "tranid: string expected";
                        if (message.currency != null && message.hasOwnProperty("currency"))
                            if (!$util.isString(message.currency))
                                return "currency: string expected";
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
                            if (!$util.isString(message.transactionTime))
                                return "transactionTime: string expected";
                        if (message.insertedDateTimeMs != null && message.hasOwnProperty("insertedDateTimeMs"))
                            if (!$util.isInteger(message.insertedDateTimeMs) && !(message.insertedDateTimeMs && $util.isInteger(message.insertedDateTimeMs.low) && $util.isInteger(message.insertedDateTimeMs.high)))
                                return "insertedDateTimeMs: integer|Long expected";
                        if (message.membershipCard != null && message.hasOwnProperty("membershipCard"))
                            if (!$util.isString(message.membershipCard))
                                return "membershipCard: string expected";
                        if (message.externalCustomerId != null && message.hasOwnProperty("externalCustomerId"))
                            if (!$util.isString(message.externalCustomerId))
                                return "externalCustomerId: string expected";
                        if (message.terminalId != null && message.hasOwnProperty("terminalId"))
                            if (!$util.isString(message.terminalId))
                                return "terminalId: string expected";
                        if (message.salesStaffId != null && message.hasOwnProperty("salesStaffId"))
                            if (!$util.isString(message.salesStaffId))
                                return "salesStaffId: string expected";
                        if (message.additionalProperties != null && message.hasOwnProperty("additionalProperties")) {
                            if (!$util.isObject(message.additionalProperties))
                                return "additionalProperties: object expected";
                            var key = Object.keys(message.additionalProperties);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.additionalProperties[key[i]]))
                                    return "additionalProperties: string{k:string} expected";
                        }
                        if (message.products != null && message.hasOwnProperty("products")) {
                            if (!Array.isArray(message.products))
                                return "products: array expected";
                            for (var i = 0; i < message.products.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransactionProduct.verify(message.products[i]);
                                if (error)
                                    return "products." + error;
                            }
                        }
                        if (message.customers != null && message.hasOwnProperty("customers")) {
                            if (!Array.isArray(message.customers))
                                return "customers: array expected";
                            for (var i = 0; i < message.customers.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosCustomerTransaction.verify(message.customers[i]);
                                if (error)
                                    return "customers." + error;
                            }
                        }
                        if (message.staffs != null && message.hasOwnProperty("staffs")) {
                            if (!Array.isArray(message.staffs))
                                return "staffs: array expected";
                            for (var i = 0; i < message.staffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.Staff.verify(message.staffs[i]);
                                if (error)
                                    return "staffs." + error;
                            }
                        }
                        if (message.posExternalStaffIds != null && message.hasOwnProperty("posExternalStaffIds")) {
                            if (!Array.isArray(message.posExternalStaffIds))
                                return "posExternalStaffIds: array expected";
                            for (var i = 0; i < message.posExternalStaffIds.length; ++i)
                                if (!$util.isString(message.posExternalStaffIds[i]))
                                    return "posExternalStaffIds: string[] expected";
                        }
                        if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                            if (!$util.isString(message.transactionType))
                                return "transactionType: string expected";
                        if (message.transactionMetadataValues != null && message.hasOwnProperty("transactionMetadataValues")) {
                            if (!Array.isArray(message.transactionMetadataValues))
                                return "transactionMetadataValues: array expected";
                            for (var i = 0; i < message.transactionMetadataValues.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransactionMetadataValue.verify(message.transactionMetadataValues[i]);
                                if (error)
                                    return "transactionMetadataValues." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosTransaction message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosTransaction} PosTransaction
                     */
                    PosTransaction.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosTransaction)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosTransaction();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.ownerId != null)
                            if ($util.Long)
                                (message.ownerId = $util.Long.fromValue(object.ownerId)).unsigned = false;
                            else if (typeof object.ownerId === "string")
                                message.ownerId = parseInt(object.ownerId, 10);
                            else if (typeof object.ownerId === "number")
                                message.ownerId = object.ownerId;
                            else if (typeof object.ownerId === "object")
                                message.ownerId = new $util.LongBits(object.ownerId.low >>> 0, object.ownerId.high >>> 0).toNumber();
                        if (object.tranid != null)
                            message.tranid = String(object.tranid);
                        if (object.currency != null)
                            message.currency = String(object.currency);
                        if (object.transactionTime != null)
                            message.transactionTime = String(object.transactionTime);
                        if (object.insertedDateTimeMs != null)
                            if ($util.Long)
                                (message.insertedDateTimeMs = $util.Long.fromValue(object.insertedDateTimeMs)).unsigned = false;
                            else if (typeof object.insertedDateTimeMs === "string")
                                message.insertedDateTimeMs = parseInt(object.insertedDateTimeMs, 10);
                            else if (typeof object.insertedDateTimeMs === "number")
                                message.insertedDateTimeMs = object.insertedDateTimeMs;
                            else if (typeof object.insertedDateTimeMs === "object")
                                message.insertedDateTimeMs = new $util.LongBits(object.insertedDateTimeMs.low >>> 0, object.insertedDateTimeMs.high >>> 0).toNumber();
                        if (object.membershipCard != null)
                            message.membershipCard = String(object.membershipCard);
                        if (object.externalCustomerId != null)
                            message.externalCustomerId = String(object.externalCustomerId);
                        if (object.terminalId != null)
                            message.terminalId = String(object.terminalId);
                        if (object.salesStaffId != null)
                            message.salesStaffId = String(object.salesStaffId);
                        if (object.additionalProperties) {
                            if (typeof object.additionalProperties !== "object")
                                throw TypeError(".palexy.streaming.v1.PosTransaction.additionalProperties: object expected");
                            message.additionalProperties = {};
                            for (var keys = Object.keys(object.additionalProperties), i = 0; i < keys.length; ++i)
                                message.additionalProperties[keys[i]] = String(object.additionalProperties[keys[i]]);
                        }
                        if (object.products) {
                            if (!Array.isArray(object.products))
                                throw TypeError(".palexy.streaming.v1.PosTransaction.products: array expected");
                            message.products = [];
                            for (var i = 0; i < object.products.length; ++i) {
                                if (typeof object.products[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransaction.products: object expected");
                                message.products[i] = $root.palexy.streaming.v1.PosTransactionProduct.fromObject(object.products[i]);
                            }
                        }
                        if (object.customers) {
                            if (!Array.isArray(object.customers))
                                throw TypeError(".palexy.streaming.v1.PosTransaction.customers: array expected");
                            message.customers = [];
                            for (var i = 0; i < object.customers.length; ++i) {
                                if (typeof object.customers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransaction.customers: object expected");
                                message.customers[i] = $root.palexy.streaming.v1.PosCustomerTransaction.fromObject(object.customers[i]);
                            }
                        }
                        if (object.staffs) {
                            if (!Array.isArray(object.staffs))
                                throw TypeError(".palexy.streaming.v1.PosTransaction.staffs: array expected");
                            message.staffs = [];
                            for (var i = 0; i < object.staffs.length; ++i) {
                                if (typeof object.staffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransaction.staffs: object expected");
                                message.staffs[i] = $root.palexy.streaming.v1.Staff.fromObject(object.staffs[i]);
                            }
                        }
                        if (object.posExternalStaffIds) {
                            if (!Array.isArray(object.posExternalStaffIds))
                                throw TypeError(".palexy.streaming.v1.PosTransaction.posExternalStaffIds: array expected");
                            message.posExternalStaffIds = [];
                            for (var i = 0; i < object.posExternalStaffIds.length; ++i)
                                message.posExternalStaffIds[i] = String(object.posExternalStaffIds[i]);
                        }
                        if (object.transactionType != null)
                            message.transactionType = String(object.transactionType);
                        if (object.transactionMetadataValues) {
                            if (!Array.isArray(object.transactionMetadataValues))
                                throw TypeError(".palexy.streaming.v1.PosTransaction.transactionMetadataValues: array expected");
                            message.transactionMetadataValues = [];
                            for (var i = 0; i < object.transactionMetadataValues.length; ++i) {
                                if (typeof object.transactionMetadataValues[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransaction.transactionMetadataValues: object expected");
                                message.transactionMetadataValues[i] = $root.palexy.streaming.v1.PosTransactionMetadataValue.fromObject(object.transactionMetadataValues[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosTransaction message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @static
                     * @param {palexy.streaming.v1.PosTransaction} message PosTransaction
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosTransaction.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.products = [];
                            object.customers = [];
                            object.staffs = [];
                            object.posExternalStaffIds = [];
                            object.transactionMetadataValues = [];
                        }
                        if (options.objects || options.defaults)
                            object.additionalProperties = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.ownerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.ownerId = options.longs === String ? "0" : 0;
                            object.tranid = "";
                            object.currency = "";
                            object.transactionTime = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.insertedDateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.insertedDateTimeMs = options.longs === String ? "0" : 0;
                            object.membershipCard = "";
                            object.externalCustomerId = "";
                            object.terminalId = "";
                            object.salesStaffId = "";
                            object.transactionType = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.ownerId != null && message.hasOwnProperty("ownerId"))
                            if (typeof message.ownerId === "number")
                                object.ownerId = options.longs === String ? String(message.ownerId) : message.ownerId;
                            else
                                object.ownerId = options.longs === String ? $util.Long.prototype.toString.call(message.ownerId) : options.longs === Number ? new $util.LongBits(message.ownerId.low >>> 0, message.ownerId.high >>> 0).toNumber() : message.ownerId;
                        if (message.tranid != null && message.hasOwnProperty("tranid"))
                            object.tranid = message.tranid;
                        if (message.currency != null && message.hasOwnProperty("currency"))
                            object.currency = message.currency;
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
                            object.transactionTime = message.transactionTime;
                        if (message.insertedDateTimeMs != null && message.hasOwnProperty("insertedDateTimeMs"))
                            if (typeof message.insertedDateTimeMs === "number")
                                object.insertedDateTimeMs = options.longs === String ? String(message.insertedDateTimeMs) : message.insertedDateTimeMs;
                            else
                                object.insertedDateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.insertedDateTimeMs) : options.longs === Number ? new $util.LongBits(message.insertedDateTimeMs.low >>> 0, message.insertedDateTimeMs.high >>> 0).toNumber() : message.insertedDateTimeMs;
                        if (message.products && message.products.length) {
                            object.products = [];
                            for (var j = 0; j < message.products.length; ++j)
                                object.products[j] = $root.palexy.streaming.v1.PosTransactionProduct.toObject(message.products[j], options);
                        }
                        if (message.customers && message.customers.length) {
                            object.customers = [];
                            for (var j = 0; j < message.customers.length; ++j)
                                object.customers[j] = $root.palexy.streaming.v1.PosCustomerTransaction.toObject(message.customers[j], options);
                        }
                        if (message.membershipCard != null && message.hasOwnProperty("membershipCard"))
                            object.membershipCard = message.membershipCard;
                        if (message.externalCustomerId != null && message.hasOwnProperty("externalCustomerId"))
                            object.externalCustomerId = message.externalCustomerId;
                        if (message.terminalId != null && message.hasOwnProperty("terminalId"))
                            object.terminalId = message.terminalId;
                        if (message.salesStaffId != null && message.hasOwnProperty("salesStaffId"))
                            object.salesStaffId = message.salesStaffId;
                        var keys2;
                        if (message.additionalProperties && (keys2 = Object.keys(message.additionalProperties)).length) {
                            object.additionalProperties = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.additionalProperties[keys2[j]] = message.additionalProperties[keys2[j]];
                        }
                        if (message.staffs && message.staffs.length) {
                            object.staffs = [];
                            for (var j = 0; j < message.staffs.length; ++j)
                                object.staffs[j] = $root.palexy.streaming.v1.Staff.toObject(message.staffs[j], options);
                        }
                        if (message.posExternalStaffIds && message.posExternalStaffIds.length) {
                            object.posExternalStaffIds = [];
                            for (var j = 0; j < message.posExternalStaffIds.length; ++j)
                                object.posExternalStaffIds[j] = message.posExternalStaffIds[j];
                        }
                        if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                            object.transactionType = message.transactionType;
                        if (message.transactionMetadataValues && message.transactionMetadataValues.length) {
                            object.transactionMetadataValues = [];
                            for (var j = 0; j < message.transactionMetadataValues.length; ++j)
                                object.transactionMetadataValues[j] = $root.palexy.streaming.v1.PosTransactionMetadataValue.toObject(message.transactionMetadataValues[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosTransaction to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosTransaction
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosTransaction.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosTransaction;
                })();
    
                v1.PosTransactionMetadata = (function() {
    
                    /**
                     * Properties of a PosTransactionMetadata.
                     * @memberof palexy.streaming.v1
                     * @interface IPosTransactionMetadata
                     * @property {number|null} [id] PosTransactionMetadata id
                     * @property {number|null} [companyId] PosTransactionMetadata companyId
                     * @property {string|null} [name] PosTransactionMetadata name
                     * @property {string|null} [description] PosTransactionMetadata description
                     * @property {palexy.streaming.v1.PosTransactionMetadata.DataType|null} [dataType] PosTransactionMetadata dataType
                     * @property {number|null} [createTimeMs] PosTransactionMetadata createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosTransactionMetadata lastUpdateTimeMs
                     * @property {number|null} [dimensionIndex] PosTransactionMetadata dimensionIndex
                     */
    
                    /**
                     * Constructs a new PosTransactionMetadata.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosTransactionMetadata.
                     * @implements IPosTransactionMetadata
                     * @constructor
                     * @param {palexy.streaming.v1.IPosTransactionMetadata=} [properties] Properties to set
                     */
                    function PosTransactionMetadata(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosTransactionMetadata id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransactionMetadata companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransactionMetadata name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.name = "";
    
                    /**
                     * PosTransactionMetadata description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.description = "";
    
                    /**
                     * PosTransactionMetadata dataType.
                     * @member {palexy.streaming.v1.PosTransactionMetadata.DataType} dataType
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.dataType = 0;
    
                    /**
                     * PosTransactionMetadata createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransactionMetadata lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransactionMetadata dimensionIndex.
                     * @member {number} dimensionIndex
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     */
                    PosTransactionMetadata.prototype.dimensionIndex = 0;
    
                    /**
                     * Creates a new PosTransactionMetadata instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadata=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosTransactionMetadata} PosTransactionMetadata instance
                     */
                    PosTransactionMetadata.create = function create(properties) {
                        return new PosTransactionMetadata(properties);
                    };
    
                    /**
                     * Encodes the specified PosTransactionMetadata message. Does not implicitly {@link palexy.streaming.v1.PosTransactionMetadata.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} message PosTransactionMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionMetadata.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.dataType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.dimensionIndex != null && Object.hasOwnProperty.call(message, "dimensionIndex"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.dimensionIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosTransactionMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosTransactionMetadata.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadata} message PosTransactionMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosTransactionMetadata message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosTransactionMetadata} PosTransactionMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionMetadata.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosTransactionMetadata();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 5:
                                message.dataType = reader.int32();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.dimensionIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosTransactionMetadata message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosTransactionMetadata} PosTransactionMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionMetadata.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosTransactionMetadata message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosTransactionMetadata.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            switch (message.dataType) {
                            default:
                                return "dataType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            if (!$util.isInteger(message.dimensionIndex))
                                return "dimensionIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosTransactionMetadata message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosTransactionMetadata} PosTransactionMetadata
                     */
                    PosTransactionMetadata.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosTransactionMetadata)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosTransactionMetadata();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        switch (object.dataType) {
                        case "DATA_TYPE_UNKNOWN":
                        case 0:
                            message.dataType = 0;
                            break;
                        case "TEXT":
                        case 1:
                            message.dataType = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.dimensionIndex != null)
                            message.dimensionIndex = object.dimensionIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosTransactionMetadata message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @static
                     * @param {palexy.streaming.v1.PosTransactionMetadata} message PosTransactionMetadata
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosTransactionMetadata.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            object.dataType = options.enums === String ? "DATA_TYPE_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.dimensionIndex = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            object.dataType = options.enums === String ? $root.palexy.streaming.v1.PosTransactionMetadata.DataType[message.dataType] : message.dataType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            object.dimensionIndex = message.dimensionIndex;
                        return object;
                    };
    
                    /**
                     * Converts this PosTransactionMetadata to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosTransactionMetadata
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosTransactionMetadata.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * DataType enum.
                     * @name palexy.streaming.v1.PosTransactionMetadata.DataType
                     * @enum {number}
                     * @property {number} DATA_TYPE_UNKNOWN=0 DATA_TYPE_UNKNOWN value
                     * @property {number} TEXT=1 TEXT value
                     */
                    PosTransactionMetadata.DataType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DATA_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "TEXT"] = 1;
                        return values;
                    })();
    
                    return PosTransactionMetadata;
                })();
    
                v1.PosTransactionMetadataValue = (function() {
    
                    /**
                     * Properties of a PosTransactionMetadataValue.
                     * @memberof palexy.streaming.v1
                     * @interface IPosTransactionMetadataValue
                     * @property {string|null} [metadataName] PosTransactionMetadataValue metadataName
                     * @property {string|null} [metadataValue] PosTransactionMetadataValue metadataValue
                     * @property {number|null} [metadataId] PosTransactionMetadataValue metadataId
                     */
    
                    /**
                     * Constructs a new PosTransactionMetadataValue.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosTransactionMetadataValue.
                     * @implements IPosTransactionMetadataValue
                     * @constructor
                     * @param {palexy.streaming.v1.IPosTransactionMetadataValue=} [properties] Properties to set
                     */
                    function PosTransactionMetadataValue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosTransactionMetadataValue metadataName.
                     * @member {string} metadataName
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @instance
                     */
                    PosTransactionMetadataValue.prototype.metadataName = "";
    
                    /**
                     * PosTransactionMetadataValue metadataValue.
                     * @member {string} metadataValue
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @instance
                     */
                    PosTransactionMetadataValue.prototype.metadataValue = "";
    
                    /**
                     * PosTransactionMetadataValue metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @instance
                     */
                    PosTransactionMetadataValue.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new PosTransactionMetadataValue instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadataValue=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosTransactionMetadataValue} PosTransactionMetadataValue instance
                     */
                    PosTransactionMetadataValue.create = function create(properties) {
                        return new PosTransactionMetadataValue(properties);
                    };
    
                    /**
                     * Encodes the specified PosTransactionMetadataValue message. Does not implicitly {@link palexy.streaming.v1.PosTransactionMetadataValue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadataValue} message PosTransactionMetadataValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionMetadataValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataName != null && Object.hasOwnProperty.call(message, "metadataName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.metadataName);
                        if (message.metadataValue != null && Object.hasOwnProperty.call(message, "metadataValue"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataValue);
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosTransactionMetadataValue message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosTransactionMetadataValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionMetadataValue} message PosTransactionMetadataValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionMetadataValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosTransactionMetadataValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosTransactionMetadataValue} PosTransactionMetadataValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionMetadataValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosTransactionMetadataValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataName = reader.string();
                                break;
                            case 2:
                                message.metadataValue = reader.string();
                                break;
                            case 3:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosTransactionMetadataValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosTransactionMetadataValue} PosTransactionMetadataValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionMetadataValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosTransactionMetadataValue message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosTransactionMetadataValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                            if (!$util.isString(message.metadataName))
                                return "metadataName: string expected";
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            if (!$util.isString(message.metadataValue))
                                return "metadataValue: string expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosTransactionMetadataValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosTransactionMetadataValue} PosTransactionMetadataValue
                     */
                    PosTransactionMetadataValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosTransactionMetadataValue)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosTransactionMetadataValue();
                        if (object.metadataName != null)
                            message.metadataName = String(object.metadataName);
                        if (object.metadataValue != null)
                            message.metadataValue = String(object.metadataValue);
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosTransactionMetadataValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @static
                     * @param {palexy.streaming.v1.PosTransactionMetadataValue} message PosTransactionMetadataValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosTransactionMetadataValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.metadataName = "";
                            object.metadataValue = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        }
                        if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                            object.metadataName = message.metadataName;
                        if (message.metadataValue != null && message.hasOwnProperty("metadataValue"))
                            object.metadataValue = message.metadataValue;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this PosTransactionMetadataValue to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosTransactionMetadataValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosTransactionMetadataValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosTransactionMetadataValue;
                })();
    
                v1.DeletePosTransactionMetadataRequest = (function() {
    
                    /**
                     * Properties of a DeletePosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeletePosTransactionMetadataRequest
                     * @property {number|null} [metadataId] DeletePosTransactionMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new DeletePosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeletePosTransactionMetadataRequest.
                     * @implements IDeletePosTransactionMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest=} [properties] Properties to set
                     */
                    function DeletePosTransactionMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeletePosTransactionMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @instance
                     */
                    DeletePosTransactionMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeletePosTransactionMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeletePosTransactionMetadataRequest} DeletePosTransactionMetadataRequest instance
                     */
                    DeletePosTransactionMetadataRequest.create = function create(properties) {
                        return new DeletePosTransactionMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeletePosTransactionMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.DeletePosTransactionMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest} message DeletePosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeletePosTransactionMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeletePosTransactionMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeletePosTransactionMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeletePosTransactionMetadataRequest} message DeletePosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeletePosTransactionMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeletePosTransactionMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeletePosTransactionMetadataRequest} DeletePosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeletePosTransactionMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeletePosTransactionMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeletePosTransactionMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeletePosTransactionMetadataRequest} DeletePosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeletePosTransactionMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeletePosTransactionMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeletePosTransactionMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeletePosTransactionMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeletePosTransactionMetadataRequest} DeletePosTransactionMetadataRequest
                     */
                    DeletePosTransactionMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeletePosTransactionMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeletePosTransactionMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeletePosTransactionMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.DeletePosTransactionMetadataRequest} message DeletePosTransactionMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeletePosTransactionMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this DeletePosTransactionMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeletePosTransactionMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeletePosTransactionMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeletePosTransactionMetadataRequest;
                })();
    
                v1.GetPosTransactionMetadataRequest = (function() {
    
                    /**
                     * Properties of a GetPosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosTransactionMetadataRequest
                     * @property {number|null} [metadataId] GetPosTransactionMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new GetPosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosTransactionMetadataRequest.
                     * @implements IGetPosTransactionMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest=} [properties] Properties to set
                     */
                    function GetPosTransactionMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosTransactionMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @instance
                     */
                    GetPosTransactionMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetPosTransactionMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosTransactionMetadataRequest} GetPosTransactionMetadataRequest instance
                     */
                    GetPosTransactionMetadataRequest.create = function create(properties) {
                        return new GetPosTransactionMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosTransactionMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.GetPosTransactionMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest} message GetPosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosTransactionMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosTransactionMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosTransactionMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosTransactionMetadataRequest} message GetPosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosTransactionMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosTransactionMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosTransactionMetadataRequest} GetPosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosTransactionMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosTransactionMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosTransactionMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosTransactionMetadataRequest} GetPosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosTransactionMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosTransactionMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosTransactionMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosTransactionMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosTransactionMetadataRequest} GetPosTransactionMetadataRequest
                     */
                    GetPosTransactionMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosTransactionMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosTransactionMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosTransactionMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.GetPosTransactionMetadataRequest} message GetPosTransactionMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosTransactionMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosTransactionMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosTransactionMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosTransactionMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosTransactionMetadataRequest;
                })();
    
                v1.ListPosTransactionMetadataRequest = (function() {
    
                    /**
                     * Properties of a ListPosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionMetadataRequest
                     * @property {number|null} [companyId] ListPosTransactionMetadataRequest companyId
                     * @property {string|null} [name] ListPosTransactionMetadataRequest name
                     * @property {number|null} [pageSize] ListPosTransactionMetadataRequest pageSize
                     * @property {string|null} [pageToken] ListPosTransactionMetadataRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListPosTransactionMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionMetadataRequest.
                     * @implements IListPosTransactionMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest=} [properties] Properties to set
                     */
                    function ListPosTransactionMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionMetadataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @instance
                     */
                    ListPosTransactionMetadataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosTransactionMetadataRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @instance
                     */
                    ListPosTransactionMetadataRequest.prototype.name = "";
    
                    /**
                     * ListPosTransactionMetadataRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @instance
                     */
                    ListPosTransactionMetadataRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosTransactionMetadataRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @instance
                     */
                    ListPosTransactionMetadataRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListPosTransactionMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataRequest} ListPosTransactionMetadataRequest instance
                     */
                    ListPosTransactionMetadataRequest.create = function create(properties) {
                        return new ListPosTransactionMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest} message ListPosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataRequest} message ListPosTransactionMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataRequest} ListPosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataRequest} ListPosTransactionMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataRequest} ListPosTransactionMetadataRequest
                     */
                    ListPosTransactionMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionMetadataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataRequest} message ListPosTransactionMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionMetadataRequest;
                })();
    
                v1.ListPosTransactionMetadataResponse = (function() {
    
                    /**
                     * Properties of a ListPosTransactionMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionMetadataResponse
                     * @property {Array.<palexy.streaming.v1.IPosTransactionMetadata>|null} [posTransactionMetadata] ListPosTransactionMetadataResponse posTransactionMetadata
                     * @property {number|null} [totalElements] ListPosTransactionMetadataResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosTransactionMetadataResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosTransactionMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionMetadataResponse.
                     * @implements IListPosTransactionMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataResponse=} [properties] Properties to set
                     */
                    function ListPosTransactionMetadataResponse(properties) {
                        this.posTransactionMetadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionMetadataResponse posTransactionMetadata.
                     * @member {Array.<palexy.streaming.v1.IPosTransactionMetadata>} posTransactionMetadata
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @instance
                     */
                    ListPosTransactionMetadataResponse.prototype.posTransactionMetadata = $util.emptyArray;
    
                    /**
                     * ListPosTransactionMetadataResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @instance
                     */
                    ListPosTransactionMetadataResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosTransactionMetadataResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @instance
                     */
                    ListPosTransactionMetadataResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosTransactionMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataResponse} ListPosTransactionMetadataResponse instance
                     */
                    ListPosTransactionMetadataResponse.create = function create(properties) {
                        return new ListPosTransactionMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataResponse} message ListPosTransactionMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posTransactionMetadata != null && message.posTransactionMetadata.length)
                            for (var i = 0; i < message.posTransactionMetadata.length; ++i)
                                $root.palexy.streaming.v1.PosTransactionMetadata.encode(message.posTransactionMetadata[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataResponse} message ListPosTransactionMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataResponse} ListPosTransactionMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posTransactionMetadata && message.posTransactionMetadata.length))
                                    message.posTransactionMetadata = [];
                                message.posTransactionMetadata.push($root.palexy.streaming.v1.PosTransactionMetadata.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataResponse} ListPosTransactionMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posTransactionMetadata != null && message.hasOwnProperty("posTransactionMetadata")) {
                            if (!Array.isArray(message.posTransactionMetadata))
                                return "posTransactionMetadata: array expected";
                            for (var i = 0; i < message.posTransactionMetadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransactionMetadata.verify(message.posTransactionMetadata[i]);
                                if (error)
                                    return "posTransactionMetadata." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataResponse} ListPosTransactionMetadataResponse
                     */
                    ListPosTransactionMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionMetadataResponse();
                        if (object.posTransactionMetadata) {
                            if (!Array.isArray(object.posTransactionMetadata))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionMetadataResponse.posTransactionMetadata: array expected");
                            message.posTransactionMetadata = [];
                            for (var i = 0; i < object.posTransactionMetadata.length; ++i) {
                                if (typeof object.posTransactionMetadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListPosTransactionMetadataResponse.posTransactionMetadata: object expected");
                                message.posTransactionMetadata[i] = $root.palexy.streaming.v1.PosTransactionMetadata.fromObject(object.posTransactionMetadata[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataResponse} message ListPosTransactionMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posTransactionMetadata = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.posTransactionMetadata && message.posTransactionMetadata.length) {
                            object.posTransactionMetadata = [];
                            for (var j = 0; j < message.posTransactionMetadata.length; ++j)
                                object.posTransactionMetadata[j] = $root.palexy.streaming.v1.PosTransactionMetadata.toObject(message.posTransactionMetadata[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionMetadataResponse;
                })();
    
                v1.ListPosTransactionMetadataValueRequest = (function() {
    
                    /**
                     * Properties of a ListPosTransactionMetadataValueRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionMetadataValueRequest
                     * @property {number|null} [metadataId] ListPosTransactionMetadataValueRequest metadataId
                     * @property {number|null} [pageSize] ListPosTransactionMetadataValueRequest pageSize
                     * @property {string|null} [pageToken] ListPosTransactionMetadataValueRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListPosTransactionMetadataValueRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionMetadataValueRequest.
                     * @implements IListPosTransactionMetadataValueRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest=} [properties] Properties to set
                     */
                    function ListPosTransactionMetadataValueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionMetadataValueRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @instance
                     */
                    ListPosTransactionMetadataValueRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosTransactionMetadataValueRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @instance
                     */
                    ListPosTransactionMetadataValueRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosTransactionMetadataValueRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @instance
                     */
                    ListPosTransactionMetadataValueRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListPosTransactionMetadataValueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueRequest} ListPosTransactionMetadataValueRequest instance
                     */
                    ListPosTransactionMetadataValueRequest.create = function create(properties) {
                        return new ListPosTransactionMetadataValueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataValueRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataValueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest} message ListPosTransactionMetadataValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataValueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataValueRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataValueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueRequest} message ListPosTransactionMetadataValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataValueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueRequest} ListPosTransactionMetadataValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataValueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionMetadataValueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataValueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueRequest} ListPosTransactionMetadataValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataValueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionMetadataValueRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionMetadataValueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionMetadataValueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueRequest} ListPosTransactionMetadataValueRequest
                     */
                    ListPosTransactionMetadataValueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionMetadataValueRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionMetadataValueRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionMetadataValueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataValueRequest} message ListPosTransactionMetadataValueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionMetadataValueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionMetadataValueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionMetadataValueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionMetadataValueRequest;
                })();
    
                v1.ListPosTransactionMetadataValueResponse = (function() {
    
                    /**
                     * Properties of a ListPosTransactionMetadataValueResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosTransactionMetadataValueResponse
                     * @property {Array.<string>|null} [values] ListPosTransactionMetadataValueResponse values
                     * @property {number|null} [totalElements] ListPosTransactionMetadataValueResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosTransactionMetadataValueResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosTransactionMetadataValueResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosTransactionMetadataValueResponse.
                     * @implements IListPosTransactionMetadataValueResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueResponse=} [properties] Properties to set
                     */
                    function ListPosTransactionMetadataValueResponse(properties) {
                        this.values = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosTransactionMetadataValueResponse values.
                     * @member {Array.<string>} values
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @instance
                     */
                    ListPosTransactionMetadataValueResponse.prototype.values = $util.emptyArray;
    
                    /**
                     * ListPosTransactionMetadataValueResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @instance
                     */
                    ListPosTransactionMetadataValueResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosTransactionMetadataValueResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @instance
                     */
                    ListPosTransactionMetadataValueResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosTransactionMetadataValueResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} ListPosTransactionMetadataValueResponse instance
                     */
                    ListPosTransactionMetadataValueResponse.create = function create(properties) {
                        return new ListPosTransactionMetadataValueResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataValueResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataValueResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueResponse} message ListPosTransactionMetadataValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataValueResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.values != null && message.values.length)
                            for (var i = 0; i < message.values.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.values[i]);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosTransactionMetadataValueResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosTransactionMetadataValueResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosTransactionMetadataValueResponse} message ListPosTransactionMetadataValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosTransactionMetadataValueResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataValueResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} ListPosTransactionMetadataValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataValueResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosTransactionMetadataValueResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.values && message.values.length))
                                    message.values = [];
                                message.values.push(reader.string());
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosTransactionMetadataValueResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} ListPosTransactionMetadataValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosTransactionMetadataValueResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosTransactionMetadataValueResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosTransactionMetadataValueResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.values != null && message.hasOwnProperty("values")) {
                            if (!Array.isArray(message.values))
                                return "values: array expected";
                            for (var i = 0; i < message.values.length; ++i)
                                if (!$util.isString(message.values[i]))
                                    return "values: string[] expected";
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosTransactionMetadataValueResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} ListPosTransactionMetadataValueResponse
                     */
                    ListPosTransactionMetadataValueResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosTransactionMetadataValueResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosTransactionMetadataValueResponse();
                        if (object.values) {
                            if (!Array.isArray(object.values))
                                throw TypeError(".palexy.streaming.v1.ListPosTransactionMetadataValueResponse.values: array expected");
                            message.values = [];
                            for (var i = 0; i < object.values.length; ++i)
                                message.values[i] = String(object.values[i]);
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosTransactionMetadataValueResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosTransactionMetadataValueResponse} message ListPosTransactionMetadataValueResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosTransactionMetadataValueResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.values = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.values && message.values.length) {
                            object.values = [];
                            for (var j = 0; j < message.values.length; ++j)
                                object.values[j] = message.values[j];
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosTransactionMetadataValueResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosTransactionMetadataValueResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosTransactionMetadataValueResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosTransactionMetadataValueResponse;
                })();
    
                /**
                 * StoreActionMomentType enum.
                 * @name palexy.streaming.v1.StoreActionMomentType
                 * @enum {number}
                 * @property {number} UNKNOWN_STORE_ACTION_MOMENT_TYPE=0 UNKNOWN_STORE_ACTION_MOMENT_TYPE value
                 * @property {number} CASHIER_DRAWING=1 CASHIER_DRAWING value
                 * @property {number} CANCEL_BILL=2 CANCEL_BILL value
                 */
                v1.StoreActionMomentType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_STORE_ACTION_MOMENT_TYPE"] = 0;
                    values[valuesById[1] = "CASHIER_DRAWING"] = 1;
                    values[valuesById[2] = "CANCEL_BILL"] = 2;
                    return values;
                })();
    
                v1.StoreActionMoment = (function() {
    
                    /**
                     * Properties of a StoreActionMoment.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreActionMoment
                     * @property {number|null} [id] StoreActionMoment id
                     * @property {number|null} [storeId] StoreActionMoment storeId
                     * @property {number|null} [dateId] StoreActionMoment dateId
                     * @property {string|null} [occurTime] StoreActionMoment occurTime
                     * @property {palexy.streaming.v1.StoreActionMomentType|null} [actionType] StoreActionMoment actionType
                     * @property {number|null} [insertedDateTimeMs] StoreActionMoment insertedDateTimeMs
                     */
    
                    /**
                     * Constructs a new StoreActionMoment.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreActionMoment.
                     * @implements IStoreActionMoment
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreActionMoment=} [properties] Properties to set
                     */
                    function StoreActionMoment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreActionMoment id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreActionMoment storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreActionMoment dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.dateId = 0;
    
                    /**
                     * StoreActionMoment occurTime.
                     * @member {string} occurTime
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.occurTime = "";
    
                    /**
                     * StoreActionMoment actionType.
                     * @member {palexy.streaming.v1.StoreActionMomentType} actionType
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.actionType = 0;
    
                    /**
                     * StoreActionMoment insertedDateTimeMs.
                     * @member {number} insertedDateTimeMs
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     */
                    StoreActionMoment.prototype.insertedDateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StoreActionMoment instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {palexy.streaming.v1.IStoreActionMoment=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreActionMoment} StoreActionMoment instance
                     */
                    StoreActionMoment.create = function create(properties) {
                        return new StoreActionMoment(properties);
                    };
    
                    /**
                     * Encodes the specified StoreActionMoment message. Does not implicitly {@link palexy.streaming.v1.StoreActionMoment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {palexy.streaming.v1.IStoreActionMoment} message StoreActionMoment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreActionMoment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.occurTime != null && Object.hasOwnProperty.call(message, "occurTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.occurTime);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.actionType);
                        if (message.insertedDateTimeMs != null && Object.hasOwnProperty.call(message, "insertedDateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.insertedDateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreActionMoment message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreActionMoment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {palexy.streaming.v1.IStoreActionMoment} message StoreActionMoment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreActionMoment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreActionMoment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreActionMoment} StoreActionMoment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreActionMoment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreActionMoment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.occurTime = reader.string();
                                break;
                            case 5:
                                message.actionType = reader.int32();
                                break;
                            case 6:
                                message.insertedDateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreActionMoment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreActionMoment} StoreActionMoment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreActionMoment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreActionMoment message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreActionMoment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.occurTime != null && message.hasOwnProperty("occurTime"))
                            if (!$util.isString(message.occurTime))
                                return "occurTime: string expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            switch (message.actionType) {
                            default:
                                return "actionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.insertedDateTimeMs != null && message.hasOwnProperty("insertedDateTimeMs"))
                            if (!$util.isInteger(message.insertedDateTimeMs) && !(message.insertedDateTimeMs && $util.isInteger(message.insertedDateTimeMs.low) && $util.isInteger(message.insertedDateTimeMs.high)))
                                return "insertedDateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreActionMoment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreActionMoment} StoreActionMoment
                     */
                    StoreActionMoment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreActionMoment)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreActionMoment();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.occurTime != null)
                            message.occurTime = String(object.occurTime);
                        switch (object.actionType) {
                        case "UNKNOWN_STORE_ACTION_MOMENT_TYPE":
                        case 0:
                            message.actionType = 0;
                            break;
                        case "CASHIER_DRAWING":
                        case 1:
                            message.actionType = 1;
                            break;
                        case "CANCEL_BILL":
                        case 2:
                            message.actionType = 2;
                            break;
                        }
                        if (object.insertedDateTimeMs != null)
                            if ($util.Long)
                                (message.insertedDateTimeMs = $util.Long.fromValue(object.insertedDateTimeMs)).unsigned = false;
                            else if (typeof object.insertedDateTimeMs === "string")
                                message.insertedDateTimeMs = parseInt(object.insertedDateTimeMs, 10);
                            else if (typeof object.insertedDateTimeMs === "number")
                                message.insertedDateTimeMs = object.insertedDateTimeMs;
                            else if (typeof object.insertedDateTimeMs === "object")
                                message.insertedDateTimeMs = new $util.LongBits(object.insertedDateTimeMs.low >>> 0, object.insertedDateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreActionMoment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @static
                     * @param {palexy.streaming.v1.StoreActionMoment} message StoreActionMoment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreActionMoment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.occurTime = "";
                            object.actionType = options.enums === String ? "UNKNOWN_STORE_ACTION_MOMENT_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.insertedDateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.insertedDateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.occurTime != null && message.hasOwnProperty("occurTime"))
                            object.occurTime = message.occurTime;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = options.enums === String ? $root.palexy.streaming.v1.StoreActionMomentType[message.actionType] : message.actionType;
                        if (message.insertedDateTimeMs != null && message.hasOwnProperty("insertedDateTimeMs"))
                            if (typeof message.insertedDateTimeMs === "number")
                                object.insertedDateTimeMs = options.longs === String ? String(message.insertedDateTimeMs) : message.insertedDateTimeMs;
                            else
                                object.insertedDateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.insertedDateTimeMs) : options.longs === Number ? new $util.LongBits(message.insertedDateTimeMs.low >>> 0, message.insertedDateTimeMs.high >>> 0).toNumber() : message.insertedDateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this StoreActionMoment to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreActionMoment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreActionMoment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreActionMoment;
                })();
    
                v1.ListStoreActionMomentRequest = (function() {
    
                    /**
                     * Properties of a ListStoreActionMomentRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreActionMomentRequest
                     * @property {Array.<number>|null} [storeIds] ListStoreActionMomentRequest storeIds
                     * @property {palexy.streaming.v1.StoreActionMomentType|null} [actionType] ListStoreActionMomentRequest actionType
                     * @property {number|null} [pageSize] ListStoreActionMomentRequest pageSize
                     * @property {string|null} [startDateId] ListStoreActionMomentRequest startDateId
                     * @property {string|null} [endDateId] ListStoreActionMomentRequest endDateId
                     */
    
                    /**
                     * Constructs a new ListStoreActionMomentRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreActionMomentRequest.
                     * @implements IListStoreActionMomentRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest=} [properties] Properties to set
                     */
                    function ListStoreActionMomentRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreActionMomentRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     */
                    ListStoreActionMomentRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListStoreActionMomentRequest actionType.
                     * @member {palexy.streaming.v1.StoreActionMomentType} actionType
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     */
                    ListStoreActionMomentRequest.prototype.actionType = 0;
    
                    /**
                     * ListStoreActionMomentRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     */
                    ListStoreActionMomentRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStoreActionMomentRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     */
                    ListStoreActionMomentRequest.prototype.startDateId = "";
    
                    /**
                     * ListStoreActionMomentRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     */
                    ListStoreActionMomentRequest.prototype.endDateId = "";
    
                    /**
                     * Creates a new ListStoreActionMomentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreActionMomentRequest} ListStoreActionMomentRequest instance
                     */
                    ListStoreActionMomentRequest.create = function create(properties) {
                        return new ListStoreActionMomentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreActionMomentRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreActionMomentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest} message ListStoreActionMomentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreActionMomentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.actionType);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreActionMomentRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreActionMomentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentRequest} message ListStoreActionMomentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreActionMomentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreActionMomentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreActionMomentRequest} ListStoreActionMomentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreActionMomentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreActionMomentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 3:
                                message.actionType = reader.int32();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.startDateId = reader.string();
                                break;
                            case 6:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreActionMomentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreActionMomentRequest} ListStoreActionMomentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreActionMomentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreActionMomentRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreActionMomentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            switch (message.actionType) {
                            default:
                                return "actionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreActionMomentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreActionMomentRequest} ListStoreActionMomentRequest
                     */
                    ListStoreActionMomentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreActionMomentRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreActionMomentRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListStoreActionMomentRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        switch (object.actionType) {
                        case "UNKNOWN_STORE_ACTION_MOMENT_TYPE":
                        case 0:
                            message.actionType = 0;
                            break;
                        case "CASHIER_DRAWING":
                        case 1:
                            message.actionType = 1;
                            break;
                        case "CANCEL_BILL":
                        case 2:
                            message.actionType = 2;
                            break;
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreActionMomentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreActionMomentRequest} message ListStoreActionMomentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreActionMomentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.actionType = options.enums === String ? "UNKNOWN_STORE_ACTION_MOMENT_TYPE" : 0;
                            object.pageSize = 0;
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = options.enums === String ? $root.palexy.streaming.v1.StoreActionMomentType[message.actionType] : message.actionType;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreActionMomentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreActionMomentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreActionMomentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreActionMomentRequest;
                })();
    
                v1.ListStoreActionMomentResponse = (function() {
    
                    /**
                     * Properties of a ListStoreActionMomentResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreActionMomentResponse
                     * @property {Array.<palexy.streaming.v1.IStoreActionMoment>|null} [storeActionMoments] ListStoreActionMomentResponse storeActionMoments
                     */
    
                    /**
                     * Constructs a new ListStoreActionMomentResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreActionMomentResponse.
                     * @implements IListStoreActionMomentResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreActionMomentResponse=} [properties] Properties to set
                     */
                    function ListStoreActionMomentResponse(properties) {
                        this.storeActionMoments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreActionMomentResponse storeActionMoments.
                     * @member {Array.<palexy.streaming.v1.IStoreActionMoment>} storeActionMoments
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @instance
                     */
                    ListStoreActionMomentResponse.prototype.storeActionMoments = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreActionMomentResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreActionMomentResponse} ListStoreActionMomentResponse instance
                     */
                    ListStoreActionMomentResponse.create = function create(properties) {
                        return new ListStoreActionMomentResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreActionMomentResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreActionMomentResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentResponse} message ListStoreActionMomentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreActionMomentResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeActionMoments != null && message.storeActionMoments.length)
                            for (var i = 0; i < message.storeActionMoments.length; ++i)
                                $root.palexy.streaming.v1.StoreActionMoment.encode(message.storeActionMoments[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreActionMomentResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreActionMomentResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreActionMomentResponse} message ListStoreActionMomentResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreActionMomentResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreActionMomentResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreActionMomentResponse} ListStoreActionMomentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreActionMomentResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreActionMomentResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeActionMoments && message.storeActionMoments.length))
                                    message.storeActionMoments = [];
                                message.storeActionMoments.push($root.palexy.streaming.v1.StoreActionMoment.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreActionMomentResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreActionMomentResponse} ListStoreActionMomentResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreActionMomentResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreActionMomentResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreActionMomentResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeActionMoments != null && message.hasOwnProperty("storeActionMoments")) {
                            if (!Array.isArray(message.storeActionMoments))
                                return "storeActionMoments: array expected";
                            for (var i = 0; i < message.storeActionMoments.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreActionMoment.verify(message.storeActionMoments[i]);
                                if (error)
                                    return "storeActionMoments." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreActionMomentResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreActionMomentResponse} ListStoreActionMomentResponse
                     */
                    ListStoreActionMomentResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreActionMomentResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreActionMomentResponse();
                        if (object.storeActionMoments) {
                            if (!Array.isArray(object.storeActionMoments))
                                throw TypeError(".palexy.streaming.v1.ListStoreActionMomentResponse.storeActionMoments: array expected");
                            message.storeActionMoments = [];
                            for (var i = 0; i < object.storeActionMoments.length; ++i) {
                                if (typeof object.storeActionMoments[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreActionMomentResponse.storeActionMoments: object expected");
                                message.storeActionMoments[i] = $root.palexy.streaming.v1.StoreActionMoment.fromObject(object.storeActionMoments[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreActionMomentResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreActionMomentResponse} message ListStoreActionMomentResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreActionMomentResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeActionMoments = [];
                        if (message.storeActionMoments && message.storeActionMoments.length) {
                            object.storeActionMoments = [];
                            for (var j = 0; j < message.storeActionMoments.length; ++j)
                                object.storeActionMoments[j] = $root.palexy.streaming.v1.StoreActionMoment.toObject(message.storeActionMoments[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreActionMomentResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreActionMomentResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreActionMomentResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreActionMomentResponse;
                })();
    
                v1.ImportStoreActionMomentsRequest = (function() {
    
                    /**
                     * Properties of an ImportStoreActionMomentsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IImportStoreActionMomentsRequest
                     * @property {Array.<palexy.streaming.v1.IStoreActionMoment>|null} [storeActionMoments] ImportStoreActionMomentsRequest storeActionMoments
                     * @property {boolean|null} [deleteExisting] ImportStoreActionMomentsRequest deleteExisting
                     * @property {boolean|null} [preview] ImportStoreActionMomentsRequest preview
                     * @property {Array.<number>|null} [storeIds] ImportStoreActionMomentsRequest storeIds
                     * @property {string|null} [startDateId] ImportStoreActionMomentsRequest startDateId
                     * @property {string|null} [endDateId] ImportStoreActionMomentsRequest endDateId
                     * @property {palexy.streaming.v1.StoreActionMomentType|null} [actionType] ImportStoreActionMomentsRequest actionType
                     */
    
                    /**
                     * Constructs a new ImportStoreActionMomentsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportStoreActionMomentsRequest.
                     * @implements IImportStoreActionMomentsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest=} [properties] Properties to set
                     */
                    function ImportStoreActionMomentsRequest(properties) {
                        this.storeActionMoments = [];
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportStoreActionMomentsRequest storeActionMoments.
                     * @member {Array.<palexy.streaming.v1.IStoreActionMoment>} storeActionMoments
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.storeActionMoments = $util.emptyArray;
    
                    /**
                     * ImportStoreActionMomentsRequest deleteExisting.
                     * @member {boolean} deleteExisting
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.deleteExisting = false;
    
                    /**
                     * ImportStoreActionMomentsRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.preview = false;
    
                    /**
                     * ImportStoreActionMomentsRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ImportStoreActionMomentsRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.startDateId = "";
    
                    /**
                     * ImportStoreActionMomentsRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.endDateId = "";
    
                    /**
                     * ImportStoreActionMomentsRequest actionType.
                     * @member {palexy.streaming.v1.StoreActionMomentType} actionType
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     */
                    ImportStoreActionMomentsRequest.prototype.actionType = 0;
    
                    /**
                     * Creates a new ImportStoreActionMomentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsRequest} ImportStoreActionMomentsRequest instance
                     */
                    ImportStoreActionMomentsRequest.create = function create(properties) {
                        return new ImportStoreActionMomentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportStoreActionMomentsRequest message. Does not implicitly {@link palexy.streaming.v1.ImportStoreActionMomentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest} message ImportStoreActionMomentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStoreActionMomentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeActionMoments != null && message.storeActionMoments.length)
                            for (var i = 0; i < message.storeActionMoments.length; ++i)
                                $root.palexy.streaming.v1.StoreActionMoment.encode(message.storeActionMoments[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.deleteExisting != null && Object.hasOwnProperty.call(message, "deleteExisting"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.deleteExisting);
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.preview);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endDateId);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.actionType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportStoreActionMomentsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportStoreActionMomentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsRequest} message ImportStoreActionMomentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStoreActionMomentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportStoreActionMomentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsRequest} ImportStoreActionMomentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStoreActionMomentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportStoreActionMomentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeActionMoments && message.storeActionMoments.length))
                                    message.storeActionMoments = [];
                                message.storeActionMoments.push($root.palexy.streaming.v1.StoreActionMoment.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.deleteExisting = reader.bool();
                                break;
                            case 3:
                                message.preview = reader.bool();
                                break;
                            case 4:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 5:
                                message.startDateId = reader.string();
                                break;
                            case 6:
                                message.endDateId = reader.string();
                                break;
                            case 7:
                                message.actionType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportStoreActionMomentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsRequest} ImportStoreActionMomentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStoreActionMomentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportStoreActionMomentsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportStoreActionMomentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeActionMoments != null && message.hasOwnProperty("storeActionMoments")) {
                            if (!Array.isArray(message.storeActionMoments))
                                return "storeActionMoments: array expected";
                            for (var i = 0; i < message.storeActionMoments.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreActionMoment.verify(message.storeActionMoments[i]);
                                if (error)
                                    return "storeActionMoments." + error;
                            }
                        }
                        if (message.deleteExisting != null && message.hasOwnProperty("deleteExisting"))
                            if (typeof message.deleteExisting !== "boolean")
                                return "deleteExisting: boolean expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            switch (message.actionType) {
                            default:
                                return "actionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates an ImportStoreActionMomentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsRequest} ImportStoreActionMomentsRequest
                     */
                    ImportStoreActionMomentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportStoreActionMomentsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportStoreActionMomentsRequest();
                        if (object.storeActionMoments) {
                            if (!Array.isArray(object.storeActionMoments))
                                throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsRequest.storeActionMoments: array expected");
                            message.storeActionMoments = [];
                            for (var i = 0; i < object.storeActionMoments.length; ++i) {
                                if (typeof object.storeActionMoments[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsRequest.storeActionMoments: object expected");
                                message.storeActionMoments[i] = $root.palexy.streaming.v1.StoreActionMoment.fromObject(object.storeActionMoments[i]);
                            }
                        }
                        if (object.deleteExisting != null)
                            message.deleteExisting = Boolean(object.deleteExisting);
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        switch (object.actionType) {
                        case "UNKNOWN_STORE_ACTION_MOMENT_TYPE":
                        case 0:
                            message.actionType = 0;
                            break;
                        case "CASHIER_DRAWING":
                        case 1:
                            message.actionType = 1;
                            break;
                        case "CANCEL_BILL":
                        case 2:
                            message.actionType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportStoreActionMomentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @static
                     * @param {palexy.streaming.v1.ImportStoreActionMomentsRequest} message ImportStoreActionMomentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportStoreActionMomentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeActionMoments = [];
                            object.storeIds = [];
                        }
                        if (options.defaults) {
                            object.deleteExisting = false;
                            object.preview = false;
                            object.startDateId = "";
                            object.endDateId = "";
                            object.actionType = options.enums === String ? "UNKNOWN_STORE_ACTION_MOMENT_TYPE" : 0;
                        }
                        if (message.storeActionMoments && message.storeActionMoments.length) {
                            object.storeActionMoments = [];
                            for (var j = 0; j < message.storeActionMoments.length; ++j)
                                object.storeActionMoments[j] = $root.palexy.streaming.v1.StoreActionMoment.toObject(message.storeActionMoments[j], options);
                        }
                        if (message.deleteExisting != null && message.hasOwnProperty("deleteExisting"))
                            object.deleteExisting = message.deleteExisting;
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = options.enums === String ? $root.palexy.streaming.v1.StoreActionMomentType[message.actionType] : message.actionType;
                        return object;
                    };
    
                    /**
                     * Converts this ImportStoreActionMomentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportStoreActionMomentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportStoreActionMomentsRequest;
                })();
    
                v1.ImportStoreActionMomentsResponse = (function() {
    
                    /**
                     * Properties of an ImportStoreActionMomentsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IImportStoreActionMomentsResponse
                     * @property {palexy.streaming.v1.IImportResult|null} [importResult] ImportStoreActionMomentsResponse importResult
                     * @property {Array.<palexy.streaming.v1.IStoreActionMoment>|null} [previewResult] ImportStoreActionMomentsResponse previewResult
                     */
    
                    /**
                     * Constructs a new ImportStoreActionMomentsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportStoreActionMomentsResponse.
                     * @implements IImportStoreActionMomentsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsResponse=} [properties] Properties to set
                     */
                    function ImportStoreActionMomentsResponse(properties) {
                        this.previewResult = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportStoreActionMomentsResponse importResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} importResult
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @instance
                     */
                    ImportStoreActionMomentsResponse.prototype.importResult = null;
    
                    /**
                     * ImportStoreActionMomentsResponse previewResult.
                     * @member {Array.<palexy.streaming.v1.IStoreActionMoment>} previewResult
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @instance
                     */
                    ImportStoreActionMomentsResponse.prototype.previewResult = $util.emptyArray;
    
                    /**
                     * Creates a new ImportStoreActionMomentsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsResponse} ImportStoreActionMomentsResponse instance
                     */
                    ImportStoreActionMomentsResponse.create = function create(properties) {
                        return new ImportStoreActionMomentsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ImportStoreActionMomentsResponse message. Does not implicitly {@link palexy.streaming.v1.ImportStoreActionMomentsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsResponse} message ImportStoreActionMomentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStoreActionMomentsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.importResult != null && Object.hasOwnProperty.call(message, "importResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.importResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.previewResult != null && message.previewResult.length)
                            for (var i = 0; i < message.previewResult.length; ++i)
                                $root.palexy.streaming.v1.StoreActionMoment.encode(message.previewResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportStoreActionMomentsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportStoreActionMomentsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportStoreActionMomentsResponse} message ImportStoreActionMomentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStoreActionMomentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportStoreActionMomentsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsResponse} ImportStoreActionMomentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStoreActionMomentsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportStoreActionMomentsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.importResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.previewResult && message.previewResult.length))
                                    message.previewResult = [];
                                message.previewResult.push($root.palexy.streaming.v1.StoreActionMoment.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportStoreActionMomentsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsResponse} ImportStoreActionMomentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStoreActionMomentsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportStoreActionMomentsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportStoreActionMomentsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.importResult != null && message.hasOwnProperty("importResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.importResult);
                            if (error)
                                return "importResult." + error;
                        }
                        if (message.previewResult != null && message.hasOwnProperty("previewResult")) {
                            if (!Array.isArray(message.previewResult))
                                return "previewResult: array expected";
                            for (var i = 0; i < message.previewResult.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreActionMoment.verify(message.previewResult[i]);
                                if (error)
                                    return "previewResult." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportStoreActionMomentsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportStoreActionMomentsResponse} ImportStoreActionMomentsResponse
                     */
                    ImportStoreActionMomentsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportStoreActionMomentsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportStoreActionMomentsResponse();
                        if (object.importResult != null) {
                            if (typeof object.importResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsResponse.importResult: object expected");
                            message.importResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.importResult);
                        }
                        if (object.previewResult) {
                            if (!Array.isArray(object.previewResult))
                                throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsResponse.previewResult: array expected");
                            message.previewResult = [];
                            for (var i = 0; i < object.previewResult.length; ++i) {
                                if (typeof object.previewResult[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportStoreActionMomentsResponse.previewResult: object expected");
                                message.previewResult[i] = $root.palexy.streaming.v1.StoreActionMoment.fromObject(object.previewResult[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportStoreActionMomentsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @static
                     * @param {palexy.streaming.v1.ImportStoreActionMomentsResponse} message ImportStoreActionMomentsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportStoreActionMomentsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.previewResult = [];
                        if (options.defaults)
                            object.importResult = null;
                        if (message.importResult != null && message.hasOwnProperty("importResult"))
                            object.importResult = $root.palexy.streaming.v1.ImportResult.toObject(message.importResult, options);
                        if (message.previewResult && message.previewResult.length) {
                            object.previewResult = [];
                            for (var j = 0; j < message.previewResult.length; ++j)
                                object.previewResult[j] = $root.palexy.streaming.v1.StoreActionMoment.toObject(message.previewResult[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ImportStoreActionMomentsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportStoreActionMomentsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportStoreActionMomentsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportStoreActionMomentsResponse;
                })();
    
                v1.PosTransactionProduct = (function() {
    
                    /**
                     * Properties of a PosTransactionProduct.
                     * @memberof palexy.streaming.v1
                     * @interface IPosTransactionProduct
                     * @property {number|null} [productId] PosTransactionProduct productId
                     * @property {string|null} [productName] PosTransactionProduct productName
                     * @property {string|null} [productCode] PosTransactionProduct productCode
                     * @property {string|null} [productDescription] PosTransactionProduct productDescription
                     * @property {number|null} [unitPrice] PosTransactionProduct unitPrice
                     * @property {number|null} [quantity] PosTransactionProduct quantity
                     * @property {number|null} [totalAmount] PosTransactionProduct totalAmount
                     * @property {number|null} [netAmount] PosTransactionProduct netAmount
                     * @property {number|null} [unitBaseCost] PosTransactionProduct unitBaseCost
                     * @property {string|null} [transactionTime] PosTransactionProduct transactionTime
                     * @property {string|null} [unit] PosTransactionProduct unit
                     * @property {number|null} [grossAmount] PosTransactionProduct grossAmount
                     * @property {number|null} [discountAmount] PosTransactionProduct discountAmount
                     * @property {string|null} [posExternalStaffId] PosTransactionProduct posExternalStaffId
                     * @property {palexy.streaming.v1.IStaff|null} [staff] PosTransactionProduct staff
                     * @property {Array.<palexy.streaming.v1.IPosProductMetadata>|null} [metadata] PosTransactionProduct metadata
                     */
    
                    /**
                     * Constructs a new PosTransactionProduct.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosTransactionProduct.
                     * @implements IPosTransactionProduct
                     * @constructor
                     * @param {palexy.streaming.v1.IPosTransactionProduct=} [properties] Properties to set
                     */
                    function PosTransactionProduct(properties) {
                        this.metadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosTransactionProduct productId.
                     * @member {number} productId
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.productId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosTransactionProduct productName.
                     * @member {string} productName
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.productName = "";
    
                    /**
                     * PosTransactionProduct productCode.
                     * @member {string} productCode
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.productCode = "";
    
                    /**
                     * PosTransactionProduct productDescription.
                     * @member {string} productDescription
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.productDescription = "";
    
                    /**
                     * PosTransactionProduct unitPrice.
                     * @member {number} unitPrice
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.unitPrice = 0;
    
                    /**
                     * PosTransactionProduct quantity.
                     * @member {number} quantity
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.quantity = 0;
    
                    /**
                     * PosTransactionProduct totalAmount.
                     * @member {number} totalAmount
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.totalAmount = 0;
    
                    /**
                     * PosTransactionProduct netAmount.
                     * @member {number} netAmount
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.netAmount = 0;
    
                    /**
                     * PosTransactionProduct unitBaseCost.
                     * @member {number} unitBaseCost
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.unitBaseCost = 0;
    
                    /**
                     * PosTransactionProduct transactionTime.
                     * @member {string} transactionTime
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.transactionTime = "";
    
                    /**
                     * PosTransactionProduct unit.
                     * @member {string} unit
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.unit = "";
    
                    /**
                     * PosTransactionProduct grossAmount.
                     * @member {number} grossAmount
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.grossAmount = 0;
    
                    /**
                     * PosTransactionProduct discountAmount.
                     * @member {number} discountAmount
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.discountAmount = 0;
    
                    /**
                     * PosTransactionProduct posExternalStaffId.
                     * @member {string} posExternalStaffId
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.posExternalStaffId = "";
    
                    /**
                     * PosTransactionProduct staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.staff = null;
    
                    /**
                     * PosTransactionProduct metadata.
                     * @member {Array.<palexy.streaming.v1.IPosProductMetadata>} metadata
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     */
                    PosTransactionProduct.prototype.metadata = $util.emptyArray;
    
                    /**
                     * Creates a new PosTransactionProduct instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionProduct=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosTransactionProduct} PosTransactionProduct instance
                     */
                    PosTransactionProduct.create = function create(properties) {
                        return new PosTransactionProduct(properties);
                    };
    
                    /**
                     * Encodes the specified PosTransactionProduct message. Does not implicitly {@link palexy.streaming.v1.PosTransactionProduct.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionProduct} message PosTransactionProduct message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionProduct.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.productId != null && Object.hasOwnProperty.call(message, "productId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.productId);
                        if (message.productName != null && Object.hasOwnProperty.call(message, "productName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.productName);
                        if (message.unitPrice != null && Object.hasOwnProperty.call(message, "unitPrice"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.unitPrice);
                        if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.quantity);
                        if (message.totalAmount != null && Object.hasOwnProperty.call(message, "totalAmount"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.totalAmount);
                        if (message.metadata != null && message.metadata.length)
                            for (var i = 0; i < message.metadata.length; ++i)
                                $root.palexy.streaming.v1.PosProductMetadata.encode(message.metadata[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.productCode != null && Object.hasOwnProperty.call(message, "productCode"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.productCode);
                        if (message.productDescription != null && Object.hasOwnProperty.call(message, "productDescription"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.productDescription);
                        if (message.netAmount != null && Object.hasOwnProperty.call(message, "netAmount"))
                            writer.uint32(/* id 9, wireType 1 =*/73).double(message.netAmount);
                        if (message.unitBaseCost != null && Object.hasOwnProperty.call(message, "unitBaseCost"))
                            writer.uint32(/* id 10, wireType 1 =*/81).double(message.unitBaseCost);
                        if (message.transactionTime != null && Object.hasOwnProperty.call(message, "transactionTime"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.transactionTime);
                        if (message.unit != null && Object.hasOwnProperty.call(message, "unit"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.unit);
                        if (message.grossAmount != null && Object.hasOwnProperty.call(message, "grossAmount"))
                            writer.uint32(/* id 13, wireType 1 =*/105).double(message.grossAmount);
                        if (message.discountAmount != null && Object.hasOwnProperty.call(message, "discountAmount"))
                            writer.uint32(/* id 14, wireType 1 =*/113).double(message.discountAmount);
                        if (message.posExternalStaffId != null && Object.hasOwnProperty.call(message, "posExternalStaffId"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.posExternalStaffId);
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosTransactionProduct message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosTransactionProduct.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {palexy.streaming.v1.IPosTransactionProduct} message PosTransactionProduct message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosTransactionProduct.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosTransactionProduct message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosTransactionProduct} PosTransactionProduct
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionProduct.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosTransactionProduct();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.productId = reader.int64();
                                break;
                            case 2:
                                message.productName = reader.string();
                                break;
                            case 7:
                                message.productCode = reader.string();
                                break;
                            case 8:
                                message.productDescription = reader.string();
                                break;
                            case 3:
                                message.unitPrice = reader.double();
                                break;
                            case 4:
                                message.quantity = reader.double();
                                break;
                            case 5:
                                message.totalAmount = reader.double();
                                break;
                            case 9:
                                message.netAmount = reader.double();
                                break;
                            case 10:
                                message.unitBaseCost = reader.double();
                                break;
                            case 11:
                                message.transactionTime = reader.string();
                                break;
                            case 12:
                                message.unit = reader.string();
                                break;
                            case 13:
                                message.grossAmount = reader.double();
                                break;
                            case 14:
                                message.discountAmount = reader.double();
                                break;
                            case 15:
                                message.posExternalStaffId = reader.string();
                                break;
                            case 16:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 6:
                                if (!(message.metadata && message.metadata.length))
                                    message.metadata = [];
                                message.metadata.push($root.palexy.streaming.v1.PosProductMetadata.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosTransactionProduct message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosTransactionProduct} PosTransactionProduct
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosTransactionProduct.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosTransactionProduct message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosTransactionProduct.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.productId != null && message.hasOwnProperty("productId"))
                            if (!$util.isInteger(message.productId) && !(message.productId && $util.isInteger(message.productId.low) && $util.isInteger(message.productId.high)))
                                return "productId: integer|Long expected";
                        if (message.productName != null && message.hasOwnProperty("productName"))
                            if (!$util.isString(message.productName))
                                return "productName: string expected";
                        if (message.productCode != null && message.hasOwnProperty("productCode"))
                            if (!$util.isString(message.productCode))
                                return "productCode: string expected";
                        if (message.productDescription != null && message.hasOwnProperty("productDescription"))
                            if (!$util.isString(message.productDescription))
                                return "productDescription: string expected";
                        if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                            if (typeof message.unitPrice !== "number")
                                return "unitPrice: number expected";
                        if (message.quantity != null && message.hasOwnProperty("quantity"))
                            if (typeof message.quantity !== "number")
                                return "quantity: number expected";
                        if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                            if (typeof message.totalAmount !== "number")
                                return "totalAmount: number expected";
                        if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                            if (typeof message.netAmount !== "number")
                                return "netAmount: number expected";
                        if (message.unitBaseCost != null && message.hasOwnProperty("unitBaseCost"))
                            if (typeof message.unitBaseCost !== "number")
                                return "unitBaseCost: number expected";
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
                            if (!$util.isString(message.transactionTime))
                                return "transactionTime: string expected";
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            if (!$util.isString(message.unit))
                                return "unit: string expected";
                        if (message.grossAmount != null && message.hasOwnProperty("grossAmount"))
                            if (typeof message.grossAmount !== "number")
                                return "grossAmount: number expected";
                        if (message.discountAmount != null && message.hasOwnProperty("discountAmount"))
                            if (typeof message.discountAmount !== "number")
                                return "discountAmount: number expected";
                        if (message.posExternalStaffId != null && message.hasOwnProperty("posExternalStaffId"))
                            if (!$util.isString(message.posExternalStaffId))
                                return "posExternalStaffId: string expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.metadata != null && message.hasOwnProperty("metadata")) {
                            if (!Array.isArray(message.metadata))
                                return "metadata: array expected";
                            for (var i = 0; i < message.metadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosProductMetadata.verify(message.metadata[i]);
                                if (error)
                                    return "metadata." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosTransactionProduct message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosTransactionProduct} PosTransactionProduct
                     */
                    PosTransactionProduct.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosTransactionProduct)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosTransactionProduct();
                        if (object.productId != null)
                            if ($util.Long)
                                (message.productId = $util.Long.fromValue(object.productId)).unsigned = false;
                            else if (typeof object.productId === "string")
                                message.productId = parseInt(object.productId, 10);
                            else if (typeof object.productId === "number")
                                message.productId = object.productId;
                            else if (typeof object.productId === "object")
                                message.productId = new $util.LongBits(object.productId.low >>> 0, object.productId.high >>> 0).toNumber();
                        if (object.productName != null)
                            message.productName = String(object.productName);
                        if (object.productCode != null)
                            message.productCode = String(object.productCode);
                        if (object.productDescription != null)
                            message.productDescription = String(object.productDescription);
                        if (object.unitPrice != null)
                            message.unitPrice = Number(object.unitPrice);
                        if (object.quantity != null)
                            message.quantity = Number(object.quantity);
                        if (object.totalAmount != null)
                            message.totalAmount = Number(object.totalAmount);
                        if (object.netAmount != null)
                            message.netAmount = Number(object.netAmount);
                        if (object.unitBaseCost != null)
                            message.unitBaseCost = Number(object.unitBaseCost);
                        if (object.transactionTime != null)
                            message.transactionTime = String(object.transactionTime);
                        if (object.unit != null)
                            message.unit = String(object.unit);
                        if (object.grossAmount != null)
                            message.grossAmount = Number(object.grossAmount);
                        if (object.discountAmount != null)
                            message.discountAmount = Number(object.discountAmount);
                        if (object.posExternalStaffId != null)
                            message.posExternalStaffId = String(object.posExternalStaffId);
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.PosTransactionProduct.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.metadata) {
                            if (!Array.isArray(object.metadata))
                                throw TypeError(".palexy.streaming.v1.PosTransactionProduct.metadata: array expected");
                            message.metadata = [];
                            for (var i = 0; i < object.metadata.length; ++i) {
                                if (typeof object.metadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosTransactionProduct.metadata: object expected");
                                message.metadata[i] = $root.palexy.streaming.v1.PosProductMetadata.fromObject(object.metadata[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosTransactionProduct message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @static
                     * @param {palexy.streaming.v1.PosTransactionProduct} message PosTransactionProduct
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosTransactionProduct.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.metadata = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.productId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.productId = options.longs === String ? "0" : 0;
                            object.productName = "";
                            object.unitPrice = 0;
                            object.quantity = 0;
                            object.totalAmount = 0;
                            object.productCode = "";
                            object.productDescription = "";
                            object.netAmount = 0;
                            object.unitBaseCost = 0;
                            object.transactionTime = "";
                            object.unit = "";
                            object.grossAmount = 0;
                            object.discountAmount = 0;
                            object.posExternalStaffId = "";
                            object.staff = null;
                        }
                        if (message.productId != null && message.hasOwnProperty("productId"))
                            if (typeof message.productId === "number")
                                object.productId = options.longs === String ? String(message.productId) : message.productId;
                            else
                                object.productId = options.longs === String ? $util.Long.prototype.toString.call(message.productId) : options.longs === Number ? new $util.LongBits(message.productId.low >>> 0, message.productId.high >>> 0).toNumber() : message.productId;
                        if (message.productName != null && message.hasOwnProperty("productName"))
                            object.productName = message.productName;
                        if (message.unitPrice != null && message.hasOwnProperty("unitPrice"))
                            object.unitPrice = options.json && !isFinite(message.unitPrice) ? String(message.unitPrice) : message.unitPrice;
                        if (message.quantity != null && message.hasOwnProperty("quantity"))
                            object.quantity = options.json && !isFinite(message.quantity) ? String(message.quantity) : message.quantity;
                        if (message.totalAmount != null && message.hasOwnProperty("totalAmount"))
                            object.totalAmount = options.json && !isFinite(message.totalAmount) ? String(message.totalAmount) : message.totalAmount;
                        if (message.metadata && message.metadata.length) {
                            object.metadata = [];
                            for (var j = 0; j < message.metadata.length; ++j)
                                object.metadata[j] = $root.palexy.streaming.v1.PosProductMetadata.toObject(message.metadata[j], options);
                        }
                        if (message.productCode != null && message.hasOwnProperty("productCode"))
                            object.productCode = message.productCode;
                        if (message.productDescription != null && message.hasOwnProperty("productDescription"))
                            object.productDescription = message.productDescription;
                        if (message.netAmount != null && message.hasOwnProperty("netAmount"))
                            object.netAmount = options.json && !isFinite(message.netAmount) ? String(message.netAmount) : message.netAmount;
                        if (message.unitBaseCost != null && message.hasOwnProperty("unitBaseCost"))
                            object.unitBaseCost = options.json && !isFinite(message.unitBaseCost) ? String(message.unitBaseCost) : message.unitBaseCost;
                        if (message.transactionTime != null && message.hasOwnProperty("transactionTime"))
                            object.transactionTime = message.transactionTime;
                        if (message.unit != null && message.hasOwnProperty("unit"))
                            object.unit = message.unit;
                        if (message.grossAmount != null && message.hasOwnProperty("grossAmount"))
                            object.grossAmount = options.json && !isFinite(message.grossAmount) ? String(message.grossAmount) : message.grossAmount;
                        if (message.discountAmount != null && message.hasOwnProperty("discountAmount"))
                            object.discountAmount = options.json && !isFinite(message.discountAmount) ? String(message.discountAmount) : message.discountAmount;
                        if (message.posExternalStaffId != null && message.hasOwnProperty("posExternalStaffId"))
                            object.posExternalStaffId = message.posExternalStaffId;
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        return object;
                    };
    
                    /**
                     * Converts this PosTransactionProduct to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosTransactionProduct
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosTransactionProduct.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosTransactionProduct;
                })();
    
                v1.PosCustomerTransaction = (function() {
    
                    /**
                     * Properties of a PosCustomerTransaction.
                     * @memberof palexy.streaming.v1
                     * @interface IPosCustomerTransaction
                     * @property {number|null} [id] PosCustomerTransaction id
                     * @property {number|null} [posTransactionId] PosCustomerTransaction posTransactionId
                     * @property {string|null} [personId] PosCustomerTransaction personId
                     * @property {string|null} [recordingTime] PosCustomerTransaction recordingTime
                     */
    
                    /**
                     * Constructs a new PosCustomerTransaction.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosCustomerTransaction.
                     * @implements IPosCustomerTransaction
                     * @constructor
                     * @param {palexy.streaming.v1.IPosCustomerTransaction=} [properties] Properties to set
                     */
                    function PosCustomerTransaction(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosCustomerTransaction id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @instance
                     */
                    PosCustomerTransaction.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosCustomerTransaction posTransactionId.
                     * @member {number} posTransactionId
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @instance
                     */
                    PosCustomerTransaction.prototype.posTransactionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosCustomerTransaction personId.
                     * @member {string} personId
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @instance
                     */
                    PosCustomerTransaction.prototype.personId = "";
    
                    /**
                     * PosCustomerTransaction recordingTime.
                     * @member {string} recordingTime
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @instance
                     */
                    PosCustomerTransaction.prototype.recordingTime = "";
    
                    /**
                     * Creates a new PosCustomerTransaction instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosCustomerTransaction=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosCustomerTransaction} PosCustomerTransaction instance
                     */
                    PosCustomerTransaction.create = function create(properties) {
                        return new PosCustomerTransaction(properties);
                    };
    
                    /**
                     * Encodes the specified PosCustomerTransaction message. Does not implicitly {@link palexy.streaming.v1.PosCustomerTransaction.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosCustomerTransaction} message PosCustomerTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosCustomerTransaction.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.posTransactionId != null && Object.hasOwnProperty.call(message, "posTransactionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.posTransactionId);
                        if (message.personId != null && Object.hasOwnProperty.call(message, "personId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.personId);
                        if (message.recordingTime != null && Object.hasOwnProperty.call(message, "recordingTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.recordingTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosCustomerTransaction message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosCustomerTransaction.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {palexy.streaming.v1.IPosCustomerTransaction} message PosCustomerTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosCustomerTransaction.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosCustomerTransaction message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosCustomerTransaction} PosCustomerTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosCustomerTransaction.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosCustomerTransaction();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.posTransactionId = reader.int64();
                                break;
                            case 3:
                                message.personId = reader.string();
                                break;
                            case 4:
                                message.recordingTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosCustomerTransaction message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosCustomerTransaction} PosCustomerTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosCustomerTransaction.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosCustomerTransaction message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosCustomerTransaction.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.posTransactionId != null && message.hasOwnProperty("posTransactionId"))
                            if (!$util.isInteger(message.posTransactionId) && !(message.posTransactionId && $util.isInteger(message.posTransactionId.low) && $util.isInteger(message.posTransactionId.high)))
                                return "posTransactionId: integer|Long expected";
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            if (!$util.isString(message.personId))
                                return "personId: string expected";
                        if (message.recordingTime != null && message.hasOwnProperty("recordingTime"))
                            if (!$util.isString(message.recordingTime))
                                return "recordingTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosCustomerTransaction message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosCustomerTransaction} PosCustomerTransaction
                     */
                    PosCustomerTransaction.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosCustomerTransaction)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosCustomerTransaction();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.posTransactionId != null)
                            if ($util.Long)
                                (message.posTransactionId = $util.Long.fromValue(object.posTransactionId)).unsigned = false;
                            else if (typeof object.posTransactionId === "string")
                                message.posTransactionId = parseInt(object.posTransactionId, 10);
                            else if (typeof object.posTransactionId === "number")
                                message.posTransactionId = object.posTransactionId;
                            else if (typeof object.posTransactionId === "object")
                                message.posTransactionId = new $util.LongBits(object.posTransactionId.low >>> 0, object.posTransactionId.high >>> 0).toNumber();
                        if (object.personId != null)
                            message.personId = String(object.personId);
                        if (object.recordingTime != null)
                            message.recordingTime = String(object.recordingTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosCustomerTransaction message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @static
                     * @param {palexy.streaming.v1.PosCustomerTransaction} message PosCustomerTransaction
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosCustomerTransaction.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.posTransactionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.posTransactionId = options.longs === String ? "0" : 0;
                            object.personId = "";
                            object.recordingTime = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.posTransactionId != null && message.hasOwnProperty("posTransactionId"))
                            if (typeof message.posTransactionId === "number")
                                object.posTransactionId = options.longs === String ? String(message.posTransactionId) : message.posTransactionId;
                            else
                                object.posTransactionId = options.longs === String ? $util.Long.prototype.toString.call(message.posTransactionId) : options.longs === Number ? new $util.LongBits(message.posTransactionId.low >>> 0, message.posTransactionId.high >>> 0).toNumber() : message.posTransactionId;
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            object.personId = message.personId;
                        if (message.recordingTime != null && message.hasOwnProperty("recordingTime"))
                            object.recordingTime = message.recordingTime;
                        return object;
                    };
    
                    /**
                     * Converts this PosCustomerTransaction to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosCustomerTransaction
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosCustomerTransaction.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosCustomerTransaction;
                })();
    
                v1.ImportResult = (function() {
    
                    /**
                     * Properties of an ImportResult.
                     * @memberof palexy.streaming.v1
                     * @interface IImportResult
                     * @property {number|null} [totalElements] ImportResult totalElements
                     * @property {number|null} [deletedElements] ImportResult deletedElements
                     * @property {number|null} [createdElements] ImportResult createdElements
                     */
    
                    /**
                     * Constructs a new ImportResult.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportResult.
                     * @implements IImportResult
                     * @constructor
                     * @param {palexy.streaming.v1.IImportResult=} [properties] Properties to set
                     */
                    function ImportResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportResult totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ImportResult
                     * @instance
                     */
                    ImportResult.prototype.totalElements = 0;
    
                    /**
                     * ImportResult deletedElements.
                     * @member {number} deletedElements
                     * @memberof palexy.streaming.v1.ImportResult
                     * @instance
                     */
                    ImportResult.prototype.deletedElements = 0;
    
                    /**
                     * ImportResult createdElements.
                     * @member {number} createdElements
                     * @memberof palexy.streaming.v1.ImportResult
                     * @instance
                     */
                    ImportResult.prototype.createdElements = 0;
    
                    /**
                     * Creates a new ImportResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {palexy.streaming.v1.IImportResult=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportResult} ImportResult instance
                     */
                    ImportResult.create = function create(properties) {
                        return new ImportResult(properties);
                    };
    
                    /**
                     * Encodes the specified ImportResult message. Does not implicitly {@link palexy.streaming.v1.ImportResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {palexy.streaming.v1.IImportResult} message ImportResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.totalElements);
                        if (message.deletedElements != null && Object.hasOwnProperty.call(message, "deletedElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.deletedElements);
                        if (message.createdElements != null && Object.hasOwnProperty.call(message, "createdElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.createdElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportResult message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {palexy.streaming.v1.IImportResult} message ImportResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportResult} ImportResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.totalElements = reader.int32();
                                break;
                            case 2:
                                message.deletedElements = reader.int32();
                                break;
                            case 3:
                                message.createdElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportResult} ImportResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportResult message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.deletedElements != null && message.hasOwnProperty("deletedElements"))
                            if (!$util.isInteger(message.deletedElements))
                                return "deletedElements: integer expected";
                        if (message.createdElements != null && message.hasOwnProperty("createdElements"))
                            if (!$util.isInteger(message.createdElements))
                                return "createdElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ImportResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportResult} ImportResult
                     */
                    ImportResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportResult)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportResult();
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.deletedElements != null)
                            message.deletedElements = object.deletedElements | 0;
                        if (object.createdElements != null)
                            message.createdElements = object.createdElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportResult
                     * @static
                     * @param {palexy.streaming.v1.ImportResult} message ImportResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.deletedElements = 0;
                            object.createdElements = 0;
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.deletedElements != null && message.hasOwnProperty("deletedElements"))
                            object.deletedElements = message.deletedElements;
                        if (message.createdElements != null && message.hasOwnProperty("createdElements"))
                            object.createdElements = message.createdElements;
                        return object;
                    };
    
                    /**
                     * Converts this ImportResult to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportResult;
                })();
    
                v1.PosImportConfig = (function() {
    
                    /**
                     * Properties of a PosImportConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IPosImportConfig
                     * @property {number|null} [id] PosImportConfig id
                     * @property {number|null} [companyId] PosImportConfig companyId
                     * @property {palexy.streaming.v1.PosImportConfig.ImportType|null} [importType] PosImportConfig importType
                     * @property {number|null} [lastImportTimeMs] PosImportConfig lastImportTimeMs
                     * @property {boolean|null} [generateTransactionId] PosImportConfig generateTransactionId
                     * @property {string|null} [storeCodeHeader] PosImportConfig storeCodeHeader
                     * @property {string|null} [productNameHeader] PosImportConfig productNameHeader
                     * @property {string|null} [productCodeHeader] PosImportConfig productCodeHeader
                     * @property {string|null} [productDescriptionHeader] PosImportConfig productDescriptionHeader
                     * @property {string|null} [unitPriceHeader] PosImportConfig unitPriceHeader
                     * @property {string|null} [quantityHeader] PosImportConfig quantityHeader
                     * @property {string|null} [totalAmountHeader] PosImportConfig totalAmountHeader
                     * @property {string|null} [terminalIdHeader] PosImportConfig terminalIdHeader
                     * @property {string|null} [transactionIdHeader] PosImportConfig transactionIdHeader
                     * @property {string|null} [currencyHeader] PosImportConfig currencyHeader
                     * @property {string|null} [transactionDateHeader] PosImportConfig transactionDateHeader
                     * @property {string|null} [transactionTimeHeader] PosImportConfig transactionTimeHeader
                     * @property {string|null} [membershipCardHeader] PosImportConfig membershipCardHeader
                     * @property {string|null} [customerIdHeader] PosImportConfig customerIdHeader
                     * @property {string|null} [salesStaffIdHeader] PosImportConfig salesStaffIdHeader
                     * @property {string|null} [netAmountHeader] PosImportConfig netAmountHeader
                     * @property {string|null} [unitBaseCostHeader] PosImportConfig unitBaseCostHeader
                     * @property {boolean|null} [zeroValueRecordsIgnored] PosImportConfig zeroValueRecordsIgnored
                     * @property {Array.<palexy.streaming.v1.PosImportConfig.IExclusionMetadata>|null} [exclusionMetadata] PosImportConfig exclusionMetadata
                     * @property {Object.<string,string>|null} [additionalPropertiesHeader] PosImportConfig additionalPropertiesHeader
                     * @property {string|null} [unitHeader] PosImportConfig unitHeader
                     * @property {string|null} [transactionDateFormat] PosImportConfig transactionDateFormat
                     * @property {string|null} [transactionTimeFormat] PosImportConfig transactionTimeFormat
                     * @property {boolean|null} [negateQuantity] PosImportConfig negateQuantity
                     * @property {boolean|null} [negateAmount] PosImportConfig negateAmount
                     * @property {string|null} [delimiter] PosImportConfig delimiter
                     * @property {boolean|null} [allowEmptyProduct] PosImportConfig allowEmptyProduct
                     * @property {palexy.streaming.v1.IPosStaffPropertiesHeaderList|null} [posStaffPropertiesHeaderList] PosImportConfig posStaffPropertiesHeaderList
                     * @property {string|null} [grossAmountHeader] PosImportConfig grossAmountHeader
                     * @property {string|null} [discountAmountHeader] PosImportConfig discountAmountHeader
                     * @property {string|null} [csvFileCharset] PosImportConfig csvFileCharset
                     * @property {string|null} [transactionTypeHeader] PosImportConfig transactionTypeHeader
                     * @property {string|null} [timezone] PosImportConfig timezone
                     * @property {string|null} [posApiUsername] PosImportConfig posApiUsername
                     * @property {string|null} [posApiPassword] PosImportConfig posApiPassword
                     * @property {string|null} [posApiIntegrationKey] PosImportConfig posApiIntegrationKey
                     * @property {string|null} [posApiBaseUrl] PosImportConfig posApiBaseUrl
                     * @property {string|null} [intradayUpdateTimeString] PosImportConfig intradayUpdateTimeString
                     * @property {number|null} [rewriteHistoricalDays] PosImportConfig rewriteHistoricalDays
                     * @property {string|null} [yesterdayUpdateTimeString] PosImportConfig yesterdayUpdateTimeString
                     * @property {boolean|null} [divideTransactionSalesEvenlyAmongStaff] PosImportConfig divideTransactionSalesEvenlyAmongStaff
                     * @property {palexy.streaming.v1.PosImportConfig.ApiProvider|null} [apiProvider] PosImportConfig apiProvider
                     * @property {string|null} [providerCompanyId] PosImportConfig providerCompanyId
                     * @property {string|null} [accessToken] PosImportConfig accessToken
                     * @property {number|null} [accessTokenExpiryMs] PosImportConfig accessTokenExpiryMs
                     * @property {string|null} [refreshToken] PosImportConfig refreshToken
                     * @property {number|null} [refreshTokenExpiryMs] PosImportConfig refreshTokenExpiryMs
                     * @property {number|null} [createTimeMs] PosImportConfig createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosImportConfig lastUpdateTimeMs
                     * @property {number|null} [revision] PosImportConfig revision
                     * @property {string|null} [companyName] PosImportConfig companyName
                     * @property {string|null} [companyCode] PosImportConfig companyCode
                     * @property {boolean|null} [posStaffSyncEnabled] PosImportConfig posStaffSyncEnabled
                     * @property {boolean|null} [generateChildStoreTransactionsFromParent] PosImportConfig generateChildStoreTransactionsFromParent
                     * @property {palexy.streaming.v1.IAsyncJobStatusSummary|null} [manualJobStatusSummary] PosImportConfig manualJobStatusSummary
                     * @property {palexy.streaming.v1.ICashierDrawingFileConfig|null} [cashierDrawingFileConfig] PosImportConfig cashierDrawingFileConfig
                     * @property {Array.<palexy.streaming.v1.ICustomStoreActionMomentConfig>|null} [customStoreActionMomentConfigs] PosImportConfig customStoreActionMomentConfigs
                     */
    
                    /**
                     * Constructs a new PosImportConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosImportConfig.
                     * @implements IPosImportConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IPosImportConfig=} [properties] Properties to set
                     */
                    function PosImportConfig(properties) {
                        this.exclusionMetadata = [];
                        this.additionalPropertiesHeader = {};
                        this.customStoreActionMomentConfigs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosImportConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig importType.
                     * @member {palexy.streaming.v1.PosImportConfig.ImportType} importType
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.importType = 0;
    
                    /**
                     * PosImportConfig lastImportTimeMs.
                     * @member {number} lastImportTimeMs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.lastImportTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig generateTransactionId.
                     * @member {boolean} generateTransactionId
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.generateTransactionId = false;
    
                    /**
                     * PosImportConfig storeCodeHeader.
                     * @member {string} storeCodeHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.storeCodeHeader = "";
    
                    /**
                     * PosImportConfig productNameHeader.
                     * @member {string} productNameHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.productNameHeader = "";
    
                    /**
                     * PosImportConfig productCodeHeader.
                     * @member {string} productCodeHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.productCodeHeader = "";
    
                    /**
                     * PosImportConfig productDescriptionHeader.
                     * @member {string} productDescriptionHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.productDescriptionHeader = "";
    
                    /**
                     * PosImportConfig unitPriceHeader.
                     * @member {string} unitPriceHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.unitPriceHeader = "";
    
                    /**
                     * PosImportConfig quantityHeader.
                     * @member {string} quantityHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.quantityHeader = "";
    
                    /**
                     * PosImportConfig totalAmountHeader.
                     * @member {string} totalAmountHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.totalAmountHeader = "";
    
                    /**
                     * PosImportConfig terminalIdHeader.
                     * @member {string} terminalIdHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.terminalIdHeader = "";
    
                    /**
                     * PosImportConfig transactionIdHeader.
                     * @member {string} transactionIdHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionIdHeader = "";
    
                    /**
                     * PosImportConfig currencyHeader.
                     * @member {string} currencyHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.currencyHeader = "";
    
                    /**
                     * PosImportConfig transactionDateHeader.
                     * @member {string} transactionDateHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionDateHeader = "";
    
                    /**
                     * PosImportConfig transactionTimeHeader.
                     * @member {string} transactionTimeHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionTimeHeader = "";
    
                    /**
                     * PosImportConfig membershipCardHeader.
                     * @member {string} membershipCardHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.membershipCardHeader = "";
    
                    /**
                     * PosImportConfig customerIdHeader.
                     * @member {string} customerIdHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.customerIdHeader = "";
    
                    /**
                     * PosImportConfig salesStaffIdHeader.
                     * @member {string} salesStaffIdHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.salesStaffIdHeader = "";
    
                    /**
                     * PosImportConfig netAmountHeader.
                     * @member {string} netAmountHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.netAmountHeader = "";
    
                    /**
                     * PosImportConfig unitBaseCostHeader.
                     * @member {string} unitBaseCostHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.unitBaseCostHeader = "";
    
                    /**
                     * PosImportConfig zeroValueRecordsIgnored.
                     * @member {boolean} zeroValueRecordsIgnored
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.zeroValueRecordsIgnored = false;
    
                    /**
                     * PosImportConfig exclusionMetadata.
                     * @member {Array.<palexy.streaming.v1.PosImportConfig.IExclusionMetadata>} exclusionMetadata
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.exclusionMetadata = $util.emptyArray;
    
                    /**
                     * PosImportConfig additionalPropertiesHeader.
                     * @member {Object.<string,string>} additionalPropertiesHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.additionalPropertiesHeader = $util.emptyObject;
    
                    /**
                     * PosImportConfig unitHeader.
                     * @member {string} unitHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.unitHeader = "";
    
                    /**
                     * PosImportConfig transactionDateFormat.
                     * @member {string} transactionDateFormat
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionDateFormat = "";
    
                    /**
                     * PosImportConfig transactionTimeFormat.
                     * @member {string} transactionTimeFormat
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionTimeFormat = "";
    
                    /**
                     * PosImportConfig negateQuantity.
                     * @member {boolean} negateQuantity
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.negateQuantity = false;
    
                    /**
                     * PosImportConfig negateAmount.
                     * @member {boolean} negateAmount
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.negateAmount = false;
    
                    /**
                     * PosImportConfig delimiter.
                     * @member {string} delimiter
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.delimiter = "";
    
                    /**
                     * PosImportConfig allowEmptyProduct.
                     * @member {boolean} allowEmptyProduct
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.allowEmptyProduct = false;
    
                    /**
                     * PosImportConfig posStaffPropertiesHeaderList.
                     * @member {palexy.streaming.v1.IPosStaffPropertiesHeaderList|null|undefined} posStaffPropertiesHeaderList
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posStaffPropertiesHeaderList = null;
    
                    /**
                     * PosImportConfig grossAmountHeader.
                     * @member {string} grossAmountHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.grossAmountHeader = "";
    
                    /**
                     * PosImportConfig discountAmountHeader.
                     * @member {string} discountAmountHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.discountAmountHeader = "";
    
                    /**
                     * PosImportConfig csvFileCharset.
                     * @member {string} csvFileCharset
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.csvFileCharset = "";
    
                    /**
                     * PosImportConfig transactionTypeHeader.
                     * @member {string} transactionTypeHeader
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.transactionTypeHeader = "";
    
                    /**
                     * PosImportConfig timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.timezone = "";
    
                    /**
                     * PosImportConfig posApiUsername.
                     * @member {string} posApiUsername
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posApiUsername = "";
    
                    /**
                     * PosImportConfig posApiPassword.
                     * @member {string} posApiPassword
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posApiPassword = "";
    
                    /**
                     * PosImportConfig posApiIntegrationKey.
                     * @member {string} posApiIntegrationKey
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posApiIntegrationKey = "";
    
                    /**
                     * PosImportConfig posApiBaseUrl.
                     * @member {string} posApiBaseUrl
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posApiBaseUrl = "";
    
                    /**
                     * PosImportConfig intradayUpdateTimeString.
                     * @member {string} intradayUpdateTimeString
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.intradayUpdateTimeString = "";
    
                    /**
                     * PosImportConfig rewriteHistoricalDays.
                     * @member {number} rewriteHistoricalDays
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.rewriteHistoricalDays = 0;
    
                    /**
                     * PosImportConfig yesterdayUpdateTimeString.
                     * @member {string} yesterdayUpdateTimeString
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.yesterdayUpdateTimeString = "";
    
                    /**
                     * PosImportConfig divideTransactionSalesEvenlyAmongStaff.
                     * @member {boolean} divideTransactionSalesEvenlyAmongStaff
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.divideTransactionSalesEvenlyAmongStaff = false;
    
                    /**
                     * PosImportConfig apiProvider.
                     * @member {palexy.streaming.v1.PosImportConfig.ApiProvider} apiProvider
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.apiProvider = 0;
    
                    /**
                     * PosImportConfig providerCompanyId.
                     * @member {string} providerCompanyId
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.providerCompanyId = "";
    
                    /**
                     * PosImportConfig accessToken.
                     * @member {string} accessToken
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.accessToken = "";
    
                    /**
                     * PosImportConfig accessTokenExpiryMs.
                     * @member {number} accessTokenExpiryMs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.accessTokenExpiryMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig refreshToken.
                     * @member {string} refreshToken
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.refreshToken = "";
    
                    /**
                     * PosImportConfig refreshTokenExpiryMs.
                     * @member {number} refreshTokenExpiryMs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.refreshTokenExpiryMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosImportConfig revision.
                     * @member {number} revision
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.revision = 0;
    
                    /**
                     * PosImportConfig companyName.
                     * @member {string} companyName
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.companyName = "";
    
                    /**
                     * PosImportConfig companyCode.
                     * @member {string} companyCode
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.companyCode = "";
    
                    /**
                     * PosImportConfig posStaffSyncEnabled.
                     * @member {boolean} posStaffSyncEnabled
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.posStaffSyncEnabled = false;
    
                    /**
                     * PosImportConfig generateChildStoreTransactionsFromParent.
                     * @member {boolean} generateChildStoreTransactionsFromParent
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.generateChildStoreTransactionsFromParent = false;
    
                    /**
                     * PosImportConfig manualJobStatusSummary.
                     * @member {palexy.streaming.v1.IAsyncJobStatusSummary|null|undefined} manualJobStatusSummary
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.manualJobStatusSummary = null;
    
                    /**
                     * PosImportConfig cashierDrawingFileConfig.
                     * @member {palexy.streaming.v1.ICashierDrawingFileConfig|null|undefined} cashierDrawingFileConfig
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.cashierDrawingFileConfig = null;
    
                    /**
                     * PosImportConfig customStoreActionMomentConfigs.
                     * @member {Array.<palexy.streaming.v1.ICustomStoreActionMomentConfig>} customStoreActionMomentConfigs
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     */
                    PosImportConfig.prototype.customStoreActionMomentConfigs = $util.emptyArray;
    
                    /**
                     * Creates a new PosImportConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosImportConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosImportConfig} PosImportConfig instance
                     */
                    PosImportConfig.create = function create(properties) {
                        return new PosImportConfig(properties);
                    };
    
                    /**
                     * Encodes the specified PosImportConfig message. Does not implicitly {@link palexy.streaming.v1.PosImportConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosImportConfig} message PosImportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosImportConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.generateTransactionId != null && Object.hasOwnProperty.call(message, "generateTransactionId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.generateTransactionId);
                        if (message.storeCodeHeader != null && Object.hasOwnProperty.call(message, "storeCodeHeader"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.storeCodeHeader);
                        if (message.productNameHeader != null && Object.hasOwnProperty.call(message, "productNameHeader"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.productNameHeader);
                        if (message.productCodeHeader != null && Object.hasOwnProperty.call(message, "productCodeHeader"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.productCodeHeader);
                        if (message.productDescriptionHeader != null && Object.hasOwnProperty.call(message, "productDescriptionHeader"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.productDescriptionHeader);
                        if (message.unitPriceHeader != null && Object.hasOwnProperty.call(message, "unitPriceHeader"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.unitPriceHeader);
                        if (message.quantityHeader != null && Object.hasOwnProperty.call(message, "quantityHeader"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.quantityHeader);
                        if (message.totalAmountHeader != null && Object.hasOwnProperty.call(message, "totalAmountHeader"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.totalAmountHeader);
                        if (message.terminalIdHeader != null && Object.hasOwnProperty.call(message, "terminalIdHeader"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.terminalIdHeader);
                        if (message.transactionIdHeader != null && Object.hasOwnProperty.call(message, "transactionIdHeader"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.transactionIdHeader);
                        if (message.currencyHeader != null && Object.hasOwnProperty.call(message, "currencyHeader"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.currencyHeader);
                        if (message.transactionDateHeader != null && Object.hasOwnProperty.call(message, "transactionDateHeader"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.transactionDateHeader);
                        if (message.transactionTimeHeader != null && Object.hasOwnProperty.call(message, "transactionTimeHeader"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.transactionTimeHeader);
                        if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.companyName);
                        if (message.membershipCardHeader != null && Object.hasOwnProperty.call(message, "membershipCardHeader"))
                            writer.uint32(/* id 17, wireType 2 =*/138).string(message.membershipCardHeader);
                        if (message.importType != null && Object.hasOwnProperty.call(message, "importType"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.importType);
                        if (message.lastImportTimeMs != null && Object.hasOwnProperty.call(message, "lastImportTimeMs"))
                            writer.uint32(/* id 19, wireType 0 =*/152).int64(message.lastImportTimeMs);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 20, wireType 2 =*/162).string(message.timezone);
                        if (message.companyCode != null && Object.hasOwnProperty.call(message, "companyCode"))
                            writer.uint32(/* id 21, wireType 2 =*/170).string(message.companyCode);
                        if (message.posApiUsername != null && Object.hasOwnProperty.call(message, "posApiUsername"))
                            writer.uint32(/* id 22, wireType 2 =*/178).string(message.posApiUsername);
                        if (message.posApiPassword != null && Object.hasOwnProperty.call(message, "posApiPassword"))
                            writer.uint32(/* id 23, wireType 2 =*/186).string(message.posApiPassword);
                        if (message.posApiIntegrationKey != null && Object.hasOwnProperty.call(message, "posApiIntegrationKey"))
                            writer.uint32(/* id 24, wireType 2 =*/194).string(message.posApiIntegrationKey);
                        if (message.posApiBaseUrl != null && Object.hasOwnProperty.call(message, "posApiBaseUrl"))
                            writer.uint32(/* id 25, wireType 2 =*/202).string(message.posApiBaseUrl);
                        if (message.customerIdHeader != null && Object.hasOwnProperty.call(message, "customerIdHeader"))
                            writer.uint32(/* id 26, wireType 2 =*/210).string(message.customerIdHeader);
                        if (message.salesStaffIdHeader != null && Object.hasOwnProperty.call(message, "salesStaffIdHeader"))
                            writer.uint32(/* id 27, wireType 2 =*/218).string(message.salesStaffIdHeader);
                        if (message.netAmountHeader != null && Object.hasOwnProperty.call(message, "netAmountHeader"))
                            writer.uint32(/* id 28, wireType 2 =*/226).string(message.netAmountHeader);
                        if (message.unitBaseCostHeader != null && Object.hasOwnProperty.call(message, "unitBaseCostHeader"))
                            writer.uint32(/* id 29, wireType 2 =*/234).string(message.unitBaseCostHeader);
                        if (message.intradayUpdateTimeString != null && Object.hasOwnProperty.call(message, "intradayUpdateTimeString"))
                            writer.uint32(/* id 30, wireType 2 =*/242).string(message.intradayUpdateTimeString);
                        if (message.rewriteHistoricalDays != null && Object.hasOwnProperty.call(message, "rewriteHistoricalDays"))
                            writer.uint32(/* id 31, wireType 0 =*/248).int32(message.rewriteHistoricalDays);
                        if (message.yesterdayUpdateTimeString != null && Object.hasOwnProperty.call(message, "yesterdayUpdateTimeString"))
                            writer.uint32(/* id 32, wireType 2 =*/258).string(message.yesterdayUpdateTimeString);
                        if (message.zeroValueRecordsIgnored != null && Object.hasOwnProperty.call(message, "zeroValueRecordsIgnored"))
                            writer.uint32(/* id 33, wireType 0 =*/264).bool(message.zeroValueRecordsIgnored);
                        if (message.exclusionMetadata != null && message.exclusionMetadata.length)
                            for (var i = 0; i < message.exclusionMetadata.length; ++i)
                                $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata.encode(message.exclusionMetadata[i], writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.additionalPropertiesHeader != null && Object.hasOwnProperty.call(message, "additionalPropertiesHeader"))
                            for (var keys = Object.keys(message.additionalPropertiesHeader), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 35, wireType 2 =*/282).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalPropertiesHeader[keys[i]]).ldelim();
                        if (message.unitHeader != null && Object.hasOwnProperty.call(message, "unitHeader"))
                            writer.uint32(/* id 36, wireType 2 =*/290).string(message.unitHeader);
                        if (message.transactionDateFormat != null && Object.hasOwnProperty.call(message, "transactionDateFormat"))
                            writer.uint32(/* id 37, wireType 2 =*/298).string(message.transactionDateFormat);
                        if (message.transactionTimeFormat != null && Object.hasOwnProperty.call(message, "transactionTimeFormat"))
                            writer.uint32(/* id 38, wireType 2 =*/306).string(message.transactionTimeFormat);
                        if (message.negateQuantity != null && Object.hasOwnProperty.call(message, "negateQuantity"))
                            writer.uint32(/* id 39, wireType 0 =*/312).bool(message.negateQuantity);
                        if (message.negateAmount != null && Object.hasOwnProperty.call(message, "negateAmount"))
                            writer.uint32(/* id 40, wireType 0 =*/320).bool(message.negateAmount);
                        if (message.manualJobStatusSummary != null && Object.hasOwnProperty.call(message, "manualJobStatusSummary"))
                            $root.palexy.streaming.v1.AsyncJobStatusSummary.encode(message.manualJobStatusSummary, writer.uint32(/* id 41, wireType 2 =*/330).fork()).ldelim();
                        if (message.delimiter != null && Object.hasOwnProperty.call(message, "delimiter"))
                            writer.uint32(/* id 42, wireType 2 =*/338).string(message.delimiter);
                        if (message.allowEmptyProduct != null && Object.hasOwnProperty.call(message, "allowEmptyProduct"))
                            writer.uint32(/* id 43, wireType 0 =*/344).bool(message.allowEmptyProduct);
                        if (message.posStaffSyncEnabled != null && Object.hasOwnProperty.call(message, "posStaffSyncEnabled"))
                            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.posStaffSyncEnabled);
                        if (message.posStaffPropertiesHeaderList != null && Object.hasOwnProperty.call(message, "posStaffPropertiesHeaderList"))
                            $root.palexy.streaming.v1.PosStaffPropertiesHeaderList.encode(message.posStaffPropertiesHeaderList, writer.uint32(/* id 45, wireType 2 =*/362).fork()).ldelim();
                        if (message.grossAmountHeader != null && Object.hasOwnProperty.call(message, "grossAmountHeader"))
                            writer.uint32(/* id 46, wireType 2 =*/370).string(message.grossAmountHeader);
                        if (message.discountAmountHeader != null && Object.hasOwnProperty.call(message, "discountAmountHeader"))
                            writer.uint32(/* id 47, wireType 2 =*/378).string(message.discountAmountHeader);
                        if (message.csvFileCharset != null && Object.hasOwnProperty.call(message, "csvFileCharset"))
                            writer.uint32(/* id 48, wireType 2 =*/386).string(message.csvFileCharset);
                        if (message.generateChildStoreTransactionsFromParent != null && Object.hasOwnProperty.call(message, "generateChildStoreTransactionsFromParent"))
                            writer.uint32(/* id 49, wireType 0 =*/392).bool(message.generateChildStoreTransactionsFromParent);
                        if (message.transactionTypeHeader != null && Object.hasOwnProperty.call(message, "transactionTypeHeader"))
                            writer.uint32(/* id 50, wireType 2 =*/402).string(message.transactionTypeHeader);
                        if (message.divideTransactionSalesEvenlyAmongStaff != null && Object.hasOwnProperty.call(message, "divideTransactionSalesEvenlyAmongStaff"))
                            writer.uint32(/* id 51, wireType 0 =*/408).bool(message.divideTransactionSalesEvenlyAmongStaff);
                        if (message.cashierDrawingFileConfig != null && Object.hasOwnProperty.call(message, "cashierDrawingFileConfig"))
                            $root.palexy.streaming.v1.CashierDrawingFileConfig.encode(message.cashierDrawingFileConfig, writer.uint32(/* id 52, wireType 2 =*/418).fork()).ldelim();
                        if (message.customStoreActionMomentConfigs != null && message.customStoreActionMomentConfigs.length)
                            for (var i = 0; i < message.customStoreActionMomentConfigs.length; ++i)
                                $root.palexy.streaming.v1.CustomStoreActionMomentConfig.encode(message.customStoreActionMomentConfigs[i], writer.uint32(/* id 53, wireType 2 =*/426).fork()).ldelim();
                        if (message.apiProvider != null && Object.hasOwnProperty.call(message, "apiProvider"))
                            writer.uint32(/* id 54, wireType 0 =*/432).int32(message.apiProvider);
                        if (message.providerCompanyId != null && Object.hasOwnProperty.call(message, "providerCompanyId"))
                            writer.uint32(/* id 55, wireType 2 =*/442).string(message.providerCompanyId);
                        if (message.accessToken != null && Object.hasOwnProperty.call(message, "accessToken"))
                            writer.uint32(/* id 56, wireType 2 =*/450).string(message.accessToken);
                        if (message.accessTokenExpiryMs != null && Object.hasOwnProperty.call(message, "accessTokenExpiryMs"))
                            writer.uint32(/* id 57, wireType 0 =*/456).int64(message.accessTokenExpiryMs);
                        if (message.refreshToken != null && Object.hasOwnProperty.call(message, "refreshToken"))
                            writer.uint32(/* id 58, wireType 2 =*/466).string(message.refreshToken);
                        if (message.refreshTokenExpiryMs != null && Object.hasOwnProperty.call(message, "refreshTokenExpiryMs"))
                            writer.uint32(/* id 59, wireType 0 =*/472).int64(message.refreshTokenExpiryMs);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 60, wireType 0 =*/480).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 61, wireType 0 =*/488).int64(message.lastUpdateTimeMs);
                        if (message.revision != null && Object.hasOwnProperty.call(message, "revision"))
                            writer.uint32(/* id 62, wireType 0 =*/496).int32(message.revision);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosImportConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosImportConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosImportConfig} message PosImportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosImportConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosImportConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosImportConfig} PosImportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosImportConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosImportConfig(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 18:
                                message.importType = reader.int32();
                                break;
                            case 19:
                                message.lastImportTimeMs = reader.int64();
                                break;
                            case 3:
                                message.generateTransactionId = reader.bool();
                                break;
                            case 4:
                                message.storeCodeHeader = reader.string();
                                break;
                            case 5:
                                message.productNameHeader = reader.string();
                                break;
                            case 6:
                                message.productCodeHeader = reader.string();
                                break;
                            case 7:
                                message.productDescriptionHeader = reader.string();
                                break;
                            case 8:
                                message.unitPriceHeader = reader.string();
                                break;
                            case 9:
                                message.quantityHeader = reader.string();
                                break;
                            case 10:
                                message.totalAmountHeader = reader.string();
                                break;
                            case 11:
                                message.terminalIdHeader = reader.string();
                                break;
                            case 12:
                                message.transactionIdHeader = reader.string();
                                break;
                            case 13:
                                message.currencyHeader = reader.string();
                                break;
                            case 14:
                                message.transactionDateHeader = reader.string();
                                break;
                            case 15:
                                message.transactionTimeHeader = reader.string();
                                break;
                            case 17:
                                message.membershipCardHeader = reader.string();
                                break;
                            case 26:
                                message.customerIdHeader = reader.string();
                                break;
                            case 27:
                                message.salesStaffIdHeader = reader.string();
                                break;
                            case 28:
                                message.netAmountHeader = reader.string();
                                break;
                            case 29:
                                message.unitBaseCostHeader = reader.string();
                                break;
                            case 33:
                                message.zeroValueRecordsIgnored = reader.bool();
                                break;
                            case 34:
                                if (!(message.exclusionMetadata && message.exclusionMetadata.length))
                                    message.exclusionMetadata = [];
                                message.exclusionMetadata.push($root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata.decode(reader, reader.uint32()));
                                break;
                            case 35:
                                if (message.additionalPropertiesHeader === $util.emptyObject)
                                    message.additionalPropertiesHeader = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.additionalPropertiesHeader[key] = value;
                                break;
                            case 36:
                                message.unitHeader = reader.string();
                                break;
                            case 37:
                                message.transactionDateFormat = reader.string();
                                break;
                            case 38:
                                message.transactionTimeFormat = reader.string();
                                break;
                            case 39:
                                message.negateQuantity = reader.bool();
                                break;
                            case 40:
                                message.negateAmount = reader.bool();
                                break;
                            case 42:
                                message.delimiter = reader.string();
                                break;
                            case 43:
                                message.allowEmptyProduct = reader.bool();
                                break;
                            case 45:
                                message.posStaffPropertiesHeaderList = $root.palexy.streaming.v1.PosStaffPropertiesHeaderList.decode(reader, reader.uint32());
                                break;
                            case 46:
                                message.grossAmountHeader = reader.string();
                                break;
                            case 47:
                                message.discountAmountHeader = reader.string();
                                break;
                            case 48:
                                message.csvFileCharset = reader.string();
                                break;
                            case 50:
                                message.transactionTypeHeader = reader.string();
                                break;
                            case 20:
                                message.timezone = reader.string();
                                break;
                            case 22:
                                message.posApiUsername = reader.string();
                                break;
                            case 23:
                                message.posApiPassword = reader.string();
                                break;
                            case 24:
                                message.posApiIntegrationKey = reader.string();
                                break;
                            case 25:
                                message.posApiBaseUrl = reader.string();
                                break;
                            case 30:
                                message.intradayUpdateTimeString = reader.string();
                                break;
                            case 31:
                                message.rewriteHistoricalDays = reader.int32();
                                break;
                            case 32:
                                message.yesterdayUpdateTimeString = reader.string();
                                break;
                            case 51:
                                message.divideTransactionSalesEvenlyAmongStaff = reader.bool();
                                break;
                            case 54:
                                message.apiProvider = reader.int32();
                                break;
                            case 55:
                                message.providerCompanyId = reader.string();
                                break;
                            case 56:
                                message.accessToken = reader.string();
                                break;
                            case 57:
                                message.accessTokenExpiryMs = reader.int64();
                                break;
                            case 58:
                                message.refreshToken = reader.string();
                                break;
                            case 59:
                                message.refreshTokenExpiryMs = reader.int64();
                                break;
                            case 60:
                                message.createTimeMs = reader.int64();
                                break;
                            case 61:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 62:
                                message.revision = reader.int32();
                                break;
                            case 16:
                                message.companyName = reader.string();
                                break;
                            case 21:
                                message.companyCode = reader.string();
                                break;
                            case 44:
                                message.posStaffSyncEnabled = reader.bool();
                                break;
                            case 49:
                                message.generateChildStoreTransactionsFromParent = reader.bool();
                                break;
                            case 41:
                                message.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.decode(reader, reader.uint32());
                                break;
                            case 52:
                                message.cashierDrawingFileConfig = $root.palexy.streaming.v1.CashierDrawingFileConfig.decode(reader, reader.uint32());
                                break;
                            case 53:
                                if (!(message.customStoreActionMomentConfigs && message.customStoreActionMomentConfigs.length))
                                    message.customStoreActionMomentConfigs = [];
                                message.customStoreActionMomentConfigs.push($root.palexy.streaming.v1.CustomStoreActionMomentConfig.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosImportConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosImportConfig} PosImportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosImportConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosImportConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosImportConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.importType != null && message.hasOwnProperty("importType"))
                            switch (message.importType) {
                            default:
                                return "importType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.lastImportTimeMs != null && message.hasOwnProperty("lastImportTimeMs"))
                            if (!$util.isInteger(message.lastImportTimeMs) && !(message.lastImportTimeMs && $util.isInteger(message.lastImportTimeMs.low) && $util.isInteger(message.lastImportTimeMs.high)))
                                return "lastImportTimeMs: integer|Long expected";
                        if (message.generateTransactionId != null && message.hasOwnProperty("generateTransactionId"))
                            if (typeof message.generateTransactionId !== "boolean")
                                return "generateTransactionId: boolean expected";
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            if (!$util.isString(message.storeCodeHeader))
                                return "storeCodeHeader: string expected";
                        if (message.productNameHeader != null && message.hasOwnProperty("productNameHeader"))
                            if (!$util.isString(message.productNameHeader))
                                return "productNameHeader: string expected";
                        if (message.productCodeHeader != null && message.hasOwnProperty("productCodeHeader"))
                            if (!$util.isString(message.productCodeHeader))
                                return "productCodeHeader: string expected";
                        if (message.productDescriptionHeader != null && message.hasOwnProperty("productDescriptionHeader"))
                            if (!$util.isString(message.productDescriptionHeader))
                                return "productDescriptionHeader: string expected";
                        if (message.unitPriceHeader != null && message.hasOwnProperty("unitPriceHeader"))
                            if (!$util.isString(message.unitPriceHeader))
                                return "unitPriceHeader: string expected";
                        if (message.quantityHeader != null && message.hasOwnProperty("quantityHeader"))
                            if (!$util.isString(message.quantityHeader))
                                return "quantityHeader: string expected";
                        if (message.totalAmountHeader != null && message.hasOwnProperty("totalAmountHeader"))
                            if (!$util.isString(message.totalAmountHeader))
                                return "totalAmountHeader: string expected";
                        if (message.terminalIdHeader != null && message.hasOwnProperty("terminalIdHeader"))
                            if (!$util.isString(message.terminalIdHeader))
                                return "terminalIdHeader: string expected";
                        if (message.transactionIdHeader != null && message.hasOwnProperty("transactionIdHeader"))
                            if (!$util.isString(message.transactionIdHeader))
                                return "transactionIdHeader: string expected";
                        if (message.currencyHeader != null && message.hasOwnProperty("currencyHeader"))
                            if (!$util.isString(message.currencyHeader))
                                return "currencyHeader: string expected";
                        if (message.transactionDateHeader != null && message.hasOwnProperty("transactionDateHeader"))
                            if (!$util.isString(message.transactionDateHeader))
                                return "transactionDateHeader: string expected";
                        if (message.transactionTimeHeader != null && message.hasOwnProperty("transactionTimeHeader"))
                            if (!$util.isString(message.transactionTimeHeader))
                                return "transactionTimeHeader: string expected";
                        if (message.membershipCardHeader != null && message.hasOwnProperty("membershipCardHeader"))
                            if (!$util.isString(message.membershipCardHeader))
                                return "membershipCardHeader: string expected";
                        if (message.customerIdHeader != null && message.hasOwnProperty("customerIdHeader"))
                            if (!$util.isString(message.customerIdHeader))
                                return "customerIdHeader: string expected";
                        if (message.salesStaffIdHeader != null && message.hasOwnProperty("salesStaffIdHeader"))
                            if (!$util.isString(message.salesStaffIdHeader))
                                return "salesStaffIdHeader: string expected";
                        if (message.netAmountHeader != null && message.hasOwnProperty("netAmountHeader"))
                            if (!$util.isString(message.netAmountHeader))
                                return "netAmountHeader: string expected";
                        if (message.unitBaseCostHeader != null && message.hasOwnProperty("unitBaseCostHeader"))
                            if (!$util.isString(message.unitBaseCostHeader))
                                return "unitBaseCostHeader: string expected";
                        if (message.zeroValueRecordsIgnored != null && message.hasOwnProperty("zeroValueRecordsIgnored"))
                            if (typeof message.zeroValueRecordsIgnored !== "boolean")
                                return "zeroValueRecordsIgnored: boolean expected";
                        if (message.exclusionMetadata != null && message.hasOwnProperty("exclusionMetadata")) {
                            if (!Array.isArray(message.exclusionMetadata))
                                return "exclusionMetadata: array expected";
                            for (var i = 0; i < message.exclusionMetadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata.verify(message.exclusionMetadata[i]);
                                if (error)
                                    return "exclusionMetadata." + error;
                            }
                        }
                        if (message.additionalPropertiesHeader != null && message.hasOwnProperty("additionalPropertiesHeader")) {
                            if (!$util.isObject(message.additionalPropertiesHeader))
                                return "additionalPropertiesHeader: object expected";
                            var key = Object.keys(message.additionalPropertiesHeader);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.additionalPropertiesHeader[key[i]]))
                                    return "additionalPropertiesHeader: string{k:string} expected";
                        }
                        if (message.unitHeader != null && message.hasOwnProperty("unitHeader"))
                            if (!$util.isString(message.unitHeader))
                                return "unitHeader: string expected";
                        if (message.transactionDateFormat != null && message.hasOwnProperty("transactionDateFormat"))
                            if (!$util.isString(message.transactionDateFormat))
                                return "transactionDateFormat: string expected";
                        if (message.transactionTimeFormat != null && message.hasOwnProperty("transactionTimeFormat"))
                            if (!$util.isString(message.transactionTimeFormat))
                                return "transactionTimeFormat: string expected";
                        if (message.negateQuantity != null && message.hasOwnProperty("negateQuantity"))
                            if (typeof message.negateQuantity !== "boolean")
                                return "negateQuantity: boolean expected";
                        if (message.negateAmount != null && message.hasOwnProperty("negateAmount"))
                            if (typeof message.negateAmount !== "boolean")
                                return "negateAmount: boolean expected";
                        if (message.delimiter != null && message.hasOwnProperty("delimiter"))
                            if (!$util.isString(message.delimiter))
                                return "delimiter: string expected";
                        if (message.allowEmptyProduct != null && message.hasOwnProperty("allowEmptyProduct"))
                            if (typeof message.allowEmptyProduct !== "boolean")
                                return "allowEmptyProduct: boolean expected";
                        if (message.posStaffPropertiesHeaderList != null && message.hasOwnProperty("posStaffPropertiesHeaderList")) {
                            var error = $root.palexy.streaming.v1.PosStaffPropertiesHeaderList.verify(message.posStaffPropertiesHeaderList);
                            if (error)
                                return "posStaffPropertiesHeaderList." + error;
                        }
                        if (message.grossAmountHeader != null && message.hasOwnProperty("grossAmountHeader"))
                            if (!$util.isString(message.grossAmountHeader))
                                return "grossAmountHeader: string expected";
                        if (message.discountAmountHeader != null && message.hasOwnProperty("discountAmountHeader"))
                            if (!$util.isString(message.discountAmountHeader))
                                return "discountAmountHeader: string expected";
                        if (message.csvFileCharset != null && message.hasOwnProperty("csvFileCharset"))
                            if (!$util.isString(message.csvFileCharset))
                                return "csvFileCharset: string expected";
                        if (message.transactionTypeHeader != null && message.hasOwnProperty("transactionTypeHeader"))
                            if (!$util.isString(message.transactionTypeHeader))
                                return "transactionTypeHeader: string expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.posApiUsername != null && message.hasOwnProperty("posApiUsername"))
                            if (!$util.isString(message.posApiUsername))
                                return "posApiUsername: string expected";
                        if (message.posApiPassword != null && message.hasOwnProperty("posApiPassword"))
                            if (!$util.isString(message.posApiPassword))
                                return "posApiPassword: string expected";
                        if (message.posApiIntegrationKey != null && message.hasOwnProperty("posApiIntegrationKey"))
                            if (!$util.isString(message.posApiIntegrationKey))
                                return "posApiIntegrationKey: string expected";
                        if (message.posApiBaseUrl != null && message.hasOwnProperty("posApiBaseUrl"))
                            if (!$util.isString(message.posApiBaseUrl))
                                return "posApiBaseUrl: string expected";
                        if (message.intradayUpdateTimeString != null && message.hasOwnProperty("intradayUpdateTimeString"))
                            if (!$util.isString(message.intradayUpdateTimeString))
                                return "intradayUpdateTimeString: string expected";
                        if (message.rewriteHistoricalDays != null && message.hasOwnProperty("rewriteHistoricalDays"))
                            if (!$util.isInteger(message.rewriteHistoricalDays))
                                return "rewriteHistoricalDays: integer expected";
                        if (message.yesterdayUpdateTimeString != null && message.hasOwnProperty("yesterdayUpdateTimeString"))
                            if (!$util.isString(message.yesterdayUpdateTimeString))
                                return "yesterdayUpdateTimeString: string expected";
                        if (message.divideTransactionSalesEvenlyAmongStaff != null && message.hasOwnProperty("divideTransactionSalesEvenlyAmongStaff"))
                            if (typeof message.divideTransactionSalesEvenlyAmongStaff !== "boolean")
                                return "divideTransactionSalesEvenlyAmongStaff: boolean expected";
                        if (message.apiProvider != null && message.hasOwnProperty("apiProvider"))
                            switch (message.apiProvider) {
                            default:
                                return "apiProvider: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId"))
                            if (!$util.isString(message.providerCompanyId))
                                return "providerCompanyId: string expected";
                        if (message.accessToken != null && message.hasOwnProperty("accessToken"))
                            if (!$util.isString(message.accessToken))
                                return "accessToken: string expected";
                        if (message.accessTokenExpiryMs != null && message.hasOwnProperty("accessTokenExpiryMs"))
                            if (!$util.isInteger(message.accessTokenExpiryMs) && !(message.accessTokenExpiryMs && $util.isInteger(message.accessTokenExpiryMs.low) && $util.isInteger(message.accessTokenExpiryMs.high)))
                                return "accessTokenExpiryMs: integer|Long expected";
                        if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                            if (!$util.isString(message.refreshToken))
                                return "refreshToken: string expected";
                        if (message.refreshTokenExpiryMs != null && message.hasOwnProperty("refreshTokenExpiryMs"))
                            if (!$util.isInteger(message.refreshTokenExpiryMs) && !(message.refreshTokenExpiryMs && $util.isInteger(message.refreshTokenExpiryMs.low) && $util.isInteger(message.refreshTokenExpiryMs.high)))
                                return "refreshTokenExpiryMs: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.revision != null && message.hasOwnProperty("revision"))
                            if (!$util.isInteger(message.revision))
                                return "revision: integer expected";
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            if (!$util.isString(message.companyName))
                                return "companyName: string expected";
                        if (message.companyCode != null && message.hasOwnProperty("companyCode"))
                            if (!$util.isString(message.companyCode))
                                return "companyCode: string expected";
                        if (message.posStaffSyncEnabled != null && message.hasOwnProperty("posStaffSyncEnabled"))
                            if (typeof message.posStaffSyncEnabled !== "boolean")
                                return "posStaffSyncEnabled: boolean expected";
                        if (message.generateChildStoreTransactionsFromParent != null && message.hasOwnProperty("generateChildStoreTransactionsFromParent"))
                            if (typeof message.generateChildStoreTransactionsFromParent !== "boolean")
                                return "generateChildStoreTransactionsFromParent: boolean expected";
                        if (message.manualJobStatusSummary != null && message.hasOwnProperty("manualJobStatusSummary")) {
                            var error = $root.palexy.streaming.v1.AsyncJobStatusSummary.verify(message.manualJobStatusSummary);
                            if (error)
                                return "manualJobStatusSummary." + error;
                        }
                        if (message.cashierDrawingFileConfig != null && message.hasOwnProperty("cashierDrawingFileConfig")) {
                            var error = $root.palexy.streaming.v1.CashierDrawingFileConfig.verify(message.cashierDrawingFileConfig);
                            if (error)
                                return "cashierDrawingFileConfig." + error;
                        }
                        if (message.customStoreActionMomentConfigs != null && message.hasOwnProperty("customStoreActionMomentConfigs")) {
                            if (!Array.isArray(message.customStoreActionMomentConfigs))
                                return "customStoreActionMomentConfigs: array expected";
                            for (var i = 0; i < message.customStoreActionMomentConfigs.length; ++i) {
                                var error = $root.palexy.streaming.v1.CustomStoreActionMomentConfig.verify(message.customStoreActionMomentConfigs[i]);
                                if (error)
                                    return "customStoreActionMomentConfigs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosImportConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosImportConfig} PosImportConfig
                     */
                    PosImportConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosImportConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosImportConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.importType) {
                        case "UNKNOWN":
                        case 0:
                            message.importType = 0;
                            break;
                        case "CSV":
                        case 1:
                            message.importType = 1;
                            break;
                        case "REST_API":
                        case 2:
                            message.importType = 2;
                            break;
                        case "MANUAL_SYNC_API":
                        case 3:
                            message.importType = 3;
                            break;
                        }
                        if (object.lastImportTimeMs != null)
                            if ($util.Long)
                                (message.lastImportTimeMs = $util.Long.fromValue(object.lastImportTimeMs)).unsigned = false;
                            else if (typeof object.lastImportTimeMs === "string")
                                message.lastImportTimeMs = parseInt(object.lastImportTimeMs, 10);
                            else if (typeof object.lastImportTimeMs === "number")
                                message.lastImportTimeMs = object.lastImportTimeMs;
                            else if (typeof object.lastImportTimeMs === "object")
                                message.lastImportTimeMs = new $util.LongBits(object.lastImportTimeMs.low >>> 0, object.lastImportTimeMs.high >>> 0).toNumber();
                        if (object.generateTransactionId != null)
                            message.generateTransactionId = Boolean(object.generateTransactionId);
                        if (object.storeCodeHeader != null)
                            message.storeCodeHeader = String(object.storeCodeHeader);
                        if (object.productNameHeader != null)
                            message.productNameHeader = String(object.productNameHeader);
                        if (object.productCodeHeader != null)
                            message.productCodeHeader = String(object.productCodeHeader);
                        if (object.productDescriptionHeader != null)
                            message.productDescriptionHeader = String(object.productDescriptionHeader);
                        if (object.unitPriceHeader != null)
                            message.unitPriceHeader = String(object.unitPriceHeader);
                        if (object.quantityHeader != null)
                            message.quantityHeader = String(object.quantityHeader);
                        if (object.totalAmountHeader != null)
                            message.totalAmountHeader = String(object.totalAmountHeader);
                        if (object.terminalIdHeader != null)
                            message.terminalIdHeader = String(object.terminalIdHeader);
                        if (object.transactionIdHeader != null)
                            message.transactionIdHeader = String(object.transactionIdHeader);
                        if (object.currencyHeader != null)
                            message.currencyHeader = String(object.currencyHeader);
                        if (object.transactionDateHeader != null)
                            message.transactionDateHeader = String(object.transactionDateHeader);
                        if (object.transactionTimeHeader != null)
                            message.transactionTimeHeader = String(object.transactionTimeHeader);
                        if (object.membershipCardHeader != null)
                            message.membershipCardHeader = String(object.membershipCardHeader);
                        if (object.customerIdHeader != null)
                            message.customerIdHeader = String(object.customerIdHeader);
                        if (object.salesStaffIdHeader != null)
                            message.salesStaffIdHeader = String(object.salesStaffIdHeader);
                        if (object.netAmountHeader != null)
                            message.netAmountHeader = String(object.netAmountHeader);
                        if (object.unitBaseCostHeader != null)
                            message.unitBaseCostHeader = String(object.unitBaseCostHeader);
                        if (object.zeroValueRecordsIgnored != null)
                            message.zeroValueRecordsIgnored = Boolean(object.zeroValueRecordsIgnored);
                        if (object.exclusionMetadata) {
                            if (!Array.isArray(object.exclusionMetadata))
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.exclusionMetadata: array expected");
                            message.exclusionMetadata = [];
                            for (var i = 0; i < object.exclusionMetadata.length; ++i) {
                                if (typeof object.exclusionMetadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosImportConfig.exclusionMetadata: object expected");
                                message.exclusionMetadata[i] = $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata.fromObject(object.exclusionMetadata[i]);
                            }
                        }
                        if (object.additionalPropertiesHeader) {
                            if (typeof object.additionalPropertiesHeader !== "object")
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.additionalPropertiesHeader: object expected");
                            message.additionalPropertiesHeader = {};
                            for (var keys = Object.keys(object.additionalPropertiesHeader), i = 0; i < keys.length; ++i)
                                message.additionalPropertiesHeader[keys[i]] = String(object.additionalPropertiesHeader[keys[i]]);
                        }
                        if (object.unitHeader != null)
                            message.unitHeader = String(object.unitHeader);
                        if (object.transactionDateFormat != null)
                            message.transactionDateFormat = String(object.transactionDateFormat);
                        if (object.transactionTimeFormat != null)
                            message.transactionTimeFormat = String(object.transactionTimeFormat);
                        if (object.negateQuantity != null)
                            message.negateQuantity = Boolean(object.negateQuantity);
                        if (object.negateAmount != null)
                            message.negateAmount = Boolean(object.negateAmount);
                        if (object.delimiter != null)
                            message.delimiter = String(object.delimiter);
                        if (object.allowEmptyProduct != null)
                            message.allowEmptyProduct = Boolean(object.allowEmptyProduct);
                        if (object.posStaffPropertiesHeaderList != null) {
                            if (typeof object.posStaffPropertiesHeaderList !== "object")
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.posStaffPropertiesHeaderList: object expected");
                            message.posStaffPropertiesHeaderList = $root.palexy.streaming.v1.PosStaffPropertiesHeaderList.fromObject(object.posStaffPropertiesHeaderList);
                        }
                        if (object.grossAmountHeader != null)
                            message.grossAmountHeader = String(object.grossAmountHeader);
                        if (object.discountAmountHeader != null)
                            message.discountAmountHeader = String(object.discountAmountHeader);
                        if (object.csvFileCharset != null)
                            message.csvFileCharset = String(object.csvFileCharset);
                        if (object.transactionTypeHeader != null)
                            message.transactionTypeHeader = String(object.transactionTypeHeader);
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.posApiUsername != null)
                            message.posApiUsername = String(object.posApiUsername);
                        if (object.posApiPassword != null)
                            message.posApiPassword = String(object.posApiPassword);
                        if (object.posApiIntegrationKey != null)
                            message.posApiIntegrationKey = String(object.posApiIntegrationKey);
                        if (object.posApiBaseUrl != null)
                            message.posApiBaseUrl = String(object.posApiBaseUrl);
                        if (object.intradayUpdateTimeString != null)
                            message.intradayUpdateTimeString = String(object.intradayUpdateTimeString);
                        if (object.rewriteHistoricalDays != null)
                            message.rewriteHistoricalDays = object.rewriteHistoricalDays | 0;
                        if (object.yesterdayUpdateTimeString != null)
                            message.yesterdayUpdateTimeString = String(object.yesterdayUpdateTimeString);
                        if (object.divideTransactionSalesEvenlyAmongStaff != null)
                            message.divideTransactionSalesEvenlyAmongStaff = Boolean(object.divideTransactionSalesEvenlyAmongStaff);
                        switch (object.apiProvider) {
                        case "API_PROVIDER_UNSPECIFIED":
                        case 0:
                            message.apiProvider = 0;
                            break;
                        case "NHANHVN":
                        case 1:
                            message.apiProvider = 1;
                            break;
                        }
                        if (object.providerCompanyId != null)
                            message.providerCompanyId = String(object.providerCompanyId);
                        if (object.accessToken != null)
                            message.accessToken = String(object.accessToken);
                        if (object.accessTokenExpiryMs != null)
                            if ($util.Long)
                                (message.accessTokenExpiryMs = $util.Long.fromValue(object.accessTokenExpiryMs)).unsigned = false;
                            else if (typeof object.accessTokenExpiryMs === "string")
                                message.accessTokenExpiryMs = parseInt(object.accessTokenExpiryMs, 10);
                            else if (typeof object.accessTokenExpiryMs === "number")
                                message.accessTokenExpiryMs = object.accessTokenExpiryMs;
                            else if (typeof object.accessTokenExpiryMs === "object")
                                message.accessTokenExpiryMs = new $util.LongBits(object.accessTokenExpiryMs.low >>> 0, object.accessTokenExpiryMs.high >>> 0).toNumber();
                        if (object.refreshToken != null)
                            message.refreshToken = String(object.refreshToken);
                        if (object.refreshTokenExpiryMs != null)
                            if ($util.Long)
                                (message.refreshTokenExpiryMs = $util.Long.fromValue(object.refreshTokenExpiryMs)).unsigned = false;
                            else if (typeof object.refreshTokenExpiryMs === "string")
                                message.refreshTokenExpiryMs = parseInt(object.refreshTokenExpiryMs, 10);
                            else if (typeof object.refreshTokenExpiryMs === "number")
                                message.refreshTokenExpiryMs = object.refreshTokenExpiryMs;
                            else if (typeof object.refreshTokenExpiryMs === "object")
                                message.refreshTokenExpiryMs = new $util.LongBits(object.refreshTokenExpiryMs.low >>> 0, object.refreshTokenExpiryMs.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.revision != null)
                            message.revision = object.revision | 0;
                        if (object.companyName != null)
                            message.companyName = String(object.companyName);
                        if (object.companyCode != null)
                            message.companyCode = String(object.companyCode);
                        if (object.posStaffSyncEnabled != null)
                            message.posStaffSyncEnabled = Boolean(object.posStaffSyncEnabled);
                        if (object.generateChildStoreTransactionsFromParent != null)
                            message.generateChildStoreTransactionsFromParent = Boolean(object.generateChildStoreTransactionsFromParent);
                        if (object.manualJobStatusSummary != null) {
                            if (typeof object.manualJobStatusSummary !== "object")
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.manualJobStatusSummary: object expected");
                            message.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.fromObject(object.manualJobStatusSummary);
                        }
                        if (object.cashierDrawingFileConfig != null) {
                            if (typeof object.cashierDrawingFileConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.cashierDrawingFileConfig: object expected");
                            message.cashierDrawingFileConfig = $root.palexy.streaming.v1.CashierDrawingFileConfig.fromObject(object.cashierDrawingFileConfig);
                        }
                        if (object.customStoreActionMomentConfigs) {
                            if (!Array.isArray(object.customStoreActionMomentConfigs))
                                throw TypeError(".palexy.streaming.v1.PosImportConfig.customStoreActionMomentConfigs: array expected");
                            message.customStoreActionMomentConfigs = [];
                            for (var i = 0; i < object.customStoreActionMomentConfigs.length; ++i) {
                                if (typeof object.customStoreActionMomentConfigs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosImportConfig.customStoreActionMomentConfigs: object expected");
                                message.customStoreActionMomentConfigs[i] = $root.palexy.streaming.v1.CustomStoreActionMomentConfig.fromObject(object.customStoreActionMomentConfigs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosImportConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @static
                     * @param {palexy.streaming.v1.PosImportConfig} message PosImportConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosImportConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.exclusionMetadata = [];
                            object.customStoreActionMomentConfigs = [];
                        }
                        if (options.objects || options.defaults)
                            object.additionalPropertiesHeader = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.generateTransactionId = false;
                            object.storeCodeHeader = "";
                            object.productNameHeader = "";
                            object.productCodeHeader = "";
                            object.productDescriptionHeader = "";
                            object.unitPriceHeader = "";
                            object.quantityHeader = "";
                            object.totalAmountHeader = "";
                            object.terminalIdHeader = "";
                            object.transactionIdHeader = "";
                            object.currencyHeader = "";
                            object.transactionDateHeader = "";
                            object.transactionTimeHeader = "";
                            object.companyName = "";
                            object.membershipCardHeader = "";
                            object.importType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastImportTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastImportTimeMs = options.longs === String ? "0" : 0;
                            object.timezone = "";
                            object.companyCode = "";
                            object.posApiUsername = "";
                            object.posApiPassword = "";
                            object.posApiIntegrationKey = "";
                            object.posApiBaseUrl = "";
                            object.customerIdHeader = "";
                            object.salesStaffIdHeader = "";
                            object.netAmountHeader = "";
                            object.unitBaseCostHeader = "";
                            object.intradayUpdateTimeString = "";
                            object.rewriteHistoricalDays = 0;
                            object.yesterdayUpdateTimeString = "";
                            object.zeroValueRecordsIgnored = false;
                            object.unitHeader = "";
                            object.transactionDateFormat = "";
                            object.transactionTimeFormat = "";
                            object.negateQuantity = false;
                            object.negateAmount = false;
                            object.manualJobStatusSummary = null;
                            object.delimiter = "";
                            object.allowEmptyProduct = false;
                            object.posStaffSyncEnabled = false;
                            object.posStaffPropertiesHeaderList = null;
                            object.grossAmountHeader = "";
                            object.discountAmountHeader = "";
                            object.csvFileCharset = "";
                            object.generateChildStoreTransactionsFromParent = false;
                            object.transactionTypeHeader = "";
                            object.divideTransactionSalesEvenlyAmongStaff = false;
                            object.cashierDrawingFileConfig = null;
                            object.apiProvider = options.enums === String ? "API_PROVIDER_UNSPECIFIED" : 0;
                            object.providerCompanyId = "";
                            object.accessToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accessTokenExpiryMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accessTokenExpiryMs = options.longs === String ? "0" : 0;
                            object.refreshToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.refreshTokenExpiryMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.refreshTokenExpiryMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.revision = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.generateTransactionId != null && message.hasOwnProperty("generateTransactionId"))
                            object.generateTransactionId = message.generateTransactionId;
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            object.storeCodeHeader = message.storeCodeHeader;
                        if (message.productNameHeader != null && message.hasOwnProperty("productNameHeader"))
                            object.productNameHeader = message.productNameHeader;
                        if (message.productCodeHeader != null && message.hasOwnProperty("productCodeHeader"))
                            object.productCodeHeader = message.productCodeHeader;
                        if (message.productDescriptionHeader != null && message.hasOwnProperty("productDescriptionHeader"))
                            object.productDescriptionHeader = message.productDescriptionHeader;
                        if (message.unitPriceHeader != null && message.hasOwnProperty("unitPriceHeader"))
                            object.unitPriceHeader = message.unitPriceHeader;
                        if (message.quantityHeader != null && message.hasOwnProperty("quantityHeader"))
                            object.quantityHeader = message.quantityHeader;
                        if (message.totalAmountHeader != null && message.hasOwnProperty("totalAmountHeader"))
                            object.totalAmountHeader = message.totalAmountHeader;
                        if (message.terminalIdHeader != null && message.hasOwnProperty("terminalIdHeader"))
                            object.terminalIdHeader = message.terminalIdHeader;
                        if (message.transactionIdHeader != null && message.hasOwnProperty("transactionIdHeader"))
                            object.transactionIdHeader = message.transactionIdHeader;
                        if (message.currencyHeader != null && message.hasOwnProperty("currencyHeader"))
                            object.currencyHeader = message.currencyHeader;
                        if (message.transactionDateHeader != null && message.hasOwnProperty("transactionDateHeader"))
                            object.transactionDateHeader = message.transactionDateHeader;
                        if (message.transactionTimeHeader != null && message.hasOwnProperty("transactionTimeHeader"))
                            object.transactionTimeHeader = message.transactionTimeHeader;
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            object.companyName = message.companyName;
                        if (message.membershipCardHeader != null && message.hasOwnProperty("membershipCardHeader"))
                            object.membershipCardHeader = message.membershipCardHeader;
                        if (message.importType != null && message.hasOwnProperty("importType"))
                            object.importType = options.enums === String ? $root.palexy.streaming.v1.PosImportConfig.ImportType[message.importType] : message.importType;
                        if (message.lastImportTimeMs != null && message.hasOwnProperty("lastImportTimeMs"))
                            if (typeof message.lastImportTimeMs === "number")
                                object.lastImportTimeMs = options.longs === String ? String(message.lastImportTimeMs) : message.lastImportTimeMs;
                            else
                                object.lastImportTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastImportTimeMs) : options.longs === Number ? new $util.LongBits(message.lastImportTimeMs.low >>> 0, message.lastImportTimeMs.high >>> 0).toNumber() : message.lastImportTimeMs;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.companyCode != null && message.hasOwnProperty("companyCode"))
                            object.companyCode = message.companyCode;
                        if (message.posApiUsername != null && message.hasOwnProperty("posApiUsername"))
                            object.posApiUsername = message.posApiUsername;
                        if (message.posApiPassword != null && message.hasOwnProperty("posApiPassword"))
                            object.posApiPassword = message.posApiPassword;
                        if (message.posApiIntegrationKey != null && message.hasOwnProperty("posApiIntegrationKey"))
                            object.posApiIntegrationKey = message.posApiIntegrationKey;
                        if (message.posApiBaseUrl != null && message.hasOwnProperty("posApiBaseUrl"))
                            object.posApiBaseUrl = message.posApiBaseUrl;
                        if (message.customerIdHeader != null && message.hasOwnProperty("customerIdHeader"))
                            object.customerIdHeader = message.customerIdHeader;
                        if (message.salesStaffIdHeader != null && message.hasOwnProperty("salesStaffIdHeader"))
                            object.salesStaffIdHeader = message.salesStaffIdHeader;
                        if (message.netAmountHeader != null && message.hasOwnProperty("netAmountHeader"))
                            object.netAmountHeader = message.netAmountHeader;
                        if (message.unitBaseCostHeader != null && message.hasOwnProperty("unitBaseCostHeader"))
                            object.unitBaseCostHeader = message.unitBaseCostHeader;
                        if (message.intradayUpdateTimeString != null && message.hasOwnProperty("intradayUpdateTimeString"))
                            object.intradayUpdateTimeString = message.intradayUpdateTimeString;
                        if (message.rewriteHistoricalDays != null && message.hasOwnProperty("rewriteHistoricalDays"))
                            object.rewriteHistoricalDays = message.rewriteHistoricalDays;
                        if (message.yesterdayUpdateTimeString != null && message.hasOwnProperty("yesterdayUpdateTimeString"))
                            object.yesterdayUpdateTimeString = message.yesterdayUpdateTimeString;
                        if (message.zeroValueRecordsIgnored != null && message.hasOwnProperty("zeroValueRecordsIgnored"))
                            object.zeroValueRecordsIgnored = message.zeroValueRecordsIgnored;
                        if (message.exclusionMetadata && message.exclusionMetadata.length) {
                            object.exclusionMetadata = [];
                            for (var j = 0; j < message.exclusionMetadata.length; ++j)
                                object.exclusionMetadata[j] = $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata.toObject(message.exclusionMetadata[j], options);
                        }
                        var keys2;
                        if (message.additionalPropertiesHeader && (keys2 = Object.keys(message.additionalPropertiesHeader)).length) {
                            object.additionalPropertiesHeader = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.additionalPropertiesHeader[keys2[j]] = message.additionalPropertiesHeader[keys2[j]];
                        }
                        if (message.unitHeader != null && message.hasOwnProperty("unitHeader"))
                            object.unitHeader = message.unitHeader;
                        if (message.transactionDateFormat != null && message.hasOwnProperty("transactionDateFormat"))
                            object.transactionDateFormat = message.transactionDateFormat;
                        if (message.transactionTimeFormat != null && message.hasOwnProperty("transactionTimeFormat"))
                            object.transactionTimeFormat = message.transactionTimeFormat;
                        if (message.negateQuantity != null && message.hasOwnProperty("negateQuantity"))
                            object.negateQuantity = message.negateQuantity;
                        if (message.negateAmount != null && message.hasOwnProperty("negateAmount"))
                            object.negateAmount = message.negateAmount;
                        if (message.manualJobStatusSummary != null && message.hasOwnProperty("manualJobStatusSummary"))
                            object.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.toObject(message.manualJobStatusSummary, options);
                        if (message.delimiter != null && message.hasOwnProperty("delimiter"))
                            object.delimiter = message.delimiter;
                        if (message.allowEmptyProduct != null && message.hasOwnProperty("allowEmptyProduct"))
                            object.allowEmptyProduct = message.allowEmptyProduct;
                        if (message.posStaffSyncEnabled != null && message.hasOwnProperty("posStaffSyncEnabled"))
                            object.posStaffSyncEnabled = message.posStaffSyncEnabled;
                        if (message.posStaffPropertiesHeaderList != null && message.hasOwnProperty("posStaffPropertiesHeaderList"))
                            object.posStaffPropertiesHeaderList = $root.palexy.streaming.v1.PosStaffPropertiesHeaderList.toObject(message.posStaffPropertiesHeaderList, options);
                        if (message.grossAmountHeader != null && message.hasOwnProperty("grossAmountHeader"))
                            object.grossAmountHeader = message.grossAmountHeader;
                        if (message.discountAmountHeader != null && message.hasOwnProperty("discountAmountHeader"))
                            object.discountAmountHeader = message.discountAmountHeader;
                        if (message.csvFileCharset != null && message.hasOwnProperty("csvFileCharset"))
                            object.csvFileCharset = message.csvFileCharset;
                        if (message.generateChildStoreTransactionsFromParent != null && message.hasOwnProperty("generateChildStoreTransactionsFromParent"))
                            object.generateChildStoreTransactionsFromParent = message.generateChildStoreTransactionsFromParent;
                        if (message.transactionTypeHeader != null && message.hasOwnProperty("transactionTypeHeader"))
                            object.transactionTypeHeader = message.transactionTypeHeader;
                        if (message.divideTransactionSalesEvenlyAmongStaff != null && message.hasOwnProperty("divideTransactionSalesEvenlyAmongStaff"))
                            object.divideTransactionSalesEvenlyAmongStaff = message.divideTransactionSalesEvenlyAmongStaff;
                        if (message.cashierDrawingFileConfig != null && message.hasOwnProperty("cashierDrawingFileConfig"))
                            object.cashierDrawingFileConfig = $root.palexy.streaming.v1.CashierDrawingFileConfig.toObject(message.cashierDrawingFileConfig, options);
                        if (message.customStoreActionMomentConfigs && message.customStoreActionMomentConfigs.length) {
                            object.customStoreActionMomentConfigs = [];
                            for (var j = 0; j < message.customStoreActionMomentConfigs.length; ++j)
                                object.customStoreActionMomentConfigs[j] = $root.palexy.streaming.v1.CustomStoreActionMomentConfig.toObject(message.customStoreActionMomentConfigs[j], options);
                        }
                        if (message.apiProvider != null && message.hasOwnProperty("apiProvider"))
                            object.apiProvider = options.enums === String ? $root.palexy.streaming.v1.PosImportConfig.ApiProvider[message.apiProvider] : message.apiProvider;
                        if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId"))
                            object.providerCompanyId = message.providerCompanyId;
                        if (message.accessToken != null && message.hasOwnProperty("accessToken"))
                            object.accessToken = message.accessToken;
                        if (message.accessTokenExpiryMs != null && message.hasOwnProperty("accessTokenExpiryMs"))
                            if (typeof message.accessTokenExpiryMs === "number")
                                object.accessTokenExpiryMs = options.longs === String ? String(message.accessTokenExpiryMs) : message.accessTokenExpiryMs;
                            else
                                object.accessTokenExpiryMs = options.longs === String ? $util.Long.prototype.toString.call(message.accessTokenExpiryMs) : options.longs === Number ? new $util.LongBits(message.accessTokenExpiryMs.low >>> 0, message.accessTokenExpiryMs.high >>> 0).toNumber() : message.accessTokenExpiryMs;
                        if (message.refreshToken != null && message.hasOwnProperty("refreshToken"))
                            object.refreshToken = message.refreshToken;
                        if (message.refreshTokenExpiryMs != null && message.hasOwnProperty("refreshTokenExpiryMs"))
                            if (typeof message.refreshTokenExpiryMs === "number")
                                object.refreshTokenExpiryMs = options.longs === String ? String(message.refreshTokenExpiryMs) : message.refreshTokenExpiryMs;
                            else
                                object.refreshTokenExpiryMs = options.longs === String ? $util.Long.prototype.toString.call(message.refreshTokenExpiryMs) : options.longs === Number ? new $util.LongBits(message.refreshTokenExpiryMs.low >>> 0, message.refreshTokenExpiryMs.high >>> 0).toNumber() : message.refreshTokenExpiryMs;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.revision != null && message.hasOwnProperty("revision"))
                            object.revision = message.revision;
                        return object;
                    };
    
                    /**
                     * Converts this PosImportConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosImportConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosImportConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ImportType enum.
                     * @name palexy.streaming.v1.PosImportConfig.ImportType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} CSV=1 CSV value
                     * @property {number} REST_API=2 REST_API value
                     * @property {number} MANUAL_SYNC_API=3 MANUAL_SYNC_API value
                     */
                    PosImportConfig.ImportType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "CSV"] = 1;
                        values[valuesById[2] = "REST_API"] = 2;
                        values[valuesById[3] = "MANUAL_SYNC_API"] = 3;
                        return values;
                    })();
    
                    /**
                     * ApiProvider enum.
                     * @name palexy.streaming.v1.PosImportConfig.ApiProvider
                     * @enum {number}
                     * @property {number} API_PROVIDER_UNSPECIFIED=0 API_PROVIDER_UNSPECIFIED value
                     * @property {number} NHANHVN=1 NHANHVN value
                     */
                    PosImportConfig.ApiProvider = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "API_PROVIDER_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NHANHVN"] = 1;
                        return values;
                    })();
    
                    PosImportConfig.ExclusionMetadata = (function() {
    
                        /**
                         * Properties of an ExclusionMetadata.
                         * @memberof palexy.streaming.v1.PosImportConfig
                         * @interface IExclusionMetadata
                         * @property {string|null} [header] ExclusionMetadata header
                         * @property {Array.<string>|null} [values] ExclusionMetadata values
                         */
    
                        /**
                         * Constructs a new ExclusionMetadata.
                         * @memberof palexy.streaming.v1.PosImportConfig
                         * @classdesc Represents an ExclusionMetadata.
                         * @implements IExclusionMetadata
                         * @constructor
                         * @param {palexy.streaming.v1.PosImportConfig.IExclusionMetadata=} [properties] Properties to set
                         */
                        function ExclusionMetadata(properties) {
                            this.values = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ExclusionMetadata header.
                         * @member {string} header
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @instance
                         */
                        ExclusionMetadata.prototype.header = "";
    
                        /**
                         * ExclusionMetadata values.
                         * @member {Array.<string>} values
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @instance
                         */
                        ExclusionMetadata.prototype.values = $util.emptyArray;
    
                        /**
                         * Creates a new ExclusionMetadata instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {palexy.streaming.v1.PosImportConfig.IExclusionMetadata=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.PosImportConfig.ExclusionMetadata} ExclusionMetadata instance
                         */
                        ExclusionMetadata.create = function create(properties) {
                            return new ExclusionMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified ExclusionMetadata message. Does not implicitly {@link palexy.streaming.v1.PosImportConfig.ExclusionMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {palexy.streaming.v1.PosImportConfig.IExclusionMetadata} message ExclusionMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExclusionMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.header != null && Object.hasOwnProperty.call(message, "header"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.header);
                            if (message.values != null && message.values.length)
                                for (var i = 0; i < message.values.length; ++i)
                                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.values[i]);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ExclusionMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosImportConfig.ExclusionMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {palexy.streaming.v1.PosImportConfig.IExclusionMetadata} message ExclusionMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ExclusionMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an ExclusionMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.PosImportConfig.ExclusionMetadata} ExclusionMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExclusionMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.header = reader.string();
                                    break;
                                case 2:
                                    if (!(message.values && message.values.length))
                                        message.values = [];
                                    message.values.push(reader.string());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an ExclusionMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.PosImportConfig.ExclusionMetadata} ExclusionMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ExclusionMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an ExclusionMetadata message.
                         * @function verify
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ExclusionMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.header != null && message.hasOwnProperty("header"))
                                if (!$util.isString(message.header))
                                    return "header: string expected";
                            if (message.values != null && message.hasOwnProperty("values")) {
                                if (!Array.isArray(message.values))
                                    return "values: array expected";
                                for (var i = 0; i < message.values.length; ++i)
                                    if (!$util.isString(message.values[i]))
                                        return "values: string[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates an ExclusionMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.PosImportConfig.ExclusionMetadata} ExclusionMetadata
                         */
                        ExclusionMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata)
                                return object;
                            var message = new $root.palexy.streaming.v1.PosImportConfig.ExclusionMetadata();
                            if (object.header != null)
                                message.header = String(object.header);
                            if (object.values) {
                                if (!Array.isArray(object.values))
                                    throw TypeError(".palexy.streaming.v1.PosImportConfig.ExclusionMetadata.values: array expected");
                                message.values = [];
                                for (var i = 0; i < object.values.length; ++i)
                                    message.values[i] = String(object.values[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an ExclusionMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @static
                         * @param {palexy.streaming.v1.PosImportConfig.ExclusionMetadata} message ExclusionMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ExclusionMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.values = [];
                            if (options.defaults)
                                object.header = "";
                            if (message.header != null && message.hasOwnProperty("header"))
                                object.header = message.header;
                            if (message.values && message.values.length) {
                                object.values = [];
                                for (var j = 0; j < message.values.length; ++j)
                                    object.values[j] = message.values[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this ExclusionMetadata to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.PosImportConfig.ExclusionMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ExclusionMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ExclusionMetadata;
                    })();
    
                    return PosImportConfig;
                })();
    
                v1.CashierDrawingFileConfig = (function() {
    
                    /**
                     * Properties of a CashierDrawingFileConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ICashierDrawingFileConfig
                     * @property {boolean|null} [enableCashierDrawingImport] CashierDrawingFileConfig enableCashierDrawingImport
                     * @property {string|null} [baseUrl] CashierDrawingFileConfig baseUrl
                     * @property {string|null} [storeCodeHeader] CashierDrawingFileConfig storeCodeHeader
                     * @property {string|null} [dateHeader] CashierDrawingFileConfig dateHeader
                     * @property {string|null} [timeHeader] CashierDrawingFileConfig timeHeader
                     */
    
                    /**
                     * Constructs a new CashierDrawingFileConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CashierDrawingFileConfig.
                     * @implements ICashierDrawingFileConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ICashierDrawingFileConfig=} [properties] Properties to set
                     */
                    function CashierDrawingFileConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CashierDrawingFileConfig enableCashierDrawingImport.
                     * @member {boolean} enableCashierDrawingImport
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     */
                    CashierDrawingFileConfig.prototype.enableCashierDrawingImport = false;
    
                    /**
                     * CashierDrawingFileConfig baseUrl.
                     * @member {string} baseUrl
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     */
                    CashierDrawingFileConfig.prototype.baseUrl = "";
    
                    /**
                     * CashierDrawingFileConfig storeCodeHeader.
                     * @member {string} storeCodeHeader
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     */
                    CashierDrawingFileConfig.prototype.storeCodeHeader = "";
    
                    /**
                     * CashierDrawingFileConfig dateHeader.
                     * @member {string} dateHeader
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     */
                    CashierDrawingFileConfig.prototype.dateHeader = "";
    
                    /**
                     * CashierDrawingFileConfig timeHeader.
                     * @member {string} timeHeader
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     */
                    CashierDrawingFileConfig.prototype.timeHeader = "";
    
                    /**
                     * Creates a new CashierDrawingFileConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {palexy.streaming.v1.ICashierDrawingFileConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CashierDrawingFileConfig} CashierDrawingFileConfig instance
                     */
                    CashierDrawingFileConfig.create = function create(properties) {
                        return new CashierDrawingFileConfig(properties);
                    };
    
                    /**
                     * Encodes the specified CashierDrawingFileConfig message. Does not implicitly {@link palexy.streaming.v1.CashierDrawingFileConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {palexy.streaming.v1.ICashierDrawingFileConfig} message CashierDrawingFileConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashierDrawingFileConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.enableCashierDrawingImport != null && Object.hasOwnProperty.call(message, "enableCashierDrawingImport"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enableCashierDrawingImport);
                        if (message.baseUrl != null && Object.hasOwnProperty.call(message, "baseUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.baseUrl);
                        if (message.storeCodeHeader != null && Object.hasOwnProperty.call(message, "storeCodeHeader"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.storeCodeHeader);
                        if (message.dateHeader != null && Object.hasOwnProperty.call(message, "dateHeader"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.dateHeader);
                        if (message.timeHeader != null && Object.hasOwnProperty.call(message, "timeHeader"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.timeHeader);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CashierDrawingFileConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.CashierDrawingFileConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {palexy.streaming.v1.ICashierDrawingFileConfig} message CashierDrawingFileConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CashierDrawingFileConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CashierDrawingFileConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CashierDrawingFileConfig} CashierDrawingFileConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashierDrawingFileConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CashierDrawingFileConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.enableCashierDrawingImport = reader.bool();
                                break;
                            case 2:
                                message.baseUrl = reader.string();
                                break;
                            case 3:
                                message.storeCodeHeader = reader.string();
                                break;
                            case 4:
                                message.dateHeader = reader.string();
                                break;
                            case 5:
                                message.timeHeader = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CashierDrawingFileConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CashierDrawingFileConfig} CashierDrawingFileConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CashierDrawingFileConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CashierDrawingFileConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CashierDrawingFileConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.enableCashierDrawingImport != null && message.hasOwnProperty("enableCashierDrawingImport"))
                            if (typeof message.enableCashierDrawingImport !== "boolean")
                                return "enableCashierDrawingImport: boolean expected";
                        if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                            if (!$util.isString(message.baseUrl))
                                return "baseUrl: string expected";
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            if (!$util.isString(message.storeCodeHeader))
                                return "storeCodeHeader: string expected";
                        if (message.dateHeader != null && message.hasOwnProperty("dateHeader"))
                            if (!$util.isString(message.dateHeader))
                                return "dateHeader: string expected";
                        if (message.timeHeader != null && message.hasOwnProperty("timeHeader"))
                            if (!$util.isString(message.timeHeader))
                                return "timeHeader: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CashierDrawingFileConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CashierDrawingFileConfig} CashierDrawingFileConfig
                     */
                    CashierDrawingFileConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CashierDrawingFileConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.CashierDrawingFileConfig();
                        if (object.enableCashierDrawingImport != null)
                            message.enableCashierDrawingImport = Boolean(object.enableCashierDrawingImport);
                        if (object.baseUrl != null)
                            message.baseUrl = String(object.baseUrl);
                        if (object.storeCodeHeader != null)
                            message.storeCodeHeader = String(object.storeCodeHeader);
                        if (object.dateHeader != null)
                            message.dateHeader = String(object.dateHeader);
                        if (object.timeHeader != null)
                            message.timeHeader = String(object.timeHeader);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CashierDrawingFileConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @static
                     * @param {palexy.streaming.v1.CashierDrawingFileConfig} message CashierDrawingFileConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CashierDrawingFileConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.enableCashierDrawingImport = false;
                            object.baseUrl = "";
                            object.storeCodeHeader = "";
                            object.dateHeader = "";
                            object.timeHeader = "";
                        }
                        if (message.enableCashierDrawingImport != null && message.hasOwnProperty("enableCashierDrawingImport"))
                            object.enableCashierDrawingImport = message.enableCashierDrawingImport;
                        if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                            object.baseUrl = message.baseUrl;
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            object.storeCodeHeader = message.storeCodeHeader;
                        if (message.dateHeader != null && message.hasOwnProperty("dateHeader"))
                            object.dateHeader = message.dateHeader;
                        if (message.timeHeader != null && message.hasOwnProperty("timeHeader"))
                            object.timeHeader = message.timeHeader;
                        return object;
                    };
    
                    /**
                     * Converts this CashierDrawingFileConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CashierDrawingFileConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CashierDrawingFileConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CashierDrawingFileConfig;
                })();
    
                v1.CustomStoreActionMomentConfig = (function() {
    
                    /**
                     * Properties of a CustomStoreActionMomentConfig.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomStoreActionMomentConfig
                     * @property {string|null} [baseUrl] CustomStoreActionMomentConfig baseUrl
                     * @property {string|null} [storeCodeHeader] CustomStoreActionMomentConfig storeCodeHeader
                     * @property {string|null} [dateHeader] CustomStoreActionMomentConfig dateHeader
                     * @property {string|null} [timeHeader] CustomStoreActionMomentConfig timeHeader
                     * @property {string|null} [actionHeader] CustomStoreActionMomentConfig actionHeader
                     * @property {Object.<string,palexy.streaming.v1.StoreActionMomentType>|null} [actionValueToType] CustomStoreActionMomentConfig actionValueToType
                     * @property {string|null} [dateFormat] CustomStoreActionMomentConfig dateFormat
                     * @property {string|null} [timeFormat] CustomStoreActionMomentConfig timeFormat
                     */
    
                    /**
                     * Constructs a new CustomStoreActionMomentConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomStoreActionMomentConfig.
                     * @implements ICustomStoreActionMomentConfig
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomStoreActionMomentConfig=} [properties] Properties to set
                     */
                    function CustomStoreActionMomentConfig(properties) {
                        this.actionValueToType = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomStoreActionMomentConfig baseUrl.
                     * @member {string} baseUrl
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.baseUrl = "";
    
                    /**
                     * CustomStoreActionMomentConfig storeCodeHeader.
                     * @member {string} storeCodeHeader
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.storeCodeHeader = "";
    
                    /**
                     * CustomStoreActionMomentConfig dateHeader.
                     * @member {string} dateHeader
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.dateHeader = "";
    
                    /**
                     * CustomStoreActionMomentConfig timeHeader.
                     * @member {string} timeHeader
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.timeHeader = "";
    
                    /**
                     * CustomStoreActionMomentConfig actionHeader.
                     * @member {string} actionHeader
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.actionHeader = "";
    
                    /**
                     * CustomStoreActionMomentConfig actionValueToType.
                     * @member {Object.<string,palexy.streaming.v1.StoreActionMomentType>} actionValueToType
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.actionValueToType = $util.emptyObject;
    
                    /**
                     * CustomStoreActionMomentConfig dateFormat.
                     * @member {string} dateFormat
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.dateFormat = "";
    
                    /**
                     * CustomStoreActionMomentConfig timeFormat.
                     * @member {string} timeFormat
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     */
                    CustomStoreActionMomentConfig.prototype.timeFormat = "";
    
                    /**
                     * Creates a new CustomStoreActionMomentConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {palexy.streaming.v1.ICustomStoreActionMomentConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomStoreActionMomentConfig} CustomStoreActionMomentConfig instance
                     */
                    CustomStoreActionMomentConfig.create = function create(properties) {
                        return new CustomStoreActionMomentConfig(properties);
                    };
    
                    /**
                     * Encodes the specified CustomStoreActionMomentConfig message. Does not implicitly {@link palexy.streaming.v1.CustomStoreActionMomentConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {palexy.streaming.v1.ICustomStoreActionMomentConfig} message CustomStoreActionMomentConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomStoreActionMomentConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.baseUrl != null && Object.hasOwnProperty.call(message, "baseUrl"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.baseUrl);
                        if (message.storeCodeHeader != null && Object.hasOwnProperty.call(message, "storeCodeHeader"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeCodeHeader);
                        if (message.dateHeader != null && Object.hasOwnProperty.call(message, "dateHeader"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateHeader);
                        if (message.timeHeader != null && Object.hasOwnProperty.call(message, "timeHeader"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.timeHeader);
                        if (message.actionHeader != null && Object.hasOwnProperty.call(message, "actionHeader"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.actionHeader);
                        if (message.actionValueToType != null && Object.hasOwnProperty.call(message, "actionValueToType"))
                            for (var keys = Object.keys(message.actionValueToType), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 0 =*/16).int32(message.actionValueToType[keys[i]]).ldelim();
                        if (message.dateFormat != null && Object.hasOwnProperty.call(message, "dateFormat"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.dateFormat);
                        if (message.timeFormat != null && Object.hasOwnProperty.call(message, "timeFormat"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.timeFormat);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomStoreActionMomentConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomStoreActionMomentConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {palexy.streaming.v1.ICustomStoreActionMomentConfig} message CustomStoreActionMomentConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomStoreActionMomentConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomStoreActionMomentConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomStoreActionMomentConfig} CustomStoreActionMomentConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomStoreActionMomentConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomStoreActionMomentConfig(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.baseUrl = reader.string();
                                break;
                            case 2:
                                message.storeCodeHeader = reader.string();
                                break;
                            case 3:
                                message.dateHeader = reader.string();
                                break;
                            case 4:
                                message.timeHeader = reader.string();
                                break;
                            case 5:
                                message.actionHeader = reader.string();
                                break;
                            case 6:
                                if (message.actionValueToType === $util.emptyObject)
                                    message.actionValueToType = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.int32();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.actionValueToType[key] = value;
                                break;
                            case 7:
                                message.dateFormat = reader.string();
                                break;
                            case 8:
                                message.timeFormat = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomStoreActionMomentConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomStoreActionMomentConfig} CustomStoreActionMomentConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomStoreActionMomentConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomStoreActionMomentConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomStoreActionMomentConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                            if (!$util.isString(message.baseUrl))
                                return "baseUrl: string expected";
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            if (!$util.isString(message.storeCodeHeader))
                                return "storeCodeHeader: string expected";
                        if (message.dateHeader != null && message.hasOwnProperty("dateHeader"))
                            if (!$util.isString(message.dateHeader))
                                return "dateHeader: string expected";
                        if (message.timeHeader != null && message.hasOwnProperty("timeHeader"))
                            if (!$util.isString(message.timeHeader))
                                return "timeHeader: string expected";
                        if (message.actionHeader != null && message.hasOwnProperty("actionHeader"))
                            if (!$util.isString(message.actionHeader))
                                return "actionHeader: string expected";
                        if (message.actionValueToType != null && message.hasOwnProperty("actionValueToType")) {
                            if (!$util.isObject(message.actionValueToType))
                                return "actionValueToType: object expected";
                            var key = Object.keys(message.actionValueToType);
                            for (var i = 0; i < key.length; ++i)
                                switch (message.actionValueToType[key[i]]) {
                                default:
                                    return "actionValueToType: enum value{k:string} expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                        }
                        if (message.dateFormat != null && message.hasOwnProperty("dateFormat"))
                            if (!$util.isString(message.dateFormat))
                                return "dateFormat: string expected";
                        if (message.timeFormat != null && message.hasOwnProperty("timeFormat"))
                            if (!$util.isString(message.timeFormat))
                                return "timeFormat: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CustomStoreActionMomentConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomStoreActionMomentConfig} CustomStoreActionMomentConfig
                     */
                    CustomStoreActionMomentConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomStoreActionMomentConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomStoreActionMomentConfig();
                        if (object.baseUrl != null)
                            message.baseUrl = String(object.baseUrl);
                        if (object.storeCodeHeader != null)
                            message.storeCodeHeader = String(object.storeCodeHeader);
                        if (object.dateHeader != null)
                            message.dateHeader = String(object.dateHeader);
                        if (object.timeHeader != null)
                            message.timeHeader = String(object.timeHeader);
                        if (object.actionHeader != null)
                            message.actionHeader = String(object.actionHeader);
                        if (object.actionValueToType) {
                            if (typeof object.actionValueToType !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomStoreActionMomentConfig.actionValueToType: object expected");
                            message.actionValueToType = {};
                            for (var keys = Object.keys(object.actionValueToType), i = 0; i < keys.length; ++i)
                                switch (object.actionValueToType[keys[i]]) {
                                case "UNKNOWN_STORE_ACTION_MOMENT_TYPE":
                                case 0:
                                    message.actionValueToType[keys[i]] = 0;
                                    break;
                                case "CASHIER_DRAWING":
                                case 1:
                                    message.actionValueToType[keys[i]] = 1;
                                    break;
                                case "CANCEL_BILL":
                                case 2:
                                    message.actionValueToType[keys[i]] = 2;
                                    break;
                                }
                        }
                        if (object.dateFormat != null)
                            message.dateFormat = String(object.dateFormat);
                        if (object.timeFormat != null)
                            message.timeFormat = String(object.timeFormat);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomStoreActionMomentConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @static
                     * @param {palexy.streaming.v1.CustomStoreActionMomentConfig} message CustomStoreActionMomentConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomStoreActionMomentConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.actionValueToType = {};
                        if (options.defaults) {
                            object.baseUrl = "";
                            object.storeCodeHeader = "";
                            object.dateHeader = "";
                            object.timeHeader = "";
                            object.actionHeader = "";
                            object.dateFormat = "";
                            object.timeFormat = "";
                        }
                        if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                            object.baseUrl = message.baseUrl;
                        if (message.storeCodeHeader != null && message.hasOwnProperty("storeCodeHeader"))
                            object.storeCodeHeader = message.storeCodeHeader;
                        if (message.dateHeader != null && message.hasOwnProperty("dateHeader"))
                            object.dateHeader = message.dateHeader;
                        if (message.timeHeader != null && message.hasOwnProperty("timeHeader"))
                            object.timeHeader = message.timeHeader;
                        if (message.actionHeader != null && message.hasOwnProperty("actionHeader"))
                            object.actionHeader = message.actionHeader;
                        var keys2;
                        if (message.actionValueToType && (keys2 = Object.keys(message.actionValueToType)).length) {
                            object.actionValueToType = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.actionValueToType[keys2[j]] = options.enums === String ? $root.palexy.streaming.v1.StoreActionMomentType[message.actionValueToType[keys2[j]]] : message.actionValueToType[keys2[j]];
                        }
                        if (message.dateFormat != null && message.hasOwnProperty("dateFormat"))
                            object.dateFormat = message.dateFormat;
                        if (message.timeFormat != null && message.hasOwnProperty("timeFormat"))
                            object.timeFormat = message.timeFormat;
                        return object;
                    };
    
                    /**
                     * Converts this CustomStoreActionMomentConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomStoreActionMomentConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomStoreActionMomentConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomStoreActionMomentConfig;
                })();
    
                v1.PosStaffPropertiesHeaderList = (function() {
    
                    /**
                     * Properties of a PosStaffPropertiesHeaderList.
                     * @memberof palexy.streaming.v1
                     * @interface IPosStaffPropertiesHeaderList
                     * @property {Array.<palexy.streaming.v1.IPosStaffPropertiesHeader>|null} [posStaffPropertiesHeader] PosStaffPropertiesHeaderList posStaffPropertiesHeader
                     */
    
                    /**
                     * Constructs a new PosStaffPropertiesHeaderList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosStaffPropertiesHeaderList.
                     * @implements IPosStaffPropertiesHeaderList
                     * @constructor
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeaderList=} [properties] Properties to set
                     */
                    function PosStaffPropertiesHeaderList(properties) {
                        this.posStaffPropertiesHeader = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosStaffPropertiesHeaderList posStaffPropertiesHeader.
                     * @member {Array.<palexy.streaming.v1.IPosStaffPropertiesHeader>} posStaffPropertiesHeader
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @instance
                     */
                    PosStaffPropertiesHeaderList.prototype.posStaffPropertiesHeader = $util.emptyArray;
    
                    /**
                     * Creates a new PosStaffPropertiesHeaderList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeaderList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeaderList} PosStaffPropertiesHeaderList instance
                     */
                    PosStaffPropertiesHeaderList.create = function create(properties) {
                        return new PosStaffPropertiesHeaderList(properties);
                    };
    
                    /**
                     * Encodes the specified PosStaffPropertiesHeaderList message. Does not implicitly {@link palexy.streaming.v1.PosStaffPropertiesHeaderList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeaderList} message PosStaffPropertiesHeaderList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosStaffPropertiesHeaderList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posStaffPropertiesHeader != null && message.posStaffPropertiesHeader.length)
                            for (var i = 0; i < message.posStaffPropertiesHeader.length; ++i)
                                $root.palexy.streaming.v1.PosStaffPropertiesHeader.encode(message.posStaffPropertiesHeader[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosStaffPropertiesHeaderList message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosStaffPropertiesHeaderList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeaderList} message PosStaffPropertiesHeaderList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosStaffPropertiesHeaderList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosStaffPropertiesHeaderList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeaderList} PosStaffPropertiesHeaderList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosStaffPropertiesHeaderList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosStaffPropertiesHeaderList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posStaffPropertiesHeader && message.posStaffPropertiesHeader.length))
                                    message.posStaffPropertiesHeader = [];
                                message.posStaffPropertiesHeader.push($root.palexy.streaming.v1.PosStaffPropertiesHeader.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosStaffPropertiesHeaderList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeaderList} PosStaffPropertiesHeaderList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosStaffPropertiesHeaderList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosStaffPropertiesHeaderList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosStaffPropertiesHeaderList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posStaffPropertiesHeader != null && message.hasOwnProperty("posStaffPropertiesHeader")) {
                            if (!Array.isArray(message.posStaffPropertiesHeader))
                                return "posStaffPropertiesHeader: array expected";
                            for (var i = 0; i < message.posStaffPropertiesHeader.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosStaffPropertiesHeader.verify(message.posStaffPropertiesHeader[i]);
                                if (error)
                                    return "posStaffPropertiesHeader." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosStaffPropertiesHeaderList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeaderList} PosStaffPropertiesHeaderList
                     */
                    PosStaffPropertiesHeaderList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosStaffPropertiesHeaderList)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosStaffPropertiesHeaderList();
                        if (object.posStaffPropertiesHeader) {
                            if (!Array.isArray(object.posStaffPropertiesHeader))
                                throw TypeError(".palexy.streaming.v1.PosStaffPropertiesHeaderList.posStaffPropertiesHeader: array expected");
                            message.posStaffPropertiesHeader = [];
                            for (var i = 0; i < object.posStaffPropertiesHeader.length; ++i) {
                                if (typeof object.posStaffPropertiesHeader[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosStaffPropertiesHeaderList.posStaffPropertiesHeader: object expected");
                                message.posStaffPropertiesHeader[i] = $root.palexy.streaming.v1.PosStaffPropertiesHeader.fromObject(object.posStaffPropertiesHeader[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosStaffPropertiesHeaderList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @static
                     * @param {palexy.streaming.v1.PosStaffPropertiesHeaderList} message PosStaffPropertiesHeaderList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosStaffPropertiesHeaderList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posStaffPropertiesHeader = [];
                        if (message.posStaffPropertiesHeader && message.posStaffPropertiesHeader.length) {
                            object.posStaffPropertiesHeader = [];
                            for (var j = 0; j < message.posStaffPropertiesHeader.length; ++j)
                                object.posStaffPropertiesHeader[j] = $root.palexy.streaming.v1.PosStaffPropertiesHeader.toObject(message.posStaffPropertiesHeader[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosStaffPropertiesHeaderList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeaderList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosStaffPropertiesHeaderList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosStaffPropertiesHeaderList;
                })();
    
                v1.PosStaffPropertiesHeader = (function() {
    
                    /**
                     * Properties of a PosStaffPropertiesHeader.
                     * @memberof palexy.streaming.v1
                     * @interface IPosStaffPropertiesHeader
                     * @property {string|null} [staffIdHeader] PosStaffPropertiesHeader staffIdHeader
                     * @property {string|null} [staffNameHeader] PosStaffPropertiesHeader staffNameHeader
                     */
    
                    /**
                     * Constructs a new PosStaffPropertiesHeader.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosStaffPropertiesHeader.
                     * @implements IPosStaffPropertiesHeader
                     * @constructor
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeader=} [properties] Properties to set
                     */
                    function PosStaffPropertiesHeader(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosStaffPropertiesHeader staffIdHeader.
                     * @member {string} staffIdHeader
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @instance
                     */
                    PosStaffPropertiesHeader.prototype.staffIdHeader = "";
    
                    /**
                     * PosStaffPropertiesHeader staffNameHeader.
                     * @member {string} staffNameHeader
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @instance
                     */
                    PosStaffPropertiesHeader.prototype.staffNameHeader = "";
    
                    /**
                     * Creates a new PosStaffPropertiesHeader instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeader=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeader} PosStaffPropertiesHeader instance
                     */
                    PosStaffPropertiesHeader.create = function create(properties) {
                        return new PosStaffPropertiesHeader(properties);
                    };
    
                    /**
                     * Encodes the specified PosStaffPropertiesHeader message. Does not implicitly {@link palexy.streaming.v1.PosStaffPropertiesHeader.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeader} message PosStaffPropertiesHeader message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosStaffPropertiesHeader.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffIdHeader != null && Object.hasOwnProperty.call(message, "staffIdHeader"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.staffIdHeader);
                        if (message.staffNameHeader != null && Object.hasOwnProperty.call(message, "staffNameHeader"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.staffNameHeader);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosStaffPropertiesHeader message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosStaffPropertiesHeader.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {palexy.streaming.v1.IPosStaffPropertiesHeader} message PosStaffPropertiesHeader message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosStaffPropertiesHeader.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosStaffPropertiesHeader message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeader} PosStaffPropertiesHeader
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosStaffPropertiesHeader.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosStaffPropertiesHeader();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffIdHeader = reader.string();
                                break;
                            case 2:
                                message.staffNameHeader = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosStaffPropertiesHeader message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeader} PosStaffPropertiesHeader
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosStaffPropertiesHeader.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosStaffPropertiesHeader message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosStaffPropertiesHeader.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffIdHeader != null && message.hasOwnProperty("staffIdHeader"))
                            if (!$util.isString(message.staffIdHeader))
                                return "staffIdHeader: string expected";
                        if (message.staffNameHeader != null && message.hasOwnProperty("staffNameHeader"))
                            if (!$util.isString(message.staffNameHeader))
                                return "staffNameHeader: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PosStaffPropertiesHeader message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosStaffPropertiesHeader} PosStaffPropertiesHeader
                     */
                    PosStaffPropertiesHeader.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosStaffPropertiesHeader)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosStaffPropertiesHeader();
                        if (object.staffIdHeader != null)
                            message.staffIdHeader = String(object.staffIdHeader);
                        if (object.staffNameHeader != null)
                            message.staffNameHeader = String(object.staffNameHeader);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosStaffPropertiesHeader message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @static
                     * @param {palexy.streaming.v1.PosStaffPropertiesHeader} message PosStaffPropertiesHeader
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosStaffPropertiesHeader.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staffIdHeader = "";
                            object.staffNameHeader = "";
                        }
                        if (message.staffIdHeader != null && message.hasOwnProperty("staffIdHeader"))
                            object.staffIdHeader = message.staffIdHeader;
                        if (message.staffNameHeader != null && message.hasOwnProperty("staffNameHeader"))
                            object.staffNameHeader = message.staffNameHeader;
                        return object;
                    };
    
                    /**
                     * Converts this PosStaffPropertiesHeader to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosStaffPropertiesHeader
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosStaffPropertiesHeader.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosStaffPropertiesHeader;
                })();
    
                v1.GetPosImportConfigRequest = (function() {
    
                    /**
                     * Properties of a GetPosImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetPosImportConfigRequest
                     * @property {number|null} [configId] GetPosImportConfigRequest configId
                     * @property {boolean|null} [includeCompanyInfo] GetPosImportConfigRequest includeCompanyInfo
                     */
    
                    /**
                     * Constructs a new GetPosImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetPosImportConfigRequest.
                     * @implements IGetPosImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest=} [properties] Properties to set
                     */
                    function GetPosImportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetPosImportConfigRequest configId.
                     * @member {number} configId
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @instance
                     */
                    GetPosImportConfigRequest.prototype.configId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetPosImportConfigRequest includeCompanyInfo.
                     * @member {boolean} includeCompanyInfo
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @instance
                     */
                    GetPosImportConfigRequest.prototype.includeCompanyInfo = false;
    
                    /**
                     * Creates a new GetPosImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetPosImportConfigRequest} GetPosImportConfigRequest instance
                     */
                    GetPosImportConfigRequest.create = function create(properties) {
                        return new GetPosImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetPosImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.GetPosImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest} message GetPosImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configId != null && Object.hasOwnProperty.call(message, "configId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.configId);
                        if (message.includeCompanyInfo != null && Object.hasOwnProperty.call(message, "includeCompanyInfo"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeCompanyInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetPosImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetPosImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetPosImportConfigRequest} message GetPosImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetPosImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetPosImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetPosImportConfigRequest} GetPosImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetPosImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configId = reader.int64();
                                break;
                            case 2:
                                message.includeCompanyInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetPosImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetPosImportConfigRequest} GetPosImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetPosImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetPosImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetPosImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (!$util.isInteger(message.configId) && !(message.configId && $util.isInteger(message.configId.low) && $util.isInteger(message.configId.high)))
                                return "configId: integer|Long expected";
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            if (typeof message.includeCompanyInfo !== "boolean")
                                return "includeCompanyInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetPosImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetPosImportConfigRequest} GetPosImportConfigRequest
                     */
                    GetPosImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetPosImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetPosImportConfigRequest();
                        if (object.configId != null)
                            if ($util.Long)
                                (message.configId = $util.Long.fromValue(object.configId)).unsigned = false;
                            else if (typeof object.configId === "string")
                                message.configId = parseInt(object.configId, 10);
                            else if (typeof object.configId === "number")
                                message.configId = object.configId;
                            else if (typeof object.configId === "object")
                                message.configId = new $util.LongBits(object.configId.low >>> 0, object.configId.high >>> 0).toNumber();
                        if (object.includeCompanyInfo != null)
                            message.includeCompanyInfo = Boolean(object.includeCompanyInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetPosImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.GetPosImportConfigRequest} message GetPosImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetPosImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.configId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.configId = options.longs === String ? "0" : 0;
                            object.includeCompanyInfo = false;
                        }
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (typeof message.configId === "number")
                                object.configId = options.longs === String ? String(message.configId) : message.configId;
                            else
                                object.configId = options.longs === String ? $util.Long.prototype.toString.call(message.configId) : options.longs === Number ? new $util.LongBits(message.configId.low >>> 0, message.configId.high >>> 0).toNumber() : message.configId;
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            object.includeCompanyInfo = message.includeCompanyInfo;
                        return object;
                    };
    
                    /**
                     * Converts this GetPosImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetPosImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetPosImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetPosImportConfigRequest;
                })();
    
                v1.ListPosImportConfigRequest = (function() {
    
                    /**
                     * Properties of a ListPosImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosImportConfigRequest
                     * @property {number|null} [companyId] ListPosImportConfigRequest companyId
                     * @property {boolean|null} [includeCompanyInfo] ListPosImportConfigRequest includeCompanyInfo
                     * @property {number|null} [pageSize] ListPosImportConfigRequest pageSize
                     * @property {string|null} [pageToken] ListPosImportConfigRequest pageToken
                     * @property {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId|null} [providerCompanyId] ListPosImportConfigRequest providerCompanyId
                     * @property {palexy.streaming.v1.PosImportConfig.ImportType|null} [importType] ListPosImportConfigRequest importType
                     * @property {boolean|null} [intradayImportIncompleteOnly] ListPosImportConfigRequest intradayImportIncompleteOnly
                     * @property {boolean|null} [fetchJobStatus] ListPosImportConfigRequest fetchJobStatus
                     * @property {Array.<palexy.streaming.v1.PosImportConfig.ImportType>|null} [importTypes] ListPosImportConfigRequest importTypes
                     */
    
                    /**
                     * Constructs a new ListPosImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosImportConfigRequest.
                     * @implements IListPosImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest=} [properties] Properties to set
                     */
                    function ListPosImportConfigRequest(properties) {
                        this.importTypes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosImportConfigRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListPosImportConfigRequest includeCompanyInfo.
                     * @member {boolean} includeCompanyInfo
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.includeCompanyInfo = false;
    
                    /**
                     * ListPosImportConfigRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.pageSize = 0;
    
                    /**
                     * ListPosImportConfigRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.pageToken = "";
    
                    /**
                     * ListPosImportConfigRequest providerCompanyId.
                     * @member {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId|null|undefined} providerCompanyId
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.providerCompanyId = null;
    
                    /**
                     * ListPosImportConfigRequest importType.
                     * @member {palexy.streaming.v1.PosImportConfig.ImportType} importType
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.importType = 0;
    
                    /**
                     * ListPosImportConfigRequest intradayImportIncompleteOnly.
                     * @member {boolean} intradayImportIncompleteOnly
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.intradayImportIncompleteOnly = false;
    
                    /**
                     * ListPosImportConfigRequest fetchJobStatus.
                     * @member {boolean} fetchJobStatus
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.fetchJobStatus = false;
    
                    /**
                     * ListPosImportConfigRequest importTypes.
                     * @member {Array.<palexy.streaming.v1.PosImportConfig.ImportType>} importTypes
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     */
                    ListPosImportConfigRequest.prototype.importTypes = $util.emptyArray;
    
                    /**
                     * Creates a new ListPosImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosImportConfigRequest} ListPosImportConfigRequest instance
                     */
                    ListPosImportConfigRequest.create = function create(properties) {
                        return new ListPosImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest} message ListPosImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.includeCompanyInfo != null && Object.hasOwnProperty.call(message, "includeCompanyInfo"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeCompanyInfo);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.importType != null && Object.hasOwnProperty.call(message, "importType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.importType);
                        if (message.intradayImportIncompleteOnly != null && Object.hasOwnProperty.call(message, "intradayImportIncompleteOnly"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.intradayImportIncompleteOnly);
                        if (message.fetchJobStatus != null && Object.hasOwnProperty.call(message, "fetchJobStatus"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.fetchJobStatus);
                        if (message.importTypes != null && message.importTypes.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.importTypes.length; ++i)
                                writer.int32(message.importTypes[i]);
                            writer.ldelim();
                        }
                        if (message.providerCompanyId != null && Object.hasOwnProperty.call(message, "providerCompanyId"))
                            $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.encode(message.providerCompanyId, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigRequest} message ListPosImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosImportConfigRequest} ListPosImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.includeCompanyInfo = reader.bool();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 9:
                                message.providerCompanyId = $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.importType = reader.int32();
                                break;
                            case 6:
                                message.intradayImportIncompleteOnly = reader.bool();
                                break;
                            case 7:
                                message.fetchJobStatus = reader.bool();
                                break;
                            case 8:
                                if (!(message.importTypes && message.importTypes.length))
                                    message.importTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.importTypes.push(reader.int32());
                                } else
                                    message.importTypes.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosImportConfigRequest} ListPosImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            if (typeof message.includeCompanyInfo !== "boolean")
                                return "includeCompanyInfo: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId")) {
                            var error = $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.verify(message.providerCompanyId);
                            if (error)
                                return "providerCompanyId." + error;
                        }
                        if (message.importType != null && message.hasOwnProperty("importType"))
                            switch (message.importType) {
                            default:
                                return "importType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.intradayImportIncompleteOnly != null && message.hasOwnProperty("intradayImportIncompleteOnly"))
                            if (typeof message.intradayImportIncompleteOnly !== "boolean")
                                return "intradayImportIncompleteOnly: boolean expected";
                        if (message.fetchJobStatus != null && message.hasOwnProperty("fetchJobStatus"))
                            if (typeof message.fetchJobStatus !== "boolean")
                                return "fetchJobStatus: boolean expected";
                        if (message.importTypes != null && message.hasOwnProperty("importTypes")) {
                            if (!Array.isArray(message.importTypes))
                                return "importTypes: array expected";
                            for (var i = 0; i < message.importTypes.length; ++i)
                                switch (message.importTypes[i]) {
                                default:
                                    return "importTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListPosImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosImportConfigRequest} ListPosImportConfigRequest
                     */
                    ListPosImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosImportConfigRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.includeCompanyInfo != null)
                            message.includeCompanyInfo = Boolean(object.includeCompanyInfo);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.providerCompanyId != null) {
                            if (typeof object.providerCompanyId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListPosImportConfigRequest.providerCompanyId: object expected");
                            message.providerCompanyId = $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.fromObject(object.providerCompanyId);
                        }
                        switch (object.importType) {
                        case "UNKNOWN":
                        case 0:
                            message.importType = 0;
                            break;
                        case "CSV":
                        case 1:
                            message.importType = 1;
                            break;
                        case "REST_API":
                        case 2:
                            message.importType = 2;
                            break;
                        case "MANUAL_SYNC_API":
                        case 3:
                            message.importType = 3;
                            break;
                        }
                        if (object.intradayImportIncompleteOnly != null)
                            message.intradayImportIncompleteOnly = Boolean(object.intradayImportIncompleteOnly);
                        if (object.fetchJobStatus != null)
                            message.fetchJobStatus = Boolean(object.fetchJobStatus);
                        if (object.importTypes) {
                            if (!Array.isArray(object.importTypes))
                                throw TypeError(".palexy.streaming.v1.ListPosImportConfigRequest.importTypes: array expected");
                            message.importTypes = [];
                            for (var i = 0; i < object.importTypes.length; ++i)
                                switch (object.importTypes[i]) {
                                default:
                                case "UNKNOWN":
                                case 0:
                                    message.importTypes[i] = 0;
                                    break;
                                case "CSV":
                                case 1:
                                    message.importTypes[i] = 1;
                                    break;
                                case "REST_API":
                                case 2:
                                    message.importTypes[i] = 2;
                                    break;
                                case "MANUAL_SYNC_API":
                                case 3:
                                    message.importTypes[i] = 3;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ListPosImportConfigRequest} message ListPosImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.importTypes = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.includeCompanyInfo = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.importType = options.enums === String ? "UNKNOWN" : 0;
                            object.intradayImportIncompleteOnly = false;
                            object.fetchJobStatus = false;
                            object.providerCompanyId = null;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            object.includeCompanyInfo = message.includeCompanyInfo;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.importType != null && message.hasOwnProperty("importType"))
                            object.importType = options.enums === String ? $root.palexy.streaming.v1.PosImportConfig.ImportType[message.importType] : message.importType;
                        if (message.intradayImportIncompleteOnly != null && message.hasOwnProperty("intradayImportIncompleteOnly"))
                            object.intradayImportIncompleteOnly = message.intradayImportIncompleteOnly;
                        if (message.fetchJobStatus != null && message.hasOwnProperty("fetchJobStatus"))
                            object.fetchJobStatus = message.fetchJobStatus;
                        if (message.importTypes && message.importTypes.length) {
                            object.importTypes = [];
                            for (var j = 0; j < message.importTypes.length; ++j)
                                object.importTypes[j] = options.enums === String ? $root.palexy.streaming.v1.PosImportConfig.ImportType[message.importTypes[j]] : message.importTypes[j];
                        }
                        if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId"))
                            object.providerCompanyId = $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.toObject(message.providerCompanyId, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListPosImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListPosImportConfigRequest.ProviderCompanyId = (function() {
    
                        /**
                         * Properties of a ProviderCompanyId.
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                         * @interface IProviderCompanyId
                         * @property {palexy.streaming.v1.PosImportConfig.ApiProvider|null} [provider] ProviderCompanyId provider
                         * @property {string|null} [providerCompanyId] ProviderCompanyId providerCompanyId
                         */
    
                        /**
                         * Constructs a new ProviderCompanyId.
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest
                         * @classdesc Represents a ProviderCompanyId.
                         * @implements IProviderCompanyId
                         * @constructor
                         * @param {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId=} [properties] Properties to set
                         */
                        function ProviderCompanyId(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ProviderCompanyId provider.
                         * @member {palexy.streaming.v1.PosImportConfig.ApiProvider} provider
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @instance
                         */
                        ProviderCompanyId.prototype.provider = 0;
    
                        /**
                         * ProviderCompanyId providerCompanyId.
                         * @member {string} providerCompanyId
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @instance
                         */
                        ProviderCompanyId.prototype.providerCompanyId = "";
    
                        /**
                         * Creates a new ProviderCompanyId instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId} ProviderCompanyId instance
                         */
                        ProviderCompanyId.create = function create(properties) {
                            return new ProviderCompanyId(properties);
                        };
    
                        /**
                         * Encodes the specified ProviderCompanyId message. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId} message ProviderCompanyId message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProviderCompanyId.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.provider != null && Object.hasOwnProperty.call(message, "provider"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.provider);
                            if (message.providerCompanyId != null && Object.hasOwnProperty.call(message, "providerCompanyId"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.providerCompanyId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ProviderCompanyId message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {palexy.streaming.v1.ListPosImportConfigRequest.IProviderCompanyId} message ProviderCompanyId message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProviderCompanyId.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ProviderCompanyId message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId} ProviderCompanyId
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProviderCompanyId.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.provider = reader.int32();
                                    break;
                                case 2:
                                    message.providerCompanyId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ProviderCompanyId message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId} ProviderCompanyId
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProviderCompanyId.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ProviderCompanyId message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProviderCompanyId.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.provider != null && message.hasOwnProperty("provider"))
                                switch (message.provider) {
                                default:
                                    return "provider: enum value expected";
                                case 0:
                                case 1:
                                    break;
                                }
                            if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId"))
                                if (!$util.isString(message.providerCompanyId))
                                    return "providerCompanyId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ProviderCompanyId message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId} ProviderCompanyId
                         */
                        ProviderCompanyId.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId();
                            switch (object.provider) {
                            case "API_PROVIDER_UNSPECIFIED":
                            case 0:
                                message.provider = 0;
                                break;
                            case "NHANHVN":
                            case 1:
                                message.provider = 1;
                                break;
                            }
                            if (object.providerCompanyId != null)
                                message.providerCompanyId = String(object.providerCompanyId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ProviderCompanyId message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @static
                         * @param {palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId} message ProviderCompanyId
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProviderCompanyId.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.provider = options.enums === String ? "API_PROVIDER_UNSPECIFIED" : 0;
                                object.providerCompanyId = "";
                            }
                            if (message.provider != null && message.hasOwnProperty("provider"))
                                object.provider = options.enums === String ? $root.palexy.streaming.v1.PosImportConfig.ApiProvider[message.provider] : message.provider;
                            if (message.providerCompanyId != null && message.hasOwnProperty("providerCompanyId"))
                                object.providerCompanyId = message.providerCompanyId;
                            return object;
                        };
    
                        /**
                         * Converts this ProviderCompanyId to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListPosImportConfigRequest.ProviderCompanyId
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProviderCompanyId.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ProviderCompanyId;
                    })();
    
                    return ListPosImportConfigRequest;
                })();
    
                v1.ListPosImportConfigResponse = (function() {
    
                    /**
                     * Properties of a ListPosImportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListPosImportConfigResponse
                     * @property {Array.<palexy.streaming.v1.IPosImportConfig>|null} [posImportConfigs] ListPosImportConfigResponse posImportConfigs
                     * @property {number|null} [totalElements] ListPosImportConfigResponse totalElements
                     * @property {string|null} [nextPageToken] ListPosImportConfigResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListPosImportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListPosImportConfigResponse.
                     * @implements IListPosImportConfigResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListPosImportConfigResponse=} [properties] Properties to set
                     */
                    function ListPosImportConfigResponse(properties) {
                        this.posImportConfigs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListPosImportConfigResponse posImportConfigs.
                     * @member {Array.<palexy.streaming.v1.IPosImportConfig>} posImportConfigs
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @instance
                     */
                    ListPosImportConfigResponse.prototype.posImportConfigs = $util.emptyArray;
    
                    /**
                     * ListPosImportConfigResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @instance
                     */
                    ListPosImportConfigResponse.prototype.totalElements = 0;
    
                    /**
                     * ListPosImportConfigResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @instance
                     */
                    ListPosImportConfigResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListPosImportConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListPosImportConfigResponse} ListPosImportConfigResponse instance
                     */
                    ListPosImportConfigResponse.create = function create(properties) {
                        return new ListPosImportConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListPosImportConfigResponse message. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigResponse} message ListPosImportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosImportConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posImportConfigs != null && message.posImportConfigs.length)
                            for (var i = 0; i < message.posImportConfigs.length; ++i)
                                $root.palexy.streaming.v1.PosImportConfig.encode(message.posImportConfigs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListPosImportConfigResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListPosImportConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListPosImportConfigResponse} message ListPosImportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListPosImportConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListPosImportConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListPosImportConfigResponse} ListPosImportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosImportConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListPosImportConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posImportConfigs && message.posImportConfigs.length))
                                    message.posImportConfigs = [];
                                message.posImportConfigs.push($root.palexy.streaming.v1.PosImportConfig.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListPosImportConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListPosImportConfigResponse} ListPosImportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListPosImportConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListPosImportConfigResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListPosImportConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posImportConfigs != null && message.hasOwnProperty("posImportConfigs")) {
                            if (!Array.isArray(message.posImportConfigs))
                                return "posImportConfigs: array expected";
                            for (var i = 0; i < message.posImportConfigs.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosImportConfig.verify(message.posImportConfigs[i]);
                                if (error)
                                    return "posImportConfigs." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListPosImportConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListPosImportConfigResponse} ListPosImportConfigResponse
                     */
                    ListPosImportConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListPosImportConfigResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListPosImportConfigResponse();
                        if (object.posImportConfigs) {
                            if (!Array.isArray(object.posImportConfigs))
                                throw TypeError(".palexy.streaming.v1.ListPosImportConfigResponse.posImportConfigs: array expected");
                            message.posImportConfigs = [];
                            for (var i = 0; i < object.posImportConfigs.length; ++i) {
                                if (typeof object.posImportConfigs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListPosImportConfigResponse.posImportConfigs: object expected");
                                message.posImportConfigs[i] = $root.palexy.streaming.v1.PosImportConfig.fromObject(object.posImportConfigs[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListPosImportConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.ListPosImportConfigResponse} message ListPosImportConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListPosImportConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.posImportConfigs = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.posImportConfigs && message.posImportConfigs.length) {
                            object.posImportConfigs = [];
                            for (var j = 0; j < message.posImportConfigs.length; ++j)
                                object.posImportConfigs[j] = $root.palexy.streaming.v1.PosImportConfig.toObject(message.posImportConfigs[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListPosImportConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListPosImportConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListPosImportConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListPosImportConfigResponse;
                })();
    
                v1.MatchPosTransactionRequest = (function() {
    
                    /**
                     * Properties of a MatchPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IMatchPosTransactionRequest
                     * @property {number|null} [storeId] MatchPosTransactionRequest storeId
                     * @property {number|null} [dateId] MatchPosTransactionRequest dateId
                     */
    
                    /**
                     * Constructs a new MatchPosTransactionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MatchPosTransactionRequest.
                     * @implements IMatchPosTransactionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest=} [properties] Properties to set
                     */
                    function MatchPosTransactionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MatchPosTransactionRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @instance
                     */
                    MatchPosTransactionRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MatchPosTransactionRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @instance
                     */
                    MatchPosTransactionRequest.prototype.dateId = 0;
    
                    /**
                     * Creates a new MatchPosTransactionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MatchPosTransactionRequest} MatchPosTransactionRequest instance
                     */
                    MatchPosTransactionRequest.create = function create(properties) {
                        return new MatchPosTransactionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MatchPosTransactionRequest message. Does not implicitly {@link palexy.streaming.v1.MatchPosTransactionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest} message MatchPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MatchPosTransactionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MatchPosTransactionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.MatchPosTransactionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionRequest} message MatchPosTransactionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MatchPosTransactionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MatchPosTransactionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MatchPosTransactionRequest} MatchPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MatchPosTransactionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MatchPosTransactionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MatchPosTransactionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MatchPosTransactionRequest} MatchPosTransactionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MatchPosTransactionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MatchPosTransactionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MatchPosTransactionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a MatchPosTransactionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MatchPosTransactionRequest} MatchPosTransactionRequest
                     */
                    MatchPosTransactionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MatchPosTransactionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.MatchPosTransactionRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MatchPosTransactionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @static
                     * @param {palexy.streaming.v1.MatchPosTransactionRequest} message MatchPosTransactionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MatchPosTransactionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this MatchPosTransactionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MatchPosTransactionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MatchPosTransactionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MatchPosTransactionRequest;
                })();
    
                v1.MatchPosTransactionResponse = (function() {
    
                    /**
                     * Properties of a MatchPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IMatchPosTransactionResponse
                     * @property {number|null} [posTransactionCount] MatchPosTransactionResponse posTransactionCount
                     * @property {number|null} [customerCount] MatchPosTransactionResponse customerCount
                     * @property {number|null} [matchedPosTransactionCount] MatchPosTransactionResponse matchedPosTransactionCount
                     */
    
                    /**
                     * Constructs a new MatchPosTransactionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MatchPosTransactionResponse.
                     * @implements IMatchPosTransactionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IMatchPosTransactionResponse=} [properties] Properties to set
                     */
                    function MatchPosTransactionResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MatchPosTransactionResponse posTransactionCount.
                     * @member {number} posTransactionCount
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @instance
                     */
                    MatchPosTransactionResponse.prototype.posTransactionCount = 0;
    
                    /**
                     * MatchPosTransactionResponse customerCount.
                     * @member {number} customerCount
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @instance
                     */
                    MatchPosTransactionResponse.prototype.customerCount = 0;
    
                    /**
                     * MatchPosTransactionResponse matchedPosTransactionCount.
                     * @member {number} matchedPosTransactionCount
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @instance
                     */
                    MatchPosTransactionResponse.prototype.matchedPosTransactionCount = 0;
    
                    /**
                     * Creates a new MatchPosTransactionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MatchPosTransactionResponse} MatchPosTransactionResponse instance
                     */
                    MatchPosTransactionResponse.create = function create(properties) {
                        return new MatchPosTransactionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified MatchPosTransactionResponse message. Does not implicitly {@link palexy.streaming.v1.MatchPosTransactionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionResponse} message MatchPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MatchPosTransactionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posTransactionCount != null && Object.hasOwnProperty.call(message, "posTransactionCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.posTransactionCount);
                        if (message.customerCount != null && Object.hasOwnProperty.call(message, "customerCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.customerCount);
                        if (message.matchedPosTransactionCount != null && Object.hasOwnProperty.call(message, "matchedPosTransactionCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.matchedPosTransactionCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MatchPosTransactionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.MatchPosTransactionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.IMatchPosTransactionResponse} message MatchPosTransactionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MatchPosTransactionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MatchPosTransactionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MatchPosTransactionResponse} MatchPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MatchPosTransactionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MatchPosTransactionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.posTransactionCount = reader.int32();
                                break;
                            case 2:
                                message.customerCount = reader.int32();
                                break;
                            case 3:
                                message.matchedPosTransactionCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MatchPosTransactionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MatchPosTransactionResponse} MatchPosTransactionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MatchPosTransactionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MatchPosTransactionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MatchPosTransactionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posTransactionCount != null && message.hasOwnProperty("posTransactionCount"))
                            if (!$util.isInteger(message.posTransactionCount))
                                return "posTransactionCount: integer expected";
                        if (message.customerCount != null && message.hasOwnProperty("customerCount"))
                            if (!$util.isInteger(message.customerCount))
                                return "customerCount: integer expected";
                        if (message.matchedPosTransactionCount != null && message.hasOwnProperty("matchedPosTransactionCount"))
                            if (!$util.isInteger(message.matchedPosTransactionCount))
                                return "matchedPosTransactionCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a MatchPosTransactionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MatchPosTransactionResponse} MatchPosTransactionResponse
                     */
                    MatchPosTransactionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MatchPosTransactionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.MatchPosTransactionResponse();
                        if (object.posTransactionCount != null)
                            message.posTransactionCount = object.posTransactionCount | 0;
                        if (object.customerCount != null)
                            message.customerCount = object.customerCount | 0;
                        if (object.matchedPosTransactionCount != null)
                            message.matchedPosTransactionCount = object.matchedPosTransactionCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MatchPosTransactionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @static
                     * @param {palexy.streaming.v1.MatchPosTransactionResponse} message MatchPosTransactionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MatchPosTransactionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.posTransactionCount = 0;
                            object.customerCount = 0;
                            object.matchedPosTransactionCount = 0;
                        }
                        if (message.posTransactionCount != null && message.hasOwnProperty("posTransactionCount"))
                            object.posTransactionCount = message.posTransactionCount;
                        if (message.customerCount != null && message.hasOwnProperty("customerCount"))
                            object.customerCount = message.customerCount;
                        if (message.matchedPosTransactionCount != null && message.hasOwnProperty("matchedPosTransactionCount"))
                            object.matchedPosTransactionCount = message.matchedPosTransactionCount;
                        return object;
                    };
    
                    /**
                     * Converts this MatchPosTransactionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MatchPosTransactionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MatchPosTransactionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MatchPosTransactionResponse;
                })();
    
                v1.PosMatchingConfig = (function() {
    
                    /**
                     * Properties of a PosMatchingConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IPosMatchingConfig
                     * @property {number|null} [id] PosMatchingConfig id
                     * @property {number|null} [companyId] PosMatchingConfig companyId
                     * @property {palexy.streaming.v1.PosMatchingConfig.PosMatchingAlgorithm|null} [matchingAlgorithm] PosMatchingConfig matchingAlgorithm
                     */
    
                    /**
                     * Constructs a new PosMatchingConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosMatchingConfig.
                     * @implements IPosMatchingConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IPosMatchingConfig=} [properties] Properties to set
                     */
                    function PosMatchingConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosMatchingConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @instance
                     */
                    PosMatchingConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMatchingConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @instance
                     */
                    PosMatchingConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosMatchingConfig matchingAlgorithm.
                     * @member {palexy.streaming.v1.PosMatchingConfig.PosMatchingAlgorithm} matchingAlgorithm
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @instance
                     */
                    PosMatchingConfig.prototype.matchingAlgorithm = 0;
    
                    /**
                     * Creates a new PosMatchingConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosMatchingConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosMatchingConfig} PosMatchingConfig instance
                     */
                    PosMatchingConfig.create = function create(properties) {
                        return new PosMatchingConfig(properties);
                    };
    
                    /**
                     * Encodes the specified PosMatchingConfig message. Does not implicitly {@link palexy.streaming.v1.PosMatchingConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosMatchingConfig} message PosMatchingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosMatchingConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.matchingAlgorithm != null && Object.hasOwnProperty.call(message, "matchingAlgorithm"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.matchingAlgorithm);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosMatchingConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosMatchingConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {palexy.streaming.v1.IPosMatchingConfig} message PosMatchingConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosMatchingConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosMatchingConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosMatchingConfig} PosMatchingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosMatchingConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosMatchingConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.matchingAlgorithm = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosMatchingConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosMatchingConfig} PosMatchingConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosMatchingConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosMatchingConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosMatchingConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.matchingAlgorithm != null && message.hasOwnProperty("matchingAlgorithm"))
                            switch (message.matchingAlgorithm) {
                            default:
                                return "matchingAlgorithm: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a PosMatchingConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosMatchingConfig} PosMatchingConfig
                     */
                    PosMatchingConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosMatchingConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosMatchingConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.matchingAlgorithm) {
                        case "UNKNOWN":
                        case 0:
                            message.matchingAlgorithm = 0;
                            break;
                        case "MERGE_WITH_ONLY_DETECTED_ACTIONS":
                        case 1:
                            message.matchingAlgorithm = 1;
                            break;
                        case "MERGE_WITH_BOTH_DETECTED_ACTIONS_AND_END_TIME":
                        case 2:
                            message.matchingAlgorithm = 2;
                            break;
                        case "DEFAULT":
                        case 3:
                            message.matchingAlgorithm = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosMatchingConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @static
                     * @param {palexy.streaming.v1.PosMatchingConfig} message PosMatchingConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosMatchingConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.matchingAlgorithm = options.enums === String ? "UNKNOWN" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.matchingAlgorithm != null && message.hasOwnProperty("matchingAlgorithm"))
                            object.matchingAlgorithm = options.enums === String ? $root.palexy.streaming.v1.PosMatchingConfig.PosMatchingAlgorithm[message.matchingAlgorithm] : message.matchingAlgorithm;
                        return object;
                    };
    
                    /**
                     * Converts this PosMatchingConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosMatchingConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosMatchingConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * PosMatchingAlgorithm enum.
                     * @name palexy.streaming.v1.PosMatchingConfig.PosMatchingAlgorithm
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} MERGE_WITH_ONLY_DETECTED_ACTIONS=1 MERGE_WITH_ONLY_DETECTED_ACTIONS value
                     * @property {number} MERGE_WITH_BOTH_DETECTED_ACTIONS_AND_END_TIME=2 MERGE_WITH_BOTH_DETECTED_ACTIONS_AND_END_TIME value
                     * @property {number} DEFAULT=3 DEFAULT value
                     */
                    PosMatchingConfig.PosMatchingAlgorithm = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "MERGE_WITH_ONLY_DETECTED_ACTIONS"] = 1;
                        values[valuesById[2] = "MERGE_WITH_BOTH_DETECTED_ACTIONS_AND_END_TIME"] = 2;
                        values[valuesById[3] = "DEFAULT"] = 3;
                        return values;
                    })();
    
                    return PosMatchingConfig;
                })();
    
                v1.PosSectionMapping = (function() {
    
                    /**
                     * Properties of a PosSectionMapping.
                     * @memberof palexy.streaming.v1
                     * @interface IPosSectionMapping
                     * @property {number|null} [id] PosSectionMapping id
                     * @property {string|null} [name] PosSectionMapping name
                     * @property {number|null} [companyId] PosSectionMapping companyId
                     * @property {string|null} [appliedDate] PosSectionMapping appliedDate
                     * @property {number|null} [sectionMetadataTypeId] PosSectionMapping sectionMetadataTypeId
                     * @property {number|null} [posMetadataId_1] PosSectionMapping posMetadataId_1
                     * @property {google.protobuf.IInt64Value|null} [posMetadataId_2] PosSectionMapping posMetadataId_2
                     * @property {google.protobuf.IInt64Value|null} [posMetadataId_3] PosSectionMapping posMetadataId_3
                     * @property {google.protobuf.IInt64Value|null} [posMetadataId_4] PosSectionMapping posMetadataId_4
                     * @property {number|null} [createTimeMs] PosSectionMapping createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosSectionMapping lastUpdateTimeMs
                     * @property {palexy.streaming.v1.IMetadataType|null} [sectionMetadataType] PosSectionMapping sectionMetadataType
                     * @property {palexy.streaming.v1.IPosMetadata|null} [posMetadata_1] PosSectionMapping posMetadata_1
                     * @property {palexy.streaming.v1.IPosMetadata|null} [posMetadata_2] PosSectionMapping posMetadata_2
                     * @property {palexy.streaming.v1.IPosMetadata|null} [posMetadata_3] PosSectionMapping posMetadata_3
                     * @property {palexy.streaming.v1.IPosMetadata|null} [posMetadata_4] PosSectionMapping posMetadata_4
                     * @property {Array.<palexy.streaming.v1.IPosSectionMappingItem>|null} [sectionMappingItems] PosSectionMapping sectionMappingItems
                     */
    
                    /**
                     * Constructs a new PosSectionMapping.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosSectionMapping.
                     * @implements IPosSectionMapping
                     * @constructor
                     * @param {palexy.streaming.v1.IPosSectionMapping=} [properties] Properties to set
                     */
                    function PosSectionMapping(properties) {
                        this.sectionMappingItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosSectionMapping id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.name = "";
    
                    /**
                     * PosSectionMapping companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping appliedDate.
                     * @member {string} appliedDate
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.appliedDate = "";
    
                    /**
                     * PosSectionMapping sectionMetadataTypeId.
                     * @member {number} sectionMetadataTypeId
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.sectionMetadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping posMetadataId_1.
                     * @member {number} posMetadataId_1
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadataId_1 = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping posMetadataId_2.
                     * @member {google.protobuf.IInt64Value|null|undefined} posMetadataId_2
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadataId_2 = null;
    
                    /**
                     * PosSectionMapping posMetadataId_3.
                     * @member {google.protobuf.IInt64Value|null|undefined} posMetadataId_3
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadataId_3 = null;
    
                    /**
                     * PosSectionMapping posMetadataId_4.
                     * @member {google.protobuf.IInt64Value|null|undefined} posMetadataId_4
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadataId_4 = null;
    
                    /**
                     * PosSectionMapping createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMapping sectionMetadataType.
                     * @member {palexy.streaming.v1.IMetadataType|null|undefined} sectionMetadataType
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.sectionMetadataType = null;
    
                    /**
                     * PosSectionMapping posMetadata_1.
                     * @member {palexy.streaming.v1.IPosMetadata|null|undefined} posMetadata_1
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadata_1 = null;
    
                    /**
                     * PosSectionMapping posMetadata_2.
                     * @member {palexy.streaming.v1.IPosMetadata|null|undefined} posMetadata_2
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadata_2 = null;
    
                    /**
                     * PosSectionMapping posMetadata_3.
                     * @member {palexy.streaming.v1.IPosMetadata|null|undefined} posMetadata_3
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadata_3 = null;
    
                    /**
                     * PosSectionMapping posMetadata_4.
                     * @member {palexy.streaming.v1.IPosMetadata|null|undefined} posMetadata_4
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.posMetadata_4 = null;
    
                    /**
                     * PosSectionMapping sectionMappingItems.
                     * @member {Array.<palexy.streaming.v1.IPosSectionMappingItem>} sectionMappingItems
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     */
                    PosSectionMapping.prototype.sectionMappingItems = $util.emptyArray;
    
                    /**
                     * Creates a new PosSectionMapping instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMapping=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosSectionMapping} PosSectionMapping instance
                     */
                    PosSectionMapping.create = function create(properties) {
                        return new PosSectionMapping(properties);
                    };
    
                    /**
                     * Encodes the specified PosSectionMapping message. Does not implicitly {@link palexy.streaming.v1.PosSectionMapping.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMapping} message PosSectionMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMapping.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.companyId);
                        if (message.appliedDate != null && Object.hasOwnProperty.call(message, "appliedDate"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.appliedDate);
                        if (message.sectionMetadataTypeId != null && Object.hasOwnProperty.call(message, "sectionMetadataTypeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.sectionMetadataTypeId);
                        if (message.posMetadataId_1 != null && Object.hasOwnProperty.call(message, "posMetadataId_1"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.posMetadataId_1);
                        if (message.posMetadataId_2 != null && Object.hasOwnProperty.call(message, "posMetadataId_2"))
                            $root.google.protobuf.Int64Value.encode(message.posMetadataId_2, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.posMetadataId_3 != null && Object.hasOwnProperty.call(message, "posMetadataId_3"))
                            $root.google.protobuf.Int64Value.encode(message.posMetadataId_3, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.posMetadataId_4 != null && Object.hasOwnProperty.call(message, "posMetadataId_4"))
                            $root.google.protobuf.Int64Value.encode(message.posMetadataId_4, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.lastUpdateTimeMs);
                        if (message.sectionMetadataType != null && Object.hasOwnProperty.call(message, "sectionMetadataType"))
                            $root.palexy.streaming.v1.MetadataType.encode(message.sectionMetadataType, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.posMetadata_1 != null && Object.hasOwnProperty.call(message, "posMetadata_1"))
                            $root.palexy.streaming.v1.PosMetadata.encode(message.posMetadata_1, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.posMetadata_2 != null && Object.hasOwnProperty.call(message, "posMetadata_2"))
                            $root.palexy.streaming.v1.PosMetadata.encode(message.posMetadata_2, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.posMetadata_3 != null && Object.hasOwnProperty.call(message, "posMetadata_3"))
                            $root.palexy.streaming.v1.PosMetadata.encode(message.posMetadata_3, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.posMetadata_4 != null && Object.hasOwnProperty.call(message, "posMetadata_4"))
                            $root.palexy.streaming.v1.PosMetadata.encode(message.posMetadata_4, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.sectionMappingItems != null && message.sectionMappingItems.length)
                            for (var i = 0; i < message.sectionMappingItems.length; ++i)
                                $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.sectionMappingItems[i], writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosSectionMapping message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosSectionMapping.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMapping} message PosSectionMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMapping.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosSectionMapping message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosSectionMapping} PosSectionMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMapping.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosSectionMapping();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.companyId = reader.int64();
                                break;
                            case 4:
                                message.appliedDate = reader.string();
                                break;
                            case 6:
                                message.sectionMetadataTypeId = reader.int64();
                                break;
                            case 7:
                                message.posMetadataId_1 = reader.int64();
                                break;
                            case 8:
                                message.posMetadataId_2 = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.posMetadataId_3 = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.posMetadataId_4 = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.createTimeMs = reader.int64();
                                break;
                            case 12:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 13:
                                message.sectionMetadataType = $root.palexy.streaming.v1.MetadataType.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.posMetadata_1 = $root.palexy.streaming.v1.PosMetadata.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.posMetadata_2 = $root.palexy.streaming.v1.PosMetadata.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.posMetadata_3 = $root.palexy.streaming.v1.PosMetadata.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.posMetadata_4 = $root.palexy.streaming.v1.PosMetadata.decode(reader, reader.uint32());
                                break;
                            case 18:
                                if (!(message.sectionMappingItems && message.sectionMappingItems.length))
                                    message.sectionMappingItems = [];
                                message.sectionMappingItems.push($root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosSectionMapping message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosSectionMapping} PosSectionMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMapping.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosSectionMapping message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosSectionMapping.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            if (!$util.isString(message.appliedDate))
                                return "appliedDate: string expected";
                        if (message.sectionMetadataTypeId != null && message.hasOwnProperty("sectionMetadataTypeId"))
                            if (!$util.isInteger(message.sectionMetadataTypeId) && !(message.sectionMetadataTypeId && $util.isInteger(message.sectionMetadataTypeId.low) && $util.isInteger(message.sectionMetadataTypeId.high)))
                                return "sectionMetadataTypeId: integer|Long expected";
                        if (message.posMetadataId_1 != null && message.hasOwnProperty("posMetadataId_1"))
                            if (!$util.isInteger(message.posMetadataId_1) && !(message.posMetadataId_1 && $util.isInteger(message.posMetadataId_1.low) && $util.isInteger(message.posMetadataId_1.high)))
                                return "posMetadataId_1: integer|Long expected";
                        if (message.posMetadataId_2 != null && message.hasOwnProperty("posMetadataId_2")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.posMetadataId_2);
                            if (error)
                                return "posMetadataId_2." + error;
                        }
                        if (message.posMetadataId_3 != null && message.hasOwnProperty("posMetadataId_3")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.posMetadataId_3);
                            if (error)
                                return "posMetadataId_3." + error;
                        }
                        if (message.posMetadataId_4 != null && message.hasOwnProperty("posMetadataId_4")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.posMetadataId_4);
                            if (error)
                                return "posMetadataId_4." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.sectionMetadataType != null && message.hasOwnProperty("sectionMetadataType")) {
                            var error = $root.palexy.streaming.v1.MetadataType.verify(message.sectionMetadataType);
                            if (error)
                                return "sectionMetadataType." + error;
                        }
                        if (message.posMetadata_1 != null && message.hasOwnProperty("posMetadata_1")) {
                            var error = $root.palexy.streaming.v1.PosMetadata.verify(message.posMetadata_1);
                            if (error)
                                return "posMetadata_1." + error;
                        }
                        if (message.posMetadata_2 != null && message.hasOwnProperty("posMetadata_2")) {
                            var error = $root.palexy.streaming.v1.PosMetadata.verify(message.posMetadata_2);
                            if (error)
                                return "posMetadata_2." + error;
                        }
                        if (message.posMetadata_3 != null && message.hasOwnProperty("posMetadata_3")) {
                            var error = $root.palexy.streaming.v1.PosMetadata.verify(message.posMetadata_3);
                            if (error)
                                return "posMetadata_3." + error;
                        }
                        if (message.posMetadata_4 != null && message.hasOwnProperty("posMetadata_4")) {
                            var error = $root.palexy.streaming.v1.PosMetadata.verify(message.posMetadata_4);
                            if (error)
                                return "posMetadata_4." + error;
                        }
                        if (message.sectionMappingItems != null && message.hasOwnProperty("sectionMappingItems")) {
                            if (!Array.isArray(message.sectionMappingItems))
                                return "sectionMappingItems: array expected";
                            for (var i = 0; i < message.sectionMappingItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.sectionMappingItems[i]);
                                if (error)
                                    return "sectionMappingItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosSectionMapping message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosSectionMapping} PosSectionMapping
                     */
                    PosSectionMapping.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosSectionMapping)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosSectionMapping();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.appliedDate != null)
                            message.appliedDate = String(object.appliedDate);
                        if (object.sectionMetadataTypeId != null)
                            if ($util.Long)
                                (message.sectionMetadataTypeId = $util.Long.fromValue(object.sectionMetadataTypeId)).unsigned = false;
                            else if (typeof object.sectionMetadataTypeId === "string")
                                message.sectionMetadataTypeId = parseInt(object.sectionMetadataTypeId, 10);
                            else if (typeof object.sectionMetadataTypeId === "number")
                                message.sectionMetadataTypeId = object.sectionMetadataTypeId;
                            else if (typeof object.sectionMetadataTypeId === "object")
                                message.sectionMetadataTypeId = new $util.LongBits(object.sectionMetadataTypeId.low >>> 0, object.sectionMetadataTypeId.high >>> 0).toNumber();
                        if (object.posMetadataId_1 != null)
                            if ($util.Long)
                                (message.posMetadataId_1 = $util.Long.fromValue(object.posMetadataId_1)).unsigned = false;
                            else if (typeof object.posMetadataId_1 === "string")
                                message.posMetadataId_1 = parseInt(object.posMetadataId_1, 10);
                            else if (typeof object.posMetadataId_1 === "number")
                                message.posMetadataId_1 = object.posMetadataId_1;
                            else if (typeof object.posMetadataId_1 === "object")
                                message.posMetadataId_1 = new $util.LongBits(object.posMetadataId_1.low >>> 0, object.posMetadataId_1.high >>> 0).toNumber();
                        if (object.posMetadataId_2 != null) {
                            if (typeof object.posMetadataId_2 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadataId_2: object expected");
                            message.posMetadataId_2 = $root.google.protobuf.Int64Value.fromObject(object.posMetadataId_2);
                        }
                        if (object.posMetadataId_3 != null) {
                            if (typeof object.posMetadataId_3 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadataId_3: object expected");
                            message.posMetadataId_3 = $root.google.protobuf.Int64Value.fromObject(object.posMetadataId_3);
                        }
                        if (object.posMetadataId_4 != null) {
                            if (typeof object.posMetadataId_4 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadataId_4: object expected");
                            message.posMetadataId_4 = $root.google.protobuf.Int64Value.fromObject(object.posMetadataId_4);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.sectionMetadataType != null) {
                            if (typeof object.sectionMetadataType !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.sectionMetadataType: object expected");
                            message.sectionMetadataType = $root.palexy.streaming.v1.MetadataType.fromObject(object.sectionMetadataType);
                        }
                        if (object.posMetadata_1 != null) {
                            if (typeof object.posMetadata_1 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadata_1: object expected");
                            message.posMetadata_1 = $root.palexy.streaming.v1.PosMetadata.fromObject(object.posMetadata_1);
                        }
                        if (object.posMetadata_2 != null) {
                            if (typeof object.posMetadata_2 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadata_2: object expected");
                            message.posMetadata_2 = $root.palexy.streaming.v1.PosMetadata.fromObject(object.posMetadata_2);
                        }
                        if (object.posMetadata_3 != null) {
                            if (typeof object.posMetadata_3 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadata_3: object expected");
                            message.posMetadata_3 = $root.palexy.streaming.v1.PosMetadata.fromObject(object.posMetadata_3);
                        }
                        if (object.posMetadata_4 != null) {
                            if (typeof object.posMetadata_4 !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.posMetadata_4: object expected");
                            message.posMetadata_4 = $root.palexy.streaming.v1.PosMetadata.fromObject(object.posMetadata_4);
                        }
                        if (object.sectionMappingItems) {
                            if (!Array.isArray(object.sectionMappingItems))
                                throw TypeError(".palexy.streaming.v1.PosSectionMapping.sectionMappingItems: array expected");
                            message.sectionMappingItems = [];
                            for (var i = 0; i < object.sectionMappingItems.length; ++i) {
                                if (typeof object.sectionMappingItems[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosSectionMapping.sectionMappingItems: object expected");
                                message.sectionMappingItems[i] = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.sectionMappingItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosSectionMapping message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @static
                     * @param {palexy.streaming.v1.PosSectionMapping} message PosSectionMapping
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosSectionMapping.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sectionMappingItems = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.appliedDate = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMetadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMetadataTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.posMetadataId_1 = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.posMetadataId_1 = options.longs === String ? "0" : 0;
                            object.posMetadataId_2 = null;
                            object.posMetadataId_3 = null;
                            object.posMetadataId_4 = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.sectionMetadataType = null;
                            object.posMetadata_1 = null;
                            object.posMetadata_2 = null;
                            object.posMetadata_3 = null;
                            object.posMetadata_4 = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            object.appliedDate = message.appliedDate;
                        if (message.sectionMetadataTypeId != null && message.hasOwnProperty("sectionMetadataTypeId"))
                            if (typeof message.sectionMetadataTypeId === "number")
                                object.sectionMetadataTypeId = options.longs === String ? String(message.sectionMetadataTypeId) : message.sectionMetadataTypeId;
                            else
                                object.sectionMetadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMetadataTypeId) : options.longs === Number ? new $util.LongBits(message.sectionMetadataTypeId.low >>> 0, message.sectionMetadataTypeId.high >>> 0).toNumber() : message.sectionMetadataTypeId;
                        if (message.posMetadataId_1 != null && message.hasOwnProperty("posMetadataId_1"))
                            if (typeof message.posMetadataId_1 === "number")
                                object.posMetadataId_1 = options.longs === String ? String(message.posMetadataId_1) : message.posMetadataId_1;
                            else
                                object.posMetadataId_1 = options.longs === String ? $util.Long.prototype.toString.call(message.posMetadataId_1) : options.longs === Number ? new $util.LongBits(message.posMetadataId_1.low >>> 0, message.posMetadataId_1.high >>> 0).toNumber() : message.posMetadataId_1;
                        if (message.posMetadataId_2 != null && message.hasOwnProperty("posMetadataId_2"))
                            object.posMetadataId_2 = $root.google.protobuf.Int64Value.toObject(message.posMetadataId_2, options);
                        if (message.posMetadataId_3 != null && message.hasOwnProperty("posMetadataId_3"))
                            object.posMetadataId_3 = $root.google.protobuf.Int64Value.toObject(message.posMetadataId_3, options);
                        if (message.posMetadataId_4 != null && message.hasOwnProperty("posMetadataId_4"))
                            object.posMetadataId_4 = $root.google.protobuf.Int64Value.toObject(message.posMetadataId_4, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.sectionMetadataType != null && message.hasOwnProperty("sectionMetadataType"))
                            object.sectionMetadataType = $root.palexy.streaming.v1.MetadataType.toObject(message.sectionMetadataType, options);
                        if (message.posMetadata_1 != null && message.hasOwnProperty("posMetadata_1"))
                            object.posMetadata_1 = $root.palexy.streaming.v1.PosMetadata.toObject(message.posMetadata_1, options);
                        if (message.posMetadata_2 != null && message.hasOwnProperty("posMetadata_2"))
                            object.posMetadata_2 = $root.palexy.streaming.v1.PosMetadata.toObject(message.posMetadata_2, options);
                        if (message.posMetadata_3 != null && message.hasOwnProperty("posMetadata_3"))
                            object.posMetadata_3 = $root.palexy.streaming.v1.PosMetadata.toObject(message.posMetadata_3, options);
                        if (message.posMetadata_4 != null && message.hasOwnProperty("posMetadata_4"))
                            object.posMetadata_4 = $root.palexy.streaming.v1.PosMetadata.toObject(message.posMetadata_4, options);
                        if (message.sectionMappingItems && message.sectionMappingItems.length) {
                            object.sectionMappingItems = [];
                            for (var j = 0; j < message.sectionMappingItems.length; ++j)
                                object.sectionMappingItems[j] = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.sectionMappingItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosSectionMapping to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosSectionMapping
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosSectionMapping.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosSectionMapping;
                })();
    
                v1.PosSectionMappingItem = (function() {
    
                    /**
                     * Properties of a PosSectionMappingItem.
                     * @memberof palexy.streaming.v1
                     * @interface IPosSectionMappingItem
                     * @property {number|null} [id] PosSectionMappingItem id
                     * @property {number|null} [sectionMappingId] PosSectionMappingItem sectionMappingId
                     * @property {number|null} [sectionMetadataValueId] PosSectionMappingItem sectionMetadataValueId
                     * @property {string|null} [posMetadataValue_1] PosSectionMappingItem posMetadataValue_1
                     * @property {string|null} [posMetadataValue_2] PosSectionMappingItem posMetadataValue_2
                     * @property {string|null} [posMetadataValue_3] PosSectionMappingItem posMetadataValue_3
                     * @property {string|null} [posMetadataValue_4] PosSectionMappingItem posMetadataValue_4
                     * @property {number|null} [createTimeMs] PosSectionMappingItem createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] PosSectionMappingItem lastUpdateTimeMs
                     * @property {google.protobuf.IInt64Value|null} [storeId] PosSectionMappingItem storeId
                     * @property {string|null} [productCode] PosSectionMappingItem productCode
                     * @property {palexy.streaming.v1.IMetadataValue|null} [sectionMetadataValue] PosSectionMappingItem sectionMetadataValue
                     */
    
                    /**
                     * Constructs a new PosSectionMappingItem.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosSectionMappingItem.
                     * @implements IPosSectionMappingItem
                     * @constructor
                     * @param {palexy.streaming.v1.IPosSectionMappingItem=} [properties] Properties to set
                     */
                    function PosSectionMappingItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosSectionMappingItem id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMappingItem sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMappingItem sectionMetadataValueId.
                     * @member {number} sectionMetadataValueId
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.sectionMetadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMappingItem posMetadataValue_1.
                     * @member {string} posMetadataValue_1
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.posMetadataValue_1 = "";
    
                    /**
                     * PosSectionMappingItem posMetadataValue_2.
                     * @member {string} posMetadataValue_2
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.posMetadataValue_2 = "";
    
                    /**
                     * PosSectionMappingItem posMetadataValue_3.
                     * @member {string} posMetadataValue_3
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.posMetadataValue_3 = "";
    
                    /**
                     * PosSectionMappingItem posMetadataValue_4.
                     * @member {string} posMetadataValue_4
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.posMetadataValue_4 = "";
    
                    /**
                     * PosSectionMappingItem createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMappingItem lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PosSectionMappingItem storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.storeId = null;
    
                    /**
                     * PosSectionMappingItem productCode.
                     * @member {string} productCode
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.productCode = "";
    
                    /**
                     * PosSectionMappingItem sectionMetadataValue.
                     * @member {palexy.streaming.v1.IMetadataValue|null|undefined} sectionMetadataValue
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     */
                    PosSectionMappingItem.prototype.sectionMetadataValue = null;
    
                    /**
                     * Creates a new PosSectionMappingItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItem=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosSectionMappingItem} PosSectionMappingItem instance
                     */
                    PosSectionMappingItem.create = function create(properties) {
                        return new PosSectionMappingItem(properties);
                    };
    
                    /**
                     * Encodes the specified PosSectionMappingItem message. Does not implicitly {@link palexy.streaming.v1.PosSectionMappingItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItem} message PosSectionMappingItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMappingItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sectionMappingId);
                        if (message.sectionMetadataValueId != null && Object.hasOwnProperty.call(message, "sectionMetadataValueId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.sectionMetadataValueId);
                        if (message.posMetadataValue_1 != null && Object.hasOwnProperty.call(message, "posMetadataValue_1"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.posMetadataValue_1);
                        if (message.posMetadataValue_2 != null && Object.hasOwnProperty.call(message, "posMetadataValue_2"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.posMetadataValue_2);
                        if (message.posMetadataValue_3 != null && Object.hasOwnProperty.call(message, "posMetadataValue_3"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.posMetadataValue_3);
                        if (message.posMetadataValue_4 != null && Object.hasOwnProperty.call(message, "posMetadataValue_4"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.posMetadataValue_4);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                        if (message.sectionMetadataValue != null && Object.hasOwnProperty.call(message, "sectionMetadataValue"))
                            $root.palexy.streaming.v1.MetadataValue.encode(message.sectionMetadataValue, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.productCode != null && Object.hasOwnProperty.call(message, "productCode"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.productCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosSectionMappingItem message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosSectionMappingItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItem} message PosSectionMappingItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMappingItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosSectionMappingItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosSectionMappingItem} PosSectionMappingItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMappingItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosSectionMappingItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 3:
                                message.sectionMetadataValueId = reader.int64();
                                break;
                            case 4:
                                message.posMetadataValue_1 = reader.string();
                                break;
                            case 5:
                                message.posMetadataValue_2 = reader.string();
                                break;
                            case 6:
                                message.posMetadataValue_3 = reader.string();
                                break;
                            case 7:
                                message.posMetadataValue_4 = reader.string();
                                break;
                            case 8:
                                message.createTimeMs = reader.int64();
                                break;
                            case 9:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 11:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.productCode = reader.string();
                                break;
                            case 10:
                                message.sectionMetadataValue = $root.palexy.streaming.v1.MetadataValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosSectionMappingItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosSectionMappingItem} PosSectionMappingItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMappingItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosSectionMappingItem message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosSectionMappingItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.sectionMetadataValueId != null && message.hasOwnProperty("sectionMetadataValueId"))
                            if (!$util.isInteger(message.sectionMetadataValueId) && !(message.sectionMetadataValueId && $util.isInteger(message.sectionMetadataValueId.low) && $util.isInteger(message.sectionMetadataValueId.high)))
                                return "sectionMetadataValueId: integer|Long expected";
                        if (message.posMetadataValue_1 != null && message.hasOwnProperty("posMetadataValue_1"))
                            if (!$util.isString(message.posMetadataValue_1))
                                return "posMetadataValue_1: string expected";
                        if (message.posMetadataValue_2 != null && message.hasOwnProperty("posMetadataValue_2"))
                            if (!$util.isString(message.posMetadataValue_2))
                                return "posMetadataValue_2: string expected";
                        if (message.posMetadataValue_3 != null && message.hasOwnProperty("posMetadataValue_3"))
                            if (!$util.isString(message.posMetadataValue_3))
                                return "posMetadataValue_3: string expected";
                        if (message.posMetadataValue_4 != null && message.hasOwnProperty("posMetadataValue_4"))
                            if (!$util.isString(message.posMetadataValue_4))
                                return "posMetadataValue_4: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.productCode != null && message.hasOwnProperty("productCode"))
                            if (!$util.isString(message.productCode))
                                return "productCode: string expected";
                        if (message.sectionMetadataValue != null && message.hasOwnProperty("sectionMetadataValue")) {
                            var error = $root.palexy.streaming.v1.MetadataValue.verify(message.sectionMetadataValue);
                            if (error)
                                return "sectionMetadataValue." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosSectionMappingItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosSectionMappingItem} PosSectionMappingItem
                     */
                    PosSectionMappingItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosSectionMappingItem)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosSectionMappingItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.sectionMetadataValueId != null)
                            if ($util.Long)
                                (message.sectionMetadataValueId = $util.Long.fromValue(object.sectionMetadataValueId)).unsigned = false;
                            else if (typeof object.sectionMetadataValueId === "string")
                                message.sectionMetadataValueId = parseInt(object.sectionMetadataValueId, 10);
                            else if (typeof object.sectionMetadataValueId === "number")
                                message.sectionMetadataValueId = object.sectionMetadataValueId;
                            else if (typeof object.sectionMetadataValueId === "object")
                                message.sectionMetadataValueId = new $util.LongBits(object.sectionMetadataValueId.low >>> 0, object.sectionMetadataValueId.high >>> 0).toNumber();
                        if (object.posMetadataValue_1 != null)
                            message.posMetadataValue_1 = String(object.posMetadataValue_1);
                        if (object.posMetadataValue_2 != null)
                            message.posMetadataValue_2 = String(object.posMetadataValue_2);
                        if (object.posMetadataValue_3 != null)
                            message.posMetadataValue_3 = String(object.posMetadataValue_3);
                        if (object.posMetadataValue_4 != null)
                            message.posMetadataValue_4 = String(object.posMetadataValue_4);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMappingItem.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.productCode != null)
                            message.productCode = String(object.productCode);
                        if (object.sectionMetadataValue != null) {
                            if (typeof object.sectionMetadataValue !== "object")
                                throw TypeError(".palexy.streaming.v1.PosSectionMappingItem.sectionMetadataValue: object expected");
                            message.sectionMetadataValue = $root.palexy.streaming.v1.MetadataValue.fromObject(object.sectionMetadataValue);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosSectionMappingItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @static
                     * @param {palexy.streaming.v1.PosSectionMappingItem} message PosSectionMappingItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosSectionMappingItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMetadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMetadataValueId = options.longs === String ? "0" : 0;
                            object.posMetadataValue_1 = "";
                            object.posMetadataValue_2 = "";
                            object.posMetadataValue_3 = "";
                            object.posMetadataValue_4 = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.sectionMetadataValue = null;
                            object.storeId = null;
                            object.productCode = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.sectionMetadataValueId != null && message.hasOwnProperty("sectionMetadataValueId"))
                            if (typeof message.sectionMetadataValueId === "number")
                                object.sectionMetadataValueId = options.longs === String ? String(message.sectionMetadataValueId) : message.sectionMetadataValueId;
                            else
                                object.sectionMetadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMetadataValueId) : options.longs === Number ? new $util.LongBits(message.sectionMetadataValueId.low >>> 0, message.sectionMetadataValueId.high >>> 0).toNumber() : message.sectionMetadataValueId;
                        if (message.posMetadataValue_1 != null && message.hasOwnProperty("posMetadataValue_1"))
                            object.posMetadataValue_1 = message.posMetadataValue_1;
                        if (message.posMetadataValue_2 != null && message.hasOwnProperty("posMetadataValue_2"))
                            object.posMetadataValue_2 = message.posMetadataValue_2;
                        if (message.posMetadataValue_3 != null && message.hasOwnProperty("posMetadataValue_3"))
                            object.posMetadataValue_3 = message.posMetadataValue_3;
                        if (message.posMetadataValue_4 != null && message.hasOwnProperty("posMetadataValue_4"))
                            object.posMetadataValue_4 = message.posMetadataValue_4;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.sectionMetadataValue != null && message.hasOwnProperty("sectionMetadataValue"))
                            object.sectionMetadataValue = $root.palexy.streaming.v1.MetadataValue.toObject(message.sectionMetadataValue, options);
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.productCode != null && message.hasOwnProperty("productCode"))
                            object.productCode = message.productCode;
                        return object;
                    };
    
                    /**
                     * Converts this PosSectionMappingItem to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosSectionMappingItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosSectionMappingItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosSectionMappingItem;
                })();
    
                v1.ListSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a ListSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListSectionMappingRequest
                     * @property {number|null} [companyId] ListSectionMappingRequest companyId
                     * @property {google.protobuf.IInt64Value|null} [sectionMetadataTypeId] ListSectionMappingRequest sectionMetadataTypeId
                     * @property {number|null} [pageSize] ListSectionMappingRequest pageSize
                     * @property {string|null} [pageToken] ListSectionMappingRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSectionMappingRequest.
                     * @implements IListSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListSectionMappingRequest=} [properties] Properties to set
                     */
                    function ListSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSectionMappingRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @instance
                     */
                    ListSectionMappingRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListSectionMappingRequest sectionMetadataTypeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} sectionMetadataTypeId
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @instance
                     */
                    ListSectionMappingRequest.prototype.sectionMetadataTypeId = null;
    
                    /**
                     * ListSectionMappingRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @instance
                     */
                    ListSectionMappingRequest.prototype.pageSize = 0;
    
                    /**
                     * ListSectionMappingRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @instance
                     */
                    ListSectionMappingRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSectionMappingRequest} ListSectionMappingRequest instance
                     */
                    ListSectionMappingRequest.create = function create(properties) {
                        return new ListSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingRequest} message ListSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.sectionMetadataTypeId != null && Object.hasOwnProperty.call(message, "sectionMetadataTypeId"))
                            $root.google.protobuf.Int64Value.encode(message.sectionMetadataTypeId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingRequest} message ListSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSectionMappingRequest} ListSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.sectionMetadataTypeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSectionMappingRequest} ListSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.sectionMetadataTypeId != null && message.hasOwnProperty("sectionMetadataTypeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.sectionMetadataTypeId);
                            if (error)
                                return "sectionMetadataTypeId." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSectionMappingRequest} ListSectionMappingRequest
                     */
                    ListSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSectionMappingRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.sectionMetadataTypeId != null) {
                            if (typeof object.sectionMetadataTypeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListSectionMappingRequest.sectionMetadataTypeId: object expected");
                            message.sectionMetadataTypeId = $root.google.protobuf.Int64Value.fromObject(object.sectionMetadataTypeId);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListSectionMappingRequest} message ListSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.sectionMetadataTypeId = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.sectionMetadataTypeId != null && message.hasOwnProperty("sectionMetadataTypeId"))
                            object.sectionMetadataTypeId = $root.google.protobuf.Int64Value.toObject(message.sectionMetadataTypeId, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSectionMappingRequest;
                })();
    
                v1.ListSectionMappingResponse = (function() {
    
                    /**
                     * Properties of a ListSectionMappingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListSectionMappingResponse
                     * @property {Array.<palexy.streaming.v1.IPosSectionMapping>|null} [sectionMappingList] ListSectionMappingResponse sectionMappingList
                     * @property {number|null} [totalElements] ListSectionMappingResponse totalElements
                     * @property {string|null} [nextPageToken] ListSectionMappingResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListSectionMappingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSectionMappingResponse.
                     * @implements IListSectionMappingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListSectionMappingResponse=} [properties] Properties to set
                     */
                    function ListSectionMappingResponse(properties) {
                        this.sectionMappingList = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSectionMappingResponse sectionMappingList.
                     * @member {Array.<palexy.streaming.v1.IPosSectionMapping>} sectionMappingList
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @instance
                     */
                    ListSectionMappingResponse.prototype.sectionMappingList = $util.emptyArray;
    
                    /**
                     * ListSectionMappingResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @instance
                     */
                    ListSectionMappingResponse.prototype.totalElements = 0;
    
                    /**
                     * ListSectionMappingResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @instance
                     */
                    ListSectionMappingResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListSectionMappingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSectionMappingResponse} ListSectionMappingResponse instance
                     */
                    ListSectionMappingResponse.create = function create(properties) {
                        return new ListSectionMappingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingResponse message. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingResponse} message ListSectionMappingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingList != null && message.sectionMappingList.length)
                            for (var i = 0; i < message.sectionMappingList.length; ++i)
                                $root.palexy.streaming.v1.PosSectionMapping.encode(message.sectionMappingList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingResponse} message ListSectionMappingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSectionMappingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSectionMappingResponse} ListSectionMappingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSectionMappingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sectionMappingList && message.sectionMappingList.length))
                                    message.sectionMappingList = [];
                                message.sectionMappingList.push($root.palexy.streaming.v1.PosSectionMapping.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSectionMappingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSectionMappingResponse} ListSectionMappingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSectionMappingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSectionMappingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingList != null && message.hasOwnProperty("sectionMappingList")) {
                            if (!Array.isArray(message.sectionMappingList))
                                return "sectionMappingList: array expected";
                            for (var i = 0; i < message.sectionMappingList.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosSectionMapping.verify(message.sectionMappingList[i]);
                                if (error)
                                    return "sectionMappingList." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListSectionMappingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSectionMappingResponse} ListSectionMappingResponse
                     */
                    ListSectionMappingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSectionMappingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSectionMappingResponse();
                        if (object.sectionMappingList) {
                            if (!Array.isArray(object.sectionMappingList))
                                throw TypeError(".palexy.streaming.v1.ListSectionMappingResponse.sectionMappingList: array expected");
                            message.sectionMappingList = [];
                            for (var i = 0; i < object.sectionMappingList.length; ++i) {
                                if (typeof object.sectionMappingList[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListSectionMappingResponse.sectionMappingList: object expected");
                                message.sectionMappingList[i] = $root.palexy.streaming.v1.PosSectionMapping.fromObject(object.sectionMappingList[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSectionMappingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListSectionMappingResponse} message ListSectionMappingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSectionMappingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sectionMappingList = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.sectionMappingList && message.sectionMappingList.length) {
                            object.sectionMappingList = [];
                            for (var j = 0; j < message.sectionMappingList.length; ++j)
                                object.sectionMappingList[j] = $root.palexy.streaming.v1.PosSectionMapping.toObject(message.sectionMappingList[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListSectionMappingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSectionMappingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSectionMappingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSectionMappingResponse;
                })();
    
                v1.CreateSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a CreateSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateSectionMappingRequest
                     * @property {palexy.streaming.v1.IPosSectionMapping|null} [sectionMapping] CreateSectionMappingRequest sectionMapping
                     * @property {boolean|null} [skipChangeEvent] CreateSectionMappingRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new CreateSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateSectionMappingRequest.
                     * @implements ICreateSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest=} [properties] Properties to set
                     */
                    function CreateSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateSectionMappingRequest sectionMapping.
                     * @member {palexy.streaming.v1.IPosSectionMapping|null|undefined} sectionMapping
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @instance
                     */
                    CreateSectionMappingRequest.prototype.sectionMapping = null;
    
                    /**
                     * CreateSectionMappingRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @instance
                     */
                    CreateSectionMappingRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new CreateSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateSectionMappingRequest} CreateSectionMappingRequest instance
                     */
                    CreateSectionMappingRequest.create = function create(properties) {
                        return new CreateSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.CreateSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest} message CreateSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMapping != null && Object.hasOwnProperty.call(message, "sectionMapping"))
                            $root.palexy.streaming.v1.PosSectionMapping.encode(message.sectionMapping, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingRequest} message CreateSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateSectionMappingRequest} CreateSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateSectionMappingRequest} CreateSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMapping != null && message.hasOwnProperty("sectionMapping")) {
                            var error = $root.palexy.streaming.v1.PosSectionMapping.verify(message.sectionMapping);
                            if (error)
                                return "sectionMapping." + error;
                        }
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateSectionMappingRequest} CreateSectionMappingRequest
                     */
                    CreateSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateSectionMappingRequest();
                        if (object.sectionMapping != null) {
                            if (typeof object.sectionMapping !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateSectionMappingRequest.sectionMapping: object expected");
                            message.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.fromObject(object.sectionMapping);
                        }
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateSectionMappingRequest} message CreateSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sectionMapping = null;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMapping != null && message.hasOwnProperty("sectionMapping"))
                            object.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.toObject(message.sectionMapping, options);
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this CreateSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateSectionMappingRequest;
                })();
    
                v1.UpdateSectionMappingRequest = (function() {
    
                    /**
                     * Properties of an UpdateSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateSectionMappingRequest
                     * @property {palexy.streaming.v1.IPosSectionMapping|null} [sectionMapping] UpdateSectionMappingRequest sectionMapping
                     * @property {boolean|null} [skipChangeEvent] UpdateSectionMappingRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new UpdateSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateSectionMappingRequest.
                     * @implements IUpdateSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest=} [properties] Properties to set
                     */
                    function UpdateSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateSectionMappingRequest sectionMapping.
                     * @member {palexy.streaming.v1.IPosSectionMapping|null|undefined} sectionMapping
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @instance
                     */
                    UpdateSectionMappingRequest.prototype.sectionMapping = null;
    
                    /**
                     * UpdateSectionMappingRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @instance
                     */
                    UpdateSectionMappingRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new UpdateSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateSectionMappingRequest} UpdateSectionMappingRequest instance
                     */
                    UpdateSectionMappingRequest.create = function create(properties) {
                        return new UpdateSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest} message UpdateSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMapping != null && Object.hasOwnProperty.call(message, "sectionMapping"))
                            $root.palexy.streaming.v1.PosSectionMapping.encode(message.sectionMapping, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingRequest} message UpdateSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateSectionMappingRequest} UpdateSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateSectionMappingRequest} UpdateSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMapping != null && message.hasOwnProperty("sectionMapping")) {
                            var error = $root.palexy.streaming.v1.PosSectionMapping.verify(message.sectionMapping);
                            if (error)
                                return "sectionMapping." + error;
                        }
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateSectionMappingRequest} UpdateSectionMappingRequest
                     */
                    UpdateSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateSectionMappingRequest();
                        if (object.sectionMapping != null) {
                            if (typeof object.sectionMapping !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateSectionMappingRequest.sectionMapping: object expected");
                            message.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.fromObject(object.sectionMapping);
                        }
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateSectionMappingRequest} message UpdateSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sectionMapping = null;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMapping != null && message.hasOwnProperty("sectionMapping"))
                            object.sectionMapping = $root.palexy.streaming.v1.PosSectionMapping.toObject(message.sectionMapping, options);
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateSectionMappingRequest;
                })();
    
                v1.DeleteSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a DeleteSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteSectionMappingRequest
                     * @property {number|null} [sectionMappingId] DeleteSectionMappingRequest sectionMappingId
                     * @property {boolean|null} [skipChangeEvent] DeleteSectionMappingRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new DeleteSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteSectionMappingRequest.
                     * @implements IDeleteSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest=} [properties] Properties to set
                     */
                    function DeleteSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteSectionMappingRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @instance
                     */
                    DeleteSectionMappingRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteSectionMappingRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @instance
                     */
                    DeleteSectionMappingRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new DeleteSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteSectionMappingRequest} DeleteSectionMappingRequest instance
                     */
                    DeleteSectionMappingRequest.create = function create(properties) {
                        return new DeleteSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest} message DeleteSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingRequest} message DeleteSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteSectionMappingRequest} DeleteSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteSectionMappingRequest} DeleteSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteSectionMappingRequest} DeleteSectionMappingRequest
                     */
                    DeleteSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteSectionMappingRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteSectionMappingRequest} message DeleteSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteSectionMappingRequest;
                })();
    
                v1.GetSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a GetSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetSectionMappingRequest
                     * @property {number|null} [sectionMappingId] GetSectionMappingRequest sectionMappingId
                     * @property {boolean|null} [includeMetadataInfo] GetSectionMappingRequest includeMetadataInfo
                     */
    
                    /**
                     * Constructs a new GetSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetSectionMappingRequest.
                     * @implements IGetSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest=} [properties] Properties to set
                     */
                    function GetSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetSectionMappingRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @instance
                     */
                    GetSectionMappingRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetSectionMappingRequest includeMetadataInfo.
                     * @member {boolean} includeMetadataInfo
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @instance
                     */
                    GetSectionMappingRequest.prototype.includeMetadataInfo = false;
    
                    /**
                     * Creates a new GetSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetSectionMappingRequest} GetSectionMappingRequest instance
                     */
                    GetSectionMappingRequest.create = function create(properties) {
                        return new GetSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.GetSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest} message GetSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.includeMetadataInfo != null && Object.hasOwnProperty.call(message, "includeMetadataInfo"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeMetadataInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingRequest} message GetSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetSectionMappingRequest} GetSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.includeMetadataInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetSectionMappingRequest} GetSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.includeMetadataInfo != null && message.hasOwnProperty("includeMetadataInfo"))
                            if (typeof message.includeMetadataInfo !== "boolean")
                                return "includeMetadataInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetSectionMappingRequest} GetSectionMappingRequest
                     */
                    GetSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetSectionMappingRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.includeMetadataInfo != null)
                            message.includeMetadataInfo = Boolean(object.includeMetadataInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.GetSectionMappingRequest} message GetSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            object.includeMetadataInfo = false;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.includeMetadataInfo != null && message.hasOwnProperty("includeMetadataInfo"))
                            object.includeMetadataInfo = message.includeMetadataInfo;
                        return object;
                    };
    
                    /**
                     * Converts this GetSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetSectionMappingRequest;
                })();
    
                v1.CloneSectionMappingRequest = (function() {
    
                    /**
                     * Properties of a CloneSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICloneSectionMappingRequest
                     * @property {number|null} [cloningSectionMappingId] CloneSectionMappingRequest cloningSectionMappingId
                     * @property {string|null} [name] CloneSectionMappingRequest name
                     * @property {string|null} [appliedDate] CloneSectionMappingRequest appliedDate
                     * @property {boolean|null} [skipChangeEvent] CloneSectionMappingRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new CloneSectionMappingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CloneSectionMappingRequest.
                     * @implements ICloneSectionMappingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest=} [properties] Properties to set
                     */
                    function CloneSectionMappingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CloneSectionMappingRequest cloningSectionMappingId.
                     * @member {number} cloningSectionMappingId
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @instance
                     */
                    CloneSectionMappingRequest.prototype.cloningSectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CloneSectionMappingRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @instance
                     */
                    CloneSectionMappingRequest.prototype.name = "";
    
                    /**
                     * CloneSectionMappingRequest appliedDate.
                     * @member {string} appliedDate
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @instance
                     */
                    CloneSectionMappingRequest.prototype.appliedDate = "";
    
                    /**
                     * CloneSectionMappingRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @instance
                     */
                    CloneSectionMappingRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new CloneSectionMappingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CloneSectionMappingRequest} CloneSectionMappingRequest instance
                     */
                    CloneSectionMappingRequest.create = function create(properties) {
                        return new CloneSectionMappingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CloneSectionMappingRequest message. Does not implicitly {@link palexy.streaming.v1.CloneSectionMappingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest} message CloneSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloneSectionMappingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cloningSectionMappingId != null && Object.hasOwnProperty.call(message, "cloningSectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.cloningSectionMappingId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.appliedDate != null && Object.hasOwnProperty.call(message, "appliedDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.appliedDate);
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CloneSectionMappingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CloneSectionMappingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICloneSectionMappingRequest} message CloneSectionMappingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloneSectionMappingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CloneSectionMappingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CloneSectionMappingRequest} CloneSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloneSectionMappingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CloneSectionMappingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cloningSectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.appliedDate = reader.string();
                                break;
                            case 4:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CloneSectionMappingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CloneSectionMappingRequest} CloneSectionMappingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloneSectionMappingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CloneSectionMappingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CloneSectionMappingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cloningSectionMappingId != null && message.hasOwnProperty("cloningSectionMappingId"))
                            if (!$util.isInteger(message.cloningSectionMappingId) && !(message.cloningSectionMappingId && $util.isInteger(message.cloningSectionMappingId.low) && $util.isInteger(message.cloningSectionMappingId.high)))
                                return "cloningSectionMappingId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            if (!$util.isString(message.appliedDate))
                                return "appliedDate: string expected";
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CloneSectionMappingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CloneSectionMappingRequest} CloneSectionMappingRequest
                     */
                    CloneSectionMappingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CloneSectionMappingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CloneSectionMappingRequest();
                        if (object.cloningSectionMappingId != null)
                            if ($util.Long)
                                (message.cloningSectionMappingId = $util.Long.fromValue(object.cloningSectionMappingId)).unsigned = false;
                            else if (typeof object.cloningSectionMappingId === "string")
                                message.cloningSectionMappingId = parseInt(object.cloningSectionMappingId, 10);
                            else if (typeof object.cloningSectionMappingId === "number")
                                message.cloningSectionMappingId = object.cloningSectionMappingId;
                            else if (typeof object.cloningSectionMappingId === "object")
                                message.cloningSectionMappingId = new $util.LongBits(object.cloningSectionMappingId.low >>> 0, object.cloningSectionMappingId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.appliedDate != null)
                            message.appliedDate = String(object.appliedDate);
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CloneSectionMappingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @static
                     * @param {palexy.streaming.v1.CloneSectionMappingRequest} message CloneSectionMappingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CloneSectionMappingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cloningSectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cloningSectionMappingId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.appliedDate = "";
                            object.skipChangeEvent = false;
                        }
                        if (message.cloningSectionMappingId != null && message.hasOwnProperty("cloningSectionMappingId"))
                            if (typeof message.cloningSectionMappingId === "number")
                                object.cloningSectionMappingId = options.longs === String ? String(message.cloningSectionMappingId) : message.cloningSectionMappingId;
                            else
                                object.cloningSectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.cloningSectionMappingId) : options.longs === Number ? new $util.LongBits(message.cloningSectionMappingId.low >>> 0, message.cloningSectionMappingId.high >>> 0).toNumber() : message.cloningSectionMappingId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.appliedDate != null && message.hasOwnProperty("appliedDate"))
                            object.appliedDate = message.appliedDate;
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this CloneSectionMappingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CloneSectionMappingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CloneSectionMappingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CloneSectionMappingRequest;
                })();
    
                v1.ListSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of a ListSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListSectionMappingItemRequest
                     * @property {number|null} [sectionMappingId] ListSectionMappingItemRequest sectionMappingId
                     * @property {google.protobuf.IInt64Value|null} [sectionMetadataValueId] ListSectionMappingItemRequest sectionMetadataValueId
                     * @property {google.protobuf.IInt64Value|null} [storeId] ListSectionMappingItemRequest storeId
                     * @property {number|null} [pageSize] ListSectionMappingItemRequest pageSize
                     * @property {string|null} [pageToken] ListSectionMappingItemRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSectionMappingItemRequest.
                     * @implements IListSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function ListSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSectionMappingItemRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     */
                    ListSectionMappingItemRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListSectionMappingItemRequest sectionMetadataValueId.
                     * @member {google.protobuf.IInt64Value|null|undefined} sectionMetadataValueId
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     */
                    ListSectionMappingItemRequest.prototype.sectionMetadataValueId = null;
    
                    /**
                     * ListSectionMappingItemRequest storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     */
                    ListSectionMappingItemRequest.prototype.storeId = null;
    
                    /**
                     * ListSectionMappingItemRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     */
                    ListSectionMappingItemRequest.prototype.pageSize = 0;
    
                    /**
                     * ListSectionMappingItemRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     */
                    ListSectionMappingItemRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSectionMappingItemRequest} ListSectionMappingItemRequest instance
                     */
                    ListSectionMappingItemRequest.create = function create(properties) {
                        return new ListSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest} message ListSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.sectionMetadataValueId != null && Object.hasOwnProperty.call(message, "sectionMetadataValueId"))
                            $root.google.protobuf.Int64Value.encode(message.sectionMetadataValueId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemRequest} message ListSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSectionMappingItemRequest} ListSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.sectionMetadataValueId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSectionMappingItemRequest} ListSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.sectionMetadataValueId != null && message.hasOwnProperty("sectionMetadataValueId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.sectionMetadataValueId);
                            if (error)
                                return "sectionMetadataValueId." + error;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSectionMappingItemRequest} ListSectionMappingItemRequest
                     */
                    ListSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSectionMappingItemRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.sectionMetadataValueId != null) {
                            if (typeof object.sectionMetadataValueId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListSectionMappingItemRequest.sectionMetadataValueId: object expected");
                            message.sectionMetadataValueId = $root.google.protobuf.Int64Value.fromObject(object.sectionMetadataValueId);
                        }
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListSectionMappingItemRequest.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ListSectionMappingItemRequest} message ListSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            object.sectionMetadataValueId = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.storeId = null;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.sectionMetadataValueId != null && message.hasOwnProperty("sectionMetadataValueId"))
                            object.sectionMetadataValueId = $root.google.protobuf.Int64Value.toObject(message.sectionMetadataValueId, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSectionMappingItemRequest;
                })();
    
                v1.ListSectionMappingItemResponse = (function() {
    
                    /**
                     * Properties of a ListSectionMappingItemResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListSectionMappingItemResponse
                     * @property {Array.<palexy.streaming.v1.IPosSectionMappingItem>|null} [items] ListSectionMappingItemResponse items
                     * @property {number|null} [totalElements] ListSectionMappingItemResponse totalElements
                     * @property {string|null} [nextPageToken] ListSectionMappingItemResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListSectionMappingItemResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListSectionMappingItemResponse.
                     * @implements IListSectionMappingItemResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListSectionMappingItemResponse=} [properties] Properties to set
                     */
                    function ListSectionMappingItemResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListSectionMappingItemResponse items.
                     * @member {Array.<palexy.streaming.v1.IPosSectionMappingItem>} items
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @instance
                     */
                    ListSectionMappingItemResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * ListSectionMappingItemResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @instance
                     */
                    ListSectionMappingItemResponse.prototype.totalElements = 0;
    
                    /**
                     * ListSectionMappingItemResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @instance
                     */
                    ListSectionMappingItemResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListSectionMappingItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListSectionMappingItemResponse} ListSectionMappingItemResponse instance
                     */
                    ListSectionMappingItemResponse.create = function create(properties) {
                        return new ListSectionMappingItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingItemResponse message. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemResponse} message ListSectionMappingItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListSectionMappingItemResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListSectionMappingItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IListSectionMappingItemResponse} message ListSectionMappingItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListSectionMappingItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListSectionMappingItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListSectionMappingItemResponse} ListSectionMappingItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListSectionMappingItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListSectionMappingItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListSectionMappingItemResponse} ListSectionMappingItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListSectionMappingItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListSectionMappingItemResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListSectionMappingItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListSectionMappingItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListSectionMappingItemResponse} ListSectionMappingItemResponse
                     */
                    ListSectionMappingItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListSectionMappingItemResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListSectionMappingItemResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.streaming.v1.ListSectionMappingItemResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListSectionMappingItemResponse.items: object expected");
                                message.items[i] = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.items[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListSectionMappingItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.ListSectionMappingItemResponse} message ListSectionMappingItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListSectionMappingItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.items[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListSectionMappingItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListSectionMappingItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListSectionMappingItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListSectionMappingItemResponse;
                })();
    
                v1.GetSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of a GetSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetSectionMappingItemRequest
                     * @property {number|null} [sectionMappingId] GetSectionMappingItemRequest sectionMappingId
                     * @property {number|null} [sectionMappingItemId] GetSectionMappingItemRequest sectionMappingItemId
                     */
    
                    /**
                     * Constructs a new GetSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetSectionMappingItemRequest.
                     * @implements IGetSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function GetSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetSectionMappingItemRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @instance
                     */
                    GetSectionMappingItemRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetSectionMappingItemRequest sectionMappingItemId.
                     * @member {number} sectionMappingItemId
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @instance
                     */
                    GetSectionMappingItemRequest.prototype.sectionMappingItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetSectionMappingItemRequest} GetSectionMappingItemRequest instance
                     */
                    GetSectionMappingItemRequest.create = function create(properties) {
                        return new GetSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.GetSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest} message GetSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.sectionMappingItemId != null && Object.hasOwnProperty.call(message, "sectionMappingItemId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sectionMappingItemId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetSectionMappingItemRequest} message GetSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetSectionMappingItemRequest} GetSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.sectionMappingItemId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetSectionMappingItemRequest} GetSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.sectionMappingItemId != null && message.hasOwnProperty("sectionMappingItemId"))
                            if (!$util.isInteger(message.sectionMappingItemId) && !(message.sectionMappingItemId && $util.isInteger(message.sectionMappingItemId.low) && $util.isInteger(message.sectionMappingItemId.high)))
                                return "sectionMappingItemId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetSectionMappingItemRequest} GetSectionMappingItemRequest
                     */
                    GetSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetSectionMappingItemRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.sectionMappingItemId != null)
                            if ($util.Long)
                                (message.sectionMappingItemId = $util.Long.fromValue(object.sectionMappingItemId)).unsigned = false;
                            else if (typeof object.sectionMappingItemId === "string")
                                message.sectionMappingItemId = parseInt(object.sectionMappingItemId, 10);
                            else if (typeof object.sectionMappingItemId === "number")
                                message.sectionMappingItemId = object.sectionMappingItemId;
                            else if (typeof object.sectionMappingItemId === "object")
                                message.sectionMappingItemId = new $util.LongBits(object.sectionMappingItemId.low >>> 0, object.sectionMappingItemId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.GetSectionMappingItemRequest} message GetSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingItemId = options.longs === String ? "0" : 0;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.sectionMappingItemId != null && message.hasOwnProperty("sectionMappingItemId"))
                            if (typeof message.sectionMappingItemId === "number")
                                object.sectionMappingItemId = options.longs === String ? String(message.sectionMappingItemId) : message.sectionMappingItemId;
                            else
                                object.sectionMappingItemId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingItemId) : options.longs === Number ? new $util.LongBits(message.sectionMappingItemId.low >>> 0, message.sectionMappingItemId.high >>> 0).toNumber() : message.sectionMappingItemId;
                        return object;
                    };
    
                    /**
                     * Converts this GetSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetSectionMappingItemRequest;
                })();
    
                v1.CreateSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of a CreateSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateSectionMappingItemRequest
                     * @property {palexy.streaming.v1.IPosSectionMappingItem|null} [sectionMappingItem] CreateSectionMappingItemRequest sectionMappingItem
                     * @property {boolean|null} [skipChangeEvent] CreateSectionMappingItemRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new CreateSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateSectionMappingItemRequest.
                     * @implements ICreateSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function CreateSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateSectionMappingItemRequest sectionMappingItem.
                     * @member {palexy.streaming.v1.IPosSectionMappingItem|null|undefined} sectionMappingItem
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @instance
                     */
                    CreateSectionMappingItemRequest.prototype.sectionMappingItem = null;
    
                    /**
                     * CreateSectionMappingItemRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @instance
                     */
                    CreateSectionMappingItemRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new CreateSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateSectionMappingItemRequest} CreateSectionMappingItemRequest instance
                     */
                    CreateSectionMappingItemRequest.create = function create(properties) {
                        return new CreateSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.CreateSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest} message CreateSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingItem != null && Object.hasOwnProperty.call(message, "sectionMappingItem"))
                            $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.sectionMappingItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateSectionMappingItemRequest} message CreateSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateSectionMappingItemRequest} CreateSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateSectionMappingItemRequest} CreateSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingItem != null && message.hasOwnProperty("sectionMappingItem")) {
                            var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.sectionMappingItem);
                            if (error)
                                return "sectionMappingItem." + error;
                        }
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateSectionMappingItemRequest} CreateSectionMappingItemRequest
                     */
                    CreateSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateSectionMappingItemRequest();
                        if (object.sectionMappingItem != null) {
                            if (typeof object.sectionMappingItem !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateSectionMappingItemRequest.sectionMappingItem: object expected");
                            message.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.sectionMappingItem);
                        }
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateSectionMappingItemRequest} message CreateSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sectionMappingItem = null;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMappingItem != null && message.hasOwnProperty("sectionMappingItem"))
                            object.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.sectionMappingItem, options);
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this CreateSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateSectionMappingItemRequest;
                })();
    
                v1.UpdateSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of an UpdateSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateSectionMappingItemRequest
                     * @property {palexy.streaming.v1.IPosSectionMappingItem|null} [sectionMappingItem] UpdateSectionMappingItemRequest sectionMappingItem
                     * @property {boolean|null} [skipChangeEvent] UpdateSectionMappingItemRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new UpdateSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateSectionMappingItemRequest.
                     * @implements IUpdateSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function UpdateSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateSectionMappingItemRequest sectionMappingItem.
                     * @member {palexy.streaming.v1.IPosSectionMappingItem|null|undefined} sectionMappingItem
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @instance
                     */
                    UpdateSectionMappingItemRequest.prototype.sectionMappingItem = null;
    
                    /**
                     * UpdateSectionMappingItemRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @instance
                     */
                    UpdateSectionMappingItemRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new UpdateSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateSectionMappingItemRequest} UpdateSectionMappingItemRequest instance
                     */
                    UpdateSectionMappingItemRequest.create = function create(properties) {
                        return new UpdateSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest} message UpdateSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingItem != null && Object.hasOwnProperty.call(message, "sectionMappingItem"))
                            $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.sectionMappingItem, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateSectionMappingItemRequest} message UpdateSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateSectionMappingItemRequest} UpdateSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateSectionMappingItemRequest} UpdateSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingItem != null && message.hasOwnProperty("sectionMappingItem")) {
                            var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.sectionMappingItem);
                            if (error)
                                return "sectionMappingItem." + error;
                        }
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateSectionMappingItemRequest} UpdateSectionMappingItemRequest
                     */
                    UpdateSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateSectionMappingItemRequest();
                        if (object.sectionMappingItem != null) {
                            if (typeof object.sectionMappingItem !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateSectionMappingItemRequest.sectionMappingItem: object expected");
                            message.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.sectionMappingItem);
                        }
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateSectionMappingItemRequest} message UpdateSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sectionMappingItem = null;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMappingItem != null && message.hasOwnProperty("sectionMappingItem"))
                            object.sectionMappingItem = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.sectionMappingItem, options);
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateSectionMappingItemRequest;
                })();
    
                v1.DeleteSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of a DeleteSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteSectionMappingItemRequest
                     * @property {number|null} [sectionMappingId] DeleteSectionMappingItemRequest sectionMappingId
                     * @property {number|null} [sectionMappingItemId] DeleteSectionMappingItemRequest sectionMappingItemId
                     * @property {boolean|null} [skipChangeEvent] DeleteSectionMappingItemRequest skipChangeEvent
                     */
    
                    /**
                     * Constructs a new DeleteSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteSectionMappingItemRequest.
                     * @implements IDeleteSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function DeleteSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteSectionMappingItemRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @instance
                     */
                    DeleteSectionMappingItemRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteSectionMappingItemRequest sectionMappingItemId.
                     * @member {number} sectionMappingItemId
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @instance
                     */
                    DeleteSectionMappingItemRequest.prototype.sectionMappingItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteSectionMappingItemRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @instance
                     */
                    DeleteSectionMappingItemRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * Creates a new DeleteSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteSectionMappingItemRequest} DeleteSectionMappingItemRequest instance
                     */
                    DeleteSectionMappingItemRequest.create = function create(properties) {
                        return new DeleteSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest} message DeleteSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.sectionMappingItemId != null && Object.hasOwnProperty.call(message, "sectionMappingItemId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sectionMappingItemId);
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.skipChangeEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteSectionMappingItemRequest} message DeleteSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteSectionMappingItemRequest} DeleteSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.sectionMappingItemId = reader.int64();
                                break;
                            case 3:
                                message.skipChangeEvent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteSectionMappingItemRequest} DeleteSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.sectionMappingItemId != null && message.hasOwnProperty("sectionMappingItemId"))
                            if (!$util.isInteger(message.sectionMappingItemId) && !(message.sectionMappingItemId && $util.isInteger(message.sectionMappingItemId.low) && $util.isInteger(message.sectionMappingItemId.high)))
                                return "sectionMappingItemId: integer|Long expected";
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteSectionMappingItemRequest} DeleteSectionMappingItemRequest
                     */
                    DeleteSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteSectionMappingItemRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.sectionMappingItemId != null)
                            if ($util.Long)
                                (message.sectionMappingItemId = $util.Long.fromValue(object.sectionMappingItemId)).unsigned = false;
                            else if (typeof object.sectionMappingItemId === "string")
                                message.sectionMappingItemId = parseInt(object.sectionMappingItemId, 10);
                            else if (typeof object.sectionMappingItemId === "number")
                                message.sectionMappingItemId = object.sectionMappingItemId;
                            else if (typeof object.sectionMappingItemId === "object")
                                message.sectionMappingItemId = new $util.LongBits(object.sectionMappingItemId.low >>> 0, object.sectionMappingItemId.high >>> 0).toNumber();
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteSectionMappingItemRequest} message DeleteSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingItemId = options.longs === String ? "0" : 0;
                            object.skipChangeEvent = false;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.sectionMappingItemId != null && message.hasOwnProperty("sectionMappingItemId"))
                            if (typeof message.sectionMappingItemId === "number")
                                object.sectionMappingItemId = options.longs === String ? String(message.sectionMappingItemId) : message.sectionMappingItemId;
                            else
                                object.sectionMappingItemId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingItemId) : options.longs === Number ? new $util.LongBits(message.sectionMappingItemId.low >>> 0, message.sectionMappingItemId.high >>> 0).toNumber() : message.sectionMappingItemId;
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteSectionMappingItemRequest;
                })();
    
                v1.ImportSectionMappingItemRequest = (function() {
    
                    /**
                     * Properties of an ImportSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IImportSectionMappingItemRequest
                     * @property {number|null} [sectionMappingId] ImportSectionMappingItemRequest sectionMappingId
                     * @property {google.protobuf.IInt64Value|null} [storeId] ImportSectionMappingItemRequest storeId
                     * @property {number|null} [accountId] ImportSectionMappingItemRequest accountId
                     * @property {boolean|null} [skipChangeEvent] ImportSectionMappingItemRequest skipChangeEvent
                     * @property {boolean|null} [preview] ImportSectionMappingItemRequest preview
                     * @property {palexy.streaming.v1.IPosSectionMappingItemList|null} [itemList] ImportSectionMappingItemRequest itemList
                     */
    
                    /**
                     * Constructs a new ImportSectionMappingItemRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportSectionMappingItemRequest.
                     * @implements IImportSectionMappingItemRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest=} [properties] Properties to set
                     */
                    function ImportSectionMappingItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportSectionMappingItemRequest sectionMappingId.
                     * @member {number} sectionMappingId
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.sectionMappingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportSectionMappingItemRequest storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.storeId = null;
    
                    /**
                     * ImportSectionMappingItemRequest accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportSectionMappingItemRequest skipChangeEvent.
                     * @member {boolean} skipChangeEvent
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.skipChangeEvent = false;
    
                    /**
                     * ImportSectionMappingItemRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.preview = false;
    
                    /**
                     * ImportSectionMappingItemRequest itemList.
                     * @member {palexy.streaming.v1.IPosSectionMappingItemList|null|undefined} itemList
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    ImportSectionMappingItemRequest.prototype.itemList = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ImportSectionMappingItemRequest sourceData.
                     * @member {"itemList"|undefined} sourceData
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     */
                    Object.defineProperty(ImportSectionMappingItemRequest.prototype, "sourceData", {
                        get: $util.oneOfGetter($oneOfFields = ["itemList"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ImportSectionMappingItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemRequest} ImportSectionMappingItemRequest instance
                     */
                    ImportSectionMappingItemRequest.create = function create(properties) {
                        return new ImportSectionMappingItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportSectionMappingItemRequest message. Does not implicitly {@link palexy.streaming.v1.ImportSectionMappingItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest} message ImportSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportSectionMappingItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingId != null && Object.hasOwnProperty.call(message, "sectionMappingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sectionMappingId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.accountId);
                        if (message.skipChangeEvent != null && Object.hasOwnProperty.call(message, "skipChangeEvent"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.skipChangeEvent);
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.preview);
                        if (message.itemList != null && Object.hasOwnProperty.call(message, "itemList"))
                            $root.palexy.streaming.v1.PosSectionMappingItemList.encode(message.itemList, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportSectionMappingItemRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportSectionMappingItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemRequest} message ImportSectionMappingItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportSectionMappingItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportSectionMappingItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemRequest} ImportSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportSectionMappingItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportSectionMappingItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sectionMappingId = reader.int64();
                                break;
                            case 2:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.accountId = reader.int64();
                                break;
                            case 4:
                                message.skipChangeEvent = reader.bool();
                                break;
                            case 5:
                                message.preview = reader.bool();
                                break;
                            case 6:
                                message.itemList = $root.palexy.streaming.v1.PosSectionMappingItemList.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportSectionMappingItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemRequest} ImportSectionMappingItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportSectionMappingItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportSectionMappingItemRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportSectionMappingItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (!$util.isInteger(message.sectionMappingId) && !(message.sectionMappingId && $util.isInteger(message.sectionMappingId.low) && $util.isInteger(message.sectionMappingId.high)))
                                return "sectionMappingId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            if (typeof message.skipChangeEvent !== "boolean")
                                return "skipChangeEvent: boolean expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.itemList != null && message.hasOwnProperty("itemList")) {
                            properties.sourceData = 1;
                            {
                                var error = $root.palexy.streaming.v1.PosSectionMappingItemList.verify(message.itemList);
                                if (error)
                                    return "itemList." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportSectionMappingItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemRequest} ImportSectionMappingItemRequest
                     */
                    ImportSectionMappingItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportSectionMappingItemRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportSectionMappingItemRequest();
                        if (object.sectionMappingId != null)
                            if ($util.Long)
                                (message.sectionMappingId = $util.Long.fromValue(object.sectionMappingId)).unsigned = false;
                            else if (typeof object.sectionMappingId === "string")
                                message.sectionMappingId = parseInt(object.sectionMappingId, 10);
                            else if (typeof object.sectionMappingId === "number")
                                message.sectionMappingId = object.sectionMappingId;
                            else if (typeof object.sectionMappingId === "object")
                                message.sectionMappingId = new $util.LongBits(object.sectionMappingId.low >>> 0, object.sectionMappingId.high >>> 0).toNumber();
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportSectionMappingItemRequest.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        if (object.skipChangeEvent != null)
                            message.skipChangeEvent = Boolean(object.skipChangeEvent);
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.itemList != null) {
                            if (typeof object.itemList !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportSectionMappingItemRequest.itemList: object expected");
                            message.itemList = $root.palexy.streaming.v1.PosSectionMappingItemList.fromObject(object.itemList);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportSectionMappingItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @static
                     * @param {palexy.streaming.v1.ImportSectionMappingItemRequest} message ImportSectionMappingItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportSectionMappingItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sectionMappingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sectionMappingId = options.longs === String ? "0" : 0;
                            object.storeId = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                            object.skipChangeEvent = false;
                            object.preview = false;
                        }
                        if (message.sectionMappingId != null && message.hasOwnProperty("sectionMappingId"))
                            if (typeof message.sectionMappingId === "number")
                                object.sectionMappingId = options.longs === String ? String(message.sectionMappingId) : message.sectionMappingId;
                            else
                                object.sectionMappingId = options.longs === String ? $util.Long.prototype.toString.call(message.sectionMappingId) : options.longs === Number ? new $util.LongBits(message.sectionMappingId.low >>> 0, message.sectionMappingId.high >>> 0).toNumber() : message.sectionMappingId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        if (message.skipChangeEvent != null && message.hasOwnProperty("skipChangeEvent"))
                            object.skipChangeEvent = message.skipChangeEvent;
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        if (message.itemList != null && message.hasOwnProperty("itemList")) {
                            object.itemList = $root.palexy.streaming.v1.PosSectionMappingItemList.toObject(message.itemList, options);
                            if (options.oneofs)
                                object.sourceData = "itemList";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ImportSectionMappingItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportSectionMappingItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportSectionMappingItemRequest;
                })();
    
                v1.PosSectionMappingItemList = (function() {
    
                    /**
                     * Properties of a PosSectionMappingItemList.
                     * @memberof palexy.streaming.v1
                     * @interface IPosSectionMappingItemList
                     * @property {Array.<palexy.streaming.v1.IPosSectionMappingItem>|null} [sectionMappingItems] PosSectionMappingItemList sectionMappingItems
                     */
    
                    /**
                     * Constructs a new PosSectionMappingItemList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PosSectionMappingItemList.
                     * @implements IPosSectionMappingItemList
                     * @constructor
                     * @param {palexy.streaming.v1.IPosSectionMappingItemList=} [properties] Properties to set
                     */
                    function PosSectionMappingItemList(properties) {
                        this.sectionMappingItems = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PosSectionMappingItemList sectionMappingItems.
                     * @member {Array.<palexy.streaming.v1.IPosSectionMappingItem>} sectionMappingItems
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @instance
                     */
                    PosSectionMappingItemList.prototype.sectionMappingItems = $util.emptyArray;
    
                    /**
                     * Creates a new PosSectionMappingItemList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItemList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PosSectionMappingItemList} PosSectionMappingItemList instance
                     */
                    PosSectionMappingItemList.create = function create(properties) {
                        return new PosSectionMappingItemList(properties);
                    };
    
                    /**
                     * Encodes the specified PosSectionMappingItemList message. Does not implicitly {@link palexy.streaming.v1.PosSectionMappingItemList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItemList} message PosSectionMappingItemList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMappingItemList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sectionMappingItems != null && message.sectionMappingItems.length)
                            for (var i = 0; i < message.sectionMappingItems.length; ++i)
                                $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.sectionMappingItems[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PosSectionMappingItemList message, length delimited. Does not implicitly {@link palexy.streaming.v1.PosSectionMappingItemList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {palexy.streaming.v1.IPosSectionMappingItemList} message PosSectionMappingItemList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PosSectionMappingItemList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PosSectionMappingItemList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PosSectionMappingItemList} PosSectionMappingItemList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMappingItemList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PosSectionMappingItemList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.sectionMappingItems && message.sectionMappingItems.length))
                                    message.sectionMappingItems = [];
                                message.sectionMappingItems.push($root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PosSectionMappingItemList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PosSectionMappingItemList} PosSectionMappingItemList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PosSectionMappingItemList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PosSectionMappingItemList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PosSectionMappingItemList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sectionMappingItems != null && message.hasOwnProperty("sectionMappingItems")) {
                            if (!Array.isArray(message.sectionMappingItems))
                                return "sectionMappingItems: array expected";
                            for (var i = 0; i < message.sectionMappingItems.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.sectionMappingItems[i]);
                                if (error)
                                    return "sectionMappingItems." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PosSectionMappingItemList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PosSectionMappingItemList} PosSectionMappingItemList
                     */
                    PosSectionMappingItemList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PosSectionMappingItemList)
                            return object;
                        var message = new $root.palexy.streaming.v1.PosSectionMappingItemList();
                        if (object.sectionMappingItems) {
                            if (!Array.isArray(object.sectionMappingItems))
                                throw TypeError(".palexy.streaming.v1.PosSectionMappingItemList.sectionMappingItems: array expected");
                            message.sectionMappingItems = [];
                            for (var i = 0; i < object.sectionMappingItems.length; ++i) {
                                if (typeof object.sectionMappingItems[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PosSectionMappingItemList.sectionMappingItems: object expected");
                                message.sectionMappingItems[i] = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.sectionMappingItems[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PosSectionMappingItemList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @static
                     * @param {palexy.streaming.v1.PosSectionMappingItemList} message PosSectionMappingItemList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PosSectionMappingItemList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sectionMappingItems = [];
                        if (message.sectionMappingItems && message.sectionMappingItems.length) {
                            object.sectionMappingItems = [];
                            for (var j = 0; j < message.sectionMappingItems.length; ++j)
                                object.sectionMappingItems[j] = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.sectionMappingItems[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PosSectionMappingItemList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PosSectionMappingItemList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PosSectionMappingItemList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PosSectionMappingItemList;
                })();
    
                v1.ImportSectionMappingItemResponse = (function() {
    
                    /**
                     * Properties of an ImportSectionMappingItemResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IImportSectionMappingItemResponse
                     * @property {palexy.streaming.v1.IImportResult|null} [importResult] ImportSectionMappingItemResponse importResult
                     * @property {Array.<palexy.streaming.v1.IPosSectionMappingItem>|null} [previewResult] ImportSectionMappingItemResponse previewResult
                     */
    
                    /**
                     * Constructs a new ImportSectionMappingItemResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportSectionMappingItemResponse.
                     * @implements IImportSectionMappingItemResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IImportSectionMappingItemResponse=} [properties] Properties to set
                     */
                    function ImportSectionMappingItemResponse(properties) {
                        this.previewResult = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportSectionMappingItemResponse importResult.
                     * @member {palexy.streaming.v1.IImportResult|null|undefined} importResult
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @instance
                     */
                    ImportSectionMappingItemResponse.prototype.importResult = null;
    
                    /**
                     * ImportSectionMappingItemResponse previewResult.
                     * @member {Array.<palexy.streaming.v1.IPosSectionMappingItem>} previewResult
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @instance
                     */
                    ImportSectionMappingItemResponse.prototype.previewResult = $util.emptyArray;
    
                    /**
                     * Creates a new ImportSectionMappingItemResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemResponse} ImportSectionMappingItemResponse instance
                     */
                    ImportSectionMappingItemResponse.create = function create(properties) {
                        return new ImportSectionMappingItemResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ImportSectionMappingItemResponse message. Does not implicitly {@link palexy.streaming.v1.ImportSectionMappingItemResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemResponse} message ImportSectionMappingItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportSectionMappingItemResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.importResult != null && Object.hasOwnProperty.call(message, "importResult"))
                            $root.palexy.streaming.v1.ImportResult.encode(message.importResult, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.previewResult != null && message.previewResult.length)
                            for (var i = 0; i < message.previewResult.length; ++i)
                                $root.palexy.streaming.v1.PosSectionMappingItem.encode(message.previewResult[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportSectionMappingItemResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportSectionMappingItemResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.IImportSectionMappingItemResponse} message ImportSectionMappingItemResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportSectionMappingItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportSectionMappingItemResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemResponse} ImportSectionMappingItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportSectionMappingItemResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportSectionMappingItemResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.importResult = $root.palexy.streaming.v1.ImportResult.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.previewResult && message.previewResult.length))
                                    message.previewResult = [];
                                message.previewResult.push($root.palexy.streaming.v1.PosSectionMappingItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportSectionMappingItemResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemResponse} ImportSectionMappingItemResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportSectionMappingItemResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportSectionMappingItemResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportSectionMappingItemResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.importResult != null && message.hasOwnProperty("importResult")) {
                            var error = $root.palexy.streaming.v1.ImportResult.verify(message.importResult);
                            if (error)
                                return "importResult." + error;
                        }
                        if (message.previewResult != null && message.hasOwnProperty("previewResult")) {
                            if (!Array.isArray(message.previewResult))
                                return "previewResult: array expected";
                            for (var i = 0; i < message.previewResult.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosSectionMappingItem.verify(message.previewResult[i]);
                                if (error)
                                    return "previewResult." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportSectionMappingItemResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportSectionMappingItemResponse} ImportSectionMappingItemResponse
                     */
                    ImportSectionMappingItemResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportSectionMappingItemResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportSectionMappingItemResponse();
                        if (object.importResult != null) {
                            if (typeof object.importResult !== "object")
                                throw TypeError(".palexy.streaming.v1.ImportSectionMappingItemResponse.importResult: object expected");
                            message.importResult = $root.palexy.streaming.v1.ImportResult.fromObject(object.importResult);
                        }
                        if (object.previewResult) {
                            if (!Array.isArray(object.previewResult))
                                throw TypeError(".palexy.streaming.v1.ImportSectionMappingItemResponse.previewResult: array expected");
                            message.previewResult = [];
                            for (var i = 0; i < object.previewResult.length; ++i) {
                                if (typeof object.previewResult[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportSectionMappingItemResponse.previewResult: object expected");
                                message.previewResult[i] = $root.palexy.streaming.v1.PosSectionMappingItem.fromObject(object.previewResult[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportSectionMappingItemResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @static
                     * @param {palexy.streaming.v1.ImportSectionMappingItemResponse} message ImportSectionMappingItemResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportSectionMappingItemResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.previewResult = [];
                        if (options.defaults)
                            object.importResult = null;
                        if (message.importResult != null && message.hasOwnProperty("importResult"))
                            object.importResult = $root.palexy.streaming.v1.ImportResult.toObject(message.importResult, options);
                        if (message.previewResult && message.previewResult.length) {
                            object.previewResult = [];
                            for (var j = 0; j < message.previewResult.length; ++j)
                                object.previewResult[j] = $root.palexy.streaming.v1.PosSectionMappingItem.toObject(message.previewResult[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ImportSectionMappingItemResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportSectionMappingItemResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportSectionMappingItemResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportSectionMappingItemResponse;
                })();
    
                v1.RawICAMetadataService = (function() {
    
                    /**
                     * Constructs a new RawICAMetadataService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICAMetadataService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function RawICAMetadataService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (RawICAMetadataService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RawICAMetadataService;
    
                    /**
                     * Creates new RawICAMetadataService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {RawICAMetadataService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    RawICAMetadataService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#listRawICAMetadata}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef ListRawICAMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListRawICAMetadataResponse} [response] ListRawICAMetadataResponse
                     */
    
                    /**
                     * Calls ListRawICAMetadata.
                     * @function listRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest} request ListRawICAMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.ListRawICAMetadataCallback} callback Node-style callback called with the error, if any, and ListRawICAMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.listRawICAMetadata = function listRawICAMetadata(request, callback) {
                        return this.rpcCall(listRawICAMetadata, $root.palexy.streaming.v1.ListRawICAMetadataRequest, $root.palexy.streaming.v1.ListRawICAMetadataResponse, request, callback);
                    }, "name", { value: "ListRawICAMetadata" });
    
                    /**
                     * Calls ListRawICAMetadata.
                     * @function listRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest} request ListRawICAMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListRawICAMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#createRawICAMetadata}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef CreateRawICAMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CreateRawICAMetadataResponse} [response] CreateRawICAMetadataResponse
                     */
    
                    /**
                     * Calls CreateRawICAMetadata.
                     * @function createRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest} request CreateRawICAMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.CreateRawICAMetadataCallback} callback Node-style callback called with the error, if any, and CreateRawICAMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.createRawICAMetadata = function createRawICAMetadata(request, callback) {
                        return this.rpcCall(createRawICAMetadata, $root.palexy.streaming.v1.CreateRawICAMetadataRequest, $root.palexy.streaming.v1.CreateRawICAMetadataResponse, request, callback);
                    }, "name", { value: "CreateRawICAMetadata" });
    
                    /**
                     * Calls CreateRawICAMetadata.
                     * @function createRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest} request CreateRawICAMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CreateRawICAMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#updateRawICAMetadata}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef UpdateRawICAMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RawICAMetadata} [response] RawICAMetadata
                     */
    
                    /**
                     * Calls UpdateRawICAMetadata.
                     * @function updateRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest} request UpdateRawICAMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.UpdateRawICAMetadataCallback} callback Node-style callback called with the error, if any, and RawICAMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.updateRawICAMetadata = function updateRawICAMetadata(request, callback) {
                        return this.rpcCall(updateRawICAMetadata, $root.palexy.streaming.v1.UpdateRawICAMetadataRequest, $root.palexy.streaming.v1.RawICAMetadata, request, callback);
                    }, "name", { value: "UpdateRawICAMetadata" });
    
                    /**
                     * Calls UpdateRawICAMetadata.
                     * @function updateRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest} request UpdateRawICAMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RawICAMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#getRawIcaMetadata}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef GetRawIcaMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RawICAMetadata} [response] RawICAMetadata
                     */
    
                    /**
                     * Calls GetRawIcaMetadata.
                     * @function getRawIcaMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest} request GetRawIcaMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.GetRawIcaMetadataCallback} callback Node-style callback called with the error, if any, and RawICAMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.getRawIcaMetadata = function getRawIcaMetadata(request, callback) {
                        return this.rpcCall(getRawIcaMetadata, $root.palexy.streaming.v1.GetRawIcaMetadataRequest, $root.palexy.streaming.v1.RawICAMetadata, request, callback);
                    }, "name", { value: "GetRawIcaMetadata" });
    
                    /**
                     * Calls GetRawIcaMetadata.
                     * @function getRawIcaMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest} request GetRawIcaMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RawICAMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#batchUpdateStatus}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef BatchUpdateStatusCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} [response] BatchUpdateRawICAMetadataStatusResponse
                     */
    
                    /**
                     * Calls BatchUpdateStatus.
                     * @function batchUpdateStatus
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest} request BatchUpdateRawICAMetadataStatusRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.BatchUpdateStatusCallback} callback Node-style callback called with the error, if any, and BatchUpdateRawICAMetadataStatusResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.batchUpdateStatus = function batchUpdateStatus(request, callback) {
                        return this.rpcCall(batchUpdateStatus, $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest, $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse, request, callback);
                    }, "name", { value: "BatchUpdateStatus" });
    
                    /**
                     * Calls BatchUpdateStatus.
                     * @function batchUpdateStatus
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest} request BatchUpdateRawICAMetadataStatusRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#aggregateData}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef AggregateDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AggregateRawICADataResponse} [response] AggregateRawICADataResponse
                     */
    
                    /**
                     * Calls AggregateData.
                     * @function aggregateData
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest} request AggregateRawICADataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.AggregateDataCallback} callback Node-style callback called with the error, if any, and AggregateRawICADataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.aggregateData = function aggregateData(request, callback) {
                        return this.rpcCall(aggregateData, $root.palexy.streaming.v1.AggregateRawICADataRequest, $root.palexy.streaming.v1.AggregateRawICADataResponse, request, callback);
                    }, "name", { value: "AggregateData" });
    
                    /**
                     * Calls AggregateData.
                     * @function aggregateData
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest} request AggregateRawICADataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AggregateRawICADataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAMetadataService#batchDeleteRawICAMetadata}.
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @typedef BatchDeleteRawICAMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} [response] BatchDeleteRawICAMetadataResponse
                     */
    
                    /**
                     * Calls BatchDeleteRawICAMetadata.
                     * @function batchDeleteRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest} request BatchDeleteRawICAMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAMetadataService.BatchDeleteRawICAMetadataCallback} callback Node-style callback called with the error, if any, and BatchDeleteRawICAMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAMetadataService.prototype.batchDeleteRawICAMetadata = function batchDeleteRawICAMetadata(request, callback) {
                        return this.rpcCall(batchDeleteRawICAMetadata, $root.palexy.streaming.v1.BatchDeleteRawICAMetadataRequest, $root.palexy.streaming.v1.BatchDeleteRawICAMetadataResponse, request, callback);
                    }, "name", { value: "BatchDeleteRawICAMetadata" });
    
                    /**
                     * Calls BatchDeleteRawICAMetadata.
                     * @function batchDeleteRawICAMetadata
                     * @memberof palexy.streaming.v1.RawICAMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest} request BatchDeleteRawICAMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchDeleteRawICAMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    return RawICAMetadataService;
                })();
    
                v1.RawICAMetadata = (function() {
    
                    /**
                     * Properties of a RawICAMetadata.
                     * @memberof palexy.streaming.v1
                     * @interface IRawICAMetadata
                     * @property {number|null} [id] RawICAMetadata id
                     * @property {number|null} [companyId] RawICAMetadata companyId
                     * @property {number|null} [storeId] RawICAMetadata storeId
                     * @property {number|null} [dateId] RawICAMetadata dateId
                     * @property {number|null} [recordCount] RawICAMetadata recordCount
                     * @property {palexy.streaming.v1.RawIcaStorageProvider|null} [cloudProvider] RawICAMetadata cloudProvider
                     * @property {string|null} [bucketName] RawICAMetadata bucketName
                     * @property {string|null} [fileName] RawICAMetadata fileName
                     * @property {palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus|null} [status] RawICAMetadata status
                     * @property {number|null} [createTimeMs] RawICAMetadata createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] RawICAMetadata lastUpdateTimeMs
                     * @property {boolean|null} [invalid] RawICAMetadata invalid
                     * @property {string|null} [invalidReason] RawICAMetadata invalidReason
                     * @property {string|null} [simulatedFileName] RawICAMetadata simulatedFileName
                     * @property {string|null} [simulatedDataDescription] RawICAMetadata simulatedDataDescription
                     * @property {number|null} [aggregatingRetryCount] RawICAMetadata aggregatingRetryCount
                     * @property {string|null} [aggregatedLevel_1FileName] RawICAMetadata aggregatedLevel_1FileName
                     * @property {string|null} [importedFileName] RawICAMetadata importedFileName
                     * @property {Array.<palexy.streaming.v1.MetricEnum>|null} [unsupportedMetrics] RawICAMetadata unsupportedMetrics
                     * @property {boolean|null} [externalTrafficHourlyMetricsEnabled] RawICAMetadata externalTrafficHourlyMetricsEnabled
                     * @property {palexy.streaming.v1.Store.CountingType|null} [countingType] RawICAMetadata countingType
                     */
    
                    /**
                     * Constructs a new RawICAMetadata.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICAMetadata.
                     * @implements IRawICAMetadata
                     * @constructor
                     * @param {palexy.streaming.v1.IRawICAMetadata=} [properties] Properties to set
                     */
                    function RawICAMetadata(properties) {
                        this.unsupportedMetrics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RawICAMetadata id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAMetadata companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAMetadata storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAMetadata dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.dateId = 0;
    
                    /**
                     * RawICAMetadata recordCount.
                     * @member {number} recordCount
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.recordCount = 0;
    
                    /**
                     * RawICAMetadata cloudProvider.
                     * @member {palexy.streaming.v1.RawIcaStorageProvider} cloudProvider
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.cloudProvider = 0;
    
                    /**
                     * RawICAMetadata bucketName.
                     * @member {string} bucketName
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.bucketName = "";
    
                    /**
                     * RawICAMetadata fileName.
                     * @member {string} fileName
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.fileName = "";
    
                    /**
                     * RawICAMetadata status.
                     * @member {palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus} status
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.status = 0;
    
                    /**
                     * RawICAMetadata createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAMetadata lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAMetadata invalid.
                     * @member {boolean} invalid
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.invalid = false;
    
                    /**
                     * RawICAMetadata invalidReason.
                     * @member {string} invalidReason
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.invalidReason = "";
    
                    /**
                     * RawICAMetadata simulatedFileName.
                     * @member {string} simulatedFileName
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.simulatedFileName = "";
    
                    /**
                     * RawICAMetadata simulatedDataDescription.
                     * @member {string} simulatedDataDescription
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.simulatedDataDescription = "";
    
                    /**
                     * RawICAMetadata aggregatingRetryCount.
                     * @member {number} aggregatingRetryCount
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.aggregatingRetryCount = 0;
    
                    /**
                     * RawICAMetadata aggregatedLevel_1FileName.
                     * @member {string} aggregatedLevel_1FileName
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.aggregatedLevel_1FileName = "";
    
                    /**
                     * RawICAMetadata importedFileName.
                     * @member {string} importedFileName
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.importedFileName = "";
    
                    /**
                     * RawICAMetadata unsupportedMetrics.
                     * @member {Array.<palexy.streaming.v1.MetricEnum>} unsupportedMetrics
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.unsupportedMetrics = $util.emptyArray;
    
                    /**
                     * RawICAMetadata externalTrafficHourlyMetricsEnabled.
                     * @member {boolean} externalTrafficHourlyMetricsEnabled
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.externalTrafficHourlyMetricsEnabled = false;
    
                    /**
                     * RawICAMetadata countingType.
                     * @member {palexy.streaming.v1.Store.CountingType} countingType
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     */
                    RawICAMetadata.prototype.countingType = 0;
    
                    /**
                     * Creates a new RawICAMetadata instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {palexy.streaming.v1.IRawICAMetadata=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RawICAMetadata} RawICAMetadata instance
                     */
                    RawICAMetadata.create = function create(properties) {
                        return new RawICAMetadata(properties);
                    };
    
                    /**
                     * Encodes the specified RawICAMetadata message. Does not implicitly {@link palexy.streaming.v1.RawICAMetadata.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {palexy.streaming.v1.IRawICAMetadata} message RawICAMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICAMetadata.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.recordCount != null && Object.hasOwnProperty.call(message, "recordCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.recordCount);
                        if (message.cloudProvider != null && Object.hasOwnProperty.call(message, "cloudProvider"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.cloudProvider);
                        if (message.bucketName != null && Object.hasOwnProperty.call(message, "bucketName"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.bucketName);
                        if (message.fileName != null && Object.hasOwnProperty.call(message, "fileName"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.fileName);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.status);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.lastUpdateTimeMs);
                        if (message.invalid != null && Object.hasOwnProperty.call(message, "invalid"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.invalid);
                        if (message.invalidReason != null && Object.hasOwnProperty.call(message, "invalidReason"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.invalidReason);
                        if (message.simulatedFileName != null && Object.hasOwnProperty.call(message, "simulatedFileName"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.simulatedFileName);
                        if (message.simulatedDataDescription != null && Object.hasOwnProperty.call(message, "simulatedDataDescription"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.simulatedDataDescription);
                        if (message.aggregatingRetryCount != null && Object.hasOwnProperty.call(message, "aggregatingRetryCount"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.aggregatingRetryCount);
                        if (message.aggregatedLevel_1FileName != null && Object.hasOwnProperty.call(message, "aggregatedLevel_1FileName"))
                            writer.uint32(/* id 17, wireType 2 =*/138).string(message.aggregatedLevel_1FileName);
                        if (message.importedFileName != null && Object.hasOwnProperty.call(message, "importedFileName"))
                            writer.uint32(/* id 18, wireType 2 =*/146).string(message.importedFileName);
                        if (message.unsupportedMetrics != null && message.unsupportedMetrics.length) {
                            writer.uint32(/* id 19, wireType 2 =*/154).fork();
                            for (var i = 0; i < message.unsupportedMetrics.length; ++i)
                                writer.int32(message.unsupportedMetrics[i]);
                            writer.ldelim();
                        }
                        if (message.externalTrafficHourlyMetricsEnabled != null && Object.hasOwnProperty.call(message, "externalTrafficHourlyMetricsEnabled"))
                            writer.uint32(/* id 21, wireType 0 =*/168).bool(message.externalTrafficHourlyMetricsEnabled);
                        if (message.countingType != null && Object.hasOwnProperty.call(message, "countingType"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.countingType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RawICAMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.RawICAMetadata.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {palexy.streaming.v1.IRawICAMetadata} message RawICAMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICAMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RawICAMetadata message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RawICAMetadata} RawICAMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICAMetadata.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RawICAMetadata();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.recordCount = reader.int32();
                                break;
                            case 6:
                                message.cloudProvider = reader.int32();
                                break;
                            case 7:
                                message.bucketName = reader.string();
                                break;
                            case 8:
                                message.fileName = reader.string();
                                break;
                            case 9:
                                message.status = reader.int32();
                                break;
                            case 10:
                                message.createTimeMs = reader.int64();
                                break;
                            case 11:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 12:
                                message.invalid = reader.bool();
                                break;
                            case 13:
                                message.invalidReason = reader.string();
                                break;
                            case 14:
                                message.simulatedFileName = reader.string();
                                break;
                            case 15:
                                message.simulatedDataDescription = reader.string();
                                break;
                            case 16:
                                message.aggregatingRetryCount = reader.int32();
                                break;
                            case 17:
                                message.aggregatedLevel_1FileName = reader.string();
                                break;
                            case 18:
                                message.importedFileName = reader.string();
                                break;
                            case 19:
                                if (!(message.unsupportedMetrics && message.unsupportedMetrics.length))
                                    message.unsupportedMetrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.unsupportedMetrics.push(reader.int32());
                                } else
                                    message.unsupportedMetrics.push(reader.int32());
                                break;
                            case 21:
                                message.externalTrafficHourlyMetricsEnabled = reader.bool();
                                break;
                            case 22:
                                message.countingType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RawICAMetadata message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RawICAMetadata} RawICAMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICAMetadata.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RawICAMetadata message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RawICAMetadata.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.recordCount != null && message.hasOwnProperty("recordCount"))
                            if (!$util.isInteger(message.recordCount))
                                return "recordCount: integer expected";
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            switch (message.cloudProvider) {
                            default:
                                return "cloudProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.bucketName != null && message.hasOwnProperty("bucketName"))
                            if (!$util.isString(message.bucketName))
                                return "bucketName: string expected";
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            if (!$util.isString(message.fileName))
                                return "fileName: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 10:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.invalid != null && message.hasOwnProperty("invalid"))
                            if (typeof message.invalid !== "boolean")
                                return "invalid: boolean expected";
                        if (message.invalidReason != null && message.hasOwnProperty("invalidReason"))
                            if (!$util.isString(message.invalidReason))
                                return "invalidReason: string expected";
                        if (message.simulatedFileName != null && message.hasOwnProperty("simulatedFileName"))
                            if (!$util.isString(message.simulatedFileName))
                                return "simulatedFileName: string expected";
                        if (message.simulatedDataDescription != null && message.hasOwnProperty("simulatedDataDescription"))
                            if (!$util.isString(message.simulatedDataDescription))
                                return "simulatedDataDescription: string expected";
                        if (message.aggregatingRetryCount != null && message.hasOwnProperty("aggregatingRetryCount"))
                            if (!$util.isInteger(message.aggregatingRetryCount))
                                return "aggregatingRetryCount: integer expected";
                        if (message.aggregatedLevel_1FileName != null && message.hasOwnProperty("aggregatedLevel_1FileName"))
                            if (!$util.isString(message.aggregatedLevel_1FileName))
                                return "aggregatedLevel_1FileName: string expected";
                        if (message.importedFileName != null && message.hasOwnProperty("importedFileName"))
                            if (!$util.isString(message.importedFileName))
                                return "importedFileName: string expected";
                        if (message.unsupportedMetrics != null && message.hasOwnProperty("unsupportedMetrics")) {
                            if (!Array.isArray(message.unsupportedMetrics))
                                return "unsupportedMetrics: array expected";
                            for (var i = 0; i < message.unsupportedMetrics.length; ++i)
                                switch (message.unsupportedMetrics[i]) {
                                default:
                                    return "unsupportedMetrics: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                case 110:
                                case 111:
                                case 112:
                                case 113:
                                case 114:
                                case 115:
                                case 116:
                                case 117:
                                case 118:
                                case 119:
                                case 120:
                                case 121:
                                case 122:
                                case 123:
                                case 124:
                                case 125:
                                case 126:
                                case 127:
                                case 128:
                                case 129:
                                case 130:
                                case 131:
                                case 132:
                                case 133:
                                case 134:
                                case 135:
                                case 136:
                                case 137:
                                case 138:
                                case 139:
                                case 140:
                                case 141:
                                case 142:
                                case 143:
                                case 144:
                                case 145:
                                case 146:
                                case 147:
                                case 148:
                                case 149:
                                case 150:
                                case 151:
                                case 152:
                                case 153:
                                case 154:
                                case 155:
                                case 156:
                                case 157:
                                case 158:
                                case 159:
                                case 160:
                                case 161:
                                case 162:
                                case 163:
                                case 164:
                                case 165:
                                case 166:
                                case 167:
                                case 168:
                                case 169:
                                case 170:
                                case 171:
                                case 172:
                                case 173:
                                case 174:
                                case 175:
                                case 176:
                                case 177:
                                case 178:
                                case 179:
                                case 180:
                                case 181:
                                case 182:
                                case 183:
                                case 184:
                                case 185:
                                case 186:
                                case 187:
                                case 188:
                                case 189:
                                case 190:
                                case 191:
                                case 192:
                                case 193:
                                case 194:
                                case 195:
                                case 196:
                                case 197:
                                case 198:
                                case 199:
                                case 200:
                                case 201:
                                case 202:
                                case 203:
                                case 204:
                                case 205:
                                case 206:
                                case 207:
                                case 208:
                                case 209:
                                case 210:
                                case 211:
                                case 212:
                                case 213:
                                case 214:
                                case 215:
                                case 216:
                                case 217:
                                case 218:
                                case 219:
                                case 220:
                                case 221:
                                case 222:
                                case 223:
                                case 224:
                                case 225:
                                case 226:
                                case 227:
                                case 228:
                                case 229:
                                case 230:
                                case 231:
                                case 232:
                                case 233:
                                case 234:
                                case 235:
                                case 236:
                                case 237:
                                case 238:
                                case 239:
                                case 240:
                                    break;
                                }
                        }
                        if (message.externalTrafficHourlyMetricsEnabled != null && message.hasOwnProperty("externalTrafficHourlyMetricsEnabled"))
                            if (typeof message.externalTrafficHourlyMetricsEnabled !== "boolean")
                                return "externalTrafficHourlyMetricsEnabled: boolean expected";
                        if (message.countingType != null && message.hasOwnProperty("countingType"))
                            switch (message.countingType) {
                            default:
                                return "countingType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a RawICAMetadata message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RawICAMetadata} RawICAMetadata
                     */
                    RawICAMetadata.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RawICAMetadata)
                            return object;
                        var message = new $root.palexy.streaming.v1.RawICAMetadata();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.recordCount != null)
                            message.recordCount = object.recordCount | 0;
                        switch (object.cloudProvider) {
                        case "RAW_PROVIDER_UNKNOWN":
                        case 0:
                            message.cloudProvider = 0;
                            break;
                        case "DATABASE":
                        case 1:
                            message.cloudProvider = 1;
                            break;
                        case "GCP":
                        case 2:
                            message.cloudProvider = 2;
                            break;
                        }
                        if (object.bucketName != null)
                            message.bucketName = String(object.bucketName);
                        if (object.fileName != null)
                            message.fileName = String(object.fileName);
                        switch (object.status) {
                        case "RAW_STATUS_UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "RAW_READY":
                        case 1:
                            message.status = 1;
                            break;
                        case "AGGREGATING":
                        case 2:
                            message.status = 2;
                            break;
                        case "DONE_AGGREGATING":
                        case 3:
                            message.status = 3;
                            break;
                        case "EXTERNAL_TRAFFIC_READY":
                        case 4:
                            message.status = 4;
                            break;
                        case "DELETED":
                        case 10:
                            message.status = 10;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.invalid != null)
                            message.invalid = Boolean(object.invalid);
                        if (object.invalidReason != null)
                            message.invalidReason = String(object.invalidReason);
                        if (object.simulatedFileName != null)
                            message.simulatedFileName = String(object.simulatedFileName);
                        if (object.simulatedDataDescription != null)
                            message.simulatedDataDescription = String(object.simulatedDataDescription);
                        if (object.aggregatingRetryCount != null)
                            message.aggregatingRetryCount = object.aggregatingRetryCount | 0;
                        if (object.aggregatedLevel_1FileName != null)
                            message.aggregatedLevel_1FileName = String(object.aggregatedLevel_1FileName);
                        if (object.importedFileName != null)
                            message.importedFileName = String(object.importedFileName);
                        if (object.unsupportedMetrics) {
                            if (!Array.isArray(object.unsupportedMetrics))
                                throw TypeError(".palexy.streaming.v1.RawICAMetadata.unsupportedMetrics: array expected");
                            message.unsupportedMetrics = [];
                            for (var i = 0; i < object.unsupportedMetrics.length; ++i)
                                switch (object.unsupportedMetrics[i]) {
                                default:
                                case "METRIC_UNKNOWN":
                                case 0:
                                    message.unsupportedMetrics[i] = 0;
                                    break;
                                case "METRIC_BUYER_TRAFFIC":
                                case 1:
                                    message.unsupportedMetrics[i] = 1;
                                    break;
                                case "METRIC_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 2:
                                    message.unsupportedMetrics[i] = 2;
                                    break;
                                case "METRIC_INTERACTION":
                                case 3:
                                    message.unsupportedMetrics[i] = 3;
                                    break;
                                case "METRIC_VISIT":
                                case 4:
                                    message.unsupportedMetrics[i] = 4;
                                    break;
                                case "METRIC_GROUP_VISIT":
                                case 5:
                                    message.unsupportedMetrics[i] = 5;
                                    break;
                                case "METRIC_GROUP_INTERACTION":
                                case 6:
                                    message.unsupportedMetrics[i] = 6;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC":
                                case 7:
                                    message.unsupportedMetrics[i] = 7;
                                    break;
                                case "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION":
                                case 8:
                                    message.unsupportedMetrics[i] = 8;
                                    break;
                                case "METRIC_BUYER_RATE":
                                case 9:
                                    message.unsupportedMetrics[i] = 9;
                                    break;
                                case "METRIC_INTERACTION_RATE":
                                case 10:
                                    message.unsupportedMetrics[i] = 10;
                                    break;
                                case "METRIC_INTERACTION_TIME":
                                case 11:
                                    message.unsupportedMetrics[i] = 11;
                                    break;
                                case "METRIC_INTERACTION_TIME_AVG":
                                case 12:
                                    message.unsupportedMetrics[i] = 12;
                                    break;
                                case "METRIC_INTERACTION_LEVEL":
                                case 13:
                                    message.unsupportedMetrics[i] = 13;
                                    break;
                                case "METRIC_INTERACTION_BUYER_RATE":
                                case 14:
                                    message.unsupportedMetrics[i] = 14;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_INTERACTION":
                                case 15:
                                    message.unsupportedMetrics[i] = 15;
                                    break;
                                case "METRIC_ON_TIME_INTERACTION_RATE":
                                case 16:
                                    message.unsupportedMetrics[i] = 16;
                                    break;
                                case "METRIC_GROUP_BUYER_RATE":
                                case 17:
                                    message.unsupportedMetrics[i] = 17;
                                    break;
                                case "METRIC_GROUP_INTERACTION_RATE":
                                case 18:
                                    message.unsupportedMetrics[i] = 18;
                                    break;
                                case "METRIC_GROUP_INTERACTION_BUYER_RATE":
                                case 19:
                                    message.unsupportedMetrics[i] = 19;
                                    break;
                                case "METRIC_LYING":
                                case 20:
                                    message.unsupportedMetrics[i] = 20;
                                    break;
                                case "METRIC_LYING_RATE":
                                case 21:
                                    message.unsupportedMetrics[i] = 21;
                                    break;
                                case "METRIC_LYING_TIME_AVG":
                                case 22:
                                    message.unsupportedMetrics[i] = 22;
                                    break;
                                case "METRIC_LYING_EXACT_ONE":
                                case 23:
                                    message.unsupportedMetrics[i] = 23;
                                    break;
                                case "METRIC_LYING_AT_LEAST_ONE":
                                case 24:
                                    message.unsupportedMetrics[i] = 24;
                                    break;
                                case "METRIC_LYING_AT_LEAST_TWO":
                                case 25:
                                    message.unsupportedMetrics[i] = 25;
                                    break;
                                case "METRIC_DWELL_TIME":
                                case 26:
                                    message.unsupportedMetrics[i] = 26;
                                    break;
                                case "METRIC_DWELL_TIME_AVG":
                                case 27:
                                    message.unsupportedMetrics[i] = 27;
                                    break;
                                case "METRIC_TOTAL_GREETED_CUSTOMERS":
                                case 28:
                                    message.unsupportedMetrics[i] = 28;
                                    break;
                                case "METRIC_GREETING_RATE":
                                case 29:
                                    message.unsupportedMetrics[i] = 29;
                                    break;
                                case "METRIC_AVG_TIME_TO_FIRST_GREETING":
                                case 30:
                                    message.unsupportedMetrics[i] = 30;
                                    break;
                                case "METRIC_ON_TIME_GREETING_RATE":
                                case 31:
                                    message.unsupportedMetrics[i] = 31;
                                    break;
                                case "METRIC_FOOT_TRAFFIC":
                                case 32:
                                    message.unsupportedMetrics[i] = 32;
                                    break;
                                case "METRIC_VISITOR_OCCUPANCY":
                                case 33:
                                    message.unsupportedMetrics[i] = 33;
                                    break;
                                case "METRIC_TOTAL_GROUPS":
                                case 34:
                                    message.unsupportedMetrics[i] = 34;
                                    break;
                                case "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS":
                                case 35:
                                    message.unsupportedMetrics[i] = 35;
                                    break;
                                case "METRIC_GROUP_RATE":
                                case 36:
                                    message.unsupportedMetrics[i] = 36;
                                    break;
                                case "METRIC_AVG_GROUP_SIZE":
                                case 37:
                                    message.unsupportedMetrics[i] = 37;
                                    break;
                                case "METRIC_TOTAL_GROUPS_WITH_KIDS":
                                case 38:
                                    message.unsupportedMetrics[i] = 38;
                                    break;
                                case "METRIC_TOTAL_KNOWN_GROUPS":
                                case 39:
                                    message.unsupportedMetrics[i] = 39;
                                    break;
                                case "METRIC_GROUPS_WITH_KIDS_RATE":
                                case 40:
                                    message.unsupportedMetrics[i] = 40;
                                    break;
                                case "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS":
                                case 41:
                                    message.unsupportedMetrics[i] = 41;
                                    break;
                                case "METRIC_CONVERSION_BY_OPPORTUNITIES":
                                case 42:
                                    message.unsupportedMetrics[i] = 42;
                                    break;
                                case "METRIC_PERCENT_SECTION_VISIT":
                                case 43:
                                    message.unsupportedMetrics[i] = 43;
                                    break;
                                case "METRIC_PERCENT_SECTION_PASS_BY":
                                case 44:
                                    message.unsupportedMetrics[i] = 44;
                                    break;
                                case "METRIC_PASS_BY":
                                case 45:
                                    message.unsupportedMetrics[i] = 45;
                                    break;
                                case "METRIC_CAPTURE_RATE":
                                case 46:
                                    message.unsupportedMetrics[i] = 46;
                                    break;
                                case "METRIC_TRANSACTION":
                                case 47:
                                    message.unsupportedMetrics[i] = 47;
                                    break;
                                case "METRIC_CONVERSION_RATE":
                                case 48:
                                    message.unsupportedMetrics[i] = 48;
                                    break;
                                case "METRIC_NET_SALES_AMOUNT":
                                case 49:
                                    message.unsupportedMetrics[i] = 49;
                                    break;
                                case "METRIC_NET_SALES_ITEMS":
                                case 50:
                                    message.unsupportedMetrics[i] = 50;
                                    break;
                                case "METRIC_NET_SALES_CONTRIBUTION":
                                case 51:
                                    message.unsupportedMetrics[i] = 51;
                                    break;
                                case "METRIC_NET_SALES_RANKING":
                                case 52:
                                    message.unsupportedMetrics[i] = 52;
                                    break;
                                case "METRIC_SHOPPER_YIELD":
                                case 53:
                                    message.unsupportedMetrics[i] = 53;
                                    break;
                                case "METRIC_ATV":
                                case 54:
                                    message.unsupportedMetrics[i] = 54;
                                    break;
                                case "METRIC_UPT":
                                case 55:
                                    message.unsupportedMetrics[i] = 55;
                                    break;
                                case "METRIC_UPDPS":
                                case 56:
                                    message.unsupportedMetrics[i] = 56;
                                    break;
                                case "METRIC_ASP":
                                case 57:
                                    message.unsupportedMetrics[i] = 57;
                                    break;
                                case "METRIC_STAFF_HOURS":
                                case 58:
                                    message.unsupportedMetrics[i] = 58;
                                    break;
                                case "METRIC_VISITOR_PER_STAFF_HOUR":
                                case 59:
                                    message.unsupportedMetrics[i] = 59;
                                    break;
                                case "METRIC_SALES_PER_STAFF_HOUR":
                                case 60:
                                    message.unsupportedMetrics[i] = 60;
                                    break;
                                case "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 61:
                                    message.unsupportedMetrics[i] = 61;
                                    break;
                                case "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 62:
                                    message.unsupportedMetrics[i] = 62;
                                    break;
                                case "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR":
                                case 63:
                                    message.unsupportedMetrics[i] = 63;
                                    break;
                                case "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR":
                                case 64:
                                    message.unsupportedMetrics[i] = 64;
                                    break;
                                case "METRIC_ROUNDED_STAFF_HOURS":
                                case 65:
                                    message.unsupportedMetrics[i] = 65;
                                    break;
                                case "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT":
                                case 66:
                                    message.unsupportedMetrics[i] = 66;
                                    break;
                                case "METRIC_VISITORS_PER_SQM":
                                case 67:
                                    message.unsupportedMetrics[i] = 67;
                                    break;
                                case "METRIC_AVG_VISITOR_PER_STORE_PER_DAY":
                                case 68:
                                    message.unsupportedMetrics[i] = 68;
                                    break;
                                case "METRIC_DAYS_WITH_VISITORS":
                                case 69:
                                    message.unsupportedMetrics[i] = 69;
                                    break;
                                case "METRIC_DAYS_WITH_NET_SALES_ITEMS":
                                case 70:
                                    message.unsupportedMetrics[i] = 70;
                                    break;
                                case "METRIC_SALES_PER_SQM":
                                case 71:
                                    message.unsupportedMetrics[i] = 71;
                                    break;
                                case "METRIC_SALES_PER_SALES_AREA_SQM":
                                case 72:
                                    message.unsupportedMetrics[i] = 72;
                                    break;
                                case "METRIC_ESTIMATED_VISIT":
                                case 73:
                                    message.unsupportedMetrics[i] = 73;
                                    break;
                                case "METRIC_ESTIMATED_PASS_BY":
                                case 74:
                                    message.unsupportedMetrics[i] = 74;
                                    break;
                                case "METRIC_WALK_IN":
                                case 75:
                                    message.unsupportedMetrics[i] = 75;
                                    break;
                                case "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY":
                                case 76:
                                    message.unsupportedMetrics[i] = 76;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1":
                                case 77:
                                    message.unsupportedMetrics[i] = 77;
                                    break;
                                case "METRIC_CUSTOM_ACTION_1_RATE":
                                case 78:
                                    message.unsupportedMetrics[i] = 78;
                                    break;
                                case "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE":
                                case 79:
                                    message.unsupportedMetrics[i] = 79;
                                    break;
                                case "METRIC_AVG_SALES_PER_STORE_PER_DAY":
                                case 80:
                                    message.unsupportedMetrics[i] = 80;
                                    break;
                                case "METRIC_STAFF_TOTAL_SERVED_VISITORS":
                                case 81:
                                    message.unsupportedMetrics[i] = 81;
                                    break;
                                case "METRIC_STAFF_CONVERSION_RATE":
                                case 82:
                                    message.unsupportedMetrics[i] = 82;
                                    break;
                                case "METRIC_STAFF_SALES_PER_SERVED_VISITORS":
                                case 83:
                                    message.unsupportedMetrics[i] = 83;
                                    break;
                                case "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR":
                                case 84:
                                    message.unsupportedMetrics[i] = 84;
                                    break;
                                case "METRIC_STAFF_PERCENTAGE_OF_SALES":
                                case 85:
                                    message.unsupportedMetrics[i] = 85;
                                    break;
                                case "METRIC_DAYS_WITH_SALES":
                                case 86:
                                    message.unsupportedMetrics[i] = 86;
                                    break;
                                case "METRIC_VIDEO_GROUP_DISTRIBUTION":
                                case 87:
                                    message.unsupportedMetrics[i] = 87;
                                    break;
                                case "METRIC_BOUNCE_RATE":
                                case 88:
                                    message.unsupportedMetrics[i] = 88;
                                    break;
                                case "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY":
                                case 89:
                                    message.unsupportedMetrics[i] = 89;
                                    break;
                                case "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS":
                                case 90:
                                    message.unsupportedMetrics[i] = 90;
                                    break;
                                case "METRIC_STAFF_STORE_NET_SALES_AMOUNT":
                                case 91:
                                    message.unsupportedMetrics[i] = 91;
                                    break;
                                case "METRIC_STAFF_UNIQUE_INTERACTIONS":
                                case 92:
                                    message.unsupportedMetrics[i] = 92;
                                    break;
                                case "METRIC_STAFF_INTERACTION_RATE":
                                case 93:
                                    message.unsupportedMetrics[i] = 93;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_VISITORS":
                                case 94:
                                    message.unsupportedMetrics[i] = 94;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS":
                                case 95:
                                    message.unsupportedMetrics[i] = 95;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS":
                                case 96:
                                    message.unsupportedMetrics[i] = 96;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME":
                                case 97:
                                    message.unsupportedMetrics[i] = 97;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME":
                                case 98:
                                    message.unsupportedMetrics[i] = 98;
                                    break;
                                case "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES":
                                case 99:
                                    message.unsupportedMetrics[i] = 99;
                                    break;
                                case "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 100:
                                    message.unsupportedMetrics[i] = 100;
                                    break;
                                case "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES":
                                case 101:
                                    message.unsupportedMetrics[i] = 101;
                                    break;
                                case "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 102:
                                    message.unsupportedMetrics[i] = 102;
                                    break;
                                case "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES":
                                case 103:
                                    message.unsupportedMetrics[i] = 103;
                                    break;
                                case "METRIC_DISCOUNT_AMOUNT":
                                case 104:
                                    message.unsupportedMetrics[i] = 104;
                                    break;
                                case "METRIC_DISCOUNT_RATE":
                                case 105:
                                    message.unsupportedMetrics[i] = 105;
                                    break;
                                case "METRIC_GROSS_AMOUNT":
                                case 106:
                                    message.unsupportedMetrics[i] = 106;
                                    break;
                                case "METRIC_SALES_PER_SQM_PER_DAY":
                                case 107:
                                    message.unsupportedMetrics[i] = 107;
                                    break;
                                case "METRIC_AVG_VISITORS_PER_SQM_PER_DAY":
                                case 108:
                                    message.unsupportedMetrics[i] = 108;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET":
                                case 109:
                                    message.unsupportedMetrics[i] = 109;
                                    break;
                                case "METRIC_STAFF_SALES_TARGET_COMPLETION":
                                case 110:
                                    message.unsupportedMetrics[i] = 110;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE":
                                case 111:
                                    message.unsupportedMetrics[i] = 111;
                                    break;
                                case "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE":
                                case 112:
                                    message.unsupportedMetrics[i] = 112;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_VISITORS":
                                case 113:
                                    message.unsupportedMetrics[i] = 113;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS":
                                case 114:
                                    message.unsupportedMetrics[i] = 114;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_TIME":
                                case 115:
                                    message.unsupportedMetrics[i] = 115;
                                    break;
                                case "METRIC_AVERAGE_QUEUE_LENGTH":
                                case 116:
                                    message.unsupportedMetrics[i] = 116;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS":
                                case 117:
                                    message.unsupportedMetrics[i] = 117;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTION_TIME":
                                case 118:
                                    message.unsupportedMetrics[i] = 118;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS":
                                case 119:
                                    message.unsupportedMetrics[i] = 119;
                                    break;
                                case "METRIC_AVERAGE_ORDER_PREPARATION_TIME":
                                case 120:
                                    message.unsupportedMetrics[i] = 120;
                                    break;
                                case "METRIC_AVERAGE_TOTAL_SERVICE_TIME":
                                case 121:
                                    message.unsupportedMetrics[i] = 121;
                                    break;
                                case "METRIC_VISIT_TARGET":
                                case 122:
                                    message.unsupportedMetrics[i] = 122;
                                    break;
                                case "METRIC_VISIT_ACHIEVED":
                                case 123:
                                    message.unsupportedMetrics[i] = 123;
                                    break;
                                case "METRIC_TRANSACTION_TARGET":
                                case 124:
                                    message.unsupportedMetrics[i] = 124;
                                    break;
                                case "METRIC_TRANSACTION_ACHIEVED":
                                case 125:
                                    message.unsupportedMetrics[i] = 125;
                                    break;
                                case "METRIC_NET_SALES_TARGET_COMPLETION":
                                case 126:
                                    message.unsupportedMetrics[i] = 126;
                                    break;
                                case "METRIC_NET_SALES_TARGET_ACHIEVED":
                                case 127:
                                    message.unsupportedMetrics[i] = 127;
                                    break;
                                case "METRIC_NET_SALES_TARGET":
                                case 128:
                                    message.unsupportedMetrics[i] = 128;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET":
                                case 129:
                                    message.unsupportedMetrics[i] = 129;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_ACHIEVED":
                                case 130:
                                    message.unsupportedMetrics[i] = 130;
                                    break;
                                case "METRIC_CONVERSION_RATE_TARGET_COMPLETION":
                                case 131:
                                    message.unsupportedMetrics[i] = 131;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE":
                                case 132:
                                    message.unsupportedMetrics[i] = 132;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE":
                                case 133:
                                    message.unsupportedMetrics[i] = 133;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE":
                                case 134:
                                    message.unsupportedMetrics[i] = 134;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE":
                                case 135:
                                    message.unsupportedMetrics[i] = 135;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE":
                                case 136:
                                    message.unsupportedMetrics[i] = 136;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE":
                                case 137:
                                    message.unsupportedMetrics[i] = 137;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE":
                                case 138:
                                    message.unsupportedMetrics[i] = 138;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE":
                                case 139:
                                    message.unsupportedMetrics[i] = 139;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET":
                                case 140:
                                    message.unsupportedMetrics[i] = 140;
                                    break;
                                case "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED":
                                case 141:
                                    message.unsupportedMetrics[i] = 141;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_TARGET":
                                case 142:
                                    message.unsupportedMetrics[i] = 142;
                                    break;
                                case "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED":
                                case 143:
                                    message.unsupportedMetrics[i] = 143;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET":
                                case 144:
                                    message.unsupportedMetrics[i] = 144;
                                    break;
                                case "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED":
                                case 145:
                                    message.unsupportedMetrics[i] = 145;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED":
                                case 146:
                                    message.unsupportedMetrics[i] = 146;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET":
                                case 147:
                                    message.unsupportedMetrics[i] = 147;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 148:
                                    message.unsupportedMetrics[i] = 148;
                                    break;
                                case "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 149:
                                    message.unsupportedMetrics[i] = 149;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED":
                                case 150:
                                    message.unsupportedMetrics[i] = 150;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET":
                                case 151:
                                    message.unsupportedMetrics[i] = 151;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 152:
                                    message.unsupportedMetrics[i] = 152;
                                    break;
                                case "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 153:
                                    message.unsupportedMetrics[i] = 153;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED":
                                case 154:
                                    message.unsupportedMetrics[i] = 154;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET":
                                case 155:
                                    message.unsupportedMetrics[i] = 155;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 156:
                                    message.unsupportedMetrics[i] = 156;
                                    break;
                                case "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 157:
                                    message.unsupportedMetrics[i] = 157;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED":
                                case 158:
                                    message.unsupportedMetrics[i] = 158;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET":
                                case 159:
                                    message.unsupportedMetrics[i] = 159;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED":
                                case 160:
                                    message.unsupportedMetrics[i] = 160;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION":
                                case 161:
                                    message.unsupportedMetrics[i] = 161;
                                    break;
                                case "METRIC_PICKUP_SAMPLE_RATE":
                                case 162:
                                    message.unsupportedMetrics[i] = 162;
                                    break;
                                case "METRIC_SERVICE_SCORE":
                                case 163:
                                    message.unsupportedMetrics[i] = 163;
                                    break;
                                case "METRIC_AVERAGE_STAFF_PER_HOUR":
                                case 164:
                                    message.unsupportedMetrics[i] = 164;
                                    break;
                                case "METRIC_ADJUSTED_VISIT":
                                case 165:
                                    message.unsupportedMetrics[i] = 165;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_AMOUNT":
                                case 166:
                                    message.unsupportedMetrics[i] = 166;
                                    break;
                                case "METRIC_ADJUSTED_NET_SALES_ITEMS":
                                case 167:
                                    message.unsupportedMetrics[i] = 167;
                                    break;
                                case "METRIC_ADJUSTED_TRANSACTION":
                                case 168:
                                    message.unsupportedMetrics[i] = 168;
                                    break;
                                case "METRIC_ADJUSTED_CONVERSION_RATE":
                                case 169:
                                    message.unsupportedMetrics[i] = 169;
                                    break;
                                case "METRIC_ADJUSTED_ATV":
                                case 170:
                                    message.unsupportedMetrics[i] = 170;
                                    break;
                                case "METRIC_ADJUSTED_UPT":
                                case 171:
                                    message.unsupportedMetrics[i] = 171;
                                    break;
                                case "METRIC_TOTAL_SERVICE_TIME":
                                case 172:
                                    message.unsupportedMetrics[i] = 172;
                                    break;
                                case "METRIC_TOTAL_SATISFIED_PREFERENCES":
                                case 173:
                                    message.unsupportedMetrics[i] = 173;
                                    break;
                                case "METRIC_PREFERENCE_SATISFACTION_RATE":
                                case 174:
                                    message.unsupportedMetrics[i] = 174;
                                    break;
                                case "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS":
                                case 175:
                                    message.unsupportedMetrics[i] = 175;
                                    break;
                                case "METRIC_TOTAL_AUTO_GENERATED_SHIFTS":
                                case 176:
                                    message.unsupportedMetrics[i] = 176;
                                    break;
                                case "METRIC_TOTAL_ADJUSTED_SHIFTS":
                                case 177:
                                    message.unsupportedMetrics[i] = 177;
                                    break;
                                case "METRIC_HUMAN_GENERATED_SHIFTS_RATE":
                                case 178:
                                    message.unsupportedMetrics[i] = 178;
                                    break;
                                case "METRIC_AUTO_GENERATED_SHIFTS_RATE":
                                case 179:
                                    message.unsupportedMetrics[i] = 179;
                                    break;
                                case "METRIC_ADJUSTED_SHIFTS_RATE":
                                case 180:
                                    message.unsupportedMetrics[i] = 180;
                                    break;
                                case "METRIC_TOTAL_HOURS_WITH_WORKLOAD":
                                case 181:
                                    message.unsupportedMetrics[i] = 181;
                                    break;
                                case "METRIC_TOTAL_COVERED_HOURS":
                                case 182:
                                    message.unsupportedMetrics[i] = 182;
                                    break;
                                case "METRIC_TOTAL_UNDERSTAFFED_HOURS":
                                case 183:
                                    message.unsupportedMetrics[i] = 183;
                                    break;
                                case "METRIC_DEMAND_COVERAGE_RATE":
                                case 184:
                                    message.unsupportedMetrics[i] = 184;
                                    break;
                                case "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT":
                                case 185:
                                    message.unsupportedMetrics[i] = 185;
                                    break;
                                case "METRIC_SCHEDULE_COMPLIANCE_RATE":
                                case 186:
                                    message.unsupportedMetrics[i] = 186;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST_RATE":
                                case 187:
                                    message.unsupportedMetrics[i] = 187;
                                    break;
                                case "METRIC_SCHEDULE_LABOR_COST":
                                case 188:
                                    message.unsupportedMetrics[i] = 188;
                                    break;
                                case "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE":
                                case 189:
                                    message.unsupportedMetrics[i] = 189;
                                    break;
                                case "METRIC_MIX_SCHEDULE_LABOR_COST_RATE":
                                case 190:
                                    message.unsupportedMetrics[i] = 190;
                                    break;
                                case "METRIC_GROSS_SCHEDULED_STAFF_HOUR":
                                case 191:
                                    message.unsupportedMetrics[i] = 191;
                                    break;
                                case "METRIC_SCHEDULED_STAFF_HOUR":
                                case 192:
                                    message.unsupportedMetrics[i] = 192;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS":
                                case 193:
                                    message.unsupportedMetrics[i] = 193;
                                    break;
                                case "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 194:
                                    message.unsupportedMetrics[i] = 194;
                                    break;
                                case "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 195:
                                    message.unsupportedMetrics[i] = 195;
                                    break;
                                case "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 196:
                                    message.unsupportedMetrics[i] = 196;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 197:
                                    message.unsupportedMetrics[i] = 197;
                                    break;
                                case "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 198:
                                    message.unsupportedMetrics[i] = 198;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 199:
                                    message.unsupportedMetrics[i] = 199;
                                    break;
                                case "METRIC_NET_SALES_ITEMS_CONTRIBUTION":
                                case 200:
                                    message.unsupportedMetrics[i] = 200;
                                    break;
                                case "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR":
                                case 201:
                                    message.unsupportedMetrics[i] = 201;
                                    break;
                                case "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR":
                                case 202:
                                    message.unsupportedMetrics[i] = 202;
                                    break;
                                case "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR":
                                case 203:
                                    message.unsupportedMetrics[i] = 203;
                                    break;
                                case "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR":
                                case 204:
                                    message.unsupportedMetrics[i] = 204;
                                    break;
                                case "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR":
                                case 205:
                                    message.unsupportedMetrics[i] = 205;
                                    break;
                                case "METRIC_SERVICE_COVERAGE_RATE":
                                case 206:
                                    message.unsupportedMetrics[i] = 206;
                                    break;
                                case "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE":
                                case 207:
                                    message.unsupportedMetrics[i] = 207;
                                    break;
                                case "METRIC_CHECKOUT_VISITORS_BY_BUCKET":
                                case 208:
                                    message.unsupportedMetrics[i] = 208;
                                    break;
                                case "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS":
                                case 209:
                                    message.unsupportedMetrics[i] = 209;
                                    break;
                                case "METRIC_SCHEDULE_OVER_BUDGET_RATE":
                                case 210:
                                    message.unsupportedMetrics[i] = 210;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS":
                                case 211:
                                    message.unsupportedMetrics[i] = 211;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS":
                                case 212:
                                    message.unsupportedMetrics[i] = 212;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_HOURS":
                                case 213:
                                    message.unsupportedMetrics[i] = 213;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS":
                                case 214:
                                    message.unsupportedMetrics[i] = 214;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_RECORDS":
                                case 215:
                                    message.unsupportedMetrics[i] = 215;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS":
                                case 216:
                                    message.unsupportedMetrics[i] = 216;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS":
                                case 217:
                                    message.unsupportedMetrics[i] = 217;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS":
                                case 218:
                                    message.unsupportedMetrics[i] = 218;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS":
                                case 219:
                                    message.unsupportedMetrics[i] = 219;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN":
                                case 220:
                                    message.unsupportedMetrics[i] = 220;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT":
                                case 221:
                                    message.unsupportedMetrics[i] = 221;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_ABSENTEE":
                                case 222:
                                    message.unsupportedMetrics[i] = 222;
                                    break;
                                case "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE":
                                case 223:
                                    message.unsupportedMetrics[i] = 223;
                                    break;
                                case "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE":
                                case 224:
                                    message.unsupportedMetrics[i] = 224;
                                    break;
                                case "METRIC_ATTENDANCE_ABSENT_RATE":
                                case 225:
                                    message.unsupportedMetrics[i] = 225;
                                    break;
                                case "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE":
                                case 226:
                                    message.unsupportedMetrics[i] = 226;
                                    break;
                                case "METRIC_ATTENDANCE_REVIEWING_PROGRESS":
                                case 227:
                                    message.unsupportedMetrics[i] = 227;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_VARIANCE":
                                case 228:
                                    message.unsupportedMetrics[i] = 228;
                                    break;
                                case "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE":
                                case 229:
                                    message.unsupportedMetrics[i] = 229;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR":
                                case 230:
                                    message.unsupportedMetrics[i] = 230;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 231:
                                    message.unsupportedMetrics[i] = 231;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR":
                                case 232:
                                    message.unsupportedMetrics[i] = 232;
                                    break;
                                case "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR":
                                case 233:
                                    message.unsupportedMetrics[i] = 233;
                                    break;
                                case "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 234:
                                    message.unsupportedMetrics[i] = 234;
                                    break;
                                case "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR":
                                case 235:
                                    message.unsupportedMetrics[i] = 235;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS":
                                case 236:
                                    message.unsupportedMetrics[i] = 236;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS":
                                case 237:
                                    message.unsupportedMetrics[i] = 237;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS":
                                case 238:
                                    message.unsupportedMetrics[i] = 238;
                                    break;
                                case "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS":
                                case 239:
                                    message.unsupportedMetrics[i] = 239;
                                    break;
                                case "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY":
                                case 240:
                                    message.unsupportedMetrics[i] = 240;
                                    break;
                                }
                        }
                        if (object.externalTrafficHourlyMetricsEnabled != null)
                            message.externalTrafficHourlyMetricsEnabled = Boolean(object.externalTrafficHourlyMetricsEnabled);
                        switch (object.countingType) {
                        case "UNKNOWN_COUNTING_TYPE":
                        case 0:
                            message.countingType = 0;
                            break;
                        case "FULL_ANALYTIC":
                        case 1:
                            message.countingType = 1;
                            break;
                        case "TRAFFIC_COUNTING":
                        case 2:
                            message.countingType = 2;
                            break;
                        case "ENTRANCE_COUNTING":
                        case 3:
                            message.countingType = 3;
                            break;
                        case "MINIMAL_CAMERA_COUNTING":
                        case 4:
                            message.countingType = 4;
                            break;
                        case "ENTRANCE_ANCHOR_MERGING":
                        case 5:
                            message.countingType = 5;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RawICAMetadata message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @static
                     * @param {palexy.streaming.v1.RawICAMetadata} message RawICAMetadata
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawICAMetadata.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.unsupportedMetrics = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.recordCount = 0;
                            object.cloudProvider = options.enums === String ? "RAW_PROVIDER_UNKNOWN" : 0;
                            object.bucketName = "";
                            object.fileName = "";
                            object.status = options.enums === String ? "RAW_STATUS_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.invalid = false;
                            object.invalidReason = "";
                            object.simulatedFileName = "";
                            object.simulatedDataDescription = "";
                            object.aggregatingRetryCount = 0;
                            object.aggregatedLevel_1FileName = "";
                            object.importedFileName = "";
                            object.externalTrafficHourlyMetricsEnabled = false;
                            object.countingType = options.enums === String ? "UNKNOWN_COUNTING_TYPE" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.recordCount != null && message.hasOwnProperty("recordCount"))
                            object.recordCount = message.recordCount;
                        if (message.cloudProvider != null && message.hasOwnProperty("cloudProvider"))
                            object.cloudProvider = options.enums === String ? $root.palexy.streaming.v1.RawIcaStorageProvider[message.cloudProvider] : message.cloudProvider;
                        if (message.bucketName != null && message.hasOwnProperty("bucketName"))
                            object.bucketName = message.bucketName;
                        if (message.fileName != null && message.hasOwnProperty("fileName"))
                            object.fileName = message.fileName;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus[message.status] : message.status;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.invalid != null && message.hasOwnProperty("invalid"))
                            object.invalid = message.invalid;
                        if (message.invalidReason != null && message.hasOwnProperty("invalidReason"))
                            object.invalidReason = message.invalidReason;
                        if (message.simulatedFileName != null && message.hasOwnProperty("simulatedFileName"))
                            object.simulatedFileName = message.simulatedFileName;
                        if (message.simulatedDataDescription != null && message.hasOwnProperty("simulatedDataDescription"))
                            object.simulatedDataDescription = message.simulatedDataDescription;
                        if (message.aggregatingRetryCount != null && message.hasOwnProperty("aggregatingRetryCount"))
                            object.aggregatingRetryCount = message.aggregatingRetryCount;
                        if (message.aggregatedLevel_1FileName != null && message.hasOwnProperty("aggregatedLevel_1FileName"))
                            object.aggregatedLevel_1FileName = message.aggregatedLevel_1FileName;
                        if (message.importedFileName != null && message.hasOwnProperty("importedFileName"))
                            object.importedFileName = message.importedFileName;
                        if (message.unsupportedMetrics && message.unsupportedMetrics.length) {
                            object.unsupportedMetrics = [];
                            for (var j = 0; j < message.unsupportedMetrics.length; ++j)
                                object.unsupportedMetrics[j] = options.enums === String ? $root.palexy.streaming.v1.MetricEnum[message.unsupportedMetrics[j]] : message.unsupportedMetrics[j];
                        }
                        if (message.externalTrafficHourlyMetricsEnabled != null && message.hasOwnProperty("externalTrafficHourlyMetricsEnabled"))
                            object.externalTrafficHourlyMetricsEnabled = message.externalTrafficHourlyMetricsEnabled;
                        if (message.countingType != null && message.hasOwnProperty("countingType"))
                            object.countingType = options.enums === String ? $root.palexy.streaming.v1.Store.CountingType[message.countingType] : message.countingType;
                        return object;
                    };
    
                    /**
                     * Converts this RawICAMetadata to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RawICAMetadata
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawICAMetadata.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * RawICAMetadataStatus enum.
                     * @name palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus
                     * @enum {number}
                     * @property {number} RAW_STATUS_UNKNOWN=0 RAW_STATUS_UNKNOWN value
                     * @property {number} RAW_READY=1 RAW_READY value
                     * @property {number} AGGREGATING=2 AGGREGATING value
                     * @property {number} DONE_AGGREGATING=3 DONE_AGGREGATING value
                     * @property {number} EXTERNAL_TRAFFIC_READY=4 EXTERNAL_TRAFFIC_READY value
                     * @property {number} DELETED=10 DELETED value
                     */
                    RawICAMetadata.RawICAMetadataStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "RAW_STATUS_UNKNOWN"] = 0;
                        values[valuesById[1] = "RAW_READY"] = 1;
                        values[valuesById[2] = "AGGREGATING"] = 2;
                        values[valuesById[3] = "DONE_AGGREGATING"] = 3;
                        values[valuesById[4] = "EXTERNAL_TRAFFIC_READY"] = 4;
                        values[valuesById[10] = "DELETED"] = 10;
                        return values;
                    })();
    
                    return RawICAMetadata;
                })();
    
                v1.ListRawICAMetadataRequest = (function() {
    
                    /**
                     * Properties of a ListRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICAMetadataRequest
                     * @property {number|null} [companyId] ListRawICAMetadataRequest companyId
                     * @property {number|null} [storeId] ListRawICAMetadataRequest storeId
                     * @property {number|null} [startDate] ListRawICAMetadataRequest startDate
                     * @property {number|null} [endDate] ListRawICAMetadataRequest endDate
                     * @property {Array.<palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus>|null} [statuses] ListRawICAMetadataRequest statuses
                     * @property {number|null} [pageSize] ListRawICAMetadataRequest pageSize
                     * @property {string|null} [pageToken] ListRawICAMetadataRequest pageToken
                     * @property {google.protobuf.IBoolValue|null} [invalid] ListRawICAMetadataRequest invalid
                     * @property {boolean|null} [smallerAggregatingRetryCountFirst] ListRawICAMetadataRequest smallerAggregatingRetryCountFirst
                     */
    
                    /**
                     * Constructs a new ListRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICAMetadataRequest.
                     * @implements IListRawICAMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest=} [properties] Properties to set
                     */
                    function ListRawICAMetadataRequest(properties) {
                        this.statuses = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICAMetadataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListRawICAMetadataRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListRawICAMetadataRequest startDate.
                     * @member {number} startDate
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.startDate = 0;
    
                    /**
                     * ListRawICAMetadataRequest endDate.
                     * @member {number} endDate
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.endDate = 0;
    
                    /**
                     * ListRawICAMetadataRequest statuses.
                     * @member {Array.<palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus>} statuses
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.statuses = $util.emptyArray;
    
                    /**
                     * ListRawICAMetadataRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.pageSize = 0;
    
                    /**
                     * ListRawICAMetadataRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.pageToken = "";
    
                    /**
                     * ListRawICAMetadataRequest invalid.
                     * @member {google.protobuf.IBoolValue|null|undefined} invalid
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.invalid = null;
    
                    /**
                     * ListRawICAMetadataRequest smallerAggregatingRetryCountFirst.
                     * @member {boolean} smallerAggregatingRetryCountFirst
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     */
                    ListRawICAMetadataRequest.prototype.smallerAggregatingRetryCountFirst = false;
    
                    /**
                     * Creates a new ListRawICAMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICAMetadataRequest} ListRawICAMetadataRequest instance
                     */
                    ListRawICAMetadataRequest.create = function create(properties) {
                        return new ListRawICAMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICAMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.ListRawICAMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest} message ListRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endDate);
                        if (message.statuses != null && message.statuses.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.statuses.length; ++i)
                                writer.int32(message.statuses[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.pageToken);
                        if (message.invalid != null && Object.hasOwnProperty.call(message, "invalid"))
                            $root.google.protobuf.BoolValue.encode(message.invalid, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.smallerAggregatingRetryCountFirst != null && Object.hasOwnProperty.call(message, "smallerAggregatingRetryCountFirst"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.smallerAggregatingRetryCountFirst);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICAMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICAMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataRequest} message ListRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICAMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICAMetadataRequest} ListRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICAMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.startDate = reader.int32();
                                break;
                            case 4:
                                message.endDate = reader.int32();
                                break;
                            case 5:
                                if (!(message.statuses && message.statuses.length))
                                    message.statuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.statuses.push(reader.int32());
                                } else
                                    message.statuses.push(reader.int32());
                                break;
                            case 6:
                                message.pageSize = reader.int32();
                                break;
                            case 7:
                                message.pageToken = reader.string();
                                break;
                            case 8:
                                message.invalid = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.smallerAggregatingRetryCountFirst = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICAMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICAMetadataRequest} ListRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICAMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICAMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isInteger(message.startDate))
                                return "startDate: integer expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isInteger(message.endDate))
                                return "endDate: integer expected";
                        if (message.statuses != null && message.hasOwnProperty("statuses")) {
                            if (!Array.isArray(message.statuses))
                                return "statuses: array expected";
                            for (var i = 0; i < message.statuses.length; ++i)
                                switch (message.statuses[i]) {
                                default:
                                    return "statuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 10:
                                    break;
                                }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.invalid != null && message.hasOwnProperty("invalid")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.invalid);
                            if (error)
                                return "invalid." + error;
                        }
                        if (message.smallerAggregatingRetryCountFirst != null && message.hasOwnProperty("smallerAggregatingRetryCountFirst"))
                            if (typeof message.smallerAggregatingRetryCountFirst !== "boolean")
                                return "smallerAggregatingRetryCountFirst: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICAMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICAMetadataRequest} ListRawICAMetadataRequest
                     */
                    ListRawICAMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICAMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICAMetadataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDate != null)
                            message.startDate = object.startDate | 0;
                        if (object.endDate != null)
                            message.endDate = object.endDate | 0;
                        if (object.statuses) {
                            if (!Array.isArray(object.statuses))
                                throw TypeError(".palexy.streaming.v1.ListRawICAMetadataRequest.statuses: array expected");
                            message.statuses = [];
                            for (var i = 0; i < object.statuses.length; ++i)
                                switch (object.statuses[i]) {
                                default:
                                case "RAW_STATUS_UNKNOWN":
                                case 0:
                                    message.statuses[i] = 0;
                                    break;
                                case "RAW_READY":
                                case 1:
                                    message.statuses[i] = 1;
                                    break;
                                case "AGGREGATING":
                                case 2:
                                    message.statuses[i] = 2;
                                    break;
                                case "DONE_AGGREGATING":
                                case 3:
                                    message.statuses[i] = 3;
                                    break;
                                case "EXTERNAL_TRAFFIC_READY":
                                case 4:
                                    message.statuses[i] = 4;
                                    break;
                                case "DELETED":
                                case 10:
                                    message.statuses[i] = 10;
                                    break;
                                }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.invalid != null) {
                            if (typeof object.invalid !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICAMetadataRequest.invalid: object expected");
                            message.invalid = $root.google.protobuf.BoolValue.fromObject(object.invalid);
                        }
                        if (object.smallerAggregatingRetryCountFirst != null)
                            message.smallerAggregatingRetryCountFirst = Boolean(object.smallerAggregatingRetryCountFirst);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICAMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ListRawICAMetadataRequest} message ListRawICAMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICAMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.statuses = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDate = 0;
                            object.endDate = 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.invalid = null;
                            object.smallerAggregatingRetryCountFirst = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        if (message.statuses && message.statuses.length) {
                            object.statuses = [];
                            for (var j = 0; j < message.statuses.length; ++j)
                                object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus[message.statuses[j]] : message.statuses[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.invalid != null && message.hasOwnProperty("invalid"))
                            object.invalid = $root.google.protobuf.BoolValue.toObject(message.invalid, options);
                        if (message.smallerAggregatingRetryCountFirst != null && message.hasOwnProperty("smallerAggregatingRetryCountFirst"))
                            object.smallerAggregatingRetryCountFirst = message.smallerAggregatingRetryCountFirst;
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICAMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICAMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICAMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICAMetadataRequest;
                })();
    
                v1.ListRawICAMetadataResponse = (function() {
    
                    /**
                     * Properties of a ListRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICAMetadataResponse
                     * @property {Array.<palexy.streaming.v1.IRawICAMetadata>|null} [rawIcaMetadata] ListRawICAMetadataResponse rawIcaMetadata
                     * @property {number|null} [totalElements] ListRawICAMetadataResponse totalElements
                     * @property {string|null} [nextPageToken] ListRawICAMetadataResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICAMetadataResponse.
                     * @implements IListRawICAMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICAMetadataResponse=} [properties] Properties to set
                     */
                    function ListRawICAMetadataResponse(properties) {
                        this.rawIcaMetadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICAMetadataResponse rawIcaMetadata.
                     * @member {Array.<palexy.streaming.v1.IRawICAMetadata>} rawIcaMetadata
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @instance
                     */
                    ListRawICAMetadataResponse.prototype.rawIcaMetadata = $util.emptyArray;
    
                    /**
                     * ListRawICAMetadataResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @instance
                     */
                    ListRawICAMetadataResponse.prototype.totalElements = 0;
    
                    /**
                     * ListRawICAMetadataResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @instance
                     */
                    ListRawICAMetadataResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListRawICAMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICAMetadataResponse} ListRawICAMetadataResponse instance
                     */
                    ListRawICAMetadataResponse.create = function create(properties) {
                        return new ListRawICAMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICAMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.ListRawICAMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataResponse} message ListRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadata != null && message.rawIcaMetadata.length)
                            for (var i = 0; i < message.rawIcaMetadata.length; ++i)
                                $root.palexy.streaming.v1.RawICAMetadata.encode(message.rawIcaMetadata[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICAMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICAMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAMetadataResponse} message ListRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICAMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICAMetadataResponse} ListRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICAMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rawIcaMetadata && message.rawIcaMetadata.length))
                                    message.rawIcaMetadata = [];
                                message.rawIcaMetadata.push($root.palexy.streaming.v1.RawICAMetadata.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICAMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICAMetadataResponse} ListRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICAMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICAMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata")) {
                            if (!Array.isArray(message.rawIcaMetadata))
                                return "rawIcaMetadata: array expected";
                            for (var i = 0; i < message.rawIcaMetadata.length; ++i) {
                                var error = $root.palexy.streaming.v1.RawICAMetadata.verify(message.rawIcaMetadata[i]);
                                if (error)
                                    return "rawIcaMetadata." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICAMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICAMetadataResponse} ListRawICAMetadataResponse
                     */
                    ListRawICAMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICAMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICAMetadataResponse();
                        if (object.rawIcaMetadata) {
                            if (!Array.isArray(object.rawIcaMetadata))
                                throw TypeError(".palexy.streaming.v1.ListRawICAMetadataResponse.rawIcaMetadata: array expected");
                            message.rawIcaMetadata = [];
                            for (var i = 0; i < object.rawIcaMetadata.length; ++i) {
                                if (typeof object.rawIcaMetadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListRawICAMetadataResponse.rawIcaMetadata: object expected");
                                message.rawIcaMetadata[i] = $root.palexy.streaming.v1.RawICAMetadata.fromObject(object.rawIcaMetadata[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICAMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ListRawICAMetadataResponse} message ListRawICAMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICAMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rawIcaMetadata = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.rawIcaMetadata && message.rawIcaMetadata.length) {
                            object.rawIcaMetadata = [];
                            for (var j = 0; j < message.rawIcaMetadata.length; ++j)
                                object.rawIcaMetadata[j] = $root.palexy.streaming.v1.RawICAMetadata.toObject(message.rawIcaMetadata[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICAMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICAMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICAMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICAMetadataResponse;
                })();
    
                v1.CreateRawICAMetadataRequest = (function() {
    
                    /**
                     * Properties of a CreateRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateRawICAMetadataRequest
                     * @property {palexy.streaming.v1.IRawICAMetadata|null} [rawIcaMetadata] CreateRawICAMetadataRequest rawIcaMetadata
                     * @property {boolean|null} [updateIfExists] CreateRawICAMetadataRequest updateIfExists
                     */
    
                    /**
                     * Constructs a new CreateRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateRawICAMetadataRequest.
                     * @implements ICreateRawICAMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest=} [properties] Properties to set
                     */
                    function CreateRawICAMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateRawICAMetadataRequest rawIcaMetadata.
                     * @member {palexy.streaming.v1.IRawICAMetadata|null|undefined} rawIcaMetadata
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @instance
                     */
                    CreateRawICAMetadataRequest.prototype.rawIcaMetadata = null;
    
                    /**
                     * CreateRawICAMetadataRequest updateIfExists.
                     * @member {boolean} updateIfExists
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @instance
                     */
                    CreateRawICAMetadataRequest.prototype.updateIfExists = false;
    
                    /**
                     * Creates a new CreateRawICAMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataRequest} CreateRawICAMetadataRequest instance
                     */
                    CreateRawICAMetadataRequest.create = function create(properties) {
                        return new CreateRawICAMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateRawICAMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.CreateRawICAMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest} message CreateRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRawICAMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadata != null && Object.hasOwnProperty.call(message, "rawIcaMetadata"))
                            $root.palexy.streaming.v1.RawICAMetadata.encode(message.rawIcaMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateIfExists != null && Object.hasOwnProperty.call(message, "updateIfExists"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.updateIfExists);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateRawICAMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateRawICAMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataRequest} message CreateRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRawICAMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateRawICAMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataRequest} CreateRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRawICAMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateRawICAMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateIfExists = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateRawICAMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataRequest} CreateRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRawICAMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateRawICAMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateRawICAMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata")) {
                            var error = $root.palexy.streaming.v1.RawICAMetadata.verify(message.rawIcaMetadata);
                            if (error)
                                return "rawIcaMetadata." + error;
                        }
                        if (message.updateIfExists != null && message.hasOwnProperty("updateIfExists"))
                            if (typeof message.updateIfExists !== "boolean")
                                return "updateIfExists: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateRawICAMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataRequest} CreateRawICAMetadataRequest
                     */
                    CreateRawICAMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateRawICAMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateRawICAMetadataRequest();
                        if (object.rawIcaMetadata != null) {
                            if (typeof object.rawIcaMetadata !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateRawICAMetadataRequest.rawIcaMetadata: object expected");
                            message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.fromObject(object.rawIcaMetadata);
                        }
                        if (object.updateIfExists != null)
                            message.updateIfExists = Boolean(object.updateIfExists);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateRawICAMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateRawICAMetadataRequest} message CreateRawICAMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateRawICAMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.rawIcaMetadata = null;
                            object.updateIfExists = false;
                        }
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata"))
                            object.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.toObject(message.rawIcaMetadata, options);
                        if (message.updateIfExists != null && message.hasOwnProperty("updateIfExists"))
                            object.updateIfExists = message.updateIfExists;
                        return object;
                    };
    
                    /**
                     * Converts this CreateRawICAMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateRawICAMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateRawICAMetadataRequest;
                })();
    
                v1.CreateRawICAMetadataResponse = (function() {
    
                    /**
                     * Properties of a CreateRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateRawICAMetadataResponse
                     * @property {palexy.streaming.v1.IRawICAMetadata|null} [rawIcaMetadata] CreateRawICAMetadataResponse rawIcaMetadata
                     * @property {boolean|null} [created] CreateRawICAMetadataResponse created
                     */
    
                    /**
                     * Constructs a new CreateRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateRawICAMetadataResponse.
                     * @implements ICreateRawICAMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataResponse=} [properties] Properties to set
                     */
                    function CreateRawICAMetadataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateRawICAMetadataResponse rawIcaMetadata.
                     * @member {palexy.streaming.v1.IRawICAMetadata|null|undefined} rawIcaMetadata
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @instance
                     */
                    CreateRawICAMetadataResponse.prototype.rawIcaMetadata = null;
    
                    /**
                     * CreateRawICAMetadataResponse created.
                     * @member {boolean} created
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @instance
                     */
                    CreateRawICAMetadataResponse.prototype.created = false;
    
                    /**
                     * Creates a new CreateRawICAMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataResponse} CreateRawICAMetadataResponse instance
                     */
                    CreateRawICAMetadataResponse.create = function create(properties) {
                        return new CreateRawICAMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateRawICAMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.CreateRawICAMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataResponse} message CreateRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRawICAMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadata != null && Object.hasOwnProperty.call(message, "rawIcaMetadata"))
                            $root.palexy.streaming.v1.RawICAMetadata.encode(message.rawIcaMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.created != null && Object.hasOwnProperty.call(message, "created"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.created);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateRawICAMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateRawICAMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateRawICAMetadataResponse} message CreateRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateRawICAMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateRawICAMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataResponse} CreateRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRawICAMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateRawICAMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.created = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateRawICAMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataResponse} CreateRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateRawICAMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateRawICAMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateRawICAMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata")) {
                            var error = $root.palexy.streaming.v1.RawICAMetadata.verify(message.rawIcaMetadata);
                            if (error)
                                return "rawIcaMetadata." + error;
                        }
                        if (message.created != null && message.hasOwnProperty("created"))
                            if (typeof message.created !== "boolean")
                                return "created: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateRawICAMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateRawICAMetadataResponse} CreateRawICAMetadataResponse
                     */
                    CreateRawICAMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateRawICAMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateRawICAMetadataResponse();
                        if (object.rawIcaMetadata != null) {
                            if (typeof object.rawIcaMetadata !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateRawICAMetadataResponse.rawIcaMetadata: object expected");
                            message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.fromObject(object.rawIcaMetadata);
                        }
                        if (object.created != null)
                            message.created = Boolean(object.created);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateRawICAMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.CreateRawICAMetadataResponse} message CreateRawICAMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateRawICAMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.rawIcaMetadata = null;
                            object.created = false;
                        }
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata"))
                            object.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.toObject(message.rawIcaMetadata, options);
                        if (message.created != null && message.hasOwnProperty("created"))
                            object.created = message.created;
                        return object;
                    };
    
                    /**
                     * Converts this CreateRawICAMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateRawICAMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateRawICAMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateRawICAMetadataResponse;
                })();
    
                v1.UpdateRawICAMetadataRequest = (function() {
    
                    /**
                     * Properties of an UpdateRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateRawICAMetadataRequest
                     * @property {palexy.streaming.v1.IRawICAMetadata|null} [rawIcaMetadata] UpdateRawICAMetadataRequest rawIcaMetadata
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateRawICAMetadataRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateRawICAMetadataRequest.
                     * @implements IUpdateRawICAMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest=} [properties] Properties to set
                     */
                    function UpdateRawICAMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateRawICAMetadataRequest rawIcaMetadata.
                     * @member {palexy.streaming.v1.IRawICAMetadata|null|undefined} rawIcaMetadata
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @instance
                     */
                    UpdateRawICAMetadataRequest.prototype.rawIcaMetadata = null;
    
                    /**
                     * UpdateRawICAMetadataRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @instance
                     */
                    UpdateRawICAMetadataRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateRawICAMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateRawICAMetadataRequest} UpdateRawICAMetadataRequest instance
                     */
                    UpdateRawICAMetadataRequest.create = function create(properties) {
                        return new UpdateRawICAMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateRawICAMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateRawICAMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest} message UpdateRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateRawICAMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadata != null && Object.hasOwnProperty.call(message, "rawIcaMetadata"))
                            $root.palexy.streaming.v1.RawICAMetadata.encode(message.rawIcaMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateRawICAMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateRawICAMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAMetadataRequest} message UpdateRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateRawICAMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateRawICAMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateRawICAMetadataRequest} UpdateRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateRawICAMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateRawICAMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateRawICAMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateRawICAMetadataRequest} UpdateRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateRawICAMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateRawICAMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateRawICAMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata")) {
                            var error = $root.palexy.streaming.v1.RawICAMetadata.verify(message.rawIcaMetadata);
                            if (error)
                                return "rawIcaMetadata." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateRawICAMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateRawICAMetadataRequest} UpdateRawICAMetadataRequest
                     */
                    UpdateRawICAMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateRawICAMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateRawICAMetadataRequest();
                        if (object.rawIcaMetadata != null) {
                            if (typeof object.rawIcaMetadata !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateRawICAMetadataRequest.rawIcaMetadata: object expected");
                            message.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.fromObject(object.rawIcaMetadata);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateRawICAMetadataRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateRawICAMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateRawICAMetadataRequest} message UpdateRawICAMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateRawICAMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.rawIcaMetadata = null;
                            object.updateMask = null;
                        }
                        if (message.rawIcaMetadata != null && message.hasOwnProperty("rawIcaMetadata"))
                            object.rawIcaMetadata = $root.palexy.streaming.v1.RawICAMetadata.toObject(message.rawIcaMetadata, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateRawICAMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateRawICAMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateRawICAMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateRawICAMetadataRequest;
                })();
    
                v1.GetRawIcaMetadataRequest = (function() {
    
                    /**
                     * Properties of a GetRawIcaMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetRawIcaMetadataRequest
                     * @property {number|null} [rawIcaMetadataId] GetRawIcaMetadataRequest rawIcaMetadataId
                     */
    
                    /**
                     * Constructs a new GetRawIcaMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetRawIcaMetadataRequest.
                     * @implements IGetRawIcaMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest=} [properties] Properties to set
                     */
                    function GetRawIcaMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetRawIcaMetadataRequest rawIcaMetadataId.
                     * @member {number} rawIcaMetadataId
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @instance
                     */
                    GetRawIcaMetadataRequest.prototype.rawIcaMetadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetRawIcaMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetRawIcaMetadataRequest} GetRawIcaMetadataRequest instance
                     */
                    GetRawIcaMetadataRequest.create = function create(properties) {
                        return new GetRawIcaMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetRawIcaMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.GetRawIcaMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest} message GetRawIcaMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRawIcaMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadataId != null && Object.hasOwnProperty.call(message, "rawIcaMetadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.rawIcaMetadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetRawIcaMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetRawIcaMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawIcaMetadataRequest} message GetRawIcaMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRawIcaMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetRawIcaMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetRawIcaMetadataRequest} GetRawIcaMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRawIcaMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetRawIcaMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaMetadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetRawIcaMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetRawIcaMetadataRequest} GetRawIcaMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRawIcaMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetRawIcaMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetRawIcaMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadataId != null && message.hasOwnProperty("rawIcaMetadataId"))
                            if (!$util.isInteger(message.rawIcaMetadataId) && !(message.rawIcaMetadataId && $util.isInteger(message.rawIcaMetadataId.low) && $util.isInteger(message.rawIcaMetadataId.high)))
                                return "rawIcaMetadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetRawIcaMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetRawIcaMetadataRequest} GetRawIcaMetadataRequest
                     */
                    GetRawIcaMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetRawIcaMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetRawIcaMetadataRequest();
                        if (object.rawIcaMetadataId != null)
                            if ($util.Long)
                                (message.rawIcaMetadataId = $util.Long.fromValue(object.rawIcaMetadataId)).unsigned = false;
                            else if (typeof object.rawIcaMetadataId === "string")
                                message.rawIcaMetadataId = parseInt(object.rawIcaMetadataId, 10);
                            else if (typeof object.rawIcaMetadataId === "number")
                                message.rawIcaMetadataId = object.rawIcaMetadataId;
                            else if (typeof object.rawIcaMetadataId === "object")
                                message.rawIcaMetadataId = new $util.LongBits(object.rawIcaMetadataId.low >>> 0, object.rawIcaMetadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetRawIcaMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.GetRawIcaMetadataRequest} message GetRawIcaMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetRawIcaMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.rawIcaMetadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.rawIcaMetadataId = options.longs === String ? "0" : 0;
                        if (message.rawIcaMetadataId != null && message.hasOwnProperty("rawIcaMetadataId"))
                            if (typeof message.rawIcaMetadataId === "number")
                                object.rawIcaMetadataId = options.longs === String ? String(message.rawIcaMetadataId) : message.rawIcaMetadataId;
                            else
                                object.rawIcaMetadataId = options.longs === String ? $util.Long.prototype.toString.call(message.rawIcaMetadataId) : options.longs === Number ? new $util.LongBits(message.rawIcaMetadataId.low >>> 0, message.rawIcaMetadataId.high >>> 0).toNumber() : message.rawIcaMetadataId;
                        return object;
                    };
    
                    /**
                     * Converts this GetRawIcaMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetRawIcaMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetRawIcaMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetRawIcaMetadataRequest;
                })();
    
                v1.BatchUpdateRawICAMetadataStatusRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateRawICAMetadataStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateRawICAMetadataStatusRequest
                     * @property {number|null} [storeId] BatchUpdateRawICAMetadataStatusRequest storeId
                     * @property {Array.<palexy.streaming.v1.IDateRange>|null} [dateRanges] BatchUpdateRawICAMetadataStatusRequest dateRanges
                     * @property {Array.<palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus>|null} [oldStatuses] BatchUpdateRawICAMetadataStatusRequest oldStatuses
                     * @property {palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus|null} [newStatus] BatchUpdateRawICAMetadataStatusRequest newStatus
                     * @property {boolean|null} [resetAggregatingRetryCount] BatchUpdateRawICAMetadataStatusRequest resetAggregatingRetryCount
                     * @property {Array.<number>|null} [storeIds] BatchUpdateRawICAMetadataStatusRequest storeIds
                     */
    
                    /**
                     * Constructs a new BatchUpdateRawICAMetadataStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateRawICAMetadataStatusRequest.
                     * @implements IBatchUpdateRawICAMetadataStatusRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest=} [properties] Properties to set
                     */
                    function BatchUpdateRawICAMetadataStatusRequest(properties) {
                        this.dateRanges = [];
                        this.oldStatuses = [];
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest dateRanges.
                     * @member {Array.<palexy.streaming.v1.IDateRange>} dateRanges
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.dateRanges = $util.emptyArray;
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest oldStatuses.
                     * @member {Array.<palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus>} oldStatuses
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.oldStatuses = $util.emptyArray;
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest newStatus.
                     * @member {palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus} newStatus
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.newStatus = 0;
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest resetAggregatingRetryCount.
                     * @member {boolean} resetAggregatingRetryCount
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.resetAggregatingRetryCount = false;
    
                    /**
                     * BatchUpdateRawICAMetadataStatusRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateRawICAMetadataStatusRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest} BatchUpdateRawICAMetadataStatusRequest instance
                     */
                    BatchUpdateRawICAMetadataStatusRequest.create = function create(properties) {
                        return new BatchUpdateRawICAMetadataStatusRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateRawICAMetadataStatusRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest} message BatchUpdateRawICAMetadataStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateRawICAMetadataStatusRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateRanges != null && message.dateRanges.length)
                            for (var i = 0; i < message.dateRanges.length; ++i)
                                $root.palexy.streaming.v1.DateRange.encode(message.dateRanges[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.oldStatuses != null && message.oldStatuses.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.oldStatuses.length; ++i)
                                writer.int32(message.oldStatuses[i]);
                            writer.ldelim();
                        }
                        if (message.newStatus != null && Object.hasOwnProperty.call(message, "newStatus"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.newStatus);
                        if (message.resetAggregatingRetryCount != null && Object.hasOwnProperty.call(message, "resetAggregatingRetryCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.resetAggregatingRetryCount);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateRawICAMetadataStatusRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusRequest} message BatchUpdateRawICAMetadataStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateRawICAMetadataStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateRawICAMetadataStatusRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest} BatchUpdateRawICAMetadataStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateRawICAMetadataStatusRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.dateRanges && message.dateRanges.length))
                                    message.dateRanges = [];
                                message.dateRanges.push($root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.oldStatuses && message.oldStatuses.length))
                                    message.oldStatuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.oldStatuses.push(reader.int32());
                                } else
                                    message.oldStatuses.push(reader.int32());
                                break;
                            case 4:
                                message.newStatus = reader.int32();
                                break;
                            case 5:
                                message.resetAggregatingRetryCount = reader.bool();
                                break;
                            case 6:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateRawICAMetadataStatusRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest} BatchUpdateRawICAMetadataStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateRawICAMetadataStatusRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateRawICAMetadataStatusRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateRawICAMetadataStatusRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateRanges != null && message.hasOwnProperty("dateRanges")) {
                            if (!Array.isArray(message.dateRanges))
                                return "dateRanges: array expected";
                            for (var i = 0; i < message.dateRanges.length; ++i) {
                                var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRanges[i]);
                                if (error)
                                    return "dateRanges." + error;
                            }
                        }
                        if (message.oldStatuses != null && message.hasOwnProperty("oldStatuses")) {
                            if (!Array.isArray(message.oldStatuses))
                                return "oldStatuses: array expected";
                            for (var i = 0; i < message.oldStatuses.length; ++i)
                                switch (message.oldStatuses[i]) {
                                default:
                                    return "oldStatuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 10:
                                    break;
                                }
                        }
                        if (message.newStatus != null && message.hasOwnProperty("newStatus"))
                            switch (message.newStatus) {
                            default:
                                return "newStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 10:
                                break;
                            }
                        if (message.resetAggregatingRetryCount != null && message.hasOwnProperty("resetAggregatingRetryCount"))
                            if (typeof message.resetAggregatingRetryCount !== "boolean")
                                return "resetAggregatingRetryCount: boolean expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateRawICAMetadataStatusRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest} BatchUpdateRawICAMetadataStatusRequest
                     */
                    BatchUpdateRawICAMetadataStatusRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateRanges) {
                            if (!Array.isArray(object.dateRanges))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.dateRanges: array expected");
                            message.dateRanges = [];
                            for (var i = 0; i < object.dateRanges.length; ++i) {
                                if (typeof object.dateRanges[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.dateRanges: object expected");
                                message.dateRanges[i] = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRanges[i]);
                            }
                        }
                        if (object.oldStatuses) {
                            if (!Array.isArray(object.oldStatuses))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.oldStatuses: array expected");
                            message.oldStatuses = [];
                            for (var i = 0; i < object.oldStatuses.length; ++i)
                                switch (object.oldStatuses[i]) {
                                default:
                                case "RAW_STATUS_UNKNOWN":
                                case 0:
                                    message.oldStatuses[i] = 0;
                                    break;
                                case "RAW_READY":
                                case 1:
                                    message.oldStatuses[i] = 1;
                                    break;
                                case "AGGREGATING":
                                case 2:
                                    message.oldStatuses[i] = 2;
                                    break;
                                case "DONE_AGGREGATING":
                                case 3:
                                    message.oldStatuses[i] = 3;
                                    break;
                                case "EXTERNAL_TRAFFIC_READY":
                                case 4:
                                    message.oldStatuses[i] = 4;
                                    break;
                                case "DELETED":
                                case 10:
                                    message.oldStatuses[i] = 10;
                                    break;
                                }
                        }
                        switch (object.newStatus) {
                        case "RAW_STATUS_UNKNOWN":
                        case 0:
                            message.newStatus = 0;
                            break;
                        case "RAW_READY":
                        case 1:
                            message.newStatus = 1;
                            break;
                        case "AGGREGATING":
                        case 2:
                            message.newStatus = 2;
                            break;
                        case "DONE_AGGREGATING":
                        case 3:
                            message.newStatus = 3;
                            break;
                        case "EXTERNAL_TRAFFIC_READY":
                        case 4:
                            message.newStatus = 4;
                            break;
                        case "DELETED":
                        case 10:
                            message.newStatus = 10;
                            break;
                        }
                        if (object.resetAggregatingRetryCount != null)
                            message.resetAggregatingRetryCount = Boolean(object.resetAggregatingRetryCount);
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateRawICAMetadataStatusRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest} message BatchUpdateRawICAMetadataStatusRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateRawICAMetadataStatusRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dateRanges = [];
                            object.oldStatuses = [];
                            object.storeIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.newStatus = options.enums === String ? "RAW_STATUS_UNKNOWN" : 0;
                            object.resetAggregatingRetryCount = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateRanges && message.dateRanges.length) {
                            object.dateRanges = [];
                            for (var j = 0; j < message.dateRanges.length; ++j)
                                object.dateRanges[j] = $root.palexy.streaming.v1.DateRange.toObject(message.dateRanges[j], options);
                        }
                        if (message.oldStatuses && message.oldStatuses.length) {
                            object.oldStatuses = [];
                            for (var j = 0; j < message.oldStatuses.length; ++j)
                                object.oldStatuses[j] = options.enums === String ? $root.palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus[message.oldStatuses[j]] : message.oldStatuses[j];
                        }
                        if (message.newStatus != null && message.hasOwnProperty("newStatus"))
                            object.newStatus = options.enums === String ? $root.palexy.streaming.v1.RawICAMetadata.RawICAMetadataStatus[message.newStatus] : message.newStatus;
                        if (message.resetAggregatingRetryCount != null && message.hasOwnProperty("resetAggregatingRetryCount"))
                            object.resetAggregatingRetryCount = message.resetAggregatingRetryCount;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateRawICAMetadataStatusRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateRawICAMetadataStatusRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateRawICAMetadataStatusRequest;
                })();
    
                v1.BatchUpdateRawICAMetadataStatusResponse = (function() {
    
                    /**
                     * Properties of a BatchUpdateRawICAMetadataStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateRawICAMetadataStatusResponse
                     * @property {number|null} [affectedRowsCount] BatchUpdateRawICAMetadataStatusResponse affectedRowsCount
                     */
    
                    /**
                     * Constructs a new BatchUpdateRawICAMetadataStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateRawICAMetadataStatusResponse.
                     * @implements IBatchUpdateRawICAMetadataStatusResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusResponse=} [properties] Properties to set
                     */
                    function BatchUpdateRawICAMetadataStatusResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateRawICAMetadataStatusResponse affectedRowsCount.
                     * @member {number} affectedRowsCount
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @instance
                     */
                    BatchUpdateRawICAMetadataStatusResponse.prototype.affectedRowsCount = 0;
    
                    /**
                     * Creates a new BatchUpdateRawICAMetadataStatusResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} BatchUpdateRawICAMetadataStatusResponse instance
                     */
                    BatchUpdateRawICAMetadataStatusResponse.create = function create(properties) {
                        return new BatchUpdateRawICAMetadataStatusResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateRawICAMetadataStatusResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusResponse} message BatchUpdateRawICAMetadataStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateRawICAMetadataStatusResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.affectedRowsCount != null && Object.hasOwnProperty.call(message, "affectedRowsCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.affectedRowsCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateRawICAMetadataStatusResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateRawICAMetadataStatusResponse} message BatchUpdateRawICAMetadataStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateRawICAMetadataStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateRawICAMetadataStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} BatchUpdateRawICAMetadataStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateRawICAMetadataStatusResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.affectedRowsCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateRawICAMetadataStatusResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} BatchUpdateRawICAMetadataStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateRawICAMetadataStatusResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateRawICAMetadataStatusResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateRawICAMetadataStatusResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            if (!$util.isInteger(message.affectedRowsCount))
                                return "affectedRowsCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateRawICAMetadataStatusResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} BatchUpdateRawICAMetadataStatusResponse
                     */
                    BatchUpdateRawICAMetadataStatusResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse();
                        if (object.affectedRowsCount != null)
                            message.affectedRowsCount = object.affectedRowsCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateRawICAMetadataStatusResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse} message BatchUpdateRawICAMetadataStatusResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateRawICAMetadataStatusResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.affectedRowsCount = 0;
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            object.affectedRowsCount = message.affectedRowsCount;
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateRawICAMetadataStatusResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateRawICAMetadataStatusResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateRawICAMetadataStatusResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateRawICAMetadataStatusResponse;
                })();
    
                v1.AggregateRawICADataRequest = (function() {
    
                    /**
                     * Properties of an AggregateRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IAggregateRawICADataRequest
                     * @property {number|null} [rawIcaMetadataId] AggregateRawICADataRequest rawIcaMetadataId
                     * @property {boolean|null} [skipCustomerActivitySummaries] AggregateRawICADataRequest skipCustomerActivitySummaries
                     * @property {boolean|null} [skipCustomerJourneysV2] AggregateRawICADataRequest skipCustomerJourneysV2
                     * @property {boolean|null} [skipCustomerJourneysV3] AggregateRawICADataRequest skipCustomerJourneysV3
                     * @property {boolean|null} [skipVisitorOccupancies] AggregateRawICADataRequest skipVisitorOccupancies
                     */
    
                    /**
                     * Constructs a new AggregateRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AggregateRawICADataRequest.
                     * @implements IAggregateRawICADataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest=} [properties] Properties to set
                     */
                    function AggregateRawICADataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AggregateRawICADataRequest rawIcaMetadataId.
                     * @member {number} rawIcaMetadataId
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     */
                    AggregateRawICADataRequest.prototype.rawIcaMetadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AggregateRawICADataRequest skipCustomerActivitySummaries.
                     * @member {boolean} skipCustomerActivitySummaries
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     */
                    AggregateRawICADataRequest.prototype.skipCustomerActivitySummaries = false;
    
                    /**
                     * AggregateRawICADataRequest skipCustomerJourneysV2.
                     * @member {boolean} skipCustomerJourneysV2
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     */
                    AggregateRawICADataRequest.prototype.skipCustomerJourneysV2 = false;
    
                    /**
                     * AggregateRawICADataRequest skipCustomerJourneysV3.
                     * @member {boolean} skipCustomerJourneysV3
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     */
                    AggregateRawICADataRequest.prototype.skipCustomerJourneysV3 = false;
    
                    /**
                     * AggregateRawICADataRequest skipVisitorOccupancies.
                     * @member {boolean} skipVisitorOccupancies
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     */
                    AggregateRawICADataRequest.prototype.skipVisitorOccupancies = false;
    
                    /**
                     * Creates a new AggregateRawICADataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AggregateRawICADataRequest} AggregateRawICADataRequest instance
                     */
                    AggregateRawICADataRequest.create = function create(properties) {
                        return new AggregateRawICADataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateRawICADataRequest message. Does not implicitly {@link palexy.streaming.v1.AggregateRawICADataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest} message AggregateRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateRawICADataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaMetadataId != null && Object.hasOwnProperty.call(message, "rawIcaMetadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.rawIcaMetadataId);
                        if (message.skipCustomerActivitySummaries != null && Object.hasOwnProperty.call(message, "skipCustomerActivitySummaries"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.skipCustomerActivitySummaries);
                        if (message.skipCustomerJourneysV2 != null && Object.hasOwnProperty.call(message, "skipCustomerJourneysV2"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.skipCustomerJourneysV2);
                        if (message.skipCustomerJourneysV3 != null && Object.hasOwnProperty.call(message, "skipCustomerJourneysV3"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.skipCustomerJourneysV3);
                        if (message.skipVisitorOccupancies != null && Object.hasOwnProperty.call(message, "skipVisitorOccupancies"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.skipVisitorOccupancies);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateRawICADataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.AggregateRawICADataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataRequest} message AggregateRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateRawICADataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateRawICADataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AggregateRawICADataRequest} AggregateRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateRawICADataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AggregateRawICADataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaMetadataId = reader.int64();
                                break;
                            case 2:
                                message.skipCustomerActivitySummaries = reader.bool();
                                break;
                            case 3:
                                message.skipCustomerJourneysV2 = reader.bool();
                                break;
                            case 4:
                                message.skipCustomerJourneysV3 = reader.bool();
                                break;
                            case 5:
                                message.skipVisitorOccupancies = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateRawICADataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AggregateRawICADataRequest} AggregateRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateRawICADataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateRawICADataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateRawICADataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaMetadataId != null && message.hasOwnProperty("rawIcaMetadataId"))
                            if (!$util.isInteger(message.rawIcaMetadataId) && !(message.rawIcaMetadataId && $util.isInteger(message.rawIcaMetadataId.low) && $util.isInteger(message.rawIcaMetadataId.high)))
                                return "rawIcaMetadataId: integer|Long expected";
                        if (message.skipCustomerActivitySummaries != null && message.hasOwnProperty("skipCustomerActivitySummaries"))
                            if (typeof message.skipCustomerActivitySummaries !== "boolean")
                                return "skipCustomerActivitySummaries: boolean expected";
                        if (message.skipCustomerJourneysV2 != null && message.hasOwnProperty("skipCustomerJourneysV2"))
                            if (typeof message.skipCustomerJourneysV2 !== "boolean")
                                return "skipCustomerJourneysV2: boolean expected";
                        if (message.skipCustomerJourneysV3 != null && message.hasOwnProperty("skipCustomerJourneysV3"))
                            if (typeof message.skipCustomerJourneysV3 !== "boolean")
                                return "skipCustomerJourneysV3: boolean expected";
                        if (message.skipVisitorOccupancies != null && message.hasOwnProperty("skipVisitorOccupancies"))
                            if (typeof message.skipVisitorOccupancies !== "boolean")
                                return "skipVisitorOccupancies: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateRawICADataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AggregateRawICADataRequest} AggregateRawICADataRequest
                     */
                    AggregateRawICADataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AggregateRawICADataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.AggregateRawICADataRequest();
                        if (object.rawIcaMetadataId != null)
                            if ($util.Long)
                                (message.rawIcaMetadataId = $util.Long.fromValue(object.rawIcaMetadataId)).unsigned = false;
                            else if (typeof object.rawIcaMetadataId === "string")
                                message.rawIcaMetadataId = parseInt(object.rawIcaMetadataId, 10);
                            else if (typeof object.rawIcaMetadataId === "number")
                                message.rawIcaMetadataId = object.rawIcaMetadataId;
                            else if (typeof object.rawIcaMetadataId === "object")
                                message.rawIcaMetadataId = new $util.LongBits(object.rawIcaMetadataId.low >>> 0, object.rawIcaMetadataId.high >>> 0).toNumber();
                        if (object.skipCustomerActivitySummaries != null)
                            message.skipCustomerActivitySummaries = Boolean(object.skipCustomerActivitySummaries);
                        if (object.skipCustomerJourneysV2 != null)
                            message.skipCustomerJourneysV2 = Boolean(object.skipCustomerJourneysV2);
                        if (object.skipCustomerJourneysV3 != null)
                            message.skipCustomerJourneysV3 = Boolean(object.skipCustomerJourneysV3);
                        if (object.skipVisitorOccupancies != null)
                            message.skipVisitorOccupancies = Boolean(object.skipVisitorOccupancies);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AggregateRawICADataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.AggregateRawICADataRequest} message AggregateRawICADataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateRawICADataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.rawIcaMetadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.rawIcaMetadataId = options.longs === String ? "0" : 0;
                            object.skipCustomerActivitySummaries = false;
                            object.skipCustomerJourneysV2 = false;
                            object.skipCustomerJourneysV3 = false;
                            object.skipVisitorOccupancies = false;
                        }
                        if (message.rawIcaMetadataId != null && message.hasOwnProperty("rawIcaMetadataId"))
                            if (typeof message.rawIcaMetadataId === "number")
                                object.rawIcaMetadataId = options.longs === String ? String(message.rawIcaMetadataId) : message.rawIcaMetadataId;
                            else
                                object.rawIcaMetadataId = options.longs === String ? $util.Long.prototype.toString.call(message.rawIcaMetadataId) : options.longs === Number ? new $util.LongBits(message.rawIcaMetadataId.low >>> 0, message.rawIcaMetadataId.high >>> 0).toNumber() : message.rawIcaMetadataId;
                        if (message.skipCustomerActivitySummaries != null && message.hasOwnProperty("skipCustomerActivitySummaries"))
                            object.skipCustomerActivitySummaries = message.skipCustomerActivitySummaries;
                        if (message.skipCustomerJourneysV2 != null && message.hasOwnProperty("skipCustomerJourneysV2"))
                            object.skipCustomerJourneysV2 = message.skipCustomerJourneysV2;
                        if (message.skipCustomerJourneysV3 != null && message.hasOwnProperty("skipCustomerJourneysV3"))
                            object.skipCustomerJourneysV3 = message.skipCustomerJourneysV3;
                        if (message.skipVisitorOccupancies != null && message.hasOwnProperty("skipVisitorOccupancies"))
                            object.skipVisitorOccupancies = message.skipVisitorOccupancies;
                        return object;
                    };
    
                    /**
                     * Converts this AggregateRawICADataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AggregateRawICADataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateRawICADataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateRawICADataRequest;
                })();
    
                v1.AggregateRawICADataResponse = (function() {
    
                    /**
                     * Properties of an AggregateRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IAggregateRawICADataResponse
                     */
    
                    /**
                     * Constructs a new AggregateRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AggregateRawICADataResponse.
                     * @implements IAggregateRawICADataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IAggregateRawICADataResponse=} [properties] Properties to set
                     */
                    function AggregateRawICADataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new AggregateRawICADataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AggregateRawICADataResponse} AggregateRawICADataResponse instance
                     */
                    AggregateRawICADataResponse.create = function create(properties) {
                        return new AggregateRawICADataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateRawICADataResponse message. Does not implicitly {@link palexy.streaming.v1.AggregateRawICADataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataResponse} message AggregateRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateRawICADataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateRawICADataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.AggregateRawICADataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IAggregateRawICADataResponse} message AggregateRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateRawICADataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateRawICADataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AggregateRawICADataResponse} AggregateRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateRawICADataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AggregateRawICADataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateRawICADataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AggregateRawICADataResponse} AggregateRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateRawICADataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateRawICADataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateRawICADataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateRawICADataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AggregateRawICADataResponse} AggregateRawICADataResponse
                     */
                    AggregateRawICADataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AggregateRawICADataResponse)
                            return object;
                        return new $root.palexy.streaming.v1.AggregateRawICADataResponse();
                    };
    
                    /**
                     * Creates a plain object from an AggregateRawICADataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.AggregateRawICADataResponse} message AggregateRawICADataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateRawICADataResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this AggregateRawICADataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AggregateRawICADataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateRawICADataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateRawICADataResponse;
                })();
    
                v1.BatchDeleteRawICAMetadataRequest = (function() {
    
                    /**
                     * Properties of a BatchDeleteRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDeleteRawICAMetadataRequest
                     * @property {number|null} [companyId] BatchDeleteRawICAMetadataRequest companyId
                     * @property {number|null} [storeId] BatchDeleteRawICAMetadataRequest storeId
                     * @property {string|null} [dateId] BatchDeleteRawICAMetadataRequest dateId
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] BatchDeleteRawICAMetadataRequest dateRange
                     * @property {number|null} [editorAccountId] BatchDeleteRawICAMetadataRequest editorAccountId
                     */
    
                    /**
                     * Constructs a new BatchDeleteRawICAMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDeleteRawICAMetadataRequest.
                     * @implements IBatchDeleteRawICAMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest=} [properties] Properties to set
                     */
                    function BatchDeleteRawICAMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteRawICAMetadataRequest companyId.
                     * @member {number|null|undefined} companyId
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.companyId = null;
    
                    /**
                     * BatchDeleteRawICAMetadataRequest storeId.
                     * @member {number|null|undefined} storeId
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.storeId = null;
    
                    /**
                     * BatchDeleteRawICAMetadataRequest dateId.
                     * @member {string|null|undefined} dateId
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.dateId = null;
    
                    /**
                     * BatchDeleteRawICAMetadataRequest dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.dateRange = null;
    
                    /**
                     * BatchDeleteRawICAMetadataRequest editorAccountId.
                     * @member {number} editorAccountId
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.editorAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * BatchDeleteRawICAMetadataRequest storeFilter.
                     * @member {"companyId"|"storeId"|undefined} storeFilter
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    Object.defineProperty(BatchDeleteRawICAMetadataRequest.prototype, "storeFilter", {
                        get: $util.oneOfGetter($oneOfFields = ["companyId", "storeId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * BatchDeleteRawICAMetadataRequest dateFilter.
                     * @member {"dateId"|"dateRange"|undefined} dateFilter
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     */
                    Object.defineProperty(BatchDeleteRawICAMetadataRequest.prototype, "dateFilter", {
                        get: $util.oneOfGetter($oneOfFields = ["dateId", "dateRange"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new BatchDeleteRawICAMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataRequest} BatchDeleteRawICAMetadataRequest instance
                     */
                    BatchDeleteRawICAMetadataRequest.create = function create(properties) {
                        return new BatchDeleteRawICAMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteRawICAMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDeleteRawICAMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest} message BatchDeleteRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteRawICAMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.editorAccountId != null && Object.hasOwnProperty.call(message, "editorAccountId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.editorAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteRawICAMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDeleteRawICAMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataRequest} message BatchDeleteRawICAMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteRawICAMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteRawICAMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataRequest} BatchDeleteRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteRawICAMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDeleteRawICAMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            case 4:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.editorAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteRawICAMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataRequest} BatchDeleteRawICAMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteRawICAMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteRawICAMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteRawICAMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            properties.storeFilter = 1;
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (properties.storeFilter === 1)
                                return "storeFilter: multiple values";
                            properties.storeFilter = 1;
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId")) {
                            properties.dateFilter = 1;
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            if (properties.dateFilter === 1)
                                return "dateFilter: multiple values";
                            properties.dateFilter = 1;
                            {
                                var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                                if (error)
                                    return "dateRange." + error;
                            }
                        }
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (!$util.isInteger(message.editorAccountId) && !(message.editorAccountId && $util.isInteger(message.editorAccountId.low) && $util.isInteger(message.editorAccountId.high)))
                                return "editorAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteRawICAMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataRequest} BatchDeleteRawICAMetadataRequest
                     */
                    BatchDeleteRawICAMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDeleteRawICAMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDeleteRawICAMetadataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.BatchDeleteRawICAMetadataRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        if (object.editorAccountId != null)
                            if ($util.Long)
                                (message.editorAccountId = $util.Long.fromValue(object.editorAccountId)).unsigned = false;
                            else if (typeof object.editorAccountId === "string")
                                message.editorAccountId = parseInt(object.editorAccountId, 10);
                            else if (typeof object.editorAccountId === "number")
                                message.editorAccountId = object.editorAccountId;
                            else if (typeof object.editorAccountId === "object")
                                message.editorAccountId = new $util.LongBits(object.editorAccountId.low >>> 0, object.editorAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteRawICAMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDeleteRawICAMetadataRequest} message BatchDeleteRawICAMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteRawICAMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.editorAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.editorAccountId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (options.oneofs)
                                object.storeFilter = "companyId";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (options.oneofs)
                                object.storeFilter = "storeId";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId")) {
                            object.dateId = message.dateId;
                            if (options.oneofs)
                                object.dateFilter = "dateId";
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                            if (options.oneofs)
                                object.dateFilter = "dateRange";
                        }
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (typeof message.editorAccountId === "number")
                                object.editorAccountId = options.longs === String ? String(message.editorAccountId) : message.editorAccountId;
                            else
                                object.editorAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.editorAccountId) : options.longs === Number ? new $util.LongBits(message.editorAccountId.low >>> 0, message.editorAccountId.high >>> 0).toNumber() : message.editorAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteRawICAMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteRawICAMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteRawICAMetadataRequest;
                })();
    
                v1.BatchDeleteRawICAMetadataResponse = (function() {
    
                    /**
                     * Properties of a BatchDeleteRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDeleteRawICAMetadataResponse
                     * @property {number|null} [affectedRowsCount] BatchDeleteRawICAMetadataResponse affectedRowsCount
                     */
    
                    /**
                     * Constructs a new BatchDeleteRawICAMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDeleteRawICAMetadataResponse.
                     * @implements IBatchDeleteRawICAMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataResponse=} [properties] Properties to set
                     */
                    function BatchDeleteRawICAMetadataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteRawICAMetadataResponse affectedRowsCount.
                     * @member {number} affectedRowsCount
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @instance
                     */
                    BatchDeleteRawICAMetadataResponse.prototype.affectedRowsCount = 0;
    
                    /**
                     * Creates a new BatchDeleteRawICAMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} BatchDeleteRawICAMetadataResponse instance
                     */
                    BatchDeleteRawICAMetadataResponse.create = function create(properties) {
                        return new BatchDeleteRawICAMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteRawICAMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.BatchDeleteRawICAMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataResponse} message BatchDeleteRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteRawICAMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.affectedRowsCount != null && Object.hasOwnProperty.call(message, "affectedRowsCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.affectedRowsCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteRawICAMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDeleteRawICAMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteRawICAMetadataResponse} message BatchDeleteRawICAMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteRawICAMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteRawICAMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} BatchDeleteRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteRawICAMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDeleteRawICAMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.affectedRowsCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteRawICAMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} BatchDeleteRawICAMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteRawICAMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteRawICAMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteRawICAMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            if (!$util.isInteger(message.affectedRowsCount))
                                return "affectedRowsCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteRawICAMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} BatchDeleteRawICAMetadataResponse
                     */
                    BatchDeleteRawICAMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDeleteRawICAMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDeleteRawICAMetadataResponse();
                        if (object.affectedRowsCount != null)
                            message.affectedRowsCount = object.affectedRowsCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteRawICAMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchDeleteRawICAMetadataResponse} message BatchDeleteRawICAMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteRawICAMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.affectedRowsCount = 0;
                        if (message.affectedRowsCount != null && message.hasOwnProperty("affectedRowsCount"))
                            object.affectedRowsCount = message.affectedRowsCount;
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteRawICAMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDeleteRawICAMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteRawICAMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteRawICAMetadataResponse;
                })();
    
                v1.LayoutService = (function() {
    
                    /**
                     * Constructs a new LayoutService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a LayoutService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function LayoutService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (LayoutService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = LayoutService;
    
                    /**
                     * Creates new LayoutService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.LayoutService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {LayoutService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    LayoutService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.LayoutService#listLayout}.
                     * @memberof palexy.streaming.v1.LayoutService
                     * @typedef ListLayoutCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListLayoutResponse} [response] ListLayoutResponse
                     */
    
                    /**
                     * Calls ListLayout.
                     * @function listLayout
                     * @memberof palexy.streaming.v1.LayoutService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutRequest} request ListLayoutRequest message or plain object
                     * @param {palexy.streaming.v1.LayoutService.ListLayoutCallback} callback Node-style callback called with the error, if any, and ListLayoutResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(LayoutService.prototype.listLayout = function listLayout(request, callback) {
                        return this.rpcCall(listLayout, $root.palexy.streaming.v1.ListLayoutRequest, $root.palexy.streaming.v1.ListLayoutResponse, request, callback);
                    }, "name", { value: "ListLayout" });
    
                    /**
                     * Calls ListLayout.
                     * @function listLayout
                     * @memberof palexy.streaming.v1.LayoutService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutRequest} request ListLayoutRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListLayoutResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.LayoutService#listLayoutCameraViews}.
                     * @memberof palexy.streaming.v1.LayoutService
                     * @typedef ListLayoutCameraViewsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListLayoutCameraViewsResponse} [response] ListLayoutCameraViewsResponse
                     */
    
                    /**
                     * Calls ListLayoutCameraViews.
                     * @function listLayoutCameraViews
                     * @memberof palexy.streaming.v1.LayoutService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest} request ListLayoutCameraViewsRequest message or plain object
                     * @param {palexy.streaming.v1.LayoutService.ListLayoutCameraViewsCallback} callback Node-style callback called with the error, if any, and ListLayoutCameraViewsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(LayoutService.prototype.listLayoutCameraViews = function listLayoutCameraViews(request, callback) {
                        return this.rpcCall(listLayoutCameraViews, $root.palexy.streaming.v1.ListLayoutCameraViewsRequest, $root.palexy.streaming.v1.ListLayoutCameraViewsResponse, request, callback);
                    }, "name", { value: "ListLayoutCameraViews" });
    
                    /**
                     * Calls ListLayoutCameraViews.
                     * @function listLayoutCameraViews
                     * @memberof palexy.streaming.v1.LayoutService
                     * @instance
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest} request ListLayoutCameraViewsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListLayoutCameraViewsResponse>} Promise
                     * @variation 2
                     */
    
                    return LayoutService;
                })();
    
                v1.Layout = (function() {
    
                    /**
                     * Properties of a Layout.
                     * @memberof palexy.streaming.v1
                     * @interface ILayout
                     * @property {number|null} [id] Layout id
                     * @property {string|null} [name] Layout name
                     * @property {number|null} [areaId] Layout areaId
                     * @property {number|null} [appliedDateId] Layout appliedDateId
                     */
    
                    /**
                     * Constructs a new Layout.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Layout.
                     * @implements ILayout
                     * @constructor
                     * @param {palexy.streaming.v1.ILayout=} [properties] Properties to set
                     */
                    function Layout(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Layout id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Layout
                     * @instance
                     */
                    Layout.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Layout name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Layout
                     * @instance
                     */
                    Layout.prototype.name = "";
    
                    /**
                     * Layout areaId.
                     * @member {number} areaId
                     * @memberof palexy.streaming.v1.Layout
                     * @instance
                     */
                    Layout.prototype.areaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Layout appliedDateId.
                     * @member {number} appliedDateId
                     * @memberof palexy.streaming.v1.Layout
                     * @instance
                     */
                    Layout.prototype.appliedDateId = 0;
    
                    /**
                     * Creates a new Layout instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {palexy.streaming.v1.ILayout=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Layout} Layout instance
                     */
                    Layout.create = function create(properties) {
                        return new Layout(properties);
                    };
    
                    /**
                     * Encodes the specified Layout message. Does not implicitly {@link palexy.streaming.v1.Layout.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {palexy.streaming.v1.ILayout} message Layout message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Layout.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.areaId);
                        if (message.appliedDateId != null && Object.hasOwnProperty.call(message, "appliedDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.appliedDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Layout message, length delimited. Does not implicitly {@link palexy.streaming.v1.Layout.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {palexy.streaming.v1.ILayout} message Layout message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Layout.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Layout message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Layout} Layout
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Layout.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Layout();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.areaId = reader.int64();
                                break;
                            case 4:
                                message.appliedDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Layout message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Layout} Layout
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Layout.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Layout message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Layout.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (!$util.isInteger(message.areaId) && !(message.areaId && $util.isInteger(message.areaId.low) && $util.isInteger(message.areaId.high)))
                                return "areaId: integer|Long expected";
                        if (message.appliedDateId != null && message.hasOwnProperty("appliedDateId"))
                            if (!$util.isInteger(message.appliedDateId))
                                return "appliedDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a Layout message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Layout} Layout
                     */
                    Layout.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Layout)
                            return object;
                        var message = new $root.palexy.streaming.v1.Layout();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.areaId != null)
                            if ($util.Long)
                                (message.areaId = $util.Long.fromValue(object.areaId)).unsigned = false;
                            else if (typeof object.areaId === "string")
                                message.areaId = parseInt(object.areaId, 10);
                            else if (typeof object.areaId === "number")
                                message.areaId = object.areaId;
                            else if (typeof object.areaId === "object")
                                message.areaId = new $util.LongBits(object.areaId.low >>> 0, object.areaId.high >>> 0).toNumber();
                        if (object.appliedDateId != null)
                            message.appliedDateId = object.appliedDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Layout message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Layout
                     * @static
                     * @param {palexy.streaming.v1.Layout} message Layout
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Layout.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.areaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.areaId = options.longs === String ? "0" : 0;
                            object.appliedDateId = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (typeof message.areaId === "number")
                                object.areaId = options.longs === String ? String(message.areaId) : message.areaId;
                            else
                                object.areaId = options.longs === String ? $util.Long.prototype.toString.call(message.areaId) : options.longs === Number ? new $util.LongBits(message.areaId.low >>> 0, message.areaId.high >>> 0).toNumber() : message.areaId;
                        if (message.appliedDateId != null && message.hasOwnProperty("appliedDateId"))
                            object.appliedDateId = message.appliedDateId;
                        return object;
                    };
    
                    /**
                     * Converts this Layout to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Layout
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Layout.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Layout;
                })();
    
                v1.ListLayoutRequest = (function() {
    
                    /**
                     * Properties of a ListLayoutRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutRequest
                     * @property {Array.<number>|null} [areaIds] ListLayoutRequest areaIds
                     * @property {google.protobuf.IInt32Value|null} [dateId] ListLayoutRequest dateId
                     */
    
                    /**
                     * Constructs a new ListLayoutRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutRequest.
                     * @implements IListLayoutRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutRequest=} [properties] Properties to set
                     */
                    function ListLayoutRequest(properties) {
                        this.areaIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLayoutRequest areaIds.
                     * @member {Array.<number>} areaIds
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @instance
                     */
                    ListLayoutRequest.prototype.areaIds = $util.emptyArray;
    
                    /**
                     * ListLayoutRequest dateId.
                     * @member {google.protobuf.IInt32Value|null|undefined} dateId
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @instance
                     */
                    ListLayoutRequest.prototype.dateId = null;
    
                    /**
                     * Creates a new ListLayoutRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutRequest} ListLayoutRequest instance
                     */
                    ListLayoutRequest.create = function create(properties) {
                        return new ListLayoutRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutRequest message. Does not implicitly {@link palexy.streaming.v1.ListLayoutRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutRequest} message ListLayoutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.areaIds != null && message.areaIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.areaIds.length; ++i)
                                writer.int64(message.areaIds[i]);
                            writer.ldelim();
                        }
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            $root.google.protobuf.Int32Value.encode(message.dateId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutRequest} message ListLayoutRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutRequest} ListLayoutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.areaIds && message.areaIds.length))
                                    message.areaIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.areaIds.push(reader.int64());
                                } else
                                    message.areaIds.push(reader.int64());
                                break;
                            case 2:
                                message.dateId = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutRequest} ListLayoutRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.areaIds != null && message.hasOwnProperty("areaIds")) {
                            if (!Array.isArray(message.areaIds))
                                return "areaIds: array expected";
                            for (var i = 0; i < message.areaIds.length; ++i)
                                if (!$util.isInteger(message.areaIds[i]) && !(message.areaIds[i] && $util.isInteger(message.areaIds[i].low) && $util.isInteger(message.areaIds[i].high)))
                                    return "areaIds: integer|Long[] expected";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId")) {
                            var error = $root.google.protobuf.Int32Value.verify(message.dateId);
                            if (error)
                                return "dateId." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutRequest} ListLayoutRequest
                     */
                    ListLayoutRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLayoutRequest();
                        if (object.areaIds) {
                            if (!Array.isArray(object.areaIds))
                                throw TypeError(".palexy.streaming.v1.ListLayoutRequest.areaIds: array expected");
                            message.areaIds = [];
                            for (var i = 0; i < object.areaIds.length; ++i)
                                if ($util.Long)
                                    (message.areaIds[i] = $util.Long.fromValue(object.areaIds[i])).unsigned = false;
                                else if (typeof object.areaIds[i] === "string")
                                    message.areaIds[i] = parseInt(object.areaIds[i], 10);
                                else if (typeof object.areaIds[i] === "number")
                                    message.areaIds[i] = object.areaIds[i];
                                else if (typeof object.areaIds[i] === "object")
                                    message.areaIds[i] = new $util.LongBits(object.areaIds[i].low >>> 0, object.areaIds[i].high >>> 0).toNumber();
                        }
                        if (object.dateId != null) {
                            if (typeof object.dateId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListLayoutRequest.dateId: object expected");
                            message.dateId = $root.google.protobuf.Int32Value.fromObject(object.dateId);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutRequest} message ListLayoutRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.areaIds = [];
                        if (options.defaults)
                            object.dateId = null;
                        if (message.areaIds && message.areaIds.length) {
                            object.areaIds = [];
                            for (var j = 0; j < message.areaIds.length; ++j)
                                if (typeof message.areaIds[j] === "number")
                                    object.areaIds[j] = options.longs === String ? String(message.areaIds[j]) : message.areaIds[j];
                                else
                                    object.areaIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.areaIds[j]) : options.longs === Number ? new $util.LongBits(message.areaIds[j].low >>> 0, message.areaIds[j].high >>> 0).toNumber() : message.areaIds[j];
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = $root.google.protobuf.Int32Value.toObject(message.dateId, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListLayoutRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutRequest;
                })();
    
                v1.ListLayoutResponse = (function() {
    
                    /**
                     * Properties of a ListLayoutResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutResponse
                     * @property {Array.<palexy.streaming.v1.ILayout>|null} [layouts] ListLayoutResponse layouts
                     */
    
                    /**
                     * Constructs a new ListLayoutResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutResponse.
                     * @implements IListLayoutResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutResponse=} [properties] Properties to set
                     */
                    function ListLayoutResponse(properties) {
                        this.layouts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLayoutResponse layouts.
                     * @member {Array.<palexy.streaming.v1.ILayout>} layouts
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @instance
                     */
                    ListLayoutResponse.prototype.layouts = $util.emptyArray;
    
                    /**
                     * Creates a new ListLayoutResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutResponse} ListLayoutResponse instance
                     */
                    ListLayoutResponse.create = function create(properties) {
                        return new ListLayoutResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutResponse message. Does not implicitly {@link palexy.streaming.v1.ListLayoutResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutResponse} message ListLayoutResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.layouts != null && message.layouts.length)
                            for (var i = 0; i < message.layouts.length; ++i)
                                $root.palexy.streaming.v1.Layout.encode(message.layouts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutResponse} message ListLayoutResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutResponse} ListLayoutResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.layouts && message.layouts.length))
                                    message.layouts = [];
                                message.layouts.push($root.palexy.streaming.v1.Layout.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutResponse} ListLayoutResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.layouts != null && message.hasOwnProperty("layouts")) {
                            if (!Array.isArray(message.layouts))
                                return "layouts: array expected";
                            for (var i = 0; i < message.layouts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Layout.verify(message.layouts[i]);
                                if (error)
                                    return "layouts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutResponse} ListLayoutResponse
                     */
                    ListLayoutResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLayoutResponse();
                        if (object.layouts) {
                            if (!Array.isArray(object.layouts))
                                throw TypeError(".palexy.streaming.v1.ListLayoutResponse.layouts: array expected");
                            message.layouts = [];
                            for (var i = 0; i < object.layouts.length; ++i) {
                                if (typeof object.layouts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListLayoutResponse.layouts: object expected");
                                message.layouts[i] = $root.palexy.streaming.v1.Layout.fromObject(object.layouts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutResponse} message ListLayoutResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.layouts = [];
                        if (message.layouts && message.layouts.length) {
                            object.layouts = [];
                            for (var j = 0; j < message.layouts.length; ++j)
                                object.layouts[j] = $root.palexy.streaming.v1.Layout.toObject(message.layouts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListLayoutResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutResponse;
                })();
    
                v1.LayoutCameraView = (function() {
    
                    /**
                     * Properties of a LayoutCameraView.
                     * @memberof palexy.streaming.v1
                     * @interface ILayoutCameraView
                     * @property {number|null} [id] LayoutCameraView id
                     * @property {number|null} [layoutId] LayoutCameraView layoutId
                     * @property {number|null} [cameraId] LayoutCameraView cameraId
                     * @property {number|null} [photoId] LayoutCameraView photoId
                     * @property {palexy.streaming.v1.ICameraPhoto|null} [image] LayoutCameraView image
                     */
    
                    /**
                     * Constructs a new LayoutCameraView.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a LayoutCameraView.
                     * @implements ILayoutCameraView
                     * @constructor
                     * @param {palexy.streaming.v1.ILayoutCameraView=} [properties] Properties to set
                     */
                    function LayoutCameraView(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * LayoutCameraView id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     */
                    LayoutCameraView.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutCameraView layoutId.
                     * @member {number} layoutId
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     */
                    LayoutCameraView.prototype.layoutId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutCameraView cameraId.
                     * @member {number} cameraId
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     */
                    LayoutCameraView.prototype.cameraId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutCameraView photoId.
                     * @member {number} photoId
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     */
                    LayoutCameraView.prototype.photoId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LayoutCameraView image.
                     * @member {palexy.streaming.v1.ICameraPhoto|null|undefined} image
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     */
                    LayoutCameraView.prototype.image = null;
    
                    /**
                     * Creates a new LayoutCameraView instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {palexy.streaming.v1.ILayoutCameraView=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.LayoutCameraView} LayoutCameraView instance
                     */
                    LayoutCameraView.create = function create(properties) {
                        return new LayoutCameraView(properties);
                    };
    
                    /**
                     * Encodes the specified LayoutCameraView message. Does not implicitly {@link palexy.streaming.v1.LayoutCameraView.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {palexy.streaming.v1.ILayoutCameraView} message LayoutCameraView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LayoutCameraView.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.layoutId != null && Object.hasOwnProperty.call(message, "layoutId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.layoutId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.cameraId);
                        if (message.photoId != null && Object.hasOwnProperty.call(message, "photoId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.photoId);
                        if (message.image != null && Object.hasOwnProperty.call(message, "image"))
                            $root.palexy.streaming.v1.CameraPhoto.encode(message.image, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified LayoutCameraView message, length delimited. Does not implicitly {@link palexy.streaming.v1.LayoutCameraView.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {palexy.streaming.v1.ILayoutCameraView} message LayoutCameraView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LayoutCameraView.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a LayoutCameraView message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.LayoutCameraView} LayoutCameraView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LayoutCameraView.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.LayoutCameraView();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.layoutId = reader.int64();
                                break;
                            case 3:
                                message.cameraId = reader.int64();
                                break;
                            case 4:
                                message.photoId = reader.int64();
                                break;
                            case 5:
                                message.image = $root.palexy.streaming.v1.CameraPhoto.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a LayoutCameraView message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.LayoutCameraView} LayoutCameraView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LayoutCameraView.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a LayoutCameraView message.
                     * @function verify
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LayoutCameraView.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (!$util.isInteger(message.layoutId) && !(message.layoutId && $util.isInteger(message.layoutId.low) && $util.isInteger(message.layoutId.high)))
                                return "layoutId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isInteger(message.cameraId) && !(message.cameraId && $util.isInteger(message.cameraId.low) && $util.isInteger(message.cameraId.high)))
                                return "cameraId: integer|Long expected";
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (!$util.isInteger(message.photoId) && !(message.photoId && $util.isInteger(message.photoId.low) && $util.isInteger(message.photoId.high)))
                                return "photoId: integer|Long expected";
                        if (message.image != null && message.hasOwnProperty("image")) {
                            var error = $root.palexy.streaming.v1.CameraPhoto.verify(message.image);
                            if (error)
                                return "image." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a LayoutCameraView message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.LayoutCameraView} LayoutCameraView
                     */
                    LayoutCameraView.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.LayoutCameraView)
                            return object;
                        var message = new $root.palexy.streaming.v1.LayoutCameraView();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.layoutId != null)
                            if ($util.Long)
                                (message.layoutId = $util.Long.fromValue(object.layoutId)).unsigned = false;
                            else if (typeof object.layoutId === "string")
                                message.layoutId = parseInt(object.layoutId, 10);
                            else if (typeof object.layoutId === "number")
                                message.layoutId = object.layoutId;
                            else if (typeof object.layoutId === "object")
                                message.layoutId = new $util.LongBits(object.layoutId.low >>> 0, object.layoutId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            if ($util.Long)
                                (message.cameraId = $util.Long.fromValue(object.cameraId)).unsigned = false;
                            else if (typeof object.cameraId === "string")
                                message.cameraId = parseInt(object.cameraId, 10);
                            else if (typeof object.cameraId === "number")
                                message.cameraId = object.cameraId;
                            else if (typeof object.cameraId === "object")
                                message.cameraId = new $util.LongBits(object.cameraId.low >>> 0, object.cameraId.high >>> 0).toNumber();
                        if (object.photoId != null)
                            if ($util.Long)
                                (message.photoId = $util.Long.fromValue(object.photoId)).unsigned = false;
                            else if (typeof object.photoId === "string")
                                message.photoId = parseInt(object.photoId, 10);
                            else if (typeof object.photoId === "number")
                                message.photoId = object.photoId;
                            else if (typeof object.photoId === "object")
                                message.photoId = new $util.LongBits(object.photoId.low >>> 0, object.photoId.high >>> 0).toNumber();
                        if (object.image != null) {
                            if (typeof object.image !== "object")
                                throw TypeError(".palexy.streaming.v1.LayoutCameraView.image: object expected");
                            message.image = $root.palexy.streaming.v1.CameraPhoto.fromObject(object.image);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a LayoutCameraView message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @static
                     * @param {palexy.streaming.v1.LayoutCameraView} message LayoutCameraView
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LayoutCameraView.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.layoutId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.layoutId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.cameraId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.cameraId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.photoId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.photoId = options.longs === String ? "0" : 0;
                            object.image = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (typeof message.layoutId === "number")
                                object.layoutId = options.longs === String ? String(message.layoutId) : message.layoutId;
                            else
                                object.layoutId = options.longs === String ? $util.Long.prototype.toString.call(message.layoutId) : options.longs === Number ? new $util.LongBits(message.layoutId.low >>> 0, message.layoutId.high >>> 0).toNumber() : message.layoutId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (typeof message.cameraId === "number")
                                object.cameraId = options.longs === String ? String(message.cameraId) : message.cameraId;
                            else
                                object.cameraId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraId) : options.longs === Number ? new $util.LongBits(message.cameraId.low >>> 0, message.cameraId.high >>> 0).toNumber() : message.cameraId;
                        if (message.photoId != null && message.hasOwnProperty("photoId"))
                            if (typeof message.photoId === "number")
                                object.photoId = options.longs === String ? String(message.photoId) : message.photoId;
                            else
                                object.photoId = options.longs === String ? $util.Long.prototype.toString.call(message.photoId) : options.longs === Number ? new $util.LongBits(message.photoId.low >>> 0, message.photoId.high >>> 0).toNumber() : message.photoId;
                        if (message.image != null && message.hasOwnProperty("image"))
                            object.image = $root.palexy.streaming.v1.CameraPhoto.toObject(message.image, options);
                        return object;
                    };
    
                    /**
                     * Converts this LayoutCameraView to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.LayoutCameraView
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LayoutCameraView.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return LayoutCameraView;
                })();
    
                v1.ListLayoutCameraViewsRequest = (function() {
    
                    /**
                     * Properties of a ListLayoutCameraViewsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutCameraViewsRequest
                     * @property {number|null} [layoutId] ListLayoutCameraViewsRequest layoutId
                     * @property {boolean|null} [includeImage] ListLayoutCameraViewsRequest includeImage
                     */
    
                    /**
                     * Constructs a new ListLayoutCameraViewsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutCameraViewsRequest.
                     * @implements IListLayoutCameraViewsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest=} [properties] Properties to set
                     */
                    function ListLayoutCameraViewsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLayoutCameraViewsRequest layoutId.
                     * @member {number} layoutId
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @instance
                     */
                    ListLayoutCameraViewsRequest.prototype.layoutId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListLayoutCameraViewsRequest includeImage.
                     * @member {boolean} includeImage
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @instance
                     */
                    ListLayoutCameraViewsRequest.prototype.includeImage = false;
    
                    /**
                     * Creates a new ListLayoutCameraViewsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsRequest} ListLayoutCameraViewsRequest instance
                     */
                    ListLayoutCameraViewsRequest.create = function create(properties) {
                        return new ListLayoutCameraViewsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutCameraViewsRequest message. Does not implicitly {@link palexy.streaming.v1.ListLayoutCameraViewsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest} message ListLayoutCameraViewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutCameraViewsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.layoutId != null && Object.hasOwnProperty.call(message, "layoutId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.layoutId);
                        if (message.includeImage != null && Object.hasOwnProperty.call(message, "includeImage"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeImage);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutCameraViewsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutCameraViewsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsRequest} message ListLayoutCameraViewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutCameraViewsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutCameraViewsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsRequest} ListLayoutCameraViewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutCameraViewsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutCameraViewsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.layoutId = reader.int64();
                                break;
                            case 2:
                                message.includeImage = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutCameraViewsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsRequest} ListLayoutCameraViewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutCameraViewsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutCameraViewsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutCameraViewsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (!$util.isInteger(message.layoutId) && !(message.layoutId && $util.isInteger(message.layoutId.low) && $util.isInteger(message.layoutId.high)))
                                return "layoutId: integer|Long expected";
                        if (message.includeImage != null && message.hasOwnProperty("includeImage"))
                            if (typeof message.includeImage !== "boolean")
                                return "includeImage: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutCameraViewsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsRequest} ListLayoutCameraViewsRequest
                     */
                    ListLayoutCameraViewsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutCameraViewsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLayoutCameraViewsRequest();
                        if (object.layoutId != null)
                            if ($util.Long)
                                (message.layoutId = $util.Long.fromValue(object.layoutId)).unsigned = false;
                            else if (typeof object.layoutId === "string")
                                message.layoutId = parseInt(object.layoutId, 10);
                            else if (typeof object.layoutId === "number")
                                message.layoutId = object.layoutId;
                            else if (typeof object.layoutId === "object")
                                message.layoutId = new $util.LongBits(object.layoutId.low >>> 0, object.layoutId.high >>> 0).toNumber();
                        if (object.includeImage != null)
                            message.includeImage = Boolean(object.includeImage);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutCameraViewsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutCameraViewsRequest} message ListLayoutCameraViewsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutCameraViewsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.layoutId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.layoutId = options.longs === String ? "0" : 0;
                            object.includeImage = false;
                        }
                        if (message.layoutId != null && message.hasOwnProperty("layoutId"))
                            if (typeof message.layoutId === "number")
                                object.layoutId = options.longs === String ? String(message.layoutId) : message.layoutId;
                            else
                                object.layoutId = options.longs === String ? $util.Long.prototype.toString.call(message.layoutId) : options.longs === Number ? new $util.LongBits(message.layoutId.low >>> 0, message.layoutId.high >>> 0).toNumber() : message.layoutId;
                        if (message.includeImage != null && message.hasOwnProperty("includeImage"))
                            object.includeImage = message.includeImage;
                        return object;
                    };
    
                    /**
                     * Converts this ListLayoutCameraViewsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutCameraViewsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutCameraViewsRequest;
                })();
    
                v1.ListLayoutCameraViewsResponse = (function() {
    
                    /**
                     * Properties of a ListLayoutCameraViewsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListLayoutCameraViewsResponse
                     * @property {Array.<palexy.streaming.v1.ILayoutCameraView>|null} [views] ListLayoutCameraViewsResponse views
                     */
    
                    /**
                     * Constructs a new ListLayoutCameraViewsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLayoutCameraViewsResponse.
                     * @implements IListLayoutCameraViewsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsResponse=} [properties] Properties to set
                     */
                    function ListLayoutCameraViewsResponse(properties) {
                        this.views = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLayoutCameraViewsResponse views.
                     * @member {Array.<palexy.streaming.v1.ILayoutCameraView>} views
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @instance
                     */
                    ListLayoutCameraViewsResponse.prototype.views = $util.emptyArray;
    
                    /**
                     * Creates a new ListLayoutCameraViewsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsResponse} ListLayoutCameraViewsResponse instance
                     */
                    ListLayoutCameraViewsResponse.create = function create(properties) {
                        return new ListLayoutCameraViewsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListLayoutCameraViewsResponse message. Does not implicitly {@link palexy.streaming.v1.ListLayoutCameraViewsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsResponse} message ListLayoutCameraViewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutCameraViewsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.views != null && message.views.length)
                            for (var i = 0; i < message.views.length; ++i)
                                $root.palexy.streaming.v1.LayoutCameraView.encode(message.views[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLayoutCameraViewsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLayoutCameraViewsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLayoutCameraViewsResponse} message ListLayoutCameraViewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLayoutCameraViewsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLayoutCameraViewsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsResponse} ListLayoutCameraViewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutCameraViewsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLayoutCameraViewsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.views && message.views.length))
                                    message.views = [];
                                message.views.push($root.palexy.streaming.v1.LayoutCameraView.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLayoutCameraViewsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsResponse} ListLayoutCameraViewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLayoutCameraViewsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLayoutCameraViewsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLayoutCameraViewsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.views != null && message.hasOwnProperty("views")) {
                            if (!Array.isArray(message.views))
                                return "views: array expected";
                            for (var i = 0; i < message.views.length; ++i) {
                                var error = $root.palexy.streaming.v1.LayoutCameraView.verify(message.views[i]);
                                if (error)
                                    return "views." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListLayoutCameraViewsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLayoutCameraViewsResponse} ListLayoutCameraViewsResponse
                     */
                    ListLayoutCameraViewsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLayoutCameraViewsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLayoutCameraViewsResponse();
                        if (object.views) {
                            if (!Array.isArray(object.views))
                                throw TypeError(".palexy.streaming.v1.ListLayoutCameraViewsResponse.views: array expected");
                            message.views = [];
                            for (var i = 0; i < object.views.length; ++i) {
                                if (typeof object.views[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListLayoutCameraViewsResponse.views: object expected");
                                message.views[i] = $root.palexy.streaming.v1.LayoutCameraView.fromObject(object.views[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLayoutCameraViewsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListLayoutCameraViewsResponse} message ListLayoutCameraViewsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLayoutCameraViewsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.views = [];
                        if (message.views && message.views.length) {
                            object.views = [];
                            for (var j = 0; j < message.views.length; ++j)
                                object.views[j] = $root.palexy.streaming.v1.LayoutCameraView.toObject(message.views[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListLayoutCameraViewsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLayoutCameraViewsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLayoutCameraViewsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLayoutCameraViewsResponse;
                })();
    
                v1.EmailService = (function() {
    
                    /**
                     * Constructs a new EmailService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EmailService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function EmailService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (EmailService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = EmailService;
    
                    /**
                     * Creates new EmailService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.EmailService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {EmailService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    EmailService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmailService#sendSimpleMessage}.
                     * @memberof palexy.streaming.v1.EmailService
                     * @typedef SendSimpleMessageCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SendSimpleMessageResponse} [response] SendSimpleMessageResponse
                     */
    
                    /**
                     * Calls SendSimpleMessage.
                     * @function sendSimpleMessage
                     * @memberof palexy.streaming.v1.EmailService
                     * @instance
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest} request SendSimpleMessageRequest message or plain object
                     * @param {palexy.streaming.v1.EmailService.SendSimpleMessageCallback} callback Node-style callback called with the error, if any, and SendSimpleMessageResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmailService.prototype.sendSimpleMessage = function sendSimpleMessage(request, callback) {
                        return this.rpcCall(sendSimpleMessage, $root.palexy.streaming.v1.SendSimpleMessageRequest, $root.palexy.streaming.v1.SendSimpleMessageResponse, request, callback);
                    }, "name", { value: "SendSimpleMessage" });
    
                    /**
                     * Calls SendSimpleMessage.
                     * @function sendSimpleMessage
                     * @memberof palexy.streaming.v1.EmailService
                     * @instance
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest} request SendSimpleMessageRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SendSimpleMessageResponse>} Promise
                     * @variation 2
                     */
    
                    return EmailService;
                })();
    
                v1.SendSimpleMessageRequest = (function() {
    
                    /**
                     * Properties of a SendSimpleMessageRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendSimpleMessageRequest
                     * @property {Array.<string>|null} [to] SendSimpleMessageRequest to
                     * @property {string|null} [subject] SendSimpleMessageRequest subject
                     * @property {string|null} [message] SendSimpleMessageRequest message
                     */
    
                    /**
                     * Constructs a new SendSimpleMessageRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendSimpleMessageRequest.
                     * @implements ISendSimpleMessageRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest=} [properties] Properties to set
                     */
                    function SendSimpleMessageRequest(properties) {
                        this.to = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendSimpleMessageRequest to.
                     * @member {Array.<string>} to
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @instance
                     */
                    SendSimpleMessageRequest.prototype.to = $util.emptyArray;
    
                    /**
                     * SendSimpleMessageRequest subject.
                     * @member {string} subject
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @instance
                     */
                    SendSimpleMessageRequest.prototype.subject = "";
    
                    /**
                     * SendSimpleMessageRequest message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @instance
                     */
                    SendSimpleMessageRequest.prototype.message = "";
    
                    /**
                     * Creates a new SendSimpleMessageRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendSimpleMessageRequest} SendSimpleMessageRequest instance
                     */
                    SendSimpleMessageRequest.create = function create(properties) {
                        return new SendSimpleMessageRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendSimpleMessageRequest message. Does not implicitly {@link palexy.streaming.v1.SendSimpleMessageRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest} message SendSimpleMessageRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendSimpleMessageRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.to != null && message.to.length)
                            for (var i = 0; i < message.to.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.to[i]);
                        if (message.subject != null && Object.hasOwnProperty.call(message, "subject"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.subject);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendSimpleMessageRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendSimpleMessageRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageRequest} message SendSimpleMessageRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendSimpleMessageRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendSimpleMessageRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendSimpleMessageRequest} SendSimpleMessageRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendSimpleMessageRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendSimpleMessageRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.to && message.to.length))
                                    message.to = [];
                                message.to.push(reader.string());
                                break;
                            case 2:
                                message.subject = reader.string();
                                break;
                            case 3:
                                message.message = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendSimpleMessageRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendSimpleMessageRequest} SendSimpleMessageRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendSimpleMessageRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendSimpleMessageRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendSimpleMessageRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.to != null && message.hasOwnProperty("to")) {
                            if (!Array.isArray(message.to))
                                return "to: array expected";
                            for (var i = 0; i < message.to.length; ++i)
                                if (!$util.isString(message.to[i]))
                                    return "to: string[] expected";
                        }
                        if (message.subject != null && message.hasOwnProperty("subject"))
                            if (!$util.isString(message.subject))
                                return "subject: string expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendSimpleMessageRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendSimpleMessageRequest} SendSimpleMessageRequest
                     */
                    SendSimpleMessageRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendSimpleMessageRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendSimpleMessageRequest();
                        if (object.to) {
                            if (!Array.isArray(object.to))
                                throw TypeError(".palexy.streaming.v1.SendSimpleMessageRequest.to: array expected");
                            message.to = [];
                            for (var i = 0; i < object.to.length; ++i)
                                message.to[i] = String(object.to[i]);
                        }
                        if (object.subject != null)
                            message.subject = String(object.subject);
                        if (object.message != null)
                            message.message = String(object.message);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendSimpleMessageRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @static
                     * @param {palexy.streaming.v1.SendSimpleMessageRequest} message SendSimpleMessageRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendSimpleMessageRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.to = [];
                        if (options.defaults) {
                            object.subject = "";
                            object.message = "";
                        }
                        if (message.to && message.to.length) {
                            object.to = [];
                            for (var j = 0; j < message.to.length; ++j)
                                object.to[j] = message.to[j];
                        }
                        if (message.subject != null && message.hasOwnProperty("subject"))
                            object.subject = message.subject;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        return object;
                    };
    
                    /**
                     * Converts this SendSimpleMessageRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendSimpleMessageRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendSimpleMessageRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendSimpleMessageRequest;
                })();
    
                v1.SendSimpleMessageResponse = (function() {
    
                    /**
                     * Properties of a SendSimpleMessageResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISendSimpleMessageResponse
                     * @property {number|null} [statusCode] SendSimpleMessageResponse statusCode
                     */
    
                    /**
                     * Constructs a new SendSimpleMessageResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendSimpleMessageResponse.
                     * @implements ISendSimpleMessageResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISendSimpleMessageResponse=} [properties] Properties to set
                     */
                    function SendSimpleMessageResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendSimpleMessageResponse statusCode.
                     * @member {number} statusCode
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @instance
                     */
                    SendSimpleMessageResponse.prototype.statusCode = 0;
    
                    /**
                     * Creates a new SendSimpleMessageResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendSimpleMessageResponse} SendSimpleMessageResponse instance
                     */
                    SendSimpleMessageResponse.create = function create(properties) {
                        return new SendSimpleMessageResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SendSimpleMessageResponse message. Does not implicitly {@link palexy.streaming.v1.SendSimpleMessageResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageResponse} message SendSimpleMessageResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendSimpleMessageResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.statusCode != null && Object.hasOwnProperty.call(message, "statusCode"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.statusCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendSimpleMessageResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendSimpleMessageResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {palexy.streaming.v1.ISendSimpleMessageResponse} message SendSimpleMessageResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendSimpleMessageResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendSimpleMessageResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendSimpleMessageResponse} SendSimpleMessageResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendSimpleMessageResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendSimpleMessageResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.statusCode = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendSimpleMessageResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendSimpleMessageResponse} SendSimpleMessageResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendSimpleMessageResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendSimpleMessageResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendSimpleMessageResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                            if (!$util.isInteger(message.statusCode))
                                return "statusCode: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendSimpleMessageResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendSimpleMessageResponse} SendSimpleMessageResponse
                     */
                    SendSimpleMessageResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendSimpleMessageResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendSimpleMessageResponse();
                        if (object.statusCode != null)
                            message.statusCode = object.statusCode | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendSimpleMessageResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @static
                     * @param {palexy.streaming.v1.SendSimpleMessageResponse} message SendSimpleMessageResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendSimpleMessageResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.statusCode = 0;
                        if (message.statusCode != null && message.hasOwnProperty("statusCode"))
                            object.statusCode = message.statusCode;
                        return object;
                    };
    
                    /**
                     * Converts this SendSimpleMessageResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendSimpleMessageResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendSimpleMessageResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendSimpleMessageResponse;
                })();
    
                /**
                 * OrderType enum.
                 * @name palexy.streaming.v1.OrderType
                 * @enum {number}
                 * @property {number} ORDER_TYPE_UNKNOWN=0 ORDER_TYPE_UNKNOWN value
                 * @property {number} ASC=1 ASC value
                 * @property {number} DESC=2 DESC value
                 * @property {number} WEIGHTED=3 WEIGHTED value
                 */
                v1.OrderType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "ORDER_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "ASC"] = 1;
                    values[valuesById[2] = "DESC"] = 2;
                    values[valuesById[3] = "WEIGHTED"] = 3;
                    return values;
                })();
    
                v1.MergingStatisticService = (function() {
    
                    /**
                     * Constructs a new MergingStatisticService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingStatisticService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function MergingStatisticService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (MergingStatisticService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MergingStatisticService;
    
                    /**
                     * Creates new MergingStatisticService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingStatisticService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {MergingStatisticService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    MergingStatisticService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MergingStatisticService#addMergingStatistic}.
                     * @memberof palexy.streaming.v1.MergingStatisticService
                     * @typedef AddMergingStatisticCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MergingStatisticResponse} [response] MergingStatisticResponse
                     */
    
                    /**
                     * Calls AddMergingStatistic.
                     * @function addMergingStatistic
                     * @memberof palexy.streaming.v1.MergingStatisticService
                     * @instance
                     * @param {palexy.streaming.v1.IMergingStatisticRequest} request MergingStatisticRequest message or plain object
                     * @param {palexy.streaming.v1.MergingStatisticService.AddMergingStatisticCallback} callback Node-style callback called with the error, if any, and MergingStatisticResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MergingStatisticService.prototype.addMergingStatistic = function addMergingStatistic(request, callback) {
                        return this.rpcCall(addMergingStatistic, $root.palexy.streaming.v1.MergingStatisticRequest, $root.palexy.streaming.v1.MergingStatisticResponse, request, callback);
                    }, "name", { value: "AddMergingStatistic" });
    
                    /**
                     * Calls AddMergingStatistic.
                     * @function addMergingStatistic
                     * @memberof palexy.streaming.v1.MergingStatisticService
                     * @instance
                     * @param {palexy.streaming.v1.IMergingStatisticRequest} request MergingStatisticRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MergingStatisticResponse>} Promise
                     * @variation 2
                     */
    
                    return MergingStatisticService;
                })();
    
                v1.InOutStatistic = (function() {
    
                    /**
                     * Properties of an InOutStatistic.
                     * @memberof palexy.streaming.v1
                     * @interface IInOutStatistic
                     * @property {string|null} [heuristicName] InOutStatistic heuristicName
                     * @property {number|null} [inNumTracklet] InOutStatistic inNumTracklet
                     * @property {number|null} [inNumBb] InOutStatistic inNumBb
                     * @property {number|null} [inBbPerTracklet] InOutStatistic inBbPerTracklet
                     * @property {number|null} [in_25bbPerTracklet] InOutStatistic in_25bbPerTracklet
                     * @property {number|null} [in_50bbPerTracklet] InOutStatistic in_50bbPerTracklet
                     * @property {number|null} [in_75bbPerTracklet] InOutStatistic in_75bbPerTracklet
                     * @property {number|null} [inTimePerTracklet] InOutStatistic inTimePerTracklet
                     * @property {number|null} [outNumTracklet] InOutStatistic outNumTracklet
                     * @property {number|null} [outNumBb] InOutStatistic outNumBb
                     * @property {number|null} [outBbPerTracklet] InOutStatistic outBbPerTracklet
                     * @property {number|null} [out_25bbPerTracklet] InOutStatistic out_25bbPerTracklet
                     * @property {number|null} [out_50bbPerTracklet] InOutStatistic out_50bbPerTracklet
                     * @property {number|null} [out_75bbPerTracklet] InOutStatistic out_75bbPerTracklet
                     * @property {number|null} [outTimePerTracklet] InOutStatistic outTimePerTracklet
                     * @property {number|null} [processingTime] InOutStatistic processingTime
                     */
    
                    /**
                     * Constructs a new InOutStatistic.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an InOutStatistic.
                     * @implements IInOutStatistic
                     * @constructor
                     * @param {palexy.streaming.v1.IInOutStatistic=} [properties] Properties to set
                     */
                    function InOutStatistic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * InOutStatistic heuristicName.
                     * @member {string} heuristicName
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.heuristicName = "";
    
                    /**
                     * InOutStatistic inNumTracklet.
                     * @member {number} inNumTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.inNumTracklet = 0;
    
                    /**
                     * InOutStatistic inNumBb.
                     * @member {number} inNumBb
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.inNumBb = 0;
    
                    /**
                     * InOutStatistic inBbPerTracklet.
                     * @member {number} inBbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.inBbPerTracklet = 0;
    
                    /**
                     * InOutStatistic in_25bbPerTracklet.
                     * @member {number} in_25bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.in_25bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic in_50bbPerTracklet.
                     * @member {number} in_50bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.in_50bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic in_75bbPerTracklet.
                     * @member {number} in_75bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.in_75bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic inTimePerTracklet.
                     * @member {number} inTimePerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.inTimePerTracklet = 0;
    
                    /**
                     * InOutStatistic outNumTracklet.
                     * @member {number} outNumTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.outNumTracklet = 0;
    
                    /**
                     * InOutStatistic outNumBb.
                     * @member {number} outNumBb
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.outNumBb = 0;
    
                    /**
                     * InOutStatistic outBbPerTracklet.
                     * @member {number} outBbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.outBbPerTracklet = 0;
    
                    /**
                     * InOutStatistic out_25bbPerTracklet.
                     * @member {number} out_25bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.out_25bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic out_50bbPerTracklet.
                     * @member {number} out_50bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.out_50bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic out_75bbPerTracklet.
                     * @member {number} out_75bbPerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.out_75bbPerTracklet = 0;
    
                    /**
                     * InOutStatistic outTimePerTracklet.
                     * @member {number} outTimePerTracklet
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.outTimePerTracklet = 0;
    
                    /**
                     * InOutStatistic processingTime.
                     * @member {number} processingTime
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     */
                    InOutStatistic.prototype.processingTime = 0;
    
                    /**
                     * Creates a new InOutStatistic instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {palexy.streaming.v1.IInOutStatistic=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.InOutStatistic} InOutStatistic instance
                     */
                    InOutStatistic.create = function create(properties) {
                        return new InOutStatistic(properties);
                    };
    
                    /**
                     * Encodes the specified InOutStatistic message. Does not implicitly {@link palexy.streaming.v1.InOutStatistic.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {palexy.streaming.v1.IInOutStatistic} message InOutStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InOutStatistic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.heuristicName != null && Object.hasOwnProperty.call(message, "heuristicName"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.heuristicName);
                        if (message.inNumTracklet != null && Object.hasOwnProperty.call(message, "inNumTracklet"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.inNumTracklet);
                        if (message.inNumBb != null && Object.hasOwnProperty.call(message, "inNumBb"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.inNumBb);
                        if (message.inBbPerTracklet != null && Object.hasOwnProperty.call(message, "inBbPerTracklet"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.inBbPerTracklet);
                        if (message.in_25bbPerTracklet != null && Object.hasOwnProperty.call(message, "in_25bbPerTracklet"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.in_25bbPerTracklet);
                        if (message.in_50bbPerTracklet != null && Object.hasOwnProperty.call(message, "in_50bbPerTracklet"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.in_50bbPerTracklet);
                        if (message.in_75bbPerTracklet != null && Object.hasOwnProperty.call(message, "in_75bbPerTracklet"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.in_75bbPerTracklet);
                        if (message.inTimePerTracklet != null && Object.hasOwnProperty.call(message, "inTimePerTracklet"))
                            writer.uint32(/* id 8, wireType 5 =*/69).float(message.inTimePerTracklet);
                        if (message.outNumTracklet != null && Object.hasOwnProperty.call(message, "outNumTracklet"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.outNumTracklet);
                        if (message.outNumBb != null && Object.hasOwnProperty.call(message, "outNumBb"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.outNumBb);
                        if (message.outBbPerTracklet != null && Object.hasOwnProperty.call(message, "outBbPerTracklet"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.outBbPerTracklet);
                        if (message.out_25bbPerTracklet != null && Object.hasOwnProperty.call(message, "out_25bbPerTracklet"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.out_25bbPerTracklet);
                        if (message.out_50bbPerTracklet != null && Object.hasOwnProperty.call(message, "out_50bbPerTracklet"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.out_50bbPerTracklet);
                        if (message.out_75bbPerTracklet != null && Object.hasOwnProperty.call(message, "out_75bbPerTracklet"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.out_75bbPerTracklet);
                        if (message.outTimePerTracklet != null && Object.hasOwnProperty.call(message, "outTimePerTracklet"))
                            writer.uint32(/* id 15, wireType 5 =*/125).float(message.outTimePerTracklet);
                        if (message.processingTime != null && Object.hasOwnProperty.call(message, "processingTime"))
                            writer.uint32(/* id 16, wireType 5 =*/133).float(message.processingTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified InOutStatistic message, length delimited. Does not implicitly {@link palexy.streaming.v1.InOutStatistic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {palexy.streaming.v1.IInOutStatistic} message InOutStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InOutStatistic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an InOutStatistic message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.InOutStatistic} InOutStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InOutStatistic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.InOutStatistic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.heuristicName = reader.string();
                                break;
                            case 2:
                                message.inNumTracklet = reader.int32();
                                break;
                            case 3:
                                message.inNumBb = reader.int32();
                                break;
                            case 4:
                                message.inBbPerTracklet = reader.float();
                                break;
                            case 5:
                                message.in_25bbPerTracklet = reader.int32();
                                break;
                            case 6:
                                message.in_50bbPerTracklet = reader.int32();
                                break;
                            case 7:
                                message.in_75bbPerTracklet = reader.int32();
                                break;
                            case 8:
                                message.inTimePerTracklet = reader.float();
                                break;
                            case 9:
                                message.outNumTracklet = reader.int32();
                                break;
                            case 10:
                                message.outNumBb = reader.int32();
                                break;
                            case 11:
                                message.outBbPerTracklet = reader.float();
                                break;
                            case 12:
                                message.out_25bbPerTracklet = reader.int32();
                                break;
                            case 13:
                                message.out_50bbPerTracklet = reader.int32();
                                break;
                            case 14:
                                message.out_75bbPerTracklet = reader.int32();
                                break;
                            case 15:
                                message.outTimePerTracklet = reader.float();
                                break;
                            case 16:
                                message.processingTime = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an InOutStatistic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.InOutStatistic} InOutStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InOutStatistic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an InOutStatistic message.
                     * @function verify
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    InOutStatistic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.heuristicName != null && message.hasOwnProperty("heuristicName"))
                            if (!$util.isString(message.heuristicName))
                                return "heuristicName: string expected";
                        if (message.inNumTracklet != null && message.hasOwnProperty("inNumTracklet"))
                            if (!$util.isInteger(message.inNumTracklet))
                                return "inNumTracklet: integer expected";
                        if (message.inNumBb != null && message.hasOwnProperty("inNumBb"))
                            if (!$util.isInteger(message.inNumBb))
                                return "inNumBb: integer expected";
                        if (message.inBbPerTracklet != null && message.hasOwnProperty("inBbPerTracklet"))
                            if (typeof message.inBbPerTracklet !== "number")
                                return "inBbPerTracklet: number expected";
                        if (message.in_25bbPerTracklet != null && message.hasOwnProperty("in_25bbPerTracklet"))
                            if (!$util.isInteger(message.in_25bbPerTracklet))
                                return "in_25bbPerTracklet: integer expected";
                        if (message.in_50bbPerTracklet != null && message.hasOwnProperty("in_50bbPerTracklet"))
                            if (!$util.isInteger(message.in_50bbPerTracklet))
                                return "in_50bbPerTracklet: integer expected";
                        if (message.in_75bbPerTracklet != null && message.hasOwnProperty("in_75bbPerTracklet"))
                            if (!$util.isInteger(message.in_75bbPerTracklet))
                                return "in_75bbPerTracklet: integer expected";
                        if (message.inTimePerTracklet != null && message.hasOwnProperty("inTimePerTracklet"))
                            if (typeof message.inTimePerTracklet !== "number")
                                return "inTimePerTracklet: number expected";
                        if (message.outNumTracklet != null && message.hasOwnProperty("outNumTracklet"))
                            if (!$util.isInteger(message.outNumTracklet))
                                return "outNumTracklet: integer expected";
                        if (message.outNumBb != null && message.hasOwnProperty("outNumBb"))
                            if (!$util.isInteger(message.outNumBb))
                                return "outNumBb: integer expected";
                        if (message.outBbPerTracklet != null && message.hasOwnProperty("outBbPerTracklet"))
                            if (typeof message.outBbPerTracklet !== "number")
                                return "outBbPerTracklet: number expected";
                        if (message.out_25bbPerTracklet != null && message.hasOwnProperty("out_25bbPerTracklet"))
                            if (!$util.isInteger(message.out_25bbPerTracklet))
                                return "out_25bbPerTracklet: integer expected";
                        if (message.out_50bbPerTracklet != null && message.hasOwnProperty("out_50bbPerTracklet"))
                            if (!$util.isInteger(message.out_50bbPerTracklet))
                                return "out_50bbPerTracklet: integer expected";
                        if (message.out_75bbPerTracklet != null && message.hasOwnProperty("out_75bbPerTracklet"))
                            if (!$util.isInteger(message.out_75bbPerTracklet))
                                return "out_75bbPerTracklet: integer expected";
                        if (message.outTimePerTracklet != null && message.hasOwnProperty("outTimePerTracklet"))
                            if (typeof message.outTimePerTracklet !== "number")
                                return "outTimePerTracklet: number expected";
                        if (message.processingTime != null && message.hasOwnProperty("processingTime"))
                            if (typeof message.processingTime !== "number")
                                return "processingTime: number expected";
                        return null;
                    };
    
                    /**
                     * Creates an InOutStatistic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.InOutStatistic} InOutStatistic
                     */
                    InOutStatistic.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.InOutStatistic)
                            return object;
                        var message = new $root.palexy.streaming.v1.InOutStatistic();
                        if (object.heuristicName != null)
                            message.heuristicName = String(object.heuristicName);
                        if (object.inNumTracklet != null)
                            message.inNumTracklet = object.inNumTracklet | 0;
                        if (object.inNumBb != null)
                            message.inNumBb = object.inNumBb | 0;
                        if (object.inBbPerTracklet != null)
                            message.inBbPerTracklet = Number(object.inBbPerTracklet);
                        if (object.in_25bbPerTracklet != null)
                            message.in_25bbPerTracklet = object.in_25bbPerTracklet | 0;
                        if (object.in_50bbPerTracklet != null)
                            message.in_50bbPerTracklet = object.in_50bbPerTracklet | 0;
                        if (object.in_75bbPerTracklet != null)
                            message.in_75bbPerTracklet = object.in_75bbPerTracklet | 0;
                        if (object.inTimePerTracklet != null)
                            message.inTimePerTracklet = Number(object.inTimePerTracklet);
                        if (object.outNumTracklet != null)
                            message.outNumTracklet = object.outNumTracklet | 0;
                        if (object.outNumBb != null)
                            message.outNumBb = object.outNumBb | 0;
                        if (object.outBbPerTracklet != null)
                            message.outBbPerTracklet = Number(object.outBbPerTracklet);
                        if (object.out_25bbPerTracklet != null)
                            message.out_25bbPerTracklet = object.out_25bbPerTracklet | 0;
                        if (object.out_50bbPerTracklet != null)
                            message.out_50bbPerTracklet = object.out_50bbPerTracklet | 0;
                        if (object.out_75bbPerTracklet != null)
                            message.out_75bbPerTracklet = object.out_75bbPerTracklet | 0;
                        if (object.outTimePerTracklet != null)
                            message.outTimePerTracklet = Number(object.outTimePerTracklet);
                        if (object.processingTime != null)
                            message.processingTime = Number(object.processingTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an InOutStatistic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @static
                     * @param {palexy.streaming.v1.InOutStatistic} message InOutStatistic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    InOutStatistic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.heuristicName = "";
                            object.inNumTracklet = 0;
                            object.inNumBb = 0;
                            object.inBbPerTracklet = 0;
                            object.in_25bbPerTracklet = 0;
                            object.in_50bbPerTracklet = 0;
                            object.in_75bbPerTracklet = 0;
                            object.inTimePerTracklet = 0;
                            object.outNumTracklet = 0;
                            object.outNumBb = 0;
                            object.outBbPerTracklet = 0;
                            object.out_25bbPerTracklet = 0;
                            object.out_50bbPerTracklet = 0;
                            object.out_75bbPerTracklet = 0;
                            object.outTimePerTracklet = 0;
                            object.processingTime = 0;
                        }
                        if (message.heuristicName != null && message.hasOwnProperty("heuristicName"))
                            object.heuristicName = message.heuristicName;
                        if (message.inNumTracklet != null && message.hasOwnProperty("inNumTracklet"))
                            object.inNumTracklet = message.inNumTracklet;
                        if (message.inNumBb != null && message.hasOwnProperty("inNumBb"))
                            object.inNumBb = message.inNumBb;
                        if (message.inBbPerTracklet != null && message.hasOwnProperty("inBbPerTracklet"))
                            object.inBbPerTracklet = options.json && !isFinite(message.inBbPerTracklet) ? String(message.inBbPerTracklet) : message.inBbPerTracklet;
                        if (message.in_25bbPerTracklet != null && message.hasOwnProperty("in_25bbPerTracklet"))
                            object.in_25bbPerTracklet = message.in_25bbPerTracklet;
                        if (message.in_50bbPerTracklet != null && message.hasOwnProperty("in_50bbPerTracklet"))
                            object.in_50bbPerTracklet = message.in_50bbPerTracklet;
                        if (message.in_75bbPerTracklet != null && message.hasOwnProperty("in_75bbPerTracklet"))
                            object.in_75bbPerTracklet = message.in_75bbPerTracklet;
                        if (message.inTimePerTracklet != null && message.hasOwnProperty("inTimePerTracklet"))
                            object.inTimePerTracklet = options.json && !isFinite(message.inTimePerTracklet) ? String(message.inTimePerTracklet) : message.inTimePerTracklet;
                        if (message.outNumTracklet != null && message.hasOwnProperty("outNumTracklet"))
                            object.outNumTracklet = message.outNumTracklet;
                        if (message.outNumBb != null && message.hasOwnProperty("outNumBb"))
                            object.outNumBb = message.outNumBb;
                        if (message.outBbPerTracklet != null && message.hasOwnProperty("outBbPerTracklet"))
                            object.outBbPerTracklet = options.json && !isFinite(message.outBbPerTracklet) ? String(message.outBbPerTracklet) : message.outBbPerTracklet;
                        if (message.out_25bbPerTracklet != null && message.hasOwnProperty("out_25bbPerTracklet"))
                            object.out_25bbPerTracklet = message.out_25bbPerTracklet;
                        if (message.out_50bbPerTracklet != null && message.hasOwnProperty("out_50bbPerTracklet"))
                            object.out_50bbPerTracklet = message.out_50bbPerTracklet;
                        if (message.out_75bbPerTracklet != null && message.hasOwnProperty("out_75bbPerTracklet"))
                            object.out_75bbPerTracklet = message.out_75bbPerTracklet;
                        if (message.outTimePerTracklet != null && message.hasOwnProperty("outTimePerTracklet"))
                            object.outTimePerTracklet = options.json && !isFinite(message.outTimePerTracklet) ? String(message.outTimePerTracklet) : message.outTimePerTracklet;
                        if (message.processingTime != null && message.hasOwnProperty("processingTime"))
                            object.processingTime = options.json && !isFinite(message.processingTime) ? String(message.processingTime) : message.processingTime;
                        return object;
                    };
    
                    /**
                     * Converts this InOutStatistic to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.InOutStatistic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    InOutStatistic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return InOutStatistic;
                })();
    
                v1.MergingStatisticRequest = (function() {
    
                    /**
                     * Properties of a MergingStatisticRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IMergingStatisticRequest
                     * @property {number|null} [storeId] MergingStatisticRequest storeId
                     * @property {string|null} [dateId] MergingStatisticRequest dateId
                     * @property {string|null} [experimentName] MergingStatisticRequest experimentName
                     * @property {Array.<palexy.streaming.v1.IInOutStatistic>|null} [listInOutStatistic] MergingStatisticRequest listInOutStatistic
                     */
    
                    /**
                     * Constructs a new MergingStatisticRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingStatisticRequest.
                     * @implements IMergingStatisticRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IMergingStatisticRequest=} [properties] Properties to set
                     */
                    function MergingStatisticRequest(properties) {
                        this.listInOutStatistic = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergingStatisticRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @instance
                     */
                    MergingStatisticRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingStatisticRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @instance
                     */
                    MergingStatisticRequest.prototype.dateId = "";
    
                    /**
                     * MergingStatisticRequest experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @instance
                     */
                    MergingStatisticRequest.prototype.experimentName = "";
    
                    /**
                     * MergingStatisticRequest listInOutStatistic.
                     * @member {Array.<palexy.streaming.v1.IInOutStatistic>} listInOutStatistic
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @instance
                     */
                    MergingStatisticRequest.prototype.listInOutStatistic = $util.emptyArray;
    
                    /**
                     * Creates a new MergingStatisticRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergingStatisticRequest} MergingStatisticRequest instance
                     */
                    MergingStatisticRequest.create = function create(properties) {
                        return new MergingStatisticRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MergingStatisticRequest message. Does not implicitly {@link palexy.streaming.v1.MergingStatisticRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRequest} message MergingStatisticRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.experimentName);
                        if (message.listInOutStatistic != null && message.listInOutStatistic.length)
                            for (var i = 0; i < message.listInOutStatistic.length; ++i)
                                $root.palexy.streaming.v1.InOutStatistic.encode(message.listInOutStatistic[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergingStatisticRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergingStatisticRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRequest} message MergingStatisticRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergingStatisticRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergingStatisticRequest} MergingStatisticRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergingStatisticRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 3:
                                message.experimentName = reader.string();
                                break;
                            case 4:
                                if (!(message.listInOutStatistic && message.listInOutStatistic.length))
                                    message.listInOutStatistic = [];
                                message.listInOutStatistic.push($root.palexy.streaming.v1.InOutStatistic.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergingStatisticRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergingStatisticRequest} MergingStatisticRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergingStatisticRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergingStatisticRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        if (message.listInOutStatistic != null && message.hasOwnProperty("listInOutStatistic")) {
                            if (!Array.isArray(message.listInOutStatistic))
                                return "listInOutStatistic: array expected";
                            for (var i = 0; i < message.listInOutStatistic.length; ++i) {
                                var error = $root.palexy.streaming.v1.InOutStatistic.verify(message.listInOutStatistic[i]);
                                if (error)
                                    return "listInOutStatistic." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a MergingStatisticRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergingStatisticRequest} MergingStatisticRequest
                     */
                    MergingStatisticRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergingStatisticRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergingStatisticRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        if (object.listInOutStatistic) {
                            if (!Array.isArray(object.listInOutStatistic))
                                throw TypeError(".palexy.streaming.v1.MergingStatisticRequest.listInOutStatistic: array expected");
                            message.listInOutStatistic = [];
                            for (var i = 0; i < object.listInOutStatistic.length; ++i) {
                                if (typeof object.listInOutStatistic[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MergingStatisticRequest.listInOutStatistic: object expected");
                                message.listInOutStatistic[i] = $root.palexy.streaming.v1.InOutStatistic.fromObject(object.listInOutStatistic[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergingStatisticRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @static
                     * @param {palexy.streaming.v1.MergingStatisticRequest} message MergingStatisticRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergingStatisticRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.listInOutStatistic = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.experimentName = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        if (message.listInOutStatistic && message.listInOutStatistic.length) {
                            object.listInOutStatistic = [];
                            for (var j = 0; j < message.listInOutStatistic.length; ++j)
                                object.listInOutStatistic[j] = $root.palexy.streaming.v1.InOutStatistic.toObject(message.listInOutStatistic[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this MergingStatisticRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergingStatisticRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergingStatisticRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergingStatisticRequest;
                })();
    
                v1.MergingStatisticRow = (function() {
    
                    /**
                     * Properties of a MergingStatisticRow.
                     * @memberof palexy.streaming.v1
                     * @interface IMergingStatisticRow
                     * @property {number|null} [id] MergingStatisticRow id
                     * @property {number|null} [storeId] MergingStatisticRow storeId
                     * @property {string|null} [dateId] MergingStatisticRow dateId
                     * @property {string|null} [experimentName] MergingStatisticRow experimentName
                     * @property {string|null} [heuristicName] MergingStatisticRow heuristicName
                     * @property {google.protobuf.ITimestamp|null} [createdTime] MergingStatisticRow createdTime
                     * @property {number|null} [inNumTracklet] MergingStatisticRow inNumTracklet
                     * @property {number|null} [inNumBb] MergingStatisticRow inNumBb
                     * @property {number|null} [inBbPerTracklet] MergingStatisticRow inBbPerTracklet
                     * @property {number|null} [inTimePerTracklet] MergingStatisticRow inTimePerTracklet
                     * @property {number|null} [in25bbPerTracklet] MergingStatisticRow in25bbPerTracklet
                     * @property {number|null} [in50bbPerTracklet] MergingStatisticRow in50bbPerTracklet
                     * @property {number|null} [in75bbPerTracklet] MergingStatisticRow in75bbPerTracklet
                     * @property {number|null} [outNumTracklet] MergingStatisticRow outNumTracklet
                     * @property {number|null} [outNumBb] MergingStatisticRow outNumBb
                     * @property {number|null} [outBbPerTracklet] MergingStatisticRow outBbPerTracklet
                     * @property {number|null} [outTimePerTracklet] MergingStatisticRow outTimePerTracklet
                     * @property {number|null} [out25bbPerTracklet] MergingStatisticRow out25bbPerTracklet
                     * @property {number|null} [out50bbPerTracklet] MergingStatisticRow out50bbPerTracklet
                     * @property {number|null} [out75bbPerTracklet] MergingStatisticRow out75bbPerTracklet
                     * @property {number|null} [processingTime] MergingStatisticRow processingTime
                     */
    
                    /**
                     * Constructs a new MergingStatisticRow.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingStatisticRow.
                     * @implements IMergingStatisticRow
                     * @constructor
                     * @param {palexy.streaming.v1.IMergingStatisticRow=} [properties] Properties to set
                     */
                    function MergingStatisticRow(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergingStatisticRow id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingStatisticRow storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MergingStatisticRow dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.dateId = "";
    
                    /**
                     * MergingStatisticRow experimentName.
                     * @member {string} experimentName
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.experimentName = "";
    
                    /**
                     * MergingStatisticRow heuristicName.
                     * @member {string} heuristicName
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.heuristicName = "";
    
                    /**
                     * MergingStatisticRow createdTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createdTime
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.createdTime = null;
    
                    /**
                     * MergingStatisticRow inNumTracklet.
                     * @member {number} inNumTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.inNumTracklet = 0;
    
                    /**
                     * MergingStatisticRow inNumBb.
                     * @member {number} inNumBb
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.inNumBb = 0;
    
                    /**
                     * MergingStatisticRow inBbPerTracklet.
                     * @member {number} inBbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.inBbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow inTimePerTracklet.
                     * @member {number} inTimePerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.inTimePerTracklet = 0;
    
                    /**
                     * MergingStatisticRow in25bbPerTracklet.
                     * @member {number} in25bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.in25bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow in50bbPerTracklet.
                     * @member {number} in50bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.in50bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow in75bbPerTracklet.
                     * @member {number} in75bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.in75bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow outNumTracklet.
                     * @member {number} outNumTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.outNumTracklet = 0;
    
                    /**
                     * MergingStatisticRow outNumBb.
                     * @member {number} outNumBb
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.outNumBb = 0;
    
                    /**
                     * MergingStatisticRow outBbPerTracklet.
                     * @member {number} outBbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.outBbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow outTimePerTracklet.
                     * @member {number} outTimePerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.outTimePerTracklet = 0;
    
                    /**
                     * MergingStatisticRow out25bbPerTracklet.
                     * @member {number} out25bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.out25bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow out50bbPerTracklet.
                     * @member {number} out50bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.out50bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow out75bbPerTracklet.
                     * @member {number} out75bbPerTracklet
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.out75bbPerTracklet = 0;
    
                    /**
                     * MergingStatisticRow processingTime.
                     * @member {number} processingTime
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     */
                    MergingStatisticRow.prototype.processingTime = 0;
    
                    /**
                     * Creates a new MergingStatisticRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRow=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergingStatisticRow} MergingStatisticRow instance
                     */
                    MergingStatisticRow.create = function create(properties) {
                        return new MergingStatisticRow(properties);
                    };
    
                    /**
                     * Encodes the specified MergingStatisticRow message. Does not implicitly {@link palexy.streaming.v1.MergingStatisticRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRow} message MergingStatisticRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        if (message.experimentName != null && Object.hasOwnProperty.call(message, "experimentName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.experimentName);
                        if (message.heuristicName != null && Object.hasOwnProperty.call(message, "heuristicName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.heuristicName);
                        if (message.createdTime != null && Object.hasOwnProperty.call(message, "createdTime"))
                            $root.google.protobuf.Timestamp.encode(message.createdTime, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.inNumTracklet != null && Object.hasOwnProperty.call(message, "inNumTracklet"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.inNumTracklet);
                        if (message.inNumBb != null && Object.hasOwnProperty.call(message, "inNumBb"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.inNumBb);
                        if (message.inBbPerTracklet != null && Object.hasOwnProperty.call(message, "inBbPerTracklet"))
                            writer.uint32(/* id 9, wireType 5 =*/77).float(message.inBbPerTracklet);
                        if (message.inTimePerTracklet != null && Object.hasOwnProperty.call(message, "inTimePerTracklet"))
                            writer.uint32(/* id 10, wireType 5 =*/85).float(message.inTimePerTracklet);
                        if (message.in25bbPerTracklet != null && Object.hasOwnProperty.call(message, "in25bbPerTracklet"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.in25bbPerTracklet);
                        if (message.in50bbPerTracklet != null && Object.hasOwnProperty.call(message, "in50bbPerTracklet"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.in50bbPerTracklet);
                        if (message.in75bbPerTracklet != null && Object.hasOwnProperty.call(message, "in75bbPerTracklet"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.in75bbPerTracklet);
                        if (message.outNumTracklet != null && Object.hasOwnProperty.call(message, "outNumTracklet"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.outNumTracklet);
                        if (message.outNumBb != null && Object.hasOwnProperty.call(message, "outNumBb"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.outNumBb);
                        if (message.outBbPerTracklet != null && Object.hasOwnProperty.call(message, "outBbPerTracklet"))
                            writer.uint32(/* id 16, wireType 5 =*/133).float(message.outBbPerTracklet);
                        if (message.outTimePerTracklet != null && Object.hasOwnProperty.call(message, "outTimePerTracklet"))
                            writer.uint32(/* id 17, wireType 5 =*/141).float(message.outTimePerTracklet);
                        if (message.out25bbPerTracklet != null && Object.hasOwnProperty.call(message, "out25bbPerTracklet"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.out25bbPerTracklet);
                        if (message.out50bbPerTracklet != null && Object.hasOwnProperty.call(message, "out50bbPerTracklet"))
                            writer.uint32(/* id 19, wireType 0 =*/152).int32(message.out50bbPerTracklet);
                        if (message.out75bbPerTracklet != null && Object.hasOwnProperty.call(message, "out75bbPerTracklet"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.out75bbPerTracklet);
                        if (message.processingTime != null && Object.hasOwnProperty.call(message, "processingTime"))
                            writer.uint32(/* id 21, wireType 5 =*/173).float(message.processingTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergingStatisticRow message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergingStatisticRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticRow} message MergingStatisticRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergingStatisticRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergingStatisticRow} MergingStatisticRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergingStatisticRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            case 4:
                                message.experimentName = reader.string();
                                break;
                            case 5:
                                message.heuristicName = reader.string();
                                break;
                            case 6:
                                message.createdTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.inNumTracklet = reader.int32();
                                break;
                            case 8:
                                message.inNumBb = reader.int32();
                                break;
                            case 9:
                                message.inBbPerTracklet = reader.float();
                                break;
                            case 10:
                                message.inTimePerTracklet = reader.float();
                                break;
                            case 11:
                                message.in25bbPerTracklet = reader.int32();
                                break;
                            case 12:
                                message.in50bbPerTracklet = reader.int32();
                                break;
                            case 13:
                                message.in75bbPerTracklet = reader.int32();
                                break;
                            case 14:
                                message.outNumTracklet = reader.int32();
                                break;
                            case 15:
                                message.outNumBb = reader.int32();
                                break;
                            case 16:
                                message.outBbPerTracklet = reader.float();
                                break;
                            case 17:
                                message.outTimePerTracklet = reader.float();
                                break;
                            case 18:
                                message.out25bbPerTracklet = reader.int32();
                                break;
                            case 19:
                                message.out50bbPerTracklet = reader.int32();
                                break;
                            case 20:
                                message.out75bbPerTracklet = reader.int32();
                                break;
                            case 21:
                                message.processingTime = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergingStatisticRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergingStatisticRow} MergingStatisticRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergingStatisticRow message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergingStatisticRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            if (!$util.isString(message.experimentName))
                                return "experimentName: string expected";
                        if (message.heuristicName != null && message.hasOwnProperty("heuristicName"))
                            if (!$util.isString(message.heuristicName))
                                return "heuristicName: string expected";
                        if (message.createdTime != null && message.hasOwnProperty("createdTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createdTime);
                            if (error)
                                return "createdTime." + error;
                        }
                        if (message.inNumTracklet != null && message.hasOwnProperty("inNumTracklet"))
                            if (!$util.isInteger(message.inNumTracklet))
                                return "inNumTracklet: integer expected";
                        if (message.inNumBb != null && message.hasOwnProperty("inNumBb"))
                            if (!$util.isInteger(message.inNumBb))
                                return "inNumBb: integer expected";
                        if (message.inBbPerTracklet != null && message.hasOwnProperty("inBbPerTracklet"))
                            if (typeof message.inBbPerTracklet !== "number")
                                return "inBbPerTracklet: number expected";
                        if (message.inTimePerTracklet != null && message.hasOwnProperty("inTimePerTracklet"))
                            if (typeof message.inTimePerTracklet !== "number")
                                return "inTimePerTracklet: number expected";
                        if (message.in25bbPerTracklet != null && message.hasOwnProperty("in25bbPerTracklet"))
                            if (!$util.isInteger(message.in25bbPerTracklet))
                                return "in25bbPerTracklet: integer expected";
                        if (message.in50bbPerTracklet != null && message.hasOwnProperty("in50bbPerTracklet"))
                            if (!$util.isInteger(message.in50bbPerTracklet))
                                return "in50bbPerTracklet: integer expected";
                        if (message.in75bbPerTracklet != null && message.hasOwnProperty("in75bbPerTracklet"))
                            if (!$util.isInteger(message.in75bbPerTracklet))
                                return "in75bbPerTracklet: integer expected";
                        if (message.outNumTracklet != null && message.hasOwnProperty("outNumTracklet"))
                            if (!$util.isInteger(message.outNumTracklet))
                                return "outNumTracklet: integer expected";
                        if (message.outNumBb != null && message.hasOwnProperty("outNumBb"))
                            if (!$util.isInteger(message.outNumBb))
                                return "outNumBb: integer expected";
                        if (message.outBbPerTracklet != null && message.hasOwnProperty("outBbPerTracklet"))
                            if (typeof message.outBbPerTracklet !== "number")
                                return "outBbPerTracklet: number expected";
                        if (message.outTimePerTracklet != null && message.hasOwnProperty("outTimePerTracklet"))
                            if (typeof message.outTimePerTracklet !== "number")
                                return "outTimePerTracklet: number expected";
                        if (message.out25bbPerTracklet != null && message.hasOwnProperty("out25bbPerTracklet"))
                            if (!$util.isInteger(message.out25bbPerTracklet))
                                return "out25bbPerTracklet: integer expected";
                        if (message.out50bbPerTracklet != null && message.hasOwnProperty("out50bbPerTracklet"))
                            if (!$util.isInteger(message.out50bbPerTracklet))
                                return "out50bbPerTracklet: integer expected";
                        if (message.out75bbPerTracklet != null && message.hasOwnProperty("out75bbPerTracklet"))
                            if (!$util.isInteger(message.out75bbPerTracklet))
                                return "out75bbPerTracklet: integer expected";
                        if (message.processingTime != null && message.hasOwnProperty("processingTime"))
                            if (typeof message.processingTime !== "number")
                                return "processingTime: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a MergingStatisticRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergingStatisticRow} MergingStatisticRow
                     */
                    MergingStatisticRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergingStatisticRow)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergingStatisticRow();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.experimentName != null)
                            message.experimentName = String(object.experimentName);
                        if (object.heuristicName != null)
                            message.heuristicName = String(object.heuristicName);
                        if (object.createdTime != null) {
                            if (typeof object.createdTime !== "object")
                                throw TypeError(".palexy.streaming.v1.MergingStatisticRow.createdTime: object expected");
                            message.createdTime = $root.google.protobuf.Timestamp.fromObject(object.createdTime);
                        }
                        if (object.inNumTracklet != null)
                            message.inNumTracklet = object.inNumTracklet | 0;
                        if (object.inNumBb != null)
                            message.inNumBb = object.inNumBb | 0;
                        if (object.inBbPerTracklet != null)
                            message.inBbPerTracklet = Number(object.inBbPerTracklet);
                        if (object.inTimePerTracklet != null)
                            message.inTimePerTracklet = Number(object.inTimePerTracklet);
                        if (object.in25bbPerTracklet != null)
                            message.in25bbPerTracklet = object.in25bbPerTracklet | 0;
                        if (object.in50bbPerTracklet != null)
                            message.in50bbPerTracklet = object.in50bbPerTracklet | 0;
                        if (object.in75bbPerTracklet != null)
                            message.in75bbPerTracklet = object.in75bbPerTracklet | 0;
                        if (object.outNumTracklet != null)
                            message.outNumTracklet = object.outNumTracklet | 0;
                        if (object.outNumBb != null)
                            message.outNumBb = object.outNumBb | 0;
                        if (object.outBbPerTracklet != null)
                            message.outBbPerTracklet = Number(object.outBbPerTracklet);
                        if (object.outTimePerTracklet != null)
                            message.outTimePerTracklet = Number(object.outTimePerTracklet);
                        if (object.out25bbPerTracklet != null)
                            message.out25bbPerTracklet = object.out25bbPerTracklet | 0;
                        if (object.out50bbPerTracklet != null)
                            message.out50bbPerTracklet = object.out50bbPerTracklet | 0;
                        if (object.out75bbPerTracklet != null)
                            message.out75bbPerTracklet = object.out75bbPerTracklet | 0;
                        if (object.processingTime != null)
                            message.processingTime = Number(object.processingTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergingStatisticRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @static
                     * @param {palexy.streaming.v1.MergingStatisticRow} message MergingStatisticRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergingStatisticRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.experimentName = "";
                            object.heuristicName = "";
                            object.createdTime = null;
                            object.inNumTracklet = 0;
                            object.inNumBb = 0;
                            object.inBbPerTracklet = 0;
                            object.inTimePerTracklet = 0;
                            object.in25bbPerTracklet = 0;
                            object.in50bbPerTracklet = 0;
                            object.in75bbPerTracklet = 0;
                            object.outNumTracklet = 0;
                            object.outNumBb = 0;
                            object.outBbPerTracklet = 0;
                            object.outTimePerTracklet = 0;
                            object.out25bbPerTracklet = 0;
                            object.out50bbPerTracklet = 0;
                            object.out75bbPerTracklet = 0;
                            object.processingTime = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.experimentName != null && message.hasOwnProperty("experimentName"))
                            object.experimentName = message.experimentName;
                        if (message.heuristicName != null && message.hasOwnProperty("heuristicName"))
                            object.heuristicName = message.heuristicName;
                        if (message.createdTime != null && message.hasOwnProperty("createdTime"))
                            object.createdTime = $root.google.protobuf.Timestamp.toObject(message.createdTime, options);
                        if (message.inNumTracklet != null && message.hasOwnProperty("inNumTracklet"))
                            object.inNumTracklet = message.inNumTracklet;
                        if (message.inNumBb != null && message.hasOwnProperty("inNumBb"))
                            object.inNumBb = message.inNumBb;
                        if (message.inBbPerTracklet != null && message.hasOwnProperty("inBbPerTracklet"))
                            object.inBbPerTracklet = options.json && !isFinite(message.inBbPerTracklet) ? String(message.inBbPerTracklet) : message.inBbPerTracklet;
                        if (message.inTimePerTracklet != null && message.hasOwnProperty("inTimePerTracklet"))
                            object.inTimePerTracklet = options.json && !isFinite(message.inTimePerTracklet) ? String(message.inTimePerTracklet) : message.inTimePerTracklet;
                        if (message.in25bbPerTracklet != null && message.hasOwnProperty("in25bbPerTracklet"))
                            object.in25bbPerTracklet = message.in25bbPerTracklet;
                        if (message.in50bbPerTracklet != null && message.hasOwnProperty("in50bbPerTracklet"))
                            object.in50bbPerTracklet = message.in50bbPerTracklet;
                        if (message.in75bbPerTracklet != null && message.hasOwnProperty("in75bbPerTracklet"))
                            object.in75bbPerTracklet = message.in75bbPerTracklet;
                        if (message.outNumTracklet != null && message.hasOwnProperty("outNumTracklet"))
                            object.outNumTracklet = message.outNumTracklet;
                        if (message.outNumBb != null && message.hasOwnProperty("outNumBb"))
                            object.outNumBb = message.outNumBb;
                        if (message.outBbPerTracklet != null && message.hasOwnProperty("outBbPerTracklet"))
                            object.outBbPerTracklet = options.json && !isFinite(message.outBbPerTracklet) ? String(message.outBbPerTracklet) : message.outBbPerTracklet;
                        if (message.outTimePerTracklet != null && message.hasOwnProperty("outTimePerTracklet"))
                            object.outTimePerTracklet = options.json && !isFinite(message.outTimePerTracklet) ? String(message.outTimePerTracklet) : message.outTimePerTracklet;
                        if (message.out25bbPerTracklet != null && message.hasOwnProperty("out25bbPerTracklet"))
                            object.out25bbPerTracklet = message.out25bbPerTracklet;
                        if (message.out50bbPerTracklet != null && message.hasOwnProperty("out50bbPerTracklet"))
                            object.out50bbPerTracklet = message.out50bbPerTracklet;
                        if (message.out75bbPerTracklet != null && message.hasOwnProperty("out75bbPerTracklet"))
                            object.out75bbPerTracklet = message.out75bbPerTracklet;
                        if (message.processingTime != null && message.hasOwnProperty("processingTime"))
                            object.processingTime = options.json && !isFinite(message.processingTime) ? String(message.processingTime) : message.processingTime;
                        return object;
                    };
    
                    /**
                     * Converts this MergingStatisticRow to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergingStatisticRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergingStatisticRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergingStatisticRow;
                })();
    
                v1.MergingStatisticResponse = (function() {
    
                    /**
                     * Properties of a MergingStatisticResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IMergingStatisticResponse
                     * @property {Array.<palexy.streaming.v1.IMergingStatisticRow>|null} [rows] MergingStatisticResponse rows
                     */
    
                    /**
                     * Constructs a new MergingStatisticResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MergingStatisticResponse.
                     * @implements IMergingStatisticResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IMergingStatisticResponse=} [properties] Properties to set
                     */
                    function MergingStatisticResponse(properties) {
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MergingStatisticResponse rows.
                     * @member {Array.<palexy.streaming.v1.IMergingStatisticRow>} rows
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @instance
                     */
                    MergingStatisticResponse.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new MergingStatisticResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MergingStatisticResponse} MergingStatisticResponse instance
                     */
                    MergingStatisticResponse.create = function create(properties) {
                        return new MergingStatisticResponse(properties);
                    };
    
                    /**
                     * Encodes the specified MergingStatisticResponse message. Does not implicitly {@link palexy.streaming.v1.MergingStatisticResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticResponse} message MergingStatisticResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.streaming.v1.MergingStatisticRow.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MergingStatisticResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.MergingStatisticResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {palexy.streaming.v1.IMergingStatisticResponse} message MergingStatisticResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MergingStatisticResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MergingStatisticResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MergingStatisticResponse} MergingStatisticResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MergingStatisticResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.streaming.v1.MergingStatisticRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MergingStatisticResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MergingStatisticResponse} MergingStatisticResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MergingStatisticResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MergingStatisticResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MergingStatisticResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.streaming.v1.MergingStatisticRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a MergingStatisticResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MergingStatisticResponse} MergingStatisticResponse
                     */
                    MergingStatisticResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MergingStatisticResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.MergingStatisticResponse();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.streaming.v1.MergingStatisticResponse.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MergingStatisticResponse.rows: object expected");
                                message.rows[i] = $root.palexy.streaming.v1.MergingStatisticRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MergingStatisticResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @static
                     * @param {palexy.streaming.v1.MergingStatisticResponse} message MergingStatisticResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MergingStatisticResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rows = [];
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.streaming.v1.MergingStatisticRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this MergingStatisticResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MergingStatisticResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MergingStatisticResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MergingStatisticResponse;
                })();
    
                /**
                 * AgeGroup enum.
                 * @name palexy.streaming.v1.AgeGroup
                 * @enum {number}
                 * @property {number} UNKNOWN_AGE_GROUP=0 UNKNOWN_AGE_GROUP value
                 * @property {number} G_LESS_THAN_12=1 G_LESS_THAN_12 value
                 * @property {number} G_12_20=2 G_12_20 value
                 * @property {number} G_20_30=3 G_20_30 value
                 * @property {number} G_30_40=4 G_30_40 value
                 * @property {number} G_GREATER_THAN_40=5 G_GREATER_THAN_40 value
                 */
                v1.AgeGroup = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_AGE_GROUP"] = 0;
                    values[valuesById[1] = "G_LESS_THAN_12"] = 1;
                    values[valuesById[2] = "G_12_20"] = 2;
                    values[valuesById[3] = "G_20_30"] = 3;
                    values[valuesById[4] = "G_30_40"] = 4;
                    values[valuesById[5] = "G_GREATER_THAN_40"] = 5;
                    return values;
                })();
    
                v1.StoreNotificationService = (function() {
    
                    /**
                     * Constructs a new StoreNotificationService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreNotificationService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreNotificationService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreNotificationService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreNotificationService;
    
                    /**
                     * Creates new StoreNotificationService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreNotificationService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreNotificationService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreNotificationService#createNotification}.
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @typedef CreateNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreNotification} [response] StoreNotification
                     */
    
                    /**
                     * Calls CreateNotification.
                     * @function createNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IStoreNotification} request StoreNotification message or plain object
                     * @param {palexy.streaming.v1.StoreNotificationService.CreateNotificationCallback} callback Node-style callback called with the error, if any, and StoreNotification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreNotificationService.prototype.createNotification = function createNotification(request, callback) {
                        return this.rpcCall(createNotification, $root.palexy.streaming.v1.StoreNotification, $root.palexy.streaming.v1.StoreNotification, request, callback);
                    }, "name", { value: "CreateNotification" });
    
                    /**
                     * Calls CreateNotification.
                     * @function createNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IStoreNotification} request StoreNotification message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreNotification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreNotificationService#listNotification}.
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @typedef ListNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreNotificationResponse} [response] ListStoreNotificationResponse
                     */
    
                    /**
                     * Calls ListNotification.
                     * @function listNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest} request ListStoreNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.StoreNotificationService.ListNotificationCallback} callback Node-style callback called with the error, if any, and ListStoreNotificationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreNotificationService.prototype.listNotification = function listNotification(request, callback) {
                        return this.rpcCall(listNotification, $root.palexy.streaming.v1.ListStoreNotificationRequest, $root.palexy.streaming.v1.ListStoreNotificationResponse, request, callback);
                    }, "name", { value: "ListNotification" });
    
                    /**
                     * Calls ListNotification.
                     * @function listNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest} request ListStoreNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreNotificationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreNotificationService#getNotification}.
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @typedef GetNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreNotification} [response] StoreNotification
                     */
    
                    /**
                     * Calls GetNotification.
                     * @function getNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest} request GetStoreNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.StoreNotificationService.GetNotificationCallback} callback Node-style callback called with the error, if any, and StoreNotification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreNotificationService.prototype.getNotification = function getNotification(request, callback) {
                        return this.rpcCall(getNotification, $root.palexy.streaming.v1.GetStoreNotificationRequest, $root.palexy.streaming.v1.StoreNotification, request, callback);
                    }, "name", { value: "GetNotification" });
    
                    /**
                     * Calls GetNotification.
                     * @function getNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest} request GetStoreNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreNotification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreNotificationService#updateNotification}.
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @typedef UpdateNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreNotification} [response] StoreNotification
                     */
    
                    /**
                     * Calls UpdateNotification.
                     * @function updateNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest} request UpdateStoreNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.StoreNotificationService.UpdateNotificationCallback} callback Node-style callback called with the error, if any, and StoreNotification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreNotificationService.prototype.updateNotification = function updateNotification(request, callback) {
                        return this.rpcCall(updateNotification, $root.palexy.streaming.v1.UpdateStoreNotificationRequest, $root.palexy.streaming.v1.StoreNotification, request, callback);
                    }, "name", { value: "UpdateNotification" });
    
                    /**
                     * Calls UpdateNotification.
                     * @function updateNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest} request UpdateStoreNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreNotification>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreNotificationService#resolveNotification}.
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @typedef ResolveNotificationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreNotification} [response] StoreNotification
                     */
    
                    /**
                     * Calls ResolveNotification.
                     * @function resolveNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest} request ResolveStoreNotificationRequest message or plain object
                     * @param {palexy.streaming.v1.StoreNotificationService.ResolveNotificationCallback} callback Node-style callback called with the error, if any, and StoreNotification
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreNotificationService.prototype.resolveNotification = function resolveNotification(request, callback) {
                        return this.rpcCall(resolveNotification, $root.palexy.streaming.v1.ResolveStoreNotificationRequest, $root.palexy.streaming.v1.StoreNotification, request, callback);
                    }, "name", { value: "ResolveNotification" });
    
                    /**
                     * Calls ResolveNotification.
                     * @function resolveNotification
                     * @memberof palexy.streaming.v1.StoreNotificationService
                     * @instance
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest} request ResolveStoreNotificationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreNotification>} Promise
                     * @variation 2
                     */
    
                    return StoreNotificationService;
                })();
    
                v1.Account = (function() {
    
                    /**
                     * Properties of an Account.
                     * @memberof palexy.streaming.v1
                     * @interface IAccount
                     * @property {number|null} [id] Account id
                     * @property {string|null} [username] Account username
                     * @property {string|null} [email] Account email
                     * @property {string|null} [fullName] Account fullName
                     * @property {boolean|null} [emailVerified] Account emailVerified
                     * @property {string|null} [preferredLanguage] Account preferredLanguage
                     */
    
                    /**
                     * Constructs a new Account.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an Account.
                     * @implements IAccount
                     * @constructor
                     * @param {palexy.streaming.v1.IAccount=} [properties] Properties to set
                     */
                    function Account(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Account id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Account username.
                     * @member {string} username
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.username = "";
    
                    /**
                     * Account email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.email = "";
    
                    /**
                     * Account fullName.
                     * @member {string} fullName
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.fullName = "";
    
                    /**
                     * Account emailVerified.
                     * @member {boolean} emailVerified
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.emailVerified = false;
    
                    /**
                     * Account preferredLanguage.
                     * @member {string} preferredLanguage
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     */
                    Account.prototype.preferredLanguage = "";
    
                    /**
                     * Creates a new Account instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {palexy.streaming.v1.IAccount=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Account} Account instance
                     */
                    Account.create = function create(properties) {
                        return new Account(properties);
                    };
    
                    /**
                     * Encodes the specified Account message. Does not implicitly {@link palexy.streaming.v1.Account.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {palexy.streaming.v1.IAccount} message Account message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Account.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fullName);
                        if (message.emailVerified != null && Object.hasOwnProperty.call(message, "emailVerified"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.emailVerified);
                        if (message.preferredLanguage != null && Object.hasOwnProperty.call(message, "preferredLanguage"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.preferredLanguage);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Account message, length delimited. Does not implicitly {@link palexy.streaming.v1.Account.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {palexy.streaming.v1.IAccount} message Account message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Account.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Account message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Account} Account
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Account.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Account();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.fullName = reader.string();
                                break;
                            case 5:
                                message.emailVerified = reader.bool();
                                break;
                            case 6:
                                message.preferredLanguage = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Account message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Account} Account
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Account.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Account message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Account.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        if (message.emailVerified != null && message.hasOwnProperty("emailVerified"))
                            if (typeof message.emailVerified !== "boolean")
                                return "emailVerified: boolean expected";
                        if (message.preferredLanguage != null && message.hasOwnProperty("preferredLanguage"))
                            if (!$util.isString(message.preferredLanguage))
                                return "preferredLanguage: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an Account message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Account} Account
                     */
                    Account.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Account)
                            return object;
                        var message = new $root.palexy.streaming.v1.Account();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        if (object.emailVerified != null)
                            message.emailVerified = Boolean(object.emailVerified);
                        if (object.preferredLanguage != null)
                            message.preferredLanguage = String(object.preferredLanguage);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Account message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Account
                     * @static
                     * @param {palexy.streaming.v1.Account} message Account
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Account.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.username = "";
                            object.email = "";
                            object.fullName = "";
                            object.emailVerified = false;
                            object.preferredLanguage = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        if (message.emailVerified != null && message.hasOwnProperty("emailVerified"))
                            object.emailVerified = message.emailVerified;
                        if (message.preferredLanguage != null && message.hasOwnProperty("preferredLanguage"))
                            object.preferredLanguage = message.preferredLanguage;
                        return object;
                    };
    
                    /**
                     * Converts this Account to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Account
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Account.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Account;
                })();
    
                v1.StoreNotification = (function() {
    
                    /**
                     * Properties of a StoreNotification.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreNotification
                     * @property {number|null} [id] StoreNotification id
                     * @property {number|null} [companyId] StoreNotification companyId
                     * @property {google.protobuf.IInt64Value|null} [storeId] StoreNotification storeId
                     * @property {palexy.streaming.v1.StoreNotification.Type|null} [type] StoreNotification type
                     * @property {string|null} [message] StoreNotification message
                     * @property {palexy.streaming.v1.StoreNotification.Level|null} [level] StoreNotification level
                     * @property {palexy.streaming.v1.StoreNotification.State|null} [state] StoreNotification state
                     * @property {number|null} [startTimeMs] StoreNotification startTimeMs
                     * @property {number|null} [endTimeMs] StoreNotification endTimeMs
                     * @property {number|null} [createTimeMs] StoreNotification createTimeMs
                     * @property {number|null} [updateTimeMs] StoreNotification updateTimeMs
                     * @property {number|null} [resolveTimeMs] StoreNotification resolveTimeMs
                     * @property {number|null} [creatorId] StoreNotification creatorId
                     * @property {number|null} [resolverId] StoreNotification resolverId
                     * @property {string|null} [timezone] StoreNotification timezone
                     * @property {palexy.streaming.v1.ICompany|null} [company] StoreNotification company
                     * @property {palexy.streaming.v1.IStore|null} [store] StoreNotification store
                     * @property {palexy.streaming.v1.IAccount|null} [creator] StoreNotification creator
                     * @property {palexy.streaming.v1.IAccount|null} [resolver] StoreNotification resolver
                     * @property {number|null} [tinkerTaskGroupId] StoreNotification tinkerTaskGroupId
                     */
    
                    /**
                     * Constructs a new StoreNotification.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreNotification.
                     * @implements IStoreNotification
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreNotification=} [properties] Properties to set
                     */
                    function StoreNotification(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreNotification id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.storeId = null;
    
                    /**
                     * StoreNotification type.
                     * @member {palexy.streaming.v1.StoreNotification.Type} type
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.type = 0;
    
                    /**
                     * StoreNotification message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.message = "";
    
                    /**
                     * StoreNotification level.
                     * @member {palexy.streaming.v1.StoreNotification.Level} level
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.level = 0;
    
                    /**
                     * StoreNotification state.
                     * @member {palexy.streaming.v1.StoreNotification.State} state
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.state = 0;
    
                    /**
                     * StoreNotification startTimeMs.
                     * @member {number} startTimeMs
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.startTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification endTimeMs.
                     * @member {number} endTimeMs
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.endTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification resolveTimeMs.
                     * @member {number} resolveTimeMs
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.resolveTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification resolverId.
                     * @member {number} resolverId
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.resolverId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreNotification timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.timezone = "";
    
                    /**
                     * StoreNotification company.
                     * @member {palexy.streaming.v1.ICompany|null|undefined} company
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.company = null;
    
                    /**
                     * StoreNotification store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.store = null;
    
                    /**
                     * StoreNotification creator.
                     * @member {palexy.streaming.v1.IAccount|null|undefined} creator
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.creator = null;
    
                    /**
                     * StoreNotification resolver.
                     * @member {palexy.streaming.v1.IAccount|null|undefined} resolver
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.resolver = null;
    
                    /**
                     * StoreNotification tinkerTaskGroupId.
                     * @member {number} tinkerTaskGroupId
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     */
                    StoreNotification.prototype.tinkerTaskGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StoreNotification instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {palexy.streaming.v1.IStoreNotification=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreNotification} StoreNotification instance
                     */
                    StoreNotification.create = function create(properties) {
                        return new StoreNotification(properties);
                    };
    
                    /**
                     * Encodes the specified StoreNotification message. Does not implicitly {@link palexy.streaming.v1.StoreNotification.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {palexy.streaming.v1.IStoreNotification} message StoreNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreNotification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.message);
                        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.level);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.state);
                        if (message.startTimeMs != null && Object.hasOwnProperty.call(message, "startTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.startTimeMs);
                        if (message.endTimeMs != null && Object.hasOwnProperty.call(message, "endTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.endTimeMs);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.updateTimeMs);
                        if (message.resolveTimeMs != null && Object.hasOwnProperty.call(message, "resolveTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.resolveTimeMs);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.creatorId);
                        if (message.resolverId != null && Object.hasOwnProperty.call(message, "resolverId"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.resolverId);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.timezone);
                        if (message.company != null && Object.hasOwnProperty.call(message, "company"))
                            $root.palexy.streaming.v1.Company.encode(message.company, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                            $root.palexy.streaming.v1.Account.encode(message.creator, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.resolver != null && Object.hasOwnProperty.call(message, "resolver"))
                            $root.palexy.streaming.v1.Account.encode(message.resolver, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.tinkerTaskGroupId != null && Object.hasOwnProperty.call(message, "tinkerTaskGroupId"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int64(message.tinkerTaskGroupId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreNotification message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreNotification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {palexy.streaming.v1.IStoreNotification} message StoreNotification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreNotification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreNotification message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreNotification} StoreNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreNotification.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreNotification();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.type = reader.int32();
                                break;
                            case 5:
                                message.message = reader.string();
                                break;
                            case 6:
                                message.level = reader.int32();
                                break;
                            case 7:
                                message.state = reader.int32();
                                break;
                            case 8:
                                message.startTimeMs = reader.int64();
                                break;
                            case 9:
                                message.endTimeMs = reader.int64();
                                break;
                            case 10:
                                message.createTimeMs = reader.int64();
                                break;
                            case 11:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 12:
                                message.resolveTimeMs = reader.int64();
                                break;
                            case 13:
                                message.creatorId = reader.int64();
                                break;
                            case 14:
                                message.resolverId = reader.int64();
                                break;
                            case 15:
                                message.timezone = reader.string();
                                break;
                            case 16:
                                message.company = $root.palexy.streaming.v1.Company.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.creator = $root.palexy.streaming.v1.Account.decode(reader, reader.uint32());
                                break;
                            case 19:
                                message.resolver = $root.palexy.streaming.v1.Account.decode(reader, reader.uint32());
                                break;
                            case 20:
                                message.tinkerTaskGroupId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreNotification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreNotification} StoreNotification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreNotification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreNotification message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreNotification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.level != null && message.hasOwnProperty("level"))
                            switch (message.level) {
                            default:
                                return "level: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                            if (!$util.isInteger(message.startTimeMs) && !(message.startTimeMs && $util.isInteger(message.startTimeMs.low) && $util.isInteger(message.startTimeMs.high)))
                                return "startTimeMs: integer|Long expected";
                        if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                            if (!$util.isInteger(message.endTimeMs) && !(message.endTimeMs && $util.isInteger(message.endTimeMs.low) && $util.isInteger(message.endTimeMs.high)))
                                return "endTimeMs: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.resolveTimeMs != null && message.hasOwnProperty("resolveTimeMs"))
                            if (!$util.isInteger(message.resolveTimeMs) && !(message.resolveTimeMs && $util.isInteger(message.resolveTimeMs.low) && $util.isInteger(message.resolveTimeMs.high)))
                                return "resolveTimeMs: integer|Long expected";
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.resolverId != null && message.hasOwnProperty("resolverId"))
                            if (!$util.isInteger(message.resolverId) && !(message.resolverId && $util.isInteger(message.resolverId.low) && $util.isInteger(message.resolverId.high)))
                                return "resolverId: integer|Long expected";
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.company != null && message.hasOwnProperty("company")) {
                            var error = $root.palexy.streaming.v1.Company.verify(message.company);
                            if (error)
                                return "company." + error;
                        }
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.creator != null && message.hasOwnProperty("creator")) {
                            var error = $root.palexy.streaming.v1.Account.verify(message.creator);
                            if (error)
                                return "creator." + error;
                        }
                        if (message.resolver != null && message.hasOwnProperty("resolver")) {
                            var error = $root.palexy.streaming.v1.Account.verify(message.resolver);
                            if (error)
                                return "resolver." + error;
                        }
                        if (message.tinkerTaskGroupId != null && message.hasOwnProperty("tinkerTaskGroupId"))
                            if (!$util.isInteger(message.tinkerTaskGroupId) && !(message.tinkerTaskGroupId && $util.isInteger(message.tinkerTaskGroupId.low) && $util.isInteger(message.tinkerTaskGroupId.high)))
                                return "tinkerTaskGroupId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreNotification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreNotification} StoreNotification
                     */
                    StoreNotification.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreNotification)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreNotification();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreNotification.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "CAMERA_BROKEN":
                        case 1:
                            message.type = 1;
                            break;
                        case "MISSING_DATA_RECOVER_IN_PROGRESS":
                        case 2:
                            message.type = 2;
                            break;
                        case "CUSTOM":
                        case 3:
                            message.type = 3;
                            break;
                        case "CAMERA_SHIFT":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        switch (object.level) {
                        case "LEVEL_UNKNOWN":
                        case 0:
                            message.level = 0;
                            break;
                        case "INFO":
                        case 1:
                            message.level = 1;
                            break;
                        case "WARN":
                        case 2:
                            message.level = 2;
                            break;
                        case "ERROR":
                        case 3:
                            message.level = 3;
                            break;
                        }
                        switch (object.state) {
                        case "STATE_UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "ACTIVE":
                        case 1:
                            message.state = 1;
                            break;
                        case "RESOLVED":
                        case 2:
                            message.state = 2;
                            break;
                        case "CANCELLED":
                        case 3:
                            message.state = 3;
                            break;
                        case "CANNOT_RESOLVE":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        if (object.startTimeMs != null)
                            if ($util.Long)
                                (message.startTimeMs = $util.Long.fromValue(object.startTimeMs)).unsigned = false;
                            else if (typeof object.startTimeMs === "string")
                                message.startTimeMs = parseInt(object.startTimeMs, 10);
                            else if (typeof object.startTimeMs === "number")
                                message.startTimeMs = object.startTimeMs;
                            else if (typeof object.startTimeMs === "object")
                                message.startTimeMs = new $util.LongBits(object.startTimeMs.low >>> 0, object.startTimeMs.high >>> 0).toNumber();
                        if (object.endTimeMs != null)
                            if ($util.Long)
                                (message.endTimeMs = $util.Long.fromValue(object.endTimeMs)).unsigned = false;
                            else if (typeof object.endTimeMs === "string")
                                message.endTimeMs = parseInt(object.endTimeMs, 10);
                            else if (typeof object.endTimeMs === "number")
                                message.endTimeMs = object.endTimeMs;
                            else if (typeof object.endTimeMs === "object")
                                message.endTimeMs = new $util.LongBits(object.endTimeMs.low >>> 0, object.endTimeMs.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.resolveTimeMs != null)
                            if ($util.Long)
                                (message.resolveTimeMs = $util.Long.fromValue(object.resolveTimeMs)).unsigned = false;
                            else if (typeof object.resolveTimeMs === "string")
                                message.resolveTimeMs = parseInt(object.resolveTimeMs, 10);
                            else if (typeof object.resolveTimeMs === "number")
                                message.resolveTimeMs = object.resolveTimeMs;
                            else if (typeof object.resolveTimeMs === "object")
                                message.resolveTimeMs = new $util.LongBits(object.resolveTimeMs.low >>> 0, object.resolveTimeMs.high >>> 0).toNumber();
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        if (object.resolverId != null)
                            if ($util.Long)
                                (message.resolverId = $util.Long.fromValue(object.resolverId)).unsigned = false;
                            else if (typeof object.resolverId === "string")
                                message.resolverId = parseInt(object.resolverId, 10);
                            else if (typeof object.resolverId === "number")
                                message.resolverId = object.resolverId;
                            else if (typeof object.resolverId === "object")
                                message.resolverId = new $util.LongBits(object.resolverId.low >>> 0, object.resolverId.high >>> 0).toNumber();
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.company != null) {
                            if (typeof object.company !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreNotification.company: object expected");
                            message.company = $root.palexy.streaming.v1.Company.fromObject(object.company);
                        }
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreNotification.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.creator != null) {
                            if (typeof object.creator !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreNotification.creator: object expected");
                            message.creator = $root.palexy.streaming.v1.Account.fromObject(object.creator);
                        }
                        if (object.resolver != null) {
                            if (typeof object.resolver !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreNotification.resolver: object expected");
                            message.resolver = $root.palexy.streaming.v1.Account.fromObject(object.resolver);
                        }
                        if (object.tinkerTaskGroupId != null)
                            if ($util.Long)
                                (message.tinkerTaskGroupId = $util.Long.fromValue(object.tinkerTaskGroupId)).unsigned = false;
                            else if (typeof object.tinkerTaskGroupId === "string")
                                message.tinkerTaskGroupId = parseInt(object.tinkerTaskGroupId, 10);
                            else if (typeof object.tinkerTaskGroupId === "number")
                                message.tinkerTaskGroupId = object.tinkerTaskGroupId;
                            else if (typeof object.tinkerTaskGroupId === "object")
                                message.tinkerTaskGroupId = new $util.LongBits(object.tinkerTaskGroupId.low >>> 0, object.tinkerTaskGroupId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreNotification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @static
                     * @param {palexy.streaming.v1.StoreNotification} message StoreNotification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreNotification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.storeId = null;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.message = "";
                            object.level = options.enums === String ? "LEVEL_UNKNOWN" : 0;
                            object.state = options.enums === String ? "STATE_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.startTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.endTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.endTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.resolveTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.resolveTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.resolverId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.resolverId = options.longs === String ? "0" : 0;
                            object.timezone = "";
                            object.company = null;
                            object.store = null;
                            object.creator = null;
                            object.resolver = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.tinkerTaskGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.tinkerTaskGroupId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.Type[message.type] : message.type;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.level != null && message.hasOwnProperty("level"))
                            object.level = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.Level[message.level] : message.level;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.State[message.state] : message.state;
                        if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                            if (typeof message.startTimeMs === "number")
                                object.startTimeMs = options.longs === String ? String(message.startTimeMs) : message.startTimeMs;
                            else
                                object.startTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeMs) : options.longs === Number ? new $util.LongBits(message.startTimeMs.low >>> 0, message.startTimeMs.high >>> 0).toNumber() : message.startTimeMs;
                        if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                            if (typeof message.endTimeMs === "number")
                                object.endTimeMs = options.longs === String ? String(message.endTimeMs) : message.endTimeMs;
                            else
                                object.endTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeMs) : options.longs === Number ? new $util.LongBits(message.endTimeMs.low >>> 0, message.endTimeMs.high >>> 0).toNumber() : message.endTimeMs;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.resolveTimeMs != null && message.hasOwnProperty("resolveTimeMs"))
                            if (typeof message.resolveTimeMs === "number")
                                object.resolveTimeMs = options.longs === String ? String(message.resolveTimeMs) : message.resolveTimeMs;
                            else
                                object.resolveTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.resolveTimeMs) : options.longs === Number ? new $util.LongBits(message.resolveTimeMs.low >>> 0, message.resolveTimeMs.high >>> 0).toNumber() : message.resolveTimeMs;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.resolverId != null && message.hasOwnProperty("resolverId"))
                            if (typeof message.resolverId === "number")
                                object.resolverId = options.longs === String ? String(message.resolverId) : message.resolverId;
                            else
                                object.resolverId = options.longs === String ? $util.Long.prototype.toString.call(message.resolverId) : options.longs === Number ? new $util.LongBits(message.resolverId.low >>> 0, message.resolverId.high >>> 0).toNumber() : message.resolverId;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.company != null && message.hasOwnProperty("company"))
                            object.company = $root.palexy.streaming.v1.Company.toObject(message.company, options);
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            object.creator = $root.palexy.streaming.v1.Account.toObject(message.creator, options);
                        if (message.resolver != null && message.hasOwnProperty("resolver"))
                            object.resolver = $root.palexy.streaming.v1.Account.toObject(message.resolver, options);
                        if (message.tinkerTaskGroupId != null && message.hasOwnProperty("tinkerTaskGroupId"))
                            if (typeof message.tinkerTaskGroupId === "number")
                                object.tinkerTaskGroupId = options.longs === String ? String(message.tinkerTaskGroupId) : message.tinkerTaskGroupId;
                            else
                                object.tinkerTaskGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.tinkerTaskGroupId) : options.longs === Number ? new $util.LongBits(message.tinkerTaskGroupId.low >>> 0, message.tinkerTaskGroupId.high >>> 0).toNumber() : message.tinkerTaskGroupId;
                        return object;
                    };
    
                    /**
                     * Converts this StoreNotification to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreNotification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreNotification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Type enum.
                     * @name palexy.streaming.v1.StoreNotification.Type
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} CAMERA_BROKEN=1 CAMERA_BROKEN value
                     * @property {number} MISSING_DATA_RECOVER_IN_PROGRESS=2 MISSING_DATA_RECOVER_IN_PROGRESS value
                     * @property {number} CUSTOM=3 CUSTOM value
                     * @property {number} CAMERA_SHIFT=4 CAMERA_SHIFT value
                     */
                    StoreNotification.Type = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "CAMERA_BROKEN"] = 1;
                        values[valuesById[2] = "MISSING_DATA_RECOVER_IN_PROGRESS"] = 2;
                        values[valuesById[3] = "CUSTOM"] = 3;
                        values[valuesById[4] = "CAMERA_SHIFT"] = 4;
                        return values;
                    })();
    
                    /**
                     * Level enum.
                     * @name palexy.streaming.v1.StoreNotification.Level
                     * @enum {number}
                     * @property {number} LEVEL_UNKNOWN=0 LEVEL_UNKNOWN value
                     * @property {number} INFO=1 INFO value
                     * @property {number} WARN=2 WARN value
                     * @property {number} ERROR=3 ERROR value
                     */
                    StoreNotification.Level = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "LEVEL_UNKNOWN"] = 0;
                        values[valuesById[1] = "INFO"] = 1;
                        values[valuesById[2] = "WARN"] = 2;
                        values[valuesById[3] = "ERROR"] = 3;
                        return values;
                    })();
    
                    /**
                     * State enum.
                     * @name palexy.streaming.v1.StoreNotification.State
                     * @enum {number}
                     * @property {number} STATE_UNKNOWN=0 STATE_UNKNOWN value
                     * @property {number} ACTIVE=1 ACTIVE value
                     * @property {number} RESOLVED=2 RESOLVED value
                     * @property {number} CANCELLED=3 CANCELLED value
                     * @property {number} CANNOT_RESOLVE=4 CANNOT_RESOLVE value
                     */
                    StoreNotification.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATE_UNKNOWN"] = 0;
                        values[valuesById[1] = "ACTIVE"] = 1;
                        values[valuesById[2] = "RESOLVED"] = 2;
                        values[valuesById[3] = "CANCELLED"] = 3;
                        values[valuesById[4] = "CANNOT_RESOLVE"] = 4;
                        return values;
                    })();
    
                    return StoreNotification;
                })();
    
                v1.ListStoreNotificationRequest = (function() {
    
                    /**
                     * Properties of a ListStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreNotificationRequest
                     * @property {palexy.streaming.v1.StoreNotification.Type|null} [type] ListStoreNotificationRequest type
                     * @property {Array.<palexy.streaming.v1.StoreNotification.State>|null} [states] ListStoreNotificationRequest states
                     * @property {number|null} [pageSize] ListStoreNotificationRequest pageSize
                     * @property {string|null} [pageToken] ListStoreNotificationRequest pageToken
                     * @property {google.protobuf.IInt64Value|null} [companyId] ListStoreNotificationRequest companyId
                     * @property {Array.<number>|null} [storeIds] ListStoreNotificationRequest storeIds
                     * @property {string|null} [startDate] ListStoreNotificationRequest startDate
                     * @property {string|null} [endDate] ListStoreNotificationRequest endDate
                     */
    
                    /**
                     * Constructs a new ListStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreNotificationRequest.
                     * @implements IListStoreNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest=} [properties] Properties to set
                     */
                    function ListStoreNotificationRequest(properties) {
                        this.states = [];
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreNotificationRequest type.
                     * @member {palexy.streaming.v1.StoreNotification.Type} type
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.type = 0;
    
                    /**
                     * ListStoreNotificationRequest states.
                     * @member {Array.<palexy.streaming.v1.StoreNotification.State>} states
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.states = $util.emptyArray;
    
                    /**
                     * ListStoreNotificationRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStoreNotificationRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.pageToken = "";
    
                    /**
                     * ListStoreNotificationRequest companyId.
                     * @member {google.protobuf.IInt64Value|null|undefined} companyId
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.companyId = null;
    
                    /**
                     * ListStoreNotificationRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListStoreNotificationRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.startDate = "";
    
                    /**
                     * ListStoreNotificationRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     */
                    ListStoreNotificationRequest.prototype.endDate = "";
    
                    /**
                     * Creates a new ListStoreNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreNotificationRequest} ListStoreNotificationRequest instance
                     */
                    ListStoreNotificationRequest.create = function create(properties) {
                        return new ListStoreNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest} message ListStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                        if (message.states != null && message.states.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.states.length; ++i)
                                writer.int32(message.states[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            $root.google.protobuf.Int64Value.encode(message.companyId, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.endDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationRequest} message ListStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreNotificationRequest} ListStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 3:
                                message.type = reader.int32();
                                break;
                            case 4:
                                if (!(message.states && message.states.length))
                                    message.states = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.states.push(reader.int32());
                                } else
                                    message.states.push(reader.int32());
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 7:
                                message.companyId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 8:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 9:
                                message.startDate = reader.string();
                                break;
                            case 10:
                                message.endDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreNotificationRequest} ListStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.states != null && message.hasOwnProperty("states")) {
                            if (!Array.isArray(message.states))
                                return "states: array expected";
                            for (var i = 0; i < message.states.length; ++i)
                                switch (message.states[i]) {
                                default:
                                    return "states: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.companyId);
                            if (error)
                                return "companyId." + error;
                        }
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreNotificationRequest} ListStoreNotificationRequest
                     */
                    ListStoreNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreNotificationRequest();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "CAMERA_BROKEN":
                        case 1:
                            message.type = 1;
                            break;
                        case "MISSING_DATA_RECOVER_IN_PROGRESS":
                        case 2:
                            message.type = 2;
                            break;
                        case "CUSTOM":
                        case 3:
                            message.type = 3;
                            break;
                        case "CAMERA_SHIFT":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.states) {
                            if (!Array.isArray(object.states))
                                throw TypeError(".palexy.streaming.v1.ListStoreNotificationRequest.states: array expected");
                            message.states = [];
                            for (var i = 0; i < object.states.length; ++i)
                                switch (object.states[i]) {
                                default:
                                case "STATE_UNKNOWN":
                                case 0:
                                    message.states[i] = 0;
                                    break;
                                case "ACTIVE":
                                case 1:
                                    message.states[i] = 1;
                                    break;
                                case "RESOLVED":
                                case 2:
                                    message.states[i] = 2;
                                    break;
                                case "CANCELLED":
                                case 3:
                                    message.states[i] = 3;
                                    break;
                                case "CANNOT_RESOLVE":
                                case 4:
                                    message.states[i] = 4;
                                    break;
                                }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.companyId != null) {
                            if (typeof object.companyId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStoreNotificationRequest.companyId: object expected");
                            message.companyId = $root.google.protobuf.Int64Value.fromObject(object.companyId);
                        }
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListStoreNotificationRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreNotificationRequest} message ListStoreNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.states = [];
                            object.storeIds = [];
                        }
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.companyId = null;
                            object.startDate = "";
                            object.endDate = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.Type[message.type] : message.type;
                        if (message.states && message.states.length) {
                            object.states = [];
                            for (var j = 0; j < message.states.length; ++j)
                                object.states[j] = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.State[message.states[j]] : message.states[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            object.companyId = $root.google.protobuf.Int64Value.toObject(message.companyId, options);
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreNotificationRequest;
                })();
    
                v1.ListStoreNotificationResponse = (function() {
    
                    /**
                     * Properties of a ListStoreNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreNotificationResponse
                     * @property {Array.<palexy.streaming.v1.IStoreNotification>|null} [notifications] ListStoreNotificationResponse notifications
                     * @property {number|null} [totalElements] ListStoreNotificationResponse totalElements
                     * @property {string|null} [nextPageToken] ListStoreNotificationResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListStoreNotificationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreNotificationResponse.
                     * @implements IListStoreNotificationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreNotificationResponse=} [properties] Properties to set
                     */
                    function ListStoreNotificationResponse(properties) {
                        this.notifications = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreNotificationResponse notifications.
                     * @member {Array.<palexy.streaming.v1.IStoreNotification>} notifications
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @instance
                     */
                    ListStoreNotificationResponse.prototype.notifications = $util.emptyArray;
    
                    /**
                     * ListStoreNotificationResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @instance
                     */
                    ListStoreNotificationResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreNotificationResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @instance
                     */
                    ListStoreNotificationResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListStoreNotificationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreNotificationResponse} ListStoreNotificationResponse instance
                     */
                    ListStoreNotificationResponse.create = function create(properties) {
                        return new ListStoreNotificationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreNotificationResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreNotificationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationResponse} message ListStoreNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreNotificationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notifications != null && message.notifications.length)
                            for (var i = 0; i < message.notifications.length; ++i)
                                $root.palexy.streaming.v1.StoreNotification.encode(message.notifications[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreNotificationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreNotificationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreNotificationResponse} message ListStoreNotificationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreNotificationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreNotificationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreNotificationResponse} ListStoreNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreNotificationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreNotificationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.notifications && message.notifications.length))
                                    message.notifications = [];
                                message.notifications.push($root.palexy.streaming.v1.StoreNotification.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreNotificationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreNotificationResponse} ListStoreNotificationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreNotificationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreNotificationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreNotificationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notifications != null && message.hasOwnProperty("notifications")) {
                            if (!Array.isArray(message.notifications))
                                return "notifications: array expected";
                            for (var i = 0; i < message.notifications.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreNotification.verify(message.notifications[i]);
                                if (error)
                                    return "notifications." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreNotificationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreNotificationResponse} ListStoreNotificationResponse
                     */
                    ListStoreNotificationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreNotificationResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreNotificationResponse();
                        if (object.notifications) {
                            if (!Array.isArray(object.notifications))
                                throw TypeError(".palexy.streaming.v1.ListStoreNotificationResponse.notifications: array expected");
                            message.notifications = [];
                            for (var i = 0; i < object.notifications.length; ++i) {
                                if (typeof object.notifications[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreNotificationResponse.notifications: object expected");
                                message.notifications[i] = $root.palexy.streaming.v1.StoreNotification.fromObject(object.notifications[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreNotificationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreNotificationResponse} message ListStoreNotificationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreNotificationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.notifications = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.notifications && message.notifications.length) {
                            object.notifications = [];
                            for (var j = 0; j < message.notifications.length; ++j)
                                object.notifications[j] = $root.palexy.streaming.v1.StoreNotification.toObject(message.notifications[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreNotificationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreNotificationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreNotificationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreNotificationResponse;
                })();
    
                v1.GetStoreNotificationRequest = (function() {
    
                    /**
                     * Properties of a GetStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreNotificationRequest
                     * @property {number|null} [notificationId] GetStoreNotificationRequest notificationId
                     */
    
                    /**
                     * Constructs a new GetStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreNotificationRequest.
                     * @implements IGetStoreNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest=} [properties] Properties to set
                     */
                    function GetStoreNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreNotificationRequest notificationId.
                     * @member {number} notificationId
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @instance
                     */
                    GetStoreNotificationRequest.prototype.notificationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStoreNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreNotificationRequest} GetStoreNotificationRequest instance
                     */
                    GetStoreNotificationRequest.create = function create(properties) {
                        return new GetStoreNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest} message GetStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notificationId != null && Object.hasOwnProperty.call(message, "notificationId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.notificationId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreNotificationRequest} message GetStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreNotificationRequest} GetStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notificationId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreNotificationRequest} GetStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (!$util.isInteger(message.notificationId) && !(message.notificationId && $util.isInteger(message.notificationId.low) && $util.isInteger(message.notificationId.high)))
                                return "notificationId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreNotificationRequest} GetStoreNotificationRequest
                     */
                    GetStoreNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreNotificationRequest();
                        if (object.notificationId != null)
                            if ($util.Long)
                                (message.notificationId = $util.Long.fromValue(object.notificationId)).unsigned = false;
                            else if (typeof object.notificationId === "string")
                                message.notificationId = parseInt(object.notificationId, 10);
                            else if (typeof object.notificationId === "number")
                                message.notificationId = object.notificationId;
                            else if (typeof object.notificationId === "object")
                                message.notificationId = new $util.LongBits(object.notificationId.low >>> 0, object.notificationId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreNotificationRequest} message GetStoreNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.notificationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.notificationId = options.longs === String ? "0" : 0;
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (typeof message.notificationId === "number")
                                object.notificationId = options.longs === String ? String(message.notificationId) : message.notificationId;
                            else
                                object.notificationId = options.longs === String ? $util.Long.prototype.toString.call(message.notificationId) : options.longs === Number ? new $util.LongBits(message.notificationId.low >>> 0, message.notificationId.high >>> 0).toNumber() : message.notificationId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreNotificationRequest;
                })();
    
                v1.UpdateStoreNotificationRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreNotificationRequest
                     * @property {palexy.streaming.v1.IStoreNotification|null} [notification] UpdateStoreNotificationRequest notification
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreNotificationRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreNotificationRequest.
                     * @implements IUpdateStoreNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest=} [properties] Properties to set
                     */
                    function UpdateStoreNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreNotificationRequest notification.
                     * @member {palexy.streaming.v1.IStoreNotification|null|undefined} notification
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @instance
                     */
                    UpdateStoreNotificationRequest.prototype.notification = null;
    
                    /**
                     * UpdateStoreNotificationRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @instance
                     */
                    UpdateStoreNotificationRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreNotificationRequest} UpdateStoreNotificationRequest instance
                     */
                    UpdateStoreNotificationRequest.create = function create(properties) {
                        return new UpdateStoreNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest} message UpdateStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notification != null && Object.hasOwnProperty.call(message, "notification"))
                            $root.palexy.streaming.v1.StoreNotification.encode(message.notification, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreNotificationRequest} message UpdateStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreNotificationRequest} UpdateStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notification = $root.palexy.streaming.v1.StoreNotification.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreNotificationRequest} UpdateStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notification != null && message.hasOwnProperty("notification")) {
                            var error = $root.palexy.streaming.v1.StoreNotification.verify(message.notification);
                            if (error)
                                return "notification." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreNotificationRequest} UpdateStoreNotificationRequest
                     */
                    UpdateStoreNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreNotificationRequest();
                        if (object.notification != null) {
                            if (typeof object.notification !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreNotificationRequest.notification: object expected");
                            message.notification = $root.palexy.streaming.v1.StoreNotification.fromObject(object.notification);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreNotificationRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreNotificationRequest} message UpdateStoreNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.notification = null;
                            object.updateMask = null;
                        }
                        if (message.notification != null && message.hasOwnProperty("notification"))
                            object.notification = $root.palexy.streaming.v1.StoreNotification.toObject(message.notification, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreNotificationRequest;
                })();
    
                v1.ResolveStoreNotificationRequest = (function() {
    
                    /**
                     * Properties of a ResolveStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IResolveStoreNotificationRequest
                     * @property {number|null} [notificationId] ResolveStoreNotificationRequest notificationId
                     * @property {number|null} [resolverId] ResolveStoreNotificationRequest resolverId
                     * @property {palexy.streaming.v1.StoreNotification.State|null} [state] ResolveStoreNotificationRequest state
                     */
    
                    /**
                     * Constructs a new ResolveStoreNotificationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ResolveStoreNotificationRequest.
                     * @implements IResolveStoreNotificationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest=} [properties] Properties to set
                     */
                    function ResolveStoreNotificationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ResolveStoreNotificationRequest notificationId.
                     * @member {number} notificationId
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @instance
                     */
                    ResolveStoreNotificationRequest.prototype.notificationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ResolveStoreNotificationRequest resolverId.
                     * @member {number} resolverId
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @instance
                     */
                    ResolveStoreNotificationRequest.prototype.resolverId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ResolveStoreNotificationRequest state.
                     * @member {palexy.streaming.v1.StoreNotification.State} state
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @instance
                     */
                    ResolveStoreNotificationRequest.prototype.state = 0;
    
                    /**
                     * Creates a new ResolveStoreNotificationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ResolveStoreNotificationRequest} ResolveStoreNotificationRequest instance
                     */
                    ResolveStoreNotificationRequest.create = function create(properties) {
                        return new ResolveStoreNotificationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ResolveStoreNotificationRequest message. Does not implicitly {@link palexy.streaming.v1.ResolveStoreNotificationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest} message ResolveStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveStoreNotificationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.notificationId != null && Object.hasOwnProperty.call(message, "notificationId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.notificationId);
                        if (message.resolverId != null && Object.hasOwnProperty.call(message, "resolverId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.resolverId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.state);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ResolveStoreNotificationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ResolveStoreNotificationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.IResolveStoreNotificationRequest} message ResolveStoreNotificationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveStoreNotificationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ResolveStoreNotificationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ResolveStoreNotificationRequest} ResolveStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveStoreNotificationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ResolveStoreNotificationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.notificationId = reader.int64();
                                break;
                            case 2:
                                message.resolverId = reader.int64();
                                break;
                            case 3:
                                message.state = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ResolveStoreNotificationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ResolveStoreNotificationRequest} ResolveStoreNotificationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveStoreNotificationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ResolveStoreNotificationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ResolveStoreNotificationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (!$util.isInteger(message.notificationId) && !(message.notificationId && $util.isInteger(message.notificationId.low) && $util.isInteger(message.notificationId.high)))
                                return "notificationId: integer|Long expected";
                        if (message.resolverId != null && message.hasOwnProperty("resolverId"))
                            if (!$util.isInteger(message.resolverId) && !(message.resolverId && $util.isInteger(message.resolverId.low) && $util.isInteger(message.resolverId.high)))
                                return "resolverId: integer|Long expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ResolveStoreNotificationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ResolveStoreNotificationRequest} ResolveStoreNotificationRequest
                     */
                    ResolveStoreNotificationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ResolveStoreNotificationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ResolveStoreNotificationRequest();
                        if (object.notificationId != null)
                            if ($util.Long)
                                (message.notificationId = $util.Long.fromValue(object.notificationId)).unsigned = false;
                            else if (typeof object.notificationId === "string")
                                message.notificationId = parseInt(object.notificationId, 10);
                            else if (typeof object.notificationId === "number")
                                message.notificationId = object.notificationId;
                            else if (typeof object.notificationId === "object")
                                message.notificationId = new $util.LongBits(object.notificationId.low >>> 0, object.notificationId.high >>> 0).toNumber();
                        if (object.resolverId != null)
                            if ($util.Long)
                                (message.resolverId = $util.Long.fromValue(object.resolverId)).unsigned = false;
                            else if (typeof object.resolverId === "string")
                                message.resolverId = parseInt(object.resolverId, 10);
                            else if (typeof object.resolverId === "number")
                                message.resolverId = object.resolverId;
                            else if (typeof object.resolverId === "object")
                                message.resolverId = new $util.LongBits(object.resolverId.low >>> 0, object.resolverId.high >>> 0).toNumber();
                        switch (object.state) {
                        case "STATE_UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "ACTIVE":
                        case 1:
                            message.state = 1;
                            break;
                        case "RESOLVED":
                        case 2:
                            message.state = 2;
                            break;
                        case "CANCELLED":
                        case 3:
                            message.state = 3;
                            break;
                        case "CANNOT_RESOLVE":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ResolveStoreNotificationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @static
                     * @param {palexy.streaming.v1.ResolveStoreNotificationRequest} message ResolveStoreNotificationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ResolveStoreNotificationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.notificationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.notificationId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.resolverId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.resolverId = options.longs === String ? "0" : 0;
                            object.state = options.enums === String ? "STATE_UNKNOWN" : 0;
                        }
                        if (message.notificationId != null && message.hasOwnProperty("notificationId"))
                            if (typeof message.notificationId === "number")
                                object.notificationId = options.longs === String ? String(message.notificationId) : message.notificationId;
                            else
                                object.notificationId = options.longs === String ? $util.Long.prototype.toString.call(message.notificationId) : options.longs === Number ? new $util.LongBits(message.notificationId.low >>> 0, message.notificationId.high >>> 0).toNumber() : message.notificationId;
                        if (message.resolverId != null && message.hasOwnProperty("resolverId"))
                            if (typeof message.resolverId === "number")
                                object.resolverId = options.longs === String ? String(message.resolverId) : message.resolverId;
                            else
                                object.resolverId = options.longs === String ? $util.Long.prototype.toString.call(message.resolverId) : options.longs === Number ? new $util.LongBits(message.resolverId.low >>> 0, message.resolverId.high >>> 0).toNumber() : message.resolverId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StoreNotification.State[message.state] : message.state;
                        return object;
                    };
    
                    /**
                     * Converts this ResolveStoreNotificationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ResolveStoreNotificationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ResolveStoreNotificationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ResolveStoreNotificationRequest;
                })();
    
                v1.AccountService = (function() {
    
                    /**
                     * Constructs a new AccountService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AccountService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function AccountService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (AccountService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AccountService;
    
                    /**
                     * Creates new AccountService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.AccountService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {AccountService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    AccountService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AccountService#listPalexyQcAccounts}.
                     * @memberof palexy.streaming.v1.AccountService
                     * @typedef ListPalexyQcAccountsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAccountsResponse} [response] ListAccountsResponse
                     */
    
                    /**
                     * Calls ListPalexyQcAccounts.
                     * @function listPalexyQcAccounts
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @param {palexy.streaming.v1.AccountService.ListPalexyQcAccountsCallback} callback Node-style callback called with the error, if any, and ListAccountsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccountService.prototype.listPalexyQcAccounts = function listPalexyQcAccounts(request, callback) {
                        return this.rpcCall(listPalexyQcAccounts, $root.google.protobuf.Empty, $root.palexy.streaming.v1.ListAccountsResponse, request, callback);
                    }, "name", { value: "ListPalexyQcAccounts" });
    
                    /**
                     * Calls ListPalexyQcAccounts.
                     * @function listPalexyQcAccounts
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAccountsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AccountService#getAccount}.
                     * @memberof palexy.streaming.v1.AccountService
                     * @typedef GetAccountCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Account} [response] Account
                     */
    
                    /**
                     * Calls GetAccount.
                     * @function getAccount
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAccountRequest} request GetAccountRequest message or plain object
                     * @param {palexy.streaming.v1.AccountService.GetAccountCallback} callback Node-style callback called with the error, if any, and Account
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccountService.prototype.getAccount = function getAccount(request, callback) {
                        return this.rpcCall(getAccount, $root.palexy.streaming.v1.GetAccountRequest, $root.palexy.streaming.v1.Account, request, callback);
                    }, "name", { value: "GetAccount" });
    
                    /**
                     * Calls GetAccount.
                     * @function getAccount
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAccountRequest} request GetAccountRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Account>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AccountService#listAccounts}.
                     * @memberof palexy.streaming.v1.AccountService
                     * @typedef ListAccountsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAccountsResponse} [response] ListAccountsResponse
                     */
    
                    /**
                     * Calls ListAccounts.
                     * @function listAccounts
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {palexy.streaming.v1.IListAccountsRequest} request ListAccountsRequest message or plain object
                     * @param {palexy.streaming.v1.AccountService.ListAccountsCallback} callback Node-style callback called with the error, if any, and ListAccountsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AccountService.prototype.listAccounts = function listAccounts(request, callback) {
                        return this.rpcCall(listAccounts, $root.palexy.streaming.v1.ListAccountsRequest, $root.palexy.streaming.v1.ListAccountsResponse, request, callback);
                    }, "name", { value: "ListAccounts" });
    
                    /**
                     * Calls ListAccounts.
                     * @function listAccounts
                     * @memberof palexy.streaming.v1.AccountService
                     * @instance
                     * @param {palexy.streaming.v1.IListAccountsRequest} request ListAccountsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAccountsResponse>} Promise
                     * @variation 2
                     */
    
                    return AccountService;
                })();
    
                v1.ListAccountsResponse = (function() {
    
                    /**
                     * Properties of a ListAccountsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListAccountsResponse
                     * @property {Array.<palexy.streaming.v1.IAccount>|null} [accounts] ListAccountsResponse accounts
                     */
    
                    /**
                     * Constructs a new ListAccountsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAccountsResponse.
                     * @implements IListAccountsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListAccountsResponse=} [properties] Properties to set
                     */
                    function ListAccountsResponse(properties) {
                        this.accounts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccountsResponse accounts.
                     * @member {Array.<palexy.streaming.v1.IAccount>} accounts
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @instance
                     */
                    ListAccountsResponse.prototype.accounts = $util.emptyArray;
    
                    /**
                     * Creates a new ListAccountsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAccountsResponse} ListAccountsResponse instance
                     */
                    ListAccountsResponse.create = function create(properties) {
                        return new ListAccountsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccountsResponse message. Does not implicitly {@link palexy.streaming.v1.ListAccountsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsResponse} message ListAccountsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccountsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accounts != null && message.accounts.length)
                            for (var i = 0; i < message.accounts.length; ++i)
                                $root.palexy.streaming.v1.Account.encode(message.accounts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccountsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAccountsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsResponse} message ListAccountsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccountsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccountsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAccountsResponse} ListAccountsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccountsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAccountsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.accounts && message.accounts.length))
                                    message.accounts = [];
                                message.accounts.push($root.palexy.streaming.v1.Account.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccountsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAccountsResponse} ListAccountsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccountsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccountsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccountsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accounts != null && message.hasOwnProperty("accounts")) {
                            if (!Array.isArray(message.accounts))
                                return "accounts: array expected";
                            for (var i = 0; i < message.accounts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Account.verify(message.accounts[i]);
                                if (error)
                                    return "accounts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAccountsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAccountsResponse} ListAccountsResponse
                     */
                    ListAccountsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAccountsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAccountsResponse();
                        if (object.accounts) {
                            if (!Array.isArray(object.accounts))
                                throw TypeError(".palexy.streaming.v1.ListAccountsResponse.accounts: array expected");
                            message.accounts = [];
                            for (var i = 0; i < object.accounts.length; ++i) {
                                if (typeof object.accounts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAccountsResponse.accounts: object expected");
                                message.accounts[i] = $root.palexy.streaming.v1.Account.fromObject(object.accounts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccountsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListAccountsResponse} message ListAccountsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccountsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.accounts = [];
                        if (message.accounts && message.accounts.length) {
                            object.accounts = [];
                            for (var j = 0; j < message.accounts.length; ++j)
                                object.accounts[j] = $root.palexy.streaming.v1.Account.toObject(message.accounts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListAccountsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAccountsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccountsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccountsResponse;
                })();
    
                v1.GetAccountRequest = (function() {
    
                    /**
                     * Properties of a GetAccountRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetAccountRequest
                     * @property {number|null} [id] GetAccountRequest id
                     * @property {string|null} [username] GetAccountRequest username
                     */
    
                    /**
                     * Constructs a new GetAccountRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetAccountRequest.
                     * @implements IGetAccountRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetAccountRequest=} [properties] Properties to set
                     */
                    function GetAccountRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAccountRequest id.
                     * @member {number|null|undefined} id
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @instance
                     */
                    GetAccountRequest.prototype.id = null;
    
                    /**
                     * GetAccountRequest username.
                     * @member {string|null|undefined} username
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @instance
                     */
                    GetAccountRequest.prototype.username = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * GetAccountRequest keyFilter.
                     * @member {"id"|"username"|undefined} keyFilter
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @instance
                     */
                    Object.defineProperty(GetAccountRequest.prototype, "keyFilter", {
                        get: $util.oneOfGetter($oneOfFields = ["id", "username"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new GetAccountRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAccountRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetAccountRequest} GetAccountRequest instance
                     */
                    GetAccountRequest.create = function create(properties) {
                        return new GetAccountRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetAccountRequest message. Does not implicitly {@link palexy.streaming.v1.GetAccountRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAccountRequest} message GetAccountRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAccountRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetAccountRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAccountRequest} message GetAccountRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAccountRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetAccountRequest} GetAccountRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetAccountRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAccountRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetAccountRequest} GetAccountRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAccountRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAccountRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id")) {
                            properties.keyFilter = 1;
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        }
                        if (message.username != null && message.hasOwnProperty("username")) {
                            if (properties.keyFilter === 1)
                                return "keyFilter: multiple values";
                            properties.keyFilter = 1;
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetAccountRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetAccountRequest} GetAccountRequest
                     */
                    GetAccountRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetAccountRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetAccountRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAccountRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.GetAccountRequest} message GetAccountRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAccountRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.id != null && message.hasOwnProperty("id")) {
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                            if (options.oneofs)
                                object.keyFilter = "id";
                        }
                        if (message.username != null && message.hasOwnProperty("username")) {
                            object.username = message.username;
                            if (options.oneofs)
                                object.keyFilter = "username";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetAccountRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetAccountRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAccountRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAccountRequest;
                })();
    
                v1.ListAccountsRequest = (function() {
    
                    /**
                     * Properties of a ListAccountsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListAccountsRequest
                     * @property {Array.<string>|null} [usernames] ListAccountsRequest usernames
                     * @property {boolean|null} [includeDisabledAccounts] ListAccountsRequest includeDisabledAccounts
                     */
    
                    /**
                     * Constructs a new ListAccountsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAccountsRequest.
                     * @implements IListAccountsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListAccountsRequest=} [properties] Properties to set
                     */
                    function ListAccountsRequest(properties) {
                        this.usernames = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccountsRequest usernames.
                     * @member {Array.<string>} usernames
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @instance
                     */
                    ListAccountsRequest.prototype.usernames = $util.emptyArray;
    
                    /**
                     * ListAccountsRequest includeDisabledAccounts.
                     * @member {boolean} includeDisabledAccounts
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @instance
                     */
                    ListAccountsRequest.prototype.includeDisabledAccounts = false;
    
                    /**
                     * Creates a new ListAccountsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAccountsRequest} ListAccountsRequest instance
                     */
                    ListAccountsRequest.create = function create(properties) {
                        return new ListAccountsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccountsRequest message. Does not implicitly {@link palexy.streaming.v1.ListAccountsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsRequest} message ListAccountsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccountsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.usernames != null && message.usernames.length)
                            for (var i = 0; i < message.usernames.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.usernames[i]);
                        if (message.includeDisabledAccounts != null && Object.hasOwnProperty.call(message, "includeDisabledAccounts"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeDisabledAccounts);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccountsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAccountsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccountsRequest} message ListAccountsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccountsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccountsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAccountsRequest} ListAccountsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccountsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAccountsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.usernames && message.usernames.length))
                                    message.usernames = [];
                                message.usernames.push(reader.string());
                                break;
                            case 2:
                                message.includeDisabledAccounts = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccountsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAccountsRequest} ListAccountsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccountsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccountsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccountsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.usernames != null && message.hasOwnProperty("usernames")) {
                            if (!Array.isArray(message.usernames))
                                return "usernames: array expected";
                            for (var i = 0; i < message.usernames.length; ++i)
                                if (!$util.isString(message.usernames[i]))
                                    return "usernames: string[] expected";
                        }
                        if (message.includeDisabledAccounts != null && message.hasOwnProperty("includeDisabledAccounts"))
                            if (typeof message.includeDisabledAccounts !== "boolean")
                                return "includeDisabledAccounts: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAccountsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAccountsRequest} ListAccountsRequest
                     */
                    ListAccountsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAccountsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAccountsRequest();
                        if (object.usernames) {
                            if (!Array.isArray(object.usernames))
                                throw TypeError(".palexy.streaming.v1.ListAccountsRequest.usernames: array expected");
                            message.usernames = [];
                            for (var i = 0; i < object.usernames.length; ++i)
                                message.usernames[i] = String(object.usernames[i]);
                        }
                        if (object.includeDisabledAccounts != null)
                            message.includeDisabledAccounts = Boolean(object.includeDisabledAccounts);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccountsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListAccountsRequest} message ListAccountsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccountsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.usernames = [];
                        if (options.defaults)
                            object.includeDisabledAccounts = false;
                        if (message.usernames && message.usernames.length) {
                            object.usernames = [];
                            for (var j = 0; j < message.usernames.length; ++j)
                                object.usernames[j] = message.usernames[j];
                        }
                        if (message.includeDisabledAccounts != null && message.hasOwnProperty("includeDisabledAccounts"))
                            object.includeDisabledAccounts = message.includeDisabledAccounts;
                        return object;
                    };
    
                    /**
                     * Converts this ListAccountsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAccountsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccountsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccountsRequest;
                })();
    
                v1.ReportSchedule = (function() {
    
                    /**
                     * Properties of a ReportSchedule.
                     * @memberof palexy.streaming.v1
                     * @interface IReportSchedule
                     * @property {number|null} [id] ReportSchedule id
                     * @property {string|null} [scheduleName] ReportSchedule scheduleName
                     * @property {number|null} [companyId] ReportSchedule companyId
                     * @property {palexy.streaming.v1.ReportSchedule.ScheduleType|null} [type] ReportSchedule type
                     * @property {string|null} [timezone] ReportSchedule timezone
                     * @property {string|null} [startSendingTime] ReportSchedule startSendingTime
                     * @property {palexy.streaming.v1.ReportSchedule.ReportType|null} [reportType] ReportSchedule reportType
                     * @property {number|null} [receiveReportDay] ReportSchedule receiveReportDay
                     * @property {Array.<palexy.streaming.v1.IReportScheduleReceiver>|null} [receivers] ReportSchedule receivers
                     * @property {string|null} [nextSendTime] ReportSchedule nextSendTime
                     * @property {palexy.streaming.v1.IDateRange|null} [latestReportDateRange] ReportSchedule latestReportDateRange
                     * @property {string|null} [customReportId] ReportSchedule customReportId
                     * @property {number|null} [createTimeMs] ReportSchedule createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] ReportSchedule lastUpdateTimeMs
                     * @property {string|null} [appliedDateTimeId] ReportSchedule appliedDateTimeId
                     */
    
                    /**
                     * Constructs a new ReportSchedule.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportSchedule.
                     * @implements IReportSchedule
                     * @constructor
                     * @param {palexy.streaming.v1.IReportSchedule=} [properties] Properties to set
                     */
                    function ReportSchedule(properties) {
                        this.receivers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportSchedule id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportSchedule scheduleName.
                     * @member {string} scheduleName
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.scheduleName = "";
    
                    /**
                     * ReportSchedule companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportSchedule type.
                     * @member {palexy.streaming.v1.ReportSchedule.ScheduleType} type
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.type = 0;
    
                    /**
                     * ReportSchedule timezone.
                     * @member {string} timezone
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.timezone = "";
    
                    /**
                     * ReportSchedule startSendingTime.
                     * @member {string} startSendingTime
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.startSendingTime = "";
    
                    /**
                     * ReportSchedule reportType.
                     * @member {palexy.streaming.v1.ReportSchedule.ReportType} reportType
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.reportType = 0;
    
                    /**
                     * ReportSchedule receiveReportDay.
                     * @member {number} receiveReportDay
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.receiveReportDay = 0;
    
                    /**
                     * ReportSchedule receivers.
                     * @member {Array.<palexy.streaming.v1.IReportScheduleReceiver>} receivers
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.receivers = $util.emptyArray;
    
                    /**
                     * ReportSchedule nextSendTime.
                     * @member {string} nextSendTime
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.nextSendTime = "";
    
                    /**
                     * ReportSchedule latestReportDateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} latestReportDateRange
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.latestReportDateRange = null;
    
                    /**
                     * ReportSchedule customReportId.
                     * @member {string} customReportId
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.customReportId = "";
    
                    /**
                     * ReportSchedule createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportSchedule lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportSchedule appliedDateTimeId.
                     * @member {string} appliedDateTimeId
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     */
                    ReportSchedule.prototype.appliedDateTimeId = "";
    
                    /**
                     * Creates a new ReportSchedule instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {palexy.streaming.v1.IReportSchedule=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportSchedule} ReportSchedule instance
                     */
                    ReportSchedule.create = function create(properties) {
                        return new ReportSchedule(properties);
                    };
    
                    /**
                     * Encodes the specified ReportSchedule message. Does not implicitly {@link palexy.streaming.v1.ReportSchedule.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {palexy.streaming.v1.IReportSchedule} message ReportSchedule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportSchedule.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.scheduleName != null && Object.hasOwnProperty.call(message, "scheduleName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.scheduleName);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.companyId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.type);
                        if (message.timezone != null && Object.hasOwnProperty.call(message, "timezone"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.timezone);
                        if (message.startSendingTime != null && Object.hasOwnProperty.call(message, "startSendingTime"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.startSendingTime);
                        if (message.reportType != null && Object.hasOwnProperty.call(message, "reportType"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.reportType);
                        if (message.receiveReportDay != null && Object.hasOwnProperty.call(message, "receiveReportDay"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.receiveReportDay);
                        if (message.receivers != null && message.receivers.length)
                            for (var i = 0; i < message.receivers.length; ++i)
                                $root.palexy.streaming.v1.ReportScheduleReceiver.encode(message.receivers[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.nextSendTime != null && Object.hasOwnProperty.call(message, "nextSendTime"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.nextSendTime);
                        if (message.latestReportDateRange != null && Object.hasOwnProperty.call(message, "latestReportDateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.latestReportDateRange, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.customReportId != null && Object.hasOwnProperty.call(message, "customReportId"))
                            writer.uint32(/* id 17, wireType 2 =*/138).string(message.customReportId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 19, wireType 0 =*/152).int64(message.lastUpdateTimeMs);
                        if (message.appliedDateTimeId != null && Object.hasOwnProperty.call(message, "appliedDateTimeId"))
                            writer.uint32(/* id 20, wireType 2 =*/162).string(message.appliedDateTimeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportSchedule message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportSchedule.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {palexy.streaming.v1.IReportSchedule} message ReportSchedule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportSchedule message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportSchedule} ReportSchedule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportSchedule.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportSchedule();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.scheduleName = reader.string();
                                break;
                            case 3:
                                message.companyId = reader.int64();
                                break;
                            case 6:
                                message.type = reader.int32();
                                break;
                            case 8:
                                message.timezone = reader.string();
                                break;
                            case 10:
                                message.startSendingTime = reader.string();
                                break;
                            case 12:
                                message.reportType = reader.int32();
                                break;
                            case 13:
                                message.receiveReportDay = reader.int32();
                                break;
                            case 14:
                                if (!(message.receivers && message.receivers.length))
                                    message.receivers = [];
                                message.receivers.push($root.palexy.streaming.v1.ReportScheduleReceiver.decode(reader, reader.uint32()));
                                break;
                            case 15:
                                message.nextSendTime = reader.string();
                                break;
                            case 16:
                                message.latestReportDateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.customReportId = reader.string();
                                break;
                            case 18:
                                message.createTimeMs = reader.int64();
                                break;
                            case 19:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 20:
                                message.appliedDateTimeId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportSchedule message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportSchedule} ReportSchedule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportSchedule.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportSchedule message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportSchedule.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.scheduleName != null && message.hasOwnProperty("scheduleName"))
                            if (!$util.isString(message.scheduleName))
                                return "scheduleName: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            if (!$util.isString(message.timezone))
                                return "timezone: string expected";
                        if (message.startSendingTime != null && message.hasOwnProperty("startSendingTime"))
                            if (!$util.isString(message.startSendingTime))
                                return "startSendingTime: string expected";
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            switch (message.reportType) {
                            default:
                                return "reportType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.receiveReportDay != null && message.hasOwnProperty("receiveReportDay"))
                            if (!$util.isInteger(message.receiveReportDay))
                                return "receiveReportDay: integer expected";
                        if (message.receivers != null && message.hasOwnProperty("receivers")) {
                            if (!Array.isArray(message.receivers))
                                return "receivers: array expected";
                            for (var i = 0; i < message.receivers.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportScheduleReceiver.verify(message.receivers[i]);
                                if (error)
                                    return "receivers." + error;
                            }
                        }
                        if (message.nextSendTime != null && message.hasOwnProperty("nextSendTime"))
                            if (!$util.isString(message.nextSendTime))
                                return "nextSendTime: string expected";
                        if (message.latestReportDateRange != null && message.hasOwnProperty("latestReportDateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.latestReportDateRange);
                            if (error)
                                return "latestReportDateRange." + error;
                        }
                        if (message.customReportId != null && message.hasOwnProperty("customReportId"))
                            if (!$util.isString(message.customReportId))
                                return "customReportId: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.appliedDateTimeId != null && message.hasOwnProperty("appliedDateTimeId"))
                            if (!$util.isString(message.appliedDateTimeId))
                                return "appliedDateTimeId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReportSchedule message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportSchedule} ReportSchedule
                     */
                    ReportSchedule.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportSchedule)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportSchedule();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.scheduleName != null)
                            message.scheduleName = String(object.scheduleName);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "WEEKLY":
                        case 1:
                            message.type = 1;
                            break;
                        case "MONTHLY":
                        case 2:
                            message.type = 2;
                            break;
                        case "DAILY":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        if (object.timezone != null)
                            message.timezone = String(object.timezone);
                        if (object.startSendingTime != null)
                            message.startSendingTime = String(object.startSendingTime);
                        switch (object.reportType) {
                        case "UNKNOWN_REPORT_TYPE":
                        case 0:
                            message.reportType = 0;
                            break;
                        case "BASIC":
                        case 1:
                            message.reportType = 1;
                            break;
                        case "STORE_EVENTS":
                        case 2:
                            message.reportType = 2;
                            break;
                        case "REPORT_STUDIO":
                        case 3:
                            message.reportType = 3;
                            break;
                        }
                        if (object.receiveReportDay != null)
                            message.receiveReportDay = object.receiveReportDay | 0;
                        if (object.receivers) {
                            if (!Array.isArray(object.receivers))
                                throw TypeError(".palexy.streaming.v1.ReportSchedule.receivers: array expected");
                            message.receivers = [];
                            for (var i = 0; i < object.receivers.length; ++i) {
                                if (typeof object.receivers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ReportSchedule.receivers: object expected");
                                message.receivers[i] = $root.palexy.streaming.v1.ReportScheduleReceiver.fromObject(object.receivers[i]);
                            }
                        }
                        if (object.nextSendTime != null)
                            message.nextSendTime = String(object.nextSendTime);
                        if (object.latestReportDateRange != null) {
                            if (typeof object.latestReportDateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.ReportSchedule.latestReportDateRange: object expected");
                            message.latestReportDateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.latestReportDateRange);
                        }
                        if (object.customReportId != null)
                            message.customReportId = String(object.customReportId);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.appliedDateTimeId != null)
                            message.appliedDateTimeId = String(object.appliedDateTimeId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportSchedule message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @static
                     * @param {palexy.streaming.v1.ReportSchedule} message ReportSchedule
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportSchedule.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.receivers = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.scheduleName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.timezone = "";
                            object.startSendingTime = "";
                            object.reportType = options.enums === String ? "UNKNOWN_REPORT_TYPE" : 0;
                            object.receiveReportDay = 0;
                            object.nextSendTime = "";
                            object.latestReportDateRange = null;
                            object.customReportId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.appliedDateTimeId = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.scheduleName != null && message.hasOwnProperty("scheduleName"))
                            object.scheduleName = message.scheduleName;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ScheduleType[message.type] : message.type;
                        if (message.timezone != null && message.hasOwnProperty("timezone"))
                            object.timezone = message.timezone;
                        if (message.startSendingTime != null && message.hasOwnProperty("startSendingTime"))
                            object.startSendingTime = message.startSendingTime;
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            object.reportType = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ReportType[message.reportType] : message.reportType;
                        if (message.receiveReportDay != null && message.hasOwnProperty("receiveReportDay"))
                            object.receiveReportDay = message.receiveReportDay;
                        if (message.receivers && message.receivers.length) {
                            object.receivers = [];
                            for (var j = 0; j < message.receivers.length; ++j)
                                object.receivers[j] = $root.palexy.streaming.v1.ReportScheduleReceiver.toObject(message.receivers[j], options);
                        }
                        if (message.nextSendTime != null && message.hasOwnProperty("nextSendTime"))
                            object.nextSendTime = message.nextSendTime;
                        if (message.latestReportDateRange != null && message.hasOwnProperty("latestReportDateRange"))
                            object.latestReportDateRange = $root.palexy.streaming.v1.DateRange.toObject(message.latestReportDateRange, options);
                        if (message.customReportId != null && message.hasOwnProperty("customReportId"))
                            object.customReportId = message.customReportId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.appliedDateTimeId != null && message.hasOwnProperty("appliedDateTimeId"))
                            object.appliedDateTimeId = message.appliedDateTimeId;
                        return object;
                    };
    
                    /**
                     * Converts this ReportSchedule to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportSchedule
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportSchedule.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ScheduleType enum.
                     * @name palexy.streaming.v1.ReportSchedule.ScheduleType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} WEEKLY=1 WEEKLY value
                     * @property {number} MONTHLY=2 MONTHLY value
                     * @property {number} DAILY=3 DAILY value
                     */
                    ReportSchedule.ScheduleType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "WEEKLY"] = 1;
                        values[valuesById[2] = "MONTHLY"] = 2;
                        values[valuesById[3] = "DAILY"] = 3;
                        return values;
                    })();
    
                    /**
                     * ReportType enum.
                     * @name palexy.streaming.v1.ReportSchedule.ReportType
                     * @enum {number}
                     * @property {number} UNKNOWN_REPORT_TYPE=0 UNKNOWN_REPORT_TYPE value
                     * @property {number} BASIC=1 BASIC value
                     * @property {number} STORE_EVENTS=2 STORE_EVENTS value
                     * @property {number} REPORT_STUDIO=3 REPORT_STUDIO value
                     */
                    ReportSchedule.ReportType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_REPORT_TYPE"] = 0;
                        values[valuesById[1] = "BASIC"] = 1;
                        values[valuesById[2] = "STORE_EVENTS"] = 2;
                        values[valuesById[3] = "REPORT_STUDIO"] = 3;
                        return values;
                    })();
    
                    return ReportSchedule;
                })();
    
                v1.ReportScheduleReceiver = (function() {
    
                    /**
                     * Properties of a ReportScheduleReceiver.
                     * @memberof palexy.streaming.v1
                     * @interface IReportScheduleReceiver
                     * @property {palexy.streaming.v1.ReportScheduleReceiver.Type|null} [type] ReportScheduleReceiver type
                     * @property {string|null} [singleUserEmail] ReportScheduleReceiver singleUserEmail
                     * @property {number|null} [groupId] ReportScheduleReceiver groupId
                     */
    
                    /**
                     * Constructs a new ReportScheduleReceiver.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportScheduleReceiver.
                     * @implements IReportScheduleReceiver
                     * @constructor
                     * @param {palexy.streaming.v1.IReportScheduleReceiver=} [properties] Properties to set
                     */
                    function ReportScheduleReceiver(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportScheduleReceiver type.
                     * @member {palexy.streaming.v1.ReportScheduleReceiver.Type} type
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @instance
                     */
                    ReportScheduleReceiver.prototype.type = 0;
    
                    /**
                     * ReportScheduleReceiver singleUserEmail.
                     * @member {string|null|undefined} singleUserEmail
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @instance
                     */
                    ReportScheduleReceiver.prototype.singleUserEmail = null;
    
                    /**
                     * ReportScheduleReceiver groupId.
                     * @member {number|null|undefined} groupId
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @instance
                     */
                    ReportScheduleReceiver.prototype.groupId = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ReportScheduleReceiver receiver.
                     * @member {"singleUserEmail"|"groupId"|undefined} receiver
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @instance
                     */
                    Object.defineProperty(ReportScheduleReceiver.prototype, "receiver", {
                        get: $util.oneOfGetter($oneOfFields = ["singleUserEmail", "groupId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ReportScheduleReceiver instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleReceiver=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportScheduleReceiver} ReportScheduleReceiver instance
                     */
                    ReportScheduleReceiver.create = function create(properties) {
                        return new ReportScheduleReceiver(properties);
                    };
    
                    /**
                     * Encodes the specified ReportScheduleReceiver message. Does not implicitly {@link palexy.streaming.v1.ReportScheduleReceiver.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleReceiver} message ReportScheduleReceiver message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportScheduleReceiver.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.singleUserEmail != null && Object.hasOwnProperty.call(message, "singleUserEmail"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.singleUserEmail);
                        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.groupId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportScheduleReceiver message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportScheduleReceiver.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleReceiver} message ReportScheduleReceiver message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportScheduleReceiver.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportScheduleReceiver message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportScheduleReceiver} ReportScheduleReceiver
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportScheduleReceiver.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportScheduleReceiver();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.singleUserEmail = reader.string();
                                break;
                            case 3:
                                message.groupId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportScheduleReceiver message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportScheduleReceiver} ReportScheduleReceiver
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportScheduleReceiver.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportScheduleReceiver message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportScheduleReceiver.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.singleUserEmail != null && message.hasOwnProperty("singleUserEmail")) {
                            properties.receiver = 1;
                            if (!$util.isString(message.singleUserEmail))
                                return "singleUserEmail: string expected";
                        }
                        if (message.groupId != null && message.hasOwnProperty("groupId")) {
                            if (properties.receiver === 1)
                                return "receiver: multiple values";
                            properties.receiver = 1;
                            if (!$util.isInteger(message.groupId) && !(message.groupId && $util.isInteger(message.groupId.low) && $util.isInteger(message.groupId.high)))
                                return "groupId: integer|Long expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ReportScheduleReceiver message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportScheduleReceiver} ReportScheduleReceiver
                     */
                    ReportScheduleReceiver.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportScheduleReceiver)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportScheduleReceiver();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "SINGLE_USER":
                        case 1:
                            message.type = 1;
                            break;
                        case "ICA_GROUP":
                        case 2:
                            message.type = 2;
                            break;
                        }
                        if (object.singleUserEmail != null)
                            message.singleUserEmail = String(object.singleUserEmail);
                        if (object.groupId != null)
                            if ($util.Long)
                                (message.groupId = $util.Long.fromValue(object.groupId)).unsigned = false;
                            else if (typeof object.groupId === "string")
                                message.groupId = parseInt(object.groupId, 10);
                            else if (typeof object.groupId === "number")
                                message.groupId = object.groupId;
                            else if (typeof object.groupId === "object")
                                message.groupId = new $util.LongBits(object.groupId.low >>> 0, object.groupId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportScheduleReceiver message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @static
                     * @param {palexy.streaming.v1.ReportScheduleReceiver} message ReportScheduleReceiver
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportScheduleReceiver.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.ReportScheduleReceiver.Type[message.type] : message.type;
                        if (message.singleUserEmail != null && message.hasOwnProperty("singleUserEmail")) {
                            object.singleUserEmail = message.singleUserEmail;
                            if (options.oneofs)
                                object.receiver = "singleUserEmail";
                        }
                        if (message.groupId != null && message.hasOwnProperty("groupId")) {
                            if (typeof message.groupId === "number")
                                object.groupId = options.longs === String ? String(message.groupId) : message.groupId;
                            else
                                object.groupId = options.longs === String ? $util.Long.prototype.toString.call(message.groupId) : options.longs === Number ? new $util.LongBits(message.groupId.low >>> 0, message.groupId.high >>> 0).toNumber() : message.groupId;
                            if (options.oneofs)
                                object.receiver = "groupId";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ReportScheduleReceiver to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportScheduleReceiver
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportScheduleReceiver.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Type enum.
                     * @name palexy.streaming.v1.ReportScheduleReceiver.Type
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} SINGLE_USER=1 SINGLE_USER value
                     * @property {number} ICA_GROUP=2 ICA_GROUP value
                     */
                    ReportScheduleReceiver.Type = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "SINGLE_USER"] = 1;
                        values[valuesById[2] = "ICA_GROUP"] = 2;
                        return values;
                    })();
    
                    return ReportScheduleReceiver;
                })();
    
                v1.ListReportScheduleReceiverRequest = (function() {
    
                    /**
                     * Properties of a ListReportScheduleReceiverRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListReportScheduleReceiverRequest
                     * @property {number|null} [scheduleId] ListReportScheduleReceiverRequest scheduleId
                     */
    
                    /**
                     * Constructs a new ListReportScheduleReceiverRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListReportScheduleReceiverRequest.
                     * @implements IListReportScheduleReceiverRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest=} [properties] Properties to set
                     */
                    function ListReportScheduleReceiverRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReportScheduleReceiverRequest scheduleId.
                     * @member {number} scheduleId
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @instance
                     */
                    ListReportScheduleReceiverRequest.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListReportScheduleReceiverRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverRequest} ListReportScheduleReceiverRequest instance
                     */
                    ListReportScheduleReceiverRequest.create = function create(properties) {
                        return new ListReportScheduleReceiverRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleReceiverRequest message. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleReceiverRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest} message ListReportScheduleReceiverRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleReceiverRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.scheduleId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleReceiverRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleReceiverRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest} message ListReportScheduleReceiverRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleReceiverRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReportScheduleReceiverRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverRequest} ListReportScheduleReceiverRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleReceiverRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReportScheduleReceiverRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReportScheduleReceiverRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverRequest} ListReportScheduleReceiverRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleReceiverRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReportScheduleReceiverRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReportScheduleReceiverRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                return "scheduleId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReportScheduleReceiverRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverRequest} ListReportScheduleReceiverRequest
                     */
                    ListReportScheduleReceiverRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListReportScheduleReceiverRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListReportScheduleReceiverRequest();
                        if (object.scheduleId != null)
                            if ($util.Long)
                                (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                            else if (typeof object.scheduleId === "string")
                                message.scheduleId = parseInt(object.scheduleId, 10);
                            else if (typeof object.scheduleId === "number")
                                message.scheduleId = object.scheduleId;
                            else if (typeof object.scheduleId === "object")
                                message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReportScheduleReceiverRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.ListReportScheduleReceiverRequest} message ListReportScheduleReceiverRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReportScheduleReceiverRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleId = options.longs === String ? "0" : 0;
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (typeof message.scheduleId === "number")
                                object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                            else
                                object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                        return object;
                    };
    
                    /**
                     * Converts this ListReportScheduleReceiverRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReportScheduleReceiverRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListReportScheduleReceiverRequest;
                })();
    
                v1.ListReportScheduleReceiverResponse = (function() {
    
                    /**
                     * Properties of a ListReportScheduleReceiverResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListReportScheduleReceiverResponse
                     * @property {Array.<palexy.streaming.v1.IReportScheduleReceiver>|null} [receivers] ListReportScheduleReceiverResponse receivers
                     */
    
                    /**
                     * Constructs a new ListReportScheduleReceiverResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListReportScheduleReceiverResponse.
                     * @implements IListReportScheduleReceiverResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverResponse=} [properties] Properties to set
                     */
                    function ListReportScheduleReceiverResponse(properties) {
                        this.receivers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReportScheduleReceiverResponse receivers.
                     * @member {Array.<palexy.streaming.v1.IReportScheduleReceiver>} receivers
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @instance
                     */
                    ListReportScheduleReceiverResponse.prototype.receivers = $util.emptyArray;
    
                    /**
                     * Creates a new ListReportScheduleReceiverResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverResponse} ListReportScheduleReceiverResponse instance
                     */
                    ListReportScheduleReceiverResponse.create = function create(properties) {
                        return new ListReportScheduleReceiverResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleReceiverResponse message. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleReceiverResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverResponse} message ListReportScheduleReceiverResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleReceiverResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.receivers != null && message.receivers.length)
                            for (var i = 0; i < message.receivers.length; ++i)
                                $root.palexy.streaming.v1.ReportScheduleReceiver.encode(message.receivers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleReceiverResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleReceiverResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverResponse} message ListReportScheduleReceiverResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleReceiverResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReportScheduleReceiverResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverResponse} ListReportScheduleReceiverResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleReceiverResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReportScheduleReceiverResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.receivers && message.receivers.length))
                                    message.receivers = [];
                                message.receivers.push($root.palexy.streaming.v1.ReportScheduleReceiver.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReportScheduleReceiverResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverResponse} ListReportScheduleReceiverResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleReceiverResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReportScheduleReceiverResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReportScheduleReceiverResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.receivers != null && message.hasOwnProperty("receivers")) {
                            if (!Array.isArray(message.receivers))
                                return "receivers: array expected";
                            for (var i = 0; i < message.receivers.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportScheduleReceiver.verify(message.receivers[i]);
                                if (error)
                                    return "receivers." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListReportScheduleReceiverResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListReportScheduleReceiverResponse} ListReportScheduleReceiverResponse
                     */
                    ListReportScheduleReceiverResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListReportScheduleReceiverResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListReportScheduleReceiverResponse();
                        if (object.receivers) {
                            if (!Array.isArray(object.receivers))
                                throw TypeError(".palexy.streaming.v1.ListReportScheduleReceiverResponse.receivers: array expected");
                            message.receivers = [];
                            for (var i = 0; i < object.receivers.length; ++i) {
                                if (typeof object.receivers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleReceiverResponse.receivers: object expected");
                                message.receivers[i] = $root.palexy.streaming.v1.ReportScheduleReceiver.fromObject(object.receivers[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReportScheduleReceiverResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.ListReportScheduleReceiverResponse} message ListReportScheduleReceiverResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReportScheduleReceiverResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.receivers = [];
                        if (message.receivers && message.receivers.length) {
                            object.receivers = [];
                            for (var j = 0; j < message.receivers.length; ++j)
                                object.receivers[j] = $root.palexy.streaming.v1.ReportScheduleReceiver.toObject(message.receivers[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListReportScheduleReceiverResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListReportScheduleReceiverResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReportScheduleReceiverResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListReportScheduleReceiverResponse;
                })();
    
                v1.ListAccessibleStoresRequest = (function() {
    
                    /**
                     * Properties of a ListAccessibleStoresRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListAccessibleStoresRequest
                     * @property {string|null} [accountEmail] ListAccessibleStoresRequest accountEmail
                     * @property {number|null} [companyId] ListAccessibleStoresRequest companyId
                     */
    
                    /**
                     * Constructs a new ListAccessibleStoresRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAccessibleStoresRequest.
                     * @implements IListAccessibleStoresRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest=} [properties] Properties to set
                     */
                    function ListAccessibleStoresRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccessibleStoresRequest accountEmail.
                     * @member {string} accountEmail
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @instance
                     */
                    ListAccessibleStoresRequest.prototype.accountEmail = "";
    
                    /**
                     * ListAccessibleStoresRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @instance
                     */
                    ListAccessibleStoresRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListAccessibleStoresRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAccessibleStoresRequest} ListAccessibleStoresRequest instance
                     */
                    ListAccessibleStoresRequest.create = function create(properties) {
                        return new ListAccessibleStoresRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccessibleStoresRequest message. Does not implicitly {@link palexy.streaming.v1.ListAccessibleStoresRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest} message ListAccessibleStoresRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccessibleStoresRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accountEmail != null && Object.hasOwnProperty.call(message, "accountEmail"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountEmail);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccessibleStoresRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAccessibleStoresRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest} message ListAccessibleStoresRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccessibleStoresRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccessibleStoresRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAccessibleStoresRequest} ListAccessibleStoresRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccessibleStoresRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAccessibleStoresRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.accountEmail = reader.string();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccessibleStoresRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAccessibleStoresRequest} ListAccessibleStoresRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccessibleStoresRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccessibleStoresRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccessibleStoresRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accountEmail != null && message.hasOwnProperty("accountEmail"))
                            if (!$util.isString(message.accountEmail))
                                return "accountEmail: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAccessibleStoresRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAccessibleStoresRequest} ListAccessibleStoresRequest
                     */
                    ListAccessibleStoresRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAccessibleStoresRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAccessibleStoresRequest();
                        if (object.accountEmail != null)
                            message.accountEmail = String(object.accountEmail);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccessibleStoresRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @static
                     * @param {palexy.streaming.v1.ListAccessibleStoresRequest} message ListAccessibleStoresRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccessibleStoresRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.accountEmail = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.accountEmail != null && message.hasOwnProperty("accountEmail"))
                            object.accountEmail = message.accountEmail;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListAccessibleStoresRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAccessibleStoresRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccessibleStoresRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccessibleStoresRequest;
                })();
    
                v1.ListAccessibleStoresResponse = (function() {
    
                    /**
                     * Properties of a ListAccessibleStoresResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListAccessibleStoresResponse
                     * @property {Array.<palexy.streaming.v1.IStore>|null} [stores] ListAccessibleStoresResponse stores
                     * @property {number|null} [accountId] ListAccessibleStoresResponse accountId
                     */
    
                    /**
                     * Constructs a new ListAccessibleStoresResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAccessibleStoresResponse.
                     * @implements IListAccessibleStoresResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListAccessibleStoresResponse=} [properties] Properties to set
                     */
                    function ListAccessibleStoresResponse(properties) {
                        this.stores = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAccessibleStoresResponse stores.
                     * @member {Array.<palexy.streaming.v1.IStore>} stores
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @instance
                     */
                    ListAccessibleStoresResponse.prototype.stores = $util.emptyArray;
    
                    /**
                     * ListAccessibleStoresResponse accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @instance
                     */
                    ListAccessibleStoresResponse.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListAccessibleStoresResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAccessibleStoresResponse} ListAccessibleStoresResponse instance
                     */
                    ListAccessibleStoresResponse.create = function create(properties) {
                        return new ListAccessibleStoresResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAccessibleStoresResponse message. Does not implicitly {@link palexy.streaming.v1.ListAccessibleStoresResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresResponse} message ListAccessibleStoresResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccessibleStoresResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.stores != null && message.stores.length)
                            for (var i = 0; i < message.stores.length; ++i)
                                $root.palexy.streaming.v1.Store.encode(message.stores[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.accountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAccessibleStoresResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAccessibleStoresResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAccessibleStoresResponse} message ListAccessibleStoresResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAccessibleStoresResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAccessibleStoresResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAccessibleStoresResponse} ListAccessibleStoresResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccessibleStoresResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAccessibleStoresResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.stores && message.stores.length))
                                    message.stores = [];
                                message.stores.push($root.palexy.streaming.v1.Store.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.accountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAccessibleStoresResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAccessibleStoresResponse} ListAccessibleStoresResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAccessibleStoresResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAccessibleStoresResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAccessibleStoresResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.stores != null && message.hasOwnProperty("stores")) {
                            if (!Array.isArray(message.stores))
                                return "stores: array expected";
                            for (var i = 0; i < message.stores.length; ++i) {
                                var error = $root.palexy.streaming.v1.Store.verify(message.stores[i]);
                                if (error)
                                    return "stores." + error;
                            }
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAccessibleStoresResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAccessibleStoresResponse} ListAccessibleStoresResponse
                     */
                    ListAccessibleStoresResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAccessibleStoresResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAccessibleStoresResponse();
                        if (object.stores) {
                            if (!Array.isArray(object.stores))
                                throw TypeError(".palexy.streaming.v1.ListAccessibleStoresResponse.stores: array expected");
                            message.stores = [];
                            for (var i = 0; i < object.stores.length; ++i) {
                                if (typeof object.stores[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAccessibleStoresResponse.stores: object expected");
                                message.stores[i] = $root.palexy.streaming.v1.Store.fromObject(object.stores[i]);
                            }
                        }
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAccessibleStoresResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @static
                     * @param {palexy.streaming.v1.ListAccessibleStoresResponse} message ListAccessibleStoresResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAccessibleStoresResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.stores = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                        if (message.stores && message.stores.length) {
                            object.stores = [];
                            for (var j = 0; j < message.stores.length; ++j)
                                object.stores[j] = $root.palexy.streaming.v1.Store.toObject(message.stores[j], options);
                        }
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        return object;
                    };
    
                    /**
                     * Converts this ListAccessibleStoresResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAccessibleStoresResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAccessibleStoresResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAccessibleStoresResponse;
                })();
    
                v1.ScheduledReportService = (function() {
    
                    /**
                     * Constructs a new ScheduledReportService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledReportService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ScheduledReportService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ScheduledReportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScheduledReportService;
    
                    /**
                     * Creates new ScheduledReportService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ScheduledReportService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ScheduledReportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#getEmailsFromReceiver}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef GetEmailsFromReceiverCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetEmailsFromReceiverResponse} [response] GetEmailsFromReceiverResponse
                     */
    
                    /**
                     * Calls GetEmailsFromReceiver.
                     * @function getEmailsFromReceiver
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest} request GetEmailsFromReceiverRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.GetEmailsFromReceiverCallback} callback Node-style callback called with the error, if any, and GetEmailsFromReceiverResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.getEmailsFromReceiver = function getEmailsFromReceiver(request, callback) {
                        return this.rpcCall(getEmailsFromReceiver, $root.palexy.streaming.v1.GetEmailsFromReceiverRequest, $root.palexy.streaming.v1.GetEmailsFromReceiverResponse, request, callback);
                    }, "name", { value: "GetEmailsFromReceiver" });
    
                    /**
                     * Calls GetEmailsFromReceiver.
                     * @function getEmailsFromReceiver
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest} request GetEmailsFromReceiverRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetEmailsFromReceiverResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#listReportScheduleReceiver}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef ListReportScheduleReceiverCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListReportScheduleReceiverResponse} [response] ListReportScheduleReceiverResponse
                     */
    
                    /**
                     * Calls ListReportScheduleReceiver.
                     * @function listReportScheduleReceiver
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest} request ListReportScheduleReceiverRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.ListReportScheduleReceiverCallback} callback Node-style callback called with the error, if any, and ListReportScheduleReceiverResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.listReportScheduleReceiver = function listReportScheduleReceiver(request, callback) {
                        return this.rpcCall(listReportScheduleReceiver, $root.palexy.streaming.v1.ListReportScheduleReceiverRequest, $root.palexy.streaming.v1.ListReportScheduleReceiverResponse, request, callback);
                    }, "name", { value: "ListReportScheduleReceiver" });
    
                    /**
                     * Calls ListReportScheduleReceiver.
                     * @function listReportScheduleReceiver
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListReportScheduleReceiverRequest} request ListReportScheduleReceiverRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListReportScheduleReceiverResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#listAccessibleStores}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef ListAccessibleStoresCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAccessibleStoresResponse} [response] ListAccessibleStoresResponse
                     */
    
                    /**
                     * Calls ListAccessibleStores.
                     * @function listAccessibleStores
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest} request ListAccessibleStoresRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.ListAccessibleStoresCallback} callback Node-style callback called with the error, if any, and ListAccessibleStoresResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.listAccessibleStores = function listAccessibleStores(request, callback) {
                        return this.rpcCall(listAccessibleStores, $root.palexy.streaming.v1.ListAccessibleStoresRequest, $root.palexy.streaming.v1.ListAccessibleStoresResponse, request, callback);
                    }, "name", { value: "ListAccessibleStores" });
    
                    /**
                     * Calls ListAccessibleStores.
                     * @function listAccessibleStores
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListAccessibleStoresRequest} request ListAccessibleStoresRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAccessibleStoresResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#getScheduledReport}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef GetScheduledReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetScheduledReportResponse} [response] GetScheduledReportResponse
                     */
    
                    /**
                     * Calls GetScheduledReport.
                     * @function getScheduledReport
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest} request GetScheduledReportRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.GetScheduledReportCallback} callback Node-style callback called with the error, if any, and GetScheduledReportResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.getScheduledReport = function getScheduledReport(request, callback) {
                        return this.rpcCall(getScheduledReport, $root.palexy.streaming.v1.GetScheduledReportRequest, $root.palexy.streaming.v1.GetScheduledReportResponse, request, callback);
                    }, "name", { value: "GetScheduledReport" });
    
                    /**
                     * Calls GetScheduledReport.
                     * @function getScheduledReport
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest} request GetScheduledReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetScheduledReportResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#updateNextSendTime}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef UpdateNextSendTimeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.UpdateNextSendTimeResponse} [response] UpdateNextSendTimeResponse
                     */
    
                    /**
                     * Calls UpdateNextSendTime.
                     * @function updateNextSendTime
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest} request UpdateNextSendTimeRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.UpdateNextSendTimeCallback} callback Node-style callback called with the error, if any, and UpdateNextSendTimeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.updateNextSendTime = function updateNextSendTime(request, callback) {
                        return this.rpcCall(updateNextSendTime, $root.palexy.streaming.v1.UpdateNextSendTimeRequest, $root.palexy.streaming.v1.UpdateNextSendTimeResponse, request, callback);
                    }, "name", { value: "UpdateNextSendTime" });
    
                    /**
                     * Calls UpdateNextSendTime.
                     * @function updateNextSendTime
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest} request UpdateNextSendTimeRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.UpdateNextSendTimeResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#listReportSchedule}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef ListReportScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListReportScheduleResponse} [response] ListReportScheduleResponse
                     */
    
                    /**
                     * Calls ListReportSchedule.
                     * @function listReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListReportScheduleRequest} request ListReportScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.ListReportScheduleCallback} callback Node-style callback called with the error, if any, and ListReportScheduleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.listReportSchedule = function listReportSchedule(request, callback) {
                        return this.rpcCall(listReportSchedule, $root.palexy.streaming.v1.ListReportScheduleRequest, $root.palexy.streaming.v1.ListReportScheduleResponse, request, callback);
                    }, "name", { value: "ListReportSchedule" });
    
                    /**
                     * Calls ListReportSchedule.
                     * @function listReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListReportScheduleRequest} request ListReportScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListReportScheduleResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#createReportSchedule}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef CreateReportScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReportSchedule} [response] ReportSchedule
                     */
    
                    /**
                     * Calls CreateReportSchedule.
                     * @function createReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest} request CreateReportScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.CreateReportScheduleCallback} callback Node-style callback called with the error, if any, and ReportSchedule
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.createReportSchedule = function createReportSchedule(request, callback) {
                        return this.rpcCall(createReportSchedule, $root.palexy.streaming.v1.CreateReportScheduleRequest, $root.palexy.streaming.v1.ReportSchedule, request, callback);
                    }, "name", { value: "CreateReportSchedule" });
    
                    /**
                     * Calls CreateReportSchedule.
                     * @function createReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest} request CreateReportScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReportSchedule>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#getReportSchedule}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef GetReportScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReportSchedule} [response] ReportSchedule
                     */
    
                    /**
                     * Calls GetReportSchedule.
                     * @function getReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest} request GetReportScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.GetReportScheduleCallback} callback Node-style callback called with the error, if any, and ReportSchedule
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.getReportSchedule = function getReportSchedule(request, callback) {
                        return this.rpcCall(getReportSchedule, $root.palexy.streaming.v1.GetReportScheduleRequest, $root.palexy.streaming.v1.ReportSchedule, request, callback);
                    }, "name", { value: "GetReportSchedule" });
    
                    /**
                     * Calls GetReportSchedule.
                     * @function getReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest} request GetReportScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReportSchedule>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#updateReportSchedule}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef UpdateReportScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReportSchedule} [response] ReportSchedule
                     */
    
                    /**
                     * Calls UpdateReportSchedule.
                     * @function updateReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest} request UpdateReportScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.UpdateReportScheduleCallback} callback Node-style callback called with the error, if any, and ReportSchedule
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.updateReportSchedule = function updateReportSchedule(request, callback) {
                        return this.rpcCall(updateReportSchedule, $root.palexy.streaming.v1.UpdateReportScheduleRequest, $root.palexy.streaming.v1.ReportSchedule, request, callback);
                    }, "name", { value: "UpdateReportSchedule" });
    
                    /**
                     * Calls UpdateReportSchedule.
                     * @function updateReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest} request UpdateReportScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReportSchedule>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#deleteReportSchedule}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef DeleteReportScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteReportSchedule.
                     * @function deleteReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest} request DeleteReportScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.DeleteReportScheduleCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.deleteReportSchedule = function deleteReportSchedule(request, callback) {
                        return this.rpcCall(deleteReportSchedule, $root.palexy.streaming.v1.DeleteReportScheduleRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteReportSchedule" });
    
                    /**
                     * Calls DeleteReportSchedule.
                     * @function deleteReportSchedule
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest} request DeleteReportScheduleRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledReportService#sendOutReport}.
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @typedef SendOutReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendOutReport.
                     * @function sendOutReport
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.ISendOutReportRequest} request SendOutReportRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledReportService.SendOutReportCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledReportService.prototype.sendOutReport = function sendOutReport(request, callback) {
                        return this.rpcCall(sendOutReport, $root.palexy.streaming.v1.SendOutReportRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendOutReport" });
    
                    /**
                     * Calls SendOutReport.
                     * @function sendOutReport
                     * @memberof palexy.streaming.v1.ScheduledReportService
                     * @instance
                     * @param {palexy.streaming.v1.ISendOutReportRequest} request SendOutReportRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return ScheduledReportService;
                })();
    
                v1.GetEmailsFromReceiverRequest = (function() {
    
                    /**
                     * Properties of a GetEmailsFromReceiverRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetEmailsFromReceiverRequest
                     * @property {Array.<palexy.streaming.v1.IReportScheduleReceiver>|null} [receivers] GetEmailsFromReceiverRequest receivers
                     */
    
                    /**
                     * Constructs a new GetEmailsFromReceiverRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetEmailsFromReceiverRequest.
                     * @implements IGetEmailsFromReceiverRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest=} [properties] Properties to set
                     */
                    function GetEmailsFromReceiverRequest(properties) {
                        this.receivers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetEmailsFromReceiverRequest receivers.
                     * @member {Array.<palexy.streaming.v1.IReportScheduleReceiver>} receivers
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @instance
                     */
                    GetEmailsFromReceiverRequest.prototype.receivers = $util.emptyArray;
    
                    /**
                     * Creates a new GetEmailsFromReceiverRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverRequest} GetEmailsFromReceiverRequest instance
                     */
                    GetEmailsFromReceiverRequest.create = function create(properties) {
                        return new GetEmailsFromReceiverRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetEmailsFromReceiverRequest message. Does not implicitly {@link palexy.streaming.v1.GetEmailsFromReceiverRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest} message GetEmailsFromReceiverRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmailsFromReceiverRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.receivers != null && message.receivers.length)
                            for (var i = 0; i < message.receivers.length; ++i)
                                $root.palexy.streaming.v1.ReportScheduleReceiver.encode(message.receivers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetEmailsFromReceiverRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetEmailsFromReceiverRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverRequest} message GetEmailsFromReceiverRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmailsFromReceiverRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetEmailsFromReceiverRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverRequest} GetEmailsFromReceiverRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmailsFromReceiverRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetEmailsFromReceiverRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.receivers && message.receivers.length))
                                    message.receivers = [];
                                message.receivers.push($root.palexy.streaming.v1.ReportScheduleReceiver.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetEmailsFromReceiverRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverRequest} GetEmailsFromReceiverRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmailsFromReceiverRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetEmailsFromReceiverRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetEmailsFromReceiverRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.receivers != null && message.hasOwnProperty("receivers")) {
                            if (!Array.isArray(message.receivers))
                                return "receivers: array expected";
                            for (var i = 0; i < message.receivers.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportScheduleReceiver.verify(message.receivers[i]);
                                if (error)
                                    return "receivers." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetEmailsFromReceiverRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverRequest} GetEmailsFromReceiverRequest
                     */
                    GetEmailsFromReceiverRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetEmailsFromReceiverRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetEmailsFromReceiverRequest();
                        if (object.receivers) {
                            if (!Array.isArray(object.receivers))
                                throw TypeError(".palexy.streaming.v1.GetEmailsFromReceiverRequest.receivers: array expected");
                            message.receivers = [];
                            for (var i = 0; i < object.receivers.length; ++i) {
                                if (typeof object.receivers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetEmailsFromReceiverRequest.receivers: object expected");
                                message.receivers[i] = $root.palexy.streaming.v1.ReportScheduleReceiver.fromObject(object.receivers[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetEmailsFromReceiverRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @static
                     * @param {palexy.streaming.v1.GetEmailsFromReceiverRequest} message GetEmailsFromReceiverRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetEmailsFromReceiverRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.receivers = [];
                        if (message.receivers && message.receivers.length) {
                            object.receivers = [];
                            for (var j = 0; j < message.receivers.length; ++j)
                                object.receivers[j] = $root.palexy.streaming.v1.ReportScheduleReceiver.toObject(message.receivers[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetEmailsFromReceiverRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetEmailsFromReceiverRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetEmailsFromReceiverRequest;
                })();
    
                v1.GetEmailsFromReceiverResponse = (function() {
    
                    /**
                     * Properties of a GetEmailsFromReceiverResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetEmailsFromReceiverResponse
                     * @property {Array.<string>|null} [emails] GetEmailsFromReceiverResponse emails
                     */
    
                    /**
                     * Constructs a new GetEmailsFromReceiverResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetEmailsFromReceiverResponse.
                     * @implements IGetEmailsFromReceiverResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverResponse=} [properties] Properties to set
                     */
                    function GetEmailsFromReceiverResponse(properties) {
                        this.emails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetEmailsFromReceiverResponse emails.
                     * @member {Array.<string>} emails
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @instance
                     */
                    GetEmailsFromReceiverResponse.prototype.emails = $util.emptyArray;
    
                    /**
                     * Creates a new GetEmailsFromReceiverResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverResponse} GetEmailsFromReceiverResponse instance
                     */
                    GetEmailsFromReceiverResponse.create = function create(properties) {
                        return new GetEmailsFromReceiverResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetEmailsFromReceiverResponse message. Does not implicitly {@link palexy.streaming.v1.GetEmailsFromReceiverResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverResponse} message GetEmailsFromReceiverResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmailsFromReceiverResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.emails != null && message.emails.length)
                            for (var i = 0; i < message.emails.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.emails[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetEmailsFromReceiverResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetEmailsFromReceiverResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetEmailsFromReceiverResponse} message GetEmailsFromReceiverResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmailsFromReceiverResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetEmailsFromReceiverResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverResponse} GetEmailsFromReceiverResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmailsFromReceiverResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetEmailsFromReceiverResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.emails && message.emails.length))
                                    message.emails = [];
                                message.emails.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetEmailsFromReceiverResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverResponse} GetEmailsFromReceiverResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmailsFromReceiverResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetEmailsFromReceiverResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetEmailsFromReceiverResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.emails != null && message.hasOwnProperty("emails")) {
                            if (!Array.isArray(message.emails))
                                return "emails: array expected";
                            for (var i = 0; i < message.emails.length; ++i)
                                if (!$util.isString(message.emails[i]))
                                    return "emails: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetEmailsFromReceiverResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetEmailsFromReceiverResponse} GetEmailsFromReceiverResponse
                     */
                    GetEmailsFromReceiverResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetEmailsFromReceiverResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetEmailsFromReceiverResponse();
                        if (object.emails) {
                            if (!Array.isArray(object.emails))
                                throw TypeError(".palexy.streaming.v1.GetEmailsFromReceiverResponse.emails: array expected");
                            message.emails = [];
                            for (var i = 0; i < object.emails.length; ++i)
                                message.emails[i] = String(object.emails[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetEmailsFromReceiverResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @static
                     * @param {palexy.streaming.v1.GetEmailsFromReceiverResponse} message GetEmailsFromReceiverResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetEmailsFromReceiverResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.emails = [];
                        if (message.emails && message.emails.length) {
                            object.emails = [];
                            for (var j = 0; j < message.emails.length; ++j)
                                object.emails[j] = message.emails[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetEmailsFromReceiverResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetEmailsFromReceiverResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetEmailsFromReceiverResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetEmailsFromReceiverResponse;
                })();
    
                v1.GetScheduledReportRequest = (function() {
    
                    /**
                     * Properties of a GetScheduledReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetScheduledReportRequest
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] GetScheduledReportRequest dateRange
                     * @property {string|null} [email] GetScheduledReportRequest email
                     * @property {number|null} [scheduleId] GetScheduledReportRequest scheduleId
                     */
    
                    /**
                     * Constructs a new GetScheduledReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetScheduledReportRequest.
                     * @implements IGetScheduledReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest=} [properties] Properties to set
                     */
                    function GetScheduledReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetScheduledReportRequest dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @instance
                     */
                    GetScheduledReportRequest.prototype.dateRange = null;
    
                    /**
                     * GetScheduledReportRequest email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @instance
                     */
                    GetScheduledReportRequest.prototype.email = "";
    
                    /**
                     * GetScheduledReportRequest scheduleId.
                     * @member {number} scheduleId
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @instance
                     */
                    GetScheduledReportRequest.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetScheduledReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetScheduledReportRequest} GetScheduledReportRequest instance
                     */
                    GetScheduledReportRequest.create = function create(properties) {
                        return new GetScheduledReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetScheduledReportRequest message. Does not implicitly {@link palexy.streaming.v1.GetScheduledReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest} message GetScheduledReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduledReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.scheduleId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetScheduledReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetScheduledReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportRequest} message GetScheduledReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduledReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetScheduledReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetScheduledReportRequest} GetScheduledReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduledReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetScheduledReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.scheduleId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetScheduledReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetScheduledReportRequest} GetScheduledReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduledReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetScheduledReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetScheduledReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                return "scheduleId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetScheduledReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetScheduledReportRequest} GetScheduledReportRequest
                     */
                    GetScheduledReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetScheduledReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetScheduledReportRequest();
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.GetScheduledReportRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.scheduleId != null)
                            if ($util.Long)
                                (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                            else if (typeof object.scheduleId === "string")
                                message.scheduleId = parseInt(object.scheduleId, 10);
                            else if (typeof object.scheduleId === "number")
                                message.scheduleId = object.scheduleId;
                            else if (typeof object.scheduleId === "object")
                                message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetScheduledReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @static
                     * @param {palexy.streaming.v1.GetScheduledReportRequest} message GetScheduledReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetScheduledReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dateRange = null;
                            object.email = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleId = options.longs === String ? "0" : 0;
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (typeof message.scheduleId === "number")
                                object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                            else
                                object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                        return object;
                    };
    
                    /**
                     * Converts this GetScheduledReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetScheduledReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetScheduledReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetScheduledReportRequest;
                })();
    
                v1.GetScheduledReportResponse = (function() {
    
                    /**
                     * Properties of a GetScheduledReportResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetScheduledReportResponse
                     * @property {palexy.streaming.v1.IScheduledReport|null} [scheduleReport] GetScheduledReportResponse scheduleReport
                     */
    
                    /**
                     * Constructs a new GetScheduledReportResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetScheduledReportResponse.
                     * @implements IGetScheduledReportResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetScheduledReportResponse=} [properties] Properties to set
                     */
                    function GetScheduledReportResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetScheduledReportResponse scheduleReport.
                     * @member {palexy.streaming.v1.IScheduledReport|null|undefined} scheduleReport
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @instance
                     */
                    GetScheduledReportResponse.prototype.scheduleReport = null;
    
                    /**
                     * Creates a new GetScheduledReportResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetScheduledReportResponse} GetScheduledReportResponse instance
                     */
                    GetScheduledReportResponse.create = function create(properties) {
                        return new GetScheduledReportResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetScheduledReportResponse message. Does not implicitly {@link palexy.streaming.v1.GetScheduledReportResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportResponse} message GetScheduledReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduledReportResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleReport != null && Object.hasOwnProperty.call(message, "scheduleReport"))
                            $root.palexy.streaming.v1.ScheduledReport.encode(message.scheduleReport, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetScheduledReportResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetScheduledReportResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduledReportResponse} message GetScheduledReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduledReportResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetScheduledReportResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetScheduledReportResponse} GetScheduledReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduledReportResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetScheduledReportResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleReport = $root.palexy.streaming.v1.ScheduledReport.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetScheduledReportResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetScheduledReportResponse} GetScheduledReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduledReportResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetScheduledReportResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetScheduledReportResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleReport != null && message.hasOwnProperty("scheduleReport")) {
                            var error = $root.palexy.streaming.v1.ScheduledReport.verify(message.scheduleReport);
                            if (error)
                                return "scheduleReport." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetScheduledReportResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetScheduledReportResponse} GetScheduledReportResponse
                     */
                    GetScheduledReportResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetScheduledReportResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetScheduledReportResponse();
                        if (object.scheduleReport != null) {
                            if (typeof object.scheduleReport !== "object")
                                throw TypeError(".palexy.streaming.v1.GetScheduledReportResponse.scheduleReport: object expected");
                            message.scheduleReport = $root.palexy.streaming.v1.ScheduledReport.fromObject(object.scheduleReport);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetScheduledReportResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @static
                     * @param {palexy.streaming.v1.GetScheduledReportResponse} message GetScheduledReportResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetScheduledReportResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.scheduleReport = null;
                        if (message.scheduleReport != null && message.hasOwnProperty("scheduleReport"))
                            object.scheduleReport = $root.palexy.streaming.v1.ScheduledReport.toObject(message.scheduleReport, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetScheduledReportResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetScheduledReportResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetScheduledReportResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetScheduledReportResponse;
                })();
    
                v1.UpdateNextSendTimeRequest = (function() {
    
                    /**
                     * Properties of an UpdateNextSendTimeRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateNextSendTimeRequest
                     * @property {google.protobuf.IInt32Value|null} [startOfWeek] UpdateNextSendTimeRequest startOfWeek
                     * @property {number|null} [scheduleId] UpdateNextSendTimeRequest scheduleId
                     */
    
                    /**
                     * Constructs a new UpdateNextSendTimeRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateNextSendTimeRequest.
                     * @implements IUpdateNextSendTimeRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest=} [properties] Properties to set
                     */
                    function UpdateNextSendTimeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateNextSendTimeRequest startOfWeek.
                     * @member {google.protobuf.IInt32Value|null|undefined} startOfWeek
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @instance
                     */
                    UpdateNextSendTimeRequest.prototype.startOfWeek = null;
    
                    /**
                     * UpdateNextSendTimeRequest scheduleId.
                     * @member {number} scheduleId
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @instance
                     */
                    UpdateNextSendTimeRequest.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new UpdateNextSendTimeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeRequest} UpdateNextSendTimeRequest instance
                     */
                    UpdateNextSendTimeRequest.create = function create(properties) {
                        return new UpdateNextSendTimeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateNextSendTimeRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateNextSendTimeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest} message UpdateNextSendTimeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNextSendTimeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startOfWeek != null && Object.hasOwnProperty.call(message, "startOfWeek"))
                            $root.google.protobuf.Int32Value.encode(message.startOfWeek, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.scheduleId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateNextSendTimeRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateNextSendTimeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeRequest} message UpdateNextSendTimeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNextSendTimeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateNextSendTimeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeRequest} UpdateNextSendTimeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNextSendTimeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateNextSendTimeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startOfWeek = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.scheduleId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateNextSendTimeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeRequest} UpdateNextSendTimeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNextSendTimeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateNextSendTimeRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateNextSendTimeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek")) {
                            var error = $root.google.protobuf.Int32Value.verify(message.startOfWeek);
                            if (error)
                                return "startOfWeek." + error;
                        }
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                return "scheduleId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateNextSendTimeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeRequest} UpdateNextSendTimeRequest
                     */
                    UpdateNextSendTimeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateNextSendTimeRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateNextSendTimeRequest();
                        if (object.startOfWeek != null) {
                            if (typeof object.startOfWeek !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNextSendTimeRequest.startOfWeek: object expected");
                            message.startOfWeek = $root.google.protobuf.Int32Value.fromObject(object.startOfWeek);
                        }
                        if (object.scheduleId != null)
                            if ($util.Long)
                                (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                            else if (typeof object.scheduleId === "string")
                                message.scheduleId = parseInt(object.scheduleId, 10);
                            else if (typeof object.scheduleId === "number")
                                message.scheduleId = object.scheduleId;
                            else if (typeof object.scheduleId === "object")
                                message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateNextSendTimeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateNextSendTimeRequest} message UpdateNextSendTimeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateNextSendTimeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startOfWeek = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleId = options.longs === String ? "0" : 0;
                        }
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            object.startOfWeek = $root.google.protobuf.Int32Value.toObject(message.startOfWeek, options);
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (typeof message.scheduleId === "number")
                                object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                            else
                                object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateNextSendTimeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateNextSendTimeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateNextSendTimeRequest;
                })();
    
                v1.UpdateNextSendTimeResponse = (function() {
    
                    /**
                     * Properties of an UpdateNextSendTimeResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateNextSendTimeResponse
                     * @property {google.protobuf.ITimestamp|null} [nextSendTime] UpdateNextSendTimeResponse nextSendTime
                     */
    
                    /**
                     * Constructs a new UpdateNextSendTimeResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateNextSendTimeResponse.
                     * @implements IUpdateNextSendTimeResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeResponse=} [properties] Properties to set
                     */
                    function UpdateNextSendTimeResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateNextSendTimeResponse nextSendTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} nextSendTime
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @instance
                     */
                    UpdateNextSendTimeResponse.prototype.nextSendTime = null;
    
                    /**
                     * Creates a new UpdateNextSendTimeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeResponse} UpdateNextSendTimeResponse instance
                     */
                    UpdateNextSendTimeResponse.create = function create(properties) {
                        return new UpdateNextSendTimeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateNextSendTimeResponse message. Does not implicitly {@link palexy.streaming.v1.UpdateNextSendTimeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeResponse} message UpdateNextSendTimeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNextSendTimeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.nextSendTime != null && Object.hasOwnProperty.call(message, "nextSendTime"))
                            $root.google.protobuf.Timestamp.encode(message.nextSendTime, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateNextSendTimeResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateNextSendTimeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNextSendTimeResponse} message UpdateNextSendTimeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNextSendTimeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateNextSendTimeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeResponse} UpdateNextSendTimeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNextSendTimeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateNextSendTimeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.nextSendTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateNextSendTimeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeResponse} UpdateNextSendTimeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNextSendTimeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateNextSendTimeResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateNextSendTimeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.nextSendTime != null && message.hasOwnProperty("nextSendTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.nextSendTime);
                            if (error)
                                return "nextSendTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateNextSendTimeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateNextSendTimeResponse} UpdateNextSendTimeResponse
                     */
                    UpdateNextSendTimeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateNextSendTimeResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateNextSendTimeResponse();
                        if (object.nextSendTime != null) {
                            if (typeof object.nextSendTime !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNextSendTimeResponse.nextSendTime: object expected");
                            message.nextSendTime = $root.google.protobuf.Timestamp.fromObject(object.nextSendTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateNextSendTimeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @static
                     * @param {palexy.streaming.v1.UpdateNextSendTimeResponse} message UpdateNextSendTimeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateNextSendTimeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.nextSendTime = null;
                        if (message.nextSendTime != null && message.hasOwnProperty("nextSendTime"))
                            object.nextSendTime = $root.google.protobuf.Timestamp.toObject(message.nextSendTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateNextSendTimeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateNextSendTimeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateNextSendTimeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateNextSendTimeResponse;
                })();
    
                v1.ListReportScheduleRequest = (function() {
    
                    /**
                     * Properties of a ListReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListReportScheduleRequest
                     * @property {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter|null} [filter] ListReportScheduleRequest filter
                     * @property {string|null} [pageToken] ListReportScheduleRequest pageToken
                     * @property {number|null} [pageSize] ListReportScheduleRequest pageSize
                     * @property {boolean|null} [includeReceivers] ListReportScheduleRequest includeReceivers
                     * @property {boolean|null} [includeLatestReportDateRange] ListReportScheduleRequest includeLatestReportDateRange
                     */
    
                    /**
                     * Constructs a new ListReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListReportScheduleRequest.
                     * @implements IListReportScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListReportScheduleRequest=} [properties] Properties to set
                     */
                    function ListReportScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReportScheduleRequest filter.
                     * @member {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     */
                    ListReportScheduleRequest.prototype.filter = null;
    
                    /**
                     * ListReportScheduleRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     */
                    ListReportScheduleRequest.prototype.pageToken = "";
    
                    /**
                     * ListReportScheduleRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     */
                    ListReportScheduleRequest.prototype.pageSize = 0;
    
                    /**
                     * ListReportScheduleRequest includeReceivers.
                     * @member {boolean} includeReceivers
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     */
                    ListReportScheduleRequest.prototype.includeReceivers = false;
    
                    /**
                     * ListReportScheduleRequest includeLatestReportDateRange.
                     * @member {boolean} includeLatestReportDateRange
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     */
                    ListReportScheduleRequest.prototype.includeLatestReportDateRange = false;
    
                    /**
                     * Creates a new ListReportScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListReportScheduleRequest} ListReportScheduleRequest instance
                     */
                    ListReportScheduleRequest.create = function create(properties) {
                        return new ListReportScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleRequest} message ListReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.encode(message.filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.includeReceivers != null && Object.hasOwnProperty.call(message, "includeReceivers"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeReceivers);
                        if (message.includeLatestReportDateRange != null && Object.hasOwnProperty.call(message, "includeLatestReportDateRange"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeLatestReportDateRange);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleRequest} message ListReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReportScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListReportScheduleRequest} ListReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReportScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filter = $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.includeReceivers = reader.bool();
                                break;
                            case 6:
                                message.includeLatestReportDateRange = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReportScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListReportScheduleRequest} ListReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReportScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReportScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.includeReceivers != null && message.hasOwnProperty("includeReceivers"))
                            if (typeof message.includeReceivers !== "boolean")
                                return "includeReceivers: boolean expected";
                        if (message.includeLatestReportDateRange != null && message.hasOwnProperty("includeLatestReportDateRange"))
                            if (typeof message.includeLatestReportDateRange !== "boolean")
                                return "includeLatestReportDateRange: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReportScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListReportScheduleRequest} ListReportScheduleRequest
                     */
                    ListReportScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListReportScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListReportScheduleRequest();
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListReportScheduleRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.fromObject(object.filter);
                        }
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.includeReceivers != null)
                            message.includeReceivers = Boolean(object.includeReceivers);
                        if (object.includeLatestReportDateRange != null)
                            message.includeLatestReportDateRange = Boolean(object.includeLatestReportDateRange);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReportScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ListReportScheduleRequest} message ListReportScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReportScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.filter = null;
                            object.pageToken = "";
                            object.pageSize = 0;
                            object.includeReceivers = false;
                            object.includeLatestReportDateRange = false;
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.toObject(message.filter, options);
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.includeReceivers != null && message.hasOwnProperty("includeReceivers"))
                            object.includeReceivers = message.includeReceivers;
                        if (message.includeLatestReportDateRange != null && message.hasOwnProperty("includeLatestReportDateRange"))
                            object.includeLatestReportDateRange = message.includeLatestReportDateRange;
                        return object;
                    };
    
                    /**
                     * Converts this ListReportScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListReportScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReportScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListReportScheduleRequest.ListReportScheduleFilter = (function() {
    
                        /**
                         * Properties of a ListReportScheduleFilter.
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest
                         * @interface IListReportScheduleFilter
                         * @property {number|null} [companyId] ListReportScheduleFilter companyId
                         * @property {string|null} [name] ListReportScheduleFilter name
                         * @property {Array.<palexy.streaming.v1.ReportSchedule.ScheduleType>|null} [scheduleTypes] ListReportScheduleFilter scheduleTypes
                         * @property {google.protobuf.IBoolValue|null} [overdue] ListReportScheduleFilter overdue
                         * @property {Array.<number>|null} [scheduleIds] ListReportScheduleFilter scheduleIds
                         * @property {Array.<number>|null} [excludedCompanyIds] ListReportScheduleFilter excludedCompanyIds
                         */
    
                        /**
                         * Constructs a new ListReportScheduleFilter.
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest
                         * @classdesc Represents a ListReportScheduleFilter.
                         * @implements IListReportScheduleFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter=} [properties] Properties to set
                         */
                        function ListReportScheduleFilter(properties) {
                            this.scheduleTypes = [];
                            this.scheduleIds = [];
                            this.excludedCompanyIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ListReportScheduleFilter companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * ListReportScheduleFilter name.
                         * @member {string} name
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.name = "";
    
                        /**
                         * ListReportScheduleFilter scheduleTypes.
                         * @member {Array.<palexy.streaming.v1.ReportSchedule.ScheduleType>} scheduleTypes
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.scheduleTypes = $util.emptyArray;
    
                        /**
                         * ListReportScheduleFilter overdue.
                         * @member {google.protobuf.IBoolValue|null|undefined} overdue
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.overdue = null;
    
                        /**
                         * ListReportScheduleFilter scheduleIds.
                         * @member {Array.<number>} scheduleIds
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.scheduleIds = $util.emptyArray;
    
                        /**
                         * ListReportScheduleFilter excludedCompanyIds.
                         * @member {Array.<number>} excludedCompanyIds
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         */
                        ListReportScheduleFilter.prototype.excludedCompanyIds = $util.emptyArray;
    
                        /**
                         * Creates a new ListReportScheduleFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter} ListReportScheduleFilter instance
                         */
                        ListReportScheduleFilter.create = function create(properties) {
                            return new ListReportScheduleFilter(properties);
                        };
    
                        /**
                         * Encodes the specified ListReportScheduleFilter message. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter} message ListReportScheduleFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListReportScheduleFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                            if (message.scheduleTypes != null && message.scheduleTypes.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.scheduleTypes.length; ++i)
                                    writer.int32(message.scheduleTypes[i]);
                                writer.ldelim();
                            }
                            if (message.overdue != null && Object.hasOwnProperty.call(message, "overdue"))
                                $root.google.protobuf.BoolValue.encode(message.overdue, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.scheduleIds != null && message.scheduleIds.length) {
                                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                                for (var i = 0; i < message.scheduleIds.length; ++i)
                                    writer.int64(message.scheduleIds[i]);
                                writer.ldelim();
                            }
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                            if (message.excludedCompanyIds != null && message.excludedCompanyIds.length) {
                                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                                for (var i = 0; i < message.excludedCompanyIds.length; ++i)
                                    writer.int64(message.excludedCompanyIds[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ListReportScheduleFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {palexy.streaming.v1.ListReportScheduleRequest.IListReportScheduleFilter} message ListReportScheduleFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ListReportScheduleFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ListReportScheduleFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter} ListReportScheduleFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListReportScheduleFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.companyId = reader.int64();
                                    break;
                                case 5:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    if (!(message.scheduleTypes && message.scheduleTypes.length))
                                        message.scheduleTypes = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.scheduleTypes.push(reader.int32());
                                    } else
                                        message.scheduleTypes.push(reader.int32());
                                    break;
                                case 3:
                                    message.overdue = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    if (!(message.scheduleIds && message.scheduleIds.length))
                                        message.scheduleIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.scheduleIds.push(reader.int64());
                                    } else
                                        message.scheduleIds.push(reader.int64());
                                    break;
                                case 6:
                                    if (!(message.excludedCompanyIds && message.excludedCompanyIds.length))
                                        message.excludedCompanyIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.excludedCompanyIds.push(reader.int64());
                                    } else
                                        message.excludedCompanyIds.push(reader.int64());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ListReportScheduleFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter} ListReportScheduleFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ListReportScheduleFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ListReportScheduleFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ListReportScheduleFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.scheduleTypes != null && message.hasOwnProperty("scheduleTypes")) {
                                if (!Array.isArray(message.scheduleTypes))
                                    return "scheduleTypes: array expected";
                                for (var i = 0; i < message.scheduleTypes.length; ++i)
                                    switch (message.scheduleTypes[i]) {
                                    default:
                                        return "scheduleTypes: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            if (message.overdue != null && message.hasOwnProperty("overdue")) {
                                var error = $root.google.protobuf.BoolValue.verify(message.overdue);
                                if (error)
                                    return "overdue." + error;
                            }
                            if (message.scheduleIds != null && message.hasOwnProperty("scheduleIds")) {
                                if (!Array.isArray(message.scheduleIds))
                                    return "scheduleIds: array expected";
                                for (var i = 0; i < message.scheduleIds.length; ++i)
                                    if (!$util.isInteger(message.scheduleIds[i]) && !(message.scheduleIds[i] && $util.isInteger(message.scheduleIds[i].low) && $util.isInteger(message.scheduleIds[i].high)))
                                        return "scheduleIds: integer|Long[] expected";
                            }
                            if (message.excludedCompanyIds != null && message.hasOwnProperty("excludedCompanyIds")) {
                                if (!Array.isArray(message.excludedCompanyIds))
                                    return "excludedCompanyIds: array expected";
                                for (var i = 0; i < message.excludedCompanyIds.length; ++i)
                                    if (!$util.isInteger(message.excludedCompanyIds[i]) && !(message.excludedCompanyIds[i] && $util.isInteger(message.excludedCompanyIds[i].low) && $util.isInteger(message.excludedCompanyIds[i].high)))
                                        return "excludedCompanyIds: integer|Long[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a ListReportScheduleFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter} ListReportScheduleFilter
                         */
                        ListReportScheduleFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter();
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.scheduleTypes) {
                                if (!Array.isArray(object.scheduleTypes))
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.scheduleTypes: array expected");
                                message.scheduleTypes = [];
                                for (var i = 0; i < object.scheduleTypes.length; ++i)
                                    switch (object.scheduleTypes[i]) {
                                    default:
                                    case "UNKNOWN":
                                    case 0:
                                        message.scheduleTypes[i] = 0;
                                        break;
                                    case "WEEKLY":
                                    case 1:
                                        message.scheduleTypes[i] = 1;
                                        break;
                                    case "MONTHLY":
                                    case 2:
                                        message.scheduleTypes[i] = 2;
                                        break;
                                    case "DAILY":
                                    case 3:
                                        message.scheduleTypes[i] = 3;
                                        break;
                                    }
                            }
                            if (object.overdue != null) {
                                if (typeof object.overdue !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.overdue: object expected");
                                message.overdue = $root.google.protobuf.BoolValue.fromObject(object.overdue);
                            }
                            if (object.scheduleIds) {
                                if (!Array.isArray(object.scheduleIds))
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.scheduleIds: array expected");
                                message.scheduleIds = [];
                                for (var i = 0; i < object.scheduleIds.length; ++i)
                                    if ($util.Long)
                                        (message.scheduleIds[i] = $util.Long.fromValue(object.scheduleIds[i])).unsigned = false;
                                    else if (typeof object.scheduleIds[i] === "string")
                                        message.scheduleIds[i] = parseInt(object.scheduleIds[i], 10);
                                    else if (typeof object.scheduleIds[i] === "number")
                                        message.scheduleIds[i] = object.scheduleIds[i];
                                    else if (typeof object.scheduleIds[i] === "object")
                                        message.scheduleIds[i] = new $util.LongBits(object.scheduleIds[i].low >>> 0, object.scheduleIds[i].high >>> 0).toNumber();
                            }
                            if (object.excludedCompanyIds) {
                                if (!Array.isArray(object.excludedCompanyIds))
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter.excludedCompanyIds: array expected");
                                message.excludedCompanyIds = [];
                                for (var i = 0; i < object.excludedCompanyIds.length; ++i)
                                    if ($util.Long)
                                        (message.excludedCompanyIds[i] = $util.Long.fromValue(object.excludedCompanyIds[i])).unsigned = false;
                                    else if (typeof object.excludedCompanyIds[i] === "string")
                                        message.excludedCompanyIds[i] = parseInt(object.excludedCompanyIds[i], 10);
                                    else if (typeof object.excludedCompanyIds[i] === "number")
                                        message.excludedCompanyIds[i] = object.excludedCompanyIds[i];
                                    else if (typeof object.excludedCompanyIds[i] === "object")
                                        message.excludedCompanyIds[i] = new $util.LongBits(object.excludedCompanyIds[i].low >>> 0, object.excludedCompanyIds[i].high >>> 0).toNumber();
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ListReportScheduleFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @static
                         * @param {palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter} message ListReportScheduleFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ListReportScheduleFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.scheduleTypes = [];
                                object.scheduleIds = [];
                                object.excludedCompanyIds = [];
                            }
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                                object.overdue = null;
                                object.name = "";
                            }
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (message.scheduleTypes && message.scheduleTypes.length) {
                                object.scheduleTypes = [];
                                for (var j = 0; j < message.scheduleTypes.length; ++j)
                                    object.scheduleTypes[j] = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ScheduleType[message.scheduleTypes[j]] : message.scheduleTypes[j];
                            }
                            if (message.overdue != null && message.hasOwnProperty("overdue"))
                                object.overdue = $root.google.protobuf.BoolValue.toObject(message.overdue, options);
                            if (message.scheduleIds && message.scheduleIds.length) {
                                object.scheduleIds = [];
                                for (var j = 0; j < message.scheduleIds.length; ++j)
                                    if (typeof message.scheduleIds[j] === "number")
                                        object.scheduleIds[j] = options.longs === String ? String(message.scheduleIds[j]) : message.scheduleIds[j];
                                    else
                                        object.scheduleIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleIds[j]) : options.longs === Number ? new $util.LongBits(message.scheduleIds[j].low >>> 0, message.scheduleIds[j].high >>> 0).toNumber() : message.scheduleIds[j];
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.excludedCompanyIds && message.excludedCompanyIds.length) {
                                object.excludedCompanyIds = [];
                                for (var j = 0; j < message.excludedCompanyIds.length; ++j)
                                    if (typeof message.excludedCompanyIds[j] === "number")
                                        object.excludedCompanyIds[j] = options.longs === String ? String(message.excludedCompanyIds[j]) : message.excludedCompanyIds[j];
                                    else
                                        object.excludedCompanyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.excludedCompanyIds[j]) : options.longs === Number ? new $util.LongBits(message.excludedCompanyIds[j].low >>> 0, message.excludedCompanyIds[j].high >>> 0).toNumber() : message.excludedCompanyIds[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this ListReportScheduleFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListReportScheduleRequest.ListReportScheduleFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ListReportScheduleFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ListReportScheduleFilter;
                    })();
    
                    return ListReportScheduleRequest;
                })();
    
                v1.ListReportScheduleResponse = (function() {
    
                    /**
                     * Properties of a ListReportScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListReportScheduleResponse
                     * @property {Array.<palexy.streaming.v1.IReportSchedule>|null} [schedules] ListReportScheduleResponse schedules
                     * @property {number|null} [totalElements] ListReportScheduleResponse totalElements
                     * @property {string|null} [nextPageToken] ListReportScheduleResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListReportScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListReportScheduleResponse.
                     * @implements IListReportScheduleResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListReportScheduleResponse=} [properties] Properties to set
                     */
                    function ListReportScheduleResponse(properties) {
                        this.schedules = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReportScheduleResponse schedules.
                     * @member {Array.<palexy.streaming.v1.IReportSchedule>} schedules
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @instance
                     */
                    ListReportScheduleResponse.prototype.schedules = $util.emptyArray;
    
                    /**
                     * ListReportScheduleResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @instance
                     */
                    ListReportScheduleResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListReportScheduleResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @instance
                     */
                    ListReportScheduleResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListReportScheduleResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListReportScheduleResponse} ListReportScheduleResponse instance
                     */
                    ListReportScheduleResponse.create = function create(properties) {
                        return new ListReportScheduleResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleResponse message. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleResponse} message ListReportScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.schedules != null && message.schedules.length)
                            for (var i = 0; i < message.schedules.length; ++i)
                                $root.palexy.streaming.v1.ReportSchedule.encode(message.schedules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReportScheduleResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListReportScheduleResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IListReportScheduleResponse} message ListReportScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReportScheduleResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReportScheduleResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListReportScheduleResponse} ListReportScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListReportScheduleResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.schedules && message.schedules.length))
                                    message.schedules = [];
                                message.schedules.push($root.palexy.streaming.v1.ReportSchedule.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReportScheduleResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListReportScheduleResponse} ListReportScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReportScheduleResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReportScheduleResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReportScheduleResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.schedules != null && message.hasOwnProperty("schedules")) {
                            if (!Array.isArray(message.schedules))
                                return "schedules: array expected";
                            for (var i = 0; i < message.schedules.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportSchedule.verify(message.schedules[i]);
                                if (error)
                                    return "schedules." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReportScheduleResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListReportScheduleResponse} ListReportScheduleResponse
                     */
                    ListReportScheduleResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListReportScheduleResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListReportScheduleResponse();
                        if (object.schedules) {
                            if (!Array.isArray(object.schedules))
                                throw TypeError(".palexy.streaming.v1.ListReportScheduleResponse.schedules: array expected");
                            message.schedules = [];
                            for (var i = 0; i < object.schedules.length; ++i) {
                                if (typeof object.schedules[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListReportScheduleResponse.schedules: object expected");
                                message.schedules[i] = $root.palexy.streaming.v1.ReportSchedule.fromObject(object.schedules[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReportScheduleResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.ListReportScheduleResponse} message ListReportScheduleResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReportScheduleResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.schedules = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.schedules && message.schedules.length) {
                            object.schedules = [];
                            for (var j = 0; j < message.schedules.length; ++j)
                                object.schedules[j] = $root.palexy.streaming.v1.ReportSchedule.toObject(message.schedules[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListReportScheduleResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListReportScheduleResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReportScheduleResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListReportScheduleResponse;
                })();
    
                v1.CreateReportScheduleRequest = (function() {
    
                    /**
                     * Properties of a CreateReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateReportScheduleRequest
                     * @property {palexy.streaming.v1.IReportSchedule|null} [schedule] CreateReportScheduleRequest schedule
                     */
    
                    /**
                     * Constructs a new CreateReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateReportScheduleRequest.
                     * @implements ICreateReportScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest=} [properties] Properties to set
                     */
                    function CreateReportScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateReportScheduleRequest schedule.
                     * @member {palexy.streaming.v1.IReportSchedule|null|undefined} schedule
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @instance
                     */
                    CreateReportScheduleRequest.prototype.schedule = null;
    
                    /**
                     * Creates a new CreateReportScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateReportScheduleRequest} CreateReportScheduleRequest instance
                     */
                    CreateReportScheduleRequest.create = function create(properties) {
                        return new CreateReportScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateReportScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.CreateReportScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest} message CreateReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateReportScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
                            $root.palexy.streaming.v1.ReportSchedule.encode(message.schedule, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateReportScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateReportScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateReportScheduleRequest} message CreateReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateReportScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateReportScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateReportScheduleRequest} CreateReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateReportScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateReportScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.schedule = $root.palexy.streaming.v1.ReportSchedule.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateReportScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateReportScheduleRequest} CreateReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateReportScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateReportScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateReportScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.schedule != null && message.hasOwnProperty("schedule")) {
                            var error = $root.palexy.streaming.v1.ReportSchedule.verify(message.schedule);
                            if (error)
                                return "schedule." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateReportScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateReportScheduleRequest} CreateReportScheduleRequest
                     */
                    CreateReportScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateReportScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateReportScheduleRequest();
                        if (object.schedule != null) {
                            if (typeof object.schedule !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateReportScheduleRequest.schedule: object expected");
                            message.schedule = $root.palexy.streaming.v1.ReportSchedule.fromObject(object.schedule);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateReportScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateReportScheduleRequest} message CreateReportScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateReportScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.schedule = null;
                        if (message.schedule != null && message.hasOwnProperty("schedule"))
                            object.schedule = $root.palexy.streaming.v1.ReportSchedule.toObject(message.schedule, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateReportScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateReportScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateReportScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateReportScheduleRequest;
                })();
    
                v1.GetReportScheduleRequest = (function() {
    
                    /**
                     * Properties of a GetReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetReportScheduleRequest
                     * @property {number|null} [id] GetReportScheduleRequest id
                     * @property {boolean|null} [includeReceivers] GetReportScheduleRequest includeReceivers
                     */
    
                    /**
                     * Constructs a new GetReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetReportScheduleRequest.
                     * @implements IGetReportScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest=} [properties] Properties to set
                     */
                    function GetReportScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetReportScheduleRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @instance
                     */
                    GetReportScheduleRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetReportScheduleRequest includeReceivers.
                     * @member {boolean} includeReceivers
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @instance
                     */
                    GetReportScheduleRequest.prototype.includeReceivers = false;
    
                    /**
                     * Creates a new GetReportScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetReportScheduleRequest} GetReportScheduleRequest instance
                     */
                    GetReportScheduleRequest.create = function create(properties) {
                        return new GetReportScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetReportScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.GetReportScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest} message GetReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.includeReceivers != null && Object.hasOwnProperty.call(message, "includeReceivers"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeReceivers);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetReportScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportScheduleRequest} message GetReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetReportScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetReportScheduleRequest} GetReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.includeReceivers = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetReportScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetReportScheduleRequest} GetReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetReportScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetReportScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.includeReceivers != null && message.hasOwnProperty("includeReceivers"))
                            if (typeof message.includeReceivers !== "boolean")
                                return "includeReceivers: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetReportScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetReportScheduleRequest} GetReportScheduleRequest
                     */
                    GetReportScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetReportScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetReportScheduleRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.includeReceivers != null)
                            message.includeReceivers = Boolean(object.includeReceivers);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetReportScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.GetReportScheduleRequest} message GetReportScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetReportScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.includeReceivers = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.includeReceivers != null && message.hasOwnProperty("includeReceivers"))
                            object.includeReceivers = message.includeReceivers;
                        return object;
                    };
    
                    /**
                     * Converts this GetReportScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetReportScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetReportScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetReportScheduleRequest;
                })();
    
                v1.UpdateReportScheduleRequest = (function() {
    
                    /**
                     * Properties of an UpdateReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateReportScheduleRequest
                     * @property {number|null} [id] UpdateReportScheduleRequest id
                     * @property {palexy.streaming.v1.IReportSchedule|null} [schedule] UpdateReportScheduleRequest schedule
                     */
    
                    /**
                     * Constructs a new UpdateReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateReportScheduleRequest.
                     * @implements IUpdateReportScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest=} [properties] Properties to set
                     */
                    function UpdateReportScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateReportScheduleRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @instance
                     */
                    UpdateReportScheduleRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateReportScheduleRequest schedule.
                     * @member {palexy.streaming.v1.IReportSchedule|null|undefined} schedule
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @instance
                     */
                    UpdateReportScheduleRequest.prototype.schedule = null;
    
                    /**
                     * Creates a new UpdateReportScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateReportScheduleRequest} UpdateReportScheduleRequest instance
                     */
                    UpdateReportScheduleRequest.create = function create(properties) {
                        return new UpdateReportScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateReportScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateReportScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest} message UpdateReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateReportScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.schedule != null && Object.hasOwnProperty.call(message, "schedule"))
                            $root.palexy.streaming.v1.ReportSchedule.encode(message.schedule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateReportScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateReportScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateReportScheduleRequest} message UpdateReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateReportScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateReportScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateReportScheduleRequest} UpdateReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateReportScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateReportScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.schedule = $root.palexy.streaming.v1.ReportSchedule.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateReportScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateReportScheduleRequest} UpdateReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateReportScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateReportScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateReportScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.schedule != null && message.hasOwnProperty("schedule")) {
                            var error = $root.palexy.streaming.v1.ReportSchedule.verify(message.schedule);
                            if (error)
                                return "schedule." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateReportScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateReportScheduleRequest} UpdateReportScheduleRequest
                     */
                    UpdateReportScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateReportScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateReportScheduleRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.schedule != null) {
                            if (typeof object.schedule !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateReportScheduleRequest.schedule: object expected");
                            message.schedule = $root.palexy.streaming.v1.ReportSchedule.fromObject(object.schedule);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateReportScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateReportScheduleRequest} message UpdateReportScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateReportScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.schedule = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.schedule != null && message.hasOwnProperty("schedule"))
                            object.schedule = $root.palexy.streaming.v1.ReportSchedule.toObject(message.schedule, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateReportScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateReportScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateReportScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateReportScheduleRequest;
                })();
    
                v1.DeleteReportScheduleRequest = (function() {
    
                    /**
                     * Properties of a DeleteReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteReportScheduleRequest
                     * @property {number|null} [id] DeleteReportScheduleRequest id
                     */
    
                    /**
                     * Constructs a new DeleteReportScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteReportScheduleRequest.
                     * @implements IDeleteReportScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest=} [properties] Properties to set
                     */
                    function DeleteReportScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteReportScheduleRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @instance
                     */
                    DeleteReportScheduleRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteReportScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteReportScheduleRequest} DeleteReportScheduleRequest instance
                     */
                    DeleteReportScheduleRequest.create = function create(properties) {
                        return new DeleteReportScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteReportScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteReportScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest} message DeleteReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteReportScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteReportScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteReportScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteReportScheduleRequest} message DeleteReportScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteReportScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteReportScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteReportScheduleRequest} DeleteReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteReportScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteReportScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteReportScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteReportScheduleRequest} DeleteReportScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteReportScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteReportScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteReportScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteReportScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteReportScheduleRequest} DeleteReportScheduleRequest
                     */
                    DeleteReportScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteReportScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteReportScheduleRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteReportScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteReportScheduleRequest} message DeleteReportScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteReportScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteReportScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteReportScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteReportScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteReportScheduleRequest;
                })();
    
                v1.SendOutReportRequest = (function() {
    
                    /**
                     * Properties of a SendOutReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendOutReportRequest
                     * @property {number|null} [scheduleId] SendOutReportRequest scheduleId
                     * @property {Array.<string>|null} [emails] SendOutReportRequest emails
                     */
    
                    /**
                     * Constructs a new SendOutReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendOutReportRequest.
                     * @implements ISendOutReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendOutReportRequest=} [properties] Properties to set
                     */
                    function SendOutReportRequest(properties) {
                        this.emails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendOutReportRequest scheduleId.
                     * @member {number} scheduleId
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @instance
                     */
                    SendOutReportRequest.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SendOutReportRequest emails.
                     * @member {Array.<string>} emails
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @instance
                     */
                    SendOutReportRequest.prototype.emails = $util.emptyArray;
    
                    /**
                     * Creates a new SendOutReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOutReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendOutReportRequest} SendOutReportRequest instance
                     */
                    SendOutReportRequest.create = function create(properties) {
                        return new SendOutReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendOutReportRequest message. Does not implicitly {@link palexy.streaming.v1.SendOutReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOutReportRequest} message SendOutReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendOutReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.scheduleId);
                        if (message.emails != null && message.emails.length)
                            for (var i = 0; i < message.emails.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.emails[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendOutReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendOutReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendOutReportRequest} message SendOutReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendOutReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendOutReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendOutReportRequest} SendOutReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendOutReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendOutReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleId = reader.int64();
                                break;
                            case 3:
                                if (!(message.emails && message.emails.length))
                                    message.emails = [];
                                message.emails.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendOutReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendOutReportRequest} SendOutReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendOutReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendOutReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendOutReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                return "scheduleId: integer|Long expected";
                        if (message.emails != null && message.hasOwnProperty("emails")) {
                            if (!Array.isArray(message.emails))
                                return "emails: array expected";
                            for (var i = 0; i < message.emails.length; ++i)
                                if (!$util.isString(message.emails[i]))
                                    return "emails: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SendOutReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendOutReportRequest} SendOutReportRequest
                     */
                    SendOutReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendOutReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendOutReportRequest();
                        if (object.scheduleId != null)
                            if ($util.Long)
                                (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                            else if (typeof object.scheduleId === "string")
                                message.scheduleId = parseInt(object.scheduleId, 10);
                            else if (typeof object.scheduleId === "number")
                                message.scheduleId = object.scheduleId;
                            else if (typeof object.scheduleId === "object")
                                message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                        if (object.emails) {
                            if (!Array.isArray(object.emails))
                                throw TypeError(".palexy.streaming.v1.SendOutReportRequest.emails: array expected");
                            message.emails = [];
                            for (var i = 0; i < object.emails.length; ++i)
                                message.emails[i] = String(object.emails[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendOutReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @static
                     * @param {palexy.streaming.v1.SendOutReportRequest} message SendOutReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendOutReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.emails = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleId = options.longs === String ? "0" : 0;
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (typeof message.scheduleId === "number")
                                object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                            else
                                object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                        if (message.emails && message.emails.length) {
                            object.emails = [];
                            for (var j = 0; j < message.emails.length; ++j)
                                object.emails[j] = message.emails[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SendOutReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendOutReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendOutReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendOutReportRequest;
                })();
    
                v1.ReportScheduleLog = (function() {
    
                    /**
                     * Properties of a ReportScheduleLog.
                     * @memberof palexy.streaming.v1
                     * @interface IReportScheduleLog
                     * @property {number|null} [id] ReportScheduleLog id
                     * @property {string|null} [email] ReportScheduleLog email
                     * @property {number|null} [scheduleId] ReportScheduleLog scheduleId
                     * @property {google.protobuf.ITimestamp|null} [createTime] ReportScheduleLog createTime
                     * @property {google.protobuf.ITimestamp|null} [lastSentTime] ReportScheduleLog lastSentTime
                     */
    
                    /**
                     * Constructs a new ReportScheduleLog.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportScheduleLog.
                     * @implements IReportScheduleLog
                     * @constructor
                     * @param {palexy.streaming.v1.IReportScheduleLog=} [properties] Properties to set
                     */
                    function ReportScheduleLog(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportScheduleLog id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     */
                    ReportScheduleLog.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportScheduleLog email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     */
                    ReportScheduleLog.prototype.email = "";
    
                    /**
                     * ReportScheduleLog scheduleId.
                     * @member {number} scheduleId
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     */
                    ReportScheduleLog.prototype.scheduleId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReportScheduleLog createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     */
                    ReportScheduleLog.prototype.createTime = null;
    
                    /**
                     * ReportScheduleLog lastSentTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} lastSentTime
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     */
                    ReportScheduleLog.prototype.lastSentTime = null;
    
                    /**
                     * Creates a new ReportScheduleLog instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleLog=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportScheduleLog} ReportScheduleLog instance
                     */
                    ReportScheduleLog.create = function create(properties) {
                        return new ReportScheduleLog(properties);
                    };
    
                    /**
                     * Encodes the specified ReportScheduleLog message. Does not implicitly {@link palexy.streaming.v1.ReportScheduleLog.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleLog} message ReportScheduleLog message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportScheduleLog.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.email);
                        if (message.scheduleId != null && Object.hasOwnProperty.call(message, "scheduleId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.scheduleId);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.lastSentTime != null && Object.hasOwnProperty.call(message, "lastSentTime"))
                            $root.google.protobuf.Timestamp.encode(message.lastSentTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportScheduleLog message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportScheduleLog.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {palexy.streaming.v1.IReportScheduleLog} message ReportScheduleLog message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportScheduleLog.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportScheduleLog message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportScheduleLog} ReportScheduleLog
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportScheduleLog.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportScheduleLog();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.email = reader.string();
                                break;
                            case 3:
                                message.scheduleId = reader.int64();
                                break;
                            case 4:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.lastSentTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportScheduleLog message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportScheduleLog} ReportScheduleLog
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportScheduleLog.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportScheduleLog message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportScheduleLog.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (!$util.isInteger(message.scheduleId) && !(message.scheduleId && $util.isInteger(message.scheduleId.low) && $util.isInteger(message.scheduleId.high)))
                                return "scheduleId: integer|Long expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.lastSentTime != null && message.hasOwnProperty("lastSentTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.lastSentTime);
                            if (error)
                                return "lastSentTime." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ReportScheduleLog message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportScheduleLog} ReportScheduleLog
                     */
                    ReportScheduleLog.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportScheduleLog)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportScheduleLog();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.scheduleId != null)
                            if ($util.Long)
                                (message.scheduleId = $util.Long.fromValue(object.scheduleId)).unsigned = false;
                            else if (typeof object.scheduleId === "string")
                                message.scheduleId = parseInt(object.scheduleId, 10);
                            else if (typeof object.scheduleId === "number")
                                message.scheduleId = object.scheduleId;
                            else if (typeof object.scheduleId === "object")
                                message.scheduleId = new $util.LongBits(object.scheduleId.low >>> 0, object.scheduleId.high >>> 0).toNumber();
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.ReportScheduleLog.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.lastSentTime != null) {
                            if (typeof object.lastSentTime !== "object")
                                throw TypeError(".palexy.streaming.v1.ReportScheduleLog.lastSentTime: object expected");
                            message.lastSentTime = $root.google.protobuf.Timestamp.fromObject(object.lastSentTime);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportScheduleLog message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @static
                     * @param {palexy.streaming.v1.ReportScheduleLog} message ReportScheduleLog
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportScheduleLog.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.email = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleId = options.longs === String ? "0" : 0;
                            object.createTime = null;
                            object.lastSentTime = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.scheduleId != null && message.hasOwnProperty("scheduleId"))
                            if (typeof message.scheduleId === "number")
                                object.scheduleId = options.longs === String ? String(message.scheduleId) : message.scheduleId;
                            else
                                object.scheduleId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleId) : options.longs === Number ? new $util.LongBits(message.scheduleId.low >>> 0, message.scheduleId.high >>> 0).toNumber() : message.scheduleId;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.lastSentTime != null && message.hasOwnProperty("lastSentTime"))
                            object.lastSentTime = $root.google.protobuf.Timestamp.toObject(message.lastSentTime, options);
                        return object;
                    };
    
                    /**
                     * Converts this ReportScheduleLog to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportScheduleLog
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportScheduleLog.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportScheduleLog;
                })();
    
                v1.ScheduledReport = (function() {
    
                    /**
                     * Properties of a ScheduledReport.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduledReport
                     * @property {palexy.streaming.v1.IDateRange|null} [dateRange] ScheduledReport dateRange
                     * @property {palexy.streaming.v1.ReportSchedule.ScheduleType|null} [type] ScheduledReport type
                     * @property {Array.<palexy.streaming.v1.IScheduledReportWidget>|null} [items] ScheduledReport items
                     * @property {palexy.streaming.v1.ReportSchedule.ReportType|null} [reportType] ScheduledReport reportType
                     * @property {string|null} [languageCode] ScheduledReport languageCode
                     */
    
                    /**
                     * Constructs a new ScheduledReport.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledReport.
                     * @implements IScheduledReport
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduledReport=} [properties] Properties to set
                     */
                    function ScheduledReport(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduledReport dateRange.
                     * @member {palexy.streaming.v1.IDateRange|null|undefined} dateRange
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     */
                    ScheduledReport.prototype.dateRange = null;
    
                    /**
                     * ScheduledReport type.
                     * @member {palexy.streaming.v1.ReportSchedule.ScheduleType} type
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     */
                    ScheduledReport.prototype.type = 0;
    
                    /**
                     * ScheduledReport items.
                     * @member {Array.<palexy.streaming.v1.IScheduledReportWidget>} items
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     */
                    ScheduledReport.prototype.items = $util.emptyArray;
    
                    /**
                     * ScheduledReport reportType.
                     * @member {palexy.streaming.v1.ReportSchedule.ReportType} reportType
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     */
                    ScheduledReport.prototype.reportType = 0;
    
                    /**
                     * ScheduledReport languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     */
                    ScheduledReport.prototype.languageCode = "";
    
                    /**
                     * Creates a new ScheduledReport instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReport=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduledReport} ScheduledReport instance
                     */
                    ScheduledReport.create = function create(properties) {
                        return new ScheduledReport(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduledReport message. Does not implicitly {@link palexy.streaming.v1.ScheduledReport.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReport} message ScheduledReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReport.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateRange.encode(message.dateRange, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.streaming.v1.ScheduledReportWidget.encode(message.items[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.reportType != null && Object.hasOwnProperty.call(message, "reportType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.reportType);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.languageCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduledReport message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduledReport.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReport} message ScheduledReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReport.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduledReport message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduledReport} ScheduledReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReport.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduledReport();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateRange = $root.palexy.streaming.v1.DateRange.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.type = reader.int32();
                                break;
                            case 3:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.streaming.v1.ScheduledReportWidget.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.reportType = reader.int32();
                                break;
                            case 5:
                                message.languageCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduledReport message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduledReport} ScheduledReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReport.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduledReport message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduledReport.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduledReportWidget.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            switch (message.reportType) {
                            default:
                                return "reportType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ScheduledReport message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduledReport} ScheduledReport
                     */
                    ScheduledReport.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduledReport)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduledReport();
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledReport.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateRange.fromObject(object.dateRange);
                        }
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "WEEKLY":
                        case 1:
                            message.type = 1;
                            break;
                        case "MONTHLY":
                        case 2:
                            message.type = 2;
                            break;
                        case "DAILY":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.streaming.v1.ScheduledReport.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ScheduledReport.items: object expected");
                                message.items[i] = $root.palexy.streaming.v1.ScheduledReportWidget.fromObject(object.items[i]);
                            }
                        }
                        switch (object.reportType) {
                        case "UNKNOWN_REPORT_TYPE":
                        case 0:
                            message.reportType = 0;
                            break;
                        case "BASIC":
                        case 1:
                            message.reportType = 1;
                            break;
                        case "STORE_EVENTS":
                        case 2:
                            message.reportType = 2;
                            break;
                        case "REPORT_STUDIO":
                        case 3:
                            message.reportType = 3;
                            break;
                        }
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduledReport message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @static
                     * @param {palexy.streaming.v1.ScheduledReport} message ScheduledReport
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduledReport.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            object.dateRange = null;
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.reportType = options.enums === String ? "UNKNOWN_REPORT_TYPE" : 0;
                            object.languageCode = "";
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateRange.toObject(message.dateRange, options);
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ScheduleType[message.type] : message.type;
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.streaming.v1.ScheduledReportWidget.toObject(message.items[j], options);
                        }
                        if (message.reportType != null && message.hasOwnProperty("reportType"))
                            object.reportType = options.enums === String ? $root.palexy.streaming.v1.ReportSchedule.ReportType[message.reportType] : message.reportType;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        return object;
                    };
    
                    /**
                     * Converts this ScheduledReport to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduledReport
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduledReport.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduledReport;
                })();
    
                v1.ScheduledReportWidget = (function() {
    
                    /**
                     * Properties of a ScheduledReportWidget.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduledReportWidget
                     * @property {string|null} [widgetId] ScheduledReportWidget widgetId
                     * @property {palexy.streaming.v1.IScheduledReportWidgetData|null} [data] ScheduledReportWidget data
                     * @property {palexy.streaming.v1.IWidgetInfo|null} [widgetInfo] ScheduledReportWidget widgetInfo
                     */
    
                    /**
                     * Constructs a new ScheduledReportWidget.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledReportWidget.
                     * @implements IScheduledReportWidget
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduledReportWidget=} [properties] Properties to set
                     */
                    function ScheduledReportWidget(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduledReportWidget widgetId.
                     * @member {string} widgetId
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @instance
                     */
                    ScheduledReportWidget.prototype.widgetId = "";
    
                    /**
                     * ScheduledReportWidget data.
                     * @member {palexy.streaming.v1.IScheduledReportWidgetData|null|undefined} data
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @instance
                     */
                    ScheduledReportWidget.prototype.data = null;
    
                    /**
                     * ScheduledReportWidget widgetInfo.
                     * @member {palexy.streaming.v1.IWidgetInfo|null|undefined} widgetInfo
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @instance
                     */
                    ScheduledReportWidget.prototype.widgetInfo = null;
    
                    /**
                     * Creates a new ScheduledReportWidget instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidget=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduledReportWidget} ScheduledReportWidget instance
                     */
                    ScheduledReportWidget.create = function create(properties) {
                        return new ScheduledReportWidget(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduledReportWidget message. Does not implicitly {@link palexy.streaming.v1.ScheduledReportWidget.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidget} message ScheduledReportWidget message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReportWidget.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.widgetId != null && Object.hasOwnProperty.call(message, "widgetId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.widgetId);
                        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                            $root.palexy.streaming.v1.ScheduledReportWidgetData.encode(message.data, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.widgetInfo != null && Object.hasOwnProperty.call(message, "widgetInfo"))
                            $root.palexy.streaming.v1.WidgetInfo.encode(message.widgetInfo, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduledReportWidget message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduledReportWidget.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidget} message ScheduledReportWidget message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReportWidget.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduledReportWidget message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduledReportWidget} ScheduledReportWidget
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReportWidget.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduledReportWidget();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.widgetId = reader.string();
                                break;
                            case 2:
                                message.data = $root.palexy.streaming.v1.ScheduledReportWidgetData.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.widgetInfo = $root.palexy.streaming.v1.WidgetInfo.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduledReportWidget message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduledReportWidget} ScheduledReportWidget
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReportWidget.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduledReportWidget message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduledReportWidget.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.widgetId != null && message.hasOwnProperty("widgetId"))
                            if (!$util.isString(message.widgetId))
                                return "widgetId: string expected";
                        if (message.data != null && message.hasOwnProperty("data")) {
                            var error = $root.palexy.streaming.v1.ScheduledReportWidgetData.verify(message.data);
                            if (error)
                                return "data." + error;
                        }
                        if (message.widgetInfo != null && message.hasOwnProperty("widgetInfo")) {
                            var error = $root.palexy.streaming.v1.WidgetInfo.verify(message.widgetInfo);
                            if (error)
                                return "widgetInfo." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScheduledReportWidget message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduledReportWidget} ScheduledReportWidget
                     */
                    ScheduledReportWidget.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduledReportWidget)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduledReportWidget();
                        if (object.widgetId != null)
                            message.widgetId = String(object.widgetId);
                        if (object.data != null) {
                            if (typeof object.data !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledReportWidget.data: object expected");
                            message.data = $root.palexy.streaming.v1.ScheduledReportWidgetData.fromObject(object.data);
                        }
                        if (object.widgetInfo != null) {
                            if (typeof object.widgetInfo !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledReportWidget.widgetInfo: object expected");
                            message.widgetInfo = $root.palexy.streaming.v1.WidgetInfo.fromObject(object.widgetInfo);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduledReportWidget message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @static
                     * @param {palexy.streaming.v1.ScheduledReportWidget} message ScheduledReportWidget
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduledReportWidget.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.widgetId = "";
                            object.data = null;
                            object.widgetInfo = null;
                        }
                        if (message.widgetId != null && message.hasOwnProperty("widgetId"))
                            object.widgetId = message.widgetId;
                        if (message.data != null && message.hasOwnProperty("data"))
                            object.data = $root.palexy.streaming.v1.ScheduledReportWidgetData.toObject(message.data, options);
                        if (message.widgetInfo != null && message.hasOwnProperty("widgetInfo"))
                            object.widgetInfo = $root.palexy.streaming.v1.WidgetInfo.toObject(message.widgetInfo, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScheduledReportWidget to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduledReportWidget
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduledReportWidget.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduledReportWidget;
                })();
    
                v1.ScheduledReportWidgetData = (function() {
    
                    /**
                     * Properties of a ScheduledReportWidgetData.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduledReportWidgetData
                     * @property {palexy.streaming.v1.IReportData|null} [data] ScheduledReportWidgetData data
                     */
    
                    /**
                     * Constructs a new ScheduledReportWidgetData.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledReportWidgetData.
                     * @implements IScheduledReportWidgetData
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduledReportWidgetData=} [properties] Properties to set
                     */
                    function ScheduledReportWidgetData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduledReportWidgetData data.
                     * @member {palexy.streaming.v1.IReportData|null|undefined} data
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @instance
                     */
                    ScheduledReportWidgetData.prototype.data = null;
    
                    /**
                     * Creates a new ScheduledReportWidgetData instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidgetData=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduledReportWidgetData} ScheduledReportWidgetData instance
                     */
                    ScheduledReportWidgetData.create = function create(properties) {
                        return new ScheduledReportWidgetData(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduledReportWidgetData message. Does not implicitly {@link palexy.streaming.v1.ScheduledReportWidgetData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidgetData} message ScheduledReportWidgetData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReportWidgetData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.data != null && Object.hasOwnProperty.call(message, "data"))
                            $root.palexy.streaming.v1.ReportData.encode(message.data, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduledReportWidgetData message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduledReportWidgetData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {palexy.streaming.v1.IScheduledReportWidgetData} message ScheduledReportWidgetData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledReportWidgetData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduledReportWidgetData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduledReportWidgetData} ScheduledReportWidgetData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReportWidgetData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduledReportWidgetData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 3:
                                message.data = $root.palexy.streaming.v1.ReportData.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduledReportWidgetData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduledReportWidgetData} ScheduledReportWidgetData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledReportWidgetData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduledReportWidgetData message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduledReportWidgetData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.data != null && message.hasOwnProperty("data")) {
                            var error = $root.palexy.streaming.v1.ReportData.verify(message.data);
                            if (error)
                                return "data." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScheduledReportWidgetData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduledReportWidgetData} ScheduledReportWidgetData
                     */
                    ScheduledReportWidgetData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduledReportWidgetData)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduledReportWidgetData();
                        if (object.data != null) {
                            if (typeof object.data !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledReportWidgetData.data: object expected");
                            message.data = $root.palexy.streaming.v1.ReportData.fromObject(object.data);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduledReportWidgetData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @static
                     * @param {palexy.streaming.v1.ScheduledReportWidgetData} message ScheduledReportWidgetData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduledReportWidgetData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.data = null;
                        if (message.data != null && message.hasOwnProperty("data"))
                            object.data = $root.palexy.streaming.v1.ReportData.toObject(message.data, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScheduledReportWidgetData to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduledReportWidgetData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduledReportWidgetData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduledReportWidgetData;
                })();
    
                v1.WidgetInfo = (function() {
    
                    /**
                     * Properties of a WidgetInfo.
                     * @memberof palexy.streaming.v1
                     * @interface IWidgetInfo
                     * @property {palexy.streaming.v1.IStoreMetadata|null} [storeMetadata] WidgetInfo storeMetadata
                     * @property {palexy.streaming.v1.IStore|null} [parentStore] WidgetInfo parentStore
                     */
    
                    /**
                     * Constructs a new WidgetInfo.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a WidgetInfo.
                     * @implements IWidgetInfo
                     * @constructor
                     * @param {palexy.streaming.v1.IWidgetInfo=} [properties] Properties to set
                     */
                    function WidgetInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WidgetInfo storeMetadata.
                     * @member {palexy.streaming.v1.IStoreMetadata|null|undefined} storeMetadata
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @instance
                     */
                    WidgetInfo.prototype.storeMetadata = null;
    
                    /**
                     * WidgetInfo parentStore.
                     * @member {palexy.streaming.v1.IStore|null|undefined} parentStore
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @instance
                     */
                    WidgetInfo.prototype.parentStore = null;
    
                    /**
                     * Creates a new WidgetInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {palexy.streaming.v1.IWidgetInfo=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.WidgetInfo} WidgetInfo instance
                     */
                    WidgetInfo.create = function create(properties) {
                        return new WidgetInfo(properties);
                    };
    
                    /**
                     * Encodes the specified WidgetInfo message. Does not implicitly {@link palexy.streaming.v1.WidgetInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {palexy.streaming.v1.IWidgetInfo} message WidgetInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WidgetInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeMetadata != null && Object.hasOwnProperty.call(message, "storeMetadata"))
                            $root.palexy.streaming.v1.StoreMetadata.encode(message.storeMetadata, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.parentStore != null && Object.hasOwnProperty.call(message, "parentStore"))
                            $root.palexy.streaming.v1.Store.encode(message.parentStore, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WidgetInfo message, length delimited. Does not implicitly {@link palexy.streaming.v1.WidgetInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {palexy.streaming.v1.IWidgetInfo} message WidgetInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WidgetInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WidgetInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.WidgetInfo} WidgetInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WidgetInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.WidgetInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeMetadata = $root.palexy.streaming.v1.StoreMetadata.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.parentStore = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WidgetInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.WidgetInfo} WidgetInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WidgetInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WidgetInfo message.
                     * @function verify
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WidgetInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeMetadata != null && message.hasOwnProperty("storeMetadata")) {
                            var error = $root.palexy.streaming.v1.StoreMetadata.verify(message.storeMetadata);
                            if (error)
                                return "storeMetadata." + error;
                        }
                        if (message.parentStore != null && message.hasOwnProperty("parentStore")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.parentStore);
                            if (error)
                                return "parentStore." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a WidgetInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.WidgetInfo} WidgetInfo
                     */
                    WidgetInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.WidgetInfo)
                            return object;
                        var message = new $root.palexy.streaming.v1.WidgetInfo();
                        if (object.storeMetadata != null) {
                            if (typeof object.storeMetadata !== "object")
                                throw TypeError(".palexy.streaming.v1.WidgetInfo.storeMetadata: object expected");
                            message.storeMetadata = $root.palexy.streaming.v1.StoreMetadata.fromObject(object.storeMetadata);
                        }
                        if (object.parentStore != null) {
                            if (typeof object.parentStore !== "object")
                                throw TypeError(".palexy.streaming.v1.WidgetInfo.parentStore: object expected");
                            message.parentStore = $root.palexy.streaming.v1.Store.fromObject(object.parentStore);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WidgetInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @static
                     * @param {palexy.streaming.v1.WidgetInfo} message WidgetInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WidgetInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeMetadata = null;
                            object.parentStore = null;
                        }
                        if (message.storeMetadata != null && message.hasOwnProperty("storeMetadata"))
                            object.storeMetadata = $root.palexy.streaming.v1.StoreMetadata.toObject(message.storeMetadata, options);
                        if (message.parentStore != null && message.hasOwnProperty("parentStore"))
                            object.parentStore = $root.palexy.streaming.v1.Store.toObject(message.parentStore, options);
                        return object;
                    };
    
                    /**
                     * Converts this WidgetInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.WidgetInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WidgetInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return WidgetInfo;
                })();
    
                v1.StoreMetadata = (function() {
    
                    /**
                     * Properties of a StoreMetadata.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreMetadata
                     * @property {number|null} [id] StoreMetadata id
                     * @property {string|null} [label] StoreMetadata label
                     * @property {number|null} [dimensionIndex] StoreMetadata dimensionIndex
                     * @property {number|null} [metadataTypeId] StoreMetadata metadataTypeId
                     * @property {number|null} [metadataValueId] StoreMetadata metadataValueId
                     */
    
                    /**
                     * Constructs a new StoreMetadata.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreMetadata.
                     * @implements IStoreMetadata
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreMetadata=} [properties] Properties to set
                     */
                    function StoreMetadata(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreMetadata id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     */
                    StoreMetadata.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreMetadata label.
                     * @member {string} label
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     */
                    StoreMetadata.prototype.label = "";
    
                    /**
                     * StoreMetadata dimensionIndex.
                     * @member {number} dimensionIndex
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     */
                    StoreMetadata.prototype.dimensionIndex = 0;
    
                    /**
                     * StoreMetadata metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     */
                    StoreMetadata.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreMetadata metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     */
                    StoreMetadata.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StoreMetadata instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {palexy.streaming.v1.IStoreMetadata=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreMetadata} StoreMetadata instance
                     */
                    StoreMetadata.create = function create(properties) {
                        return new StoreMetadata(properties);
                    };
    
                    /**
                     * Encodes the specified StoreMetadata message. Does not implicitly {@link palexy.streaming.v1.StoreMetadata.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {palexy.streaming.v1.IStoreMetadata} message StoreMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreMetadata.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
                        if (message.dimensionIndex != null && Object.hasOwnProperty.call(message, "dimensionIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dimensionIndex);
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.metadataTypeId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.metadataValueId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreMetadata.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {palexy.streaming.v1.IStoreMetadata} message StoreMetadata message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreMetadata message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreMetadata} StoreMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreMetadata.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreMetadata();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.label = reader.string();
                                break;
                            case 3:
                                message.dimensionIndex = reader.int32();
                                break;
                            case 4:
                                message.metadataTypeId = reader.int64();
                                break;
                            case 5:
                                message.metadataValueId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreMetadata message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreMetadata} StoreMetadata
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreMetadata.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreMetadata message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreMetadata.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            if (!$util.isInteger(message.dimensionIndex))
                                return "dimensionIndex: integer expected";
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreMetadata message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreMetadata} StoreMetadata
                     */
                    StoreMetadata.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreMetadata)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreMetadata();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.label != null)
                            message.label = String(object.label);
                        if (object.dimensionIndex != null)
                            message.dimensionIndex = object.dimensionIndex | 0;
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreMetadata message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @static
                     * @param {palexy.streaming.v1.StoreMetadata} message StoreMetadata
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreMetadata.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.label = "";
                            object.dimensionIndex = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        if (message.dimensionIndex != null && message.hasOwnProperty("dimensionIndex"))
                            object.dimensionIndex = message.dimensionIndex;
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        return object;
                    };
    
                    /**
                     * Converts this StoreMetadata to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreMetadata
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreMetadata.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreMetadata;
                })();
    
                v1.ReportData = (function() {
    
                    /**
                     * Properties of a ReportData.
                     * @memberof palexy.streaming.v1
                     * @interface IReportData
                     * @property {Array.<string>|null} [dates] ReportData dates
                     * @property {Array.<string>|null} [dimensions] ReportData dimensions
                     * @property {Array.<number>|null} [metricTotals] ReportData metricTotals
                     * @property {Array.<palexy.streaming.v1.IReportMetric>|null} [metrics] ReportData metrics
                     * @property {Array.<palexy.streaming.v1.IReportRow>|null} [rows] ReportData rows
                     */
    
                    /**
                     * Constructs a new ReportData.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportData.
                     * @implements IReportData
                     * @constructor
                     * @param {palexy.streaming.v1.IReportData=} [properties] Properties to set
                     */
                    function ReportData(properties) {
                        this.dates = [];
                        this.dimensions = [];
                        this.metricTotals = [];
                        this.metrics = [];
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportData dates.
                     * @member {Array.<string>} dates
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     */
                    ReportData.prototype.dates = $util.emptyArray;
    
                    /**
                     * ReportData dimensions.
                     * @member {Array.<string>} dimensions
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     */
                    ReportData.prototype.dimensions = $util.emptyArray;
    
                    /**
                     * ReportData metricTotals.
                     * @member {Array.<number>} metricTotals
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     */
                    ReportData.prototype.metricTotals = $util.emptyArray;
    
                    /**
                     * ReportData metrics.
                     * @member {Array.<palexy.streaming.v1.IReportMetric>} metrics
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     */
                    ReportData.prototype.metrics = $util.emptyArray;
    
                    /**
                     * ReportData rows.
                     * @member {Array.<palexy.streaming.v1.IReportRow>} rows
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     */
                    ReportData.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new ReportData instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {palexy.streaming.v1.IReportData=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportData} ReportData instance
                     */
                    ReportData.create = function create(properties) {
                        return new ReportData(properties);
                    };
    
                    /**
                     * Encodes the specified ReportData message. Does not implicitly {@link palexy.streaming.v1.ReportData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {palexy.streaming.v1.IReportData} message ReportData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dates != null && message.dates.length)
                            for (var i = 0; i < message.dates.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dates[i]);
                        if (message.dimensions != null && message.dimensions.length)
                            for (var i = 0; i < message.dimensions.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dimensions[i]);
                        if (message.metricTotals != null && message.metricTotals.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.metricTotals.length; ++i)
                                writer.double(message.metricTotals[i]);
                            writer.ldelim();
                        }
                        if (message.metrics != null && message.metrics.length)
                            for (var i = 0; i < message.metrics.length; ++i)
                                $root.palexy.streaming.v1.ReportMetric.encode(message.metrics[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.streaming.v1.ReportRow.encode(message.rows[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportData message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {palexy.streaming.v1.IReportData} message ReportData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportData} ReportData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dates && message.dates.length))
                                    message.dates = [];
                                message.dates.push(reader.string());
                                break;
                            case 2:
                                if (!(message.dimensions && message.dimensions.length))
                                    message.dimensions = [];
                                message.dimensions.push(reader.string());
                                break;
                            case 3:
                                if (!(message.metricTotals && message.metricTotals.length))
                                    message.metricTotals = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.metricTotals.push(reader.double());
                                } else
                                    message.metricTotals.push(reader.double());
                                break;
                            case 4:
                                if (!(message.metrics && message.metrics.length))
                                    message.metrics = [];
                                message.metrics.push($root.palexy.streaming.v1.ReportMetric.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.streaming.v1.ReportRow.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportData} ReportData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportData message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dates != null && message.hasOwnProperty("dates")) {
                            if (!Array.isArray(message.dates))
                                return "dates: array expected";
                            for (var i = 0; i < message.dates.length; ++i)
                                if (!$util.isString(message.dates[i]))
                                    return "dates: string[] expected";
                        }
                        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                            if (!Array.isArray(message.dimensions))
                                return "dimensions: array expected";
                            for (var i = 0; i < message.dimensions.length; ++i)
                                if (!$util.isString(message.dimensions[i]))
                                    return "dimensions: string[] expected";
                        }
                        if (message.metricTotals != null && message.hasOwnProperty("metricTotals")) {
                            if (!Array.isArray(message.metricTotals))
                                return "metricTotals: array expected";
                            for (var i = 0; i < message.metricTotals.length; ++i)
                                if (typeof message.metricTotals[i] !== "number")
                                    return "metricTotals: number[] expected";
                        }
                        if (message.metrics != null && message.hasOwnProperty("metrics")) {
                            if (!Array.isArray(message.metrics))
                                return "metrics: array expected";
                            for (var i = 0; i < message.metrics.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportMetric.verify(message.metrics[i]);
                                if (error)
                                    return "metrics." + error;
                            }
                        }
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.streaming.v1.ReportRow.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ReportData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportData} ReportData
                     */
                    ReportData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportData)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportData();
                        if (object.dates) {
                            if (!Array.isArray(object.dates))
                                throw TypeError(".palexy.streaming.v1.ReportData.dates: array expected");
                            message.dates = [];
                            for (var i = 0; i < object.dates.length; ++i)
                                message.dates[i] = String(object.dates[i]);
                        }
                        if (object.dimensions) {
                            if (!Array.isArray(object.dimensions))
                                throw TypeError(".palexy.streaming.v1.ReportData.dimensions: array expected");
                            message.dimensions = [];
                            for (var i = 0; i < object.dimensions.length; ++i)
                                message.dimensions[i] = String(object.dimensions[i]);
                        }
                        if (object.metricTotals) {
                            if (!Array.isArray(object.metricTotals))
                                throw TypeError(".palexy.streaming.v1.ReportData.metricTotals: array expected");
                            message.metricTotals = [];
                            for (var i = 0; i < object.metricTotals.length; ++i)
                                message.metricTotals[i] = Number(object.metricTotals[i]);
                        }
                        if (object.metrics) {
                            if (!Array.isArray(object.metrics))
                                throw TypeError(".palexy.streaming.v1.ReportData.metrics: array expected");
                            message.metrics = [];
                            for (var i = 0; i < object.metrics.length; ++i) {
                                if (typeof object.metrics[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ReportData.metrics: object expected");
                                message.metrics[i] = $root.palexy.streaming.v1.ReportMetric.fromObject(object.metrics[i]);
                            }
                        }
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.streaming.v1.ReportData.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ReportData.rows: object expected");
                                message.rows[i] = $root.palexy.streaming.v1.ReportRow.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportData
                     * @static
                     * @param {palexy.streaming.v1.ReportData} message ReportData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dates = [];
                            object.dimensions = [];
                            object.metricTotals = [];
                            object.metrics = [];
                            object.rows = [];
                        }
                        if (message.dates && message.dates.length) {
                            object.dates = [];
                            for (var j = 0; j < message.dates.length; ++j)
                                object.dates[j] = message.dates[j];
                        }
                        if (message.dimensions && message.dimensions.length) {
                            object.dimensions = [];
                            for (var j = 0; j < message.dimensions.length; ++j)
                                object.dimensions[j] = message.dimensions[j];
                        }
                        if (message.metricTotals && message.metricTotals.length) {
                            object.metricTotals = [];
                            for (var j = 0; j < message.metricTotals.length; ++j)
                                object.metricTotals[j] = options.json && !isFinite(message.metricTotals[j]) ? String(message.metricTotals[j]) : message.metricTotals[j];
                        }
                        if (message.metrics && message.metrics.length) {
                            object.metrics = [];
                            for (var j = 0; j < message.metrics.length; ++j)
                                object.metrics[j] = $root.palexy.streaming.v1.ReportMetric.toObject(message.metrics[j], options);
                        }
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.streaming.v1.ReportRow.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ReportData to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportData;
                })();
    
                v1.ReportMetric = (function() {
    
                    /**
                     * Properties of a ReportMetric.
                     * @memberof palexy.streaming.v1
                     * @interface IReportMetric
                     * @property {string|null} [id] ReportMetric id
                     * @property {number|null} [dateRangeIndex] ReportMetric dateRangeIndex
                     */
    
                    /**
                     * Constructs a new ReportMetric.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportMetric.
                     * @implements IReportMetric
                     * @constructor
                     * @param {palexy.streaming.v1.IReportMetric=} [properties] Properties to set
                     */
                    function ReportMetric(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportMetric id.
                     * @member {string} id
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @instance
                     */
                    ReportMetric.prototype.id = "";
    
                    /**
                     * ReportMetric dateRangeIndex.
                     * @member {number} dateRangeIndex
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @instance
                     */
                    ReportMetric.prototype.dateRangeIndex = 0;
    
                    /**
                     * Creates a new ReportMetric instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {palexy.streaming.v1.IReportMetric=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportMetric} ReportMetric instance
                     */
                    ReportMetric.create = function create(properties) {
                        return new ReportMetric(properties);
                    };
    
                    /**
                     * Encodes the specified ReportMetric message. Does not implicitly {@link palexy.streaming.v1.ReportMetric.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {palexy.streaming.v1.IReportMetric} message ReportMetric message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportMetric.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.dateRangeIndex != null && Object.hasOwnProperty.call(message, "dateRangeIndex"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateRangeIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportMetric message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportMetric.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {palexy.streaming.v1.IReportMetric} message ReportMetric message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportMetric.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportMetric message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportMetric} ReportMetric
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportMetric.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportMetric();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.dateRangeIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportMetric message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportMetric} ReportMetric
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportMetric.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportMetric message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportMetric.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.dateRangeIndex != null && message.hasOwnProperty("dateRangeIndex"))
                            if (!$util.isInteger(message.dateRangeIndex))
                                return "dateRangeIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReportMetric message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportMetric} ReportMetric
                     */
                    ReportMetric.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportMetric)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportMetric();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.dateRangeIndex != null)
                            message.dateRangeIndex = object.dateRangeIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportMetric message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @static
                     * @param {palexy.streaming.v1.ReportMetric} message ReportMetric
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportMetric.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.id = "";
                            object.dateRangeIndex = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.dateRangeIndex != null && message.hasOwnProperty("dateRangeIndex"))
                            object.dateRangeIndex = message.dateRangeIndex;
                        return object;
                    };
    
                    /**
                     * Converts this ReportMetric to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportMetric
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportMetric.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportMetric;
                })();
    
                v1.ReportRow = (function() {
    
                    /**
                     * Properties of a ReportRow.
                     * @memberof palexy.streaming.v1
                     * @interface IReportRow
                     * @property {Array.<string>|null} [dimensionValues] ReportRow dimensionValues
                     * @property {Array.<number>|null} [metricValues] ReportRow metricValues
                     */
    
                    /**
                     * Constructs a new ReportRow.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportRow.
                     * @implements IReportRow
                     * @constructor
                     * @param {palexy.streaming.v1.IReportRow=} [properties] Properties to set
                     */
                    function ReportRow(properties) {
                        this.dimensionValues = [];
                        this.metricValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReportRow dimensionValues.
                     * @member {Array.<string>} dimensionValues
                     * @memberof palexy.streaming.v1.ReportRow
                     * @instance
                     */
                    ReportRow.prototype.dimensionValues = $util.emptyArray;
    
                    /**
                     * ReportRow metricValues.
                     * @member {Array.<number>} metricValues
                     * @memberof palexy.streaming.v1.ReportRow
                     * @instance
                     */
                    ReportRow.prototype.metricValues = $util.emptyArray;
    
                    /**
                     * Creates a new ReportRow instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {palexy.streaming.v1.IReportRow=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReportRow} ReportRow instance
                     */
                    ReportRow.create = function create(properties) {
                        return new ReportRow(properties);
                    };
    
                    /**
                     * Encodes the specified ReportRow message. Does not implicitly {@link palexy.streaming.v1.ReportRow.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {palexy.streaming.v1.IReportRow} message ReportRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportRow.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dimensionValues != null && message.dimensionValues.length)
                            for (var i = 0; i < message.dimensionValues.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dimensionValues[i]);
                        if (message.metricValues != null && message.metricValues.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.metricValues.length; ++i)
                                writer.double(message.metricValues[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReportRow message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReportRow.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {palexy.streaming.v1.IReportRow} message ReportRow message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReportRow.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReportRow message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReportRow} ReportRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportRow.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReportRow();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dimensionValues && message.dimensionValues.length))
                                    message.dimensionValues = [];
                                message.dimensionValues.push(reader.string());
                                break;
                            case 2:
                                if (!(message.metricValues && message.metricValues.length))
                                    message.metricValues = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.metricValues.push(reader.double());
                                } else
                                    message.metricValues.push(reader.double());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReportRow message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReportRow} ReportRow
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReportRow.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReportRow message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReportRow.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dimensionValues != null && message.hasOwnProperty("dimensionValues")) {
                            if (!Array.isArray(message.dimensionValues))
                                return "dimensionValues: array expected";
                            for (var i = 0; i < message.dimensionValues.length; ++i)
                                if (!$util.isString(message.dimensionValues[i]))
                                    return "dimensionValues: string[] expected";
                        }
                        if (message.metricValues != null && message.hasOwnProperty("metricValues")) {
                            if (!Array.isArray(message.metricValues))
                                return "metricValues: array expected";
                            for (var i = 0; i < message.metricValues.length; ++i)
                                if (typeof message.metricValues[i] !== "number")
                                    return "metricValues: number[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ReportRow message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReportRow} ReportRow
                     */
                    ReportRow.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReportRow)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReportRow();
                        if (object.dimensionValues) {
                            if (!Array.isArray(object.dimensionValues))
                                throw TypeError(".palexy.streaming.v1.ReportRow.dimensionValues: array expected");
                            message.dimensionValues = [];
                            for (var i = 0; i < object.dimensionValues.length; ++i)
                                message.dimensionValues[i] = String(object.dimensionValues[i]);
                        }
                        if (object.metricValues) {
                            if (!Array.isArray(object.metricValues))
                                throw TypeError(".palexy.streaming.v1.ReportRow.metricValues: array expected");
                            message.metricValues = [];
                            for (var i = 0; i < object.metricValues.length; ++i)
                                message.metricValues[i] = Number(object.metricValues[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReportRow message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReportRow
                     * @static
                     * @param {palexy.streaming.v1.ReportRow} message ReportRow
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReportRow.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dimensionValues = [];
                            object.metricValues = [];
                        }
                        if (message.dimensionValues && message.dimensionValues.length) {
                            object.dimensionValues = [];
                            for (var j = 0; j < message.dimensionValues.length; ++j)
                                object.dimensionValues[j] = message.dimensionValues[j];
                        }
                        if (message.metricValues && message.metricValues.length) {
                            object.metricValues = [];
                            for (var j = 0; j < message.metricValues.length; ++j)
                                object.metricValues[j] = options.json && !isFinite(message.metricValues[j]) ? String(message.metricValues[j]) : message.metricValues[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ReportRow to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReportRow
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReportRow.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReportRow;
                })();
    
                v1.CustomerActivityService = (function() {
    
                    /**
                     * Constructs a new CustomerActivityService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerActivityService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CustomerActivityService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CustomerActivityService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CustomerActivityService;
    
                    /**
                     * Creates new CustomerActivityService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CustomerActivityService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CustomerActivityService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CustomerActivityService#aggregateDataLevel2}.
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @typedef AggregateDataLevel2Callback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AggregateDataLevel2Response} [response] AggregateDataLevel2Response
                     */
    
                    /**
                     * Calls AggregateDataLevel2.
                     * @function aggregateDataLevel2
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @instance
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request} request AggregateDataLevel2Request message or plain object
                     * @param {palexy.streaming.v1.CustomerActivityService.AggregateDataLevel2Callback} callback Node-style callback called with the error, if any, and AggregateDataLevel2Response
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CustomerActivityService.prototype.aggregateDataLevel2 = function aggregateDataLevel2(request, callback) {
                        return this.rpcCall(aggregateDataLevel2, $root.palexy.streaming.v1.AggregateDataLevel2Request, $root.palexy.streaming.v1.AggregateDataLevel2Response, request, callback);
                    }, "name", { value: "AggregateDataLevel2" });
    
                    /**
                     * Calls AggregateDataLevel2.
                     * @function aggregateDataLevel2
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @instance
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request} request AggregateDataLevel2Request message or plain object
                     * @returns {Promise<palexy.streaming.v1.AggregateDataLevel2Response>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CustomerActivityService#getAggregateLevel2Params}.
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @typedef GetAggregateLevel2ParamsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AggregateLevel2Params} [response] AggregateLevel2Params
                     */
    
                    /**
                     * Calls GetAggregateLevel2Params.
                     * @function getAggregateLevel2Params
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest} request GetAggregateLevel2ParamsRequest message or plain object
                     * @param {palexy.streaming.v1.CustomerActivityService.GetAggregateLevel2ParamsCallback} callback Node-style callback called with the error, if any, and AggregateLevel2Params
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CustomerActivityService.prototype.getAggregateLevel2Params = function getAggregateLevel2Params(request, callback) {
                        return this.rpcCall(getAggregateLevel2Params, $root.palexy.streaming.v1.GetAggregateLevel2ParamsRequest, $root.palexy.streaming.v1.AggregateLevel2Params, request, callback);
                    }, "name", { value: "GetAggregateLevel2Params" });
    
                    /**
                     * Calls GetAggregateLevel2Params.
                     * @function getAggregateLevel2Params
                     * @memberof palexy.streaming.v1.CustomerActivityService
                     * @instance
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest} request GetAggregateLevel2ParamsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AggregateLevel2Params>} Promise
                     * @variation 2
                     */
    
                    return CustomerActivityService;
                })();
    
                v1.AggregateDataLevel2Request = (function() {
    
                    /**
                     * Properties of an AggregateDataLevel2Request.
                     * @memberof palexy.streaming.v1
                     * @interface IAggregateDataLevel2Request
                     * @property {number|null} [storeId] AggregateDataLevel2Request storeId
                     * @property {number|null} [dateId] AggregateDataLevel2Request dateId
                     */
    
                    /**
                     * Constructs a new AggregateDataLevel2Request.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AggregateDataLevel2Request.
                     * @implements IAggregateDataLevel2Request
                     * @constructor
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request=} [properties] Properties to set
                     */
                    function AggregateDataLevel2Request(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AggregateDataLevel2Request storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @instance
                     */
                    AggregateDataLevel2Request.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AggregateDataLevel2Request dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @instance
                     */
                    AggregateDataLevel2Request.prototype.dateId = 0;
    
                    /**
                     * Creates a new AggregateDataLevel2Request instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Request} AggregateDataLevel2Request instance
                     */
                    AggregateDataLevel2Request.create = function create(properties) {
                        return new AggregateDataLevel2Request(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateDataLevel2Request message. Does not implicitly {@link palexy.streaming.v1.AggregateDataLevel2Request.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request} message AggregateDataLevel2Request message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateDataLevel2Request.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateDataLevel2Request message, length delimited. Does not implicitly {@link palexy.streaming.v1.AggregateDataLevel2Request.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Request} message AggregateDataLevel2Request message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateDataLevel2Request.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateDataLevel2Request message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Request} AggregateDataLevel2Request
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateDataLevel2Request.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AggregateDataLevel2Request();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateDataLevel2Request message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Request} AggregateDataLevel2Request
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateDataLevel2Request.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateDataLevel2Request message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateDataLevel2Request.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateDataLevel2Request message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Request} AggregateDataLevel2Request
                     */
                    AggregateDataLevel2Request.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AggregateDataLevel2Request)
                            return object;
                        var message = new $root.palexy.streaming.v1.AggregateDataLevel2Request();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AggregateDataLevel2Request message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @static
                     * @param {palexy.streaming.v1.AggregateDataLevel2Request} message AggregateDataLevel2Request
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateDataLevel2Request.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this AggregateDataLevel2Request to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Request
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateDataLevel2Request.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateDataLevel2Request;
                })();
    
                v1.AggregateDataLevel2Response = (function() {
    
                    /**
                     * Properties of an AggregateDataLevel2Response.
                     * @memberof palexy.streaming.v1
                     * @interface IAggregateDataLevel2Response
                     */
    
                    /**
                     * Constructs a new AggregateDataLevel2Response.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AggregateDataLevel2Response.
                     * @implements IAggregateDataLevel2Response
                     * @constructor
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Response=} [properties] Properties to set
                     */
                    function AggregateDataLevel2Response(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new AggregateDataLevel2Response instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Response=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Response} AggregateDataLevel2Response instance
                     */
                    AggregateDataLevel2Response.create = function create(properties) {
                        return new AggregateDataLevel2Response(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateDataLevel2Response message. Does not implicitly {@link palexy.streaming.v1.AggregateDataLevel2Response.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Response} message AggregateDataLevel2Response message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateDataLevel2Response.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateDataLevel2Response message, length delimited. Does not implicitly {@link palexy.streaming.v1.AggregateDataLevel2Response.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {palexy.streaming.v1.IAggregateDataLevel2Response} message AggregateDataLevel2Response message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateDataLevel2Response.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateDataLevel2Response message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Response} AggregateDataLevel2Response
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateDataLevel2Response.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AggregateDataLevel2Response();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateDataLevel2Response message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Response} AggregateDataLevel2Response
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateDataLevel2Response.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateDataLevel2Response message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateDataLevel2Response.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateDataLevel2Response message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AggregateDataLevel2Response} AggregateDataLevel2Response
                     */
                    AggregateDataLevel2Response.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AggregateDataLevel2Response)
                            return object;
                        return new $root.palexy.streaming.v1.AggregateDataLevel2Response();
                    };
    
                    /**
                     * Creates a plain object from an AggregateDataLevel2Response message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @static
                     * @param {palexy.streaming.v1.AggregateDataLevel2Response} message AggregateDataLevel2Response
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateDataLevel2Response.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this AggregateDataLevel2Response to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AggregateDataLevel2Response
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateDataLevel2Response.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateDataLevel2Response;
                })();
    
                v1.GetAggregateLevel2ParamsRequest = (function() {
    
                    /**
                     * Properties of a GetAggregateLevel2ParamsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetAggregateLevel2ParamsRequest
                     * @property {number|null} [storeId] GetAggregateLevel2ParamsRequest storeId
                     * @property {number|null} [dateId] GetAggregateLevel2ParamsRequest dateId
                     * @property {boolean|null} [includeStaffingData] GetAggregateLevel2ParamsRequest includeStaffingData
                     * @property {boolean|null} [includePosData] GetAggregateLevel2ParamsRequest includePosData
                     * @property {boolean|null} [includeForecastData] GetAggregateLevel2ParamsRequest includeForecastData
                     * @property {boolean|null} [includeFileData] GetAggregateLevel2ParamsRequest includeFileData
                     */
    
                    /**
                     * Constructs a new GetAggregateLevel2ParamsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetAggregateLevel2ParamsRequest.
                     * @implements IGetAggregateLevel2ParamsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest=} [properties] Properties to set
                     */
                    function GetAggregateLevel2ParamsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAggregateLevel2ParamsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetAggregateLevel2ParamsRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.dateId = 0;
    
                    /**
                     * GetAggregateLevel2ParamsRequest includeStaffingData.
                     * @member {boolean} includeStaffingData
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.includeStaffingData = false;
    
                    /**
                     * GetAggregateLevel2ParamsRequest includePosData.
                     * @member {boolean} includePosData
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.includePosData = false;
    
                    /**
                     * GetAggregateLevel2ParamsRequest includeForecastData.
                     * @member {boolean} includeForecastData
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.includeForecastData = false;
    
                    /**
                     * GetAggregateLevel2ParamsRequest includeFileData.
                     * @member {boolean} includeFileData
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     */
                    GetAggregateLevel2ParamsRequest.prototype.includeFileData = false;
    
                    /**
                     * Creates a new GetAggregateLevel2ParamsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetAggregateLevel2ParamsRequest} GetAggregateLevel2ParamsRequest instance
                     */
                    GetAggregateLevel2ParamsRequest.create = function create(properties) {
                        return new GetAggregateLevel2ParamsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetAggregateLevel2ParamsRequest message. Does not implicitly {@link palexy.streaming.v1.GetAggregateLevel2ParamsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest} message GetAggregateLevel2ParamsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAggregateLevel2ParamsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.includeStaffingData != null && Object.hasOwnProperty.call(message, "includeStaffingData"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeStaffingData);
                        if (message.includePosData != null && Object.hasOwnProperty.call(message, "includePosData"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includePosData);
                        if (message.includeForecastData != null && Object.hasOwnProperty.call(message, "includeForecastData"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeForecastData);
                        if (message.includeFileData != null && Object.hasOwnProperty.call(message, "includeFileData"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeFileData);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAggregateLevel2ParamsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetAggregateLevel2ParamsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetAggregateLevel2ParamsRequest} message GetAggregateLevel2ParamsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAggregateLevel2ParamsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAggregateLevel2ParamsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetAggregateLevel2ParamsRequest} GetAggregateLevel2ParamsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAggregateLevel2ParamsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetAggregateLevel2ParamsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.includeStaffingData = reader.bool();
                                break;
                            case 4:
                                message.includePosData = reader.bool();
                                break;
                            case 5:
                                message.includeForecastData = reader.bool();
                                break;
                            case 6:
                                message.includeFileData = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAggregateLevel2ParamsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetAggregateLevel2ParamsRequest} GetAggregateLevel2ParamsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAggregateLevel2ParamsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAggregateLevel2ParamsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAggregateLevel2ParamsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.includeStaffingData != null && message.hasOwnProperty("includeStaffingData"))
                            if (typeof message.includeStaffingData !== "boolean")
                                return "includeStaffingData: boolean expected";
                        if (message.includePosData != null && message.hasOwnProperty("includePosData"))
                            if (typeof message.includePosData !== "boolean")
                                return "includePosData: boolean expected";
                        if (message.includeForecastData != null && message.hasOwnProperty("includeForecastData"))
                            if (typeof message.includeForecastData !== "boolean")
                                return "includeForecastData: boolean expected";
                        if (message.includeFileData != null && message.hasOwnProperty("includeFileData"))
                            if (typeof message.includeFileData !== "boolean")
                                return "includeFileData: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetAggregateLevel2ParamsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetAggregateLevel2ParamsRequest} GetAggregateLevel2ParamsRequest
                     */
                    GetAggregateLevel2ParamsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetAggregateLevel2ParamsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetAggregateLevel2ParamsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.includeStaffingData != null)
                            message.includeStaffingData = Boolean(object.includeStaffingData);
                        if (object.includePosData != null)
                            message.includePosData = Boolean(object.includePosData);
                        if (object.includeForecastData != null)
                            message.includeForecastData = Boolean(object.includeForecastData);
                        if (object.includeFileData != null)
                            message.includeFileData = Boolean(object.includeFileData);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAggregateLevel2ParamsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @static
                     * @param {palexy.streaming.v1.GetAggregateLevel2ParamsRequest} message GetAggregateLevel2ParamsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAggregateLevel2ParamsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.includeStaffingData = false;
                            object.includePosData = false;
                            object.includeForecastData = false;
                            object.includeFileData = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.includeStaffingData != null && message.hasOwnProperty("includeStaffingData"))
                            object.includeStaffingData = message.includeStaffingData;
                        if (message.includePosData != null && message.hasOwnProperty("includePosData"))
                            object.includePosData = message.includePosData;
                        if (message.includeForecastData != null && message.hasOwnProperty("includeForecastData"))
                            object.includeForecastData = message.includeForecastData;
                        if (message.includeFileData != null && message.hasOwnProperty("includeFileData"))
                            object.includeFileData = message.includeFileData;
                        return object;
                    };
    
                    /**
                     * Converts this GetAggregateLevel2ParamsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetAggregateLevel2ParamsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAggregateLevel2ParamsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAggregateLevel2ParamsRequest;
                })();
    
                v1.AggregateLevel2Params = (function() {
    
                    /**
                     * Properties of an AggregateLevel2Params.
                     * @memberof palexy.streaming.v1
                     * @interface IAggregateLevel2Params
                     * @property {number|null} [onTimeInteractionThresholdSeconds] AggregateLevel2Params onTimeInteractionThresholdSeconds
                     * @property {number|null} [onTimeGreetingThresholdSeconds] AggregateLevel2Params onTimeGreetingThresholdSeconds
                     * @property {number|null} [timeToGreetingOutlierThresholdSeconds] AggregateLevel2Params timeToGreetingOutlierThresholdSeconds
                     * @property {number|null} [bounceThresholdSeconds] AggregateLevel2Params bounceThresholdSeconds
                     * @property {Array.<number>|null} [storeVisitAreaIds] AggregateLevel2Params storeVisitAreaIds
                     * @property {number|null} [sectionVisitDurationLowerBoundSeconds] AggregateLevel2Params sectionVisitDurationLowerBoundSeconds
                     * @property {Array.<palexy.streaming.v1.IMetadataType>|null} [metadataTypes] AggregateLevel2Params metadataTypes
                     * @property {boolean|null} [useNetAmount] AggregateLevel2Params useNetAmount
                     * @property {boolean|null} [useSalesTransactionsAsNetSalesTransactions] AggregateLevel2Params useSalesTransactionsAsNetSalesTransactions
                     * @property {palexy.streaming.v1.TransactionCalculationMethod|null} [transactionCalculationMethod] AggregateLevel2Params transactionCalculationMethod
                     * @property {boolean|null} [useSalesItemsAsNetSalesItems] AggregateLevel2Params useSalesItemsAsNetSalesItems
                     * @property {boolean|null} [includeReturningItemsForDiscountAnalysis] AggregateLevel2Params includeReturningItemsForDiscountAnalysis
                     * @property {Array.<string>|null} [excludedTransactionTypes] AggregateLevel2Params excludedTransactionTypes
                     * @property {Array.<palexy.streaming.v1.IStaff>|null} [staff] AggregateLevel2Params staff
                     * @property {palexy.streaming.v1.IForecastPrediction|null} [forecastVisit] AggregateLevel2Params forecastVisit
                     * @property {palexy.streaming.v1.IForecastPrediction|null} [forecastNetSales] AggregateLevel2Params forecastNetSales
                     * @property {palexy.streaming.v1.IForecastPrediction|null} [forecastTransaction] AggregateLevel2Params forecastTransaction
                     * @property {palexy.streaming.v1.IForecastPrediction|null} [forecastNetSalesItems] AggregateLevel2Params forecastNetSalesItems
                     * @property {string|null} [uriPath] AggregateLevel2Params uriPath
                     * @property {Uint8Array|null} [fileData] AggregateLevel2Params fileData
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [posTransactions] AggregateLevel2Params posTransactions
                     * @property {Array.<palexy.streaming.v1.IProductSectionMapping>|null} [productSectionMapping] AggregateLevel2Params productSectionMapping
                     * @property {Array.<palexy.streaming.v1.IParsedStaffAllocation>|null} [staffAllocations] AggregateLevel2Params staffAllocations
                     * @property {Array.<palexy.streaming.v1.IScheduleAreaMapping>|null} [scheduleAreaMappings] AggregateLevel2Params scheduleAreaMappings
                     * @property {number|null} [highConcurrentCheckoutVisitorsThreshold] AggregateLevel2Params highConcurrentCheckoutVisitorsThreshold
                     * @property {number|null} [highConcurrentCheckoutOpportunitiesThreshold] AggregateLevel2Params highConcurrentCheckoutOpportunitiesThreshold
                     * @property {number|null} [queuingTimeComplianceThreshold] AggregateLevel2Params queuingTimeComplianceThreshold
                     * @property {number|null} [transactionTimeComplianceThreshold] AggregateLevel2Params transactionTimeComplianceThreshold
                     * @property {number|null} [orderPreparationTimeComplianceThreshold] AggregateLevel2Params orderPreparationTimeComplianceThreshold
                     * @property {number|null} [totalServiceTimeComplianceThreshold] AggregateLevel2Params totalServiceTimeComplianceThreshold
                     * @property {Object.<string,number>|null} [biasByMetric] AggregateLevel2Params biasByMetric
                     * @property {palexy.streaming.v1.IAdjustedMetricConfig|null} [adjustedMetricConfig] AggregateLevel2Params adjustedMetricConfig
                     */
    
                    /**
                     * Constructs a new AggregateLevel2Params.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AggregateLevel2Params.
                     * @implements IAggregateLevel2Params
                     * @constructor
                     * @param {palexy.streaming.v1.IAggregateLevel2Params=} [properties] Properties to set
                     */
                    function AggregateLevel2Params(properties) {
                        this.storeVisitAreaIds = [];
                        this.metadataTypes = [];
                        this.excludedTransactionTypes = [];
                        this.staff = [];
                        this.posTransactions = [];
                        this.productSectionMapping = [];
                        this.staffAllocations = [];
                        this.scheduleAreaMappings = [];
                        this.biasByMetric = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AggregateLevel2Params onTimeInteractionThresholdSeconds.
                     * @member {number} onTimeInteractionThresholdSeconds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.onTimeInteractionThresholdSeconds = 0;
    
                    /**
                     * AggregateLevel2Params onTimeGreetingThresholdSeconds.
                     * @member {number} onTimeGreetingThresholdSeconds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.onTimeGreetingThresholdSeconds = 0;
    
                    /**
                     * AggregateLevel2Params timeToGreetingOutlierThresholdSeconds.
                     * @member {number} timeToGreetingOutlierThresholdSeconds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.timeToGreetingOutlierThresholdSeconds = 0;
    
                    /**
                     * AggregateLevel2Params bounceThresholdSeconds.
                     * @member {number} bounceThresholdSeconds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.bounceThresholdSeconds = 0;
    
                    /**
                     * AggregateLevel2Params storeVisitAreaIds.
                     * @member {Array.<number>} storeVisitAreaIds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.storeVisitAreaIds = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params sectionVisitDurationLowerBoundSeconds.
                     * @member {number} sectionVisitDurationLowerBoundSeconds
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.sectionVisitDurationLowerBoundSeconds = 0;
    
                    /**
                     * AggregateLevel2Params metadataTypes.
                     * @member {Array.<palexy.streaming.v1.IMetadataType>} metadataTypes
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.metadataTypes = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params useNetAmount.
                     * @member {boolean} useNetAmount
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.useNetAmount = false;
    
                    /**
                     * AggregateLevel2Params useSalesTransactionsAsNetSalesTransactions.
                     * @member {boolean} useSalesTransactionsAsNetSalesTransactions
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.useSalesTransactionsAsNetSalesTransactions = false;
    
                    /**
                     * AggregateLevel2Params transactionCalculationMethod.
                     * @member {palexy.streaming.v1.TransactionCalculationMethod} transactionCalculationMethod
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.transactionCalculationMethod = 0;
    
                    /**
                     * AggregateLevel2Params useSalesItemsAsNetSalesItems.
                     * @member {boolean} useSalesItemsAsNetSalesItems
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.useSalesItemsAsNetSalesItems = false;
    
                    /**
                     * AggregateLevel2Params includeReturningItemsForDiscountAnalysis.
                     * @member {boolean} includeReturningItemsForDiscountAnalysis
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.includeReturningItemsForDiscountAnalysis = false;
    
                    /**
                     * AggregateLevel2Params excludedTransactionTypes.
                     * @member {Array.<string>} excludedTransactionTypes
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.excludedTransactionTypes = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params staff.
                     * @member {Array.<palexy.streaming.v1.IStaff>} staff
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.staff = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params forecastVisit.
                     * @member {palexy.streaming.v1.IForecastPrediction|null|undefined} forecastVisit
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.forecastVisit = null;
    
                    /**
                     * AggregateLevel2Params forecastNetSales.
                     * @member {palexy.streaming.v1.IForecastPrediction|null|undefined} forecastNetSales
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.forecastNetSales = null;
    
                    /**
                     * AggregateLevel2Params forecastTransaction.
                     * @member {palexy.streaming.v1.IForecastPrediction|null|undefined} forecastTransaction
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.forecastTransaction = null;
    
                    /**
                     * AggregateLevel2Params forecastNetSalesItems.
                     * @member {palexy.streaming.v1.IForecastPrediction|null|undefined} forecastNetSalesItems
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.forecastNetSalesItems = null;
    
                    /**
                     * AggregateLevel2Params uriPath.
                     * @member {string|null|undefined} uriPath
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.uriPath = null;
    
                    /**
                     * AggregateLevel2Params fileData.
                     * @member {Uint8Array|null|undefined} fileData
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.fileData = null;
    
                    /**
                     * AggregateLevel2Params posTransactions.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} posTransactions
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.posTransactions = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params productSectionMapping.
                     * @member {Array.<palexy.streaming.v1.IProductSectionMapping>} productSectionMapping
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.productSectionMapping = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params staffAllocations.
                     * @member {Array.<palexy.streaming.v1.IParsedStaffAllocation>} staffAllocations
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.staffAllocations = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params scheduleAreaMappings.
                     * @member {Array.<palexy.streaming.v1.IScheduleAreaMapping>} scheduleAreaMappings
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.scheduleAreaMappings = $util.emptyArray;
    
                    /**
                     * AggregateLevel2Params highConcurrentCheckoutVisitorsThreshold.
                     * @member {number} highConcurrentCheckoutVisitorsThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.highConcurrentCheckoutVisitorsThreshold = 0;
    
                    /**
                     * AggregateLevel2Params highConcurrentCheckoutOpportunitiesThreshold.
                     * @member {number} highConcurrentCheckoutOpportunitiesThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.highConcurrentCheckoutOpportunitiesThreshold = 0;
    
                    /**
                     * AggregateLevel2Params queuingTimeComplianceThreshold.
                     * @member {number} queuingTimeComplianceThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.queuingTimeComplianceThreshold = 0;
    
                    /**
                     * AggregateLevel2Params transactionTimeComplianceThreshold.
                     * @member {number} transactionTimeComplianceThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.transactionTimeComplianceThreshold = 0;
    
                    /**
                     * AggregateLevel2Params orderPreparationTimeComplianceThreshold.
                     * @member {number} orderPreparationTimeComplianceThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.orderPreparationTimeComplianceThreshold = 0;
    
                    /**
                     * AggregateLevel2Params totalServiceTimeComplianceThreshold.
                     * @member {number} totalServiceTimeComplianceThreshold
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.totalServiceTimeComplianceThreshold = 0;
    
                    /**
                     * AggregateLevel2Params biasByMetric.
                     * @member {Object.<string,number>} biasByMetric
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.biasByMetric = $util.emptyObject;
    
                    /**
                     * AggregateLevel2Params adjustedMetricConfig.
                     * @member {palexy.streaming.v1.IAdjustedMetricConfig|null|undefined} adjustedMetricConfig
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    AggregateLevel2Params.prototype.adjustedMetricConfig = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * AggregateLevel2Params aggregatedLevel_1Data.
                     * @member {"uriPath"|"fileData"|undefined} aggregatedLevel_1Data
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     */
                    Object.defineProperty(AggregateLevel2Params.prototype, "aggregatedLevel_1Data", {
                        get: $util.oneOfGetter($oneOfFields = ["uriPath", "fileData"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new AggregateLevel2Params instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {palexy.streaming.v1.IAggregateLevel2Params=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AggregateLevel2Params} AggregateLevel2Params instance
                     */
                    AggregateLevel2Params.create = function create(properties) {
                        return new AggregateLevel2Params(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateLevel2Params message. Does not implicitly {@link palexy.streaming.v1.AggregateLevel2Params.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {palexy.streaming.v1.IAggregateLevel2Params} message AggregateLevel2Params message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateLevel2Params.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.onTimeInteractionThresholdSeconds != null && Object.hasOwnProperty.call(message, "onTimeInteractionThresholdSeconds"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.onTimeInteractionThresholdSeconds);
                        if (message.onTimeGreetingThresholdSeconds != null && Object.hasOwnProperty.call(message, "onTimeGreetingThresholdSeconds"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.onTimeGreetingThresholdSeconds);
                        if (message.timeToGreetingOutlierThresholdSeconds != null && Object.hasOwnProperty.call(message, "timeToGreetingOutlierThresholdSeconds"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.timeToGreetingOutlierThresholdSeconds);
                        if (message.storeVisitAreaIds != null && message.storeVisitAreaIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.storeVisitAreaIds.length; ++i)
                                writer.int64(message.storeVisitAreaIds[i]);
                            writer.ldelim();
                        }
                        if (message.sectionVisitDurationLowerBoundSeconds != null && Object.hasOwnProperty.call(message, "sectionVisitDurationLowerBoundSeconds"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.sectionVisitDurationLowerBoundSeconds);
                        if (message.metadataTypes != null && message.metadataTypes.length)
                            for (var i = 0; i < message.metadataTypes.length; ++i)
                                $root.palexy.streaming.v1.MetadataType.encode(message.metadataTypes[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.useNetAmount != null && Object.hasOwnProperty.call(message, "useNetAmount"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.useNetAmount);
                        if (message.useSalesTransactionsAsNetSalesTransactions != null && Object.hasOwnProperty.call(message, "useSalesTransactionsAsNetSalesTransactions"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.useSalesTransactionsAsNetSalesTransactions);
                        if (message.useSalesItemsAsNetSalesItems != null && Object.hasOwnProperty.call(message, "useSalesItemsAsNetSalesItems"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.useSalesItemsAsNetSalesItems);
                        if (message.staff != null && message.staff.length)
                            for (var i = 0; i < message.staff.length; ++i)
                                $root.palexy.streaming.v1.Staff.encode(message.staff[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.forecastVisit != null && Object.hasOwnProperty.call(message, "forecastVisit"))
                            $root.palexy.streaming.v1.ForecastPrediction.encode(message.forecastVisit, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.forecastNetSales != null && Object.hasOwnProperty.call(message, "forecastNetSales"))
                            $root.palexy.streaming.v1.ForecastPrediction.encode(message.forecastNetSales, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.uriPath != null && Object.hasOwnProperty.call(message, "uriPath"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.uriPath);
                        if (message.fileData != null && Object.hasOwnProperty.call(message, "fileData"))
                            writer.uint32(/* id 14, wireType 2 =*/114).bytes(message.fileData);
                        if (message.posTransactions != null && message.posTransactions.length)
                            for (var i = 0; i < message.posTransactions.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.posTransactions[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.productSectionMapping != null && message.productSectionMapping.length)
                            for (var i = 0; i < message.productSectionMapping.length; ++i)
                                $root.palexy.streaming.v1.ProductSectionMapping.encode(message.productSectionMapping[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.staffAllocations != null && message.staffAllocations.length)
                            for (var i = 0; i < message.staffAllocations.length; ++i)
                                $root.palexy.streaming.v1.ParsedStaffAllocation.encode(message.staffAllocations[i], writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.bounceThresholdSeconds != null && Object.hasOwnProperty.call(message, "bounceThresholdSeconds"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.bounceThresholdSeconds);
                        if (message.includeReturningItemsForDiscountAnalysis != null && Object.hasOwnProperty.call(message, "includeReturningItemsForDiscountAnalysis"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.includeReturningItemsForDiscountAnalysis);
                        if (message.highConcurrentCheckoutVisitorsThreshold != null && Object.hasOwnProperty.call(message, "highConcurrentCheckoutVisitorsThreshold"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.highConcurrentCheckoutVisitorsThreshold);
                        if (message.highConcurrentCheckoutOpportunitiesThreshold != null && Object.hasOwnProperty.call(message, "highConcurrentCheckoutOpportunitiesThreshold"))
                            writer.uint32(/* id 21, wireType 0 =*/168).int32(message.highConcurrentCheckoutOpportunitiesThreshold);
                        if (message.scheduleAreaMappings != null && message.scheduleAreaMappings.length)
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i)
                                $root.palexy.streaming.v1.ScheduleAreaMapping.encode(message.scheduleAreaMappings[i], writer.uint32(/* id 22, wireType 2 =*/178).fork()).ldelim();
                        if (message.transactionCalculationMethod != null && Object.hasOwnProperty.call(message, "transactionCalculationMethod"))
                            writer.uint32(/* id 23, wireType 0 =*/184).int32(message.transactionCalculationMethod);
                        if (message.queuingTimeComplianceThreshold != null && Object.hasOwnProperty.call(message, "queuingTimeComplianceThreshold"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int32(message.queuingTimeComplianceThreshold);
                        if (message.transactionTimeComplianceThreshold != null && Object.hasOwnProperty.call(message, "transactionTimeComplianceThreshold"))
                            writer.uint32(/* id 25, wireType 0 =*/200).int32(message.transactionTimeComplianceThreshold);
                        if (message.orderPreparationTimeComplianceThreshold != null && Object.hasOwnProperty.call(message, "orderPreparationTimeComplianceThreshold"))
                            writer.uint32(/* id 26, wireType 0 =*/208).int32(message.orderPreparationTimeComplianceThreshold);
                        if (message.totalServiceTimeComplianceThreshold != null && Object.hasOwnProperty.call(message, "totalServiceTimeComplianceThreshold"))
                            writer.uint32(/* id 27, wireType 0 =*/216).int32(message.totalServiceTimeComplianceThreshold);
                        if (message.adjustedMetricConfig != null && Object.hasOwnProperty.call(message, "adjustedMetricConfig"))
                            $root.palexy.streaming.v1.AdjustedMetricConfig.encode(message.adjustedMetricConfig, writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                        if (message.excludedTransactionTypes != null && message.excludedTransactionTypes.length)
                            for (var i = 0; i < message.excludedTransactionTypes.length; ++i)
                                writer.uint32(/* id 29, wireType 2 =*/234).string(message.excludedTransactionTypes[i]);
                        if (message.forecastTransaction != null && Object.hasOwnProperty.call(message, "forecastTransaction"))
                            $root.palexy.streaming.v1.ForecastPrediction.encode(message.forecastTransaction, writer.uint32(/* id 30, wireType 2 =*/242).fork()).ldelim();
                        if (message.forecastNetSalesItems != null && Object.hasOwnProperty.call(message, "forecastNetSalesItems"))
                            $root.palexy.streaming.v1.ForecastPrediction.encode(message.forecastNetSalesItems, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                        if (message.biasByMetric != null && Object.hasOwnProperty.call(message, "biasByMetric"))
                            for (var keys = Object.keys(message.biasByMetric), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 32, wireType 2 =*/258).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 1 =*/17).double(message.biasByMetric[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateLevel2Params message, length delimited. Does not implicitly {@link palexy.streaming.v1.AggregateLevel2Params.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {palexy.streaming.v1.IAggregateLevel2Params} message AggregateLevel2Params message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateLevel2Params.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateLevel2Params message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AggregateLevel2Params} AggregateLevel2Params
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateLevel2Params.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AggregateLevel2Params(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.onTimeInteractionThresholdSeconds = reader.int32();
                                break;
                            case 2:
                                message.onTimeGreetingThresholdSeconds = reader.int32();
                                break;
                            case 3:
                                message.timeToGreetingOutlierThresholdSeconds = reader.int32();
                                break;
                            case 18:
                                message.bounceThresholdSeconds = reader.int32();
                                break;
                            case 4:
                                if (!(message.storeVisitAreaIds && message.storeVisitAreaIds.length))
                                    message.storeVisitAreaIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeVisitAreaIds.push(reader.int64());
                                } else
                                    message.storeVisitAreaIds.push(reader.int64());
                                break;
                            case 5:
                                message.sectionVisitDurationLowerBoundSeconds = reader.int32();
                                break;
                            case 6:
                                if (!(message.metadataTypes && message.metadataTypes.length))
                                    message.metadataTypes = [];
                                message.metadataTypes.push($root.palexy.streaming.v1.MetadataType.decode(reader, reader.uint32()));
                                break;
                            case 7:
                                message.useNetAmount = reader.bool();
                                break;
                            case 8:
                                message.useSalesTransactionsAsNetSalesTransactions = reader.bool();
                                break;
                            case 23:
                                message.transactionCalculationMethod = reader.int32();
                                break;
                            case 9:
                                message.useSalesItemsAsNetSalesItems = reader.bool();
                                break;
                            case 19:
                                message.includeReturningItemsForDiscountAnalysis = reader.bool();
                                break;
                            case 29:
                                if (!(message.excludedTransactionTypes && message.excludedTransactionTypes.length))
                                    message.excludedTransactionTypes = [];
                                message.excludedTransactionTypes.push(reader.string());
                                break;
                            case 10:
                                if (!(message.staff && message.staff.length))
                                    message.staff = [];
                                message.staff.push($root.palexy.streaming.v1.Staff.decode(reader, reader.uint32()));
                                break;
                            case 11:
                                message.forecastVisit = $root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.forecastNetSales = $root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32());
                                break;
                            case 30:
                                message.forecastTransaction = $root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32());
                                break;
                            case 31:
                                message.forecastNetSalesItems = $root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.uriPath = reader.string();
                                break;
                            case 14:
                                message.fileData = reader.bytes();
                                break;
                            case 15:
                                if (!(message.posTransactions && message.posTransactions.length))
                                    message.posTransactions = [];
                                message.posTransactions.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            case 16:
                                if (!(message.productSectionMapping && message.productSectionMapping.length))
                                    message.productSectionMapping = [];
                                message.productSectionMapping.push($root.palexy.streaming.v1.ProductSectionMapping.decode(reader, reader.uint32()));
                                break;
                            case 17:
                                if (!(message.staffAllocations && message.staffAllocations.length))
                                    message.staffAllocations = [];
                                message.staffAllocations.push($root.palexy.streaming.v1.ParsedStaffAllocation.decode(reader, reader.uint32()));
                                break;
                            case 22:
                                if (!(message.scheduleAreaMappings && message.scheduleAreaMappings.length))
                                    message.scheduleAreaMappings = [];
                                message.scheduleAreaMappings.push($root.palexy.streaming.v1.ScheduleAreaMapping.decode(reader, reader.uint32()));
                                break;
                            case 20:
                                message.highConcurrentCheckoutVisitorsThreshold = reader.int32();
                                break;
                            case 21:
                                message.highConcurrentCheckoutOpportunitiesThreshold = reader.int32();
                                break;
                            case 24:
                                message.queuingTimeComplianceThreshold = reader.int32();
                                break;
                            case 25:
                                message.transactionTimeComplianceThreshold = reader.int32();
                                break;
                            case 26:
                                message.orderPreparationTimeComplianceThreshold = reader.int32();
                                break;
                            case 27:
                                message.totalServiceTimeComplianceThreshold = reader.int32();
                                break;
                            case 32:
                                if (message.biasByMetric === $util.emptyObject)
                                    message.biasByMetric = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = 0;
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.double();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.biasByMetric[key] = value;
                                break;
                            case 28:
                                message.adjustedMetricConfig = $root.palexy.streaming.v1.AdjustedMetricConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateLevel2Params message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AggregateLevel2Params} AggregateLevel2Params
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateLevel2Params.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateLevel2Params message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateLevel2Params.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.onTimeInteractionThresholdSeconds != null && message.hasOwnProperty("onTimeInteractionThresholdSeconds"))
                            if (!$util.isInteger(message.onTimeInteractionThresholdSeconds))
                                return "onTimeInteractionThresholdSeconds: integer expected";
                        if (message.onTimeGreetingThresholdSeconds != null && message.hasOwnProperty("onTimeGreetingThresholdSeconds"))
                            if (!$util.isInteger(message.onTimeGreetingThresholdSeconds))
                                return "onTimeGreetingThresholdSeconds: integer expected";
                        if (message.timeToGreetingOutlierThresholdSeconds != null && message.hasOwnProperty("timeToGreetingOutlierThresholdSeconds"))
                            if (!$util.isInteger(message.timeToGreetingOutlierThresholdSeconds))
                                return "timeToGreetingOutlierThresholdSeconds: integer expected";
                        if (message.bounceThresholdSeconds != null && message.hasOwnProperty("bounceThresholdSeconds"))
                            if (!$util.isInteger(message.bounceThresholdSeconds))
                                return "bounceThresholdSeconds: integer expected";
                        if (message.storeVisitAreaIds != null && message.hasOwnProperty("storeVisitAreaIds")) {
                            if (!Array.isArray(message.storeVisitAreaIds))
                                return "storeVisitAreaIds: array expected";
                            for (var i = 0; i < message.storeVisitAreaIds.length; ++i)
                                if (!$util.isInteger(message.storeVisitAreaIds[i]) && !(message.storeVisitAreaIds[i] && $util.isInteger(message.storeVisitAreaIds[i].low) && $util.isInteger(message.storeVisitAreaIds[i].high)))
                                    return "storeVisitAreaIds: integer|Long[] expected";
                        }
                        if (message.sectionVisitDurationLowerBoundSeconds != null && message.hasOwnProperty("sectionVisitDurationLowerBoundSeconds"))
                            if (!$util.isInteger(message.sectionVisitDurationLowerBoundSeconds))
                                return "sectionVisitDurationLowerBoundSeconds: integer expected";
                        if (message.metadataTypes != null && message.hasOwnProperty("metadataTypes")) {
                            if (!Array.isArray(message.metadataTypes))
                                return "metadataTypes: array expected";
                            for (var i = 0; i < message.metadataTypes.length; ++i) {
                                var error = $root.palexy.streaming.v1.MetadataType.verify(message.metadataTypes[i]);
                                if (error)
                                    return "metadataTypes." + error;
                            }
                        }
                        if (message.useNetAmount != null && message.hasOwnProperty("useNetAmount"))
                            if (typeof message.useNetAmount !== "boolean")
                                return "useNetAmount: boolean expected";
                        if (message.useSalesTransactionsAsNetSalesTransactions != null && message.hasOwnProperty("useSalesTransactionsAsNetSalesTransactions"))
                            if (typeof message.useSalesTransactionsAsNetSalesTransactions !== "boolean")
                                return "useSalesTransactionsAsNetSalesTransactions: boolean expected";
                        if (message.transactionCalculationMethod != null && message.hasOwnProperty("transactionCalculationMethod"))
                            switch (message.transactionCalculationMethod) {
                            default:
                                return "transactionCalculationMethod: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.useSalesItemsAsNetSalesItems != null && message.hasOwnProperty("useSalesItemsAsNetSalesItems"))
                            if (typeof message.useSalesItemsAsNetSalesItems !== "boolean")
                                return "useSalesItemsAsNetSalesItems: boolean expected";
                        if (message.includeReturningItemsForDiscountAnalysis != null && message.hasOwnProperty("includeReturningItemsForDiscountAnalysis"))
                            if (typeof message.includeReturningItemsForDiscountAnalysis !== "boolean")
                                return "includeReturningItemsForDiscountAnalysis: boolean expected";
                        if (message.excludedTransactionTypes != null && message.hasOwnProperty("excludedTransactionTypes")) {
                            if (!Array.isArray(message.excludedTransactionTypes))
                                return "excludedTransactionTypes: array expected";
                            for (var i = 0; i < message.excludedTransactionTypes.length; ++i)
                                if (!$util.isString(message.excludedTransactionTypes[i]))
                                    return "excludedTransactionTypes: string[] expected";
                        }
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            if (!Array.isArray(message.staff))
                                return "staff: array expected";
                            for (var i = 0; i < message.staff.length; ++i) {
                                var error = $root.palexy.streaming.v1.Staff.verify(message.staff[i]);
                                if (error)
                                    return "staff." + error;
                            }
                        }
                        if (message.forecastVisit != null && message.hasOwnProperty("forecastVisit")) {
                            var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.forecastVisit);
                            if (error)
                                return "forecastVisit." + error;
                        }
                        if (message.forecastNetSales != null && message.hasOwnProperty("forecastNetSales")) {
                            var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.forecastNetSales);
                            if (error)
                                return "forecastNetSales." + error;
                        }
                        if (message.forecastTransaction != null && message.hasOwnProperty("forecastTransaction")) {
                            var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.forecastTransaction);
                            if (error)
                                return "forecastTransaction." + error;
                        }
                        if (message.forecastNetSalesItems != null && message.hasOwnProperty("forecastNetSalesItems")) {
                            var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.forecastNetSalesItems);
                            if (error)
                                return "forecastNetSalesItems." + error;
                        }
                        if (message.uriPath != null && message.hasOwnProperty("uriPath")) {
                            properties.aggregatedLevel_1Data = 1;
                            if (!$util.isString(message.uriPath))
                                return "uriPath: string expected";
                        }
                        if (message.fileData != null && message.hasOwnProperty("fileData")) {
                            if (properties.aggregatedLevel_1Data === 1)
                                return "aggregatedLevel_1Data: multiple values";
                            properties.aggregatedLevel_1Data = 1;
                            if (!(message.fileData && typeof message.fileData.length === "number" || $util.isString(message.fileData)))
                                return "fileData: buffer expected";
                        }
                        if (message.posTransactions != null && message.hasOwnProperty("posTransactions")) {
                            if (!Array.isArray(message.posTransactions))
                                return "posTransactions: array expected";
                            for (var i = 0; i < message.posTransactions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.posTransactions[i]);
                                if (error)
                                    return "posTransactions." + error;
                            }
                        }
                        if (message.productSectionMapping != null && message.hasOwnProperty("productSectionMapping")) {
                            if (!Array.isArray(message.productSectionMapping))
                                return "productSectionMapping: array expected";
                            for (var i = 0; i < message.productSectionMapping.length; ++i) {
                                var error = $root.palexy.streaming.v1.ProductSectionMapping.verify(message.productSectionMapping[i]);
                                if (error)
                                    return "productSectionMapping." + error;
                            }
                        }
                        if (message.staffAllocations != null && message.hasOwnProperty("staffAllocations")) {
                            if (!Array.isArray(message.staffAllocations))
                                return "staffAllocations: array expected";
                            for (var i = 0; i < message.staffAllocations.length; ++i) {
                                var error = $root.palexy.streaming.v1.ParsedStaffAllocation.verify(message.staffAllocations[i]);
                                if (error)
                                    return "staffAllocations." + error;
                            }
                        }
                        if (message.scheduleAreaMappings != null && message.hasOwnProperty("scheduleAreaMappings")) {
                            if (!Array.isArray(message.scheduleAreaMappings))
                                return "scheduleAreaMappings: array expected";
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduleAreaMapping.verify(message.scheduleAreaMappings[i]);
                                if (error)
                                    return "scheduleAreaMappings." + error;
                            }
                        }
                        if (message.highConcurrentCheckoutVisitorsThreshold != null && message.hasOwnProperty("highConcurrentCheckoutVisitorsThreshold"))
                            if (!$util.isInteger(message.highConcurrentCheckoutVisitorsThreshold))
                                return "highConcurrentCheckoutVisitorsThreshold: integer expected";
                        if (message.highConcurrentCheckoutOpportunitiesThreshold != null && message.hasOwnProperty("highConcurrentCheckoutOpportunitiesThreshold"))
                            if (!$util.isInteger(message.highConcurrentCheckoutOpportunitiesThreshold))
                                return "highConcurrentCheckoutOpportunitiesThreshold: integer expected";
                        if (message.queuingTimeComplianceThreshold != null && message.hasOwnProperty("queuingTimeComplianceThreshold"))
                            if (!$util.isInteger(message.queuingTimeComplianceThreshold))
                                return "queuingTimeComplianceThreshold: integer expected";
                        if (message.transactionTimeComplianceThreshold != null && message.hasOwnProperty("transactionTimeComplianceThreshold"))
                            if (!$util.isInteger(message.transactionTimeComplianceThreshold))
                                return "transactionTimeComplianceThreshold: integer expected";
                        if (message.orderPreparationTimeComplianceThreshold != null && message.hasOwnProperty("orderPreparationTimeComplianceThreshold"))
                            if (!$util.isInteger(message.orderPreparationTimeComplianceThreshold))
                                return "orderPreparationTimeComplianceThreshold: integer expected";
                        if (message.totalServiceTimeComplianceThreshold != null && message.hasOwnProperty("totalServiceTimeComplianceThreshold"))
                            if (!$util.isInteger(message.totalServiceTimeComplianceThreshold))
                                return "totalServiceTimeComplianceThreshold: integer expected";
                        if (message.biasByMetric != null && message.hasOwnProperty("biasByMetric")) {
                            if (!$util.isObject(message.biasByMetric))
                                return "biasByMetric: object expected";
                            var key = Object.keys(message.biasByMetric);
                            for (var i = 0; i < key.length; ++i)
                                if (typeof message.biasByMetric[key[i]] !== "number")
                                    return "biasByMetric: number{k:string} expected";
                        }
                        if (message.adjustedMetricConfig != null && message.hasOwnProperty("adjustedMetricConfig")) {
                            var error = $root.palexy.streaming.v1.AdjustedMetricConfig.verify(message.adjustedMetricConfig);
                            if (error)
                                return "adjustedMetricConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AggregateLevel2Params message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AggregateLevel2Params} AggregateLevel2Params
                     */
                    AggregateLevel2Params.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AggregateLevel2Params)
                            return object;
                        var message = new $root.palexy.streaming.v1.AggregateLevel2Params();
                        if (object.onTimeInteractionThresholdSeconds != null)
                            message.onTimeInteractionThresholdSeconds = object.onTimeInteractionThresholdSeconds | 0;
                        if (object.onTimeGreetingThresholdSeconds != null)
                            message.onTimeGreetingThresholdSeconds = object.onTimeGreetingThresholdSeconds | 0;
                        if (object.timeToGreetingOutlierThresholdSeconds != null)
                            message.timeToGreetingOutlierThresholdSeconds = object.timeToGreetingOutlierThresholdSeconds | 0;
                        if (object.bounceThresholdSeconds != null)
                            message.bounceThresholdSeconds = object.bounceThresholdSeconds | 0;
                        if (object.storeVisitAreaIds) {
                            if (!Array.isArray(object.storeVisitAreaIds))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.storeVisitAreaIds: array expected");
                            message.storeVisitAreaIds = [];
                            for (var i = 0; i < object.storeVisitAreaIds.length; ++i)
                                if ($util.Long)
                                    (message.storeVisitAreaIds[i] = $util.Long.fromValue(object.storeVisitAreaIds[i])).unsigned = false;
                                else if (typeof object.storeVisitAreaIds[i] === "string")
                                    message.storeVisitAreaIds[i] = parseInt(object.storeVisitAreaIds[i], 10);
                                else if (typeof object.storeVisitAreaIds[i] === "number")
                                    message.storeVisitAreaIds[i] = object.storeVisitAreaIds[i];
                                else if (typeof object.storeVisitAreaIds[i] === "object")
                                    message.storeVisitAreaIds[i] = new $util.LongBits(object.storeVisitAreaIds[i].low >>> 0, object.storeVisitAreaIds[i].high >>> 0).toNumber();
                        }
                        if (object.sectionVisitDurationLowerBoundSeconds != null)
                            message.sectionVisitDurationLowerBoundSeconds = object.sectionVisitDurationLowerBoundSeconds | 0;
                        if (object.metadataTypes) {
                            if (!Array.isArray(object.metadataTypes))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.metadataTypes: array expected");
                            message.metadataTypes = [];
                            for (var i = 0; i < object.metadataTypes.length; ++i) {
                                if (typeof object.metadataTypes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.metadataTypes: object expected");
                                message.metadataTypes[i] = $root.palexy.streaming.v1.MetadataType.fromObject(object.metadataTypes[i]);
                            }
                        }
                        if (object.useNetAmount != null)
                            message.useNetAmount = Boolean(object.useNetAmount);
                        if (object.useSalesTransactionsAsNetSalesTransactions != null)
                            message.useSalesTransactionsAsNetSalesTransactions = Boolean(object.useSalesTransactionsAsNetSalesTransactions);
                        switch (object.transactionCalculationMethod) {
                        case "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED":
                        case 0:
                            message.transactionCalculationMethod = 0;
                            break;
                        case "ALL_TRANSACTIONS":
                        case 1:
                            message.transactionCalculationMethod = 1;
                            break;
                        case "SALE_ONLY":
                        case 2:
                            message.transactionCalculationMethod = 2;
                            break;
                        case "SALE_MINUS_RETURN":
                        case 3:
                            message.transactionCalculationMethod = 3;
                            break;
                        }
                        if (object.useSalesItemsAsNetSalesItems != null)
                            message.useSalesItemsAsNetSalesItems = Boolean(object.useSalesItemsAsNetSalesItems);
                        if (object.includeReturningItemsForDiscountAnalysis != null)
                            message.includeReturningItemsForDiscountAnalysis = Boolean(object.includeReturningItemsForDiscountAnalysis);
                        if (object.excludedTransactionTypes) {
                            if (!Array.isArray(object.excludedTransactionTypes))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.excludedTransactionTypes: array expected");
                            message.excludedTransactionTypes = [];
                            for (var i = 0; i < object.excludedTransactionTypes.length; ++i)
                                message.excludedTransactionTypes[i] = String(object.excludedTransactionTypes[i]);
                        }
                        if (object.staff) {
                            if (!Array.isArray(object.staff))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.staff: array expected");
                            message.staff = [];
                            for (var i = 0; i < object.staff.length; ++i) {
                                if (typeof object.staff[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.staff: object expected");
                                message.staff[i] = $root.palexy.streaming.v1.Staff.fromObject(object.staff[i]);
                            }
                        }
                        if (object.forecastVisit != null) {
                            if (typeof object.forecastVisit !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.forecastVisit: object expected");
                            message.forecastVisit = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.forecastVisit);
                        }
                        if (object.forecastNetSales != null) {
                            if (typeof object.forecastNetSales !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.forecastNetSales: object expected");
                            message.forecastNetSales = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.forecastNetSales);
                        }
                        if (object.forecastTransaction != null) {
                            if (typeof object.forecastTransaction !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.forecastTransaction: object expected");
                            message.forecastTransaction = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.forecastTransaction);
                        }
                        if (object.forecastNetSalesItems != null) {
                            if (typeof object.forecastNetSalesItems !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.forecastNetSalesItems: object expected");
                            message.forecastNetSalesItems = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.forecastNetSalesItems);
                        }
                        if (object.uriPath != null)
                            message.uriPath = String(object.uriPath);
                        if (object.fileData != null)
                            if (typeof object.fileData === "string")
                                $util.base64.decode(object.fileData, message.fileData = $util.newBuffer($util.base64.length(object.fileData)), 0);
                            else if (object.fileData.length)
                                message.fileData = object.fileData;
                        if (object.posTransactions) {
                            if (!Array.isArray(object.posTransactions))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.posTransactions: array expected");
                            message.posTransactions = [];
                            for (var i = 0; i < object.posTransactions.length; ++i) {
                                if (typeof object.posTransactions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.posTransactions: object expected");
                                message.posTransactions[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.posTransactions[i]);
                            }
                        }
                        if (object.productSectionMapping) {
                            if (!Array.isArray(object.productSectionMapping))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.productSectionMapping: array expected");
                            message.productSectionMapping = [];
                            for (var i = 0; i < object.productSectionMapping.length; ++i) {
                                if (typeof object.productSectionMapping[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.productSectionMapping: object expected");
                                message.productSectionMapping[i] = $root.palexy.streaming.v1.ProductSectionMapping.fromObject(object.productSectionMapping[i]);
                            }
                        }
                        if (object.staffAllocations) {
                            if (!Array.isArray(object.staffAllocations))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.staffAllocations: array expected");
                            message.staffAllocations = [];
                            for (var i = 0; i < object.staffAllocations.length; ++i) {
                                if (typeof object.staffAllocations[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.staffAllocations: object expected");
                                message.staffAllocations[i] = $root.palexy.streaming.v1.ParsedStaffAllocation.fromObject(object.staffAllocations[i]);
                            }
                        }
                        if (object.scheduleAreaMappings) {
                            if (!Array.isArray(object.scheduleAreaMappings))
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.scheduleAreaMappings: array expected");
                            message.scheduleAreaMappings = [];
                            for (var i = 0; i < object.scheduleAreaMappings.length; ++i) {
                                if (typeof object.scheduleAreaMappings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.scheduleAreaMappings: object expected");
                                message.scheduleAreaMappings[i] = $root.palexy.streaming.v1.ScheduleAreaMapping.fromObject(object.scheduleAreaMappings[i]);
                            }
                        }
                        if (object.highConcurrentCheckoutVisitorsThreshold != null)
                            message.highConcurrentCheckoutVisitorsThreshold = object.highConcurrentCheckoutVisitorsThreshold | 0;
                        if (object.highConcurrentCheckoutOpportunitiesThreshold != null)
                            message.highConcurrentCheckoutOpportunitiesThreshold = object.highConcurrentCheckoutOpportunitiesThreshold | 0;
                        if (object.queuingTimeComplianceThreshold != null)
                            message.queuingTimeComplianceThreshold = object.queuingTimeComplianceThreshold | 0;
                        if (object.transactionTimeComplianceThreshold != null)
                            message.transactionTimeComplianceThreshold = object.transactionTimeComplianceThreshold | 0;
                        if (object.orderPreparationTimeComplianceThreshold != null)
                            message.orderPreparationTimeComplianceThreshold = object.orderPreparationTimeComplianceThreshold | 0;
                        if (object.totalServiceTimeComplianceThreshold != null)
                            message.totalServiceTimeComplianceThreshold = object.totalServiceTimeComplianceThreshold | 0;
                        if (object.biasByMetric) {
                            if (typeof object.biasByMetric !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.biasByMetric: object expected");
                            message.biasByMetric = {};
                            for (var keys = Object.keys(object.biasByMetric), i = 0; i < keys.length; ++i)
                                message.biasByMetric[keys[i]] = Number(object.biasByMetric[keys[i]]);
                        }
                        if (object.adjustedMetricConfig != null) {
                            if (typeof object.adjustedMetricConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.AggregateLevel2Params.adjustedMetricConfig: object expected");
                            message.adjustedMetricConfig = $root.palexy.streaming.v1.AdjustedMetricConfig.fromObject(object.adjustedMetricConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AggregateLevel2Params message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @static
                     * @param {palexy.streaming.v1.AggregateLevel2Params} message AggregateLevel2Params
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateLevel2Params.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeVisitAreaIds = [];
                            object.metadataTypes = [];
                            object.staff = [];
                            object.posTransactions = [];
                            object.productSectionMapping = [];
                            object.staffAllocations = [];
                            object.scheduleAreaMappings = [];
                            object.excludedTransactionTypes = [];
                        }
                        if (options.objects || options.defaults)
                            object.biasByMetric = {};
                        if (options.defaults) {
                            object.onTimeInteractionThresholdSeconds = 0;
                            object.onTimeGreetingThresholdSeconds = 0;
                            object.timeToGreetingOutlierThresholdSeconds = 0;
                            object.sectionVisitDurationLowerBoundSeconds = 0;
                            object.useNetAmount = false;
                            object.useSalesTransactionsAsNetSalesTransactions = false;
                            object.useSalesItemsAsNetSalesItems = false;
                            object.forecastVisit = null;
                            object.forecastNetSales = null;
                            object.bounceThresholdSeconds = 0;
                            object.includeReturningItemsForDiscountAnalysis = false;
                            object.highConcurrentCheckoutVisitorsThreshold = 0;
                            object.highConcurrentCheckoutOpportunitiesThreshold = 0;
                            object.transactionCalculationMethod = options.enums === String ? "TRANSACTION_CALCULATION_METHOD_UNSPECIFIED" : 0;
                            object.queuingTimeComplianceThreshold = 0;
                            object.transactionTimeComplianceThreshold = 0;
                            object.orderPreparationTimeComplianceThreshold = 0;
                            object.totalServiceTimeComplianceThreshold = 0;
                            object.adjustedMetricConfig = null;
                            object.forecastTransaction = null;
                            object.forecastNetSalesItems = null;
                        }
                        if (message.onTimeInteractionThresholdSeconds != null && message.hasOwnProperty("onTimeInteractionThresholdSeconds"))
                            object.onTimeInteractionThresholdSeconds = message.onTimeInteractionThresholdSeconds;
                        if (message.onTimeGreetingThresholdSeconds != null && message.hasOwnProperty("onTimeGreetingThresholdSeconds"))
                            object.onTimeGreetingThresholdSeconds = message.onTimeGreetingThresholdSeconds;
                        if (message.timeToGreetingOutlierThresholdSeconds != null && message.hasOwnProperty("timeToGreetingOutlierThresholdSeconds"))
                            object.timeToGreetingOutlierThresholdSeconds = message.timeToGreetingOutlierThresholdSeconds;
                        if (message.storeVisitAreaIds && message.storeVisitAreaIds.length) {
                            object.storeVisitAreaIds = [];
                            for (var j = 0; j < message.storeVisitAreaIds.length; ++j)
                                if (typeof message.storeVisitAreaIds[j] === "number")
                                    object.storeVisitAreaIds[j] = options.longs === String ? String(message.storeVisitAreaIds[j]) : message.storeVisitAreaIds[j];
                                else
                                    object.storeVisitAreaIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeVisitAreaIds[j]) : options.longs === Number ? new $util.LongBits(message.storeVisitAreaIds[j].low >>> 0, message.storeVisitAreaIds[j].high >>> 0).toNumber() : message.storeVisitAreaIds[j];
                        }
                        if (message.sectionVisitDurationLowerBoundSeconds != null && message.hasOwnProperty("sectionVisitDurationLowerBoundSeconds"))
                            object.sectionVisitDurationLowerBoundSeconds = message.sectionVisitDurationLowerBoundSeconds;
                        if (message.metadataTypes && message.metadataTypes.length) {
                            object.metadataTypes = [];
                            for (var j = 0; j < message.metadataTypes.length; ++j)
                                object.metadataTypes[j] = $root.palexy.streaming.v1.MetadataType.toObject(message.metadataTypes[j], options);
                        }
                        if (message.useNetAmount != null && message.hasOwnProperty("useNetAmount"))
                            object.useNetAmount = message.useNetAmount;
                        if (message.useSalesTransactionsAsNetSalesTransactions != null && message.hasOwnProperty("useSalesTransactionsAsNetSalesTransactions"))
                            object.useSalesTransactionsAsNetSalesTransactions = message.useSalesTransactionsAsNetSalesTransactions;
                        if (message.useSalesItemsAsNetSalesItems != null && message.hasOwnProperty("useSalesItemsAsNetSalesItems"))
                            object.useSalesItemsAsNetSalesItems = message.useSalesItemsAsNetSalesItems;
                        if (message.staff && message.staff.length) {
                            object.staff = [];
                            for (var j = 0; j < message.staff.length; ++j)
                                object.staff[j] = $root.palexy.streaming.v1.Staff.toObject(message.staff[j], options);
                        }
                        if (message.forecastVisit != null && message.hasOwnProperty("forecastVisit"))
                            object.forecastVisit = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.forecastVisit, options);
                        if (message.forecastNetSales != null && message.hasOwnProperty("forecastNetSales"))
                            object.forecastNetSales = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.forecastNetSales, options);
                        if (message.uriPath != null && message.hasOwnProperty("uriPath")) {
                            object.uriPath = message.uriPath;
                            if (options.oneofs)
                                object.aggregatedLevel_1Data = "uriPath";
                        }
                        if (message.fileData != null && message.hasOwnProperty("fileData")) {
                            object.fileData = options.bytes === String ? $util.base64.encode(message.fileData, 0, message.fileData.length) : options.bytes === Array ? Array.prototype.slice.call(message.fileData) : message.fileData;
                            if (options.oneofs)
                                object.aggregatedLevel_1Data = "fileData";
                        }
                        if (message.posTransactions && message.posTransactions.length) {
                            object.posTransactions = [];
                            for (var j = 0; j < message.posTransactions.length; ++j)
                                object.posTransactions[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.posTransactions[j], options);
                        }
                        if (message.productSectionMapping && message.productSectionMapping.length) {
                            object.productSectionMapping = [];
                            for (var j = 0; j < message.productSectionMapping.length; ++j)
                                object.productSectionMapping[j] = $root.palexy.streaming.v1.ProductSectionMapping.toObject(message.productSectionMapping[j], options);
                        }
                        if (message.staffAllocations && message.staffAllocations.length) {
                            object.staffAllocations = [];
                            for (var j = 0; j < message.staffAllocations.length; ++j)
                                object.staffAllocations[j] = $root.palexy.streaming.v1.ParsedStaffAllocation.toObject(message.staffAllocations[j], options);
                        }
                        if (message.bounceThresholdSeconds != null && message.hasOwnProperty("bounceThresholdSeconds"))
                            object.bounceThresholdSeconds = message.bounceThresholdSeconds;
                        if (message.includeReturningItemsForDiscountAnalysis != null && message.hasOwnProperty("includeReturningItemsForDiscountAnalysis"))
                            object.includeReturningItemsForDiscountAnalysis = message.includeReturningItemsForDiscountAnalysis;
                        if (message.highConcurrentCheckoutVisitorsThreshold != null && message.hasOwnProperty("highConcurrentCheckoutVisitorsThreshold"))
                            object.highConcurrentCheckoutVisitorsThreshold = message.highConcurrentCheckoutVisitorsThreshold;
                        if (message.highConcurrentCheckoutOpportunitiesThreshold != null && message.hasOwnProperty("highConcurrentCheckoutOpportunitiesThreshold"))
                            object.highConcurrentCheckoutOpportunitiesThreshold = message.highConcurrentCheckoutOpportunitiesThreshold;
                        if (message.scheduleAreaMappings && message.scheduleAreaMappings.length) {
                            object.scheduleAreaMappings = [];
                            for (var j = 0; j < message.scheduleAreaMappings.length; ++j)
                                object.scheduleAreaMappings[j] = $root.palexy.streaming.v1.ScheduleAreaMapping.toObject(message.scheduleAreaMappings[j], options);
                        }
                        if (message.transactionCalculationMethod != null && message.hasOwnProperty("transactionCalculationMethod"))
                            object.transactionCalculationMethod = options.enums === String ? $root.palexy.streaming.v1.TransactionCalculationMethod[message.transactionCalculationMethod] : message.transactionCalculationMethod;
                        if (message.queuingTimeComplianceThreshold != null && message.hasOwnProperty("queuingTimeComplianceThreshold"))
                            object.queuingTimeComplianceThreshold = message.queuingTimeComplianceThreshold;
                        if (message.transactionTimeComplianceThreshold != null && message.hasOwnProperty("transactionTimeComplianceThreshold"))
                            object.transactionTimeComplianceThreshold = message.transactionTimeComplianceThreshold;
                        if (message.orderPreparationTimeComplianceThreshold != null && message.hasOwnProperty("orderPreparationTimeComplianceThreshold"))
                            object.orderPreparationTimeComplianceThreshold = message.orderPreparationTimeComplianceThreshold;
                        if (message.totalServiceTimeComplianceThreshold != null && message.hasOwnProperty("totalServiceTimeComplianceThreshold"))
                            object.totalServiceTimeComplianceThreshold = message.totalServiceTimeComplianceThreshold;
                        if (message.adjustedMetricConfig != null && message.hasOwnProperty("adjustedMetricConfig"))
                            object.adjustedMetricConfig = $root.palexy.streaming.v1.AdjustedMetricConfig.toObject(message.adjustedMetricConfig, options);
                        if (message.excludedTransactionTypes && message.excludedTransactionTypes.length) {
                            object.excludedTransactionTypes = [];
                            for (var j = 0; j < message.excludedTransactionTypes.length; ++j)
                                object.excludedTransactionTypes[j] = message.excludedTransactionTypes[j];
                        }
                        if (message.forecastTransaction != null && message.hasOwnProperty("forecastTransaction"))
                            object.forecastTransaction = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.forecastTransaction, options);
                        if (message.forecastNetSalesItems != null && message.hasOwnProperty("forecastNetSalesItems"))
                            object.forecastNetSalesItems = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.forecastNetSalesItems, options);
                        var keys2;
                        if (message.biasByMetric && (keys2 = Object.keys(message.biasByMetric)).length) {
                            object.biasByMetric = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.biasByMetric[keys2[j]] = options.json && !isFinite(message.biasByMetric[keys2[j]]) ? String(message.biasByMetric[keys2[j]]) : message.biasByMetric[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AggregateLevel2Params to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AggregateLevel2Params
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateLevel2Params.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateLevel2Params;
                })();
    
                v1.CustomerJourneyService = (function() {
    
                    /**
                     * Constructs a new CustomerJourneyService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerJourneyService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CustomerJourneyService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CustomerJourneyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CustomerJourneyService;
    
                    /**
                     * Creates new CustomerJourneyService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerJourneyService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CustomerJourneyService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CustomerJourneyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.CustomerJourneyService#listCustomerJourney}.
                     * @memberof palexy.streaming.v1.CustomerJourneyService
                     * @typedef listCustomerJourneyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCustomerJourneyResponse} [response] ListCustomerJourneyResponse
                     */
    
                    /**
                     * Calls listCustomerJourney.
                     * @function listCustomerJourney
                     * @memberof palexy.streaming.v1.CustomerJourneyService
                     * @instance
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest} request ListCustomerJourneyRequest message or plain object
                     * @param {palexy.streaming.v1.CustomerJourneyService.listCustomerJourneyCallback} callback Node-style callback called with the error, if any, and ListCustomerJourneyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CustomerJourneyService.prototype.listCustomerJourney = function listCustomerJourney(request, callback) {
                        return this.rpcCall(listCustomerJourney, $root.palexy.streaming.v1.ListCustomerJourneyRequest, $root.palexy.streaming.v1.ListCustomerJourneyResponse, request, callback);
                    }, "name", { value: "listCustomerJourney" });
    
                    /**
                     * Calls listCustomerJourney.
                     * @function listCustomerJourney
                     * @memberof palexy.streaming.v1.CustomerJourneyService
                     * @instance
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest} request ListCustomerJourneyRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCustomerJourneyResponse>} Promise
                     * @variation 2
                     */
    
                    return CustomerJourneyService;
                })();
    
                v1.ListCustomerJourneyRequest = (function() {
    
                    /**
                     * Properties of a ListCustomerJourneyRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCustomerJourneyRequest
                     * @property {number|null} [storeId] ListCustomerJourneyRequest storeId
                     * @property {string|null} [startDateId] ListCustomerJourneyRequest startDateId
                     * @property {string|null} [endDateId] ListCustomerJourneyRequest endDateId
                     * @property {number|null} [metadataTypeId] ListCustomerJourneyRequest metadataTypeId
                     * @property {google.protobuf.IBoolValue|null} [isBuyer] ListCustomerJourneyRequest isBuyer
                     */
    
                    /**
                     * Constructs a new ListCustomerJourneyRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCustomerJourneyRequest.
                     * @implements IListCustomerJourneyRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest=} [properties] Properties to set
                     */
                    function ListCustomerJourneyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCustomerJourneyRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     */
                    ListCustomerJourneyRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListCustomerJourneyRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     */
                    ListCustomerJourneyRequest.prototype.startDateId = "";
    
                    /**
                     * ListCustomerJourneyRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     */
                    ListCustomerJourneyRequest.prototype.endDateId = "";
    
                    /**
                     * ListCustomerJourneyRequest metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     */
                    ListCustomerJourneyRequest.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListCustomerJourneyRequest isBuyer.
                     * @member {google.protobuf.IBoolValue|null|undefined} isBuyer
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     */
                    ListCustomerJourneyRequest.prototype.isBuyer = null;
    
                    /**
                     * Creates a new ListCustomerJourneyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCustomerJourneyRequest} ListCustomerJourneyRequest instance
                     */
                    ListCustomerJourneyRequest.create = function create(properties) {
                        return new ListCustomerJourneyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCustomerJourneyRequest message. Does not implicitly {@link palexy.streaming.v1.ListCustomerJourneyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest} message ListCustomerJourneyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCustomerJourneyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.metadataTypeId);
                        if (message.isBuyer != null && Object.hasOwnProperty.call(message, "isBuyer"))
                            $root.google.protobuf.BoolValue.encode(message.isBuyer, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCustomerJourneyRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCustomerJourneyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyRequest} message ListCustomerJourneyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCustomerJourneyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCustomerJourneyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCustomerJourneyRequest} ListCustomerJourneyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCustomerJourneyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCustomerJourneyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.string();
                                break;
                            case 3:
                                message.endDateId = reader.string();
                                break;
                            case 4:
                                message.metadataTypeId = reader.int64();
                                break;
                            case 5:
                                message.isBuyer = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCustomerJourneyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCustomerJourneyRequest} ListCustomerJourneyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCustomerJourneyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCustomerJourneyRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCustomerJourneyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        if (message.isBuyer != null && message.hasOwnProperty("isBuyer")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isBuyer);
                            if (error)
                                return "isBuyer." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCustomerJourneyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCustomerJourneyRequest} ListCustomerJourneyRequest
                     */
                    ListCustomerJourneyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCustomerJourneyRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCustomerJourneyRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        if (object.isBuyer != null) {
                            if (typeof object.isBuyer !== "object")
                                throw TypeError(".palexy.streaming.v1.ListCustomerJourneyRequest.isBuyer: object expected");
                            message.isBuyer = $root.google.protobuf.BoolValue.fromObject(object.isBuyer);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCustomerJourneyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCustomerJourneyRequest} message ListCustomerJourneyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCustomerJourneyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = "";
                            object.endDateId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                            object.isBuyer = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        if (message.isBuyer != null && message.hasOwnProperty("isBuyer"))
                            object.isBuyer = $root.google.protobuf.BoolValue.toObject(message.isBuyer, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListCustomerJourneyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCustomerJourneyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCustomerJourneyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCustomerJourneyRequest;
                })();
    
                v1.ListCustomerJourneyResponse = (function() {
    
                    /**
                     * Properties of a ListCustomerJourneyResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCustomerJourneyResponse
                     * @property {Array.<palexy.streaming.v1.ICustomerJourney>|null} [journeys] ListCustomerJourneyResponse journeys
                     */
    
                    /**
                     * Constructs a new ListCustomerJourneyResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCustomerJourneyResponse.
                     * @implements IListCustomerJourneyResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCustomerJourneyResponse=} [properties] Properties to set
                     */
                    function ListCustomerJourneyResponse(properties) {
                        this.journeys = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCustomerJourneyResponse journeys.
                     * @member {Array.<palexy.streaming.v1.ICustomerJourney>} journeys
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @instance
                     */
                    ListCustomerJourneyResponse.prototype.journeys = $util.emptyArray;
    
                    /**
                     * Creates a new ListCustomerJourneyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCustomerJourneyResponse} ListCustomerJourneyResponse instance
                     */
                    ListCustomerJourneyResponse.create = function create(properties) {
                        return new ListCustomerJourneyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCustomerJourneyResponse message. Does not implicitly {@link palexy.streaming.v1.ListCustomerJourneyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyResponse} message ListCustomerJourneyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCustomerJourneyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.journeys != null && message.journeys.length)
                            for (var i = 0; i < message.journeys.length; ++i)
                                $root.palexy.streaming.v1.CustomerJourney.encode(message.journeys[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCustomerJourneyResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCustomerJourneyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCustomerJourneyResponse} message ListCustomerJourneyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCustomerJourneyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCustomerJourneyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCustomerJourneyResponse} ListCustomerJourneyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCustomerJourneyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCustomerJourneyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.journeys && message.journeys.length))
                                    message.journeys = [];
                                message.journeys.push($root.palexy.streaming.v1.CustomerJourney.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCustomerJourneyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCustomerJourneyResponse} ListCustomerJourneyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCustomerJourneyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCustomerJourneyResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCustomerJourneyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.journeys != null && message.hasOwnProperty("journeys")) {
                            if (!Array.isArray(message.journeys))
                                return "journeys: array expected";
                            for (var i = 0; i < message.journeys.length; ++i) {
                                var error = $root.palexy.streaming.v1.CustomerJourney.verify(message.journeys[i]);
                                if (error)
                                    return "journeys." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCustomerJourneyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCustomerJourneyResponse} ListCustomerJourneyResponse
                     */
                    ListCustomerJourneyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCustomerJourneyResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCustomerJourneyResponse();
                        if (object.journeys) {
                            if (!Array.isArray(object.journeys))
                                throw TypeError(".palexy.streaming.v1.ListCustomerJourneyResponse.journeys: array expected");
                            message.journeys = [];
                            for (var i = 0; i < object.journeys.length; ++i) {
                                if (typeof object.journeys[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCustomerJourneyResponse.journeys: object expected");
                                message.journeys[i] = $root.palexy.streaming.v1.CustomerJourney.fromObject(object.journeys[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCustomerJourneyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCustomerJourneyResponse} message ListCustomerJourneyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCustomerJourneyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.journeys = [];
                        if (message.journeys && message.journeys.length) {
                            object.journeys = [];
                            for (var j = 0; j < message.journeys.length; ++j)
                                object.journeys[j] = $root.palexy.streaming.v1.CustomerJourney.toObject(message.journeys[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCustomerJourneyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCustomerJourneyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCustomerJourneyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCustomerJourneyResponse;
                })();
    
                v1.CustomerJourney = (function() {
    
                    /**
                     * Properties of a CustomerJourney.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomerJourney
                     * @property {string|null} [visitorId] CustomerJourney visitorId
                     * @property {Array.<palexy.streaming.v1.ICustomerJourneyStep>|null} [steps] CustomerJourney steps
                     */
    
                    /**
                     * Constructs a new CustomerJourney.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerJourney.
                     * @implements ICustomerJourney
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomerJourney=} [properties] Properties to set
                     */
                    function CustomerJourney(properties) {
                        this.steps = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomerJourney visitorId.
                     * @member {string} visitorId
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @instance
                     */
                    CustomerJourney.prototype.visitorId = "";
    
                    /**
                     * CustomerJourney steps.
                     * @member {Array.<palexy.streaming.v1.ICustomerJourneyStep>} steps
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @instance
                     */
                    CustomerJourney.prototype.steps = $util.emptyArray;
    
                    /**
                     * Creates a new CustomerJourney instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourney=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomerJourney} CustomerJourney instance
                     */
                    CustomerJourney.create = function create(properties) {
                        return new CustomerJourney(properties);
                    };
    
                    /**
                     * Encodes the specified CustomerJourney message. Does not implicitly {@link palexy.streaming.v1.CustomerJourney.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourney} message CustomerJourney message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourney.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.visitorId != null && Object.hasOwnProperty.call(message, "visitorId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.visitorId);
                        if (message.steps != null && message.steps.length)
                            for (var i = 0; i < message.steps.length; ++i)
                                $root.palexy.streaming.v1.CustomerJourneyStep.encode(message.steps[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomerJourney message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomerJourney.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourney} message CustomerJourney message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourney.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomerJourney message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomerJourney} CustomerJourney
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourney.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomerJourney();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.visitorId = reader.string();
                                break;
                            case 2:
                                if (!(message.steps && message.steps.length))
                                    message.steps = [];
                                message.steps.push($root.palexy.streaming.v1.CustomerJourneyStep.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomerJourney message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomerJourney} CustomerJourney
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourney.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomerJourney message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomerJourney.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            if (!$util.isString(message.visitorId))
                                return "visitorId: string expected";
                        if (message.steps != null && message.hasOwnProperty("steps")) {
                            if (!Array.isArray(message.steps))
                                return "steps: array expected";
                            for (var i = 0; i < message.steps.length; ++i) {
                                var error = $root.palexy.streaming.v1.CustomerJourneyStep.verify(message.steps[i]);
                                if (error)
                                    return "steps." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CustomerJourney message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomerJourney} CustomerJourney
                     */
                    CustomerJourney.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomerJourney)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomerJourney();
                        if (object.visitorId != null)
                            message.visitorId = String(object.visitorId);
                        if (object.steps) {
                            if (!Array.isArray(object.steps))
                                throw TypeError(".palexy.streaming.v1.CustomerJourney.steps: array expected");
                            message.steps = [];
                            for (var i = 0; i < object.steps.length; ++i) {
                                if (typeof object.steps[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CustomerJourney.steps: object expected");
                                message.steps[i] = $root.palexy.streaming.v1.CustomerJourneyStep.fromObject(object.steps[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomerJourney message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @static
                     * @param {palexy.streaming.v1.CustomerJourney} message CustomerJourney
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomerJourney.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.steps = [];
                        if (options.defaults)
                            object.visitorId = "";
                        if (message.visitorId != null && message.hasOwnProperty("visitorId"))
                            object.visitorId = message.visitorId;
                        if (message.steps && message.steps.length) {
                            object.steps = [];
                            for (var j = 0; j < message.steps.length; ++j)
                                object.steps[j] = $root.palexy.streaming.v1.CustomerJourneyStep.toObject(message.steps[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CustomerJourney to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomerJourney
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomerJourney.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomerJourney;
                })();
    
                v1.CustomerJourneyStep = (function() {
    
                    /**
                     * Properties of a CustomerJourneyStep.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomerJourneyStep
                     * @property {string|null} [startTime] CustomerJourneyStep startTime
                     * @property {string|null} [endTime] CustomerJourneyStep endTime
                     * @property {string|null} [actionType] CustomerJourneyStep actionType
                     * @property {palexy.streaming.v1.ICustomerJourneySectionVisitDetail|null} [sectionVisitDetail] CustomerJourneyStep sectionVisitDetail
                     * @property {palexy.streaming.v1.ICustomerJourneyTransactionDetail|null} [transactionDetail] CustomerJourneyStep transactionDetail
                     */
    
                    /**
                     * Constructs a new CustomerJourneyStep.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerJourneyStep.
                     * @implements ICustomerJourneyStep
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomerJourneyStep=} [properties] Properties to set
                     */
                    function CustomerJourneyStep(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomerJourneyStep startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    CustomerJourneyStep.prototype.startTime = "";
    
                    /**
                     * CustomerJourneyStep endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    CustomerJourneyStep.prototype.endTime = "";
    
                    /**
                     * CustomerJourneyStep actionType.
                     * @member {string} actionType
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    CustomerJourneyStep.prototype.actionType = "";
    
                    /**
                     * CustomerJourneyStep sectionVisitDetail.
                     * @member {palexy.streaming.v1.ICustomerJourneySectionVisitDetail|null|undefined} sectionVisitDetail
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    CustomerJourneyStep.prototype.sectionVisitDetail = null;
    
                    /**
                     * CustomerJourneyStep transactionDetail.
                     * @member {palexy.streaming.v1.ICustomerJourneyTransactionDetail|null|undefined} transactionDetail
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    CustomerJourneyStep.prototype.transactionDetail = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * CustomerJourneyStep detail.
                     * @member {"sectionVisitDetail"|"transactionDetail"|undefined} detail
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     */
                    Object.defineProperty(CustomerJourneyStep.prototype, "detail", {
                        get: $util.oneOfGetter($oneOfFields = ["sectionVisitDetail", "transactionDetail"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new CustomerJourneyStep instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyStep=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomerJourneyStep} CustomerJourneyStep instance
                     */
                    CustomerJourneyStep.create = function create(properties) {
                        return new CustomerJourneyStep(properties);
                    };
    
                    /**
                     * Encodes the specified CustomerJourneyStep message. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyStep.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyStep} message CustomerJourneyStep message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneyStep.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endTime);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.actionType);
                        if (message.sectionVisitDetail != null && Object.hasOwnProperty.call(message, "sectionVisitDetail"))
                            $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail.encode(message.sectionVisitDetail, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.transactionDetail != null && Object.hasOwnProperty.call(message, "transactionDetail"))
                            $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.encode(message.transactionDetail, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomerJourneyStep message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyStep.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyStep} message CustomerJourneyStep message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneyStep.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomerJourneyStep message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomerJourneyStep} CustomerJourneyStep
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneyStep.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomerJourneyStep();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startTime = reader.string();
                                break;
                            case 2:
                                message.endTime = reader.string();
                                break;
                            case 3:
                                message.actionType = reader.string();
                                break;
                            case 4:
                                message.sectionVisitDetail = $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.transactionDetail = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomerJourneyStep message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomerJourneyStep} CustomerJourneyStep
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneyStep.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomerJourneyStep message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomerJourneyStep.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            if (!$util.isString(message.actionType))
                                return "actionType: string expected";
                        if (message.sectionVisitDetail != null && message.hasOwnProperty("sectionVisitDetail")) {
                            properties.detail = 1;
                            {
                                var error = $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail.verify(message.sectionVisitDetail);
                                if (error)
                                    return "sectionVisitDetail." + error;
                            }
                        }
                        if (message.transactionDetail != null && message.hasOwnProperty("transactionDetail")) {
                            if (properties.detail === 1)
                                return "detail: multiple values";
                            properties.detail = 1;
                            {
                                var error = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.verify(message.transactionDetail);
                                if (error)
                                    return "transactionDetail." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CustomerJourneyStep message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomerJourneyStep} CustomerJourneyStep
                     */
                    CustomerJourneyStep.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomerJourneyStep)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomerJourneyStep();
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.actionType != null)
                            message.actionType = String(object.actionType);
                        if (object.sectionVisitDetail != null) {
                            if (typeof object.sectionVisitDetail !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomerJourneyStep.sectionVisitDetail: object expected");
                            message.sectionVisitDetail = $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail.fromObject(object.sectionVisitDetail);
                        }
                        if (object.transactionDetail != null) {
                            if (typeof object.transactionDetail !== "object")
                                throw TypeError(".palexy.streaming.v1.CustomerJourneyStep.transactionDetail: object expected");
                            message.transactionDetail = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.fromObject(object.transactionDetail);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomerJourneyStep message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @static
                     * @param {palexy.streaming.v1.CustomerJourneyStep} message CustomerJourneyStep
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomerJourneyStep.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startTime = "";
                            object.endTime = "";
                            object.actionType = "";
                        }
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = message.actionType;
                        if (message.sectionVisitDetail != null && message.hasOwnProperty("sectionVisitDetail")) {
                            object.sectionVisitDetail = $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail.toObject(message.sectionVisitDetail, options);
                            if (options.oneofs)
                                object.detail = "sectionVisitDetail";
                        }
                        if (message.transactionDetail != null && message.hasOwnProperty("transactionDetail")) {
                            object.transactionDetail = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.toObject(message.transactionDetail, options);
                            if (options.oneofs)
                                object.detail = "transactionDetail";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CustomerJourneyStep to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomerJourneyStep
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomerJourneyStep.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomerJourneyStep;
                })();
    
                v1.CustomerJourneySectionVisitDetail = (function() {
    
                    /**
                     * Properties of a CustomerJourneySectionVisitDetail.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomerJourneySectionVisitDetail
                     * @property {number|null} [metadataValueId] CustomerJourneySectionVisitDetail metadataValueId
                     * @property {string|null} [metadataValueName] CustomerJourneySectionVisitDetail metadataValueName
                     */
    
                    /**
                     * Constructs a new CustomerJourneySectionVisitDetail.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerJourneySectionVisitDetail.
                     * @implements ICustomerJourneySectionVisitDetail
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomerJourneySectionVisitDetail=} [properties] Properties to set
                     */
                    function CustomerJourneySectionVisitDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomerJourneySectionVisitDetail metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @instance
                     */
                    CustomerJourneySectionVisitDetail.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CustomerJourneySectionVisitDetail metadataValueName.
                     * @member {string} metadataValueName
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @instance
                     */
                    CustomerJourneySectionVisitDetail.prototype.metadataValueName = "";
    
                    /**
                     * Creates a new CustomerJourneySectionVisitDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneySectionVisitDetail=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomerJourneySectionVisitDetail} CustomerJourneySectionVisitDetail instance
                     */
                    CustomerJourneySectionVisitDetail.create = function create(properties) {
                        return new CustomerJourneySectionVisitDetail(properties);
                    };
    
                    /**
                     * Encodes the specified CustomerJourneySectionVisitDetail message. Does not implicitly {@link palexy.streaming.v1.CustomerJourneySectionVisitDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneySectionVisitDetail} message CustomerJourneySectionVisitDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneySectionVisitDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataValueId);
                        if (message.metadataValueName != null && Object.hasOwnProperty.call(message, "metadataValueName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataValueName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomerJourneySectionVisitDetail message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomerJourneySectionVisitDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneySectionVisitDetail} message CustomerJourneySectionVisitDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneySectionVisitDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomerJourneySectionVisitDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomerJourneySectionVisitDetail} CustomerJourneySectionVisitDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneySectionVisitDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataValueId = reader.int64();
                                break;
                            case 2:
                                message.metadataValueName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomerJourneySectionVisitDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomerJourneySectionVisitDetail} CustomerJourneySectionVisitDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneySectionVisitDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomerJourneySectionVisitDetail message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomerJourneySectionVisitDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.metadataValueName != null && message.hasOwnProperty("metadataValueName"))
                            if (!$util.isString(message.metadataValueName))
                                return "metadataValueName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CustomerJourneySectionVisitDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomerJourneySectionVisitDetail} CustomerJourneySectionVisitDetail
                     */
                    CustomerJourneySectionVisitDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomerJourneySectionVisitDetail();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.metadataValueName != null)
                            message.metadataValueName = String(object.metadataValueName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomerJourneySectionVisitDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @static
                     * @param {palexy.streaming.v1.CustomerJourneySectionVisitDetail} message CustomerJourneySectionVisitDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomerJourneySectionVisitDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            object.metadataValueName = "";
                        }
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.metadataValueName != null && message.hasOwnProperty("metadataValueName"))
                            object.metadataValueName = message.metadataValueName;
                        return object;
                    };
    
                    /**
                     * Converts this CustomerJourneySectionVisitDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomerJourneySectionVisitDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomerJourneySectionVisitDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomerJourneySectionVisitDetail;
                })();
    
                v1.CustomerJourneyTransactionDetail = (function() {
    
                    /**
                     * Properties of a CustomerJourneyTransactionDetail.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomerJourneyTransactionDetail
                     * @property {Array.<palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem>|null} [items] CustomerJourneyTransactionDetail items
                     */
    
                    /**
                     * Constructs a new CustomerJourneyTransactionDetail.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomerJourneyTransactionDetail.
                     * @implements ICustomerJourneyTransactionDetail
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomerJourneyTransactionDetail=} [properties] Properties to set
                     */
                    function CustomerJourneyTransactionDetail(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomerJourneyTransactionDetail items.
                     * @member {Array.<palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem>} items
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @instance
                     */
                    CustomerJourneyTransactionDetail.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new CustomerJourneyTransactionDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyTransactionDetail=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail} CustomerJourneyTransactionDetail instance
                     */
                    CustomerJourneyTransactionDetail.create = function create(properties) {
                        return new CustomerJourneyTransactionDetail(properties);
                    };
    
                    /**
                     * Encodes the specified CustomerJourneyTransactionDetail message. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyTransactionDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyTransactionDetail} message CustomerJourneyTransactionDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneyTransactionDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomerJourneyTransactionDetail message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyTransactionDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {palexy.streaming.v1.ICustomerJourneyTransactionDetail} message CustomerJourneyTransactionDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomerJourneyTransactionDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomerJourneyTransactionDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail} CustomerJourneyTransactionDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneyTransactionDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomerJourneyTransactionDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomerJourneyTransactionDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail} CustomerJourneyTransactionDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomerJourneyTransactionDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomerJourneyTransactionDetail message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomerJourneyTransactionDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CustomerJourneyTransactionDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail} CustomerJourneyTransactionDetail
                     */
                    CustomerJourneyTransactionDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomerJourneyTransactionDetail)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomerJourneyTransactionDetail();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.streaming.v1.CustomerJourneyTransactionDetail.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CustomerJourneyTransactionDetail.items: object expected");
                                message.items[i] = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomerJourneyTransactionDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @static
                     * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail} message CustomerJourneyTransactionDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomerJourneyTransactionDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CustomerJourneyTransactionDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomerJourneyTransactionDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    CustomerJourneyTransactionDetail.Item = (function() {
    
                        /**
                         * Properties of an Item.
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                         * @interface IItem
                         * @property {number|null} [itemId] Item itemId
                         * @property {string|null} [itemName] Item itemName
                         * @property {number|null} [quantity] Item quantity
                         */
    
                        /**
                         * Constructs a new Item.
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail
                         * @classdesc Represents an Item.
                         * @implements IItem
                         * @constructor
                         * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem=} [properties] Properties to set
                         */
                        function Item(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Item itemId.
                         * @member {number} itemId
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @instance
                         */
                        Item.prototype.itemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Item itemName.
                         * @member {string} itemName
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @instance
                         */
                        Item.prototype.itemName = "";
    
                        /**
                         * Item quantity.
                         * @member {number} quantity
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @instance
                         */
                        Item.prototype.quantity = 0;
    
                        /**
                         * Creates a new Item instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail.Item} Item instance
                         */
                        Item.create = function create(properties) {
                            return new Item(properties);
                        };
    
                        /**
                         * Encodes the specified Item message. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem} message Item message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Item.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.itemId);
                            if (message.itemName != null && Object.hasOwnProperty.call(message, "itemName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.itemName);
                            if (message.quantity != null && Object.hasOwnProperty.call(message, "quantity"))
                                writer.uint32(/* id 3, wireType 1 =*/25).double(message.quantity);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Item message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomerJourneyTransactionDetail.Item.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail.IItem} message Item message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Item.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an Item message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail.Item} Item
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Item.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.itemId = reader.int64();
                                    break;
                                case 2:
                                    message.itemName = reader.string();
                                    break;
                                case 3:
                                    message.quantity = reader.double();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an Item message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail.Item} Item
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Item.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an Item message.
                         * @function verify
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Item.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                if (!$util.isInteger(message.itemId) && !(message.itemId && $util.isInteger(message.itemId.low) && $util.isInteger(message.itemId.high)))
                                    return "itemId: integer|Long expected";
                            if (message.itemName != null && message.hasOwnProperty("itemName"))
                                if (!$util.isString(message.itemName))
                                    return "itemName: string expected";
                            if (message.quantity != null && message.hasOwnProperty("quantity"))
                                if (typeof message.quantity !== "number")
                                    return "quantity: number expected";
                            return null;
                        };
    
                        /**
                         * Creates an Item message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.CustomerJourneyTransactionDetail.Item} Item
                         */
                        Item.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item)
                                return object;
                            var message = new $root.palexy.streaming.v1.CustomerJourneyTransactionDetail.Item();
                            if (object.itemId != null)
                                if ($util.Long)
                                    (message.itemId = $util.Long.fromValue(object.itemId)).unsigned = false;
                                else if (typeof object.itemId === "string")
                                    message.itemId = parseInt(object.itemId, 10);
                                else if (typeof object.itemId === "number")
                                    message.itemId = object.itemId;
                                else if (typeof object.itemId === "object")
                                    message.itemId = new $util.LongBits(object.itemId.low >>> 0, object.itemId.high >>> 0).toNumber();
                            if (object.itemName != null)
                                message.itemName = String(object.itemName);
                            if (object.quantity != null)
                                message.quantity = Number(object.quantity);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an Item message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @static
                         * @param {palexy.streaming.v1.CustomerJourneyTransactionDetail.Item} message Item
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Item.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.itemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.itemId = options.longs === String ? "0" : 0;
                                object.itemName = "";
                                object.quantity = 0;
                            }
                            if (message.itemId != null && message.hasOwnProperty("itemId"))
                                if (typeof message.itemId === "number")
                                    object.itemId = options.longs === String ? String(message.itemId) : message.itemId;
                                else
                                    object.itemId = options.longs === String ? $util.Long.prototype.toString.call(message.itemId) : options.longs === Number ? new $util.LongBits(message.itemId.low >>> 0, message.itemId.high >>> 0).toNumber() : message.itemId;
                            if (message.itemName != null && message.hasOwnProperty("itemName"))
                                object.itemName = message.itemName;
                            if (message.quantity != null && message.hasOwnProperty("quantity"))
                                object.quantity = options.json && !isFinite(message.quantity) ? String(message.quantity) : message.quantity;
                            return object;
                        };
    
                        /**
                         * Converts this Item to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.CustomerJourneyTransactionDetail.Item
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Item.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Item;
                    })();
    
                    return CustomerJourneyTransactionDetail;
                })();
    
                v1.StoreEventService = (function() {
    
                    /**
                     * Constructs a new StoreEventService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEventService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreEventService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreEventService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreEventService;
    
                    /**
                     * Creates new StoreEventService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreEventService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreEventService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#createStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef CreateStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEvent} [response] StoreEvent
                     */
    
                    /**
                     * Calls CreateStoreEvent.
                     * @function createStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest} request CreateStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.CreateStoreEventCallback} callback Node-style callback called with the error, if any, and StoreEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.createStoreEvent = function createStoreEvent(request, callback) {
                        return this.rpcCall(createStoreEvent, $root.palexy.streaming.v1.CreateStoreEventRequest, $root.palexy.streaming.v1.StoreEvent, request, callback);
                    }, "name", { value: "CreateStoreEvent" });
    
                    /**
                     * Calls CreateStoreEvent.
                     * @function createStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest} request CreateStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#batchCreateStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef BatchCreateStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateStoreEventResponse} [response] BatchCreateStoreEventResponse
                     */
    
                    /**
                     * Calls BatchCreateStoreEvent.
                     * @function batchCreateStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest} request BatchCreateStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.BatchCreateStoreEventCallback} callback Node-style callback called with the error, if any, and BatchCreateStoreEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.batchCreateStoreEvent = function batchCreateStoreEvent(request, callback) {
                        return this.rpcCall(batchCreateStoreEvent, $root.palexy.streaming.v1.BatchCreateStoreEventRequest, $root.palexy.streaming.v1.BatchCreateStoreEventResponse, request, callback);
                    }, "name", { value: "BatchCreateStoreEvent" });
    
                    /**
                     * Calls BatchCreateStoreEvent.
                     * @function batchCreateStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest} request BatchCreateStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateStoreEventResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#getStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef GetStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEvent} [response] StoreEvent
                     */
    
                    /**
                     * Calls GetStoreEvent.
                     * @function getStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreEventRequest} request GetStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.GetStoreEventCallback} callback Node-style callback called with the error, if any, and StoreEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.getStoreEvent = function getStoreEvent(request, callback) {
                        return this.rpcCall(getStoreEvent, $root.palexy.streaming.v1.GetStoreEventRequest, $root.palexy.streaming.v1.StoreEvent, request, callback);
                    }, "name", { value: "GetStoreEvent" });
    
                    /**
                     * Calls GetStoreEvent.
                     * @function getStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreEventRequest} request GetStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#updateStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef UpdateStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEvent} [response] StoreEvent
                     */
    
                    /**
                     * Calls UpdateStoreEvent.
                     * @function updateStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest} request UpdateStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.UpdateStoreEventCallback} callback Node-style callback called with the error, if any, and StoreEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.updateStoreEvent = function updateStoreEvent(request, callback) {
                        return this.rpcCall(updateStoreEvent, $root.palexy.streaming.v1.UpdateStoreEventRequest, $root.palexy.streaming.v1.StoreEvent, request, callback);
                    }, "name", { value: "UpdateStoreEvent" });
    
                    /**
                     * Calls UpdateStoreEvent.
                     * @function updateStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest} request UpdateStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#deleteStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef DeleteStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStoreEvent.
                     * @function deleteStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest} request DeleteStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.DeleteStoreEventCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.deleteStoreEvent = function deleteStoreEvent(request, callback) {
                        return this.rpcCall(deleteStoreEvent, $root.palexy.streaming.v1.DeleteStoreEventRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStoreEvent" });
    
                    /**
                     * Calls DeleteStoreEvent.
                     * @function deleteStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest} request DeleteStoreEventRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#listStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef ListStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreEventResponse} [response] ListStoreEventResponse
                     */
    
                    /**
                     * Calls ListStoreEvent.
                     * @function listStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventRequest} request ListStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.ListStoreEventCallback} callback Node-style callback called with the error, if any, and ListStoreEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.listStoreEvent = function listStoreEvent(request, callback) {
                        return this.rpcCall(listStoreEvent, $root.palexy.streaming.v1.ListStoreEventRequest, $root.palexy.streaming.v1.ListStoreEventResponse, request, callback);
                    }, "name", { value: "ListStoreEvent" });
    
                    /**
                     * Calls ListStoreEvent.
                     * @function listStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventRequest} request ListStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreEventResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#listStoreEventReviewLog}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef ListStoreEventReviewLogCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreEventReviewLogResponse} [response] ListStoreEventReviewLogResponse
                     */
    
                    /**
                     * Calls ListStoreEventReviewLog.
                     * @function listStoreEventReviewLog
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest} request ListStoreEventReviewLogRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.ListStoreEventReviewLogCallback} callback Node-style callback called with the error, if any, and ListStoreEventReviewLogResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.listStoreEventReviewLog = function listStoreEventReviewLog(request, callback) {
                        return this.rpcCall(listStoreEventReviewLog, $root.palexy.streaming.v1.ListStoreEventReviewLogRequest, $root.palexy.streaming.v1.ListStoreEventReviewLogResponse, request, callback);
                    }, "name", { value: "ListStoreEventReviewLog" });
    
                    /**
                     * Calls ListStoreEventReviewLog.
                     * @function listStoreEventReviewLog
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest} request ListStoreEventReviewLogRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreEventReviewLogResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#reviewStoreEvent}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef ReviewStoreEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ReviewStoreEventResponse} [response] ReviewStoreEventResponse
                     */
    
                    /**
                     * Calls ReviewStoreEvent.
                     * @function reviewStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest} request ReviewStoreEventRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.ReviewStoreEventCallback} callback Node-style callback called with the error, if any, and ReviewStoreEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.reviewStoreEvent = function reviewStoreEvent(request, callback) {
                        return this.rpcCall(reviewStoreEvent, $root.palexy.streaming.v1.ReviewStoreEventRequest, $root.palexy.streaming.v1.ReviewStoreEventResponse, request, callback);
                    }, "name", { value: "ReviewStoreEvent" });
    
                    /**
                     * Calls ReviewStoreEvent.
                     * @function reviewStoreEvent
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest} request ReviewStoreEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ReviewStoreEventResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#fetchStoreEventReport}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef FetchStoreEventReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEventAnalyticsReport} [response] StoreEventAnalyticsReport
                     */
    
                    /**
                     * Calls FetchStoreEventReport.
                     * @function fetchStoreEventReport
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest} request FetchStoreEventAnalyticsReportRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.FetchStoreEventReportCallback} callback Node-style callback called with the error, if any, and StoreEventAnalyticsReport
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.fetchStoreEventReport = function fetchStoreEventReport(request, callback) {
                        return this.rpcCall(fetchStoreEventReport, $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest, $root.palexy.streaming.v1.StoreEventAnalyticsReport, request, callback);
                    }, "name", { value: "FetchStoreEventReport" });
    
                    /**
                     * Calls FetchStoreEventReport.
                     * @function fetchStoreEventReport
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest} request FetchStoreEventAnalyticsReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEventAnalyticsReport>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#fetchExpiredStoreEventArtifacts}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef FetchExpiredStoreEventArtifactsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} [response] FetchExpiredStoreEventArtifactsResponse
                     */
    
                    /**
                     * Calls FetchExpiredStoreEventArtifacts.
                     * @function fetchExpiredStoreEventArtifacts
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest} request FetchExpiredStoreEventArtifactsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.FetchExpiredStoreEventArtifactsCallback} callback Node-style callback called with the error, if any, and FetchExpiredStoreEventArtifactsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.fetchExpiredStoreEventArtifacts = function fetchExpiredStoreEventArtifacts(request, callback) {
                        return this.rpcCall(fetchExpiredStoreEventArtifacts, $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest, $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse, request, callback);
                    }, "name", { value: "FetchExpiredStoreEventArtifacts" });
    
                    /**
                     * Calls FetchExpiredStoreEventArtifacts.
                     * @function fetchExpiredStoreEventArtifacts
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest} request FetchExpiredStoreEventArtifactsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#batchUpdateStoreEvents}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef BatchUpdateStoreEventsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUpdateStoreEventsResponse} [response] BatchUpdateStoreEventsResponse
                     */
    
                    /**
                     * Calls BatchUpdateStoreEvents.
                     * @function batchUpdateStoreEvents
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest} request BatchUpdateStoreEventsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.BatchUpdateStoreEventsCallback} callback Node-style callback called with the error, if any, and BatchUpdateStoreEventsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.batchUpdateStoreEvents = function batchUpdateStoreEvents(request, callback) {
                        return this.rpcCall(batchUpdateStoreEvents, $root.palexy.streaming.v1.BatchUpdateStoreEventsRequest, $root.palexy.streaming.v1.BatchUpdateStoreEventsResponse, request, callback);
                    }, "name", { value: "BatchUpdateStoreEvents" });
    
                    /**
                     * Calls BatchUpdateStoreEvents.
                     * @function batchUpdateStoreEvents
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest} request BatchUpdateStoreEventsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUpdateStoreEventsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#getStoreEventInsights}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef GetStoreEventInsightsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetStoreEventInsightsResponse} [response] GetStoreEventInsightsResponse
                     */
    
                    /**
                     * Calls GetStoreEventInsights.
                     * @function getStoreEventInsights
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest} request GetStoreEventInsightsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.GetStoreEventInsightsCallback} callback Node-style callback called with the error, if any, and GetStoreEventInsightsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.getStoreEventInsights = function getStoreEventInsights(request, callback) {
                        return this.rpcCall(getStoreEventInsights, $root.palexy.streaming.v1.GetStoreEventInsightsRequest, $root.palexy.streaming.v1.GetStoreEventInsightsResponse, request, callback);
                    }, "name", { value: "GetStoreEventInsights" });
    
                    /**
                     * Calls GetStoreEventInsights.
                     * @function getStoreEventInsights
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest} request GetStoreEventInsightsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetStoreEventInsightsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#createStoreEventPriorityConfig}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef CreateStoreEventPriorityConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEventPriorityConfig} [response] StoreEventPriorityConfig
                     */
    
                    /**
                     * Calls CreateStoreEventPriorityConfig.
                     * @function createStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest} request CreateStoreEventPriorityConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.CreateStoreEventPriorityConfigCallback} callback Node-style callback called with the error, if any, and StoreEventPriorityConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.createStoreEventPriorityConfig = function createStoreEventPriorityConfig(request, callback) {
                        return this.rpcCall(createStoreEventPriorityConfig, $root.palexy.streaming.v1.CreateStoreEventPriorityConfigRequest, $root.palexy.streaming.v1.StoreEventPriorityConfig, request, callback);
                    }, "name", { value: "CreateStoreEventPriorityConfig" });
    
                    /**
                     * Calls CreateStoreEventPriorityConfig.
                     * @function createStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest} request CreateStoreEventPriorityConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEventPriorityConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#updateStoreEventPriorityConfig}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef UpdateStoreEventPriorityConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreEventPriorityConfig} [response] StoreEventPriorityConfig
                     */
    
                    /**
                     * Calls UpdateStoreEventPriorityConfig.
                     * @function updateStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest} request UpdateStoreEventPriorityConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.UpdateStoreEventPriorityConfigCallback} callback Node-style callback called with the error, if any, and StoreEventPriorityConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.updateStoreEventPriorityConfig = function updateStoreEventPriorityConfig(request, callback) {
                        return this.rpcCall(updateStoreEventPriorityConfig, $root.palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest, $root.palexy.streaming.v1.StoreEventPriorityConfig, request, callback);
                    }, "name", { value: "UpdateStoreEventPriorityConfig" });
    
                    /**
                     * Calls UpdateStoreEventPriorityConfig.
                     * @function updateStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest} request UpdateStoreEventPriorityConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreEventPriorityConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#deleteStoreEventPriorityConfig}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef DeleteStoreEventPriorityConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStoreEventPriorityConfig.
                     * @function deleteStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest} request DeleteStoreEventPriorityConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.DeleteStoreEventPriorityConfigCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.deleteStoreEventPriorityConfig = function deleteStoreEventPriorityConfig(request, callback) {
                        return this.rpcCall(deleteStoreEventPriorityConfig, $root.palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStoreEventPriorityConfig" });
    
                    /**
                     * Calls DeleteStoreEventPriorityConfig.
                     * @function deleteStoreEventPriorityConfig
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest} request DeleteStoreEventPriorityConfigRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreEventService#listStoreEventPriorityConfigs}.
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @typedef ListStoreEventPriorityConfigsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} [response] ListStoreEventPriorityConfigsResponse
                     */
    
                    /**
                     * Calls ListStoreEventPriorityConfigs.
                     * @function listStoreEventPriorityConfigs
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest} request ListStoreEventPriorityConfigsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreEventService.ListStoreEventPriorityConfigsCallback} callback Node-style callback called with the error, if any, and ListStoreEventPriorityConfigsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreEventService.prototype.listStoreEventPriorityConfigs = function listStoreEventPriorityConfigs(request, callback) {
                        return this.rpcCall(listStoreEventPriorityConfigs, $root.palexy.streaming.v1.ListStoreEventPriorityConfigsRequest, $root.palexy.streaming.v1.ListStoreEventPriorityConfigsResponse, request, callback);
                    }, "name", { value: "ListStoreEventPriorityConfigs" });
    
                    /**
                     * Calls ListStoreEventPriorityConfigs.
                     * @function listStoreEventPriorityConfigs
                     * @memberof palexy.streaming.v1.StoreEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest} request ListStoreEventPriorityConfigsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreEventPriorityConfigsResponse>} Promise
                     * @variation 2
                     */
    
                    return StoreEventService;
                })();
    
                v1.FetchStoreEventAnalyticsReportRequest = (function() {
    
                    /**
                     * Properties of a FetchStoreEventAnalyticsReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchStoreEventAnalyticsReportRequest
                     * @property {Array.<string>|null} [dates] FetchStoreEventAnalyticsReportRequest dates
                     * @property {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Dimension>|null} [dimensions] FetchStoreEventAnalyticsReportRequest dimensions
                     * @property {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Metric>|null} [metrics] FetchStoreEventAnalyticsReportRequest metrics
                     * @property {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter|null} [reportFilter] FetchStoreEventAnalyticsReportRequest reportFilter
                     */
    
                    /**
                     * Constructs a new FetchStoreEventAnalyticsReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchStoreEventAnalyticsReportRequest.
                     * @implements IFetchStoreEventAnalyticsReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest=} [properties] Properties to set
                     */
                    function FetchStoreEventAnalyticsReportRequest(properties) {
                        this.dates = [];
                        this.dimensions = [];
                        this.metrics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchStoreEventAnalyticsReportRequest dates.
                     * @member {Array.<string>} dates
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @instance
                     */
                    FetchStoreEventAnalyticsReportRequest.prototype.dates = $util.emptyArray;
    
                    /**
                     * FetchStoreEventAnalyticsReportRequest dimensions.
                     * @member {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Dimension>} dimensions
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @instance
                     */
                    FetchStoreEventAnalyticsReportRequest.prototype.dimensions = $util.emptyArray;
    
                    /**
                     * FetchStoreEventAnalyticsReportRequest metrics.
                     * @member {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Metric>} metrics
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @instance
                     */
                    FetchStoreEventAnalyticsReportRequest.prototype.metrics = $util.emptyArray;
    
                    /**
                     * FetchStoreEventAnalyticsReportRequest reportFilter.
                     * @member {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter|null|undefined} reportFilter
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @instance
                     */
                    FetchStoreEventAnalyticsReportRequest.prototype.reportFilter = null;
    
                    /**
                     * Creates a new FetchStoreEventAnalyticsReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest} FetchStoreEventAnalyticsReportRequest instance
                     */
                    FetchStoreEventAnalyticsReportRequest.create = function create(properties) {
                        return new FetchStoreEventAnalyticsReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchStoreEventAnalyticsReportRequest message. Does not implicitly {@link palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest} message FetchStoreEventAnalyticsReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreEventAnalyticsReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dates != null && message.dates.length)
                            for (var i = 0; i < message.dates.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dates[i]);
                        if (message.dimensions != null && message.dimensions.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.dimensions.length; ++i)
                                writer.int32(message.dimensions[i]);
                            writer.ldelim();
                        }
                        if (message.metrics != null && message.metrics.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.metrics.length; ++i)
                                writer.int32(message.metrics[i]);
                            writer.ldelim();
                        }
                        if (message.reportFilter != null && Object.hasOwnProperty.call(message, "reportFilter"))
                            $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.encode(message.reportFilter, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchStoreEventAnalyticsReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchStoreEventAnalyticsReportRequest} message FetchStoreEventAnalyticsReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchStoreEventAnalyticsReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchStoreEventAnalyticsReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest} FetchStoreEventAnalyticsReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreEventAnalyticsReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dates && message.dates.length))
                                    message.dates = [];
                                message.dates.push(reader.string());
                                break;
                            case 2:
                                if (!(message.dimensions && message.dimensions.length))
                                    message.dimensions = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.dimensions.push(reader.int32());
                                } else
                                    message.dimensions.push(reader.int32());
                                break;
                            case 3:
                                if (!(message.metrics && message.metrics.length))
                                    message.metrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.metrics.push(reader.int32());
                                } else
                                    message.metrics.push(reader.int32());
                                break;
                            case 4:
                                message.reportFilter = $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchStoreEventAnalyticsReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest} FetchStoreEventAnalyticsReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchStoreEventAnalyticsReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchStoreEventAnalyticsReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchStoreEventAnalyticsReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dates != null && message.hasOwnProperty("dates")) {
                            if (!Array.isArray(message.dates))
                                return "dates: array expected";
                            for (var i = 0; i < message.dates.length; ++i)
                                if (!$util.isString(message.dates[i]))
                                    return "dates: string[] expected";
                        }
                        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                            if (!Array.isArray(message.dimensions))
                                return "dimensions: array expected";
                            for (var i = 0; i < message.dimensions.length; ++i)
                                switch (message.dimensions[i]) {
                                default:
                                    return "dimensions: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 18:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                    break;
                                }
                        }
                        if (message.metrics != null && message.hasOwnProperty("metrics")) {
                            if (!Array.isArray(message.metrics))
                                return "metrics: array expected";
                            for (var i = 0; i < message.metrics.length; ++i)
                                switch (message.metrics[i]) {
                                default:
                                    return "metrics: enum value[] expected";
                                case 0:
                                case 1:
                                    break;
                                }
                        }
                        if (message.reportFilter != null && message.hasOwnProperty("reportFilter")) {
                            var error = $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.verify(message.reportFilter);
                            if (error)
                                return "reportFilter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FetchStoreEventAnalyticsReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest} FetchStoreEventAnalyticsReportRequest
                     */
                    FetchStoreEventAnalyticsReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest();
                        if (object.dates) {
                            if (!Array.isArray(object.dates))
                                throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.dates: array expected");
                            message.dates = [];
                            for (var i = 0; i < object.dates.length; ++i)
                                message.dates[i] = String(object.dates[i]);
                        }
                        if (object.dimensions) {
                            if (!Array.isArray(object.dimensions))
                                throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.dimensions: array expected");
                            message.dimensions = [];
                            for (var i = 0; i < object.dimensions.length; ++i)
                                switch (object.dimensions[i]) {
                                default:
                                case "UNKNOWN_DIMENSION":
                                case 0:
                                    message.dimensions[i] = 0;
                                    break;
                                case "STATUS":
                                case 1:
                                    message.dimensions[i] = 1;
                                    break;
                                case "EVENT_TYPE":
                                case 2:
                                    message.dimensions[i] = 2;
                                    break;
                                case "NTH_DAY":
                                case 3:
                                    message.dimensions[i] = 3;
                                    break;
                                case "NTH_WEEK":
                                case 4:
                                    message.dimensions[i] = 4;
                                    break;
                                case "CUSTOM_NTH_WEEK":
                                case 18:
                                    message.dimensions[i] = 18;
                                    break;
                                case "NTH_MONTH":
                                case 5:
                                    message.dimensions[i] = 5;
                                    break;
                                case "STORE_NAME":
                                case 6:
                                    message.dimensions[i] = 6;
                                    break;
                                case "NTH_QUARTER":
                                case 7:
                                    message.dimensions[i] = 7;
                                    break;
                                case "STORE_METADATA_1":
                                case 8:
                                    message.dimensions[i] = 8;
                                    break;
                                case "STORE_METADATA_2":
                                case 9:
                                    message.dimensions[i] = 9;
                                    break;
                                case "STORE_METADATA_3":
                                case 10:
                                    message.dimensions[i] = 10;
                                    break;
                                case "STORE_METADATA_4":
                                case 11:
                                    message.dimensions[i] = 11;
                                    break;
                                case "STORE_METADATA_5":
                                case 12:
                                    message.dimensions[i] = 12;
                                    break;
                                case "STORE_METADATA_6":
                                case 13:
                                    message.dimensions[i] = 13;
                                    break;
                                case "STORE_METADATA_7":
                                case 14:
                                    message.dimensions[i] = 14;
                                    break;
                                case "STORE_METADATA_8":
                                case 15:
                                    message.dimensions[i] = 15;
                                    break;
                                case "STORE_METADATA_9":
                                case 16:
                                    message.dimensions[i] = 16;
                                    break;
                                case "STORE_METADATA_10":
                                case 17:
                                    message.dimensions[i] = 17;
                                    break;
                                case "STORE_METADATA_11":
                                case 19:
                                    message.dimensions[i] = 19;
                                    break;
                                case "STORE_METADATA_12":
                                case 20:
                                    message.dimensions[i] = 20;
                                    break;
                                case "STORE_METADATA_13":
                                case 21:
                                    message.dimensions[i] = 21;
                                    break;
                                case "STORE_METADATA_14":
                                case 22:
                                    message.dimensions[i] = 22;
                                    break;
                                case "STORE_METADATA_15":
                                case 23:
                                    message.dimensions[i] = 23;
                                    break;
                                case "STORE_METADATA_16":
                                case 24:
                                    message.dimensions[i] = 24;
                                    break;
                                case "STORE_METADATA_17":
                                case 25:
                                    message.dimensions[i] = 25;
                                    break;
                                case "STORE_METADATA_18":
                                case 26:
                                    message.dimensions[i] = 26;
                                    break;
                                case "STORE_METADATA_19":
                                case 27:
                                    message.dimensions[i] = 27;
                                    break;
                                case "STORE_METADATA_20":
                                case 28:
                                    message.dimensions[i] = 28;
                                    break;
                                case "STORE_METADATA_21":
                                case 29:
                                    message.dimensions[i] = 29;
                                    break;
                                case "STORE_METADATA_22":
                                case 30:
                                    message.dimensions[i] = 30;
                                    break;
                                case "STORE_METADATA_23":
                                case 31:
                                    message.dimensions[i] = 31;
                                    break;
                                case "STORE_METADATA_24":
                                case 32:
                                    message.dimensions[i] = 32;
                                    break;
                                case "STORE_METADATA_25":
                                case 33:
                                    message.dimensions[i] = 33;
                                    break;
                                case "STORE_METADATA_26":
                                case 34:
                                    message.dimensions[i] = 34;
                                    break;
                                case "STORE_METADATA_27":
                                case 35:
                                    message.dimensions[i] = 35;
                                    break;
                                case "STORE_METADATA_28":
                                case 36:
                                    message.dimensions[i] = 36;
                                    break;
                                case "STORE_METADATA_29":
                                case 37:
                                    message.dimensions[i] = 37;
                                    break;
                                case "STORE_METADATA_30":
                                case 38:
                                    message.dimensions[i] = 38;
                                    break;
                                case "STORE_METADATA_31":
                                case 39:
                                    message.dimensions[i] = 39;
                                    break;
                                case "STORE_METADATA_32":
                                case 40:
                                    message.dimensions[i] = 40;
                                    break;
                                case "STORE_METADATA_33":
                                case 41:
                                    message.dimensions[i] = 41;
                                    break;
                                case "STORE_METADATA_34":
                                case 42:
                                    message.dimensions[i] = 42;
                                    break;
                                case "STORE_METADATA_35":
                                case 43:
                                    message.dimensions[i] = 43;
                                    break;
                                case "STORE_METADATA_36":
                                case 44:
                                    message.dimensions[i] = 44;
                                    break;
                                case "STORE_METADATA_37":
                                case 45:
                                    message.dimensions[i] = 45;
                                    break;
                                case "STORE_METADATA_38":
                                case 46:
                                    message.dimensions[i] = 46;
                                    break;
                                case "STORE_METADATA_39":
                                case 47:
                                    message.dimensions[i] = 47;
                                    break;
                                case "STORE_METADATA_40":
                                case 48:
                                    message.dimensions[i] = 48;
                                    break;
                                case "STORE_METADATA_41":
                                case 49:
                                    message.dimensions[i] = 49;
                                    break;
                                case "STORE_METADATA_42":
                                case 50:
                                    message.dimensions[i] = 50;
                                    break;
                                case "STORE_METADATA_43":
                                case 51:
                                    message.dimensions[i] = 51;
                                    break;
                                case "STORE_METADATA_44":
                                case 52:
                                    message.dimensions[i] = 52;
                                    break;
                                case "STORE_METADATA_45":
                                case 53:
                                    message.dimensions[i] = 53;
                                    break;
                                case "STORE_METADATA_46":
                                case 54:
                                    message.dimensions[i] = 54;
                                    break;
                                case "STORE_METADATA_47":
                                case 55:
                                    message.dimensions[i] = 55;
                                    break;
                                case "STORE_METADATA_48":
                                case 56:
                                    message.dimensions[i] = 56;
                                    break;
                                case "STORE_METADATA_49":
                                case 57:
                                    message.dimensions[i] = 57;
                                    break;
                                case "STORE_METADATA_50":
                                case 58:
                                    message.dimensions[i] = 58;
                                    break;
                                case "STORE_METADATA_51":
                                case 59:
                                    message.dimensions[i] = 59;
                                    break;
                                case "STORE_METADATA_52":
                                case 60:
                                    message.dimensions[i] = 60;
                                    break;
                                case "STORE_METADATA_53":
                                case 61:
                                    message.dimensions[i] = 61;
                                    break;
                                case "STORE_METADATA_54":
                                case 62:
                                    message.dimensions[i] = 62;
                                    break;
                                case "STORE_METADATA_55":
                                case 63:
                                    message.dimensions[i] = 63;
                                    break;
                                case "STORE_METADATA_56":
                                case 64:
                                    message.dimensions[i] = 64;
                                    break;
                                case "STORE_METADATA_57":
                                case 65:
                                    message.dimensions[i] = 65;
                                    break;
                                case "STORE_METADATA_58":
                                case 66:
                                    message.dimensions[i] = 66;
                                    break;
                                case "STORE_METADATA_59":
                                case 67:
                                    message.dimensions[i] = 67;
                                    break;
                                case "STORE_METADATA_60":
                                case 68:
                                    message.dimensions[i] = 68;
                                    break;
                                case "STORE_METADATA_61":
                                case 69:
                                    message.dimensions[i] = 69;
                                    break;
                                case "STORE_METADATA_62":
                                case 70:
                                    message.dimensions[i] = 70;
                                    break;
                                case "STORE_METADATA_63":
                                case 71:
                                    message.dimensions[i] = 71;
                                    break;
                                case "STORE_METADATA_64":
                                case 72:
                                    message.dimensions[i] = 72;
                                    break;
                                case "STORE_METADATA_65":
                                case 73:
                                    message.dimensions[i] = 73;
                                    break;
                                case "STORE_METADATA_66":
                                case 74:
                                    message.dimensions[i] = 74;
                                    break;
                                case "STORE_METADATA_67":
                                case 75:
                                    message.dimensions[i] = 75;
                                    break;
                                case "STORE_METADATA_68":
                                case 76:
                                    message.dimensions[i] = 76;
                                    break;
                                case "STORE_METADATA_69":
                                case 77:
                                    message.dimensions[i] = 77;
                                    break;
                                case "STORE_METADATA_70":
                                case 78:
                                    message.dimensions[i] = 78;
                                    break;
                                case "STORE_METADATA_71":
                                case 79:
                                    message.dimensions[i] = 79;
                                    break;
                                case "STORE_METADATA_72":
                                case 80:
                                    message.dimensions[i] = 80;
                                    break;
                                case "STORE_METADATA_73":
                                case 81:
                                    message.dimensions[i] = 81;
                                    break;
                                case "STORE_METADATA_74":
                                case 82:
                                    message.dimensions[i] = 82;
                                    break;
                                case "STORE_METADATA_75":
                                case 83:
                                    message.dimensions[i] = 83;
                                    break;
                                case "STORE_METADATA_76":
                                case 84:
                                    message.dimensions[i] = 84;
                                    break;
                                case "STORE_METADATA_77":
                                case 85:
                                    message.dimensions[i] = 85;
                                    break;
                                case "STORE_METADATA_78":
                                case 86:
                                    message.dimensions[i] = 86;
                                    break;
                                case "STORE_METADATA_79":
                                case 87:
                                    message.dimensions[i] = 87;
                                    break;
                                case "STORE_METADATA_80":
                                case 88:
                                    message.dimensions[i] = 88;
                                    break;
                                case "STORE_METADATA_81":
                                case 89:
                                    message.dimensions[i] = 89;
                                    break;
                                case "STORE_METADATA_82":
                                case 90:
                                    message.dimensions[i] = 90;
                                    break;
                                case "STORE_METADATA_83":
                                case 91:
                                    message.dimensions[i] = 91;
                                    break;
                                case "STORE_METADATA_84":
                                case 92:
                                    message.dimensions[i] = 92;
                                    break;
                                case "STORE_METADATA_85":
                                case 93:
                                    message.dimensions[i] = 93;
                                    break;
                                case "STORE_METADATA_86":
                                case 94:
                                    message.dimensions[i] = 94;
                                    break;
                                case "STORE_METADATA_87":
                                case 95:
                                    message.dimensions[i] = 95;
                                    break;
                                case "STORE_METADATA_88":
                                case 96:
                                    message.dimensions[i] = 96;
                                    break;
                                case "STORE_METADATA_89":
                                case 97:
                                    message.dimensions[i] = 97;
                                    break;
                                case "STORE_METADATA_90":
                                case 98:
                                    message.dimensions[i] = 98;
                                    break;
                                case "STORE_METADATA_91":
                                case 99:
                                    message.dimensions[i] = 99;
                                    break;
                                case "STORE_METADATA_92":
                                case 100:
                                    message.dimensions[i] = 100;
                                    break;
                                case "STORE_METADATA_93":
                                case 101:
                                    message.dimensions[i] = 101;
                                    break;
                                case "STORE_METADATA_94":
                                case 102:
                                    message.dimensions[i] = 102;
                                    break;
                                case "STORE_METADATA_95":
                                case 103:
                                    message.dimensions[i] = 103;
                                    break;
                                case "STORE_METADATA_96":
                                case 104:
                                    message.dimensions[i] = 104;
                                    break;
                                case "STORE_METADATA_97":
                                case 105:
                                    message.dimensions[i] = 105;
                                    break;
                                case "STORE_METADATA_98":
                                case 106:
                                    message.dimensions[i] = 106;
                                    break;
                                case "STORE_METADATA_99":
                                case 107:
                                    message.dimensions[i] = 107;
                                    break;
                                case "STORE_METADATA_100":
                                case 108:
                                    message.dimensions[i] = 108;
                                    break;
                                case "EVENT_PRIORITY":
                                case 109:
                                    message.dimensions[i] = 109;
                                    break;
                                }
                        }
                        if (object.metrics) {
                            if (!Array.isArray(object.metrics))
                                throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.metrics: array expected");
                            message.metrics = [];
                            for (var i = 0; i < object.metrics.length; ++i)
                                switch (object.metrics[i]) {
                                default:
                                case "UNKNOWN_METRIC":
                                case 0:
                                    message.metrics[i] = 0;
                                    break;
                                case "NUMBER_OF_STORE_EVENTS":
                                case 1:
                                    message.metrics[i] = 1;
                                    break;
                                }
                        }
                        if (object.reportFilter != null) {
                            if (typeof object.reportFilter !== "object")
                                throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.reportFilter: object expected");
                            message.reportFilter = $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.fromObject(object.reportFilter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchStoreEventAnalyticsReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest} message FetchStoreEventAnalyticsReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchStoreEventAnalyticsReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dates = [];
                            object.dimensions = [];
                            object.metrics = [];
                        }
                        if (options.defaults)
                            object.reportFilter = null;
                        if (message.dates && message.dates.length) {
                            object.dates = [];
                            for (var j = 0; j < message.dates.length; ++j)
                                object.dates[j] = message.dates[j];
                        }
                        if (message.dimensions && message.dimensions.length) {
                            object.dimensions = [];
                            for (var j = 0; j < message.dimensions.length; ++j)
                                object.dimensions[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventAnalyticsReport.Dimension[message.dimensions[j]] : message.dimensions[j];
                        }
                        if (message.metrics && message.metrics.length) {
                            object.metrics = [];
                            for (var j = 0; j < message.metrics.length; ++j)
                                object.metrics[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventAnalyticsReport.Metric[message.metrics[j]] : message.metrics[j];
                        }
                        if (message.reportFilter != null && message.hasOwnProperty("reportFilter"))
                            object.reportFilter = $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.toObject(message.reportFilter, options);
                        return object;
                    };
    
                    /**
                     * Converts this FetchStoreEventAnalyticsReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchStoreEventAnalyticsReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    FetchStoreEventAnalyticsReportRequest.Filter = (function() {
    
                        /**
                         * Properties of a Filter.
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                         * @interface IFilter
                         * @property {number|null} [companyId] Filter companyId
                         * @property {Array.<number>|null} [storeIds] Filter storeIds
                         * @property {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>|null} [statuses] Filter statuses
                         * @property {Array.<palexy.streaming.v1.StoreEventType>|null} [types] Filter types
                         * @property {boolean|null} [isTestEvent] Filter isTestEvent
                         * @property {Array.<palexy.streaming.v1.StoreEvent.Priority>|null} [priorities] Filter priorities
                         */
    
                        /**
                         * Constructs a new Filter.
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest
                         * @classdesc Represents a Filter.
                         * @implements IFilter
                         * @constructor
                         * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter=} [properties] Properties to set
                         */
                        function Filter(properties) {
                            this.storeIds = [];
                            this.statuses = [];
                            this.types = [];
                            this.priorities = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Filter companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Filter storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * Filter statuses.
                         * @member {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>} statuses
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.statuses = $util.emptyArray;
    
                        /**
                         * Filter types.
                         * @member {Array.<palexy.streaming.v1.StoreEventType>} types
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.types = $util.emptyArray;
    
                        /**
                         * Filter isTestEvent.
                         * @member {boolean} isTestEvent
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.isTestEvent = false;
    
                        /**
                         * Filter priorities.
                         * @member {Array.<palexy.streaming.v1.StoreEvent.Priority>} priorities
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.priorities = $util.emptyArray;
    
                        /**
                         * Creates a new Filter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter} Filter instance
                         */
                        Filter.create = function create(properties) {
                            return new Filter(properties);
                        };
    
                        /**
                         * Encodes the specified Filter message. Does not implicitly {@link palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter} message Filter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Filter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.statuses != null && message.statuses.length) {
                                writer.uint32(/* id 3, wireType 2 =*/26).fork();
                                for (var i = 0; i < message.statuses.length; ++i)
                                    writer.int32(message.statuses[i]);
                                writer.ldelim();
                            }
                            if (message.types != null && message.types.length) {
                                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                                for (var i = 0; i < message.types.length; ++i)
                                    writer.int32(message.types[i]);
                                writer.ldelim();
                            }
                            if (message.isTestEvent != null && Object.hasOwnProperty.call(message, "isTestEvent"))
                                writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isTestEvent);
                            if (message.priorities != null && message.priorities.length) {
                                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                                for (var i = 0; i < message.priorities.length; ++i)
                                    writer.int32(message.priorities[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Filter message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.IFilter} message Filter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Filter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Filter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter} Filter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Filter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.companyId = reader.int64();
                                    break;
                                case 2:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 3:
                                    if (!(message.statuses && message.statuses.length))
                                        message.statuses = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.statuses.push(reader.int32());
                                    } else
                                        message.statuses.push(reader.int32());
                                    break;
                                case 4:
                                    if (!(message.types && message.types.length))
                                        message.types = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.types.push(reader.int32());
                                    } else
                                        message.types.push(reader.int32());
                                    break;
                                case 5:
                                    message.isTestEvent = reader.bool();
                                    break;
                                case 6:
                                    if (!(message.priorities && message.priorities.length))
                                        message.priorities = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.priorities.push(reader.int32());
                                    } else
                                        message.priorities.push(reader.int32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Filter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter} Filter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Filter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Filter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Filter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.statuses != null && message.hasOwnProperty("statuses")) {
                                if (!Array.isArray(message.statuses))
                                    return "statuses: array expected";
                                for (var i = 0; i < message.statuses.length; ++i)
                                    switch (message.statuses[i]) {
                                    default:
                                        return "statuses: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            if (message.types != null && message.hasOwnProperty("types")) {
                                if (!Array.isArray(message.types))
                                    return "types: array expected";
                                for (var i = 0; i < message.types.length; ++i)
                                    switch (message.types[i]) {
                                    default:
                                        return "types: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                    case 5:
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 9:
                                    case 10:
                                    case 11:
                                    case 12:
                                    case 13:
                                    case 14:
                                    case 15:
                                    case 16:
                                    case 17:
                                    case 18:
                                    case 19:
                                        break;
                                    }
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                if (typeof message.isTestEvent !== "boolean")
                                    return "isTestEvent: boolean expected";
                            if (message.priorities != null && message.hasOwnProperty("priorities")) {
                                if (!Array.isArray(message.priorities))
                                    return "priorities: array expected";
                                for (var i = 0; i < message.priorities.length; ++i)
                                    switch (message.priorities[i]) {
                                    default:
                                        return "priorities: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Filter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter} Filter
                         */
                        Filter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter)
                                return object;
                            var message = new $root.palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter();
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.statuses) {
                                if (!Array.isArray(object.statuses))
                                    throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.statuses: array expected");
                                message.statuses = [];
                                for (var i = 0; i < object.statuses.length; ++i)
                                    switch (object.statuses[i]) {
                                    default:
                                    case "UNKNOWN":
                                    case 0:
                                        message.statuses[i] = 0;
                                        break;
                                    case "NOT_REVIEWED":
                                    case 1:
                                        message.statuses[i] = 1;
                                        break;
                                    case "APPROVED":
                                    case 2:
                                        message.statuses[i] = 2;
                                        break;
                                    case "REJECTED":
                                    case 3:
                                        message.statuses[i] = 3;
                                        break;
                                    }
                            }
                            if (object.types) {
                                if (!Array.isArray(object.types))
                                    throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.types: array expected");
                                message.types = [];
                                for (var i = 0; i < object.types.length; ++i)
                                    switch (object.types[i]) {
                                    default:
                                    case "UNKNOWN_STORE_EVENT_TYPE":
                                    case 0:
                                        message.types[i] = 0;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION":
                                    case 1:
                                        message.types[i] = 1;
                                        break;
                                    case "SUSPICIOUS_CASHIER_ACTIVITY":
                                    case 2:
                                        message.types[i] = 2;
                                        break;
                                    case "SOP_NON_COMPLIANCE":
                                    case 3:
                                        message.types[i] = 3;
                                        break;
                                    case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                                    case 4:
                                        message.types[i] = 4;
                                        break;
                                    case "STAFF_GATHERING":
                                    case 5:
                                        message.types[i] = 5;
                                        break;
                                    case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                                    case 6:
                                        message.types[i] = 6;
                                        break;
                                    case "CUSTOMER_NEEDS_ASSISTANCE":
                                    case 7:
                                        message.types[i] = 7;
                                        break;
                                    case "STAFF_NOT_WEAR_GLOVE":
                                    case 8:
                                        message.types[i] = 8;
                                        break;
                                    case "NOT_GREETED_ON_TIME":
                                    case 9:
                                        message.types[i] = 9;
                                        break;
                                    case "STAFF_MISSING":
                                    case 10:
                                        message.types[i] = 10;
                                        break;
                                    case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                                    case 11:
                                        message.types[i] = 11;
                                        break;
                                    case "HIGH_TRAFFIC_CHECKOUT":
                                    case 12:
                                        message.types[i] = 12;
                                        break;
                                    case "LONG_TOTAL_SERVICE_TIME":
                                    case 13:
                                        message.types[i] = 13;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                                    case 14:
                                        message.types[i] = 14;
                                        break;
                                    case "LATE_TABLE_CLEANING":
                                    case 15:
                                        message.types[i] = 15;
                                        break;
                                    case "SUSPICIOUS_BILL_CANCELLATION":
                                    case 16:
                                        message.types[i] = 16;
                                        break;
                                    case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                                    case 17:
                                        message.types[i] = 17;
                                        break;
                                    case "LONG_QUEUE":
                                    case 18:
                                        message.types[i] = 18;
                                        break;
                                    case "LONG_CHECKOUT_TIME":
                                    case 19:
                                        message.types[i] = 19;
                                        break;
                                    }
                            }
                            if (object.isTestEvent != null)
                                message.isTestEvent = Boolean(object.isTestEvent);
                            if (object.priorities) {
                                if (!Array.isArray(object.priorities))
                                    throw TypeError(".palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter.priorities: array expected");
                                message.priorities = [];
                                for (var i = 0; i < object.priorities.length; ++i)
                                    switch (object.priorities[i]) {
                                    default:
                                    case "PRIORITY_UNKNOWN":
                                    case 0:
                                        message.priorities[i] = 0;
                                        break;
                                    case "LOW":
                                    case 1:
                                        message.priorities[i] = 1;
                                        break;
                                    case "MEDIUM":
                                    case 2:
                                        message.priorities[i] = 2;
                                        break;
                                    case "HIGH":
                                    case 3:
                                        message.priorities[i] = 3;
                                        break;
                                    }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Filter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter} message Filter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Filter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.storeIds = [];
                                object.statuses = [];
                                object.types = [];
                                object.priorities = [];
                            }
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                                object.isTestEvent = false;
                            }
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.statuses && message.statuses.length) {
                                object.statuses = [];
                                for (var j = 0; j < message.statuses.length; ++j)
                                    object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.StoreEventStatus[message.statuses[j]] : message.statuses[j];
                            }
                            if (message.types && message.types.length) {
                                object.types = [];
                                for (var j = 0; j < message.types.length; ++j)
                                    object.types[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.types[j]] : message.types[j];
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                object.isTestEvent = message.isTestEvent;
                            if (message.priorities && message.priorities.length) {
                                object.priorities = [];
                                for (var j = 0; j < message.priorities.length; ++j)
                                    object.priorities[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.Priority[message.priorities[j]] : message.priorities[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Filter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.FetchStoreEventAnalyticsReportRequest.Filter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Filter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Filter;
                    })();
    
                    return FetchStoreEventAnalyticsReportRequest;
                })();
    
                v1.StoreEventAnalyticsReport = (function() {
    
                    /**
                     * Properties of a StoreEventAnalyticsReport.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreEventAnalyticsReport
                     * @property {Array.<string>|null} [dates] StoreEventAnalyticsReport dates
                     * @property {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Dimension>|null} [dimensions] StoreEventAnalyticsReport dimensions
                     * @property {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Metric>|null} [metrics] StoreEventAnalyticsReport metrics
                     * @property {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.IRow>|null} [rows] StoreEventAnalyticsReport rows
                     */
    
                    /**
                     * Constructs a new StoreEventAnalyticsReport.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEventAnalyticsReport.
                     * @implements IStoreEventAnalyticsReport
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreEventAnalyticsReport=} [properties] Properties to set
                     */
                    function StoreEventAnalyticsReport(properties) {
                        this.dates = [];
                        this.dimensions = [];
                        this.metrics = [];
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEventAnalyticsReport dates.
                     * @member {Array.<string>} dates
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @instance
                     */
                    StoreEventAnalyticsReport.prototype.dates = $util.emptyArray;
    
                    /**
                     * StoreEventAnalyticsReport dimensions.
                     * @member {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Dimension>} dimensions
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @instance
                     */
                    StoreEventAnalyticsReport.prototype.dimensions = $util.emptyArray;
    
                    /**
                     * StoreEventAnalyticsReport metrics.
                     * @member {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.Metric>} metrics
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @instance
                     */
                    StoreEventAnalyticsReport.prototype.metrics = $util.emptyArray;
    
                    /**
                     * StoreEventAnalyticsReport rows.
                     * @member {Array.<palexy.streaming.v1.StoreEventAnalyticsReport.IRow>} rows
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @instance
                     */
                    StoreEventAnalyticsReport.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new StoreEventAnalyticsReport instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventAnalyticsReport=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreEventAnalyticsReport} StoreEventAnalyticsReport instance
                     */
                    StoreEventAnalyticsReport.create = function create(properties) {
                        return new StoreEventAnalyticsReport(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEventAnalyticsReport message. Does not implicitly {@link palexy.streaming.v1.StoreEventAnalyticsReport.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventAnalyticsReport} message StoreEventAnalyticsReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventAnalyticsReport.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dates != null && message.dates.length)
                            for (var i = 0; i < message.dates.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dates[i]);
                        if (message.dimensions != null && message.dimensions.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.dimensions.length; ++i)
                                writer.int32(message.dimensions[i]);
                            writer.ldelim();
                        }
                        if (message.metrics != null && message.metrics.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.metrics.length; ++i)
                                writer.int32(message.metrics[i]);
                            writer.ldelim();
                        }
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row.encode(message.rows[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEventAnalyticsReport message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEventAnalyticsReport.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventAnalyticsReport} message StoreEventAnalyticsReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventAnalyticsReport.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEventAnalyticsReport message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreEventAnalyticsReport} StoreEventAnalyticsReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventAnalyticsReport.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEventAnalyticsReport();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dates && message.dates.length))
                                    message.dates = [];
                                message.dates.push(reader.string());
                                break;
                            case 2:
                                if (!(message.dimensions && message.dimensions.length))
                                    message.dimensions = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.dimensions.push(reader.int32());
                                } else
                                    message.dimensions.push(reader.int32());
                                break;
                            case 3:
                                if (!(message.metrics && message.metrics.length))
                                    message.metrics = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.metrics.push(reader.int32());
                                } else
                                    message.metrics.push(reader.int32());
                                break;
                            case 4:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.streaming.v1.StoreEventAnalyticsReport.Row.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEventAnalyticsReport message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreEventAnalyticsReport} StoreEventAnalyticsReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventAnalyticsReport.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEventAnalyticsReport message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEventAnalyticsReport.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dates != null && message.hasOwnProperty("dates")) {
                            if (!Array.isArray(message.dates))
                                return "dates: array expected";
                            for (var i = 0; i < message.dates.length; ++i)
                                if (!$util.isString(message.dates[i]))
                                    return "dates: string[] expected";
                        }
                        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                            if (!Array.isArray(message.dimensions))
                                return "dimensions: array expected";
                            for (var i = 0; i < message.dimensions.length; ++i)
                                switch (message.dimensions[i]) {
                                default:
                                    return "dimensions: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 18:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 19:
                                case 20:
                                case 21:
                                case 22:
                                case 23:
                                case 24:
                                case 25:
                                case 26:
                                case 27:
                                case 28:
                                case 29:
                                case 30:
                                case 31:
                                case 32:
                                case 33:
                                case 34:
                                case 35:
                                case 36:
                                case 37:
                                case 38:
                                case 39:
                                case 40:
                                case 41:
                                case 42:
                                case 43:
                                case 44:
                                case 45:
                                case 46:
                                case 47:
                                case 48:
                                case 49:
                                case 50:
                                case 51:
                                case 52:
                                case 53:
                                case 54:
                                case 55:
                                case 56:
                                case 57:
                                case 58:
                                case 59:
                                case 60:
                                case 61:
                                case 62:
                                case 63:
                                case 64:
                                case 65:
                                case 66:
                                case 67:
                                case 68:
                                case 69:
                                case 70:
                                case 71:
                                case 72:
                                case 73:
                                case 74:
                                case 75:
                                case 76:
                                case 77:
                                case 78:
                                case 79:
                                case 80:
                                case 81:
                                case 82:
                                case 83:
                                case 84:
                                case 85:
                                case 86:
                                case 87:
                                case 88:
                                case 89:
                                case 90:
                                case 91:
                                case 92:
                                case 93:
                                case 94:
                                case 95:
                                case 96:
                                case 97:
                                case 98:
                                case 99:
                                case 100:
                                case 101:
                                case 102:
                                case 103:
                                case 104:
                                case 105:
                                case 106:
                                case 107:
                                case 108:
                                case 109:
                                    break;
                                }
                        }
                        if (message.metrics != null && message.hasOwnProperty("metrics")) {
                            if (!Array.isArray(message.metrics))
                                return "metrics: array expected";
                            for (var i = 0; i < message.metrics.length; ++i)
                                switch (message.metrics[i]) {
                                default:
                                    return "metrics: enum value[] expected";
                                case 0:
                                case 1:
                                    break;
                                }
                        }
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreEventAnalyticsReport message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreEventAnalyticsReport} StoreEventAnalyticsReport
                     */
                    StoreEventAnalyticsReport.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreEventAnalyticsReport)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreEventAnalyticsReport();
                        if (object.dates) {
                            if (!Array.isArray(object.dates))
                                throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.dates: array expected");
                            message.dates = [];
                            for (var i = 0; i < object.dates.length; ++i)
                                message.dates[i] = String(object.dates[i]);
                        }
                        if (object.dimensions) {
                            if (!Array.isArray(object.dimensions))
                                throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.dimensions: array expected");
                            message.dimensions = [];
                            for (var i = 0; i < object.dimensions.length; ++i)
                                switch (object.dimensions[i]) {
                                default:
                                case "UNKNOWN_DIMENSION":
                                case 0:
                                    message.dimensions[i] = 0;
                                    break;
                                case "STATUS":
                                case 1:
                                    message.dimensions[i] = 1;
                                    break;
                                case "EVENT_TYPE":
                                case 2:
                                    message.dimensions[i] = 2;
                                    break;
                                case "NTH_DAY":
                                case 3:
                                    message.dimensions[i] = 3;
                                    break;
                                case "NTH_WEEK":
                                case 4:
                                    message.dimensions[i] = 4;
                                    break;
                                case "CUSTOM_NTH_WEEK":
                                case 18:
                                    message.dimensions[i] = 18;
                                    break;
                                case "NTH_MONTH":
                                case 5:
                                    message.dimensions[i] = 5;
                                    break;
                                case "STORE_NAME":
                                case 6:
                                    message.dimensions[i] = 6;
                                    break;
                                case "NTH_QUARTER":
                                case 7:
                                    message.dimensions[i] = 7;
                                    break;
                                case "STORE_METADATA_1":
                                case 8:
                                    message.dimensions[i] = 8;
                                    break;
                                case "STORE_METADATA_2":
                                case 9:
                                    message.dimensions[i] = 9;
                                    break;
                                case "STORE_METADATA_3":
                                case 10:
                                    message.dimensions[i] = 10;
                                    break;
                                case "STORE_METADATA_4":
                                case 11:
                                    message.dimensions[i] = 11;
                                    break;
                                case "STORE_METADATA_5":
                                case 12:
                                    message.dimensions[i] = 12;
                                    break;
                                case "STORE_METADATA_6":
                                case 13:
                                    message.dimensions[i] = 13;
                                    break;
                                case "STORE_METADATA_7":
                                case 14:
                                    message.dimensions[i] = 14;
                                    break;
                                case "STORE_METADATA_8":
                                case 15:
                                    message.dimensions[i] = 15;
                                    break;
                                case "STORE_METADATA_9":
                                case 16:
                                    message.dimensions[i] = 16;
                                    break;
                                case "STORE_METADATA_10":
                                case 17:
                                    message.dimensions[i] = 17;
                                    break;
                                case "STORE_METADATA_11":
                                case 19:
                                    message.dimensions[i] = 19;
                                    break;
                                case "STORE_METADATA_12":
                                case 20:
                                    message.dimensions[i] = 20;
                                    break;
                                case "STORE_METADATA_13":
                                case 21:
                                    message.dimensions[i] = 21;
                                    break;
                                case "STORE_METADATA_14":
                                case 22:
                                    message.dimensions[i] = 22;
                                    break;
                                case "STORE_METADATA_15":
                                case 23:
                                    message.dimensions[i] = 23;
                                    break;
                                case "STORE_METADATA_16":
                                case 24:
                                    message.dimensions[i] = 24;
                                    break;
                                case "STORE_METADATA_17":
                                case 25:
                                    message.dimensions[i] = 25;
                                    break;
                                case "STORE_METADATA_18":
                                case 26:
                                    message.dimensions[i] = 26;
                                    break;
                                case "STORE_METADATA_19":
                                case 27:
                                    message.dimensions[i] = 27;
                                    break;
                                case "STORE_METADATA_20":
                                case 28:
                                    message.dimensions[i] = 28;
                                    break;
                                case "STORE_METADATA_21":
                                case 29:
                                    message.dimensions[i] = 29;
                                    break;
                                case "STORE_METADATA_22":
                                case 30:
                                    message.dimensions[i] = 30;
                                    break;
                                case "STORE_METADATA_23":
                                case 31:
                                    message.dimensions[i] = 31;
                                    break;
                                case "STORE_METADATA_24":
                                case 32:
                                    message.dimensions[i] = 32;
                                    break;
                                case "STORE_METADATA_25":
                                case 33:
                                    message.dimensions[i] = 33;
                                    break;
                                case "STORE_METADATA_26":
                                case 34:
                                    message.dimensions[i] = 34;
                                    break;
                                case "STORE_METADATA_27":
                                case 35:
                                    message.dimensions[i] = 35;
                                    break;
                                case "STORE_METADATA_28":
                                case 36:
                                    message.dimensions[i] = 36;
                                    break;
                                case "STORE_METADATA_29":
                                case 37:
                                    message.dimensions[i] = 37;
                                    break;
                                case "STORE_METADATA_30":
                                case 38:
                                    message.dimensions[i] = 38;
                                    break;
                                case "STORE_METADATA_31":
                                case 39:
                                    message.dimensions[i] = 39;
                                    break;
                                case "STORE_METADATA_32":
                                case 40:
                                    message.dimensions[i] = 40;
                                    break;
                                case "STORE_METADATA_33":
                                case 41:
                                    message.dimensions[i] = 41;
                                    break;
                                case "STORE_METADATA_34":
                                case 42:
                                    message.dimensions[i] = 42;
                                    break;
                                case "STORE_METADATA_35":
                                case 43:
                                    message.dimensions[i] = 43;
                                    break;
                                case "STORE_METADATA_36":
                                case 44:
                                    message.dimensions[i] = 44;
                                    break;
                                case "STORE_METADATA_37":
                                case 45:
                                    message.dimensions[i] = 45;
                                    break;
                                case "STORE_METADATA_38":
                                case 46:
                                    message.dimensions[i] = 46;
                                    break;
                                case "STORE_METADATA_39":
                                case 47:
                                    message.dimensions[i] = 47;
                                    break;
                                case "STORE_METADATA_40":
                                case 48:
                                    message.dimensions[i] = 48;
                                    break;
                                case "STORE_METADATA_41":
                                case 49:
                                    message.dimensions[i] = 49;
                                    break;
                                case "STORE_METADATA_42":
                                case 50:
                                    message.dimensions[i] = 50;
                                    break;
                                case "STORE_METADATA_43":
                                case 51:
                                    message.dimensions[i] = 51;
                                    break;
                                case "STORE_METADATA_44":
                                case 52:
                                    message.dimensions[i] = 52;
                                    break;
                                case "STORE_METADATA_45":
                                case 53:
                                    message.dimensions[i] = 53;
                                    break;
                                case "STORE_METADATA_46":
                                case 54:
                                    message.dimensions[i] = 54;
                                    break;
                                case "STORE_METADATA_47":
                                case 55:
                                    message.dimensions[i] = 55;
                                    break;
                                case "STORE_METADATA_48":
                                case 56:
                                    message.dimensions[i] = 56;
                                    break;
                                case "STORE_METADATA_49":
                                case 57:
                                    message.dimensions[i] = 57;
                                    break;
                                case "STORE_METADATA_50":
                                case 58:
                                    message.dimensions[i] = 58;
                                    break;
                                case "STORE_METADATA_51":
                                case 59:
                                    message.dimensions[i] = 59;
                                    break;
                                case "STORE_METADATA_52":
                                case 60:
                                    message.dimensions[i] = 60;
                                    break;
                                case "STORE_METADATA_53":
                                case 61:
                                    message.dimensions[i] = 61;
                                    break;
                                case "STORE_METADATA_54":
                                case 62:
                                    message.dimensions[i] = 62;
                                    break;
                                case "STORE_METADATA_55":
                                case 63:
                                    message.dimensions[i] = 63;
                                    break;
                                case "STORE_METADATA_56":
                                case 64:
                                    message.dimensions[i] = 64;
                                    break;
                                case "STORE_METADATA_57":
                                case 65:
                                    message.dimensions[i] = 65;
                                    break;
                                case "STORE_METADATA_58":
                                case 66:
                                    message.dimensions[i] = 66;
                                    break;
                                case "STORE_METADATA_59":
                                case 67:
                                    message.dimensions[i] = 67;
                                    break;
                                case "STORE_METADATA_60":
                                case 68:
                                    message.dimensions[i] = 68;
                                    break;
                                case "STORE_METADATA_61":
                                case 69:
                                    message.dimensions[i] = 69;
                                    break;
                                case "STORE_METADATA_62":
                                case 70:
                                    message.dimensions[i] = 70;
                                    break;
                                case "STORE_METADATA_63":
                                case 71:
                                    message.dimensions[i] = 71;
                                    break;
                                case "STORE_METADATA_64":
                                case 72:
                                    message.dimensions[i] = 72;
                                    break;
                                case "STORE_METADATA_65":
                                case 73:
                                    message.dimensions[i] = 73;
                                    break;
                                case "STORE_METADATA_66":
                                case 74:
                                    message.dimensions[i] = 74;
                                    break;
                                case "STORE_METADATA_67":
                                case 75:
                                    message.dimensions[i] = 75;
                                    break;
                                case "STORE_METADATA_68":
                                case 76:
                                    message.dimensions[i] = 76;
                                    break;
                                case "STORE_METADATA_69":
                                case 77:
                                    message.dimensions[i] = 77;
                                    break;
                                case "STORE_METADATA_70":
                                case 78:
                                    message.dimensions[i] = 78;
                                    break;
                                case "STORE_METADATA_71":
                                case 79:
                                    message.dimensions[i] = 79;
                                    break;
                                case "STORE_METADATA_72":
                                case 80:
                                    message.dimensions[i] = 80;
                                    break;
                                case "STORE_METADATA_73":
                                case 81:
                                    message.dimensions[i] = 81;
                                    break;
                                case "STORE_METADATA_74":
                                case 82:
                                    message.dimensions[i] = 82;
                                    break;
                                case "STORE_METADATA_75":
                                case 83:
                                    message.dimensions[i] = 83;
                                    break;
                                case "STORE_METADATA_76":
                                case 84:
                                    message.dimensions[i] = 84;
                                    break;
                                case "STORE_METADATA_77":
                                case 85:
                                    message.dimensions[i] = 85;
                                    break;
                                case "STORE_METADATA_78":
                                case 86:
                                    message.dimensions[i] = 86;
                                    break;
                                case "STORE_METADATA_79":
                                case 87:
                                    message.dimensions[i] = 87;
                                    break;
                                case "STORE_METADATA_80":
                                case 88:
                                    message.dimensions[i] = 88;
                                    break;
                                case "STORE_METADATA_81":
                                case 89:
                                    message.dimensions[i] = 89;
                                    break;
                                case "STORE_METADATA_82":
                                case 90:
                                    message.dimensions[i] = 90;
                                    break;
                                case "STORE_METADATA_83":
                                case 91:
                                    message.dimensions[i] = 91;
                                    break;
                                case "STORE_METADATA_84":
                                case 92:
                                    message.dimensions[i] = 92;
                                    break;
                                case "STORE_METADATA_85":
                                case 93:
                                    message.dimensions[i] = 93;
                                    break;
                                case "STORE_METADATA_86":
                                case 94:
                                    message.dimensions[i] = 94;
                                    break;
                                case "STORE_METADATA_87":
                                case 95:
                                    message.dimensions[i] = 95;
                                    break;
                                case "STORE_METADATA_88":
                                case 96:
                                    message.dimensions[i] = 96;
                                    break;
                                case "STORE_METADATA_89":
                                case 97:
                                    message.dimensions[i] = 97;
                                    break;
                                case "STORE_METADATA_90":
                                case 98:
                                    message.dimensions[i] = 98;
                                    break;
                                case "STORE_METADATA_91":
                                case 99:
                                    message.dimensions[i] = 99;
                                    break;
                                case "STORE_METADATA_92":
                                case 100:
                                    message.dimensions[i] = 100;
                                    break;
                                case "STORE_METADATA_93":
                                case 101:
                                    message.dimensions[i] = 101;
                                    break;
                                case "STORE_METADATA_94":
                                case 102:
                                    message.dimensions[i] = 102;
                                    break;
                                case "STORE_METADATA_95":
                                case 103:
                                    message.dimensions[i] = 103;
                                    break;
                                case "STORE_METADATA_96":
                                case 104:
                                    message.dimensions[i] = 104;
                                    break;
                                case "STORE_METADATA_97":
                                case 105:
                                    message.dimensions[i] = 105;
                                    break;
                                case "STORE_METADATA_98":
                                case 106:
                                    message.dimensions[i] = 106;
                                    break;
                                case "STORE_METADATA_99":
                                case 107:
                                    message.dimensions[i] = 107;
                                    break;
                                case "STORE_METADATA_100":
                                case 108:
                                    message.dimensions[i] = 108;
                                    break;
                                case "EVENT_PRIORITY":
                                case 109:
                                    message.dimensions[i] = 109;
                                    break;
                                }
                        }
                        if (object.metrics) {
                            if (!Array.isArray(object.metrics))
                                throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.metrics: array expected");
                            message.metrics = [];
                            for (var i = 0; i < object.metrics.length; ++i)
                                switch (object.metrics[i]) {
                                default:
                                case "UNKNOWN_METRIC":
                                case 0:
                                    message.metrics[i] = 0;
                                    break;
                                case "NUMBER_OF_STORE_EVENTS":
                                case 1:
                                    message.metrics[i] = 1;
                                    break;
                                }
                        }
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.rows: object expected");
                                message.rows[i] = $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEventAnalyticsReport message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @static
                     * @param {palexy.streaming.v1.StoreEventAnalyticsReport} message StoreEventAnalyticsReport
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEventAnalyticsReport.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dates = [];
                            object.dimensions = [];
                            object.metrics = [];
                            object.rows = [];
                        }
                        if (message.dates && message.dates.length) {
                            object.dates = [];
                            for (var j = 0; j < message.dates.length; ++j)
                                object.dates[j] = message.dates[j];
                        }
                        if (message.dimensions && message.dimensions.length) {
                            object.dimensions = [];
                            for (var j = 0; j < message.dimensions.length; ++j)
                                object.dimensions[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventAnalyticsReport.Dimension[message.dimensions[j]] : message.dimensions[j];
                        }
                        if (message.metrics && message.metrics.length) {
                            object.metrics = [];
                            for (var j = 0; j < message.metrics.length; ++j)
                                object.metrics[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventAnalyticsReport.Metric[message.metrics[j]] : message.metrics[j];
                        }
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreEventAnalyticsReport to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEventAnalyticsReport.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Dimension enum.
                     * @name palexy.streaming.v1.StoreEventAnalyticsReport.Dimension
                     * @enum {number}
                     * @property {number} UNKNOWN_DIMENSION=0 UNKNOWN_DIMENSION value
                     * @property {number} STATUS=1 STATUS value
                     * @property {number} EVENT_TYPE=2 EVENT_TYPE value
                     * @property {number} NTH_DAY=3 NTH_DAY value
                     * @property {number} NTH_WEEK=4 NTH_WEEK value
                     * @property {number} CUSTOM_NTH_WEEK=18 CUSTOM_NTH_WEEK value
                     * @property {number} NTH_MONTH=5 NTH_MONTH value
                     * @property {number} STORE_NAME=6 STORE_NAME value
                     * @property {number} NTH_QUARTER=7 NTH_QUARTER value
                     * @property {number} STORE_METADATA_1=8 STORE_METADATA_1 value
                     * @property {number} STORE_METADATA_2=9 STORE_METADATA_2 value
                     * @property {number} STORE_METADATA_3=10 STORE_METADATA_3 value
                     * @property {number} STORE_METADATA_4=11 STORE_METADATA_4 value
                     * @property {number} STORE_METADATA_5=12 STORE_METADATA_5 value
                     * @property {number} STORE_METADATA_6=13 STORE_METADATA_6 value
                     * @property {number} STORE_METADATA_7=14 STORE_METADATA_7 value
                     * @property {number} STORE_METADATA_8=15 STORE_METADATA_8 value
                     * @property {number} STORE_METADATA_9=16 STORE_METADATA_9 value
                     * @property {number} STORE_METADATA_10=17 STORE_METADATA_10 value
                     * @property {number} STORE_METADATA_11=19 STORE_METADATA_11 value
                     * @property {number} STORE_METADATA_12=20 STORE_METADATA_12 value
                     * @property {number} STORE_METADATA_13=21 STORE_METADATA_13 value
                     * @property {number} STORE_METADATA_14=22 STORE_METADATA_14 value
                     * @property {number} STORE_METADATA_15=23 STORE_METADATA_15 value
                     * @property {number} STORE_METADATA_16=24 STORE_METADATA_16 value
                     * @property {number} STORE_METADATA_17=25 STORE_METADATA_17 value
                     * @property {number} STORE_METADATA_18=26 STORE_METADATA_18 value
                     * @property {number} STORE_METADATA_19=27 STORE_METADATA_19 value
                     * @property {number} STORE_METADATA_20=28 STORE_METADATA_20 value
                     * @property {number} STORE_METADATA_21=29 STORE_METADATA_21 value
                     * @property {number} STORE_METADATA_22=30 STORE_METADATA_22 value
                     * @property {number} STORE_METADATA_23=31 STORE_METADATA_23 value
                     * @property {number} STORE_METADATA_24=32 STORE_METADATA_24 value
                     * @property {number} STORE_METADATA_25=33 STORE_METADATA_25 value
                     * @property {number} STORE_METADATA_26=34 STORE_METADATA_26 value
                     * @property {number} STORE_METADATA_27=35 STORE_METADATA_27 value
                     * @property {number} STORE_METADATA_28=36 STORE_METADATA_28 value
                     * @property {number} STORE_METADATA_29=37 STORE_METADATA_29 value
                     * @property {number} STORE_METADATA_30=38 STORE_METADATA_30 value
                     * @property {number} STORE_METADATA_31=39 STORE_METADATA_31 value
                     * @property {number} STORE_METADATA_32=40 STORE_METADATA_32 value
                     * @property {number} STORE_METADATA_33=41 STORE_METADATA_33 value
                     * @property {number} STORE_METADATA_34=42 STORE_METADATA_34 value
                     * @property {number} STORE_METADATA_35=43 STORE_METADATA_35 value
                     * @property {number} STORE_METADATA_36=44 STORE_METADATA_36 value
                     * @property {number} STORE_METADATA_37=45 STORE_METADATA_37 value
                     * @property {number} STORE_METADATA_38=46 STORE_METADATA_38 value
                     * @property {number} STORE_METADATA_39=47 STORE_METADATA_39 value
                     * @property {number} STORE_METADATA_40=48 STORE_METADATA_40 value
                     * @property {number} STORE_METADATA_41=49 STORE_METADATA_41 value
                     * @property {number} STORE_METADATA_42=50 STORE_METADATA_42 value
                     * @property {number} STORE_METADATA_43=51 STORE_METADATA_43 value
                     * @property {number} STORE_METADATA_44=52 STORE_METADATA_44 value
                     * @property {number} STORE_METADATA_45=53 STORE_METADATA_45 value
                     * @property {number} STORE_METADATA_46=54 STORE_METADATA_46 value
                     * @property {number} STORE_METADATA_47=55 STORE_METADATA_47 value
                     * @property {number} STORE_METADATA_48=56 STORE_METADATA_48 value
                     * @property {number} STORE_METADATA_49=57 STORE_METADATA_49 value
                     * @property {number} STORE_METADATA_50=58 STORE_METADATA_50 value
                     * @property {number} STORE_METADATA_51=59 STORE_METADATA_51 value
                     * @property {number} STORE_METADATA_52=60 STORE_METADATA_52 value
                     * @property {number} STORE_METADATA_53=61 STORE_METADATA_53 value
                     * @property {number} STORE_METADATA_54=62 STORE_METADATA_54 value
                     * @property {number} STORE_METADATA_55=63 STORE_METADATA_55 value
                     * @property {number} STORE_METADATA_56=64 STORE_METADATA_56 value
                     * @property {number} STORE_METADATA_57=65 STORE_METADATA_57 value
                     * @property {number} STORE_METADATA_58=66 STORE_METADATA_58 value
                     * @property {number} STORE_METADATA_59=67 STORE_METADATA_59 value
                     * @property {number} STORE_METADATA_60=68 STORE_METADATA_60 value
                     * @property {number} STORE_METADATA_61=69 STORE_METADATA_61 value
                     * @property {number} STORE_METADATA_62=70 STORE_METADATA_62 value
                     * @property {number} STORE_METADATA_63=71 STORE_METADATA_63 value
                     * @property {number} STORE_METADATA_64=72 STORE_METADATA_64 value
                     * @property {number} STORE_METADATA_65=73 STORE_METADATA_65 value
                     * @property {number} STORE_METADATA_66=74 STORE_METADATA_66 value
                     * @property {number} STORE_METADATA_67=75 STORE_METADATA_67 value
                     * @property {number} STORE_METADATA_68=76 STORE_METADATA_68 value
                     * @property {number} STORE_METADATA_69=77 STORE_METADATA_69 value
                     * @property {number} STORE_METADATA_70=78 STORE_METADATA_70 value
                     * @property {number} STORE_METADATA_71=79 STORE_METADATA_71 value
                     * @property {number} STORE_METADATA_72=80 STORE_METADATA_72 value
                     * @property {number} STORE_METADATA_73=81 STORE_METADATA_73 value
                     * @property {number} STORE_METADATA_74=82 STORE_METADATA_74 value
                     * @property {number} STORE_METADATA_75=83 STORE_METADATA_75 value
                     * @property {number} STORE_METADATA_76=84 STORE_METADATA_76 value
                     * @property {number} STORE_METADATA_77=85 STORE_METADATA_77 value
                     * @property {number} STORE_METADATA_78=86 STORE_METADATA_78 value
                     * @property {number} STORE_METADATA_79=87 STORE_METADATA_79 value
                     * @property {number} STORE_METADATA_80=88 STORE_METADATA_80 value
                     * @property {number} STORE_METADATA_81=89 STORE_METADATA_81 value
                     * @property {number} STORE_METADATA_82=90 STORE_METADATA_82 value
                     * @property {number} STORE_METADATA_83=91 STORE_METADATA_83 value
                     * @property {number} STORE_METADATA_84=92 STORE_METADATA_84 value
                     * @property {number} STORE_METADATA_85=93 STORE_METADATA_85 value
                     * @property {number} STORE_METADATA_86=94 STORE_METADATA_86 value
                     * @property {number} STORE_METADATA_87=95 STORE_METADATA_87 value
                     * @property {number} STORE_METADATA_88=96 STORE_METADATA_88 value
                     * @property {number} STORE_METADATA_89=97 STORE_METADATA_89 value
                     * @property {number} STORE_METADATA_90=98 STORE_METADATA_90 value
                     * @property {number} STORE_METADATA_91=99 STORE_METADATA_91 value
                     * @property {number} STORE_METADATA_92=100 STORE_METADATA_92 value
                     * @property {number} STORE_METADATA_93=101 STORE_METADATA_93 value
                     * @property {number} STORE_METADATA_94=102 STORE_METADATA_94 value
                     * @property {number} STORE_METADATA_95=103 STORE_METADATA_95 value
                     * @property {number} STORE_METADATA_96=104 STORE_METADATA_96 value
                     * @property {number} STORE_METADATA_97=105 STORE_METADATA_97 value
                     * @property {number} STORE_METADATA_98=106 STORE_METADATA_98 value
                     * @property {number} STORE_METADATA_99=107 STORE_METADATA_99 value
                     * @property {number} STORE_METADATA_100=108 STORE_METADATA_100 value
                     * @property {number} EVENT_PRIORITY=109 EVENT_PRIORITY value
                     */
                    StoreEventAnalyticsReport.Dimension = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_DIMENSION"] = 0;
                        values[valuesById[1] = "STATUS"] = 1;
                        values[valuesById[2] = "EVENT_TYPE"] = 2;
                        values[valuesById[3] = "NTH_DAY"] = 3;
                        values[valuesById[4] = "NTH_WEEK"] = 4;
                        values[valuesById[18] = "CUSTOM_NTH_WEEK"] = 18;
                        values[valuesById[5] = "NTH_MONTH"] = 5;
                        values[valuesById[6] = "STORE_NAME"] = 6;
                        values[valuesById[7] = "NTH_QUARTER"] = 7;
                        values[valuesById[8] = "STORE_METADATA_1"] = 8;
                        values[valuesById[9] = "STORE_METADATA_2"] = 9;
                        values[valuesById[10] = "STORE_METADATA_3"] = 10;
                        values[valuesById[11] = "STORE_METADATA_4"] = 11;
                        values[valuesById[12] = "STORE_METADATA_5"] = 12;
                        values[valuesById[13] = "STORE_METADATA_6"] = 13;
                        values[valuesById[14] = "STORE_METADATA_7"] = 14;
                        values[valuesById[15] = "STORE_METADATA_8"] = 15;
                        values[valuesById[16] = "STORE_METADATA_9"] = 16;
                        values[valuesById[17] = "STORE_METADATA_10"] = 17;
                        values[valuesById[19] = "STORE_METADATA_11"] = 19;
                        values[valuesById[20] = "STORE_METADATA_12"] = 20;
                        values[valuesById[21] = "STORE_METADATA_13"] = 21;
                        values[valuesById[22] = "STORE_METADATA_14"] = 22;
                        values[valuesById[23] = "STORE_METADATA_15"] = 23;
                        values[valuesById[24] = "STORE_METADATA_16"] = 24;
                        values[valuesById[25] = "STORE_METADATA_17"] = 25;
                        values[valuesById[26] = "STORE_METADATA_18"] = 26;
                        values[valuesById[27] = "STORE_METADATA_19"] = 27;
                        values[valuesById[28] = "STORE_METADATA_20"] = 28;
                        values[valuesById[29] = "STORE_METADATA_21"] = 29;
                        values[valuesById[30] = "STORE_METADATA_22"] = 30;
                        values[valuesById[31] = "STORE_METADATA_23"] = 31;
                        values[valuesById[32] = "STORE_METADATA_24"] = 32;
                        values[valuesById[33] = "STORE_METADATA_25"] = 33;
                        values[valuesById[34] = "STORE_METADATA_26"] = 34;
                        values[valuesById[35] = "STORE_METADATA_27"] = 35;
                        values[valuesById[36] = "STORE_METADATA_28"] = 36;
                        values[valuesById[37] = "STORE_METADATA_29"] = 37;
                        values[valuesById[38] = "STORE_METADATA_30"] = 38;
                        values[valuesById[39] = "STORE_METADATA_31"] = 39;
                        values[valuesById[40] = "STORE_METADATA_32"] = 40;
                        values[valuesById[41] = "STORE_METADATA_33"] = 41;
                        values[valuesById[42] = "STORE_METADATA_34"] = 42;
                        values[valuesById[43] = "STORE_METADATA_35"] = 43;
                        values[valuesById[44] = "STORE_METADATA_36"] = 44;
                        values[valuesById[45] = "STORE_METADATA_37"] = 45;
                        values[valuesById[46] = "STORE_METADATA_38"] = 46;
                        values[valuesById[47] = "STORE_METADATA_39"] = 47;
                        values[valuesById[48] = "STORE_METADATA_40"] = 48;
                        values[valuesById[49] = "STORE_METADATA_41"] = 49;
                        values[valuesById[50] = "STORE_METADATA_42"] = 50;
                        values[valuesById[51] = "STORE_METADATA_43"] = 51;
                        values[valuesById[52] = "STORE_METADATA_44"] = 52;
                        values[valuesById[53] = "STORE_METADATA_45"] = 53;
                        values[valuesById[54] = "STORE_METADATA_46"] = 54;
                        values[valuesById[55] = "STORE_METADATA_47"] = 55;
                        values[valuesById[56] = "STORE_METADATA_48"] = 56;
                        values[valuesById[57] = "STORE_METADATA_49"] = 57;
                        values[valuesById[58] = "STORE_METADATA_50"] = 58;
                        values[valuesById[59] = "STORE_METADATA_51"] = 59;
                        values[valuesById[60] = "STORE_METADATA_52"] = 60;
                        values[valuesById[61] = "STORE_METADATA_53"] = 61;
                        values[valuesById[62] = "STORE_METADATA_54"] = 62;
                        values[valuesById[63] = "STORE_METADATA_55"] = 63;
                        values[valuesById[64] = "STORE_METADATA_56"] = 64;
                        values[valuesById[65] = "STORE_METADATA_57"] = 65;
                        values[valuesById[66] = "STORE_METADATA_58"] = 66;
                        values[valuesById[67] = "STORE_METADATA_59"] = 67;
                        values[valuesById[68] = "STORE_METADATA_60"] = 68;
                        values[valuesById[69] = "STORE_METADATA_61"] = 69;
                        values[valuesById[70] = "STORE_METADATA_62"] = 70;
                        values[valuesById[71] = "STORE_METADATA_63"] = 71;
                        values[valuesById[72] = "STORE_METADATA_64"] = 72;
                        values[valuesById[73] = "STORE_METADATA_65"] = 73;
                        values[valuesById[74] = "STORE_METADATA_66"] = 74;
                        values[valuesById[75] = "STORE_METADATA_67"] = 75;
                        values[valuesById[76] = "STORE_METADATA_68"] = 76;
                        values[valuesById[77] = "STORE_METADATA_69"] = 77;
                        values[valuesById[78] = "STORE_METADATA_70"] = 78;
                        values[valuesById[79] = "STORE_METADATA_71"] = 79;
                        values[valuesById[80] = "STORE_METADATA_72"] = 80;
                        values[valuesById[81] = "STORE_METADATA_73"] = 81;
                        values[valuesById[82] = "STORE_METADATA_74"] = 82;
                        values[valuesById[83] = "STORE_METADATA_75"] = 83;
                        values[valuesById[84] = "STORE_METADATA_76"] = 84;
                        values[valuesById[85] = "STORE_METADATA_77"] = 85;
                        values[valuesById[86] = "STORE_METADATA_78"] = 86;
                        values[valuesById[87] = "STORE_METADATA_79"] = 87;
                        values[valuesById[88] = "STORE_METADATA_80"] = 88;
                        values[valuesById[89] = "STORE_METADATA_81"] = 89;
                        values[valuesById[90] = "STORE_METADATA_82"] = 90;
                        values[valuesById[91] = "STORE_METADATA_83"] = 91;
                        values[valuesById[92] = "STORE_METADATA_84"] = 92;
                        values[valuesById[93] = "STORE_METADATA_85"] = 93;
                        values[valuesById[94] = "STORE_METADATA_86"] = 94;
                        values[valuesById[95] = "STORE_METADATA_87"] = 95;
                        values[valuesById[96] = "STORE_METADATA_88"] = 96;
                        values[valuesById[97] = "STORE_METADATA_89"] = 97;
                        values[valuesById[98] = "STORE_METADATA_90"] = 98;
                        values[valuesById[99] = "STORE_METADATA_91"] = 99;
                        values[valuesById[100] = "STORE_METADATA_92"] = 100;
                        values[valuesById[101] = "STORE_METADATA_93"] = 101;
                        values[valuesById[102] = "STORE_METADATA_94"] = 102;
                        values[valuesById[103] = "STORE_METADATA_95"] = 103;
                        values[valuesById[104] = "STORE_METADATA_96"] = 104;
                        values[valuesById[105] = "STORE_METADATA_97"] = 105;
                        values[valuesById[106] = "STORE_METADATA_98"] = 106;
                        values[valuesById[107] = "STORE_METADATA_99"] = 107;
                        values[valuesById[108] = "STORE_METADATA_100"] = 108;
                        values[valuesById[109] = "EVENT_PRIORITY"] = 109;
                        return values;
                    })();
    
                    /**
                     * Metric enum.
                     * @name palexy.streaming.v1.StoreEventAnalyticsReport.Metric
                     * @enum {number}
                     * @property {number} UNKNOWN_METRIC=0 UNKNOWN_METRIC value
                     * @property {number} NUMBER_OF_STORE_EVENTS=1 NUMBER_OF_STORE_EVENTS value
                     */
                    StoreEventAnalyticsReport.Metric = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_METRIC"] = 0;
                        values[valuesById[1] = "NUMBER_OF_STORE_EVENTS"] = 1;
                        return values;
                    })();
    
                    StoreEventAnalyticsReport.Row = (function() {
    
                        /**
                         * Properties of a Row.
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                         * @interface IRow
                         * @property {Array.<string>|null} [dimensionValues] Row dimensionValues
                         * @property {Array.<number>|null} [metricValues] Row metricValues
                         */
    
                        /**
                         * Constructs a new Row.
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport
                         * @classdesc Represents a Row.
                         * @implements IRow
                         * @constructor
                         * @param {palexy.streaming.v1.StoreEventAnalyticsReport.IRow=} [properties] Properties to set
                         */
                        function Row(properties) {
                            this.dimensionValues = [];
                            this.metricValues = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Row dimensionValues.
                         * @member {Array.<string>} dimensionValues
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @instance
                         */
                        Row.prototype.dimensionValues = $util.emptyArray;
    
                        /**
                         * Row metricValues.
                         * @member {Array.<number>} metricValues
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @instance
                         */
                        Row.prototype.metricValues = $util.emptyArray;
    
                        /**
                         * Creates a new Row instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {palexy.streaming.v1.StoreEventAnalyticsReport.IRow=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.StoreEventAnalyticsReport.Row} Row instance
                         */
                        Row.create = function create(properties) {
                            return new Row(properties);
                        };
    
                        /**
                         * Encodes the specified Row message. Does not implicitly {@link palexy.streaming.v1.StoreEventAnalyticsReport.Row.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {palexy.streaming.v1.StoreEventAnalyticsReport.IRow} message Row message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Row.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dimensionValues != null && message.dimensionValues.length)
                                for (var i = 0; i < message.dimensionValues.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dimensionValues[i]);
                            if (message.metricValues != null && message.metricValues.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.metricValues.length; ++i)
                                    writer.double(message.metricValues[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Row message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEventAnalyticsReport.Row.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {palexy.streaming.v1.StoreEventAnalyticsReport.IRow} message Row message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Row.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Row message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.StoreEventAnalyticsReport.Row} Row
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Row.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.dimensionValues && message.dimensionValues.length))
                                        message.dimensionValues = [];
                                    message.dimensionValues.push(reader.string());
                                    break;
                                case 2:
                                    if (!(message.metricValues && message.metricValues.length))
                                        message.metricValues = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.metricValues.push(reader.double());
                                    } else
                                        message.metricValues.push(reader.double());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Row message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.StoreEventAnalyticsReport.Row} Row
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Row.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Row message.
                         * @function verify
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Row.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dimensionValues != null && message.hasOwnProperty("dimensionValues")) {
                                if (!Array.isArray(message.dimensionValues))
                                    return "dimensionValues: array expected";
                                for (var i = 0; i < message.dimensionValues.length; ++i)
                                    if (!$util.isString(message.dimensionValues[i]))
                                        return "dimensionValues: string[] expected";
                            }
                            if (message.metricValues != null && message.hasOwnProperty("metricValues")) {
                                if (!Array.isArray(message.metricValues))
                                    return "metricValues: array expected";
                                for (var i = 0; i < message.metricValues.length; ++i)
                                    if (typeof message.metricValues[i] !== "number")
                                        return "metricValues: number[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Row message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.StoreEventAnalyticsReport.Row} Row
                         */
                        Row.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row)
                                return object;
                            var message = new $root.palexy.streaming.v1.StoreEventAnalyticsReport.Row();
                            if (object.dimensionValues) {
                                if (!Array.isArray(object.dimensionValues))
                                    throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.Row.dimensionValues: array expected");
                                message.dimensionValues = [];
                                for (var i = 0; i < object.dimensionValues.length; ++i)
                                    message.dimensionValues[i] = String(object.dimensionValues[i]);
                            }
                            if (object.metricValues) {
                                if (!Array.isArray(object.metricValues))
                                    throw TypeError(".palexy.streaming.v1.StoreEventAnalyticsReport.Row.metricValues: array expected");
                                message.metricValues = [];
                                for (var i = 0; i < object.metricValues.length; ++i)
                                    message.metricValues[i] = Number(object.metricValues[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Row message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @static
                         * @param {palexy.streaming.v1.StoreEventAnalyticsReport.Row} message Row
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Row.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.dimensionValues = [];
                                object.metricValues = [];
                            }
                            if (message.dimensionValues && message.dimensionValues.length) {
                                object.dimensionValues = [];
                                for (var j = 0; j < message.dimensionValues.length; ++j)
                                    object.dimensionValues[j] = message.dimensionValues[j];
                            }
                            if (message.metricValues && message.metricValues.length) {
                                object.metricValues = [];
                                for (var j = 0; j < message.metricValues.length; ++j)
                                    object.metricValues[j] = options.json && !isFinite(message.metricValues[j]) ? String(message.metricValues[j]) : message.metricValues[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Row to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.StoreEventAnalyticsReport.Row
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Row.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Row;
                    })();
    
                    return StoreEventAnalyticsReport;
                })();
    
                v1.ListStoreEventReviewLogRequest = (function() {
    
                    /**
                     * Properties of a ListStoreEventReviewLogRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventReviewLogRequest
                     * @property {number|null} [id] ListStoreEventReviewLogRequest id
                     */
    
                    /**
                     * Constructs a new ListStoreEventReviewLogRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventReviewLogRequest.
                     * @implements IListStoreEventReviewLogRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest=} [properties] Properties to set
                     */
                    function ListStoreEventReviewLogRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventReviewLogRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @instance
                     */
                    ListStoreEventReviewLogRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStoreEventReviewLogRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogRequest} ListStoreEventReviewLogRequest instance
                     */
                    ListStoreEventReviewLogRequest.create = function create(properties) {
                        return new ListStoreEventReviewLogRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventReviewLogRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventReviewLogRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest} message ListStoreEventReviewLogRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventReviewLogRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventReviewLogRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventReviewLogRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogRequest} message ListStoreEventReviewLogRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventReviewLogRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventReviewLogRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogRequest} ListStoreEventReviewLogRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventReviewLogRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventReviewLogRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventReviewLogRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogRequest} ListStoreEventReviewLogRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventReviewLogRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventReviewLogRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventReviewLogRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventReviewLogRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogRequest} ListStoreEventReviewLogRequest
                     */
                    ListStoreEventReviewLogRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventReviewLogRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventReviewLogRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventReviewLogRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventReviewLogRequest} message ListStoreEventReviewLogRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventReviewLogRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventReviewLogRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventReviewLogRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreEventReviewLogRequest;
                })();
    
                v1.ListStoreEventReviewLogResponse = (function() {
    
                    /**
                     * Properties of a ListStoreEventReviewLogResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventReviewLogResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEventReviewLog>|null} [reviewLogs] ListStoreEventReviewLogResponse reviewLogs
                     */
    
                    /**
                     * Constructs a new ListStoreEventReviewLogResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventReviewLogResponse.
                     * @implements IListStoreEventReviewLogResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogResponse=} [properties] Properties to set
                     */
                    function ListStoreEventReviewLogResponse(properties) {
                        this.reviewLogs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventReviewLogResponse reviewLogs.
                     * @member {Array.<palexy.streaming.v1.IStoreEventReviewLog>} reviewLogs
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @instance
                     */
                    ListStoreEventReviewLogResponse.prototype.reviewLogs = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreEventReviewLogResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogResponse} ListStoreEventReviewLogResponse instance
                     */
                    ListStoreEventReviewLogResponse.create = function create(properties) {
                        return new ListStoreEventReviewLogResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventReviewLogResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventReviewLogResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogResponse} message ListStoreEventReviewLogResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventReviewLogResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reviewLogs != null && message.reviewLogs.length)
                            for (var i = 0; i < message.reviewLogs.length; ++i)
                                $root.palexy.streaming.v1.StoreEventReviewLog.encode(message.reviewLogs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventReviewLogResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventReviewLogResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventReviewLogResponse} message ListStoreEventReviewLogResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventReviewLogResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventReviewLogResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogResponse} ListStoreEventReviewLogResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventReviewLogResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventReviewLogResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.reviewLogs && message.reviewLogs.length))
                                    message.reviewLogs = [];
                                message.reviewLogs.push($root.palexy.streaming.v1.StoreEventReviewLog.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventReviewLogResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogResponse} ListStoreEventReviewLogResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventReviewLogResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventReviewLogResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventReviewLogResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reviewLogs != null && message.hasOwnProperty("reviewLogs")) {
                            if (!Array.isArray(message.reviewLogs))
                                return "reviewLogs: array expected";
                            for (var i = 0; i < message.reviewLogs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEventReviewLog.verify(message.reviewLogs[i]);
                                if (error)
                                    return "reviewLogs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventReviewLogResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventReviewLogResponse} ListStoreEventReviewLogResponse
                     */
                    ListStoreEventReviewLogResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventReviewLogResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventReviewLogResponse();
                        if (object.reviewLogs) {
                            if (!Array.isArray(object.reviewLogs))
                                throw TypeError(".palexy.streaming.v1.ListStoreEventReviewLogResponse.reviewLogs: array expected");
                            message.reviewLogs = [];
                            for (var i = 0; i < object.reviewLogs.length; ++i) {
                                if (typeof object.reviewLogs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventReviewLogResponse.reviewLogs: object expected");
                                message.reviewLogs[i] = $root.palexy.streaming.v1.StoreEventReviewLog.fromObject(object.reviewLogs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventReviewLogResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventReviewLogResponse} message ListStoreEventReviewLogResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventReviewLogResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.reviewLogs = [];
                        if (message.reviewLogs && message.reviewLogs.length) {
                            object.reviewLogs = [];
                            for (var j = 0; j < message.reviewLogs.length; ++j)
                                object.reviewLogs[j] = $root.palexy.streaming.v1.StoreEventReviewLog.toObject(message.reviewLogs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventReviewLogResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventReviewLogResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventReviewLogResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreEventReviewLogResponse;
                })();
    
                v1.CreateStoreEventRequest = (function() {
    
                    /**
                     * Properties of a CreateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStoreEventRequest
                     * @property {palexy.streaming.v1.IStoreEvent|null} [event] CreateStoreEventRequest event
                     */
    
                    /**
                     * Constructs a new CreateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStoreEventRequest.
                     * @implements ICreateStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest=} [properties] Properties to set
                     */
                    function CreateStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStoreEventRequest event.
                     * @member {palexy.streaming.v1.IStoreEvent|null|undefined} event
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @instance
                     */
                    CreateStoreEventRequest.prototype.event = null;
    
                    /**
                     * Creates a new CreateStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStoreEventRequest} CreateStoreEventRequest instance
                     */
                    CreateStoreEventRequest.create = function create(properties) {
                        return new CreateStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest} message CreateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                            $root.palexy.streaming.v1.StoreEvent.encode(message.event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventRequest} message CreateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStoreEventRequest} CreateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.event = $root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStoreEventRequest} CreateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.event != null && message.hasOwnProperty("event")) {
                            var error = $root.palexy.streaming.v1.StoreEvent.verify(message.event);
                            if (error)
                                return "event." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStoreEventRequest} CreateStoreEventRequest
                     */
                    CreateStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStoreEventRequest();
                        if (object.event != null) {
                            if (typeof object.event !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreEventRequest.event: object expected");
                            message.event = $root.palexy.streaming.v1.StoreEvent.fromObject(object.event);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStoreEventRequest} message CreateStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.event = null;
                        if (message.event != null && message.hasOwnProperty("event"))
                            object.event = $root.palexy.streaming.v1.StoreEvent.toObject(message.event, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStoreEventRequest;
                })();
    
                v1.BatchCreateStoreEventRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStoreEventRequest
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] BatchCreateStoreEventRequest events
                     */
    
                    /**
                     * Constructs a new BatchCreateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStoreEventRequest.
                     * @implements IBatchCreateStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest=} [properties] Properties to set
                     */
                    function BatchCreateStoreEventRequest(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStoreEventRequest events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @instance
                     */
                    BatchCreateStoreEventRequest.prototype.events = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventRequest} BatchCreateStoreEventRequest instance
                     */
                    BatchCreateStoreEventRequest.create = function create(properties) {
                        return new BatchCreateStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest} message BatchCreateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventRequest} message BatchCreateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventRequest} BatchCreateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventRequest} BatchCreateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventRequest} BatchCreateStoreEventRequest
                     */
                    BatchCreateStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStoreEventRequest();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStoreEventRequest.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStoreEventRequest.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStoreEventRequest} message BatchCreateStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStoreEventRequest;
                })();
    
                v1.BatchCreateStoreEventResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStoreEventResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] BatchCreateStoreEventResponse events
                     */
    
                    /**
                     * Constructs a new BatchCreateStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStoreEventResponse.
                     * @implements IBatchCreateStoreEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventResponse=} [properties] Properties to set
                     */
                    function BatchCreateStoreEventResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStoreEventResponse events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @instance
                     */
                    BatchCreateStoreEventResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStoreEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventResponse} BatchCreateStoreEventResponse instance
                     */
                    BatchCreateStoreEventResponse.create = function create(properties) {
                        return new BatchCreateStoreEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreEventResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventResponse} message BatchCreateStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreEventResponse} message BatchCreateStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStoreEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventResponse} BatchCreateStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStoreEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStoreEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventResponse} BatchCreateStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStoreEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStoreEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStoreEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStoreEventResponse} BatchCreateStoreEventResponse
                     */
                    BatchCreateStoreEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStoreEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStoreEventResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStoreEventResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStoreEventResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStoreEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStoreEventResponse} message BatchCreateStoreEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStoreEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStoreEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStoreEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStoreEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStoreEventResponse;
                })();
    
                v1.FetchExpiredStoreEventArtifactsRequest = (function() {
    
                    /**
                     * Properties of a FetchExpiredStoreEventArtifactsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchExpiredStoreEventArtifactsRequest
                     * @property {number|null} [pageSize] FetchExpiredStoreEventArtifactsRequest pageSize
                     * @property {string|null} [pageToken] FetchExpiredStoreEventArtifactsRequest pageToken
                     */
    
                    /**
                     * Constructs a new FetchExpiredStoreEventArtifactsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchExpiredStoreEventArtifactsRequest.
                     * @implements IFetchExpiredStoreEventArtifactsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest=} [properties] Properties to set
                     */
                    function FetchExpiredStoreEventArtifactsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExpiredStoreEventArtifactsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @instance
                     */
                    FetchExpiredStoreEventArtifactsRequest.prototype.pageSize = 0;
    
                    /**
                     * FetchExpiredStoreEventArtifactsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @instance
                     */
                    FetchExpiredStoreEventArtifactsRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new FetchExpiredStoreEventArtifactsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest} FetchExpiredStoreEventArtifactsRequest instance
                     */
                    FetchExpiredStoreEventArtifactsRequest.create = function create(properties) {
                        return new FetchExpiredStoreEventArtifactsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExpiredStoreEventArtifactsRequest message. Does not implicitly {@link palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest} message FetchExpiredStoreEventArtifactsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExpiredStoreEventArtifactsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExpiredStoreEventArtifactsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsRequest} message FetchExpiredStoreEventArtifactsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExpiredStoreEventArtifactsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExpiredStoreEventArtifactsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest} FetchExpiredStoreEventArtifactsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExpiredStoreEventArtifactsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExpiredStoreEventArtifactsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest} FetchExpiredStoreEventArtifactsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExpiredStoreEventArtifactsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExpiredStoreEventArtifactsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExpiredStoreEventArtifactsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchExpiredStoreEventArtifactsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest} FetchExpiredStoreEventArtifactsRequest
                     */
                    FetchExpiredStoreEventArtifactsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExpiredStoreEventArtifactsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @static
                     * @param {palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest} message FetchExpiredStoreEventArtifactsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExpiredStoreEventArtifactsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this FetchExpiredStoreEventArtifactsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExpiredStoreEventArtifactsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExpiredStoreEventArtifactsRequest;
                })();
    
                v1.FetchExpiredStoreEventArtifactsResponse = (function() {
    
                    /**
                     * Properties of a FetchExpiredStoreEventArtifactsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IFetchExpiredStoreEventArtifactsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] FetchExpiredStoreEventArtifactsResponse events
                     * @property {string|null} [nextPageToken] FetchExpiredStoreEventArtifactsResponse nextPageToken
                     * @property {number|null} [totalElements] FetchExpiredStoreEventArtifactsResponse totalElements
                     */
    
                    /**
                     * Constructs a new FetchExpiredStoreEventArtifactsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a FetchExpiredStoreEventArtifactsResponse.
                     * @implements IFetchExpiredStoreEventArtifactsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsResponse=} [properties] Properties to set
                     */
                    function FetchExpiredStoreEventArtifactsResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FetchExpiredStoreEventArtifactsResponse events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @instance
                     */
                    FetchExpiredStoreEventArtifactsResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * FetchExpiredStoreEventArtifactsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @instance
                     */
                    FetchExpiredStoreEventArtifactsResponse.prototype.nextPageToken = "";
    
                    /**
                     * FetchExpiredStoreEventArtifactsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @instance
                     */
                    FetchExpiredStoreEventArtifactsResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FetchExpiredStoreEventArtifactsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} FetchExpiredStoreEventArtifactsResponse instance
                     */
                    FetchExpiredStoreEventArtifactsResponse.create = function create(properties) {
                        return new FetchExpiredStoreEventArtifactsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FetchExpiredStoreEventArtifactsResponse message. Does not implicitly {@link palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsResponse} message FetchExpiredStoreEventArtifactsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExpiredStoreEventArtifactsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FetchExpiredStoreEventArtifactsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {palexy.streaming.v1.IFetchExpiredStoreEventArtifactsResponse} message FetchExpiredStoreEventArtifactsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FetchExpiredStoreEventArtifactsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FetchExpiredStoreEventArtifactsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} FetchExpiredStoreEventArtifactsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExpiredStoreEventArtifactsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FetchExpiredStoreEventArtifactsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} FetchExpiredStoreEventArtifactsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FetchExpiredStoreEventArtifactsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FetchExpiredStoreEventArtifactsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FetchExpiredStoreEventArtifactsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FetchExpiredStoreEventArtifactsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} FetchExpiredStoreEventArtifactsResponse
                     */
                    FetchExpiredStoreEventArtifactsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FetchExpiredStoreEventArtifactsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @static
                     * @param {palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse} message FetchExpiredStoreEventArtifactsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FetchExpiredStoreEventArtifactsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this FetchExpiredStoreEventArtifactsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.FetchExpiredStoreEventArtifactsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FetchExpiredStoreEventArtifactsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FetchExpiredStoreEventArtifactsResponse;
                })();
    
                v1.BatchUpdateStoreEventsRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateStoreEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStoreEventsRequest
                     * @property {Array.<palexy.streaming.v1.IUpdateStoreEventRequest>|null} [updateStoreEventRequests] BatchUpdateStoreEventsRequest updateStoreEventRequests
                     */
    
                    /**
                     * Constructs a new BatchUpdateStoreEventsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStoreEventsRequest.
                     * @implements IBatchUpdateStoreEventsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest=} [properties] Properties to set
                     */
                    function BatchUpdateStoreEventsRequest(properties) {
                        this.updateStoreEventRequests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStoreEventsRequest updateStoreEventRequests.
                     * @member {Array.<palexy.streaming.v1.IUpdateStoreEventRequest>} updateStoreEventRequests
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @instance
                     */
                    BatchUpdateStoreEventsRequest.prototype.updateStoreEventRequests = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStoreEventsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsRequest} BatchUpdateStoreEventsRequest instance
                     */
                    BatchUpdateStoreEventsRequest.create = function create(properties) {
                        return new BatchUpdateStoreEventsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreEventsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreEventsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest} message BatchUpdateStoreEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreEventsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.updateStoreEventRequests != null && message.updateStoreEventRequests.length)
                            for (var i = 0; i < message.updateStoreEventRequests.length; ++i)
                                $root.palexy.streaming.v1.UpdateStoreEventRequest.encode(message.updateStoreEventRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreEventsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreEventsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsRequest} message BatchUpdateStoreEventsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreEventsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreEventsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsRequest} BatchUpdateStoreEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreEventsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStoreEventsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.updateStoreEventRequests && message.updateStoreEventRequests.length))
                                    message.updateStoreEventRequests = [];
                                message.updateStoreEventRequests.push($root.palexy.streaming.v1.UpdateStoreEventRequest.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreEventsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsRequest} BatchUpdateStoreEventsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreEventsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStoreEventsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStoreEventsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.updateStoreEventRequests != null && message.hasOwnProperty("updateStoreEventRequests")) {
                            if (!Array.isArray(message.updateStoreEventRequests))
                                return "updateStoreEventRequests: array expected";
                            for (var i = 0; i < message.updateStoreEventRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.UpdateStoreEventRequest.verify(message.updateStoreEventRequests[i]);
                                if (error)
                                    return "updateStoreEventRequests." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStoreEventsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsRequest} BatchUpdateStoreEventsRequest
                     */
                    BatchUpdateStoreEventsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStoreEventsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStoreEventsRequest();
                        if (object.updateStoreEventRequests) {
                            if (!Array.isArray(object.updateStoreEventRequests))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStoreEventsRequest.updateStoreEventRequests: array expected");
                            message.updateStoreEventRequests = [];
                            for (var i = 0; i < object.updateStoreEventRequests.length; ++i) {
                                if (typeof object.updateStoreEventRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateStoreEventsRequest.updateStoreEventRequests: object expected");
                                message.updateStoreEventRequests[i] = $root.palexy.streaming.v1.UpdateStoreEventRequest.fromObject(object.updateStoreEventRequests[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStoreEventsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStoreEventsRequest} message BatchUpdateStoreEventsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStoreEventsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.updateStoreEventRequests = [];
                        if (message.updateStoreEventRequests && message.updateStoreEventRequests.length) {
                            object.updateStoreEventRequests = [];
                            for (var j = 0; j < message.updateStoreEventRequests.length; ++j)
                                object.updateStoreEventRequests[j] = $root.palexy.streaming.v1.UpdateStoreEventRequest.toObject(message.updateStoreEventRequests[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStoreEventsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStoreEventsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStoreEventsRequest;
                })();
    
                v1.BatchUpdateStoreEventsResponse = (function() {
    
                    /**
                     * Properties of a BatchUpdateStoreEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStoreEventsResponse
                     * @property {Array.<number>|null} [eventIds] BatchUpdateStoreEventsResponse eventIds
                     */
    
                    /**
                     * Constructs a new BatchUpdateStoreEventsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStoreEventsResponse.
                     * @implements IBatchUpdateStoreEventsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsResponse=} [properties] Properties to set
                     */
                    function BatchUpdateStoreEventsResponse(properties) {
                        this.eventIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStoreEventsResponse eventIds.
                     * @member {Array.<number>} eventIds
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @instance
                     */
                    BatchUpdateStoreEventsResponse.prototype.eventIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStoreEventsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsResponse} BatchUpdateStoreEventsResponse instance
                     */
                    BatchUpdateStoreEventsResponse.create = function create(properties) {
                        return new BatchUpdateStoreEventsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreEventsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreEventsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsResponse} message BatchUpdateStoreEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreEventsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventIds != null && message.eventIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.eventIds.length; ++i)
                                writer.int64(message.eventIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreEventsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreEventsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreEventsResponse} message BatchUpdateStoreEventsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreEventsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsResponse} BatchUpdateStoreEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreEventsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStoreEventsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.eventIds && message.eventIds.length))
                                    message.eventIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.eventIds.push(reader.int64());
                                } else
                                    message.eventIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreEventsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsResponse} BatchUpdateStoreEventsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreEventsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStoreEventsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStoreEventsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.eventIds != null && message.hasOwnProperty("eventIds")) {
                            if (!Array.isArray(message.eventIds))
                                return "eventIds: array expected";
                            for (var i = 0; i < message.eventIds.length; ++i)
                                if (!$util.isInteger(message.eventIds[i]) && !(message.eventIds[i] && $util.isInteger(message.eventIds[i].low) && $util.isInteger(message.eventIds[i].high)))
                                    return "eventIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStoreEventsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStoreEventsResponse} BatchUpdateStoreEventsResponse
                     */
                    BatchUpdateStoreEventsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStoreEventsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStoreEventsResponse();
                        if (object.eventIds) {
                            if (!Array.isArray(object.eventIds))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStoreEventsResponse.eventIds: array expected");
                            message.eventIds = [];
                            for (var i = 0; i < object.eventIds.length; ++i)
                                if ($util.Long)
                                    (message.eventIds[i] = $util.Long.fromValue(object.eventIds[i])).unsigned = false;
                                else if (typeof object.eventIds[i] === "string")
                                    message.eventIds[i] = parseInt(object.eventIds[i], 10);
                                else if (typeof object.eventIds[i] === "number")
                                    message.eventIds[i] = object.eventIds[i];
                                else if (typeof object.eventIds[i] === "object")
                                    message.eventIds[i] = new $util.LongBits(object.eventIds[i].low >>> 0, object.eventIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStoreEventsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStoreEventsResponse} message BatchUpdateStoreEventsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStoreEventsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.eventIds = [];
                        if (message.eventIds && message.eventIds.length) {
                            object.eventIds = [];
                            for (var j = 0; j < message.eventIds.length; ++j)
                                if (typeof message.eventIds[j] === "number")
                                    object.eventIds[j] = options.longs === String ? String(message.eventIds[j]) : message.eventIds[j];
                                else
                                    object.eventIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.eventIds[j]) : options.longs === Number ? new $util.LongBits(message.eventIds[j].low >>> 0, message.eventIds[j].high >>> 0).toNumber() : message.eventIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStoreEventsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStoreEventsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStoreEventsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStoreEventsResponse;
                })();
    
                v1.GetStoreEventRequest = (function() {
    
                    /**
                     * Properties of a GetStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreEventRequest
                     * @property {number|null} [id] GetStoreEventRequest id
                     */
    
                    /**
                     * Constructs a new GetStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreEventRequest.
                     * @implements IGetStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreEventRequest=} [properties] Properties to set
                     */
                    function GetStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreEventRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @instance
                     */
                    GetStoreEventRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreEventRequest} GetStoreEventRequest instance
                     */
                    GetStoreEventRequest.create = function create(properties) {
                        return new GetStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventRequest} message GetStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventRequest} message GetStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreEventRequest} GetStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreEventRequest} GetStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreEventRequest} GetStoreEventRequest
                     */
                    GetStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreEventRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreEventRequest} message GetStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreEventRequest;
                })();
    
                v1.UpdateStoreEventRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreEventRequest
                     * @property {palexy.streaming.v1.IStoreEvent|null} [event] UpdateStoreEventRequest event
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreEventRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreEventRequest.
                     * @implements IUpdateStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest=} [properties] Properties to set
                     */
                    function UpdateStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreEventRequest event.
                     * @member {palexy.streaming.v1.IStoreEvent|null|undefined} event
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @instance
                     */
                    UpdateStoreEventRequest.prototype.event = null;
    
                    /**
                     * UpdateStoreEventRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @instance
                     */
                    UpdateStoreEventRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreEventRequest} UpdateStoreEventRequest instance
                     */
                    UpdateStoreEventRequest.create = function create(properties) {
                        return new UpdateStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest} message UpdateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                            $root.palexy.streaming.v1.StoreEvent.encode(message.event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventRequest} message UpdateStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreEventRequest} UpdateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.event = $root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreEventRequest} UpdateStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.event != null && message.hasOwnProperty("event")) {
                            var error = $root.palexy.streaming.v1.StoreEvent.verify(message.event);
                            if (error)
                                return "event." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreEventRequest} UpdateStoreEventRequest
                     */
                    UpdateStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreEventRequest();
                        if (object.event != null) {
                            if (typeof object.event !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreEventRequest.event: object expected");
                            message.event = $root.palexy.streaming.v1.StoreEvent.fromObject(object.event);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreEventRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreEventRequest} message UpdateStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.event = null;
                            object.updateMask = null;
                        }
                        if (message.event != null && message.hasOwnProperty("event"))
                            object.event = $root.palexy.streaming.v1.StoreEvent.toObject(message.event, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreEventRequest;
                })();
    
                v1.DeleteStoreEventRequest = (function() {
    
                    /**
                     * Properties of a DeleteStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStoreEventRequest
                     * @property {number|null} [id] DeleteStoreEventRequest id
                     */
    
                    /**
                     * Constructs a new DeleteStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStoreEventRequest.
                     * @implements IDeleteStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest=} [properties] Properties to set
                     */
                    function DeleteStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStoreEventRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @instance
                     */
                    DeleteStoreEventRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStoreEventRequest} DeleteStoreEventRequest instance
                     */
                    DeleteStoreEventRequest.create = function create(properties) {
                        return new DeleteStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest} message DeleteStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventRequest} message DeleteStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStoreEventRequest} DeleteStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStoreEventRequest} DeleteStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStoreEventRequest} DeleteStoreEventRequest
                     */
                    DeleteStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStoreEventRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStoreEventRequest} message DeleteStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStoreEventRequest;
                })();
    
                v1.ListStoreEventRequest = (function() {
    
                    /**
                     * Properties of a ListStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventRequest
                     * @property {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter|null} [storeEventFilter] ListStoreEventRequest storeEventFilter
                     * @property {number|null} [pageSize] ListStoreEventRequest pageSize
                     * @property {number|null} [pageIndex] ListStoreEventRequest pageIndex
                     * @property {boolean|null} [includeFormSubmission] ListStoreEventRequest includeFormSubmission
                     * @property {palexy.streaming.v1.ListStoreEventRequest.Order|null} [order] ListStoreEventRequest order
                     */
    
                    /**
                     * Constructs a new ListStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventRequest.
                     * @implements IListStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventRequest=} [properties] Properties to set
                     */
                    function ListStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventRequest storeEventFilter.
                     * @member {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter|null|undefined} storeEventFilter
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     */
                    ListStoreEventRequest.prototype.storeEventFilter = null;
    
                    /**
                     * ListStoreEventRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     */
                    ListStoreEventRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStoreEventRequest pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     */
                    ListStoreEventRequest.prototype.pageIndex = 0;
    
                    /**
                     * ListStoreEventRequest includeFormSubmission.
                     * @member {boolean} includeFormSubmission
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     */
                    ListStoreEventRequest.prototype.includeFormSubmission = false;
    
                    /**
                     * ListStoreEventRequest order.
                     * @member {palexy.streaming.v1.ListStoreEventRequest.Order} order
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     */
                    ListStoreEventRequest.prototype.order = 0;
    
                    /**
                     * Creates a new ListStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventRequest} ListStoreEventRequest instance
                     */
                    ListStoreEventRequest.create = function create(properties) {
                        return new ListStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventRequest} message ListStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeEventFilter != null && Object.hasOwnProperty.call(message, "storeEventFilter"))
                            $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.encode(message.storeEventFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageIndex);
                        if (message.includeFormSubmission != null && Object.hasOwnProperty.call(message, "includeFormSubmission"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeFormSubmission);
                        if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.order);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventRequest} message ListStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventRequest} ListStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeEventFilter = $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageIndex = reader.int32();
                                break;
                            case 4:
                                message.includeFormSubmission = reader.bool();
                                break;
                            case 5:
                                message.order = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventRequest} ListStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeEventFilter != null && message.hasOwnProperty("storeEventFilter")) {
                            var error = $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.verify(message.storeEventFilter);
                            if (error)
                                return "storeEventFilter." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        if (message.includeFormSubmission != null && message.hasOwnProperty("includeFormSubmission"))
                            if (typeof message.includeFormSubmission !== "boolean")
                                return "includeFormSubmission: boolean expected";
                        if (message.order != null && message.hasOwnProperty("order"))
                            switch (message.order) {
                            default:
                                return "order: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventRequest} ListStoreEventRequest
                     */
                    ListStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventRequest();
                        if (object.storeEventFilter != null) {
                            if (typeof object.storeEventFilter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.storeEventFilter: object expected");
                            message.storeEventFilter = $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.fromObject(object.storeEventFilter);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        if (object.includeFormSubmission != null)
                            message.includeFormSubmission = Boolean(object.includeFormSubmission);
                        switch (object.order) {
                        case "ORDER_UNSPECIFIED":
                        case 0:
                            message.order = 0;
                            break;
                        case "CREATE_TIME_DESC":
                        case 1:
                            message.order = 1;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventRequest} message ListStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeEventFilter = null;
                            object.pageSize = 0;
                            object.pageIndex = 0;
                            object.includeFormSubmission = false;
                            object.order = options.enums === String ? "ORDER_UNSPECIFIED" : 0;
                        }
                        if (message.storeEventFilter != null && message.hasOwnProperty("storeEventFilter"))
                            object.storeEventFilter = $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.toObject(message.storeEventFilter, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        if (message.includeFormSubmission != null && message.hasOwnProperty("includeFormSubmission"))
                            object.includeFormSubmission = message.includeFormSubmission;
                        if (message.order != null && message.hasOwnProperty("order"))
                            object.order = options.enums === String ? $root.palexy.streaming.v1.ListStoreEventRequest.Order[message.order] : message.order;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListStoreEventRequest.StoreEventFilter = (function() {
    
                        /**
                         * Properties of a StoreEventFilter.
                         * @memberof palexy.streaming.v1.ListStoreEventRequest
                         * @interface IStoreEventFilter
                         * @property {Array.<number>|null} [storeIds] StoreEventFilter storeIds
                         * @property {string|null} [startDate] StoreEventFilter startDate
                         * @property {string|null} [endDate] StoreEventFilter endDate
                         * @property {palexy.streaming.v1.StoreEventType|null} [type] StoreEventFilter type
                         * @property {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>|null} [statuses] StoreEventFilter statuses
                         * @property {boolean|null} [isTestEvent] StoreEventFilter isTestEvent
                         * @property {Array.<palexy.streaming.v1.StoreEventType>|null} [types] StoreEventFilter types
                         * @property {Array.<palexy.streaming.v1.StoreEvent.Priority>|null} [priorities] StoreEventFilter priorities
                         * @property {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter|null} [formSubmissionFilter] StoreEventFilter formSubmissionFilter
                         * @property {boolean|null} [realtimeOnly] StoreEventFilter realtimeOnly
                         */
    
                        /**
                         * Constructs a new StoreEventFilter.
                         * @memberof palexy.streaming.v1.ListStoreEventRequest
                         * @classdesc Represents a StoreEventFilter.
                         * @implements IStoreEventFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter=} [properties] Properties to set
                         */
                        function StoreEventFilter(properties) {
                            this.storeIds = [];
                            this.statuses = [];
                            this.types = [];
                            this.priorities = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * StoreEventFilter storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * StoreEventFilter startDate.
                         * @member {string} startDate
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.startDate = "";
    
                        /**
                         * StoreEventFilter endDate.
                         * @member {string} endDate
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.endDate = "";
    
                        /**
                         * StoreEventFilter type.
                         * @member {palexy.streaming.v1.StoreEventType} type
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.type = 0;
    
                        /**
                         * StoreEventFilter statuses.
                         * @member {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>} statuses
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.statuses = $util.emptyArray;
    
                        /**
                         * StoreEventFilter isTestEvent.
                         * @member {boolean} isTestEvent
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.isTestEvent = false;
    
                        /**
                         * StoreEventFilter types.
                         * @member {Array.<palexy.streaming.v1.StoreEventType>} types
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.types = $util.emptyArray;
    
                        /**
                         * StoreEventFilter priorities.
                         * @member {Array.<palexy.streaming.v1.StoreEvent.Priority>} priorities
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.priorities = $util.emptyArray;
    
                        /**
                         * StoreEventFilter formSubmissionFilter.
                         * @member {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter|null|undefined} formSubmissionFilter
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.formSubmissionFilter = null;
    
                        /**
                         * StoreEventFilter realtimeOnly.
                         * @member {boolean} realtimeOnly
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        StoreEventFilter.prototype.realtimeOnly = false;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * StoreEventFilter _formSubmissionFilter.
                         * @member {"formSubmissionFilter"|undefined} _formSubmissionFilter
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         */
                        Object.defineProperty(StoreEventFilter.prototype, "_formSubmissionFilter", {
                            get: $util.oneOfGetter($oneOfFields = ["formSubmissionFilter"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new StoreEventFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter} StoreEventFilter instance
                         */
                        StoreEventFilter.create = function create(properties) {
                            return new StoreEventFilter(properties);
                        };
    
                        /**
                         * Encodes the specified StoreEventFilter message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter} message StoreEventFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StoreEventFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDate);
                            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDate);
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                            if (message.statuses != null && message.statuses.length) {
                                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                                for (var i = 0; i < message.statuses.length; ++i)
                                    writer.int32(message.statuses[i]);
                                writer.ldelim();
                            }
                            if (message.isTestEvent != null && Object.hasOwnProperty.call(message, "isTestEvent"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isTestEvent);
                            if (message.types != null && message.types.length) {
                                writer.uint32(/* id 7, wireType 2 =*/58).fork();
                                for (var i = 0; i < message.types.length; ++i)
                                    writer.int32(message.types[i]);
                                writer.ldelim();
                            }
                            if (message.priorities != null && message.priorities.length) {
                                writer.uint32(/* id 8, wireType 2 =*/66).fork();
                                for (var i = 0; i < message.priorities.length; ++i)
                                    writer.int32(message.priorities[i]);
                                writer.ldelim();
                            }
                            if (message.formSubmissionFilter != null && Object.hasOwnProperty.call(message, "formSubmissionFilter"))
                                $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.encode(message.formSubmissionFilter, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                            if (message.realtimeOnly != null && Object.hasOwnProperty.call(message, "realtimeOnly"))
                                writer.uint32(/* id 10, wireType 0 =*/80).bool(message.realtimeOnly);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified StoreEventFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IStoreEventFilter} message StoreEventFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        StoreEventFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a StoreEventFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter} StoreEventFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StoreEventFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 2:
                                    message.startDate = reader.string();
                                    break;
                                case 3:
                                    message.endDate = reader.string();
                                    break;
                                case 4:
                                    message.type = reader.int32();
                                    break;
                                case 5:
                                    if (!(message.statuses && message.statuses.length))
                                        message.statuses = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.statuses.push(reader.int32());
                                    } else
                                        message.statuses.push(reader.int32());
                                    break;
                                case 6:
                                    message.isTestEvent = reader.bool();
                                    break;
                                case 7:
                                    if (!(message.types && message.types.length))
                                        message.types = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.types.push(reader.int32());
                                    } else
                                        message.types.push(reader.int32());
                                    break;
                                case 8:
                                    if (!(message.priorities && message.priorities.length))
                                        message.priorities = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.priorities.push(reader.int32());
                                    } else
                                        message.priorities.push(reader.int32());
                                    break;
                                case 9:
                                    message.formSubmissionFilter = $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.decode(reader, reader.uint32());
                                    break;
                                case 10:
                                    message.realtimeOnly = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a StoreEventFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter} StoreEventFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        StoreEventFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a StoreEventFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        StoreEventFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (!$util.isString(message.startDate))
                                    return "startDate: string expected";
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (!$util.isString(message.endDate))
                                    return "endDate: string expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                case 11:
                                case 12:
                                case 13:
                                case 14:
                                case 15:
                                case 16:
                                case 17:
                                case 18:
                                case 19:
                                    break;
                                }
                            if (message.statuses != null && message.hasOwnProperty("statuses")) {
                                if (!Array.isArray(message.statuses))
                                    return "statuses: array expected";
                                for (var i = 0; i < message.statuses.length; ++i)
                                    switch (message.statuses[i]) {
                                    default:
                                        return "statuses: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                if (typeof message.isTestEvent !== "boolean")
                                    return "isTestEvent: boolean expected";
                            if (message.types != null && message.hasOwnProperty("types")) {
                                if (!Array.isArray(message.types))
                                    return "types: array expected";
                                for (var i = 0; i < message.types.length; ++i)
                                    switch (message.types[i]) {
                                    default:
                                        return "types: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                    case 5:
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 9:
                                    case 10:
                                    case 11:
                                    case 12:
                                    case 13:
                                    case 14:
                                    case 15:
                                    case 16:
                                    case 17:
                                    case 18:
                                    case 19:
                                        break;
                                    }
                            }
                            if (message.priorities != null && message.hasOwnProperty("priorities")) {
                                if (!Array.isArray(message.priorities))
                                    return "priorities: array expected";
                                for (var i = 0; i < message.priorities.length; ++i)
                                    switch (message.priorities[i]) {
                                    default:
                                        return "priorities: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            if (message.formSubmissionFilter != null && message.hasOwnProperty("formSubmissionFilter")) {
                                properties._formSubmissionFilter = 1;
                                {
                                    var error = $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.verify(message.formSubmissionFilter);
                                    if (error)
                                        return "formSubmissionFilter." + error;
                                }
                            }
                            if (message.realtimeOnly != null && message.hasOwnProperty("realtimeOnly"))
                                if (typeof message.realtimeOnly !== "boolean")
                                    return "realtimeOnly: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a StoreEventFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter} StoreEventFilter
                         */
                        StoreEventFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.startDate != null)
                                message.startDate = String(object.startDate);
                            if (object.endDate != null)
                                message.endDate = String(object.endDate);
                            switch (object.type) {
                            case "UNKNOWN_STORE_EVENT_TYPE":
                            case 0:
                                message.type = 0;
                                break;
                            case "MISSED_CUSTOMER_INTERACTION":
                            case 1:
                                message.type = 1;
                                break;
                            case "SUSPICIOUS_CASHIER_ACTIVITY":
                            case 2:
                                message.type = 2;
                                break;
                            case "SOP_NON_COMPLIANCE":
                            case 3:
                                message.type = 3;
                                break;
                            case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                            case 4:
                                message.type = 4;
                                break;
                            case "STAFF_GATHERING":
                            case 5:
                                message.type = 5;
                                break;
                            case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                            case 6:
                                message.type = 6;
                                break;
                            case "CUSTOMER_NEEDS_ASSISTANCE":
                            case 7:
                                message.type = 7;
                                break;
                            case "STAFF_NOT_WEAR_GLOVE":
                            case 8:
                                message.type = 8;
                                break;
                            case "NOT_GREETED_ON_TIME":
                            case 9:
                                message.type = 9;
                                break;
                            case "STAFF_MISSING":
                            case 10:
                                message.type = 10;
                                break;
                            case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                            case 11:
                                message.type = 11;
                                break;
                            case "HIGH_TRAFFIC_CHECKOUT":
                            case 12:
                                message.type = 12;
                                break;
                            case "LONG_TOTAL_SERVICE_TIME":
                            case 13:
                                message.type = 13;
                                break;
                            case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                            case 14:
                                message.type = 14;
                                break;
                            case "LATE_TABLE_CLEANING":
                            case 15:
                                message.type = 15;
                                break;
                            case "SUSPICIOUS_BILL_CANCELLATION":
                            case 16:
                                message.type = 16;
                                break;
                            case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                            case 17:
                                message.type = 17;
                                break;
                            case "LONG_QUEUE":
                            case 18:
                                message.type = 18;
                                break;
                            case "LONG_CHECKOUT_TIME":
                            case 19:
                                message.type = 19;
                                break;
                            }
                            if (object.statuses) {
                                if (!Array.isArray(object.statuses))
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.statuses: array expected");
                                message.statuses = [];
                                for (var i = 0; i < object.statuses.length; ++i)
                                    switch (object.statuses[i]) {
                                    default:
                                    case "UNKNOWN":
                                    case 0:
                                        message.statuses[i] = 0;
                                        break;
                                    case "NOT_REVIEWED":
                                    case 1:
                                        message.statuses[i] = 1;
                                        break;
                                    case "APPROVED":
                                    case 2:
                                        message.statuses[i] = 2;
                                        break;
                                    case "REJECTED":
                                    case 3:
                                        message.statuses[i] = 3;
                                        break;
                                    }
                            }
                            if (object.isTestEvent != null)
                                message.isTestEvent = Boolean(object.isTestEvent);
                            if (object.types) {
                                if (!Array.isArray(object.types))
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.types: array expected");
                                message.types = [];
                                for (var i = 0; i < object.types.length; ++i)
                                    switch (object.types[i]) {
                                    default:
                                    case "UNKNOWN_STORE_EVENT_TYPE":
                                    case 0:
                                        message.types[i] = 0;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION":
                                    case 1:
                                        message.types[i] = 1;
                                        break;
                                    case "SUSPICIOUS_CASHIER_ACTIVITY":
                                    case 2:
                                        message.types[i] = 2;
                                        break;
                                    case "SOP_NON_COMPLIANCE":
                                    case 3:
                                        message.types[i] = 3;
                                        break;
                                    case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                                    case 4:
                                        message.types[i] = 4;
                                        break;
                                    case "STAFF_GATHERING":
                                    case 5:
                                        message.types[i] = 5;
                                        break;
                                    case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                                    case 6:
                                        message.types[i] = 6;
                                        break;
                                    case "CUSTOMER_NEEDS_ASSISTANCE":
                                    case 7:
                                        message.types[i] = 7;
                                        break;
                                    case "STAFF_NOT_WEAR_GLOVE":
                                    case 8:
                                        message.types[i] = 8;
                                        break;
                                    case "NOT_GREETED_ON_TIME":
                                    case 9:
                                        message.types[i] = 9;
                                        break;
                                    case "STAFF_MISSING":
                                    case 10:
                                        message.types[i] = 10;
                                        break;
                                    case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                                    case 11:
                                        message.types[i] = 11;
                                        break;
                                    case "HIGH_TRAFFIC_CHECKOUT":
                                    case 12:
                                        message.types[i] = 12;
                                        break;
                                    case "LONG_TOTAL_SERVICE_TIME":
                                    case 13:
                                        message.types[i] = 13;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                                    case 14:
                                        message.types[i] = 14;
                                        break;
                                    case "LATE_TABLE_CLEANING":
                                    case 15:
                                        message.types[i] = 15;
                                        break;
                                    case "SUSPICIOUS_BILL_CANCELLATION":
                                    case 16:
                                        message.types[i] = 16;
                                        break;
                                    case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                                    case 17:
                                        message.types[i] = 17;
                                        break;
                                    case "LONG_QUEUE":
                                    case 18:
                                        message.types[i] = 18;
                                        break;
                                    case "LONG_CHECKOUT_TIME":
                                    case 19:
                                        message.types[i] = 19;
                                        break;
                                    }
                            }
                            if (object.priorities) {
                                if (!Array.isArray(object.priorities))
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.priorities: array expected");
                                message.priorities = [];
                                for (var i = 0; i < object.priorities.length; ++i)
                                    switch (object.priorities[i]) {
                                    default:
                                    case "PRIORITY_UNKNOWN":
                                    case 0:
                                        message.priorities[i] = 0;
                                        break;
                                    case "LOW":
                                    case 1:
                                        message.priorities[i] = 1;
                                        break;
                                    case "MEDIUM":
                                    case 2:
                                        message.priorities[i] = 2;
                                        break;
                                    case "HIGH":
                                    case 3:
                                        message.priorities[i] = 3;
                                        break;
                                    }
                            }
                            if (object.formSubmissionFilter != null) {
                                if (typeof object.formSubmissionFilter !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter.formSubmissionFilter: object expected");
                                message.formSubmissionFilter = $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.fromObject(object.formSubmissionFilter);
                            }
                            if (object.realtimeOnly != null)
                                message.realtimeOnly = Boolean(object.realtimeOnly);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a StoreEventFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter} message StoreEventFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        StoreEventFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.storeIds = [];
                                object.statuses = [];
                                object.types = [];
                                object.priorities = [];
                            }
                            if (options.defaults) {
                                object.startDate = "";
                                object.endDate = "";
                                object.type = options.enums === String ? "UNKNOWN_STORE_EVENT_TYPE" : 0;
                                object.isTestEvent = false;
                                object.realtimeOnly = false;
                            }
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                object.startDate = message.startDate;
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                object.endDate = message.endDate;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.type] : message.type;
                            if (message.statuses && message.statuses.length) {
                                object.statuses = [];
                                for (var j = 0; j < message.statuses.length; ++j)
                                    object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.StoreEventStatus[message.statuses[j]] : message.statuses[j];
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                object.isTestEvent = message.isTestEvent;
                            if (message.types && message.types.length) {
                                object.types = [];
                                for (var j = 0; j < message.types.length; ++j)
                                    object.types[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.types[j]] : message.types[j];
                            }
                            if (message.priorities && message.priorities.length) {
                                object.priorities = [];
                                for (var j = 0; j < message.priorities.length; ++j)
                                    object.priorities[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.Priority[message.priorities[j]] : message.priorities[j];
                            }
                            if (message.formSubmissionFilter != null && message.hasOwnProperty("formSubmissionFilter")) {
                                object.formSubmissionFilter = $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.toObject(message.formSubmissionFilter, options);
                                if (options.oneofs)
                                    object._formSubmissionFilter = "formSubmissionFilter";
                            }
                            if (message.realtimeOnly != null && message.hasOwnProperty("realtimeOnly"))
                                object.realtimeOnly = message.realtimeOnly;
                            return object;
                        };
    
                        /**
                         * Converts this StoreEventFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.StoreEventFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        StoreEventFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return StoreEventFilter;
                    })();
    
                    ListStoreEventRequest.FormSubmissionFilter = (function() {
    
                        /**
                         * Properties of a FormSubmissionFilter.
                         * @memberof palexy.streaming.v1.ListStoreEventRequest
                         * @interface IFormSubmissionFilter
                         * @property {number|null} [formId] FormSubmissionFilter formId
                         * @property {number|null} [formFieldId] FormSubmissionFilter formFieldId
                         * @property {string|null} [optionId] FormSubmissionFilter optionId
                         * @property {string|null} [internalQuestionId] FormSubmissionFilter internalQuestionId
                         */
    
                        /**
                         * Constructs a new FormSubmissionFilter.
                         * @memberof palexy.streaming.v1.ListStoreEventRequest
                         * @classdesc Represents a FormSubmissionFilter.
                         * @implements IFormSubmissionFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter=} [properties] Properties to set
                         */
                        function FormSubmissionFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * FormSubmissionFilter formId.
                         * @member {number} formId
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @instance
                         */
                        FormSubmissionFilter.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormSubmissionFilter formFieldId.
                         * @member {number} formFieldId
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @instance
                         */
                        FormSubmissionFilter.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormSubmissionFilter optionId.
                         * @member {string} optionId
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @instance
                         */
                        FormSubmissionFilter.prototype.optionId = "";
    
                        /**
                         * FormSubmissionFilter internalQuestionId.
                         * @member {string} internalQuestionId
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @instance
                         */
                        FormSubmissionFilter.prototype.internalQuestionId = "";
    
                        /**
                         * Creates a new FormSubmissionFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter} FormSubmissionFilter instance
                         */
                        FormSubmissionFilter.create = function create(properties) {
                            return new FormSubmissionFilter(properties);
                        };
    
                        /**
                         * Encodes the specified FormSubmissionFilter message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter} message FormSubmissionFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormSubmissionFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                            if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                            if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.optionId);
                            if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.internalQuestionId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified FormSubmissionFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.IFormSubmissionFilter} message FormSubmissionFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormSubmissionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a FormSubmissionFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter} FormSubmissionFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormSubmissionFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.formId = reader.int64();
                                    break;
                                case 2:
                                    message.formFieldId = reader.int64();
                                    break;
                                case 3:
                                    message.optionId = reader.string();
                                    break;
                                case 4:
                                    message.internalQuestionId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a FormSubmissionFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter} FormSubmissionFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormSubmissionFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a FormSubmissionFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        FormSubmissionFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                    return "formId: integer|Long expected";
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                    return "formFieldId: integer|Long expected";
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                if (!$util.isString(message.optionId))
                                    return "optionId: string expected";
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                if (!$util.isString(message.internalQuestionId))
                                    return "internalQuestionId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a FormSubmissionFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter} FormSubmissionFilter
                         */
                        FormSubmissionFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter();
                            if (object.formId != null)
                                if ($util.Long)
                                    (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                                else if (typeof object.formId === "string")
                                    message.formId = parseInt(object.formId, 10);
                                else if (typeof object.formId === "number")
                                    message.formId = object.formId;
                                else if (typeof object.formId === "object")
                                    message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                            if (object.formFieldId != null)
                                if ($util.Long)
                                    (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                                else if (typeof object.formFieldId === "string")
                                    message.formFieldId = parseInt(object.formFieldId, 10);
                                else if (typeof object.formFieldId === "number")
                                    message.formFieldId = object.formFieldId;
                                else if (typeof object.formFieldId === "object")
                                    message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                            if (object.optionId != null)
                                message.optionId = String(object.optionId);
                            if (object.internalQuestionId != null)
                                message.internalQuestionId = String(object.internalQuestionId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a FormSubmissionFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @static
                         * @param {palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter} message FormSubmissionFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        FormSubmissionFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formFieldId = options.longs === String ? "0" : 0;
                                object.optionId = "";
                                object.internalQuestionId = "";
                            }
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (typeof message.formId === "number")
                                    object.formId = options.longs === String ? String(message.formId) : message.formId;
                                else
                                    object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (typeof message.formFieldId === "number")
                                    object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                                else
                                    object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                object.optionId = message.optionId;
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                object.internalQuestionId = message.internalQuestionId;
                            return object;
                        };
    
                        /**
                         * Converts this FormSubmissionFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListStoreEventRequest.FormSubmissionFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        FormSubmissionFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return FormSubmissionFilter;
                    })();
    
                    /**
                     * Order enum.
                     * @name palexy.streaming.v1.ListStoreEventRequest.Order
                     * @enum {number}
                     * @property {number} ORDER_UNSPECIFIED=0 ORDER_UNSPECIFIED value
                     * @property {number} CREATE_TIME_DESC=1 CREATE_TIME_DESC value
                     */
                    ListStoreEventRequest.Order = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ORDER_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CREATE_TIME_DESC"] = 1;
                        return values;
                    })();
    
                    return ListStoreEventRequest;
                })();
    
                v1.ListStoreEventResponse = (function() {
    
                    /**
                     * Properties of a ListStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] ListStoreEventResponse events
                     * @property {number|null} [pageSize] ListStoreEventResponse pageSize
                     * @property {number|null} [pageIndex] ListStoreEventResponse pageIndex
                     * @property {number|null} [totalElements] ListStoreEventResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventResponse.
                     * @implements IListStoreEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventResponse=} [properties] Properties to set
                     */
                    function ListStoreEventResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventResponse events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @instance
                     */
                    ListStoreEventResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * ListStoreEventResponse pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @instance
                     */
                    ListStoreEventResponse.prototype.pageSize = 0;
    
                    /**
                     * ListStoreEventResponse pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @instance
                     */
                    ListStoreEventResponse.prototype.pageIndex = 0;
    
                    /**
                     * ListStoreEventResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @instance
                     */
                    ListStoreEventResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStoreEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventResponse} ListStoreEventResponse instance
                     */
                    ListStoreEventResponse.create = function create(properties) {
                        return new ListStoreEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventResponse} message ListStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageIndex);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventResponse} message ListStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventResponse} ListStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageIndex = reader.int32();
                                break;
                            case 4:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventResponse} ListStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventResponse} ListStoreEventResponse
                     */
                    ListStoreEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.ListStoreEventResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventResponse} message ListStoreEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageIndex = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreEventResponse;
                })();
    
                v1.GetStoreEventInsightsRequest = (function() {
    
                    /**
                     * Properties of a GetStoreEventInsightsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreEventInsightsRequest
                     * @property {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter|null} [filter] GetStoreEventInsightsRequest filter
                     * @property {number|null} [pageSize] GetStoreEventInsightsRequest pageSize
                     * @property {number|null} [pageIndex] GetStoreEventInsightsRequest pageIndex
                     * @property {number|null} [samplesPerQuestion] GetStoreEventInsightsRequest samplesPerQuestion
                     */
    
                    /**
                     * Constructs a new GetStoreEventInsightsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreEventInsightsRequest.
                     * @implements IGetStoreEventInsightsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest=} [properties] Properties to set
                     */
                    function GetStoreEventInsightsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreEventInsightsRequest filter.
                     * @member {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @instance
                     */
                    GetStoreEventInsightsRequest.prototype.filter = null;
    
                    /**
                     * GetStoreEventInsightsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @instance
                     */
                    GetStoreEventInsightsRequest.prototype.pageSize = 0;
    
                    /**
                     * GetStoreEventInsightsRequest pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @instance
                     */
                    GetStoreEventInsightsRequest.prototype.pageIndex = 0;
    
                    /**
                     * GetStoreEventInsightsRequest samplesPerQuestion.
                     * @member {number} samplesPerQuestion
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @instance
                     */
                    GetStoreEventInsightsRequest.prototype.samplesPerQuestion = 0;
    
                    /**
                     * Creates a new GetStoreEventInsightsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest} GetStoreEventInsightsRequest instance
                     */
                    GetStoreEventInsightsRequest.create = function create(properties) {
                        return new GetStoreEventInsightsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreEventInsightsRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest} message GetStoreEventInsightsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventInsightsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.encode(message.filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageIndex);
                        if (message.samplesPerQuestion != null && Object.hasOwnProperty.call(message, "samplesPerQuestion"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.samplesPerQuestion);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreEventInsightsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsRequest} message GetStoreEventInsightsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventInsightsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreEventInsightsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest} GetStoreEventInsightsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventInsightsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreEventInsightsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filter = $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageIndex = reader.int32();
                                break;
                            case 4:
                                message.samplesPerQuestion = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreEventInsightsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest} GetStoreEventInsightsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventInsightsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreEventInsightsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreEventInsightsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        if (message.samplesPerQuestion != null && message.hasOwnProperty("samplesPerQuestion"))
                            if (!$util.isInteger(message.samplesPerQuestion))
                                return "samplesPerQuestion: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreEventInsightsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest} GetStoreEventInsightsRequest
                     */
                    GetStoreEventInsightsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreEventInsightsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreEventInsightsRequest();
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.fromObject(object.filter);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        if (object.samplesPerQuestion != null)
                            message.samplesPerQuestion = object.samplesPerQuestion | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreEventInsightsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoreEventInsightsRequest} message GetStoreEventInsightsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreEventInsightsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.filter = null;
                            object.pageSize = 0;
                            object.pageIndex = 0;
                            object.samplesPerQuestion = 0;
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.toObject(message.filter, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        if (message.samplesPerQuestion != null && message.hasOwnProperty("samplesPerQuestion"))
                            object.samplesPerQuestion = message.samplesPerQuestion;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreEventInsightsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreEventInsightsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    GetStoreEventInsightsRequest.InsightsFilter = (function() {
    
                        /**
                         * Properties of an InsightsFilter.
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                         * @interface IInsightsFilter
                         * @property {Array.<number>|null} [storeIds] InsightsFilter storeIds
                         * @property {string|null} [startDate] InsightsFilter startDate
                         * @property {string|null} [endDate] InsightsFilter endDate
                         * @property {Array.<palexy.streaming.v1.StoreEventType>|null} [types] InsightsFilter types
                         * @property {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>|null} [statuses] InsightsFilter statuses
                         * @property {boolean|null} [isTestEvent] InsightsFilter isTestEvent
                         * @property {number|null} [companyId] InsightsFilter companyId
                         * @property {Array.<number>|null} [formIds] InsightsFilter formIds
                         */
    
                        /**
                         * Constructs a new InsightsFilter.
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest
                         * @classdesc Represents an InsightsFilter.
                         * @implements IInsightsFilter
                         * @constructor
                         * @param {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter=} [properties] Properties to set
                         */
                        function InsightsFilter(properties) {
                            this.storeIds = [];
                            this.types = [];
                            this.statuses = [];
                            this.formIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * InsightsFilter storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * InsightsFilter startDate.
                         * @member {string} startDate
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.startDate = "";
    
                        /**
                         * InsightsFilter endDate.
                         * @member {string} endDate
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.endDate = "";
    
                        /**
                         * InsightsFilter types.
                         * @member {Array.<palexy.streaming.v1.StoreEventType>} types
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.types = $util.emptyArray;
    
                        /**
                         * InsightsFilter statuses.
                         * @member {Array.<palexy.streaming.v1.StoreEvent.StoreEventStatus>} statuses
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.statuses = $util.emptyArray;
    
                        /**
                         * InsightsFilter isTestEvent.
                         * @member {boolean} isTestEvent
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.isTestEvent = false;
    
                        /**
                         * InsightsFilter companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * InsightsFilter formIds.
                         * @member {Array.<number>} formIds
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         */
                        InsightsFilter.prototype.formIds = $util.emptyArray;
    
                        /**
                         * Creates a new InsightsFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter} InsightsFilter instance
                         */
                        InsightsFilter.create = function create(properties) {
                            return new InsightsFilter(properties);
                        };
    
                        /**
                         * Encodes the specified InsightsFilter message. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter} message InsightsFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InsightsFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDate);
                            if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDate);
                            if (message.types != null && message.types.length) {
                                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                                for (var i = 0; i < message.types.length; ++i)
                                    writer.int32(message.types[i]);
                                writer.ldelim();
                            }
                            if (message.statuses != null && message.statuses.length) {
                                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                                for (var i = 0; i < message.statuses.length; ++i)
                                    writer.int32(message.statuses[i]);
                                writer.ldelim();
                            }
                            if (message.isTestEvent != null && Object.hasOwnProperty.call(message, "isTestEvent"))
                                writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isTestEvent);
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.companyId);
                            if (message.formIds != null && message.formIds.length) {
                                writer.uint32(/* id 8, wireType 2 =*/66).fork();
                                for (var i = 0; i < message.formIds.length; ++i)
                                    writer.int64(message.formIds[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified InsightsFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {palexy.streaming.v1.GetStoreEventInsightsRequest.IInsightsFilter} message InsightsFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        InsightsFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes an InsightsFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter} InsightsFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InsightsFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 2:
                                    message.startDate = reader.string();
                                    break;
                                case 3:
                                    message.endDate = reader.string();
                                    break;
                                case 4:
                                    if (!(message.types && message.types.length))
                                        message.types = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.types.push(reader.int32());
                                    } else
                                        message.types.push(reader.int32());
                                    break;
                                case 5:
                                    if (!(message.statuses && message.statuses.length))
                                        message.statuses = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.statuses.push(reader.int32());
                                    } else
                                        message.statuses.push(reader.int32());
                                    break;
                                case 6:
                                    message.isTestEvent = reader.bool();
                                    break;
                                case 7:
                                    message.companyId = reader.int64();
                                    break;
                                case 8:
                                    if (!(message.formIds && message.formIds.length))
                                        message.formIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.formIds.push(reader.int64());
                                    } else
                                        message.formIds.push(reader.int64());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes an InsightsFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter} InsightsFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        InsightsFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies an InsightsFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        InsightsFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                if (!$util.isString(message.startDate))
                                    return "startDate: string expected";
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                if (!$util.isString(message.endDate))
                                    return "endDate: string expected";
                            if (message.types != null && message.hasOwnProperty("types")) {
                                if (!Array.isArray(message.types))
                                    return "types: array expected";
                                for (var i = 0; i < message.types.length; ++i)
                                    switch (message.types[i]) {
                                    default:
                                        return "types: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                    case 5:
                                    case 6:
                                    case 7:
                                    case 8:
                                    case 9:
                                    case 10:
                                    case 11:
                                    case 12:
                                    case 13:
                                    case 14:
                                    case 15:
                                    case 16:
                                    case 17:
                                    case 18:
                                    case 19:
                                        break;
                                    }
                            }
                            if (message.statuses != null && message.hasOwnProperty("statuses")) {
                                if (!Array.isArray(message.statuses))
                                    return "statuses: array expected";
                                for (var i = 0; i < message.statuses.length; ++i)
                                    switch (message.statuses[i]) {
                                    default:
                                        return "statuses: enum value[] expected";
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        break;
                                    }
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                if (typeof message.isTestEvent !== "boolean")
                                    return "isTestEvent: boolean expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            if (message.formIds != null && message.hasOwnProperty("formIds")) {
                                if (!Array.isArray(message.formIds))
                                    return "formIds: array expected";
                                for (var i = 0; i < message.formIds.length; ++i)
                                    if (!$util.isInteger(message.formIds[i]) && !(message.formIds[i] && $util.isInteger(message.formIds[i].low) && $util.isInteger(message.formIds[i].high)))
                                        return "formIds: integer|Long[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates an InsightsFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter} InsightsFilter
                         */
                        InsightsFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.startDate != null)
                                message.startDate = String(object.startDate);
                            if (object.endDate != null)
                                message.endDate = String(object.endDate);
                            if (object.types) {
                                if (!Array.isArray(object.types))
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.types: array expected");
                                message.types = [];
                                for (var i = 0; i < object.types.length; ++i)
                                    switch (object.types[i]) {
                                    default:
                                    case "UNKNOWN_STORE_EVENT_TYPE":
                                    case 0:
                                        message.types[i] = 0;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION":
                                    case 1:
                                        message.types[i] = 1;
                                        break;
                                    case "SUSPICIOUS_CASHIER_ACTIVITY":
                                    case 2:
                                        message.types[i] = 2;
                                        break;
                                    case "SOP_NON_COMPLIANCE":
                                    case 3:
                                        message.types[i] = 3;
                                        break;
                                    case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                                    case 4:
                                        message.types[i] = 4;
                                        break;
                                    case "STAFF_GATHERING":
                                    case 5:
                                        message.types[i] = 5;
                                        break;
                                    case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                                    case 6:
                                        message.types[i] = 6;
                                        break;
                                    case "CUSTOMER_NEEDS_ASSISTANCE":
                                    case 7:
                                        message.types[i] = 7;
                                        break;
                                    case "STAFF_NOT_WEAR_GLOVE":
                                    case 8:
                                        message.types[i] = 8;
                                        break;
                                    case "NOT_GREETED_ON_TIME":
                                    case 9:
                                        message.types[i] = 9;
                                        break;
                                    case "STAFF_MISSING":
                                    case 10:
                                        message.types[i] = 10;
                                        break;
                                    case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                                    case 11:
                                        message.types[i] = 11;
                                        break;
                                    case "HIGH_TRAFFIC_CHECKOUT":
                                    case 12:
                                        message.types[i] = 12;
                                        break;
                                    case "LONG_TOTAL_SERVICE_TIME":
                                    case 13:
                                        message.types[i] = 13;
                                        break;
                                    case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                                    case 14:
                                        message.types[i] = 14;
                                        break;
                                    case "LATE_TABLE_CLEANING":
                                    case 15:
                                        message.types[i] = 15;
                                        break;
                                    case "SUSPICIOUS_BILL_CANCELLATION":
                                    case 16:
                                        message.types[i] = 16;
                                        break;
                                    case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                                    case 17:
                                        message.types[i] = 17;
                                        break;
                                    case "LONG_QUEUE":
                                    case 18:
                                        message.types[i] = 18;
                                        break;
                                    case "LONG_CHECKOUT_TIME":
                                    case 19:
                                        message.types[i] = 19;
                                        break;
                                    }
                            }
                            if (object.statuses) {
                                if (!Array.isArray(object.statuses))
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.statuses: array expected");
                                message.statuses = [];
                                for (var i = 0; i < object.statuses.length; ++i)
                                    switch (object.statuses[i]) {
                                    default:
                                    case "UNKNOWN":
                                    case 0:
                                        message.statuses[i] = 0;
                                        break;
                                    case "NOT_REVIEWED":
                                    case 1:
                                        message.statuses[i] = 1;
                                        break;
                                    case "APPROVED":
                                    case 2:
                                        message.statuses[i] = 2;
                                        break;
                                    case "REJECTED":
                                    case 3:
                                        message.statuses[i] = 3;
                                        break;
                                    }
                            }
                            if (object.isTestEvent != null)
                                message.isTestEvent = Boolean(object.isTestEvent);
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            if (object.formIds) {
                                if (!Array.isArray(object.formIds))
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter.formIds: array expected");
                                message.formIds = [];
                                for (var i = 0; i < object.formIds.length; ++i)
                                    if ($util.Long)
                                        (message.formIds[i] = $util.Long.fromValue(object.formIds[i])).unsigned = false;
                                    else if (typeof object.formIds[i] === "string")
                                        message.formIds[i] = parseInt(object.formIds[i], 10);
                                    else if (typeof object.formIds[i] === "number")
                                        message.formIds[i] = object.formIds[i];
                                    else if (typeof object.formIds[i] === "object")
                                        message.formIds[i] = new $util.LongBits(object.formIds[i].low >>> 0, object.formIds[i].high >>> 0).toNumber();
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from an InsightsFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @static
                         * @param {palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter} message InsightsFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        InsightsFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.storeIds = [];
                                object.types = [];
                                object.statuses = [];
                                object.formIds = [];
                            }
                            if (options.defaults) {
                                object.startDate = "";
                                object.endDate = "";
                                object.isTestEvent = false;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                            }
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.startDate != null && message.hasOwnProperty("startDate"))
                                object.startDate = message.startDate;
                            if (message.endDate != null && message.hasOwnProperty("endDate"))
                                object.endDate = message.endDate;
                            if (message.types && message.types.length) {
                                object.types = [];
                                for (var j = 0; j < message.types.length; ++j)
                                    object.types[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.types[j]] : message.types[j];
                            }
                            if (message.statuses && message.statuses.length) {
                                object.statuses = [];
                                for (var j = 0; j < message.statuses.length; ++j)
                                    object.statuses[j] = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.StoreEventStatus[message.statuses[j]] : message.statuses[j];
                            }
                            if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                                object.isTestEvent = message.isTestEvent;
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (message.formIds && message.formIds.length) {
                                object.formIds = [];
                                for (var j = 0; j < message.formIds.length; ++j)
                                    if (typeof message.formIds[j] === "number")
                                        object.formIds[j] = options.longs === String ? String(message.formIds[j]) : message.formIds[j];
                                    else
                                        object.formIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.formIds[j]) : options.longs === Number ? new $util.LongBits(message.formIds[j].low >>> 0, message.formIds[j].high >>> 0).toNumber() : message.formIds[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this InsightsFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.GetStoreEventInsightsRequest.InsightsFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        InsightsFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return InsightsFilter;
                    })();
    
                    return GetStoreEventInsightsRequest;
                })();
    
                v1.QuestionSampleEvents = (function() {
    
                    /**
                     * Properties of a QuestionSampleEvents.
                     * @memberof palexy.streaming.v1
                     * @interface IQuestionSampleEvents
                     * @property {string|null} [internalQuestionId] QuestionSampleEvents internalQuestionId
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] QuestionSampleEvents events
                     */
    
                    /**
                     * Constructs a new QuestionSampleEvents.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a QuestionSampleEvents.
                     * @implements IQuestionSampleEvents
                     * @constructor
                     * @param {palexy.streaming.v1.IQuestionSampleEvents=} [properties] Properties to set
                     */
                    function QuestionSampleEvents(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QuestionSampleEvents internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @instance
                     */
                    QuestionSampleEvents.prototype.internalQuestionId = "";
    
                    /**
                     * QuestionSampleEvents events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @instance
                     */
                    QuestionSampleEvents.prototype.events = $util.emptyArray;
    
                    /**
                     * Creates a new QuestionSampleEvents instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {palexy.streaming.v1.IQuestionSampleEvents=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.QuestionSampleEvents} QuestionSampleEvents instance
                     */
                    QuestionSampleEvents.create = function create(properties) {
                        return new QuestionSampleEvents(properties);
                    };
    
                    /**
                     * Encodes the specified QuestionSampleEvents message. Does not implicitly {@link palexy.streaming.v1.QuestionSampleEvents.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {palexy.streaming.v1.IQuestionSampleEvents} message QuestionSampleEvents message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuestionSampleEvents.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.internalQuestionId);
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QuestionSampleEvents message, length delimited. Does not implicitly {@link palexy.streaming.v1.QuestionSampleEvents.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {palexy.streaming.v1.IQuestionSampleEvents} message QuestionSampleEvents message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuestionSampleEvents.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QuestionSampleEvents message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.QuestionSampleEvents} QuestionSampleEvents
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuestionSampleEvents.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.QuestionSampleEvents();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.internalQuestionId = reader.string();
                                break;
                            case 2:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QuestionSampleEvents message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.QuestionSampleEvents} QuestionSampleEvents
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuestionSampleEvents.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QuestionSampleEvents message.
                     * @function verify
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QuestionSampleEvents.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a QuestionSampleEvents message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.QuestionSampleEvents} QuestionSampleEvents
                     */
                    QuestionSampleEvents.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.QuestionSampleEvents)
                            return object;
                        var message = new $root.palexy.streaming.v1.QuestionSampleEvents();
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.QuestionSampleEvents.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.QuestionSampleEvents.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QuestionSampleEvents message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @static
                     * @param {palexy.streaming.v1.QuestionSampleEvents} message QuestionSampleEvents
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QuestionSampleEvents.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (options.defaults)
                            object.internalQuestionId = "";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this QuestionSampleEvents to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.QuestionSampleEvents
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QuestionSampleEvents.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QuestionSampleEvents;
                })();
    
                v1.GetStoreEventInsightsResponse = (function() {
    
                    /**
                     * Properties of a GetStoreEventInsightsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoreEventInsightsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEvent>|null} [events] GetStoreEventInsightsResponse events
                     * @property {number|null} [pageSize] GetStoreEventInsightsResponse pageSize
                     * @property {number|null} [pageIndex] GetStoreEventInsightsResponse pageIndex
                     * @property {number|null} [totalElements] GetStoreEventInsightsResponse totalElements
                     * @property {Array.<palexy.task_management.v1.ISubmissionStatistics>|null} [stats] GetStoreEventInsightsResponse stats
                     * @property {Array.<palexy.streaming.v1.IQuestionSampleEvents>|null} [questionSamples] GetStoreEventInsightsResponse questionSamples
                     */
    
                    /**
                     * Constructs a new GetStoreEventInsightsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoreEventInsightsResponse.
                     * @implements IGetStoreEventInsightsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsResponse=} [properties] Properties to set
                     */
                    function GetStoreEventInsightsResponse(properties) {
                        this.events = [];
                        this.stats = [];
                        this.questionSamples = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreEventInsightsResponse events.
                     * @member {Array.<palexy.streaming.v1.IStoreEvent>} events
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * GetStoreEventInsightsResponse pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.pageSize = 0;
    
                    /**
                     * GetStoreEventInsightsResponse pageIndex.
                     * @member {number} pageIndex
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.pageIndex = 0;
    
                    /**
                     * GetStoreEventInsightsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetStoreEventInsightsResponse stats.
                     * @member {Array.<palexy.task_management.v1.ISubmissionStatistics>} stats
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.stats = $util.emptyArray;
    
                    /**
                     * GetStoreEventInsightsResponse questionSamples.
                     * @member {Array.<palexy.streaming.v1.IQuestionSampleEvents>} questionSamples
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     */
                    GetStoreEventInsightsResponse.prototype.questionSamples = $util.emptyArray;
    
                    /**
                     * Creates a new GetStoreEventInsightsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsResponse} GetStoreEventInsightsResponse instance
                     */
                    GetStoreEventInsightsResponse.create = function create(properties) {
                        return new GetStoreEventInsightsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreEventInsightsResponse message. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsResponse} message GetStoreEventInsightsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventInsightsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.StoreEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageIndex != null && Object.hasOwnProperty.call(message, "pageIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageIndex);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalElements);
                        if (message.stats != null && message.stats.length)
                            for (var i = 0; i < message.stats.length; ++i)
                                $root.palexy.task_management.v1.SubmissionStatistics.encode(message.stats[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.questionSamples != null && message.questionSamples.length)
                            for (var i = 0; i < message.questionSamples.length; ++i)
                                $root.palexy.streaming.v1.QuestionSampleEvents.encode(message.questionSamples[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreEventInsightsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoreEventInsightsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoreEventInsightsResponse} message GetStoreEventInsightsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreEventInsightsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreEventInsightsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsResponse} GetStoreEventInsightsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventInsightsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoreEventInsightsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.StoreEvent.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageIndex = reader.int32();
                                break;
                            case 4:
                                message.totalElements = reader.int64();
                                break;
                            case 5:
                                if (!(message.stats && message.stats.length))
                                    message.stats = [];
                                message.stats.push($root.palexy.task_management.v1.SubmissionStatistics.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                if (!(message.questionSamples && message.questionSamples.length))
                                    message.questionSamples = [];
                                message.questionSamples.push($root.palexy.streaming.v1.QuestionSampleEvents.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreEventInsightsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsResponse} GetStoreEventInsightsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreEventInsightsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreEventInsightsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreEventInsightsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            if (!$util.isInteger(message.pageIndex))
                                return "pageIndex: integer expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.stats != null && message.hasOwnProperty("stats")) {
                            if (!Array.isArray(message.stats))
                                return "stats: array expected";
                            for (var i = 0; i < message.stats.length; ++i) {
                                var error = $root.palexy.task_management.v1.SubmissionStatistics.verify(message.stats[i]);
                                if (error)
                                    return "stats." + error;
                            }
                        }
                        if (message.questionSamples != null && message.hasOwnProperty("questionSamples")) {
                            if (!Array.isArray(message.questionSamples))
                                return "questionSamples: array expected";
                            for (var i = 0; i < message.questionSamples.length; ++i) {
                                var error = $root.palexy.streaming.v1.QuestionSampleEvents.verify(message.questionSamples[i]);
                                if (error)
                                    return "questionSamples." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreEventInsightsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoreEventInsightsResponse} GetStoreEventInsightsResponse
                     */
                    GetStoreEventInsightsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoreEventInsightsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoreEventInsightsResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.StoreEvent.fromObject(object.events[i]);
                            }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageIndex != null)
                            message.pageIndex = object.pageIndex | 0;
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.stats) {
                            if (!Array.isArray(object.stats))
                                throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.stats: array expected");
                            message.stats = [];
                            for (var i = 0; i < object.stats.length; ++i) {
                                if (typeof object.stats[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.stats: object expected");
                                message.stats[i] = $root.palexy.task_management.v1.SubmissionStatistics.fromObject(object.stats[i]);
                            }
                        }
                        if (object.questionSamples) {
                            if (!Array.isArray(object.questionSamples))
                                throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.questionSamples: array expected");
                            message.questionSamples = [];
                            for (var i = 0; i < object.questionSamples.length; ++i) {
                                if (typeof object.questionSamples[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStoreEventInsightsResponse.questionSamples: object expected");
                                message.questionSamples[i] = $root.palexy.streaming.v1.QuestionSampleEvents.fromObject(object.questionSamples[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreEventInsightsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @static
                     * @param {palexy.streaming.v1.GetStoreEventInsightsResponse} message GetStoreEventInsightsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreEventInsightsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.events = [];
                            object.stats = [];
                            object.questionSamples = [];
                        }
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageIndex = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.StoreEvent.toObject(message.events[j], options);
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageIndex != null && message.hasOwnProperty("pageIndex"))
                            object.pageIndex = message.pageIndex;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.stats && message.stats.length) {
                            object.stats = [];
                            for (var j = 0; j < message.stats.length; ++j)
                                object.stats[j] = $root.palexy.task_management.v1.SubmissionStatistics.toObject(message.stats[j], options);
                        }
                        if (message.questionSamples && message.questionSamples.length) {
                            object.questionSamples = [];
                            for (var j = 0; j < message.questionSamples.length; ++j)
                                object.questionSamples[j] = $root.palexy.streaming.v1.QuestionSampleEvents.toObject(message.questionSamples[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreEventInsightsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoreEventInsightsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreEventInsightsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreEventInsightsResponse;
                })();
    
                /**
                 * StoreEventType enum.
                 * @name palexy.streaming.v1.StoreEventType
                 * @enum {number}
                 * @property {number} UNKNOWN_STORE_EVENT_TYPE=0 UNKNOWN_STORE_EVENT_TYPE value
                 * @property {number} MISSED_CUSTOMER_INTERACTION=1 MISSED_CUSTOMER_INTERACTION value
                 * @property {number} SUSPICIOUS_CASHIER_ACTIVITY=2 SUSPICIOUS_CASHIER_ACTIVITY value
                 * @property {number} SOP_NON_COMPLIANCE=3 SOP_NON_COMPLIANCE value
                 * @property {number} STAFF_ATTENDANCE_NON_COMPLIANCE=4 STAFF_ATTENDANCE_NON_COMPLIANCE value
                 * @property {number} STAFF_GATHERING=5 STAFF_GATHERING value
                 * @property {number} STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE=6 STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE value
                 * @property {number} CUSTOMER_NEEDS_ASSISTANCE=7 CUSTOMER_NEEDS_ASSISTANCE value
                 * @property {number} STAFF_NOT_WEAR_GLOVE=8 STAFF_NOT_WEAR_GLOVE value
                 * @property {number} NOT_GREETED_ON_TIME=9 NOT_GREETED_ON_TIME value
                 * @property {number} STAFF_MISSING=10 STAFF_MISSING value
                 * @property {number} STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP=11 STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP value
                 * @property {number} HIGH_TRAFFIC_CHECKOUT=12 HIGH_TRAFFIC_CHECKOUT value
                 * @property {number} LONG_TOTAL_SERVICE_TIME=13 LONG_TOTAL_SERVICE_TIME value
                 * @property {number} MISSED_CUSTOMER_INTERACTION_AT_SECTION=14 MISSED_CUSTOMER_INTERACTION_AT_SECTION value
                 * @property {number} LATE_TABLE_CLEANING=15 LATE_TABLE_CLEANING value
                 * @property {number} SUSPICIOUS_BILL_CANCELLATION=16 SUSPICIOUS_BILL_CANCELLATION value
                 * @property {number} PREPARE_DRINK_WITHOUT_AUTHORIZATION=17 PREPARE_DRINK_WITHOUT_AUTHORIZATION value
                 * @property {number} LONG_QUEUE=18 LONG_QUEUE value
                 * @property {number} LONG_CHECKOUT_TIME=19 LONG_CHECKOUT_TIME value
                 */
                v1.StoreEventType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_STORE_EVENT_TYPE"] = 0;
                    values[valuesById[1] = "MISSED_CUSTOMER_INTERACTION"] = 1;
                    values[valuesById[2] = "SUSPICIOUS_CASHIER_ACTIVITY"] = 2;
                    values[valuesById[3] = "SOP_NON_COMPLIANCE"] = 3;
                    values[valuesById[4] = "STAFF_ATTENDANCE_NON_COMPLIANCE"] = 4;
                    values[valuesById[5] = "STAFF_GATHERING"] = 5;
                    values[valuesById[6] = "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE"] = 6;
                    values[valuesById[7] = "CUSTOMER_NEEDS_ASSISTANCE"] = 7;
                    values[valuesById[8] = "STAFF_NOT_WEAR_GLOVE"] = 8;
                    values[valuesById[9] = "NOT_GREETED_ON_TIME"] = 9;
                    values[valuesById[10] = "STAFF_MISSING"] = 10;
                    values[valuesById[11] = "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP"] = 11;
                    values[valuesById[12] = "HIGH_TRAFFIC_CHECKOUT"] = 12;
                    values[valuesById[13] = "LONG_TOTAL_SERVICE_TIME"] = 13;
                    values[valuesById[14] = "MISSED_CUSTOMER_INTERACTION_AT_SECTION"] = 14;
                    values[valuesById[15] = "LATE_TABLE_CLEANING"] = 15;
                    values[valuesById[16] = "SUSPICIOUS_BILL_CANCELLATION"] = 16;
                    values[valuesById[17] = "PREPARE_DRINK_WITHOUT_AUTHORIZATION"] = 17;
                    values[valuesById[18] = "LONG_QUEUE"] = 18;
                    values[valuesById[19] = "LONG_CHECKOUT_TIME"] = 19;
                    return values;
                })();
    
                v1.StoreEvent = (function() {
    
                    /**
                     * Properties of a StoreEvent.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreEvent
                     * @property {number|null} [id] StoreEvent id
                     * @property {palexy.streaming.v1.StoreEventType|null} [type] StoreEvent type
                     * @property {number|null} [storeId] StoreEvent storeId
                     * @property {string|null} [dateId] StoreEvent dateId
                     * @property {google.protobuf.ITimestamp|null} [startTime] StoreEvent startTime
                     * @property {number|null} [durationInSeconds] StoreEvent durationInSeconds
                     * @property {palexy.streaming.v1.IStoreEventDetails|null} [details] StoreEvent details
                     * @property {Array.<string>|null} [cameraIds] StoreEvent cameraIds
                     * @property {boolean|null} [isRealtime] StoreEvent isRealtime
                     * @property {palexy.streaming.v1.StoreEvent.StoreEventStatus|null} [status] StoreEvent status
                     * @property {string|null} [description] StoreEvent description
                     * @property {string|null} [latestReviewReason] StoreEvent latestReviewReason
                     * @property {boolean|null} [isTestEvent] StoreEvent isTestEvent
                     * @property {google.protobuf.ITimestamp|null} [createTime] StoreEvent createTime
                     * @property {google.protobuf.ITimestamp|null} [updateTime] StoreEvent updateTime
                     * @property {google.protobuf.ITimestamp|null} [artifactsCleanupTime] StoreEvent artifactsCleanupTime
                     * @property {palexy.streaming.v1.StoreEvent.Priority|null} [priority] StoreEvent priority
                     */
    
                    /**
                     * Constructs a new StoreEvent.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEvent.
                     * @implements IStoreEvent
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreEvent=} [properties] Properties to set
                     */
                    function StoreEvent(properties) {
                        this.cameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEvent id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEvent type.
                     * @member {palexy.streaming.v1.StoreEventType} type
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.type = 0;
    
                    /**
                     * StoreEvent storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEvent dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.dateId = "";
    
                    /**
                     * StoreEvent startTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} startTime
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.startTime = null;
    
                    /**
                     * StoreEvent durationInSeconds.
                     * @member {number} durationInSeconds
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.durationInSeconds = 0;
    
                    /**
                     * StoreEvent details.
                     * @member {palexy.streaming.v1.IStoreEventDetails|null|undefined} details
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.details = null;
    
                    /**
                     * StoreEvent cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * StoreEvent isRealtime.
                     * @member {boolean} isRealtime
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.isRealtime = false;
    
                    /**
                     * StoreEvent status.
                     * @member {palexy.streaming.v1.StoreEvent.StoreEventStatus} status
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.status = 0;
    
                    /**
                     * StoreEvent description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.description = "";
    
                    /**
                     * StoreEvent latestReviewReason.
                     * @member {string} latestReviewReason
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.latestReviewReason = "";
    
                    /**
                     * StoreEvent isTestEvent.
                     * @member {boolean} isTestEvent
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.isTestEvent = false;
    
                    /**
                     * StoreEvent createTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} createTime
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.createTime = null;
    
                    /**
                     * StoreEvent updateTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} updateTime
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.updateTime = null;
    
                    /**
                     * StoreEvent artifactsCleanupTime.
                     * @member {google.protobuf.ITimestamp|null|undefined} artifactsCleanupTime
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.artifactsCleanupTime = null;
    
                    /**
                     * StoreEvent priority.
                     * @member {palexy.streaming.v1.StoreEvent.Priority} priority
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     */
                    StoreEvent.prototype.priority = 0;
    
                    /**
                     * Creates a new StoreEvent instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {palexy.streaming.v1.IStoreEvent=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreEvent} StoreEvent instance
                     */
                    StoreEvent.create = function create(properties) {
                        return new StoreEvent(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEvent message. Does not implicitly {@link palexy.streaming.v1.StoreEvent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {palexy.streaming.v1.IStoreEvent} message StoreEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEvent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.dateId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            $root.google.protobuf.Timestamp.encode(message.startTime, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.durationInSeconds != null && Object.hasOwnProperty.call(message, "durationInSeconds"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.durationInSeconds);
                        if (message.details != null && Object.hasOwnProperty.call(message, "details"))
                            $root.palexy.streaming.v1.StoreEventDetails.encode(message.details, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.cameraIds[i]);
                        if (message.isRealtime != null && Object.hasOwnProperty.call(message, "isRealtime"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isRealtime);
                        if (message.createTime != null && Object.hasOwnProperty.call(message, "createTime"))
                            $root.google.protobuf.Timestamp.encode(message.createTime, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.updateTime != null && Object.hasOwnProperty.call(message, "updateTime"))
                            $root.google.protobuf.Timestamp.encode(message.updateTime, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.status);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.description);
                        if (message.latestReviewReason != null && Object.hasOwnProperty.call(message, "latestReviewReason"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.latestReviewReason);
                        if (message.isTestEvent != null && Object.hasOwnProperty.call(message, "isTestEvent"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isTestEvent);
                        if (message.artifactsCleanupTime != null && Object.hasOwnProperty.call(message, "artifactsCleanupTime"))
                            $root.google.protobuf.Timestamp.encode(message.artifactsCleanupTime, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.priority);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEvent message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEvent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {palexy.streaming.v1.IStoreEvent} message StoreEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEvent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEvent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreEvent} StoreEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEvent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEvent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.type = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.string();
                                break;
                            case 5:
                                message.startTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.durationInSeconds = reader.int32();
                                break;
                            case 7:
                                message.details = $root.palexy.streaming.v1.StoreEventDetails.decode(reader, reader.uint32());
                                break;
                            case 8:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            case 9:
                                message.isRealtime = reader.bool();
                                break;
                            case 12:
                                message.status = reader.int32();
                                break;
                            case 13:
                                message.description = reader.string();
                                break;
                            case 14:
                                message.latestReviewReason = reader.string();
                                break;
                            case 15:
                                message.isTestEvent = reader.bool();
                                break;
                            case 10:
                                message.createTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.updateTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.artifactsCleanupTime = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.priority = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEvent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreEvent} StoreEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEvent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEvent message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEvent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                                break;
                            }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.startTime);
                            if (error)
                                return "startTime." + error;
                        }
                        if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                            if (!$util.isInteger(message.durationInSeconds))
                                return "durationInSeconds: integer expected";
                        if (message.details != null && message.hasOwnProperty("details")) {
                            var error = $root.palexy.streaming.v1.StoreEventDetails.verify(message.details);
                            if (error)
                                return "details." + error;
                        }
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        if (message.isRealtime != null && message.hasOwnProperty("isRealtime"))
                            if (typeof message.isRealtime !== "boolean")
                                return "isRealtime: boolean expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.latestReviewReason != null && message.hasOwnProperty("latestReviewReason"))
                            if (!$util.isString(message.latestReviewReason))
                                return "latestReviewReason: string expected";
                        if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                            if (typeof message.isTestEvent !== "boolean")
                                return "isTestEvent: boolean expected";
                        if (message.createTime != null && message.hasOwnProperty("createTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.createTime);
                            if (error)
                                return "createTime." + error;
                        }
                        if (message.updateTime != null && message.hasOwnProperty("updateTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.updateTime);
                            if (error)
                                return "updateTime." + error;
                        }
                        if (message.artifactsCleanupTime != null && message.hasOwnProperty("artifactsCleanupTime")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.artifactsCleanupTime);
                            if (error)
                                return "artifactsCleanupTime." + error;
                        }
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            switch (message.priority) {
                            default:
                                return "priority: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a StoreEvent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreEvent} StoreEvent
                     */
                    StoreEvent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreEvent)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreEvent();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN_STORE_EVENT_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "MISSED_CUSTOMER_INTERACTION":
                        case 1:
                            message.type = 1;
                            break;
                        case "SUSPICIOUS_CASHIER_ACTIVITY":
                        case 2:
                            message.type = 2;
                            break;
                        case "SOP_NON_COMPLIANCE":
                        case 3:
                            message.type = 3;
                            break;
                        case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                        case 4:
                            message.type = 4;
                            break;
                        case "STAFF_GATHERING":
                        case 5:
                            message.type = 5;
                            break;
                        case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                        case 6:
                            message.type = 6;
                            break;
                        case "CUSTOMER_NEEDS_ASSISTANCE":
                        case 7:
                            message.type = 7;
                            break;
                        case "STAFF_NOT_WEAR_GLOVE":
                        case 8:
                            message.type = 8;
                            break;
                        case "NOT_GREETED_ON_TIME":
                        case 9:
                            message.type = 9;
                            break;
                        case "STAFF_MISSING":
                        case 10:
                            message.type = 10;
                            break;
                        case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                        case 11:
                            message.type = 11;
                            break;
                        case "HIGH_TRAFFIC_CHECKOUT":
                        case 12:
                            message.type = 12;
                            break;
                        case "LONG_TOTAL_SERVICE_TIME":
                        case 13:
                            message.type = 13;
                            break;
                        case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                        case 14:
                            message.type = 14;
                            break;
                        case "LATE_TABLE_CLEANING":
                        case 15:
                            message.type = 15;
                            break;
                        case "SUSPICIOUS_BILL_CANCELLATION":
                        case 16:
                            message.type = 16;
                            break;
                        case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                        case 17:
                            message.type = 17;
                            break;
                        case "LONG_QUEUE":
                        case 18:
                            message.type = 18;
                            break;
                        case "LONG_CHECKOUT_TIME":
                        case 19:
                            message.type = 19;
                            break;
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.startTime != null) {
                            if (typeof object.startTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEvent.startTime: object expected");
                            message.startTime = $root.google.protobuf.Timestamp.fromObject(object.startTime);
                        }
                        if (object.durationInSeconds != null)
                            message.durationInSeconds = object.durationInSeconds | 0;
                        if (object.details != null) {
                            if (typeof object.details !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEvent.details: object expected");
                            message.details = $root.palexy.streaming.v1.StoreEventDetails.fromObject(object.details);
                        }
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.StoreEvent.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        if (object.isRealtime != null)
                            message.isRealtime = Boolean(object.isRealtime);
                        switch (object.status) {
                        case "UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "NOT_REVIEWED":
                        case 1:
                            message.status = 1;
                            break;
                        case "APPROVED":
                        case 2:
                            message.status = 2;
                            break;
                        case "REJECTED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.latestReviewReason != null)
                            message.latestReviewReason = String(object.latestReviewReason);
                        if (object.isTestEvent != null)
                            message.isTestEvent = Boolean(object.isTestEvent);
                        if (object.createTime != null) {
                            if (typeof object.createTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEvent.createTime: object expected");
                            message.createTime = $root.google.protobuf.Timestamp.fromObject(object.createTime);
                        }
                        if (object.updateTime != null) {
                            if (typeof object.updateTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEvent.updateTime: object expected");
                            message.updateTime = $root.google.protobuf.Timestamp.fromObject(object.updateTime);
                        }
                        if (object.artifactsCleanupTime != null) {
                            if (typeof object.artifactsCleanupTime !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEvent.artifactsCleanupTime: object expected");
                            message.artifactsCleanupTime = $root.google.protobuf.Timestamp.fromObject(object.artifactsCleanupTime);
                        }
                        switch (object.priority) {
                        case "PRIORITY_UNKNOWN":
                        case 0:
                            message.priority = 0;
                            break;
                        case "LOW":
                        case 1:
                            message.priority = 1;
                            break;
                        case "MEDIUM":
                        case 2:
                            message.priority = 2;
                            break;
                        case "HIGH":
                        case 3:
                            message.priority = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEvent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @static
                     * @param {palexy.streaming.v1.StoreEvent} message StoreEvent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEvent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameraIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN_STORE_EVENT_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.startTime = null;
                            object.durationInSeconds = 0;
                            object.details = null;
                            object.isRealtime = false;
                            object.createTime = null;
                            object.updateTime = null;
                            object.status = options.enums === String ? "UNKNOWN" : 0;
                            object.description = "";
                            object.latestReviewReason = "";
                            object.isTestEvent = false;
                            object.artifactsCleanupTime = null;
                            object.priority = options.enums === String ? "PRIORITY_UNKNOWN" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.type] : message.type;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = $root.google.protobuf.Timestamp.toObject(message.startTime, options);
                        if (message.durationInSeconds != null && message.hasOwnProperty("durationInSeconds"))
                            object.durationInSeconds = message.durationInSeconds;
                        if (message.details != null && message.hasOwnProperty("details"))
                            object.details = $root.palexy.streaming.v1.StoreEventDetails.toObject(message.details, options);
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        if (message.isRealtime != null && message.hasOwnProperty("isRealtime"))
                            object.isRealtime = message.isRealtime;
                        if (message.createTime != null && message.hasOwnProperty("createTime"))
                            object.createTime = $root.google.protobuf.Timestamp.toObject(message.createTime, options);
                        if (message.updateTime != null && message.hasOwnProperty("updateTime"))
                            object.updateTime = $root.google.protobuf.Timestamp.toObject(message.updateTime, options);
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.StoreEventStatus[message.status] : message.status;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.latestReviewReason != null && message.hasOwnProperty("latestReviewReason"))
                            object.latestReviewReason = message.latestReviewReason;
                        if (message.isTestEvent != null && message.hasOwnProperty("isTestEvent"))
                            object.isTestEvent = message.isTestEvent;
                        if (message.artifactsCleanupTime != null && message.hasOwnProperty("artifactsCleanupTime"))
                            object.artifactsCleanupTime = $root.google.protobuf.Timestamp.toObject(message.artifactsCleanupTime, options);
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            object.priority = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.Priority[message.priority] : message.priority;
                        return object;
                    };
    
                    /**
                     * Converts this StoreEvent to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreEvent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEvent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * StoreEventStatus enum.
                     * @name palexy.streaming.v1.StoreEvent.StoreEventStatus
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} NOT_REVIEWED=1 NOT_REVIEWED value
                     * @property {number} APPROVED=2 APPROVED value
                     * @property {number} REJECTED=3 REJECTED value
                     */
                    StoreEvent.StoreEventStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "NOT_REVIEWED"] = 1;
                        values[valuesById[2] = "APPROVED"] = 2;
                        values[valuesById[3] = "REJECTED"] = 3;
                        return values;
                    })();
    
                    /**
                     * Priority enum.
                     * @name palexy.streaming.v1.StoreEvent.Priority
                     * @enum {number}
                     * @property {number} PRIORITY_UNKNOWN=0 PRIORITY_UNKNOWN value
                     * @property {number} LOW=1 LOW value
                     * @property {number} MEDIUM=2 MEDIUM value
                     * @property {number} HIGH=3 HIGH value
                     */
                    StoreEvent.Priority = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PRIORITY_UNKNOWN"] = 0;
                        values[valuesById[1] = "LOW"] = 1;
                        values[valuesById[2] = "MEDIUM"] = 2;
                        values[valuesById[3] = "HIGH"] = 3;
                        return values;
                    })();
    
                    return StoreEvent;
                })();
    
                v1.CriticalMoment = (function() {
    
                    /**
                     * Properties of a CriticalMoment.
                     * @memberof palexy.streaming.v1
                     * @interface ICriticalMoment
                     * @property {string|null} [label] CriticalMoment label
                     * @property {number|null} [momentInSecond] CriticalMoment momentInSecond
                     */
    
                    /**
                     * Constructs a new CriticalMoment.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CriticalMoment.
                     * @implements ICriticalMoment
                     * @constructor
                     * @param {palexy.streaming.v1.ICriticalMoment=} [properties] Properties to set
                     */
                    function CriticalMoment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CriticalMoment label.
                     * @member {string} label
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @instance
                     */
                    CriticalMoment.prototype.label = "";
    
                    /**
                     * CriticalMoment momentInSecond.
                     * @member {number} momentInSecond
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @instance
                     */
                    CriticalMoment.prototype.momentInSecond = 0;
    
                    /**
                     * Creates a new CriticalMoment instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {palexy.streaming.v1.ICriticalMoment=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CriticalMoment} CriticalMoment instance
                     */
                    CriticalMoment.create = function create(properties) {
                        return new CriticalMoment(properties);
                    };
    
                    /**
                     * Encodes the specified CriticalMoment message. Does not implicitly {@link palexy.streaming.v1.CriticalMoment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {palexy.streaming.v1.ICriticalMoment} message CriticalMoment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CriticalMoment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
                        if (message.momentInSecond != null && Object.hasOwnProperty.call(message, "momentInSecond"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.momentInSecond);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CriticalMoment message, length delimited. Does not implicitly {@link palexy.streaming.v1.CriticalMoment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {palexy.streaming.v1.ICriticalMoment} message CriticalMoment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CriticalMoment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CriticalMoment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CriticalMoment} CriticalMoment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CriticalMoment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CriticalMoment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.label = reader.string();
                                break;
                            case 2:
                                message.momentInSecond = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CriticalMoment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CriticalMoment} CriticalMoment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CriticalMoment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CriticalMoment message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CriticalMoment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        if (message.momentInSecond != null && message.hasOwnProperty("momentInSecond"))
                            if (!$util.isInteger(message.momentInSecond))
                                return "momentInSecond: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CriticalMoment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CriticalMoment} CriticalMoment
                     */
                    CriticalMoment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CriticalMoment)
                            return object;
                        var message = new $root.palexy.streaming.v1.CriticalMoment();
                        if (object.label != null)
                            message.label = String(object.label);
                        if (object.momentInSecond != null)
                            message.momentInSecond = object.momentInSecond | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CriticalMoment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @static
                     * @param {palexy.streaming.v1.CriticalMoment} message CriticalMoment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CriticalMoment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.label = "";
                            object.momentInSecond = 0;
                        }
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        if (message.momentInSecond != null && message.hasOwnProperty("momentInSecond"))
                            object.momentInSecond = message.momentInSecond;
                        return object;
                    };
    
                    /**
                     * Converts this CriticalMoment to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CriticalMoment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CriticalMoment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CriticalMoment;
                })();
    
                v1.StoreEventReviewLog = (function() {
    
                    /**
                     * Properties of a StoreEventReviewLog.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreEventReviewLog
                     * @property {number|null} [id] StoreEventReviewLog id
                     * @property {number|null} [reviewerId] StoreEventReviewLog reviewerId
                     * @property {string|null} [reviewerAccountName] StoreEventReviewLog reviewerAccountName
                     * @property {number|null} [storeEventId] StoreEventReviewLog storeEventId
                     * @property {number|null} [reviewTimeMs] StoreEventReviewLog reviewTimeMs
                     * @property {palexy.streaming.v1.StoreEventReviewLog.ReviewStatus|null} [storeEventStatus] StoreEventReviewLog storeEventStatus
                     * @property {string|null} [reason] StoreEventReviewLog reason
                     */
    
                    /**
                     * Constructs a new StoreEventReviewLog.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEventReviewLog.
                     * @implements IStoreEventReviewLog
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreEventReviewLog=} [properties] Properties to set
                     */
                    function StoreEventReviewLog(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEventReviewLog id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventReviewLog reviewerId.
                     * @member {number} reviewerId
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.reviewerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventReviewLog reviewerAccountName.
                     * @member {string} reviewerAccountName
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.reviewerAccountName = "";
    
                    /**
                     * StoreEventReviewLog storeEventId.
                     * @member {number} storeEventId
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.storeEventId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventReviewLog reviewTimeMs.
                     * @member {number} reviewTimeMs
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.reviewTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventReviewLog storeEventStatus.
                     * @member {palexy.streaming.v1.StoreEventReviewLog.ReviewStatus} storeEventStatus
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.storeEventStatus = 0;
    
                    /**
                     * StoreEventReviewLog reason.
                     * @member {string} reason
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     */
                    StoreEventReviewLog.prototype.reason = "";
    
                    /**
                     * Creates a new StoreEventReviewLog instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventReviewLog=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreEventReviewLog} StoreEventReviewLog instance
                     */
                    StoreEventReviewLog.create = function create(properties) {
                        return new StoreEventReviewLog(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEventReviewLog message. Does not implicitly {@link palexy.streaming.v1.StoreEventReviewLog.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventReviewLog} message StoreEventReviewLog message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventReviewLog.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.reviewerId != null && Object.hasOwnProperty.call(message, "reviewerId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.reviewerId);
                        if (message.reviewerAccountName != null && Object.hasOwnProperty.call(message, "reviewerAccountName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.reviewerAccountName);
                        if (message.storeEventId != null && Object.hasOwnProperty.call(message, "storeEventId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.storeEventId);
                        if (message.reviewTimeMs != null && Object.hasOwnProperty.call(message, "reviewTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.reviewTimeMs);
                        if (message.storeEventStatus != null && Object.hasOwnProperty.call(message, "storeEventStatus"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.storeEventStatus);
                        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.reason);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEventReviewLog message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEventReviewLog.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventReviewLog} message StoreEventReviewLog message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventReviewLog.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEventReviewLog message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreEventReviewLog} StoreEventReviewLog
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventReviewLog.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEventReviewLog();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.reviewerId = reader.int64();
                                break;
                            case 3:
                                message.reviewerAccountName = reader.string();
                                break;
                            case 4:
                                message.storeEventId = reader.int64();
                                break;
                            case 5:
                                message.reviewTimeMs = reader.int64();
                                break;
                            case 6:
                                message.storeEventStatus = reader.int32();
                                break;
                            case 7:
                                message.reason = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEventReviewLog message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreEventReviewLog} StoreEventReviewLog
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventReviewLog.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEventReviewLog message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEventReviewLog.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.reviewerId != null && message.hasOwnProperty("reviewerId"))
                            if (!$util.isInteger(message.reviewerId) && !(message.reviewerId && $util.isInteger(message.reviewerId.low) && $util.isInteger(message.reviewerId.high)))
                                return "reviewerId: integer|Long expected";
                        if (message.reviewerAccountName != null && message.hasOwnProperty("reviewerAccountName"))
                            if (!$util.isString(message.reviewerAccountName))
                                return "reviewerAccountName: string expected";
                        if (message.storeEventId != null && message.hasOwnProperty("storeEventId"))
                            if (!$util.isInteger(message.storeEventId) && !(message.storeEventId && $util.isInteger(message.storeEventId.low) && $util.isInteger(message.storeEventId.high)))
                                return "storeEventId: integer|Long expected";
                        if (message.reviewTimeMs != null && message.hasOwnProperty("reviewTimeMs"))
                            if (!$util.isInteger(message.reviewTimeMs) && !(message.reviewTimeMs && $util.isInteger(message.reviewTimeMs.low) && $util.isInteger(message.reviewTimeMs.high)))
                                return "reviewTimeMs: integer|Long expected";
                        if (message.storeEventStatus != null && message.hasOwnProperty("storeEventStatus"))
                            switch (message.storeEventStatus) {
                            default:
                                return "storeEventStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            if (!$util.isString(message.reason))
                                return "reason: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreEventReviewLog message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreEventReviewLog} StoreEventReviewLog
                     */
                    StoreEventReviewLog.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreEventReviewLog)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreEventReviewLog();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.reviewerId != null)
                            if ($util.Long)
                                (message.reviewerId = $util.Long.fromValue(object.reviewerId)).unsigned = false;
                            else if (typeof object.reviewerId === "string")
                                message.reviewerId = parseInt(object.reviewerId, 10);
                            else if (typeof object.reviewerId === "number")
                                message.reviewerId = object.reviewerId;
                            else if (typeof object.reviewerId === "object")
                                message.reviewerId = new $util.LongBits(object.reviewerId.low >>> 0, object.reviewerId.high >>> 0).toNumber();
                        if (object.reviewerAccountName != null)
                            message.reviewerAccountName = String(object.reviewerAccountName);
                        if (object.storeEventId != null)
                            if ($util.Long)
                                (message.storeEventId = $util.Long.fromValue(object.storeEventId)).unsigned = false;
                            else if (typeof object.storeEventId === "string")
                                message.storeEventId = parseInt(object.storeEventId, 10);
                            else if (typeof object.storeEventId === "number")
                                message.storeEventId = object.storeEventId;
                            else if (typeof object.storeEventId === "object")
                                message.storeEventId = new $util.LongBits(object.storeEventId.low >>> 0, object.storeEventId.high >>> 0).toNumber();
                        if (object.reviewTimeMs != null)
                            if ($util.Long)
                                (message.reviewTimeMs = $util.Long.fromValue(object.reviewTimeMs)).unsigned = false;
                            else if (typeof object.reviewTimeMs === "string")
                                message.reviewTimeMs = parseInt(object.reviewTimeMs, 10);
                            else if (typeof object.reviewTimeMs === "number")
                                message.reviewTimeMs = object.reviewTimeMs;
                            else if (typeof object.reviewTimeMs === "object")
                                message.reviewTimeMs = new $util.LongBits(object.reviewTimeMs.low >>> 0, object.reviewTimeMs.high >>> 0).toNumber();
                        switch (object.storeEventStatus) {
                        case "UNKNOWN":
                        case 0:
                            message.storeEventStatus = 0;
                            break;
                        case "APPROVED":
                        case 1:
                            message.storeEventStatus = 1;
                            break;
                        case "REJECTED":
                        case 2:
                            message.storeEventStatus = 2;
                            break;
                        case "COMMENTED":
                        case 3:
                            message.storeEventStatus = 3;
                            break;
                        case "VIEWED":
                        case 4:
                            message.storeEventStatus = 4;
                            break;
                        }
                        if (object.reason != null)
                            message.reason = String(object.reason);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEventReviewLog message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @static
                     * @param {palexy.streaming.v1.StoreEventReviewLog} message StoreEventReviewLog
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEventReviewLog.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.reviewerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.reviewerId = options.longs === String ? "0" : 0;
                            object.reviewerAccountName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeEventId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeEventId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.reviewTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.reviewTimeMs = options.longs === String ? "0" : 0;
                            object.storeEventStatus = options.enums === String ? "UNKNOWN" : 0;
                            object.reason = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.reviewerId != null && message.hasOwnProperty("reviewerId"))
                            if (typeof message.reviewerId === "number")
                                object.reviewerId = options.longs === String ? String(message.reviewerId) : message.reviewerId;
                            else
                                object.reviewerId = options.longs === String ? $util.Long.prototype.toString.call(message.reviewerId) : options.longs === Number ? new $util.LongBits(message.reviewerId.low >>> 0, message.reviewerId.high >>> 0).toNumber() : message.reviewerId;
                        if (message.reviewerAccountName != null && message.hasOwnProperty("reviewerAccountName"))
                            object.reviewerAccountName = message.reviewerAccountName;
                        if (message.storeEventId != null && message.hasOwnProperty("storeEventId"))
                            if (typeof message.storeEventId === "number")
                                object.storeEventId = options.longs === String ? String(message.storeEventId) : message.storeEventId;
                            else
                                object.storeEventId = options.longs === String ? $util.Long.prototype.toString.call(message.storeEventId) : options.longs === Number ? new $util.LongBits(message.storeEventId.low >>> 0, message.storeEventId.high >>> 0).toNumber() : message.storeEventId;
                        if (message.reviewTimeMs != null && message.hasOwnProperty("reviewTimeMs"))
                            if (typeof message.reviewTimeMs === "number")
                                object.reviewTimeMs = options.longs === String ? String(message.reviewTimeMs) : message.reviewTimeMs;
                            else
                                object.reviewTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.reviewTimeMs) : options.longs === Number ? new $util.LongBits(message.reviewTimeMs.low >>> 0, message.reviewTimeMs.high >>> 0).toNumber() : message.reviewTimeMs;
                        if (message.storeEventStatus != null && message.hasOwnProperty("storeEventStatus"))
                            object.storeEventStatus = options.enums === String ? $root.palexy.streaming.v1.StoreEventReviewLog.ReviewStatus[message.storeEventStatus] : message.storeEventStatus;
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            object.reason = message.reason;
                        return object;
                    };
    
                    /**
                     * Converts this StoreEventReviewLog to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreEventReviewLog
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEventReviewLog.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ReviewStatus enum.
                     * @name palexy.streaming.v1.StoreEventReviewLog.ReviewStatus
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} APPROVED=1 APPROVED value
                     * @property {number} REJECTED=2 REJECTED value
                     * @property {number} COMMENTED=3 COMMENTED value
                     * @property {number} VIEWED=4 VIEWED value
                     */
                    StoreEventReviewLog.ReviewStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "APPROVED"] = 1;
                        values[valuesById[2] = "REJECTED"] = 2;
                        values[valuesById[3] = "COMMENTED"] = 3;
                        values[valuesById[4] = "VIEWED"] = 4;
                        return values;
                    })();
    
                    return StoreEventReviewLog;
                })();
    
                v1.ReviewStoreEventRequest = (function() {
    
                    /**
                     * Properties of a ReviewStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IReviewStoreEventRequest
                     * @property {number|null} [eventId] ReviewStoreEventRequest eventId
                     * @property {number|null} [reviewerId] ReviewStoreEventRequest reviewerId
                     * @property {string|null} [reason] ReviewStoreEventRequest reason
                     * @property {palexy.streaming.v1.StoreEventReviewLog.ReviewStatus|null} [storeEventStatus] ReviewStoreEventRequest storeEventStatus
                     */
    
                    /**
                     * Constructs a new ReviewStoreEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReviewStoreEventRequest.
                     * @implements IReviewStoreEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest=} [properties] Properties to set
                     */
                    function ReviewStoreEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReviewStoreEventRequest eventId.
                     * @member {number} eventId
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @instance
                     */
                    ReviewStoreEventRequest.prototype.eventId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReviewStoreEventRequest reviewerId.
                     * @member {number} reviewerId
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @instance
                     */
                    ReviewStoreEventRequest.prototype.reviewerId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReviewStoreEventRequest reason.
                     * @member {string} reason
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @instance
                     */
                    ReviewStoreEventRequest.prototype.reason = "";
    
                    /**
                     * ReviewStoreEventRequest storeEventStatus.
                     * @member {palexy.streaming.v1.StoreEventReviewLog.ReviewStatus} storeEventStatus
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @instance
                     */
                    ReviewStoreEventRequest.prototype.storeEventStatus = 0;
    
                    /**
                     * Creates a new ReviewStoreEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReviewStoreEventRequest} ReviewStoreEventRequest instance
                     */
                    ReviewStoreEventRequest.create = function create(properties) {
                        return new ReviewStoreEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ReviewStoreEventRequest message. Does not implicitly {@link palexy.streaming.v1.ReviewStoreEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest} message ReviewStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewStoreEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventId != null && Object.hasOwnProperty.call(message, "eventId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.eventId);
                        if (message.reviewerId != null && Object.hasOwnProperty.call(message, "reviewerId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.reviewerId);
                        if (message.reason != null && Object.hasOwnProperty.call(message, "reason"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.reason);
                        if (message.storeEventStatus != null && Object.hasOwnProperty.call(message, "storeEventStatus"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.storeEventStatus);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReviewStoreEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReviewStoreEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventRequest} message ReviewStoreEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewStoreEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReviewStoreEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReviewStoreEventRequest} ReviewStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewStoreEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReviewStoreEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.eventId = reader.int64();
                                break;
                            case 2:
                                message.reviewerId = reader.int64();
                                break;
                            case 4:
                                message.reason = reader.string();
                                break;
                            case 5:
                                message.storeEventStatus = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReviewStoreEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReviewStoreEventRequest} ReviewStoreEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewStoreEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReviewStoreEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReviewStoreEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.eventId != null && message.hasOwnProperty("eventId"))
                            if (!$util.isInteger(message.eventId) && !(message.eventId && $util.isInteger(message.eventId.low) && $util.isInteger(message.eventId.high)))
                                return "eventId: integer|Long expected";
                        if (message.reviewerId != null && message.hasOwnProperty("reviewerId"))
                            if (!$util.isInteger(message.reviewerId) && !(message.reviewerId && $util.isInteger(message.reviewerId.low) && $util.isInteger(message.reviewerId.high)))
                                return "reviewerId: integer|Long expected";
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            if (!$util.isString(message.reason))
                                return "reason: string expected";
                        if (message.storeEventStatus != null && message.hasOwnProperty("storeEventStatus"))
                            switch (message.storeEventStatus) {
                            default:
                                return "storeEventStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ReviewStoreEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReviewStoreEventRequest} ReviewStoreEventRequest
                     */
                    ReviewStoreEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReviewStoreEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReviewStoreEventRequest();
                        if (object.eventId != null)
                            if ($util.Long)
                                (message.eventId = $util.Long.fromValue(object.eventId)).unsigned = false;
                            else if (typeof object.eventId === "string")
                                message.eventId = parseInt(object.eventId, 10);
                            else if (typeof object.eventId === "number")
                                message.eventId = object.eventId;
                            else if (typeof object.eventId === "object")
                                message.eventId = new $util.LongBits(object.eventId.low >>> 0, object.eventId.high >>> 0).toNumber();
                        if (object.reviewerId != null)
                            if ($util.Long)
                                (message.reviewerId = $util.Long.fromValue(object.reviewerId)).unsigned = false;
                            else if (typeof object.reviewerId === "string")
                                message.reviewerId = parseInt(object.reviewerId, 10);
                            else if (typeof object.reviewerId === "number")
                                message.reviewerId = object.reviewerId;
                            else if (typeof object.reviewerId === "object")
                                message.reviewerId = new $util.LongBits(object.reviewerId.low >>> 0, object.reviewerId.high >>> 0).toNumber();
                        if (object.reason != null)
                            message.reason = String(object.reason);
                        switch (object.storeEventStatus) {
                        case "UNKNOWN":
                        case 0:
                            message.storeEventStatus = 0;
                            break;
                        case "APPROVED":
                        case 1:
                            message.storeEventStatus = 1;
                            break;
                        case "REJECTED":
                        case 2:
                            message.storeEventStatus = 2;
                            break;
                        case "COMMENTED":
                        case 3:
                            message.storeEventStatus = 3;
                            break;
                        case "VIEWED":
                        case 4:
                            message.storeEventStatus = 4;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReviewStoreEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ReviewStoreEventRequest} message ReviewStoreEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReviewStoreEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.eventId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.eventId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.reviewerId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.reviewerId = options.longs === String ? "0" : 0;
                            object.reason = "";
                            object.storeEventStatus = options.enums === String ? "UNKNOWN" : 0;
                        }
                        if (message.eventId != null && message.hasOwnProperty("eventId"))
                            if (typeof message.eventId === "number")
                                object.eventId = options.longs === String ? String(message.eventId) : message.eventId;
                            else
                                object.eventId = options.longs === String ? $util.Long.prototype.toString.call(message.eventId) : options.longs === Number ? new $util.LongBits(message.eventId.low >>> 0, message.eventId.high >>> 0).toNumber() : message.eventId;
                        if (message.reviewerId != null && message.hasOwnProperty("reviewerId"))
                            if (typeof message.reviewerId === "number")
                                object.reviewerId = options.longs === String ? String(message.reviewerId) : message.reviewerId;
                            else
                                object.reviewerId = options.longs === String ? $util.Long.prototype.toString.call(message.reviewerId) : options.longs === Number ? new $util.LongBits(message.reviewerId.low >>> 0, message.reviewerId.high >>> 0).toNumber() : message.reviewerId;
                        if (message.reason != null && message.hasOwnProperty("reason"))
                            object.reason = message.reason;
                        if (message.storeEventStatus != null && message.hasOwnProperty("storeEventStatus"))
                            object.storeEventStatus = options.enums === String ? $root.palexy.streaming.v1.StoreEventReviewLog.ReviewStatus[message.storeEventStatus] : message.storeEventStatus;
                        return object;
                    };
    
                    /**
                     * Converts this ReviewStoreEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReviewStoreEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReviewStoreEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReviewStoreEventRequest;
                })();
    
                v1.ReviewStoreEventResponse = (function() {
    
                    /**
                     * Properties of a ReviewStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IReviewStoreEventResponse
                     * @property {palexy.streaming.v1.IStoreEventReviewLog|null} [reviewLog] ReviewStoreEventResponse reviewLog
                     * @property {boolean|null} [success] ReviewStoreEventResponse success
                     */
    
                    /**
                     * Constructs a new ReviewStoreEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReviewStoreEventResponse.
                     * @implements IReviewStoreEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IReviewStoreEventResponse=} [properties] Properties to set
                     */
                    function ReviewStoreEventResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReviewStoreEventResponse reviewLog.
                     * @member {palexy.streaming.v1.IStoreEventReviewLog|null|undefined} reviewLog
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @instance
                     */
                    ReviewStoreEventResponse.prototype.reviewLog = null;
    
                    /**
                     * ReviewStoreEventResponse success.
                     * @member {boolean} success
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @instance
                     */
                    ReviewStoreEventResponse.prototype.success = false;
    
                    /**
                     * Creates a new ReviewStoreEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ReviewStoreEventResponse} ReviewStoreEventResponse instance
                     */
                    ReviewStoreEventResponse.create = function create(properties) {
                        return new ReviewStoreEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ReviewStoreEventResponse message. Does not implicitly {@link palexy.streaming.v1.ReviewStoreEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventResponse} message ReviewStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewStoreEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reviewLog != null && Object.hasOwnProperty.call(message, "reviewLog"))
                            $root.palexy.streaming.v1.StoreEventReviewLog.encode(message.reviewLog, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.success != null && Object.hasOwnProperty.call(message, "success"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.success);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReviewStoreEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ReviewStoreEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IReviewStoreEventResponse} message ReviewStoreEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReviewStoreEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReviewStoreEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ReviewStoreEventResponse} ReviewStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewStoreEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ReviewStoreEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.reviewLog = $root.palexy.streaming.v1.StoreEventReviewLog.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.success = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReviewStoreEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ReviewStoreEventResponse} ReviewStoreEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReviewStoreEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReviewStoreEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReviewStoreEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reviewLog != null && message.hasOwnProperty("reviewLog")) {
                            var error = $root.palexy.streaming.v1.StoreEventReviewLog.verify(message.reviewLog);
                            if (error)
                                return "reviewLog." + error;
                        }
                        if (message.success != null && message.hasOwnProperty("success"))
                            if (typeof message.success !== "boolean")
                                return "success: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReviewStoreEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ReviewStoreEventResponse} ReviewStoreEventResponse
                     */
                    ReviewStoreEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ReviewStoreEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ReviewStoreEventResponse();
                        if (object.reviewLog != null) {
                            if (typeof object.reviewLog !== "object")
                                throw TypeError(".palexy.streaming.v1.ReviewStoreEventResponse.reviewLog: object expected");
                            message.reviewLog = $root.palexy.streaming.v1.StoreEventReviewLog.fromObject(object.reviewLog);
                        }
                        if (object.success != null)
                            message.success = Boolean(object.success);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReviewStoreEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @static
                     * @param {palexy.streaming.v1.ReviewStoreEventResponse} message ReviewStoreEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReviewStoreEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.reviewLog = null;
                            object.success = false;
                        }
                        if (message.reviewLog != null && message.hasOwnProperty("reviewLog"))
                            object.reviewLog = $root.palexy.streaming.v1.StoreEventReviewLog.toObject(message.reviewLog, options);
                        if (message.success != null && message.hasOwnProperty("success"))
                            object.success = message.success;
                        return object;
                    };
    
                    /**
                     * Converts this ReviewStoreEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ReviewStoreEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReviewStoreEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReviewStoreEventResponse;
                })();
    
                v1.StoreEventDetails = (function() {
    
                    /**
                     * Properties of a StoreEventDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreEventDetails
                     * @property {palexy.streaming.v1.IMissedCustomerInteractionDetails|null} [missedCustomerInteractionDetails] StoreEventDetails missedCustomerInteractionDetails
                     * @property {palexy.streaming.v1.ISuspiciousCashierActivityDetails|null} [suspiciousCashierActivityDetails] StoreEventDetails suspiciousCashierActivityDetails
                     * @property {palexy.streaming.v1.ISopNonComplianceActivityDetails|null} [sopNonComplianceActivityDetails] StoreEventDetails sopNonComplianceActivityDetails
                     * @property {palexy.streaming.v1.IStaffGatheringDetails|null} [staffGatheringDetails] StoreEventDetails staffGatheringDetails
                     * @property {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails|null} [staffAttendanceNonComplianceDetails] StoreEventDetails staffAttendanceNonComplianceDetails
                     * @property {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails|null} [storeOpenCloseTimeNonComplianceDetails] StoreEventDetails storeOpenCloseTimeNonComplianceDetails
                     * @property {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails|null} [staffLeavingSpecialAreaWoFollowingSopDetails] StoreEventDetails staffLeavingSpecialAreaWoFollowingSopDetails
                     * @property {palexy.streaming.v1.ILongTotalServiceTimeDetails|null} [longTotalServiceTimeDetails] StoreEventDetails longTotalServiceTimeDetails
                     * @property {palexy.streaming.v1.IArtifact|null} [thumbnailImage] StoreEventDetails thumbnailImage
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] StoreEventDetails artifacts
                     * @property {Array.<palexy.streaming.v1.ICriticalMoment>|null} [criticalMoments] StoreEventDetails criticalMoments
                     * @property {palexy.task_management.v1.IFormSubmission|null} [formSubmission] StoreEventDetails formSubmission
                     */
    
                    /**
                     * Constructs a new StoreEventDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEventDetails.
                     * @implements IStoreEventDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreEventDetails=} [properties] Properties to set
                     */
                    function StoreEventDetails(properties) {
                        this.artifacts = [];
                        this.criticalMoments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEventDetails missedCustomerInteractionDetails.
                     * @member {palexy.streaming.v1.IMissedCustomerInteractionDetails|null|undefined} missedCustomerInteractionDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.missedCustomerInteractionDetails = null;
    
                    /**
                     * StoreEventDetails suspiciousCashierActivityDetails.
                     * @member {palexy.streaming.v1.ISuspiciousCashierActivityDetails|null|undefined} suspiciousCashierActivityDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.suspiciousCashierActivityDetails = null;
    
                    /**
                     * StoreEventDetails sopNonComplianceActivityDetails.
                     * @member {palexy.streaming.v1.ISopNonComplianceActivityDetails|null|undefined} sopNonComplianceActivityDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.sopNonComplianceActivityDetails = null;
    
                    /**
                     * StoreEventDetails staffGatheringDetails.
                     * @member {palexy.streaming.v1.IStaffGatheringDetails|null|undefined} staffGatheringDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.staffGatheringDetails = null;
    
                    /**
                     * StoreEventDetails staffAttendanceNonComplianceDetails.
                     * @member {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails|null|undefined} staffAttendanceNonComplianceDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.staffAttendanceNonComplianceDetails = null;
    
                    /**
                     * StoreEventDetails storeOpenCloseTimeNonComplianceDetails.
                     * @member {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails|null|undefined} storeOpenCloseTimeNonComplianceDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.storeOpenCloseTimeNonComplianceDetails = null;
    
                    /**
                     * StoreEventDetails staffLeavingSpecialAreaWoFollowingSopDetails.
                     * @member {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails|null|undefined} staffLeavingSpecialAreaWoFollowingSopDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.staffLeavingSpecialAreaWoFollowingSopDetails = null;
    
                    /**
                     * StoreEventDetails longTotalServiceTimeDetails.
                     * @member {palexy.streaming.v1.ILongTotalServiceTimeDetails|null|undefined} longTotalServiceTimeDetails
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.longTotalServiceTimeDetails = null;
    
                    /**
                     * StoreEventDetails thumbnailImage.
                     * @member {palexy.streaming.v1.IArtifact|null|undefined} thumbnailImage
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.thumbnailImage = null;
    
                    /**
                     * StoreEventDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * StoreEventDetails criticalMoments.
                     * @member {Array.<palexy.streaming.v1.ICriticalMoment>} criticalMoments
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.criticalMoments = $util.emptyArray;
    
                    /**
                     * StoreEventDetails formSubmission.
                     * @member {palexy.task_management.v1.IFormSubmission|null|undefined} formSubmission
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    StoreEventDetails.prototype.formSubmission = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * StoreEventDetails details.
                     * @member {"missedCustomerInteractionDetails"|"suspiciousCashierActivityDetails"|"sopNonComplianceActivityDetails"|"staffGatheringDetails"|"staffAttendanceNonComplianceDetails"|"storeOpenCloseTimeNonComplianceDetails"|"staffLeavingSpecialAreaWoFollowingSopDetails"|"longTotalServiceTimeDetails"|undefined} details
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     */
                    Object.defineProperty(StoreEventDetails.prototype, "details", {
                        get: $util.oneOfGetter($oneOfFields = ["missedCustomerInteractionDetails", "suspiciousCashierActivityDetails", "sopNonComplianceActivityDetails", "staffGatheringDetails", "staffAttendanceNonComplianceDetails", "storeOpenCloseTimeNonComplianceDetails", "staffLeavingSpecialAreaWoFollowingSopDetails", "longTotalServiceTimeDetails"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new StoreEventDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreEventDetails} StoreEventDetails instance
                     */
                    StoreEventDetails.create = function create(properties) {
                        return new StoreEventDetails(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEventDetails message. Does not implicitly {@link palexy.streaming.v1.StoreEventDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventDetails} message StoreEventDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.missedCustomerInteractionDetails != null && Object.hasOwnProperty.call(message, "missedCustomerInteractionDetails"))
                            $root.palexy.streaming.v1.MissedCustomerInteractionDetails.encode(message.missedCustomerInteractionDetails, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.thumbnailImage != null && Object.hasOwnProperty.call(message, "thumbnailImage"))
                            $root.palexy.streaming.v1.Artifact.encode(message.thumbnailImage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.suspiciousCashierActivityDetails != null && Object.hasOwnProperty.call(message, "suspiciousCashierActivityDetails"))
                            $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.encode(message.suspiciousCashierActivityDetails, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.sopNonComplianceActivityDetails != null && Object.hasOwnProperty.call(message, "sopNonComplianceActivityDetails"))
                            $root.palexy.streaming.v1.SopNonComplianceActivityDetails.encode(message.sopNonComplianceActivityDetails, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.staffGatheringDetails != null && Object.hasOwnProperty.call(message, "staffGatheringDetails"))
                            $root.palexy.streaming.v1.StaffGatheringDetails.encode(message.staffGatheringDetails, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.staffAttendanceNonComplianceDetails != null && Object.hasOwnProperty.call(message, "staffAttendanceNonComplianceDetails"))
                            $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails.encode(message.staffAttendanceNonComplianceDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.storeOpenCloseTimeNonComplianceDetails != null && Object.hasOwnProperty.call(message, "storeOpenCloseTimeNonComplianceDetails"))
                            $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.encode(message.storeOpenCloseTimeNonComplianceDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.criticalMoments != null && message.criticalMoments.length)
                            for (var i = 0; i < message.criticalMoments.length; ++i)
                                $root.palexy.streaming.v1.CriticalMoment.encode(message.criticalMoments[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.staffLeavingSpecialAreaWoFollowingSopDetails != null && Object.hasOwnProperty.call(message, "staffLeavingSpecialAreaWoFollowingSopDetails"))
                            $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.encode(message.staffLeavingSpecialAreaWoFollowingSopDetails, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.formSubmission != null && Object.hasOwnProperty.call(message, "formSubmission"))
                            $root.palexy.task_management.v1.FormSubmission.encode(message.formSubmission, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.longTotalServiceTimeDetails != null && Object.hasOwnProperty.call(message, "longTotalServiceTimeDetails"))
                            $root.palexy.streaming.v1.LongTotalServiceTimeDetails.encode(message.longTotalServiceTimeDetails, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEventDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEventDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventDetails} message StoreEventDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEventDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreEventDetails} StoreEventDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEventDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.missedCustomerInteractionDetails = $root.palexy.streaming.v1.MissedCustomerInteractionDetails.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.suspiciousCashierActivityDetails = $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.sopNonComplianceActivityDetails = $root.palexy.streaming.v1.SopNonComplianceActivityDetails.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.staffGatheringDetails = $root.palexy.streaming.v1.StaffGatheringDetails.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.staffAttendanceNonComplianceDetails = $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.storeOpenCloseTimeNonComplianceDetails = $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.staffLeavingSpecialAreaWoFollowingSopDetails = $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.longTotalServiceTimeDetails = $root.palexy.streaming.v1.LongTotalServiceTimeDetails.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.thumbnailImage = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                break;
                            case 8:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            case 9:
                                if (!(message.criticalMoments && message.criticalMoments.length))
                                    message.criticalMoments = [];
                                message.criticalMoments.push($root.palexy.streaming.v1.CriticalMoment.decode(reader, reader.uint32()));
                                break;
                            case 11:
                                message.formSubmission = $root.palexy.task_management.v1.FormSubmission.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEventDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreEventDetails} StoreEventDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEventDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEventDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.missedCustomerInteractionDetails != null && message.hasOwnProperty("missedCustomerInteractionDetails")) {
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.MissedCustomerInteractionDetails.verify(message.missedCustomerInteractionDetails);
                                if (error)
                                    return "missedCustomerInteractionDetails." + error;
                            }
                        }
                        if (message.suspiciousCashierActivityDetails != null && message.hasOwnProperty("suspiciousCashierActivityDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.verify(message.suspiciousCashierActivityDetails);
                                if (error)
                                    return "suspiciousCashierActivityDetails." + error;
                            }
                        }
                        if (message.sopNonComplianceActivityDetails != null && message.hasOwnProperty("sopNonComplianceActivityDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.SopNonComplianceActivityDetails.verify(message.sopNonComplianceActivityDetails);
                                if (error)
                                    return "sopNonComplianceActivityDetails." + error;
                            }
                        }
                        if (message.staffGatheringDetails != null && message.hasOwnProperty("staffGatheringDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.StaffGatheringDetails.verify(message.staffGatheringDetails);
                                if (error)
                                    return "staffGatheringDetails." + error;
                            }
                        }
                        if (message.staffAttendanceNonComplianceDetails != null && message.hasOwnProperty("staffAttendanceNonComplianceDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails.verify(message.staffAttendanceNonComplianceDetails);
                                if (error)
                                    return "staffAttendanceNonComplianceDetails." + error;
                            }
                        }
                        if (message.storeOpenCloseTimeNonComplianceDetails != null && message.hasOwnProperty("storeOpenCloseTimeNonComplianceDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.verify(message.storeOpenCloseTimeNonComplianceDetails);
                                if (error)
                                    return "storeOpenCloseTimeNonComplianceDetails." + error;
                            }
                        }
                        if (message.staffLeavingSpecialAreaWoFollowingSopDetails != null && message.hasOwnProperty("staffLeavingSpecialAreaWoFollowingSopDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.verify(message.staffLeavingSpecialAreaWoFollowingSopDetails);
                                if (error)
                                    return "staffLeavingSpecialAreaWoFollowingSopDetails." + error;
                            }
                        }
                        if (message.longTotalServiceTimeDetails != null && message.hasOwnProperty("longTotalServiceTimeDetails")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.streaming.v1.LongTotalServiceTimeDetails.verify(message.longTotalServiceTimeDetails);
                                if (error)
                                    return "longTotalServiceTimeDetails." + error;
                            }
                        }
                        if (message.thumbnailImage != null && message.hasOwnProperty("thumbnailImage")) {
                            var error = $root.palexy.streaming.v1.Artifact.verify(message.thumbnailImage);
                            if (error)
                                return "thumbnailImage." + error;
                        }
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        if (message.criticalMoments != null && message.hasOwnProperty("criticalMoments")) {
                            if (!Array.isArray(message.criticalMoments))
                                return "criticalMoments: array expected";
                            for (var i = 0; i < message.criticalMoments.length; ++i) {
                                var error = $root.palexy.streaming.v1.CriticalMoment.verify(message.criticalMoments[i]);
                                if (error)
                                    return "criticalMoments." + error;
                            }
                        }
                        if (message.formSubmission != null && message.hasOwnProperty("formSubmission")) {
                            var error = $root.palexy.task_management.v1.FormSubmission.verify(message.formSubmission);
                            if (error)
                                return "formSubmission." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreEventDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreEventDetails} StoreEventDetails
                     */
                    StoreEventDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreEventDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreEventDetails();
                        if (object.missedCustomerInteractionDetails != null) {
                            if (typeof object.missedCustomerInteractionDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.missedCustomerInteractionDetails: object expected");
                            message.missedCustomerInteractionDetails = $root.palexy.streaming.v1.MissedCustomerInteractionDetails.fromObject(object.missedCustomerInteractionDetails);
                        }
                        if (object.suspiciousCashierActivityDetails != null) {
                            if (typeof object.suspiciousCashierActivityDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.suspiciousCashierActivityDetails: object expected");
                            message.suspiciousCashierActivityDetails = $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.fromObject(object.suspiciousCashierActivityDetails);
                        }
                        if (object.sopNonComplianceActivityDetails != null) {
                            if (typeof object.sopNonComplianceActivityDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.sopNonComplianceActivityDetails: object expected");
                            message.sopNonComplianceActivityDetails = $root.palexy.streaming.v1.SopNonComplianceActivityDetails.fromObject(object.sopNonComplianceActivityDetails);
                        }
                        if (object.staffGatheringDetails != null) {
                            if (typeof object.staffGatheringDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.staffGatheringDetails: object expected");
                            message.staffGatheringDetails = $root.palexy.streaming.v1.StaffGatheringDetails.fromObject(object.staffGatheringDetails);
                        }
                        if (object.staffAttendanceNonComplianceDetails != null) {
                            if (typeof object.staffAttendanceNonComplianceDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.staffAttendanceNonComplianceDetails: object expected");
                            message.staffAttendanceNonComplianceDetails = $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails.fromObject(object.staffAttendanceNonComplianceDetails);
                        }
                        if (object.storeOpenCloseTimeNonComplianceDetails != null) {
                            if (typeof object.storeOpenCloseTimeNonComplianceDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.storeOpenCloseTimeNonComplianceDetails: object expected");
                            message.storeOpenCloseTimeNonComplianceDetails = $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.fromObject(object.storeOpenCloseTimeNonComplianceDetails);
                        }
                        if (object.staffLeavingSpecialAreaWoFollowingSopDetails != null) {
                            if (typeof object.staffLeavingSpecialAreaWoFollowingSopDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.staffLeavingSpecialAreaWoFollowingSopDetails: object expected");
                            message.staffLeavingSpecialAreaWoFollowingSopDetails = $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.fromObject(object.staffLeavingSpecialAreaWoFollowingSopDetails);
                        }
                        if (object.longTotalServiceTimeDetails != null) {
                            if (typeof object.longTotalServiceTimeDetails !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.longTotalServiceTimeDetails: object expected");
                            message.longTotalServiceTimeDetails = $root.palexy.streaming.v1.LongTotalServiceTimeDetails.fromObject(object.longTotalServiceTimeDetails);
                        }
                        if (object.thumbnailImage != null) {
                            if (typeof object.thumbnailImage !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.thumbnailImage: object expected");
                            message.thumbnailImage = $root.palexy.streaming.v1.Artifact.fromObject(object.thumbnailImage);
                        }
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StoreEventDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        if (object.criticalMoments) {
                            if (!Array.isArray(object.criticalMoments))
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.criticalMoments: array expected");
                            message.criticalMoments = [];
                            for (var i = 0; i < object.criticalMoments.length; ++i) {
                                if (typeof object.criticalMoments[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StoreEventDetails.criticalMoments: object expected");
                                message.criticalMoments[i] = $root.palexy.streaming.v1.CriticalMoment.fromObject(object.criticalMoments[i]);
                            }
                        }
                        if (object.formSubmission != null) {
                            if (typeof object.formSubmission !== "object")
                                throw TypeError(".palexy.streaming.v1.StoreEventDetails.formSubmission: object expected");
                            message.formSubmission = $root.palexy.task_management.v1.FormSubmission.fromObject(object.formSubmission);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEventDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @static
                     * @param {palexy.streaming.v1.StoreEventDetails} message StoreEventDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEventDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.artifacts = [];
                            object.criticalMoments = [];
                        }
                        if (options.defaults) {
                            object.thumbnailImage = null;
                            object.formSubmission = null;
                        }
                        if (message.missedCustomerInteractionDetails != null && message.hasOwnProperty("missedCustomerInteractionDetails")) {
                            object.missedCustomerInteractionDetails = $root.palexy.streaming.v1.MissedCustomerInteractionDetails.toObject(message.missedCustomerInteractionDetails, options);
                            if (options.oneofs)
                                object.details = "missedCustomerInteractionDetails";
                        }
                        if (message.thumbnailImage != null && message.hasOwnProperty("thumbnailImage"))
                            object.thumbnailImage = $root.palexy.streaming.v1.Artifact.toObject(message.thumbnailImage, options);
                        if (message.suspiciousCashierActivityDetails != null && message.hasOwnProperty("suspiciousCashierActivityDetails")) {
                            object.suspiciousCashierActivityDetails = $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.toObject(message.suspiciousCashierActivityDetails, options);
                            if (options.oneofs)
                                object.details = "suspiciousCashierActivityDetails";
                        }
                        if (message.sopNonComplianceActivityDetails != null && message.hasOwnProperty("sopNonComplianceActivityDetails")) {
                            object.sopNonComplianceActivityDetails = $root.palexy.streaming.v1.SopNonComplianceActivityDetails.toObject(message.sopNonComplianceActivityDetails, options);
                            if (options.oneofs)
                                object.details = "sopNonComplianceActivityDetails";
                        }
                        if (message.staffGatheringDetails != null && message.hasOwnProperty("staffGatheringDetails")) {
                            object.staffGatheringDetails = $root.palexy.streaming.v1.StaffGatheringDetails.toObject(message.staffGatheringDetails, options);
                            if (options.oneofs)
                                object.details = "staffGatheringDetails";
                        }
                        if (message.staffAttendanceNonComplianceDetails != null && message.hasOwnProperty("staffAttendanceNonComplianceDetails")) {
                            object.staffAttendanceNonComplianceDetails = $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails.toObject(message.staffAttendanceNonComplianceDetails, options);
                            if (options.oneofs)
                                object.details = "staffAttendanceNonComplianceDetails";
                        }
                        if (message.storeOpenCloseTimeNonComplianceDetails != null && message.hasOwnProperty("storeOpenCloseTimeNonComplianceDetails")) {
                            object.storeOpenCloseTimeNonComplianceDetails = $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.toObject(message.storeOpenCloseTimeNonComplianceDetails, options);
                            if (options.oneofs)
                                object.details = "storeOpenCloseTimeNonComplianceDetails";
                        }
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        if (message.criticalMoments && message.criticalMoments.length) {
                            object.criticalMoments = [];
                            for (var j = 0; j < message.criticalMoments.length; ++j)
                                object.criticalMoments[j] = $root.palexy.streaming.v1.CriticalMoment.toObject(message.criticalMoments[j], options);
                        }
                        if (message.staffLeavingSpecialAreaWoFollowingSopDetails != null && message.hasOwnProperty("staffLeavingSpecialAreaWoFollowingSopDetails")) {
                            object.staffLeavingSpecialAreaWoFollowingSopDetails = $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.toObject(message.staffLeavingSpecialAreaWoFollowingSopDetails, options);
                            if (options.oneofs)
                                object.details = "staffLeavingSpecialAreaWoFollowingSopDetails";
                        }
                        if (message.formSubmission != null && message.hasOwnProperty("formSubmission"))
                            object.formSubmission = $root.palexy.task_management.v1.FormSubmission.toObject(message.formSubmission, options);
                        if (message.longTotalServiceTimeDetails != null && message.hasOwnProperty("longTotalServiceTimeDetails")) {
                            object.longTotalServiceTimeDetails = $root.palexy.streaming.v1.LongTotalServiceTimeDetails.toObject(message.longTotalServiceTimeDetails, options);
                            if (options.oneofs)
                                object.details = "longTotalServiceTimeDetails";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreEventDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreEventDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEventDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreEventDetails;
                })();
    
                v1.StoreOpenCloseTimeNonComplianceDetails = (function() {
    
                    /**
                     * Properties of a StoreOpenCloseTimeNonComplianceDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreOpenCloseTimeNonComplianceDetails
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] StoreOpenCloseTimeNonComplianceDetails artifacts
                     * @property {boolean|null} [isLateOpen] StoreOpenCloseTimeNonComplianceDetails isLateOpen
                     */
    
                    /**
                     * Constructs a new StoreOpenCloseTimeNonComplianceDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreOpenCloseTimeNonComplianceDetails.
                     * @implements IStoreOpenCloseTimeNonComplianceDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails=} [properties] Properties to set
                     */
                    function StoreOpenCloseTimeNonComplianceDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreOpenCloseTimeNonComplianceDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @instance
                     */
                    StoreOpenCloseTimeNonComplianceDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * StoreOpenCloseTimeNonComplianceDetails isLateOpen.
                     * @member {boolean} isLateOpen
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @instance
                     */
                    StoreOpenCloseTimeNonComplianceDetails.prototype.isLateOpen = false;
    
                    /**
                     * Creates a new StoreOpenCloseTimeNonComplianceDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails} StoreOpenCloseTimeNonComplianceDetails instance
                     */
                    StoreOpenCloseTimeNonComplianceDetails.create = function create(properties) {
                        return new StoreOpenCloseTimeNonComplianceDetails(properties);
                    };
    
                    /**
                     * Encodes the specified StoreOpenCloseTimeNonComplianceDetails message. Does not implicitly {@link palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails} message StoreOpenCloseTimeNonComplianceDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreOpenCloseTimeNonComplianceDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.isLateOpen != null && Object.hasOwnProperty.call(message, "isLateOpen"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isLateOpen);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreOpenCloseTimeNonComplianceDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStoreOpenCloseTimeNonComplianceDetails} message StoreOpenCloseTimeNonComplianceDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreOpenCloseTimeNonComplianceDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreOpenCloseTimeNonComplianceDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails} StoreOpenCloseTimeNonComplianceDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreOpenCloseTimeNonComplianceDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.isLateOpen = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreOpenCloseTimeNonComplianceDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails} StoreOpenCloseTimeNonComplianceDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreOpenCloseTimeNonComplianceDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreOpenCloseTimeNonComplianceDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreOpenCloseTimeNonComplianceDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        if (message.isLateOpen != null && message.hasOwnProperty("isLateOpen"))
                            if (typeof message.isLateOpen !== "boolean")
                                return "isLateOpen: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreOpenCloseTimeNonComplianceDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails} StoreOpenCloseTimeNonComplianceDetails
                     */
                    StoreOpenCloseTimeNonComplianceDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails();
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        if (object.isLateOpen != null)
                            message.isLateOpen = Boolean(object.isLateOpen);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreOpenCloseTimeNonComplianceDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails} message StoreOpenCloseTimeNonComplianceDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreOpenCloseTimeNonComplianceDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (options.defaults)
                            object.isLateOpen = false;
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        if (message.isLateOpen != null && message.hasOwnProperty("isLateOpen"))
                            object.isLateOpen = message.isLateOpen;
                        return object;
                    };
    
                    /**
                     * Converts this StoreOpenCloseTimeNonComplianceDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreOpenCloseTimeNonComplianceDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreOpenCloseTimeNonComplianceDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreOpenCloseTimeNonComplianceDetails;
                })();
    
                v1.MissedCustomerInteractionDetails = (function() {
    
                    /**
                     * Properties of a MissedCustomerInteractionDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IMissedCustomerInteractionDetails
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] MissedCustomerInteractionDetails artifacts
                     */
    
                    /**
                     * Constructs a new MissedCustomerInteractionDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MissedCustomerInteractionDetails.
                     * @implements IMissedCustomerInteractionDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IMissedCustomerInteractionDetails=} [properties] Properties to set
                     */
                    function MissedCustomerInteractionDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MissedCustomerInteractionDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @instance
                     */
                    MissedCustomerInteractionDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * Creates a new MissedCustomerInteractionDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {palexy.streaming.v1.IMissedCustomerInteractionDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MissedCustomerInteractionDetails} MissedCustomerInteractionDetails instance
                     */
                    MissedCustomerInteractionDetails.create = function create(properties) {
                        return new MissedCustomerInteractionDetails(properties);
                    };
    
                    /**
                     * Encodes the specified MissedCustomerInteractionDetails message. Does not implicitly {@link palexy.streaming.v1.MissedCustomerInteractionDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {palexy.streaming.v1.IMissedCustomerInteractionDetails} message MissedCustomerInteractionDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MissedCustomerInteractionDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MissedCustomerInteractionDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.MissedCustomerInteractionDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {palexy.streaming.v1.IMissedCustomerInteractionDetails} message MissedCustomerInteractionDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MissedCustomerInteractionDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MissedCustomerInteractionDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MissedCustomerInteractionDetails} MissedCustomerInteractionDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MissedCustomerInteractionDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MissedCustomerInteractionDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MissedCustomerInteractionDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MissedCustomerInteractionDetails} MissedCustomerInteractionDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MissedCustomerInteractionDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MissedCustomerInteractionDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MissedCustomerInteractionDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a MissedCustomerInteractionDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MissedCustomerInteractionDetails} MissedCustomerInteractionDetails
                     */
                    MissedCustomerInteractionDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MissedCustomerInteractionDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.MissedCustomerInteractionDetails();
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.MissedCustomerInteractionDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.MissedCustomerInteractionDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MissedCustomerInteractionDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @static
                     * @param {palexy.streaming.v1.MissedCustomerInteractionDetails} message MissedCustomerInteractionDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MissedCustomerInteractionDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this MissedCustomerInteractionDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MissedCustomerInteractionDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MissedCustomerInteractionDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MissedCustomerInteractionDetails;
                })();
    
                v1.StaffGatheringDetails = (function() {
    
                    /**
                     * Properties of a StaffGatheringDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffGatheringDetails
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] StaffGatheringDetails artifacts
                     */
    
                    /**
                     * Constructs a new StaffGatheringDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffGatheringDetails.
                     * @implements IStaffGatheringDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffGatheringDetails=} [properties] Properties to set
                     */
                    function StaffGatheringDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffGatheringDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @instance
                     */
                    StaffGatheringDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * Creates a new StaffGatheringDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffGatheringDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffGatheringDetails} StaffGatheringDetails instance
                     */
                    StaffGatheringDetails.create = function create(properties) {
                        return new StaffGatheringDetails(properties);
                    };
    
                    /**
                     * Encodes the specified StaffGatheringDetails message. Does not implicitly {@link palexy.streaming.v1.StaffGatheringDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffGatheringDetails} message StaffGatheringDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffGatheringDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffGatheringDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffGatheringDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffGatheringDetails} message StaffGatheringDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffGatheringDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffGatheringDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffGatheringDetails} StaffGatheringDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffGatheringDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffGatheringDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffGatheringDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffGatheringDetails} StaffGatheringDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffGatheringDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffGatheringDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffGatheringDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffGatheringDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffGatheringDetails} StaffGatheringDetails
                     */
                    StaffGatheringDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffGatheringDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffGatheringDetails();
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.StaffGatheringDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffGatheringDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffGatheringDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @static
                     * @param {palexy.streaming.v1.StaffGatheringDetails} message StaffGatheringDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffGatheringDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffGatheringDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffGatheringDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffGatheringDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffGatheringDetails;
                })();
    
                v1.StaffAttendanceNonComplianceDetails = (function() {
    
                    /**
                     * Properties of a StaffAttendanceNonComplianceDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffAttendanceNonComplianceDetails
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] StaffAttendanceNonComplianceDetails artifacts
                     * @property {number|null} [expectedNoStaffs] StaffAttendanceNonComplianceDetails expectedNoStaffs
                     * @property {number|null} [maxNumStaffs] StaffAttendanceNonComplianceDetails maxNumStaffs
                     */
    
                    /**
                     * Constructs a new StaffAttendanceNonComplianceDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffAttendanceNonComplianceDetails.
                     * @implements IStaffAttendanceNonComplianceDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails=} [properties] Properties to set
                     */
                    function StaffAttendanceNonComplianceDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffAttendanceNonComplianceDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @instance
                     */
                    StaffAttendanceNonComplianceDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * StaffAttendanceNonComplianceDetails expectedNoStaffs.
                     * @member {number} expectedNoStaffs
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @instance
                     */
                    StaffAttendanceNonComplianceDetails.prototype.expectedNoStaffs = 0;
    
                    /**
                     * StaffAttendanceNonComplianceDetails maxNumStaffs.
                     * @member {number} maxNumStaffs
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @instance
                     */
                    StaffAttendanceNonComplianceDetails.prototype.maxNumStaffs = 0;
    
                    /**
                     * Creates a new StaffAttendanceNonComplianceDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffAttendanceNonComplianceDetails} StaffAttendanceNonComplianceDetails instance
                     */
                    StaffAttendanceNonComplianceDetails.create = function create(properties) {
                        return new StaffAttendanceNonComplianceDetails(properties);
                    };
    
                    /**
                     * Encodes the specified StaffAttendanceNonComplianceDetails message. Does not implicitly {@link palexy.streaming.v1.StaffAttendanceNonComplianceDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails} message StaffAttendanceNonComplianceDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAttendanceNonComplianceDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.expectedNoStaffs != null && Object.hasOwnProperty.call(message, "expectedNoStaffs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.expectedNoStaffs);
                        if (message.maxNumStaffs != null && Object.hasOwnProperty.call(message, "maxNumStaffs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxNumStaffs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffAttendanceNonComplianceDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffAttendanceNonComplianceDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffAttendanceNonComplianceDetails} message StaffAttendanceNonComplianceDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAttendanceNonComplianceDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffAttendanceNonComplianceDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffAttendanceNonComplianceDetails} StaffAttendanceNonComplianceDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAttendanceNonComplianceDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.expectedNoStaffs = reader.int32();
                                break;
                            case 3:
                                message.maxNumStaffs = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffAttendanceNonComplianceDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffAttendanceNonComplianceDetails} StaffAttendanceNonComplianceDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAttendanceNonComplianceDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffAttendanceNonComplianceDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffAttendanceNonComplianceDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        if (message.expectedNoStaffs != null && message.hasOwnProperty("expectedNoStaffs"))
                            if (!$util.isInteger(message.expectedNoStaffs))
                                return "expectedNoStaffs: integer expected";
                        if (message.maxNumStaffs != null && message.hasOwnProperty("maxNumStaffs"))
                            if (!$util.isInteger(message.maxNumStaffs))
                                return "maxNumStaffs: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffAttendanceNonComplianceDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffAttendanceNonComplianceDetails} StaffAttendanceNonComplianceDetails
                     */
                    StaffAttendanceNonComplianceDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffAttendanceNonComplianceDetails();
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.StaffAttendanceNonComplianceDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffAttendanceNonComplianceDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        if (object.expectedNoStaffs != null)
                            message.expectedNoStaffs = object.expectedNoStaffs | 0;
                        if (object.maxNumStaffs != null)
                            message.maxNumStaffs = object.maxNumStaffs | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffAttendanceNonComplianceDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @static
                     * @param {palexy.streaming.v1.StaffAttendanceNonComplianceDetails} message StaffAttendanceNonComplianceDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffAttendanceNonComplianceDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (options.defaults) {
                            object.expectedNoStaffs = 0;
                            object.maxNumStaffs = 0;
                        }
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        if (message.expectedNoStaffs != null && message.hasOwnProperty("expectedNoStaffs"))
                            object.expectedNoStaffs = message.expectedNoStaffs;
                        if (message.maxNumStaffs != null && message.hasOwnProperty("maxNumStaffs"))
                            object.maxNumStaffs = message.maxNumStaffs;
                        return object;
                    };
    
                    /**
                     * Converts this StaffAttendanceNonComplianceDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffAttendanceNonComplianceDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffAttendanceNonComplianceDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffAttendanceNonComplianceDetails;
                })();
    
                v1.SuspiciousCashierActivityDetails = (function() {
    
                    /**
                     * Properties of a SuspiciousCashierActivityDetails.
                     * @memberof palexy.streaming.v1
                     * @interface ISuspiciousCashierActivityDetails
                     * @property {palexy.streaming.v1.SuspiciousCashierActivityDetails.ActivityType|null} [activityType] SuspiciousCashierActivityDetails activityType
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] SuspiciousCashierActivityDetails artifacts
                     * @property {string|null} [nearestPreviousTransactionDatetime] SuspiciousCashierActivityDetails nearestPreviousTransactionDatetime
                     * @property {string|null} [nearestNextTransactionDatetime] SuspiciousCashierActivityDetails nearestNextTransactionDatetime
                     * @property {string|null} [relatedTransactionId] SuspiciousCashierActivityDetails relatedTransactionId
                     * @property {string|null} [nearestPreviousTransactionId] SuspiciousCashierActivityDetails nearestPreviousTransactionId
                     * @property {string|null} [nearestNextTransactionId] SuspiciousCashierActivityDetails nearestNextTransactionId
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [relatedPosTransactions] SuspiciousCashierActivityDetails relatedPosTransactions
                     */
    
                    /**
                     * Constructs a new SuspiciousCashierActivityDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SuspiciousCashierActivityDetails.
                     * @implements ISuspiciousCashierActivityDetails
                     * @constructor
                     * @param {palexy.streaming.v1.ISuspiciousCashierActivityDetails=} [properties] Properties to set
                     */
                    function SuspiciousCashierActivityDetails(properties) {
                        this.artifacts = [];
                        this.relatedPosTransactions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SuspiciousCashierActivityDetails activityType.
                     * @member {palexy.streaming.v1.SuspiciousCashierActivityDetails.ActivityType} activityType
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.activityType = 0;
    
                    /**
                     * SuspiciousCashierActivityDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * SuspiciousCashierActivityDetails nearestPreviousTransactionDatetime.
                     * @member {string} nearestPreviousTransactionDatetime
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.nearestPreviousTransactionDatetime = "";
    
                    /**
                     * SuspiciousCashierActivityDetails nearestNextTransactionDatetime.
                     * @member {string} nearestNextTransactionDatetime
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.nearestNextTransactionDatetime = "";
    
                    /**
                     * SuspiciousCashierActivityDetails relatedTransactionId.
                     * @member {string} relatedTransactionId
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.relatedTransactionId = "";
    
                    /**
                     * SuspiciousCashierActivityDetails nearestPreviousTransactionId.
                     * @member {string} nearestPreviousTransactionId
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.nearestPreviousTransactionId = "";
    
                    /**
                     * SuspiciousCashierActivityDetails nearestNextTransactionId.
                     * @member {string} nearestNextTransactionId
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.nearestNextTransactionId = "";
    
                    /**
                     * SuspiciousCashierActivityDetails relatedPosTransactions.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} relatedPosTransactions
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     */
                    SuspiciousCashierActivityDetails.prototype.relatedPosTransactions = $util.emptyArray;
    
                    /**
                     * Creates a new SuspiciousCashierActivityDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISuspiciousCashierActivityDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SuspiciousCashierActivityDetails} SuspiciousCashierActivityDetails instance
                     */
                    SuspiciousCashierActivityDetails.create = function create(properties) {
                        return new SuspiciousCashierActivityDetails(properties);
                    };
    
                    /**
                     * Encodes the specified SuspiciousCashierActivityDetails message. Does not implicitly {@link palexy.streaming.v1.SuspiciousCashierActivityDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISuspiciousCashierActivityDetails} message SuspiciousCashierActivityDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SuspiciousCashierActivityDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.activityType != null && Object.hasOwnProperty.call(message, "activityType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.activityType);
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.nearestPreviousTransactionDatetime != null && Object.hasOwnProperty.call(message, "nearestPreviousTransactionDatetime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nearestPreviousTransactionDatetime);
                        if (message.nearestNextTransactionDatetime != null && Object.hasOwnProperty.call(message, "nearestNextTransactionDatetime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.nearestNextTransactionDatetime);
                        if (message.relatedTransactionId != null && Object.hasOwnProperty.call(message, "relatedTransactionId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.relatedTransactionId);
                        if (message.nearestPreviousTransactionId != null && Object.hasOwnProperty.call(message, "nearestPreviousTransactionId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.nearestPreviousTransactionId);
                        if (message.nearestNextTransactionId != null && Object.hasOwnProperty.call(message, "nearestNextTransactionId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.nearestNextTransactionId);
                        if (message.relatedPosTransactions != null && message.relatedPosTransactions.length)
                            for (var i = 0; i < message.relatedPosTransactions.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.relatedPosTransactions[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SuspiciousCashierActivityDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.SuspiciousCashierActivityDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISuspiciousCashierActivityDetails} message SuspiciousCashierActivityDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SuspiciousCashierActivityDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SuspiciousCashierActivityDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SuspiciousCashierActivityDetails} SuspiciousCashierActivityDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SuspiciousCashierActivityDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SuspiciousCashierActivityDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.activityType = reader.int32();
                                break;
                            case 2:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.nearestPreviousTransactionDatetime = reader.string();
                                break;
                            case 4:
                                message.nearestNextTransactionDatetime = reader.string();
                                break;
                            case 5:
                                message.relatedTransactionId = reader.string();
                                break;
                            case 6:
                                message.nearestPreviousTransactionId = reader.string();
                                break;
                            case 7:
                                message.nearestNextTransactionId = reader.string();
                                break;
                            case 8:
                                if (!(message.relatedPosTransactions && message.relatedPosTransactions.length))
                                    message.relatedPosTransactions = [];
                                message.relatedPosTransactions.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SuspiciousCashierActivityDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SuspiciousCashierActivityDetails} SuspiciousCashierActivityDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SuspiciousCashierActivityDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SuspiciousCashierActivityDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SuspiciousCashierActivityDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.activityType != null && message.hasOwnProperty("activityType"))
                            switch (message.activityType) {
                            default:
                                return "activityType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        if (message.nearestPreviousTransactionDatetime != null && message.hasOwnProperty("nearestPreviousTransactionDatetime"))
                            if (!$util.isString(message.nearestPreviousTransactionDatetime))
                                return "nearestPreviousTransactionDatetime: string expected";
                        if (message.nearestNextTransactionDatetime != null && message.hasOwnProperty("nearestNextTransactionDatetime"))
                            if (!$util.isString(message.nearestNextTransactionDatetime))
                                return "nearestNextTransactionDatetime: string expected";
                        if (message.relatedTransactionId != null && message.hasOwnProperty("relatedTransactionId"))
                            if (!$util.isString(message.relatedTransactionId))
                                return "relatedTransactionId: string expected";
                        if (message.nearestPreviousTransactionId != null && message.hasOwnProperty("nearestPreviousTransactionId"))
                            if (!$util.isString(message.nearestPreviousTransactionId))
                                return "nearestPreviousTransactionId: string expected";
                        if (message.nearestNextTransactionId != null && message.hasOwnProperty("nearestNextTransactionId"))
                            if (!$util.isString(message.nearestNextTransactionId))
                                return "nearestNextTransactionId: string expected";
                        if (message.relatedPosTransactions != null && message.hasOwnProperty("relatedPosTransactions")) {
                            if (!Array.isArray(message.relatedPosTransactions))
                                return "relatedPosTransactions: array expected";
                            for (var i = 0; i < message.relatedPosTransactions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.relatedPosTransactions[i]);
                                if (error)
                                    return "relatedPosTransactions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SuspiciousCashierActivityDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SuspiciousCashierActivityDetails} SuspiciousCashierActivityDetails
                     */
                    SuspiciousCashierActivityDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SuspiciousCashierActivityDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.SuspiciousCashierActivityDetails();
                        switch (object.activityType) {
                        case "UNKNOWN":
                        case 0:
                            message.activityType = 0;
                            break;
                        case "OTHERS":
                        case 1:
                            message.activityType = 1;
                            break;
                        case "NO_BILL":
                        case 2:
                            message.activityType = 2;
                            break;
                        case "STAFF_STEALING":
                        case 3:
                            message.activityType = 3;
                            break;
                        case "OPEN_CASHIER_DRAW_WITHOUT_CUSTOMER":
                        case 4:
                            message.activityType = 4;
                            break;
                        case "SUSPICIOUS_SENIOR_CITIZEN_DISCOUNT":
                        case 5:
                            message.activityType = 5;
                            break;
                        case "BILL_WITHOUT_CUSTOMER":
                        case 6:
                            message.activityType = 6;
                            break;
                        }
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.SuspiciousCashierActivityDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.SuspiciousCashierActivityDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        if (object.nearestPreviousTransactionDatetime != null)
                            message.nearestPreviousTransactionDatetime = String(object.nearestPreviousTransactionDatetime);
                        if (object.nearestNextTransactionDatetime != null)
                            message.nearestNextTransactionDatetime = String(object.nearestNextTransactionDatetime);
                        if (object.relatedTransactionId != null)
                            message.relatedTransactionId = String(object.relatedTransactionId);
                        if (object.nearestPreviousTransactionId != null)
                            message.nearestPreviousTransactionId = String(object.nearestPreviousTransactionId);
                        if (object.nearestNextTransactionId != null)
                            message.nearestNextTransactionId = String(object.nearestNextTransactionId);
                        if (object.relatedPosTransactions) {
                            if (!Array.isArray(object.relatedPosTransactions))
                                throw TypeError(".palexy.streaming.v1.SuspiciousCashierActivityDetails.relatedPosTransactions: array expected");
                            message.relatedPosTransactions = [];
                            for (var i = 0; i < object.relatedPosTransactions.length; ++i) {
                                if (typeof object.relatedPosTransactions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.SuspiciousCashierActivityDetails.relatedPosTransactions: object expected");
                                message.relatedPosTransactions[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.relatedPosTransactions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SuspiciousCashierActivityDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.SuspiciousCashierActivityDetails} message SuspiciousCashierActivityDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SuspiciousCashierActivityDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.artifacts = [];
                            object.relatedPosTransactions = [];
                        }
                        if (options.defaults) {
                            object.activityType = options.enums === String ? "UNKNOWN" : 0;
                            object.nearestPreviousTransactionDatetime = "";
                            object.nearestNextTransactionDatetime = "";
                            object.relatedTransactionId = "";
                            object.nearestPreviousTransactionId = "";
                            object.nearestNextTransactionId = "";
                        }
                        if (message.activityType != null && message.hasOwnProperty("activityType"))
                            object.activityType = options.enums === String ? $root.palexy.streaming.v1.SuspiciousCashierActivityDetails.ActivityType[message.activityType] : message.activityType;
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        if (message.nearestPreviousTransactionDatetime != null && message.hasOwnProperty("nearestPreviousTransactionDatetime"))
                            object.nearestPreviousTransactionDatetime = message.nearestPreviousTransactionDatetime;
                        if (message.nearestNextTransactionDatetime != null && message.hasOwnProperty("nearestNextTransactionDatetime"))
                            object.nearestNextTransactionDatetime = message.nearestNextTransactionDatetime;
                        if (message.relatedTransactionId != null && message.hasOwnProperty("relatedTransactionId"))
                            object.relatedTransactionId = message.relatedTransactionId;
                        if (message.nearestPreviousTransactionId != null && message.hasOwnProperty("nearestPreviousTransactionId"))
                            object.nearestPreviousTransactionId = message.nearestPreviousTransactionId;
                        if (message.nearestNextTransactionId != null && message.hasOwnProperty("nearestNextTransactionId"))
                            object.nearestNextTransactionId = message.nearestNextTransactionId;
                        if (message.relatedPosTransactions && message.relatedPosTransactions.length) {
                            object.relatedPosTransactions = [];
                            for (var j = 0; j < message.relatedPosTransactions.length; ++j)
                                object.relatedPosTransactions[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.relatedPosTransactions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SuspiciousCashierActivityDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SuspiciousCashierActivityDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SuspiciousCashierActivityDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ActivityType enum.
                     * @name palexy.streaming.v1.SuspiciousCashierActivityDetails.ActivityType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} OTHERS=1 OTHERS value
                     * @property {number} NO_BILL=2 NO_BILL value
                     * @property {number} STAFF_STEALING=3 STAFF_STEALING value
                     * @property {number} OPEN_CASHIER_DRAW_WITHOUT_CUSTOMER=4 OPEN_CASHIER_DRAW_WITHOUT_CUSTOMER value
                     * @property {number} SUSPICIOUS_SENIOR_CITIZEN_DISCOUNT=5 SUSPICIOUS_SENIOR_CITIZEN_DISCOUNT value
                     * @property {number} BILL_WITHOUT_CUSTOMER=6 BILL_WITHOUT_CUSTOMER value
                     */
                    SuspiciousCashierActivityDetails.ActivityType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "OTHERS"] = 1;
                        values[valuesById[2] = "NO_BILL"] = 2;
                        values[valuesById[3] = "STAFF_STEALING"] = 3;
                        values[valuesById[4] = "OPEN_CASHIER_DRAW_WITHOUT_CUSTOMER"] = 4;
                        values[valuesById[5] = "SUSPICIOUS_SENIOR_CITIZEN_DISCOUNT"] = 5;
                        values[valuesById[6] = "BILL_WITHOUT_CUSTOMER"] = 6;
                        return values;
                    })();
    
                    return SuspiciousCashierActivityDetails;
                })();
    
                v1.StaffLeavingSpecialAreaWoFollowingSopDetails = (function() {
    
                    /**
                     * Properties of a StaffLeavingSpecialAreaWoFollowingSopDetails.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffLeavingSpecialAreaWoFollowingSopDetails
                     * @property {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.ActivityType|null} [activityType] StaffLeavingSpecialAreaWoFollowingSopDetails activityType
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] StaffLeavingSpecialAreaWoFollowingSopDetails artifacts
                     */
    
                    /**
                     * Constructs a new StaffLeavingSpecialAreaWoFollowingSopDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffLeavingSpecialAreaWoFollowingSopDetails.
                     * @implements IStaffLeavingSpecialAreaWoFollowingSopDetails
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails=} [properties] Properties to set
                     */
                    function StaffLeavingSpecialAreaWoFollowingSopDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffLeavingSpecialAreaWoFollowingSopDetails activityType.
                     * @member {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.ActivityType} activityType
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @instance
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.prototype.activityType = 0;
    
                    /**
                     * StaffLeavingSpecialAreaWoFollowingSopDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @instance
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * Creates a new StaffLeavingSpecialAreaWoFollowingSopDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails} StaffLeavingSpecialAreaWoFollowingSopDetails instance
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.create = function create(properties) {
                        return new StaffLeavingSpecialAreaWoFollowingSopDetails(properties);
                    };
    
                    /**
                     * Encodes the specified StaffLeavingSpecialAreaWoFollowingSopDetails message. Does not implicitly {@link palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails} message StaffLeavingSpecialAreaWoFollowingSopDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.activityType != null && Object.hasOwnProperty.call(message, "activityType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.activityType);
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffLeavingSpecialAreaWoFollowingSopDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {palexy.streaming.v1.IStaffLeavingSpecialAreaWoFollowingSopDetails} message StaffLeavingSpecialAreaWoFollowingSopDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffLeavingSpecialAreaWoFollowingSopDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails} StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.activityType = reader.int32();
                                break;
                            case 2:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffLeavingSpecialAreaWoFollowingSopDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails} StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffLeavingSpecialAreaWoFollowingSopDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.activityType != null && message.hasOwnProperty("activityType"))
                            switch (message.activityType) {
                            default:
                                return "activityType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffLeavingSpecialAreaWoFollowingSopDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails} StaffLeavingSpecialAreaWoFollowingSopDetails
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails();
                        switch (object.activityType) {
                        case "UNKNOWN":
                        case 0:
                            message.activityType = 0;
                            break;
                        case "BODY_NOT_CHECKED":
                        case 1:
                            message.activityType = 1;
                            break;
                        }
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffLeavingSpecialAreaWoFollowingSopDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @static
                     * @param {palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails} message StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (options.defaults)
                            object.activityType = options.enums === String ? "UNKNOWN" : 0;
                        if (message.activityType != null && message.hasOwnProperty("activityType"))
                            object.activityType = options.enums === String ? $root.palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.ActivityType[message.activityType] : message.activityType;
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffLeavingSpecialAreaWoFollowingSopDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ActivityType enum.
                     * @name palexy.streaming.v1.StaffLeavingSpecialAreaWoFollowingSopDetails.ActivityType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} BODY_NOT_CHECKED=1 BODY_NOT_CHECKED value
                     */
                    StaffLeavingSpecialAreaWoFollowingSopDetails.ActivityType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "BODY_NOT_CHECKED"] = 1;
                        return values;
                    })();
    
                    return StaffLeavingSpecialAreaWoFollowingSopDetails;
                })();
    
                v1.SopNonComplianceActivityDetails = (function() {
    
                    /**
                     * Properties of a SopNonComplianceActivityDetails.
                     * @memberof palexy.streaming.v1
                     * @interface ISopNonComplianceActivityDetails
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [artifacts] SopNonComplianceActivityDetails artifacts
                     */
    
                    /**
                     * Constructs a new SopNonComplianceActivityDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SopNonComplianceActivityDetails.
                     * @implements ISopNonComplianceActivityDetails
                     * @constructor
                     * @param {palexy.streaming.v1.ISopNonComplianceActivityDetails=} [properties] Properties to set
                     */
                    function SopNonComplianceActivityDetails(properties) {
                        this.artifacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SopNonComplianceActivityDetails artifacts.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} artifacts
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @instance
                     */
                    SopNonComplianceActivityDetails.prototype.artifacts = $util.emptyArray;
    
                    /**
                     * Creates a new SopNonComplianceActivityDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISopNonComplianceActivityDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SopNonComplianceActivityDetails} SopNonComplianceActivityDetails instance
                     */
                    SopNonComplianceActivityDetails.create = function create(properties) {
                        return new SopNonComplianceActivityDetails(properties);
                    };
    
                    /**
                     * Encodes the specified SopNonComplianceActivityDetails message. Does not implicitly {@link palexy.streaming.v1.SopNonComplianceActivityDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISopNonComplianceActivityDetails} message SopNonComplianceActivityDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SopNonComplianceActivityDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.artifacts != null && message.artifacts.length)
                            for (var i = 0; i < message.artifacts.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.artifacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SopNonComplianceActivityDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.SopNonComplianceActivityDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.ISopNonComplianceActivityDetails} message SopNonComplianceActivityDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SopNonComplianceActivityDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SopNonComplianceActivityDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SopNonComplianceActivityDetails} SopNonComplianceActivityDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SopNonComplianceActivityDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SopNonComplianceActivityDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.artifacts && message.artifacts.length))
                                    message.artifacts = [];
                                message.artifacts.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SopNonComplianceActivityDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SopNonComplianceActivityDetails} SopNonComplianceActivityDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SopNonComplianceActivityDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SopNonComplianceActivityDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SopNonComplianceActivityDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.artifacts != null && message.hasOwnProperty("artifacts")) {
                            if (!Array.isArray(message.artifacts))
                                return "artifacts: array expected";
                            for (var i = 0; i < message.artifacts.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.artifacts[i]);
                                if (error)
                                    return "artifacts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SopNonComplianceActivityDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SopNonComplianceActivityDetails} SopNonComplianceActivityDetails
                     */
                    SopNonComplianceActivityDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SopNonComplianceActivityDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.SopNonComplianceActivityDetails();
                        if (object.artifacts) {
                            if (!Array.isArray(object.artifacts))
                                throw TypeError(".palexy.streaming.v1.SopNonComplianceActivityDetails.artifacts: array expected");
                            message.artifacts = [];
                            for (var i = 0; i < object.artifacts.length; ++i) {
                                if (typeof object.artifacts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.SopNonComplianceActivityDetails.artifacts: object expected");
                                message.artifacts[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.artifacts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SopNonComplianceActivityDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @static
                     * @param {palexy.streaming.v1.SopNonComplianceActivityDetails} message SopNonComplianceActivityDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SopNonComplianceActivityDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.artifacts = [];
                        if (message.artifacts && message.artifacts.length) {
                            object.artifacts = [];
                            for (var j = 0; j < message.artifacts.length; ++j)
                                object.artifacts[j] = $root.palexy.streaming.v1.Artifact.toObject(message.artifacts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SopNonComplianceActivityDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SopNonComplianceActivityDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SopNonComplianceActivityDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SopNonComplianceActivityDetails;
                })();
    
                v1.LongTotalServiceTimeDetails = (function() {
    
                    /**
                     * Properties of a LongTotalServiceTimeDetails.
                     * @memberof palexy.streaming.v1
                     * @interface ILongTotalServiceTimeDetails
                     * @property {number|null} [totalServiceTimeSeconds] LongTotalServiceTimeDetails totalServiceTimeSeconds
                     */
    
                    /**
                     * Constructs a new LongTotalServiceTimeDetails.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a LongTotalServiceTimeDetails.
                     * @implements ILongTotalServiceTimeDetails
                     * @constructor
                     * @param {palexy.streaming.v1.ILongTotalServiceTimeDetails=} [properties] Properties to set
                     */
                    function LongTotalServiceTimeDetails(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * LongTotalServiceTimeDetails totalServiceTimeSeconds.
                     * @member {number} totalServiceTimeSeconds
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @instance
                     */
                    LongTotalServiceTimeDetails.prototype.totalServiceTimeSeconds = 0;
    
                    /**
                     * Creates a new LongTotalServiceTimeDetails instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {palexy.streaming.v1.ILongTotalServiceTimeDetails=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.LongTotalServiceTimeDetails} LongTotalServiceTimeDetails instance
                     */
                    LongTotalServiceTimeDetails.create = function create(properties) {
                        return new LongTotalServiceTimeDetails(properties);
                    };
    
                    /**
                     * Encodes the specified LongTotalServiceTimeDetails message. Does not implicitly {@link palexy.streaming.v1.LongTotalServiceTimeDetails.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {palexy.streaming.v1.ILongTotalServiceTimeDetails} message LongTotalServiceTimeDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LongTotalServiceTimeDetails.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.totalServiceTimeSeconds != null && Object.hasOwnProperty.call(message, "totalServiceTimeSeconds"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.totalServiceTimeSeconds);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified LongTotalServiceTimeDetails message, length delimited. Does not implicitly {@link palexy.streaming.v1.LongTotalServiceTimeDetails.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {palexy.streaming.v1.ILongTotalServiceTimeDetails} message LongTotalServiceTimeDetails message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LongTotalServiceTimeDetails.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a LongTotalServiceTimeDetails message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.LongTotalServiceTimeDetails} LongTotalServiceTimeDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LongTotalServiceTimeDetails.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.LongTotalServiceTimeDetails();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.totalServiceTimeSeconds = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a LongTotalServiceTimeDetails message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.LongTotalServiceTimeDetails} LongTotalServiceTimeDetails
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LongTotalServiceTimeDetails.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a LongTotalServiceTimeDetails message.
                     * @function verify
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LongTotalServiceTimeDetails.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.totalServiceTimeSeconds != null && message.hasOwnProperty("totalServiceTimeSeconds"))
                            if (!$util.isInteger(message.totalServiceTimeSeconds))
                                return "totalServiceTimeSeconds: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a LongTotalServiceTimeDetails message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.LongTotalServiceTimeDetails} LongTotalServiceTimeDetails
                     */
                    LongTotalServiceTimeDetails.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.LongTotalServiceTimeDetails)
                            return object;
                        var message = new $root.palexy.streaming.v1.LongTotalServiceTimeDetails();
                        if (object.totalServiceTimeSeconds != null)
                            message.totalServiceTimeSeconds = object.totalServiceTimeSeconds | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a LongTotalServiceTimeDetails message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @static
                     * @param {palexy.streaming.v1.LongTotalServiceTimeDetails} message LongTotalServiceTimeDetails
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LongTotalServiceTimeDetails.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.totalServiceTimeSeconds = 0;
                        if (message.totalServiceTimeSeconds != null && message.hasOwnProperty("totalServiceTimeSeconds"))
                            object.totalServiceTimeSeconds = message.totalServiceTimeSeconds;
                        return object;
                    };
    
                    /**
                     * Converts this LongTotalServiceTimeDetails to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.LongTotalServiceTimeDetails
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LongTotalServiceTimeDetails.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return LongTotalServiceTimeDetails;
                })();
    
                v1.EmbeddedReportService = (function() {
    
                    /**
                     * Constructs a new EmbeddedReportService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EmbeddedReportService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function EmbeddedReportService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (EmbeddedReportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = EmbeddedReportService;
    
                    /**
                     * Creates new EmbeddedReportService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {EmbeddedReportService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    EmbeddedReportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmbeddedReportService#createEmbeddedReport}.
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @typedef CreateEmbeddedReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.EmbeddedReport} [response] EmbeddedReport
                     */
    
                    /**
                     * Calls CreateEmbeddedReport.
                     * @function createEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest} request CreateEmbeddedReportRequest message or plain object
                     * @param {palexy.streaming.v1.EmbeddedReportService.CreateEmbeddedReportCallback} callback Node-style callback called with the error, if any, and EmbeddedReport
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmbeddedReportService.prototype.createEmbeddedReport = function createEmbeddedReport(request, callback) {
                        return this.rpcCall(createEmbeddedReport, $root.palexy.streaming.v1.CreateEmbeddedReportRequest, $root.palexy.streaming.v1.EmbeddedReport, request, callback);
                    }, "name", { value: "CreateEmbeddedReport" });
    
                    /**
                     * Calls CreateEmbeddedReport.
                     * @function createEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest} request CreateEmbeddedReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.EmbeddedReport>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmbeddedReportService#getEmbeddedReport}.
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @typedef GetEmbeddedReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.EmbeddedReport} [response] EmbeddedReport
                     */
    
                    /**
                     * Calls GetEmbeddedReport.
                     * @function getEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest} request GetEmbeddedReportRequest message or plain object
                     * @param {palexy.streaming.v1.EmbeddedReportService.GetEmbeddedReportCallback} callback Node-style callback called with the error, if any, and EmbeddedReport
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmbeddedReportService.prototype.getEmbeddedReport = function getEmbeddedReport(request, callback) {
                        return this.rpcCall(getEmbeddedReport, $root.palexy.streaming.v1.GetEmbeddedReportRequest, $root.palexy.streaming.v1.EmbeddedReport, request, callback);
                    }, "name", { value: "GetEmbeddedReport" });
    
                    /**
                     * Calls GetEmbeddedReport.
                     * @function getEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest} request GetEmbeddedReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.EmbeddedReport>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmbeddedReportService#updateEmbeddedReport}.
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @typedef UpdateEmbeddedReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.EmbeddedReport} [response] EmbeddedReport
                     */
    
                    /**
                     * Calls UpdateEmbeddedReport.
                     * @function updateEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest} request UpdateEmbeddedReportRequest message or plain object
                     * @param {palexy.streaming.v1.EmbeddedReportService.UpdateEmbeddedReportCallback} callback Node-style callback called with the error, if any, and EmbeddedReport
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmbeddedReportService.prototype.updateEmbeddedReport = function updateEmbeddedReport(request, callback) {
                        return this.rpcCall(updateEmbeddedReport, $root.palexy.streaming.v1.UpdateEmbeddedReportRequest, $root.palexy.streaming.v1.EmbeddedReport, request, callback);
                    }, "name", { value: "UpdateEmbeddedReport" });
    
                    /**
                     * Calls UpdateEmbeddedReport.
                     * @function updateEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest} request UpdateEmbeddedReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.EmbeddedReport>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmbeddedReportService#deleteEmbeddedReport}.
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @typedef DeleteEmbeddedReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteEmbeddedReport.
                     * @function deleteEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest} request DeleteEmbeddedReportRequest message or plain object
                     * @param {palexy.streaming.v1.EmbeddedReportService.DeleteEmbeddedReportCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmbeddedReportService.prototype.deleteEmbeddedReport = function deleteEmbeddedReport(request, callback) {
                        return this.rpcCall(deleteEmbeddedReport, $root.palexy.streaming.v1.DeleteEmbeddedReportRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteEmbeddedReport" });
    
                    /**
                     * Calls DeleteEmbeddedReport.
                     * @function deleteEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest} request DeleteEmbeddedReportRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.EmbeddedReportService#listEmbeddedReport}.
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @typedef ListEmbeddedReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListEmbeddedReportResponse} [response] ListEmbeddedReportResponse
                     */
    
                    /**
                     * Calls ListEmbeddedReport.
                     * @function listEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest} request ListEmbeddedReportRequest message or plain object
                     * @param {palexy.streaming.v1.EmbeddedReportService.ListEmbeddedReportCallback} callback Node-style callback called with the error, if any, and ListEmbeddedReportResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(EmbeddedReportService.prototype.listEmbeddedReport = function listEmbeddedReport(request, callback) {
                        return this.rpcCall(listEmbeddedReport, $root.palexy.streaming.v1.ListEmbeddedReportRequest, $root.palexy.streaming.v1.ListEmbeddedReportResponse, request, callback);
                    }, "name", { value: "ListEmbeddedReport" });
    
                    /**
                     * Calls ListEmbeddedReport.
                     * @function listEmbeddedReport
                     * @memberof palexy.streaming.v1.EmbeddedReportService
                     * @instance
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest} request ListEmbeddedReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListEmbeddedReportResponse>} Promise
                     * @variation 2
                     */
    
                    return EmbeddedReportService;
                })();
    
                v1.CreateEmbeddedReportRequest = (function() {
    
                    /**
                     * Properties of a CreateEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateEmbeddedReportRequest
                     * @property {palexy.streaming.v1.IEmbeddedReport|null} [report] CreateEmbeddedReportRequest report
                     */
    
                    /**
                     * Constructs a new CreateEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateEmbeddedReportRequest.
                     * @implements ICreateEmbeddedReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest=} [properties] Properties to set
                     */
                    function CreateEmbeddedReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateEmbeddedReportRequest report.
                     * @member {palexy.streaming.v1.IEmbeddedReport|null|undefined} report
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @instance
                     */
                    CreateEmbeddedReportRequest.prototype.report = null;
    
                    /**
                     * Creates a new CreateEmbeddedReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateEmbeddedReportRequest} CreateEmbeddedReportRequest instance
                     */
                    CreateEmbeddedReportRequest.create = function create(properties) {
                        return new CreateEmbeddedReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateEmbeddedReportRequest message. Does not implicitly {@link palexy.streaming.v1.CreateEmbeddedReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest} message CreateEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateEmbeddedReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.report != null && Object.hasOwnProperty.call(message, "report"))
                            $root.palexy.streaming.v1.EmbeddedReport.encode(message.report, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateEmbeddedReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateEmbeddedReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateEmbeddedReportRequest} message CreateEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateEmbeddedReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateEmbeddedReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateEmbeddedReportRequest} CreateEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateEmbeddedReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateEmbeddedReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.report = $root.palexy.streaming.v1.EmbeddedReport.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateEmbeddedReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateEmbeddedReportRequest} CreateEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateEmbeddedReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateEmbeddedReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateEmbeddedReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.report != null && message.hasOwnProperty("report")) {
                            var error = $root.palexy.streaming.v1.EmbeddedReport.verify(message.report);
                            if (error)
                                return "report." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateEmbeddedReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateEmbeddedReportRequest} CreateEmbeddedReportRequest
                     */
                    CreateEmbeddedReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateEmbeddedReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateEmbeddedReportRequest();
                        if (object.report != null) {
                            if (typeof object.report !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateEmbeddedReportRequest.report: object expected");
                            message.report = $root.palexy.streaming.v1.EmbeddedReport.fromObject(object.report);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateEmbeddedReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateEmbeddedReportRequest} message CreateEmbeddedReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateEmbeddedReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.report = null;
                        if (message.report != null && message.hasOwnProperty("report"))
                            object.report = $root.palexy.streaming.v1.EmbeddedReport.toObject(message.report, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateEmbeddedReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateEmbeddedReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateEmbeddedReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateEmbeddedReportRequest;
                })();
    
                v1.GetEmbeddedReportRequest = (function() {
    
                    /**
                     * Properties of a GetEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetEmbeddedReportRequest
                     * @property {number|null} [id] GetEmbeddedReportRequest id
                     */
    
                    /**
                     * Constructs a new GetEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetEmbeddedReportRequest.
                     * @implements IGetEmbeddedReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest=} [properties] Properties to set
                     */
                    function GetEmbeddedReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetEmbeddedReportRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @instance
                     */
                    GetEmbeddedReportRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetEmbeddedReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetEmbeddedReportRequest} GetEmbeddedReportRequest instance
                     */
                    GetEmbeddedReportRequest.create = function create(properties) {
                        return new GetEmbeddedReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetEmbeddedReportRequest message. Does not implicitly {@link palexy.streaming.v1.GetEmbeddedReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest} message GetEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmbeddedReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetEmbeddedReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetEmbeddedReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetEmbeddedReportRequest} message GetEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetEmbeddedReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetEmbeddedReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetEmbeddedReportRequest} GetEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmbeddedReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetEmbeddedReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetEmbeddedReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetEmbeddedReportRequest} GetEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetEmbeddedReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetEmbeddedReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetEmbeddedReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetEmbeddedReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetEmbeddedReportRequest} GetEmbeddedReportRequest
                     */
                    GetEmbeddedReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetEmbeddedReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetEmbeddedReportRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetEmbeddedReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.GetEmbeddedReportRequest} message GetEmbeddedReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetEmbeddedReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetEmbeddedReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetEmbeddedReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetEmbeddedReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetEmbeddedReportRequest;
                })();
    
                v1.UpdateEmbeddedReportRequest = (function() {
    
                    /**
                     * Properties of an UpdateEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateEmbeddedReportRequest
                     * @property {palexy.streaming.v1.IEmbeddedReport|null} [report] UpdateEmbeddedReportRequest report
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateEmbeddedReportRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateEmbeddedReportRequest.
                     * @implements IUpdateEmbeddedReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest=} [properties] Properties to set
                     */
                    function UpdateEmbeddedReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateEmbeddedReportRequest report.
                     * @member {palexy.streaming.v1.IEmbeddedReport|null|undefined} report
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @instance
                     */
                    UpdateEmbeddedReportRequest.prototype.report = null;
    
                    /**
                     * UpdateEmbeddedReportRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @instance
                     */
                    UpdateEmbeddedReportRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateEmbeddedReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateEmbeddedReportRequest} UpdateEmbeddedReportRequest instance
                     */
                    UpdateEmbeddedReportRequest.create = function create(properties) {
                        return new UpdateEmbeddedReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateEmbeddedReportRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateEmbeddedReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest} message UpdateEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateEmbeddedReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.report != null && Object.hasOwnProperty.call(message, "report"))
                            $root.palexy.streaming.v1.EmbeddedReport.encode(message.report, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateEmbeddedReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateEmbeddedReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateEmbeddedReportRequest} message UpdateEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateEmbeddedReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateEmbeddedReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateEmbeddedReportRequest} UpdateEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateEmbeddedReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateEmbeddedReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.report = $root.palexy.streaming.v1.EmbeddedReport.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateEmbeddedReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateEmbeddedReportRequest} UpdateEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateEmbeddedReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateEmbeddedReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateEmbeddedReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.report != null && message.hasOwnProperty("report")) {
                            var error = $root.palexy.streaming.v1.EmbeddedReport.verify(message.report);
                            if (error)
                                return "report." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateEmbeddedReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateEmbeddedReportRequest} UpdateEmbeddedReportRequest
                     */
                    UpdateEmbeddedReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateEmbeddedReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateEmbeddedReportRequest();
                        if (object.report != null) {
                            if (typeof object.report !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateEmbeddedReportRequest.report: object expected");
                            message.report = $root.palexy.streaming.v1.EmbeddedReport.fromObject(object.report);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateEmbeddedReportRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateEmbeddedReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateEmbeddedReportRequest} message UpdateEmbeddedReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateEmbeddedReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.report = null;
                            object.updateMask = null;
                        }
                        if (message.report != null && message.hasOwnProperty("report"))
                            object.report = $root.palexy.streaming.v1.EmbeddedReport.toObject(message.report, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateEmbeddedReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateEmbeddedReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateEmbeddedReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateEmbeddedReportRequest;
                })();
    
                v1.DeleteEmbeddedReportRequest = (function() {
    
                    /**
                     * Properties of a DeleteEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteEmbeddedReportRequest
                     * @property {number|null} [id] DeleteEmbeddedReportRequest id
                     */
    
                    /**
                     * Constructs a new DeleteEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteEmbeddedReportRequest.
                     * @implements IDeleteEmbeddedReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest=} [properties] Properties to set
                     */
                    function DeleteEmbeddedReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteEmbeddedReportRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @instance
                     */
                    DeleteEmbeddedReportRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteEmbeddedReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteEmbeddedReportRequest} DeleteEmbeddedReportRequest instance
                     */
                    DeleteEmbeddedReportRequest.create = function create(properties) {
                        return new DeleteEmbeddedReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteEmbeddedReportRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteEmbeddedReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest} message DeleteEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteEmbeddedReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteEmbeddedReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteEmbeddedReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteEmbeddedReportRequest} message DeleteEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteEmbeddedReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteEmbeddedReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteEmbeddedReportRequest} DeleteEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteEmbeddedReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteEmbeddedReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteEmbeddedReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteEmbeddedReportRequest} DeleteEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteEmbeddedReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteEmbeddedReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteEmbeddedReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteEmbeddedReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteEmbeddedReportRequest} DeleteEmbeddedReportRequest
                     */
                    DeleteEmbeddedReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteEmbeddedReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteEmbeddedReportRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteEmbeddedReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteEmbeddedReportRequest} message DeleteEmbeddedReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteEmbeddedReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteEmbeddedReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteEmbeddedReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteEmbeddedReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteEmbeddedReportRequest;
                })();
    
                v1.ListEmbeddedReportRequest = (function() {
    
                    /**
                     * Properties of a ListEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListEmbeddedReportRequest
                     * @property {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter|null} [reportFilter] ListEmbeddedReportRequest reportFilter
                     */
    
                    /**
                     * Constructs a new ListEmbeddedReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListEmbeddedReportRequest.
                     * @implements IListEmbeddedReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest=} [properties] Properties to set
                     */
                    function ListEmbeddedReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListEmbeddedReportRequest reportFilter.
                     * @member {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter|null|undefined} reportFilter
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @instance
                     */
                    ListEmbeddedReportRequest.prototype.reportFilter = null;
    
                    /**
                     * Creates a new ListEmbeddedReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListEmbeddedReportRequest} ListEmbeddedReportRequest instance
                     */
                    ListEmbeddedReportRequest.create = function create(properties) {
                        return new ListEmbeddedReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListEmbeddedReportRequest message. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest} message ListEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListEmbeddedReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reportFilter != null && Object.hasOwnProperty.call(message, "reportFilter"))
                            $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.encode(message.reportFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListEmbeddedReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportRequest} message ListEmbeddedReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListEmbeddedReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListEmbeddedReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListEmbeddedReportRequest} ListEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListEmbeddedReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListEmbeddedReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.reportFilter = $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListEmbeddedReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListEmbeddedReportRequest} ListEmbeddedReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListEmbeddedReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListEmbeddedReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListEmbeddedReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reportFilter != null && message.hasOwnProperty("reportFilter")) {
                            var error = $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.verify(message.reportFilter);
                            if (error)
                                return "reportFilter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListEmbeddedReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListEmbeddedReportRequest} ListEmbeddedReportRequest
                     */
                    ListEmbeddedReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListEmbeddedReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListEmbeddedReportRequest();
                        if (object.reportFilter != null) {
                            if (typeof object.reportFilter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListEmbeddedReportRequest.reportFilter: object expected");
                            message.reportFilter = $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.fromObject(object.reportFilter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListEmbeddedReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @static
                     * @param {palexy.streaming.v1.ListEmbeddedReportRequest} message ListEmbeddedReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListEmbeddedReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.reportFilter = null;
                        if (message.reportFilter != null && message.hasOwnProperty("reportFilter"))
                            object.reportFilter = $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.toObject(message.reportFilter, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListEmbeddedReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListEmbeddedReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListEmbeddedReportRequest.ReportFilter = (function() {
    
                        /**
                         * Properties of a ReportFilter.
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                         * @interface IReportFilter
                         * @property {number|null} [companyId] ReportFilter companyId
                         */
    
                        /**
                         * Constructs a new ReportFilter.
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest
                         * @classdesc Represents a ReportFilter.
                         * @implements IReportFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter=} [properties] Properties to set
                         */
                        function ReportFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ReportFilter companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @instance
                         */
                        ReportFilter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new ReportFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter} ReportFilter instance
                         */
                        ReportFilter.create = function create(properties) {
                            return new ReportFilter(properties);
                        };
    
                        /**
                         * Encodes the specified ReportFilter message. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter} message ReportFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ReportFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ReportFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {palexy.streaming.v1.ListEmbeddedReportRequest.IReportFilter} message ReportFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ReportFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ReportFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter} ReportFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ReportFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.companyId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ReportFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter} ReportFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ReportFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ReportFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ReportFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates a ReportFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter} ReportFilter
                         */
                        ReportFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter();
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ReportFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @static
                         * @param {palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter} message ReportFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ReportFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            return object;
                        };
    
                        /**
                         * Converts this ReportFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListEmbeddedReportRequest.ReportFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ReportFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ReportFilter;
                    })();
    
                    return ListEmbeddedReportRequest;
                })();
    
                v1.ListEmbeddedReportResponse = (function() {
    
                    /**
                     * Properties of a ListEmbeddedReportResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListEmbeddedReportResponse
                     * @property {Array.<palexy.streaming.v1.IEmbeddedReport>|null} [reports] ListEmbeddedReportResponse reports
                     */
    
                    /**
                     * Constructs a new ListEmbeddedReportResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListEmbeddedReportResponse.
                     * @implements IListEmbeddedReportResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListEmbeddedReportResponse=} [properties] Properties to set
                     */
                    function ListEmbeddedReportResponse(properties) {
                        this.reports = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListEmbeddedReportResponse reports.
                     * @member {Array.<palexy.streaming.v1.IEmbeddedReport>} reports
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @instance
                     */
                    ListEmbeddedReportResponse.prototype.reports = $util.emptyArray;
    
                    /**
                     * Creates a new ListEmbeddedReportResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListEmbeddedReportResponse} ListEmbeddedReportResponse instance
                     */
                    ListEmbeddedReportResponse.create = function create(properties) {
                        return new ListEmbeddedReportResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListEmbeddedReportResponse message. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportResponse} message ListEmbeddedReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListEmbeddedReportResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reports != null && message.reports.length)
                            for (var i = 0; i < message.reports.length; ++i)
                                $root.palexy.streaming.v1.EmbeddedReport.encode(message.reports[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListEmbeddedReportResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListEmbeddedReportResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IListEmbeddedReportResponse} message ListEmbeddedReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListEmbeddedReportResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListEmbeddedReportResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListEmbeddedReportResponse} ListEmbeddedReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListEmbeddedReportResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListEmbeddedReportResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.reports && message.reports.length))
                                    message.reports = [];
                                message.reports.push($root.palexy.streaming.v1.EmbeddedReport.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListEmbeddedReportResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListEmbeddedReportResponse} ListEmbeddedReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListEmbeddedReportResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListEmbeddedReportResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListEmbeddedReportResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reports != null && message.hasOwnProperty("reports")) {
                            if (!Array.isArray(message.reports))
                                return "reports: array expected";
                            for (var i = 0; i < message.reports.length; ++i) {
                                var error = $root.palexy.streaming.v1.EmbeddedReport.verify(message.reports[i]);
                                if (error)
                                    return "reports." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListEmbeddedReportResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListEmbeddedReportResponse} ListEmbeddedReportResponse
                     */
                    ListEmbeddedReportResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListEmbeddedReportResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListEmbeddedReportResponse();
                        if (object.reports) {
                            if (!Array.isArray(object.reports))
                                throw TypeError(".palexy.streaming.v1.ListEmbeddedReportResponse.reports: array expected");
                            message.reports = [];
                            for (var i = 0; i < object.reports.length; ++i) {
                                if (typeof object.reports[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListEmbeddedReportResponse.reports: object expected");
                                message.reports[i] = $root.palexy.streaming.v1.EmbeddedReport.fromObject(object.reports[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListEmbeddedReportResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @static
                     * @param {palexy.streaming.v1.ListEmbeddedReportResponse} message ListEmbeddedReportResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListEmbeddedReportResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.reports = [];
                        if (message.reports && message.reports.length) {
                            object.reports = [];
                            for (var j = 0; j < message.reports.length; ++j)
                                object.reports[j] = $root.palexy.streaming.v1.EmbeddedReport.toObject(message.reports[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListEmbeddedReportResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListEmbeddedReportResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListEmbeddedReportResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListEmbeddedReportResponse;
                })();
    
                v1.EmbeddedReport = (function() {
    
                    /**
                     * Properties of an EmbeddedReport.
                     * @memberof palexy.streaming.v1
                     * @interface IEmbeddedReport
                     * @property {number|null} [id] EmbeddedReport id
                     * @property {string|null} [name] EmbeddedReport name
                     * @property {string|null} [iframeLink] EmbeddedReport iframeLink
                     * @property {string|null} [width] EmbeddedReport width
                     * @property {string|null} [height] EmbeddedReport height
                     * @property {number|null} [companyId] EmbeddedReport companyId
                     * @property {Array.<number>|null} [sharedAccountIds] EmbeddedReport sharedAccountIds
                     * @property {palexy.streaming.v1.EmbeddedReportSource|null} [source] EmbeddedReport source
                     * @property {number|null} [createTimeMs] EmbeddedReport createTimeMs
                     * @property {number|null} [updateTimeMs] EmbeddedReport updateTimeMs
                     */
    
                    /**
                     * Constructs a new EmbeddedReport.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an EmbeddedReport.
                     * @implements IEmbeddedReport
                     * @constructor
                     * @param {palexy.streaming.v1.IEmbeddedReport=} [properties] Properties to set
                     */
                    function EmbeddedReport(properties) {
                        this.sharedAccountIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EmbeddedReport id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * EmbeddedReport name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.name = "";
    
                    /**
                     * EmbeddedReport iframeLink.
                     * @member {string} iframeLink
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.iframeLink = "";
    
                    /**
                     * EmbeddedReport width.
                     * @member {string} width
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.width = "";
    
                    /**
                     * EmbeddedReport height.
                     * @member {string} height
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.height = "";
    
                    /**
                     * EmbeddedReport companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * EmbeddedReport sharedAccountIds.
                     * @member {Array.<number>} sharedAccountIds
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.sharedAccountIds = $util.emptyArray;
    
                    /**
                     * EmbeddedReport source.
                     * @member {palexy.streaming.v1.EmbeddedReportSource} source
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.source = 0;
    
                    /**
                     * EmbeddedReport createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * EmbeddedReport updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     */
                    EmbeddedReport.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new EmbeddedReport instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {palexy.streaming.v1.IEmbeddedReport=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.EmbeddedReport} EmbeddedReport instance
                     */
                    EmbeddedReport.create = function create(properties) {
                        return new EmbeddedReport(properties);
                    };
    
                    /**
                     * Encodes the specified EmbeddedReport message. Does not implicitly {@link palexy.streaming.v1.EmbeddedReport.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {palexy.streaming.v1.IEmbeddedReport} message EmbeddedReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmbeddedReport.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.iframeLink != null && Object.hasOwnProperty.call(message, "iframeLink"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.iframeLink);
                        if (message.width != null && Object.hasOwnProperty.call(message, "width"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.width);
                        if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.height);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.companyId);
                        if (message.sharedAccountIds != null && message.sharedAccountIds.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.sharedAccountIds.length; ++i)
                                writer.int64(message.sharedAccountIds[i]);
                            writer.ldelim();
                        }
                        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.source);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EmbeddedReport message, length delimited. Does not implicitly {@link palexy.streaming.v1.EmbeddedReport.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {palexy.streaming.v1.IEmbeddedReport} message EmbeddedReport message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmbeddedReport.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EmbeddedReport message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.EmbeddedReport} EmbeddedReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmbeddedReport.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.EmbeddedReport();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.iframeLink = reader.string();
                                break;
                            case 4:
                                message.width = reader.string();
                                break;
                            case 5:
                                message.height = reader.string();
                                break;
                            case 6:
                                message.companyId = reader.int64();
                                break;
                            case 7:
                                if (!(message.sharedAccountIds && message.sharedAccountIds.length))
                                    message.sharedAccountIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.sharedAccountIds.push(reader.int64());
                                } else
                                    message.sharedAccountIds.push(reader.int64());
                                break;
                            case 8:
                                message.source = reader.int32();
                                break;
                            case 9:
                                message.createTimeMs = reader.int64();
                                break;
                            case 10:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EmbeddedReport message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.EmbeddedReport} EmbeddedReport
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmbeddedReport.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EmbeddedReport message.
                     * @function verify
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EmbeddedReport.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.iframeLink != null && message.hasOwnProperty("iframeLink"))
                            if (!$util.isString(message.iframeLink))
                                return "iframeLink: string expected";
                        if (message.width != null && message.hasOwnProperty("width"))
                            if (!$util.isString(message.width))
                                return "width: string expected";
                        if (message.height != null && message.hasOwnProperty("height"))
                            if (!$util.isString(message.height))
                                return "height: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.sharedAccountIds != null && message.hasOwnProperty("sharedAccountIds")) {
                            if (!Array.isArray(message.sharedAccountIds))
                                return "sharedAccountIds: array expected";
                            for (var i = 0; i < message.sharedAccountIds.length; ++i)
                                if (!$util.isInteger(message.sharedAccountIds[i]) && !(message.sharedAccountIds[i] && $util.isInteger(message.sharedAccountIds[i].low) && $util.isInteger(message.sharedAccountIds[i].high)))
                                    return "sharedAccountIds: integer|Long[] expected";
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            switch (message.source) {
                            default:
                                return "source: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an EmbeddedReport message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.EmbeddedReport} EmbeddedReport
                     */
                    EmbeddedReport.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.EmbeddedReport)
                            return object;
                        var message = new $root.palexy.streaming.v1.EmbeddedReport();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.iframeLink != null)
                            message.iframeLink = String(object.iframeLink);
                        if (object.width != null)
                            message.width = String(object.width);
                        if (object.height != null)
                            message.height = String(object.height);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.sharedAccountIds) {
                            if (!Array.isArray(object.sharedAccountIds))
                                throw TypeError(".palexy.streaming.v1.EmbeddedReport.sharedAccountIds: array expected");
                            message.sharedAccountIds = [];
                            for (var i = 0; i < object.sharedAccountIds.length; ++i)
                                if ($util.Long)
                                    (message.sharedAccountIds[i] = $util.Long.fromValue(object.sharedAccountIds[i])).unsigned = false;
                                else if (typeof object.sharedAccountIds[i] === "string")
                                    message.sharedAccountIds[i] = parseInt(object.sharedAccountIds[i], 10);
                                else if (typeof object.sharedAccountIds[i] === "number")
                                    message.sharedAccountIds[i] = object.sharedAccountIds[i];
                                else if (typeof object.sharedAccountIds[i] === "object")
                                    message.sharedAccountIds[i] = new $util.LongBits(object.sharedAccountIds[i].low >>> 0, object.sharedAccountIds[i].high >>> 0).toNumber();
                        }
                        switch (object.source) {
                        case "UNKNOWN_SOURCE":
                        case 0:
                            message.source = 0;
                            break;
                        case "DATA_STUDIO":
                        case 1:
                            message.source = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EmbeddedReport message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @static
                     * @param {palexy.streaming.v1.EmbeddedReport} message EmbeddedReport
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EmbeddedReport.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.sharedAccountIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.iframeLink = "";
                            object.width = "";
                            object.height = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.source = options.enums === String ? "UNKNOWN_SOURCE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.iframeLink != null && message.hasOwnProperty("iframeLink"))
                            object.iframeLink = message.iframeLink;
                        if (message.width != null && message.hasOwnProperty("width"))
                            object.width = message.width;
                        if (message.height != null && message.hasOwnProperty("height"))
                            object.height = message.height;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.sharedAccountIds && message.sharedAccountIds.length) {
                            object.sharedAccountIds = [];
                            for (var j = 0; j < message.sharedAccountIds.length; ++j)
                                if (typeof message.sharedAccountIds[j] === "number")
                                    object.sharedAccountIds[j] = options.longs === String ? String(message.sharedAccountIds[j]) : message.sharedAccountIds[j];
                                else
                                    object.sharedAccountIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.sharedAccountIds[j]) : options.longs === Number ? new $util.LongBits(message.sharedAccountIds[j].low >>> 0, message.sharedAccountIds[j].high >>> 0).toNumber() : message.sharedAccountIds[j];
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            object.source = options.enums === String ? $root.palexy.streaming.v1.EmbeddedReportSource[message.source] : message.source;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this EmbeddedReport to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.EmbeddedReport
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EmbeddedReport.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EmbeddedReport;
                })();
    
                /**
                 * EmbeddedReportSource enum.
                 * @name palexy.streaming.v1.EmbeddedReportSource
                 * @enum {number}
                 * @property {number} UNKNOWN_SOURCE=0 UNKNOWN_SOURCE value
                 * @property {number} DATA_STUDIO=1 DATA_STUDIO value
                 */
                v1.EmbeddedReportSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_SOURCE"] = 0;
                    values[valuesById[1] = "DATA_STUDIO"] = 1;
                    return values;
                })();
    
                v1.StaffDataService = (function() {
    
                    /**
                     * Constructs a new StaffDataService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffDataService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffDataService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffDataService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffDataService;
    
                    /**
                     * Creates new StaffDataService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffDataService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffDataService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#createStaffImportConfig}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef CreateStaffImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffImportConfig} [response] StaffImportConfig
                     */
    
                    /**
                     * Calls CreateStaffImportConfig.
                     * @function createStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest} request CreateStaffImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.CreateStaffImportConfigCallback} callback Node-style callback called with the error, if any, and StaffImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.createStaffImportConfig = function createStaffImportConfig(request, callback) {
                        return this.rpcCall(createStaffImportConfig, $root.palexy.streaming.v1.CreateStaffImportConfigRequest, $root.palexy.streaming.v1.StaffImportConfig, request, callback);
                    }, "name", { value: "CreateStaffImportConfig" });
    
                    /**
                     * Calls CreateStaffImportConfig.
                     * @function createStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest} request CreateStaffImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#updateStaffImportConfig}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef UpdateStaffImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffImportConfig} [response] StaffImportConfig
                     */
    
                    /**
                     * Calls UpdateStaffImportConfig.
                     * @function updateStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest} request UpdateStaffImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.UpdateStaffImportConfigCallback} callback Node-style callback called with the error, if any, and StaffImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.updateStaffImportConfig = function updateStaffImportConfig(request, callback) {
                        return this.rpcCall(updateStaffImportConfig, $root.palexy.streaming.v1.UpdateStaffImportConfigRequest, $root.palexy.streaming.v1.StaffImportConfig, request, callback);
                    }, "name", { value: "UpdateStaffImportConfig" });
    
                    /**
                     * Calls UpdateStaffImportConfig.
                     * @function updateStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest} request UpdateStaffImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#deleteStaffImportConfig}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef DeleteStaffImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStaffImportConfig.
                     * @function deleteStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest} request DeleteStaffImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.DeleteStaffImportConfigCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.deleteStaffImportConfig = function deleteStaffImportConfig(request, callback) {
                        return this.rpcCall(deleteStaffImportConfig, $root.palexy.streaming.v1.DeleteStaffImportConfigRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStaffImportConfig" });
    
                    /**
                     * Calls DeleteStaffImportConfig.
                     * @function deleteStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest} request DeleteStaffImportConfigRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#listStaffImportConfig}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef ListStaffImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffImportConfigResponse} [response] ListStaffImportConfigResponse
                     */
    
                    /**
                     * Calls ListStaffImportConfig.
                     * @function listStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest} request ListStaffImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.ListStaffImportConfigCallback} callback Node-style callback called with the error, if any, and ListStaffImportConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.listStaffImportConfig = function listStaffImportConfig(request, callback) {
                        return this.rpcCall(listStaffImportConfig, $root.palexy.streaming.v1.ListStaffImportConfigRequest, $root.palexy.streaming.v1.ListStaffImportConfigResponse, request, callback);
                    }, "name", { value: "ListStaffImportConfig" });
    
                    /**
                     * Calls ListStaffImportConfig.
                     * @function listStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest} request ListStaffImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffImportConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#getStaffImportConfig}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef GetStaffImportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffImportConfig} [response] StaffImportConfig
                     */
    
                    /**
                     * Calls GetStaffImportConfig.
                     * @function getStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest} request GetStaffImportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.GetStaffImportConfigCallback} callback Node-style callback called with the error, if any, and StaffImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.getStaffImportConfig = function getStaffImportConfig(request, callback) {
                        return this.rpcCall(getStaffImportConfig, $root.palexy.streaming.v1.GetStaffImportConfigRequest, $root.palexy.streaming.v1.StaffImportConfig, request, callback);
                    }, "name", { value: "GetStaffImportConfig" });
    
                    /**
                     * Calls GetStaffImportConfig.
                     * @function getStaffImportConfig
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest} request GetStaffImportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffImportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#importStaffData}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef ImportStaffDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ImportStaffData.
                     * @function importStaffData
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IImportStaffDataRequest} request ImportStaffDataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.ImportStaffDataCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.importStaffData = function importStaffData(request, callback) {
                        return this.rpcCall(importStaffData, $root.palexy.streaming.v1.ImportStaffDataRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ImportStaffData" });
    
                    /**
                     * Calls ImportStaffData.
                     * @function importStaffData
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IImportStaffDataRequest} request ImportStaffDataRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#listStaffAllocation}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef ListStaffAllocationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffAllocationResponse} [response] ListStaffAllocationResponse
                     */
    
                    /**
                     * Calls ListStaffAllocation.
                     * @function listStaffAllocation
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest} request ListStaffAllocationRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.ListStaffAllocationCallback} callback Node-style callback called with the error, if any, and ListStaffAllocationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.listStaffAllocation = function listStaffAllocation(request, callback) {
                        return this.rpcCall(listStaffAllocation, $root.palexy.streaming.v1.ListStaffAllocationRequest, $root.palexy.streaming.v1.ListStaffAllocationResponse, request, callback);
                    }, "name", { value: "ListStaffAllocation" });
    
                    /**
                     * Calls ListStaffAllocation.
                     * @function listStaffAllocation
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest} request ListStaffAllocationRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffAllocationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffDataService#getStaffImportConfigByCompanyId}.
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @typedef GetStaffImportConfigByCompanyIdCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffImportConfig} [response] StaffImportConfig
                     */
    
                    /**
                     * Calls GetStaffImportConfigByCompanyId.
                     * @function getStaffImportConfigByCompanyId
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest} request GetStaffImportConfigByCompanyIdRequest message or plain object
                     * @param {palexy.streaming.v1.StaffDataService.GetStaffImportConfigByCompanyIdCallback} callback Node-style callback called with the error, if any, and StaffImportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffDataService.prototype.getStaffImportConfigByCompanyId = function getStaffImportConfigByCompanyId(request, callback) {
                        return this.rpcCall(getStaffImportConfigByCompanyId, $root.palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest, $root.palexy.streaming.v1.StaffImportConfig, request, callback);
                    }, "name", { value: "GetStaffImportConfigByCompanyId" });
    
                    /**
                     * Calls GetStaffImportConfigByCompanyId.
                     * @function getStaffImportConfigByCompanyId
                     * @memberof palexy.streaming.v1.StaffDataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest} request GetStaffImportConfigByCompanyIdRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffImportConfig>} Promise
                     * @variation 2
                     */
    
                    return StaffDataService;
                })();
    
                v1.ListStaffAllocationRequest = (function() {
    
                    /**
                     * Properties of a ListStaffAllocationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffAllocationRequest
                     * @property {Array.<number>|null} [storeIds] ListStaffAllocationRequest storeIds
                     * @property {number|null} [startDateId] ListStaffAllocationRequest startDateId
                     * @property {number|null} [endDateId] ListStaffAllocationRequest endDateId
                     * @property {number|null} [pageSize] ListStaffAllocationRequest pageSize
                     * @property {string|null} [pageToken] ListStaffAllocationRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListStaffAllocationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffAllocationRequest.
                     * @implements IListStaffAllocationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest=} [properties] Properties to set
                     */
                    function ListStaffAllocationRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffAllocationRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     */
                    ListStaffAllocationRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListStaffAllocationRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     */
                    ListStaffAllocationRequest.prototype.startDateId = 0;
    
                    /**
                     * ListStaffAllocationRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     */
                    ListStaffAllocationRequest.prototype.endDateId = 0;
    
                    /**
                     * ListStaffAllocationRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     */
                    ListStaffAllocationRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffAllocationRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     */
                    ListStaffAllocationRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListStaffAllocationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffAllocationRequest} ListStaffAllocationRequest instance
                     */
                    ListStaffAllocationRequest.create = function create(properties) {
                        return new ListStaffAllocationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffAllocationRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffAllocationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest} message ListStaffAllocationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffAllocationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffAllocationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffAllocationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationRequest} message ListStaffAllocationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffAllocationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffAllocationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffAllocationRequest} ListStaffAllocationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffAllocationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffAllocationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffAllocationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffAllocationRequest} ListStaffAllocationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffAllocationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffAllocationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffAllocationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffAllocationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffAllocationRequest} ListStaffAllocationRequest
                     */
                    ListStaffAllocationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffAllocationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffAllocationRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListStaffAllocationRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffAllocationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffAllocationRequest} message ListStaffAllocationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffAllocationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffAllocationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffAllocationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffAllocationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffAllocationRequest;
                })();
    
                v1.ListStaffAllocationResponse = (function() {
    
                    /**
                     * Properties of a ListStaffAllocationResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffAllocationResponse
                     * @property {Array.<palexy.streaming.v1.IParsedStaffAllocation>|null} [allocations] ListStaffAllocationResponse allocations
                     * @property {string|null} [nextPageToken] ListStaffAllocationResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffAllocationResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStaffAllocationResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffAllocationResponse.
                     * @implements IListStaffAllocationResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffAllocationResponse=} [properties] Properties to set
                     */
                    function ListStaffAllocationResponse(properties) {
                        this.allocations = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffAllocationResponse allocations.
                     * @member {Array.<palexy.streaming.v1.IParsedStaffAllocation>} allocations
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @instance
                     */
                    ListStaffAllocationResponse.prototype.allocations = $util.emptyArray;
    
                    /**
                     * ListStaffAllocationResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @instance
                     */
                    ListStaffAllocationResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffAllocationResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @instance
                     */
                    ListStaffAllocationResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListStaffAllocationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffAllocationResponse} ListStaffAllocationResponse instance
                     */
                    ListStaffAllocationResponse.create = function create(properties) {
                        return new ListStaffAllocationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffAllocationResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffAllocationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationResponse} message ListStaffAllocationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffAllocationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.allocations != null && message.allocations.length)
                            for (var i = 0; i < message.allocations.length; ++i)
                                $root.palexy.streaming.v1.ParsedStaffAllocation.encode(message.allocations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffAllocationResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffAllocationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffAllocationResponse} message ListStaffAllocationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffAllocationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffAllocationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffAllocationResponse} ListStaffAllocationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffAllocationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffAllocationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.allocations && message.allocations.length))
                                    message.allocations = [];
                                message.allocations.push($root.palexy.streaming.v1.ParsedStaffAllocation.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffAllocationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffAllocationResponse} ListStaffAllocationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffAllocationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffAllocationResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffAllocationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.allocations != null && message.hasOwnProperty("allocations")) {
                            if (!Array.isArray(message.allocations))
                                return "allocations: array expected";
                            for (var i = 0; i < message.allocations.length; ++i) {
                                var error = $root.palexy.streaming.v1.ParsedStaffAllocation.verify(message.allocations[i]);
                                if (error)
                                    return "allocations." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffAllocationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffAllocationResponse} ListStaffAllocationResponse
                     */
                    ListStaffAllocationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffAllocationResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffAllocationResponse();
                        if (object.allocations) {
                            if (!Array.isArray(object.allocations))
                                throw TypeError(".palexy.streaming.v1.ListStaffAllocationResponse.allocations: array expected");
                            message.allocations = [];
                            for (var i = 0; i < object.allocations.length; ++i) {
                                if (typeof object.allocations[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffAllocationResponse.allocations: object expected");
                                message.allocations[i] = $root.palexy.streaming.v1.ParsedStaffAllocation.fromObject(object.allocations[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffAllocationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffAllocationResponse} message ListStaffAllocationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffAllocationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.allocations = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.allocations && message.allocations.length) {
                            object.allocations = [];
                            for (var j = 0; j < message.allocations.length; ++j)
                                object.allocations[j] = $root.palexy.streaming.v1.ParsedStaffAllocation.toObject(message.allocations[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffAllocationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffAllocationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffAllocationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffAllocationResponse;
                })();
    
                v1.GetStaffImportConfigByCompanyIdRequest = (function() {
    
                    /**
                     * Properties of a GetStaffImportConfigByCompanyIdRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffImportConfigByCompanyIdRequest
                     * @property {number|null} [companyId] GetStaffImportConfigByCompanyIdRequest companyId
                     */
    
                    /**
                     * Constructs a new GetStaffImportConfigByCompanyIdRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffImportConfigByCompanyIdRequest.
                     * @implements IGetStaffImportConfigByCompanyIdRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest=} [properties] Properties to set
                     */
                    function GetStaffImportConfigByCompanyIdRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffImportConfigByCompanyIdRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @instance
                     */
                    GetStaffImportConfigByCompanyIdRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffImportConfigByCompanyIdRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest} GetStaffImportConfigByCompanyIdRequest instance
                     */
                    GetStaffImportConfigByCompanyIdRequest.create = function create(properties) {
                        return new GetStaffImportConfigByCompanyIdRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffImportConfigByCompanyIdRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest} message GetStaffImportConfigByCompanyIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffImportConfigByCompanyIdRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffImportConfigByCompanyIdRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigByCompanyIdRequest} message GetStaffImportConfigByCompanyIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffImportConfigByCompanyIdRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffImportConfigByCompanyIdRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest} GetStaffImportConfigByCompanyIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffImportConfigByCompanyIdRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffImportConfigByCompanyIdRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest} GetStaffImportConfigByCompanyIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffImportConfigByCompanyIdRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffImportConfigByCompanyIdRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffImportConfigByCompanyIdRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffImportConfigByCompanyIdRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest} GetStaffImportConfigByCompanyIdRequest
                     */
                    GetStaffImportConfigByCompanyIdRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffImportConfigByCompanyIdRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest} message GetStaffImportConfigByCompanyIdRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffImportConfigByCompanyIdRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffImportConfigByCompanyIdRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffImportConfigByCompanyIdRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffImportConfigByCompanyIdRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffImportConfigByCompanyIdRequest;
                })();
    
                v1.StaffImportConfig = (function() {
    
                    /**
                     * Properties of a StaffImportConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffImportConfig
                     * @property {number|null} [id] StaffImportConfig id
                     * @property {number|null} [companyId] StaffImportConfig companyId
                     * @property {string|null} [apiUsername] StaffImportConfig apiUsername
                     * @property {string|null} [apiPassword] StaffImportConfig apiPassword
                     * @property {string|null} [apiIntegrationKey] StaffImportConfig apiIntegrationKey
                     * @property {string|null} [apiBaseUrl] StaffImportConfig apiBaseUrl
                     * @property {number|null} [lastEditorAccountId] StaffImportConfig lastEditorAccountId
                     * @property {number|null} [createdTimeMs] StaffImportConfig createdTimeMs
                     * @property {number|null} [lastUpdatedTimeMs] StaffImportConfig lastUpdatedTimeMs
                     * @property {Array.<string>|null} [includedRoles] StaffImportConfig includedRoles
                     * @property {Array.<string>|null} [excludedRoles] StaffImportConfig excludedRoles
                     * @property {Array.<string>|null} [includedSecondRoles] StaffImportConfig includedSecondRoles
                     * @property {string|null} [companyName] StaffImportConfig companyName
                     * @property {palexy.streaming.v1.IAsyncJobStatusSummary|null} [manualJobStatusSummary] StaffImportConfig manualJobStatusSummary
                     * @property {palexy.streaming.v1.IAsyncJobStatusSummary|null} [autoJobStatusSummary] StaffImportConfig autoJobStatusSummary
                     */
    
                    /**
                     * Constructs a new StaffImportConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffImportConfig.
                     * @implements IStaffImportConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffImportConfig=} [properties] Properties to set
                     */
                    function StaffImportConfig(properties) {
                        this.includedRoles = [];
                        this.excludedRoles = [];
                        this.includedSecondRoles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffImportConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffImportConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffImportConfig apiUsername.
                     * @member {string} apiUsername
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.apiUsername = "";
    
                    /**
                     * StaffImportConfig apiPassword.
                     * @member {string} apiPassword
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.apiPassword = "";
    
                    /**
                     * StaffImportConfig apiIntegrationKey.
                     * @member {string} apiIntegrationKey
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.apiIntegrationKey = "";
    
                    /**
                     * StaffImportConfig apiBaseUrl.
                     * @member {string} apiBaseUrl
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.apiBaseUrl = "";
    
                    /**
                     * StaffImportConfig lastEditorAccountId.
                     * @member {number} lastEditorAccountId
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.lastEditorAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffImportConfig createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffImportConfig lastUpdatedTimeMs.
                     * @member {number} lastUpdatedTimeMs
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.lastUpdatedTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffImportConfig includedRoles.
                     * @member {Array.<string>} includedRoles
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.includedRoles = $util.emptyArray;
    
                    /**
                     * StaffImportConfig excludedRoles.
                     * @member {Array.<string>} excludedRoles
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.excludedRoles = $util.emptyArray;
    
                    /**
                     * StaffImportConfig includedSecondRoles.
                     * @member {Array.<string>} includedSecondRoles
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.includedSecondRoles = $util.emptyArray;
    
                    /**
                     * StaffImportConfig companyName.
                     * @member {string} companyName
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.companyName = "";
    
                    /**
                     * StaffImportConfig manualJobStatusSummary.
                     * @member {palexy.streaming.v1.IAsyncJobStatusSummary|null|undefined} manualJobStatusSummary
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.manualJobStatusSummary = null;
    
                    /**
                     * StaffImportConfig autoJobStatusSummary.
                     * @member {palexy.streaming.v1.IAsyncJobStatusSummary|null|undefined} autoJobStatusSummary
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     */
                    StaffImportConfig.prototype.autoJobStatusSummary = null;
    
                    /**
                     * Creates a new StaffImportConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaffImportConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffImportConfig} StaffImportConfig instance
                     */
                    StaffImportConfig.create = function create(properties) {
                        return new StaffImportConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StaffImportConfig message. Does not implicitly {@link palexy.streaming.v1.StaffImportConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaffImportConfig} message StaffImportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffImportConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.apiUsername != null && Object.hasOwnProperty.call(message, "apiUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.apiUsername);
                        if (message.apiPassword != null && Object.hasOwnProperty.call(message, "apiPassword"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.apiPassword);
                        if (message.apiIntegrationKey != null && Object.hasOwnProperty.call(message, "apiIntegrationKey"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.apiIntegrationKey);
                        if (message.apiBaseUrl != null && Object.hasOwnProperty.call(message, "apiBaseUrl"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.apiBaseUrl);
                        if (message.lastEditorAccountId != null && Object.hasOwnProperty.call(message, "lastEditorAccountId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastEditorAccountId);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createdTimeMs);
                        if (message.lastUpdatedTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdatedTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdatedTimeMs);
                        if (message.companyName != null && Object.hasOwnProperty.call(message, "companyName"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.companyName);
                        if (message.includedRoles != null && message.includedRoles.length)
                            for (var i = 0; i < message.includedRoles.length; ++i)
                                writer.uint32(/* id 12, wireType 2 =*/98).string(message.includedRoles[i]);
                        if (message.excludedRoles != null && message.excludedRoles.length)
                            for (var i = 0; i < message.excludedRoles.length; ++i)
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.excludedRoles[i]);
                        if (message.manualJobStatusSummary != null && Object.hasOwnProperty.call(message, "manualJobStatusSummary"))
                            $root.palexy.streaming.v1.AsyncJobStatusSummary.encode(message.manualJobStatusSummary, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.autoJobStatusSummary != null && Object.hasOwnProperty.call(message, "autoJobStatusSummary"))
                            $root.palexy.streaming.v1.AsyncJobStatusSummary.encode(message.autoJobStatusSummary, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.includedSecondRoles != null && message.includedSecondRoles.length)
                            for (var i = 0; i < message.includedSecondRoles.length; ++i)
                                writer.uint32(/* id 16, wireType 2 =*/130).string(message.includedSecondRoles[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffImportConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffImportConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {palexy.streaming.v1.IStaffImportConfig} message StaffImportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffImportConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffImportConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffImportConfig} StaffImportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffImportConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffImportConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.apiUsername = reader.string();
                                break;
                            case 4:
                                message.apiPassword = reader.string();
                                break;
                            case 5:
                                message.apiIntegrationKey = reader.string();
                                break;
                            case 6:
                                message.apiBaseUrl = reader.string();
                                break;
                            case 7:
                                message.lastEditorAccountId = reader.int64();
                                break;
                            case 8:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 9:
                                message.lastUpdatedTimeMs = reader.int64();
                                break;
                            case 12:
                                if (!(message.includedRoles && message.includedRoles.length))
                                    message.includedRoles = [];
                                message.includedRoles.push(reader.string());
                                break;
                            case 13:
                                if (!(message.excludedRoles && message.excludedRoles.length))
                                    message.excludedRoles = [];
                                message.excludedRoles.push(reader.string());
                                break;
                            case 16:
                                if (!(message.includedSecondRoles && message.includedSecondRoles.length))
                                    message.includedSecondRoles = [];
                                message.includedSecondRoles.push(reader.string());
                                break;
                            case 10:
                                message.companyName = reader.string();
                                break;
                            case 14:
                                message.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.autoJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffImportConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffImportConfig} StaffImportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffImportConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffImportConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffImportConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.apiUsername != null && message.hasOwnProperty("apiUsername"))
                            if (!$util.isString(message.apiUsername))
                                return "apiUsername: string expected";
                        if (message.apiPassword != null && message.hasOwnProperty("apiPassword"))
                            if (!$util.isString(message.apiPassword))
                                return "apiPassword: string expected";
                        if (message.apiIntegrationKey != null && message.hasOwnProperty("apiIntegrationKey"))
                            if (!$util.isString(message.apiIntegrationKey))
                                return "apiIntegrationKey: string expected";
                        if (message.apiBaseUrl != null && message.hasOwnProperty("apiBaseUrl"))
                            if (!$util.isString(message.apiBaseUrl))
                                return "apiBaseUrl: string expected";
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId"))
                            if (!$util.isInteger(message.lastEditorAccountId) && !(message.lastEditorAccountId && $util.isInteger(message.lastEditorAccountId.low) && $util.isInteger(message.lastEditorAccountId.high)))
                                return "lastEditorAccountId: integer|Long expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdatedTimeMs != null && message.hasOwnProperty("lastUpdatedTimeMs"))
                            if (!$util.isInteger(message.lastUpdatedTimeMs) && !(message.lastUpdatedTimeMs && $util.isInteger(message.lastUpdatedTimeMs.low) && $util.isInteger(message.lastUpdatedTimeMs.high)))
                                return "lastUpdatedTimeMs: integer|Long expected";
                        if (message.includedRoles != null && message.hasOwnProperty("includedRoles")) {
                            if (!Array.isArray(message.includedRoles))
                                return "includedRoles: array expected";
                            for (var i = 0; i < message.includedRoles.length; ++i)
                                if (!$util.isString(message.includedRoles[i]))
                                    return "includedRoles: string[] expected";
                        }
                        if (message.excludedRoles != null && message.hasOwnProperty("excludedRoles")) {
                            if (!Array.isArray(message.excludedRoles))
                                return "excludedRoles: array expected";
                            for (var i = 0; i < message.excludedRoles.length; ++i)
                                if (!$util.isString(message.excludedRoles[i]))
                                    return "excludedRoles: string[] expected";
                        }
                        if (message.includedSecondRoles != null && message.hasOwnProperty("includedSecondRoles")) {
                            if (!Array.isArray(message.includedSecondRoles))
                                return "includedSecondRoles: array expected";
                            for (var i = 0; i < message.includedSecondRoles.length; ++i)
                                if (!$util.isString(message.includedSecondRoles[i]))
                                    return "includedSecondRoles: string[] expected";
                        }
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            if (!$util.isString(message.companyName))
                                return "companyName: string expected";
                        if (message.manualJobStatusSummary != null && message.hasOwnProperty("manualJobStatusSummary")) {
                            var error = $root.palexy.streaming.v1.AsyncJobStatusSummary.verify(message.manualJobStatusSummary);
                            if (error)
                                return "manualJobStatusSummary." + error;
                        }
                        if (message.autoJobStatusSummary != null && message.hasOwnProperty("autoJobStatusSummary")) {
                            var error = $root.palexy.streaming.v1.AsyncJobStatusSummary.verify(message.autoJobStatusSummary);
                            if (error)
                                return "autoJobStatusSummary." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffImportConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffImportConfig} StaffImportConfig
                     */
                    StaffImportConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffImportConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffImportConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.apiUsername != null)
                            message.apiUsername = String(object.apiUsername);
                        if (object.apiPassword != null)
                            message.apiPassword = String(object.apiPassword);
                        if (object.apiIntegrationKey != null)
                            message.apiIntegrationKey = String(object.apiIntegrationKey);
                        if (object.apiBaseUrl != null)
                            message.apiBaseUrl = String(object.apiBaseUrl);
                        if (object.lastEditorAccountId != null)
                            if ($util.Long)
                                (message.lastEditorAccountId = $util.Long.fromValue(object.lastEditorAccountId)).unsigned = false;
                            else if (typeof object.lastEditorAccountId === "string")
                                message.lastEditorAccountId = parseInt(object.lastEditorAccountId, 10);
                            else if (typeof object.lastEditorAccountId === "number")
                                message.lastEditorAccountId = object.lastEditorAccountId;
                            else if (typeof object.lastEditorAccountId === "object")
                                message.lastEditorAccountId = new $util.LongBits(object.lastEditorAccountId.low >>> 0, object.lastEditorAccountId.high >>> 0).toNumber();
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdatedTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdatedTimeMs = $util.Long.fromValue(object.lastUpdatedTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdatedTimeMs === "string")
                                message.lastUpdatedTimeMs = parseInt(object.lastUpdatedTimeMs, 10);
                            else if (typeof object.lastUpdatedTimeMs === "number")
                                message.lastUpdatedTimeMs = object.lastUpdatedTimeMs;
                            else if (typeof object.lastUpdatedTimeMs === "object")
                                message.lastUpdatedTimeMs = new $util.LongBits(object.lastUpdatedTimeMs.low >>> 0, object.lastUpdatedTimeMs.high >>> 0).toNumber();
                        if (object.includedRoles) {
                            if (!Array.isArray(object.includedRoles))
                                throw TypeError(".palexy.streaming.v1.StaffImportConfig.includedRoles: array expected");
                            message.includedRoles = [];
                            for (var i = 0; i < object.includedRoles.length; ++i)
                                message.includedRoles[i] = String(object.includedRoles[i]);
                        }
                        if (object.excludedRoles) {
                            if (!Array.isArray(object.excludedRoles))
                                throw TypeError(".palexy.streaming.v1.StaffImportConfig.excludedRoles: array expected");
                            message.excludedRoles = [];
                            for (var i = 0; i < object.excludedRoles.length; ++i)
                                message.excludedRoles[i] = String(object.excludedRoles[i]);
                        }
                        if (object.includedSecondRoles) {
                            if (!Array.isArray(object.includedSecondRoles))
                                throw TypeError(".palexy.streaming.v1.StaffImportConfig.includedSecondRoles: array expected");
                            message.includedSecondRoles = [];
                            for (var i = 0; i < object.includedSecondRoles.length; ++i)
                                message.includedSecondRoles[i] = String(object.includedSecondRoles[i]);
                        }
                        if (object.companyName != null)
                            message.companyName = String(object.companyName);
                        if (object.manualJobStatusSummary != null) {
                            if (typeof object.manualJobStatusSummary !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffImportConfig.manualJobStatusSummary: object expected");
                            message.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.fromObject(object.manualJobStatusSummary);
                        }
                        if (object.autoJobStatusSummary != null) {
                            if (typeof object.autoJobStatusSummary !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffImportConfig.autoJobStatusSummary: object expected");
                            message.autoJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.fromObject(object.autoJobStatusSummary);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffImportConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @static
                     * @param {palexy.streaming.v1.StaffImportConfig} message StaffImportConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffImportConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.includedRoles = [];
                            object.excludedRoles = [];
                            object.includedSecondRoles = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.apiUsername = "";
                            object.apiPassword = "";
                            object.apiIntegrationKey = "";
                            object.apiBaseUrl = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastEditorAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastEditorAccountId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdatedTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdatedTimeMs = options.longs === String ? "0" : 0;
                            object.companyName = "";
                            object.manualJobStatusSummary = null;
                            object.autoJobStatusSummary = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.apiUsername != null && message.hasOwnProperty("apiUsername"))
                            object.apiUsername = message.apiUsername;
                        if (message.apiPassword != null && message.hasOwnProperty("apiPassword"))
                            object.apiPassword = message.apiPassword;
                        if (message.apiIntegrationKey != null && message.hasOwnProperty("apiIntegrationKey"))
                            object.apiIntegrationKey = message.apiIntegrationKey;
                        if (message.apiBaseUrl != null && message.hasOwnProperty("apiBaseUrl"))
                            object.apiBaseUrl = message.apiBaseUrl;
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId"))
                            if (typeof message.lastEditorAccountId === "number")
                                object.lastEditorAccountId = options.longs === String ? String(message.lastEditorAccountId) : message.lastEditorAccountId;
                            else
                                object.lastEditorAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.lastEditorAccountId) : options.longs === Number ? new $util.LongBits(message.lastEditorAccountId.low >>> 0, message.lastEditorAccountId.high >>> 0).toNumber() : message.lastEditorAccountId;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdatedTimeMs != null && message.hasOwnProperty("lastUpdatedTimeMs"))
                            if (typeof message.lastUpdatedTimeMs === "number")
                                object.lastUpdatedTimeMs = options.longs === String ? String(message.lastUpdatedTimeMs) : message.lastUpdatedTimeMs;
                            else
                                object.lastUpdatedTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdatedTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdatedTimeMs.low >>> 0, message.lastUpdatedTimeMs.high >>> 0).toNumber() : message.lastUpdatedTimeMs;
                        if (message.companyName != null && message.hasOwnProperty("companyName"))
                            object.companyName = message.companyName;
                        if (message.includedRoles && message.includedRoles.length) {
                            object.includedRoles = [];
                            for (var j = 0; j < message.includedRoles.length; ++j)
                                object.includedRoles[j] = message.includedRoles[j];
                        }
                        if (message.excludedRoles && message.excludedRoles.length) {
                            object.excludedRoles = [];
                            for (var j = 0; j < message.excludedRoles.length; ++j)
                                object.excludedRoles[j] = message.excludedRoles[j];
                        }
                        if (message.manualJobStatusSummary != null && message.hasOwnProperty("manualJobStatusSummary"))
                            object.manualJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.toObject(message.manualJobStatusSummary, options);
                        if (message.autoJobStatusSummary != null && message.hasOwnProperty("autoJobStatusSummary"))
                            object.autoJobStatusSummary = $root.palexy.streaming.v1.AsyncJobStatusSummary.toObject(message.autoJobStatusSummary, options);
                        if (message.includedSecondRoles && message.includedSecondRoles.length) {
                            object.includedSecondRoles = [];
                            for (var j = 0; j < message.includedSecondRoles.length; ++j)
                                object.includedSecondRoles[j] = message.includedSecondRoles[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffImportConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffImportConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffImportConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffImportConfig;
                })();
    
                v1.CreateStaffImportConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffImportConfigRequest
                     * @property {palexy.streaming.v1.IStaffImportConfig|null} [config] CreateStaffImportConfigRequest config
                     */
    
                    /**
                     * Constructs a new CreateStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffImportConfigRequest.
                     * @implements ICreateStaffImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest=} [properties] Properties to set
                     */
                    function CreateStaffImportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffImportConfigRequest config.
                     * @member {palexy.streaming.v1.IStaffImportConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @instance
                     */
                    CreateStaffImportConfigRequest.prototype.config = null;
    
                    /**
                     * Creates a new CreateStaffImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffImportConfigRequest} CreateStaffImportConfigRequest instance
                     */
                    CreateStaffImportConfigRequest.create = function create(properties) {
                        return new CreateStaffImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest} message CreateStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.StaffImportConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffImportConfigRequest} message CreateStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffImportConfigRequest} CreateStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.streaming.v1.StaffImportConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffImportConfigRequest} CreateStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.StaffImportConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffImportConfigRequest} CreateStaffImportConfigRequest
                     */
                    CreateStaffImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffImportConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStaffImportConfigRequest.config: object expected");
                            message.config = $root.palexy.streaming.v1.StaffImportConfig.fromObject(object.config);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffImportConfigRequest} message CreateStaffImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.config = null;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.StaffImportConfig.toObject(message.config, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffImportConfigRequest;
                })();
    
                v1.UpdateStaffImportConfigRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffImportConfigRequest
                     * @property {palexy.streaming.v1.IStaffImportConfig|null} [config] UpdateStaffImportConfigRequest config
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStaffImportConfigRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffImportConfigRequest.
                     * @implements IUpdateStaffImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest=} [properties] Properties to set
                     */
                    function UpdateStaffImportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffImportConfigRequest config.
                     * @member {palexy.streaming.v1.IStaffImportConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @instance
                     */
                    UpdateStaffImportConfigRequest.prototype.config = null;
    
                    /**
                     * UpdateStaffImportConfigRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @instance
                     */
                    UpdateStaffImportConfigRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStaffImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffImportConfigRequest} UpdateStaffImportConfigRequest instance
                     */
                    UpdateStaffImportConfigRequest.create = function create(properties) {
                        return new UpdateStaffImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest} message UpdateStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.StaffImportConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffImportConfigRequest} message UpdateStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffImportConfigRequest} UpdateStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.streaming.v1.StaffImportConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffImportConfigRequest} UpdateStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.StaffImportConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffImportConfigRequest} UpdateStaffImportConfigRequest
                     */
                    UpdateStaffImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffImportConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffImportConfigRequest.config: object expected");
                            message.config = $root.palexy.streaming.v1.StaffImportConfig.fromObject(object.config);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffImportConfigRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffImportConfigRequest} message UpdateStaffImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.config = null;
                            object.updateMask = null;
                        }
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.StaffImportConfig.toObject(message.config, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffImportConfigRequest;
                })();
    
                v1.DeleteStaffImportConfigRequest = (function() {
    
                    /**
                     * Properties of a DeleteStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStaffImportConfigRequest
                     * @property {number|null} [configId] DeleteStaffImportConfigRequest configId
                     */
    
                    /**
                     * Constructs a new DeleteStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStaffImportConfigRequest.
                     * @implements IDeleteStaffImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest=} [properties] Properties to set
                     */
                    function DeleteStaffImportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStaffImportConfigRequest configId.
                     * @member {number} configId
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @instance
                     */
                    DeleteStaffImportConfigRequest.prototype.configId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStaffImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStaffImportConfigRequest} DeleteStaffImportConfigRequest instance
                     */
                    DeleteStaffImportConfigRequest.create = function create(properties) {
                        return new DeleteStaffImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStaffImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStaffImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest} message DeleteStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configId != null && Object.hasOwnProperty.call(message, "configId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.configId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStaffImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStaffImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffImportConfigRequest} message DeleteStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStaffImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStaffImportConfigRequest} DeleteStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStaffImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStaffImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStaffImportConfigRequest} DeleteStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStaffImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStaffImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (!$util.isInteger(message.configId) && !(message.configId && $util.isInteger(message.configId.low) && $util.isInteger(message.configId.high)))
                                return "configId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStaffImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStaffImportConfigRequest} DeleteStaffImportConfigRequest
                     */
                    DeleteStaffImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStaffImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStaffImportConfigRequest();
                        if (object.configId != null)
                            if ($util.Long)
                                (message.configId = $util.Long.fromValue(object.configId)).unsigned = false;
                            else if (typeof object.configId === "string")
                                message.configId = parseInt(object.configId, 10);
                            else if (typeof object.configId === "number")
                                message.configId = object.configId;
                            else if (typeof object.configId === "object")
                                message.configId = new $util.LongBits(object.configId.low >>> 0, object.configId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStaffImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStaffImportConfigRequest} message DeleteStaffImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStaffImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.configId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.configId = options.longs === String ? "0" : 0;
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (typeof message.configId === "number")
                                object.configId = options.longs === String ? String(message.configId) : message.configId;
                            else
                                object.configId = options.longs === String ? $util.Long.prototype.toString.call(message.configId) : options.longs === Number ? new $util.LongBits(message.configId.low >>> 0, message.configId.high >>> 0).toNumber() : message.configId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStaffImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStaffImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStaffImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStaffImportConfigRequest;
                })();
    
                v1.ListStaffImportConfigRequest = (function() {
    
                    /**
                     * Properties of a ListStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffImportConfigRequest
                     * @property {number|null} [pageSize] ListStaffImportConfigRequest pageSize
                     * @property {string|null} [pageToken] ListStaffImportConfigRequest pageToken
                     * @property {Array.<number>|null} [companyIds] ListStaffImportConfigRequest companyIds
                     * @property {boolean|null} [includeCompanyInfo] ListStaffImportConfigRequest includeCompanyInfo
                     * @property {boolean|null} [fetchJobStatus] ListStaffImportConfigRequest fetchJobStatus
                     */
    
                    /**
                     * Constructs a new ListStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffImportConfigRequest.
                     * @implements IListStaffImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest=} [properties] Properties to set
                     */
                    function ListStaffImportConfigRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffImportConfigRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     */
                    ListStaffImportConfigRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffImportConfigRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     */
                    ListStaffImportConfigRequest.prototype.pageToken = "";
    
                    /**
                     * ListStaffImportConfigRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     */
                    ListStaffImportConfigRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * ListStaffImportConfigRequest includeCompanyInfo.
                     * @member {boolean} includeCompanyInfo
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     */
                    ListStaffImportConfigRequest.prototype.includeCompanyInfo = false;
    
                    /**
                     * ListStaffImportConfigRequest fetchJobStatus.
                     * @member {boolean} fetchJobStatus
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     */
                    ListStaffImportConfigRequest.prototype.fetchJobStatus = false;
    
                    /**
                     * Creates a new ListStaffImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffImportConfigRequest} ListStaffImportConfigRequest instance
                     */
                    ListStaffImportConfigRequest.create = function create(properties) {
                        return new ListStaffImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest} message ListStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        if (message.includeCompanyInfo != null && Object.hasOwnProperty.call(message, "includeCompanyInfo"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeCompanyInfo);
                        if (message.fetchJobStatus != null && Object.hasOwnProperty.call(message, "fetchJobStatus"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.fetchJobStatus);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigRequest} message ListStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffImportConfigRequest} ListStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            case 4:
                                message.includeCompanyInfo = reader.bool();
                                break;
                            case 5:
                                message.fetchJobStatus = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffImportConfigRequest} ListStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            if (typeof message.includeCompanyInfo !== "boolean")
                                return "includeCompanyInfo: boolean expected";
                        if (message.fetchJobStatus != null && message.hasOwnProperty("fetchJobStatus"))
                            if (typeof message.fetchJobStatus !== "boolean")
                                return "fetchJobStatus: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffImportConfigRequest} ListStaffImportConfigRequest
                     */
                    ListStaffImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffImportConfigRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.ListStaffImportConfigRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        if (object.includeCompanyInfo != null)
                            message.includeCompanyInfo = Boolean(object.includeCompanyInfo);
                        if (object.fetchJobStatus != null)
                            message.fetchJobStatus = Boolean(object.fetchJobStatus);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffImportConfigRequest} message ListStaffImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeCompanyInfo = false;
                            object.fetchJobStatus = false;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        if (message.includeCompanyInfo != null && message.hasOwnProperty("includeCompanyInfo"))
                            object.includeCompanyInfo = message.includeCompanyInfo;
                        if (message.fetchJobStatus != null && message.hasOwnProperty("fetchJobStatus"))
                            object.fetchJobStatus = message.fetchJobStatus;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffImportConfigRequest;
                })();
    
                v1.ListStaffImportConfigResponse = (function() {
    
                    /**
                     * Properties of a ListStaffImportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffImportConfigResponse
                     * @property {string|null} [nextPageToken] ListStaffImportConfigResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffImportConfigResponse totalElements
                     * @property {Array.<palexy.streaming.v1.IStaffImportConfig>|null} [staffImportConfigs] ListStaffImportConfigResponse staffImportConfigs
                     */
    
                    /**
                     * Constructs a new ListStaffImportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffImportConfigResponse.
                     * @implements IListStaffImportConfigResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffImportConfigResponse=} [properties] Properties to set
                     */
                    function ListStaffImportConfigResponse(properties) {
                        this.staffImportConfigs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffImportConfigResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @instance
                     */
                    ListStaffImportConfigResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffImportConfigResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @instance
                     */
                    ListStaffImportConfigResponse.prototype.totalElements = 0;
    
                    /**
                     * ListStaffImportConfigResponse staffImportConfigs.
                     * @member {Array.<palexy.streaming.v1.IStaffImportConfig>} staffImportConfigs
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @instance
                     */
                    ListStaffImportConfigResponse.prototype.staffImportConfigs = $util.emptyArray;
    
                    /**
                     * Creates a new ListStaffImportConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffImportConfigResponse} ListStaffImportConfigResponse instance
                     */
                    ListStaffImportConfigResponse.create = function create(properties) {
                        return new ListStaffImportConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffImportConfigResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffImportConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigResponse} message ListStaffImportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffImportConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.staffImportConfigs != null && message.staffImportConfigs.length)
                            for (var i = 0; i < message.staffImportConfigs.length; ++i)
                                $root.palexy.streaming.v1.StaffImportConfig.encode(message.staffImportConfigs[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffImportConfigResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffImportConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffImportConfigResponse} message ListStaffImportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffImportConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffImportConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffImportConfigResponse} ListStaffImportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffImportConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffImportConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.nextPageToken = reader.string();
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                if (!(message.staffImportConfigs && message.staffImportConfigs.length))
                                    message.staffImportConfigs = [];
                                message.staffImportConfigs.push($root.palexy.streaming.v1.StaffImportConfig.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffImportConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffImportConfigResponse} ListStaffImportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffImportConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffImportConfigResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffImportConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.staffImportConfigs != null && message.hasOwnProperty("staffImportConfigs")) {
                            if (!Array.isArray(message.staffImportConfigs))
                                return "staffImportConfigs: array expected";
                            for (var i = 0; i < message.staffImportConfigs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffImportConfig.verify(message.staffImportConfigs[i]);
                                if (error)
                                    return "staffImportConfigs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffImportConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffImportConfigResponse} ListStaffImportConfigResponse
                     */
                    ListStaffImportConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffImportConfigResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffImportConfigResponse();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.staffImportConfigs) {
                            if (!Array.isArray(object.staffImportConfigs))
                                throw TypeError(".palexy.streaming.v1.ListStaffImportConfigResponse.staffImportConfigs: array expected");
                            message.staffImportConfigs = [];
                            for (var i = 0; i < object.staffImportConfigs.length; ++i) {
                                if (typeof object.staffImportConfigs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffImportConfigResponse.staffImportConfigs: object expected");
                                message.staffImportConfigs[i] = $root.palexy.streaming.v1.StaffImportConfig.fromObject(object.staffImportConfigs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffImportConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffImportConfigResponse} message ListStaffImportConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffImportConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffImportConfigs = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.staffImportConfigs && message.staffImportConfigs.length) {
                            object.staffImportConfigs = [];
                            for (var j = 0; j < message.staffImportConfigs.length; ++j)
                                object.staffImportConfigs[j] = $root.palexy.streaming.v1.StaffImportConfig.toObject(message.staffImportConfigs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffImportConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffImportConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffImportConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffImportConfigResponse;
                })();
    
                v1.ImportStaffDataRequest = (function() {
    
                    /**
                     * Properties of an ImportStaffDataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IImportStaffDataRequest
                     * @property {Array.<palexy.streaming.v1.IParsedStaffAllocation>|null} [allocations] ImportStaffDataRequest allocations
                     * @property {number|null} [companyId] ImportStaffDataRequest companyId
                     * @property {string|null} [dateId] ImportStaffDataRequest dateId
                     */
    
                    /**
                     * Constructs a new ImportStaffDataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImportStaffDataRequest.
                     * @implements IImportStaffDataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IImportStaffDataRequest=} [properties] Properties to set
                     */
                    function ImportStaffDataRequest(properties) {
                        this.allocations = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportStaffDataRequest allocations.
                     * @member {Array.<palexy.streaming.v1.IParsedStaffAllocation>} allocations
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @instance
                     */
                    ImportStaffDataRequest.prototype.allocations = $util.emptyArray;
    
                    /**
                     * ImportStaffDataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @instance
                     */
                    ImportStaffDataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportStaffDataRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @instance
                     */
                    ImportStaffDataRequest.prototype.dateId = "";
    
                    /**
                     * Creates a new ImportStaffDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStaffDataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImportStaffDataRequest} ImportStaffDataRequest instance
                     */
                    ImportStaffDataRequest.create = function create(properties) {
                        return new ImportStaffDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportStaffDataRequest message. Does not implicitly {@link palexy.streaming.v1.ImportStaffDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStaffDataRequest} message ImportStaffDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStaffDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.allocations != null && message.allocations.length)
                            for (var i = 0; i < message.allocations.length; ++i)
                                $root.palexy.streaming.v1.ParsedStaffAllocation.encode(message.allocations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportStaffDataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImportStaffDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IImportStaffDataRequest} message ImportStaffDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportStaffDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportStaffDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImportStaffDataRequest} ImportStaffDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStaffDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImportStaffDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.allocations && message.allocations.length))
                                    message.allocations = [];
                                message.allocations.push($root.palexy.streaming.v1.ParsedStaffAllocation.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportStaffDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImportStaffDataRequest} ImportStaffDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportStaffDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportStaffDataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportStaffDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.allocations != null && message.hasOwnProperty("allocations")) {
                            if (!Array.isArray(message.allocations))
                                return "allocations: array expected";
                            for (var i = 0; i < message.allocations.length; ++i) {
                                var error = $root.palexy.streaming.v1.ParsedStaffAllocation.verify(message.allocations[i]);
                                if (error)
                                    return "allocations." + error;
                            }
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ImportStaffDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImportStaffDataRequest} ImportStaffDataRequest
                     */
                    ImportStaffDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImportStaffDataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImportStaffDataRequest();
                        if (object.allocations) {
                            if (!Array.isArray(object.allocations))
                                throw TypeError(".palexy.streaming.v1.ImportStaffDataRequest.allocations: array expected");
                            message.allocations = [];
                            for (var i = 0; i < object.allocations.length; ++i) {
                                if (typeof object.allocations[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ImportStaffDataRequest.allocations: object expected");
                                message.allocations[i] = $root.palexy.streaming.v1.ParsedStaffAllocation.fromObject(object.allocations[i]);
                            }
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportStaffDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ImportStaffDataRequest} message ImportStaffDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportStaffDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.allocations = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                        }
                        if (message.allocations && message.allocations.length) {
                            object.allocations = [];
                            for (var j = 0; j < message.allocations.length; ++j)
                                object.allocations[j] = $root.palexy.streaming.v1.ParsedStaffAllocation.toObject(message.allocations[j], options);
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this ImportStaffDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImportStaffDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportStaffDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportStaffDataRequest;
                })();
    
                v1.GetStaffImportConfigRequest = (function() {
    
                    /**
                     * Properties of a GetStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffImportConfigRequest
                     * @property {number|null} [configId] GetStaffImportConfigRequest configId
                     */
    
                    /**
                     * Constructs a new GetStaffImportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffImportConfigRequest.
                     * @implements IGetStaffImportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest=} [properties] Properties to set
                     */
                    function GetStaffImportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffImportConfigRequest configId.
                     * @member {number} configId
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @instance
                     */
                    GetStaffImportConfigRequest.prototype.configId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffImportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffImportConfigRequest} GetStaffImportConfigRequest instance
                     */
                    GetStaffImportConfigRequest.create = function create(properties) {
                        return new GetStaffImportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffImportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffImportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest} message GetStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffImportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configId != null && Object.hasOwnProperty.call(message, "configId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.configId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffImportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffImportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffImportConfigRequest} message GetStaffImportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffImportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffImportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffImportConfigRequest} GetStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffImportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffImportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffImportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffImportConfigRequest} GetStaffImportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffImportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffImportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffImportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (!$util.isInteger(message.configId) && !(message.configId && $util.isInteger(message.configId.low) && $util.isInteger(message.configId.high)))
                                return "configId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffImportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffImportConfigRequest} GetStaffImportConfigRequest
                     */
                    GetStaffImportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffImportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffImportConfigRequest();
                        if (object.configId != null)
                            if ($util.Long)
                                (message.configId = $util.Long.fromValue(object.configId)).unsigned = false;
                            else if (typeof object.configId === "string")
                                message.configId = parseInt(object.configId, 10);
                            else if (typeof object.configId === "number")
                                message.configId = object.configId;
                            else if (typeof object.configId === "object")
                                message.configId = new $util.LongBits(object.configId.low >>> 0, object.configId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffImportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffImportConfigRequest} message GetStaffImportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffImportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.configId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.configId = options.longs === String ? "0" : 0;
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (typeof message.configId === "number")
                                object.configId = options.longs === String ? String(message.configId) : message.configId;
                            else
                                object.configId = options.longs === String ? $util.Long.prototype.toString.call(message.configId) : options.longs === Number ? new $util.LongBits(message.configId.low >>> 0, message.configId.high >>> 0).toNumber() : message.configId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffImportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffImportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffImportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffImportConfigRequest;
                })();
    
                v1.ParsedStaffAllocation = (function() {
    
                    /**
                     * Properties of a ParsedStaffAllocation.
                     * @memberof palexy.streaming.v1
                     * @interface IParsedStaffAllocation
                     * @property {number|null} [dateId] ParsedStaffAllocation dateId
                     * @property {string|null} [startTime] ParsedStaffAllocation startTime
                     * @property {string|null} [endTime] ParsedStaffAllocation endTime
                     * @property {string|null} [staffId] ParsedStaffAllocation staffId
                     * @property {string|null} [staffName] ParsedStaffAllocation staffName
                     * @property {string|null} [staffRole] ParsedStaffAllocation staffRole
                     * @property {string|null} [description] ParsedStaffAllocation description
                     * @property {string|null} [storeCode] ParsedStaffAllocation storeCode
                     * @property {number|null} [storeId] ParsedStaffAllocation storeId
                     * @property {string|null} [staffSecondRole] ParsedStaffAllocation staffSecondRole
                     * @property {number|null} [scheduleAreaId] ParsedStaffAllocation scheduleAreaId
                     */
    
                    /**
                     * Constructs a new ParsedStaffAllocation.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ParsedStaffAllocation.
                     * @implements IParsedStaffAllocation
                     * @constructor
                     * @param {palexy.streaming.v1.IParsedStaffAllocation=} [properties] Properties to set
                     */
                    function ParsedStaffAllocation(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ParsedStaffAllocation dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.dateId = 0;
    
                    /**
                     * ParsedStaffAllocation startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.startTime = "";
    
                    /**
                     * ParsedStaffAllocation endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.endTime = "";
    
                    /**
                     * ParsedStaffAllocation staffId.
                     * @member {string} staffId
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.staffId = "";
    
                    /**
                     * ParsedStaffAllocation staffName.
                     * @member {string} staffName
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.staffName = "";
    
                    /**
                     * ParsedStaffAllocation staffRole.
                     * @member {string} staffRole
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.staffRole = "";
    
                    /**
                     * ParsedStaffAllocation description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.description = "";
    
                    /**
                     * ParsedStaffAllocation storeCode.
                     * @member {string} storeCode
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.storeCode = "";
    
                    /**
                     * ParsedStaffAllocation storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ParsedStaffAllocation staffSecondRole.
                     * @member {string} staffSecondRole
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.staffSecondRole = "";
    
                    /**
                     * ParsedStaffAllocation scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     */
                    ParsedStaffAllocation.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ParsedStaffAllocation instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {palexy.streaming.v1.IParsedStaffAllocation=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ParsedStaffAllocation} ParsedStaffAllocation instance
                     */
                    ParsedStaffAllocation.create = function create(properties) {
                        return new ParsedStaffAllocation(properties);
                    };
    
                    /**
                     * Encodes the specified ParsedStaffAllocation message. Does not implicitly {@link palexy.streaming.v1.ParsedStaffAllocation.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {palexy.streaming.v1.IParsedStaffAllocation} message ParsedStaffAllocation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParsedStaffAllocation.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endTime);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.staffId);
                        if (message.staffName != null && Object.hasOwnProperty.call(message, "staffName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.staffName);
                        if (message.staffRole != null && Object.hasOwnProperty.call(message, "staffRole"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.staffRole);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.description);
                        if (message.storeCode != null && Object.hasOwnProperty.call(message, "storeCode"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.storeCode);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.storeId);
                        if (message.staffSecondRole != null && Object.hasOwnProperty.call(message, "staffSecondRole"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.staffSecondRole);
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.scheduleAreaId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ParsedStaffAllocation message, length delimited. Does not implicitly {@link palexy.streaming.v1.ParsedStaffAllocation.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {palexy.streaming.v1.IParsedStaffAllocation} message ParsedStaffAllocation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ParsedStaffAllocation.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ParsedStaffAllocation message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ParsedStaffAllocation} ParsedStaffAllocation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParsedStaffAllocation.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ParsedStaffAllocation();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.int32();
                                break;
                            case 2:
                                message.startTime = reader.string();
                                break;
                            case 3:
                                message.endTime = reader.string();
                                break;
                            case 4:
                                message.staffId = reader.string();
                                break;
                            case 5:
                                message.staffName = reader.string();
                                break;
                            case 6:
                                message.staffRole = reader.string();
                                break;
                            case 7:
                                message.description = reader.string();
                                break;
                            case 8:
                                message.storeCode = reader.string();
                                break;
                            case 9:
                                message.storeId = reader.int64();
                                break;
                            case 10:
                                message.staffSecondRole = reader.string();
                                break;
                            case 11:
                                message.scheduleAreaId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ParsedStaffAllocation message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ParsedStaffAllocation} ParsedStaffAllocation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ParsedStaffAllocation.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ParsedStaffAllocation message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ParsedStaffAllocation.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isString(message.staffId))
                                return "staffId: string expected";
                        if (message.staffName != null && message.hasOwnProperty("staffName"))
                            if (!$util.isString(message.staffName))
                                return "staffName: string expected";
                        if (message.staffRole != null && message.hasOwnProperty("staffRole"))
                            if (!$util.isString(message.staffRole))
                                return "staffRole: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                            if (!$util.isString(message.storeCode))
                                return "storeCode: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffSecondRole != null && message.hasOwnProperty("staffSecondRole"))
                            if (!$util.isString(message.staffSecondRole))
                                return "staffSecondRole: string expected";
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ParsedStaffAllocation message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ParsedStaffAllocation} ParsedStaffAllocation
                     */
                    ParsedStaffAllocation.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ParsedStaffAllocation)
                            return object;
                        var message = new $root.palexy.streaming.v1.ParsedStaffAllocation();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.staffId != null)
                            message.staffId = String(object.staffId);
                        if (object.staffName != null)
                            message.staffName = String(object.staffName);
                        if (object.staffRole != null)
                            message.staffRole = String(object.staffRole);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.storeCode != null)
                            message.storeCode = String(object.storeCode);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffSecondRole != null)
                            message.staffSecondRole = String(object.staffSecondRole);
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ParsedStaffAllocation message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @static
                     * @param {palexy.streaming.v1.ParsedStaffAllocation} message ParsedStaffAllocation
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ParsedStaffAllocation.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dateId = 0;
                            object.startTime = "";
                            object.endTime = "";
                            object.staffId = "";
                            object.staffName = "";
                            object.staffRole = "";
                            object.description = "";
                            object.storeCode = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.staffSecondRole = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            object.staffId = message.staffId;
                        if (message.staffName != null && message.hasOwnProperty("staffName"))
                            object.staffName = message.staffName;
                        if (message.staffRole != null && message.hasOwnProperty("staffRole"))
                            object.staffRole = message.staffRole;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.storeCode != null && message.hasOwnProperty("storeCode"))
                            object.storeCode = message.storeCode;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffSecondRole != null && message.hasOwnProperty("staffSecondRole"))
                            object.staffSecondRole = message.staffSecondRole;
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        return object;
                    };
    
                    /**
                     * Converts this ParsedStaffAllocation to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ParsedStaffAllocation
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ParsedStaffAllocation.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ParsedStaffAllocation;
                })();
    
                v1.RawICAConsistencyService = (function() {
    
                    /**
                     * Constructs a new RawICAConsistencyService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICAConsistencyService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function RawICAConsistencyService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (RawICAConsistencyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = RawICAConsistencyService;
    
                    /**
                     * Creates new RawICAConsistencyService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {RawICAConsistencyService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    RawICAConsistencyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#createOrUpdateRawICAConsistency}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef CreateOrUpdateRawICAConsistencyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} [response] CreateOrUpdateRawICAConsistencyResponse
                     */
    
                    /**
                     * Calls CreateOrUpdateRawICAConsistency.
                     * @function createOrUpdateRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest} request CreateOrUpdateRawICAConsistencyRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.CreateOrUpdateRawICAConsistencyCallback} callback Node-style callback called with the error, if any, and CreateOrUpdateRawICAConsistencyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.createOrUpdateRawICAConsistency = function createOrUpdateRawICAConsistency(request, callback) {
                        return this.rpcCall(createOrUpdateRawICAConsistency, $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest, $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse, request, callback);
                    }, "name", { value: "CreateOrUpdateRawICAConsistency" });
    
                    /**
                     * Calls CreateOrUpdateRawICAConsistency.
                     * @function createOrUpdateRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest} request CreateOrUpdateRawICAConsistencyRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#listRawICAConsistency}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef ListRawICAConsistencyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListRawICAConsistencyResponse} [response] ListRawICAConsistencyResponse
                     */
    
                    /**
                     * Calls ListRawICAConsistency.
                     * @function listRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest} request ListRawICAConsistencyRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.ListRawICAConsistencyCallback} callback Node-style callback called with the error, if any, and ListRawICAConsistencyResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.listRawICAConsistency = function listRawICAConsistency(request, callback) {
                        return this.rpcCall(listRawICAConsistency, $root.palexy.streaming.v1.ListRawICAConsistencyRequest, $root.palexy.streaming.v1.ListRawICAConsistencyResponse, request, callback);
                    }, "name", { value: "ListRawICAConsistency" });
    
                    /**
                     * Calls ListRawICAConsistency.
                     * @function listRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest} request ListRawICAConsistencyRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListRawICAConsistencyResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#getRawICAConsistency}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef GetRawICAConsistencyCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RawICAConsistency} [response] RawICAConsistency
                     */
    
                    /**
                     * Calls GetRawICAConsistency.
                     * @function getRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest} request GetRawICAConsistencyRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.GetRawICAConsistencyCallback} callback Node-style callback called with the error, if any, and RawICAConsistency
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.getRawICAConsistency = function getRawICAConsistency(request, callback) {
                        return this.rpcCall(getRawICAConsistency, $root.palexy.streaming.v1.GetRawICAConsistencyRequest, $root.palexy.streaming.v1.RawICAConsistency, request, callback);
                    }, "name", { value: "GetRawICAConsistency" });
    
                    /**
                     * Calls GetRawICAConsistency.
                     * @function getRawICAConsistency
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest} request GetRawICAConsistencyRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RawICAConsistency>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#updateRawICAConsistencyState}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef UpdateRawICAConsistencyStateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RawICAConsistency} [response] RawICAConsistency
                     */
    
                    /**
                     * Calls UpdateRawICAConsistencyState.
                     * @function updateRawICAConsistencyState
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest} request UpdateRawICAConsistencyStateRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.UpdateRawICAConsistencyStateCallback} callback Node-style callback called with the error, if any, and RawICAConsistency
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.updateRawICAConsistencyState = function updateRawICAConsistencyState(request, callback) {
                        return this.rpcCall(updateRawICAConsistencyState, $root.palexy.streaming.v1.UpdateRawICAConsistencyStateRequest, $root.palexy.streaming.v1.RawICAConsistency, request, callback);
                    }, "name", { value: "UpdateRawICAConsistencyState" });
    
                    /**
                     * Calls UpdateRawICAConsistencyState.
                     * @function updateRawICAConsistencyState
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest} request UpdateRawICAConsistencyStateRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RawICAConsistency>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#getRecommendedSimulatingSource}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef GetRecommendedSimulatingSourceCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} [response] GetRecommendedSimulatingSourceResponse
                     */
    
                    /**
                     * Calls GetRecommendedSimulatingSource.
                     * @function getRecommendedSimulatingSource
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest} request GetRecommendedSimulatingSourceRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.GetRecommendedSimulatingSourceCallback} callback Node-style callback called with the error, if any, and GetRecommendedSimulatingSourceResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.getRecommendedSimulatingSource = function getRecommendedSimulatingSource(request, callback) {
                        return this.rpcCall(getRecommendedSimulatingSource, $root.palexy.streaming.v1.GetRecommendedSimulatingSourceRequest, $root.palexy.streaming.v1.GetRecommendedSimulatingSourceResponse, request, callback);
                    }, "name", { value: "GetRecommendedSimulatingSource" });
    
                    /**
                     * Calls GetRecommendedSimulatingSource.
                     * @function getRecommendedSimulatingSource
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest} request GetRecommendedSimulatingSourceRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetRecommendedSimulatingSourceResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#simulateRawICAData}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef SimulateRawICADataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SimulateRawICADataResponse} [response] SimulateRawICADataResponse
                     */
    
                    /**
                     * Calls SimulateRawICAData.
                     * @function simulateRawICAData
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest} request SimulateRawICADataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.SimulateRawICADataCallback} callback Node-style callback called with the error, if any, and SimulateRawICADataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.simulateRawICAData = function simulateRawICAData(request, callback) {
                        return this.rpcCall(simulateRawICAData, $root.palexy.streaming.v1.SimulateRawICADataRequest, $root.palexy.streaming.v1.SimulateRawICADataResponse, request, callback);
                    }, "name", { value: "SimulateRawICAData" });
    
                    /**
                     * Calls SimulateRawICAData.
                     * @function simulateRawICAData
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest} request SimulateRawICADataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SimulateRawICADataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.RawICAConsistencyService#revertSimulatedRawICAData}.
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @typedef RevertSimulatedRawICADataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RevertSimulatedRawICADataResponse} [response] RevertSimulatedRawICADataResponse
                     */
    
                    /**
                     * Calls RevertSimulatedRawICAData.
                     * @function revertSimulatedRawICAData
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest} request RevertSimulatedRawICADataRequest message or plain object
                     * @param {palexy.streaming.v1.RawICAConsistencyService.RevertSimulatedRawICADataCallback} callback Node-style callback called with the error, if any, and RevertSimulatedRawICADataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(RawICAConsistencyService.prototype.revertSimulatedRawICAData = function revertSimulatedRawICAData(request, callback) {
                        return this.rpcCall(revertSimulatedRawICAData, $root.palexy.streaming.v1.RevertSimulatedRawICADataRequest, $root.palexy.streaming.v1.RevertSimulatedRawICADataResponse, request, callback);
                    }, "name", { value: "RevertSimulatedRawICAData" });
    
                    /**
                     * Calls RevertSimulatedRawICAData.
                     * @function revertSimulatedRawICAData
                     * @memberof palexy.streaming.v1.RawICAConsistencyService
                     * @instance
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest} request RevertSimulatedRawICADataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RevertSimulatedRawICADataResponse>} Promise
                     * @variation 2
                     */
    
                    return RawICAConsistencyService;
                })();
    
                v1.CreateOrUpdateRawICAConsistencyRequest = (function() {
    
                    /**
                     * Properties of a CreateOrUpdateRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateOrUpdateRawICAConsistencyRequest
                     * @property {number|null} [storeId] CreateOrUpdateRawICAConsistencyRequest storeId
                     * @property {number|null} [dateId] CreateOrUpdateRawICAConsistencyRequest dateId
                     */
    
                    /**
                     * Constructs a new CreateOrUpdateRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateOrUpdateRawICAConsistencyRequest.
                     * @implements ICreateOrUpdateRawICAConsistencyRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest=} [properties] Properties to set
                     */
                    function CreateOrUpdateRawICAConsistencyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateOrUpdateRawICAConsistencyRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @instance
                     */
                    CreateOrUpdateRawICAConsistencyRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateOrUpdateRawICAConsistencyRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @instance
                     */
                    CreateOrUpdateRawICAConsistencyRequest.prototype.dateId = 0;
    
                    /**
                     * Creates a new CreateOrUpdateRawICAConsistencyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest} CreateOrUpdateRawICAConsistencyRequest instance
                     */
                    CreateOrUpdateRawICAConsistencyRequest.create = function create(properties) {
                        return new CreateOrUpdateRawICAConsistencyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateOrUpdateRawICAConsistencyRequest message. Does not implicitly {@link palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest} message CreateOrUpdateRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateOrUpdateRawICAConsistencyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateOrUpdateRawICAConsistencyRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyRequest} message CreateOrUpdateRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateOrUpdateRawICAConsistencyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateOrUpdateRawICAConsistencyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest} CreateOrUpdateRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateOrUpdateRawICAConsistencyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateOrUpdateRawICAConsistencyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest} CreateOrUpdateRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateOrUpdateRawICAConsistencyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateOrUpdateRawICAConsistencyRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateOrUpdateRawICAConsistencyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateOrUpdateRawICAConsistencyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest} CreateOrUpdateRawICAConsistencyRequest
                     */
                    CreateOrUpdateRawICAConsistencyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateOrUpdateRawICAConsistencyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest} message CreateOrUpdateRawICAConsistencyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateOrUpdateRawICAConsistencyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        return object;
                    };
    
                    /**
                     * Converts this CreateOrUpdateRawICAConsistencyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateOrUpdateRawICAConsistencyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateOrUpdateRawICAConsistencyRequest;
                })();
    
                v1.CreateOrUpdateRawICAConsistencyResponse = (function() {
    
                    /**
                     * Properties of a CreateOrUpdateRawICAConsistencyResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateOrUpdateRawICAConsistencyResponse
                     * @property {palexy.streaming.v1.IRawICAConsistency|null} [rawIcaConsistency] CreateOrUpdateRawICAConsistencyResponse rawIcaConsistency
                     * @property {boolean|null} [created] CreateOrUpdateRawICAConsistencyResponse created
                     */
    
                    /**
                     * Constructs a new CreateOrUpdateRawICAConsistencyResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateOrUpdateRawICAConsistencyResponse.
                     * @implements ICreateOrUpdateRawICAConsistencyResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyResponse=} [properties] Properties to set
                     */
                    function CreateOrUpdateRawICAConsistencyResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateOrUpdateRawICAConsistencyResponse rawIcaConsistency.
                     * @member {palexy.streaming.v1.IRawICAConsistency|null|undefined} rawIcaConsistency
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @instance
                     */
                    CreateOrUpdateRawICAConsistencyResponse.prototype.rawIcaConsistency = null;
    
                    /**
                     * CreateOrUpdateRawICAConsistencyResponse created.
                     * @member {boolean} created
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @instance
                     */
                    CreateOrUpdateRawICAConsistencyResponse.prototype.created = false;
    
                    /**
                     * Creates a new CreateOrUpdateRawICAConsistencyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} CreateOrUpdateRawICAConsistencyResponse instance
                     */
                    CreateOrUpdateRawICAConsistencyResponse.create = function create(properties) {
                        return new CreateOrUpdateRawICAConsistencyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateOrUpdateRawICAConsistencyResponse message. Does not implicitly {@link palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyResponse} message CreateOrUpdateRawICAConsistencyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateOrUpdateRawICAConsistencyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaConsistency != null && Object.hasOwnProperty.call(message, "rawIcaConsistency"))
                            $root.palexy.streaming.v1.RawICAConsistency.encode(message.rawIcaConsistency, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.created != null && Object.hasOwnProperty.call(message, "created"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.created);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateOrUpdateRawICAConsistencyResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateOrUpdateRawICAConsistencyResponse} message CreateOrUpdateRawICAConsistencyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateOrUpdateRawICAConsistencyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateOrUpdateRawICAConsistencyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} CreateOrUpdateRawICAConsistencyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateOrUpdateRawICAConsistencyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaConsistency = $root.palexy.streaming.v1.RawICAConsistency.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.created = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateOrUpdateRawICAConsistencyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} CreateOrUpdateRawICAConsistencyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateOrUpdateRawICAConsistencyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateOrUpdateRawICAConsistencyResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateOrUpdateRawICAConsistencyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaConsistency != null && message.hasOwnProperty("rawIcaConsistency")) {
                            var error = $root.palexy.streaming.v1.RawICAConsistency.verify(message.rawIcaConsistency);
                            if (error)
                                return "rawIcaConsistency." + error;
                        }
                        if (message.created != null && message.hasOwnProperty("created"))
                            if (typeof message.created !== "boolean")
                                return "created: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateOrUpdateRawICAConsistencyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} CreateOrUpdateRawICAConsistencyResponse
                     */
                    CreateOrUpdateRawICAConsistencyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse();
                        if (object.rawIcaConsistency != null) {
                            if (typeof object.rawIcaConsistency !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse.rawIcaConsistency: object expected");
                            message.rawIcaConsistency = $root.palexy.streaming.v1.RawICAConsistency.fromObject(object.rawIcaConsistency);
                        }
                        if (object.created != null)
                            message.created = Boolean(object.created);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateOrUpdateRawICAConsistencyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse} message CreateOrUpdateRawICAConsistencyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateOrUpdateRawICAConsistencyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.rawIcaConsistency = null;
                            object.created = false;
                        }
                        if (message.rawIcaConsistency != null && message.hasOwnProperty("rawIcaConsistency"))
                            object.rawIcaConsistency = $root.palexy.streaming.v1.RawICAConsistency.toObject(message.rawIcaConsistency, options);
                        if (message.created != null && message.hasOwnProperty("created"))
                            object.created = message.created;
                        return object;
                    };
    
                    /**
                     * Converts this CreateOrUpdateRawICAConsistencyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateOrUpdateRawICAConsistencyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateOrUpdateRawICAConsistencyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateOrUpdateRawICAConsistencyResponse;
                })();
    
                v1.ListRawICAConsistencyRequest = (function() {
    
                    /**
                     * Properties of a ListRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICAConsistencyRequest
                     * @property {number|null} [companyId] ListRawICAConsistencyRequest companyId
                     * @property {Array.<number>|null} [storeIds] ListRawICAConsistencyRequest storeIds
                     * @property {Array.<palexy.streaming.v1.RawICAConsistency.State>|null} [states] ListRawICAConsistencyRequest states
                     * @property {number|null} [pageSize] ListRawICAConsistencyRequest pageSize
                     * @property {string|null} [pageToken] ListRawICAConsistencyRequest pageToken
                     * @property {google.protobuf.IInt64Value|null} [lastChangedFromMs] ListRawICAConsistencyRequest lastChangedFromMs
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] ListRawICAConsistencyRequest fromDate
                     * @property {palexy.streaming.v1.IDateFilter|null} [toDate] ListRawICAConsistencyRequest toDate
                     */
    
                    /**
                     * Constructs a new ListRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICAConsistencyRequest.
                     * @implements IListRawICAConsistencyRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest=} [properties] Properties to set
                     */
                    function ListRawICAConsistencyRequest(properties) {
                        this.storeIds = [];
                        this.states = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICAConsistencyRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListRawICAConsistencyRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListRawICAConsistencyRequest states.
                     * @member {Array.<palexy.streaming.v1.RawICAConsistency.State>} states
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.states = $util.emptyArray;
    
                    /**
                     * ListRawICAConsistencyRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.pageSize = 0;
    
                    /**
                     * ListRawICAConsistencyRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.pageToken = "";
    
                    /**
                     * ListRawICAConsistencyRequest lastChangedFromMs.
                     * @member {google.protobuf.IInt64Value|null|undefined} lastChangedFromMs
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.lastChangedFromMs = null;
    
                    /**
                     * ListRawICAConsistencyRequest fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.fromDate = null;
    
                    /**
                     * ListRawICAConsistencyRequest toDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} toDate
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     */
                    ListRawICAConsistencyRequest.prototype.toDate = null;
    
                    /**
                     * Creates a new ListRawICAConsistencyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyRequest} ListRawICAConsistencyRequest instance
                     */
                    ListRawICAConsistencyRequest.create = function create(properties) {
                        return new ListRawICAConsistencyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICAConsistencyRequest message. Does not implicitly {@link palexy.streaming.v1.ListRawICAConsistencyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest} message ListRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAConsistencyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.states != null && message.states.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.states.length; ++i)
                                writer.int32(message.states[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.pageToken);
                        if (message.lastChangedFromMs != null && Object.hasOwnProperty.call(message, "lastChangedFromMs"))
                            $root.google.protobuf.Int64Value.encode(message.lastChangedFromMs, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.toDate, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICAConsistencyRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICAConsistencyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyRequest} message ListRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAConsistencyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICAConsistencyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyRequest} ListRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAConsistencyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICAConsistencyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 5:
                                if (!(message.states && message.states.length))
                                    message.states = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.states.push(reader.int32());
                                } else
                                    message.states.push(reader.int32());
                                break;
                            case 6:
                                message.pageSize = reader.int32();
                                break;
                            case 7:
                                message.pageToken = reader.string();
                                break;
                            case 8:
                                message.lastChangedFromMs = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.toDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICAConsistencyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyRequest} ListRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAConsistencyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICAConsistencyRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICAConsistencyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.states != null && message.hasOwnProperty("states")) {
                            if (!Array.isArray(message.states))
                                return "states: array expected";
                            for (var i = 0; i < message.states.length; ++i)
                                switch (message.states[i]) {
                                default:
                                    return "states: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.lastChangedFromMs != null && message.hasOwnProperty("lastChangedFromMs")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.lastChangedFromMs);
                            if (error)
                                return "lastChangedFromMs." + error;
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.toDate != null && message.hasOwnProperty("toDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.toDate);
                            if (error)
                                return "toDate." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICAConsistencyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyRequest} ListRawICAConsistencyRequest
                     */
                    ListRawICAConsistencyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICAConsistencyRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICAConsistencyRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.states) {
                            if (!Array.isArray(object.states))
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyRequest.states: array expected");
                            message.states = [];
                            for (var i = 0; i < object.states.length; ++i)
                                switch (object.states[i]) {
                                default:
                                case "UNKNOWN":
                                case 0:
                                    message.states[i] = 0;
                                    break;
                                case "NORMAL":
                                case 1:
                                    message.states[i] = 1;
                                    break;
                                case "CONSIDERABLE_LOSS":
                                case 2:
                                    message.states[i] = 2;
                                    break;
                                case "CONSIDERABLE_LOSS_BUT_INSIGNIFICANT":
                                case 3:
                                    message.states[i] = 3;
                                    break;
                                case "SIMULATED":
                                case 4:
                                    message.states[i] = 4;
                                    break;
                                case "INVALID":
                                case 5:
                                    message.states[i] = 5;
                                    break;
                                }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.lastChangedFromMs != null) {
                            if (typeof object.lastChangedFromMs !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyRequest.lastChangedFromMs: object expected");
                            message.lastChangedFromMs = $root.google.protobuf.Int64Value.fromObject(object.lastChangedFromMs);
                        }
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyRequest.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.toDate != null) {
                            if (typeof object.toDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyRequest.toDate: object expected");
                            message.toDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.toDate);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICAConsistencyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.ListRawICAConsistencyRequest} message ListRawICAConsistencyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICAConsistencyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeIds = [];
                            object.states = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.lastChangedFromMs = null;
                            object.fromDate = null;
                            object.toDate = null;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.states && message.states.length) {
                            object.states = [];
                            for (var j = 0; j < message.states.length; ++j)
                                object.states[j] = options.enums === String ? $root.palexy.streaming.v1.RawICAConsistency.State[message.states[j]] : message.states[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.lastChangedFromMs != null && message.hasOwnProperty("lastChangedFromMs"))
                            object.lastChangedFromMs = $root.google.protobuf.Int64Value.toObject(message.lastChangedFromMs, options);
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = $root.palexy.streaming.v1.DateFilter.toObject(message.toDate, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICAConsistencyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICAConsistencyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICAConsistencyRequest;
                })();
    
                v1.ListRawICAConsistencyResponse = (function() {
    
                    /**
                     * Properties of a ListRawICAConsistencyResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListRawICAConsistencyResponse
                     * @property {Array.<palexy.streaming.v1.IRawICAConsistency>|null} [rawIcaConsistencies] ListRawICAConsistencyResponse rawIcaConsistencies
                     * @property {number|null} [totalElements] ListRawICAConsistencyResponse totalElements
                     * @property {string|null} [nextPageToken] ListRawICAConsistencyResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListRawICAConsistencyResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListRawICAConsistencyResponse.
                     * @implements IListRawICAConsistencyResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListRawICAConsistencyResponse=} [properties] Properties to set
                     */
                    function ListRawICAConsistencyResponse(properties) {
                        this.rawIcaConsistencies = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListRawICAConsistencyResponse rawIcaConsistencies.
                     * @member {Array.<palexy.streaming.v1.IRawICAConsistency>} rawIcaConsistencies
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @instance
                     */
                    ListRawICAConsistencyResponse.prototype.rawIcaConsistencies = $util.emptyArray;
    
                    /**
                     * ListRawICAConsistencyResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @instance
                     */
                    ListRawICAConsistencyResponse.prototype.totalElements = 0;
    
                    /**
                     * ListRawICAConsistencyResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @instance
                     */
                    ListRawICAConsistencyResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListRawICAConsistencyResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyResponse} ListRawICAConsistencyResponse instance
                     */
                    ListRawICAConsistencyResponse.create = function create(properties) {
                        return new ListRawICAConsistencyResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListRawICAConsistencyResponse message. Does not implicitly {@link palexy.streaming.v1.ListRawICAConsistencyResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyResponse} message ListRawICAConsistencyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAConsistencyResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaConsistencies != null && message.rawIcaConsistencies.length)
                            for (var i = 0; i < message.rawIcaConsistencies.length; ++i)
                                $root.palexy.streaming.v1.RawICAConsistency.encode(message.rawIcaConsistencies[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListRawICAConsistencyResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListRawICAConsistencyResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.IListRawICAConsistencyResponse} message ListRawICAConsistencyResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListRawICAConsistencyResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListRawICAConsistencyResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyResponse} ListRawICAConsistencyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAConsistencyResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListRawICAConsistencyResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rawIcaConsistencies && message.rawIcaConsistencies.length))
                                    message.rawIcaConsistencies = [];
                                message.rawIcaConsistencies.push($root.palexy.streaming.v1.RawICAConsistency.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListRawICAConsistencyResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyResponse} ListRawICAConsistencyResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListRawICAConsistencyResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListRawICAConsistencyResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListRawICAConsistencyResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaConsistencies != null && message.hasOwnProperty("rawIcaConsistencies")) {
                            if (!Array.isArray(message.rawIcaConsistencies))
                                return "rawIcaConsistencies: array expected";
                            for (var i = 0; i < message.rawIcaConsistencies.length; ++i) {
                                var error = $root.palexy.streaming.v1.RawICAConsistency.verify(message.rawIcaConsistencies[i]);
                                if (error)
                                    return "rawIcaConsistencies." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListRawICAConsistencyResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListRawICAConsistencyResponse} ListRawICAConsistencyResponse
                     */
                    ListRawICAConsistencyResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListRawICAConsistencyResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListRawICAConsistencyResponse();
                        if (object.rawIcaConsistencies) {
                            if (!Array.isArray(object.rawIcaConsistencies))
                                throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyResponse.rawIcaConsistencies: array expected");
                            message.rawIcaConsistencies = [];
                            for (var i = 0; i < object.rawIcaConsistencies.length; ++i) {
                                if (typeof object.rawIcaConsistencies[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListRawICAConsistencyResponse.rawIcaConsistencies: object expected");
                                message.rawIcaConsistencies[i] = $root.palexy.streaming.v1.RawICAConsistency.fromObject(object.rawIcaConsistencies[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListRawICAConsistencyResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @static
                     * @param {palexy.streaming.v1.ListRawICAConsistencyResponse} message ListRawICAConsistencyResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListRawICAConsistencyResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rawIcaConsistencies = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.rawIcaConsistencies && message.rawIcaConsistencies.length) {
                            object.rawIcaConsistencies = [];
                            for (var j = 0; j < message.rawIcaConsistencies.length; ++j)
                                object.rawIcaConsistencies[j] = $root.palexy.streaming.v1.RawICAConsistency.toObject(message.rawIcaConsistencies[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListRawICAConsistencyResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListRawICAConsistencyResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListRawICAConsistencyResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListRawICAConsistencyResponse;
                })();
    
                v1.GetRawICAConsistencyRequest = (function() {
    
                    /**
                     * Properties of a GetRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetRawICAConsistencyRequest
                     * @property {number|null} [id] GetRawICAConsistencyRequest id
                     */
    
                    /**
                     * Constructs a new GetRawICAConsistencyRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetRawICAConsistencyRequest.
                     * @implements IGetRawICAConsistencyRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest=} [properties] Properties to set
                     */
                    function GetRawICAConsistencyRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetRawICAConsistencyRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @instance
                     */
                    GetRawICAConsistencyRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetRawICAConsistencyRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetRawICAConsistencyRequest} GetRawICAConsistencyRequest instance
                     */
                    GetRawICAConsistencyRequest.create = function create(properties) {
                        return new GetRawICAConsistencyRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetRawICAConsistencyRequest message. Does not implicitly {@link palexy.streaming.v1.GetRawICAConsistencyRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest} message GetRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRawICAConsistencyRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetRawICAConsistencyRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetRawICAConsistencyRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRawICAConsistencyRequest} message GetRawICAConsistencyRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRawICAConsistencyRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetRawICAConsistencyRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetRawICAConsistencyRequest} GetRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRawICAConsistencyRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetRawICAConsistencyRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetRawICAConsistencyRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetRawICAConsistencyRequest} GetRawICAConsistencyRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRawICAConsistencyRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetRawICAConsistencyRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetRawICAConsistencyRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetRawICAConsistencyRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetRawICAConsistencyRequest} GetRawICAConsistencyRequest
                     */
                    GetRawICAConsistencyRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetRawICAConsistencyRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetRawICAConsistencyRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetRawICAConsistencyRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @static
                     * @param {palexy.streaming.v1.GetRawICAConsistencyRequest} message GetRawICAConsistencyRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetRawICAConsistencyRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetRawICAConsistencyRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetRawICAConsistencyRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetRawICAConsistencyRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetRawICAConsistencyRequest;
                })();
    
                v1.UpdateRawICAConsistencyStateRequest = (function() {
    
                    /**
                     * Properties of an UpdateRawICAConsistencyStateRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateRawICAConsistencyStateRequest
                     * @property {number|null} [id] UpdateRawICAConsistencyStateRequest id
                     * @property {palexy.streaming.v1.RawICAConsistency.State|null} [newState] UpdateRawICAConsistencyStateRequest newState
                     * @property {number|null} [editorAccountId] UpdateRawICAConsistencyStateRequest editorAccountId
                     */
    
                    /**
                     * Constructs a new UpdateRawICAConsistencyStateRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateRawICAConsistencyStateRequest.
                     * @implements IUpdateRawICAConsistencyStateRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest=} [properties] Properties to set
                     */
                    function UpdateRawICAConsistencyStateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateRawICAConsistencyStateRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @instance
                     */
                    UpdateRawICAConsistencyStateRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateRawICAConsistencyStateRequest newState.
                     * @member {palexy.streaming.v1.RawICAConsistency.State} newState
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @instance
                     */
                    UpdateRawICAConsistencyStateRequest.prototype.newState = 0;
    
                    /**
                     * UpdateRawICAConsistencyStateRequest editorAccountId.
                     * @member {number} editorAccountId
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @instance
                     */
                    UpdateRawICAConsistencyStateRequest.prototype.editorAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new UpdateRawICAConsistencyStateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateRawICAConsistencyStateRequest} UpdateRawICAConsistencyStateRequest instance
                     */
                    UpdateRawICAConsistencyStateRequest.create = function create(properties) {
                        return new UpdateRawICAConsistencyStateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateRawICAConsistencyStateRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateRawICAConsistencyStateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest} message UpdateRawICAConsistencyStateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateRawICAConsistencyStateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.newState != null && Object.hasOwnProperty.call(message, "newState"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.newState);
                        if (message.editorAccountId != null && Object.hasOwnProperty.call(message, "editorAccountId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.editorAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateRawICAConsistencyStateRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateRawICAConsistencyStateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateRawICAConsistencyStateRequest} message UpdateRawICAConsistencyStateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateRawICAConsistencyStateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateRawICAConsistencyStateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateRawICAConsistencyStateRequest} UpdateRawICAConsistencyStateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateRawICAConsistencyStateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateRawICAConsistencyStateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.newState = reader.int32();
                                break;
                            case 3:
                                message.editorAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateRawICAConsistencyStateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateRawICAConsistencyStateRequest} UpdateRawICAConsistencyStateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateRawICAConsistencyStateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateRawICAConsistencyStateRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateRawICAConsistencyStateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            switch (message.newState) {
                            default:
                                return "newState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (!$util.isInteger(message.editorAccountId) && !(message.editorAccountId && $util.isInteger(message.editorAccountId.low) && $util.isInteger(message.editorAccountId.high)))
                                return "editorAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateRawICAConsistencyStateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateRawICAConsistencyStateRequest} UpdateRawICAConsistencyStateRequest
                     */
                    UpdateRawICAConsistencyStateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateRawICAConsistencyStateRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateRawICAConsistencyStateRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        switch (object.newState) {
                        case "UNKNOWN":
                        case 0:
                            message.newState = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.newState = 1;
                            break;
                        case "CONSIDERABLE_LOSS":
                        case 2:
                            message.newState = 2;
                            break;
                        case "CONSIDERABLE_LOSS_BUT_INSIGNIFICANT":
                        case 3:
                            message.newState = 3;
                            break;
                        case "SIMULATED":
                        case 4:
                            message.newState = 4;
                            break;
                        case "INVALID":
                        case 5:
                            message.newState = 5;
                            break;
                        }
                        if (object.editorAccountId != null)
                            if ($util.Long)
                                (message.editorAccountId = $util.Long.fromValue(object.editorAccountId)).unsigned = false;
                            else if (typeof object.editorAccountId === "string")
                                message.editorAccountId = parseInt(object.editorAccountId, 10);
                            else if (typeof object.editorAccountId === "number")
                                message.editorAccountId = object.editorAccountId;
                            else if (typeof object.editorAccountId === "object")
                                message.editorAccountId = new $util.LongBits(object.editorAccountId.low >>> 0, object.editorAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateRawICAConsistencyStateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateRawICAConsistencyStateRequest} message UpdateRawICAConsistencyStateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateRawICAConsistencyStateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.newState = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.editorAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.editorAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            object.newState = options.enums === String ? $root.palexy.streaming.v1.RawICAConsistency.State[message.newState] : message.newState;
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (typeof message.editorAccountId === "number")
                                object.editorAccountId = options.longs === String ? String(message.editorAccountId) : message.editorAccountId;
                            else
                                object.editorAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.editorAccountId) : options.longs === Number ? new $util.LongBits(message.editorAccountId.low >>> 0, message.editorAccountId.high >>> 0).toNumber() : message.editorAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateRawICAConsistencyStateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateRawICAConsistencyStateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateRawICAConsistencyStateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateRawICAConsistencyStateRequest;
                })();
    
                v1.RawICAConsistency = (function() {
    
                    /**
                     * Properties of a RawICAConsistency.
                     * @memberof palexy.streaming.v1
                     * @interface IRawICAConsistency
                     * @property {number|null} [id] RawICAConsistency id
                     * @property {number|null} [companyId] RawICAConsistency companyId
                     * @property {number|null} [storeId] RawICAConsistency storeId
                     * @property {number|null} [dateId] RawICAConsistency dateId
                     * @property {palexy.streaming.v1.ITimeRangeList|null} [requiredStreamingIntervals] RawICAConsistency requiredStreamingIntervals
                     * @property {Object.<string,palexy.streaming.v1.ITimeRangeList>|null} [missingStreamingIntervalsByCameraId] RawICAConsistency missingStreamingIntervalsByCameraId
                     * @property {number|null} [requiredStreamingDurationSeconds] RawICAConsistency requiredStreamingDurationSeconds
                     * @property {number|null} [actualStreamingDurationSeconds] RawICAConsistency actualStreamingDurationSeconds
                     * @property {number|null} [missingStreamingDurationSeconds] RawICAConsistency missingStreamingDurationSeconds
                     * @property {palexy.streaming.v1.RawICAConsistency.State|null} [state] RawICAConsistency state
                     * @property {palexy.streaming.v1.ITimeRangeList|null} [simulatedIntervals] RawICAConsistency simulatedIntervals
                     * @property {google.protobuf.IInt64Value|null} [lastEditorAccountId] RawICAConsistency lastEditorAccountId
                     * @property {number|null} [createTimeMs] RawICAConsistency createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] RawICAConsistency lastUpdateTimeMs
                     * @property {Array.<string>|null} [simulatedCameraIds] RawICAConsistency simulatedCameraIds
                     * @property {string|null} [lastEditorUsername] RawICAConsistency lastEditorUsername
                     */
    
                    /**
                     * Constructs a new RawICAConsistency.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICAConsistency.
                     * @implements IRawICAConsistency
                     * @constructor
                     * @param {palexy.streaming.v1.IRawICAConsistency=} [properties] Properties to set
                     */
                    function RawICAConsistency(properties) {
                        this.missingStreamingIntervalsByCameraId = {};
                        this.simulatedCameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RawICAConsistency id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAConsistency companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAConsistency storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAConsistency dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.dateId = 0;
    
                    /**
                     * RawICAConsistency requiredStreamingIntervals.
                     * @member {palexy.streaming.v1.ITimeRangeList|null|undefined} requiredStreamingIntervals
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.requiredStreamingIntervals = null;
    
                    /**
                     * RawICAConsistency missingStreamingIntervalsByCameraId.
                     * @member {Object.<string,palexy.streaming.v1.ITimeRangeList>} missingStreamingIntervalsByCameraId
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.missingStreamingIntervalsByCameraId = $util.emptyObject;
    
                    /**
                     * RawICAConsistency requiredStreamingDurationSeconds.
                     * @member {number} requiredStreamingDurationSeconds
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.requiredStreamingDurationSeconds = 0;
    
                    /**
                     * RawICAConsistency actualStreamingDurationSeconds.
                     * @member {number} actualStreamingDurationSeconds
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.actualStreamingDurationSeconds = 0;
    
                    /**
                     * RawICAConsistency missingStreamingDurationSeconds.
                     * @member {number} missingStreamingDurationSeconds
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.missingStreamingDurationSeconds = 0;
    
                    /**
                     * RawICAConsistency state.
                     * @member {palexy.streaming.v1.RawICAConsistency.State} state
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.state = 0;
    
                    /**
                     * RawICAConsistency simulatedIntervals.
                     * @member {palexy.streaming.v1.ITimeRangeList|null|undefined} simulatedIntervals
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.simulatedIntervals = null;
    
                    /**
                     * RawICAConsistency lastEditorAccountId.
                     * @member {google.protobuf.IInt64Value|null|undefined} lastEditorAccountId
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.lastEditorAccountId = null;
    
                    /**
                     * RawICAConsistency createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAConsistency lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICAConsistency simulatedCameraIds.
                     * @member {Array.<string>} simulatedCameraIds
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.simulatedCameraIds = $util.emptyArray;
    
                    /**
                     * RawICAConsistency lastEditorUsername.
                     * @member {string} lastEditorUsername
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     */
                    RawICAConsistency.prototype.lastEditorUsername = "";
    
                    /**
                     * Creates a new RawICAConsistency instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {palexy.streaming.v1.IRawICAConsistency=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RawICAConsistency} RawICAConsistency instance
                     */
                    RawICAConsistency.create = function create(properties) {
                        return new RawICAConsistency(properties);
                    };
    
                    /**
                     * Encodes the specified RawICAConsistency message. Does not implicitly {@link palexy.streaming.v1.RawICAConsistency.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {palexy.streaming.v1.IRawICAConsistency} message RawICAConsistency message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICAConsistency.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.requiredStreamingIntervals != null && Object.hasOwnProperty.call(message, "requiredStreamingIntervals"))
                            $root.palexy.streaming.v1.TimeRangeList.encode(message.requiredStreamingIntervals, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.missingStreamingIntervalsByCameraId != null && Object.hasOwnProperty.call(message, "missingStreamingIntervalsByCameraId"))
                            for (var keys = Object.keys(message.missingStreamingIntervalsByCameraId), i = 0; i < keys.length; ++i) {
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]);
                                $root.palexy.streaming.v1.TimeRangeList.encode(message.missingStreamingIntervalsByCameraId[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                            }
                        if (message.requiredStreamingDurationSeconds != null && Object.hasOwnProperty.call(message, "requiredStreamingDurationSeconds"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.requiredStreamingDurationSeconds);
                        if (message.actualStreamingDurationSeconds != null && Object.hasOwnProperty.call(message, "actualStreamingDurationSeconds"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.actualStreamingDurationSeconds);
                        if (message.missingStreamingDurationSeconds != null && Object.hasOwnProperty.call(message, "missingStreamingDurationSeconds"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.missingStreamingDurationSeconds);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.state);
                        if (message.simulatedIntervals != null && Object.hasOwnProperty.call(message, "simulatedIntervals"))
                            $root.palexy.streaming.v1.TimeRangeList.encode(message.simulatedIntervals, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.lastEditorAccountId != null && Object.hasOwnProperty.call(message, "lastEditorAccountId"))
                            $root.google.protobuf.Int64Value.encode(message.lastEditorAccountId, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.lastUpdateTimeMs);
                        if (message.lastEditorUsername != null && Object.hasOwnProperty.call(message, "lastEditorUsername"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.lastEditorUsername);
                        if (message.simulatedCameraIds != null && message.simulatedCameraIds.length)
                            for (var i = 0; i < message.simulatedCameraIds.length; ++i)
                                writer.uint32(/* id 16, wireType 2 =*/130).string(message.simulatedCameraIds[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RawICAConsistency message, length delimited. Does not implicitly {@link palexy.streaming.v1.RawICAConsistency.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {palexy.streaming.v1.IRawICAConsistency} message RawICAConsistency message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICAConsistency.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RawICAConsistency message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RawICAConsistency} RawICAConsistency
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICAConsistency.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RawICAConsistency(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.requiredStreamingIntervals = $root.palexy.streaming.v1.TimeRangeList.decode(reader, reader.uint32());
                                break;
                            case 6:
                                if (message.missingStreamingIntervalsByCameraId === $util.emptyObject)
                                    message.missingStreamingIntervalsByCameraId = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = null;
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = $root.palexy.streaming.v1.TimeRangeList.decode(reader, reader.uint32());
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.missingStreamingIntervalsByCameraId[key] = value;
                                break;
                            case 7:
                                message.requiredStreamingDurationSeconds = reader.int32();
                                break;
                            case 8:
                                message.actualStreamingDurationSeconds = reader.int32();
                                break;
                            case 9:
                                message.missingStreamingDurationSeconds = reader.int32();
                                break;
                            case 10:
                                message.state = reader.int32();
                                break;
                            case 11:
                                message.simulatedIntervals = $root.palexy.streaming.v1.TimeRangeList.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.lastEditorAccountId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.createTimeMs = reader.int64();
                                break;
                            case 14:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 16:
                                if (!(message.simulatedCameraIds && message.simulatedCameraIds.length))
                                    message.simulatedCameraIds = [];
                                message.simulatedCameraIds.push(reader.string());
                                break;
                            case 15:
                                message.lastEditorUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RawICAConsistency message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RawICAConsistency} RawICAConsistency
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICAConsistency.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RawICAConsistency message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RawICAConsistency.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.requiredStreamingIntervals != null && message.hasOwnProperty("requiredStreamingIntervals")) {
                            var error = $root.palexy.streaming.v1.TimeRangeList.verify(message.requiredStreamingIntervals);
                            if (error)
                                return "requiredStreamingIntervals." + error;
                        }
                        if (message.missingStreamingIntervalsByCameraId != null && message.hasOwnProperty("missingStreamingIntervalsByCameraId")) {
                            if (!$util.isObject(message.missingStreamingIntervalsByCameraId))
                                return "missingStreamingIntervalsByCameraId: object expected";
                            var key = Object.keys(message.missingStreamingIntervalsByCameraId);
                            for (var i = 0; i < key.length; ++i) {
                                var error = $root.palexy.streaming.v1.TimeRangeList.verify(message.missingStreamingIntervalsByCameraId[key[i]]);
                                if (error)
                                    return "missingStreamingIntervalsByCameraId." + error;
                            }
                        }
                        if (message.requiredStreamingDurationSeconds != null && message.hasOwnProperty("requiredStreamingDurationSeconds"))
                            if (!$util.isInteger(message.requiredStreamingDurationSeconds))
                                return "requiredStreamingDurationSeconds: integer expected";
                        if (message.actualStreamingDurationSeconds != null && message.hasOwnProperty("actualStreamingDurationSeconds"))
                            if (!$util.isInteger(message.actualStreamingDurationSeconds))
                                return "actualStreamingDurationSeconds: integer expected";
                        if (message.missingStreamingDurationSeconds != null && message.hasOwnProperty("missingStreamingDurationSeconds"))
                            if (!$util.isInteger(message.missingStreamingDurationSeconds))
                                return "missingStreamingDurationSeconds: integer expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.simulatedIntervals != null && message.hasOwnProperty("simulatedIntervals")) {
                            var error = $root.palexy.streaming.v1.TimeRangeList.verify(message.simulatedIntervals);
                            if (error)
                                return "simulatedIntervals." + error;
                        }
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.lastEditorAccountId);
                            if (error)
                                return "lastEditorAccountId." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.simulatedCameraIds != null && message.hasOwnProperty("simulatedCameraIds")) {
                            if (!Array.isArray(message.simulatedCameraIds))
                                return "simulatedCameraIds: array expected";
                            for (var i = 0; i < message.simulatedCameraIds.length; ++i)
                                if (!$util.isString(message.simulatedCameraIds[i]))
                                    return "simulatedCameraIds: string[] expected";
                        }
                        if (message.lastEditorUsername != null && message.hasOwnProperty("lastEditorUsername"))
                            if (!$util.isString(message.lastEditorUsername))
                                return "lastEditorUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RawICAConsistency message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RawICAConsistency} RawICAConsistency
                     */
                    RawICAConsistency.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RawICAConsistency)
                            return object;
                        var message = new $root.palexy.streaming.v1.RawICAConsistency();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.requiredStreamingIntervals != null) {
                            if (typeof object.requiredStreamingIntervals !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICAConsistency.requiredStreamingIntervals: object expected");
                            message.requiredStreamingIntervals = $root.palexy.streaming.v1.TimeRangeList.fromObject(object.requiredStreamingIntervals);
                        }
                        if (object.missingStreamingIntervalsByCameraId) {
                            if (typeof object.missingStreamingIntervalsByCameraId !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICAConsistency.missingStreamingIntervalsByCameraId: object expected");
                            message.missingStreamingIntervalsByCameraId = {};
                            for (var keys = Object.keys(object.missingStreamingIntervalsByCameraId), i = 0; i < keys.length; ++i) {
                                if (typeof object.missingStreamingIntervalsByCameraId[keys[i]] !== "object")
                                    throw TypeError(".palexy.streaming.v1.RawICAConsistency.missingStreamingIntervalsByCameraId: object expected");
                                message.missingStreamingIntervalsByCameraId[keys[i]] = $root.palexy.streaming.v1.TimeRangeList.fromObject(object.missingStreamingIntervalsByCameraId[keys[i]]);
                            }
                        }
                        if (object.requiredStreamingDurationSeconds != null)
                            message.requiredStreamingDurationSeconds = object.requiredStreamingDurationSeconds | 0;
                        if (object.actualStreamingDurationSeconds != null)
                            message.actualStreamingDurationSeconds = object.actualStreamingDurationSeconds | 0;
                        if (object.missingStreamingDurationSeconds != null)
                            message.missingStreamingDurationSeconds = object.missingStreamingDurationSeconds | 0;
                        switch (object.state) {
                        case "UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.state = 1;
                            break;
                        case "CONSIDERABLE_LOSS":
                        case 2:
                            message.state = 2;
                            break;
                        case "CONSIDERABLE_LOSS_BUT_INSIGNIFICANT":
                        case 3:
                            message.state = 3;
                            break;
                        case "SIMULATED":
                        case 4:
                            message.state = 4;
                            break;
                        case "INVALID":
                        case 5:
                            message.state = 5;
                            break;
                        }
                        if (object.simulatedIntervals != null) {
                            if (typeof object.simulatedIntervals !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICAConsistency.simulatedIntervals: object expected");
                            message.simulatedIntervals = $root.palexy.streaming.v1.TimeRangeList.fromObject(object.simulatedIntervals);
                        }
                        if (object.lastEditorAccountId != null) {
                            if (typeof object.lastEditorAccountId !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICAConsistency.lastEditorAccountId: object expected");
                            message.lastEditorAccountId = $root.google.protobuf.Int64Value.fromObject(object.lastEditorAccountId);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.simulatedCameraIds) {
                            if (!Array.isArray(object.simulatedCameraIds))
                                throw TypeError(".palexy.streaming.v1.RawICAConsistency.simulatedCameraIds: array expected");
                            message.simulatedCameraIds = [];
                            for (var i = 0; i < object.simulatedCameraIds.length; ++i)
                                message.simulatedCameraIds[i] = String(object.simulatedCameraIds[i]);
                        }
                        if (object.lastEditorUsername != null)
                            message.lastEditorUsername = String(object.lastEditorUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RawICAConsistency message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @static
                     * @param {palexy.streaming.v1.RawICAConsistency} message RawICAConsistency
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawICAConsistency.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.simulatedCameraIds = [];
                        if (options.objects || options.defaults)
                            object.missingStreamingIntervalsByCameraId = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.requiredStreamingIntervals = null;
                            object.requiredStreamingDurationSeconds = 0;
                            object.actualStreamingDurationSeconds = 0;
                            object.missingStreamingDurationSeconds = 0;
                            object.state = options.enums === String ? "UNKNOWN" : 0;
                            object.simulatedIntervals = null;
                            object.lastEditorAccountId = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.lastEditorUsername = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.requiredStreamingIntervals != null && message.hasOwnProperty("requiredStreamingIntervals"))
                            object.requiredStreamingIntervals = $root.palexy.streaming.v1.TimeRangeList.toObject(message.requiredStreamingIntervals, options);
                        var keys2;
                        if (message.missingStreamingIntervalsByCameraId && (keys2 = Object.keys(message.missingStreamingIntervalsByCameraId)).length) {
                            object.missingStreamingIntervalsByCameraId = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.missingStreamingIntervalsByCameraId[keys2[j]] = $root.palexy.streaming.v1.TimeRangeList.toObject(message.missingStreamingIntervalsByCameraId[keys2[j]], options);
                        }
                        if (message.requiredStreamingDurationSeconds != null && message.hasOwnProperty("requiredStreamingDurationSeconds"))
                            object.requiredStreamingDurationSeconds = message.requiredStreamingDurationSeconds;
                        if (message.actualStreamingDurationSeconds != null && message.hasOwnProperty("actualStreamingDurationSeconds"))
                            object.actualStreamingDurationSeconds = message.actualStreamingDurationSeconds;
                        if (message.missingStreamingDurationSeconds != null && message.hasOwnProperty("missingStreamingDurationSeconds"))
                            object.missingStreamingDurationSeconds = message.missingStreamingDurationSeconds;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.RawICAConsistency.State[message.state] : message.state;
                        if (message.simulatedIntervals != null && message.hasOwnProperty("simulatedIntervals"))
                            object.simulatedIntervals = $root.palexy.streaming.v1.TimeRangeList.toObject(message.simulatedIntervals, options);
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId"))
                            object.lastEditorAccountId = $root.google.protobuf.Int64Value.toObject(message.lastEditorAccountId, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.lastEditorUsername != null && message.hasOwnProperty("lastEditorUsername"))
                            object.lastEditorUsername = message.lastEditorUsername;
                        if (message.simulatedCameraIds && message.simulatedCameraIds.length) {
                            object.simulatedCameraIds = [];
                            for (var j = 0; j < message.simulatedCameraIds.length; ++j)
                                object.simulatedCameraIds[j] = message.simulatedCameraIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RawICAConsistency to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RawICAConsistency
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawICAConsistency.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * State enum.
                     * @name palexy.streaming.v1.RawICAConsistency.State
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} NORMAL=1 NORMAL value
                     * @property {number} CONSIDERABLE_LOSS=2 CONSIDERABLE_LOSS value
                     * @property {number} CONSIDERABLE_LOSS_BUT_INSIGNIFICANT=3 CONSIDERABLE_LOSS_BUT_INSIGNIFICANT value
                     * @property {number} SIMULATED=4 SIMULATED value
                     * @property {number} INVALID=5 INVALID value
                     */
                    RawICAConsistency.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "NORMAL"] = 1;
                        values[valuesById[2] = "CONSIDERABLE_LOSS"] = 2;
                        values[valuesById[3] = "CONSIDERABLE_LOSS_BUT_INSIGNIFICANT"] = 3;
                        values[valuesById[4] = "SIMULATED"] = 4;
                        values[valuesById[5] = "INVALID"] = 5;
                        return values;
                    })();
    
                    return RawICAConsistency;
                })();
    
                v1.GetRecommendedSimulatingSourceRequest = (function() {
    
                    /**
                     * Properties of a GetRecommendedSimulatingSourceRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetRecommendedSimulatingSourceRequest
                     * @property {number|null} [rawIcaConsistencyId] GetRecommendedSimulatingSourceRequest rawIcaConsistencyId
                     * @property {number|null} [expectedWholeDayVisits] GetRecommendedSimulatingSourceRequest expectedWholeDayVisits
                     * @property {number|null} [maxResults] GetRecommendedSimulatingSourceRequest maxResults
                     * @property {Array.<string>|null} [cameraIds] GetRecommendedSimulatingSourceRequest cameraIds
                     */
    
                    /**
                     * Constructs a new GetRecommendedSimulatingSourceRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetRecommendedSimulatingSourceRequest.
                     * @implements IGetRecommendedSimulatingSourceRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest=} [properties] Properties to set
                     */
                    function GetRecommendedSimulatingSourceRequest(properties) {
                        this.cameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetRecommendedSimulatingSourceRequest rawIcaConsistencyId.
                     * @member {number} rawIcaConsistencyId
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @instance
                     */
                    GetRecommendedSimulatingSourceRequest.prototype.rawIcaConsistencyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetRecommendedSimulatingSourceRequest expectedWholeDayVisits.
                     * @member {number} expectedWholeDayVisits
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @instance
                     */
                    GetRecommendedSimulatingSourceRequest.prototype.expectedWholeDayVisits = 0;
    
                    /**
                     * GetRecommendedSimulatingSourceRequest maxResults.
                     * @member {number} maxResults
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @instance
                     */
                    GetRecommendedSimulatingSourceRequest.prototype.maxResults = 0;
    
                    /**
                     * GetRecommendedSimulatingSourceRequest cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @instance
                     */
                    GetRecommendedSimulatingSourceRequest.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * Creates a new GetRecommendedSimulatingSourceRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceRequest} GetRecommendedSimulatingSourceRequest instance
                     */
                    GetRecommendedSimulatingSourceRequest.create = function create(properties) {
                        return new GetRecommendedSimulatingSourceRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetRecommendedSimulatingSourceRequest message. Does not implicitly {@link palexy.streaming.v1.GetRecommendedSimulatingSourceRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest} message GetRecommendedSimulatingSourceRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRecommendedSimulatingSourceRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaConsistencyId != null && Object.hasOwnProperty.call(message, "rawIcaConsistencyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.rawIcaConsistencyId);
                        if (message.expectedWholeDayVisits != null && Object.hasOwnProperty.call(message, "expectedWholeDayVisits"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.expectedWholeDayVisits);
                        if (message.maxResults != null && Object.hasOwnProperty.call(message, "maxResults"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.maxResults);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.cameraIds[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetRecommendedSimulatingSourceRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetRecommendedSimulatingSourceRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceRequest} message GetRecommendedSimulatingSourceRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRecommendedSimulatingSourceRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetRecommendedSimulatingSourceRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceRequest} GetRecommendedSimulatingSourceRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRecommendedSimulatingSourceRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetRecommendedSimulatingSourceRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaConsistencyId = reader.int64();
                                break;
                            case 2:
                                message.expectedWholeDayVisits = reader.int32();
                                break;
                            case 3:
                                message.maxResults = reader.int32();
                                break;
                            case 4:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetRecommendedSimulatingSourceRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceRequest} GetRecommendedSimulatingSourceRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRecommendedSimulatingSourceRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetRecommendedSimulatingSourceRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetRecommendedSimulatingSourceRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (!$util.isInteger(message.rawIcaConsistencyId) && !(message.rawIcaConsistencyId && $util.isInteger(message.rawIcaConsistencyId.low) && $util.isInteger(message.rawIcaConsistencyId.high)))
                                return "rawIcaConsistencyId: integer|Long expected";
                        if (message.expectedWholeDayVisits != null && message.hasOwnProperty("expectedWholeDayVisits"))
                            if (!$util.isInteger(message.expectedWholeDayVisits))
                                return "expectedWholeDayVisits: integer expected";
                        if (message.maxResults != null && message.hasOwnProperty("maxResults"))
                            if (!$util.isInteger(message.maxResults))
                                return "maxResults: integer expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetRecommendedSimulatingSourceRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceRequest} GetRecommendedSimulatingSourceRequest
                     */
                    GetRecommendedSimulatingSourceRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetRecommendedSimulatingSourceRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetRecommendedSimulatingSourceRequest();
                        if (object.rawIcaConsistencyId != null)
                            if ($util.Long)
                                (message.rawIcaConsistencyId = $util.Long.fromValue(object.rawIcaConsistencyId)).unsigned = false;
                            else if (typeof object.rawIcaConsistencyId === "string")
                                message.rawIcaConsistencyId = parseInt(object.rawIcaConsistencyId, 10);
                            else if (typeof object.rawIcaConsistencyId === "number")
                                message.rawIcaConsistencyId = object.rawIcaConsistencyId;
                            else if (typeof object.rawIcaConsistencyId === "object")
                                message.rawIcaConsistencyId = new $util.LongBits(object.rawIcaConsistencyId.low >>> 0, object.rawIcaConsistencyId.high >>> 0).toNumber();
                        if (object.expectedWholeDayVisits != null)
                            message.expectedWholeDayVisits = object.expectedWholeDayVisits | 0;
                        if (object.maxResults != null)
                            message.maxResults = object.maxResults | 0;
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.GetRecommendedSimulatingSourceRequest.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetRecommendedSimulatingSourceRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @static
                     * @param {palexy.streaming.v1.GetRecommendedSimulatingSourceRequest} message GetRecommendedSimulatingSourceRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetRecommendedSimulatingSourceRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameraIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.rawIcaConsistencyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.rawIcaConsistencyId = options.longs === String ? "0" : 0;
                            object.expectedWholeDayVisits = 0;
                            object.maxResults = 0;
                        }
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (typeof message.rawIcaConsistencyId === "number")
                                object.rawIcaConsistencyId = options.longs === String ? String(message.rawIcaConsistencyId) : message.rawIcaConsistencyId;
                            else
                                object.rawIcaConsistencyId = options.longs === String ? $util.Long.prototype.toString.call(message.rawIcaConsistencyId) : options.longs === Number ? new $util.LongBits(message.rawIcaConsistencyId.low >>> 0, message.rawIcaConsistencyId.high >>> 0).toNumber() : message.rawIcaConsistencyId;
                        if (message.expectedWholeDayVisits != null && message.hasOwnProperty("expectedWholeDayVisits"))
                            object.expectedWholeDayVisits = message.expectedWholeDayVisits;
                        if (message.maxResults != null && message.hasOwnProperty("maxResults"))
                            object.maxResults = message.maxResults;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetRecommendedSimulatingSourceRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetRecommendedSimulatingSourceRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetRecommendedSimulatingSourceRequest;
                })();
    
                v1.GetRecommendedSimulatingSourceResponse = (function() {
    
                    /**
                     * Properties of a GetRecommendedSimulatingSourceResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetRecommendedSimulatingSourceResponse
                     * @property {number|null} [expectedWholeDayVisits] GetRecommendedSimulatingSourceResponse expectedWholeDayVisits
                     * @property {Array.<palexy.streaming.v1.ITimeRange>|null} [intervals] GetRecommendedSimulatingSourceResponse intervals
                     * @property {Array.<palexy.streaming.v1.IRecommendedSimulatingSource>|null} [recommendedSimulatingSources] GetRecommendedSimulatingSourceResponse recommendedSimulatingSources
                     */
    
                    /**
                     * Constructs a new GetRecommendedSimulatingSourceResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetRecommendedSimulatingSourceResponse.
                     * @implements IGetRecommendedSimulatingSourceResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceResponse=} [properties] Properties to set
                     */
                    function GetRecommendedSimulatingSourceResponse(properties) {
                        this.intervals = [];
                        this.recommendedSimulatingSources = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetRecommendedSimulatingSourceResponse expectedWholeDayVisits.
                     * @member {number} expectedWholeDayVisits
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @instance
                     */
                    GetRecommendedSimulatingSourceResponse.prototype.expectedWholeDayVisits = 0;
    
                    /**
                     * GetRecommendedSimulatingSourceResponse intervals.
                     * @member {Array.<palexy.streaming.v1.ITimeRange>} intervals
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @instance
                     */
                    GetRecommendedSimulatingSourceResponse.prototype.intervals = $util.emptyArray;
    
                    /**
                     * GetRecommendedSimulatingSourceResponse recommendedSimulatingSources.
                     * @member {Array.<palexy.streaming.v1.IRecommendedSimulatingSource>} recommendedSimulatingSources
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @instance
                     */
                    GetRecommendedSimulatingSourceResponse.prototype.recommendedSimulatingSources = $util.emptyArray;
    
                    /**
                     * Creates a new GetRecommendedSimulatingSourceResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} GetRecommendedSimulatingSourceResponse instance
                     */
                    GetRecommendedSimulatingSourceResponse.create = function create(properties) {
                        return new GetRecommendedSimulatingSourceResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetRecommendedSimulatingSourceResponse message. Does not implicitly {@link palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceResponse} message GetRecommendedSimulatingSourceResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRecommendedSimulatingSourceResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.expectedWholeDayVisits != null && Object.hasOwnProperty.call(message, "expectedWholeDayVisits"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.expectedWholeDayVisits);
                        if (message.intervals != null && message.intervals.length)
                            for (var i = 0; i < message.intervals.length; ++i)
                                $root.palexy.streaming.v1.TimeRange.encode(message.intervals[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.recommendedSimulatingSources != null && message.recommendedSimulatingSources.length)
                            for (var i = 0; i < message.recommendedSimulatingSources.length; ++i)
                                $root.palexy.streaming.v1.RecommendedSimulatingSource.encode(message.recommendedSimulatingSources[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetRecommendedSimulatingSourceResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetRecommendedSimulatingSourceResponse} message GetRecommendedSimulatingSourceResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetRecommendedSimulatingSourceResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetRecommendedSimulatingSourceResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} GetRecommendedSimulatingSourceResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRecommendedSimulatingSourceResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetRecommendedSimulatingSourceResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.expectedWholeDayVisits = reader.int32();
                                break;
                            case 2:
                                if (!(message.intervals && message.intervals.length))
                                    message.intervals = [];
                                message.intervals.push($root.palexy.streaming.v1.TimeRange.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.recommendedSimulatingSources && message.recommendedSimulatingSources.length))
                                    message.recommendedSimulatingSources = [];
                                message.recommendedSimulatingSources.push($root.palexy.streaming.v1.RecommendedSimulatingSource.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetRecommendedSimulatingSourceResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} GetRecommendedSimulatingSourceResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetRecommendedSimulatingSourceResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetRecommendedSimulatingSourceResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetRecommendedSimulatingSourceResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.expectedWholeDayVisits != null && message.hasOwnProperty("expectedWholeDayVisits"))
                            if (!$util.isInteger(message.expectedWholeDayVisits))
                                return "expectedWholeDayVisits: integer expected";
                        if (message.intervals != null && message.hasOwnProperty("intervals")) {
                            if (!Array.isArray(message.intervals))
                                return "intervals: array expected";
                            for (var i = 0; i < message.intervals.length; ++i) {
                                var error = $root.palexy.streaming.v1.TimeRange.verify(message.intervals[i]);
                                if (error)
                                    return "intervals." + error;
                            }
                        }
                        if (message.recommendedSimulatingSources != null && message.hasOwnProperty("recommendedSimulatingSources")) {
                            if (!Array.isArray(message.recommendedSimulatingSources))
                                return "recommendedSimulatingSources: array expected";
                            for (var i = 0; i < message.recommendedSimulatingSources.length; ++i) {
                                var error = $root.palexy.streaming.v1.RecommendedSimulatingSource.verify(message.recommendedSimulatingSources[i]);
                                if (error)
                                    return "recommendedSimulatingSources." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetRecommendedSimulatingSourceResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} GetRecommendedSimulatingSourceResponse
                     */
                    GetRecommendedSimulatingSourceResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetRecommendedSimulatingSourceResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetRecommendedSimulatingSourceResponse();
                        if (object.expectedWholeDayVisits != null)
                            message.expectedWholeDayVisits = object.expectedWholeDayVisits | 0;
                        if (object.intervals) {
                            if (!Array.isArray(object.intervals))
                                throw TypeError(".palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.intervals: array expected");
                            message.intervals = [];
                            for (var i = 0; i < object.intervals.length; ++i) {
                                if (typeof object.intervals[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.intervals: object expected");
                                message.intervals[i] = $root.palexy.streaming.v1.TimeRange.fromObject(object.intervals[i]);
                            }
                        }
                        if (object.recommendedSimulatingSources) {
                            if (!Array.isArray(object.recommendedSimulatingSources))
                                throw TypeError(".palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.recommendedSimulatingSources: array expected");
                            message.recommendedSimulatingSources = [];
                            for (var i = 0; i < object.recommendedSimulatingSources.length; ++i) {
                                if (typeof object.recommendedSimulatingSources[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetRecommendedSimulatingSourceResponse.recommendedSimulatingSources: object expected");
                                message.recommendedSimulatingSources[i] = $root.palexy.streaming.v1.RecommendedSimulatingSource.fromObject(object.recommendedSimulatingSources[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetRecommendedSimulatingSourceResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @static
                     * @param {palexy.streaming.v1.GetRecommendedSimulatingSourceResponse} message GetRecommendedSimulatingSourceResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetRecommendedSimulatingSourceResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.intervals = [];
                            object.recommendedSimulatingSources = [];
                        }
                        if (options.defaults)
                            object.expectedWholeDayVisits = 0;
                        if (message.expectedWholeDayVisits != null && message.hasOwnProperty("expectedWholeDayVisits"))
                            object.expectedWholeDayVisits = message.expectedWholeDayVisits;
                        if (message.intervals && message.intervals.length) {
                            object.intervals = [];
                            for (var j = 0; j < message.intervals.length; ++j)
                                object.intervals[j] = $root.palexy.streaming.v1.TimeRange.toObject(message.intervals[j], options);
                        }
                        if (message.recommendedSimulatingSources && message.recommendedSimulatingSources.length) {
                            object.recommendedSimulatingSources = [];
                            for (var j = 0; j < message.recommendedSimulatingSources.length; ++j)
                                object.recommendedSimulatingSources[j] = $root.palexy.streaming.v1.RecommendedSimulatingSource.toObject(message.recommendedSimulatingSources[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetRecommendedSimulatingSourceResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetRecommendedSimulatingSourceResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetRecommendedSimulatingSourceResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetRecommendedSimulatingSourceResponse;
                })();
    
                v1.RecommendedSimulatingSource = (function() {
    
                    /**
                     * Properties of a RecommendedSimulatingSource.
                     * @memberof palexy.streaming.v1
                     * @interface IRecommendedSimulatingSource
                     * @property {number|null} [storeId] RecommendedSimulatingSource storeId
                     * @property {number|null} [dateId] RecommendedSimulatingSource dateId
                     * @property {number|null} [sourceTotalVisits] RecommendedSimulatingSource sourceTotalVisits
                     * @property {number|null} [finalTotalVisits] RecommendedSimulatingSource finalTotalVisits
                     * @property {number|null} [addedVisitsCount] RecommendedSimulatingSource addedVisitsCount
                     * @property {number|null} [removedVisitsCount] RecommendedSimulatingSource removedVisitsCount
                     * @property {number|null} [finalConversionRate] RecommendedSimulatingSource finalConversionRate
                     */
    
                    /**
                     * Constructs a new RecommendedSimulatingSource.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RecommendedSimulatingSource.
                     * @implements IRecommendedSimulatingSource
                     * @constructor
                     * @param {palexy.streaming.v1.IRecommendedSimulatingSource=} [properties] Properties to set
                     */
                    function RecommendedSimulatingSource(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RecommendedSimulatingSource storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RecommendedSimulatingSource dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.dateId = 0;
    
                    /**
                     * RecommendedSimulatingSource sourceTotalVisits.
                     * @member {number} sourceTotalVisits
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.sourceTotalVisits = 0;
    
                    /**
                     * RecommendedSimulatingSource finalTotalVisits.
                     * @member {number} finalTotalVisits
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.finalTotalVisits = 0;
    
                    /**
                     * RecommendedSimulatingSource addedVisitsCount.
                     * @member {number} addedVisitsCount
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.addedVisitsCount = 0;
    
                    /**
                     * RecommendedSimulatingSource removedVisitsCount.
                     * @member {number} removedVisitsCount
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.removedVisitsCount = 0;
    
                    /**
                     * RecommendedSimulatingSource finalConversionRate.
                     * @member {number} finalConversionRate
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     */
                    RecommendedSimulatingSource.prototype.finalConversionRate = 0;
    
                    /**
                     * Creates a new RecommendedSimulatingSource instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {palexy.streaming.v1.IRecommendedSimulatingSource=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RecommendedSimulatingSource} RecommendedSimulatingSource instance
                     */
                    RecommendedSimulatingSource.create = function create(properties) {
                        return new RecommendedSimulatingSource(properties);
                    };
    
                    /**
                     * Encodes the specified RecommendedSimulatingSource message. Does not implicitly {@link palexy.streaming.v1.RecommendedSimulatingSource.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {palexy.streaming.v1.IRecommendedSimulatingSource} message RecommendedSimulatingSource message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RecommendedSimulatingSource.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.sourceTotalVisits != null && Object.hasOwnProperty.call(message, "sourceTotalVisits"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sourceTotalVisits);
                        if (message.finalTotalVisits != null && Object.hasOwnProperty.call(message, "finalTotalVisits"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.finalTotalVisits);
                        if (message.addedVisitsCount != null && Object.hasOwnProperty.call(message, "addedVisitsCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.addedVisitsCount);
                        if (message.removedVisitsCount != null && Object.hasOwnProperty.call(message, "removedVisitsCount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.removedVisitsCount);
                        if (message.finalConversionRate != null && Object.hasOwnProperty.call(message, "finalConversionRate"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.finalConversionRate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RecommendedSimulatingSource message, length delimited. Does not implicitly {@link palexy.streaming.v1.RecommendedSimulatingSource.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {palexy.streaming.v1.IRecommendedSimulatingSource} message RecommendedSimulatingSource message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RecommendedSimulatingSource.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RecommendedSimulatingSource message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RecommendedSimulatingSource} RecommendedSimulatingSource
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RecommendedSimulatingSource.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RecommendedSimulatingSource();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.sourceTotalVisits = reader.int32();
                                break;
                            case 4:
                                message.finalTotalVisits = reader.int32();
                                break;
                            case 5:
                                message.addedVisitsCount = reader.int32();
                                break;
                            case 6:
                                message.removedVisitsCount = reader.int32();
                                break;
                            case 7:
                                message.finalConversionRate = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RecommendedSimulatingSource message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RecommendedSimulatingSource} RecommendedSimulatingSource
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RecommendedSimulatingSource.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RecommendedSimulatingSource message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RecommendedSimulatingSource.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.sourceTotalVisits != null && message.hasOwnProperty("sourceTotalVisits"))
                            if (!$util.isInteger(message.sourceTotalVisits))
                                return "sourceTotalVisits: integer expected";
                        if (message.finalTotalVisits != null && message.hasOwnProperty("finalTotalVisits"))
                            if (!$util.isInteger(message.finalTotalVisits))
                                return "finalTotalVisits: integer expected";
                        if (message.addedVisitsCount != null && message.hasOwnProperty("addedVisitsCount"))
                            if (!$util.isInteger(message.addedVisitsCount))
                                return "addedVisitsCount: integer expected";
                        if (message.removedVisitsCount != null && message.hasOwnProperty("removedVisitsCount"))
                            if (!$util.isInteger(message.removedVisitsCount))
                                return "removedVisitsCount: integer expected";
                        if (message.finalConversionRate != null && message.hasOwnProperty("finalConversionRate"))
                            if (typeof message.finalConversionRate !== "number")
                                return "finalConversionRate: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a RecommendedSimulatingSource message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RecommendedSimulatingSource} RecommendedSimulatingSource
                     */
                    RecommendedSimulatingSource.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RecommendedSimulatingSource)
                            return object;
                        var message = new $root.palexy.streaming.v1.RecommendedSimulatingSource();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.sourceTotalVisits != null)
                            message.sourceTotalVisits = object.sourceTotalVisits | 0;
                        if (object.finalTotalVisits != null)
                            message.finalTotalVisits = object.finalTotalVisits | 0;
                        if (object.addedVisitsCount != null)
                            message.addedVisitsCount = object.addedVisitsCount | 0;
                        if (object.removedVisitsCount != null)
                            message.removedVisitsCount = object.removedVisitsCount | 0;
                        if (object.finalConversionRate != null)
                            message.finalConversionRate = Number(object.finalConversionRate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RecommendedSimulatingSource message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @static
                     * @param {palexy.streaming.v1.RecommendedSimulatingSource} message RecommendedSimulatingSource
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RecommendedSimulatingSource.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.sourceTotalVisits = 0;
                            object.finalTotalVisits = 0;
                            object.addedVisitsCount = 0;
                            object.removedVisitsCount = 0;
                            object.finalConversionRate = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.sourceTotalVisits != null && message.hasOwnProperty("sourceTotalVisits"))
                            object.sourceTotalVisits = message.sourceTotalVisits;
                        if (message.finalTotalVisits != null && message.hasOwnProperty("finalTotalVisits"))
                            object.finalTotalVisits = message.finalTotalVisits;
                        if (message.addedVisitsCount != null && message.hasOwnProperty("addedVisitsCount"))
                            object.addedVisitsCount = message.addedVisitsCount;
                        if (message.removedVisitsCount != null && message.hasOwnProperty("removedVisitsCount"))
                            object.removedVisitsCount = message.removedVisitsCount;
                        if (message.finalConversionRate != null && message.hasOwnProperty("finalConversionRate"))
                            object.finalConversionRate = options.json && !isFinite(message.finalConversionRate) ? String(message.finalConversionRate) : message.finalConversionRate;
                        return object;
                    };
    
                    /**
                     * Converts this RecommendedSimulatingSource to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RecommendedSimulatingSource
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RecommendedSimulatingSource.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RecommendedSimulatingSource;
                })();
    
                v1.SimulateRawICADataRequest = (function() {
    
                    /**
                     * Properties of a SimulateRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISimulateRawICADataRequest
                     * @property {number|null} [rawIcaConsistencyId] SimulateRawICADataRequest rawIcaConsistencyId
                     * @property {number|null} [sourceStoreId] SimulateRawICADataRequest sourceStoreId
                     * @property {number|null} [sourceDateId] SimulateRawICADataRequest sourceDateId
                     * @property {Array.<palexy.streaming.v1.ITimeRange>|null} [intervals] SimulateRawICADataRequest intervals
                     * @property {boolean|null} [dryRun] SimulateRawICADataRequest dryRun
                     * @property {number|null} [editorAccountId] SimulateRawICADataRequest editorAccountId
                     * @property {Array.<string>|null} [cameraIds] SimulateRawICADataRequest cameraIds
                     */
    
                    /**
                     * Constructs a new SimulateRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SimulateRawICADataRequest.
                     * @implements ISimulateRawICADataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest=} [properties] Properties to set
                     */
                    function SimulateRawICADataRequest(properties) {
                        this.intervals = [];
                        this.cameraIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SimulateRawICADataRequest rawIcaConsistencyId.
                     * @member {number} rawIcaConsistencyId
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.rawIcaConsistencyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SimulateRawICADataRequest sourceStoreId.
                     * @member {number} sourceStoreId
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.sourceStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SimulateRawICADataRequest sourceDateId.
                     * @member {number} sourceDateId
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.sourceDateId = 0;
    
                    /**
                     * SimulateRawICADataRequest intervals.
                     * @member {Array.<palexy.streaming.v1.ITimeRange>} intervals
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.intervals = $util.emptyArray;
    
                    /**
                     * SimulateRawICADataRequest dryRun.
                     * @member {boolean} dryRun
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.dryRun = false;
    
                    /**
                     * SimulateRawICADataRequest editorAccountId.
                     * @member {number} editorAccountId
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.editorAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SimulateRawICADataRequest cameraIds.
                     * @member {Array.<string>} cameraIds
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     */
                    SimulateRawICADataRequest.prototype.cameraIds = $util.emptyArray;
    
                    /**
                     * Creates a new SimulateRawICADataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SimulateRawICADataRequest} SimulateRawICADataRequest instance
                     */
                    SimulateRawICADataRequest.create = function create(properties) {
                        return new SimulateRawICADataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SimulateRawICADataRequest message. Does not implicitly {@link palexy.streaming.v1.SimulateRawICADataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest} message SimulateRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SimulateRawICADataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaConsistencyId != null && Object.hasOwnProperty.call(message, "rawIcaConsistencyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.rawIcaConsistencyId);
                        if (message.sourceStoreId != null && Object.hasOwnProperty.call(message, "sourceStoreId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.sourceStoreId);
                        if (message.sourceDateId != null && Object.hasOwnProperty.call(message, "sourceDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.sourceDateId);
                        if (message.intervals != null && message.intervals.length)
                            for (var i = 0; i < message.intervals.length; ++i)
                                $root.palexy.streaming.v1.TimeRange.encode(message.intervals[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.dryRun != null && Object.hasOwnProperty.call(message, "dryRun"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.dryRun);
                        if (message.editorAccountId != null && Object.hasOwnProperty.call(message, "editorAccountId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.editorAccountId);
                        if (message.cameraIds != null && message.cameraIds.length)
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).string(message.cameraIds[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SimulateRawICADataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SimulateRawICADataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataRequest} message SimulateRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SimulateRawICADataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SimulateRawICADataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SimulateRawICADataRequest} SimulateRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SimulateRawICADataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SimulateRawICADataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaConsistencyId = reader.int64();
                                break;
                            case 2:
                                message.sourceStoreId = reader.int64();
                                break;
                            case 3:
                                message.sourceDateId = reader.int32();
                                break;
                            case 4:
                                if (!(message.intervals && message.intervals.length))
                                    message.intervals = [];
                                message.intervals.push($root.palexy.streaming.v1.TimeRange.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.dryRun = reader.bool();
                                break;
                            case 6:
                                message.editorAccountId = reader.int64();
                                break;
                            case 7:
                                if (!(message.cameraIds && message.cameraIds.length))
                                    message.cameraIds = [];
                                message.cameraIds.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SimulateRawICADataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SimulateRawICADataRequest} SimulateRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SimulateRawICADataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SimulateRawICADataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SimulateRawICADataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (!$util.isInteger(message.rawIcaConsistencyId) && !(message.rawIcaConsistencyId && $util.isInteger(message.rawIcaConsistencyId.low) && $util.isInteger(message.rawIcaConsistencyId.high)))
                                return "rawIcaConsistencyId: integer|Long expected";
                        if (message.sourceStoreId != null && message.hasOwnProperty("sourceStoreId"))
                            if (!$util.isInteger(message.sourceStoreId) && !(message.sourceStoreId && $util.isInteger(message.sourceStoreId.low) && $util.isInteger(message.sourceStoreId.high)))
                                return "sourceStoreId: integer|Long expected";
                        if (message.sourceDateId != null && message.hasOwnProperty("sourceDateId"))
                            if (!$util.isInteger(message.sourceDateId))
                                return "sourceDateId: integer expected";
                        if (message.intervals != null && message.hasOwnProperty("intervals")) {
                            if (!Array.isArray(message.intervals))
                                return "intervals: array expected";
                            for (var i = 0; i < message.intervals.length; ++i) {
                                var error = $root.palexy.streaming.v1.TimeRange.verify(message.intervals[i]);
                                if (error)
                                    return "intervals." + error;
                            }
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            if (typeof message.dryRun !== "boolean")
                                return "dryRun: boolean expected";
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (!$util.isInteger(message.editorAccountId) && !(message.editorAccountId && $util.isInteger(message.editorAccountId.low) && $util.isInteger(message.editorAccountId.high)))
                                return "editorAccountId: integer|Long expected";
                        if (message.cameraIds != null && message.hasOwnProperty("cameraIds")) {
                            if (!Array.isArray(message.cameraIds))
                                return "cameraIds: array expected";
                            for (var i = 0; i < message.cameraIds.length; ++i)
                                if (!$util.isString(message.cameraIds[i]))
                                    return "cameraIds: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SimulateRawICADataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SimulateRawICADataRequest} SimulateRawICADataRequest
                     */
                    SimulateRawICADataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SimulateRawICADataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SimulateRawICADataRequest();
                        if (object.rawIcaConsistencyId != null)
                            if ($util.Long)
                                (message.rawIcaConsistencyId = $util.Long.fromValue(object.rawIcaConsistencyId)).unsigned = false;
                            else if (typeof object.rawIcaConsistencyId === "string")
                                message.rawIcaConsistencyId = parseInt(object.rawIcaConsistencyId, 10);
                            else if (typeof object.rawIcaConsistencyId === "number")
                                message.rawIcaConsistencyId = object.rawIcaConsistencyId;
                            else if (typeof object.rawIcaConsistencyId === "object")
                                message.rawIcaConsistencyId = new $util.LongBits(object.rawIcaConsistencyId.low >>> 0, object.rawIcaConsistencyId.high >>> 0).toNumber();
                        if (object.sourceStoreId != null)
                            if ($util.Long)
                                (message.sourceStoreId = $util.Long.fromValue(object.sourceStoreId)).unsigned = false;
                            else if (typeof object.sourceStoreId === "string")
                                message.sourceStoreId = parseInt(object.sourceStoreId, 10);
                            else if (typeof object.sourceStoreId === "number")
                                message.sourceStoreId = object.sourceStoreId;
                            else if (typeof object.sourceStoreId === "object")
                                message.sourceStoreId = new $util.LongBits(object.sourceStoreId.low >>> 0, object.sourceStoreId.high >>> 0).toNumber();
                        if (object.sourceDateId != null)
                            message.sourceDateId = object.sourceDateId | 0;
                        if (object.intervals) {
                            if (!Array.isArray(object.intervals))
                                throw TypeError(".palexy.streaming.v1.SimulateRawICADataRequest.intervals: array expected");
                            message.intervals = [];
                            for (var i = 0; i < object.intervals.length; ++i) {
                                if (typeof object.intervals[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.SimulateRawICADataRequest.intervals: object expected");
                                message.intervals[i] = $root.palexy.streaming.v1.TimeRange.fromObject(object.intervals[i]);
                            }
                        }
                        if (object.dryRun != null)
                            message.dryRun = Boolean(object.dryRun);
                        if (object.editorAccountId != null)
                            if ($util.Long)
                                (message.editorAccountId = $util.Long.fromValue(object.editorAccountId)).unsigned = false;
                            else if (typeof object.editorAccountId === "string")
                                message.editorAccountId = parseInt(object.editorAccountId, 10);
                            else if (typeof object.editorAccountId === "number")
                                message.editorAccountId = object.editorAccountId;
                            else if (typeof object.editorAccountId === "object")
                                message.editorAccountId = new $util.LongBits(object.editorAccountId.low >>> 0, object.editorAccountId.high >>> 0).toNumber();
                        if (object.cameraIds) {
                            if (!Array.isArray(object.cameraIds))
                                throw TypeError(".palexy.streaming.v1.SimulateRawICADataRequest.cameraIds: array expected");
                            message.cameraIds = [];
                            for (var i = 0; i < object.cameraIds.length; ++i)
                                message.cameraIds[i] = String(object.cameraIds[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SimulateRawICADataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.SimulateRawICADataRequest} message SimulateRawICADataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SimulateRawICADataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.intervals = [];
                            object.cameraIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.rawIcaConsistencyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.rawIcaConsistencyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sourceStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sourceStoreId = options.longs === String ? "0" : 0;
                            object.sourceDateId = 0;
                            object.dryRun = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.editorAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.editorAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (typeof message.rawIcaConsistencyId === "number")
                                object.rawIcaConsistencyId = options.longs === String ? String(message.rawIcaConsistencyId) : message.rawIcaConsistencyId;
                            else
                                object.rawIcaConsistencyId = options.longs === String ? $util.Long.prototype.toString.call(message.rawIcaConsistencyId) : options.longs === Number ? new $util.LongBits(message.rawIcaConsistencyId.low >>> 0, message.rawIcaConsistencyId.high >>> 0).toNumber() : message.rawIcaConsistencyId;
                        if (message.sourceStoreId != null && message.hasOwnProperty("sourceStoreId"))
                            if (typeof message.sourceStoreId === "number")
                                object.sourceStoreId = options.longs === String ? String(message.sourceStoreId) : message.sourceStoreId;
                            else
                                object.sourceStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.sourceStoreId) : options.longs === Number ? new $util.LongBits(message.sourceStoreId.low >>> 0, message.sourceStoreId.high >>> 0).toNumber() : message.sourceStoreId;
                        if (message.sourceDateId != null && message.hasOwnProperty("sourceDateId"))
                            object.sourceDateId = message.sourceDateId;
                        if (message.intervals && message.intervals.length) {
                            object.intervals = [];
                            for (var j = 0; j < message.intervals.length; ++j)
                                object.intervals[j] = $root.palexy.streaming.v1.TimeRange.toObject(message.intervals[j], options);
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            object.dryRun = message.dryRun;
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (typeof message.editorAccountId === "number")
                                object.editorAccountId = options.longs === String ? String(message.editorAccountId) : message.editorAccountId;
                            else
                                object.editorAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.editorAccountId) : options.longs === Number ? new $util.LongBits(message.editorAccountId.low >>> 0, message.editorAccountId.high >>> 0).toNumber() : message.editorAccountId;
                        if (message.cameraIds && message.cameraIds.length) {
                            object.cameraIds = [];
                            for (var j = 0; j < message.cameraIds.length; ++j)
                                object.cameraIds[j] = message.cameraIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SimulateRawICADataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SimulateRawICADataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SimulateRawICADataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SimulateRawICADataRequest;
                })();
    
                v1.SimulateRawICADataResponse = (function() {
    
                    /**
                     * Properties of a SimulateRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISimulateRawICADataResponse
                     * @property {number|null} [sourceTotalVisits] SimulateRawICADataResponse sourceTotalVisits
                     * @property {number|null} [finalTotalVisits] SimulateRawICADataResponse finalTotalVisits
                     * @property {number|null} [addedVisitsCount] SimulateRawICADataResponse addedVisitsCount
                     * @property {number|null} [removedVisitsCount] SimulateRawICADataResponse removedVisitsCount
                     * @property {number|null} [finalConversionRate] SimulateRawICADataResponse finalConversionRate
                     */
    
                    /**
                     * Constructs a new SimulateRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SimulateRawICADataResponse.
                     * @implements ISimulateRawICADataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISimulateRawICADataResponse=} [properties] Properties to set
                     */
                    function SimulateRawICADataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SimulateRawICADataResponse sourceTotalVisits.
                     * @member {number} sourceTotalVisits
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     */
                    SimulateRawICADataResponse.prototype.sourceTotalVisits = 0;
    
                    /**
                     * SimulateRawICADataResponse finalTotalVisits.
                     * @member {number} finalTotalVisits
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     */
                    SimulateRawICADataResponse.prototype.finalTotalVisits = 0;
    
                    /**
                     * SimulateRawICADataResponse addedVisitsCount.
                     * @member {number} addedVisitsCount
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     */
                    SimulateRawICADataResponse.prototype.addedVisitsCount = 0;
    
                    /**
                     * SimulateRawICADataResponse removedVisitsCount.
                     * @member {number} removedVisitsCount
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     */
                    SimulateRawICADataResponse.prototype.removedVisitsCount = 0;
    
                    /**
                     * SimulateRawICADataResponse finalConversionRate.
                     * @member {number} finalConversionRate
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     */
                    SimulateRawICADataResponse.prototype.finalConversionRate = 0;
    
                    /**
                     * Creates a new SimulateRawICADataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SimulateRawICADataResponse} SimulateRawICADataResponse instance
                     */
                    SimulateRawICADataResponse.create = function create(properties) {
                        return new SimulateRawICADataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SimulateRawICADataResponse message. Does not implicitly {@link palexy.streaming.v1.SimulateRawICADataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataResponse} message SimulateRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SimulateRawICADataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sourceTotalVisits != null && Object.hasOwnProperty.call(message, "sourceTotalVisits"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.sourceTotalVisits);
                        if (message.finalTotalVisits != null && Object.hasOwnProperty.call(message, "finalTotalVisits"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.finalTotalVisits);
                        if (message.addedVisitsCount != null && Object.hasOwnProperty.call(message, "addedVisitsCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.addedVisitsCount);
                        if (message.removedVisitsCount != null && Object.hasOwnProperty.call(message, "removedVisitsCount"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.removedVisitsCount);
                        if (message.finalConversionRate != null && Object.hasOwnProperty.call(message, "finalConversionRate"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.finalConversionRate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SimulateRawICADataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SimulateRawICADataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.ISimulateRawICADataResponse} message SimulateRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SimulateRawICADataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SimulateRawICADataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SimulateRawICADataResponse} SimulateRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SimulateRawICADataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SimulateRawICADataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sourceTotalVisits = reader.int32();
                                break;
                            case 2:
                                message.finalTotalVisits = reader.int32();
                                break;
                            case 3:
                                message.addedVisitsCount = reader.int32();
                                break;
                            case 4:
                                message.removedVisitsCount = reader.int32();
                                break;
                            case 5:
                                message.finalConversionRate = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SimulateRawICADataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SimulateRawICADataResponse} SimulateRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SimulateRawICADataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SimulateRawICADataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SimulateRawICADataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sourceTotalVisits != null && message.hasOwnProperty("sourceTotalVisits"))
                            if (!$util.isInteger(message.sourceTotalVisits))
                                return "sourceTotalVisits: integer expected";
                        if (message.finalTotalVisits != null && message.hasOwnProperty("finalTotalVisits"))
                            if (!$util.isInteger(message.finalTotalVisits))
                                return "finalTotalVisits: integer expected";
                        if (message.addedVisitsCount != null && message.hasOwnProperty("addedVisitsCount"))
                            if (!$util.isInteger(message.addedVisitsCount))
                                return "addedVisitsCount: integer expected";
                        if (message.removedVisitsCount != null && message.hasOwnProperty("removedVisitsCount"))
                            if (!$util.isInteger(message.removedVisitsCount))
                                return "removedVisitsCount: integer expected";
                        if (message.finalConversionRate != null && message.hasOwnProperty("finalConversionRate"))
                            if (typeof message.finalConversionRate !== "number")
                                return "finalConversionRate: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a SimulateRawICADataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SimulateRawICADataResponse} SimulateRawICADataResponse
                     */
                    SimulateRawICADataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SimulateRawICADataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SimulateRawICADataResponse();
                        if (object.sourceTotalVisits != null)
                            message.sourceTotalVisits = object.sourceTotalVisits | 0;
                        if (object.finalTotalVisits != null)
                            message.finalTotalVisits = object.finalTotalVisits | 0;
                        if (object.addedVisitsCount != null)
                            message.addedVisitsCount = object.addedVisitsCount | 0;
                        if (object.removedVisitsCount != null)
                            message.removedVisitsCount = object.removedVisitsCount | 0;
                        if (object.finalConversionRate != null)
                            message.finalConversionRate = Number(object.finalConversionRate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SimulateRawICADataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.SimulateRawICADataResponse} message SimulateRawICADataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SimulateRawICADataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sourceTotalVisits = 0;
                            object.finalTotalVisits = 0;
                            object.addedVisitsCount = 0;
                            object.removedVisitsCount = 0;
                            object.finalConversionRate = 0;
                        }
                        if (message.sourceTotalVisits != null && message.hasOwnProperty("sourceTotalVisits"))
                            object.sourceTotalVisits = message.sourceTotalVisits;
                        if (message.finalTotalVisits != null && message.hasOwnProperty("finalTotalVisits"))
                            object.finalTotalVisits = message.finalTotalVisits;
                        if (message.addedVisitsCount != null && message.hasOwnProperty("addedVisitsCount"))
                            object.addedVisitsCount = message.addedVisitsCount;
                        if (message.removedVisitsCount != null && message.hasOwnProperty("removedVisitsCount"))
                            object.removedVisitsCount = message.removedVisitsCount;
                        if (message.finalConversionRate != null && message.hasOwnProperty("finalConversionRate"))
                            object.finalConversionRate = options.json && !isFinite(message.finalConversionRate) ? String(message.finalConversionRate) : message.finalConversionRate;
                        return object;
                    };
    
                    /**
                     * Converts this SimulateRawICADataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SimulateRawICADataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SimulateRawICADataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SimulateRawICADataResponse;
                })();
    
                v1.RevertSimulatedRawICADataRequest = (function() {
    
                    /**
                     * Properties of a RevertSimulatedRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IRevertSimulatedRawICADataRequest
                     * @property {number|null} [rawIcaConsistencyId] RevertSimulatedRawICADataRequest rawIcaConsistencyId
                     * @property {number|null} [editorAccountId] RevertSimulatedRawICADataRequest editorAccountId
                     */
    
                    /**
                     * Constructs a new RevertSimulatedRawICADataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RevertSimulatedRawICADataRequest.
                     * @implements IRevertSimulatedRawICADataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest=} [properties] Properties to set
                     */
                    function RevertSimulatedRawICADataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RevertSimulatedRawICADataRequest rawIcaConsistencyId.
                     * @member {number} rawIcaConsistencyId
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @instance
                     */
                    RevertSimulatedRawICADataRequest.prototype.rawIcaConsistencyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RevertSimulatedRawICADataRequest editorAccountId.
                     * @member {number} editorAccountId
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @instance
                     */
                    RevertSimulatedRawICADataRequest.prototype.editorAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new RevertSimulatedRawICADataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataRequest} RevertSimulatedRawICADataRequest instance
                     */
                    RevertSimulatedRawICADataRequest.create = function create(properties) {
                        return new RevertSimulatedRawICADataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RevertSimulatedRawICADataRequest message. Does not implicitly {@link palexy.streaming.v1.RevertSimulatedRawICADataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest} message RevertSimulatedRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RevertSimulatedRawICADataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rawIcaConsistencyId != null && Object.hasOwnProperty.call(message, "rawIcaConsistencyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.rawIcaConsistencyId);
                        if (message.editorAccountId != null && Object.hasOwnProperty.call(message, "editorAccountId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.editorAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RevertSimulatedRawICADataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.RevertSimulatedRawICADataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataRequest} message RevertSimulatedRawICADataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RevertSimulatedRawICADataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RevertSimulatedRawICADataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataRequest} RevertSimulatedRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RevertSimulatedRawICADataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RevertSimulatedRawICADataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rawIcaConsistencyId = reader.int64();
                                break;
                            case 2:
                                message.editorAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RevertSimulatedRawICADataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataRequest} RevertSimulatedRawICADataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RevertSimulatedRawICADataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RevertSimulatedRawICADataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RevertSimulatedRawICADataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (!$util.isInteger(message.rawIcaConsistencyId) && !(message.rawIcaConsistencyId && $util.isInteger(message.rawIcaConsistencyId.low) && $util.isInteger(message.rawIcaConsistencyId.high)))
                                return "rawIcaConsistencyId: integer|Long expected";
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (!$util.isInteger(message.editorAccountId) && !(message.editorAccountId && $util.isInteger(message.editorAccountId.low) && $util.isInteger(message.editorAccountId.high)))
                                return "editorAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a RevertSimulatedRawICADataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataRequest} RevertSimulatedRawICADataRequest
                     */
                    RevertSimulatedRawICADataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RevertSimulatedRawICADataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.RevertSimulatedRawICADataRequest();
                        if (object.rawIcaConsistencyId != null)
                            if ($util.Long)
                                (message.rawIcaConsistencyId = $util.Long.fromValue(object.rawIcaConsistencyId)).unsigned = false;
                            else if (typeof object.rawIcaConsistencyId === "string")
                                message.rawIcaConsistencyId = parseInt(object.rawIcaConsistencyId, 10);
                            else if (typeof object.rawIcaConsistencyId === "number")
                                message.rawIcaConsistencyId = object.rawIcaConsistencyId;
                            else if (typeof object.rawIcaConsistencyId === "object")
                                message.rawIcaConsistencyId = new $util.LongBits(object.rawIcaConsistencyId.low >>> 0, object.rawIcaConsistencyId.high >>> 0).toNumber();
                        if (object.editorAccountId != null)
                            if ($util.Long)
                                (message.editorAccountId = $util.Long.fromValue(object.editorAccountId)).unsigned = false;
                            else if (typeof object.editorAccountId === "string")
                                message.editorAccountId = parseInt(object.editorAccountId, 10);
                            else if (typeof object.editorAccountId === "number")
                                message.editorAccountId = object.editorAccountId;
                            else if (typeof object.editorAccountId === "object")
                                message.editorAccountId = new $util.LongBits(object.editorAccountId.low >>> 0, object.editorAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RevertSimulatedRawICADataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @static
                     * @param {palexy.streaming.v1.RevertSimulatedRawICADataRequest} message RevertSimulatedRawICADataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RevertSimulatedRawICADataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.rawIcaConsistencyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.rawIcaConsistencyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.editorAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.editorAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.rawIcaConsistencyId != null && message.hasOwnProperty("rawIcaConsistencyId"))
                            if (typeof message.rawIcaConsistencyId === "number")
                                object.rawIcaConsistencyId = options.longs === String ? String(message.rawIcaConsistencyId) : message.rawIcaConsistencyId;
                            else
                                object.rawIcaConsistencyId = options.longs === String ? $util.Long.prototype.toString.call(message.rawIcaConsistencyId) : options.longs === Number ? new $util.LongBits(message.rawIcaConsistencyId.low >>> 0, message.rawIcaConsistencyId.high >>> 0).toNumber() : message.rawIcaConsistencyId;
                        if (message.editorAccountId != null && message.hasOwnProperty("editorAccountId"))
                            if (typeof message.editorAccountId === "number")
                                object.editorAccountId = options.longs === String ? String(message.editorAccountId) : message.editorAccountId;
                            else
                                object.editorAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.editorAccountId) : options.longs === Number ? new $util.LongBits(message.editorAccountId.low >>> 0, message.editorAccountId.high >>> 0).toNumber() : message.editorAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this RevertSimulatedRawICADataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RevertSimulatedRawICADataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RevertSimulatedRawICADataRequest;
                })();
    
                v1.RevertSimulatedRawICADataResponse = (function() {
    
                    /**
                     * Properties of a RevertSimulatedRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IRevertSimulatedRawICADataResponse
                     * @property {palexy.streaming.v1.RawICAConsistency.State|null} [newState] RevertSimulatedRawICADataResponse newState
                     */
    
                    /**
                     * Constructs a new RevertSimulatedRawICADataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RevertSimulatedRawICADataResponse.
                     * @implements IRevertSimulatedRawICADataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataResponse=} [properties] Properties to set
                     */
                    function RevertSimulatedRawICADataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RevertSimulatedRawICADataResponse newState.
                     * @member {palexy.streaming.v1.RawICAConsistency.State} newState
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @instance
                     */
                    RevertSimulatedRawICADataResponse.prototype.newState = 0;
    
                    /**
                     * Creates a new RevertSimulatedRawICADataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataResponse} RevertSimulatedRawICADataResponse instance
                     */
                    RevertSimulatedRawICADataResponse.create = function create(properties) {
                        return new RevertSimulatedRawICADataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified RevertSimulatedRawICADataResponse message. Does not implicitly {@link palexy.streaming.v1.RevertSimulatedRawICADataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataResponse} message RevertSimulatedRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RevertSimulatedRawICADataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.newState != null && Object.hasOwnProperty.call(message, "newState"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.newState);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RevertSimulatedRawICADataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.RevertSimulatedRawICADataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.IRevertSimulatedRawICADataResponse} message RevertSimulatedRawICADataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RevertSimulatedRawICADataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RevertSimulatedRawICADataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataResponse} RevertSimulatedRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RevertSimulatedRawICADataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RevertSimulatedRawICADataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.newState = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RevertSimulatedRawICADataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataResponse} RevertSimulatedRawICADataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RevertSimulatedRawICADataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RevertSimulatedRawICADataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RevertSimulatedRawICADataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            switch (message.newState) {
                            default:
                                return "newState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a RevertSimulatedRawICADataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RevertSimulatedRawICADataResponse} RevertSimulatedRawICADataResponse
                     */
                    RevertSimulatedRawICADataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RevertSimulatedRawICADataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.RevertSimulatedRawICADataResponse();
                        switch (object.newState) {
                        case "UNKNOWN":
                        case 0:
                            message.newState = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.newState = 1;
                            break;
                        case "CONSIDERABLE_LOSS":
                        case 2:
                            message.newState = 2;
                            break;
                        case "CONSIDERABLE_LOSS_BUT_INSIGNIFICANT":
                        case 3:
                            message.newState = 3;
                            break;
                        case "SIMULATED":
                        case 4:
                            message.newState = 4;
                            break;
                        case "INVALID":
                        case 5:
                            message.newState = 5;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RevertSimulatedRawICADataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @static
                     * @param {palexy.streaming.v1.RevertSimulatedRawICADataResponse} message RevertSimulatedRawICADataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RevertSimulatedRawICADataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.newState = options.enums === String ? "UNKNOWN" : 0;
                        if (message.newState != null && message.hasOwnProperty("newState"))
                            object.newState = options.enums === String ? $root.palexy.streaming.v1.RawICAConsistency.State[message.newState] : message.newState;
                        return object;
                    };
    
                    /**
                     * Converts this RevertSimulatedRawICADataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RevertSimulatedRawICADataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RevertSimulatedRawICADataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RevertSimulatedRawICADataResponse;
                })();
    
                v1.ReportService = (function() {
    
                    /**
                     * Constructs a new ReportService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ReportService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ReportService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ReportService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ReportService;
    
                    /**
                     * Creates new ReportService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ReportService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ReportService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ReportService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ReportService#getReport}.
                     * @memberof palexy.streaming.v1.ReportService
                     * @typedef GetReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetReportResponse} [response] GetReportResponse
                     */
    
                    /**
                     * Calls GetReport.
                     * @function getReport
                     * @memberof palexy.streaming.v1.ReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetReportRequest} request GetReportRequest message or plain object
                     * @param {palexy.streaming.v1.ReportService.GetReportCallback} callback Node-style callback called with the error, if any, and GetReportResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ReportService.prototype.getReport = function getReport(request, callback) {
                        return this.rpcCall(getReport, $root.palexy.streaming.v1.GetReportRequest, $root.palexy.streaming.v1.GetReportResponse, request, callback);
                    }, "name", { value: "GetReport" });
    
                    /**
                     * Calls GetReport.
                     * @function getReport
                     * @memberof palexy.streaming.v1.ReportService
                     * @instance
                     * @param {palexy.streaming.v1.IGetReportRequest} request GetReportRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetReportResponse>} Promise
                     * @variation 2
                     */
    
                    return ReportService;
                })();
    
                v1.GetReportRequest = (function() {
    
                    /**
                     * Properties of a GetReportRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetReportRequest
                     * @property {Array.<string>|null} [dates] GetReportRequest dates
                     * @property {Array.<string>|null} [dimensions] GetReportRequest dimensions
                     * @property {Array.<string>|null} [metrics] GetReportRequest metrics
                     * @property {Array.<string>|null} [sorts] GetReportRequest sorts
                     * @property {palexy.streaming.v1.GetReportRequest.IFilter|null} [filter] GetReportRequest filter
                     * @property {boolean|null} [showTotals] GetReportRequest showTotals
                     * @property {boolean|null} [includeTargets] GetReportRequest includeTargets
                     */
    
                    /**
                     * Constructs a new GetReportRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetReportRequest.
                     * @implements IGetReportRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetReportRequest=} [properties] Properties to set
                     */
                    function GetReportRequest(properties) {
                        this.dates = [];
                        this.dimensions = [];
                        this.metrics = [];
                        this.sorts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetReportRequest dates.
                     * @member {Array.<string>} dates
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.dates = $util.emptyArray;
    
                    /**
                     * GetReportRequest dimensions.
                     * @member {Array.<string>} dimensions
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.dimensions = $util.emptyArray;
    
                    /**
                     * GetReportRequest metrics.
                     * @member {Array.<string>} metrics
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.metrics = $util.emptyArray;
    
                    /**
                     * GetReportRequest sorts.
                     * @member {Array.<string>} sorts
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.sorts = $util.emptyArray;
    
                    /**
                     * GetReportRequest filter.
                     * @member {palexy.streaming.v1.GetReportRequest.IFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.filter = null;
    
                    /**
                     * GetReportRequest showTotals.
                     * @member {boolean} showTotals
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.showTotals = false;
    
                    /**
                     * GetReportRequest includeTargets.
                     * @member {boolean} includeTargets
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     */
                    GetReportRequest.prototype.includeTargets = false;
    
                    /**
                     * Creates a new GetReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetReportRequest} GetReportRequest instance
                     */
                    GetReportRequest.create = function create(properties) {
                        return new GetReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetReportRequest message. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportRequest} message GetReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dates != null && message.dates.length)
                            for (var i = 0; i < message.dates.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dates[i]);
                        if (message.dimensions != null && message.dimensions.length)
                            for (var i = 0; i < message.dimensions.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dimensions[i]);
                        if (message.metrics != null && message.metrics.length)
                            for (var i = 0; i < message.metrics.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.metrics[i]);
                        if (message.sorts != null && message.sorts.length)
                            for (var i = 0; i < message.sorts.length; ++i)
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.sorts[i]);
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.GetReportRequest.Filter.encode(message.filter, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.showTotals != null && Object.hasOwnProperty.call(message, "showTotals"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.showTotals);
                        if (message.includeTargets != null && Object.hasOwnProperty.call(message, "includeTargets"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeTargets);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetReportRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetReportRequest} message GetReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetReportRequest} GetReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dates && message.dates.length))
                                    message.dates = [];
                                message.dates.push(reader.string());
                                break;
                            case 2:
                                if (!(message.dimensions && message.dimensions.length))
                                    message.dimensions = [];
                                message.dimensions.push(reader.string());
                                break;
                            case 3:
                                if (!(message.metrics && message.metrics.length))
                                    message.metrics = [];
                                message.metrics.push(reader.string());
                                break;
                            case 4:
                                if (!(message.sorts && message.sorts.length))
                                    message.sorts = [];
                                message.sorts.push(reader.string());
                                break;
                            case 5:
                                message.filter = $root.palexy.streaming.v1.GetReportRequest.Filter.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.showTotals = reader.bool();
                                break;
                            case 7:
                                message.includeTargets = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetReportRequest} GetReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetReportRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dates != null && message.hasOwnProperty("dates")) {
                            if (!Array.isArray(message.dates))
                                return "dates: array expected";
                            for (var i = 0; i < message.dates.length; ++i)
                                if (!$util.isString(message.dates[i]))
                                    return "dates: string[] expected";
                        }
                        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                            if (!Array.isArray(message.dimensions))
                                return "dimensions: array expected";
                            for (var i = 0; i < message.dimensions.length; ++i)
                                if (!$util.isString(message.dimensions[i]))
                                    return "dimensions: string[] expected";
                        }
                        if (message.metrics != null && message.hasOwnProperty("metrics")) {
                            if (!Array.isArray(message.metrics))
                                return "metrics: array expected";
                            for (var i = 0; i < message.metrics.length; ++i)
                                if (!$util.isString(message.metrics[i]))
                                    return "metrics: string[] expected";
                        }
                        if (message.sorts != null && message.hasOwnProperty("sorts")) {
                            if (!Array.isArray(message.sorts))
                                return "sorts: array expected";
                            for (var i = 0; i < message.sorts.length; ++i)
                                if (!$util.isString(message.sorts[i]))
                                    return "sorts: string[] expected";
                        }
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.GetReportRequest.Filter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.showTotals != null && message.hasOwnProperty("showTotals"))
                            if (typeof message.showTotals !== "boolean")
                                return "showTotals: boolean expected";
                        if (message.includeTargets != null && message.hasOwnProperty("includeTargets"))
                            if (typeof message.includeTargets !== "boolean")
                                return "includeTargets: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetReportRequest} GetReportRequest
                     */
                    GetReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetReportRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetReportRequest();
                        if (object.dates) {
                            if (!Array.isArray(object.dates))
                                throw TypeError(".palexy.streaming.v1.GetReportRequest.dates: array expected");
                            message.dates = [];
                            for (var i = 0; i < object.dates.length; ++i)
                                message.dates[i] = String(object.dates[i]);
                        }
                        if (object.dimensions) {
                            if (!Array.isArray(object.dimensions))
                                throw TypeError(".palexy.streaming.v1.GetReportRequest.dimensions: array expected");
                            message.dimensions = [];
                            for (var i = 0; i < object.dimensions.length; ++i)
                                message.dimensions[i] = String(object.dimensions[i]);
                        }
                        if (object.metrics) {
                            if (!Array.isArray(object.metrics))
                                throw TypeError(".palexy.streaming.v1.GetReportRequest.metrics: array expected");
                            message.metrics = [];
                            for (var i = 0; i < object.metrics.length; ++i)
                                message.metrics[i] = String(object.metrics[i]);
                        }
                        if (object.sorts) {
                            if (!Array.isArray(object.sorts))
                                throw TypeError(".palexy.streaming.v1.GetReportRequest.sorts: array expected");
                            message.sorts = [];
                            for (var i = 0; i < object.sorts.length; ++i)
                                message.sorts[i] = String(object.sorts[i]);
                        }
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.GetReportRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.GetReportRequest.Filter.fromObject(object.filter);
                        }
                        if (object.showTotals != null)
                            message.showTotals = Boolean(object.showTotals);
                        if (object.includeTargets != null)
                            message.includeTargets = Boolean(object.includeTargets);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @static
                     * @param {palexy.streaming.v1.GetReportRequest} message GetReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dates = [];
                            object.dimensions = [];
                            object.metrics = [];
                            object.sorts = [];
                        }
                        if (options.defaults) {
                            object.filter = null;
                            object.showTotals = false;
                            object.includeTargets = false;
                        }
                        if (message.dates && message.dates.length) {
                            object.dates = [];
                            for (var j = 0; j < message.dates.length; ++j)
                                object.dates[j] = message.dates[j];
                        }
                        if (message.dimensions && message.dimensions.length) {
                            object.dimensions = [];
                            for (var j = 0; j < message.dimensions.length; ++j)
                                object.dimensions[j] = message.dimensions[j];
                        }
                        if (message.metrics && message.metrics.length) {
                            object.metrics = [];
                            for (var j = 0; j < message.metrics.length; ++j)
                                object.metrics[j] = message.metrics[j];
                        }
                        if (message.sorts && message.sorts.length) {
                            object.sorts = [];
                            for (var j = 0; j < message.sorts.length; ++j)
                                object.sorts[j] = message.sorts[j];
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.GetReportRequest.Filter.toObject(message.filter, options);
                        if (message.showTotals != null && message.hasOwnProperty("showTotals"))
                            object.showTotals = message.showTotals;
                        if (message.includeTargets != null && message.hasOwnProperty("includeTargets"))
                            object.includeTargets = message.includeTargets;
                        return object;
                    };
    
                    /**
                     * Converts this GetReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    GetReportRequest.Filter = (function() {
    
                        /**
                         * Properties of a Filter.
                         * @memberof palexy.streaming.v1.GetReportRequest
                         * @interface IFilter
                         * @property {number|null} [companyId] Filter companyId
                         * @property {Array.<number>|null} [storeIds] Filter storeIds
                         * @property {string|null} [gender] Filter gender
                         * @property {Array.<number>|null} [ageRanges] Filter ageRanges
                         * @property {Array.<number>|null} [hourBins] Filter hourBins
                         * @property {Array.<number>|null} [metadataValueIds] Filter metadataValueIds
                         * @property {Array.<palexy.streaming.v1.GetReportRequest.IDimensionFilter>|null} [dimensionFilters] Filter dimensionFilters
                         */
    
                        /**
                         * Constructs a new Filter.
                         * @memberof palexy.streaming.v1.GetReportRequest
                         * @classdesc Represents a Filter.
                         * @implements IFilter
                         * @constructor
                         * @param {palexy.streaming.v1.GetReportRequest.IFilter=} [properties] Properties to set
                         */
                        function Filter(properties) {
                            this.storeIds = [];
                            this.ageRanges = [];
                            this.hourBins = [];
                            this.metadataValueIds = [];
                            this.dimensionFilters = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Filter companyId.
                         * @member {number} companyId
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Filter storeIds.
                         * @member {Array.<number>} storeIds
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.storeIds = $util.emptyArray;
    
                        /**
                         * Filter gender.
                         * @member {string} gender
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.gender = "";
    
                        /**
                         * Filter ageRanges.
                         * @member {Array.<number>} ageRanges
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.ageRanges = $util.emptyArray;
    
                        /**
                         * Filter hourBins.
                         * @member {Array.<number>} hourBins
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.hourBins = $util.emptyArray;
    
                        /**
                         * Filter metadataValueIds.
                         * @member {Array.<number>} metadataValueIds
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.metadataValueIds = $util.emptyArray;
    
                        /**
                         * Filter dimensionFilters.
                         * @member {Array.<palexy.streaming.v1.GetReportRequest.IDimensionFilter>} dimensionFilters
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         */
                        Filter.prototype.dimensionFilters = $util.emptyArray;
    
                        /**
                         * Creates a new Filter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.GetReportRequest.Filter} Filter instance
                         */
                        Filter.create = function create(properties) {
                            return new Filter(properties);
                        };
    
                        /**
                         * Encodes the specified Filter message. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.Filter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IFilter} message Filter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Filter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                            if (message.storeIds != null && message.storeIds.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    writer.int64(message.storeIds[i]);
                                writer.ldelim();
                            }
                            if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.gender);
                            if (message.ageRanges != null && message.ageRanges.length) {
                                writer.uint32(/* id 4, wireType 2 =*/34).fork();
                                for (var i = 0; i < message.ageRanges.length; ++i)
                                    writer.int32(message.ageRanges[i]);
                                writer.ldelim();
                            }
                            if (message.hourBins != null && message.hourBins.length) {
                                writer.uint32(/* id 5, wireType 2 =*/42).fork();
                                for (var i = 0; i < message.hourBins.length; ++i)
                                    writer.int32(message.hourBins[i]);
                                writer.ldelim();
                            }
                            if (message.metadataValueIds != null && message.metadataValueIds.length) {
                                writer.uint32(/* id 6, wireType 2 =*/50).fork();
                                for (var i = 0; i < message.metadataValueIds.length; ++i)
                                    writer.int64(message.metadataValueIds[i]);
                                writer.ldelim();
                            }
                            if (message.dimensionFilters != null && message.dimensionFilters.length)
                                for (var i = 0; i < message.dimensionFilters.length; ++i)
                                    $root.palexy.streaming.v1.GetReportRequest.DimensionFilter.encode(message.dimensionFilters[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Filter message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.Filter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IFilter} message Filter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Filter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Filter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.GetReportRequest.Filter} Filter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Filter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportRequest.Filter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.companyId = reader.int64();
                                    break;
                                case 2:
                                    if (!(message.storeIds && message.storeIds.length))
                                        message.storeIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.storeIds.push(reader.int64());
                                    } else
                                        message.storeIds.push(reader.int64());
                                    break;
                                case 3:
                                    message.gender = reader.string();
                                    break;
                                case 4:
                                    if (!(message.ageRanges && message.ageRanges.length))
                                        message.ageRanges = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.ageRanges.push(reader.int32());
                                    } else
                                        message.ageRanges.push(reader.int32());
                                    break;
                                case 5:
                                    if (!(message.hourBins && message.hourBins.length))
                                        message.hourBins = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.hourBins.push(reader.int32());
                                    } else
                                        message.hourBins.push(reader.int32());
                                    break;
                                case 6:
                                    if (!(message.metadataValueIds && message.metadataValueIds.length))
                                        message.metadataValueIds = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.metadataValueIds.push(reader.int64());
                                    } else
                                        message.metadataValueIds.push(reader.int64());
                                    break;
                                case 7:
                                    if (!(message.dimensionFilters && message.dimensionFilters.length))
                                        message.dimensionFilters = [];
                                    message.dimensionFilters.push($root.palexy.streaming.v1.GetReportRequest.DimensionFilter.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Filter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.GetReportRequest.Filter} Filter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Filter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Filter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Filter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                    return "companyId: integer|Long expected";
                            if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                                if (!Array.isArray(message.storeIds))
                                    return "storeIds: array expected";
                                for (var i = 0; i < message.storeIds.length; ++i)
                                    if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                        return "storeIds: integer|Long[] expected";
                            }
                            if (message.gender != null && message.hasOwnProperty("gender"))
                                if (!$util.isString(message.gender))
                                    return "gender: string expected";
                            if (message.ageRanges != null && message.hasOwnProperty("ageRanges")) {
                                if (!Array.isArray(message.ageRanges))
                                    return "ageRanges: array expected";
                                for (var i = 0; i < message.ageRanges.length; ++i)
                                    if (!$util.isInteger(message.ageRanges[i]))
                                        return "ageRanges: integer[] expected";
                            }
                            if (message.hourBins != null && message.hasOwnProperty("hourBins")) {
                                if (!Array.isArray(message.hourBins))
                                    return "hourBins: array expected";
                                for (var i = 0; i < message.hourBins.length; ++i)
                                    if (!$util.isInteger(message.hourBins[i]))
                                        return "hourBins: integer[] expected";
                            }
                            if (message.metadataValueIds != null && message.hasOwnProperty("metadataValueIds")) {
                                if (!Array.isArray(message.metadataValueIds))
                                    return "metadataValueIds: array expected";
                                for (var i = 0; i < message.metadataValueIds.length; ++i)
                                    if (!$util.isInteger(message.metadataValueIds[i]) && !(message.metadataValueIds[i] && $util.isInteger(message.metadataValueIds[i].low) && $util.isInteger(message.metadataValueIds[i].high)))
                                        return "metadataValueIds: integer|Long[] expected";
                            }
                            if (message.dimensionFilters != null && message.hasOwnProperty("dimensionFilters")) {
                                if (!Array.isArray(message.dimensionFilters))
                                    return "dimensionFilters: array expected";
                                for (var i = 0; i < message.dimensionFilters.length; ++i) {
                                    var error = $root.palexy.streaming.v1.GetReportRequest.DimensionFilter.verify(message.dimensionFilters[i]);
                                    if (error)
                                        return "dimensionFilters." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Filter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.GetReportRequest.Filter} Filter
                         */
                        Filter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.GetReportRequest.Filter)
                                return object;
                            var message = new $root.palexy.streaming.v1.GetReportRequest.Filter();
                            if (object.companyId != null)
                                if ($util.Long)
                                    (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                                else if (typeof object.companyId === "string")
                                    message.companyId = parseInt(object.companyId, 10);
                                else if (typeof object.companyId === "number")
                                    message.companyId = object.companyId;
                                else if (typeof object.companyId === "object")
                                    message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                            if (object.storeIds) {
                                if (!Array.isArray(object.storeIds))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.storeIds: array expected");
                                message.storeIds = [];
                                for (var i = 0; i < object.storeIds.length; ++i)
                                    if ($util.Long)
                                        (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                    else if (typeof object.storeIds[i] === "string")
                                        message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                    else if (typeof object.storeIds[i] === "number")
                                        message.storeIds[i] = object.storeIds[i];
                                    else if (typeof object.storeIds[i] === "object")
                                        message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                            }
                            if (object.gender != null)
                                message.gender = String(object.gender);
                            if (object.ageRanges) {
                                if (!Array.isArray(object.ageRanges))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.ageRanges: array expected");
                                message.ageRanges = [];
                                for (var i = 0; i < object.ageRanges.length; ++i)
                                    message.ageRanges[i] = object.ageRanges[i] | 0;
                            }
                            if (object.hourBins) {
                                if (!Array.isArray(object.hourBins))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.hourBins: array expected");
                                message.hourBins = [];
                                for (var i = 0; i < object.hourBins.length; ++i)
                                    message.hourBins[i] = object.hourBins[i] | 0;
                            }
                            if (object.metadataValueIds) {
                                if (!Array.isArray(object.metadataValueIds))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.metadataValueIds: array expected");
                                message.metadataValueIds = [];
                                for (var i = 0; i < object.metadataValueIds.length; ++i)
                                    if ($util.Long)
                                        (message.metadataValueIds[i] = $util.Long.fromValue(object.metadataValueIds[i])).unsigned = false;
                                    else if (typeof object.metadataValueIds[i] === "string")
                                        message.metadataValueIds[i] = parseInt(object.metadataValueIds[i], 10);
                                    else if (typeof object.metadataValueIds[i] === "number")
                                        message.metadataValueIds[i] = object.metadataValueIds[i];
                                    else if (typeof object.metadataValueIds[i] === "object")
                                        message.metadataValueIds[i] = new $util.LongBits(object.metadataValueIds[i].low >>> 0, object.metadataValueIds[i].high >>> 0).toNumber();
                            }
                            if (object.dimensionFilters) {
                                if (!Array.isArray(object.dimensionFilters))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.dimensionFilters: array expected");
                                message.dimensionFilters = [];
                                for (var i = 0; i < object.dimensionFilters.length; ++i) {
                                    if (typeof object.dimensionFilters[i] !== "object")
                                        throw TypeError(".palexy.streaming.v1.GetReportRequest.Filter.dimensionFilters: object expected");
                                    message.dimensionFilters[i] = $root.palexy.streaming.v1.GetReportRequest.DimensionFilter.fromObject(object.dimensionFilters[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Filter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.Filter} message Filter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Filter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.storeIds = [];
                                object.ageRanges = [];
                                object.hourBins = [];
                                object.metadataValueIds = [];
                                object.dimensionFilters = [];
                            }
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.companyId = options.longs === String ? "0" : 0;
                                object.gender = "";
                            }
                            if (message.companyId != null && message.hasOwnProperty("companyId"))
                                if (typeof message.companyId === "number")
                                    object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                                else
                                    object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (message.storeIds && message.storeIds.length) {
                                object.storeIds = [];
                                for (var j = 0; j < message.storeIds.length; ++j)
                                    if (typeof message.storeIds[j] === "number")
                                        object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                    else
                                        object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                            }
                            if (message.gender != null && message.hasOwnProperty("gender"))
                                object.gender = message.gender;
                            if (message.ageRanges && message.ageRanges.length) {
                                object.ageRanges = [];
                                for (var j = 0; j < message.ageRanges.length; ++j)
                                    object.ageRanges[j] = message.ageRanges[j];
                            }
                            if (message.hourBins && message.hourBins.length) {
                                object.hourBins = [];
                                for (var j = 0; j < message.hourBins.length; ++j)
                                    object.hourBins[j] = message.hourBins[j];
                            }
                            if (message.metadataValueIds && message.metadataValueIds.length) {
                                object.metadataValueIds = [];
                                for (var j = 0; j < message.metadataValueIds.length; ++j)
                                    if (typeof message.metadataValueIds[j] === "number")
                                        object.metadataValueIds[j] = options.longs === String ? String(message.metadataValueIds[j]) : message.metadataValueIds[j];
                                    else
                                        object.metadataValueIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueIds[j]) : options.longs === Number ? new $util.LongBits(message.metadataValueIds[j].low >>> 0, message.metadataValueIds[j].high >>> 0).toNumber() : message.metadataValueIds[j];
                            }
                            if (message.dimensionFilters && message.dimensionFilters.length) {
                                object.dimensionFilters = [];
                                for (var j = 0; j < message.dimensionFilters.length; ++j)
                                    object.dimensionFilters[j] = $root.palexy.streaming.v1.GetReportRequest.DimensionFilter.toObject(message.dimensionFilters[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Filter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.GetReportRequest.Filter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Filter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Filter;
                    })();
    
                    GetReportRequest.DimensionFilter = (function() {
    
                        /**
                         * Properties of a DimensionFilter.
                         * @memberof palexy.streaming.v1.GetReportRequest
                         * @interface IDimensionFilter
                         * @property {string|null} [dimension] DimensionFilter dimension
                         * @property {Array.<string>|null} [values] DimensionFilter values
                         */
    
                        /**
                         * Constructs a new DimensionFilter.
                         * @memberof palexy.streaming.v1.GetReportRequest
                         * @classdesc Represents a DimensionFilter.
                         * @implements IDimensionFilter
                         * @constructor
                         * @param {palexy.streaming.v1.GetReportRequest.IDimensionFilter=} [properties] Properties to set
                         */
                        function DimensionFilter(properties) {
                            this.values = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DimensionFilter dimension.
                         * @member {string} dimension
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @instance
                         */
                        DimensionFilter.prototype.dimension = "";
    
                        /**
                         * DimensionFilter values.
                         * @member {Array.<string>} values
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @instance
                         */
                        DimensionFilter.prototype.values = $util.emptyArray;
    
                        /**
                         * Creates a new DimensionFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IDimensionFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.GetReportRequest.DimensionFilter} DimensionFilter instance
                         */
                        DimensionFilter.create = function create(properties) {
                            return new DimensionFilter(properties);
                        };
    
                        /**
                         * Encodes the specified DimensionFilter message. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.DimensionFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IDimensionFilter} message DimensionFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DimensionFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dimension != null && Object.hasOwnProperty.call(message, "dimension"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dimension);
                            if (message.values != null && message.values.length)
                                for (var i = 0; i < message.values.length; ++i)
                                    writer.uint32(/* id 2, wireType 2 =*/18).string(message.values[i]);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DimensionFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportRequest.DimensionFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.IDimensionFilter} message DimensionFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DimensionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DimensionFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.GetReportRequest.DimensionFilter} DimensionFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DimensionFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportRequest.DimensionFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dimension = reader.string();
                                    break;
                                case 2:
                                    if (!(message.values && message.values.length))
                                        message.values = [];
                                    message.values.push(reader.string());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DimensionFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.GetReportRequest.DimensionFilter} DimensionFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DimensionFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DimensionFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DimensionFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dimension != null && message.hasOwnProperty("dimension"))
                                if (!$util.isString(message.dimension))
                                    return "dimension: string expected";
                            if (message.values != null && message.hasOwnProperty("values")) {
                                if (!Array.isArray(message.values))
                                    return "values: array expected";
                                for (var i = 0; i < message.values.length; ++i)
                                    if (!$util.isString(message.values[i]))
                                        return "values: string[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a DimensionFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.GetReportRequest.DimensionFilter} DimensionFilter
                         */
                        DimensionFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.GetReportRequest.DimensionFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.GetReportRequest.DimensionFilter();
                            if (object.dimension != null)
                                message.dimension = String(object.dimension);
                            if (object.values) {
                                if (!Array.isArray(object.values))
                                    throw TypeError(".palexy.streaming.v1.GetReportRequest.DimensionFilter.values: array expected");
                                message.values = [];
                                for (var i = 0; i < object.values.length; ++i)
                                    message.values[i] = String(object.values[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DimensionFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @static
                         * @param {palexy.streaming.v1.GetReportRequest.DimensionFilter} message DimensionFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DimensionFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.values = [];
                            if (options.defaults)
                                object.dimension = "";
                            if (message.dimension != null && message.hasOwnProperty("dimension"))
                                object.dimension = message.dimension;
                            if (message.values && message.values.length) {
                                object.values = [];
                                for (var j = 0; j < message.values.length; ++j)
                                    object.values[j] = message.values[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this DimensionFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.GetReportRequest.DimensionFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DimensionFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DimensionFilter;
                    })();
    
                    return GetReportRequest;
                })();
    
                v1.GetReportResponse = (function() {
    
                    /**
                     * Properties of a GetReportResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetReportResponse
                     * @property {Array.<string>|null} [dates] GetReportResponse dates
                     * @property {Array.<string>|null} [dimensions] GetReportResponse dimensions
                     * @property {Array.<number>|null} [metricTotals] GetReportResponse metricTotals
                     * @property {Array.<palexy.streaming.v1.GetReportResponse.IMetric>|null} [metrics] GetReportResponse metrics
                     * @property {Array.<palexy.streaming.v1.GetReportResponse.IRow>|null} [rows] GetReportResponse rows
                     */
    
                    /**
                     * Constructs a new GetReportResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetReportResponse.
                     * @implements IGetReportResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetReportResponse=} [properties] Properties to set
                     */
                    function GetReportResponse(properties) {
                        this.dates = [];
                        this.dimensions = [];
                        this.metricTotals = [];
                        this.metrics = [];
                        this.rows = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetReportResponse dates.
                     * @member {Array.<string>} dates
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     */
                    GetReportResponse.prototype.dates = $util.emptyArray;
    
                    /**
                     * GetReportResponse dimensions.
                     * @member {Array.<string>} dimensions
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     */
                    GetReportResponse.prototype.dimensions = $util.emptyArray;
    
                    /**
                     * GetReportResponse metricTotals.
                     * @member {Array.<number>} metricTotals
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     */
                    GetReportResponse.prototype.metricTotals = $util.emptyArray;
    
                    /**
                     * GetReportResponse metrics.
                     * @member {Array.<palexy.streaming.v1.GetReportResponse.IMetric>} metrics
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     */
                    GetReportResponse.prototype.metrics = $util.emptyArray;
    
                    /**
                     * GetReportResponse rows.
                     * @member {Array.<palexy.streaming.v1.GetReportResponse.IRow>} rows
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     */
                    GetReportResponse.prototype.rows = $util.emptyArray;
    
                    /**
                     * Creates a new GetReportResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetReportResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetReportResponse} GetReportResponse instance
                     */
                    GetReportResponse.create = function create(properties) {
                        return new GetReportResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetReportResponse message. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetReportResponse} message GetReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dates != null && message.dates.length)
                            for (var i = 0; i < message.dates.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.dates[i]);
                        if (message.dimensions != null && message.dimensions.length)
                            for (var i = 0; i < message.dimensions.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.dimensions[i]);
                        if (message.metricTotals != null && message.metricTotals.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.metricTotals.length; ++i)
                                writer.double(message.metricTotals[i]);
                            writer.ldelim();
                        }
                        if (message.metrics != null && message.metrics.length)
                            for (var i = 0; i < message.metrics.length; ++i)
                                $root.palexy.streaming.v1.GetReportResponse.Metric.encode(message.metrics[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.streaming.v1.GetReportResponse.Row.encode(message.rows[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetReportResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetReportResponse} message GetReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetReportResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetReportResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetReportResponse} GetReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dates && message.dates.length))
                                    message.dates = [];
                                message.dates.push(reader.string());
                                break;
                            case 2:
                                if (!(message.dimensions && message.dimensions.length))
                                    message.dimensions = [];
                                message.dimensions.push(reader.string());
                                break;
                            case 3:
                                if (!(message.metricTotals && message.metricTotals.length))
                                    message.metricTotals = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.metricTotals.push(reader.double());
                                } else
                                    message.metricTotals.push(reader.double());
                                break;
                            case 4:
                                if (!(message.metrics && message.metrics.length))
                                    message.metrics = [];
                                message.metrics.push($root.palexy.streaming.v1.GetReportResponse.Metric.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.streaming.v1.GetReportResponse.Row.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetReportResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetReportResponse} GetReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetReportResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetReportResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetReportResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dates != null && message.hasOwnProperty("dates")) {
                            if (!Array.isArray(message.dates))
                                return "dates: array expected";
                            for (var i = 0; i < message.dates.length; ++i)
                                if (!$util.isString(message.dates[i]))
                                    return "dates: string[] expected";
                        }
                        if (message.dimensions != null && message.hasOwnProperty("dimensions")) {
                            if (!Array.isArray(message.dimensions))
                                return "dimensions: array expected";
                            for (var i = 0; i < message.dimensions.length; ++i)
                                if (!$util.isString(message.dimensions[i]))
                                    return "dimensions: string[] expected";
                        }
                        if (message.metricTotals != null && message.hasOwnProperty("metricTotals")) {
                            if (!Array.isArray(message.metricTotals))
                                return "metricTotals: array expected";
                            for (var i = 0; i < message.metricTotals.length; ++i)
                                if (typeof message.metricTotals[i] !== "number")
                                    return "metricTotals: number[] expected";
                        }
                        if (message.metrics != null && message.hasOwnProperty("metrics")) {
                            if (!Array.isArray(message.metrics))
                                return "metrics: array expected";
                            for (var i = 0; i < message.metrics.length; ++i) {
                                var error = $root.palexy.streaming.v1.GetReportResponse.Metric.verify(message.metrics[i]);
                                if (error)
                                    return "metrics." + error;
                            }
                        }
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.streaming.v1.GetReportResponse.Row.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetReportResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetReportResponse} GetReportResponse
                     */
                    GetReportResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetReportResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetReportResponse();
                        if (object.dates) {
                            if (!Array.isArray(object.dates))
                                throw TypeError(".palexy.streaming.v1.GetReportResponse.dates: array expected");
                            message.dates = [];
                            for (var i = 0; i < object.dates.length; ++i)
                                message.dates[i] = String(object.dates[i]);
                        }
                        if (object.dimensions) {
                            if (!Array.isArray(object.dimensions))
                                throw TypeError(".palexy.streaming.v1.GetReportResponse.dimensions: array expected");
                            message.dimensions = [];
                            for (var i = 0; i < object.dimensions.length; ++i)
                                message.dimensions[i] = String(object.dimensions[i]);
                        }
                        if (object.metricTotals) {
                            if (!Array.isArray(object.metricTotals))
                                throw TypeError(".palexy.streaming.v1.GetReportResponse.metricTotals: array expected");
                            message.metricTotals = [];
                            for (var i = 0; i < object.metricTotals.length; ++i)
                                message.metricTotals[i] = Number(object.metricTotals[i]);
                        }
                        if (object.metrics) {
                            if (!Array.isArray(object.metrics))
                                throw TypeError(".palexy.streaming.v1.GetReportResponse.metrics: array expected");
                            message.metrics = [];
                            for (var i = 0; i < object.metrics.length; ++i) {
                                if (typeof object.metrics[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetReportResponse.metrics: object expected");
                                message.metrics[i] = $root.palexy.streaming.v1.GetReportResponse.Metric.fromObject(object.metrics[i]);
                            }
                        }
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.streaming.v1.GetReportResponse.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetReportResponse.rows: object expected");
                                message.rows[i] = $root.palexy.streaming.v1.GetReportResponse.Row.fromObject(object.rows[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetReportResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @static
                     * @param {palexy.streaming.v1.GetReportResponse} message GetReportResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetReportResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.dates = [];
                            object.dimensions = [];
                            object.metricTotals = [];
                            object.metrics = [];
                            object.rows = [];
                        }
                        if (message.dates && message.dates.length) {
                            object.dates = [];
                            for (var j = 0; j < message.dates.length; ++j)
                                object.dates[j] = message.dates[j];
                        }
                        if (message.dimensions && message.dimensions.length) {
                            object.dimensions = [];
                            for (var j = 0; j < message.dimensions.length; ++j)
                                object.dimensions[j] = message.dimensions[j];
                        }
                        if (message.metricTotals && message.metricTotals.length) {
                            object.metricTotals = [];
                            for (var j = 0; j < message.metricTotals.length; ++j)
                                object.metricTotals[j] = options.json && !isFinite(message.metricTotals[j]) ? String(message.metricTotals[j]) : message.metricTotals[j];
                        }
                        if (message.metrics && message.metrics.length) {
                            object.metrics = [];
                            for (var j = 0; j < message.metrics.length; ++j)
                                object.metrics[j] = $root.palexy.streaming.v1.GetReportResponse.Metric.toObject(message.metrics[j], options);
                        }
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.streaming.v1.GetReportResponse.Row.toObject(message.rows[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetReportResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetReportResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetReportResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    GetReportResponse.Metric = (function() {
    
                        /**
                         * Properties of a Metric.
                         * @memberof palexy.streaming.v1.GetReportResponse
                         * @interface IMetric
                         * @property {string|null} [id] Metric id
                         * @property {number|null} [dateRangeIndex] Metric dateRangeIndex
                         * @property {boolean|null} [isTarget] Metric isTarget
                         */
    
                        /**
                         * Constructs a new Metric.
                         * @memberof palexy.streaming.v1.GetReportResponse
                         * @classdesc Represents a Metric.
                         * @implements IMetric
                         * @constructor
                         * @param {palexy.streaming.v1.GetReportResponse.IMetric=} [properties] Properties to set
                         */
                        function Metric(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Metric id.
                         * @member {string} id
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @instance
                         */
                        Metric.prototype.id = "";
    
                        /**
                         * Metric dateRangeIndex.
                         * @member {number} dateRangeIndex
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @instance
                         */
                        Metric.prototype.dateRangeIndex = 0;
    
                        /**
                         * Metric isTarget.
                         * @member {boolean} isTarget
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @instance
                         */
                        Metric.prototype.isTarget = false;
    
                        /**
                         * Creates a new Metric instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IMetric=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.GetReportResponse.Metric} Metric instance
                         */
                        Metric.create = function create(properties) {
                            return new Metric(properties);
                        };
    
                        /**
                         * Encodes the specified Metric message. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.Metric.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IMetric} message Metric message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Metric.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                            if (message.dateRangeIndex != null && Object.hasOwnProperty.call(message, "dateRangeIndex"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateRangeIndex);
                            if (message.isTarget != null && Object.hasOwnProperty.call(message, "isTarget"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isTarget);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Metric message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.Metric.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IMetric} message Metric message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Metric.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Metric message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.GetReportResponse.Metric} Metric
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Metric.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportResponse.Metric();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.id = reader.string();
                                    break;
                                case 2:
                                    message.dateRangeIndex = reader.int32();
                                    break;
                                case 3:
                                    message.isTarget = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Metric message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.GetReportResponse.Metric} Metric
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Metric.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Metric message.
                         * @function verify
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Metric.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isString(message.id))
                                    return "id: string expected";
                            if (message.dateRangeIndex != null && message.hasOwnProperty("dateRangeIndex"))
                                if (!$util.isInteger(message.dateRangeIndex))
                                    return "dateRangeIndex: integer expected";
                            if (message.isTarget != null && message.hasOwnProperty("isTarget"))
                                if (typeof message.isTarget !== "boolean")
                                    return "isTarget: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a Metric message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.GetReportResponse.Metric} Metric
                         */
                        Metric.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.GetReportResponse.Metric)
                                return object;
                            var message = new $root.palexy.streaming.v1.GetReportResponse.Metric();
                            if (object.id != null)
                                message.id = String(object.id);
                            if (object.dateRangeIndex != null)
                                message.dateRangeIndex = object.dateRangeIndex | 0;
                            if (object.isTarget != null)
                                message.isTarget = Boolean(object.isTarget);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Metric message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.Metric} message Metric
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Metric.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.id = "";
                                object.dateRangeIndex = 0;
                                object.isTarget = false;
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.dateRangeIndex != null && message.hasOwnProperty("dateRangeIndex"))
                                object.dateRangeIndex = message.dateRangeIndex;
                            if (message.isTarget != null && message.hasOwnProperty("isTarget"))
                                object.isTarget = message.isTarget;
                            return object;
                        };
    
                        /**
                         * Converts this Metric to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.GetReportResponse.Metric
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Metric.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Metric;
                    })();
    
                    GetReportResponse.Row = (function() {
    
                        /**
                         * Properties of a Row.
                         * @memberof palexy.streaming.v1.GetReportResponse
                         * @interface IRow
                         * @property {Array.<string>|null} [dimensionValues] Row dimensionValues
                         * @property {Array.<number>|null} [metricValues] Row metricValues
                         */
    
                        /**
                         * Constructs a new Row.
                         * @memberof palexy.streaming.v1.GetReportResponse
                         * @classdesc Represents a Row.
                         * @implements IRow
                         * @constructor
                         * @param {palexy.streaming.v1.GetReportResponse.IRow=} [properties] Properties to set
                         */
                        function Row(properties) {
                            this.dimensionValues = [];
                            this.metricValues = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Row dimensionValues.
                         * @member {Array.<string>} dimensionValues
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @instance
                         */
                        Row.prototype.dimensionValues = $util.emptyArray;
    
                        /**
                         * Row metricValues.
                         * @member {Array.<number>} metricValues
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @instance
                         */
                        Row.prototype.metricValues = $util.emptyArray;
    
                        /**
                         * Creates a new Row instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IRow=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.GetReportResponse.Row} Row instance
                         */
                        Row.create = function create(properties) {
                            return new Row(properties);
                        };
    
                        /**
                         * Encodes the specified Row message. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.Row.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IRow} message Row message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Row.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dimensionValues != null && message.dimensionValues.length)
                                for (var i = 0; i < message.dimensionValues.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.dimensionValues[i]);
                            if (message.metricValues != null && message.metricValues.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.metricValues.length; ++i)
                                    writer.double(message.metricValues[i]);
                                writer.ldelim();
                            }
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Row message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetReportResponse.Row.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.IRow} message Row message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Row.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Row message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.GetReportResponse.Row} Row
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Row.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetReportResponse.Row();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.dimensionValues && message.dimensionValues.length))
                                        message.dimensionValues = [];
                                    message.dimensionValues.push(reader.string());
                                    break;
                                case 2:
                                    if (!(message.metricValues && message.metricValues.length))
                                        message.metricValues = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.metricValues.push(reader.double());
                                    } else
                                        message.metricValues.push(reader.double());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Row message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.GetReportResponse.Row} Row
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Row.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Row message.
                         * @function verify
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Row.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dimensionValues != null && message.hasOwnProperty("dimensionValues")) {
                                if (!Array.isArray(message.dimensionValues))
                                    return "dimensionValues: array expected";
                                for (var i = 0; i < message.dimensionValues.length; ++i)
                                    if (!$util.isString(message.dimensionValues[i]))
                                        return "dimensionValues: string[] expected";
                            }
                            if (message.metricValues != null && message.hasOwnProperty("metricValues")) {
                                if (!Array.isArray(message.metricValues))
                                    return "metricValues: array expected";
                                for (var i = 0; i < message.metricValues.length; ++i)
                                    if (typeof message.metricValues[i] !== "number")
                                        return "metricValues: number[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Row message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.GetReportResponse.Row} Row
                         */
                        Row.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.GetReportResponse.Row)
                                return object;
                            var message = new $root.palexy.streaming.v1.GetReportResponse.Row();
                            if (object.dimensionValues) {
                                if (!Array.isArray(object.dimensionValues))
                                    throw TypeError(".palexy.streaming.v1.GetReportResponse.Row.dimensionValues: array expected");
                                message.dimensionValues = [];
                                for (var i = 0; i < object.dimensionValues.length; ++i)
                                    message.dimensionValues[i] = String(object.dimensionValues[i]);
                            }
                            if (object.metricValues) {
                                if (!Array.isArray(object.metricValues))
                                    throw TypeError(".palexy.streaming.v1.GetReportResponse.Row.metricValues: array expected");
                                message.metricValues = [];
                                for (var i = 0; i < object.metricValues.length; ++i)
                                    message.metricValues[i] = Number(object.metricValues[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Row message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @static
                         * @param {palexy.streaming.v1.GetReportResponse.Row} message Row
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Row.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults) {
                                object.dimensionValues = [];
                                object.metricValues = [];
                            }
                            if (message.dimensionValues && message.dimensionValues.length) {
                                object.dimensionValues = [];
                                for (var j = 0; j < message.dimensionValues.length; ++j)
                                    object.dimensionValues[j] = message.dimensionValues[j];
                            }
                            if (message.metricValues && message.metricValues.length) {
                                object.metricValues = [];
                                for (var j = 0; j < message.metricValues.length; ++j)
                                    object.metricValues[j] = options.json && !isFinite(message.metricValues[j]) ? String(message.metricValues[j]) : message.metricValues[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Row to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.GetReportResponse.Row
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Row.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Row;
                    })();
    
                    return GetReportResponse;
                })();
    
                v1.NpsMeasurementService = (function() {
    
                    /**
                     * Constructs a new NpsMeasurementService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a NpsMeasurementService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function NpsMeasurementService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (NpsMeasurementService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = NpsMeasurementService;
    
                    /**
                     * Creates new NpsMeasurementService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {NpsMeasurementService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    NpsMeasurementService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#createNpsCampaign}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef CreateNpsCampaignCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.NpsCampaign} [response] NpsCampaign
                     */
    
                    /**
                     * Calls CreateNpsCampaign.
                     * @function createNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.INpsCampaign} request NpsCampaign message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.CreateNpsCampaignCallback} callback Node-style callback called with the error, if any, and NpsCampaign
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.createNpsCampaign = function createNpsCampaign(request, callback) {
                        return this.rpcCall(createNpsCampaign, $root.palexy.streaming.v1.NpsCampaign, $root.palexy.streaming.v1.NpsCampaign, request, callback);
                    }, "name", { value: "CreateNpsCampaign" });
    
                    /**
                     * Calls CreateNpsCampaign.
                     * @function createNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.INpsCampaign} request NpsCampaign message or plain object
                     * @returns {Promise<palexy.streaming.v1.NpsCampaign>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#listNpsCampaign}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef ListNpsCampaignCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListNpsCampaignResponse} [response] ListNpsCampaignResponse
                     */
    
                    /**
                     * Calls ListNpsCampaign.
                     * @function listNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest} request ListNpsCampaignRequest message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.ListNpsCampaignCallback} callback Node-style callback called with the error, if any, and ListNpsCampaignResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.listNpsCampaign = function listNpsCampaign(request, callback) {
                        return this.rpcCall(listNpsCampaign, $root.palexy.streaming.v1.ListNpsCampaignRequest, $root.palexy.streaming.v1.ListNpsCampaignResponse, request, callback);
                    }, "name", { value: "ListNpsCampaign" });
    
                    /**
                     * Calls ListNpsCampaign.
                     * @function listNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest} request ListNpsCampaignRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListNpsCampaignResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#getNpsCampaign}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef GetNpsCampaignCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.NpsCampaign} [response] NpsCampaign
                     */
    
                    /**
                     * Calls GetNpsCampaign.
                     * @function getNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest} request GetNpsCampaignRequest message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.GetNpsCampaignCallback} callback Node-style callback called with the error, if any, and NpsCampaign
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.getNpsCampaign = function getNpsCampaign(request, callback) {
                        return this.rpcCall(getNpsCampaign, $root.palexy.streaming.v1.GetNpsCampaignRequest, $root.palexy.streaming.v1.NpsCampaign, request, callback);
                    }, "name", { value: "GetNpsCampaign" });
    
                    /**
                     * Calls GetNpsCampaign.
                     * @function getNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest} request GetNpsCampaignRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.NpsCampaign>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#updateNpsCampaign}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef UpdateNpsCampaignCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.NpsCampaign} [response] NpsCampaign
                     */
    
                    /**
                     * Calls UpdateNpsCampaign.
                     * @function updateNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest} request UpdateNpsCampaignRequest message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.UpdateNpsCampaignCallback} callback Node-style callback called with the error, if any, and NpsCampaign
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.updateNpsCampaign = function updateNpsCampaign(request, callback) {
                        return this.rpcCall(updateNpsCampaign, $root.palexy.streaming.v1.UpdateNpsCampaignRequest, $root.palexy.streaming.v1.NpsCampaign, request, callback);
                    }, "name", { value: "UpdateNpsCampaign" });
    
                    /**
                     * Calls UpdateNpsCampaign.
                     * @function updateNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest} request UpdateNpsCampaignRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.NpsCampaign>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#getActiveNpsCampaign}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef GetActiveNpsCampaignCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetActiveNpsCampaignResponse} [response] GetActiveNpsCampaignResponse
                     */
    
                    /**
                     * Calls GetActiveNpsCampaign.
                     * @function getActiveNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest} request GetActiveNpsCampaignRequest message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.GetActiveNpsCampaignCallback} callback Node-style callback called with the error, if any, and GetActiveNpsCampaignResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.getActiveNpsCampaign = function getActiveNpsCampaign(request, callback) {
                        return this.rpcCall(getActiveNpsCampaign, $root.palexy.streaming.v1.GetActiveNpsCampaignRequest, $root.palexy.streaming.v1.GetActiveNpsCampaignResponse, request, callback);
                    }, "name", { value: "GetActiveNpsCampaign" });
    
                    /**
                     * Calls GetActiveNpsCampaign.
                     * @function getActiveNpsCampaign
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest} request GetActiveNpsCampaignRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetActiveNpsCampaignResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.NpsMeasurementService#createNpsResponse}.
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @typedef CreateNpsResponseCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.NpsResponse} [response] NpsResponse
                     */
    
                    /**
                     * Calls CreateNpsResponse.
                     * @function createNpsResponse
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.INpsResponse} request NpsResponse message or plain object
                     * @param {palexy.streaming.v1.NpsMeasurementService.CreateNpsResponseCallback} callback Node-style callback called with the error, if any, and NpsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(NpsMeasurementService.prototype.createNpsResponse = function createNpsResponse(request, callback) {
                        return this.rpcCall(createNpsResponse, $root.palexy.streaming.v1.NpsResponse, $root.palexy.streaming.v1.NpsResponse, request, callback);
                    }, "name", { value: "CreateNpsResponse" });
    
                    /**
                     * Calls CreateNpsResponse.
                     * @function createNpsResponse
                     * @memberof palexy.streaming.v1.NpsMeasurementService
                     * @instance
                     * @param {palexy.streaming.v1.INpsResponse} request NpsResponse message or plain object
                     * @returns {Promise<palexy.streaming.v1.NpsResponse>} Promise
                     * @variation 2
                     */
    
                    return NpsMeasurementService;
                })();
    
                v1.ListNpsCampaignRequest = (function() {
    
                    /**
                     * Properties of a ListNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListNpsCampaignRequest
                     * @property {number|null} [pageSize] ListNpsCampaignRequest pageSize
                     * @property {string|null} [pageToken] ListNpsCampaignRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListNpsCampaignRequest.
                     * @implements IListNpsCampaignRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest=} [properties] Properties to set
                     */
                    function ListNpsCampaignRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListNpsCampaignRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @instance
                     */
                    ListNpsCampaignRequest.prototype.pageSize = 0;
    
                    /**
                     * ListNpsCampaignRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @instance
                     */
                    ListNpsCampaignRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListNpsCampaignRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListNpsCampaignRequest} ListNpsCampaignRequest instance
                     */
                    ListNpsCampaignRequest.create = function create(properties) {
                        return new ListNpsCampaignRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListNpsCampaignRequest message. Does not implicitly {@link palexy.streaming.v1.ListNpsCampaignRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest} message ListNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNpsCampaignRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListNpsCampaignRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListNpsCampaignRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignRequest} message ListNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNpsCampaignRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListNpsCampaignRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListNpsCampaignRequest} ListNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNpsCampaignRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListNpsCampaignRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListNpsCampaignRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListNpsCampaignRequest} ListNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNpsCampaignRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListNpsCampaignRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListNpsCampaignRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListNpsCampaignRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListNpsCampaignRequest} ListNpsCampaignRequest
                     */
                    ListNpsCampaignRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListNpsCampaignRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListNpsCampaignRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListNpsCampaignRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.ListNpsCampaignRequest} message ListNpsCampaignRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListNpsCampaignRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListNpsCampaignRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListNpsCampaignRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListNpsCampaignRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListNpsCampaignRequest;
                })();
    
                v1.ListNpsCampaignResponse = (function() {
    
                    /**
                     * Properties of a ListNpsCampaignResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListNpsCampaignResponse
                     * @property {Array.<palexy.streaming.v1.INpsCampaign>|null} [campaigns] ListNpsCampaignResponse campaigns
                     * @property {number|null} [totalElements] ListNpsCampaignResponse totalElements
                     * @property {string|null} [nextPageToken] ListNpsCampaignResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListNpsCampaignResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListNpsCampaignResponse.
                     * @implements IListNpsCampaignResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListNpsCampaignResponse=} [properties] Properties to set
                     */
                    function ListNpsCampaignResponse(properties) {
                        this.campaigns = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListNpsCampaignResponse campaigns.
                     * @member {Array.<palexy.streaming.v1.INpsCampaign>} campaigns
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @instance
                     */
                    ListNpsCampaignResponse.prototype.campaigns = $util.emptyArray;
    
                    /**
                     * ListNpsCampaignResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @instance
                     */
                    ListNpsCampaignResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListNpsCampaignResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @instance
                     */
                    ListNpsCampaignResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListNpsCampaignResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListNpsCampaignResponse} ListNpsCampaignResponse instance
                     */
                    ListNpsCampaignResponse.create = function create(properties) {
                        return new ListNpsCampaignResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListNpsCampaignResponse message. Does not implicitly {@link palexy.streaming.v1.ListNpsCampaignResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignResponse} message ListNpsCampaignResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNpsCampaignResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.campaigns != null && message.campaigns.length)
                            for (var i = 0; i < message.campaigns.length; ++i)
                                $root.palexy.streaming.v1.NpsCampaign.encode(message.campaigns[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListNpsCampaignResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListNpsCampaignResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IListNpsCampaignResponse} message ListNpsCampaignResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListNpsCampaignResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListNpsCampaignResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListNpsCampaignResponse} ListNpsCampaignResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNpsCampaignResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListNpsCampaignResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.campaigns && message.campaigns.length))
                                    message.campaigns = [];
                                message.campaigns.push($root.palexy.streaming.v1.NpsCampaign.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListNpsCampaignResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListNpsCampaignResponse} ListNpsCampaignResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListNpsCampaignResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListNpsCampaignResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListNpsCampaignResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.campaigns != null && message.hasOwnProperty("campaigns")) {
                            if (!Array.isArray(message.campaigns))
                                return "campaigns: array expected";
                            for (var i = 0; i < message.campaigns.length; ++i) {
                                var error = $root.palexy.streaming.v1.NpsCampaign.verify(message.campaigns[i]);
                                if (error)
                                    return "campaigns." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListNpsCampaignResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListNpsCampaignResponse} ListNpsCampaignResponse
                     */
                    ListNpsCampaignResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListNpsCampaignResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListNpsCampaignResponse();
                        if (object.campaigns) {
                            if (!Array.isArray(object.campaigns))
                                throw TypeError(".palexy.streaming.v1.ListNpsCampaignResponse.campaigns: array expected");
                            message.campaigns = [];
                            for (var i = 0; i < object.campaigns.length; ++i) {
                                if (typeof object.campaigns[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListNpsCampaignResponse.campaigns: object expected");
                                message.campaigns[i] = $root.palexy.streaming.v1.NpsCampaign.fromObject(object.campaigns[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListNpsCampaignResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.ListNpsCampaignResponse} message ListNpsCampaignResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListNpsCampaignResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.campaigns = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.campaigns && message.campaigns.length) {
                            object.campaigns = [];
                            for (var j = 0; j < message.campaigns.length; ++j)
                                object.campaigns[j] = $root.palexy.streaming.v1.NpsCampaign.toObject(message.campaigns[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListNpsCampaignResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListNpsCampaignResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListNpsCampaignResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListNpsCampaignResponse;
                })();
    
                v1.GetNpsCampaignRequest = (function() {
    
                    /**
                     * Properties of a GetNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetNpsCampaignRequest
                     * @property {number|null} [campaignId] GetNpsCampaignRequest campaignId
                     */
    
                    /**
                     * Constructs a new GetNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetNpsCampaignRequest.
                     * @implements IGetNpsCampaignRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest=} [properties] Properties to set
                     */
                    function GetNpsCampaignRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetNpsCampaignRequest campaignId.
                     * @member {number} campaignId
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @instance
                     */
                    GetNpsCampaignRequest.prototype.campaignId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetNpsCampaignRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetNpsCampaignRequest} GetNpsCampaignRequest instance
                     */
                    GetNpsCampaignRequest.create = function create(properties) {
                        return new GetNpsCampaignRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetNpsCampaignRequest message. Does not implicitly {@link palexy.streaming.v1.GetNpsCampaignRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest} message GetNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetNpsCampaignRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.campaignId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetNpsCampaignRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetNpsCampaignRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetNpsCampaignRequest} message GetNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetNpsCampaignRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetNpsCampaignRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetNpsCampaignRequest} GetNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetNpsCampaignRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetNpsCampaignRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.campaignId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetNpsCampaignRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetNpsCampaignRequest} GetNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetNpsCampaignRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetNpsCampaignRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetNpsCampaignRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                            if (!$util.isInteger(message.campaignId) && !(message.campaignId && $util.isInteger(message.campaignId.low) && $util.isInteger(message.campaignId.high)))
                                return "campaignId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetNpsCampaignRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetNpsCampaignRequest} GetNpsCampaignRequest
                     */
                    GetNpsCampaignRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetNpsCampaignRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetNpsCampaignRequest();
                        if (object.campaignId != null)
                            if ($util.Long)
                                (message.campaignId = $util.Long.fromValue(object.campaignId)).unsigned = false;
                            else if (typeof object.campaignId === "string")
                                message.campaignId = parseInt(object.campaignId, 10);
                            else if (typeof object.campaignId === "number")
                                message.campaignId = object.campaignId;
                            else if (typeof object.campaignId === "object")
                                message.campaignId = new $util.LongBits(object.campaignId.low >>> 0, object.campaignId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetNpsCampaignRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.GetNpsCampaignRequest} message GetNpsCampaignRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetNpsCampaignRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.campaignId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.campaignId = options.longs === String ? "0" : 0;
                        if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                            if (typeof message.campaignId === "number")
                                object.campaignId = options.longs === String ? String(message.campaignId) : message.campaignId;
                            else
                                object.campaignId = options.longs === String ? $util.Long.prototype.toString.call(message.campaignId) : options.longs === Number ? new $util.LongBits(message.campaignId.low >>> 0, message.campaignId.high >>> 0).toNumber() : message.campaignId;
                        return object;
                    };
    
                    /**
                     * Converts this GetNpsCampaignRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetNpsCampaignRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetNpsCampaignRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetNpsCampaignRequest;
                })();
    
                v1.UpdateNpsCampaignRequest = (function() {
    
                    /**
                     * Properties of an UpdateNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateNpsCampaignRequest
                     * @property {palexy.streaming.v1.INpsCampaign|null} [campaign] UpdateNpsCampaignRequest campaign
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateNpsCampaignRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateNpsCampaignRequest.
                     * @implements IUpdateNpsCampaignRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest=} [properties] Properties to set
                     */
                    function UpdateNpsCampaignRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateNpsCampaignRequest campaign.
                     * @member {palexy.streaming.v1.INpsCampaign|null|undefined} campaign
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @instance
                     */
                    UpdateNpsCampaignRequest.prototype.campaign = null;
    
                    /**
                     * UpdateNpsCampaignRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @instance
                     */
                    UpdateNpsCampaignRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateNpsCampaignRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateNpsCampaignRequest} UpdateNpsCampaignRequest instance
                     */
                    UpdateNpsCampaignRequest.create = function create(properties) {
                        return new UpdateNpsCampaignRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateNpsCampaignRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateNpsCampaignRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest} message UpdateNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNpsCampaignRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                            $root.palexy.streaming.v1.NpsCampaign.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateNpsCampaignRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateNpsCampaignRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateNpsCampaignRequest} message UpdateNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateNpsCampaignRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateNpsCampaignRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateNpsCampaignRequest} UpdateNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNpsCampaignRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateNpsCampaignRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.campaign = $root.palexy.streaming.v1.NpsCampaign.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateNpsCampaignRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateNpsCampaignRequest} UpdateNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateNpsCampaignRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateNpsCampaignRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateNpsCampaignRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.campaign != null && message.hasOwnProperty("campaign")) {
                            var error = $root.palexy.streaming.v1.NpsCampaign.verify(message.campaign);
                            if (error)
                                return "campaign." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateNpsCampaignRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateNpsCampaignRequest} UpdateNpsCampaignRequest
                     */
                    UpdateNpsCampaignRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateNpsCampaignRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateNpsCampaignRequest();
                        if (object.campaign != null) {
                            if (typeof object.campaign !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNpsCampaignRequest.campaign: object expected");
                            message.campaign = $root.palexy.streaming.v1.NpsCampaign.fromObject(object.campaign);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateNpsCampaignRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateNpsCampaignRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateNpsCampaignRequest} message UpdateNpsCampaignRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateNpsCampaignRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.campaign = null;
                            object.updateMask = null;
                        }
                        if (message.campaign != null && message.hasOwnProperty("campaign"))
                            object.campaign = $root.palexy.streaming.v1.NpsCampaign.toObject(message.campaign, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateNpsCampaignRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateNpsCampaignRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateNpsCampaignRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateNpsCampaignRequest;
                })();
    
                v1.GetActiveNpsCampaignRequest = (function() {
    
                    /**
                     * Properties of a GetActiveNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetActiveNpsCampaignRequest
                     * @property {number|null} [accountId] GetActiveNpsCampaignRequest accountId
                     */
    
                    /**
                     * Constructs a new GetActiveNpsCampaignRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetActiveNpsCampaignRequest.
                     * @implements IGetActiveNpsCampaignRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest=} [properties] Properties to set
                     */
                    function GetActiveNpsCampaignRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetActiveNpsCampaignRequest accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @instance
                     */
                    GetActiveNpsCampaignRequest.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetActiveNpsCampaignRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignRequest} GetActiveNpsCampaignRequest instance
                     */
                    GetActiveNpsCampaignRequest.create = function create(properties) {
                        return new GetActiveNpsCampaignRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetActiveNpsCampaignRequest message. Does not implicitly {@link palexy.streaming.v1.GetActiveNpsCampaignRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest} message GetActiveNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetActiveNpsCampaignRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.accountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetActiveNpsCampaignRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetActiveNpsCampaignRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignRequest} message GetActiveNpsCampaignRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetActiveNpsCampaignRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetActiveNpsCampaignRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignRequest} GetActiveNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetActiveNpsCampaignRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetActiveNpsCampaignRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.accountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetActiveNpsCampaignRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignRequest} GetActiveNpsCampaignRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetActiveNpsCampaignRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetActiveNpsCampaignRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetActiveNpsCampaignRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetActiveNpsCampaignRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignRequest} GetActiveNpsCampaignRequest
                     */
                    GetActiveNpsCampaignRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetActiveNpsCampaignRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetActiveNpsCampaignRequest();
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetActiveNpsCampaignRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @static
                     * @param {palexy.streaming.v1.GetActiveNpsCampaignRequest} message GetActiveNpsCampaignRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetActiveNpsCampaignRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        return object;
                    };
    
                    /**
                     * Converts this GetActiveNpsCampaignRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetActiveNpsCampaignRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetActiveNpsCampaignRequest;
                })();
    
                v1.GetActiveNpsCampaignResponse = (function() {
    
                    /**
                     * Properties of a GetActiveNpsCampaignResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetActiveNpsCampaignResponse
                     * @property {palexy.streaming.v1.INpsCampaign|null} [campaign] GetActiveNpsCampaignResponse campaign
                     */
    
                    /**
                     * Constructs a new GetActiveNpsCampaignResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetActiveNpsCampaignResponse.
                     * @implements IGetActiveNpsCampaignResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignResponse=} [properties] Properties to set
                     */
                    function GetActiveNpsCampaignResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetActiveNpsCampaignResponse campaign.
                     * @member {palexy.streaming.v1.INpsCampaign|null|undefined} campaign
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @instance
                     */
                    GetActiveNpsCampaignResponse.prototype.campaign = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * GetActiveNpsCampaignResponse option.
                     * @member {"campaign"|undefined} option
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @instance
                     */
                    Object.defineProperty(GetActiveNpsCampaignResponse.prototype, "option", {
                        get: $util.oneOfGetter($oneOfFields = ["campaign"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new GetActiveNpsCampaignResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignResponse} GetActiveNpsCampaignResponse instance
                     */
                    GetActiveNpsCampaignResponse.create = function create(properties) {
                        return new GetActiveNpsCampaignResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetActiveNpsCampaignResponse message. Does not implicitly {@link palexy.streaming.v1.GetActiveNpsCampaignResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignResponse} message GetActiveNpsCampaignResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetActiveNpsCampaignResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.campaign != null && Object.hasOwnProperty.call(message, "campaign"))
                            $root.palexy.streaming.v1.NpsCampaign.encode(message.campaign, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetActiveNpsCampaignResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetActiveNpsCampaignResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetActiveNpsCampaignResponse} message GetActiveNpsCampaignResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetActiveNpsCampaignResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetActiveNpsCampaignResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignResponse} GetActiveNpsCampaignResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetActiveNpsCampaignResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetActiveNpsCampaignResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.campaign = $root.palexy.streaming.v1.NpsCampaign.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetActiveNpsCampaignResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignResponse} GetActiveNpsCampaignResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetActiveNpsCampaignResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetActiveNpsCampaignResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetActiveNpsCampaignResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.campaign != null && message.hasOwnProperty("campaign")) {
                            properties.option = 1;
                            {
                                var error = $root.palexy.streaming.v1.NpsCampaign.verify(message.campaign);
                                if (error)
                                    return "campaign." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetActiveNpsCampaignResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetActiveNpsCampaignResponse} GetActiveNpsCampaignResponse
                     */
                    GetActiveNpsCampaignResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetActiveNpsCampaignResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetActiveNpsCampaignResponse();
                        if (object.campaign != null) {
                            if (typeof object.campaign !== "object")
                                throw TypeError(".palexy.streaming.v1.GetActiveNpsCampaignResponse.campaign: object expected");
                            message.campaign = $root.palexy.streaming.v1.NpsCampaign.fromObject(object.campaign);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetActiveNpsCampaignResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @static
                     * @param {palexy.streaming.v1.GetActiveNpsCampaignResponse} message GetActiveNpsCampaignResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetActiveNpsCampaignResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.campaign != null && message.hasOwnProperty("campaign")) {
                            object.campaign = $root.palexy.streaming.v1.NpsCampaign.toObject(message.campaign, options);
                            if (options.oneofs)
                                object.option = "campaign";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetActiveNpsCampaignResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetActiveNpsCampaignResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetActiveNpsCampaignResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetActiveNpsCampaignResponse;
                })();
    
                v1.NpsCampaign = (function() {
    
                    /**
                     * Properties of a NpsCampaign.
                     * @memberof palexy.streaming.v1
                     * @interface INpsCampaign
                     * @property {number|null} [id] NpsCampaign id
                     * @property {string|null} [name] NpsCampaign name
                     * @property {number|null} [startTimeMs] NpsCampaign startTimeMs
                     * @property {number|null} [endTimeMs] NpsCampaign endTimeMs
                     * @property {number|null} [createTimeMs] NpsCampaign createTimeMs
                     * @property {boolean|null} [disabled] NpsCampaign disabled
                     */
    
                    /**
                     * Constructs a new NpsCampaign.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a NpsCampaign.
                     * @implements INpsCampaign
                     * @constructor
                     * @param {palexy.streaming.v1.INpsCampaign=} [properties] Properties to set
                     */
                    function NpsCampaign(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NpsCampaign id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsCampaign name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.name = "";
    
                    /**
                     * NpsCampaign startTimeMs.
                     * @member {number} startTimeMs
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.startTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsCampaign endTimeMs.
                     * @member {number} endTimeMs
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.endTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsCampaign createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsCampaign disabled.
                     * @member {boolean} disabled
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     */
                    NpsCampaign.prototype.disabled = false;
    
                    /**
                     * Creates a new NpsCampaign instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {palexy.streaming.v1.INpsCampaign=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.NpsCampaign} NpsCampaign instance
                     */
                    NpsCampaign.create = function create(properties) {
                        return new NpsCampaign(properties);
                    };
    
                    /**
                     * Encodes the specified NpsCampaign message. Does not implicitly {@link palexy.streaming.v1.NpsCampaign.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {palexy.streaming.v1.INpsCampaign} message NpsCampaign message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsCampaign.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.startTimeMs != null && Object.hasOwnProperty.call(message, "startTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.startTimeMs);
                        if (message.endTimeMs != null && Object.hasOwnProperty.call(message, "endTimeMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.endTimeMs);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.disabled != null && Object.hasOwnProperty.call(message, "disabled"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.disabled);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NpsCampaign message, length delimited. Does not implicitly {@link palexy.streaming.v1.NpsCampaign.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {palexy.streaming.v1.INpsCampaign} message NpsCampaign message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsCampaign.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NpsCampaign message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.NpsCampaign} NpsCampaign
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsCampaign.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.NpsCampaign();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.startTimeMs = reader.int64();
                                break;
                            case 4:
                                message.endTimeMs = reader.int64();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.disabled = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a NpsCampaign message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.NpsCampaign} NpsCampaign
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsCampaign.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NpsCampaign message.
                     * @function verify
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NpsCampaign.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                            if (!$util.isInteger(message.startTimeMs) && !(message.startTimeMs && $util.isInteger(message.startTimeMs.low) && $util.isInteger(message.startTimeMs.high)))
                                return "startTimeMs: integer|Long expected";
                        if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                            if (!$util.isInteger(message.endTimeMs) && !(message.endTimeMs && $util.isInteger(message.endTimeMs.low) && $util.isInteger(message.endTimeMs.high)))
                                return "endTimeMs: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            if (typeof message.disabled !== "boolean")
                                return "disabled: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a NpsCampaign message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.NpsCampaign} NpsCampaign
                     */
                    NpsCampaign.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.NpsCampaign)
                            return object;
                        var message = new $root.palexy.streaming.v1.NpsCampaign();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.startTimeMs != null)
                            if ($util.Long)
                                (message.startTimeMs = $util.Long.fromValue(object.startTimeMs)).unsigned = false;
                            else if (typeof object.startTimeMs === "string")
                                message.startTimeMs = parseInt(object.startTimeMs, 10);
                            else if (typeof object.startTimeMs === "number")
                                message.startTimeMs = object.startTimeMs;
                            else if (typeof object.startTimeMs === "object")
                                message.startTimeMs = new $util.LongBits(object.startTimeMs.low >>> 0, object.startTimeMs.high >>> 0).toNumber();
                        if (object.endTimeMs != null)
                            if ($util.Long)
                                (message.endTimeMs = $util.Long.fromValue(object.endTimeMs)).unsigned = false;
                            else if (typeof object.endTimeMs === "string")
                                message.endTimeMs = parseInt(object.endTimeMs, 10);
                            else if (typeof object.endTimeMs === "number")
                                message.endTimeMs = object.endTimeMs;
                            else if (typeof object.endTimeMs === "object")
                                message.endTimeMs = new $util.LongBits(object.endTimeMs.low >>> 0, object.endTimeMs.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.disabled != null)
                            message.disabled = Boolean(object.disabled);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NpsCampaign message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @static
                     * @param {palexy.streaming.v1.NpsCampaign} message NpsCampaign
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NpsCampaign.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.startTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.endTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.endTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            object.disabled = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.startTimeMs != null && message.hasOwnProperty("startTimeMs"))
                            if (typeof message.startTimeMs === "number")
                                object.startTimeMs = options.longs === String ? String(message.startTimeMs) : message.startTimeMs;
                            else
                                object.startTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.startTimeMs) : options.longs === Number ? new $util.LongBits(message.startTimeMs.low >>> 0, message.startTimeMs.high >>> 0).toNumber() : message.startTimeMs;
                        if (message.endTimeMs != null && message.hasOwnProperty("endTimeMs"))
                            if (typeof message.endTimeMs === "number")
                                object.endTimeMs = options.longs === String ? String(message.endTimeMs) : message.endTimeMs;
                            else
                                object.endTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.endTimeMs) : options.longs === Number ? new $util.LongBits(message.endTimeMs.low >>> 0, message.endTimeMs.high >>> 0).toNumber() : message.endTimeMs;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            object.disabled = message.disabled;
                        return object;
                    };
    
                    /**
                     * Converts this NpsCampaign to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.NpsCampaign
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NpsCampaign.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NpsCampaign;
                })();
    
                v1.NpsResponse = (function() {
    
                    /**
                     * Properties of a NpsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface INpsResponse
                     * @property {number|null} [campaignId] NpsResponse campaignId
                     * @property {number|null} [accountId] NpsResponse accountId
                     * @property {number|null} [score] NpsResponse score
                     * @property {string|null} [message] NpsResponse message
                     * @property {boolean|null} [rejected] NpsResponse rejected
                     * @property {number|null} [createTimeMs] NpsResponse createTimeMs
                     */
    
                    /**
                     * Constructs a new NpsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a NpsResponse.
                     * @implements INpsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.INpsResponse=} [properties] Properties to set
                     */
                    function NpsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NpsResponse campaignId.
                     * @member {number} campaignId
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.campaignId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsResponse accountId.
                     * @member {number} accountId
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * NpsResponse score.
                     * @member {number} score
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.score = 0;
    
                    /**
                     * NpsResponse message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.message = "";
    
                    /**
                     * NpsResponse rejected.
                     * @member {boolean} rejected
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.rejected = false;
    
                    /**
                     * NpsResponse createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     */
                    NpsResponse.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new NpsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {palexy.streaming.v1.INpsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.NpsResponse} NpsResponse instance
                     */
                    NpsResponse.create = function create(properties) {
                        return new NpsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified NpsResponse message. Does not implicitly {@link palexy.streaming.v1.NpsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {palexy.streaming.v1.INpsResponse} message NpsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.campaignId != null && Object.hasOwnProperty.call(message, "campaignId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.campaignId);
                        if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.accountId);
                        if (message.score != null && Object.hasOwnProperty.call(message, "score"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.score);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
                        if (message.rejected != null && Object.hasOwnProperty.call(message, "rejected"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.rejected);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NpsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.NpsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {palexy.streaming.v1.INpsResponse} message NpsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NpsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.NpsResponse} NpsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.NpsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.campaignId = reader.int64();
                                break;
                            case 2:
                                message.accountId = reader.int64();
                                break;
                            case 3:
                                message.score = reader.int32();
                                break;
                            case 4:
                                message.message = reader.string();
                                break;
                            case 5:
                                message.rejected = reader.bool();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a NpsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.NpsResponse} NpsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NpsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NpsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                            if (!$util.isInteger(message.campaignId) && !(message.campaignId && $util.isInteger(message.campaignId.low) && $util.isInteger(message.campaignId.high)))
                                return "campaignId: integer|Long expected";
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                                return "accountId: integer|Long expected";
                        if (message.score != null && message.hasOwnProperty("score"))
                            if (!$util.isInteger(message.score))
                                return "score: integer expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.rejected != null && message.hasOwnProperty("rejected"))
                            if (typeof message.rejected !== "boolean")
                                return "rejected: boolean expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a NpsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.NpsResponse} NpsResponse
                     */
                    NpsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.NpsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.NpsResponse();
                        if (object.campaignId != null)
                            if ($util.Long)
                                (message.campaignId = $util.Long.fromValue(object.campaignId)).unsigned = false;
                            else if (typeof object.campaignId === "string")
                                message.campaignId = parseInt(object.campaignId, 10);
                            else if (typeof object.campaignId === "number")
                                message.campaignId = object.campaignId;
                            else if (typeof object.campaignId === "object")
                                message.campaignId = new $util.LongBits(object.campaignId.low >>> 0, object.campaignId.high >>> 0).toNumber();
                        if (object.accountId != null)
                            if ($util.Long)
                                (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                            else if (typeof object.accountId === "string")
                                message.accountId = parseInt(object.accountId, 10);
                            else if (typeof object.accountId === "number")
                                message.accountId = object.accountId;
                            else if (typeof object.accountId === "object")
                                message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                        if (object.score != null)
                            message.score = object.score | 0;
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.rejected != null)
                            message.rejected = Boolean(object.rejected);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NpsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @static
                     * @param {palexy.streaming.v1.NpsResponse} message NpsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NpsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.campaignId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.campaignId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.accountId = options.longs === String ? "0" : 0;
                            object.score = 0;
                            object.message = "";
                            object.rejected = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.campaignId != null && message.hasOwnProperty("campaignId"))
                            if (typeof message.campaignId === "number")
                                object.campaignId = options.longs === String ? String(message.campaignId) : message.campaignId;
                            else
                                object.campaignId = options.longs === String ? $util.Long.prototype.toString.call(message.campaignId) : options.longs === Number ? new $util.LongBits(message.campaignId.low >>> 0, message.campaignId.high >>> 0).toNumber() : message.campaignId;
                        if (message.accountId != null && message.hasOwnProperty("accountId"))
                            if (typeof message.accountId === "number")
                                object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                            else
                                object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                        if (message.score != null && message.hasOwnProperty("score"))
                            object.score = message.score;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.rejected != null && message.hasOwnProperty("rejected"))
                            object.rejected = message.rejected;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this NpsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.NpsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NpsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NpsResponse;
                })();
    
                v1.StaffService = (function() {
    
                    /**
                     * Constructs a new StaffService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffService;
    
                    /**
                     * Creates new StaffService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#createStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef CreateStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Staff} [response] Staff
                     */
    
                    /**
                     * Calls CreateStaff.
                     * @function createStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffRequest} request CreateStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.CreateStaffCallback} callback Node-style callback called with the error, if any, and Staff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.createStaff = function createStaff(request, callback) {
                        return this.rpcCall(createStaff, $root.palexy.streaming.v1.CreateStaffRequest, $root.palexy.streaming.v1.Staff, request, callback);
                    }, "name", { value: "CreateStaff" });
    
                    /**
                     * Calls CreateStaff.
                     * @function createStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffRequest} request CreateStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Staff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#validateStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ValidateStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ValidateStaffResponse} [response] ValidateStaffResponse
                     */
    
                    /**
                     * Calls ValidateStaff.
                     * @function validateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IValidateStaffRequest} request ValidateStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ValidateStaffCallback} callback Node-style callback called with the error, if any, and ValidateStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.validateStaff = function validateStaff(request, callback) {
                        return this.rpcCall(validateStaff, $root.palexy.streaming.v1.ValidateStaffRequest, $root.palexy.streaming.v1.ValidateStaffResponse, request, callback);
                    }, "name", { value: "ValidateStaff" });
    
                    /**
                     * Calls ValidateStaff.
                     * @function validateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IValidateStaffRequest} request ValidateStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ValidateStaffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#moveStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef MoveStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.MoveStaffResponse} [response] MoveStaffResponse
                     */
    
                    /**
                     * Calls MoveStaff.
                     * @function moveStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IMoveStaffRequest} request MoveStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.MoveStaffCallback} callback Node-style callback called with the error, if any, and MoveStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.moveStaff = function moveStaff(request, callback) {
                        return this.rpcCall(moveStaff, $root.palexy.streaming.v1.MoveStaffRequest, $root.palexy.streaming.v1.MoveStaffResponse, request, callback);
                    }, "name", { value: "MoveStaff" });
    
                    /**
                     * Calls MoveStaff.
                     * @function moveStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IMoveStaffRequest} request MoveStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.MoveStaffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#updateStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef UpdateStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Staff} [response] Staff
                     */
    
                    /**
                     * Calls UpdateStaff.
                     * @function updateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffRequest} request UpdateStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.UpdateStaffCallback} callback Node-style callback called with the error, if any, and Staff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.updateStaff = function updateStaff(request, callback) {
                        return this.rpcCall(updateStaff, $root.palexy.streaming.v1.UpdateStaffRequest, $root.palexy.streaming.v1.Staff, request, callback);
                    }, "name", { value: "UpdateStaff" });
    
                    /**
                     * Calls UpdateStaff.
                     * @function updateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffRequest} request UpdateStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Staff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#uploadStaffPhoto}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef UploadStaffPhotoCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Staff} [response] Staff
                     */
    
                    /**
                     * Calls UploadStaffPhoto.
                     * @function uploadStaffPhoto
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest} request UploadStaffPhotoRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.UploadStaffPhotoCallback} callback Node-style callback called with the error, if any, and Staff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.uploadStaffPhoto = function uploadStaffPhoto(request, callback) {
                        return this.rpcCall(uploadStaffPhoto, $root.palexy.streaming.v1.UploadStaffPhotoRequest, $root.palexy.streaming.v1.Staff, request, callback);
                    }, "name", { value: "UploadStaffPhoto" });
    
                    /**
                     * Calls UploadStaffPhoto.
                     * @function uploadStaffPhoto
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest} request UploadStaffPhotoRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Staff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#getStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef GetStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Staff} [response] Staff
                     */
    
                    /**
                     * Calls GetStaff.
                     * @function getStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffRequest} request GetStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.GetStaffCallback} callback Node-style callback called with the error, if any, and Staff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.getStaff = function getStaff(request, callback) {
                        return this.rpcCall(getStaff, $root.palexy.streaming.v1.GetStaffRequest, $root.palexy.streaming.v1.Staff, request, callback);
                    }, "name", { value: "GetStaff" });
    
                    /**
                     * Calls GetStaff.
                     * @function getStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffRequest} request GetStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Staff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#listStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ListStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffResponse} [response] ListStaffResponse
                     */
    
                    /**
                     * Calls ListStaff.
                     * @function listStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffRequest} request ListStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ListStaffCallback} callback Node-style callback called with the error, if any, and ListStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.listStaff = function listStaff(request, callback) {
                        return this.rpcCall(listStaff, $root.palexy.streaming.v1.ListStaffRequest, $root.palexy.streaming.v1.ListStaffResponse, request, callback);
                    }, "name", { value: "ListStaff" });
    
                    /**
                     * Calls ListStaff.
                     * @function listStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffRequest} request ListStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#batchCreateStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef BatchCreateStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateStaffResponse} [response] BatchCreateStaffResponse
                     */
    
                    /**
                     * Calls BatchCreateStaff.
                     * @function batchCreateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest} request BatchCreateStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.BatchCreateStaffCallback} callback Node-style callback called with the error, if any, and BatchCreateStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.batchCreateStaff = function batchCreateStaff(request, callback) {
                        return this.rpcCall(batchCreateStaff, $root.palexy.streaming.v1.BatchCreateStaffRequest, $root.palexy.streaming.v1.BatchCreateStaffResponse, request, callback);
                    }, "name", { value: "BatchCreateStaff" });
    
                    /**
                     * Calls BatchCreateStaff.
                     * @function batchCreateStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest} request BatchCreateStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateStaffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#listUnmappedStaffId}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ListUnmappedStaffIdCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListUnmappedStaffIdResponse} [response] ListUnmappedStaffIdResponse
                     */
    
                    /**
                     * Calls ListUnmappedStaffId.
                     * @function listUnmappedStaffId
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest} request ListUnmappedStaffIdRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ListUnmappedStaffIdCallback} callback Node-style callback called with the error, if any, and ListUnmappedStaffIdResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.listUnmappedStaffId = function listUnmappedStaffId(request, callback) {
                        return this.rpcCall(listUnmappedStaffId, $root.palexy.streaming.v1.ListUnmappedStaffIdRequest, $root.palexy.streaming.v1.ListUnmappedStaffIdResponse, request, callback);
                    }, "name", { value: "ListUnmappedStaffId" });
    
                    /**
                     * Calls ListUnmappedStaffId.
                     * @function listUnmappedStaffId
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest} request ListUnmappedStaffIdRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListUnmappedStaffIdResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#listStaffSalesHistory}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ListStaffSalesHistoryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffSalesHistoryResponse} [response] ListStaffSalesHistoryResponse
                     */
    
                    /**
                     * Calls ListStaffSalesHistory.
                     * @function listStaffSalesHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest} request ListStaffSalesHistoryRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ListStaffSalesHistoryCallback} callback Node-style callback called with the error, if any, and ListStaffSalesHistoryResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.listStaffSalesHistory = function listStaffSalesHistory(request, callback) {
                        return this.rpcCall(listStaffSalesHistory, $root.palexy.streaming.v1.ListStaffSalesHistoryRequest, $root.palexy.streaming.v1.ListStaffSalesHistoryResponse, request, callback);
                    }, "name", { value: "ListStaffSalesHistory" });
    
                    /**
                     * Calls ListStaffSalesHistory.
                     * @function listStaffSalesHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest} request ListStaffSalesHistoryRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffSalesHistoryResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#assignStaffToStore}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef AssignStaffToStoreCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.AssignStaffToStoreResponse} [response] AssignStaffToStoreResponse
                     */
    
                    /**
                     * Calls AssignStaffToStore.
                     * @function assignStaffToStore
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest} request AssignStaffToStoreRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.AssignStaffToStoreCallback} callback Node-style callback called with the error, if any, and AssignStaffToStoreResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.assignStaffToStore = function assignStaffToStore(request, callback) {
                        return this.rpcCall(assignStaffToStore, $root.palexy.streaming.v1.AssignStaffToStoreRequest, $root.palexy.streaming.v1.AssignStaffToStoreResponse, request, callback);
                    }, "name", { value: "AssignStaffToStore" });
    
                    /**
                     * Calls AssignStaffToStore.
                     * @function assignStaffToStore
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest} request AssignStaffToStoreRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.AssignStaffToStoreResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#removeStaffFromStore}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef RemoveStaffFromStoreCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.RemoveStaffFromStoreResponse} [response] RemoveStaffFromStoreResponse
                     */
    
                    /**
                     * Calls RemoveStaffFromStore.
                     * @function removeStaffFromStore
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest} request RemoveStaffFromStoreRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.RemoveStaffFromStoreCallback} callback Node-style callback called with the error, if any, and RemoveStaffFromStoreResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.removeStaffFromStore = function removeStaffFromStore(request, callback) {
                        return this.rpcCall(removeStaffFromStore, $root.palexy.streaming.v1.RemoveStaffFromStoreRequest, $root.palexy.streaming.v1.RemoveStaffFromStoreResponse, request, callback);
                    }, "name", { value: "RemoveStaffFromStore" });
    
                    /**
                     * Calls RemoveStaffFromStore.
                     * @function removeStaffFromStore
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest} request RemoveStaffFromStoreRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.RemoveStaffFromStoreResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#sendStaffInvitation}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef SendStaffInvitationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls SendStaffInvitation.
                     * @function sendStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest} request SendStaffInvitationRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.SendStaffInvitationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.sendStaffInvitation = function sendStaffInvitation(request, callback) {
                        return this.rpcCall(sendStaffInvitation, $root.palexy.streaming.v1.SendStaffInvitationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "SendStaffInvitation" });
    
                    /**
                     * Calls SendStaffInvitation.
                     * @function sendStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest} request SendStaffInvitationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#expireStaffInvitation}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ExpireStaffInvitationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ExpireStaffInvitation.
                     * @function expireStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest} request ExpireStaffInvitationRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ExpireStaffInvitationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.expireStaffInvitation = function expireStaffInvitation(request, callback) {
                        return this.rpcCall(expireStaffInvitation, $root.palexy.streaming.v1.ExpireStaffInvitationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ExpireStaffInvitation" });
    
                    /**
                     * Calls ExpireStaffInvitation.
                     * @function expireStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest} request ExpireStaffInvitationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#invalidateLatestStaffInvitationHistory}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef InvalidateLatestStaffInvitationHistoryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls InvalidateLatestStaffInvitationHistory.
                     * @function invalidateLatestStaffInvitationHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest} request InvalidateLatestStaffInvitationHistoryRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.InvalidateLatestStaffInvitationHistoryCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.invalidateLatestStaffInvitationHistory = function invalidateLatestStaffInvitationHistory(request, callback) {
                        return this.rpcCall(invalidateLatestStaffInvitationHistory, $root.palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "InvalidateLatestStaffInvitationHistory" });
    
                    /**
                     * Calls InvalidateLatestStaffInvitationHistory.
                     * @function invalidateLatestStaffInvitationHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest} request InvalidateLatestStaffInvitationHistoryRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#batchInviteStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef BatchInviteStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchInviteStaffResponse} [response] BatchInviteStaffResponse
                     */
    
                    /**
                     * Calls BatchInviteStaff.
                     * @function batchInviteStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest} request BatchInviteStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.BatchInviteStaffCallback} callback Node-style callback called with the error, if any, and BatchInviteStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.batchInviteStaff = function batchInviteStaff(request, callback) {
                        return this.rpcCall(batchInviteStaff, $root.palexy.streaming.v1.BatchInviteStaffRequest, $root.palexy.streaming.v1.BatchInviteStaffResponse, request, callback);
                    }, "name", { value: "BatchInviteStaff" });
    
                    /**
                     * Calls BatchInviteStaff.
                     * @function batchInviteStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest} request BatchInviteStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchInviteStaffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#confirmStaffInvitation}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ConfirmStaffInvitationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ConfirmStaffInvitation.
                     * @function confirmStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest} request ConfirmStaffInvitationRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ConfirmStaffInvitationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.confirmStaffInvitation = function confirmStaffInvitation(request, callback) {
                        return this.rpcCall(confirmStaffInvitation, $root.palexy.streaming.v1.ConfirmStaffInvitationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ConfirmStaffInvitation" });
    
                    /**
                     * Calls ConfirmStaffInvitation.
                     * @function confirmStaffInvitation
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest} request ConfirmStaffInvitationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#createInvitationHistory}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef CreateInvitationHistoryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffInvitationHistory} [response] StaffInvitationHistory
                     */
    
                    /**
                     * Calls CreateInvitationHistory.
                     * @function createInvitationHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest} request CreateStaffInvitationHistoryRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.CreateInvitationHistoryCallback} callback Node-style callback called with the error, if any, and StaffInvitationHistory
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.createInvitationHistory = function createInvitationHistory(request, callback) {
                        return this.rpcCall(createInvitationHistory, $root.palexy.streaming.v1.CreateStaffInvitationHistoryRequest, $root.palexy.streaming.v1.StaffInvitationHistory, request, callback);
                    }, "name", { value: "CreateInvitationHistory" });
    
                    /**
                     * Calls CreateInvitationHistory.
                     * @function createInvitationHistory
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest} request CreateStaffInvitationHistoryRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffInvitationHistory>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#updateStaffByAccount}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef UpdateStaffByAccountCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls UpdateStaffByAccount.
                     * @function updateStaffByAccount
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest} request UpdateStaffByAccountRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.UpdateStaffByAccountCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.updateStaffByAccount = function updateStaffByAccount(request, callback) {
                        return this.rpcCall(updateStaffByAccount, $root.palexy.streaming.v1.UpdateStaffByAccountRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "UpdateStaffByAccount" });
    
                    /**
                     * Calls UpdateStaffByAccount.
                     * @function updateStaffByAccount
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest} request UpdateStaffByAccountRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#batchUpdateStaffAreaOrderIndices}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef BatchUpdateStaffAreaOrderIndicesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} [response] BatchUpdateStaffAreaOrderIndicesResponse
                     */
    
                    /**
                     * Calls BatchUpdateStaffAreaOrderIndices.
                     * @function batchUpdateStaffAreaOrderIndices
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest} request BatchUpdateStaffAreaOrderIndicesRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.BatchUpdateStaffAreaOrderIndicesCallback} callback Node-style callback called with the error, if any, and BatchUpdateStaffAreaOrderIndicesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.batchUpdateStaffAreaOrderIndices = function batchUpdateStaffAreaOrderIndices(request, callback) {
                        return this.rpcCall(batchUpdateStaffAreaOrderIndices, $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest, $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse, request, callback);
                    }, "name", { value: "BatchUpdateStaffAreaOrderIndices" });
    
                    /**
                     * Calls BatchUpdateStaffAreaOrderIndices.
                     * @function batchUpdateStaffAreaOrderIndices
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest} request BatchUpdateStaffAreaOrderIndicesRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#populateWorkforceData}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef PopulateWorkforceDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PopulateWorkforceDataResponse} [response] PopulateWorkforceDataResponse
                     */
    
                    /**
                     * Calls PopulateWorkforceData.
                     * @function populateWorkforceData
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest} request PopulateWorkforceDataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.PopulateWorkforceDataCallback} callback Node-style callback called with the error, if any, and PopulateWorkforceDataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.populateWorkforceData = function populateWorkforceData(request, callback) {
                        return this.rpcCall(populateWorkforceData, $root.palexy.streaming.v1.PopulateWorkforceDataRequest, $root.palexy.streaming.v1.PopulateWorkforceDataResponse, request, callback);
                    }, "name", { value: "PopulateWorkforceData" });
    
                    /**
                     * Calls PopulateWorkforceData.
                     * @function populateWorkforceData
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest} request PopulateWorkforceDataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PopulateWorkforceDataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffService#listDayOffStaff}.
                     * @memberof palexy.streaming.v1.StaffService
                     * @typedef ListDayOffStaffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListDayOffStaffResponse} [response] ListDayOffStaffResponse
                     */
    
                    /**
                     * Calls ListDayOffStaff.
                     * @function listDayOffStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest} request ListDayOffStaffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffService.ListDayOffStaffCallback} callback Node-style callback called with the error, if any, and ListDayOffStaffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffService.prototype.listDayOffStaff = function listDayOffStaff(request, callback) {
                        return this.rpcCall(listDayOffStaff, $root.palexy.streaming.v1.ListDayOffStaffRequest, $root.palexy.streaming.v1.ListDayOffStaffResponse, request, callback);
                    }, "name", { value: "ListDayOffStaff" });
    
                    /**
                     * Calls ListDayOffStaff.
                     * @function listDayOffStaff
                     * @memberof palexy.streaming.v1.StaffService
                     * @instance
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest} request ListDayOffStaffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListDayOffStaffResponse>} Promise
                     * @variation 2
                     */
    
                    return StaffService;
                })();
    
                v1.StaffMetadataService = (function() {
    
                    /**
                     * Constructs a new StaffMetadataService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffMetadataService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffMetadataService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffMetadataService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffMetadataService;
    
                    /**
                     * Creates new StaffMetadataService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffMetadataService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffMetadataService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffMetadataService#createStaffMetadata}.
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @typedef CreateStaffMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.protobuf.StaffMetadata} [response] StaffMetadata
                     */
    
                    /**
                     * Calls CreateStaffMetadata.
                     * @function createStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.protobuf.IStaffMetadata} request StaffMetadata message or plain object
                     * @param {palexy.streaming.v1.StaffMetadataService.CreateStaffMetadataCallback} callback Node-style callback called with the error, if any, and StaffMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffMetadataService.prototype.createStaffMetadata = function createStaffMetadata(request, callback) {
                        return this.rpcCall(createStaffMetadata, $root.palexy.protobuf.StaffMetadata, $root.palexy.protobuf.StaffMetadata, request, callback);
                    }, "name", { value: "CreateStaffMetadata" });
    
                    /**
                     * Calls CreateStaffMetadata.
                     * @function createStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.protobuf.IStaffMetadata} request StaffMetadata message or plain object
                     * @returns {Promise<palexy.protobuf.StaffMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffMetadataService#updateStaffMetadata}.
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @typedef UpdateStaffMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.protobuf.StaffMetadata} [response] StaffMetadata
                     */
    
                    /**
                     * Calls UpdateStaffMetadata.
                     * @function updateStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.protobuf.IStaffMetadata} request StaffMetadata message or plain object
                     * @param {palexy.streaming.v1.StaffMetadataService.UpdateStaffMetadataCallback} callback Node-style callback called with the error, if any, and StaffMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffMetadataService.prototype.updateStaffMetadata = function updateStaffMetadata(request, callback) {
                        return this.rpcCall(updateStaffMetadata, $root.palexy.protobuf.StaffMetadata, $root.palexy.protobuf.StaffMetadata, request, callback);
                    }, "name", { value: "UpdateStaffMetadata" });
    
                    /**
                     * Calls UpdateStaffMetadata.
                     * @function updateStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.protobuf.IStaffMetadata} request StaffMetadata message or plain object
                     * @returns {Promise<palexy.protobuf.StaffMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffMetadataService#deleteStaffMetadata}.
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @typedef DeleteStaffMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStaffMetadata.
                     * @function deleteStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest} request DeleteStaffMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffMetadataService.DeleteStaffMetadataCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffMetadataService.prototype.deleteStaffMetadata = function deleteStaffMetadata(request, callback) {
                        return this.rpcCall(deleteStaffMetadata, $root.palexy.streaming.v1.DeleteStaffMetadataRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStaffMetadata" });
    
                    /**
                     * Calls DeleteStaffMetadata.
                     * @function deleteStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest} request DeleteStaffMetadataRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffMetadataService#getStaffMetadata}.
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @typedef GetStaffMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.protobuf.StaffMetadata} [response] StaffMetadata
                     */
    
                    /**
                     * Calls GetStaffMetadata.
                     * @function getStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest} request GetStaffMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffMetadataService.GetStaffMetadataCallback} callback Node-style callback called with the error, if any, and StaffMetadata
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffMetadataService.prototype.getStaffMetadata = function getStaffMetadata(request, callback) {
                        return this.rpcCall(getStaffMetadata, $root.palexy.streaming.v1.GetStaffMetadataRequest, $root.palexy.protobuf.StaffMetadata, request, callback);
                    }, "name", { value: "GetStaffMetadata" });
    
                    /**
                     * Calls GetStaffMetadata.
                     * @function getStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest} request GetStaffMetadataRequest message or plain object
                     * @returns {Promise<palexy.protobuf.StaffMetadata>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffMetadataService#listStaffMetadata}.
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @typedef ListStaffMetadataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffMetadataResponse} [response] ListStaffMetadataResponse
                     */
    
                    /**
                     * Calls ListStaffMetadata.
                     * @function listStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest} request ListStaffMetadataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffMetadataService.ListStaffMetadataCallback} callback Node-style callback called with the error, if any, and ListStaffMetadataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffMetadataService.prototype.listStaffMetadata = function listStaffMetadata(request, callback) {
                        return this.rpcCall(listStaffMetadata, $root.palexy.streaming.v1.ListStaffMetadataRequest, $root.palexy.streaming.v1.ListStaffMetadataResponse, request, callback);
                    }, "name", { value: "ListStaffMetadata" });
    
                    /**
                     * Calls ListStaffMetadata.
                     * @function listStaffMetadata
                     * @memberof palexy.streaming.v1.StaffMetadataService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest} request ListStaffMetadataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffMetadataResponse>} Promise
                     * @variation 2
                     */
    
                    return StaffMetadataService;
                })();
    
                v1.Staff = (function() {
    
                    /**
                     * Properties of a Staff.
                     * @memberof palexy.streaming.v1
                     * @interface IStaff
                     * @property {number|null} [id] Staff id
                     * @property {number|null} [storeId] Staff storeId
                     * @property {string|null} [fullName] Staff fullName
                     * @property {string|null} [title] Staff title
                     * @property {string|null} [mobile] Staff mobile
                     * @property {boolean|null} [disabled] Staff disabled
                     * @property {string|null} [profilePhotoUrl] Staff profilePhotoUrl
                     * @property {number|null} [createTimeMs] Staff createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Staff lastUpdateTimeMs
                     * @property {number|null} [companyId] Staff companyId
                     * @property {Array.<palexy.streaming.v1.IStaffAssignedStore>|null} [assignedStores] Staff assignedStores
                     * @property {number|null} [preferredScheduleAreaId] Staff preferredScheduleAreaId
                     * @property {palexy.streaming.v1.IScheduleArea|null} [preferredScheduleArea] Staff preferredScheduleArea
                     * @property {number|null} [creatorId] Staff creatorId
                     * @property {Array.<string>|null} [posExternalStaffId] Staff posExternalStaffId
                     * @property {Array.<string>|null} [staffingExternalStaffId] Staff staffingExternalStaffId
                     * @property {boolean|null} [isSyncPosStaff] Staff isSyncPosStaff
                     * @property {palexy.streaming.v1.Staff.IProfilePhotoMetadata|null} [profilePhotoMetadata] Staff profilePhotoMetadata
                     * @property {string|null} [email] Staff email
                     * @property {string|null} [accountUsername] Staff accountUsername
                     * @property {boolean|null} [waitingForInvitation] Staff waitingForInvitation
                     * @property {palexy.streaming.v1.StaffInvitationStatus|null} [invitationStatus] Staff invitationStatus
                     * @property {string|null} [invitationErrorMessage] Staff invitationErrorMessage
                     * @property {Array.<number>|null} [staffPositionIds] Staff staffPositionIds
                     * @property {Array.<palexy.streaming.v1.IStaffPosition>|null} [staffPositions] Staff staffPositions
                     * @property {palexy.protobuf.IStaffWorkingSetting|null} [workingSetting] Staff workingSetting
                     * @property {palexy.protobuf.StaffEmploymentType|null} [employmentType] Staff employmentType
                     * @property {Array.<palexy.streaming.v1.IStaffAssignPosition>|null} [staffAssignPositions] Staff staffAssignPositions
                     * @property {string|null} [lastWorkingDateId] Staff lastWorkingDateId
                     * @property {string|null} [startDate] Staff startDate
                     * @property {palexy.protobuf.Gender|null} [gender] Staff gender
                     * @property {google.protobuf.IBoolValue|null} [hasScheduleManagerRole] Staff hasScheduleManagerRole
                     * @property {Array.<palexy.protobuf.IStaffMetadataValueMapping>|null} [metadataValues] Staff metadataValues
                     * @property {Array.<palexy.protobuf.IEmployeePolicyRule>|null} [applyEmployeePolicyRules] Staff applyEmployeePolicyRules
                     */
    
                    /**
                     * Constructs a new Staff.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Staff.
                     * @implements IStaff
                     * @constructor
                     * @param {palexy.streaming.v1.IStaff=} [properties] Properties to set
                     */
                    function Staff(properties) {
                        this.assignedStores = [];
                        this.posExternalStaffId = [];
                        this.staffingExternalStaffId = [];
                        this.staffPositionIds = [];
                        this.staffPositions = [];
                        this.staffAssignPositions = [];
                        this.metadataValues = [];
                        this.applyEmployeePolicyRules = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Staff id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff fullName.
                     * @member {string} fullName
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.fullName = "";
    
                    /**
                     * Staff title.
                     * @member {string} title
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.title = "";
    
                    /**
                     * Staff mobile.
                     * @member {string} mobile
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.mobile = "";
    
                    /**
                     * Staff disabled.
                     * @member {boolean} disabled
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.disabled = false;
    
                    /**
                     * Staff profilePhotoUrl.
                     * @member {string} profilePhotoUrl
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.profilePhotoUrl = "";
    
                    /**
                     * Staff createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff assignedStores.
                     * @member {Array.<palexy.streaming.v1.IStaffAssignedStore>} assignedStores
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.assignedStores = $util.emptyArray;
    
                    /**
                     * Staff preferredScheduleAreaId.
                     * @member {number} preferredScheduleAreaId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.preferredScheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff preferredScheduleArea.
                     * @member {palexy.streaming.v1.IScheduleArea|null|undefined} preferredScheduleArea
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.preferredScheduleArea = null;
    
                    /**
                     * Staff creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Staff posExternalStaffId.
                     * @member {Array.<string>} posExternalStaffId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.posExternalStaffId = $util.emptyArray;
    
                    /**
                     * Staff staffingExternalStaffId.
                     * @member {Array.<string>} staffingExternalStaffId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.staffingExternalStaffId = $util.emptyArray;
    
                    /**
                     * Staff isSyncPosStaff.
                     * @member {boolean} isSyncPosStaff
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.isSyncPosStaff = false;
    
                    /**
                     * Staff profilePhotoMetadata.
                     * @member {palexy.streaming.v1.Staff.IProfilePhotoMetadata|null|undefined} profilePhotoMetadata
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.profilePhotoMetadata = null;
    
                    /**
                     * Staff email.
                     * @member {string} email
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.email = "";
    
                    /**
                     * Staff accountUsername.
                     * @member {string} accountUsername
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.accountUsername = "";
    
                    /**
                     * Staff waitingForInvitation.
                     * @member {boolean} waitingForInvitation
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.waitingForInvitation = false;
    
                    /**
                     * Staff invitationStatus.
                     * @member {palexy.streaming.v1.StaffInvitationStatus} invitationStatus
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.invitationStatus = 0;
    
                    /**
                     * Staff invitationErrorMessage.
                     * @member {string} invitationErrorMessage
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.invitationErrorMessage = "";
    
                    /**
                     * Staff staffPositionIds.
                     * @member {Array.<number>} staffPositionIds
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.staffPositionIds = $util.emptyArray;
    
                    /**
                     * Staff staffPositions.
                     * @member {Array.<palexy.streaming.v1.IStaffPosition>} staffPositions
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.staffPositions = $util.emptyArray;
    
                    /**
                     * Staff workingSetting.
                     * @member {palexy.protobuf.IStaffWorkingSetting|null|undefined} workingSetting
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.workingSetting = null;
    
                    /**
                     * Staff employmentType.
                     * @member {palexy.protobuf.StaffEmploymentType} employmentType
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.employmentType = 0;
    
                    /**
                     * Staff staffAssignPositions.
                     * @member {Array.<palexy.streaming.v1.IStaffAssignPosition>} staffAssignPositions
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.staffAssignPositions = $util.emptyArray;
    
                    /**
                     * Staff lastWorkingDateId.
                     * @member {string} lastWorkingDateId
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.lastWorkingDateId = "";
    
                    /**
                     * Staff startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.startDate = "";
    
                    /**
                     * Staff gender.
                     * @member {palexy.protobuf.Gender} gender
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.gender = 0;
    
                    /**
                     * Staff hasScheduleManagerRole.
                     * @member {google.protobuf.IBoolValue|null|undefined} hasScheduleManagerRole
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.hasScheduleManagerRole = null;
    
                    /**
                     * Staff metadataValues.
                     * @member {Array.<palexy.protobuf.IStaffMetadataValueMapping>} metadataValues
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.metadataValues = $util.emptyArray;
    
                    /**
                     * Staff applyEmployeePolicyRules.
                     * @member {Array.<palexy.protobuf.IEmployeePolicyRule>} applyEmployeePolicyRules
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     */
                    Staff.prototype.applyEmployeePolicyRules = $util.emptyArray;
    
                    /**
                     * Creates a new Staff instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {palexy.streaming.v1.IStaff=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Staff} Staff instance
                     */
                    Staff.create = function create(properties) {
                        return new Staff(properties);
                    };
    
                    /**
                     * Encodes the specified Staff message. Does not implicitly {@link palexy.streaming.v1.Staff.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {palexy.streaming.v1.IStaff} message Staff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Staff.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fullName);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.title);
                        if (message.mobile != null && Object.hasOwnProperty.call(message, "mobile"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.mobile);
                        if (message.disabled != null && Object.hasOwnProperty.call(message, "disabled"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.disabled);
                        if (message.profilePhotoUrl != null && Object.hasOwnProperty.call(message, "profilePhotoUrl"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.profilePhotoUrl);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                        if (message.posExternalStaffId != null && message.posExternalStaffId.length)
                            for (var i = 0; i < message.posExternalStaffId.length; ++i)
                                writer.uint32(/* id 10, wireType 2 =*/82).string(message.posExternalStaffId[i]);
                        if (message.staffingExternalStaffId != null && message.staffingExternalStaffId.length)
                            for (var i = 0; i < message.staffingExternalStaffId.length; ++i)
                                writer.uint32(/* id 11, wireType 2 =*/90).string(message.staffingExternalStaffId[i]);
                        if (message.isSyncPosStaff != null && Object.hasOwnProperty.call(message, "isSyncPosStaff"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.isSyncPosStaff);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.companyId);
                        if (message.assignedStores != null && message.assignedStores.length)
                            for (var i = 0; i < message.assignedStores.length; ++i)
                                $root.palexy.streaming.v1.StaffAssignedStore.encode(message.assignedStores[i], writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.profilePhotoMetadata != null && Object.hasOwnProperty.call(message, "profilePhotoMetadata"))
                            $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata.encode(message.profilePhotoMetadata, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.preferredScheduleAreaId != null && Object.hasOwnProperty.call(message, "preferredScheduleAreaId"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int64(message.preferredScheduleAreaId);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 17, wireType 2 =*/138).string(message.email);
                        if (message.accountUsername != null && Object.hasOwnProperty.call(message, "accountUsername"))
                            writer.uint32(/* id 18, wireType 2 =*/146).string(message.accountUsername);
                        if (message.waitingForInvitation != null && Object.hasOwnProperty.call(message, "waitingForInvitation"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.waitingForInvitation);
                        if (message.invitationStatus != null && Object.hasOwnProperty.call(message, "invitationStatus"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.invitationStatus);
                        if (message.invitationErrorMessage != null && Object.hasOwnProperty.call(message, "invitationErrorMessage"))
                            writer.uint32(/* id 21, wireType 2 =*/170).string(message.invitationErrorMessage);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int64(message.creatorId);
                        if (message.staffPositionIds != null && message.staffPositionIds.length) {
                            writer.uint32(/* id 23, wireType 2 =*/186).fork();
                            for (var i = 0; i < message.staffPositionIds.length; ++i)
                                writer.int64(message.staffPositionIds[i]);
                            writer.ldelim();
                        }
                        if (message.workingSetting != null && Object.hasOwnProperty.call(message, "workingSetting"))
                            $root.palexy.protobuf.StaffWorkingSetting.encode(message.workingSetting, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                        if (message.preferredScheduleArea != null && Object.hasOwnProperty.call(message, "preferredScheduleArea"))
                            $root.palexy.streaming.v1.ScheduleArea.encode(message.preferredScheduleArea, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                        if (message.staffPositions != null && message.staffPositions.length)
                            for (var i = 0; i < message.staffPositions.length; ++i)
                                $root.palexy.streaming.v1.StaffPosition.encode(message.staffPositions[i], writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                        if (message.employmentType != null && Object.hasOwnProperty.call(message, "employmentType"))
                            writer.uint32(/* id 27, wireType 0 =*/216).int32(message.employmentType);
                        if (message.staffAssignPositions != null && message.staffAssignPositions.length)
                            for (var i = 0; i < message.staffAssignPositions.length; ++i)
                                $root.palexy.streaming.v1.StaffAssignPosition.encode(message.staffAssignPositions[i], writer.uint32(/* id 28, wireType 2 =*/226).fork()).ldelim();
                        if (message.lastWorkingDateId != null && Object.hasOwnProperty.call(message, "lastWorkingDateId"))
                            writer.uint32(/* id 29, wireType 2 =*/234).string(message.lastWorkingDateId);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 30, wireType 2 =*/242).string(message.startDate);
                        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                            writer.uint32(/* id 31, wireType 0 =*/248).int32(message.gender);
                        if (message.hasScheduleManagerRole != null && Object.hasOwnProperty.call(message, "hasScheduleManagerRole"))
                            $root.google.protobuf.BoolValue.encode(message.hasScheduleManagerRole, writer.uint32(/* id 32, wireType 2 =*/258).fork()).ldelim();
                        if (message.metadataValues != null && message.metadataValues.length)
                            for (var i = 0; i < message.metadataValues.length; ++i)
                                $root.palexy.protobuf.StaffMetadataValueMapping.encode(message.metadataValues[i], writer.uint32(/* id 33, wireType 2 =*/266).fork()).ldelim();
                        if (message.applyEmployeePolicyRules != null && message.applyEmployeePolicyRules.length)
                            for (var i = 0; i < message.applyEmployeePolicyRules.length; ++i)
                                $root.palexy.protobuf.EmployeePolicyRule.encode(message.applyEmployeePolicyRules[i], writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Staff message, length delimited. Does not implicitly {@link palexy.streaming.v1.Staff.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {palexy.streaming.v1.IStaff} message Staff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Staff.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Staff message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Staff} Staff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Staff.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Staff();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.fullName = reader.string();
                                break;
                            case 4:
                                message.title = reader.string();
                                break;
                            case 5:
                                message.mobile = reader.string();
                                break;
                            case 6:
                                message.disabled = reader.bool();
                                break;
                            case 7:
                                message.profilePhotoUrl = reader.string();
                                break;
                            case 8:
                                message.createTimeMs = reader.int64();
                                break;
                            case 9:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 13:
                                message.companyId = reader.int64();
                                break;
                            case 14:
                                if (!(message.assignedStores && message.assignedStores.length))
                                    message.assignedStores = [];
                                message.assignedStores.push($root.palexy.streaming.v1.StaffAssignedStore.decode(reader, reader.uint32()));
                                break;
                            case 16:
                                message.preferredScheduleAreaId = reader.int64();
                                break;
                            case 25:
                                message.preferredScheduleArea = $root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32());
                                break;
                            case 22:
                                message.creatorId = reader.int64();
                                break;
                            case 10:
                                if (!(message.posExternalStaffId && message.posExternalStaffId.length))
                                    message.posExternalStaffId = [];
                                message.posExternalStaffId.push(reader.string());
                                break;
                            case 11:
                                if (!(message.staffingExternalStaffId && message.staffingExternalStaffId.length))
                                    message.staffingExternalStaffId = [];
                                message.staffingExternalStaffId.push(reader.string());
                                break;
                            case 12:
                                message.isSyncPosStaff = reader.bool();
                                break;
                            case 15:
                                message.profilePhotoMetadata = $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.email = reader.string();
                                break;
                            case 18:
                                message.accountUsername = reader.string();
                                break;
                            case 19:
                                message.waitingForInvitation = reader.bool();
                                break;
                            case 20:
                                message.invitationStatus = reader.int32();
                                break;
                            case 21:
                                message.invitationErrorMessage = reader.string();
                                break;
                            case 23:
                                if (!(message.staffPositionIds && message.staffPositionIds.length))
                                    message.staffPositionIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffPositionIds.push(reader.int64());
                                } else
                                    message.staffPositionIds.push(reader.int64());
                                break;
                            case 26:
                                if (!(message.staffPositions && message.staffPositions.length))
                                    message.staffPositions = [];
                                message.staffPositions.push($root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32()));
                                break;
                            case 24:
                                message.workingSetting = $root.palexy.protobuf.StaffWorkingSetting.decode(reader, reader.uint32());
                                break;
                            case 27:
                                message.employmentType = reader.int32();
                                break;
                            case 28:
                                if (!(message.staffAssignPositions && message.staffAssignPositions.length))
                                    message.staffAssignPositions = [];
                                message.staffAssignPositions.push($root.palexy.streaming.v1.StaffAssignPosition.decode(reader, reader.uint32()));
                                break;
                            case 29:
                                message.lastWorkingDateId = reader.string();
                                break;
                            case 30:
                                message.startDate = reader.string();
                                break;
                            case 31:
                                message.gender = reader.int32();
                                break;
                            case 32:
                                message.hasScheduleManagerRole = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 33:
                                if (!(message.metadataValues && message.metadataValues.length))
                                    message.metadataValues = [];
                                message.metadataValues.push($root.palexy.protobuf.StaffMetadataValueMapping.decode(reader, reader.uint32()));
                                break;
                            case 34:
                                if (!(message.applyEmployeePolicyRules && message.applyEmployeePolicyRules.length))
                                    message.applyEmployeePolicyRules = [];
                                message.applyEmployeePolicyRules.push($root.palexy.protobuf.EmployeePolicyRule.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Staff message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Staff} Staff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Staff.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Staff message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Staff.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.mobile != null && message.hasOwnProperty("mobile"))
                            if (!$util.isString(message.mobile))
                                return "mobile: string expected";
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            if (typeof message.disabled !== "boolean")
                                return "disabled: boolean expected";
                        if (message.profilePhotoUrl != null && message.hasOwnProperty("profilePhotoUrl"))
                            if (!$util.isString(message.profilePhotoUrl))
                                return "profilePhotoUrl: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.assignedStores != null && message.hasOwnProperty("assignedStores")) {
                            if (!Array.isArray(message.assignedStores))
                                return "assignedStores: array expected";
                            for (var i = 0; i < message.assignedStores.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffAssignedStore.verify(message.assignedStores[i]);
                                if (error)
                                    return "assignedStores." + error;
                            }
                        }
                        if (message.preferredScheduleAreaId != null && message.hasOwnProperty("preferredScheduleAreaId"))
                            if (!$util.isInteger(message.preferredScheduleAreaId) && !(message.preferredScheduleAreaId && $util.isInteger(message.preferredScheduleAreaId.low) && $util.isInteger(message.preferredScheduleAreaId.high)))
                                return "preferredScheduleAreaId: integer|Long expected";
                        if (message.preferredScheduleArea != null && message.hasOwnProperty("preferredScheduleArea")) {
                            var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.preferredScheduleArea);
                            if (error)
                                return "preferredScheduleArea." + error;
                        }
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.posExternalStaffId != null && message.hasOwnProperty("posExternalStaffId")) {
                            if (!Array.isArray(message.posExternalStaffId))
                                return "posExternalStaffId: array expected";
                            for (var i = 0; i < message.posExternalStaffId.length; ++i)
                                if (!$util.isString(message.posExternalStaffId[i]))
                                    return "posExternalStaffId: string[] expected";
                        }
                        if (message.staffingExternalStaffId != null && message.hasOwnProperty("staffingExternalStaffId")) {
                            if (!Array.isArray(message.staffingExternalStaffId))
                                return "staffingExternalStaffId: array expected";
                            for (var i = 0; i < message.staffingExternalStaffId.length; ++i)
                                if (!$util.isString(message.staffingExternalStaffId[i]))
                                    return "staffingExternalStaffId: string[] expected";
                        }
                        if (message.isSyncPosStaff != null && message.hasOwnProperty("isSyncPosStaff"))
                            if (typeof message.isSyncPosStaff !== "boolean")
                                return "isSyncPosStaff: boolean expected";
                        if (message.profilePhotoMetadata != null && message.hasOwnProperty("profilePhotoMetadata")) {
                            var error = $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata.verify(message.profilePhotoMetadata);
                            if (error)
                                return "profilePhotoMetadata." + error;
                        }
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            if (!$util.isString(message.accountUsername))
                                return "accountUsername: string expected";
                        if (message.waitingForInvitation != null && message.hasOwnProperty("waitingForInvitation"))
                            if (typeof message.waitingForInvitation !== "boolean")
                                return "waitingForInvitation: boolean expected";
                        if (message.invitationStatus != null && message.hasOwnProperty("invitationStatus"))
                            switch (message.invitationStatus) {
                            default:
                                return "invitationStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.invitationErrorMessage != null && message.hasOwnProperty("invitationErrorMessage"))
                            if (!$util.isString(message.invitationErrorMessage))
                                return "invitationErrorMessage: string expected";
                        if (message.staffPositionIds != null && message.hasOwnProperty("staffPositionIds")) {
                            if (!Array.isArray(message.staffPositionIds))
                                return "staffPositionIds: array expected";
                            for (var i = 0; i < message.staffPositionIds.length; ++i)
                                if (!$util.isInteger(message.staffPositionIds[i]) && !(message.staffPositionIds[i] && $util.isInteger(message.staffPositionIds[i].low) && $util.isInteger(message.staffPositionIds[i].high)))
                                    return "staffPositionIds: integer|Long[] expected";
                        }
                        if (message.staffPositions != null && message.hasOwnProperty("staffPositions")) {
                            if (!Array.isArray(message.staffPositions))
                                return "staffPositions: array expected";
                            for (var i = 0; i < message.staffPositions.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPositions[i]);
                                if (error)
                                    return "staffPositions." + error;
                            }
                        }
                        if (message.workingSetting != null && message.hasOwnProperty("workingSetting")) {
                            var error = $root.palexy.protobuf.StaffWorkingSetting.verify(message.workingSetting);
                            if (error)
                                return "workingSetting." + error;
                        }
                        if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                            switch (message.employmentType) {
                            default:
                                return "employmentType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.staffAssignPositions != null && message.hasOwnProperty("staffAssignPositions")) {
                            if (!Array.isArray(message.staffAssignPositions))
                                return "staffAssignPositions: array expected";
                            for (var i = 0; i < message.staffAssignPositions.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffAssignPosition.verify(message.staffAssignPositions[i]);
                                if (error)
                                    return "staffAssignPositions." + error;
                            }
                        }
                        if (message.lastWorkingDateId != null && message.hasOwnProperty("lastWorkingDateId"))
                            if (!$util.isString(message.lastWorkingDateId))
                                return "lastWorkingDateId: string expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            switch (message.gender) {
                            default:
                                return "gender: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.hasScheduleManagerRole != null && message.hasOwnProperty("hasScheduleManagerRole")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.hasScheduleManagerRole);
                            if (error)
                                return "hasScheduleManagerRole." + error;
                        }
                        if (message.metadataValues != null && message.hasOwnProperty("metadataValues")) {
                            if (!Array.isArray(message.metadataValues))
                                return "metadataValues: array expected";
                            for (var i = 0; i < message.metadataValues.length; ++i) {
                                var error = $root.palexy.protobuf.StaffMetadataValueMapping.verify(message.metadataValues[i]);
                                if (error)
                                    return "metadataValues." + error;
                            }
                        }
                        if (message.applyEmployeePolicyRules != null && message.hasOwnProperty("applyEmployeePolicyRules")) {
                            if (!Array.isArray(message.applyEmployeePolicyRules))
                                return "applyEmployeePolicyRules: array expected";
                            for (var i = 0; i < message.applyEmployeePolicyRules.length; ++i) {
                                var error = $root.palexy.protobuf.EmployeePolicyRule.verify(message.applyEmployeePolicyRules[i]);
                                if (error)
                                    return "applyEmployeePolicyRules." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Staff message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Staff} Staff
                     */
                    Staff.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Staff)
                            return object;
                        var message = new $root.palexy.streaming.v1.Staff();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.mobile != null)
                            message.mobile = String(object.mobile);
                        if (object.disabled != null)
                            message.disabled = Boolean(object.disabled);
                        if (object.profilePhotoUrl != null)
                            message.profilePhotoUrl = String(object.profilePhotoUrl);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.assignedStores) {
                            if (!Array.isArray(object.assignedStores))
                                throw TypeError(".palexy.streaming.v1.Staff.assignedStores: array expected");
                            message.assignedStores = [];
                            for (var i = 0; i < object.assignedStores.length; ++i) {
                                if (typeof object.assignedStores[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.assignedStores: object expected");
                                message.assignedStores[i] = $root.palexy.streaming.v1.StaffAssignedStore.fromObject(object.assignedStores[i]);
                            }
                        }
                        if (object.preferredScheduleAreaId != null)
                            if ($util.Long)
                                (message.preferredScheduleAreaId = $util.Long.fromValue(object.preferredScheduleAreaId)).unsigned = false;
                            else if (typeof object.preferredScheduleAreaId === "string")
                                message.preferredScheduleAreaId = parseInt(object.preferredScheduleAreaId, 10);
                            else if (typeof object.preferredScheduleAreaId === "number")
                                message.preferredScheduleAreaId = object.preferredScheduleAreaId;
                            else if (typeof object.preferredScheduleAreaId === "object")
                                message.preferredScheduleAreaId = new $util.LongBits(object.preferredScheduleAreaId.low >>> 0, object.preferredScheduleAreaId.high >>> 0).toNumber();
                        if (object.preferredScheduleArea != null) {
                            if (typeof object.preferredScheduleArea !== "object")
                                throw TypeError(".palexy.streaming.v1.Staff.preferredScheduleArea: object expected");
                            message.preferredScheduleArea = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.preferredScheduleArea);
                        }
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        if (object.posExternalStaffId) {
                            if (!Array.isArray(object.posExternalStaffId))
                                throw TypeError(".palexy.streaming.v1.Staff.posExternalStaffId: array expected");
                            message.posExternalStaffId = [];
                            for (var i = 0; i < object.posExternalStaffId.length; ++i)
                                message.posExternalStaffId[i] = String(object.posExternalStaffId[i]);
                        }
                        if (object.staffingExternalStaffId) {
                            if (!Array.isArray(object.staffingExternalStaffId))
                                throw TypeError(".palexy.streaming.v1.Staff.staffingExternalStaffId: array expected");
                            message.staffingExternalStaffId = [];
                            for (var i = 0; i < object.staffingExternalStaffId.length; ++i)
                                message.staffingExternalStaffId[i] = String(object.staffingExternalStaffId[i]);
                        }
                        if (object.isSyncPosStaff != null)
                            message.isSyncPosStaff = Boolean(object.isSyncPosStaff);
                        if (object.profilePhotoMetadata != null) {
                            if (typeof object.profilePhotoMetadata !== "object")
                                throw TypeError(".palexy.streaming.v1.Staff.profilePhotoMetadata: object expected");
                            message.profilePhotoMetadata = $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata.fromObject(object.profilePhotoMetadata);
                        }
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.accountUsername != null)
                            message.accountUsername = String(object.accountUsername);
                        if (object.waitingForInvitation != null)
                            message.waitingForInvitation = Boolean(object.waitingForInvitation);
                        switch (object.invitationStatus) {
                        case "UNKNOWN_INVITATION_STATUS":
                        case 0:
                            message.invitationStatus = 0;
                            break;
                        case "NO_VERIFICATION_METHOD":
                        case 1:
                            message.invitationStatus = 1;
                            break;
                        case "NO_INVITATION_SEND":
                        case 2:
                            message.invitationStatus = 2;
                            break;
                        case "WAITING_TO_BE_PROCESSED":
                        case 3:
                            message.invitationStatus = 3;
                            break;
                        case "WAITING_FOR_CONFIRMATION":
                        case 4:
                            message.invitationStatus = 4;
                            break;
                        case "INVITATION_ACCEPTED":
                        case 5:
                            message.invitationStatus = 5;
                            break;
                        case "INVITATION_DECLINED":
                        case 6:
                            message.invitationStatus = 6;
                            break;
                        case "INVITATION_EXPIRED":
                        case 7:
                            message.invitationStatus = 7;
                            break;
                        case "PERMISSION_CONFLICT":
                        case 8:
                            message.invitationStatus = 8;
                            break;
                        case "SEND_INVITATION_FAILED":
                        case 9:
                            message.invitationStatus = 9;
                            break;
                        case "INVALID_STAFF_INFORMATION":
                        case 10:
                            message.invitationStatus = 10;
                            break;
                        }
                        if (object.invitationErrorMessage != null)
                            message.invitationErrorMessage = String(object.invitationErrorMessage);
                        if (object.staffPositionIds) {
                            if (!Array.isArray(object.staffPositionIds))
                                throw TypeError(".palexy.streaming.v1.Staff.staffPositionIds: array expected");
                            message.staffPositionIds = [];
                            for (var i = 0; i < object.staffPositionIds.length; ++i)
                                if ($util.Long)
                                    (message.staffPositionIds[i] = $util.Long.fromValue(object.staffPositionIds[i])).unsigned = false;
                                else if (typeof object.staffPositionIds[i] === "string")
                                    message.staffPositionIds[i] = parseInt(object.staffPositionIds[i], 10);
                                else if (typeof object.staffPositionIds[i] === "number")
                                    message.staffPositionIds[i] = object.staffPositionIds[i];
                                else if (typeof object.staffPositionIds[i] === "object")
                                    message.staffPositionIds[i] = new $util.LongBits(object.staffPositionIds[i].low >>> 0, object.staffPositionIds[i].high >>> 0).toNumber();
                        }
                        if (object.staffPositions) {
                            if (!Array.isArray(object.staffPositions))
                                throw TypeError(".palexy.streaming.v1.Staff.staffPositions: array expected");
                            message.staffPositions = [];
                            for (var i = 0; i < object.staffPositions.length; ++i) {
                                if (typeof object.staffPositions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.staffPositions: object expected");
                                message.staffPositions[i] = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPositions[i]);
                            }
                        }
                        if (object.workingSetting != null) {
                            if (typeof object.workingSetting !== "object")
                                throw TypeError(".palexy.streaming.v1.Staff.workingSetting: object expected");
                            message.workingSetting = $root.palexy.protobuf.StaffWorkingSetting.fromObject(object.workingSetting);
                        }
                        switch (object.employmentType) {
                        case "UNKNOWN_STAFF_EMPLOYMENT_TYPE":
                        case 0:
                            message.employmentType = 0;
                            break;
                        case "FULL_TIME":
                        case 1:
                            message.employmentType = 1;
                            break;
                        case "PART_TIME":
                        case 2:
                            message.employmentType = 2;
                            break;
                        case "EXTERNAL_STAFF":
                        case 3:
                            message.employmentType = 3;
                            break;
                        }
                        if (object.staffAssignPositions) {
                            if (!Array.isArray(object.staffAssignPositions))
                                throw TypeError(".palexy.streaming.v1.Staff.staffAssignPositions: array expected");
                            message.staffAssignPositions = [];
                            for (var i = 0; i < object.staffAssignPositions.length; ++i) {
                                if (typeof object.staffAssignPositions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.staffAssignPositions: object expected");
                                message.staffAssignPositions[i] = $root.palexy.streaming.v1.StaffAssignPosition.fromObject(object.staffAssignPositions[i]);
                            }
                        }
                        if (object.lastWorkingDateId != null)
                            message.lastWorkingDateId = String(object.lastWorkingDateId);
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        switch (object.gender) {
                        case "GENDER_UNSPECIFIED":
                        case 0:
                            message.gender = 0;
                            break;
                        case "MALE":
                        case 1:
                            message.gender = 1;
                            break;
                        case "FEMALE":
                        case 2:
                            message.gender = 2;
                            break;
                        }
                        if (object.hasScheduleManagerRole != null) {
                            if (typeof object.hasScheduleManagerRole !== "object")
                                throw TypeError(".palexy.streaming.v1.Staff.hasScheduleManagerRole: object expected");
                            message.hasScheduleManagerRole = $root.google.protobuf.BoolValue.fromObject(object.hasScheduleManagerRole);
                        }
                        if (object.metadataValues) {
                            if (!Array.isArray(object.metadataValues))
                                throw TypeError(".palexy.streaming.v1.Staff.metadataValues: array expected");
                            message.metadataValues = [];
                            for (var i = 0; i < object.metadataValues.length; ++i) {
                                if (typeof object.metadataValues[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.metadataValues: object expected");
                                message.metadataValues[i] = $root.palexy.protobuf.StaffMetadataValueMapping.fromObject(object.metadataValues[i]);
                            }
                        }
                        if (object.applyEmployeePolicyRules) {
                            if (!Array.isArray(object.applyEmployeePolicyRules))
                                throw TypeError(".palexy.streaming.v1.Staff.applyEmployeePolicyRules: array expected");
                            message.applyEmployeePolicyRules = [];
                            for (var i = 0; i < object.applyEmployeePolicyRules.length; ++i) {
                                if (typeof object.applyEmployeePolicyRules[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.applyEmployeePolicyRules: object expected");
                                message.applyEmployeePolicyRules[i] = $root.palexy.protobuf.EmployeePolicyRule.fromObject(object.applyEmployeePolicyRules[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Staff message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Staff
                     * @static
                     * @param {palexy.streaming.v1.Staff} message Staff
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Staff.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.posExternalStaffId = [];
                            object.staffingExternalStaffId = [];
                            object.assignedStores = [];
                            object.staffPositionIds = [];
                            object.staffPositions = [];
                            object.staffAssignPositions = [];
                            object.metadataValues = [];
                            object.applyEmployeePolicyRules = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.fullName = "";
                            object.title = "";
                            object.mobile = "";
                            object.disabled = false;
                            object.profilePhotoUrl = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.isSyncPosStaff = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.profilePhotoMetadata = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.preferredScheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.preferredScheduleAreaId = options.longs === String ? "0" : 0;
                            object.email = "";
                            object.accountUsername = "";
                            object.waitingForInvitation = false;
                            object.invitationStatus = options.enums === String ? "UNKNOWN_INVITATION_STATUS" : 0;
                            object.invitationErrorMessage = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            object.workingSetting = null;
                            object.preferredScheduleArea = null;
                            object.employmentType = options.enums === String ? "UNKNOWN_STAFF_EMPLOYMENT_TYPE" : 0;
                            object.lastWorkingDateId = "";
                            object.startDate = "";
                            object.gender = options.enums === String ? "GENDER_UNSPECIFIED" : 0;
                            object.hasScheduleManagerRole = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.mobile != null && message.hasOwnProperty("mobile"))
                            object.mobile = message.mobile;
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            object.disabled = message.disabled;
                        if (message.profilePhotoUrl != null && message.hasOwnProperty("profilePhotoUrl"))
                            object.profilePhotoUrl = message.profilePhotoUrl;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.posExternalStaffId && message.posExternalStaffId.length) {
                            object.posExternalStaffId = [];
                            for (var j = 0; j < message.posExternalStaffId.length; ++j)
                                object.posExternalStaffId[j] = message.posExternalStaffId[j];
                        }
                        if (message.staffingExternalStaffId && message.staffingExternalStaffId.length) {
                            object.staffingExternalStaffId = [];
                            for (var j = 0; j < message.staffingExternalStaffId.length; ++j)
                                object.staffingExternalStaffId[j] = message.staffingExternalStaffId[j];
                        }
                        if (message.isSyncPosStaff != null && message.hasOwnProperty("isSyncPosStaff"))
                            object.isSyncPosStaff = message.isSyncPosStaff;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.assignedStores && message.assignedStores.length) {
                            object.assignedStores = [];
                            for (var j = 0; j < message.assignedStores.length; ++j)
                                object.assignedStores[j] = $root.palexy.streaming.v1.StaffAssignedStore.toObject(message.assignedStores[j], options);
                        }
                        if (message.profilePhotoMetadata != null && message.hasOwnProperty("profilePhotoMetadata"))
                            object.profilePhotoMetadata = $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata.toObject(message.profilePhotoMetadata, options);
                        if (message.preferredScheduleAreaId != null && message.hasOwnProperty("preferredScheduleAreaId"))
                            if (typeof message.preferredScheduleAreaId === "number")
                                object.preferredScheduleAreaId = options.longs === String ? String(message.preferredScheduleAreaId) : message.preferredScheduleAreaId;
                            else
                                object.preferredScheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.preferredScheduleAreaId) : options.longs === Number ? new $util.LongBits(message.preferredScheduleAreaId.low >>> 0, message.preferredScheduleAreaId.high >>> 0).toNumber() : message.preferredScheduleAreaId;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            object.accountUsername = message.accountUsername;
                        if (message.waitingForInvitation != null && message.hasOwnProperty("waitingForInvitation"))
                            object.waitingForInvitation = message.waitingForInvitation;
                        if (message.invitationStatus != null && message.hasOwnProperty("invitationStatus"))
                            object.invitationStatus = options.enums === String ? $root.palexy.streaming.v1.StaffInvitationStatus[message.invitationStatus] : message.invitationStatus;
                        if (message.invitationErrorMessage != null && message.hasOwnProperty("invitationErrorMessage"))
                            object.invitationErrorMessage = message.invitationErrorMessage;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.staffPositionIds && message.staffPositionIds.length) {
                            object.staffPositionIds = [];
                            for (var j = 0; j < message.staffPositionIds.length; ++j)
                                if (typeof message.staffPositionIds[j] === "number")
                                    object.staffPositionIds[j] = options.longs === String ? String(message.staffPositionIds[j]) : message.staffPositionIds[j];
                                else
                                    object.staffPositionIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionIds[j]) : options.longs === Number ? new $util.LongBits(message.staffPositionIds[j].low >>> 0, message.staffPositionIds[j].high >>> 0).toNumber() : message.staffPositionIds[j];
                        }
                        if (message.workingSetting != null && message.hasOwnProperty("workingSetting"))
                            object.workingSetting = $root.palexy.protobuf.StaffWorkingSetting.toObject(message.workingSetting, options);
                        if (message.preferredScheduleArea != null && message.hasOwnProperty("preferredScheduleArea"))
                            object.preferredScheduleArea = $root.palexy.streaming.v1.ScheduleArea.toObject(message.preferredScheduleArea, options);
                        if (message.staffPositions && message.staffPositions.length) {
                            object.staffPositions = [];
                            for (var j = 0; j < message.staffPositions.length; ++j)
                                object.staffPositions[j] = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPositions[j], options);
                        }
                        if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                            object.employmentType = options.enums === String ? $root.palexy.protobuf.StaffEmploymentType[message.employmentType] : message.employmentType;
                        if (message.staffAssignPositions && message.staffAssignPositions.length) {
                            object.staffAssignPositions = [];
                            for (var j = 0; j < message.staffAssignPositions.length; ++j)
                                object.staffAssignPositions[j] = $root.palexy.streaming.v1.StaffAssignPosition.toObject(message.staffAssignPositions[j], options);
                        }
                        if (message.lastWorkingDateId != null && message.hasOwnProperty("lastWorkingDateId"))
                            object.lastWorkingDateId = message.lastWorkingDateId;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            object.gender = options.enums === String ? $root.palexy.protobuf.Gender[message.gender] : message.gender;
                        if (message.hasScheduleManagerRole != null && message.hasOwnProperty("hasScheduleManagerRole"))
                            object.hasScheduleManagerRole = $root.google.protobuf.BoolValue.toObject(message.hasScheduleManagerRole, options);
                        if (message.metadataValues && message.metadataValues.length) {
                            object.metadataValues = [];
                            for (var j = 0; j < message.metadataValues.length; ++j)
                                object.metadataValues[j] = $root.palexy.protobuf.StaffMetadataValueMapping.toObject(message.metadataValues[j], options);
                        }
                        if (message.applyEmployeePolicyRules && message.applyEmployeePolicyRules.length) {
                            object.applyEmployeePolicyRules = [];
                            for (var j = 0; j < message.applyEmployeePolicyRules.length; ++j)
                                object.applyEmployeePolicyRules[j] = $root.palexy.protobuf.EmployeePolicyRule.toObject(message.applyEmployeePolicyRules[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Staff to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Staff
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Staff.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    Staff.ProfilePhotoMetadata = (function() {
    
                        /**
                         * Properties of a ProfilePhotoMetadata.
                         * @memberof palexy.streaming.v1.Staff
                         * @interface IProfilePhotoMetadata
                         * @property {palexy.streaming.v1.IArtifact|null} [smallArtifact] ProfilePhotoMetadata smallArtifact
                         * @property {palexy.streaming.v1.IArtifact|null} [mediumArtifact] ProfilePhotoMetadata mediumArtifact
                         * @property {palexy.streaming.v1.IArtifact|null} [largeArtifact] ProfilePhotoMetadata largeArtifact
                         * @property {palexy.streaming.v1.IArtifact|null} [xlargeArtifact] ProfilePhotoMetadata xlargeArtifact
                         */
    
                        /**
                         * Constructs a new ProfilePhotoMetadata.
                         * @memberof palexy.streaming.v1.Staff
                         * @classdesc Represents a ProfilePhotoMetadata.
                         * @implements IProfilePhotoMetadata
                         * @constructor
                         * @param {palexy.streaming.v1.Staff.IProfilePhotoMetadata=} [properties] Properties to set
                         */
                        function ProfilePhotoMetadata(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ProfilePhotoMetadata smallArtifact.
                         * @member {palexy.streaming.v1.IArtifact|null|undefined} smallArtifact
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @instance
                         */
                        ProfilePhotoMetadata.prototype.smallArtifact = null;
    
                        /**
                         * ProfilePhotoMetadata mediumArtifact.
                         * @member {palexy.streaming.v1.IArtifact|null|undefined} mediumArtifact
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @instance
                         */
                        ProfilePhotoMetadata.prototype.mediumArtifact = null;
    
                        /**
                         * ProfilePhotoMetadata largeArtifact.
                         * @member {palexy.streaming.v1.IArtifact|null|undefined} largeArtifact
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @instance
                         */
                        ProfilePhotoMetadata.prototype.largeArtifact = null;
    
                        /**
                         * ProfilePhotoMetadata xlargeArtifact.
                         * @member {palexy.streaming.v1.IArtifact|null|undefined} xlargeArtifact
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @instance
                         */
                        ProfilePhotoMetadata.prototype.xlargeArtifact = null;
    
                        /**
                         * Creates a new ProfilePhotoMetadata instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {palexy.streaming.v1.Staff.IProfilePhotoMetadata=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.Staff.ProfilePhotoMetadata} ProfilePhotoMetadata instance
                         */
                        ProfilePhotoMetadata.create = function create(properties) {
                            return new ProfilePhotoMetadata(properties);
                        };
    
                        /**
                         * Encodes the specified ProfilePhotoMetadata message. Does not implicitly {@link palexy.streaming.v1.Staff.ProfilePhotoMetadata.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {palexy.streaming.v1.Staff.IProfilePhotoMetadata} message ProfilePhotoMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProfilePhotoMetadata.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.smallArtifact != null && Object.hasOwnProperty.call(message, "smallArtifact"))
                                $root.palexy.streaming.v1.Artifact.encode(message.smallArtifact, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.mediumArtifact != null && Object.hasOwnProperty.call(message, "mediumArtifact"))
                                $root.palexy.streaming.v1.Artifact.encode(message.mediumArtifact, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.largeArtifact != null && Object.hasOwnProperty.call(message, "largeArtifact"))
                                $root.palexy.streaming.v1.Artifact.encode(message.largeArtifact, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.xlargeArtifact != null && Object.hasOwnProperty.call(message, "xlargeArtifact"))
                                $root.palexy.streaming.v1.Artifact.encode(message.xlargeArtifact, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ProfilePhotoMetadata message, length delimited. Does not implicitly {@link palexy.streaming.v1.Staff.ProfilePhotoMetadata.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {palexy.streaming.v1.Staff.IProfilePhotoMetadata} message ProfilePhotoMetadata message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ProfilePhotoMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ProfilePhotoMetadata message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.Staff.ProfilePhotoMetadata} ProfilePhotoMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProfilePhotoMetadata.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.smallArtifact = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.mediumArtifact = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.largeArtifact = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.xlargeArtifact = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ProfilePhotoMetadata message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.Staff.ProfilePhotoMetadata} ProfilePhotoMetadata
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ProfilePhotoMetadata.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ProfilePhotoMetadata message.
                         * @function verify
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ProfilePhotoMetadata.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.smallArtifact != null && message.hasOwnProperty("smallArtifact")) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.smallArtifact);
                                if (error)
                                    return "smallArtifact." + error;
                            }
                            if (message.mediumArtifact != null && message.hasOwnProperty("mediumArtifact")) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.mediumArtifact);
                                if (error)
                                    return "mediumArtifact." + error;
                            }
                            if (message.largeArtifact != null && message.hasOwnProperty("largeArtifact")) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.largeArtifact);
                                if (error)
                                    return "largeArtifact." + error;
                            }
                            if (message.xlargeArtifact != null && message.hasOwnProperty("xlargeArtifact")) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.xlargeArtifact);
                                if (error)
                                    return "xlargeArtifact." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a ProfilePhotoMetadata message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.Staff.ProfilePhotoMetadata} ProfilePhotoMetadata
                         */
                        ProfilePhotoMetadata.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata)
                                return object;
                            var message = new $root.palexy.streaming.v1.Staff.ProfilePhotoMetadata();
                            if (object.smallArtifact != null) {
                                if (typeof object.smallArtifact !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.ProfilePhotoMetadata.smallArtifact: object expected");
                                message.smallArtifact = $root.palexy.streaming.v1.Artifact.fromObject(object.smallArtifact);
                            }
                            if (object.mediumArtifact != null) {
                                if (typeof object.mediumArtifact !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.ProfilePhotoMetadata.mediumArtifact: object expected");
                                message.mediumArtifact = $root.palexy.streaming.v1.Artifact.fromObject(object.mediumArtifact);
                            }
                            if (object.largeArtifact != null) {
                                if (typeof object.largeArtifact !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.ProfilePhotoMetadata.largeArtifact: object expected");
                                message.largeArtifact = $root.palexy.streaming.v1.Artifact.fromObject(object.largeArtifact);
                            }
                            if (object.xlargeArtifact != null) {
                                if (typeof object.xlargeArtifact !== "object")
                                    throw TypeError(".palexy.streaming.v1.Staff.ProfilePhotoMetadata.xlargeArtifact: object expected");
                                message.xlargeArtifact = $root.palexy.streaming.v1.Artifact.fromObject(object.xlargeArtifact);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ProfilePhotoMetadata message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @static
                         * @param {palexy.streaming.v1.Staff.ProfilePhotoMetadata} message ProfilePhotoMetadata
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ProfilePhotoMetadata.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.smallArtifact = null;
                                object.mediumArtifact = null;
                                object.largeArtifact = null;
                                object.xlargeArtifact = null;
                            }
                            if (message.smallArtifact != null && message.hasOwnProperty("smallArtifact"))
                                object.smallArtifact = $root.palexy.streaming.v1.Artifact.toObject(message.smallArtifact, options);
                            if (message.mediumArtifact != null && message.hasOwnProperty("mediumArtifact"))
                                object.mediumArtifact = $root.palexy.streaming.v1.Artifact.toObject(message.mediumArtifact, options);
                            if (message.largeArtifact != null && message.hasOwnProperty("largeArtifact"))
                                object.largeArtifact = $root.palexy.streaming.v1.Artifact.toObject(message.largeArtifact, options);
                            if (message.xlargeArtifact != null && message.hasOwnProperty("xlargeArtifact"))
                                object.xlargeArtifact = $root.palexy.streaming.v1.Artifact.toObject(message.xlargeArtifact, options);
                            return object;
                        };
    
                        /**
                         * Converts this ProfilePhotoMetadata to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.Staff.ProfilePhotoMetadata
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ProfilePhotoMetadata.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ProfilePhotoMetadata;
                    })();
    
                    return Staff;
                })();
    
                v1.StaffAssignPosition = (function() {
    
                    /**
                     * Properties of a StaffAssignPosition.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffAssignPosition
                     * @property {number|null} [positionId] StaffAssignPosition positionId
                     * @property {number|null} [staffId] StaffAssignPosition staffId
                     * @property {number|null} [level] StaffAssignPosition level
                     * @property {boolean|null} [isPrimary] StaffAssignPosition isPrimary
                     * @property {palexy.streaming.v1.IStaffPosition|null} [position] StaffAssignPosition position
                     */
    
                    /**
                     * Constructs a new StaffAssignPosition.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffAssignPosition.
                     * @implements IStaffAssignPosition
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffAssignPosition=} [properties] Properties to set
                     */
                    function StaffAssignPosition(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffAssignPosition positionId.
                     * @member {number} positionId
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     */
                    StaffAssignPosition.prototype.positionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAssignPosition staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     */
                    StaffAssignPosition.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAssignPosition level.
                     * @member {number} level
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     */
                    StaffAssignPosition.prototype.level = 0;
    
                    /**
                     * StaffAssignPosition isPrimary.
                     * @member {boolean} isPrimary
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     */
                    StaffAssignPosition.prototype.isPrimary = false;
    
                    /**
                     * StaffAssignPosition position.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} position
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     */
                    StaffAssignPosition.prototype.position = null;
    
                    /**
                     * Creates a new StaffAssignPosition instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignPosition=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffAssignPosition} StaffAssignPosition instance
                     */
                    StaffAssignPosition.create = function create(properties) {
                        return new StaffAssignPosition(properties);
                    };
    
                    /**
                     * Encodes the specified StaffAssignPosition message. Does not implicitly {@link palexy.streaming.v1.StaffAssignPosition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignPosition} message StaffAssignPosition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAssignPosition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.positionId != null && Object.hasOwnProperty.call(message, "positionId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.positionId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                        if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.level);
                        if (message.isPrimary != null && Object.hasOwnProperty.call(message, "isPrimary"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isPrimary);
                        if (message.position != null && Object.hasOwnProperty.call(message, "position"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.position, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffAssignPosition message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffAssignPosition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignPosition} message StaffAssignPosition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAssignPosition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffAssignPosition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffAssignPosition} StaffAssignPosition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAssignPosition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffAssignPosition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.positionId = reader.int64();
                                break;
                            case 2:
                                message.staffId = reader.int64();
                                break;
                            case 3:
                                message.level = reader.int32();
                                break;
                            case 4:
                                message.isPrimary = reader.bool();
                                break;
                            case 5:
                                message.position = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffAssignPosition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffAssignPosition} StaffAssignPosition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAssignPosition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffAssignPosition message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffAssignPosition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.positionId != null && message.hasOwnProperty("positionId"))
                            if (!$util.isInteger(message.positionId) && !(message.positionId && $util.isInteger(message.positionId.low) && $util.isInteger(message.positionId.high)))
                                return "positionId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.level != null && message.hasOwnProperty("level"))
                            if (!$util.isInteger(message.level))
                                return "level: integer expected";
                        if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                            if (typeof message.isPrimary !== "boolean")
                                return "isPrimary: boolean expected";
                        if (message.position != null && message.hasOwnProperty("position")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.position);
                            if (error)
                                return "position." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffAssignPosition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffAssignPosition} StaffAssignPosition
                     */
                    StaffAssignPosition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffAssignPosition)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffAssignPosition();
                        if (object.positionId != null)
                            if ($util.Long)
                                (message.positionId = $util.Long.fromValue(object.positionId)).unsigned = false;
                            else if (typeof object.positionId === "string")
                                message.positionId = parseInt(object.positionId, 10);
                            else if (typeof object.positionId === "number")
                                message.positionId = object.positionId;
                            else if (typeof object.positionId === "object")
                                message.positionId = new $util.LongBits(object.positionId.low >>> 0, object.positionId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.level != null)
                            message.level = object.level | 0;
                        if (object.isPrimary != null)
                            message.isPrimary = Boolean(object.isPrimary);
                        if (object.position != null) {
                            if (typeof object.position !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffAssignPosition.position: object expected");
                            message.position = $root.palexy.streaming.v1.StaffPosition.fromObject(object.position);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffAssignPosition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @static
                     * @param {palexy.streaming.v1.StaffAssignPosition} message StaffAssignPosition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffAssignPosition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.positionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.positionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.level = 0;
                            object.isPrimary = false;
                            object.position = null;
                        }
                        if (message.positionId != null && message.hasOwnProperty("positionId"))
                            if (typeof message.positionId === "number")
                                object.positionId = options.longs === String ? String(message.positionId) : message.positionId;
                            else
                                object.positionId = options.longs === String ? $util.Long.prototype.toString.call(message.positionId) : options.longs === Number ? new $util.LongBits(message.positionId.low >>> 0, message.positionId.high >>> 0).toNumber() : message.positionId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.level != null && message.hasOwnProperty("level"))
                            object.level = message.level;
                        if (message.isPrimary != null && message.hasOwnProperty("isPrimary"))
                            object.isPrimary = message.isPrimary;
                        if (message.position != null && message.hasOwnProperty("position"))
                            object.position = $root.palexy.streaming.v1.StaffPosition.toObject(message.position, options);
                        return object;
                    };
    
                    /**
                     * Converts this StaffAssignPosition to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffAssignPosition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffAssignPosition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffAssignPosition;
                })();
    
                /**
                 * StaffInvitationStatus enum.
                 * @name palexy.streaming.v1.StaffInvitationStatus
                 * @enum {number}
                 * @property {number} UNKNOWN_INVITATION_STATUS=0 UNKNOWN_INVITATION_STATUS value
                 * @property {number} NO_VERIFICATION_METHOD=1 NO_VERIFICATION_METHOD value
                 * @property {number} NO_INVITATION_SEND=2 NO_INVITATION_SEND value
                 * @property {number} WAITING_TO_BE_PROCESSED=3 WAITING_TO_BE_PROCESSED value
                 * @property {number} WAITING_FOR_CONFIRMATION=4 WAITING_FOR_CONFIRMATION value
                 * @property {number} INVITATION_ACCEPTED=5 INVITATION_ACCEPTED value
                 * @property {number} INVITATION_DECLINED=6 INVITATION_DECLINED value
                 * @property {number} INVITATION_EXPIRED=7 INVITATION_EXPIRED value
                 * @property {number} PERMISSION_CONFLICT=8 PERMISSION_CONFLICT value
                 * @property {number} SEND_INVITATION_FAILED=9 SEND_INVITATION_FAILED value
                 * @property {number} INVALID_STAFF_INFORMATION=10 INVALID_STAFF_INFORMATION value
                 */
                v1.StaffInvitationStatus = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_INVITATION_STATUS"] = 0;
                    values[valuesById[1] = "NO_VERIFICATION_METHOD"] = 1;
                    values[valuesById[2] = "NO_INVITATION_SEND"] = 2;
                    values[valuesById[3] = "WAITING_TO_BE_PROCESSED"] = 3;
                    values[valuesById[4] = "WAITING_FOR_CONFIRMATION"] = 4;
                    values[valuesById[5] = "INVITATION_ACCEPTED"] = 5;
                    values[valuesById[6] = "INVITATION_DECLINED"] = 6;
                    values[valuesById[7] = "INVITATION_EXPIRED"] = 7;
                    values[valuesById[8] = "PERMISSION_CONFLICT"] = 8;
                    values[valuesById[9] = "SEND_INVITATION_FAILED"] = 9;
                    values[valuesById[10] = "INVALID_STAFF_INFORMATION"] = 10;
                    return values;
                })();
    
                v1.StaffAssignedStore = (function() {
    
                    /**
                     * Properties of a StaffAssignedStore.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffAssignedStore
                     * @property {number|null} [storeId] StaffAssignedStore storeId
                     * @property {string|null} [auditUsername] StaffAssignedStore auditUsername
                     * @property {number|null} [createTimeMs] StaffAssignedStore createTimeMs
                     * @property {palexy.streaming.v1.StaffAssignedStore.StaffType|null} [staffType] StaffAssignedStore staffType
                     * @property {number|null} [areaOrderIndex] StaffAssignedStore areaOrderIndex
                     */
    
                    /**
                     * Constructs a new StaffAssignedStore.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffAssignedStore.
                     * @implements IStaffAssignedStore
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffAssignedStore=} [properties] Properties to set
                     */
                    function StaffAssignedStore(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffAssignedStore storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     */
                    StaffAssignedStore.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAssignedStore auditUsername.
                     * @member {string} auditUsername
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     */
                    StaffAssignedStore.prototype.auditUsername = "";
    
                    /**
                     * StaffAssignedStore createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     */
                    StaffAssignedStore.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAssignedStore staffType.
                     * @member {palexy.streaming.v1.StaffAssignedStore.StaffType} staffType
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     */
                    StaffAssignedStore.prototype.staffType = 0;
    
                    /**
                     * StaffAssignedStore areaOrderIndex.
                     * @member {number} areaOrderIndex
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     */
                    StaffAssignedStore.prototype.areaOrderIndex = 0;
    
                    /**
                     * Creates a new StaffAssignedStore instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignedStore=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffAssignedStore} StaffAssignedStore instance
                     */
                    StaffAssignedStore.create = function create(properties) {
                        return new StaffAssignedStore(properties);
                    };
    
                    /**
                     * Encodes the specified StaffAssignedStore message. Does not implicitly {@link palexy.streaming.v1.StaffAssignedStore.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignedStore} message StaffAssignedStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAssignedStore.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.auditUsername != null && Object.hasOwnProperty.call(message, "auditUsername"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.auditUsername);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createTimeMs);
                        if (message.staffType != null && Object.hasOwnProperty.call(message, "staffType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.staffType);
                        if (message.areaOrderIndex != null && Object.hasOwnProperty.call(message, "areaOrderIndex"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.areaOrderIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffAssignedStore message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffAssignedStore.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {palexy.streaming.v1.IStaffAssignedStore} message StaffAssignedStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAssignedStore.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffAssignedStore message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffAssignedStore} StaffAssignedStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAssignedStore.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffAssignedStore();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.auditUsername = reader.string();
                                break;
                            case 3:
                                message.createTimeMs = reader.int64();
                                break;
                            case 4:
                                message.staffType = reader.int32();
                                break;
                            case 5:
                                message.areaOrderIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffAssignedStore message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffAssignedStore} StaffAssignedStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAssignedStore.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffAssignedStore message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffAssignedStore.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            if (!$util.isString(message.auditUsername))
                                return "auditUsername: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.staffType != null && message.hasOwnProperty("staffType"))
                            switch (message.staffType) {
                            default:
                                return "staffType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.areaOrderIndex != null && message.hasOwnProperty("areaOrderIndex"))
                            if (!$util.isInteger(message.areaOrderIndex))
                                return "areaOrderIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffAssignedStore message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffAssignedStore} StaffAssignedStore
                     */
                    StaffAssignedStore.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffAssignedStore)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffAssignedStore();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.auditUsername != null)
                            message.auditUsername = String(object.auditUsername);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        switch (object.staffType) {
                        case "UNKNOWN_STAFF_TYPE":
                        case 0:
                            message.staffType = 0;
                            break;
                        case "PERMANENT":
                        case 1:
                            message.staffType = 1;
                            break;
                        case "BORROWED":
                        case 2:
                            message.staffType = 2;
                            break;
                        }
                        if (object.areaOrderIndex != null)
                            message.areaOrderIndex = object.areaOrderIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffAssignedStore message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @static
                     * @param {palexy.streaming.v1.StaffAssignedStore} message StaffAssignedStore
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffAssignedStore.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.auditUsername = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            object.staffType = options.enums === String ? "UNKNOWN_STAFF_TYPE" : 0;
                            object.areaOrderIndex = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            object.auditUsername = message.auditUsername;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.staffType != null && message.hasOwnProperty("staffType"))
                            object.staffType = options.enums === String ? $root.palexy.streaming.v1.StaffAssignedStore.StaffType[message.staffType] : message.staffType;
                        if (message.areaOrderIndex != null && message.hasOwnProperty("areaOrderIndex"))
                            object.areaOrderIndex = message.areaOrderIndex;
                        return object;
                    };
    
                    /**
                     * Converts this StaffAssignedStore to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffAssignedStore
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffAssignedStore.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * StaffType enum.
                     * @name palexy.streaming.v1.StaffAssignedStore.StaffType
                     * @enum {number}
                     * @property {number} UNKNOWN_STAFF_TYPE=0 UNKNOWN_STAFF_TYPE value
                     * @property {number} PERMANENT=1 PERMANENT value
                     * @property {number} BORROWED=2 BORROWED value
                     */
                    StaffAssignedStore.StaffType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_STAFF_TYPE"] = 0;
                        values[valuesById[1] = "PERMANENT"] = 1;
                        values[valuesById[2] = "BORROWED"] = 2;
                        return values;
                    })();
    
                    return StaffAssignedStore;
                })();
    
                v1.CreateStaffRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffRequest
                     * @property {palexy.streaming.v1.IStaff|null} [staff] CreateStaffRequest staff
                     */
    
                    /**
                     * Constructs a new CreateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffRequest.
                     * @implements ICreateStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffRequest=} [properties] Properties to set
                     */
                    function CreateStaffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffRequest staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @instance
                     */
                    CreateStaffRequest.prototype.staff = null;
    
                    /**
                     * Creates a new CreateStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffRequest} CreateStaffRequest instance
                     */
                    CreateStaffRequest.create = function create(properties) {
                        return new CreateStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffRequest} message CreateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffRequest} message CreateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffRequest} CreateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffRequest} CreateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffRequest} CreateStaffRequest
                     */
                    CreateStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffRequest();
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStaffRequest.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffRequest} message CreateStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staff = null;
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffRequest;
                })();
    
                v1.MoveStaffRequest = (function() {
    
                    /**
                     * Properties of a MoveStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IMoveStaffRequest
                     * @property {number|null} [sourceStoreId] MoveStaffRequest sourceStoreId
                     * @property {number|null} [destinationStoreId] MoveStaffRequest destinationStoreId
                     * @property {number|null} [staffId] MoveStaffRequest staffId
                     * @property {string|null} [auditUsername] MoveStaffRequest auditUsername
                     */
    
                    /**
                     * Constructs a new MoveStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MoveStaffRequest.
                     * @implements IMoveStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IMoveStaffRequest=} [properties] Properties to set
                     */
                    function MoveStaffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MoveStaffRequest sourceStoreId.
                     * @member {number} sourceStoreId
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @instance
                     */
                    MoveStaffRequest.prototype.sourceStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MoveStaffRequest destinationStoreId.
                     * @member {number} destinationStoreId
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @instance
                     */
                    MoveStaffRequest.prototype.destinationStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MoveStaffRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @instance
                     */
                    MoveStaffRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MoveStaffRequest auditUsername.
                     * @member {string} auditUsername
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @instance
                     */
                    MoveStaffRequest.prototype.auditUsername = "";
    
                    /**
                     * Creates a new MoveStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MoveStaffRequest} MoveStaffRequest instance
                     */
                    MoveStaffRequest.create = function create(properties) {
                        return new MoveStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MoveStaffRequest message. Does not implicitly {@link palexy.streaming.v1.MoveStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffRequest} message MoveStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MoveStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sourceStoreId != null && Object.hasOwnProperty.call(message, "sourceStoreId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.sourceStoreId);
                        if (message.destinationStoreId != null && Object.hasOwnProperty.call(message, "destinationStoreId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.destinationStoreId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.auditUsername != null && Object.hasOwnProperty.call(message, "auditUsername"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.auditUsername);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MoveStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.MoveStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffRequest} message MoveStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MoveStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MoveStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MoveStaffRequest} MoveStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MoveStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MoveStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sourceStoreId = reader.int64();
                                break;
                            case 2:
                                message.destinationStoreId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.auditUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MoveStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MoveStaffRequest} MoveStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MoveStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MoveStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MoveStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sourceStoreId != null && message.hasOwnProperty("sourceStoreId"))
                            if (!$util.isInteger(message.sourceStoreId) && !(message.sourceStoreId && $util.isInteger(message.sourceStoreId.low) && $util.isInteger(message.sourceStoreId.high)))
                                return "sourceStoreId: integer|Long expected";
                        if (message.destinationStoreId != null && message.hasOwnProperty("destinationStoreId"))
                            if (!$util.isInteger(message.destinationStoreId) && !(message.destinationStoreId && $util.isInteger(message.destinationStoreId.low) && $util.isInteger(message.destinationStoreId.high)))
                                return "destinationStoreId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            if (!$util.isString(message.auditUsername))
                                return "auditUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a MoveStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MoveStaffRequest} MoveStaffRequest
                     */
                    MoveStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MoveStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.MoveStaffRequest();
                        if (object.sourceStoreId != null)
                            if ($util.Long)
                                (message.sourceStoreId = $util.Long.fromValue(object.sourceStoreId)).unsigned = false;
                            else if (typeof object.sourceStoreId === "string")
                                message.sourceStoreId = parseInt(object.sourceStoreId, 10);
                            else if (typeof object.sourceStoreId === "number")
                                message.sourceStoreId = object.sourceStoreId;
                            else if (typeof object.sourceStoreId === "object")
                                message.sourceStoreId = new $util.LongBits(object.sourceStoreId.low >>> 0, object.sourceStoreId.high >>> 0).toNumber();
                        if (object.destinationStoreId != null)
                            if ($util.Long)
                                (message.destinationStoreId = $util.Long.fromValue(object.destinationStoreId)).unsigned = false;
                            else if (typeof object.destinationStoreId === "string")
                                message.destinationStoreId = parseInt(object.destinationStoreId, 10);
                            else if (typeof object.destinationStoreId === "number")
                                message.destinationStoreId = object.destinationStoreId;
                            else if (typeof object.destinationStoreId === "object")
                                message.destinationStoreId = new $util.LongBits(object.destinationStoreId.low >>> 0, object.destinationStoreId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.auditUsername != null)
                            message.auditUsername = String(object.auditUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MoveStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.MoveStaffRequest} message MoveStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MoveStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sourceStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sourceStoreId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.destinationStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.destinationStoreId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.auditUsername = "";
                        }
                        if (message.sourceStoreId != null && message.hasOwnProperty("sourceStoreId"))
                            if (typeof message.sourceStoreId === "number")
                                object.sourceStoreId = options.longs === String ? String(message.sourceStoreId) : message.sourceStoreId;
                            else
                                object.sourceStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.sourceStoreId) : options.longs === Number ? new $util.LongBits(message.sourceStoreId.low >>> 0, message.sourceStoreId.high >>> 0).toNumber() : message.sourceStoreId;
                        if (message.destinationStoreId != null && message.hasOwnProperty("destinationStoreId"))
                            if (typeof message.destinationStoreId === "number")
                                object.destinationStoreId = options.longs === String ? String(message.destinationStoreId) : message.destinationStoreId;
                            else
                                object.destinationStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.destinationStoreId) : options.longs === Number ? new $util.LongBits(message.destinationStoreId.low >>> 0, message.destinationStoreId.high >>> 0).toNumber() : message.destinationStoreId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            object.auditUsername = message.auditUsername;
                        return object;
                    };
    
                    /**
                     * Converts this MoveStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MoveStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MoveStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MoveStaffRequest;
                })();
    
                v1.MoveStaffResponse = (function() {
    
                    /**
                     * Properties of a MoveStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IMoveStaffResponse
                     */
    
                    /**
                     * Constructs a new MoveStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MoveStaffResponse.
                     * @implements IMoveStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IMoveStaffResponse=} [properties] Properties to set
                     */
                    function MoveStaffResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new MoveStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.MoveStaffResponse} MoveStaffResponse instance
                     */
                    MoveStaffResponse.create = function create(properties) {
                        return new MoveStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified MoveStaffResponse message. Does not implicitly {@link palexy.streaming.v1.MoveStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffResponse} message MoveStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MoveStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MoveStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.MoveStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IMoveStaffResponse} message MoveStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MoveStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MoveStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.MoveStaffResponse} MoveStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MoveStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.MoveStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MoveStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.MoveStaffResponse} MoveStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MoveStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MoveStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MoveStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a MoveStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.MoveStaffResponse} MoveStaffResponse
                     */
                    MoveStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.MoveStaffResponse)
                            return object;
                        return new $root.palexy.streaming.v1.MoveStaffResponse();
                    };
    
                    /**
                     * Creates a plain object from a MoveStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.MoveStaffResponse} message MoveStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MoveStaffResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this MoveStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.MoveStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MoveStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MoveStaffResponse;
                })();
    
                v1.ValidateStaffRequest = (function() {
    
                    /**
                     * Properties of a ValidateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IValidateStaffRequest
                     * @property {palexy.streaming.v1.IStaff|null} [staff] ValidateStaffRequest staff
                     * @property {boolean|null} [forUpdate] ValidateStaffRequest forUpdate
                     * @property {google.protobuf.IFieldMask|null} [updateMask] ValidateStaffRequest updateMask
                     */
    
                    /**
                     * Constructs a new ValidateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ValidateStaffRequest.
                     * @implements IValidateStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IValidateStaffRequest=} [properties] Properties to set
                     */
                    function ValidateStaffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ValidateStaffRequest staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @instance
                     */
                    ValidateStaffRequest.prototype.staff = null;
    
                    /**
                     * ValidateStaffRequest forUpdate.
                     * @member {boolean} forUpdate
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @instance
                     */
                    ValidateStaffRequest.prototype.forUpdate = false;
    
                    /**
                     * ValidateStaffRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @instance
                     */
                    ValidateStaffRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new ValidateStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ValidateStaffRequest} ValidateStaffRequest instance
                     */
                    ValidateStaffRequest.create = function create(properties) {
                        return new ValidateStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ValidateStaffRequest message. Does not implicitly {@link palexy.streaming.v1.ValidateStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffRequest} message ValidateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.forUpdate != null && Object.hasOwnProperty.call(message, "forUpdate"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.forUpdate);
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ValidateStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ValidateStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffRequest} message ValidateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ValidateStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ValidateStaffRequest} ValidateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ValidateStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.forUpdate = reader.bool();
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ValidateStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ValidateStaffRequest} ValidateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ValidateStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ValidateStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.forUpdate != null && message.hasOwnProperty("forUpdate"))
                            if (typeof message.forUpdate !== "boolean")
                                return "forUpdate: boolean expected";
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ValidateStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ValidateStaffRequest} ValidateStaffRequest
                     */
                    ValidateStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ValidateStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ValidateStaffRequest();
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.ValidateStaffRequest.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.forUpdate != null)
                            message.forUpdate = Boolean(object.forUpdate);
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.ValidateStaffRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ValidateStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ValidateStaffRequest} message ValidateStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ValidateStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staff = null;
                            object.forUpdate = false;
                            object.updateMask = null;
                        }
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.forUpdate != null && message.hasOwnProperty("forUpdate"))
                            object.forUpdate = message.forUpdate;
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this ValidateStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ValidateStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ValidateStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ValidateStaffRequest;
                })();
    
                v1.ValidateStaffResponse = (function() {
    
                    /**
                     * Properties of a ValidateStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IValidateStaffResponse
                     * @property {Array.<palexy.streaming.v1.ValidateStaffResponse.IWarning>|null} [warnings] ValidateStaffResponse warnings
                     */
    
                    /**
                     * Constructs a new ValidateStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ValidateStaffResponse.
                     * @implements IValidateStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IValidateStaffResponse=} [properties] Properties to set
                     */
                    function ValidateStaffResponse(properties) {
                        this.warnings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ValidateStaffResponse warnings.
                     * @member {Array.<palexy.streaming.v1.ValidateStaffResponse.IWarning>} warnings
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @instance
                     */
                    ValidateStaffResponse.prototype.warnings = $util.emptyArray;
    
                    /**
                     * Creates a new ValidateStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ValidateStaffResponse} ValidateStaffResponse instance
                     */
                    ValidateStaffResponse.create = function create(properties) {
                        return new ValidateStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ValidateStaffResponse message. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffResponse} message ValidateStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.warnings != null && message.warnings.length)
                            for (var i = 0; i < message.warnings.length; ++i)
                                $root.palexy.streaming.v1.ValidateStaffResponse.Warning.encode(message.warnings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ValidateStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IValidateStaffResponse} message ValidateStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ValidateStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ValidateStaffResponse} ValidateStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ValidateStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.warnings && message.warnings.length))
                                    message.warnings = [];
                                message.warnings.push($root.palexy.streaming.v1.ValidateStaffResponse.Warning.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ValidateStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ValidateStaffResponse} ValidateStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ValidateStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ValidateStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.warnings != null && message.hasOwnProperty("warnings")) {
                            if (!Array.isArray(message.warnings))
                                return "warnings: array expected";
                            for (var i = 0; i < message.warnings.length; ++i) {
                                var error = $root.palexy.streaming.v1.ValidateStaffResponse.Warning.verify(message.warnings[i]);
                                if (error)
                                    return "warnings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ValidateStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ValidateStaffResponse} ValidateStaffResponse
                     */
                    ValidateStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ValidateStaffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ValidateStaffResponse();
                        if (object.warnings) {
                            if (!Array.isArray(object.warnings))
                                throw TypeError(".palexy.streaming.v1.ValidateStaffResponse.warnings: array expected");
                            message.warnings = [];
                            for (var i = 0; i < object.warnings.length; ++i) {
                                if (typeof object.warnings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ValidateStaffResponse.warnings: object expected");
                                message.warnings[i] = $root.palexy.streaming.v1.ValidateStaffResponse.Warning.fromObject(object.warnings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ValidateStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.ValidateStaffResponse} message ValidateStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ValidateStaffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.warnings = [];
                        if (message.warnings && message.warnings.length) {
                            object.warnings = [];
                            for (var j = 0; j < message.warnings.length; ++j)
                                object.warnings[j] = $root.palexy.streaming.v1.ValidateStaffResponse.Warning.toObject(message.warnings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ValidateStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ValidateStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ValidateStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ValidateStaffResponse.Warning = (function() {
    
                        /**
                         * Properties of a Warning.
                         * @memberof palexy.streaming.v1.ValidateStaffResponse
                         * @interface IWarning
                         * @property {palexy.streaming.v1.ValidateStaffResponse.WarningType|null} [type] Warning type
                         * @property {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning|null} [duplicateStaffNameWarning] Warning duplicateStaffNameWarning
                         */
    
                        /**
                         * Constructs a new Warning.
                         * @memberof palexy.streaming.v1.ValidateStaffResponse
                         * @classdesc Represents a Warning.
                         * @implements IWarning
                         * @constructor
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IWarning=} [properties] Properties to set
                         */
                        function Warning(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Warning type.
                         * @member {palexy.streaming.v1.ValidateStaffResponse.WarningType} type
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @instance
                         */
                        Warning.prototype.type = 0;
    
                        /**
                         * Warning duplicateStaffNameWarning.
                         * @member {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning|null|undefined} duplicateStaffNameWarning
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @instance
                         */
                        Warning.prototype.duplicateStaffNameWarning = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * Warning details.
                         * @member {"duplicateStaffNameWarning"|undefined} details
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @instance
                         */
                        Object.defineProperty(Warning.prototype, "details", {
                            get: $util.oneOfGetter($oneOfFields = ["duplicateStaffNameWarning"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new Warning instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IWarning=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.Warning} Warning instance
                         */
                        Warning.create = function create(properties) {
                            return new Warning(properties);
                        };
    
                        /**
                         * Encodes the specified Warning message. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.Warning.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IWarning} message Warning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Warning.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.duplicateStaffNameWarning != null && Object.hasOwnProperty.call(message, "duplicateStaffNameWarning"))
                                $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.encode(message.duplicateStaffNameWarning, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Warning message, length delimited. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.Warning.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IWarning} message Warning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Warning.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Warning message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.Warning} Warning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Warning.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ValidateStaffResponse.Warning();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.type = reader.int32();
                                    break;
                                case 2:
                                    message.duplicateStaffNameWarning = $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Warning message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.Warning} Warning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Warning.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Warning message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Warning.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                    break;
                                }
                            if (message.duplicateStaffNameWarning != null && message.hasOwnProperty("duplicateStaffNameWarning")) {
                                properties.details = 1;
                                {
                                    var error = $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.verify(message.duplicateStaffNameWarning);
                                    if (error)
                                        return "duplicateStaffNameWarning." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Warning message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.Warning} Warning
                         */
                        Warning.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ValidateStaffResponse.Warning)
                                return object;
                            var message = new $root.palexy.streaming.v1.ValidateStaffResponse.Warning();
                            switch (object.type) {
                            case "UNKNOWN":
                            case 0:
                                message.type = 0;
                                break;
                            case "DUPLICATE_STAFF_NAME":
                            case 1:
                                message.type = 1;
                                break;
                            }
                            if (object.duplicateStaffNameWarning != null) {
                                if (typeof object.duplicateStaffNameWarning !== "object")
                                    throw TypeError(".palexy.streaming.v1.ValidateStaffResponse.Warning.duplicateStaffNameWarning: object expected");
                                message.duplicateStaffNameWarning = $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.fromObject(object.duplicateStaffNameWarning);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Warning message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.Warning} message Warning
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Warning.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.type = options.enums === String ? "UNKNOWN" : 0;
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.palexy.streaming.v1.ValidateStaffResponse.WarningType[message.type] : message.type;
                            if (message.duplicateStaffNameWarning != null && message.hasOwnProperty("duplicateStaffNameWarning")) {
                                object.duplicateStaffNameWarning = $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.toObject(message.duplicateStaffNameWarning, options);
                                if (options.oneofs)
                                    object.details = "duplicateStaffNameWarning";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Warning to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.Warning
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Warning.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Warning;
                    })();
    
                    /**
                     * WarningType enum.
                     * @name palexy.streaming.v1.ValidateStaffResponse.WarningType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} DUPLICATE_STAFF_NAME=1 DUPLICATE_STAFF_NAME value
                     */
                    ValidateStaffResponse.WarningType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "DUPLICATE_STAFF_NAME"] = 1;
                        return values;
                    })();
    
                    ValidateStaffResponse.DuplicateStaffNameWarning = (function() {
    
                        /**
                         * Properties of a DuplicateStaffNameWarning.
                         * @memberof palexy.streaming.v1.ValidateStaffResponse
                         * @interface IDuplicateStaffNameWarning
                         * @property {string|null} [staffName] DuplicateStaffNameWarning staffName
                         * @property {string|null} [storeWithSameStaffName] DuplicateStaffNameWarning storeWithSameStaffName
                         */
    
                        /**
                         * Constructs a new DuplicateStaffNameWarning.
                         * @memberof palexy.streaming.v1.ValidateStaffResponse
                         * @classdesc Represents a DuplicateStaffNameWarning.
                         * @implements IDuplicateStaffNameWarning
                         * @constructor
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning=} [properties] Properties to set
                         */
                        function DuplicateStaffNameWarning(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DuplicateStaffNameWarning staffName.
                         * @member {string} staffName
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @instance
                         */
                        DuplicateStaffNameWarning.prototype.staffName = "";
    
                        /**
                         * DuplicateStaffNameWarning storeWithSameStaffName.
                         * @member {string} storeWithSameStaffName
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @instance
                         */
                        DuplicateStaffNameWarning.prototype.storeWithSameStaffName = "";
    
                        /**
                         * Creates a new DuplicateStaffNameWarning instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning} DuplicateStaffNameWarning instance
                         */
                        DuplicateStaffNameWarning.create = function create(properties) {
                            return new DuplicateStaffNameWarning(properties);
                        };
    
                        /**
                         * Encodes the specified DuplicateStaffNameWarning message. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning} message DuplicateStaffNameWarning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DuplicateStaffNameWarning.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.staffName != null && Object.hasOwnProperty.call(message, "staffName"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.staffName);
                            if (message.storeWithSameStaffName != null && Object.hasOwnProperty.call(message, "storeWithSameStaffName"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeWithSameStaffName);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DuplicateStaffNameWarning message, length delimited. Does not implicitly {@link palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.IDuplicateStaffNameWarning} message DuplicateStaffNameWarning message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DuplicateStaffNameWarning.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DuplicateStaffNameWarning message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning} DuplicateStaffNameWarning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DuplicateStaffNameWarning.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.staffName = reader.string();
                                    break;
                                case 2:
                                    message.storeWithSameStaffName = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DuplicateStaffNameWarning message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning} DuplicateStaffNameWarning
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DuplicateStaffNameWarning.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DuplicateStaffNameWarning message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DuplicateStaffNameWarning.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.staffName != null && message.hasOwnProperty("staffName"))
                                if (!$util.isString(message.staffName))
                                    return "staffName: string expected";
                            if (message.storeWithSameStaffName != null && message.hasOwnProperty("storeWithSameStaffName"))
                                if (!$util.isString(message.storeWithSameStaffName))
                                    return "storeWithSameStaffName: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DuplicateStaffNameWarning message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning} DuplicateStaffNameWarning
                         */
                        DuplicateStaffNameWarning.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning)
                                return object;
                            var message = new $root.palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning();
                            if (object.staffName != null)
                                message.staffName = String(object.staffName);
                            if (object.storeWithSameStaffName != null)
                                message.storeWithSameStaffName = String(object.storeWithSameStaffName);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DuplicateStaffNameWarning message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @static
                         * @param {palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning} message DuplicateStaffNameWarning
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DuplicateStaffNameWarning.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.staffName = "";
                                object.storeWithSameStaffName = "";
                            }
                            if (message.staffName != null && message.hasOwnProperty("staffName"))
                                object.staffName = message.staffName;
                            if (message.storeWithSameStaffName != null && message.hasOwnProperty("storeWithSameStaffName"))
                                object.storeWithSameStaffName = message.storeWithSameStaffName;
                            return object;
                        };
    
                        /**
                         * Converts this DuplicateStaffNameWarning to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ValidateStaffResponse.DuplicateStaffNameWarning
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DuplicateStaffNameWarning.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DuplicateStaffNameWarning;
                    })();
    
                    return ValidateStaffResponse;
                })();
    
                v1.UpdateStaffRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffRequest
                     * @property {palexy.streaming.v1.IStaff|null} [staff] UpdateStaffRequest staff
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStaffRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffRequest.
                     * @implements IUpdateStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffRequest=} [properties] Properties to set
                     */
                    function UpdateStaffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffRequest staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @instance
                     */
                    UpdateStaffRequest.prototype.staff = null;
    
                    /**
                     * UpdateStaffRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @instance
                     */
                    UpdateStaffRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffRequest} UpdateStaffRequest instance
                     */
                    UpdateStaffRequest.create = function create(properties) {
                        return new UpdateStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffRequest} message UpdateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffRequest} message UpdateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffRequest} UpdateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffRequest} UpdateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffRequest} UpdateStaffRequest
                     */
                    UpdateStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffRequest();
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffRequest.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffRequest} message UpdateStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staff = null;
                            object.updateMask = null;
                        }
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffRequest;
                })();
    
                v1.UploadStaffPhotoRequest = (function() {
    
                    /**
                     * Properties of an UploadStaffPhotoRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUploadStaffPhotoRequest
                     * @property {number|null} [staffId] UploadStaffPhotoRequest staffId
                     * @property {Uint8Array|null} [smallPhoto] UploadStaffPhotoRequest smallPhoto
                     * @property {Uint8Array|null} [mediumPhoto] UploadStaffPhotoRequest mediumPhoto
                     * @property {Uint8Array|null} [largePhoto] UploadStaffPhotoRequest largePhoto
                     * @property {Uint8Array|null} [xlargePhoto] UploadStaffPhotoRequest xlargePhoto
                     * @property {string|null} [fileExtension] UploadStaffPhotoRequest fileExtension
                     */
    
                    /**
                     * Constructs a new UploadStaffPhotoRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UploadStaffPhotoRequest.
                     * @implements IUploadStaffPhotoRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest=} [properties] Properties to set
                     */
                    function UploadStaffPhotoRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UploadStaffPhotoRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UploadStaffPhotoRequest smallPhoto.
                     * @member {Uint8Array} smallPhoto
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.smallPhoto = $util.newBuffer([]);
    
                    /**
                     * UploadStaffPhotoRequest mediumPhoto.
                     * @member {Uint8Array} mediumPhoto
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.mediumPhoto = $util.newBuffer([]);
    
                    /**
                     * UploadStaffPhotoRequest largePhoto.
                     * @member {Uint8Array} largePhoto
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.largePhoto = $util.newBuffer([]);
    
                    /**
                     * UploadStaffPhotoRequest xlargePhoto.
                     * @member {Uint8Array} xlargePhoto
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.xlargePhoto = $util.newBuffer([]);
    
                    /**
                     * UploadStaffPhotoRequest fileExtension.
                     * @member {string} fileExtension
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     */
                    UploadStaffPhotoRequest.prototype.fileExtension = "";
    
                    /**
                     * Creates a new UploadStaffPhotoRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UploadStaffPhotoRequest} UploadStaffPhotoRequest instance
                     */
                    UploadStaffPhotoRequest.create = function create(properties) {
                        return new UploadStaffPhotoRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UploadStaffPhotoRequest message. Does not implicitly {@link palexy.streaming.v1.UploadStaffPhotoRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest} message UploadStaffPhotoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadStaffPhotoRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.smallPhoto != null && Object.hasOwnProperty.call(message, "smallPhoto"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.smallPhoto);
                        if (message.mediumPhoto != null && Object.hasOwnProperty.call(message, "mediumPhoto"))
                            writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.mediumPhoto);
                        if (message.largePhoto != null && Object.hasOwnProperty.call(message, "largePhoto"))
                            writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.largePhoto);
                        if (message.xlargePhoto != null && Object.hasOwnProperty.call(message, "xlargePhoto"))
                            writer.uint32(/* id 5, wireType 2 =*/42).bytes(message.xlargePhoto);
                        if (message.fileExtension != null && Object.hasOwnProperty.call(message, "fileExtension"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.fileExtension);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UploadStaffPhotoRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UploadStaffPhotoRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.IUploadStaffPhotoRequest} message UploadStaffPhotoRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UploadStaffPhotoRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UploadStaffPhotoRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UploadStaffPhotoRequest} UploadStaffPhotoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadStaffPhotoRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UploadStaffPhotoRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.smallPhoto = reader.bytes();
                                break;
                            case 3:
                                message.mediumPhoto = reader.bytes();
                                break;
                            case 4:
                                message.largePhoto = reader.bytes();
                                break;
                            case 5:
                                message.xlargePhoto = reader.bytes();
                                break;
                            case 6:
                                message.fileExtension = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UploadStaffPhotoRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UploadStaffPhotoRequest} UploadStaffPhotoRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UploadStaffPhotoRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UploadStaffPhotoRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UploadStaffPhotoRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.smallPhoto != null && message.hasOwnProperty("smallPhoto"))
                            if (!(message.smallPhoto && typeof message.smallPhoto.length === "number" || $util.isString(message.smallPhoto)))
                                return "smallPhoto: buffer expected";
                        if (message.mediumPhoto != null && message.hasOwnProperty("mediumPhoto"))
                            if (!(message.mediumPhoto && typeof message.mediumPhoto.length === "number" || $util.isString(message.mediumPhoto)))
                                return "mediumPhoto: buffer expected";
                        if (message.largePhoto != null && message.hasOwnProperty("largePhoto"))
                            if (!(message.largePhoto && typeof message.largePhoto.length === "number" || $util.isString(message.largePhoto)))
                                return "largePhoto: buffer expected";
                        if (message.xlargePhoto != null && message.hasOwnProperty("xlargePhoto"))
                            if (!(message.xlargePhoto && typeof message.xlargePhoto.length === "number" || $util.isString(message.xlargePhoto)))
                                return "xlargePhoto: buffer expected";
                        if (message.fileExtension != null && message.hasOwnProperty("fileExtension"))
                            if (!$util.isString(message.fileExtension))
                                return "fileExtension: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UploadStaffPhotoRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UploadStaffPhotoRequest} UploadStaffPhotoRequest
                     */
                    UploadStaffPhotoRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UploadStaffPhotoRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UploadStaffPhotoRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.smallPhoto != null)
                            if (typeof object.smallPhoto === "string")
                                $util.base64.decode(object.smallPhoto, message.smallPhoto = $util.newBuffer($util.base64.length(object.smallPhoto)), 0);
                            else if (object.smallPhoto.length)
                                message.smallPhoto = object.smallPhoto;
                        if (object.mediumPhoto != null)
                            if (typeof object.mediumPhoto === "string")
                                $util.base64.decode(object.mediumPhoto, message.mediumPhoto = $util.newBuffer($util.base64.length(object.mediumPhoto)), 0);
                            else if (object.mediumPhoto.length)
                                message.mediumPhoto = object.mediumPhoto;
                        if (object.largePhoto != null)
                            if (typeof object.largePhoto === "string")
                                $util.base64.decode(object.largePhoto, message.largePhoto = $util.newBuffer($util.base64.length(object.largePhoto)), 0);
                            else if (object.largePhoto.length)
                                message.largePhoto = object.largePhoto;
                        if (object.xlargePhoto != null)
                            if (typeof object.xlargePhoto === "string")
                                $util.base64.decode(object.xlargePhoto, message.xlargePhoto = $util.newBuffer($util.base64.length(object.xlargePhoto)), 0);
                            else if (object.xlargePhoto.length)
                                message.xlargePhoto = object.xlargePhoto;
                        if (object.fileExtension != null)
                            message.fileExtension = String(object.fileExtension);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UploadStaffPhotoRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @static
                     * @param {palexy.streaming.v1.UploadStaffPhotoRequest} message UploadStaffPhotoRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UploadStaffPhotoRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if (options.bytes === String)
                                object.smallPhoto = "";
                            else {
                                object.smallPhoto = [];
                                if (options.bytes !== Array)
                                    object.smallPhoto = $util.newBuffer(object.smallPhoto);
                            }
                            if (options.bytes === String)
                                object.mediumPhoto = "";
                            else {
                                object.mediumPhoto = [];
                                if (options.bytes !== Array)
                                    object.mediumPhoto = $util.newBuffer(object.mediumPhoto);
                            }
                            if (options.bytes === String)
                                object.largePhoto = "";
                            else {
                                object.largePhoto = [];
                                if (options.bytes !== Array)
                                    object.largePhoto = $util.newBuffer(object.largePhoto);
                            }
                            if (options.bytes === String)
                                object.xlargePhoto = "";
                            else {
                                object.xlargePhoto = [];
                                if (options.bytes !== Array)
                                    object.xlargePhoto = $util.newBuffer(object.xlargePhoto);
                            }
                            object.fileExtension = "";
                        }
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.smallPhoto != null && message.hasOwnProperty("smallPhoto"))
                            object.smallPhoto = options.bytes === String ? $util.base64.encode(message.smallPhoto, 0, message.smallPhoto.length) : options.bytes === Array ? Array.prototype.slice.call(message.smallPhoto) : message.smallPhoto;
                        if (message.mediumPhoto != null && message.hasOwnProperty("mediumPhoto"))
                            object.mediumPhoto = options.bytes === String ? $util.base64.encode(message.mediumPhoto, 0, message.mediumPhoto.length) : options.bytes === Array ? Array.prototype.slice.call(message.mediumPhoto) : message.mediumPhoto;
                        if (message.largePhoto != null && message.hasOwnProperty("largePhoto"))
                            object.largePhoto = options.bytes === String ? $util.base64.encode(message.largePhoto, 0, message.largePhoto.length) : options.bytes === Array ? Array.prototype.slice.call(message.largePhoto) : message.largePhoto;
                        if (message.xlargePhoto != null && message.hasOwnProperty("xlargePhoto"))
                            object.xlargePhoto = options.bytes === String ? $util.base64.encode(message.xlargePhoto, 0, message.xlargePhoto.length) : options.bytes === Array ? Array.prototype.slice.call(message.xlargePhoto) : message.xlargePhoto;
                        if (message.fileExtension != null && message.hasOwnProperty("fileExtension"))
                            object.fileExtension = message.fileExtension;
                        return object;
                    };
    
                    /**
                     * Converts this UploadStaffPhotoRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UploadStaffPhotoRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UploadStaffPhotoRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UploadStaffPhotoRequest;
                })();
    
                v1.GetStaffRequest = (function() {
    
                    /**
                     * Properties of a GetStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffRequest
                     * @property {number|null} [staffId] GetStaffRequest staffId
                     */
    
                    /**
                     * Constructs a new GetStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffRequest.
                     * @implements IGetStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffRequest=} [properties] Properties to set
                     */
                    function GetStaffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @instance
                     */
                    GetStaffRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffRequest} GetStaffRequest instance
                     */
                    GetStaffRequest.create = function create(properties) {
                        return new GetStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffRequest} message GetStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffRequest} message GetStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffRequest} GetStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffRequest} GetStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffRequest} GetStaffRequest
                     */
                    GetStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffRequest} message GetStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffRequest;
                })();
    
                v1.CustomAttributeFilter = (function() {
    
                    /**
                     * Properties of a CustomAttributeFilter.
                     * @memberof palexy.streaming.v1
                     * @interface ICustomAttributeFilter
                     * @property {number|null} [staffMetadataId] CustomAttributeFilter staffMetadataId
                     * @property {Array.<number>|null} [allowedValueIds] CustomAttributeFilter allowedValueIds
                     */
    
                    /**
                     * Constructs a new CustomAttributeFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CustomAttributeFilter.
                     * @implements ICustomAttributeFilter
                     * @constructor
                     * @param {palexy.streaming.v1.ICustomAttributeFilter=} [properties] Properties to set
                     */
                    function CustomAttributeFilter(properties) {
                        this.allowedValueIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomAttributeFilter staffMetadataId.
                     * @member {number} staffMetadataId
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @instance
                     */
                    CustomAttributeFilter.prototype.staffMetadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CustomAttributeFilter allowedValueIds.
                     * @member {Array.<number>} allowedValueIds
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @instance
                     */
                    CustomAttributeFilter.prototype.allowedValueIds = $util.emptyArray;
    
                    /**
                     * Creates a new CustomAttributeFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {palexy.streaming.v1.ICustomAttributeFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CustomAttributeFilter} CustomAttributeFilter instance
                     */
                    CustomAttributeFilter.create = function create(properties) {
                        return new CustomAttributeFilter(properties);
                    };
    
                    /**
                     * Encodes the specified CustomAttributeFilter message. Does not implicitly {@link palexy.streaming.v1.CustomAttributeFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {palexy.streaming.v1.ICustomAttributeFilter} message CustomAttributeFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomAttributeFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffMetadataId != null && Object.hasOwnProperty.call(message, "staffMetadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffMetadataId);
                        if (message.allowedValueIds != null && message.allowedValueIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.allowedValueIds.length; ++i)
                                writer.int64(message.allowedValueIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomAttributeFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.CustomAttributeFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {palexy.streaming.v1.ICustomAttributeFilter} message CustomAttributeFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomAttributeFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomAttributeFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CustomAttributeFilter} CustomAttributeFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomAttributeFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CustomAttributeFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffMetadataId = reader.int64();
                                break;
                            case 2:
                                if (!(message.allowedValueIds && message.allowedValueIds.length))
                                    message.allowedValueIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.allowedValueIds.push(reader.int64());
                                } else
                                    message.allowedValueIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomAttributeFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CustomAttributeFilter} CustomAttributeFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomAttributeFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomAttributeFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomAttributeFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffMetadataId != null && message.hasOwnProperty("staffMetadataId"))
                            if (!$util.isInteger(message.staffMetadataId) && !(message.staffMetadataId && $util.isInteger(message.staffMetadataId.low) && $util.isInteger(message.staffMetadataId.high)))
                                return "staffMetadataId: integer|Long expected";
                        if (message.allowedValueIds != null && message.hasOwnProperty("allowedValueIds")) {
                            if (!Array.isArray(message.allowedValueIds))
                                return "allowedValueIds: array expected";
                            for (var i = 0; i < message.allowedValueIds.length; ++i)
                                if (!$util.isInteger(message.allowedValueIds[i]) && !(message.allowedValueIds[i] && $util.isInteger(message.allowedValueIds[i].low) && $util.isInteger(message.allowedValueIds[i].high)))
                                    return "allowedValueIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CustomAttributeFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CustomAttributeFilter} CustomAttributeFilter
                     */
                    CustomAttributeFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CustomAttributeFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.CustomAttributeFilter();
                        if (object.staffMetadataId != null)
                            if ($util.Long)
                                (message.staffMetadataId = $util.Long.fromValue(object.staffMetadataId)).unsigned = false;
                            else if (typeof object.staffMetadataId === "string")
                                message.staffMetadataId = parseInt(object.staffMetadataId, 10);
                            else if (typeof object.staffMetadataId === "number")
                                message.staffMetadataId = object.staffMetadataId;
                            else if (typeof object.staffMetadataId === "object")
                                message.staffMetadataId = new $util.LongBits(object.staffMetadataId.low >>> 0, object.staffMetadataId.high >>> 0).toNumber();
                        if (object.allowedValueIds) {
                            if (!Array.isArray(object.allowedValueIds))
                                throw TypeError(".palexy.streaming.v1.CustomAttributeFilter.allowedValueIds: array expected");
                            message.allowedValueIds = [];
                            for (var i = 0; i < object.allowedValueIds.length; ++i)
                                if ($util.Long)
                                    (message.allowedValueIds[i] = $util.Long.fromValue(object.allowedValueIds[i])).unsigned = false;
                                else if (typeof object.allowedValueIds[i] === "string")
                                    message.allowedValueIds[i] = parseInt(object.allowedValueIds[i], 10);
                                else if (typeof object.allowedValueIds[i] === "number")
                                    message.allowedValueIds[i] = object.allowedValueIds[i];
                                else if (typeof object.allowedValueIds[i] === "object")
                                    message.allowedValueIds[i] = new $util.LongBits(object.allowedValueIds[i].low >>> 0, object.allowedValueIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomAttributeFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @static
                     * @param {palexy.streaming.v1.CustomAttributeFilter} message CustomAttributeFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomAttributeFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.allowedValueIds = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffMetadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffMetadataId = options.longs === String ? "0" : 0;
                        if (message.staffMetadataId != null && message.hasOwnProperty("staffMetadataId"))
                            if (typeof message.staffMetadataId === "number")
                                object.staffMetadataId = options.longs === String ? String(message.staffMetadataId) : message.staffMetadataId;
                            else
                                object.staffMetadataId = options.longs === String ? $util.Long.prototype.toString.call(message.staffMetadataId) : options.longs === Number ? new $util.LongBits(message.staffMetadataId.low >>> 0, message.staffMetadataId.high >>> 0).toNumber() : message.staffMetadataId;
                        if (message.allowedValueIds && message.allowedValueIds.length) {
                            object.allowedValueIds = [];
                            for (var j = 0; j < message.allowedValueIds.length; ++j)
                                if (typeof message.allowedValueIds[j] === "number")
                                    object.allowedValueIds[j] = options.longs === String ? String(message.allowedValueIds[j]) : message.allowedValueIds[j];
                                else
                                    object.allowedValueIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.allowedValueIds[j]) : options.longs === Number ? new $util.LongBits(message.allowedValueIds[j].low >>> 0, message.allowedValueIds[j].high >>> 0).toNumber() : message.allowedValueIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CustomAttributeFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CustomAttributeFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomAttributeFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomAttributeFilter;
                })();
    
                v1.ListStaffRequest = (function() {
    
                    /**
                     * Properties of a ListStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffRequest
                     * @property {Array.<number>|null} [storeId] ListStaffRequest storeId
                     * @property {google.protobuf.IBoolValue|null} [disabled] ListStaffRequest disabled
                     * @property {string|null} [searchKey] ListStaffRequest searchKey
                     * @property {number|null} [pageSize] ListStaffRequest pageSize
                     * @property {string|null} [pageToken] ListStaffRequest pageToken
                     * @property {Array.<string>|null} [orderByFields] ListStaffRequest orderByFields
                     * @property {Array.<palexy.streaming.v1.StaffInvitationStatus>|null} [invitationStatuses] ListStaffRequest invitationStatuses
                     * @property {Array.<number>|null} [staffIds] ListStaffRequest staffIds
                     * @property {string|null} [accountUsername] ListStaffRequest accountUsername
                     * @property {Array.<string>|null} [accountUsernames] ListStaffRequest accountUsernames
                     * @property {boolean|null} [includeWorkingSetting] ListStaffRequest includeWorkingSetting
                     * @property {number|null} [timeOffTypeId] ListStaffRequest timeOffTypeId
                     * @property {boolean|null} [includeHasScheduleManagerRole] ListStaffRequest includeHasScheduleManagerRole
                     * @property {Array.<palexy.protobuf.Gender>|null} [genders] ListStaffRequest genders
                     * @property {Array.<palexy.protobuf.StaffEmploymentType>|null} [employmentTypes] ListStaffRequest employmentTypes
                     * @property {Array.<palexy.streaming.v1.ICustomAttributeFilter>|null} [customAttributeFilters] ListStaffRequest customAttributeFilters
                     * @property {number|null} [matchingGroupId] ListStaffRequest matchingGroupId
                     * @property {boolean|null} [fetchApplyEmployeePolicy] ListStaffRequest fetchApplyEmployeePolicy
                     */
    
                    /**
                     * Constructs a new ListStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffRequest.
                     * @implements IListStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffRequest=} [properties] Properties to set
                     */
                    function ListStaffRequest(properties) {
                        this.storeId = [];
                        this.orderByFields = [];
                        this.invitationStatuses = [];
                        this.staffIds = [];
                        this.accountUsernames = [];
                        this.genders = [];
                        this.employmentTypes = [];
                        this.customAttributeFilters = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffRequest storeId.
                     * @member {Array.<number>} storeId
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.storeId = $util.emptyArray;
    
                    /**
                     * ListStaffRequest disabled.
                     * @member {google.protobuf.IBoolValue|null|undefined} disabled
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.disabled = null;
    
                    /**
                     * ListStaffRequest searchKey.
                     * @member {string} searchKey
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.searchKey = "";
    
                    /**
                     * ListStaffRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.pageToken = "";
    
                    /**
                     * ListStaffRequest orderByFields.
                     * @member {Array.<string>} orderByFields
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.orderByFields = $util.emptyArray;
    
                    /**
                     * ListStaffRequest invitationStatuses.
                     * @member {Array.<palexy.streaming.v1.StaffInvitationStatus>} invitationStatuses
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.invitationStatuses = $util.emptyArray;
    
                    /**
                     * ListStaffRequest staffIds.
                     * @member {Array.<number>} staffIds
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.staffIds = $util.emptyArray;
    
                    /**
                     * ListStaffRequest accountUsername.
                     * @member {string} accountUsername
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.accountUsername = "";
    
                    /**
                     * ListStaffRequest accountUsernames.
                     * @member {Array.<string>} accountUsernames
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.accountUsernames = $util.emptyArray;
    
                    /**
                     * ListStaffRequest includeWorkingSetting.
                     * @member {boolean} includeWorkingSetting
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.includeWorkingSetting = false;
    
                    /**
                     * ListStaffRequest timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffRequest includeHasScheduleManagerRole.
                     * @member {boolean} includeHasScheduleManagerRole
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.includeHasScheduleManagerRole = false;
    
                    /**
                     * ListStaffRequest genders.
                     * @member {Array.<palexy.protobuf.Gender>} genders
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.genders = $util.emptyArray;
    
                    /**
                     * ListStaffRequest employmentTypes.
                     * @member {Array.<palexy.protobuf.StaffEmploymentType>} employmentTypes
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.employmentTypes = $util.emptyArray;
    
                    /**
                     * ListStaffRequest customAttributeFilters.
                     * @member {Array.<palexy.streaming.v1.ICustomAttributeFilter>} customAttributeFilters
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.customAttributeFilters = $util.emptyArray;
    
                    /**
                     * ListStaffRequest matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffRequest fetchApplyEmployeePolicy.
                     * @member {boolean} fetchApplyEmployeePolicy
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     */
                    ListStaffRequest.prototype.fetchApplyEmployeePolicy = false;
    
                    /**
                     * Creates a new ListStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffRequest} ListStaffRequest instance
                     */
                    ListStaffRequest.create = function create(properties) {
                        return new ListStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffRequest} message ListStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && message.storeId.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeId.length; ++i)
                                writer.int64(message.storeId[i]);
                            writer.ldelim();
                        }
                        if (message.disabled != null && Object.hasOwnProperty.call(message, "disabled"))
                            $root.google.protobuf.BoolValue.encode(message.disabled, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.searchKey != null && Object.hasOwnProperty.call(message, "searchKey"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.searchKey);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        if (message.orderByFields != null && message.orderByFields.length)
                            for (var i = 0; i < message.orderByFields.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.orderByFields[i]);
                        if (message.invitationStatuses != null && message.invitationStatuses.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.invitationStatuses.length; ++i)
                                writer.int32(message.invitationStatuses[i]);
                            writer.ldelim();
                        }
                        if (message.staffIds != null && message.staffIds.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.staffIds.length; ++i)
                                writer.int64(message.staffIds[i]);
                            writer.ldelim();
                        }
                        if (message.accountUsername != null && Object.hasOwnProperty.call(message, "accountUsername"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.accountUsername);
                        if (message.includeWorkingSetting != null && Object.hasOwnProperty.call(message, "includeWorkingSetting"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.includeWorkingSetting);
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.timeOffTypeId);
                        if (message.includeHasScheduleManagerRole != null && Object.hasOwnProperty.call(message, "includeHasScheduleManagerRole"))
                            writer.uint32(/* id 12, wireType 0 =*/96).bool(message.includeHasScheduleManagerRole);
                        if (message.accountUsernames != null && message.accountUsernames.length)
                            for (var i = 0; i < message.accountUsernames.length; ++i)
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.accountUsernames[i]);
                        if (message.genders != null && message.genders.length) {
                            writer.uint32(/* id 14, wireType 2 =*/114).fork();
                            for (var i = 0; i < message.genders.length; ++i)
                                writer.int32(message.genders[i]);
                            writer.ldelim();
                        }
                        if (message.employmentTypes != null && message.employmentTypes.length) {
                            writer.uint32(/* id 15, wireType 2 =*/122).fork();
                            for (var i = 0; i < message.employmentTypes.length; ++i)
                                writer.int32(message.employmentTypes[i]);
                            writer.ldelim();
                        }
                        if (message.customAttributeFilters != null && message.customAttributeFilters.length)
                            for (var i = 0; i < message.customAttributeFilters.length; ++i)
                                $root.palexy.streaming.v1.CustomAttributeFilter.encode(message.customAttributeFilters[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.matchingGroupId);
                        if (message.fetchApplyEmployeePolicy != null && Object.hasOwnProperty.call(message, "fetchApplyEmployeePolicy"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.fetchApplyEmployeePolicy);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffRequest} message ListStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffRequest} ListStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeId && message.storeId.length))
                                    message.storeId = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeId.push(reader.int64());
                                } else
                                    message.storeId.push(reader.int64());
                                break;
                            case 2:
                                message.disabled = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.searchKey = reader.string();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            case 6:
                                if (!(message.orderByFields && message.orderByFields.length))
                                    message.orderByFields = [];
                                message.orderByFields.push(reader.string());
                                break;
                            case 7:
                                if (!(message.invitationStatuses && message.invitationStatuses.length))
                                    message.invitationStatuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.invitationStatuses.push(reader.int32());
                                } else
                                    message.invitationStatuses.push(reader.int32());
                                break;
                            case 8:
                                if (!(message.staffIds && message.staffIds.length))
                                    message.staffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffIds.push(reader.int64());
                                } else
                                    message.staffIds.push(reader.int64());
                                break;
                            case 9:
                                message.accountUsername = reader.string();
                                break;
                            case 13:
                                if (!(message.accountUsernames && message.accountUsernames.length))
                                    message.accountUsernames = [];
                                message.accountUsernames.push(reader.string());
                                break;
                            case 10:
                                message.includeWorkingSetting = reader.bool();
                                break;
                            case 11:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 12:
                                message.includeHasScheduleManagerRole = reader.bool();
                                break;
                            case 14:
                                if (!(message.genders && message.genders.length))
                                    message.genders = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.genders.push(reader.int32());
                                } else
                                    message.genders.push(reader.int32());
                                break;
                            case 15:
                                if (!(message.employmentTypes && message.employmentTypes.length))
                                    message.employmentTypes = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.employmentTypes.push(reader.int32());
                                } else
                                    message.employmentTypes.push(reader.int32());
                                break;
                            case 16:
                                if (!(message.customAttributeFilters && message.customAttributeFilters.length))
                                    message.customAttributeFilters = [];
                                message.customAttributeFilters.push($root.palexy.streaming.v1.CustomAttributeFilter.decode(reader, reader.uint32()));
                                break;
                            case 17:
                                message.matchingGroupId = reader.int64();
                                break;
                            case 18:
                                message.fetchApplyEmployeePolicy = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffRequest} ListStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (!Array.isArray(message.storeId))
                                return "storeId: array expected";
                            for (var i = 0; i < message.storeId.length; ++i)
                                if (!$util.isInteger(message.storeId[i]) && !(message.storeId[i] && $util.isInteger(message.storeId[i].low) && $util.isInteger(message.storeId[i].high)))
                                    return "storeId: integer|Long[] expected";
                        }
                        if (message.disabled != null && message.hasOwnProperty("disabled")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.disabled);
                            if (error)
                                return "disabled." + error;
                        }
                        if (message.searchKey != null && message.hasOwnProperty("searchKey"))
                            if (!$util.isString(message.searchKey))
                                return "searchKey: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.orderByFields != null && message.hasOwnProperty("orderByFields")) {
                            if (!Array.isArray(message.orderByFields))
                                return "orderByFields: array expected";
                            for (var i = 0; i < message.orderByFields.length; ++i)
                                if (!$util.isString(message.orderByFields[i]))
                                    return "orderByFields: string[] expected";
                        }
                        if (message.invitationStatuses != null && message.hasOwnProperty("invitationStatuses")) {
                            if (!Array.isArray(message.invitationStatuses))
                                return "invitationStatuses: array expected";
                            for (var i = 0; i < message.invitationStatuses.length; ++i)
                                switch (message.invitationStatuses[i]) {
                                default:
                                    return "invitationStatuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                    break;
                                }
                        }
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (!Array.isArray(message.staffIds))
                                return "staffIds: array expected";
                            for (var i = 0; i < message.staffIds.length; ++i)
                                if (!$util.isInteger(message.staffIds[i]) && !(message.staffIds[i] && $util.isInteger(message.staffIds[i].low) && $util.isInteger(message.staffIds[i].high)))
                                    return "staffIds: integer|Long[] expected";
                        }
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            if (!$util.isString(message.accountUsername))
                                return "accountUsername: string expected";
                        if (message.accountUsernames != null && message.hasOwnProperty("accountUsernames")) {
                            if (!Array.isArray(message.accountUsernames))
                                return "accountUsernames: array expected";
                            for (var i = 0; i < message.accountUsernames.length; ++i)
                                if (!$util.isString(message.accountUsernames[i]))
                                    return "accountUsernames: string[] expected";
                        }
                        if (message.includeWorkingSetting != null && message.hasOwnProperty("includeWorkingSetting"))
                            if (typeof message.includeWorkingSetting !== "boolean")
                                return "includeWorkingSetting: boolean expected";
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.includeHasScheduleManagerRole != null && message.hasOwnProperty("includeHasScheduleManagerRole"))
                            if (typeof message.includeHasScheduleManagerRole !== "boolean")
                                return "includeHasScheduleManagerRole: boolean expected";
                        if (message.genders != null && message.hasOwnProperty("genders")) {
                            if (!Array.isArray(message.genders))
                                return "genders: array expected";
                            for (var i = 0; i < message.genders.length; ++i)
                                switch (message.genders[i]) {
                                default:
                                    return "genders: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                        }
                        if (message.employmentTypes != null && message.hasOwnProperty("employmentTypes")) {
                            if (!Array.isArray(message.employmentTypes))
                                return "employmentTypes: array expected";
                            for (var i = 0; i < message.employmentTypes.length; ++i)
                                switch (message.employmentTypes[i]) {
                                default:
                                    return "employmentTypes: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                        }
                        if (message.customAttributeFilters != null && message.hasOwnProperty("customAttributeFilters")) {
                            if (!Array.isArray(message.customAttributeFilters))
                                return "customAttributeFilters: array expected";
                            for (var i = 0; i < message.customAttributeFilters.length; ++i) {
                                var error = $root.palexy.streaming.v1.CustomAttributeFilter.verify(message.customAttributeFilters[i]);
                                if (error)
                                    return "customAttributeFilters." + error;
                            }
                        }
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        if (message.fetchApplyEmployeePolicy != null && message.hasOwnProperty("fetchApplyEmployeePolicy"))
                            if (typeof message.fetchApplyEmployeePolicy !== "boolean")
                                return "fetchApplyEmployeePolicy: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffRequest} ListStaffRequest
                     */
                    ListStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffRequest();
                        if (object.storeId) {
                            if (!Array.isArray(object.storeId))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.storeId: array expected");
                            message.storeId = [];
                            for (var i = 0; i < object.storeId.length; ++i)
                                if ($util.Long)
                                    (message.storeId[i] = $util.Long.fromValue(object.storeId[i])).unsigned = false;
                                else if (typeof object.storeId[i] === "string")
                                    message.storeId[i] = parseInt(object.storeId[i], 10);
                                else if (typeof object.storeId[i] === "number")
                                    message.storeId[i] = object.storeId[i];
                                else if (typeof object.storeId[i] === "object")
                                    message.storeId[i] = new $util.LongBits(object.storeId[i].low >>> 0, object.storeId[i].high >>> 0).toNumber();
                        }
                        if (object.disabled != null) {
                            if (typeof object.disabled !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.disabled: object expected");
                            message.disabled = $root.google.protobuf.BoolValue.fromObject(object.disabled);
                        }
                        if (object.searchKey != null)
                            message.searchKey = String(object.searchKey);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.orderByFields) {
                            if (!Array.isArray(object.orderByFields))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.orderByFields: array expected");
                            message.orderByFields = [];
                            for (var i = 0; i < object.orderByFields.length; ++i)
                                message.orderByFields[i] = String(object.orderByFields[i]);
                        }
                        if (object.invitationStatuses) {
                            if (!Array.isArray(object.invitationStatuses))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.invitationStatuses: array expected");
                            message.invitationStatuses = [];
                            for (var i = 0; i < object.invitationStatuses.length; ++i)
                                switch (object.invitationStatuses[i]) {
                                default:
                                case "UNKNOWN_INVITATION_STATUS":
                                case 0:
                                    message.invitationStatuses[i] = 0;
                                    break;
                                case "NO_VERIFICATION_METHOD":
                                case 1:
                                    message.invitationStatuses[i] = 1;
                                    break;
                                case "NO_INVITATION_SEND":
                                case 2:
                                    message.invitationStatuses[i] = 2;
                                    break;
                                case "WAITING_TO_BE_PROCESSED":
                                case 3:
                                    message.invitationStatuses[i] = 3;
                                    break;
                                case "WAITING_FOR_CONFIRMATION":
                                case 4:
                                    message.invitationStatuses[i] = 4;
                                    break;
                                case "INVITATION_ACCEPTED":
                                case 5:
                                    message.invitationStatuses[i] = 5;
                                    break;
                                case "INVITATION_DECLINED":
                                case 6:
                                    message.invitationStatuses[i] = 6;
                                    break;
                                case "INVITATION_EXPIRED":
                                case 7:
                                    message.invitationStatuses[i] = 7;
                                    break;
                                case "PERMISSION_CONFLICT":
                                case 8:
                                    message.invitationStatuses[i] = 8;
                                    break;
                                case "SEND_INVITATION_FAILED":
                                case 9:
                                    message.invitationStatuses[i] = 9;
                                    break;
                                case "INVALID_STAFF_INFORMATION":
                                case 10:
                                    message.invitationStatuses[i] = 10;
                                    break;
                                }
                        }
                        if (object.staffIds) {
                            if (!Array.isArray(object.staffIds))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.staffIds: array expected");
                            message.staffIds = [];
                            for (var i = 0; i < object.staffIds.length; ++i)
                                if ($util.Long)
                                    (message.staffIds[i] = $util.Long.fromValue(object.staffIds[i])).unsigned = false;
                                else if (typeof object.staffIds[i] === "string")
                                    message.staffIds[i] = parseInt(object.staffIds[i], 10);
                                else if (typeof object.staffIds[i] === "number")
                                    message.staffIds[i] = object.staffIds[i];
                                else if (typeof object.staffIds[i] === "object")
                                    message.staffIds[i] = new $util.LongBits(object.staffIds[i].low >>> 0, object.staffIds[i].high >>> 0).toNumber();
                        }
                        if (object.accountUsername != null)
                            message.accountUsername = String(object.accountUsername);
                        if (object.accountUsernames) {
                            if (!Array.isArray(object.accountUsernames))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.accountUsernames: array expected");
                            message.accountUsernames = [];
                            for (var i = 0; i < object.accountUsernames.length; ++i)
                                message.accountUsernames[i] = String(object.accountUsernames[i]);
                        }
                        if (object.includeWorkingSetting != null)
                            message.includeWorkingSetting = Boolean(object.includeWorkingSetting);
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        if (object.includeHasScheduleManagerRole != null)
                            message.includeHasScheduleManagerRole = Boolean(object.includeHasScheduleManagerRole);
                        if (object.genders) {
                            if (!Array.isArray(object.genders))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.genders: array expected");
                            message.genders = [];
                            for (var i = 0; i < object.genders.length; ++i)
                                switch (object.genders[i]) {
                                default:
                                case "GENDER_UNSPECIFIED":
                                case 0:
                                    message.genders[i] = 0;
                                    break;
                                case "MALE":
                                case 1:
                                    message.genders[i] = 1;
                                    break;
                                case "FEMALE":
                                case 2:
                                    message.genders[i] = 2;
                                    break;
                                }
                        }
                        if (object.employmentTypes) {
                            if (!Array.isArray(object.employmentTypes))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.employmentTypes: array expected");
                            message.employmentTypes = [];
                            for (var i = 0; i < object.employmentTypes.length; ++i)
                                switch (object.employmentTypes[i]) {
                                default:
                                case "UNKNOWN_STAFF_EMPLOYMENT_TYPE":
                                case 0:
                                    message.employmentTypes[i] = 0;
                                    break;
                                case "FULL_TIME":
                                case 1:
                                    message.employmentTypes[i] = 1;
                                    break;
                                case "PART_TIME":
                                case 2:
                                    message.employmentTypes[i] = 2;
                                    break;
                                case "EXTERNAL_STAFF":
                                case 3:
                                    message.employmentTypes[i] = 3;
                                    break;
                                }
                        }
                        if (object.customAttributeFilters) {
                            if (!Array.isArray(object.customAttributeFilters))
                                throw TypeError(".palexy.streaming.v1.ListStaffRequest.customAttributeFilters: array expected");
                            message.customAttributeFilters = [];
                            for (var i = 0; i < object.customAttributeFilters.length; ++i) {
                                if (typeof object.customAttributeFilters[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffRequest.customAttributeFilters: object expected");
                                message.customAttributeFilters[i] = $root.palexy.streaming.v1.CustomAttributeFilter.fromObject(object.customAttributeFilters[i]);
                            }
                        }
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        if (object.fetchApplyEmployeePolicy != null)
                            message.fetchApplyEmployeePolicy = Boolean(object.fetchApplyEmployeePolicy);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffRequest} message ListStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeId = [];
                            object.orderByFields = [];
                            object.invitationStatuses = [];
                            object.staffIds = [];
                            object.accountUsernames = [];
                            object.genders = [];
                            object.employmentTypes = [];
                            object.customAttributeFilters = [];
                        }
                        if (options.defaults) {
                            object.disabled = null;
                            object.searchKey = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.accountUsername = "";
                            object.includeWorkingSetting = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            object.includeHasScheduleManagerRole = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                            object.fetchApplyEmployeePolicy = false;
                        }
                        if (message.storeId && message.storeId.length) {
                            object.storeId = [];
                            for (var j = 0; j < message.storeId.length; ++j)
                                if (typeof message.storeId[j] === "number")
                                    object.storeId[j] = options.longs === String ? String(message.storeId[j]) : message.storeId[j];
                                else
                                    object.storeId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeId[j]) : options.longs === Number ? new $util.LongBits(message.storeId[j].low >>> 0, message.storeId[j].high >>> 0).toNumber() : message.storeId[j];
                        }
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            object.disabled = $root.google.protobuf.BoolValue.toObject(message.disabled, options);
                        if (message.searchKey != null && message.hasOwnProperty("searchKey"))
                            object.searchKey = message.searchKey;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.orderByFields && message.orderByFields.length) {
                            object.orderByFields = [];
                            for (var j = 0; j < message.orderByFields.length; ++j)
                                object.orderByFields[j] = message.orderByFields[j];
                        }
                        if (message.invitationStatuses && message.invitationStatuses.length) {
                            object.invitationStatuses = [];
                            for (var j = 0; j < message.invitationStatuses.length; ++j)
                                object.invitationStatuses[j] = options.enums === String ? $root.palexy.streaming.v1.StaffInvitationStatus[message.invitationStatuses[j]] : message.invitationStatuses[j];
                        }
                        if (message.staffIds && message.staffIds.length) {
                            object.staffIds = [];
                            for (var j = 0; j < message.staffIds.length; ++j)
                                if (typeof message.staffIds[j] === "number")
                                    object.staffIds[j] = options.longs === String ? String(message.staffIds[j]) : message.staffIds[j];
                                else
                                    object.staffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffIds[j]) : options.longs === Number ? new $util.LongBits(message.staffIds[j].low >>> 0, message.staffIds[j].high >>> 0).toNumber() : message.staffIds[j];
                        }
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            object.accountUsername = message.accountUsername;
                        if (message.includeWorkingSetting != null && message.hasOwnProperty("includeWorkingSetting"))
                            object.includeWorkingSetting = message.includeWorkingSetting;
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.includeHasScheduleManagerRole != null && message.hasOwnProperty("includeHasScheduleManagerRole"))
                            object.includeHasScheduleManagerRole = message.includeHasScheduleManagerRole;
                        if (message.accountUsernames && message.accountUsernames.length) {
                            object.accountUsernames = [];
                            for (var j = 0; j < message.accountUsernames.length; ++j)
                                object.accountUsernames[j] = message.accountUsernames[j];
                        }
                        if (message.genders && message.genders.length) {
                            object.genders = [];
                            for (var j = 0; j < message.genders.length; ++j)
                                object.genders[j] = options.enums === String ? $root.palexy.protobuf.Gender[message.genders[j]] : message.genders[j];
                        }
                        if (message.employmentTypes && message.employmentTypes.length) {
                            object.employmentTypes = [];
                            for (var j = 0; j < message.employmentTypes.length; ++j)
                                object.employmentTypes[j] = options.enums === String ? $root.palexy.protobuf.StaffEmploymentType[message.employmentTypes[j]] : message.employmentTypes[j];
                        }
                        if (message.customAttributeFilters && message.customAttributeFilters.length) {
                            object.customAttributeFilters = [];
                            for (var j = 0; j < message.customAttributeFilters.length; ++j)
                                object.customAttributeFilters[j] = $root.palexy.streaming.v1.CustomAttributeFilter.toObject(message.customAttributeFilters[j], options);
                        }
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        if (message.fetchApplyEmployeePolicy != null && message.hasOwnProperty("fetchApplyEmployeePolicy"))
                            object.fetchApplyEmployeePolicy = message.fetchApplyEmployeePolicy;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffRequest;
                })();
    
                v1.DayOffStaff = (function() {
    
                    /**
                     * Properties of a DayOffStaff.
                     * @memberof palexy.streaming.v1
                     * @interface IDayOffStaff
                     * @property {palexy.streaming.v1.IStaff|null} [staff] DayOffStaff staff
                     * @property {palexy.streaming.v1.DayOffStaff.Category|null} [category] DayOffStaff category
                     * @property {string|null} [timeOffTypeName] DayOffStaff timeOffTypeName
                     * @property {string|null} [timeOffPaidType] DayOffStaff timeOffPaidType
                     * @property {number|null} [timeOffAmount] DayOffStaff timeOffAmount
                     * @property {number|null} [timeOffRequestId] DayOffStaff timeOffRequestId
                     * @property {number|null} [timeOffItemId] DayOffStaff timeOffItemId
                     * @property {string|null} [timeOffTrackingUnit] DayOffStaff timeOffTrackingUnit
                     * @property {number|null} [timeOffAmountInUnit] DayOffStaff timeOffAmountInUnit
                     */
    
                    /**
                     * Constructs a new DayOffStaff.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DayOffStaff.
                     * @implements IDayOffStaff
                     * @constructor
                     * @param {palexy.streaming.v1.IDayOffStaff=} [properties] Properties to set
                     */
                    function DayOffStaff(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DayOffStaff staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.staff = null;
    
                    /**
                     * DayOffStaff category.
                     * @member {palexy.streaming.v1.DayOffStaff.Category} category
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.category = 0;
    
                    /**
                     * DayOffStaff timeOffTypeName.
                     * @member {string} timeOffTypeName
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffTypeName = "";
    
                    /**
                     * DayOffStaff timeOffPaidType.
                     * @member {string} timeOffPaidType
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffPaidType = "";
    
                    /**
                     * DayOffStaff timeOffAmount.
                     * @member {number} timeOffAmount
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffAmount = 0;
    
                    /**
                     * DayOffStaff timeOffRequestId.
                     * @member {number} timeOffRequestId
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffRequestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DayOffStaff timeOffItemId.
                     * @member {number} timeOffItemId
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DayOffStaff timeOffTrackingUnit.
                     * @member {string} timeOffTrackingUnit
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffTrackingUnit = "";
    
                    /**
                     * DayOffStaff timeOffAmountInUnit.
                     * @member {number} timeOffAmountInUnit
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     */
                    DayOffStaff.prototype.timeOffAmountInUnit = 0;
    
                    /**
                     * Creates a new DayOffStaff instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {palexy.streaming.v1.IDayOffStaff=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DayOffStaff} DayOffStaff instance
                     */
                    DayOffStaff.create = function create(properties) {
                        return new DayOffStaff(properties);
                    };
    
                    /**
                     * Encodes the specified DayOffStaff message. Does not implicitly {@link palexy.streaming.v1.DayOffStaff.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {palexy.streaming.v1.IDayOffStaff} message DayOffStaff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DayOffStaff.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.category != null && Object.hasOwnProperty.call(message, "category"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.category);
                        if (message.timeOffTypeName != null && Object.hasOwnProperty.call(message, "timeOffTypeName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.timeOffTypeName);
                        if (message.timeOffPaidType != null && Object.hasOwnProperty.call(message, "timeOffPaidType"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.timeOffPaidType);
                        if (message.timeOffAmount != null && Object.hasOwnProperty.call(message, "timeOffAmount"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.timeOffAmount);
                        if (message.timeOffRequestId != null && Object.hasOwnProperty.call(message, "timeOffRequestId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.timeOffRequestId);
                        if (message.timeOffItemId != null && Object.hasOwnProperty.call(message, "timeOffItemId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.timeOffItemId);
                        if (message.timeOffTrackingUnit != null && Object.hasOwnProperty.call(message, "timeOffTrackingUnit"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.timeOffTrackingUnit);
                        if (message.timeOffAmountInUnit != null && Object.hasOwnProperty.call(message, "timeOffAmountInUnit"))
                            writer.uint32(/* id 9, wireType 1 =*/73).double(message.timeOffAmountInUnit);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DayOffStaff message, length delimited. Does not implicitly {@link palexy.streaming.v1.DayOffStaff.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {palexy.streaming.v1.IDayOffStaff} message DayOffStaff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DayOffStaff.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DayOffStaff message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DayOffStaff} DayOffStaff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DayOffStaff.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DayOffStaff();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.category = reader.int32();
                                break;
                            case 3:
                                message.timeOffTypeName = reader.string();
                                break;
                            case 4:
                                message.timeOffPaidType = reader.string();
                                break;
                            case 5:
                                message.timeOffAmount = reader.double();
                                break;
                            case 6:
                                message.timeOffRequestId = reader.int64();
                                break;
                            case 7:
                                message.timeOffItemId = reader.int64();
                                break;
                            case 8:
                                message.timeOffTrackingUnit = reader.string();
                                break;
                            case 9:
                                message.timeOffAmountInUnit = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DayOffStaff message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DayOffStaff} DayOffStaff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DayOffStaff.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DayOffStaff message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DayOffStaff.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.category != null && message.hasOwnProperty("category"))
                            switch (message.category) {
                            default:
                                return "category: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.timeOffTypeName != null && message.hasOwnProperty("timeOffTypeName"))
                            if (!$util.isString(message.timeOffTypeName))
                                return "timeOffTypeName: string expected";
                        if (message.timeOffPaidType != null && message.hasOwnProperty("timeOffPaidType"))
                            if (!$util.isString(message.timeOffPaidType))
                                return "timeOffPaidType: string expected";
                        if (message.timeOffAmount != null && message.hasOwnProperty("timeOffAmount"))
                            if (typeof message.timeOffAmount !== "number")
                                return "timeOffAmount: number expected";
                        if (message.timeOffRequestId != null && message.hasOwnProperty("timeOffRequestId"))
                            if (!$util.isInteger(message.timeOffRequestId) && !(message.timeOffRequestId && $util.isInteger(message.timeOffRequestId.low) && $util.isInteger(message.timeOffRequestId.high)))
                                return "timeOffRequestId: integer|Long expected";
                        if (message.timeOffItemId != null && message.hasOwnProperty("timeOffItemId"))
                            if (!$util.isInteger(message.timeOffItemId) && !(message.timeOffItemId && $util.isInteger(message.timeOffItemId.low) && $util.isInteger(message.timeOffItemId.high)))
                                return "timeOffItemId: integer|Long expected";
                        if (message.timeOffTrackingUnit != null && message.hasOwnProperty("timeOffTrackingUnit"))
                            if (!$util.isString(message.timeOffTrackingUnit))
                                return "timeOffTrackingUnit: string expected";
                        if (message.timeOffAmountInUnit != null && message.hasOwnProperty("timeOffAmountInUnit"))
                            if (typeof message.timeOffAmountInUnit !== "number")
                                return "timeOffAmountInUnit: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a DayOffStaff message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DayOffStaff} DayOffStaff
                     */
                    DayOffStaff.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DayOffStaff)
                            return object;
                        var message = new $root.palexy.streaming.v1.DayOffStaff();
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.DayOffStaff.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        switch (object.category) {
                        case "CATEGORY_UNSPECIFIED":
                        case 0:
                            message.category = 0;
                            break;
                        case "LEAVE_REQUEST":
                        case 1:
                            message.category = 1;
                            break;
                        case "NO_SCHEDULE":
                        case 2:
                            message.category = 2;
                            break;
                        }
                        if (object.timeOffTypeName != null)
                            message.timeOffTypeName = String(object.timeOffTypeName);
                        if (object.timeOffPaidType != null)
                            message.timeOffPaidType = String(object.timeOffPaidType);
                        if (object.timeOffAmount != null)
                            message.timeOffAmount = Number(object.timeOffAmount);
                        if (object.timeOffRequestId != null)
                            if ($util.Long)
                                (message.timeOffRequestId = $util.Long.fromValue(object.timeOffRequestId)).unsigned = false;
                            else if (typeof object.timeOffRequestId === "string")
                                message.timeOffRequestId = parseInt(object.timeOffRequestId, 10);
                            else if (typeof object.timeOffRequestId === "number")
                                message.timeOffRequestId = object.timeOffRequestId;
                            else if (typeof object.timeOffRequestId === "object")
                                message.timeOffRequestId = new $util.LongBits(object.timeOffRequestId.low >>> 0, object.timeOffRequestId.high >>> 0).toNumber();
                        if (object.timeOffItemId != null)
                            if ($util.Long)
                                (message.timeOffItemId = $util.Long.fromValue(object.timeOffItemId)).unsigned = false;
                            else if (typeof object.timeOffItemId === "string")
                                message.timeOffItemId = parseInt(object.timeOffItemId, 10);
                            else if (typeof object.timeOffItemId === "number")
                                message.timeOffItemId = object.timeOffItemId;
                            else if (typeof object.timeOffItemId === "object")
                                message.timeOffItemId = new $util.LongBits(object.timeOffItemId.low >>> 0, object.timeOffItemId.high >>> 0).toNumber();
                        if (object.timeOffTrackingUnit != null)
                            message.timeOffTrackingUnit = String(object.timeOffTrackingUnit);
                        if (object.timeOffAmountInUnit != null)
                            message.timeOffAmountInUnit = Number(object.timeOffAmountInUnit);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DayOffStaff message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @static
                     * @param {palexy.streaming.v1.DayOffStaff} message DayOffStaff
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DayOffStaff.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staff = null;
                            object.category = options.enums === String ? "CATEGORY_UNSPECIFIED" : 0;
                            object.timeOffTypeName = "";
                            object.timeOffPaidType = "";
                            object.timeOffAmount = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffRequestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffRequestId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffItemId = options.longs === String ? "0" : 0;
                            object.timeOffTrackingUnit = "";
                            object.timeOffAmountInUnit = 0;
                        }
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.category != null && message.hasOwnProperty("category"))
                            object.category = options.enums === String ? $root.palexy.streaming.v1.DayOffStaff.Category[message.category] : message.category;
                        if (message.timeOffTypeName != null && message.hasOwnProperty("timeOffTypeName"))
                            object.timeOffTypeName = message.timeOffTypeName;
                        if (message.timeOffPaidType != null && message.hasOwnProperty("timeOffPaidType"))
                            object.timeOffPaidType = message.timeOffPaidType;
                        if (message.timeOffAmount != null && message.hasOwnProperty("timeOffAmount"))
                            object.timeOffAmount = options.json && !isFinite(message.timeOffAmount) ? String(message.timeOffAmount) : message.timeOffAmount;
                        if (message.timeOffRequestId != null && message.hasOwnProperty("timeOffRequestId"))
                            if (typeof message.timeOffRequestId === "number")
                                object.timeOffRequestId = options.longs === String ? String(message.timeOffRequestId) : message.timeOffRequestId;
                            else
                                object.timeOffRequestId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffRequestId) : options.longs === Number ? new $util.LongBits(message.timeOffRequestId.low >>> 0, message.timeOffRequestId.high >>> 0).toNumber() : message.timeOffRequestId;
                        if (message.timeOffItemId != null && message.hasOwnProperty("timeOffItemId"))
                            if (typeof message.timeOffItemId === "number")
                                object.timeOffItemId = options.longs === String ? String(message.timeOffItemId) : message.timeOffItemId;
                            else
                                object.timeOffItemId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffItemId) : options.longs === Number ? new $util.LongBits(message.timeOffItemId.low >>> 0, message.timeOffItemId.high >>> 0).toNumber() : message.timeOffItemId;
                        if (message.timeOffTrackingUnit != null && message.hasOwnProperty("timeOffTrackingUnit"))
                            object.timeOffTrackingUnit = message.timeOffTrackingUnit;
                        if (message.timeOffAmountInUnit != null && message.hasOwnProperty("timeOffAmountInUnit"))
                            object.timeOffAmountInUnit = options.json && !isFinite(message.timeOffAmountInUnit) ? String(message.timeOffAmountInUnit) : message.timeOffAmountInUnit;
                        return object;
                    };
    
                    /**
                     * Converts this DayOffStaff to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DayOffStaff
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DayOffStaff.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Category enum.
                     * @name palexy.streaming.v1.DayOffStaff.Category
                     * @enum {number}
                     * @property {number} CATEGORY_UNSPECIFIED=0 CATEGORY_UNSPECIFIED value
                     * @property {number} LEAVE_REQUEST=1 LEAVE_REQUEST value
                     * @property {number} NO_SCHEDULE=2 NO_SCHEDULE value
                     */
                    DayOffStaff.Category = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "CATEGORY_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "LEAVE_REQUEST"] = 1;
                        values[valuesById[2] = "NO_SCHEDULE"] = 2;
                        return values;
                    })();
    
                    return DayOffStaff;
                })();
    
                v1.ListDayOffStaffResponse = (function() {
    
                    /**
                     * Properties of a ListDayOffStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListDayOffStaffResponse
                     * @property {Array.<palexy.streaming.v1.IDayOffStaff>|null} [dayOffStaff] ListDayOffStaffResponse dayOffStaff
                     * @property {number|null} [totalElements] ListDayOffStaffResponse totalElements
                     * @property {string|null} [nextPageToken] ListDayOffStaffResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListDayOffStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListDayOffStaffResponse.
                     * @implements IListDayOffStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListDayOffStaffResponse=} [properties] Properties to set
                     */
                    function ListDayOffStaffResponse(properties) {
                        this.dayOffStaff = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDayOffStaffResponse dayOffStaff.
                     * @member {Array.<palexy.streaming.v1.IDayOffStaff>} dayOffStaff
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @instance
                     */
                    ListDayOffStaffResponse.prototype.dayOffStaff = $util.emptyArray;
    
                    /**
                     * ListDayOffStaffResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @instance
                     */
                    ListDayOffStaffResponse.prototype.totalElements = 0;
    
                    /**
                     * ListDayOffStaffResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @instance
                     */
                    ListDayOffStaffResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListDayOffStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListDayOffStaffResponse} ListDayOffStaffResponse instance
                     */
                    ListDayOffStaffResponse.create = function create(properties) {
                        return new ListDayOffStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListDayOffStaffResponse message. Does not implicitly {@link palexy.streaming.v1.ListDayOffStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffResponse} message ListDayOffStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDayOffStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dayOffStaff != null && message.dayOffStaff.length)
                            for (var i = 0; i < message.dayOffStaff.length; ++i)
                                $root.palexy.streaming.v1.DayOffStaff.encode(message.dayOffStaff[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDayOffStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListDayOffStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffResponse} message ListDayOffStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDayOffStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDayOffStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListDayOffStaffResponse} ListDayOffStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDayOffStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListDayOffStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dayOffStaff && message.dayOffStaff.length))
                                    message.dayOffStaff = [];
                                message.dayOffStaff.push($root.palexy.streaming.v1.DayOffStaff.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDayOffStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListDayOffStaffResponse} ListDayOffStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDayOffStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDayOffStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDayOffStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dayOffStaff != null && message.hasOwnProperty("dayOffStaff")) {
                            if (!Array.isArray(message.dayOffStaff))
                                return "dayOffStaff: array expected";
                            for (var i = 0; i < message.dayOffStaff.length; ++i) {
                                var error = $root.palexy.streaming.v1.DayOffStaff.verify(message.dayOffStaff[i]);
                                if (error)
                                    return "dayOffStaff." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListDayOffStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListDayOffStaffResponse} ListDayOffStaffResponse
                     */
                    ListDayOffStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListDayOffStaffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListDayOffStaffResponse();
                        if (object.dayOffStaff) {
                            if (!Array.isArray(object.dayOffStaff))
                                throw TypeError(".palexy.streaming.v1.ListDayOffStaffResponse.dayOffStaff: array expected");
                            message.dayOffStaff = [];
                            for (var i = 0; i < object.dayOffStaff.length; ++i) {
                                if (typeof object.dayOffStaff[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListDayOffStaffResponse.dayOffStaff: object expected");
                                message.dayOffStaff[i] = $root.palexy.streaming.v1.DayOffStaff.fromObject(object.dayOffStaff[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDayOffStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.ListDayOffStaffResponse} message ListDayOffStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDayOffStaffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dayOffStaff = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.dayOffStaff && message.dayOffStaff.length) {
                            object.dayOffStaff = [];
                            for (var j = 0; j < message.dayOffStaff.length; ++j)
                                object.dayOffStaff[j] = $root.palexy.streaming.v1.DayOffStaff.toObject(message.dayOffStaff[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListDayOffStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListDayOffStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDayOffStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDayOffStaffResponse;
                })();
    
                v1.ListDayOffStaffRequest = (function() {
    
                    /**
                     * Properties of a ListDayOffStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListDayOffStaffRequest
                     * @property {Array.<number>|null} [storeIds] ListDayOffStaffRequest storeIds
                     * @property {number|null} [startDateId] ListDayOffStaffRequest startDateId
                     * @property {number|null} [endDateId] ListDayOffStaffRequest endDateId
                     * @property {number|null} [pageSize] ListDayOffStaffRequest pageSize
                     * @property {string|null} [pageToken] ListDayOffStaffRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListDayOffStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListDayOffStaffRequest.
                     * @implements IListDayOffStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest=} [properties] Properties to set
                     */
                    function ListDayOffStaffRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDayOffStaffRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     */
                    ListDayOffStaffRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListDayOffStaffRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     */
                    ListDayOffStaffRequest.prototype.startDateId = 0;
    
                    /**
                     * ListDayOffStaffRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     */
                    ListDayOffStaffRequest.prototype.endDateId = 0;
    
                    /**
                     * ListDayOffStaffRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     */
                    ListDayOffStaffRequest.prototype.pageSize = 0;
    
                    /**
                     * ListDayOffStaffRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     */
                    ListDayOffStaffRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListDayOffStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListDayOffStaffRequest} ListDayOffStaffRequest instance
                     */
                    ListDayOffStaffRequest.create = function create(properties) {
                        return new ListDayOffStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListDayOffStaffRequest message. Does not implicitly {@link palexy.streaming.v1.ListDayOffStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest} message ListDayOffStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDayOffStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDayOffStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListDayOffStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IListDayOffStaffRequest} message ListDayOffStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDayOffStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDayOffStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListDayOffStaffRequest} ListDayOffStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDayOffStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListDayOffStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDayOffStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListDayOffStaffRequest} ListDayOffStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDayOffStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDayOffStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDayOffStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListDayOffStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListDayOffStaffRequest} ListDayOffStaffRequest
                     */
                    ListDayOffStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListDayOffStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListDayOffStaffRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListDayOffStaffRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDayOffStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.ListDayOffStaffRequest} message ListDayOffStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDayOffStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListDayOffStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListDayOffStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDayOffStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDayOffStaffRequest;
                })();
    
                v1.ListStaffResponse = (function() {
    
                    /**
                     * Properties of a ListStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffResponse
                     * @property {Array.<palexy.streaming.v1.IStaff>|null} [staff] ListStaffResponse staff
                     * @property {number|null} [totalElements] ListStaffResponse totalElements
                     * @property {string|null} [nextPageToken] ListStaffResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffResponse.
                     * @implements IListStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffResponse=} [properties] Properties to set
                     */
                    function ListStaffResponse(properties) {
                        this.staff = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffResponse staff.
                     * @member {Array.<palexy.streaming.v1.IStaff>} staff
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @instance
                     */
                    ListStaffResponse.prototype.staff = $util.emptyArray;
    
                    /**
                     * ListStaffResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @instance
                     */
                    ListStaffResponse.prototype.totalElements = 0;
    
                    /**
                     * ListStaffResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @instance
                     */
                    ListStaffResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffResponse} ListStaffResponse instance
                     */
                    ListStaffResponse.create = function create(properties) {
                        return new ListStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffResponse} message ListStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && message.staff.length)
                            for (var i = 0; i < message.staff.length; ++i)
                                $root.palexy.streaming.v1.Staff.encode(message.staff[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffResponse} message ListStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffResponse} ListStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staff && message.staff.length))
                                    message.staff = [];
                                message.staff.push($root.palexy.streaming.v1.Staff.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffResponse} ListStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            if (!Array.isArray(message.staff))
                                return "staff: array expected";
                            for (var i = 0; i < message.staff.length; ++i) {
                                var error = $root.palexy.streaming.v1.Staff.verify(message.staff[i]);
                                if (error)
                                    return "staff." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffResponse} ListStaffResponse
                     */
                    ListStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffResponse();
                        if (object.staff) {
                            if (!Array.isArray(object.staff))
                                throw TypeError(".palexy.streaming.v1.ListStaffResponse.staff: array expected");
                            message.staff = [];
                            for (var i = 0; i < object.staff.length; ++i) {
                                if (typeof object.staff[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffResponse.staff: object expected");
                                message.staff[i] = $root.palexy.streaming.v1.Staff.fromObject(object.staff[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffResponse} message ListStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staff = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.staff && message.staff.length) {
                            object.staff = [];
                            for (var j = 0; j < message.staff.length; ++j)
                                object.staff[j] = $root.palexy.streaming.v1.Staff.toObject(message.staff[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffResponse;
                })();
    
                v1.BatchCreateStaffRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStaffRequest
                     * @property {number|null} [companyId] BatchCreateStaffRequest companyId
                     * @property {Array.<palexy.streaming.v1.IStaff>|null} [staff] BatchCreateStaffRequest staff
                     * @property {boolean|null} [preview] BatchCreateStaffRequest preview
                     * @property {boolean|null} [disableNotInList] BatchCreateStaffRequest disableNotInList
                     * @property {Array.<number>|null} [affectedStoreIds] BatchCreateStaffRequest affectedStoreIds
                     */
    
                    /**
                     * Constructs a new BatchCreateStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStaffRequest.
                     * @implements IBatchCreateStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest=} [properties] Properties to set
                     */
                    function BatchCreateStaffRequest(properties) {
                        this.staff = [];
                        this.affectedStoreIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStaffRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     */
                    BatchCreateStaffRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchCreateStaffRequest staff.
                     * @member {Array.<palexy.streaming.v1.IStaff>} staff
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     */
                    BatchCreateStaffRequest.prototype.staff = $util.emptyArray;
    
                    /**
                     * BatchCreateStaffRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     */
                    BatchCreateStaffRequest.prototype.preview = false;
    
                    /**
                     * BatchCreateStaffRequest disableNotInList.
                     * @member {boolean} disableNotInList
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     */
                    BatchCreateStaffRequest.prototype.disableNotInList = false;
    
                    /**
                     * BatchCreateStaffRequest affectedStoreIds.
                     * @member {Array.<number>} affectedStoreIds
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     */
                    BatchCreateStaffRequest.prototype.affectedStoreIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStaffRequest} BatchCreateStaffRequest instance
                     */
                    BatchCreateStaffRequest.create = function create(properties) {
                        return new BatchCreateStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest} message BatchCreateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.staff != null && message.staff.length)
                            for (var i = 0; i < message.staff.length; ++i)
                                $root.palexy.streaming.v1.Staff.encode(message.staff[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.preview);
                        if (message.disableNotInList != null && Object.hasOwnProperty.call(message, "disableNotInList"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.disableNotInList);
                        if (message.affectedStoreIds != null && message.affectedStoreIds.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.affectedStoreIds.length; ++i)
                                writer.int64(message.affectedStoreIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffRequest} message BatchCreateStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStaffRequest} BatchCreateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                if (!(message.staff && message.staff.length))
                                    message.staff = [];
                                message.staff.push($root.palexy.streaming.v1.Staff.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.preview = reader.bool();
                                break;
                            case 4:
                                message.disableNotInList = reader.bool();
                                break;
                            case 5:
                                if (!(message.affectedStoreIds && message.affectedStoreIds.length))
                                    message.affectedStoreIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.affectedStoreIds.push(reader.int64());
                                } else
                                    message.affectedStoreIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStaffRequest} BatchCreateStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            if (!Array.isArray(message.staff))
                                return "staff: array expected";
                            for (var i = 0; i < message.staff.length; ++i) {
                                var error = $root.palexy.streaming.v1.Staff.verify(message.staff[i]);
                                if (error)
                                    return "staff." + error;
                            }
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.disableNotInList != null && message.hasOwnProperty("disableNotInList"))
                            if (typeof message.disableNotInList !== "boolean")
                                return "disableNotInList: boolean expected";
                        if (message.affectedStoreIds != null && message.hasOwnProperty("affectedStoreIds")) {
                            if (!Array.isArray(message.affectedStoreIds))
                                return "affectedStoreIds: array expected";
                            for (var i = 0; i < message.affectedStoreIds.length; ++i)
                                if (!$util.isInteger(message.affectedStoreIds[i]) && !(message.affectedStoreIds[i] && $util.isInteger(message.affectedStoreIds[i].low) && $util.isInteger(message.affectedStoreIds[i].high)))
                                    return "affectedStoreIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStaffRequest} BatchCreateStaffRequest
                     */
                    BatchCreateStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStaffRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.staff) {
                            if (!Array.isArray(object.staff))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStaffRequest.staff: array expected");
                            message.staff = [];
                            for (var i = 0; i < object.staff.length; ++i) {
                                if (typeof object.staff[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStaffRequest.staff: object expected");
                                message.staff[i] = $root.palexy.streaming.v1.Staff.fromObject(object.staff[i]);
                            }
                        }
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.disableNotInList != null)
                            message.disableNotInList = Boolean(object.disableNotInList);
                        if (object.affectedStoreIds) {
                            if (!Array.isArray(object.affectedStoreIds))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStaffRequest.affectedStoreIds: array expected");
                            message.affectedStoreIds = [];
                            for (var i = 0; i < object.affectedStoreIds.length; ++i)
                                if ($util.Long)
                                    (message.affectedStoreIds[i] = $util.Long.fromValue(object.affectedStoreIds[i])).unsigned = false;
                                else if (typeof object.affectedStoreIds[i] === "string")
                                    message.affectedStoreIds[i] = parseInt(object.affectedStoreIds[i], 10);
                                else if (typeof object.affectedStoreIds[i] === "number")
                                    message.affectedStoreIds[i] = object.affectedStoreIds[i];
                                else if (typeof object.affectedStoreIds[i] === "object")
                                    message.affectedStoreIds[i] = new $util.LongBits(object.affectedStoreIds[i].low >>> 0, object.affectedStoreIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStaffRequest} message BatchCreateStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.staff = [];
                            object.affectedStoreIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.preview = false;
                            object.disableNotInList = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.staff && message.staff.length) {
                            object.staff = [];
                            for (var j = 0; j < message.staff.length; ++j)
                                object.staff[j] = $root.palexy.streaming.v1.Staff.toObject(message.staff[j], options);
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        if (message.disableNotInList != null && message.hasOwnProperty("disableNotInList"))
                            object.disableNotInList = message.disableNotInList;
                        if (message.affectedStoreIds && message.affectedStoreIds.length) {
                            object.affectedStoreIds = [];
                            for (var j = 0; j < message.affectedStoreIds.length; ++j)
                                if (typeof message.affectedStoreIds[j] === "number")
                                    object.affectedStoreIds[j] = options.longs === String ? String(message.affectedStoreIds[j]) : message.affectedStoreIds[j];
                                else
                                    object.affectedStoreIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.affectedStoreIds[j]) : options.longs === Number ? new $util.LongBits(message.affectedStoreIds[j].low >>> 0, message.affectedStoreIds[j].high >>> 0).toNumber() : message.affectedStoreIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStaffRequest;
                })();
    
                v1.BatchCreateStaffResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStaffResponse
                     * @property {Array.<palexy.streaming.v1.IBatchCreateStaffResult>|null} [results] BatchCreateStaffResponse results
                     */
    
                    /**
                     * Constructs a new BatchCreateStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStaffResponse.
                     * @implements IBatchCreateStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStaffResponse=} [properties] Properties to set
                     */
                    function BatchCreateStaffResponse(properties) {
                        this.results = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStaffResponse results.
                     * @member {Array.<palexy.streaming.v1.IBatchCreateStaffResult>} results
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @instance
                     */
                    BatchCreateStaffResponse.prototype.results = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStaffResponse} BatchCreateStaffResponse instance
                     */
                    BatchCreateStaffResponse.create = function create(properties) {
                        return new BatchCreateStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResponse} message BatchCreateStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.results != null && message.results.length)
                            for (var i = 0; i < message.results.length; ++i)
                                $root.palexy.streaming.v1.BatchCreateStaffResult.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResponse} message BatchCreateStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStaffResponse} BatchCreateStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.results && message.results.length))
                                    message.results = [];
                                message.results.push($root.palexy.streaming.v1.BatchCreateStaffResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStaffResponse} BatchCreateStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.results != null && message.hasOwnProperty("results")) {
                            if (!Array.isArray(message.results))
                                return "results: array expected";
                            for (var i = 0; i < message.results.length; ++i) {
                                var error = $root.palexy.streaming.v1.BatchCreateStaffResult.verify(message.results[i]);
                                if (error)
                                    return "results." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStaffResponse} BatchCreateStaffResponse
                     */
                    BatchCreateStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStaffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStaffResponse();
                        if (object.results) {
                            if (!Array.isArray(object.results))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStaffResponse.results: array expected");
                            message.results = [];
                            for (var i = 0; i < object.results.length; ++i) {
                                if (typeof object.results[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStaffResponse.results: object expected");
                                message.results[i] = $root.palexy.streaming.v1.BatchCreateStaffResult.fromObject(object.results[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStaffResponse} message BatchCreateStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStaffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.results = [];
                        if (message.results && message.results.length) {
                            object.results = [];
                            for (var j = 0; j < message.results.length; ++j)
                                object.results[j] = $root.palexy.streaming.v1.BatchCreateStaffResult.toObject(message.results[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStaffResponse;
                })();
    
                v1.BatchCreateStaffResult = (function() {
    
                    /**
                     * Properties of a BatchCreateStaffResult.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStaffResult
                     * @property {palexy.streaming.v1.IStaff|null} [staff] BatchCreateStaffResult staff
                     * @property {number|null} [rowNum] BatchCreateStaffResult rowNum
                     * @property {boolean|null} [newStaff] BatchCreateStaffResult newStaff
                     * @property {boolean|null} [existed] BatchCreateStaffResult existed
                     * @property {string|null} [failedReason] BatchCreateStaffResult failedReason
                     * @property {boolean|null} [disabled] BatchCreateStaffResult disabled
                     */
    
                    /**
                     * Constructs a new BatchCreateStaffResult.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStaffResult.
                     * @implements IBatchCreateStaffResult
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStaffResult=} [properties] Properties to set
                     */
                    function BatchCreateStaffResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStaffResult staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.staff = null;
    
                    /**
                     * BatchCreateStaffResult rowNum.
                     * @member {number} rowNum
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.rowNum = 0;
    
                    /**
                     * BatchCreateStaffResult newStaff.
                     * @member {boolean} newStaff
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.newStaff = false;
    
                    /**
                     * BatchCreateStaffResult existed.
                     * @member {boolean} existed
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.existed = false;
    
                    /**
                     * BatchCreateStaffResult failedReason.
                     * @member {string} failedReason
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.failedReason = "";
    
                    /**
                     * BatchCreateStaffResult disabled.
                     * @member {boolean} disabled
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     */
                    BatchCreateStaffResult.prototype.disabled = false;
    
                    /**
                     * Creates a new BatchCreateStaffResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResult=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStaffResult} BatchCreateStaffResult instance
                     */
                    BatchCreateStaffResult.create = function create(properties) {
                        return new BatchCreateStaffResult(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffResult message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResult} message BatchCreateStaffResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.rowNum != null && Object.hasOwnProperty.call(message, "rowNum"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.rowNum);
                        if (message.newStaff != null && Object.hasOwnProperty.call(message, "newStaff"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.newStaff);
                        if (message.existed != null && Object.hasOwnProperty.call(message, "existed"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.existed);
                        if (message.failedReason != null && Object.hasOwnProperty.call(message, "failedReason"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.failedReason);
                        if (message.disabled != null && Object.hasOwnProperty.call(message, "disabled"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.disabled);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStaffResult message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStaffResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStaffResult} message BatchCreateStaffResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStaffResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStaffResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStaffResult} BatchCreateStaffResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStaffResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.rowNum = reader.int32();
                                break;
                            case 3:
                                message.newStaff = reader.bool();
                                break;
                            case 4:
                                message.existed = reader.bool();
                                break;
                            case 5:
                                message.failedReason = reader.string();
                                break;
                            case 6:
                                message.disabled = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStaffResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStaffResult} BatchCreateStaffResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStaffResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStaffResult message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStaffResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.rowNum != null && message.hasOwnProperty("rowNum"))
                            if (!$util.isInteger(message.rowNum))
                                return "rowNum: integer expected";
                        if (message.newStaff != null && message.hasOwnProperty("newStaff"))
                            if (typeof message.newStaff !== "boolean")
                                return "newStaff: boolean expected";
                        if (message.existed != null && message.hasOwnProperty("existed"))
                            if (typeof message.existed !== "boolean")
                                return "existed: boolean expected";
                        if (message.failedReason != null && message.hasOwnProperty("failedReason"))
                            if (!$util.isString(message.failedReason))
                                return "failedReason: string expected";
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            if (typeof message.disabled !== "boolean")
                                return "disabled: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStaffResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStaffResult} BatchCreateStaffResult
                     */
                    BatchCreateStaffResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStaffResult)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStaffResult();
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.BatchCreateStaffResult.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.rowNum != null)
                            message.rowNum = object.rowNum | 0;
                        if (object.newStaff != null)
                            message.newStaff = Boolean(object.newStaff);
                        if (object.existed != null)
                            message.existed = Boolean(object.existed);
                        if (object.failedReason != null)
                            message.failedReason = String(object.failedReason);
                        if (object.disabled != null)
                            message.disabled = Boolean(object.disabled);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStaffResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStaffResult} message BatchCreateStaffResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStaffResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staff = null;
                            object.rowNum = 0;
                            object.newStaff = false;
                            object.existed = false;
                            object.failedReason = "";
                            object.disabled = false;
                        }
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.rowNum != null && message.hasOwnProperty("rowNum"))
                            object.rowNum = message.rowNum;
                        if (message.newStaff != null && message.hasOwnProperty("newStaff"))
                            object.newStaff = message.newStaff;
                        if (message.existed != null && message.hasOwnProperty("existed"))
                            object.existed = message.existed;
                        if (message.failedReason != null && message.hasOwnProperty("failedReason"))
                            object.failedReason = message.failedReason;
                        if (message.disabled != null && message.hasOwnProperty("disabled"))
                            object.disabled = message.disabled;
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStaffResult to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStaffResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStaffResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStaffResult;
                })();
    
                v1.ListUnmappedStaffIdRequest = (function() {
    
                    /**
                     * Properties of a ListUnmappedStaffIdRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListUnmappedStaffIdRequest
                     * @property {Array.<number>|null} [storeId] ListUnmappedStaffIdRequest storeId
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] ListUnmappedStaffIdRequest fromDate
                     * @property {boolean|null} [includePosSource] ListUnmappedStaffIdRequest includePosSource
                     * @property {boolean|null} [includeStaffingSource] ListUnmappedStaffIdRequest includeStaffingSource
                     */
    
                    /**
                     * Constructs a new ListUnmappedStaffIdRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListUnmappedStaffIdRequest.
                     * @implements IListUnmappedStaffIdRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest=} [properties] Properties to set
                     */
                    function ListUnmappedStaffIdRequest(properties) {
                        this.storeId = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListUnmappedStaffIdRequest storeId.
                     * @member {Array.<number>} storeId
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @instance
                     */
                    ListUnmappedStaffIdRequest.prototype.storeId = $util.emptyArray;
    
                    /**
                     * ListUnmappedStaffIdRequest fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @instance
                     */
                    ListUnmappedStaffIdRequest.prototype.fromDate = null;
    
                    /**
                     * ListUnmappedStaffIdRequest includePosSource.
                     * @member {boolean} includePosSource
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @instance
                     */
                    ListUnmappedStaffIdRequest.prototype.includePosSource = false;
    
                    /**
                     * ListUnmappedStaffIdRequest includeStaffingSource.
                     * @member {boolean} includeStaffingSource
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @instance
                     */
                    ListUnmappedStaffIdRequest.prototype.includeStaffingSource = false;
    
                    /**
                     * Creates a new ListUnmappedStaffIdRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdRequest} ListUnmappedStaffIdRequest instance
                     */
                    ListUnmappedStaffIdRequest.create = function create(properties) {
                        return new ListUnmappedStaffIdRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListUnmappedStaffIdRequest message. Does not implicitly {@link palexy.streaming.v1.ListUnmappedStaffIdRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest} message ListUnmappedStaffIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListUnmappedStaffIdRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && message.storeId.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeId.length; ++i)
                                writer.int64(message.storeId[i]);
                            writer.ldelim();
                        }
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.includePosSource != null && Object.hasOwnProperty.call(message, "includePosSource"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includePosSource);
                        if (message.includeStaffingSource != null && Object.hasOwnProperty.call(message, "includeStaffingSource"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeStaffingSource);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListUnmappedStaffIdRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListUnmappedStaffIdRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdRequest} message ListUnmappedStaffIdRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListUnmappedStaffIdRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListUnmappedStaffIdRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdRequest} ListUnmappedStaffIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListUnmappedStaffIdRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListUnmappedStaffIdRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeId && message.storeId.length))
                                    message.storeId = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeId.push(reader.int64());
                                } else
                                    message.storeId.push(reader.int64());
                                break;
                            case 2:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.includePosSource = reader.bool();
                                break;
                            case 4:
                                message.includeStaffingSource = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListUnmappedStaffIdRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdRequest} ListUnmappedStaffIdRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListUnmappedStaffIdRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListUnmappedStaffIdRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListUnmappedStaffIdRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (!Array.isArray(message.storeId))
                                return "storeId: array expected";
                            for (var i = 0; i < message.storeId.length; ++i)
                                if (!$util.isInteger(message.storeId[i]) && !(message.storeId[i] && $util.isInteger(message.storeId[i].low) && $util.isInteger(message.storeId[i].high)))
                                    return "storeId: integer|Long[] expected";
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.includePosSource != null && message.hasOwnProperty("includePosSource"))
                            if (typeof message.includePosSource !== "boolean")
                                return "includePosSource: boolean expected";
                        if (message.includeStaffingSource != null && message.hasOwnProperty("includeStaffingSource"))
                            if (typeof message.includeStaffingSource !== "boolean")
                                return "includeStaffingSource: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListUnmappedStaffIdRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdRequest} ListUnmappedStaffIdRequest
                     */
                    ListUnmappedStaffIdRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListUnmappedStaffIdRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListUnmappedStaffIdRequest();
                        if (object.storeId) {
                            if (!Array.isArray(object.storeId))
                                throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdRequest.storeId: array expected");
                            message.storeId = [];
                            for (var i = 0; i < object.storeId.length; ++i)
                                if ($util.Long)
                                    (message.storeId[i] = $util.Long.fromValue(object.storeId[i])).unsigned = false;
                                else if (typeof object.storeId[i] === "string")
                                    message.storeId[i] = parseInt(object.storeId[i], 10);
                                else if (typeof object.storeId[i] === "number")
                                    message.storeId[i] = object.storeId[i];
                                else if (typeof object.storeId[i] === "object")
                                    message.storeId[i] = new $util.LongBits(object.storeId[i].low >>> 0, object.storeId[i].high >>> 0).toNumber();
                        }
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdRequest.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.includePosSource != null)
                            message.includePosSource = Boolean(object.includePosSource);
                        if (object.includeStaffingSource != null)
                            message.includeStaffingSource = Boolean(object.includeStaffingSource);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListUnmappedStaffIdRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @static
                     * @param {palexy.streaming.v1.ListUnmappedStaffIdRequest} message ListUnmappedStaffIdRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListUnmappedStaffIdRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeId = [];
                        if (options.defaults) {
                            object.fromDate = null;
                            object.includePosSource = false;
                            object.includeStaffingSource = false;
                        }
                        if (message.storeId && message.storeId.length) {
                            object.storeId = [];
                            for (var j = 0; j < message.storeId.length; ++j)
                                if (typeof message.storeId[j] === "number")
                                    object.storeId[j] = options.longs === String ? String(message.storeId[j]) : message.storeId[j];
                                else
                                    object.storeId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeId[j]) : options.longs === Number ? new $util.LongBits(message.storeId[j].low >>> 0, message.storeId[j].high >>> 0).toNumber() : message.storeId[j];
                        }
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.includePosSource != null && message.hasOwnProperty("includePosSource"))
                            object.includePosSource = message.includePosSource;
                        if (message.includeStaffingSource != null && message.hasOwnProperty("includeStaffingSource"))
                            object.includeStaffingSource = message.includeStaffingSource;
                        return object;
                    };
    
                    /**
                     * Converts this ListUnmappedStaffIdRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListUnmappedStaffIdRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListUnmappedStaffIdRequest;
                })();
    
                v1.ListUnmappedStaffIdResponse = (function() {
    
                    /**
                     * Properties of a ListUnmappedStaffIdResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListUnmappedStaffIdResponse
                     * @property {Array.<palexy.streaming.v1.IUnmappedStaffId>|null} [posId] ListUnmappedStaffIdResponse posId
                     * @property {Array.<palexy.streaming.v1.IUnmappedStaffId>|null} [staffingId] ListUnmappedStaffIdResponse staffingId
                     */
    
                    /**
                     * Constructs a new ListUnmappedStaffIdResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListUnmappedStaffIdResponse.
                     * @implements IListUnmappedStaffIdResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdResponse=} [properties] Properties to set
                     */
                    function ListUnmappedStaffIdResponse(properties) {
                        this.posId = [];
                        this.staffingId = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListUnmappedStaffIdResponse posId.
                     * @member {Array.<palexy.streaming.v1.IUnmappedStaffId>} posId
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @instance
                     */
                    ListUnmappedStaffIdResponse.prototype.posId = $util.emptyArray;
    
                    /**
                     * ListUnmappedStaffIdResponse staffingId.
                     * @member {Array.<palexy.streaming.v1.IUnmappedStaffId>} staffingId
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @instance
                     */
                    ListUnmappedStaffIdResponse.prototype.staffingId = $util.emptyArray;
    
                    /**
                     * Creates a new ListUnmappedStaffIdResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdResponse} ListUnmappedStaffIdResponse instance
                     */
                    ListUnmappedStaffIdResponse.create = function create(properties) {
                        return new ListUnmappedStaffIdResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListUnmappedStaffIdResponse message. Does not implicitly {@link palexy.streaming.v1.ListUnmappedStaffIdResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdResponse} message ListUnmappedStaffIdResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListUnmappedStaffIdResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.posId != null && message.posId.length)
                            for (var i = 0; i < message.posId.length; ++i)
                                $root.palexy.streaming.v1.UnmappedStaffId.encode(message.posId[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.staffingId != null && message.staffingId.length)
                            for (var i = 0; i < message.staffingId.length; ++i)
                                $root.palexy.streaming.v1.UnmappedStaffId.encode(message.staffingId[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListUnmappedStaffIdResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListUnmappedStaffIdResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {palexy.streaming.v1.IListUnmappedStaffIdResponse} message ListUnmappedStaffIdResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListUnmappedStaffIdResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListUnmappedStaffIdResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdResponse} ListUnmappedStaffIdResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListUnmappedStaffIdResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListUnmappedStaffIdResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.posId && message.posId.length))
                                    message.posId = [];
                                message.posId.push($root.palexy.streaming.v1.UnmappedStaffId.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.staffingId && message.staffingId.length))
                                    message.staffingId = [];
                                message.staffingId.push($root.palexy.streaming.v1.UnmappedStaffId.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListUnmappedStaffIdResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdResponse} ListUnmappedStaffIdResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListUnmappedStaffIdResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListUnmappedStaffIdResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListUnmappedStaffIdResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.posId != null && message.hasOwnProperty("posId")) {
                            if (!Array.isArray(message.posId))
                                return "posId: array expected";
                            for (var i = 0; i < message.posId.length; ++i) {
                                var error = $root.palexy.streaming.v1.UnmappedStaffId.verify(message.posId[i]);
                                if (error)
                                    return "posId." + error;
                            }
                        }
                        if (message.staffingId != null && message.hasOwnProperty("staffingId")) {
                            if (!Array.isArray(message.staffingId))
                                return "staffingId: array expected";
                            for (var i = 0; i < message.staffingId.length; ++i) {
                                var error = $root.palexy.streaming.v1.UnmappedStaffId.verify(message.staffingId[i]);
                                if (error)
                                    return "staffingId." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListUnmappedStaffIdResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListUnmappedStaffIdResponse} ListUnmappedStaffIdResponse
                     */
                    ListUnmappedStaffIdResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListUnmappedStaffIdResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListUnmappedStaffIdResponse();
                        if (object.posId) {
                            if (!Array.isArray(object.posId))
                                throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdResponse.posId: array expected");
                            message.posId = [];
                            for (var i = 0; i < object.posId.length; ++i) {
                                if (typeof object.posId[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdResponse.posId: object expected");
                                message.posId[i] = $root.palexy.streaming.v1.UnmappedStaffId.fromObject(object.posId[i]);
                            }
                        }
                        if (object.staffingId) {
                            if (!Array.isArray(object.staffingId))
                                throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdResponse.staffingId: array expected");
                            message.staffingId = [];
                            for (var i = 0; i < object.staffingId.length; ++i) {
                                if (typeof object.staffingId[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListUnmappedStaffIdResponse.staffingId: object expected");
                                message.staffingId[i] = $root.palexy.streaming.v1.UnmappedStaffId.fromObject(object.staffingId[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListUnmappedStaffIdResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @static
                     * @param {palexy.streaming.v1.ListUnmappedStaffIdResponse} message ListUnmappedStaffIdResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListUnmappedStaffIdResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.posId = [];
                            object.staffingId = [];
                        }
                        if (message.posId && message.posId.length) {
                            object.posId = [];
                            for (var j = 0; j < message.posId.length; ++j)
                                object.posId[j] = $root.palexy.streaming.v1.UnmappedStaffId.toObject(message.posId[j], options);
                        }
                        if (message.staffingId && message.staffingId.length) {
                            object.staffingId = [];
                            for (var j = 0; j < message.staffingId.length; ++j)
                                object.staffingId[j] = $root.palexy.streaming.v1.UnmappedStaffId.toObject(message.staffingId[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListUnmappedStaffIdResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListUnmappedStaffIdResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListUnmappedStaffIdResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListUnmappedStaffIdResponse;
                })();
    
                v1.UnmappedStaffId = (function() {
    
                    /**
                     * Properties of an UnmappedStaffId.
                     * @memberof palexy.streaming.v1
                     * @interface IUnmappedStaffId
                     * @property {string|null} [externalStaffId] UnmappedStaffId externalStaffId
                     * @property {string|null} [latestPresentDate] UnmappedStaffId latestPresentDate
                     */
    
                    /**
                     * Constructs a new UnmappedStaffId.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UnmappedStaffId.
                     * @implements IUnmappedStaffId
                     * @constructor
                     * @param {palexy.streaming.v1.IUnmappedStaffId=} [properties] Properties to set
                     */
                    function UnmappedStaffId(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UnmappedStaffId externalStaffId.
                     * @member {string} externalStaffId
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @instance
                     */
                    UnmappedStaffId.prototype.externalStaffId = "";
    
                    /**
                     * UnmappedStaffId latestPresentDate.
                     * @member {string} latestPresentDate
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @instance
                     */
                    UnmappedStaffId.prototype.latestPresentDate = "";
    
                    /**
                     * Creates a new UnmappedStaffId instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {palexy.streaming.v1.IUnmappedStaffId=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UnmappedStaffId} UnmappedStaffId instance
                     */
                    UnmappedStaffId.create = function create(properties) {
                        return new UnmappedStaffId(properties);
                    };
    
                    /**
                     * Encodes the specified UnmappedStaffId message. Does not implicitly {@link palexy.streaming.v1.UnmappedStaffId.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {palexy.streaming.v1.IUnmappedStaffId} message UnmappedStaffId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UnmappedStaffId.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.externalStaffId != null && Object.hasOwnProperty.call(message, "externalStaffId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.externalStaffId);
                        if (message.latestPresentDate != null && Object.hasOwnProperty.call(message, "latestPresentDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.latestPresentDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UnmappedStaffId message, length delimited. Does not implicitly {@link palexy.streaming.v1.UnmappedStaffId.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {palexy.streaming.v1.IUnmappedStaffId} message UnmappedStaffId message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UnmappedStaffId.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UnmappedStaffId message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UnmappedStaffId} UnmappedStaffId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UnmappedStaffId.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UnmappedStaffId();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.externalStaffId = reader.string();
                                break;
                            case 2:
                                message.latestPresentDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UnmappedStaffId message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UnmappedStaffId} UnmappedStaffId
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UnmappedStaffId.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UnmappedStaffId message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UnmappedStaffId.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.externalStaffId != null && message.hasOwnProperty("externalStaffId"))
                            if (!$util.isString(message.externalStaffId))
                                return "externalStaffId: string expected";
                        if (message.latestPresentDate != null && message.hasOwnProperty("latestPresentDate"))
                            if (!$util.isString(message.latestPresentDate))
                                return "latestPresentDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UnmappedStaffId message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UnmappedStaffId} UnmappedStaffId
                     */
                    UnmappedStaffId.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UnmappedStaffId)
                            return object;
                        var message = new $root.palexy.streaming.v1.UnmappedStaffId();
                        if (object.externalStaffId != null)
                            message.externalStaffId = String(object.externalStaffId);
                        if (object.latestPresentDate != null)
                            message.latestPresentDate = String(object.latestPresentDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UnmappedStaffId message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @static
                     * @param {palexy.streaming.v1.UnmappedStaffId} message UnmappedStaffId
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UnmappedStaffId.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.externalStaffId = "";
                            object.latestPresentDate = "";
                        }
                        if (message.externalStaffId != null && message.hasOwnProperty("externalStaffId"))
                            object.externalStaffId = message.externalStaffId;
                        if (message.latestPresentDate != null && message.hasOwnProperty("latestPresentDate"))
                            object.latestPresentDate = message.latestPresentDate;
                        return object;
                    };
    
                    /**
                     * Converts this UnmappedStaffId to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UnmappedStaffId
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UnmappedStaffId.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UnmappedStaffId;
                })();
    
                v1.ListStaffSalesHistoryRequest = (function() {
    
                    /**
                     * Properties of a ListStaffSalesHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffSalesHistoryRequest
                     * @property {number|null} [staffId] ListStaffSalesHistoryRequest staffId
                     * @property {palexy.streaming.v1.IDateFilter|null} [fromDate] ListStaffSalesHistoryRequest fromDate
                     * @property {palexy.streaming.v1.IDateFilter|null} [toDate] ListStaffSalesHistoryRequest toDate
                     * @property {Array.<number>|null} [storeId] ListStaffSalesHistoryRequest storeId
                     * @property {number|null} [pageSize] ListStaffSalesHistoryRequest pageSize
                     * @property {string|null} [pageToken] ListStaffSalesHistoryRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListStaffSalesHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffSalesHistoryRequest.
                     * @implements IListStaffSalesHistoryRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest=} [properties] Properties to set
                     */
                    function ListStaffSalesHistoryRequest(properties) {
                        this.storeId = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffSalesHistoryRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffSalesHistoryRequest fromDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} fromDate
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.fromDate = null;
    
                    /**
                     * ListStaffSalesHistoryRequest toDate.
                     * @member {palexy.streaming.v1.IDateFilter|null|undefined} toDate
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.toDate = null;
    
                    /**
                     * ListStaffSalesHistoryRequest storeId.
                     * @member {Array.<number>} storeId
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.storeId = $util.emptyArray;
    
                    /**
                     * ListStaffSalesHistoryRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffSalesHistoryRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     */
                    ListStaffSalesHistoryRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListStaffSalesHistoryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryRequest} ListStaffSalesHistoryRequest instance
                     */
                    ListStaffSalesHistoryRequest.create = function create(properties) {
                        return new ListStaffSalesHistoryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffSalesHistoryRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffSalesHistoryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest} message ListStaffSalesHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffSalesHistoryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.fromDate != null && Object.hasOwnProperty.call(message, "fromDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.fromDate, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.toDate != null && Object.hasOwnProperty.call(message, "toDate"))
                            $root.palexy.streaming.v1.DateFilter.encode(message.toDate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.storeId != null && message.storeId.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.storeId.length; ++i)
                                writer.int64(message.storeId[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffSalesHistoryRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffSalesHistoryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryRequest} message ListStaffSalesHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffSalesHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffSalesHistoryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryRequest} ListStaffSalesHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffSalesHistoryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffSalesHistoryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.fromDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.toDate = $root.palexy.streaming.v1.DateFilter.decode(reader, reader.uint32());
                                break;
                            case 6:
                                if (!(message.storeId && message.storeId.length))
                                    message.storeId = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeId.push(reader.int64());
                                } else
                                    message.storeId.push(reader.int64());
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffSalesHistoryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryRequest} ListStaffSalesHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffSalesHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffSalesHistoryRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffSalesHistoryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.fromDate != null && message.hasOwnProperty("fromDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.fromDate);
                            if (error)
                                return "fromDate." + error;
                        }
                        if (message.toDate != null && message.hasOwnProperty("toDate")) {
                            var error = $root.palexy.streaming.v1.DateFilter.verify(message.toDate);
                            if (error)
                                return "toDate." + error;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (!Array.isArray(message.storeId))
                                return "storeId: array expected";
                            for (var i = 0; i < message.storeId.length; ++i)
                                if (!$util.isInteger(message.storeId[i]) && !(message.storeId[i] && $util.isInteger(message.storeId[i].low) && $util.isInteger(message.storeId[i].high)))
                                    return "storeId: integer|Long[] expected";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffSalesHistoryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryRequest} ListStaffSalesHistoryRequest
                     */
                    ListStaffSalesHistoryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffSalesHistoryRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffSalesHistoryRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.fromDate != null) {
                            if (typeof object.fromDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStaffSalesHistoryRequest.fromDate: object expected");
                            message.fromDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.fromDate);
                        }
                        if (object.toDate != null) {
                            if (typeof object.toDate !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStaffSalesHistoryRequest.toDate: object expected");
                            message.toDate = $root.palexy.streaming.v1.DateFilter.fromObject(object.toDate);
                        }
                        if (object.storeId) {
                            if (!Array.isArray(object.storeId))
                                throw TypeError(".palexy.streaming.v1.ListStaffSalesHistoryRequest.storeId: array expected");
                            message.storeId = [];
                            for (var i = 0; i < object.storeId.length; ++i)
                                if ($util.Long)
                                    (message.storeId[i] = $util.Long.fromValue(object.storeId[i])).unsigned = false;
                                else if (typeof object.storeId[i] === "string")
                                    message.storeId[i] = parseInt(object.storeId[i], 10);
                                else if (typeof object.storeId[i] === "number")
                                    message.storeId[i] = object.storeId[i];
                                else if (typeof object.storeId[i] === "object")
                                    message.storeId[i] = new $util.LongBits(object.storeId[i].low >>> 0, object.storeId[i].high >>> 0).toNumber();
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffSalesHistoryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffSalesHistoryRequest} message ListStaffSalesHistoryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffSalesHistoryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeId = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.fromDate = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.toDate = null;
                        }
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.fromDate != null && message.hasOwnProperty("fromDate"))
                            object.fromDate = $root.palexy.streaming.v1.DateFilter.toObject(message.fromDate, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.toDate != null && message.hasOwnProperty("toDate"))
                            object.toDate = $root.palexy.streaming.v1.DateFilter.toObject(message.toDate, options);
                        if (message.storeId && message.storeId.length) {
                            object.storeId = [];
                            for (var j = 0; j < message.storeId.length; ++j)
                                if (typeof message.storeId[j] === "number")
                                    object.storeId[j] = options.longs === String ? String(message.storeId[j]) : message.storeId[j];
                                else
                                    object.storeId[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeId[j]) : options.longs === Number ? new $util.LongBits(message.storeId[j].low >>> 0, message.storeId[j].high >>> 0).toNumber() : message.storeId[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffSalesHistoryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffSalesHistoryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffSalesHistoryRequest;
                })();
    
                v1.ListStaffSalesHistoryResponse = (function() {
    
                    /**
                     * Properties of a ListStaffSalesHistoryResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffSalesHistoryResponse
                     * @property {Array.<palexy.streaming.v1.IPosTransaction>|null} [transactionList] ListStaffSalesHistoryResponse transactionList
                     * @property {number|null} [totalElements] ListStaffSalesHistoryResponse totalElements
                     * @property {string|null} [nextPageToken] ListStaffSalesHistoryResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListStaffSalesHistoryResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffSalesHistoryResponse.
                     * @implements IListStaffSalesHistoryResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryResponse=} [properties] Properties to set
                     */
                    function ListStaffSalesHistoryResponse(properties) {
                        this.transactionList = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffSalesHistoryResponse transactionList.
                     * @member {Array.<palexy.streaming.v1.IPosTransaction>} transactionList
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @instance
                     */
                    ListStaffSalesHistoryResponse.prototype.transactionList = $util.emptyArray;
    
                    /**
                     * ListStaffSalesHistoryResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @instance
                     */
                    ListStaffSalesHistoryResponse.prototype.totalElements = 0;
    
                    /**
                     * ListStaffSalesHistoryResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @instance
                     */
                    ListStaffSalesHistoryResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListStaffSalesHistoryResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryResponse} ListStaffSalesHistoryResponse instance
                     */
                    ListStaffSalesHistoryResponse.create = function create(properties) {
                        return new ListStaffSalesHistoryResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffSalesHistoryResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffSalesHistoryResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryResponse} message ListStaffSalesHistoryResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffSalesHistoryResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.transactionList != null && message.transactionList.length)
                            for (var i = 0; i < message.transactionList.length; ++i)
                                $root.palexy.streaming.v1.PosTransaction.encode(message.transactionList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffSalesHistoryResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffSalesHistoryResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffSalesHistoryResponse} message ListStaffSalesHistoryResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffSalesHistoryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffSalesHistoryResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryResponse} ListStaffSalesHistoryResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffSalesHistoryResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffSalesHistoryResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.transactionList && message.transactionList.length))
                                    message.transactionList = [];
                                message.transactionList.push($root.palexy.streaming.v1.PosTransaction.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffSalesHistoryResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryResponse} ListStaffSalesHistoryResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffSalesHistoryResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffSalesHistoryResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffSalesHistoryResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.transactionList != null && message.hasOwnProperty("transactionList")) {
                            if (!Array.isArray(message.transactionList))
                                return "transactionList: array expected";
                            for (var i = 0; i < message.transactionList.length; ++i) {
                                var error = $root.palexy.streaming.v1.PosTransaction.verify(message.transactionList[i]);
                                if (error)
                                    return "transactionList." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffSalesHistoryResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffSalesHistoryResponse} ListStaffSalesHistoryResponse
                     */
                    ListStaffSalesHistoryResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffSalesHistoryResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffSalesHistoryResponse();
                        if (object.transactionList) {
                            if (!Array.isArray(object.transactionList))
                                throw TypeError(".palexy.streaming.v1.ListStaffSalesHistoryResponse.transactionList: array expected");
                            message.transactionList = [];
                            for (var i = 0; i < object.transactionList.length; ++i) {
                                if (typeof object.transactionList[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffSalesHistoryResponse.transactionList: object expected");
                                message.transactionList[i] = $root.palexy.streaming.v1.PosTransaction.fromObject(object.transactionList[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffSalesHistoryResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffSalesHistoryResponse} message ListStaffSalesHistoryResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffSalesHistoryResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.transactionList = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.transactionList && message.transactionList.length) {
                            object.transactionList = [];
                            for (var j = 0; j < message.transactionList.length; ++j)
                                object.transactionList[j] = $root.palexy.streaming.v1.PosTransaction.toObject(message.transactionList[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffSalesHistoryResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffSalesHistoryResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffSalesHistoryResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffSalesHistoryResponse;
                })();
    
                v1.AssignStaffToStoreRequest = (function() {
    
                    /**
                     * Properties of an AssignStaffToStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IAssignStaffToStoreRequest
                     * @property {number|null} [storeId] AssignStaffToStoreRequest storeId
                     * @property {number|null} [staffId] AssignStaffToStoreRequest staffId
                     * @property {string|null} [auditUsername] AssignStaffToStoreRequest auditUsername
                     * @property {palexy.streaming.v1.StaffAssignedStore.StaffType|null} [staffType] AssignStaffToStoreRequest staffType
                     */
    
                    /**
                     * Constructs a new AssignStaffToStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AssignStaffToStoreRequest.
                     * @implements IAssignStaffToStoreRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest=} [properties] Properties to set
                     */
                    function AssignStaffToStoreRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AssignStaffToStoreRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @instance
                     */
                    AssignStaffToStoreRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AssignStaffToStoreRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @instance
                     */
                    AssignStaffToStoreRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AssignStaffToStoreRequest auditUsername.
                     * @member {string} auditUsername
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @instance
                     */
                    AssignStaffToStoreRequest.prototype.auditUsername = "";
    
                    /**
                     * AssignStaffToStoreRequest staffType.
                     * @member {palexy.streaming.v1.StaffAssignedStore.StaffType} staffType
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @instance
                     */
                    AssignStaffToStoreRequest.prototype.staffType = 0;
    
                    /**
                     * Creates a new AssignStaffToStoreRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AssignStaffToStoreRequest} AssignStaffToStoreRequest instance
                     */
                    AssignStaffToStoreRequest.create = function create(properties) {
                        return new AssignStaffToStoreRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AssignStaffToStoreRequest message. Does not implicitly {@link palexy.streaming.v1.AssignStaffToStoreRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest} message AssignStaffToStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AssignStaffToStoreRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                        if (message.auditUsername != null && Object.hasOwnProperty.call(message, "auditUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.auditUsername);
                        if (message.staffType != null && Object.hasOwnProperty.call(message, "staffType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.staffType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AssignStaffToStoreRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.AssignStaffToStoreRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreRequest} message AssignStaffToStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AssignStaffToStoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AssignStaffToStoreRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AssignStaffToStoreRequest} AssignStaffToStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AssignStaffToStoreRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AssignStaffToStoreRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.staffId = reader.int64();
                                break;
                            case 3:
                                message.auditUsername = reader.string();
                                break;
                            case 4:
                                message.staffType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AssignStaffToStoreRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AssignStaffToStoreRequest} AssignStaffToStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AssignStaffToStoreRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AssignStaffToStoreRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AssignStaffToStoreRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            if (!$util.isString(message.auditUsername))
                                return "auditUsername: string expected";
                        if (message.staffType != null && message.hasOwnProperty("staffType"))
                            switch (message.staffType) {
                            default:
                                return "staffType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates an AssignStaffToStoreRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AssignStaffToStoreRequest} AssignStaffToStoreRequest
                     */
                    AssignStaffToStoreRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AssignStaffToStoreRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.AssignStaffToStoreRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.auditUsername != null)
                            message.auditUsername = String(object.auditUsername);
                        switch (object.staffType) {
                        case "UNKNOWN_STAFF_TYPE":
                        case 0:
                            message.staffType = 0;
                            break;
                        case "PERMANENT":
                        case 1:
                            message.staffType = 1;
                            break;
                        case "BORROWED":
                        case 2:
                            message.staffType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AssignStaffToStoreRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.AssignStaffToStoreRequest} message AssignStaffToStoreRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AssignStaffToStoreRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.auditUsername = "";
                            object.staffType = options.enums === String ? "UNKNOWN_STAFF_TYPE" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            object.auditUsername = message.auditUsername;
                        if (message.staffType != null && message.hasOwnProperty("staffType"))
                            object.staffType = options.enums === String ? $root.palexy.streaming.v1.StaffAssignedStore.StaffType[message.staffType] : message.staffType;
                        return object;
                    };
    
                    /**
                     * Converts this AssignStaffToStoreRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AssignStaffToStoreRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AssignStaffToStoreRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AssignStaffToStoreRequest;
                })();
    
                v1.AssignStaffToStoreResponse = (function() {
    
                    /**
                     * Properties of an AssignStaffToStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IAssignStaffToStoreResponse
                     */
    
                    /**
                     * Constructs a new AssignStaffToStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AssignStaffToStoreResponse.
                     * @implements IAssignStaffToStoreResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IAssignStaffToStoreResponse=} [properties] Properties to set
                     */
                    function AssignStaffToStoreResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new AssignStaffToStoreResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AssignStaffToStoreResponse} AssignStaffToStoreResponse instance
                     */
                    AssignStaffToStoreResponse.create = function create(properties) {
                        return new AssignStaffToStoreResponse(properties);
                    };
    
                    /**
                     * Encodes the specified AssignStaffToStoreResponse message. Does not implicitly {@link palexy.streaming.v1.AssignStaffToStoreResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreResponse} message AssignStaffToStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AssignStaffToStoreResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AssignStaffToStoreResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.AssignStaffToStoreResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IAssignStaffToStoreResponse} message AssignStaffToStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AssignStaffToStoreResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AssignStaffToStoreResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AssignStaffToStoreResponse} AssignStaffToStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AssignStaffToStoreResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AssignStaffToStoreResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AssignStaffToStoreResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AssignStaffToStoreResponse} AssignStaffToStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AssignStaffToStoreResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AssignStaffToStoreResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AssignStaffToStoreResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an AssignStaffToStoreResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AssignStaffToStoreResponse} AssignStaffToStoreResponse
                     */
                    AssignStaffToStoreResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AssignStaffToStoreResponse)
                            return object;
                        return new $root.palexy.streaming.v1.AssignStaffToStoreResponse();
                    };
    
                    /**
                     * Creates a plain object from an AssignStaffToStoreResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.AssignStaffToStoreResponse} message AssignStaffToStoreResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AssignStaffToStoreResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this AssignStaffToStoreResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AssignStaffToStoreResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AssignStaffToStoreResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AssignStaffToStoreResponse;
                })();
    
                v1.RemoveStaffFromStoreRequest = (function() {
    
                    /**
                     * Properties of a RemoveStaffFromStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IRemoveStaffFromStoreRequest
                     * @property {number|null} [storeId] RemoveStaffFromStoreRequest storeId
                     * @property {number|null} [staffId] RemoveStaffFromStoreRequest staffId
                     * @property {string|null} [auditUsername] RemoveStaffFromStoreRequest auditUsername
                     */
    
                    /**
                     * Constructs a new RemoveStaffFromStoreRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RemoveStaffFromStoreRequest.
                     * @implements IRemoveStaffFromStoreRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest=} [properties] Properties to set
                     */
                    function RemoveStaffFromStoreRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RemoveStaffFromStoreRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @instance
                     */
                    RemoveStaffFromStoreRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RemoveStaffFromStoreRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @instance
                     */
                    RemoveStaffFromStoreRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RemoveStaffFromStoreRequest auditUsername.
                     * @member {string} auditUsername
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @instance
                     */
                    RemoveStaffFromStoreRequest.prototype.auditUsername = "";
    
                    /**
                     * Creates a new RemoveStaffFromStoreRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreRequest} RemoveStaffFromStoreRequest instance
                     */
                    RemoveStaffFromStoreRequest.create = function create(properties) {
                        return new RemoveStaffFromStoreRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RemoveStaffFromStoreRequest message. Does not implicitly {@link palexy.streaming.v1.RemoveStaffFromStoreRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest} message RemoveStaffFromStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveStaffFromStoreRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                        if (message.auditUsername != null && Object.hasOwnProperty.call(message, "auditUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.auditUsername);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoveStaffFromStoreRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.RemoveStaffFromStoreRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreRequest} message RemoveStaffFromStoreRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveStaffFromStoreRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoveStaffFromStoreRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreRequest} RemoveStaffFromStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveStaffFromStoreRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RemoveStaffFromStoreRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.staffId = reader.int64();
                                break;
                            case 3:
                                message.auditUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoveStaffFromStoreRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreRequest} RemoveStaffFromStoreRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveStaffFromStoreRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoveStaffFromStoreRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoveStaffFromStoreRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            if (!$util.isString(message.auditUsername))
                                return "auditUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RemoveStaffFromStoreRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreRequest} RemoveStaffFromStoreRequest
                     */
                    RemoveStaffFromStoreRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RemoveStaffFromStoreRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.RemoveStaffFromStoreRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.auditUsername != null)
                            message.auditUsername = String(object.auditUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RemoveStaffFromStoreRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @static
                     * @param {palexy.streaming.v1.RemoveStaffFromStoreRequest} message RemoveStaffFromStoreRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoveStaffFromStoreRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.auditUsername = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.auditUsername != null && message.hasOwnProperty("auditUsername"))
                            object.auditUsername = message.auditUsername;
                        return object;
                    };
    
                    /**
                     * Converts this RemoveStaffFromStoreRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoveStaffFromStoreRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoveStaffFromStoreRequest;
                })();
    
                v1.RemoveStaffFromStoreResponse = (function() {
    
                    /**
                     * Properties of a RemoveStaffFromStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IRemoveStaffFromStoreResponse
                     */
    
                    /**
                     * Constructs a new RemoveStaffFromStoreResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RemoveStaffFromStoreResponse.
                     * @implements IRemoveStaffFromStoreResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreResponse=} [properties] Properties to set
                     */
                    function RemoveStaffFromStoreResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new RemoveStaffFromStoreResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreResponse} RemoveStaffFromStoreResponse instance
                     */
                    RemoveStaffFromStoreResponse.create = function create(properties) {
                        return new RemoveStaffFromStoreResponse(properties);
                    };
    
                    /**
                     * Encodes the specified RemoveStaffFromStoreResponse message. Does not implicitly {@link palexy.streaming.v1.RemoveStaffFromStoreResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreResponse} message RemoveStaffFromStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveStaffFromStoreResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoveStaffFromStoreResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.RemoveStaffFromStoreResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.IRemoveStaffFromStoreResponse} message RemoveStaffFromStoreResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveStaffFromStoreResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoveStaffFromStoreResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreResponse} RemoveStaffFromStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveStaffFromStoreResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RemoveStaffFromStoreResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoveStaffFromStoreResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreResponse} RemoveStaffFromStoreResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveStaffFromStoreResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoveStaffFromStoreResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoveStaffFromStoreResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a RemoveStaffFromStoreResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RemoveStaffFromStoreResponse} RemoveStaffFromStoreResponse
                     */
                    RemoveStaffFromStoreResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RemoveStaffFromStoreResponse)
                            return object;
                        return new $root.palexy.streaming.v1.RemoveStaffFromStoreResponse();
                    };
    
                    /**
                     * Creates a plain object from a RemoveStaffFromStoreResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @static
                     * @param {palexy.streaming.v1.RemoveStaffFromStoreResponse} message RemoveStaffFromStoreResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoveStaffFromStoreResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this RemoveStaffFromStoreResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RemoveStaffFromStoreResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoveStaffFromStoreResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoveStaffFromStoreResponse;
                })();
    
                v1.SendStaffInvitationRequest = (function() {
    
                    /**
                     * Properties of a SendStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISendStaffInvitationRequest
                     * @property {number|null} [staffId] SendStaffInvitationRequest staffId
                     */
    
                    /**
                     * Constructs a new SendStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SendStaffInvitationRequest.
                     * @implements ISendStaffInvitationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest=} [properties] Properties to set
                     */
                    function SendStaffInvitationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SendStaffInvitationRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @instance
                     */
                    SendStaffInvitationRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SendStaffInvitationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SendStaffInvitationRequest} SendStaffInvitationRequest instance
                     */
                    SendStaffInvitationRequest.create = function create(properties) {
                        return new SendStaffInvitationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SendStaffInvitationRequest message. Does not implicitly {@link palexy.streaming.v1.SendStaffInvitationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest} message SendStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendStaffInvitationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SendStaffInvitationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SendStaffInvitationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.ISendStaffInvitationRequest} message SendStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SendStaffInvitationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SendStaffInvitationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SendStaffInvitationRequest} SendStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendStaffInvitationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SendStaffInvitationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SendStaffInvitationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SendStaffInvitationRequest} SendStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SendStaffInvitationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SendStaffInvitationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SendStaffInvitationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SendStaffInvitationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SendStaffInvitationRequest} SendStaffInvitationRequest
                     */
                    SendStaffInvitationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SendStaffInvitationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SendStaffInvitationRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SendStaffInvitationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.SendStaffInvitationRequest} message SendStaffInvitationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SendStaffInvitationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        return object;
                    };
    
                    /**
                     * Converts this SendStaffInvitationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SendStaffInvitationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SendStaffInvitationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SendStaffInvitationRequest;
                })();
    
                v1.BatchInviteStaffRequest = (function() {
    
                    /**
                     * Properties of a BatchInviteStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchInviteStaffRequest
                     * @property {Array.<number>|null} [staffIds] BatchInviteStaffRequest staffIds
                     * @property {number|null} [companyId] BatchInviteStaffRequest companyId
                     * @property {boolean|null} [preview] BatchInviteStaffRequest preview
                     */
    
                    /**
                     * Constructs a new BatchInviteStaffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchInviteStaffRequest.
                     * @implements IBatchInviteStaffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest=} [properties] Properties to set
                     */
                    function BatchInviteStaffRequest(properties) {
                        this.staffIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchInviteStaffRequest staffIds.
                     * @member {Array.<number>} staffIds
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @instance
                     */
                    BatchInviteStaffRequest.prototype.staffIds = $util.emptyArray;
    
                    /**
                     * BatchInviteStaffRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @instance
                     */
                    BatchInviteStaffRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchInviteStaffRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @instance
                     */
                    BatchInviteStaffRequest.prototype.preview = false;
    
                    /**
                     * Creates a new BatchInviteStaffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchInviteStaffRequest} BatchInviteStaffRequest instance
                     */
                    BatchInviteStaffRequest.create = function create(properties) {
                        return new BatchInviteStaffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchInviteStaffRequest message. Does not implicitly {@link palexy.streaming.v1.BatchInviteStaffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest} message BatchInviteStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchInviteStaffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffIds != null && message.staffIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.staffIds.length; ++i)
                                writer.int64(message.staffIds[i]);
                            writer.ldelim();
                        }
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.preview);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchInviteStaffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchInviteStaffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffRequest} message BatchInviteStaffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchInviteStaffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchInviteStaffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchInviteStaffRequest} BatchInviteStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchInviteStaffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchInviteStaffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffIds && message.staffIds.length))
                                    message.staffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffIds.push(reader.int64());
                                } else
                                    message.staffIds.push(reader.int64());
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.preview = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchInviteStaffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchInviteStaffRequest} BatchInviteStaffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchInviteStaffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchInviteStaffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchInviteStaffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (!Array.isArray(message.staffIds))
                                return "staffIds: array expected";
                            for (var i = 0; i < message.staffIds.length; ++i)
                                if (!$util.isInteger(message.staffIds[i]) && !(message.staffIds[i] && $util.isInteger(message.staffIds[i].low) && $util.isInteger(message.staffIds[i].high)))
                                    return "staffIds: integer|Long[] expected";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchInviteStaffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchInviteStaffRequest} BatchInviteStaffRequest
                     */
                    BatchInviteStaffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchInviteStaffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchInviteStaffRequest();
                        if (object.staffIds) {
                            if (!Array.isArray(object.staffIds))
                                throw TypeError(".palexy.streaming.v1.BatchInviteStaffRequest.staffIds: array expected");
                            message.staffIds = [];
                            for (var i = 0; i < object.staffIds.length; ++i)
                                if ($util.Long)
                                    (message.staffIds[i] = $util.Long.fromValue(object.staffIds[i])).unsigned = false;
                                else if (typeof object.staffIds[i] === "string")
                                    message.staffIds[i] = parseInt(object.staffIds[i], 10);
                                else if (typeof object.staffIds[i] === "number")
                                    message.staffIds[i] = object.staffIds[i];
                                else if (typeof object.staffIds[i] === "object")
                                    message.staffIds[i] = new $util.LongBits(object.staffIds[i].low >>> 0, object.staffIds[i].high >>> 0).toNumber();
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchInviteStaffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchInviteStaffRequest} message BatchInviteStaffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchInviteStaffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.preview = false;
                        }
                        if (message.staffIds && message.staffIds.length) {
                            object.staffIds = [];
                            for (var j = 0; j < message.staffIds.length; ++j)
                                if (typeof message.staffIds[j] === "number")
                                    object.staffIds[j] = options.longs === String ? String(message.staffIds[j]) : message.staffIds[j];
                                else
                                    object.staffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffIds[j]) : options.longs === Number ? new $util.LongBits(message.staffIds[j].low >>> 0, message.staffIds[j].high >>> 0).toNumber() : message.staffIds[j];
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        return object;
                    };
    
                    /**
                     * Converts this BatchInviteStaffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchInviteStaffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchInviteStaffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchInviteStaffRequest;
                })();
    
                v1.BatchInviteStaffResponse = (function() {
    
                    /**
                     * Properties of a BatchInviteStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchInviteStaffResponse
                     * @property {Array.<palexy.streaming.v1.IBatchCreateStaffResult>|null} [results] BatchInviteStaffResponse results
                     */
    
                    /**
                     * Constructs a new BatchInviteStaffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchInviteStaffResponse.
                     * @implements IBatchInviteStaffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchInviteStaffResponse=} [properties] Properties to set
                     */
                    function BatchInviteStaffResponse(properties) {
                        this.results = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchInviteStaffResponse results.
                     * @member {Array.<palexy.streaming.v1.IBatchCreateStaffResult>} results
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @instance
                     */
                    BatchInviteStaffResponse.prototype.results = $util.emptyArray;
    
                    /**
                     * Creates a new BatchInviteStaffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchInviteStaffResponse} BatchInviteStaffResponse instance
                     */
                    BatchInviteStaffResponse.create = function create(properties) {
                        return new BatchInviteStaffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchInviteStaffResponse message. Does not implicitly {@link palexy.streaming.v1.BatchInviteStaffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffResponse} message BatchInviteStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchInviteStaffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.results != null && message.results.length)
                            for (var i = 0; i < message.results.length; ++i)
                                $root.palexy.streaming.v1.BatchCreateStaffResult.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchInviteStaffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchInviteStaffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchInviteStaffResponse} message BatchInviteStaffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchInviteStaffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchInviteStaffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchInviteStaffResponse} BatchInviteStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchInviteStaffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchInviteStaffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.results && message.results.length))
                                    message.results = [];
                                message.results.push($root.palexy.streaming.v1.BatchCreateStaffResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchInviteStaffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchInviteStaffResponse} BatchInviteStaffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchInviteStaffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchInviteStaffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchInviteStaffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.results != null && message.hasOwnProperty("results")) {
                            if (!Array.isArray(message.results))
                                return "results: array expected";
                            for (var i = 0; i < message.results.length; ++i) {
                                var error = $root.palexy.streaming.v1.BatchCreateStaffResult.verify(message.results[i]);
                                if (error)
                                    return "results." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchInviteStaffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchInviteStaffResponse} BatchInviteStaffResponse
                     */
                    BatchInviteStaffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchInviteStaffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchInviteStaffResponse();
                        if (object.results) {
                            if (!Array.isArray(object.results))
                                throw TypeError(".palexy.streaming.v1.BatchInviteStaffResponse.results: array expected");
                            message.results = [];
                            for (var i = 0; i < object.results.length; ++i) {
                                if (typeof object.results[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchInviteStaffResponse.results: object expected");
                                message.results[i] = $root.palexy.streaming.v1.BatchCreateStaffResult.fromObject(object.results[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchInviteStaffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchInviteStaffResponse} message BatchInviteStaffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchInviteStaffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.results = [];
                        if (message.results && message.results.length) {
                            object.results = [];
                            for (var j = 0; j < message.results.length; ++j)
                                object.results[j] = $root.palexy.streaming.v1.BatchCreateStaffResult.toObject(message.results[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchInviteStaffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchInviteStaffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchInviteStaffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchInviteStaffResponse;
                })();
    
                v1.ExpireStaffInvitationRequest = (function() {
    
                    /**
                     * Properties of an ExpireStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExpireStaffInvitationRequest
                     * @property {number|null} [staffId] ExpireStaffInvitationRequest staffId
                     * @property {string|null} [staffEmail] ExpireStaffInvitationRequest staffEmail
                     */
    
                    /**
                     * Constructs a new ExpireStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExpireStaffInvitationRequest.
                     * @implements IExpireStaffInvitationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest=} [properties] Properties to set
                     */
                    function ExpireStaffInvitationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExpireStaffInvitationRequest staffId.
                     * @member {number|null|undefined} staffId
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @instance
                     */
                    ExpireStaffInvitationRequest.prototype.staffId = null;
    
                    /**
                     * ExpireStaffInvitationRequest staffEmail.
                     * @member {string|null|undefined} staffEmail
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @instance
                     */
                    ExpireStaffInvitationRequest.prototype.staffEmail = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ExpireStaffInvitationRequest identifyInfo.
                     * @member {"staffId"|"staffEmail"|undefined} identifyInfo
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @instance
                     */
                    Object.defineProperty(ExpireStaffInvitationRequest.prototype, "identifyInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["staffId", "staffEmail"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ExpireStaffInvitationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExpireStaffInvitationRequest} ExpireStaffInvitationRequest instance
                     */
                    ExpireStaffInvitationRequest.create = function create(properties) {
                        return new ExpireStaffInvitationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExpireStaffInvitationRequest message. Does not implicitly {@link palexy.streaming.v1.ExpireStaffInvitationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest} message ExpireStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireStaffInvitationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.staffEmail != null && Object.hasOwnProperty.call(message, "staffEmail"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.staffEmail);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExpireStaffInvitationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExpireStaffInvitationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireStaffInvitationRequest} message ExpireStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireStaffInvitationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExpireStaffInvitationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExpireStaffInvitationRequest} ExpireStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireStaffInvitationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExpireStaffInvitationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.staffEmail = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExpireStaffInvitationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExpireStaffInvitationRequest} ExpireStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireStaffInvitationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExpireStaffInvitationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExpireStaffInvitationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.staffId != null && message.hasOwnProperty("staffId")) {
                            properties.identifyInfo = 1;
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        }
                        if (message.staffEmail != null && message.hasOwnProperty("staffEmail")) {
                            if (properties.identifyInfo === 1)
                                return "identifyInfo: multiple values";
                            properties.identifyInfo = 1;
                            if (!$util.isString(message.staffEmail))
                                return "staffEmail: string expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExpireStaffInvitationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExpireStaffInvitationRequest} ExpireStaffInvitationRequest
                     */
                    ExpireStaffInvitationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExpireStaffInvitationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExpireStaffInvitationRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.staffEmail != null)
                            message.staffEmail = String(object.staffEmail);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExpireStaffInvitationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.ExpireStaffInvitationRequest} message ExpireStaffInvitationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExpireStaffInvitationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.staffId != null && message.hasOwnProperty("staffId")) {
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                            if (options.oneofs)
                                object.identifyInfo = "staffId";
                        }
                        if (message.staffEmail != null && message.hasOwnProperty("staffEmail")) {
                            object.staffEmail = message.staffEmail;
                            if (options.oneofs)
                                object.identifyInfo = "staffEmail";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExpireStaffInvitationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExpireStaffInvitationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExpireStaffInvitationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExpireStaffInvitationRequest;
                })();
    
                v1.InvalidateLatestStaffInvitationHistoryRequest = (function() {
    
                    /**
                     * Properties of an InvalidateLatestStaffInvitationHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IInvalidateLatestStaffInvitationHistoryRequest
                     * @property {number|null} [staffId] InvalidateLatestStaffInvitationHistoryRequest staffId
                     * @property {string|null} [staffEmail] InvalidateLatestStaffInvitationHistoryRequest staffEmail
                     */
    
                    /**
                     * Constructs a new InvalidateLatestStaffInvitationHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an InvalidateLatestStaffInvitationHistoryRequest.
                     * @implements IInvalidateLatestStaffInvitationHistoryRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest=} [properties] Properties to set
                     */
                    function InvalidateLatestStaffInvitationHistoryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * InvalidateLatestStaffInvitationHistoryRequest staffId.
                     * @member {number|null|undefined} staffId
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @instance
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.prototype.staffId = null;
    
                    /**
                     * InvalidateLatestStaffInvitationHistoryRequest staffEmail.
                     * @member {string|null|undefined} staffEmail
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @instance
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.prototype.staffEmail = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * InvalidateLatestStaffInvitationHistoryRequest identifyInfo.
                     * @member {"staffId"|"staffEmail"|undefined} identifyInfo
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @instance
                     */
                    Object.defineProperty(InvalidateLatestStaffInvitationHistoryRequest.prototype, "identifyInfo", {
                        get: $util.oneOfGetter($oneOfFields = ["staffId", "staffEmail"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new InvalidateLatestStaffInvitationHistoryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest} InvalidateLatestStaffInvitationHistoryRequest instance
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.create = function create(properties) {
                        return new InvalidateLatestStaffInvitationHistoryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified InvalidateLatestStaffInvitationHistoryRequest message. Does not implicitly {@link palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest} message InvalidateLatestStaffInvitationHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.staffEmail != null && Object.hasOwnProperty.call(message, "staffEmail"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.staffEmail);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified InvalidateLatestStaffInvitationHistoryRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IInvalidateLatestStaffInvitationHistoryRequest} message InvalidateLatestStaffInvitationHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an InvalidateLatestStaffInvitationHistoryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest} InvalidateLatestStaffInvitationHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.staffEmail = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an InvalidateLatestStaffInvitationHistoryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest} InvalidateLatestStaffInvitationHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an InvalidateLatestStaffInvitationHistoryRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.staffId != null && message.hasOwnProperty("staffId")) {
                            properties.identifyInfo = 1;
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        }
                        if (message.staffEmail != null && message.hasOwnProperty("staffEmail")) {
                            if (properties.identifyInfo === 1)
                                return "identifyInfo: multiple values";
                            properties.identifyInfo = 1;
                            if (!$util.isString(message.staffEmail))
                                return "staffEmail: string expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an InvalidateLatestStaffInvitationHistoryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest} InvalidateLatestStaffInvitationHistoryRequest
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.staffEmail != null)
                            message.staffEmail = String(object.staffEmail);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an InvalidateLatestStaffInvitationHistoryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest} message InvalidateLatestStaffInvitationHistoryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.staffId != null && message.hasOwnProperty("staffId")) {
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                            if (options.oneofs)
                                object.identifyInfo = "staffId";
                        }
                        if (message.staffEmail != null && message.hasOwnProperty("staffEmail")) {
                            object.staffEmail = message.staffEmail;
                            if (options.oneofs)
                                object.identifyInfo = "staffEmail";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this InvalidateLatestStaffInvitationHistoryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.InvalidateLatestStaffInvitationHistoryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    InvalidateLatestStaffInvitationHistoryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return InvalidateLatestStaffInvitationHistoryRequest;
                })();
    
                v1.StaffInvitationHistory = (function() {
    
                    /**
                     * Properties of a StaffInvitationHistory.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffInvitationHistory
                     * @property {number|null} [id] StaffInvitationHistory id
                     * @property {number|null} [staffId] StaffInvitationHistory staffId
                     * @property {palexy.streaming.v1.StaffInvitationStatus|null} [invitationStatus] StaffInvitationHistory invitationStatus
                     * @property {string|null} [errorMessage] StaffInvitationHistory errorMessage
                     * @property {boolean|null} [invalid] StaffInvitationHistory invalid
                     * @property {number|null} [createTimeMs] StaffInvitationHistory createTimeMs
                     */
    
                    /**
                     * Constructs a new StaffInvitationHistory.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffInvitationHistory.
                     * @implements IStaffInvitationHistory
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffInvitationHistory=} [properties] Properties to set
                     */
                    function StaffInvitationHistory(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffInvitationHistory id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffInvitationHistory staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffInvitationHistory invitationStatus.
                     * @member {palexy.streaming.v1.StaffInvitationStatus} invitationStatus
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.invitationStatus = 0;
    
                    /**
                     * StaffInvitationHistory errorMessage.
                     * @member {string} errorMessage
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.errorMessage = "";
    
                    /**
                     * StaffInvitationHistory invalid.
                     * @member {boolean} invalid
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.invalid = false;
    
                    /**
                     * StaffInvitationHistory createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     */
                    StaffInvitationHistory.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StaffInvitationHistory instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffInvitationHistory=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffInvitationHistory} StaffInvitationHistory instance
                     */
                    StaffInvitationHistory.create = function create(properties) {
                        return new StaffInvitationHistory(properties);
                    };
    
                    /**
                     * Encodes the specified StaffInvitationHistory message. Does not implicitly {@link palexy.streaming.v1.StaffInvitationHistory.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffInvitationHistory} message StaffInvitationHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInvitationHistory.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                        if (message.invitationStatus != null && Object.hasOwnProperty.call(message, "invitationStatus"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.invitationStatus);
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.errorMessage);
                        if (message.invalid != null && Object.hasOwnProperty.call(message, "invalid"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.invalid);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffInvitationHistory message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffInvitationHistory.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffInvitationHistory} message StaffInvitationHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInvitationHistory.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffInvitationHistory message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffInvitationHistory} StaffInvitationHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInvitationHistory.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffInvitationHistory();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.staffId = reader.int64();
                                break;
                            case 3:
                                message.invitationStatus = reader.int32();
                                break;
                            case 4:
                                message.errorMessage = reader.string();
                                break;
                            case 5:
                                message.invalid = reader.bool();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffInvitationHistory message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffInvitationHistory} StaffInvitationHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInvitationHistory.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffInvitationHistory message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffInvitationHistory.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.invitationStatus != null && message.hasOwnProperty("invitationStatus"))
                            switch (message.invitationStatus) {
                            default:
                                return "invitationStatus: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        if (message.invalid != null && message.hasOwnProperty("invalid"))
                            if (typeof message.invalid !== "boolean")
                                return "invalid: boolean expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffInvitationHistory message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffInvitationHistory} StaffInvitationHistory
                     */
                    StaffInvitationHistory.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffInvitationHistory)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffInvitationHistory();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        switch (object.invitationStatus) {
                        case "UNKNOWN_INVITATION_STATUS":
                        case 0:
                            message.invitationStatus = 0;
                            break;
                        case "NO_VERIFICATION_METHOD":
                        case 1:
                            message.invitationStatus = 1;
                            break;
                        case "NO_INVITATION_SEND":
                        case 2:
                            message.invitationStatus = 2;
                            break;
                        case "WAITING_TO_BE_PROCESSED":
                        case 3:
                            message.invitationStatus = 3;
                            break;
                        case "WAITING_FOR_CONFIRMATION":
                        case 4:
                            message.invitationStatus = 4;
                            break;
                        case "INVITATION_ACCEPTED":
                        case 5:
                            message.invitationStatus = 5;
                            break;
                        case "INVITATION_DECLINED":
                        case 6:
                            message.invitationStatus = 6;
                            break;
                        case "INVITATION_EXPIRED":
                        case 7:
                            message.invitationStatus = 7;
                            break;
                        case "PERMISSION_CONFLICT":
                        case 8:
                            message.invitationStatus = 8;
                            break;
                        case "SEND_INVITATION_FAILED":
                        case 9:
                            message.invitationStatus = 9;
                            break;
                        case "INVALID_STAFF_INFORMATION":
                        case 10:
                            message.invitationStatus = 10;
                            break;
                        }
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        if (object.invalid != null)
                            message.invalid = Boolean(object.invalid);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffInvitationHistory message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @static
                     * @param {palexy.streaming.v1.StaffInvitationHistory} message StaffInvitationHistory
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffInvitationHistory.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.invitationStatus = options.enums === String ? "UNKNOWN_INVITATION_STATUS" : 0;
                            object.errorMessage = "";
                            object.invalid = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.invitationStatus != null && message.hasOwnProperty("invitationStatus"))
                            object.invitationStatus = options.enums === String ? $root.palexy.streaming.v1.StaffInvitationStatus[message.invitationStatus] : message.invitationStatus;
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        if (message.invalid != null && message.hasOwnProperty("invalid"))
                            object.invalid = message.invalid;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this StaffInvitationHistory to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffInvitationHistory
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffInvitationHistory.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffInvitationHistory;
                })();
    
                v1.CreateStaffInvitationHistoryRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffInvitationHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffInvitationHistoryRequest
                     * @property {palexy.streaming.v1.IStaffInvitationHistory|null} [invitationHistory] CreateStaffInvitationHistoryRequest invitationHistory
                     */
    
                    /**
                     * Constructs a new CreateStaffInvitationHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffInvitationHistoryRequest.
                     * @implements ICreateStaffInvitationHistoryRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest=} [properties] Properties to set
                     */
                    function CreateStaffInvitationHistoryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffInvitationHistoryRequest invitationHistory.
                     * @member {palexy.streaming.v1.IStaffInvitationHistory|null|undefined} invitationHistory
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @instance
                     */
                    CreateStaffInvitationHistoryRequest.prototype.invitationHistory = null;
    
                    /**
                     * Creates a new CreateStaffInvitationHistoryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffInvitationHistoryRequest} CreateStaffInvitationHistoryRequest instance
                     */
                    CreateStaffInvitationHistoryRequest.create = function create(properties) {
                        return new CreateStaffInvitationHistoryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffInvitationHistoryRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffInvitationHistoryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest} message CreateStaffInvitationHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffInvitationHistoryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.invitationHistory != null && Object.hasOwnProperty.call(message, "invitationHistory"))
                            $root.palexy.streaming.v1.StaffInvitationHistory.encode(message.invitationHistory, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffInvitationHistoryRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffInvitationHistoryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffInvitationHistoryRequest} message CreateStaffInvitationHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffInvitationHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffInvitationHistoryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffInvitationHistoryRequest} CreateStaffInvitationHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffInvitationHistoryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffInvitationHistoryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.invitationHistory = $root.palexy.streaming.v1.StaffInvitationHistory.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffInvitationHistoryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffInvitationHistoryRequest} CreateStaffInvitationHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffInvitationHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffInvitationHistoryRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffInvitationHistoryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.invitationHistory != null && message.hasOwnProperty("invitationHistory")) {
                            var error = $root.palexy.streaming.v1.StaffInvitationHistory.verify(message.invitationHistory);
                            if (error)
                                return "invitationHistory." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffInvitationHistoryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffInvitationHistoryRequest} CreateStaffInvitationHistoryRequest
                     */
                    CreateStaffInvitationHistoryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffInvitationHistoryRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffInvitationHistoryRequest();
                        if (object.invitationHistory != null) {
                            if (typeof object.invitationHistory !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStaffInvitationHistoryRequest.invitationHistory: object expected");
                            message.invitationHistory = $root.palexy.streaming.v1.StaffInvitationHistory.fromObject(object.invitationHistory);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffInvitationHistoryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffInvitationHistoryRequest} message CreateStaffInvitationHistoryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffInvitationHistoryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.invitationHistory = null;
                        if (message.invitationHistory != null && message.hasOwnProperty("invitationHistory"))
                            object.invitationHistory = $root.palexy.streaming.v1.StaffInvitationHistory.toObject(message.invitationHistory, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffInvitationHistoryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffInvitationHistoryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffInvitationHistoryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffInvitationHistoryRequest;
                })();
    
                v1.ConfirmStaffInvitationRequest = (function() {
    
                    /**
                     * Properties of a ConfirmStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IConfirmStaffInvitationRequest
                     * @property {number|null} [staffId] ConfirmStaffInvitationRequest staffId
                     * @property {string|null} [accountUsername] ConfirmStaffInvitationRequest accountUsername
                     * @property {boolean|null} [accept] ConfirmStaffInvitationRequest accept
                     */
    
                    /**
                     * Constructs a new ConfirmStaffInvitationRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ConfirmStaffInvitationRequest.
                     * @implements IConfirmStaffInvitationRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest=} [properties] Properties to set
                     */
                    function ConfirmStaffInvitationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ConfirmStaffInvitationRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @instance
                     */
                    ConfirmStaffInvitationRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ConfirmStaffInvitationRequest accountUsername.
                     * @member {string} accountUsername
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @instance
                     */
                    ConfirmStaffInvitationRequest.prototype.accountUsername = "";
    
                    /**
                     * ConfirmStaffInvitationRequest accept.
                     * @member {boolean} accept
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @instance
                     */
                    ConfirmStaffInvitationRequest.prototype.accept = false;
    
                    /**
                     * Creates a new ConfirmStaffInvitationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ConfirmStaffInvitationRequest} ConfirmStaffInvitationRequest instance
                     */
                    ConfirmStaffInvitationRequest.create = function create(properties) {
                        return new ConfirmStaffInvitationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ConfirmStaffInvitationRequest message. Does not implicitly {@link palexy.streaming.v1.ConfirmStaffInvitationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest} message ConfirmStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConfirmStaffInvitationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.accountUsername != null && Object.hasOwnProperty.call(message, "accountUsername"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.accountUsername);
                        if (message.accept != null && Object.hasOwnProperty.call(message, "accept"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.accept);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ConfirmStaffInvitationRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ConfirmStaffInvitationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.IConfirmStaffInvitationRequest} message ConfirmStaffInvitationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ConfirmStaffInvitationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ConfirmStaffInvitationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ConfirmStaffInvitationRequest} ConfirmStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConfirmStaffInvitationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ConfirmStaffInvitationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.accountUsername = reader.string();
                                break;
                            case 3:
                                message.accept = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ConfirmStaffInvitationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ConfirmStaffInvitationRequest} ConfirmStaffInvitationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ConfirmStaffInvitationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ConfirmStaffInvitationRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ConfirmStaffInvitationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            if (!$util.isString(message.accountUsername))
                                return "accountUsername: string expected";
                        if (message.accept != null && message.hasOwnProperty("accept"))
                            if (typeof message.accept !== "boolean")
                                return "accept: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ConfirmStaffInvitationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ConfirmStaffInvitationRequest} ConfirmStaffInvitationRequest
                     */
                    ConfirmStaffInvitationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ConfirmStaffInvitationRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ConfirmStaffInvitationRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.accountUsername != null)
                            message.accountUsername = String(object.accountUsername);
                        if (object.accept != null)
                            message.accept = Boolean(object.accept);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ConfirmStaffInvitationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @static
                     * @param {palexy.streaming.v1.ConfirmStaffInvitationRequest} message ConfirmStaffInvitationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ConfirmStaffInvitationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.accountUsername = "";
                            object.accept = false;
                        }
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            object.accountUsername = message.accountUsername;
                        if (message.accept != null && message.hasOwnProperty("accept"))
                            object.accept = message.accept;
                        return object;
                    };
    
                    /**
                     * Converts this ConfirmStaffInvitationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ConfirmStaffInvitationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ConfirmStaffInvitationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ConfirmStaffInvitationRequest;
                })();
    
                v1.UpdateStaffByAccountRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffByAccountRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffByAccountRequest
                     * @property {string|null} [accountUsername] UpdateStaffByAccountRequest accountUsername
                     * @property {string|null} [fullName] UpdateStaffByAccountRequest fullName
                     */
    
                    /**
                     * Constructs a new UpdateStaffByAccountRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffByAccountRequest.
                     * @implements IUpdateStaffByAccountRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest=} [properties] Properties to set
                     */
                    function UpdateStaffByAccountRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffByAccountRequest accountUsername.
                     * @member {string} accountUsername
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @instance
                     */
                    UpdateStaffByAccountRequest.prototype.accountUsername = "";
    
                    /**
                     * UpdateStaffByAccountRequest fullName.
                     * @member {string} fullName
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @instance
                     */
                    UpdateStaffByAccountRequest.prototype.fullName = "";
    
                    /**
                     * Creates a new UpdateStaffByAccountRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffByAccountRequest} UpdateStaffByAccountRequest instance
                     */
                    UpdateStaffByAccountRequest.create = function create(properties) {
                        return new UpdateStaffByAccountRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffByAccountRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffByAccountRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest} message UpdateStaffByAccountRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffByAccountRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.accountUsername != null && Object.hasOwnProperty.call(message, "accountUsername"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.accountUsername);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.fullName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffByAccountRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffByAccountRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffByAccountRequest} message UpdateStaffByAccountRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffByAccountRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffByAccountRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffByAccountRequest} UpdateStaffByAccountRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffByAccountRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffByAccountRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.accountUsername = reader.string();
                                break;
                            case 2:
                                message.fullName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffByAccountRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffByAccountRequest} UpdateStaffByAccountRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffByAccountRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffByAccountRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffByAccountRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            if (!$util.isString(message.accountUsername))
                                return "accountUsername: string expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffByAccountRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffByAccountRequest} UpdateStaffByAccountRequest
                     */
                    UpdateStaffByAccountRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffByAccountRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffByAccountRequest();
                        if (object.accountUsername != null)
                            message.accountUsername = String(object.accountUsername);
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffByAccountRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffByAccountRequest} message UpdateStaffByAccountRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffByAccountRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.accountUsername = "";
                            object.fullName = "";
                        }
                        if (message.accountUsername != null && message.hasOwnProperty("accountUsername"))
                            object.accountUsername = message.accountUsername;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffByAccountRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffByAccountRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffByAccountRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffByAccountRequest;
                })();
    
                v1.StaffAreaOrderIndex = (function() {
    
                    /**
                     * Properties of a StaffAreaOrderIndex.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffAreaOrderIndex
                     * @property {number|null} [staffId] StaffAreaOrderIndex staffId
                     * @property {number|null} [storeId] StaffAreaOrderIndex storeId
                     * @property {number|null} [areaOrderIndex] StaffAreaOrderIndex areaOrderIndex
                     */
    
                    /**
                     * Constructs a new StaffAreaOrderIndex.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffAreaOrderIndex.
                     * @implements IStaffAreaOrderIndex
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffAreaOrderIndex=} [properties] Properties to set
                     */
                    function StaffAreaOrderIndex(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffAreaOrderIndex staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @instance
                     */
                    StaffAreaOrderIndex.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAreaOrderIndex storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @instance
                     */
                    StaffAreaOrderIndex.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffAreaOrderIndex areaOrderIndex.
                     * @member {number} areaOrderIndex
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @instance
                     */
                    StaffAreaOrderIndex.prototype.areaOrderIndex = 0;
    
                    /**
                     * Creates a new StaffAreaOrderIndex instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {palexy.streaming.v1.IStaffAreaOrderIndex=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffAreaOrderIndex} StaffAreaOrderIndex instance
                     */
                    StaffAreaOrderIndex.create = function create(properties) {
                        return new StaffAreaOrderIndex(properties);
                    };
    
                    /**
                     * Encodes the specified StaffAreaOrderIndex message. Does not implicitly {@link palexy.streaming.v1.StaffAreaOrderIndex.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {palexy.streaming.v1.IStaffAreaOrderIndex} message StaffAreaOrderIndex message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAreaOrderIndex.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.areaOrderIndex != null && Object.hasOwnProperty.call(message, "areaOrderIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.areaOrderIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffAreaOrderIndex message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffAreaOrderIndex.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {palexy.streaming.v1.IStaffAreaOrderIndex} message StaffAreaOrderIndex message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffAreaOrderIndex.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffAreaOrderIndex message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffAreaOrderIndex} StaffAreaOrderIndex
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAreaOrderIndex.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffAreaOrderIndex();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.areaOrderIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffAreaOrderIndex message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffAreaOrderIndex} StaffAreaOrderIndex
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffAreaOrderIndex.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffAreaOrderIndex message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffAreaOrderIndex.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.areaOrderIndex != null && message.hasOwnProperty("areaOrderIndex"))
                            if (!$util.isInteger(message.areaOrderIndex))
                                return "areaOrderIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffAreaOrderIndex message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffAreaOrderIndex} StaffAreaOrderIndex
                     */
                    StaffAreaOrderIndex.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffAreaOrderIndex)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffAreaOrderIndex();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.areaOrderIndex != null)
                            message.areaOrderIndex = object.areaOrderIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffAreaOrderIndex message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @static
                     * @param {palexy.streaming.v1.StaffAreaOrderIndex} message StaffAreaOrderIndex
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffAreaOrderIndex.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.areaOrderIndex = 0;
                        }
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.areaOrderIndex != null && message.hasOwnProperty("areaOrderIndex"))
                            object.areaOrderIndex = message.areaOrderIndex;
                        return object;
                    };
    
                    /**
                     * Converts this StaffAreaOrderIndex to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffAreaOrderIndex
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffAreaOrderIndex.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffAreaOrderIndex;
                })();
    
                v1.BatchUpdateStaffAreaOrderIndicesRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateStaffAreaOrderIndicesRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStaffAreaOrderIndicesRequest
                     * @property {number|null} [storeId] BatchUpdateStaffAreaOrderIndicesRequest storeId
                     * @property {Array.<palexy.streaming.v1.IStaffAreaOrderIndex>|null} [requests] BatchUpdateStaffAreaOrderIndicesRequest requests
                     */
    
                    /**
                     * Constructs a new BatchUpdateStaffAreaOrderIndicesRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStaffAreaOrderIndicesRequest.
                     * @implements IBatchUpdateStaffAreaOrderIndicesRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest=} [properties] Properties to set
                     */
                    function BatchUpdateStaffAreaOrderIndicesRequest(properties) {
                        this.requests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStaffAreaOrderIndicesRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @instance
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchUpdateStaffAreaOrderIndicesRequest requests.
                     * @member {Array.<palexy.streaming.v1.IStaffAreaOrderIndex>} requests
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @instance
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.prototype.requests = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStaffAreaOrderIndicesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest} BatchUpdateStaffAreaOrderIndicesRequest instance
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.create = function create(properties) {
                        return new BatchUpdateStaffAreaOrderIndicesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStaffAreaOrderIndicesRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest} message BatchUpdateStaffAreaOrderIndicesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.requests != null && message.requests.length)
                            for (var i = 0; i < message.requests.length; ++i)
                                $root.palexy.streaming.v1.StaffAreaOrderIndex.encode(message.requests[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStaffAreaOrderIndicesRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesRequest} message BatchUpdateStaffAreaOrderIndicesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStaffAreaOrderIndicesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest} BatchUpdateStaffAreaOrderIndicesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.requests && message.requests.length))
                                    message.requests = [];
                                message.requests.push($root.palexy.streaming.v1.StaffAreaOrderIndex.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStaffAreaOrderIndicesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest} BatchUpdateStaffAreaOrderIndicesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStaffAreaOrderIndicesRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.requests != null && message.hasOwnProperty("requests")) {
                            if (!Array.isArray(message.requests))
                                return "requests: array expected";
                            for (var i = 0; i < message.requests.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffAreaOrderIndex.verify(message.requests[i]);
                                if (error)
                                    return "requests." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStaffAreaOrderIndicesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest} BatchUpdateStaffAreaOrderIndicesRequest
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.requests) {
                            if (!Array.isArray(object.requests))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest.requests: array expected");
                            message.requests = [];
                            for (var i = 0; i < object.requests.length; ++i) {
                                if (typeof object.requests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest.requests: object expected");
                                message.requests[i] = $root.palexy.streaming.v1.StaffAreaOrderIndex.fromObject(object.requests[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStaffAreaOrderIndicesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest} message BatchUpdateStaffAreaOrderIndicesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.requests = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.requests && message.requests.length) {
                            object.requests = [];
                            for (var j = 0; j < message.requests.length; ++j)
                                object.requests[j] = $root.palexy.streaming.v1.StaffAreaOrderIndex.toObject(message.requests[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStaffAreaOrderIndicesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStaffAreaOrderIndicesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStaffAreaOrderIndicesRequest;
                })();
    
                v1.BatchUpdateStaffAreaOrderIndicesResponse = (function() {
    
                    /**
                     * Properties of a BatchUpdateStaffAreaOrderIndicesResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStaffAreaOrderIndicesResponse
                     * @property {Array.<palexy.streaming.v1.IStaffAreaOrderIndex>|null} [staffAreaOrderIndices] BatchUpdateStaffAreaOrderIndicesResponse staffAreaOrderIndices
                     */
    
                    /**
                     * Constructs a new BatchUpdateStaffAreaOrderIndicesResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStaffAreaOrderIndicesResponse.
                     * @implements IBatchUpdateStaffAreaOrderIndicesResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesResponse=} [properties] Properties to set
                     */
                    function BatchUpdateStaffAreaOrderIndicesResponse(properties) {
                        this.staffAreaOrderIndices = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStaffAreaOrderIndicesResponse staffAreaOrderIndices.
                     * @member {Array.<palexy.streaming.v1.IStaffAreaOrderIndex>} staffAreaOrderIndices
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @instance
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.prototype.staffAreaOrderIndices = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStaffAreaOrderIndicesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} BatchUpdateStaffAreaOrderIndicesResponse instance
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.create = function create(properties) {
                        return new BatchUpdateStaffAreaOrderIndicesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStaffAreaOrderIndicesResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesResponse} message BatchUpdateStaffAreaOrderIndicesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffAreaOrderIndices != null && message.staffAreaOrderIndices.length)
                            for (var i = 0; i < message.staffAreaOrderIndices.length; ++i)
                                $root.palexy.streaming.v1.StaffAreaOrderIndex.encode(message.staffAreaOrderIndices[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStaffAreaOrderIndicesResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStaffAreaOrderIndicesResponse} message BatchUpdateStaffAreaOrderIndicesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStaffAreaOrderIndicesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} BatchUpdateStaffAreaOrderIndicesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffAreaOrderIndices && message.staffAreaOrderIndices.length))
                                    message.staffAreaOrderIndices = [];
                                message.staffAreaOrderIndices.push($root.palexy.streaming.v1.StaffAreaOrderIndex.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStaffAreaOrderIndicesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} BatchUpdateStaffAreaOrderIndicesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStaffAreaOrderIndicesResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffAreaOrderIndices != null && message.hasOwnProperty("staffAreaOrderIndices")) {
                            if (!Array.isArray(message.staffAreaOrderIndices))
                                return "staffAreaOrderIndices: array expected";
                            for (var i = 0; i < message.staffAreaOrderIndices.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffAreaOrderIndex.verify(message.staffAreaOrderIndices[i]);
                                if (error)
                                    return "staffAreaOrderIndices." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStaffAreaOrderIndicesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} BatchUpdateStaffAreaOrderIndicesResponse
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse();
                        if (object.staffAreaOrderIndices) {
                            if (!Array.isArray(object.staffAreaOrderIndices))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse.staffAreaOrderIndices: array expected");
                            message.staffAreaOrderIndices = [];
                            for (var i = 0; i < object.staffAreaOrderIndices.length; ++i) {
                                if (typeof object.staffAreaOrderIndices[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse.staffAreaOrderIndices: object expected");
                                message.staffAreaOrderIndices[i] = $root.palexy.streaming.v1.StaffAreaOrderIndex.fromObject(object.staffAreaOrderIndices[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStaffAreaOrderIndicesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse} message BatchUpdateStaffAreaOrderIndicesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffAreaOrderIndices = [];
                        if (message.staffAreaOrderIndices && message.staffAreaOrderIndices.length) {
                            object.staffAreaOrderIndices = [];
                            for (var j = 0; j < message.staffAreaOrderIndices.length; ++j)
                                object.staffAreaOrderIndices[j] = $root.palexy.streaming.v1.StaffAreaOrderIndex.toObject(message.staffAreaOrderIndices[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStaffAreaOrderIndicesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStaffAreaOrderIndicesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStaffAreaOrderIndicesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStaffAreaOrderIndicesResponse;
                })();
    
                v1.UpdateStaffStatusRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffStatusRequest
                     * @property {boolean|null} [disable] UpdateStaffStatusRequest disable
                     * @property {google.protobuf.IInt32Value|null} [lastWorkingDateId] UpdateStaffStatusRequest lastWorkingDateId
                     */
    
                    /**
                     * Constructs a new UpdateStaffStatusRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffStatusRequest.
                     * @implements IUpdateStaffStatusRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffStatusRequest=} [properties] Properties to set
                     */
                    function UpdateStaffStatusRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffStatusRequest disable.
                     * @member {boolean} disable
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @instance
                     */
                    UpdateStaffStatusRequest.prototype.disable = false;
    
                    /**
                     * UpdateStaffStatusRequest lastWorkingDateId.
                     * @member {google.protobuf.IInt32Value|null|undefined} lastWorkingDateId
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @instance
                     */
                    UpdateStaffStatusRequest.prototype.lastWorkingDateId = null;
    
                    /**
                     * Creates a new UpdateStaffStatusRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffStatusRequest} UpdateStaffStatusRequest instance
                     */
                    UpdateStaffStatusRequest.create = function create(properties) {
                        return new UpdateStaffStatusRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffStatusRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffStatusRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusRequest} message UpdateStaffStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffStatusRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.disable != null && Object.hasOwnProperty.call(message, "disable"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.disable);
                        if (message.lastWorkingDateId != null && Object.hasOwnProperty.call(message, "lastWorkingDateId"))
                            $root.google.protobuf.Int32Value.encode(message.lastWorkingDateId, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffStatusRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffStatusRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusRequest} message UpdateStaffStatusRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffStatusRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffStatusRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffStatusRequest} UpdateStaffStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffStatusRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffStatusRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.disable = reader.bool();
                                break;
                            case 2:
                                message.lastWorkingDateId = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffStatusRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffStatusRequest} UpdateStaffStatusRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffStatusRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffStatusRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffStatusRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.disable != null && message.hasOwnProperty("disable"))
                            if (typeof message.disable !== "boolean")
                                return "disable: boolean expected";
                        if (message.lastWorkingDateId != null && message.hasOwnProperty("lastWorkingDateId")) {
                            var error = $root.google.protobuf.Int32Value.verify(message.lastWorkingDateId);
                            if (error)
                                return "lastWorkingDateId." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffStatusRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffStatusRequest} UpdateStaffStatusRequest
                     */
                    UpdateStaffStatusRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffStatusRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffStatusRequest();
                        if (object.disable != null)
                            message.disable = Boolean(object.disable);
                        if (object.lastWorkingDateId != null) {
                            if (typeof object.lastWorkingDateId !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffStatusRequest.lastWorkingDateId: object expected");
                            message.lastWorkingDateId = $root.google.protobuf.Int32Value.fromObject(object.lastWorkingDateId);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffStatusRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffStatusRequest} message UpdateStaffStatusRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffStatusRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.disable = false;
                            object.lastWorkingDateId = null;
                        }
                        if (message.disable != null && message.hasOwnProperty("disable"))
                            object.disable = message.disable;
                        if (message.lastWorkingDateId != null && message.hasOwnProperty("lastWorkingDateId"))
                            object.lastWorkingDateId = $root.google.protobuf.Int32Value.toObject(message.lastWorkingDateId, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffStatusRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffStatusRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffStatusRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffStatusRequest;
                })();
    
                v1.UpdateStaffStatusResponse = (function() {
    
                    /**
                     * Properties of an UpdateStaffStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffStatusResponse
                     */
    
                    /**
                     * Constructs a new UpdateStaffStatusResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffStatusResponse.
                     * @implements IUpdateStaffStatusResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffStatusResponse=} [properties] Properties to set
                     */
                    function UpdateStaffStatusResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new UpdateStaffStatusResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffStatusResponse} UpdateStaffStatusResponse instance
                     */
                    UpdateStaffStatusResponse.create = function create(properties) {
                        return new UpdateStaffStatusResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffStatusResponse message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffStatusResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusResponse} message UpdateStaffStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffStatusResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffStatusResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffStatusResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffStatusResponse} message UpdateStaffStatusResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffStatusResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffStatusResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffStatusResponse} UpdateStaffStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffStatusResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffStatusResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffStatusResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffStatusResponse} UpdateStaffStatusResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffStatusResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffStatusResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffStatusResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffStatusResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffStatusResponse} UpdateStaffStatusResponse
                     */
                    UpdateStaffStatusResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffStatusResponse)
                            return object;
                        return new $root.palexy.streaming.v1.UpdateStaffStatusResponse();
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffStatusResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffStatusResponse} message UpdateStaffStatusResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffStatusResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this UpdateStaffStatusResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffStatusResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffStatusResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffStatusResponse;
                })();
    
                v1.DeleteStaffMetadataRequest = (function() {
    
                    /**
                     * Properties of a DeleteStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStaffMetadataRequest
                     * @property {number|null} [metadataId] DeleteStaffMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new DeleteStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStaffMetadataRequest.
                     * @implements IDeleteStaffMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest=} [properties] Properties to set
                     */
                    function DeleteStaffMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStaffMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @instance
                     */
                    DeleteStaffMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStaffMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStaffMetadataRequest} DeleteStaffMetadataRequest instance
                     */
                    DeleteStaffMetadataRequest.create = function create(properties) {
                        return new DeleteStaffMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStaffMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStaffMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest} message DeleteStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStaffMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStaffMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffMetadataRequest} message DeleteStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStaffMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStaffMetadataRequest} DeleteStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStaffMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStaffMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStaffMetadataRequest} DeleteStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStaffMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStaffMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStaffMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStaffMetadataRequest} DeleteStaffMetadataRequest
                     */
                    DeleteStaffMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStaffMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStaffMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStaffMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStaffMetadataRequest} message DeleteStaffMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStaffMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStaffMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStaffMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStaffMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStaffMetadataRequest;
                })();
    
                v1.GetStaffMetadataRequest = (function() {
    
                    /**
                     * Properties of a GetStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffMetadataRequest
                     * @property {number|null} [metadataId] GetStaffMetadataRequest metadataId
                     */
    
                    /**
                     * Constructs a new GetStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffMetadataRequest.
                     * @implements IGetStaffMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest=} [properties] Properties to set
                     */
                    function GetStaffMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffMetadataRequest metadataId.
                     * @member {number} metadataId
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @instance
                     */
                    GetStaffMetadataRequest.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffMetadataRequest} GetStaffMetadataRequest instance
                     */
                    GetStaffMetadataRequest.create = function create(properties) {
                        return new GetStaffMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest} message GetStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffMetadataRequest} message GetStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffMetadataRequest} GetStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffMetadataRequest} GetStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                                return "metadataId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffMetadataRequest} GetStaffMetadataRequest
                     */
                    GetStaffMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffMetadataRequest();
                        if (object.metadataId != null)
                            if ($util.Long)
                                (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                            else if (typeof object.metadataId === "string")
                                message.metadataId = parseInt(object.metadataId, 10);
                            else if (typeof object.metadataId === "number")
                                message.metadataId = object.metadataId;
                            else if (typeof object.metadataId === "object")
                                message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffMetadataRequest} message GetStaffMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataId = options.longs === String ? "0" : 0;
                        if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                            if (typeof message.metadataId === "number")
                                object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                            else
                                object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffMetadataRequest;
                })();
    
                v1.ListStaffMetadataRequest = (function() {
    
                    /**
                     * Properties of a ListStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffMetadataRequest
                     * @property {number|null} [companyId] ListStaffMetadataRequest companyId
                     * @property {string|null} [name] ListStaffMetadataRequest name
                     * @property {number|null} [pageSize] ListStaffMetadataRequest pageSize
                     * @property {string|null} [pageToken] ListStaffMetadataRequest pageToken
                     * @property {boolean|null} [includeDeletedMetadata] ListStaffMetadataRequest includeDeletedMetadata
                     */
    
                    /**
                     * Constructs a new ListStaffMetadataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffMetadataRequest.
                     * @implements IListStaffMetadataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest=} [properties] Properties to set
                     */
                    function ListStaffMetadataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffMetadataRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     */
                    ListStaffMetadataRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffMetadataRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     */
                    ListStaffMetadataRequest.prototype.name = "";
    
                    /**
                     * ListStaffMetadataRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     */
                    ListStaffMetadataRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffMetadataRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     */
                    ListStaffMetadataRequest.prototype.pageToken = "";
    
                    /**
                     * ListStaffMetadataRequest includeDeletedMetadata.
                     * @member {boolean} includeDeletedMetadata
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     */
                    ListStaffMetadataRequest.prototype.includeDeletedMetadata = false;
    
                    /**
                     * Creates a new ListStaffMetadataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffMetadataRequest} ListStaffMetadataRequest instance
                     */
                    ListStaffMetadataRequest.create = function create(properties) {
                        return new ListStaffMetadataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffMetadataRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffMetadataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest} message ListStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffMetadataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.includeDeletedMetadata != null && Object.hasOwnProperty.call(message, "includeDeletedMetadata"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeDeletedMetadata);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffMetadataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffMetadataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataRequest} message ListStaffMetadataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffMetadataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffMetadataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffMetadataRequest} ListStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffMetadataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffMetadataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 5:
                                message.includeDeletedMetadata = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffMetadataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffMetadataRequest} ListStaffMetadataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffMetadataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffMetadataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffMetadataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.includeDeletedMetadata != null && message.hasOwnProperty("includeDeletedMetadata"))
                            if (typeof message.includeDeletedMetadata !== "boolean")
                                return "includeDeletedMetadata: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffMetadataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffMetadataRequest} ListStaffMetadataRequest
                     */
                    ListStaffMetadataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffMetadataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffMetadataRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.includeDeletedMetadata != null)
                            message.includeDeletedMetadata = Boolean(object.includeDeletedMetadata);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffMetadataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffMetadataRequest} message ListStaffMetadataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffMetadataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeDeletedMetadata = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.includeDeletedMetadata != null && message.hasOwnProperty("includeDeletedMetadata"))
                            object.includeDeletedMetadata = message.includeDeletedMetadata;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffMetadataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffMetadataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffMetadataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffMetadataRequest;
                })();
    
                v1.ListStaffMetadataResponse = (function() {
    
                    /**
                     * Properties of a ListStaffMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffMetadataResponse
                     * @property {Array.<palexy.protobuf.IStaffMetadata>|null} [staffMetadata] ListStaffMetadataResponse staffMetadata
                     * @property {number|null} [totalElements] ListStaffMetadataResponse totalElements
                     * @property {string|null} [nextPageToken] ListStaffMetadataResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListStaffMetadataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffMetadataResponse.
                     * @implements IListStaffMetadataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffMetadataResponse=} [properties] Properties to set
                     */
                    function ListStaffMetadataResponse(properties) {
                        this.staffMetadata = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffMetadataResponse staffMetadata.
                     * @member {Array.<palexy.protobuf.IStaffMetadata>} staffMetadata
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @instance
                     */
                    ListStaffMetadataResponse.prototype.staffMetadata = $util.emptyArray;
    
                    /**
                     * ListStaffMetadataResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @instance
                     */
                    ListStaffMetadataResponse.prototype.totalElements = 0;
    
                    /**
                     * ListStaffMetadataResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @instance
                     */
                    ListStaffMetadataResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListStaffMetadataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffMetadataResponse} ListStaffMetadataResponse instance
                     */
                    ListStaffMetadataResponse.create = function create(properties) {
                        return new ListStaffMetadataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffMetadataResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffMetadataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataResponse} message ListStaffMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffMetadataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffMetadata != null && message.staffMetadata.length)
                            for (var i = 0; i < message.staffMetadata.length; ++i)
                                $root.palexy.protobuf.StaffMetadata.encode(message.staffMetadata[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffMetadataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffMetadataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffMetadataResponse} message ListStaffMetadataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffMetadataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffMetadataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffMetadataResponse} ListStaffMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffMetadataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffMetadataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffMetadata && message.staffMetadata.length))
                                    message.staffMetadata = [];
                                message.staffMetadata.push($root.palexy.protobuf.StaffMetadata.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffMetadataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffMetadataResponse} ListStaffMetadataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffMetadataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffMetadataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffMetadataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffMetadata != null && message.hasOwnProperty("staffMetadata")) {
                            if (!Array.isArray(message.staffMetadata))
                                return "staffMetadata: array expected";
                            for (var i = 0; i < message.staffMetadata.length; ++i) {
                                var error = $root.palexy.protobuf.StaffMetadata.verify(message.staffMetadata[i]);
                                if (error)
                                    return "staffMetadata." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffMetadataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffMetadataResponse} ListStaffMetadataResponse
                     */
                    ListStaffMetadataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffMetadataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffMetadataResponse();
                        if (object.staffMetadata) {
                            if (!Array.isArray(object.staffMetadata))
                                throw TypeError(".palexy.streaming.v1.ListStaffMetadataResponse.staffMetadata: array expected");
                            message.staffMetadata = [];
                            for (var i = 0; i < object.staffMetadata.length; ++i) {
                                if (typeof object.staffMetadata[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffMetadataResponse.staffMetadata: object expected");
                                message.staffMetadata[i] = $root.palexy.protobuf.StaffMetadata.fromObject(object.staffMetadata[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffMetadataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffMetadataResponse} message ListStaffMetadataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffMetadataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffMetadata = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.staffMetadata && message.staffMetadata.length) {
                            object.staffMetadata = [];
                            for (var j = 0; j < message.staffMetadata.length; ++j)
                                object.staffMetadata[j] = $root.palexy.protobuf.StaffMetadata.toObject(message.staffMetadata[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffMetadataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffMetadataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffMetadataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffMetadataResponse;
                })();
    
                v1.AsyncQueueSenderService = (function() {
    
                    /**
                     * Constructs a new AsyncQueueSenderService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncQueueSenderService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function AsyncQueueSenderService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (AsyncQueueSenderService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AsyncQueueSenderService;
    
                    /**
                     * Creates new AsyncQueueSenderService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {AsyncQueueSenderService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    AsyncQueueSenderService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncQueueSenderService#executeTask}.
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @typedef ExecuteTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ExecuteTask.
                     * @function executeTask
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest} request AsyncQueueSenderExecuteTaskRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncQueueSenderService.ExecuteTaskCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncQueueSenderService.prototype.executeTask = function executeTask(request, callback) {
                        return this.rpcCall(executeTask, $root.palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ExecuteTask" });
    
                    /**
                     * Calls ExecuteTask.
                     * @function executeTask
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest} request AsyncQueueSenderExecuteTaskRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncQueueSenderService#listTasks}.
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @typedef ListTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} [response] ListAsyncQueueSenderTasksResponse
                     */
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest} request ListAsyncQueueSenderTasksRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncQueueSenderService.ListTasksCallback} callback Node-style callback called with the error, if any, and ListAsyncQueueSenderTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncQueueSenderService.prototype.listTasks = function listTasks(request, callback) {
                        return this.rpcCall(listTasks, $root.palexy.streaming.v1.ListAsyncQueueSenderTasksRequest, $root.palexy.streaming.v1.ListAsyncQueueSenderTasksResponse, request, callback);
                    }, "name", { value: "ListTasks" });
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest} request ListAsyncQueueSenderTasksRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListAsyncQueueSenderTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AsyncQueueSenderService#batchDeleteTasks}.
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @typedef BatchDeleteTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls BatchDeleteTasks.
                     * @function batchDeleteTasks
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest} request BatchDeleteTasksRequest message or plain object
                     * @param {palexy.streaming.v1.AsyncQueueSenderService.BatchDeleteTasksCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AsyncQueueSenderService.prototype.batchDeleteTasks = function batchDeleteTasks(request, callback) {
                        return this.rpcCall(batchDeleteTasks, $root.palexy.streaming.v1.BatchDeleteTasksRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "BatchDeleteTasks" });
    
                    /**
                     * Calls BatchDeleteTasks.
                     * @function batchDeleteTasks
                     * @memberof palexy.streaming.v1.AsyncQueueSenderService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest} request BatchDeleteTasksRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return AsyncQueueSenderService;
                })();
    
                v1.AsyncQueueSenderTask = (function() {
    
                    /**
                     * Properties of an AsyncQueueSenderTask.
                     * @memberof palexy.streaming.v1
                     * @interface IAsyncQueueSenderTask
                     * @property {number|null} [id] AsyncQueueSenderTask id
                     * @property {Uint8Array|null} [message] AsyncQueueSenderTask message
                     * @property {string|null} [destinationQueue] AsyncQueueSenderTask destinationQueue
                     * @property {string|null} [traceId] AsyncQueueSenderTask traceId
                     * @property {palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState|null} [state] AsyncQueueSenderTask state
                     * @property {number|null} [createTimeMs] AsyncQueueSenderTask createTimeMs
                     * @property {number|null} [updateTimeMs] AsyncQueueSenderTask updateTimeMs
                     * @property {number|null} [sentTimeMs] AsyncQueueSenderTask sentTimeMs
                     */
    
                    /**
                     * Constructs a new AsyncQueueSenderTask.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncQueueSenderTask.
                     * @implements IAsyncQueueSenderTask
                     * @constructor
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTask=} [properties] Properties to set
                     */
                    function AsyncQueueSenderTask(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AsyncQueueSenderTask id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncQueueSenderTask message.
                     * @member {Uint8Array} message
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.message = $util.newBuffer([]);
    
                    /**
                     * AsyncQueueSenderTask destinationQueue.
                     * @member {string} destinationQueue
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.destinationQueue = "";
    
                    /**
                     * AsyncQueueSenderTask traceId.
                     * @member {string} traceId
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.traceId = "";
    
                    /**
                     * AsyncQueueSenderTask state.
                     * @member {palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState} state
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.state = 0;
    
                    /**
                     * AsyncQueueSenderTask createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncQueueSenderTask updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AsyncQueueSenderTask sentTimeMs.
                     * @member {number} sentTimeMs
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     */
                    AsyncQueueSenderTask.prototype.sentTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AsyncQueueSenderTask instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTask=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTask} AsyncQueueSenderTask instance
                     */
                    AsyncQueueSenderTask.create = function create(properties) {
                        return new AsyncQueueSenderTask(properties);
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderTask message. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderTask.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTask} message AsyncQueueSenderTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderTask.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).bytes(message.message);
                        if (message.destinationQueue != null && Object.hasOwnProperty.call(message, "destinationQueue"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.destinationQueue);
                        if (message.traceId != null && Object.hasOwnProperty.call(message, "traceId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.traceId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.state);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updateTimeMs);
                        if (message.sentTimeMs != null && Object.hasOwnProperty.call(message, "sentTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.sentTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderTask message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderTask.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTask} message AsyncQueueSenderTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderTask.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderTask message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTask} AsyncQueueSenderTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderTask.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncQueueSenderTask();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.message = reader.bytes();
                                break;
                            case 3:
                                message.destinationQueue = reader.string();
                                break;
                            case 4:
                                message.traceId = reader.string();
                                break;
                            case 5:
                                message.state = reader.int32();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.sentTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderTask message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTask} AsyncQueueSenderTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderTask.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AsyncQueueSenderTask message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AsyncQueueSenderTask.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!(message.message && typeof message.message.length === "number" || $util.isString(message.message)))
                                return "message: buffer expected";
                        if (message.destinationQueue != null && message.hasOwnProperty("destinationQueue"))
                            if (!$util.isString(message.destinationQueue))
                                return "destinationQueue: string expected";
                        if (message.traceId != null && message.hasOwnProperty("traceId"))
                            if (!$util.isString(message.traceId))
                                return "traceId: string expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.sentTimeMs != null && message.hasOwnProperty("sentTimeMs"))
                            if (!$util.isInteger(message.sentTimeMs) && !(message.sentTimeMs && $util.isInteger(message.sentTimeMs.low) && $util.isInteger(message.sentTimeMs.high)))
                                return "sentTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AsyncQueueSenderTask message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTask} AsyncQueueSenderTask
                     */
                    AsyncQueueSenderTask.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AsyncQueueSenderTask)
                            return object;
                        var message = new $root.palexy.streaming.v1.AsyncQueueSenderTask();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.message != null)
                            if (typeof object.message === "string")
                                $util.base64.decode(object.message, message.message = $util.newBuffer($util.base64.length(object.message)), 0);
                            else if (object.message.length)
                                message.message = object.message;
                        if (object.destinationQueue != null)
                            message.destinationQueue = String(object.destinationQueue);
                        if (object.traceId != null)
                            message.traceId = String(object.traceId);
                        switch (object.state) {
                        case "UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "WAITING_TO_SEND":
                        case 1:
                            message.state = 1;
                            break;
                        case "SENT":
                        case 2:
                            message.state = 2;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.sentTimeMs != null)
                            if ($util.Long)
                                (message.sentTimeMs = $util.Long.fromValue(object.sentTimeMs)).unsigned = false;
                            else if (typeof object.sentTimeMs === "string")
                                message.sentTimeMs = parseInt(object.sentTimeMs, 10);
                            else if (typeof object.sentTimeMs === "number")
                                message.sentTimeMs = object.sentTimeMs;
                            else if (typeof object.sentTimeMs === "object")
                                message.sentTimeMs = new $util.LongBits(object.sentTimeMs.low >>> 0, object.sentTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AsyncQueueSenderTask message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @static
                     * @param {palexy.streaming.v1.AsyncQueueSenderTask} message AsyncQueueSenderTask
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AsyncQueueSenderTask.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if (options.bytes === String)
                                object.message = "";
                            else {
                                object.message = [];
                                if (options.bytes !== Array)
                                    object.message = $util.newBuffer(object.message);
                            }
                            object.destinationQueue = "";
                            object.traceId = "";
                            object.state = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.sentTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.sentTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = options.bytes === String ? $util.base64.encode(message.message, 0, message.message.length) : options.bytes === Array ? Array.prototype.slice.call(message.message) : message.message;
                        if (message.destinationQueue != null && message.hasOwnProperty("destinationQueue"))
                            object.destinationQueue = message.destinationQueue;
                        if (message.traceId != null && message.hasOwnProperty("traceId"))
                            object.traceId = message.traceId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState[message.state] : message.state;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.sentTimeMs != null && message.hasOwnProperty("sentTimeMs"))
                            if (typeof message.sentTimeMs === "number")
                                object.sentTimeMs = options.longs === String ? String(message.sentTimeMs) : message.sentTimeMs;
                            else
                                object.sentTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.sentTimeMs) : options.longs === Number ? new $util.LongBits(message.sentTimeMs.low >>> 0, message.sentTimeMs.high >>> 0).toNumber() : message.sentTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this AsyncQueueSenderTask to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTask
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AsyncQueueSenderTask.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * AsyncQueueSenderTaskState enum.
                     * @name palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} WAITING_TO_SEND=1 WAITING_TO_SEND value
                     * @property {number} SENT=2 SENT value
                     */
                    AsyncQueueSenderTask.AsyncQueueSenderTaskState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "WAITING_TO_SEND"] = 1;
                        values[valuesById[2] = "SENT"] = 2;
                        return values;
                    })();
    
                    return AsyncQueueSenderTask;
                })();
    
                v1.ListAsyncQueueSenderTasksRequest = (function() {
    
                    /**
                     * Properties of a ListAsyncQueueSenderTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListAsyncQueueSenderTasksRequest
                     * @property {number|null} [pageSize] ListAsyncQueueSenderTasksRequest pageSize
                     * @property {string|null} [pageToken] ListAsyncQueueSenderTasksRequest pageToken
                     * @property {palexy.streaming.v1.IAsyncQueueSenderTaskFilter|null} [filter] ListAsyncQueueSenderTasksRequest filter
                     */
    
                    /**
                     * Constructs a new ListAsyncQueueSenderTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAsyncQueueSenderTasksRequest.
                     * @implements IListAsyncQueueSenderTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest=} [properties] Properties to set
                     */
                    function ListAsyncQueueSenderTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAsyncQueueSenderTasksRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @instance
                     */
                    ListAsyncQueueSenderTasksRequest.prototype.pageSize = 0;
    
                    /**
                     * ListAsyncQueueSenderTasksRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @instance
                     */
                    ListAsyncQueueSenderTasksRequest.prototype.pageToken = "";
    
                    /**
                     * ListAsyncQueueSenderTasksRequest filter.
                     * @member {palexy.streaming.v1.IAsyncQueueSenderTaskFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @instance
                     */
                    ListAsyncQueueSenderTasksRequest.prototype.filter = null;
    
                    /**
                     * Creates a new ListAsyncQueueSenderTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksRequest} ListAsyncQueueSenderTasksRequest instance
                     */
                    ListAsyncQueueSenderTasksRequest.create = function create(properties) {
                        return new ListAsyncQueueSenderTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAsyncQueueSenderTasksRequest message. Does not implicitly {@link palexy.streaming.v1.ListAsyncQueueSenderTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest} message ListAsyncQueueSenderTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncQueueSenderTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter.encode(message.filter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAsyncQueueSenderTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAsyncQueueSenderTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksRequest} message ListAsyncQueueSenderTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncQueueSenderTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAsyncQueueSenderTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksRequest} ListAsyncQueueSenderTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncQueueSenderTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAsyncQueueSenderTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.filter = $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAsyncQueueSenderTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksRequest} ListAsyncQueueSenderTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncQueueSenderTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAsyncQueueSenderTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAsyncQueueSenderTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAsyncQueueSenderTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksRequest} ListAsyncQueueSenderTasksRequest
                     */
                    ListAsyncQueueSenderTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAsyncQueueSenderTasksRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAsyncQueueSenderTasksRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListAsyncQueueSenderTasksRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter.fromObject(object.filter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAsyncQueueSenderTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ListAsyncQueueSenderTasksRequest} message ListAsyncQueueSenderTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAsyncQueueSenderTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.filter = null;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter.toObject(message.filter, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListAsyncQueueSenderTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAsyncQueueSenderTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAsyncQueueSenderTasksRequest;
                })();
    
                v1.AsyncQueueSenderTaskFilter = (function() {
    
                    /**
                     * Properties of an AsyncQueueSenderTaskFilter.
                     * @memberof palexy.streaming.v1
                     * @interface IAsyncQueueSenderTaskFilter
                     * @property {palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState|null} [state] AsyncQueueSenderTaskFilter state
                     * @property {number|null} [maxCreateTimeMs] AsyncQueueSenderTaskFilter maxCreateTimeMs
                     */
    
                    /**
                     * Constructs a new AsyncQueueSenderTaskFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncQueueSenderTaskFilter.
                     * @implements IAsyncQueueSenderTaskFilter
                     * @constructor
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTaskFilter=} [properties] Properties to set
                     */
                    function AsyncQueueSenderTaskFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AsyncQueueSenderTaskFilter state.
                     * @member {palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState} state
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @instance
                     */
                    AsyncQueueSenderTaskFilter.prototype.state = 0;
    
                    /**
                     * AsyncQueueSenderTaskFilter maxCreateTimeMs.
                     * @member {number} maxCreateTimeMs
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @instance
                     */
                    AsyncQueueSenderTaskFilter.prototype.maxCreateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AsyncQueueSenderTaskFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTaskFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTaskFilter} AsyncQueueSenderTaskFilter instance
                     */
                    AsyncQueueSenderTaskFilter.create = function create(properties) {
                        return new AsyncQueueSenderTaskFilter(properties);
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderTaskFilter message. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderTaskFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTaskFilter} message AsyncQueueSenderTaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderTaskFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                        if (message.maxCreateTimeMs != null && Object.hasOwnProperty.call(message, "maxCreateTimeMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.maxCreateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderTaskFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderTaskFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderTaskFilter} message AsyncQueueSenderTaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderTaskFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderTaskFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTaskFilter} AsyncQueueSenderTaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderTaskFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.state = reader.int32();
                                break;
                            case 2:
                                message.maxCreateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderTaskFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTaskFilter} AsyncQueueSenderTaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderTaskFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AsyncQueueSenderTaskFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AsyncQueueSenderTaskFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.maxCreateTimeMs != null && message.hasOwnProperty("maxCreateTimeMs"))
                            if (!$util.isInteger(message.maxCreateTimeMs) && !(message.maxCreateTimeMs && $util.isInteger(message.maxCreateTimeMs.low) && $util.isInteger(message.maxCreateTimeMs.high)))
                                return "maxCreateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AsyncQueueSenderTaskFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AsyncQueueSenderTaskFilter} AsyncQueueSenderTaskFilter
                     */
                    AsyncQueueSenderTaskFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.AsyncQueueSenderTaskFilter();
                        switch (object.state) {
                        case "UNKNOWN":
                        case 0:
                            message.state = 0;
                            break;
                        case "WAITING_TO_SEND":
                        case 1:
                            message.state = 1;
                            break;
                        case "SENT":
                        case 2:
                            message.state = 2;
                            break;
                        }
                        if (object.maxCreateTimeMs != null)
                            if ($util.Long)
                                (message.maxCreateTimeMs = $util.Long.fromValue(object.maxCreateTimeMs)).unsigned = false;
                            else if (typeof object.maxCreateTimeMs === "string")
                                message.maxCreateTimeMs = parseInt(object.maxCreateTimeMs, 10);
                            else if (typeof object.maxCreateTimeMs === "number")
                                message.maxCreateTimeMs = object.maxCreateTimeMs;
                            else if (typeof object.maxCreateTimeMs === "object")
                                message.maxCreateTimeMs = new $util.LongBits(object.maxCreateTimeMs.low >>> 0, object.maxCreateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AsyncQueueSenderTaskFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @static
                     * @param {palexy.streaming.v1.AsyncQueueSenderTaskFilter} message AsyncQueueSenderTaskFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AsyncQueueSenderTaskFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.state = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.maxCreateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.maxCreateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.AsyncQueueSenderTask.AsyncQueueSenderTaskState[message.state] : message.state;
                        if (message.maxCreateTimeMs != null && message.hasOwnProperty("maxCreateTimeMs"))
                            if (typeof message.maxCreateTimeMs === "number")
                                object.maxCreateTimeMs = options.longs === String ? String(message.maxCreateTimeMs) : message.maxCreateTimeMs;
                            else
                                object.maxCreateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.maxCreateTimeMs) : options.longs === Number ? new $util.LongBits(message.maxCreateTimeMs.low >>> 0, message.maxCreateTimeMs.high >>> 0).toNumber() : message.maxCreateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this AsyncQueueSenderTaskFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AsyncQueueSenderTaskFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AsyncQueueSenderTaskFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AsyncQueueSenderTaskFilter;
                })();
    
                v1.ListAsyncQueueSenderTasksResponse = (function() {
    
                    /**
                     * Properties of a ListAsyncQueueSenderTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListAsyncQueueSenderTasksResponse
                     * @property {Array.<palexy.streaming.v1.IAsyncQueueSenderTask>|null} [tasks] ListAsyncQueueSenderTasksResponse tasks
                     * @property {number|null} [totalElements] ListAsyncQueueSenderTasksResponse totalElements
                     * @property {string|null} [nextPageToken] ListAsyncQueueSenderTasksResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListAsyncQueueSenderTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListAsyncQueueSenderTasksResponse.
                     * @implements IListAsyncQueueSenderTasksResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksResponse=} [properties] Properties to set
                     */
                    function ListAsyncQueueSenderTasksResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAsyncQueueSenderTasksResponse tasks.
                     * @member {Array.<palexy.streaming.v1.IAsyncQueueSenderTask>} tasks
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @instance
                     */
                    ListAsyncQueueSenderTasksResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * ListAsyncQueueSenderTasksResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @instance
                     */
                    ListAsyncQueueSenderTasksResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListAsyncQueueSenderTasksResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @instance
                     */
                    ListAsyncQueueSenderTasksResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListAsyncQueueSenderTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} ListAsyncQueueSenderTasksResponse instance
                     */
                    ListAsyncQueueSenderTasksResponse.create = function create(properties) {
                        return new ListAsyncQueueSenderTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAsyncQueueSenderTasksResponse message. Does not implicitly {@link palexy.streaming.v1.ListAsyncQueueSenderTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksResponse} message ListAsyncQueueSenderTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncQueueSenderTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.streaming.v1.AsyncQueueSenderTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAsyncQueueSenderTasksResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListAsyncQueueSenderTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListAsyncQueueSenderTasksResponse} message ListAsyncQueueSenderTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAsyncQueueSenderTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAsyncQueueSenderTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} ListAsyncQueueSenderTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncQueueSenderTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListAsyncQueueSenderTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.streaming.v1.AsyncQueueSenderTask.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAsyncQueueSenderTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} ListAsyncQueueSenderTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAsyncQueueSenderTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAsyncQueueSenderTasksResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAsyncQueueSenderTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncQueueSenderTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAsyncQueueSenderTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} ListAsyncQueueSenderTasksResponse
                     */
                    ListAsyncQueueSenderTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListAsyncQueueSenderTasksResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListAsyncQueueSenderTasksResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.streaming.v1.ListAsyncQueueSenderTasksResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListAsyncQueueSenderTasksResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.streaming.v1.AsyncQueueSenderTask.fromObject(object.tasks[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAsyncQueueSenderTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.ListAsyncQueueSenderTasksResponse} message ListAsyncQueueSenderTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAsyncQueueSenderTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.streaming.v1.AsyncQueueSenderTask.toObject(message.tasks[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListAsyncQueueSenderTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListAsyncQueueSenderTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAsyncQueueSenderTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAsyncQueueSenderTasksResponse;
                })();
    
                v1.BatchDeleteTasksRequest = (function() {
    
                    /**
                     * Properties of a BatchDeleteTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDeleteTasksRequest
                     * @property {Array.<number>|null} [taskIds] BatchDeleteTasksRequest taskIds
                     */
    
                    /**
                     * Constructs a new BatchDeleteTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDeleteTasksRequest.
                     * @implements IBatchDeleteTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest=} [properties] Properties to set
                     */
                    function BatchDeleteTasksRequest(properties) {
                        this.taskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteTasksRequest taskIds.
                     * @member {Array.<number>} taskIds
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @instance
                     */
                    BatchDeleteTasksRequest.prototype.taskIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDeleteTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDeleteTasksRequest} BatchDeleteTasksRequest instance
                     */
                    BatchDeleteTasksRequest.create = function create(properties) {
                        return new BatchDeleteTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteTasksRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDeleteTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest} message BatchDeleteTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskIds != null && message.taskIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.taskIds.length; ++i)
                                writer.int64(message.taskIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDeleteTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteTasksRequest} message BatchDeleteTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDeleteTasksRequest} BatchDeleteTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDeleteTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.taskIds && message.taskIds.length))
                                    message.taskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.taskIds.push(reader.int64());
                                } else
                                    message.taskIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDeleteTasksRequest} BatchDeleteTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskIds != null && message.hasOwnProperty("taskIds")) {
                            if (!Array.isArray(message.taskIds))
                                return "taskIds: array expected";
                            for (var i = 0; i < message.taskIds.length; ++i)
                                if (!$util.isInteger(message.taskIds[i]) && !(message.taskIds[i] && $util.isInteger(message.taskIds[i].low) && $util.isInteger(message.taskIds[i].high)))
                                    return "taskIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDeleteTasksRequest} BatchDeleteTasksRequest
                     */
                    BatchDeleteTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDeleteTasksRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDeleteTasksRequest();
                        if (object.taskIds) {
                            if (!Array.isArray(object.taskIds))
                                throw TypeError(".palexy.streaming.v1.BatchDeleteTasksRequest.taskIds: array expected");
                            message.taskIds = [];
                            for (var i = 0; i < object.taskIds.length; ++i)
                                if ($util.Long)
                                    (message.taskIds[i] = $util.Long.fromValue(object.taskIds[i])).unsigned = false;
                                else if (typeof object.taskIds[i] === "string")
                                    message.taskIds[i] = parseInt(object.taskIds[i], 10);
                                else if (typeof object.taskIds[i] === "number")
                                    message.taskIds[i] = object.taskIds[i];
                                else if (typeof object.taskIds[i] === "object")
                                    message.taskIds[i] = new $util.LongBits(object.taskIds[i].low >>> 0, object.taskIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDeleteTasksRequest} message BatchDeleteTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskIds = [];
                        if (message.taskIds && message.taskIds.length) {
                            object.taskIds = [];
                            for (var j = 0; j < message.taskIds.length; ++j)
                                if (typeof message.taskIds[j] === "number")
                                    object.taskIds[j] = options.longs === String ? String(message.taskIds[j]) : message.taskIds[j];
                                else
                                    object.taskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.taskIds[j]) : options.longs === Number ? new $util.LongBits(message.taskIds[j].low >>> 0, message.taskIds[j].high >>> 0).toNumber() : message.taskIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDeleteTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteTasksRequest;
                })();
    
                v1.AsyncQueueSenderExecuteTaskRequest = (function() {
    
                    /**
                     * Properties of an AsyncQueueSenderExecuteTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IAsyncQueueSenderExecuteTaskRequest
                     * @property {number|null} [taskId] AsyncQueueSenderExecuteTaskRequest taskId
                     */
    
                    /**
                     * Constructs a new AsyncQueueSenderExecuteTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncQueueSenderExecuteTaskRequest.
                     * @implements IAsyncQueueSenderExecuteTaskRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest=} [properties] Properties to set
                     */
                    function AsyncQueueSenderExecuteTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AsyncQueueSenderExecuteTaskRequest taskId.
                     * @member {number} taskId
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @instance
                     */
                    AsyncQueueSenderExecuteTaskRequest.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AsyncQueueSenderExecuteTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest} AsyncQueueSenderExecuteTaskRequest instance
                     */
                    AsyncQueueSenderExecuteTaskRequest.create = function create(properties) {
                        return new AsyncQueueSenderExecuteTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderExecuteTaskRequest message. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest} message AsyncQueueSenderExecuteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderExecuteTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.taskId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AsyncQueueSenderExecuteTaskRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IAsyncQueueSenderExecuteTaskRequest} message AsyncQueueSenderExecuteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncQueueSenderExecuteTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderExecuteTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest} AsyncQueueSenderExecuteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderExecuteTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AsyncQueueSenderExecuteTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest} AsyncQueueSenderExecuteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncQueueSenderExecuteTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AsyncQueueSenderExecuteTaskRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AsyncQueueSenderExecuteTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AsyncQueueSenderExecuteTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest} AsyncQueueSenderExecuteTaskRequest
                     */
                    AsyncQueueSenderExecuteTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AsyncQueueSenderExecuteTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest} message AsyncQueueSenderExecuteTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AsyncQueueSenderExecuteTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        return object;
                    };
    
                    /**
                     * Converts this AsyncQueueSenderExecuteTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AsyncQueueSenderExecuteTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AsyncQueueSenderExecuteTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AsyncQueueSenderExecuteTaskRequest;
                })();
    
                v1.ExportReportConfigService = (function() {
    
                    /**
                     * Constructs a new ExportReportConfigService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportReportConfigService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ExportReportConfigService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ExportReportConfigService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ExportReportConfigService;
    
                    /**
                     * Creates new ExportReportConfigService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ExportReportConfigService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ExportReportConfigService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportReportConfigService#createExportReportConfig}.
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @typedef CreateExportReportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportReportConfig} [response] ExportReportConfig
                     */
    
                    /**
                     * Calls CreateExportReportConfig.
                     * @function createExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IExportReportConfig} request ExportReportConfig message or plain object
                     * @param {palexy.streaming.v1.ExportReportConfigService.CreateExportReportConfigCallback} callback Node-style callback called with the error, if any, and ExportReportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportReportConfigService.prototype.createExportReportConfig = function createExportReportConfig(request, callback) {
                        return this.rpcCall(createExportReportConfig, $root.palexy.streaming.v1.ExportReportConfig, $root.palexy.streaming.v1.ExportReportConfig, request, callback);
                    }, "name", { value: "CreateExportReportConfig" });
    
                    /**
                     * Calls CreateExportReportConfig.
                     * @function createExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IExportReportConfig} request ExportReportConfig message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportReportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportReportConfigService#updateExportReportConfig}.
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @typedef UpdateExportReportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportReportConfig} [response] ExportReportConfig
                     */
    
                    /**
                     * Calls UpdateExportReportConfig.
                     * @function updateExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest} request UpdateExportReportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.ExportReportConfigService.UpdateExportReportConfigCallback} callback Node-style callback called with the error, if any, and ExportReportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportReportConfigService.prototype.updateExportReportConfig = function updateExportReportConfig(request, callback) {
                        return this.rpcCall(updateExportReportConfig, $root.palexy.streaming.v1.UpdateExportReportConfigRequest, $root.palexy.streaming.v1.ExportReportConfig, request, callback);
                    }, "name", { value: "UpdateExportReportConfig" });
    
                    /**
                     * Calls UpdateExportReportConfig.
                     * @function updateExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest} request UpdateExportReportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportReportConfig>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportReportConfigService#deleteExportReportConfig}.
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @typedef DeleteExportReportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteExportReportConfig.
                     * @function deleteExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest} request DeleteExportReportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.ExportReportConfigService.DeleteExportReportConfigCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportReportConfigService.prototype.deleteExportReportConfig = function deleteExportReportConfig(request, callback) {
                        return this.rpcCall(deleteExportReportConfig, $root.palexy.streaming.v1.DeleteExportReportConfigRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteExportReportConfig" });
    
                    /**
                     * Calls DeleteExportReportConfig.
                     * @function deleteExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest} request DeleteExportReportConfigRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportReportConfigService#listExportReportConfig}.
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @typedef ListExportReportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListExportReportConfigResponse} [response] ListExportReportConfigResponse
                     */
    
                    /**
                     * Calls ListExportReportConfig.
                     * @function listExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest} request ListExportReportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.ExportReportConfigService.ListExportReportConfigCallback} callback Node-style callback called with the error, if any, and ListExportReportConfigResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportReportConfigService.prototype.listExportReportConfig = function listExportReportConfig(request, callback) {
                        return this.rpcCall(listExportReportConfig, $root.palexy.streaming.v1.ListExportReportConfigRequest, $root.palexy.streaming.v1.ListExportReportConfigResponse, request, callback);
                    }, "name", { value: "ListExportReportConfig" });
    
                    /**
                     * Calls ListExportReportConfig.
                     * @function listExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest} request ListExportReportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListExportReportConfigResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ExportReportConfigService#getExportReportConfig}.
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @typedef GetExportReportConfigCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExportReportConfig} [response] ExportReportConfig
                     */
    
                    /**
                     * Calls GetExportReportConfig.
                     * @function getExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest} request GetExportReportConfigRequest message or plain object
                     * @param {palexy.streaming.v1.ExportReportConfigService.GetExportReportConfigCallback} callback Node-style callback called with the error, if any, and ExportReportConfig
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ExportReportConfigService.prototype.getExportReportConfig = function getExportReportConfig(request, callback) {
                        return this.rpcCall(getExportReportConfig, $root.palexy.streaming.v1.GetExportReportConfigRequest, $root.palexy.streaming.v1.ExportReportConfig, request, callback);
                    }, "name", { value: "GetExportReportConfig" });
    
                    /**
                     * Calls GetExportReportConfig.
                     * @function getExportReportConfig
                     * @memberof palexy.streaming.v1.ExportReportConfigService
                     * @instance
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest} request GetExportReportConfigRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExportReportConfig>} Promise
                     * @variation 2
                     */
    
                    return ExportReportConfigService;
                })();
    
                v1.UpdateExportReportConfigRequest = (function() {
    
                    /**
                     * Properties of an UpdateExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateExportReportConfigRequest
                     * @property {palexy.streaming.v1.IExportReportConfig|null} [config] UpdateExportReportConfigRequest config
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateExportReportConfigRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateExportReportConfigRequest.
                     * @implements IUpdateExportReportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest=} [properties] Properties to set
                     */
                    function UpdateExportReportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateExportReportConfigRequest config.
                     * @member {palexy.streaming.v1.IExportReportConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @instance
                     */
                    UpdateExportReportConfigRequest.prototype.config = null;
    
                    /**
                     * UpdateExportReportConfigRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @instance
                     */
                    UpdateExportReportConfigRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateExportReportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateExportReportConfigRequest} UpdateExportReportConfigRequest instance
                     */
                    UpdateExportReportConfigRequest.create = function create(properties) {
                        return new UpdateExportReportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateExportReportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateExportReportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest} message UpdateExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExportReportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.ExportReportConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateExportReportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateExportReportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateExportReportConfigRequest} message UpdateExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateExportReportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateExportReportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateExportReportConfigRequest} UpdateExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExportReportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateExportReportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.streaming.v1.ExportReportConfig.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateExportReportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateExportReportConfigRequest} UpdateExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateExportReportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateExportReportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateExportReportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.ExportReportConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateExportReportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateExportReportConfigRequest} UpdateExportReportConfigRequest
                     */
                    UpdateExportReportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateExportReportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateExportReportConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateExportReportConfigRequest.config: object expected");
                            message.config = $root.palexy.streaming.v1.ExportReportConfig.fromObject(object.config);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateExportReportConfigRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateExportReportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateExportReportConfigRequest} message UpdateExportReportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateExportReportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.config = null;
                            object.updateMask = null;
                        }
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.ExportReportConfig.toObject(message.config, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateExportReportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateExportReportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateExportReportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateExportReportConfigRequest;
                })();
    
                v1.DeleteExportReportConfigRequest = (function() {
    
                    /**
                     * Properties of a DeleteExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteExportReportConfigRequest
                     * @property {number|null} [configId] DeleteExportReportConfigRequest configId
                     */
    
                    /**
                     * Constructs a new DeleteExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteExportReportConfigRequest.
                     * @implements IDeleteExportReportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest=} [properties] Properties to set
                     */
                    function DeleteExportReportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteExportReportConfigRequest configId.
                     * @member {number} configId
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @instance
                     */
                    DeleteExportReportConfigRequest.prototype.configId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteExportReportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteExportReportConfigRequest} DeleteExportReportConfigRequest instance
                     */
                    DeleteExportReportConfigRequest.create = function create(properties) {
                        return new DeleteExportReportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteExportReportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteExportReportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest} message DeleteExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportReportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configId != null && Object.hasOwnProperty.call(message, "configId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.configId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteExportReportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteExportReportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteExportReportConfigRequest} message DeleteExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteExportReportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteExportReportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteExportReportConfigRequest} DeleteExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportReportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteExportReportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteExportReportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteExportReportConfigRequest} DeleteExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteExportReportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteExportReportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteExportReportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (!$util.isInteger(message.configId) && !(message.configId && $util.isInteger(message.configId.low) && $util.isInteger(message.configId.high)))
                                return "configId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteExportReportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteExportReportConfigRequest} DeleteExportReportConfigRequest
                     */
                    DeleteExportReportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteExportReportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteExportReportConfigRequest();
                        if (object.configId != null)
                            if ($util.Long)
                                (message.configId = $util.Long.fromValue(object.configId)).unsigned = false;
                            else if (typeof object.configId === "string")
                                message.configId = parseInt(object.configId, 10);
                            else if (typeof object.configId === "number")
                                message.configId = object.configId;
                            else if (typeof object.configId === "object")
                                message.configId = new $util.LongBits(object.configId.low >>> 0, object.configId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteExportReportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteExportReportConfigRequest} message DeleteExportReportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteExportReportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.configId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.configId = options.longs === String ? "0" : 0;
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (typeof message.configId === "number")
                                object.configId = options.longs === String ? String(message.configId) : message.configId;
                            else
                                object.configId = options.longs === String ? $util.Long.prototype.toString.call(message.configId) : options.longs === Number ? new $util.LongBits(message.configId.low >>> 0, message.configId.high >>> 0).toNumber() : message.configId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteExportReportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteExportReportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteExportReportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteExportReportConfigRequest;
                })();
    
                v1.ListExportReportConfigRequest = (function() {
    
                    /**
                     * Properties of a ListExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListExportReportConfigRequest
                     * @property {number|null} [companyId] ListExportReportConfigRequest companyId
                     * @property {number|null} [pageSize] ListExportReportConfigRequest pageSize
                     * @property {string|null} [pageToken] ListExportReportConfigRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListExportReportConfigRequest.
                     * @implements IListExportReportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest=} [properties] Properties to set
                     */
                    function ListExportReportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExportReportConfigRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @instance
                     */
                    ListExportReportConfigRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListExportReportConfigRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @instance
                     */
                    ListExportReportConfigRequest.prototype.pageSize = 0;
    
                    /**
                     * ListExportReportConfigRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @instance
                     */
                    ListExportReportConfigRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListExportReportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListExportReportConfigRequest} ListExportReportConfigRequest instance
                     */
                    ListExportReportConfigRequest.create = function create(properties) {
                        return new ListExportReportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListExportReportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.ListExportReportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest} message ListExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExportReportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExportReportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListExportReportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigRequest} message ListExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExportReportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExportReportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListExportReportConfigRequest} ListExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExportReportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListExportReportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExportReportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListExportReportConfigRequest} ListExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExportReportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExportReportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExportReportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExportReportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListExportReportConfigRequest} ListExportReportConfigRequest
                     */
                    ListExportReportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListExportReportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListExportReportConfigRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExportReportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ListExportReportConfigRequest} message ListExportReportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExportReportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListExportReportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListExportReportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExportReportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExportReportConfigRequest;
                })();
    
                v1.ListExportReportConfigResponse = (function() {
    
                    /**
                     * Properties of a ListExportReportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListExportReportConfigResponse
                     * @property {Array.<palexy.streaming.v1.IExportReportConfig>|null} [configs] ListExportReportConfigResponse configs
                     * @property {string|null} [nextPageToken] ListExportReportConfigResponse nextPageToken
                     * @property {number|null} [totalElements] ListExportReportConfigResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListExportReportConfigResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListExportReportConfigResponse.
                     * @implements IListExportReportConfigResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListExportReportConfigResponse=} [properties] Properties to set
                     */
                    function ListExportReportConfigResponse(properties) {
                        this.configs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListExportReportConfigResponse configs.
                     * @member {Array.<palexy.streaming.v1.IExportReportConfig>} configs
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @instance
                     */
                    ListExportReportConfigResponse.prototype.configs = $util.emptyArray;
    
                    /**
                     * ListExportReportConfigResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @instance
                     */
                    ListExportReportConfigResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListExportReportConfigResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @instance
                     */
                    ListExportReportConfigResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListExportReportConfigResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListExportReportConfigResponse} ListExportReportConfigResponse instance
                     */
                    ListExportReportConfigResponse.create = function create(properties) {
                        return new ListExportReportConfigResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListExportReportConfigResponse message. Does not implicitly {@link palexy.streaming.v1.ListExportReportConfigResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigResponse} message ListExportReportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExportReportConfigResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configs != null && message.configs.length)
                            for (var i = 0; i < message.configs.length; ++i)
                                $root.palexy.streaming.v1.ExportReportConfig.encode(message.configs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListExportReportConfigResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListExportReportConfigResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.IListExportReportConfigResponse} message ListExportReportConfigResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListExportReportConfigResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListExportReportConfigResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListExportReportConfigResponse} ListExportReportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExportReportConfigResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListExportReportConfigResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.configs && message.configs.length))
                                    message.configs = [];
                                message.configs.push($root.palexy.streaming.v1.ExportReportConfig.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListExportReportConfigResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListExportReportConfigResponse} ListExportReportConfigResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListExportReportConfigResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListExportReportConfigResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListExportReportConfigResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configs != null && message.hasOwnProperty("configs")) {
                            if (!Array.isArray(message.configs))
                                return "configs: array expected";
                            for (var i = 0; i < message.configs.length; ++i) {
                                var error = $root.palexy.streaming.v1.ExportReportConfig.verify(message.configs[i]);
                                if (error)
                                    return "configs." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListExportReportConfigResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListExportReportConfigResponse} ListExportReportConfigResponse
                     */
                    ListExportReportConfigResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListExportReportConfigResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListExportReportConfigResponse();
                        if (object.configs) {
                            if (!Array.isArray(object.configs))
                                throw TypeError(".palexy.streaming.v1.ListExportReportConfigResponse.configs: array expected");
                            message.configs = [];
                            for (var i = 0; i < object.configs.length; ++i) {
                                if (typeof object.configs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListExportReportConfigResponse.configs: object expected");
                                message.configs[i] = $root.palexy.streaming.v1.ExportReportConfig.fromObject(object.configs[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListExportReportConfigResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @static
                     * @param {palexy.streaming.v1.ListExportReportConfigResponse} message ListExportReportConfigResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListExportReportConfigResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.configs = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.configs && message.configs.length) {
                            object.configs = [];
                            for (var j = 0; j < message.configs.length; ++j)
                                object.configs[j] = $root.palexy.streaming.v1.ExportReportConfig.toObject(message.configs[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListExportReportConfigResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListExportReportConfigResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListExportReportConfigResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListExportReportConfigResponse;
                })();
    
                v1.GetExportReportConfigRequest = (function() {
    
                    /**
                     * Properties of a GetExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetExportReportConfigRequest
                     * @property {number|null} [configId] GetExportReportConfigRequest configId
                     */
    
                    /**
                     * Constructs a new GetExportReportConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetExportReportConfigRequest.
                     * @implements IGetExportReportConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest=} [properties] Properties to set
                     */
                    function GetExportReportConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetExportReportConfigRequest configId.
                     * @member {number} configId
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @instance
                     */
                    GetExportReportConfigRequest.prototype.configId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetExportReportConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetExportReportConfigRequest} GetExportReportConfigRequest instance
                     */
                    GetExportReportConfigRequest.create = function create(properties) {
                        return new GetExportReportConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetExportReportConfigRequest message. Does not implicitly {@link palexy.streaming.v1.GetExportReportConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest} message GetExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExportReportConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configId != null && Object.hasOwnProperty.call(message, "configId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.configId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetExportReportConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetExportReportConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetExportReportConfigRequest} message GetExportReportConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetExportReportConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetExportReportConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetExportReportConfigRequest} GetExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExportReportConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetExportReportConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.configId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetExportReportConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetExportReportConfigRequest} GetExportReportConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetExportReportConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetExportReportConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetExportReportConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (!$util.isInteger(message.configId) && !(message.configId && $util.isInteger(message.configId.low) && $util.isInteger(message.configId.high)))
                                return "configId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetExportReportConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetExportReportConfigRequest} GetExportReportConfigRequest
                     */
                    GetExportReportConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetExportReportConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetExportReportConfigRequest();
                        if (object.configId != null)
                            if ($util.Long)
                                (message.configId = $util.Long.fromValue(object.configId)).unsigned = false;
                            else if (typeof object.configId === "string")
                                message.configId = parseInt(object.configId, 10);
                            else if (typeof object.configId === "number")
                                message.configId = object.configId;
                            else if (typeof object.configId === "object")
                                message.configId = new $util.LongBits(object.configId.low >>> 0, object.configId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetExportReportConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.GetExportReportConfigRequest} message GetExportReportConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetExportReportConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.configId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.configId = options.longs === String ? "0" : 0;
                        if (message.configId != null && message.hasOwnProperty("configId"))
                            if (typeof message.configId === "number")
                                object.configId = options.longs === String ? String(message.configId) : message.configId;
                            else
                                object.configId = options.longs === String ? $util.Long.prototype.toString.call(message.configId) : options.longs === Number ? new $util.LongBits(message.configId.low >>> 0, message.configId.high >>> 0).toNumber() : message.configId;
                        return object;
                    };
    
                    /**
                     * Converts this GetExportReportConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetExportReportConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetExportReportConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetExportReportConfigRequest;
                })();
    
                v1.ExportReportConfig = (function() {
    
                    /**
                     * Properties of an ExportReportConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IExportReportConfig
                     * @property {number|null} [id] ExportReportConfig id
                     * @property {number|null} [companyId] ExportReportConfig companyId
                     * @property {string|null} [reportName] ExportReportConfig reportName
                     * @property {palexy.streaming.v1.IGetReportRequest|null} [reportRequest] ExportReportConfig reportRequest
                     * @property {palexy.streaming.v1.ExportReportConfig.FileFormat|null} [format] ExportReportConfig format
                     * @property {palexy.streaming.v1.ExportReportConfig.StorageProvider|null} [storageProvider] ExportReportConfig storageProvider
                     * @property {number|null} [createTimeMs] ExportReportConfig createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] ExportReportConfig lastUpdateTimeMs
                     * @property {palexy.streaming.v1.ExportReportConfig.ISftpConfig|null} [sftpConfig] ExportReportConfig sftpConfig
                     */
    
                    /**
                     * Constructs a new ExportReportConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExportReportConfig.
                     * @implements IExportReportConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IExportReportConfig=} [properties] Properties to set
                     */
                    function ExportReportConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExportReportConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportReportConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportReportConfig reportName.
                     * @member {string} reportName
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.reportName = "";
    
                    /**
                     * ExportReportConfig reportRequest.
                     * @member {palexy.streaming.v1.IGetReportRequest|null|undefined} reportRequest
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.reportRequest = null;
    
                    /**
                     * ExportReportConfig format.
                     * @member {palexy.streaming.v1.ExportReportConfig.FileFormat} format
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.format = 0;
    
                    /**
                     * ExportReportConfig storageProvider.
                     * @member {palexy.streaming.v1.ExportReportConfig.StorageProvider} storageProvider
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.storageProvider = 0;
    
                    /**
                     * ExportReportConfig createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportReportConfig lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ExportReportConfig sftpConfig.
                     * @member {palexy.streaming.v1.ExportReportConfig.ISftpConfig|null|undefined} sftpConfig
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    ExportReportConfig.prototype.sftpConfig = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * ExportReportConfig storageConfig.
                     * @member {"sftpConfig"|undefined} storageConfig
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     */
                    Object.defineProperty(ExportReportConfig.prototype, "storageConfig", {
                        get: $util.oneOfGetter($oneOfFields = ["sftpConfig"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new ExportReportConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {palexy.streaming.v1.IExportReportConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExportReportConfig} ExportReportConfig instance
                     */
                    ExportReportConfig.create = function create(properties) {
                        return new ExportReportConfig(properties);
                    };
    
                    /**
                     * Encodes the specified ExportReportConfig message. Does not implicitly {@link palexy.streaming.v1.ExportReportConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {palexy.streaming.v1.IExportReportConfig} message ExportReportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.reportName != null && Object.hasOwnProperty.call(message, "reportName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.reportName);
                        if (message.reportRequest != null && Object.hasOwnProperty.call(message, "reportRequest"))
                            $root.palexy.streaming.v1.GetReportRequest.encode(message.reportRequest, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.format);
                        if (message.storageProvider != null && Object.hasOwnProperty.call(message, "storageProvider"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.storageProvider);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                        if (message.sftpConfig != null && Object.hasOwnProperty.call(message, "sftpConfig"))
                            $root.palexy.streaming.v1.ExportReportConfig.SftpConfig.encode(message.sftpConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExportReportConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportReportConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {palexy.streaming.v1.IExportReportConfig} message ExportReportConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExportReportConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExportReportConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExportReportConfig} ExportReportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportReportConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.reportName = reader.string();
                                break;
                            case 4:
                                message.reportRequest = $root.palexy.streaming.v1.GetReportRequest.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.format = reader.int32();
                                break;
                            case 6:
                                message.storageProvider = reader.int32();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 9:
                                message.sftpConfig = $root.palexy.streaming.v1.ExportReportConfig.SftpConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExportReportConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExportReportConfig} ExportReportConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExportReportConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExportReportConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExportReportConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.reportName != null && message.hasOwnProperty("reportName"))
                            if (!$util.isString(message.reportName))
                                return "reportName: string expected";
                        if (message.reportRequest != null && message.hasOwnProperty("reportRequest")) {
                            var error = $root.palexy.streaming.v1.GetReportRequest.verify(message.reportRequest);
                            if (error)
                                return "reportRequest." + error;
                        }
                        if (message.format != null && message.hasOwnProperty("format"))
                            switch (message.format) {
                            default:
                                return "format: enum value expected";
                            case 0:
                                break;
                            }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            switch (message.storageProvider) {
                            default:
                                return "storageProvider: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.sftpConfig != null && message.hasOwnProperty("sftpConfig")) {
                            properties.storageConfig = 1;
                            {
                                var error = $root.palexy.streaming.v1.ExportReportConfig.SftpConfig.verify(message.sftpConfig);
                                if (error)
                                    return "sftpConfig." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExportReportConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExportReportConfig} ExportReportConfig
                     */
                    ExportReportConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExportReportConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExportReportConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.reportName != null)
                            message.reportName = String(object.reportName);
                        if (object.reportRequest != null) {
                            if (typeof object.reportRequest !== "object")
                                throw TypeError(".palexy.streaming.v1.ExportReportConfig.reportRequest: object expected");
                            message.reportRequest = $root.palexy.streaming.v1.GetReportRequest.fromObject(object.reportRequest);
                        }
                        switch (object.format) {
                        case "CSV":
                        case 0:
                            message.format = 0;
                            break;
                        }
                        switch (object.storageProvider) {
                        case "UNKNOWN":
                        case 0:
                            message.storageProvider = 0;
                            break;
                        case "SFTP":
                        case 1:
                            message.storageProvider = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.sftpConfig != null) {
                            if (typeof object.sftpConfig !== "object")
                                throw TypeError(".palexy.streaming.v1.ExportReportConfig.sftpConfig: object expected");
                            message.sftpConfig = $root.palexy.streaming.v1.ExportReportConfig.SftpConfig.fromObject(object.sftpConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExportReportConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @static
                     * @param {palexy.streaming.v1.ExportReportConfig} message ExportReportConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExportReportConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.reportName = "";
                            object.reportRequest = null;
                            object.format = options.enums === String ? "CSV" : 0;
                            object.storageProvider = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.reportName != null && message.hasOwnProperty("reportName"))
                            object.reportName = message.reportName;
                        if (message.reportRequest != null && message.hasOwnProperty("reportRequest"))
                            object.reportRequest = $root.palexy.streaming.v1.GetReportRequest.toObject(message.reportRequest, options);
                        if (message.format != null && message.hasOwnProperty("format"))
                            object.format = options.enums === String ? $root.palexy.streaming.v1.ExportReportConfig.FileFormat[message.format] : message.format;
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            object.storageProvider = options.enums === String ? $root.palexy.streaming.v1.ExportReportConfig.StorageProvider[message.storageProvider] : message.storageProvider;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.sftpConfig != null && message.hasOwnProperty("sftpConfig")) {
                            object.sftpConfig = $root.palexy.streaming.v1.ExportReportConfig.SftpConfig.toObject(message.sftpConfig, options);
                            if (options.oneofs)
                                object.storageConfig = "sftpConfig";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExportReportConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExportReportConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExportReportConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FileFormat enum.
                     * @name palexy.streaming.v1.ExportReportConfig.FileFormat
                     * @enum {number}
                     * @property {number} CSV=0 CSV value
                     */
                    ExportReportConfig.FileFormat = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "CSV"] = 0;
                        return values;
                    })();
    
                    /**
                     * StorageProvider enum.
                     * @name palexy.streaming.v1.ExportReportConfig.StorageProvider
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} SFTP=1 SFTP value
                     */
                    ExportReportConfig.StorageProvider = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "SFTP"] = 1;
                        return values;
                    })();
    
                    ExportReportConfig.SftpConfig = (function() {
    
                        /**
                         * Properties of a SftpConfig.
                         * @memberof palexy.streaming.v1.ExportReportConfig
                         * @interface ISftpConfig
                         * @property {string|null} [baseUrl] SftpConfig baseUrl
                         * @property {string|null} [username] SftpConfig username
                         * @property {string|null} [password] SftpConfig password
                         * @property {string|null} [integrationKey] SftpConfig integrationKey
                         */
    
                        /**
                         * Constructs a new SftpConfig.
                         * @memberof palexy.streaming.v1.ExportReportConfig
                         * @classdesc Represents a SftpConfig.
                         * @implements ISftpConfig
                         * @constructor
                         * @param {palexy.streaming.v1.ExportReportConfig.ISftpConfig=} [properties] Properties to set
                         */
                        function SftpConfig(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * SftpConfig baseUrl.
                         * @member {string} baseUrl
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @instance
                         */
                        SftpConfig.prototype.baseUrl = "";
    
                        /**
                         * SftpConfig username.
                         * @member {string} username
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @instance
                         */
                        SftpConfig.prototype.username = "";
    
                        /**
                         * SftpConfig password.
                         * @member {string} password
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @instance
                         */
                        SftpConfig.prototype.password = "";
    
                        /**
                         * SftpConfig integrationKey.
                         * @member {string} integrationKey
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @instance
                         */
                        SftpConfig.prototype.integrationKey = "";
    
                        /**
                         * Creates a new SftpConfig instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {palexy.streaming.v1.ExportReportConfig.ISftpConfig=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ExportReportConfig.SftpConfig} SftpConfig instance
                         */
                        SftpConfig.create = function create(properties) {
                            return new SftpConfig(properties);
                        };
    
                        /**
                         * Encodes the specified SftpConfig message. Does not implicitly {@link palexy.streaming.v1.ExportReportConfig.SftpConfig.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {palexy.streaming.v1.ExportReportConfig.ISftpConfig} message SftpConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SftpConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.baseUrl != null && Object.hasOwnProperty.call(message, "baseUrl"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.baseUrl);
                            if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                            if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.password);
                            if (message.integrationKey != null && Object.hasOwnProperty.call(message, "integrationKey"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.integrationKey);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified SftpConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExportReportConfig.SftpConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {palexy.streaming.v1.ExportReportConfig.ISftpConfig} message SftpConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        SftpConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a SftpConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ExportReportConfig.SftpConfig} SftpConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SftpConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExportReportConfig.SftpConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.baseUrl = reader.string();
                                    break;
                                case 2:
                                    message.username = reader.string();
                                    break;
                                case 3:
                                    message.password = reader.string();
                                    break;
                                case 4:
                                    message.integrationKey = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a SftpConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ExportReportConfig.SftpConfig} SftpConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        SftpConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a SftpConfig message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        SftpConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                                if (!$util.isString(message.baseUrl))
                                    return "baseUrl: string expected";
                            if (message.username != null && message.hasOwnProperty("username"))
                                if (!$util.isString(message.username))
                                    return "username: string expected";
                            if (message.password != null && message.hasOwnProperty("password"))
                                if (!$util.isString(message.password))
                                    return "password: string expected";
                            if (message.integrationKey != null && message.hasOwnProperty("integrationKey"))
                                if (!$util.isString(message.integrationKey))
                                    return "integrationKey: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a SftpConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ExportReportConfig.SftpConfig} SftpConfig
                         */
                        SftpConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ExportReportConfig.SftpConfig)
                                return object;
                            var message = new $root.palexy.streaming.v1.ExportReportConfig.SftpConfig();
                            if (object.baseUrl != null)
                                message.baseUrl = String(object.baseUrl);
                            if (object.username != null)
                                message.username = String(object.username);
                            if (object.password != null)
                                message.password = String(object.password);
                            if (object.integrationKey != null)
                                message.integrationKey = String(object.integrationKey);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a SftpConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @static
                         * @param {palexy.streaming.v1.ExportReportConfig.SftpConfig} message SftpConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        SftpConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.baseUrl = "";
                                object.username = "";
                                object.password = "";
                                object.integrationKey = "";
                            }
                            if (message.baseUrl != null && message.hasOwnProperty("baseUrl"))
                                object.baseUrl = message.baseUrl;
                            if (message.username != null && message.hasOwnProperty("username"))
                                object.username = message.username;
                            if (message.password != null && message.hasOwnProperty("password"))
                                object.password = message.password;
                            if (message.integrationKey != null && message.hasOwnProperty("integrationKey"))
                                object.integrationKey = message.integrationKey;
                            return object;
                        };
    
                        /**
                         * Converts this SftpConfig to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ExportReportConfig.SftpConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        SftpConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return SftpConfig;
                    })();
    
                    return ExportReportConfig;
                })();
    
                v1.ForecastTask = (function() {
    
                    /**
                     * Properties of a ForecastTask.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastTask
                     * @property {number|null} [id] ForecastTask id
                     * @property {number|null} [dateId] ForecastTask dateId
                     * @property {Array.<number>|null} [storeIds] ForecastTask storeIds
                     * @property {number|null} [forecastModelId] ForecastTask forecastModelId
                     * @property {number|null} [forecastModelVersionId] ForecastTask forecastModelVersionId
                     * @property {number|null} [forecastingHorizon] ForecastTask forecastingHorizon
                     * @property {palexy.streaming.v1.ForecastTask.State|null} [state] ForecastTask state
                     * @property {palexy.streaming.v1.IForecastTaskResult|null} [result] ForecastTask result
                     * @property {string|null} [errorMessage] ForecastTask errorMessage
                     * @property {number|null} [createTimeMs] ForecastTask createTimeMs
                     * @property {number|null} [updateTimeMs] ForecastTask updateTimeMs
                     */
    
                    /**
                     * Constructs a new ForecastTask.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastTask.
                     * @implements IForecastTask
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastTask=} [properties] Properties to set
                     */
                    function ForecastTask(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastTask id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastTask dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.dateId = 0;
    
                    /**
                     * ForecastTask storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ForecastTask forecastModelId.
                     * @member {number} forecastModelId
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.forecastModelId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastTask forecastModelVersionId.
                     * @member {number} forecastModelVersionId
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.forecastModelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastTask forecastingHorizon.
                     * @member {number} forecastingHorizon
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.forecastingHorizon = 0;
    
                    /**
                     * ForecastTask state.
                     * @member {palexy.streaming.v1.ForecastTask.State} state
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.state = 0;
    
                    /**
                     * ForecastTask result.
                     * @member {palexy.streaming.v1.IForecastTaskResult|null|undefined} result
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.result = null;
    
                    /**
                     * ForecastTask errorMessage.
                     * @member {string} errorMessage
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.errorMessage = "";
    
                    /**
                     * ForecastTask createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastTask updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     */
                    ForecastTask.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ForecastTask instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {palexy.streaming.v1.IForecastTask=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastTask} ForecastTask instance
                     */
                    ForecastTask.create = function create(properties) {
                        return new ForecastTask(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastTask message. Does not implicitly {@link palexy.streaming.v1.ForecastTask.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {palexy.streaming.v1.IForecastTask} message ForecastTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastTask.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.forecastModelId != null && Object.hasOwnProperty.call(message, "forecastModelId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.forecastModelId);
                        if (message.forecastModelVersionId != null && Object.hasOwnProperty.call(message, "forecastModelVersionId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.forecastModelVersionId);
                        if (message.forecastingHorizon != null && Object.hasOwnProperty.call(message, "forecastingHorizon"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.forecastingHorizon);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.state);
                        if (message.result != null && Object.hasOwnProperty.call(message, "result"))
                            $root.palexy.streaming.v1.ForecastTaskResult.encode(message.result, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.errorMessage != null && Object.hasOwnProperty.call(message, "errorMessage"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.errorMessage);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastTask message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastTask.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {palexy.streaming.v1.IForecastTask} message ForecastTask message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastTask.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastTask message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastTask} ForecastTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastTask.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastTask();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 4:
                                message.forecastModelId = reader.int64();
                                break;
                            case 5:
                                message.forecastModelVersionId = reader.int64();
                                break;
                            case 6:
                                message.forecastingHorizon = reader.int32();
                                break;
                            case 7:
                                message.state = reader.int32();
                                break;
                            case 8:
                                message.result = $root.palexy.streaming.v1.ForecastTaskResult.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.errorMessage = reader.string();
                                break;
                            case 10:
                                message.createTimeMs = reader.int64();
                                break;
                            case 11:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastTask message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastTask} ForecastTask
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastTask.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastTask message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastTask.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (!$util.isInteger(message.forecastModelId) && !(message.forecastModelId && $util.isInteger(message.forecastModelId.low) && $util.isInteger(message.forecastModelId.high)))
                                return "forecastModelId: integer|Long expected";
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (!$util.isInteger(message.forecastModelVersionId) && !(message.forecastModelVersionId && $util.isInteger(message.forecastModelVersionId.low) && $util.isInteger(message.forecastModelVersionId.high)))
                                return "forecastModelVersionId: integer|Long expected";
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            if (!$util.isInteger(message.forecastingHorizon))
                                return "forecastingHorizon: integer expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.result != null && message.hasOwnProperty("result")) {
                            var error = $root.palexy.streaming.v1.ForecastTaskResult.verify(message.result);
                            if (error)
                                return "result." + error;
                        }
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            if (!$util.isString(message.errorMessage))
                                return "errorMessage: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastTask message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastTask} ForecastTask
                     */
                    ForecastTask.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastTask)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastTask();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ForecastTask.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.forecastModelId != null)
                            if ($util.Long)
                                (message.forecastModelId = $util.Long.fromValue(object.forecastModelId)).unsigned = false;
                            else if (typeof object.forecastModelId === "string")
                                message.forecastModelId = parseInt(object.forecastModelId, 10);
                            else if (typeof object.forecastModelId === "number")
                                message.forecastModelId = object.forecastModelId;
                            else if (typeof object.forecastModelId === "object")
                                message.forecastModelId = new $util.LongBits(object.forecastModelId.low >>> 0, object.forecastModelId.high >>> 0).toNumber();
                        if (object.forecastModelVersionId != null)
                            if ($util.Long)
                                (message.forecastModelVersionId = $util.Long.fromValue(object.forecastModelVersionId)).unsigned = false;
                            else if (typeof object.forecastModelVersionId === "string")
                                message.forecastModelVersionId = parseInt(object.forecastModelVersionId, 10);
                            else if (typeof object.forecastModelVersionId === "number")
                                message.forecastModelVersionId = object.forecastModelVersionId;
                            else if (typeof object.forecastModelVersionId === "object")
                                message.forecastModelVersionId = new $util.LongBits(object.forecastModelVersionId.low >>> 0, object.forecastModelVersionId.high >>> 0).toNumber();
                        if (object.forecastingHorizon != null)
                            message.forecastingHorizon = object.forecastingHorizon | 0;
                        switch (object.state) {
                        case "UNKNOWN_STATE":
                        case 0:
                            message.state = 0;
                            break;
                        case "CREATED":
                        case 1:
                            message.state = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.state = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.state = 3;
                            break;
                        case "PARTIAL":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        if (object.result != null) {
                            if (typeof object.result !== "object")
                                throw TypeError(".palexy.streaming.v1.ForecastTask.result: object expected");
                            message.result = $root.palexy.streaming.v1.ForecastTaskResult.fromObject(object.result);
                        }
                        if (object.errorMessage != null)
                            message.errorMessage = String(object.errorMessage);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastTask message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @static
                     * @param {palexy.streaming.v1.ForecastTask} message ForecastTask
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastTask.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelVersionId = options.longs === String ? "0" : 0;
                            object.forecastingHorizon = 0;
                            object.state = options.enums === String ? "UNKNOWN_STATE" : 0;
                            object.result = null;
                            object.errorMessage = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (typeof message.forecastModelId === "number")
                                object.forecastModelId = options.longs === String ? String(message.forecastModelId) : message.forecastModelId;
                            else
                                object.forecastModelId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelId) : options.longs === Number ? new $util.LongBits(message.forecastModelId.low >>> 0, message.forecastModelId.high >>> 0).toNumber() : message.forecastModelId;
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (typeof message.forecastModelVersionId === "number")
                                object.forecastModelVersionId = options.longs === String ? String(message.forecastModelVersionId) : message.forecastModelVersionId;
                            else
                                object.forecastModelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelVersionId) : options.longs === Number ? new $util.LongBits(message.forecastModelVersionId.low >>> 0, message.forecastModelVersionId.high >>> 0).toNumber() : message.forecastModelVersionId;
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            object.forecastingHorizon = message.forecastingHorizon;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.ForecastTask.State[message.state] : message.state;
                        if (message.result != null && message.hasOwnProperty("result"))
                            object.result = $root.palexy.streaming.v1.ForecastTaskResult.toObject(message.result, options);
                        if (message.errorMessage != null && message.hasOwnProperty("errorMessage"))
                            object.errorMessage = message.errorMessage;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastTask to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastTask
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastTask.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * State enum.
                     * @name palexy.streaming.v1.ForecastTask.State
                     * @enum {number}
                     * @property {number} UNKNOWN_STATE=0 UNKNOWN_STATE value
                     * @property {number} CREATED=1 CREATED value
                     * @property {number} DONE=2 DONE value
                     * @property {number} FAILED=3 FAILED value
                     * @property {number} PARTIAL=4 PARTIAL value
                     */
                    ForecastTask.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_STATE"] = 0;
                        values[valuesById[1] = "CREATED"] = 1;
                        values[valuesById[2] = "DONE"] = 2;
                        values[valuesById[3] = "FAILED"] = 3;
                        values[valuesById[4] = "PARTIAL"] = 4;
                        return values;
                    })();
    
                    return ForecastTask;
                })();
    
                v1.ForecastTaskResult = (function() {
    
                    /**
                     * Properties of a ForecastTaskResult.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastTaskResult
                     * @property {number|null} [doneCount] ForecastTaskResult doneCount
                     */
    
                    /**
                     * Constructs a new ForecastTaskResult.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastTaskResult.
                     * @implements IForecastTaskResult
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastTaskResult=} [properties] Properties to set
                     */
                    function ForecastTaskResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastTaskResult doneCount.
                     * @member {number} doneCount
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @instance
                     */
                    ForecastTaskResult.prototype.doneCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ForecastTaskResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {palexy.streaming.v1.IForecastTaskResult=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastTaskResult} ForecastTaskResult instance
                     */
                    ForecastTaskResult.create = function create(properties) {
                        return new ForecastTaskResult(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastTaskResult message. Does not implicitly {@link palexy.streaming.v1.ForecastTaskResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {palexy.streaming.v1.IForecastTaskResult} message ForecastTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastTaskResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.doneCount != null && Object.hasOwnProperty.call(message, "doneCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.doneCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastTaskResult message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastTaskResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {palexy.streaming.v1.IForecastTaskResult} message ForecastTaskResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastTaskResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastTaskResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastTaskResult} ForecastTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastTaskResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastTaskResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.doneCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastTaskResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastTaskResult} ForecastTaskResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastTaskResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastTaskResult message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastTaskResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.doneCount != null && message.hasOwnProperty("doneCount"))
                            if (!$util.isInteger(message.doneCount) && !(message.doneCount && $util.isInteger(message.doneCount.low) && $util.isInteger(message.doneCount.high)))
                                return "doneCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastTaskResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastTaskResult} ForecastTaskResult
                     */
                    ForecastTaskResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastTaskResult)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastTaskResult();
                        if (object.doneCount != null)
                            if ($util.Long)
                                (message.doneCount = $util.Long.fromValue(object.doneCount)).unsigned = false;
                            else if (typeof object.doneCount === "string")
                                message.doneCount = parseInt(object.doneCount, 10);
                            else if (typeof object.doneCount === "number")
                                message.doneCount = object.doneCount;
                            else if (typeof object.doneCount === "object")
                                message.doneCount = new $util.LongBits(object.doneCount.low >>> 0, object.doneCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastTaskResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @static
                     * @param {palexy.streaming.v1.ForecastTaskResult} message ForecastTaskResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastTaskResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.doneCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.doneCount = options.longs === String ? "0" : 0;
                        if (message.doneCount != null && message.hasOwnProperty("doneCount"))
                            if (typeof message.doneCount === "number")
                                object.doneCount = options.longs === String ? String(message.doneCount) : message.doneCount;
                            else
                                object.doneCount = options.longs === String ? $util.Long.prototype.toString.call(message.doneCount) : options.longs === Number ? new $util.LongBits(message.doneCount.low >>> 0, message.doneCount.high >>> 0).toNumber() : message.doneCount;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastTaskResult to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastTaskResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastTaskResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastTaskResult;
                })();
    
                v1.CreateForecastTaskRequest = (function() {
    
                    /**
                     * Properties of a CreateForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateForecastTaskRequest
                     * @property {number|null} [dateId] CreateForecastTaskRequest dateId
                     * @property {Array.<number>|null} [storeIds] CreateForecastTaskRequest storeIds
                     * @property {number|null} [forecastModelId] CreateForecastTaskRequest forecastModelId
                     * @property {number|null} [forecastModelVersionId] CreateForecastTaskRequest forecastModelVersionId
                     * @property {number|null} [forecastingHorizon] CreateForecastTaskRequest forecastingHorizon
                     */
    
                    /**
                     * Constructs a new CreateForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateForecastTaskRequest.
                     * @implements ICreateForecastTaskRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest=} [properties] Properties to set
                     */
                    function CreateForecastTaskRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateForecastTaskRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     */
                    CreateForecastTaskRequest.prototype.dateId = 0;
    
                    /**
                     * CreateForecastTaskRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     */
                    CreateForecastTaskRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * CreateForecastTaskRequest forecastModelId.
                     * @member {number} forecastModelId
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     */
                    CreateForecastTaskRequest.prototype.forecastModelId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateForecastTaskRequest forecastModelVersionId.
                     * @member {number} forecastModelVersionId
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     */
                    CreateForecastTaskRequest.prototype.forecastModelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateForecastTaskRequest forecastingHorizon.
                     * @member {number} forecastingHorizon
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     */
                    CreateForecastTaskRequest.prototype.forecastingHorizon = 0;
    
                    /**
                     * Creates a new CreateForecastTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateForecastTaskRequest} CreateForecastTaskRequest instance
                     */
                    CreateForecastTaskRequest.create = function create(properties) {
                        return new CreateForecastTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateForecastTaskRequest message. Does not implicitly {@link palexy.streaming.v1.CreateForecastTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest} message CreateForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateForecastTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.forecastModelId != null && Object.hasOwnProperty.call(message, "forecastModelId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.forecastModelId);
                        if (message.forecastModelVersionId != null && Object.hasOwnProperty.call(message, "forecastModelVersionId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.forecastModelVersionId);
                        if (message.forecastingHorizon != null && Object.hasOwnProperty.call(message, "forecastingHorizon"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.forecastingHorizon);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateForecastTaskRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateForecastTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest} message CreateForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateForecastTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateForecastTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateForecastTaskRequest} CreateForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateForecastTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateForecastTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.int32();
                                break;
                            case 2:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 3:
                                message.forecastModelId = reader.int64();
                                break;
                            case 4:
                                message.forecastModelVersionId = reader.int64();
                                break;
                            case 5:
                                message.forecastingHorizon = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateForecastTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateForecastTaskRequest} CreateForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateForecastTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateForecastTaskRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateForecastTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (!$util.isInteger(message.forecastModelId) && !(message.forecastModelId && $util.isInteger(message.forecastModelId.low) && $util.isInteger(message.forecastModelId.high)))
                                return "forecastModelId: integer|Long expected";
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (!$util.isInteger(message.forecastModelVersionId) && !(message.forecastModelVersionId && $util.isInteger(message.forecastModelVersionId.low) && $util.isInteger(message.forecastModelVersionId.high)))
                                return "forecastModelVersionId: integer|Long expected";
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            if (!$util.isInteger(message.forecastingHorizon))
                                return "forecastingHorizon: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateForecastTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateForecastTaskRequest} CreateForecastTaskRequest
                     */
                    CreateForecastTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateForecastTaskRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateForecastTaskRequest();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.CreateForecastTaskRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.forecastModelId != null)
                            if ($util.Long)
                                (message.forecastModelId = $util.Long.fromValue(object.forecastModelId)).unsigned = false;
                            else if (typeof object.forecastModelId === "string")
                                message.forecastModelId = parseInt(object.forecastModelId, 10);
                            else if (typeof object.forecastModelId === "number")
                                message.forecastModelId = object.forecastModelId;
                            else if (typeof object.forecastModelId === "object")
                                message.forecastModelId = new $util.LongBits(object.forecastModelId.low >>> 0, object.forecastModelId.high >>> 0).toNumber();
                        if (object.forecastModelVersionId != null)
                            if ($util.Long)
                                (message.forecastModelVersionId = $util.Long.fromValue(object.forecastModelVersionId)).unsigned = false;
                            else if (typeof object.forecastModelVersionId === "string")
                                message.forecastModelVersionId = parseInt(object.forecastModelVersionId, 10);
                            else if (typeof object.forecastModelVersionId === "number")
                                message.forecastModelVersionId = object.forecastModelVersionId;
                            else if (typeof object.forecastModelVersionId === "object")
                                message.forecastModelVersionId = new $util.LongBits(object.forecastModelVersionId.low >>> 0, object.forecastModelVersionId.high >>> 0).toNumber();
                        if (object.forecastingHorizon != null)
                            message.forecastingHorizon = object.forecastingHorizon | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateForecastTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateForecastTaskRequest} message CreateForecastTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateForecastTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.dateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelVersionId = options.longs === String ? "0" : 0;
                            object.forecastingHorizon = 0;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (typeof message.forecastModelId === "number")
                                object.forecastModelId = options.longs === String ? String(message.forecastModelId) : message.forecastModelId;
                            else
                                object.forecastModelId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelId) : options.longs === Number ? new $util.LongBits(message.forecastModelId.low >>> 0, message.forecastModelId.high >>> 0).toNumber() : message.forecastModelId;
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (typeof message.forecastModelVersionId === "number")
                                object.forecastModelVersionId = options.longs === String ? String(message.forecastModelVersionId) : message.forecastModelVersionId;
                            else
                                object.forecastModelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelVersionId) : options.longs === Number ? new $util.LongBits(message.forecastModelVersionId.low >>> 0, message.forecastModelVersionId.high >>> 0).toNumber() : message.forecastModelVersionId;
                        if (message.forecastingHorizon != null && message.hasOwnProperty("forecastingHorizon"))
                            object.forecastingHorizon = message.forecastingHorizon;
                        return object;
                    };
    
                    /**
                     * Converts this CreateForecastTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateForecastTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateForecastTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateForecastTaskRequest;
                })();
    
                v1.BatchCreateForecastTasksRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateForecastTasksRequest
                     * @property {Array.<palexy.streaming.v1.ICreateForecastTaskRequest>|null} [requests] BatchCreateForecastTasksRequest requests
                     */
    
                    /**
                     * Constructs a new BatchCreateForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateForecastTasksRequest.
                     * @implements IBatchCreateForecastTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest=} [properties] Properties to set
                     */
                    function BatchCreateForecastTasksRequest(properties) {
                        this.requests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateForecastTasksRequest requests.
                     * @member {Array.<palexy.streaming.v1.ICreateForecastTaskRequest>} requests
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @instance
                     */
                    BatchCreateForecastTasksRequest.prototype.requests = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateForecastTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksRequest} BatchCreateForecastTasksRequest instance
                     */
                    BatchCreateForecastTasksRequest.create = function create(properties) {
                        return new BatchCreateForecastTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateForecastTasksRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateForecastTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest} message BatchCreateForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateForecastTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.requests != null && message.requests.length)
                            for (var i = 0; i < message.requests.length; ++i)
                                $root.palexy.streaming.v1.CreateForecastTaskRequest.encode(message.requests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateForecastTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateForecastTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest} message BatchCreateForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateForecastTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateForecastTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksRequest} BatchCreateForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateForecastTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateForecastTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.requests && message.requests.length))
                                    message.requests = [];
                                message.requests.push($root.palexy.streaming.v1.CreateForecastTaskRequest.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateForecastTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksRequest} BatchCreateForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateForecastTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateForecastTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateForecastTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.requests != null && message.hasOwnProperty("requests")) {
                            if (!Array.isArray(message.requests))
                                return "requests: array expected";
                            for (var i = 0; i < message.requests.length; ++i) {
                                var error = $root.palexy.streaming.v1.CreateForecastTaskRequest.verify(message.requests[i]);
                                if (error)
                                    return "requests." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateForecastTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksRequest} BatchCreateForecastTasksRequest
                     */
                    BatchCreateForecastTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateForecastTasksRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateForecastTasksRequest();
                        if (object.requests) {
                            if (!Array.isArray(object.requests))
                                throw TypeError(".palexy.streaming.v1.BatchCreateForecastTasksRequest.requests: array expected");
                            message.requests = [];
                            for (var i = 0; i < object.requests.length; ++i) {
                                if (typeof object.requests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateForecastTasksRequest.requests: object expected");
                                message.requests[i] = $root.palexy.streaming.v1.CreateForecastTaskRequest.fromObject(object.requests[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateForecastTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateForecastTasksRequest} message BatchCreateForecastTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateForecastTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.requests = [];
                        if (message.requests && message.requests.length) {
                            object.requests = [];
                            for (var j = 0; j < message.requests.length; ++j)
                                object.requests[j] = $root.palexy.streaming.v1.CreateForecastTaskRequest.toObject(message.requests[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateForecastTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateForecastTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateForecastTasksRequest;
                })();
    
                v1.BatchCreateForecastTasksResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateForecastTasksResponse
                     * @property {Array.<palexy.streaming.v1.IForecastTask>|null} [tasks] BatchCreateForecastTasksResponse tasks
                     */
    
                    /**
                     * Constructs a new BatchCreateForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateForecastTasksResponse.
                     * @implements IBatchCreateForecastTasksResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksResponse=} [properties] Properties to set
                     */
                    function BatchCreateForecastTasksResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateForecastTasksResponse tasks.
                     * @member {Array.<palexy.streaming.v1.IForecastTask>} tasks
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @instance
                     */
                    BatchCreateForecastTasksResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateForecastTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksResponse} BatchCreateForecastTasksResponse instance
                     */
                    BatchCreateForecastTasksResponse.create = function create(properties) {
                        return new BatchCreateForecastTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateForecastTasksResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateForecastTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksResponse} message BatchCreateForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateForecastTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.streaming.v1.ForecastTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateForecastTasksResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateForecastTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksResponse} message BatchCreateForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateForecastTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateForecastTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksResponse} BatchCreateForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateForecastTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateForecastTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.streaming.v1.ForecastTask.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateForecastTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksResponse} BatchCreateForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateForecastTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateForecastTasksResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateForecastTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateForecastTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateForecastTasksResponse} BatchCreateForecastTasksResponse
                     */
                    BatchCreateForecastTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateForecastTasksResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateForecastTasksResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.streaming.v1.BatchCreateForecastTasksResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateForecastTasksResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.streaming.v1.ForecastTask.fromObject(object.tasks[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateForecastTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateForecastTasksResponse} message BatchCreateForecastTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateForecastTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.streaming.v1.ForecastTask.toObject(message.tasks[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateForecastTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateForecastTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateForecastTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateForecastTasksResponse;
                })();
    
                v1.GetForecastTaskRequest = (function() {
    
                    /**
                     * Properties of a GetForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetForecastTaskRequest
                     * @property {number|null} [taskId] GetForecastTaskRequest taskId
                     */
    
                    /**
                     * Constructs a new GetForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetForecastTaskRequest.
                     * @implements IGetForecastTaskRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest=} [properties] Properties to set
                     */
                    function GetForecastTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetForecastTaskRequest taskId.
                     * @member {number} taskId
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @instance
                     */
                    GetForecastTaskRequest.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetForecastTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetForecastTaskRequest} GetForecastTaskRequest instance
                     */
                    GetForecastTaskRequest.create = function create(properties) {
                        return new GetForecastTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetForecastTaskRequest message. Does not implicitly {@link palexy.streaming.v1.GetForecastTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest} message GetForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetForecastTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.taskId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetForecastTaskRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetForecastTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest} message GetForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetForecastTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetForecastTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetForecastTaskRequest} GetForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetForecastTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetForecastTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetForecastTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetForecastTaskRequest} GetForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetForecastTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetForecastTaskRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetForecastTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetForecastTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetForecastTaskRequest} GetForecastTaskRequest
                     */
                    GetForecastTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetForecastTaskRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetForecastTaskRequest();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetForecastTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.GetForecastTaskRequest} message GetForecastTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetForecastTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        return object;
                    };
    
                    /**
                     * Converts this GetForecastTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetForecastTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetForecastTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetForecastTaskRequest;
                })();
    
                v1.DeleteForecastTaskRequest = (function() {
    
                    /**
                     * Properties of a DeleteForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteForecastTaskRequest
                     * @property {number|null} [taskId] DeleteForecastTaskRequest taskId
                     */
    
                    /**
                     * Constructs a new DeleteForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteForecastTaskRequest.
                     * @implements IDeleteForecastTaskRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest=} [properties] Properties to set
                     */
                    function DeleteForecastTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteForecastTaskRequest taskId.
                     * @member {number} taskId
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @instance
                     */
                    DeleteForecastTaskRequest.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteForecastTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteForecastTaskRequest} DeleteForecastTaskRequest instance
                     */
                    DeleteForecastTaskRequest.create = function create(properties) {
                        return new DeleteForecastTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteForecastTaskRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteForecastTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest} message DeleteForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteForecastTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.taskId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteForecastTaskRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteForecastTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest} message DeleteForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteForecastTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteForecastTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteForecastTaskRequest} DeleteForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteForecastTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteForecastTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteForecastTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteForecastTaskRequest} DeleteForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteForecastTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteForecastTaskRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteForecastTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteForecastTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteForecastTaskRequest} DeleteForecastTaskRequest
                     */
                    DeleteForecastTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteForecastTaskRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteForecastTaskRequest();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteForecastTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteForecastTaskRequest} message DeleteForecastTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteForecastTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteForecastTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteForecastTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteForecastTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteForecastTaskRequest;
                })();
    
                v1.UpdateForecastTaskRequest = (function() {
    
                    /**
                     * Properties of an UpdateForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateForecastTaskRequest
                     * @property {palexy.streaming.v1.IForecastTask|null} [task] UpdateForecastTaskRequest task
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateForecastTaskRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateForecastTaskRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateForecastTaskRequest.
                     * @implements IUpdateForecastTaskRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest=} [properties] Properties to set
                     */
                    function UpdateForecastTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateForecastTaskRequest task.
                     * @member {palexy.streaming.v1.IForecastTask|null|undefined} task
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @instance
                     */
                    UpdateForecastTaskRequest.prototype.task = null;
    
                    /**
                     * UpdateForecastTaskRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @instance
                     */
                    UpdateForecastTaskRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateForecastTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateForecastTaskRequest} UpdateForecastTaskRequest instance
                     */
                    UpdateForecastTaskRequest.create = function create(properties) {
                        return new UpdateForecastTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateForecastTaskRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateForecastTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest} message UpdateForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateForecastTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            $root.palexy.streaming.v1.ForecastTask.encode(message.task, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateForecastTaskRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateForecastTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest} message UpdateForecastTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateForecastTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateForecastTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateForecastTaskRequest} UpdateForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateForecastTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateForecastTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = $root.palexy.streaming.v1.ForecastTask.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateForecastTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateForecastTaskRequest} UpdateForecastTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateForecastTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateForecastTaskRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateForecastTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task")) {
                            var error = $root.palexy.streaming.v1.ForecastTask.verify(message.task);
                            if (error)
                                return "task." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateForecastTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateForecastTaskRequest} UpdateForecastTaskRequest
                     */
                    UpdateForecastTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateForecastTaskRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateForecastTaskRequest();
                        if (object.task != null) {
                            if (typeof object.task !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateForecastTaskRequest.task: object expected");
                            message.task = $root.palexy.streaming.v1.ForecastTask.fromObject(object.task);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateForecastTaskRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateForecastTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateForecastTaskRequest} message UpdateForecastTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateForecastTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.task = null;
                            object.updateMask = null;
                        }
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = $root.palexy.streaming.v1.ForecastTask.toObject(message.task, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateForecastTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateForecastTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateForecastTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateForecastTaskRequest;
                })();
    
                v1.ListForecastTasksRequest = (function() {
    
                    /**
                     * Properties of a ListForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListForecastTasksRequest
                     * @property {palexy.streaming.v1.ForecastTask.State|null} [state] ListForecastTasksRequest state
                     * @property {number|null} [forecastModelId] ListForecastTasksRequest forecastModelId
                     * @property {number|null} [forecastModelVersionId] ListForecastTasksRequest forecastModelVersionId
                     * @property {number|null} [startDateId] ListForecastTasksRequest startDateId
                     * @property {number|null} [endDateId] ListForecastTasksRequest endDateId
                     * @property {number|null} [storeId] ListForecastTasksRequest storeId
                     * @property {number|null} [pageSize] ListForecastTasksRequest pageSize
                     * @property {string|null} [pageToken] ListForecastTasksRequest pageToken
                     * @property {number|null} [companyId] ListForecastTasksRequest companyId
                     */
    
                    /**
                     * Constructs a new ListForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListForecastTasksRequest.
                     * @implements IListForecastTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListForecastTasksRequest=} [properties] Properties to set
                     */
                    function ListForecastTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListForecastTasksRequest state.
                     * @member {palexy.streaming.v1.ForecastTask.State} state
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.state = 0;
    
                    /**
                     * ListForecastTasksRequest forecastModelId.
                     * @member {number} forecastModelId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.forecastModelId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListForecastTasksRequest forecastModelVersionId.
                     * @member {number} forecastModelVersionId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.forecastModelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListForecastTasksRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.startDateId = 0;
    
                    /**
                     * ListForecastTasksRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.endDateId = 0;
    
                    /**
                     * ListForecastTasksRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListForecastTasksRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.pageSize = 0;
    
                    /**
                     * ListForecastTasksRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.pageToken = "";
    
                    /**
                     * ListForecastTasksRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     */
                    ListForecastTasksRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListForecastTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListForecastTasksRequest} ListForecastTasksRequest instance
                     */
                    ListForecastTasksRequest.create = function create(properties) {
                        return new ListForecastTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListForecastTasksRequest message. Does not implicitly {@link palexy.streaming.v1.ListForecastTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksRequest} message ListForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                        if (message.forecastModelId != null && Object.hasOwnProperty.call(message, "forecastModelId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.forecastModelId);
                        if (message.forecastModelVersionId != null && Object.hasOwnProperty.call(message, "forecastModelVersionId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.forecastModelVersionId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.endDateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.storeId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.pageToken);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListForecastTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListForecastTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksRequest} message ListForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListForecastTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListForecastTasksRequest} ListForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListForecastTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.state = reader.int32();
                                break;
                            case 2:
                                message.forecastModelId = reader.int64();
                                break;
                            case 3:
                                message.forecastModelVersionId = reader.int64();
                                break;
                            case 4:
                                message.startDateId = reader.int32();
                                break;
                            case 5:
                                message.endDateId = reader.int32();
                                break;
                            case 6:
                                message.storeId = reader.int64();
                                break;
                            case 7:
                                message.pageSize = reader.int32();
                                break;
                            case 8:
                                message.pageToken = reader.string();
                                break;
                            case 9:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListForecastTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListForecastTasksRequest} ListForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListForecastTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListForecastTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (!$util.isInteger(message.forecastModelId) && !(message.forecastModelId && $util.isInteger(message.forecastModelId.low) && $util.isInteger(message.forecastModelId.high)))
                                return "forecastModelId: integer|Long expected";
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (!$util.isInteger(message.forecastModelVersionId) && !(message.forecastModelVersionId && $util.isInteger(message.forecastModelVersionId.low) && $util.isInteger(message.forecastModelVersionId.high)))
                                return "forecastModelVersionId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListForecastTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListForecastTasksRequest} ListForecastTasksRequest
                     */
                    ListForecastTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListForecastTasksRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListForecastTasksRequest();
                        switch (object.state) {
                        case "UNKNOWN_STATE":
                        case 0:
                            message.state = 0;
                            break;
                        case "CREATED":
                        case 1:
                            message.state = 1;
                            break;
                        case "DONE":
                        case 2:
                            message.state = 2;
                            break;
                        case "FAILED":
                        case 3:
                            message.state = 3;
                            break;
                        case "PARTIAL":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        if (object.forecastModelId != null)
                            if ($util.Long)
                                (message.forecastModelId = $util.Long.fromValue(object.forecastModelId)).unsigned = false;
                            else if (typeof object.forecastModelId === "string")
                                message.forecastModelId = parseInt(object.forecastModelId, 10);
                            else if (typeof object.forecastModelId === "number")
                                message.forecastModelId = object.forecastModelId;
                            else if (typeof object.forecastModelId === "object")
                                message.forecastModelId = new $util.LongBits(object.forecastModelId.low >>> 0, object.forecastModelId.high >>> 0).toNumber();
                        if (object.forecastModelVersionId != null)
                            if ($util.Long)
                                (message.forecastModelVersionId = $util.Long.fromValue(object.forecastModelVersionId)).unsigned = false;
                            else if (typeof object.forecastModelVersionId === "string")
                                message.forecastModelVersionId = parseInt(object.forecastModelVersionId, 10);
                            else if (typeof object.forecastModelVersionId === "number")
                                message.forecastModelVersionId = object.forecastModelVersionId;
                            else if (typeof object.forecastModelVersionId === "object")
                                message.forecastModelVersionId = new $util.LongBits(object.forecastModelVersionId.low >>> 0, object.forecastModelVersionId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListForecastTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ListForecastTasksRequest} message ListForecastTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListForecastTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.state = options.enums === String ? "UNKNOWN_STATE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.forecastModelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.forecastModelVersionId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.ForecastTask.State[message.state] : message.state;
                        if (message.forecastModelId != null && message.hasOwnProperty("forecastModelId"))
                            if (typeof message.forecastModelId === "number")
                                object.forecastModelId = options.longs === String ? String(message.forecastModelId) : message.forecastModelId;
                            else
                                object.forecastModelId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelId) : options.longs === Number ? new $util.LongBits(message.forecastModelId.low >>> 0, message.forecastModelId.high >>> 0).toNumber() : message.forecastModelId;
                        if (message.forecastModelVersionId != null && message.hasOwnProperty("forecastModelVersionId"))
                            if (typeof message.forecastModelVersionId === "number")
                                object.forecastModelVersionId = options.longs === String ? String(message.forecastModelVersionId) : message.forecastModelVersionId;
                            else
                                object.forecastModelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.forecastModelVersionId) : options.longs === Number ? new $util.LongBits(message.forecastModelVersionId.low >>> 0, message.forecastModelVersionId.high >>> 0).toNumber() : message.forecastModelVersionId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListForecastTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListForecastTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListForecastTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListForecastTasksRequest;
                })();
    
                v1.ListForecastTasksResponse = (function() {
    
                    /**
                     * Properties of a ListForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListForecastTasksResponse
                     * @property {Array.<palexy.streaming.v1.IForecastTask>|null} [tasks] ListForecastTasksResponse tasks
                     * @property {number|null} [totalElements] ListForecastTasksResponse totalElements
                     * @property {string|null} [nextPageToken] ListForecastTasksResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListForecastTasksResponse.
                     * @implements IListForecastTasksResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListForecastTasksResponse=} [properties] Properties to set
                     */
                    function ListForecastTasksResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListForecastTasksResponse tasks.
                     * @member {Array.<palexy.streaming.v1.IForecastTask>} tasks
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @instance
                     */
                    ListForecastTasksResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * ListForecastTasksResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @instance
                     */
                    ListForecastTasksResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListForecastTasksResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @instance
                     */
                    ListForecastTasksResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListForecastTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListForecastTasksResponse} ListForecastTasksResponse instance
                     */
                    ListForecastTasksResponse.create = function create(properties) {
                        return new ListForecastTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListForecastTasksResponse message. Does not implicitly {@link palexy.streaming.v1.ListForecastTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksResponse} message ListForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.streaming.v1.ForecastTask.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListForecastTasksResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListForecastTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastTasksResponse} message ListForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListForecastTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListForecastTasksResponse} ListForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListForecastTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.streaming.v1.ForecastTask.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListForecastTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListForecastTasksResponse} ListForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListForecastTasksResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListForecastTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastTask.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListForecastTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListForecastTasksResponse} ListForecastTasksResponse
                     */
                    ListForecastTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListForecastTasksResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListForecastTasksResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.streaming.v1.ListForecastTasksResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListForecastTasksResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.streaming.v1.ForecastTask.fromObject(object.tasks[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListForecastTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.ListForecastTasksResponse} message ListForecastTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListForecastTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.streaming.v1.ForecastTask.toObject(message.tasks[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListForecastTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListForecastTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListForecastTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListForecastTasksResponse;
                })();
    
                v1.SummarizeForecastTasksRequest = (function() {
    
                    /**
                     * Properties of a SummarizeForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISummarizeForecastTasksRequest
                     */
    
                    /**
                     * Constructs a new SummarizeForecastTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SummarizeForecastTasksRequest.
                     * @implements ISummarizeForecastTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest=} [properties] Properties to set
                     */
                    function SummarizeForecastTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new SummarizeForecastTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksRequest} SummarizeForecastTasksRequest instance
                     */
                    SummarizeForecastTasksRequest.create = function create(properties) {
                        return new SummarizeForecastTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SummarizeForecastTasksRequest message. Does not implicitly {@link palexy.streaming.v1.SummarizeForecastTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest} message SummarizeForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SummarizeForecastTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SummarizeForecastTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SummarizeForecastTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest} message SummarizeForecastTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SummarizeForecastTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SummarizeForecastTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksRequest} SummarizeForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SummarizeForecastTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SummarizeForecastTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SummarizeForecastTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksRequest} SummarizeForecastTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SummarizeForecastTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SummarizeForecastTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SummarizeForecastTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a SummarizeForecastTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksRequest} SummarizeForecastTasksRequest
                     */
                    SummarizeForecastTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SummarizeForecastTasksRequest)
                            return object;
                        return new $root.palexy.streaming.v1.SummarizeForecastTasksRequest();
                    };
    
                    /**
                     * Creates a plain object from a SummarizeForecastTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.SummarizeForecastTasksRequest} message SummarizeForecastTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SummarizeForecastTasksRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this SummarizeForecastTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SummarizeForecastTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SummarizeForecastTasksRequest;
                })();
    
                v1.SummarizeForecastTasksResponse = (function() {
    
                    /**
                     * Properties of a SummarizeForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISummarizeForecastTasksResponse
                     * @property {number|null} [failedCount] SummarizeForecastTasksResponse failedCount
                     * @property {number|null} [createdCount] SummarizeForecastTasksResponse createdCount
                     */
    
                    /**
                     * Constructs a new SummarizeForecastTasksResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SummarizeForecastTasksResponse.
                     * @implements ISummarizeForecastTasksResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksResponse=} [properties] Properties to set
                     */
                    function SummarizeForecastTasksResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SummarizeForecastTasksResponse failedCount.
                     * @member {number} failedCount
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @instance
                     */
                    SummarizeForecastTasksResponse.prototype.failedCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SummarizeForecastTasksResponse createdCount.
                     * @member {number} createdCount
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @instance
                     */
                    SummarizeForecastTasksResponse.prototype.createdCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SummarizeForecastTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksResponse} SummarizeForecastTasksResponse instance
                     */
                    SummarizeForecastTasksResponse.create = function create(properties) {
                        return new SummarizeForecastTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SummarizeForecastTasksResponse message. Does not implicitly {@link palexy.streaming.v1.SummarizeForecastTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksResponse} message SummarizeForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SummarizeForecastTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.failedCount != null && Object.hasOwnProperty.call(message, "failedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.failedCount);
                        if (message.createdCount != null && Object.hasOwnProperty.call(message, "createdCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.createdCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SummarizeForecastTasksResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SummarizeForecastTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksResponse} message SummarizeForecastTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SummarizeForecastTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SummarizeForecastTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksResponse} SummarizeForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SummarizeForecastTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SummarizeForecastTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.failedCount = reader.int64();
                                break;
                            case 2:
                                message.createdCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SummarizeForecastTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksResponse} SummarizeForecastTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SummarizeForecastTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SummarizeForecastTasksResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SummarizeForecastTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.failedCount != null && message.hasOwnProperty("failedCount"))
                            if (!$util.isInteger(message.failedCount) && !(message.failedCount && $util.isInteger(message.failedCount.low) && $util.isInteger(message.failedCount.high)))
                                return "failedCount: integer|Long expected";
                        if (message.createdCount != null && message.hasOwnProperty("createdCount"))
                            if (!$util.isInteger(message.createdCount) && !(message.createdCount && $util.isInteger(message.createdCount.low) && $util.isInteger(message.createdCount.high)))
                                return "createdCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SummarizeForecastTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SummarizeForecastTasksResponse} SummarizeForecastTasksResponse
                     */
                    SummarizeForecastTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SummarizeForecastTasksResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SummarizeForecastTasksResponse();
                        if (object.failedCount != null)
                            if ($util.Long)
                                (message.failedCount = $util.Long.fromValue(object.failedCount)).unsigned = false;
                            else if (typeof object.failedCount === "string")
                                message.failedCount = parseInt(object.failedCount, 10);
                            else if (typeof object.failedCount === "number")
                                message.failedCount = object.failedCount;
                            else if (typeof object.failedCount === "object")
                                message.failedCount = new $util.LongBits(object.failedCount.low >>> 0, object.failedCount.high >>> 0).toNumber();
                        if (object.createdCount != null)
                            if ($util.Long)
                                (message.createdCount = $util.Long.fromValue(object.createdCount)).unsigned = false;
                            else if (typeof object.createdCount === "string")
                                message.createdCount = parseInt(object.createdCount, 10);
                            else if (typeof object.createdCount === "number")
                                message.createdCount = object.createdCount;
                            else if (typeof object.createdCount === "object")
                                message.createdCount = new $util.LongBits(object.createdCount.low >>> 0, object.createdCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SummarizeForecastTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @static
                     * @param {palexy.streaming.v1.SummarizeForecastTasksResponse} message SummarizeForecastTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SummarizeForecastTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.failedCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.failedCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdCount = options.longs === String ? "0" : 0;
                        }
                        if (message.failedCount != null && message.hasOwnProperty("failedCount"))
                            if (typeof message.failedCount === "number")
                                object.failedCount = options.longs === String ? String(message.failedCount) : message.failedCount;
                            else
                                object.failedCount = options.longs === String ? $util.Long.prototype.toString.call(message.failedCount) : options.longs === Number ? new $util.LongBits(message.failedCount.low >>> 0, message.failedCount.high >>> 0).toNumber() : message.failedCount;
                        if (message.createdCount != null && message.hasOwnProperty("createdCount"))
                            if (typeof message.createdCount === "number")
                                object.createdCount = options.longs === String ? String(message.createdCount) : message.createdCount;
                            else
                                object.createdCount = options.longs === String ? $util.Long.prototype.toString.call(message.createdCount) : options.longs === Number ? new $util.LongBits(message.createdCount.low >>> 0, message.createdCount.high >>> 0).toNumber() : message.createdCount;
                        return object;
                    };
    
                    /**
                     * Converts this SummarizeForecastTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SummarizeForecastTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SummarizeForecastTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SummarizeForecastTasksResponse;
                })();
    
                v1.ForecastService = (function() {
    
                    /**
                     * Constructs a new ForecastService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ForecastService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ForecastService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ForecastService;
    
                    /**
                     * Creates new ForecastService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ForecastService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ForecastService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#listForecastModelVersion}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef ListForecastModelVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListForecastModelVersionResponse} [response] ListForecastModelVersionResponse
                     */
    
                    /**
                     * Calls ListForecastModelVersion.
                     * @function listForecastModelVersion
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest} request ListForecastModelVersionRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.ListForecastModelVersionCallback} callback Node-style callback called with the error, if any, and ListForecastModelVersionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.listForecastModelVersion = function listForecastModelVersion(request, callback) {
                        return this.rpcCall(listForecastModelVersion, $root.palexy.streaming.v1.ListForecastModelVersionRequest, $root.palexy.streaming.v1.ListForecastModelVersionResponse, request, callback);
                    }, "name", { value: "ListForecastModelVersion" });
    
                    /**
                     * Calls ListForecastModelVersion.
                     * @function listForecastModelVersion
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest} request ListForecastModelVersionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListForecastModelVersionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#getForecastModelVersion}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef GetForecastModelVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ForecastModelVersion} [response] ForecastModelVersion
                     */
    
                    /**
                     * Calls GetForecastModelVersion.
                     * @function getForecastModelVersion
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest} request GetForecastModelVersionRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.GetForecastModelVersionCallback} callback Node-style callback called with the error, if any, and ForecastModelVersion
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.getForecastModelVersion = function getForecastModelVersion(request, callback) {
                        return this.rpcCall(getForecastModelVersion, $root.palexy.streaming.v1.GetForecastModelVersionRequest, $root.palexy.streaming.v1.ForecastModelVersion, request, callback);
                    }, "name", { value: "GetForecastModelVersion" });
    
                    /**
                     * Calls GetForecastModelVersion.
                     * @function getForecastModelVersion
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest} request GetForecastModelVersionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ForecastModelVersion>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#triggerCreateTasks}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef TriggerCreateTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls TriggerCreateTasks.
                     * @function triggerCreateTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest} request TriggerCreateTasksRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.TriggerCreateTasksCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.triggerCreateTasks = function triggerCreateTasks(request, callback) {
                        return this.rpcCall(triggerCreateTasks, $root.palexy.streaming.v1.TriggerCreateTasksRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "TriggerCreateTasks" });
    
                    /**
                     * Calls TriggerCreateTasks.
                     * @function triggerCreateTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest} request TriggerCreateTasksRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#batchCreatePrediction}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef BatchCreatePredictionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreatePredictionResponse} [response] BatchCreatePredictionResponse
                     */
    
                    /**
                     * Calls BatchCreatePrediction.
                     * @function batchCreatePrediction
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest} request BatchCreatePredictionRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.BatchCreatePredictionCallback} callback Node-style callback called with the error, if any, and BatchCreatePredictionResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.batchCreatePrediction = function batchCreatePrediction(request, callback) {
                        return this.rpcCall(batchCreatePrediction, $root.palexy.streaming.v1.BatchCreatePredictionRequest, $root.palexy.streaming.v1.BatchCreatePredictionResponse, request, callback);
                    }, "name", { value: "BatchCreatePrediction" });
    
                    /**
                     * Calls BatchCreatePrediction.
                     * @function batchCreatePrediction
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest} request BatchCreatePredictionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreatePredictionResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#listLatestForecastStoreWholeDay}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef ListLatestForecastStoreWholeDayCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} [response] ListLatestForecastStoreWholeDayResponse
                     */
    
                    /**
                     * Calls ListLatestForecastStoreWholeDay.
                     * @function listLatestForecastStoreWholeDay
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest} request ListLatestForecastStoreWholeDayRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.ListLatestForecastStoreWholeDayCallback} callback Node-style callback called with the error, if any, and ListLatestForecastStoreWholeDayResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.listLatestForecastStoreWholeDay = function listLatestForecastStoreWholeDay(request, callback) {
                        return this.rpcCall(listLatestForecastStoreWholeDay, $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest, $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse, request, callback);
                    }, "name", { value: "ListLatestForecastStoreWholeDay" });
    
                    /**
                     * Calls ListLatestForecastStoreWholeDay.
                     * @function listLatestForecastStoreWholeDay
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest} request ListLatestForecastStoreWholeDayRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#batchCheckForecastOverrideDays}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef BatchCheckForecastOverrideDaysCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} [response] BatchCheckForecastOverrideDaysResponse
                     */
    
                    /**
                     * Calls BatchCheckForecastOverrideDays.
                     * @function batchCheckForecastOverrideDays
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest} request BatchCheckForecastOverrideDaysRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.BatchCheckForecastOverrideDaysCallback} callback Node-style callback called with the error, if any, and BatchCheckForecastOverrideDaysResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.batchCheckForecastOverrideDays = function batchCheckForecastOverrideDays(request, callback) {
                        return this.rpcCall(batchCheckForecastOverrideDays, $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest, $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse, request, callback);
                    }, "name", { value: "BatchCheckForecastOverrideDays" });
    
                    /**
                     * Calls BatchCheckForecastOverrideDays.
                     * @function batchCheckForecastOverrideDays
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest} request BatchCheckForecastOverrideDaysRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#saveForecastUserOverride}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef SaveForecastUserOverrideCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SaveForecastUserOverrideResponse} [response] SaveForecastUserOverrideResponse
                     */
    
                    /**
                     * Calls SaveForecastUserOverride.
                     * @function saveForecastUserOverride
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest} request SaveForecastUserOverrideRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.SaveForecastUserOverrideCallback} callback Node-style callback called with the error, if any, and SaveForecastUserOverrideResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.saveForecastUserOverride = function saveForecastUserOverride(request, callback) {
                        return this.rpcCall(saveForecastUserOverride, $root.palexy.streaming.v1.SaveForecastUserOverrideRequest, $root.palexy.streaming.v1.SaveForecastUserOverrideResponse, request, callback);
                    }, "name", { value: "SaveForecastUserOverride" });
    
                    /**
                     * Calls SaveForecastUserOverride.
                     * @function saveForecastUserOverride
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest} request SaveForecastUserOverrideRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SaveForecastUserOverrideResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#deleteForecastUserOverride}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef DeleteForecastUserOverrideCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteForecastUserOverride.
                     * @function deleteForecastUserOverride
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest} request DeleteForecastUserOverrideRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.DeleteForecastUserOverrideCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.deleteForecastUserOverride = function deleteForecastUserOverride(request, callback) {
                        return this.rpcCall(deleteForecastUserOverride, $root.palexy.streaming.v1.DeleteForecastUserOverrideRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteForecastUserOverride" });
    
                    /**
                     * Calls DeleteForecastUserOverride.
                     * @function deleteForecastUserOverride
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest} request DeleteForecastUserOverrideRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#cleanupStaleForecastData}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef CleanupStaleForecastDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CleanupStaleForecastDataResponse} [response] CleanupStaleForecastDataResponse
                     */
    
                    /**
                     * Calls CleanupStaleForecastData.
                     * @function cleanupStaleForecastData
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest} request CleanupStaleForecastDataRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.CleanupStaleForecastDataCallback} callback Node-style callback called with the error, if any, and CleanupStaleForecastDataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.cleanupStaleForecastData = function cleanupStaleForecastData(request, callback) {
                        return this.rpcCall(cleanupStaleForecastData, $root.palexy.streaming.v1.CleanupStaleForecastDataRequest, $root.palexy.streaming.v1.CleanupStaleForecastDataResponse, request, callback);
                    }, "name", { value: "CleanupStaleForecastData" });
    
                    /**
                     * Calls CleanupStaleForecastData.
                     * @function cleanupStaleForecastData
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest} request CleanupStaleForecastDataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CleanupStaleForecastDataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#createForecastTask}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef CreateForecastTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ForecastTask} [response] ForecastTask
                     */
    
                    /**
                     * Calls CreateForecastTask.
                     * @function createForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest} request CreateForecastTaskRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.CreateForecastTaskCallback} callback Node-style callback called with the error, if any, and ForecastTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.createForecastTask = function createForecastTask(request, callback) {
                        return this.rpcCall(createForecastTask, $root.palexy.streaming.v1.CreateForecastTaskRequest, $root.palexy.streaming.v1.ForecastTask, request, callback);
                    }, "name", { value: "CreateForecastTask" });
    
                    /**
                     * Calls CreateForecastTask.
                     * @function createForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateForecastTaskRequest} request CreateForecastTaskRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ForecastTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#batchCreateForecastTasks}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef BatchCreateForecastTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateForecastTasksResponse} [response] BatchCreateForecastTasksResponse
                     */
    
                    /**
                     * Calls BatchCreateForecastTasks.
                     * @function batchCreateForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest} request BatchCreateForecastTasksRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.BatchCreateForecastTasksCallback} callback Node-style callback called with the error, if any, and BatchCreateForecastTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.batchCreateForecastTasks = function batchCreateForecastTasks(request, callback) {
                        return this.rpcCall(batchCreateForecastTasks, $root.palexy.streaming.v1.BatchCreateForecastTasksRequest, $root.palexy.streaming.v1.BatchCreateForecastTasksResponse, request, callback);
                    }, "name", { value: "BatchCreateForecastTasks" });
    
                    /**
                     * Calls BatchCreateForecastTasks.
                     * @function batchCreateForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateForecastTasksRequest} request BatchCreateForecastTasksRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateForecastTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#listForecastTasks}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef ListForecastTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListForecastTasksResponse} [response] ListForecastTasksResponse
                     */
    
                    /**
                     * Calls ListForecastTasks.
                     * @function listForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListForecastTasksRequest} request ListForecastTasksRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.ListForecastTasksCallback} callback Node-style callback called with the error, if any, and ListForecastTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.listForecastTasks = function listForecastTasks(request, callback) {
                        return this.rpcCall(listForecastTasks, $root.palexy.streaming.v1.ListForecastTasksRequest, $root.palexy.streaming.v1.ListForecastTasksResponse, request, callback);
                    }, "name", { value: "ListForecastTasks" });
    
                    /**
                     * Calls ListForecastTasks.
                     * @function listForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IListForecastTasksRequest} request ListForecastTasksRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListForecastTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#getForecastTask}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef GetForecastTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ForecastTask} [response] ForecastTask
                     */
    
                    /**
                     * Calls GetForecastTask.
                     * @function getForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest} request GetForecastTaskRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.GetForecastTaskCallback} callback Node-style callback called with the error, if any, and ForecastTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.getForecastTask = function getForecastTask(request, callback) {
                        return this.rpcCall(getForecastTask, $root.palexy.streaming.v1.GetForecastTaskRequest, $root.palexy.streaming.v1.ForecastTask, request, callback);
                    }, "name", { value: "GetForecastTask" });
    
                    /**
                     * Calls GetForecastTask.
                     * @function getForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IGetForecastTaskRequest} request GetForecastTaskRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ForecastTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#updateForecastTask}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef UpdateForecastTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ForecastTask} [response] ForecastTask
                     */
    
                    /**
                     * Calls UpdateForecastTask.
                     * @function updateForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest} request UpdateForecastTaskRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.UpdateForecastTaskCallback} callback Node-style callback called with the error, if any, and ForecastTask
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.updateForecastTask = function updateForecastTask(request, callback) {
                        return this.rpcCall(updateForecastTask, $root.palexy.streaming.v1.UpdateForecastTaskRequest, $root.palexy.streaming.v1.ForecastTask, request, callback);
                    }, "name", { value: "UpdateForecastTask" });
    
                    /**
                     * Calls UpdateForecastTask.
                     * @function updateForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateForecastTaskRequest} request UpdateForecastTaskRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ForecastTask>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#deleteForecastTask}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef DeleteForecastTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteForecastTask.
                     * @function deleteForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest} request DeleteForecastTaskRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.DeleteForecastTaskCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.deleteForecastTask = function deleteForecastTask(request, callback) {
                        return this.rpcCall(deleteForecastTask, $root.palexy.streaming.v1.DeleteForecastTaskRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteForecastTask" });
    
                    /**
                     * Calls DeleteForecastTask.
                     * @function deleteForecastTask
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteForecastTaskRequest} request DeleteForecastTaskRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ForecastService#summarizeForecastTasks}.
                     * @memberof palexy.streaming.v1.ForecastService
                     * @typedef SummarizeForecastTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SummarizeForecastTasksResponse} [response] SummarizeForecastTasksResponse
                     */
    
                    /**
                     * Calls SummarizeForecastTasks.
                     * @function summarizeForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest} request SummarizeForecastTasksRequest message or plain object
                     * @param {palexy.streaming.v1.ForecastService.SummarizeForecastTasksCallback} callback Node-style callback called with the error, if any, and SummarizeForecastTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ForecastService.prototype.summarizeForecastTasks = function summarizeForecastTasks(request, callback) {
                        return this.rpcCall(summarizeForecastTasks, $root.palexy.streaming.v1.SummarizeForecastTasksRequest, $root.palexy.streaming.v1.SummarizeForecastTasksResponse, request, callback);
                    }, "name", { value: "SummarizeForecastTasks" });
    
                    /**
                     * Calls SummarizeForecastTasks.
                     * @function summarizeForecastTasks
                     * @memberof palexy.streaming.v1.ForecastService
                     * @instance
                     * @param {palexy.streaming.v1.ISummarizeForecastTasksRequest} request SummarizeForecastTasksRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SummarizeForecastTasksResponse>} Promise
                     * @variation 2
                     */
    
                    return ForecastService;
                })();
    
                v1.ListForecastModelVersionRequest = (function() {
    
                    /**
                     * Properties of a ListForecastModelVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListForecastModelVersionRequest
                     * @property {boolean|null} [includeDisabledForInferring] ListForecastModelVersionRequest includeDisabledForInferring
                     */
    
                    /**
                     * Constructs a new ListForecastModelVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListForecastModelVersionRequest.
                     * @implements IListForecastModelVersionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest=} [properties] Properties to set
                     */
                    function ListForecastModelVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListForecastModelVersionRequest includeDisabledForInferring.
                     * @member {boolean} includeDisabledForInferring
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @instance
                     */
                    ListForecastModelVersionRequest.prototype.includeDisabledForInferring = false;
    
                    /**
                     * Creates a new ListForecastModelVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListForecastModelVersionRequest} ListForecastModelVersionRequest instance
                     */
                    ListForecastModelVersionRequest.create = function create(properties) {
                        return new ListForecastModelVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListForecastModelVersionRequest message. Does not implicitly {@link palexy.streaming.v1.ListForecastModelVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest} message ListForecastModelVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastModelVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.includeDisabledForInferring != null && Object.hasOwnProperty.call(message, "includeDisabledForInferring"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.includeDisabledForInferring);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListForecastModelVersionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListForecastModelVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionRequest} message ListForecastModelVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastModelVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListForecastModelVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListForecastModelVersionRequest} ListForecastModelVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastModelVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListForecastModelVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.includeDisabledForInferring = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListForecastModelVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListForecastModelVersionRequest} ListForecastModelVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastModelVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListForecastModelVersionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListForecastModelVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.includeDisabledForInferring != null && message.hasOwnProperty("includeDisabledForInferring"))
                            if (typeof message.includeDisabledForInferring !== "boolean")
                                return "includeDisabledForInferring: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListForecastModelVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListForecastModelVersionRequest} ListForecastModelVersionRequest
                     */
                    ListForecastModelVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListForecastModelVersionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListForecastModelVersionRequest();
                        if (object.includeDisabledForInferring != null)
                            message.includeDisabledForInferring = Boolean(object.includeDisabledForInferring);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListForecastModelVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.ListForecastModelVersionRequest} message ListForecastModelVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListForecastModelVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.includeDisabledForInferring = false;
                        if (message.includeDisabledForInferring != null && message.hasOwnProperty("includeDisabledForInferring"))
                            object.includeDisabledForInferring = message.includeDisabledForInferring;
                        return object;
                    };
    
                    /**
                     * Converts this ListForecastModelVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListForecastModelVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListForecastModelVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListForecastModelVersionRequest;
                })();
    
                v1.ListForecastModelVersionResponse = (function() {
    
                    /**
                     * Properties of a ListForecastModelVersionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListForecastModelVersionResponse
                     * @property {Array.<palexy.streaming.v1.IForecastModelVersion>|null} [forecastModelVersions] ListForecastModelVersionResponse forecastModelVersions
                     */
    
                    /**
                     * Constructs a new ListForecastModelVersionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListForecastModelVersionResponse.
                     * @implements IListForecastModelVersionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListForecastModelVersionResponse=} [properties] Properties to set
                     */
                    function ListForecastModelVersionResponse(properties) {
                        this.forecastModelVersions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListForecastModelVersionResponse forecastModelVersions.
                     * @member {Array.<palexy.streaming.v1.IForecastModelVersion>} forecastModelVersions
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @instance
                     */
                    ListForecastModelVersionResponse.prototype.forecastModelVersions = $util.emptyArray;
    
                    /**
                     * Creates a new ListForecastModelVersionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListForecastModelVersionResponse} ListForecastModelVersionResponse instance
                     */
                    ListForecastModelVersionResponse.create = function create(properties) {
                        return new ListForecastModelVersionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListForecastModelVersionResponse message. Does not implicitly {@link palexy.streaming.v1.ListForecastModelVersionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionResponse} message ListForecastModelVersionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastModelVersionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.forecastModelVersions != null && message.forecastModelVersions.length)
                            for (var i = 0; i < message.forecastModelVersions.length; ++i)
                                $root.palexy.streaming.v1.ForecastModelVersion.encode(message.forecastModelVersions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListForecastModelVersionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListForecastModelVersionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.IListForecastModelVersionResponse} message ListForecastModelVersionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListForecastModelVersionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListForecastModelVersionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListForecastModelVersionResponse} ListForecastModelVersionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastModelVersionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListForecastModelVersionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.forecastModelVersions && message.forecastModelVersions.length))
                                    message.forecastModelVersions = [];
                                message.forecastModelVersions.push($root.palexy.streaming.v1.ForecastModelVersion.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListForecastModelVersionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListForecastModelVersionResponse} ListForecastModelVersionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListForecastModelVersionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListForecastModelVersionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListForecastModelVersionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.forecastModelVersions != null && message.hasOwnProperty("forecastModelVersions")) {
                            if (!Array.isArray(message.forecastModelVersions))
                                return "forecastModelVersions: array expected";
                            for (var i = 0; i < message.forecastModelVersions.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastModelVersion.verify(message.forecastModelVersions[i]);
                                if (error)
                                    return "forecastModelVersions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListForecastModelVersionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListForecastModelVersionResponse} ListForecastModelVersionResponse
                     */
                    ListForecastModelVersionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListForecastModelVersionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListForecastModelVersionResponse();
                        if (object.forecastModelVersions) {
                            if (!Array.isArray(object.forecastModelVersions))
                                throw TypeError(".palexy.streaming.v1.ListForecastModelVersionResponse.forecastModelVersions: array expected");
                            message.forecastModelVersions = [];
                            for (var i = 0; i < object.forecastModelVersions.length; ++i) {
                                if (typeof object.forecastModelVersions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListForecastModelVersionResponse.forecastModelVersions: object expected");
                                message.forecastModelVersions[i] = $root.palexy.streaming.v1.ForecastModelVersion.fromObject(object.forecastModelVersions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListForecastModelVersionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @static
                     * @param {palexy.streaming.v1.ListForecastModelVersionResponse} message ListForecastModelVersionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListForecastModelVersionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.forecastModelVersions = [];
                        if (message.forecastModelVersions && message.forecastModelVersions.length) {
                            object.forecastModelVersions = [];
                            for (var j = 0; j < message.forecastModelVersions.length; ++j)
                                object.forecastModelVersions[j] = $root.palexy.streaming.v1.ForecastModelVersion.toObject(message.forecastModelVersions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListForecastModelVersionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListForecastModelVersionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListForecastModelVersionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListForecastModelVersionResponse;
                })();
    
                v1.GetForecastModelVersionRequest = (function() {
    
                    /**
                     * Properties of a GetForecastModelVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetForecastModelVersionRequest
                     * @property {number|null} [modelId] GetForecastModelVersionRequest modelId
                     * @property {number|null} [versionId] GetForecastModelVersionRequest versionId
                     */
    
                    /**
                     * Constructs a new GetForecastModelVersionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetForecastModelVersionRequest.
                     * @implements IGetForecastModelVersionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest=} [properties] Properties to set
                     */
                    function GetForecastModelVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetForecastModelVersionRequest modelId.
                     * @member {number} modelId
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @instance
                     */
                    GetForecastModelVersionRequest.prototype.modelId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetForecastModelVersionRequest versionId.
                     * @member {number} versionId
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @instance
                     */
                    GetForecastModelVersionRequest.prototype.versionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetForecastModelVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetForecastModelVersionRequest} GetForecastModelVersionRequest instance
                     */
                    GetForecastModelVersionRequest.create = function create(properties) {
                        return new GetForecastModelVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetForecastModelVersionRequest message. Does not implicitly {@link palexy.streaming.v1.GetForecastModelVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest} message GetForecastModelVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetForecastModelVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.modelId != null && Object.hasOwnProperty.call(message, "modelId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.modelId);
                        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.versionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetForecastModelVersionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetForecastModelVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetForecastModelVersionRequest} message GetForecastModelVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetForecastModelVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetForecastModelVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetForecastModelVersionRequest} GetForecastModelVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetForecastModelVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetForecastModelVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.modelId = reader.int64();
                                break;
                            case 2:
                                message.versionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetForecastModelVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetForecastModelVersionRequest} GetForecastModelVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetForecastModelVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetForecastModelVersionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetForecastModelVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.modelId != null && message.hasOwnProperty("modelId"))
                            if (!$util.isInteger(message.modelId) && !(message.modelId && $util.isInteger(message.modelId.low) && $util.isInteger(message.modelId.high)))
                                return "modelId: integer|Long expected";
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (!$util.isInteger(message.versionId) && !(message.versionId && $util.isInteger(message.versionId.low) && $util.isInteger(message.versionId.high)))
                                return "versionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetForecastModelVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetForecastModelVersionRequest} GetForecastModelVersionRequest
                     */
                    GetForecastModelVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetForecastModelVersionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetForecastModelVersionRequest();
                        if (object.modelId != null)
                            if ($util.Long)
                                (message.modelId = $util.Long.fromValue(object.modelId)).unsigned = false;
                            else if (typeof object.modelId === "string")
                                message.modelId = parseInt(object.modelId, 10);
                            else if (typeof object.modelId === "number")
                                message.modelId = object.modelId;
                            else if (typeof object.modelId === "object")
                                message.modelId = new $util.LongBits(object.modelId.low >>> 0, object.modelId.high >>> 0).toNumber();
                        if (object.versionId != null)
                            if ($util.Long)
                                (message.versionId = $util.Long.fromValue(object.versionId)).unsigned = false;
                            else if (typeof object.versionId === "string")
                                message.versionId = parseInt(object.versionId, 10);
                            else if (typeof object.versionId === "number")
                                message.versionId = object.versionId;
                            else if (typeof object.versionId === "object")
                                message.versionId = new $util.LongBits(object.versionId.low >>> 0, object.versionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetForecastModelVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @static
                     * @param {palexy.streaming.v1.GetForecastModelVersionRequest} message GetForecastModelVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetForecastModelVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.modelId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.modelId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.versionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.versionId = options.longs === String ? "0" : 0;
                        }
                        if (message.modelId != null && message.hasOwnProperty("modelId"))
                            if (typeof message.modelId === "number")
                                object.modelId = options.longs === String ? String(message.modelId) : message.modelId;
                            else
                                object.modelId = options.longs === String ? $util.Long.prototype.toString.call(message.modelId) : options.longs === Number ? new $util.LongBits(message.modelId.low >>> 0, message.modelId.high >>> 0).toNumber() : message.modelId;
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (typeof message.versionId === "number")
                                object.versionId = options.longs === String ? String(message.versionId) : message.versionId;
                            else
                                object.versionId = options.longs === String ? $util.Long.prototype.toString.call(message.versionId) : options.longs === Number ? new $util.LongBits(message.versionId.low >>> 0, message.versionId.high >>> 0).toNumber() : message.versionId;
                        return object;
                    };
    
                    /**
                     * Converts this GetForecastModelVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetForecastModelVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetForecastModelVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetForecastModelVersionRequest;
                })();
    
                v1.TriggerCreateTasksRequest = (function() {
    
                    /**
                     * Properties of a TriggerCreateTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerCreateTasksRequest
                     */
    
                    /**
                     * Constructs a new TriggerCreateTasksRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerCreateTasksRequest.
                     * @implements ITriggerCreateTasksRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest=} [properties] Properties to set
                     */
                    function TriggerCreateTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new TriggerCreateTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerCreateTasksRequest} TriggerCreateTasksRequest instance
                     */
                    TriggerCreateTasksRequest.create = function create(properties) {
                        return new TriggerCreateTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerCreateTasksRequest message. Does not implicitly {@link palexy.streaming.v1.TriggerCreateTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest} message TriggerCreateTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerCreateTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerCreateTasksRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerCreateTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerCreateTasksRequest} message TriggerCreateTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerCreateTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerCreateTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerCreateTasksRequest} TriggerCreateTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerCreateTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerCreateTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerCreateTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerCreateTasksRequest} TriggerCreateTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerCreateTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerCreateTasksRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerCreateTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a TriggerCreateTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerCreateTasksRequest} TriggerCreateTasksRequest
                     */
                    TriggerCreateTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerCreateTasksRequest)
                            return object;
                        return new $root.palexy.streaming.v1.TriggerCreateTasksRequest();
                    };
    
                    /**
                     * Creates a plain object from a TriggerCreateTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @static
                     * @param {palexy.streaming.v1.TriggerCreateTasksRequest} message TriggerCreateTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerCreateTasksRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this TriggerCreateTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerCreateTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerCreateTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerCreateTasksRequest;
                })();
    
                v1.BatchCreatePredictionRequest = (function() {
    
                    /**
                     * Properties of a BatchCreatePredictionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreatePredictionRequest
                     * @property {Array.<palexy.streaming.v1.IForecastPrediction>|null} [predictions] BatchCreatePredictionRequest predictions
                     * @property {Array.<palexy.streaming.v1.IForecastSectionWholeDay>|null} [sectionWholeDayForecasts] BatchCreatePredictionRequest sectionWholeDayForecasts
                     * @property {Array.<palexy.streaming.v1.IForecastSectionHour>|null} [sectionHourForecasts] BatchCreatePredictionRequest sectionHourForecasts
                     */
    
                    /**
                     * Constructs a new BatchCreatePredictionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreatePredictionRequest.
                     * @implements IBatchCreatePredictionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest=} [properties] Properties to set
                     */
                    function BatchCreatePredictionRequest(properties) {
                        this.predictions = [];
                        this.sectionWholeDayForecasts = [];
                        this.sectionHourForecasts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreatePredictionRequest predictions.
                     * @member {Array.<palexy.streaming.v1.IForecastPrediction>} predictions
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @instance
                     */
                    BatchCreatePredictionRequest.prototype.predictions = $util.emptyArray;
    
                    /**
                     * BatchCreatePredictionRequest sectionWholeDayForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionWholeDay>} sectionWholeDayForecasts
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @instance
                     */
                    BatchCreatePredictionRequest.prototype.sectionWholeDayForecasts = $util.emptyArray;
    
                    /**
                     * BatchCreatePredictionRequest sectionHourForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionHour>} sectionHourForecasts
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @instance
                     */
                    BatchCreatePredictionRequest.prototype.sectionHourForecasts = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreatePredictionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreatePredictionRequest} BatchCreatePredictionRequest instance
                     */
                    BatchCreatePredictionRequest.create = function create(properties) {
                        return new BatchCreatePredictionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreatePredictionRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreatePredictionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest} message BatchCreatePredictionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreatePredictionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.predictions != null && message.predictions.length)
                            for (var i = 0; i < message.predictions.length; ++i)
                                $root.palexy.streaming.v1.ForecastPrediction.encode(message.predictions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.sectionWholeDayForecasts != null && message.sectionWholeDayForecasts.length)
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionWholeDay.encode(message.sectionWholeDayForecasts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.sectionHourForecasts != null && message.sectionHourForecasts.length)
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionHour.encode(message.sectionHourForecasts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreatePredictionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreatePredictionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionRequest} message BatchCreatePredictionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreatePredictionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreatePredictionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreatePredictionRequest} BatchCreatePredictionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreatePredictionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreatePredictionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.predictions && message.predictions.length))
                                    message.predictions = [];
                                message.predictions.push($root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length))
                                    message.sectionWholeDayForecasts = [];
                                message.sectionWholeDayForecasts.push($root.palexy.streaming.v1.ForecastSectionWholeDay.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.sectionHourForecasts && message.sectionHourForecasts.length))
                                    message.sectionHourForecasts = [];
                                message.sectionHourForecasts.push($root.palexy.streaming.v1.ForecastSectionHour.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreatePredictionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreatePredictionRequest} BatchCreatePredictionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreatePredictionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreatePredictionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreatePredictionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.predictions != null && message.hasOwnProperty("predictions")) {
                            if (!Array.isArray(message.predictions))
                                return "predictions: array expected";
                            for (var i = 0; i < message.predictions.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.predictions[i]);
                                if (error)
                                    return "predictions." + error;
                            }
                        }
                        if (message.sectionWholeDayForecasts != null && message.hasOwnProperty("sectionWholeDayForecasts")) {
                            if (!Array.isArray(message.sectionWholeDayForecasts))
                                return "sectionWholeDayForecasts: array expected";
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionWholeDay.verify(message.sectionWholeDayForecasts[i]);
                                if (error)
                                    return "sectionWholeDayForecasts." + error;
                            }
                        }
                        if (message.sectionHourForecasts != null && message.hasOwnProperty("sectionHourForecasts")) {
                            if (!Array.isArray(message.sectionHourForecasts))
                                return "sectionHourForecasts: array expected";
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionHour.verify(message.sectionHourForecasts[i]);
                                if (error)
                                    return "sectionHourForecasts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreatePredictionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreatePredictionRequest} BatchCreatePredictionRequest
                     */
                    BatchCreatePredictionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreatePredictionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreatePredictionRequest();
                        if (object.predictions) {
                            if (!Array.isArray(object.predictions))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.predictions: array expected");
                            message.predictions = [];
                            for (var i = 0; i < object.predictions.length; ++i) {
                                if (typeof object.predictions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.predictions: object expected");
                                message.predictions[i] = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.predictions[i]);
                            }
                        }
                        if (object.sectionWholeDayForecasts) {
                            if (!Array.isArray(object.sectionWholeDayForecasts))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.sectionWholeDayForecasts: array expected");
                            message.sectionWholeDayForecasts = [];
                            for (var i = 0; i < object.sectionWholeDayForecasts.length; ++i) {
                                if (typeof object.sectionWholeDayForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.sectionWholeDayForecasts: object expected");
                                message.sectionWholeDayForecasts[i] = $root.palexy.streaming.v1.ForecastSectionWholeDay.fromObject(object.sectionWholeDayForecasts[i]);
                            }
                        }
                        if (object.sectionHourForecasts) {
                            if (!Array.isArray(object.sectionHourForecasts))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.sectionHourForecasts: array expected");
                            message.sectionHourForecasts = [];
                            for (var i = 0; i < object.sectionHourForecasts.length; ++i) {
                                if (typeof object.sectionHourForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionRequest.sectionHourForecasts: object expected");
                                message.sectionHourForecasts[i] = $root.palexy.streaming.v1.ForecastSectionHour.fromObject(object.sectionHourForecasts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreatePredictionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreatePredictionRequest} message BatchCreatePredictionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreatePredictionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.predictions = [];
                            object.sectionWholeDayForecasts = [];
                            object.sectionHourForecasts = [];
                        }
                        if (message.predictions && message.predictions.length) {
                            object.predictions = [];
                            for (var j = 0; j < message.predictions.length; ++j)
                                object.predictions[j] = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.predictions[j], options);
                        }
                        if (message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length) {
                            object.sectionWholeDayForecasts = [];
                            for (var j = 0; j < message.sectionWholeDayForecasts.length; ++j)
                                object.sectionWholeDayForecasts[j] = $root.palexy.streaming.v1.ForecastSectionWholeDay.toObject(message.sectionWholeDayForecasts[j], options);
                        }
                        if (message.sectionHourForecasts && message.sectionHourForecasts.length) {
                            object.sectionHourForecasts = [];
                            for (var j = 0; j < message.sectionHourForecasts.length; ++j)
                                object.sectionHourForecasts[j] = $root.palexy.streaming.v1.ForecastSectionHour.toObject(message.sectionHourForecasts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreatePredictionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreatePredictionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreatePredictionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreatePredictionRequest;
                })();
    
                v1.BatchCreatePredictionResponse = (function() {
    
                    /**
                     * Properties of a BatchCreatePredictionResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreatePredictionResponse
                     * @property {Array.<palexy.streaming.v1.IForecastPrediction>|null} [predictions] BatchCreatePredictionResponse predictions
                     * @property {Array.<palexy.streaming.v1.IForecastSectionWholeDay>|null} [sectionWholeDayForecasts] BatchCreatePredictionResponse sectionWholeDayForecasts
                     * @property {Array.<palexy.streaming.v1.IForecastSectionHour>|null} [sectionHourForecasts] BatchCreatePredictionResponse sectionHourForecasts
                     */
    
                    /**
                     * Constructs a new BatchCreatePredictionResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreatePredictionResponse.
                     * @implements IBatchCreatePredictionResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreatePredictionResponse=} [properties] Properties to set
                     */
                    function BatchCreatePredictionResponse(properties) {
                        this.predictions = [];
                        this.sectionWholeDayForecasts = [];
                        this.sectionHourForecasts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreatePredictionResponse predictions.
                     * @member {Array.<palexy.streaming.v1.IForecastPrediction>} predictions
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @instance
                     */
                    BatchCreatePredictionResponse.prototype.predictions = $util.emptyArray;
    
                    /**
                     * BatchCreatePredictionResponse sectionWholeDayForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionWholeDay>} sectionWholeDayForecasts
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @instance
                     */
                    BatchCreatePredictionResponse.prototype.sectionWholeDayForecasts = $util.emptyArray;
    
                    /**
                     * BatchCreatePredictionResponse sectionHourForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionHour>} sectionHourForecasts
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @instance
                     */
                    BatchCreatePredictionResponse.prototype.sectionHourForecasts = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreatePredictionResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreatePredictionResponse} BatchCreatePredictionResponse instance
                     */
                    BatchCreatePredictionResponse.create = function create(properties) {
                        return new BatchCreatePredictionResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreatePredictionResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreatePredictionResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionResponse} message BatchCreatePredictionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreatePredictionResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.predictions != null && message.predictions.length)
                            for (var i = 0; i < message.predictions.length; ++i)
                                $root.palexy.streaming.v1.ForecastPrediction.encode(message.predictions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.sectionWholeDayForecasts != null && message.sectionWholeDayForecasts.length)
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionWholeDay.encode(message.sectionWholeDayForecasts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.sectionHourForecasts != null && message.sectionHourForecasts.length)
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionHour.encode(message.sectionHourForecasts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreatePredictionResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreatePredictionResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreatePredictionResponse} message BatchCreatePredictionResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreatePredictionResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreatePredictionResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreatePredictionResponse} BatchCreatePredictionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreatePredictionResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreatePredictionResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.predictions && message.predictions.length))
                                    message.predictions = [];
                                message.predictions.push($root.palexy.streaming.v1.ForecastPrediction.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length))
                                    message.sectionWholeDayForecasts = [];
                                message.sectionWholeDayForecasts.push($root.palexy.streaming.v1.ForecastSectionWholeDay.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.sectionHourForecasts && message.sectionHourForecasts.length))
                                    message.sectionHourForecasts = [];
                                message.sectionHourForecasts.push($root.palexy.streaming.v1.ForecastSectionHour.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreatePredictionResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreatePredictionResponse} BatchCreatePredictionResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreatePredictionResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreatePredictionResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreatePredictionResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.predictions != null && message.hasOwnProperty("predictions")) {
                            if (!Array.isArray(message.predictions))
                                return "predictions: array expected";
                            for (var i = 0; i < message.predictions.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastPrediction.verify(message.predictions[i]);
                                if (error)
                                    return "predictions." + error;
                            }
                        }
                        if (message.sectionWholeDayForecasts != null && message.hasOwnProperty("sectionWholeDayForecasts")) {
                            if (!Array.isArray(message.sectionWholeDayForecasts))
                                return "sectionWholeDayForecasts: array expected";
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionWholeDay.verify(message.sectionWholeDayForecasts[i]);
                                if (error)
                                    return "sectionWholeDayForecasts." + error;
                            }
                        }
                        if (message.sectionHourForecasts != null && message.hasOwnProperty("sectionHourForecasts")) {
                            if (!Array.isArray(message.sectionHourForecasts))
                                return "sectionHourForecasts: array expected";
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionHour.verify(message.sectionHourForecasts[i]);
                                if (error)
                                    return "sectionHourForecasts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreatePredictionResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreatePredictionResponse} BatchCreatePredictionResponse
                     */
                    BatchCreatePredictionResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreatePredictionResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreatePredictionResponse();
                        if (object.predictions) {
                            if (!Array.isArray(object.predictions))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.predictions: array expected");
                            message.predictions = [];
                            for (var i = 0; i < object.predictions.length; ++i) {
                                if (typeof object.predictions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.predictions: object expected");
                                message.predictions[i] = $root.palexy.streaming.v1.ForecastPrediction.fromObject(object.predictions[i]);
                            }
                        }
                        if (object.sectionWholeDayForecasts) {
                            if (!Array.isArray(object.sectionWholeDayForecasts))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.sectionWholeDayForecasts: array expected");
                            message.sectionWholeDayForecasts = [];
                            for (var i = 0; i < object.sectionWholeDayForecasts.length; ++i) {
                                if (typeof object.sectionWholeDayForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.sectionWholeDayForecasts: object expected");
                                message.sectionWholeDayForecasts[i] = $root.palexy.streaming.v1.ForecastSectionWholeDay.fromObject(object.sectionWholeDayForecasts[i]);
                            }
                        }
                        if (object.sectionHourForecasts) {
                            if (!Array.isArray(object.sectionHourForecasts))
                                throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.sectionHourForecasts: array expected");
                            message.sectionHourForecasts = [];
                            for (var i = 0; i < object.sectionHourForecasts.length; ++i) {
                                if (typeof object.sectionHourForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreatePredictionResponse.sectionHourForecasts: object expected");
                                message.sectionHourForecasts[i] = $root.palexy.streaming.v1.ForecastSectionHour.fromObject(object.sectionHourForecasts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreatePredictionResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreatePredictionResponse} message BatchCreatePredictionResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreatePredictionResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.predictions = [];
                            object.sectionWholeDayForecasts = [];
                            object.sectionHourForecasts = [];
                        }
                        if (message.predictions && message.predictions.length) {
                            object.predictions = [];
                            for (var j = 0; j < message.predictions.length; ++j)
                                object.predictions[j] = $root.palexy.streaming.v1.ForecastPrediction.toObject(message.predictions[j], options);
                        }
                        if (message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length) {
                            object.sectionWholeDayForecasts = [];
                            for (var j = 0; j < message.sectionWholeDayForecasts.length; ++j)
                                object.sectionWholeDayForecasts[j] = $root.palexy.streaming.v1.ForecastSectionWholeDay.toObject(message.sectionWholeDayForecasts[j], options);
                        }
                        if (message.sectionHourForecasts && message.sectionHourForecasts.length) {
                            object.sectionHourForecasts = [];
                            for (var j = 0; j < message.sectionHourForecasts.length; ++j)
                                object.sectionHourForecasts[j] = $root.palexy.streaming.v1.ForecastSectionHour.toObject(message.sectionHourForecasts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreatePredictionResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreatePredictionResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreatePredictionResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreatePredictionResponse;
                })();
    
                v1.CleanupStaleForecastDataRequest = (function() {
    
                    /**
                     * Properties of a CleanupStaleForecastDataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICleanupStaleForecastDataRequest
                     * @property {Array.<number>|null} [companyIds] CleanupStaleForecastDataRequest companyIds
                     * @property {boolean|null} [dryRun] CleanupStaleForecastDataRequest dryRun
                     */
    
                    /**
                     * Constructs a new CleanupStaleForecastDataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CleanupStaleForecastDataRequest.
                     * @implements ICleanupStaleForecastDataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest=} [properties] Properties to set
                     */
                    function CleanupStaleForecastDataRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CleanupStaleForecastDataRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @instance
                     */
                    CleanupStaleForecastDataRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * CleanupStaleForecastDataRequest dryRun.
                     * @member {boolean} dryRun
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @instance
                     */
                    CleanupStaleForecastDataRequest.prototype.dryRun = false;
    
                    /**
                     * Creates a new CleanupStaleForecastDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataRequest} CleanupStaleForecastDataRequest instance
                     */
                    CleanupStaleForecastDataRequest.create = function create(properties) {
                        return new CleanupStaleForecastDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CleanupStaleForecastDataRequest message. Does not implicitly {@link palexy.streaming.v1.CleanupStaleForecastDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest} message CleanupStaleForecastDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanupStaleForecastDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        if (message.dryRun != null && Object.hasOwnProperty.call(message, "dryRun"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.dryRun);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CleanupStaleForecastDataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CleanupStaleForecastDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataRequest} message CleanupStaleForecastDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanupStaleForecastDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CleanupStaleForecastDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataRequest} CleanupStaleForecastDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanupStaleForecastDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CleanupStaleForecastDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            case 2:
                                message.dryRun = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CleanupStaleForecastDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataRequest} CleanupStaleForecastDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanupStaleForecastDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CleanupStaleForecastDataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CleanupStaleForecastDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            if (typeof message.dryRun !== "boolean")
                                return "dryRun: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CleanupStaleForecastDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataRequest} CleanupStaleForecastDataRequest
                     */
                    CleanupStaleForecastDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CleanupStaleForecastDataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CleanupStaleForecastDataRequest();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.CleanupStaleForecastDataRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        if (object.dryRun != null)
                            message.dryRun = Boolean(object.dryRun);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CleanupStaleForecastDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @static
                     * @param {palexy.streaming.v1.CleanupStaleForecastDataRequest} message CleanupStaleForecastDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CleanupStaleForecastDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (options.defaults)
                            object.dryRun = false;
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            object.dryRun = message.dryRun;
                        return object;
                    };
    
                    /**
                     * Converts this CleanupStaleForecastDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CleanupStaleForecastDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CleanupStaleForecastDataRequest;
                })();
    
                v1.CleanupStaleForecastDataResponse = (function() {
    
                    /**
                     * Properties of a CleanupStaleForecastDataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICleanupStaleForecastDataResponse
                     * @property {boolean|null} [dryRun] CleanupStaleForecastDataResponse dryRun
                     * @property {Array.<palexy.streaming.v1.ICompanyForecastCleanupResult>|null} [results] CleanupStaleForecastDataResponse results
                     * @property {number|null} [totalStaleWholeDayRows] CleanupStaleForecastDataResponse totalStaleWholeDayRows
                     * @property {number|null} [totalStaleHourRows] CleanupStaleForecastDataResponse totalStaleHourRows
                     * @property {number|null} [totalStaleInfluenceFactorRows] CleanupStaleForecastDataResponse totalStaleInfluenceFactorRows
                     * @property {number|null} [deletedPredictionRows] CleanupStaleForecastDataResponse deletedPredictionRows
                     */
    
                    /**
                     * Constructs a new CleanupStaleForecastDataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CleanupStaleForecastDataResponse.
                     * @implements ICleanupStaleForecastDataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataResponse=} [properties] Properties to set
                     */
                    function CleanupStaleForecastDataResponse(properties) {
                        this.results = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CleanupStaleForecastDataResponse dryRun.
                     * @member {boolean} dryRun
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.dryRun = false;
    
                    /**
                     * CleanupStaleForecastDataResponse results.
                     * @member {Array.<palexy.streaming.v1.ICompanyForecastCleanupResult>} results
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.results = $util.emptyArray;
    
                    /**
                     * CleanupStaleForecastDataResponse totalStaleWholeDayRows.
                     * @member {number} totalStaleWholeDayRows
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.totalStaleWholeDayRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CleanupStaleForecastDataResponse totalStaleHourRows.
                     * @member {number} totalStaleHourRows
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.totalStaleHourRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CleanupStaleForecastDataResponse totalStaleInfluenceFactorRows.
                     * @member {number} totalStaleInfluenceFactorRows
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.totalStaleInfluenceFactorRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CleanupStaleForecastDataResponse deletedPredictionRows.
                     * @member {number} deletedPredictionRows
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     */
                    CleanupStaleForecastDataResponse.prototype.deletedPredictionRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CleanupStaleForecastDataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataResponse} CleanupStaleForecastDataResponse instance
                     */
                    CleanupStaleForecastDataResponse.create = function create(properties) {
                        return new CleanupStaleForecastDataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CleanupStaleForecastDataResponse message. Does not implicitly {@link palexy.streaming.v1.CleanupStaleForecastDataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataResponse} message CleanupStaleForecastDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanupStaleForecastDataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dryRun != null && Object.hasOwnProperty.call(message, "dryRun"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.dryRun);
                        if (message.results != null && message.results.length)
                            for (var i = 0; i < message.results.length; ++i)
                                $root.palexy.streaming.v1.CompanyForecastCleanupResult.encode(message.results[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.totalStaleWholeDayRows != null && Object.hasOwnProperty.call(message, "totalStaleWholeDayRows"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalStaleWholeDayRows);
                        if (message.totalStaleHourRows != null && Object.hasOwnProperty.call(message, "totalStaleHourRows"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalStaleHourRows);
                        if (message.totalStaleInfluenceFactorRows != null && Object.hasOwnProperty.call(message, "totalStaleInfluenceFactorRows"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.totalStaleInfluenceFactorRows);
                        if (message.deletedPredictionRows != null && Object.hasOwnProperty.call(message, "deletedPredictionRows"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.deletedPredictionRows);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CleanupStaleForecastDataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CleanupStaleForecastDataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICleanupStaleForecastDataResponse} message CleanupStaleForecastDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanupStaleForecastDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CleanupStaleForecastDataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataResponse} CleanupStaleForecastDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanupStaleForecastDataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CleanupStaleForecastDataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dryRun = reader.bool();
                                break;
                            case 2:
                                if (!(message.results && message.results.length))
                                    message.results = [];
                                message.results.push($root.palexy.streaming.v1.CompanyForecastCleanupResult.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.totalStaleWholeDayRows = reader.int64();
                                break;
                            case 4:
                                message.totalStaleHourRows = reader.int64();
                                break;
                            case 5:
                                message.totalStaleInfluenceFactorRows = reader.int64();
                                break;
                            case 6:
                                message.deletedPredictionRows = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CleanupStaleForecastDataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataResponse} CleanupStaleForecastDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanupStaleForecastDataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CleanupStaleForecastDataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CleanupStaleForecastDataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            if (typeof message.dryRun !== "boolean")
                                return "dryRun: boolean expected";
                        if (message.results != null && message.hasOwnProperty("results")) {
                            if (!Array.isArray(message.results))
                                return "results: array expected";
                            for (var i = 0; i < message.results.length; ++i) {
                                var error = $root.palexy.streaming.v1.CompanyForecastCleanupResult.verify(message.results[i]);
                                if (error)
                                    return "results." + error;
                            }
                        }
                        if (message.totalStaleWholeDayRows != null && message.hasOwnProperty("totalStaleWholeDayRows"))
                            if (!$util.isInteger(message.totalStaleWholeDayRows) && !(message.totalStaleWholeDayRows && $util.isInteger(message.totalStaleWholeDayRows.low) && $util.isInteger(message.totalStaleWholeDayRows.high)))
                                return "totalStaleWholeDayRows: integer|Long expected";
                        if (message.totalStaleHourRows != null && message.hasOwnProperty("totalStaleHourRows"))
                            if (!$util.isInteger(message.totalStaleHourRows) && !(message.totalStaleHourRows && $util.isInteger(message.totalStaleHourRows.low) && $util.isInteger(message.totalStaleHourRows.high)))
                                return "totalStaleHourRows: integer|Long expected";
                        if (message.totalStaleInfluenceFactorRows != null && message.hasOwnProperty("totalStaleInfluenceFactorRows"))
                            if (!$util.isInteger(message.totalStaleInfluenceFactorRows) && !(message.totalStaleInfluenceFactorRows && $util.isInteger(message.totalStaleInfluenceFactorRows.low) && $util.isInteger(message.totalStaleInfluenceFactorRows.high)))
                                return "totalStaleInfluenceFactorRows: integer|Long expected";
                        if (message.deletedPredictionRows != null && message.hasOwnProperty("deletedPredictionRows"))
                            if (!$util.isInteger(message.deletedPredictionRows) && !(message.deletedPredictionRows && $util.isInteger(message.deletedPredictionRows.low) && $util.isInteger(message.deletedPredictionRows.high)))
                                return "deletedPredictionRows: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CleanupStaleForecastDataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CleanupStaleForecastDataResponse} CleanupStaleForecastDataResponse
                     */
                    CleanupStaleForecastDataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CleanupStaleForecastDataResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.CleanupStaleForecastDataResponse();
                        if (object.dryRun != null)
                            message.dryRun = Boolean(object.dryRun);
                        if (object.results) {
                            if (!Array.isArray(object.results))
                                throw TypeError(".palexy.streaming.v1.CleanupStaleForecastDataResponse.results: array expected");
                            message.results = [];
                            for (var i = 0; i < object.results.length; ++i) {
                                if (typeof object.results[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CleanupStaleForecastDataResponse.results: object expected");
                                message.results[i] = $root.palexy.streaming.v1.CompanyForecastCleanupResult.fromObject(object.results[i]);
                            }
                        }
                        if (object.totalStaleWholeDayRows != null)
                            if ($util.Long)
                                (message.totalStaleWholeDayRows = $util.Long.fromValue(object.totalStaleWholeDayRows)).unsigned = false;
                            else if (typeof object.totalStaleWholeDayRows === "string")
                                message.totalStaleWholeDayRows = parseInt(object.totalStaleWholeDayRows, 10);
                            else if (typeof object.totalStaleWholeDayRows === "number")
                                message.totalStaleWholeDayRows = object.totalStaleWholeDayRows;
                            else if (typeof object.totalStaleWholeDayRows === "object")
                                message.totalStaleWholeDayRows = new $util.LongBits(object.totalStaleWholeDayRows.low >>> 0, object.totalStaleWholeDayRows.high >>> 0).toNumber();
                        if (object.totalStaleHourRows != null)
                            if ($util.Long)
                                (message.totalStaleHourRows = $util.Long.fromValue(object.totalStaleHourRows)).unsigned = false;
                            else if (typeof object.totalStaleHourRows === "string")
                                message.totalStaleHourRows = parseInt(object.totalStaleHourRows, 10);
                            else if (typeof object.totalStaleHourRows === "number")
                                message.totalStaleHourRows = object.totalStaleHourRows;
                            else if (typeof object.totalStaleHourRows === "object")
                                message.totalStaleHourRows = new $util.LongBits(object.totalStaleHourRows.low >>> 0, object.totalStaleHourRows.high >>> 0).toNumber();
                        if (object.totalStaleInfluenceFactorRows != null)
                            if ($util.Long)
                                (message.totalStaleInfluenceFactorRows = $util.Long.fromValue(object.totalStaleInfluenceFactorRows)).unsigned = false;
                            else if (typeof object.totalStaleInfluenceFactorRows === "string")
                                message.totalStaleInfluenceFactorRows = parseInt(object.totalStaleInfluenceFactorRows, 10);
                            else if (typeof object.totalStaleInfluenceFactorRows === "number")
                                message.totalStaleInfluenceFactorRows = object.totalStaleInfluenceFactorRows;
                            else if (typeof object.totalStaleInfluenceFactorRows === "object")
                                message.totalStaleInfluenceFactorRows = new $util.LongBits(object.totalStaleInfluenceFactorRows.low >>> 0, object.totalStaleInfluenceFactorRows.high >>> 0).toNumber();
                        if (object.deletedPredictionRows != null)
                            if ($util.Long)
                                (message.deletedPredictionRows = $util.Long.fromValue(object.deletedPredictionRows)).unsigned = false;
                            else if (typeof object.deletedPredictionRows === "string")
                                message.deletedPredictionRows = parseInt(object.deletedPredictionRows, 10);
                            else if (typeof object.deletedPredictionRows === "number")
                                message.deletedPredictionRows = object.deletedPredictionRows;
                            else if (typeof object.deletedPredictionRows === "object")
                                message.deletedPredictionRows = new $util.LongBits(object.deletedPredictionRows.low >>> 0, object.deletedPredictionRows.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CleanupStaleForecastDataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @static
                     * @param {palexy.streaming.v1.CleanupStaleForecastDataResponse} message CleanupStaleForecastDataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CleanupStaleForecastDataResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.results = [];
                        if (options.defaults) {
                            object.dryRun = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalStaleWholeDayRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalStaleWholeDayRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalStaleHourRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalStaleHourRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalStaleInfluenceFactorRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalStaleInfluenceFactorRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.deletedPredictionRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.deletedPredictionRows = options.longs === String ? "0" : 0;
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            object.dryRun = message.dryRun;
                        if (message.results && message.results.length) {
                            object.results = [];
                            for (var j = 0; j < message.results.length; ++j)
                                object.results[j] = $root.palexy.streaming.v1.CompanyForecastCleanupResult.toObject(message.results[j], options);
                        }
                        if (message.totalStaleWholeDayRows != null && message.hasOwnProperty("totalStaleWholeDayRows"))
                            if (typeof message.totalStaleWholeDayRows === "number")
                                object.totalStaleWholeDayRows = options.longs === String ? String(message.totalStaleWholeDayRows) : message.totalStaleWholeDayRows;
                            else
                                object.totalStaleWholeDayRows = options.longs === String ? $util.Long.prototype.toString.call(message.totalStaleWholeDayRows) : options.longs === Number ? new $util.LongBits(message.totalStaleWholeDayRows.low >>> 0, message.totalStaleWholeDayRows.high >>> 0).toNumber() : message.totalStaleWholeDayRows;
                        if (message.totalStaleHourRows != null && message.hasOwnProperty("totalStaleHourRows"))
                            if (typeof message.totalStaleHourRows === "number")
                                object.totalStaleHourRows = options.longs === String ? String(message.totalStaleHourRows) : message.totalStaleHourRows;
                            else
                                object.totalStaleHourRows = options.longs === String ? $util.Long.prototype.toString.call(message.totalStaleHourRows) : options.longs === Number ? new $util.LongBits(message.totalStaleHourRows.low >>> 0, message.totalStaleHourRows.high >>> 0).toNumber() : message.totalStaleHourRows;
                        if (message.totalStaleInfluenceFactorRows != null && message.hasOwnProperty("totalStaleInfluenceFactorRows"))
                            if (typeof message.totalStaleInfluenceFactorRows === "number")
                                object.totalStaleInfluenceFactorRows = options.longs === String ? String(message.totalStaleInfluenceFactorRows) : message.totalStaleInfluenceFactorRows;
                            else
                                object.totalStaleInfluenceFactorRows = options.longs === String ? $util.Long.prototype.toString.call(message.totalStaleInfluenceFactorRows) : options.longs === Number ? new $util.LongBits(message.totalStaleInfluenceFactorRows.low >>> 0, message.totalStaleInfluenceFactorRows.high >>> 0).toNumber() : message.totalStaleInfluenceFactorRows;
                        if (message.deletedPredictionRows != null && message.hasOwnProperty("deletedPredictionRows"))
                            if (typeof message.deletedPredictionRows === "number")
                                object.deletedPredictionRows = options.longs === String ? String(message.deletedPredictionRows) : message.deletedPredictionRows;
                            else
                                object.deletedPredictionRows = options.longs === String ? $util.Long.prototype.toString.call(message.deletedPredictionRows) : options.longs === Number ? new $util.LongBits(message.deletedPredictionRows.low >>> 0, message.deletedPredictionRows.high >>> 0).toNumber() : message.deletedPredictionRows;
                        return object;
                    };
    
                    /**
                     * Converts this CleanupStaleForecastDataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CleanupStaleForecastDataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CleanupStaleForecastDataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CleanupStaleForecastDataResponse;
                })();
    
                v1.CompanyForecastCleanupResult = (function() {
    
                    /**
                     * Properties of a CompanyForecastCleanupResult.
                     * @memberof palexy.streaming.v1
                     * @interface ICompanyForecastCleanupResult
                     * @property {number|null} [companyId] CompanyForecastCleanupResult companyId
                     * @property {boolean|null} [hasStaleData] CompanyForecastCleanupResult hasStaleData
                     * @property {number|null} [staleWholeDayRows] CompanyForecastCleanupResult staleWholeDayRows
                     * @property {number|null} [staleHourRows] CompanyForecastCleanupResult staleHourRows
                     * @property {number|null} [staleInfluenceFactorRows] CompanyForecastCleanupResult staleInfluenceFactorRows
                     */
    
                    /**
                     * Constructs a new CompanyForecastCleanupResult.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CompanyForecastCleanupResult.
                     * @implements ICompanyForecastCleanupResult
                     * @constructor
                     * @param {palexy.streaming.v1.ICompanyForecastCleanupResult=} [properties] Properties to set
                     */
                    function CompanyForecastCleanupResult(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyForecastCleanupResult companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     */
                    CompanyForecastCleanupResult.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyForecastCleanupResult hasStaleData.
                     * @member {boolean} hasStaleData
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     */
                    CompanyForecastCleanupResult.prototype.hasStaleData = false;
    
                    /**
                     * CompanyForecastCleanupResult staleWholeDayRows.
                     * @member {number} staleWholeDayRows
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     */
                    CompanyForecastCleanupResult.prototype.staleWholeDayRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyForecastCleanupResult staleHourRows.
                     * @member {number} staleHourRows
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     */
                    CompanyForecastCleanupResult.prototype.staleHourRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyForecastCleanupResult staleInfluenceFactorRows.
                     * @member {number} staleInfluenceFactorRows
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     */
                    CompanyForecastCleanupResult.prototype.staleInfluenceFactorRows = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CompanyForecastCleanupResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {palexy.streaming.v1.ICompanyForecastCleanupResult=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CompanyForecastCleanupResult} CompanyForecastCleanupResult instance
                     */
                    CompanyForecastCleanupResult.create = function create(properties) {
                        return new CompanyForecastCleanupResult(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyForecastCleanupResult message. Does not implicitly {@link palexy.streaming.v1.CompanyForecastCleanupResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {palexy.streaming.v1.ICompanyForecastCleanupResult} message CompanyForecastCleanupResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyForecastCleanupResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.hasStaleData != null && Object.hasOwnProperty.call(message, "hasStaleData"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.hasStaleData);
                        if (message.staleWholeDayRows != null && Object.hasOwnProperty.call(message, "staleWholeDayRows"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staleWholeDayRows);
                        if (message.staleHourRows != null && Object.hasOwnProperty.call(message, "staleHourRows"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.staleHourRows);
                        if (message.staleInfluenceFactorRows != null && Object.hasOwnProperty.call(message, "staleInfluenceFactorRows"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.staleInfluenceFactorRows);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyForecastCleanupResult message, length delimited. Does not implicitly {@link palexy.streaming.v1.CompanyForecastCleanupResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {palexy.streaming.v1.ICompanyForecastCleanupResult} message CompanyForecastCleanupResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyForecastCleanupResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyForecastCleanupResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CompanyForecastCleanupResult} CompanyForecastCleanupResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyForecastCleanupResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CompanyForecastCleanupResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.hasStaleData = reader.bool();
                                break;
                            case 3:
                                message.staleWholeDayRows = reader.int64();
                                break;
                            case 4:
                                message.staleHourRows = reader.int64();
                                break;
                            case 5:
                                message.staleInfluenceFactorRows = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyForecastCleanupResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CompanyForecastCleanupResult} CompanyForecastCleanupResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyForecastCleanupResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyForecastCleanupResult message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyForecastCleanupResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.hasStaleData != null && message.hasOwnProperty("hasStaleData"))
                            if (typeof message.hasStaleData !== "boolean")
                                return "hasStaleData: boolean expected";
                        if (message.staleWholeDayRows != null && message.hasOwnProperty("staleWholeDayRows"))
                            if (!$util.isInteger(message.staleWholeDayRows) && !(message.staleWholeDayRows && $util.isInteger(message.staleWholeDayRows.low) && $util.isInteger(message.staleWholeDayRows.high)))
                                return "staleWholeDayRows: integer|Long expected";
                        if (message.staleHourRows != null && message.hasOwnProperty("staleHourRows"))
                            if (!$util.isInteger(message.staleHourRows) && !(message.staleHourRows && $util.isInteger(message.staleHourRows.low) && $util.isInteger(message.staleHourRows.high)))
                                return "staleHourRows: integer|Long expected";
                        if (message.staleInfluenceFactorRows != null && message.hasOwnProperty("staleInfluenceFactorRows"))
                            if (!$util.isInteger(message.staleInfluenceFactorRows) && !(message.staleInfluenceFactorRows && $util.isInteger(message.staleInfluenceFactorRows.low) && $util.isInteger(message.staleInfluenceFactorRows.high)))
                                return "staleInfluenceFactorRows: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyForecastCleanupResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CompanyForecastCleanupResult} CompanyForecastCleanupResult
                     */
                    CompanyForecastCleanupResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CompanyForecastCleanupResult)
                            return object;
                        var message = new $root.palexy.streaming.v1.CompanyForecastCleanupResult();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.hasStaleData != null)
                            message.hasStaleData = Boolean(object.hasStaleData);
                        if (object.staleWholeDayRows != null)
                            if ($util.Long)
                                (message.staleWholeDayRows = $util.Long.fromValue(object.staleWholeDayRows)).unsigned = false;
                            else if (typeof object.staleWholeDayRows === "string")
                                message.staleWholeDayRows = parseInt(object.staleWholeDayRows, 10);
                            else if (typeof object.staleWholeDayRows === "number")
                                message.staleWholeDayRows = object.staleWholeDayRows;
                            else if (typeof object.staleWholeDayRows === "object")
                                message.staleWholeDayRows = new $util.LongBits(object.staleWholeDayRows.low >>> 0, object.staleWholeDayRows.high >>> 0).toNumber();
                        if (object.staleHourRows != null)
                            if ($util.Long)
                                (message.staleHourRows = $util.Long.fromValue(object.staleHourRows)).unsigned = false;
                            else if (typeof object.staleHourRows === "string")
                                message.staleHourRows = parseInt(object.staleHourRows, 10);
                            else if (typeof object.staleHourRows === "number")
                                message.staleHourRows = object.staleHourRows;
                            else if (typeof object.staleHourRows === "object")
                                message.staleHourRows = new $util.LongBits(object.staleHourRows.low >>> 0, object.staleHourRows.high >>> 0).toNumber();
                        if (object.staleInfluenceFactorRows != null)
                            if ($util.Long)
                                (message.staleInfluenceFactorRows = $util.Long.fromValue(object.staleInfluenceFactorRows)).unsigned = false;
                            else if (typeof object.staleInfluenceFactorRows === "string")
                                message.staleInfluenceFactorRows = parseInt(object.staleInfluenceFactorRows, 10);
                            else if (typeof object.staleInfluenceFactorRows === "number")
                                message.staleInfluenceFactorRows = object.staleInfluenceFactorRows;
                            else if (typeof object.staleInfluenceFactorRows === "object")
                                message.staleInfluenceFactorRows = new $util.LongBits(object.staleInfluenceFactorRows.low >>> 0, object.staleInfluenceFactorRows.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyForecastCleanupResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @static
                     * @param {palexy.streaming.v1.CompanyForecastCleanupResult} message CompanyForecastCleanupResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyForecastCleanupResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.hasStaleData = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staleWholeDayRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staleWholeDayRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staleHourRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staleHourRows = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staleInfluenceFactorRows = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staleInfluenceFactorRows = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.hasStaleData != null && message.hasOwnProperty("hasStaleData"))
                            object.hasStaleData = message.hasStaleData;
                        if (message.staleWholeDayRows != null && message.hasOwnProperty("staleWholeDayRows"))
                            if (typeof message.staleWholeDayRows === "number")
                                object.staleWholeDayRows = options.longs === String ? String(message.staleWholeDayRows) : message.staleWholeDayRows;
                            else
                                object.staleWholeDayRows = options.longs === String ? $util.Long.prototype.toString.call(message.staleWholeDayRows) : options.longs === Number ? new $util.LongBits(message.staleWholeDayRows.low >>> 0, message.staleWholeDayRows.high >>> 0).toNumber() : message.staleWholeDayRows;
                        if (message.staleHourRows != null && message.hasOwnProperty("staleHourRows"))
                            if (typeof message.staleHourRows === "number")
                                object.staleHourRows = options.longs === String ? String(message.staleHourRows) : message.staleHourRows;
                            else
                                object.staleHourRows = options.longs === String ? $util.Long.prototype.toString.call(message.staleHourRows) : options.longs === Number ? new $util.LongBits(message.staleHourRows.low >>> 0, message.staleHourRows.high >>> 0).toNumber() : message.staleHourRows;
                        if (message.staleInfluenceFactorRows != null && message.hasOwnProperty("staleInfluenceFactorRows"))
                            if (typeof message.staleInfluenceFactorRows === "number")
                                object.staleInfluenceFactorRows = options.longs === String ? String(message.staleInfluenceFactorRows) : message.staleInfluenceFactorRows;
                            else
                                object.staleInfluenceFactorRows = options.longs === String ? $util.Long.prototype.toString.call(message.staleInfluenceFactorRows) : options.longs === Number ? new $util.LongBits(message.staleInfluenceFactorRows.low >>> 0, message.staleInfluenceFactorRows.high >>> 0).toNumber() : message.staleInfluenceFactorRows;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyForecastCleanupResult to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CompanyForecastCleanupResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyForecastCleanupResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyForecastCleanupResult;
                })();
    
                v1.ListLatestForecastStoreWholeDayRequest = (function() {
    
                    /**
                     * Properties of a ListLatestForecastStoreWholeDayRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListLatestForecastStoreWholeDayRequest
                     * @property {number|null} [storeId] ListLatestForecastStoreWholeDayRequest storeId
                     * @property {number|null} [startDateId] ListLatestForecastStoreWholeDayRequest startDateId
                     * @property {number|null} [endDateId] ListLatestForecastStoreWholeDayRequest endDateId
                     * @property {palexy.streaming.v1.ForecastModel.Metric|null} [forecastMetric] ListLatestForecastStoreWholeDayRequest forecastMetric
                     */
    
                    /**
                     * Constructs a new ListLatestForecastStoreWholeDayRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLatestForecastStoreWholeDayRequest.
                     * @implements IListLatestForecastStoreWholeDayRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest=} [properties] Properties to set
                     */
                    function ListLatestForecastStoreWholeDayRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLatestForecastStoreWholeDayRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @instance
                     */
                    ListLatestForecastStoreWholeDayRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListLatestForecastStoreWholeDayRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @instance
                     */
                    ListLatestForecastStoreWholeDayRequest.prototype.startDateId = 0;
    
                    /**
                     * ListLatestForecastStoreWholeDayRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @instance
                     */
                    ListLatestForecastStoreWholeDayRequest.prototype.endDateId = 0;
    
                    /**
                     * ListLatestForecastStoreWholeDayRequest forecastMetric.
                     * @member {palexy.streaming.v1.ForecastModel.Metric} forecastMetric
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @instance
                     */
                    ListLatestForecastStoreWholeDayRequest.prototype.forecastMetric = 0;
    
                    /**
                     * Creates a new ListLatestForecastStoreWholeDayRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest} ListLatestForecastStoreWholeDayRequest instance
                     */
                    ListLatestForecastStoreWholeDayRequest.create = function create(properties) {
                        return new ListLatestForecastStoreWholeDayRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListLatestForecastStoreWholeDayRequest message. Does not implicitly {@link palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest} message ListLatestForecastStoreWholeDayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLatestForecastStoreWholeDayRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.forecastMetric != null && Object.hasOwnProperty.call(message, "forecastMetric"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.forecastMetric);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLatestForecastStoreWholeDayRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayRequest} message ListLatestForecastStoreWholeDayRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLatestForecastStoreWholeDayRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLatestForecastStoreWholeDayRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest} ListLatestForecastStoreWholeDayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLatestForecastStoreWholeDayRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.forecastMetric = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLatestForecastStoreWholeDayRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest} ListLatestForecastStoreWholeDayRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLatestForecastStoreWholeDayRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLatestForecastStoreWholeDayRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLatestForecastStoreWholeDayRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            switch (message.forecastMetric) {
                            default:
                                return "forecastMetric: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ListLatestForecastStoreWholeDayRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest} ListLatestForecastStoreWholeDayRequest
                     */
                    ListLatestForecastStoreWholeDayRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        switch (object.forecastMetric) {
                        case "UNKNOWN_METRIC":
                        case 0:
                            message.forecastMetric = 0;
                            break;
                        case "VISITS":
                        case 1:
                            message.forecastMetric = 1;
                            break;
                        case "NET_SALES":
                        case 2:
                            message.forecastMetric = 2;
                            break;
                        case "TRANSACTION":
                        case 3:
                            message.forecastMetric = 3;
                            break;
                        case "NET_SALES_ITEMS":
                        case 4:
                            message.forecastMetric = 4;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLatestForecastStoreWholeDayRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @static
                     * @param {palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest} message ListLatestForecastStoreWholeDayRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLatestForecastStoreWholeDayRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.forecastMetric = options.enums === String ? "UNKNOWN_METRIC" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            object.forecastMetric = options.enums === String ? $root.palexy.streaming.v1.ForecastModel.Metric[message.forecastMetric] : message.forecastMetric;
                        return object;
                    };
    
                    /**
                     * Converts this ListLatestForecastStoreWholeDayRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLatestForecastStoreWholeDayRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLatestForecastStoreWholeDayRequest;
                })();
    
                v1.ListLatestForecastStoreWholeDayResponse = (function() {
    
                    /**
                     * Properties of a ListLatestForecastStoreWholeDayResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListLatestForecastStoreWholeDayResponse
                     * @property {Array.<palexy.streaming.v1.IForecastStoreWholeDayView>|null} [forecastStoreWholeDays] ListLatestForecastStoreWholeDayResponse forecastStoreWholeDays
                     */
    
                    /**
                     * Constructs a new ListLatestForecastStoreWholeDayResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListLatestForecastStoreWholeDayResponse.
                     * @implements IListLatestForecastStoreWholeDayResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayResponse=} [properties] Properties to set
                     */
                    function ListLatestForecastStoreWholeDayResponse(properties) {
                        this.forecastStoreWholeDays = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListLatestForecastStoreWholeDayResponse forecastStoreWholeDays.
                     * @member {Array.<palexy.streaming.v1.IForecastStoreWholeDayView>} forecastStoreWholeDays
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @instance
                     */
                    ListLatestForecastStoreWholeDayResponse.prototype.forecastStoreWholeDays = $util.emptyArray;
    
                    /**
                     * Creates a new ListLatestForecastStoreWholeDayResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} ListLatestForecastStoreWholeDayResponse instance
                     */
                    ListLatestForecastStoreWholeDayResponse.create = function create(properties) {
                        return new ListLatestForecastStoreWholeDayResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListLatestForecastStoreWholeDayResponse message. Does not implicitly {@link palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayResponse} message ListLatestForecastStoreWholeDayResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLatestForecastStoreWholeDayResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.forecastStoreWholeDays != null && message.forecastStoreWholeDays.length)
                            for (var i = 0; i < message.forecastStoreWholeDays.length; ++i)
                                $root.palexy.streaming.v1.ForecastStoreWholeDayView.encode(message.forecastStoreWholeDays[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListLatestForecastStoreWholeDayResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {palexy.streaming.v1.IListLatestForecastStoreWholeDayResponse} message ListLatestForecastStoreWholeDayResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListLatestForecastStoreWholeDayResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListLatestForecastStoreWholeDayResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} ListLatestForecastStoreWholeDayResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLatestForecastStoreWholeDayResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.forecastStoreWholeDays && message.forecastStoreWholeDays.length))
                                    message.forecastStoreWholeDays = [];
                                message.forecastStoreWholeDays.push($root.palexy.streaming.v1.ForecastStoreWholeDayView.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListLatestForecastStoreWholeDayResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} ListLatestForecastStoreWholeDayResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListLatestForecastStoreWholeDayResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListLatestForecastStoreWholeDayResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListLatestForecastStoreWholeDayResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.forecastStoreWholeDays != null && message.hasOwnProperty("forecastStoreWholeDays")) {
                            if (!Array.isArray(message.forecastStoreWholeDays))
                                return "forecastStoreWholeDays: array expected";
                            for (var i = 0; i < message.forecastStoreWholeDays.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastStoreWholeDayView.verify(message.forecastStoreWholeDays[i]);
                                if (error)
                                    return "forecastStoreWholeDays." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListLatestForecastStoreWholeDayResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} ListLatestForecastStoreWholeDayResponse
                     */
                    ListLatestForecastStoreWholeDayResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse();
                        if (object.forecastStoreWholeDays) {
                            if (!Array.isArray(object.forecastStoreWholeDays))
                                throw TypeError(".palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse.forecastStoreWholeDays: array expected");
                            message.forecastStoreWholeDays = [];
                            for (var i = 0; i < object.forecastStoreWholeDays.length; ++i) {
                                if (typeof object.forecastStoreWholeDays[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse.forecastStoreWholeDays: object expected");
                                message.forecastStoreWholeDays[i] = $root.palexy.streaming.v1.ForecastStoreWholeDayView.fromObject(object.forecastStoreWholeDays[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListLatestForecastStoreWholeDayResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @static
                     * @param {palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse} message ListLatestForecastStoreWholeDayResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListLatestForecastStoreWholeDayResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.forecastStoreWholeDays = [];
                        if (message.forecastStoreWholeDays && message.forecastStoreWholeDays.length) {
                            object.forecastStoreWholeDays = [];
                            for (var j = 0; j < message.forecastStoreWholeDays.length; ++j)
                                object.forecastStoreWholeDays[j] = $root.palexy.streaming.v1.ForecastStoreWholeDayView.toObject(message.forecastStoreWholeDays[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListLatestForecastStoreWholeDayResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListLatestForecastStoreWholeDayResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListLatestForecastStoreWholeDayResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListLatestForecastStoreWholeDayResponse;
                })();
    
                v1.ForecastStoreWholeDayView = (function() {
    
                    /**
                     * Properties of a ForecastStoreWholeDayView.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastStoreWholeDayView
                     * @property {number|null} [dateId] ForecastStoreWholeDayView dateId
                     * @property {number|null} [modelForecastValue] ForecastStoreWholeDayView modelForecastValue
                     * @property {Array.<palexy.streaming.v1.IInfluenceFactor>|null} [influenceFactors] ForecastStoreWholeDayView influenceFactors
                     * @property {number|null} [effectiveValue] ForecastStoreWholeDayView effectiveValue
                     * @property {boolean|null} [hasOverride] ForecastStoreWholeDayView hasOverride
                     */
    
                    /**
                     * Constructs a new ForecastStoreWholeDayView.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastStoreWholeDayView.
                     * @implements IForecastStoreWholeDayView
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastStoreWholeDayView=} [properties] Properties to set
                     */
                    function ForecastStoreWholeDayView(properties) {
                        this.influenceFactors = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastStoreWholeDayView dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     */
                    ForecastStoreWholeDayView.prototype.dateId = 0;
    
                    /**
                     * ForecastStoreWholeDayView modelForecastValue.
                     * @member {number} modelForecastValue
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     */
                    ForecastStoreWholeDayView.prototype.modelForecastValue = 0;
    
                    /**
                     * ForecastStoreWholeDayView influenceFactors.
                     * @member {Array.<palexy.streaming.v1.IInfluenceFactor>} influenceFactors
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     */
                    ForecastStoreWholeDayView.prototype.influenceFactors = $util.emptyArray;
    
                    /**
                     * ForecastStoreWholeDayView effectiveValue.
                     * @member {number} effectiveValue
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     */
                    ForecastStoreWholeDayView.prototype.effectiveValue = 0;
    
                    /**
                     * ForecastStoreWholeDayView hasOverride.
                     * @member {boolean} hasOverride
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     */
                    ForecastStoreWholeDayView.prototype.hasOverride = false;
    
                    /**
                     * Creates a new ForecastStoreWholeDayView instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDayView=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDayView} ForecastStoreWholeDayView instance
                     */
                    ForecastStoreWholeDayView.create = function create(properties) {
                        return new ForecastStoreWholeDayView(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastStoreWholeDayView message. Does not implicitly {@link palexy.streaming.v1.ForecastStoreWholeDayView.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDayView} message ForecastStoreWholeDayView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreWholeDayView.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                        if (message.modelForecastValue != null && Object.hasOwnProperty.call(message, "modelForecastValue"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.modelForecastValue);
                        if (message.influenceFactors != null && message.influenceFactors.length)
                            for (var i = 0; i < message.influenceFactors.length; ++i)
                                $root.palexy.streaming.v1.InfluenceFactor.encode(message.influenceFactors[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.effectiveValue != null && Object.hasOwnProperty.call(message, "effectiveValue"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.effectiveValue);
                        if (message.hasOverride != null && Object.hasOwnProperty.call(message, "hasOverride"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hasOverride);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastStoreWholeDayView message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastStoreWholeDayView.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDayView} message ForecastStoreWholeDayView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreWholeDayView.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastStoreWholeDayView message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDayView} ForecastStoreWholeDayView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreWholeDayView.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastStoreWholeDayView();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateId = reader.int32();
                                break;
                            case 2:
                                message.modelForecastValue = reader.float();
                                break;
                            case 3:
                                if (!(message.influenceFactors && message.influenceFactors.length))
                                    message.influenceFactors = [];
                                message.influenceFactors.push($root.palexy.streaming.v1.InfluenceFactor.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.effectiveValue = reader.float();
                                break;
                            case 5:
                                message.hasOverride = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastStoreWholeDayView message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDayView} ForecastStoreWholeDayView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreWholeDayView.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastStoreWholeDayView message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastStoreWholeDayView.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.modelForecastValue != null && message.hasOwnProperty("modelForecastValue"))
                            if (typeof message.modelForecastValue !== "number")
                                return "modelForecastValue: number expected";
                        if (message.influenceFactors != null && message.hasOwnProperty("influenceFactors")) {
                            if (!Array.isArray(message.influenceFactors))
                                return "influenceFactors: array expected";
                            for (var i = 0; i < message.influenceFactors.length; ++i) {
                                var error = $root.palexy.streaming.v1.InfluenceFactor.verify(message.influenceFactors[i]);
                                if (error)
                                    return "influenceFactors." + error;
                            }
                        }
                        if (message.effectiveValue != null && message.hasOwnProperty("effectiveValue"))
                            if (typeof message.effectiveValue !== "number")
                                return "effectiveValue: number expected";
                        if (message.hasOverride != null && message.hasOwnProperty("hasOverride"))
                            if (typeof message.hasOverride !== "boolean")
                                return "hasOverride: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastStoreWholeDayView message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDayView} ForecastStoreWholeDayView
                     */
                    ForecastStoreWholeDayView.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastStoreWholeDayView)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastStoreWholeDayView();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.modelForecastValue != null)
                            message.modelForecastValue = Number(object.modelForecastValue);
                        if (object.influenceFactors) {
                            if (!Array.isArray(object.influenceFactors))
                                throw TypeError(".palexy.streaming.v1.ForecastStoreWholeDayView.influenceFactors: array expected");
                            message.influenceFactors = [];
                            for (var i = 0; i < object.influenceFactors.length; ++i) {
                                if (typeof object.influenceFactors[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastStoreWholeDayView.influenceFactors: object expected");
                                message.influenceFactors[i] = $root.palexy.streaming.v1.InfluenceFactor.fromObject(object.influenceFactors[i]);
                            }
                        }
                        if (object.effectiveValue != null)
                            message.effectiveValue = Number(object.effectiveValue);
                        if (object.hasOverride != null)
                            message.hasOverride = Boolean(object.hasOverride);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastStoreWholeDayView message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @static
                     * @param {palexy.streaming.v1.ForecastStoreWholeDayView} message ForecastStoreWholeDayView
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastStoreWholeDayView.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.influenceFactors = [];
                        if (options.defaults) {
                            object.dateId = 0;
                            object.modelForecastValue = 0;
                            object.effectiveValue = 0;
                            object.hasOverride = false;
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.modelForecastValue != null && message.hasOwnProperty("modelForecastValue"))
                            object.modelForecastValue = options.json && !isFinite(message.modelForecastValue) ? String(message.modelForecastValue) : message.modelForecastValue;
                        if (message.influenceFactors && message.influenceFactors.length) {
                            object.influenceFactors = [];
                            for (var j = 0; j < message.influenceFactors.length; ++j)
                                object.influenceFactors[j] = $root.palexy.streaming.v1.InfluenceFactor.toObject(message.influenceFactors[j], options);
                        }
                        if (message.effectiveValue != null && message.hasOwnProperty("effectiveValue"))
                            object.effectiveValue = options.json && !isFinite(message.effectiveValue) ? String(message.effectiveValue) : message.effectiveValue;
                        if (message.hasOverride != null && message.hasOwnProperty("hasOverride"))
                            object.hasOverride = message.hasOverride;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastStoreWholeDayView to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDayView
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastStoreWholeDayView.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastStoreWholeDayView;
                })();
    
                v1.BatchCheckForecastOverrideDaysRequest = (function() {
    
                    /**
                     * Properties of a BatchCheckForecastOverrideDaysRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCheckForecastOverrideDaysRequest
                     * @property {Array.<number>|null} [storeIds] BatchCheckForecastOverrideDaysRequest storeIds
                     * @property {number|null} [startDateId] BatchCheckForecastOverrideDaysRequest startDateId
                     * @property {number|null} [endDateId] BatchCheckForecastOverrideDaysRequest endDateId
                     * @property {palexy.streaming.v1.ForecastModel.Metric|null} [forecastMetric] BatchCheckForecastOverrideDaysRequest forecastMetric
                     */
    
                    /**
                     * Constructs a new BatchCheckForecastOverrideDaysRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCheckForecastOverrideDaysRequest.
                     * @implements IBatchCheckForecastOverrideDaysRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest=} [properties] Properties to set
                     */
                    function BatchCheckForecastOverrideDaysRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCheckForecastOverrideDaysRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @instance
                     */
                    BatchCheckForecastOverrideDaysRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * BatchCheckForecastOverrideDaysRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @instance
                     */
                    BatchCheckForecastOverrideDaysRequest.prototype.startDateId = 0;
    
                    /**
                     * BatchCheckForecastOverrideDaysRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @instance
                     */
                    BatchCheckForecastOverrideDaysRequest.prototype.endDateId = 0;
    
                    /**
                     * BatchCheckForecastOverrideDaysRequest forecastMetric.
                     * @member {palexy.streaming.v1.ForecastModel.Metric} forecastMetric
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @instance
                     */
                    BatchCheckForecastOverrideDaysRequest.prototype.forecastMetric = 0;
    
                    /**
                     * Creates a new BatchCheckForecastOverrideDaysRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest} BatchCheckForecastOverrideDaysRequest instance
                     */
                    BatchCheckForecastOverrideDaysRequest.create = function create(properties) {
                        return new BatchCheckForecastOverrideDaysRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCheckForecastOverrideDaysRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest} message BatchCheckForecastOverrideDaysRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCheckForecastOverrideDaysRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.forecastMetric != null && Object.hasOwnProperty.call(message, "forecastMetric"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.forecastMetric);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCheckForecastOverrideDaysRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysRequest} message BatchCheckForecastOverrideDaysRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCheckForecastOverrideDaysRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCheckForecastOverrideDaysRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest} BatchCheckForecastOverrideDaysRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCheckForecastOverrideDaysRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.forecastMetric = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCheckForecastOverrideDaysRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest} BatchCheckForecastOverrideDaysRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCheckForecastOverrideDaysRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCheckForecastOverrideDaysRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCheckForecastOverrideDaysRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            switch (message.forecastMetric) {
                            default:
                                return "forecastMetric: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCheckForecastOverrideDaysRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest} BatchCheckForecastOverrideDaysRequest
                     */
                    BatchCheckForecastOverrideDaysRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        switch (object.forecastMetric) {
                        case "UNKNOWN_METRIC":
                        case 0:
                            message.forecastMetric = 0;
                            break;
                        case "VISITS":
                        case 1:
                            message.forecastMetric = 1;
                            break;
                        case "NET_SALES":
                        case 2:
                            message.forecastMetric = 2;
                            break;
                        case "TRANSACTION":
                        case 3:
                            message.forecastMetric = 3;
                            break;
                        case "NET_SALES_ITEMS":
                        case 4:
                            message.forecastMetric = 4;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCheckForecastOverrideDaysRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest} message BatchCheckForecastOverrideDaysRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCheckForecastOverrideDaysRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.forecastMetric = options.enums === String ? "UNKNOWN_METRIC" : 0;
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            object.forecastMetric = options.enums === String ? $root.palexy.streaming.v1.ForecastModel.Metric[message.forecastMetric] : message.forecastMetric;
                        return object;
                    };
    
                    /**
                     * Converts this BatchCheckForecastOverrideDaysRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCheckForecastOverrideDaysRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCheckForecastOverrideDaysRequest;
                })();
    
                v1.BatchCheckForecastOverrideDaysResponse = (function() {
    
                    /**
                     * Properties of a BatchCheckForecastOverrideDaysResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCheckForecastOverrideDaysResponse
                     * @property {Array.<palexy.streaming.v1.IStoreOverrideDays>|null} [storeOverrideDays] BatchCheckForecastOverrideDaysResponse storeOverrideDays
                     */
    
                    /**
                     * Constructs a new BatchCheckForecastOverrideDaysResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCheckForecastOverrideDaysResponse.
                     * @implements IBatchCheckForecastOverrideDaysResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysResponse=} [properties] Properties to set
                     */
                    function BatchCheckForecastOverrideDaysResponse(properties) {
                        this.storeOverrideDays = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCheckForecastOverrideDaysResponse storeOverrideDays.
                     * @member {Array.<palexy.streaming.v1.IStoreOverrideDays>} storeOverrideDays
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @instance
                     */
                    BatchCheckForecastOverrideDaysResponse.prototype.storeOverrideDays = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCheckForecastOverrideDaysResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} BatchCheckForecastOverrideDaysResponse instance
                     */
                    BatchCheckForecastOverrideDaysResponse.create = function create(properties) {
                        return new BatchCheckForecastOverrideDaysResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCheckForecastOverrideDaysResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysResponse} message BatchCheckForecastOverrideDaysResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCheckForecastOverrideDaysResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeOverrideDays != null && message.storeOverrideDays.length)
                            for (var i = 0; i < message.storeOverrideDays.length; ++i)
                                $root.palexy.streaming.v1.StoreOverrideDays.encode(message.storeOverrideDays[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCheckForecastOverrideDaysResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCheckForecastOverrideDaysResponse} message BatchCheckForecastOverrideDaysResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCheckForecastOverrideDaysResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCheckForecastOverrideDaysResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} BatchCheckForecastOverrideDaysResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCheckForecastOverrideDaysResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeOverrideDays && message.storeOverrideDays.length))
                                    message.storeOverrideDays = [];
                                message.storeOverrideDays.push($root.palexy.streaming.v1.StoreOverrideDays.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCheckForecastOverrideDaysResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} BatchCheckForecastOverrideDaysResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCheckForecastOverrideDaysResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCheckForecastOverrideDaysResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCheckForecastOverrideDaysResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeOverrideDays != null && message.hasOwnProperty("storeOverrideDays")) {
                            if (!Array.isArray(message.storeOverrideDays))
                                return "storeOverrideDays: array expected";
                            for (var i = 0; i < message.storeOverrideDays.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreOverrideDays.verify(message.storeOverrideDays[i]);
                                if (error)
                                    return "storeOverrideDays." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCheckForecastOverrideDaysResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} BatchCheckForecastOverrideDaysResponse
                     */
                    BatchCheckForecastOverrideDaysResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse();
                        if (object.storeOverrideDays) {
                            if (!Array.isArray(object.storeOverrideDays))
                                throw TypeError(".palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse.storeOverrideDays: array expected");
                            message.storeOverrideDays = [];
                            for (var i = 0; i < object.storeOverrideDays.length; ++i) {
                                if (typeof object.storeOverrideDays[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse.storeOverrideDays: object expected");
                                message.storeOverrideDays[i] = $root.palexy.streaming.v1.StoreOverrideDays.fromObject(object.storeOverrideDays[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCheckForecastOverrideDaysResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse} message BatchCheckForecastOverrideDaysResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCheckForecastOverrideDaysResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeOverrideDays = [];
                        if (message.storeOverrideDays && message.storeOverrideDays.length) {
                            object.storeOverrideDays = [];
                            for (var j = 0; j < message.storeOverrideDays.length; ++j)
                                object.storeOverrideDays[j] = $root.palexy.streaming.v1.StoreOverrideDays.toObject(message.storeOverrideDays[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCheckForecastOverrideDaysResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCheckForecastOverrideDaysResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCheckForecastOverrideDaysResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCheckForecastOverrideDaysResponse;
                })();
    
                v1.StoreOverrideDays = (function() {
    
                    /**
                     * Properties of a StoreOverrideDays.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreOverrideDays
                     * @property {number|null} [storeId] StoreOverrideDays storeId
                     * @property {Array.<number>|null} [dateIds] StoreOverrideDays dateIds
                     */
    
                    /**
                     * Constructs a new StoreOverrideDays.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreOverrideDays.
                     * @implements IStoreOverrideDays
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreOverrideDays=} [properties] Properties to set
                     */
                    function StoreOverrideDays(properties) {
                        this.dateIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreOverrideDays storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @instance
                     */
                    StoreOverrideDays.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreOverrideDays dateIds.
                     * @member {Array.<number>} dateIds
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @instance
                     */
                    StoreOverrideDays.prototype.dateIds = $util.emptyArray;
    
                    /**
                     * Creates a new StoreOverrideDays instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {palexy.streaming.v1.IStoreOverrideDays=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreOverrideDays} StoreOverrideDays instance
                     */
                    StoreOverrideDays.create = function create(properties) {
                        return new StoreOverrideDays(properties);
                    };
    
                    /**
                     * Encodes the specified StoreOverrideDays message. Does not implicitly {@link palexy.streaming.v1.StoreOverrideDays.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {palexy.streaming.v1.IStoreOverrideDays} message StoreOverrideDays message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreOverrideDays.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateIds != null && message.dateIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.dateIds.length; ++i)
                                writer.int32(message.dateIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreOverrideDays message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreOverrideDays.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {palexy.streaming.v1.IStoreOverrideDays} message StoreOverrideDays message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreOverrideDays.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreOverrideDays message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreOverrideDays} StoreOverrideDays
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreOverrideDays.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreOverrideDays();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.dateIds && message.dateIds.length))
                                    message.dateIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.dateIds.push(reader.int32());
                                } else
                                    message.dateIds.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreOverrideDays message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreOverrideDays} StoreOverrideDays
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreOverrideDays.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreOverrideDays message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreOverrideDays.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateIds != null && message.hasOwnProperty("dateIds")) {
                            if (!Array.isArray(message.dateIds))
                                return "dateIds: array expected";
                            for (var i = 0; i < message.dateIds.length; ++i)
                                if (!$util.isInteger(message.dateIds[i]))
                                    return "dateIds: integer[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreOverrideDays message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreOverrideDays} StoreOverrideDays
                     */
                    StoreOverrideDays.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreOverrideDays)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreOverrideDays();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateIds) {
                            if (!Array.isArray(object.dateIds))
                                throw TypeError(".palexy.streaming.v1.StoreOverrideDays.dateIds: array expected");
                            message.dateIds = [];
                            for (var i = 0; i < object.dateIds.length; ++i)
                                message.dateIds[i] = object.dateIds[i] | 0;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreOverrideDays message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @static
                     * @param {palexy.streaming.v1.StoreOverrideDays} message StoreOverrideDays
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreOverrideDays.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dateIds = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateIds && message.dateIds.length) {
                            object.dateIds = [];
                            for (var j = 0; j < message.dateIds.length; ++j)
                                object.dateIds[j] = message.dateIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreOverrideDays to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreOverrideDays
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreOverrideDays.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreOverrideDays;
                })();
    
                v1.SaveForecastUserOverrideRequest = (function() {
    
                    /**
                     * Properties of a SaveForecastUserOverrideRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISaveForecastUserOverrideRequest
                     * @property {number|null} [storeId] SaveForecastUserOverrideRequest storeId
                     * @property {number|null} [dateId] SaveForecastUserOverrideRequest dateId
                     * @property {string|null} [forecastMetric] SaveForecastUserOverrideRequest forecastMetric
                     * @property {number|null} [overrideValue] SaveForecastUserOverrideRequest overrideValue
                     * @property {google.protobuf.IInt64Value|null} [lastEditorAccountId] SaveForecastUserOverrideRequest lastEditorAccountId
                     */
    
                    /**
                     * Constructs a new SaveForecastUserOverrideRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SaveForecastUserOverrideRequest.
                     * @implements ISaveForecastUserOverrideRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest=} [properties] Properties to set
                     */
                    function SaveForecastUserOverrideRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SaveForecastUserOverrideRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     */
                    SaveForecastUserOverrideRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SaveForecastUserOverrideRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     */
                    SaveForecastUserOverrideRequest.prototype.dateId = 0;
    
                    /**
                     * SaveForecastUserOverrideRequest forecastMetric.
                     * @member {string} forecastMetric
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     */
                    SaveForecastUserOverrideRequest.prototype.forecastMetric = "";
    
                    /**
                     * SaveForecastUserOverrideRequest overrideValue.
                     * @member {number} overrideValue
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     */
                    SaveForecastUserOverrideRequest.prototype.overrideValue = 0;
    
                    /**
                     * SaveForecastUserOverrideRequest lastEditorAccountId.
                     * @member {google.protobuf.IInt64Value|null|undefined} lastEditorAccountId
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     */
                    SaveForecastUserOverrideRequest.prototype.lastEditorAccountId = null;
    
                    /**
                     * Creates a new SaveForecastUserOverrideRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideRequest} SaveForecastUserOverrideRequest instance
                     */
                    SaveForecastUserOverrideRequest.create = function create(properties) {
                        return new SaveForecastUserOverrideRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SaveForecastUserOverrideRequest message. Does not implicitly {@link palexy.streaming.v1.SaveForecastUserOverrideRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest} message SaveForecastUserOverrideRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SaveForecastUserOverrideRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.forecastMetric != null && Object.hasOwnProperty.call(message, "forecastMetric"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.forecastMetric);
                        if (message.overrideValue != null && Object.hasOwnProperty.call(message, "overrideValue"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.overrideValue);
                        if (message.lastEditorAccountId != null && Object.hasOwnProperty.call(message, "lastEditorAccountId"))
                            $root.google.protobuf.Int64Value.encode(message.lastEditorAccountId, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SaveForecastUserOverrideRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SaveForecastUserOverrideRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideRequest} message SaveForecastUserOverrideRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SaveForecastUserOverrideRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SaveForecastUserOverrideRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideRequest} SaveForecastUserOverrideRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SaveForecastUserOverrideRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SaveForecastUserOverrideRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.forecastMetric = reader.string();
                                break;
                            case 4:
                                message.overrideValue = reader.float();
                                break;
                            case 5:
                                message.lastEditorAccountId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SaveForecastUserOverrideRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideRequest} SaveForecastUserOverrideRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SaveForecastUserOverrideRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SaveForecastUserOverrideRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SaveForecastUserOverrideRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            if (!$util.isString(message.forecastMetric))
                                return "forecastMetric: string expected";
                        if (message.overrideValue != null && message.hasOwnProperty("overrideValue"))
                            if (typeof message.overrideValue !== "number")
                                return "overrideValue: number expected";
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.lastEditorAccountId);
                            if (error)
                                return "lastEditorAccountId." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SaveForecastUserOverrideRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideRequest} SaveForecastUserOverrideRequest
                     */
                    SaveForecastUserOverrideRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SaveForecastUserOverrideRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SaveForecastUserOverrideRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.forecastMetric != null)
                            message.forecastMetric = String(object.forecastMetric);
                        if (object.overrideValue != null)
                            message.overrideValue = Number(object.overrideValue);
                        if (object.lastEditorAccountId != null) {
                            if (typeof object.lastEditorAccountId !== "object")
                                throw TypeError(".palexy.streaming.v1.SaveForecastUserOverrideRequest.lastEditorAccountId: object expected");
                            message.lastEditorAccountId = $root.google.protobuf.Int64Value.fromObject(object.lastEditorAccountId);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SaveForecastUserOverrideRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.SaveForecastUserOverrideRequest} message SaveForecastUserOverrideRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SaveForecastUserOverrideRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.forecastMetric = "";
                            object.overrideValue = 0;
                            object.lastEditorAccountId = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            object.forecastMetric = message.forecastMetric;
                        if (message.overrideValue != null && message.hasOwnProperty("overrideValue"))
                            object.overrideValue = options.json && !isFinite(message.overrideValue) ? String(message.overrideValue) : message.overrideValue;
                        if (message.lastEditorAccountId != null && message.hasOwnProperty("lastEditorAccountId"))
                            object.lastEditorAccountId = $root.google.protobuf.Int64Value.toObject(message.lastEditorAccountId, options);
                        return object;
                    };
    
                    /**
                     * Converts this SaveForecastUserOverrideRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SaveForecastUserOverrideRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SaveForecastUserOverrideRequest;
                })();
    
                v1.SaveForecastUserOverrideResponse = (function() {
    
                    /**
                     * Properties of a SaveForecastUserOverrideResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISaveForecastUserOverrideResponse
                     * @property {number|null} [id] SaveForecastUserOverrideResponse id
                     */
    
                    /**
                     * Constructs a new SaveForecastUserOverrideResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SaveForecastUserOverrideResponse.
                     * @implements ISaveForecastUserOverrideResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideResponse=} [properties] Properties to set
                     */
                    function SaveForecastUserOverrideResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SaveForecastUserOverrideResponse id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @instance
                     */
                    SaveForecastUserOverrideResponse.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SaveForecastUserOverrideResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideResponse} SaveForecastUserOverrideResponse instance
                     */
                    SaveForecastUserOverrideResponse.create = function create(properties) {
                        return new SaveForecastUserOverrideResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SaveForecastUserOverrideResponse message. Does not implicitly {@link palexy.streaming.v1.SaveForecastUserOverrideResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideResponse} message SaveForecastUserOverrideResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SaveForecastUserOverrideResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SaveForecastUserOverrideResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SaveForecastUserOverrideResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {palexy.streaming.v1.ISaveForecastUserOverrideResponse} message SaveForecastUserOverrideResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SaveForecastUserOverrideResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SaveForecastUserOverrideResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideResponse} SaveForecastUserOverrideResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SaveForecastUserOverrideResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SaveForecastUserOverrideResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SaveForecastUserOverrideResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideResponse} SaveForecastUserOverrideResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SaveForecastUserOverrideResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SaveForecastUserOverrideResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SaveForecastUserOverrideResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SaveForecastUserOverrideResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SaveForecastUserOverrideResponse} SaveForecastUserOverrideResponse
                     */
                    SaveForecastUserOverrideResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SaveForecastUserOverrideResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SaveForecastUserOverrideResponse();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SaveForecastUserOverrideResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @static
                     * @param {palexy.streaming.v1.SaveForecastUserOverrideResponse} message SaveForecastUserOverrideResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SaveForecastUserOverrideResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this SaveForecastUserOverrideResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SaveForecastUserOverrideResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SaveForecastUserOverrideResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SaveForecastUserOverrideResponse;
                })();
    
                v1.DeleteForecastUserOverrideRequest = (function() {
    
                    /**
                     * Properties of a DeleteForecastUserOverrideRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteForecastUserOverrideRequest
                     * @property {number|null} [storeId] DeleteForecastUserOverrideRequest storeId
                     * @property {number|null} [dateId] DeleteForecastUserOverrideRequest dateId
                     * @property {string|null} [forecastMetric] DeleteForecastUserOverrideRequest forecastMetric
                     */
    
                    /**
                     * Constructs a new DeleteForecastUserOverrideRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteForecastUserOverrideRequest.
                     * @implements IDeleteForecastUserOverrideRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest=} [properties] Properties to set
                     */
                    function DeleteForecastUserOverrideRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteForecastUserOverrideRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @instance
                     */
                    DeleteForecastUserOverrideRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteForecastUserOverrideRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @instance
                     */
                    DeleteForecastUserOverrideRequest.prototype.dateId = 0;
    
                    /**
                     * DeleteForecastUserOverrideRequest forecastMetric.
                     * @member {string} forecastMetric
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @instance
                     */
                    DeleteForecastUserOverrideRequest.prototype.forecastMetric = "";
    
                    /**
                     * Creates a new DeleteForecastUserOverrideRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteForecastUserOverrideRequest} DeleteForecastUserOverrideRequest instance
                     */
                    DeleteForecastUserOverrideRequest.create = function create(properties) {
                        return new DeleteForecastUserOverrideRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteForecastUserOverrideRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteForecastUserOverrideRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest} message DeleteForecastUserOverrideRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteForecastUserOverrideRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.forecastMetric != null && Object.hasOwnProperty.call(message, "forecastMetric"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.forecastMetric);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteForecastUserOverrideRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteForecastUserOverrideRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteForecastUserOverrideRequest} message DeleteForecastUserOverrideRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteForecastUserOverrideRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteForecastUserOverrideRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteForecastUserOverrideRequest} DeleteForecastUserOverrideRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteForecastUserOverrideRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteForecastUserOverrideRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.forecastMetric = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteForecastUserOverrideRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteForecastUserOverrideRequest} DeleteForecastUserOverrideRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteForecastUserOverrideRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteForecastUserOverrideRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteForecastUserOverrideRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            if (!$util.isString(message.forecastMetric))
                                return "forecastMetric: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteForecastUserOverrideRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteForecastUserOverrideRequest} DeleteForecastUserOverrideRequest
                     */
                    DeleteForecastUserOverrideRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteForecastUserOverrideRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteForecastUserOverrideRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.forecastMetric != null)
                            message.forecastMetric = String(object.forecastMetric);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteForecastUserOverrideRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteForecastUserOverrideRequest} message DeleteForecastUserOverrideRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteForecastUserOverrideRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.forecastMetric = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            object.forecastMetric = message.forecastMetric;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteForecastUserOverrideRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteForecastUserOverrideRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteForecastUserOverrideRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteForecastUserOverrideRequest;
                })();
    
                v1.ForecastModel = (function() {
    
                    /**
                     * Properties of a ForecastModel.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastModel
                     * @property {number|null} [id] ForecastModel id
                     * @property {string|null} [modelName] ForecastModel modelName
                     * @property {number|null} [forecastHorizon] ForecastModel forecastHorizon
                     * @property {palexy.streaming.v1.ForecastModel.Metric|null} [forecastMetric] ForecastModel forecastMetric
                     * @property {palexy.streaming.v1.ForecastModel.Granularity|null} [granularity] ForecastModel granularity
                     */
    
                    /**
                     * Constructs a new ForecastModel.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastModel.
                     * @implements IForecastModel
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastModel=} [properties] Properties to set
                     */
                    function ForecastModel(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastModel id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     */
                    ForecastModel.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastModel modelName.
                     * @member {string} modelName
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     */
                    ForecastModel.prototype.modelName = "";
    
                    /**
                     * ForecastModel forecastHorizon.
                     * @member {number} forecastHorizon
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     */
                    ForecastModel.prototype.forecastHorizon = 0;
    
                    /**
                     * ForecastModel forecastMetric.
                     * @member {palexy.streaming.v1.ForecastModel.Metric} forecastMetric
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     */
                    ForecastModel.prototype.forecastMetric = 0;
    
                    /**
                     * ForecastModel granularity.
                     * @member {palexy.streaming.v1.ForecastModel.Granularity} granularity
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     */
                    ForecastModel.prototype.granularity = 0;
    
                    /**
                     * Creates a new ForecastModel instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {palexy.streaming.v1.IForecastModel=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastModel} ForecastModel instance
                     */
                    ForecastModel.create = function create(properties) {
                        return new ForecastModel(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastModel message. Does not implicitly {@link palexy.streaming.v1.ForecastModel.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {palexy.streaming.v1.IForecastModel} message ForecastModel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastModel.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.modelName != null && Object.hasOwnProperty.call(message, "modelName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.modelName);
                        if (message.forecastHorizon != null && Object.hasOwnProperty.call(message, "forecastHorizon"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.forecastHorizon);
                        if (message.forecastMetric != null && Object.hasOwnProperty.call(message, "forecastMetric"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.forecastMetric);
                        if (message.granularity != null && Object.hasOwnProperty.call(message, "granularity"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.granularity);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastModel message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastModel.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {palexy.streaming.v1.IForecastModel} message ForecastModel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastModel.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastModel message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastModel} ForecastModel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastModel.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastModel();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.modelName = reader.string();
                                break;
                            case 3:
                                message.forecastHorizon = reader.int32();
                                break;
                            case 4:
                                message.forecastMetric = reader.int32();
                                break;
                            case 5:
                                message.granularity = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastModel message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastModel} ForecastModel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastModel.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastModel message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastModel.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.modelName != null && message.hasOwnProperty("modelName"))
                            if (!$util.isString(message.modelName))
                                return "modelName: string expected";
                        if (message.forecastHorizon != null && message.hasOwnProperty("forecastHorizon"))
                            if (!$util.isInteger(message.forecastHorizon))
                                return "forecastHorizon: integer expected";
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            switch (message.forecastMetric) {
                            default:
                                return "forecastMetric: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.granularity != null && message.hasOwnProperty("granularity"))
                            switch (message.granularity) {
                            default:
                                return "granularity: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ForecastModel message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastModel} ForecastModel
                     */
                    ForecastModel.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastModel)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastModel();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.modelName != null)
                            message.modelName = String(object.modelName);
                        if (object.forecastHorizon != null)
                            message.forecastHorizon = object.forecastHorizon | 0;
                        switch (object.forecastMetric) {
                        case "UNKNOWN_METRIC":
                        case 0:
                            message.forecastMetric = 0;
                            break;
                        case "VISITS":
                        case 1:
                            message.forecastMetric = 1;
                            break;
                        case "NET_SALES":
                        case 2:
                            message.forecastMetric = 2;
                            break;
                        case "TRANSACTION":
                        case 3:
                            message.forecastMetric = 3;
                            break;
                        case "NET_SALES_ITEMS":
                        case 4:
                            message.forecastMetric = 4;
                            break;
                        }
                        switch (object.granularity) {
                        case "UNKNOWN_GRANULARITY":
                        case 0:
                            message.granularity = 0;
                            break;
                        case "HOURLY":
                        case 1:
                            message.granularity = 1;
                            break;
                        case "DAILY":
                        case 2:
                            message.granularity = 2;
                            break;
                        case "HOURLY_AND_DAILY":
                        case 3:
                            message.granularity = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastModel message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @static
                     * @param {palexy.streaming.v1.ForecastModel} message ForecastModel
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastModel.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.modelName = "";
                            object.forecastHorizon = 0;
                            object.forecastMetric = options.enums === String ? "UNKNOWN_METRIC" : 0;
                            object.granularity = options.enums === String ? "UNKNOWN_GRANULARITY" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.modelName != null && message.hasOwnProperty("modelName"))
                            object.modelName = message.modelName;
                        if (message.forecastHorizon != null && message.hasOwnProperty("forecastHorizon"))
                            object.forecastHorizon = message.forecastHorizon;
                        if (message.forecastMetric != null && message.hasOwnProperty("forecastMetric"))
                            object.forecastMetric = options.enums === String ? $root.palexy.streaming.v1.ForecastModel.Metric[message.forecastMetric] : message.forecastMetric;
                        if (message.granularity != null && message.hasOwnProperty("granularity"))
                            object.granularity = options.enums === String ? $root.palexy.streaming.v1.ForecastModel.Granularity[message.granularity] : message.granularity;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastModel to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastModel
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastModel.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Granularity enum.
                     * @name palexy.streaming.v1.ForecastModel.Granularity
                     * @enum {number}
                     * @property {number} UNKNOWN_GRANULARITY=0 UNKNOWN_GRANULARITY value
                     * @property {number} HOURLY=1 HOURLY value
                     * @property {number} DAILY=2 DAILY value
                     * @property {number} HOURLY_AND_DAILY=3 HOURLY_AND_DAILY value
                     */
                    ForecastModel.Granularity = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_GRANULARITY"] = 0;
                        values[valuesById[1] = "HOURLY"] = 1;
                        values[valuesById[2] = "DAILY"] = 2;
                        values[valuesById[3] = "HOURLY_AND_DAILY"] = 3;
                        return values;
                    })();
    
                    /**
                     * Metric enum.
                     * @name palexy.streaming.v1.ForecastModel.Metric
                     * @enum {number}
                     * @property {number} UNKNOWN_METRIC=0 UNKNOWN_METRIC value
                     * @property {number} VISITS=1 VISITS value
                     * @property {number} NET_SALES=2 NET_SALES value
                     * @property {number} TRANSACTION=3 TRANSACTION value
                     * @property {number} NET_SALES_ITEMS=4 NET_SALES_ITEMS value
                     */
                    ForecastModel.Metric = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_METRIC"] = 0;
                        values[valuesById[1] = "VISITS"] = 1;
                        values[valuesById[2] = "NET_SALES"] = 2;
                        values[valuesById[3] = "TRANSACTION"] = 3;
                        values[valuesById[4] = "NET_SALES_ITEMS"] = 4;
                        return values;
                    })();
    
                    return ForecastModel;
                })();
    
                v1.ForecastModelVersion = (function() {
    
                    /**
                     * Properties of a ForecastModelVersion.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastModelVersion
                     * @property {number|null} [id] ForecastModelVersion id
                     * @property {palexy.streaming.v1.IForecastModel|null} [model] ForecastModelVersion model
                     * @property {string|null} [versionName] ForecastModelVersion versionName
                     * @property {boolean|null} [isEnabledForInferring] ForecastModelVersion isEnabledForInferring
                     * @property {boolean|null} [isActive] ForecastModelVersion isActive
                     * @property {Object.<string,string>|null} [additionalProperties] ForecastModelVersion additionalProperties
                     * @property {boolean|null} [isEnabledForAggregatingByDefault] ForecastModelVersion isEnabledForAggregatingByDefault
                     */
    
                    /**
                     * Constructs a new ForecastModelVersion.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastModelVersion.
                     * @implements IForecastModelVersion
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastModelVersion=} [properties] Properties to set
                     */
                    function ForecastModelVersion(properties) {
                        this.additionalProperties = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastModelVersion id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastModelVersion model.
                     * @member {palexy.streaming.v1.IForecastModel|null|undefined} model
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.model = null;
    
                    /**
                     * ForecastModelVersion versionName.
                     * @member {string} versionName
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.versionName = "";
    
                    /**
                     * ForecastModelVersion isEnabledForInferring.
                     * @member {boolean} isEnabledForInferring
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.isEnabledForInferring = false;
    
                    /**
                     * ForecastModelVersion isActive.
                     * @member {boolean} isActive
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.isActive = false;
    
                    /**
                     * ForecastModelVersion additionalProperties.
                     * @member {Object.<string,string>} additionalProperties
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.additionalProperties = $util.emptyObject;
    
                    /**
                     * ForecastModelVersion isEnabledForAggregatingByDefault.
                     * @member {boolean} isEnabledForAggregatingByDefault
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     */
                    ForecastModelVersion.prototype.isEnabledForAggregatingByDefault = false;
    
                    /**
                     * Creates a new ForecastModelVersion instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {palexy.streaming.v1.IForecastModelVersion=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastModelVersion} ForecastModelVersion instance
                     */
                    ForecastModelVersion.create = function create(properties) {
                        return new ForecastModelVersion(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastModelVersion message. Does not implicitly {@link palexy.streaming.v1.ForecastModelVersion.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {palexy.streaming.v1.IForecastModelVersion} message ForecastModelVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastModelVersion.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                            $root.palexy.streaming.v1.ForecastModel.encode(message.model, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.versionName != null && Object.hasOwnProperty.call(message, "versionName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.versionName);
                        if (message.isEnabledForInferring != null && Object.hasOwnProperty.call(message, "isEnabledForInferring"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isEnabledForInferring);
                        if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isActive);
                        if (message.additionalProperties != null && Object.hasOwnProperty.call(message, "additionalProperties"))
                            for (var keys = Object.keys(message.additionalProperties), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalProperties[keys[i]]).ldelim();
                        if (message.isEnabledForAggregatingByDefault != null && Object.hasOwnProperty.call(message, "isEnabledForAggregatingByDefault"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isEnabledForAggregatingByDefault);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastModelVersion message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastModelVersion.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {palexy.streaming.v1.IForecastModelVersion} message ForecastModelVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastModelVersion.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastModelVersion message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastModelVersion} ForecastModelVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastModelVersion.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastModelVersion(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.model = $root.palexy.streaming.v1.ForecastModel.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.versionName = reader.string();
                                break;
                            case 4:
                                message.isEnabledForInferring = reader.bool();
                                break;
                            case 5:
                                message.isActive = reader.bool();
                                break;
                            case 6:
                                if (message.additionalProperties === $util.emptyObject)
                                    message.additionalProperties = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.additionalProperties[key] = value;
                                break;
                            case 7:
                                message.isEnabledForAggregatingByDefault = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastModelVersion message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastModelVersion} ForecastModelVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastModelVersion.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastModelVersion message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastModelVersion.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.model != null && message.hasOwnProperty("model")) {
                            var error = $root.palexy.streaming.v1.ForecastModel.verify(message.model);
                            if (error)
                                return "model." + error;
                        }
                        if (message.versionName != null && message.hasOwnProperty("versionName"))
                            if (!$util.isString(message.versionName))
                                return "versionName: string expected";
                        if (message.isEnabledForInferring != null && message.hasOwnProperty("isEnabledForInferring"))
                            if (typeof message.isEnabledForInferring !== "boolean")
                                return "isEnabledForInferring: boolean expected";
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            if (typeof message.isActive !== "boolean")
                                return "isActive: boolean expected";
                        if (message.additionalProperties != null && message.hasOwnProperty("additionalProperties")) {
                            if (!$util.isObject(message.additionalProperties))
                                return "additionalProperties: object expected";
                            var key = Object.keys(message.additionalProperties);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.additionalProperties[key[i]]))
                                    return "additionalProperties: string{k:string} expected";
                        }
                        if (message.isEnabledForAggregatingByDefault != null && message.hasOwnProperty("isEnabledForAggregatingByDefault"))
                            if (typeof message.isEnabledForAggregatingByDefault !== "boolean")
                                return "isEnabledForAggregatingByDefault: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastModelVersion message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastModelVersion} ForecastModelVersion
                     */
                    ForecastModelVersion.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastModelVersion)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastModelVersion();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.model != null) {
                            if (typeof object.model !== "object")
                                throw TypeError(".palexy.streaming.v1.ForecastModelVersion.model: object expected");
                            message.model = $root.palexy.streaming.v1.ForecastModel.fromObject(object.model);
                        }
                        if (object.versionName != null)
                            message.versionName = String(object.versionName);
                        if (object.isEnabledForInferring != null)
                            message.isEnabledForInferring = Boolean(object.isEnabledForInferring);
                        if (object.isActive != null)
                            message.isActive = Boolean(object.isActive);
                        if (object.additionalProperties) {
                            if (typeof object.additionalProperties !== "object")
                                throw TypeError(".palexy.streaming.v1.ForecastModelVersion.additionalProperties: object expected");
                            message.additionalProperties = {};
                            for (var keys = Object.keys(object.additionalProperties), i = 0; i < keys.length; ++i)
                                message.additionalProperties[keys[i]] = String(object.additionalProperties[keys[i]]);
                        }
                        if (object.isEnabledForAggregatingByDefault != null)
                            message.isEnabledForAggregatingByDefault = Boolean(object.isEnabledForAggregatingByDefault);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastModelVersion message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @static
                     * @param {palexy.streaming.v1.ForecastModelVersion} message ForecastModelVersion
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastModelVersion.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.additionalProperties = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.model = null;
                            object.versionName = "";
                            object.isEnabledForInferring = false;
                            object.isActive = false;
                            object.isEnabledForAggregatingByDefault = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.model != null && message.hasOwnProperty("model"))
                            object.model = $root.palexy.streaming.v1.ForecastModel.toObject(message.model, options);
                        if (message.versionName != null && message.hasOwnProperty("versionName"))
                            object.versionName = message.versionName;
                        if (message.isEnabledForInferring != null && message.hasOwnProperty("isEnabledForInferring"))
                            object.isEnabledForInferring = message.isEnabledForInferring;
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            object.isActive = message.isActive;
                        var keys2;
                        if (message.additionalProperties && (keys2 = Object.keys(message.additionalProperties)).length) {
                            object.additionalProperties = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.additionalProperties[keys2[j]] = message.additionalProperties[keys2[j]];
                        }
                        if (message.isEnabledForAggregatingByDefault != null && message.hasOwnProperty("isEnabledForAggregatingByDefault"))
                            object.isEnabledForAggregatingByDefault = message.isEnabledForAggregatingByDefault;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastModelVersion to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastModelVersion
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastModelVersion.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastModelVersion;
                })();
    
                v1.ForecastPrediction = (function() {
    
                    /**
                     * Properties of a ForecastPrediction.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastPrediction
                     * @property {number|null} [modelVersionId] ForecastPrediction modelVersionId
                     * @property {number|null} [historicalDataDateId] ForecastPrediction historicalDataDateId
                     * @property {Array.<palexy.streaming.v1.IForecastStoreWholeDay>|null} [storeWholeDayForecasts] ForecastPrediction storeWholeDayForecasts
                     * @property {Array.<palexy.streaming.v1.IForecastStoreHour>|null} [storeHourForecasts] ForecastPrediction storeHourForecasts
                     * @property {Array.<palexy.streaming.v1.IForecastSectionWholeDay>|null} [sectionWholeDayForecasts] ForecastPrediction sectionWholeDayForecasts
                     * @property {Array.<palexy.streaming.v1.IForecastSectionHour>|null} [sectionHourForecasts] ForecastPrediction sectionHourForecasts
                     */
    
                    /**
                     * Constructs a new ForecastPrediction.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastPrediction.
                     * @implements IForecastPrediction
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastPrediction=} [properties] Properties to set
                     */
                    function ForecastPrediction(properties) {
                        this.storeWholeDayForecasts = [];
                        this.storeHourForecasts = [];
                        this.sectionWholeDayForecasts = [];
                        this.sectionHourForecasts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastPrediction modelVersionId.
                     * @member {number} modelVersionId
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.modelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastPrediction historicalDataDateId.
                     * @member {number} historicalDataDateId
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.historicalDataDateId = 0;
    
                    /**
                     * ForecastPrediction storeWholeDayForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastStoreWholeDay>} storeWholeDayForecasts
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.storeWholeDayForecasts = $util.emptyArray;
    
                    /**
                     * ForecastPrediction storeHourForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastStoreHour>} storeHourForecasts
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.storeHourForecasts = $util.emptyArray;
    
                    /**
                     * ForecastPrediction sectionWholeDayForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionWholeDay>} sectionWholeDayForecasts
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.sectionWholeDayForecasts = $util.emptyArray;
    
                    /**
                     * ForecastPrediction sectionHourForecasts.
                     * @member {Array.<palexy.streaming.v1.IForecastSectionHour>} sectionHourForecasts
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     */
                    ForecastPrediction.prototype.sectionHourForecasts = $util.emptyArray;
    
                    /**
                     * Creates a new ForecastPrediction instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {palexy.streaming.v1.IForecastPrediction=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastPrediction} ForecastPrediction instance
                     */
                    ForecastPrediction.create = function create(properties) {
                        return new ForecastPrediction(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastPrediction message. Does not implicitly {@link palexy.streaming.v1.ForecastPrediction.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {palexy.streaming.v1.IForecastPrediction} message ForecastPrediction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastPrediction.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.modelVersionId != null && Object.hasOwnProperty.call(message, "modelVersionId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.modelVersionId);
                        if (message.historicalDataDateId != null && Object.hasOwnProperty.call(message, "historicalDataDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.historicalDataDateId);
                        if (message.storeWholeDayForecasts != null && message.storeWholeDayForecasts.length)
                            for (var i = 0; i < message.storeWholeDayForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastStoreWholeDay.encode(message.storeWholeDayForecasts[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.storeHourForecasts != null && message.storeHourForecasts.length)
                            for (var i = 0; i < message.storeHourForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastStoreHour.encode(message.storeHourForecasts[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.sectionWholeDayForecasts != null && message.sectionWholeDayForecasts.length)
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionWholeDay.encode(message.sectionWholeDayForecasts[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.sectionHourForecasts != null && message.sectionHourForecasts.length)
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i)
                                $root.palexy.streaming.v1.ForecastSectionHour.encode(message.sectionHourForecasts[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastPrediction message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastPrediction.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {palexy.streaming.v1.IForecastPrediction} message ForecastPrediction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastPrediction.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastPrediction message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastPrediction} ForecastPrediction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastPrediction.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastPrediction();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.modelVersionId = reader.int64();
                                break;
                            case 2:
                                message.historicalDataDateId = reader.int32();
                                break;
                            case 3:
                                if (!(message.storeWholeDayForecasts && message.storeWholeDayForecasts.length))
                                    message.storeWholeDayForecasts = [];
                                message.storeWholeDayForecasts.push($root.palexy.streaming.v1.ForecastStoreWholeDay.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                if (!(message.storeHourForecasts && message.storeHourForecasts.length))
                                    message.storeHourForecasts = [];
                                message.storeHourForecasts.push($root.palexy.streaming.v1.ForecastStoreHour.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                if (!(message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length))
                                    message.sectionWholeDayForecasts = [];
                                message.sectionWholeDayForecasts.push($root.palexy.streaming.v1.ForecastSectionWholeDay.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                if (!(message.sectionHourForecasts && message.sectionHourForecasts.length))
                                    message.sectionHourForecasts = [];
                                message.sectionHourForecasts.push($root.palexy.streaming.v1.ForecastSectionHour.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastPrediction message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastPrediction} ForecastPrediction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastPrediction.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastPrediction message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastPrediction.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (!$util.isInteger(message.modelVersionId) && !(message.modelVersionId && $util.isInteger(message.modelVersionId.low) && $util.isInteger(message.modelVersionId.high)))
                                return "modelVersionId: integer|Long expected";
                        if (message.historicalDataDateId != null && message.hasOwnProperty("historicalDataDateId"))
                            if (!$util.isInteger(message.historicalDataDateId))
                                return "historicalDataDateId: integer expected";
                        if (message.storeWholeDayForecasts != null && message.hasOwnProperty("storeWholeDayForecasts")) {
                            if (!Array.isArray(message.storeWholeDayForecasts))
                                return "storeWholeDayForecasts: array expected";
                            for (var i = 0; i < message.storeWholeDayForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastStoreWholeDay.verify(message.storeWholeDayForecasts[i]);
                                if (error)
                                    return "storeWholeDayForecasts." + error;
                            }
                        }
                        if (message.storeHourForecasts != null && message.hasOwnProperty("storeHourForecasts")) {
                            if (!Array.isArray(message.storeHourForecasts))
                                return "storeHourForecasts: array expected";
                            for (var i = 0; i < message.storeHourForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastStoreHour.verify(message.storeHourForecasts[i]);
                                if (error)
                                    return "storeHourForecasts." + error;
                            }
                        }
                        if (message.sectionWholeDayForecasts != null && message.hasOwnProperty("sectionWholeDayForecasts")) {
                            if (!Array.isArray(message.sectionWholeDayForecasts))
                                return "sectionWholeDayForecasts: array expected";
                            for (var i = 0; i < message.sectionWholeDayForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionWholeDay.verify(message.sectionWholeDayForecasts[i]);
                                if (error)
                                    return "sectionWholeDayForecasts." + error;
                            }
                        }
                        if (message.sectionHourForecasts != null && message.hasOwnProperty("sectionHourForecasts")) {
                            if (!Array.isArray(message.sectionHourForecasts))
                                return "sectionHourForecasts: array expected";
                            for (var i = 0; i < message.sectionHourForecasts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ForecastSectionHour.verify(message.sectionHourForecasts[i]);
                                if (error)
                                    return "sectionHourForecasts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ForecastPrediction message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastPrediction} ForecastPrediction
                     */
                    ForecastPrediction.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastPrediction)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastPrediction();
                        if (object.modelVersionId != null)
                            if ($util.Long)
                                (message.modelVersionId = $util.Long.fromValue(object.modelVersionId)).unsigned = false;
                            else if (typeof object.modelVersionId === "string")
                                message.modelVersionId = parseInt(object.modelVersionId, 10);
                            else if (typeof object.modelVersionId === "number")
                                message.modelVersionId = object.modelVersionId;
                            else if (typeof object.modelVersionId === "object")
                                message.modelVersionId = new $util.LongBits(object.modelVersionId.low >>> 0, object.modelVersionId.high >>> 0).toNumber();
                        if (object.historicalDataDateId != null)
                            message.historicalDataDateId = object.historicalDataDateId | 0;
                        if (object.storeWholeDayForecasts) {
                            if (!Array.isArray(object.storeWholeDayForecasts))
                                throw TypeError(".palexy.streaming.v1.ForecastPrediction.storeWholeDayForecasts: array expected");
                            message.storeWholeDayForecasts = [];
                            for (var i = 0; i < object.storeWholeDayForecasts.length; ++i) {
                                if (typeof object.storeWholeDayForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastPrediction.storeWholeDayForecasts: object expected");
                                message.storeWholeDayForecasts[i] = $root.palexy.streaming.v1.ForecastStoreWholeDay.fromObject(object.storeWholeDayForecasts[i]);
                            }
                        }
                        if (object.storeHourForecasts) {
                            if (!Array.isArray(object.storeHourForecasts))
                                throw TypeError(".palexy.streaming.v1.ForecastPrediction.storeHourForecasts: array expected");
                            message.storeHourForecasts = [];
                            for (var i = 0; i < object.storeHourForecasts.length; ++i) {
                                if (typeof object.storeHourForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastPrediction.storeHourForecasts: object expected");
                                message.storeHourForecasts[i] = $root.palexy.streaming.v1.ForecastStoreHour.fromObject(object.storeHourForecasts[i]);
                            }
                        }
                        if (object.sectionWholeDayForecasts) {
                            if (!Array.isArray(object.sectionWholeDayForecasts))
                                throw TypeError(".palexy.streaming.v1.ForecastPrediction.sectionWholeDayForecasts: array expected");
                            message.sectionWholeDayForecasts = [];
                            for (var i = 0; i < object.sectionWholeDayForecasts.length; ++i) {
                                if (typeof object.sectionWholeDayForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastPrediction.sectionWholeDayForecasts: object expected");
                                message.sectionWholeDayForecasts[i] = $root.palexy.streaming.v1.ForecastSectionWholeDay.fromObject(object.sectionWholeDayForecasts[i]);
                            }
                        }
                        if (object.sectionHourForecasts) {
                            if (!Array.isArray(object.sectionHourForecasts))
                                throw TypeError(".palexy.streaming.v1.ForecastPrediction.sectionHourForecasts: array expected");
                            message.sectionHourForecasts = [];
                            for (var i = 0; i < object.sectionHourForecasts.length; ++i) {
                                if (typeof object.sectionHourForecasts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastPrediction.sectionHourForecasts: object expected");
                                message.sectionHourForecasts[i] = $root.palexy.streaming.v1.ForecastSectionHour.fromObject(object.sectionHourForecasts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastPrediction message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @static
                     * @param {palexy.streaming.v1.ForecastPrediction} message ForecastPrediction
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastPrediction.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeWholeDayForecasts = [];
                            object.storeHourForecasts = [];
                            object.sectionWholeDayForecasts = [];
                            object.sectionHourForecasts = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.modelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.modelVersionId = options.longs === String ? "0" : 0;
                            object.historicalDataDateId = 0;
                        }
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (typeof message.modelVersionId === "number")
                                object.modelVersionId = options.longs === String ? String(message.modelVersionId) : message.modelVersionId;
                            else
                                object.modelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.modelVersionId) : options.longs === Number ? new $util.LongBits(message.modelVersionId.low >>> 0, message.modelVersionId.high >>> 0).toNumber() : message.modelVersionId;
                        if (message.historicalDataDateId != null && message.hasOwnProperty("historicalDataDateId"))
                            object.historicalDataDateId = message.historicalDataDateId;
                        if (message.storeWholeDayForecasts && message.storeWholeDayForecasts.length) {
                            object.storeWholeDayForecasts = [];
                            for (var j = 0; j < message.storeWholeDayForecasts.length; ++j)
                                object.storeWholeDayForecasts[j] = $root.palexy.streaming.v1.ForecastStoreWholeDay.toObject(message.storeWholeDayForecasts[j], options);
                        }
                        if (message.storeHourForecasts && message.storeHourForecasts.length) {
                            object.storeHourForecasts = [];
                            for (var j = 0; j < message.storeHourForecasts.length; ++j)
                                object.storeHourForecasts[j] = $root.palexy.streaming.v1.ForecastStoreHour.toObject(message.storeHourForecasts[j], options);
                        }
                        if (message.sectionWholeDayForecasts && message.sectionWholeDayForecasts.length) {
                            object.sectionWholeDayForecasts = [];
                            for (var j = 0; j < message.sectionWholeDayForecasts.length; ++j)
                                object.sectionWholeDayForecasts[j] = $root.palexy.streaming.v1.ForecastSectionWholeDay.toObject(message.sectionWholeDayForecasts[j], options);
                        }
                        if (message.sectionHourForecasts && message.sectionHourForecasts.length) {
                            object.sectionHourForecasts = [];
                            for (var j = 0; j < message.sectionHourForecasts.length; ++j)
                                object.sectionHourForecasts[j] = $root.palexy.streaming.v1.ForecastSectionHour.toObject(message.sectionHourForecasts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ForecastPrediction to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastPrediction
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastPrediction.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastPrediction;
                })();
    
                v1.ForecastStoreWholeDay = (function() {
    
                    /**
                     * Properties of a ForecastStoreWholeDay.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastStoreWholeDay
                     * @property {number|null} [storeId] ForecastStoreWholeDay storeId
                     * @property {number|null} [dateId] ForecastStoreWholeDay dateId
                     * @property {number|null} [forecastValue] ForecastStoreWholeDay forecastValue
                     * @property {Array.<palexy.streaming.v1.IInfluenceFactor>|null} [influenceFactors] ForecastStoreWholeDay influenceFactors
                     */
    
                    /**
                     * Constructs a new ForecastStoreWholeDay.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastStoreWholeDay.
                     * @implements IForecastStoreWholeDay
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastStoreWholeDay=} [properties] Properties to set
                     */
                    function ForecastStoreWholeDay(properties) {
                        this.influenceFactors = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastStoreWholeDay storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @instance
                     */
                    ForecastStoreWholeDay.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastStoreWholeDay dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @instance
                     */
                    ForecastStoreWholeDay.prototype.dateId = 0;
    
                    /**
                     * ForecastStoreWholeDay forecastValue.
                     * @member {number} forecastValue
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @instance
                     */
                    ForecastStoreWholeDay.prototype.forecastValue = 0;
    
                    /**
                     * ForecastStoreWholeDay influenceFactors.
                     * @member {Array.<palexy.streaming.v1.IInfluenceFactor>} influenceFactors
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @instance
                     */
                    ForecastStoreWholeDay.prototype.influenceFactors = $util.emptyArray;
    
                    /**
                     * Creates a new ForecastStoreWholeDay instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDay=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDay} ForecastStoreWholeDay instance
                     */
                    ForecastStoreWholeDay.create = function create(properties) {
                        return new ForecastStoreWholeDay(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastStoreWholeDay message. Does not implicitly {@link palexy.streaming.v1.ForecastStoreWholeDay.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDay} message ForecastStoreWholeDay message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreWholeDay.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.forecastValue != null && Object.hasOwnProperty.call(message, "forecastValue"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.forecastValue);
                        if (message.influenceFactors != null && message.influenceFactors.length)
                            for (var i = 0; i < message.influenceFactors.length; ++i)
                                $root.palexy.streaming.v1.InfluenceFactor.encode(message.influenceFactors[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastStoreWholeDay message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastStoreWholeDay.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreWholeDay} message ForecastStoreWholeDay message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreWholeDay.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastStoreWholeDay message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDay} ForecastStoreWholeDay
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreWholeDay.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastStoreWholeDay();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.forecastValue = reader.float();
                                break;
                            case 4:
                                if (!(message.influenceFactors && message.influenceFactors.length))
                                    message.influenceFactors = [];
                                message.influenceFactors.push($root.palexy.streaming.v1.InfluenceFactor.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastStoreWholeDay message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDay} ForecastStoreWholeDay
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreWholeDay.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastStoreWholeDay message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastStoreWholeDay.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            if (typeof message.forecastValue !== "number")
                                return "forecastValue: number expected";
                        if (message.influenceFactors != null && message.hasOwnProperty("influenceFactors")) {
                            if (!Array.isArray(message.influenceFactors))
                                return "influenceFactors: array expected";
                            for (var i = 0; i < message.influenceFactors.length; ++i) {
                                var error = $root.palexy.streaming.v1.InfluenceFactor.verify(message.influenceFactors[i]);
                                if (error)
                                    return "influenceFactors." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ForecastStoreWholeDay message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastStoreWholeDay} ForecastStoreWholeDay
                     */
                    ForecastStoreWholeDay.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastStoreWholeDay)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastStoreWholeDay();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.forecastValue != null)
                            message.forecastValue = Number(object.forecastValue);
                        if (object.influenceFactors) {
                            if (!Array.isArray(object.influenceFactors))
                                throw TypeError(".palexy.streaming.v1.ForecastStoreWholeDay.influenceFactors: array expected");
                            message.influenceFactors = [];
                            for (var i = 0; i < object.influenceFactors.length; ++i) {
                                if (typeof object.influenceFactors[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ForecastStoreWholeDay.influenceFactors: object expected");
                                message.influenceFactors[i] = $root.palexy.streaming.v1.InfluenceFactor.fromObject(object.influenceFactors[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastStoreWholeDay message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @static
                     * @param {palexy.streaming.v1.ForecastStoreWholeDay} message ForecastStoreWholeDay
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastStoreWholeDay.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.influenceFactors = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.forecastValue = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            object.forecastValue = options.json && !isFinite(message.forecastValue) ? String(message.forecastValue) : message.forecastValue;
                        if (message.influenceFactors && message.influenceFactors.length) {
                            object.influenceFactors = [];
                            for (var j = 0; j < message.influenceFactors.length; ++j)
                                object.influenceFactors[j] = $root.palexy.streaming.v1.InfluenceFactor.toObject(message.influenceFactors[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ForecastStoreWholeDay to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastStoreWholeDay
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastStoreWholeDay.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastStoreWholeDay;
                })();
    
                v1.InfluenceFactor = (function() {
    
                    /**
                     * Properties of an InfluenceFactor.
                     * @memberof palexy.streaming.v1
                     * @interface IInfluenceFactor
                     * @property {palexy.streaming.v1.InfluenceFactor.FactorType|null} [type] InfluenceFactor type
                     * @property {string|null} [name] InfluenceFactor name
                     * @property {number|null} [estimatedPercentageInfluence] InfluenceFactor estimatedPercentageInfluence
                     */
    
                    /**
                     * Constructs a new InfluenceFactor.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an InfluenceFactor.
                     * @implements IInfluenceFactor
                     * @constructor
                     * @param {palexy.streaming.v1.IInfluenceFactor=} [properties] Properties to set
                     */
                    function InfluenceFactor(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * InfluenceFactor type.
                     * @member {palexy.streaming.v1.InfluenceFactor.FactorType} type
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @instance
                     */
                    InfluenceFactor.prototype.type = 0;
    
                    /**
                     * InfluenceFactor name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @instance
                     */
                    InfluenceFactor.prototype.name = "";
    
                    /**
                     * InfluenceFactor estimatedPercentageInfluence.
                     * @member {number} estimatedPercentageInfluence
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @instance
                     */
                    InfluenceFactor.prototype.estimatedPercentageInfluence = 0;
    
                    /**
                     * Creates a new InfluenceFactor instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {palexy.streaming.v1.IInfluenceFactor=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.InfluenceFactor} InfluenceFactor instance
                     */
                    InfluenceFactor.create = function create(properties) {
                        return new InfluenceFactor(properties);
                    };
    
                    /**
                     * Encodes the specified InfluenceFactor message. Does not implicitly {@link palexy.streaming.v1.InfluenceFactor.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {palexy.streaming.v1.IInfluenceFactor} message InfluenceFactor message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InfluenceFactor.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.estimatedPercentageInfluence != null && Object.hasOwnProperty.call(message, "estimatedPercentageInfluence"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.estimatedPercentageInfluence);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified InfluenceFactor message, length delimited. Does not implicitly {@link palexy.streaming.v1.InfluenceFactor.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {palexy.streaming.v1.IInfluenceFactor} message InfluenceFactor message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InfluenceFactor.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an InfluenceFactor message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.InfluenceFactor} InfluenceFactor
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InfluenceFactor.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.InfluenceFactor();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.estimatedPercentageInfluence = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an InfluenceFactor message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.InfluenceFactor} InfluenceFactor
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InfluenceFactor.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an InfluenceFactor message.
                     * @function verify
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    InfluenceFactor.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                                break;
                            }
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.estimatedPercentageInfluence != null && message.hasOwnProperty("estimatedPercentageInfluence"))
                            if (typeof message.estimatedPercentageInfluence !== "number")
                                return "estimatedPercentageInfluence: number expected";
                        return null;
                    };
    
                    /**
                     * Creates an InfluenceFactor message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.InfluenceFactor} InfluenceFactor
                     */
                    InfluenceFactor.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.InfluenceFactor)
                            return object;
                        var message = new $root.palexy.streaming.v1.InfluenceFactor();
                        switch (object.type) {
                        case "UNKNOWN_FACTOR_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "EVENT":
                        case 1:
                            message.type = 1;
                            break;
                        case "HOLIDAY":
                        case 2:
                            message.type = 2;
                            break;
                        case "PROMOTION":
                        case 3:
                            message.type = 3;
                            break;
                        case "WEEK_OF_MONTH":
                        case 4:
                            message.type = 4;
                            break;
                        case "RAIN":
                        case 5:
                            message.type = 5;
                            break;
                        case "TET":
                        case 6:
                            message.type = 6;
                            break;
                        case "RECENT_DOWNTREND":
                        case 7:
                            message.type = 7;
                            break;
                        case "USER_CALENDAR_EVENT":
                        case 8:
                            message.type = 8;
                            break;
                        case "USER_MANUAL_OVERRIDE":
                        case 9:
                            message.type = 9;
                            break;
                        }
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.estimatedPercentageInfluence != null)
                            message.estimatedPercentageInfluence = Number(object.estimatedPercentageInfluence);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an InfluenceFactor message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @static
                     * @param {palexy.streaming.v1.InfluenceFactor} message InfluenceFactor
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    InfluenceFactor.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNKNOWN_FACTOR_TYPE" : 0;
                            object.name = "";
                            object.estimatedPercentageInfluence = 0;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.InfluenceFactor.FactorType[message.type] : message.type;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.estimatedPercentageInfluence != null && message.hasOwnProperty("estimatedPercentageInfluence"))
                            object.estimatedPercentageInfluence = options.json && !isFinite(message.estimatedPercentageInfluence) ? String(message.estimatedPercentageInfluence) : message.estimatedPercentageInfluence;
                        return object;
                    };
    
                    /**
                     * Converts this InfluenceFactor to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.InfluenceFactor
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    InfluenceFactor.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FactorType enum.
                     * @name palexy.streaming.v1.InfluenceFactor.FactorType
                     * @enum {number}
                     * @property {number} UNKNOWN_FACTOR_TYPE=0 UNKNOWN_FACTOR_TYPE value
                     * @property {number} EVENT=1 EVENT value
                     * @property {number} HOLIDAY=2 HOLIDAY value
                     * @property {number} PROMOTION=3 PROMOTION value
                     * @property {number} WEEK_OF_MONTH=4 WEEK_OF_MONTH value
                     * @property {number} RAIN=5 RAIN value
                     * @property {number} TET=6 TET value
                     * @property {number} RECENT_DOWNTREND=7 RECENT_DOWNTREND value
                     * @property {number} USER_CALENDAR_EVENT=8 USER_CALENDAR_EVENT value
                     * @property {number} USER_MANUAL_OVERRIDE=9 USER_MANUAL_OVERRIDE value
                     */
                    InfluenceFactor.FactorType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_FACTOR_TYPE"] = 0;
                        values[valuesById[1] = "EVENT"] = 1;
                        values[valuesById[2] = "HOLIDAY"] = 2;
                        values[valuesById[3] = "PROMOTION"] = 3;
                        values[valuesById[4] = "WEEK_OF_MONTH"] = 4;
                        values[valuesById[5] = "RAIN"] = 5;
                        values[valuesById[6] = "TET"] = 6;
                        values[valuesById[7] = "RECENT_DOWNTREND"] = 7;
                        values[valuesById[8] = "USER_CALENDAR_EVENT"] = 8;
                        values[valuesById[9] = "USER_MANUAL_OVERRIDE"] = 9;
                        return values;
                    })();
    
                    return InfluenceFactor;
                })();
    
                v1.ForecastStoreHour = (function() {
    
                    /**
                     * Properties of a ForecastStoreHour.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastStoreHour
                     * @property {number|null} [storeId] ForecastStoreHour storeId
                     * @property {number|null} [dateId] ForecastStoreHour dateId
                     * @property {number|null} [hour] ForecastStoreHour hour
                     * @property {number|null} [forecastValue] ForecastStoreHour forecastValue
                     */
    
                    /**
                     * Constructs a new ForecastStoreHour.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastStoreHour.
                     * @implements IForecastStoreHour
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastStoreHour=} [properties] Properties to set
                     */
                    function ForecastStoreHour(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastStoreHour storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @instance
                     */
                    ForecastStoreHour.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastStoreHour dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @instance
                     */
                    ForecastStoreHour.prototype.dateId = 0;
    
                    /**
                     * ForecastStoreHour hour.
                     * @member {number} hour
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @instance
                     */
                    ForecastStoreHour.prototype.hour = 0;
    
                    /**
                     * ForecastStoreHour forecastValue.
                     * @member {number} forecastValue
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @instance
                     */
                    ForecastStoreHour.prototype.forecastValue = 0;
    
                    /**
                     * Creates a new ForecastStoreHour instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreHour=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastStoreHour} ForecastStoreHour instance
                     */
                    ForecastStoreHour.create = function create(properties) {
                        return new ForecastStoreHour(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastStoreHour message. Does not implicitly {@link palexy.streaming.v1.ForecastStoreHour.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreHour} message ForecastStoreHour message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreHour.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.hour);
                        if (message.forecastValue != null && Object.hasOwnProperty.call(message, "forecastValue"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.forecastValue);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastStoreHour message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastStoreHour.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastStoreHour} message ForecastStoreHour message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastStoreHour.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastStoreHour message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastStoreHour} ForecastStoreHour
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreHour.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastStoreHour();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.hour = reader.int32();
                                break;
                            case 4:
                                message.forecastValue = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastStoreHour message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastStoreHour} ForecastStoreHour
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastStoreHour.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastStoreHour message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastStoreHour.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            if (!$util.isInteger(message.hour))
                                return "hour: integer expected";
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            if (typeof message.forecastValue !== "number")
                                return "forecastValue: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastStoreHour message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastStoreHour} ForecastStoreHour
                     */
                    ForecastStoreHour.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastStoreHour)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastStoreHour();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.hour != null)
                            message.hour = object.hour | 0;
                        if (object.forecastValue != null)
                            message.forecastValue = Number(object.forecastValue);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastStoreHour message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @static
                     * @param {palexy.streaming.v1.ForecastStoreHour} message ForecastStoreHour
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastStoreHour.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.hour = 0;
                            object.forecastValue = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            object.hour = message.hour;
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            object.forecastValue = options.json && !isFinite(message.forecastValue) ? String(message.forecastValue) : message.forecastValue;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastStoreHour to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastStoreHour
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastStoreHour.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastStoreHour;
                })();
    
                v1.ForecastSectionWholeDay = (function() {
    
                    /**
                     * Properties of a ForecastSectionWholeDay.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastSectionWholeDay
                     * @property {number|null} [storeId] ForecastSectionWholeDay storeId
                     * @property {number|null} [metadataValueId] ForecastSectionWholeDay metadataValueId
                     * @property {number|null} [dateId] ForecastSectionWholeDay dateId
                     * @property {number|null} [forecastValue] ForecastSectionWholeDay forecastValue
                     * @property {number|null} [modelVersionId] ForecastSectionWholeDay modelVersionId
                     */
    
                    /**
                     * Constructs a new ForecastSectionWholeDay.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastSectionWholeDay.
                     * @implements IForecastSectionWholeDay
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastSectionWholeDay=} [properties] Properties to set
                     */
                    function ForecastSectionWholeDay(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastSectionWholeDay storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     */
                    ForecastSectionWholeDay.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastSectionWholeDay metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     */
                    ForecastSectionWholeDay.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastSectionWholeDay dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     */
                    ForecastSectionWholeDay.prototype.dateId = 0;
    
                    /**
                     * ForecastSectionWholeDay forecastValue.
                     * @member {number} forecastValue
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     */
                    ForecastSectionWholeDay.prototype.forecastValue = 0;
    
                    /**
                     * ForecastSectionWholeDay modelVersionId.
                     * @member {number} modelVersionId
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     */
                    ForecastSectionWholeDay.prototype.modelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ForecastSectionWholeDay instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionWholeDay=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastSectionWholeDay} ForecastSectionWholeDay instance
                     */
                    ForecastSectionWholeDay.create = function create(properties) {
                        return new ForecastSectionWholeDay(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastSectionWholeDay message. Does not implicitly {@link palexy.streaming.v1.ForecastSectionWholeDay.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionWholeDay} message ForecastSectionWholeDay message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastSectionWholeDay.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.metadataValueId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.forecastValue != null && Object.hasOwnProperty.call(message, "forecastValue"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.forecastValue);
                        if (message.modelVersionId != null && Object.hasOwnProperty.call(message, "modelVersionId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.modelVersionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastSectionWholeDay message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastSectionWholeDay.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionWholeDay} message ForecastSectionWholeDay message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastSectionWholeDay.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastSectionWholeDay message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastSectionWholeDay} ForecastSectionWholeDay
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastSectionWholeDay.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastSectionWholeDay();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.metadataValueId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.forecastValue = reader.float();
                                break;
                            case 5:
                                message.modelVersionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastSectionWholeDay message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastSectionWholeDay} ForecastSectionWholeDay
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastSectionWholeDay.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastSectionWholeDay message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastSectionWholeDay.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            if (typeof message.forecastValue !== "number")
                                return "forecastValue: number expected";
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (!$util.isInteger(message.modelVersionId) && !(message.modelVersionId && $util.isInteger(message.modelVersionId.low) && $util.isInteger(message.modelVersionId.high)))
                                return "modelVersionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastSectionWholeDay message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastSectionWholeDay} ForecastSectionWholeDay
                     */
                    ForecastSectionWholeDay.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastSectionWholeDay)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastSectionWholeDay();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.forecastValue != null)
                            message.forecastValue = Number(object.forecastValue);
                        if (object.modelVersionId != null)
                            if ($util.Long)
                                (message.modelVersionId = $util.Long.fromValue(object.modelVersionId)).unsigned = false;
                            else if (typeof object.modelVersionId === "string")
                                message.modelVersionId = parseInt(object.modelVersionId, 10);
                            else if (typeof object.modelVersionId === "number")
                                message.modelVersionId = object.modelVersionId;
                            else if (typeof object.modelVersionId === "object")
                                message.modelVersionId = new $util.LongBits(object.modelVersionId.low >>> 0, object.modelVersionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastSectionWholeDay message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @static
                     * @param {palexy.streaming.v1.ForecastSectionWholeDay} message ForecastSectionWholeDay
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastSectionWholeDay.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.forecastValue = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.modelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.modelVersionId = options.longs === String ? "0" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            object.forecastValue = options.json && !isFinite(message.forecastValue) ? String(message.forecastValue) : message.forecastValue;
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (typeof message.modelVersionId === "number")
                                object.modelVersionId = options.longs === String ? String(message.modelVersionId) : message.modelVersionId;
                            else
                                object.modelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.modelVersionId) : options.longs === Number ? new $util.LongBits(message.modelVersionId.low >>> 0, message.modelVersionId.high >>> 0).toNumber() : message.modelVersionId;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastSectionWholeDay to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastSectionWholeDay
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastSectionWholeDay.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastSectionWholeDay;
                })();
    
                v1.ForecastSectionHour = (function() {
    
                    /**
                     * Properties of a ForecastSectionHour.
                     * @memberof palexy.streaming.v1
                     * @interface IForecastSectionHour
                     * @property {number|null} [storeId] ForecastSectionHour storeId
                     * @property {number|null} [metadataValueId] ForecastSectionHour metadataValueId
                     * @property {number|null} [dateId] ForecastSectionHour dateId
                     * @property {number|null} [hour] ForecastSectionHour hour
                     * @property {number|null} [forecastValue] ForecastSectionHour forecastValue
                     * @property {number|null} [modelVersionId] ForecastSectionHour modelVersionId
                     */
    
                    /**
                     * Constructs a new ForecastSectionHour.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ForecastSectionHour.
                     * @implements IForecastSectionHour
                     * @constructor
                     * @param {palexy.streaming.v1.IForecastSectionHour=} [properties] Properties to set
                     */
                    function ForecastSectionHour(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ForecastSectionHour storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastSectionHour metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ForecastSectionHour dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.dateId = 0;
    
                    /**
                     * ForecastSectionHour hour.
                     * @member {number} hour
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.hour = 0;
    
                    /**
                     * ForecastSectionHour forecastValue.
                     * @member {number} forecastValue
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.forecastValue = 0;
    
                    /**
                     * ForecastSectionHour modelVersionId.
                     * @member {number} modelVersionId
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     */
                    ForecastSectionHour.prototype.modelVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ForecastSectionHour instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionHour=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ForecastSectionHour} ForecastSectionHour instance
                     */
                    ForecastSectionHour.create = function create(properties) {
                        return new ForecastSectionHour(properties);
                    };
    
                    /**
                     * Encodes the specified ForecastSectionHour message. Does not implicitly {@link palexy.streaming.v1.ForecastSectionHour.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionHour} message ForecastSectionHour message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastSectionHour.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.metadataValueId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.hour);
                        if (message.forecastValue != null && Object.hasOwnProperty.call(message, "forecastValue"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.forecastValue);
                        if (message.modelVersionId != null && Object.hasOwnProperty.call(message, "modelVersionId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.modelVersionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ForecastSectionHour message, length delimited. Does not implicitly {@link palexy.streaming.v1.ForecastSectionHour.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {palexy.streaming.v1.IForecastSectionHour} message ForecastSectionHour message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ForecastSectionHour.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ForecastSectionHour message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ForecastSectionHour} ForecastSectionHour
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastSectionHour.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ForecastSectionHour();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.metadataValueId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.hour = reader.int32();
                                break;
                            case 5:
                                message.forecastValue = reader.float();
                                break;
                            case 6:
                                message.modelVersionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ForecastSectionHour message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ForecastSectionHour} ForecastSectionHour
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ForecastSectionHour.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ForecastSectionHour message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ForecastSectionHour.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            if (!$util.isInteger(message.hour))
                                return "hour: integer expected";
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            if (typeof message.forecastValue !== "number")
                                return "forecastValue: number expected";
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (!$util.isInteger(message.modelVersionId) && !(message.modelVersionId && $util.isInteger(message.modelVersionId.low) && $util.isInteger(message.modelVersionId.high)))
                                return "modelVersionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ForecastSectionHour message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ForecastSectionHour} ForecastSectionHour
                     */
                    ForecastSectionHour.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ForecastSectionHour)
                            return object;
                        var message = new $root.palexy.streaming.v1.ForecastSectionHour();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.hour != null)
                            message.hour = object.hour | 0;
                        if (object.forecastValue != null)
                            message.forecastValue = Number(object.forecastValue);
                        if (object.modelVersionId != null)
                            if ($util.Long)
                                (message.modelVersionId = $util.Long.fromValue(object.modelVersionId)).unsigned = false;
                            else if (typeof object.modelVersionId === "string")
                                message.modelVersionId = parseInt(object.modelVersionId, 10);
                            else if (typeof object.modelVersionId === "number")
                                message.modelVersionId = object.modelVersionId;
                            else if (typeof object.modelVersionId === "object")
                                message.modelVersionId = new $util.LongBits(object.modelVersionId.low >>> 0, object.modelVersionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ForecastSectionHour message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @static
                     * @param {palexy.streaming.v1.ForecastSectionHour} message ForecastSectionHour
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ForecastSectionHour.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.hour = 0;
                            object.forecastValue = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.modelVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.modelVersionId = options.longs === String ? "0" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            object.hour = message.hour;
                        if (message.forecastValue != null && message.hasOwnProperty("forecastValue"))
                            object.forecastValue = options.json && !isFinite(message.forecastValue) ? String(message.forecastValue) : message.forecastValue;
                        if (message.modelVersionId != null && message.hasOwnProperty("modelVersionId"))
                            if (typeof message.modelVersionId === "number")
                                object.modelVersionId = options.longs === String ? String(message.modelVersionId) : message.modelVersionId;
                            else
                                object.modelVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.modelVersionId) : options.longs === Number ? new $util.LongBits(message.modelVersionId.low >>> 0, message.modelVersionId.high >>> 0).toNumber() : message.modelVersionId;
                        return object;
                    };
    
                    /**
                     * Converts this ForecastSectionHour to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ForecastSectionHour
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ForecastSectionHour.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ForecastSectionHour;
                })();
    
                v1.StoreSnapshotService = (function() {
    
                    /**
                     * Constructs a new StoreSnapshotService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreSnapshotService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreSnapshotService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreSnapshotService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreSnapshotService;
    
                    /**
                     * Creates new StoreSnapshotService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreSnapshotService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreSnapshotService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreSnapshotService#createStoreSnapshot}.
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @typedef CreateStoreSnapshotCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StoreSnapshot} [response] StoreSnapshot
                     */
    
                    /**
                     * Calls CreateStoreSnapshot.
                     * @function createStoreSnapshot
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest} request CreateStoreSnapshotRequest message or plain object
                     * @param {palexy.streaming.v1.StoreSnapshotService.CreateStoreSnapshotCallback} callback Node-style callback called with the error, if any, and StoreSnapshot
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreSnapshotService.prototype.createStoreSnapshot = function createStoreSnapshot(request, callback) {
                        return this.rpcCall(createStoreSnapshot, $root.palexy.streaming.v1.CreateStoreSnapshotRequest, $root.palexy.streaming.v1.StoreSnapshot, request, callback);
                    }, "name", { value: "CreateStoreSnapshot" });
    
                    /**
                     * Calls CreateStoreSnapshot.
                     * @function createStoreSnapshot
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest} request CreateStoreSnapshotRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StoreSnapshot>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreSnapshotService#batchCreateStoreSnapshot}.
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @typedef BatchCreateStoreSnapshotCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} [response] BatchCreateStoreSnapshotResponse
                     */
    
                    /**
                     * Calls BatchCreateStoreSnapshot.
                     * @function batchCreateStoreSnapshot
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest} request BatchCreateStoreSnapshotRequest message or plain object
                     * @param {palexy.streaming.v1.StoreSnapshotService.BatchCreateStoreSnapshotCallback} callback Node-style callback called with the error, if any, and BatchCreateStoreSnapshotResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreSnapshotService.prototype.batchCreateStoreSnapshot = function batchCreateStoreSnapshot(request, callback) {
                        return this.rpcCall(batchCreateStoreSnapshot, $root.palexy.streaming.v1.BatchCreateStoreSnapshotRequest, $root.palexy.streaming.v1.BatchCreateStoreSnapshotResponse, request, callback);
                    }, "name", { value: "BatchCreateStoreSnapshot" });
    
                    /**
                     * Calls BatchCreateStoreSnapshot.
                     * @function batchCreateStoreSnapshot
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest} request BatchCreateStoreSnapshotRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateStoreSnapshotResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreSnapshotService#listStoreSnapshots}.
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @typedef ListStoreSnapshotsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreSnapshotsResponse} [response] ListStoreSnapshotsResponse
                     */
    
                    /**
                     * Calls ListStoreSnapshots.
                     * @function listStoreSnapshots
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest} request ListStoreSnapshotsRequest message or plain object
                     * @param {palexy.streaming.v1.StoreSnapshotService.ListStoreSnapshotsCallback} callback Node-style callback called with the error, if any, and ListStoreSnapshotsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreSnapshotService.prototype.listStoreSnapshots = function listStoreSnapshots(request, callback) {
                        return this.rpcCall(listStoreSnapshots, $root.palexy.streaming.v1.ListStoreSnapshotsRequest, $root.palexy.streaming.v1.ListStoreSnapshotsResponse, request, callback);
                    }, "name", { value: "ListStoreSnapshots" });
    
                    /**
                     * Calls ListStoreSnapshots.
                     * @function listStoreSnapshots
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest} request ListStoreSnapshotsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreSnapshotsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreSnapshotService#fetchStoreSnapshotsForCleaningUp}.
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @typedef FetchStoreSnapshotsForCleaningUpCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.FetchStoreSnapshotsResponse} [response] FetchStoreSnapshotsResponse
                     */
    
                    /**
                     * Calls FetchStoreSnapshotsForCleaningUp.
                     * @function fetchStoreSnapshotsForCleaningUp
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest} request FetchStoreSnapshotsForCleaningUpRequest message or plain object
                     * @param {palexy.streaming.v1.StoreSnapshotService.FetchStoreSnapshotsForCleaningUpCallback} callback Node-style callback called with the error, if any, and FetchStoreSnapshotsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreSnapshotService.prototype.fetchStoreSnapshotsForCleaningUp = function fetchStoreSnapshotsForCleaningUp(request, callback) {
                        return this.rpcCall(fetchStoreSnapshotsForCleaningUp, $root.palexy.streaming.v1.FetchStoreSnapshotsForCleaningUpRequest, $root.palexy.streaming.v1.FetchStoreSnapshotsResponse, request, callback);
                    }, "name", { value: "FetchStoreSnapshotsForCleaningUp" });
    
                    /**
                     * Calls FetchStoreSnapshotsForCleaningUp.
                     * @function fetchStoreSnapshotsForCleaningUp
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IFetchStoreSnapshotsForCleaningUpRequest} request FetchStoreSnapshotsForCleaningUpRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.FetchStoreSnapshotsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreSnapshotService#batchDeleteStoreSnapshots}.
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @typedef BatchDeleteStoreSnapshotsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls BatchDeleteStoreSnapshots.
                     * @function batchDeleteStoreSnapshots
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest} request BatchDeleteStoreSnapshotRequest message or plain object
                     * @param {palexy.streaming.v1.StoreSnapshotService.BatchDeleteStoreSnapshotsCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreSnapshotService.prototype.batchDeleteStoreSnapshots = function batchDeleteStoreSnapshots(request, callback) {
                        return this.rpcCall(batchDeleteStoreSnapshots, $root.palexy.streaming.v1.BatchDeleteStoreSnapshotRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "BatchDeleteStoreSnapshots" });
    
                    /**
                     * Calls BatchDeleteStoreSnapshots.
                     * @function batchDeleteStoreSnapshots
                     * @memberof palexy.streaming.v1.StoreSnapshotService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest} request BatchDeleteStoreSnapshotRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return StoreSnapshotService;
                })();
    
                v1.StoreSnapshot = (function() {
    
                    /**
                     * Properties of a StoreSnapshot.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreSnapshot
                     * @property {number|null} [id] StoreSnapshot id
                     * @property {number|null} [storeId] StoreSnapshot storeId
                     * @property {string|null} [cameraId] StoreSnapshot cameraId
                     * @property {string|null} [capturedTime] StoreSnapshot capturedTime
                     * @property {string|null} [scheduledTime] StoreSnapshot scheduledTime
                     * @property {string|null} [thumbnailUrl] StoreSnapshot thumbnailUrl
                     * @property {string|null} [originalImageUrl] StoreSnapshot originalImageUrl
                     * @property {string|null} [originalImageFile] StoreSnapshot originalImageFile
                     * @property {string|null} [thumbnailFile] StoreSnapshot thumbnailFile
                     */
    
                    /**
                     * Constructs a new StoreSnapshot.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreSnapshot.
                     * @implements IStoreSnapshot
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreSnapshot=} [properties] Properties to set
                     */
                    function StoreSnapshot(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreSnapshot id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreSnapshot storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreSnapshot cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.cameraId = "";
    
                    /**
                     * StoreSnapshot capturedTime.
                     * @member {string} capturedTime
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.capturedTime = "";
    
                    /**
                     * StoreSnapshot scheduledTime.
                     * @member {string} scheduledTime
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.scheduledTime = "";
    
                    /**
                     * StoreSnapshot thumbnailUrl.
                     * @member {string} thumbnailUrl
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.thumbnailUrl = "";
    
                    /**
                     * StoreSnapshot originalImageUrl.
                     * @member {string} originalImageUrl
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.originalImageUrl = "";
    
                    /**
                     * StoreSnapshot originalImageFile.
                     * @member {string} originalImageFile
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.originalImageFile = "";
    
                    /**
                     * StoreSnapshot thumbnailFile.
                     * @member {string} thumbnailFile
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     */
                    StoreSnapshot.prototype.thumbnailFile = "";
    
                    /**
                     * Creates a new StoreSnapshot instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {palexy.streaming.v1.IStoreSnapshot=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreSnapshot} StoreSnapshot instance
                     */
                    StoreSnapshot.create = function create(properties) {
                        return new StoreSnapshot(properties);
                    };
    
                    /**
                     * Encodes the specified StoreSnapshot message. Does not implicitly {@link palexy.streaming.v1.StoreSnapshot.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {palexy.streaming.v1.IStoreSnapshot} message StoreSnapshot message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreSnapshot.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.cameraId);
                        if (message.capturedTime != null && Object.hasOwnProperty.call(message, "capturedTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.capturedTime);
                        if (message.scheduledTime != null && Object.hasOwnProperty.call(message, "scheduledTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.scheduledTime);
                        if (message.thumbnailUrl != null && Object.hasOwnProperty.call(message, "thumbnailUrl"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.thumbnailUrl);
                        if (message.originalImageUrl != null && Object.hasOwnProperty.call(message, "originalImageUrl"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.originalImageUrl);
                        if (message.originalImageFile != null && Object.hasOwnProperty.call(message, "originalImageFile"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.originalImageFile);
                        if (message.thumbnailFile != null && Object.hasOwnProperty.call(message, "thumbnailFile"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.thumbnailFile);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreSnapshot message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreSnapshot.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {palexy.streaming.v1.IStoreSnapshot} message StoreSnapshot message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreSnapshot.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreSnapshot message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreSnapshot} StoreSnapshot
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreSnapshot.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreSnapshot();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.cameraId = reader.string();
                                break;
                            case 4:
                                message.capturedTime = reader.string();
                                break;
                            case 5:
                                message.scheduledTime = reader.string();
                                break;
                            case 6:
                                message.thumbnailUrl = reader.string();
                                break;
                            case 7:
                                message.originalImageUrl = reader.string();
                                break;
                            case 8:
                                message.originalImageFile = reader.string();
                                break;
                            case 9:
                                message.thumbnailFile = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreSnapshot message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreSnapshot} StoreSnapshot
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreSnapshot.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreSnapshot message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreSnapshot.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.capturedTime != null && message.hasOwnProperty("capturedTime"))
                            if (!$util.isString(message.capturedTime))
                                return "capturedTime: string expected";
                        if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                            if (!$util.isString(message.scheduledTime))
                                return "scheduledTime: string expected";
                        if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                            if (!$util.isString(message.thumbnailUrl))
                                return "thumbnailUrl: string expected";
                        if (message.originalImageUrl != null && message.hasOwnProperty("originalImageUrl"))
                            if (!$util.isString(message.originalImageUrl))
                                return "originalImageUrl: string expected";
                        if (message.originalImageFile != null && message.hasOwnProperty("originalImageFile"))
                            if (!$util.isString(message.originalImageFile))
                                return "originalImageFile: string expected";
                        if (message.thumbnailFile != null && message.hasOwnProperty("thumbnailFile"))
                            if (!$util.isString(message.thumbnailFile))
                                return "thumbnailFile: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreSnapshot message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreSnapshot} StoreSnapshot
                     */
                    StoreSnapshot.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreSnapshot)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreSnapshot();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.capturedTime != null)
                            message.capturedTime = String(object.capturedTime);
                        if (object.scheduledTime != null)
                            message.scheduledTime = String(object.scheduledTime);
                        if (object.thumbnailUrl != null)
                            message.thumbnailUrl = String(object.thumbnailUrl);
                        if (object.originalImageUrl != null)
                            message.originalImageUrl = String(object.originalImageUrl);
                        if (object.originalImageFile != null)
                            message.originalImageFile = String(object.originalImageFile);
                        if (object.thumbnailFile != null)
                            message.thumbnailFile = String(object.thumbnailFile);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreSnapshot message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @static
                     * @param {palexy.streaming.v1.StoreSnapshot} message StoreSnapshot
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreSnapshot.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.cameraId = "";
                            object.capturedTime = "";
                            object.scheduledTime = "";
                            object.thumbnailUrl = "";
                            object.originalImageUrl = "";
                            object.originalImageFile = "";
                            object.thumbnailFile = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.capturedTime != null && message.hasOwnProperty("capturedTime"))
                            object.capturedTime = message.capturedTime;
                        if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                            object.scheduledTime = message.scheduledTime;
                        if (message.thumbnailUrl != null && message.hasOwnProperty("thumbnailUrl"))
                            object.thumbnailUrl = message.thumbnailUrl;
                        if (message.originalImageUrl != null && message.hasOwnProperty("originalImageUrl"))
                            object.originalImageUrl = message.originalImageUrl;
                        if (message.originalImageFile != null && message.hasOwnProperty("originalImageFile"))
                            object.originalImageFile = message.originalImageFile;
                        if (message.thumbnailFile != null && message.hasOwnProperty("thumbnailFile"))
                            object.thumbnailFile = message.thumbnailFile;
                        return object;
                    };
    
                    /**
                     * Converts this StoreSnapshot to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreSnapshot
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreSnapshot.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreSnapshot;
                })();
    
                v1.CreateStoreSnapshotRequest = (function() {
    
                    /**
                     * Properties of a CreateStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStoreSnapshotRequest
                     * @property {number|null} [storeId] CreateStoreSnapshotRequest storeId
                     * @property {string|null} [cameraId] CreateStoreSnapshotRequest cameraId
                     * @property {string|null} [capturedTime] CreateStoreSnapshotRequest capturedTime
                     * @property {string|null} [scheduledTime] CreateStoreSnapshotRequest scheduledTime
                     * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [thumbnail] CreateStoreSnapshotRequest thumbnail
                     * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [originalImage] CreateStoreSnapshotRequest originalImage
                     */
    
                    /**
                     * Constructs a new CreateStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStoreSnapshotRequest.
                     * @implements ICreateStoreSnapshotRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest=} [properties] Properties to set
                     */
                    function CreateStoreSnapshotRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStoreSnapshotRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateStoreSnapshotRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.cameraId = "";
    
                    /**
                     * CreateStoreSnapshotRequest capturedTime.
                     * @member {string} capturedTime
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.capturedTime = "";
    
                    /**
                     * CreateStoreSnapshotRequest scheduledTime.
                     * @member {string} scheduledTime
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.scheduledTime = "";
    
                    /**
                     * CreateStoreSnapshotRequest thumbnail.
                     * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} thumbnail
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.thumbnail = null;
    
                    /**
                     * CreateStoreSnapshotRequest originalImage.
                     * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} originalImage
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     */
                    CreateStoreSnapshotRequest.prototype.originalImage = null;
    
                    /**
                     * Creates a new CreateStoreSnapshotRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStoreSnapshotRequest} CreateStoreSnapshotRequest instance
                     */
                    CreateStoreSnapshotRequest.create = function create(properties) {
                        return new CreateStoreSnapshotRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStoreSnapshotRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStoreSnapshotRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest} message CreateStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreSnapshotRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.cameraId);
                        if (message.capturedTime != null && Object.hasOwnProperty.call(message, "capturedTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.capturedTime);
                        if (message.scheduledTime != null && Object.hasOwnProperty.call(message, "scheduledTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.scheduledTime);
                        if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                            $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.thumbnail, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.originalImage != null && Object.hasOwnProperty.call(message, "originalImage"))
                            $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.originalImage, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStoreSnapshotRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStoreSnapshotRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreSnapshotRequest} message CreateStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreSnapshotRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStoreSnapshotRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStoreSnapshotRequest} CreateStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreSnapshotRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStoreSnapshotRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.cameraId = reader.string();
                                break;
                            case 3:
                                message.capturedTime = reader.string();
                                break;
                            case 4:
                                message.scheduledTime = reader.string();
                                break;
                            case 5:
                                message.thumbnail = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.originalImage = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStoreSnapshotRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStoreSnapshotRequest} CreateStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreSnapshotRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStoreSnapshotRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStoreSnapshotRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.capturedTime != null && message.hasOwnProperty("capturedTime"))
                            if (!$util.isString(message.capturedTime))
                                return "capturedTime: string expected";
                        if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                            if (!$util.isString(message.scheduledTime))
                                return "scheduledTime: string expected";
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail")) {
                            var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.thumbnail);
                            if (error)
                                return "thumbnail." + error;
                        }
                        if (message.originalImage != null && message.hasOwnProperty("originalImage")) {
                            var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.originalImage);
                            if (error)
                                return "originalImage." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStoreSnapshotRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStoreSnapshotRequest} CreateStoreSnapshotRequest
                     */
                    CreateStoreSnapshotRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStoreSnapshotRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStoreSnapshotRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.capturedTime != null)
                            message.capturedTime = String(object.capturedTime);
                        if (object.scheduledTime != null)
                            message.scheduledTime = String(object.scheduledTime);
                        if (object.thumbnail != null) {
                            if (typeof object.thumbnail !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreSnapshotRequest.thumbnail: object expected");
                            message.thumbnail = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.thumbnail);
                        }
                        if (object.originalImage != null) {
                            if (typeof object.originalImage !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreSnapshotRequest.originalImage: object expected");
                            message.originalImage = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.originalImage);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStoreSnapshotRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStoreSnapshotRequest} message CreateStoreSnapshotRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStoreSnapshotRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.cameraId = "";
                            object.capturedTime = "";
                            object.scheduledTime = "";
                            object.thumbnail = null;
                            object.originalImage = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.capturedTime != null && message.hasOwnProperty("capturedTime"))
                            object.capturedTime = message.capturedTime;
                        if (message.scheduledTime != null && message.hasOwnProperty("scheduledTime"))
                            object.scheduledTime = message.scheduledTime;
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                            object.thumbnail = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.thumbnail, options);
                        if (message.originalImage != null && message.hasOwnProperty("originalImage"))
                            object.originalImage = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.originalImage, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStoreSnapshotRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStoreSnapshotRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStoreSnapshotRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStoreSnapshotRequest;
                })();
    
                v1.BatchCreateStoreSnapshotRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStoreSnapshotRequest
                     * @property {Array.<palexy.streaming.v1.ICreateStoreSnapshotRequest>|null} [requests] BatchCreateStoreSnapshotRequest requests
                     */
    
                    /**
                     * Constructs a new BatchCreateStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStoreSnapshotRequest.
                     * @implements IBatchCreateStoreSnapshotRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest=} [properties] Properties to set
                     */
                    function BatchCreateStoreSnapshotRequest(properties) {
                        this.requests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStoreSnapshotRequest requests.
                     * @member {Array.<palexy.streaming.v1.ICreateStoreSnapshotRequest>} requests
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @instance
                     */
                    BatchCreateStoreSnapshotRequest.prototype.requests = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStoreSnapshotRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotRequest} BatchCreateStoreSnapshotRequest instance
                     */
                    BatchCreateStoreSnapshotRequest.create = function create(properties) {
                        return new BatchCreateStoreSnapshotRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreSnapshotRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreSnapshotRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest} message BatchCreateStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreSnapshotRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.requests != null && message.requests.length)
                            for (var i = 0; i < message.requests.length; ++i)
                                $root.palexy.streaming.v1.CreateStoreSnapshotRequest.encode(message.requests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreSnapshotRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreSnapshotRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotRequest} message BatchCreateStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreSnapshotRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStoreSnapshotRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotRequest} BatchCreateStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreSnapshotRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStoreSnapshotRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.requests && message.requests.length))
                                    message.requests = [];
                                message.requests.push($root.palexy.streaming.v1.CreateStoreSnapshotRequest.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStoreSnapshotRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotRequest} BatchCreateStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreSnapshotRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStoreSnapshotRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStoreSnapshotRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.requests != null && message.hasOwnProperty("requests")) {
                            if (!Array.isArray(message.requests))
                                return "requests: array expected";
                            for (var i = 0; i < message.requests.length; ++i) {
                                var error = $root.palexy.streaming.v1.CreateStoreSnapshotRequest.verify(message.requests[i]);
                                if (error)
                                    return "requests." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStoreSnapshotRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotRequest} BatchCreateStoreSnapshotRequest
                     */
                    BatchCreateStoreSnapshotRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStoreSnapshotRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStoreSnapshotRequest();
                        if (object.requests) {
                            if (!Array.isArray(object.requests))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStoreSnapshotRequest.requests: array expected");
                            message.requests = [];
                            for (var i = 0; i < object.requests.length; ++i) {
                                if (typeof object.requests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStoreSnapshotRequest.requests: object expected");
                                message.requests[i] = $root.palexy.streaming.v1.CreateStoreSnapshotRequest.fromObject(object.requests[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStoreSnapshotRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStoreSnapshotRequest} message BatchCreateStoreSnapshotRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStoreSnapshotRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.requests = [];
                        if (message.requests && message.requests.length) {
                            object.requests = [];
                            for (var j = 0; j < message.requests.length; ++j)
                                object.requests[j] = $root.palexy.streaming.v1.CreateStoreSnapshotRequest.toObject(message.requests[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStoreSnapshotRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStoreSnapshotRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStoreSnapshotRequest;
                })();
    
                v1.BatchCreateStoreSnapshotResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateStoreSnapshotResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateStoreSnapshotResponse
                     * @property {Array.<palexy.streaming.v1.IStoreSnapshot>|null} [storeSnapshots] BatchCreateStoreSnapshotResponse storeSnapshots
                     */
    
                    /**
                     * Constructs a new BatchCreateStoreSnapshotResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateStoreSnapshotResponse.
                     * @implements IBatchCreateStoreSnapshotResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotResponse=} [properties] Properties to set
                     */
                    function BatchCreateStoreSnapshotResponse(properties) {
                        this.storeSnapshots = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateStoreSnapshotResponse storeSnapshots.
                     * @member {Array.<palexy.streaming.v1.IStoreSnapshot>} storeSnapshots
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @instance
                     */
                    BatchCreateStoreSnapshotResponse.prototype.storeSnapshots = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateStoreSnapshotResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} BatchCreateStoreSnapshotResponse instance
                     */
                    BatchCreateStoreSnapshotResponse.create = function create(properties) {
                        return new BatchCreateStoreSnapshotResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreSnapshotResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreSnapshotResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotResponse} message BatchCreateStoreSnapshotResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreSnapshotResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeSnapshots != null && message.storeSnapshots.length)
                            for (var i = 0; i < message.storeSnapshots.length; ++i)
                                $root.palexy.streaming.v1.StoreSnapshot.encode(message.storeSnapshots[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateStoreSnapshotResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateStoreSnapshotResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateStoreSnapshotResponse} message BatchCreateStoreSnapshotResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateStoreSnapshotResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateStoreSnapshotResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} BatchCreateStoreSnapshotResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreSnapshotResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateStoreSnapshotResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeSnapshots && message.storeSnapshots.length))
                                    message.storeSnapshots = [];
                                message.storeSnapshots.push($root.palexy.streaming.v1.StoreSnapshot.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateStoreSnapshotResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} BatchCreateStoreSnapshotResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateStoreSnapshotResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateStoreSnapshotResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateStoreSnapshotResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeSnapshots != null && message.hasOwnProperty("storeSnapshots")) {
                            if (!Array.isArray(message.storeSnapshots))
                                return "storeSnapshots: array expected";
                            for (var i = 0; i < message.storeSnapshots.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreSnapshot.verify(message.storeSnapshots[i]);
                                if (error)
                                    return "storeSnapshots." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateStoreSnapshotResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} BatchCreateStoreSnapshotResponse
                     */
                    BatchCreateStoreSnapshotResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateStoreSnapshotResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateStoreSnapshotResponse();
                        if (object.storeSnapshots) {
                            if (!Array.isArray(object.storeSnapshots))
                                throw TypeError(".palexy.streaming.v1.BatchCreateStoreSnapshotResponse.storeSnapshots: array expected");
                            message.storeSnapshots = [];
                            for (var i = 0; i < object.storeSnapshots.length; ++i) {
                                if (typeof object.storeSnapshots[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateStoreSnapshotResponse.storeSnapshots: object expected");
                                message.storeSnapshots[i] = $root.palexy.streaming.v1.StoreSnapshot.fromObject(object.storeSnapshots[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateStoreSnapshotResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateStoreSnapshotResponse} message BatchCreateStoreSnapshotResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateStoreSnapshotResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeSnapshots = [];
                        if (message.storeSnapshots && message.storeSnapshots.length) {
                            object.storeSnapshots = [];
                            for (var j = 0; j < message.storeSnapshots.length; ++j)
                                object.storeSnapshots[j] = $root.palexy.streaming.v1.StoreSnapshot.toObject(message.storeSnapshots[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateStoreSnapshotResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateStoreSnapshotResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateStoreSnapshotResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateStoreSnapshotResponse;
                })();
    
                v1.ListStoreSnapshotsRequest = (function() {
    
                    /**
                     * Properties of a ListStoreSnapshotsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreSnapshotsRequest
                     * @property {number|null} [storeId] ListStoreSnapshotsRequest storeId
                     * @property {string|null} [dateId] ListStoreSnapshotsRequest dateId
                     * @property {string|null} [cameraId] ListStoreSnapshotsRequest cameraId
                     */
    
                    /**
                     * Constructs a new ListStoreSnapshotsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreSnapshotsRequest.
                     * @implements IListStoreSnapshotsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest=} [properties] Properties to set
                     */
                    function ListStoreSnapshotsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreSnapshotsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @instance
                     */
                    ListStoreSnapshotsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreSnapshotsRequest dateId.
                     * @member {string} dateId
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @instance
                     */
                    ListStoreSnapshotsRequest.prototype.dateId = "";
    
                    /**
                     * ListStoreSnapshotsRequest cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @instance
                     */
                    ListStoreSnapshotsRequest.prototype.cameraId = "";
    
                    /**
                     * Creates a new ListStoreSnapshotsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsRequest} ListStoreSnapshotsRequest instance
                     */
                    ListStoreSnapshotsRequest.create = function create(properties) {
                        return new ListStoreSnapshotsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreSnapshotsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreSnapshotsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest} message ListStoreSnapshotsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreSnapshotsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.cameraId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreSnapshotsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreSnapshotsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsRequest} message ListStoreSnapshotsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreSnapshotsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreSnapshotsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsRequest} ListStoreSnapshotsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreSnapshotsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreSnapshotsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            case 4:
                                message.cameraId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreSnapshotsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsRequest} ListStoreSnapshotsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreSnapshotsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreSnapshotsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreSnapshotsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreSnapshotsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsRequest} ListStoreSnapshotsRequest
                     */
                    ListStoreSnapshotsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreSnapshotsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreSnapshotsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreSnapshotsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreSnapshotsRequest} message ListStoreSnapshotsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreSnapshotsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = "";
                            object.cameraId = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreSnapshotsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreSnapshotsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreSnapshotsRequest;
                })();
    
                v1.ListStoreSnapshotsResponse = (function() {
    
                    /**
                     * Properties of a ListStoreSnapshotsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreSnapshotsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreSnapshot>|null} [storeSnapshots] ListStoreSnapshotsResponse storeSnapshots
                     */
    
                    /**
                     * Constructs a new ListStoreSnapshotsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreSnapshotsResponse.
                     * @implements IListStoreSnapshotsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreSnapshotsResponse=} [properties] Properties to set
                     */
                    function ListStoreSnapshotsResponse(properties) {
                        this.storeSnapshots = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreSnapshotsResponse storeSnapshots.
                     * @member {Array.<palexy.streaming.v1.IStoreSnapshot>} storeSnapshots
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @instance
                     */
                    ListStoreSnapshotsResponse.prototype.storeSnapshots = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreSnapshotsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsResponse} ListStoreSnapshotsResponse instance
                     */
                    ListStoreSnapshotsResponse.create = function create(properties) {
                        return new ListStoreSnapshotsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreSnapshotsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreSnapshotsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsResponse} message ListStoreSnapshotsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreSnapshotsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeSnapshots != null && message.storeSnapshots.length)
                            for (var i = 0; i < message.storeSnapshots.length; ++i)
                                $root.palexy.streaming.v1.StoreSnapshot.encode(message.storeSnapshots[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreSnapshotsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreSnapshotsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreSnapshotsResponse} message ListStoreSnapshotsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreSnapshotsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreSnapshotsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsResponse} ListStoreSnapshotsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreSnapshotsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreSnapshotsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeSnapshots && message.storeSnapshots.length))
                                    message.storeSnapshots = [];
                                message.storeSnapshots.push($root.palexy.streaming.v1.StoreSnapshot.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreSnapshotsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsResponse} ListStoreSnapshotsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreSnapshotsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreSnapshotsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreSnapshotsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeSnapshots != null && message.hasOwnProperty("storeSnapshots")) {
                            if (!Array.isArray(message.storeSnapshots))
                                return "storeSnapshots: array expected";
                            for (var i = 0; i < message.storeSnapshots.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreSnapshot.verify(message.storeSnapshots[i]);
                                if (error)
                                    return "storeSnapshots." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreSnapshotsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreSnapshotsResponse} ListStoreSnapshotsResponse
                     */
                    ListStoreSnapshotsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreSnapshotsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreSnapshotsResponse();
                        if (object.storeSnapshots) {
                            if (!Array.isArray(object.storeSnapshots))
                                throw TypeError(".palexy.streaming.v1.ListStoreSnapshotsResponse.storeSnapshots: array expected");
                            message.storeSnapshots = [];
                            for (var i = 0; i < object.storeSnapshots.length; ++i) {
                                if (typeof object.storeSnapshots[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreSnapshotsResponse.storeSnapshots: object expected");
                                message.storeSnapshots[i] = $root.palexy.streaming.v1.StoreSnapshot.fromObject(object.storeSnapshots[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreSnapshotsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreSnapshotsResponse} message ListStoreSnapshotsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreSnapshotsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeSnapshots = [];
                        if (message.storeSnapshots && message.storeSnapshots.length) {
                            object.storeSnapshots = [];
                            for (var j = 0; j < message.storeSnapshots.length; ++j)
                                object.storeSnapshots[j] = $root.palexy.streaming.v1.StoreSnapshot.toObject(message.storeSnapshots[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreSnapshotsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreSnapshotsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreSnapshotsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreSnapshotsResponse;
                })();
    
                v1.BatchDeleteStoreSnapshotRequest = (function() {
    
                    /**
                     * Properties of a BatchDeleteStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDeleteStoreSnapshotRequest
                     * @property {Array.<number>|null} [storeSnapshotIds] BatchDeleteStoreSnapshotRequest storeSnapshotIds
                     */
    
                    /**
                     * Constructs a new BatchDeleteStoreSnapshotRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDeleteStoreSnapshotRequest.
                     * @implements IBatchDeleteStoreSnapshotRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest=} [properties] Properties to set
                     */
                    function BatchDeleteStoreSnapshotRequest(properties) {
                        this.storeSnapshotIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDeleteStoreSnapshotRequest storeSnapshotIds.
                     * @member {Array.<number>} storeSnapshotIds
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @instance
                     */
                    BatchDeleteStoreSnapshotRequest.prototype.storeSnapshotIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDeleteStoreSnapshotRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDeleteStoreSnapshotRequest} BatchDeleteStoreSnapshotRequest instance
                     */
                    BatchDeleteStoreSnapshotRequest.create = function create(properties) {
                        return new BatchDeleteStoreSnapshotRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDeleteStoreSnapshotRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDeleteStoreSnapshotRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest} message BatchDeleteStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteStoreSnapshotRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeSnapshotIds != null && message.storeSnapshotIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeSnapshotIds.length; ++i)
                                writer.int64(message.storeSnapshotIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDeleteStoreSnapshotRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDeleteStoreSnapshotRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDeleteStoreSnapshotRequest} message BatchDeleteStoreSnapshotRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDeleteStoreSnapshotRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDeleteStoreSnapshotRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDeleteStoreSnapshotRequest} BatchDeleteStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteStoreSnapshotRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDeleteStoreSnapshotRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeSnapshotIds && message.storeSnapshotIds.length))
                                    message.storeSnapshotIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeSnapshotIds.push(reader.int64());
                                } else
                                    message.storeSnapshotIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDeleteStoreSnapshotRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDeleteStoreSnapshotRequest} BatchDeleteStoreSnapshotRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDeleteStoreSnapshotRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDeleteStoreSnapshotRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDeleteStoreSnapshotRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeSnapshotIds != null && message.hasOwnProperty("storeSnapshotIds")) {
                            if (!Array.isArray(message.storeSnapshotIds))
                                return "storeSnapshotIds: array expected";
                            for (var i = 0; i < message.storeSnapshotIds.length; ++i)
                                if (!$util.isInteger(message.storeSnapshotIds[i]) && !(message.storeSnapshotIds[i] && $util.isInteger(message.storeSnapshotIds[i].low) && $util.isInteger(message.storeSnapshotIds[i].high)))
                                    return "storeSnapshotIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDeleteStoreSnapshotRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDeleteStoreSnapshotRequest} BatchDeleteStoreSnapshotRequest
                     */
                    BatchDeleteStoreSnapshotRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDeleteStoreSnapshotRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDeleteStoreSnapshotRequest();
                        if (object.storeSnapshotIds) {
                            if (!Array.isArray(object.storeSnapshotIds))
                                throw TypeError(".palexy.streaming.v1.BatchDeleteStoreSnapshotRequest.storeSnapshotIds: array expected");
                            message.storeSnapshotIds = [];
                            for (var i = 0; i < object.storeSnapshotIds.length; ++i)
                                if ($util.Long)
                                    (message.storeSnapshotIds[i] = $util.Long.fromValue(object.storeSnapshotIds[i])).unsigned = false;
                                else if (typeof object.storeSnapshotIds[i] === "string")
                                    message.storeSnapshotIds[i] = parseInt(object.storeSnapshotIds[i], 10);
                                else if (typeof object.storeSnapshotIds[i] === "number")
                                    message.storeSnapshotIds[i] = object.storeSnapshotIds[i];
                                else if (typeof object.storeSnapshotIds[i] === "object")
                                    message.storeSnapshotIds[i] = new $util.LongBits(object.storeSnapshotIds[i].low >>> 0, object.storeSnapshotIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDeleteStoreSnapshotRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDeleteStoreSnapshotRequest} message BatchDeleteStoreSnapshotRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDeleteStoreSnapshotRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeSnapshotIds = [];
                        if (message.storeSnapshotIds && message.storeSnapshotIds.length) {
                            object.storeSnapshotIds = [];
                            for (var j = 0; j < message.storeSnapshotIds.length; ++j)
                                if (typeof message.storeSnapshotIds[j] === "number")
                                    object.storeSnapshotIds[j] = options.longs === String ? String(message.storeSnapshotIds[j]) : message.storeSnapshotIds[j];
                                else
                                    object.storeSnapshotIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeSnapshotIds[j]) : options.longs === Number ? new $util.LongBits(message.storeSnapshotIds[j].low >>> 0, message.storeSnapshotIds[j].high >>> 0).toNumber() : message.storeSnapshotIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDeleteStoreSnapshotRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDeleteStoreSnapshotRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDeleteStoreSnapshotRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDeleteStoreSnapshotRequest;
                })();
    
                v1.StoreWeatherService = (function() {
    
                    /**
                     * Constructs a new StoreWeatherService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreWeatherService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreWeatherService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreWeatherService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreWeatherService;
    
                    /**
                     * Creates new StoreWeatherService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreWeatherService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreWeatherService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreWeatherService#batchUpdateStoreWeather}.
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @typedef BatchUpdateStoreWeatherCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} [response] BatchUpdateStoreWeatherResponse
                     */
    
                    /**
                     * Calls BatchUpdateStoreWeather.
                     * @function batchUpdateStoreWeather
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest} request BatchUpdateStoreWeatherRequest message or plain object
                     * @param {palexy.streaming.v1.StoreWeatherService.BatchUpdateStoreWeatherCallback} callback Node-style callback called with the error, if any, and BatchUpdateStoreWeatherResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreWeatherService.prototype.batchUpdateStoreWeather = function batchUpdateStoreWeather(request, callback) {
                        return this.rpcCall(batchUpdateStoreWeather, $root.palexy.streaming.v1.BatchUpdateStoreWeatherRequest, $root.palexy.streaming.v1.BatchUpdateStoreWeatherResponse, request, callback);
                    }, "name", { value: "BatchUpdateStoreWeather" });
    
                    /**
                     * Calls BatchUpdateStoreWeather.
                     * @function batchUpdateStoreWeather
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest} request BatchUpdateStoreWeatherRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUpdateStoreWeatherResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreWeatherService#listStoreWeather}.
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @typedef ListStoreWeatherCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStoreWeatherResponse} [response] ListStoreWeatherResponse
                     */
    
                    /**
                     * Calls ListStoreWeather.
                     * @function listStoreWeather
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest} request ListStoreWeatherRequest message or plain object
                     * @param {palexy.streaming.v1.StoreWeatherService.ListStoreWeatherCallback} callback Node-style callback called with the error, if any, and ListStoreWeatherResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreWeatherService.prototype.listStoreWeather = function listStoreWeather(request, callback) {
                        return this.rpcCall(listStoreWeather, $root.palexy.streaming.v1.ListStoreWeatherRequest, $root.palexy.streaming.v1.ListStoreWeatherResponse, request, callback);
                    }, "name", { value: "ListStoreWeather" });
    
                    /**
                     * Calls ListStoreWeather.
                     * @function listStoreWeather
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest} request ListStoreWeatherRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStoreWeatherResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StoreWeatherService#triggerCreateTasks}.
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @typedef TriggerCreateTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls TriggerCreateTasks.
                     * @function triggerCreateTasks
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @param {palexy.streaming.v1.StoreWeatherService.TriggerCreateTasksCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreWeatherService.prototype.triggerCreateTasks = function triggerCreateTasks(request, callback) {
                        return this.rpcCall(triggerCreateTasks, $root.google.protobuf.Empty, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "TriggerCreateTasks" });
    
                    /**
                     * Calls TriggerCreateTasks.
                     * @function triggerCreateTasks
                     * @memberof palexy.streaming.v1.StoreWeatherService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return StoreWeatherService;
                })();
    
                /**
                 * WeatherDataSource enum.
                 * @name palexy.streaming.v1.WeatherDataSource
                 * @enum {number}
                 * @property {number} UNKNOWN_DATA_SOURCE=0 UNKNOWN_DATA_SOURCE value
                 * @property {number} WEATHERAPI=1 WEATHERAPI value
                 * @property {number} WEATHERBIT=2 WEATHERBIT value
                 */
                v1.WeatherDataSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_DATA_SOURCE"] = 0;
                    values[valuesById[1] = "WEATHERAPI"] = 1;
                    values[valuesById[2] = "WEATHERBIT"] = 2;
                    return values;
                })();
    
                /**
                 * AirQualityDataSource enum.
                 * @name palexy.streaming.v1.AirQualityDataSource
                 * @enum {number}
                 * @property {number} UNKNOWN_AIR_QUALITY_DATA_SOURCE=0 UNKNOWN_AIR_QUALITY_DATA_SOURCE value
                 * @property {number} AIR_QUALITY_WEATHERBIT=1 AIR_QUALITY_WEATHERBIT value
                 */
                v1.AirQualityDataSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_AIR_QUALITY_DATA_SOURCE"] = 0;
                    values[valuesById[1] = "AIR_QUALITY_WEATHERBIT"] = 1;
                    return values;
                })();
    
                v1.StoreWeather = (function() {
    
                    /**
                     * Properties of a StoreWeather.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreWeather
                     * @property {number|null} [storeId] StoreWeather storeId
                     * @property {number|null} [dateId] StoreWeather dateId
                     * @property {number|null} [hour] StoreWeather hour
                     * @property {palexy.streaming.v1.StoreWeather.Granularity|null} [granularity] StoreWeather granularity
                     * @property {palexy.streaming.v1.StoreWeather.WeatherCondition|null} [condition] StoreWeather condition
                     * @property {string|null} [conditionDetail] StoreWeather conditionDetail
                     * @property {number|null} [minTemperatureInC] StoreWeather minTemperatureInC
                     * @property {number|null} [avgTemperatureInC] StoreWeather avgTemperatureInC
                     * @property {number|null} [maxTemperatureInC] StoreWeather maxTemperatureInC
                     * @property {number|null} [feelsLikeInC] StoreWeather feelsLikeInC
                     * @property {number|null} [chanceOfRain] StoreWeather chanceOfRain
                     * @property {number|null} [precipitationInMm] StoreWeather precipitationInMm
                     * @property {number|null} [cloud] StoreWeather cloud
                     * @property {number|null} [humidity] StoreWeather humidity
                     * @property {number|null} [uv] StoreWeather uv
                     * @property {number|null} [aqi] StoreWeather aqi
                     * @property {palexy.streaming.v1.WeatherDataSource|null} [dataSource] StoreWeather dataSource
                     * @property {palexy.streaming.v1.AirQualityDataSource|null} [airQualityDataSource] StoreWeather airQualityDataSource
                     * @property {Array.<number>|null} [rainyHours] StoreWeather rainyHours
                     * @property {palexy.streaming.v1.StoreWeather.AirQualityCondition|null} [airQualityCondition] StoreWeather airQualityCondition
                     */
    
                    /**
                     * Constructs a new StoreWeather.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreWeather.
                     * @implements IStoreWeather
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreWeather=} [properties] Properties to set
                     */
                    function StoreWeather(properties) {
                        this.rainyHours = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreWeather storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreWeather dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.dateId = 0;
    
                    /**
                     * StoreWeather hour.
                     * @member {number} hour
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.hour = 0;
    
                    /**
                     * StoreWeather granularity.
                     * @member {palexy.streaming.v1.StoreWeather.Granularity} granularity
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.granularity = 0;
    
                    /**
                     * StoreWeather condition.
                     * @member {palexy.streaming.v1.StoreWeather.WeatherCondition} condition
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.condition = 0;
    
                    /**
                     * StoreWeather conditionDetail.
                     * @member {string} conditionDetail
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.conditionDetail = "";
    
                    /**
                     * StoreWeather minTemperatureInC.
                     * @member {number} minTemperatureInC
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.minTemperatureInC = 0;
    
                    /**
                     * StoreWeather avgTemperatureInC.
                     * @member {number} avgTemperatureInC
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.avgTemperatureInC = 0;
    
                    /**
                     * StoreWeather maxTemperatureInC.
                     * @member {number} maxTemperatureInC
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.maxTemperatureInC = 0;
    
                    /**
                     * StoreWeather feelsLikeInC.
                     * @member {number} feelsLikeInC
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.feelsLikeInC = 0;
    
                    /**
                     * StoreWeather chanceOfRain.
                     * @member {number} chanceOfRain
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.chanceOfRain = 0;
    
                    /**
                     * StoreWeather precipitationInMm.
                     * @member {number} precipitationInMm
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.precipitationInMm = 0;
    
                    /**
                     * StoreWeather cloud.
                     * @member {number} cloud
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.cloud = 0;
    
                    /**
                     * StoreWeather humidity.
                     * @member {number} humidity
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.humidity = 0;
    
                    /**
                     * StoreWeather uv.
                     * @member {number} uv
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.uv = 0;
    
                    /**
                     * StoreWeather aqi.
                     * @member {number} aqi
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.aqi = 0;
    
                    /**
                     * StoreWeather dataSource.
                     * @member {palexy.streaming.v1.WeatherDataSource} dataSource
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.dataSource = 0;
    
                    /**
                     * StoreWeather airQualityDataSource.
                     * @member {palexy.streaming.v1.AirQualityDataSource} airQualityDataSource
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.airQualityDataSource = 0;
    
                    /**
                     * StoreWeather rainyHours.
                     * @member {Array.<number>} rainyHours
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.rainyHours = $util.emptyArray;
    
                    /**
                     * StoreWeather airQualityCondition.
                     * @member {palexy.streaming.v1.StoreWeather.AirQualityCondition} airQualityCondition
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     */
                    StoreWeather.prototype.airQualityCondition = 0;
    
                    /**
                     * Creates a new StoreWeather instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {palexy.streaming.v1.IStoreWeather=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreWeather} StoreWeather instance
                     */
                    StoreWeather.create = function create(properties) {
                        return new StoreWeather(properties);
                    };
    
                    /**
                     * Encodes the specified StoreWeather message. Does not implicitly {@link palexy.streaming.v1.StoreWeather.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {palexy.streaming.v1.IStoreWeather} message StoreWeather message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreWeather.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.hour != null && Object.hasOwnProperty.call(message, "hour"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.hour);
                        if (message.granularity != null && Object.hasOwnProperty.call(message, "granularity"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.granularity);
                        if (message.condition != null && Object.hasOwnProperty.call(message, "condition"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.condition);
                        if (message.conditionDetail != null && Object.hasOwnProperty.call(message, "conditionDetail"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.conditionDetail);
                        if (message.minTemperatureInC != null && Object.hasOwnProperty.call(message, "minTemperatureInC"))
                            writer.uint32(/* id 7, wireType 5 =*/61).float(message.minTemperatureInC);
                        if (message.avgTemperatureInC != null && Object.hasOwnProperty.call(message, "avgTemperatureInC"))
                            writer.uint32(/* id 8, wireType 5 =*/69).float(message.avgTemperatureInC);
                        if (message.maxTemperatureInC != null && Object.hasOwnProperty.call(message, "maxTemperatureInC"))
                            writer.uint32(/* id 9, wireType 5 =*/77).float(message.maxTemperatureInC);
                        if (message.feelsLikeInC != null && Object.hasOwnProperty.call(message, "feelsLikeInC"))
                            writer.uint32(/* id 10, wireType 5 =*/85).float(message.feelsLikeInC);
                        if (message.chanceOfRain != null && Object.hasOwnProperty.call(message, "chanceOfRain"))
                            writer.uint32(/* id 11, wireType 5 =*/93).float(message.chanceOfRain);
                        if (message.precipitationInMm != null && Object.hasOwnProperty.call(message, "precipitationInMm"))
                            writer.uint32(/* id 12, wireType 5 =*/101).float(message.precipitationInMm);
                        if (message.cloud != null && Object.hasOwnProperty.call(message, "cloud"))
                            writer.uint32(/* id 13, wireType 5 =*/109).float(message.cloud);
                        if (message.humidity != null && Object.hasOwnProperty.call(message, "humidity"))
                            writer.uint32(/* id 14, wireType 5 =*/117).float(message.humidity);
                        if (message.uv != null && Object.hasOwnProperty.call(message, "uv"))
                            writer.uint32(/* id 15, wireType 5 =*/125).float(message.uv);
                        if (message.dataSource != null && Object.hasOwnProperty.call(message, "dataSource"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.dataSource);
                        if (message.aqi != null && Object.hasOwnProperty.call(message, "aqi"))
                            writer.uint32(/* id 17, wireType 5 =*/141).float(message.aqi);
                        if (message.airQualityDataSource != null && Object.hasOwnProperty.call(message, "airQualityDataSource"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.airQualityDataSource);
                        if (message.rainyHours != null && message.rainyHours.length) {
                            writer.uint32(/* id 19, wireType 2 =*/154).fork();
                            for (var i = 0; i < message.rainyHours.length; ++i)
                                writer.int32(message.rainyHours[i]);
                            writer.ldelim();
                        }
                        if (message.airQualityCondition != null && Object.hasOwnProperty.call(message, "airQualityCondition"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.airQualityCondition);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreWeather message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreWeather.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {palexy.streaming.v1.IStoreWeather} message StoreWeather message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreWeather.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreWeather message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreWeather} StoreWeather
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreWeather.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreWeather();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.hour = reader.int32();
                                break;
                            case 4:
                                message.granularity = reader.int32();
                                break;
                            case 5:
                                message.condition = reader.int32();
                                break;
                            case 6:
                                message.conditionDetail = reader.string();
                                break;
                            case 7:
                                message.minTemperatureInC = reader.float();
                                break;
                            case 8:
                                message.avgTemperatureInC = reader.float();
                                break;
                            case 9:
                                message.maxTemperatureInC = reader.float();
                                break;
                            case 10:
                                message.feelsLikeInC = reader.float();
                                break;
                            case 11:
                                message.chanceOfRain = reader.float();
                                break;
                            case 12:
                                message.precipitationInMm = reader.float();
                                break;
                            case 13:
                                message.cloud = reader.float();
                                break;
                            case 14:
                                message.humidity = reader.float();
                                break;
                            case 15:
                                message.uv = reader.float();
                                break;
                            case 17:
                                message.aqi = reader.float();
                                break;
                            case 16:
                                message.dataSource = reader.int32();
                                break;
                            case 18:
                                message.airQualityDataSource = reader.int32();
                                break;
                            case 19:
                                if (!(message.rainyHours && message.rainyHours.length))
                                    message.rainyHours = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.rainyHours.push(reader.int32());
                                } else
                                    message.rainyHours.push(reader.int32());
                                break;
                            case 20:
                                message.airQualityCondition = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreWeather message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreWeather} StoreWeather
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreWeather.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreWeather message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreWeather.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            if (!$util.isInteger(message.hour))
                                return "hour: integer expected";
                        if (message.granularity != null && message.hasOwnProperty("granularity"))
                            switch (message.granularity) {
                            default:
                                return "granularity: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.condition != null && message.hasOwnProperty("condition"))
                            switch (message.condition) {
                            default:
                                return "condition: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.conditionDetail != null && message.hasOwnProperty("conditionDetail"))
                            if (!$util.isString(message.conditionDetail))
                                return "conditionDetail: string expected";
                        if (message.minTemperatureInC != null && message.hasOwnProperty("minTemperatureInC"))
                            if (typeof message.minTemperatureInC !== "number")
                                return "minTemperatureInC: number expected";
                        if (message.avgTemperatureInC != null && message.hasOwnProperty("avgTemperatureInC"))
                            if (typeof message.avgTemperatureInC !== "number")
                                return "avgTemperatureInC: number expected";
                        if (message.maxTemperatureInC != null && message.hasOwnProperty("maxTemperatureInC"))
                            if (typeof message.maxTemperatureInC !== "number")
                                return "maxTemperatureInC: number expected";
                        if (message.feelsLikeInC != null && message.hasOwnProperty("feelsLikeInC"))
                            if (typeof message.feelsLikeInC !== "number")
                                return "feelsLikeInC: number expected";
                        if (message.chanceOfRain != null && message.hasOwnProperty("chanceOfRain"))
                            if (typeof message.chanceOfRain !== "number")
                                return "chanceOfRain: number expected";
                        if (message.precipitationInMm != null && message.hasOwnProperty("precipitationInMm"))
                            if (typeof message.precipitationInMm !== "number")
                                return "precipitationInMm: number expected";
                        if (message.cloud != null && message.hasOwnProperty("cloud"))
                            if (typeof message.cloud !== "number")
                                return "cloud: number expected";
                        if (message.humidity != null && message.hasOwnProperty("humidity"))
                            if (typeof message.humidity !== "number")
                                return "humidity: number expected";
                        if (message.uv != null && message.hasOwnProperty("uv"))
                            if (typeof message.uv !== "number")
                                return "uv: number expected";
                        if (message.aqi != null && message.hasOwnProperty("aqi"))
                            if (typeof message.aqi !== "number")
                                return "aqi: number expected";
                        if (message.dataSource != null && message.hasOwnProperty("dataSource"))
                            switch (message.dataSource) {
                            default:
                                return "dataSource: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.airQualityDataSource != null && message.hasOwnProperty("airQualityDataSource"))
                            switch (message.airQualityDataSource) {
                            default:
                                return "airQualityDataSource: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.rainyHours != null && message.hasOwnProperty("rainyHours")) {
                            if (!Array.isArray(message.rainyHours))
                                return "rainyHours: array expected";
                            for (var i = 0; i < message.rainyHours.length; ++i)
                                if (!$util.isInteger(message.rainyHours[i]))
                                    return "rainyHours: integer[] expected";
                        }
                        if (message.airQualityCondition != null && message.hasOwnProperty("airQualityCondition"))
                            switch (message.airQualityCondition) {
                            default:
                                return "airQualityCondition: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a StoreWeather message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreWeather} StoreWeather
                     */
                    StoreWeather.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreWeather)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreWeather();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.hour != null)
                            message.hour = object.hour | 0;
                        switch (object.granularity) {
                        case "UNKNOWN":
                        case 0:
                            message.granularity = 0;
                            break;
                        case "DAILY":
                        case 1:
                            message.granularity = 1;
                            break;
                        case "HOURLY":
                        case 2:
                            message.granularity = 2;
                            break;
                        }
                        switch (object.condition) {
                        case "UNKNOWN_CONDITION":
                        case 0:
                            message.condition = 0;
                            break;
                        case "CLEAR":
                        case 1:
                            message.condition = 1;
                            break;
                        case "PARTLY_CLOUDY":
                        case 2:
                            message.condition = 2;
                            break;
                        case "CLOUDY":
                        case 3:
                            message.condition = 3;
                            break;
                        case "RAINY":
                        case 4:
                            message.condition = 4;
                            break;
                        }
                        if (object.conditionDetail != null)
                            message.conditionDetail = String(object.conditionDetail);
                        if (object.minTemperatureInC != null)
                            message.minTemperatureInC = Number(object.minTemperatureInC);
                        if (object.avgTemperatureInC != null)
                            message.avgTemperatureInC = Number(object.avgTemperatureInC);
                        if (object.maxTemperatureInC != null)
                            message.maxTemperatureInC = Number(object.maxTemperatureInC);
                        if (object.feelsLikeInC != null)
                            message.feelsLikeInC = Number(object.feelsLikeInC);
                        if (object.chanceOfRain != null)
                            message.chanceOfRain = Number(object.chanceOfRain);
                        if (object.precipitationInMm != null)
                            message.precipitationInMm = Number(object.precipitationInMm);
                        if (object.cloud != null)
                            message.cloud = Number(object.cloud);
                        if (object.humidity != null)
                            message.humidity = Number(object.humidity);
                        if (object.uv != null)
                            message.uv = Number(object.uv);
                        if (object.aqi != null)
                            message.aqi = Number(object.aqi);
                        switch (object.dataSource) {
                        case "UNKNOWN_DATA_SOURCE":
                        case 0:
                            message.dataSource = 0;
                            break;
                        case "WEATHERAPI":
                        case 1:
                            message.dataSource = 1;
                            break;
                        case "WEATHERBIT":
                        case 2:
                            message.dataSource = 2;
                            break;
                        }
                        switch (object.airQualityDataSource) {
                        case "UNKNOWN_AIR_QUALITY_DATA_SOURCE":
                        case 0:
                            message.airQualityDataSource = 0;
                            break;
                        case "AIR_QUALITY_WEATHERBIT":
                        case 1:
                            message.airQualityDataSource = 1;
                            break;
                        }
                        if (object.rainyHours) {
                            if (!Array.isArray(object.rainyHours))
                                throw TypeError(".palexy.streaming.v1.StoreWeather.rainyHours: array expected");
                            message.rainyHours = [];
                            for (var i = 0; i < object.rainyHours.length; ++i)
                                message.rainyHours[i] = object.rainyHours[i] | 0;
                        }
                        switch (object.airQualityCondition) {
                        case "UNKNOWN_AQ_CONDITION":
                        case 0:
                            message.airQualityCondition = 0;
                            break;
                        case "GOOD":
                        case 1:
                            message.airQualityCondition = 1;
                            break;
                        case "MODERATE":
                        case 2:
                            message.airQualityCondition = 2;
                            break;
                        case "UNHEALTHY_FOR_SENSITIVE_GROUPS":
                        case 3:
                            message.airQualityCondition = 3;
                            break;
                        case "UNHEALTHY":
                        case 4:
                            message.airQualityCondition = 4;
                            break;
                        case "VERY_UNHEALTHY":
                        case 5:
                            message.airQualityCondition = 5;
                            break;
                        case "HAZARDOUS":
                        case 6:
                            message.airQualityCondition = 6;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreWeather message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @static
                     * @param {palexy.streaming.v1.StoreWeather} message StoreWeather
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreWeather.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rainyHours = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.hour = 0;
                            object.granularity = options.enums === String ? "UNKNOWN" : 0;
                            object.condition = options.enums === String ? "UNKNOWN_CONDITION" : 0;
                            object.conditionDetail = "";
                            object.minTemperatureInC = 0;
                            object.avgTemperatureInC = 0;
                            object.maxTemperatureInC = 0;
                            object.feelsLikeInC = 0;
                            object.chanceOfRain = 0;
                            object.precipitationInMm = 0;
                            object.cloud = 0;
                            object.humidity = 0;
                            object.uv = 0;
                            object.dataSource = options.enums === String ? "UNKNOWN_DATA_SOURCE" : 0;
                            object.aqi = 0;
                            object.airQualityDataSource = options.enums === String ? "UNKNOWN_AIR_QUALITY_DATA_SOURCE" : 0;
                            object.airQualityCondition = options.enums === String ? "UNKNOWN_AQ_CONDITION" : 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.hour != null && message.hasOwnProperty("hour"))
                            object.hour = message.hour;
                        if (message.granularity != null && message.hasOwnProperty("granularity"))
                            object.granularity = options.enums === String ? $root.palexy.streaming.v1.StoreWeather.Granularity[message.granularity] : message.granularity;
                        if (message.condition != null && message.hasOwnProperty("condition"))
                            object.condition = options.enums === String ? $root.palexy.streaming.v1.StoreWeather.WeatherCondition[message.condition] : message.condition;
                        if (message.conditionDetail != null && message.hasOwnProperty("conditionDetail"))
                            object.conditionDetail = message.conditionDetail;
                        if (message.minTemperatureInC != null && message.hasOwnProperty("minTemperatureInC"))
                            object.minTemperatureInC = options.json && !isFinite(message.minTemperatureInC) ? String(message.minTemperatureInC) : message.minTemperatureInC;
                        if (message.avgTemperatureInC != null && message.hasOwnProperty("avgTemperatureInC"))
                            object.avgTemperatureInC = options.json && !isFinite(message.avgTemperatureInC) ? String(message.avgTemperatureInC) : message.avgTemperatureInC;
                        if (message.maxTemperatureInC != null && message.hasOwnProperty("maxTemperatureInC"))
                            object.maxTemperatureInC = options.json && !isFinite(message.maxTemperatureInC) ? String(message.maxTemperatureInC) : message.maxTemperatureInC;
                        if (message.feelsLikeInC != null && message.hasOwnProperty("feelsLikeInC"))
                            object.feelsLikeInC = options.json && !isFinite(message.feelsLikeInC) ? String(message.feelsLikeInC) : message.feelsLikeInC;
                        if (message.chanceOfRain != null && message.hasOwnProperty("chanceOfRain"))
                            object.chanceOfRain = options.json && !isFinite(message.chanceOfRain) ? String(message.chanceOfRain) : message.chanceOfRain;
                        if (message.precipitationInMm != null && message.hasOwnProperty("precipitationInMm"))
                            object.precipitationInMm = options.json && !isFinite(message.precipitationInMm) ? String(message.precipitationInMm) : message.precipitationInMm;
                        if (message.cloud != null && message.hasOwnProperty("cloud"))
                            object.cloud = options.json && !isFinite(message.cloud) ? String(message.cloud) : message.cloud;
                        if (message.humidity != null && message.hasOwnProperty("humidity"))
                            object.humidity = options.json && !isFinite(message.humidity) ? String(message.humidity) : message.humidity;
                        if (message.uv != null && message.hasOwnProperty("uv"))
                            object.uv = options.json && !isFinite(message.uv) ? String(message.uv) : message.uv;
                        if (message.dataSource != null && message.hasOwnProperty("dataSource"))
                            object.dataSource = options.enums === String ? $root.palexy.streaming.v1.WeatherDataSource[message.dataSource] : message.dataSource;
                        if (message.aqi != null && message.hasOwnProperty("aqi"))
                            object.aqi = options.json && !isFinite(message.aqi) ? String(message.aqi) : message.aqi;
                        if (message.airQualityDataSource != null && message.hasOwnProperty("airQualityDataSource"))
                            object.airQualityDataSource = options.enums === String ? $root.palexy.streaming.v1.AirQualityDataSource[message.airQualityDataSource] : message.airQualityDataSource;
                        if (message.rainyHours && message.rainyHours.length) {
                            object.rainyHours = [];
                            for (var j = 0; j < message.rainyHours.length; ++j)
                                object.rainyHours[j] = message.rainyHours[j];
                        }
                        if (message.airQualityCondition != null && message.hasOwnProperty("airQualityCondition"))
                            object.airQualityCondition = options.enums === String ? $root.palexy.streaming.v1.StoreWeather.AirQualityCondition[message.airQualityCondition] : message.airQualityCondition;
                        return object;
                    };
    
                    /**
                     * Converts this StoreWeather to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreWeather
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreWeather.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * WeatherCondition enum.
                     * @name palexy.streaming.v1.StoreWeather.WeatherCondition
                     * @enum {number}
                     * @property {number} UNKNOWN_CONDITION=0 UNKNOWN_CONDITION value
                     * @property {number} CLEAR=1 CLEAR value
                     * @property {number} PARTLY_CLOUDY=2 PARTLY_CLOUDY value
                     * @property {number} CLOUDY=3 CLOUDY value
                     * @property {number} RAINY=4 RAINY value
                     */
                    StoreWeather.WeatherCondition = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_CONDITION"] = 0;
                        values[valuesById[1] = "CLEAR"] = 1;
                        values[valuesById[2] = "PARTLY_CLOUDY"] = 2;
                        values[valuesById[3] = "CLOUDY"] = 3;
                        values[valuesById[4] = "RAINY"] = 4;
                        return values;
                    })();
    
                    /**
                     * AirQualityCondition enum.
                     * @name palexy.streaming.v1.StoreWeather.AirQualityCondition
                     * @enum {number}
                     * @property {number} UNKNOWN_AQ_CONDITION=0 UNKNOWN_AQ_CONDITION value
                     * @property {number} GOOD=1 GOOD value
                     * @property {number} MODERATE=2 MODERATE value
                     * @property {number} UNHEALTHY_FOR_SENSITIVE_GROUPS=3 UNHEALTHY_FOR_SENSITIVE_GROUPS value
                     * @property {number} UNHEALTHY=4 UNHEALTHY value
                     * @property {number} VERY_UNHEALTHY=5 VERY_UNHEALTHY value
                     * @property {number} HAZARDOUS=6 HAZARDOUS value
                     */
                    StoreWeather.AirQualityCondition = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_AQ_CONDITION"] = 0;
                        values[valuesById[1] = "GOOD"] = 1;
                        values[valuesById[2] = "MODERATE"] = 2;
                        values[valuesById[3] = "UNHEALTHY_FOR_SENSITIVE_GROUPS"] = 3;
                        values[valuesById[4] = "UNHEALTHY"] = 4;
                        values[valuesById[5] = "VERY_UNHEALTHY"] = 5;
                        values[valuesById[6] = "HAZARDOUS"] = 6;
                        return values;
                    })();
    
                    /**
                     * Granularity enum.
                     * @name palexy.streaming.v1.StoreWeather.Granularity
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} DAILY=1 DAILY value
                     * @property {number} HOURLY=2 HOURLY value
                     */
                    StoreWeather.Granularity = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "DAILY"] = 1;
                        values[valuesById[2] = "HOURLY"] = 2;
                        return values;
                    })();
    
                    return StoreWeather;
                })();
    
                v1.BatchUpdateStoreWeatherRequest = (function() {
    
                    /**
                     * Properties of a BatchUpdateStoreWeatherRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStoreWeatherRequest
                     * @property {Array.<palexy.streaming.v1.IStoreWeather>|null} [storeWeathers] BatchUpdateStoreWeatherRequest storeWeathers
                     */
    
                    /**
                     * Constructs a new BatchUpdateStoreWeatherRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStoreWeatherRequest.
                     * @implements IBatchUpdateStoreWeatherRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest=} [properties] Properties to set
                     */
                    function BatchUpdateStoreWeatherRequest(properties) {
                        this.storeWeathers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStoreWeatherRequest storeWeathers.
                     * @member {Array.<palexy.streaming.v1.IStoreWeather>} storeWeathers
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @instance
                     */
                    BatchUpdateStoreWeatherRequest.prototype.storeWeathers = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStoreWeatherRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherRequest} BatchUpdateStoreWeatherRequest instance
                     */
                    BatchUpdateStoreWeatherRequest.create = function create(properties) {
                        return new BatchUpdateStoreWeatherRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreWeatherRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreWeatherRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest} message BatchUpdateStoreWeatherRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreWeatherRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeWeathers != null && message.storeWeathers.length)
                            for (var i = 0; i < message.storeWeathers.length; ++i)
                                $root.palexy.streaming.v1.StoreWeather.encode(message.storeWeathers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreWeatherRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreWeatherRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherRequest} message BatchUpdateStoreWeatherRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreWeatherRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreWeatherRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherRequest} BatchUpdateStoreWeatherRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreWeatherRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStoreWeatherRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeWeathers && message.storeWeathers.length))
                                    message.storeWeathers = [];
                                message.storeWeathers.push($root.palexy.streaming.v1.StoreWeather.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreWeatherRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherRequest} BatchUpdateStoreWeatherRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreWeatherRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStoreWeatherRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStoreWeatherRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeWeathers != null && message.hasOwnProperty("storeWeathers")) {
                            if (!Array.isArray(message.storeWeathers))
                                return "storeWeathers: array expected";
                            for (var i = 0; i < message.storeWeathers.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreWeather.verify(message.storeWeathers[i]);
                                if (error)
                                    return "storeWeathers." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStoreWeatherRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherRequest} BatchUpdateStoreWeatherRequest
                     */
                    BatchUpdateStoreWeatherRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStoreWeatherRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStoreWeatherRequest();
                        if (object.storeWeathers) {
                            if (!Array.isArray(object.storeWeathers))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStoreWeatherRequest.storeWeathers: array expected");
                            message.storeWeathers = [];
                            for (var i = 0; i < object.storeWeathers.length; ++i) {
                                if (typeof object.storeWeathers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateStoreWeatherRequest.storeWeathers: object expected");
                                message.storeWeathers[i] = $root.palexy.streaming.v1.StoreWeather.fromObject(object.storeWeathers[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStoreWeatherRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStoreWeatherRequest} message BatchUpdateStoreWeatherRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStoreWeatherRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeWeathers = [];
                        if (message.storeWeathers && message.storeWeathers.length) {
                            object.storeWeathers = [];
                            for (var j = 0; j < message.storeWeathers.length; ++j)
                                object.storeWeathers[j] = $root.palexy.streaming.v1.StoreWeather.toObject(message.storeWeathers[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStoreWeatherRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStoreWeatherRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStoreWeatherRequest;
                })();
    
                v1.BatchUpdateStoreWeatherResponse = (function() {
    
                    /**
                     * Properties of a BatchUpdateStoreWeatherResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUpdateStoreWeatherResponse
                     * @property {Array.<palexy.streaming.v1.IStoreWeather>|null} [storeWeathers] BatchUpdateStoreWeatherResponse storeWeathers
                     */
    
                    /**
                     * Constructs a new BatchUpdateStoreWeatherResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUpdateStoreWeatherResponse.
                     * @implements IBatchUpdateStoreWeatherResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherResponse=} [properties] Properties to set
                     */
                    function BatchUpdateStoreWeatherResponse(properties) {
                        this.storeWeathers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUpdateStoreWeatherResponse storeWeathers.
                     * @member {Array.<palexy.streaming.v1.IStoreWeather>} storeWeathers
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @instance
                     */
                    BatchUpdateStoreWeatherResponse.prototype.storeWeathers = $util.emptyArray;
    
                    /**
                     * Creates a new BatchUpdateStoreWeatherResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} BatchUpdateStoreWeatherResponse instance
                     */
                    BatchUpdateStoreWeatherResponse.create = function create(properties) {
                        return new BatchUpdateStoreWeatherResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreWeatherResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreWeatherResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherResponse} message BatchUpdateStoreWeatherResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreWeatherResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeWeathers != null && message.storeWeathers.length)
                            for (var i = 0; i < message.storeWeathers.length; ++i)
                                $root.palexy.streaming.v1.StoreWeather.encode(message.storeWeathers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUpdateStoreWeatherResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUpdateStoreWeatherResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUpdateStoreWeatherResponse} message BatchUpdateStoreWeatherResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUpdateStoreWeatherResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreWeatherResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} BatchUpdateStoreWeatherResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreWeatherResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUpdateStoreWeatherResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeWeathers && message.storeWeathers.length))
                                    message.storeWeathers = [];
                                message.storeWeathers.push($root.palexy.streaming.v1.StoreWeather.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUpdateStoreWeatherResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} BatchUpdateStoreWeatherResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUpdateStoreWeatherResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUpdateStoreWeatherResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUpdateStoreWeatherResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeWeathers != null && message.hasOwnProperty("storeWeathers")) {
                            if (!Array.isArray(message.storeWeathers))
                                return "storeWeathers: array expected";
                            for (var i = 0; i < message.storeWeathers.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreWeather.verify(message.storeWeathers[i]);
                                if (error)
                                    return "storeWeathers." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchUpdateStoreWeatherResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} BatchUpdateStoreWeatherResponse
                     */
                    BatchUpdateStoreWeatherResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUpdateStoreWeatherResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUpdateStoreWeatherResponse();
                        if (object.storeWeathers) {
                            if (!Array.isArray(object.storeWeathers))
                                throw TypeError(".palexy.streaming.v1.BatchUpdateStoreWeatherResponse.storeWeathers: array expected");
                            message.storeWeathers = [];
                            for (var i = 0; i < object.storeWeathers.length; ++i) {
                                if (typeof object.storeWeathers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUpdateStoreWeatherResponse.storeWeathers: object expected");
                                message.storeWeathers[i] = $root.palexy.streaming.v1.StoreWeather.fromObject(object.storeWeathers[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUpdateStoreWeatherResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUpdateStoreWeatherResponse} message BatchUpdateStoreWeatherResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUpdateStoreWeatherResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeWeathers = [];
                        if (message.storeWeathers && message.storeWeathers.length) {
                            object.storeWeathers = [];
                            for (var j = 0; j < message.storeWeathers.length; ++j)
                                object.storeWeathers[j] = $root.palexy.streaming.v1.StoreWeather.toObject(message.storeWeathers[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchUpdateStoreWeatherResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUpdateStoreWeatherResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUpdateStoreWeatherResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUpdateStoreWeatherResponse;
                })();
    
                v1.ListStoreWeatherRequest = (function() {
    
                    /**
                     * Properties of a ListStoreWeatherRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreWeatherRequest
                     * @property {number|null} [storeId] ListStoreWeatherRequest storeId
                     * @property {number|null} [startDateId] ListStoreWeatherRequest startDateId
                     * @property {number|null} [endDateId] ListStoreWeatherRequest endDateId
                     * @property {Array.<palexy.streaming.v1.StoreWeather.Granularity>|null} [granularities] ListStoreWeatherRequest granularities
                     */
    
                    /**
                     * Constructs a new ListStoreWeatherRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreWeatherRequest.
                     * @implements IListStoreWeatherRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest=} [properties] Properties to set
                     */
                    function ListStoreWeatherRequest(properties) {
                        this.granularities = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreWeatherRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @instance
                     */
                    ListStoreWeatherRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreWeatherRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @instance
                     */
                    ListStoreWeatherRequest.prototype.startDateId = 0;
    
                    /**
                     * ListStoreWeatherRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @instance
                     */
                    ListStoreWeatherRequest.prototype.endDateId = 0;
    
                    /**
                     * ListStoreWeatherRequest granularities.
                     * @member {Array.<palexy.streaming.v1.StoreWeather.Granularity>} granularities
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @instance
                     */
                    ListStoreWeatherRequest.prototype.granularities = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreWeatherRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreWeatherRequest} ListStoreWeatherRequest instance
                     */
                    ListStoreWeatherRequest.create = function create(properties) {
                        return new ListStoreWeatherRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreWeatherRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreWeatherRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest} message ListStoreWeatherRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreWeatherRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.granularities != null && message.granularities.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.granularities.length; ++i)
                                writer.int32(message.granularities[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreWeatherRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreWeatherRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherRequest} message ListStoreWeatherRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreWeatherRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreWeatherRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreWeatherRequest} ListStoreWeatherRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreWeatherRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreWeatherRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                if (!(message.granularities && message.granularities.length))
                                    message.granularities = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.granularities.push(reader.int32());
                                } else
                                    message.granularities.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreWeatherRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreWeatherRequest} ListStoreWeatherRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreWeatherRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreWeatherRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreWeatherRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.granularities != null && message.hasOwnProperty("granularities")) {
                            if (!Array.isArray(message.granularities))
                                return "granularities: array expected";
                            for (var i = 0; i < message.granularities.length; ++i)
                                switch (message.granularities[i]) {
                                default:
                                    return "granularities: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreWeatherRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreWeatherRequest} ListStoreWeatherRequest
                     */
                    ListStoreWeatherRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreWeatherRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreWeatherRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.granularities) {
                            if (!Array.isArray(object.granularities))
                                throw TypeError(".palexy.streaming.v1.ListStoreWeatherRequest.granularities: array expected");
                            message.granularities = [];
                            for (var i = 0; i < object.granularities.length; ++i)
                                switch (object.granularities[i]) {
                                default:
                                case "UNKNOWN":
                                case 0:
                                    message.granularities[i] = 0;
                                    break;
                                case "DAILY":
                                case 1:
                                    message.granularities[i] = 1;
                                    break;
                                case "HOURLY":
                                case 2:
                                    message.granularities[i] = 2;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreWeatherRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreWeatherRequest} message ListStoreWeatherRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreWeatherRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.granularities = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.granularities && message.granularities.length) {
                            object.granularities = [];
                            for (var j = 0; j < message.granularities.length; ++j)
                                object.granularities[j] = options.enums === String ? $root.palexy.streaming.v1.StoreWeather.Granularity[message.granularities[j]] : message.granularities[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreWeatherRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreWeatherRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreWeatherRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreWeatherRequest;
                })();
    
                v1.ListStoreWeatherResponse = (function() {
    
                    /**
                     * Properties of a ListStoreWeatherResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreWeatherResponse
                     * @property {Array.<palexy.streaming.v1.IStoreWeather>|null} [storeWeathers] ListStoreWeatherResponse storeWeathers
                     */
    
                    /**
                     * Constructs a new ListStoreWeatherResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreWeatherResponse.
                     * @implements IListStoreWeatherResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreWeatherResponse=} [properties] Properties to set
                     */
                    function ListStoreWeatherResponse(properties) {
                        this.storeWeathers = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreWeatherResponse storeWeathers.
                     * @member {Array.<palexy.streaming.v1.IStoreWeather>} storeWeathers
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @instance
                     */
                    ListStoreWeatherResponse.prototype.storeWeathers = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreWeatherResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreWeatherResponse} ListStoreWeatherResponse instance
                     */
                    ListStoreWeatherResponse.create = function create(properties) {
                        return new ListStoreWeatherResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreWeatherResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreWeatherResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherResponse} message ListStoreWeatherResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreWeatherResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeWeathers != null && message.storeWeathers.length)
                            for (var i = 0; i < message.storeWeathers.length; ++i)
                                $root.palexy.streaming.v1.StoreWeather.encode(message.storeWeathers[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreWeatherResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreWeatherResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreWeatherResponse} message ListStoreWeatherResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreWeatherResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreWeatherResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreWeatherResponse} ListStoreWeatherResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreWeatherResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreWeatherResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeWeathers && message.storeWeathers.length))
                                    message.storeWeathers = [];
                                message.storeWeathers.push($root.palexy.streaming.v1.StoreWeather.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreWeatherResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreWeatherResponse} ListStoreWeatherResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreWeatherResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreWeatherResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreWeatherResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeWeathers != null && message.hasOwnProperty("storeWeathers")) {
                            if (!Array.isArray(message.storeWeathers))
                                return "storeWeathers: array expected";
                            for (var i = 0; i < message.storeWeathers.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreWeather.verify(message.storeWeathers[i]);
                                if (error)
                                    return "storeWeathers." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreWeatherResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreWeatherResponse} ListStoreWeatherResponse
                     */
                    ListStoreWeatherResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreWeatherResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreWeatherResponse();
                        if (object.storeWeathers) {
                            if (!Array.isArray(object.storeWeathers))
                                throw TypeError(".palexy.streaming.v1.ListStoreWeatherResponse.storeWeathers: array expected");
                            message.storeWeathers = [];
                            for (var i = 0; i < object.storeWeathers.length; ++i) {
                                if (typeof object.storeWeathers[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreWeatherResponse.storeWeathers: object expected");
                                message.storeWeathers[i] = $root.palexy.streaming.v1.StoreWeather.fromObject(object.storeWeathers[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreWeatherResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreWeatherResponse} message ListStoreWeatherResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreWeatherResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeWeathers = [];
                        if (message.storeWeathers && message.storeWeathers.length) {
                            object.storeWeathers = [];
                            for (var j = 0; j < message.storeWeathers.length; ++j)
                                object.storeWeathers[j] = $root.palexy.streaming.v1.StoreWeather.toObject(message.storeWeathers[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreWeatherResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreWeatherResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreWeatherResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreWeatherResponse;
                })();
    
                v1.ScheduledTaskEventService = (function() {
    
                    /**
                     * Constructs a new ScheduledTaskEventService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledTaskEventService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ScheduledTaskEventService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ScheduledTaskEventService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScheduledTaskEventService;
    
                    /**
                     * Creates new ScheduledTaskEventService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ScheduledTaskEventService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ScheduledTaskEventService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledTaskEventService#createScheduledTaskEvent}.
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @typedef CreateScheduledTaskEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ScheduledTaskEvent} [response] ScheduledTaskEvent
                     */
    
                    /**
                     * Calls CreateScheduledTaskEvent.
                     * @function createScheduledTaskEvent
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IScheduledTaskEvent} request ScheduledTaskEvent message or plain object
                     * @param {palexy.streaming.v1.ScheduledTaskEventService.CreateScheduledTaskEventCallback} callback Node-style callback called with the error, if any, and ScheduledTaskEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledTaskEventService.prototype.createScheduledTaskEvent = function createScheduledTaskEvent(request, callback) {
                        return this.rpcCall(createScheduledTaskEvent, $root.palexy.streaming.v1.ScheduledTaskEvent, $root.palexy.streaming.v1.ScheduledTaskEvent, request, callback);
                    }, "name", { value: "CreateScheduledTaskEvent" });
    
                    /**
                     * Calls CreateScheduledTaskEvent.
                     * @function createScheduledTaskEvent
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IScheduledTaskEvent} request ScheduledTaskEvent message or plain object
                     * @returns {Promise<palexy.streaming.v1.ScheduledTaskEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledTaskEventService#batchCreateScheduledTaskEvent}.
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @typedef BatchCreateScheduledTaskEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} [response] BatchCreateScheduledTaskEventResponse
                     */
    
                    /**
                     * Calls BatchCreateScheduledTaskEvent.
                     * @function batchCreateScheduledTaskEvent
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest} request BatchCreateScheduledTaskEventRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledTaskEventService.BatchCreateScheduledTaskEventCallback} callback Node-style callback called with the error, if any, and BatchCreateScheduledTaskEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledTaskEventService.prototype.batchCreateScheduledTaskEvent = function batchCreateScheduledTaskEvent(request, callback) {
                        return this.rpcCall(batchCreateScheduledTaskEvent, $root.palexy.streaming.v1.BatchCreateScheduledTaskEventRequest, $root.palexy.streaming.v1.BatchCreateScheduledTaskEventResponse, request, callback);
                    }, "name", { value: "BatchCreateScheduledTaskEvent" });
    
                    /**
                     * Calls BatchCreateScheduledTaskEvent.
                     * @function batchCreateScheduledTaskEvent
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest} request BatchCreateScheduledTaskEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchCreateScheduledTaskEventResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduledTaskEventService#listScheduledTaskEvents}.
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @typedef ListScheduledTaskEventsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListScheduledTaskEventResponse} [response] ListScheduledTaskEventResponse
                     */
    
                    /**
                     * Calls ListScheduledTaskEvents.
                     * @function listScheduledTaskEvents
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest} request ListScheduledTaskEventRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduledTaskEventService.ListScheduledTaskEventsCallback} callback Node-style callback called with the error, if any, and ListScheduledTaskEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduledTaskEventService.prototype.listScheduledTaskEvents = function listScheduledTaskEvents(request, callback) {
                        return this.rpcCall(listScheduledTaskEvents, $root.palexy.streaming.v1.ListScheduledTaskEventRequest, $root.palexy.streaming.v1.ListScheduledTaskEventResponse, request, callback);
                    }, "name", { value: "ListScheduledTaskEvents" });
    
                    /**
                     * Calls ListScheduledTaskEvents.
                     * @function listScheduledTaskEvents
                     * @memberof palexy.streaming.v1.ScheduledTaskEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest} request ListScheduledTaskEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListScheduledTaskEventResponse>} Promise
                     * @variation 2
                     */
    
                    return ScheduledTaskEventService;
                })();
    
                v1.ScheduledTaskEvent = (function() {
    
                    /**
                     * Properties of a ScheduledTaskEvent.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduledTaskEvent
                     * @property {number|null} [id] ScheduledTaskEvent id
                     * @property {palexy.streaming.v1.ScheduledTaskType|null} [scheduledTaskType] ScheduledTaskEvent scheduledTaskType
                     * @property {string|null} [eventDate] ScheduledTaskEvent eventDate
                     * @property {number|null} [companyId] ScheduledTaskEvent companyId
                     * @property {google.protobuf.IInt64Value|null} [storeId] ScheduledTaskEvent storeId
                     * @property {google.protobuf.IStringValue|null} [countryCode] ScheduledTaskEvent countryCode
                     * @property {number|null} [createTimeMs] ScheduledTaskEvent createTimeMs
                     */
    
                    /**
                     * Constructs a new ScheduledTaskEvent.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduledTaskEvent.
                     * @implements IScheduledTaskEvent
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduledTaskEvent=} [properties] Properties to set
                     */
                    function ScheduledTaskEvent(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduledTaskEvent id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduledTaskEvent scheduledTaskType.
                     * @member {palexy.streaming.v1.ScheduledTaskType} scheduledTaskType
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.scheduledTaskType = 0;
    
                    /**
                     * ScheduledTaskEvent eventDate.
                     * @member {string} eventDate
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.eventDate = "";
    
                    /**
                     * ScheduledTaskEvent companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduledTaskEvent storeId.
                     * @member {google.protobuf.IInt64Value|null|undefined} storeId
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.storeId = null;
    
                    /**
                     * ScheduledTaskEvent countryCode.
                     * @member {google.protobuf.IStringValue|null|undefined} countryCode
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.countryCode = null;
    
                    /**
                     * ScheduledTaskEvent createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     */
                    ScheduledTaskEvent.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ScheduledTaskEvent instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {palexy.streaming.v1.IScheduledTaskEvent=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduledTaskEvent} ScheduledTaskEvent instance
                     */
                    ScheduledTaskEvent.create = function create(properties) {
                        return new ScheduledTaskEvent(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduledTaskEvent message. Does not implicitly {@link palexy.streaming.v1.ScheduledTaskEvent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {palexy.streaming.v1.IScheduledTaskEvent} message ScheduledTaskEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledTaskEvent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.scheduledTaskType != null && Object.hasOwnProperty.call(message, "scheduledTaskType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.scheduledTaskType);
                        if (message.eventDate != null && Object.hasOwnProperty.call(message, "eventDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.eventDate);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            $root.google.protobuf.Int64Value.encode(message.storeId, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.countryCode != null && Object.hasOwnProperty.call(message, "countryCode"))
                            $root.google.protobuf.StringValue.encode(message.countryCode, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduledTaskEvent message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduledTaskEvent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {palexy.streaming.v1.IScheduledTaskEvent} message ScheduledTaskEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduledTaskEvent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduledTaskEvent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduledTaskEvent} ScheduledTaskEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledTaskEvent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduledTaskEvent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.scheduledTaskType = reader.int32();
                                break;
                            case 3:
                                message.eventDate = reader.string();
                                break;
                            case 4:
                                message.companyId = reader.int64();
                                break;
                            case 5:
                                message.storeId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.countryCode = $root.google.protobuf.StringValue.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduledTaskEvent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduledTaskEvent} ScheduledTaskEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduledTaskEvent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduledTaskEvent message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduledTaskEvent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.scheduledTaskType != null && message.hasOwnProperty("scheduledTaskType"))
                            switch (message.scheduledTaskType) {
                            default:
                                return "scheduledTaskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                                break;
                            }
                        if (message.eventDate != null && message.hasOwnProperty("eventDate"))
                            if (!$util.isString(message.eventDate))
                                return "eventDate: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.storeId);
                            if (error)
                                return "storeId." + error;
                        }
                        if (message.countryCode != null && message.hasOwnProperty("countryCode")) {
                            var error = $root.google.protobuf.StringValue.verify(message.countryCode);
                            if (error)
                                return "countryCode." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ScheduledTaskEvent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduledTaskEvent} ScheduledTaskEvent
                     */
                    ScheduledTaskEvent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduledTaskEvent)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduledTaskEvent();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        switch (object.scheduledTaskType) {
                        case "SCHEDULED_TASK_TYPE_UNKNOWN":
                        case 0:
                            message.scheduledTaskType = 0;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS":
                        case 1:
                            message.scheduledTaskType = 1;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS":
                        case 2:
                            message.scheduledTaskType = 2;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS":
                        case 3:
                            message.scheduledTaskType = 3;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS":
                        case 4:
                            message.scheduledTaskType = 4;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS":
                        case 5:
                            message.scheduledTaskType = 5;
                            break;
                        case "SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS":
                        case 6:
                            message.scheduledTaskType = 6;
                            break;
                        case "SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS":
                        case 7:
                            message.scheduledTaskType = 7;
                            break;
                        case "SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER":
                        case 8:
                            message.scheduledTaskType = 8;
                            break;
                        case "SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY":
                        case 9:
                            message.scheduledTaskType = 9;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS":
                        case 10:
                            message.scheduledTaskType = 10;
                            break;
                        case "SCHEDULED_AVAILABILITY_AUTO_LOCK":
                        case 11:
                            message.scheduledTaskType = 11;
                            break;
                        case "SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS":
                        case 12:
                            message.scheduledTaskType = 12;
                            break;
                        case "SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS":
                        case 13:
                            message.scheduledTaskType = 13;
                            break;
                        case "SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER":
                        case 14:
                            message.scheduledTaskType = 14;
                            break;
                        case "SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER":
                        case 15:
                            message.scheduledTaskType = 15;
                            break;
                        }
                        if (object.eventDate != null)
                            message.eventDate = String(object.eventDate);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null) {
                            if (typeof object.storeId !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledTaskEvent.storeId: object expected");
                            message.storeId = $root.google.protobuf.Int64Value.fromObject(object.storeId);
                        }
                        if (object.countryCode != null) {
                            if (typeof object.countryCode !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduledTaskEvent.countryCode: object expected");
                            message.countryCode = $root.google.protobuf.StringValue.fromObject(object.countryCode);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduledTaskEvent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @static
                     * @param {palexy.streaming.v1.ScheduledTaskEvent} message ScheduledTaskEvent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduledTaskEvent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.scheduledTaskType = options.enums === String ? "SCHEDULED_TASK_TYPE_UNKNOWN" : 0;
                            object.eventDate = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.storeId = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            object.countryCode = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.scheduledTaskType != null && message.hasOwnProperty("scheduledTaskType"))
                            object.scheduledTaskType = options.enums === String ? $root.palexy.streaming.v1.ScheduledTaskType[message.scheduledTaskType] : message.scheduledTaskType;
                        if (message.eventDate != null && message.hasOwnProperty("eventDate"))
                            object.eventDate = message.eventDate;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = $root.google.protobuf.Int64Value.toObject(message.storeId, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.countryCode != null && message.hasOwnProperty("countryCode"))
                            object.countryCode = $root.google.protobuf.StringValue.toObject(message.countryCode, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScheduledTaskEvent to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduledTaskEvent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduledTaskEvent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduledTaskEvent;
                })();
    
                v1.ListScheduledTaskEventRequest = (function() {
    
                    /**
                     * Properties of a ListScheduledTaskEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduledTaskEventRequest
                     * @property {palexy.streaming.v1.ScheduledTaskType|null} [scheduledTaskType] ListScheduledTaskEventRequest scheduledTaskType
                     * @property {string|null} [eventStartDateId] ListScheduledTaskEventRequest eventStartDateId
                     * @property {string|null} [eventEndDateId] ListScheduledTaskEventRequest eventEndDateId
                     * @property {number|null} [pageSize] ListScheduledTaskEventRequest pageSize
                     * @property {string|null} [pageToken] ListScheduledTaskEventRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListScheduledTaskEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduledTaskEventRequest.
                     * @implements IListScheduledTaskEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest=} [properties] Properties to set
                     */
                    function ListScheduledTaskEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduledTaskEventRequest scheduledTaskType.
                     * @member {palexy.streaming.v1.ScheduledTaskType} scheduledTaskType
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     */
                    ListScheduledTaskEventRequest.prototype.scheduledTaskType = 0;
    
                    /**
                     * ListScheduledTaskEventRequest eventStartDateId.
                     * @member {string} eventStartDateId
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     */
                    ListScheduledTaskEventRequest.prototype.eventStartDateId = "";
    
                    /**
                     * ListScheduledTaskEventRequest eventEndDateId.
                     * @member {string} eventEndDateId
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     */
                    ListScheduledTaskEventRequest.prototype.eventEndDateId = "";
    
                    /**
                     * ListScheduledTaskEventRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     */
                    ListScheduledTaskEventRequest.prototype.pageSize = 0;
    
                    /**
                     * ListScheduledTaskEventRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     */
                    ListScheduledTaskEventRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListScheduledTaskEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventRequest} ListScheduledTaskEventRequest instance
                     */
                    ListScheduledTaskEventRequest.create = function create(properties) {
                        return new ListScheduledTaskEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduledTaskEventRequest message. Does not implicitly {@link palexy.streaming.v1.ListScheduledTaskEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest} message ListScheduledTaskEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduledTaskEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduledTaskType != null && Object.hasOwnProperty.call(message, "scheduledTaskType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.scheduledTaskType);
                        if (message.eventStartDateId != null && Object.hasOwnProperty.call(message, "eventStartDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.eventStartDateId);
                        if (message.eventEndDateId != null && Object.hasOwnProperty.call(message, "eventEndDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.eventEndDateId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduledTaskEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduledTaskEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventRequest} message ListScheduledTaskEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduledTaskEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduledTaskEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventRequest} ListScheduledTaskEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduledTaskEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduledTaskEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduledTaskType = reader.int32();
                                break;
                            case 2:
                                message.eventStartDateId = reader.string();
                                break;
                            case 3:
                                message.eventEndDateId = reader.string();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduledTaskEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventRequest} ListScheduledTaskEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduledTaskEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduledTaskEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduledTaskEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduledTaskType != null && message.hasOwnProperty("scheduledTaskType"))
                            switch (message.scheduledTaskType) {
                            default:
                                return "scheduledTaskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                                break;
                            }
                        if (message.eventStartDateId != null && message.hasOwnProperty("eventStartDateId"))
                            if (!$util.isString(message.eventStartDateId))
                                return "eventStartDateId: string expected";
                        if (message.eventEndDateId != null && message.hasOwnProperty("eventEndDateId"))
                            if (!$util.isString(message.eventEndDateId))
                                return "eventEndDateId: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduledTaskEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventRequest} ListScheduledTaskEventRequest
                     */
                    ListScheduledTaskEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduledTaskEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduledTaskEventRequest();
                        switch (object.scheduledTaskType) {
                        case "SCHEDULED_TASK_TYPE_UNKNOWN":
                        case 0:
                            message.scheduledTaskType = 0;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS":
                        case 1:
                            message.scheduledTaskType = 1;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS":
                        case 2:
                            message.scheduledTaskType = 2;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS":
                        case 3:
                            message.scheduledTaskType = 3;
                            break;
                        case "SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS":
                        case 4:
                            message.scheduledTaskType = 4;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS":
                        case 5:
                            message.scheduledTaskType = 5;
                            break;
                        case "SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS":
                        case 6:
                            message.scheduledTaskType = 6;
                            break;
                        case "SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS":
                        case 7:
                            message.scheduledTaskType = 7;
                            break;
                        case "SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER":
                        case 8:
                            message.scheduledTaskType = 8;
                            break;
                        case "SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY":
                        case 9:
                            message.scheduledTaskType = 9;
                            break;
                        case "SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS":
                        case 10:
                            message.scheduledTaskType = 10;
                            break;
                        case "SCHEDULED_AVAILABILITY_AUTO_LOCK":
                        case 11:
                            message.scheduledTaskType = 11;
                            break;
                        case "SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS":
                        case 12:
                            message.scheduledTaskType = 12;
                            break;
                        case "SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS":
                        case 13:
                            message.scheduledTaskType = 13;
                            break;
                        case "SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER":
                        case 14:
                            message.scheduledTaskType = 14;
                            break;
                        case "SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER":
                        case 15:
                            message.scheduledTaskType = 15;
                            break;
                        }
                        if (object.eventStartDateId != null)
                            message.eventStartDateId = String(object.eventStartDateId);
                        if (object.eventEndDateId != null)
                            message.eventEndDateId = String(object.eventEndDateId);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduledTaskEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ListScheduledTaskEventRequest} message ListScheduledTaskEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduledTaskEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.scheduledTaskType = options.enums === String ? "SCHEDULED_TASK_TYPE_UNKNOWN" : 0;
                            object.eventStartDateId = "";
                            object.eventEndDateId = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.scheduledTaskType != null && message.hasOwnProperty("scheduledTaskType"))
                            object.scheduledTaskType = options.enums === String ? $root.palexy.streaming.v1.ScheduledTaskType[message.scheduledTaskType] : message.scheduledTaskType;
                        if (message.eventStartDateId != null && message.hasOwnProperty("eventStartDateId"))
                            object.eventStartDateId = message.eventStartDateId;
                        if (message.eventEndDateId != null && message.hasOwnProperty("eventEndDateId"))
                            object.eventEndDateId = message.eventEndDateId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduledTaskEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduledTaskEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduledTaskEventRequest;
                })();
    
                v1.ListScheduledTaskEventResponse = (function() {
    
                    /**
                     * Properties of a ListScheduledTaskEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduledTaskEventResponse
                     * @property {Array.<palexy.streaming.v1.IScheduledTaskEvent>|null} [events] ListScheduledTaskEventResponse events
                     * @property {number|null} [totalElements] ListScheduledTaskEventResponse totalElements
                     * @property {string|null} [nextPageToken] ListScheduledTaskEventResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListScheduledTaskEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduledTaskEventResponse.
                     * @implements IListScheduledTaskEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduledTaskEventResponse=} [properties] Properties to set
                     */
                    function ListScheduledTaskEventResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduledTaskEventResponse events.
                     * @member {Array.<palexy.streaming.v1.IScheduledTaskEvent>} events
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @instance
                     */
                    ListScheduledTaskEventResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * ListScheduledTaskEventResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @instance
                     */
                    ListScheduledTaskEventResponse.prototype.totalElements = 0;
    
                    /**
                     * ListScheduledTaskEventResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @instance
                     */
                    ListScheduledTaskEventResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListScheduledTaskEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventResponse} ListScheduledTaskEventResponse instance
                     */
                    ListScheduledTaskEventResponse.create = function create(properties) {
                        return new ListScheduledTaskEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduledTaskEventResponse message. Does not implicitly {@link palexy.streaming.v1.ListScheduledTaskEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventResponse} message ListScheduledTaskEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduledTaskEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.ScheduledTaskEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduledTaskEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduledTaskEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduledTaskEventResponse} message ListScheduledTaskEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduledTaskEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduledTaskEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventResponse} ListScheduledTaskEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduledTaskEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduledTaskEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.ScheduledTaskEvent.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduledTaskEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventResponse} ListScheduledTaskEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduledTaskEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduledTaskEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduledTaskEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduledTaskEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduledTaskEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduledTaskEventResponse} ListScheduledTaskEventResponse
                     */
                    ListScheduledTaskEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduledTaskEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduledTaskEventResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.ListScheduledTaskEventResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListScheduledTaskEventResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.ScheduledTaskEvent.fromObject(object.events[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduledTaskEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.ListScheduledTaskEventResponse} message ListScheduledTaskEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduledTaskEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.ScheduledTaskEvent.toObject(message.events[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduledTaskEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduledTaskEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduledTaskEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduledTaskEventResponse;
                })();
    
                /**
                 * ScheduledTaskType enum.
                 * @name palexy.streaming.v1.ScheduledTaskType
                 * @enum {number}
                 * @property {number} SCHEDULED_TASK_TYPE_UNKNOWN=0 SCHEDULED_TASK_TYPE_UNKNOWN value
                 * @property {number} SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS=1 SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS value
                 * @property {number} SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS=2 SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS value
                 * @property {number} SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS=3 SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS value
                 * @property {number} SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS=4 SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS value
                 * @property {number} SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS=5 SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS value
                 * @property {number} SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS=6 SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS value
                 * @property {number} SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS=7 SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS value
                 * @property {number} SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER=8 SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER value
                 * @property {number} SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY=9 SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY value
                 * @property {number} SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS=10 SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS value
                 * @property {number} SCHEDULED_AVAILABILITY_AUTO_LOCK=11 SCHEDULED_AVAILABILITY_AUTO_LOCK value
                 * @property {number} SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS=12 SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS value
                 * @property {number} SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS=13 SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS value
                 * @property {number} SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER=14 SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER value
                 * @property {number} SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER=15 SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER value
                 */
                v1.ScheduledTaskType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SCHEDULED_TASK_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "SCHEDULED_CREATE_WEEKLY_INSIGHTS_TASKS"] = 1;
                    values[valuesById[2] = "SCHEDULED_CREATE_MONTHLY_INSIGHTS_TASKS"] = 2;
                    values[valuesById[3] = "SCHEDULED_CREATE_MONTHLY_TREND_REPORT_TASKS"] = 3;
                    values[valuesById[4] = "SCHEDULED_CREATE_WEEKLY_ADJUST_BUDGET_TASKS"] = 4;
                    values[valuesById[5] = "SCHEDULED_CREATE_MONTHLY_MALL_TREND_REPORT_TASKS"] = 5;
                    values[valuesById[6] = "SCHEDULED_CREATE_DAILY_INSIGHTS_TASKS"] = 6;
                    values[valuesById[7] = "SCHEDULED_AUTO_FILL_ATTENDANCE_RECORDS"] = 7;
                    values[valuesById[8] = "SCHEDULED_TRIGGER_DAILY_REVIEW_REMINDER"] = 8;
                    values[valuesById[9] = "SCHEDULED_AUTO_GENERATE_SCHEDULE_FROM_EMPLOYEE_POLICY"] = 9;
                    values[valuesById[10] = "SCHEDULED_CREATE_MONTHLY_LOCATION_TREND_REPORT_TASKS"] = 10;
                    values[valuesById[11] = "SCHEDULED_AVAILABILITY_AUTO_LOCK"] = 11;
                    values[valuesById[12] = "SCHEDULED_CREATE_QUARTERLY_TREND_REPORT_TASKS"] = 12;
                    values[valuesById[13] = "SCHEDULED_CREATE_HALFYEAR_TREND_REPORT_TASKS"] = 13;
                    values[valuesById[14] = "SCHEDULED_TRIGGER_UNPUBLISHED_SHIFT_REMINDER"] = 14;
                    values[valuesById[15] = "SCHEDULED_TRIGGER_PENDING_APPROVAL_SCHEDULE_REMINDER"] = 15;
                    return values;
                })();
    
                v1.BatchCreateScheduledTaskEventRequest = (function() {
    
                    /**
                     * Properties of a BatchCreateScheduledTaskEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateScheduledTaskEventRequest
                     * @property {Array.<palexy.streaming.v1.IScheduledTaskEvent>|null} [events] BatchCreateScheduledTaskEventRequest events
                     */
    
                    /**
                     * Constructs a new BatchCreateScheduledTaskEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateScheduledTaskEventRequest.
                     * @implements IBatchCreateScheduledTaskEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest=} [properties] Properties to set
                     */
                    function BatchCreateScheduledTaskEventRequest(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateScheduledTaskEventRequest events.
                     * @member {Array.<palexy.streaming.v1.IScheduledTaskEvent>} events
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @instance
                     */
                    BatchCreateScheduledTaskEventRequest.prototype.events = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateScheduledTaskEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventRequest} BatchCreateScheduledTaskEventRequest instance
                     */
                    BatchCreateScheduledTaskEventRequest.create = function create(properties) {
                        return new BatchCreateScheduledTaskEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateScheduledTaskEventRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCreateScheduledTaskEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest} message BatchCreateScheduledTaskEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateScheduledTaskEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.ScheduledTaskEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateScheduledTaskEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateScheduledTaskEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventRequest} message BatchCreateScheduledTaskEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateScheduledTaskEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateScheduledTaskEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventRequest} BatchCreateScheduledTaskEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateScheduledTaskEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateScheduledTaskEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.ScheduledTaskEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateScheduledTaskEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventRequest} BatchCreateScheduledTaskEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateScheduledTaskEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateScheduledTaskEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateScheduledTaskEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduledTaskEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateScheduledTaskEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventRequest} BatchCreateScheduledTaskEventRequest
                     */
                    BatchCreateScheduledTaskEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateScheduledTaskEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateScheduledTaskEventRequest();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.BatchCreateScheduledTaskEventRequest.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateScheduledTaskEventRequest.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.ScheduledTaskEvent.fromObject(object.events[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateScheduledTaskEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateScheduledTaskEventRequest} message BatchCreateScheduledTaskEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateScheduledTaskEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.ScheduledTaskEvent.toObject(message.events[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateScheduledTaskEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateScheduledTaskEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateScheduledTaskEventRequest;
                })();
    
                v1.BatchCreateScheduledTaskEventResponse = (function() {
    
                    /**
                     * Properties of a BatchCreateScheduledTaskEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCreateScheduledTaskEventResponse
                     * @property {Array.<palexy.streaming.v1.IScheduledTaskEvent>|null} [events] BatchCreateScheduledTaskEventResponse events
                     */
    
                    /**
                     * Constructs a new BatchCreateScheduledTaskEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCreateScheduledTaskEventResponse.
                     * @implements IBatchCreateScheduledTaskEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventResponse=} [properties] Properties to set
                     */
                    function BatchCreateScheduledTaskEventResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCreateScheduledTaskEventResponse events.
                     * @member {Array.<palexy.streaming.v1.IScheduledTaskEvent>} events
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @instance
                     */
                    BatchCreateScheduledTaskEventResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCreateScheduledTaskEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} BatchCreateScheduledTaskEventResponse instance
                     */
                    BatchCreateScheduledTaskEventResponse.create = function create(properties) {
                        return new BatchCreateScheduledTaskEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCreateScheduledTaskEventResponse message. Does not implicitly {@link palexy.streaming.v1.BatchCreateScheduledTaskEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventResponse} message BatchCreateScheduledTaskEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateScheduledTaskEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.ScheduledTaskEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCreateScheduledTaskEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCreateScheduledTaskEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchCreateScheduledTaskEventResponse} message BatchCreateScheduledTaskEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCreateScheduledTaskEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCreateScheduledTaskEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} BatchCreateScheduledTaskEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateScheduledTaskEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCreateScheduledTaskEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.ScheduledTaskEvent.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCreateScheduledTaskEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} BatchCreateScheduledTaskEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCreateScheduledTaskEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCreateScheduledTaskEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCreateScheduledTaskEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduledTaskEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCreateScheduledTaskEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} BatchCreateScheduledTaskEventResponse
                     */
                    BatchCreateScheduledTaskEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCreateScheduledTaskEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCreateScheduledTaskEventResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.BatchCreateScheduledTaskEventResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchCreateScheduledTaskEventResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.ScheduledTaskEvent.fromObject(object.events[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCreateScheduledTaskEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchCreateScheduledTaskEventResponse} message BatchCreateScheduledTaskEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCreateScheduledTaskEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.ScheduledTaskEvent.toObject(message.events[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCreateScheduledTaskEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCreateScheduledTaskEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCreateScheduledTaskEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCreateScheduledTaskEventResponse;
                })();
    
                v1.InsightUnderlyingDataChangedEventService = (function() {
    
                    /**
                     * Constructs a new InsightUnderlyingDataChangedEventService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an InsightUnderlyingDataChangedEventService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function InsightUnderlyingDataChangedEventService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (InsightUnderlyingDataChangedEventService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = InsightUnderlyingDataChangedEventService;
    
                    /**
                     * Creates new InsightUnderlyingDataChangedEventService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {InsightUnderlyingDataChangedEventService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    InsightUnderlyingDataChangedEventService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.InsightUnderlyingDataChangedEventService#listInsightUnderlyingDataChangedEvent}.
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @typedef ListInsightUnderlyingDataChangedEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} [response] ListInsightUnderlyingDataChangedEventResponse
                     */
    
                    /**
                     * Calls ListInsightUnderlyingDataChangedEvent.
                     * @function listInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest} request ListInsightUnderlyingDataChangedEventRequest message or plain object
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEventService.ListInsightUnderlyingDataChangedEventCallback} callback Node-style callback called with the error, if any, and ListInsightUnderlyingDataChangedEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(InsightUnderlyingDataChangedEventService.prototype.listInsightUnderlyingDataChangedEvent = function listInsightUnderlyingDataChangedEvent(request, callback) {
                        return this.rpcCall(listInsightUnderlyingDataChangedEvent, $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest, $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse, request, callback);
                    }, "name", { value: "ListInsightUnderlyingDataChangedEvent" });
    
                    /**
                     * Calls ListInsightUnderlyingDataChangedEvent.
                     * @function listInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest} request ListInsightUnderlyingDataChangedEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.InsightUnderlyingDataChangedEventService#createInsightUnderlyingDataChangedEvent}.
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @typedef CreateInsightUnderlyingDataChangedEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} [response] InsightUnderlyingDataChangedEvent
                     */
    
                    /**
                     * Calls CreateInsightUnderlyingDataChangedEvent.
                     * @function createInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest} request CreateInsightUnderlyingDataChangedEventRequest message or plain object
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEventService.CreateInsightUnderlyingDataChangedEventCallback} callback Node-style callback called with the error, if any, and InsightUnderlyingDataChangedEvent
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(InsightUnderlyingDataChangedEventService.prototype.createInsightUnderlyingDataChangedEvent = function createInsightUnderlyingDataChangedEvent(request, callback) {
                        return this.rpcCall(createInsightUnderlyingDataChangedEvent, $root.palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest, $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent, request, callback);
                    }, "name", { value: "CreateInsightUnderlyingDataChangedEvent" });
    
                    /**
                     * Calls CreateInsightUnderlyingDataChangedEvent.
                     * @function createInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest} request CreateInsightUnderlyingDataChangedEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.InsightUnderlyingDataChangedEvent>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.InsightUnderlyingDataChangedEventService#batchCompleteInsightUnderlyingDataChangedEvent}.
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @typedef BatchCompleteInsightUnderlyingDataChangedEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls BatchCompleteInsightUnderlyingDataChangedEvent.
                     * @function batchCompleteInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest} request BatchCompleteInsightUnderlyingDataChangedEventRequest message or plain object
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEventService.BatchCompleteInsightUnderlyingDataChangedEventCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(InsightUnderlyingDataChangedEventService.prototype.batchCompleteInsightUnderlyingDataChangedEvent = function batchCompleteInsightUnderlyingDataChangedEvent(request, callback) {
                        return this.rpcCall(batchCompleteInsightUnderlyingDataChangedEvent, $root.palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "BatchCompleteInsightUnderlyingDataChangedEvent" });
    
                    /**
                     * Calls BatchCompleteInsightUnderlyingDataChangedEvent.
                     * @function batchCompleteInsightUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest} request BatchCompleteInsightUnderlyingDataChangedEventRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.InsightUnderlyingDataChangedEventService#processUnderlyingDataChangedEvent}.
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @typedef ProcessUnderlyingDataChangedEventCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} [response] ProcessUnderlyingDataChangedEventResponse
                     */
    
                    /**
                     * Calls ProcessUnderlyingDataChangedEvent.
                     * @function processUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest} request ProcessUnderlyingDataChangedEventRequest message or plain object
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEventService.ProcessUnderlyingDataChangedEventCallback} callback Node-style callback called with the error, if any, and ProcessUnderlyingDataChangedEventResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(InsightUnderlyingDataChangedEventService.prototype.processUnderlyingDataChangedEvent = function processUnderlyingDataChangedEvent(request, callback) {
                        return this.rpcCall(processUnderlyingDataChangedEvent, $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest, $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse, request, callback);
                    }, "name", { value: "ProcessUnderlyingDataChangedEvent" });
    
                    /**
                     * Calls ProcessUnderlyingDataChangedEvent.
                     * @function processUnderlyingDataChangedEvent
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEventService
                     * @instance
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest} request ProcessUnderlyingDataChangedEventRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse>} Promise
                     * @variation 2
                     */
    
                    return InsightUnderlyingDataChangedEventService;
                })();
    
                v1.InsightUnderlyingDataChangedEvent = (function() {
    
                    /**
                     * Properties of an InsightUnderlyingDataChangedEvent.
                     * @memberof palexy.streaming.v1
                     * @interface IInsightUnderlyingDataChangedEvent
                     * @property {number|null} [id] InsightUnderlyingDataChangedEvent id
                     * @property {number|null} [companyId] InsightUnderlyingDataChangedEvent companyId
                     * @property {Array.<number>|null} [storeIds] InsightUnderlyingDataChangedEvent storeIds
                     * @property {number|null} [startDateId] InsightUnderlyingDataChangedEvent startDateId
                     * @property {number|null} [endDateId] InsightUnderlyingDataChangedEvent endDateId
                     * @property {palexy.streaming.v1.DataSource|null} [dataSource] InsightUnderlyingDataChangedEvent dataSource
                     * @property {Array.<number>|null} [asyncJobDependencyIds] InsightUnderlyingDataChangedEvent asyncJobDependencyIds
                     * @property {boolean|null} [processed] InsightUnderlyingDataChangedEvent processed
                     * @property {number|null} [createTimeMs] InsightUnderlyingDataChangedEvent createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] InsightUnderlyingDataChangedEvent lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new InsightUnderlyingDataChangedEvent.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an InsightUnderlyingDataChangedEvent.
                     * @implements IInsightUnderlyingDataChangedEvent
                     * @constructor
                     * @param {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent=} [properties] Properties to set
                     */
                    function InsightUnderlyingDataChangedEvent(properties) {
                        this.storeIds = [];
                        this.asyncJobDependencyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * InsightUnderlyingDataChangedEvent id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * InsightUnderlyingDataChangedEvent startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.startDateId = 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.endDateId = 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent dataSource.
                     * @member {palexy.streaming.v1.DataSource} dataSource
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.dataSource = 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent asyncJobDependencyIds.
                     * @member {Array.<number>} asyncJobDependencyIds
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.asyncJobDependencyIds = $util.emptyArray;
    
                    /**
                     * InsightUnderlyingDataChangedEvent processed.
                     * @member {boolean} processed
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.processed = false;
    
                    /**
                     * InsightUnderlyingDataChangedEvent createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * InsightUnderlyingDataChangedEvent lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     */
                    InsightUnderlyingDataChangedEvent.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new InsightUnderlyingDataChangedEvent instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} InsightUnderlyingDataChangedEvent instance
                     */
                    InsightUnderlyingDataChangedEvent.create = function create(properties) {
                        return new InsightUnderlyingDataChangedEvent(properties);
                    };
    
                    /**
                     * Encodes the specified InsightUnderlyingDataChangedEvent message. Does not implicitly {@link palexy.streaming.v1.InsightUnderlyingDataChangedEvent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent} message InsightUnderlyingDataChangedEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InsightUnderlyingDataChangedEvent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.endDateId);
                        if (message.dataSource != null && Object.hasOwnProperty.call(message, "dataSource"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.dataSource);
                        if (message.asyncJobDependencyIds != null && message.asyncJobDependencyIds.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.asyncJobDependencyIds.length; ++i)
                                writer.int64(message.asyncJobDependencyIds[i]);
                            writer.ldelim();
                        }
                        if (message.processed != null && Object.hasOwnProperty.call(message, "processed"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.processed);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified InsightUnderlyingDataChangedEvent message, length delimited. Does not implicitly {@link palexy.streaming.v1.InsightUnderlyingDataChangedEvent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent} message InsightUnderlyingDataChangedEvent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    InsightUnderlyingDataChangedEvent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an InsightUnderlyingDataChangedEvent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} InsightUnderlyingDataChangedEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InsightUnderlyingDataChangedEvent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 4:
                                message.startDateId = reader.int32();
                                break;
                            case 5:
                                message.endDateId = reader.int32();
                                break;
                            case 6:
                                message.dataSource = reader.int32();
                                break;
                            case 7:
                                if (!(message.asyncJobDependencyIds && message.asyncJobDependencyIds.length))
                                    message.asyncJobDependencyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.asyncJobDependencyIds.push(reader.int64());
                                } else
                                    message.asyncJobDependencyIds.push(reader.int64());
                                break;
                            case 8:
                                message.processed = reader.bool();
                                break;
                            case 9:
                                message.createTimeMs = reader.int64();
                                break;
                            case 10:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an InsightUnderlyingDataChangedEvent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} InsightUnderlyingDataChangedEvent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    InsightUnderlyingDataChangedEvent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an InsightUnderlyingDataChangedEvent message.
                     * @function verify
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    InsightUnderlyingDataChangedEvent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.dataSource != null && message.hasOwnProperty("dataSource"))
                            switch (message.dataSource) {
                            default:
                                return "dataSource: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.asyncJobDependencyIds != null && message.hasOwnProperty("asyncJobDependencyIds")) {
                            if (!Array.isArray(message.asyncJobDependencyIds))
                                return "asyncJobDependencyIds: array expected";
                            for (var i = 0; i < message.asyncJobDependencyIds.length; ++i)
                                if (!$util.isInteger(message.asyncJobDependencyIds[i]) && !(message.asyncJobDependencyIds[i] && $util.isInteger(message.asyncJobDependencyIds[i].low) && $util.isInteger(message.asyncJobDependencyIds[i].high)))
                                    return "asyncJobDependencyIds: integer|Long[] expected";
                        }
                        if (message.processed != null && message.hasOwnProperty("processed"))
                            if (typeof message.processed !== "boolean")
                                return "processed: boolean expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an InsightUnderlyingDataChangedEvent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} InsightUnderlyingDataChangedEvent
                     */
                    InsightUnderlyingDataChangedEvent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent)
                            return object;
                        var message = new $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.InsightUnderlyingDataChangedEvent.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        switch (object.dataSource) {
                        case "DS_UNKNOWN":
                        case 0:
                            message.dataSource = 0;
                            break;
                        case "VIDEO":
                        case 1:
                            message.dataSource = 1;
                            break;
                        case "POS":
                        case 2:
                            message.dataSource = 2;
                            break;
                        case "STAFFING":
                        case 3:
                            message.dataSource = 3;
                            break;
                        case "FORECAST":
                        case 4:
                            message.dataSource = 4;
                            break;
                        case "TARGET":
                        case 5:
                            message.dataSource = 5;
                            break;
                        }
                        if (object.asyncJobDependencyIds) {
                            if (!Array.isArray(object.asyncJobDependencyIds))
                                throw TypeError(".palexy.streaming.v1.InsightUnderlyingDataChangedEvent.asyncJobDependencyIds: array expected");
                            message.asyncJobDependencyIds = [];
                            for (var i = 0; i < object.asyncJobDependencyIds.length; ++i)
                                if ($util.Long)
                                    (message.asyncJobDependencyIds[i] = $util.Long.fromValue(object.asyncJobDependencyIds[i])).unsigned = false;
                                else if (typeof object.asyncJobDependencyIds[i] === "string")
                                    message.asyncJobDependencyIds[i] = parseInt(object.asyncJobDependencyIds[i], 10);
                                else if (typeof object.asyncJobDependencyIds[i] === "number")
                                    message.asyncJobDependencyIds[i] = object.asyncJobDependencyIds[i];
                                else if (typeof object.asyncJobDependencyIds[i] === "object")
                                    message.asyncJobDependencyIds[i] = new $util.LongBits(object.asyncJobDependencyIds[i].low >>> 0, object.asyncJobDependencyIds[i].high >>> 0).toNumber();
                        }
                        if (object.processed != null)
                            message.processed = Boolean(object.processed);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an InsightUnderlyingDataChangedEvent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @static
                     * @param {palexy.streaming.v1.InsightUnderlyingDataChangedEvent} message InsightUnderlyingDataChangedEvent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    InsightUnderlyingDataChangedEvent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.storeIds = [];
                            object.asyncJobDependencyIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.dataSource = options.enums === String ? "DS_UNKNOWN" : 0;
                            object.processed = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.dataSource != null && message.hasOwnProperty("dataSource"))
                            object.dataSource = options.enums === String ? $root.palexy.streaming.v1.DataSource[message.dataSource] : message.dataSource;
                        if (message.asyncJobDependencyIds && message.asyncJobDependencyIds.length) {
                            object.asyncJobDependencyIds = [];
                            for (var j = 0; j < message.asyncJobDependencyIds.length; ++j)
                                if (typeof message.asyncJobDependencyIds[j] === "number")
                                    object.asyncJobDependencyIds[j] = options.longs === String ? String(message.asyncJobDependencyIds[j]) : message.asyncJobDependencyIds[j];
                                else
                                    object.asyncJobDependencyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.asyncJobDependencyIds[j]) : options.longs === Number ? new $util.LongBits(message.asyncJobDependencyIds[j].low >>> 0, message.asyncJobDependencyIds[j].high >>> 0).toNumber() : message.asyncJobDependencyIds[j];
                        }
                        if (message.processed != null && message.hasOwnProperty("processed"))
                            object.processed = message.processed;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this InsightUnderlyingDataChangedEvent to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.InsightUnderlyingDataChangedEvent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    InsightUnderlyingDataChangedEvent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return InsightUnderlyingDataChangedEvent;
                })();
    
                v1.ListInsightUnderlyingDataChangedEventRequest = (function() {
    
                    /**
                     * Properties of a ListInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListInsightUnderlyingDataChangedEventRequest
                     * @property {google.protobuf.IInt64Value|null} [companyId] ListInsightUnderlyingDataChangedEventRequest companyId
                     * @property {google.protobuf.IBoolValue|null} [processed] ListInsightUnderlyingDataChangedEventRequest processed
                     * @property {boolean|null} [dependenciesReadyOnly] ListInsightUnderlyingDataChangedEventRequest dependenciesReadyOnly
                     * @property {number|null} [pageSize] ListInsightUnderlyingDataChangedEventRequest pageSize
                     * @property {string|null} [pageToken] ListInsightUnderlyingDataChangedEventRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListInsightUnderlyingDataChangedEventRequest.
                     * @implements IListInsightUnderlyingDataChangedEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     */
                    function ListInsightUnderlyingDataChangedEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListInsightUnderlyingDataChangedEventRequest companyId.
                     * @member {google.protobuf.IInt64Value|null|undefined} companyId
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.companyId = null;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventRequest processed.
                     * @member {google.protobuf.IBoolValue|null|undefined} processed
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.processed = null;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventRequest dependenciesReadyOnly.
                     * @member {boolean} dependenciesReadyOnly
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.dependenciesReadyOnly = false;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.pageSize = 0;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListInsightUnderlyingDataChangedEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest} ListInsightUnderlyingDataChangedEventRequest instance
                     */
                    ListInsightUnderlyingDataChangedEventRequest.create = function create(properties) {
                        return new ListInsightUnderlyingDataChangedEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListInsightUnderlyingDataChangedEventRequest message. Does not implicitly {@link palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest} message ListInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListInsightUnderlyingDataChangedEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            $root.google.protobuf.Int64Value.encode(message.companyId, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.processed != null && Object.hasOwnProperty.call(message, "processed"))
                            $root.google.protobuf.BoolValue.encode(message.processed, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.dependenciesReadyOnly != null && Object.hasOwnProperty.call(message, "dependenciesReadyOnly"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.dependenciesReadyOnly);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListInsightUnderlyingDataChangedEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventRequest} message ListInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListInsightUnderlyingDataChangedEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest} ListInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListInsightUnderlyingDataChangedEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = $root.google.protobuf.Int64Value.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.processed = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.dependenciesReadyOnly = reader.bool();
                                break;
                            case 4:
                                message.pageSize = reader.int32();
                                break;
                            case 5:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest} ListInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListInsightUnderlyingDataChangedEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListInsightUnderlyingDataChangedEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListInsightUnderlyingDataChangedEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            var error = $root.google.protobuf.Int64Value.verify(message.companyId);
                            if (error)
                                return "companyId." + error;
                        }
                        if (message.processed != null && message.hasOwnProperty("processed")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.processed);
                            if (error)
                                return "processed." + error;
                        }
                        if (message.dependenciesReadyOnly != null && message.hasOwnProperty("dependenciesReadyOnly"))
                            if (typeof message.dependenciesReadyOnly !== "boolean")
                                return "dependenciesReadyOnly: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListInsightUnderlyingDataChangedEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest} ListInsightUnderlyingDataChangedEventRequest
                     */
                    ListInsightUnderlyingDataChangedEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest();
                        if (object.companyId != null) {
                            if (typeof object.companyId !== "object")
                                throw TypeError(".palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest.companyId: object expected");
                            message.companyId = $root.google.protobuf.Int64Value.fromObject(object.companyId);
                        }
                        if (object.processed != null) {
                            if (typeof object.processed !== "object")
                                throw TypeError(".palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest.processed: object expected");
                            message.processed = $root.google.protobuf.BoolValue.fromObject(object.processed);
                        }
                        if (object.dependenciesReadyOnly != null)
                            message.dependenciesReadyOnly = Boolean(object.dependenciesReadyOnly);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListInsightUnderlyingDataChangedEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest} message ListInsightUnderlyingDataChangedEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListInsightUnderlyingDataChangedEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.companyId = null;
                            object.processed = null;
                            object.dependenciesReadyOnly = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            object.companyId = $root.google.protobuf.Int64Value.toObject(message.companyId, options);
                        if (message.processed != null && message.hasOwnProperty("processed"))
                            object.processed = $root.google.protobuf.BoolValue.toObject(message.processed, options);
                        if (message.dependenciesReadyOnly != null && message.hasOwnProperty("dependenciesReadyOnly"))
                            object.dependenciesReadyOnly = message.dependenciesReadyOnly;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListInsightUnderlyingDataChangedEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListInsightUnderlyingDataChangedEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListInsightUnderlyingDataChangedEventRequest;
                })();
    
                v1.ListInsightUnderlyingDataChangedEventResponse = (function() {
    
                    /**
                     * Properties of a ListInsightUnderlyingDataChangedEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListInsightUnderlyingDataChangedEventResponse
                     * @property {Array.<palexy.streaming.v1.IInsightUnderlyingDataChangedEvent>|null} [events] ListInsightUnderlyingDataChangedEventResponse events
                     * @property {number|null} [totalElements] ListInsightUnderlyingDataChangedEventResponse totalElements
                     * @property {string|null} [nextPageToken] ListInsightUnderlyingDataChangedEventResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListInsightUnderlyingDataChangedEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListInsightUnderlyingDataChangedEventResponse.
                     * @implements IListInsightUnderlyingDataChangedEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventResponse=} [properties] Properties to set
                     */
                    function ListInsightUnderlyingDataChangedEventResponse(properties) {
                        this.events = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListInsightUnderlyingDataChangedEventResponse events.
                     * @member {Array.<palexy.streaming.v1.IInsightUnderlyingDataChangedEvent>} events
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventResponse.prototype.events = $util.emptyArray;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListInsightUnderlyingDataChangedEventResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @instance
                     */
                    ListInsightUnderlyingDataChangedEventResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListInsightUnderlyingDataChangedEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} ListInsightUnderlyingDataChangedEventResponse instance
                     */
                    ListInsightUnderlyingDataChangedEventResponse.create = function create(properties) {
                        return new ListInsightUnderlyingDataChangedEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListInsightUnderlyingDataChangedEventResponse message. Does not implicitly {@link palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventResponse} message ListInsightUnderlyingDataChangedEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListInsightUnderlyingDataChangedEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.events != null && message.events.length)
                            for (var i = 0; i < message.events.length; ++i)
                                $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.encode(message.events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListInsightUnderlyingDataChangedEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IListInsightUnderlyingDataChangedEventResponse} message ListInsightUnderlyingDataChangedEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListInsightUnderlyingDataChangedEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListInsightUnderlyingDataChangedEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} ListInsightUnderlyingDataChangedEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListInsightUnderlyingDataChangedEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.events && message.events.length))
                                    message.events = [];
                                message.events.push($root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int64();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListInsightUnderlyingDataChangedEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} ListInsightUnderlyingDataChangedEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListInsightUnderlyingDataChangedEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListInsightUnderlyingDataChangedEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListInsightUnderlyingDataChangedEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.events != null && message.hasOwnProperty("events")) {
                            if (!Array.isArray(message.events))
                                return "events: array expected";
                            for (var i = 0; i < message.events.length; ++i) {
                                var error = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.verify(message.events[i]);
                                if (error)
                                    return "events." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListInsightUnderlyingDataChangedEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} ListInsightUnderlyingDataChangedEventResponse
                     */
                    ListInsightUnderlyingDataChangedEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse();
                        if (object.events) {
                            if (!Array.isArray(object.events))
                                throw TypeError(".palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse.events: array expected");
                            message.events = [];
                            for (var i = 0; i < object.events.length; ++i) {
                                if (typeof object.events[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse.events: object expected");
                                message.events[i] = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.fromObject(object.events[i]);
                            }
                        }
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListInsightUnderlyingDataChangedEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse} message ListInsightUnderlyingDataChangedEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListInsightUnderlyingDataChangedEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.events = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                            object.nextPageToken = "";
                        }
                        if (message.events && message.events.length) {
                            object.events = [];
                            for (var j = 0; j < message.events.length; ++j)
                                object.events[j] = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.toObject(message.events[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListInsightUnderlyingDataChangedEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListInsightUnderlyingDataChangedEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListInsightUnderlyingDataChangedEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListInsightUnderlyingDataChangedEventResponse;
                })();
    
                v1.CreateInsightUnderlyingDataChangedEventRequest = (function() {
    
                    /**
                     * Properties of a CreateInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateInsightUnderlyingDataChangedEventRequest
                     * @property {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent|null} [event] CreateInsightUnderlyingDataChangedEventRequest event
                     * @property {Array.<palexy.streaming.v1.IAsyncJob>|null} [asyncJobDependencies] CreateInsightUnderlyingDataChangedEventRequest asyncJobDependencies
                     */
    
                    /**
                     * Constructs a new CreateInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateInsightUnderlyingDataChangedEventRequest.
                     * @implements ICreateInsightUnderlyingDataChangedEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     */
                    function CreateInsightUnderlyingDataChangedEventRequest(properties) {
                        this.asyncJobDependencies = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateInsightUnderlyingDataChangedEventRequest event.
                     * @member {palexy.streaming.v1.IInsightUnderlyingDataChangedEvent|null|undefined} event
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.prototype.event = null;
    
                    /**
                     * CreateInsightUnderlyingDataChangedEventRequest asyncJobDependencies.
                     * @member {Array.<palexy.streaming.v1.IAsyncJob>} asyncJobDependencies
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.prototype.asyncJobDependencies = $util.emptyArray;
    
                    /**
                     * Creates a new CreateInsightUnderlyingDataChangedEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest} CreateInsightUnderlyingDataChangedEventRequest instance
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.create = function create(properties) {
                        return new CreateInsightUnderlyingDataChangedEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateInsightUnderlyingDataChangedEventRequest message. Does not implicitly {@link palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest} message CreateInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.event != null && Object.hasOwnProperty.call(message, "event"))
                            $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.encode(message.event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.asyncJobDependencies != null && message.asyncJobDependencies.length)
                            for (var i = 0; i < message.asyncJobDependencies.length; ++i)
                                $root.palexy.streaming.v1.AsyncJob.encode(message.asyncJobDependencies[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateInsightUnderlyingDataChangedEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateInsightUnderlyingDataChangedEventRequest} message CreateInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest} CreateInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.event = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.asyncJobDependencies && message.asyncJobDependencies.length))
                                    message.asyncJobDependencies = [];
                                message.asyncJobDependencies.push($root.palexy.streaming.v1.AsyncJob.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest} CreateInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateInsightUnderlyingDataChangedEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.event != null && message.hasOwnProperty("event")) {
                            var error = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.verify(message.event);
                            if (error)
                                return "event." + error;
                        }
                        if (message.asyncJobDependencies != null && message.hasOwnProperty("asyncJobDependencies")) {
                            if (!Array.isArray(message.asyncJobDependencies))
                                return "asyncJobDependencies: array expected";
                            for (var i = 0; i < message.asyncJobDependencies.length; ++i) {
                                var error = $root.palexy.streaming.v1.AsyncJob.verify(message.asyncJobDependencies[i]);
                                if (error)
                                    return "asyncJobDependencies." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateInsightUnderlyingDataChangedEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest} CreateInsightUnderlyingDataChangedEventRequest
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest();
                        if (object.event != null) {
                            if (typeof object.event !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest.event: object expected");
                            message.event = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.fromObject(object.event);
                        }
                        if (object.asyncJobDependencies) {
                            if (!Array.isArray(object.asyncJobDependencies))
                                throw TypeError(".palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest.asyncJobDependencies: array expected");
                            message.asyncJobDependencies = [];
                            for (var i = 0; i < object.asyncJobDependencies.length; ++i) {
                                if (typeof object.asyncJobDependencies[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest.asyncJobDependencies: object expected");
                                message.asyncJobDependencies[i] = $root.palexy.streaming.v1.AsyncJob.fromObject(object.asyncJobDependencies[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateInsightUnderlyingDataChangedEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest} message CreateInsightUnderlyingDataChangedEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.asyncJobDependencies = [];
                        if (options.defaults)
                            object.event = null;
                        if (message.event != null && message.hasOwnProperty("event"))
                            object.event = $root.palexy.streaming.v1.InsightUnderlyingDataChangedEvent.toObject(message.event, options);
                        if (message.asyncJobDependencies && message.asyncJobDependencies.length) {
                            object.asyncJobDependencies = [];
                            for (var j = 0; j < message.asyncJobDependencies.length; ++j)
                                object.asyncJobDependencies[j] = $root.palexy.streaming.v1.AsyncJob.toObject(message.asyncJobDependencies[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateInsightUnderlyingDataChangedEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateInsightUnderlyingDataChangedEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateInsightUnderlyingDataChangedEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateInsightUnderlyingDataChangedEventRequest;
                })();
    
                v1.BatchCompleteInsightUnderlyingDataChangedEventRequest = (function() {
    
                    /**
                     * Properties of a BatchCompleteInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @property {Array.<number>|null} [eventIds] BatchCompleteInsightUnderlyingDataChangedEventRequest eventIds
                     */
    
                    /**
                     * Constructs a new BatchCompleteInsightUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchCompleteInsightUnderlyingDataChangedEventRequest.
                     * @implements IBatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     */
                    function BatchCompleteInsightUnderlyingDataChangedEventRequest(properties) {
                        this.eventIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchCompleteInsightUnderlyingDataChangedEventRequest eventIds.
                     * @member {Array.<number>} eventIds
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.prototype.eventIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchCompleteInsightUnderlyingDataChangedEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest} BatchCompleteInsightUnderlyingDataChangedEventRequest instance
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.create = function create(properties) {
                        return new BatchCompleteInsightUnderlyingDataChangedEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchCompleteInsightUnderlyingDataChangedEventRequest message. Does not implicitly {@link palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest} message BatchCompleteInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventIds != null && message.eventIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.eventIds.length; ++i)
                                writer.int64(message.eventIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchCompleteInsightUnderlyingDataChangedEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchCompleteInsightUnderlyingDataChangedEventRequest} message BatchCompleteInsightUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchCompleteInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest} BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.eventIds && message.eventIds.length))
                                    message.eventIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.eventIds.push(reader.int64());
                                } else
                                    message.eventIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchCompleteInsightUnderlyingDataChangedEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest} BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchCompleteInsightUnderlyingDataChangedEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.eventIds != null && message.hasOwnProperty("eventIds")) {
                            if (!Array.isArray(message.eventIds))
                                return "eventIds: array expected";
                            for (var i = 0; i < message.eventIds.length; ++i)
                                if (!$util.isInteger(message.eventIds[i]) && !(message.eventIds[i] && $util.isInteger(message.eventIds[i].low) && $util.isInteger(message.eventIds[i].high)))
                                    return "eventIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchCompleteInsightUnderlyingDataChangedEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest} BatchCompleteInsightUnderlyingDataChangedEventRequest
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest();
                        if (object.eventIds) {
                            if (!Array.isArray(object.eventIds))
                                throw TypeError(".palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest.eventIds: array expected");
                            message.eventIds = [];
                            for (var i = 0; i < object.eventIds.length; ++i)
                                if ($util.Long)
                                    (message.eventIds[i] = $util.Long.fromValue(object.eventIds[i])).unsigned = false;
                                else if (typeof object.eventIds[i] === "string")
                                    message.eventIds[i] = parseInt(object.eventIds[i], 10);
                                else if (typeof object.eventIds[i] === "number")
                                    message.eventIds[i] = object.eventIds[i];
                                else if (typeof object.eventIds[i] === "object")
                                    message.eventIds[i] = new $util.LongBits(object.eventIds[i].low >>> 0, object.eventIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchCompleteInsightUnderlyingDataChangedEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest} message BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.eventIds = [];
                        if (message.eventIds && message.eventIds.length) {
                            object.eventIds = [];
                            for (var j = 0; j < message.eventIds.length; ++j)
                                if (typeof message.eventIds[j] === "number")
                                    object.eventIds[j] = options.longs === String ? String(message.eventIds[j]) : message.eventIds[j];
                                else
                                    object.eventIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.eventIds[j]) : options.longs === Number ? new $util.LongBits(message.eventIds[j].low >>> 0, message.eventIds[j].high >>> 0).toNumber() : message.eventIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchCompleteInsightUnderlyingDataChangedEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchCompleteInsightUnderlyingDataChangedEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchCompleteInsightUnderlyingDataChangedEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchCompleteInsightUnderlyingDataChangedEventRequest;
                })();
    
                v1.ProcessUnderlyingDataChangedEventRequest = (function() {
    
                    /**
                     * Properties of a ProcessUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IProcessUnderlyingDataChangedEventRequest
                     * @property {number|null} [batchSize] ProcessUnderlyingDataChangedEventRequest batchSize
                     */
    
                    /**
                     * Constructs a new ProcessUnderlyingDataChangedEventRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ProcessUnderlyingDataChangedEventRequest.
                     * @implements IProcessUnderlyingDataChangedEventRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     */
                    function ProcessUnderlyingDataChangedEventRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProcessUnderlyingDataChangedEventRequest batchSize.
                     * @member {number} batchSize
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @instance
                     */
                    ProcessUnderlyingDataChangedEventRequest.prototype.batchSize = 0;
    
                    /**
                     * Creates a new ProcessUnderlyingDataChangedEventRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest} ProcessUnderlyingDataChangedEventRequest instance
                     */
                    ProcessUnderlyingDataChangedEventRequest.create = function create(properties) {
                        return new ProcessUnderlyingDataChangedEventRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessUnderlyingDataChangedEventRequest message. Does not implicitly {@link palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest} message ProcessUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessUnderlyingDataChangedEventRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.batchSize != null && Object.hasOwnProperty.call(message, "batchSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.batchSize);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessUnderlyingDataChangedEventRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventRequest} message ProcessUnderlyingDataChangedEventRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessUnderlyingDataChangedEventRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessUnderlyingDataChangedEventRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest} ProcessUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessUnderlyingDataChangedEventRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.batchSize = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessUnderlyingDataChangedEventRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest} ProcessUnderlyingDataChangedEventRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessUnderlyingDataChangedEventRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessUnderlyingDataChangedEventRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessUnderlyingDataChangedEventRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                            if (!$util.isInteger(message.batchSize))
                                return "batchSize: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessUnderlyingDataChangedEventRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest} ProcessUnderlyingDataChangedEventRequest
                     */
                    ProcessUnderlyingDataChangedEventRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest();
                        if (object.batchSize != null)
                            message.batchSize = object.batchSize | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProcessUnderlyingDataChangedEventRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @static
                     * @param {palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest} message ProcessUnderlyingDataChangedEventRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessUnderlyingDataChangedEventRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.batchSize = 0;
                        if (message.batchSize != null && message.hasOwnProperty("batchSize"))
                            object.batchSize = message.batchSize;
                        return object;
                    };
    
                    /**
                     * Converts this ProcessUnderlyingDataChangedEventRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessUnderlyingDataChangedEventRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessUnderlyingDataChangedEventRequest;
                })();
    
                v1.ProcessUnderlyingDataChangedEventResponse = (function() {
    
                    /**
                     * Properties of a ProcessUnderlyingDataChangedEventResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IProcessUnderlyingDataChangedEventResponse
                     * @property {number|null} [processedCount] ProcessUnderlyingDataChangedEventResponse processedCount
                     */
    
                    /**
                     * Constructs a new ProcessUnderlyingDataChangedEventResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ProcessUnderlyingDataChangedEventResponse.
                     * @implements IProcessUnderlyingDataChangedEventResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventResponse=} [properties] Properties to set
                     */
                    function ProcessUnderlyingDataChangedEventResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProcessUnderlyingDataChangedEventResponse processedCount.
                     * @member {number} processedCount
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @instance
                     */
                    ProcessUnderlyingDataChangedEventResponse.prototype.processedCount = 0;
    
                    /**
                     * Creates a new ProcessUnderlyingDataChangedEventResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} ProcessUnderlyingDataChangedEventResponse instance
                     */
                    ProcessUnderlyingDataChangedEventResponse.create = function create(properties) {
                        return new ProcessUnderlyingDataChangedEventResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessUnderlyingDataChangedEventResponse message. Does not implicitly {@link palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventResponse} message ProcessUnderlyingDataChangedEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessUnderlyingDataChangedEventResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.processedCount != null && Object.hasOwnProperty.call(message, "processedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.processedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessUnderlyingDataChangedEventResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.IProcessUnderlyingDataChangedEventResponse} message ProcessUnderlyingDataChangedEventResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessUnderlyingDataChangedEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessUnderlyingDataChangedEventResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} ProcessUnderlyingDataChangedEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessUnderlyingDataChangedEventResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.processedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessUnderlyingDataChangedEventResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} ProcessUnderlyingDataChangedEventResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessUnderlyingDataChangedEventResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessUnderlyingDataChangedEventResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessUnderlyingDataChangedEventResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.processedCount != null && message.hasOwnProperty("processedCount"))
                            if (!$util.isInteger(message.processedCount))
                                return "processedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessUnderlyingDataChangedEventResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} ProcessUnderlyingDataChangedEventResponse
                     */
                    ProcessUnderlyingDataChangedEventResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse();
                        if (object.processedCount != null)
                            message.processedCount = object.processedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProcessUnderlyingDataChangedEventResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @static
                     * @param {palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse} message ProcessUnderlyingDataChangedEventResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessUnderlyingDataChangedEventResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.processedCount = 0;
                        if (message.processedCount != null && message.hasOwnProperty("processedCount"))
                            object.processedCount = message.processedCount;
                        return object;
                    };
    
                    /**
                     * Converts this ProcessUnderlyingDataChangedEventResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ProcessUnderlyingDataChangedEventResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessUnderlyingDataChangedEventResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessUnderlyingDataChangedEventResponse;
                })();
    
                v1.ImageProcessingModel = (function() {
    
                    /**
                     * Properties of an ImageProcessingModel.
                     * @memberof palexy.streaming.v1
                     * @interface IImageProcessingModel
                     * @property {number|null} [id] ImageProcessingModel id
                     * @property {string|null} [name] ImageProcessingModel name
                     * @property {string|null} [description] ImageProcessingModel description
                     * @property {palexy.streaming.v1.ImageProcessingModel.ModelType|null} [type] ImageProcessingModel type
                     * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [modelFile] ImageProcessingModel modelFile
                     * @property {number|null} [createTimeMs] ImageProcessingModel createTimeMs
                     */
    
                    /**
                     * Constructs a new ImageProcessingModel.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImageProcessingModel.
                     * @implements IImageProcessingModel
                     * @constructor
                     * @param {palexy.streaming.v1.IImageProcessingModel=} [properties] Properties to set
                     */
                    function ImageProcessingModel(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImageProcessingModel id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImageProcessingModel name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.name = "";
    
                    /**
                     * ImageProcessingModel description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.description = "";
    
                    /**
                     * ImageProcessingModel type.
                     * @member {palexy.streaming.v1.ImageProcessingModel.ModelType} type
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.type = 0;
    
                    /**
                     * ImageProcessingModel modelFile.
                     * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} modelFile
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.modelFile = null;
    
                    /**
                     * ImageProcessingModel createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     */
                    ImageProcessingModel.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ImageProcessingModel instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {palexy.streaming.v1.IImageProcessingModel=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ImageProcessingModel} ImageProcessingModel instance
                     */
                    ImageProcessingModel.create = function create(properties) {
                        return new ImageProcessingModel(properties);
                    };
    
                    /**
                     * Encodes the specified ImageProcessingModel message. Does not implicitly {@link palexy.streaming.v1.ImageProcessingModel.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {palexy.streaming.v1.IImageProcessingModel} message ImageProcessingModel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImageProcessingModel.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.type);
                        if (message.modelFile != null && Object.hasOwnProperty.call(message, "modelFile"))
                            $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.modelFile, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImageProcessingModel message, length delimited. Does not implicitly {@link palexy.streaming.v1.ImageProcessingModel.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {palexy.streaming.v1.IImageProcessingModel} message ImageProcessingModel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImageProcessingModel.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImageProcessingModel message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ImageProcessingModel} ImageProcessingModel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImageProcessingModel.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ImageProcessingModel();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.type = reader.int32();
                                break;
                            case 5:
                                message.modelFile = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImageProcessingModel message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ImageProcessingModel} ImageProcessingModel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImageProcessingModel.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImageProcessingModel message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImageProcessingModel.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.modelFile != null && message.hasOwnProperty("modelFile")) {
                            var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.modelFile);
                            if (error)
                                return "modelFile." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an ImageProcessingModel message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ImageProcessingModel} ImageProcessingModel
                     */
                    ImageProcessingModel.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ImageProcessingModel)
                            return object;
                        var message = new $root.palexy.streaming.v1.ImageProcessingModel();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        switch (object.type) {
                        case "UNKNOWN_MODEL_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "PERSON_REID":
                        case 1:
                            message.type = 1;
                            break;
                        case "PERSON_DETECTION":
                        case 2:
                            message.type = 2;
                            break;
                        case "GENDER_AGE_GROUP":
                        case 3:
                            message.type = 3;
                            break;
                        case "BOUNDING_BOX_ATTIRIBUTE":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.modelFile != null) {
                            if (typeof object.modelFile !== "object")
                                throw TypeError(".palexy.streaming.v1.ImageProcessingModel.modelFile: object expected");
                            message.modelFile = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.modelFile);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImageProcessingModel message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @static
                     * @param {palexy.streaming.v1.ImageProcessingModel} message ImageProcessingModel
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImageProcessingModel.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            object.type = options.enums === String ? "UNKNOWN_MODEL_TYPE" : 0;
                            object.modelFile = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.ImageProcessingModel.ModelType[message.type] : message.type;
                        if (message.modelFile != null && message.hasOwnProperty("modelFile"))
                            object.modelFile = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.modelFile, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ImageProcessingModel to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ImageProcessingModel
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImageProcessingModel.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ModelType enum.
                     * @name palexy.streaming.v1.ImageProcessingModel.ModelType
                     * @enum {number}
                     * @property {number} UNKNOWN_MODEL_TYPE=0 UNKNOWN_MODEL_TYPE value
                     * @property {number} PERSON_REID=1 PERSON_REID value
                     * @property {number} PERSON_DETECTION=2 PERSON_DETECTION value
                     * @property {number} GENDER_AGE_GROUP=3 GENDER_AGE_GROUP value
                     * @property {number} BOUNDING_BOX_ATTIRIBUTE=4 BOUNDING_BOX_ATTIRIBUTE value
                     */
                    ImageProcessingModel.ModelType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_MODEL_TYPE"] = 0;
                        values[valuesById[1] = "PERSON_REID"] = 1;
                        values[valuesById[2] = "PERSON_DETECTION"] = 2;
                        values[valuesById[3] = "GENDER_AGE_GROUP"] = 3;
                        values[valuesById[4] = "BOUNDING_BOX_ATTIRIBUTE"] = 4;
                        return values;
                    })();
    
                    return ImageProcessingModel;
                })();
    
                v1.ImageProcessingModelService = (function() {
    
                    /**
                     * Constructs a new ImageProcessingModelService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ImageProcessingModelService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ImageProcessingModelService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ImageProcessingModelService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ImageProcessingModelService;
    
                    /**
                     * Creates new ImageProcessingModelService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ImageProcessingModelService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ImageProcessingModelService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ImageProcessingModelService#getImageProcessingModel}.
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @typedef GetImageProcessingModelCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ImageProcessingModel} [response] ImageProcessingModel
                     */
    
                    /**
                     * Calls GetImageProcessingModel.
                     * @function getImageProcessingModel
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @instance
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest} request GetImageProcessingModelRequest message or plain object
                     * @param {palexy.streaming.v1.ImageProcessingModelService.GetImageProcessingModelCallback} callback Node-style callback called with the error, if any, and ImageProcessingModel
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ImageProcessingModelService.prototype.getImageProcessingModel = function getImageProcessingModel(request, callback) {
                        return this.rpcCall(getImageProcessingModel, $root.palexy.streaming.v1.GetImageProcessingModelRequest, $root.palexy.streaming.v1.ImageProcessingModel, request, callback);
                    }, "name", { value: "GetImageProcessingModel" });
    
                    /**
                     * Calls GetImageProcessingModel.
                     * @function getImageProcessingModel
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @instance
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest} request GetImageProcessingModelRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ImageProcessingModel>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ImageProcessingModelService#listImageProcessingModels}.
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @typedef ListImageProcessingModelsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListImageProcessingModelsResponse} [response] ListImageProcessingModelsResponse
                     */
    
                    /**
                     * Calls ListImageProcessingModels.
                     * @function listImageProcessingModels
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @instance
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest} request ListImageProcessingModelsRequest message or plain object
                     * @param {palexy.streaming.v1.ImageProcessingModelService.ListImageProcessingModelsCallback} callback Node-style callback called with the error, if any, and ListImageProcessingModelsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ImageProcessingModelService.prototype.listImageProcessingModels = function listImageProcessingModels(request, callback) {
                        return this.rpcCall(listImageProcessingModels, $root.palexy.streaming.v1.ListImageProcessingModelsRequest, $root.palexy.streaming.v1.ListImageProcessingModelsResponse, request, callback);
                    }, "name", { value: "ListImageProcessingModels" });
    
                    /**
                     * Calls ListImageProcessingModels.
                     * @function listImageProcessingModels
                     * @memberof palexy.streaming.v1.ImageProcessingModelService
                     * @instance
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest} request ListImageProcessingModelsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListImageProcessingModelsResponse>} Promise
                     * @variation 2
                     */
    
                    return ImageProcessingModelService;
                })();
    
                v1.GetImageProcessingModelRequest = (function() {
    
                    /**
                     * Properties of a GetImageProcessingModelRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetImageProcessingModelRequest
                     * @property {string|null} [name] GetImageProcessingModelRequest name
                     */
    
                    /**
                     * Constructs a new GetImageProcessingModelRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetImageProcessingModelRequest.
                     * @implements IGetImageProcessingModelRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest=} [properties] Properties to set
                     */
                    function GetImageProcessingModelRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetImageProcessingModelRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @instance
                     */
                    GetImageProcessingModelRequest.prototype.name = "";
    
                    /**
                     * Creates a new GetImageProcessingModelRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetImageProcessingModelRequest} GetImageProcessingModelRequest instance
                     */
                    GetImageProcessingModelRequest.create = function create(properties) {
                        return new GetImageProcessingModelRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetImageProcessingModelRequest message. Does not implicitly {@link palexy.streaming.v1.GetImageProcessingModelRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest} message GetImageProcessingModelRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetImageProcessingModelRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetImageProcessingModelRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetImageProcessingModelRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetImageProcessingModelRequest} message GetImageProcessingModelRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetImageProcessingModelRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetImageProcessingModelRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetImageProcessingModelRequest} GetImageProcessingModelRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetImageProcessingModelRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetImageProcessingModelRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetImageProcessingModelRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetImageProcessingModelRequest} GetImageProcessingModelRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetImageProcessingModelRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetImageProcessingModelRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetImageProcessingModelRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetImageProcessingModelRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetImageProcessingModelRequest} GetImageProcessingModelRequest
                     */
                    GetImageProcessingModelRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetImageProcessingModelRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetImageProcessingModelRequest();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetImageProcessingModelRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @static
                     * @param {palexy.streaming.v1.GetImageProcessingModelRequest} message GetImageProcessingModelRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetImageProcessingModelRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.name = "";
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this GetImageProcessingModelRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetImageProcessingModelRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetImageProcessingModelRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetImageProcessingModelRequest;
                })();
    
                v1.ListImageProcessingModelsRequest = (function() {
    
                    /**
                     * Properties of a ListImageProcessingModelsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListImageProcessingModelsRequest
                     * @property {palexy.streaming.v1.ImageProcessingModel.ModelType|null} [modelType] ListImageProcessingModelsRequest modelType
                     */
    
                    /**
                     * Constructs a new ListImageProcessingModelsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListImageProcessingModelsRequest.
                     * @implements IListImageProcessingModelsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest=} [properties] Properties to set
                     */
                    function ListImageProcessingModelsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListImageProcessingModelsRequest modelType.
                     * @member {palexy.streaming.v1.ImageProcessingModel.ModelType} modelType
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @instance
                     */
                    ListImageProcessingModelsRequest.prototype.modelType = 0;
    
                    /**
                     * Creates a new ListImageProcessingModelsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsRequest} ListImageProcessingModelsRequest instance
                     */
                    ListImageProcessingModelsRequest.create = function create(properties) {
                        return new ListImageProcessingModelsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListImageProcessingModelsRequest message. Does not implicitly {@link palexy.streaming.v1.ListImageProcessingModelsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest} message ListImageProcessingModelsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListImageProcessingModelsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.modelType != null && Object.hasOwnProperty.call(message, "modelType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.modelType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListImageProcessingModelsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListImageProcessingModelsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsRequest} message ListImageProcessingModelsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListImageProcessingModelsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListImageProcessingModelsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsRequest} ListImageProcessingModelsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListImageProcessingModelsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListImageProcessingModelsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.modelType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListImageProcessingModelsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsRequest} ListImageProcessingModelsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListImageProcessingModelsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListImageProcessingModelsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListImageProcessingModelsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.modelType != null && message.hasOwnProperty("modelType"))
                            switch (message.modelType) {
                            default:
                                return "modelType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ListImageProcessingModelsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsRequest} ListImageProcessingModelsRequest
                     */
                    ListImageProcessingModelsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListImageProcessingModelsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListImageProcessingModelsRequest();
                        switch (object.modelType) {
                        case "UNKNOWN_MODEL_TYPE":
                        case 0:
                            message.modelType = 0;
                            break;
                        case "PERSON_REID":
                        case 1:
                            message.modelType = 1;
                            break;
                        case "PERSON_DETECTION":
                        case 2:
                            message.modelType = 2;
                            break;
                        case "GENDER_AGE_GROUP":
                        case 3:
                            message.modelType = 3;
                            break;
                        case "BOUNDING_BOX_ATTIRIBUTE":
                        case 4:
                            message.modelType = 4;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListImageProcessingModelsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListImageProcessingModelsRequest} message ListImageProcessingModelsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListImageProcessingModelsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.modelType = options.enums === String ? "UNKNOWN_MODEL_TYPE" : 0;
                        if (message.modelType != null && message.hasOwnProperty("modelType"))
                            object.modelType = options.enums === String ? $root.palexy.streaming.v1.ImageProcessingModel.ModelType[message.modelType] : message.modelType;
                        return object;
                    };
    
                    /**
                     * Converts this ListImageProcessingModelsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListImageProcessingModelsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListImageProcessingModelsRequest;
                })();
    
                v1.ListImageProcessingModelsResponse = (function() {
    
                    /**
                     * Properties of a ListImageProcessingModelsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListImageProcessingModelsResponse
                     * @property {Array.<palexy.streaming.v1.IImageProcessingModel>|null} [models] ListImageProcessingModelsResponse models
                     */
    
                    /**
                     * Constructs a new ListImageProcessingModelsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListImageProcessingModelsResponse.
                     * @implements IListImageProcessingModelsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListImageProcessingModelsResponse=} [properties] Properties to set
                     */
                    function ListImageProcessingModelsResponse(properties) {
                        this.models = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListImageProcessingModelsResponse models.
                     * @member {Array.<palexy.streaming.v1.IImageProcessingModel>} models
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @instance
                     */
                    ListImageProcessingModelsResponse.prototype.models = $util.emptyArray;
    
                    /**
                     * Creates a new ListImageProcessingModelsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsResponse} ListImageProcessingModelsResponse instance
                     */
                    ListImageProcessingModelsResponse.create = function create(properties) {
                        return new ListImageProcessingModelsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListImageProcessingModelsResponse message. Does not implicitly {@link palexy.streaming.v1.ListImageProcessingModelsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsResponse} message ListImageProcessingModelsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListImageProcessingModelsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.models != null && message.models.length)
                            for (var i = 0; i < message.models.length; ++i)
                                $root.palexy.streaming.v1.ImageProcessingModel.encode(message.models[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListImageProcessingModelsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListImageProcessingModelsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListImageProcessingModelsResponse} message ListImageProcessingModelsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListImageProcessingModelsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListImageProcessingModelsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsResponse} ListImageProcessingModelsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListImageProcessingModelsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListImageProcessingModelsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.models && message.models.length))
                                    message.models = [];
                                message.models.push($root.palexy.streaming.v1.ImageProcessingModel.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListImageProcessingModelsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsResponse} ListImageProcessingModelsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListImageProcessingModelsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListImageProcessingModelsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListImageProcessingModelsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.models != null && message.hasOwnProperty("models")) {
                            if (!Array.isArray(message.models))
                                return "models: array expected";
                            for (var i = 0; i < message.models.length; ++i) {
                                var error = $root.palexy.streaming.v1.ImageProcessingModel.verify(message.models[i]);
                                if (error)
                                    return "models." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListImageProcessingModelsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListImageProcessingModelsResponse} ListImageProcessingModelsResponse
                     */
                    ListImageProcessingModelsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListImageProcessingModelsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListImageProcessingModelsResponse();
                        if (object.models) {
                            if (!Array.isArray(object.models))
                                throw TypeError(".palexy.streaming.v1.ListImageProcessingModelsResponse.models: array expected");
                            message.models = [];
                            for (var i = 0; i < object.models.length; ++i) {
                                if (typeof object.models[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListImageProcessingModelsResponse.models: object expected");
                                message.models[i] = $root.palexy.streaming.v1.ImageProcessingModel.fromObject(object.models[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListImageProcessingModelsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListImageProcessingModelsResponse} message ListImageProcessingModelsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListImageProcessingModelsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.models = [];
                        if (message.models && message.models.length) {
                            object.models = [];
                            for (var j = 0; j < message.models.length; ++j)
                                object.models[j] = $root.palexy.streaming.v1.ImageProcessingModel.toObject(message.models[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListImageProcessingModelsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListImageProcessingModelsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListImageProcessingModelsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListImageProcessingModelsResponse;
                })();
    
                v1.StaffPositionService = (function() {
    
                    /**
                     * Constructs a new StaffPositionService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffPositionService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffPositionService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffPositionService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffPositionService;
    
                    /**
                     * Creates new StaffPositionService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffPositionService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffPositionService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffPositionService#getStaffPosition}.
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @typedef GetStaffPositionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffPosition} [response] StaffPosition
                     */
    
                    /**
                     * Calls GetStaffPosition.
                     * @function getStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest} request GetStaffPositionRequest message or plain object
                     * @param {palexy.streaming.v1.StaffPositionService.GetStaffPositionCallback} callback Node-style callback called with the error, if any, and StaffPosition
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffPositionService.prototype.getStaffPosition = function getStaffPosition(request, callback) {
                        return this.rpcCall(getStaffPosition, $root.palexy.streaming.v1.GetStaffPositionRequest, $root.palexy.streaming.v1.StaffPosition, request, callback);
                    }, "name", { value: "GetStaffPosition" });
    
                    /**
                     * Calls GetStaffPosition.
                     * @function getStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest} request GetStaffPositionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffPosition>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffPositionService#listStaffPositions}.
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @typedef ListStaffPositionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffPositionsResponse} [response] ListStaffPositionsResponse
                     */
    
                    /**
                     * Calls ListStaffPositions.
                     * @function listStaffPositions
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest} request ListStaffPositionsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffPositionService.ListStaffPositionsCallback} callback Node-style callback called with the error, if any, and ListStaffPositionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffPositionService.prototype.listStaffPositions = function listStaffPositions(request, callback) {
                        return this.rpcCall(listStaffPositions, $root.palexy.streaming.v1.ListStaffPositionsRequest, $root.palexy.streaming.v1.ListStaffPositionsResponse, request, callback);
                    }, "name", { value: "ListStaffPositions" });
    
                    /**
                     * Calls ListStaffPositions.
                     * @function listStaffPositions
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest} request ListStaffPositionsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffPositionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffPositionService#createStaffPosition}.
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @typedef CreateStaffPositionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffPosition} [response] StaffPosition
                     */
    
                    /**
                     * Calls CreateStaffPosition.
                     * @function createStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest} request CreateStaffPositionRequest message or plain object
                     * @param {palexy.streaming.v1.StaffPositionService.CreateStaffPositionCallback} callback Node-style callback called with the error, if any, and StaffPosition
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffPositionService.prototype.createStaffPosition = function createStaffPosition(request, callback) {
                        return this.rpcCall(createStaffPosition, $root.palexy.streaming.v1.CreateStaffPositionRequest, $root.palexy.streaming.v1.StaffPosition, request, callback);
                    }, "name", { value: "CreateStaffPosition" });
    
                    /**
                     * Calls CreateStaffPosition.
                     * @function createStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest} request CreateStaffPositionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffPosition>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffPositionService#updateStaffPosition}.
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @typedef UpdateStaffPositionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffPosition} [response] StaffPosition
                     */
    
                    /**
                     * Calls UpdateStaffPosition.
                     * @function updateStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest} request UpdateStaffPositionRequest message or plain object
                     * @param {palexy.streaming.v1.StaffPositionService.UpdateStaffPositionCallback} callback Node-style callback called with the error, if any, and StaffPosition
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffPositionService.prototype.updateStaffPosition = function updateStaffPosition(request, callback) {
                        return this.rpcCall(updateStaffPosition, $root.palexy.streaming.v1.UpdateStaffPositionRequest, $root.palexy.streaming.v1.StaffPosition, request, callback);
                    }, "name", { value: "UpdateStaffPosition" });
    
                    /**
                     * Calls UpdateStaffPosition.
                     * @function updateStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest} request UpdateStaffPositionRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffPosition>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffPositionService#deleteStaffPosition}.
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @typedef DeleteStaffPositionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStaffPosition.
                     * @function deleteStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest} request DeleteStaffPositionRequest message or plain object
                     * @param {palexy.streaming.v1.StaffPositionService.DeleteStaffPositionCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffPositionService.prototype.deleteStaffPosition = function deleteStaffPosition(request, callback) {
                        return this.rpcCall(deleteStaffPosition, $root.palexy.streaming.v1.DeleteStaffPositionRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStaffPosition" });
    
                    /**
                     * Calls DeleteStaffPosition.
                     * @function deleteStaffPosition
                     * @memberof palexy.streaming.v1.StaffPositionService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest} request DeleteStaffPositionRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return StaffPositionService;
                })();
    
                v1.ListStaffPositionsRequest = (function() {
    
                    /**
                     * Properties of a ListStaffPositionsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffPositionsRequest
                     * @property {number|null} [companyId] ListStaffPositionsRequest companyId
                     * @property {number|null} [storeId] ListStaffPositionsRequest storeId
                     * @property {number|null} [staffId] ListStaffPositionsRequest staffId
                     */
    
                    /**
                     * Constructs a new ListStaffPositionsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffPositionsRequest.
                     * @implements IListStaffPositionsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest=} [properties] Properties to set
                     */
                    function ListStaffPositionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffPositionsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @instance
                     */
                    ListStaffPositionsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffPositionsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @instance
                     */
                    ListStaffPositionsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffPositionsRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @instance
                     */
                    ListStaffPositionsRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStaffPositionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffPositionsRequest} ListStaffPositionsRequest instance
                     */
                    ListStaffPositionsRequest.create = function create(properties) {
                        return new ListStaffPositionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffPositionsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffPositionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest} message ListStaffPositionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffPositionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffPositionsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffPositionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsRequest} message ListStaffPositionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffPositionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffPositionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffPositionsRequest} ListStaffPositionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffPositionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffPositionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffPositionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffPositionsRequest} ListStaffPositionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffPositionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffPositionsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffPositionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffPositionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffPositionsRequest} ListStaffPositionsRequest
                     */
                    ListStaffPositionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffPositionsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffPositionsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffPositionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffPositionsRequest} message ListStaffPositionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffPositionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffPositionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffPositionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffPositionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffPositionsRequest;
                })();
    
                v1.ListStaffPositionsResponse = (function() {
    
                    /**
                     * Properties of a ListStaffPositionsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffPositionsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffPosition>|null} [staffPositions] ListStaffPositionsResponse staffPositions
                     */
    
                    /**
                     * Constructs a new ListStaffPositionsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffPositionsResponse.
                     * @implements IListStaffPositionsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffPositionsResponse=} [properties] Properties to set
                     */
                    function ListStaffPositionsResponse(properties) {
                        this.staffPositions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffPositionsResponse staffPositions.
                     * @member {Array.<palexy.streaming.v1.IStaffPosition>} staffPositions
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @instance
                     */
                    ListStaffPositionsResponse.prototype.staffPositions = $util.emptyArray;
    
                    /**
                     * Creates a new ListStaffPositionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffPositionsResponse} ListStaffPositionsResponse instance
                     */
                    ListStaffPositionsResponse.create = function create(properties) {
                        return new ListStaffPositionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffPositionsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffPositionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsResponse} message ListStaffPositionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffPositionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffPositions != null && message.staffPositions.length)
                            for (var i = 0; i < message.staffPositions.length; ++i)
                                $root.palexy.streaming.v1.StaffPosition.encode(message.staffPositions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffPositionsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffPositionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffPositionsResponse} message ListStaffPositionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffPositionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffPositionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffPositionsResponse} ListStaffPositionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffPositionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffPositionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffPositions && message.staffPositions.length))
                                    message.staffPositions = [];
                                message.staffPositions.push($root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffPositionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffPositionsResponse} ListStaffPositionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffPositionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffPositionsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffPositionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffPositions != null && message.hasOwnProperty("staffPositions")) {
                            if (!Array.isArray(message.staffPositions))
                                return "staffPositions: array expected";
                            for (var i = 0; i < message.staffPositions.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPositions[i]);
                                if (error)
                                    return "staffPositions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffPositionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffPositionsResponse} ListStaffPositionsResponse
                     */
                    ListStaffPositionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffPositionsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffPositionsResponse();
                        if (object.staffPositions) {
                            if (!Array.isArray(object.staffPositions))
                                throw TypeError(".palexy.streaming.v1.ListStaffPositionsResponse.staffPositions: array expected");
                            message.staffPositions = [];
                            for (var i = 0; i < object.staffPositions.length; ++i) {
                                if (typeof object.staffPositions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffPositionsResponse.staffPositions: object expected");
                                message.staffPositions[i] = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPositions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffPositionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffPositionsResponse} message ListStaffPositionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffPositionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffPositions = [];
                        if (message.staffPositions && message.staffPositions.length) {
                            object.staffPositions = [];
                            for (var j = 0; j < message.staffPositions.length; ++j)
                                object.staffPositions[j] = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPositions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffPositionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffPositionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffPositionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffPositionsResponse;
                })();
    
                v1.CreateStaffPositionRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffPositionRequest
                     * @property {palexy.streaming.v1.IStaffPosition|null} [staffPosition] CreateStaffPositionRequest staffPosition
                     */
    
                    /**
                     * Constructs a new CreateStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffPositionRequest.
                     * @implements ICreateStaffPositionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest=} [properties] Properties to set
                     */
                    function CreateStaffPositionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffPositionRequest staffPosition.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} staffPosition
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @instance
                     */
                    CreateStaffPositionRequest.prototype.staffPosition = null;
    
                    /**
                     * Creates a new CreateStaffPositionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffPositionRequest} CreateStaffPositionRequest instance
                     */
                    CreateStaffPositionRequest.create = function create(properties) {
                        return new CreateStaffPositionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffPositionRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffPositionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest} message CreateStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffPositionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffPosition != null && Object.hasOwnProperty.call(message, "staffPosition"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.staffPosition, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffPositionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffPositionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffPositionRequest} message CreateStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffPositionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffPositionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffPositionRequest} CreateStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffPositionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffPositionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffPosition = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffPositionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffPositionRequest} CreateStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffPositionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffPositionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffPositionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPosition);
                            if (error)
                                return "staffPosition." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffPositionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffPositionRequest} CreateStaffPositionRequest
                     */
                    CreateStaffPositionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffPositionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffPositionRequest();
                        if (object.staffPosition != null) {
                            if (typeof object.staffPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStaffPositionRequest.staffPosition: object expected");
                            message.staffPosition = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPosition);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffPositionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffPositionRequest} message CreateStaffPositionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffPositionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffPosition = null;
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition"))
                            object.staffPosition = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPosition, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffPositionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffPositionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffPositionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffPositionRequest;
                })();
    
                v1.DeleteStaffPositionRequest = (function() {
    
                    /**
                     * Properties of a DeleteStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStaffPositionRequest
                     * @property {number|null} [staffPositionId] DeleteStaffPositionRequest staffPositionId
                     */
    
                    /**
                     * Constructs a new DeleteStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStaffPositionRequest.
                     * @implements IDeleteStaffPositionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest=} [properties] Properties to set
                     */
                    function DeleteStaffPositionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStaffPositionRequest staffPositionId.
                     * @member {number} staffPositionId
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @instance
                     */
                    DeleteStaffPositionRequest.prototype.staffPositionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStaffPositionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStaffPositionRequest} DeleteStaffPositionRequest instance
                     */
                    DeleteStaffPositionRequest.create = function create(properties) {
                        return new DeleteStaffPositionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStaffPositionRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStaffPositionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest} message DeleteStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffPositionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffPositionId != null && Object.hasOwnProperty.call(message, "staffPositionId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffPositionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStaffPositionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStaffPositionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffPositionRequest} message DeleteStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffPositionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStaffPositionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStaffPositionRequest} DeleteStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffPositionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStaffPositionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffPositionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStaffPositionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStaffPositionRequest} DeleteStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffPositionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStaffPositionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStaffPositionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (!$util.isInteger(message.staffPositionId) && !(message.staffPositionId && $util.isInteger(message.staffPositionId.low) && $util.isInteger(message.staffPositionId.high)))
                                return "staffPositionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStaffPositionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStaffPositionRequest} DeleteStaffPositionRequest
                     */
                    DeleteStaffPositionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStaffPositionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStaffPositionRequest();
                        if (object.staffPositionId != null)
                            if ($util.Long)
                                (message.staffPositionId = $util.Long.fromValue(object.staffPositionId)).unsigned = false;
                            else if (typeof object.staffPositionId === "string")
                                message.staffPositionId = parseInt(object.staffPositionId, 10);
                            else if (typeof object.staffPositionId === "number")
                                message.staffPositionId = object.staffPositionId;
                            else if (typeof object.staffPositionId === "object")
                                message.staffPositionId = new $util.LongBits(object.staffPositionId.low >>> 0, object.staffPositionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStaffPositionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStaffPositionRequest} message DeleteStaffPositionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStaffPositionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffPositionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffPositionId = options.longs === String ? "0" : 0;
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (typeof message.staffPositionId === "number")
                                object.staffPositionId = options.longs === String ? String(message.staffPositionId) : message.staffPositionId;
                            else
                                object.staffPositionId = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionId) : options.longs === Number ? new $util.LongBits(message.staffPositionId.low >>> 0, message.staffPositionId.high >>> 0).toNumber() : message.staffPositionId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStaffPositionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStaffPositionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStaffPositionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStaffPositionRequest;
                })();
    
                v1.GetStaffPositionRequest = (function() {
    
                    /**
                     * Properties of a GetStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffPositionRequest
                     * @property {number|null} [staffPositionId] GetStaffPositionRequest staffPositionId
                     */
    
                    /**
                     * Constructs a new GetStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffPositionRequest.
                     * @implements IGetStaffPositionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest=} [properties] Properties to set
                     */
                    function GetStaffPositionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffPositionRequest staffPositionId.
                     * @member {number} staffPositionId
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @instance
                     */
                    GetStaffPositionRequest.prototype.staffPositionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffPositionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffPositionRequest} GetStaffPositionRequest instance
                     */
                    GetStaffPositionRequest.create = function create(properties) {
                        return new GetStaffPositionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffPositionRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffPositionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest} message GetStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffPositionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffPositionId != null && Object.hasOwnProperty.call(message, "staffPositionId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffPositionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffPositionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffPositionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffPositionRequest} message GetStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffPositionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffPositionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffPositionRequest} GetStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffPositionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffPositionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffPositionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffPositionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffPositionRequest} GetStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffPositionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffPositionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffPositionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (!$util.isInteger(message.staffPositionId) && !(message.staffPositionId && $util.isInteger(message.staffPositionId.low) && $util.isInteger(message.staffPositionId.high)))
                                return "staffPositionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffPositionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffPositionRequest} GetStaffPositionRequest
                     */
                    GetStaffPositionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffPositionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffPositionRequest();
                        if (object.staffPositionId != null)
                            if ($util.Long)
                                (message.staffPositionId = $util.Long.fromValue(object.staffPositionId)).unsigned = false;
                            else if (typeof object.staffPositionId === "string")
                                message.staffPositionId = parseInt(object.staffPositionId, 10);
                            else if (typeof object.staffPositionId === "number")
                                message.staffPositionId = object.staffPositionId;
                            else if (typeof object.staffPositionId === "object")
                                message.staffPositionId = new $util.LongBits(object.staffPositionId.low >>> 0, object.staffPositionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffPositionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffPositionRequest} message GetStaffPositionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffPositionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffPositionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffPositionId = options.longs === String ? "0" : 0;
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (typeof message.staffPositionId === "number")
                                object.staffPositionId = options.longs === String ? String(message.staffPositionId) : message.staffPositionId;
                            else
                                object.staffPositionId = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionId) : options.longs === Number ? new $util.LongBits(message.staffPositionId.low >>> 0, message.staffPositionId.high >>> 0).toNumber() : message.staffPositionId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffPositionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffPositionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffPositionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffPositionRequest;
                })();
    
                v1.UpdateStaffPositionRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffPositionRequest
                     * @property {palexy.streaming.v1.IStaffPosition|null} [staffPosition] UpdateStaffPositionRequest staffPosition
                     */
    
                    /**
                     * Constructs a new UpdateStaffPositionRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffPositionRequest.
                     * @implements IUpdateStaffPositionRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest=} [properties] Properties to set
                     */
                    function UpdateStaffPositionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffPositionRequest staffPosition.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} staffPosition
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @instance
                     */
                    UpdateStaffPositionRequest.prototype.staffPosition = null;
    
                    /**
                     * Creates a new UpdateStaffPositionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffPositionRequest} UpdateStaffPositionRequest instance
                     */
                    UpdateStaffPositionRequest.create = function create(properties) {
                        return new UpdateStaffPositionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffPositionRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffPositionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest} message UpdateStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffPositionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffPosition != null && Object.hasOwnProperty.call(message, "staffPosition"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.staffPosition, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffPositionRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffPositionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffPositionRequest} message UpdateStaffPositionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffPositionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffPositionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffPositionRequest} UpdateStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffPositionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffPositionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffPosition = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffPositionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffPositionRequest} UpdateStaffPositionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffPositionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffPositionRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffPositionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPosition);
                            if (error)
                                return "staffPosition." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffPositionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffPositionRequest} UpdateStaffPositionRequest
                     */
                    UpdateStaffPositionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffPositionRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffPositionRequest();
                        if (object.staffPosition != null) {
                            if (typeof object.staffPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffPositionRequest.staffPosition: object expected");
                            message.staffPosition = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPosition);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffPositionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffPositionRequest} message UpdateStaffPositionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffPositionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffPosition = null;
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition"))
                            object.staffPosition = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPosition, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffPositionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffPositionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffPositionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffPositionRequest;
                })();
    
                v1.StaffPosition = (function() {
    
                    /**
                     * Properties of a StaffPosition.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffPosition
                     * @property {number|null} [id] StaffPosition id
                     * @property {number|null} [companyId] StaffPosition companyId
                     * @property {string|null} [name] StaffPosition name
                     * @property {string|null} [description] StaffPosition description
                     * @property {number|null} [createTimeMs] StaffPosition createTimeMs
                     * @property {number|null} [updateTimeMs] StaffPosition updateTimeMs
                     * @property {number|null} [rank] StaffPosition rank
                     * @property {number|null} [defaultAreaId] StaffPosition defaultAreaId
                     * @property {palexy.streaming.v1.IStoreFilter|null} [appliedStores] StaffPosition appliedStores
                     */
    
                    /**
                     * Constructs a new StaffPosition.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffPosition.
                     * @implements IStaffPosition
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffPosition=} [properties] Properties to set
                     */
                    function StaffPosition(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffPosition id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffPosition companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffPosition name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.name = "";
    
                    /**
                     * StaffPosition description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.description = "";
    
                    /**
                     * StaffPosition createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffPosition updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffPosition rank.
                     * @member {number} rank
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.rank = 0;
    
                    /**
                     * StaffPosition defaultAreaId.
                     * @member {number} defaultAreaId
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.defaultAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffPosition appliedStores.
                     * @member {palexy.streaming.v1.IStoreFilter|null|undefined} appliedStores
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    StaffPosition.prototype.appliedStores = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * StaffPosition _appliedStores.
                     * @member {"appliedStores"|undefined} _appliedStores
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     */
                    Object.defineProperty(StaffPosition.prototype, "_appliedStores", {
                        get: $util.oneOfGetter($oneOfFields = ["appliedStores"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new StaffPosition instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffPosition=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffPosition} StaffPosition instance
                     */
                    StaffPosition.create = function create(properties) {
                        return new StaffPosition(properties);
                    };
    
                    /**
                     * Encodes the specified StaffPosition message. Does not implicitly {@link palexy.streaming.v1.StaffPosition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffPosition} message StaffPosition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffPosition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updateTimeMs);
                        if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.rank);
                        if (message.defaultAreaId != null && Object.hasOwnProperty.call(message, "defaultAreaId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.defaultAreaId);
                        if (message.appliedStores != null && Object.hasOwnProperty.call(message, "appliedStores"))
                            $root.palexy.streaming.v1.StoreFilter.encode(message.appliedStores, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffPosition message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffPosition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {palexy.streaming.v1.IStaffPosition} message StaffPosition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffPosition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffPosition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffPosition} StaffPosition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffPosition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffPosition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 7:
                                message.rank = reader.int32();
                                break;
                            case 8:
                                message.defaultAreaId = reader.int64();
                                break;
                            case 9:
                                message.appliedStores = $root.palexy.streaming.v1.StoreFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffPosition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffPosition} StaffPosition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffPosition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffPosition message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffPosition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.rank != null && message.hasOwnProperty("rank"))
                            if (!$util.isInteger(message.rank))
                                return "rank: integer expected";
                        if (message.defaultAreaId != null && message.hasOwnProperty("defaultAreaId"))
                            if (!$util.isInteger(message.defaultAreaId) && !(message.defaultAreaId && $util.isInteger(message.defaultAreaId.low) && $util.isInteger(message.defaultAreaId.high)))
                                return "defaultAreaId: integer|Long expected";
                        if (message.appliedStores != null && message.hasOwnProperty("appliedStores")) {
                            properties._appliedStores = 1;
                            {
                                var error = $root.palexy.streaming.v1.StoreFilter.verify(message.appliedStores);
                                if (error)
                                    return "appliedStores." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffPosition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffPosition} StaffPosition
                     */
                    StaffPosition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffPosition)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffPosition();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.rank != null)
                            message.rank = object.rank | 0;
                        if (object.defaultAreaId != null)
                            if ($util.Long)
                                (message.defaultAreaId = $util.Long.fromValue(object.defaultAreaId)).unsigned = false;
                            else if (typeof object.defaultAreaId === "string")
                                message.defaultAreaId = parseInt(object.defaultAreaId, 10);
                            else if (typeof object.defaultAreaId === "number")
                                message.defaultAreaId = object.defaultAreaId;
                            else if (typeof object.defaultAreaId === "object")
                                message.defaultAreaId = new $util.LongBits(object.defaultAreaId.low >>> 0, object.defaultAreaId.high >>> 0).toNumber();
                        if (object.appliedStores != null) {
                            if (typeof object.appliedStores !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffPosition.appliedStores: object expected");
                            message.appliedStores = $root.palexy.streaming.v1.StoreFilter.fromObject(object.appliedStores);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffPosition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @static
                     * @param {palexy.streaming.v1.StaffPosition} message StaffPosition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffPosition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.rank = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.defaultAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.defaultAreaId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.rank != null && message.hasOwnProperty("rank"))
                            object.rank = message.rank;
                        if (message.defaultAreaId != null && message.hasOwnProperty("defaultAreaId"))
                            if (typeof message.defaultAreaId === "number")
                                object.defaultAreaId = options.longs === String ? String(message.defaultAreaId) : message.defaultAreaId;
                            else
                                object.defaultAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.defaultAreaId) : options.longs === Number ? new $util.LongBits(message.defaultAreaId.low >>> 0, message.defaultAreaId.high >>> 0).toNumber() : message.defaultAreaId;
                        if (message.appliedStores != null && message.hasOwnProperty("appliedStores")) {
                            object.appliedStores = $root.palexy.streaming.v1.StoreFilter.toObject(message.appliedStores, options);
                            if (options.oneofs)
                                object._appliedStores = "appliedStores";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffPosition to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffPosition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffPosition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffPosition;
                })();
    
                v1.ScheduleAreaService = (function() {
    
                    /**
                     * Constructs a new ScheduleAreaService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduleAreaService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ScheduleAreaService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ScheduleAreaService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScheduleAreaService;
    
                    /**
                     * Creates new ScheduleAreaService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ScheduleAreaService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ScheduleAreaService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#getScheduleArea}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef GetScheduleAreaCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ScheduleArea} [response] ScheduleArea
                     */
    
                    /**
                     * Calls GetScheduleArea.
                     * @function getScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest} request GetScheduleAreaRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.GetScheduleAreaCallback} callback Node-style callback called with the error, if any, and ScheduleArea
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.getScheduleArea = function getScheduleArea(request, callback) {
                        return this.rpcCall(getScheduleArea, $root.palexy.streaming.v1.GetScheduleAreaRequest, $root.palexy.streaming.v1.ScheduleArea, request, callback);
                    }, "name", { value: "GetScheduleArea" });
    
                    /**
                     * Calls GetScheduleArea.
                     * @function getScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest} request GetScheduleAreaRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ScheduleArea>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#listScheduleAreas}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef ListScheduleAreasCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListScheduleAreasResponse} [response] ListScheduleAreasResponse
                     */
    
                    /**
                     * Calls ListScheduleAreas.
                     * @function listScheduleAreas
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest} request ListScheduleAreasRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.ListScheduleAreasCallback} callback Node-style callback called with the error, if any, and ListScheduleAreasResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.listScheduleAreas = function listScheduleAreas(request, callback) {
                        return this.rpcCall(listScheduleAreas, $root.palexy.streaming.v1.ListScheduleAreasRequest, $root.palexy.streaming.v1.ListScheduleAreasResponse, request, callback);
                    }, "name", { value: "ListScheduleAreas" });
    
                    /**
                     * Calls ListScheduleAreas.
                     * @function listScheduleAreas
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest} request ListScheduleAreasRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListScheduleAreasResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#createScheduleArea}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef CreateScheduleAreaCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ScheduleArea} [response] ScheduleArea
                     */
    
                    /**
                     * Calls CreateScheduleArea.
                     * @function createScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest} request CreateScheduleAreaRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.CreateScheduleAreaCallback} callback Node-style callback called with the error, if any, and ScheduleArea
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.createScheduleArea = function createScheduleArea(request, callback) {
                        return this.rpcCall(createScheduleArea, $root.palexy.streaming.v1.CreateScheduleAreaRequest, $root.palexy.streaming.v1.ScheduleArea, request, callback);
                    }, "name", { value: "CreateScheduleArea" });
    
                    /**
                     * Calls CreateScheduleArea.
                     * @function createScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest} request CreateScheduleAreaRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ScheduleArea>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#updateScheduleArea}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef UpdateScheduleAreaCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ScheduleArea} [response] ScheduleArea
                     */
    
                    /**
                     * Calls UpdateScheduleArea.
                     * @function updateScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest} request UpdateScheduleAreaRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.UpdateScheduleAreaCallback} callback Node-style callback called with the error, if any, and ScheduleArea
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.updateScheduleArea = function updateScheduleArea(request, callback) {
                        return this.rpcCall(updateScheduleArea, $root.palexy.streaming.v1.UpdateScheduleAreaRequest, $root.palexy.streaming.v1.ScheduleArea, request, callback);
                    }, "name", { value: "UpdateScheduleArea" });
    
                    /**
                     * Calls UpdateScheduleArea.
                     * @function updateScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest} request UpdateScheduleAreaRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ScheduleArea>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#deleteScheduleArea}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef DeleteScheduleAreaCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteScheduleArea.
                     * @function deleteScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest} request DeleteScheduleAreaRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.DeleteScheduleAreaCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.deleteScheduleArea = function deleteScheduleArea(request, callback) {
                        return this.rpcCall(deleteScheduleArea, $root.palexy.streaming.v1.DeleteScheduleAreaRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteScheduleArea" });
    
                    /**
                     * Calls DeleteScheduleArea.
                     * @function deleteScheduleArea
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest} request DeleteScheduleAreaRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#listScheduleAreaMappings}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef ListScheduleAreaMappingsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListScheduleAreaMappingsResponse} [response] ListScheduleAreaMappingsResponse
                     */
    
                    /**
                     * Calls ListScheduleAreaMappings.
                     * @function listScheduleAreaMappings
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest} request ListScheduleAreaMappingsRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.ListScheduleAreaMappingsCallback} callback Node-style callback called with the error, if any, and ListScheduleAreaMappingsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.listScheduleAreaMappings = function listScheduleAreaMappings(request, callback) {
                        return this.rpcCall(listScheduleAreaMappings, $root.palexy.streaming.v1.ListScheduleAreaMappingsRequest, $root.palexy.streaming.v1.ListScheduleAreaMappingsResponse, request, callback);
                    }, "name", { value: "ListScheduleAreaMappings" });
    
                    /**
                     * Calls ListScheduleAreaMappings.
                     * @function listScheduleAreaMappings
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest} request ListScheduleAreaMappingsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListScheduleAreaMappingsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleAreaService#batchEditScheduleAreaMappings}.
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @typedef BatchEditScheduleAreaMappingsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} [response] BatchEditScheduleAreaMappingsResponse
                     */
    
                    /**
                     * Calls BatchEditScheduleAreaMappings.
                     * @function batchEditScheduleAreaMappings
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest} request BatchEditScheduleAreaMappingsRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleAreaService.BatchEditScheduleAreaMappingsCallback} callback Node-style callback called with the error, if any, and BatchEditScheduleAreaMappingsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleAreaService.prototype.batchEditScheduleAreaMappings = function batchEditScheduleAreaMappings(request, callback) {
                        return this.rpcCall(batchEditScheduleAreaMappings, $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest, $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse, request, callback);
                    }, "name", { value: "BatchEditScheduleAreaMappings" });
    
                    /**
                     * Calls BatchEditScheduleAreaMappings.
                     * @function batchEditScheduleAreaMappings
                     * @memberof palexy.streaming.v1.ScheduleAreaService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest} request BatchEditScheduleAreaMappingsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse>} Promise
                     * @variation 2
                     */
    
                    return ScheduleAreaService;
                })();
    
                v1.ListScheduleAreasRequest = (function() {
    
                    /**
                     * Properties of a ListScheduleAreasRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduleAreasRequest
                     * @property {number|null} [companyId] ListScheduleAreasRequest companyId
                     * @property {number|null} [storeId] ListScheduleAreasRequest storeId
                     */
    
                    /**
                     * Constructs a new ListScheduleAreasRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduleAreasRequest.
                     * @implements IListScheduleAreasRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest=} [properties] Properties to set
                     */
                    function ListScheduleAreasRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduleAreasRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @instance
                     */
                    ListScheduleAreasRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListScheduleAreasRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @instance
                     */
                    ListScheduleAreasRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListScheduleAreasRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduleAreasRequest} ListScheduleAreasRequest instance
                     */
                    ListScheduleAreasRequest.create = function create(properties) {
                        return new ListScheduleAreasRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreasRequest message. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreasRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest} message ListScheduleAreasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreasRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreasRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreasRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasRequest} message ListScheduleAreasRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreasRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduleAreasRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduleAreasRequest} ListScheduleAreasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreasRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduleAreasRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduleAreasRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduleAreasRequest} ListScheduleAreasRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreasRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduleAreasRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduleAreasRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduleAreasRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduleAreasRequest} ListScheduleAreasRequest
                     */
                    ListScheduleAreasRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduleAreasRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduleAreasRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduleAreasRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @static
                     * @param {palexy.streaming.v1.ListScheduleAreasRequest} message ListScheduleAreasRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduleAreasRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduleAreasRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduleAreasRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduleAreasRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduleAreasRequest;
                })();
    
                v1.ListScheduleAreasResponse = (function() {
    
                    /**
                     * Properties of a ListScheduleAreasResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduleAreasResponse
                     * @property {Array.<palexy.streaming.v1.IScheduleArea>|null} [scheduleAreas] ListScheduleAreasResponse scheduleAreas
                     */
    
                    /**
                     * Constructs a new ListScheduleAreasResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduleAreasResponse.
                     * @implements IListScheduleAreasResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduleAreasResponse=} [properties] Properties to set
                     */
                    function ListScheduleAreasResponse(properties) {
                        this.scheduleAreas = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduleAreasResponse scheduleAreas.
                     * @member {Array.<palexy.streaming.v1.IScheduleArea>} scheduleAreas
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @instance
                     */
                    ListScheduleAreasResponse.prototype.scheduleAreas = $util.emptyArray;
    
                    /**
                     * Creates a new ListScheduleAreasResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduleAreasResponse} ListScheduleAreasResponse instance
                     */
                    ListScheduleAreasResponse.create = function create(properties) {
                        return new ListScheduleAreasResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreasResponse message. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreasResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasResponse} message ListScheduleAreasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreasResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleAreas != null && message.scheduleAreas.length)
                            for (var i = 0; i < message.scheduleAreas.length; ++i)
                                $root.palexy.streaming.v1.ScheduleArea.encode(message.scheduleAreas[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreasResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreasResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreasResponse} message ListScheduleAreasResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreasResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduleAreasResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduleAreasResponse} ListScheduleAreasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreasResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduleAreasResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.scheduleAreas && message.scheduleAreas.length))
                                    message.scheduleAreas = [];
                                message.scheduleAreas.push($root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduleAreasResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduleAreasResponse} ListScheduleAreasResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreasResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduleAreasResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduleAreasResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleAreas != null && message.hasOwnProperty("scheduleAreas")) {
                            if (!Array.isArray(message.scheduleAreas))
                                return "scheduleAreas: array expected";
                            for (var i = 0; i < message.scheduleAreas.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.scheduleAreas[i]);
                                if (error)
                                    return "scheduleAreas." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduleAreasResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduleAreasResponse} ListScheduleAreasResponse
                     */
                    ListScheduleAreasResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduleAreasResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduleAreasResponse();
                        if (object.scheduleAreas) {
                            if (!Array.isArray(object.scheduleAreas))
                                throw TypeError(".palexy.streaming.v1.ListScheduleAreasResponse.scheduleAreas: array expected");
                            message.scheduleAreas = [];
                            for (var i = 0; i < object.scheduleAreas.length; ++i) {
                                if (typeof object.scheduleAreas[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListScheduleAreasResponse.scheduleAreas: object expected");
                                message.scheduleAreas[i] = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.scheduleAreas[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduleAreasResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @static
                     * @param {palexy.streaming.v1.ListScheduleAreasResponse} message ListScheduleAreasResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduleAreasResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.scheduleAreas = [];
                        if (message.scheduleAreas && message.scheduleAreas.length) {
                            object.scheduleAreas = [];
                            for (var j = 0; j < message.scheduleAreas.length; ++j)
                                object.scheduleAreas[j] = $root.palexy.streaming.v1.ScheduleArea.toObject(message.scheduleAreas[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduleAreasResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduleAreasResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduleAreasResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduleAreasResponse;
                })();
    
                v1.CreateScheduleAreaRequest = (function() {
    
                    /**
                     * Properties of a CreateScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateScheduleAreaRequest
                     * @property {palexy.streaming.v1.IScheduleArea|null} [scheduleArea] CreateScheduleAreaRequest scheduleArea
                     */
    
                    /**
                     * Constructs a new CreateScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateScheduleAreaRequest.
                     * @implements ICreateScheduleAreaRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest=} [properties] Properties to set
                     */
                    function CreateScheduleAreaRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateScheduleAreaRequest scheduleArea.
                     * @member {palexy.streaming.v1.IScheduleArea|null|undefined} scheduleArea
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @instance
                     */
                    CreateScheduleAreaRequest.prototype.scheduleArea = null;
    
                    /**
                     * Creates a new CreateScheduleAreaRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateScheduleAreaRequest} CreateScheduleAreaRequest instance
                     */
                    CreateScheduleAreaRequest.create = function create(properties) {
                        return new CreateScheduleAreaRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateScheduleAreaRequest message. Does not implicitly {@link palexy.streaming.v1.CreateScheduleAreaRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest} message CreateScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScheduleAreaRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleArea != null && Object.hasOwnProperty.call(message, "scheduleArea"))
                            $root.palexy.streaming.v1.ScheduleArea.encode(message.scheduleArea, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateScheduleAreaRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateScheduleAreaRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateScheduleAreaRequest} message CreateScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateScheduleAreaRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateScheduleAreaRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateScheduleAreaRequest} CreateScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScheduleAreaRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateScheduleAreaRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateScheduleAreaRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateScheduleAreaRequest} CreateScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateScheduleAreaRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateScheduleAreaRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateScheduleAreaRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea")) {
                            var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.scheduleArea);
                            if (error)
                                return "scheduleArea." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateScheduleAreaRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateScheduleAreaRequest} CreateScheduleAreaRequest
                     */
                    CreateScheduleAreaRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateScheduleAreaRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateScheduleAreaRequest();
                        if (object.scheduleArea != null) {
                            if (typeof object.scheduleArea !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateScheduleAreaRequest.scheduleArea: object expected");
                            message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.scheduleArea);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateScheduleAreaRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateScheduleAreaRequest} message CreateScheduleAreaRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateScheduleAreaRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.scheduleArea = null;
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea"))
                            object.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.toObject(message.scheduleArea, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateScheduleAreaRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateScheduleAreaRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateScheduleAreaRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateScheduleAreaRequest;
                })();
    
                v1.DeleteScheduleAreaRequest = (function() {
    
                    /**
                     * Properties of a DeleteScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteScheduleAreaRequest
                     * @property {number|null} [scheduleAreaId] DeleteScheduleAreaRequest scheduleAreaId
                     */
    
                    /**
                     * Constructs a new DeleteScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteScheduleAreaRequest.
                     * @implements IDeleteScheduleAreaRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest=} [properties] Properties to set
                     */
                    function DeleteScheduleAreaRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteScheduleAreaRequest scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @instance
                     */
                    DeleteScheduleAreaRequest.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteScheduleAreaRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteScheduleAreaRequest} DeleteScheduleAreaRequest instance
                     */
                    DeleteScheduleAreaRequest.create = function create(properties) {
                        return new DeleteScheduleAreaRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteScheduleAreaRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteScheduleAreaRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest} message DeleteScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteScheduleAreaRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.scheduleAreaId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteScheduleAreaRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteScheduleAreaRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteScheduleAreaRequest} message DeleteScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteScheduleAreaRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteScheduleAreaRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteScheduleAreaRequest} DeleteScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteScheduleAreaRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteScheduleAreaRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleAreaId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteScheduleAreaRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteScheduleAreaRequest} DeleteScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteScheduleAreaRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteScheduleAreaRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteScheduleAreaRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteScheduleAreaRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteScheduleAreaRequest} DeleteScheduleAreaRequest
                     */
                    DeleteScheduleAreaRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteScheduleAreaRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteScheduleAreaRequest();
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteScheduleAreaRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteScheduleAreaRequest} message DeleteScheduleAreaRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteScheduleAreaRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteScheduleAreaRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteScheduleAreaRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteScheduleAreaRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteScheduleAreaRequest;
                })();
    
                v1.GetScheduleAreaRequest = (function() {
    
                    /**
                     * Properties of a GetScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetScheduleAreaRequest
                     * @property {number|null} [scheduleAreaId] GetScheduleAreaRequest scheduleAreaId
                     */
    
                    /**
                     * Constructs a new GetScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetScheduleAreaRequest.
                     * @implements IGetScheduleAreaRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest=} [properties] Properties to set
                     */
                    function GetScheduleAreaRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetScheduleAreaRequest scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @instance
                     */
                    GetScheduleAreaRequest.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetScheduleAreaRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetScheduleAreaRequest} GetScheduleAreaRequest instance
                     */
                    GetScheduleAreaRequest.create = function create(properties) {
                        return new GetScheduleAreaRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetScheduleAreaRequest message. Does not implicitly {@link palexy.streaming.v1.GetScheduleAreaRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest} message GetScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduleAreaRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.scheduleAreaId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetScheduleAreaRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetScheduleAreaRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetScheduleAreaRequest} message GetScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetScheduleAreaRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetScheduleAreaRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetScheduleAreaRequest} GetScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduleAreaRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetScheduleAreaRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleAreaId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetScheduleAreaRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetScheduleAreaRequest} GetScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetScheduleAreaRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetScheduleAreaRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetScheduleAreaRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetScheduleAreaRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetScheduleAreaRequest} GetScheduleAreaRequest
                     */
                    GetScheduleAreaRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetScheduleAreaRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetScheduleAreaRequest();
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetScheduleAreaRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.GetScheduleAreaRequest} message GetScheduleAreaRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetScheduleAreaRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        return object;
                    };
    
                    /**
                     * Converts this GetScheduleAreaRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetScheduleAreaRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetScheduleAreaRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetScheduleAreaRequest;
                })();
    
                v1.UpdateScheduleAreaRequest = (function() {
    
                    /**
                     * Properties of an UpdateScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateScheduleAreaRequest
                     * @property {palexy.streaming.v1.IScheduleArea|null} [scheduleArea] UpdateScheduleAreaRequest scheduleArea
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateScheduleAreaRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateScheduleAreaRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateScheduleAreaRequest.
                     * @implements IUpdateScheduleAreaRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest=} [properties] Properties to set
                     */
                    function UpdateScheduleAreaRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateScheduleAreaRequest scheduleArea.
                     * @member {palexy.streaming.v1.IScheduleArea|null|undefined} scheduleArea
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @instance
                     */
                    UpdateScheduleAreaRequest.prototype.scheduleArea = null;
    
                    /**
                     * UpdateScheduleAreaRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @instance
                     */
                    UpdateScheduleAreaRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateScheduleAreaRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateScheduleAreaRequest} UpdateScheduleAreaRequest instance
                     */
                    UpdateScheduleAreaRequest.create = function create(properties) {
                        return new UpdateScheduleAreaRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateScheduleAreaRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateScheduleAreaRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest} message UpdateScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateScheduleAreaRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleArea != null && Object.hasOwnProperty.call(message, "scheduleArea"))
                            $root.palexy.streaming.v1.ScheduleArea.encode(message.scheduleArea, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateScheduleAreaRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateScheduleAreaRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateScheduleAreaRequest} message UpdateScheduleAreaRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateScheduleAreaRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateScheduleAreaRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateScheduleAreaRequest} UpdateScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateScheduleAreaRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateScheduleAreaRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateScheduleAreaRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateScheduleAreaRequest} UpdateScheduleAreaRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateScheduleAreaRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateScheduleAreaRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateScheduleAreaRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea")) {
                            var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.scheduleArea);
                            if (error)
                                return "scheduleArea." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateScheduleAreaRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateScheduleAreaRequest} UpdateScheduleAreaRequest
                     */
                    UpdateScheduleAreaRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateScheduleAreaRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateScheduleAreaRequest();
                        if (object.scheduleArea != null) {
                            if (typeof object.scheduleArea !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateScheduleAreaRequest.scheduleArea: object expected");
                            message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.scheduleArea);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateScheduleAreaRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateScheduleAreaRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateScheduleAreaRequest} message UpdateScheduleAreaRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateScheduleAreaRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.scheduleArea = null;
                            object.updateMask = null;
                        }
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea"))
                            object.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.toObject(message.scheduleArea, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateScheduleAreaRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateScheduleAreaRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateScheduleAreaRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateScheduleAreaRequest;
                })();
    
                v1.StoreFilter = (function() {
    
                    /**
                     * Properties of a StoreFilter.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreFilter
                     * @property {palexy.streaming.v1.StoreFilter.Mode|null} [mode] StoreFilter mode
                     * @property {Array.<number>|null} [ids] StoreFilter ids
                     * @property {Array.<number>|null} [excludedIds] StoreFilter excludedIds
                     */
    
                    /**
                     * Constructs a new StoreFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreFilter.
                     * @implements IStoreFilter
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreFilter=} [properties] Properties to set
                     */
                    function StoreFilter(properties) {
                        this.ids = [];
                        this.excludedIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreFilter mode.
                     * @member {palexy.streaming.v1.StoreFilter.Mode} mode
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @instance
                     */
                    StoreFilter.prototype.mode = 0;
    
                    /**
                     * StoreFilter ids.
                     * @member {Array.<number>} ids
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @instance
                     */
                    StoreFilter.prototype.ids = $util.emptyArray;
    
                    /**
                     * StoreFilter excludedIds.
                     * @member {Array.<number>} excludedIds
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @instance
                     */
                    StoreFilter.prototype.excludedIds = $util.emptyArray;
    
                    /**
                     * Creates a new StoreFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {palexy.streaming.v1.IStoreFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreFilter} StoreFilter instance
                     */
                    StoreFilter.create = function create(properties) {
                        return new StoreFilter(properties);
                    };
    
                    /**
                     * Encodes the specified StoreFilter message. Does not implicitly {@link palexy.streaming.v1.StoreFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {palexy.streaming.v1.IStoreFilter} message StoreFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
                        if (message.ids != null && message.ids.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.ids.length; ++i)
                                writer.int64(message.ids[i]);
                            writer.ldelim();
                        }
                        if (message.excludedIds != null && message.excludedIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.excludedIds.length; ++i)
                                writer.int64(message.excludedIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {palexy.streaming.v1.IStoreFilter} message StoreFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreFilter} StoreFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mode = reader.int32();
                                break;
                            case 2:
                                if (!(message.ids && message.ids.length))
                                    message.ids = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ids.push(reader.int64());
                                } else
                                    message.ids.push(reader.int64());
                                break;
                            case 3:
                                if (!(message.excludedIds && message.excludedIds.length))
                                    message.excludedIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.excludedIds.push(reader.int64());
                                } else
                                    message.excludedIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreFilter} StoreFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            switch (message.mode) {
                            default:
                                return "mode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.ids != null && message.hasOwnProperty("ids")) {
                            if (!Array.isArray(message.ids))
                                return "ids: array expected";
                            for (var i = 0; i < message.ids.length; ++i)
                                if (!$util.isInteger(message.ids[i]) && !(message.ids[i] && $util.isInteger(message.ids[i].low) && $util.isInteger(message.ids[i].high)))
                                    return "ids: integer|Long[] expected";
                        }
                        if (message.excludedIds != null && message.hasOwnProperty("excludedIds")) {
                            if (!Array.isArray(message.excludedIds))
                                return "excludedIds: array expected";
                            for (var i = 0; i < message.excludedIds.length; ++i)
                                if (!$util.isInteger(message.excludedIds[i]) && !(message.excludedIds[i] && $util.isInteger(message.excludedIds[i].low) && $util.isInteger(message.excludedIds[i].high)))
                                    return "excludedIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreFilter} StoreFilter
                     */
                    StoreFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreFilter();
                        switch (object.mode) {
                        case "UNKNOWN":
                        case 0:
                            message.mode = 0;
                            break;
                        case "ALL":
                        case 1:
                            message.mode = 1;
                            break;
                        case "STORES":
                        case 2:
                            message.mode = 2;
                            break;
                        }
                        if (object.ids) {
                            if (!Array.isArray(object.ids))
                                throw TypeError(".palexy.streaming.v1.StoreFilter.ids: array expected");
                            message.ids = [];
                            for (var i = 0; i < object.ids.length; ++i)
                                if ($util.Long)
                                    (message.ids[i] = $util.Long.fromValue(object.ids[i])).unsigned = false;
                                else if (typeof object.ids[i] === "string")
                                    message.ids[i] = parseInt(object.ids[i], 10);
                                else if (typeof object.ids[i] === "number")
                                    message.ids[i] = object.ids[i];
                                else if (typeof object.ids[i] === "object")
                                    message.ids[i] = new $util.LongBits(object.ids[i].low >>> 0, object.ids[i].high >>> 0).toNumber();
                        }
                        if (object.excludedIds) {
                            if (!Array.isArray(object.excludedIds))
                                throw TypeError(".palexy.streaming.v1.StoreFilter.excludedIds: array expected");
                            message.excludedIds = [];
                            for (var i = 0; i < object.excludedIds.length; ++i)
                                if ($util.Long)
                                    (message.excludedIds[i] = $util.Long.fromValue(object.excludedIds[i])).unsigned = false;
                                else if (typeof object.excludedIds[i] === "string")
                                    message.excludedIds[i] = parseInt(object.excludedIds[i], 10);
                                else if (typeof object.excludedIds[i] === "number")
                                    message.excludedIds[i] = object.excludedIds[i];
                                else if (typeof object.excludedIds[i] === "object")
                                    message.excludedIds[i] = new $util.LongBits(object.excludedIds[i].low >>> 0, object.excludedIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @static
                     * @param {palexy.streaming.v1.StoreFilter} message StoreFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.ids = [];
                            object.excludedIds = [];
                        }
                        if (options.defaults)
                            object.mode = options.enums === String ? "UNKNOWN" : 0;
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            object.mode = options.enums === String ? $root.palexy.streaming.v1.StoreFilter.Mode[message.mode] : message.mode;
                        if (message.ids && message.ids.length) {
                            object.ids = [];
                            for (var j = 0; j < message.ids.length; ++j)
                                if (typeof message.ids[j] === "number")
                                    object.ids[j] = options.longs === String ? String(message.ids[j]) : message.ids[j];
                                else
                                    object.ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ids[j]) : options.longs === Number ? new $util.LongBits(message.ids[j].low >>> 0, message.ids[j].high >>> 0).toNumber() : message.ids[j];
                        }
                        if (message.excludedIds && message.excludedIds.length) {
                            object.excludedIds = [];
                            for (var j = 0; j < message.excludedIds.length; ++j)
                                if (typeof message.excludedIds[j] === "number")
                                    object.excludedIds[j] = options.longs === String ? String(message.excludedIds[j]) : message.excludedIds[j];
                                else
                                    object.excludedIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.excludedIds[j]) : options.longs === Number ? new $util.LongBits(message.excludedIds[j].low >>> 0, message.excludedIds[j].high >>> 0).toNumber() : message.excludedIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Mode enum.
                     * @name palexy.streaming.v1.StoreFilter.Mode
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} ALL=1 ALL value
                     * @property {number} STORES=2 STORES value
                     */
                    StoreFilter.Mode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "ALL"] = 1;
                        values[valuesById[2] = "STORES"] = 2;
                        return values;
                    })();
    
                    return StoreFilter;
                })();
    
                v1.ScheduleArea = (function() {
    
                    /**
                     * Properties of a ScheduleArea.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduleArea
                     * @property {number|null} [id] ScheduleArea id
                     * @property {number|null} [companyId] ScheduleArea companyId
                     * @property {string|null} [areaName] ScheduleArea areaName
                     * @property {string|null} [color] ScheduleArea color
                     * @property {number|null} [rank] ScheduleArea rank
                     * @property {number|null} [createTimeMs] ScheduleArea createTimeMs
                     * @property {number|null} [updateTimeMs] ScheduleArea updateTimeMs
                     * @property {palexy.streaming.v1.IStoreFilter|null} [appliedStores] ScheduleArea appliedStores
                     */
    
                    /**
                     * Constructs a new ScheduleArea.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduleArea.
                     * @implements IScheduleArea
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduleArea=} [properties] Properties to set
                     */
                    function ScheduleArea(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduleArea id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleArea companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleArea areaName.
                     * @member {string} areaName
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.areaName = "";
    
                    /**
                     * ScheduleArea color.
                     * @member {string} color
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.color = "";
    
                    /**
                     * ScheduleArea rank.
                     * @member {number} rank
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.rank = 0;
    
                    /**
                     * ScheduleArea createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleArea updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleArea appliedStores.
                     * @member {palexy.streaming.v1.IStoreFilter|null|undefined} appliedStores
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     */
                    ScheduleArea.prototype.appliedStores = null;
    
                    /**
                     * Creates a new ScheduleArea instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {palexy.streaming.v1.IScheduleArea=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduleArea} ScheduleArea instance
                     */
                    ScheduleArea.create = function create(properties) {
                        return new ScheduleArea(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduleArea message. Does not implicitly {@link palexy.streaming.v1.ScheduleArea.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {palexy.streaming.v1.IScheduleArea} message ScheduleArea message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleArea.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.areaName != null && Object.hasOwnProperty.call(message, "areaName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.areaName);
                        if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.color);
                        if (message.rank != null && Object.hasOwnProperty.call(message, "rank"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.rank);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updateTimeMs);
                        if (message.appliedStores != null && Object.hasOwnProperty.call(message, "appliedStores"))
                            $root.palexy.streaming.v1.StoreFilter.encode(message.appliedStores, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduleArea message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduleArea.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {palexy.streaming.v1.IScheduleArea} message ScheduleArea message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleArea.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduleArea message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduleArea} ScheduleArea
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleArea.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduleArea();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.areaName = reader.string();
                                break;
                            case 4:
                                message.color = reader.string();
                                break;
                            case 5:
                                message.rank = reader.int32();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.appliedStores = $root.palexy.streaming.v1.StoreFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduleArea message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduleArea} ScheduleArea
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleArea.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduleArea message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduleArea.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.areaName != null && message.hasOwnProperty("areaName"))
                            if (!$util.isString(message.areaName))
                                return "areaName: string expected";
                        if (message.color != null && message.hasOwnProperty("color"))
                            if (!$util.isString(message.color))
                                return "color: string expected";
                        if (message.rank != null && message.hasOwnProperty("rank"))
                            if (!$util.isInteger(message.rank))
                                return "rank: integer expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.appliedStores != null && message.hasOwnProperty("appliedStores")) {
                            var error = $root.palexy.streaming.v1.StoreFilter.verify(message.appliedStores);
                            if (error)
                                return "appliedStores." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScheduleArea message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduleArea} ScheduleArea
                     */
                    ScheduleArea.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduleArea)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduleArea();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.areaName != null)
                            message.areaName = String(object.areaName);
                        if (object.color != null)
                            message.color = String(object.color);
                        if (object.rank != null)
                            message.rank = object.rank | 0;
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.appliedStores != null) {
                            if (typeof object.appliedStores !== "object")
                                throw TypeError(".palexy.streaming.v1.ScheduleArea.appliedStores: object expected");
                            message.appliedStores = $root.palexy.streaming.v1.StoreFilter.fromObject(object.appliedStores);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduleArea message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @static
                     * @param {palexy.streaming.v1.ScheduleArea} message ScheduleArea
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduleArea.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.areaName = "";
                            object.color = "";
                            object.rank = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.appliedStores = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.areaName != null && message.hasOwnProperty("areaName"))
                            object.areaName = message.areaName;
                        if (message.color != null && message.hasOwnProperty("color"))
                            object.color = message.color;
                        if (message.rank != null && message.hasOwnProperty("rank"))
                            object.rank = message.rank;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.appliedStores != null && message.hasOwnProperty("appliedStores"))
                            object.appliedStores = $root.palexy.streaming.v1.StoreFilter.toObject(message.appliedStores, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScheduleArea to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduleArea
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduleArea.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduleArea;
                })();
    
                v1.ScheduleAreaMapping = (function() {
    
                    /**
                     * Properties of a ScheduleAreaMapping.
                     * @memberof palexy.streaming.v1
                     * @interface IScheduleAreaMapping
                     * @property {number|null} [id] ScheduleAreaMapping id
                     * @property {number|null} [scheduleAreaId] ScheduleAreaMapping scheduleAreaId
                     * @property {number|null} [metadataValueId] ScheduleAreaMapping metadataValueId
                     * @property {number|null} [createTimeMs] ScheduleAreaMapping createTimeMs
                     * @property {number|null} [updateTimeMs] ScheduleAreaMapping updateTimeMs
                     */
    
                    /**
                     * Constructs a new ScheduleAreaMapping.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduleAreaMapping.
                     * @implements IScheduleAreaMapping
                     * @constructor
                     * @param {palexy.streaming.v1.IScheduleAreaMapping=} [properties] Properties to set
                     */
                    function ScheduleAreaMapping(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduleAreaMapping id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     */
                    ScheduleAreaMapping.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleAreaMapping scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     */
                    ScheduleAreaMapping.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleAreaMapping metadataValueId.
                     * @member {number} metadataValueId
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     */
                    ScheduleAreaMapping.prototype.metadataValueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleAreaMapping createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     */
                    ScheduleAreaMapping.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ScheduleAreaMapping updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     */
                    ScheduleAreaMapping.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ScheduleAreaMapping instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {palexy.streaming.v1.IScheduleAreaMapping=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ScheduleAreaMapping} ScheduleAreaMapping instance
                     */
                    ScheduleAreaMapping.create = function create(properties) {
                        return new ScheduleAreaMapping(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduleAreaMapping message. Does not implicitly {@link palexy.streaming.v1.ScheduleAreaMapping.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {palexy.streaming.v1.IScheduleAreaMapping} message ScheduleAreaMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleAreaMapping.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.scheduleAreaId);
                        if (message.metadataValueId != null && Object.hasOwnProperty.call(message, "metadataValueId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.metadataValueId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduleAreaMapping message, length delimited. Does not implicitly {@link palexy.streaming.v1.ScheduleAreaMapping.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {palexy.streaming.v1.IScheduleAreaMapping} message ScheduleAreaMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleAreaMapping.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduleAreaMapping message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ScheduleAreaMapping} ScheduleAreaMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleAreaMapping.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ScheduleAreaMapping();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.scheduleAreaId = reader.int64();
                                break;
                            case 3:
                                message.metadataValueId = reader.int64();
                                break;
                            case 4:
                                message.createTimeMs = reader.int64();
                                break;
                            case 5:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduleAreaMapping message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ScheduleAreaMapping} ScheduleAreaMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleAreaMapping.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduleAreaMapping message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduleAreaMapping.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (!$util.isInteger(message.metadataValueId) && !(message.metadataValueId && $util.isInteger(message.metadataValueId.low) && $util.isInteger(message.metadataValueId.high)))
                                return "metadataValueId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ScheduleAreaMapping message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ScheduleAreaMapping} ScheduleAreaMapping
                     */
                    ScheduleAreaMapping.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ScheduleAreaMapping)
                            return object;
                        var message = new $root.palexy.streaming.v1.ScheduleAreaMapping();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        if (object.metadataValueId != null)
                            if ($util.Long)
                                (message.metadataValueId = $util.Long.fromValue(object.metadataValueId)).unsigned = false;
                            else if (typeof object.metadataValueId === "string")
                                message.metadataValueId = parseInt(object.metadataValueId, 10);
                            else if (typeof object.metadataValueId === "number")
                                message.metadataValueId = object.metadataValueId;
                            else if (typeof object.metadataValueId === "object")
                                message.metadataValueId = new $util.LongBits(object.metadataValueId.low >>> 0, object.metadataValueId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduleAreaMapping message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @static
                     * @param {palexy.streaming.v1.ScheduleAreaMapping} message ScheduleAreaMapping
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduleAreaMapping.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataValueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataValueId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        if (message.metadataValueId != null && message.hasOwnProperty("metadataValueId"))
                            if (typeof message.metadataValueId === "number")
                                object.metadataValueId = options.longs === String ? String(message.metadataValueId) : message.metadataValueId;
                            else
                                object.metadataValueId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataValueId) : options.longs === Number ? new $util.LongBits(message.metadataValueId.low >>> 0, message.metadataValueId.high >>> 0).toNumber() : message.metadataValueId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ScheduleAreaMapping to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ScheduleAreaMapping
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduleAreaMapping.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduleAreaMapping;
                })();
    
                v1.ListScheduleAreaMappingsRequest = (function() {
    
                    /**
                     * Properties of a ListScheduleAreaMappingsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduleAreaMappingsRequest
                     * @property {number|null} [companyId] ListScheduleAreaMappingsRequest companyId
                     */
    
                    /**
                     * Constructs a new ListScheduleAreaMappingsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduleAreaMappingsRequest.
                     * @implements IListScheduleAreaMappingsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest=} [properties] Properties to set
                     */
                    function ListScheduleAreaMappingsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduleAreaMappingsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @instance
                     */
                    ListScheduleAreaMappingsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListScheduleAreaMappingsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsRequest} ListScheduleAreaMappingsRequest instance
                     */
                    ListScheduleAreaMappingsRequest.create = function create(properties) {
                        return new ListScheduleAreaMappingsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreaMappingsRequest message. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreaMappingsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest} message ListScheduleAreaMappingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreaMappingsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreaMappingsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreaMappingsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsRequest} message ListScheduleAreaMappingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreaMappingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduleAreaMappingsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsRequest} ListScheduleAreaMappingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreaMappingsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduleAreaMappingsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduleAreaMappingsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsRequest} ListScheduleAreaMappingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreaMappingsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduleAreaMappingsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduleAreaMappingsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduleAreaMappingsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsRequest} ListScheduleAreaMappingsRequest
                     */
                    ListScheduleAreaMappingsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduleAreaMappingsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduleAreaMappingsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduleAreaMappingsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListScheduleAreaMappingsRequest} message ListScheduleAreaMappingsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduleAreaMappingsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduleAreaMappingsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduleAreaMappingsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduleAreaMappingsRequest;
                })();
    
                v1.ListScheduleAreaMappingsResponse = (function() {
    
                    /**
                     * Properties of a ListScheduleAreaMappingsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListScheduleAreaMappingsResponse
                     * @property {Array.<palexy.streaming.v1.IScheduleAreaMapping>|null} [scheduleAreaMappings] ListScheduleAreaMappingsResponse scheduleAreaMappings
                     */
    
                    /**
                     * Constructs a new ListScheduleAreaMappingsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListScheduleAreaMappingsResponse.
                     * @implements IListScheduleAreaMappingsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsResponse=} [properties] Properties to set
                     */
                    function ListScheduleAreaMappingsResponse(properties) {
                        this.scheduleAreaMappings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListScheduleAreaMappingsResponse scheduleAreaMappings.
                     * @member {Array.<palexy.streaming.v1.IScheduleAreaMapping>} scheduleAreaMappings
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @instance
                     */
                    ListScheduleAreaMappingsResponse.prototype.scheduleAreaMappings = $util.emptyArray;
    
                    /**
                     * Creates a new ListScheduleAreaMappingsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsResponse} ListScheduleAreaMappingsResponse instance
                     */
                    ListScheduleAreaMappingsResponse.create = function create(properties) {
                        return new ListScheduleAreaMappingsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreaMappingsResponse message. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreaMappingsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsResponse} message ListScheduleAreaMappingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreaMappingsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleAreaMappings != null && message.scheduleAreaMappings.length)
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i)
                                $root.palexy.streaming.v1.ScheduleAreaMapping.encode(message.scheduleAreaMappings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListScheduleAreaMappingsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListScheduleAreaMappingsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListScheduleAreaMappingsResponse} message ListScheduleAreaMappingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListScheduleAreaMappingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListScheduleAreaMappingsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsResponse} ListScheduleAreaMappingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreaMappingsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListScheduleAreaMappingsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.scheduleAreaMappings && message.scheduleAreaMappings.length))
                                    message.scheduleAreaMappings = [];
                                message.scheduleAreaMappings.push($root.palexy.streaming.v1.ScheduleAreaMapping.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListScheduleAreaMappingsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsResponse} ListScheduleAreaMappingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListScheduleAreaMappingsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListScheduleAreaMappingsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListScheduleAreaMappingsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleAreaMappings != null && message.hasOwnProperty("scheduleAreaMappings")) {
                            if (!Array.isArray(message.scheduleAreaMappings))
                                return "scheduleAreaMappings: array expected";
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduleAreaMapping.verify(message.scheduleAreaMappings[i]);
                                if (error)
                                    return "scheduleAreaMappings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListScheduleAreaMappingsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListScheduleAreaMappingsResponse} ListScheduleAreaMappingsResponse
                     */
                    ListScheduleAreaMappingsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListScheduleAreaMappingsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListScheduleAreaMappingsResponse();
                        if (object.scheduleAreaMappings) {
                            if (!Array.isArray(object.scheduleAreaMappings))
                                throw TypeError(".palexy.streaming.v1.ListScheduleAreaMappingsResponse.scheduleAreaMappings: array expected");
                            message.scheduleAreaMappings = [];
                            for (var i = 0; i < object.scheduleAreaMappings.length; ++i) {
                                if (typeof object.scheduleAreaMappings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListScheduleAreaMappingsResponse.scheduleAreaMappings: object expected");
                                message.scheduleAreaMappings[i] = $root.palexy.streaming.v1.ScheduleAreaMapping.fromObject(object.scheduleAreaMappings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListScheduleAreaMappingsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListScheduleAreaMappingsResponse} message ListScheduleAreaMappingsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListScheduleAreaMappingsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.scheduleAreaMappings = [];
                        if (message.scheduleAreaMappings && message.scheduleAreaMappings.length) {
                            object.scheduleAreaMappings = [];
                            for (var j = 0; j < message.scheduleAreaMappings.length; ++j)
                                object.scheduleAreaMappings[j] = $root.palexy.streaming.v1.ScheduleAreaMapping.toObject(message.scheduleAreaMappings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListScheduleAreaMappingsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListScheduleAreaMappingsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListScheduleAreaMappingsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListScheduleAreaMappingsResponse;
                })();
    
                v1.BatchEditScheduleAreaMappingsRequest = (function() {
    
                    /**
                     * Properties of a BatchEditScheduleAreaMappingsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchEditScheduleAreaMappingsRequest
                     * @property {number|null} [metadataTypeId] BatchEditScheduleAreaMappingsRequest metadataTypeId
                     * @property {Array.<palexy.streaming.v1.IScheduleAreaMapping>|null} [scheduleAreaMappings] BatchEditScheduleAreaMappingsRequest scheduleAreaMappings
                     */
    
                    /**
                     * Constructs a new BatchEditScheduleAreaMappingsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchEditScheduleAreaMappingsRequest.
                     * @implements IBatchEditScheduleAreaMappingsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest=} [properties] Properties to set
                     */
                    function BatchEditScheduleAreaMappingsRequest(properties) {
                        this.scheduleAreaMappings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchEditScheduleAreaMappingsRequest metadataTypeId.
                     * @member {number} metadataTypeId
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @instance
                     */
                    BatchEditScheduleAreaMappingsRequest.prototype.metadataTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchEditScheduleAreaMappingsRequest scheduleAreaMappings.
                     * @member {Array.<palexy.streaming.v1.IScheduleAreaMapping>} scheduleAreaMappings
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @instance
                     */
                    BatchEditScheduleAreaMappingsRequest.prototype.scheduleAreaMappings = $util.emptyArray;
    
                    /**
                     * Creates a new BatchEditScheduleAreaMappingsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest} BatchEditScheduleAreaMappingsRequest instance
                     */
                    BatchEditScheduleAreaMappingsRequest.create = function create(properties) {
                        return new BatchEditScheduleAreaMappingsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchEditScheduleAreaMappingsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest} message BatchEditScheduleAreaMappingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchEditScheduleAreaMappingsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.metadataTypeId != null && Object.hasOwnProperty.call(message, "metadataTypeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataTypeId);
                        if (message.scheduleAreaMappings != null && message.scheduleAreaMappings.length)
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i)
                                $root.palexy.streaming.v1.ScheduleAreaMapping.encode(message.scheduleAreaMappings[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchEditScheduleAreaMappingsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsRequest} message BatchEditScheduleAreaMappingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchEditScheduleAreaMappingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchEditScheduleAreaMappingsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest} BatchEditScheduleAreaMappingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchEditScheduleAreaMappingsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.metadataTypeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.scheduleAreaMappings && message.scheduleAreaMappings.length))
                                    message.scheduleAreaMappings = [];
                                message.scheduleAreaMappings.push($root.palexy.streaming.v1.ScheduleAreaMapping.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchEditScheduleAreaMappingsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest} BatchEditScheduleAreaMappingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchEditScheduleAreaMappingsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchEditScheduleAreaMappingsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchEditScheduleAreaMappingsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (!$util.isInteger(message.metadataTypeId) && !(message.metadataTypeId && $util.isInteger(message.metadataTypeId.low) && $util.isInteger(message.metadataTypeId.high)))
                                return "metadataTypeId: integer|Long expected";
                        if (message.scheduleAreaMappings != null && message.hasOwnProperty("scheduleAreaMappings")) {
                            if (!Array.isArray(message.scheduleAreaMappings))
                                return "scheduleAreaMappings: array expected";
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduleAreaMapping.verify(message.scheduleAreaMappings[i]);
                                if (error)
                                    return "scheduleAreaMappings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchEditScheduleAreaMappingsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest} BatchEditScheduleAreaMappingsRequest
                     */
                    BatchEditScheduleAreaMappingsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest();
                        if (object.metadataTypeId != null)
                            if ($util.Long)
                                (message.metadataTypeId = $util.Long.fromValue(object.metadataTypeId)).unsigned = false;
                            else if (typeof object.metadataTypeId === "string")
                                message.metadataTypeId = parseInt(object.metadataTypeId, 10);
                            else if (typeof object.metadataTypeId === "number")
                                message.metadataTypeId = object.metadataTypeId;
                            else if (typeof object.metadataTypeId === "object")
                                message.metadataTypeId = new $util.LongBits(object.metadataTypeId.low >>> 0, object.metadataTypeId.high >>> 0).toNumber();
                        if (object.scheduleAreaMappings) {
                            if (!Array.isArray(object.scheduleAreaMappings))
                                throw TypeError(".palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest.scheduleAreaMappings: array expected");
                            message.scheduleAreaMappings = [];
                            for (var i = 0; i < object.scheduleAreaMappings.length; ++i) {
                                if (typeof object.scheduleAreaMappings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest.scheduleAreaMappings: object expected");
                                message.scheduleAreaMappings[i] = $root.palexy.streaming.v1.ScheduleAreaMapping.fromObject(object.scheduleAreaMappings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchEditScheduleAreaMappingsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest} message BatchEditScheduleAreaMappingsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchEditScheduleAreaMappingsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.scheduleAreaMappings = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.metadataTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.metadataTypeId = options.longs === String ? "0" : 0;
                        if (message.metadataTypeId != null && message.hasOwnProperty("metadataTypeId"))
                            if (typeof message.metadataTypeId === "number")
                                object.metadataTypeId = options.longs === String ? String(message.metadataTypeId) : message.metadataTypeId;
                            else
                                object.metadataTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataTypeId) : options.longs === Number ? new $util.LongBits(message.metadataTypeId.low >>> 0, message.metadataTypeId.high >>> 0).toNumber() : message.metadataTypeId;
                        if (message.scheduleAreaMappings && message.scheduleAreaMappings.length) {
                            object.scheduleAreaMappings = [];
                            for (var j = 0; j < message.scheduleAreaMappings.length; ++j)
                                object.scheduleAreaMappings[j] = $root.palexy.streaming.v1.ScheduleAreaMapping.toObject(message.scheduleAreaMappings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchEditScheduleAreaMappingsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchEditScheduleAreaMappingsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchEditScheduleAreaMappingsRequest;
                })();
    
                v1.BatchEditScheduleAreaMappingsResponse = (function() {
    
                    /**
                     * Properties of a BatchEditScheduleAreaMappingsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchEditScheduleAreaMappingsResponse
                     * @property {Array.<palexy.streaming.v1.IScheduleAreaMapping>|null} [scheduleAreaMappings] BatchEditScheduleAreaMappingsResponse scheduleAreaMappings
                     */
    
                    /**
                     * Constructs a new BatchEditScheduleAreaMappingsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchEditScheduleAreaMappingsResponse.
                     * @implements IBatchEditScheduleAreaMappingsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsResponse=} [properties] Properties to set
                     */
                    function BatchEditScheduleAreaMappingsResponse(properties) {
                        this.scheduleAreaMappings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchEditScheduleAreaMappingsResponse scheduleAreaMappings.
                     * @member {Array.<palexy.streaming.v1.IScheduleAreaMapping>} scheduleAreaMappings
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @instance
                     */
                    BatchEditScheduleAreaMappingsResponse.prototype.scheduleAreaMappings = $util.emptyArray;
    
                    /**
                     * Creates a new BatchEditScheduleAreaMappingsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} BatchEditScheduleAreaMappingsResponse instance
                     */
                    BatchEditScheduleAreaMappingsResponse.create = function create(properties) {
                        return new BatchEditScheduleAreaMappingsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchEditScheduleAreaMappingsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsResponse} message BatchEditScheduleAreaMappingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchEditScheduleAreaMappingsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.scheduleAreaMappings != null && message.scheduleAreaMappings.length)
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i)
                                $root.palexy.streaming.v1.ScheduleAreaMapping.encode(message.scheduleAreaMappings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchEditScheduleAreaMappingsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchEditScheduleAreaMappingsResponse} message BatchEditScheduleAreaMappingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchEditScheduleAreaMappingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchEditScheduleAreaMappingsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} BatchEditScheduleAreaMappingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchEditScheduleAreaMappingsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.scheduleAreaMappings && message.scheduleAreaMappings.length))
                                    message.scheduleAreaMappings = [];
                                message.scheduleAreaMappings.push($root.palexy.streaming.v1.ScheduleAreaMapping.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchEditScheduleAreaMappingsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} BatchEditScheduleAreaMappingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchEditScheduleAreaMappingsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchEditScheduleAreaMappingsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchEditScheduleAreaMappingsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.scheduleAreaMappings != null && message.hasOwnProperty("scheduleAreaMappings")) {
                            if (!Array.isArray(message.scheduleAreaMappings))
                                return "scheduleAreaMappings: array expected";
                            for (var i = 0; i < message.scheduleAreaMappings.length; ++i) {
                                var error = $root.palexy.streaming.v1.ScheduleAreaMapping.verify(message.scheduleAreaMappings[i]);
                                if (error)
                                    return "scheduleAreaMappings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchEditScheduleAreaMappingsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} BatchEditScheduleAreaMappingsResponse
                     */
                    BatchEditScheduleAreaMappingsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse();
                        if (object.scheduleAreaMappings) {
                            if (!Array.isArray(object.scheduleAreaMappings))
                                throw TypeError(".palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse.scheduleAreaMappings: array expected");
                            message.scheduleAreaMappings = [];
                            for (var i = 0; i < object.scheduleAreaMappings.length; ++i) {
                                if (typeof object.scheduleAreaMappings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse.scheduleAreaMappings: object expected");
                                message.scheduleAreaMappings[i] = $root.palexy.streaming.v1.ScheduleAreaMapping.fromObject(object.scheduleAreaMappings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchEditScheduleAreaMappingsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse} message BatchEditScheduleAreaMappingsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchEditScheduleAreaMappingsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.scheduleAreaMappings = [];
                        if (message.scheduleAreaMappings && message.scheduleAreaMappings.length) {
                            object.scheduleAreaMappings = [];
                            for (var j = 0; j < message.scheduleAreaMappings.length; ++j)
                                object.scheduleAreaMappings[j] = $root.palexy.streaming.v1.ScheduleAreaMapping.toObject(message.scheduleAreaMappings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchEditScheduleAreaMappingsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchEditScheduleAreaMappingsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchEditScheduleAreaMappingsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchEditScheduleAreaMappingsResponse;
                })();
    
                v1.ShiftTemplateService = (function() {
    
                    /**
                     * Constructs a new ShiftTemplateService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ShiftTemplateService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ShiftTemplateService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ShiftTemplateService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ShiftTemplateService;
    
                    /**
                     * Creates new ShiftTemplateService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ShiftTemplateService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ShiftTemplateService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#getShiftTemplate}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef GetShiftTemplateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ShiftTemplate} [response] ShiftTemplate
                     */
    
                    /**
                     * Calls GetShiftTemplate.
                     * @function getShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest} request GetShiftTemplateRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.GetShiftTemplateCallback} callback Node-style callback called with the error, if any, and ShiftTemplate
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.getShiftTemplate = function getShiftTemplate(request, callback) {
                        return this.rpcCall(getShiftTemplate, $root.palexy.streaming.v1.GetShiftTemplateRequest, $root.palexy.streaming.v1.ShiftTemplate, request, callback);
                    }, "name", { value: "GetShiftTemplate" });
    
                    /**
                     * Calls GetShiftTemplate.
                     * @function getShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest} request GetShiftTemplateRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ShiftTemplate>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#listShiftTemplates}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef ListShiftTemplatesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListShiftTemplatesResponse} [response] ListShiftTemplatesResponse
                     */
    
                    /**
                     * Calls ListShiftTemplates.
                     * @function listShiftTemplates
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest} request ListShiftTemplatesRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.ListShiftTemplatesCallback} callback Node-style callback called with the error, if any, and ListShiftTemplatesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.listShiftTemplates = function listShiftTemplates(request, callback) {
                        return this.rpcCall(listShiftTemplates, $root.palexy.streaming.v1.ListShiftTemplatesRequest, $root.palexy.streaming.v1.ListShiftTemplatesResponse, request, callback);
                    }, "name", { value: "ListShiftTemplates" });
    
                    /**
                     * Calls ListShiftTemplates.
                     * @function listShiftTemplates
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest} request ListShiftTemplatesRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListShiftTemplatesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#createShiftTemplate}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef CreateShiftTemplateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ShiftTemplate} [response] ShiftTemplate
                     */
    
                    /**
                     * Calls CreateShiftTemplate.
                     * @function createShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest} request CreateShiftTemplateRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.CreateShiftTemplateCallback} callback Node-style callback called with the error, if any, and ShiftTemplate
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.createShiftTemplate = function createShiftTemplate(request, callback) {
                        return this.rpcCall(createShiftTemplate, $root.palexy.streaming.v1.CreateShiftTemplateRequest, $root.palexy.streaming.v1.ShiftTemplate, request, callback);
                    }, "name", { value: "CreateShiftTemplate" });
    
                    /**
                     * Calls CreateShiftTemplate.
                     * @function createShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest} request CreateShiftTemplateRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ShiftTemplate>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#updateShiftTemplate}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef UpdateShiftTemplateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ShiftTemplate} [response] ShiftTemplate
                     */
    
                    /**
                     * Calls UpdateShiftTemplate.
                     * @function updateShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest} request UpdateShiftTemplateRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.UpdateShiftTemplateCallback} callback Node-style callback called with the error, if any, and ShiftTemplate
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.updateShiftTemplate = function updateShiftTemplate(request, callback) {
                        return this.rpcCall(updateShiftTemplate, $root.palexy.streaming.v1.UpdateShiftTemplateRequest, $root.palexy.streaming.v1.ShiftTemplate, request, callback);
                    }, "name", { value: "UpdateShiftTemplate" });
    
                    /**
                     * Calls UpdateShiftTemplate.
                     * @function updateShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest} request UpdateShiftTemplateRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ShiftTemplate>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#deleteShiftTemplate}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef DeleteShiftTemplateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteShiftTemplate.
                     * @function deleteShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest} request DeleteShiftTemplateRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.DeleteShiftTemplateCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.deleteShiftTemplate = function deleteShiftTemplate(request, callback) {
                        return this.rpcCall(deleteShiftTemplate, $root.palexy.streaming.v1.DeleteShiftTemplateRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteShiftTemplate" });
    
                    /**
                     * Calls DeleteShiftTemplate.
                     * @function deleteShiftTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest} request DeleteShiftTemplateRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ShiftTemplateService#listFrequentlyUsedTemplates}.
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @typedef ListFrequentlyUsedTemplatesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} [response] ListFrequentlyUsedTemplatesResponse
                     */
    
                    /**
                     * Calls ListFrequentlyUsedTemplates.
                     * @function listFrequentlyUsedTemplates
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest} request ListFrequentlyUsedTemplatesRequest message or plain object
                     * @param {palexy.streaming.v1.ShiftTemplateService.ListFrequentlyUsedTemplatesCallback} callback Node-style callback called with the error, if any, and ListFrequentlyUsedTemplatesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ShiftTemplateService.prototype.listFrequentlyUsedTemplates = function listFrequentlyUsedTemplates(request, callback) {
                        return this.rpcCall(listFrequentlyUsedTemplates, $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest, $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse, request, callback);
                    }, "name", { value: "ListFrequentlyUsedTemplates" });
    
                    /**
                     * Calls ListFrequentlyUsedTemplates.
                     * @function listFrequentlyUsedTemplates
                     * @memberof palexy.streaming.v1.ShiftTemplateService
                     * @instance
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest} request ListFrequentlyUsedTemplatesRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse>} Promise
                     * @variation 2
                     */
    
                    return ShiftTemplateService;
                })();
    
                v1.GetShiftTemplateRequest = (function() {
    
                    /**
                     * Properties of a GetShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetShiftTemplateRequest
                     * @property {number|null} [shiftTemplateId] GetShiftTemplateRequest shiftTemplateId
                     */
    
                    /**
                     * Constructs a new GetShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetShiftTemplateRequest.
                     * @implements IGetShiftTemplateRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest=} [properties] Properties to set
                     */
                    function GetShiftTemplateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetShiftTemplateRequest shiftTemplateId.
                     * @member {number} shiftTemplateId
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @instance
                     */
                    GetShiftTemplateRequest.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetShiftTemplateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetShiftTemplateRequest} GetShiftTemplateRequest instance
                     */
                    GetShiftTemplateRequest.create = function create(properties) {
                        return new GetShiftTemplateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetShiftTemplateRequest message. Does not implicitly {@link palexy.streaming.v1.GetShiftTemplateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest} message GetShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetShiftTemplateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.shiftTemplateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetShiftTemplateRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetShiftTemplateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetShiftTemplateRequest} message GetShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetShiftTemplateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetShiftTemplateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetShiftTemplateRequest} GetShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetShiftTemplateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetShiftTemplateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftTemplateId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetShiftTemplateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetShiftTemplateRequest} GetShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetShiftTemplateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetShiftTemplateRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetShiftTemplateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                                return "shiftTemplateId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetShiftTemplateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetShiftTemplateRequest} GetShiftTemplateRequest
                     */
                    GetShiftTemplateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetShiftTemplateRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetShiftTemplateRequest();
                        if (object.shiftTemplateId != null)
                            if ($util.Long)
                                (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                            else if (typeof object.shiftTemplateId === "string")
                                message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                            else if (typeof object.shiftTemplateId === "number")
                                message.shiftTemplateId = object.shiftTemplateId;
                            else if (typeof object.shiftTemplateId === "object")
                                message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetShiftTemplateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.GetShiftTemplateRequest} message GetShiftTemplateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetShiftTemplateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (typeof message.shiftTemplateId === "number")
                                object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                            else
                                object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                        return object;
                    };
    
                    /**
                     * Converts this GetShiftTemplateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetShiftTemplateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetShiftTemplateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetShiftTemplateRequest;
                })();
    
                v1.ListShiftTemplatesRequest = (function() {
    
                    /**
                     * Properties of a ListShiftTemplatesRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListShiftTemplatesRequest
                     * @property {number|null} [companyId] ListShiftTemplatesRequest companyId
                     * @property {boolean|null} [includeCreatorInfo] ListShiftTemplatesRequest includeCreatorInfo
                     * @property {palexy.streaming.v1.ShiftTemplateLevel|null} [templateLevel] ListShiftTemplatesRequest templateLevel
                     * @property {number|null} [storeId] ListShiftTemplatesRequest storeId
                     * @property {boolean|null} [includeLevelTargetInfo] ListShiftTemplatesRequest includeLevelTargetInfo
                     */
    
                    /**
                     * Constructs a new ListShiftTemplatesRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListShiftTemplatesRequest.
                     * @implements IListShiftTemplatesRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest=} [properties] Properties to set
                     */
                    function ListShiftTemplatesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListShiftTemplatesRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     */
                    ListShiftTemplatesRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListShiftTemplatesRequest includeCreatorInfo.
                     * @member {boolean} includeCreatorInfo
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     */
                    ListShiftTemplatesRequest.prototype.includeCreatorInfo = false;
    
                    /**
                     * ListShiftTemplatesRequest templateLevel.
                     * @member {palexy.streaming.v1.ShiftTemplateLevel} templateLevel
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     */
                    ListShiftTemplatesRequest.prototype.templateLevel = 0;
    
                    /**
                     * ListShiftTemplatesRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     */
                    ListShiftTemplatesRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListShiftTemplatesRequest includeLevelTargetInfo.
                     * @member {boolean} includeLevelTargetInfo
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     */
                    ListShiftTemplatesRequest.prototype.includeLevelTargetInfo = false;
    
                    /**
                     * Creates a new ListShiftTemplatesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListShiftTemplatesRequest} ListShiftTemplatesRequest instance
                     */
                    ListShiftTemplatesRequest.create = function create(properties) {
                        return new ListShiftTemplatesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListShiftTemplatesRequest message. Does not implicitly {@link palexy.streaming.v1.ListShiftTemplatesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest} message ListShiftTemplatesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftTemplatesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.includeCreatorInfo != null && Object.hasOwnProperty.call(message, "includeCreatorInfo"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeCreatorInfo);
                        if (message.templateLevel != null && Object.hasOwnProperty.call(message, "templateLevel"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.templateLevel);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.storeId);
                        if (message.includeLevelTargetInfo != null && Object.hasOwnProperty.call(message, "includeLevelTargetInfo"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeLevelTargetInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListShiftTemplatesRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListShiftTemplatesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesRequest} message ListShiftTemplatesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftTemplatesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListShiftTemplatesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListShiftTemplatesRequest} ListShiftTemplatesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftTemplatesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListShiftTemplatesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.includeCreatorInfo = reader.bool();
                                break;
                            case 3:
                                message.templateLevel = reader.int32();
                                break;
                            case 4:
                                message.storeId = reader.int64();
                                break;
                            case 5:
                                message.includeLevelTargetInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListShiftTemplatesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListShiftTemplatesRequest} ListShiftTemplatesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftTemplatesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListShiftTemplatesRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListShiftTemplatesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.includeCreatorInfo != null && message.hasOwnProperty("includeCreatorInfo"))
                            if (typeof message.includeCreatorInfo !== "boolean")
                                return "includeCreatorInfo: boolean expected";
                        if (message.templateLevel != null && message.hasOwnProperty("templateLevel"))
                            switch (message.templateLevel) {
                            default:
                                return "templateLevel: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.includeLevelTargetInfo != null && message.hasOwnProperty("includeLevelTargetInfo"))
                            if (typeof message.includeLevelTargetInfo !== "boolean")
                                return "includeLevelTargetInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListShiftTemplatesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListShiftTemplatesRequest} ListShiftTemplatesRequest
                     */
                    ListShiftTemplatesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListShiftTemplatesRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListShiftTemplatesRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.includeCreatorInfo != null)
                            message.includeCreatorInfo = Boolean(object.includeCreatorInfo);
                        switch (object.templateLevel) {
                        case "UNKNOWN_TEMPLATE_LEVEL":
                        case 0:
                            message.templateLevel = 0;
                            break;
                        case "COMPANY":
                        case 1:
                            message.templateLevel = 1;
                            break;
                        case "STORE":
                        case 2:
                            message.templateLevel = 2;
                            break;
                        case "STORE_GROUP":
                        case 3:
                            message.templateLevel = 3;
                            break;
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.includeLevelTargetInfo != null)
                            message.includeLevelTargetInfo = Boolean(object.includeLevelTargetInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListShiftTemplatesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.ListShiftTemplatesRequest} message ListShiftTemplatesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListShiftTemplatesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.includeCreatorInfo = false;
                            object.templateLevel = options.enums === String ? "UNKNOWN_TEMPLATE_LEVEL" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.includeLevelTargetInfo = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.includeCreatorInfo != null && message.hasOwnProperty("includeCreatorInfo"))
                            object.includeCreatorInfo = message.includeCreatorInfo;
                        if (message.templateLevel != null && message.hasOwnProperty("templateLevel"))
                            object.templateLevel = options.enums === String ? $root.palexy.streaming.v1.ShiftTemplateLevel[message.templateLevel] : message.templateLevel;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.includeLevelTargetInfo != null && message.hasOwnProperty("includeLevelTargetInfo"))
                            object.includeLevelTargetInfo = message.includeLevelTargetInfo;
                        return object;
                    };
    
                    /**
                     * Converts this ListShiftTemplatesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListShiftTemplatesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListShiftTemplatesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListShiftTemplatesRequest;
                })();
    
                v1.ListShiftTemplatesResponse = (function() {
    
                    /**
                     * Properties of a ListShiftTemplatesResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListShiftTemplatesResponse
                     * @property {Array.<palexy.streaming.v1.IShiftTemplate>|null} [shiftTemplates] ListShiftTemplatesResponse shiftTemplates
                     */
    
                    /**
                     * Constructs a new ListShiftTemplatesResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListShiftTemplatesResponse.
                     * @implements IListShiftTemplatesResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListShiftTemplatesResponse=} [properties] Properties to set
                     */
                    function ListShiftTemplatesResponse(properties) {
                        this.shiftTemplates = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListShiftTemplatesResponse shiftTemplates.
                     * @member {Array.<palexy.streaming.v1.IShiftTemplate>} shiftTemplates
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @instance
                     */
                    ListShiftTemplatesResponse.prototype.shiftTemplates = $util.emptyArray;
    
                    /**
                     * Creates a new ListShiftTemplatesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListShiftTemplatesResponse} ListShiftTemplatesResponse instance
                     */
                    ListShiftTemplatesResponse.create = function create(properties) {
                        return new ListShiftTemplatesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListShiftTemplatesResponse message. Does not implicitly {@link palexy.streaming.v1.ListShiftTemplatesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesResponse} message ListShiftTemplatesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftTemplatesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplates != null && message.shiftTemplates.length)
                            for (var i = 0; i < message.shiftTemplates.length; ++i)
                                $root.palexy.streaming.v1.ShiftTemplate.encode(message.shiftTemplates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListShiftTemplatesResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListShiftTemplatesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftTemplatesResponse} message ListShiftTemplatesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftTemplatesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListShiftTemplatesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListShiftTemplatesResponse} ListShiftTemplatesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftTemplatesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListShiftTemplatesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.shiftTemplates && message.shiftTemplates.length))
                                    message.shiftTemplates = [];
                                message.shiftTemplates.push($root.palexy.streaming.v1.ShiftTemplate.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListShiftTemplatesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListShiftTemplatesResponse} ListShiftTemplatesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftTemplatesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListShiftTemplatesResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListShiftTemplatesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplates != null && message.hasOwnProperty("shiftTemplates")) {
                            if (!Array.isArray(message.shiftTemplates))
                                return "shiftTemplates: array expected";
                            for (var i = 0; i < message.shiftTemplates.length; ++i) {
                                var error = $root.palexy.streaming.v1.ShiftTemplate.verify(message.shiftTemplates[i]);
                                if (error)
                                    return "shiftTemplates." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListShiftTemplatesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListShiftTemplatesResponse} ListShiftTemplatesResponse
                     */
                    ListShiftTemplatesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListShiftTemplatesResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListShiftTemplatesResponse();
                        if (object.shiftTemplates) {
                            if (!Array.isArray(object.shiftTemplates))
                                throw TypeError(".palexy.streaming.v1.ListShiftTemplatesResponse.shiftTemplates: array expected");
                            message.shiftTemplates = [];
                            for (var i = 0; i < object.shiftTemplates.length; ++i) {
                                if (typeof object.shiftTemplates[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListShiftTemplatesResponse.shiftTemplates: object expected");
                                message.shiftTemplates[i] = $root.palexy.streaming.v1.ShiftTemplate.fromObject(object.shiftTemplates[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListShiftTemplatesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.ListShiftTemplatesResponse} message ListShiftTemplatesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListShiftTemplatesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.shiftTemplates = [];
                        if (message.shiftTemplates && message.shiftTemplates.length) {
                            object.shiftTemplates = [];
                            for (var j = 0; j < message.shiftTemplates.length; ++j)
                                object.shiftTemplates[j] = $root.palexy.streaming.v1.ShiftTemplate.toObject(message.shiftTemplates[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListShiftTemplatesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListShiftTemplatesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListShiftTemplatesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListShiftTemplatesResponse;
                })();
    
                v1.ListFrequentlyUsedTemplatesRequest = (function() {
    
                    /**
                     * Properties of a ListFrequentlyUsedTemplatesRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListFrequentlyUsedTemplatesRequest
                     * @property {number|null} [storeId] ListFrequentlyUsedTemplatesRequest storeId
                     * @property {number|null} [startDateId] ListFrequentlyUsedTemplatesRequest startDateId
                     * @property {number|null} [endDateId] ListFrequentlyUsedTemplatesRequest endDateId
                     * @property {number|null} [limit] ListFrequentlyUsedTemplatesRequest limit
                     */
    
                    /**
                     * Constructs a new ListFrequentlyUsedTemplatesRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListFrequentlyUsedTemplatesRequest.
                     * @implements IListFrequentlyUsedTemplatesRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest=} [properties] Properties to set
                     */
                    function ListFrequentlyUsedTemplatesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFrequentlyUsedTemplatesRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @instance
                     */
                    ListFrequentlyUsedTemplatesRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFrequentlyUsedTemplatesRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @instance
                     */
                    ListFrequentlyUsedTemplatesRequest.prototype.startDateId = 0;
    
                    /**
                     * ListFrequentlyUsedTemplatesRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @instance
                     */
                    ListFrequentlyUsedTemplatesRequest.prototype.endDateId = 0;
    
                    /**
                     * ListFrequentlyUsedTemplatesRequest limit.
                     * @member {number} limit
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @instance
                     */
                    ListFrequentlyUsedTemplatesRequest.prototype.limit = 0;
    
                    /**
                     * Creates a new ListFrequentlyUsedTemplatesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest} ListFrequentlyUsedTemplatesRequest instance
                     */
                    ListFrequentlyUsedTemplatesRequest.create = function create(properties) {
                        return new ListFrequentlyUsedTemplatesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFrequentlyUsedTemplatesRequest message. Does not implicitly {@link palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest} message ListFrequentlyUsedTemplatesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFrequentlyUsedTemplatesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.limit != null && Object.hasOwnProperty.call(message, "limit"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.limit);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFrequentlyUsedTemplatesRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesRequest} message ListFrequentlyUsedTemplatesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFrequentlyUsedTemplatesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFrequentlyUsedTemplatesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest} ListFrequentlyUsedTemplatesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFrequentlyUsedTemplatesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.limit = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFrequentlyUsedTemplatesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest} ListFrequentlyUsedTemplatesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFrequentlyUsedTemplatesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFrequentlyUsedTemplatesRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFrequentlyUsedTemplatesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            if (!$util.isInteger(message.limit))
                                return "limit: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFrequentlyUsedTemplatesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest} ListFrequentlyUsedTemplatesRequest
                     */
                    ListFrequentlyUsedTemplatesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.limit != null)
                            message.limit = object.limit | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFrequentlyUsedTemplatesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @static
                     * @param {palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest} message ListFrequentlyUsedTemplatesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFrequentlyUsedTemplatesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.limit = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.limit != null && message.hasOwnProperty("limit"))
                            object.limit = message.limit;
                        return object;
                    };
    
                    /**
                     * Converts this ListFrequentlyUsedTemplatesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFrequentlyUsedTemplatesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFrequentlyUsedTemplatesRequest;
                })();
    
                v1.ListFrequentlyUsedTemplatesResponse = (function() {
    
                    /**
                     * Properties of a ListFrequentlyUsedTemplatesResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListFrequentlyUsedTemplatesResponse
                     * @property {Array.<palexy.streaming.v1.IShiftTemplate>|null} [shiftTemplates] ListFrequentlyUsedTemplatesResponse shiftTemplates
                     */
    
                    /**
                     * Constructs a new ListFrequentlyUsedTemplatesResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListFrequentlyUsedTemplatesResponse.
                     * @implements IListFrequentlyUsedTemplatesResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesResponse=} [properties] Properties to set
                     */
                    function ListFrequentlyUsedTemplatesResponse(properties) {
                        this.shiftTemplates = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFrequentlyUsedTemplatesResponse shiftTemplates.
                     * @member {Array.<palexy.streaming.v1.IShiftTemplate>} shiftTemplates
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @instance
                     */
                    ListFrequentlyUsedTemplatesResponse.prototype.shiftTemplates = $util.emptyArray;
    
                    /**
                     * Creates a new ListFrequentlyUsedTemplatesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} ListFrequentlyUsedTemplatesResponse instance
                     */
                    ListFrequentlyUsedTemplatesResponse.create = function create(properties) {
                        return new ListFrequentlyUsedTemplatesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFrequentlyUsedTemplatesResponse message. Does not implicitly {@link palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesResponse} message ListFrequentlyUsedTemplatesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFrequentlyUsedTemplatesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplates != null && message.shiftTemplates.length)
                            for (var i = 0; i < message.shiftTemplates.length; ++i)
                                $root.palexy.streaming.v1.ShiftTemplate.encode(message.shiftTemplates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFrequentlyUsedTemplatesResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.IListFrequentlyUsedTemplatesResponse} message ListFrequentlyUsedTemplatesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFrequentlyUsedTemplatesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFrequentlyUsedTemplatesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} ListFrequentlyUsedTemplatesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFrequentlyUsedTemplatesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.shiftTemplates && message.shiftTemplates.length))
                                    message.shiftTemplates = [];
                                message.shiftTemplates.push($root.palexy.streaming.v1.ShiftTemplate.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFrequentlyUsedTemplatesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} ListFrequentlyUsedTemplatesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFrequentlyUsedTemplatesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFrequentlyUsedTemplatesResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFrequentlyUsedTemplatesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplates != null && message.hasOwnProperty("shiftTemplates")) {
                            if (!Array.isArray(message.shiftTemplates))
                                return "shiftTemplates: array expected";
                            for (var i = 0; i < message.shiftTemplates.length; ++i) {
                                var error = $root.palexy.streaming.v1.ShiftTemplate.verify(message.shiftTemplates[i]);
                                if (error)
                                    return "shiftTemplates." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFrequentlyUsedTemplatesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} ListFrequentlyUsedTemplatesResponse
                     */
                    ListFrequentlyUsedTemplatesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse();
                        if (object.shiftTemplates) {
                            if (!Array.isArray(object.shiftTemplates))
                                throw TypeError(".palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse.shiftTemplates: array expected");
                            message.shiftTemplates = [];
                            for (var i = 0; i < object.shiftTemplates.length; ++i) {
                                if (typeof object.shiftTemplates[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse.shiftTemplates: object expected");
                                message.shiftTemplates[i] = $root.palexy.streaming.v1.ShiftTemplate.fromObject(object.shiftTemplates[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFrequentlyUsedTemplatesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @static
                     * @param {palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse} message ListFrequentlyUsedTemplatesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFrequentlyUsedTemplatesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.shiftTemplates = [];
                        if (message.shiftTemplates && message.shiftTemplates.length) {
                            object.shiftTemplates = [];
                            for (var j = 0; j < message.shiftTemplates.length; ++j)
                                object.shiftTemplates[j] = $root.palexy.streaming.v1.ShiftTemplate.toObject(message.shiftTemplates[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFrequentlyUsedTemplatesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListFrequentlyUsedTemplatesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFrequentlyUsedTemplatesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFrequentlyUsedTemplatesResponse;
                })();
    
                v1.CreateShiftTemplateRequest = (function() {
    
                    /**
                     * Properties of a CreateShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateShiftTemplateRequest
                     * @property {palexy.streaming.v1.IShiftTemplate|null} [shiftTemplate] CreateShiftTemplateRequest shiftTemplate
                     */
    
                    /**
                     * Constructs a new CreateShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateShiftTemplateRequest.
                     * @implements ICreateShiftTemplateRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest=} [properties] Properties to set
                     */
                    function CreateShiftTemplateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateShiftTemplateRequest shiftTemplate.
                     * @member {palexy.streaming.v1.IShiftTemplate|null|undefined} shiftTemplate
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @instance
                     */
                    CreateShiftTemplateRequest.prototype.shiftTemplate = null;
    
                    /**
                     * Creates a new CreateShiftTemplateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateShiftTemplateRequest} CreateShiftTemplateRequest instance
                     */
                    CreateShiftTemplateRequest.create = function create(properties) {
                        return new CreateShiftTemplateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateShiftTemplateRequest message. Does not implicitly {@link palexy.streaming.v1.CreateShiftTemplateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest} message CreateShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateShiftTemplateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplate != null && Object.hasOwnProperty.call(message, "shiftTemplate"))
                            $root.palexy.streaming.v1.ShiftTemplate.encode(message.shiftTemplate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateShiftTemplateRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateShiftTemplateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateShiftTemplateRequest} message CreateShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateShiftTemplateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateShiftTemplateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateShiftTemplateRequest} CreateShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateShiftTemplateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateShiftTemplateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateShiftTemplateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateShiftTemplateRequest} CreateShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateShiftTemplateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateShiftTemplateRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateShiftTemplateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplate != null && message.hasOwnProperty("shiftTemplate")) {
                            var error = $root.palexy.streaming.v1.ShiftTemplate.verify(message.shiftTemplate);
                            if (error)
                                return "shiftTemplate." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateShiftTemplateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateShiftTemplateRequest} CreateShiftTemplateRequest
                     */
                    CreateShiftTemplateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateShiftTemplateRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateShiftTemplateRequest();
                        if (object.shiftTemplate != null) {
                            if (typeof object.shiftTemplate !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateShiftTemplateRequest.shiftTemplate: object expected");
                            message.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.fromObject(object.shiftTemplate);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateShiftTemplateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateShiftTemplateRequest} message CreateShiftTemplateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateShiftTemplateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.shiftTemplate = null;
                        if (message.shiftTemplate != null && message.hasOwnProperty("shiftTemplate"))
                            object.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.toObject(message.shiftTemplate, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateShiftTemplateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateShiftTemplateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateShiftTemplateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateShiftTemplateRequest;
                })();
    
                v1.UpdateShiftTemplateRequest = (function() {
    
                    /**
                     * Properties of an UpdateShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateShiftTemplateRequest
                     * @property {palexy.streaming.v1.IShiftTemplate|null} [shiftTemplate] UpdateShiftTemplateRequest shiftTemplate
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateShiftTemplateRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateShiftTemplateRequest.
                     * @implements IUpdateShiftTemplateRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest=} [properties] Properties to set
                     */
                    function UpdateShiftTemplateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateShiftTemplateRequest shiftTemplate.
                     * @member {palexy.streaming.v1.IShiftTemplate|null|undefined} shiftTemplate
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @instance
                     */
                    UpdateShiftTemplateRequest.prototype.shiftTemplate = null;
    
                    /**
                     * UpdateShiftTemplateRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @instance
                     */
                    UpdateShiftTemplateRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateShiftTemplateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateShiftTemplateRequest} UpdateShiftTemplateRequest instance
                     */
                    UpdateShiftTemplateRequest.create = function create(properties) {
                        return new UpdateShiftTemplateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateShiftTemplateRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateShiftTemplateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest} message UpdateShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateShiftTemplateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplate != null && Object.hasOwnProperty.call(message, "shiftTemplate"))
                            $root.palexy.streaming.v1.ShiftTemplate.encode(message.shiftTemplate, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateShiftTemplateRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateShiftTemplateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateShiftTemplateRequest} message UpdateShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateShiftTemplateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateShiftTemplateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateShiftTemplateRequest} UpdateShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateShiftTemplateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateShiftTemplateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateShiftTemplateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateShiftTemplateRequest} UpdateShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateShiftTemplateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateShiftTemplateRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateShiftTemplateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplate != null && message.hasOwnProperty("shiftTemplate")) {
                            var error = $root.palexy.streaming.v1.ShiftTemplate.verify(message.shiftTemplate);
                            if (error)
                                return "shiftTemplate." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateShiftTemplateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateShiftTemplateRequest} UpdateShiftTemplateRequest
                     */
                    UpdateShiftTemplateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateShiftTemplateRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateShiftTemplateRequest();
                        if (object.shiftTemplate != null) {
                            if (typeof object.shiftTemplate !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateShiftTemplateRequest.shiftTemplate: object expected");
                            message.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.fromObject(object.shiftTemplate);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateShiftTemplateRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateShiftTemplateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateShiftTemplateRequest} message UpdateShiftTemplateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateShiftTemplateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.shiftTemplate = null;
                            object.updateMask = null;
                        }
                        if (message.shiftTemplate != null && message.hasOwnProperty("shiftTemplate"))
                            object.shiftTemplate = $root.palexy.streaming.v1.ShiftTemplate.toObject(message.shiftTemplate, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateShiftTemplateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateShiftTemplateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateShiftTemplateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateShiftTemplateRequest;
                })();
    
                v1.DeleteShiftTemplateRequest = (function() {
    
                    /**
                     * Properties of a DeleteShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteShiftTemplateRequest
                     * @property {number|null} [shiftTemplateId] DeleteShiftTemplateRequest shiftTemplateId
                     */
    
                    /**
                     * Constructs a new DeleteShiftTemplateRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteShiftTemplateRequest.
                     * @implements IDeleteShiftTemplateRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest=} [properties] Properties to set
                     */
                    function DeleteShiftTemplateRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteShiftTemplateRequest shiftTemplateId.
                     * @member {number} shiftTemplateId
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @instance
                     */
                    DeleteShiftTemplateRequest.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteShiftTemplateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteShiftTemplateRequest} DeleteShiftTemplateRequest instance
                     */
                    DeleteShiftTemplateRequest.create = function create(properties) {
                        return new DeleteShiftTemplateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteShiftTemplateRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteShiftTemplateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest} message DeleteShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteShiftTemplateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.shiftTemplateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteShiftTemplateRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteShiftTemplateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteShiftTemplateRequest} message DeleteShiftTemplateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteShiftTemplateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteShiftTemplateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteShiftTemplateRequest} DeleteShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteShiftTemplateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteShiftTemplateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftTemplateId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteShiftTemplateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteShiftTemplateRequest} DeleteShiftTemplateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteShiftTemplateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteShiftTemplateRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteShiftTemplateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                                return "shiftTemplateId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteShiftTemplateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteShiftTemplateRequest} DeleteShiftTemplateRequest
                     */
                    DeleteShiftTemplateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteShiftTemplateRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteShiftTemplateRequest();
                        if (object.shiftTemplateId != null)
                            if ($util.Long)
                                (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                            else if (typeof object.shiftTemplateId === "string")
                                message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                            else if (typeof object.shiftTemplateId === "number")
                                message.shiftTemplateId = object.shiftTemplateId;
                            else if (typeof object.shiftTemplateId === "object")
                                message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteShiftTemplateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteShiftTemplateRequest} message DeleteShiftTemplateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteShiftTemplateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (typeof message.shiftTemplateId === "number")
                                object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                            else
                                object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteShiftTemplateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteShiftTemplateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteShiftTemplateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteShiftTemplateRequest;
                })();
    
                v1.ShiftTemplate = (function() {
    
                    /**
                     * Properties of a ShiftTemplate.
                     * @memberof palexy.streaming.v1
                     * @interface IShiftTemplate
                     * @property {number|null} [id] ShiftTemplate id
                     * @property {number|null} [companyId] ShiftTemplate companyId
                     * @property {string|null} [shiftName] ShiftTemplate shiftName
                     * @property {string|null} [note] ShiftTemplate note
                     * @property {string|null} [startTime] ShiftTemplate startTime
                     * @property {string|null} [endTime] ShiftTemplate endTime
                     * @property {boolean|null} [isCrossDayShift] ShiftTemplate isCrossDayShift
                     * @property {string|null} [color] ShiftTemplate color
                     * @property {number|null} [creatorId] ShiftTemplate creatorId
                     * @property {number|null} [staffPositionId] ShiftTemplate staffPositionId
                     * @property {number|null} [createTimeMs] ShiftTemplate createTimeMs
                     * @property {number|null} [updateTimeMs] ShiftTemplate updateTimeMs
                     * @property {palexy.streaming.v1.IAccount|null} [creator] ShiftTemplate creator
                     * @property {palexy.streaming.v1.IStaffPosition|null} [staffPosition] ShiftTemplate staffPosition
                     * @property {boolean|null} [isCommonTemplate] ShiftTemplate isCommonTemplate
                     * @property {Array.<palexy.protobuf.IBreakTime>|null} [breakTimes] ShiftTemplate breakTimes
                     * @property {palexy.streaming.v1.ShiftTemplateLevel|null} [templateLevel] ShiftTemplate templateLevel
                     * @property {number|null} [storeId] ShiftTemplate storeId
                     * @property {string|null} [storeName] ShiftTemplate storeName
                     * @property {boolean|null} [belongToOperationEvent] ShiftTemplate belongToOperationEvent
                     * @property {number|null} [positionIdFromEvent] ShiftTemplate positionIdFromEvent
                     * @property {number|null} [positionLevelFromEvent] ShiftTemplate positionLevelFromEvent
                     * @property {palexy.protobuf.StaffEmploymentType|null} [employmentTypeFromEvent] ShiftTemplate employmentTypeFromEvent
                     * @property {palexy.protobuf.Gender|null} [genderFromEvent] ShiftTemplate genderFromEvent
                     * @property {number|null} [areaIdFromEvent] ShiftTemplate areaIdFromEvent
                     */
    
                    /**
                     * Constructs a new ShiftTemplate.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ShiftTemplate.
                     * @implements IShiftTemplate
                     * @constructor
                     * @param {palexy.streaming.v1.IShiftTemplate=} [properties] Properties to set
                     */
                    function ShiftTemplate(properties) {
                        this.breakTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftTemplate id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate shiftName.
                     * @member {string} shiftName
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.shiftName = "";
    
                    /**
                     * ShiftTemplate note.
                     * @member {string} note
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.note = "";
    
                    /**
                     * ShiftTemplate startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.startTime = "";
    
                    /**
                     * ShiftTemplate endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.endTime = "";
    
                    /**
                     * ShiftTemplate isCrossDayShift.
                     * @member {boolean} isCrossDayShift
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.isCrossDayShift = false;
    
                    /**
                     * ShiftTemplate color.
                     * @member {string} color
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.color = "";
    
                    /**
                     * ShiftTemplate creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate staffPositionId.
                     * @member {number} staffPositionId
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.staffPositionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate creator.
                     * @member {palexy.streaming.v1.IAccount|null|undefined} creator
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.creator = null;
    
                    /**
                     * ShiftTemplate staffPosition.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} staffPosition
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.staffPosition = null;
    
                    /**
                     * ShiftTemplate isCommonTemplate.
                     * @member {boolean} isCommonTemplate
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.isCommonTemplate = false;
    
                    /**
                     * ShiftTemplate breakTimes.
                     * @member {Array.<palexy.protobuf.IBreakTime>} breakTimes
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.breakTimes = $util.emptyArray;
    
                    /**
                     * ShiftTemplate templateLevel.
                     * @member {palexy.streaming.v1.ShiftTemplateLevel} templateLevel
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.templateLevel = 0;
    
                    /**
                     * ShiftTemplate storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate storeName.
                     * @member {string} storeName
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.storeName = "";
    
                    /**
                     * ShiftTemplate belongToOperationEvent.
                     * @member {boolean} belongToOperationEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.belongToOperationEvent = false;
    
                    /**
                     * ShiftTemplate positionIdFromEvent.
                     * @member {number} positionIdFromEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.positionIdFromEvent = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftTemplate positionLevelFromEvent.
                     * @member {number} positionLevelFromEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.positionLevelFromEvent = 0;
    
                    /**
                     * ShiftTemplate employmentTypeFromEvent.
                     * @member {palexy.protobuf.StaffEmploymentType} employmentTypeFromEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.employmentTypeFromEvent = 0;
    
                    /**
                     * ShiftTemplate genderFromEvent.
                     * @member {palexy.protobuf.Gender} genderFromEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.genderFromEvent = 0;
    
                    /**
                     * ShiftTemplate areaIdFromEvent.
                     * @member {number} areaIdFromEvent
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     */
                    ShiftTemplate.prototype.areaIdFromEvent = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ShiftTemplate instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {palexy.streaming.v1.IShiftTemplate=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ShiftTemplate} ShiftTemplate instance
                     */
                    ShiftTemplate.create = function create(properties) {
                        return new ShiftTemplate(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftTemplate message. Does not implicitly {@link palexy.streaming.v1.ShiftTemplate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {palexy.streaming.v1.IShiftTemplate} message ShiftTemplate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftTemplate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.shiftName != null && Object.hasOwnProperty.call(message, "shiftName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.shiftName);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.note);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endTime);
                        if (message.isCrossDayShift != null && Object.hasOwnProperty.call(message, "isCrossDayShift"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isCrossDayShift);
                        if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.color);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.creatorId);
                        if (message.staffPositionId != null && Object.hasOwnProperty.call(message, "staffPositionId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.staffPositionId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.updateTimeMs);
                        if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                            $root.palexy.streaming.v1.Account.encode(message.creator, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.staffPosition != null && Object.hasOwnProperty.call(message, "staffPosition"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.staffPosition, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.isCommonTemplate != null && Object.hasOwnProperty.call(message, "isCommonTemplate"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isCommonTemplate);
                        if (message.breakTimes != null && message.breakTimes.length)
                            for (var i = 0; i < message.breakTimes.length; ++i)
                                $root.palexy.protobuf.BreakTime.encode(message.breakTimes[i], writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.templateLevel != null && Object.hasOwnProperty.call(message, "templateLevel"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.templateLevel);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int64(message.storeId);
                        if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                            writer.uint32(/* id 19, wireType 2 =*/154).string(message.storeName);
                        if (message.belongToOperationEvent != null && Object.hasOwnProperty.call(message, "belongToOperationEvent"))
                            writer.uint32(/* id 100, wireType 0 =*/800).bool(message.belongToOperationEvent);
                        if (message.positionIdFromEvent != null && Object.hasOwnProperty.call(message, "positionIdFromEvent"))
                            writer.uint32(/* id 101, wireType 0 =*/808).int64(message.positionIdFromEvent);
                        if (message.positionLevelFromEvent != null && Object.hasOwnProperty.call(message, "positionLevelFromEvent"))
                            writer.uint32(/* id 102, wireType 0 =*/816).int32(message.positionLevelFromEvent);
                        if (message.employmentTypeFromEvent != null && Object.hasOwnProperty.call(message, "employmentTypeFromEvent"))
                            writer.uint32(/* id 103, wireType 0 =*/824).int32(message.employmentTypeFromEvent);
                        if (message.genderFromEvent != null && Object.hasOwnProperty.call(message, "genderFromEvent"))
                            writer.uint32(/* id 104, wireType 0 =*/832).int32(message.genderFromEvent);
                        if (message.areaIdFromEvent != null && Object.hasOwnProperty.call(message, "areaIdFromEvent"))
                            writer.uint32(/* id 105, wireType 0 =*/840).int64(message.areaIdFromEvent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftTemplate message, length delimited. Does not implicitly {@link palexy.streaming.v1.ShiftTemplate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {palexy.streaming.v1.IShiftTemplate} message ShiftTemplate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftTemplate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftTemplate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ShiftTemplate} ShiftTemplate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftTemplate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ShiftTemplate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.shiftName = reader.string();
                                break;
                            case 4:
                                message.note = reader.string();
                                break;
                            case 5:
                                message.startTime = reader.string();
                                break;
                            case 6:
                                message.endTime = reader.string();
                                break;
                            case 7:
                                message.isCrossDayShift = reader.bool();
                                break;
                            case 8:
                                message.color = reader.string();
                                break;
                            case 9:
                                message.creatorId = reader.int64();
                                break;
                            case 10:
                                message.staffPositionId = reader.int64();
                                break;
                            case 11:
                                message.createTimeMs = reader.int64();
                                break;
                            case 12:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 13:
                                message.creator = $root.palexy.streaming.v1.Account.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.staffPosition = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.isCommonTemplate = reader.bool();
                                break;
                            case 16:
                                if (!(message.breakTimes && message.breakTimes.length))
                                    message.breakTimes = [];
                                message.breakTimes.push($root.palexy.protobuf.BreakTime.decode(reader, reader.uint32()));
                                break;
                            case 17:
                                message.templateLevel = reader.int32();
                                break;
                            case 18:
                                message.storeId = reader.int64();
                                break;
                            case 19:
                                message.storeName = reader.string();
                                break;
                            case 100:
                                message.belongToOperationEvent = reader.bool();
                                break;
                            case 101:
                                message.positionIdFromEvent = reader.int64();
                                break;
                            case 102:
                                message.positionLevelFromEvent = reader.int32();
                                break;
                            case 103:
                                message.employmentTypeFromEvent = reader.int32();
                                break;
                            case 104:
                                message.genderFromEvent = reader.int32();
                                break;
                            case 105:
                                message.areaIdFromEvent = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftTemplate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ShiftTemplate} ShiftTemplate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftTemplate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftTemplate message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftTemplate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            if (!$util.isString(message.shiftName))
                                return "shiftName: string expected";
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            if (typeof message.isCrossDayShift !== "boolean")
                                return "isCrossDayShift: boolean expected";
                        if (message.color != null && message.hasOwnProperty("color"))
                            if (!$util.isString(message.color))
                                return "color: string expected";
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (!$util.isInteger(message.staffPositionId) && !(message.staffPositionId && $util.isInteger(message.staffPositionId.low) && $util.isInteger(message.staffPositionId.high)))
                                return "staffPositionId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.creator != null && message.hasOwnProperty("creator")) {
                            var error = $root.palexy.streaming.v1.Account.verify(message.creator);
                            if (error)
                                return "creator." + error;
                        }
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPosition);
                            if (error)
                                return "staffPosition." + error;
                        }
                        if (message.isCommonTemplate != null && message.hasOwnProperty("isCommonTemplate"))
                            if (typeof message.isCommonTemplate !== "boolean")
                                return "isCommonTemplate: boolean expected";
                        if (message.breakTimes != null && message.hasOwnProperty("breakTimes")) {
                            if (!Array.isArray(message.breakTimes))
                                return "breakTimes: array expected";
                            for (var i = 0; i < message.breakTimes.length; ++i) {
                                var error = $root.palexy.protobuf.BreakTime.verify(message.breakTimes[i]);
                                if (error)
                                    return "breakTimes." + error;
                            }
                        }
                        if (message.templateLevel != null && message.hasOwnProperty("templateLevel"))
                            switch (message.templateLevel) {
                            default:
                                return "templateLevel: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            if (!$util.isString(message.storeName))
                                return "storeName: string expected";
                        if (message.belongToOperationEvent != null && message.hasOwnProperty("belongToOperationEvent"))
                            if (typeof message.belongToOperationEvent !== "boolean")
                                return "belongToOperationEvent: boolean expected";
                        if (message.positionIdFromEvent != null && message.hasOwnProperty("positionIdFromEvent"))
                            if (!$util.isInteger(message.positionIdFromEvent) && !(message.positionIdFromEvent && $util.isInteger(message.positionIdFromEvent.low) && $util.isInteger(message.positionIdFromEvent.high)))
                                return "positionIdFromEvent: integer|Long expected";
                        if (message.positionLevelFromEvent != null && message.hasOwnProperty("positionLevelFromEvent"))
                            if (!$util.isInteger(message.positionLevelFromEvent))
                                return "positionLevelFromEvent: integer expected";
                        if (message.employmentTypeFromEvent != null && message.hasOwnProperty("employmentTypeFromEvent"))
                            switch (message.employmentTypeFromEvent) {
                            default:
                                return "employmentTypeFromEvent: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.genderFromEvent != null && message.hasOwnProperty("genderFromEvent"))
                            switch (message.genderFromEvent) {
                            default:
                                return "genderFromEvent: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.areaIdFromEvent != null && message.hasOwnProperty("areaIdFromEvent"))
                            if (!$util.isInteger(message.areaIdFromEvent) && !(message.areaIdFromEvent && $util.isInteger(message.areaIdFromEvent.low) && $util.isInteger(message.areaIdFromEvent.high)))
                                return "areaIdFromEvent: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftTemplate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ShiftTemplate} ShiftTemplate
                     */
                    ShiftTemplate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ShiftTemplate)
                            return object;
                        var message = new $root.palexy.streaming.v1.ShiftTemplate();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.shiftName != null)
                            message.shiftName = String(object.shiftName);
                        if (object.note != null)
                            message.note = String(object.note);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.isCrossDayShift != null)
                            message.isCrossDayShift = Boolean(object.isCrossDayShift);
                        if (object.color != null)
                            message.color = String(object.color);
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        if (object.staffPositionId != null)
                            if ($util.Long)
                                (message.staffPositionId = $util.Long.fromValue(object.staffPositionId)).unsigned = false;
                            else if (typeof object.staffPositionId === "string")
                                message.staffPositionId = parseInt(object.staffPositionId, 10);
                            else if (typeof object.staffPositionId === "number")
                                message.staffPositionId = object.staffPositionId;
                            else if (typeof object.staffPositionId === "object")
                                message.staffPositionId = new $util.LongBits(object.staffPositionId.low >>> 0, object.staffPositionId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.creator != null) {
                            if (typeof object.creator !== "object")
                                throw TypeError(".palexy.streaming.v1.ShiftTemplate.creator: object expected");
                            message.creator = $root.palexy.streaming.v1.Account.fromObject(object.creator);
                        }
                        if (object.staffPosition != null) {
                            if (typeof object.staffPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.ShiftTemplate.staffPosition: object expected");
                            message.staffPosition = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPosition);
                        }
                        if (object.isCommonTemplate != null)
                            message.isCommonTemplate = Boolean(object.isCommonTemplate);
                        if (object.breakTimes) {
                            if (!Array.isArray(object.breakTimes))
                                throw TypeError(".palexy.streaming.v1.ShiftTemplate.breakTimes: array expected");
                            message.breakTimes = [];
                            for (var i = 0; i < object.breakTimes.length; ++i) {
                                if (typeof object.breakTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ShiftTemplate.breakTimes: object expected");
                                message.breakTimes[i] = $root.palexy.protobuf.BreakTime.fromObject(object.breakTimes[i]);
                            }
                        }
                        switch (object.templateLevel) {
                        case "UNKNOWN_TEMPLATE_LEVEL":
                        case 0:
                            message.templateLevel = 0;
                            break;
                        case "COMPANY":
                        case 1:
                            message.templateLevel = 1;
                            break;
                        case "STORE":
                        case 2:
                            message.templateLevel = 2;
                            break;
                        case "STORE_GROUP":
                        case 3:
                            message.templateLevel = 3;
                            break;
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.storeName != null)
                            message.storeName = String(object.storeName);
                        if (object.belongToOperationEvent != null)
                            message.belongToOperationEvent = Boolean(object.belongToOperationEvent);
                        if (object.positionIdFromEvent != null)
                            if ($util.Long)
                                (message.positionIdFromEvent = $util.Long.fromValue(object.positionIdFromEvent)).unsigned = false;
                            else if (typeof object.positionIdFromEvent === "string")
                                message.positionIdFromEvent = parseInt(object.positionIdFromEvent, 10);
                            else if (typeof object.positionIdFromEvent === "number")
                                message.positionIdFromEvent = object.positionIdFromEvent;
                            else if (typeof object.positionIdFromEvent === "object")
                                message.positionIdFromEvent = new $util.LongBits(object.positionIdFromEvent.low >>> 0, object.positionIdFromEvent.high >>> 0).toNumber();
                        if (object.positionLevelFromEvent != null)
                            message.positionLevelFromEvent = object.positionLevelFromEvent | 0;
                        switch (object.employmentTypeFromEvent) {
                        case "UNKNOWN_STAFF_EMPLOYMENT_TYPE":
                        case 0:
                            message.employmentTypeFromEvent = 0;
                            break;
                        case "FULL_TIME":
                        case 1:
                            message.employmentTypeFromEvent = 1;
                            break;
                        case "PART_TIME":
                        case 2:
                            message.employmentTypeFromEvent = 2;
                            break;
                        case "EXTERNAL_STAFF":
                        case 3:
                            message.employmentTypeFromEvent = 3;
                            break;
                        }
                        switch (object.genderFromEvent) {
                        case "GENDER_UNSPECIFIED":
                        case 0:
                            message.genderFromEvent = 0;
                            break;
                        case "MALE":
                        case 1:
                            message.genderFromEvent = 1;
                            break;
                        case "FEMALE":
                        case 2:
                            message.genderFromEvent = 2;
                            break;
                        }
                        if (object.areaIdFromEvent != null)
                            if ($util.Long)
                                (message.areaIdFromEvent = $util.Long.fromValue(object.areaIdFromEvent)).unsigned = false;
                            else if (typeof object.areaIdFromEvent === "string")
                                message.areaIdFromEvent = parseInt(object.areaIdFromEvent, 10);
                            else if (typeof object.areaIdFromEvent === "number")
                                message.areaIdFromEvent = object.areaIdFromEvent;
                            else if (typeof object.areaIdFromEvent === "object")
                                message.areaIdFromEvent = new $util.LongBits(object.areaIdFromEvent.low >>> 0, object.areaIdFromEvent.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftTemplate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @static
                     * @param {palexy.streaming.v1.ShiftTemplate} message ShiftTemplate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftTemplate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.breakTimes = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.shiftName = "";
                            object.note = "";
                            object.startTime = "";
                            object.endTime = "";
                            object.isCrossDayShift = false;
                            object.color = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffPositionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffPositionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.creator = null;
                            object.staffPosition = null;
                            object.isCommonTemplate = false;
                            object.templateLevel = options.enums === String ? "UNKNOWN_TEMPLATE_LEVEL" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.storeName = "";
                            object.belongToOperationEvent = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.positionIdFromEvent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.positionIdFromEvent = options.longs === String ? "0" : 0;
                            object.positionLevelFromEvent = 0;
                            object.employmentTypeFromEvent = options.enums === String ? "UNKNOWN_STAFF_EMPLOYMENT_TYPE" : 0;
                            object.genderFromEvent = options.enums === String ? "GENDER_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.areaIdFromEvent = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.areaIdFromEvent = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            object.shiftName = message.shiftName;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            object.isCrossDayShift = message.isCrossDayShift;
                        if (message.color != null && message.hasOwnProperty("color"))
                            object.color = message.color;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (typeof message.staffPositionId === "number")
                                object.staffPositionId = options.longs === String ? String(message.staffPositionId) : message.staffPositionId;
                            else
                                object.staffPositionId = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionId) : options.longs === Number ? new $util.LongBits(message.staffPositionId.low >>> 0, message.staffPositionId.high >>> 0).toNumber() : message.staffPositionId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            object.creator = $root.palexy.streaming.v1.Account.toObject(message.creator, options);
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition"))
                            object.staffPosition = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPosition, options);
                        if (message.isCommonTemplate != null && message.hasOwnProperty("isCommonTemplate"))
                            object.isCommonTemplate = message.isCommonTemplate;
                        if (message.breakTimes && message.breakTimes.length) {
                            object.breakTimes = [];
                            for (var j = 0; j < message.breakTimes.length; ++j)
                                object.breakTimes[j] = $root.palexy.protobuf.BreakTime.toObject(message.breakTimes[j], options);
                        }
                        if (message.templateLevel != null && message.hasOwnProperty("templateLevel"))
                            object.templateLevel = options.enums === String ? $root.palexy.streaming.v1.ShiftTemplateLevel[message.templateLevel] : message.templateLevel;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            object.storeName = message.storeName;
                        if (message.belongToOperationEvent != null && message.hasOwnProperty("belongToOperationEvent"))
                            object.belongToOperationEvent = message.belongToOperationEvent;
                        if (message.positionIdFromEvent != null && message.hasOwnProperty("positionIdFromEvent"))
                            if (typeof message.positionIdFromEvent === "number")
                                object.positionIdFromEvent = options.longs === String ? String(message.positionIdFromEvent) : message.positionIdFromEvent;
                            else
                                object.positionIdFromEvent = options.longs === String ? $util.Long.prototype.toString.call(message.positionIdFromEvent) : options.longs === Number ? new $util.LongBits(message.positionIdFromEvent.low >>> 0, message.positionIdFromEvent.high >>> 0).toNumber() : message.positionIdFromEvent;
                        if (message.positionLevelFromEvent != null && message.hasOwnProperty("positionLevelFromEvent"))
                            object.positionLevelFromEvent = message.positionLevelFromEvent;
                        if (message.employmentTypeFromEvent != null && message.hasOwnProperty("employmentTypeFromEvent"))
                            object.employmentTypeFromEvent = options.enums === String ? $root.palexy.protobuf.StaffEmploymentType[message.employmentTypeFromEvent] : message.employmentTypeFromEvent;
                        if (message.genderFromEvent != null && message.hasOwnProperty("genderFromEvent"))
                            object.genderFromEvent = options.enums === String ? $root.palexy.protobuf.Gender[message.genderFromEvent] : message.genderFromEvent;
                        if (message.areaIdFromEvent != null && message.hasOwnProperty("areaIdFromEvent"))
                            if (typeof message.areaIdFromEvent === "number")
                                object.areaIdFromEvent = options.longs === String ? String(message.areaIdFromEvent) : message.areaIdFromEvent;
                            else
                                object.areaIdFromEvent = options.longs === String ? $util.Long.prototype.toString.call(message.areaIdFromEvent) : options.longs === Number ? new $util.LongBits(message.areaIdFromEvent.low >>> 0, message.areaIdFromEvent.high >>> 0).toNumber() : message.areaIdFromEvent;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftTemplate to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ShiftTemplate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftTemplate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftTemplate;
                })();
    
                /**
                 * ShiftTemplateLevel enum.
                 * @name palexy.streaming.v1.ShiftTemplateLevel
                 * @enum {number}
                 * @property {number} UNKNOWN_TEMPLATE_LEVEL=0 UNKNOWN_TEMPLATE_LEVEL value
                 * @property {number} COMPANY=1 COMPANY value
                 * @property {number} STORE=2 STORE value
                 * @property {number} STORE_GROUP=3 STORE_GROUP value
                 */
                v1.ShiftTemplateLevel = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_TEMPLATE_LEVEL"] = 0;
                    values[valuesById[1] = "COMPANY"] = 1;
                    values[valuesById[2] = "STORE"] = 2;
                    values[valuesById[3] = "STORE_GROUP"] = 3;
                    return values;
                })();
    
                v1.DraftCreateStaffShiftRequest = (function() {
    
                    /**
                     * Properties of a DraftCreateStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftCreateStaffShiftRequest
                     * @property {palexy.streaming.v1.IStaffShift|null} [staffShift] DraftCreateStaffShiftRequest staffShift
                     */
    
                    /**
                     * Constructs a new DraftCreateStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftCreateStaffShiftRequest.
                     * @implements IDraftCreateStaffShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest=} [properties] Properties to set
                     */
                    function DraftCreateStaffShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftCreateStaffShiftRequest staffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} staffShift
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @instance
                     */
                    DraftCreateStaffShiftRequest.prototype.staffShift = null;
    
                    /**
                     * Creates a new DraftCreateStaffShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftCreateStaffShiftRequest} DraftCreateStaffShiftRequest instance
                     */
                    DraftCreateStaffShiftRequest.create = function create(properties) {
                        return new DraftCreateStaffShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftCreateStaffShiftRequest message. Does not implicitly {@link palexy.streaming.v1.DraftCreateStaffShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest} message DraftCreateStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftCreateStaffShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShift != null && Object.hasOwnProperty.call(message, "staffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.staffShift, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftCreateStaffShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftCreateStaffShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest} message DraftCreateStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftCreateStaffShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftCreateStaffShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftCreateStaffShiftRequest} DraftCreateStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftCreateStaffShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftCreateStaffShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftCreateStaffShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftCreateStaffShiftRequest} DraftCreateStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftCreateStaffShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftCreateStaffShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftCreateStaffShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShift != null && message.hasOwnProperty("staffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShift);
                            if (error)
                                return "staffShift." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftCreateStaffShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftCreateStaffShiftRequest} DraftCreateStaffShiftRequest
                     */
                    DraftCreateStaffShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftCreateStaffShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftCreateStaffShiftRequest();
                        if (object.staffShift != null) {
                            if (typeof object.staffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftCreateStaffShiftRequest.staffShift: object expected");
                            message.staffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShift);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftCreateStaffShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftCreateStaffShiftRequest} message DraftCreateStaffShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftCreateStaffShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffShift = null;
                        if (message.staffShift != null && message.hasOwnProperty("staffShift"))
                            object.staffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShift, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftCreateStaffShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftCreateStaffShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftCreateStaffShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftCreateStaffShiftRequest;
                })();
    
                v1.DraftEditStaffShiftRequest = (function() {
    
                    /**
                     * Properties of a DraftEditStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftEditStaffShiftRequest
                     * @property {palexy.streaming.v1.IStaffShift|null} [staffShift] DraftEditStaffShiftRequest staffShift
                     * @property {google.protobuf.IFieldMask|null} [updateMask] DraftEditStaffShiftRequest updateMask
                     */
    
                    /**
                     * Constructs a new DraftEditStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftEditStaffShiftRequest.
                     * @implements IDraftEditStaffShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest=} [properties] Properties to set
                     */
                    function DraftEditStaffShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftEditStaffShiftRequest staffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} staffShift
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @instance
                     */
                    DraftEditStaffShiftRequest.prototype.staffShift = null;
    
                    /**
                     * DraftEditStaffShiftRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @instance
                     */
                    DraftEditStaffShiftRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new DraftEditStaffShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftEditStaffShiftRequest} DraftEditStaffShiftRequest instance
                     */
                    DraftEditStaffShiftRequest.create = function create(properties) {
                        return new DraftEditStaffShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftEditStaffShiftRequest message. Does not implicitly {@link palexy.streaming.v1.DraftEditStaffShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest} message DraftEditStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftEditStaffShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShift != null && Object.hasOwnProperty.call(message, "staffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.staffShift, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftEditStaffShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftEditStaffShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest} message DraftEditStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftEditStaffShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftEditStaffShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftEditStaffShiftRequest} DraftEditStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftEditStaffShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftEditStaffShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftEditStaffShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftEditStaffShiftRequest} DraftEditStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftEditStaffShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftEditStaffShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftEditStaffShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShift != null && message.hasOwnProperty("staffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShift);
                            if (error)
                                return "staffShift." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftEditStaffShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftEditStaffShiftRequest} DraftEditStaffShiftRequest
                     */
                    DraftEditStaffShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftEditStaffShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftEditStaffShiftRequest();
                        if (object.staffShift != null) {
                            if (typeof object.staffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftEditStaffShiftRequest.staffShift: object expected");
                            message.staffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShift);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftEditStaffShiftRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftEditStaffShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftEditStaffShiftRequest} message DraftEditStaffShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftEditStaffShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staffShift = null;
                            object.updateMask = null;
                        }
                        if (message.staffShift != null && message.hasOwnProperty("staffShift"))
                            object.staffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShift, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftEditStaffShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftEditStaffShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftEditStaffShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftEditStaffShiftRequest;
                })();
    
                v1.SwapStaffShiftsRequest = (function() {
    
                    /**
                     * Properties of a SwapStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ISwapStaffShiftsRequest
                     * @property {number|null} [firstShiftId] SwapStaffShiftsRequest firstShiftId
                     * @property {number|null} [secondShiftId] SwapStaffShiftsRequest secondShiftId
                     */
    
                    /**
                     * Constructs a new SwapStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SwapStaffShiftsRequest.
                     * @implements ISwapStaffShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest=} [properties] Properties to set
                     */
                    function SwapStaffShiftsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SwapStaffShiftsRequest firstShiftId.
                     * @member {number} firstShiftId
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @instance
                     */
                    SwapStaffShiftsRequest.prototype.firstShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SwapStaffShiftsRequest secondShiftId.
                     * @member {number} secondShiftId
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @instance
                     */
                    SwapStaffShiftsRequest.prototype.secondShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SwapStaffShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SwapStaffShiftsRequest} SwapStaffShiftsRequest instance
                     */
                    SwapStaffShiftsRequest.create = function create(properties) {
                        return new SwapStaffShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SwapStaffShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.SwapStaffShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest} message SwapStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SwapStaffShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.firstShiftId != null && Object.hasOwnProperty.call(message, "firstShiftId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.firstShiftId);
                        if (message.secondShiftId != null && Object.hasOwnProperty.call(message, "secondShiftId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.secondShiftId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SwapStaffShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.SwapStaffShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest} message SwapStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SwapStaffShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SwapStaffShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SwapStaffShiftsRequest} SwapStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SwapStaffShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SwapStaffShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.firstShiftId = reader.int64();
                                break;
                            case 2:
                                message.secondShiftId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SwapStaffShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SwapStaffShiftsRequest} SwapStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SwapStaffShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SwapStaffShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SwapStaffShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.firstShiftId != null && message.hasOwnProperty("firstShiftId"))
                            if (!$util.isInteger(message.firstShiftId) && !(message.firstShiftId && $util.isInteger(message.firstShiftId.low) && $util.isInteger(message.firstShiftId.high)))
                                return "firstShiftId: integer|Long expected";
                        if (message.secondShiftId != null && message.hasOwnProperty("secondShiftId"))
                            if (!$util.isInteger(message.secondShiftId) && !(message.secondShiftId && $util.isInteger(message.secondShiftId.low) && $util.isInteger(message.secondShiftId.high)))
                                return "secondShiftId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SwapStaffShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SwapStaffShiftsRequest} SwapStaffShiftsRequest
                     */
                    SwapStaffShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SwapStaffShiftsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.SwapStaffShiftsRequest();
                        if (object.firstShiftId != null)
                            if ($util.Long)
                                (message.firstShiftId = $util.Long.fromValue(object.firstShiftId)).unsigned = false;
                            else if (typeof object.firstShiftId === "string")
                                message.firstShiftId = parseInt(object.firstShiftId, 10);
                            else if (typeof object.firstShiftId === "number")
                                message.firstShiftId = object.firstShiftId;
                            else if (typeof object.firstShiftId === "object")
                                message.firstShiftId = new $util.LongBits(object.firstShiftId.low >>> 0, object.firstShiftId.high >>> 0).toNumber();
                        if (object.secondShiftId != null)
                            if ($util.Long)
                                (message.secondShiftId = $util.Long.fromValue(object.secondShiftId)).unsigned = false;
                            else if (typeof object.secondShiftId === "string")
                                message.secondShiftId = parseInt(object.secondShiftId, 10);
                            else if (typeof object.secondShiftId === "number")
                                message.secondShiftId = object.secondShiftId;
                            else if (typeof object.secondShiftId === "object")
                                message.secondShiftId = new $util.LongBits(object.secondShiftId.low >>> 0, object.secondShiftId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SwapStaffShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.SwapStaffShiftsRequest} message SwapStaffShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SwapStaffShiftsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.firstShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.firstShiftId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.secondShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.secondShiftId = options.longs === String ? "0" : 0;
                        }
                        if (message.firstShiftId != null && message.hasOwnProperty("firstShiftId"))
                            if (typeof message.firstShiftId === "number")
                                object.firstShiftId = options.longs === String ? String(message.firstShiftId) : message.firstShiftId;
                            else
                                object.firstShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.firstShiftId) : options.longs === Number ? new $util.LongBits(message.firstShiftId.low >>> 0, message.firstShiftId.high >>> 0).toNumber() : message.firstShiftId;
                        if (message.secondShiftId != null && message.hasOwnProperty("secondShiftId"))
                            if (typeof message.secondShiftId === "number")
                                object.secondShiftId = options.longs === String ? String(message.secondShiftId) : message.secondShiftId;
                            else
                                object.secondShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.secondShiftId) : options.longs === Number ? new $util.LongBits(message.secondShiftId.low >>> 0, message.secondShiftId.high >>> 0).toNumber() : message.secondShiftId;
                        return object;
                    };
    
                    /**
                     * Converts this SwapStaffShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SwapStaffShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SwapStaffShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SwapStaffShiftsRequest;
                })();
    
                v1.SwapStaffShiftsResponse = (function() {
    
                    /**
                     * Properties of a SwapStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ISwapStaffShiftsResponse
                     * @property {palexy.streaming.v1.IStaffShift|null} [firstShift] SwapStaffShiftsResponse firstShift
                     * @property {palexy.streaming.v1.IStaffShift|null} [secondShift] SwapStaffShiftsResponse secondShift
                     */
    
                    /**
                     * Constructs a new SwapStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a SwapStaffShiftsResponse.
                     * @implements ISwapStaffShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ISwapStaffShiftsResponse=} [properties] Properties to set
                     */
                    function SwapStaffShiftsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SwapStaffShiftsResponse firstShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} firstShift
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @instance
                     */
                    SwapStaffShiftsResponse.prototype.firstShift = null;
    
                    /**
                     * SwapStaffShiftsResponse secondShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} secondShift
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @instance
                     */
                    SwapStaffShiftsResponse.prototype.secondShift = null;
    
                    /**
                     * Creates a new SwapStaffShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.SwapStaffShiftsResponse} SwapStaffShiftsResponse instance
                     */
                    SwapStaffShiftsResponse.create = function create(properties) {
                        return new SwapStaffShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SwapStaffShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.SwapStaffShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsResponse} message SwapStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SwapStaffShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.firstShift != null && Object.hasOwnProperty.call(message, "firstShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.firstShift, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.secondShift != null && Object.hasOwnProperty.call(message, "secondShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.secondShift, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SwapStaffShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.SwapStaffShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ISwapStaffShiftsResponse} message SwapStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SwapStaffShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SwapStaffShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.SwapStaffShiftsResponse} SwapStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SwapStaffShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.SwapStaffShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.firstShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.secondShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SwapStaffShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.SwapStaffShiftsResponse} SwapStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SwapStaffShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SwapStaffShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SwapStaffShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.firstShift != null && message.hasOwnProperty("firstShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.firstShift);
                            if (error)
                                return "firstShift." + error;
                        }
                        if (message.secondShift != null && message.hasOwnProperty("secondShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.secondShift);
                            if (error)
                                return "secondShift." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SwapStaffShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.SwapStaffShiftsResponse} SwapStaffShiftsResponse
                     */
                    SwapStaffShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.SwapStaffShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.SwapStaffShiftsResponse();
                        if (object.firstShift != null) {
                            if (typeof object.firstShift !== "object")
                                throw TypeError(".palexy.streaming.v1.SwapStaffShiftsResponse.firstShift: object expected");
                            message.firstShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.firstShift);
                        }
                        if (object.secondShift != null) {
                            if (typeof object.secondShift !== "object")
                                throw TypeError(".palexy.streaming.v1.SwapStaffShiftsResponse.secondShift: object expected");
                            message.secondShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.secondShift);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SwapStaffShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.SwapStaffShiftsResponse} message SwapStaffShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SwapStaffShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.firstShift = null;
                            object.secondShift = null;
                        }
                        if (message.firstShift != null && message.hasOwnProperty("firstShift"))
                            object.firstShift = $root.palexy.streaming.v1.StaffShift.toObject(message.firstShift, options);
                        if (message.secondShift != null && message.hasOwnProperty("secondShift"))
                            object.secondShift = $root.palexy.streaming.v1.StaffShift.toObject(message.secondShift, options);
                        return object;
                    };
    
                    /**
                     * Converts this SwapStaffShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.SwapStaffShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SwapStaffShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SwapStaffShiftsResponse;
                })();
    
                v1.DraftDeleteStaffShiftRequest = (function() {
    
                    /**
                     * Properties of a DraftDeleteStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftDeleteStaffShiftRequest
                     * @property {number|null} [staffShiftId] DraftDeleteStaffShiftRequest staffShiftId
                     * @property {number|null} [updateTimeMs] DraftDeleteStaffShiftRequest updateTimeMs
                     */
    
                    /**
                     * Constructs a new DraftDeleteStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftDeleteStaffShiftRequest.
                     * @implements IDraftDeleteStaffShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest=} [properties] Properties to set
                     */
                    function DraftDeleteStaffShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftDeleteStaffShiftRequest staffShiftId.
                     * @member {number} staffShiftId
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @instance
                     */
                    DraftDeleteStaffShiftRequest.prototype.staffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DraftDeleteStaffShiftRequest updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @instance
                     */
                    DraftDeleteStaffShiftRequest.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DraftDeleteStaffShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftRequest} DraftDeleteStaffShiftRequest instance
                     */
                    DraftDeleteStaffShiftRequest.create = function create(properties) {
                        return new DraftDeleteStaffShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffShiftRequest message. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest} message DraftDeleteStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftId != null && Object.hasOwnProperty.call(message, "staffShiftId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffShiftId);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest} message DraftDeleteStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftRequest} DraftDeleteStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftDeleteStaffShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShiftId = reader.int64();
                                break;
                            case 2:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftRequest} DraftDeleteStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftDeleteStaffShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftDeleteStaffShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (!$util.isInteger(message.staffShiftId) && !(message.staffShiftId && $util.isInteger(message.staffShiftId.low) && $util.isInteger(message.staffShiftId.high)))
                                return "staffShiftId: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DraftDeleteStaffShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftRequest} DraftDeleteStaffShiftRequest
                     */
                    DraftDeleteStaffShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftDeleteStaffShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftDeleteStaffShiftRequest();
                        if (object.staffShiftId != null)
                            if ($util.Long)
                                (message.staffShiftId = $util.Long.fromValue(object.staffShiftId)).unsigned = false;
                            else if (typeof object.staffShiftId === "string")
                                message.staffShiftId = parseInt(object.staffShiftId, 10);
                            else if (typeof object.staffShiftId === "number")
                                message.staffShiftId = object.staffShiftId;
                            else if (typeof object.staffShiftId === "object")
                                message.staffShiftId = new $util.LongBits(object.staffShiftId.low >>> 0, object.staffShiftId.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftDeleteStaffShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftDeleteStaffShiftRequest} message DraftDeleteStaffShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftDeleteStaffShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (typeof message.staffShiftId === "number")
                                object.staffShiftId = options.longs === String ? String(message.staffShiftId) : message.staffShiftId;
                            else
                                object.staffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftId) : options.longs === Number ? new $util.LongBits(message.staffShiftId.low >>> 0, message.staffShiftId.high >>> 0).toNumber() : message.staffShiftId;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this DraftDeleteStaffShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftDeleteStaffShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftDeleteStaffShiftRequest;
                })();
    
                v1.DraftDeleteStaffShiftResponse = (function() {
    
                    /**
                     * Properties of a DraftDeleteStaffShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftDeleteStaffShiftResponse
                     * @property {palexy.streaming.v1.IStaffShift|null} [staffShift] DraftDeleteStaffShiftResponse staffShift
                     */
    
                    /**
                     * Constructs a new DraftDeleteStaffShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftDeleteStaffShiftResponse.
                     * @implements IDraftDeleteStaffShiftResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftResponse=} [properties] Properties to set
                     */
                    function DraftDeleteStaffShiftResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftDeleteStaffShiftResponse staffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} staffShift
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @instance
                     */
                    DraftDeleteStaffShiftResponse.prototype.staffShift = null;
    
                    /**
                     * Creates a new DraftDeleteStaffShiftResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftResponse} DraftDeleteStaffShiftResponse instance
                     */
                    DraftDeleteStaffShiftResponse.create = function create(properties) {
                        return new DraftDeleteStaffShiftResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffShiftResponse message. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffShiftResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftResponse} message DraftDeleteStaffShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffShiftResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShift != null && Object.hasOwnProperty.call(message, "staffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.staffShift, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffShiftResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffShiftResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftResponse} message DraftDeleteStaffShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffShiftResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffShiftResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftResponse} DraftDeleteStaffShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffShiftResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftDeleteStaffShiftResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffShiftResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftResponse} DraftDeleteStaffShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffShiftResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftDeleteStaffShiftResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftDeleteStaffShiftResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShift != null && message.hasOwnProperty("staffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShift);
                            if (error)
                                return "staffShift." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftDeleteStaffShiftResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftDeleteStaffShiftResponse} DraftDeleteStaffShiftResponse
                     */
                    DraftDeleteStaffShiftResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftDeleteStaffShiftResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftDeleteStaffShiftResponse();
                        if (object.staffShift != null) {
                            if (typeof object.staffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftDeleteStaffShiftResponse.staffShift: object expected");
                            message.staffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShift);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftDeleteStaffShiftResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.DraftDeleteStaffShiftResponse} message DraftDeleteStaffShiftResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftDeleteStaffShiftResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffShift = null;
                        if (message.staffShift != null && message.hasOwnProperty("staffShift"))
                            object.staffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShift, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftDeleteStaffShiftResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftDeleteStaffShiftResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftDeleteStaffShiftResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftDeleteStaffShiftResponse;
                })();
    
                v1.GetStaffShiftRequest = (function() {
    
                    /**
                     * Properties of a GetStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffShiftRequest
                     * @property {number|null} [staffShiftId] GetStaffShiftRequest staffShiftId
                     */
    
                    /**
                     * Constructs a new GetStaffShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffShiftRequest.
                     * @implements IGetStaffShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest=} [properties] Properties to set
                     */
                    function GetStaffShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffShiftRequest staffShiftId.
                     * @member {number} staffShiftId
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @instance
                     */
                    GetStaffShiftRequest.prototype.staffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffShiftRequest} GetStaffShiftRequest instance
                     */
                    GetStaffShiftRequest.create = function create(properties) {
                        return new GetStaffShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffShiftRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest} message GetStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftId != null && Object.hasOwnProperty.call(message, "staffShiftId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffShiftId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest} message GetStaffShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffShiftRequest} GetStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShiftId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffShiftRequest} GetStaffShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (!$util.isInteger(message.staffShiftId) && !(message.staffShiftId && $util.isInteger(message.staffShiftId.low) && $util.isInteger(message.staffShiftId.high)))
                                return "staffShiftId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffShiftRequest} GetStaffShiftRequest
                     */
                    GetStaffShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffShiftRequest();
                        if (object.staffShiftId != null)
                            if ($util.Long)
                                (message.staffShiftId = $util.Long.fromValue(object.staffShiftId)).unsigned = false;
                            else if (typeof object.staffShiftId === "string")
                                message.staffShiftId = parseInt(object.staffShiftId, 10);
                            else if (typeof object.staffShiftId === "number")
                                message.staffShiftId = object.staffShiftId;
                            else if (typeof object.staffShiftId === "object")
                                message.staffShiftId = new $util.LongBits(object.staffShiftId.low >>> 0, object.staffShiftId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffShiftRequest} message GetStaffShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftId = options.longs === String ? "0" : 0;
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (typeof message.staffShiftId === "number")
                                object.staffShiftId = options.longs === String ? String(message.staffShiftId) : message.staffShiftId;
                            else
                                object.staffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftId) : options.longs === Number ? new $util.LongBits(message.staffShiftId.low >>> 0, message.staffShiftId.high >>> 0).toNumber() : message.staffShiftId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffShiftRequest;
                })();
    
                v1.StaffShift = (function() {
    
                    /**
                     * Properties of a StaffShift.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffShift
                     * @property {number|null} [id] StaffShift id
                     * @property {number|null} [storeId] StaffShift storeId
                     * @property {number|null} [staffId] StaffShift staffId
                     * @property {number|null} [dateId] StaffShift dateId
                     * @property {string|null} [note] StaffShift note
                     * @property {string|null} [startTime] StaffShift startTime
                     * @property {string|null} [endTime] StaffShift endTime
                     * @property {boolean|null} [isCrossDayShift] StaffShift isCrossDayShift
                     * @property {string|null} [color] StaffShift color
                     * @property {string|null} [shiftName] StaffShift shiftName
                     * @property {number|null} [staffPositionId] StaffShift staffPositionId
                     * @property {number|null} [createTimeMs] StaffShift createTimeMs
                     * @property {number|null} [updateTimeMs] StaffShift updateTimeMs
                     * @property {number|null} [originalId] StaffShift originalId
                     * @property {palexy.streaming.v1.StaffScheduleState|null} [state] StaffShift state
                     * @property {number|null} [scheduleAreaId] StaffShift scheduleAreaId
                     * @property {palexy.streaming.v1.ScheduleOriginType|null} [originType] StaffShift originType
                     * @property {palexy.streaming.v1.IStaffPosition|null} [staffPosition] StaffShift staffPosition
                     * @property {palexy.streaming.v1.IStaff|null} [staff] StaffShift staff
                     * @property {palexy.streaming.v1.IScheduleArea|null} [scheduleArea] StaffShift scheduleArea
                     * @property {Array.<palexy.protobuf.IBreakTime>|null} [breakTimes] StaffShift breakTimes
                     * @property {palexy.streaming.v1.IStore|null} [store] StaffShift store
                     * @property {boolean|null} [isOpenToClaim] StaffShift isOpenToClaim
                     * @property {google.protobuf.IBoolValue|null} [belongToBorrowRequest] StaffShift belongToBorrowRequest
                     * @property {google.protobuf.IBoolValue|null} [requiredPosition] StaffShift requiredPosition
                     * @property {Array.<palexy.protobuf.INonCoverageTime>|null} [nonCoverageTimes] StaffShift nonCoverageTimes
                     */
    
                    /**
                     * Constructs a new StaffShift.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShift.
                     * @implements IStaffShift
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffShift=} [properties] Properties to set
                     */
                    function StaffShift(properties) {
                        this.breakTimes = [];
                        this.nonCoverageTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffShift id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.dateId = 0;
    
                    /**
                     * StaffShift note.
                     * @member {string} note
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.note = "";
    
                    /**
                     * StaffShift startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.startTime = "";
    
                    /**
                     * StaffShift endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.endTime = "";
    
                    /**
                     * StaffShift isCrossDayShift.
                     * @member {boolean} isCrossDayShift
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.isCrossDayShift = false;
    
                    /**
                     * StaffShift color.
                     * @member {string} color
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.color = "";
    
                    /**
                     * StaffShift shiftName.
                     * @member {string} shiftName
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.shiftName = "";
    
                    /**
                     * StaffShift staffPositionId.
                     * @member {number} staffPositionId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.staffPositionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift originalId.
                     * @member {number} originalId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.originalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift state.
                     * @member {palexy.streaming.v1.StaffScheduleState} state
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.state = 0;
    
                    /**
                     * StaffShift scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShift originType.
                     * @member {palexy.streaming.v1.ScheduleOriginType} originType
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.originType = 0;
    
                    /**
                     * StaffShift staffPosition.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} staffPosition
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.staffPosition = null;
    
                    /**
                     * StaffShift staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.staff = null;
    
                    /**
                     * StaffShift scheduleArea.
                     * @member {palexy.streaming.v1.IScheduleArea|null|undefined} scheduleArea
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.scheduleArea = null;
    
                    /**
                     * StaffShift breakTimes.
                     * @member {Array.<palexy.protobuf.IBreakTime>} breakTimes
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.breakTimes = $util.emptyArray;
    
                    /**
                     * StaffShift store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.store = null;
    
                    /**
                     * StaffShift isOpenToClaim.
                     * @member {boolean} isOpenToClaim
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.isOpenToClaim = false;
    
                    /**
                     * StaffShift belongToBorrowRequest.
                     * @member {google.protobuf.IBoolValue|null|undefined} belongToBorrowRequest
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.belongToBorrowRequest = null;
    
                    /**
                     * StaffShift requiredPosition.
                     * @member {google.protobuf.IBoolValue|null|undefined} requiredPosition
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.requiredPosition = null;
    
                    /**
                     * StaffShift nonCoverageTimes.
                     * @member {Array.<palexy.protobuf.INonCoverageTime>} nonCoverageTimes
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     */
                    StaffShift.prototype.nonCoverageTimes = $util.emptyArray;
    
                    /**
                     * Creates a new StaffShift instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {palexy.streaming.v1.IStaffShift=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffShift} StaffShift instance
                     */
                    StaffShift.create = function create(properties) {
                        return new StaffShift(properties);
                    };
    
                    /**
                     * Encodes the specified StaffShift message. Does not implicitly {@link palexy.streaming.v1.StaffShift.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {palexy.streaming.v1.IStaffShift} message StaffShift message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShift.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.note);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.endTime);
                        if (message.isCrossDayShift != null && Object.hasOwnProperty.call(message, "isCrossDayShift"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isCrossDayShift);
                        if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.color);
                        if (message.shiftName != null && Object.hasOwnProperty.call(message, "shiftName"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.shiftName);
                        if (message.staffPositionId != null && Object.hasOwnProperty.call(message, "staffPositionId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.staffPositionId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.updateTimeMs);
                        if (message.originalId != null && Object.hasOwnProperty.call(message, "originalId"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.originalId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.state);
                        if (message.staffPosition != null && Object.hasOwnProperty.call(message, "staffPosition"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.staffPosition, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int64(message.scheduleAreaId);
                        if (message.breakTimes != null && message.breakTimes.length)
                            for (var i = 0; i < message.breakTimes.length; ++i)
                                $root.palexy.protobuf.BreakTime.encode(message.breakTimes[i], writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.scheduleArea != null && Object.hasOwnProperty.call(message, "scheduleArea"))
                            $root.palexy.streaming.v1.ScheduleArea.encode(message.scheduleArea, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.originType != null && Object.hasOwnProperty.call(message, "originType"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.originType);
                        if (message.isOpenToClaim != null && Object.hasOwnProperty.call(message, "isOpenToClaim"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.isOpenToClaim);
                        if (message.belongToBorrowRequest != null && Object.hasOwnProperty.call(message, "belongToBorrowRequest"))
                            $root.google.protobuf.BoolValue.encode(message.belongToBorrowRequest, writer.uint32(/* id 24, wireType 2 =*/194).fork()).ldelim();
                        if (message.requiredPosition != null && Object.hasOwnProperty.call(message, "requiredPosition"))
                            $root.google.protobuf.BoolValue.encode(message.requiredPosition, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                        if (message.nonCoverageTimes != null && message.nonCoverageTimes.length)
                            for (var i = 0; i < message.nonCoverageTimes.length; ++i)
                                $root.palexy.protobuf.NonCoverageTime.encode(message.nonCoverageTimes[i], writer.uint32(/* id 26, wireType 2 =*/210).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffShift message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffShift.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {palexy.streaming.v1.IStaffShift} message StaffShift message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShift.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffShift message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffShift} StaffShift
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShift.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffShift();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.note = reader.string();
                                break;
                            case 6:
                                message.startTime = reader.string();
                                break;
                            case 7:
                                message.endTime = reader.string();
                                break;
                            case 8:
                                message.isCrossDayShift = reader.bool();
                                break;
                            case 9:
                                message.color = reader.string();
                                break;
                            case 10:
                                message.shiftName = reader.string();
                                break;
                            case 11:
                                message.staffPositionId = reader.int64();
                                break;
                            case 12:
                                message.createTimeMs = reader.int64();
                                break;
                            case 13:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 14:
                                message.originalId = reader.int64();
                                break;
                            case 15:
                                message.state = reader.int32();
                                break;
                            case 18:
                                message.scheduleAreaId = reader.int64();
                                break;
                            case 22:
                                message.originType = reader.int32();
                                break;
                            case 16:
                                message.staffPosition = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 21:
                                message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32());
                                break;
                            case 19:
                                if (!(message.breakTimes && message.breakTimes.length))
                                    message.breakTimes = [];
                                message.breakTimes.push($root.palexy.protobuf.BreakTime.decode(reader, reader.uint32()));
                                break;
                            case 20:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 23:
                                message.isOpenToClaim = reader.bool();
                                break;
                            case 24:
                                message.belongToBorrowRequest = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 25:
                                message.requiredPosition = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 26:
                                if (!(message.nonCoverageTimes && message.nonCoverageTimes.length))
                                    message.nonCoverageTimes = [];
                                message.nonCoverageTimes.push($root.palexy.protobuf.NonCoverageTime.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffShift message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffShift} StaffShift
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShift.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffShift message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffShift.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            if (typeof message.isCrossDayShift !== "boolean")
                                return "isCrossDayShift: boolean expected";
                        if (message.color != null && message.hasOwnProperty("color"))
                            if (!$util.isString(message.color))
                                return "color: string expected";
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            if (!$util.isString(message.shiftName))
                                return "shiftName: string expected";
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (!$util.isInteger(message.staffPositionId) && !(message.staffPositionId && $util.isInteger(message.staffPositionId.low) && $util.isInteger(message.staffPositionId.high)))
                                return "staffPositionId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.originalId != null && message.hasOwnProperty("originalId"))
                            if (!$util.isInteger(message.originalId) && !(message.originalId && $util.isInteger(message.originalId.low) && $util.isInteger(message.originalId.high)))
                                return "originalId: integer|Long expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        if (message.originType != null && message.hasOwnProperty("originType"))
                            switch (message.originType) {
                            default:
                                return "originType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPosition);
                            if (error)
                                return "staffPosition." + error;
                        }
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea")) {
                            var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.scheduleArea);
                            if (error)
                                return "scheduleArea." + error;
                        }
                        if (message.breakTimes != null && message.hasOwnProperty("breakTimes")) {
                            if (!Array.isArray(message.breakTimes))
                                return "breakTimes: array expected";
                            for (var i = 0; i < message.breakTimes.length; ++i) {
                                var error = $root.palexy.protobuf.BreakTime.verify(message.breakTimes[i]);
                                if (error)
                                    return "breakTimes." + error;
                            }
                        }
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.isOpenToClaim != null && message.hasOwnProperty("isOpenToClaim"))
                            if (typeof message.isOpenToClaim !== "boolean")
                                return "isOpenToClaim: boolean expected";
                        if (message.belongToBorrowRequest != null && message.hasOwnProperty("belongToBorrowRequest")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.belongToBorrowRequest);
                            if (error)
                                return "belongToBorrowRequest." + error;
                        }
                        if (message.requiredPosition != null && message.hasOwnProperty("requiredPosition")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.requiredPosition);
                            if (error)
                                return "requiredPosition." + error;
                        }
                        if (message.nonCoverageTimes != null && message.hasOwnProperty("nonCoverageTimes")) {
                            if (!Array.isArray(message.nonCoverageTimes))
                                return "nonCoverageTimes: array expected";
                            for (var i = 0; i < message.nonCoverageTimes.length; ++i) {
                                var error = $root.palexy.protobuf.NonCoverageTime.verify(message.nonCoverageTimes[i]);
                                if (error)
                                    return "nonCoverageTimes." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffShift message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffShift} StaffShift
                     */
                    StaffShift.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffShift)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffShift();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.note != null)
                            message.note = String(object.note);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.isCrossDayShift != null)
                            message.isCrossDayShift = Boolean(object.isCrossDayShift);
                        if (object.color != null)
                            message.color = String(object.color);
                        if (object.shiftName != null)
                            message.shiftName = String(object.shiftName);
                        if (object.staffPositionId != null)
                            if ($util.Long)
                                (message.staffPositionId = $util.Long.fromValue(object.staffPositionId)).unsigned = false;
                            else if (typeof object.staffPositionId === "string")
                                message.staffPositionId = parseInt(object.staffPositionId, 10);
                            else if (typeof object.staffPositionId === "number")
                                message.staffPositionId = object.staffPositionId;
                            else if (typeof object.staffPositionId === "object")
                                message.staffPositionId = new $util.LongBits(object.staffPositionId.low >>> 0, object.staffPositionId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.originalId != null)
                            if ($util.Long)
                                (message.originalId = $util.Long.fromValue(object.originalId)).unsigned = false;
                            else if (typeof object.originalId === "string")
                                message.originalId = parseInt(object.originalId, 10);
                            else if (typeof object.originalId === "number")
                                message.originalId = object.originalId;
                            else if (typeof object.originalId === "object")
                                message.originalId = new $util.LongBits(object.originalId.low >>> 0, object.originalId.high >>> 0).toNumber();
                        switch (object.state) {
                        case "DRAFT_CREATED":
                        case 0:
                            message.state = 0;
                            break;
                        case "DRAFT_UPDATED":
                        case 1:
                            message.state = 1;
                            break;
                        case "DRAFT_DELETED":
                        case 2:
                            message.state = 2;
                            break;
                        case "PUBLISHED":
                        case 3:
                            message.state = 3;
                            break;
                        }
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        switch (object.originType) {
                        case "HUMAN_GENERATED":
                        case 0:
                            message.originType = 0;
                            break;
                        case "AUTO_GENERATED":
                        case 1:
                            message.originType = 1;
                            break;
                        case "ADJUSTED":
                        case 2:
                            message.originType = 2;
                            break;
                        case "MODEL_SCHEDULE":
                        case 3:
                            message.originType = 3;
                            break;
                        }
                        if (object.staffPosition != null) {
                            if (typeof object.staffPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.staffPosition: object expected");
                            message.staffPosition = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPosition);
                        }
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.scheduleArea != null) {
                            if (typeof object.scheduleArea !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.scheduleArea: object expected");
                            message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.scheduleArea);
                        }
                        if (object.breakTimes) {
                            if (!Array.isArray(object.breakTimes))
                                throw TypeError(".palexy.streaming.v1.StaffShift.breakTimes: array expected");
                            message.breakTimes = [];
                            for (var i = 0; i < object.breakTimes.length; ++i) {
                                if (typeof object.breakTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffShift.breakTimes: object expected");
                                message.breakTimes[i] = $root.palexy.protobuf.BreakTime.fromObject(object.breakTimes[i]);
                            }
                        }
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.isOpenToClaim != null)
                            message.isOpenToClaim = Boolean(object.isOpenToClaim);
                        if (object.belongToBorrowRequest != null) {
                            if (typeof object.belongToBorrowRequest !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.belongToBorrowRequest: object expected");
                            message.belongToBorrowRequest = $root.google.protobuf.BoolValue.fromObject(object.belongToBorrowRequest);
                        }
                        if (object.requiredPosition != null) {
                            if (typeof object.requiredPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShift.requiredPosition: object expected");
                            message.requiredPosition = $root.google.protobuf.BoolValue.fromObject(object.requiredPosition);
                        }
                        if (object.nonCoverageTimes) {
                            if (!Array.isArray(object.nonCoverageTimes))
                                throw TypeError(".palexy.streaming.v1.StaffShift.nonCoverageTimes: array expected");
                            message.nonCoverageTimes = [];
                            for (var i = 0; i < object.nonCoverageTimes.length; ++i) {
                                if (typeof object.nonCoverageTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffShift.nonCoverageTimes: object expected");
                                message.nonCoverageTimes[i] = $root.palexy.protobuf.NonCoverageTime.fromObject(object.nonCoverageTimes[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffShift message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffShift
                     * @static
                     * @param {palexy.streaming.v1.StaffShift} message StaffShift
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffShift.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.breakTimes = [];
                            object.nonCoverageTimes = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.note = "";
                            object.startTime = "";
                            object.endTime = "";
                            object.isCrossDayShift = false;
                            object.color = "";
                            object.shiftName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffPositionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffPositionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.originalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.originalId = options.longs === String ? "0" : 0;
                            object.state = options.enums === String ? "DRAFT_CREATED" : 0;
                            object.staffPosition = null;
                            object.staff = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                            object.store = null;
                            object.scheduleArea = null;
                            object.originType = options.enums === String ? "HUMAN_GENERATED" : 0;
                            object.isOpenToClaim = false;
                            object.belongToBorrowRequest = null;
                            object.requiredPosition = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            object.isCrossDayShift = message.isCrossDayShift;
                        if (message.color != null && message.hasOwnProperty("color"))
                            object.color = message.color;
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            object.shiftName = message.shiftName;
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (typeof message.staffPositionId === "number")
                                object.staffPositionId = options.longs === String ? String(message.staffPositionId) : message.staffPositionId;
                            else
                                object.staffPositionId = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionId) : options.longs === Number ? new $util.LongBits(message.staffPositionId.low >>> 0, message.staffPositionId.high >>> 0).toNumber() : message.staffPositionId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.originalId != null && message.hasOwnProperty("originalId"))
                            if (typeof message.originalId === "number")
                                object.originalId = options.longs === String ? String(message.originalId) : message.originalId;
                            else
                                object.originalId = options.longs === String ? $util.Long.prototype.toString.call(message.originalId) : options.longs === Number ? new $util.LongBits(message.originalId.low >>> 0, message.originalId.high >>> 0).toNumber() : message.originalId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StaffScheduleState[message.state] : message.state;
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition"))
                            object.staffPosition = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPosition, options);
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        if (message.breakTimes && message.breakTimes.length) {
                            object.breakTimes = [];
                            for (var j = 0; j < message.breakTimes.length; ++j)
                                object.breakTimes[j] = $root.palexy.protobuf.BreakTime.toObject(message.breakTimes[j], options);
                        }
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea"))
                            object.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.toObject(message.scheduleArea, options);
                        if (message.originType != null && message.hasOwnProperty("originType"))
                            object.originType = options.enums === String ? $root.palexy.streaming.v1.ScheduleOriginType[message.originType] : message.originType;
                        if (message.isOpenToClaim != null && message.hasOwnProperty("isOpenToClaim"))
                            object.isOpenToClaim = message.isOpenToClaim;
                        if (message.belongToBorrowRequest != null && message.hasOwnProperty("belongToBorrowRequest"))
                            object.belongToBorrowRequest = $root.google.protobuf.BoolValue.toObject(message.belongToBorrowRequest, options);
                        if (message.requiredPosition != null && message.hasOwnProperty("requiredPosition"))
                            object.requiredPosition = $root.google.protobuf.BoolValue.toObject(message.requiredPosition, options);
                        if (message.nonCoverageTimes && message.nonCoverageTimes.length) {
                            object.nonCoverageTimes = [];
                            for (var j = 0; j < message.nonCoverageTimes.length; ++j)
                                object.nonCoverageTimes[j] = $root.palexy.protobuf.NonCoverageTime.toObject(message.nonCoverageTimes[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffShift to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffShift
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffShift.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffShift;
                })();
    
                /**
                 * StaffScheduleState enum.
                 * @name palexy.streaming.v1.StaffScheduleState
                 * @enum {number}
                 * @property {number} DRAFT_CREATED=0 DRAFT_CREATED value
                 * @property {number} DRAFT_UPDATED=1 DRAFT_UPDATED value
                 * @property {number} DRAFT_DELETED=2 DRAFT_DELETED value
                 * @property {number} PUBLISHED=3 PUBLISHED value
                 */
                v1.StaffScheduleState = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "DRAFT_CREATED"] = 0;
                    values[valuesById[1] = "DRAFT_UPDATED"] = 1;
                    values[valuesById[2] = "DRAFT_DELETED"] = 2;
                    values[valuesById[3] = "PUBLISHED"] = 3;
                    return values;
                })();
    
                /**
                 * ScheduleOriginType enum.
                 * @name palexy.streaming.v1.ScheduleOriginType
                 * @enum {number}
                 * @property {number} HUMAN_GENERATED=0 HUMAN_GENERATED value
                 * @property {number} AUTO_GENERATED=1 AUTO_GENERATED value
                 * @property {number} ADJUSTED=2 ADJUSTED value
                 * @property {number} MODEL_SCHEDULE=3 MODEL_SCHEDULE value
                 */
                v1.ScheduleOriginType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "HUMAN_GENERATED"] = 0;
                    values[valuesById[1] = "AUTO_GENERATED"] = 1;
                    values[valuesById[2] = "ADJUSTED"] = 2;
                    values[valuesById[3] = "MODEL_SCHEDULE"] = 3;
                    return values;
                })();
    
                v1.DraftCreateStaffTimeOffRequest = (function() {
    
                    /**
                     * Properties of a DraftCreateStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftCreateStaffTimeOffRequest
                     * @property {palexy.streaming.v1.IStaffTimeOff|null} [staffTimeOff] DraftCreateStaffTimeOffRequest staffTimeOff
                     */
    
                    /**
                     * Constructs a new DraftCreateStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftCreateStaffTimeOffRequest.
                     * @implements IDraftCreateStaffTimeOffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest=} [properties] Properties to set
                     */
                    function DraftCreateStaffTimeOffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftCreateStaffTimeOffRequest staffTimeOff.
                     * @member {palexy.streaming.v1.IStaffTimeOff|null|undefined} staffTimeOff
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @instance
                     */
                    DraftCreateStaffTimeOffRequest.prototype.staffTimeOff = null;
    
                    /**
                     * Creates a new DraftCreateStaffTimeOffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftCreateStaffTimeOffRequest} DraftCreateStaffTimeOffRequest instance
                     */
                    DraftCreateStaffTimeOffRequest.create = function create(properties) {
                        return new DraftCreateStaffTimeOffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftCreateStaffTimeOffRequest message. Does not implicitly {@link palexy.streaming.v1.DraftCreateStaffTimeOffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest} message DraftCreateStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftCreateStaffTimeOffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOff != null && Object.hasOwnProperty.call(message, "staffTimeOff"))
                            $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftCreateStaffTimeOffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftCreateStaffTimeOffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest} message DraftCreateStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftCreateStaffTimeOffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftCreateStaffTimeOffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftCreateStaffTimeOffRequest} DraftCreateStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftCreateStaffTimeOffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftCreateStaffTimeOffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftCreateStaffTimeOffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftCreateStaffTimeOffRequest} DraftCreateStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftCreateStaffTimeOffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftCreateStaffTimeOffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftCreateStaffTimeOffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff")) {
                            var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOff);
                            if (error)
                                return "staffTimeOff." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftCreateStaffTimeOffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftCreateStaffTimeOffRequest} DraftCreateStaffTimeOffRequest
                     */
                    DraftCreateStaffTimeOffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftCreateStaffTimeOffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftCreateStaffTimeOffRequest();
                        if (object.staffTimeOff != null) {
                            if (typeof object.staffTimeOff !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftCreateStaffTimeOffRequest.staffTimeOff: object expected");
                            message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOff);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftCreateStaffTimeOffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftCreateStaffTimeOffRequest} message DraftCreateStaffTimeOffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftCreateStaffTimeOffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffTimeOff = null;
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff"))
                            object.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOff, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftCreateStaffTimeOffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftCreateStaffTimeOffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftCreateStaffTimeOffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftCreateStaffTimeOffRequest;
                })();
    
                v1.BatchDraftCreateStaffTimeOffsRequest = (function() {
    
                    /**
                     * Properties of a BatchDraftCreateStaffTimeOffsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftCreateStaffTimeOffsRequest
                     * @property {number|null} [storeId] BatchDraftCreateStaffTimeOffsRequest storeId
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [staffTimeOffs] BatchDraftCreateStaffTimeOffsRequest staffTimeOffs
                     */
    
                    /**
                     * Constructs a new BatchDraftCreateStaffTimeOffsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftCreateStaffTimeOffsRequest.
                     * @implements IBatchDraftCreateStaffTimeOffsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest=} [properties] Properties to set
                     */
                    function BatchDraftCreateStaffTimeOffsRequest(properties) {
                        this.staffTimeOffs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftCreateStaffTimeOffsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffTimeOffsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchDraftCreateStaffTimeOffsRequest staffTimeOffs.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} staffTimeOffs
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffTimeOffsRequest.prototype.staffTimeOffs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDraftCreateStaffTimeOffsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest} BatchDraftCreateStaffTimeOffsRequest instance
                     */
                    BatchDraftCreateStaffTimeOffsRequest.create = function create(properties) {
                        return new BatchDraftCreateStaffTimeOffsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffTimeOffsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest} message BatchDraftCreateStaffTimeOffsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffTimeOffsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.staffTimeOffs != null && message.staffTimeOffs.length)
                            for (var i = 0; i < message.staffTimeOffs.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOffs[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffTimeOffsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest} message BatchDraftCreateStaffTimeOffsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffTimeOffsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffTimeOffsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest} BatchDraftCreateStaffTimeOffsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffTimeOffsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.staffTimeOffs && message.staffTimeOffs.length))
                                    message.staffTimeOffs = [];
                                message.staffTimeOffs.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffTimeOffsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest} BatchDraftCreateStaffTimeOffsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffTimeOffsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftCreateStaffTimeOffsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftCreateStaffTimeOffsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffTimeOffs != null && message.hasOwnProperty("staffTimeOffs")) {
                            if (!Array.isArray(message.staffTimeOffs))
                                return "staffTimeOffs: array expected";
                            for (var i = 0; i < message.staffTimeOffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOffs[i]);
                                if (error)
                                    return "staffTimeOffs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftCreateStaffTimeOffsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest} BatchDraftCreateStaffTimeOffsRequest
                     */
                    BatchDraftCreateStaffTimeOffsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffTimeOffs) {
                            if (!Array.isArray(object.staffTimeOffs))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest.staffTimeOffs: array expected");
                            message.staffTimeOffs = [];
                            for (var i = 0; i < object.staffTimeOffs.length; ++i) {
                                if (typeof object.staffTimeOffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest.staffTimeOffs: object expected");
                                message.staffTimeOffs[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOffs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftCreateStaffTimeOffsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest} message BatchDraftCreateStaffTimeOffsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftCreateStaffTimeOffsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffTimeOffs = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffTimeOffs && message.staffTimeOffs.length) {
                            object.staffTimeOffs = [];
                            for (var j = 0; j < message.staffTimeOffs.length; ++j)
                                object.staffTimeOffs[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOffs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftCreateStaffTimeOffsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftCreateStaffTimeOffsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftCreateStaffTimeOffsRequest;
                })();
    
                v1.BatchDraftCreateStaffTimeOffsResponse = (function() {
    
                    /**
                     * Properties of a BatchDraftCreateStaffTimeOffsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftCreateStaffTimeOffsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [staffTimeOffs] BatchDraftCreateStaffTimeOffsResponse staffTimeOffs
                     */
    
                    /**
                     * Constructs a new BatchDraftCreateStaffTimeOffsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftCreateStaffTimeOffsResponse.
                     * @implements IBatchDraftCreateStaffTimeOffsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsResponse=} [properties] Properties to set
                     */
                    function BatchDraftCreateStaffTimeOffsResponse(properties) {
                        this.staffTimeOffs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftCreateStaffTimeOffsResponse staffTimeOffs.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} staffTimeOffs
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @instance
                     */
                    BatchDraftCreateStaffTimeOffsResponse.prototype.staffTimeOffs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDraftCreateStaffTimeOffsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} BatchDraftCreateStaffTimeOffsResponse instance
                     */
                    BatchDraftCreateStaffTimeOffsResponse.create = function create(properties) {
                        return new BatchDraftCreateStaffTimeOffsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffTimeOffsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsResponse} message BatchDraftCreateStaffTimeOffsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffTimeOffsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOffs != null && message.staffTimeOffs.length)
                            for (var i = 0; i < message.staffTimeOffs.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOffs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffTimeOffsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsResponse} message BatchDraftCreateStaffTimeOffsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffTimeOffsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffTimeOffsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} BatchDraftCreateStaffTimeOffsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffTimeOffsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffTimeOffs && message.staffTimeOffs.length))
                                    message.staffTimeOffs = [];
                                message.staffTimeOffs.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffTimeOffsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} BatchDraftCreateStaffTimeOffsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffTimeOffsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftCreateStaffTimeOffsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftCreateStaffTimeOffsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOffs != null && message.hasOwnProperty("staffTimeOffs")) {
                            if (!Array.isArray(message.staffTimeOffs))
                                return "staffTimeOffs: array expected";
                            for (var i = 0; i < message.staffTimeOffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOffs[i]);
                                if (error)
                                    return "staffTimeOffs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftCreateStaffTimeOffsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} BatchDraftCreateStaffTimeOffsResponse
                     */
                    BatchDraftCreateStaffTimeOffsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse();
                        if (object.staffTimeOffs) {
                            if (!Array.isArray(object.staffTimeOffs))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse.staffTimeOffs: array expected");
                            message.staffTimeOffs = [];
                            for (var i = 0; i < object.staffTimeOffs.length; ++i) {
                                if (typeof object.staffTimeOffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse.staffTimeOffs: object expected");
                                message.staffTimeOffs[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOffs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftCreateStaffTimeOffsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} message BatchDraftCreateStaffTimeOffsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftCreateStaffTimeOffsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffTimeOffs = [];
                        if (message.staffTimeOffs && message.staffTimeOffs.length) {
                            object.staffTimeOffs = [];
                            for (var j = 0; j < message.staffTimeOffs.length; ++j)
                                object.staffTimeOffs[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOffs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftCreateStaffTimeOffsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftCreateStaffTimeOffsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftCreateStaffTimeOffsResponse;
                })();
    
                v1.DraftEditStaffTimeOffRequest = (function() {
    
                    /**
                     * Properties of a DraftEditStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftEditStaffTimeOffRequest
                     * @property {palexy.streaming.v1.IStaffTimeOff|null} [staffTimeOff] DraftEditStaffTimeOffRequest staffTimeOff
                     * @property {google.protobuf.IFieldMask|null} [updateMask] DraftEditStaffTimeOffRequest updateMask
                     */
    
                    /**
                     * Constructs a new DraftEditStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftEditStaffTimeOffRequest.
                     * @implements IDraftEditStaffTimeOffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest=} [properties] Properties to set
                     */
                    function DraftEditStaffTimeOffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftEditStaffTimeOffRequest staffTimeOff.
                     * @member {palexy.streaming.v1.IStaffTimeOff|null|undefined} staffTimeOff
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @instance
                     */
                    DraftEditStaffTimeOffRequest.prototype.staffTimeOff = null;
    
                    /**
                     * DraftEditStaffTimeOffRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @instance
                     */
                    DraftEditStaffTimeOffRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new DraftEditStaffTimeOffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftEditStaffTimeOffRequest} DraftEditStaffTimeOffRequest instance
                     */
                    DraftEditStaffTimeOffRequest.create = function create(properties) {
                        return new DraftEditStaffTimeOffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftEditStaffTimeOffRequest message. Does not implicitly {@link palexy.streaming.v1.DraftEditStaffTimeOffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest} message DraftEditStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftEditStaffTimeOffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOff != null && Object.hasOwnProperty.call(message, "staffTimeOff"))
                            $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftEditStaffTimeOffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftEditStaffTimeOffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest} message DraftEditStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftEditStaffTimeOffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftEditStaffTimeOffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftEditStaffTimeOffRequest} DraftEditStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftEditStaffTimeOffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftEditStaffTimeOffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftEditStaffTimeOffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftEditStaffTimeOffRequest} DraftEditStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftEditStaffTimeOffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftEditStaffTimeOffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftEditStaffTimeOffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff")) {
                            var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOff);
                            if (error)
                                return "staffTimeOff." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftEditStaffTimeOffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftEditStaffTimeOffRequest} DraftEditStaffTimeOffRequest
                     */
                    DraftEditStaffTimeOffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftEditStaffTimeOffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftEditStaffTimeOffRequest();
                        if (object.staffTimeOff != null) {
                            if (typeof object.staffTimeOff !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftEditStaffTimeOffRequest.staffTimeOff: object expected");
                            message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOff);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftEditStaffTimeOffRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftEditStaffTimeOffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftEditStaffTimeOffRequest} message DraftEditStaffTimeOffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftEditStaffTimeOffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staffTimeOff = null;
                            object.updateMask = null;
                        }
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff"))
                            object.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOff, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftEditStaffTimeOffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftEditStaffTimeOffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftEditStaffTimeOffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftEditStaffTimeOffRequest;
                })();
    
                v1.DraftDeleteStaffTimeOffRequest = (function() {
    
                    /**
                     * Properties of a DraftDeleteStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftDeleteStaffTimeOffRequest
                     * @property {number|null} [staffTimeOffId] DraftDeleteStaffTimeOffRequest staffTimeOffId
                     * @property {number|null} [updateTimeMs] DraftDeleteStaffTimeOffRequest updateTimeMs
                     */
    
                    /**
                     * Constructs a new DraftDeleteStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftDeleteStaffTimeOffRequest.
                     * @implements IDraftDeleteStaffTimeOffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest=} [properties] Properties to set
                     */
                    function DraftDeleteStaffTimeOffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftDeleteStaffTimeOffRequest staffTimeOffId.
                     * @member {number} staffTimeOffId
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @instance
                     */
                    DraftDeleteStaffTimeOffRequest.prototype.staffTimeOffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DraftDeleteStaffTimeOffRequest updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @instance
                     */
                    DraftDeleteStaffTimeOffRequest.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DraftDeleteStaffTimeOffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffRequest} DraftDeleteStaffTimeOffRequest instance
                     */
                    DraftDeleteStaffTimeOffRequest.create = function create(properties) {
                        return new DraftDeleteStaffTimeOffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffTimeOffRequest message. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffTimeOffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest} message DraftDeleteStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffTimeOffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOffId != null && Object.hasOwnProperty.call(message, "staffTimeOffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffTimeOffId);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffTimeOffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffTimeOffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest} message DraftDeleteStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffTimeOffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffTimeOffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffRequest} DraftDeleteStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffTimeOffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftDeleteStaffTimeOffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffTimeOffId = reader.int64();
                                break;
                            case 2:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffTimeOffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffRequest} DraftDeleteStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffTimeOffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftDeleteStaffTimeOffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftDeleteStaffTimeOffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOffId != null && message.hasOwnProperty("staffTimeOffId"))
                            if (!$util.isInteger(message.staffTimeOffId) && !(message.staffTimeOffId && $util.isInteger(message.staffTimeOffId.low) && $util.isInteger(message.staffTimeOffId.high)))
                                return "staffTimeOffId: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DraftDeleteStaffTimeOffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffRequest} DraftDeleteStaffTimeOffRequest
                     */
                    DraftDeleteStaffTimeOffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftDeleteStaffTimeOffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftDeleteStaffTimeOffRequest();
                        if (object.staffTimeOffId != null)
                            if ($util.Long)
                                (message.staffTimeOffId = $util.Long.fromValue(object.staffTimeOffId)).unsigned = false;
                            else if (typeof object.staffTimeOffId === "string")
                                message.staffTimeOffId = parseInt(object.staffTimeOffId, 10);
                            else if (typeof object.staffTimeOffId === "number")
                                message.staffTimeOffId = object.staffTimeOffId;
                            else if (typeof object.staffTimeOffId === "object")
                                message.staffTimeOffId = new $util.LongBits(object.staffTimeOffId.low >>> 0, object.staffTimeOffId.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftDeleteStaffTimeOffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.DraftDeleteStaffTimeOffRequest} message DraftDeleteStaffTimeOffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftDeleteStaffTimeOffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffTimeOffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffTimeOffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.staffTimeOffId != null && message.hasOwnProperty("staffTimeOffId"))
                            if (typeof message.staffTimeOffId === "number")
                                object.staffTimeOffId = options.longs === String ? String(message.staffTimeOffId) : message.staffTimeOffId;
                            else
                                object.staffTimeOffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffTimeOffId) : options.longs === Number ? new $util.LongBits(message.staffTimeOffId.low >>> 0, message.staffTimeOffId.high >>> 0).toNumber() : message.staffTimeOffId;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this DraftDeleteStaffTimeOffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftDeleteStaffTimeOffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftDeleteStaffTimeOffRequest;
                })();
    
                v1.DraftDeleteStaffTimeOffResponse = (function() {
    
                    /**
                     * Properties of a DraftDeleteStaffTimeOffResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IDraftDeleteStaffTimeOffResponse
                     * @property {palexy.streaming.v1.IStaffTimeOff|null} [staffTimeOff] DraftDeleteStaffTimeOffResponse staffTimeOff
                     */
    
                    /**
                     * Constructs a new DraftDeleteStaffTimeOffResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DraftDeleteStaffTimeOffResponse.
                     * @implements IDraftDeleteStaffTimeOffResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffResponse=} [properties] Properties to set
                     */
                    function DraftDeleteStaffTimeOffResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DraftDeleteStaffTimeOffResponse staffTimeOff.
                     * @member {palexy.streaming.v1.IStaffTimeOff|null|undefined} staffTimeOff
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @instance
                     */
                    DraftDeleteStaffTimeOffResponse.prototype.staffTimeOff = null;
    
                    /**
                     * Creates a new DraftDeleteStaffTimeOffResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} DraftDeleteStaffTimeOffResponse instance
                     */
                    DraftDeleteStaffTimeOffResponse.create = function create(properties) {
                        return new DraftDeleteStaffTimeOffResponse(properties);
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffTimeOffResponse message. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffTimeOffResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffResponse} message DraftDeleteStaffTimeOffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffTimeOffResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOff != null && Object.hasOwnProperty.call(message, "staffTimeOff"))
                            $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOff, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DraftDeleteStaffTimeOffResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.DraftDeleteStaffTimeOffResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffResponse} message DraftDeleteStaffTimeOffResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DraftDeleteStaffTimeOffResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffTimeOffResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} DraftDeleteStaffTimeOffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffTimeOffResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DraftDeleteStaffTimeOffResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DraftDeleteStaffTimeOffResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} DraftDeleteStaffTimeOffResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DraftDeleteStaffTimeOffResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DraftDeleteStaffTimeOffResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DraftDeleteStaffTimeOffResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff")) {
                            var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOff);
                            if (error)
                                return "staffTimeOff." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DraftDeleteStaffTimeOffResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} DraftDeleteStaffTimeOffResponse
                     */
                    DraftDeleteStaffTimeOffResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DraftDeleteStaffTimeOffResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.DraftDeleteStaffTimeOffResponse();
                        if (object.staffTimeOff != null) {
                            if (typeof object.staffTimeOff !== "object")
                                throw TypeError(".palexy.streaming.v1.DraftDeleteStaffTimeOffResponse.staffTimeOff: object expected");
                            message.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOff);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DraftDeleteStaffTimeOffResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @static
                     * @param {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} message DraftDeleteStaffTimeOffResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DraftDeleteStaffTimeOffResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffTimeOff = null;
                        if (message.staffTimeOff != null && message.hasOwnProperty("staffTimeOff"))
                            object.staffTimeOff = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOff, options);
                        return object;
                    };
    
                    /**
                     * Converts this DraftDeleteStaffTimeOffResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DraftDeleteStaffTimeOffResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DraftDeleteStaffTimeOffResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DraftDeleteStaffTimeOffResponse;
                })();
    
                v1.GetStaffTimeOffRequest = (function() {
    
                    /**
                     * Properties of a GetStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffTimeOffRequest
                     * @property {number|null} [staffTimeOffId] GetStaffTimeOffRequest staffTimeOffId
                     */
    
                    /**
                     * Constructs a new GetStaffTimeOffRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffTimeOffRequest.
                     * @implements IGetStaffTimeOffRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest=} [properties] Properties to set
                     */
                    function GetStaffTimeOffRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffTimeOffRequest staffTimeOffId.
                     * @member {number} staffTimeOffId
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @instance
                     */
                    GetStaffTimeOffRequest.prototype.staffTimeOffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStaffTimeOffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffTimeOffRequest} GetStaffTimeOffRequest instance
                     */
                    GetStaffTimeOffRequest.create = function create(properties) {
                        return new GetStaffTimeOffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffTimeOffRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffTimeOffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest} message GetStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffTimeOffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffTimeOffId != null && Object.hasOwnProperty.call(message, "staffTimeOffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffTimeOffId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffTimeOffRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffTimeOffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest} message GetStaffTimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffTimeOffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffTimeOffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffTimeOffRequest} GetStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffTimeOffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffTimeOffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffTimeOffId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffTimeOffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffTimeOffRequest} GetStaffTimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffTimeOffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffTimeOffRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffTimeOffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffTimeOffId != null && message.hasOwnProperty("staffTimeOffId"))
                            if (!$util.isInteger(message.staffTimeOffId) && !(message.staffTimeOffId && $util.isInteger(message.staffTimeOffId.low) && $util.isInteger(message.staffTimeOffId.high)))
                                return "staffTimeOffId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffTimeOffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffTimeOffRequest} GetStaffTimeOffRequest
                     */
                    GetStaffTimeOffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffTimeOffRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffTimeOffRequest();
                        if (object.staffTimeOffId != null)
                            if ($util.Long)
                                (message.staffTimeOffId = $util.Long.fromValue(object.staffTimeOffId)).unsigned = false;
                            else if (typeof object.staffTimeOffId === "string")
                                message.staffTimeOffId = parseInt(object.staffTimeOffId, 10);
                            else if (typeof object.staffTimeOffId === "number")
                                message.staffTimeOffId = object.staffTimeOffId;
                            else if (typeof object.staffTimeOffId === "object")
                                message.staffTimeOffId = new $util.LongBits(object.staffTimeOffId.low >>> 0, object.staffTimeOffId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffTimeOffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffTimeOffRequest} message GetStaffTimeOffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffTimeOffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffTimeOffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffTimeOffId = options.longs === String ? "0" : 0;
                        if (message.staffTimeOffId != null && message.hasOwnProperty("staffTimeOffId"))
                            if (typeof message.staffTimeOffId === "number")
                                object.staffTimeOffId = options.longs === String ? String(message.staffTimeOffId) : message.staffTimeOffId;
                            else
                                object.staffTimeOffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffTimeOffId) : options.longs === Number ? new $util.LongBits(message.staffTimeOffId.low >>> 0, message.staffTimeOffId.high >>> 0).toNumber() : message.staffTimeOffId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffTimeOffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffTimeOffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffTimeOffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffTimeOffRequest;
                })();
    
                v1.StaffTimeOff = (function() {
    
                    /**
                     * Properties of a StaffTimeOff.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffTimeOff
                     * @property {number|null} [id] StaffTimeOff id
                     * @property {number|null} [storeId] StaffTimeOff storeId
                     * @property {number|null} [staffId] StaffTimeOff staffId
                     * @property {number|null} [dateId] StaffTimeOff dateId
                     * @property {string|null} [name] StaffTimeOff name
                     * @property {string|null} [shortName] StaffTimeOff shortName
                     * @property {string|null} [description] StaffTimeOff description
                     * @property {boolean|null} [isAllDay] StaffTimeOff isAllDay
                     * @property {number|null} [totalHours] StaffTimeOff totalHours
                     * @property {palexy.protobuf.timeoff.TimeOffType.PaidType|null} [paidType] StaffTimeOff paidType
                     * @property {number|null} [createTimeMs] StaffTimeOff createTimeMs
                     * @property {number|null} [updateTimeMs] StaffTimeOff updateTimeMs
                     * @property {number|null} [originalId] StaffTimeOff originalId
                     * @property {palexy.streaming.v1.StaffScheduleState|null} [state] StaffTimeOff state
                     * @property {palexy.streaming.v1.IStore|null} [store] StaffTimeOff store
                     * @property {palexy.streaming.v1.ScheduleOriginType|null} [originType] StaffTimeOff originType
                     * @property {number|null} [timeOffRequestId] StaffTimeOff timeOffRequestId
                     */
    
                    /**
                     * Constructs a new StaffTimeOff.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffTimeOff.
                     * @implements IStaffTimeOff
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffTimeOff=} [properties] Properties to set
                     */
                    function StaffTimeOff(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffTimeOff id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.dateId = 0;
    
                    /**
                     * StaffTimeOff name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.name = "";
    
                    /**
                     * StaffTimeOff shortName.
                     * @member {string} shortName
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.shortName = "";
    
                    /**
                     * StaffTimeOff description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.description = "";
    
                    /**
                     * StaffTimeOff isAllDay.
                     * @member {boolean} isAllDay
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.isAllDay = false;
    
                    /**
                     * StaffTimeOff totalHours.
                     * @member {number} totalHours
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.totalHours = 0;
    
                    /**
                     * StaffTimeOff paidType.
                     * @member {palexy.protobuf.timeoff.TimeOffType.PaidType} paidType
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.paidType = 0;
    
                    /**
                     * StaffTimeOff createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff originalId.
                     * @member {number} originalId
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.originalId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffTimeOff state.
                     * @member {palexy.streaming.v1.StaffScheduleState} state
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.state = 0;
    
                    /**
                     * StaffTimeOff store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.store = null;
    
                    /**
                     * StaffTimeOff originType.
                     * @member {palexy.streaming.v1.ScheduleOriginType} originType
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.originType = 0;
    
                    /**
                     * StaffTimeOff timeOffRequestId.
                     * @member {number} timeOffRequestId
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     */
                    StaffTimeOff.prototype.timeOffRequestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StaffTimeOff instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {palexy.streaming.v1.IStaffTimeOff=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffTimeOff} StaffTimeOff instance
                     */
                    StaffTimeOff.create = function create(properties) {
                        return new StaffTimeOff(properties);
                    };
    
                    /**
                     * Encodes the specified StaffTimeOff message. Does not implicitly {@link palexy.streaming.v1.StaffTimeOff.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {palexy.streaming.v1.IStaffTimeOff} message StaffTimeOff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffTimeOff.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                        if (message.shortName != null && Object.hasOwnProperty.call(message, "shortName"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.shortName);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.description);
                        if (message.isAllDay != null && Object.hasOwnProperty.call(message, "isAllDay"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isAllDay);
                        if (message.totalHours != null && Object.hasOwnProperty.call(message, "totalHours"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.totalHours);
                        if (message.paidType != null && Object.hasOwnProperty.call(message, "paidType"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.paidType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.updateTimeMs);
                        if (message.originalId != null && Object.hasOwnProperty.call(message, "originalId"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.originalId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int32(message.state);
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.originType != null && Object.hasOwnProperty.call(message, "originType"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.originType);
                        if (message.timeOffRequestId != null && Object.hasOwnProperty.call(message, "timeOffRequestId"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.timeOffRequestId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffTimeOff message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffTimeOff.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {palexy.streaming.v1.IStaffTimeOff} message StaffTimeOff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffTimeOff.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffTimeOff message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffTimeOff} StaffTimeOff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffTimeOff.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffTimeOff();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.name = reader.string();
                                break;
                            case 6:
                                message.shortName = reader.string();
                                break;
                            case 7:
                                message.description = reader.string();
                                break;
                            case 8:
                                message.isAllDay = reader.bool();
                                break;
                            case 9:
                                message.totalHours = reader.int32();
                                break;
                            case 10:
                                message.paidType = reader.int32();
                                break;
                            case 11:
                                message.createTimeMs = reader.int64();
                                break;
                            case 12:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 13:
                                message.originalId = reader.int64();
                                break;
                            case 14:
                                message.state = reader.int32();
                                break;
                            case 15:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.originType = reader.int32();
                                break;
                            case 17:
                                message.timeOffRequestId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffTimeOff message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffTimeOff} StaffTimeOff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffTimeOff.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffTimeOff message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffTimeOff.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.shortName != null && message.hasOwnProperty("shortName"))
                            if (!$util.isString(message.shortName))
                                return "shortName: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                            if (typeof message.isAllDay !== "boolean")
                                return "isAllDay: boolean expected";
                        if (message.totalHours != null && message.hasOwnProperty("totalHours"))
                            if (!$util.isInteger(message.totalHours))
                                return "totalHours: integer expected";
                        if (message.paidType != null && message.hasOwnProperty("paidType"))
                            switch (message.paidType) {
                            default:
                                return "paidType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.originalId != null && message.hasOwnProperty("originalId"))
                            if (!$util.isInteger(message.originalId) && !(message.originalId && $util.isInteger(message.originalId.low) && $util.isInteger(message.originalId.high)))
                                return "originalId: integer|Long expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.originType != null && message.hasOwnProperty("originType"))
                            switch (message.originType) {
                            default:
                                return "originType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.timeOffRequestId != null && message.hasOwnProperty("timeOffRequestId"))
                            if (!$util.isInteger(message.timeOffRequestId) && !(message.timeOffRequestId && $util.isInteger(message.timeOffRequestId.low) && $util.isInteger(message.timeOffRequestId.high)))
                                return "timeOffRequestId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffTimeOff message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffTimeOff} StaffTimeOff
                     */
                    StaffTimeOff.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffTimeOff)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffTimeOff();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.shortName != null)
                            message.shortName = String(object.shortName);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.isAllDay != null)
                            message.isAllDay = Boolean(object.isAllDay);
                        if (object.totalHours != null)
                            message.totalHours = object.totalHours | 0;
                        switch (object.paidType) {
                        case "PAID":
                        case 0:
                            message.paidType = 0;
                            break;
                        case "UNPAID":
                        case 1:
                            message.paidType = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.originalId != null)
                            if ($util.Long)
                                (message.originalId = $util.Long.fromValue(object.originalId)).unsigned = false;
                            else if (typeof object.originalId === "string")
                                message.originalId = parseInt(object.originalId, 10);
                            else if (typeof object.originalId === "number")
                                message.originalId = object.originalId;
                            else if (typeof object.originalId === "object")
                                message.originalId = new $util.LongBits(object.originalId.low >>> 0, object.originalId.high >>> 0).toNumber();
                        switch (object.state) {
                        case "DRAFT_CREATED":
                        case 0:
                            message.state = 0;
                            break;
                        case "DRAFT_UPDATED":
                        case 1:
                            message.state = 1;
                            break;
                        case "DRAFT_DELETED":
                        case 2:
                            message.state = 2;
                            break;
                        case "PUBLISHED":
                        case 3:
                            message.state = 3;
                            break;
                        }
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffTimeOff.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        switch (object.originType) {
                        case "HUMAN_GENERATED":
                        case 0:
                            message.originType = 0;
                            break;
                        case "AUTO_GENERATED":
                        case 1:
                            message.originType = 1;
                            break;
                        case "ADJUSTED":
                        case 2:
                            message.originType = 2;
                            break;
                        case "MODEL_SCHEDULE":
                        case 3:
                            message.originType = 3;
                            break;
                        }
                        if (object.timeOffRequestId != null)
                            if ($util.Long)
                                (message.timeOffRequestId = $util.Long.fromValue(object.timeOffRequestId)).unsigned = false;
                            else if (typeof object.timeOffRequestId === "string")
                                message.timeOffRequestId = parseInt(object.timeOffRequestId, 10);
                            else if (typeof object.timeOffRequestId === "number")
                                message.timeOffRequestId = object.timeOffRequestId;
                            else if (typeof object.timeOffRequestId === "object")
                                message.timeOffRequestId = new $util.LongBits(object.timeOffRequestId.low >>> 0, object.timeOffRequestId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffTimeOff message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @static
                     * @param {palexy.streaming.v1.StaffTimeOff} message StaffTimeOff
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffTimeOff.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.name = "";
                            object.shortName = "";
                            object.description = "";
                            object.isAllDay = false;
                            object.totalHours = 0;
                            object.paidType = options.enums === String ? "PAID" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.originalId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.originalId = options.longs === String ? "0" : 0;
                            object.state = options.enums === String ? "DRAFT_CREATED" : 0;
                            object.store = null;
                            object.originType = options.enums === String ? "HUMAN_GENERATED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffRequestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffRequestId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.shortName != null && message.hasOwnProperty("shortName"))
                            object.shortName = message.shortName;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                            object.isAllDay = message.isAllDay;
                        if (message.totalHours != null && message.hasOwnProperty("totalHours"))
                            object.totalHours = message.totalHours;
                        if (message.paidType != null && message.hasOwnProperty("paidType"))
                            object.paidType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffType.PaidType[message.paidType] : message.paidType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.originalId != null && message.hasOwnProperty("originalId"))
                            if (typeof message.originalId === "number")
                                object.originalId = options.longs === String ? String(message.originalId) : message.originalId;
                            else
                                object.originalId = options.longs === String ? $util.Long.prototype.toString.call(message.originalId) : options.longs === Number ? new $util.LongBits(message.originalId.low >>> 0, message.originalId.high >>> 0).toNumber() : message.originalId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StaffScheduleState[message.state] : message.state;
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.originType != null && message.hasOwnProperty("originType"))
                            object.originType = options.enums === String ? $root.palexy.streaming.v1.ScheduleOriginType[message.originType] : message.originType;
                        if (message.timeOffRequestId != null && message.hasOwnProperty("timeOffRequestId"))
                            if (typeof message.timeOffRequestId === "number")
                                object.timeOffRequestId = options.longs === String ? String(message.timeOffRequestId) : message.timeOffRequestId;
                            else
                                object.timeOffRequestId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffRequestId) : options.longs === Number ? new $util.LongBits(message.timeOffRequestId.low >>> 0, message.timeOffRequestId.high >>> 0).toNumber() : message.timeOffRequestId;
                        return object;
                    };
    
                    /**
                     * Converts this StaffTimeOff to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffTimeOff
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffTimeOff.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffTimeOff;
                })();
    
                v1.StaffScheduleService = (function() {
    
                    /**
                     * Constructs a new StaffScheduleService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffScheduleService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffScheduleService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffScheduleService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffScheduleService;
    
                    /**
                     * Creates new StaffScheduleService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffScheduleService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffScheduleService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftCreateStaffShift}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftCreateStaffShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShift} [response] StaffShift
                     */
    
                    /**
                     * Calls DraftCreateStaffShift.
                     * @function draftCreateStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest} request DraftCreateStaffShiftRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftCreateStaffShiftCallback} callback Node-style callback called with the error, if any, and StaffShift
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftCreateStaffShift = function draftCreateStaffShift(request, callback) {
                        return this.rpcCall(draftCreateStaffShift, $root.palexy.streaming.v1.DraftCreateStaffShiftRequest, $root.palexy.streaming.v1.StaffShift, request, callback);
                    }, "name", { value: "DraftCreateStaffShift" });
    
                    /**
                     * Calls DraftCreateStaffShift.
                     * @function draftCreateStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftCreateStaffShiftRequest} request DraftCreateStaffShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShift>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftEditStaffShift}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftEditStaffShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShift} [response] StaffShift
                     */
    
                    /**
                     * Calls DraftEditStaffShift.
                     * @function draftEditStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest} request DraftEditStaffShiftRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftEditStaffShiftCallback} callback Node-style callback called with the error, if any, and StaffShift
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftEditStaffShift = function draftEditStaffShift(request, callback) {
                        return this.rpcCall(draftEditStaffShift, $root.palexy.streaming.v1.DraftEditStaffShiftRequest, $root.palexy.streaming.v1.StaffShift, request, callback);
                    }, "name", { value: "DraftEditStaffShift" });
    
                    /**
                     * Calls DraftEditStaffShift.
                     * @function draftEditStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftEditStaffShiftRequest} request DraftEditStaffShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShift>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#swapStaffShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef SwapStaffShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.SwapStaffShiftsResponse} [response] SwapStaffShiftsResponse
                     */
    
                    /**
                     * Calls SwapStaffShifts.
                     * @function swapStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest} request SwapStaffShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.SwapStaffShiftsCallback} callback Node-style callback called with the error, if any, and SwapStaffShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.swapStaffShifts = function swapStaffShifts(request, callback) {
                        return this.rpcCall(swapStaffShifts, $root.palexy.streaming.v1.SwapStaffShiftsRequest, $root.palexy.streaming.v1.SwapStaffShiftsResponse, request, callback);
                    }, "name", { value: "SwapStaffShifts" });
    
                    /**
                     * Calls SwapStaffShifts.
                     * @function swapStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ISwapStaffShiftsRequest} request SwapStaffShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.SwapStaffShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftDeleteStaffShift}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftDeleteStaffShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.DraftDeleteStaffShiftResponse} [response] DraftDeleteStaffShiftResponse
                     */
    
                    /**
                     * Calls DraftDeleteStaffShift.
                     * @function draftDeleteStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest} request DraftDeleteStaffShiftRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftDeleteStaffShiftCallback} callback Node-style callback called with the error, if any, and DraftDeleteStaffShiftResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftDeleteStaffShift = function draftDeleteStaffShift(request, callback) {
                        return this.rpcCall(draftDeleteStaffShift, $root.palexy.streaming.v1.DraftDeleteStaffShiftRequest, $root.palexy.streaming.v1.DraftDeleteStaffShiftResponse, request, callback);
                    }, "name", { value: "DraftDeleteStaffShift" });
    
                    /**
                     * Calls DraftDeleteStaffShift.
                     * @function draftDeleteStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftDeleteStaffShiftRequest} request DraftDeleteStaffShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.DraftDeleteStaffShiftResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#getStaffShift}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef GetStaffShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShift} [response] StaffShift
                     */
    
                    /**
                     * Calls GetStaffShift.
                     * @function getStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest} request GetStaffShiftRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.GetStaffShiftCallback} callback Node-style callback called with the error, if any, and StaffShift
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.getStaffShift = function getStaffShift(request, callback) {
                        return this.rpcCall(getStaffShift, $root.palexy.streaming.v1.GetStaffShiftRequest, $root.palexy.streaming.v1.StaffShift, request, callback);
                    }, "name", { value: "GetStaffShift" });
    
                    /**
                     * Calls GetStaffShift.
                     * @function getStaffShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffShiftRequest} request GetStaffShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShift>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#listStaffShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ListStaffShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffShiftsResponse} [response] ListStaffShiftsResponse
                     */
    
                    /**
                     * Calls ListStaffShifts.
                     * @function listStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest} request ListStaffShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ListStaffShiftsCallback} callback Node-style callback called with the error, if any, and ListStaffShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.listStaffShifts = function listStaffShifts(request, callback) {
                        return this.rpcCall(listStaffShifts, $root.palexy.streaming.v1.ListStaffShiftsRequest, $root.palexy.streaming.v1.ListStaffShiftsResponse, request, callback);
                    }, "name", { value: "ListStaffShifts" });
    
                    /**
                     * Calls ListStaffShifts.
                     * @function listStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest} request ListStaffShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#batchDraftCreateStaffShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef BatchDraftCreateStaffShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} [response] BatchDraftCreateStaffShiftsResponse
                     */
    
                    /**
                     * Calls BatchDraftCreateStaffShifts.
                     * @function batchDraftCreateStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest} request BatchDraftCreateStaffShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.BatchDraftCreateStaffShiftsCallback} callback Node-style callback called with the error, if any, and BatchDraftCreateStaffShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.batchDraftCreateStaffShifts = function batchDraftCreateStaffShifts(request, callback) {
                        return this.rpcCall(batchDraftCreateStaffShifts, $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest, $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse, request, callback);
                    }, "name", { value: "BatchDraftCreateStaffShifts" });
    
                    /**
                     * Calls BatchDraftCreateStaffShifts.
                     * @function batchDraftCreateStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest} request BatchDraftCreateStaffShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#batchDraftEditStaffShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef BatchDraftEditStaffShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} [response] BatchDraftEditStaffShiftsResponse
                     */
    
                    /**
                     * Calls BatchDraftEditStaffShifts.
                     * @function batchDraftEditStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest} request BatchDraftEditStaffShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.BatchDraftEditStaffShiftsCallback} callback Node-style callback called with the error, if any, and BatchDraftEditStaffShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.batchDraftEditStaffShifts = function batchDraftEditStaffShifts(request, callback) {
                        return this.rpcCall(batchDraftEditStaffShifts, $root.palexy.streaming.v1.BatchDraftEditStaffShiftsRequest, $root.palexy.streaming.v1.BatchDraftEditStaffShiftsResponse, request, callback);
                    }, "name", { value: "BatchDraftEditStaffShifts" });
    
                    /**
                     * Calls BatchDraftEditStaffShifts.
                     * @function batchDraftEditStaffShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest} request BatchDraftEditStaffShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchDraftEditStaffShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftCreateStaffTimeOff}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftCreateStaffTimeOffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffTimeOff} [response] StaffTimeOff
                     */
    
                    /**
                     * Calls DraftCreateStaffTimeOff.
                     * @function draftCreateStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest} request DraftCreateStaffTimeOffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftCreateStaffTimeOffCallback} callback Node-style callback called with the error, if any, and StaffTimeOff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftCreateStaffTimeOff = function draftCreateStaffTimeOff(request, callback) {
                        return this.rpcCall(draftCreateStaffTimeOff, $root.palexy.streaming.v1.DraftCreateStaffTimeOffRequest, $root.palexy.streaming.v1.StaffTimeOff, request, callback);
                    }, "name", { value: "DraftCreateStaffTimeOff" });
    
                    /**
                     * Calls DraftCreateStaffTimeOff.
                     * @function draftCreateStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftCreateStaffTimeOffRequest} request DraftCreateStaffTimeOffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffTimeOff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#batchDraftCreateStaffTimeOffs}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef BatchDraftCreateStaffTimeOffsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse} [response] BatchDraftCreateStaffTimeOffsResponse
                     */
    
                    /**
                     * Calls BatchDraftCreateStaffTimeOffs.
                     * @function batchDraftCreateStaffTimeOffs
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest} request BatchDraftCreateStaffTimeOffsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.BatchDraftCreateStaffTimeOffsCallback} callback Node-style callback called with the error, if any, and BatchDraftCreateStaffTimeOffsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.batchDraftCreateStaffTimeOffs = function batchDraftCreateStaffTimeOffs(request, callback) {
                        return this.rpcCall(batchDraftCreateStaffTimeOffs, $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsRequest, $root.palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse, request, callback);
                    }, "name", { value: "BatchDraftCreateStaffTimeOffs" });
    
                    /**
                     * Calls BatchDraftCreateStaffTimeOffs.
                     * @function batchDraftCreateStaffTimeOffs
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffTimeOffsRequest} request BatchDraftCreateStaffTimeOffsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchDraftCreateStaffTimeOffsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftEditStaffTimeOff}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftEditStaffTimeOffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffTimeOff} [response] StaffTimeOff
                     */
    
                    /**
                     * Calls DraftEditStaffTimeOff.
                     * @function draftEditStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest} request DraftEditStaffTimeOffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftEditStaffTimeOffCallback} callback Node-style callback called with the error, if any, and StaffTimeOff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftEditStaffTimeOff = function draftEditStaffTimeOff(request, callback) {
                        return this.rpcCall(draftEditStaffTimeOff, $root.palexy.streaming.v1.DraftEditStaffTimeOffRequest, $root.palexy.streaming.v1.StaffTimeOff, request, callback);
                    }, "name", { value: "DraftEditStaffTimeOff" });
    
                    /**
                     * Calls DraftEditStaffTimeOff.
                     * @function draftEditStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftEditStaffTimeOffRequest} request DraftEditStaffTimeOffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffTimeOff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#draftDeleteStaffTimeOff}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DraftDeleteStaffTimeOffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.DraftDeleteStaffTimeOffResponse} [response] DraftDeleteStaffTimeOffResponse
                     */
    
                    /**
                     * Calls DraftDeleteStaffTimeOff.
                     * @function draftDeleteStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest} request DraftDeleteStaffTimeOffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DraftDeleteStaffTimeOffCallback} callback Node-style callback called with the error, if any, and DraftDeleteStaffTimeOffResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.draftDeleteStaffTimeOff = function draftDeleteStaffTimeOff(request, callback) {
                        return this.rpcCall(draftDeleteStaffTimeOff, $root.palexy.streaming.v1.DraftDeleteStaffTimeOffRequest, $root.palexy.streaming.v1.DraftDeleteStaffTimeOffResponse, request, callback);
                    }, "name", { value: "DraftDeleteStaffTimeOff" });
    
                    /**
                     * Calls DraftDeleteStaffTimeOff.
                     * @function draftDeleteStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDraftDeleteStaffTimeOffRequest} request DraftDeleteStaffTimeOffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.DraftDeleteStaffTimeOffResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#getStaffTimeOff}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef GetStaffTimeOffCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffTimeOff} [response] StaffTimeOff
                     */
    
                    /**
                     * Calls GetStaffTimeOff.
                     * @function getStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest} request GetStaffTimeOffRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.GetStaffTimeOffCallback} callback Node-style callback called with the error, if any, and StaffTimeOff
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.getStaffTimeOff = function getStaffTimeOff(request, callback) {
                        return this.rpcCall(getStaffTimeOff, $root.palexy.streaming.v1.GetStaffTimeOffRequest, $root.palexy.streaming.v1.StaffTimeOff, request, callback);
                    }, "name", { value: "GetStaffTimeOff" });
    
                    /**
                     * Calls GetStaffTimeOff.
                     * @function getStaffTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffTimeOffRequest} request GetStaffTimeOffRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffTimeOff>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#createDemoData}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef CreateDemoDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CreateDemoDataResponse} [response] CreateDemoDataResponse
                     */
    
                    /**
                     * Calls CreateDemoData.
                     * @function createDemoData
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest} request CreateDemoDataRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.CreateDemoDataCallback} callback Node-style callback called with the error, if any, and CreateDemoDataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.createDemoData = function createDemoData(request, callback) {
                        return this.rpcCall(createDemoData, $root.palexy.streaming.v1.CreateDemoDataRequest, $root.palexy.streaming.v1.CreateDemoDataResponse, request, callback);
                    }, "name", { value: "CreateDemoData" });
    
                    /**
                     * Calls CreateDemoData.
                     * @function createDemoData
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest} request CreateDemoDataRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CreateDemoDataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#getStaffSchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef GetStaffScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetStaffScheduleResponse} [response] GetStaffScheduleResponse
                     */
    
                    /**
                     * Calls GetStaffSchedule.
                     * @function getStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest} request GetStaffScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.GetStaffScheduleCallback} callback Node-style callback called with the error, if any, and GetStaffScheduleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.getStaffSchedule = function getStaffSchedule(request, callback) {
                        return this.rpcCall(getStaffSchedule, $root.palexy.streaming.v1.GetStaffScheduleRequest, $root.palexy.streaming.v1.GetStaffScheduleResponse, request, callback);
                    }, "name", { value: "GetStaffSchedule" });
    
                    /**
                     * Calls GetStaffSchedule.
                     * @function getStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest} request GetStaffScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetStaffScheduleResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#publishStaffSchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef PublishStaffScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.PublishStaffScheduleResponse} [response] PublishStaffScheduleResponse
                     */
    
                    /**
                     * Calls PublishStaffSchedule.
                     * @function publishStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest} request PublishStaffScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.PublishStaffScheduleCallback} callback Node-style callback called with the error, if any, and PublishStaffScheduleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.publishStaffSchedule = function publishStaffSchedule(request, callback) {
                        return this.rpcCall(publishStaffSchedule, $root.palexy.streaming.v1.PublishStaffScheduleRequest, $root.palexy.streaming.v1.PublishStaffScheduleResponse, request, callback);
                    }, "name", { value: "PublishStaffSchedule" });
    
                    /**
                     * Calls PublishStaffSchedule.
                     * @function publishStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest} request PublishStaffScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.PublishStaffScheduleResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#discardDraftStaffSchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DiscardDraftStaffScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DiscardDraftStaffSchedule.
                     * @function discardDraftStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest} request DiscardDraftStaffScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DiscardDraftStaffScheduleCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.discardDraftStaffSchedule = function discardDraftStaffSchedule(request, callback) {
                        return this.rpcCall(discardDraftStaffSchedule, $root.palexy.streaming.v1.DiscardDraftStaffScheduleRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DiscardDraftStaffSchedule" });
    
                    /**
                     * Calls DiscardDraftStaffSchedule.
                     * @function discardDraftStaffSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest} request DiscardDraftStaffScheduleRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#copySchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef CopyScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.GetStaffScheduleResponse} [response] GetStaffScheduleResponse
                     */
    
                    /**
                     * Calls CopySchedule.
                     * @function copySchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICopyScheduleRequest} request CopyScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.CopyScheduleCallback} callback Node-style callback called with the error, if any, and GetStaffScheduleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.copySchedule = function copySchedule(request, callback) {
                        return this.rpcCall(copySchedule, $root.palexy.streaming.v1.CopyScheduleRequest, $root.palexy.streaming.v1.GetStaffScheduleResponse, request, callback);
                    }, "name", { value: "CopySchedule" });
    
                    /**
                     * Calls CopySchedule.
                     * @function copySchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICopyScheduleRequest} request CopyScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.GetStaffScheduleResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#getStaffScheduleGeneralSetting}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef GetStaffScheduleGeneralSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffScheduleGeneralSetting} [response] StaffScheduleGeneralSetting
                     */
    
                    /**
                     * Calls GetStaffScheduleGeneralSetting.
                     * @function getStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest} request GetStaffScheduleGeneralSettingRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.GetStaffScheduleGeneralSettingCallback} callback Node-style callback called with the error, if any, and StaffScheduleGeneralSetting
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.getStaffScheduleGeneralSetting = function getStaffScheduleGeneralSetting(request, callback) {
                        return this.rpcCall(getStaffScheduleGeneralSetting, $root.palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest, $root.palexy.streaming.v1.StaffScheduleGeneralSetting, request, callback);
                    }, "name", { value: "GetStaffScheduleGeneralSetting" });
    
                    /**
                     * Calls GetStaffScheduleGeneralSetting.
                     * @function getStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest} request GetStaffScheduleGeneralSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffScheduleGeneralSetting>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#listStaffScheduleGeneralSettings}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ListStaffScheduleGeneralSettingsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} [response] ListStaffScheduleGeneralSettingsResponse
                     */
    
                    /**
                     * Calls ListStaffScheduleGeneralSettings.
                     * @function listStaffScheduleGeneralSettings
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest} request ListStaffScheduleGeneralSettingsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ListStaffScheduleGeneralSettingsCallback} callback Node-style callback called with the error, if any, and ListStaffScheduleGeneralSettingsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.listStaffScheduleGeneralSettings = function listStaffScheduleGeneralSettings(request, callback) {
                        return this.rpcCall(listStaffScheduleGeneralSettings, $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest, $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse, request, callback);
                    }, "name", { value: "ListStaffScheduleGeneralSettings" });
    
                    /**
                     * Calls ListStaffScheduleGeneralSettings.
                     * @function listStaffScheduleGeneralSettings
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest} request ListStaffScheduleGeneralSettingsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#createStaffScheduleGeneralSetting}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef CreateStaffScheduleGeneralSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffScheduleGeneralSetting} [response] StaffScheduleGeneralSetting
                     */
    
                    /**
                     * Calls CreateStaffScheduleGeneralSetting.
                     * @function createStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest} request CreateStaffScheduleGeneralSettingRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.CreateStaffScheduleGeneralSettingCallback} callback Node-style callback called with the error, if any, and StaffScheduleGeneralSetting
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.createStaffScheduleGeneralSetting = function createStaffScheduleGeneralSetting(request, callback) {
                        return this.rpcCall(createStaffScheduleGeneralSetting, $root.palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest, $root.palexy.streaming.v1.StaffScheduleGeneralSetting, request, callback);
                    }, "name", { value: "CreateStaffScheduleGeneralSetting" });
    
                    /**
                     * Calls CreateStaffScheduleGeneralSetting.
                     * @function createStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest} request CreateStaffScheduleGeneralSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffScheduleGeneralSetting>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#updateStaffScheduleGeneralSetting}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef UpdateStaffScheduleGeneralSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffScheduleGeneralSetting} [response] StaffScheduleGeneralSetting
                     */
    
                    /**
                     * Calls UpdateStaffScheduleGeneralSetting.
                     * @function updateStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest} request UpdateStaffScheduleGeneralSettingRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.UpdateStaffScheduleGeneralSettingCallback} callback Node-style callback called with the error, if any, and StaffScheduleGeneralSetting
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.updateStaffScheduleGeneralSetting = function updateStaffScheduleGeneralSetting(request, callback) {
                        return this.rpcCall(updateStaffScheduleGeneralSetting, $root.palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest, $root.palexy.streaming.v1.StaffScheduleGeneralSetting, request, callback);
                    }, "name", { value: "UpdateStaffScheduleGeneralSetting" });
    
                    /**
                     * Calls UpdateStaffScheduleGeneralSetting.
                     * @function updateStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest} request UpdateStaffScheduleGeneralSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffScheduleGeneralSetting>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#deleteStaffScheduleGeneralSetting}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef DeleteStaffScheduleGeneralSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStaffScheduleGeneralSetting.
                     * @function deleteStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest} request DeleteStaffScheduleGeneralSettingRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.DeleteStaffScheduleGeneralSettingCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.deleteStaffScheduleGeneralSetting = function deleteStaffScheduleGeneralSetting(request, callback) {
                        return this.rpcCall(deleteStaffScheduleGeneralSetting, $root.palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStaffScheduleGeneralSetting" });
    
                    /**
                     * Calls DeleteStaffScheduleGeneralSetting.
                     * @function deleteStaffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest} request DeleteStaffScheduleGeneralSettingRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#cleanUpSchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef CleanUpScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls CleanUpSchedule.
                     * @function cleanUpSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest} request CleanUpScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.CleanUpScheduleCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.cleanUpSchedule = function cleanUpSchedule(request, callback) {
                        return this.rpcCall(cleanUpSchedule, $root.palexy.streaming.v1.CleanUpScheduleRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "CleanUpSchedule" });
    
                    /**
                     * Calls CleanUpSchedule.
                     * @function cleanUpSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest} request CleanUpScheduleRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#calculateNonComplianceForProposedShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef CalculateNonComplianceForProposedShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} [response] CalculateNonComplianceForProposedShiftsResponse
                     */
    
                    /**
                     * Calls CalculateNonComplianceForProposedShifts.
                     * @function calculateNonComplianceForProposedShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest} request CalculateNonComplianceForProposedShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.CalculateNonComplianceForProposedShiftsCallback} callback Node-style callback called with the error, if any, and CalculateNonComplianceForProposedShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.calculateNonComplianceForProposedShifts = function calculateNonComplianceForProposedShifts(request, callback) {
                        return this.rpcCall(calculateNonComplianceForProposedShifts, $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest, $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse, request, callback);
                    }, "name", { value: "CalculateNonComplianceForProposedShifts" });
    
                    /**
                     * Calls CalculateNonComplianceForProposedShifts.
                     * @function calculateNonComplianceForProposedShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest} request CalculateNonComplianceForProposedShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#batchUploadSchedule}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef BatchUploadScheduleCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.BatchUploadScheduleResponse} [response] BatchUploadScheduleResponse
                     */
    
                    /**
                     * Calls BatchUploadSchedule.
                     * @function batchUploadSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest} request BatchUploadScheduleRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.BatchUploadScheduleCallback} callback Node-style callback called with the error, if any, and BatchUploadScheduleResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.batchUploadSchedule = function batchUploadSchedule(request, callback) {
                        return this.rpcCall(batchUploadSchedule, $root.palexy.streaming.v1.BatchUploadScheduleRequest, $root.palexy.streaming.v1.BatchUploadScheduleResponse, request, callback);
                    }, "name", { value: "BatchUploadSchedule" });
    
                    /**
                     * Calls BatchUploadSchedule.
                     * @function batchUploadSchedule
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest} request BatchUploadScheduleRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.BatchUploadScheduleResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#claimShift}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ClaimShiftCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ClaimShiftResponse} [response] ClaimShiftResponse
                     */
    
                    /**
                     * Calls ClaimShift.
                     * @function claimShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IClaimShiftRequest} request ClaimShiftRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ClaimShiftCallback} callback Node-style callback called with the error, if any, and ClaimShiftResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.claimShift = function claimShift(request, callback) {
                        return this.rpcCall(claimShift, $root.palexy.streaming.v1.ClaimShiftRequest, $root.palexy.streaming.v1.ClaimShiftResponse, request, callback);
                    }, "name", { value: "ClaimShift" });
    
                    /**
                     * Calls ClaimShift.
                     * @function claimShift
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IClaimShiftRequest} request ClaimShiftRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ClaimShiftResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#listShiftOpenToClaim}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ListShiftOpenToClaimCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListShiftOpenToClaimResponse} [response] ListShiftOpenToClaimResponse
                     */
    
                    /**
                     * Calls ListShiftOpenToClaim.
                     * @function listShiftOpenToClaim
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest} request ListShiftOpenToClaimRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ListShiftOpenToClaimCallback} callback Node-style callback called with the error, if any, and ListShiftOpenToClaimResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.listShiftOpenToClaim = function listShiftOpenToClaim(request, callback) {
                        return this.rpcCall(listShiftOpenToClaim, $root.palexy.streaming.v1.ListShiftOpenToClaimRequest, $root.palexy.streaming.v1.ListShiftOpenToClaimResponse, request, callback);
                    }, "name", { value: "ListShiftOpenToClaim" });
    
                    /**
                     * Calls ListShiftOpenToClaim.
                     * @function listShiftOpenToClaim
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest} request ListShiftOpenToClaimRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListShiftOpenToClaimResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#listStaffShiftToSwap}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ListStaffShiftToSwapCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffShiftToSwapResponse} [response] ListStaffShiftToSwapResponse
                     */
    
                    /**
                     * Calls ListStaffShiftToSwap.
                     * @function listStaffShiftToSwap
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest} request ListStaffShiftToSwapRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ListStaffShiftToSwapCallback} callback Node-style callback called with the error, if any, and ListStaffShiftToSwapResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.listStaffShiftToSwap = function listStaffShiftToSwap(request, callback) {
                        return this.rpcCall(listStaffShiftToSwap, $root.palexy.streaming.v1.ListStaffShiftToSwapRequest, $root.palexy.streaming.v1.ListStaffShiftToSwapResponse, request, callback);
                    }, "name", { value: "ListStaffShiftToSwap" });
    
                    /**
                     * Calls ListStaffShiftToSwap.
                     * @function listStaffShiftToSwap
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest} request ListStaffShiftToSwapRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffShiftToSwapResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffScheduleService#expireOpenToClaimShifts}.
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @typedef ExpireOpenToClaimShiftsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} [response] ExpireOpenToClaimShiftsResponse
                     */
    
                    /**
                     * Calls ExpireOpenToClaimShifts.
                     * @function expireOpenToClaimShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest} request ExpireOpenToClaimShiftsRequest message or plain object
                     * @param {palexy.streaming.v1.StaffScheduleService.ExpireOpenToClaimShiftsCallback} callback Node-style callback called with the error, if any, and ExpireOpenToClaimShiftsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffScheduleService.prototype.expireOpenToClaimShifts = function expireOpenToClaimShifts(request, callback) {
                        return this.rpcCall(expireOpenToClaimShifts, $root.palexy.streaming.v1.ExpireOpenToClaimShiftsRequest, $root.palexy.streaming.v1.ExpireOpenToClaimShiftsResponse, request, callback);
                    }, "name", { value: "ExpireOpenToClaimShifts" });
    
                    /**
                     * Calls ExpireOpenToClaimShifts.
                     * @function expireOpenToClaimShifts
                     * @memberof palexy.streaming.v1.StaffScheduleService
                     * @instance
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest} request ExpireOpenToClaimShiftsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ExpireOpenToClaimShiftsResponse>} Promise
                     * @variation 2
                     */
    
                    return StaffScheduleService;
                })();
    
                v1.AvailabilityReminderService = (function() {
    
                    /**
                     * Constructs a new AvailabilityReminderService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AvailabilityReminderService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function AvailabilityReminderService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (AvailabilityReminderService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = AvailabilityReminderService;
    
                    /**
                     * Creates new AvailabilityReminderService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {AvailabilityReminderService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    AvailabilityReminderService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AvailabilityReminderService#listCompanyEnableAvailabilityReminder}.
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @typedef ListCompanyEnableAvailabilityReminderCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} [response] ListCompanyEnableAvailabilityReminderSettingResponse
                     */
    
                    /**
                     * Calls ListCompanyEnableAvailabilityReminder.
                     * @function listCompanyEnableAvailabilityReminder
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest} request ListCompanyEnableAvailabilityReminderSettingRequest message or plain object
                     * @param {palexy.streaming.v1.AvailabilityReminderService.ListCompanyEnableAvailabilityReminderCallback} callback Node-style callback called with the error, if any, and ListCompanyEnableAvailabilityReminderSettingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AvailabilityReminderService.prototype.listCompanyEnableAvailabilityReminder = function listCompanyEnableAvailabilityReminder(request, callback) {
                        return this.rpcCall(listCompanyEnableAvailabilityReminder, $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest, $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse, request, callback);
                    }, "name", { value: "ListCompanyEnableAvailabilityReminder" });
    
                    /**
                     * Calls ListCompanyEnableAvailabilityReminder.
                     * @function listCompanyEnableAvailabilityReminder
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest} request ListCompanyEnableAvailabilityReminderSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.AvailabilityReminderService#triggerAvailabilityReminderNotifications}.
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @typedef TriggerAvailabilityReminderNotificationsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls TriggerAvailabilityReminderNotifications.
                     * @function triggerAvailabilityReminderNotifications
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest} request TriggerAvailabilityReminderNotificationsRequest message or plain object
                     * @param {palexy.streaming.v1.AvailabilityReminderService.TriggerAvailabilityReminderNotificationsCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(AvailabilityReminderService.prototype.triggerAvailabilityReminderNotifications = function triggerAvailabilityReminderNotifications(request, callback) {
                        return this.rpcCall(triggerAvailabilityReminderNotifications, $root.palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "TriggerAvailabilityReminderNotifications" });
    
                    /**
                     * Calls TriggerAvailabilityReminderNotifications.
                     * @function triggerAvailabilityReminderNotifications
                     * @memberof palexy.streaming.v1.AvailabilityReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest} request TriggerAvailabilityReminderNotificationsRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return AvailabilityReminderService;
                })();
    
                v1.DailyReviewReminderService = (function() {
    
                    /**
                     * Constructs a new DailyReviewReminderService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DailyReviewReminderService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function DailyReviewReminderService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (DailyReviewReminderService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DailyReviewReminderService;
    
                    /**
                     * Creates new DailyReviewReminderService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {DailyReviewReminderService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    DailyReviewReminderService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.DailyReviewReminderService#listCompanyEnableDailyReviewReminderSetting}.
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @typedef ListCompanyEnableDailyReviewReminderSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} [response] ListCompanyEnableDailyReviewReminderSettingResponse
                     */
    
                    /**
                     * Calls ListCompanyEnableDailyReviewReminderSetting.
                     * @function listCompanyEnableDailyReviewReminderSetting
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest} request ListCompanyEnableDailyReviewReminderSettingRequest message or plain object
                     * @param {palexy.streaming.v1.DailyReviewReminderService.ListCompanyEnableDailyReviewReminderSettingCallback} callback Node-style callback called with the error, if any, and ListCompanyEnableDailyReviewReminderSettingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DailyReviewReminderService.prototype.listCompanyEnableDailyReviewReminderSetting = function listCompanyEnableDailyReviewReminderSetting(request, callback) {
                        return this.rpcCall(listCompanyEnableDailyReviewReminderSetting, $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest, $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse, request, callback);
                    }, "name", { value: "ListCompanyEnableDailyReviewReminderSetting" });
    
                    /**
                     * Calls ListCompanyEnableDailyReviewReminderSetting.
                     * @function listCompanyEnableDailyReviewReminderSetting
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest} request ListCompanyEnableDailyReviewReminderSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.DailyReviewReminderService#triggerDailyReviewReminderNotifications}.
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @typedef TriggerDailyReviewReminderNotificationsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} [response] TriggerDailyReviewReminderNotificationsResponse
                     */
    
                    /**
                     * Calls TriggerDailyReviewReminderNotifications.
                     * @function triggerDailyReviewReminderNotifications
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest} request TriggerDailyReviewReminderNotificationsRequest message or plain object
                     * @param {palexy.streaming.v1.DailyReviewReminderService.TriggerDailyReviewReminderNotificationsCallback} callback Node-style callback called with the error, if any, and TriggerDailyReviewReminderNotificationsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DailyReviewReminderService.prototype.triggerDailyReviewReminderNotifications = function triggerDailyReviewReminderNotifications(request, callback) {
                        return this.rpcCall(triggerDailyReviewReminderNotifications, $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest, $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse, request, callback);
                    }, "name", { value: "TriggerDailyReviewReminderNotifications" });
    
                    /**
                     * Calls TriggerDailyReviewReminderNotifications.
                     * @function triggerDailyReviewReminderNotifications
                     * @memberof palexy.streaming.v1.DailyReviewReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest} request TriggerDailyReviewReminderNotificationsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse>} Promise
                     * @variation 2
                     */
    
                    return DailyReviewReminderService;
                })();
    
                v1.ExpireOpenToClaimShiftsRequest = (function() {
    
                    /**
                     * Properties of an ExpireOpenToClaimShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IExpireOpenToClaimShiftsRequest
                     */
    
                    /**
                     * Constructs a new ExpireOpenToClaimShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExpireOpenToClaimShiftsRequest.
                     * @implements IExpireOpenToClaimShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest=} [properties] Properties to set
                     */
                    function ExpireOpenToClaimShiftsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ExpireOpenToClaimShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsRequest} ExpireOpenToClaimShiftsRequest instance
                     */
                    ExpireOpenToClaimShiftsRequest.create = function create(properties) {
                        return new ExpireOpenToClaimShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ExpireOpenToClaimShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.ExpireOpenToClaimShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest} message ExpireOpenToClaimShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireOpenToClaimShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExpireOpenToClaimShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExpireOpenToClaimShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsRequest} message ExpireOpenToClaimShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireOpenToClaimShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExpireOpenToClaimShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsRequest} ExpireOpenToClaimShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireOpenToClaimShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExpireOpenToClaimShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExpireOpenToClaimShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsRequest} ExpireOpenToClaimShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireOpenToClaimShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExpireOpenToClaimShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExpireOpenToClaimShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExpireOpenToClaimShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsRequest} ExpireOpenToClaimShiftsRequest
                     */
                    ExpireOpenToClaimShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExpireOpenToClaimShiftsRequest)
                            return object;
                        return new $root.palexy.streaming.v1.ExpireOpenToClaimShiftsRequest();
                    };
    
                    /**
                     * Creates a plain object from an ExpireOpenToClaimShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ExpireOpenToClaimShiftsRequest} message ExpireOpenToClaimShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExpireOpenToClaimShiftsRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ExpireOpenToClaimShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExpireOpenToClaimShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExpireOpenToClaimShiftsRequest;
                })();
    
                v1.ExpireOpenToClaimShiftsResponse = (function() {
    
                    /**
                     * Properties of an ExpireOpenToClaimShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IExpireOpenToClaimShiftsResponse
                     * @property {number|null} [expiredCount] ExpireOpenToClaimShiftsResponse expiredCount
                     */
    
                    /**
                     * Constructs a new ExpireOpenToClaimShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ExpireOpenToClaimShiftsResponse.
                     * @implements IExpireOpenToClaimShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsResponse=} [properties] Properties to set
                     */
                    function ExpireOpenToClaimShiftsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExpireOpenToClaimShiftsResponse expiredCount.
                     * @member {number} expiredCount
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @instance
                     */
                    ExpireOpenToClaimShiftsResponse.prototype.expiredCount = 0;
    
                    /**
                     * Creates a new ExpireOpenToClaimShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} ExpireOpenToClaimShiftsResponse instance
                     */
                    ExpireOpenToClaimShiftsResponse.create = function create(properties) {
                        return new ExpireOpenToClaimShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ExpireOpenToClaimShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.ExpireOpenToClaimShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsResponse} message ExpireOpenToClaimShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireOpenToClaimShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.expiredCount != null && Object.hasOwnProperty.call(message, "expiredCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.expiredCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExpireOpenToClaimShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ExpireOpenToClaimShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IExpireOpenToClaimShiftsResponse} message ExpireOpenToClaimShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExpireOpenToClaimShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExpireOpenToClaimShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} ExpireOpenToClaimShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireOpenToClaimShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ExpireOpenToClaimShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.expiredCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExpireOpenToClaimShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} ExpireOpenToClaimShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExpireOpenToClaimShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExpireOpenToClaimShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExpireOpenToClaimShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.expiredCount != null && message.hasOwnProperty("expiredCount"))
                            if (!$util.isInteger(message.expiredCount))
                                return "expiredCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExpireOpenToClaimShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} ExpireOpenToClaimShiftsResponse
                     */
                    ExpireOpenToClaimShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ExpireOpenToClaimShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ExpireOpenToClaimShiftsResponse();
                        if (object.expiredCount != null)
                            message.expiredCount = object.expiredCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExpireOpenToClaimShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ExpireOpenToClaimShiftsResponse} message ExpireOpenToClaimShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExpireOpenToClaimShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.expiredCount = 0;
                        if (message.expiredCount != null && message.hasOwnProperty("expiredCount"))
                            object.expiredCount = message.expiredCount;
                        return object;
                    };
    
                    /**
                     * Converts this ExpireOpenToClaimShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ExpireOpenToClaimShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExpireOpenToClaimShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExpireOpenToClaimShiftsResponse;
                })();
    
                v1.DailyReviewReminderSetting = (function() {
    
                    /**
                     * Properties of a DailyReviewReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @interface IDailyReviewReminderSetting
                     * @property {number|null} [companyId] DailyReviewReminderSetting companyId
                     * @property {string|null} [remindTime] DailyReviewReminderSetting remindTime
                     * @property {string|null} [companyDefaultTimezone] DailyReviewReminderSetting companyDefaultTimezone
                     * @property {number|null} [matchingGroupId] DailyReviewReminderSetting matchingGroupId
                     */
    
                    /**
                     * Constructs a new DailyReviewReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DailyReviewReminderSetting.
                     * @implements IDailyReviewReminderSetting
                     * @constructor
                     * @param {palexy.streaming.v1.IDailyReviewReminderSetting=} [properties] Properties to set
                     */
                    function DailyReviewReminderSetting(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DailyReviewReminderSetting companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @instance
                     */
                    DailyReviewReminderSetting.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DailyReviewReminderSetting remindTime.
                     * @member {string} remindTime
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @instance
                     */
                    DailyReviewReminderSetting.prototype.remindTime = "";
    
                    /**
                     * DailyReviewReminderSetting companyDefaultTimezone.
                     * @member {string} companyDefaultTimezone
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @instance
                     */
                    DailyReviewReminderSetting.prototype.companyDefaultTimezone = "";
    
                    /**
                     * DailyReviewReminderSetting matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @instance
                     */
                    DailyReviewReminderSetting.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DailyReviewReminderSetting instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IDailyReviewReminderSetting=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DailyReviewReminderSetting} DailyReviewReminderSetting instance
                     */
                    DailyReviewReminderSetting.create = function create(properties) {
                        return new DailyReviewReminderSetting(properties);
                    };
    
                    /**
                     * Encodes the specified DailyReviewReminderSetting message. Does not implicitly {@link palexy.streaming.v1.DailyReviewReminderSetting.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IDailyReviewReminderSetting} message DailyReviewReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DailyReviewReminderSetting.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.remindTime != null && Object.hasOwnProperty.call(message, "remindTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.remindTime);
                        if (message.companyDefaultTimezone != null && Object.hasOwnProperty.call(message, "companyDefaultTimezone"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyDefaultTimezone);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.matchingGroupId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DailyReviewReminderSetting message, length delimited. Does not implicitly {@link palexy.streaming.v1.DailyReviewReminderSetting.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IDailyReviewReminderSetting} message DailyReviewReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DailyReviewReminderSetting.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DailyReviewReminderSetting message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DailyReviewReminderSetting} DailyReviewReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DailyReviewReminderSetting.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DailyReviewReminderSetting();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.remindTime = reader.string();
                                break;
                            case 3:
                                message.companyDefaultTimezone = reader.string();
                                break;
                            case 4:
                                message.matchingGroupId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DailyReviewReminderSetting message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DailyReviewReminderSetting} DailyReviewReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DailyReviewReminderSetting.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DailyReviewReminderSetting message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DailyReviewReminderSetting.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            if (!$util.isString(message.remindTime))
                                return "remindTime: string expected";
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            if (!$util.isString(message.companyDefaultTimezone))
                                return "companyDefaultTimezone: string expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DailyReviewReminderSetting message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DailyReviewReminderSetting} DailyReviewReminderSetting
                     */
                    DailyReviewReminderSetting.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DailyReviewReminderSetting)
                            return object;
                        var message = new $root.palexy.streaming.v1.DailyReviewReminderSetting();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.remindTime != null)
                            message.remindTime = String(object.remindTime);
                        if (object.companyDefaultTimezone != null)
                            message.companyDefaultTimezone = String(object.companyDefaultTimezone);
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DailyReviewReminderSetting message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.DailyReviewReminderSetting} message DailyReviewReminderSetting
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DailyReviewReminderSetting.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.remindTime = "";
                            object.companyDefaultTimezone = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            object.remindTime = message.remindTime;
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            object.companyDefaultTimezone = message.companyDefaultTimezone;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        return object;
                    };
    
                    /**
                     * Converts this DailyReviewReminderSetting to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DailyReviewReminderSetting
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DailyReviewReminderSetting.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DailyReviewReminderSetting;
                })();
    
                v1.ListCompanyEnableDailyReviewReminderSettingRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableDailyReviewReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableDailyReviewReminderSettingRequest
                     * @property {number|null} [pageSize] ListCompanyEnableDailyReviewReminderSettingRequest pageSize
                     * @property {string|null} [pageToken] ListCompanyEnableDailyReviewReminderSettingRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableDailyReviewReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableDailyReviewReminderSettingRequest.
                     * @implements IListCompanyEnableDailyReviewReminderSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest=} [properties] Properties to set
                     */
                    function ListCompanyEnableDailyReviewReminderSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnableDailyReviewReminderSettingRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.prototype.pageSize = 0;
    
                    /**
                     * ListCompanyEnableDailyReviewReminderSettingRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnableDailyReviewReminderSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest} ListCompanyEnableDailyReviewReminderSettingRequest instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.create = function create(properties) {
                        return new ListCompanyEnableDailyReviewReminderSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableDailyReviewReminderSettingRequest message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest} message ListCompanyEnableDailyReviewReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableDailyReviewReminderSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingRequest} message ListCompanyEnableDailyReviewReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableDailyReviewReminderSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest} ListCompanyEnableDailyReviewReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableDailyReviewReminderSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest} ListCompanyEnableDailyReviewReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableDailyReviewReminderSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableDailyReviewReminderSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest} ListCompanyEnableDailyReviewReminderSettingRequest
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableDailyReviewReminderSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest} message ListCompanyEnableDailyReviewReminderSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnableDailyReviewReminderSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableDailyReviewReminderSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableDailyReviewReminderSettingRequest;
                })();
    
                v1.ListCompanyEnableDailyReviewReminderSettingResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableDailyReviewReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableDailyReviewReminderSettingResponse
                     * @property {Array.<palexy.streaming.v1.IDailyReviewReminderSetting>|null} [settings] ListCompanyEnableDailyReviewReminderSettingResponse settings
                     * @property {string|null} [nextPageToken] ListCompanyEnableDailyReviewReminderSettingResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableDailyReviewReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableDailyReviewReminderSettingResponse.
                     * @implements IListCompanyEnableDailyReviewReminderSettingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingResponse=} [properties] Properties to set
                     */
                    function ListCompanyEnableDailyReviewReminderSettingResponse(properties) {
                        this.settings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnableDailyReviewReminderSettingResponse settings.
                     * @member {Array.<palexy.streaming.v1.IDailyReviewReminderSetting>} settings
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.prototype.settings = $util.emptyArray;
    
                    /**
                     * ListCompanyEnableDailyReviewReminderSettingResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnableDailyReviewReminderSettingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} ListCompanyEnableDailyReviewReminderSettingResponse instance
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.create = function create(properties) {
                        return new ListCompanyEnableDailyReviewReminderSettingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableDailyReviewReminderSettingResponse message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingResponse} message ListCompanyEnableDailyReviewReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.settings != null && message.settings.length)
                            for (var i = 0; i < message.settings.length; ++i)
                                $root.palexy.streaming.v1.DailyReviewReminderSetting.encode(message.settings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableDailyReviewReminderSettingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableDailyReviewReminderSettingResponse} message ListCompanyEnableDailyReviewReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableDailyReviewReminderSettingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} ListCompanyEnableDailyReviewReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.settings && message.settings.length))
                                    message.settings = [];
                                message.settings.push($root.palexy.streaming.v1.DailyReviewReminderSetting.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableDailyReviewReminderSettingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} ListCompanyEnableDailyReviewReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableDailyReviewReminderSettingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.settings != null && message.hasOwnProperty("settings")) {
                            if (!Array.isArray(message.settings))
                                return "settings: array expected";
                            for (var i = 0; i < message.settings.length; ++i) {
                                var error = $root.palexy.streaming.v1.DailyReviewReminderSetting.verify(message.settings[i]);
                                if (error)
                                    return "settings." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableDailyReviewReminderSettingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} ListCompanyEnableDailyReviewReminderSettingResponse
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse();
                        if (object.settings) {
                            if (!Array.isArray(object.settings))
                                throw TypeError(".palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse.settings: array expected");
                            message.settings = [];
                            for (var i = 0; i < object.settings.length; ++i) {
                                if (typeof object.settings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse.settings: object expected");
                                message.settings[i] = $root.palexy.streaming.v1.DailyReviewReminderSetting.fromObject(object.settings[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableDailyReviewReminderSettingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse} message ListCompanyEnableDailyReviewReminderSettingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.settings = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.settings && message.settings.length) {
                            object.settings = [];
                            for (var j = 0; j < message.settings.length; ++j)
                                object.settings[j] = $root.palexy.streaming.v1.DailyReviewReminderSetting.toObject(message.settings[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnableDailyReviewReminderSettingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableDailyReviewReminderSettingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableDailyReviewReminderSettingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableDailyReviewReminderSettingResponse;
                })();
    
                v1.TriggerDailyReviewReminderNotificationsRequest = (function() {
    
                    /**
                     * Properties of a TriggerDailyReviewReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerDailyReviewReminderNotificationsRequest
                     * @property {Array.<number>|null} [companyIds] TriggerDailyReviewReminderNotificationsRequest companyIds
                     */
    
                    /**
                     * Constructs a new TriggerDailyReviewReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerDailyReviewReminderNotificationsRequest.
                     * @implements ITriggerDailyReviewReminderNotificationsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest=} [properties] Properties to set
                     */
                    function TriggerDailyReviewReminderNotificationsRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerDailyReviewReminderNotificationsRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @instance
                     */
                    TriggerDailyReviewReminderNotificationsRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerDailyReviewReminderNotificationsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest} TriggerDailyReviewReminderNotificationsRequest instance
                     */
                    TriggerDailyReviewReminderNotificationsRequest.create = function create(properties) {
                        return new TriggerDailyReviewReminderNotificationsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerDailyReviewReminderNotificationsRequest message. Does not implicitly {@link palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest} message TriggerDailyReviewReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerDailyReviewReminderNotificationsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerDailyReviewReminderNotificationsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsRequest} message TriggerDailyReviewReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerDailyReviewReminderNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerDailyReviewReminderNotificationsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest} TriggerDailyReviewReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerDailyReviewReminderNotificationsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerDailyReviewReminderNotificationsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest} TriggerDailyReviewReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerDailyReviewReminderNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerDailyReviewReminderNotificationsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerDailyReviewReminderNotificationsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerDailyReviewReminderNotificationsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest} TriggerDailyReviewReminderNotificationsRequest
                     */
                    TriggerDailyReviewReminderNotificationsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerDailyReviewReminderNotificationsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest} message TriggerDailyReviewReminderNotificationsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerDailyReviewReminderNotificationsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerDailyReviewReminderNotificationsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerDailyReviewReminderNotificationsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerDailyReviewReminderNotificationsRequest;
                })();
    
                v1.TriggerDailyReviewReminderNotificationsResponse = (function() {
    
                    /**
                     * Properties of a TriggerDailyReviewReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerDailyReviewReminderNotificationsResponse
                     */
    
                    /**
                     * Constructs a new TriggerDailyReviewReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerDailyReviewReminderNotificationsResponse.
                     * @implements ITriggerDailyReviewReminderNotificationsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsResponse=} [properties] Properties to set
                     */
                    function TriggerDailyReviewReminderNotificationsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new TriggerDailyReviewReminderNotificationsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} TriggerDailyReviewReminderNotificationsResponse instance
                     */
                    TriggerDailyReviewReminderNotificationsResponse.create = function create(properties) {
                        return new TriggerDailyReviewReminderNotificationsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerDailyReviewReminderNotificationsResponse message. Does not implicitly {@link palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsResponse} message TriggerDailyReviewReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerDailyReviewReminderNotificationsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerDailyReviewReminderNotificationsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerDailyReviewReminderNotificationsResponse} message TriggerDailyReviewReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerDailyReviewReminderNotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerDailyReviewReminderNotificationsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} TriggerDailyReviewReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerDailyReviewReminderNotificationsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerDailyReviewReminderNotificationsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} TriggerDailyReviewReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerDailyReviewReminderNotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerDailyReviewReminderNotificationsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerDailyReviewReminderNotificationsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a TriggerDailyReviewReminderNotificationsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} TriggerDailyReviewReminderNotificationsResponse
                     */
                    TriggerDailyReviewReminderNotificationsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse)
                            return object;
                        return new $root.palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse();
                    };
    
                    /**
                     * Creates a plain object from a TriggerDailyReviewReminderNotificationsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse} message TriggerDailyReviewReminderNotificationsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerDailyReviewReminderNotificationsResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this TriggerDailyReviewReminderNotificationsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerDailyReviewReminderNotificationsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerDailyReviewReminderNotificationsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerDailyReviewReminderNotificationsResponse;
                })();
    
                v1.ScheduleReminderService = (function() {
    
                    /**
                     * Constructs a new ScheduleReminderService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ScheduleReminderService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ScheduleReminderService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ScheduleReminderService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ScheduleReminderService;
    
                    /**
                     * Creates new ScheduleReminderService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ScheduleReminderService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ScheduleReminderService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleReminderService#listCompanyEnableUnpublishedShiftReminderSetting}.
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @typedef ListCompanyEnableUnpublishedShiftReminderSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} [response] ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     */
    
                    /**
                     * Calls ListCompanyEnableUnpublishedShiftReminderSetting.
                     * @function listCompanyEnableUnpublishedShiftReminderSetting
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest} request ListCompanyEnableUnpublishedShiftReminderSettingRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleReminderService.ListCompanyEnableUnpublishedShiftReminderSettingCallback} callback Node-style callback called with the error, if any, and ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleReminderService.prototype.listCompanyEnableUnpublishedShiftReminderSetting = function listCompanyEnableUnpublishedShiftReminderSetting(request, callback) {
                        return this.rpcCall(listCompanyEnableUnpublishedShiftReminderSetting, $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest, $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse, request, callback);
                    }, "name", { value: "ListCompanyEnableUnpublishedShiftReminderSetting" });
    
                    /**
                     * Calls ListCompanyEnableUnpublishedShiftReminderSetting.
                     * @function listCompanyEnableUnpublishedShiftReminderSetting
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest} request ListCompanyEnableUnpublishedShiftReminderSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleReminderService#triggerUnpublishedShiftReminderNotifications}.
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @typedef TriggerUnpublishedShiftReminderNotificationsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} [response] TriggerUnpublishedShiftReminderNotificationsResponse
                     */
    
                    /**
                     * Calls TriggerUnpublishedShiftReminderNotifications.
                     * @function triggerUnpublishedShiftReminderNotifications
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest} request TriggerUnpublishedShiftReminderNotificationsRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleReminderService.TriggerUnpublishedShiftReminderNotificationsCallback} callback Node-style callback called with the error, if any, and TriggerUnpublishedShiftReminderNotificationsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleReminderService.prototype.triggerUnpublishedShiftReminderNotifications = function triggerUnpublishedShiftReminderNotifications(request, callback) {
                        return this.rpcCall(triggerUnpublishedShiftReminderNotifications, $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest, $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse, request, callback);
                    }, "name", { value: "TriggerUnpublishedShiftReminderNotifications" });
    
                    /**
                     * Calls TriggerUnpublishedShiftReminderNotifications.
                     * @function triggerUnpublishedShiftReminderNotifications
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest} request TriggerUnpublishedShiftReminderNotificationsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleReminderService#listCompanyEnablePendingApprovalScheduleReminderSetting}.
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @typedef ListCompanyEnablePendingApprovalScheduleReminderSettingCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} [response] ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     */
    
                    /**
                     * Calls ListCompanyEnablePendingApprovalScheduleReminderSetting.
                     * @function listCompanyEnablePendingApprovalScheduleReminderSetting
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest} request ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleReminderService.ListCompanyEnablePendingApprovalScheduleReminderSettingCallback} callback Node-style callback called with the error, if any, and ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleReminderService.prototype.listCompanyEnablePendingApprovalScheduleReminderSetting = function listCompanyEnablePendingApprovalScheduleReminderSetting(request, callback) {
                        return this.rpcCall(listCompanyEnablePendingApprovalScheduleReminderSetting, $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest, $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse, request, callback);
                    }, "name", { value: "ListCompanyEnablePendingApprovalScheduleReminderSetting" });
    
                    /**
                     * Calls ListCompanyEnablePendingApprovalScheduleReminderSetting.
                     * @function listCompanyEnablePendingApprovalScheduleReminderSetting
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest} request ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.ScheduleReminderService#triggerPendingApprovalScheduleReminderNotifications}.
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @typedef TriggerPendingApprovalScheduleReminderNotificationsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} [response] TriggerPendingApprovalScheduleReminderNotificationsResponse
                     */
    
                    /**
                     * Calls TriggerPendingApprovalScheduleReminderNotifications.
                     * @function triggerPendingApprovalScheduleReminderNotifications
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest} request TriggerPendingApprovalScheduleReminderNotificationsRequest message or plain object
                     * @param {palexy.streaming.v1.ScheduleReminderService.TriggerPendingApprovalScheduleReminderNotificationsCallback} callback Node-style callback called with the error, if any, and TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ScheduleReminderService.prototype.triggerPendingApprovalScheduleReminderNotifications = function triggerPendingApprovalScheduleReminderNotifications(request, callback) {
                        return this.rpcCall(triggerPendingApprovalScheduleReminderNotifications, $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest, $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse, request, callback);
                    }, "name", { value: "TriggerPendingApprovalScheduleReminderNotifications" });
    
                    /**
                     * Calls TriggerPendingApprovalScheduleReminderNotifications.
                     * @function triggerPendingApprovalScheduleReminderNotifications
                     * @memberof palexy.streaming.v1.ScheduleReminderService
                     * @instance
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest} request TriggerPendingApprovalScheduleReminderNotificationsRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse>} Promise
                     * @variation 2
                     */
    
                    return ScheduleReminderService;
                })();
    
                v1.UnpublishedShiftReminderSetting = (function() {
    
                    /**
                     * Properties of an UnpublishedShiftReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @interface IUnpublishedShiftReminderSetting
                     * @property {number|null} [companyId] UnpublishedShiftReminderSetting companyId
                     * @property {string|null} [remindTime] UnpublishedShiftReminderSetting remindTime
                     * @property {string|null} [companyDefaultTimezone] UnpublishedShiftReminderSetting companyDefaultTimezone
                     * @property {number|null} [matchingGroupId] UnpublishedShiftReminderSetting matchingGroupId
                     * @property {number|null} [advanceNoticeDays] UnpublishedShiftReminderSetting advanceNoticeDays
                     * @property {number|null} [startOfWeek] UnpublishedShiftReminderSetting startOfWeek
                     */
    
                    /**
                     * Constructs a new UnpublishedShiftReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UnpublishedShiftReminderSetting.
                     * @implements IUnpublishedShiftReminderSetting
                     * @constructor
                     * @param {palexy.streaming.v1.IUnpublishedShiftReminderSetting=} [properties] Properties to set
                     */
                    function UnpublishedShiftReminderSetting(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UnpublishedShiftReminderSetting companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UnpublishedShiftReminderSetting remindTime.
                     * @member {string} remindTime
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.remindTime = "";
    
                    /**
                     * UnpublishedShiftReminderSetting companyDefaultTimezone.
                     * @member {string} companyDefaultTimezone
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.companyDefaultTimezone = "";
    
                    /**
                     * UnpublishedShiftReminderSetting matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UnpublishedShiftReminderSetting advanceNoticeDays.
                     * @member {number} advanceNoticeDays
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.advanceNoticeDays = 0;
    
                    /**
                     * UnpublishedShiftReminderSetting startOfWeek.
                     * @member {number} startOfWeek
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     */
                    UnpublishedShiftReminderSetting.prototype.startOfWeek = 0;
    
                    /**
                     * Creates a new UnpublishedShiftReminderSetting instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IUnpublishedShiftReminderSetting=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UnpublishedShiftReminderSetting} UnpublishedShiftReminderSetting instance
                     */
                    UnpublishedShiftReminderSetting.create = function create(properties) {
                        return new UnpublishedShiftReminderSetting(properties);
                    };
    
                    /**
                     * Encodes the specified UnpublishedShiftReminderSetting message. Does not implicitly {@link palexy.streaming.v1.UnpublishedShiftReminderSetting.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IUnpublishedShiftReminderSetting} message UnpublishedShiftReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UnpublishedShiftReminderSetting.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.remindTime != null && Object.hasOwnProperty.call(message, "remindTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.remindTime);
                        if (message.companyDefaultTimezone != null && Object.hasOwnProperty.call(message, "companyDefaultTimezone"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyDefaultTimezone);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.matchingGroupId);
                        if (message.advanceNoticeDays != null && Object.hasOwnProperty.call(message, "advanceNoticeDays"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.advanceNoticeDays);
                        if (message.startOfWeek != null && Object.hasOwnProperty.call(message, "startOfWeek"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.startOfWeek);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UnpublishedShiftReminderSetting message, length delimited. Does not implicitly {@link palexy.streaming.v1.UnpublishedShiftReminderSetting.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IUnpublishedShiftReminderSetting} message UnpublishedShiftReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UnpublishedShiftReminderSetting.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UnpublishedShiftReminderSetting message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UnpublishedShiftReminderSetting} UnpublishedShiftReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UnpublishedShiftReminderSetting.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UnpublishedShiftReminderSetting();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.remindTime = reader.string();
                                break;
                            case 3:
                                message.companyDefaultTimezone = reader.string();
                                break;
                            case 4:
                                message.matchingGroupId = reader.int64();
                                break;
                            case 5:
                                message.advanceNoticeDays = reader.int32();
                                break;
                            case 6:
                                message.startOfWeek = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UnpublishedShiftReminderSetting message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UnpublishedShiftReminderSetting} UnpublishedShiftReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UnpublishedShiftReminderSetting.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UnpublishedShiftReminderSetting message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UnpublishedShiftReminderSetting.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            if (!$util.isString(message.remindTime))
                                return "remindTime: string expected";
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            if (!$util.isString(message.companyDefaultTimezone))
                                return "companyDefaultTimezone: string expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        if (message.advanceNoticeDays != null && message.hasOwnProperty("advanceNoticeDays"))
                            if (!$util.isInteger(message.advanceNoticeDays))
                                return "advanceNoticeDays: integer expected";
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            if (!$util.isInteger(message.startOfWeek))
                                return "startOfWeek: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an UnpublishedShiftReminderSetting message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UnpublishedShiftReminderSetting} UnpublishedShiftReminderSetting
                     */
                    UnpublishedShiftReminderSetting.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UnpublishedShiftReminderSetting)
                            return object;
                        var message = new $root.palexy.streaming.v1.UnpublishedShiftReminderSetting();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.remindTime != null)
                            message.remindTime = String(object.remindTime);
                        if (object.companyDefaultTimezone != null)
                            message.companyDefaultTimezone = String(object.companyDefaultTimezone);
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        if (object.advanceNoticeDays != null)
                            message.advanceNoticeDays = object.advanceNoticeDays | 0;
                        if (object.startOfWeek != null)
                            message.startOfWeek = object.startOfWeek | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UnpublishedShiftReminderSetting message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.UnpublishedShiftReminderSetting} message UnpublishedShiftReminderSetting
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UnpublishedShiftReminderSetting.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.remindTime = "";
                            object.companyDefaultTimezone = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                            object.advanceNoticeDays = 0;
                            object.startOfWeek = 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            object.remindTime = message.remindTime;
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            object.companyDefaultTimezone = message.companyDefaultTimezone;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        if (message.advanceNoticeDays != null && message.hasOwnProperty("advanceNoticeDays"))
                            object.advanceNoticeDays = message.advanceNoticeDays;
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            object.startOfWeek = message.startOfWeek;
                        return object;
                    };
    
                    /**
                     * Converts this UnpublishedShiftReminderSetting to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UnpublishedShiftReminderSetting
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UnpublishedShiftReminderSetting.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UnpublishedShiftReminderSetting;
                })();
    
                v1.PendingApprovalScheduleReminderSetting = (function() {
    
                    /**
                     * Properties of a PendingApprovalScheduleReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @interface IPendingApprovalScheduleReminderSetting
                     * @property {number|null} [companyId] PendingApprovalScheduleReminderSetting companyId
                     * @property {string|null} [remindTime] PendingApprovalScheduleReminderSetting remindTime
                     * @property {string|null} [companyDefaultTimezone] PendingApprovalScheduleReminderSetting companyDefaultTimezone
                     * @property {number|null} [matchingGroupId] PendingApprovalScheduleReminderSetting matchingGroupId
                     * @property {number|null} [startOfWeek] PendingApprovalScheduleReminderSetting startOfWeek
                     */
    
                    /**
                     * Constructs a new PendingApprovalScheduleReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PendingApprovalScheduleReminderSetting.
                     * @implements IPendingApprovalScheduleReminderSetting
                     * @constructor
                     * @param {palexy.streaming.v1.IPendingApprovalScheduleReminderSetting=} [properties] Properties to set
                     */
                    function PendingApprovalScheduleReminderSetting(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PendingApprovalScheduleReminderSetting companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     */
                    PendingApprovalScheduleReminderSetting.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PendingApprovalScheduleReminderSetting remindTime.
                     * @member {string} remindTime
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     */
                    PendingApprovalScheduleReminderSetting.prototype.remindTime = "";
    
                    /**
                     * PendingApprovalScheduleReminderSetting companyDefaultTimezone.
                     * @member {string} companyDefaultTimezone
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     */
                    PendingApprovalScheduleReminderSetting.prototype.companyDefaultTimezone = "";
    
                    /**
                     * PendingApprovalScheduleReminderSetting matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     */
                    PendingApprovalScheduleReminderSetting.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PendingApprovalScheduleReminderSetting startOfWeek.
                     * @member {number} startOfWeek
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     */
                    PendingApprovalScheduleReminderSetting.prototype.startOfWeek = 0;
    
                    /**
                     * Creates a new PendingApprovalScheduleReminderSetting instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IPendingApprovalScheduleReminderSetting=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PendingApprovalScheduleReminderSetting} PendingApprovalScheduleReminderSetting instance
                     */
                    PendingApprovalScheduleReminderSetting.create = function create(properties) {
                        return new PendingApprovalScheduleReminderSetting(properties);
                    };
    
                    /**
                     * Encodes the specified PendingApprovalScheduleReminderSetting message. Does not implicitly {@link palexy.streaming.v1.PendingApprovalScheduleReminderSetting.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IPendingApprovalScheduleReminderSetting} message PendingApprovalScheduleReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PendingApprovalScheduleReminderSetting.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.remindTime != null && Object.hasOwnProperty.call(message, "remindTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.remindTime);
                        if (message.companyDefaultTimezone != null && Object.hasOwnProperty.call(message, "companyDefaultTimezone"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.companyDefaultTimezone);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.matchingGroupId);
                        if (message.startOfWeek != null && Object.hasOwnProperty.call(message, "startOfWeek"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.startOfWeek);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PendingApprovalScheduleReminderSetting message, length delimited. Does not implicitly {@link palexy.streaming.v1.PendingApprovalScheduleReminderSetting.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IPendingApprovalScheduleReminderSetting} message PendingApprovalScheduleReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PendingApprovalScheduleReminderSetting.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PendingApprovalScheduleReminderSetting message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PendingApprovalScheduleReminderSetting} PendingApprovalScheduleReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PendingApprovalScheduleReminderSetting.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.remindTime = reader.string();
                                break;
                            case 3:
                                message.companyDefaultTimezone = reader.string();
                                break;
                            case 4:
                                message.matchingGroupId = reader.int64();
                                break;
                            case 5:
                                message.startOfWeek = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PendingApprovalScheduleReminderSetting message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PendingApprovalScheduleReminderSetting} PendingApprovalScheduleReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PendingApprovalScheduleReminderSetting.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PendingApprovalScheduleReminderSetting message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PendingApprovalScheduleReminderSetting.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            if (!$util.isString(message.remindTime))
                                return "remindTime: string expected";
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            if (!$util.isString(message.companyDefaultTimezone))
                                return "companyDefaultTimezone: string expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            if (!$util.isInteger(message.startOfWeek))
                                return "startOfWeek: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a PendingApprovalScheduleReminderSetting message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PendingApprovalScheduleReminderSetting} PendingApprovalScheduleReminderSetting
                     */
                    PendingApprovalScheduleReminderSetting.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting)
                            return object;
                        var message = new $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.remindTime != null)
                            message.remindTime = String(object.remindTime);
                        if (object.companyDefaultTimezone != null)
                            message.companyDefaultTimezone = String(object.companyDefaultTimezone);
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        if (object.startOfWeek != null)
                            message.startOfWeek = object.startOfWeek | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PendingApprovalScheduleReminderSetting message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.PendingApprovalScheduleReminderSetting} message PendingApprovalScheduleReminderSetting
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PendingApprovalScheduleReminderSetting.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.remindTime = "";
                            object.companyDefaultTimezone = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                            object.startOfWeek = 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.remindTime != null && message.hasOwnProperty("remindTime"))
                            object.remindTime = message.remindTime;
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            object.companyDefaultTimezone = message.companyDefaultTimezone;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        if (message.startOfWeek != null && message.hasOwnProperty("startOfWeek"))
                            object.startOfWeek = message.startOfWeek;
                        return object;
                    };
    
                    /**
                     * Converts this PendingApprovalScheduleReminderSetting to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PendingApprovalScheduleReminderSetting
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PendingApprovalScheduleReminderSetting.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PendingApprovalScheduleReminderSetting;
                })();
    
                v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableUnpublishedShiftReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @property {number|null} [pageSize] ListCompanyEnableUnpublishedShiftReminderSettingRequest pageSize
                     * @property {string|null} [pageToken] ListCompanyEnableUnpublishedShiftReminderSettingRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableUnpublishedShiftReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableUnpublishedShiftReminderSettingRequest.
                     * @implements IListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest=} [properties] Properties to set
                     */
                    function ListCompanyEnableUnpublishedShiftReminderSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnableUnpublishedShiftReminderSettingRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.prototype.pageSize = 0;
    
                    /**
                     * ListCompanyEnableUnpublishedShiftReminderSettingRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnableUnpublishedShiftReminderSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest} ListCompanyEnableUnpublishedShiftReminderSettingRequest instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.create = function create(properties) {
                        return new ListCompanyEnableUnpublishedShiftReminderSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableUnpublishedShiftReminderSettingRequest message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest} message ListCompanyEnableUnpublishedShiftReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableUnpublishedShiftReminderSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingRequest} message ListCompanyEnableUnpublishedShiftReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableUnpublishedShiftReminderSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest} ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableUnpublishedShiftReminderSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest} ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableUnpublishedShiftReminderSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableUnpublishedShiftReminderSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest} ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableUnpublishedShiftReminderSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest} message ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnableUnpublishedShiftReminderSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableUnpublishedShiftReminderSettingRequest;
                })();
    
                v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableUnpublishedShiftReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @property {Array.<palexy.streaming.v1.IUnpublishedShiftReminderSetting>|null} [settings] ListCompanyEnableUnpublishedShiftReminderSettingResponse settings
                     * @property {string|null} [nextPageToken] ListCompanyEnableUnpublishedShiftReminderSettingResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableUnpublishedShiftReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableUnpublishedShiftReminderSettingResponse.
                     * @implements IListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingResponse=} [properties] Properties to set
                     */
                    function ListCompanyEnableUnpublishedShiftReminderSettingResponse(properties) {
                        this.settings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnableUnpublishedShiftReminderSettingResponse settings.
                     * @member {Array.<palexy.streaming.v1.IUnpublishedShiftReminderSetting>} settings
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.prototype.settings = $util.emptyArray;
    
                    /**
                     * ListCompanyEnableUnpublishedShiftReminderSettingResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnableUnpublishedShiftReminderSettingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} ListCompanyEnableUnpublishedShiftReminderSettingResponse instance
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.create = function create(properties) {
                        return new ListCompanyEnableUnpublishedShiftReminderSettingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableUnpublishedShiftReminderSettingResponse message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingResponse} message ListCompanyEnableUnpublishedShiftReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.settings != null && message.settings.length)
                            for (var i = 0; i < message.settings.length; ++i)
                                $root.palexy.streaming.v1.UnpublishedShiftReminderSetting.encode(message.settings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableUnpublishedShiftReminderSettingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableUnpublishedShiftReminderSettingResponse} message ListCompanyEnableUnpublishedShiftReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableUnpublishedShiftReminderSettingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.settings && message.settings.length))
                                    message.settings = [];
                                message.settings.push($root.palexy.streaming.v1.UnpublishedShiftReminderSetting.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableUnpublishedShiftReminderSettingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableUnpublishedShiftReminderSettingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.settings != null && message.hasOwnProperty("settings")) {
                            if (!Array.isArray(message.settings))
                                return "settings: array expected";
                            for (var i = 0; i < message.settings.length; ++i) {
                                var error = $root.palexy.streaming.v1.UnpublishedShiftReminderSetting.verify(message.settings[i]);
                                if (error)
                                    return "settings." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableUnpublishedShiftReminderSettingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse();
                        if (object.settings) {
                            if (!Array.isArray(object.settings))
                                throw TypeError(".palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse.settings: array expected");
                            message.settings = [];
                            for (var i = 0; i < object.settings.length; ++i) {
                                if (typeof object.settings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse.settings: object expected");
                                message.settings[i] = $root.palexy.streaming.v1.UnpublishedShiftReminderSetting.fromObject(object.settings[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableUnpublishedShiftReminderSettingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse} message ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.settings = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.settings && message.settings.length) {
                            object.settings = [];
                            for (var j = 0; j < message.settings.length; ++j)
                                object.settings[j] = $root.palexy.streaming.v1.UnpublishedShiftReminderSetting.toObject(message.settings[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnableUnpublishedShiftReminderSettingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableUnpublishedShiftReminderSettingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableUnpublishedShiftReminderSettingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableUnpublishedShiftReminderSettingResponse;
                })();
    
                v1.TriggerUnpublishedShiftReminderNotificationsRequest = (function() {
    
                    /**
                     * Properties of a TriggerUnpublishedShiftReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerUnpublishedShiftReminderNotificationsRequest
                     * @property {Array.<number>|null} [companyIds] TriggerUnpublishedShiftReminderNotificationsRequest companyIds
                     */
    
                    /**
                     * Constructs a new TriggerUnpublishedShiftReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerUnpublishedShiftReminderNotificationsRequest.
                     * @implements ITriggerUnpublishedShiftReminderNotificationsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest=} [properties] Properties to set
                     */
                    function TriggerUnpublishedShiftReminderNotificationsRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerUnpublishedShiftReminderNotificationsRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @instance
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerUnpublishedShiftReminderNotificationsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest} TriggerUnpublishedShiftReminderNotificationsRequest instance
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.create = function create(properties) {
                        return new TriggerUnpublishedShiftReminderNotificationsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerUnpublishedShiftReminderNotificationsRequest message. Does not implicitly {@link palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest} message TriggerUnpublishedShiftReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerUnpublishedShiftReminderNotificationsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsRequest} message TriggerUnpublishedShiftReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerUnpublishedShiftReminderNotificationsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest} TriggerUnpublishedShiftReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerUnpublishedShiftReminderNotificationsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest} TriggerUnpublishedShiftReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerUnpublishedShiftReminderNotificationsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerUnpublishedShiftReminderNotificationsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest} TriggerUnpublishedShiftReminderNotificationsRequest
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerUnpublishedShiftReminderNotificationsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest} message TriggerUnpublishedShiftReminderNotificationsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerUnpublishedShiftReminderNotificationsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerUnpublishedShiftReminderNotificationsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerUnpublishedShiftReminderNotificationsRequest;
                })();
    
                v1.TriggerUnpublishedShiftReminderNotificationsResponse = (function() {
    
                    /**
                     * Properties of a TriggerUnpublishedShiftReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerUnpublishedShiftReminderNotificationsResponse
                     * @property {Array.<number>|null} [succeededCompanyIds] TriggerUnpublishedShiftReminderNotificationsResponse succeededCompanyIds
                     */
    
                    /**
                     * Constructs a new TriggerUnpublishedShiftReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerUnpublishedShiftReminderNotificationsResponse.
                     * @implements ITriggerUnpublishedShiftReminderNotificationsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsResponse=} [properties] Properties to set
                     */
                    function TriggerUnpublishedShiftReminderNotificationsResponse(properties) {
                        this.succeededCompanyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerUnpublishedShiftReminderNotificationsResponse succeededCompanyIds.
                     * @member {Array.<number>} succeededCompanyIds
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @instance
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.prototype.succeededCompanyIds = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerUnpublishedShiftReminderNotificationsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} TriggerUnpublishedShiftReminderNotificationsResponse instance
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.create = function create(properties) {
                        return new TriggerUnpublishedShiftReminderNotificationsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerUnpublishedShiftReminderNotificationsResponse message. Does not implicitly {@link palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsResponse} message TriggerUnpublishedShiftReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.succeededCompanyIds != null && message.succeededCompanyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.succeededCompanyIds.length; ++i)
                                writer.int64(message.succeededCompanyIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerUnpublishedShiftReminderNotificationsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerUnpublishedShiftReminderNotificationsResponse} message TriggerUnpublishedShiftReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerUnpublishedShiftReminderNotificationsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} TriggerUnpublishedShiftReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.succeededCompanyIds && message.succeededCompanyIds.length))
                                    message.succeededCompanyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.succeededCompanyIds.push(reader.int64());
                                } else
                                    message.succeededCompanyIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerUnpublishedShiftReminderNotificationsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} TriggerUnpublishedShiftReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerUnpublishedShiftReminderNotificationsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.succeededCompanyIds != null && message.hasOwnProperty("succeededCompanyIds")) {
                            if (!Array.isArray(message.succeededCompanyIds))
                                return "succeededCompanyIds: array expected";
                            for (var i = 0; i < message.succeededCompanyIds.length; ++i)
                                if (!$util.isInteger(message.succeededCompanyIds[i]) && !(message.succeededCompanyIds[i] && $util.isInteger(message.succeededCompanyIds[i].low) && $util.isInteger(message.succeededCompanyIds[i].high)))
                                    return "succeededCompanyIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerUnpublishedShiftReminderNotificationsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} TriggerUnpublishedShiftReminderNotificationsResponse
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse();
                        if (object.succeededCompanyIds) {
                            if (!Array.isArray(object.succeededCompanyIds))
                                throw TypeError(".palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse.succeededCompanyIds: array expected");
                            message.succeededCompanyIds = [];
                            for (var i = 0; i < object.succeededCompanyIds.length; ++i)
                                if ($util.Long)
                                    (message.succeededCompanyIds[i] = $util.Long.fromValue(object.succeededCompanyIds[i])).unsigned = false;
                                else if (typeof object.succeededCompanyIds[i] === "string")
                                    message.succeededCompanyIds[i] = parseInt(object.succeededCompanyIds[i], 10);
                                else if (typeof object.succeededCompanyIds[i] === "number")
                                    message.succeededCompanyIds[i] = object.succeededCompanyIds[i];
                                else if (typeof object.succeededCompanyIds[i] === "object")
                                    message.succeededCompanyIds[i] = new $util.LongBits(object.succeededCompanyIds[i].low >>> 0, object.succeededCompanyIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerUnpublishedShiftReminderNotificationsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse} message TriggerUnpublishedShiftReminderNotificationsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.succeededCompanyIds = [];
                        if (message.succeededCompanyIds && message.succeededCompanyIds.length) {
                            object.succeededCompanyIds = [];
                            for (var j = 0; j < message.succeededCompanyIds.length; ++j)
                                if (typeof message.succeededCompanyIds[j] === "number")
                                    object.succeededCompanyIds[j] = options.longs === String ? String(message.succeededCompanyIds[j]) : message.succeededCompanyIds[j];
                                else
                                    object.succeededCompanyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.succeededCompanyIds[j]) : options.longs === Number ? new $util.LongBits(message.succeededCompanyIds[j].low >>> 0, message.succeededCompanyIds[j].high >>> 0).toNumber() : message.succeededCompanyIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerUnpublishedShiftReminderNotificationsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerUnpublishedShiftReminderNotificationsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerUnpublishedShiftReminderNotificationsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerUnpublishedShiftReminderNotificationsResponse;
                })();
    
                v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @property {number|null} [pageSize] ListCompanyEnablePendingApprovalScheduleReminderSettingRequest pageSize
                     * @property {string|null} [pageToken] ListCompanyEnablePendingApprovalScheduleReminderSettingRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.
                     * @implements IListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest=} [properties] Properties to set
                     */
                    function ListCompanyEnablePendingApprovalScheduleReminderSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnablePendingApprovalScheduleReminderSettingRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.prototype.pageSize = 0;
    
                    /**
                     * ListCompanyEnablePendingApprovalScheduleReminderSettingRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnablePendingApprovalScheduleReminderSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest} ListCompanyEnablePendingApprovalScheduleReminderSettingRequest instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.create = function create(properties) {
                        return new ListCompanyEnablePendingApprovalScheduleReminderSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest} message ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingRequest} message ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest} ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest} ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest} ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnablePendingApprovalScheduleReminderSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest} message ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnablePendingApprovalScheduleReminderSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnablePendingApprovalScheduleReminderSettingRequest;
                })();
    
                v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @property {Array.<palexy.streaming.v1.IPendingApprovalScheduleReminderSetting>|null} [settings] ListCompanyEnablePendingApprovalScheduleReminderSettingResponse settings
                     * @property {string|null} [nextPageToken] ListCompanyEnablePendingApprovalScheduleReminderSettingResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.
                     * @implements IListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingResponse=} [properties] Properties to set
                     */
                    function ListCompanyEnablePendingApprovalScheduleReminderSettingResponse(properties) {
                        this.settings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnablePendingApprovalScheduleReminderSettingResponse settings.
                     * @member {Array.<palexy.streaming.v1.IPendingApprovalScheduleReminderSetting>} settings
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.prototype.settings = $util.emptyArray;
    
                    /**
                     * ListCompanyEnablePendingApprovalScheduleReminderSettingResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListCompanyEnablePendingApprovalScheduleReminderSettingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} ListCompanyEnablePendingApprovalScheduleReminderSettingResponse instance
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.create = function create(properties) {
                        return new ListCompanyEnablePendingApprovalScheduleReminderSettingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingResponse} message ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.settings != null && message.settings.length)
                            for (var i = 0; i < message.settings.length; ++i)
                                $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting.encode(message.settings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnablePendingApprovalScheduleReminderSettingResponse} message ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.settings && message.settings.length))
                                    message.settings = [];
                                message.settings.push($root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.settings != null && message.hasOwnProperty("settings")) {
                            if (!Array.isArray(message.settings))
                                return "settings: array expected";
                            for (var i = 0; i < message.settings.length; ++i) {
                                var error = $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting.verify(message.settings[i]);
                                if (error)
                                    return "settings." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse();
                        if (object.settings) {
                            if (!Array.isArray(object.settings))
                                throw TypeError(".palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.settings: array expected");
                            message.settings = [];
                            for (var i = 0; i < object.settings.length; ++i) {
                                if (typeof object.settings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.settings: object expected");
                                message.settings[i] = $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting.fromObject(object.settings[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnablePendingApprovalScheduleReminderSettingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse} message ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.settings = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.settings && message.settings.length) {
                            object.settings = [];
                            for (var j = 0; j < message.settings.length; ++j)
                                object.settings[j] = $root.palexy.streaming.v1.PendingApprovalScheduleReminderSetting.toObject(message.settings[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnablePendingApprovalScheduleReminderSettingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnablePendingApprovalScheduleReminderSettingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnablePendingApprovalScheduleReminderSettingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnablePendingApprovalScheduleReminderSettingResponse;
                })();
    
                v1.TriggerPendingApprovalScheduleReminderNotificationsRequest = (function() {
    
                    /**
                     * Properties of a TriggerPendingApprovalScheduleReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @property {Array.<number>|null} [companyIds] TriggerPendingApprovalScheduleReminderNotificationsRequest companyIds
                     */
    
                    /**
                     * Constructs a new TriggerPendingApprovalScheduleReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerPendingApprovalScheduleReminderNotificationsRequest.
                     * @implements ITriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest=} [properties] Properties to set
                     */
                    function TriggerPendingApprovalScheduleReminderNotificationsRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerPendingApprovalScheduleReminderNotificationsRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @instance
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerPendingApprovalScheduleReminderNotificationsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest} TriggerPendingApprovalScheduleReminderNotificationsRequest instance
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.create = function create(properties) {
                        return new TriggerPendingApprovalScheduleReminderNotificationsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerPendingApprovalScheduleReminderNotificationsRequest message. Does not implicitly {@link palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest} message TriggerPendingApprovalScheduleReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerPendingApprovalScheduleReminderNotificationsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsRequest} message TriggerPendingApprovalScheduleReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerPendingApprovalScheduleReminderNotificationsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest} TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerPendingApprovalScheduleReminderNotificationsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest} TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerPendingApprovalScheduleReminderNotificationsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerPendingApprovalScheduleReminderNotificationsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest} TriggerPendingApprovalScheduleReminderNotificationsRequest
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerPendingApprovalScheduleReminderNotificationsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest} message TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerPendingApprovalScheduleReminderNotificationsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerPendingApprovalScheduleReminderNotificationsRequest;
                })();
    
                v1.TriggerPendingApprovalScheduleReminderNotificationsResponse = (function() {
    
                    /**
                     * Properties of a TriggerPendingApprovalScheduleReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @property {Array.<number>|null} [succeededCompanyIds] TriggerPendingApprovalScheduleReminderNotificationsResponse succeededCompanyIds
                     */
    
                    /**
                     * Constructs a new TriggerPendingApprovalScheduleReminderNotificationsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerPendingApprovalScheduleReminderNotificationsResponse.
                     * @implements ITriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsResponse=} [properties] Properties to set
                     */
                    function TriggerPendingApprovalScheduleReminderNotificationsResponse(properties) {
                        this.succeededCompanyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerPendingApprovalScheduleReminderNotificationsResponse succeededCompanyIds.
                     * @member {Array.<number>} succeededCompanyIds
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @instance
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.prototype.succeededCompanyIds = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerPendingApprovalScheduleReminderNotificationsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} TriggerPendingApprovalScheduleReminderNotificationsResponse instance
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.create = function create(properties) {
                        return new TriggerPendingApprovalScheduleReminderNotificationsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerPendingApprovalScheduleReminderNotificationsResponse message. Does not implicitly {@link palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsResponse} message TriggerPendingApprovalScheduleReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.succeededCompanyIds != null && message.succeededCompanyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.succeededCompanyIds.length; ++i)
                                writer.int64(message.succeededCompanyIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerPendingApprovalScheduleReminderNotificationsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.ITriggerPendingApprovalScheduleReminderNotificationsResponse} message TriggerPendingApprovalScheduleReminderNotificationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerPendingApprovalScheduleReminderNotificationsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.succeededCompanyIds && message.succeededCompanyIds.length))
                                    message.succeededCompanyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.succeededCompanyIds.push(reader.int64());
                                } else
                                    message.succeededCompanyIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerPendingApprovalScheduleReminderNotificationsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerPendingApprovalScheduleReminderNotificationsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.succeededCompanyIds != null && message.hasOwnProperty("succeededCompanyIds")) {
                            if (!Array.isArray(message.succeededCompanyIds))
                                return "succeededCompanyIds: array expected";
                            for (var i = 0; i < message.succeededCompanyIds.length; ++i)
                                if (!$util.isInteger(message.succeededCompanyIds[i]) && !(message.succeededCompanyIds[i] && $util.isInteger(message.succeededCompanyIds[i].low) && $util.isInteger(message.succeededCompanyIds[i].high)))
                                    return "succeededCompanyIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerPendingApprovalScheduleReminderNotificationsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} TriggerPendingApprovalScheduleReminderNotificationsResponse
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse();
                        if (object.succeededCompanyIds) {
                            if (!Array.isArray(object.succeededCompanyIds))
                                throw TypeError(".palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse.succeededCompanyIds: array expected");
                            message.succeededCompanyIds = [];
                            for (var i = 0; i < object.succeededCompanyIds.length; ++i)
                                if ($util.Long)
                                    (message.succeededCompanyIds[i] = $util.Long.fromValue(object.succeededCompanyIds[i])).unsigned = false;
                                else if (typeof object.succeededCompanyIds[i] === "string")
                                    message.succeededCompanyIds[i] = parseInt(object.succeededCompanyIds[i], 10);
                                else if (typeof object.succeededCompanyIds[i] === "number")
                                    message.succeededCompanyIds[i] = object.succeededCompanyIds[i];
                                else if (typeof object.succeededCompanyIds[i] === "object")
                                    message.succeededCompanyIds[i] = new $util.LongBits(object.succeededCompanyIds[i].low >>> 0, object.succeededCompanyIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerPendingApprovalScheduleReminderNotificationsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @static
                     * @param {palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse} message TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.succeededCompanyIds = [];
                        if (message.succeededCompanyIds && message.succeededCompanyIds.length) {
                            object.succeededCompanyIds = [];
                            for (var j = 0; j < message.succeededCompanyIds.length; ++j)
                                if (typeof message.succeededCompanyIds[j] === "number")
                                    object.succeededCompanyIds[j] = options.longs === String ? String(message.succeededCompanyIds[j]) : message.succeededCompanyIds[j];
                                else
                                    object.succeededCompanyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.succeededCompanyIds[j]) : options.longs === Number ? new $util.LongBits(message.succeededCompanyIds[j].low >>> 0, message.succeededCompanyIds[j].high >>> 0).toNumber() : message.succeededCompanyIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerPendingApprovalScheduleReminderNotificationsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerPendingApprovalScheduleReminderNotificationsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerPendingApprovalScheduleReminderNotificationsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerPendingApprovalScheduleReminderNotificationsResponse;
                })();
    
                v1.CalculateNonComplianceForProposedShiftsRequest = (function() {
    
                    /**
                     * Properties of a CalculateNonComplianceForProposedShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICalculateNonComplianceForProposedShiftsRequest
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [proposedShifts] CalculateNonComplianceForProposedShiftsRequest proposedShifts
                     * @property {number|null} [storeId] CalculateNonComplianceForProposedShiftsRequest storeId
                     * @property {number|null} [startDateId] CalculateNonComplianceForProposedShiftsRequest startDateId
                     * @property {number|null} [endDateId] CalculateNonComplianceForProposedShiftsRequest endDateId
                     */
    
                    /**
                     * Constructs a new CalculateNonComplianceForProposedShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CalculateNonComplianceForProposedShiftsRequest.
                     * @implements ICalculateNonComplianceForProposedShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest=} [properties] Properties to set
                     */
                    function CalculateNonComplianceForProposedShiftsRequest(properties) {
                        this.proposedShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateNonComplianceForProposedShiftsRequest proposedShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} proposedShifts
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @instance
                     */
                    CalculateNonComplianceForProposedShiftsRequest.prototype.proposedShifts = $util.emptyArray;
    
                    /**
                     * CalculateNonComplianceForProposedShiftsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @instance
                     */
                    CalculateNonComplianceForProposedShiftsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CalculateNonComplianceForProposedShiftsRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @instance
                     */
                    CalculateNonComplianceForProposedShiftsRequest.prototype.startDateId = 0;
    
                    /**
                     * CalculateNonComplianceForProposedShiftsRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @instance
                     */
                    CalculateNonComplianceForProposedShiftsRequest.prototype.endDateId = 0;
    
                    /**
                     * Creates a new CalculateNonComplianceForProposedShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest} CalculateNonComplianceForProposedShiftsRequest instance
                     */
                    CalculateNonComplianceForProposedShiftsRequest.create = function create(properties) {
                        return new CalculateNonComplianceForProposedShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateNonComplianceForProposedShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest} message CalculateNonComplianceForProposedShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateNonComplianceForProposedShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.proposedShifts != null && message.proposedShifts.length)
                            for (var i = 0; i < message.proposedShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.proposedShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateNonComplianceForProposedShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsRequest} message CalculateNonComplianceForProposedShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateNonComplianceForProposedShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateNonComplianceForProposedShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest} CalculateNonComplianceForProposedShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateNonComplianceForProposedShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.proposedShifts && message.proposedShifts.length))
                                    message.proposedShifts = [];
                                message.proposedShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.startDateId = reader.int32();
                                break;
                            case 4:
                                message.endDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateNonComplianceForProposedShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest} CalculateNonComplianceForProposedShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateNonComplianceForProposedShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateNonComplianceForProposedShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateNonComplianceForProposedShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.proposedShifts != null && message.hasOwnProperty("proposedShifts")) {
                            if (!Array.isArray(message.proposedShifts))
                                return "proposedShifts: array expected";
                            for (var i = 0; i < message.proposedShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.proposedShifts[i]);
                                if (error)
                                    return "proposedShifts." + error;
                            }
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CalculateNonComplianceForProposedShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest} CalculateNonComplianceForProposedShiftsRequest
                     */
                    CalculateNonComplianceForProposedShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest();
                        if (object.proposedShifts) {
                            if (!Array.isArray(object.proposedShifts))
                                throw TypeError(".palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest.proposedShifts: array expected");
                            message.proposedShifts = [];
                            for (var i = 0; i < object.proposedShifts.length; ++i) {
                                if (typeof object.proposedShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest.proposedShifts: object expected");
                                message.proposedShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.proposedShifts[i]);
                            }
                        }
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateNonComplianceForProposedShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest} message CalculateNonComplianceForProposedShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateNonComplianceForProposedShiftsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.proposedShifts = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                        }
                        if (message.proposedShifts && message.proposedShifts.length) {
                            object.proposedShifts = [];
                            for (var j = 0; j < message.proposedShifts.length; ++j)
                                object.proposedShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.proposedShifts[j], options);
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this CalculateNonComplianceForProposedShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateNonComplianceForProposedShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateNonComplianceForProposedShiftsRequest;
                })();
    
                v1.CalculateNonComplianceForProposedShiftsResponse = (function() {
    
                    /**
                     * Properties of a CalculateNonComplianceForProposedShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICalculateNonComplianceForProposedShiftsResponse
                     * @property {Array.<palexy.protobuf.IScheduleNonCompliance>|null} [nonCompliances] CalculateNonComplianceForProposedShiftsResponse nonCompliances
                     */
    
                    /**
                     * Constructs a new CalculateNonComplianceForProposedShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CalculateNonComplianceForProposedShiftsResponse.
                     * @implements ICalculateNonComplianceForProposedShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsResponse=} [properties] Properties to set
                     */
                    function CalculateNonComplianceForProposedShiftsResponse(properties) {
                        this.nonCompliances = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CalculateNonComplianceForProposedShiftsResponse nonCompliances.
                     * @member {Array.<palexy.protobuf.IScheduleNonCompliance>} nonCompliances
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @instance
                     */
                    CalculateNonComplianceForProposedShiftsResponse.prototype.nonCompliances = $util.emptyArray;
    
                    /**
                     * Creates a new CalculateNonComplianceForProposedShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} CalculateNonComplianceForProposedShiftsResponse instance
                     */
                    CalculateNonComplianceForProposedShiftsResponse.create = function create(properties) {
                        return new CalculateNonComplianceForProposedShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CalculateNonComplianceForProposedShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsResponse} message CalculateNonComplianceForProposedShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateNonComplianceForProposedShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.nonCompliances != null && message.nonCompliances.length)
                            for (var i = 0; i < message.nonCompliances.length; ++i)
                                $root.palexy.protobuf.ScheduleNonCompliance.encode(message.nonCompliances[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CalculateNonComplianceForProposedShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ICalculateNonComplianceForProposedShiftsResponse} message CalculateNonComplianceForProposedShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CalculateNonComplianceForProposedShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CalculateNonComplianceForProposedShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} CalculateNonComplianceForProposedShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateNonComplianceForProposedShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.nonCompliances && message.nonCompliances.length))
                                    message.nonCompliances = [];
                                message.nonCompliances.push($root.palexy.protobuf.ScheduleNonCompliance.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CalculateNonComplianceForProposedShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} CalculateNonComplianceForProposedShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CalculateNonComplianceForProposedShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CalculateNonComplianceForProposedShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CalculateNonComplianceForProposedShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.nonCompliances != null && message.hasOwnProperty("nonCompliances")) {
                            if (!Array.isArray(message.nonCompliances))
                                return "nonCompliances: array expected";
                            for (var i = 0; i < message.nonCompliances.length; ++i) {
                                var error = $root.palexy.protobuf.ScheduleNonCompliance.verify(message.nonCompliances[i]);
                                if (error)
                                    return "nonCompliances." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CalculateNonComplianceForProposedShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} CalculateNonComplianceForProposedShiftsResponse
                     */
                    CalculateNonComplianceForProposedShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse();
                        if (object.nonCompliances) {
                            if (!Array.isArray(object.nonCompliances))
                                throw TypeError(".palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse.nonCompliances: array expected");
                            message.nonCompliances = [];
                            for (var i = 0; i < object.nonCompliances.length; ++i) {
                                if (typeof object.nonCompliances[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse.nonCompliances: object expected");
                                message.nonCompliances[i] = $root.palexy.protobuf.ScheduleNonCompliance.fromObject(object.nonCompliances[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CalculateNonComplianceForProposedShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse} message CalculateNonComplianceForProposedShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CalculateNonComplianceForProposedShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.nonCompliances = [];
                        if (message.nonCompliances && message.nonCompliances.length) {
                            object.nonCompliances = [];
                            for (var j = 0; j < message.nonCompliances.length; ++j)
                                object.nonCompliances[j] = $root.palexy.protobuf.ScheduleNonCompliance.toObject(message.nonCompliances[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CalculateNonComplianceForProposedShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CalculateNonComplianceForProposedShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CalculateNonComplianceForProposedShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CalculateNonComplianceForProposedShiftsResponse;
                })();
    
                v1.CleanUpScheduleRequest = (function() {
    
                    /**
                     * Properties of a CleanUpScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICleanUpScheduleRequest
                     * @property {number|null} [storeId] CleanUpScheduleRequest storeId
                     * @property {number|null} [startDateId] CleanUpScheduleRequest startDateId
                     * @property {number|null} [endDateId] CleanUpScheduleRequest endDateId
                     */
    
                    /**
                     * Constructs a new CleanUpScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CleanUpScheduleRequest.
                     * @implements ICleanUpScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest=} [properties] Properties to set
                     */
                    function CleanUpScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CleanUpScheduleRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @instance
                     */
                    CleanUpScheduleRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CleanUpScheduleRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @instance
                     */
                    CleanUpScheduleRequest.prototype.startDateId = 0;
    
                    /**
                     * CleanUpScheduleRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @instance
                     */
                    CleanUpScheduleRequest.prototype.endDateId = 0;
    
                    /**
                     * Creates a new CleanUpScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CleanUpScheduleRequest} CleanUpScheduleRequest instance
                     */
                    CleanUpScheduleRequest.create = function create(properties) {
                        return new CleanUpScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CleanUpScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.CleanUpScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest} message CleanUpScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CleanUpScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CleanUpScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICleanUpScheduleRequest} message CleanUpScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CleanUpScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CleanUpScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CleanUpScheduleRequest} CleanUpScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CleanUpScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CleanUpScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CleanUpScheduleRequest} CleanUpScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CleanUpScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CleanUpScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CleanUpScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CleanUpScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CleanUpScheduleRequest} CleanUpScheduleRequest
                     */
                    CleanUpScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CleanUpScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CleanUpScheduleRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CleanUpScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.CleanUpScheduleRequest} message CleanUpScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CleanUpScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this CleanUpScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CleanUpScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CleanUpScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CleanUpScheduleRequest;
                })();
    
                v1.BatchDraftEditStaffShiftsRequest = (function() {
    
                    /**
                     * Properties of a BatchDraftEditStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftEditStaffShiftsRequest
                     * @property {number|null} [storeId] BatchDraftEditStaffShiftsRequest storeId
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] BatchDraftEditStaffShiftsRequest staffShifts
                     * @property {google.protobuf.IFieldMask|null} [updateMask] BatchDraftEditStaffShiftsRequest updateMask
                     */
    
                    /**
                     * Constructs a new BatchDraftEditStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftEditStaffShiftsRequest.
                     * @implements IBatchDraftEditStaffShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest=} [properties] Properties to set
                     */
                    function BatchDraftEditStaffShiftsRequest(properties) {
                        this.staffShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftEditStaffShiftsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftEditStaffShiftsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchDraftEditStaffShiftsRequest staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftEditStaffShiftsRequest.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * BatchDraftEditStaffShiftsRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftEditStaffShiftsRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new BatchDraftEditStaffShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsRequest} BatchDraftEditStaffShiftsRequest instance
                     */
                    BatchDraftEditStaffShiftsRequest.create = function create(properties) {
                        return new BatchDraftEditStaffShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftEditStaffShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDraftEditStaffShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest} message BatchDraftEditStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftEditStaffShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftEditStaffShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftEditStaffShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsRequest} message BatchDraftEditStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftEditStaffShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftEditStaffShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsRequest} BatchDraftEditStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftEditStaffShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftEditStaffShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftEditStaffShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsRequest} BatchDraftEditStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftEditStaffShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftEditStaffShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftEditStaffShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftEditStaffShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsRequest} BatchDraftEditStaffShiftsRequest
                     */
                    BatchDraftEditStaffShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftEditStaffShiftsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftEditStaffShiftsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.BatchDraftEditStaffShiftsRequest.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftEditStaffShiftsRequest.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.BatchDraftEditStaffShiftsRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftEditStaffShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftEditStaffShiftsRequest} message BatchDraftEditStaffShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftEditStaffShiftsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShifts = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.updateMask = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftEditStaffShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftEditStaffShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftEditStaffShiftsRequest;
                })();
    
                v1.BatchDraftEditStaffShiftsResponse = (function() {
    
                    /**
                     * Properties of a BatchDraftEditStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftEditStaffShiftsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] BatchDraftEditStaffShiftsResponse staffShifts
                     */
    
                    /**
                     * Constructs a new BatchDraftEditStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftEditStaffShiftsResponse.
                     * @implements IBatchDraftEditStaffShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsResponse=} [properties] Properties to set
                     */
                    function BatchDraftEditStaffShiftsResponse(properties) {
                        this.staffShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftEditStaffShiftsResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @instance
                     */
                    BatchDraftEditStaffShiftsResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDraftEditStaffShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} BatchDraftEditStaffShiftsResponse instance
                     */
                    BatchDraftEditStaffShiftsResponse.create = function create(properties) {
                        return new BatchDraftEditStaffShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftEditStaffShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchDraftEditStaffShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsResponse} message BatchDraftEditStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftEditStaffShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftEditStaffShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftEditStaffShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftEditStaffShiftsResponse} message BatchDraftEditStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftEditStaffShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftEditStaffShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} BatchDraftEditStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftEditStaffShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftEditStaffShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftEditStaffShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} BatchDraftEditStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftEditStaffShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftEditStaffShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftEditStaffShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftEditStaffShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} BatchDraftEditStaffShiftsResponse
                     */
                    BatchDraftEditStaffShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftEditStaffShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftEditStaffShiftsResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.BatchDraftEditStaffShiftsResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftEditStaffShiftsResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftEditStaffShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftEditStaffShiftsResponse} message BatchDraftEditStaffShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftEditStaffShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShifts = [];
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftEditStaffShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftEditStaffShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftEditStaffShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftEditStaffShiftsResponse;
                })();
    
                v1.BatchDraftCreateStaffShiftsRequest = (function() {
    
                    /**
                     * Properties of a BatchDraftCreateStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftCreateStaffShiftsRequest
                     * @property {number|null} [storeId] BatchDraftCreateStaffShiftsRequest storeId
                     * @property {number|null} [startDateId] BatchDraftCreateStaffShiftsRequest startDateId
                     * @property {number|null} [endDateId] BatchDraftCreateStaffShiftsRequest endDateId
                     * @property {Array.<palexy.protobuf.IProposedShift>|null} [proposedShifts] BatchDraftCreateStaffShiftsRequest proposedShifts
                     * @property {boolean|null} [preview] BatchDraftCreateStaffShiftsRequest preview
                     * @property {Array.<number>|null} [staffIds] BatchDraftCreateStaffShiftsRequest staffIds
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] BatchDraftCreateStaffShiftsRequest staffShifts
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [timeOffs] BatchDraftCreateStaffShiftsRequest timeOffs
                     * @property {boolean|null} [allowDisabledStaff] BatchDraftCreateStaffShiftsRequest allowDisabledStaff
                     * @property {boolean|null} [createAuditHistory] BatchDraftCreateStaffShiftsRequest createAuditHistory
                     * @property {boolean|null} [allowExistingPublishedShifts] BatchDraftCreateStaffShiftsRequest allowExistingPublishedShifts
                     */
    
                    /**
                     * Constructs a new BatchDraftCreateStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftCreateStaffShiftsRequest.
                     * @implements IBatchDraftCreateStaffShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest=} [properties] Properties to set
                     */
                    function BatchDraftCreateStaffShiftsRequest(properties) {
                        this.proposedShifts = [];
                        this.staffIds = [];
                        this.staffShifts = [];
                        this.timeOffs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.startDateId = 0;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.endDateId = 0;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest proposedShifts.
                     * @member {Array.<palexy.protobuf.IProposedShift>} proposedShifts
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.proposedShifts = $util.emptyArray;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.preview = false;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest staffIds.
                     * @member {Array.<number>} staffIds
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.staffIds = $util.emptyArray;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest timeOffs.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} timeOffs
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.timeOffs = $util.emptyArray;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest allowDisabledStaff.
                     * @member {boolean} allowDisabledStaff
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.allowDisabledStaff = false;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest createAuditHistory.
                     * @member {boolean} createAuditHistory
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.createAuditHistory = false;
    
                    /**
                     * BatchDraftCreateStaffShiftsRequest allowExistingPublishedShifts.
                     * @member {boolean} allowExistingPublishedShifts
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.allowExistingPublishedShifts = false;
    
                    /**
                     * Creates a new BatchDraftCreateStaffShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest} BatchDraftCreateStaffShiftsRequest instance
                     */
                    BatchDraftCreateStaffShiftsRequest.create = function create(properties) {
                        return new BatchDraftCreateStaffShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest} message BatchDraftCreateStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.proposedShifts != null && message.proposedShifts.length)
                            for (var i = 0; i < message.proposedShifts.length; ++i)
                                $root.palexy.protobuf.ProposedShift.encode(message.proposedShifts[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.preview);
                        if (message.staffIds != null && message.staffIds.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.staffIds.length; ++i)
                                writer.int64(message.staffIds[i]);
                            writer.ldelim();
                        }
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.timeOffs != null && message.timeOffs.length)
                            for (var i = 0; i < message.timeOffs.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.timeOffs[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.allowDisabledStaff != null && Object.hasOwnProperty.call(message, "allowDisabledStaff"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.allowDisabledStaff);
                        if (message.createAuditHistory != null && Object.hasOwnProperty.call(message, "createAuditHistory"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.createAuditHistory);
                        if (message.allowExistingPublishedShifts != null && Object.hasOwnProperty.call(message, "allowExistingPublishedShifts"))
                            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.allowExistingPublishedShifts);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsRequest} message BatchDraftCreateStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest} BatchDraftCreateStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                if (!(message.proposedShifts && message.proposedShifts.length))
                                    message.proposedShifts = [];
                                message.proposedShifts.push($root.palexy.protobuf.ProposedShift.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.preview = reader.bool();
                                break;
                            case 6:
                                if (!(message.staffIds && message.staffIds.length))
                                    message.staffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffIds.push(reader.int64());
                                } else
                                    message.staffIds.push(reader.int64());
                                break;
                            case 7:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 8:
                                if (!(message.timeOffs && message.timeOffs.length))
                                    message.timeOffs = [];
                                message.timeOffs.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            case 9:
                                message.allowDisabledStaff = reader.bool();
                                break;
                            case 10:
                                message.createAuditHistory = reader.bool();
                                break;
                            case 11:
                                message.allowExistingPublishedShifts = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest} BatchDraftCreateStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftCreateStaffShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftCreateStaffShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.proposedShifts != null && message.hasOwnProperty("proposedShifts")) {
                            if (!Array.isArray(message.proposedShifts))
                                return "proposedShifts: array expected";
                            for (var i = 0; i < message.proposedShifts.length; ++i) {
                                var error = $root.palexy.protobuf.ProposedShift.verify(message.proposedShifts[i]);
                                if (error)
                                    return "proposedShifts." + error;
                            }
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (!Array.isArray(message.staffIds))
                                return "staffIds: array expected";
                            for (var i = 0; i < message.staffIds.length; ++i)
                                if (!$util.isInteger(message.staffIds[i]) && !(message.staffIds[i] && $util.isInteger(message.staffIds[i].low) && $util.isInteger(message.staffIds[i].high)))
                                    return "staffIds: integer|Long[] expected";
                        }
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.timeOffs != null && message.hasOwnProperty("timeOffs")) {
                            if (!Array.isArray(message.timeOffs))
                                return "timeOffs: array expected";
                            for (var i = 0; i < message.timeOffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.timeOffs[i]);
                                if (error)
                                    return "timeOffs." + error;
                            }
                        }
                        if (message.allowDisabledStaff != null && message.hasOwnProperty("allowDisabledStaff"))
                            if (typeof message.allowDisabledStaff !== "boolean")
                                return "allowDisabledStaff: boolean expected";
                        if (message.createAuditHistory != null && message.hasOwnProperty("createAuditHistory"))
                            if (typeof message.createAuditHistory !== "boolean")
                                return "createAuditHistory: boolean expected";
                        if (message.allowExistingPublishedShifts != null && message.hasOwnProperty("allowExistingPublishedShifts"))
                            if (typeof message.allowExistingPublishedShifts !== "boolean")
                                return "allowExistingPublishedShifts: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftCreateStaffShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest} BatchDraftCreateStaffShiftsRequest
                     */
                    BatchDraftCreateStaffShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.proposedShifts) {
                            if (!Array.isArray(object.proposedShifts))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.proposedShifts: array expected");
                            message.proposedShifts = [];
                            for (var i = 0; i < object.proposedShifts.length; ++i) {
                                if (typeof object.proposedShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.proposedShifts: object expected");
                                message.proposedShifts[i] = $root.palexy.protobuf.ProposedShift.fromObject(object.proposedShifts[i]);
                            }
                        }
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        if (object.staffIds) {
                            if (!Array.isArray(object.staffIds))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.staffIds: array expected");
                            message.staffIds = [];
                            for (var i = 0; i < object.staffIds.length; ++i)
                                if ($util.Long)
                                    (message.staffIds[i] = $util.Long.fromValue(object.staffIds[i])).unsigned = false;
                                else if (typeof object.staffIds[i] === "string")
                                    message.staffIds[i] = parseInt(object.staffIds[i], 10);
                                else if (typeof object.staffIds[i] === "number")
                                    message.staffIds[i] = object.staffIds[i];
                                else if (typeof object.staffIds[i] === "object")
                                    message.staffIds[i] = new $util.LongBits(object.staffIds[i].low >>> 0, object.staffIds[i].high >>> 0).toNumber();
                        }
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.timeOffs) {
                            if (!Array.isArray(object.timeOffs))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.timeOffs: array expected");
                            message.timeOffs = [];
                            for (var i = 0; i < object.timeOffs.length; ++i) {
                                if (typeof object.timeOffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest.timeOffs: object expected");
                                message.timeOffs[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.timeOffs[i]);
                            }
                        }
                        if (object.allowDisabledStaff != null)
                            message.allowDisabledStaff = Boolean(object.allowDisabledStaff);
                        if (object.createAuditHistory != null)
                            message.createAuditHistory = Boolean(object.createAuditHistory);
                        if (object.allowExistingPublishedShifts != null)
                            message.allowExistingPublishedShifts = Boolean(object.allowExistingPublishedShifts);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftCreateStaffShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest} message BatchDraftCreateStaffShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftCreateStaffShiftsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.proposedShifts = [];
                            object.staffIds = [];
                            object.staffShifts = [];
                            object.timeOffs = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.preview = false;
                            object.allowDisabledStaff = false;
                            object.createAuditHistory = false;
                            object.allowExistingPublishedShifts = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.proposedShifts && message.proposedShifts.length) {
                            object.proposedShifts = [];
                            for (var j = 0; j < message.proposedShifts.length; ++j)
                                object.proposedShifts[j] = $root.palexy.protobuf.ProposedShift.toObject(message.proposedShifts[j], options);
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        if (message.staffIds && message.staffIds.length) {
                            object.staffIds = [];
                            for (var j = 0; j < message.staffIds.length; ++j)
                                if (typeof message.staffIds[j] === "number")
                                    object.staffIds[j] = options.longs === String ? String(message.staffIds[j]) : message.staffIds[j];
                                else
                                    object.staffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffIds[j]) : options.longs === Number ? new $util.LongBits(message.staffIds[j].low >>> 0, message.staffIds[j].high >>> 0).toNumber() : message.staffIds[j];
                        }
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.timeOffs && message.timeOffs.length) {
                            object.timeOffs = [];
                            for (var j = 0; j < message.timeOffs.length; ++j)
                                object.timeOffs[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.timeOffs[j], options);
                        }
                        if (message.allowDisabledStaff != null && message.hasOwnProperty("allowDisabledStaff"))
                            object.allowDisabledStaff = message.allowDisabledStaff;
                        if (message.createAuditHistory != null && message.hasOwnProperty("createAuditHistory"))
                            object.createAuditHistory = message.createAuditHistory;
                        if (message.allowExistingPublishedShifts != null && message.hasOwnProperty("allowExistingPublishedShifts"))
                            object.allowExistingPublishedShifts = message.allowExistingPublishedShifts;
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftCreateStaffShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftCreateStaffShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftCreateStaffShiftsRequest;
                })();
    
                v1.BatchDraftCreateStaffShiftsResponse = (function() {
    
                    /**
                     * Properties of a BatchDraftCreateStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchDraftCreateStaffShiftsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] BatchDraftCreateStaffShiftsResponse staffShifts
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [staffTimeOffs] BatchDraftCreateStaffShiftsResponse staffTimeOffs
                     */
    
                    /**
                     * Constructs a new BatchDraftCreateStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchDraftCreateStaffShiftsResponse.
                     * @implements IBatchDraftCreateStaffShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsResponse=} [properties] Properties to set
                     */
                    function BatchDraftCreateStaffShiftsResponse(properties) {
                        this.staffShifts = [];
                        this.staffTimeOffs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchDraftCreateStaffShiftsResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * BatchDraftCreateStaffShiftsResponse staffTimeOffs.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} staffTimeOffs
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @instance
                     */
                    BatchDraftCreateStaffShiftsResponse.prototype.staffTimeOffs = $util.emptyArray;
    
                    /**
                     * Creates a new BatchDraftCreateStaffShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} BatchDraftCreateStaffShiftsResponse instance
                     */
                    BatchDraftCreateStaffShiftsResponse.create = function create(properties) {
                        return new BatchDraftCreateStaffShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsResponse} message BatchDraftCreateStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.staffTimeOffs != null && message.staffTimeOffs.length)
                            for (var i = 0; i < message.staffTimeOffs.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOffs[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchDraftCreateStaffShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchDraftCreateStaffShiftsResponse} message BatchDraftCreateStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchDraftCreateStaffShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} BatchDraftCreateStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.staffTimeOffs && message.staffTimeOffs.length))
                                    message.staffTimeOffs = [];
                                message.staffTimeOffs.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchDraftCreateStaffShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} BatchDraftCreateStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchDraftCreateStaffShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchDraftCreateStaffShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchDraftCreateStaffShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.staffTimeOffs != null && message.hasOwnProperty("staffTimeOffs")) {
                            if (!Array.isArray(message.staffTimeOffs))
                                return "staffTimeOffs: array expected";
                            for (var i = 0; i < message.staffTimeOffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOffs[i]);
                                if (error)
                                    return "staffTimeOffs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchDraftCreateStaffShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} BatchDraftCreateStaffShiftsResponse
                     */
                    BatchDraftCreateStaffShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.staffTimeOffs) {
                            if (!Array.isArray(object.staffTimeOffs))
                                throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.staffTimeOffs: array expected");
                            message.staffTimeOffs = [];
                            for (var i = 0; i < object.staffTimeOffs.length; ++i) {
                                if (typeof object.staffTimeOffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse.staffTimeOffs: object expected");
                                message.staffTimeOffs[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOffs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchDraftCreateStaffShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse} message BatchDraftCreateStaffShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchDraftCreateStaffShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.staffShifts = [];
                            object.staffTimeOffs = [];
                        }
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.staffTimeOffs && message.staffTimeOffs.length) {
                            object.staffTimeOffs = [];
                            for (var j = 0; j < message.staffTimeOffs.length; ++j)
                                object.staffTimeOffs[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOffs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchDraftCreateStaffShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchDraftCreateStaffShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchDraftCreateStaffShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchDraftCreateStaffShiftsResponse;
                })();
    
                v1.GetStaffScheduleGeneralSettingRequest = (function() {
    
                    /**
                     * Properties of a GetStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffScheduleGeneralSettingRequest
                     * @property {number|null} [companyId] GetStaffScheduleGeneralSettingRequest companyId
                     * @property {number|null} [settingId] GetStaffScheduleGeneralSettingRequest settingId
                     */
    
                    /**
                     * Constructs a new GetStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffScheduleGeneralSettingRequest.
                     * @implements IGetStaffScheduleGeneralSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     */
                    function GetStaffScheduleGeneralSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffScheduleGeneralSettingRequest companyId.
                     * @member {number|null|undefined} companyId
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    GetStaffScheduleGeneralSettingRequest.prototype.companyId = null;
    
                    /**
                     * GetStaffScheduleGeneralSettingRequest settingId.
                     * @member {number|null|undefined} settingId
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    GetStaffScheduleGeneralSettingRequest.prototype.settingId = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * GetStaffScheduleGeneralSettingRequest filter.
                     * @member {"companyId"|"settingId"|undefined} filter
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    Object.defineProperty(GetStaffScheduleGeneralSettingRequest.prototype, "filter", {
                        get: $util.oneOfGetter($oneOfFields = ["companyId", "settingId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new GetStaffScheduleGeneralSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest} GetStaffScheduleGeneralSettingRequest instance
                     */
                    GetStaffScheduleGeneralSettingRequest.create = function create(properties) {
                        return new GetStaffScheduleGeneralSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleGeneralSettingRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest} message GetStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleGeneralSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.settingId != null && Object.hasOwnProperty.call(message, "settingId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.settingId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleGeneralSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleGeneralSettingRequest} message GetStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleGeneralSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffScheduleGeneralSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest} GetStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleGeneralSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.settingId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffScheduleGeneralSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest} GetStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleGeneralSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffScheduleGeneralSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffScheduleGeneralSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            properties.filter = 1;
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        }
                        if (message.settingId != null && message.hasOwnProperty("settingId")) {
                            if (properties.filter === 1)
                                return "filter: multiple values";
                            properties.filter = 1;
                            if (!$util.isInteger(message.settingId) && !(message.settingId && $util.isInteger(message.settingId.low) && $util.isInteger(message.settingId.high)))
                                return "settingId: integer|Long expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffScheduleGeneralSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest} GetStaffScheduleGeneralSettingRequest
                     */
                    GetStaffScheduleGeneralSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.settingId != null)
                            if ($util.Long)
                                (message.settingId = $util.Long.fromValue(object.settingId)).unsigned = false;
                            else if (typeof object.settingId === "string")
                                message.settingId = parseInt(object.settingId, 10);
                            else if (typeof object.settingId === "number")
                                message.settingId = object.settingId;
                            else if (typeof object.settingId === "object")
                                message.settingId = new $util.LongBits(object.settingId.low >>> 0, object.settingId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffScheduleGeneralSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest} message GetStaffScheduleGeneralSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffScheduleGeneralSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.companyId != null && message.hasOwnProperty("companyId")) {
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                            if (options.oneofs)
                                object.filter = "companyId";
                        }
                        if (message.settingId != null && message.hasOwnProperty("settingId")) {
                            if (typeof message.settingId === "number")
                                object.settingId = options.longs === String ? String(message.settingId) : message.settingId;
                            else
                                object.settingId = options.longs === String ? $util.Long.prototype.toString.call(message.settingId) : options.longs === Number ? new $util.LongBits(message.settingId.low >>> 0, message.settingId.high >>> 0).toNumber() : message.settingId;
                            if (options.oneofs)
                                object.filter = "settingId";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffScheduleGeneralSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffScheduleGeneralSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffScheduleGeneralSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffScheduleGeneralSettingRequest;
                })();
    
                v1.ListStaffScheduleGeneralSettingsRequest = (function() {
    
                    /**
                     * Properties of a ListStaffScheduleGeneralSettingsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffScheduleGeneralSettingsRequest
                     * @property {Array.<number>|null} [companyIds] ListStaffScheduleGeneralSettingsRequest companyIds
                     * @property {google.protobuf.IFieldMask|null} [readMask] ListStaffScheduleGeneralSettingsRequest readMask
                     */
    
                    /**
                     * Constructs a new ListStaffScheduleGeneralSettingsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffScheduleGeneralSettingsRequest.
                     * @implements IListStaffScheduleGeneralSettingsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest=} [properties] Properties to set
                     */
                    function ListStaffScheduleGeneralSettingsRequest(properties) {
                        this.companyIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffScheduleGeneralSettingsRequest companyIds.
                     * @member {Array.<number>} companyIds
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @instance
                     */
                    ListStaffScheduleGeneralSettingsRequest.prototype.companyIds = $util.emptyArray;
    
                    /**
                     * ListStaffScheduleGeneralSettingsRequest readMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} readMask
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @instance
                     */
                    ListStaffScheduleGeneralSettingsRequest.prototype.readMask = null;
    
                    /**
                     * Creates a new ListStaffScheduleGeneralSettingsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest} ListStaffScheduleGeneralSettingsRequest instance
                     */
                    ListStaffScheduleGeneralSettingsRequest.create = function create(properties) {
                        return new ListStaffScheduleGeneralSettingsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffScheduleGeneralSettingsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest} message ListStaffScheduleGeneralSettingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffScheduleGeneralSettingsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyIds != null && message.companyIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.companyIds.length; ++i)
                                writer.int64(message.companyIds[i]);
                            writer.ldelim();
                        }
                        if (message.readMask != null && Object.hasOwnProperty.call(message, "readMask"))
                            $root.google.protobuf.FieldMask.encode(message.readMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffScheduleGeneralSettingsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsRequest} message ListStaffScheduleGeneralSettingsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffScheduleGeneralSettingsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffScheduleGeneralSettingsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest} ListStaffScheduleGeneralSettingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffScheduleGeneralSettingsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyIds && message.companyIds.length))
                                    message.companyIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.companyIds.push(reader.int64());
                                } else
                                    message.companyIds.push(reader.int64());
                                break;
                            case 2:
                                message.readMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffScheduleGeneralSettingsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest} ListStaffScheduleGeneralSettingsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffScheduleGeneralSettingsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffScheduleGeneralSettingsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffScheduleGeneralSettingsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyIds != null && message.hasOwnProperty("companyIds")) {
                            if (!Array.isArray(message.companyIds))
                                return "companyIds: array expected";
                            for (var i = 0; i < message.companyIds.length; ++i)
                                if (!$util.isInteger(message.companyIds[i]) && !(message.companyIds[i] && $util.isInteger(message.companyIds[i].low) && $util.isInteger(message.companyIds[i].high)))
                                    return "companyIds: integer|Long[] expected";
                        }
                        if (message.readMask != null && message.hasOwnProperty("readMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.readMask);
                            if (error)
                                return "readMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffScheduleGeneralSettingsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest} ListStaffScheduleGeneralSettingsRequest
                     */
                    ListStaffScheduleGeneralSettingsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest();
                        if (object.companyIds) {
                            if (!Array.isArray(object.companyIds))
                                throw TypeError(".palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest.companyIds: array expected");
                            message.companyIds = [];
                            for (var i = 0; i < object.companyIds.length; ++i)
                                if ($util.Long)
                                    (message.companyIds[i] = $util.Long.fromValue(object.companyIds[i])).unsigned = false;
                                else if (typeof object.companyIds[i] === "string")
                                    message.companyIds[i] = parseInt(object.companyIds[i], 10);
                                else if (typeof object.companyIds[i] === "number")
                                    message.companyIds[i] = object.companyIds[i];
                                else if (typeof object.companyIds[i] === "object")
                                    message.companyIds[i] = new $util.LongBits(object.companyIds[i].low >>> 0, object.companyIds[i].high >>> 0).toNumber();
                        }
                        if (object.readMask != null) {
                            if (typeof object.readMask !== "object")
                                throw TypeError(".palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest.readMask: object expected");
                            message.readMask = $root.google.protobuf.FieldMask.fromObject(object.readMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffScheduleGeneralSettingsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest} message ListStaffScheduleGeneralSettingsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffScheduleGeneralSettingsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyIds = [];
                        if (options.defaults)
                            object.readMask = null;
                        if (message.companyIds && message.companyIds.length) {
                            object.companyIds = [];
                            for (var j = 0; j < message.companyIds.length; ++j)
                                if (typeof message.companyIds[j] === "number")
                                    object.companyIds[j] = options.longs === String ? String(message.companyIds[j]) : message.companyIds[j];
                                else
                                    object.companyIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.companyIds[j]) : options.longs === Number ? new $util.LongBits(message.companyIds[j].low >>> 0, message.companyIds[j].high >>> 0).toNumber() : message.companyIds[j];
                        }
                        if (message.readMask != null && message.hasOwnProperty("readMask"))
                            object.readMask = $root.google.protobuf.FieldMask.toObject(message.readMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffScheduleGeneralSettingsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffScheduleGeneralSettingsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffScheduleGeneralSettingsRequest;
                })();
    
                v1.ListStaffScheduleGeneralSettingsResponse = (function() {
    
                    /**
                     * Properties of a ListStaffScheduleGeneralSettingsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffScheduleGeneralSettingsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffScheduleGeneralSetting>|null} [settings] ListStaffScheduleGeneralSettingsResponse settings
                     */
    
                    /**
                     * Constructs a new ListStaffScheduleGeneralSettingsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffScheduleGeneralSettingsResponse.
                     * @implements IListStaffScheduleGeneralSettingsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsResponse=} [properties] Properties to set
                     */
                    function ListStaffScheduleGeneralSettingsResponse(properties) {
                        this.settings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffScheduleGeneralSettingsResponse settings.
                     * @member {Array.<palexy.streaming.v1.IStaffScheduleGeneralSetting>} settings
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @instance
                     */
                    ListStaffScheduleGeneralSettingsResponse.prototype.settings = $util.emptyArray;
    
                    /**
                     * Creates a new ListStaffScheduleGeneralSettingsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} ListStaffScheduleGeneralSettingsResponse instance
                     */
                    ListStaffScheduleGeneralSettingsResponse.create = function create(properties) {
                        return new ListStaffScheduleGeneralSettingsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffScheduleGeneralSettingsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsResponse} message ListStaffScheduleGeneralSettingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffScheduleGeneralSettingsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.settings != null && message.settings.length)
                            for (var i = 0; i < message.settings.length; ++i)
                                $root.palexy.streaming.v1.StaffScheduleGeneralSetting.encode(message.settings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffScheduleGeneralSettingsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffScheduleGeneralSettingsResponse} message ListStaffScheduleGeneralSettingsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffScheduleGeneralSettingsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffScheduleGeneralSettingsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} ListStaffScheduleGeneralSettingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffScheduleGeneralSettingsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.settings && message.settings.length))
                                    message.settings = [];
                                message.settings.push($root.palexy.streaming.v1.StaffScheduleGeneralSetting.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffScheduleGeneralSettingsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} ListStaffScheduleGeneralSettingsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffScheduleGeneralSettingsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffScheduleGeneralSettingsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffScheduleGeneralSettingsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.settings != null && message.hasOwnProperty("settings")) {
                            if (!Array.isArray(message.settings))
                                return "settings: array expected";
                            for (var i = 0; i < message.settings.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.verify(message.settings[i]);
                                if (error)
                                    return "settings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffScheduleGeneralSettingsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} ListStaffScheduleGeneralSettingsResponse
                     */
                    ListStaffScheduleGeneralSettingsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse();
                        if (object.settings) {
                            if (!Array.isArray(object.settings))
                                throw TypeError(".palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse.settings: array expected");
                            message.settings = [];
                            for (var i = 0; i < object.settings.length; ++i) {
                                if (typeof object.settings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse.settings: object expected");
                                message.settings[i] = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.fromObject(object.settings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffScheduleGeneralSettingsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse} message ListStaffScheduleGeneralSettingsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffScheduleGeneralSettingsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.settings = [];
                        if (message.settings && message.settings.length) {
                            object.settings = [];
                            for (var j = 0; j < message.settings.length; ++j)
                                object.settings[j] = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.toObject(message.settings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffScheduleGeneralSettingsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffScheduleGeneralSettingsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffScheduleGeneralSettingsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffScheduleGeneralSettingsResponse;
                })();
    
                v1.CreateDemoDataRequest = (function() {
    
                    /**
                     * Properties of a CreateDemoDataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateDemoDataRequest
                     * @property {number|null} [storeId] CreateDemoDataRequest storeId
                     * @property {number|null} [startDateId] CreateDemoDataRequest startDateId
                     */
    
                    /**
                     * Constructs a new CreateDemoDataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateDemoDataRequest.
                     * @implements ICreateDemoDataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest=} [properties] Properties to set
                     */
                    function CreateDemoDataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDemoDataRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @instance
                     */
                    CreateDemoDataRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateDemoDataRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @instance
                     */
                    CreateDemoDataRequest.prototype.startDateId = 0;
    
                    /**
                     * Creates a new CreateDemoDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateDemoDataRequest} CreateDemoDataRequest instance
                     */
                    CreateDemoDataRequest.create = function create(properties) {
                        return new CreateDemoDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDemoDataRequest message. Does not implicitly {@link palexy.streaming.v1.CreateDemoDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest} message CreateDemoDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDemoDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDemoDataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateDemoDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataRequest} message CreateDemoDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDemoDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDemoDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateDemoDataRequest} CreateDemoDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDemoDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateDemoDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDemoDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateDemoDataRequest} CreateDemoDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDemoDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDemoDataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDemoDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateDemoDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateDemoDataRequest} CreateDemoDataRequest
                     */
                    CreateDemoDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateDemoDataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateDemoDataRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDemoDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateDemoDataRequest} message CreateDemoDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDemoDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        return object;
                    };
    
                    /**
                     * Converts this CreateDemoDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateDemoDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDemoDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDemoDataRequest;
                })();
    
                v1.CreateDemoDataResponse = (function() {
    
                    /**
                     * Properties of a CreateDemoDataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateDemoDataResponse
                     */
    
                    /**
                     * Constructs a new CreateDemoDataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateDemoDataResponse.
                     * @implements ICreateDemoDataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateDemoDataResponse=} [properties] Properties to set
                     */
                    function CreateDemoDataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new CreateDemoDataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateDemoDataResponse} CreateDemoDataResponse instance
                     */
                    CreateDemoDataResponse.create = function create(properties) {
                        return new CreateDemoDataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDemoDataResponse message. Does not implicitly {@link palexy.streaming.v1.CreateDemoDataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataResponse} message CreateDemoDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDemoDataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDemoDataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateDemoDataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {palexy.streaming.v1.ICreateDemoDataResponse} message CreateDemoDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDemoDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDemoDataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateDemoDataResponse} CreateDemoDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDemoDataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateDemoDataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDemoDataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateDemoDataResponse} CreateDemoDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDemoDataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDemoDataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDemoDataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateDemoDataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateDemoDataResponse} CreateDemoDataResponse
                     */
                    CreateDemoDataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateDemoDataResponse)
                            return object;
                        return new $root.palexy.streaming.v1.CreateDemoDataResponse();
                    };
    
                    /**
                     * Creates a plain object from a CreateDemoDataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @static
                     * @param {palexy.streaming.v1.CreateDemoDataResponse} message CreateDemoDataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDemoDataResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this CreateDemoDataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateDemoDataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDemoDataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDemoDataResponse;
                })();
    
                v1.ListStaffShiftsRequest = (function() {
    
                    /**
                     * Properties of a ListStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftsRequest
                     * @property {number|null} [storeId] ListStaffShiftsRequest storeId
                     * @property {number|null} [startDateId] ListStaffShiftsRequest startDateId
                     * @property {number|null} [endDateId] ListStaffShiftsRequest endDateId
                     * @property {palexy.streaming.v1.StaffScheduleState|null} [state] ListStaffShiftsRequest state
                     * @property {boolean|null} [includeStaffPosition] ListStaffShiftsRequest includeStaffPosition
                     * @property {boolean|null} [includeStaff] ListStaffShiftsRequest includeStaff
                     * @property {Array.<number>|null} [staffIds] ListStaffShiftsRequest staffIds
                     */
    
                    /**
                     * Constructs a new ListStaffShiftsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftsRequest.
                     * @implements IListStaffShiftsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest=} [properties] Properties to set
                     */
                    function ListStaffShiftsRequest(properties) {
                        this.staffIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftsRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftsRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.startDateId = 0;
    
                    /**
                     * ListStaffShiftsRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.endDateId = 0;
    
                    /**
                     * ListStaffShiftsRequest state.
                     * @member {palexy.streaming.v1.StaffScheduleState} state
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.state = 0;
    
                    /**
                     * ListStaffShiftsRequest includeStaffPosition.
                     * @member {boolean} includeStaffPosition
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.includeStaffPosition = false;
    
                    /**
                     * ListStaffShiftsRequest includeStaff.
                     * @member {boolean} includeStaff
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.includeStaff = false;
    
                    /**
                     * ListStaffShiftsRequest staffIds.
                     * @member {Array.<number>} staffIds
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     */
                    ListStaffShiftsRequest.prototype.staffIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListStaffShiftsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftsRequest} ListStaffShiftsRequest instance
                     */
                    ListStaffShiftsRequest.create = function create(properties) {
                        return new ListStaffShiftsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest} message ListStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.state);
                        if (message.includeStaffPosition != null && Object.hasOwnProperty.call(message, "includeStaffPosition"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeStaffPosition);
                        if (message.includeStaff != null && Object.hasOwnProperty.call(message, "includeStaff"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeStaff);
                        if (message.staffIds != null && message.staffIds.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.staffIds.length; ++i)
                                writer.int64(message.staffIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsRequest} message ListStaffShiftsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftsRequest} ListStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.state = reader.int32();
                                break;
                            case 5:
                                message.includeStaffPosition = reader.bool();
                                break;
                            case 7:
                                message.includeStaff = reader.bool();
                                break;
                            case 8:
                                if (!(message.staffIds && message.staffIds.length))
                                    message.staffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffIds.push(reader.int64());
                                } else
                                    message.staffIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftsRequest} ListStaffShiftsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.includeStaffPosition != null && message.hasOwnProperty("includeStaffPosition"))
                            if (typeof message.includeStaffPosition !== "boolean")
                                return "includeStaffPosition: boolean expected";
                        if (message.includeStaff != null && message.hasOwnProperty("includeStaff"))
                            if (typeof message.includeStaff !== "boolean")
                                return "includeStaff: boolean expected";
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (!Array.isArray(message.staffIds))
                                return "staffIds: array expected";
                            for (var i = 0; i < message.staffIds.length; ++i)
                                if (!$util.isInteger(message.staffIds[i]) && !(message.staffIds[i] && $util.isInteger(message.staffIds[i].low) && $util.isInteger(message.staffIds[i].high)))
                                    return "staffIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftsRequest} ListStaffShiftsRequest
                     */
                    ListStaffShiftsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftsRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        switch (object.state) {
                        case "DRAFT_CREATED":
                        case 0:
                            message.state = 0;
                            break;
                        case "DRAFT_UPDATED":
                        case 1:
                            message.state = 1;
                            break;
                        case "DRAFT_DELETED":
                        case 2:
                            message.state = 2;
                            break;
                        case "PUBLISHED":
                        case 3:
                            message.state = 3;
                            break;
                        }
                        if (object.includeStaffPosition != null)
                            message.includeStaffPosition = Boolean(object.includeStaffPosition);
                        if (object.includeStaff != null)
                            message.includeStaff = Boolean(object.includeStaff);
                        if (object.staffIds) {
                            if (!Array.isArray(object.staffIds))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftsRequest.staffIds: array expected");
                            message.staffIds = [];
                            for (var i = 0; i < object.staffIds.length; ++i)
                                if ($util.Long)
                                    (message.staffIds[i] = $util.Long.fromValue(object.staffIds[i])).unsigned = false;
                                else if (typeof object.staffIds[i] === "string")
                                    message.staffIds[i] = parseInt(object.staffIds[i], 10);
                                else if (typeof object.staffIds[i] === "number")
                                    message.staffIds[i] = object.staffIds[i];
                                else if (typeof object.staffIds[i] === "object")
                                    message.staffIds[i] = new $util.LongBits(object.staffIds[i].low >>> 0, object.staffIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftsRequest} message ListStaffShiftsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.state = options.enums === String ? "DRAFT_CREATED" : 0;
                            object.includeStaffPosition = false;
                            object.includeStaff = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StaffScheduleState[message.state] : message.state;
                        if (message.includeStaffPosition != null && message.hasOwnProperty("includeStaffPosition"))
                            object.includeStaffPosition = message.includeStaffPosition;
                        if (message.includeStaff != null && message.hasOwnProperty("includeStaff"))
                            object.includeStaff = message.includeStaff;
                        if (message.staffIds && message.staffIds.length) {
                            object.staffIds = [];
                            for (var j = 0; j < message.staffIds.length; ++j)
                                if (typeof message.staffIds[j] === "number")
                                    object.staffIds[j] = options.longs === String ? String(message.staffIds[j]) : message.staffIds[j];
                                else
                                    object.staffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffIds[j]) : options.longs === Number ? new $util.LongBits(message.staffIds[j].low >>> 0, message.staffIds[j].high >>> 0).toNumber() : message.staffIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftsRequest;
                })();
    
                v1.ListStaffShiftsResponse = (function() {
    
                    /**
                     * Properties of a ListStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftsResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] ListStaffShiftsResponse staffShifts
                     */
    
                    /**
                     * Constructs a new ListStaffShiftsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftsResponse.
                     * @implements IListStaffShiftsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftsResponse=} [properties] Properties to set
                     */
                    function ListStaffShiftsResponse(properties) {
                        this.staffShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftsResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @instance
                     */
                    ListStaffShiftsResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * Creates a new ListStaffShiftsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftsResponse} ListStaffShiftsResponse instance
                     */
                    ListStaffShiftsResponse.create = function create(properties) {
                        return new ListStaffShiftsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsResponse} message ListStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftsResponse} message ListStaffShiftsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftsResponse} ListStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftsResponse} ListStaffShiftsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftsResponse} ListStaffShiftsResponse
                     */
                    ListStaffShiftsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftsResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftsResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffShiftsResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftsResponse} message ListStaffShiftsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShifts = [];
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftsResponse;
                })();
    
                v1.CreateStaffScheduleGeneralSettingRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffScheduleGeneralSettingRequest
                     * @property {palexy.streaming.v1.IStaffScheduleGeneralSetting|null} [staffScheduleGeneralSetting] CreateStaffScheduleGeneralSettingRequest staffScheduleGeneralSetting
                     */
    
                    /**
                     * Constructs a new CreateStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffScheduleGeneralSettingRequest.
                     * @implements ICreateStaffScheduleGeneralSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     */
                    function CreateStaffScheduleGeneralSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffScheduleGeneralSettingRequest staffScheduleGeneralSetting.
                     * @member {palexy.streaming.v1.IStaffScheduleGeneralSetting|null|undefined} staffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    CreateStaffScheduleGeneralSettingRequest.prototype.staffScheduleGeneralSetting = null;
    
                    /**
                     * Creates a new CreateStaffScheduleGeneralSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest} CreateStaffScheduleGeneralSettingRequest instance
                     */
                    CreateStaffScheduleGeneralSettingRequest.create = function create(properties) {
                        return new CreateStaffScheduleGeneralSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffScheduleGeneralSettingRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest} message CreateStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffScheduleGeneralSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffScheduleGeneralSetting != null && Object.hasOwnProperty.call(message, "staffScheduleGeneralSetting"))
                            $root.palexy.streaming.v1.StaffScheduleGeneralSetting.encode(message.staffScheduleGeneralSetting, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffScheduleGeneralSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffScheduleGeneralSettingRequest} message CreateStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffScheduleGeneralSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffScheduleGeneralSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest} CreateStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffScheduleGeneralSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffScheduleGeneralSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest} CreateStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffScheduleGeneralSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffScheduleGeneralSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffScheduleGeneralSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffScheduleGeneralSetting != null && message.hasOwnProperty("staffScheduleGeneralSetting")) {
                            var error = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.verify(message.staffScheduleGeneralSetting);
                            if (error)
                                return "staffScheduleGeneralSetting." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffScheduleGeneralSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest} CreateStaffScheduleGeneralSettingRequest
                     */
                    CreateStaffScheduleGeneralSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest();
                        if (object.staffScheduleGeneralSetting != null) {
                            if (typeof object.staffScheduleGeneralSetting !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest.staffScheduleGeneralSetting: object expected");
                            message.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.fromObject(object.staffScheduleGeneralSetting);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffScheduleGeneralSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest} message CreateStaffScheduleGeneralSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffScheduleGeneralSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffScheduleGeneralSetting = null;
                        if (message.staffScheduleGeneralSetting != null && message.hasOwnProperty("staffScheduleGeneralSetting"))
                            object.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.toObject(message.staffScheduleGeneralSetting, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffScheduleGeneralSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffScheduleGeneralSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffScheduleGeneralSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffScheduleGeneralSettingRequest;
                })();
    
                v1.UpdateStaffScheduleGeneralSettingRequest = (function() {
    
                    /**
                     * Properties of an UpdateStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStaffScheduleGeneralSettingRequest
                     * @property {palexy.streaming.v1.IStaffScheduleGeneralSetting|null} [staffScheduleGeneralSetting] UpdateStaffScheduleGeneralSettingRequest staffScheduleGeneralSetting
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStaffScheduleGeneralSettingRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStaffScheduleGeneralSettingRequest.
                     * @implements IUpdateStaffScheduleGeneralSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     */
                    function UpdateStaffScheduleGeneralSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStaffScheduleGeneralSettingRequest staffScheduleGeneralSetting.
                     * @member {palexy.streaming.v1.IStaffScheduleGeneralSetting|null|undefined} staffScheduleGeneralSetting
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    UpdateStaffScheduleGeneralSettingRequest.prototype.staffScheduleGeneralSetting = null;
    
                    /**
                     * UpdateStaffScheduleGeneralSettingRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    UpdateStaffScheduleGeneralSettingRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStaffScheduleGeneralSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest} UpdateStaffScheduleGeneralSettingRequest instance
                     */
                    UpdateStaffScheduleGeneralSettingRequest.create = function create(properties) {
                        return new UpdateStaffScheduleGeneralSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStaffScheduleGeneralSettingRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest} message UpdateStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffScheduleGeneralSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffScheduleGeneralSetting != null && Object.hasOwnProperty.call(message, "staffScheduleGeneralSetting"))
                            $root.palexy.streaming.v1.StaffScheduleGeneralSetting.encode(message.staffScheduleGeneralSetting, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStaffScheduleGeneralSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStaffScheduleGeneralSettingRequest} message UpdateStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStaffScheduleGeneralSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStaffScheduleGeneralSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest} UpdateStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffScheduleGeneralSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStaffScheduleGeneralSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest} UpdateStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStaffScheduleGeneralSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStaffScheduleGeneralSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStaffScheduleGeneralSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffScheduleGeneralSetting != null && message.hasOwnProperty("staffScheduleGeneralSetting")) {
                            var error = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.verify(message.staffScheduleGeneralSetting);
                            if (error)
                                return "staffScheduleGeneralSetting." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStaffScheduleGeneralSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest} UpdateStaffScheduleGeneralSettingRequest
                     */
                    UpdateStaffScheduleGeneralSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest();
                        if (object.staffScheduleGeneralSetting != null) {
                            if (typeof object.staffScheduleGeneralSetting !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest.staffScheduleGeneralSetting: object expected");
                            message.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.fromObject(object.staffScheduleGeneralSetting);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStaffScheduleGeneralSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest} message UpdateStaffScheduleGeneralSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStaffScheduleGeneralSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.staffScheduleGeneralSetting = null;
                            object.updateMask = null;
                        }
                        if (message.staffScheduleGeneralSetting != null && message.hasOwnProperty("staffScheduleGeneralSetting"))
                            object.staffScheduleGeneralSetting = $root.palexy.streaming.v1.StaffScheduleGeneralSetting.toObject(message.staffScheduleGeneralSetting, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStaffScheduleGeneralSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStaffScheduleGeneralSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStaffScheduleGeneralSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStaffScheduleGeneralSettingRequest;
                })();
    
                v1.DeleteStaffScheduleGeneralSettingRequest = (function() {
    
                    /**
                     * Properties of a DeleteStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStaffScheduleGeneralSettingRequest
                     * @property {number|null} [settingId] DeleteStaffScheduleGeneralSettingRequest settingId
                     */
    
                    /**
                     * Constructs a new DeleteStaffScheduleGeneralSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStaffScheduleGeneralSettingRequest.
                     * @implements IDeleteStaffScheduleGeneralSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     */
                    function DeleteStaffScheduleGeneralSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStaffScheduleGeneralSettingRequest settingId.
                     * @member {number} settingId
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @instance
                     */
                    DeleteStaffScheduleGeneralSettingRequest.prototype.settingId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStaffScheduleGeneralSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest} DeleteStaffScheduleGeneralSettingRequest instance
                     */
                    DeleteStaffScheduleGeneralSettingRequest.create = function create(properties) {
                        return new DeleteStaffScheduleGeneralSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStaffScheduleGeneralSettingRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest} message DeleteStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffScheduleGeneralSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.settingId != null && Object.hasOwnProperty.call(message, "settingId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.settingId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStaffScheduleGeneralSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStaffScheduleGeneralSettingRequest} message DeleteStaffScheduleGeneralSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStaffScheduleGeneralSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStaffScheduleGeneralSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest} DeleteStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffScheduleGeneralSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.settingId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStaffScheduleGeneralSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest} DeleteStaffScheduleGeneralSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStaffScheduleGeneralSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStaffScheduleGeneralSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStaffScheduleGeneralSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.settingId != null && message.hasOwnProperty("settingId"))
                            if (!$util.isInteger(message.settingId) && !(message.settingId && $util.isInteger(message.settingId.low) && $util.isInteger(message.settingId.high)))
                                return "settingId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStaffScheduleGeneralSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest} DeleteStaffScheduleGeneralSettingRequest
                     */
                    DeleteStaffScheduleGeneralSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest();
                        if (object.settingId != null)
                            if ($util.Long)
                                (message.settingId = $util.Long.fromValue(object.settingId)).unsigned = false;
                            else if (typeof object.settingId === "string")
                                message.settingId = parseInt(object.settingId, 10);
                            else if (typeof object.settingId === "number")
                                message.settingId = object.settingId;
                            else if (typeof object.settingId === "object")
                                message.settingId = new $util.LongBits(object.settingId.low >>> 0, object.settingId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStaffScheduleGeneralSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest} message DeleteStaffScheduleGeneralSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStaffScheduleGeneralSettingRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.settingId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.settingId = options.longs === String ? "0" : 0;
                        if (message.settingId != null && message.hasOwnProperty("settingId"))
                            if (typeof message.settingId === "number")
                                object.settingId = options.longs === String ? String(message.settingId) : message.settingId;
                            else
                                object.settingId = options.longs === String ? $util.Long.prototype.toString.call(message.settingId) : options.longs === Number ? new $util.LongBits(message.settingId.low >>> 0, message.settingId.high >>> 0).toNumber() : message.settingId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStaffScheduleGeneralSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStaffScheduleGeneralSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStaffScheduleGeneralSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStaffScheduleGeneralSettingRequest;
                })();
    
                v1.ListCompanyEnableAvailabilityReminderSettingRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableAvailabilityReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableAvailabilityReminderSettingRequest
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableAvailabilityReminderSettingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableAvailabilityReminderSettingRequest.
                     * @implements IListCompanyEnableAvailabilityReminderSettingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest=} [properties] Properties to set
                     */
                    function ListCompanyEnableAvailabilityReminderSettingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ListCompanyEnableAvailabilityReminderSettingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest} ListCompanyEnableAvailabilityReminderSettingRequest instance
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.create = function create(properties) {
                        return new ListCompanyEnableAvailabilityReminderSettingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableAvailabilityReminderSettingRequest message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest} message ListCompanyEnableAvailabilityReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableAvailabilityReminderSettingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingRequest} message ListCompanyEnableAvailabilityReminderSettingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableAvailabilityReminderSettingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest} ListCompanyEnableAvailabilityReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableAvailabilityReminderSettingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest} ListCompanyEnableAvailabilityReminderSettingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableAvailabilityReminderSettingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableAvailabilityReminderSettingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest} ListCompanyEnableAvailabilityReminderSettingRequest
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest)
                            return object;
                        return new $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest();
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableAvailabilityReminderSettingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest} message ListCompanyEnableAvailabilityReminderSettingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ListCompanyEnableAvailabilityReminderSettingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableAvailabilityReminderSettingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableAvailabilityReminderSettingRequest;
                })();
    
                v1.ListCompanyEnableAvailabilityReminderSettingResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyEnableAvailabilityReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListCompanyEnableAvailabilityReminderSettingResponse
                     * @property {Array.<palexy.streaming.v1.IAvailabilityReminderSetting>|null} [availabilityReminderSettings] ListCompanyEnableAvailabilityReminderSettingResponse availabilityReminderSettings
                     */
    
                    /**
                     * Constructs a new ListCompanyEnableAvailabilityReminderSettingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListCompanyEnableAvailabilityReminderSettingResponse.
                     * @implements IListCompanyEnableAvailabilityReminderSettingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingResponse=} [properties] Properties to set
                     */
                    function ListCompanyEnableAvailabilityReminderSettingResponse(properties) {
                        this.availabilityReminderSettings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyEnableAvailabilityReminderSettingResponse availabilityReminderSettings.
                     * @member {Array.<palexy.streaming.v1.IAvailabilityReminderSetting>} availabilityReminderSettings
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @instance
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.prototype.availabilityReminderSettings = $util.emptyArray;
    
                    /**
                     * Creates a new ListCompanyEnableAvailabilityReminderSettingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} ListCompanyEnableAvailabilityReminderSettingResponse instance
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.create = function create(properties) {
                        return new ListCompanyEnableAvailabilityReminderSettingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableAvailabilityReminderSettingResponse message. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingResponse} message ListCompanyEnableAvailabilityReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.availabilityReminderSettings != null && message.availabilityReminderSettings.length)
                            for (var i = 0; i < message.availabilityReminderSettings.length; ++i)
                                $root.palexy.streaming.v1.AvailabilityReminderSetting.encode(message.availabilityReminderSettings[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyEnableAvailabilityReminderSettingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.IListCompanyEnableAvailabilityReminderSettingResponse} message ListCompanyEnableAvailabilityReminderSettingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyEnableAvailabilityReminderSettingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} ListCompanyEnableAvailabilityReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.availabilityReminderSettings && message.availabilityReminderSettings.length))
                                    message.availabilityReminderSettings = [];
                                message.availabilityReminderSettings.push($root.palexy.streaming.v1.AvailabilityReminderSetting.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyEnableAvailabilityReminderSettingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} ListCompanyEnableAvailabilityReminderSettingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyEnableAvailabilityReminderSettingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.availabilityReminderSettings != null && message.hasOwnProperty("availabilityReminderSettings")) {
                            if (!Array.isArray(message.availabilityReminderSettings))
                                return "availabilityReminderSettings: array expected";
                            for (var i = 0; i < message.availabilityReminderSettings.length; ++i) {
                                var error = $root.palexy.streaming.v1.AvailabilityReminderSetting.verify(message.availabilityReminderSettings[i]);
                                if (error)
                                    return "availabilityReminderSettings." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyEnableAvailabilityReminderSettingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} ListCompanyEnableAvailabilityReminderSettingResponse
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse();
                        if (object.availabilityReminderSettings) {
                            if (!Array.isArray(object.availabilityReminderSettings))
                                throw TypeError(".palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse.availabilityReminderSettings: array expected");
                            message.availabilityReminderSettings = [];
                            for (var i = 0; i < object.availabilityReminderSettings.length; ++i) {
                                if (typeof object.availabilityReminderSettings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse.availabilityReminderSettings: object expected");
                                message.availabilityReminderSettings[i] = $root.palexy.streaming.v1.AvailabilityReminderSetting.fromObject(object.availabilityReminderSettings[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyEnableAvailabilityReminderSettingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @static
                     * @param {palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse} message ListCompanyEnableAvailabilityReminderSettingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.availabilityReminderSettings = [];
                        if (message.availabilityReminderSettings && message.availabilityReminderSettings.length) {
                            object.availabilityReminderSettings = [];
                            for (var j = 0; j < message.availabilityReminderSettings.length; ++j)
                                object.availabilityReminderSettings[j] = $root.palexy.streaming.v1.AvailabilityReminderSetting.toObject(message.availabilityReminderSettings[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyEnableAvailabilityReminderSettingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListCompanyEnableAvailabilityReminderSettingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyEnableAvailabilityReminderSettingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyEnableAvailabilityReminderSettingResponse;
                })();
    
                v1.AvailabilityReminderSetting = (function() {
    
                    /**
                     * Properties of an AvailabilityReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @interface IAvailabilityReminderSetting
                     * @property {number|null} [companyId] AvailabilityReminderSetting companyId
                     * @property {string|null} [time] AvailabilityReminderSetting time
                     * @property {string|null} [companyDefaultTimezone] AvailabilityReminderSetting companyDefaultTimezone
                     * @property {number|null} [matchingGroupId] AvailabilityReminderSetting matchingGroupId
                     * @property {Array.<palexy.streaming.v1.DayOfWeek>|null} [weekdays] AvailabilityReminderSetting weekdays
                     */
    
                    /**
                     * Constructs a new AvailabilityReminderSetting.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AvailabilityReminderSetting.
                     * @implements IAvailabilityReminderSetting
                     * @constructor
                     * @param {palexy.streaming.v1.IAvailabilityReminderSetting=} [properties] Properties to set
                     */
                    function AvailabilityReminderSetting(properties) {
                        this.weekdays = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AvailabilityReminderSetting companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     */
                    AvailabilityReminderSetting.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AvailabilityReminderSetting time.
                     * @member {string} time
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     */
                    AvailabilityReminderSetting.prototype.time = "";
    
                    /**
                     * AvailabilityReminderSetting companyDefaultTimezone.
                     * @member {string} companyDefaultTimezone
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     */
                    AvailabilityReminderSetting.prototype.companyDefaultTimezone = "";
    
                    /**
                     * AvailabilityReminderSetting matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     */
                    AvailabilityReminderSetting.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AvailabilityReminderSetting weekdays.
                     * @member {Array.<palexy.streaming.v1.DayOfWeek>} weekdays
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     */
                    AvailabilityReminderSetting.prototype.weekdays = $util.emptyArray;
    
                    /**
                     * Creates a new AvailabilityReminderSetting instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IAvailabilityReminderSetting=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AvailabilityReminderSetting} AvailabilityReminderSetting instance
                     */
                    AvailabilityReminderSetting.create = function create(properties) {
                        return new AvailabilityReminderSetting(properties);
                    };
    
                    /**
                     * Encodes the specified AvailabilityReminderSetting message. Does not implicitly {@link palexy.streaming.v1.AvailabilityReminderSetting.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IAvailabilityReminderSetting} message AvailabilityReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AvailabilityReminderSetting.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.time != null && Object.hasOwnProperty.call(message, "time"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.time);
                        if (message.companyDefaultTimezone != null && Object.hasOwnProperty.call(message, "companyDefaultTimezone"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.companyDefaultTimezone);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.matchingGroupId);
                        if (message.weekdays != null && message.weekdays.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.weekdays.length; ++i)
                                writer.int32(message.weekdays[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AvailabilityReminderSetting message, length delimited. Does not implicitly {@link palexy.streaming.v1.AvailabilityReminderSetting.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.IAvailabilityReminderSetting} message AvailabilityReminderSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AvailabilityReminderSetting.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AvailabilityReminderSetting message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AvailabilityReminderSetting} AvailabilityReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AvailabilityReminderSetting.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AvailabilityReminderSetting();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.time = reader.string();
                                break;
                            case 4:
                                message.companyDefaultTimezone = reader.string();
                                break;
                            case 5:
                                message.matchingGroupId = reader.int64();
                                break;
                            case 6:
                                if (!(message.weekdays && message.weekdays.length))
                                    message.weekdays = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.weekdays.push(reader.int32());
                                } else
                                    message.weekdays.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AvailabilityReminderSetting message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AvailabilityReminderSetting} AvailabilityReminderSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AvailabilityReminderSetting.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AvailabilityReminderSetting message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AvailabilityReminderSetting.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.time != null && message.hasOwnProperty("time"))
                            if (!$util.isString(message.time))
                                return "time: string expected";
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            if (!$util.isString(message.companyDefaultTimezone))
                                return "companyDefaultTimezone: string expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        if (message.weekdays != null && message.hasOwnProperty("weekdays")) {
                            if (!Array.isArray(message.weekdays))
                                return "weekdays: array expected";
                            for (var i = 0; i < message.weekdays.length; ++i)
                                switch (message.weekdays[i]) {
                                default:
                                    return "weekdays: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AvailabilityReminderSetting message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AvailabilityReminderSetting} AvailabilityReminderSetting
                     */
                    AvailabilityReminderSetting.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AvailabilityReminderSetting)
                            return object;
                        var message = new $root.palexy.streaming.v1.AvailabilityReminderSetting();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.time != null)
                            message.time = String(object.time);
                        if (object.companyDefaultTimezone != null)
                            message.companyDefaultTimezone = String(object.companyDefaultTimezone);
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        if (object.weekdays) {
                            if (!Array.isArray(object.weekdays))
                                throw TypeError(".palexy.streaming.v1.AvailabilityReminderSetting.weekdays: array expected");
                            message.weekdays = [];
                            for (var i = 0; i < object.weekdays.length; ++i)
                                switch (object.weekdays[i]) {
                                default:
                                case "DAY_OF_WEEK_UNSPECIFIED":
                                case 0:
                                    message.weekdays[i] = 0;
                                    break;
                                case "MONDAY":
                                case 1:
                                    message.weekdays[i] = 1;
                                    break;
                                case "TUESDAY":
                                case 2:
                                    message.weekdays[i] = 2;
                                    break;
                                case "WEDNESDAY":
                                case 3:
                                    message.weekdays[i] = 3;
                                    break;
                                case "THURSDAY":
                                case 4:
                                    message.weekdays[i] = 4;
                                    break;
                                case "FRIDAY":
                                case 5:
                                    message.weekdays[i] = 5;
                                    break;
                                case "SATURDAY":
                                case 6:
                                    message.weekdays[i] = 6;
                                    break;
                                case "SUNDAY":
                                case 7:
                                    message.weekdays[i] = 7;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AvailabilityReminderSetting message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @static
                     * @param {palexy.streaming.v1.AvailabilityReminderSetting} message AvailabilityReminderSetting
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AvailabilityReminderSetting.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.weekdays = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.time = "";
                            object.companyDefaultTimezone = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.time != null && message.hasOwnProperty("time"))
                            object.time = message.time;
                        if (message.companyDefaultTimezone != null && message.hasOwnProperty("companyDefaultTimezone"))
                            object.companyDefaultTimezone = message.companyDefaultTimezone;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        if (message.weekdays && message.weekdays.length) {
                            object.weekdays = [];
                            for (var j = 0; j < message.weekdays.length; ++j)
                                object.weekdays[j] = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.weekdays[j]] : message.weekdays[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AvailabilityReminderSetting to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AvailabilityReminderSetting
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AvailabilityReminderSetting.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AvailabilityReminderSetting;
                })();
    
                v1.CompanyAvailabilityReminderTarget = (function() {
    
                    /**
                     * Properties of a CompanyAvailabilityReminderTarget.
                     * @memberof palexy.streaming.v1
                     * @interface ICompanyAvailabilityReminderTarget
                     * @property {number|null} [companyId] CompanyAvailabilityReminderTarget companyId
                     * @property {number|null} [matchingGroupId] CompanyAvailabilityReminderTarget matchingGroupId
                     */
    
                    /**
                     * Constructs a new CompanyAvailabilityReminderTarget.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CompanyAvailabilityReminderTarget.
                     * @implements ICompanyAvailabilityReminderTarget
                     * @constructor
                     * @param {palexy.streaming.v1.ICompanyAvailabilityReminderTarget=} [properties] Properties to set
                     */
                    function CompanyAvailabilityReminderTarget(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyAvailabilityReminderTarget companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @instance
                     */
                    CompanyAvailabilityReminderTarget.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyAvailabilityReminderTarget matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @instance
                     */
                    CompanyAvailabilityReminderTarget.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CompanyAvailabilityReminderTarget instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {palexy.streaming.v1.ICompanyAvailabilityReminderTarget=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CompanyAvailabilityReminderTarget} CompanyAvailabilityReminderTarget instance
                     */
                    CompanyAvailabilityReminderTarget.create = function create(properties) {
                        return new CompanyAvailabilityReminderTarget(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyAvailabilityReminderTarget message. Does not implicitly {@link palexy.streaming.v1.CompanyAvailabilityReminderTarget.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {palexy.streaming.v1.ICompanyAvailabilityReminderTarget} message CompanyAvailabilityReminderTarget message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyAvailabilityReminderTarget.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.matchingGroupId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyAvailabilityReminderTarget message, length delimited. Does not implicitly {@link palexy.streaming.v1.CompanyAvailabilityReminderTarget.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {palexy.streaming.v1.ICompanyAvailabilityReminderTarget} message CompanyAvailabilityReminderTarget message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyAvailabilityReminderTarget.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyAvailabilityReminderTarget message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CompanyAvailabilityReminderTarget} CompanyAvailabilityReminderTarget
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyAvailabilityReminderTarget.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.matchingGroupId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyAvailabilityReminderTarget message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CompanyAvailabilityReminderTarget} CompanyAvailabilityReminderTarget
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyAvailabilityReminderTarget.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyAvailabilityReminderTarget message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyAvailabilityReminderTarget.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyAvailabilityReminderTarget message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CompanyAvailabilityReminderTarget} CompanyAvailabilityReminderTarget
                     */
                    CompanyAvailabilityReminderTarget.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget)
                            return object;
                        var message = new $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyAvailabilityReminderTarget message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @static
                     * @param {palexy.streaming.v1.CompanyAvailabilityReminderTarget} message CompanyAvailabilityReminderTarget
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyAvailabilityReminderTarget.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyAvailabilityReminderTarget to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CompanyAvailabilityReminderTarget
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyAvailabilityReminderTarget.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyAvailabilityReminderTarget;
                })();
    
                v1.TriggerAvailabilityReminderNotificationsRequest = (function() {
    
                    /**
                     * Properties of a TriggerAvailabilityReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ITriggerAvailabilityReminderNotificationsRequest
                     * @property {Array.<palexy.streaming.v1.ICompanyAvailabilityReminderTarget>|null} [targets] TriggerAvailabilityReminderNotificationsRequest targets
                     */
    
                    /**
                     * Constructs a new TriggerAvailabilityReminderNotificationsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TriggerAvailabilityReminderNotificationsRequest.
                     * @implements ITriggerAvailabilityReminderNotificationsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest=} [properties] Properties to set
                     */
                    function TriggerAvailabilityReminderNotificationsRequest(properties) {
                        this.targets = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TriggerAvailabilityReminderNotificationsRequest targets.
                     * @member {Array.<palexy.streaming.v1.ICompanyAvailabilityReminderTarget>} targets
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @instance
                     */
                    TriggerAvailabilityReminderNotificationsRequest.prototype.targets = $util.emptyArray;
    
                    /**
                     * Creates a new TriggerAvailabilityReminderNotificationsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest} TriggerAvailabilityReminderNotificationsRequest instance
                     */
                    TriggerAvailabilityReminderNotificationsRequest.create = function create(properties) {
                        return new TriggerAvailabilityReminderNotificationsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TriggerAvailabilityReminderNotificationsRequest message. Does not implicitly {@link palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest} message TriggerAvailabilityReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerAvailabilityReminderNotificationsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.targets != null && message.targets.length)
                            for (var i = 0; i < message.targets.length; ++i)
                                $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget.encode(message.targets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TriggerAvailabilityReminderNotificationsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.ITriggerAvailabilityReminderNotificationsRequest} message TriggerAvailabilityReminderNotificationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TriggerAvailabilityReminderNotificationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TriggerAvailabilityReminderNotificationsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest} TriggerAvailabilityReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerAvailabilityReminderNotificationsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.targets && message.targets.length))
                                    message.targets = [];
                                message.targets.push($root.palexy.streaming.v1.CompanyAvailabilityReminderTarget.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TriggerAvailabilityReminderNotificationsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest} TriggerAvailabilityReminderNotificationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TriggerAvailabilityReminderNotificationsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TriggerAvailabilityReminderNotificationsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TriggerAvailabilityReminderNotificationsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.targets != null && message.hasOwnProperty("targets")) {
                            if (!Array.isArray(message.targets))
                                return "targets: array expected";
                            for (var i = 0; i < message.targets.length; ++i) {
                                var error = $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget.verify(message.targets[i]);
                                if (error)
                                    return "targets." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TriggerAvailabilityReminderNotificationsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest} TriggerAvailabilityReminderNotificationsRequest
                     */
                    TriggerAvailabilityReminderNotificationsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest();
                        if (object.targets) {
                            if (!Array.isArray(object.targets))
                                throw TypeError(".palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest.targets: array expected");
                            message.targets = [];
                            for (var i = 0; i < object.targets.length; ++i) {
                                if (typeof object.targets[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest.targets: object expected");
                                message.targets[i] = $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget.fromObject(object.targets[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TriggerAvailabilityReminderNotificationsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @static
                     * @param {palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest} message TriggerAvailabilityReminderNotificationsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TriggerAvailabilityReminderNotificationsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.targets = [];
                        if (message.targets && message.targets.length) {
                            object.targets = [];
                            for (var j = 0; j < message.targets.length; ++j)
                                object.targets[j] = $root.palexy.streaming.v1.CompanyAvailabilityReminderTarget.toObject(message.targets[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TriggerAvailabilityReminderNotificationsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TriggerAvailabilityReminderNotificationsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TriggerAvailabilityReminderNotificationsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TriggerAvailabilityReminderNotificationsRequest;
                })();
    
                v1.GetStaffScheduleRequest = (function() {
    
                    /**
                     * Properties of a GetStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffScheduleRequest
                     * @property {number|null} [startDateId] GetStaffScheduleRequest startDateId
                     * @property {number|null} [endDateId] GetStaffScheduleRequest endDateId
                     * @property {number|null} [storeId] GetStaffScheduleRequest storeId
                     * @property {palexy.streaming.v1.IIdList|null} [staffIds] GetStaffScheduleRequest staffIds
                     * @property {boolean|null} [includeStoreInformation] GetStaffScheduleRequest includeStoreInformation
                     * @property {boolean|null} [includeOriginalShift] GetStaffScheduleRequest includeOriginalShift
                     * @property {boolean|null} [includeStoreRequestInfo] GetStaffScheduleRequest includeStoreRequestInfo
                     */
    
                    /**
                     * Constructs a new GetStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffScheduleRequest.
                     * @implements IGetStaffScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest=} [properties] Properties to set
                     */
                    function GetStaffScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffScheduleRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.startDateId = 0;
    
                    /**
                     * GetStaffScheduleRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.endDateId = 0;
    
                    /**
                     * GetStaffScheduleRequest storeId.
                     * @member {number|null|undefined} storeId
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.storeId = null;
    
                    /**
                     * GetStaffScheduleRequest staffIds.
                     * @member {palexy.streaming.v1.IIdList|null|undefined} staffIds
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.staffIds = null;
    
                    /**
                     * GetStaffScheduleRequest includeStoreInformation.
                     * @member {boolean} includeStoreInformation
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.includeStoreInformation = false;
    
                    /**
                     * GetStaffScheduleRequest includeOriginalShift.
                     * @member {boolean} includeOriginalShift
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.includeOriginalShift = false;
    
                    /**
                     * GetStaffScheduleRequest includeStoreRequestInfo.
                     * @member {boolean} includeStoreRequestInfo
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    GetStaffScheduleRequest.prototype.includeStoreRequestInfo = false;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * GetStaffScheduleRequest filterOption.
                     * @member {"storeId"|"staffIds"|undefined} filterOption
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     */
                    Object.defineProperty(GetStaffScheduleRequest.prototype, "filterOption", {
                        get: $util.oneOfGetter($oneOfFields = ["storeId", "staffIds"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new GetStaffScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffScheduleRequest} GetStaffScheduleRequest instance
                     */
                    GetStaffScheduleRequest.create = function create(properties) {
                        return new GetStaffScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest} message GetStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.staffIds != null && Object.hasOwnProperty.call(message, "staffIds"))
                            $root.palexy.streaming.v1.IdList.encode(message.staffIds, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.includeStoreInformation != null && Object.hasOwnProperty.call(message, "includeStoreInformation"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeStoreInformation);
                        if (message.includeOriginalShift != null && Object.hasOwnProperty.call(message, "includeOriginalShift"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeOriginalShift);
                        if (message.includeStoreRequestInfo != null && Object.hasOwnProperty.call(message, "includeStoreRequestInfo"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeStoreRequestInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleRequest} message GetStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffScheduleRequest} GetStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateId = reader.int32();
                                break;
                            case 2:
                                message.endDateId = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.staffIds = $root.palexy.streaming.v1.IdList.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.includeStoreInformation = reader.bool();
                                break;
                            case 6:
                                message.includeOriginalShift = reader.bool();
                                break;
                            case 7:
                                message.includeStoreRequestInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffScheduleRequest} GetStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            properties.filterOption = 1;
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        }
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (properties.filterOption === 1)
                                return "filterOption: multiple values";
                            properties.filterOption = 1;
                            {
                                var error = $root.palexy.streaming.v1.IdList.verify(message.staffIds);
                                if (error)
                                    return "staffIds." + error;
                            }
                        }
                        if (message.includeStoreInformation != null && message.hasOwnProperty("includeStoreInformation"))
                            if (typeof message.includeStoreInformation !== "boolean")
                                return "includeStoreInformation: boolean expected";
                        if (message.includeOriginalShift != null && message.hasOwnProperty("includeOriginalShift"))
                            if (typeof message.includeOriginalShift !== "boolean")
                                return "includeOriginalShift: boolean expected";
                        if (message.includeStoreRequestInfo != null && message.hasOwnProperty("includeStoreRequestInfo"))
                            if (typeof message.includeStoreRequestInfo !== "boolean")
                                return "includeStoreRequestInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffScheduleRequest} GetStaffScheduleRequest
                     */
                    GetStaffScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffScheduleRequest();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffIds != null) {
                            if (typeof object.staffIds !== "object")
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleRequest.staffIds: object expected");
                            message.staffIds = $root.palexy.streaming.v1.IdList.fromObject(object.staffIds);
                        }
                        if (object.includeStoreInformation != null)
                            message.includeStoreInformation = Boolean(object.includeStoreInformation);
                        if (object.includeOriginalShift != null)
                            message.includeOriginalShift = Boolean(object.includeOriginalShift);
                        if (object.includeStoreRequestInfo != null)
                            message.includeStoreRequestInfo = Boolean(object.includeStoreRequestInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffScheduleRequest} message GetStaffScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.includeStoreInformation = false;
                            object.includeOriginalShift = false;
                            object.includeStoreRequestInfo = false;
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId")) {
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            if (options.oneofs)
                                object.filterOption = "storeId";
                        }
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            object.staffIds = $root.palexy.streaming.v1.IdList.toObject(message.staffIds, options);
                            if (options.oneofs)
                                object.filterOption = "staffIds";
                        }
                        if (message.includeStoreInformation != null && message.hasOwnProperty("includeStoreInformation"))
                            object.includeStoreInformation = message.includeStoreInformation;
                        if (message.includeOriginalShift != null && message.hasOwnProperty("includeOriginalShift"))
                            object.includeOriginalShift = message.includeOriginalShift;
                        if (message.includeStoreRequestInfo != null && message.hasOwnProperty("includeStoreRequestInfo"))
                            object.includeStoreRequestInfo = message.includeStoreRequestInfo;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffScheduleRequest;
                })();
    
                v1.GetStaffScheduleResponse = (function() {
    
                    /**
                     * Properties of a GetStaffScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffScheduleResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] GetStaffScheduleResponse staffShifts
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [staffTimeOffs] GetStaffScheduleResponse staffTimeOffs
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [draftShiftsOutsideScope] GetStaffScheduleResponse draftShiftsOutsideScope
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [draftTimeOffsOutsideScope] GetStaffScheduleResponse draftTimeOffsOutsideScope
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [originalShiftsOutsideScope] GetStaffScheduleResponse originalShiftsOutsideScope
                     * @property {Array.<palexy.streaming.v1.IStaffTimeOff>|null} [originalTimeOffsOutsideScope] GetStaffScheduleResponse originalTimeOffsOutsideScope
                     */
    
                    /**
                     * Constructs a new GetStaffScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffScheduleResponse.
                     * @implements IGetStaffScheduleResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffScheduleResponse=} [properties] Properties to set
                     */
                    function GetStaffScheduleResponse(properties) {
                        this.staffShifts = [];
                        this.staffTimeOffs = [];
                        this.draftShiftsOutsideScope = [];
                        this.draftTimeOffsOutsideScope = [];
                        this.originalShiftsOutsideScope = [];
                        this.originalTimeOffsOutsideScope = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffScheduleResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * GetStaffScheduleResponse staffTimeOffs.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} staffTimeOffs
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.staffTimeOffs = $util.emptyArray;
    
                    /**
                     * GetStaffScheduleResponse draftShiftsOutsideScope.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} draftShiftsOutsideScope
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.draftShiftsOutsideScope = $util.emptyArray;
    
                    /**
                     * GetStaffScheduleResponse draftTimeOffsOutsideScope.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} draftTimeOffsOutsideScope
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.draftTimeOffsOutsideScope = $util.emptyArray;
    
                    /**
                     * GetStaffScheduleResponse originalShiftsOutsideScope.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} originalShiftsOutsideScope
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.originalShiftsOutsideScope = $util.emptyArray;
    
                    /**
                     * GetStaffScheduleResponse originalTimeOffsOutsideScope.
                     * @member {Array.<palexy.streaming.v1.IStaffTimeOff>} originalTimeOffsOutsideScope
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     */
                    GetStaffScheduleResponse.prototype.originalTimeOffsOutsideScope = $util.emptyArray;
    
                    /**
                     * Creates a new GetStaffScheduleResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffScheduleResponse} GetStaffScheduleResponse instance
                     */
                    GetStaffScheduleResponse.create = function create(properties) {
                        return new GetStaffScheduleResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleResponse message. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleResponse} message GetStaffScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.staffTimeOffs != null && message.staffTimeOffs.length)
                            for (var i = 0; i < message.staffTimeOffs.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.staffTimeOffs[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.draftShiftsOutsideScope != null && message.draftShiftsOutsideScope.length)
                            for (var i = 0; i < message.draftShiftsOutsideScope.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.draftShiftsOutsideScope[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.draftTimeOffsOutsideScope != null && message.draftTimeOffsOutsideScope.length)
                            for (var i = 0; i < message.draftTimeOffsOutsideScope.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.draftTimeOffsOutsideScope[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.originalShiftsOutsideScope != null && message.originalShiftsOutsideScope.length)
                            for (var i = 0; i < message.originalShiftsOutsideScope.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.originalShiftsOutsideScope[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.originalTimeOffsOutsideScope != null && message.originalTimeOffsOutsideScope.length)
                            for (var i = 0; i < message.originalTimeOffsOutsideScope.length; ++i)
                                $root.palexy.streaming.v1.StaffTimeOff.encode(message.originalTimeOffsOutsideScope[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffScheduleResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffScheduleResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffScheduleResponse} message GetStaffScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffScheduleResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffScheduleResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffScheduleResponse} GetStaffScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffScheduleResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.staffTimeOffs && message.staffTimeOffs.length))
                                    message.staffTimeOffs = [];
                                message.staffTimeOffs.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.draftShiftsOutsideScope && message.draftShiftsOutsideScope.length))
                                    message.draftShiftsOutsideScope = [];
                                message.draftShiftsOutsideScope.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                if (!(message.draftTimeOffsOutsideScope && message.draftTimeOffsOutsideScope.length))
                                    message.draftTimeOffsOutsideScope = [];
                                message.draftTimeOffsOutsideScope.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                if (!(message.originalShiftsOutsideScope && message.originalShiftsOutsideScope.length))
                                    message.originalShiftsOutsideScope = [];
                                message.originalShiftsOutsideScope.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                if (!(message.originalTimeOffsOutsideScope && message.originalTimeOffsOutsideScope.length))
                                    message.originalTimeOffsOutsideScope = [];
                                message.originalTimeOffsOutsideScope.push($root.palexy.streaming.v1.StaffTimeOff.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffScheduleResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffScheduleResponse} GetStaffScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffScheduleResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffScheduleResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffScheduleResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.staffTimeOffs != null && message.hasOwnProperty("staffTimeOffs")) {
                            if (!Array.isArray(message.staffTimeOffs))
                                return "staffTimeOffs: array expected";
                            for (var i = 0; i < message.staffTimeOffs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.staffTimeOffs[i]);
                                if (error)
                                    return "staffTimeOffs." + error;
                            }
                        }
                        if (message.draftShiftsOutsideScope != null && message.hasOwnProperty("draftShiftsOutsideScope")) {
                            if (!Array.isArray(message.draftShiftsOutsideScope))
                                return "draftShiftsOutsideScope: array expected";
                            for (var i = 0; i < message.draftShiftsOutsideScope.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.draftShiftsOutsideScope[i]);
                                if (error)
                                    return "draftShiftsOutsideScope." + error;
                            }
                        }
                        if (message.draftTimeOffsOutsideScope != null && message.hasOwnProperty("draftTimeOffsOutsideScope")) {
                            if (!Array.isArray(message.draftTimeOffsOutsideScope))
                                return "draftTimeOffsOutsideScope: array expected";
                            for (var i = 0; i < message.draftTimeOffsOutsideScope.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.draftTimeOffsOutsideScope[i]);
                                if (error)
                                    return "draftTimeOffsOutsideScope." + error;
                            }
                        }
                        if (message.originalShiftsOutsideScope != null && message.hasOwnProperty("originalShiftsOutsideScope")) {
                            if (!Array.isArray(message.originalShiftsOutsideScope))
                                return "originalShiftsOutsideScope: array expected";
                            for (var i = 0; i < message.originalShiftsOutsideScope.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.originalShiftsOutsideScope[i]);
                                if (error)
                                    return "originalShiftsOutsideScope." + error;
                            }
                        }
                        if (message.originalTimeOffsOutsideScope != null && message.hasOwnProperty("originalTimeOffsOutsideScope")) {
                            if (!Array.isArray(message.originalTimeOffsOutsideScope))
                                return "originalTimeOffsOutsideScope: array expected";
                            for (var i = 0; i < message.originalTimeOffsOutsideScope.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffTimeOff.verify(message.originalTimeOffsOutsideScope[i]);
                                if (error)
                                    return "originalTimeOffsOutsideScope." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffScheduleResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffScheduleResponse} GetStaffScheduleResponse
                     */
                    GetStaffScheduleResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffScheduleResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffScheduleResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.staffTimeOffs) {
                            if (!Array.isArray(object.staffTimeOffs))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.staffTimeOffs: array expected");
                            message.staffTimeOffs = [];
                            for (var i = 0; i < object.staffTimeOffs.length; ++i) {
                                if (typeof object.staffTimeOffs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.staffTimeOffs: object expected");
                                message.staffTimeOffs[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.staffTimeOffs[i]);
                            }
                        }
                        if (object.draftShiftsOutsideScope) {
                            if (!Array.isArray(object.draftShiftsOutsideScope))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.draftShiftsOutsideScope: array expected");
                            message.draftShiftsOutsideScope = [];
                            for (var i = 0; i < object.draftShiftsOutsideScope.length; ++i) {
                                if (typeof object.draftShiftsOutsideScope[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.draftShiftsOutsideScope: object expected");
                                message.draftShiftsOutsideScope[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.draftShiftsOutsideScope[i]);
                            }
                        }
                        if (object.draftTimeOffsOutsideScope) {
                            if (!Array.isArray(object.draftTimeOffsOutsideScope))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.draftTimeOffsOutsideScope: array expected");
                            message.draftTimeOffsOutsideScope = [];
                            for (var i = 0; i < object.draftTimeOffsOutsideScope.length; ++i) {
                                if (typeof object.draftTimeOffsOutsideScope[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.draftTimeOffsOutsideScope: object expected");
                                message.draftTimeOffsOutsideScope[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.draftTimeOffsOutsideScope[i]);
                            }
                        }
                        if (object.originalShiftsOutsideScope) {
                            if (!Array.isArray(object.originalShiftsOutsideScope))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.originalShiftsOutsideScope: array expected");
                            message.originalShiftsOutsideScope = [];
                            for (var i = 0; i < object.originalShiftsOutsideScope.length; ++i) {
                                if (typeof object.originalShiftsOutsideScope[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.originalShiftsOutsideScope: object expected");
                                message.originalShiftsOutsideScope[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.originalShiftsOutsideScope[i]);
                            }
                        }
                        if (object.originalTimeOffsOutsideScope) {
                            if (!Array.isArray(object.originalTimeOffsOutsideScope))
                                throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.originalTimeOffsOutsideScope: array expected");
                            message.originalTimeOffsOutsideScope = [];
                            for (var i = 0; i < object.originalTimeOffsOutsideScope.length; ++i) {
                                if (typeof object.originalTimeOffsOutsideScope[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStaffScheduleResponse.originalTimeOffsOutsideScope: object expected");
                                message.originalTimeOffsOutsideScope[i] = $root.palexy.streaming.v1.StaffTimeOff.fromObject(object.originalTimeOffsOutsideScope[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffScheduleResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.GetStaffScheduleResponse} message GetStaffScheduleResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffScheduleResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.staffShifts = [];
                            object.staffTimeOffs = [];
                            object.draftShiftsOutsideScope = [];
                            object.draftTimeOffsOutsideScope = [];
                            object.originalShiftsOutsideScope = [];
                            object.originalTimeOffsOutsideScope = [];
                        }
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.staffTimeOffs && message.staffTimeOffs.length) {
                            object.staffTimeOffs = [];
                            for (var j = 0; j < message.staffTimeOffs.length; ++j)
                                object.staffTimeOffs[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.staffTimeOffs[j], options);
                        }
                        if (message.draftShiftsOutsideScope && message.draftShiftsOutsideScope.length) {
                            object.draftShiftsOutsideScope = [];
                            for (var j = 0; j < message.draftShiftsOutsideScope.length; ++j)
                                object.draftShiftsOutsideScope[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.draftShiftsOutsideScope[j], options);
                        }
                        if (message.draftTimeOffsOutsideScope && message.draftTimeOffsOutsideScope.length) {
                            object.draftTimeOffsOutsideScope = [];
                            for (var j = 0; j < message.draftTimeOffsOutsideScope.length; ++j)
                                object.draftTimeOffsOutsideScope[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.draftTimeOffsOutsideScope[j], options);
                        }
                        if (message.originalShiftsOutsideScope && message.originalShiftsOutsideScope.length) {
                            object.originalShiftsOutsideScope = [];
                            for (var j = 0; j < message.originalShiftsOutsideScope.length; ++j)
                                object.originalShiftsOutsideScope[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.originalShiftsOutsideScope[j], options);
                        }
                        if (message.originalTimeOffsOutsideScope && message.originalTimeOffsOutsideScope.length) {
                            object.originalTimeOffsOutsideScope = [];
                            for (var j = 0; j < message.originalTimeOffsOutsideScope.length; ++j)
                                object.originalTimeOffsOutsideScope[j] = $root.palexy.streaming.v1.StaffTimeOff.toObject(message.originalTimeOffsOutsideScope[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffScheduleResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffScheduleResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffScheduleResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffScheduleResponse;
                })();
    
                v1.PublishStaffScheduleRequest = (function() {
    
                    /**
                     * Properties of a PublishStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IPublishStaffScheduleRequest
                     * @property {number|null} [startDateId] PublishStaffScheduleRequest startDateId
                     * @property {number|null} [endDateId] PublishStaffScheduleRequest endDateId
                     * @property {number|null} [storeId] PublishStaffScheduleRequest storeId
                     * @property {boolean|null} [doNotPublishOpenShifts] PublishStaffScheduleRequest doNotPublishOpenShifts
                     * @property {boolean|null} [autoFillTimeOff] PublishStaffScheduleRequest autoFillTimeOff
                     * @property {number|null} [minDateId] PublishStaffScheduleRequest minDateId
                     * @property {number|null} [creatorId] PublishStaffScheduleRequest creatorId
                     * @property {boolean|null} [disableApprovalRequest] PublishStaffScheduleRequest disableApprovalRequest
                     * @property {boolean|null} [disablePublishNotification] PublishStaffScheduleRequest disablePublishNotification
                     */
    
                    /**
                     * Constructs a new PublishStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PublishStaffScheduleRequest.
                     * @implements IPublishStaffScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest=} [properties] Properties to set
                     */
                    function PublishStaffScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PublishStaffScheduleRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.startDateId = 0;
    
                    /**
                     * PublishStaffScheduleRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.endDateId = 0;
    
                    /**
                     * PublishStaffScheduleRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PublishStaffScheduleRequest doNotPublishOpenShifts.
                     * @member {boolean} doNotPublishOpenShifts
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.doNotPublishOpenShifts = false;
    
                    /**
                     * PublishStaffScheduleRequest autoFillTimeOff.
                     * @member {boolean} autoFillTimeOff
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.autoFillTimeOff = false;
    
                    /**
                     * PublishStaffScheduleRequest minDateId.
                     * @member {number} minDateId
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.minDateId = 0;
    
                    /**
                     * PublishStaffScheduleRequest creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PublishStaffScheduleRequest disableApprovalRequest.
                     * @member {boolean} disableApprovalRequest
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.disableApprovalRequest = false;
    
                    /**
                     * PublishStaffScheduleRequest disablePublishNotification.
                     * @member {boolean} disablePublishNotification
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     */
                    PublishStaffScheduleRequest.prototype.disablePublishNotification = false;
    
                    /**
                     * Creates a new PublishStaffScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PublishStaffScheduleRequest} PublishStaffScheduleRequest instance
                     */
                    PublishStaffScheduleRequest.create = function create(properties) {
                        return new PublishStaffScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified PublishStaffScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.PublishStaffScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest} message PublishStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishStaffScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.doNotPublishOpenShifts != null && Object.hasOwnProperty.call(message, "doNotPublishOpenShifts"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.doNotPublishOpenShifts);
                        if (message.autoFillTimeOff != null && Object.hasOwnProperty.call(message, "autoFillTimeOff"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.autoFillTimeOff);
                        if (message.minDateId != null && Object.hasOwnProperty.call(message, "minDateId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.minDateId);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.creatorId);
                        if (message.disableApprovalRequest != null && Object.hasOwnProperty.call(message, "disableApprovalRequest"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.disableApprovalRequest);
                        if (message.disablePublishNotification != null && Object.hasOwnProperty.call(message, "disablePublishNotification"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.disablePublishNotification);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PublishStaffScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.PublishStaffScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleRequest} message PublishStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishStaffScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PublishStaffScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PublishStaffScheduleRequest} PublishStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishStaffScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PublishStaffScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateId = reader.int32();
                                break;
                            case 2:
                                message.endDateId = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.doNotPublishOpenShifts = reader.bool();
                                break;
                            case 5:
                                message.autoFillTimeOff = reader.bool();
                                break;
                            case 6:
                                message.minDateId = reader.int32();
                                break;
                            case 7:
                                message.creatorId = reader.int64();
                                break;
                            case 8:
                                message.disableApprovalRequest = reader.bool();
                                break;
                            case 9:
                                message.disablePublishNotification = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PublishStaffScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PublishStaffScheduleRequest} PublishStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishStaffScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PublishStaffScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PublishStaffScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.doNotPublishOpenShifts != null && message.hasOwnProperty("doNotPublishOpenShifts"))
                            if (typeof message.doNotPublishOpenShifts !== "boolean")
                                return "doNotPublishOpenShifts: boolean expected";
                        if (message.autoFillTimeOff != null && message.hasOwnProperty("autoFillTimeOff"))
                            if (typeof message.autoFillTimeOff !== "boolean")
                                return "autoFillTimeOff: boolean expected";
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            if (!$util.isInteger(message.minDateId))
                                return "minDateId: integer expected";
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.disableApprovalRequest != null && message.hasOwnProperty("disableApprovalRequest"))
                            if (typeof message.disableApprovalRequest !== "boolean")
                                return "disableApprovalRequest: boolean expected";
                        if (message.disablePublishNotification != null && message.hasOwnProperty("disablePublishNotification"))
                            if (typeof message.disablePublishNotification !== "boolean")
                                return "disablePublishNotification: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a PublishStaffScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PublishStaffScheduleRequest} PublishStaffScheduleRequest
                     */
                    PublishStaffScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PublishStaffScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.PublishStaffScheduleRequest();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.doNotPublishOpenShifts != null)
                            message.doNotPublishOpenShifts = Boolean(object.doNotPublishOpenShifts);
                        if (object.autoFillTimeOff != null)
                            message.autoFillTimeOff = Boolean(object.autoFillTimeOff);
                        if (object.minDateId != null)
                            message.minDateId = object.minDateId | 0;
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        if (object.disableApprovalRequest != null)
                            message.disableApprovalRequest = Boolean(object.disableApprovalRequest);
                        if (object.disablePublishNotification != null)
                            message.disablePublishNotification = Boolean(object.disablePublishNotification);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PublishStaffScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.PublishStaffScheduleRequest} message PublishStaffScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PublishStaffScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.doNotPublishOpenShifts = false;
                            object.autoFillTimeOff = false;
                            object.minDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            object.disableApprovalRequest = false;
                            object.disablePublishNotification = false;
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.doNotPublishOpenShifts != null && message.hasOwnProperty("doNotPublishOpenShifts"))
                            object.doNotPublishOpenShifts = message.doNotPublishOpenShifts;
                        if (message.autoFillTimeOff != null && message.hasOwnProperty("autoFillTimeOff"))
                            object.autoFillTimeOff = message.autoFillTimeOff;
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            object.minDateId = message.minDateId;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.disableApprovalRequest != null && message.hasOwnProperty("disableApprovalRequest"))
                            object.disableApprovalRequest = message.disableApprovalRequest;
                        if (message.disablePublishNotification != null && message.hasOwnProperty("disablePublishNotification"))
                            object.disablePublishNotification = message.disablePublishNotification;
                        return object;
                    };
    
                    /**
                     * Converts this PublishStaffScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PublishStaffScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PublishStaffScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PublishStaffScheduleRequest;
                })();
    
                v1.PublishStaffScheduleResponse = (function() {
    
                    /**
                     * Properties of a PublishStaffScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IPublishStaffScheduleResponse
                     * @property {palexy.protobuf.IScheduleApprovalRequest|null} [createdApprovalRequest] PublishStaffScheduleResponse createdApprovalRequest
                     * @property {boolean|null} [isPublished] PublishStaffScheduleResponse isPublished
                     */
    
                    /**
                     * Constructs a new PublishStaffScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PublishStaffScheduleResponse.
                     * @implements IPublishStaffScheduleResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IPublishStaffScheduleResponse=} [properties] Properties to set
                     */
                    function PublishStaffScheduleResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PublishStaffScheduleResponse createdApprovalRequest.
                     * @member {palexy.protobuf.IScheduleApprovalRequest|null|undefined} createdApprovalRequest
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @instance
                     */
                    PublishStaffScheduleResponse.prototype.createdApprovalRequest = null;
    
                    /**
                     * PublishStaffScheduleResponse isPublished.
                     * @member {boolean} isPublished
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @instance
                     */
                    PublishStaffScheduleResponse.prototype.isPublished = false;
    
                    /**
                     * Creates a new PublishStaffScheduleResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PublishStaffScheduleResponse} PublishStaffScheduleResponse instance
                     */
                    PublishStaffScheduleResponse.create = function create(properties) {
                        return new PublishStaffScheduleResponse(properties);
                    };
    
                    /**
                     * Encodes the specified PublishStaffScheduleResponse message. Does not implicitly {@link palexy.streaming.v1.PublishStaffScheduleResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleResponse} message PublishStaffScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishStaffScheduleResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.createdApprovalRequest != null && Object.hasOwnProperty.call(message, "createdApprovalRequest"))
                            $root.palexy.protobuf.ScheduleApprovalRequest.encode(message.createdApprovalRequest, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.isPublished != null && Object.hasOwnProperty.call(message, "isPublished"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isPublished);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PublishStaffScheduleResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.PublishStaffScheduleResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IPublishStaffScheduleResponse} message PublishStaffScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishStaffScheduleResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PublishStaffScheduleResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PublishStaffScheduleResponse} PublishStaffScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishStaffScheduleResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PublishStaffScheduleResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.createdApprovalRequest = $root.palexy.protobuf.ScheduleApprovalRequest.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.isPublished = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PublishStaffScheduleResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PublishStaffScheduleResponse} PublishStaffScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishStaffScheduleResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PublishStaffScheduleResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PublishStaffScheduleResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.createdApprovalRequest != null && message.hasOwnProperty("createdApprovalRequest")) {
                            var error = $root.palexy.protobuf.ScheduleApprovalRequest.verify(message.createdApprovalRequest);
                            if (error)
                                return "createdApprovalRequest." + error;
                        }
                        if (message.isPublished != null && message.hasOwnProperty("isPublished"))
                            if (typeof message.isPublished !== "boolean")
                                return "isPublished: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a PublishStaffScheduleResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PublishStaffScheduleResponse} PublishStaffScheduleResponse
                     */
                    PublishStaffScheduleResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PublishStaffScheduleResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.PublishStaffScheduleResponse();
                        if (object.createdApprovalRequest != null) {
                            if (typeof object.createdApprovalRequest !== "object")
                                throw TypeError(".palexy.streaming.v1.PublishStaffScheduleResponse.createdApprovalRequest: object expected");
                            message.createdApprovalRequest = $root.palexy.protobuf.ScheduleApprovalRequest.fromObject(object.createdApprovalRequest);
                        }
                        if (object.isPublished != null)
                            message.isPublished = Boolean(object.isPublished);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PublishStaffScheduleResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.PublishStaffScheduleResponse} message PublishStaffScheduleResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PublishStaffScheduleResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.createdApprovalRequest = null;
                            object.isPublished = false;
                        }
                        if (message.createdApprovalRequest != null && message.hasOwnProperty("createdApprovalRequest"))
                            object.createdApprovalRequest = $root.palexy.protobuf.ScheduleApprovalRequest.toObject(message.createdApprovalRequest, options);
                        if (message.isPublished != null && message.hasOwnProperty("isPublished"))
                            object.isPublished = message.isPublished;
                        return object;
                    };
    
                    /**
                     * Converts this PublishStaffScheduleResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PublishStaffScheduleResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PublishStaffScheduleResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PublishStaffScheduleResponse;
                })();
    
                v1.DiscardDraftStaffScheduleRequest = (function() {
    
                    /**
                     * Properties of a DiscardDraftStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDiscardDraftStaffScheduleRequest
                     * @property {number|null} [startDateId] DiscardDraftStaffScheduleRequest startDateId
                     * @property {number|null} [endDateId] DiscardDraftStaffScheduleRequest endDateId
                     * @property {number|null} [storeId] DiscardDraftStaffScheduleRequest storeId
                     * @property {number|null} [minDateId] DiscardDraftStaffScheduleRequest minDateId
                     */
    
                    /**
                     * Constructs a new DiscardDraftStaffScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DiscardDraftStaffScheduleRequest.
                     * @implements IDiscardDraftStaffScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest=} [properties] Properties to set
                     */
                    function DiscardDraftStaffScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DiscardDraftStaffScheduleRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @instance
                     */
                    DiscardDraftStaffScheduleRequest.prototype.startDateId = 0;
    
                    /**
                     * DiscardDraftStaffScheduleRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @instance
                     */
                    DiscardDraftStaffScheduleRequest.prototype.endDateId = 0;
    
                    /**
                     * DiscardDraftStaffScheduleRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @instance
                     */
                    DiscardDraftStaffScheduleRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DiscardDraftStaffScheduleRequest minDateId.
                     * @member {number} minDateId
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @instance
                     */
                    DiscardDraftStaffScheduleRequest.prototype.minDateId = 0;
    
                    /**
                     * Creates a new DiscardDraftStaffScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DiscardDraftStaffScheduleRequest} DiscardDraftStaffScheduleRequest instance
                     */
                    DiscardDraftStaffScheduleRequest.create = function create(properties) {
                        return new DiscardDraftStaffScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DiscardDraftStaffScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.DiscardDraftStaffScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest} message DiscardDraftStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DiscardDraftStaffScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endDateId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.minDateId != null && Object.hasOwnProperty.call(message, "minDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.minDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DiscardDraftStaffScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DiscardDraftStaffScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IDiscardDraftStaffScheduleRequest} message DiscardDraftStaffScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DiscardDraftStaffScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DiscardDraftStaffScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DiscardDraftStaffScheduleRequest} DiscardDraftStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DiscardDraftStaffScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DiscardDraftStaffScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateId = reader.int32();
                                break;
                            case 2:
                                message.endDateId = reader.int32();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.minDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DiscardDraftStaffScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DiscardDraftStaffScheduleRequest} DiscardDraftStaffScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DiscardDraftStaffScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DiscardDraftStaffScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DiscardDraftStaffScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            if (!$util.isInteger(message.minDateId))
                                return "minDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a DiscardDraftStaffScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DiscardDraftStaffScheduleRequest} DiscardDraftStaffScheduleRequest
                     */
                    DiscardDraftStaffScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DiscardDraftStaffScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DiscardDraftStaffScheduleRequest();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.minDateId != null)
                            message.minDateId = object.minDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DiscardDraftStaffScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.DiscardDraftStaffScheduleRequest} message DiscardDraftStaffScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DiscardDraftStaffScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.minDateId = 0;
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.minDateId != null && message.hasOwnProperty("minDateId"))
                            object.minDateId = message.minDateId;
                        return object;
                    };
    
                    /**
                     * Converts this DiscardDraftStaffScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DiscardDraftStaffScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DiscardDraftStaffScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DiscardDraftStaffScheduleRequest;
                })();
    
                v1.CopyScheduleRequest = (function() {
    
                    /**
                     * Properties of a CopyScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICopyScheduleRequest
                     * @property {number|null} [storeId] CopyScheduleRequest storeId
                     * @property {number|null} [fromStartDateId] CopyScheduleRequest fromStartDateId
                     * @property {number|null} [fromEndDateId] CopyScheduleRequest fromEndDateId
                     * @property {number|null} [toStartDateId] CopyScheduleRequest toStartDateId
                     * @property {number|null} [toEndDateId] CopyScheduleRequest toEndDateId
                     * @property {Array.<number>|null} [staffIds] CopyScheduleRequest staffIds
                     * @property {boolean|null} [preview] CopyScheduleRequest preview
                     */
    
                    /**
                     * Constructs a new CopyScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CopyScheduleRequest.
                     * @implements ICopyScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICopyScheduleRequest=} [properties] Properties to set
                     */
                    function CopyScheduleRequest(properties) {
                        this.staffIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CopyScheduleRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CopyScheduleRequest fromStartDateId.
                     * @member {number} fromStartDateId
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.fromStartDateId = 0;
    
                    /**
                     * CopyScheduleRequest fromEndDateId.
                     * @member {number} fromEndDateId
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.fromEndDateId = 0;
    
                    /**
                     * CopyScheduleRequest toStartDateId.
                     * @member {number} toStartDateId
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.toStartDateId = 0;
    
                    /**
                     * CopyScheduleRequest toEndDateId.
                     * @member {number} toEndDateId
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.toEndDateId = 0;
    
                    /**
                     * CopyScheduleRequest staffIds.
                     * @member {Array.<number>} staffIds
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.staffIds = $util.emptyArray;
    
                    /**
                     * CopyScheduleRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     */
                    CopyScheduleRequest.prototype.preview = false;
    
                    /**
                     * Creates a new CopyScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICopyScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CopyScheduleRequest} CopyScheduleRequest instance
                     */
                    CopyScheduleRequest.create = function create(properties) {
                        return new CopyScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CopyScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.CopyScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICopyScheduleRequest} message CopyScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CopyScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.fromStartDateId != null && Object.hasOwnProperty.call(message, "fromStartDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.fromStartDateId);
                        if (message.fromEndDateId != null && Object.hasOwnProperty.call(message, "fromEndDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.fromEndDateId);
                        if (message.toStartDateId != null && Object.hasOwnProperty.call(message, "toStartDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.toStartDateId);
                        if (message.toEndDateId != null && Object.hasOwnProperty.call(message, "toEndDateId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.toEndDateId);
                        if (message.staffIds != null && message.staffIds.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.staffIds.length; ++i)
                                writer.int64(message.staffIds[i]);
                            writer.ldelim();
                        }
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.preview);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CopyScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CopyScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.ICopyScheduleRequest} message CopyScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CopyScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CopyScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CopyScheduleRequest} CopyScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CopyScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CopyScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.fromStartDateId = reader.int32();
                                break;
                            case 3:
                                message.fromEndDateId = reader.int32();
                                break;
                            case 4:
                                message.toStartDateId = reader.int32();
                                break;
                            case 5:
                                message.toEndDateId = reader.int32();
                                break;
                            case 6:
                                if (!(message.staffIds && message.staffIds.length))
                                    message.staffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.staffIds.push(reader.int64());
                                } else
                                    message.staffIds.push(reader.int64());
                                break;
                            case 7:
                                message.preview = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CopyScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CopyScheduleRequest} CopyScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CopyScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CopyScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CopyScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.fromStartDateId != null && message.hasOwnProperty("fromStartDateId"))
                            if (!$util.isInteger(message.fromStartDateId))
                                return "fromStartDateId: integer expected";
                        if (message.fromEndDateId != null && message.hasOwnProperty("fromEndDateId"))
                            if (!$util.isInteger(message.fromEndDateId))
                                return "fromEndDateId: integer expected";
                        if (message.toStartDateId != null && message.hasOwnProperty("toStartDateId"))
                            if (!$util.isInteger(message.toStartDateId))
                                return "toStartDateId: integer expected";
                        if (message.toEndDateId != null && message.hasOwnProperty("toEndDateId"))
                            if (!$util.isInteger(message.toEndDateId))
                                return "toEndDateId: integer expected";
                        if (message.staffIds != null && message.hasOwnProperty("staffIds")) {
                            if (!Array.isArray(message.staffIds))
                                return "staffIds: array expected";
                            for (var i = 0; i < message.staffIds.length; ++i)
                                if (!$util.isInteger(message.staffIds[i]) && !(message.staffIds[i] && $util.isInteger(message.staffIds[i].low) && $util.isInteger(message.staffIds[i].high)))
                                    return "staffIds: integer|Long[] expected";
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CopyScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CopyScheduleRequest} CopyScheduleRequest
                     */
                    CopyScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CopyScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CopyScheduleRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.fromStartDateId != null)
                            message.fromStartDateId = object.fromStartDateId | 0;
                        if (object.fromEndDateId != null)
                            message.fromEndDateId = object.fromEndDateId | 0;
                        if (object.toStartDateId != null)
                            message.toStartDateId = object.toStartDateId | 0;
                        if (object.toEndDateId != null)
                            message.toEndDateId = object.toEndDateId | 0;
                        if (object.staffIds) {
                            if (!Array.isArray(object.staffIds))
                                throw TypeError(".palexy.streaming.v1.CopyScheduleRequest.staffIds: array expected");
                            message.staffIds = [];
                            for (var i = 0; i < object.staffIds.length; ++i)
                                if ($util.Long)
                                    (message.staffIds[i] = $util.Long.fromValue(object.staffIds[i])).unsigned = false;
                                else if (typeof object.staffIds[i] === "string")
                                    message.staffIds[i] = parseInt(object.staffIds[i], 10);
                                else if (typeof object.staffIds[i] === "number")
                                    message.staffIds[i] = object.staffIds[i];
                                else if (typeof object.staffIds[i] === "object")
                                    message.staffIds[i] = new $util.LongBits(object.staffIds[i].low >>> 0, object.staffIds[i].high >>> 0).toNumber();
                        }
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CopyScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.CopyScheduleRequest} message CopyScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CopyScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.fromStartDateId = 0;
                            object.fromEndDateId = 0;
                            object.toStartDateId = 0;
                            object.toEndDateId = 0;
                            object.preview = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.fromStartDateId != null && message.hasOwnProperty("fromStartDateId"))
                            object.fromStartDateId = message.fromStartDateId;
                        if (message.fromEndDateId != null && message.hasOwnProperty("fromEndDateId"))
                            object.fromEndDateId = message.fromEndDateId;
                        if (message.toStartDateId != null && message.hasOwnProperty("toStartDateId"))
                            object.toStartDateId = message.toStartDateId;
                        if (message.toEndDateId != null && message.hasOwnProperty("toEndDateId"))
                            object.toEndDateId = message.toEndDateId;
                        if (message.staffIds && message.staffIds.length) {
                            object.staffIds = [];
                            for (var j = 0; j < message.staffIds.length; ++j)
                                if (typeof message.staffIds[j] === "number")
                                    object.staffIds[j] = options.longs === String ? String(message.staffIds[j]) : message.staffIds[j];
                                else
                                    object.staffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.staffIds[j]) : options.longs === Number ? new $util.LongBits(message.staffIds[j].low >>> 0, message.staffIds[j].high >>> 0).toNumber() : message.staffIds[j];
                        }
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        return object;
                    };
    
                    /**
                     * Converts this CopyScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CopyScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CopyScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CopyScheduleRequest;
                })();
    
                v1.StaffScheduleGeneralSetting = (function() {
    
                    /**
                     * Properties of a StaffScheduleGeneralSetting.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffScheduleGeneralSetting
                     * @property {number|null} [id] StaffScheduleGeneralSetting id
                     * @property {number|null} [companyId] StaffScheduleGeneralSetting companyId
                     * @property {number|null} [recommendedMaxHoursPerWeek] StaffScheduleGeneralSetting recommendedMaxHoursPerWeek
                     * @property {number|null} [recommendedMaxHoursPerDay] StaffScheduleGeneralSetting recommendedMaxHoursPerDay
                     * @property {number|null} [recommendedMinHoursBetweenLongShifts] StaffScheduleGeneralSetting recommendedMinHoursBetweenLongShifts
                     * @property {number|null} [createTimeMs] StaffScheduleGeneralSetting createTimeMs
                     * @property {number|null} [updateTimeMs] StaffScheduleGeneralSetting updateTimeMs
                     * @property {number|null} [usualNumOfShiftsPerStaffPerWeek] StaffScheduleGeneralSetting usualNumOfShiftsPerStaffPerWeek
                     * @property {number|null} [recommendedMaxBreakTimePerDayPerStaffInMin] StaffScheduleGeneralSetting recommendedMaxBreakTimePerDayPerStaffInMin
                     * @property {Array.<number>|null} [ignoredPositionIdsForMetricCalculation] StaffScheduleGeneralSetting ignoredPositionIdsForMetricCalculation
                     * @property {number|null} [recommendedMinDistanceFromShiftStartToBreakStartInMin] StaffScheduleGeneralSetting recommendedMinDistanceFromShiftStartToBreakStartInMin
                     * @property {number|null} [recommendedMinDistanceFromShiftEndToBreakStartInMin] StaffScheduleGeneralSetting recommendedMinDistanceFromShiftEndToBreakStartInMin
                     * @property {boolean|null} [enableMinHoursBetweenLongShiftsRule] StaffScheduleGeneralSetting enableMinHoursBetweenLongShiftsRule
                     * @property {boolean|null} [enableMaxBreakTimePerDayPerStaffRule] StaffScheduleGeneralSetting enableMaxBreakTimePerDayPerStaffRule
                     * @property {boolean|null} [enableMaxHoursPerDayRule] StaffScheduleGeneralSetting enableMaxHoursPerDayRule
                     * @property {boolean|null} [enableMaxHoursPerWeekRule] StaffScheduleGeneralSetting enableMaxHoursPerWeekRule
                     * @property {boolean|null} [enableUnavailabilityOverlapRule] StaffScheduleGeneralSetting enableUnavailabilityOverlapRule
                     * @property {boolean|null} [enableHourNotCoveredRule] StaffScheduleGeneralSetting enableHourNotCoveredRule
                     * @property {boolean|null} [enableLackOfStaffRule] StaffScheduleGeneralSetting enableLackOfStaffRule
                     * @property {palexy.streaming.v1.EmailLanguage|null} [sendInvitationLanguage] StaffScheduleGeneralSetting sendInvitationLanguage
                     * @property {number|null} [targetScheduleLaborCostRate] StaffScheduleGeneralSetting targetScheduleLaborCostRate
                     * @property {number|null} [targetScheduleLaborCostRateVariability] StaffScheduleGeneralSetting targetScheduleLaborCostRateVariability
                     * @property {boolean|null} [treatPreferToWorkAsCanOnlyWorkByDefault] StaffScheduleGeneralSetting treatPreferToWorkAsCanOnlyWorkByDefault
                     * @property {number|null} [timeOffTypeIdForAutoFill] StaffScheduleGeneralSetting timeOffTypeIdForAutoFill
                     * @property {boolean|null} [rotatingShiftForStaffBalanceByDefault] StaffScheduleGeneralSetting rotatingShiftForStaffBalanceByDefault
                     * @property {palexy.streaming.v1.PayPeriodType|null} [payPeriodType] StaffScheduleGeneralSetting payPeriodType
                     * @property {number|null} [dayOfMonthToStartPayPeriod] StaffScheduleGeneralSetting dayOfMonthToStartPayPeriod
                     * @property {number|null} [recommendedMaxHoursPerWeekForPartTime] StaffScheduleGeneralSetting recommendedMaxHoursPerWeekForPartTime
                     * @property {boolean|null} [enableScheduleApprovalProcess] StaffScheduleGeneralSetting enableScheduleApprovalProcess
                     * @property {palexy.protobuf.ScheduleApprovalPeriod|null} [scheduleApprovalPeriod] StaffScheduleGeneralSetting scheduleApprovalPeriod
                     * @property {boolean|null} [enableMaxHoursPerWeekIncludeOtRule] StaffScheduleGeneralSetting enableMaxHoursPerWeekIncludeOtRule
                     * @property {number|null} [recommendedMaxHoursPerWeekIncludeOt] StaffScheduleGeneralSetting recommendedMaxHoursPerWeekIncludeOt
                     * @property {number|null} [recommendedMaxHoursPerMonthForPartTime] StaffScheduleGeneralSetting recommendedMaxHoursPerMonthForPartTime
                     * @property {boolean|null} [enableOtCalculation] StaffScheduleGeneralSetting enableOtCalculation
                     * @property {palexy.streaming.v1.PartTimeOtPolicy|null} [partTimeOtPolicy] StaffScheduleGeneralSetting partTimeOtPolicy
                     * @property {palexy.streaming.v1.FullTimeOtPolicy|null} [fullTimeOtPolicy] StaffScheduleGeneralSetting fullTimeOtPolicy
                     * @property {palexy.streaming.v1.LockSchedulePeriodType|null} [lockSchedulePeriodType] StaffScheduleGeneralSetting lockSchedulePeriodType
                     * @property {number|null} [lockSchedulePeriodAfterDays] StaffScheduleGeneralSetting lockSchedulePeriodAfterDays
                     * @property {number|null} [fullTimeRatio] StaffScheduleGeneralSetting fullTimeRatio
                     * @property {boolean|null} [enableScheduleTemplateUsage] StaffScheduleGeneralSetting enableScheduleTemplateUsage
                     * @property {boolean|null} [disableRequiredStaffPosition] StaffScheduleGeneralSetting disableRequiredStaffPosition
                     * @property {boolean|null} [allowStaffToClaimShift] StaffScheduleGeneralSetting allowStaffToClaimShift
                     * @property {number|null} [minStaffAtEachOperationHour] StaffScheduleGeneralSetting minStaffAtEachOperationHour
                     * @property {boolean|null} [allowStaffToSwapShift] StaffScheduleGeneralSetting allowStaffToSwapShift
                     * @property {boolean|null} [enableAvailabilityReminder] StaffScheduleGeneralSetting enableAvailabilityReminder
                     * @property {Array.<palexy.streaming.v1.DayOfWeek>|null} [availabilityReminderDaysOfWeek] StaffScheduleGeneralSetting availabilityReminderDaysOfWeek
                     * @property {string|null} [availabilityReminderTime] StaffScheduleGeneralSetting availabilityReminderTime
                     * @property {boolean|null} [enableDayPartSummary] StaffScheduleGeneralSetting enableDayPartSummary
                     * @property {number|null} [defaultWorkingHourPerDay] StaffScheduleGeneralSetting defaultWorkingHourPerDay
                     * @property {string|null} [defaultStartTimeInDay] StaffScheduleGeneralSetting defaultStartTimeInDay
                     * @property {string|null} [defaultEndTimeInDay] StaffScheduleGeneralSetting defaultEndTimeInDay
                     * @property {boolean|null} [highlightPtShiftsCrossMaxWorkingHours] StaffScheduleGeneralSetting highlightPtShiftsCrossMaxWorkingHours
                     * @property {number|null} [ptWorkingHoursThresholdForHighlight] StaffScheduleGeneralSetting ptWorkingHoursThresholdForHighlight
                     * @property {boolean|null} [defaultRequiredPosition] StaffScheduleGeneralSetting defaultRequiredPosition
                     * @property {boolean|null} [allowStaffToRequestTimeOff] StaffScheduleGeneralSetting allowStaffToRequestTimeOff
                     * @property {boolean|null} [allowAreaManagerEditBudget] StaffScheduleGeneralSetting allowAreaManagerEditBudget
                     * @property {boolean|null} [distributeBudgetHoursEvenlyByDefault] StaffScheduleGeneralSetting distributeBudgetHoursEvenlyByDefault
                     * @property {palexy.streaming.v1.IStoreFilter|null} [allowEditStaffAreaStores] StaffScheduleGeneralSetting allowEditStaffAreaStores
                     * @property {boolean|null} [enableStrictApprovalFlow] StaffScheduleGeneralSetting enableStrictApprovalFlow
                     * @property {Array.<palexy.protobuf.INonCoveragePositionMapping>|null} [nonCoveragePositionMappings] StaffScheduleGeneralSetting nonCoveragePositionMappings
                     * @property {boolean|null} [skipApprovalOnMinimalChanges] StaffScheduleGeneralSetting skipApprovalOnMinimalChanges
                     * @property {number|null} [minimalChangesThresholdPercentage] StaffScheduleGeneralSetting minimalChangesThresholdPercentage
                     * @property {boolean|null} [allowExternalStaffEmploymentType] StaffScheduleGeneralSetting allowExternalStaffEmploymentType
                     * @property {number|null} [maxAutoAdjustBudgetDecreasePercentage] StaffScheduleGeneralSetting maxAutoAdjustBudgetDecreasePercentage
                     * @property {boolean|null} [strictBufferBetweenShifts] StaffScheduleGeneralSetting strictBufferBetweenShifts
                     * @property {boolean|null} [enableWeeklyAvailabilityAutoLock] StaffScheduleGeneralSetting enableWeeklyAvailabilityAutoLock
                     * @property {palexy.streaming.v1.DayOfWeek|null} [availabilityAutoLockDayOfWeek] StaffScheduleGeneralSetting availabilityAutoLockDayOfWeek
                     * @property {Array.<number>|null} [showPaidHoursPositionIds] StaffScheduleGeneralSetting showPaidHoursPositionIds
                     * @property {boolean|null} [disableEditNonCoverageAtShiftLevel] StaffScheduleGeneralSetting disableEditNonCoverageAtShiftLevel
                     * @property {boolean|null} [enableBudgetPlanningTplhWarning] StaffScheduleGeneralSetting enableBudgetPlanningTplhWarning
                     * @property {boolean|null} [disableEditBreakTimeAtShiftLevel] StaffScheduleGeneralSetting disableEditBreakTimeAtShiftLevel
                     */
    
                    /**
                     * Constructs a new StaffScheduleGeneralSetting.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffScheduleGeneralSetting.
                     * @implements IStaffScheduleGeneralSetting
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSetting=} [properties] Properties to set
                     */
                    function StaffScheduleGeneralSetting(properties) {
                        this.ignoredPositionIdsForMetricCalculation = [];
                        this.availabilityReminderDaysOfWeek = [];
                        this.nonCoveragePositionMappings = [];
                        this.showPaidHoursPositionIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffScheduleGeneralSetting id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffScheduleGeneralSetting companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxHoursPerWeek.
                     * @member {number} recommendedMaxHoursPerWeek
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxHoursPerWeek = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxHoursPerDay.
                     * @member {number} recommendedMaxHoursPerDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxHoursPerDay = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMinHoursBetweenLongShifts.
                     * @member {number} recommendedMinHoursBetweenLongShifts
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMinHoursBetweenLongShifts = 0;
    
                    /**
                     * StaffScheduleGeneralSetting createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffScheduleGeneralSetting updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffScheduleGeneralSetting usualNumOfShiftsPerStaffPerWeek.
                     * @member {number} usualNumOfShiftsPerStaffPerWeek
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.usualNumOfShiftsPerStaffPerWeek = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxBreakTimePerDayPerStaffInMin.
                     * @member {number} recommendedMaxBreakTimePerDayPerStaffInMin
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxBreakTimePerDayPerStaffInMin = 0;
    
                    /**
                     * StaffScheduleGeneralSetting ignoredPositionIdsForMetricCalculation.
                     * @member {Array.<number>} ignoredPositionIdsForMetricCalculation
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.ignoredPositionIdsForMetricCalculation = $util.emptyArray;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMinDistanceFromShiftStartToBreakStartInMin.
                     * @member {number} recommendedMinDistanceFromShiftStartToBreakStartInMin
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMinDistanceFromShiftStartToBreakStartInMin = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMinDistanceFromShiftEndToBreakStartInMin.
                     * @member {number} recommendedMinDistanceFromShiftEndToBreakStartInMin
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMinDistanceFromShiftEndToBreakStartInMin = 0;
    
                    /**
                     * StaffScheduleGeneralSetting enableMinHoursBetweenLongShiftsRule.
                     * @member {boolean} enableMinHoursBetweenLongShiftsRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableMinHoursBetweenLongShiftsRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableMaxBreakTimePerDayPerStaffRule.
                     * @member {boolean} enableMaxBreakTimePerDayPerStaffRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableMaxBreakTimePerDayPerStaffRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableMaxHoursPerDayRule.
                     * @member {boolean} enableMaxHoursPerDayRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableMaxHoursPerDayRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableMaxHoursPerWeekRule.
                     * @member {boolean} enableMaxHoursPerWeekRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableMaxHoursPerWeekRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableUnavailabilityOverlapRule.
                     * @member {boolean} enableUnavailabilityOverlapRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableUnavailabilityOverlapRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableHourNotCoveredRule.
                     * @member {boolean} enableHourNotCoveredRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableHourNotCoveredRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableLackOfStaffRule.
                     * @member {boolean} enableLackOfStaffRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableLackOfStaffRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting sendInvitationLanguage.
                     * @member {palexy.streaming.v1.EmailLanguage} sendInvitationLanguage
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.sendInvitationLanguage = 0;
    
                    /**
                     * StaffScheduleGeneralSetting targetScheduleLaborCostRate.
                     * @member {number} targetScheduleLaborCostRate
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.targetScheduleLaborCostRate = 0;
    
                    /**
                     * StaffScheduleGeneralSetting targetScheduleLaborCostRateVariability.
                     * @member {number} targetScheduleLaborCostRateVariability
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.targetScheduleLaborCostRateVariability = 0;
    
                    /**
                     * StaffScheduleGeneralSetting treatPreferToWorkAsCanOnlyWorkByDefault.
                     * @member {boolean} treatPreferToWorkAsCanOnlyWorkByDefault
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.treatPreferToWorkAsCanOnlyWorkByDefault = false;
    
                    /**
                     * StaffScheduleGeneralSetting timeOffTypeIdForAutoFill.
                     * @member {number} timeOffTypeIdForAutoFill
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.timeOffTypeIdForAutoFill = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffScheduleGeneralSetting rotatingShiftForStaffBalanceByDefault.
                     * @member {boolean} rotatingShiftForStaffBalanceByDefault
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.rotatingShiftForStaffBalanceByDefault = false;
    
                    /**
                     * StaffScheduleGeneralSetting payPeriodType.
                     * @member {palexy.streaming.v1.PayPeriodType} payPeriodType
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.payPeriodType = 0;
    
                    /**
                     * StaffScheduleGeneralSetting dayOfMonthToStartPayPeriod.
                     * @member {number} dayOfMonthToStartPayPeriod
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.dayOfMonthToStartPayPeriod = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxHoursPerWeekForPartTime.
                     * @member {number} recommendedMaxHoursPerWeekForPartTime
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxHoursPerWeekForPartTime = 0;
    
                    /**
                     * StaffScheduleGeneralSetting enableScheduleApprovalProcess.
                     * @member {boolean} enableScheduleApprovalProcess
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableScheduleApprovalProcess = false;
    
                    /**
                     * StaffScheduleGeneralSetting scheduleApprovalPeriod.
                     * @member {palexy.protobuf.ScheduleApprovalPeriod} scheduleApprovalPeriod
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.scheduleApprovalPeriod = 0;
    
                    /**
                     * StaffScheduleGeneralSetting enableMaxHoursPerWeekIncludeOtRule.
                     * @member {boolean} enableMaxHoursPerWeekIncludeOtRule
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableMaxHoursPerWeekIncludeOtRule = false;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxHoursPerWeekIncludeOt.
                     * @member {number} recommendedMaxHoursPerWeekIncludeOt
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxHoursPerWeekIncludeOt = 0;
    
                    /**
                     * StaffScheduleGeneralSetting recommendedMaxHoursPerMonthForPartTime.
                     * @member {number} recommendedMaxHoursPerMonthForPartTime
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.recommendedMaxHoursPerMonthForPartTime = 0;
    
                    /**
                     * StaffScheduleGeneralSetting enableOtCalculation.
                     * @member {boolean} enableOtCalculation
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableOtCalculation = false;
    
                    /**
                     * StaffScheduleGeneralSetting partTimeOtPolicy.
                     * @member {palexy.streaming.v1.PartTimeOtPolicy} partTimeOtPolicy
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.partTimeOtPolicy = 0;
    
                    /**
                     * StaffScheduleGeneralSetting fullTimeOtPolicy.
                     * @member {palexy.streaming.v1.FullTimeOtPolicy} fullTimeOtPolicy
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.fullTimeOtPolicy = 0;
    
                    /**
                     * StaffScheduleGeneralSetting lockSchedulePeriodType.
                     * @member {palexy.streaming.v1.LockSchedulePeriodType} lockSchedulePeriodType
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.lockSchedulePeriodType = 0;
    
                    /**
                     * StaffScheduleGeneralSetting lockSchedulePeriodAfterDays.
                     * @member {number} lockSchedulePeriodAfterDays
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.lockSchedulePeriodAfterDays = 0;
    
                    /**
                     * StaffScheduleGeneralSetting fullTimeRatio.
                     * @member {number} fullTimeRatio
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.fullTimeRatio = 0;
    
                    /**
                     * StaffScheduleGeneralSetting enableScheduleTemplateUsage.
                     * @member {boolean} enableScheduleTemplateUsage
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableScheduleTemplateUsage = false;
    
                    /**
                     * StaffScheduleGeneralSetting disableRequiredStaffPosition.
                     * @member {boolean} disableRequiredStaffPosition
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.disableRequiredStaffPosition = false;
    
                    /**
                     * StaffScheduleGeneralSetting allowStaffToClaimShift.
                     * @member {boolean} allowStaffToClaimShift
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowStaffToClaimShift = false;
    
                    /**
                     * StaffScheduleGeneralSetting minStaffAtEachOperationHour.
                     * @member {number} minStaffAtEachOperationHour
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.minStaffAtEachOperationHour = 0;
    
                    /**
                     * StaffScheduleGeneralSetting allowStaffToSwapShift.
                     * @member {boolean} allowStaffToSwapShift
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowStaffToSwapShift = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableAvailabilityReminder.
                     * @member {boolean} enableAvailabilityReminder
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableAvailabilityReminder = false;
    
                    /**
                     * StaffScheduleGeneralSetting availabilityReminderDaysOfWeek.
                     * @member {Array.<palexy.streaming.v1.DayOfWeek>} availabilityReminderDaysOfWeek
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.availabilityReminderDaysOfWeek = $util.emptyArray;
    
                    /**
                     * StaffScheduleGeneralSetting availabilityReminderTime.
                     * @member {string} availabilityReminderTime
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.availabilityReminderTime = "";
    
                    /**
                     * StaffScheduleGeneralSetting enableDayPartSummary.
                     * @member {boolean} enableDayPartSummary
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableDayPartSummary = false;
    
                    /**
                     * StaffScheduleGeneralSetting defaultWorkingHourPerDay.
                     * @member {number} defaultWorkingHourPerDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.defaultWorkingHourPerDay = 0;
    
                    /**
                     * StaffScheduleGeneralSetting defaultStartTimeInDay.
                     * @member {string} defaultStartTimeInDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.defaultStartTimeInDay = "";
    
                    /**
                     * StaffScheduleGeneralSetting defaultEndTimeInDay.
                     * @member {string} defaultEndTimeInDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.defaultEndTimeInDay = "";
    
                    /**
                     * StaffScheduleGeneralSetting highlightPtShiftsCrossMaxWorkingHours.
                     * @member {boolean} highlightPtShiftsCrossMaxWorkingHours
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.highlightPtShiftsCrossMaxWorkingHours = false;
    
                    /**
                     * StaffScheduleGeneralSetting ptWorkingHoursThresholdForHighlight.
                     * @member {number} ptWorkingHoursThresholdForHighlight
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.ptWorkingHoursThresholdForHighlight = 0;
    
                    /**
                     * StaffScheduleGeneralSetting defaultRequiredPosition.
                     * @member {boolean} defaultRequiredPosition
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.defaultRequiredPosition = false;
    
                    /**
                     * StaffScheduleGeneralSetting allowStaffToRequestTimeOff.
                     * @member {boolean} allowStaffToRequestTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowStaffToRequestTimeOff = false;
    
                    /**
                     * StaffScheduleGeneralSetting allowAreaManagerEditBudget.
                     * @member {boolean} allowAreaManagerEditBudget
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowAreaManagerEditBudget = false;
    
                    /**
                     * StaffScheduleGeneralSetting distributeBudgetHoursEvenlyByDefault.
                     * @member {boolean} distributeBudgetHoursEvenlyByDefault
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.distributeBudgetHoursEvenlyByDefault = false;
    
                    /**
                     * StaffScheduleGeneralSetting allowEditStaffAreaStores.
                     * @member {palexy.streaming.v1.IStoreFilter|null|undefined} allowEditStaffAreaStores
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowEditStaffAreaStores = null;
    
                    /**
                     * StaffScheduleGeneralSetting enableStrictApprovalFlow.
                     * @member {boolean} enableStrictApprovalFlow
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableStrictApprovalFlow = false;
    
                    /**
                     * StaffScheduleGeneralSetting nonCoveragePositionMappings.
                     * @member {Array.<palexy.protobuf.INonCoveragePositionMapping>} nonCoveragePositionMappings
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.nonCoveragePositionMappings = $util.emptyArray;
    
                    /**
                     * StaffScheduleGeneralSetting skipApprovalOnMinimalChanges.
                     * @member {boolean} skipApprovalOnMinimalChanges
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.skipApprovalOnMinimalChanges = false;
    
                    /**
                     * StaffScheduleGeneralSetting minimalChangesThresholdPercentage.
                     * @member {number} minimalChangesThresholdPercentage
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.minimalChangesThresholdPercentage = 0;
    
                    /**
                     * StaffScheduleGeneralSetting allowExternalStaffEmploymentType.
                     * @member {boolean} allowExternalStaffEmploymentType
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.allowExternalStaffEmploymentType = false;
    
                    /**
                     * StaffScheduleGeneralSetting maxAutoAdjustBudgetDecreasePercentage.
                     * @member {number} maxAutoAdjustBudgetDecreasePercentage
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.maxAutoAdjustBudgetDecreasePercentage = 0;
    
                    /**
                     * StaffScheduleGeneralSetting strictBufferBetweenShifts.
                     * @member {boolean} strictBufferBetweenShifts
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.strictBufferBetweenShifts = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableWeeklyAvailabilityAutoLock.
                     * @member {boolean} enableWeeklyAvailabilityAutoLock
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableWeeklyAvailabilityAutoLock = false;
    
                    /**
                     * StaffScheduleGeneralSetting availabilityAutoLockDayOfWeek.
                     * @member {palexy.streaming.v1.DayOfWeek} availabilityAutoLockDayOfWeek
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.availabilityAutoLockDayOfWeek = 0;
    
                    /**
                     * StaffScheduleGeneralSetting showPaidHoursPositionIds.
                     * @member {Array.<number>} showPaidHoursPositionIds
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.showPaidHoursPositionIds = $util.emptyArray;
    
                    /**
                     * StaffScheduleGeneralSetting disableEditNonCoverageAtShiftLevel.
                     * @member {boolean} disableEditNonCoverageAtShiftLevel
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.disableEditNonCoverageAtShiftLevel = false;
    
                    /**
                     * StaffScheduleGeneralSetting enableBudgetPlanningTplhWarning.
                     * @member {boolean} enableBudgetPlanningTplhWarning
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.enableBudgetPlanningTplhWarning = false;
    
                    /**
                     * StaffScheduleGeneralSetting disableEditBreakTimeAtShiftLevel.
                     * @member {boolean} disableEditBreakTimeAtShiftLevel
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    StaffScheduleGeneralSetting.prototype.disableEditBreakTimeAtShiftLevel = false;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * StaffScheduleGeneralSetting _allowEditStaffAreaStores.
                     * @member {"allowEditStaffAreaStores"|undefined} _allowEditStaffAreaStores
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     */
                    Object.defineProperty(StaffScheduleGeneralSetting.prototype, "_allowEditStaffAreaStores", {
                        get: $util.oneOfGetter($oneOfFields = ["allowEditStaffAreaStores"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new StaffScheduleGeneralSetting instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSetting=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSetting} StaffScheduleGeneralSetting instance
                     */
                    StaffScheduleGeneralSetting.create = function create(properties) {
                        return new StaffScheduleGeneralSetting(properties);
                    };
    
                    /**
                     * Encodes the specified StaffScheduleGeneralSetting message. Does not implicitly {@link palexy.streaming.v1.StaffScheduleGeneralSetting.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSetting} message StaffScheduleGeneralSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffScheduleGeneralSetting.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.recommendedMaxHoursPerWeek != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerWeek"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.recommendedMaxHoursPerWeek);
                        if (message.recommendedMaxHoursPerDay != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerDay"))
                            writer.uint32(/* id 4, wireType 5 =*/37).float(message.recommendedMaxHoursPerDay);
                        if (message.recommendedMinHoursBetweenLongShifts != null && Object.hasOwnProperty.call(message, "recommendedMinHoursBetweenLongShifts"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.recommendedMinHoursBetweenLongShifts);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updateTimeMs);
                        if (message.usualNumOfShiftsPerStaffPerWeek != null && Object.hasOwnProperty.call(message, "usualNumOfShiftsPerStaffPerWeek"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.usualNumOfShiftsPerStaffPerWeek);
                        if (message.recommendedMaxBreakTimePerDayPerStaffInMin != null && Object.hasOwnProperty.call(message, "recommendedMaxBreakTimePerDayPerStaffInMin"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.recommendedMaxBreakTimePerDayPerStaffInMin);
                        if (message.recommendedMinDistanceFromShiftStartToBreakStartInMin != null && Object.hasOwnProperty.call(message, "recommendedMinDistanceFromShiftStartToBreakStartInMin"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.recommendedMinDistanceFromShiftStartToBreakStartInMin);
                        if (message.recommendedMinDistanceFromShiftEndToBreakStartInMin != null && Object.hasOwnProperty.call(message, "recommendedMinDistanceFromShiftEndToBreakStartInMin"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.recommendedMinDistanceFromShiftEndToBreakStartInMin);
                        if (message.ignoredPositionIdsForMetricCalculation != null && message.ignoredPositionIdsForMetricCalculation.length) {
                            writer.uint32(/* id 12, wireType 2 =*/98).fork();
                            for (var i = 0; i < message.ignoredPositionIdsForMetricCalculation.length; ++i)
                                writer.int64(message.ignoredPositionIdsForMetricCalculation[i]);
                            writer.ldelim();
                        }
                        if (message.enableMinHoursBetweenLongShiftsRule != null && Object.hasOwnProperty.call(message, "enableMinHoursBetweenLongShiftsRule"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.enableMinHoursBetweenLongShiftsRule);
                        if (message.enableMaxBreakTimePerDayPerStaffRule != null && Object.hasOwnProperty.call(message, "enableMaxBreakTimePerDayPerStaffRule"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.enableMaxBreakTimePerDayPerStaffRule);
                        if (message.enableMaxHoursPerDayRule != null && Object.hasOwnProperty.call(message, "enableMaxHoursPerDayRule"))
                            writer.uint32(/* id 15, wireType 0 =*/120).bool(message.enableMaxHoursPerDayRule);
                        if (message.enableMaxHoursPerWeekRule != null && Object.hasOwnProperty.call(message, "enableMaxHoursPerWeekRule"))
                            writer.uint32(/* id 16, wireType 0 =*/128).bool(message.enableMaxHoursPerWeekRule);
                        if (message.enableUnavailabilityOverlapRule != null && Object.hasOwnProperty.call(message, "enableUnavailabilityOverlapRule"))
                            writer.uint32(/* id 17, wireType 0 =*/136).bool(message.enableUnavailabilityOverlapRule);
                        if (message.enableHourNotCoveredRule != null && Object.hasOwnProperty.call(message, "enableHourNotCoveredRule"))
                            writer.uint32(/* id 18, wireType 0 =*/144).bool(message.enableHourNotCoveredRule);
                        if (message.enableLackOfStaffRule != null && Object.hasOwnProperty.call(message, "enableLackOfStaffRule"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.enableLackOfStaffRule);
                        if (message.sendInvitationLanguage != null && Object.hasOwnProperty.call(message, "sendInvitationLanguage"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.sendInvitationLanguage);
                        if (message.targetScheduleLaborCostRate != null && Object.hasOwnProperty.call(message, "targetScheduleLaborCostRate"))
                            writer.uint32(/* id 21, wireType 5 =*/173).float(message.targetScheduleLaborCostRate);
                        if (message.targetScheduleLaborCostRateVariability != null && Object.hasOwnProperty.call(message, "targetScheduleLaborCostRateVariability"))
                            writer.uint32(/* id 22, wireType 5 =*/181).float(message.targetScheduleLaborCostRateVariability);
                        if (message.treatPreferToWorkAsCanOnlyWorkByDefault != null && Object.hasOwnProperty.call(message, "treatPreferToWorkAsCanOnlyWorkByDefault"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.treatPreferToWorkAsCanOnlyWorkByDefault);
                        if (message.timeOffTypeIdForAutoFill != null && Object.hasOwnProperty.call(message, "timeOffTypeIdForAutoFill"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int64(message.timeOffTypeIdForAutoFill);
                        if (message.rotatingShiftForStaffBalanceByDefault != null && Object.hasOwnProperty.call(message, "rotatingShiftForStaffBalanceByDefault"))
                            writer.uint32(/* id 25, wireType 0 =*/200).bool(message.rotatingShiftForStaffBalanceByDefault);
                        if (message.payPeriodType != null && Object.hasOwnProperty.call(message, "payPeriodType"))
                            writer.uint32(/* id 26, wireType 0 =*/208).int32(message.payPeriodType);
                        if (message.dayOfMonthToStartPayPeriod != null && Object.hasOwnProperty.call(message, "dayOfMonthToStartPayPeriod"))
                            writer.uint32(/* id 27, wireType 0 =*/216).int32(message.dayOfMonthToStartPayPeriod);
                        if (message.recommendedMaxHoursPerWeekForPartTime != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerWeekForPartTime"))
                            writer.uint32(/* id 28, wireType 5 =*/229).float(message.recommendedMaxHoursPerWeekForPartTime);
                        if (message.recommendedMaxHoursPerMonthForPartTime != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerMonthForPartTime"))
                            writer.uint32(/* id 29, wireType 5 =*/237).float(message.recommendedMaxHoursPerMonthForPartTime);
                        if (message.enableOtCalculation != null && Object.hasOwnProperty.call(message, "enableOtCalculation"))
                            writer.uint32(/* id 30, wireType 0 =*/240).bool(message.enableOtCalculation);
                        if (message.partTimeOtPolicy != null && Object.hasOwnProperty.call(message, "partTimeOtPolicy"))
                            writer.uint32(/* id 31, wireType 0 =*/248).int32(message.partTimeOtPolicy);
                        if (message.fullTimeOtPolicy != null && Object.hasOwnProperty.call(message, "fullTimeOtPolicy"))
                            writer.uint32(/* id 32, wireType 0 =*/256).int32(message.fullTimeOtPolicy);
                        if (message.lockSchedulePeriodType != null && Object.hasOwnProperty.call(message, "lockSchedulePeriodType"))
                            writer.uint32(/* id 33, wireType 0 =*/264).int32(message.lockSchedulePeriodType);
                        if (message.lockSchedulePeriodAfterDays != null && Object.hasOwnProperty.call(message, "lockSchedulePeriodAfterDays"))
                            writer.uint32(/* id 34, wireType 0 =*/272).int32(message.lockSchedulePeriodAfterDays);
                        if (message.enableScheduleApprovalProcess != null && Object.hasOwnProperty.call(message, "enableScheduleApprovalProcess"))
                            writer.uint32(/* id 35, wireType 0 =*/280).bool(message.enableScheduleApprovalProcess);
                        if (message.scheduleApprovalPeriod != null && Object.hasOwnProperty.call(message, "scheduleApprovalPeriod"))
                            writer.uint32(/* id 36, wireType 0 =*/288).int32(message.scheduleApprovalPeriod);
                        if (message.enableMaxHoursPerWeekIncludeOtRule != null && Object.hasOwnProperty.call(message, "enableMaxHoursPerWeekIncludeOtRule"))
                            writer.uint32(/* id 37, wireType 0 =*/296).bool(message.enableMaxHoursPerWeekIncludeOtRule);
                        if (message.recommendedMaxHoursPerWeekIncludeOt != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerWeekIncludeOt"))
                            writer.uint32(/* id 38, wireType 5 =*/309).float(message.recommendedMaxHoursPerWeekIncludeOt);
                        if (message.fullTimeRatio != null && Object.hasOwnProperty.call(message, "fullTimeRatio"))
                            writer.uint32(/* id 39, wireType 1 =*/313).double(message.fullTimeRatio);
                        if (message.enableScheduleTemplateUsage != null && Object.hasOwnProperty.call(message, "enableScheduleTemplateUsage"))
                            writer.uint32(/* id 40, wireType 0 =*/320).bool(message.enableScheduleTemplateUsage);
                        if (message.disableRequiredStaffPosition != null && Object.hasOwnProperty.call(message, "disableRequiredStaffPosition"))
                            writer.uint32(/* id 41, wireType 0 =*/328).bool(message.disableRequiredStaffPosition);
                        if (message.allowStaffToClaimShift != null && Object.hasOwnProperty.call(message, "allowStaffToClaimShift"))
                            writer.uint32(/* id 42, wireType 0 =*/336).bool(message.allowStaffToClaimShift);
                        if (message.minStaffAtEachOperationHour != null && Object.hasOwnProperty.call(message, "minStaffAtEachOperationHour"))
                            writer.uint32(/* id 43, wireType 0 =*/344).int32(message.minStaffAtEachOperationHour);
                        if (message.enableAvailabilityReminder != null && Object.hasOwnProperty.call(message, "enableAvailabilityReminder"))
                            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.enableAvailabilityReminder);
                        if (message.availabilityReminderDaysOfWeek != null && message.availabilityReminderDaysOfWeek.length) {
                            writer.uint32(/* id 45, wireType 2 =*/362).fork();
                            for (var i = 0; i < message.availabilityReminderDaysOfWeek.length; ++i)
                                writer.int32(message.availabilityReminderDaysOfWeek[i]);
                            writer.ldelim();
                        }
                        if (message.availabilityReminderTime != null && Object.hasOwnProperty.call(message, "availabilityReminderTime"))
                            writer.uint32(/* id 46, wireType 2 =*/370).string(message.availabilityReminderTime);
                        if (message.allowStaffToSwapShift != null && Object.hasOwnProperty.call(message, "allowStaffToSwapShift"))
                            writer.uint32(/* id 47, wireType 0 =*/376).bool(message.allowStaffToSwapShift);
                        if (message.defaultWorkingHourPerDay != null && Object.hasOwnProperty.call(message, "defaultWorkingHourPerDay"))
                            writer.uint32(/* id 48, wireType 5 =*/389).float(message.defaultWorkingHourPerDay);
                        if (message.defaultStartTimeInDay != null && Object.hasOwnProperty.call(message, "defaultStartTimeInDay"))
                            writer.uint32(/* id 49, wireType 2 =*/394).string(message.defaultStartTimeInDay);
                        if (message.defaultEndTimeInDay != null && Object.hasOwnProperty.call(message, "defaultEndTimeInDay"))
                            writer.uint32(/* id 50, wireType 2 =*/402).string(message.defaultEndTimeInDay);
                        if (message.enableDayPartSummary != null && Object.hasOwnProperty.call(message, "enableDayPartSummary"))
                            writer.uint32(/* id 51, wireType 0 =*/408).bool(message.enableDayPartSummary);
                        if (message.highlightPtShiftsCrossMaxWorkingHours != null && Object.hasOwnProperty.call(message, "highlightPtShiftsCrossMaxWorkingHours"))
                            writer.uint32(/* id 52, wireType 0 =*/416).bool(message.highlightPtShiftsCrossMaxWorkingHours);
                        if (message.ptWorkingHoursThresholdForHighlight != null && Object.hasOwnProperty.call(message, "ptWorkingHoursThresholdForHighlight"))
                            writer.uint32(/* id 53, wireType 5 =*/429).float(message.ptWorkingHoursThresholdForHighlight);
                        if (message.defaultRequiredPosition != null && Object.hasOwnProperty.call(message, "defaultRequiredPosition"))
                            writer.uint32(/* id 54, wireType 0 =*/432).bool(message.defaultRequiredPosition);
                        if (message.allowStaffToRequestTimeOff != null && Object.hasOwnProperty.call(message, "allowStaffToRequestTimeOff"))
                            writer.uint32(/* id 55, wireType 0 =*/440).bool(message.allowStaffToRequestTimeOff);
                        if (message.allowAreaManagerEditBudget != null && Object.hasOwnProperty.call(message, "allowAreaManagerEditBudget"))
                            writer.uint32(/* id 56, wireType 0 =*/448).bool(message.allowAreaManagerEditBudget);
                        if (message.distributeBudgetHoursEvenlyByDefault != null && Object.hasOwnProperty.call(message, "distributeBudgetHoursEvenlyByDefault"))
                            writer.uint32(/* id 57, wireType 0 =*/456).bool(message.distributeBudgetHoursEvenlyByDefault);
                        if (message.allowEditStaffAreaStores != null && Object.hasOwnProperty.call(message, "allowEditStaffAreaStores"))
                            $root.palexy.streaming.v1.StoreFilter.encode(message.allowEditStaffAreaStores, writer.uint32(/* id 58, wireType 2 =*/466).fork()).ldelim();
                        if (message.enableStrictApprovalFlow != null && Object.hasOwnProperty.call(message, "enableStrictApprovalFlow"))
                            writer.uint32(/* id 59, wireType 0 =*/472).bool(message.enableStrictApprovalFlow);
                        if (message.nonCoveragePositionMappings != null && message.nonCoveragePositionMappings.length)
                            for (var i = 0; i < message.nonCoveragePositionMappings.length; ++i)
                                $root.palexy.protobuf.NonCoveragePositionMapping.encode(message.nonCoveragePositionMappings[i], writer.uint32(/* id 60, wireType 2 =*/482).fork()).ldelim();
                        if (message.skipApprovalOnMinimalChanges != null && Object.hasOwnProperty.call(message, "skipApprovalOnMinimalChanges"))
                            writer.uint32(/* id 61, wireType 0 =*/488).bool(message.skipApprovalOnMinimalChanges);
                        if (message.minimalChangesThresholdPercentage != null && Object.hasOwnProperty.call(message, "minimalChangesThresholdPercentage"))
                            writer.uint32(/* id 62, wireType 5 =*/501).float(message.minimalChangesThresholdPercentage);
                        if (message.allowExternalStaffEmploymentType != null && Object.hasOwnProperty.call(message, "allowExternalStaffEmploymentType"))
                            writer.uint32(/* id 63, wireType 0 =*/504).bool(message.allowExternalStaffEmploymentType);
                        if (message.maxAutoAdjustBudgetDecreasePercentage != null && Object.hasOwnProperty.call(message, "maxAutoAdjustBudgetDecreasePercentage"))
                            writer.uint32(/* id 64, wireType 5 =*/517).float(message.maxAutoAdjustBudgetDecreasePercentage);
                        if (message.strictBufferBetweenShifts != null && Object.hasOwnProperty.call(message, "strictBufferBetweenShifts"))
                            writer.uint32(/* id 65, wireType 0 =*/520).bool(message.strictBufferBetweenShifts);
                        if (message.enableWeeklyAvailabilityAutoLock != null && Object.hasOwnProperty.call(message, "enableWeeklyAvailabilityAutoLock"))
                            writer.uint32(/* id 66, wireType 0 =*/528).bool(message.enableWeeklyAvailabilityAutoLock);
                        if (message.availabilityAutoLockDayOfWeek != null && Object.hasOwnProperty.call(message, "availabilityAutoLockDayOfWeek"))
                            writer.uint32(/* id 67, wireType 0 =*/536).int32(message.availabilityAutoLockDayOfWeek);
                        if (message.showPaidHoursPositionIds != null && message.showPaidHoursPositionIds.length) {
                            writer.uint32(/* id 68, wireType 2 =*/546).fork();
                            for (var i = 0; i < message.showPaidHoursPositionIds.length; ++i)
                                writer.int64(message.showPaidHoursPositionIds[i]);
                            writer.ldelim();
                        }
                        if (message.disableEditNonCoverageAtShiftLevel != null && Object.hasOwnProperty.call(message, "disableEditNonCoverageAtShiftLevel"))
                            writer.uint32(/* id 69, wireType 0 =*/552).bool(message.disableEditNonCoverageAtShiftLevel);
                        if (message.enableBudgetPlanningTplhWarning != null && Object.hasOwnProperty.call(message, "enableBudgetPlanningTplhWarning"))
                            writer.uint32(/* id 70, wireType 0 =*/560).bool(message.enableBudgetPlanningTplhWarning);
                        if (message.disableEditBreakTimeAtShiftLevel != null && Object.hasOwnProperty.call(message, "disableEditBreakTimeAtShiftLevel"))
                            writer.uint32(/* id 71, wireType 0 =*/568).bool(message.disableEditBreakTimeAtShiftLevel);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffScheduleGeneralSetting message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffScheduleGeneralSetting.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSetting} message StaffScheduleGeneralSetting message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffScheduleGeneralSetting.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffScheduleGeneralSetting message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSetting} StaffScheduleGeneralSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffScheduleGeneralSetting.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffScheduleGeneralSetting();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.recommendedMaxHoursPerWeek = reader.float();
                                break;
                            case 4:
                                message.recommendedMaxHoursPerDay = reader.float();
                                break;
                            case 5:
                                message.recommendedMinHoursBetweenLongShifts = reader.float();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.usualNumOfShiftsPerStaffPerWeek = reader.int32();
                                break;
                            case 9:
                                message.recommendedMaxBreakTimePerDayPerStaffInMin = reader.int32();
                                break;
                            case 12:
                                if (!(message.ignoredPositionIdsForMetricCalculation && message.ignoredPositionIdsForMetricCalculation.length))
                                    message.ignoredPositionIdsForMetricCalculation = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ignoredPositionIdsForMetricCalculation.push(reader.int64());
                                } else
                                    message.ignoredPositionIdsForMetricCalculation.push(reader.int64());
                                break;
                            case 10:
                                message.recommendedMinDistanceFromShiftStartToBreakStartInMin = reader.int32();
                                break;
                            case 11:
                                message.recommendedMinDistanceFromShiftEndToBreakStartInMin = reader.int32();
                                break;
                            case 13:
                                message.enableMinHoursBetweenLongShiftsRule = reader.bool();
                                break;
                            case 14:
                                message.enableMaxBreakTimePerDayPerStaffRule = reader.bool();
                                break;
                            case 15:
                                message.enableMaxHoursPerDayRule = reader.bool();
                                break;
                            case 16:
                                message.enableMaxHoursPerWeekRule = reader.bool();
                                break;
                            case 17:
                                message.enableUnavailabilityOverlapRule = reader.bool();
                                break;
                            case 18:
                                message.enableHourNotCoveredRule = reader.bool();
                                break;
                            case 19:
                                message.enableLackOfStaffRule = reader.bool();
                                break;
                            case 20:
                                message.sendInvitationLanguage = reader.int32();
                                break;
                            case 21:
                                message.targetScheduleLaborCostRate = reader.float();
                                break;
                            case 22:
                                message.targetScheduleLaborCostRateVariability = reader.float();
                                break;
                            case 23:
                                message.treatPreferToWorkAsCanOnlyWorkByDefault = reader.bool();
                                break;
                            case 24:
                                message.timeOffTypeIdForAutoFill = reader.int64();
                                break;
                            case 25:
                                message.rotatingShiftForStaffBalanceByDefault = reader.bool();
                                break;
                            case 26:
                                message.payPeriodType = reader.int32();
                                break;
                            case 27:
                                message.dayOfMonthToStartPayPeriod = reader.int32();
                                break;
                            case 28:
                                message.recommendedMaxHoursPerWeekForPartTime = reader.float();
                                break;
                            case 35:
                                message.enableScheduleApprovalProcess = reader.bool();
                                break;
                            case 36:
                                message.scheduleApprovalPeriod = reader.int32();
                                break;
                            case 37:
                                message.enableMaxHoursPerWeekIncludeOtRule = reader.bool();
                                break;
                            case 38:
                                message.recommendedMaxHoursPerWeekIncludeOt = reader.float();
                                break;
                            case 29:
                                message.recommendedMaxHoursPerMonthForPartTime = reader.float();
                                break;
                            case 30:
                                message.enableOtCalculation = reader.bool();
                                break;
                            case 31:
                                message.partTimeOtPolicy = reader.int32();
                                break;
                            case 32:
                                message.fullTimeOtPolicy = reader.int32();
                                break;
                            case 33:
                                message.lockSchedulePeriodType = reader.int32();
                                break;
                            case 34:
                                message.lockSchedulePeriodAfterDays = reader.int32();
                                break;
                            case 39:
                                message.fullTimeRatio = reader.double();
                                break;
                            case 40:
                                message.enableScheduleTemplateUsage = reader.bool();
                                break;
                            case 41:
                                message.disableRequiredStaffPosition = reader.bool();
                                break;
                            case 42:
                                message.allowStaffToClaimShift = reader.bool();
                                break;
                            case 43:
                                message.minStaffAtEachOperationHour = reader.int32();
                                break;
                            case 47:
                                message.allowStaffToSwapShift = reader.bool();
                                break;
                            case 44:
                                message.enableAvailabilityReminder = reader.bool();
                                break;
                            case 45:
                                if (!(message.availabilityReminderDaysOfWeek && message.availabilityReminderDaysOfWeek.length))
                                    message.availabilityReminderDaysOfWeek = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.availabilityReminderDaysOfWeek.push(reader.int32());
                                } else
                                    message.availabilityReminderDaysOfWeek.push(reader.int32());
                                break;
                            case 46:
                                message.availabilityReminderTime = reader.string();
                                break;
                            case 51:
                                message.enableDayPartSummary = reader.bool();
                                break;
                            case 48:
                                message.defaultWorkingHourPerDay = reader.float();
                                break;
                            case 49:
                                message.defaultStartTimeInDay = reader.string();
                                break;
                            case 50:
                                message.defaultEndTimeInDay = reader.string();
                                break;
                            case 52:
                                message.highlightPtShiftsCrossMaxWorkingHours = reader.bool();
                                break;
                            case 53:
                                message.ptWorkingHoursThresholdForHighlight = reader.float();
                                break;
                            case 54:
                                message.defaultRequiredPosition = reader.bool();
                                break;
                            case 55:
                                message.allowStaffToRequestTimeOff = reader.bool();
                                break;
                            case 56:
                                message.allowAreaManagerEditBudget = reader.bool();
                                break;
                            case 57:
                                message.distributeBudgetHoursEvenlyByDefault = reader.bool();
                                break;
                            case 58:
                                message.allowEditStaffAreaStores = $root.palexy.streaming.v1.StoreFilter.decode(reader, reader.uint32());
                                break;
                            case 59:
                                message.enableStrictApprovalFlow = reader.bool();
                                break;
                            case 60:
                                if (!(message.nonCoveragePositionMappings && message.nonCoveragePositionMappings.length))
                                    message.nonCoveragePositionMappings = [];
                                message.nonCoveragePositionMappings.push($root.palexy.protobuf.NonCoveragePositionMapping.decode(reader, reader.uint32()));
                                break;
                            case 61:
                                message.skipApprovalOnMinimalChanges = reader.bool();
                                break;
                            case 62:
                                message.minimalChangesThresholdPercentage = reader.float();
                                break;
                            case 63:
                                message.allowExternalStaffEmploymentType = reader.bool();
                                break;
                            case 64:
                                message.maxAutoAdjustBudgetDecreasePercentage = reader.float();
                                break;
                            case 65:
                                message.strictBufferBetweenShifts = reader.bool();
                                break;
                            case 66:
                                message.enableWeeklyAvailabilityAutoLock = reader.bool();
                                break;
                            case 67:
                                message.availabilityAutoLockDayOfWeek = reader.int32();
                                break;
                            case 68:
                                if (!(message.showPaidHoursPositionIds && message.showPaidHoursPositionIds.length))
                                    message.showPaidHoursPositionIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.showPaidHoursPositionIds.push(reader.int64());
                                } else
                                    message.showPaidHoursPositionIds.push(reader.int64());
                                break;
                            case 69:
                                message.disableEditNonCoverageAtShiftLevel = reader.bool();
                                break;
                            case 70:
                                message.enableBudgetPlanningTplhWarning = reader.bool();
                                break;
                            case 71:
                                message.disableEditBreakTimeAtShiftLevel = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffScheduleGeneralSetting message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSetting} StaffScheduleGeneralSetting
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffScheduleGeneralSetting.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffScheduleGeneralSetting message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffScheduleGeneralSetting.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.recommendedMaxHoursPerWeek != null && message.hasOwnProperty("recommendedMaxHoursPerWeek"))
                            if (typeof message.recommendedMaxHoursPerWeek !== "number")
                                return "recommendedMaxHoursPerWeek: number expected";
                        if (message.recommendedMaxHoursPerDay != null && message.hasOwnProperty("recommendedMaxHoursPerDay"))
                            if (typeof message.recommendedMaxHoursPerDay !== "number")
                                return "recommendedMaxHoursPerDay: number expected";
                        if (message.recommendedMinHoursBetweenLongShifts != null && message.hasOwnProperty("recommendedMinHoursBetweenLongShifts"))
                            if (typeof message.recommendedMinHoursBetweenLongShifts !== "number")
                                return "recommendedMinHoursBetweenLongShifts: number expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.usualNumOfShiftsPerStaffPerWeek != null && message.hasOwnProperty("usualNumOfShiftsPerStaffPerWeek"))
                            if (!$util.isInteger(message.usualNumOfShiftsPerStaffPerWeek))
                                return "usualNumOfShiftsPerStaffPerWeek: integer expected";
                        if (message.recommendedMaxBreakTimePerDayPerStaffInMin != null && message.hasOwnProperty("recommendedMaxBreakTimePerDayPerStaffInMin"))
                            if (!$util.isInteger(message.recommendedMaxBreakTimePerDayPerStaffInMin))
                                return "recommendedMaxBreakTimePerDayPerStaffInMin: integer expected";
                        if (message.ignoredPositionIdsForMetricCalculation != null && message.hasOwnProperty("ignoredPositionIdsForMetricCalculation")) {
                            if (!Array.isArray(message.ignoredPositionIdsForMetricCalculation))
                                return "ignoredPositionIdsForMetricCalculation: array expected";
                            for (var i = 0; i < message.ignoredPositionIdsForMetricCalculation.length; ++i)
                                if (!$util.isInteger(message.ignoredPositionIdsForMetricCalculation[i]) && !(message.ignoredPositionIdsForMetricCalculation[i] && $util.isInteger(message.ignoredPositionIdsForMetricCalculation[i].low) && $util.isInteger(message.ignoredPositionIdsForMetricCalculation[i].high)))
                                    return "ignoredPositionIdsForMetricCalculation: integer|Long[] expected";
                        }
                        if (message.recommendedMinDistanceFromShiftStartToBreakStartInMin != null && message.hasOwnProperty("recommendedMinDistanceFromShiftStartToBreakStartInMin"))
                            if (!$util.isInteger(message.recommendedMinDistanceFromShiftStartToBreakStartInMin))
                                return "recommendedMinDistanceFromShiftStartToBreakStartInMin: integer expected";
                        if (message.recommendedMinDistanceFromShiftEndToBreakStartInMin != null && message.hasOwnProperty("recommendedMinDistanceFromShiftEndToBreakStartInMin"))
                            if (!$util.isInteger(message.recommendedMinDistanceFromShiftEndToBreakStartInMin))
                                return "recommendedMinDistanceFromShiftEndToBreakStartInMin: integer expected";
                        if (message.enableMinHoursBetweenLongShiftsRule != null && message.hasOwnProperty("enableMinHoursBetweenLongShiftsRule"))
                            if (typeof message.enableMinHoursBetweenLongShiftsRule !== "boolean")
                                return "enableMinHoursBetweenLongShiftsRule: boolean expected";
                        if (message.enableMaxBreakTimePerDayPerStaffRule != null && message.hasOwnProperty("enableMaxBreakTimePerDayPerStaffRule"))
                            if (typeof message.enableMaxBreakTimePerDayPerStaffRule !== "boolean")
                                return "enableMaxBreakTimePerDayPerStaffRule: boolean expected";
                        if (message.enableMaxHoursPerDayRule != null && message.hasOwnProperty("enableMaxHoursPerDayRule"))
                            if (typeof message.enableMaxHoursPerDayRule !== "boolean")
                                return "enableMaxHoursPerDayRule: boolean expected";
                        if (message.enableMaxHoursPerWeekRule != null && message.hasOwnProperty("enableMaxHoursPerWeekRule"))
                            if (typeof message.enableMaxHoursPerWeekRule !== "boolean")
                                return "enableMaxHoursPerWeekRule: boolean expected";
                        if (message.enableUnavailabilityOverlapRule != null && message.hasOwnProperty("enableUnavailabilityOverlapRule"))
                            if (typeof message.enableUnavailabilityOverlapRule !== "boolean")
                                return "enableUnavailabilityOverlapRule: boolean expected";
                        if (message.enableHourNotCoveredRule != null && message.hasOwnProperty("enableHourNotCoveredRule"))
                            if (typeof message.enableHourNotCoveredRule !== "boolean")
                                return "enableHourNotCoveredRule: boolean expected";
                        if (message.enableLackOfStaffRule != null && message.hasOwnProperty("enableLackOfStaffRule"))
                            if (typeof message.enableLackOfStaffRule !== "boolean")
                                return "enableLackOfStaffRule: boolean expected";
                        if (message.sendInvitationLanguage != null && message.hasOwnProperty("sendInvitationLanguage"))
                            switch (message.sendInvitationLanguage) {
                            default:
                                return "sendInvitationLanguage: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.targetScheduleLaborCostRate != null && message.hasOwnProperty("targetScheduleLaborCostRate"))
                            if (typeof message.targetScheduleLaborCostRate !== "number")
                                return "targetScheduleLaborCostRate: number expected";
                        if (message.targetScheduleLaborCostRateVariability != null && message.hasOwnProperty("targetScheduleLaborCostRateVariability"))
                            if (typeof message.targetScheduleLaborCostRateVariability !== "number")
                                return "targetScheduleLaborCostRateVariability: number expected";
                        if (message.treatPreferToWorkAsCanOnlyWorkByDefault != null && message.hasOwnProperty("treatPreferToWorkAsCanOnlyWorkByDefault"))
                            if (typeof message.treatPreferToWorkAsCanOnlyWorkByDefault !== "boolean")
                                return "treatPreferToWorkAsCanOnlyWorkByDefault: boolean expected";
                        if (message.timeOffTypeIdForAutoFill != null && message.hasOwnProperty("timeOffTypeIdForAutoFill"))
                            if (!$util.isInteger(message.timeOffTypeIdForAutoFill) && !(message.timeOffTypeIdForAutoFill && $util.isInteger(message.timeOffTypeIdForAutoFill.low) && $util.isInteger(message.timeOffTypeIdForAutoFill.high)))
                                return "timeOffTypeIdForAutoFill: integer|Long expected";
                        if (message.rotatingShiftForStaffBalanceByDefault != null && message.hasOwnProperty("rotatingShiftForStaffBalanceByDefault"))
                            if (typeof message.rotatingShiftForStaffBalanceByDefault !== "boolean")
                                return "rotatingShiftForStaffBalanceByDefault: boolean expected";
                        if (message.payPeriodType != null && message.hasOwnProperty("payPeriodType"))
                            switch (message.payPeriodType) {
                            default:
                                return "payPeriodType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                            if (!$util.isInteger(message.dayOfMonthToStartPayPeriod))
                                return "dayOfMonthToStartPayPeriod: integer expected";
                        if (message.recommendedMaxHoursPerWeekForPartTime != null && message.hasOwnProperty("recommendedMaxHoursPerWeekForPartTime"))
                            if (typeof message.recommendedMaxHoursPerWeekForPartTime !== "number")
                                return "recommendedMaxHoursPerWeekForPartTime: number expected";
                        if (message.enableScheduleApprovalProcess != null && message.hasOwnProperty("enableScheduleApprovalProcess"))
                            if (typeof message.enableScheduleApprovalProcess !== "boolean")
                                return "enableScheduleApprovalProcess: boolean expected";
                        if (message.scheduleApprovalPeriod != null && message.hasOwnProperty("scheduleApprovalPeriod"))
                            switch (message.scheduleApprovalPeriod) {
                            default:
                                return "scheduleApprovalPeriod: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.enableMaxHoursPerWeekIncludeOtRule != null && message.hasOwnProperty("enableMaxHoursPerWeekIncludeOtRule"))
                            if (typeof message.enableMaxHoursPerWeekIncludeOtRule !== "boolean")
                                return "enableMaxHoursPerWeekIncludeOtRule: boolean expected";
                        if (message.recommendedMaxHoursPerWeekIncludeOt != null && message.hasOwnProperty("recommendedMaxHoursPerWeekIncludeOt"))
                            if (typeof message.recommendedMaxHoursPerWeekIncludeOt !== "number")
                                return "recommendedMaxHoursPerWeekIncludeOt: number expected";
                        if (message.recommendedMaxHoursPerMonthForPartTime != null && message.hasOwnProperty("recommendedMaxHoursPerMonthForPartTime"))
                            if (typeof message.recommendedMaxHoursPerMonthForPartTime !== "number")
                                return "recommendedMaxHoursPerMonthForPartTime: number expected";
                        if (message.enableOtCalculation != null && message.hasOwnProperty("enableOtCalculation"))
                            if (typeof message.enableOtCalculation !== "boolean")
                                return "enableOtCalculation: boolean expected";
                        if (message.partTimeOtPolicy != null && message.hasOwnProperty("partTimeOtPolicy"))
                            switch (message.partTimeOtPolicy) {
                            default:
                                return "partTimeOtPolicy: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.fullTimeOtPolicy != null && message.hasOwnProperty("fullTimeOtPolicy"))
                            switch (message.fullTimeOtPolicy) {
                            default:
                                return "fullTimeOtPolicy: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.lockSchedulePeriodType != null && message.hasOwnProperty("lockSchedulePeriodType"))
                            switch (message.lockSchedulePeriodType) {
                            default:
                                return "lockSchedulePeriodType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.lockSchedulePeriodAfterDays != null && message.hasOwnProperty("lockSchedulePeriodAfterDays"))
                            if (!$util.isInteger(message.lockSchedulePeriodAfterDays))
                                return "lockSchedulePeriodAfterDays: integer expected";
                        if (message.fullTimeRatio != null && message.hasOwnProperty("fullTimeRatio"))
                            if (typeof message.fullTimeRatio !== "number")
                                return "fullTimeRatio: number expected";
                        if (message.enableScheduleTemplateUsage != null && message.hasOwnProperty("enableScheduleTemplateUsage"))
                            if (typeof message.enableScheduleTemplateUsage !== "boolean")
                                return "enableScheduleTemplateUsage: boolean expected";
                        if (message.disableRequiredStaffPosition != null && message.hasOwnProperty("disableRequiredStaffPosition"))
                            if (typeof message.disableRequiredStaffPosition !== "boolean")
                                return "disableRequiredStaffPosition: boolean expected";
                        if (message.allowStaffToClaimShift != null && message.hasOwnProperty("allowStaffToClaimShift"))
                            if (typeof message.allowStaffToClaimShift !== "boolean")
                                return "allowStaffToClaimShift: boolean expected";
                        if (message.minStaffAtEachOperationHour != null && message.hasOwnProperty("minStaffAtEachOperationHour"))
                            if (!$util.isInteger(message.minStaffAtEachOperationHour))
                                return "minStaffAtEachOperationHour: integer expected";
                        if (message.allowStaffToSwapShift != null && message.hasOwnProperty("allowStaffToSwapShift"))
                            if (typeof message.allowStaffToSwapShift !== "boolean")
                                return "allowStaffToSwapShift: boolean expected";
                        if (message.enableAvailabilityReminder != null && message.hasOwnProperty("enableAvailabilityReminder"))
                            if (typeof message.enableAvailabilityReminder !== "boolean")
                                return "enableAvailabilityReminder: boolean expected";
                        if (message.availabilityReminderDaysOfWeek != null && message.hasOwnProperty("availabilityReminderDaysOfWeek")) {
                            if (!Array.isArray(message.availabilityReminderDaysOfWeek))
                                return "availabilityReminderDaysOfWeek: array expected";
                            for (var i = 0; i < message.availabilityReminderDaysOfWeek.length; ++i)
                                switch (message.availabilityReminderDaysOfWeek[i]) {
                                default:
                                    return "availabilityReminderDaysOfWeek: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                    break;
                                }
                        }
                        if (message.availabilityReminderTime != null && message.hasOwnProperty("availabilityReminderTime"))
                            if (!$util.isString(message.availabilityReminderTime))
                                return "availabilityReminderTime: string expected";
                        if (message.enableDayPartSummary != null && message.hasOwnProperty("enableDayPartSummary"))
                            if (typeof message.enableDayPartSummary !== "boolean")
                                return "enableDayPartSummary: boolean expected";
                        if (message.defaultWorkingHourPerDay != null && message.hasOwnProperty("defaultWorkingHourPerDay"))
                            if (typeof message.defaultWorkingHourPerDay !== "number")
                                return "defaultWorkingHourPerDay: number expected";
                        if (message.defaultStartTimeInDay != null && message.hasOwnProperty("defaultStartTimeInDay"))
                            if (!$util.isString(message.defaultStartTimeInDay))
                                return "defaultStartTimeInDay: string expected";
                        if (message.defaultEndTimeInDay != null && message.hasOwnProperty("defaultEndTimeInDay"))
                            if (!$util.isString(message.defaultEndTimeInDay))
                                return "defaultEndTimeInDay: string expected";
                        if (message.highlightPtShiftsCrossMaxWorkingHours != null && message.hasOwnProperty("highlightPtShiftsCrossMaxWorkingHours"))
                            if (typeof message.highlightPtShiftsCrossMaxWorkingHours !== "boolean")
                                return "highlightPtShiftsCrossMaxWorkingHours: boolean expected";
                        if (message.ptWorkingHoursThresholdForHighlight != null && message.hasOwnProperty("ptWorkingHoursThresholdForHighlight"))
                            if (typeof message.ptWorkingHoursThresholdForHighlight !== "number")
                                return "ptWorkingHoursThresholdForHighlight: number expected";
                        if (message.defaultRequiredPosition != null && message.hasOwnProperty("defaultRequiredPosition"))
                            if (typeof message.defaultRequiredPosition !== "boolean")
                                return "defaultRequiredPosition: boolean expected";
                        if (message.allowStaffToRequestTimeOff != null && message.hasOwnProperty("allowStaffToRequestTimeOff"))
                            if (typeof message.allowStaffToRequestTimeOff !== "boolean")
                                return "allowStaffToRequestTimeOff: boolean expected";
                        if (message.allowAreaManagerEditBudget != null && message.hasOwnProperty("allowAreaManagerEditBudget"))
                            if (typeof message.allowAreaManagerEditBudget !== "boolean")
                                return "allowAreaManagerEditBudget: boolean expected";
                        if (message.distributeBudgetHoursEvenlyByDefault != null && message.hasOwnProperty("distributeBudgetHoursEvenlyByDefault"))
                            if (typeof message.distributeBudgetHoursEvenlyByDefault !== "boolean")
                                return "distributeBudgetHoursEvenlyByDefault: boolean expected";
                        if (message.allowEditStaffAreaStores != null && message.hasOwnProperty("allowEditStaffAreaStores")) {
                            properties._allowEditStaffAreaStores = 1;
                            {
                                var error = $root.palexy.streaming.v1.StoreFilter.verify(message.allowEditStaffAreaStores);
                                if (error)
                                    return "allowEditStaffAreaStores." + error;
                            }
                        }
                        if (message.enableStrictApprovalFlow != null && message.hasOwnProperty("enableStrictApprovalFlow"))
                            if (typeof message.enableStrictApprovalFlow !== "boolean")
                                return "enableStrictApprovalFlow: boolean expected";
                        if (message.nonCoveragePositionMappings != null && message.hasOwnProperty("nonCoveragePositionMappings")) {
                            if (!Array.isArray(message.nonCoveragePositionMappings))
                                return "nonCoveragePositionMappings: array expected";
                            for (var i = 0; i < message.nonCoveragePositionMappings.length; ++i) {
                                var error = $root.palexy.protobuf.NonCoveragePositionMapping.verify(message.nonCoveragePositionMappings[i]);
                                if (error)
                                    return "nonCoveragePositionMappings." + error;
                            }
                        }
                        if (message.skipApprovalOnMinimalChanges != null && message.hasOwnProperty("skipApprovalOnMinimalChanges"))
                            if (typeof message.skipApprovalOnMinimalChanges !== "boolean")
                                return "skipApprovalOnMinimalChanges: boolean expected";
                        if (message.minimalChangesThresholdPercentage != null && message.hasOwnProperty("minimalChangesThresholdPercentage"))
                            if (typeof message.minimalChangesThresholdPercentage !== "number")
                                return "minimalChangesThresholdPercentage: number expected";
                        if (message.allowExternalStaffEmploymentType != null && message.hasOwnProperty("allowExternalStaffEmploymentType"))
                            if (typeof message.allowExternalStaffEmploymentType !== "boolean")
                                return "allowExternalStaffEmploymentType: boolean expected";
                        if (message.maxAutoAdjustBudgetDecreasePercentage != null && message.hasOwnProperty("maxAutoAdjustBudgetDecreasePercentage"))
                            if (typeof message.maxAutoAdjustBudgetDecreasePercentage !== "number")
                                return "maxAutoAdjustBudgetDecreasePercentage: number expected";
                        if (message.strictBufferBetweenShifts != null && message.hasOwnProperty("strictBufferBetweenShifts"))
                            if (typeof message.strictBufferBetweenShifts !== "boolean")
                                return "strictBufferBetweenShifts: boolean expected";
                        if (message.enableWeeklyAvailabilityAutoLock != null && message.hasOwnProperty("enableWeeklyAvailabilityAutoLock"))
                            if (typeof message.enableWeeklyAvailabilityAutoLock !== "boolean")
                                return "enableWeeklyAvailabilityAutoLock: boolean expected";
                        if (message.availabilityAutoLockDayOfWeek != null && message.hasOwnProperty("availabilityAutoLockDayOfWeek"))
                            switch (message.availabilityAutoLockDayOfWeek) {
                            default:
                                return "availabilityAutoLockDayOfWeek: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.showPaidHoursPositionIds != null && message.hasOwnProperty("showPaidHoursPositionIds")) {
                            if (!Array.isArray(message.showPaidHoursPositionIds))
                                return "showPaidHoursPositionIds: array expected";
                            for (var i = 0; i < message.showPaidHoursPositionIds.length; ++i)
                                if (!$util.isInteger(message.showPaidHoursPositionIds[i]) && !(message.showPaidHoursPositionIds[i] && $util.isInteger(message.showPaidHoursPositionIds[i].low) && $util.isInteger(message.showPaidHoursPositionIds[i].high)))
                                    return "showPaidHoursPositionIds: integer|Long[] expected";
                        }
                        if (message.disableEditNonCoverageAtShiftLevel != null && message.hasOwnProperty("disableEditNonCoverageAtShiftLevel"))
                            if (typeof message.disableEditNonCoverageAtShiftLevel !== "boolean")
                                return "disableEditNonCoverageAtShiftLevel: boolean expected";
                        if (message.enableBudgetPlanningTplhWarning != null && message.hasOwnProperty("enableBudgetPlanningTplhWarning"))
                            if (typeof message.enableBudgetPlanningTplhWarning !== "boolean")
                                return "enableBudgetPlanningTplhWarning: boolean expected";
                        if (message.disableEditBreakTimeAtShiftLevel != null && message.hasOwnProperty("disableEditBreakTimeAtShiftLevel"))
                            if (typeof message.disableEditBreakTimeAtShiftLevel !== "boolean")
                                return "disableEditBreakTimeAtShiftLevel: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffScheduleGeneralSetting message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSetting} StaffScheduleGeneralSetting
                     */
                    StaffScheduleGeneralSetting.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffScheduleGeneralSetting)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffScheduleGeneralSetting();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.recommendedMaxHoursPerWeek != null)
                            message.recommendedMaxHoursPerWeek = Number(object.recommendedMaxHoursPerWeek);
                        if (object.recommendedMaxHoursPerDay != null)
                            message.recommendedMaxHoursPerDay = Number(object.recommendedMaxHoursPerDay);
                        if (object.recommendedMinHoursBetweenLongShifts != null)
                            message.recommendedMinHoursBetweenLongShifts = Number(object.recommendedMinHoursBetweenLongShifts);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.usualNumOfShiftsPerStaffPerWeek != null)
                            message.usualNumOfShiftsPerStaffPerWeek = object.usualNumOfShiftsPerStaffPerWeek | 0;
                        if (object.recommendedMaxBreakTimePerDayPerStaffInMin != null)
                            message.recommendedMaxBreakTimePerDayPerStaffInMin = object.recommendedMaxBreakTimePerDayPerStaffInMin | 0;
                        if (object.ignoredPositionIdsForMetricCalculation) {
                            if (!Array.isArray(object.ignoredPositionIdsForMetricCalculation))
                                throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.ignoredPositionIdsForMetricCalculation: array expected");
                            message.ignoredPositionIdsForMetricCalculation = [];
                            for (var i = 0; i < object.ignoredPositionIdsForMetricCalculation.length; ++i)
                                if ($util.Long)
                                    (message.ignoredPositionIdsForMetricCalculation[i] = $util.Long.fromValue(object.ignoredPositionIdsForMetricCalculation[i])).unsigned = false;
                                else if (typeof object.ignoredPositionIdsForMetricCalculation[i] === "string")
                                    message.ignoredPositionIdsForMetricCalculation[i] = parseInt(object.ignoredPositionIdsForMetricCalculation[i], 10);
                                else if (typeof object.ignoredPositionIdsForMetricCalculation[i] === "number")
                                    message.ignoredPositionIdsForMetricCalculation[i] = object.ignoredPositionIdsForMetricCalculation[i];
                                else if (typeof object.ignoredPositionIdsForMetricCalculation[i] === "object")
                                    message.ignoredPositionIdsForMetricCalculation[i] = new $util.LongBits(object.ignoredPositionIdsForMetricCalculation[i].low >>> 0, object.ignoredPositionIdsForMetricCalculation[i].high >>> 0).toNumber();
                        }
                        if (object.recommendedMinDistanceFromShiftStartToBreakStartInMin != null)
                            message.recommendedMinDistanceFromShiftStartToBreakStartInMin = object.recommendedMinDistanceFromShiftStartToBreakStartInMin | 0;
                        if (object.recommendedMinDistanceFromShiftEndToBreakStartInMin != null)
                            message.recommendedMinDistanceFromShiftEndToBreakStartInMin = object.recommendedMinDistanceFromShiftEndToBreakStartInMin | 0;
                        if (object.enableMinHoursBetweenLongShiftsRule != null)
                            message.enableMinHoursBetweenLongShiftsRule = Boolean(object.enableMinHoursBetweenLongShiftsRule);
                        if (object.enableMaxBreakTimePerDayPerStaffRule != null)
                            message.enableMaxBreakTimePerDayPerStaffRule = Boolean(object.enableMaxBreakTimePerDayPerStaffRule);
                        if (object.enableMaxHoursPerDayRule != null)
                            message.enableMaxHoursPerDayRule = Boolean(object.enableMaxHoursPerDayRule);
                        if (object.enableMaxHoursPerWeekRule != null)
                            message.enableMaxHoursPerWeekRule = Boolean(object.enableMaxHoursPerWeekRule);
                        if (object.enableUnavailabilityOverlapRule != null)
                            message.enableUnavailabilityOverlapRule = Boolean(object.enableUnavailabilityOverlapRule);
                        if (object.enableHourNotCoveredRule != null)
                            message.enableHourNotCoveredRule = Boolean(object.enableHourNotCoveredRule);
                        if (object.enableLackOfStaffRule != null)
                            message.enableLackOfStaffRule = Boolean(object.enableLackOfStaffRule);
                        switch (object.sendInvitationLanguage) {
                        case "en":
                        case 0:
                            message.sendInvitationLanguage = 0;
                            break;
                        case "vi":
                        case 1:
                            message.sendInvitationLanguage = 1;
                            break;
                        case "th":
                        case 2:
                            message.sendInvitationLanguage = 2;
                            break;
                        case "ja":
                        case 3:
                            message.sendInvitationLanguage = 3;
                            break;
                        case "zh_hans":
                        case 4:
                            message.sendInvitationLanguage = 4;
                            break;
                        case "zh_hant":
                        case 5:
                            message.sendInvitationLanguage = 5;
                            break;
                        case "ko":
                        case 6:
                            message.sendInvitationLanguage = 6;
                            break;
                        case "id":
                        case 7:
                            message.sendInvitationLanguage = 7;
                            break;
                        }
                        if (object.targetScheduleLaborCostRate != null)
                            message.targetScheduleLaborCostRate = Number(object.targetScheduleLaborCostRate);
                        if (object.targetScheduleLaborCostRateVariability != null)
                            message.targetScheduleLaborCostRateVariability = Number(object.targetScheduleLaborCostRateVariability);
                        if (object.treatPreferToWorkAsCanOnlyWorkByDefault != null)
                            message.treatPreferToWorkAsCanOnlyWorkByDefault = Boolean(object.treatPreferToWorkAsCanOnlyWorkByDefault);
                        if (object.timeOffTypeIdForAutoFill != null)
                            if ($util.Long)
                                (message.timeOffTypeIdForAutoFill = $util.Long.fromValue(object.timeOffTypeIdForAutoFill)).unsigned = false;
                            else if (typeof object.timeOffTypeIdForAutoFill === "string")
                                message.timeOffTypeIdForAutoFill = parseInt(object.timeOffTypeIdForAutoFill, 10);
                            else if (typeof object.timeOffTypeIdForAutoFill === "number")
                                message.timeOffTypeIdForAutoFill = object.timeOffTypeIdForAutoFill;
                            else if (typeof object.timeOffTypeIdForAutoFill === "object")
                                message.timeOffTypeIdForAutoFill = new $util.LongBits(object.timeOffTypeIdForAutoFill.low >>> 0, object.timeOffTypeIdForAutoFill.high >>> 0).toNumber();
                        if (object.rotatingShiftForStaffBalanceByDefault != null)
                            message.rotatingShiftForStaffBalanceByDefault = Boolean(object.rotatingShiftForStaffBalanceByDefault);
                        switch (object.payPeriodType) {
                        case "PAY_PERIOD_UNSPECIFIED":
                        case 0:
                            message.payPeriodType = 0;
                            break;
                        case "MONTHLY":
                        case 1:
                            message.payPeriodType = 1;
                            break;
                        }
                        if (object.dayOfMonthToStartPayPeriod != null)
                            message.dayOfMonthToStartPayPeriod = object.dayOfMonthToStartPayPeriod | 0;
                        if (object.recommendedMaxHoursPerWeekForPartTime != null)
                            message.recommendedMaxHoursPerWeekForPartTime = Number(object.recommendedMaxHoursPerWeekForPartTime);
                        if (object.enableScheduleApprovalProcess != null)
                            message.enableScheduleApprovalProcess = Boolean(object.enableScheduleApprovalProcess);
                        switch (object.scheduleApprovalPeriod) {
                        case "SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED":
                        case 0:
                            message.scheduleApprovalPeriod = 0;
                            break;
                        case "SCHEDULE_APPROVAL_PERIOD_WEEKLY":
                        case 1:
                            message.scheduleApprovalPeriod = 1;
                            break;
                        case "SCHEDULE_APPROVAL_PERIOD_MONTHLY":
                        case 2:
                            message.scheduleApprovalPeriod = 2;
                            break;
                        }
                        if (object.enableMaxHoursPerWeekIncludeOtRule != null)
                            message.enableMaxHoursPerWeekIncludeOtRule = Boolean(object.enableMaxHoursPerWeekIncludeOtRule);
                        if (object.recommendedMaxHoursPerWeekIncludeOt != null)
                            message.recommendedMaxHoursPerWeekIncludeOt = Number(object.recommendedMaxHoursPerWeekIncludeOt);
                        if (object.recommendedMaxHoursPerMonthForPartTime != null)
                            message.recommendedMaxHoursPerMonthForPartTime = Number(object.recommendedMaxHoursPerMonthForPartTime);
                        if (object.enableOtCalculation != null)
                            message.enableOtCalculation = Boolean(object.enableOtCalculation);
                        switch (object.partTimeOtPolicy) {
                        case "PART_TIME_OT_POLICY_UNSPECIFIED":
                        case 0:
                            message.partTimeOtPolicy = 0;
                            break;
                        case "USE_MONTHLY_MAXIMUM":
                        case 1:
                            message.partTimeOtPolicy = 1;
                            break;
                        }
                        switch (object.fullTimeOtPolicy) {
                        case "FULL_TIME_OT_POLICY_UNSPECIFIED":
                        case 0:
                            message.fullTimeOtPolicy = 0;
                            break;
                        case "NONE":
                        case 1:
                            message.fullTimeOtPolicy = 1;
                            break;
                        case "USE_WEEKLY_MAXIMUM_TO_INFER_MONTHLY":
                        case 2:
                            message.fullTimeOtPolicy = 2;
                            break;
                        }
                        switch (object.lockSchedulePeriodType) {
                        case "LOCK_SCHEDULE_PERIOD_TYPE_UNSPECIFIED":
                        case 0:
                            message.lockSchedulePeriodType = 0;
                            break;
                        case "WEEK":
                        case 1:
                            message.lockSchedulePeriodType = 1;
                            break;
                        case "MONTH":
                        case 2:
                            message.lockSchedulePeriodType = 2;
                            break;
                        }
                        if (object.lockSchedulePeriodAfterDays != null)
                            message.lockSchedulePeriodAfterDays = object.lockSchedulePeriodAfterDays | 0;
                        if (object.fullTimeRatio != null)
                            message.fullTimeRatio = Number(object.fullTimeRatio);
                        if (object.enableScheduleTemplateUsage != null)
                            message.enableScheduleTemplateUsage = Boolean(object.enableScheduleTemplateUsage);
                        if (object.disableRequiredStaffPosition != null)
                            message.disableRequiredStaffPosition = Boolean(object.disableRequiredStaffPosition);
                        if (object.allowStaffToClaimShift != null)
                            message.allowStaffToClaimShift = Boolean(object.allowStaffToClaimShift);
                        if (object.minStaffAtEachOperationHour != null)
                            message.minStaffAtEachOperationHour = object.minStaffAtEachOperationHour | 0;
                        if (object.allowStaffToSwapShift != null)
                            message.allowStaffToSwapShift = Boolean(object.allowStaffToSwapShift);
                        if (object.enableAvailabilityReminder != null)
                            message.enableAvailabilityReminder = Boolean(object.enableAvailabilityReminder);
                        if (object.availabilityReminderDaysOfWeek) {
                            if (!Array.isArray(object.availabilityReminderDaysOfWeek))
                                throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.availabilityReminderDaysOfWeek: array expected");
                            message.availabilityReminderDaysOfWeek = [];
                            for (var i = 0; i < object.availabilityReminderDaysOfWeek.length; ++i)
                                switch (object.availabilityReminderDaysOfWeek[i]) {
                                default:
                                case "DAY_OF_WEEK_UNSPECIFIED":
                                case 0:
                                    message.availabilityReminderDaysOfWeek[i] = 0;
                                    break;
                                case "MONDAY":
                                case 1:
                                    message.availabilityReminderDaysOfWeek[i] = 1;
                                    break;
                                case "TUESDAY":
                                case 2:
                                    message.availabilityReminderDaysOfWeek[i] = 2;
                                    break;
                                case "WEDNESDAY":
                                case 3:
                                    message.availabilityReminderDaysOfWeek[i] = 3;
                                    break;
                                case "THURSDAY":
                                case 4:
                                    message.availabilityReminderDaysOfWeek[i] = 4;
                                    break;
                                case "FRIDAY":
                                case 5:
                                    message.availabilityReminderDaysOfWeek[i] = 5;
                                    break;
                                case "SATURDAY":
                                case 6:
                                    message.availabilityReminderDaysOfWeek[i] = 6;
                                    break;
                                case "SUNDAY":
                                case 7:
                                    message.availabilityReminderDaysOfWeek[i] = 7;
                                    break;
                                }
                        }
                        if (object.availabilityReminderTime != null)
                            message.availabilityReminderTime = String(object.availabilityReminderTime);
                        if (object.enableDayPartSummary != null)
                            message.enableDayPartSummary = Boolean(object.enableDayPartSummary);
                        if (object.defaultWorkingHourPerDay != null)
                            message.defaultWorkingHourPerDay = Number(object.defaultWorkingHourPerDay);
                        if (object.defaultStartTimeInDay != null)
                            message.defaultStartTimeInDay = String(object.defaultStartTimeInDay);
                        if (object.defaultEndTimeInDay != null)
                            message.defaultEndTimeInDay = String(object.defaultEndTimeInDay);
                        if (object.highlightPtShiftsCrossMaxWorkingHours != null)
                            message.highlightPtShiftsCrossMaxWorkingHours = Boolean(object.highlightPtShiftsCrossMaxWorkingHours);
                        if (object.ptWorkingHoursThresholdForHighlight != null)
                            message.ptWorkingHoursThresholdForHighlight = Number(object.ptWorkingHoursThresholdForHighlight);
                        if (object.defaultRequiredPosition != null)
                            message.defaultRequiredPosition = Boolean(object.defaultRequiredPosition);
                        if (object.allowStaffToRequestTimeOff != null)
                            message.allowStaffToRequestTimeOff = Boolean(object.allowStaffToRequestTimeOff);
                        if (object.allowAreaManagerEditBudget != null)
                            message.allowAreaManagerEditBudget = Boolean(object.allowAreaManagerEditBudget);
                        if (object.distributeBudgetHoursEvenlyByDefault != null)
                            message.distributeBudgetHoursEvenlyByDefault = Boolean(object.distributeBudgetHoursEvenlyByDefault);
                        if (object.allowEditStaffAreaStores != null) {
                            if (typeof object.allowEditStaffAreaStores !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.allowEditStaffAreaStores: object expected");
                            message.allowEditStaffAreaStores = $root.palexy.streaming.v1.StoreFilter.fromObject(object.allowEditStaffAreaStores);
                        }
                        if (object.enableStrictApprovalFlow != null)
                            message.enableStrictApprovalFlow = Boolean(object.enableStrictApprovalFlow);
                        if (object.nonCoveragePositionMappings) {
                            if (!Array.isArray(object.nonCoveragePositionMappings))
                                throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.nonCoveragePositionMappings: array expected");
                            message.nonCoveragePositionMappings = [];
                            for (var i = 0; i < object.nonCoveragePositionMappings.length; ++i) {
                                if (typeof object.nonCoveragePositionMappings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.nonCoveragePositionMappings: object expected");
                                message.nonCoveragePositionMappings[i] = $root.palexy.protobuf.NonCoveragePositionMapping.fromObject(object.nonCoveragePositionMappings[i]);
                            }
                        }
                        if (object.skipApprovalOnMinimalChanges != null)
                            message.skipApprovalOnMinimalChanges = Boolean(object.skipApprovalOnMinimalChanges);
                        if (object.minimalChangesThresholdPercentage != null)
                            message.minimalChangesThresholdPercentage = Number(object.minimalChangesThresholdPercentage);
                        if (object.allowExternalStaffEmploymentType != null)
                            message.allowExternalStaffEmploymentType = Boolean(object.allowExternalStaffEmploymentType);
                        if (object.maxAutoAdjustBudgetDecreasePercentage != null)
                            message.maxAutoAdjustBudgetDecreasePercentage = Number(object.maxAutoAdjustBudgetDecreasePercentage);
                        if (object.strictBufferBetweenShifts != null)
                            message.strictBufferBetweenShifts = Boolean(object.strictBufferBetweenShifts);
                        if (object.enableWeeklyAvailabilityAutoLock != null)
                            message.enableWeeklyAvailabilityAutoLock = Boolean(object.enableWeeklyAvailabilityAutoLock);
                        switch (object.availabilityAutoLockDayOfWeek) {
                        case "DAY_OF_WEEK_UNSPECIFIED":
                        case 0:
                            message.availabilityAutoLockDayOfWeek = 0;
                            break;
                        case "MONDAY":
                        case 1:
                            message.availabilityAutoLockDayOfWeek = 1;
                            break;
                        case "TUESDAY":
                        case 2:
                            message.availabilityAutoLockDayOfWeek = 2;
                            break;
                        case "WEDNESDAY":
                        case 3:
                            message.availabilityAutoLockDayOfWeek = 3;
                            break;
                        case "THURSDAY":
                        case 4:
                            message.availabilityAutoLockDayOfWeek = 4;
                            break;
                        case "FRIDAY":
                        case 5:
                            message.availabilityAutoLockDayOfWeek = 5;
                            break;
                        case "SATURDAY":
                        case 6:
                            message.availabilityAutoLockDayOfWeek = 6;
                            break;
                        case "SUNDAY":
                        case 7:
                            message.availabilityAutoLockDayOfWeek = 7;
                            break;
                        }
                        if (object.showPaidHoursPositionIds) {
                            if (!Array.isArray(object.showPaidHoursPositionIds))
                                throw TypeError(".palexy.streaming.v1.StaffScheduleGeneralSetting.showPaidHoursPositionIds: array expected");
                            message.showPaidHoursPositionIds = [];
                            for (var i = 0; i < object.showPaidHoursPositionIds.length; ++i)
                                if ($util.Long)
                                    (message.showPaidHoursPositionIds[i] = $util.Long.fromValue(object.showPaidHoursPositionIds[i])).unsigned = false;
                                else if (typeof object.showPaidHoursPositionIds[i] === "string")
                                    message.showPaidHoursPositionIds[i] = parseInt(object.showPaidHoursPositionIds[i], 10);
                                else if (typeof object.showPaidHoursPositionIds[i] === "number")
                                    message.showPaidHoursPositionIds[i] = object.showPaidHoursPositionIds[i];
                                else if (typeof object.showPaidHoursPositionIds[i] === "object")
                                    message.showPaidHoursPositionIds[i] = new $util.LongBits(object.showPaidHoursPositionIds[i].low >>> 0, object.showPaidHoursPositionIds[i].high >>> 0).toNumber();
                        }
                        if (object.disableEditNonCoverageAtShiftLevel != null)
                            message.disableEditNonCoverageAtShiftLevel = Boolean(object.disableEditNonCoverageAtShiftLevel);
                        if (object.enableBudgetPlanningTplhWarning != null)
                            message.enableBudgetPlanningTplhWarning = Boolean(object.enableBudgetPlanningTplhWarning);
                        if (object.disableEditBreakTimeAtShiftLevel != null)
                            message.disableEditBreakTimeAtShiftLevel = Boolean(object.disableEditBreakTimeAtShiftLevel);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffScheduleGeneralSetting message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @static
                     * @param {palexy.streaming.v1.StaffScheduleGeneralSetting} message StaffScheduleGeneralSetting
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffScheduleGeneralSetting.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.ignoredPositionIdsForMetricCalculation = [];
                            object.availabilityReminderDaysOfWeek = [];
                            object.nonCoveragePositionMappings = [];
                            object.showPaidHoursPositionIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.recommendedMaxHoursPerWeek = 0;
                            object.recommendedMaxHoursPerDay = 0;
                            object.recommendedMinHoursBetweenLongShifts = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.usualNumOfShiftsPerStaffPerWeek = 0;
                            object.recommendedMaxBreakTimePerDayPerStaffInMin = 0;
                            object.recommendedMinDistanceFromShiftStartToBreakStartInMin = 0;
                            object.recommendedMinDistanceFromShiftEndToBreakStartInMin = 0;
                            object.enableMinHoursBetweenLongShiftsRule = false;
                            object.enableMaxBreakTimePerDayPerStaffRule = false;
                            object.enableMaxHoursPerDayRule = false;
                            object.enableMaxHoursPerWeekRule = false;
                            object.enableUnavailabilityOverlapRule = false;
                            object.enableHourNotCoveredRule = false;
                            object.enableLackOfStaffRule = false;
                            object.sendInvitationLanguage = options.enums === String ? "en" : 0;
                            object.targetScheduleLaborCostRate = 0;
                            object.targetScheduleLaborCostRateVariability = 0;
                            object.treatPreferToWorkAsCanOnlyWorkByDefault = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeIdForAutoFill = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeIdForAutoFill = options.longs === String ? "0" : 0;
                            object.rotatingShiftForStaffBalanceByDefault = false;
                            object.payPeriodType = options.enums === String ? "PAY_PERIOD_UNSPECIFIED" : 0;
                            object.dayOfMonthToStartPayPeriod = 0;
                            object.recommendedMaxHoursPerWeekForPartTime = 0;
                            object.recommendedMaxHoursPerMonthForPartTime = 0;
                            object.enableOtCalculation = false;
                            object.partTimeOtPolicy = options.enums === String ? "PART_TIME_OT_POLICY_UNSPECIFIED" : 0;
                            object.fullTimeOtPolicy = options.enums === String ? "FULL_TIME_OT_POLICY_UNSPECIFIED" : 0;
                            object.lockSchedulePeriodType = options.enums === String ? "LOCK_SCHEDULE_PERIOD_TYPE_UNSPECIFIED" : 0;
                            object.lockSchedulePeriodAfterDays = 0;
                            object.enableScheduleApprovalProcess = false;
                            object.scheduleApprovalPeriod = options.enums === String ? "SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED" : 0;
                            object.enableMaxHoursPerWeekIncludeOtRule = false;
                            object.recommendedMaxHoursPerWeekIncludeOt = 0;
                            object.fullTimeRatio = 0;
                            object.enableScheduleTemplateUsage = false;
                            object.disableRequiredStaffPosition = false;
                            object.allowStaffToClaimShift = false;
                            object.minStaffAtEachOperationHour = 0;
                            object.enableAvailabilityReminder = false;
                            object.availabilityReminderTime = "";
                            object.allowStaffToSwapShift = false;
                            object.defaultWorkingHourPerDay = 0;
                            object.defaultStartTimeInDay = "";
                            object.defaultEndTimeInDay = "";
                            object.enableDayPartSummary = false;
                            object.highlightPtShiftsCrossMaxWorkingHours = false;
                            object.ptWorkingHoursThresholdForHighlight = 0;
                            object.defaultRequiredPosition = false;
                            object.allowStaffToRequestTimeOff = false;
                            object.allowAreaManagerEditBudget = false;
                            object.distributeBudgetHoursEvenlyByDefault = false;
                            object.enableStrictApprovalFlow = false;
                            object.skipApprovalOnMinimalChanges = false;
                            object.minimalChangesThresholdPercentage = 0;
                            object.allowExternalStaffEmploymentType = false;
                            object.maxAutoAdjustBudgetDecreasePercentage = 0;
                            object.strictBufferBetweenShifts = false;
                            object.enableWeeklyAvailabilityAutoLock = false;
                            object.availabilityAutoLockDayOfWeek = options.enums === String ? "DAY_OF_WEEK_UNSPECIFIED" : 0;
                            object.disableEditNonCoverageAtShiftLevel = false;
                            object.enableBudgetPlanningTplhWarning = false;
                            object.disableEditBreakTimeAtShiftLevel = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.recommendedMaxHoursPerWeek != null && message.hasOwnProperty("recommendedMaxHoursPerWeek"))
                            object.recommendedMaxHoursPerWeek = options.json && !isFinite(message.recommendedMaxHoursPerWeek) ? String(message.recommendedMaxHoursPerWeek) : message.recommendedMaxHoursPerWeek;
                        if (message.recommendedMaxHoursPerDay != null && message.hasOwnProperty("recommendedMaxHoursPerDay"))
                            object.recommendedMaxHoursPerDay = options.json && !isFinite(message.recommendedMaxHoursPerDay) ? String(message.recommendedMaxHoursPerDay) : message.recommendedMaxHoursPerDay;
                        if (message.recommendedMinHoursBetweenLongShifts != null && message.hasOwnProperty("recommendedMinHoursBetweenLongShifts"))
                            object.recommendedMinHoursBetweenLongShifts = options.json && !isFinite(message.recommendedMinHoursBetweenLongShifts) ? String(message.recommendedMinHoursBetweenLongShifts) : message.recommendedMinHoursBetweenLongShifts;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.usualNumOfShiftsPerStaffPerWeek != null && message.hasOwnProperty("usualNumOfShiftsPerStaffPerWeek"))
                            object.usualNumOfShiftsPerStaffPerWeek = message.usualNumOfShiftsPerStaffPerWeek;
                        if (message.recommendedMaxBreakTimePerDayPerStaffInMin != null && message.hasOwnProperty("recommendedMaxBreakTimePerDayPerStaffInMin"))
                            object.recommendedMaxBreakTimePerDayPerStaffInMin = message.recommendedMaxBreakTimePerDayPerStaffInMin;
                        if (message.recommendedMinDistanceFromShiftStartToBreakStartInMin != null && message.hasOwnProperty("recommendedMinDistanceFromShiftStartToBreakStartInMin"))
                            object.recommendedMinDistanceFromShiftStartToBreakStartInMin = message.recommendedMinDistanceFromShiftStartToBreakStartInMin;
                        if (message.recommendedMinDistanceFromShiftEndToBreakStartInMin != null && message.hasOwnProperty("recommendedMinDistanceFromShiftEndToBreakStartInMin"))
                            object.recommendedMinDistanceFromShiftEndToBreakStartInMin = message.recommendedMinDistanceFromShiftEndToBreakStartInMin;
                        if (message.ignoredPositionIdsForMetricCalculation && message.ignoredPositionIdsForMetricCalculation.length) {
                            object.ignoredPositionIdsForMetricCalculation = [];
                            for (var j = 0; j < message.ignoredPositionIdsForMetricCalculation.length; ++j)
                                if (typeof message.ignoredPositionIdsForMetricCalculation[j] === "number")
                                    object.ignoredPositionIdsForMetricCalculation[j] = options.longs === String ? String(message.ignoredPositionIdsForMetricCalculation[j]) : message.ignoredPositionIdsForMetricCalculation[j];
                                else
                                    object.ignoredPositionIdsForMetricCalculation[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ignoredPositionIdsForMetricCalculation[j]) : options.longs === Number ? new $util.LongBits(message.ignoredPositionIdsForMetricCalculation[j].low >>> 0, message.ignoredPositionIdsForMetricCalculation[j].high >>> 0).toNumber() : message.ignoredPositionIdsForMetricCalculation[j];
                        }
                        if (message.enableMinHoursBetweenLongShiftsRule != null && message.hasOwnProperty("enableMinHoursBetweenLongShiftsRule"))
                            object.enableMinHoursBetweenLongShiftsRule = message.enableMinHoursBetweenLongShiftsRule;
                        if (message.enableMaxBreakTimePerDayPerStaffRule != null && message.hasOwnProperty("enableMaxBreakTimePerDayPerStaffRule"))
                            object.enableMaxBreakTimePerDayPerStaffRule = message.enableMaxBreakTimePerDayPerStaffRule;
                        if (message.enableMaxHoursPerDayRule != null && message.hasOwnProperty("enableMaxHoursPerDayRule"))
                            object.enableMaxHoursPerDayRule = message.enableMaxHoursPerDayRule;
                        if (message.enableMaxHoursPerWeekRule != null && message.hasOwnProperty("enableMaxHoursPerWeekRule"))
                            object.enableMaxHoursPerWeekRule = message.enableMaxHoursPerWeekRule;
                        if (message.enableUnavailabilityOverlapRule != null && message.hasOwnProperty("enableUnavailabilityOverlapRule"))
                            object.enableUnavailabilityOverlapRule = message.enableUnavailabilityOverlapRule;
                        if (message.enableHourNotCoveredRule != null && message.hasOwnProperty("enableHourNotCoveredRule"))
                            object.enableHourNotCoveredRule = message.enableHourNotCoveredRule;
                        if (message.enableLackOfStaffRule != null && message.hasOwnProperty("enableLackOfStaffRule"))
                            object.enableLackOfStaffRule = message.enableLackOfStaffRule;
                        if (message.sendInvitationLanguage != null && message.hasOwnProperty("sendInvitationLanguage"))
                            object.sendInvitationLanguage = options.enums === String ? $root.palexy.streaming.v1.EmailLanguage[message.sendInvitationLanguage] : message.sendInvitationLanguage;
                        if (message.targetScheduleLaborCostRate != null && message.hasOwnProperty("targetScheduleLaborCostRate"))
                            object.targetScheduleLaborCostRate = options.json && !isFinite(message.targetScheduleLaborCostRate) ? String(message.targetScheduleLaborCostRate) : message.targetScheduleLaborCostRate;
                        if (message.targetScheduleLaborCostRateVariability != null && message.hasOwnProperty("targetScheduleLaborCostRateVariability"))
                            object.targetScheduleLaborCostRateVariability = options.json && !isFinite(message.targetScheduleLaborCostRateVariability) ? String(message.targetScheduleLaborCostRateVariability) : message.targetScheduleLaborCostRateVariability;
                        if (message.treatPreferToWorkAsCanOnlyWorkByDefault != null && message.hasOwnProperty("treatPreferToWorkAsCanOnlyWorkByDefault"))
                            object.treatPreferToWorkAsCanOnlyWorkByDefault = message.treatPreferToWorkAsCanOnlyWorkByDefault;
                        if (message.timeOffTypeIdForAutoFill != null && message.hasOwnProperty("timeOffTypeIdForAutoFill"))
                            if (typeof message.timeOffTypeIdForAutoFill === "number")
                                object.timeOffTypeIdForAutoFill = options.longs === String ? String(message.timeOffTypeIdForAutoFill) : message.timeOffTypeIdForAutoFill;
                            else
                                object.timeOffTypeIdForAutoFill = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeIdForAutoFill) : options.longs === Number ? new $util.LongBits(message.timeOffTypeIdForAutoFill.low >>> 0, message.timeOffTypeIdForAutoFill.high >>> 0).toNumber() : message.timeOffTypeIdForAutoFill;
                        if (message.rotatingShiftForStaffBalanceByDefault != null && message.hasOwnProperty("rotatingShiftForStaffBalanceByDefault"))
                            object.rotatingShiftForStaffBalanceByDefault = message.rotatingShiftForStaffBalanceByDefault;
                        if (message.payPeriodType != null && message.hasOwnProperty("payPeriodType"))
                            object.payPeriodType = options.enums === String ? $root.palexy.streaming.v1.PayPeriodType[message.payPeriodType] : message.payPeriodType;
                        if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                            object.dayOfMonthToStartPayPeriod = message.dayOfMonthToStartPayPeriod;
                        if (message.recommendedMaxHoursPerWeekForPartTime != null && message.hasOwnProperty("recommendedMaxHoursPerWeekForPartTime"))
                            object.recommendedMaxHoursPerWeekForPartTime = options.json && !isFinite(message.recommendedMaxHoursPerWeekForPartTime) ? String(message.recommendedMaxHoursPerWeekForPartTime) : message.recommendedMaxHoursPerWeekForPartTime;
                        if (message.recommendedMaxHoursPerMonthForPartTime != null && message.hasOwnProperty("recommendedMaxHoursPerMonthForPartTime"))
                            object.recommendedMaxHoursPerMonthForPartTime = options.json && !isFinite(message.recommendedMaxHoursPerMonthForPartTime) ? String(message.recommendedMaxHoursPerMonthForPartTime) : message.recommendedMaxHoursPerMonthForPartTime;
                        if (message.enableOtCalculation != null && message.hasOwnProperty("enableOtCalculation"))
                            object.enableOtCalculation = message.enableOtCalculation;
                        if (message.partTimeOtPolicy != null && message.hasOwnProperty("partTimeOtPolicy"))
                            object.partTimeOtPolicy = options.enums === String ? $root.palexy.streaming.v1.PartTimeOtPolicy[message.partTimeOtPolicy] : message.partTimeOtPolicy;
                        if (message.fullTimeOtPolicy != null && message.hasOwnProperty("fullTimeOtPolicy"))
                            object.fullTimeOtPolicy = options.enums === String ? $root.palexy.streaming.v1.FullTimeOtPolicy[message.fullTimeOtPolicy] : message.fullTimeOtPolicy;
                        if (message.lockSchedulePeriodType != null && message.hasOwnProperty("lockSchedulePeriodType"))
                            object.lockSchedulePeriodType = options.enums === String ? $root.palexy.streaming.v1.LockSchedulePeriodType[message.lockSchedulePeriodType] : message.lockSchedulePeriodType;
                        if (message.lockSchedulePeriodAfterDays != null && message.hasOwnProperty("lockSchedulePeriodAfterDays"))
                            object.lockSchedulePeriodAfterDays = message.lockSchedulePeriodAfterDays;
                        if (message.enableScheduleApprovalProcess != null && message.hasOwnProperty("enableScheduleApprovalProcess"))
                            object.enableScheduleApprovalProcess = message.enableScheduleApprovalProcess;
                        if (message.scheduleApprovalPeriod != null && message.hasOwnProperty("scheduleApprovalPeriod"))
                            object.scheduleApprovalPeriod = options.enums === String ? $root.palexy.protobuf.ScheduleApprovalPeriod[message.scheduleApprovalPeriod] : message.scheduleApprovalPeriod;
                        if (message.enableMaxHoursPerWeekIncludeOtRule != null && message.hasOwnProperty("enableMaxHoursPerWeekIncludeOtRule"))
                            object.enableMaxHoursPerWeekIncludeOtRule = message.enableMaxHoursPerWeekIncludeOtRule;
                        if (message.recommendedMaxHoursPerWeekIncludeOt != null && message.hasOwnProperty("recommendedMaxHoursPerWeekIncludeOt"))
                            object.recommendedMaxHoursPerWeekIncludeOt = options.json && !isFinite(message.recommendedMaxHoursPerWeekIncludeOt) ? String(message.recommendedMaxHoursPerWeekIncludeOt) : message.recommendedMaxHoursPerWeekIncludeOt;
                        if (message.fullTimeRatio != null && message.hasOwnProperty("fullTimeRatio"))
                            object.fullTimeRatio = options.json && !isFinite(message.fullTimeRatio) ? String(message.fullTimeRatio) : message.fullTimeRatio;
                        if (message.enableScheduleTemplateUsage != null && message.hasOwnProperty("enableScheduleTemplateUsage"))
                            object.enableScheduleTemplateUsage = message.enableScheduleTemplateUsage;
                        if (message.disableRequiredStaffPosition != null && message.hasOwnProperty("disableRequiredStaffPosition"))
                            object.disableRequiredStaffPosition = message.disableRequiredStaffPosition;
                        if (message.allowStaffToClaimShift != null && message.hasOwnProperty("allowStaffToClaimShift"))
                            object.allowStaffToClaimShift = message.allowStaffToClaimShift;
                        if (message.minStaffAtEachOperationHour != null && message.hasOwnProperty("minStaffAtEachOperationHour"))
                            object.minStaffAtEachOperationHour = message.minStaffAtEachOperationHour;
                        if (message.enableAvailabilityReminder != null && message.hasOwnProperty("enableAvailabilityReminder"))
                            object.enableAvailabilityReminder = message.enableAvailabilityReminder;
                        if (message.availabilityReminderDaysOfWeek && message.availabilityReminderDaysOfWeek.length) {
                            object.availabilityReminderDaysOfWeek = [];
                            for (var j = 0; j < message.availabilityReminderDaysOfWeek.length; ++j)
                                object.availabilityReminderDaysOfWeek[j] = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.availabilityReminderDaysOfWeek[j]] : message.availabilityReminderDaysOfWeek[j];
                        }
                        if (message.availabilityReminderTime != null && message.hasOwnProperty("availabilityReminderTime"))
                            object.availabilityReminderTime = message.availabilityReminderTime;
                        if (message.allowStaffToSwapShift != null && message.hasOwnProperty("allowStaffToSwapShift"))
                            object.allowStaffToSwapShift = message.allowStaffToSwapShift;
                        if (message.defaultWorkingHourPerDay != null && message.hasOwnProperty("defaultWorkingHourPerDay"))
                            object.defaultWorkingHourPerDay = options.json && !isFinite(message.defaultWorkingHourPerDay) ? String(message.defaultWorkingHourPerDay) : message.defaultWorkingHourPerDay;
                        if (message.defaultStartTimeInDay != null && message.hasOwnProperty("defaultStartTimeInDay"))
                            object.defaultStartTimeInDay = message.defaultStartTimeInDay;
                        if (message.defaultEndTimeInDay != null && message.hasOwnProperty("defaultEndTimeInDay"))
                            object.defaultEndTimeInDay = message.defaultEndTimeInDay;
                        if (message.enableDayPartSummary != null && message.hasOwnProperty("enableDayPartSummary"))
                            object.enableDayPartSummary = message.enableDayPartSummary;
                        if (message.highlightPtShiftsCrossMaxWorkingHours != null && message.hasOwnProperty("highlightPtShiftsCrossMaxWorkingHours"))
                            object.highlightPtShiftsCrossMaxWorkingHours = message.highlightPtShiftsCrossMaxWorkingHours;
                        if (message.ptWorkingHoursThresholdForHighlight != null && message.hasOwnProperty("ptWorkingHoursThresholdForHighlight"))
                            object.ptWorkingHoursThresholdForHighlight = options.json && !isFinite(message.ptWorkingHoursThresholdForHighlight) ? String(message.ptWorkingHoursThresholdForHighlight) : message.ptWorkingHoursThresholdForHighlight;
                        if (message.defaultRequiredPosition != null && message.hasOwnProperty("defaultRequiredPosition"))
                            object.defaultRequiredPosition = message.defaultRequiredPosition;
                        if (message.allowStaffToRequestTimeOff != null && message.hasOwnProperty("allowStaffToRequestTimeOff"))
                            object.allowStaffToRequestTimeOff = message.allowStaffToRequestTimeOff;
                        if (message.allowAreaManagerEditBudget != null && message.hasOwnProperty("allowAreaManagerEditBudget"))
                            object.allowAreaManagerEditBudget = message.allowAreaManagerEditBudget;
                        if (message.distributeBudgetHoursEvenlyByDefault != null && message.hasOwnProperty("distributeBudgetHoursEvenlyByDefault"))
                            object.distributeBudgetHoursEvenlyByDefault = message.distributeBudgetHoursEvenlyByDefault;
                        if (message.allowEditStaffAreaStores != null && message.hasOwnProperty("allowEditStaffAreaStores")) {
                            object.allowEditStaffAreaStores = $root.palexy.streaming.v1.StoreFilter.toObject(message.allowEditStaffAreaStores, options);
                            if (options.oneofs)
                                object._allowEditStaffAreaStores = "allowEditStaffAreaStores";
                        }
                        if (message.enableStrictApprovalFlow != null && message.hasOwnProperty("enableStrictApprovalFlow"))
                            object.enableStrictApprovalFlow = message.enableStrictApprovalFlow;
                        if (message.nonCoveragePositionMappings && message.nonCoveragePositionMappings.length) {
                            object.nonCoveragePositionMappings = [];
                            for (var j = 0; j < message.nonCoveragePositionMappings.length; ++j)
                                object.nonCoveragePositionMappings[j] = $root.palexy.protobuf.NonCoveragePositionMapping.toObject(message.nonCoveragePositionMappings[j], options);
                        }
                        if (message.skipApprovalOnMinimalChanges != null && message.hasOwnProperty("skipApprovalOnMinimalChanges"))
                            object.skipApprovalOnMinimalChanges = message.skipApprovalOnMinimalChanges;
                        if (message.minimalChangesThresholdPercentage != null && message.hasOwnProperty("minimalChangesThresholdPercentage"))
                            object.minimalChangesThresholdPercentage = options.json && !isFinite(message.minimalChangesThresholdPercentage) ? String(message.minimalChangesThresholdPercentage) : message.minimalChangesThresholdPercentage;
                        if (message.allowExternalStaffEmploymentType != null && message.hasOwnProperty("allowExternalStaffEmploymentType"))
                            object.allowExternalStaffEmploymentType = message.allowExternalStaffEmploymentType;
                        if (message.maxAutoAdjustBudgetDecreasePercentage != null && message.hasOwnProperty("maxAutoAdjustBudgetDecreasePercentage"))
                            object.maxAutoAdjustBudgetDecreasePercentage = options.json && !isFinite(message.maxAutoAdjustBudgetDecreasePercentage) ? String(message.maxAutoAdjustBudgetDecreasePercentage) : message.maxAutoAdjustBudgetDecreasePercentage;
                        if (message.strictBufferBetweenShifts != null && message.hasOwnProperty("strictBufferBetweenShifts"))
                            object.strictBufferBetweenShifts = message.strictBufferBetweenShifts;
                        if (message.enableWeeklyAvailabilityAutoLock != null && message.hasOwnProperty("enableWeeklyAvailabilityAutoLock"))
                            object.enableWeeklyAvailabilityAutoLock = message.enableWeeklyAvailabilityAutoLock;
                        if (message.availabilityAutoLockDayOfWeek != null && message.hasOwnProperty("availabilityAutoLockDayOfWeek"))
                            object.availabilityAutoLockDayOfWeek = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.availabilityAutoLockDayOfWeek] : message.availabilityAutoLockDayOfWeek;
                        if (message.showPaidHoursPositionIds && message.showPaidHoursPositionIds.length) {
                            object.showPaidHoursPositionIds = [];
                            for (var j = 0; j < message.showPaidHoursPositionIds.length; ++j)
                                if (typeof message.showPaidHoursPositionIds[j] === "number")
                                    object.showPaidHoursPositionIds[j] = options.longs === String ? String(message.showPaidHoursPositionIds[j]) : message.showPaidHoursPositionIds[j];
                                else
                                    object.showPaidHoursPositionIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.showPaidHoursPositionIds[j]) : options.longs === Number ? new $util.LongBits(message.showPaidHoursPositionIds[j].low >>> 0, message.showPaidHoursPositionIds[j].high >>> 0).toNumber() : message.showPaidHoursPositionIds[j];
                        }
                        if (message.disableEditNonCoverageAtShiftLevel != null && message.hasOwnProperty("disableEditNonCoverageAtShiftLevel"))
                            object.disableEditNonCoverageAtShiftLevel = message.disableEditNonCoverageAtShiftLevel;
                        if (message.enableBudgetPlanningTplhWarning != null && message.hasOwnProperty("enableBudgetPlanningTplhWarning"))
                            object.enableBudgetPlanningTplhWarning = message.enableBudgetPlanningTplhWarning;
                        if (message.disableEditBreakTimeAtShiftLevel != null && message.hasOwnProperty("disableEditBreakTimeAtShiftLevel"))
                            object.disableEditBreakTimeAtShiftLevel = message.disableEditBreakTimeAtShiftLevel;
                        return object;
                    };
    
                    /**
                     * Converts this StaffScheduleGeneralSetting to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSetting
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffScheduleGeneralSetting.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffScheduleGeneralSetting;
                })();
    
                v1.StaffScheduleGeneralSettingForStaff = (function() {
    
                    /**
                     * Properties of a StaffScheduleGeneralSettingForStaff.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffScheduleGeneralSettingForStaff
                     * @property {boolean|null} [allowStaffToClaimShift] StaffScheduleGeneralSettingForStaff allowStaffToClaimShift
                     * @property {boolean|null} [allowStaffToSwapShift] StaffScheduleGeneralSettingForStaff allowStaffToSwapShift
                     * @property {number|null} [defaultWorkingHourPerDay] StaffScheduleGeneralSettingForStaff defaultWorkingHourPerDay
                     * @property {string|null} [defaultStartTimeInDay] StaffScheduleGeneralSettingForStaff defaultStartTimeInDay
                     * @property {string|null} [defaultEndTimeInDay] StaffScheduleGeneralSettingForStaff defaultEndTimeInDay
                     * @property {palexy.streaming.v1.PayPeriodType|null} [payPeriodType] StaffScheduleGeneralSettingForStaff payPeriodType
                     * @property {number|null} [dayOfMonthToStartPayPeriod] StaffScheduleGeneralSettingForStaff dayOfMonthToStartPayPeriod
                     * @property {boolean|null} [allowStaffToRequestTimeOff] StaffScheduleGeneralSettingForStaff allowStaffToRequestTimeOff
                     */
    
                    /**
                     * Constructs a new StaffScheduleGeneralSettingForStaff.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffScheduleGeneralSettingForStaff.
                     * @implements IStaffScheduleGeneralSettingForStaff
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSettingForStaff=} [properties] Properties to set
                     */
                    function StaffScheduleGeneralSettingForStaff(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffScheduleGeneralSettingForStaff allowStaffToClaimShift.
                     * @member {boolean} allowStaffToClaimShift
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.allowStaffToClaimShift = false;
    
                    /**
                     * StaffScheduleGeneralSettingForStaff allowStaffToSwapShift.
                     * @member {boolean} allowStaffToSwapShift
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.allowStaffToSwapShift = false;
    
                    /**
                     * StaffScheduleGeneralSettingForStaff defaultWorkingHourPerDay.
                     * @member {number} defaultWorkingHourPerDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.defaultWorkingHourPerDay = 0;
    
                    /**
                     * StaffScheduleGeneralSettingForStaff defaultStartTimeInDay.
                     * @member {string} defaultStartTimeInDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.defaultStartTimeInDay = "";
    
                    /**
                     * StaffScheduleGeneralSettingForStaff defaultEndTimeInDay.
                     * @member {string} defaultEndTimeInDay
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.defaultEndTimeInDay = "";
    
                    /**
                     * StaffScheduleGeneralSettingForStaff payPeriodType.
                     * @member {palexy.streaming.v1.PayPeriodType} payPeriodType
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.payPeriodType = 0;
    
                    /**
                     * StaffScheduleGeneralSettingForStaff dayOfMonthToStartPayPeriod.
                     * @member {number} dayOfMonthToStartPayPeriod
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.dayOfMonthToStartPayPeriod = 0;
    
                    /**
                     * StaffScheduleGeneralSettingForStaff allowStaffToRequestTimeOff.
                     * @member {boolean} allowStaffToRequestTimeOff
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.allowStaffToRequestTimeOff = false;
    
                    /**
                     * Creates a new StaffScheduleGeneralSettingForStaff instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSettingForStaff=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSettingForStaff} StaffScheduleGeneralSettingForStaff instance
                     */
                    StaffScheduleGeneralSettingForStaff.create = function create(properties) {
                        return new StaffScheduleGeneralSettingForStaff(properties);
                    };
    
                    /**
                     * Encodes the specified StaffScheduleGeneralSettingForStaff message. Does not implicitly {@link palexy.streaming.v1.StaffScheduleGeneralSettingForStaff.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSettingForStaff} message StaffScheduleGeneralSettingForStaff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffScheduleGeneralSettingForStaff.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.allowStaffToClaimShift != null && Object.hasOwnProperty.call(message, "allowStaffToClaimShift"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.allowStaffToClaimShift);
                        if (message.allowStaffToSwapShift != null && Object.hasOwnProperty.call(message, "allowStaffToSwapShift"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowStaffToSwapShift);
                        if (message.defaultWorkingHourPerDay != null && Object.hasOwnProperty.call(message, "defaultWorkingHourPerDay"))
                            writer.uint32(/* id 3, wireType 5 =*/29).float(message.defaultWorkingHourPerDay);
                        if (message.defaultStartTimeInDay != null && Object.hasOwnProperty.call(message, "defaultStartTimeInDay"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.defaultStartTimeInDay);
                        if (message.defaultEndTimeInDay != null && Object.hasOwnProperty.call(message, "defaultEndTimeInDay"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.defaultEndTimeInDay);
                        if (message.payPeriodType != null && Object.hasOwnProperty.call(message, "payPeriodType"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.payPeriodType);
                        if (message.dayOfMonthToStartPayPeriod != null && Object.hasOwnProperty.call(message, "dayOfMonthToStartPayPeriod"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.dayOfMonthToStartPayPeriod);
                        if (message.allowStaffToRequestTimeOff != null && Object.hasOwnProperty.call(message, "allowStaffToRequestTimeOff"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.allowStaffToRequestTimeOff);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffScheduleGeneralSettingForStaff message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffScheduleGeneralSettingForStaff.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {palexy.streaming.v1.IStaffScheduleGeneralSettingForStaff} message StaffScheduleGeneralSettingForStaff message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffScheduleGeneralSettingForStaff.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffScheduleGeneralSettingForStaff message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSettingForStaff} StaffScheduleGeneralSettingForStaff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffScheduleGeneralSettingForStaff.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffScheduleGeneralSettingForStaff();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.allowStaffToClaimShift = reader.bool();
                                break;
                            case 2:
                                message.allowStaffToSwapShift = reader.bool();
                                break;
                            case 3:
                                message.defaultWorkingHourPerDay = reader.float();
                                break;
                            case 4:
                                message.defaultStartTimeInDay = reader.string();
                                break;
                            case 5:
                                message.defaultEndTimeInDay = reader.string();
                                break;
                            case 6:
                                message.payPeriodType = reader.int32();
                                break;
                            case 7:
                                message.dayOfMonthToStartPayPeriod = reader.int32();
                                break;
                            case 8:
                                message.allowStaffToRequestTimeOff = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffScheduleGeneralSettingForStaff message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSettingForStaff} StaffScheduleGeneralSettingForStaff
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffScheduleGeneralSettingForStaff.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffScheduleGeneralSettingForStaff message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffScheduleGeneralSettingForStaff.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.allowStaffToClaimShift != null && message.hasOwnProperty("allowStaffToClaimShift"))
                            if (typeof message.allowStaffToClaimShift !== "boolean")
                                return "allowStaffToClaimShift: boolean expected";
                        if (message.allowStaffToSwapShift != null && message.hasOwnProperty("allowStaffToSwapShift"))
                            if (typeof message.allowStaffToSwapShift !== "boolean")
                                return "allowStaffToSwapShift: boolean expected";
                        if (message.defaultWorkingHourPerDay != null && message.hasOwnProperty("defaultWorkingHourPerDay"))
                            if (typeof message.defaultWorkingHourPerDay !== "number")
                                return "defaultWorkingHourPerDay: number expected";
                        if (message.defaultStartTimeInDay != null && message.hasOwnProperty("defaultStartTimeInDay"))
                            if (!$util.isString(message.defaultStartTimeInDay))
                                return "defaultStartTimeInDay: string expected";
                        if (message.defaultEndTimeInDay != null && message.hasOwnProperty("defaultEndTimeInDay"))
                            if (!$util.isString(message.defaultEndTimeInDay))
                                return "defaultEndTimeInDay: string expected";
                        if (message.payPeriodType != null && message.hasOwnProperty("payPeriodType"))
                            switch (message.payPeriodType) {
                            default:
                                return "payPeriodType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                            if (!$util.isInteger(message.dayOfMonthToStartPayPeriod))
                                return "dayOfMonthToStartPayPeriod: integer expected";
                        if (message.allowStaffToRequestTimeOff != null && message.hasOwnProperty("allowStaffToRequestTimeOff"))
                            if (typeof message.allowStaffToRequestTimeOff !== "boolean")
                                return "allowStaffToRequestTimeOff: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffScheduleGeneralSettingForStaff message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffScheduleGeneralSettingForStaff} StaffScheduleGeneralSettingForStaff
                     */
                    StaffScheduleGeneralSettingForStaff.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffScheduleGeneralSettingForStaff)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffScheduleGeneralSettingForStaff();
                        if (object.allowStaffToClaimShift != null)
                            message.allowStaffToClaimShift = Boolean(object.allowStaffToClaimShift);
                        if (object.allowStaffToSwapShift != null)
                            message.allowStaffToSwapShift = Boolean(object.allowStaffToSwapShift);
                        if (object.defaultWorkingHourPerDay != null)
                            message.defaultWorkingHourPerDay = Number(object.defaultWorkingHourPerDay);
                        if (object.defaultStartTimeInDay != null)
                            message.defaultStartTimeInDay = String(object.defaultStartTimeInDay);
                        if (object.defaultEndTimeInDay != null)
                            message.defaultEndTimeInDay = String(object.defaultEndTimeInDay);
                        switch (object.payPeriodType) {
                        case "PAY_PERIOD_UNSPECIFIED":
                        case 0:
                            message.payPeriodType = 0;
                            break;
                        case "MONTHLY":
                        case 1:
                            message.payPeriodType = 1;
                            break;
                        }
                        if (object.dayOfMonthToStartPayPeriod != null)
                            message.dayOfMonthToStartPayPeriod = object.dayOfMonthToStartPayPeriod | 0;
                        if (object.allowStaffToRequestTimeOff != null)
                            message.allowStaffToRequestTimeOff = Boolean(object.allowStaffToRequestTimeOff);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffScheduleGeneralSettingForStaff message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @static
                     * @param {palexy.streaming.v1.StaffScheduleGeneralSettingForStaff} message StaffScheduleGeneralSettingForStaff
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffScheduleGeneralSettingForStaff.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.allowStaffToClaimShift = false;
                            object.allowStaffToSwapShift = false;
                            object.defaultWorkingHourPerDay = 0;
                            object.defaultStartTimeInDay = "";
                            object.defaultEndTimeInDay = "";
                            object.payPeriodType = options.enums === String ? "PAY_PERIOD_UNSPECIFIED" : 0;
                            object.dayOfMonthToStartPayPeriod = 0;
                            object.allowStaffToRequestTimeOff = false;
                        }
                        if (message.allowStaffToClaimShift != null && message.hasOwnProperty("allowStaffToClaimShift"))
                            object.allowStaffToClaimShift = message.allowStaffToClaimShift;
                        if (message.allowStaffToSwapShift != null && message.hasOwnProperty("allowStaffToSwapShift"))
                            object.allowStaffToSwapShift = message.allowStaffToSwapShift;
                        if (message.defaultWorkingHourPerDay != null && message.hasOwnProperty("defaultWorkingHourPerDay"))
                            object.defaultWorkingHourPerDay = options.json && !isFinite(message.defaultWorkingHourPerDay) ? String(message.defaultWorkingHourPerDay) : message.defaultWorkingHourPerDay;
                        if (message.defaultStartTimeInDay != null && message.hasOwnProperty("defaultStartTimeInDay"))
                            object.defaultStartTimeInDay = message.defaultStartTimeInDay;
                        if (message.defaultEndTimeInDay != null && message.hasOwnProperty("defaultEndTimeInDay"))
                            object.defaultEndTimeInDay = message.defaultEndTimeInDay;
                        if (message.payPeriodType != null && message.hasOwnProperty("payPeriodType"))
                            object.payPeriodType = options.enums === String ? $root.palexy.streaming.v1.PayPeriodType[message.payPeriodType] : message.payPeriodType;
                        if (message.dayOfMonthToStartPayPeriod != null && message.hasOwnProperty("dayOfMonthToStartPayPeriod"))
                            object.dayOfMonthToStartPayPeriod = message.dayOfMonthToStartPayPeriod;
                        if (message.allowStaffToRequestTimeOff != null && message.hasOwnProperty("allowStaffToRequestTimeOff"))
                            object.allowStaffToRequestTimeOff = message.allowStaffToRequestTimeOff;
                        return object;
                    };
    
                    /**
                     * Converts this StaffScheduleGeneralSettingForStaff to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffScheduleGeneralSettingForStaff
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffScheduleGeneralSettingForStaff.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffScheduleGeneralSettingForStaff;
                })();
    
                /**
                 * PartTimeOtPolicy enum.
                 * @name palexy.streaming.v1.PartTimeOtPolicy
                 * @enum {number}
                 * @property {number} PART_TIME_OT_POLICY_UNSPECIFIED=0 PART_TIME_OT_POLICY_UNSPECIFIED value
                 * @property {number} USE_MONTHLY_MAXIMUM=1 USE_MONTHLY_MAXIMUM value
                 */
                v1.PartTimeOtPolicy = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "PART_TIME_OT_POLICY_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "USE_MONTHLY_MAXIMUM"] = 1;
                    return values;
                })();
    
                /**
                 * FullTimeOtPolicy enum.
                 * @name palexy.streaming.v1.FullTimeOtPolicy
                 * @enum {number}
                 * @property {number} FULL_TIME_OT_POLICY_UNSPECIFIED=0 FULL_TIME_OT_POLICY_UNSPECIFIED value
                 * @property {number} NONE=1 NONE value
                 * @property {number} USE_WEEKLY_MAXIMUM_TO_INFER_MONTHLY=2 USE_WEEKLY_MAXIMUM_TO_INFER_MONTHLY value
                 */
                v1.FullTimeOtPolicy = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FULL_TIME_OT_POLICY_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "NONE"] = 1;
                    values[valuesById[2] = "USE_WEEKLY_MAXIMUM_TO_INFER_MONTHLY"] = 2;
                    return values;
                })();
    
                /**
                 * PayPeriodType enum.
                 * @name palexy.streaming.v1.PayPeriodType
                 * @enum {number}
                 * @property {number} PAY_PERIOD_UNSPECIFIED=0 PAY_PERIOD_UNSPECIFIED value
                 * @property {number} MONTHLY=1 MONTHLY value
                 */
                v1.PayPeriodType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "PAY_PERIOD_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "MONTHLY"] = 1;
                    return values;
                })();
    
                /**
                 * LockSchedulePeriodType enum.
                 * @name palexy.streaming.v1.LockSchedulePeriodType
                 * @enum {number}
                 * @property {number} LOCK_SCHEDULE_PERIOD_TYPE_UNSPECIFIED=0 LOCK_SCHEDULE_PERIOD_TYPE_UNSPECIFIED value
                 * @property {number} WEEK=1 WEEK value
                 * @property {number} MONTH=2 MONTH value
                 */
                v1.LockSchedulePeriodType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "LOCK_SCHEDULE_PERIOD_TYPE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "WEEK"] = 1;
                    values[valuesById[2] = "MONTH"] = 2;
                    return values;
                })();
    
                /**
                 * EmailLanguage enum.
                 * @name palexy.streaming.v1.EmailLanguage
                 * @enum {number}
                 * @property {number} en=0 en value
                 * @property {number} vi=1 vi value
                 * @property {number} th=2 th value
                 * @property {number} ja=3 ja value
                 * @property {number} zh_hans=4 zh_hans value
                 * @property {number} zh_hant=5 zh_hant value
                 * @property {number} ko=6 ko value
                 * @property {number} id=7 id value
                 */
                v1.EmailLanguage = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "en"] = 0;
                    values[valuesById[1] = "vi"] = 1;
                    values[valuesById[2] = "th"] = 2;
                    values[valuesById[3] = "ja"] = 3;
                    values[valuesById[4] = "zh_hans"] = 4;
                    values[valuesById[5] = "zh_hant"] = 5;
                    values[valuesById[6] = "ko"] = 6;
                    values[valuesById[7] = "id"] = 7;
                    return values;
                })();
    
                v1.GetStoresForLateVideoCheckingRequest = (function() {
    
                    /**
                     * Properties of a GetStoresForLateVideoCheckingRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoresForLateVideoCheckingRequest
                     */
    
                    /**
                     * Constructs a new GetStoresForLateVideoCheckingRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoresForLateVideoCheckingRequest.
                     * @implements IGetStoresForLateVideoCheckingRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest=} [properties] Properties to set
                     */
                    function GetStoresForLateVideoCheckingRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new GetStoresForLateVideoCheckingRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingRequest} GetStoresForLateVideoCheckingRequest instance
                     */
                    GetStoresForLateVideoCheckingRequest.create = function create(properties) {
                        return new GetStoresForLateVideoCheckingRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoresForLateVideoCheckingRequest message. Does not implicitly {@link palexy.streaming.v1.GetStoresForLateVideoCheckingRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest} message GetStoresForLateVideoCheckingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoresForLateVideoCheckingRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoresForLateVideoCheckingRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoresForLateVideoCheckingRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingRequest} message GetStoresForLateVideoCheckingRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoresForLateVideoCheckingRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoresForLateVideoCheckingRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingRequest} GetStoresForLateVideoCheckingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoresForLateVideoCheckingRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoresForLateVideoCheckingRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoresForLateVideoCheckingRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingRequest} GetStoresForLateVideoCheckingRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoresForLateVideoCheckingRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoresForLateVideoCheckingRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoresForLateVideoCheckingRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoresForLateVideoCheckingRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingRequest} GetStoresForLateVideoCheckingRequest
                     */
                    GetStoresForLateVideoCheckingRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoresForLateVideoCheckingRequest)
                            return object;
                        return new $root.palexy.streaming.v1.GetStoresForLateVideoCheckingRequest();
                    };
    
                    /**
                     * Creates a plain object from a GetStoresForLateVideoCheckingRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStoresForLateVideoCheckingRequest} message GetStoresForLateVideoCheckingRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoresForLateVideoCheckingRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this GetStoresForLateVideoCheckingRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoresForLateVideoCheckingRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoresForLateVideoCheckingRequest;
                })();
    
                v1.GetStoresForLateVideoCheckingResponse = (function() {
    
                    /**
                     * Properties of a GetStoresForLateVideoCheckingResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStoresForLateVideoCheckingResponse
                     * @property {Array.<palexy.streaming.v1.IStore>|null} [stores] GetStoresForLateVideoCheckingResponse stores
                     */
    
                    /**
                     * Constructs a new GetStoresForLateVideoCheckingResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStoresForLateVideoCheckingResponse.
                     * @implements IGetStoresForLateVideoCheckingResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingResponse=} [properties] Properties to set
                     */
                    function GetStoresForLateVideoCheckingResponse(properties) {
                        this.stores = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoresForLateVideoCheckingResponse stores.
                     * @member {Array.<palexy.streaming.v1.IStore>} stores
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @instance
                     */
                    GetStoresForLateVideoCheckingResponse.prototype.stores = $util.emptyArray;
    
                    /**
                     * Creates a new GetStoresForLateVideoCheckingResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} GetStoresForLateVideoCheckingResponse instance
                     */
                    GetStoresForLateVideoCheckingResponse.create = function create(properties) {
                        return new GetStoresForLateVideoCheckingResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoresForLateVideoCheckingResponse message. Does not implicitly {@link palexy.streaming.v1.GetStoresForLateVideoCheckingResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingResponse} message GetStoresForLateVideoCheckingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoresForLateVideoCheckingResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.stores != null && message.stores.length)
                            for (var i = 0; i < message.stores.length; ++i)
                                $root.palexy.streaming.v1.Store.encode(message.stores[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoresForLateVideoCheckingResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStoresForLateVideoCheckingResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {palexy.streaming.v1.IGetStoresForLateVideoCheckingResponse} message GetStoresForLateVideoCheckingResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoresForLateVideoCheckingResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoresForLateVideoCheckingResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} GetStoresForLateVideoCheckingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoresForLateVideoCheckingResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStoresForLateVideoCheckingResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.stores && message.stores.length))
                                    message.stores = [];
                                message.stores.push($root.palexy.streaming.v1.Store.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoresForLateVideoCheckingResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} GetStoresForLateVideoCheckingResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoresForLateVideoCheckingResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoresForLateVideoCheckingResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoresForLateVideoCheckingResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.stores != null && message.hasOwnProperty("stores")) {
                            if (!Array.isArray(message.stores))
                                return "stores: array expected";
                            for (var i = 0; i < message.stores.length; ++i) {
                                var error = $root.palexy.streaming.v1.Store.verify(message.stores[i]);
                                if (error)
                                    return "stores." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetStoresForLateVideoCheckingResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} GetStoresForLateVideoCheckingResponse
                     */
                    GetStoresForLateVideoCheckingResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStoresForLateVideoCheckingResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStoresForLateVideoCheckingResponse();
                        if (object.stores) {
                            if (!Array.isArray(object.stores))
                                throw TypeError(".palexy.streaming.v1.GetStoresForLateVideoCheckingResponse.stores: array expected");
                            message.stores = [];
                            for (var i = 0; i < object.stores.length; ++i) {
                                if (typeof object.stores[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.GetStoresForLateVideoCheckingResponse.stores: object expected");
                                message.stores[i] = $root.palexy.streaming.v1.Store.fromObject(object.stores[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoresForLateVideoCheckingResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @static
                     * @param {palexy.streaming.v1.GetStoresForLateVideoCheckingResponse} message GetStoresForLateVideoCheckingResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoresForLateVideoCheckingResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.stores = [];
                        if (message.stores && message.stores.length) {
                            object.stores = [];
                            for (var j = 0; j < message.stores.length; ++j)
                                object.stores[j] = $root.palexy.streaming.v1.Store.toObject(message.stores[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetStoresForLateVideoCheckingResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStoresForLateVideoCheckingResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoresForLateVideoCheckingResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoresForLateVideoCheckingResponse;
                })();
    
                v1.ListShiftOpenToClaimRequest = (function() {
    
                    /**
                     * Properties of a ListShiftOpenToClaimRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListShiftOpenToClaimRequest
                     * @property {number|null} [companyId] ListShiftOpenToClaimRequest companyId
                     * @property {Array.<number>|null} [storeIds] ListShiftOpenToClaimRequest storeIds
                     * @property {number|null} [startDateId] ListShiftOpenToClaimRequest startDateId
                     * @property {number|null} [endDateId] ListShiftOpenToClaimRequest endDateId
                     * @property {boolean|null} [onlyClaimable] ListShiftOpenToClaimRequest onlyClaimable
                     * @property {boolean|null} [includeStoreInformation] ListShiftOpenToClaimRequest includeStoreInformation
                     * @property {boolean|null} [includePositionInformation] ListShiftOpenToClaimRequest includePositionInformation
                     * @property {number|null} [pageSize] ListShiftOpenToClaimRequest pageSize
                     * @property {string|null} [pageToken] ListShiftOpenToClaimRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListShiftOpenToClaimRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListShiftOpenToClaimRequest.
                     * @implements IListShiftOpenToClaimRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest=} [properties] Properties to set
                     */
                    function ListShiftOpenToClaimRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListShiftOpenToClaimRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListShiftOpenToClaimRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListShiftOpenToClaimRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.startDateId = 0;
    
                    /**
                     * ListShiftOpenToClaimRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.endDateId = 0;
    
                    /**
                     * ListShiftOpenToClaimRequest onlyClaimable.
                     * @member {boolean} onlyClaimable
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.onlyClaimable = false;
    
                    /**
                     * ListShiftOpenToClaimRequest includeStoreInformation.
                     * @member {boolean} includeStoreInformation
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.includeStoreInformation = false;
    
                    /**
                     * ListShiftOpenToClaimRequest includePositionInformation.
                     * @member {boolean} includePositionInformation
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.includePositionInformation = false;
    
                    /**
                     * ListShiftOpenToClaimRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.pageSize = 0;
    
                    /**
                     * ListShiftOpenToClaimRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     */
                    ListShiftOpenToClaimRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListShiftOpenToClaimRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimRequest} ListShiftOpenToClaimRequest instance
                     */
                    ListShiftOpenToClaimRequest.create = function create(properties) {
                        return new ListShiftOpenToClaimRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListShiftOpenToClaimRequest message. Does not implicitly {@link palexy.streaming.v1.ListShiftOpenToClaimRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest} message ListShiftOpenToClaimRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftOpenToClaimRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endDateId);
                        if (message.onlyClaimable != null && Object.hasOwnProperty.call(message, "onlyClaimable"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.onlyClaimable);
                        if (message.includeStoreInformation != null && Object.hasOwnProperty.call(message, "includeStoreInformation"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeStoreInformation);
                        if (message.includePositionInformation != null && Object.hasOwnProperty.call(message, "includePositionInformation"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includePositionInformation);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListShiftOpenToClaimRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListShiftOpenToClaimRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimRequest} message ListShiftOpenToClaimRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftOpenToClaimRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListShiftOpenToClaimRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimRequest} ListShiftOpenToClaimRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftOpenToClaimRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListShiftOpenToClaimRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 3:
                                message.startDateId = reader.int32();
                                break;
                            case 4:
                                message.endDateId = reader.int32();
                                break;
                            case 5:
                                message.onlyClaimable = reader.bool();
                                break;
                            case 6:
                                message.includeStoreInformation = reader.bool();
                                break;
                            case 7:
                                message.includePositionInformation = reader.bool();
                                break;
                            case 8:
                                message.pageSize = reader.int32();
                                break;
                            case 9:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListShiftOpenToClaimRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimRequest} ListShiftOpenToClaimRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftOpenToClaimRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListShiftOpenToClaimRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListShiftOpenToClaimRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.onlyClaimable != null && message.hasOwnProperty("onlyClaimable"))
                            if (typeof message.onlyClaimable !== "boolean")
                                return "onlyClaimable: boolean expected";
                        if (message.includeStoreInformation != null && message.hasOwnProperty("includeStoreInformation"))
                            if (typeof message.includeStoreInformation !== "boolean")
                                return "includeStoreInformation: boolean expected";
                        if (message.includePositionInformation != null && message.hasOwnProperty("includePositionInformation"))
                            if (typeof message.includePositionInformation !== "boolean")
                                return "includePositionInformation: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListShiftOpenToClaimRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimRequest} ListShiftOpenToClaimRequest
                     */
                    ListShiftOpenToClaimRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListShiftOpenToClaimRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListShiftOpenToClaimRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.streaming.v1.ListShiftOpenToClaimRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.onlyClaimable != null)
                            message.onlyClaimable = Boolean(object.onlyClaimable);
                        if (object.includeStoreInformation != null)
                            message.includeStoreInformation = Boolean(object.includeStoreInformation);
                        if (object.includePositionInformation != null)
                            message.includePositionInformation = Boolean(object.includePositionInformation);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListShiftOpenToClaimRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.ListShiftOpenToClaimRequest} message ListShiftOpenToClaimRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListShiftOpenToClaimRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.onlyClaimable = false;
                            object.includeStoreInformation = false;
                            object.includePositionInformation = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.onlyClaimable != null && message.hasOwnProperty("onlyClaimable"))
                            object.onlyClaimable = message.onlyClaimable;
                        if (message.includeStoreInformation != null && message.hasOwnProperty("includeStoreInformation"))
                            object.includeStoreInformation = message.includeStoreInformation;
                        if (message.includePositionInformation != null && message.hasOwnProperty("includePositionInformation"))
                            object.includePositionInformation = message.includePositionInformation;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListShiftOpenToClaimRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListShiftOpenToClaimRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListShiftOpenToClaimRequest;
                })();
    
                v1.ListShiftOpenToClaimResponse = (function() {
    
                    /**
                     * Properties of a ListShiftOpenToClaimResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListShiftOpenToClaimResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] ListShiftOpenToClaimResponse staffShifts
                     * @property {string|null} [nextPageToken] ListShiftOpenToClaimResponse nextPageToken
                     * @property {number|null} [totalElements] ListShiftOpenToClaimResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListShiftOpenToClaimResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListShiftOpenToClaimResponse.
                     * @implements IListShiftOpenToClaimResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimResponse=} [properties] Properties to set
                     */
                    function ListShiftOpenToClaimResponse(properties) {
                        this.staffShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListShiftOpenToClaimResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @instance
                     */
                    ListShiftOpenToClaimResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * ListShiftOpenToClaimResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @instance
                     */
                    ListShiftOpenToClaimResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListShiftOpenToClaimResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @instance
                     */
                    ListShiftOpenToClaimResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListShiftOpenToClaimResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimResponse} ListShiftOpenToClaimResponse instance
                     */
                    ListShiftOpenToClaimResponse.create = function create(properties) {
                        return new ListShiftOpenToClaimResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListShiftOpenToClaimResponse message. Does not implicitly {@link palexy.streaming.v1.ListShiftOpenToClaimResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimResponse} message ListShiftOpenToClaimResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftOpenToClaimResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListShiftOpenToClaimResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListShiftOpenToClaimResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {palexy.streaming.v1.IListShiftOpenToClaimResponse} message ListShiftOpenToClaimResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListShiftOpenToClaimResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListShiftOpenToClaimResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimResponse} ListShiftOpenToClaimResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftOpenToClaimResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListShiftOpenToClaimResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListShiftOpenToClaimResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimResponse} ListShiftOpenToClaimResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListShiftOpenToClaimResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListShiftOpenToClaimResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListShiftOpenToClaimResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListShiftOpenToClaimResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListShiftOpenToClaimResponse} ListShiftOpenToClaimResponse
                     */
                    ListShiftOpenToClaimResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListShiftOpenToClaimResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListShiftOpenToClaimResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.ListShiftOpenToClaimResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListShiftOpenToClaimResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListShiftOpenToClaimResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @static
                     * @param {palexy.streaming.v1.ListShiftOpenToClaimResponse} message ListShiftOpenToClaimResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListShiftOpenToClaimResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShifts = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListShiftOpenToClaimResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListShiftOpenToClaimResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListShiftOpenToClaimResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListShiftOpenToClaimResponse;
                })();
    
                v1.ListStaffShiftToSwapRequest = (function() {
    
                    /**
                     * Properties of a ListStaffShiftToSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftToSwapRequest
                     * @property {number|null} [fromShiftId] ListStaffShiftToSwapRequest fromShiftId
                     * @property {number|null} [startDateId] ListStaffShiftToSwapRequest startDateId
                     * @property {number|null} [endDateId] ListStaffShiftToSwapRequest endDateId
                     * @property {boolean|null} [includeStoreInfo] ListStaffShiftToSwapRequest includeStoreInfo
                     * @property {boolean|null} [includeStaffInfo] ListStaffShiftToSwapRequest includeStaffInfo
                     * @property {boolean|null} [includeScheduleAreaInfo] ListStaffShiftToSwapRequest includeScheduleAreaInfo
                     * @property {number|null} [pageSize] ListStaffShiftToSwapRequest pageSize
                     * @property {string|null} [pageToken] ListStaffShiftToSwapRequest pageToken
                     * @property {number|null} [toStaffId] ListStaffShiftToSwapRequest toStaffId
                     */
    
                    /**
                     * Constructs a new ListStaffShiftToSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftToSwapRequest.
                     * @implements IListStaffShiftToSwapRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest=} [properties] Properties to set
                     */
                    function ListStaffShiftToSwapRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftToSwapRequest fromShiftId.
                     * @member {number} fromShiftId
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.fromShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftToSwapRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.startDateId = 0;
    
                    /**
                     * ListStaffShiftToSwapRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.endDateId = 0;
    
                    /**
                     * ListStaffShiftToSwapRequest includeStoreInfo.
                     * @member {boolean} includeStoreInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.includeStoreInfo = false;
    
                    /**
                     * ListStaffShiftToSwapRequest includeStaffInfo.
                     * @member {boolean} includeStaffInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.includeStaffInfo = false;
    
                    /**
                     * ListStaffShiftToSwapRequest includeScheduleAreaInfo.
                     * @member {boolean} includeScheduleAreaInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.includeScheduleAreaInfo = false;
    
                    /**
                     * ListStaffShiftToSwapRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffShiftToSwapRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.pageToken = "";
    
                    /**
                     * ListStaffShiftToSwapRequest toStaffId.
                     * @member {number} toStaffId
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     */
                    ListStaffShiftToSwapRequest.prototype.toStaffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStaffShiftToSwapRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapRequest} ListStaffShiftToSwapRequest instance
                     */
                    ListStaffShiftToSwapRequest.create = function create(properties) {
                        return new ListStaffShiftToSwapRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftToSwapRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftToSwapRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest} message ListStaffShiftToSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftToSwapRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fromShiftId != null && Object.hasOwnProperty.call(message, "fromShiftId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.fromShiftId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.includeStoreInfo != null && Object.hasOwnProperty.call(message, "includeStoreInfo"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeStoreInfo);
                        if (message.includeStaffInfo != null && Object.hasOwnProperty.call(message, "includeStaffInfo"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeStaffInfo);
                        if (message.includeScheduleAreaInfo != null && Object.hasOwnProperty.call(message, "includeScheduleAreaInfo"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.includeScheduleAreaInfo);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.pageToken);
                        if (message.toStaffId != null && Object.hasOwnProperty.call(message, "toStaffId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.toStaffId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftToSwapRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftToSwapRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapRequest} message ListStaffShiftToSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftToSwapRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftToSwapRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapRequest} ListStaffShiftToSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftToSwapRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftToSwapRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fromShiftId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 5:
                                message.includeStoreInfo = reader.bool();
                                break;
                            case 6:
                                message.includeStaffInfo = reader.bool();
                                break;
                            case 7:
                                message.includeScheduleAreaInfo = reader.bool();
                                break;
                            case 8:
                                message.pageSize = reader.int32();
                                break;
                            case 9:
                                message.pageToken = reader.string();
                                break;
                            case 10:
                                message.toStaffId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftToSwapRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapRequest} ListStaffShiftToSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftToSwapRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftToSwapRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftToSwapRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fromShiftId != null && message.hasOwnProperty("fromShiftId"))
                            if (!$util.isInteger(message.fromShiftId) && !(message.fromShiftId && $util.isInteger(message.fromShiftId.low) && $util.isInteger(message.fromShiftId.high)))
                                return "fromShiftId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            if (typeof message.includeStoreInfo !== "boolean")
                                return "includeStoreInfo: boolean expected";
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            if (typeof message.includeStaffInfo !== "boolean")
                                return "includeStaffInfo: boolean expected";
                        if (message.includeScheduleAreaInfo != null && message.hasOwnProperty("includeScheduleAreaInfo"))
                            if (typeof message.includeScheduleAreaInfo !== "boolean")
                                return "includeScheduleAreaInfo: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (!$util.isInteger(message.toStaffId) && !(message.toStaffId && $util.isInteger(message.toStaffId.low) && $util.isInteger(message.toStaffId.high)))
                                return "toStaffId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftToSwapRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapRequest} ListStaffShiftToSwapRequest
                     */
                    ListStaffShiftToSwapRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftToSwapRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftToSwapRequest();
                        if (object.fromShiftId != null)
                            if ($util.Long)
                                (message.fromShiftId = $util.Long.fromValue(object.fromShiftId)).unsigned = false;
                            else if (typeof object.fromShiftId === "string")
                                message.fromShiftId = parseInt(object.fromShiftId, 10);
                            else if (typeof object.fromShiftId === "number")
                                message.fromShiftId = object.fromShiftId;
                            else if (typeof object.fromShiftId === "object")
                                message.fromShiftId = new $util.LongBits(object.fromShiftId.low >>> 0, object.fromShiftId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.includeStoreInfo != null)
                            message.includeStoreInfo = Boolean(object.includeStoreInfo);
                        if (object.includeStaffInfo != null)
                            message.includeStaffInfo = Boolean(object.includeStaffInfo);
                        if (object.includeScheduleAreaInfo != null)
                            message.includeScheduleAreaInfo = Boolean(object.includeScheduleAreaInfo);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.toStaffId != null)
                            if ($util.Long)
                                (message.toStaffId = $util.Long.fromValue(object.toStaffId)).unsigned = false;
                            else if (typeof object.toStaffId === "string")
                                message.toStaffId = parseInt(object.toStaffId, 10);
                            else if (typeof object.toStaffId === "number")
                                message.toStaffId = object.toStaffId;
                            else if (typeof object.toStaffId === "object")
                                message.toStaffId = new $util.LongBits(object.toStaffId.low >>> 0, object.toStaffId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftToSwapRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftToSwapRequest} message ListStaffShiftToSwapRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftToSwapRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromShiftId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.includeStoreInfo = false;
                            object.includeStaffInfo = false;
                            object.includeScheduleAreaInfo = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.toStaffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.toStaffId = options.longs === String ? "0" : 0;
                        }
                        if (message.fromShiftId != null && message.hasOwnProperty("fromShiftId"))
                            if (typeof message.fromShiftId === "number")
                                object.fromShiftId = options.longs === String ? String(message.fromShiftId) : message.fromShiftId;
                            else
                                object.fromShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.fromShiftId) : options.longs === Number ? new $util.LongBits(message.fromShiftId.low >>> 0, message.fromShiftId.high >>> 0).toNumber() : message.fromShiftId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            object.includeStoreInfo = message.includeStoreInfo;
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            object.includeStaffInfo = message.includeStaffInfo;
                        if (message.includeScheduleAreaInfo != null && message.hasOwnProperty("includeScheduleAreaInfo"))
                            object.includeScheduleAreaInfo = message.includeScheduleAreaInfo;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (typeof message.toStaffId === "number")
                                object.toStaffId = options.longs === String ? String(message.toStaffId) : message.toStaffId;
                            else
                                object.toStaffId = options.longs === String ? $util.Long.prototype.toString.call(message.toStaffId) : options.longs === Number ? new $util.LongBits(message.toStaffId.low >>> 0, message.toStaffId.high >>> 0).toNumber() : message.toStaffId;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftToSwapRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftToSwapRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftToSwapRequest;
                })();
    
                v1.ListStaffShiftToSwapResponse = (function() {
    
                    /**
                     * Properties of a ListStaffShiftToSwapResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftToSwapResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShift>|null} [staffShifts] ListStaffShiftToSwapResponse staffShifts
                     * @property {string|null} [nextPageToken] ListStaffShiftToSwapResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffShiftToSwapResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStaffShiftToSwapResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftToSwapResponse.
                     * @implements IListStaffShiftToSwapResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapResponse=} [properties] Properties to set
                     */
                    function ListStaffShiftToSwapResponse(properties) {
                        this.staffShifts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftToSwapResponse staffShifts.
                     * @member {Array.<palexy.streaming.v1.IStaffShift>} staffShifts
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @instance
                     */
                    ListStaffShiftToSwapResponse.prototype.staffShifts = $util.emptyArray;
    
                    /**
                     * ListStaffShiftToSwapResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @instance
                     */
                    ListStaffShiftToSwapResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffShiftToSwapResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @instance
                     */
                    ListStaffShiftToSwapResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListStaffShiftToSwapResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapResponse} ListStaffShiftToSwapResponse instance
                     */
                    ListStaffShiftToSwapResponse.create = function create(properties) {
                        return new ListStaffShiftToSwapResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftToSwapResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftToSwapResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapResponse} message ListStaffShiftToSwapResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftToSwapResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShifts != null && message.staffShifts.length)
                            for (var i = 0; i < message.staffShifts.length; ++i)
                                $root.palexy.streaming.v1.StaffShift.encode(message.staffShifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftToSwapResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftToSwapResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftToSwapResponse} message ListStaffShiftToSwapResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftToSwapResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftToSwapResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapResponse} ListStaffShiftToSwapResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftToSwapResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftToSwapResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShifts && message.staffShifts.length))
                                    message.staffShifts = [];
                                message.staffShifts.push($root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftToSwapResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapResponse} ListStaffShiftToSwapResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftToSwapResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftToSwapResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftToSwapResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShifts != null && message.hasOwnProperty("staffShifts")) {
                            if (!Array.isArray(message.staffShifts))
                                return "staffShifts: array expected";
                            for (var i = 0; i < message.staffShifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShifts[i]);
                                if (error)
                                    return "staffShifts." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftToSwapResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftToSwapResponse} ListStaffShiftToSwapResponse
                     */
                    ListStaffShiftToSwapResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftToSwapResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftToSwapResponse();
                        if (object.staffShifts) {
                            if (!Array.isArray(object.staffShifts))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftToSwapResponse.staffShifts: array expected");
                            message.staffShifts = [];
                            for (var i = 0; i < object.staffShifts.length; ++i) {
                                if (typeof object.staffShifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffShiftToSwapResponse.staffShifts: object expected");
                                message.staffShifts[i] = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShifts[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftToSwapResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftToSwapResponse} message ListStaffShiftToSwapResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftToSwapResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShifts = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.staffShifts && message.staffShifts.length) {
                            object.staffShifts = [];
                            for (var j = 0; j < message.staffShifts.length; ++j)
                                object.staffShifts[j] = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShifts[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftToSwapResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftToSwapResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftToSwapResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftToSwapResponse;
                })();
    
                v1.ClaimShiftRequest = (function() {
    
                    /**
                     * Properties of a ClaimShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IClaimShiftRequest
                     * @property {number|null} [staffId] ClaimShiftRequest staffId
                     * @property {number|null} [shiftId] ClaimShiftRequest shiftId
                     */
    
                    /**
                     * Constructs a new ClaimShiftRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ClaimShiftRequest.
                     * @implements IClaimShiftRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IClaimShiftRequest=} [properties] Properties to set
                     */
                    function ClaimShiftRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ClaimShiftRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @instance
                     */
                    ClaimShiftRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ClaimShiftRequest shiftId.
                     * @member {number} shiftId
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @instance
                     */
                    ClaimShiftRequest.prototype.shiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ClaimShiftRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ClaimShiftRequest} ClaimShiftRequest instance
                     */
                    ClaimShiftRequest.create = function create(properties) {
                        return new ClaimShiftRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ClaimShiftRequest message. Does not implicitly {@link palexy.streaming.v1.ClaimShiftRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftRequest} message ClaimShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ClaimShiftRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                        if (message.shiftId != null && Object.hasOwnProperty.call(message, "shiftId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.shiftId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ClaimShiftRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ClaimShiftRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftRequest} message ClaimShiftRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ClaimShiftRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ClaimShiftRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ClaimShiftRequest} ClaimShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ClaimShiftRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ClaimShiftRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffId = reader.int64();
                                break;
                            case 2:
                                message.shiftId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ClaimShiftRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ClaimShiftRequest} ClaimShiftRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ClaimShiftRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ClaimShiftRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ClaimShiftRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.shiftId != null && message.hasOwnProperty("shiftId"))
                            if (!$util.isInteger(message.shiftId) && !(message.shiftId && $util.isInteger(message.shiftId.low) && $util.isInteger(message.shiftId.high)))
                                return "shiftId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ClaimShiftRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ClaimShiftRequest} ClaimShiftRequest
                     */
                    ClaimShiftRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ClaimShiftRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ClaimShiftRequest();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.shiftId != null)
                            if ($util.Long)
                                (message.shiftId = $util.Long.fromValue(object.shiftId)).unsigned = false;
                            else if (typeof object.shiftId === "string")
                                message.shiftId = parseInt(object.shiftId, 10);
                            else if (typeof object.shiftId === "number")
                                message.shiftId = object.shiftId;
                            else if (typeof object.shiftId === "object")
                                message.shiftId = new $util.LongBits(object.shiftId.low >>> 0, object.shiftId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ClaimShiftRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @static
                     * @param {palexy.streaming.v1.ClaimShiftRequest} message ClaimShiftRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ClaimShiftRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.shiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.shiftId = options.longs === String ? "0" : 0;
                        }
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.shiftId != null && message.hasOwnProperty("shiftId"))
                            if (typeof message.shiftId === "number")
                                object.shiftId = options.longs === String ? String(message.shiftId) : message.shiftId;
                            else
                                object.shiftId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftId) : options.longs === Number ? new $util.LongBits(message.shiftId.low >>> 0, message.shiftId.high >>> 0).toNumber() : message.shiftId;
                        return object;
                    };
    
                    /**
                     * Converts this ClaimShiftRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ClaimShiftRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ClaimShiftRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ClaimShiftRequest;
                })();
    
                v1.ClaimShiftResponse = (function() {
    
                    /**
                     * Properties of a ClaimShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IClaimShiftResponse
                     * @property {palexy.streaming.v1.IStaffShift|null} [staffShift] ClaimShiftResponse staffShift
                     */
    
                    /**
                     * Constructs a new ClaimShiftResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ClaimShiftResponse.
                     * @implements IClaimShiftResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IClaimShiftResponse=} [properties] Properties to set
                     */
                    function ClaimShiftResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ClaimShiftResponse staffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} staffShift
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @instance
                     */
                    ClaimShiftResponse.prototype.staffShift = null;
    
                    /**
                     * Creates a new ClaimShiftResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ClaimShiftResponse} ClaimShiftResponse instance
                     */
                    ClaimShiftResponse.create = function create(properties) {
                        return new ClaimShiftResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ClaimShiftResponse message. Does not implicitly {@link palexy.streaming.v1.ClaimShiftResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftResponse} message ClaimShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ClaimShiftResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShift != null && Object.hasOwnProperty.call(message, "staffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.staffShift, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ClaimShiftResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ClaimShiftResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.IClaimShiftResponse} message ClaimShiftResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ClaimShiftResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ClaimShiftResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ClaimShiftResponse} ClaimShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ClaimShiftResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ClaimShiftResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ClaimShiftResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ClaimShiftResponse} ClaimShiftResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ClaimShiftResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ClaimShiftResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ClaimShiftResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShift != null && message.hasOwnProperty("staffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShift);
                            if (error)
                                return "staffShift." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ClaimShiftResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ClaimShiftResponse} ClaimShiftResponse
                     */
                    ClaimShiftResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ClaimShiftResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ClaimShiftResponse();
                        if (object.staffShift != null) {
                            if (typeof object.staffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.ClaimShiftResponse.staffShift: object expected");
                            message.staffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShift);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ClaimShiftResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @static
                     * @param {palexy.streaming.v1.ClaimShiftResponse} message ClaimShiftResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ClaimShiftResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.staffShift = null;
                        if (message.staffShift != null && message.hasOwnProperty("staffShift"))
                            object.staffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShift, options);
                        return object;
                    };
    
                    /**
                     * Converts this ClaimShiftResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ClaimShiftResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ClaimShiftResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ClaimShiftResponse;
                })();
    
                v1.StaffShiftClaimRequestService = (function() {
    
                    /**
                     * Constructs a new StaffShiftClaimRequestService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftClaimRequestService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffShiftClaimRequestService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffShiftClaimRequestService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffShiftClaimRequestService;
    
                    /**
                     * Creates new StaffShiftClaimRequestService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequestService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffShiftClaimRequestService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffShiftClaimRequestService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftClaimRequestService#listStaffShiftClaimRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequestService
                     * @typedef ListStaffShiftClaimRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} [response] ListStaffShiftClaimRequestResponse
                     */
    
                    /**
                     * Calls ListStaffShiftClaimRequest.
                     * @function listStaffShiftClaimRequest
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest} request ListStaffShiftClaimRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftClaimRequestService.ListStaffShiftClaimRequestCallback} callback Node-style callback called with the error, if any, and ListStaffShiftClaimRequestResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftClaimRequestService.prototype.listStaffShiftClaimRequest = function listStaffShiftClaimRequest(request, callback) {
                        return this.rpcCall(listStaffShiftClaimRequest, $root.palexy.streaming.v1.ListStaffShiftClaimRequestRequest, $root.palexy.streaming.v1.ListStaffShiftClaimRequestResponse, request, callback);
                    }, "name", { value: "ListStaffShiftClaimRequest" });
    
                    /**
                     * Calls ListStaffShiftClaimRequest.
                     * @function listStaffShiftClaimRequest
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest} request ListStaffShiftClaimRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffShiftClaimRequestResponse>} Promise
                     * @variation 2
                     */
    
                    return StaffShiftClaimRequestService;
                })();
    
                v1.ListStaffShiftClaimRequestRequest = (function() {
    
                    /**
                     * Properties of a ListStaffShiftClaimRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftClaimRequestRequest
                     * @property {number|null} [storeId] ListStaffShiftClaimRequestRequest storeId
                     * @property {number|null} [startDateId] ListStaffShiftClaimRequestRequest startDateId
                     * @property {number|null} [endDateId] ListStaffShiftClaimRequestRequest endDateId
                     * @property {boolean|null} [includeStaffInformation] ListStaffShiftClaimRequestRequest includeStaffInformation
                     * @property {boolean|null} [includeStaffShiftInformation] ListStaffShiftClaimRequestRequest includeStaffShiftInformation
                     * @property {number|null} [pageSize] ListStaffShiftClaimRequestRequest pageSize
                     * @property {string|null} [pageToken] ListStaffShiftClaimRequestRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListStaffShiftClaimRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftClaimRequestRequest.
                     * @implements IListStaffShiftClaimRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest=} [properties] Properties to set
                     */
                    function ListStaffShiftClaimRequestRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftClaimRequestRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftClaimRequestRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.startDateId = 0;
    
                    /**
                     * ListStaffShiftClaimRequestRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.endDateId = 0;
    
                    /**
                     * ListStaffShiftClaimRequestRequest includeStaffInformation.
                     * @member {boolean} includeStaffInformation
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.includeStaffInformation = false;
    
                    /**
                     * ListStaffShiftClaimRequestRequest includeStaffShiftInformation.
                     * @member {boolean} includeStaffShiftInformation
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.includeStaffShiftInformation = false;
    
                    /**
                     * ListStaffShiftClaimRequestRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffShiftClaimRequestRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     */
                    ListStaffShiftClaimRequestRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListStaffShiftClaimRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestRequest} ListStaffShiftClaimRequestRequest instance
                     */
                    ListStaffShiftClaimRequestRequest.create = function create(properties) {
                        return new ListStaffShiftClaimRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftClaimRequestRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftClaimRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest} message ListStaffShiftClaimRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftClaimRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.includeStaffInformation != null && Object.hasOwnProperty.call(message, "includeStaffInformation"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeStaffInformation);
                        if (message.includeStaffShiftInformation != null && Object.hasOwnProperty.call(message, "includeStaffShiftInformation"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeStaffShiftInformation);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftClaimRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftClaimRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestRequest} message ListStaffShiftClaimRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftClaimRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftClaimRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestRequest} ListStaffShiftClaimRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftClaimRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftClaimRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.includeStaffInformation = reader.bool();
                                break;
                            case 5:
                                message.includeStaffShiftInformation = reader.bool();
                                break;
                            case 6:
                                message.pageSize = reader.int32();
                                break;
                            case 7:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftClaimRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestRequest} ListStaffShiftClaimRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftClaimRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftClaimRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftClaimRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.includeStaffInformation != null && message.hasOwnProperty("includeStaffInformation"))
                            if (typeof message.includeStaffInformation !== "boolean")
                                return "includeStaffInformation: boolean expected";
                        if (message.includeStaffShiftInformation != null && message.hasOwnProperty("includeStaffShiftInformation"))
                            if (typeof message.includeStaffShiftInformation !== "boolean")
                                return "includeStaffShiftInformation: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftClaimRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestRequest} ListStaffShiftClaimRequestRequest
                     */
                    ListStaffShiftClaimRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftClaimRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftClaimRequestRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.includeStaffInformation != null)
                            message.includeStaffInformation = Boolean(object.includeStaffInformation);
                        if (object.includeStaffShiftInformation != null)
                            message.includeStaffShiftInformation = Boolean(object.includeStaffShiftInformation);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftClaimRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftClaimRequestRequest} message ListStaffShiftClaimRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftClaimRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.includeStaffInformation = false;
                            object.includeStaffShiftInformation = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.includeStaffInformation != null && message.hasOwnProperty("includeStaffInformation"))
                            object.includeStaffInformation = message.includeStaffInformation;
                        if (message.includeStaffShiftInformation != null && message.hasOwnProperty("includeStaffShiftInformation"))
                            object.includeStaffShiftInformation = message.includeStaffShiftInformation;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftClaimRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftClaimRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftClaimRequestRequest;
                })();
    
                v1.ListStaffShiftClaimRequestResponse = (function() {
    
                    /**
                     * Properties of a ListStaffShiftClaimRequestResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftClaimRequestResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShiftClaimRequest>|null} [staffShiftClaimRequests] ListStaffShiftClaimRequestResponse staffShiftClaimRequests
                     * @property {string|null} [nextPageToken] ListStaffShiftClaimRequestResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffShiftClaimRequestResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStaffShiftClaimRequestResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftClaimRequestResponse.
                     * @implements IListStaffShiftClaimRequestResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestResponse=} [properties] Properties to set
                     */
                    function ListStaffShiftClaimRequestResponse(properties) {
                        this.staffShiftClaimRequests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftClaimRequestResponse staffShiftClaimRequests.
                     * @member {Array.<palexy.streaming.v1.IStaffShiftClaimRequest>} staffShiftClaimRequests
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @instance
                     */
                    ListStaffShiftClaimRequestResponse.prototype.staffShiftClaimRequests = $util.emptyArray;
    
                    /**
                     * ListStaffShiftClaimRequestResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @instance
                     */
                    ListStaffShiftClaimRequestResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffShiftClaimRequestResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @instance
                     */
                    ListStaffShiftClaimRequestResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListStaffShiftClaimRequestResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} ListStaffShiftClaimRequestResponse instance
                     */
                    ListStaffShiftClaimRequestResponse.create = function create(properties) {
                        return new ListStaffShiftClaimRequestResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftClaimRequestResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftClaimRequestResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestResponse} message ListStaffShiftClaimRequestResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftClaimRequestResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftClaimRequests != null && message.staffShiftClaimRequests.length)
                            for (var i = 0; i < message.staffShiftClaimRequests.length; ++i)
                                $root.palexy.streaming.v1.StaffShiftClaimRequest.encode(message.staffShiftClaimRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftClaimRequestResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftClaimRequestResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftClaimRequestResponse} message ListStaffShiftClaimRequestResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftClaimRequestResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftClaimRequestResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} ListStaffShiftClaimRequestResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftClaimRequestResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftClaimRequestResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShiftClaimRequests && message.staffShiftClaimRequests.length))
                                    message.staffShiftClaimRequests = [];
                                message.staffShiftClaimRequests.push($root.palexy.streaming.v1.StaffShiftClaimRequest.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftClaimRequestResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} ListStaffShiftClaimRequestResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftClaimRequestResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftClaimRequestResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftClaimRequestResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftClaimRequests != null && message.hasOwnProperty("staffShiftClaimRequests")) {
                            if (!Array.isArray(message.staffShiftClaimRequests))
                                return "staffShiftClaimRequests: array expected";
                            for (var i = 0; i < message.staffShiftClaimRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShiftClaimRequest.verify(message.staffShiftClaimRequests[i]);
                                if (error)
                                    return "staffShiftClaimRequests." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftClaimRequestResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} ListStaffShiftClaimRequestResponse
                     */
                    ListStaffShiftClaimRequestResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftClaimRequestResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftClaimRequestResponse();
                        if (object.staffShiftClaimRequests) {
                            if (!Array.isArray(object.staffShiftClaimRequests))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftClaimRequestResponse.staffShiftClaimRequests: array expected");
                            message.staffShiftClaimRequests = [];
                            for (var i = 0; i < object.staffShiftClaimRequests.length; ++i) {
                                if (typeof object.staffShiftClaimRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffShiftClaimRequestResponse.staffShiftClaimRequests: object expected");
                                message.staffShiftClaimRequests[i] = $root.palexy.streaming.v1.StaffShiftClaimRequest.fromObject(object.staffShiftClaimRequests[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftClaimRequestResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftClaimRequestResponse} message ListStaffShiftClaimRequestResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftClaimRequestResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShiftClaimRequests = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.staffShiftClaimRequests && message.staffShiftClaimRequests.length) {
                            object.staffShiftClaimRequests = [];
                            for (var j = 0; j < message.staffShiftClaimRequests.length; ++j)
                                object.staffShiftClaimRequests[j] = $root.palexy.streaming.v1.StaffShiftClaimRequest.toObject(message.staffShiftClaimRequests[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftClaimRequestResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftClaimRequestResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftClaimRequestResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftClaimRequestResponse;
                })();
    
                v1.StaffShiftClaimRequest = (function() {
    
                    /**
                     * Properties of a StaffShiftClaimRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffShiftClaimRequest
                     * @property {number|null} [id] StaffShiftClaimRequest id
                     * @property {number|null} [staffShiftId] StaffShiftClaimRequest staffShiftId
                     * @property {number|null} [staffId] StaffShiftClaimRequest staffId
                     * @property {palexy.streaming.v1.StaffShiftClaimRequestState|null} [state] StaffShiftClaimRequest state
                     * @property {palexy.streaming.v1.IStaff|null} [staff] StaffShiftClaimRequest staff
                     * @property {palexy.streaming.v1.IStaffShift|null} [staffShift] StaffShiftClaimRequest staffShift
                     * @property {number|null} [createTimeMs] StaffShiftClaimRequest createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] StaffShiftClaimRequest lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new StaffShiftClaimRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftClaimRequest.
                     * @implements IStaffShiftClaimRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffShiftClaimRequest=} [properties] Properties to set
                     */
                    function StaffShiftClaimRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffShiftClaimRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftClaimRequest staffShiftId.
                     * @member {number} staffShiftId
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.staffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftClaimRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftClaimRequest state.
                     * @member {palexy.streaming.v1.StaffShiftClaimRequestState} state
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.state = 0;
    
                    /**
                     * StaffShiftClaimRequest staff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} staff
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.staff = null;
    
                    /**
                     * StaffShiftClaimRequest staffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} staffShift
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.staffShift = null;
    
                    /**
                     * StaffShiftClaimRequest createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftClaimRequest lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     */
                    StaffShiftClaimRequest.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StaffShiftClaimRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftClaimRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffShiftClaimRequest} StaffShiftClaimRequest instance
                     */
                    StaffShiftClaimRequest.create = function create(properties) {
                        return new StaffShiftClaimRequest(properties);
                    };
    
                    /**
                     * Encodes the specified StaffShiftClaimRequest message. Does not implicitly {@link palexy.streaming.v1.StaffShiftClaimRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftClaimRequest} message StaffShiftClaimRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftClaimRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.staffShiftId != null && Object.hasOwnProperty.call(message, "staffShiftId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffShiftId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.state);
                        if (message.staff != null && Object.hasOwnProperty.call(message, "staff"))
                            $root.palexy.streaming.v1.Staff.encode(message.staff, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.staffShift != null && Object.hasOwnProperty.call(message, "staffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.staffShift, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffShiftClaimRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffShiftClaimRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftClaimRequest} message StaffShiftClaimRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftClaimRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffShiftClaimRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffShiftClaimRequest} StaffShiftClaimRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftClaimRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffShiftClaimRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.staffShiftId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.state = reader.int32();
                                break;
                            case 5:
                                message.staff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.staffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffShiftClaimRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffShiftClaimRequest} StaffShiftClaimRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftClaimRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffShiftClaimRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffShiftClaimRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (!$util.isInteger(message.staffShiftId) && !(message.staffShiftId && $util.isInteger(message.staffShiftId.low) && $util.isInteger(message.staffShiftId.high)))
                                return "staffShiftId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.staff != null && message.hasOwnProperty("staff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.staff);
                            if (error)
                                return "staff." + error;
                        }
                        if (message.staffShift != null && message.hasOwnProperty("staffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.staffShift);
                            if (error)
                                return "staffShift." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffShiftClaimRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffShiftClaimRequest} StaffShiftClaimRequest
                     */
                    StaffShiftClaimRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffShiftClaimRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffShiftClaimRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.staffShiftId != null)
                            if ($util.Long)
                                (message.staffShiftId = $util.Long.fromValue(object.staffShiftId)).unsigned = false;
                            else if (typeof object.staffShiftId === "string")
                                message.staffShiftId = parseInt(object.staffShiftId, 10);
                            else if (typeof object.staffShiftId === "number")
                                message.staffShiftId = object.staffShiftId;
                            else if (typeof object.staffShiftId === "object")
                                message.staffShiftId = new $util.LongBits(object.staffShiftId.low >>> 0, object.staffShiftId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        switch (object.state) {
                        case "STAFF_SHIFT_CLAIM_REQUEST_STATE_UNSPECIFIED":
                        case 0:
                            message.state = 0;
                            break;
                        case "APPROVED":
                        case 1:
                            message.state = 1;
                            break;
                        }
                        if (object.staff != null) {
                            if (typeof object.staff !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftClaimRequest.staff: object expected");
                            message.staff = $root.palexy.streaming.v1.Staff.fromObject(object.staff);
                        }
                        if (object.staffShift != null) {
                            if (typeof object.staffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftClaimRequest.staffShift: object expected");
                            message.staffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.staffShift);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffShiftClaimRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @static
                     * @param {palexy.streaming.v1.StaffShiftClaimRequest} message StaffShiftClaimRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffShiftClaimRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.state = options.enums === String ? "STAFF_SHIFT_CLAIM_REQUEST_STATE_UNSPECIFIED" : 0;
                            object.staff = null;
                            object.staffShift = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                            if (typeof message.staffShiftId === "number")
                                object.staffShiftId = options.longs === String ? String(message.staffShiftId) : message.staffShiftId;
                            else
                                object.staffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftId) : options.longs === Number ? new $util.LongBits(message.staffShiftId.low >>> 0, message.staffShiftId.high >>> 0).toNumber() : message.staffShiftId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StaffShiftClaimRequestState[message.state] : message.state;
                        if (message.staff != null && message.hasOwnProperty("staff"))
                            object.staff = $root.palexy.streaming.v1.Staff.toObject(message.staff, options);
                        if (message.staffShift != null && message.hasOwnProperty("staffShift"))
                            object.staffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.staffShift, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this StaffShiftClaimRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffShiftClaimRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffShiftClaimRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffShiftClaimRequest;
                })();
    
                /**
                 * StaffShiftClaimRequestState enum.
                 * @name palexy.streaming.v1.StaffShiftClaimRequestState
                 * @enum {number}
                 * @property {number} STAFF_SHIFT_CLAIM_REQUEST_STATE_UNSPECIFIED=0 STAFF_SHIFT_CLAIM_REQUEST_STATE_UNSPECIFIED value
                 * @property {number} APPROVED=1 APPROVED value
                 */
                v1.StaffShiftClaimRequestState = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STAFF_SHIFT_CLAIM_REQUEST_STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "APPROVED"] = 1;
                    return values;
                })();
    
                v1.StaffShiftSwapRequestService = (function() {
    
                    /**
                     * Constructs a new StaffShiftSwapRequestService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftSwapRequestService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StaffShiftSwapRequestService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StaffShiftSwapRequestService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StaffShiftSwapRequestService;
    
                    /**
                     * Creates new StaffShiftSwapRequestService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StaffShiftSwapRequestService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StaffShiftSwapRequestService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#getStaffShiftSwapRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef GetStaffShiftSwapRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShiftSwapRequest} [response] StaffShiftSwapRequest
                     */
    
                    /**
                     * Calls GetStaffShiftSwapRequest.
                     * @function getStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest} request GetStaffShiftSwapRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.GetStaffShiftSwapRequestCallback} callback Node-style callback called with the error, if any, and StaffShiftSwapRequest
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.getStaffShiftSwapRequest = function getStaffShiftSwapRequest(request, callback) {
                        return this.rpcCall(getStaffShiftSwapRequest, $root.palexy.streaming.v1.GetStaffShiftSwapRequestRequest, $root.palexy.streaming.v1.StaffShiftSwapRequest, request, callback);
                    }, "name", { value: "GetStaffShiftSwapRequest" });
    
                    /**
                     * Calls GetStaffShiftSwapRequest.
                     * @function getStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest} request GetStaffShiftSwapRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShiftSwapRequest>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#listStaffShiftSwapRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef ListStaffShiftSwapRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} [response] ListStaffShiftSwapRequestResponse
                     */
    
                    /**
                     * Calls ListStaffShiftSwapRequest.
                     * @function listStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest} request ListStaffShiftSwapRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.ListStaffShiftSwapRequestCallback} callback Node-style callback called with the error, if any, and ListStaffShiftSwapRequestResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.listStaffShiftSwapRequest = function listStaffShiftSwapRequest(request, callback) {
                        return this.rpcCall(listStaffShiftSwapRequest, $root.palexy.streaming.v1.ListStaffShiftSwapRequestRequest, $root.palexy.streaming.v1.ListStaffShiftSwapRequestResponse, request, callback);
                    }, "name", { value: "ListStaffShiftSwapRequest" });
    
                    /**
                     * Calls ListStaffShiftSwapRequest.
                     * @function listStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest} request ListStaffShiftSwapRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffShiftSwapRequestResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#listStaffShiftSwapRequestHistory}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef ListStaffShiftSwapRequestHistoryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} [response] ListStaffShiftSwapRequestHistoryResponse
                     */
    
                    /**
                     * Calls ListStaffShiftSwapRequestHistory.
                     * @function listStaffShiftSwapRequestHistory
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest} request ListStaffShiftSwapRequestHistoryRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.ListStaffShiftSwapRequestHistoryCallback} callback Node-style callback called with the error, if any, and ListStaffShiftSwapRequestHistoryResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.listStaffShiftSwapRequestHistory = function listStaffShiftSwapRequestHistory(request, callback) {
                        return this.rpcCall(listStaffShiftSwapRequestHistory, $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest, $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse, request, callback);
                    }, "name", { value: "ListStaffShiftSwapRequestHistory" });
    
                    /**
                     * Calls ListStaffShiftSwapRequestHistory.
                     * @function listStaffShiftSwapRequestHistory
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest} request ListStaffShiftSwapRequestHistoryRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#createStaffShiftSwapRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef CreateStaffShiftSwapRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShiftSwapRequest} [response] StaffShiftSwapRequest
                     */
    
                    /**
                     * Calls CreateStaffShiftSwapRequest.
                     * @function createStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest} request CreateStaffShiftSwapRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.CreateStaffShiftSwapRequestCallback} callback Node-style callback called with the error, if any, and StaffShiftSwapRequest
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.createStaffShiftSwapRequest = function createStaffShiftSwapRequest(request, callback) {
                        return this.rpcCall(createStaffShiftSwapRequest, $root.palexy.streaming.v1.CreateStaffShiftSwapRequestRequest, $root.palexy.streaming.v1.StaffShiftSwapRequest, request, callback);
                    }, "name", { value: "CreateStaffShiftSwapRequest" });
    
                    /**
                     * Calls CreateStaffShiftSwapRequest.
                     * @function createStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest} request CreateStaffShiftSwapRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShiftSwapRequest>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#approveStaffShiftSwapRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef ApproveStaffShiftSwapRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShiftSwapRequest} [response] StaffShiftSwapRequest
                     */
    
                    /**
                     * Calls ApproveStaffShiftSwapRequest.
                     * @function approveStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest} request ApproveStaffShiftSwapRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.ApproveStaffShiftSwapRequestCallback} callback Node-style callback called with the error, if any, and StaffShiftSwapRequest
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.approveStaffShiftSwapRequest = function approveStaffShiftSwapRequest(request, callback) {
                        return this.rpcCall(approveStaffShiftSwapRequest, $root.palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest, $root.palexy.streaming.v1.StaffShiftSwapRequest, request, callback);
                    }, "name", { value: "ApproveStaffShiftSwapRequest" });
    
                    /**
                     * Calls ApproveStaffShiftSwapRequest.
                     * @function approveStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest} request ApproveStaffShiftSwapRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShiftSwapRequest>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.StaffShiftSwapRequestService#rejectStaffShiftSwapRequest}.
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @typedef RejectStaffShiftSwapRequestCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.StaffShiftSwapRequest} [response] StaffShiftSwapRequest
                     */
    
                    /**
                     * Calls RejectStaffShiftSwapRequest.
                     * @function rejectStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest} request RejectStaffShiftSwapRequestRequest message or plain object
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestService.RejectStaffShiftSwapRequestCallback} callback Node-style callback called with the error, if any, and StaffShiftSwapRequest
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StaffShiftSwapRequestService.prototype.rejectStaffShiftSwapRequest = function rejectStaffShiftSwapRequest(request, callback) {
                        return this.rpcCall(rejectStaffShiftSwapRequest, $root.palexy.streaming.v1.RejectStaffShiftSwapRequestRequest, $root.palexy.streaming.v1.StaffShiftSwapRequest, request, callback);
                    }, "name", { value: "RejectStaffShiftSwapRequest" });
    
                    /**
                     * Calls RejectStaffShiftSwapRequest.
                     * @function rejectStaffShiftSwapRequest
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestService
                     * @instance
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest} request RejectStaffShiftSwapRequestRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.StaffShiftSwapRequest>} Promise
                     * @variation 2
                     */
    
                    return StaffShiftSwapRequestService;
                })();
    
                v1.GetStaffShiftSwapRequestRequest = (function() {
    
                    /**
                     * Properties of a GetStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetStaffShiftSwapRequestRequest
                     * @property {number|null} [id] GetStaffShiftSwapRequestRequest id
                     * @property {boolean|null} [includeStaffInfo] GetStaffShiftSwapRequestRequest includeStaffInfo
                     * @property {boolean|null} [includeStaffShiftInfo] GetStaffShiftSwapRequestRequest includeStaffShiftInfo
                     * @property {boolean|null} [includeStoreInfo] GetStaffShiftSwapRequestRequest includeStoreInfo
                     */
    
                    /**
                     * Constructs a new GetStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetStaffShiftSwapRequestRequest.
                     * @implements IGetStaffShiftSwapRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest=} [properties] Properties to set
                     */
                    function GetStaffShiftSwapRequestRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStaffShiftSwapRequestRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @instance
                     */
                    GetStaffShiftSwapRequestRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetStaffShiftSwapRequestRequest includeStaffInfo.
                     * @member {boolean} includeStaffInfo
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @instance
                     */
                    GetStaffShiftSwapRequestRequest.prototype.includeStaffInfo = false;
    
                    /**
                     * GetStaffShiftSwapRequestRequest includeStaffShiftInfo.
                     * @member {boolean} includeStaffShiftInfo
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @instance
                     */
                    GetStaffShiftSwapRequestRequest.prototype.includeStaffShiftInfo = false;
    
                    /**
                     * GetStaffShiftSwapRequestRequest includeStoreInfo.
                     * @member {boolean} includeStoreInfo
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @instance
                     */
                    GetStaffShiftSwapRequestRequest.prototype.includeStoreInfo = false;
    
                    /**
                     * Creates a new GetStaffShiftSwapRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetStaffShiftSwapRequestRequest} GetStaffShiftSwapRequestRequest instance
                     */
                    GetStaffShiftSwapRequestRequest.create = function create(properties) {
                        return new GetStaffShiftSwapRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStaffShiftSwapRequestRequest message. Does not implicitly {@link palexy.streaming.v1.GetStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest} message GetStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffShiftSwapRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.includeStaffInfo != null && Object.hasOwnProperty.call(message, "includeStaffInfo"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeStaffInfo);
                        if (message.includeStaffShiftInfo != null && Object.hasOwnProperty.call(message, "includeStaffShiftInfo"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.includeStaffShiftInfo);
                        if (message.includeStoreInfo != null && Object.hasOwnProperty.call(message, "includeStoreInfo"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeStoreInfo);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStaffShiftSwapRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetStaffShiftSwapRequestRequest} message GetStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStaffShiftSwapRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStaffShiftSwapRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetStaffShiftSwapRequestRequest} GetStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffShiftSwapRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetStaffShiftSwapRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.includeStaffInfo = reader.bool();
                                break;
                            case 3:
                                message.includeStaffShiftInfo = reader.bool();
                                break;
                            case 4:
                                message.includeStoreInfo = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStaffShiftSwapRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetStaffShiftSwapRequestRequest} GetStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStaffShiftSwapRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStaffShiftSwapRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStaffShiftSwapRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            if (typeof message.includeStaffInfo !== "boolean")
                                return "includeStaffInfo: boolean expected";
                        if (message.includeStaffShiftInfo != null && message.hasOwnProperty("includeStaffShiftInfo"))
                            if (typeof message.includeStaffShiftInfo !== "boolean")
                                return "includeStaffShiftInfo: boolean expected";
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            if (typeof message.includeStoreInfo !== "boolean")
                                return "includeStoreInfo: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStaffShiftSwapRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetStaffShiftSwapRequestRequest} GetStaffShiftSwapRequestRequest
                     */
                    GetStaffShiftSwapRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetStaffShiftSwapRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetStaffShiftSwapRequestRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.includeStaffInfo != null)
                            message.includeStaffInfo = Boolean(object.includeStaffInfo);
                        if (object.includeStaffShiftInfo != null)
                            message.includeStaffShiftInfo = Boolean(object.includeStaffShiftInfo);
                        if (object.includeStoreInfo != null)
                            message.includeStoreInfo = Boolean(object.includeStoreInfo);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStaffShiftSwapRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.GetStaffShiftSwapRequestRequest} message GetStaffShiftSwapRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStaffShiftSwapRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.includeStaffInfo = false;
                            object.includeStaffShiftInfo = false;
                            object.includeStoreInfo = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            object.includeStaffInfo = message.includeStaffInfo;
                        if (message.includeStaffShiftInfo != null && message.hasOwnProperty("includeStaffShiftInfo"))
                            object.includeStaffShiftInfo = message.includeStaffShiftInfo;
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            object.includeStoreInfo = message.includeStoreInfo;
                        return object;
                    };
    
                    /**
                     * Converts this GetStaffShiftSwapRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetStaffShiftSwapRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStaffShiftSwapRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStaffShiftSwapRequestRequest;
                })();
    
                v1.ListStaffShiftSwapRequestRequest = (function() {
    
                    /**
                     * Properties of a ListStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftSwapRequestRequest
                     * @property {number|null} [storeId] ListStaffShiftSwapRequestRequest storeId
                     * @property {number|null} [fromStaffId] ListStaffShiftSwapRequestRequest fromStaffId
                     * @property {number|null} [toStaffId] ListStaffShiftSwapRequestRequest toStaffId
                     * @property {number|null} [fromStaffShiftId] ListStaffShiftSwapRequestRequest fromStaffShiftId
                     * @property {Array.<palexy.streaming.v1.StaffShiftSwapRequest.State>|null} [states] ListStaffShiftSwapRequestRequest states
                     * @property {number|null} [minCreateTimeMs] ListStaffShiftSwapRequestRequest minCreateTimeMs
                     * @property {number|null} [maxCreateTimeMs] ListStaffShiftSwapRequestRequest maxCreateTimeMs
                     * @property {boolean|null} [includeStoreInfo] ListStaffShiftSwapRequestRequest includeStoreInfo
                     * @property {boolean|null} [includeStaffInfo] ListStaffShiftSwapRequestRequest includeStaffInfo
                     * @property {boolean|null} [includeStaffShiftInfo] ListStaffShiftSwapRequestRequest includeStaffShiftInfo
                     * @property {number|null} [pageSize] ListStaffShiftSwapRequestRequest pageSize
                     * @property {string|null} [pageToken] ListStaffShiftSwapRequestRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftSwapRequestRequest.
                     * @implements IListStaffShiftSwapRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest=} [properties] Properties to set
                     */
                    function ListStaffShiftSwapRequestRequest(properties) {
                        this.states = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftSwapRequestRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest fromStaffId.
                     * @member {number} fromStaffId
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.fromStaffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest toStaffId.
                     * @member {number} toStaffId
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.toStaffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest fromStaffShiftId.
                     * @member {number} fromStaffShiftId
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.fromStaffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest states.
                     * @member {Array.<palexy.streaming.v1.StaffShiftSwapRequest.State>} states
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.states = $util.emptyArray;
    
                    /**
                     * ListStaffShiftSwapRequestRequest minCreateTimeMs.
                     * @member {number} minCreateTimeMs
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.minCreateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest maxCreateTimeMs.
                     * @member {number} maxCreateTimeMs
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.maxCreateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest includeStoreInfo.
                     * @member {boolean} includeStoreInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.includeStoreInfo = false;
    
                    /**
                     * ListStaffShiftSwapRequestRequest includeStaffInfo.
                     * @member {boolean} includeStaffInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.includeStaffInfo = false;
    
                    /**
                     * ListStaffShiftSwapRequestRequest includeStaffShiftInfo.
                     * @member {boolean} includeStaffShiftInfo
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.includeStaffShiftInfo = false;
    
                    /**
                     * ListStaffShiftSwapRequestRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffShiftSwapRequestRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListStaffShiftSwapRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestRequest} ListStaffShiftSwapRequestRequest instance
                     */
                    ListStaffShiftSwapRequestRequest.create = function create(properties) {
                        return new ListStaffShiftSwapRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest} message ListStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.fromStaffId != null && Object.hasOwnProperty.call(message, "fromStaffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.fromStaffId);
                        if (message.toStaffId != null && Object.hasOwnProperty.call(message, "toStaffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.toStaffId);
                        if (message.fromStaffShiftId != null && Object.hasOwnProperty.call(message, "fromStaffShiftId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.fromStaffShiftId);
                        if (message.states != null && message.states.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.states.length; ++i)
                                writer.int32(message.states[i]);
                            writer.ldelim();
                        }
                        if (message.minCreateTimeMs != null && Object.hasOwnProperty.call(message, "minCreateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.minCreateTimeMs);
                        if (message.maxCreateTimeMs != null && Object.hasOwnProperty.call(message, "maxCreateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.maxCreateTimeMs);
                        if (message.includeStoreInfo != null && Object.hasOwnProperty.call(message, "includeStoreInfo"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.includeStoreInfo);
                        if (message.includeStaffInfo != null && Object.hasOwnProperty.call(message, "includeStaffInfo"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.includeStaffInfo);
                        if (message.includeStaffShiftInfo != null && Object.hasOwnProperty.call(message, "includeStaffShiftInfo"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.includeStaffShiftInfo);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestRequest} message ListStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestRequest} ListStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.fromStaffId = reader.int64();
                                break;
                            case 3:
                                message.toStaffId = reader.int64();
                                break;
                            case 4:
                                message.fromStaffShiftId = reader.int64();
                                break;
                            case 5:
                                if (!(message.states && message.states.length))
                                    message.states = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.states.push(reader.int32());
                                } else
                                    message.states.push(reader.int32());
                                break;
                            case 6:
                                message.minCreateTimeMs = reader.int64();
                                break;
                            case 7:
                                message.maxCreateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.includeStoreInfo = reader.bool();
                                break;
                            case 9:
                                message.includeStaffInfo = reader.bool();
                                break;
                            case 10:
                                message.includeStaffShiftInfo = reader.bool();
                                break;
                            case 11:
                                message.pageSize = reader.int32();
                                break;
                            case 12:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestRequest} ListStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftSwapRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftSwapRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.fromStaffId != null && message.hasOwnProperty("fromStaffId"))
                            if (!$util.isInteger(message.fromStaffId) && !(message.fromStaffId && $util.isInteger(message.fromStaffId.low) && $util.isInteger(message.fromStaffId.high)))
                                return "fromStaffId: integer|Long expected";
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (!$util.isInteger(message.toStaffId) && !(message.toStaffId && $util.isInteger(message.toStaffId.low) && $util.isInteger(message.toStaffId.high)))
                                return "toStaffId: integer|Long expected";
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (!$util.isInteger(message.fromStaffShiftId) && !(message.fromStaffShiftId && $util.isInteger(message.fromStaffShiftId.low) && $util.isInteger(message.fromStaffShiftId.high)))
                                return "fromStaffShiftId: integer|Long expected";
                        if (message.states != null && message.hasOwnProperty("states")) {
                            if (!Array.isArray(message.states))
                                return "states: array expected";
                            for (var i = 0; i < message.states.length; ++i)
                                switch (message.states[i]) {
                                default:
                                    return "states: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        if (message.minCreateTimeMs != null && message.hasOwnProperty("minCreateTimeMs"))
                            if (!$util.isInteger(message.minCreateTimeMs) && !(message.minCreateTimeMs && $util.isInteger(message.minCreateTimeMs.low) && $util.isInteger(message.minCreateTimeMs.high)))
                                return "minCreateTimeMs: integer|Long expected";
                        if (message.maxCreateTimeMs != null && message.hasOwnProperty("maxCreateTimeMs"))
                            if (!$util.isInteger(message.maxCreateTimeMs) && !(message.maxCreateTimeMs && $util.isInteger(message.maxCreateTimeMs.low) && $util.isInteger(message.maxCreateTimeMs.high)))
                                return "maxCreateTimeMs: integer|Long expected";
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            if (typeof message.includeStoreInfo !== "boolean")
                                return "includeStoreInfo: boolean expected";
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            if (typeof message.includeStaffInfo !== "boolean")
                                return "includeStaffInfo: boolean expected";
                        if (message.includeStaffShiftInfo != null && message.hasOwnProperty("includeStaffShiftInfo"))
                            if (typeof message.includeStaffShiftInfo !== "boolean")
                                return "includeStaffShiftInfo: boolean expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftSwapRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestRequest} ListStaffShiftSwapRequestRequest
                     */
                    ListStaffShiftSwapRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftSwapRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.fromStaffId != null)
                            if ($util.Long)
                                (message.fromStaffId = $util.Long.fromValue(object.fromStaffId)).unsigned = false;
                            else if (typeof object.fromStaffId === "string")
                                message.fromStaffId = parseInt(object.fromStaffId, 10);
                            else if (typeof object.fromStaffId === "number")
                                message.fromStaffId = object.fromStaffId;
                            else if (typeof object.fromStaffId === "object")
                                message.fromStaffId = new $util.LongBits(object.fromStaffId.low >>> 0, object.fromStaffId.high >>> 0).toNumber();
                        if (object.toStaffId != null)
                            if ($util.Long)
                                (message.toStaffId = $util.Long.fromValue(object.toStaffId)).unsigned = false;
                            else if (typeof object.toStaffId === "string")
                                message.toStaffId = parseInt(object.toStaffId, 10);
                            else if (typeof object.toStaffId === "number")
                                message.toStaffId = object.toStaffId;
                            else if (typeof object.toStaffId === "object")
                                message.toStaffId = new $util.LongBits(object.toStaffId.low >>> 0, object.toStaffId.high >>> 0).toNumber();
                        if (object.fromStaffShiftId != null)
                            if ($util.Long)
                                (message.fromStaffShiftId = $util.Long.fromValue(object.fromStaffShiftId)).unsigned = false;
                            else if (typeof object.fromStaffShiftId === "string")
                                message.fromStaffShiftId = parseInt(object.fromStaffShiftId, 10);
                            else if (typeof object.fromStaffShiftId === "number")
                                message.fromStaffShiftId = object.fromStaffShiftId;
                            else if (typeof object.fromStaffShiftId === "object")
                                message.fromStaffShiftId = new $util.LongBits(object.fromStaffShiftId.low >>> 0, object.fromStaffShiftId.high >>> 0).toNumber();
                        if (object.states) {
                            if (!Array.isArray(object.states))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftSwapRequestRequest.states: array expected");
                            message.states = [];
                            for (var i = 0; i < object.states.length; ++i)
                                switch (object.states[i]) {
                                default:
                                case "STATE_UNSPECIFIED":
                                case 0:
                                    message.states[i] = 0;
                                    break;
                                case "PENDING":
                                case 1:
                                    message.states[i] = 1;
                                    break;
                                case "APPROVED_BY_RECEIVER":
                                case 2:
                                    message.states[i] = 2;
                                    break;
                                case "COMPLETED":
                                case 3:
                                    message.states[i] = 3;
                                    break;
                                case "REJECTED":
                                case 4:
                                    message.states[i] = 4;
                                    break;
                                }
                        }
                        if (object.minCreateTimeMs != null)
                            if ($util.Long)
                                (message.minCreateTimeMs = $util.Long.fromValue(object.minCreateTimeMs)).unsigned = false;
                            else if (typeof object.minCreateTimeMs === "string")
                                message.minCreateTimeMs = parseInt(object.minCreateTimeMs, 10);
                            else if (typeof object.minCreateTimeMs === "number")
                                message.minCreateTimeMs = object.minCreateTimeMs;
                            else if (typeof object.minCreateTimeMs === "object")
                                message.minCreateTimeMs = new $util.LongBits(object.minCreateTimeMs.low >>> 0, object.minCreateTimeMs.high >>> 0).toNumber();
                        if (object.maxCreateTimeMs != null)
                            if ($util.Long)
                                (message.maxCreateTimeMs = $util.Long.fromValue(object.maxCreateTimeMs)).unsigned = false;
                            else if (typeof object.maxCreateTimeMs === "string")
                                message.maxCreateTimeMs = parseInt(object.maxCreateTimeMs, 10);
                            else if (typeof object.maxCreateTimeMs === "number")
                                message.maxCreateTimeMs = object.maxCreateTimeMs;
                            else if (typeof object.maxCreateTimeMs === "object")
                                message.maxCreateTimeMs = new $util.LongBits(object.maxCreateTimeMs.low >>> 0, object.maxCreateTimeMs.high >>> 0).toNumber();
                        if (object.includeStoreInfo != null)
                            message.includeStoreInfo = Boolean(object.includeStoreInfo);
                        if (object.includeStaffInfo != null)
                            message.includeStaffInfo = Boolean(object.includeStaffInfo);
                        if (object.includeStaffShiftInfo != null)
                            message.includeStaffShiftInfo = Boolean(object.includeStaffShiftInfo);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftSwapRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestRequest} message ListStaffShiftSwapRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftSwapRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.states = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromStaffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromStaffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.toStaffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.toStaffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromStaffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromStaffShiftId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.minCreateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.minCreateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.maxCreateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.maxCreateTimeMs = options.longs === String ? "0" : 0;
                            object.includeStoreInfo = false;
                            object.includeStaffInfo = false;
                            object.includeStaffShiftInfo = false;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.fromStaffId != null && message.hasOwnProperty("fromStaffId"))
                            if (typeof message.fromStaffId === "number")
                                object.fromStaffId = options.longs === String ? String(message.fromStaffId) : message.fromStaffId;
                            else
                                object.fromStaffId = options.longs === String ? $util.Long.prototype.toString.call(message.fromStaffId) : options.longs === Number ? new $util.LongBits(message.fromStaffId.low >>> 0, message.fromStaffId.high >>> 0).toNumber() : message.fromStaffId;
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (typeof message.toStaffId === "number")
                                object.toStaffId = options.longs === String ? String(message.toStaffId) : message.toStaffId;
                            else
                                object.toStaffId = options.longs === String ? $util.Long.prototype.toString.call(message.toStaffId) : options.longs === Number ? new $util.LongBits(message.toStaffId.low >>> 0, message.toStaffId.high >>> 0).toNumber() : message.toStaffId;
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (typeof message.fromStaffShiftId === "number")
                                object.fromStaffShiftId = options.longs === String ? String(message.fromStaffShiftId) : message.fromStaffShiftId;
                            else
                                object.fromStaffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.fromStaffShiftId) : options.longs === Number ? new $util.LongBits(message.fromStaffShiftId.low >>> 0, message.fromStaffShiftId.high >>> 0).toNumber() : message.fromStaffShiftId;
                        if (message.states && message.states.length) {
                            object.states = [];
                            for (var j = 0; j < message.states.length; ++j)
                                object.states[j] = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequest.State[message.states[j]] : message.states[j];
                        }
                        if (message.minCreateTimeMs != null && message.hasOwnProperty("minCreateTimeMs"))
                            if (typeof message.minCreateTimeMs === "number")
                                object.minCreateTimeMs = options.longs === String ? String(message.minCreateTimeMs) : message.minCreateTimeMs;
                            else
                                object.minCreateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.minCreateTimeMs) : options.longs === Number ? new $util.LongBits(message.minCreateTimeMs.low >>> 0, message.minCreateTimeMs.high >>> 0).toNumber() : message.minCreateTimeMs;
                        if (message.maxCreateTimeMs != null && message.hasOwnProperty("maxCreateTimeMs"))
                            if (typeof message.maxCreateTimeMs === "number")
                                object.maxCreateTimeMs = options.longs === String ? String(message.maxCreateTimeMs) : message.maxCreateTimeMs;
                            else
                                object.maxCreateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.maxCreateTimeMs) : options.longs === Number ? new $util.LongBits(message.maxCreateTimeMs.low >>> 0, message.maxCreateTimeMs.high >>> 0).toNumber() : message.maxCreateTimeMs;
                        if (message.includeStoreInfo != null && message.hasOwnProperty("includeStoreInfo"))
                            object.includeStoreInfo = message.includeStoreInfo;
                        if (message.includeStaffInfo != null && message.hasOwnProperty("includeStaffInfo"))
                            object.includeStaffInfo = message.includeStaffInfo;
                        if (message.includeStaffShiftInfo != null && message.hasOwnProperty("includeStaffShiftInfo"))
                            object.includeStaffShiftInfo = message.includeStaffShiftInfo;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftSwapRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftSwapRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftSwapRequestRequest;
                })();
    
                v1.ListStaffShiftSwapRequestResponse = (function() {
    
                    /**
                     * Properties of a ListStaffShiftSwapRequestResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftSwapRequestResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShiftSwapRequest>|null} [staffShiftSwapRequests] ListStaffShiftSwapRequestResponse staffShiftSwapRequests
                     * @property {string|null} [nextPageToken] ListStaffShiftSwapRequestResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffShiftSwapRequestResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStaffShiftSwapRequestResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftSwapRequestResponse.
                     * @implements IListStaffShiftSwapRequestResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestResponse=} [properties] Properties to set
                     */
                    function ListStaffShiftSwapRequestResponse(properties) {
                        this.staffShiftSwapRequests = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftSwapRequestResponse staffShiftSwapRequests.
                     * @member {Array.<palexy.streaming.v1.IStaffShiftSwapRequest>} staffShiftSwapRequests
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestResponse.prototype.staffShiftSwapRequests = $util.emptyArray;
    
                    /**
                     * ListStaffShiftSwapRequestResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffShiftSwapRequestResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListStaffShiftSwapRequestResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} ListStaffShiftSwapRequestResponse instance
                     */
                    ListStaffShiftSwapRequestResponse.create = function create(properties) {
                        return new ListStaffShiftSwapRequestResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestResponse} message ListStaffShiftSwapRequestResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftSwapRequests != null && message.staffShiftSwapRequests.length)
                            for (var i = 0; i < message.staffShiftSwapRequests.length; ++i)
                                $root.palexy.streaming.v1.StaffShiftSwapRequest.encode(message.staffShiftSwapRequests[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestResponse} message ListStaffShiftSwapRequestResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} ListStaffShiftSwapRequestResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShiftSwapRequests && message.staffShiftSwapRequests.length))
                                    message.staffShiftSwapRequests = [];
                                message.staffShiftSwapRequests.push($root.palexy.streaming.v1.StaffShiftSwapRequest.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} ListStaffShiftSwapRequestResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftSwapRequestResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftSwapRequestResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftSwapRequests != null && message.hasOwnProperty("staffShiftSwapRequests")) {
                            if (!Array.isArray(message.staffShiftSwapRequests))
                                return "staffShiftSwapRequests: array expected";
                            for (var i = 0; i < message.staffShiftSwapRequests.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShiftSwapRequest.verify(message.staffShiftSwapRequests[i]);
                                if (error)
                                    return "staffShiftSwapRequests." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftSwapRequestResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} ListStaffShiftSwapRequestResponse
                     */
                    ListStaffShiftSwapRequestResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftSwapRequestResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestResponse();
                        if (object.staffShiftSwapRequests) {
                            if (!Array.isArray(object.staffShiftSwapRequests))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftSwapRequestResponse.staffShiftSwapRequests: array expected");
                            message.staffShiftSwapRequests = [];
                            for (var i = 0; i < object.staffShiftSwapRequests.length; ++i) {
                                if (typeof object.staffShiftSwapRequests[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffShiftSwapRequestResponse.staffShiftSwapRequests: object expected");
                                message.staffShiftSwapRequests[i] = $root.palexy.streaming.v1.StaffShiftSwapRequest.fromObject(object.staffShiftSwapRequests[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftSwapRequestResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestResponse} message ListStaffShiftSwapRequestResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftSwapRequestResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShiftSwapRequests = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.staffShiftSwapRequests && message.staffShiftSwapRequests.length) {
                            object.staffShiftSwapRequests = [];
                            for (var j = 0; j < message.staffShiftSwapRequests.length; ++j)
                                object.staffShiftSwapRequests[j] = $root.palexy.streaming.v1.StaffShiftSwapRequest.toObject(message.staffShiftSwapRequests[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftSwapRequestResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftSwapRequestResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftSwapRequestResponse;
                })();
    
                v1.ListStaffShiftSwapRequestHistoryRequest = (function() {
    
                    /**
                     * Properties of a ListStaffShiftSwapRequestHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftSwapRequestHistoryRequest
                     * @property {number|null} [staffShiftSwapRequestId] ListStaffShiftSwapRequestHistoryRequest staffShiftSwapRequestId
                     * @property {number|null} [pageSize] ListStaffShiftSwapRequestHistoryRequest pageSize
                     * @property {string|null} [pageToken] ListStaffShiftSwapRequestHistoryRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListStaffShiftSwapRequestHistoryRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftSwapRequestHistoryRequest.
                     * @implements IListStaffShiftSwapRequestHistoryRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest=} [properties] Properties to set
                     */
                    function ListStaffShiftSwapRequestHistoryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftSwapRequestHistoryRequest staffShiftSwapRequestId.
                     * @member {number} staffShiftSwapRequestId
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryRequest.prototype.staffShiftSwapRequestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStaffShiftSwapRequestHistoryRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStaffShiftSwapRequestHistoryRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListStaffShiftSwapRequestHistoryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest} ListStaffShiftSwapRequestHistoryRequest instance
                     */
                    ListStaffShiftSwapRequestHistoryRequest.create = function create(properties) {
                        return new ListStaffShiftSwapRequestHistoryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestHistoryRequest message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest} message ListStaffShiftSwapRequestHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestHistoryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftSwapRequestId != null && Object.hasOwnProperty.call(message, "staffShiftSwapRequestId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffShiftSwapRequestId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestHistoryRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryRequest} message ListStaffShiftSwapRequestHistoryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestHistoryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestHistoryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest} ListStaffShiftSwapRequestHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestHistoryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShiftSwapRequestId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestHistoryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest} ListStaffShiftSwapRequestHistoryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestHistoryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftSwapRequestHistoryRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftSwapRequestHistoryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (!$util.isInteger(message.staffShiftSwapRequestId) && !(message.staffShiftSwapRequestId && $util.isInteger(message.staffShiftSwapRequestId.low) && $util.isInteger(message.staffShiftSwapRequestId.high)))
                                return "staffShiftSwapRequestId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftSwapRequestHistoryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest} ListStaffShiftSwapRequestHistoryRequest
                     */
                    ListStaffShiftSwapRequestHistoryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest();
                        if (object.staffShiftSwapRequestId != null)
                            if ($util.Long)
                                (message.staffShiftSwapRequestId = $util.Long.fromValue(object.staffShiftSwapRequestId)).unsigned = false;
                            else if (typeof object.staffShiftSwapRequestId === "string")
                                message.staffShiftSwapRequestId = parseInt(object.staffShiftSwapRequestId, 10);
                            else if (typeof object.staffShiftSwapRequestId === "number")
                                message.staffShiftSwapRequestId = object.staffShiftSwapRequestId;
                            else if (typeof object.staffShiftSwapRequestId === "object")
                                message.staffShiftSwapRequestId = new $util.LongBits(object.staffShiftSwapRequestId.low >>> 0, object.staffShiftSwapRequestId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftSwapRequestHistoryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest} message ListStaffShiftSwapRequestHistoryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftSwapRequestHistoryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftSwapRequestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftSwapRequestId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (typeof message.staffShiftSwapRequestId === "number")
                                object.staffShiftSwapRequestId = options.longs === String ? String(message.staffShiftSwapRequestId) : message.staffShiftSwapRequestId;
                            else
                                object.staffShiftSwapRequestId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftSwapRequestId) : options.longs === Number ? new $util.LongBits(message.staffShiftSwapRequestId.low >>> 0, message.staffShiftSwapRequestId.high >>> 0).toNumber() : message.staffShiftSwapRequestId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftSwapRequestHistoryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftSwapRequestHistoryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftSwapRequestHistoryRequest;
                })();
    
                v1.ListStaffShiftSwapRequestHistoryResponse = (function() {
    
                    /**
                     * Properties of a ListStaffShiftSwapRequestHistoryResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStaffShiftSwapRequestHistoryResponse
                     * @property {Array.<palexy.streaming.v1.IStaffShiftSwapRequestHistory>|null} [staffShiftSwapRequestHistories] ListStaffShiftSwapRequestHistoryResponse staffShiftSwapRequestHistories
                     * @property {string|null} [nextPageToken] ListStaffShiftSwapRequestHistoryResponse nextPageToken
                     * @property {number|null} [totalElements] ListStaffShiftSwapRequestHistoryResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStaffShiftSwapRequestHistoryResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStaffShiftSwapRequestHistoryResponse.
                     * @implements IListStaffShiftSwapRequestHistoryResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryResponse=} [properties] Properties to set
                     */
                    function ListStaffShiftSwapRequestHistoryResponse(properties) {
                        this.staffShiftSwapRequestHistories = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStaffShiftSwapRequestHistoryResponse staffShiftSwapRequestHistories.
                     * @member {Array.<palexy.streaming.v1.IStaffShiftSwapRequestHistory>} staffShiftSwapRequestHistories
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryResponse.prototype.staffShiftSwapRequestHistories = $util.emptyArray;
    
                    /**
                     * ListStaffShiftSwapRequestHistoryResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStaffShiftSwapRequestHistoryResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @instance
                     */
                    ListStaffShiftSwapRequestHistoryResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListStaffShiftSwapRequestHistoryResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} ListStaffShiftSwapRequestHistoryResponse instance
                     */
                    ListStaffShiftSwapRequestHistoryResponse.create = function create(properties) {
                        return new ListStaffShiftSwapRequestHistoryResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestHistoryResponse message. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryResponse} message ListStaffShiftSwapRequestHistoryResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestHistoryResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftSwapRequestHistories != null && message.staffShiftSwapRequestHistories.length)
                            for (var i = 0; i < message.staffShiftSwapRequestHistories.length; ++i)
                                $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.encode(message.staffShiftSwapRequestHistories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStaffShiftSwapRequestHistoryResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStaffShiftSwapRequestHistoryResponse} message ListStaffShiftSwapRequestHistoryResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStaffShiftSwapRequestHistoryResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestHistoryResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} ListStaffShiftSwapRequestHistoryResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestHistoryResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.staffShiftSwapRequestHistories && message.staffShiftSwapRequestHistories.length))
                                    message.staffShiftSwapRequestHistories = [];
                                message.staffShiftSwapRequestHistories.push($root.palexy.streaming.v1.StaffShiftSwapRequestHistory.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStaffShiftSwapRequestHistoryResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} ListStaffShiftSwapRequestHistoryResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStaffShiftSwapRequestHistoryResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStaffShiftSwapRequestHistoryResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStaffShiftSwapRequestHistoryResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftSwapRequestHistories != null && message.hasOwnProperty("staffShiftSwapRequestHistories")) {
                            if (!Array.isArray(message.staffShiftSwapRequestHistories))
                                return "staffShiftSwapRequestHistories: array expected";
                            for (var i = 0; i < message.staffShiftSwapRequestHistories.length; ++i) {
                                var error = $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.verify(message.staffShiftSwapRequestHistories[i]);
                                if (error)
                                    return "staffShiftSwapRequestHistories." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStaffShiftSwapRequestHistoryResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} ListStaffShiftSwapRequestHistoryResponse
                     */
                    ListStaffShiftSwapRequestHistoryResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse();
                        if (object.staffShiftSwapRequestHistories) {
                            if (!Array.isArray(object.staffShiftSwapRequestHistories))
                                throw TypeError(".palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse.staffShiftSwapRequestHistories: array expected");
                            message.staffShiftSwapRequestHistories = [];
                            for (var i = 0; i < object.staffShiftSwapRequestHistories.length; ++i) {
                                if (typeof object.staffShiftSwapRequestHistories[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse.staffShiftSwapRequestHistories: object expected");
                                message.staffShiftSwapRequestHistories[i] = $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.fromObject(object.staffShiftSwapRequestHistories[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStaffShiftSwapRequestHistoryResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse} message ListStaffShiftSwapRequestHistoryResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStaffShiftSwapRequestHistoryResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffShiftSwapRequestHistories = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.staffShiftSwapRequestHistories && message.staffShiftSwapRequestHistories.length) {
                            object.staffShiftSwapRequestHistories = [];
                            for (var j = 0; j < message.staffShiftSwapRequestHistories.length; ++j)
                                object.staffShiftSwapRequestHistories[j] = $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.toObject(message.staffShiftSwapRequestHistories[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStaffShiftSwapRequestHistoryResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStaffShiftSwapRequestHistoryResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStaffShiftSwapRequestHistoryResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStaffShiftSwapRequestHistoryResponse;
                })();
    
                v1.CreateStaffShiftSwapRequestRequest = (function() {
    
                    /**
                     * Properties of a CreateStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStaffShiftSwapRequestRequest
                     * @property {number|null} [fromStaffShiftId] CreateStaffShiftSwapRequestRequest fromStaffShiftId
                     * @property {number|null} [toStaffShiftId] CreateStaffShiftSwapRequestRequest toStaffShiftId
                     * @property {string|null} [byUsername] CreateStaffShiftSwapRequestRequest byUsername
                     */
    
                    /**
                     * Constructs a new CreateStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStaffShiftSwapRequestRequest.
                     * @implements ICreateStaffShiftSwapRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest=} [properties] Properties to set
                     */
                    function CreateStaffShiftSwapRequestRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStaffShiftSwapRequestRequest fromStaffShiftId.
                     * @member {number} fromStaffShiftId
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @instance
                     */
                    CreateStaffShiftSwapRequestRequest.prototype.fromStaffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateStaffShiftSwapRequestRequest toStaffShiftId.
                     * @member {number} toStaffShiftId
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @instance
                     */
                    CreateStaffShiftSwapRequestRequest.prototype.toStaffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateStaffShiftSwapRequestRequest byUsername.
                     * @member {string} byUsername
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @instance
                     */
                    CreateStaffShiftSwapRequestRequest.prototype.byUsername = "";
    
                    /**
                     * Creates a new CreateStaffShiftSwapRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStaffShiftSwapRequestRequest} CreateStaffShiftSwapRequestRequest instance
                     */
                    CreateStaffShiftSwapRequestRequest.create = function create(properties) {
                        return new CreateStaffShiftSwapRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStaffShiftSwapRequestRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest} message CreateStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffShiftSwapRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fromStaffShiftId != null && Object.hasOwnProperty.call(message, "fromStaffShiftId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.fromStaffShiftId);
                        if (message.toStaffShiftId != null && Object.hasOwnProperty.call(message, "toStaffShiftId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.toStaffShiftId);
                        if (message.byUsername != null && Object.hasOwnProperty.call(message, "byUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.byUsername);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStaffShiftSwapRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStaffShiftSwapRequestRequest} message CreateStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStaffShiftSwapRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStaffShiftSwapRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStaffShiftSwapRequestRequest} CreateStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffShiftSwapRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStaffShiftSwapRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fromStaffShiftId = reader.int64();
                                break;
                            case 2:
                                message.toStaffShiftId = reader.int64();
                                break;
                            case 3:
                                message.byUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStaffShiftSwapRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStaffShiftSwapRequestRequest} CreateStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStaffShiftSwapRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStaffShiftSwapRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStaffShiftSwapRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (!$util.isInteger(message.fromStaffShiftId) && !(message.fromStaffShiftId && $util.isInteger(message.fromStaffShiftId.low) && $util.isInteger(message.fromStaffShiftId.high)))
                                return "fromStaffShiftId: integer|Long expected";
                        if (message.toStaffShiftId != null && message.hasOwnProperty("toStaffShiftId"))
                            if (!$util.isInteger(message.toStaffShiftId) && !(message.toStaffShiftId && $util.isInteger(message.toStaffShiftId.low) && $util.isInteger(message.toStaffShiftId.high)))
                                return "toStaffShiftId: integer|Long expected";
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            if (!$util.isString(message.byUsername))
                                return "byUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateStaffShiftSwapRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStaffShiftSwapRequestRequest} CreateStaffShiftSwapRequestRequest
                     */
                    CreateStaffShiftSwapRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStaffShiftSwapRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStaffShiftSwapRequestRequest();
                        if (object.fromStaffShiftId != null)
                            if ($util.Long)
                                (message.fromStaffShiftId = $util.Long.fromValue(object.fromStaffShiftId)).unsigned = false;
                            else if (typeof object.fromStaffShiftId === "string")
                                message.fromStaffShiftId = parseInt(object.fromStaffShiftId, 10);
                            else if (typeof object.fromStaffShiftId === "number")
                                message.fromStaffShiftId = object.fromStaffShiftId;
                            else if (typeof object.fromStaffShiftId === "object")
                                message.fromStaffShiftId = new $util.LongBits(object.fromStaffShiftId.low >>> 0, object.fromStaffShiftId.high >>> 0).toNumber();
                        if (object.toStaffShiftId != null)
                            if ($util.Long)
                                (message.toStaffShiftId = $util.Long.fromValue(object.toStaffShiftId)).unsigned = false;
                            else if (typeof object.toStaffShiftId === "string")
                                message.toStaffShiftId = parseInt(object.toStaffShiftId, 10);
                            else if (typeof object.toStaffShiftId === "number")
                                message.toStaffShiftId = object.toStaffShiftId;
                            else if (typeof object.toStaffShiftId === "object")
                                message.toStaffShiftId = new $util.LongBits(object.toStaffShiftId.low >>> 0, object.toStaffShiftId.high >>> 0).toNumber();
                        if (object.byUsername != null)
                            message.byUsername = String(object.byUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStaffShiftSwapRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStaffShiftSwapRequestRequest} message CreateStaffShiftSwapRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStaffShiftSwapRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromStaffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromStaffShiftId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.toStaffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.toStaffShiftId = options.longs === String ? "0" : 0;
                            object.byUsername = "";
                        }
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (typeof message.fromStaffShiftId === "number")
                                object.fromStaffShiftId = options.longs === String ? String(message.fromStaffShiftId) : message.fromStaffShiftId;
                            else
                                object.fromStaffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.fromStaffShiftId) : options.longs === Number ? new $util.LongBits(message.fromStaffShiftId.low >>> 0, message.fromStaffShiftId.high >>> 0).toNumber() : message.fromStaffShiftId;
                        if (message.toStaffShiftId != null && message.hasOwnProperty("toStaffShiftId"))
                            if (typeof message.toStaffShiftId === "number")
                                object.toStaffShiftId = options.longs === String ? String(message.toStaffShiftId) : message.toStaffShiftId;
                            else
                                object.toStaffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.toStaffShiftId) : options.longs === Number ? new $util.LongBits(message.toStaffShiftId.low >>> 0, message.toStaffShiftId.high >>> 0).toNumber() : message.toStaffShiftId;
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            object.byUsername = message.byUsername;
                        return object;
                    };
    
                    /**
                     * Converts this CreateStaffShiftSwapRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStaffShiftSwapRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStaffShiftSwapRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStaffShiftSwapRequestRequest;
                })();
    
                v1.ApproveStaffShiftSwapRequestRequest = (function() {
    
                    /**
                     * Properties of an ApproveStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IApproveStaffShiftSwapRequestRequest
                     * @property {number|null} [staffShiftSwapRequestId] ApproveStaffShiftSwapRequestRequest staffShiftSwapRequestId
                     * @property {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType|null} [approveBy] ApproveStaffShiftSwapRequestRequest approveBy
                     * @property {string|null} [byUsername] ApproveStaffShiftSwapRequestRequest byUsername
                     */
    
                    /**
                     * Constructs a new ApproveStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an ApproveStaffShiftSwapRequestRequest.
                     * @implements IApproveStaffShiftSwapRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest=} [properties] Properties to set
                     */
                    function ApproveStaffShiftSwapRequestRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ApproveStaffShiftSwapRequestRequest staffShiftSwapRequestId.
                     * @member {number} staffShiftSwapRequestId
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ApproveStaffShiftSwapRequestRequest.prototype.staffShiftSwapRequestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ApproveStaffShiftSwapRequestRequest approveBy.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType} approveBy
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ApproveStaffShiftSwapRequestRequest.prototype.approveBy = 0;
    
                    /**
                     * ApproveStaffShiftSwapRequestRequest byUsername.
                     * @member {string} byUsername
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @instance
                     */
                    ApproveStaffShiftSwapRequestRequest.prototype.byUsername = "";
    
                    /**
                     * Creates a new ApproveStaffShiftSwapRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest} ApproveStaffShiftSwapRequestRequest instance
                     */
                    ApproveStaffShiftSwapRequestRequest.create = function create(properties) {
                        return new ApproveStaffShiftSwapRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ApproveStaffShiftSwapRequestRequest message. Does not implicitly {@link palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest} message ApproveStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ApproveStaffShiftSwapRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftSwapRequestId != null && Object.hasOwnProperty.call(message, "staffShiftSwapRequestId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffShiftSwapRequestId);
                        if (message.approveBy != null && Object.hasOwnProperty.call(message, "approveBy"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.approveBy);
                        if (message.byUsername != null && Object.hasOwnProperty.call(message, "byUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.byUsername);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ApproveStaffShiftSwapRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IApproveStaffShiftSwapRequestRequest} message ApproveStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ApproveStaffShiftSwapRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ApproveStaffShiftSwapRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest} ApproveStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ApproveStaffShiftSwapRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShiftSwapRequestId = reader.int64();
                                break;
                            case 2:
                                message.approveBy = reader.int32();
                                break;
                            case 3:
                                message.byUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ApproveStaffShiftSwapRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest} ApproveStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ApproveStaffShiftSwapRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ApproveStaffShiftSwapRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ApproveStaffShiftSwapRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (!$util.isInteger(message.staffShiftSwapRequestId) && !(message.staffShiftSwapRequestId && $util.isInteger(message.staffShiftSwapRequestId.low) && $util.isInteger(message.staffShiftSwapRequestId.high)))
                                return "staffShiftSwapRequestId: integer|Long expected";
                        if (message.approveBy != null && message.hasOwnProperty("approveBy"))
                            switch (message.approveBy) {
                            default:
                                return "approveBy: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            if (!$util.isString(message.byUsername))
                                return "byUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ApproveStaffShiftSwapRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest} ApproveStaffShiftSwapRequestRequest
                     */
                    ApproveStaffShiftSwapRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest();
                        if (object.staffShiftSwapRequestId != null)
                            if ($util.Long)
                                (message.staffShiftSwapRequestId = $util.Long.fromValue(object.staffShiftSwapRequestId)).unsigned = false;
                            else if (typeof object.staffShiftSwapRequestId === "string")
                                message.staffShiftSwapRequestId = parseInt(object.staffShiftSwapRequestId, 10);
                            else if (typeof object.staffShiftSwapRequestId === "number")
                                message.staffShiftSwapRequestId = object.staffShiftSwapRequestId;
                            else if (typeof object.staffShiftSwapRequestId === "object")
                                message.staffShiftSwapRequestId = new $util.LongBits(object.staffShiftSwapRequestId.low >>> 0, object.staffShiftSwapRequestId.high >>> 0).toNumber();
                        switch (object.approveBy) {
                        case "ACTOR_TYPE_UNSPECIFIED":
                        case 0:
                            message.approveBy = 0;
                            break;
                        case "STAFF":
                        case 1:
                            message.approveBy = 1;
                            break;
                        case "RECEIVER":
                        case 2:
                            message.approveBy = 2;
                            break;
                        case "MANAGER":
                        case 3:
                            message.approveBy = 3;
                            break;
                        case "SYSTEM":
                        case 4:
                            message.approveBy = 4;
                            break;
                        }
                        if (object.byUsername != null)
                            message.byUsername = String(object.byUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ApproveStaffShiftSwapRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest} message ApproveStaffShiftSwapRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ApproveStaffShiftSwapRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftSwapRequestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftSwapRequestId = options.longs === String ? "0" : 0;
                            object.approveBy = options.enums === String ? "ACTOR_TYPE_UNSPECIFIED" : 0;
                            object.byUsername = "";
                        }
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (typeof message.staffShiftSwapRequestId === "number")
                                object.staffShiftSwapRequestId = options.longs === String ? String(message.staffShiftSwapRequestId) : message.staffShiftSwapRequestId;
                            else
                                object.staffShiftSwapRequestId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftSwapRequestId) : options.longs === Number ? new $util.LongBits(message.staffShiftSwapRequestId.low >>> 0, message.staffShiftSwapRequestId.high >>> 0).toNumber() : message.staffShiftSwapRequestId;
                        if (message.approveBy != null && message.hasOwnProperty("approveBy"))
                            object.approveBy = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType[message.approveBy] : message.approveBy;
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            object.byUsername = message.byUsername;
                        return object;
                    };
    
                    /**
                     * Converts this ApproveStaffShiftSwapRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ApproveStaffShiftSwapRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ApproveStaffShiftSwapRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ApproveStaffShiftSwapRequestRequest;
                })();
    
                v1.RejectStaffShiftSwapRequestRequest = (function() {
    
                    /**
                     * Properties of a RejectStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IRejectStaffShiftSwapRequestRequest
                     * @property {number|null} [staffShiftSwapRequestId] RejectStaffShiftSwapRequestRequest staffShiftSwapRequestId
                     * @property {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType|null} [rejectBy] RejectStaffShiftSwapRequestRequest rejectBy
                     * @property {string|null} [byUsername] RejectStaffShiftSwapRequestRequest byUsername
                     */
    
                    /**
                     * Constructs a new RejectStaffShiftSwapRequestRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RejectStaffShiftSwapRequestRequest.
                     * @implements IRejectStaffShiftSwapRequestRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest=} [properties] Properties to set
                     */
                    function RejectStaffShiftSwapRequestRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RejectStaffShiftSwapRequestRequest staffShiftSwapRequestId.
                     * @member {number} staffShiftSwapRequestId
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @instance
                     */
                    RejectStaffShiftSwapRequestRequest.prototype.staffShiftSwapRequestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RejectStaffShiftSwapRequestRequest rejectBy.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType} rejectBy
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @instance
                     */
                    RejectStaffShiftSwapRequestRequest.prototype.rejectBy = 0;
    
                    /**
                     * RejectStaffShiftSwapRequestRequest byUsername.
                     * @member {string} byUsername
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @instance
                     */
                    RejectStaffShiftSwapRequestRequest.prototype.byUsername = "";
    
                    /**
                     * Creates a new RejectStaffShiftSwapRequestRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RejectStaffShiftSwapRequestRequest} RejectStaffShiftSwapRequestRequest instance
                     */
                    RejectStaffShiftSwapRequestRequest.create = function create(properties) {
                        return new RejectStaffShiftSwapRequestRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RejectStaffShiftSwapRequestRequest message. Does not implicitly {@link palexy.streaming.v1.RejectStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest} message RejectStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RejectStaffShiftSwapRequestRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.staffShiftSwapRequestId != null && Object.hasOwnProperty.call(message, "staffShiftSwapRequestId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffShiftSwapRequestId);
                        if (message.rejectBy != null && Object.hasOwnProperty.call(message, "rejectBy"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.rejectBy);
                        if (message.byUsername != null && Object.hasOwnProperty.call(message, "byUsername"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.byUsername);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RejectStaffShiftSwapRequestRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.RejectStaffShiftSwapRequestRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.IRejectStaffShiftSwapRequestRequest} message RejectStaffShiftSwapRequestRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RejectStaffShiftSwapRequestRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RejectStaffShiftSwapRequestRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RejectStaffShiftSwapRequestRequest} RejectStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RejectStaffShiftSwapRequestRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RejectStaffShiftSwapRequestRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.staffShiftSwapRequestId = reader.int64();
                                break;
                            case 2:
                                message.rejectBy = reader.int32();
                                break;
                            case 3:
                                message.byUsername = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RejectStaffShiftSwapRequestRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RejectStaffShiftSwapRequestRequest} RejectStaffShiftSwapRequestRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RejectStaffShiftSwapRequestRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RejectStaffShiftSwapRequestRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RejectStaffShiftSwapRequestRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (!$util.isInteger(message.staffShiftSwapRequestId) && !(message.staffShiftSwapRequestId && $util.isInteger(message.staffShiftSwapRequestId.low) && $util.isInteger(message.staffShiftSwapRequestId.high)))
                                return "staffShiftSwapRequestId: integer|Long expected";
                        if (message.rejectBy != null && message.hasOwnProperty("rejectBy"))
                            switch (message.rejectBy) {
                            default:
                                return "rejectBy: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            if (!$util.isString(message.byUsername))
                                return "byUsername: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RejectStaffShiftSwapRequestRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RejectStaffShiftSwapRequestRequest} RejectStaffShiftSwapRequestRequest
                     */
                    RejectStaffShiftSwapRequestRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RejectStaffShiftSwapRequestRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.RejectStaffShiftSwapRequestRequest();
                        if (object.staffShiftSwapRequestId != null)
                            if ($util.Long)
                                (message.staffShiftSwapRequestId = $util.Long.fromValue(object.staffShiftSwapRequestId)).unsigned = false;
                            else if (typeof object.staffShiftSwapRequestId === "string")
                                message.staffShiftSwapRequestId = parseInt(object.staffShiftSwapRequestId, 10);
                            else if (typeof object.staffShiftSwapRequestId === "number")
                                message.staffShiftSwapRequestId = object.staffShiftSwapRequestId;
                            else if (typeof object.staffShiftSwapRequestId === "object")
                                message.staffShiftSwapRequestId = new $util.LongBits(object.staffShiftSwapRequestId.low >>> 0, object.staffShiftSwapRequestId.high >>> 0).toNumber();
                        switch (object.rejectBy) {
                        case "ACTOR_TYPE_UNSPECIFIED":
                        case 0:
                            message.rejectBy = 0;
                            break;
                        case "STAFF":
                        case 1:
                            message.rejectBy = 1;
                            break;
                        case "RECEIVER":
                        case 2:
                            message.rejectBy = 2;
                            break;
                        case "MANAGER":
                        case 3:
                            message.rejectBy = 3;
                            break;
                        case "SYSTEM":
                        case 4:
                            message.rejectBy = 4;
                            break;
                        }
                        if (object.byUsername != null)
                            message.byUsername = String(object.byUsername);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RejectStaffShiftSwapRequestRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @static
                     * @param {palexy.streaming.v1.RejectStaffShiftSwapRequestRequest} message RejectStaffShiftSwapRequestRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RejectStaffShiftSwapRequestRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffShiftSwapRequestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffShiftSwapRequestId = options.longs === String ? "0" : 0;
                            object.rejectBy = options.enums === String ? "ACTOR_TYPE_UNSPECIFIED" : 0;
                            object.byUsername = "";
                        }
                        if (message.staffShiftSwapRequestId != null && message.hasOwnProperty("staffShiftSwapRequestId"))
                            if (typeof message.staffShiftSwapRequestId === "number")
                                object.staffShiftSwapRequestId = options.longs === String ? String(message.staffShiftSwapRequestId) : message.staffShiftSwapRequestId;
                            else
                                object.staffShiftSwapRequestId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftSwapRequestId) : options.longs === Number ? new $util.LongBits(message.staffShiftSwapRequestId.low >>> 0, message.staffShiftSwapRequestId.high >>> 0).toNumber() : message.staffShiftSwapRequestId;
                        if (message.rejectBy != null && message.hasOwnProperty("rejectBy"))
                            object.rejectBy = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType[message.rejectBy] : message.rejectBy;
                        if (message.byUsername != null && message.hasOwnProperty("byUsername"))
                            object.byUsername = message.byUsername;
                        return object;
                    };
    
                    /**
                     * Converts this RejectStaffShiftSwapRequestRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RejectStaffShiftSwapRequestRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RejectStaffShiftSwapRequestRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RejectStaffShiftSwapRequestRequest;
                })();
    
                v1.StaffShiftSwapRequest = (function() {
    
                    /**
                     * Properties of a StaffShiftSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffShiftSwapRequest
                     * @property {number|null} [id] StaffShiftSwapRequest id
                     * @property {number|null} [storeId] StaffShiftSwapRequest storeId
                     * @property {number|null} [fromStaffId] StaffShiftSwapRequest fromStaffId
                     * @property {number|null} [fromStaffShiftId] StaffShiftSwapRequest fromStaffShiftId
                     * @property {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest|null} [fromStaffShiftSnapshot] StaffShiftSwapRequest fromStaffShiftSnapshot
                     * @property {number|null} [toStaffId] StaffShiftSwapRequest toStaffId
                     * @property {number|null} [toStaffShiftId] StaffShiftSwapRequest toStaffShiftId
                     * @property {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest|null} [toStaffShiftSnapshot] StaffShiftSwapRequest toStaffShiftSnapshot
                     * @property {palexy.streaming.v1.StaffShiftSwapRequest.State|null} [state] StaffShiftSwapRequest state
                     * @property {palexy.streaming.v1.StaffShiftSwapRequest.Message|null} [message] StaffShiftSwapRequest message
                     * @property {palexy.streaming.v1.IStore|null} [store] StaffShiftSwapRequest store
                     * @property {palexy.streaming.v1.IStaff|null} [fromStaff] StaffShiftSwapRequest fromStaff
                     * @property {palexy.streaming.v1.IStaffShift|null} [fromStaffShift] StaffShiftSwapRequest fromStaffShift
                     * @property {palexy.streaming.v1.IStaff|null} [toStaff] StaffShiftSwapRequest toStaff
                     * @property {palexy.streaming.v1.IStaffShift|null} [toStaffShift] StaffShiftSwapRequest toStaffShift
                     * @property {number|null} [createTimeMs] StaffShiftSwapRequest createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] StaffShiftSwapRequest lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new StaffShiftSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftSwapRequest.
                     * @implements IStaffShiftSwapRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequest=} [properties] Properties to set
                     */
                    function StaffShiftSwapRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffShiftSwapRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest fromStaffId.
                     * @member {number} fromStaffId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.fromStaffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest fromStaffShiftId.
                     * @member {number} fromStaffShiftId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.fromStaffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest fromStaffShiftSnapshot.
                     * @member {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest|null|undefined} fromStaffShiftSnapshot
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.fromStaffShiftSnapshot = null;
    
                    /**
                     * StaffShiftSwapRequest toStaffId.
                     * @member {number} toStaffId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.toStaffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest toStaffShiftId.
                     * @member {number} toStaffShiftId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.toStaffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest toStaffShiftSnapshot.
                     * @member {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest|null|undefined} toStaffShiftSnapshot
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.toStaffShiftSnapshot = null;
    
                    /**
                     * StaffShiftSwapRequest state.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequest.State} state
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.state = 0;
    
                    /**
                     * StaffShiftSwapRequest message.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequest.Message} message
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.message = 0;
    
                    /**
                     * StaffShiftSwapRequest store.
                     * @member {palexy.streaming.v1.IStore|null|undefined} store
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.store = null;
    
                    /**
                     * StaffShiftSwapRequest fromStaff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} fromStaff
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.fromStaff = null;
    
                    /**
                     * StaffShiftSwapRequest fromStaffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} fromStaffShift
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.fromStaffShift = null;
    
                    /**
                     * StaffShiftSwapRequest toStaff.
                     * @member {palexy.streaming.v1.IStaff|null|undefined} toStaff
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.toStaff = null;
    
                    /**
                     * StaffShiftSwapRequest toStaffShift.
                     * @member {palexy.streaming.v1.IStaffShift|null|undefined} toStaffShift
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.toStaffShift = null;
    
                    /**
                     * StaffShiftSwapRequest createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequest lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     */
                    StaffShiftSwapRequest.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StaffShiftSwapRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequest} StaffShiftSwapRequest instance
                     */
                    StaffShiftSwapRequest.create = function create(properties) {
                        return new StaffShiftSwapRequest(properties);
                    };
    
                    /**
                     * Encodes the specified StaffShiftSwapRequest message. Does not implicitly {@link palexy.streaming.v1.StaffShiftSwapRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequest} message StaffShiftSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSwapRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.fromStaffId != null && Object.hasOwnProperty.call(message, "fromStaffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.fromStaffId);
                        if (message.fromStaffShiftId != null && Object.hasOwnProperty.call(message, "fromStaffShiftId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.fromStaffShiftId);
                        if (message.fromStaffShiftSnapshot != null && Object.hasOwnProperty.call(message, "fromStaffShiftSnapshot"))
                            $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.encode(message.fromStaffShiftSnapshot, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.toStaffId != null && Object.hasOwnProperty.call(message, "toStaffId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.toStaffId);
                        if (message.toStaffShiftId != null && Object.hasOwnProperty.call(message, "toStaffShiftId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.toStaffShiftId);
                        if (message.toStaffShiftSnapshot != null && Object.hasOwnProperty.call(message, "toStaffShiftSnapshot"))
                            $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.encode(message.toStaffShiftSnapshot, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.state);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.message);
                        if (message.store != null && Object.hasOwnProperty.call(message, "store"))
                            $root.palexy.streaming.v1.Store.encode(message.store, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.fromStaff != null && Object.hasOwnProperty.call(message, "fromStaff"))
                            $root.palexy.streaming.v1.Staff.encode(message.fromStaff, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.fromStaffShift != null && Object.hasOwnProperty.call(message, "fromStaffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.fromStaffShift, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.toStaff != null && Object.hasOwnProperty.call(message, "toStaff"))
                            $root.palexy.streaming.v1.Staff.encode(message.toStaff, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        if (message.toStaffShift != null && Object.hasOwnProperty.call(message, "toStaffShift"))
                            $root.palexy.streaming.v1.StaffShift.encode(message.toStaffShift, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffShiftSwapRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffShiftSwapRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequest} message StaffShiftSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSwapRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffShiftSwapRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequest} StaffShiftSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSwapRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffShiftSwapRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.fromStaffId = reader.int64();
                                break;
                            case 4:
                                message.fromStaffShiftId = reader.int64();
                                break;
                            case 5:
                                message.fromStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.toStaffId = reader.int64();
                                break;
                            case 7:
                                message.toStaffShiftId = reader.int64();
                                break;
                            case 8:
                                message.toStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.state = reader.int32();
                                break;
                            case 10:
                                message.message = reader.int32();
                                break;
                            case 11:
                                message.store = $root.palexy.streaming.v1.Store.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.fromStaff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 13:
                                message.fromStaffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.toStaff = $root.palexy.streaming.v1.Staff.decode(reader, reader.uint32());
                                break;
                            case 15:
                                message.toStaffShift = $root.palexy.streaming.v1.StaffShift.decode(reader, reader.uint32());
                                break;
                            case 16:
                                message.createTimeMs = reader.int64();
                                break;
                            case 17:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffShiftSwapRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequest} StaffShiftSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSwapRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffShiftSwapRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffShiftSwapRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.fromStaffId != null && message.hasOwnProperty("fromStaffId"))
                            if (!$util.isInteger(message.fromStaffId) && !(message.fromStaffId && $util.isInteger(message.fromStaffId.low) && $util.isInteger(message.fromStaffId.high)))
                                return "fromStaffId: integer|Long expected";
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (!$util.isInteger(message.fromStaffShiftId) && !(message.fromStaffShiftId && $util.isInteger(message.fromStaffShiftId.low) && $util.isInteger(message.fromStaffShiftId.high)))
                                return "fromStaffShiftId: integer|Long expected";
                        if (message.fromStaffShiftSnapshot != null && message.hasOwnProperty("fromStaffShiftSnapshot")) {
                            var error = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.verify(message.fromStaffShiftSnapshot);
                            if (error)
                                return "fromStaffShiftSnapshot." + error;
                        }
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (!$util.isInteger(message.toStaffId) && !(message.toStaffId && $util.isInteger(message.toStaffId.low) && $util.isInteger(message.toStaffId.high)))
                                return "toStaffId: integer|Long expected";
                        if (message.toStaffShiftId != null && message.hasOwnProperty("toStaffShiftId"))
                            if (!$util.isInteger(message.toStaffShiftId) && !(message.toStaffShiftId && $util.isInteger(message.toStaffShiftId.low) && $util.isInteger(message.toStaffShiftId.high)))
                                return "toStaffShiftId: integer|Long expected";
                        if (message.toStaffShiftSnapshot != null && message.hasOwnProperty("toStaffShiftSnapshot")) {
                            var error = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.verify(message.toStaffShiftSnapshot);
                            if (error)
                                return "toStaffShiftSnapshot." + error;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            switch (message.message) {
                            default:
                                return "message: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.store != null && message.hasOwnProperty("store")) {
                            var error = $root.palexy.streaming.v1.Store.verify(message.store);
                            if (error)
                                return "store." + error;
                        }
                        if (message.fromStaff != null && message.hasOwnProperty("fromStaff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.fromStaff);
                            if (error)
                                return "fromStaff." + error;
                        }
                        if (message.fromStaffShift != null && message.hasOwnProperty("fromStaffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.fromStaffShift);
                            if (error)
                                return "fromStaffShift." + error;
                        }
                        if (message.toStaff != null && message.hasOwnProperty("toStaff")) {
                            var error = $root.palexy.streaming.v1.Staff.verify(message.toStaff);
                            if (error)
                                return "toStaff." + error;
                        }
                        if (message.toStaffShift != null && message.hasOwnProperty("toStaffShift")) {
                            var error = $root.palexy.streaming.v1.StaffShift.verify(message.toStaffShift);
                            if (error)
                                return "toStaffShift." + error;
                        }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffShiftSwapRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequest} StaffShiftSwapRequest
                     */
                    StaffShiftSwapRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffShiftSwapRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffShiftSwapRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.fromStaffId != null)
                            if ($util.Long)
                                (message.fromStaffId = $util.Long.fromValue(object.fromStaffId)).unsigned = false;
                            else if (typeof object.fromStaffId === "string")
                                message.fromStaffId = parseInt(object.fromStaffId, 10);
                            else if (typeof object.fromStaffId === "number")
                                message.fromStaffId = object.fromStaffId;
                            else if (typeof object.fromStaffId === "object")
                                message.fromStaffId = new $util.LongBits(object.fromStaffId.low >>> 0, object.fromStaffId.high >>> 0).toNumber();
                        if (object.fromStaffShiftId != null)
                            if ($util.Long)
                                (message.fromStaffShiftId = $util.Long.fromValue(object.fromStaffShiftId)).unsigned = false;
                            else if (typeof object.fromStaffShiftId === "string")
                                message.fromStaffShiftId = parseInt(object.fromStaffShiftId, 10);
                            else if (typeof object.fromStaffShiftId === "number")
                                message.fromStaffShiftId = object.fromStaffShiftId;
                            else if (typeof object.fromStaffShiftId === "object")
                                message.fromStaffShiftId = new $util.LongBits(object.fromStaffShiftId.low >>> 0, object.fromStaffShiftId.high >>> 0).toNumber();
                        if (object.fromStaffShiftSnapshot != null) {
                            if (typeof object.fromStaffShiftSnapshot !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.fromStaffShiftSnapshot: object expected");
                            message.fromStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.fromObject(object.fromStaffShiftSnapshot);
                        }
                        if (object.toStaffId != null)
                            if ($util.Long)
                                (message.toStaffId = $util.Long.fromValue(object.toStaffId)).unsigned = false;
                            else if (typeof object.toStaffId === "string")
                                message.toStaffId = parseInt(object.toStaffId, 10);
                            else if (typeof object.toStaffId === "number")
                                message.toStaffId = object.toStaffId;
                            else if (typeof object.toStaffId === "object")
                                message.toStaffId = new $util.LongBits(object.toStaffId.low >>> 0, object.toStaffId.high >>> 0).toNumber();
                        if (object.toStaffShiftId != null)
                            if ($util.Long)
                                (message.toStaffShiftId = $util.Long.fromValue(object.toStaffShiftId)).unsigned = false;
                            else if (typeof object.toStaffShiftId === "string")
                                message.toStaffShiftId = parseInt(object.toStaffShiftId, 10);
                            else if (typeof object.toStaffShiftId === "number")
                                message.toStaffShiftId = object.toStaffShiftId;
                            else if (typeof object.toStaffShiftId === "object")
                                message.toStaffShiftId = new $util.LongBits(object.toStaffShiftId.low >>> 0, object.toStaffShiftId.high >>> 0).toNumber();
                        if (object.toStaffShiftSnapshot != null) {
                            if (typeof object.toStaffShiftSnapshot !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.toStaffShiftSnapshot: object expected");
                            message.toStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.fromObject(object.toStaffShiftSnapshot);
                        }
                        switch (object.state) {
                        case "STATE_UNSPECIFIED":
                        case 0:
                            message.state = 0;
                            break;
                        case "PENDING":
                        case 1:
                            message.state = 1;
                            break;
                        case "APPROVED_BY_RECEIVER":
                        case 2:
                            message.state = 2;
                            break;
                        case "COMPLETED":
                        case 3:
                            message.state = 3;
                            break;
                        case "REJECTED":
                        case 4:
                            message.state = 4;
                            break;
                        }
                        switch (object.message) {
                        case "MESSAGE_UNSPECIFIED":
                        case 0:
                            message.message = 0;
                            break;
                        case "STAFF_SHIFT_STORE_CHANGED":
                        case 1:
                            message.message = 1;
                            break;
                        case "STAFF_SHIFT_REASSIGNED":
                        case 2:
                            message.message = 2;
                            break;
                        case "STAFF_SHIFT_DELETED":
                        case 3:
                            message.message = 3;
                            break;
                        case "OTHER_SWAP_REQUEST_APPROVED":
                        case 4:
                            message.message = 4;
                            break;
                        case "REJECTED_BY_RECEIVER":
                        case 5:
                            message.message = 5;
                            break;
                        case "REJECTED_BY_MANAGER":
                        case 6:
                            message.message = 6;
                            break;
                        case "STAFF_SHIFT_CHECKED_IN":
                        case 7:
                            message.message = 7;
                            break;
                        }
                        if (object.store != null) {
                            if (typeof object.store !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.store: object expected");
                            message.store = $root.palexy.streaming.v1.Store.fromObject(object.store);
                        }
                        if (object.fromStaff != null) {
                            if (typeof object.fromStaff !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.fromStaff: object expected");
                            message.fromStaff = $root.palexy.streaming.v1.Staff.fromObject(object.fromStaff);
                        }
                        if (object.fromStaffShift != null) {
                            if (typeof object.fromStaffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.fromStaffShift: object expected");
                            message.fromStaffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.fromStaffShift);
                        }
                        if (object.toStaff != null) {
                            if (typeof object.toStaff !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.toStaff: object expected");
                            message.toStaff = $root.palexy.streaming.v1.Staff.fromObject(object.toStaff);
                        }
                        if (object.toStaffShift != null) {
                            if (typeof object.toStaffShift !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSwapRequest.toStaffShift: object expected");
                            message.toStaffShift = $root.palexy.streaming.v1.StaffShift.fromObject(object.toStaffShift);
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffShiftSwapRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.StaffShiftSwapRequest} message StaffShiftSwapRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffShiftSwapRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromStaffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromStaffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.fromStaffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.fromStaffShiftId = options.longs === String ? "0" : 0;
                            object.fromStaffShiftSnapshot = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.toStaffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.toStaffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.toStaffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.toStaffShiftId = options.longs === String ? "0" : 0;
                            object.toStaffShiftSnapshot = null;
                            object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                            object.message = options.enums === String ? "MESSAGE_UNSPECIFIED" : 0;
                            object.store = null;
                            object.fromStaff = null;
                            object.fromStaffShift = null;
                            object.toStaff = null;
                            object.toStaffShift = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.fromStaffId != null && message.hasOwnProperty("fromStaffId"))
                            if (typeof message.fromStaffId === "number")
                                object.fromStaffId = options.longs === String ? String(message.fromStaffId) : message.fromStaffId;
                            else
                                object.fromStaffId = options.longs === String ? $util.Long.prototype.toString.call(message.fromStaffId) : options.longs === Number ? new $util.LongBits(message.fromStaffId.low >>> 0, message.fromStaffId.high >>> 0).toNumber() : message.fromStaffId;
                        if (message.fromStaffShiftId != null && message.hasOwnProperty("fromStaffShiftId"))
                            if (typeof message.fromStaffShiftId === "number")
                                object.fromStaffShiftId = options.longs === String ? String(message.fromStaffShiftId) : message.fromStaffShiftId;
                            else
                                object.fromStaffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.fromStaffShiftId) : options.longs === Number ? new $util.LongBits(message.fromStaffShiftId.low >>> 0, message.fromStaffShiftId.high >>> 0).toNumber() : message.fromStaffShiftId;
                        if (message.fromStaffShiftSnapshot != null && message.hasOwnProperty("fromStaffShiftSnapshot"))
                            object.fromStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.toObject(message.fromStaffShiftSnapshot, options);
                        if (message.toStaffId != null && message.hasOwnProperty("toStaffId"))
                            if (typeof message.toStaffId === "number")
                                object.toStaffId = options.longs === String ? String(message.toStaffId) : message.toStaffId;
                            else
                                object.toStaffId = options.longs === String ? $util.Long.prototype.toString.call(message.toStaffId) : options.longs === Number ? new $util.LongBits(message.toStaffId.low >>> 0, message.toStaffId.high >>> 0).toNumber() : message.toStaffId;
                        if (message.toStaffShiftId != null && message.hasOwnProperty("toStaffShiftId"))
                            if (typeof message.toStaffShiftId === "number")
                                object.toStaffShiftId = options.longs === String ? String(message.toStaffShiftId) : message.toStaffShiftId;
                            else
                                object.toStaffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.toStaffShiftId) : options.longs === Number ? new $util.LongBits(message.toStaffShiftId.low >>> 0, message.toStaffShiftId.high >>> 0).toNumber() : message.toStaffShiftId;
                        if (message.toStaffShiftSnapshot != null && message.hasOwnProperty("toStaffShiftSnapshot"))
                            object.toStaffShiftSnapshot = $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.toObject(message.toStaffShiftSnapshot, options);
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequest.State[message.state] : message.state;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequest.Message[message.message] : message.message;
                        if (message.store != null && message.hasOwnProperty("store"))
                            object.store = $root.palexy.streaming.v1.Store.toObject(message.store, options);
                        if (message.fromStaff != null && message.hasOwnProperty("fromStaff"))
                            object.fromStaff = $root.palexy.streaming.v1.Staff.toObject(message.fromStaff, options);
                        if (message.fromStaffShift != null && message.hasOwnProperty("fromStaffShift"))
                            object.fromStaffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.fromStaffShift, options);
                        if (message.toStaff != null && message.hasOwnProperty("toStaff"))
                            object.toStaff = $root.palexy.streaming.v1.Staff.toObject(message.toStaff, options);
                        if (message.toStaffShift != null && message.hasOwnProperty("toStaffShift"))
                            object.toStaffShift = $root.palexy.streaming.v1.StaffShift.toObject(message.toStaffShift, options);
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this StaffShiftSwapRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffShiftSwapRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * State enum.
                     * @name palexy.streaming.v1.StaffShiftSwapRequest.State
                     * @enum {number}
                     * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                     * @property {number} PENDING=1 PENDING value
                     * @property {number} APPROVED_BY_RECEIVER=2 APPROVED_BY_RECEIVER value
                     * @property {number} COMPLETED=3 COMPLETED value
                     * @property {number} REJECTED=4 REJECTED value
                     */
                    StaffShiftSwapRequest.State = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PENDING"] = 1;
                        values[valuesById[2] = "APPROVED_BY_RECEIVER"] = 2;
                        values[valuesById[3] = "COMPLETED"] = 3;
                        values[valuesById[4] = "REJECTED"] = 4;
                        return values;
                    })();
    
                    /**
                     * Message enum.
                     * @name palexy.streaming.v1.StaffShiftSwapRequest.Message
                     * @enum {number}
                     * @property {number} MESSAGE_UNSPECIFIED=0 MESSAGE_UNSPECIFIED value
                     * @property {number} STAFF_SHIFT_STORE_CHANGED=1 STAFF_SHIFT_STORE_CHANGED value
                     * @property {number} STAFF_SHIFT_REASSIGNED=2 STAFF_SHIFT_REASSIGNED value
                     * @property {number} STAFF_SHIFT_DELETED=3 STAFF_SHIFT_DELETED value
                     * @property {number} OTHER_SWAP_REQUEST_APPROVED=4 OTHER_SWAP_REQUEST_APPROVED value
                     * @property {number} REJECTED_BY_RECEIVER=5 REJECTED_BY_RECEIVER value
                     * @property {number} REJECTED_BY_MANAGER=6 REJECTED_BY_MANAGER value
                     * @property {number} STAFF_SHIFT_CHECKED_IN=7 STAFF_SHIFT_CHECKED_IN value
                     */
                    StaffShiftSwapRequest.Message = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "MESSAGE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STAFF_SHIFT_STORE_CHANGED"] = 1;
                        values[valuesById[2] = "STAFF_SHIFT_REASSIGNED"] = 2;
                        values[valuesById[3] = "STAFF_SHIFT_DELETED"] = 3;
                        values[valuesById[4] = "OTHER_SWAP_REQUEST_APPROVED"] = 4;
                        values[valuesById[5] = "REJECTED_BY_RECEIVER"] = 5;
                        values[valuesById[6] = "REJECTED_BY_MANAGER"] = 6;
                        values[valuesById[7] = "STAFF_SHIFT_CHECKED_IN"] = 7;
                        return values;
                    })();
    
                    return StaffShiftSwapRequest;
                })();
    
                v1.StaffShiftSwapRequestHistory = (function() {
    
                    /**
                     * Properties of a StaffShiftSwapRequestHistory.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffShiftSwapRequestHistory
                     * @property {number|null} [id] StaffShiftSwapRequestHistory id
                     * @property {number|null} [requestId] StaffShiftSwapRequestHistory requestId
                     * @property {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType|null} [actorType] StaffShiftSwapRequestHistory actorType
                     * @property {string|null} [actorUsername] StaffShiftSwapRequestHistory actorUsername
                     * @property {palexy.streaming.v1.StaffShiftSwapRequestHistory.Action|null} [action] StaffShiftSwapRequestHistory action
                     * @property {number|null} [createTimeMs] StaffShiftSwapRequestHistory createTimeMs
                     */
    
                    /**
                     * Constructs a new StaffShiftSwapRequestHistory.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftSwapRequestHistory.
                     * @implements IStaffShiftSwapRequestHistory
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequestHistory=} [properties] Properties to set
                     */
                    function StaffShiftSwapRequestHistory(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffShiftSwapRequestHistory id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequestHistory requestId.
                     * @member {number} requestId
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.requestId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSwapRequestHistory actorType.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType} actorType
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.actorType = 0;
    
                    /**
                     * StaffShiftSwapRequestHistory actorUsername.
                     * @member {string} actorUsername
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.actorUsername = "";
    
                    /**
                     * StaffShiftSwapRequestHistory action.
                     * @member {palexy.streaming.v1.StaffShiftSwapRequestHistory.Action} action
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.action = 0;
    
                    /**
                     * StaffShiftSwapRequestHistory createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     */
                    StaffShiftSwapRequestHistory.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StaffShiftSwapRequestHistory instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequestHistory=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequestHistory} StaffShiftSwapRequestHistory instance
                     */
                    StaffShiftSwapRequestHistory.create = function create(properties) {
                        return new StaffShiftSwapRequestHistory(properties);
                    };
    
                    /**
                     * Encodes the specified StaffShiftSwapRequestHistory message. Does not implicitly {@link palexy.streaming.v1.StaffShiftSwapRequestHistory.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequestHistory} message StaffShiftSwapRequestHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSwapRequestHistory.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.requestId != null && Object.hasOwnProperty.call(message, "requestId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.requestId);
                        if (message.actorType != null && Object.hasOwnProperty.call(message, "actorType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.actorType);
                        if (message.actorUsername != null && Object.hasOwnProperty.call(message, "actorUsername"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.actorUsername);
                        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.action);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffShiftSwapRequestHistory message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffShiftSwapRequestHistory.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSwapRequestHistory} message StaffShiftSwapRequestHistory message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSwapRequestHistory.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffShiftSwapRequestHistory message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequestHistory} StaffShiftSwapRequestHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSwapRequestHistory.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffShiftSwapRequestHistory();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.requestId = reader.int64();
                                break;
                            case 3:
                                message.actorType = reader.int32();
                                break;
                            case 4:
                                message.actorUsername = reader.string();
                                break;
                            case 5:
                                message.action = reader.int32();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffShiftSwapRequestHistory message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequestHistory} StaffShiftSwapRequestHistory
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSwapRequestHistory.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffShiftSwapRequestHistory message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffShiftSwapRequestHistory.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.requestId != null && message.hasOwnProperty("requestId"))
                            if (!$util.isInteger(message.requestId) && !(message.requestId && $util.isInteger(message.requestId.low) && $util.isInteger(message.requestId.high)))
                                return "requestId: integer|Long expected";
                        if (message.actorType != null && message.hasOwnProperty("actorType"))
                            switch (message.actorType) {
                            default:
                                return "actorType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.actorUsername != null && message.hasOwnProperty("actorUsername"))
                            if (!$util.isString(message.actorUsername))
                                return "actorUsername: string expected";
                        if (message.action != null && message.hasOwnProperty("action"))
                            switch (message.action) {
                            default:
                                return "action: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffShiftSwapRequestHistory message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffShiftSwapRequestHistory} StaffShiftSwapRequestHistory
                     */
                    StaffShiftSwapRequestHistory.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffShiftSwapRequestHistory)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffShiftSwapRequestHistory();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.requestId != null)
                            if ($util.Long)
                                (message.requestId = $util.Long.fromValue(object.requestId)).unsigned = false;
                            else if (typeof object.requestId === "string")
                                message.requestId = parseInt(object.requestId, 10);
                            else if (typeof object.requestId === "number")
                                message.requestId = object.requestId;
                            else if (typeof object.requestId === "object")
                                message.requestId = new $util.LongBits(object.requestId.low >>> 0, object.requestId.high >>> 0).toNumber();
                        switch (object.actorType) {
                        case "ACTOR_TYPE_UNSPECIFIED":
                        case 0:
                            message.actorType = 0;
                            break;
                        case "STAFF":
                        case 1:
                            message.actorType = 1;
                            break;
                        case "RECEIVER":
                        case 2:
                            message.actorType = 2;
                            break;
                        case "MANAGER":
                        case 3:
                            message.actorType = 3;
                            break;
                        case "SYSTEM":
                        case 4:
                            message.actorType = 4;
                            break;
                        }
                        if (object.actorUsername != null)
                            message.actorUsername = String(object.actorUsername);
                        switch (object.action) {
                        case "UNKNOWN_ACTION":
                        case 0:
                            message.action = 0;
                            break;
                        case "CREATE":
                        case 1:
                            message.action = 1;
                            break;
                        case "APPROVE":
                        case 2:
                            message.action = 2;
                            break;
                        case "REJECT":
                        case 3:
                            message.action = 3;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffShiftSwapRequestHistory message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @static
                     * @param {palexy.streaming.v1.StaffShiftSwapRequestHistory} message StaffShiftSwapRequestHistory
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffShiftSwapRequestHistory.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.requestId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.requestId = options.longs === String ? "0" : 0;
                            object.actorType = options.enums === String ? "ACTOR_TYPE_UNSPECIFIED" : 0;
                            object.actorUsername = "";
                            object.action = options.enums === String ? "UNKNOWN_ACTION" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.requestId != null && message.hasOwnProperty("requestId"))
                            if (typeof message.requestId === "number")
                                object.requestId = options.longs === String ? String(message.requestId) : message.requestId;
                            else
                                object.requestId = options.longs === String ? $util.Long.prototype.toString.call(message.requestId) : options.longs === Number ? new $util.LongBits(message.requestId.low >>> 0, message.requestId.high >>> 0).toNumber() : message.requestId;
                        if (message.actorType != null && message.hasOwnProperty("actorType"))
                            object.actorType = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType[message.actorType] : message.actorType;
                        if (message.actorUsername != null && message.hasOwnProperty("actorUsername"))
                            object.actorUsername = message.actorUsername;
                        if (message.action != null && message.hasOwnProperty("action"))
                            object.action = options.enums === String ? $root.palexy.streaming.v1.StaffShiftSwapRequestHistory.Action[message.action] : message.action;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this StaffShiftSwapRequestHistory to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffShiftSwapRequestHistory
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffShiftSwapRequestHistory.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Action enum.
                     * @name palexy.streaming.v1.StaffShiftSwapRequestHistory.Action
                     * @enum {number}
                     * @property {number} UNKNOWN_ACTION=0 UNKNOWN_ACTION value
                     * @property {number} CREATE=1 CREATE value
                     * @property {number} APPROVE=2 APPROVE value
                     * @property {number} REJECT=3 REJECT value
                     */
                    StaffShiftSwapRequestHistory.Action = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_ACTION"] = 0;
                        values[valuesById[1] = "CREATE"] = 1;
                        values[valuesById[2] = "APPROVE"] = 2;
                        values[valuesById[3] = "REJECT"] = 3;
                        return values;
                    })();
    
                    /**
                     * ActorType enum.
                     * @name palexy.streaming.v1.StaffShiftSwapRequestHistory.ActorType
                     * @enum {number}
                     * @property {number} ACTOR_TYPE_UNSPECIFIED=0 ACTOR_TYPE_UNSPECIFIED value
                     * @property {number} STAFF=1 STAFF value
                     * @property {number} RECEIVER=2 RECEIVER value
                     * @property {number} MANAGER=3 MANAGER value
                     * @property {number} SYSTEM=4 SYSTEM value
                     */
                    StaffShiftSwapRequestHistory.ActorType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ACTOR_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STAFF"] = 1;
                        values[valuesById[2] = "RECEIVER"] = 2;
                        values[valuesById[3] = "MANAGER"] = 3;
                        values[valuesById[4] = "SYSTEM"] = 4;
                        return values;
                    })();
    
                    return StaffShiftSwapRequestHistory;
                })();
    
                v1.StaffShiftSnapshotForSwapRequest = (function() {
    
                    /**
                     * Properties of a StaffShiftSnapshotForSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IStaffShiftSnapshotForSwapRequest
                     * @property {number|null} [id] StaffShiftSnapshotForSwapRequest id
                     * @property {number|null} [storeId] StaffShiftSnapshotForSwapRequest storeId
                     * @property {number|null} [staffId] StaffShiftSnapshotForSwapRequest staffId
                     * @property {number|null} [dateId] StaffShiftSnapshotForSwapRequest dateId
                     * @property {string|null} [startTime] StaffShiftSnapshotForSwapRequest startTime
                     * @property {string|null} [endTime] StaffShiftSnapshotForSwapRequest endTime
                     * @property {boolean|null} [isCrossDayShift] StaffShiftSnapshotForSwapRequest isCrossDayShift
                     * @property {string|null} [color] StaffShiftSnapshotForSwapRequest color
                     * @property {string|null} [shiftName] StaffShiftSnapshotForSwapRequest shiftName
                     * @property {number|null} [staffPositionId] StaffShiftSnapshotForSwapRequest staffPositionId
                     * @property {number|null} [scheduleAreaId] StaffShiftSnapshotForSwapRequest scheduleAreaId
                     * @property {Array.<palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest>|null} [breakTimes] StaffShiftSnapshotForSwapRequest breakTimes
                     * @property {palexy.streaming.v1.IStaffPosition|null} [staffPosition] StaffShiftSnapshotForSwapRequest staffPosition
                     * @property {palexy.streaming.v1.IScheduleArea|null} [scheduleArea] StaffShiftSnapshotForSwapRequest scheduleArea
                     */
    
                    /**
                     * Constructs a new StaffShiftSnapshotForSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StaffShiftSnapshotForSwapRequest.
                     * @implements IStaffShiftSnapshotForSwapRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest=} [properties] Properties to set
                     */
                    function StaffShiftSnapshotForSwapRequest(properties) {
                        this.breakTimes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffShiftSnapshotForSwapRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.dateId = 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.startTime = "";
    
                    /**
                     * StaffShiftSnapshotForSwapRequest endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.endTime = "";
    
                    /**
                     * StaffShiftSnapshotForSwapRequest isCrossDayShift.
                     * @member {boolean} isCrossDayShift
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.isCrossDayShift = false;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest color.
                     * @member {string} color
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.color = "";
    
                    /**
                     * StaffShiftSnapshotForSwapRequest shiftName.
                     * @member {string} shiftName
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.shiftName = "";
    
                    /**
                     * StaffShiftSnapshotForSwapRequest staffPositionId.
                     * @member {number} staffPositionId
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.staffPositionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest scheduleAreaId.
                     * @member {number} scheduleAreaId
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest breakTimes.
                     * @member {Array.<palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest>} breakTimes
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.breakTimes = $util.emptyArray;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest staffPosition.
                     * @member {palexy.streaming.v1.IStaffPosition|null|undefined} staffPosition
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.staffPosition = null;
    
                    /**
                     * StaffShiftSnapshotForSwapRequest scheduleArea.
                     * @member {palexy.streaming.v1.IScheduleArea|null|undefined} scheduleArea
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.scheduleArea = null;
    
                    /**
                     * Creates a new StaffShiftSnapshotForSwapRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StaffShiftSnapshotForSwapRequest} StaffShiftSnapshotForSwapRequest instance
                     */
                    StaffShiftSnapshotForSwapRequest.create = function create(properties) {
                        return new StaffShiftSnapshotForSwapRequest(properties);
                    };
    
                    /**
                     * Encodes the specified StaffShiftSnapshotForSwapRequest message. Does not implicitly {@link palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest} message StaffShiftSnapshotForSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSnapshotForSwapRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.endTime);
                        if (message.isCrossDayShift != null && Object.hasOwnProperty.call(message, "isCrossDayShift"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isCrossDayShift);
                        if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.color);
                        if (message.shiftName != null && Object.hasOwnProperty.call(message, "shiftName"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.shiftName);
                        if (message.staffPositionId != null && Object.hasOwnProperty.call(message, "staffPositionId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.staffPositionId);
                        if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.scheduleAreaId);
                        if (message.breakTimes != null && message.breakTimes.length)
                            for (var i = 0; i < message.breakTimes.length; ++i)
                                $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.encode(message.breakTimes[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.staffPosition != null && Object.hasOwnProperty.call(message, "staffPosition"))
                            $root.palexy.streaming.v1.StaffPosition.encode(message.staffPosition, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.scheduleArea != null && Object.hasOwnProperty.call(message, "scheduleArea"))
                            $root.palexy.streaming.v1.ScheduleArea.encode(message.scheduleArea, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffShiftSnapshotForSwapRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IStaffShiftSnapshotForSwapRequest} message StaffShiftSnapshotForSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffShiftSnapshotForSwapRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffShiftSnapshotForSwapRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StaffShiftSnapshotForSwapRequest} StaffShiftSnapshotForSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSnapshotForSwapRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.startTime = reader.string();
                                break;
                            case 6:
                                message.endTime = reader.string();
                                break;
                            case 7:
                                message.isCrossDayShift = reader.bool();
                                break;
                            case 8:
                                message.color = reader.string();
                                break;
                            case 9:
                                message.shiftName = reader.string();
                                break;
                            case 10:
                                message.staffPositionId = reader.int64();
                                break;
                            case 11:
                                message.scheduleAreaId = reader.int64();
                                break;
                            case 12:
                                if (!(message.breakTimes && message.breakTimes.length))
                                    message.breakTimes = [];
                                message.breakTimes.push($root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.decode(reader, reader.uint32()));
                                break;
                            case 13:
                                message.staffPosition = $root.palexy.streaming.v1.StaffPosition.decode(reader, reader.uint32());
                                break;
                            case 14:
                                message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffShiftSnapshotForSwapRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StaffShiftSnapshotForSwapRequest} StaffShiftSnapshotForSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffShiftSnapshotForSwapRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffShiftSnapshotForSwapRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffShiftSnapshotForSwapRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            if (typeof message.isCrossDayShift !== "boolean")
                                return "isCrossDayShift: boolean expected";
                        if (message.color != null && message.hasOwnProperty("color"))
                            if (!$util.isString(message.color))
                                return "color: string expected";
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            if (!$util.isString(message.shiftName))
                                return "shiftName: string expected";
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (!$util.isInteger(message.staffPositionId) && !(message.staffPositionId && $util.isInteger(message.staffPositionId.low) && $util.isInteger(message.staffPositionId.high)))
                                return "staffPositionId: integer|Long expected";
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                                return "scheduleAreaId: integer|Long expected";
                        if (message.breakTimes != null && message.hasOwnProperty("breakTimes")) {
                            if (!Array.isArray(message.breakTimes))
                                return "breakTimes: array expected";
                            for (var i = 0; i < message.breakTimes.length; ++i) {
                                var error = $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.verify(message.breakTimes[i]);
                                if (error)
                                    return "breakTimes." + error;
                            }
                        }
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition")) {
                            var error = $root.palexy.streaming.v1.StaffPosition.verify(message.staffPosition);
                            if (error)
                                return "staffPosition." + error;
                        }
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea")) {
                            var error = $root.palexy.streaming.v1.ScheduleArea.verify(message.scheduleArea);
                            if (error)
                                return "scheduleArea." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffShiftSnapshotForSwapRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StaffShiftSnapshotForSwapRequest} StaffShiftSnapshotForSwapRequest
                     */
                    StaffShiftSnapshotForSwapRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.StaffShiftSnapshotForSwapRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.isCrossDayShift != null)
                            message.isCrossDayShift = Boolean(object.isCrossDayShift);
                        if (object.color != null)
                            message.color = String(object.color);
                        if (object.shiftName != null)
                            message.shiftName = String(object.shiftName);
                        if (object.staffPositionId != null)
                            if ($util.Long)
                                (message.staffPositionId = $util.Long.fromValue(object.staffPositionId)).unsigned = false;
                            else if (typeof object.staffPositionId === "string")
                                message.staffPositionId = parseInt(object.staffPositionId, 10);
                            else if (typeof object.staffPositionId === "number")
                                message.staffPositionId = object.staffPositionId;
                            else if (typeof object.staffPositionId === "object")
                                message.staffPositionId = new $util.LongBits(object.staffPositionId.low >>> 0, object.staffPositionId.high >>> 0).toNumber();
                        if (object.scheduleAreaId != null)
                            if ($util.Long)
                                (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                            else if (typeof object.scheduleAreaId === "string")
                                message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                            else if (typeof object.scheduleAreaId === "number")
                                message.scheduleAreaId = object.scheduleAreaId;
                            else if (typeof object.scheduleAreaId === "object")
                                message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                        if (object.breakTimes) {
                            if (!Array.isArray(object.breakTimes))
                                throw TypeError(".palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.breakTimes: array expected");
                            message.breakTimes = [];
                            for (var i = 0; i < object.breakTimes.length; ++i) {
                                if (typeof object.breakTimes[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.breakTimes: object expected");
                                message.breakTimes[i] = $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.fromObject(object.breakTimes[i]);
                            }
                        }
                        if (object.staffPosition != null) {
                            if (typeof object.staffPosition !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.staffPosition: object expected");
                            message.staffPosition = $root.palexy.streaming.v1.StaffPosition.fromObject(object.staffPosition);
                        }
                        if (object.scheduleArea != null) {
                            if (typeof object.scheduleArea !== "object")
                                throw TypeError(".palexy.streaming.v1.StaffShiftSnapshotForSwapRequest.scheduleArea: object expected");
                            message.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.fromObject(object.scheduleArea);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffShiftSnapshotForSwapRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.StaffShiftSnapshotForSwapRequest} message StaffShiftSnapshotForSwapRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffShiftSnapshotForSwapRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.breakTimes = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.startTime = "";
                            object.endTime = "";
                            object.isCrossDayShift = false;
                            object.color = "";
                            object.shiftName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffPositionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffPositionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.scheduleAreaId = options.longs === String ? "0" : 0;
                            object.staffPosition = null;
                            object.scheduleArea = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.isCrossDayShift != null && message.hasOwnProperty("isCrossDayShift"))
                            object.isCrossDayShift = message.isCrossDayShift;
                        if (message.color != null && message.hasOwnProperty("color"))
                            object.color = message.color;
                        if (message.shiftName != null && message.hasOwnProperty("shiftName"))
                            object.shiftName = message.shiftName;
                        if (message.staffPositionId != null && message.hasOwnProperty("staffPositionId"))
                            if (typeof message.staffPositionId === "number")
                                object.staffPositionId = options.longs === String ? String(message.staffPositionId) : message.staffPositionId;
                            else
                                object.staffPositionId = options.longs === String ? $util.Long.prototype.toString.call(message.staffPositionId) : options.longs === Number ? new $util.LongBits(message.staffPositionId.low >>> 0, message.staffPositionId.high >>> 0).toNumber() : message.staffPositionId;
                        if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                            if (typeof message.scheduleAreaId === "number")
                                object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                            else
                                object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                        if (message.breakTimes && message.breakTimes.length) {
                            object.breakTimes = [];
                            for (var j = 0; j < message.breakTimes.length; ++j)
                                object.breakTimes[j] = $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.toObject(message.breakTimes[j], options);
                        }
                        if (message.staffPosition != null && message.hasOwnProperty("staffPosition"))
                            object.staffPosition = $root.palexy.streaming.v1.StaffPosition.toObject(message.staffPosition, options);
                        if (message.scheduleArea != null && message.hasOwnProperty("scheduleArea"))
                            object.scheduleArea = $root.palexy.streaming.v1.ScheduleArea.toObject(message.scheduleArea, options);
                        return object;
                    };
    
                    /**
                     * Converts this StaffShiftSnapshotForSwapRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StaffShiftSnapshotForSwapRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffShiftSnapshotForSwapRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffShiftSnapshotForSwapRequest;
                })();
    
                v1.BreakTimeSnapshotForSwapRequest = (function() {
    
                    /**
                     * Properties of a BreakTimeSnapshotForSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBreakTimeSnapshotForSwapRequest
                     * @property {number|null} [id] BreakTimeSnapshotForSwapRequest id
                     * @property {string|null} [name] BreakTimeSnapshotForSwapRequest name
                     * @property {string|null} [type] BreakTimeSnapshotForSwapRequest type
                     * @property {string|null} [startTime] BreakTimeSnapshotForSwapRequest startTime
                     * @property {number|null} [duration] BreakTimeSnapshotForSwapRequest duration
                     */
    
                    /**
                     * Constructs a new BreakTimeSnapshotForSwapRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BreakTimeSnapshotForSwapRequest.
                     * @implements IBreakTimeSnapshotForSwapRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest=} [properties] Properties to set
                     */
                    function BreakTimeSnapshotForSwapRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BreakTimeSnapshotForSwapRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BreakTimeSnapshotForSwapRequest name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.name = "";
    
                    /**
                     * BreakTimeSnapshotForSwapRequest type.
                     * @member {string} type
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.type = "";
    
                    /**
                     * BreakTimeSnapshotForSwapRequest startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.startTime = "";
    
                    /**
                     * BreakTimeSnapshotForSwapRequest duration.
                     * @member {number} duration
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.duration = 0;
    
                    /**
                     * Creates a new BreakTimeSnapshotForSwapRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BreakTimeSnapshotForSwapRequest} BreakTimeSnapshotForSwapRequest instance
                     */
                    BreakTimeSnapshotForSwapRequest.create = function create(properties) {
                        return new BreakTimeSnapshotForSwapRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BreakTimeSnapshotForSwapRequest message. Does not implicitly {@link palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest} message BreakTimeSnapshotForSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BreakTimeSnapshotForSwapRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.type);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.startTime);
                        if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.duration);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BreakTimeSnapshotForSwapRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BreakTimeSnapshotForSwapRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.IBreakTimeSnapshotForSwapRequest} message BreakTimeSnapshotForSwapRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BreakTimeSnapshotForSwapRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BreakTimeSnapshotForSwapRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BreakTimeSnapshotForSwapRequest} BreakTimeSnapshotForSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BreakTimeSnapshotForSwapRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.type = reader.string();
                                break;
                            case 4:
                                message.startTime = reader.string();
                                break;
                            case 5:
                                message.duration = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BreakTimeSnapshotForSwapRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BreakTimeSnapshotForSwapRequest} BreakTimeSnapshotForSwapRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BreakTimeSnapshotForSwapRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BreakTimeSnapshotForSwapRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BreakTimeSnapshotForSwapRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            if (!$util.isString(message.type))
                                return "type: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            if (!$util.isInteger(message.duration))
                                return "duration: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a BreakTimeSnapshotForSwapRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BreakTimeSnapshotForSwapRequest} BreakTimeSnapshotForSwapRequest
                     */
                    BreakTimeSnapshotForSwapRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BreakTimeSnapshotForSwapRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.type != null)
                            message.type = String(object.type);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.duration != null)
                            message.duration = object.duration | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BreakTimeSnapshotForSwapRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @static
                     * @param {palexy.streaming.v1.BreakTimeSnapshotForSwapRequest} message BreakTimeSnapshotForSwapRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BreakTimeSnapshotForSwapRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.type = "";
                            object.startTime = "";
                            object.duration = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = message.type;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            object.duration = message.duration;
                        return object;
                    };
    
                    /**
                     * Converts this BreakTimeSnapshotForSwapRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BreakTimeSnapshotForSwapRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BreakTimeSnapshotForSwapRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BreakTimeSnapshotForSwapRequest;
                })();
    
                v1.MallService = (function() {
    
                    /**
                     * Constructs a new MallService service.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a MallService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function MallService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (MallService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = MallService;
    
                    /**
                     * Creates new MallService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.streaming.v1.MallService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {MallService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    MallService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MallService#getMall}.
                     * @memberof palexy.streaming.v1.MallService
                     * @typedef GetMallCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Mall} [response] Mall
                     */
    
                    /**
                     * Calls GetMall.
                     * @function getMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IGetMallRequest} request GetMallRequest message or plain object
                     * @param {palexy.streaming.v1.MallService.GetMallCallback} callback Node-style callback called with the error, if any, and Mall
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MallService.prototype.getMall = function getMall(request, callback) {
                        return this.rpcCall(getMall, $root.palexy.streaming.v1.GetMallRequest, $root.palexy.streaming.v1.Mall, request, callback);
                    }, "name", { value: "GetMall" });
    
                    /**
                     * Calls GetMall.
                     * @function getMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IGetMallRequest} request GetMallRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Mall>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MallService#listMalls}.
                     * @memberof palexy.streaming.v1.MallService
                     * @typedef ListMallsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.ListMallResponse} [response] ListMallResponse
                     */
    
                    /**
                     * Calls ListMalls.
                     * @function listMalls
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IListMallRequest} request ListMallRequest message or plain object
                     * @param {palexy.streaming.v1.MallService.ListMallsCallback} callback Node-style callback called with the error, if any, and ListMallResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MallService.prototype.listMalls = function listMalls(request, callback) {
                        return this.rpcCall(listMalls, $root.palexy.streaming.v1.ListMallRequest, $root.palexy.streaming.v1.ListMallResponse, request, callback);
                    }, "name", { value: "ListMalls" });
    
                    /**
                     * Calls ListMalls.
                     * @function listMalls
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IListMallRequest} request ListMallRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.ListMallResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MallService#createMall}.
                     * @memberof palexy.streaming.v1.MallService
                     * @typedef CreateMallCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Mall} [response] Mall
                     */
    
                    /**
                     * Calls CreateMall.
                     * @function createMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IMall} request Mall message or plain object
                     * @param {palexy.streaming.v1.MallService.CreateMallCallback} callback Node-style callback called with the error, if any, and Mall
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MallService.prototype.createMall = function createMall(request, callback) {
                        return this.rpcCall(createMall, $root.palexy.streaming.v1.Mall, $root.palexy.streaming.v1.Mall, request, callback);
                    }, "name", { value: "CreateMall" });
    
                    /**
                     * Calls CreateMall.
                     * @function createMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IMall} request Mall message or plain object
                     * @returns {Promise<palexy.streaming.v1.Mall>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MallService#updateMall}.
                     * @memberof palexy.streaming.v1.MallService
                     * @typedef UpdateMallCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.streaming.v1.Mall} [response] Mall
                     */
    
                    /**
                     * Calls UpdateMall.
                     * @function updateMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateMallRequest} request UpdateMallRequest message or plain object
                     * @param {palexy.streaming.v1.MallService.UpdateMallCallback} callback Node-style callback called with the error, if any, and Mall
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MallService.prototype.updateMall = function updateMall(request, callback) {
                        return this.rpcCall(updateMall, $root.palexy.streaming.v1.UpdateMallRequest, $root.palexy.streaming.v1.Mall, request, callback);
                    }, "name", { value: "UpdateMall" });
    
                    /**
                     * Calls UpdateMall.
                     * @function updateMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IUpdateMallRequest} request UpdateMallRequest message or plain object
                     * @returns {Promise<palexy.streaming.v1.Mall>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.streaming.v1.MallService#deleteMall}.
                     * @memberof palexy.streaming.v1.MallService
                     * @typedef DeleteMallCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteMall.
                     * @function deleteMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteMallRequest} request DeleteMallRequest message or plain object
                     * @param {palexy.streaming.v1.MallService.DeleteMallCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(MallService.prototype.deleteMall = function deleteMall(request, callback) {
                        return this.rpcCall(deleteMall, $root.palexy.streaming.v1.DeleteMallRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteMall" });
    
                    /**
                     * Calls DeleteMall.
                     * @function deleteMall
                     * @memberof palexy.streaming.v1.MallService
                     * @instance
                     * @param {palexy.streaming.v1.IDeleteMallRequest} request DeleteMallRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return MallService;
                })();
    
                v1.Mall = (function() {
    
                    /**
                     * Properties of a Mall.
                     * @memberof palexy.streaming.v1
                     * @interface IMall
                     * @property {number|null} [id] Mall id
                     * @property {string|null} [name] Mall name
                     * @property {string|null} [description] Mall description
                     * @property {string|null} [country] Mall country
                     * @property {string|null} [addressPrimary] Mall addressPrimary
                     * @property {string|null} [addressSecondary] Mall addressSecondary
                     * @property {string|null} [dependentLocality] Mall dependentLocality
                     * @property {string|null} [locality] Mall locality
                     * @property {string|null} [adminArea] Mall adminArea
                     * @property {palexy.streaming.v1.IGeoCoordinate|null} [geoCoordinate] Mall geoCoordinate
                     * @property {palexy.streaming.v1.Mall.MallType|null} [mallType] Mall mallType
                     * @property {number|null} [createTimeMs] Mall createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Mall lastUpdateTimeMs
                     * @property {string|null} [mallCode] Mall mallCode
                     * @property {string|null} [openTime] Mall openTime
                     * @property {string|null} [closeTime] Mall closeTime
                     * @property {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null} [listWeekdayCustomStreamingTime] Mall listWeekdayCustomStreamingTime
                     * @property {number|null} [storeCount] Mall storeCount
                     * @property {boolean|null} [autoGenerateTrendStoreSetEnabled] Mall autoGenerateTrendStoreSetEnabled
                     * @property {palexy.streaming.v1.Mall.LocationType|null} [locationType] Mall locationType
                     */
    
                    /**
                     * Constructs a new Mall.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a Mall.
                     * @implements IMall
                     * @constructor
                     * @param {palexy.streaming.v1.IMall=} [properties] Properties to set
                     */
                    function Mall(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Mall id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Mall name.
                     * @member {string} name
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.name = "";
    
                    /**
                     * Mall description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.description = "";
    
                    /**
                     * Mall country.
                     * @member {string} country
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.country = "";
    
                    /**
                     * Mall addressPrimary.
                     * @member {string} addressPrimary
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.addressPrimary = "";
    
                    /**
                     * Mall addressSecondary.
                     * @member {string} addressSecondary
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.addressSecondary = "";
    
                    /**
                     * Mall dependentLocality.
                     * @member {string} dependentLocality
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.dependentLocality = "";
    
                    /**
                     * Mall locality.
                     * @member {string} locality
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.locality = "";
    
                    /**
                     * Mall adminArea.
                     * @member {string} adminArea
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.adminArea = "";
    
                    /**
                     * Mall geoCoordinate.
                     * @member {palexy.streaming.v1.IGeoCoordinate|null|undefined} geoCoordinate
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.geoCoordinate = null;
    
                    /**
                     * Mall mallType.
                     * @member {palexy.streaming.v1.Mall.MallType} mallType
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.mallType = 0;
    
                    /**
                     * Mall createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Mall lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Mall mallCode.
                     * @member {string} mallCode
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.mallCode = "";
    
                    /**
                     * Mall openTime.
                     * @member {string} openTime
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.openTime = "";
    
                    /**
                     * Mall closeTime.
                     * @member {string} closeTime
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.closeTime = "";
    
                    /**
                     * Mall listWeekdayCustomStreamingTime.
                     * @member {palexy.streaming.v1.IListWeekdayCustomStreamingTime|null|undefined} listWeekdayCustomStreamingTime
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.listWeekdayCustomStreamingTime = null;
    
                    /**
                     * Mall storeCount.
                     * @member {number} storeCount
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.storeCount = 0;
    
                    /**
                     * Mall autoGenerateTrendStoreSetEnabled.
                     * @member {boolean} autoGenerateTrendStoreSetEnabled
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.autoGenerateTrendStoreSetEnabled = false;
    
                    /**
                     * Mall locationType.
                     * @member {palexy.streaming.v1.Mall.LocationType} locationType
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     */
                    Mall.prototype.locationType = 0;
    
                    /**
                     * Creates a new Mall instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {palexy.streaming.v1.IMall=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Mall} Mall instance
                     */
                    Mall.create = function create(properties) {
                        return new Mall(properties);
                    };
    
                    /**
                     * Encodes the specified Mall message. Does not implicitly {@link palexy.streaming.v1.Mall.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {palexy.streaming.v1.IMall} message Mall message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Mall.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.country);
                        if (message.addressPrimary != null && Object.hasOwnProperty.call(message, "addressPrimary"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.addressPrimary);
                        if (message.addressSecondary != null && Object.hasOwnProperty.call(message, "addressSecondary"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.addressSecondary);
                        if (message.dependentLocality != null && Object.hasOwnProperty.call(message, "dependentLocality"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.dependentLocality);
                        if (message.locality != null && Object.hasOwnProperty.call(message, "locality"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.locality);
                        if (message.adminArea != null && Object.hasOwnProperty.call(message, "adminArea"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.adminArea);
                        if (message.geoCoordinate != null && Object.hasOwnProperty.call(message, "geoCoordinate"))
                            $root.palexy.streaming.v1.GeoCoordinate.encode(message.geoCoordinate, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.mallType != null && Object.hasOwnProperty.call(message, "mallType"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.mallType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.lastUpdateTimeMs);
                        if (message.mallCode != null && Object.hasOwnProperty.call(message, "mallCode"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.mallCode);
                        if (message.openTime != null && Object.hasOwnProperty.call(message, "openTime"))
                            writer.uint32(/* id 15, wireType 2 =*/122).string(message.openTime);
                        if (message.closeTime != null && Object.hasOwnProperty.call(message, "closeTime"))
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.closeTime);
                        if (message.listWeekdayCustomStreamingTime != null && Object.hasOwnProperty.call(message, "listWeekdayCustomStreamingTime"))
                            $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.encode(message.listWeekdayCustomStreamingTime, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.storeCount != null && Object.hasOwnProperty.call(message, "storeCount"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int32(message.storeCount);
                        if (message.autoGenerateTrendStoreSetEnabled != null && Object.hasOwnProperty.call(message, "autoGenerateTrendStoreSetEnabled"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.autoGenerateTrendStoreSetEnabled);
                        if (message.locationType != null && Object.hasOwnProperty.call(message, "locationType"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int32(message.locationType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Mall message, length delimited. Does not implicitly {@link palexy.streaming.v1.Mall.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {palexy.streaming.v1.IMall} message Mall message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Mall.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Mall message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Mall} Mall
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Mall.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Mall();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.country = reader.string();
                                break;
                            case 5:
                                message.addressPrimary = reader.string();
                                break;
                            case 6:
                                message.addressSecondary = reader.string();
                                break;
                            case 7:
                                message.dependentLocality = reader.string();
                                break;
                            case 8:
                                message.locality = reader.string();
                                break;
                            case 9:
                                message.adminArea = reader.string();
                                break;
                            case 10:
                                message.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.mallType = reader.int32();
                                break;
                            case 12:
                                message.createTimeMs = reader.int64();
                                break;
                            case 13:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 14:
                                message.mallCode = reader.string();
                                break;
                            case 15:
                                message.openTime = reader.string();
                                break;
                            case 16:
                                message.closeTime = reader.string();
                                break;
                            case 17:
                                message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.decode(reader, reader.uint32());
                                break;
                            case 18:
                                message.storeCount = reader.int32();
                                break;
                            case 19:
                                message.autoGenerateTrendStoreSetEnabled = reader.bool();
                                break;
                            case 20:
                                message.locationType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Mall message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Mall} Mall
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Mall.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Mall message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Mall.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.country != null && message.hasOwnProperty("country"))
                            if (!$util.isString(message.country))
                                return "country: string expected";
                        if (message.addressPrimary != null && message.hasOwnProperty("addressPrimary"))
                            if (!$util.isString(message.addressPrimary))
                                return "addressPrimary: string expected";
                        if (message.addressSecondary != null && message.hasOwnProperty("addressSecondary"))
                            if (!$util.isString(message.addressSecondary))
                                return "addressSecondary: string expected";
                        if (message.dependentLocality != null && message.hasOwnProperty("dependentLocality"))
                            if (!$util.isString(message.dependentLocality))
                                return "dependentLocality: string expected";
                        if (message.locality != null && message.hasOwnProperty("locality"))
                            if (!$util.isString(message.locality))
                                return "locality: string expected";
                        if (message.adminArea != null && message.hasOwnProperty("adminArea"))
                            if (!$util.isString(message.adminArea))
                                return "adminArea: string expected";
                        if (message.geoCoordinate != null && message.hasOwnProperty("geoCoordinate")) {
                            var error = $root.palexy.streaming.v1.GeoCoordinate.verify(message.geoCoordinate);
                            if (error)
                                return "geoCoordinate." + error;
                        }
                        if (message.mallType != null && message.hasOwnProperty("mallType"))
                            switch (message.mallType) {
                            default:
                                return "mallType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.mallCode != null && message.hasOwnProperty("mallCode"))
                            if (!$util.isString(message.mallCode))
                                return "mallCode: string expected";
                        if (message.openTime != null && message.hasOwnProperty("openTime"))
                            if (!$util.isString(message.openTime))
                                return "openTime: string expected";
                        if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                            if (!$util.isString(message.closeTime))
                                return "closeTime: string expected";
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime")) {
                            var error = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.verify(message.listWeekdayCustomStreamingTime);
                            if (error)
                                return "listWeekdayCustomStreamingTime." + error;
                        }
                        if (message.storeCount != null && message.hasOwnProperty("storeCount"))
                            if (!$util.isInteger(message.storeCount))
                                return "storeCount: integer expected";
                        if (message.autoGenerateTrendStoreSetEnabled != null && message.hasOwnProperty("autoGenerateTrendStoreSetEnabled"))
                            if (typeof message.autoGenerateTrendStoreSetEnabled !== "boolean")
                                return "autoGenerateTrendStoreSetEnabled: boolean expected";
                        if (message.locationType != null && message.hasOwnProperty("locationType"))
                            switch (message.locationType) {
                            default:
                                return "locationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a Mall message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Mall} Mall
                     */
                    Mall.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Mall)
                            return object;
                        var message = new $root.palexy.streaming.v1.Mall();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.country != null)
                            message.country = String(object.country);
                        if (object.addressPrimary != null)
                            message.addressPrimary = String(object.addressPrimary);
                        if (object.addressSecondary != null)
                            message.addressSecondary = String(object.addressSecondary);
                        if (object.dependentLocality != null)
                            message.dependentLocality = String(object.dependentLocality);
                        if (object.locality != null)
                            message.locality = String(object.locality);
                        if (object.adminArea != null)
                            message.adminArea = String(object.adminArea);
                        if (object.geoCoordinate != null) {
                            if (typeof object.geoCoordinate !== "object")
                                throw TypeError(".palexy.streaming.v1.Mall.geoCoordinate: object expected");
                            message.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.fromObject(object.geoCoordinate);
                        }
                        switch (object.mallType) {
                        case "UNKNOWN_MALL_TYPE":
                        case 0:
                            message.mallType = 0;
                            break;
                        case "TOURIST":
                        case 1:
                            message.mallType = 1;
                            break;
                        case "LOCAL":
                        case 2:
                            message.mallType = 2;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.mallCode != null)
                            message.mallCode = String(object.mallCode);
                        if (object.openTime != null)
                            message.openTime = String(object.openTime);
                        if (object.closeTime != null)
                            message.closeTime = String(object.closeTime);
                        if (object.listWeekdayCustomStreamingTime != null) {
                            if (typeof object.listWeekdayCustomStreamingTime !== "object")
                                throw TypeError(".palexy.streaming.v1.Mall.listWeekdayCustomStreamingTime: object expected");
                            message.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.fromObject(object.listWeekdayCustomStreamingTime);
                        }
                        if (object.storeCount != null)
                            message.storeCount = object.storeCount | 0;
                        if (object.autoGenerateTrendStoreSetEnabled != null)
                            message.autoGenerateTrendStoreSetEnabled = Boolean(object.autoGenerateTrendStoreSetEnabled);
                        switch (object.locationType) {
                        case "UNKNOWN_LOCATION_TYPE":
                        case 0:
                            message.locationType = 0;
                            break;
                        case "MALL":
                        case 1:
                            message.locationType = 1;
                            break;
                        case "STREET":
                        case 2:
                            message.locationType = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Mall message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Mall
                     * @static
                     * @param {palexy.streaming.v1.Mall} message Mall
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Mall.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            object.country = "";
                            object.addressPrimary = "";
                            object.addressSecondary = "";
                            object.dependentLocality = "";
                            object.locality = "";
                            object.adminArea = "";
                            object.geoCoordinate = null;
                            object.mallType = options.enums === String ? "UNKNOWN_MALL_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.mallCode = "";
                            object.openTime = "";
                            object.closeTime = "";
                            object.listWeekdayCustomStreamingTime = null;
                            object.storeCount = 0;
                            object.autoGenerateTrendStoreSetEnabled = false;
                            object.locationType = options.enums === String ? "UNKNOWN_LOCATION_TYPE" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.country != null && message.hasOwnProperty("country"))
                            object.country = message.country;
                        if (message.addressPrimary != null && message.hasOwnProperty("addressPrimary"))
                            object.addressPrimary = message.addressPrimary;
                        if (message.addressSecondary != null && message.hasOwnProperty("addressSecondary"))
                            object.addressSecondary = message.addressSecondary;
                        if (message.dependentLocality != null && message.hasOwnProperty("dependentLocality"))
                            object.dependentLocality = message.dependentLocality;
                        if (message.locality != null && message.hasOwnProperty("locality"))
                            object.locality = message.locality;
                        if (message.adminArea != null && message.hasOwnProperty("adminArea"))
                            object.adminArea = message.adminArea;
                        if (message.geoCoordinate != null && message.hasOwnProperty("geoCoordinate"))
                            object.geoCoordinate = $root.palexy.streaming.v1.GeoCoordinate.toObject(message.geoCoordinate, options);
                        if (message.mallType != null && message.hasOwnProperty("mallType"))
                            object.mallType = options.enums === String ? $root.palexy.streaming.v1.Mall.MallType[message.mallType] : message.mallType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.mallCode != null && message.hasOwnProperty("mallCode"))
                            object.mallCode = message.mallCode;
                        if (message.openTime != null && message.hasOwnProperty("openTime"))
                            object.openTime = message.openTime;
                        if (message.closeTime != null && message.hasOwnProperty("closeTime"))
                            object.closeTime = message.closeTime;
                        if (message.listWeekdayCustomStreamingTime != null && message.hasOwnProperty("listWeekdayCustomStreamingTime"))
                            object.listWeekdayCustomStreamingTime = $root.palexy.streaming.v1.ListWeekdayCustomStreamingTime.toObject(message.listWeekdayCustomStreamingTime, options);
                        if (message.storeCount != null && message.hasOwnProperty("storeCount"))
                            object.storeCount = message.storeCount;
                        if (message.autoGenerateTrendStoreSetEnabled != null && message.hasOwnProperty("autoGenerateTrendStoreSetEnabled"))
                            object.autoGenerateTrendStoreSetEnabled = message.autoGenerateTrendStoreSetEnabled;
                        if (message.locationType != null && message.hasOwnProperty("locationType"))
                            object.locationType = options.enums === String ? $root.palexy.streaming.v1.Mall.LocationType[message.locationType] : message.locationType;
                        return object;
                    };
    
                    /**
                     * Converts this Mall to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Mall
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Mall.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * MallType enum.
                     * @name palexy.streaming.v1.Mall.MallType
                     * @enum {number}
                     * @property {number} UNKNOWN_MALL_TYPE=0 UNKNOWN_MALL_TYPE value
                     * @property {number} TOURIST=1 TOURIST value
                     * @property {number} LOCAL=2 LOCAL value
                     */
                    Mall.MallType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_MALL_TYPE"] = 0;
                        values[valuesById[1] = "TOURIST"] = 1;
                        values[valuesById[2] = "LOCAL"] = 2;
                        return values;
                    })();
    
                    /**
                     * LocationType enum.
                     * @name palexy.streaming.v1.Mall.LocationType
                     * @enum {number}
                     * @property {number} UNKNOWN_LOCATION_TYPE=0 UNKNOWN_LOCATION_TYPE value
                     * @property {number} MALL=1 MALL value
                     * @property {number} STREET=2 STREET value
                     */
                    Mall.LocationType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_LOCATION_TYPE"] = 0;
                        values[valuesById[1] = "MALL"] = 1;
                        values[valuesById[2] = "STREET"] = 2;
                        return values;
                    })();
    
                    return Mall;
                })();
    
                v1.GetMallRequest = (function() {
    
                    /**
                     * Properties of a GetMallRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IGetMallRequest
                     * @property {number|null} [mallId] GetMallRequest mallId
                     */
    
                    /**
                     * Constructs a new GetMallRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a GetMallRequest.
                     * @implements IGetMallRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IGetMallRequest=} [properties] Properties to set
                     */
                    function GetMallRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetMallRequest mallId.
                     * @member {number} mallId
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @instance
                     */
                    GetMallRequest.prototype.mallId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetMallRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMallRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.GetMallRequest} GetMallRequest instance
                     */
                    GetMallRequest.create = function create(properties) {
                        return new GetMallRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetMallRequest message. Does not implicitly {@link palexy.streaming.v1.GetMallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMallRequest} message GetMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetMallRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mallId != null && Object.hasOwnProperty.call(message, "mallId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.mallId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetMallRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.GetMallRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IGetMallRequest} message GetMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetMallRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetMallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.GetMallRequest} GetMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetMallRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.GetMallRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mallId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetMallRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.GetMallRequest} GetMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetMallRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetMallRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetMallRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (!$util.isInteger(message.mallId) && !(message.mallId && $util.isInteger(message.mallId.low) && $util.isInteger(message.mallId.high)))
                                return "mallId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetMallRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.GetMallRequest} GetMallRequest
                     */
                    GetMallRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.GetMallRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.GetMallRequest();
                        if (object.mallId != null)
                            if ($util.Long)
                                (message.mallId = $util.Long.fromValue(object.mallId)).unsigned = false;
                            else if (typeof object.mallId === "string")
                                message.mallId = parseInt(object.mallId, 10);
                            else if (typeof object.mallId === "number")
                                message.mallId = object.mallId;
                            else if (typeof object.mallId === "object")
                                message.mallId = new $util.LongBits(object.mallId.low >>> 0, object.mallId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetMallRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @static
                     * @param {palexy.streaming.v1.GetMallRequest} message GetMallRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetMallRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.mallId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.mallId = options.longs === String ? "0" : 0;
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (typeof message.mallId === "number")
                                object.mallId = options.longs === String ? String(message.mallId) : message.mallId;
                            else
                                object.mallId = options.longs === String ? $util.Long.prototype.toString.call(message.mallId) : options.longs === Number ? new $util.LongBits(message.mallId.low >>> 0, message.mallId.high >>> 0).toNumber() : message.mallId;
                        return object;
                    };
    
                    /**
                     * Converts this GetMallRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.GetMallRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetMallRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetMallRequest;
                })();
    
                v1.ListMallRequest = (function() {
    
                    /**
                     * Properties of a ListMallRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListMallRequest
                     * @property {palexy.streaming.v1.ListMallRequest.IMallFilter|null} [filter] ListMallRequest filter
                     * @property {number|null} [pageSize] ListMallRequest pageSize
                     * @property {string|null} [pageToken] ListMallRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListMallRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMallRequest.
                     * @implements IListMallRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListMallRequest=} [properties] Properties to set
                     */
                    function ListMallRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMallRequest filter.
                     * @member {palexy.streaming.v1.ListMallRequest.IMallFilter|null|undefined} filter
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @instance
                     */
                    ListMallRequest.prototype.filter = null;
    
                    /**
                     * ListMallRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @instance
                     */
                    ListMallRequest.prototype.pageSize = 0;
    
                    /**
                     * ListMallRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @instance
                     */
                    ListMallRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListMallRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMallRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMallRequest} ListMallRequest instance
                     */
                    ListMallRequest.create = function create(properties) {
                        return new ListMallRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListMallRequest message. Does not implicitly {@link palexy.streaming.v1.ListMallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMallRequest} message ListMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMallRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.streaming.v1.ListMallRequest.MallFilter.encode(message.filter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMallRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMallRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IListMallRequest} message ListMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMallRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMallRequest} ListMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMallRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMallRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.filter = $root.palexy.streaming.v1.ListMallRequest.MallFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMallRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMallRequest} ListMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMallRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMallRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMallRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.streaming.v1.ListMallRequest.MallFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListMallRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMallRequest} ListMallRequest
                     */
                    ListMallRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMallRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMallRequest();
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.streaming.v1.ListMallRequest.filter: object expected");
                            message.filter = $root.palexy.streaming.v1.ListMallRequest.MallFilter.fromObject(object.filter);
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMallRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @static
                     * @param {palexy.streaming.v1.ListMallRequest} message ListMallRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMallRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.filter = null;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.streaming.v1.ListMallRequest.MallFilter.toObject(message.filter, options);
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListMallRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMallRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMallRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListMallRequest.MallFilter = (function() {
    
                        /**
                         * Properties of a MallFilter.
                         * @memberof palexy.streaming.v1.ListMallRequest
                         * @interface IMallFilter
                         * @property {string|null} [name] MallFilter name
                         * @property {Array.<number>|null} [ids] MallFilter ids
                         * @property {string|null} [country] MallFilter country
                         * @property {palexy.streaming.v1.Mall.LocationType|null} [locationType] MallFilter locationType
                         */
    
                        /**
                         * Constructs a new MallFilter.
                         * @memberof palexy.streaming.v1.ListMallRequest
                         * @classdesc Represents a MallFilter.
                         * @implements IMallFilter
                         * @constructor
                         * @param {palexy.streaming.v1.ListMallRequest.IMallFilter=} [properties] Properties to set
                         */
                        function MallFilter(properties) {
                            this.ids = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * MallFilter name.
                         * @member {string} name
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @instance
                         */
                        MallFilter.prototype.name = "";
    
                        /**
                         * MallFilter ids.
                         * @member {Array.<number>} ids
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @instance
                         */
                        MallFilter.prototype.ids = $util.emptyArray;
    
                        /**
                         * MallFilter country.
                         * @member {string} country
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @instance
                         */
                        MallFilter.prototype.country = "";
    
                        /**
                         * MallFilter locationType.
                         * @member {palexy.streaming.v1.Mall.LocationType} locationType
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @instance
                         */
                        MallFilter.prototype.locationType = 0;
    
                        /**
                         * Creates a new MallFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {palexy.streaming.v1.ListMallRequest.IMallFilter=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.ListMallRequest.MallFilter} MallFilter instance
                         */
                        MallFilter.create = function create(properties) {
                            return new MallFilter(properties);
                        };
    
                        /**
                         * Encodes the specified MallFilter message. Does not implicitly {@link palexy.streaming.v1.ListMallRequest.MallFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {palexy.streaming.v1.ListMallRequest.IMallFilter} message MallFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MallFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                            if (message.ids != null && message.ids.length) {
                                writer.uint32(/* id 2, wireType 2 =*/18).fork();
                                for (var i = 0; i < message.ids.length; ++i)
                                    writer.int64(message.ids[i]);
                                writer.ldelim();
                            }
                            if (message.country != null && Object.hasOwnProperty.call(message, "country"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.country);
                            if (message.locationType != null && Object.hasOwnProperty.call(message, "locationType"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.locationType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified MallFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMallRequest.MallFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {palexy.streaming.v1.ListMallRequest.IMallFilter} message MallFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MallFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a MallFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.ListMallRequest.MallFilter} MallFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MallFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMallRequest.MallFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.name = reader.string();
                                    break;
                                case 2:
                                    if (!(message.ids && message.ids.length))
                                        message.ids = [];
                                    if ((tag & 7) === 2) {
                                        var end2 = reader.uint32() + reader.pos;
                                        while (reader.pos < end2)
                                            message.ids.push(reader.int64());
                                    } else
                                        message.ids.push(reader.int64());
                                    break;
                                case 3:
                                    message.country = reader.string();
                                    break;
                                case 4:
                                    message.locationType = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a MallFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.ListMallRequest.MallFilter} MallFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MallFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a MallFilter message.
                         * @function verify
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MallFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.name != null && message.hasOwnProperty("name"))
                                if (!$util.isString(message.name))
                                    return "name: string expected";
                            if (message.ids != null && message.hasOwnProperty("ids")) {
                                if (!Array.isArray(message.ids))
                                    return "ids: array expected";
                                for (var i = 0; i < message.ids.length; ++i)
                                    if (!$util.isInteger(message.ids[i]) && !(message.ids[i] && $util.isInteger(message.ids[i].low) && $util.isInteger(message.ids[i].high)))
                                        return "ids: integer|Long[] expected";
                            }
                            if (message.country != null && message.hasOwnProperty("country"))
                                if (!$util.isString(message.country))
                                    return "country: string expected";
                            if (message.locationType != null && message.hasOwnProperty("locationType"))
                                switch (message.locationType) {
                                default:
                                    return "locationType: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            return null;
                        };
    
                        /**
                         * Creates a MallFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.ListMallRequest.MallFilter} MallFilter
                         */
                        MallFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.ListMallRequest.MallFilter)
                                return object;
                            var message = new $root.palexy.streaming.v1.ListMallRequest.MallFilter();
                            if (object.name != null)
                                message.name = String(object.name);
                            if (object.ids) {
                                if (!Array.isArray(object.ids))
                                    throw TypeError(".palexy.streaming.v1.ListMallRequest.MallFilter.ids: array expected");
                                message.ids = [];
                                for (var i = 0; i < object.ids.length; ++i)
                                    if ($util.Long)
                                        (message.ids[i] = $util.Long.fromValue(object.ids[i])).unsigned = false;
                                    else if (typeof object.ids[i] === "string")
                                        message.ids[i] = parseInt(object.ids[i], 10);
                                    else if (typeof object.ids[i] === "number")
                                        message.ids[i] = object.ids[i];
                                    else if (typeof object.ids[i] === "object")
                                        message.ids[i] = new $util.LongBits(object.ids[i].low >>> 0, object.ids[i].high >>> 0).toNumber();
                            }
                            if (object.country != null)
                                message.country = String(object.country);
                            switch (object.locationType) {
                            case "UNKNOWN_LOCATION_TYPE":
                            case 0:
                                message.locationType = 0;
                                break;
                            case "MALL":
                            case 1:
                                message.locationType = 1;
                                break;
                            case "STREET":
                            case 2:
                                message.locationType = 2;
                                break;
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a MallFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @static
                         * @param {palexy.streaming.v1.ListMallRequest.MallFilter} message MallFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MallFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.ids = [];
                            if (options.defaults) {
                                object.name = "";
                                object.country = "";
                                object.locationType = options.enums === String ? "UNKNOWN_LOCATION_TYPE" : 0;
                            }
                            if (message.name != null && message.hasOwnProperty("name"))
                                object.name = message.name;
                            if (message.ids && message.ids.length) {
                                object.ids = [];
                                for (var j = 0; j < message.ids.length; ++j)
                                    if (typeof message.ids[j] === "number")
                                        object.ids[j] = options.longs === String ? String(message.ids[j]) : message.ids[j];
                                    else
                                        object.ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ids[j]) : options.longs === Number ? new $util.LongBits(message.ids[j].low >>> 0, message.ids[j].high >>> 0).toNumber() : message.ids[j];
                            }
                            if (message.country != null && message.hasOwnProperty("country"))
                                object.country = message.country;
                            if (message.locationType != null && message.hasOwnProperty("locationType"))
                                object.locationType = options.enums === String ? $root.palexy.streaming.v1.Mall.LocationType[message.locationType] : message.locationType;
                            return object;
                        };
    
                        /**
                         * Converts this MallFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.ListMallRequest.MallFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MallFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return MallFilter;
                    })();
    
                    return ListMallRequest;
                })();
    
                v1.ListMallResponse = (function() {
    
                    /**
                     * Properties of a ListMallResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListMallResponse
                     * @property {Array.<palexy.streaming.v1.IMall>|null} [malls] ListMallResponse malls
                     * @property {number|null} [totalElements] ListMallResponse totalElements
                     * @property {string|null} [nextPageToken] ListMallResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListMallResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListMallResponse.
                     * @implements IListMallResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListMallResponse=} [properties] Properties to set
                     */
                    function ListMallResponse(properties) {
                        this.malls = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListMallResponse malls.
                     * @member {Array.<palexy.streaming.v1.IMall>} malls
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @instance
                     */
                    ListMallResponse.prototype.malls = $util.emptyArray;
    
                    /**
                     * ListMallResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @instance
                     */
                    ListMallResponse.prototype.totalElements = 0;
    
                    /**
                     * ListMallResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @instance
                     */
                    ListMallResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListMallResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMallResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListMallResponse} ListMallResponse instance
                     */
                    ListMallResponse.create = function create(properties) {
                        return new ListMallResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListMallResponse message. Does not implicitly {@link palexy.streaming.v1.ListMallResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMallResponse} message ListMallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMallResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.malls != null && message.malls.length)
                            for (var i = 0; i < message.malls.length; ++i)
                                $root.palexy.streaming.v1.Mall.encode(message.malls[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListMallResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListMallResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {palexy.streaming.v1.IListMallResponse} message ListMallResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListMallResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListMallResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListMallResponse} ListMallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMallResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListMallResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.malls && message.malls.length))
                                    message.malls = [];
                                message.malls.push($root.palexy.streaming.v1.Mall.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListMallResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListMallResponse} ListMallResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListMallResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListMallResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListMallResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.malls != null && message.hasOwnProperty("malls")) {
                            if (!Array.isArray(message.malls))
                                return "malls: array expected";
                            for (var i = 0; i < message.malls.length; ++i) {
                                var error = $root.palexy.streaming.v1.Mall.verify(message.malls[i]);
                                if (error)
                                    return "malls." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListMallResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListMallResponse} ListMallResponse
                     */
                    ListMallResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListMallResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListMallResponse();
                        if (object.malls) {
                            if (!Array.isArray(object.malls))
                                throw TypeError(".palexy.streaming.v1.ListMallResponse.malls: array expected");
                            message.malls = [];
                            for (var i = 0; i < object.malls.length; ++i) {
                                if (typeof object.malls[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListMallResponse.malls: object expected");
                                message.malls[i] = $root.palexy.streaming.v1.Mall.fromObject(object.malls[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListMallResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @static
                     * @param {palexy.streaming.v1.ListMallResponse} message ListMallResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListMallResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.malls = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.malls && message.malls.length) {
                            object.malls = [];
                            for (var j = 0; j < message.malls.length; ++j)
                                object.malls[j] = $root.palexy.streaming.v1.Mall.toObject(message.malls[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListMallResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListMallResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListMallResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListMallResponse;
                })();
    
                v1.UpdateMallRequest = (function() {
    
                    /**
                     * Properties of an UpdateMallRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateMallRequest
                     * @property {palexy.streaming.v1.IMall|null} [mall] UpdateMallRequest mall
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateMallRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateMallRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateMallRequest.
                     * @implements IUpdateMallRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateMallRequest=} [properties] Properties to set
                     */
                    function UpdateMallRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateMallRequest mall.
                     * @member {palexy.streaming.v1.IMall|null|undefined} mall
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @instance
                     */
                    UpdateMallRequest.prototype.mall = null;
    
                    /**
                     * UpdateMallRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @instance
                     */
                    UpdateMallRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateMallRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMallRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateMallRequest} UpdateMallRequest instance
                     */
                    UpdateMallRequest.create = function create(properties) {
                        return new UpdateMallRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateMallRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateMallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMallRequest} message UpdateMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateMallRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mall != null && Object.hasOwnProperty.call(message, "mall"))
                            $root.palexy.streaming.v1.Mall.encode(message.mall, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateMallRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateMallRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateMallRequest} message UpdateMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateMallRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateMallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateMallRequest} UpdateMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateMallRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateMallRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mall = $root.palexy.streaming.v1.Mall.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateMallRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateMallRequest} UpdateMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateMallRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateMallRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateMallRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mall != null && message.hasOwnProperty("mall")) {
                            var error = $root.palexy.streaming.v1.Mall.verify(message.mall);
                            if (error)
                                return "mall." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateMallRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateMallRequest} UpdateMallRequest
                     */
                    UpdateMallRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateMallRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateMallRequest();
                        if (object.mall != null) {
                            if (typeof object.mall !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateMallRequest.mall: object expected");
                            message.mall = $root.palexy.streaming.v1.Mall.fromObject(object.mall);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateMallRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateMallRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateMallRequest} message UpdateMallRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateMallRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mall = null;
                            object.updateMask = null;
                        }
                        if (message.mall != null && message.hasOwnProperty("mall"))
                            object.mall = $root.palexy.streaming.v1.Mall.toObject(message.mall, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateMallRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateMallRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateMallRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateMallRequest;
                })();
    
                v1.DeleteMallRequest = (function() {
    
                    /**
                     * Properties of a DeleteMallRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteMallRequest
                     * @property {number|null} [mallId] DeleteMallRequest mallId
                     */
    
                    /**
                     * Constructs a new DeleteMallRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteMallRequest.
                     * @implements IDeleteMallRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteMallRequest=} [properties] Properties to set
                     */
                    function DeleteMallRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteMallRequest mallId.
                     * @member {number} mallId
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @instance
                     */
                    DeleteMallRequest.prototype.mallId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteMallRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMallRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteMallRequest} DeleteMallRequest instance
                     */
                    DeleteMallRequest.create = function create(properties) {
                        return new DeleteMallRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteMallRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteMallRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMallRequest} message DeleteMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteMallRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mallId != null && Object.hasOwnProperty.call(message, "mallId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.mallId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteMallRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteMallRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteMallRequest} message DeleteMallRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteMallRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteMallRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteMallRequest} DeleteMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteMallRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteMallRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mallId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteMallRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteMallRequest} DeleteMallRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteMallRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteMallRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteMallRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (!$util.isInteger(message.mallId) && !(message.mallId && $util.isInteger(message.mallId.low) && $util.isInteger(message.mallId.high)))
                                return "mallId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteMallRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteMallRequest} DeleteMallRequest
                     */
                    DeleteMallRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteMallRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteMallRequest();
                        if (object.mallId != null)
                            if ($util.Long)
                                (message.mallId = $util.Long.fromValue(object.mallId)).unsigned = false;
                            else if (typeof object.mallId === "string")
                                message.mallId = parseInt(object.mallId, 10);
                            else if (typeof object.mallId === "number")
                                message.mallId = object.mallId;
                            else if (typeof object.mallId === "object")
                                message.mallId = new $util.LongBits(object.mallId.low >>> 0, object.mallId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteMallRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteMallRequest} message DeleteMallRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteMallRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.mallId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.mallId = options.longs === String ? "0" : 0;
                        if (message.mallId != null && message.hasOwnProperty("mallId"))
                            if (typeof message.mallId === "number")
                                object.mallId = options.longs === String ? String(message.mallId) : message.mallId;
                            else
                                object.mallId = options.longs === String ? $util.Long.prototype.toString.call(message.mallId) : options.longs === Number ? new $util.LongBits(message.mallId.low >>> 0, message.mallId.high >>> 0).toNumber() : message.mallId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteMallRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteMallRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteMallRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteMallRequest;
                })();
    
                v1.AdjacentStore = (function() {
    
                    /**
                     * Properties of an AdjacentStore.
                     * @memberof palexy.streaming.v1
                     * @interface IAdjacentStore
                     * @property {number|null} [id] AdjacentStore id
                     * @property {number|null} [firstStoreId] AdjacentStore firstStoreId
                     * @property {number|null} [secondStoreId] AdjacentStore secondStoreId
                     * @property {palexy.streaming.v1.AdjacentStore.Origin|null} [origin] AdjacentStore origin
                     * @property {number|null} [companyId] AdjacentStore companyId
                     * @property {number|null} [createTimeMs] AdjacentStore createTimeMs
                     */
    
                    /**
                     * Constructs a new AdjacentStore.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AdjacentStore.
                     * @implements IAdjacentStore
                     * @constructor
                     * @param {palexy.streaming.v1.IAdjacentStore=} [properties] Properties to set
                     */
                    function AdjacentStore(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AdjacentStore id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjacentStore firstStoreId.
                     * @member {number} firstStoreId
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.firstStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjacentStore secondStoreId.
                     * @member {number} secondStoreId
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.secondStoreId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjacentStore origin.
                     * @member {palexy.streaming.v1.AdjacentStore.Origin} origin
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.origin = 0;
    
                    /**
                     * AdjacentStore companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AdjacentStore createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     */
                    AdjacentStore.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AdjacentStore instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {palexy.streaming.v1.IAdjacentStore=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AdjacentStore} AdjacentStore instance
                     */
                    AdjacentStore.create = function create(properties) {
                        return new AdjacentStore(properties);
                    };
    
                    /**
                     * Encodes the specified AdjacentStore message. Does not implicitly {@link palexy.streaming.v1.AdjacentStore.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {palexy.streaming.v1.IAdjacentStore} message AdjacentStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdjacentStore.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.firstStoreId != null && Object.hasOwnProperty.call(message, "firstStoreId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.firstStoreId);
                        if (message.secondStoreId != null && Object.hasOwnProperty.call(message, "secondStoreId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.secondStoreId);
                        if (message.origin != null && Object.hasOwnProperty.call(message, "origin"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.origin);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.companyId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AdjacentStore message, length delimited. Does not implicitly {@link palexy.streaming.v1.AdjacentStore.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {palexy.streaming.v1.IAdjacentStore} message AdjacentStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdjacentStore.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AdjacentStore message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AdjacentStore} AdjacentStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdjacentStore.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AdjacentStore();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.firstStoreId = reader.int64();
                                break;
                            case 3:
                                message.secondStoreId = reader.int64();
                                break;
                            case 4:
                                message.origin = reader.int32();
                                break;
                            case 5:
                                message.companyId = reader.int64();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AdjacentStore message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AdjacentStore} AdjacentStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdjacentStore.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AdjacentStore message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AdjacentStore.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.firstStoreId != null && message.hasOwnProperty("firstStoreId"))
                            if (!$util.isInteger(message.firstStoreId) && !(message.firstStoreId && $util.isInteger(message.firstStoreId.low) && $util.isInteger(message.firstStoreId.high)))
                                return "firstStoreId: integer|Long expected";
                        if (message.secondStoreId != null && message.hasOwnProperty("secondStoreId"))
                            if (!$util.isInteger(message.secondStoreId) && !(message.secondStoreId && $util.isInteger(message.secondStoreId.low) && $util.isInteger(message.secondStoreId.high)))
                                return "secondStoreId: integer|Long expected";
                        if (message.origin != null && message.hasOwnProperty("origin"))
                            switch (message.origin) {
                            default:
                                return "origin: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AdjacentStore message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AdjacentStore} AdjacentStore
                     */
                    AdjacentStore.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AdjacentStore)
                            return object;
                        var message = new $root.palexy.streaming.v1.AdjacentStore();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.firstStoreId != null)
                            if ($util.Long)
                                (message.firstStoreId = $util.Long.fromValue(object.firstStoreId)).unsigned = false;
                            else if (typeof object.firstStoreId === "string")
                                message.firstStoreId = parseInt(object.firstStoreId, 10);
                            else if (typeof object.firstStoreId === "number")
                                message.firstStoreId = object.firstStoreId;
                            else if (typeof object.firstStoreId === "object")
                                message.firstStoreId = new $util.LongBits(object.firstStoreId.low >>> 0, object.firstStoreId.high >>> 0).toNumber();
                        if (object.secondStoreId != null)
                            if ($util.Long)
                                (message.secondStoreId = $util.Long.fromValue(object.secondStoreId)).unsigned = false;
                            else if (typeof object.secondStoreId === "string")
                                message.secondStoreId = parseInt(object.secondStoreId, 10);
                            else if (typeof object.secondStoreId === "number")
                                message.secondStoreId = object.secondStoreId;
                            else if (typeof object.secondStoreId === "object")
                                message.secondStoreId = new $util.LongBits(object.secondStoreId.low >>> 0, object.secondStoreId.high >>> 0).toNumber();
                        switch (object.origin) {
                        case "UNKNOWN":
                        case 0:
                            message.origin = 0;
                            break;
                        case "MANUAL":
                        case 1:
                            message.origin = 1;
                            break;
                        case "SYSTEM":
                        case 2:
                            message.origin = 2;
                            break;
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AdjacentStore message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @static
                     * @param {palexy.streaming.v1.AdjacentStore} message AdjacentStore
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AdjacentStore.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.firstStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.firstStoreId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.secondStoreId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.secondStoreId = options.longs === String ? "0" : 0;
                            object.origin = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.firstStoreId != null && message.hasOwnProperty("firstStoreId"))
                            if (typeof message.firstStoreId === "number")
                                object.firstStoreId = options.longs === String ? String(message.firstStoreId) : message.firstStoreId;
                            else
                                object.firstStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.firstStoreId) : options.longs === Number ? new $util.LongBits(message.firstStoreId.low >>> 0, message.firstStoreId.high >>> 0).toNumber() : message.firstStoreId;
                        if (message.secondStoreId != null && message.hasOwnProperty("secondStoreId"))
                            if (typeof message.secondStoreId === "number")
                                object.secondStoreId = options.longs === String ? String(message.secondStoreId) : message.secondStoreId;
                            else
                                object.secondStoreId = options.longs === String ? $util.Long.prototype.toString.call(message.secondStoreId) : options.longs === Number ? new $util.LongBits(message.secondStoreId.low >>> 0, message.secondStoreId.high >>> 0).toNumber() : message.secondStoreId;
                        if (message.origin != null && message.hasOwnProperty("origin"))
                            object.origin = options.enums === String ? $root.palexy.streaming.v1.AdjacentStore.Origin[message.origin] : message.origin;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this AdjacentStore to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AdjacentStore
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AdjacentStore.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Origin enum.
                     * @name palexy.streaming.v1.AdjacentStore.Origin
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} MANUAL=1 MANUAL value
                     * @property {number} SYSTEM=2 SYSTEM value
                     */
                    AdjacentStore.Origin = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "MANUAL"] = 1;
                        values[valuesById[2] = "SYSTEM"] = 2;
                        return values;
                    })();
    
                    return AdjacentStore;
                })();
    
                v1.ShiftPreviewData = (function() {
    
                    /**
                     * Properties of a ShiftPreviewData.
                     * @memberof palexy.streaming.v1
                     * @interface IShiftPreviewData
                     * @property {number|null} [storeId] ShiftPreviewData storeId
                     * @property {string|null} [storeName] ShiftPreviewData storeName
                     * @property {number|null} [dateId] ShiftPreviewData dateId
                     * @property {string|null} [staffName] ShiftPreviewData staffName
                     * @property {string|null} [posId] ShiftPreviewData posId
                     * @property {string|null} [startTime] ShiftPreviewData startTime
                     * @property {string|null} [endTime] ShiftPreviewData endTime
                     * @property {string|null} [shiftTemplateName] ShiftPreviewData shiftTemplateName
                     * @property {boolean|null} [isTimeOff] ShiftPreviewData isTimeOff
                     */
    
                    /**
                     * Constructs a new ShiftPreviewData.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ShiftPreviewData.
                     * @implements IShiftPreviewData
                     * @constructor
                     * @param {palexy.streaming.v1.IShiftPreviewData=} [properties] Properties to set
                     */
                    function ShiftPreviewData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftPreviewData storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ShiftPreviewData storeName.
                     * @member {string} storeName
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.storeName = "";
    
                    /**
                     * ShiftPreviewData dateId.
                     * @member {number} dateId
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.dateId = 0;
    
                    /**
                     * ShiftPreviewData staffName.
                     * @member {string} staffName
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.staffName = "";
    
                    /**
                     * ShiftPreviewData posId.
                     * @member {string} posId
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.posId = "";
    
                    /**
                     * ShiftPreviewData startTime.
                     * @member {string} startTime
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.startTime = "";
    
                    /**
                     * ShiftPreviewData endTime.
                     * @member {string} endTime
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.endTime = "";
    
                    /**
                     * ShiftPreviewData shiftTemplateName.
                     * @member {string} shiftTemplateName
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.shiftTemplateName = "";
    
                    /**
                     * ShiftPreviewData isTimeOff.
                     * @member {boolean} isTimeOff
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     */
                    ShiftPreviewData.prototype.isTimeOff = false;
    
                    /**
                     * Creates a new ShiftPreviewData instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {palexy.streaming.v1.IShiftPreviewData=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ShiftPreviewData} ShiftPreviewData instance
                     */
                    ShiftPreviewData.create = function create(properties) {
                        return new ShiftPreviewData(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftPreviewData message. Does not implicitly {@link palexy.streaming.v1.ShiftPreviewData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {palexy.streaming.v1.IShiftPreviewData} message ShiftPreviewData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftPreviewData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.storeName);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.staffName != null && Object.hasOwnProperty.call(message, "staffName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.staffName);
                        if (message.posId != null && Object.hasOwnProperty.call(message, "posId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.posId);
                        if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.startTime);
                        if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.endTime);
                        if (message.shiftTemplateName != null && Object.hasOwnProperty.call(message, "shiftTemplateName"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.shiftTemplateName);
                        if (message.isTimeOff != null && Object.hasOwnProperty.call(message, "isTimeOff"))
                            writer.uint32(/* id 13, wireType 0 =*/104).bool(message.isTimeOff);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftPreviewData message, length delimited. Does not implicitly {@link palexy.streaming.v1.ShiftPreviewData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {palexy.streaming.v1.IShiftPreviewData} message ShiftPreviewData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftPreviewData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftPreviewData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ShiftPreviewData} ShiftPreviewData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftPreviewData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ShiftPreviewData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.storeName = reader.string();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.staffName = reader.string();
                                break;
                            case 5:
                                message.posId = reader.string();
                                break;
                            case 8:
                                message.startTime = reader.string();
                                break;
                            case 9:
                                message.endTime = reader.string();
                                break;
                            case 12:
                                message.shiftTemplateName = reader.string();
                                break;
                            case 13:
                                message.isTimeOff = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftPreviewData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ShiftPreviewData} ShiftPreviewData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftPreviewData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftPreviewData message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftPreviewData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            if (!$util.isString(message.storeName))
                                return "storeName: string expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.staffName != null && message.hasOwnProperty("staffName"))
                            if (!$util.isString(message.staffName))
                                return "staffName: string expected";
                        if (message.posId != null && message.hasOwnProperty("posId"))
                            if (!$util.isString(message.posId))
                                return "posId: string expected";
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            if (!$util.isString(message.startTime))
                                return "startTime: string expected";
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            if (!$util.isString(message.endTime))
                                return "endTime: string expected";
                        if (message.shiftTemplateName != null && message.hasOwnProperty("shiftTemplateName"))
                            if (!$util.isString(message.shiftTemplateName))
                                return "shiftTemplateName: string expected";
                        if (message.isTimeOff != null && message.hasOwnProperty("isTimeOff"))
                            if (typeof message.isTimeOff !== "boolean")
                                return "isTimeOff: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftPreviewData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ShiftPreviewData} ShiftPreviewData
                     */
                    ShiftPreviewData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ShiftPreviewData)
                            return object;
                        var message = new $root.palexy.streaming.v1.ShiftPreviewData();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.storeName != null)
                            message.storeName = String(object.storeName);
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.staffName != null)
                            message.staffName = String(object.staffName);
                        if (object.posId != null)
                            message.posId = String(object.posId);
                        if (object.startTime != null)
                            message.startTime = String(object.startTime);
                        if (object.endTime != null)
                            message.endTime = String(object.endTime);
                        if (object.shiftTemplateName != null)
                            message.shiftTemplateName = String(object.shiftTemplateName);
                        if (object.isTimeOff != null)
                            message.isTimeOff = Boolean(object.isTimeOff);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftPreviewData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @static
                     * @param {palexy.streaming.v1.ShiftPreviewData} message ShiftPreviewData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftPreviewData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.storeName = "";
                            object.dateId = 0;
                            object.staffName = "";
                            object.posId = "";
                            object.startTime = "";
                            object.endTime = "";
                            object.shiftTemplateName = "";
                            object.isTimeOff = false;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            object.storeName = message.storeName;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.staffName != null && message.hasOwnProperty("staffName"))
                            object.staffName = message.staffName;
                        if (message.posId != null && message.hasOwnProperty("posId"))
                            object.posId = message.posId;
                        if (message.startTime != null && message.hasOwnProperty("startTime"))
                            object.startTime = message.startTime;
                        if (message.endTime != null && message.hasOwnProperty("endTime"))
                            object.endTime = message.endTime;
                        if (message.shiftTemplateName != null && message.hasOwnProperty("shiftTemplateName"))
                            object.shiftTemplateName = message.shiftTemplateName;
                        if (message.isTimeOff != null && message.hasOwnProperty("isTimeOff"))
                            object.isTimeOff = message.isTimeOff;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftPreviewData to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ShiftPreviewData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftPreviewData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftPreviewData;
                })();
    
                v1.BatchUploadScheduleRequest = (function() {
    
                    /**
                     * Properties of a BatchUploadScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUploadScheduleRequest
                     * @property {number|null} [companyId] BatchUploadScheduleRequest companyId
                     * @property {palexy.streaming.v1.IEmailAttachment|null} [file] BatchUploadScheduleRequest file
                     * @property {number|null} [startDateId] BatchUploadScheduleRequest startDateId
                     * @property {number|null} [endDateId] BatchUploadScheduleRequest endDateId
                     * @property {boolean|null} [preview] BatchUploadScheduleRequest preview
                     */
    
                    /**
                     * Constructs a new BatchUploadScheduleRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUploadScheduleRequest.
                     * @implements IBatchUploadScheduleRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest=} [properties] Properties to set
                     */
                    function BatchUploadScheduleRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUploadScheduleRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     */
                    BatchUploadScheduleRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchUploadScheduleRequest file.
                     * @member {palexy.streaming.v1.IEmailAttachment|null|undefined} file
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     */
                    BatchUploadScheduleRequest.prototype.file = null;
    
                    /**
                     * BatchUploadScheduleRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     */
                    BatchUploadScheduleRequest.prototype.startDateId = 0;
    
                    /**
                     * BatchUploadScheduleRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     */
                    BatchUploadScheduleRequest.prototype.endDateId = 0;
    
                    /**
                     * BatchUploadScheduleRequest preview.
                     * @member {boolean} preview
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     */
                    BatchUploadScheduleRequest.prototype.preview = false;
    
                    /**
                     * Creates a new BatchUploadScheduleRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUploadScheduleRequest} BatchUploadScheduleRequest instance
                     */
                    BatchUploadScheduleRequest.create = function create(properties) {
                        return new BatchUploadScheduleRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUploadScheduleRequest message. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest} message BatchUploadScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUploadScheduleRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                            $root.palexy.streaming.v1.EmailAttachment.encode(message.file, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.endDateId);
                        if (message.preview != null && Object.hasOwnProperty.call(message, "preview"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.preview);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUploadScheduleRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleRequest} message BatchUploadScheduleRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUploadScheduleRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUploadScheduleRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUploadScheduleRequest} BatchUploadScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUploadScheduleRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUploadScheduleRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.file = $root.palexy.streaming.v1.EmailAttachment.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.startDateId = reader.int32();
                                break;
                            case 4:
                                message.endDateId = reader.int32();
                                break;
                            case 5:
                                message.preview = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUploadScheduleRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUploadScheduleRequest} BatchUploadScheduleRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUploadScheduleRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUploadScheduleRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUploadScheduleRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.file != null && message.hasOwnProperty("file")) {
                            var error = $root.palexy.streaming.v1.EmailAttachment.verify(message.file);
                            if (error)
                                return "file." + error;
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            if (typeof message.preview !== "boolean")
                                return "preview: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchUploadScheduleRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUploadScheduleRequest} BatchUploadScheduleRequest
                     */
                    BatchUploadScheduleRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUploadScheduleRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUploadScheduleRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.file != null) {
                            if (typeof object.file !== "object")
                                throw TypeError(".palexy.streaming.v1.BatchUploadScheduleRequest.file: object expected");
                            message.file = $root.palexy.streaming.v1.EmailAttachment.fromObject(object.file);
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.preview != null)
                            message.preview = Boolean(object.preview);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUploadScheduleRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @static
                     * @param {palexy.streaming.v1.BatchUploadScheduleRequest} message BatchUploadScheduleRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUploadScheduleRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.file = null;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.preview = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.file != null && message.hasOwnProperty("file"))
                            object.file = $root.palexy.streaming.v1.EmailAttachment.toObject(message.file, options);
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.preview != null && message.hasOwnProperty("preview"))
                            object.preview = message.preview;
                        return object;
                    };
    
                    /**
                     * Converts this BatchUploadScheduleRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUploadScheduleRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUploadScheduleRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchUploadScheduleRequest;
                })();
    
                v1.BatchUploadScheduleResponse = (function() {
    
                    /**
                     * Properties of a BatchUploadScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IBatchUploadScheduleResponse
                     * @property {Array.<palexy.streaming.v1.IShiftPreviewData>|null} [shifts] BatchUploadScheduleResponse shifts
                     * @property {Array.<palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError>|null} [errors] BatchUploadScheduleResponse errors
                     * @property {Array.<palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError>|null} [warnings] BatchUploadScheduleResponse warnings
                     * @property {string|null} [message] BatchUploadScheduleResponse message
                     * @property {string|null} [storeId] BatchUploadScheduleResponse storeId
                     */
    
                    /**
                     * Constructs a new BatchUploadScheduleResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BatchUploadScheduleResponse.
                     * @implements IBatchUploadScheduleResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IBatchUploadScheduleResponse=} [properties] Properties to set
                     */
                    function BatchUploadScheduleResponse(properties) {
                        this.shifts = [];
                        this.errors = [];
                        this.warnings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchUploadScheduleResponse shifts.
                     * @member {Array.<palexy.streaming.v1.IShiftPreviewData>} shifts
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     */
                    BatchUploadScheduleResponse.prototype.shifts = $util.emptyArray;
    
                    /**
                     * BatchUploadScheduleResponse errors.
                     * @member {Array.<palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError>} errors
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     */
                    BatchUploadScheduleResponse.prototype.errors = $util.emptyArray;
    
                    /**
                     * BatchUploadScheduleResponse warnings.
                     * @member {Array.<palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError>} warnings
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     */
                    BatchUploadScheduleResponse.prototype.warnings = $util.emptyArray;
    
                    /**
                     * BatchUploadScheduleResponse message.
                     * @member {string} message
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     */
                    BatchUploadScheduleResponse.prototype.message = "";
    
                    /**
                     * BatchUploadScheduleResponse storeId.
                     * @member {string} storeId
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     */
                    BatchUploadScheduleResponse.prototype.storeId = "";
    
                    /**
                     * Creates a new BatchUploadScheduleResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BatchUploadScheduleResponse} BatchUploadScheduleResponse instance
                     */
                    BatchUploadScheduleResponse.create = function create(properties) {
                        return new BatchUploadScheduleResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchUploadScheduleResponse message. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleResponse} message BatchUploadScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUploadScheduleResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shifts != null && message.shifts.length)
                            for (var i = 0; i < message.shifts.length; ++i)
                                $root.palexy.streaming.v1.ShiftPreviewData.encode(message.shifts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.errors != null && message.errors.length)
                            for (var i = 0; i < message.errors.length; ++i)
                                $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.encode(message.errors[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.warnings != null && message.warnings.length)
                            for (var i = 0; i < message.warnings.length; ++i)
                                $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.encode(message.warnings[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.message);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.storeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchUploadScheduleResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.IBatchUploadScheduleResponse} message BatchUploadScheduleResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchUploadScheduleResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchUploadScheduleResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BatchUploadScheduleResponse} BatchUploadScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUploadScheduleResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUploadScheduleResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.shifts && message.shifts.length))
                                    message.shifts = [];
                                message.shifts.push($root.palexy.streaming.v1.ShiftPreviewData.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.errors && message.errors.length))
                                    message.errors = [];
                                message.errors.push($root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.warnings && message.warnings.length))
                                    message.warnings = [];
                                message.warnings.push($root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.message = reader.string();
                                break;
                            case 5:
                                message.storeId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchUploadScheduleResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BatchUploadScheduleResponse} BatchUploadScheduleResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchUploadScheduleResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchUploadScheduleResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchUploadScheduleResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shifts != null && message.hasOwnProperty("shifts")) {
                            if (!Array.isArray(message.shifts))
                                return "shifts: array expected";
                            for (var i = 0; i < message.shifts.length; ++i) {
                                var error = $root.palexy.streaming.v1.ShiftPreviewData.verify(message.shifts[i]);
                                if (error)
                                    return "shifts." + error;
                            }
                        }
                        if (message.errors != null && message.hasOwnProperty("errors")) {
                            if (!Array.isArray(message.errors))
                                return "errors: array expected";
                            for (var i = 0; i < message.errors.length; ++i) {
                                var error = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.verify(message.errors[i]);
                                if (error)
                                    return "errors." + error;
                            }
                        }
                        if (message.warnings != null && message.hasOwnProperty("warnings")) {
                            if (!Array.isArray(message.warnings))
                                return "warnings: array expected";
                            for (var i = 0; i < message.warnings.length; ++i) {
                                var error = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.verify(message.warnings[i]);
                                if (error)
                                    return "warnings." + error;
                            }
                        }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isString(message.storeId))
                                return "storeId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a BatchUploadScheduleResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BatchUploadScheduleResponse} BatchUploadScheduleResponse
                     */
                    BatchUploadScheduleResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BatchUploadScheduleResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.BatchUploadScheduleResponse();
                        if (object.shifts) {
                            if (!Array.isArray(object.shifts))
                                throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.shifts: array expected");
                            message.shifts = [];
                            for (var i = 0; i < object.shifts.length; ++i) {
                                if (typeof object.shifts[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.shifts: object expected");
                                message.shifts[i] = $root.palexy.streaming.v1.ShiftPreviewData.fromObject(object.shifts[i]);
                            }
                        }
                        if (object.errors) {
                            if (!Array.isArray(object.errors))
                                throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.errors: array expected");
                            message.errors = [];
                            for (var i = 0; i < object.errors.length; ++i) {
                                if (typeof object.errors[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.errors: object expected");
                                message.errors[i] = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.fromObject(object.errors[i]);
                            }
                        }
                        if (object.warnings) {
                            if (!Array.isArray(object.warnings))
                                throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.warnings: array expected");
                            message.warnings = [];
                            for (var i = 0; i < object.warnings.length; ++i) {
                                if (typeof object.warnings[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.BatchUploadScheduleResponse.warnings: object expected");
                                message.warnings[i] = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.fromObject(object.warnings[i]);
                            }
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.storeId != null)
                            message.storeId = String(object.storeId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchUploadScheduleResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @static
                     * @param {palexy.streaming.v1.BatchUploadScheduleResponse} message BatchUploadScheduleResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchUploadScheduleResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.shifts = [];
                            object.errors = [];
                            object.warnings = [];
                        }
                        if (options.defaults) {
                            object.message = "";
                            object.storeId = "";
                        }
                        if (message.shifts && message.shifts.length) {
                            object.shifts = [];
                            for (var j = 0; j < message.shifts.length; ++j)
                                object.shifts[j] = $root.palexy.streaming.v1.ShiftPreviewData.toObject(message.shifts[j], options);
                        }
                        if (message.errors && message.errors.length) {
                            object.errors = [];
                            for (var j = 0; j < message.errors.length; ++j)
                                object.errors[j] = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.toObject(message.errors[j], options);
                        }
                        if (message.warnings && message.warnings.length) {
                            object.warnings = [];
                            for (var j = 0; j < message.warnings.length; ++j)
                                object.warnings[j] = $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.toObject(message.warnings[j], options);
                        }
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            object.storeId = message.storeId;
                        return object;
                    };
    
                    /**
                     * Converts this BatchUploadScheduleResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchUploadScheduleResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    BatchUploadScheduleResponse.ShiftError = (function() {
    
                        /**
                         * Properties of a ShiftError.
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                         * @interface IShiftError
                         * @property {string|null} [cellReference] ShiftError cellReference
                         * @property {string|null} [message] ShiftError message
                         */
    
                        /**
                         * Constructs a new ShiftError.
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse
                         * @classdesc Represents a ShiftError.
                         * @implements IShiftError
                         * @constructor
                         * @param {palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError=} [properties] Properties to set
                         */
                        function ShiftError(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ShiftError cellReference.
                         * @member {string} cellReference
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @instance
                         */
                        ShiftError.prototype.cellReference = "";
    
                        /**
                         * ShiftError message.
                         * @member {string} message
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @instance
                         */
                        ShiftError.prototype.message = "";
    
                        /**
                         * Creates a new ShiftError instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError} ShiftError instance
                         */
                        ShiftError.create = function create(properties) {
                            return new ShiftError(properties);
                        };
    
                        /**
                         * Encodes the specified ShiftError message. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError} message ShiftError message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftError.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.cellReference != null && Object.hasOwnProperty.call(message, "cellReference"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.cellReference);
                            if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ShiftError message, length delimited. Does not implicitly {@link palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {palexy.streaming.v1.BatchUploadScheduleResponse.IShiftError} message ShiftError message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftError.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ShiftError message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError} ShiftError
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftError.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.cellReference = reader.string();
                                    break;
                                case 2:
                                    message.message = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ShiftError message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError} ShiftError
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftError.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ShiftError message.
                         * @function verify
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ShiftError.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.cellReference != null && message.hasOwnProperty("cellReference"))
                                if (!$util.isString(message.cellReference))
                                    return "cellReference: string expected";
                            if (message.message != null && message.hasOwnProperty("message"))
                                if (!$util.isString(message.message))
                                    return "message: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ShiftError message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError} ShiftError
                         */
                        ShiftError.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError)
                                return object;
                            var message = new $root.palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError();
                            if (object.cellReference != null)
                                message.cellReference = String(object.cellReference);
                            if (object.message != null)
                                message.message = String(object.message);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ShiftError message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @static
                         * @param {palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError} message ShiftError
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ShiftError.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.cellReference = "";
                                object.message = "";
                            }
                            if (message.cellReference != null && message.hasOwnProperty("cellReference"))
                                object.cellReference = message.cellReference;
                            if (message.message != null && message.hasOwnProperty("message"))
                                object.message = message.message;
                            return object;
                        };
    
                        /**
                         * Converts this ShiftError to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.BatchUploadScheduleResponse.ShiftError
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ShiftError.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ShiftError;
                    })();
    
                    return BatchUploadScheduleResponse;
                })();
    
                v1.StoreTargetSummary = (function() {
    
                    /**
                     * Properties of a StoreTargetSummary.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreTargetSummary
                     * @property {number|null} [totalSales] StoreTargetSummary totalSales
                     * @property {number|null} [totalStores] StoreTargetSummary totalStores
                     * @property {number|null} [noStoresWithSalesTarget] StoreTargetSummary noStoresWithSalesTarget
                     * @property {number|null} [noStoresWithConversionRateTarget] StoreTargetSummary noStoresWithConversionRateTarget
                     * @property {number|null} [noStoresWithAtvTarget] StoreTargetSummary noStoresWithAtvTarget
                     * @property {number|null} [noStoresWithUptTarget] StoreTargetSummary noStoresWithUptTarget
                     * @property {number|null} [noStoresWithInteractionRateTarget] StoreTargetSummary noStoresWithInteractionRateTarget
                     * @property {number|null} [noStoresWithItemsTarget] StoreTargetSummary noStoresWithItemsTarget
                     * @property {number|null} [noStoresWithSalesPerStaffHourTarget] StoreTargetSummary noStoresWithSalesPerStaffHourTarget
                     * @property {number|null} [noStoresWithCaptureRateTarget] StoreTargetSummary noStoresWithCaptureRateTarget
                     * @property {number|null} [noStoresWithGreetingRateTarget] StoreTargetSummary noStoresWithGreetingRateTarget
                     * @property {number|null} [noStoresWithOnTimeGreetingRateTarget] StoreTargetSummary noStoresWithOnTimeGreetingRateTarget
                     * @property {number|null} [noStoresWithConversionByOpportunitiesTarget] StoreTargetSummary noStoresWithConversionByOpportunitiesTarget
                     * @property {number|null} [noStoresWithQueueTimeComplianceRateTarget] StoreTargetSummary noStoresWithQueueTimeComplianceRateTarget
                     * @property {number|null} [noStoresWithTransactionTimeComplianceRateTarget] StoreTargetSummary noStoresWithTransactionTimeComplianceRateTarget
                     * @property {number|null} [noStoresWithOrderPreparationTimeComplianceRateTarget] StoreTargetSummary noStoresWithOrderPreparationTimeComplianceRateTarget
                     * @property {number|null} [noStoresWithTotalServiceTimeComplianceRateTarget] StoreTargetSummary noStoresWithTotalServiceTimeComplianceRateTarget
                     * @property {number|null} [noStoresWithDwellTimeAvgTarget] StoreTargetSummary noStoresWithDwellTimeAvgTarget
                     * @property {number|null} [noStoresWithCustomAction_1RateTarget] StoreTargetSummary noStoresWithCustomAction_1RateTarget
                     * @property {number|null} [noStoresWithAvgVisitorsPerStaffTarget] StoreTargetSummary noStoresWithAvgVisitorsPerStaffTarget
                     * @property {number|null} [noStoresWithInteractionTimeAvgTarget] StoreTargetSummary noStoresWithInteractionTimeAvgTarget
                     */
    
                    /**
                     * Constructs a new StoreTargetSummary.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreTargetSummary.
                     * @implements IStoreTargetSummary
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreTargetSummary=} [properties] Properties to set
                     */
                    function StoreTargetSummary(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreTargetSummary totalSales.
                     * @member {number} totalSales
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.totalSales = 0;
    
                    /**
                     * StoreTargetSummary totalStores.
                     * @member {number} totalStores
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.totalStores = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithSalesTarget.
                     * @member {number} noStoresWithSalesTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithSalesTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithConversionRateTarget.
                     * @member {number} noStoresWithConversionRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithConversionRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithAtvTarget.
                     * @member {number} noStoresWithAtvTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithAtvTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithUptTarget.
                     * @member {number} noStoresWithUptTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithUptTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithInteractionRateTarget.
                     * @member {number} noStoresWithInteractionRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithInteractionRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithItemsTarget.
                     * @member {number} noStoresWithItemsTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithItemsTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithSalesPerStaffHourTarget.
                     * @member {number} noStoresWithSalesPerStaffHourTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithSalesPerStaffHourTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithCaptureRateTarget.
                     * @member {number} noStoresWithCaptureRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithCaptureRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithGreetingRateTarget.
                     * @member {number} noStoresWithGreetingRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithGreetingRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithOnTimeGreetingRateTarget.
                     * @member {number} noStoresWithOnTimeGreetingRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithOnTimeGreetingRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithConversionByOpportunitiesTarget.
                     * @member {number} noStoresWithConversionByOpportunitiesTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithConversionByOpportunitiesTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithQueueTimeComplianceRateTarget.
                     * @member {number} noStoresWithQueueTimeComplianceRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithQueueTimeComplianceRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithTransactionTimeComplianceRateTarget.
                     * @member {number} noStoresWithTransactionTimeComplianceRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithTransactionTimeComplianceRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithOrderPreparationTimeComplianceRateTarget.
                     * @member {number} noStoresWithOrderPreparationTimeComplianceRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithOrderPreparationTimeComplianceRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithTotalServiceTimeComplianceRateTarget.
                     * @member {number} noStoresWithTotalServiceTimeComplianceRateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithTotalServiceTimeComplianceRateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithDwellTimeAvgTarget.
                     * @member {number} noStoresWithDwellTimeAvgTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithDwellTimeAvgTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithCustomAction_1RateTarget.
                     * @member {number} noStoresWithCustomAction_1RateTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithCustomAction_1RateTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithAvgVisitorsPerStaffTarget.
                     * @member {number} noStoresWithAvgVisitorsPerStaffTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithAvgVisitorsPerStaffTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreTargetSummary noStoresWithInteractionTimeAvgTarget.
                     * @member {number} noStoresWithInteractionTimeAvgTarget
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     */
                    StoreTargetSummary.prototype.noStoresWithInteractionTimeAvgTarget = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new StoreTargetSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {palexy.streaming.v1.IStoreTargetSummary=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreTargetSummary} StoreTargetSummary instance
                     */
                    StoreTargetSummary.create = function create(properties) {
                        return new StoreTargetSummary(properties);
                    };
    
                    /**
                     * Encodes the specified StoreTargetSummary message. Does not implicitly {@link palexy.streaming.v1.StoreTargetSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {palexy.streaming.v1.IStoreTargetSummary} message StoreTargetSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreTargetSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.totalSales != null && Object.hasOwnProperty.call(message, "totalSales"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.totalSales);
                        if (message.totalStores != null && Object.hasOwnProperty.call(message, "totalStores"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalStores);
                        if (message.noStoresWithSalesTarget != null && Object.hasOwnProperty.call(message, "noStoresWithSalesTarget"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.noStoresWithSalesTarget);
                        if (message.noStoresWithConversionRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithConversionRateTarget"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.noStoresWithConversionRateTarget);
                        if (message.noStoresWithAtvTarget != null && Object.hasOwnProperty.call(message, "noStoresWithAtvTarget"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.noStoresWithAtvTarget);
                        if (message.noStoresWithUptTarget != null && Object.hasOwnProperty.call(message, "noStoresWithUptTarget"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.noStoresWithUptTarget);
                        if (message.noStoresWithInteractionRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithInteractionRateTarget"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.noStoresWithInteractionRateTarget);
                        if (message.noStoresWithItemsTarget != null && Object.hasOwnProperty.call(message, "noStoresWithItemsTarget"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.noStoresWithItemsTarget);
                        if (message.noStoresWithSalesPerStaffHourTarget != null && Object.hasOwnProperty.call(message, "noStoresWithSalesPerStaffHourTarget"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.noStoresWithSalesPerStaffHourTarget);
                        if (message.noStoresWithCaptureRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithCaptureRateTarget"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.noStoresWithCaptureRateTarget);
                        if (message.noStoresWithGreetingRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithGreetingRateTarget"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.noStoresWithGreetingRateTarget);
                        if (message.noStoresWithOnTimeGreetingRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithOnTimeGreetingRateTarget"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.noStoresWithOnTimeGreetingRateTarget);
                        if (message.noStoresWithConversionByOpportunitiesTarget != null && Object.hasOwnProperty.call(message, "noStoresWithConversionByOpportunitiesTarget"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.noStoresWithConversionByOpportunitiesTarget);
                        if (message.noStoresWithQueueTimeComplianceRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithQueueTimeComplianceRateTarget"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.noStoresWithQueueTimeComplianceRateTarget);
                        if (message.noStoresWithTransactionTimeComplianceRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithTransactionTimeComplianceRateTarget"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int64(message.noStoresWithTransactionTimeComplianceRateTarget);
                        if (message.noStoresWithOrderPreparationTimeComplianceRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithOrderPreparationTimeComplianceRateTarget"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int64(message.noStoresWithOrderPreparationTimeComplianceRateTarget);
                        if (message.noStoresWithTotalServiceTimeComplianceRateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithTotalServiceTimeComplianceRateTarget"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.noStoresWithTotalServiceTimeComplianceRateTarget);
                        if (message.noStoresWithDwellTimeAvgTarget != null && Object.hasOwnProperty.call(message, "noStoresWithDwellTimeAvgTarget"))
                            writer.uint32(/* id 18, wireType 0 =*/144).int64(message.noStoresWithDwellTimeAvgTarget);
                        if (message.noStoresWithCustomAction_1RateTarget != null && Object.hasOwnProperty.call(message, "noStoresWithCustomAction_1RateTarget"))
                            writer.uint32(/* id 19, wireType 0 =*/152).int64(message.noStoresWithCustomAction_1RateTarget);
                        if (message.noStoresWithAvgVisitorsPerStaffTarget != null && Object.hasOwnProperty.call(message, "noStoresWithAvgVisitorsPerStaffTarget"))
                            writer.uint32(/* id 20, wireType 0 =*/160).int64(message.noStoresWithAvgVisitorsPerStaffTarget);
                        if (message.noStoresWithInteractionTimeAvgTarget != null && Object.hasOwnProperty.call(message, "noStoresWithInteractionTimeAvgTarget"))
                            writer.uint32(/* id 21, wireType 0 =*/168).int64(message.noStoresWithInteractionTimeAvgTarget);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreTargetSummary message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreTargetSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {palexy.streaming.v1.IStoreTargetSummary} message StoreTargetSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreTargetSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreTargetSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreTargetSummary} StoreTargetSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreTargetSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreTargetSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.totalSales = reader.double();
                                break;
                            case 2:
                                message.totalStores = reader.int64();
                                break;
                            case 3:
                                message.noStoresWithSalesTarget = reader.int64();
                                break;
                            case 4:
                                message.noStoresWithConversionRateTarget = reader.int64();
                                break;
                            case 5:
                                message.noStoresWithAtvTarget = reader.int64();
                                break;
                            case 6:
                                message.noStoresWithUptTarget = reader.int64();
                                break;
                            case 7:
                                message.noStoresWithInteractionRateTarget = reader.int64();
                                break;
                            case 8:
                                message.noStoresWithItemsTarget = reader.int64();
                                break;
                            case 9:
                                message.noStoresWithSalesPerStaffHourTarget = reader.int64();
                                break;
                            case 10:
                                message.noStoresWithCaptureRateTarget = reader.int64();
                                break;
                            case 11:
                                message.noStoresWithGreetingRateTarget = reader.int64();
                                break;
                            case 12:
                                message.noStoresWithOnTimeGreetingRateTarget = reader.int64();
                                break;
                            case 13:
                                message.noStoresWithConversionByOpportunitiesTarget = reader.int64();
                                break;
                            case 14:
                                message.noStoresWithQueueTimeComplianceRateTarget = reader.int64();
                                break;
                            case 15:
                                message.noStoresWithTransactionTimeComplianceRateTarget = reader.int64();
                                break;
                            case 16:
                                message.noStoresWithOrderPreparationTimeComplianceRateTarget = reader.int64();
                                break;
                            case 17:
                                message.noStoresWithTotalServiceTimeComplianceRateTarget = reader.int64();
                                break;
                            case 18:
                                message.noStoresWithDwellTimeAvgTarget = reader.int64();
                                break;
                            case 19:
                                message.noStoresWithCustomAction_1RateTarget = reader.int64();
                                break;
                            case 20:
                                message.noStoresWithAvgVisitorsPerStaffTarget = reader.int64();
                                break;
                            case 21:
                                message.noStoresWithInteractionTimeAvgTarget = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreTargetSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreTargetSummary} StoreTargetSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreTargetSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreTargetSummary message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreTargetSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.totalSales != null && message.hasOwnProperty("totalSales"))
                            if (typeof message.totalSales !== "number")
                                return "totalSales: number expected";
                        if (message.totalStores != null && message.hasOwnProperty("totalStores"))
                            if (!$util.isInteger(message.totalStores) && !(message.totalStores && $util.isInteger(message.totalStores.low) && $util.isInteger(message.totalStores.high)))
                                return "totalStores: integer|Long expected";
                        if (message.noStoresWithSalesTarget != null && message.hasOwnProperty("noStoresWithSalesTarget"))
                            if (!$util.isInteger(message.noStoresWithSalesTarget) && !(message.noStoresWithSalesTarget && $util.isInteger(message.noStoresWithSalesTarget.low) && $util.isInteger(message.noStoresWithSalesTarget.high)))
                                return "noStoresWithSalesTarget: integer|Long expected";
                        if (message.noStoresWithConversionRateTarget != null && message.hasOwnProperty("noStoresWithConversionRateTarget"))
                            if (!$util.isInteger(message.noStoresWithConversionRateTarget) && !(message.noStoresWithConversionRateTarget && $util.isInteger(message.noStoresWithConversionRateTarget.low) && $util.isInteger(message.noStoresWithConversionRateTarget.high)))
                                return "noStoresWithConversionRateTarget: integer|Long expected";
                        if (message.noStoresWithAtvTarget != null && message.hasOwnProperty("noStoresWithAtvTarget"))
                            if (!$util.isInteger(message.noStoresWithAtvTarget) && !(message.noStoresWithAtvTarget && $util.isInteger(message.noStoresWithAtvTarget.low) && $util.isInteger(message.noStoresWithAtvTarget.high)))
                                return "noStoresWithAtvTarget: integer|Long expected";
                        if (message.noStoresWithUptTarget != null && message.hasOwnProperty("noStoresWithUptTarget"))
                            if (!$util.isInteger(message.noStoresWithUptTarget) && !(message.noStoresWithUptTarget && $util.isInteger(message.noStoresWithUptTarget.low) && $util.isInteger(message.noStoresWithUptTarget.high)))
                                return "noStoresWithUptTarget: integer|Long expected";
                        if (message.noStoresWithInteractionRateTarget != null && message.hasOwnProperty("noStoresWithInteractionRateTarget"))
                            if (!$util.isInteger(message.noStoresWithInteractionRateTarget) && !(message.noStoresWithInteractionRateTarget && $util.isInteger(message.noStoresWithInteractionRateTarget.low) && $util.isInteger(message.noStoresWithInteractionRateTarget.high)))
                                return "noStoresWithInteractionRateTarget: integer|Long expected";
                        if (message.noStoresWithItemsTarget != null && message.hasOwnProperty("noStoresWithItemsTarget"))
                            if (!$util.isInteger(message.noStoresWithItemsTarget) && !(message.noStoresWithItemsTarget && $util.isInteger(message.noStoresWithItemsTarget.low) && $util.isInteger(message.noStoresWithItemsTarget.high)))
                                return "noStoresWithItemsTarget: integer|Long expected";
                        if (message.noStoresWithSalesPerStaffHourTarget != null && message.hasOwnProperty("noStoresWithSalesPerStaffHourTarget"))
                            if (!$util.isInteger(message.noStoresWithSalesPerStaffHourTarget) && !(message.noStoresWithSalesPerStaffHourTarget && $util.isInteger(message.noStoresWithSalesPerStaffHourTarget.low) && $util.isInteger(message.noStoresWithSalesPerStaffHourTarget.high)))
                                return "noStoresWithSalesPerStaffHourTarget: integer|Long expected";
                        if (message.noStoresWithCaptureRateTarget != null && message.hasOwnProperty("noStoresWithCaptureRateTarget"))
                            if (!$util.isInteger(message.noStoresWithCaptureRateTarget) && !(message.noStoresWithCaptureRateTarget && $util.isInteger(message.noStoresWithCaptureRateTarget.low) && $util.isInteger(message.noStoresWithCaptureRateTarget.high)))
                                return "noStoresWithCaptureRateTarget: integer|Long expected";
                        if (message.noStoresWithGreetingRateTarget != null && message.hasOwnProperty("noStoresWithGreetingRateTarget"))
                            if (!$util.isInteger(message.noStoresWithGreetingRateTarget) && !(message.noStoresWithGreetingRateTarget && $util.isInteger(message.noStoresWithGreetingRateTarget.low) && $util.isInteger(message.noStoresWithGreetingRateTarget.high)))
                                return "noStoresWithGreetingRateTarget: integer|Long expected";
                        if (message.noStoresWithOnTimeGreetingRateTarget != null && message.hasOwnProperty("noStoresWithOnTimeGreetingRateTarget"))
                            if (!$util.isInteger(message.noStoresWithOnTimeGreetingRateTarget) && !(message.noStoresWithOnTimeGreetingRateTarget && $util.isInteger(message.noStoresWithOnTimeGreetingRateTarget.low) && $util.isInteger(message.noStoresWithOnTimeGreetingRateTarget.high)))
                                return "noStoresWithOnTimeGreetingRateTarget: integer|Long expected";
                        if (message.noStoresWithConversionByOpportunitiesTarget != null && message.hasOwnProperty("noStoresWithConversionByOpportunitiesTarget"))
                            if (!$util.isInteger(message.noStoresWithConversionByOpportunitiesTarget) && !(message.noStoresWithConversionByOpportunitiesTarget && $util.isInteger(message.noStoresWithConversionByOpportunitiesTarget.low) && $util.isInteger(message.noStoresWithConversionByOpportunitiesTarget.high)))
                                return "noStoresWithConversionByOpportunitiesTarget: integer|Long expected";
                        if (message.noStoresWithQueueTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithQueueTimeComplianceRateTarget"))
                            if (!$util.isInteger(message.noStoresWithQueueTimeComplianceRateTarget) && !(message.noStoresWithQueueTimeComplianceRateTarget && $util.isInteger(message.noStoresWithQueueTimeComplianceRateTarget.low) && $util.isInteger(message.noStoresWithQueueTimeComplianceRateTarget.high)))
                                return "noStoresWithQueueTimeComplianceRateTarget: integer|Long expected";
                        if (message.noStoresWithTransactionTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithTransactionTimeComplianceRateTarget"))
                            if (!$util.isInteger(message.noStoresWithTransactionTimeComplianceRateTarget) && !(message.noStoresWithTransactionTimeComplianceRateTarget && $util.isInteger(message.noStoresWithTransactionTimeComplianceRateTarget.low) && $util.isInteger(message.noStoresWithTransactionTimeComplianceRateTarget.high)))
                                return "noStoresWithTransactionTimeComplianceRateTarget: integer|Long expected";
                        if (message.noStoresWithOrderPreparationTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithOrderPreparationTimeComplianceRateTarget"))
                            if (!$util.isInteger(message.noStoresWithOrderPreparationTimeComplianceRateTarget) && !(message.noStoresWithOrderPreparationTimeComplianceRateTarget && $util.isInteger(message.noStoresWithOrderPreparationTimeComplianceRateTarget.low) && $util.isInteger(message.noStoresWithOrderPreparationTimeComplianceRateTarget.high)))
                                return "noStoresWithOrderPreparationTimeComplianceRateTarget: integer|Long expected";
                        if (message.noStoresWithTotalServiceTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithTotalServiceTimeComplianceRateTarget"))
                            if (!$util.isInteger(message.noStoresWithTotalServiceTimeComplianceRateTarget) && !(message.noStoresWithTotalServiceTimeComplianceRateTarget && $util.isInteger(message.noStoresWithTotalServiceTimeComplianceRateTarget.low) && $util.isInteger(message.noStoresWithTotalServiceTimeComplianceRateTarget.high)))
                                return "noStoresWithTotalServiceTimeComplianceRateTarget: integer|Long expected";
                        if (message.noStoresWithDwellTimeAvgTarget != null && message.hasOwnProperty("noStoresWithDwellTimeAvgTarget"))
                            if (!$util.isInteger(message.noStoresWithDwellTimeAvgTarget) && !(message.noStoresWithDwellTimeAvgTarget && $util.isInteger(message.noStoresWithDwellTimeAvgTarget.low) && $util.isInteger(message.noStoresWithDwellTimeAvgTarget.high)))
                                return "noStoresWithDwellTimeAvgTarget: integer|Long expected";
                        if (message.noStoresWithCustomAction_1RateTarget != null && message.hasOwnProperty("noStoresWithCustomAction_1RateTarget"))
                            if (!$util.isInteger(message.noStoresWithCustomAction_1RateTarget) && !(message.noStoresWithCustomAction_1RateTarget && $util.isInteger(message.noStoresWithCustomAction_1RateTarget.low) && $util.isInteger(message.noStoresWithCustomAction_1RateTarget.high)))
                                return "noStoresWithCustomAction_1RateTarget: integer|Long expected";
                        if (message.noStoresWithAvgVisitorsPerStaffTarget != null && message.hasOwnProperty("noStoresWithAvgVisitorsPerStaffTarget"))
                            if (!$util.isInteger(message.noStoresWithAvgVisitorsPerStaffTarget) && !(message.noStoresWithAvgVisitorsPerStaffTarget && $util.isInteger(message.noStoresWithAvgVisitorsPerStaffTarget.low) && $util.isInteger(message.noStoresWithAvgVisitorsPerStaffTarget.high)))
                                return "noStoresWithAvgVisitorsPerStaffTarget: integer|Long expected";
                        if (message.noStoresWithInteractionTimeAvgTarget != null && message.hasOwnProperty("noStoresWithInteractionTimeAvgTarget"))
                            if (!$util.isInteger(message.noStoresWithInteractionTimeAvgTarget) && !(message.noStoresWithInteractionTimeAvgTarget && $util.isInteger(message.noStoresWithInteractionTimeAvgTarget.low) && $util.isInteger(message.noStoresWithInteractionTimeAvgTarget.high)))
                                return "noStoresWithInteractionTimeAvgTarget: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreTargetSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreTargetSummary} StoreTargetSummary
                     */
                    StoreTargetSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreTargetSummary)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreTargetSummary();
                        if (object.totalSales != null)
                            message.totalSales = Number(object.totalSales);
                        if (object.totalStores != null)
                            if ($util.Long)
                                (message.totalStores = $util.Long.fromValue(object.totalStores)).unsigned = false;
                            else if (typeof object.totalStores === "string")
                                message.totalStores = parseInt(object.totalStores, 10);
                            else if (typeof object.totalStores === "number")
                                message.totalStores = object.totalStores;
                            else if (typeof object.totalStores === "object")
                                message.totalStores = new $util.LongBits(object.totalStores.low >>> 0, object.totalStores.high >>> 0).toNumber();
                        if (object.noStoresWithSalesTarget != null)
                            if ($util.Long)
                                (message.noStoresWithSalesTarget = $util.Long.fromValue(object.noStoresWithSalesTarget)).unsigned = false;
                            else if (typeof object.noStoresWithSalesTarget === "string")
                                message.noStoresWithSalesTarget = parseInt(object.noStoresWithSalesTarget, 10);
                            else if (typeof object.noStoresWithSalesTarget === "number")
                                message.noStoresWithSalesTarget = object.noStoresWithSalesTarget;
                            else if (typeof object.noStoresWithSalesTarget === "object")
                                message.noStoresWithSalesTarget = new $util.LongBits(object.noStoresWithSalesTarget.low >>> 0, object.noStoresWithSalesTarget.high >>> 0).toNumber();
                        if (object.noStoresWithConversionRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithConversionRateTarget = $util.Long.fromValue(object.noStoresWithConversionRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithConversionRateTarget === "string")
                                message.noStoresWithConversionRateTarget = parseInt(object.noStoresWithConversionRateTarget, 10);
                            else if (typeof object.noStoresWithConversionRateTarget === "number")
                                message.noStoresWithConversionRateTarget = object.noStoresWithConversionRateTarget;
                            else if (typeof object.noStoresWithConversionRateTarget === "object")
                                message.noStoresWithConversionRateTarget = new $util.LongBits(object.noStoresWithConversionRateTarget.low >>> 0, object.noStoresWithConversionRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithAtvTarget != null)
                            if ($util.Long)
                                (message.noStoresWithAtvTarget = $util.Long.fromValue(object.noStoresWithAtvTarget)).unsigned = false;
                            else if (typeof object.noStoresWithAtvTarget === "string")
                                message.noStoresWithAtvTarget = parseInt(object.noStoresWithAtvTarget, 10);
                            else if (typeof object.noStoresWithAtvTarget === "number")
                                message.noStoresWithAtvTarget = object.noStoresWithAtvTarget;
                            else if (typeof object.noStoresWithAtvTarget === "object")
                                message.noStoresWithAtvTarget = new $util.LongBits(object.noStoresWithAtvTarget.low >>> 0, object.noStoresWithAtvTarget.high >>> 0).toNumber();
                        if (object.noStoresWithUptTarget != null)
                            if ($util.Long)
                                (message.noStoresWithUptTarget = $util.Long.fromValue(object.noStoresWithUptTarget)).unsigned = false;
                            else if (typeof object.noStoresWithUptTarget === "string")
                                message.noStoresWithUptTarget = parseInt(object.noStoresWithUptTarget, 10);
                            else if (typeof object.noStoresWithUptTarget === "number")
                                message.noStoresWithUptTarget = object.noStoresWithUptTarget;
                            else if (typeof object.noStoresWithUptTarget === "object")
                                message.noStoresWithUptTarget = new $util.LongBits(object.noStoresWithUptTarget.low >>> 0, object.noStoresWithUptTarget.high >>> 0).toNumber();
                        if (object.noStoresWithInteractionRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithInteractionRateTarget = $util.Long.fromValue(object.noStoresWithInteractionRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithInteractionRateTarget === "string")
                                message.noStoresWithInteractionRateTarget = parseInt(object.noStoresWithInteractionRateTarget, 10);
                            else if (typeof object.noStoresWithInteractionRateTarget === "number")
                                message.noStoresWithInteractionRateTarget = object.noStoresWithInteractionRateTarget;
                            else if (typeof object.noStoresWithInteractionRateTarget === "object")
                                message.noStoresWithInteractionRateTarget = new $util.LongBits(object.noStoresWithInteractionRateTarget.low >>> 0, object.noStoresWithInteractionRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithItemsTarget != null)
                            if ($util.Long)
                                (message.noStoresWithItemsTarget = $util.Long.fromValue(object.noStoresWithItemsTarget)).unsigned = false;
                            else if (typeof object.noStoresWithItemsTarget === "string")
                                message.noStoresWithItemsTarget = parseInt(object.noStoresWithItemsTarget, 10);
                            else if (typeof object.noStoresWithItemsTarget === "number")
                                message.noStoresWithItemsTarget = object.noStoresWithItemsTarget;
                            else if (typeof object.noStoresWithItemsTarget === "object")
                                message.noStoresWithItemsTarget = new $util.LongBits(object.noStoresWithItemsTarget.low >>> 0, object.noStoresWithItemsTarget.high >>> 0).toNumber();
                        if (object.noStoresWithSalesPerStaffHourTarget != null)
                            if ($util.Long)
                                (message.noStoresWithSalesPerStaffHourTarget = $util.Long.fromValue(object.noStoresWithSalesPerStaffHourTarget)).unsigned = false;
                            else if (typeof object.noStoresWithSalesPerStaffHourTarget === "string")
                                message.noStoresWithSalesPerStaffHourTarget = parseInt(object.noStoresWithSalesPerStaffHourTarget, 10);
                            else if (typeof object.noStoresWithSalesPerStaffHourTarget === "number")
                                message.noStoresWithSalesPerStaffHourTarget = object.noStoresWithSalesPerStaffHourTarget;
                            else if (typeof object.noStoresWithSalesPerStaffHourTarget === "object")
                                message.noStoresWithSalesPerStaffHourTarget = new $util.LongBits(object.noStoresWithSalesPerStaffHourTarget.low >>> 0, object.noStoresWithSalesPerStaffHourTarget.high >>> 0).toNumber();
                        if (object.noStoresWithCaptureRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithCaptureRateTarget = $util.Long.fromValue(object.noStoresWithCaptureRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithCaptureRateTarget === "string")
                                message.noStoresWithCaptureRateTarget = parseInt(object.noStoresWithCaptureRateTarget, 10);
                            else if (typeof object.noStoresWithCaptureRateTarget === "number")
                                message.noStoresWithCaptureRateTarget = object.noStoresWithCaptureRateTarget;
                            else if (typeof object.noStoresWithCaptureRateTarget === "object")
                                message.noStoresWithCaptureRateTarget = new $util.LongBits(object.noStoresWithCaptureRateTarget.low >>> 0, object.noStoresWithCaptureRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithGreetingRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithGreetingRateTarget = $util.Long.fromValue(object.noStoresWithGreetingRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithGreetingRateTarget === "string")
                                message.noStoresWithGreetingRateTarget = parseInt(object.noStoresWithGreetingRateTarget, 10);
                            else if (typeof object.noStoresWithGreetingRateTarget === "number")
                                message.noStoresWithGreetingRateTarget = object.noStoresWithGreetingRateTarget;
                            else if (typeof object.noStoresWithGreetingRateTarget === "object")
                                message.noStoresWithGreetingRateTarget = new $util.LongBits(object.noStoresWithGreetingRateTarget.low >>> 0, object.noStoresWithGreetingRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithOnTimeGreetingRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithOnTimeGreetingRateTarget = $util.Long.fromValue(object.noStoresWithOnTimeGreetingRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithOnTimeGreetingRateTarget === "string")
                                message.noStoresWithOnTimeGreetingRateTarget = parseInt(object.noStoresWithOnTimeGreetingRateTarget, 10);
                            else if (typeof object.noStoresWithOnTimeGreetingRateTarget === "number")
                                message.noStoresWithOnTimeGreetingRateTarget = object.noStoresWithOnTimeGreetingRateTarget;
                            else if (typeof object.noStoresWithOnTimeGreetingRateTarget === "object")
                                message.noStoresWithOnTimeGreetingRateTarget = new $util.LongBits(object.noStoresWithOnTimeGreetingRateTarget.low >>> 0, object.noStoresWithOnTimeGreetingRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithConversionByOpportunitiesTarget != null)
                            if ($util.Long)
                                (message.noStoresWithConversionByOpportunitiesTarget = $util.Long.fromValue(object.noStoresWithConversionByOpportunitiesTarget)).unsigned = false;
                            else if (typeof object.noStoresWithConversionByOpportunitiesTarget === "string")
                                message.noStoresWithConversionByOpportunitiesTarget = parseInt(object.noStoresWithConversionByOpportunitiesTarget, 10);
                            else if (typeof object.noStoresWithConversionByOpportunitiesTarget === "number")
                                message.noStoresWithConversionByOpportunitiesTarget = object.noStoresWithConversionByOpportunitiesTarget;
                            else if (typeof object.noStoresWithConversionByOpportunitiesTarget === "object")
                                message.noStoresWithConversionByOpportunitiesTarget = new $util.LongBits(object.noStoresWithConversionByOpportunitiesTarget.low >>> 0, object.noStoresWithConversionByOpportunitiesTarget.high >>> 0).toNumber();
                        if (object.noStoresWithQueueTimeComplianceRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithQueueTimeComplianceRateTarget = $util.Long.fromValue(object.noStoresWithQueueTimeComplianceRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithQueueTimeComplianceRateTarget === "string")
                                message.noStoresWithQueueTimeComplianceRateTarget = parseInt(object.noStoresWithQueueTimeComplianceRateTarget, 10);
                            else if (typeof object.noStoresWithQueueTimeComplianceRateTarget === "number")
                                message.noStoresWithQueueTimeComplianceRateTarget = object.noStoresWithQueueTimeComplianceRateTarget;
                            else if (typeof object.noStoresWithQueueTimeComplianceRateTarget === "object")
                                message.noStoresWithQueueTimeComplianceRateTarget = new $util.LongBits(object.noStoresWithQueueTimeComplianceRateTarget.low >>> 0, object.noStoresWithQueueTimeComplianceRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithTransactionTimeComplianceRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithTransactionTimeComplianceRateTarget = $util.Long.fromValue(object.noStoresWithTransactionTimeComplianceRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithTransactionTimeComplianceRateTarget === "string")
                                message.noStoresWithTransactionTimeComplianceRateTarget = parseInt(object.noStoresWithTransactionTimeComplianceRateTarget, 10);
                            else if (typeof object.noStoresWithTransactionTimeComplianceRateTarget === "number")
                                message.noStoresWithTransactionTimeComplianceRateTarget = object.noStoresWithTransactionTimeComplianceRateTarget;
                            else if (typeof object.noStoresWithTransactionTimeComplianceRateTarget === "object")
                                message.noStoresWithTransactionTimeComplianceRateTarget = new $util.LongBits(object.noStoresWithTransactionTimeComplianceRateTarget.low >>> 0, object.noStoresWithTransactionTimeComplianceRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithOrderPreparationTimeComplianceRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithOrderPreparationTimeComplianceRateTarget = $util.Long.fromValue(object.noStoresWithOrderPreparationTimeComplianceRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithOrderPreparationTimeComplianceRateTarget === "string")
                                message.noStoresWithOrderPreparationTimeComplianceRateTarget = parseInt(object.noStoresWithOrderPreparationTimeComplianceRateTarget, 10);
                            else if (typeof object.noStoresWithOrderPreparationTimeComplianceRateTarget === "number")
                                message.noStoresWithOrderPreparationTimeComplianceRateTarget = object.noStoresWithOrderPreparationTimeComplianceRateTarget;
                            else if (typeof object.noStoresWithOrderPreparationTimeComplianceRateTarget === "object")
                                message.noStoresWithOrderPreparationTimeComplianceRateTarget = new $util.LongBits(object.noStoresWithOrderPreparationTimeComplianceRateTarget.low >>> 0, object.noStoresWithOrderPreparationTimeComplianceRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithTotalServiceTimeComplianceRateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithTotalServiceTimeComplianceRateTarget = $util.Long.fromValue(object.noStoresWithTotalServiceTimeComplianceRateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithTotalServiceTimeComplianceRateTarget === "string")
                                message.noStoresWithTotalServiceTimeComplianceRateTarget = parseInt(object.noStoresWithTotalServiceTimeComplianceRateTarget, 10);
                            else if (typeof object.noStoresWithTotalServiceTimeComplianceRateTarget === "number")
                                message.noStoresWithTotalServiceTimeComplianceRateTarget = object.noStoresWithTotalServiceTimeComplianceRateTarget;
                            else if (typeof object.noStoresWithTotalServiceTimeComplianceRateTarget === "object")
                                message.noStoresWithTotalServiceTimeComplianceRateTarget = new $util.LongBits(object.noStoresWithTotalServiceTimeComplianceRateTarget.low >>> 0, object.noStoresWithTotalServiceTimeComplianceRateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithDwellTimeAvgTarget != null)
                            if ($util.Long)
                                (message.noStoresWithDwellTimeAvgTarget = $util.Long.fromValue(object.noStoresWithDwellTimeAvgTarget)).unsigned = false;
                            else if (typeof object.noStoresWithDwellTimeAvgTarget === "string")
                                message.noStoresWithDwellTimeAvgTarget = parseInt(object.noStoresWithDwellTimeAvgTarget, 10);
                            else if (typeof object.noStoresWithDwellTimeAvgTarget === "number")
                                message.noStoresWithDwellTimeAvgTarget = object.noStoresWithDwellTimeAvgTarget;
                            else if (typeof object.noStoresWithDwellTimeAvgTarget === "object")
                                message.noStoresWithDwellTimeAvgTarget = new $util.LongBits(object.noStoresWithDwellTimeAvgTarget.low >>> 0, object.noStoresWithDwellTimeAvgTarget.high >>> 0).toNumber();
                        if (object.noStoresWithCustomAction_1RateTarget != null)
                            if ($util.Long)
                                (message.noStoresWithCustomAction_1RateTarget = $util.Long.fromValue(object.noStoresWithCustomAction_1RateTarget)).unsigned = false;
                            else if (typeof object.noStoresWithCustomAction_1RateTarget === "string")
                                message.noStoresWithCustomAction_1RateTarget = parseInt(object.noStoresWithCustomAction_1RateTarget, 10);
                            else if (typeof object.noStoresWithCustomAction_1RateTarget === "number")
                                message.noStoresWithCustomAction_1RateTarget = object.noStoresWithCustomAction_1RateTarget;
                            else if (typeof object.noStoresWithCustomAction_1RateTarget === "object")
                                message.noStoresWithCustomAction_1RateTarget = new $util.LongBits(object.noStoresWithCustomAction_1RateTarget.low >>> 0, object.noStoresWithCustomAction_1RateTarget.high >>> 0).toNumber();
                        if (object.noStoresWithAvgVisitorsPerStaffTarget != null)
                            if ($util.Long)
                                (message.noStoresWithAvgVisitorsPerStaffTarget = $util.Long.fromValue(object.noStoresWithAvgVisitorsPerStaffTarget)).unsigned = false;
                            else if (typeof object.noStoresWithAvgVisitorsPerStaffTarget === "string")
                                message.noStoresWithAvgVisitorsPerStaffTarget = parseInt(object.noStoresWithAvgVisitorsPerStaffTarget, 10);
                            else if (typeof object.noStoresWithAvgVisitorsPerStaffTarget === "number")
                                message.noStoresWithAvgVisitorsPerStaffTarget = object.noStoresWithAvgVisitorsPerStaffTarget;
                            else if (typeof object.noStoresWithAvgVisitorsPerStaffTarget === "object")
                                message.noStoresWithAvgVisitorsPerStaffTarget = new $util.LongBits(object.noStoresWithAvgVisitorsPerStaffTarget.low >>> 0, object.noStoresWithAvgVisitorsPerStaffTarget.high >>> 0).toNumber();
                        if (object.noStoresWithInteractionTimeAvgTarget != null)
                            if ($util.Long)
                                (message.noStoresWithInteractionTimeAvgTarget = $util.Long.fromValue(object.noStoresWithInteractionTimeAvgTarget)).unsigned = false;
                            else if (typeof object.noStoresWithInteractionTimeAvgTarget === "string")
                                message.noStoresWithInteractionTimeAvgTarget = parseInt(object.noStoresWithInteractionTimeAvgTarget, 10);
                            else if (typeof object.noStoresWithInteractionTimeAvgTarget === "number")
                                message.noStoresWithInteractionTimeAvgTarget = object.noStoresWithInteractionTimeAvgTarget;
                            else if (typeof object.noStoresWithInteractionTimeAvgTarget === "object")
                                message.noStoresWithInteractionTimeAvgTarget = new $util.LongBits(object.noStoresWithInteractionTimeAvgTarget.low >>> 0, object.noStoresWithInteractionTimeAvgTarget.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreTargetSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @static
                     * @param {palexy.streaming.v1.StoreTargetSummary} message StoreTargetSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreTargetSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.totalSales = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalStores = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalStores = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithSalesTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithSalesTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithConversionRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithConversionRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithAtvTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithAtvTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithUptTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithUptTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithInteractionRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithInteractionRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithItemsTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithItemsTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithSalesPerStaffHourTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithSalesPerStaffHourTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithCaptureRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithCaptureRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithGreetingRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithGreetingRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithOnTimeGreetingRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithOnTimeGreetingRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithConversionByOpportunitiesTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithConversionByOpportunitiesTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithQueueTimeComplianceRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithQueueTimeComplianceRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithTransactionTimeComplianceRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithTransactionTimeComplianceRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithOrderPreparationTimeComplianceRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithOrderPreparationTimeComplianceRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithTotalServiceTimeComplianceRateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithTotalServiceTimeComplianceRateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithDwellTimeAvgTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithDwellTimeAvgTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithCustomAction_1RateTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithCustomAction_1RateTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithAvgVisitorsPerStaffTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithAvgVisitorsPerStaffTarget = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.noStoresWithInteractionTimeAvgTarget = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.noStoresWithInteractionTimeAvgTarget = options.longs === String ? "0" : 0;
                        }
                        if (message.totalSales != null && message.hasOwnProperty("totalSales"))
                            object.totalSales = options.json && !isFinite(message.totalSales) ? String(message.totalSales) : message.totalSales;
                        if (message.totalStores != null && message.hasOwnProperty("totalStores"))
                            if (typeof message.totalStores === "number")
                                object.totalStores = options.longs === String ? String(message.totalStores) : message.totalStores;
                            else
                                object.totalStores = options.longs === String ? $util.Long.prototype.toString.call(message.totalStores) : options.longs === Number ? new $util.LongBits(message.totalStores.low >>> 0, message.totalStores.high >>> 0).toNumber() : message.totalStores;
                        if (message.noStoresWithSalesTarget != null && message.hasOwnProperty("noStoresWithSalesTarget"))
                            if (typeof message.noStoresWithSalesTarget === "number")
                                object.noStoresWithSalesTarget = options.longs === String ? String(message.noStoresWithSalesTarget) : message.noStoresWithSalesTarget;
                            else
                                object.noStoresWithSalesTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithSalesTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithSalesTarget.low >>> 0, message.noStoresWithSalesTarget.high >>> 0).toNumber() : message.noStoresWithSalesTarget;
                        if (message.noStoresWithConversionRateTarget != null && message.hasOwnProperty("noStoresWithConversionRateTarget"))
                            if (typeof message.noStoresWithConversionRateTarget === "number")
                                object.noStoresWithConversionRateTarget = options.longs === String ? String(message.noStoresWithConversionRateTarget) : message.noStoresWithConversionRateTarget;
                            else
                                object.noStoresWithConversionRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithConversionRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithConversionRateTarget.low >>> 0, message.noStoresWithConversionRateTarget.high >>> 0).toNumber() : message.noStoresWithConversionRateTarget;
                        if (message.noStoresWithAtvTarget != null && message.hasOwnProperty("noStoresWithAtvTarget"))
                            if (typeof message.noStoresWithAtvTarget === "number")
                                object.noStoresWithAtvTarget = options.longs === String ? String(message.noStoresWithAtvTarget) : message.noStoresWithAtvTarget;
                            else
                                object.noStoresWithAtvTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithAtvTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithAtvTarget.low >>> 0, message.noStoresWithAtvTarget.high >>> 0).toNumber() : message.noStoresWithAtvTarget;
                        if (message.noStoresWithUptTarget != null && message.hasOwnProperty("noStoresWithUptTarget"))
                            if (typeof message.noStoresWithUptTarget === "number")
                                object.noStoresWithUptTarget = options.longs === String ? String(message.noStoresWithUptTarget) : message.noStoresWithUptTarget;
                            else
                                object.noStoresWithUptTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithUptTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithUptTarget.low >>> 0, message.noStoresWithUptTarget.high >>> 0).toNumber() : message.noStoresWithUptTarget;
                        if (message.noStoresWithInteractionRateTarget != null && message.hasOwnProperty("noStoresWithInteractionRateTarget"))
                            if (typeof message.noStoresWithInteractionRateTarget === "number")
                                object.noStoresWithInteractionRateTarget = options.longs === String ? String(message.noStoresWithInteractionRateTarget) : message.noStoresWithInteractionRateTarget;
                            else
                                object.noStoresWithInteractionRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithInteractionRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithInteractionRateTarget.low >>> 0, message.noStoresWithInteractionRateTarget.high >>> 0).toNumber() : message.noStoresWithInteractionRateTarget;
                        if (message.noStoresWithItemsTarget != null && message.hasOwnProperty("noStoresWithItemsTarget"))
                            if (typeof message.noStoresWithItemsTarget === "number")
                                object.noStoresWithItemsTarget = options.longs === String ? String(message.noStoresWithItemsTarget) : message.noStoresWithItemsTarget;
                            else
                                object.noStoresWithItemsTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithItemsTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithItemsTarget.low >>> 0, message.noStoresWithItemsTarget.high >>> 0).toNumber() : message.noStoresWithItemsTarget;
                        if (message.noStoresWithSalesPerStaffHourTarget != null && message.hasOwnProperty("noStoresWithSalesPerStaffHourTarget"))
                            if (typeof message.noStoresWithSalesPerStaffHourTarget === "number")
                                object.noStoresWithSalesPerStaffHourTarget = options.longs === String ? String(message.noStoresWithSalesPerStaffHourTarget) : message.noStoresWithSalesPerStaffHourTarget;
                            else
                                object.noStoresWithSalesPerStaffHourTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithSalesPerStaffHourTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithSalesPerStaffHourTarget.low >>> 0, message.noStoresWithSalesPerStaffHourTarget.high >>> 0).toNumber() : message.noStoresWithSalesPerStaffHourTarget;
                        if (message.noStoresWithCaptureRateTarget != null && message.hasOwnProperty("noStoresWithCaptureRateTarget"))
                            if (typeof message.noStoresWithCaptureRateTarget === "number")
                                object.noStoresWithCaptureRateTarget = options.longs === String ? String(message.noStoresWithCaptureRateTarget) : message.noStoresWithCaptureRateTarget;
                            else
                                object.noStoresWithCaptureRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithCaptureRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithCaptureRateTarget.low >>> 0, message.noStoresWithCaptureRateTarget.high >>> 0).toNumber() : message.noStoresWithCaptureRateTarget;
                        if (message.noStoresWithGreetingRateTarget != null && message.hasOwnProperty("noStoresWithGreetingRateTarget"))
                            if (typeof message.noStoresWithGreetingRateTarget === "number")
                                object.noStoresWithGreetingRateTarget = options.longs === String ? String(message.noStoresWithGreetingRateTarget) : message.noStoresWithGreetingRateTarget;
                            else
                                object.noStoresWithGreetingRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithGreetingRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithGreetingRateTarget.low >>> 0, message.noStoresWithGreetingRateTarget.high >>> 0).toNumber() : message.noStoresWithGreetingRateTarget;
                        if (message.noStoresWithOnTimeGreetingRateTarget != null && message.hasOwnProperty("noStoresWithOnTimeGreetingRateTarget"))
                            if (typeof message.noStoresWithOnTimeGreetingRateTarget === "number")
                                object.noStoresWithOnTimeGreetingRateTarget = options.longs === String ? String(message.noStoresWithOnTimeGreetingRateTarget) : message.noStoresWithOnTimeGreetingRateTarget;
                            else
                                object.noStoresWithOnTimeGreetingRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithOnTimeGreetingRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithOnTimeGreetingRateTarget.low >>> 0, message.noStoresWithOnTimeGreetingRateTarget.high >>> 0).toNumber() : message.noStoresWithOnTimeGreetingRateTarget;
                        if (message.noStoresWithConversionByOpportunitiesTarget != null && message.hasOwnProperty("noStoresWithConversionByOpportunitiesTarget"))
                            if (typeof message.noStoresWithConversionByOpportunitiesTarget === "number")
                                object.noStoresWithConversionByOpportunitiesTarget = options.longs === String ? String(message.noStoresWithConversionByOpportunitiesTarget) : message.noStoresWithConversionByOpportunitiesTarget;
                            else
                                object.noStoresWithConversionByOpportunitiesTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithConversionByOpportunitiesTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithConversionByOpportunitiesTarget.low >>> 0, message.noStoresWithConversionByOpportunitiesTarget.high >>> 0).toNumber() : message.noStoresWithConversionByOpportunitiesTarget;
                        if (message.noStoresWithQueueTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithQueueTimeComplianceRateTarget"))
                            if (typeof message.noStoresWithQueueTimeComplianceRateTarget === "number")
                                object.noStoresWithQueueTimeComplianceRateTarget = options.longs === String ? String(message.noStoresWithQueueTimeComplianceRateTarget) : message.noStoresWithQueueTimeComplianceRateTarget;
                            else
                                object.noStoresWithQueueTimeComplianceRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithQueueTimeComplianceRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithQueueTimeComplianceRateTarget.low >>> 0, message.noStoresWithQueueTimeComplianceRateTarget.high >>> 0).toNumber() : message.noStoresWithQueueTimeComplianceRateTarget;
                        if (message.noStoresWithTransactionTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithTransactionTimeComplianceRateTarget"))
                            if (typeof message.noStoresWithTransactionTimeComplianceRateTarget === "number")
                                object.noStoresWithTransactionTimeComplianceRateTarget = options.longs === String ? String(message.noStoresWithTransactionTimeComplianceRateTarget) : message.noStoresWithTransactionTimeComplianceRateTarget;
                            else
                                object.noStoresWithTransactionTimeComplianceRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithTransactionTimeComplianceRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithTransactionTimeComplianceRateTarget.low >>> 0, message.noStoresWithTransactionTimeComplianceRateTarget.high >>> 0).toNumber() : message.noStoresWithTransactionTimeComplianceRateTarget;
                        if (message.noStoresWithOrderPreparationTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithOrderPreparationTimeComplianceRateTarget"))
                            if (typeof message.noStoresWithOrderPreparationTimeComplianceRateTarget === "number")
                                object.noStoresWithOrderPreparationTimeComplianceRateTarget = options.longs === String ? String(message.noStoresWithOrderPreparationTimeComplianceRateTarget) : message.noStoresWithOrderPreparationTimeComplianceRateTarget;
                            else
                                object.noStoresWithOrderPreparationTimeComplianceRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithOrderPreparationTimeComplianceRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithOrderPreparationTimeComplianceRateTarget.low >>> 0, message.noStoresWithOrderPreparationTimeComplianceRateTarget.high >>> 0).toNumber() : message.noStoresWithOrderPreparationTimeComplianceRateTarget;
                        if (message.noStoresWithTotalServiceTimeComplianceRateTarget != null && message.hasOwnProperty("noStoresWithTotalServiceTimeComplianceRateTarget"))
                            if (typeof message.noStoresWithTotalServiceTimeComplianceRateTarget === "number")
                                object.noStoresWithTotalServiceTimeComplianceRateTarget = options.longs === String ? String(message.noStoresWithTotalServiceTimeComplianceRateTarget) : message.noStoresWithTotalServiceTimeComplianceRateTarget;
                            else
                                object.noStoresWithTotalServiceTimeComplianceRateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithTotalServiceTimeComplianceRateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithTotalServiceTimeComplianceRateTarget.low >>> 0, message.noStoresWithTotalServiceTimeComplianceRateTarget.high >>> 0).toNumber() : message.noStoresWithTotalServiceTimeComplianceRateTarget;
                        if (message.noStoresWithDwellTimeAvgTarget != null && message.hasOwnProperty("noStoresWithDwellTimeAvgTarget"))
                            if (typeof message.noStoresWithDwellTimeAvgTarget === "number")
                                object.noStoresWithDwellTimeAvgTarget = options.longs === String ? String(message.noStoresWithDwellTimeAvgTarget) : message.noStoresWithDwellTimeAvgTarget;
                            else
                                object.noStoresWithDwellTimeAvgTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithDwellTimeAvgTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithDwellTimeAvgTarget.low >>> 0, message.noStoresWithDwellTimeAvgTarget.high >>> 0).toNumber() : message.noStoresWithDwellTimeAvgTarget;
                        if (message.noStoresWithCustomAction_1RateTarget != null && message.hasOwnProperty("noStoresWithCustomAction_1RateTarget"))
                            if (typeof message.noStoresWithCustomAction_1RateTarget === "number")
                                object.noStoresWithCustomAction_1RateTarget = options.longs === String ? String(message.noStoresWithCustomAction_1RateTarget) : message.noStoresWithCustomAction_1RateTarget;
                            else
                                object.noStoresWithCustomAction_1RateTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithCustomAction_1RateTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithCustomAction_1RateTarget.low >>> 0, message.noStoresWithCustomAction_1RateTarget.high >>> 0).toNumber() : message.noStoresWithCustomAction_1RateTarget;
                        if (message.noStoresWithAvgVisitorsPerStaffTarget != null && message.hasOwnProperty("noStoresWithAvgVisitorsPerStaffTarget"))
                            if (typeof message.noStoresWithAvgVisitorsPerStaffTarget === "number")
                                object.noStoresWithAvgVisitorsPerStaffTarget = options.longs === String ? String(message.noStoresWithAvgVisitorsPerStaffTarget) : message.noStoresWithAvgVisitorsPerStaffTarget;
                            else
                                object.noStoresWithAvgVisitorsPerStaffTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithAvgVisitorsPerStaffTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithAvgVisitorsPerStaffTarget.low >>> 0, message.noStoresWithAvgVisitorsPerStaffTarget.high >>> 0).toNumber() : message.noStoresWithAvgVisitorsPerStaffTarget;
                        if (message.noStoresWithInteractionTimeAvgTarget != null && message.hasOwnProperty("noStoresWithInteractionTimeAvgTarget"))
                            if (typeof message.noStoresWithInteractionTimeAvgTarget === "number")
                                object.noStoresWithInteractionTimeAvgTarget = options.longs === String ? String(message.noStoresWithInteractionTimeAvgTarget) : message.noStoresWithInteractionTimeAvgTarget;
                            else
                                object.noStoresWithInteractionTimeAvgTarget = options.longs === String ? $util.Long.prototype.toString.call(message.noStoresWithInteractionTimeAvgTarget) : options.longs === Number ? new $util.LongBits(message.noStoresWithInteractionTimeAvgTarget.low >>> 0, message.noStoresWithInteractionTimeAvgTarget.high >>> 0).toNumber() : message.noStoresWithInteractionTimeAvgTarget;
                        return object;
                    };
    
                    /**
                     * Converts this StoreTargetSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreTargetSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreTargetSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreTargetSummary;
                })();
    
                v1.StoreEventPriorityConfig = (function() {
    
                    /**
                     * Properties of a StoreEventPriorityConfig.
                     * @memberof palexy.streaming.v1
                     * @interface IStoreEventPriorityConfig
                     * @property {number|null} [id] StoreEventPriorityConfig id
                     * @property {number|null} [companyId] StoreEventPriorityConfig companyId
                     * @property {palexy.streaming.v1.StoreEventType|null} [storeEventType] StoreEventPriorityConfig storeEventType
                     * @property {palexy.streaming.v1.StoreEvent.Priority|null} [defaultPriority] StoreEventPriorityConfig defaultPriority
                     * @property {Array.<palexy.streaming.v1.IPriorityRule>|null} [rules] StoreEventPriorityConfig rules
                     */
    
                    /**
                     * Constructs a new StoreEventPriorityConfig.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a StoreEventPriorityConfig.
                     * @implements IStoreEventPriorityConfig
                     * @constructor
                     * @param {palexy.streaming.v1.IStoreEventPriorityConfig=} [properties] Properties to set
                     */
                    function StoreEventPriorityConfig(properties) {
                        this.rules = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEventPriorityConfig id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     */
                    StoreEventPriorityConfig.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventPriorityConfig companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     */
                    StoreEventPriorityConfig.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreEventPriorityConfig storeEventType.
                     * @member {palexy.streaming.v1.StoreEventType} storeEventType
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     */
                    StoreEventPriorityConfig.prototype.storeEventType = 0;
    
                    /**
                     * StoreEventPriorityConfig defaultPriority.
                     * @member {palexy.streaming.v1.StoreEvent.Priority} defaultPriority
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     */
                    StoreEventPriorityConfig.prototype.defaultPriority = 0;
    
                    /**
                     * StoreEventPriorityConfig rules.
                     * @member {Array.<palexy.streaming.v1.IPriorityRule>} rules
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     */
                    StoreEventPriorityConfig.prototype.rules = $util.emptyArray;
    
                    /**
                     * Creates a new StoreEventPriorityConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventPriorityConfig=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.StoreEventPriorityConfig} StoreEventPriorityConfig instance
                     */
                    StoreEventPriorityConfig.create = function create(properties) {
                        return new StoreEventPriorityConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEventPriorityConfig message. Does not implicitly {@link palexy.streaming.v1.StoreEventPriorityConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventPriorityConfig} message StoreEventPriorityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventPriorityConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.storeEventType != null && Object.hasOwnProperty.call(message, "storeEventType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.storeEventType);
                        if (message.defaultPriority != null && Object.hasOwnProperty.call(message, "defaultPriority"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.defaultPriority);
                        if (message.rules != null && message.rules.length)
                            for (var i = 0; i < message.rules.length; ++i)
                                $root.palexy.streaming.v1.PriorityRule.encode(message.rules[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEventPriorityConfig message, length delimited. Does not implicitly {@link palexy.streaming.v1.StoreEventPriorityConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {palexy.streaming.v1.IStoreEventPriorityConfig} message StoreEventPriorityConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventPriorityConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEventPriorityConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.StoreEventPriorityConfig} StoreEventPriorityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventPriorityConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.StoreEventPriorityConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.storeEventType = reader.int32();
                                break;
                            case 4:
                                message.defaultPriority = reader.int32();
                                break;
                            case 5:
                                if (!(message.rules && message.rules.length))
                                    message.rules = [];
                                message.rules.push($root.palexy.streaming.v1.PriorityRule.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEventPriorityConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.StoreEventPriorityConfig} StoreEventPriorityConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventPriorityConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEventPriorityConfig message.
                     * @function verify
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEventPriorityConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            switch (message.storeEventType) {
                            default:
                                return "storeEventType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                            case 17:
                            case 18:
                            case 19:
                                break;
                            }
                        if (message.defaultPriority != null && message.hasOwnProperty("defaultPriority"))
                            switch (message.defaultPriority) {
                            default:
                                return "defaultPriority: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.rules != null && message.hasOwnProperty("rules")) {
                            if (!Array.isArray(message.rules))
                                return "rules: array expected";
                            for (var i = 0; i < message.rules.length; ++i) {
                                var error = $root.palexy.streaming.v1.PriorityRule.verify(message.rules[i]);
                                if (error)
                                    return "rules." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreEventPriorityConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.StoreEventPriorityConfig} StoreEventPriorityConfig
                     */
                    StoreEventPriorityConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.StoreEventPriorityConfig)
                            return object;
                        var message = new $root.palexy.streaming.v1.StoreEventPriorityConfig();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.storeEventType) {
                        case "UNKNOWN_STORE_EVENT_TYPE":
                        case 0:
                            message.storeEventType = 0;
                            break;
                        case "MISSED_CUSTOMER_INTERACTION":
                        case 1:
                            message.storeEventType = 1;
                            break;
                        case "SUSPICIOUS_CASHIER_ACTIVITY":
                        case 2:
                            message.storeEventType = 2;
                            break;
                        case "SOP_NON_COMPLIANCE":
                        case 3:
                            message.storeEventType = 3;
                            break;
                        case "STAFF_ATTENDANCE_NON_COMPLIANCE":
                        case 4:
                            message.storeEventType = 4;
                            break;
                        case "STAFF_GATHERING":
                        case 5:
                            message.storeEventType = 5;
                            break;
                        case "STORE_OPEN_CLOSE_TIME_NON_COMPLIANCE":
                        case 6:
                            message.storeEventType = 6;
                            break;
                        case "CUSTOMER_NEEDS_ASSISTANCE":
                        case 7:
                            message.storeEventType = 7;
                            break;
                        case "STAFF_NOT_WEAR_GLOVE":
                        case 8:
                            message.storeEventType = 8;
                            break;
                        case "NOT_GREETED_ON_TIME":
                        case 9:
                            message.storeEventType = 9;
                            break;
                        case "STAFF_MISSING":
                        case 10:
                            message.storeEventType = 10;
                            break;
                        case "STAFF_LEAVING_SPECIAL_AREA_WITHOUT_FOLLOWING_SOP":
                        case 11:
                            message.storeEventType = 11;
                            break;
                        case "HIGH_TRAFFIC_CHECKOUT":
                        case 12:
                            message.storeEventType = 12;
                            break;
                        case "LONG_TOTAL_SERVICE_TIME":
                        case 13:
                            message.storeEventType = 13;
                            break;
                        case "MISSED_CUSTOMER_INTERACTION_AT_SECTION":
                        case 14:
                            message.storeEventType = 14;
                            break;
                        case "LATE_TABLE_CLEANING":
                        case 15:
                            message.storeEventType = 15;
                            break;
                        case "SUSPICIOUS_BILL_CANCELLATION":
                        case 16:
                            message.storeEventType = 16;
                            break;
                        case "PREPARE_DRINK_WITHOUT_AUTHORIZATION":
                        case 17:
                            message.storeEventType = 17;
                            break;
                        case "LONG_QUEUE":
                        case 18:
                            message.storeEventType = 18;
                            break;
                        case "LONG_CHECKOUT_TIME":
                        case 19:
                            message.storeEventType = 19;
                            break;
                        }
                        switch (object.defaultPriority) {
                        case "PRIORITY_UNKNOWN":
                        case 0:
                            message.defaultPriority = 0;
                            break;
                        case "LOW":
                        case 1:
                            message.defaultPriority = 1;
                            break;
                        case "MEDIUM":
                        case 2:
                            message.defaultPriority = 2;
                            break;
                        case "HIGH":
                        case 3:
                            message.defaultPriority = 3;
                            break;
                        }
                        if (object.rules) {
                            if (!Array.isArray(object.rules))
                                throw TypeError(".palexy.streaming.v1.StoreEventPriorityConfig.rules: array expected");
                            message.rules = [];
                            for (var i = 0; i < object.rules.length; ++i) {
                                if (typeof object.rules[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.StoreEventPriorityConfig.rules: object expected");
                                message.rules[i] = $root.palexy.streaming.v1.PriorityRule.fromObject(object.rules[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEventPriorityConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @static
                     * @param {palexy.streaming.v1.StoreEventPriorityConfig} message StoreEventPriorityConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEventPriorityConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rules = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.storeEventType = options.enums === String ? "UNKNOWN_STORE_EVENT_TYPE" : 0;
                            object.defaultPriority = options.enums === String ? "PRIORITY_UNKNOWN" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            object.storeEventType = options.enums === String ? $root.palexy.streaming.v1.StoreEventType[message.storeEventType] : message.storeEventType;
                        if (message.defaultPriority != null && message.hasOwnProperty("defaultPriority"))
                            object.defaultPriority = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.Priority[message.defaultPriority] : message.defaultPriority;
                        if (message.rules && message.rules.length) {
                            object.rules = [];
                            for (var j = 0; j < message.rules.length; ++j)
                                object.rules[j] = $root.palexy.streaming.v1.PriorityRule.toObject(message.rules[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreEventPriorityConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.StoreEventPriorityConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEventPriorityConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreEventPriorityConfig;
                })();
    
                v1.PriorityRule = (function() {
    
                    /**
                     * Properties of a PriorityRule.
                     * @memberof palexy.streaming.v1
                     * @interface IPriorityRule
                     * @property {Array.<palexy.streaming.v1.IPriorityCondition>|null} [conditions] PriorityRule conditions
                     * @property {palexy.streaming.v1.StoreEvent.Priority|null} [priority] PriorityRule priority
                     */
    
                    /**
                     * Constructs a new PriorityRule.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PriorityRule.
                     * @implements IPriorityRule
                     * @constructor
                     * @param {palexy.streaming.v1.IPriorityRule=} [properties] Properties to set
                     */
                    function PriorityRule(properties) {
                        this.conditions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PriorityRule conditions.
                     * @member {Array.<palexy.streaming.v1.IPriorityCondition>} conditions
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @instance
                     */
                    PriorityRule.prototype.conditions = $util.emptyArray;
    
                    /**
                     * PriorityRule priority.
                     * @member {palexy.streaming.v1.StoreEvent.Priority} priority
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @instance
                     */
                    PriorityRule.prototype.priority = 0;
    
                    /**
                     * Creates a new PriorityRule instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRule=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PriorityRule} PriorityRule instance
                     */
                    PriorityRule.create = function create(properties) {
                        return new PriorityRule(properties);
                    };
    
                    /**
                     * Encodes the specified PriorityRule message. Does not implicitly {@link palexy.streaming.v1.PriorityRule.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRule} message PriorityRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityRule.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.conditions != null && message.conditions.length)
                            for (var i = 0; i < message.conditions.length; ++i)
                                $root.palexy.streaming.v1.PriorityCondition.encode(message.conditions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.priority);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PriorityRule message, length delimited. Does not implicitly {@link palexy.streaming.v1.PriorityRule.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRule} message PriorityRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityRule.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PriorityRule message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PriorityRule} PriorityRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityRule.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PriorityRule();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.conditions && message.conditions.length))
                                    message.conditions = [];
                                message.conditions.push($root.palexy.streaming.v1.PriorityCondition.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.priority = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PriorityRule message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PriorityRule} PriorityRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityRule.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PriorityRule message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PriorityRule.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.conditions != null && message.hasOwnProperty("conditions")) {
                            if (!Array.isArray(message.conditions))
                                return "conditions: array expected";
                            for (var i = 0; i < message.conditions.length; ++i) {
                                var error = $root.palexy.streaming.v1.PriorityCondition.verify(message.conditions[i]);
                                if (error)
                                    return "conditions." + error;
                            }
                        }
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            switch (message.priority) {
                            default:
                                return "priority: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a PriorityRule message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PriorityRule} PriorityRule
                     */
                    PriorityRule.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PriorityRule)
                            return object;
                        var message = new $root.palexy.streaming.v1.PriorityRule();
                        if (object.conditions) {
                            if (!Array.isArray(object.conditions))
                                throw TypeError(".palexy.streaming.v1.PriorityRule.conditions: array expected");
                            message.conditions = [];
                            for (var i = 0; i < object.conditions.length; ++i) {
                                if (typeof object.conditions[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PriorityRule.conditions: object expected");
                                message.conditions[i] = $root.palexy.streaming.v1.PriorityCondition.fromObject(object.conditions[i]);
                            }
                        }
                        switch (object.priority) {
                        case "PRIORITY_UNKNOWN":
                        case 0:
                            message.priority = 0;
                            break;
                        case "LOW":
                        case 1:
                            message.priority = 1;
                            break;
                        case "MEDIUM":
                        case 2:
                            message.priority = 2;
                            break;
                        case "HIGH":
                        case 3:
                            message.priority = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PriorityRule message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @static
                     * @param {palexy.streaming.v1.PriorityRule} message PriorityRule
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PriorityRule.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.conditions = [];
                        if (options.defaults)
                            object.priority = options.enums === String ? "PRIORITY_UNKNOWN" : 0;
                        if (message.conditions && message.conditions.length) {
                            object.conditions = [];
                            for (var j = 0; j < message.conditions.length; ++j)
                                object.conditions[j] = $root.palexy.streaming.v1.PriorityCondition.toObject(message.conditions[j], options);
                        }
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            object.priority = options.enums === String ? $root.palexy.streaming.v1.StoreEvent.Priority[message.priority] : message.priority;
                        return object;
                    };
    
                    /**
                     * Converts this PriorityRule to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PriorityRule
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PriorityRule.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PriorityRule;
                })();
    
                v1.PriorityCondition = (function() {
    
                    /**
                     * Properties of a PriorityCondition.
                     * @memberof palexy.streaming.v1
                     * @interface IPriorityCondition
                     * @property {palexy.streaming.v1.IPriorityConditionField|null} [field] PriorityCondition field
                     * @property {palexy.streaming.v1.ComparisonOperator|null} [operator] PriorityCondition operator
                     * @property {Array.<string>|null} [values] PriorityCondition values
                     */
    
                    /**
                     * Constructs a new PriorityCondition.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PriorityCondition.
                     * @implements IPriorityCondition
                     * @constructor
                     * @param {palexy.streaming.v1.IPriorityCondition=} [properties] Properties to set
                     */
                    function PriorityCondition(properties) {
                        this.values = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PriorityCondition field.
                     * @member {palexy.streaming.v1.IPriorityConditionField|null|undefined} field
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @instance
                     */
                    PriorityCondition.prototype.field = null;
    
                    /**
                     * PriorityCondition operator.
                     * @member {palexy.streaming.v1.ComparisonOperator} operator
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @instance
                     */
                    PriorityCondition.prototype.operator = 0;
    
                    /**
                     * PriorityCondition values.
                     * @member {Array.<string>} values
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @instance
                     */
                    PriorityCondition.prototype.values = $util.emptyArray;
    
                    /**
                     * Creates a new PriorityCondition instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {palexy.streaming.v1.IPriorityCondition=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PriorityCondition} PriorityCondition instance
                     */
                    PriorityCondition.create = function create(properties) {
                        return new PriorityCondition(properties);
                    };
    
                    /**
                     * Encodes the specified PriorityCondition message. Does not implicitly {@link palexy.streaming.v1.PriorityCondition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {palexy.streaming.v1.IPriorityCondition} message PriorityCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityCondition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
                            $root.palexy.streaming.v1.PriorityConditionField.encode(message.field, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.operator);
                        if (message.values != null && message.values.length)
                            for (var i = 0; i < message.values.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.values[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PriorityCondition message, length delimited. Does not implicitly {@link palexy.streaming.v1.PriorityCondition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {palexy.streaming.v1.IPriorityCondition} message PriorityCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityCondition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PriorityCondition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PriorityCondition} PriorityCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityCondition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PriorityCondition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.field = $root.palexy.streaming.v1.PriorityConditionField.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.operator = reader.int32();
                                break;
                            case 3:
                                if (!(message.values && message.values.length))
                                    message.values = [];
                                message.values.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PriorityCondition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PriorityCondition} PriorityCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityCondition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PriorityCondition message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PriorityCondition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.field != null && message.hasOwnProperty("field")) {
                            var error = $root.palexy.streaming.v1.PriorityConditionField.verify(message.field);
                            if (error)
                                return "field." + error;
                        }
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            switch (message.operator) {
                            default:
                                return "operator: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.values != null && message.hasOwnProperty("values")) {
                            if (!Array.isArray(message.values))
                                return "values: array expected";
                            for (var i = 0; i < message.values.length; ++i)
                                if (!$util.isString(message.values[i]))
                                    return "values: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PriorityCondition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PriorityCondition} PriorityCondition
                     */
                    PriorityCondition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PriorityCondition)
                            return object;
                        var message = new $root.palexy.streaming.v1.PriorityCondition();
                        if (object.field != null) {
                            if (typeof object.field !== "object")
                                throw TypeError(".palexy.streaming.v1.PriorityCondition.field: object expected");
                            message.field = $root.palexy.streaming.v1.PriorityConditionField.fromObject(object.field);
                        }
                        switch (object.operator) {
                        case "UNKNOWN_COMPARISON_OPERATOR":
                        case 0:
                            message.operator = 0;
                            break;
                        case "CONTAINS_VALUE":
                        case 1:
                            message.operator = 1;
                            break;
                        case "NOT_CONTAINS_VALUE":
                        case 2:
                            message.operator = 2;
                            break;
                        case "GT":
                        case 3:
                            message.operator = 3;
                            break;
                        }
                        if (object.values) {
                            if (!Array.isArray(object.values))
                                throw TypeError(".palexy.streaming.v1.PriorityCondition.values: array expected");
                            message.values = [];
                            for (var i = 0; i < object.values.length; ++i)
                                message.values[i] = String(object.values[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PriorityCondition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @static
                     * @param {palexy.streaming.v1.PriorityCondition} message PriorityCondition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PriorityCondition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.values = [];
                        if (options.defaults) {
                            object.field = null;
                            object.operator = options.enums === String ? "UNKNOWN_COMPARISON_OPERATOR" : 0;
                        }
                        if (message.field != null && message.hasOwnProperty("field"))
                            object.field = $root.palexy.streaming.v1.PriorityConditionField.toObject(message.field, options);
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = options.enums === String ? $root.palexy.streaming.v1.ComparisonOperator[message.operator] : message.operator;
                        if (message.values && message.values.length) {
                            object.values = [];
                            for (var j = 0; j < message.values.length; ++j)
                                object.values[j] = message.values[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PriorityCondition to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PriorityCondition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PriorityCondition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PriorityCondition;
                })();
    
                v1.PriorityConditionField = (function() {
    
                    /**
                     * Properties of a PriorityConditionField.
                     * @memberof palexy.streaming.v1
                     * @interface IPriorityConditionField
                     * @property {palexy.streaming.v1.PriorityConditionField.FieldType|null} [fieldType] PriorityConditionField fieldType
                     * @property {palexy.streaming.v1.PriorityConditionField.IFormFieldData|null} [formFieldData] PriorityConditionField formFieldData
                     */
    
                    /**
                     * Constructs a new PriorityConditionField.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PriorityConditionField.
                     * @implements IPriorityConditionField
                     * @constructor
                     * @param {palexy.streaming.v1.IPriorityConditionField=} [properties] Properties to set
                     */
                    function PriorityConditionField(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PriorityConditionField fieldType.
                     * @member {palexy.streaming.v1.PriorityConditionField.FieldType} fieldType
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @instance
                     */
                    PriorityConditionField.prototype.fieldType = 0;
    
                    /**
                     * PriorityConditionField formFieldData.
                     * @member {palexy.streaming.v1.PriorityConditionField.IFormFieldData|null|undefined} formFieldData
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @instance
                     */
                    PriorityConditionField.prototype.formFieldData = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * PriorityConditionField _formFieldData.
                     * @member {"formFieldData"|undefined} _formFieldData
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @instance
                     */
                    Object.defineProperty(PriorityConditionField.prototype, "_formFieldData", {
                        get: $util.oneOfGetter($oneOfFields = ["formFieldData"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new PriorityConditionField instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {palexy.streaming.v1.IPriorityConditionField=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PriorityConditionField} PriorityConditionField instance
                     */
                    PriorityConditionField.create = function create(properties) {
                        return new PriorityConditionField(properties);
                    };
    
                    /**
                     * Encodes the specified PriorityConditionField message. Does not implicitly {@link palexy.streaming.v1.PriorityConditionField.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {palexy.streaming.v1.IPriorityConditionField} message PriorityConditionField message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityConditionField.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fieldType != null && Object.hasOwnProperty.call(message, "fieldType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fieldType);
                        if (message.formFieldData != null && Object.hasOwnProperty.call(message, "formFieldData"))
                            $root.palexy.streaming.v1.PriorityConditionField.FormFieldData.encode(message.formFieldData, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PriorityConditionField message, length delimited. Does not implicitly {@link palexy.streaming.v1.PriorityConditionField.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {palexy.streaming.v1.IPriorityConditionField} message PriorityConditionField message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityConditionField.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PriorityConditionField message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PriorityConditionField} PriorityConditionField
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityConditionField.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PriorityConditionField();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fieldType = reader.int32();
                                break;
                            case 2:
                                message.formFieldData = $root.palexy.streaming.v1.PriorityConditionField.FormFieldData.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PriorityConditionField message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PriorityConditionField} PriorityConditionField
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityConditionField.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PriorityConditionField message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PriorityConditionField.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                            switch (message.fieldType) {
                            default:
                                return "fieldType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.formFieldData != null && message.hasOwnProperty("formFieldData")) {
                            properties._formFieldData = 1;
                            {
                                var error = $root.palexy.streaming.v1.PriorityConditionField.FormFieldData.verify(message.formFieldData);
                                if (error)
                                    return "formFieldData." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PriorityConditionField message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PriorityConditionField} PriorityConditionField
                     */
                    PriorityConditionField.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PriorityConditionField)
                            return object;
                        var message = new $root.palexy.streaming.v1.PriorityConditionField();
                        switch (object.fieldType) {
                        case "UNKNOWN_FIELD_TYPE":
                        case 0:
                            message.fieldType = 0;
                            break;
                        case "FORM_FIELD":
                        case 1:
                            message.fieldType = 1;
                            break;
                        case "TOTAL_SERVICE_TIME":
                        case 2:
                            message.fieldType = 2;
                            break;
                        }
                        if (object.formFieldData != null) {
                            if (typeof object.formFieldData !== "object")
                                throw TypeError(".palexy.streaming.v1.PriorityConditionField.formFieldData: object expected");
                            message.formFieldData = $root.palexy.streaming.v1.PriorityConditionField.FormFieldData.fromObject(object.formFieldData);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PriorityConditionField message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @static
                     * @param {palexy.streaming.v1.PriorityConditionField} message PriorityConditionField
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PriorityConditionField.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.fieldType = options.enums === String ? "UNKNOWN_FIELD_TYPE" : 0;
                        if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                            object.fieldType = options.enums === String ? $root.palexy.streaming.v1.PriorityConditionField.FieldType[message.fieldType] : message.fieldType;
                        if (message.formFieldData != null && message.hasOwnProperty("formFieldData")) {
                            object.formFieldData = $root.palexy.streaming.v1.PriorityConditionField.FormFieldData.toObject(message.formFieldData, options);
                            if (options.oneofs)
                                object._formFieldData = "formFieldData";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PriorityConditionField to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PriorityConditionField
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PriorityConditionField.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FieldType enum.
                     * @name palexy.streaming.v1.PriorityConditionField.FieldType
                     * @enum {number}
                     * @property {number} UNKNOWN_FIELD_TYPE=0 UNKNOWN_FIELD_TYPE value
                     * @property {number} FORM_FIELD=1 FORM_FIELD value
                     * @property {number} TOTAL_SERVICE_TIME=2 TOTAL_SERVICE_TIME value
                     */
                    PriorityConditionField.FieldType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN_FIELD_TYPE"] = 0;
                        values[valuesById[1] = "FORM_FIELD"] = 1;
                        values[valuesById[2] = "TOTAL_SERVICE_TIME"] = 2;
                        return values;
                    })();
    
                    PriorityConditionField.FormFieldData = (function() {
    
                        /**
                         * Properties of a FormFieldData.
                         * @memberof palexy.streaming.v1.PriorityConditionField
                         * @interface IFormFieldData
                         * @property {number|null} [formId] FormFieldData formId
                         * @property {number|null} [formFieldId] FormFieldData formFieldId
                         * @property {string|null} [internalQuestionId] FormFieldData internalQuestionId
                         */
    
                        /**
                         * Constructs a new FormFieldData.
                         * @memberof palexy.streaming.v1.PriorityConditionField
                         * @classdesc Represents a FormFieldData.
                         * @implements IFormFieldData
                         * @constructor
                         * @param {palexy.streaming.v1.PriorityConditionField.IFormFieldData=} [properties] Properties to set
                         */
                        function FormFieldData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * FormFieldData formId.
                         * @member {number} formId
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @instance
                         */
                        FormFieldData.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormFieldData formFieldId.
                         * @member {number} formFieldId
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @instance
                         */
                        FormFieldData.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormFieldData internalQuestionId.
                         * @member {string} internalQuestionId
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @instance
                         */
                        FormFieldData.prototype.internalQuestionId = "";
    
                        /**
                         * Creates a new FormFieldData instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {palexy.streaming.v1.PriorityConditionField.IFormFieldData=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.PriorityConditionField.FormFieldData} FormFieldData instance
                         */
                        FormFieldData.create = function create(properties) {
                            return new FormFieldData(properties);
                        };
    
                        /**
                         * Encodes the specified FormFieldData message. Does not implicitly {@link palexy.streaming.v1.PriorityConditionField.FormFieldData.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {palexy.streaming.v1.PriorityConditionField.IFormFieldData} message FormFieldData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormFieldData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                            if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                            if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.internalQuestionId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified FormFieldData message, length delimited. Does not implicitly {@link palexy.streaming.v1.PriorityConditionField.FormFieldData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {palexy.streaming.v1.PriorityConditionField.IFormFieldData} message FormFieldData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormFieldData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a FormFieldData message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.PriorityConditionField.FormFieldData} FormFieldData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormFieldData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PriorityConditionField.FormFieldData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.formId = reader.int64();
                                    break;
                                case 2:
                                    message.formFieldId = reader.int64();
                                    break;
                                case 3:
                                    message.internalQuestionId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a FormFieldData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.PriorityConditionField.FormFieldData} FormFieldData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormFieldData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a FormFieldData message.
                         * @function verify
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        FormFieldData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                    return "formId: integer|Long expected";
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                    return "formFieldId: integer|Long expected";
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                if (!$util.isString(message.internalQuestionId))
                                    return "internalQuestionId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a FormFieldData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.PriorityConditionField.FormFieldData} FormFieldData
                         */
                        FormFieldData.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.PriorityConditionField.FormFieldData)
                                return object;
                            var message = new $root.palexy.streaming.v1.PriorityConditionField.FormFieldData();
                            if (object.formId != null)
                                if ($util.Long)
                                    (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                                else if (typeof object.formId === "string")
                                    message.formId = parseInt(object.formId, 10);
                                else if (typeof object.formId === "number")
                                    message.formId = object.formId;
                                else if (typeof object.formId === "object")
                                    message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                            if (object.formFieldId != null)
                                if ($util.Long)
                                    (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                                else if (typeof object.formFieldId === "string")
                                    message.formFieldId = parseInt(object.formFieldId, 10);
                                else if (typeof object.formFieldId === "number")
                                    message.formFieldId = object.formFieldId;
                                else if (typeof object.formFieldId === "object")
                                    message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                            if (object.internalQuestionId != null)
                                message.internalQuestionId = String(object.internalQuestionId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a FormFieldData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @static
                         * @param {palexy.streaming.v1.PriorityConditionField.FormFieldData} message FormFieldData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        FormFieldData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formFieldId = options.longs === String ? "0" : 0;
                                object.internalQuestionId = "";
                            }
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (typeof message.formId === "number")
                                    object.formId = options.longs === String ? String(message.formId) : message.formId;
                                else
                                    object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (typeof message.formFieldId === "number")
                                    object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                                else
                                    object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                object.internalQuestionId = message.internalQuestionId;
                            return object;
                        };
    
                        /**
                         * Converts this FormFieldData to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.PriorityConditionField.FormFieldData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        FormFieldData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return FormFieldData;
                    })();
    
                    return PriorityConditionField;
                })();
    
                v1.PriorityRuleList = (function() {
    
                    /**
                     * Properties of a PriorityRuleList.
                     * @memberof palexy.streaming.v1
                     * @interface IPriorityRuleList
                     * @property {Array.<palexy.streaming.v1.IPriorityRule>|null} [rules] PriorityRuleList rules
                     */
    
                    /**
                     * Constructs a new PriorityRuleList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PriorityRuleList.
                     * @implements IPriorityRuleList
                     * @constructor
                     * @param {palexy.streaming.v1.IPriorityRuleList=} [properties] Properties to set
                     */
                    function PriorityRuleList(properties) {
                        this.rules = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PriorityRuleList rules.
                     * @member {Array.<palexy.streaming.v1.IPriorityRule>} rules
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @instance
                     */
                    PriorityRuleList.prototype.rules = $util.emptyArray;
    
                    /**
                     * Creates a new PriorityRuleList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRuleList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PriorityRuleList} PriorityRuleList instance
                     */
                    PriorityRuleList.create = function create(properties) {
                        return new PriorityRuleList(properties);
                    };
    
                    /**
                     * Encodes the specified PriorityRuleList message. Does not implicitly {@link palexy.streaming.v1.PriorityRuleList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRuleList} message PriorityRuleList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityRuleList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rules != null && message.rules.length)
                            for (var i = 0; i < message.rules.length; ++i)
                                $root.palexy.streaming.v1.PriorityRule.encode(message.rules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PriorityRuleList message, length delimited. Does not implicitly {@link palexy.streaming.v1.PriorityRuleList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {palexy.streaming.v1.IPriorityRuleList} message PriorityRuleList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PriorityRuleList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PriorityRuleList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PriorityRuleList} PriorityRuleList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityRuleList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PriorityRuleList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rules && message.rules.length))
                                    message.rules = [];
                                message.rules.push($root.palexy.streaming.v1.PriorityRule.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PriorityRuleList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PriorityRuleList} PriorityRuleList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PriorityRuleList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PriorityRuleList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PriorityRuleList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rules != null && message.hasOwnProperty("rules")) {
                            if (!Array.isArray(message.rules))
                                return "rules: array expected";
                            for (var i = 0; i < message.rules.length; ++i) {
                                var error = $root.palexy.streaming.v1.PriorityRule.verify(message.rules[i]);
                                if (error)
                                    return "rules." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PriorityRuleList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PriorityRuleList} PriorityRuleList
                     */
                    PriorityRuleList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PriorityRuleList)
                            return object;
                        var message = new $root.palexy.streaming.v1.PriorityRuleList();
                        if (object.rules) {
                            if (!Array.isArray(object.rules))
                                throw TypeError(".palexy.streaming.v1.PriorityRuleList.rules: array expected");
                            message.rules = [];
                            for (var i = 0; i < object.rules.length; ++i) {
                                if (typeof object.rules[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.PriorityRuleList.rules: object expected");
                                message.rules[i] = $root.palexy.streaming.v1.PriorityRule.fromObject(object.rules[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PriorityRuleList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @static
                     * @param {palexy.streaming.v1.PriorityRuleList} message PriorityRuleList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PriorityRuleList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.rules = [];
                        if (message.rules && message.rules.length) {
                            object.rules = [];
                            for (var j = 0; j < message.rules.length; ++j)
                                object.rules[j] = $root.palexy.streaming.v1.PriorityRule.toObject(message.rules[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this PriorityRuleList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PriorityRuleList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PriorityRuleList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PriorityRuleList;
                })();
    
                v1.CreateStoreEventPriorityConfigRequest = (function() {
    
                    /**
                     * Properties of a CreateStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface ICreateStoreEventPriorityConfigRequest
                     * @property {palexy.streaming.v1.IStoreEventPriorityConfig|null} [config] CreateStoreEventPriorityConfigRequest config
                     */
    
                    /**
                     * Constructs a new CreateStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a CreateStoreEventPriorityConfigRequest.
                     * @implements ICreateStoreEventPriorityConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest=} [properties] Properties to set
                     */
                    function CreateStoreEventPriorityConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateStoreEventPriorityConfigRequest config.
                     * @member {palexy.streaming.v1.IStoreEventPriorityConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @instance
                     */
                    CreateStoreEventPriorityConfigRequest.prototype.config = null;
    
                    /**
                     * Creates a new CreateStoreEventPriorityConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.CreateStoreEventPriorityConfigRequest} CreateStoreEventPriorityConfigRequest instance
                     */
                    CreateStoreEventPriorityConfigRequest.create = function create(properties) {
                        return new CreateStoreEventPriorityConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateStoreEventPriorityConfigRequest message. Does not implicitly {@link palexy.streaming.v1.CreateStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest} message CreateStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreEventPriorityConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.StoreEventPriorityConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateStoreEventPriorityConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.CreateStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.ICreateStoreEventPriorityConfigRequest} message CreateStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateStoreEventPriorityConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateStoreEventPriorityConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.CreateStoreEventPriorityConfigRequest} CreateStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreEventPriorityConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.CreateStoreEventPriorityConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateStoreEventPriorityConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.CreateStoreEventPriorityConfigRequest} CreateStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateStoreEventPriorityConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateStoreEventPriorityConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateStoreEventPriorityConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.StoreEventPriorityConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateStoreEventPriorityConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.CreateStoreEventPriorityConfigRequest} CreateStoreEventPriorityConfigRequest
                     */
                    CreateStoreEventPriorityConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.CreateStoreEventPriorityConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.CreateStoreEventPriorityConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.CreateStoreEventPriorityConfigRequest.config: object expected");
                            message.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.fromObject(object.config);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateStoreEventPriorityConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.CreateStoreEventPriorityConfigRequest} message CreateStoreEventPriorityConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateStoreEventPriorityConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.config = null;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.toObject(message.config, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateStoreEventPriorityConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.CreateStoreEventPriorityConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateStoreEventPriorityConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateStoreEventPriorityConfigRequest;
                })();
    
                v1.UpdateStoreEventPriorityConfigRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IUpdateStoreEventPriorityConfigRequest
                     * @property {palexy.streaming.v1.IStoreEventPriorityConfig|null} [config] UpdateStoreEventPriorityConfigRequest config
                     */
    
                    /**
                     * Constructs a new UpdateStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an UpdateStoreEventPriorityConfigRequest.
                     * @implements IUpdateStoreEventPriorityConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest=} [properties] Properties to set
                     */
                    function UpdateStoreEventPriorityConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreEventPriorityConfigRequest config.
                     * @member {palexy.streaming.v1.IStoreEventPriorityConfig|null|undefined} config
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @instance
                     */
                    UpdateStoreEventPriorityConfigRequest.prototype.config = null;
    
                    /**
                     * Creates a new UpdateStoreEventPriorityConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest} UpdateStoreEventPriorityConfigRequest instance
                     */
                    UpdateStoreEventPriorityConfigRequest.create = function create(properties) {
                        return new UpdateStoreEventPriorityConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreEventPriorityConfigRequest message. Does not implicitly {@link palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest} message UpdateStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreEventPriorityConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.streaming.v1.StoreEventPriorityConfig.encode(message.config, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreEventPriorityConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IUpdateStoreEventPriorityConfigRequest} message UpdateStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreEventPriorityConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreEventPriorityConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest} UpdateStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreEventPriorityConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreEventPriorityConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest} UpdateStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreEventPriorityConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreEventPriorityConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreEventPriorityConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.streaming.v1.StoreEventPriorityConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreEventPriorityConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest} UpdateStoreEventPriorityConfigRequest
                     */
                    UpdateStoreEventPriorityConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest();
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest.config: object expected");
                            message.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.fromObject(object.config);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreEventPriorityConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest} message UpdateStoreEventPriorityConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreEventPriorityConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.config = null;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.streaming.v1.StoreEventPriorityConfig.toObject(message.config, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreEventPriorityConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.UpdateStoreEventPriorityConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreEventPriorityConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreEventPriorityConfigRequest;
                })();
    
                v1.DeleteStoreEventPriorityConfigRequest = (function() {
    
                    /**
                     * Properties of a DeleteStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IDeleteStoreEventPriorityConfigRequest
                     * @property {number|null} [id] DeleteStoreEventPriorityConfigRequest id
                     */
    
                    /**
                     * Constructs a new DeleteStoreEventPriorityConfigRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DeleteStoreEventPriorityConfigRequest.
                     * @implements IDeleteStoreEventPriorityConfigRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest=} [properties] Properties to set
                     */
                    function DeleteStoreEventPriorityConfigRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStoreEventPriorityConfigRequest id.
                     * @member {number} id
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @instance
                     */
                    DeleteStoreEventPriorityConfigRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStoreEventPriorityConfigRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest} DeleteStoreEventPriorityConfigRequest instance
                     */
                    DeleteStoreEventPriorityConfigRequest.create = function create(properties) {
                        return new DeleteStoreEventPriorityConfigRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStoreEventPriorityConfigRequest message. Does not implicitly {@link palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest} message DeleteStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreEventPriorityConfigRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStoreEventPriorityConfigRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.IDeleteStoreEventPriorityConfigRequest} message DeleteStoreEventPriorityConfigRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreEventPriorityConfigRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStoreEventPriorityConfigRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest} DeleteStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreEventPriorityConfigRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStoreEventPriorityConfigRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest} DeleteStoreEventPriorityConfigRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreEventPriorityConfigRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStoreEventPriorityConfigRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStoreEventPriorityConfigRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStoreEventPriorityConfigRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest} DeleteStoreEventPriorityConfigRequest
                     */
                    DeleteStoreEventPriorityConfigRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStoreEventPriorityConfigRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @static
                     * @param {palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest} message DeleteStoreEventPriorityConfigRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStoreEventPriorityConfigRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStoreEventPriorityConfigRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DeleteStoreEventPriorityConfigRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStoreEventPriorityConfigRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStoreEventPriorityConfigRequest;
                })();
    
                v1.ListStoreEventPriorityConfigsRequest = (function() {
    
                    /**
                     * Properties of a ListStoreEventPriorityConfigsRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventPriorityConfigsRequest
                     * @property {number|null} [companyId] ListStoreEventPriorityConfigsRequest companyId
                     */
    
                    /**
                     * Constructs a new ListStoreEventPriorityConfigsRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventPriorityConfigsRequest.
                     * @implements IListStoreEventPriorityConfigsRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest=} [properties] Properties to set
                     */
                    function ListStoreEventPriorityConfigsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventPriorityConfigsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @instance
                     */
                    ListStoreEventPriorityConfigsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStoreEventPriorityConfigsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsRequest} ListStoreEventPriorityConfigsRequest instance
                     */
                    ListStoreEventPriorityConfigsRequest.create = function create(properties) {
                        return new ListStoreEventPriorityConfigsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventPriorityConfigsRequest message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventPriorityConfigsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest} message ListStoreEventPriorityConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventPriorityConfigsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventPriorityConfigsRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventPriorityConfigsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsRequest} message ListStoreEventPriorityConfigsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventPriorityConfigsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventPriorityConfigsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsRequest} ListStoreEventPriorityConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventPriorityConfigsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventPriorityConfigsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventPriorityConfigsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsRequest} ListStoreEventPriorityConfigsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventPriorityConfigsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventPriorityConfigsRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventPriorityConfigsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventPriorityConfigsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsRequest} ListStoreEventPriorityConfigsRequest
                     */
                    ListStoreEventPriorityConfigsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventPriorityConfigsRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventPriorityConfigsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventPriorityConfigsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventPriorityConfigsRequest} message ListStoreEventPriorityConfigsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventPriorityConfigsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventPriorityConfigsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventPriorityConfigsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreEventPriorityConfigsRequest;
                })();
    
                v1.ListStoreEventPriorityConfigsResponse = (function() {
    
                    /**
                     * Properties of a ListStoreEventPriorityConfigsResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IListStoreEventPriorityConfigsResponse
                     * @property {Array.<palexy.streaming.v1.IStoreEventPriorityConfig>|null} [configs] ListStoreEventPriorityConfigsResponse configs
                     */
    
                    /**
                     * Constructs a new ListStoreEventPriorityConfigsResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ListStoreEventPriorityConfigsResponse.
                     * @implements IListStoreEventPriorityConfigsResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsResponse=} [properties] Properties to set
                     */
                    function ListStoreEventPriorityConfigsResponse(properties) {
                        this.configs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreEventPriorityConfigsResponse configs.
                     * @member {Array.<palexy.streaming.v1.IStoreEventPriorityConfig>} configs
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @instance
                     */
                    ListStoreEventPriorityConfigsResponse.prototype.configs = $util.emptyArray;
    
                    /**
                     * Creates a new ListStoreEventPriorityConfigsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} ListStoreEventPriorityConfigsResponse instance
                     */
                    ListStoreEventPriorityConfigsResponse.create = function create(properties) {
                        return new ListStoreEventPriorityConfigsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreEventPriorityConfigsResponse message. Does not implicitly {@link palexy.streaming.v1.ListStoreEventPriorityConfigsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsResponse} message ListStoreEventPriorityConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventPriorityConfigsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.configs != null && message.configs.length)
                            for (var i = 0; i < message.configs.length; ++i)
                                $root.palexy.streaming.v1.StoreEventPriorityConfig.encode(message.configs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreEventPriorityConfigsResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.ListStoreEventPriorityConfigsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.IListStoreEventPriorityConfigsResponse} message ListStoreEventPriorityConfigsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreEventPriorityConfigsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreEventPriorityConfigsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} ListStoreEventPriorityConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventPriorityConfigsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ListStoreEventPriorityConfigsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.configs && message.configs.length))
                                    message.configs = [];
                                message.configs.push($root.palexy.streaming.v1.StoreEventPriorityConfig.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreEventPriorityConfigsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} ListStoreEventPriorityConfigsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreEventPriorityConfigsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreEventPriorityConfigsResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreEventPriorityConfigsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.configs != null && message.hasOwnProperty("configs")) {
                            if (!Array.isArray(message.configs))
                                return "configs: array expected";
                            for (var i = 0; i < message.configs.length; ++i) {
                                var error = $root.palexy.streaming.v1.StoreEventPriorityConfig.verify(message.configs[i]);
                                if (error)
                                    return "configs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreEventPriorityConfigsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} ListStoreEventPriorityConfigsResponse
                     */
                    ListStoreEventPriorityConfigsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ListStoreEventPriorityConfigsResponse)
                            return object;
                        var message = new $root.palexy.streaming.v1.ListStoreEventPriorityConfigsResponse();
                        if (object.configs) {
                            if (!Array.isArray(object.configs))
                                throw TypeError(".palexy.streaming.v1.ListStoreEventPriorityConfigsResponse.configs: array expected");
                            message.configs = [];
                            for (var i = 0; i < object.configs.length; ++i) {
                                if (typeof object.configs[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.ListStoreEventPriorityConfigsResponse.configs: object expected");
                                message.configs[i] = $root.palexy.streaming.v1.StoreEventPriorityConfig.fromObject(object.configs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreEventPriorityConfigsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @static
                     * @param {palexy.streaming.v1.ListStoreEventPriorityConfigsResponse} message ListStoreEventPriorityConfigsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreEventPriorityConfigsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.configs = [];
                        if (message.configs && message.configs.length) {
                            object.configs = [];
                            for (var j = 0; j < message.configs.length; ++j)
                                object.configs[j] = $root.palexy.streaming.v1.StoreEventPriorityConfig.toObject(message.configs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreEventPriorityConfigsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ListStoreEventPriorityConfigsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreEventPriorityConfigsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreEventPriorityConfigsResponse;
                })();
    
                v1.PopulateWorkforceDataRequest = (function() {
    
                    /**
                     * Properties of a PopulateWorkforceDataRequest.
                     * @memberof palexy.streaming.v1
                     * @interface IPopulateWorkforceDataRequest
                     * @property {number|null} [storeId] PopulateWorkforceDataRequest storeId
                     * @property {number|null} [startDateId] PopulateWorkforceDataRequest startDateId
                     * @property {number|null} [endDateId] PopulateWorkforceDataRequest endDateId
                     * @property {number|null} [shiftTemplateId] PopulateWorkforceDataRequest shiftTemplateId
                     * @property {string|null} [username] PopulateWorkforceDataRequest username
                     */
    
                    /**
                     * Constructs a new PopulateWorkforceDataRequest.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PopulateWorkforceDataRequest.
                     * @implements IPopulateWorkforceDataRequest
                     * @constructor
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest=} [properties] Properties to set
                     */
                    function PopulateWorkforceDataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PopulateWorkforceDataRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     */
                    PopulateWorkforceDataRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PopulateWorkforceDataRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     */
                    PopulateWorkforceDataRequest.prototype.startDateId = 0;
    
                    /**
                     * PopulateWorkforceDataRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     */
                    PopulateWorkforceDataRequest.prototype.endDateId = 0;
    
                    /**
                     * PopulateWorkforceDataRequest shiftTemplateId.
                     * @member {number} shiftTemplateId
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     */
                    PopulateWorkforceDataRequest.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * PopulateWorkforceDataRequest username.
                     * @member {string} username
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     */
                    PopulateWorkforceDataRequest.prototype.username = "";
    
                    /**
                     * Creates a new PopulateWorkforceDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataRequest} PopulateWorkforceDataRequest instance
                     */
                    PopulateWorkforceDataRequest.create = function create(properties) {
                        return new PopulateWorkforceDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified PopulateWorkforceDataRequest message. Does not implicitly {@link palexy.streaming.v1.PopulateWorkforceDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest} message PopulateWorkforceDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PopulateWorkforceDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.shiftTemplateId);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.username);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PopulateWorkforceDataRequest message, length delimited. Does not implicitly {@link palexy.streaming.v1.PopulateWorkforceDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataRequest} message PopulateWorkforceDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PopulateWorkforceDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PopulateWorkforceDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataRequest} PopulateWorkforceDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PopulateWorkforceDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PopulateWorkforceDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.shiftTemplateId = reader.int64();
                                break;
                            case 5:
                                message.username = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PopulateWorkforceDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataRequest} PopulateWorkforceDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PopulateWorkforceDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PopulateWorkforceDataRequest message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PopulateWorkforceDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                                return "shiftTemplateId: integer|Long expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PopulateWorkforceDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataRequest} PopulateWorkforceDataRequest
                     */
                    PopulateWorkforceDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PopulateWorkforceDataRequest)
                            return object;
                        var message = new $root.palexy.streaming.v1.PopulateWorkforceDataRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        if (object.shiftTemplateId != null)
                            if ($util.Long)
                                (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                            else if (typeof object.shiftTemplateId === "string")
                                message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                            else if (typeof object.shiftTemplateId === "number")
                                message.shiftTemplateId = object.shiftTemplateId;
                            else if (typeof object.shiftTemplateId === "object")
                                message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PopulateWorkforceDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @static
                     * @param {palexy.streaming.v1.PopulateWorkforceDataRequest} message PopulateWorkforceDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PopulateWorkforceDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.shiftTemplateId = options.longs === String ? "0" : 0;
                            object.username = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (typeof message.shiftTemplateId === "number")
                                object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                            else
                                object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        return object;
                    };
    
                    /**
                     * Converts this PopulateWorkforceDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PopulateWorkforceDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PopulateWorkforceDataRequest;
                })();
    
                v1.PopulateWorkforceDataResponse = (function() {
    
                    /**
                     * Properties of a PopulateWorkforceDataResponse.
                     * @memberof palexy.streaming.v1
                     * @interface IPopulateWorkforceDataResponse
                     */
    
                    /**
                     * Constructs a new PopulateWorkforceDataResponse.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a PopulateWorkforceDataResponse.
                     * @implements IPopulateWorkforceDataResponse
                     * @constructor
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataResponse=} [properties] Properties to set
                     */
                    function PopulateWorkforceDataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new PopulateWorkforceDataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataResponse=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataResponse} PopulateWorkforceDataResponse instance
                     */
                    PopulateWorkforceDataResponse.create = function create(properties) {
                        return new PopulateWorkforceDataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified PopulateWorkforceDataResponse message. Does not implicitly {@link palexy.streaming.v1.PopulateWorkforceDataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataResponse} message PopulateWorkforceDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PopulateWorkforceDataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PopulateWorkforceDataResponse message, length delimited. Does not implicitly {@link palexy.streaming.v1.PopulateWorkforceDataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {palexy.streaming.v1.IPopulateWorkforceDataResponse} message PopulateWorkforceDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PopulateWorkforceDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PopulateWorkforceDataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataResponse} PopulateWorkforceDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PopulateWorkforceDataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.PopulateWorkforceDataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PopulateWorkforceDataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataResponse} PopulateWorkforceDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PopulateWorkforceDataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PopulateWorkforceDataResponse message.
                     * @function verify
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PopulateWorkforceDataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a PopulateWorkforceDataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.PopulateWorkforceDataResponse} PopulateWorkforceDataResponse
                     */
                    PopulateWorkforceDataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.PopulateWorkforceDataResponse)
                            return object;
                        return new $root.palexy.streaming.v1.PopulateWorkforceDataResponse();
                    };
    
                    /**
                     * Creates a plain object from a PopulateWorkforceDataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @static
                     * @param {palexy.streaming.v1.PopulateWorkforceDataResponse} message PopulateWorkforceDataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PopulateWorkforceDataResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this PopulateWorkforceDataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.PopulateWorkforceDataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PopulateWorkforceDataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PopulateWorkforceDataResponse;
                })();
    
                /**
                 * RawIcaStorageProvider enum.
                 * @name palexy.streaming.v1.RawIcaStorageProvider
                 * @enum {number}
                 * @property {number} RAW_PROVIDER_UNKNOWN=0 RAW_PROVIDER_UNKNOWN value
                 * @property {number} DATABASE=1 DATABASE value
                 * @property {number} GCP=2 GCP value
                 */
                v1.RawIcaStorageProvider = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "RAW_PROVIDER_UNKNOWN"] = 0;
                    values[valuesById[1] = "DATABASE"] = 1;
                    values[valuesById[2] = "GCP"] = 2;
                    return values;
                })();
    
                v1.DateRange = (function() {
    
                    /**
                     * Properties of a DateRange.
                     * @memberof palexy.streaming.v1
                     * @interface IDateRange
                     * @property {string|null} [startDate] DateRange startDate
                     * @property {string|null} [endDate] DateRange endDate
                     */
    
                    /**
                     * Constructs a new DateRange.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DateRange.
                     * @implements IDateRange
                     * @constructor
                     * @param {palexy.streaming.v1.IDateRange=} [properties] Properties to set
                     */
                    function DateRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DateRange startDate.
                     * @member {string} startDate
                     * @memberof palexy.streaming.v1.DateRange
                     * @instance
                     */
                    DateRange.prototype.startDate = "";
    
                    /**
                     * DateRange endDate.
                     * @member {string} endDate
                     * @memberof palexy.streaming.v1.DateRange
                     * @instance
                     */
                    DateRange.prototype.endDate = "";
    
                    /**
                     * Creates a new DateRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {palexy.streaming.v1.IDateRange=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DateRange} DateRange instance
                     */
                    DateRange.create = function create(properties) {
                        return new DateRange(properties);
                    };
    
                    /**
                     * Encodes the specified DateRange message. Does not implicitly {@link palexy.streaming.v1.DateRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {palexy.streaming.v1.IDateRange} message DateRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DateRange message, length delimited. Does not implicitly {@link palexy.streaming.v1.DateRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {palexy.streaming.v1.IDateRange} message DateRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DateRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DateRange} DateRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DateRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDate = reader.string();
                                break;
                            case 2:
                                message.endDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DateRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DateRange} DateRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DateRange message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DateRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DateRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DateRange} DateRange
                     */
                    DateRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DateRange)
                            return object;
                        var message = new $root.palexy.streaming.v1.DateRange();
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DateRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DateRange
                     * @static
                     * @param {palexy.streaming.v1.DateRange} message DateRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DateRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDate = "";
                            object.endDate = "";
                        }
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        return object;
                    };
    
                    /**
                     * Converts this DateRange to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DateRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DateRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DateRange;
                })();
    
                v1.TimeRange = (function() {
    
                    /**
                     * Properties of a TimeRange.
                     * @memberof palexy.streaming.v1
                     * @interface ITimeRange
                     * @property {number|null} [startSecondOfDay] TimeRange startSecondOfDay
                     * @property {number|null} [endSecondOfDay] TimeRange endSecondOfDay
                     */
    
                    /**
                     * Constructs a new TimeRange.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TimeRange.
                     * @implements ITimeRange
                     * @constructor
                     * @param {palexy.streaming.v1.ITimeRange=} [properties] Properties to set
                     */
                    function TimeRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeRange startSecondOfDay.
                     * @member {number} startSecondOfDay
                     * @memberof palexy.streaming.v1.TimeRange
                     * @instance
                     */
                    TimeRange.prototype.startSecondOfDay = 0;
    
                    /**
                     * TimeRange endSecondOfDay.
                     * @member {number} endSecondOfDay
                     * @memberof palexy.streaming.v1.TimeRange
                     * @instance
                     */
                    TimeRange.prototype.endSecondOfDay = 0;
    
                    /**
                     * Creates a new TimeRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {palexy.streaming.v1.ITimeRange=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TimeRange} TimeRange instance
                     */
                    TimeRange.create = function create(properties) {
                        return new TimeRange(properties);
                    };
    
                    /**
                     * Encodes the specified TimeRange message. Does not implicitly {@link palexy.streaming.v1.TimeRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {palexy.streaming.v1.ITimeRange} message TimeRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startSecondOfDay != null && Object.hasOwnProperty.call(message, "startSecondOfDay"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.startSecondOfDay);
                        if (message.endSecondOfDay != null && Object.hasOwnProperty.call(message, "endSecondOfDay"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.endSecondOfDay);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeRange message, length delimited. Does not implicitly {@link palexy.streaming.v1.TimeRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {palexy.streaming.v1.ITimeRange} message TimeRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TimeRange} TimeRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TimeRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startSecondOfDay = reader.int32();
                                break;
                            case 2:
                                message.endSecondOfDay = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TimeRange} TimeRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeRange message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startSecondOfDay != null && message.hasOwnProperty("startSecondOfDay"))
                            if (!$util.isInteger(message.startSecondOfDay))
                                return "startSecondOfDay: integer expected";
                        if (message.endSecondOfDay != null && message.hasOwnProperty("endSecondOfDay"))
                            if (!$util.isInteger(message.endSecondOfDay))
                                return "endSecondOfDay: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TimeRange} TimeRange
                     */
                    TimeRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TimeRange)
                            return object;
                        var message = new $root.palexy.streaming.v1.TimeRange();
                        if (object.startSecondOfDay != null)
                            message.startSecondOfDay = object.startSecondOfDay | 0;
                        if (object.endSecondOfDay != null)
                            message.endSecondOfDay = object.endSecondOfDay | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TimeRange
                     * @static
                     * @param {palexy.streaming.v1.TimeRange} message TimeRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startSecondOfDay = 0;
                            object.endSecondOfDay = 0;
                        }
                        if (message.startSecondOfDay != null && message.hasOwnProperty("startSecondOfDay"))
                            object.startSecondOfDay = message.startSecondOfDay;
                        if (message.endSecondOfDay != null && message.hasOwnProperty("endSecondOfDay"))
                            object.endSecondOfDay = message.endSecondOfDay;
                        return object;
                    };
    
                    /**
                     * Converts this TimeRange to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TimeRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeRange;
                })();
    
                v1.DateTimeRange = (function() {
    
                    /**
                     * Properties of a DateTimeRange.
                     * @memberof palexy.streaming.v1
                     * @interface IDateTimeRange
                     * @property {string|null} [startDateTime] DateTimeRange startDateTime
                     * @property {string|null} [endDateTime] DateTimeRange endDateTime
                     */
    
                    /**
                     * Constructs a new DateTimeRange.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DateTimeRange.
                     * @implements IDateTimeRange
                     * @constructor
                     * @param {palexy.streaming.v1.IDateTimeRange=} [properties] Properties to set
                     */
                    function DateTimeRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DateTimeRange startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @instance
                     */
                    DateTimeRange.prototype.startDateTime = "";
    
                    /**
                     * DateTimeRange endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @instance
                     */
                    DateTimeRange.prototype.endDateTime = "";
    
                    /**
                     * Creates a new DateTimeRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {palexy.streaming.v1.IDateTimeRange=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DateTimeRange} DateTimeRange instance
                     */
                    DateTimeRange.create = function create(properties) {
                        return new DateTimeRange(properties);
                    };
    
                    /**
                     * Encodes the specified DateTimeRange message. Does not implicitly {@link palexy.streaming.v1.DateTimeRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {palexy.streaming.v1.IDateTimeRange} message DateTimeRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateTimeRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endDateTime);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DateTimeRange message, length delimited. Does not implicitly {@link palexy.streaming.v1.DateTimeRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {palexy.streaming.v1.IDateTimeRange} message DateTimeRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateTimeRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DateTimeRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DateTimeRange} DateTimeRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateTimeRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DateTimeRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startDateTime = reader.string();
                                break;
                            case 2:
                                message.endDateTime = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DateTimeRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DateTimeRange} DateTimeRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateTimeRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DateTimeRange message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DateTimeRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a DateTimeRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DateTimeRange} DateTimeRange
                     */
                    DateTimeRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DateTimeRange)
                            return object;
                        var message = new $root.palexy.streaming.v1.DateTimeRange();
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DateTimeRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @static
                     * @param {palexy.streaming.v1.DateTimeRange} message DateTimeRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DateTimeRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startDateTime = "";
                            object.endDateTime = "";
                        }
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        return object;
                    };
    
                    /**
                     * Converts this DateTimeRange to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DateTimeRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DateTimeRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DateTimeRange;
                })();
    
                v1.TimeRangeList = (function() {
    
                    /**
                     * Properties of a TimeRangeList.
                     * @memberof palexy.streaming.v1
                     * @interface ITimeRangeList
                     * @property {Array.<palexy.streaming.v1.ITimeRange>|null} [timeRanges] TimeRangeList timeRanges
                     */
    
                    /**
                     * Constructs a new TimeRangeList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a TimeRangeList.
                     * @implements ITimeRangeList
                     * @constructor
                     * @param {palexy.streaming.v1.ITimeRangeList=} [properties] Properties to set
                     */
                    function TimeRangeList(properties) {
                        this.timeRanges = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeRangeList timeRanges.
                     * @member {Array.<palexy.streaming.v1.ITimeRange>} timeRanges
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @instance
                     */
                    TimeRangeList.prototype.timeRanges = $util.emptyArray;
    
                    /**
                     * Creates a new TimeRangeList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {palexy.streaming.v1.ITimeRangeList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.TimeRangeList} TimeRangeList instance
                     */
                    TimeRangeList.create = function create(properties) {
                        return new TimeRangeList(properties);
                    };
    
                    /**
                     * Encodes the specified TimeRangeList message. Does not implicitly {@link palexy.streaming.v1.TimeRangeList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {palexy.streaming.v1.ITimeRangeList} message TimeRangeList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeRangeList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.timeRanges != null && message.timeRanges.length)
                            for (var i = 0; i < message.timeRanges.length; ++i)
                                $root.palexy.streaming.v1.TimeRange.encode(message.timeRanges[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeRangeList message, length delimited. Does not implicitly {@link palexy.streaming.v1.TimeRangeList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {palexy.streaming.v1.ITimeRangeList} message TimeRangeList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeRangeList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeRangeList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.TimeRangeList} TimeRangeList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeRangeList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.TimeRangeList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.timeRanges && message.timeRanges.length))
                                    message.timeRanges = [];
                                message.timeRanges.push($root.palexy.streaming.v1.TimeRange.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeRangeList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.TimeRangeList} TimeRangeList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeRangeList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeRangeList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeRangeList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.timeRanges != null && message.hasOwnProperty("timeRanges")) {
                            if (!Array.isArray(message.timeRanges))
                                return "timeRanges: array expected";
                            for (var i = 0; i < message.timeRanges.length; ++i) {
                                var error = $root.palexy.streaming.v1.TimeRange.verify(message.timeRanges[i]);
                                if (error)
                                    return "timeRanges." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TimeRangeList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.TimeRangeList} TimeRangeList
                     */
                    TimeRangeList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.TimeRangeList)
                            return object;
                        var message = new $root.palexy.streaming.v1.TimeRangeList();
                        if (object.timeRanges) {
                            if (!Array.isArray(object.timeRanges))
                                throw TypeError(".palexy.streaming.v1.TimeRangeList.timeRanges: array expected");
                            message.timeRanges = [];
                            for (var i = 0; i < object.timeRanges.length; ++i) {
                                if (typeof object.timeRanges[i] !== "object")
                                    throw TypeError(".palexy.streaming.v1.TimeRangeList.timeRanges: object expected");
                                message.timeRanges[i] = $root.palexy.streaming.v1.TimeRange.fromObject(object.timeRanges[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeRangeList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @static
                     * @param {palexy.streaming.v1.TimeRangeList} message TimeRangeList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeRangeList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.timeRanges = [];
                        if (message.timeRanges && message.timeRanges.length) {
                            object.timeRanges = [];
                            for (var j = 0; j < message.timeRanges.length; ++j)
                                object.timeRanges[j] = $root.palexy.streaming.v1.TimeRange.toObject(message.timeRanges[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TimeRangeList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.TimeRangeList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeRangeList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeRangeList;
                })();
    
                v1.DateFilter = (function() {
    
                    /**
                     * Properties of a DateFilter.
                     * @memberof palexy.streaming.v1
                     * @interface IDateFilter
                     * @property {number|null} [daysAgo] DateFilter daysAgo
                     * @property {string|null} [dateId] DateFilter dateId
                     */
    
                    /**
                     * Constructs a new DateFilter.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a DateFilter.
                     * @implements IDateFilter
                     * @constructor
                     * @param {palexy.streaming.v1.IDateFilter=} [properties] Properties to set
                     */
                    function DateFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DateFilter daysAgo.
                     * @member {number|null|undefined} daysAgo
                     * @memberof palexy.streaming.v1.DateFilter
                     * @instance
                     */
                    DateFilter.prototype.daysAgo = null;
    
                    /**
                     * DateFilter dateId.
                     * @member {string|null|undefined} dateId
                     * @memberof palexy.streaming.v1.DateFilter
                     * @instance
                     */
                    DateFilter.prototype.dateId = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * DateFilter filterOneof.
                     * @member {"daysAgo"|"dateId"|undefined} filterOneof
                     * @memberof palexy.streaming.v1.DateFilter
                     * @instance
                     */
                    Object.defineProperty(DateFilter.prototype, "filterOneof", {
                        get: $util.oneOfGetter($oneOfFields = ["daysAgo", "dateId"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new DateFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {palexy.streaming.v1.IDateFilter=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.DateFilter} DateFilter instance
                     */
                    DateFilter.create = function create(properties) {
                        return new DateFilter(properties);
                    };
    
                    /**
                     * Encodes the specified DateFilter message. Does not implicitly {@link palexy.streaming.v1.DateFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {palexy.streaming.v1.IDateFilter} message DateFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.daysAgo != null && Object.hasOwnProperty.call(message, "daysAgo"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.daysAgo);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DateFilter message, length delimited. Does not implicitly {@link palexy.streaming.v1.DateFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {palexy.streaming.v1.IDateFilter} message DateFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DateFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.DateFilter} DateFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.DateFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.daysAgo = reader.int32();
                                break;
                            case 2:
                                message.dateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DateFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.DateFilter} DateFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DateFilter message.
                     * @function verify
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DateFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.daysAgo != null && message.hasOwnProperty("daysAgo")) {
                            properties.filterOneof = 1;
                            if (!$util.isInteger(message.daysAgo))
                                return "daysAgo: integer expected";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId")) {
                            if (properties.filterOneof === 1)
                                return "filterOneof: multiple values";
                            properties.filterOneof = 1;
                            if (!$util.isString(message.dateId))
                                return "dateId: string expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DateFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.DateFilter} DateFilter
                     */
                    DateFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.DateFilter)
                            return object;
                        var message = new $root.palexy.streaming.v1.DateFilter();
                        if (object.daysAgo != null)
                            message.daysAgo = object.daysAgo | 0;
                        if (object.dateId != null)
                            message.dateId = String(object.dateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DateFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.DateFilter
                     * @static
                     * @param {palexy.streaming.v1.DateFilter} message DateFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DateFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.daysAgo != null && message.hasOwnProperty("daysAgo")) {
                            object.daysAgo = message.daysAgo;
                            if (options.oneofs)
                                object.filterOneof = "daysAgo";
                        }
                        if (message.dateId != null && message.hasOwnProperty("dateId")) {
                            object.dateId = message.dateId;
                            if (options.oneofs)
                                object.filterOneof = "dateId";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this DateFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.DateFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DateFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DateFilter;
                })();
    
                v1.IdList = (function() {
    
                    /**
                     * Properties of an IdList.
                     * @memberof palexy.streaming.v1
                     * @interface IIdList
                     * @property {Array.<number>|null} [ids] IdList ids
                     */
    
                    /**
                     * Constructs a new IdList.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an IdList.
                     * @implements IIdList
                     * @constructor
                     * @param {palexy.streaming.v1.IIdList=} [properties] Properties to set
                     */
                    function IdList(properties) {
                        this.ids = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * IdList ids.
                     * @member {Array.<number>} ids
                     * @memberof palexy.streaming.v1.IdList
                     * @instance
                     */
                    IdList.prototype.ids = $util.emptyArray;
    
                    /**
                     * Creates a new IdList instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {palexy.streaming.v1.IIdList=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.IdList} IdList instance
                     */
                    IdList.create = function create(properties) {
                        return new IdList(properties);
                    };
    
                    /**
                     * Encodes the specified IdList message. Does not implicitly {@link palexy.streaming.v1.IdList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {palexy.streaming.v1.IIdList} message IdList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IdList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ids != null && message.ids.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.ids.length; ++i)
                                writer.int64(message.ids[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified IdList message, length delimited. Does not implicitly {@link palexy.streaming.v1.IdList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {palexy.streaming.v1.IIdList} message IdList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    IdList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an IdList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.IdList} IdList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IdList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.IdList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.ids && message.ids.length))
                                    message.ids = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ids.push(reader.int64());
                                } else
                                    message.ids.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an IdList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.IdList} IdList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    IdList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an IdList message.
                     * @function verify
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    IdList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ids != null && message.hasOwnProperty("ids")) {
                            if (!Array.isArray(message.ids))
                                return "ids: array expected";
                            for (var i = 0; i < message.ids.length; ++i)
                                if (!$util.isInteger(message.ids[i]) && !(message.ids[i] && $util.isInteger(message.ids[i].low) && $util.isInteger(message.ids[i].high)))
                                    return "ids: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an IdList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.IdList} IdList
                     */
                    IdList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.IdList)
                            return object;
                        var message = new $root.palexy.streaming.v1.IdList();
                        if (object.ids) {
                            if (!Array.isArray(object.ids))
                                throw TypeError(".palexy.streaming.v1.IdList.ids: array expected");
                            message.ids = [];
                            for (var i = 0; i < object.ids.length; ++i)
                                if ($util.Long)
                                    (message.ids[i] = $util.Long.fromValue(object.ids[i])).unsigned = false;
                                else if (typeof object.ids[i] === "string")
                                    message.ids[i] = parseInt(object.ids[i], 10);
                                else if (typeof object.ids[i] === "number")
                                    message.ids[i] = object.ids[i];
                                else if (typeof object.ids[i] === "object")
                                    message.ids[i] = new $util.LongBits(object.ids[i].low >>> 0, object.ids[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an IdList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.IdList
                     * @static
                     * @param {palexy.streaming.v1.IdList} message IdList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    IdList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.ids = [];
                        if (message.ids && message.ids.length) {
                            object.ids = [];
                            for (var j = 0; j < message.ids.length; ++j)
                                if (typeof message.ids[j] === "number")
                                    object.ids[j] = options.longs === String ? String(message.ids[j]) : message.ids[j];
                                else
                                    object.ids[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ids[j]) : options.longs === Number ? new $util.LongBits(message.ids[j].low >>> 0, message.ids[j].high >>> 0).toNumber() : message.ids[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this IdList to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.IdList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    IdList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return IdList;
                })();
    
                v1.ProtoPeriod = (function() {
    
                    /**
                     * Properties of a ProtoPeriod.
                     * @memberof palexy.streaming.v1
                     * @interface IProtoPeriod
                     * @property {number|null} [years] ProtoPeriod years
                     * @property {number|null} [months] ProtoPeriod months
                     * @property {number|null} [days] ProtoPeriod days
                     */
    
                    /**
                     * Constructs a new ProtoPeriod.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a ProtoPeriod.
                     * @implements IProtoPeriod
                     * @constructor
                     * @param {palexy.streaming.v1.IProtoPeriod=} [properties] Properties to set
                     */
                    function ProtoPeriod(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProtoPeriod years.
                     * @member {number} years
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @instance
                     */
                    ProtoPeriod.prototype.years = 0;
    
                    /**
                     * ProtoPeriod months.
                     * @member {number} months
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @instance
                     */
                    ProtoPeriod.prototype.months = 0;
    
                    /**
                     * ProtoPeriod days.
                     * @member {number} days
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @instance
                     */
                    ProtoPeriod.prototype.days = 0;
    
                    /**
                     * Creates a new ProtoPeriod instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {palexy.streaming.v1.IProtoPeriod=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.ProtoPeriod} ProtoPeriod instance
                     */
                    ProtoPeriod.create = function create(properties) {
                        return new ProtoPeriod(properties);
                    };
    
                    /**
                     * Encodes the specified ProtoPeriod message. Does not implicitly {@link palexy.streaming.v1.ProtoPeriod.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {palexy.streaming.v1.IProtoPeriod} message ProtoPeriod message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProtoPeriod.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.years != null && Object.hasOwnProperty.call(message, "years"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.years);
                        if (message.months != null && Object.hasOwnProperty.call(message, "months"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.months);
                        if (message.days != null && Object.hasOwnProperty.call(message, "days"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.days);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProtoPeriod message, length delimited. Does not implicitly {@link palexy.streaming.v1.ProtoPeriod.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {palexy.streaming.v1.IProtoPeriod} message ProtoPeriod message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProtoPeriod.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProtoPeriod message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.ProtoPeriod} ProtoPeriod
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProtoPeriod.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.ProtoPeriod();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.years = reader.int32();
                                break;
                            case 2:
                                message.months = reader.int32();
                                break;
                            case 3:
                                message.days = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProtoPeriod message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.ProtoPeriod} ProtoPeriod
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProtoPeriod.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProtoPeriod message.
                     * @function verify
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProtoPeriod.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.years != null && message.hasOwnProperty("years"))
                            if (!$util.isInteger(message.years))
                                return "years: integer expected";
                        if (message.months != null && message.hasOwnProperty("months"))
                            if (!$util.isInteger(message.months))
                                return "months: integer expected";
                        if (message.days != null && message.hasOwnProperty("days"))
                            if (!$util.isInteger(message.days))
                                return "days: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProtoPeriod message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.ProtoPeriod} ProtoPeriod
                     */
                    ProtoPeriod.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.ProtoPeriod)
                            return object;
                        var message = new $root.palexy.streaming.v1.ProtoPeriod();
                        if (object.years != null)
                            message.years = object.years | 0;
                        if (object.months != null)
                            message.months = object.months | 0;
                        if (object.days != null)
                            message.days = object.days | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProtoPeriod message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @static
                     * @param {palexy.streaming.v1.ProtoPeriod} message ProtoPeriod
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProtoPeriod.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.years = 0;
                            object.months = 0;
                            object.days = 0;
                        }
                        if (message.years != null && message.hasOwnProperty("years"))
                            object.years = message.years;
                        if (message.months != null && message.hasOwnProperty("months"))
                            object.months = message.months;
                        if (message.days != null && message.hasOwnProperty("days"))
                            object.days = message.days;
                        return object;
                    };
    
                    /**
                     * Converts this ProtoPeriod to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.ProtoPeriod
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProtoPeriod.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * PeriodUnit enum.
                     * @name palexy.streaming.v1.ProtoPeriod.PeriodUnit
                     * @enum {number}
                     * @property {number} UNIT_UNSPECIFIED=0 UNIT_UNSPECIFIED value
                     * @property {number} DAY=1 DAY value
                     * @property {number} MONTH=2 MONTH value
                     * @property {number} YEAR=3 YEAR value
                     */
                    ProtoPeriod.PeriodUnit = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNIT_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DAY"] = 1;
                        values[valuesById[2] = "MONTH"] = 2;
                        values[valuesById[3] = "YEAR"] = 3;
                        return values;
                    })();
    
                    return ProtoPeriod;
                })();
    
                v1.RawICARecord = (function() {
    
                    /**
                     * Properties of a RawICARecord.
                     * @memberof palexy.streaming.v1
                     * @interface IRawICARecord
                     * @property {string|null} [cameraId] RawICARecord cameraId
                     * @property {number|null} [coordinateCameraX] RawICARecord coordinateCameraX
                     * @property {number|null} [coordinateCameraY] RawICARecord coordinateCameraY
                     * @property {string|null} [recordingDateTime] RawICARecord recordingDateTime
                     * @property {number|null} [coordinateFloorX] RawICARecord coordinateFloorX
                     * @property {number|null} [coordinateFloorY] RawICARecord coordinateFloorY
                     * @property {string|null} [personId] RawICARecord personId
                     * @property {string|null} [actionType] RawICARecord actionType
                     * @property {string|null} [tileId] RawICARecord tileId
                     * @property {boolean|null} [isStaff] RawICARecord isStaff
                     * @property {string|null} [gender] RawICARecord gender
                     * @property {number|null} [ageRange] RawICARecord ageRange
                     * @property {number|null} [storeId] RawICARecord storeId
                     * @property {number|null} [areaId] RawICARecord areaId
                     * @property {number|null} [duration] RawICARecord duration
                     * @property {string|null} [customPersonType] RawICARecord customPersonType
                     * @property {number|null} [height] RawICARecord height
                     * @property {string|null} [visitorGroupId] RawICARecord visitorGroupId
                     * @property {palexy.streaming.v1.RawICARecord.VisitType|null} [visitType] RawICARecord visitType
                     * @property {palexy.streaming.v1.IVisitorDirection|null} [visitorDirection] RawICARecord visitorDirection
                     * @property {number|null} [validBbProb] RawICARecord validBbProb
                     * @property {string|null} [checkoutGroupId] RawICARecord checkoutGroupId
                     * @property {number|null} [queueLength] RawICARecord queueLength
                     * @property {palexy.streaming.v1.IBoundingBoxCoordinates|null} [boundingBoxCoordinates] RawICARecord boundingBoxCoordinates
                     * @property {string|null} [imagePath] RawICARecord imagePath
                     * @property {Array.<number>|null} [featureVector] RawICARecord featureVector
                     * @property {Array.<number>|null} [ageRangeData] RawICARecord ageRangeData
                     * @property {string|null} [recordUuid] RawICARecord recordUuid
                     */
    
                    /**
                     * Constructs a new RawICARecord.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a RawICARecord.
                     * @implements IRawICARecord
                     * @constructor
                     * @param {palexy.streaming.v1.IRawICARecord=} [properties] Properties to set
                     */
                    function RawICARecord(properties) {
                        this.featureVector = [];
                        this.ageRangeData = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RawICARecord cameraId.
                     * @member {string} cameraId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.cameraId = "";
    
                    /**
                     * RawICARecord coordinateCameraX.
                     * @member {number} coordinateCameraX
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.coordinateCameraX = 0;
    
                    /**
                     * RawICARecord coordinateCameraY.
                     * @member {number} coordinateCameraY
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.coordinateCameraY = 0;
    
                    /**
                     * RawICARecord recordingDateTime.
                     * @member {string} recordingDateTime
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.recordingDateTime = "";
    
                    /**
                     * RawICARecord coordinateFloorX.
                     * @member {number} coordinateFloorX
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.coordinateFloorX = 0;
    
                    /**
                     * RawICARecord coordinateFloorY.
                     * @member {number} coordinateFloorY
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.coordinateFloorY = 0;
    
                    /**
                     * RawICARecord personId.
                     * @member {string} personId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.personId = "";
    
                    /**
                     * RawICARecord actionType.
                     * @member {string} actionType
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.actionType = "";
    
                    /**
                     * RawICARecord tileId.
                     * @member {string} tileId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.tileId = "";
    
                    /**
                     * RawICARecord isStaff.
                     * @member {boolean} isStaff
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.isStaff = false;
    
                    /**
                     * RawICARecord gender.
                     * @member {string} gender
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.gender = "";
    
                    /**
                     * RawICARecord ageRange.
                     * @member {number} ageRange
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.ageRange = 0;
    
                    /**
                     * RawICARecord storeId.
                     * @member {number} storeId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICARecord areaId.
                     * @member {number} areaId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.areaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RawICARecord duration.
                     * @member {number} duration
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.duration = 0;
    
                    /**
                     * RawICARecord customPersonType.
                     * @member {string} customPersonType
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.customPersonType = "";
    
                    /**
                     * RawICARecord height.
                     * @member {number} height
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.height = 0;
    
                    /**
                     * RawICARecord visitorGroupId.
                     * @member {string} visitorGroupId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.visitorGroupId = "";
    
                    /**
                     * RawICARecord visitType.
                     * @member {palexy.streaming.v1.RawICARecord.VisitType} visitType
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.visitType = 0;
    
                    /**
                     * RawICARecord visitorDirection.
                     * @member {palexy.streaming.v1.IVisitorDirection|null|undefined} visitorDirection
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.visitorDirection = null;
    
                    /**
                     * RawICARecord validBbProb.
                     * @member {number} validBbProb
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.validBbProb = 0;
    
                    /**
                     * RawICARecord checkoutGroupId.
                     * @member {string} checkoutGroupId
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.checkoutGroupId = "";
    
                    /**
                     * RawICARecord queueLength.
                     * @member {number} queueLength
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.queueLength = 0;
    
                    /**
                     * RawICARecord boundingBoxCoordinates.
                     * @member {palexy.streaming.v1.IBoundingBoxCoordinates|null|undefined} boundingBoxCoordinates
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.boundingBoxCoordinates = null;
    
                    /**
                     * RawICARecord imagePath.
                     * @member {string} imagePath
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.imagePath = "";
    
                    /**
                     * RawICARecord featureVector.
                     * @member {Array.<number>} featureVector
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.featureVector = $util.emptyArray;
    
                    /**
                     * RawICARecord ageRangeData.
                     * @member {Array.<number>} ageRangeData
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.ageRangeData = $util.emptyArray;
    
                    /**
                     * RawICARecord recordUuid.
                     * @member {string} recordUuid
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     */
                    RawICARecord.prototype.recordUuid = "";
    
                    /**
                     * Creates a new RawICARecord instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICARecord=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.RawICARecord} RawICARecord instance
                     */
                    RawICARecord.create = function create(properties) {
                        return new RawICARecord(properties);
                    };
    
                    /**
                     * Encodes the specified RawICARecord message. Does not implicitly {@link palexy.streaming.v1.RawICARecord.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICARecord} message RawICARecord message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICARecord.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                        if (message.coordinateCameraX != null && Object.hasOwnProperty.call(message, "coordinateCameraX"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.coordinateCameraX);
                        if (message.coordinateCameraY != null && Object.hasOwnProperty.call(message, "coordinateCameraY"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.coordinateCameraY);
                        if (message.recordingDateTime != null && Object.hasOwnProperty.call(message, "recordingDateTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.recordingDateTime);
                        if (message.coordinateFloorX != null && Object.hasOwnProperty.call(message, "coordinateFloorX"))
                            writer.uint32(/* id 5, wireType 5 =*/45).float(message.coordinateFloorX);
                        if (message.coordinateFloorY != null && Object.hasOwnProperty.call(message, "coordinateFloorY"))
                            writer.uint32(/* id 6, wireType 5 =*/53).float(message.coordinateFloorY);
                        if (message.personId != null && Object.hasOwnProperty.call(message, "personId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.personId);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.actionType);
                        if (message.tileId != null && Object.hasOwnProperty.call(message, "tileId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.tileId);
                        if (message.isStaff != null && Object.hasOwnProperty.call(message, "isStaff"))
                            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.isStaff);
                        if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.gender);
                        if (message.ageRange != null && Object.hasOwnProperty.call(message, "ageRange"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.ageRange);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.storeId);
                        if (message.areaId != null && Object.hasOwnProperty.call(message, "areaId"))
                            writer.uint32(/* id 14, wireType 0 =*/112).int64(message.areaId);
                        if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                            writer.uint32(/* id 15, wireType 5 =*/125).float(message.duration);
                        if (message.boundingBoxCoordinates != null && Object.hasOwnProperty.call(message, "boundingBoxCoordinates"))
                            $root.palexy.streaming.v1.BoundingBoxCoordinates.encode(message.boundingBoxCoordinates, writer.uint32(/* id 16, wireType 2 =*/130).fork()).ldelim();
                        if (message.imagePath != null && Object.hasOwnProperty.call(message, "imagePath"))
                            writer.uint32(/* id 17, wireType 2 =*/138).string(message.imagePath);
                        if (message.featureVector != null && message.featureVector.length) {
                            writer.uint32(/* id 18, wireType 2 =*/146).fork();
                            for (var i = 0; i < message.featureVector.length; ++i)
                                writer.float(message.featureVector[i]);
                            writer.ldelim();
                        }
                        if (message.customPersonType != null && Object.hasOwnProperty.call(message, "customPersonType"))
                            writer.uint32(/* id 19, wireType 2 =*/154).string(message.customPersonType);
                        if (message.ageRangeData != null && message.ageRangeData.length) {
                            writer.uint32(/* id 20, wireType 2 =*/162).fork();
                            for (var i = 0; i < message.ageRangeData.length; ++i)
                                writer.float(message.ageRangeData[i]);
                            writer.ldelim();
                        }
                        if (message.recordUuid != null && Object.hasOwnProperty.call(message, "recordUuid"))
                            writer.uint32(/* id 21, wireType 2 =*/170).string(message.recordUuid);
                        if (message.height != null && Object.hasOwnProperty.call(message, "height"))
                            writer.uint32(/* id 22, wireType 0 =*/176).int32(message.height);
                        if (message.visitorGroupId != null && Object.hasOwnProperty.call(message, "visitorGroupId"))
                            writer.uint32(/* id 23, wireType 2 =*/186).string(message.visitorGroupId);
                        if (message.visitType != null && Object.hasOwnProperty.call(message, "visitType"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int32(message.visitType);
                        if (message.visitorDirection != null && Object.hasOwnProperty.call(message, "visitorDirection"))
                            $root.palexy.streaming.v1.VisitorDirection.encode(message.visitorDirection, writer.uint32(/* id 25, wireType 2 =*/202).fork()).ldelim();
                        if (message.validBbProb != null && Object.hasOwnProperty.call(message, "validBbProb"))
                            writer.uint32(/* id 26, wireType 5 =*/213).float(message.validBbProb);
                        if (message.checkoutGroupId != null && Object.hasOwnProperty.call(message, "checkoutGroupId"))
                            writer.uint32(/* id 27, wireType 2 =*/218).string(message.checkoutGroupId);
                        if (message.queueLength != null && Object.hasOwnProperty.call(message, "queueLength"))
                            writer.uint32(/* id 28, wireType 0 =*/224).int32(message.queueLength);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RawICARecord message, length delimited. Does not implicitly {@link palexy.streaming.v1.RawICARecord.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {palexy.streaming.v1.IRawICARecord} message RawICARecord message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RawICARecord.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RawICARecord message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.RawICARecord} RawICARecord
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICARecord.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.RawICARecord();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.cameraId = reader.string();
                                break;
                            case 2:
                                message.coordinateCameraX = reader.int32();
                                break;
                            case 3:
                                message.coordinateCameraY = reader.int32();
                                break;
                            case 4:
                                message.recordingDateTime = reader.string();
                                break;
                            case 5:
                                message.coordinateFloorX = reader.float();
                                break;
                            case 6:
                                message.coordinateFloorY = reader.float();
                                break;
                            case 7:
                                message.personId = reader.string();
                                break;
                            case 8:
                                message.actionType = reader.string();
                                break;
                            case 9:
                                message.tileId = reader.string();
                                break;
                            case 10:
                                message.isStaff = reader.bool();
                                break;
                            case 11:
                                message.gender = reader.string();
                                break;
                            case 12:
                                message.ageRange = reader.int32();
                                break;
                            case 13:
                                message.storeId = reader.int64();
                                break;
                            case 14:
                                message.areaId = reader.int64();
                                break;
                            case 15:
                                message.duration = reader.float();
                                break;
                            case 19:
                                message.customPersonType = reader.string();
                                break;
                            case 22:
                                message.height = reader.int32();
                                break;
                            case 23:
                                message.visitorGroupId = reader.string();
                                break;
                            case 24:
                                message.visitType = reader.int32();
                                break;
                            case 25:
                                message.visitorDirection = $root.palexy.streaming.v1.VisitorDirection.decode(reader, reader.uint32());
                                break;
                            case 26:
                                message.validBbProb = reader.float();
                                break;
                            case 27:
                                message.checkoutGroupId = reader.string();
                                break;
                            case 28:
                                message.queueLength = reader.int32();
                                break;
                            case 16:
                                message.boundingBoxCoordinates = $root.palexy.streaming.v1.BoundingBoxCoordinates.decode(reader, reader.uint32());
                                break;
                            case 17:
                                message.imagePath = reader.string();
                                break;
                            case 18:
                                if (!(message.featureVector && message.featureVector.length))
                                    message.featureVector = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.featureVector.push(reader.float());
                                } else
                                    message.featureVector.push(reader.float());
                                break;
                            case 20:
                                if (!(message.ageRangeData && message.ageRangeData.length))
                                    message.ageRangeData = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ageRangeData.push(reader.float());
                                } else
                                    message.ageRangeData.push(reader.float());
                                break;
                            case 21:
                                message.recordUuid = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RawICARecord message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.RawICARecord} RawICARecord
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RawICARecord.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RawICARecord message.
                     * @function verify
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RawICARecord.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            if (!$util.isString(message.cameraId))
                                return "cameraId: string expected";
                        if (message.coordinateCameraX != null && message.hasOwnProperty("coordinateCameraX"))
                            if (!$util.isInteger(message.coordinateCameraX))
                                return "coordinateCameraX: integer expected";
                        if (message.coordinateCameraY != null && message.hasOwnProperty("coordinateCameraY"))
                            if (!$util.isInteger(message.coordinateCameraY))
                                return "coordinateCameraY: integer expected";
                        if (message.recordingDateTime != null && message.hasOwnProperty("recordingDateTime"))
                            if (!$util.isString(message.recordingDateTime))
                                return "recordingDateTime: string expected";
                        if (message.coordinateFloorX != null && message.hasOwnProperty("coordinateFloorX"))
                            if (typeof message.coordinateFloorX !== "number")
                                return "coordinateFloorX: number expected";
                        if (message.coordinateFloorY != null && message.hasOwnProperty("coordinateFloorY"))
                            if (typeof message.coordinateFloorY !== "number")
                                return "coordinateFloorY: number expected";
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            if (!$util.isString(message.personId))
                                return "personId: string expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            if (!$util.isString(message.actionType))
                                return "actionType: string expected";
                        if (message.tileId != null && message.hasOwnProperty("tileId"))
                            if (!$util.isString(message.tileId))
                                return "tileId: string expected";
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            if (typeof message.isStaff !== "boolean")
                                return "isStaff: boolean expected";
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            if (!$util.isString(message.gender))
                                return "gender: string expected";
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            if (!$util.isInteger(message.ageRange))
                                return "ageRange: integer expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (!$util.isInteger(message.areaId) && !(message.areaId && $util.isInteger(message.areaId.low) && $util.isInteger(message.areaId.high)))
                                return "areaId: integer|Long expected";
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            if (typeof message.duration !== "number")
                                return "duration: number expected";
                        if (message.customPersonType != null && message.hasOwnProperty("customPersonType"))
                            if (!$util.isString(message.customPersonType))
                                return "customPersonType: string expected";
                        if (message.height != null && message.hasOwnProperty("height"))
                            if (!$util.isInteger(message.height))
                                return "height: integer expected";
                        if (message.visitorGroupId != null && message.hasOwnProperty("visitorGroupId"))
                            if (!$util.isString(message.visitorGroupId))
                                return "visitorGroupId: string expected";
                        if (message.visitType != null && message.hasOwnProperty("visitType"))
                            switch (message.visitType) {
                            default:
                                return "visitType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.visitorDirection != null && message.hasOwnProperty("visitorDirection")) {
                            var error = $root.palexy.streaming.v1.VisitorDirection.verify(message.visitorDirection);
                            if (error)
                                return "visitorDirection." + error;
                        }
                        if (message.validBbProb != null && message.hasOwnProperty("validBbProb"))
                            if (typeof message.validBbProb !== "number")
                                return "validBbProb: number expected";
                        if (message.checkoutGroupId != null && message.hasOwnProperty("checkoutGroupId"))
                            if (!$util.isString(message.checkoutGroupId))
                                return "checkoutGroupId: string expected";
                        if (message.queueLength != null && message.hasOwnProperty("queueLength"))
                            if (!$util.isInteger(message.queueLength))
                                return "queueLength: integer expected";
                        if (message.boundingBoxCoordinates != null && message.hasOwnProperty("boundingBoxCoordinates")) {
                            var error = $root.palexy.streaming.v1.BoundingBoxCoordinates.verify(message.boundingBoxCoordinates);
                            if (error)
                                return "boundingBoxCoordinates." + error;
                        }
                        if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                            if (!$util.isString(message.imagePath))
                                return "imagePath: string expected";
                        if (message.featureVector != null && message.hasOwnProperty("featureVector")) {
                            if (!Array.isArray(message.featureVector))
                                return "featureVector: array expected";
                            for (var i = 0; i < message.featureVector.length; ++i)
                                if (typeof message.featureVector[i] !== "number")
                                    return "featureVector: number[] expected";
                        }
                        if (message.ageRangeData != null && message.hasOwnProperty("ageRangeData")) {
                            if (!Array.isArray(message.ageRangeData))
                                return "ageRangeData: array expected";
                            for (var i = 0; i < message.ageRangeData.length; ++i)
                                if (typeof message.ageRangeData[i] !== "number")
                                    return "ageRangeData: number[] expected";
                        }
                        if (message.recordUuid != null && message.hasOwnProperty("recordUuid"))
                            if (!$util.isString(message.recordUuid))
                                return "recordUuid: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RawICARecord message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.RawICARecord} RawICARecord
                     */
                    RawICARecord.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.RawICARecord)
                            return object;
                        var message = new $root.palexy.streaming.v1.RawICARecord();
                        if (object.cameraId != null)
                            message.cameraId = String(object.cameraId);
                        if (object.coordinateCameraX != null)
                            message.coordinateCameraX = object.coordinateCameraX | 0;
                        if (object.coordinateCameraY != null)
                            message.coordinateCameraY = object.coordinateCameraY | 0;
                        if (object.recordingDateTime != null)
                            message.recordingDateTime = String(object.recordingDateTime);
                        if (object.coordinateFloorX != null)
                            message.coordinateFloorX = Number(object.coordinateFloorX);
                        if (object.coordinateFloorY != null)
                            message.coordinateFloorY = Number(object.coordinateFloorY);
                        if (object.personId != null)
                            message.personId = String(object.personId);
                        if (object.actionType != null)
                            message.actionType = String(object.actionType);
                        if (object.tileId != null)
                            message.tileId = String(object.tileId);
                        if (object.isStaff != null)
                            message.isStaff = Boolean(object.isStaff);
                        if (object.gender != null)
                            message.gender = String(object.gender);
                        if (object.ageRange != null)
                            message.ageRange = object.ageRange | 0;
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.areaId != null)
                            if ($util.Long)
                                (message.areaId = $util.Long.fromValue(object.areaId)).unsigned = false;
                            else if (typeof object.areaId === "string")
                                message.areaId = parseInt(object.areaId, 10);
                            else if (typeof object.areaId === "number")
                                message.areaId = object.areaId;
                            else if (typeof object.areaId === "object")
                                message.areaId = new $util.LongBits(object.areaId.low >>> 0, object.areaId.high >>> 0).toNumber();
                        if (object.duration != null)
                            message.duration = Number(object.duration);
                        if (object.customPersonType != null)
                            message.customPersonType = String(object.customPersonType);
                        if (object.height != null)
                            message.height = object.height | 0;
                        if (object.visitorGroupId != null)
                            message.visitorGroupId = String(object.visitorGroupId);
                        switch (object.visitType) {
                        case "UNKNOWN":
                        case 0:
                            message.visitType = 0;
                            break;
                        case "ENTRANCE":
                        case 1:
                            message.visitType = 1;
                            break;
                        case "QUEUE_TIME":
                        case 2:
                            message.visitType = 2;
                            break;
                        case "PRODUCT_SECTION":
                        case 3:
                            message.visitType = 3;
                            break;
                        }
                        if (object.visitorDirection != null) {
                            if (typeof object.visitorDirection !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICARecord.visitorDirection: object expected");
                            message.visitorDirection = $root.palexy.streaming.v1.VisitorDirection.fromObject(object.visitorDirection);
                        }
                        if (object.validBbProb != null)
                            message.validBbProb = Number(object.validBbProb);
                        if (object.checkoutGroupId != null)
                            message.checkoutGroupId = String(object.checkoutGroupId);
                        if (object.queueLength != null)
                            message.queueLength = object.queueLength | 0;
                        if (object.boundingBoxCoordinates != null) {
                            if (typeof object.boundingBoxCoordinates !== "object")
                                throw TypeError(".palexy.streaming.v1.RawICARecord.boundingBoxCoordinates: object expected");
                            message.boundingBoxCoordinates = $root.palexy.streaming.v1.BoundingBoxCoordinates.fromObject(object.boundingBoxCoordinates);
                        }
                        if (object.imagePath != null)
                            message.imagePath = String(object.imagePath);
                        if (object.featureVector) {
                            if (!Array.isArray(object.featureVector))
                                throw TypeError(".palexy.streaming.v1.RawICARecord.featureVector: array expected");
                            message.featureVector = [];
                            for (var i = 0; i < object.featureVector.length; ++i)
                                message.featureVector[i] = Number(object.featureVector[i]);
                        }
                        if (object.ageRangeData) {
                            if (!Array.isArray(object.ageRangeData))
                                throw TypeError(".palexy.streaming.v1.RawICARecord.ageRangeData: array expected");
                            message.ageRangeData = [];
                            for (var i = 0; i < object.ageRangeData.length; ++i)
                                message.ageRangeData[i] = Number(object.ageRangeData[i]);
                        }
                        if (object.recordUuid != null)
                            message.recordUuid = String(object.recordUuid);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RawICARecord message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @static
                     * @param {palexy.streaming.v1.RawICARecord} message RawICARecord
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RawICARecord.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.featureVector = [];
                            object.ageRangeData = [];
                        }
                        if (options.defaults) {
                            object.cameraId = "";
                            object.coordinateCameraX = 0;
                            object.coordinateCameraY = 0;
                            object.recordingDateTime = "";
                            object.coordinateFloorX = 0;
                            object.coordinateFloorY = 0;
                            object.personId = "";
                            object.actionType = "";
                            object.tileId = "";
                            object.isStaff = false;
                            object.gender = "";
                            object.ageRange = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.areaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.areaId = options.longs === String ? "0" : 0;
                            object.duration = 0;
                            object.boundingBoxCoordinates = null;
                            object.imagePath = "";
                            object.customPersonType = "";
                            object.recordUuid = "";
                            object.height = 0;
                            object.visitorGroupId = "";
                            object.visitType = options.enums === String ? "UNKNOWN" : 0;
                            object.visitorDirection = null;
                            object.validBbProb = 0;
                            object.checkoutGroupId = "";
                            object.queueLength = 0;
                        }
                        if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                            object.cameraId = message.cameraId;
                        if (message.coordinateCameraX != null && message.hasOwnProperty("coordinateCameraX"))
                            object.coordinateCameraX = message.coordinateCameraX;
                        if (message.coordinateCameraY != null && message.hasOwnProperty("coordinateCameraY"))
                            object.coordinateCameraY = message.coordinateCameraY;
                        if (message.recordingDateTime != null && message.hasOwnProperty("recordingDateTime"))
                            object.recordingDateTime = message.recordingDateTime;
                        if (message.coordinateFloorX != null && message.hasOwnProperty("coordinateFloorX"))
                            object.coordinateFloorX = options.json && !isFinite(message.coordinateFloorX) ? String(message.coordinateFloorX) : message.coordinateFloorX;
                        if (message.coordinateFloorY != null && message.hasOwnProperty("coordinateFloorY"))
                            object.coordinateFloorY = options.json && !isFinite(message.coordinateFloorY) ? String(message.coordinateFloorY) : message.coordinateFloorY;
                        if (message.personId != null && message.hasOwnProperty("personId"))
                            object.personId = message.personId;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = message.actionType;
                        if (message.tileId != null && message.hasOwnProperty("tileId"))
                            object.tileId = message.tileId;
                        if (message.isStaff != null && message.hasOwnProperty("isStaff"))
                            object.isStaff = message.isStaff;
                        if (message.gender != null && message.hasOwnProperty("gender"))
                            object.gender = message.gender;
                        if (message.ageRange != null && message.hasOwnProperty("ageRange"))
                            object.ageRange = message.ageRange;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.areaId != null && message.hasOwnProperty("areaId"))
                            if (typeof message.areaId === "number")
                                object.areaId = options.longs === String ? String(message.areaId) : message.areaId;
                            else
                                object.areaId = options.longs === String ? $util.Long.prototype.toString.call(message.areaId) : options.longs === Number ? new $util.LongBits(message.areaId.low >>> 0, message.areaId.high >>> 0).toNumber() : message.areaId;
                        if (message.duration != null && message.hasOwnProperty("duration"))
                            object.duration = options.json && !isFinite(message.duration) ? String(message.duration) : message.duration;
                        if (message.boundingBoxCoordinates != null && message.hasOwnProperty("boundingBoxCoordinates"))
                            object.boundingBoxCoordinates = $root.palexy.streaming.v1.BoundingBoxCoordinates.toObject(message.boundingBoxCoordinates, options);
                        if (message.imagePath != null && message.hasOwnProperty("imagePath"))
                            object.imagePath = message.imagePath;
                        if (message.featureVector && message.featureVector.length) {
                            object.featureVector = [];
                            for (var j = 0; j < message.featureVector.length; ++j)
                                object.featureVector[j] = options.json && !isFinite(message.featureVector[j]) ? String(message.featureVector[j]) : message.featureVector[j];
                        }
                        if (message.customPersonType != null && message.hasOwnProperty("customPersonType"))
                            object.customPersonType = message.customPersonType;
                        if (message.ageRangeData && message.ageRangeData.length) {
                            object.ageRangeData = [];
                            for (var j = 0; j < message.ageRangeData.length; ++j)
                                object.ageRangeData[j] = options.json && !isFinite(message.ageRangeData[j]) ? String(message.ageRangeData[j]) : message.ageRangeData[j];
                        }
                        if (message.recordUuid != null && message.hasOwnProperty("recordUuid"))
                            object.recordUuid = message.recordUuid;
                        if (message.height != null && message.hasOwnProperty("height"))
                            object.height = message.height;
                        if (message.visitorGroupId != null && message.hasOwnProperty("visitorGroupId"))
                            object.visitorGroupId = message.visitorGroupId;
                        if (message.visitType != null && message.hasOwnProperty("visitType"))
                            object.visitType = options.enums === String ? $root.palexy.streaming.v1.RawICARecord.VisitType[message.visitType] : message.visitType;
                        if (message.visitorDirection != null && message.hasOwnProperty("visitorDirection"))
                            object.visitorDirection = $root.palexy.streaming.v1.VisitorDirection.toObject(message.visitorDirection, options);
                        if (message.validBbProb != null && message.hasOwnProperty("validBbProb"))
                            object.validBbProb = options.json && !isFinite(message.validBbProb) ? String(message.validBbProb) : message.validBbProb;
                        if (message.checkoutGroupId != null && message.hasOwnProperty("checkoutGroupId"))
                            object.checkoutGroupId = message.checkoutGroupId;
                        if (message.queueLength != null && message.hasOwnProperty("queueLength"))
                            object.queueLength = message.queueLength;
                        return object;
                    };
    
                    /**
                     * Converts this RawICARecord to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.RawICARecord
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RawICARecord.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * VisitType enum.
                     * @name palexy.streaming.v1.RawICARecord.VisitType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} ENTRANCE=1 ENTRANCE value
                     * @property {number} QUEUE_TIME=2 QUEUE_TIME value
                     * @property {number} PRODUCT_SECTION=3 PRODUCT_SECTION value
                     */
                    RawICARecord.VisitType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "ENTRANCE"] = 1;
                        values[valuesById[2] = "QUEUE_TIME"] = 2;
                        values[valuesById[3] = "PRODUCT_SECTION"] = 3;
                        return values;
                    })();
    
                    return RawICARecord;
                })();
    
                v1.VisitorDirection = (function() {
    
                    /**
                     * Properties of a VisitorDirection.
                     * @memberof palexy.streaming.v1
                     * @interface IVisitorDirection
                     * @property {number|null} [bodyDirectionAngle] VisitorDirection bodyDirectionAngle
                     * @property {number|null} [bodyDirectionProb] VisitorDirection bodyDirectionProb
                     */
    
                    /**
                     * Constructs a new VisitorDirection.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a VisitorDirection.
                     * @implements IVisitorDirection
                     * @constructor
                     * @param {palexy.streaming.v1.IVisitorDirection=} [properties] Properties to set
                     */
                    function VisitorDirection(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VisitorDirection bodyDirectionAngle.
                     * @member {number} bodyDirectionAngle
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @instance
                     */
                    VisitorDirection.prototype.bodyDirectionAngle = 0;
    
                    /**
                     * VisitorDirection bodyDirectionProb.
                     * @member {number} bodyDirectionProb
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @instance
                     */
                    VisitorDirection.prototype.bodyDirectionProb = 0;
    
                    /**
                     * Creates a new VisitorDirection instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {palexy.streaming.v1.IVisitorDirection=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.VisitorDirection} VisitorDirection instance
                     */
                    VisitorDirection.create = function create(properties) {
                        return new VisitorDirection(properties);
                    };
    
                    /**
                     * Encodes the specified VisitorDirection message. Does not implicitly {@link palexy.streaming.v1.VisitorDirection.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {palexy.streaming.v1.IVisitorDirection} message VisitorDirection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VisitorDirection.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.bodyDirectionAngle != null && Object.hasOwnProperty.call(message, "bodyDirectionAngle"))
                            writer.uint32(/* id 1, wireType 5 =*/13).float(message.bodyDirectionAngle);
                        if (message.bodyDirectionProb != null && Object.hasOwnProperty.call(message, "bodyDirectionProb"))
                            writer.uint32(/* id 2, wireType 5 =*/21).float(message.bodyDirectionProb);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VisitorDirection message, length delimited. Does not implicitly {@link palexy.streaming.v1.VisitorDirection.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {palexy.streaming.v1.IVisitorDirection} message VisitorDirection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VisitorDirection.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VisitorDirection message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.VisitorDirection} VisitorDirection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VisitorDirection.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.VisitorDirection();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.bodyDirectionAngle = reader.float();
                                break;
                            case 2:
                                message.bodyDirectionProb = reader.float();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VisitorDirection message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.VisitorDirection} VisitorDirection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VisitorDirection.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VisitorDirection message.
                     * @function verify
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VisitorDirection.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.bodyDirectionAngle != null && message.hasOwnProperty("bodyDirectionAngle"))
                            if (typeof message.bodyDirectionAngle !== "number")
                                return "bodyDirectionAngle: number expected";
                        if (message.bodyDirectionProb != null && message.hasOwnProperty("bodyDirectionProb"))
                            if (typeof message.bodyDirectionProb !== "number")
                                return "bodyDirectionProb: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a VisitorDirection message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.VisitorDirection} VisitorDirection
                     */
                    VisitorDirection.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.VisitorDirection)
                            return object;
                        var message = new $root.palexy.streaming.v1.VisitorDirection();
                        if (object.bodyDirectionAngle != null)
                            message.bodyDirectionAngle = Number(object.bodyDirectionAngle);
                        if (object.bodyDirectionProb != null)
                            message.bodyDirectionProb = Number(object.bodyDirectionProb);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VisitorDirection message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @static
                     * @param {palexy.streaming.v1.VisitorDirection} message VisitorDirection
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VisitorDirection.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.bodyDirectionAngle = 0;
                            object.bodyDirectionProb = 0;
                        }
                        if (message.bodyDirectionAngle != null && message.hasOwnProperty("bodyDirectionAngle"))
                            object.bodyDirectionAngle = options.json && !isFinite(message.bodyDirectionAngle) ? String(message.bodyDirectionAngle) : message.bodyDirectionAngle;
                        if (message.bodyDirectionProb != null && message.hasOwnProperty("bodyDirectionProb"))
                            object.bodyDirectionProb = options.json && !isFinite(message.bodyDirectionProb) ? String(message.bodyDirectionProb) : message.bodyDirectionProb;
                        return object;
                    };
    
                    /**
                     * Converts this VisitorDirection to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.VisitorDirection
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VisitorDirection.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return VisitorDirection;
                })();
    
                v1.BoundingBoxCoordinates = (function() {
    
                    /**
                     * Properties of a BoundingBoxCoordinates.
                     * @memberof palexy.streaming.v1
                     * @interface IBoundingBoxCoordinates
                     * @property {number|null} [xMin] BoundingBoxCoordinates xMin
                     * @property {number|null} [xMax] BoundingBoxCoordinates xMax
                     * @property {number|null} [yMin] BoundingBoxCoordinates yMin
                     * @property {number|null} [yMax] BoundingBoxCoordinates yMax
                     */
    
                    /**
                     * Constructs a new BoundingBoxCoordinates.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents a BoundingBoxCoordinates.
                     * @implements IBoundingBoxCoordinates
                     * @constructor
                     * @param {palexy.streaming.v1.IBoundingBoxCoordinates=} [properties] Properties to set
                     */
                    function BoundingBoxCoordinates(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BoundingBoxCoordinates xMin.
                     * @member {number} xMin
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @instance
                     */
                    BoundingBoxCoordinates.prototype.xMin = 0;
    
                    /**
                     * BoundingBoxCoordinates xMax.
                     * @member {number} xMax
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @instance
                     */
                    BoundingBoxCoordinates.prototype.xMax = 0;
    
                    /**
                     * BoundingBoxCoordinates yMin.
                     * @member {number} yMin
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @instance
                     */
                    BoundingBoxCoordinates.prototype.yMin = 0;
    
                    /**
                     * BoundingBoxCoordinates yMax.
                     * @member {number} yMax
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @instance
                     */
                    BoundingBoxCoordinates.prototype.yMax = 0;
    
                    /**
                     * Creates a new BoundingBoxCoordinates instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {palexy.streaming.v1.IBoundingBoxCoordinates=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.BoundingBoxCoordinates} BoundingBoxCoordinates instance
                     */
                    BoundingBoxCoordinates.create = function create(properties) {
                        return new BoundingBoxCoordinates(properties);
                    };
    
                    /**
                     * Encodes the specified BoundingBoxCoordinates message. Does not implicitly {@link palexy.streaming.v1.BoundingBoxCoordinates.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {palexy.streaming.v1.IBoundingBoxCoordinates} message BoundingBoxCoordinates message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoundingBoxCoordinates.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.xMin != null && Object.hasOwnProperty.call(message, "xMin"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.xMin);
                        if (message.xMax != null && Object.hasOwnProperty.call(message, "xMax"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.xMax);
                        if (message.yMin != null && Object.hasOwnProperty.call(message, "yMin"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.yMin);
                        if (message.yMax != null && Object.hasOwnProperty.call(message, "yMax"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.yMax);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BoundingBoxCoordinates message, length delimited. Does not implicitly {@link palexy.streaming.v1.BoundingBoxCoordinates.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {palexy.streaming.v1.IBoundingBoxCoordinates} message BoundingBoxCoordinates message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BoundingBoxCoordinates.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BoundingBoxCoordinates message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.BoundingBoxCoordinates} BoundingBoxCoordinates
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoundingBoxCoordinates.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.BoundingBoxCoordinates();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.xMin = reader.int32();
                                break;
                            case 2:
                                message.xMax = reader.int32();
                                break;
                            case 3:
                                message.yMin = reader.int32();
                                break;
                            case 4:
                                message.yMax = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BoundingBoxCoordinates message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.BoundingBoxCoordinates} BoundingBoxCoordinates
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BoundingBoxCoordinates.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BoundingBoxCoordinates message.
                     * @function verify
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BoundingBoxCoordinates.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.xMin != null && message.hasOwnProperty("xMin"))
                            if (!$util.isInteger(message.xMin))
                                return "xMin: integer expected";
                        if (message.xMax != null && message.hasOwnProperty("xMax"))
                            if (!$util.isInteger(message.xMax))
                                return "xMax: integer expected";
                        if (message.yMin != null && message.hasOwnProperty("yMin"))
                            if (!$util.isInteger(message.yMin))
                                return "yMin: integer expected";
                        if (message.yMax != null && message.hasOwnProperty("yMax"))
                            if (!$util.isInteger(message.yMax))
                                return "yMax: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a BoundingBoxCoordinates message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.BoundingBoxCoordinates} BoundingBoxCoordinates
                     */
                    BoundingBoxCoordinates.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.BoundingBoxCoordinates)
                            return object;
                        var message = new $root.palexy.streaming.v1.BoundingBoxCoordinates();
                        if (object.xMin != null)
                            message.xMin = object.xMin | 0;
                        if (object.xMax != null)
                            message.xMax = object.xMax | 0;
                        if (object.yMin != null)
                            message.yMin = object.yMin | 0;
                        if (object.yMax != null)
                            message.yMax = object.yMax | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BoundingBoxCoordinates message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @static
                     * @param {palexy.streaming.v1.BoundingBoxCoordinates} message BoundingBoxCoordinates
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BoundingBoxCoordinates.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.xMin = 0;
                            object.xMax = 0;
                            object.yMin = 0;
                            object.yMax = 0;
                        }
                        if (message.xMin != null && message.hasOwnProperty("xMin"))
                            object.xMin = message.xMin;
                        if (message.xMax != null && message.hasOwnProperty("xMax"))
                            object.xMax = message.xMax;
                        if (message.yMin != null && message.hasOwnProperty("yMin"))
                            object.yMin = message.yMin;
                        if (message.yMax != null && message.hasOwnProperty("yMax"))
                            object.yMax = message.yMax;
                        return object;
                    };
    
                    /**
                     * Converts this BoundingBoxCoordinates to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.BoundingBoxCoordinates
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BoundingBoxCoordinates.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BoundingBoxCoordinates;
                })();
    
                /**
                 * DataSource enum.
                 * @name palexy.streaming.v1.DataSource
                 * @enum {number}
                 * @property {number} DS_UNKNOWN=0 DS_UNKNOWN value
                 * @property {number} VIDEO=1 VIDEO value
                 * @property {number} POS=2 POS value
                 * @property {number} STAFFING=3 STAFFING value
                 * @property {number} FORECAST=4 FORECAST value
                 * @property {number} TARGET=5 TARGET value
                 */
                v1.DataSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "DS_UNKNOWN"] = 0;
                    values[valuesById[1] = "VIDEO"] = 1;
                    values[valuesById[2] = "POS"] = 2;
                    values[valuesById[3] = "STAFFING"] = 3;
                    values[valuesById[4] = "FORECAST"] = 4;
                    values[valuesById[5] = "TARGET"] = 5;
                    return values;
                })();
    
                /**
                 * MetricEnum enum.
                 * @name palexy.streaming.v1.MetricEnum
                 * @enum {number}
                 * @property {number} METRIC_UNKNOWN=0 METRIC_UNKNOWN value
                 * @property {number} METRIC_BUYER_TRAFFIC=1 METRIC_BUYER_TRAFFIC value
                 * @property {number} METRIC_BUYER_TRAFFIC_WITH_INTERACTION=2 METRIC_BUYER_TRAFFIC_WITH_INTERACTION value
                 * @property {number} METRIC_INTERACTION=3 METRIC_INTERACTION value
                 * @property {number} METRIC_VISIT=4 METRIC_VISIT value
                 * @property {number} METRIC_GROUP_VISIT=5 METRIC_GROUP_VISIT value
                 * @property {number} METRIC_GROUP_INTERACTION=6 METRIC_GROUP_INTERACTION value
                 * @property {number} METRIC_GROUP_BUYER_TRAFFIC=7 METRIC_GROUP_BUYER_TRAFFIC value
                 * @property {number} METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION=8 METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION value
                 * @property {number} METRIC_BUYER_RATE=9 METRIC_BUYER_RATE value
                 * @property {number} METRIC_INTERACTION_RATE=10 METRIC_INTERACTION_RATE value
                 * @property {number} METRIC_INTERACTION_TIME=11 METRIC_INTERACTION_TIME value
                 * @property {number} METRIC_INTERACTION_TIME_AVG=12 METRIC_INTERACTION_TIME_AVG value
                 * @property {number} METRIC_INTERACTION_LEVEL=13 METRIC_INTERACTION_LEVEL value
                 * @property {number} METRIC_INTERACTION_BUYER_RATE=14 METRIC_INTERACTION_BUYER_RATE value
                 * @property {number} METRIC_AVG_TIME_TO_FIRST_INTERACTION=15 METRIC_AVG_TIME_TO_FIRST_INTERACTION value
                 * @property {number} METRIC_ON_TIME_INTERACTION_RATE=16 METRIC_ON_TIME_INTERACTION_RATE value
                 * @property {number} METRIC_GROUP_BUYER_RATE=17 METRIC_GROUP_BUYER_RATE value
                 * @property {number} METRIC_GROUP_INTERACTION_RATE=18 METRIC_GROUP_INTERACTION_RATE value
                 * @property {number} METRIC_GROUP_INTERACTION_BUYER_RATE=19 METRIC_GROUP_INTERACTION_BUYER_RATE value
                 * @property {number} METRIC_LYING=20 METRIC_LYING value
                 * @property {number} METRIC_LYING_RATE=21 METRIC_LYING_RATE value
                 * @property {number} METRIC_LYING_TIME_AVG=22 METRIC_LYING_TIME_AVG value
                 * @property {number} METRIC_LYING_EXACT_ONE=23 METRIC_LYING_EXACT_ONE value
                 * @property {number} METRIC_LYING_AT_LEAST_ONE=24 METRIC_LYING_AT_LEAST_ONE value
                 * @property {number} METRIC_LYING_AT_LEAST_TWO=25 METRIC_LYING_AT_LEAST_TWO value
                 * @property {number} METRIC_DWELL_TIME=26 METRIC_DWELL_TIME value
                 * @property {number} METRIC_DWELL_TIME_AVG=27 METRIC_DWELL_TIME_AVG value
                 * @property {number} METRIC_TOTAL_GREETED_CUSTOMERS=28 METRIC_TOTAL_GREETED_CUSTOMERS value
                 * @property {number} METRIC_GREETING_RATE=29 METRIC_GREETING_RATE value
                 * @property {number} METRIC_AVG_TIME_TO_FIRST_GREETING=30 METRIC_AVG_TIME_TO_FIRST_GREETING value
                 * @property {number} METRIC_ON_TIME_GREETING_RATE=31 METRIC_ON_TIME_GREETING_RATE value
                 * @property {number} METRIC_FOOT_TRAFFIC=32 METRIC_FOOT_TRAFFIC value
                 * @property {number} METRIC_VISITOR_OCCUPANCY=33 METRIC_VISITOR_OCCUPANCY value
                 * @property {number} METRIC_TOTAL_GROUPS=34 METRIC_TOTAL_GROUPS value
                 * @property {number} METRIC_TOTAL_VISITORS_GOING_AS_GROUPS=35 METRIC_TOTAL_VISITORS_GOING_AS_GROUPS value
                 * @property {number} METRIC_GROUP_RATE=36 METRIC_GROUP_RATE value
                 * @property {number} METRIC_AVG_GROUP_SIZE=37 METRIC_AVG_GROUP_SIZE value
                 * @property {number} METRIC_TOTAL_GROUPS_WITH_KIDS=38 METRIC_TOTAL_GROUPS_WITH_KIDS value
                 * @property {number} METRIC_TOTAL_KNOWN_GROUPS=39 METRIC_TOTAL_KNOWN_GROUPS value
                 * @property {number} METRIC_GROUPS_WITH_KIDS_RATE=40 METRIC_GROUPS_WITH_KIDS_RATE value
                 * @property {number} METRIC_TOTAL_GROUPS_AND_INDIVIDUALS=41 METRIC_TOTAL_GROUPS_AND_INDIVIDUALS value
                 * @property {number} METRIC_CONVERSION_BY_OPPORTUNITIES=42 METRIC_CONVERSION_BY_OPPORTUNITIES value
                 * @property {number} METRIC_PERCENT_SECTION_VISIT=43 METRIC_PERCENT_SECTION_VISIT value
                 * @property {number} METRIC_PERCENT_SECTION_PASS_BY=44 METRIC_PERCENT_SECTION_PASS_BY value
                 * @property {number} METRIC_PASS_BY=45 METRIC_PASS_BY value
                 * @property {number} METRIC_CAPTURE_RATE=46 METRIC_CAPTURE_RATE value
                 * @property {number} METRIC_TRANSACTION=47 METRIC_TRANSACTION value
                 * @property {number} METRIC_CONVERSION_RATE=48 METRIC_CONVERSION_RATE value
                 * @property {number} METRIC_NET_SALES_AMOUNT=49 METRIC_NET_SALES_AMOUNT value
                 * @property {number} METRIC_NET_SALES_ITEMS=50 METRIC_NET_SALES_ITEMS value
                 * @property {number} METRIC_NET_SALES_CONTRIBUTION=51 METRIC_NET_SALES_CONTRIBUTION value
                 * @property {number} METRIC_NET_SALES_RANKING=52 METRIC_NET_SALES_RANKING value
                 * @property {number} METRIC_SHOPPER_YIELD=53 METRIC_SHOPPER_YIELD value
                 * @property {number} METRIC_ATV=54 METRIC_ATV value
                 * @property {number} METRIC_UPT=55 METRIC_UPT value
                 * @property {number} METRIC_UPDPS=56 METRIC_UPDPS value
                 * @property {number} METRIC_ASP=57 METRIC_ASP value
                 * @property {number} METRIC_STAFF_HOURS=58 METRIC_STAFF_HOURS value
                 * @property {number} METRIC_VISITOR_PER_STAFF_HOUR=59 METRIC_VISITOR_PER_STAFF_HOUR value
                 * @property {number} METRIC_SALES_PER_STAFF_HOUR=60 METRIC_SALES_PER_STAFF_HOUR value
                 * @property {number} METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR=61 METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR value
                 * @property {number} METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR=62 METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR value
                 * @property {number} METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR=63 METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR value
                 * @property {number} METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR=64 METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR value
                 * @property {number} METRIC_ROUNDED_STAFF_HOURS=65 METRIC_ROUNDED_STAFF_HOURS value
                 * @property {number} METRIC_STAFF_HOUR_WITH_VISITOR_COUNT=66 METRIC_STAFF_HOUR_WITH_VISITOR_COUNT value
                 * @property {number} METRIC_VISITORS_PER_SQM=67 METRIC_VISITORS_PER_SQM value
                 * @property {number} METRIC_AVG_VISITOR_PER_STORE_PER_DAY=68 METRIC_AVG_VISITOR_PER_STORE_PER_DAY value
                 * @property {number} METRIC_DAYS_WITH_VISITORS=69 METRIC_DAYS_WITH_VISITORS value
                 * @property {number} METRIC_DAYS_WITH_NET_SALES_ITEMS=70 METRIC_DAYS_WITH_NET_SALES_ITEMS value
                 * @property {number} METRIC_SALES_PER_SQM=71 METRIC_SALES_PER_SQM value
                 * @property {number} METRIC_SALES_PER_SALES_AREA_SQM=72 METRIC_SALES_PER_SALES_AREA_SQM value
                 * @property {number} METRIC_ESTIMATED_VISIT=73 METRIC_ESTIMATED_VISIT value
                 * @property {number} METRIC_ESTIMATED_PASS_BY=74 METRIC_ESTIMATED_PASS_BY value
                 * @property {number} METRIC_WALK_IN=75 METRIC_WALK_IN value
                 * @property {number} METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY=76 METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY value
                 * @property {number} METRIC_CUSTOM_ACTION_1=77 METRIC_CUSTOM_ACTION_1 value
                 * @property {number} METRIC_CUSTOM_ACTION_1_RATE=78 METRIC_CUSTOM_ACTION_1_RATE value
                 * @property {number} METRIC_CONVERTED_CUSTOM_ACTION_1_RATE=79 METRIC_CONVERTED_CUSTOM_ACTION_1_RATE value
                 * @property {number} METRIC_AVG_SALES_PER_STORE_PER_DAY=80 METRIC_AVG_SALES_PER_STORE_PER_DAY value
                 * @property {number} METRIC_STAFF_TOTAL_SERVED_VISITORS=81 METRIC_STAFF_TOTAL_SERVED_VISITORS value
                 * @property {number} METRIC_STAFF_CONVERSION_RATE=82 METRIC_STAFF_CONVERSION_RATE value
                 * @property {number} METRIC_STAFF_SALES_PER_SERVED_VISITORS=83 METRIC_STAFF_SALES_PER_SERVED_VISITORS value
                 * @property {number} METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR=84 METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR value
                 * @property {number} METRIC_STAFF_PERCENTAGE_OF_SALES=85 METRIC_STAFF_PERCENTAGE_OF_SALES value
                 * @property {number} METRIC_DAYS_WITH_SALES=86 METRIC_DAYS_WITH_SALES value
                 * @property {number} METRIC_VIDEO_GROUP_DISTRIBUTION=87 METRIC_VIDEO_GROUP_DISTRIBUTION value
                 * @property {number} METRIC_BOUNCE_RATE=88 METRIC_BOUNCE_RATE value
                 * @property {number} METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY=89 METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY value
                 * @property {number} METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS=90 METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS value
                 * @property {number} METRIC_STAFF_STORE_NET_SALES_AMOUNT=91 METRIC_STAFF_STORE_NET_SALES_AMOUNT value
                 * @property {number} METRIC_STAFF_UNIQUE_INTERACTIONS=92 METRIC_STAFF_UNIQUE_INTERACTIONS value
                 * @property {number} METRIC_STAFF_INTERACTION_RATE=93 METRIC_STAFF_INTERACTION_RATE value
                 * @property {number} METRIC_TOTAL_CHECKOUT_VISITORS=94 METRIC_TOTAL_CHECKOUT_VISITORS value
                 * @property {number} METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS=95 METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS value
                 * @property {number} METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS=96 METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS value
                 * @property {number} METRIC_AVG_CHECKOUT_TIME=97 METRIC_AVG_CHECKOUT_TIME value
                 * @property {number} METRIC_MAX_CHECKOUT_TIME=98 METRIC_MAX_CHECKOUT_TIME value
                 * @property {number} METRIC_TOTAL_CHECKOUT_OPPORTUNITIES=99 METRIC_TOTAL_CHECKOUT_OPPORTUNITIES value
                 * @property {number} METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES=100 METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES value
                 * @property {number} METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES=101 METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES value
                 * @property {number} METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES=102 METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES value
                 * @property {number} METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES=103 METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES value
                 * @property {number} METRIC_DISCOUNT_AMOUNT=104 METRIC_DISCOUNT_AMOUNT value
                 * @property {number} METRIC_DISCOUNT_RATE=105 METRIC_DISCOUNT_RATE value
                 * @property {number} METRIC_GROSS_AMOUNT=106 METRIC_GROSS_AMOUNT value
                 * @property {number} METRIC_SALES_PER_SQM_PER_DAY=107 METRIC_SALES_PER_SQM_PER_DAY value
                 * @property {number} METRIC_AVG_VISITORS_PER_SQM_PER_DAY=108 METRIC_AVG_VISITORS_PER_SQM_PER_DAY value
                 * @property {number} METRIC_STAFF_SALES_TARGET=109 METRIC_STAFF_SALES_TARGET value
                 * @property {number} METRIC_STAFF_SALES_TARGET_COMPLETION=110 METRIC_STAFF_SALES_TARGET_COMPLETION value
                 * @property {number} METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE=111 METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE value
                 * @property {number} METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE=112 METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE value
                 * @property {number} METRIC_TOTAL_IN_QUEUE_VISITORS=113 METRIC_TOTAL_IN_QUEUE_VISITORS value
                 * @property {number} METRIC_TOTAL_IN_QUEUE_ACTIONS=114 METRIC_TOTAL_IN_QUEUE_ACTIONS value
                 * @property {number} METRIC_AVERAGE_QUEUE_TIME=115 METRIC_AVERAGE_QUEUE_TIME value
                 * @property {number} METRIC_AVERAGE_QUEUE_LENGTH=116 METRIC_AVERAGE_QUEUE_LENGTH value
                 * @property {number} METRIC_TOTAL_TRANSACTION_ACTIONS=117 METRIC_TOTAL_TRANSACTION_ACTIONS value
                 * @property {number} METRIC_AVERAGE_TRANSACTION_TIME=118 METRIC_AVERAGE_TRANSACTION_TIME value
                 * @property {number} METRIC_TOTAL_PICKUP_ACTIONS=119 METRIC_TOTAL_PICKUP_ACTIONS value
                 * @property {number} METRIC_AVERAGE_ORDER_PREPARATION_TIME=120 METRIC_AVERAGE_ORDER_PREPARATION_TIME value
                 * @property {number} METRIC_AVERAGE_TOTAL_SERVICE_TIME=121 METRIC_AVERAGE_TOTAL_SERVICE_TIME value
                 * @property {number} METRIC_VISIT_TARGET=122 METRIC_VISIT_TARGET value
                 * @property {number} METRIC_VISIT_ACHIEVED=123 METRIC_VISIT_ACHIEVED value
                 * @property {number} METRIC_TRANSACTION_TARGET=124 METRIC_TRANSACTION_TARGET value
                 * @property {number} METRIC_TRANSACTION_ACHIEVED=125 METRIC_TRANSACTION_ACHIEVED value
                 * @property {number} METRIC_NET_SALES_TARGET_COMPLETION=126 METRIC_NET_SALES_TARGET_COMPLETION value
                 * @property {number} METRIC_NET_SALES_TARGET_ACHIEVED=127 METRIC_NET_SALES_TARGET_ACHIEVED value
                 * @property {number} METRIC_NET_SALES_TARGET=128 METRIC_NET_SALES_TARGET value
                 * @property {number} METRIC_CONVERSION_RATE_TARGET=129 METRIC_CONVERSION_RATE_TARGET value
                 * @property {number} METRIC_CONVERSION_RATE_TARGET_ACHIEVED=130 METRIC_CONVERSION_RATE_TARGET_ACHIEVED value
                 * @property {number} METRIC_CONVERSION_RATE_TARGET_COMPLETION=131 METRIC_CONVERSION_RATE_TARGET_COMPLETION value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE=132 METRIC_QUEUE_TIME_COMPLIANCE value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE_RATE=133 METRIC_QUEUE_TIME_COMPLIANCE_RATE value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE=134 METRIC_TRANSACTION_TIME_COMPLIANCE value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE_RATE=135 METRIC_TRANSACTION_TIME_COMPLIANCE_RATE value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE=136 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE=137 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE=138 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE=139 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE value
                 * @property {number} METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET=140 METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET value
                 * @property {number} METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED=141 METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED value
                 * @property {number} METRIC_TOTAL_PICKUP_ACTIONS_TARGET=142 METRIC_TOTAL_PICKUP_ACTIONS_TARGET value
                 * @property {number} METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED=143 METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED value
                 * @property {number} METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET=144 METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET value
                 * @property {number} METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED=145 METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED=146 METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET=147 METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED=148 METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED value
                 * @property {number} METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION=149 METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED=150 METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET=151 METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED=152 METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED value
                 * @property {number} METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION=153 METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED=154 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET=155 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED=156 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED value
                 * @property {number} METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION=157 METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED=158 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET=159 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED=160 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION=161 METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION value
                 * @property {number} METRIC_PICKUP_SAMPLE_RATE=162 METRIC_PICKUP_SAMPLE_RATE value
                 * @property {number} METRIC_SERVICE_SCORE=163 METRIC_SERVICE_SCORE value
                 * @property {number} METRIC_AVERAGE_STAFF_PER_HOUR=164 METRIC_AVERAGE_STAFF_PER_HOUR value
                 * @property {number} METRIC_ADJUSTED_VISIT=165 METRIC_ADJUSTED_VISIT value
                 * @property {number} METRIC_ADJUSTED_NET_SALES_AMOUNT=166 METRIC_ADJUSTED_NET_SALES_AMOUNT value
                 * @property {number} METRIC_ADJUSTED_NET_SALES_ITEMS=167 METRIC_ADJUSTED_NET_SALES_ITEMS value
                 * @property {number} METRIC_ADJUSTED_TRANSACTION=168 METRIC_ADJUSTED_TRANSACTION value
                 * @property {number} METRIC_ADJUSTED_CONVERSION_RATE=169 METRIC_ADJUSTED_CONVERSION_RATE value
                 * @property {number} METRIC_ADJUSTED_ATV=170 METRIC_ADJUSTED_ATV value
                 * @property {number} METRIC_ADJUSTED_UPT=171 METRIC_ADJUSTED_UPT value
                 * @property {number} METRIC_TOTAL_SERVICE_TIME=172 METRIC_TOTAL_SERVICE_TIME value
                 * @property {number} METRIC_TOTAL_SATISFIED_PREFERENCES=173 METRIC_TOTAL_SATISFIED_PREFERENCES value
                 * @property {number} METRIC_PREFERENCE_SATISFACTION_RATE=174 METRIC_PREFERENCE_SATISFACTION_RATE value
                 * @property {number} METRIC_TOTAL_HUMAN_GENERATED_SHIFTS=175 METRIC_TOTAL_HUMAN_GENERATED_SHIFTS value
                 * @property {number} METRIC_TOTAL_AUTO_GENERATED_SHIFTS=176 METRIC_TOTAL_AUTO_GENERATED_SHIFTS value
                 * @property {number} METRIC_TOTAL_ADJUSTED_SHIFTS=177 METRIC_TOTAL_ADJUSTED_SHIFTS value
                 * @property {number} METRIC_HUMAN_GENERATED_SHIFTS_RATE=178 METRIC_HUMAN_GENERATED_SHIFTS_RATE value
                 * @property {number} METRIC_AUTO_GENERATED_SHIFTS_RATE=179 METRIC_AUTO_GENERATED_SHIFTS_RATE value
                 * @property {number} METRIC_ADJUSTED_SHIFTS_RATE=180 METRIC_ADJUSTED_SHIFTS_RATE value
                 * @property {number} METRIC_TOTAL_HOURS_WITH_WORKLOAD=181 METRIC_TOTAL_HOURS_WITH_WORKLOAD value
                 * @property {number} METRIC_TOTAL_COVERED_HOURS=182 METRIC_TOTAL_COVERED_HOURS value
                 * @property {number} METRIC_TOTAL_UNDERSTAFFED_HOURS=183 METRIC_TOTAL_UNDERSTAFFED_HOURS value
                 * @property {number} METRIC_DEMAND_COVERAGE_RATE=184 METRIC_DEMAND_COVERAGE_RATE value
                 * @property {number} METRIC_SCHEDULE_NON_COMPLIANCE_COUNT=185 METRIC_SCHEDULE_NON_COMPLIANCE_COUNT value
                 * @property {number} METRIC_SCHEDULE_COMPLIANCE_RATE=186 METRIC_SCHEDULE_COMPLIANCE_RATE value
                 * @property {number} METRIC_SCHEDULE_LABOR_COST_RATE=187 METRIC_SCHEDULE_LABOR_COST_RATE value
                 * @property {number} METRIC_SCHEDULE_LABOR_COST=188 METRIC_SCHEDULE_LABOR_COST value
                 * @property {number} METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE=189 METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE value
                 * @property {number} METRIC_MIX_SCHEDULE_LABOR_COST_RATE=190 METRIC_MIX_SCHEDULE_LABOR_COST_RATE value
                 * @property {number} METRIC_GROSS_SCHEDULED_STAFF_HOUR=191 METRIC_GROSS_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_SCHEDULED_STAFF_HOUR=192 METRIC_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS=193 METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS value
                 * @property {number} METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR=194 METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR=195 METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR=196 METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR=197 METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR=198 METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR=199 METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_NET_SALES_ITEMS_CONTRIBUTION=200 METRIC_NET_SALES_ITEMS_CONTRIBUTION value
                 * @property {number} METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR=201 METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR=202 METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR=203 METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR=204 METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR value
                 * @property {number} METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR=205 METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR value
                 * @property {number} METRIC_SERVICE_COVERAGE_RATE=206 METRIC_SERVICE_COVERAGE_RATE value
                 * @property {number} METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE=207 METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE value
                 * @property {number} METRIC_CHECKOUT_VISITORS_BY_BUCKET=208 METRIC_CHECKOUT_VISITORS_BY_BUCKET value
                 * @property {number} METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS=209 METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS value
                 * @property {number} METRIC_SCHEDULE_OVER_BUDGET_RATE=210 METRIC_SCHEDULE_OVER_BUDGET_RATE value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS=211 METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS=212 METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_PAID_HOURS=213 METRIC_ATTENDANCE_TOTAL_PAID_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS=214 METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_RECORDS=215 METRIC_ATTENDANCE_TOTAL_RECORDS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS=216 METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS=217 METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS=218 METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS=219 METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN=220 METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT=221 METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_ABSENTEE=222 METRIC_ATTENDANCE_TOTAL_ABSENTEE value
                 * @property {number} METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE=223 METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE value
                 * @property {number} METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE=224 METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE value
                 * @property {number} METRIC_ATTENDANCE_ABSENT_RATE=225 METRIC_ATTENDANCE_ABSENT_RATE value
                 * @property {number} METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE=226 METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE value
                 * @property {number} METRIC_ATTENDANCE_REVIEWING_PROGRESS=227 METRIC_ATTENDANCE_REVIEWING_PROGRESS value
                 * @property {number} METRIC_ATTENDANCE_SCHEDULE_VARIANCE=228 METRIC_ATTENDANCE_SCHEDULE_VARIANCE value
                 * @property {number} METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE=229 METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE value
                 * @property {number} METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR=230 METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR value
                 * @property {number} METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR=231 METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR=232 METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR value
                 * @property {number} METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR=233 METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR value
                 * @property {number} METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR=234 METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR value
                 * @property {number} METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR=235 METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_WORKING_HOURS=236 METRIC_ATTENDANCE_TOTAL_WORKING_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS=237 METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS=238 METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS value
                 * @property {number} METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS=239 METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS value
                 * @property {number} METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY=240 METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY value
                 */
                v1.MetricEnum = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "METRIC_UNKNOWN"] = 0;
                    values[valuesById[1] = "METRIC_BUYER_TRAFFIC"] = 1;
                    values[valuesById[2] = "METRIC_BUYER_TRAFFIC_WITH_INTERACTION"] = 2;
                    values[valuesById[3] = "METRIC_INTERACTION"] = 3;
                    values[valuesById[4] = "METRIC_VISIT"] = 4;
                    values[valuesById[5] = "METRIC_GROUP_VISIT"] = 5;
                    values[valuesById[6] = "METRIC_GROUP_INTERACTION"] = 6;
                    values[valuesById[7] = "METRIC_GROUP_BUYER_TRAFFIC"] = 7;
                    values[valuesById[8] = "METRIC_GROUP_BUYER_TRAFFIC_WITH_INTERACTION"] = 8;
                    values[valuesById[9] = "METRIC_BUYER_RATE"] = 9;
                    values[valuesById[10] = "METRIC_INTERACTION_RATE"] = 10;
                    values[valuesById[11] = "METRIC_INTERACTION_TIME"] = 11;
                    values[valuesById[12] = "METRIC_INTERACTION_TIME_AVG"] = 12;
                    values[valuesById[13] = "METRIC_INTERACTION_LEVEL"] = 13;
                    values[valuesById[14] = "METRIC_INTERACTION_BUYER_RATE"] = 14;
                    values[valuesById[15] = "METRIC_AVG_TIME_TO_FIRST_INTERACTION"] = 15;
                    values[valuesById[16] = "METRIC_ON_TIME_INTERACTION_RATE"] = 16;
                    values[valuesById[17] = "METRIC_GROUP_BUYER_RATE"] = 17;
                    values[valuesById[18] = "METRIC_GROUP_INTERACTION_RATE"] = 18;
                    values[valuesById[19] = "METRIC_GROUP_INTERACTION_BUYER_RATE"] = 19;
                    values[valuesById[20] = "METRIC_LYING"] = 20;
                    values[valuesById[21] = "METRIC_LYING_RATE"] = 21;
                    values[valuesById[22] = "METRIC_LYING_TIME_AVG"] = 22;
                    values[valuesById[23] = "METRIC_LYING_EXACT_ONE"] = 23;
                    values[valuesById[24] = "METRIC_LYING_AT_LEAST_ONE"] = 24;
                    values[valuesById[25] = "METRIC_LYING_AT_LEAST_TWO"] = 25;
                    values[valuesById[26] = "METRIC_DWELL_TIME"] = 26;
                    values[valuesById[27] = "METRIC_DWELL_TIME_AVG"] = 27;
                    values[valuesById[28] = "METRIC_TOTAL_GREETED_CUSTOMERS"] = 28;
                    values[valuesById[29] = "METRIC_GREETING_RATE"] = 29;
                    values[valuesById[30] = "METRIC_AVG_TIME_TO_FIRST_GREETING"] = 30;
                    values[valuesById[31] = "METRIC_ON_TIME_GREETING_RATE"] = 31;
                    values[valuesById[32] = "METRIC_FOOT_TRAFFIC"] = 32;
                    values[valuesById[33] = "METRIC_VISITOR_OCCUPANCY"] = 33;
                    values[valuesById[34] = "METRIC_TOTAL_GROUPS"] = 34;
                    values[valuesById[35] = "METRIC_TOTAL_VISITORS_GOING_AS_GROUPS"] = 35;
                    values[valuesById[36] = "METRIC_GROUP_RATE"] = 36;
                    values[valuesById[37] = "METRIC_AVG_GROUP_SIZE"] = 37;
                    values[valuesById[38] = "METRIC_TOTAL_GROUPS_WITH_KIDS"] = 38;
                    values[valuesById[39] = "METRIC_TOTAL_KNOWN_GROUPS"] = 39;
                    values[valuesById[40] = "METRIC_GROUPS_WITH_KIDS_RATE"] = 40;
                    values[valuesById[41] = "METRIC_TOTAL_GROUPS_AND_INDIVIDUALS"] = 41;
                    values[valuesById[42] = "METRIC_CONVERSION_BY_OPPORTUNITIES"] = 42;
                    values[valuesById[43] = "METRIC_PERCENT_SECTION_VISIT"] = 43;
                    values[valuesById[44] = "METRIC_PERCENT_SECTION_PASS_BY"] = 44;
                    values[valuesById[45] = "METRIC_PASS_BY"] = 45;
                    values[valuesById[46] = "METRIC_CAPTURE_RATE"] = 46;
                    values[valuesById[47] = "METRIC_TRANSACTION"] = 47;
                    values[valuesById[48] = "METRIC_CONVERSION_RATE"] = 48;
                    values[valuesById[49] = "METRIC_NET_SALES_AMOUNT"] = 49;
                    values[valuesById[50] = "METRIC_NET_SALES_ITEMS"] = 50;
                    values[valuesById[51] = "METRIC_NET_SALES_CONTRIBUTION"] = 51;
                    values[valuesById[52] = "METRIC_NET_SALES_RANKING"] = 52;
                    values[valuesById[53] = "METRIC_SHOPPER_YIELD"] = 53;
                    values[valuesById[54] = "METRIC_ATV"] = 54;
                    values[valuesById[55] = "METRIC_UPT"] = 55;
                    values[valuesById[56] = "METRIC_UPDPS"] = 56;
                    values[valuesById[57] = "METRIC_ASP"] = 57;
                    values[valuesById[58] = "METRIC_STAFF_HOURS"] = 58;
                    values[valuesById[59] = "METRIC_VISITOR_PER_STAFF_HOUR"] = 59;
                    values[valuesById[60] = "METRIC_SALES_PER_STAFF_HOUR"] = 60;
                    values[valuesById[61] = "METRIC_AVERAGE_VISITORS_PER_STAFF_IN_HOUR"] = 61;
                    values[valuesById[62] = "METRIC_MAX_VISITORS_PER_STAFF_IN_HOUR"] = 62;
                    values[valuesById[63] = "METRIC_FORECAST_AVERAGE_VISITORS_PER_STAFF_IN_HOUR"] = 63;
                    values[valuesById[64] = "METRIC_FORECAST_MAX_VISITORS_PER_STAFF_IN_HOUR"] = 64;
                    values[valuesById[65] = "METRIC_ROUNDED_STAFF_HOURS"] = 65;
                    values[valuesById[66] = "METRIC_STAFF_HOUR_WITH_VISITOR_COUNT"] = 66;
                    values[valuesById[67] = "METRIC_VISITORS_PER_SQM"] = 67;
                    values[valuesById[68] = "METRIC_AVG_VISITOR_PER_STORE_PER_DAY"] = 68;
                    values[valuesById[69] = "METRIC_DAYS_WITH_VISITORS"] = 69;
                    values[valuesById[70] = "METRIC_DAYS_WITH_NET_SALES_ITEMS"] = 70;
                    values[valuesById[71] = "METRIC_SALES_PER_SQM"] = 71;
                    values[valuesById[72] = "METRIC_SALES_PER_SALES_AREA_SQM"] = 72;
                    values[valuesById[73] = "METRIC_ESTIMATED_VISIT"] = 73;
                    values[valuesById[74] = "METRIC_ESTIMATED_PASS_BY"] = 74;
                    values[valuesById[75] = "METRIC_WALK_IN"] = 75;
                    values[valuesById[76] = "METRIC_PERCENT_SECTION_ESTIMATED_PASS_BY"] = 76;
                    values[valuesById[77] = "METRIC_CUSTOM_ACTION_1"] = 77;
                    values[valuesById[78] = "METRIC_CUSTOM_ACTION_1_RATE"] = 78;
                    values[valuesById[79] = "METRIC_CONVERTED_CUSTOM_ACTION_1_RATE"] = 79;
                    values[valuesById[80] = "METRIC_AVG_SALES_PER_STORE_PER_DAY"] = 80;
                    values[valuesById[81] = "METRIC_STAFF_TOTAL_SERVED_VISITORS"] = 81;
                    values[valuesById[82] = "METRIC_STAFF_CONVERSION_RATE"] = 82;
                    values[valuesById[83] = "METRIC_STAFF_SALES_PER_SERVED_VISITORS"] = 83;
                    values[valuesById[84] = "METRIC_STAFF_SERVED_VISITORS_PER_STAFF_HOUR"] = 84;
                    values[valuesById[85] = "METRIC_STAFF_PERCENTAGE_OF_SALES"] = 85;
                    values[valuesById[86] = "METRIC_DAYS_WITH_SALES"] = 86;
                    values[valuesById[87] = "METRIC_VIDEO_GROUP_DISTRIBUTION"] = 87;
                    values[valuesById[88] = "METRIC_BOUNCE_RATE"] = 88;
                    values[valuesById[89] = "METRIC_AVG_MALL_VISITOR_PER_STORE_PER_DAY"] = 89;
                    values[valuesById[90] = "METRIC_TOTAL_ON_TIME_GREETED_CUSTOMERS"] = 90;
                    values[valuesById[91] = "METRIC_STAFF_STORE_NET_SALES_AMOUNT"] = 91;
                    values[valuesById[92] = "METRIC_STAFF_UNIQUE_INTERACTIONS"] = 92;
                    values[valuesById[93] = "METRIC_STAFF_INTERACTION_RATE"] = 93;
                    values[valuesById[94] = "METRIC_TOTAL_CHECKOUT_VISITORS"] = 94;
                    values[valuesById[95] = "METRIC_MAX_CONCURRENT_CHECKOUT_VISITORS"] = 95;
                    values[valuesById[96] = "METRIC_AVG_CONCURRENT_CHECKOUT_VISITORS"] = 96;
                    values[valuesById[97] = "METRIC_AVG_CHECKOUT_TIME"] = 97;
                    values[valuesById[98] = "METRIC_MAX_CHECKOUT_TIME"] = 98;
                    values[valuesById[99] = "METRIC_TOTAL_CHECKOUT_OPPORTUNITIES"] = 99;
                    values[valuesById[100] = "METRIC_MAX_CONCURRENT_CHECKOUT_OPPORTUNITIES"] = 100;
                    values[valuesById[101] = "METRIC_AVG_CONCURRENT_CHECKOUT_OPPORTUNITIES"] = 101;
                    values[valuesById[102] = "METRIC_AVG_CHECKOUT_TIME_BY_OPPORTUNITIES"] = 102;
                    values[valuesById[103] = "METRIC_MAX_CHECKOUT_TIME_BY_OPPORTUNITIES"] = 103;
                    values[valuesById[104] = "METRIC_DISCOUNT_AMOUNT"] = 104;
                    values[valuesById[105] = "METRIC_DISCOUNT_RATE"] = 105;
                    values[valuesById[106] = "METRIC_GROSS_AMOUNT"] = 106;
                    values[valuesById[107] = "METRIC_SALES_PER_SQM_PER_DAY"] = 107;
                    values[valuesById[108] = "METRIC_AVG_VISITORS_PER_SQM_PER_DAY"] = 108;
                    values[valuesById[109] = "METRIC_STAFF_SALES_TARGET"] = 109;
                    values[valuesById[110] = "METRIC_STAFF_SALES_TARGET_COMPLETION"] = 110;
                    values[valuesById[111] = "METRIC_HIGH_CONCURRENT_CHECKOUT_VISITORS_RATE"] = 111;
                    values[valuesById[112] = "METRIC_HIGH_CONCURRENT_CHECKOUT_OPPORTUNITIES_RATE"] = 112;
                    values[valuesById[113] = "METRIC_TOTAL_IN_QUEUE_VISITORS"] = 113;
                    values[valuesById[114] = "METRIC_TOTAL_IN_QUEUE_ACTIONS"] = 114;
                    values[valuesById[115] = "METRIC_AVERAGE_QUEUE_TIME"] = 115;
                    values[valuesById[116] = "METRIC_AVERAGE_QUEUE_LENGTH"] = 116;
                    values[valuesById[117] = "METRIC_TOTAL_TRANSACTION_ACTIONS"] = 117;
                    values[valuesById[118] = "METRIC_AVERAGE_TRANSACTION_TIME"] = 118;
                    values[valuesById[119] = "METRIC_TOTAL_PICKUP_ACTIONS"] = 119;
                    values[valuesById[120] = "METRIC_AVERAGE_ORDER_PREPARATION_TIME"] = 120;
                    values[valuesById[121] = "METRIC_AVERAGE_TOTAL_SERVICE_TIME"] = 121;
                    values[valuesById[122] = "METRIC_VISIT_TARGET"] = 122;
                    values[valuesById[123] = "METRIC_VISIT_ACHIEVED"] = 123;
                    values[valuesById[124] = "METRIC_TRANSACTION_TARGET"] = 124;
                    values[valuesById[125] = "METRIC_TRANSACTION_ACHIEVED"] = 125;
                    values[valuesById[126] = "METRIC_NET_SALES_TARGET_COMPLETION"] = 126;
                    values[valuesById[127] = "METRIC_NET_SALES_TARGET_ACHIEVED"] = 127;
                    values[valuesById[128] = "METRIC_NET_SALES_TARGET"] = 128;
                    values[valuesById[129] = "METRIC_CONVERSION_RATE_TARGET"] = 129;
                    values[valuesById[130] = "METRIC_CONVERSION_RATE_TARGET_ACHIEVED"] = 130;
                    values[valuesById[131] = "METRIC_CONVERSION_RATE_TARGET_COMPLETION"] = 131;
                    values[valuesById[132] = "METRIC_QUEUE_TIME_COMPLIANCE"] = 132;
                    values[valuesById[133] = "METRIC_QUEUE_TIME_COMPLIANCE_RATE"] = 133;
                    values[valuesById[134] = "METRIC_TRANSACTION_TIME_COMPLIANCE"] = 134;
                    values[valuesById[135] = "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE"] = 135;
                    values[valuesById[136] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE"] = 136;
                    values[valuesById[137] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE"] = 137;
                    values[valuesById[138] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE"] = 138;
                    values[valuesById[139] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE"] = 139;
                    values[valuesById[140] = "METRIC_TOTAL_IN_QUEUE_ACTIONS_TARGET"] = 140;
                    values[valuesById[141] = "METRIC_TOTAL_IN_QUEUE_ACTIONS_ACHIEVED"] = 141;
                    values[valuesById[142] = "METRIC_TOTAL_PICKUP_ACTIONS_TARGET"] = 142;
                    values[valuesById[143] = "METRIC_TOTAL_PICKUP_ACTIONS_ACHIEVED"] = 143;
                    values[valuesById[144] = "METRIC_TOTAL_TRANSACTION_ACTIONS_TARGET"] = 144;
                    values[valuesById[145] = "METRIC_TOTAL_TRANSACTION_ACTIONS_ACHIEVED"] = 145;
                    values[valuesById[146] = "METRIC_QUEUE_TIME_COMPLIANCE_ACHIEVED"] = 146;
                    values[valuesById[147] = "METRIC_QUEUE_TIME_COMPLIANCE_RATE_TARGET"] = 147;
                    values[valuesById[148] = "METRIC_QUEUE_TIME_COMPLIANCE_RATE_ACHIEVED"] = 148;
                    values[valuesById[149] = "METRIC_QUEUE_TIME_COMPLIANCE_RATE_COMPLETION"] = 149;
                    values[valuesById[150] = "METRIC_TRANSACTION_TIME_COMPLIANCE_ACHIEVED"] = 150;
                    values[valuesById[151] = "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_TARGET"] = 151;
                    values[valuesById[152] = "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_ACHIEVED"] = 152;
                    values[valuesById[153] = "METRIC_TRANSACTION_TIME_COMPLIANCE_RATE_COMPLETION"] = 153;
                    values[valuesById[154] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_ACHIEVED"] = 154;
                    values[valuesById[155] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_TARGET"] = 155;
                    values[valuesById[156] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_ACHIEVED"] = 156;
                    values[valuesById[157] = "METRIC_ORDER_PREPARATION_TIME_COMPLIANCE_RATE_COMPLETION"] = 157;
                    values[valuesById[158] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_ACHIEVED"] = 158;
                    values[valuesById[159] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_TARGET"] = 159;
                    values[valuesById[160] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_ACHIEVED"] = 160;
                    values[valuesById[161] = "METRIC_TOTAL_SERVICE_TIME_COMPLIANCE_RATE_COMPLETION"] = 161;
                    values[valuesById[162] = "METRIC_PICKUP_SAMPLE_RATE"] = 162;
                    values[valuesById[163] = "METRIC_SERVICE_SCORE"] = 163;
                    values[valuesById[164] = "METRIC_AVERAGE_STAFF_PER_HOUR"] = 164;
                    values[valuesById[165] = "METRIC_ADJUSTED_VISIT"] = 165;
                    values[valuesById[166] = "METRIC_ADJUSTED_NET_SALES_AMOUNT"] = 166;
                    values[valuesById[167] = "METRIC_ADJUSTED_NET_SALES_ITEMS"] = 167;
                    values[valuesById[168] = "METRIC_ADJUSTED_TRANSACTION"] = 168;
                    values[valuesById[169] = "METRIC_ADJUSTED_CONVERSION_RATE"] = 169;
                    values[valuesById[170] = "METRIC_ADJUSTED_ATV"] = 170;
                    values[valuesById[171] = "METRIC_ADJUSTED_UPT"] = 171;
                    values[valuesById[172] = "METRIC_TOTAL_SERVICE_TIME"] = 172;
                    values[valuesById[173] = "METRIC_TOTAL_SATISFIED_PREFERENCES"] = 173;
                    values[valuesById[174] = "METRIC_PREFERENCE_SATISFACTION_RATE"] = 174;
                    values[valuesById[175] = "METRIC_TOTAL_HUMAN_GENERATED_SHIFTS"] = 175;
                    values[valuesById[176] = "METRIC_TOTAL_AUTO_GENERATED_SHIFTS"] = 176;
                    values[valuesById[177] = "METRIC_TOTAL_ADJUSTED_SHIFTS"] = 177;
                    values[valuesById[178] = "METRIC_HUMAN_GENERATED_SHIFTS_RATE"] = 178;
                    values[valuesById[179] = "METRIC_AUTO_GENERATED_SHIFTS_RATE"] = 179;
                    values[valuesById[180] = "METRIC_ADJUSTED_SHIFTS_RATE"] = 180;
                    values[valuesById[181] = "METRIC_TOTAL_HOURS_WITH_WORKLOAD"] = 181;
                    values[valuesById[182] = "METRIC_TOTAL_COVERED_HOURS"] = 182;
                    values[valuesById[183] = "METRIC_TOTAL_UNDERSTAFFED_HOURS"] = 183;
                    values[valuesById[184] = "METRIC_DEMAND_COVERAGE_RATE"] = 184;
                    values[valuesById[185] = "METRIC_SCHEDULE_NON_COMPLIANCE_COUNT"] = 185;
                    values[valuesById[186] = "METRIC_SCHEDULE_COMPLIANCE_RATE"] = 186;
                    values[valuesById[187] = "METRIC_SCHEDULE_LABOR_COST_RATE"] = 187;
                    values[valuesById[188] = "METRIC_SCHEDULE_LABOR_COST"] = 188;
                    values[valuesById[189] = "METRIC_FORECAST_SCHEDULE_LABOR_COST_RATE"] = 189;
                    values[valuesById[190] = "METRIC_MIX_SCHEDULE_LABOR_COST_RATE"] = 190;
                    values[valuesById[191] = "METRIC_GROSS_SCHEDULED_STAFF_HOUR"] = 191;
                    values[valuesById[192] = "METRIC_SCHEDULED_STAFF_HOUR"] = 192;
                    values[valuesById[193] = "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS"] = 193;
                    values[valuesById[194] = "METRIC_AVG_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR"] = 194;
                    values[valuesById[195] = "METRIC_AVG_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR"] = 195;
                    values[valuesById[196] = "METRIC_AVG_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR"] = 196;
                    values[valuesById[197] = "METRIC_MIX_VISITOR_PER_SCHEDULED_STAFF_HOUR"] = 197;
                    values[valuesById[198] = "METRIC_MIX_ITEM_PER_SCHEDULED_LABOR_HOUR"] = 198;
                    values[valuesById[199] = "METRIC_MIX_TRANSACTION_PER_SCHEDULED_LABOR_HOUR"] = 199;
                    values[valuesById[200] = "METRIC_NET_SALES_ITEMS_CONTRIBUTION"] = 200;
                    values[valuesById[201] = "METRIC_VISITOR_PER_SCHEDULED_STAFF_HOUR"] = 201;
                    values[valuesById[202] = "METRIC_ITEM_PER_SCHEDULED_LABOR_HOUR"] = 202;
                    values[valuesById[203] = "METRIC_TRANSACTION_PER_SCHEDULED_LABOR_HOUR"] = 203;
                    values[valuesById[204] = "METRIC_AVERAGE_TRANSACTIONS_PER_LABOR_HOUR"] = 204;
                    values[valuesById[205] = "METRIC_AVERAGE_ITEMS_PER_LABOR_HOUR"] = 205;
                    values[valuesById[206] = "METRIC_SERVICE_COVERAGE_RATE"] = 206;
                    values[valuesById[207] = "METRIC_SCHEDULED_NON_WORKING_LABOR_HOURS_RATE"] = 207;
                    values[valuesById[208] = "METRIC_CHECKOUT_VISITORS_BY_BUCKET"] = 208;
                    values[valuesById[209] = "METRIC_SCHEDULE_BUDGET_WORKING_LABOR_HOURS"] = 209;
                    values[valuesById[210] = "METRIC_SCHEDULE_OVER_BUDGET_RATE"] = 210;
                    values[valuesById[211] = "METRIC_ATTENDANCE_TOTAL_CLOCKED_HOURS"] = 211;
                    values[valuesById[212] = "METRIC_ATTENDANCE_TOTAL_UNPAID_BREAK_HOURS"] = 212;
                    values[valuesById[213] = "METRIC_ATTENDANCE_TOTAL_PAID_HOURS"] = 213;
                    values[valuesById[214] = "METRIC_ATTENDANCE_TOTAL_PAID_TIME_OFF_HOURS"] = 214;
                    values[valuesById[215] = "METRIC_ATTENDANCE_TOTAL_RECORDS"] = 215;
                    values[valuesById[216] = "METRIC_ATTENDANCE_TOTAL_APPROVED_RECORDS"] = 216;
                    values[valuesById[217] = "METRIC_ATTENDANCE_TOTAL_PENDING_RECORDS"] = 217;
                    values[valuesById[218] = "METRIC_ATTENDANCE_TOTAL_DISCARDED_RECORDS"] = 218;
                    values[valuesById[219] = "METRIC_ATTENDANCE_TOTAL_UNSCHEDULED_RECORDS"] = 219;
                    values[valuesById[220] = "METRIC_ATTENDANCE_TOTAL_LATE_CLOCK_IN"] = 220;
                    values[valuesById[221] = "METRIC_ATTENDANCE_TOTAL_EARLY_CLOCK_OUT"] = 221;
                    values[valuesById[222] = "METRIC_ATTENDANCE_TOTAL_ABSENTEE"] = 222;
                    values[valuesById[223] = "METRIC_ATTENDANCE_LATE_CLOCK_IN_RATE"] = 223;
                    values[valuesById[224] = "METRIC_ATTENDANCE_EARLY_CLOCK_OUT_RATE"] = 224;
                    values[valuesById[225] = "METRIC_ATTENDANCE_ABSENT_RATE"] = 225;
                    values[valuesById[226] = "METRIC_ATTENDANCE_UNSCHEDULED_RECORD_RATE"] = 226;
                    values[valuesById[227] = "METRIC_ATTENDANCE_REVIEWING_PROGRESS"] = 227;
                    values[valuesById[228] = "METRIC_ATTENDANCE_SCHEDULE_VARIANCE"] = 228;
                    values[valuesById[229] = "METRIC_ATTENDANCE_SCHEDULE_OVERRUN_RATE"] = 229;
                    values[valuesById[230] = "METRIC_MIX_VISITOR_PER_PAID_SCHEDULED_STAFF_HOUR"] = 230;
                    values[valuesById[231] = "METRIC_MIX_ITEM_PER_PAID_SCHEDULED_LABOR_HOUR"] = 231;
                    values[valuesById[232] = "METRIC_MIX_TRANSACTION_PER_PAID_SCHEDULED_LABOR_HOUR"] = 232;
                    values[valuesById[233] = "METRIC_MIX_VISITOR_PER_PAID_ATTENDANCE_STAFF_HOUR"] = 233;
                    values[valuesById[234] = "METRIC_MIX_ITEM_PER_PAID_ATTENDANCE_LABOR_HOUR"] = 234;
                    values[valuesById[235] = "METRIC_MIX_TRANSACTION_PER_PAID_ATTENDANCE_LABOR_HOUR"] = 235;
                    values[valuesById[236] = "METRIC_ATTENDANCE_TOTAL_WORKING_HOURS"] = 236;
                    values[valuesById[237] = "METRIC_ATTENDANCE_TOTAL_NON_COVERAGE_HOURS"] = 237;
                    values[valuesById[238] = "METRIC_ATTENDANCE_TOTAL_NON_WORKING_HOURS"] = 238;
                    values[valuesById[239] = "METRIC_ATTENDANCE_TOTAL_APPROVED_LEAVE_RECORDS"] = 239;
                    values[valuesById[240] = "METRIC_AVG_TRANSACTIONS_PER_STORE_PER_DAY"] = 240;
                    return values;
                })();
    
                /**
                 * DayOfWeek enum.
                 * @name palexy.streaming.v1.DayOfWeek
                 * @enum {number}
                 * @property {number} DAY_OF_WEEK_UNSPECIFIED=0 DAY_OF_WEEK_UNSPECIFIED value
                 * @property {number} MONDAY=1 MONDAY value
                 * @property {number} TUESDAY=2 TUESDAY value
                 * @property {number} WEDNESDAY=3 WEDNESDAY value
                 * @property {number} THURSDAY=4 THURSDAY value
                 * @property {number} FRIDAY=5 FRIDAY value
                 * @property {number} SATURDAY=6 SATURDAY value
                 * @property {number} SUNDAY=7 SUNDAY value
                 */
                v1.DayOfWeek = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "DAY_OF_WEEK_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "MONDAY"] = 1;
                    values[valuesById[2] = "TUESDAY"] = 2;
                    values[valuesById[3] = "WEDNESDAY"] = 3;
                    values[valuesById[4] = "THURSDAY"] = 4;
                    values[valuesById[5] = "FRIDAY"] = 5;
                    values[valuesById[6] = "SATURDAY"] = 6;
                    values[valuesById[7] = "SUNDAY"] = 7;
                    return values;
                })();
    
                v1.AsyncJobStatusSummary = (function() {
    
                    /**
                     * Properties of an AsyncJobStatusSummary.
                     * @memberof palexy.streaming.v1
                     * @interface IAsyncJobStatusSummary
                     * @property {string|null} [jobType] AsyncJobStatusSummary jobType
                     * @property {number|null} [ongoingJobCount] AsyncJobStatusSummary ongoingJobCount
                     * @property {number|null} [lastRecurringTimeMs] AsyncJobStatusSummary lastRecurringTimeMs
                     */
    
                    /**
                     * Constructs a new AsyncJobStatusSummary.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an AsyncJobStatusSummary.
                     * @implements IAsyncJobStatusSummary
                     * @constructor
                     * @param {palexy.streaming.v1.IAsyncJobStatusSummary=} [properties] Properties to set
                     */
                    function AsyncJobStatusSummary(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AsyncJobStatusSummary jobType.
                     * @member {string} jobType
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @instance
                     */
                    AsyncJobStatusSummary.prototype.jobType = "";
    
                    /**
                     * AsyncJobStatusSummary ongoingJobCount.
                     * @member {number} ongoingJobCount
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @instance
                     */
                    AsyncJobStatusSummary.prototype.ongoingJobCount = 0;
    
                    /**
                     * AsyncJobStatusSummary lastRecurringTimeMs.
                     * @member {number} lastRecurringTimeMs
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @instance
                     */
                    AsyncJobStatusSummary.prototype.lastRecurringTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AsyncJobStatusSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJobStatusSummary=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.AsyncJobStatusSummary} AsyncJobStatusSummary instance
                     */
                    AsyncJobStatusSummary.create = function create(properties) {
                        return new AsyncJobStatusSummary(properties);
                    };
    
                    /**
                     * Encodes the specified AsyncJobStatusSummary message. Does not implicitly {@link palexy.streaming.v1.AsyncJobStatusSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJobStatusSummary} message AsyncJobStatusSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncJobStatusSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ongoingJobCount != null && Object.hasOwnProperty.call(message, "ongoingJobCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ongoingJobCount);
                        if (message.lastRecurringTimeMs != null && Object.hasOwnProperty.call(message, "lastRecurringTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.lastRecurringTimeMs);
                        if (message.jobType != null && Object.hasOwnProperty.call(message, "jobType"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.jobType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AsyncJobStatusSummary message, length delimited. Does not implicitly {@link palexy.streaming.v1.AsyncJobStatusSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {palexy.streaming.v1.IAsyncJobStatusSummary} message AsyncJobStatusSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AsyncJobStatusSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AsyncJobStatusSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.AsyncJobStatusSummary} AsyncJobStatusSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncJobStatusSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.AsyncJobStatusSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 4:
                                message.jobType = reader.string();
                                break;
                            case 2:
                                message.ongoingJobCount = reader.int32();
                                break;
                            case 3:
                                message.lastRecurringTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AsyncJobStatusSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.AsyncJobStatusSummary} AsyncJobStatusSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AsyncJobStatusSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AsyncJobStatusSummary message.
                     * @function verify
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AsyncJobStatusSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.jobType != null && message.hasOwnProperty("jobType"))
                            if (!$util.isString(message.jobType))
                                return "jobType: string expected";
                        if (message.ongoingJobCount != null && message.hasOwnProperty("ongoingJobCount"))
                            if (!$util.isInteger(message.ongoingJobCount))
                                return "ongoingJobCount: integer expected";
                        if (message.lastRecurringTimeMs != null && message.hasOwnProperty("lastRecurringTimeMs"))
                            if (!$util.isInteger(message.lastRecurringTimeMs) && !(message.lastRecurringTimeMs && $util.isInteger(message.lastRecurringTimeMs.low) && $util.isInteger(message.lastRecurringTimeMs.high)))
                                return "lastRecurringTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AsyncJobStatusSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.AsyncJobStatusSummary} AsyncJobStatusSummary
                     */
                    AsyncJobStatusSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.AsyncJobStatusSummary)
                            return object;
                        var message = new $root.palexy.streaming.v1.AsyncJobStatusSummary();
                        if (object.jobType != null)
                            message.jobType = String(object.jobType);
                        if (object.ongoingJobCount != null)
                            message.ongoingJobCount = object.ongoingJobCount | 0;
                        if (object.lastRecurringTimeMs != null)
                            if ($util.Long)
                                (message.lastRecurringTimeMs = $util.Long.fromValue(object.lastRecurringTimeMs)).unsigned = false;
                            else if (typeof object.lastRecurringTimeMs === "string")
                                message.lastRecurringTimeMs = parseInt(object.lastRecurringTimeMs, 10);
                            else if (typeof object.lastRecurringTimeMs === "number")
                                message.lastRecurringTimeMs = object.lastRecurringTimeMs;
                            else if (typeof object.lastRecurringTimeMs === "object")
                                message.lastRecurringTimeMs = new $util.LongBits(object.lastRecurringTimeMs.low >>> 0, object.lastRecurringTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AsyncJobStatusSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @static
                     * @param {palexy.streaming.v1.AsyncJobStatusSummary} message AsyncJobStatusSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AsyncJobStatusSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.ongoingJobCount = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastRecurringTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastRecurringTimeMs = options.longs === String ? "0" : 0;
                            object.jobType = "";
                        }
                        if (message.ongoingJobCount != null && message.hasOwnProperty("ongoingJobCount"))
                            object.ongoingJobCount = message.ongoingJobCount;
                        if (message.lastRecurringTimeMs != null && message.hasOwnProperty("lastRecurringTimeMs"))
                            if (typeof message.lastRecurringTimeMs === "number")
                                object.lastRecurringTimeMs = options.longs === String ? String(message.lastRecurringTimeMs) : message.lastRecurringTimeMs;
                            else
                                object.lastRecurringTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastRecurringTimeMs) : options.longs === Number ? new $util.LongBits(message.lastRecurringTimeMs.low >>> 0, message.lastRecurringTimeMs.high >>> 0).toNumber() : message.lastRecurringTimeMs;
                        if (message.jobType != null && message.hasOwnProperty("jobType"))
                            object.jobType = message.jobType;
                        return object;
                    };
    
                    /**
                     * Converts this AsyncJobStatusSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.AsyncJobStatusSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AsyncJobStatusSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AsyncJobStatusSummary;
                })();
    
                v1.Artifact = (function() {
    
                    /**
                     * Properties of an Artifact.
                     * @memberof palexy.streaming.v1
                     * @interface IArtifact
                     * @property {palexy.streaming.v1.Artifact.ArtifactType|null} [type] Artifact type
                     * @property {palexy.streaming.v1.StorageProvider|null} [storageProvider] Artifact storageProvider
                     * @property {string|null} [description] Artifact description
                     * @property {Object.<string,string>|null} [additionalProperties] Artifact additionalProperties
                     * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [gcsFile] Artifact gcsFile
                     * @property {palexy.streaming.v1.Artifact.IGDriveFile|null} [gdriveFile] Artifact gdriveFile
                     */
    
                    /**
                     * Constructs a new Artifact.
                     * @memberof palexy.streaming.v1
                     * @classdesc Represents an Artifact.
                     * @implements IArtifact
                     * @constructor
                     * @param {palexy.streaming.v1.IArtifact=} [properties] Properties to set
                     */
                    function Artifact(properties) {
                        this.additionalProperties = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Artifact type.
                     * @member {palexy.streaming.v1.Artifact.ArtifactType} type
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.type = 0;
    
                    /**
                     * Artifact storageProvider.
                     * @member {palexy.streaming.v1.StorageProvider} storageProvider
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.storageProvider = 0;
    
                    /**
                     * Artifact description.
                     * @member {string} description
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.description = "";
    
                    /**
                     * Artifact additionalProperties.
                     * @member {Object.<string,string>} additionalProperties
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.additionalProperties = $util.emptyObject;
    
                    /**
                     * Artifact gcsFile.
                     * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} gcsFile
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.gcsFile = null;
    
                    /**
                     * Artifact gdriveFile.
                     * @member {palexy.streaming.v1.Artifact.IGDriveFile|null|undefined} gdriveFile
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Artifact.prototype.gdriveFile = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * Artifact storage.
                     * @member {"gcsFile"|"gdriveFile"|undefined} storage
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     */
                    Object.defineProperty(Artifact.prototype, "storage", {
                        get: $util.oneOfGetter($oneOfFields = ["gcsFile", "gdriveFile"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new Artifact instance using the specified properties.
                     * @function create
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {palexy.streaming.v1.IArtifact=} [properties] Properties to set
                     * @returns {palexy.streaming.v1.Artifact} Artifact instance
                     */
                    Artifact.create = function create(properties) {
                        return new Artifact(properties);
                    };
    
                    /**
                     * Encodes the specified Artifact message. Does not implicitly {@link palexy.streaming.v1.Artifact.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {palexy.streaming.v1.IArtifact} message Artifact message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Artifact.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.storageProvider != null && Object.hasOwnProperty.call(message, "storageProvider"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.storageProvider);
                        if (message.gcsFile != null && Object.hasOwnProperty.call(message, "gcsFile"))
                            $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.gcsFile, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.gdriveFile != null && Object.hasOwnProperty.call(message, "gdriveFile"))
                            $root.palexy.streaming.v1.Artifact.GDriveFile.encode(message.gdriveFile, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
                        if (message.additionalProperties != null && Object.hasOwnProperty.call(message, "additionalProperties"))
                            for (var keys = Object.keys(message.additionalProperties), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.additionalProperties[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Artifact message, length delimited. Does not implicitly {@link palexy.streaming.v1.Artifact.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {palexy.streaming.v1.IArtifact} message Artifact message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Artifact.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Artifact message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.streaming.v1.Artifact} Artifact
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Artifact.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Artifact(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.storageProvider = reader.int32();
                                break;
                            case 5:
                                message.description = reader.string();
                                break;
                            case 6:
                                if (message.additionalProperties === $util.emptyObject)
                                    message.additionalProperties = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.additionalProperties[key] = value;
                                break;
                            case 3:
                                message.gcsFile = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.gdriveFile = $root.palexy.streaming.v1.Artifact.GDriveFile.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Artifact message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.streaming.v1.Artifact} Artifact
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Artifact.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Artifact message.
                     * @function verify
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Artifact.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            switch (message.storageProvider) {
                            default:
                                return "storageProvider: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.additionalProperties != null && message.hasOwnProperty("additionalProperties")) {
                            if (!$util.isObject(message.additionalProperties))
                                return "additionalProperties: object expected";
                            var key = Object.keys(message.additionalProperties);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.additionalProperties[key[i]]))
                                    return "additionalProperties: string{k:string} expected";
                        }
                        if (message.gcsFile != null && message.hasOwnProperty("gcsFile")) {
                            properties.storage = 1;
                            {
                                var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.gcsFile);
                                if (error)
                                    return "gcsFile." + error;
                            }
                        }
                        if (message.gdriveFile != null && message.hasOwnProperty("gdriveFile")) {
                            if (properties.storage === 1)
                                return "storage: multiple values";
                            properties.storage = 1;
                            {
                                var error = $root.palexy.streaming.v1.Artifact.GDriveFile.verify(message.gdriveFile);
                                if (error)
                                    return "gdriveFile." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an Artifact message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.streaming.v1.Artifact} Artifact
                     */
                    Artifact.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.streaming.v1.Artifact)
                            return object;
                        var message = new $root.palexy.streaming.v1.Artifact();
                        switch (object.type) {
                        case "UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "IMAGE":
                        case 1:
                            message.type = 1;
                            break;
                        case "VIDEO":
                        case 2:
                            message.type = 2;
                            break;
                        case "ZIP":
                        case 3:
                            message.type = 3;
                            break;
                        }
                        switch (object.storageProvider) {
                        case "UNKNOWN_PROVIDER":
                        case 0:
                            message.storageProvider = 0;
                            break;
                        case "GCS":
                        case 1:
                            message.storageProvider = 1;
                            break;
                        case "GDRIVE":
                        case 2:
                            message.storageProvider = 2;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.additionalProperties) {
                            if (typeof object.additionalProperties !== "object")
                                throw TypeError(".palexy.streaming.v1.Artifact.additionalProperties: object expected");
                            message.additionalProperties = {};
                            for (var keys = Object.keys(object.additionalProperties), i = 0; i < keys.length; ++i)
                                message.additionalProperties[keys[i]] = String(object.additionalProperties[keys[i]]);
                        }
                        if (object.gcsFile != null) {
                            if (typeof object.gcsFile !== "object")
                                throw TypeError(".palexy.streaming.v1.Artifact.gcsFile: object expected");
                            message.gcsFile = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.gcsFile);
                        }
                        if (object.gdriveFile != null) {
                            if (typeof object.gdriveFile !== "object")
                                throw TypeError(".palexy.streaming.v1.Artifact.gdriveFile: object expected");
                            message.gdriveFile = $root.palexy.streaming.v1.Artifact.GDriveFile.fromObject(object.gdriveFile);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Artifact message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.streaming.v1.Artifact
                     * @static
                     * @param {palexy.streaming.v1.Artifact} message Artifact
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Artifact.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.additionalProperties = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNKNOWN" : 0;
                            object.storageProvider = options.enums === String ? "UNKNOWN_PROVIDER" : 0;
                            object.description = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.streaming.v1.Artifact.ArtifactType[message.type] : message.type;
                        if (message.storageProvider != null && message.hasOwnProperty("storageProvider"))
                            object.storageProvider = options.enums === String ? $root.palexy.streaming.v1.StorageProvider[message.storageProvider] : message.storageProvider;
                        if (message.gcsFile != null && message.hasOwnProperty("gcsFile")) {
                            object.gcsFile = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.gcsFile, options);
                            if (options.oneofs)
                                object.storage = "gcsFile";
                        }
                        if (message.gdriveFile != null && message.hasOwnProperty("gdriveFile")) {
                            object.gdriveFile = $root.palexy.streaming.v1.Artifact.GDriveFile.toObject(message.gdriveFile, options);
                            if (options.oneofs)
                                object.storage = "gdriveFile";
                        }
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        var keys2;
                        if (message.additionalProperties && (keys2 = Object.keys(message.additionalProperties)).length) {
                            object.additionalProperties = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.additionalProperties[keys2[j]] = message.additionalProperties[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Artifact to JSON.
                     * @function toJSON
                     * @memberof palexy.streaming.v1.Artifact
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Artifact.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ArtifactType enum.
                     * @name palexy.streaming.v1.Artifact.ArtifactType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} IMAGE=1 IMAGE value
                     * @property {number} VIDEO=2 VIDEO value
                     * @property {number} ZIP=3 ZIP value
                     */
                    Artifact.ArtifactType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "IMAGE"] = 1;
                        values[valuesById[2] = "VIDEO"] = 2;
                        values[valuesById[3] = "ZIP"] = 3;
                        return values;
                    })();
    
                    Artifact.GCSFile = (function() {
    
                        /**
                         * Properties of a GCSFile.
                         * @memberof palexy.streaming.v1.Artifact
                         * @interface IGCSFile
                         * @property {string|null} [bucket] GCSFile bucket
                         * @property {string|null} [path] GCSFile path
                         * @property {string|null} [directUrl] GCSFile directUrl
                         */
    
                        /**
                         * Constructs a new GCSFile.
                         * @memberof palexy.streaming.v1.Artifact
                         * @classdesc Represents a GCSFile.
                         * @implements IGCSFile
                         * @constructor
                         * @param {palexy.streaming.v1.Artifact.IGCSFile=} [properties] Properties to set
                         */
                        function GCSFile(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GCSFile bucket.
                         * @member {string} bucket
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @instance
                         */
                        GCSFile.prototype.bucket = "";
    
                        /**
                         * GCSFile path.
                         * @member {string} path
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @instance
                         */
                        GCSFile.prototype.path = "";
    
                        /**
                         * GCSFile directUrl.
                         * @member {string} directUrl
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @instance
                         */
                        GCSFile.prototype.directUrl = "";
    
                        /**
                         * Creates a new GCSFile instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGCSFile=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.Artifact.GCSFile} GCSFile instance
                         */
                        GCSFile.create = function create(properties) {
                            return new GCSFile(properties);
                        };
    
                        /**
                         * Encodes the specified GCSFile message. Does not implicitly {@link palexy.streaming.v1.Artifact.GCSFile.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGCSFile} message GCSFile message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GCSFile.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.bucket != null && Object.hasOwnProperty.call(message, "bucket"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.bucket);
                            if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                            if (message.directUrl != null && Object.hasOwnProperty.call(message, "directUrl"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.directUrl);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GCSFile message, length delimited. Does not implicitly {@link palexy.streaming.v1.Artifact.GCSFile.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGCSFile} message GCSFile message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GCSFile.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GCSFile message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.Artifact.GCSFile} GCSFile
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GCSFile.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Artifact.GCSFile();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.bucket = reader.string();
                                    break;
                                case 2:
                                    message.path = reader.string();
                                    break;
                                case 3:
                                    message.directUrl = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GCSFile message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.Artifact.GCSFile} GCSFile
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GCSFile.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GCSFile message.
                         * @function verify
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GCSFile.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.bucket != null && message.hasOwnProperty("bucket"))
                                if (!$util.isString(message.bucket))
                                    return "bucket: string expected";
                            if (message.path != null && message.hasOwnProperty("path"))
                                if (!$util.isString(message.path))
                                    return "path: string expected";
                            if (message.directUrl != null && message.hasOwnProperty("directUrl"))
                                if (!$util.isString(message.directUrl))
                                    return "directUrl: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a GCSFile message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.Artifact.GCSFile} GCSFile
                         */
                        GCSFile.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.Artifact.GCSFile)
                                return object;
                            var message = new $root.palexy.streaming.v1.Artifact.GCSFile();
                            if (object.bucket != null)
                                message.bucket = String(object.bucket);
                            if (object.path != null)
                                message.path = String(object.path);
                            if (object.directUrl != null)
                                message.directUrl = String(object.directUrl);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GCSFile message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.GCSFile} message GCSFile
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GCSFile.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.bucket = "";
                                object.path = "";
                                object.directUrl = "";
                            }
                            if (message.bucket != null && message.hasOwnProperty("bucket"))
                                object.bucket = message.bucket;
                            if (message.path != null && message.hasOwnProperty("path"))
                                object.path = message.path;
                            if (message.directUrl != null && message.hasOwnProperty("directUrl"))
                                object.directUrl = message.directUrl;
                            return object;
                        };
    
                        /**
                         * Converts this GCSFile to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.Artifact.GCSFile
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GCSFile.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GCSFile;
                    })();
    
                    Artifact.GDriveFile = (function() {
    
                        /**
                         * Properties of a GDriveFile.
                         * @memberof palexy.streaming.v1.Artifact
                         * @interface IGDriveFile
                         * @property {string|null} [id] GDriveFile id
                         * @property {string|null} [link] GDriveFile link
                         * @property {Array.<string>|null} [parentIds] GDriveFile parentIds
                         */
    
                        /**
                         * Constructs a new GDriveFile.
                         * @memberof palexy.streaming.v1.Artifact
                         * @classdesc Represents a GDriveFile.
                         * @implements IGDriveFile
                         * @constructor
                         * @param {palexy.streaming.v1.Artifact.IGDriveFile=} [properties] Properties to set
                         */
                        function GDriveFile(properties) {
                            this.parentIds = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GDriveFile id.
                         * @member {string} id
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @instance
                         */
                        GDriveFile.prototype.id = "";
    
                        /**
                         * GDriveFile link.
                         * @member {string} link
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @instance
                         */
                        GDriveFile.prototype.link = "";
    
                        /**
                         * GDriveFile parentIds.
                         * @member {Array.<string>} parentIds
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @instance
                         */
                        GDriveFile.prototype.parentIds = $util.emptyArray;
    
                        /**
                         * Creates a new GDriveFile instance using the specified properties.
                         * @function create
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGDriveFile=} [properties] Properties to set
                         * @returns {palexy.streaming.v1.Artifact.GDriveFile} GDriveFile instance
                         */
                        GDriveFile.create = function create(properties) {
                            return new GDriveFile(properties);
                        };
    
                        /**
                         * Encodes the specified GDriveFile message. Does not implicitly {@link palexy.streaming.v1.Artifact.GDriveFile.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGDriveFile} message GDriveFile message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GDriveFile.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                            if (message.link != null && Object.hasOwnProperty.call(message, "link"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.link);
                            if (message.parentIds != null && message.parentIds.length)
                                for (var i = 0; i < message.parentIds.length; ++i)
                                    writer.uint32(/* id 3, wireType 2 =*/26).string(message.parentIds[i]);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GDriveFile message, length delimited. Does not implicitly {@link palexy.streaming.v1.Artifact.GDriveFile.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.IGDriveFile} message GDriveFile message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GDriveFile.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GDriveFile message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.streaming.v1.Artifact.GDriveFile} GDriveFile
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GDriveFile.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.streaming.v1.Artifact.GDriveFile();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.id = reader.string();
                                    break;
                                case 2:
                                    message.link = reader.string();
                                    break;
                                case 3:
                                    if (!(message.parentIds && message.parentIds.length))
                                        message.parentIds = [];
                                    message.parentIds.push(reader.string());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GDriveFile message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.streaming.v1.Artifact.GDriveFile} GDriveFile
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GDriveFile.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GDriveFile message.
                         * @function verify
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GDriveFile.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.id != null && message.hasOwnProperty("id"))
                                if (!$util.isString(message.id))
                                    return "id: string expected";
                            if (message.link != null && message.hasOwnProperty("link"))
                                if (!$util.isString(message.link))
                                    return "link: string expected";
                            if (message.parentIds != null && message.hasOwnProperty("parentIds")) {
                                if (!Array.isArray(message.parentIds))
                                    return "parentIds: array expected";
                                for (var i = 0; i < message.parentIds.length; ++i)
                                    if (!$util.isString(message.parentIds[i]))
                                        return "parentIds: string[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a GDriveFile message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.streaming.v1.Artifact.GDriveFile} GDriveFile
                         */
                        GDriveFile.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.streaming.v1.Artifact.GDriveFile)
                                return object;
                            var message = new $root.palexy.streaming.v1.Artifact.GDriveFile();
                            if (object.id != null)
                                message.id = String(object.id);
                            if (object.link != null)
                                message.link = String(object.link);
                            if (object.parentIds) {
                                if (!Array.isArray(object.parentIds))
                                    throw TypeError(".palexy.streaming.v1.Artifact.GDriveFile.parentIds: array expected");
                                message.parentIds = [];
                                for (var i = 0; i < object.parentIds.length; ++i)
                                    message.parentIds[i] = String(object.parentIds[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GDriveFile message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @static
                         * @param {palexy.streaming.v1.Artifact.GDriveFile} message GDriveFile
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GDriveFile.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.parentIds = [];
                            if (options.defaults) {
                                object.id = "";
                                object.link = "";
                            }
                            if (message.id != null && message.hasOwnProperty("id"))
                                object.id = message.id;
                            if (message.link != null && message.hasOwnProperty("link"))
                                object.link = message.link;
                            if (message.parentIds && message.parentIds.length) {
                                object.parentIds = [];
                                for (var j = 0; j < message.parentIds.length; ++j)
                                    object.parentIds[j] = message.parentIds[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this GDriveFile to JSON.
                         * @function toJSON
                         * @memberof palexy.streaming.v1.Artifact.GDriveFile
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GDriveFile.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GDriveFile;
                    })();
    
                    return Artifact;
                })();
    
                /**
                 * StorageProvider enum.
                 * @name palexy.streaming.v1.StorageProvider
                 * @enum {number}
                 * @property {number} UNKNOWN_PROVIDER=0 UNKNOWN_PROVIDER value
                 * @property {number} GCS=1 GCS value
                 * @property {number} GDRIVE=2 GDRIVE value
                 */
                v1.StorageProvider = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_PROVIDER"] = 0;
                    values[valuesById[1] = "GCS"] = 1;
                    values[valuesById[2] = "GDRIVE"] = 2;
                    return values;
                })();
    
                /**
                 * DataType enum.
                 * @name palexy.streaming.v1.DataType
                 * @enum {number}
                 * @property {number} DATA_TYPE_UNKNOWN=0 DATA_TYPE_UNKNOWN value
                 * @property {number} TEXT=1 TEXT value
                 * @property {number} NUMERIC=2 NUMERIC value
                 */
                v1.DataType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "DATA_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "TEXT"] = 1;
                    values[valuesById[2] = "NUMERIC"] = 2;
                    return values;
                })();
    
                /**
                 * ComparisonOperator enum.
                 * @name palexy.streaming.v1.ComparisonOperator
                 * @enum {number}
                 * @property {number} UNKNOWN_COMPARISON_OPERATOR=0 UNKNOWN_COMPARISON_OPERATOR value
                 * @property {number} CONTAINS_VALUE=1 CONTAINS_VALUE value
                 * @property {number} NOT_CONTAINS_VALUE=2 NOT_CONTAINS_VALUE value
                 * @property {number} GT=3 GT value
                 */
                v1.ComparisonOperator = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_COMPARISON_OPERATOR"] = 0;
                    values[valuesById[1] = "CONTAINS_VALUE"] = 1;
                    values[valuesById[2] = "NOT_CONTAINS_VALUE"] = 2;
                    values[valuesById[3] = "GT"] = 3;
                    return values;
                })();
    
                return v1;
            })();
    
            return streaming;
        })();
    
        palexy.store_issue = (function() {
    
            /**
             * Namespace store_issue.
             * @memberof palexy
             * @namespace
             */
            var store_issue = {};
    
            store_issue.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.store_issue
                 * @namespace
                 */
                var v1 = {};
    
                v1.StoreIssue = (function() {
    
                    /**
                     * Properties of a StoreIssue.
                     * @memberof palexy.store_issue.v1
                     * @interface IStoreIssue
                     * @property {number|null} [id] StoreIssue id
                     * @property {number|null} [storeId] StoreIssue storeId
                     * @property {palexy.store_issue.v1.StoreIssueType|null} [type] StoreIssue type
                     * @property {palexy.store_issue.v1.StoreIssueState|null} [state] StoreIssue state
                     * @property {string|null} [description] StoreIssue description
                     * @property {number|null} [createTimeMs] StoreIssue createTimeMs
                     * @property {number|null} [updateTimeMs] StoreIssue updateTimeMs
                     * @property {number|null} [occurredDateId] StoreIssue occurredDateId
                     * @property {string|null} [storeName] StoreIssue storeName
                     * @property {number|null} [companyId] StoreIssue companyId
                     * @property {palexy.store_issue.v1.IStoreIssueAdvancedInfo|null} [advancedInfo] StoreIssue advancedInfo
                     */
    
                    /**
                     * Constructs a new StoreIssue.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a StoreIssue.
                     * @implements IStoreIssue
                     * @constructor
                     * @param {palexy.store_issue.v1.IStoreIssue=} [properties] Properties to set
                     */
                    function StoreIssue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreIssue id.
                     * @member {number} id
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssue storeId.
                     * @member {number} storeId
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssue type.
                     * @member {palexy.store_issue.v1.StoreIssueType} type
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.type = 0;
    
                    /**
                     * StoreIssue state.
                     * @member {palexy.store_issue.v1.StoreIssueState} state
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.state = 0;
    
                    /**
                     * StoreIssue description.
                     * @member {string} description
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.description = "";
    
                    /**
                     * StoreIssue createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssue updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssue occurredDateId.
                     * @member {number} occurredDateId
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.occurredDateId = 0;
    
                    /**
                     * StoreIssue storeName.
                     * @member {string} storeName
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.storeName = "";
    
                    /**
                     * StoreIssue companyId.
                     * @member {number} companyId
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssue advancedInfo.
                     * @member {palexy.store_issue.v1.IStoreIssueAdvancedInfo|null|undefined} advancedInfo
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     */
                    StoreIssue.prototype.advancedInfo = null;
    
                    /**
                     * Creates a new StoreIssue instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssue=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.StoreIssue} StoreIssue instance
                     */
                    StoreIssue.create = function create(properties) {
                        return new StoreIssue(properties);
                    };
    
                    /**
                     * Encodes the specified StoreIssue message. Does not implicitly {@link palexy.store_issue.v1.StoreIssue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssue} message StoreIssue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.state);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.updateTimeMs);
                        if (message.occurredDateId != null && Object.hasOwnProperty.call(message, "occurredDateId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.occurredDateId);
                        if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.storeName);
                        if (message.advancedInfo != null && Object.hasOwnProperty.call(message, "advancedInfo"))
                            $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.encode(message.advancedInfo, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreIssue message, length delimited. Does not implicitly {@link palexy.store_issue.v1.StoreIssue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssue} message StoreIssue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreIssue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.StoreIssue} StoreIssue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.StoreIssue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.storeId = reader.int64();
                                break;
                            case 3:
                                message.type = reader.int32();
                                break;
                            case 4:
                                message.state = reader.int32();
                                break;
                            case 5:
                                message.description = reader.string();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.occurredDateId = reader.int32();
                                break;
                            case 9:
                                message.storeName = reader.string();
                                break;
                            case 11:
                                message.companyId = reader.int64();
                                break;
                            case 10:
                                message.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreIssue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.StoreIssue} StoreIssue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreIssue message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreIssue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.occurredDateId != null && message.hasOwnProperty("occurredDateId"))
                            if (!$util.isInteger(message.occurredDateId))
                                return "occurredDateId: integer expected";
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            if (!$util.isString(message.storeName))
                                return "storeName: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.advancedInfo != null && message.hasOwnProperty("advancedInfo")) {
                            var error = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.verify(message.advancedInfo);
                            if (error)
                                return "advancedInfo." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreIssue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.StoreIssue} StoreIssue
                     */
                    StoreIssue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.StoreIssue)
                            return object;
                        var message = new $root.palexy.store_issue.v1.StoreIssue();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN_STORE_ISSUE_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "SECTION_CONFIG":
                        case 1:
                            message.type = 1;
                            break;
                        case "UPLOAD_VIDEOS":
                        case 2:
                            message.type = 2;
                            break;
                        case "PREPROCESSING":
                        case 3:
                            message.type = 3;
                            break;
                        case "CAMERA_VIEW_CHANGE":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        switch (object.state) {
                        case "UNKNOWN_STORE_ISSUE_STATE":
                        case 0:
                            message.state = 0;
                            break;
                        case "ACTIVE":
                        case 1:
                            message.state = 1;
                            break;
                        case "RESOLVED":
                        case 2:
                            message.state = 2;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        if (object.occurredDateId != null)
                            message.occurredDateId = object.occurredDateId | 0;
                        if (object.storeName != null)
                            message.storeName = String(object.storeName);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.advancedInfo != null) {
                            if (typeof object.advancedInfo !== "object")
                                throw TypeError(".palexy.store_issue.v1.StoreIssue.advancedInfo: object expected");
                            message.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.fromObject(object.advancedInfo);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreIssue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @static
                     * @param {palexy.store_issue.v1.StoreIssue} message StoreIssue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreIssue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN_STORE_ISSUE_TYPE" : 0;
                            object.state = options.enums === String ? "UNKNOWN_STORE_ISSUE_STATE" : 0;
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.occurredDateId = 0;
                            object.storeName = "";
                            object.advancedInfo = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueType[message.type] : message.type;
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueState[message.state] : message.state;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.occurredDateId != null && message.hasOwnProperty("occurredDateId"))
                            object.occurredDateId = message.occurredDateId;
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            object.storeName = message.storeName;
                        if (message.advancedInfo != null && message.hasOwnProperty("advancedInfo"))
                            object.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.toObject(message.advancedInfo, options);
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this StoreIssue to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.StoreIssue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreIssue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreIssue;
                })();
    
                v1.StoreIssueService = (function() {
    
                    /**
                     * Constructs a new StoreIssueService service.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a StoreIssueService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function StoreIssueService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (StoreIssueService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = StoreIssueService;
    
                    /**
                     * Creates new StoreIssueService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {StoreIssueService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    StoreIssueService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#raiseStoreIssue}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef RaiseStoreIssueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.store_issue.v1.StoreIssue} [response] StoreIssue
                     */
    
                    /**
                     * Calls RaiseStoreIssue.
                     * @function raiseStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest} request RaiseStoreIssueRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.RaiseStoreIssueCallback} callback Node-style callback called with the error, if any, and StoreIssue
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.raiseStoreIssue = function raiseStoreIssue(request, callback) {
                        return this.rpcCall(raiseStoreIssue, $root.palexy.store_issue.v1.RaiseStoreIssueRequest, $root.palexy.store_issue.v1.StoreIssue, request, callback);
                    }, "name", { value: "RaiseStoreIssue" });
    
                    /**
                     * Calls RaiseStoreIssue.
                     * @function raiseStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest} request RaiseStoreIssueRequest message or plain object
                     * @returns {Promise<palexy.store_issue.v1.StoreIssue>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#getStoreIssue}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef GetStoreIssueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.store_issue.v1.StoreIssue} [response] StoreIssue
                     */
    
                    /**
                     * Calls GetStoreIssue.
                     * @function getStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest} request GetStoreIssueRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.GetStoreIssueCallback} callback Node-style callback called with the error, if any, and StoreIssue
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.getStoreIssue = function getStoreIssue(request, callback) {
                        return this.rpcCall(getStoreIssue, $root.palexy.store_issue.v1.GetStoreIssueRequest, $root.palexy.store_issue.v1.StoreIssue, request, callback);
                    }, "name", { value: "GetStoreIssue" });
    
                    /**
                     * Calls GetStoreIssue.
                     * @function getStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest} request GetStoreIssueRequest message or plain object
                     * @returns {Promise<palexy.store_issue.v1.StoreIssue>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#listStoreIssues}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef ListStoreIssuesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.store_issue.v1.ListStoreIssuesResponse} [response] ListStoreIssuesResponse
                     */
    
                    /**
                     * Calls ListStoreIssues.
                     * @function listStoreIssues
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest} request ListStoreIssuesRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.ListStoreIssuesCallback} callback Node-style callback called with the error, if any, and ListStoreIssuesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.listStoreIssues = function listStoreIssues(request, callback) {
                        return this.rpcCall(listStoreIssues, $root.palexy.store_issue.v1.ListStoreIssuesRequest, $root.palexy.store_issue.v1.ListStoreIssuesResponse, request, callback);
                    }, "name", { value: "ListStoreIssues" });
    
                    /**
                     * Calls ListStoreIssues.
                     * @function listStoreIssues
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest} request ListStoreIssuesRequest message or plain object
                     * @returns {Promise<palexy.store_issue.v1.ListStoreIssuesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#updateStoreIssue}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef UpdateStoreIssueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.store_issue.v1.StoreIssue} [response] StoreIssue
                     */
    
                    /**
                     * Calls UpdateStoreIssue.
                     * @function updateStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest} request UpdateStoreIssueRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.UpdateStoreIssueCallback} callback Node-style callback called with the error, if any, and StoreIssue
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.updateStoreIssue = function updateStoreIssue(request, callback) {
                        return this.rpcCall(updateStoreIssue, $root.palexy.store_issue.v1.UpdateStoreIssueRequest, $root.palexy.store_issue.v1.StoreIssue, request, callback);
                    }, "name", { value: "UpdateStoreIssue" });
    
                    /**
                     * Calls UpdateStoreIssue.
                     * @function updateStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest} request UpdateStoreIssueRequest message or plain object
                     * @returns {Promise<palexy.store_issue.v1.StoreIssue>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#deleteStoreIssue}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef DeleteStoreIssueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteStoreIssue.
                     * @function deleteStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest} request DeleteStoreIssueRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.DeleteStoreIssueCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.deleteStoreIssue = function deleteStoreIssue(request, callback) {
                        return this.rpcCall(deleteStoreIssue, $root.palexy.store_issue.v1.DeleteStoreIssueRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteStoreIssue" });
    
                    /**
                     * Calls DeleteStoreIssue.
                     * @function deleteStoreIssue
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest} request DeleteStoreIssueRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.store_issue.v1.StoreIssueService#getStoreIssueReport}.
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @typedef GetStoreIssueReportCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.store_issue.v1.StoreIssueReportResponse} [response] StoreIssueReportResponse
                     */
    
                    /**
                     * Calls GetStoreIssueReport.
                     * @function getStoreIssueReport
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest} request StoreIssueReportRequest message or plain object
                     * @param {palexy.store_issue.v1.StoreIssueService.GetStoreIssueReportCallback} callback Node-style callback called with the error, if any, and StoreIssueReportResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(StoreIssueService.prototype.getStoreIssueReport = function getStoreIssueReport(request, callback) {
                        return this.rpcCall(getStoreIssueReport, $root.palexy.store_issue.v1.StoreIssueReportRequest, $root.palexy.store_issue.v1.StoreIssueReportResponse, request, callback);
                    }, "name", { value: "GetStoreIssueReport" });
    
                    /**
                     * Calls GetStoreIssueReport.
                     * @function getStoreIssueReport
                     * @memberof palexy.store_issue.v1.StoreIssueService
                     * @instance
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest} request StoreIssueReportRequest message or plain object
                     * @returns {Promise<palexy.store_issue.v1.StoreIssueReportResponse>} Promise
                     * @variation 2
                     */
    
                    return StoreIssueService;
                })();
    
                v1.DeleteStoreIssueRequest = (function() {
    
                    /**
                     * Properties of a DeleteStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IDeleteStoreIssueRequest
                     * @property {number|null} [issueId] DeleteStoreIssueRequest issueId
                     */
    
                    /**
                     * Constructs a new DeleteStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a DeleteStoreIssueRequest.
                     * @implements IDeleteStoreIssueRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest=} [properties] Properties to set
                     */
                    function DeleteStoreIssueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteStoreIssueRequest issueId.
                     * @member {number} issueId
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @instance
                     */
                    DeleteStoreIssueRequest.prototype.issueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteStoreIssueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.DeleteStoreIssueRequest} DeleteStoreIssueRequest instance
                     */
                    DeleteStoreIssueRequest.create = function create(properties) {
                        return new DeleteStoreIssueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteStoreIssueRequest message. Does not implicitly {@link palexy.store_issue.v1.DeleteStoreIssueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest} message DeleteStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreIssueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.issueId != null && Object.hasOwnProperty.call(message, "issueId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.issueId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteStoreIssueRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.DeleteStoreIssueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IDeleteStoreIssueRequest} message DeleteStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteStoreIssueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteStoreIssueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.DeleteStoreIssueRequest} DeleteStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreIssueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.DeleteStoreIssueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.issueId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteStoreIssueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.DeleteStoreIssueRequest} DeleteStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteStoreIssueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteStoreIssueRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteStoreIssueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.issueId != null && message.hasOwnProperty("issueId"))
                            if (!$util.isInteger(message.issueId) && !(message.issueId && $util.isInteger(message.issueId.low) && $util.isInteger(message.issueId.high)))
                                return "issueId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteStoreIssueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.DeleteStoreIssueRequest} DeleteStoreIssueRequest
                     */
                    DeleteStoreIssueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.DeleteStoreIssueRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.DeleteStoreIssueRequest();
                        if (object.issueId != null)
                            if ($util.Long)
                                (message.issueId = $util.Long.fromValue(object.issueId)).unsigned = false;
                            else if (typeof object.issueId === "string")
                                message.issueId = parseInt(object.issueId, 10);
                            else if (typeof object.issueId === "number")
                                message.issueId = object.issueId;
                            else if (typeof object.issueId === "object")
                                message.issueId = new $util.LongBits(object.issueId.low >>> 0, object.issueId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteStoreIssueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.DeleteStoreIssueRequest} message DeleteStoreIssueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteStoreIssueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.issueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.issueId = options.longs === String ? "0" : 0;
                        if (message.issueId != null && message.hasOwnProperty("issueId"))
                            if (typeof message.issueId === "number")
                                object.issueId = options.longs === String ? String(message.issueId) : message.issueId;
                            else
                                object.issueId = options.longs === String ? $util.Long.prototype.toString.call(message.issueId) : options.longs === Number ? new $util.LongBits(message.issueId.low >>> 0, message.issueId.high >>> 0).toNumber() : message.issueId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteStoreIssueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.DeleteStoreIssueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteStoreIssueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteStoreIssueRequest;
                })();
    
                v1.UpdateStoreIssueRequest = (function() {
    
                    /**
                     * Properties of an UpdateStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IUpdateStoreIssueRequest
                     * @property {palexy.store_issue.v1.IStoreIssue|null} [storeIssue] UpdateStoreIssueRequest storeIssue
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateStoreIssueRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents an UpdateStoreIssueRequest.
                     * @implements IUpdateStoreIssueRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest=} [properties] Properties to set
                     */
                    function UpdateStoreIssueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateStoreIssueRequest storeIssue.
                     * @member {palexy.store_issue.v1.IStoreIssue|null|undefined} storeIssue
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @instance
                     */
                    UpdateStoreIssueRequest.prototype.storeIssue = null;
    
                    /**
                     * UpdateStoreIssueRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @instance
                     */
                    UpdateStoreIssueRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateStoreIssueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.UpdateStoreIssueRequest} UpdateStoreIssueRequest instance
                     */
                    UpdateStoreIssueRequest.create = function create(properties) {
                        return new UpdateStoreIssueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateStoreIssueRequest message. Does not implicitly {@link palexy.store_issue.v1.UpdateStoreIssueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest} message UpdateStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreIssueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIssue != null && Object.hasOwnProperty.call(message, "storeIssue"))
                            $root.palexy.store_issue.v1.StoreIssue.encode(message.storeIssue, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateStoreIssueRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.UpdateStoreIssueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IUpdateStoreIssueRequest} message UpdateStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateStoreIssueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateStoreIssueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.UpdateStoreIssueRequest} UpdateStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreIssueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.UpdateStoreIssueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeIssue = $root.palexy.store_issue.v1.StoreIssue.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateStoreIssueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.UpdateStoreIssueRequest} UpdateStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateStoreIssueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateStoreIssueRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateStoreIssueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIssue != null && message.hasOwnProperty("storeIssue")) {
                            var error = $root.palexy.store_issue.v1.StoreIssue.verify(message.storeIssue);
                            if (error)
                                return "storeIssue." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateStoreIssueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.UpdateStoreIssueRequest} UpdateStoreIssueRequest
                     */
                    UpdateStoreIssueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.UpdateStoreIssueRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.UpdateStoreIssueRequest();
                        if (object.storeIssue != null) {
                            if (typeof object.storeIssue !== "object")
                                throw TypeError(".palexy.store_issue.v1.UpdateStoreIssueRequest.storeIssue: object expected");
                            message.storeIssue = $root.palexy.store_issue.v1.StoreIssue.fromObject(object.storeIssue);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.store_issue.v1.UpdateStoreIssueRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateStoreIssueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.UpdateStoreIssueRequest} message UpdateStoreIssueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateStoreIssueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeIssue = null;
                            object.updateMask = null;
                        }
                        if (message.storeIssue != null && message.hasOwnProperty("storeIssue"))
                            object.storeIssue = $root.palexy.store_issue.v1.StoreIssue.toObject(message.storeIssue, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateStoreIssueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.UpdateStoreIssueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateStoreIssueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateStoreIssueRequest;
                })();
    
                v1.RaiseStoreIssueRequest = (function() {
    
                    /**
                     * Properties of a RaiseStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IRaiseStoreIssueRequest
                     * @property {number|null} [storeId] RaiseStoreIssueRequest storeId
                     * @property {palexy.store_issue.v1.StoreIssueType|null} [type] RaiseStoreIssueRequest type
                     * @property {string|null} [description] RaiseStoreIssueRequest description
                     * @property {number|null} [occurredDateId] RaiseStoreIssueRequest occurredDateId
                     * @property {palexy.store_issue.v1.IStoreIssueAdvancedInfo|null} [advancedInfo] RaiseStoreIssueRequest advancedInfo
                     */
    
                    /**
                     * Constructs a new RaiseStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a RaiseStoreIssueRequest.
                     * @implements IRaiseStoreIssueRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest=} [properties] Properties to set
                     */
                    function RaiseStoreIssueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RaiseStoreIssueRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     */
                    RaiseStoreIssueRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RaiseStoreIssueRequest type.
                     * @member {palexy.store_issue.v1.StoreIssueType} type
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     */
                    RaiseStoreIssueRequest.prototype.type = 0;
    
                    /**
                     * RaiseStoreIssueRequest description.
                     * @member {string} description
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     */
                    RaiseStoreIssueRequest.prototype.description = "";
    
                    /**
                     * RaiseStoreIssueRequest occurredDateId.
                     * @member {number} occurredDateId
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     */
                    RaiseStoreIssueRequest.prototype.occurredDateId = 0;
    
                    /**
                     * RaiseStoreIssueRequest advancedInfo.
                     * @member {palexy.store_issue.v1.IStoreIssueAdvancedInfo|null|undefined} advancedInfo
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     */
                    RaiseStoreIssueRequest.prototype.advancedInfo = null;
    
                    /**
                     * Creates a new RaiseStoreIssueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.RaiseStoreIssueRequest} RaiseStoreIssueRequest instance
                     */
                    RaiseStoreIssueRequest.create = function create(properties) {
                        return new RaiseStoreIssueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RaiseStoreIssueRequest message. Does not implicitly {@link palexy.store_issue.v1.RaiseStoreIssueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest} message RaiseStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RaiseStoreIssueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.occurredDateId != null && Object.hasOwnProperty.call(message, "occurredDateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.occurredDateId);
                        if (message.advancedInfo != null && Object.hasOwnProperty.call(message, "advancedInfo"))
                            $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.encode(message.advancedInfo, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RaiseStoreIssueRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.RaiseStoreIssueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IRaiseStoreIssueRequest} message RaiseStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RaiseStoreIssueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RaiseStoreIssueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.RaiseStoreIssueRequest} RaiseStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RaiseStoreIssueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.RaiseStoreIssueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.type = reader.int32();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.occurredDateId = reader.int32();
                                break;
                            case 5:
                                message.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RaiseStoreIssueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.RaiseStoreIssueRequest} RaiseStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RaiseStoreIssueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RaiseStoreIssueRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RaiseStoreIssueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.occurredDateId != null && message.hasOwnProperty("occurredDateId"))
                            if (!$util.isInteger(message.occurredDateId))
                                return "occurredDateId: integer expected";
                        if (message.advancedInfo != null && message.hasOwnProperty("advancedInfo")) {
                            var error = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.verify(message.advancedInfo);
                            if (error)
                                return "advancedInfo." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RaiseStoreIssueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.RaiseStoreIssueRequest} RaiseStoreIssueRequest
                     */
                    RaiseStoreIssueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.RaiseStoreIssueRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.RaiseStoreIssueRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        switch (object.type) {
                        case "UNKNOWN_STORE_ISSUE_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "SECTION_CONFIG":
                        case 1:
                            message.type = 1;
                            break;
                        case "UPLOAD_VIDEOS":
                        case 2:
                            message.type = 2;
                            break;
                        case "PREPROCESSING":
                        case 3:
                            message.type = 3;
                            break;
                        case "CAMERA_VIEW_CHANGE":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.occurredDateId != null)
                            message.occurredDateId = object.occurredDateId | 0;
                        if (object.advancedInfo != null) {
                            if (typeof object.advancedInfo !== "object")
                                throw TypeError(".palexy.store_issue.v1.RaiseStoreIssueRequest.advancedInfo: object expected");
                            message.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.fromObject(object.advancedInfo);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RaiseStoreIssueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.RaiseStoreIssueRequest} message RaiseStoreIssueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RaiseStoreIssueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.type = options.enums === String ? "UNKNOWN_STORE_ISSUE_TYPE" : 0;
                            object.description = "";
                            object.occurredDateId = 0;
                            object.advancedInfo = null;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueType[message.type] : message.type;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.occurredDateId != null && message.hasOwnProperty("occurredDateId"))
                            object.occurredDateId = message.occurredDateId;
                        if (message.advancedInfo != null && message.hasOwnProperty("advancedInfo"))
                            object.advancedInfo = $root.palexy.store_issue.v1.StoreIssueAdvancedInfo.toObject(message.advancedInfo, options);
                        return object;
                    };
    
                    /**
                     * Converts this RaiseStoreIssueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.RaiseStoreIssueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RaiseStoreIssueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RaiseStoreIssueRequest;
                })();
    
                v1.GetStoreIssueRequest = (function() {
    
                    /**
                     * Properties of a GetStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IGetStoreIssueRequest
                     * @property {number|null} [issueId] GetStoreIssueRequest issueId
                     */
    
                    /**
                     * Constructs a new GetStoreIssueRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a GetStoreIssueRequest.
                     * @implements IGetStoreIssueRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest=} [properties] Properties to set
                     */
                    function GetStoreIssueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetStoreIssueRequest issueId.
                     * @member {number} issueId
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @instance
                     */
                    GetStoreIssueRequest.prototype.issueId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetStoreIssueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.GetStoreIssueRequest} GetStoreIssueRequest instance
                     */
                    GetStoreIssueRequest.create = function create(properties) {
                        return new GetStoreIssueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetStoreIssueRequest message. Does not implicitly {@link palexy.store_issue.v1.GetStoreIssueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest} message GetStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreIssueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.issueId != null && Object.hasOwnProperty.call(message, "issueId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.issueId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetStoreIssueRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.GetStoreIssueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.IGetStoreIssueRequest} message GetStoreIssueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetStoreIssueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetStoreIssueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.GetStoreIssueRequest} GetStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreIssueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.GetStoreIssueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.issueId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetStoreIssueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.GetStoreIssueRequest} GetStoreIssueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetStoreIssueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetStoreIssueRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetStoreIssueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.issueId != null && message.hasOwnProperty("issueId"))
                            if (!$util.isInteger(message.issueId) && !(message.issueId && $util.isInteger(message.issueId.low) && $util.isInteger(message.issueId.high)))
                                return "issueId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetStoreIssueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.GetStoreIssueRequest} GetStoreIssueRequest
                     */
                    GetStoreIssueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.GetStoreIssueRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.GetStoreIssueRequest();
                        if (object.issueId != null)
                            if ($util.Long)
                                (message.issueId = $util.Long.fromValue(object.issueId)).unsigned = false;
                            else if (typeof object.issueId === "string")
                                message.issueId = parseInt(object.issueId, 10);
                            else if (typeof object.issueId === "number")
                                message.issueId = object.issueId;
                            else if (typeof object.issueId === "object")
                                message.issueId = new $util.LongBits(object.issueId.low >>> 0, object.issueId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetStoreIssueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @static
                     * @param {palexy.store_issue.v1.GetStoreIssueRequest} message GetStoreIssueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetStoreIssueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.issueId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.issueId = options.longs === String ? "0" : 0;
                        if (message.issueId != null && message.hasOwnProperty("issueId"))
                            if (typeof message.issueId === "number")
                                object.issueId = options.longs === String ? String(message.issueId) : message.issueId;
                            else
                                object.issueId = options.longs === String ? $util.Long.prototype.toString.call(message.issueId) : options.longs === Number ? new $util.LongBits(message.issueId.low >>> 0, message.issueId.high >>> 0).toNumber() : message.issueId;
                        return object;
                    };
    
                    /**
                     * Converts this GetStoreIssueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.GetStoreIssueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetStoreIssueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetStoreIssueRequest;
                })();
    
                v1.ListStoreIssuesRequest = (function() {
    
                    /**
                     * Properties of a ListStoreIssuesRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IListStoreIssuesRequest
                     * @property {number|null} [storeId] ListStoreIssuesRequest storeId
                     * @property {number|null} [companyId] ListStoreIssuesRequest companyId
                     * @property {palexy.store_issue.v1.StoreIssueState|null} [issueState] ListStoreIssuesRequest issueState
                     * @property {palexy.store_issue.v1.StoreIssueType|null} [issueType] ListStoreIssuesRequest issueType
                     * @property {number|null} [pageSize] ListStoreIssuesRequest pageSize
                     * @property {string|null} [pageToken] ListStoreIssuesRequest pageToken
                     * @property {string|null} [startDate] ListStoreIssuesRequest startDate
                     * @property {string|null} [endDate] ListStoreIssuesRequest endDate
                     */
    
                    /**
                     * Constructs a new ListStoreIssuesRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a ListStoreIssuesRequest.
                     * @implements IListStoreIssuesRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest=} [properties] Properties to set
                     */
                    function ListStoreIssuesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreIssuesRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreIssuesRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListStoreIssuesRequest issueState.
                     * @member {palexy.store_issue.v1.StoreIssueState} issueState
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.issueState = 0;
    
                    /**
                     * ListStoreIssuesRequest issueType.
                     * @member {palexy.store_issue.v1.StoreIssueType} issueType
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.issueType = 0;
    
                    /**
                     * ListStoreIssuesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListStoreIssuesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.pageToken = "";
    
                    /**
                     * ListStoreIssuesRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.startDate = "";
    
                    /**
                     * ListStoreIssuesRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     */
                    ListStoreIssuesRequest.prototype.endDate = "";
    
                    /**
                     * Creates a new ListStoreIssuesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.ListStoreIssuesRequest} ListStoreIssuesRequest instance
                     */
                    ListStoreIssuesRequest.create = function create(properties) {
                        return new ListStoreIssuesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreIssuesRequest message. Does not implicitly {@link palexy.store_issue.v1.ListStoreIssuesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest} message ListStoreIssuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreIssuesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.issueState != null && Object.hasOwnProperty.call(message, "issueState"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.issueState);
                        if (message.issueType != null && Object.hasOwnProperty.call(message, "issueType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.issueType);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.endDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreIssuesRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.ListStoreIssuesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesRequest} message ListStoreIssuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreIssuesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreIssuesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.ListStoreIssuesRequest} ListStoreIssuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreIssuesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.ListStoreIssuesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.issueState = reader.int32();
                                break;
                            case 4:
                                message.issueType = reader.int32();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 7:
                                message.startDate = reader.string();
                                break;
                            case 8:
                                message.endDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreIssuesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.ListStoreIssuesRequest} ListStoreIssuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreIssuesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreIssuesRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreIssuesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.issueState != null && message.hasOwnProperty("issueState"))
                            switch (message.issueState) {
                            default:
                                return "issueState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.issueType != null && message.hasOwnProperty("issueType"))
                            switch (message.issueType) {
                            default:
                                return "issueType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreIssuesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.ListStoreIssuesRequest} ListStoreIssuesRequest
                     */
                    ListStoreIssuesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.ListStoreIssuesRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.ListStoreIssuesRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.issueState) {
                        case "UNKNOWN_STORE_ISSUE_STATE":
                        case 0:
                            message.issueState = 0;
                            break;
                        case "ACTIVE":
                        case 1:
                            message.issueState = 1;
                            break;
                        case "RESOLVED":
                        case 2:
                            message.issueState = 2;
                            break;
                        }
                        switch (object.issueType) {
                        case "UNKNOWN_STORE_ISSUE_TYPE":
                        case 0:
                            message.issueType = 0;
                            break;
                        case "SECTION_CONFIG":
                        case 1:
                            message.issueType = 1;
                            break;
                        case "UPLOAD_VIDEOS":
                        case 2:
                            message.issueType = 2;
                            break;
                        case "PREPROCESSING":
                        case 3:
                            message.issueType = 3;
                            break;
                        case "CAMERA_VIEW_CHANGE":
                        case 4:
                            message.issueType = 4;
                            break;
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreIssuesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @static
                     * @param {palexy.store_issue.v1.ListStoreIssuesRequest} message ListStoreIssuesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreIssuesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.issueState = options.enums === String ? "UNKNOWN_STORE_ISSUE_STATE" : 0;
                            object.issueType = options.enums === String ? "UNKNOWN_STORE_ISSUE_TYPE" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.startDate = "";
                            object.endDate = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.issueState != null && message.hasOwnProperty("issueState"))
                            object.issueState = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueState[message.issueState] : message.issueState;
                        if (message.issueType != null && message.hasOwnProperty("issueType"))
                            object.issueType = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueType[message.issueType] : message.issueType;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreIssuesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.ListStoreIssuesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreIssuesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreIssuesRequest;
                })();
    
                v1.ListStoreIssuesResponse = (function() {
    
                    /**
                     * Properties of a ListStoreIssuesResponse.
                     * @memberof palexy.store_issue.v1
                     * @interface IListStoreIssuesResponse
                     * @property {Array.<palexy.store_issue.v1.IStoreIssue>|null} [issues] ListStoreIssuesResponse issues
                     * @property {string|null} [nextPageToken] ListStoreIssuesResponse nextPageToken
                     * @property {number|null} [totalElements] ListStoreIssuesResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListStoreIssuesResponse.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a ListStoreIssuesResponse.
                     * @implements IListStoreIssuesResponse
                     * @constructor
                     * @param {palexy.store_issue.v1.IListStoreIssuesResponse=} [properties] Properties to set
                     */
                    function ListStoreIssuesResponse(properties) {
                        this.issues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListStoreIssuesResponse issues.
                     * @member {Array.<palexy.store_issue.v1.IStoreIssue>} issues
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @instance
                     */
                    ListStoreIssuesResponse.prototype.issues = $util.emptyArray;
    
                    /**
                     * ListStoreIssuesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @instance
                     */
                    ListStoreIssuesResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListStoreIssuesResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @instance
                     */
                    ListStoreIssuesResponse.prototype.totalElements = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListStoreIssuesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesResponse=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.ListStoreIssuesResponse} ListStoreIssuesResponse instance
                     */
                    ListStoreIssuesResponse.create = function create(properties) {
                        return new ListStoreIssuesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListStoreIssuesResponse message. Does not implicitly {@link palexy.store_issue.v1.ListStoreIssuesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesResponse} message ListStoreIssuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreIssuesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.issues != null && message.issues.length)
                            for (var i = 0; i < message.issues.length; ++i)
                                $root.palexy.store_issue.v1.StoreIssue.encode(message.issues[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListStoreIssuesResponse message, length delimited. Does not implicitly {@link palexy.store_issue.v1.ListStoreIssuesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {palexy.store_issue.v1.IListStoreIssuesResponse} message ListStoreIssuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListStoreIssuesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListStoreIssuesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.ListStoreIssuesResponse} ListStoreIssuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreIssuesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.ListStoreIssuesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.issues && message.issues.length))
                                    message.issues = [];
                                message.issues.push($root.palexy.store_issue.v1.StoreIssue.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListStoreIssuesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.ListStoreIssuesResponse} ListStoreIssuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListStoreIssuesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListStoreIssuesResponse message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListStoreIssuesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.issues != null && message.hasOwnProperty("issues")) {
                            if (!Array.isArray(message.issues))
                                return "issues: array expected";
                            for (var i = 0; i < message.issues.length; ++i) {
                                var error = $root.palexy.store_issue.v1.StoreIssue.verify(message.issues[i]);
                                if (error)
                                    return "issues." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements) && !(message.totalElements && $util.isInteger(message.totalElements.low) && $util.isInteger(message.totalElements.high)))
                                return "totalElements: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListStoreIssuesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.ListStoreIssuesResponse} ListStoreIssuesResponse
                     */
                    ListStoreIssuesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.ListStoreIssuesResponse)
                            return object;
                        var message = new $root.palexy.store_issue.v1.ListStoreIssuesResponse();
                        if (object.issues) {
                            if (!Array.isArray(object.issues))
                                throw TypeError(".palexy.store_issue.v1.ListStoreIssuesResponse.issues: array expected");
                            message.issues = [];
                            for (var i = 0; i < object.issues.length; ++i) {
                                if (typeof object.issues[i] !== "object")
                                    throw TypeError(".palexy.store_issue.v1.ListStoreIssuesResponse.issues: object expected");
                                message.issues[i] = $root.palexy.store_issue.v1.StoreIssue.fromObject(object.issues[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            if ($util.Long)
                                (message.totalElements = $util.Long.fromValue(object.totalElements)).unsigned = false;
                            else if (typeof object.totalElements === "string")
                                message.totalElements = parseInt(object.totalElements, 10);
                            else if (typeof object.totalElements === "number")
                                message.totalElements = object.totalElements;
                            else if (typeof object.totalElements === "object")
                                message.totalElements = new $util.LongBits(object.totalElements.low >>> 0, object.totalElements.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListStoreIssuesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @static
                     * @param {palexy.store_issue.v1.ListStoreIssuesResponse} message ListStoreIssuesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListStoreIssuesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.issues = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalElements = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalElements = options.longs === String ? "0" : 0;
                        }
                        if (message.issues && message.issues.length) {
                            object.issues = [];
                            for (var j = 0; j < message.issues.length; ++j)
                                object.issues[j] = $root.palexy.store_issue.v1.StoreIssue.toObject(message.issues[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (typeof message.totalElements === "number")
                                object.totalElements = options.longs === String ? String(message.totalElements) : message.totalElements;
                            else
                                object.totalElements = options.longs === String ? $util.Long.prototype.toString.call(message.totalElements) : options.longs === Number ? new $util.LongBits(message.totalElements.low >>> 0, message.totalElements.high >>> 0).toNumber() : message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListStoreIssuesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.ListStoreIssuesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListStoreIssuesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListStoreIssuesResponse;
                })();
    
                /**
                 * StoreIssueType enum.
                 * @name palexy.store_issue.v1.StoreIssueType
                 * @enum {number}
                 * @property {number} UNKNOWN_STORE_ISSUE_TYPE=0 UNKNOWN_STORE_ISSUE_TYPE value
                 * @property {number} SECTION_CONFIG=1 SECTION_CONFIG value
                 * @property {number} UPLOAD_VIDEOS=2 UPLOAD_VIDEOS value
                 * @property {number} PREPROCESSING=3 PREPROCESSING value
                 * @property {number} CAMERA_VIEW_CHANGE=4 CAMERA_VIEW_CHANGE value
                 */
                v1.StoreIssueType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_STORE_ISSUE_TYPE"] = 0;
                    values[valuesById[1] = "SECTION_CONFIG"] = 1;
                    values[valuesById[2] = "UPLOAD_VIDEOS"] = 2;
                    values[valuesById[3] = "PREPROCESSING"] = 3;
                    values[valuesById[4] = "CAMERA_VIEW_CHANGE"] = 4;
                    return values;
                })();
    
                /**
                 * StoreIssueState enum.
                 * @name palexy.store_issue.v1.StoreIssueState
                 * @enum {number}
                 * @property {number} UNKNOWN_STORE_ISSUE_STATE=0 UNKNOWN_STORE_ISSUE_STATE value
                 * @property {number} ACTIVE=1 ACTIVE value
                 * @property {number} RESOLVED=2 RESOLVED value
                 */
                v1.StoreIssueState = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_STORE_ISSUE_STATE"] = 0;
                    values[valuesById[1] = "ACTIVE"] = 1;
                    values[valuesById[2] = "RESOLVED"] = 2;
                    return values;
                })();
    
                v1.StoreIssueReportRequest = (function() {
    
                    /**
                     * Properties of a StoreIssueReportRequest.
                     * @memberof palexy.store_issue.v1
                     * @interface IStoreIssueReportRequest
                     * @property {number|null} [storeId] StoreIssueReportRequest storeId
                     * @property {number|null} [companyId] StoreIssueReportRequest companyId
                     * @property {string|null} [startDate] StoreIssueReportRequest startDate
                     * @property {string|null} [endDate] StoreIssueReportRequest endDate
                     */
    
                    /**
                     * Constructs a new StoreIssueReportRequest.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a StoreIssueReportRequest.
                     * @implements IStoreIssueReportRequest
                     * @constructor
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest=} [properties] Properties to set
                     */
                    function StoreIssueReportRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreIssueReportRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @instance
                     */
                    StoreIssueReportRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssueReportRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @instance
                     */
                    StoreIssueReportRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * StoreIssueReportRequest startDate.
                     * @member {string} startDate
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @instance
                     */
                    StoreIssueReportRequest.prototype.startDate = "";
    
                    /**
                     * StoreIssueReportRequest endDate.
                     * @member {string} endDate
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @instance
                     */
                    StoreIssueReportRequest.prototype.endDate = "";
    
                    /**
                     * Creates a new StoreIssueReportRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.StoreIssueReportRequest} StoreIssueReportRequest instance
                     */
                    StoreIssueReportRequest.create = function create(properties) {
                        return new StoreIssueReportRequest(properties);
                    };
    
                    /**
                     * Encodes the specified StoreIssueReportRequest message. Does not implicitly {@link palexy.store_issue.v1.StoreIssueReportRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest} message StoreIssueReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueReportRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.startDate != null && Object.hasOwnProperty.call(message, "startDate"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDate);
                        if (message.endDate != null && Object.hasOwnProperty.call(message, "endDate"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDate);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreIssueReportRequest message, length delimited. Does not implicitly {@link palexy.store_issue.v1.StoreIssueReportRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportRequest} message StoreIssueReportRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueReportRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreIssueReportRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.StoreIssueReportRequest} StoreIssueReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueReportRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.StoreIssueReportRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.startDate = reader.string();
                                break;
                            case 4:
                                message.endDate = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreIssueReportRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.StoreIssueReportRequest} StoreIssueReportRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueReportRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreIssueReportRequest message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreIssueReportRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            if (!$util.isString(message.startDate))
                                return "startDate: string expected";
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            if (!$util.isString(message.endDate))
                                return "endDate: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreIssueReportRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.StoreIssueReportRequest} StoreIssueReportRequest
                     */
                    StoreIssueReportRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.StoreIssueReportRequest)
                            return object;
                        var message = new $root.palexy.store_issue.v1.StoreIssueReportRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.startDate != null)
                            message.startDate = String(object.startDate);
                        if (object.endDate != null)
                            message.endDate = String(object.endDate);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreIssueReportRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @static
                     * @param {palexy.store_issue.v1.StoreIssueReportRequest} message StoreIssueReportRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreIssueReportRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.startDate = "";
                            object.endDate = "";
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.startDate != null && message.hasOwnProperty("startDate"))
                            object.startDate = message.startDate;
                        if (message.endDate != null && message.hasOwnProperty("endDate"))
                            object.endDate = message.endDate;
                        return object;
                    };
    
                    /**
                     * Converts this StoreIssueReportRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.StoreIssueReportRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreIssueReportRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreIssueReportRequest;
                })();
    
                v1.StoreIssueReportResponse = (function() {
    
                    /**
                     * Properties of a StoreIssueReportResponse.
                     * @memberof palexy.store_issue.v1
                     * @interface IStoreIssueReportResponse
                     * @property {Array.<palexy.store_issue.v1.ICountIssueByType>|null} [countByType] StoreIssueReportResponse countByType
                     * @property {Array.<palexy.store_issue.v1.ICountIssueByState>|null} [countByState] StoreIssueReportResponse countByState
                     */
    
                    /**
                     * Constructs a new StoreIssueReportResponse.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a StoreIssueReportResponse.
                     * @implements IStoreIssueReportResponse
                     * @constructor
                     * @param {palexy.store_issue.v1.IStoreIssueReportResponse=} [properties] Properties to set
                     */
                    function StoreIssueReportResponse(properties) {
                        this.countByType = [];
                        this.countByState = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreIssueReportResponse countByType.
                     * @member {Array.<palexy.store_issue.v1.ICountIssueByType>} countByType
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @instance
                     */
                    StoreIssueReportResponse.prototype.countByType = $util.emptyArray;
    
                    /**
                     * StoreIssueReportResponse countByState.
                     * @member {Array.<palexy.store_issue.v1.ICountIssueByState>} countByState
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @instance
                     */
                    StoreIssueReportResponse.prototype.countByState = $util.emptyArray;
    
                    /**
                     * Creates a new StoreIssueReportResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportResponse=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.StoreIssueReportResponse} StoreIssueReportResponse instance
                     */
                    StoreIssueReportResponse.create = function create(properties) {
                        return new StoreIssueReportResponse(properties);
                    };
    
                    /**
                     * Encodes the specified StoreIssueReportResponse message. Does not implicitly {@link palexy.store_issue.v1.StoreIssueReportResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportResponse} message StoreIssueReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueReportResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.countByType != null && message.countByType.length)
                            for (var i = 0; i < message.countByType.length; ++i)
                                $root.palexy.store_issue.v1.CountIssueByType.encode(message.countByType[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.countByState != null && message.countByState.length)
                            for (var i = 0; i < message.countByState.length; ++i)
                                $root.palexy.store_issue.v1.CountIssueByState.encode(message.countByState[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreIssueReportResponse message, length delimited. Does not implicitly {@link palexy.store_issue.v1.StoreIssueReportResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueReportResponse} message StoreIssueReportResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueReportResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreIssueReportResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.StoreIssueReportResponse} StoreIssueReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueReportResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.StoreIssueReportResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.countByType && message.countByType.length))
                                    message.countByType = [];
                                message.countByType.push($root.palexy.store_issue.v1.CountIssueByType.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.countByState && message.countByState.length))
                                    message.countByState = [];
                                message.countByState.push($root.palexy.store_issue.v1.CountIssueByState.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreIssueReportResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.StoreIssueReportResponse} StoreIssueReportResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueReportResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreIssueReportResponse message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreIssueReportResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.countByType != null && message.hasOwnProperty("countByType")) {
                            if (!Array.isArray(message.countByType))
                                return "countByType: array expected";
                            for (var i = 0; i < message.countByType.length; ++i) {
                                var error = $root.palexy.store_issue.v1.CountIssueByType.verify(message.countByType[i]);
                                if (error)
                                    return "countByType." + error;
                            }
                        }
                        if (message.countByState != null && message.hasOwnProperty("countByState")) {
                            if (!Array.isArray(message.countByState))
                                return "countByState: array expected";
                            for (var i = 0; i < message.countByState.length; ++i) {
                                var error = $root.palexy.store_issue.v1.CountIssueByState.verify(message.countByState[i]);
                                if (error)
                                    return "countByState." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreIssueReportResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.StoreIssueReportResponse} StoreIssueReportResponse
                     */
                    StoreIssueReportResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.StoreIssueReportResponse)
                            return object;
                        var message = new $root.palexy.store_issue.v1.StoreIssueReportResponse();
                        if (object.countByType) {
                            if (!Array.isArray(object.countByType))
                                throw TypeError(".palexy.store_issue.v1.StoreIssueReportResponse.countByType: array expected");
                            message.countByType = [];
                            for (var i = 0; i < object.countByType.length; ++i) {
                                if (typeof object.countByType[i] !== "object")
                                    throw TypeError(".palexy.store_issue.v1.StoreIssueReportResponse.countByType: object expected");
                                message.countByType[i] = $root.palexy.store_issue.v1.CountIssueByType.fromObject(object.countByType[i]);
                            }
                        }
                        if (object.countByState) {
                            if (!Array.isArray(object.countByState))
                                throw TypeError(".palexy.store_issue.v1.StoreIssueReportResponse.countByState: array expected");
                            message.countByState = [];
                            for (var i = 0; i < object.countByState.length; ++i) {
                                if (typeof object.countByState[i] !== "object")
                                    throw TypeError(".palexy.store_issue.v1.StoreIssueReportResponse.countByState: object expected");
                                message.countByState[i] = $root.palexy.store_issue.v1.CountIssueByState.fromObject(object.countByState[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreIssueReportResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @static
                     * @param {palexy.store_issue.v1.StoreIssueReportResponse} message StoreIssueReportResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreIssueReportResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.countByType = [];
                            object.countByState = [];
                        }
                        if (message.countByType && message.countByType.length) {
                            object.countByType = [];
                            for (var j = 0; j < message.countByType.length; ++j)
                                object.countByType[j] = $root.palexy.store_issue.v1.CountIssueByType.toObject(message.countByType[j], options);
                        }
                        if (message.countByState && message.countByState.length) {
                            object.countByState = [];
                            for (var j = 0; j < message.countByState.length; ++j)
                                object.countByState[j] = $root.palexy.store_issue.v1.CountIssueByState.toObject(message.countByState[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreIssueReportResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.StoreIssueReportResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreIssueReportResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreIssueReportResponse;
                })();
    
                v1.CountIssueByType = (function() {
    
                    /**
                     * Properties of a CountIssueByType.
                     * @memberof palexy.store_issue.v1
                     * @interface ICountIssueByType
                     * @property {palexy.store_issue.v1.StoreIssueType|null} [type] CountIssueByType type
                     * @property {number|null} [count] CountIssueByType count
                     */
    
                    /**
                     * Constructs a new CountIssueByType.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a CountIssueByType.
                     * @implements ICountIssueByType
                     * @constructor
                     * @param {palexy.store_issue.v1.ICountIssueByType=} [properties] Properties to set
                     */
                    function CountIssueByType(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CountIssueByType type.
                     * @member {palexy.store_issue.v1.StoreIssueType} type
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @instance
                     */
                    CountIssueByType.prototype.type = 0;
    
                    /**
                     * CountIssueByType count.
                     * @member {number} count
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @instance
                     */
                    CountIssueByType.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CountIssueByType instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByType=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.CountIssueByType} CountIssueByType instance
                     */
                    CountIssueByType.create = function create(properties) {
                        return new CountIssueByType(properties);
                    };
    
                    /**
                     * Encodes the specified CountIssueByType message. Does not implicitly {@link palexy.store_issue.v1.CountIssueByType.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByType} message CountIssueByType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CountIssueByType.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.count);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CountIssueByType message, length delimited. Does not implicitly {@link palexy.store_issue.v1.CountIssueByType.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByType} message CountIssueByType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CountIssueByType.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CountIssueByType message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.CountIssueByType} CountIssueByType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CountIssueByType.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.CountIssueByType();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.count = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CountIssueByType message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.CountIssueByType} CountIssueByType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CountIssueByType.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CountIssueByType message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CountIssueByType.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                                return "count: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CountIssueByType message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.CountIssueByType} CountIssueByType
                     */
                    CountIssueByType.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.CountIssueByType)
                            return object;
                        var message = new $root.palexy.store_issue.v1.CountIssueByType();
                        switch (object.type) {
                        case "UNKNOWN_STORE_ISSUE_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "SECTION_CONFIG":
                        case 1:
                            message.type = 1;
                            break;
                        case "UPLOAD_VIDEOS":
                        case 2:
                            message.type = 2;
                            break;
                        case "PREPROCESSING":
                        case 3:
                            message.type = 3;
                            break;
                        case "CAMERA_VIEW_CHANGE":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.count != null)
                            if ($util.Long)
                                (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                            else if (typeof object.count === "string")
                                message.count = parseInt(object.count, 10);
                            else if (typeof object.count === "number")
                                message.count = object.count;
                            else if (typeof object.count === "object")
                                message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CountIssueByType message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @static
                     * @param {palexy.store_issue.v1.CountIssueByType} message CountIssueByType
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CountIssueByType.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNKNOWN_STORE_ISSUE_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.count = options.longs === String ? "0" : 0;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueType[message.type] : message.type;
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (typeof message.count === "number")
                                object.count = options.longs === String ? String(message.count) : message.count;
                            else
                                object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                        return object;
                    };
    
                    /**
                     * Converts this CountIssueByType to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.CountIssueByType
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CountIssueByType.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CountIssueByType;
                })();
    
                v1.CountIssueByState = (function() {
    
                    /**
                     * Properties of a CountIssueByState.
                     * @memberof palexy.store_issue.v1
                     * @interface ICountIssueByState
                     * @property {palexy.store_issue.v1.StoreIssueState|null} [state] CountIssueByState state
                     * @property {number|null} [count] CountIssueByState count
                     */
    
                    /**
                     * Constructs a new CountIssueByState.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a CountIssueByState.
                     * @implements ICountIssueByState
                     * @constructor
                     * @param {palexy.store_issue.v1.ICountIssueByState=} [properties] Properties to set
                     */
                    function CountIssueByState(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CountIssueByState state.
                     * @member {palexy.store_issue.v1.StoreIssueState} state
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @instance
                     */
                    CountIssueByState.prototype.state = 0;
    
                    /**
                     * CountIssueByState count.
                     * @member {number} count
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @instance
                     */
                    CountIssueByState.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CountIssueByState instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByState=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.CountIssueByState} CountIssueByState instance
                     */
                    CountIssueByState.create = function create(properties) {
                        return new CountIssueByState(properties);
                    };
    
                    /**
                     * Encodes the specified CountIssueByState message. Does not implicitly {@link palexy.store_issue.v1.CountIssueByState.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByState} message CountIssueByState message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CountIssueByState.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
                        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.count);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CountIssueByState message, length delimited. Does not implicitly {@link palexy.store_issue.v1.CountIssueByState.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {palexy.store_issue.v1.ICountIssueByState} message CountIssueByState message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CountIssueByState.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CountIssueByState message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.CountIssueByState} CountIssueByState
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CountIssueByState.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.CountIssueByState();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.state = reader.int32();
                                break;
                            case 2:
                                message.count = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CountIssueByState message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.CountIssueByState} CountIssueByState
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CountIssueByState.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CountIssueByState message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CountIssueByState.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.state != null && message.hasOwnProperty("state"))
                            switch (message.state) {
                            default:
                                return "state: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                                return "count: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CountIssueByState message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.CountIssueByState} CountIssueByState
                     */
                    CountIssueByState.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.CountIssueByState)
                            return object;
                        var message = new $root.palexy.store_issue.v1.CountIssueByState();
                        switch (object.state) {
                        case "UNKNOWN_STORE_ISSUE_STATE":
                        case 0:
                            message.state = 0;
                            break;
                        case "ACTIVE":
                        case 1:
                            message.state = 1;
                            break;
                        case "RESOLVED":
                        case 2:
                            message.state = 2;
                            break;
                        }
                        if (object.count != null)
                            if ($util.Long)
                                (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                            else if (typeof object.count === "string")
                                message.count = parseInt(object.count, 10);
                            else if (typeof object.count === "number")
                                message.count = object.count;
                            else if (typeof object.count === "object")
                                message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CountIssueByState message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @static
                     * @param {palexy.store_issue.v1.CountIssueByState} message CountIssueByState
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CountIssueByState.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.state = options.enums === String ? "UNKNOWN_STORE_ISSUE_STATE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.count = options.longs === String ? "0" : 0;
                        }
                        if (message.state != null && message.hasOwnProperty("state"))
                            object.state = options.enums === String ? $root.palexy.store_issue.v1.StoreIssueState[message.state] : message.state;
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (typeof message.count === "number")
                                object.count = options.longs === String ? String(message.count) : message.count;
                            else
                                object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                        return object;
                    };
    
                    /**
                     * Converts this CountIssueByState to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.CountIssueByState
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CountIssueByState.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CountIssueByState;
                })();
    
                v1.StoreIssueAdvancedInfo = (function() {
    
                    /**
                     * Properties of a StoreIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @interface IStoreIssueAdvancedInfo
                     * @property {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo|null} [preprocessingIssueAdvancedInfo] StoreIssueAdvancedInfo preprocessingIssueAdvancedInfo
                     * @property {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo|null} [cameraViewChangeIssueAdvancedInfo] StoreIssueAdvancedInfo cameraViewChangeIssueAdvancedInfo
                     */
    
                    /**
                     * Constructs a new StoreIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a StoreIssueAdvancedInfo.
                     * @implements IStoreIssueAdvancedInfo
                     * @constructor
                     * @param {palexy.store_issue.v1.IStoreIssueAdvancedInfo=} [properties] Properties to set
                     */
                    function StoreIssueAdvancedInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreIssueAdvancedInfo preprocessingIssueAdvancedInfo.
                     * @member {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo|null|undefined} preprocessingIssueAdvancedInfo
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @instance
                     */
                    StoreIssueAdvancedInfo.prototype.preprocessingIssueAdvancedInfo = null;
    
                    /**
                     * StoreIssueAdvancedInfo cameraViewChangeIssueAdvancedInfo.
                     * @member {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo|null|undefined} cameraViewChangeIssueAdvancedInfo
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @instance
                     */
                    StoreIssueAdvancedInfo.prototype.cameraViewChangeIssueAdvancedInfo = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * StoreIssueAdvancedInfo info.
                     * @member {"preprocessingIssueAdvancedInfo"|"cameraViewChangeIssueAdvancedInfo"|undefined} info
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @instance
                     */
                    Object.defineProperty(StoreIssueAdvancedInfo.prototype, "info", {
                        get: $util.oneOfGetter($oneOfFields = ["preprocessingIssueAdvancedInfo", "cameraViewChangeIssueAdvancedInfo"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new StoreIssueAdvancedInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueAdvancedInfo=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.StoreIssueAdvancedInfo} StoreIssueAdvancedInfo instance
                     */
                    StoreIssueAdvancedInfo.create = function create(properties) {
                        return new StoreIssueAdvancedInfo(properties);
                    };
    
                    /**
                     * Encodes the specified StoreIssueAdvancedInfo message. Does not implicitly {@link palexy.store_issue.v1.StoreIssueAdvancedInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueAdvancedInfo} message StoreIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueAdvancedInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.preprocessingIssueAdvancedInfo != null && Object.hasOwnProperty.call(message, "preprocessingIssueAdvancedInfo"))
                            $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.encode(message.preprocessingIssueAdvancedInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.cameraViewChangeIssueAdvancedInfo != null && Object.hasOwnProperty.call(message, "cameraViewChangeIssueAdvancedInfo"))
                            $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.encode(message.cameraViewChangeIssueAdvancedInfo, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreIssueAdvancedInfo message, length delimited. Does not implicitly {@link palexy.store_issue.v1.StoreIssueAdvancedInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IStoreIssueAdvancedInfo} message StoreIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreIssueAdvancedInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreIssueAdvancedInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.StoreIssueAdvancedInfo} StoreIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueAdvancedInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.StoreIssueAdvancedInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.preprocessingIssueAdvancedInfo = $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.cameraViewChangeIssueAdvancedInfo = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreIssueAdvancedInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.StoreIssueAdvancedInfo} StoreIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreIssueAdvancedInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreIssueAdvancedInfo message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreIssueAdvancedInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.preprocessingIssueAdvancedInfo != null && message.hasOwnProperty("preprocessingIssueAdvancedInfo")) {
                            properties.info = 1;
                            {
                                var error = $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.verify(message.preprocessingIssueAdvancedInfo);
                                if (error)
                                    return "preprocessingIssueAdvancedInfo." + error;
                            }
                        }
                        if (message.cameraViewChangeIssueAdvancedInfo != null && message.hasOwnProperty("cameraViewChangeIssueAdvancedInfo")) {
                            if (properties.info === 1)
                                return "info: multiple values";
                            properties.info = 1;
                            {
                                var error = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.verify(message.cameraViewChangeIssueAdvancedInfo);
                                if (error)
                                    return "cameraViewChangeIssueAdvancedInfo." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StoreIssueAdvancedInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.StoreIssueAdvancedInfo} StoreIssueAdvancedInfo
                     */
                    StoreIssueAdvancedInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.StoreIssueAdvancedInfo)
                            return object;
                        var message = new $root.palexy.store_issue.v1.StoreIssueAdvancedInfo();
                        if (object.preprocessingIssueAdvancedInfo != null) {
                            if (typeof object.preprocessingIssueAdvancedInfo !== "object")
                                throw TypeError(".palexy.store_issue.v1.StoreIssueAdvancedInfo.preprocessingIssueAdvancedInfo: object expected");
                            message.preprocessingIssueAdvancedInfo = $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.fromObject(object.preprocessingIssueAdvancedInfo);
                        }
                        if (object.cameraViewChangeIssueAdvancedInfo != null) {
                            if (typeof object.cameraViewChangeIssueAdvancedInfo !== "object")
                                throw TypeError(".palexy.store_issue.v1.StoreIssueAdvancedInfo.cameraViewChangeIssueAdvancedInfo: object expected");
                            message.cameraViewChangeIssueAdvancedInfo = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.fromObject(object.cameraViewChangeIssueAdvancedInfo);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreIssueAdvancedInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.StoreIssueAdvancedInfo} message StoreIssueAdvancedInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreIssueAdvancedInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.preprocessingIssueAdvancedInfo != null && message.hasOwnProperty("preprocessingIssueAdvancedInfo")) {
                            object.preprocessingIssueAdvancedInfo = $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.toObject(message.preprocessingIssueAdvancedInfo, options);
                            if (options.oneofs)
                                object.info = "preprocessingIssueAdvancedInfo";
                        }
                        if (message.cameraViewChangeIssueAdvancedInfo != null && message.hasOwnProperty("cameraViewChangeIssueAdvancedInfo")) {
                            object.cameraViewChangeIssueAdvancedInfo = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.toObject(message.cameraViewChangeIssueAdvancedInfo, options);
                            if (options.oneofs)
                                object.info = "cameraViewChangeIssueAdvancedInfo";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StoreIssueAdvancedInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.StoreIssueAdvancedInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreIssueAdvancedInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreIssueAdvancedInfo;
                })();
    
                v1.PreprocessingIssueAdvancedInfo = (function() {
    
                    /**
                     * Properties of a PreprocessingIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @interface IPreprocessingIssueAdvancedInfo
                     * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [video] PreprocessingIssueAdvancedInfo video
                     * @property {string|null} [videoUrl] PreprocessingIssueAdvancedInfo videoUrl
                     */
    
                    /**
                     * Constructs a new PreprocessingIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a PreprocessingIssueAdvancedInfo.
                     * @implements IPreprocessingIssueAdvancedInfo
                     * @constructor
                     * @param {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo=} [properties] Properties to set
                     */
                    function PreprocessingIssueAdvancedInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PreprocessingIssueAdvancedInfo video.
                     * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} video
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @instance
                     */
                    PreprocessingIssueAdvancedInfo.prototype.video = null;
    
                    /**
                     * PreprocessingIssueAdvancedInfo videoUrl.
                     * @member {string} videoUrl
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @instance
                     */
                    PreprocessingIssueAdvancedInfo.prototype.videoUrl = "";
    
                    /**
                     * Creates a new PreprocessingIssueAdvancedInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.PreprocessingIssueAdvancedInfo} PreprocessingIssueAdvancedInfo instance
                     */
                    PreprocessingIssueAdvancedInfo.create = function create(properties) {
                        return new PreprocessingIssueAdvancedInfo(properties);
                    };
    
                    /**
                     * Encodes the specified PreprocessingIssueAdvancedInfo message. Does not implicitly {@link palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo} message PreprocessingIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreprocessingIssueAdvancedInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.video != null && Object.hasOwnProperty.call(message, "video"))
                            $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.video, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.videoUrl != null && Object.hasOwnProperty.call(message, "videoUrl"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.videoUrl);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PreprocessingIssueAdvancedInfo message, length delimited. Does not implicitly {@link palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.IPreprocessingIssueAdvancedInfo} message PreprocessingIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PreprocessingIssueAdvancedInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PreprocessingIssueAdvancedInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.PreprocessingIssueAdvancedInfo} PreprocessingIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreprocessingIssueAdvancedInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.video = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.videoUrl = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PreprocessingIssueAdvancedInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.PreprocessingIssueAdvancedInfo} PreprocessingIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PreprocessingIssueAdvancedInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PreprocessingIssueAdvancedInfo message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PreprocessingIssueAdvancedInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.video != null && message.hasOwnProperty("video")) {
                            var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.video);
                            if (error)
                                return "video." + error;
                        }
                        if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                            if (!$util.isString(message.videoUrl))
                                return "videoUrl: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a PreprocessingIssueAdvancedInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.PreprocessingIssueAdvancedInfo} PreprocessingIssueAdvancedInfo
                     */
                    PreprocessingIssueAdvancedInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo)
                            return object;
                        var message = new $root.palexy.store_issue.v1.PreprocessingIssueAdvancedInfo();
                        if (object.video != null) {
                            if (typeof object.video !== "object")
                                throw TypeError(".palexy.store_issue.v1.PreprocessingIssueAdvancedInfo.video: object expected");
                            message.video = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.video);
                        }
                        if (object.videoUrl != null)
                            message.videoUrl = String(object.videoUrl);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PreprocessingIssueAdvancedInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.PreprocessingIssueAdvancedInfo} message PreprocessingIssueAdvancedInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PreprocessingIssueAdvancedInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.video = null;
                            object.videoUrl = "";
                        }
                        if (message.video != null && message.hasOwnProperty("video"))
                            object.video = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.video, options);
                        if (message.videoUrl != null && message.hasOwnProperty("videoUrl"))
                            object.videoUrl = message.videoUrl;
                        return object;
                    };
    
                    /**
                     * Converts this PreprocessingIssueAdvancedInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.PreprocessingIssueAdvancedInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PreprocessingIssueAdvancedInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PreprocessingIssueAdvancedInfo;
                })();
    
                v1.CameraViewChangeIssueAdvancedInfo = (function() {
    
                    /**
                     * Properties of a CameraViewChangeIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @interface ICameraViewChangeIssueAdvancedInfo
                     * @property {Array.<palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair>|null} [cameraViewChangeImagePairs] CameraViewChangeIssueAdvancedInfo cameraViewChangeImagePairs
                     */
    
                    /**
                     * Constructs a new CameraViewChangeIssueAdvancedInfo.
                     * @memberof palexy.store_issue.v1
                     * @classdesc Represents a CameraViewChangeIssueAdvancedInfo.
                     * @implements ICameraViewChangeIssueAdvancedInfo
                     * @constructor
                     * @param {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo=} [properties] Properties to set
                     */
                    function CameraViewChangeIssueAdvancedInfo(properties) {
                        this.cameraViewChangeImagePairs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CameraViewChangeIssueAdvancedInfo cameraViewChangeImagePairs.
                     * @member {Array.<palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair>} cameraViewChangeImagePairs
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @instance
                     */
                    CameraViewChangeIssueAdvancedInfo.prototype.cameraViewChangeImagePairs = $util.emptyArray;
    
                    /**
                     * Creates a new CameraViewChangeIssueAdvancedInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo=} [properties] Properties to set
                     * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo} CameraViewChangeIssueAdvancedInfo instance
                     */
                    CameraViewChangeIssueAdvancedInfo.create = function create(properties) {
                        return new CameraViewChangeIssueAdvancedInfo(properties);
                    };
    
                    /**
                     * Encodes the specified CameraViewChangeIssueAdvancedInfo message. Does not implicitly {@link palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo} message CameraViewChangeIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraViewChangeIssueAdvancedInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.cameraViewChangeImagePairs != null && message.cameraViewChangeImagePairs.length)
                            for (var i = 0; i < message.cameraViewChangeImagePairs.length; ++i)
                                $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.encode(message.cameraViewChangeImagePairs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CameraViewChangeIssueAdvancedInfo message, length delimited. Does not implicitly {@link palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.ICameraViewChangeIssueAdvancedInfo} message CameraViewChangeIssueAdvancedInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CameraViewChangeIssueAdvancedInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CameraViewChangeIssueAdvancedInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo} CameraViewChangeIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraViewChangeIssueAdvancedInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.cameraViewChangeImagePairs && message.cameraViewChangeImagePairs.length))
                                    message.cameraViewChangeImagePairs = [];
                                message.cameraViewChangeImagePairs.push($root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CameraViewChangeIssueAdvancedInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo} CameraViewChangeIssueAdvancedInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CameraViewChangeIssueAdvancedInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CameraViewChangeIssueAdvancedInfo message.
                     * @function verify
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CameraViewChangeIssueAdvancedInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.cameraViewChangeImagePairs != null && message.hasOwnProperty("cameraViewChangeImagePairs")) {
                            if (!Array.isArray(message.cameraViewChangeImagePairs))
                                return "cameraViewChangeImagePairs: array expected";
                            for (var i = 0; i < message.cameraViewChangeImagePairs.length; ++i) {
                                var error = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.verify(message.cameraViewChangeImagePairs[i]);
                                if (error)
                                    return "cameraViewChangeImagePairs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CameraViewChangeIssueAdvancedInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo} CameraViewChangeIssueAdvancedInfo
                     */
                    CameraViewChangeIssueAdvancedInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo)
                            return object;
                        var message = new $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo();
                        if (object.cameraViewChangeImagePairs) {
                            if (!Array.isArray(object.cameraViewChangeImagePairs))
                                throw TypeError(".palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.cameraViewChangeImagePairs: array expected");
                            message.cameraViewChangeImagePairs = [];
                            for (var i = 0; i < object.cameraViewChangeImagePairs.length; ++i) {
                                if (typeof object.cameraViewChangeImagePairs[i] !== "object")
                                    throw TypeError(".palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.cameraViewChangeImagePairs: object expected");
                                message.cameraViewChangeImagePairs[i] = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.fromObject(object.cameraViewChangeImagePairs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CameraViewChangeIssueAdvancedInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @static
                     * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo} message CameraViewChangeIssueAdvancedInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CameraViewChangeIssueAdvancedInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cameraViewChangeImagePairs = [];
                        if (message.cameraViewChangeImagePairs && message.cameraViewChangeImagePairs.length) {
                            object.cameraViewChangeImagePairs = [];
                            for (var j = 0; j < message.cameraViewChangeImagePairs.length; ++j)
                                object.cameraViewChangeImagePairs[j] = $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.toObject(message.cameraViewChangeImagePairs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CameraViewChangeIssueAdvancedInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CameraViewChangeIssueAdvancedInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair = (function() {
    
                        /**
                         * Properties of a CameraViewChangeImagePair.
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                         * @interface ICameraViewChangeImagePair
                         * @property {string|null} [cameraId] CameraViewChangeImagePair cameraId
                         * @property {number|null} [cameraDatabaseId] CameraViewChangeImagePair cameraDatabaseId
                         * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [testImage] CameraViewChangeImagePair testImage
                         * @property {palexy.streaming.v1.Artifact.IGCSFile|null} [referenceImage] CameraViewChangeImagePair referenceImage
                         */
    
                        /**
                         * Constructs a new CameraViewChangeImagePair.
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo
                         * @classdesc Represents a CameraViewChangeImagePair.
                         * @implements ICameraViewChangeImagePair
                         * @constructor
                         * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair=} [properties] Properties to set
                         */
                        function CameraViewChangeImagePair(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * CameraViewChangeImagePair cameraId.
                         * @member {string} cameraId
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @instance
                         */
                        CameraViewChangeImagePair.prototype.cameraId = "";
    
                        /**
                         * CameraViewChangeImagePair cameraDatabaseId.
                         * @member {number} cameraDatabaseId
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @instance
                         */
                        CameraViewChangeImagePair.prototype.cameraDatabaseId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * CameraViewChangeImagePair testImage.
                         * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} testImage
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @instance
                         */
                        CameraViewChangeImagePair.prototype.testImage = null;
    
                        /**
                         * CameraViewChangeImagePair referenceImage.
                         * @member {palexy.streaming.v1.Artifact.IGCSFile|null|undefined} referenceImage
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @instance
                         */
                        CameraViewChangeImagePair.prototype.referenceImage = null;
    
                        /**
                         * Creates a new CameraViewChangeImagePair instance using the specified properties.
                         * @function create
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair=} [properties] Properties to set
                         * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair} CameraViewChangeImagePair instance
                         */
                        CameraViewChangeImagePair.create = function create(properties) {
                            return new CameraViewChangeImagePair(properties);
                        };
    
                        /**
                         * Encodes the specified CameraViewChangeImagePair message. Does not implicitly {@link palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair} message CameraViewChangeImagePair message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CameraViewChangeImagePair.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.cameraId != null && Object.hasOwnProperty.call(message, "cameraId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.cameraId);
                            if (message.testImage != null && Object.hasOwnProperty.call(message, "testImage"))
                                $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.testImage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.referenceImage != null && Object.hasOwnProperty.call(message, "referenceImage"))
                                $root.palexy.streaming.v1.Artifact.GCSFile.encode(message.referenceImage, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.cameraDatabaseId != null && Object.hasOwnProperty.call(message, "cameraDatabaseId"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int64(message.cameraDatabaseId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified CameraViewChangeImagePair message, length delimited. Does not implicitly {@link palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.ICameraViewChangeImagePair} message CameraViewChangeImagePair message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        CameraViewChangeImagePair.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a CameraViewChangeImagePair message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair} CameraViewChangeImagePair
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CameraViewChangeImagePair.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.cameraId = reader.string();
                                    break;
                                case 4:
                                    message.cameraDatabaseId = reader.int64();
                                    break;
                                case 2:
                                    message.testImage = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.referenceImage = $root.palexy.streaming.v1.Artifact.GCSFile.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a CameraViewChangeImagePair message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair} CameraViewChangeImagePair
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        CameraViewChangeImagePair.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a CameraViewChangeImagePair message.
                         * @function verify
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        CameraViewChangeImagePair.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                                if (!$util.isString(message.cameraId))
                                    return "cameraId: string expected";
                            if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                                if (!$util.isInteger(message.cameraDatabaseId) && !(message.cameraDatabaseId && $util.isInteger(message.cameraDatabaseId.low) && $util.isInteger(message.cameraDatabaseId.high)))
                                    return "cameraDatabaseId: integer|Long expected";
                            if (message.testImage != null && message.hasOwnProperty("testImage")) {
                                var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.testImage);
                                if (error)
                                    return "testImage." + error;
                            }
                            if (message.referenceImage != null && message.hasOwnProperty("referenceImage")) {
                                var error = $root.palexy.streaming.v1.Artifact.GCSFile.verify(message.referenceImage);
                                if (error)
                                    return "referenceImage." + error;
                            }
                            return null;
                        };
    
                        /**
                         * Creates a CameraViewChangeImagePair message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair} CameraViewChangeImagePair
                         */
                        CameraViewChangeImagePair.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair)
                                return object;
                            var message = new $root.palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair();
                            if (object.cameraId != null)
                                message.cameraId = String(object.cameraId);
                            if (object.cameraDatabaseId != null)
                                if ($util.Long)
                                    (message.cameraDatabaseId = $util.Long.fromValue(object.cameraDatabaseId)).unsigned = false;
                                else if (typeof object.cameraDatabaseId === "string")
                                    message.cameraDatabaseId = parseInt(object.cameraDatabaseId, 10);
                                else if (typeof object.cameraDatabaseId === "number")
                                    message.cameraDatabaseId = object.cameraDatabaseId;
                                else if (typeof object.cameraDatabaseId === "object")
                                    message.cameraDatabaseId = new $util.LongBits(object.cameraDatabaseId.low >>> 0, object.cameraDatabaseId.high >>> 0).toNumber();
                            if (object.testImage != null) {
                                if (typeof object.testImage !== "object")
                                    throw TypeError(".palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.testImage: object expected");
                                message.testImage = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.testImage);
                            }
                            if (object.referenceImage != null) {
                                if (typeof object.referenceImage !== "object")
                                    throw TypeError(".palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair.referenceImage: object expected");
                                message.referenceImage = $root.palexy.streaming.v1.Artifact.GCSFile.fromObject(object.referenceImage);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a CameraViewChangeImagePair message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @static
                         * @param {palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair} message CameraViewChangeImagePair
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        CameraViewChangeImagePair.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.cameraId = "";
                                object.testImage = null;
                                object.referenceImage = null;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.cameraDatabaseId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.cameraDatabaseId = options.longs === String ? "0" : 0;
                            }
                            if (message.cameraId != null && message.hasOwnProperty("cameraId"))
                                object.cameraId = message.cameraId;
                            if (message.testImage != null && message.hasOwnProperty("testImage"))
                                object.testImage = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.testImage, options);
                            if (message.referenceImage != null && message.hasOwnProperty("referenceImage"))
                                object.referenceImage = $root.palexy.streaming.v1.Artifact.GCSFile.toObject(message.referenceImage, options);
                            if (message.cameraDatabaseId != null && message.hasOwnProperty("cameraDatabaseId"))
                                if (typeof message.cameraDatabaseId === "number")
                                    object.cameraDatabaseId = options.longs === String ? String(message.cameraDatabaseId) : message.cameraDatabaseId;
                                else
                                    object.cameraDatabaseId = options.longs === String ? $util.Long.prototype.toString.call(message.cameraDatabaseId) : options.longs === Number ? new $util.LongBits(message.cameraDatabaseId.low >>> 0, message.cameraDatabaseId.high >>> 0).toNumber() : message.cameraDatabaseId;
                            return object;
                        };
    
                        /**
                         * Converts this CameraViewChangeImagePair to JSON.
                         * @function toJSON
                         * @memberof palexy.store_issue.v1.CameraViewChangeIssueAdvancedInfo.CameraViewChangeImagePair
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        CameraViewChangeImagePair.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return CameraViewChangeImagePair;
                    })();
    
                    return CameraViewChangeIssueAdvancedInfo;
                })();
    
                return v1;
            })();
    
            return store_issue;
        })();
    
        palexy.protobuf = (function() {
    
            /**
             * Namespace protobuf.
             * @memberof palexy
             * @namespace
             */
            var protobuf = {};
    
            protobuf.EmailVerificationToken = (function() {
    
                /**
                 * Properties of an EmailVerificationToken.
                 * @memberof palexy.protobuf
                 * @interface IEmailVerificationToken
                 * @property {number|null} [id] EmailVerificationToken id
                 * @property {number|null} [accountId] EmailVerificationToken accountId
                 * @property {string|null} [email] EmailVerificationToken email
                 * @property {palexy.protobuf.EmailVerificationType|null} [verificationType] EmailVerificationToken verificationType
                 * @property {string|null} [token] EmailVerificationToken token
                 * @property {boolean|null} [isExpired] EmailVerificationToken isExpired
                 * @property {number|null} [expiryTimeMs] EmailVerificationToken expiryTimeMs
                 * @property {number|null} [createTimeMs] EmailVerificationToken createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] EmailVerificationToken lastUpdateTimeMs
                 * @property {number|null} [staffId] EmailVerificationToken staffId
                 * @property {number|null} [storeId] EmailVerificationToken storeId
                 */
    
                /**
                 * Constructs a new EmailVerificationToken.
                 * @memberof palexy.protobuf
                 * @classdesc Represents an EmailVerificationToken.
                 * @implements IEmailVerificationToken
                 * @constructor
                 * @param {palexy.protobuf.IEmailVerificationToken=} [properties] Properties to set
                 */
                function EmailVerificationToken(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EmailVerificationToken id.
                 * @member {number} id
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken accountId.
                 * @member {number} accountId
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.accountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken email.
                 * @member {string} email
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.email = "";
    
                /**
                 * EmailVerificationToken verificationType.
                 * @member {palexy.protobuf.EmailVerificationType} verificationType
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.verificationType = 0;
    
                /**
                 * EmailVerificationToken token.
                 * @member {string} token
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.token = "";
    
                /**
                 * EmailVerificationToken isExpired.
                 * @member {boolean} isExpired
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.isExpired = false;
    
                /**
                 * EmailVerificationToken expiryTimeMs.
                 * @member {number} expiryTimeMs
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.expiryTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmailVerificationToken storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 */
                EmailVerificationToken.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new EmailVerificationToken instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {palexy.protobuf.IEmailVerificationToken=} [properties] Properties to set
                 * @returns {palexy.protobuf.EmailVerificationToken} EmailVerificationToken instance
                 */
                EmailVerificationToken.create = function create(properties) {
                    return new EmailVerificationToken(properties);
                };
    
                /**
                 * Encodes the specified EmailVerificationToken message. Does not implicitly {@link palexy.protobuf.EmailVerificationToken.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {palexy.protobuf.IEmailVerificationToken} message EmailVerificationToken message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailVerificationToken.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.accountId != null && Object.hasOwnProperty.call(message, "accountId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.accountId);
                    if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                    if (message.verificationType != null && Object.hasOwnProperty.call(message, "verificationType"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.verificationType);
                    if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message.token);
                    if (message.isExpired != null && Object.hasOwnProperty.call(message, "isExpired"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isExpired);
                    if (message.expiryTimeMs != null && Object.hasOwnProperty.call(message, "expiryTimeMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.expiryTimeMs);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int64(message.staffId);
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int64(message.storeId);
                    return writer;
                };
    
                /**
                 * Encodes the specified EmailVerificationToken message, length delimited. Does not implicitly {@link palexy.protobuf.EmailVerificationToken.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {palexy.protobuf.IEmailVerificationToken} message EmailVerificationToken message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmailVerificationToken.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EmailVerificationToken message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.EmailVerificationToken} EmailVerificationToken
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailVerificationToken.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.EmailVerificationToken();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.accountId = reader.int64();
                            break;
                        case 3:
                            message.email = reader.string();
                            break;
                        case 4:
                            message.verificationType = reader.int32();
                            break;
                        case 5:
                            message.token = reader.string();
                            break;
                        case 6:
                            message.isExpired = reader.bool();
                            break;
                        case 7:
                            message.expiryTimeMs = reader.int64();
                            break;
                        case 8:
                            message.createTimeMs = reader.int64();
                            break;
                        case 9:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        case 10:
                            message.staffId = reader.int64();
                            break;
                        case 11:
                            message.storeId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EmailVerificationToken message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.EmailVerificationToken} EmailVerificationToken
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmailVerificationToken.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EmailVerificationToken message.
                 * @function verify
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmailVerificationToken.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.accountId != null && message.hasOwnProperty("accountId"))
                        if (!$util.isInteger(message.accountId) && !(message.accountId && $util.isInteger(message.accountId.low) && $util.isInteger(message.accountId.high)))
                            return "accountId: integer|Long expected";
                    if (message.email != null && message.hasOwnProperty("email"))
                        if (!$util.isString(message.email))
                            return "email: string expected";
                    if (message.verificationType != null && message.hasOwnProperty("verificationType"))
                        switch (message.verificationType) {
                        default:
                            return "verificationType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                            break;
                        }
                    if (message.token != null && message.hasOwnProperty("token"))
                        if (!$util.isString(message.token))
                            return "token: string expected";
                    if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                        if (typeof message.isExpired !== "boolean")
                            return "isExpired: boolean expected";
                    if (message.expiryTimeMs != null && message.hasOwnProperty("expiryTimeMs"))
                        if (!$util.isInteger(message.expiryTimeMs) && !(message.expiryTimeMs && $util.isInteger(message.expiryTimeMs.low) && $util.isInteger(message.expiryTimeMs.high)))
                            return "expiryTimeMs: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates an EmailVerificationToken message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.EmailVerificationToken} EmailVerificationToken
                 */
                EmailVerificationToken.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.EmailVerificationToken)
                        return object;
                    var message = new $root.palexy.protobuf.EmailVerificationToken();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.accountId != null)
                        if ($util.Long)
                            (message.accountId = $util.Long.fromValue(object.accountId)).unsigned = false;
                        else if (typeof object.accountId === "string")
                            message.accountId = parseInt(object.accountId, 10);
                        else if (typeof object.accountId === "number")
                            message.accountId = object.accountId;
                        else if (typeof object.accountId === "object")
                            message.accountId = new $util.LongBits(object.accountId.low >>> 0, object.accountId.high >>> 0).toNumber();
                    if (object.email != null)
                        message.email = String(object.email);
                    switch (object.verificationType) {
                    case "UNKNOWN_VERIFICATION_TYPE":
                    case 0:
                        message.verificationType = 0;
                        break;
                    case "ACCOUNT_CONFIRMATION":
                    case 1:
                        message.verificationType = 1;
                        break;
                    case "PASSWORD_RESET":
                    case 2:
                        message.verificationType = 2;
                        break;
                    case "EMAIL_VERIFICATION":
                    case 3:
                        message.verificationType = 3;
                        break;
                    case "STAFF_INVITATION":
                    case 4:
                        message.verificationType = 4;
                        break;
                    case "INVITE_STAFF_EMAIL":
                    case 5:
                        message.verificationType = 5;
                        break;
                    }
                    if (object.token != null)
                        message.token = String(object.token);
                    if (object.isExpired != null)
                        message.isExpired = Boolean(object.isExpired);
                    if (object.expiryTimeMs != null)
                        if ($util.Long)
                            (message.expiryTimeMs = $util.Long.fromValue(object.expiryTimeMs)).unsigned = false;
                        else if (typeof object.expiryTimeMs === "string")
                            message.expiryTimeMs = parseInt(object.expiryTimeMs, 10);
                        else if (typeof object.expiryTimeMs === "number")
                            message.expiryTimeMs = object.expiryTimeMs;
                        else if (typeof object.expiryTimeMs === "object")
                            message.expiryTimeMs = new $util.LongBits(object.expiryTimeMs.low >>> 0, object.expiryTimeMs.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from an EmailVerificationToken message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @static
                 * @param {palexy.protobuf.EmailVerificationToken} message EmailVerificationToken
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmailVerificationToken.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.accountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.accountId = options.longs === String ? "0" : 0;
                        object.email = "";
                        object.verificationType = options.enums === String ? "UNKNOWN_VERIFICATION_TYPE" : 0;
                        object.token = "";
                        object.isExpired = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.expiryTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.expiryTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.accountId != null && message.hasOwnProperty("accountId"))
                        if (typeof message.accountId === "number")
                            object.accountId = options.longs === String ? String(message.accountId) : message.accountId;
                        else
                            object.accountId = options.longs === String ? $util.Long.prototype.toString.call(message.accountId) : options.longs === Number ? new $util.LongBits(message.accountId.low >>> 0, message.accountId.high >>> 0).toNumber() : message.accountId;
                    if (message.email != null && message.hasOwnProperty("email"))
                        object.email = message.email;
                    if (message.verificationType != null && message.hasOwnProperty("verificationType"))
                        object.verificationType = options.enums === String ? $root.palexy.protobuf.EmailVerificationType[message.verificationType] : message.verificationType;
                    if (message.token != null && message.hasOwnProperty("token"))
                        object.token = message.token;
                    if (message.isExpired != null && message.hasOwnProperty("isExpired"))
                        object.isExpired = message.isExpired;
                    if (message.expiryTimeMs != null && message.hasOwnProperty("expiryTimeMs"))
                        if (typeof message.expiryTimeMs === "number")
                            object.expiryTimeMs = options.longs === String ? String(message.expiryTimeMs) : message.expiryTimeMs;
                        else
                            object.expiryTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.expiryTimeMs) : options.longs === Number ? new $util.LongBits(message.expiryTimeMs.low >>> 0, message.expiryTimeMs.high >>> 0).toNumber() : message.expiryTimeMs;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    return object;
                };
    
                /**
                 * Converts this EmailVerificationToken to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.EmailVerificationToken
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmailVerificationToken.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EmailVerificationToken;
            })();
    
            /**
             * EmailVerificationType enum.
             * @name palexy.protobuf.EmailVerificationType
             * @enum {number}
             * @property {number} UNKNOWN_VERIFICATION_TYPE=0 UNKNOWN_VERIFICATION_TYPE value
             * @property {number} ACCOUNT_CONFIRMATION=1 ACCOUNT_CONFIRMATION value
             * @property {number} PASSWORD_RESET=2 PASSWORD_RESET value
             * @property {number} EMAIL_VERIFICATION=3 EMAIL_VERIFICATION value
             * @property {number} STAFF_INVITATION=4 STAFF_INVITATION value
             * @property {number} INVITE_STAFF_EMAIL=5 INVITE_STAFF_EMAIL value
             */
            protobuf.EmailVerificationType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_VERIFICATION_TYPE"] = 0;
                values[valuesById[1] = "ACCOUNT_CONFIRMATION"] = 1;
                values[valuesById[2] = "PASSWORD_RESET"] = 2;
                values[valuesById[3] = "EMAIL_VERIFICATION"] = 3;
                values[valuesById[4] = "STAFF_INVITATION"] = 4;
                values[valuesById[5] = "INVITE_STAFF_EMAIL"] = 5;
                return values;
            })();
    
            protobuf.BreakTime = (function() {
    
                /**
                 * Properties of a BreakTime.
                 * @memberof palexy.protobuf
                 * @interface IBreakTime
                 * @property {number|null} [id] BreakTime id
                 * @property {string|null} [name] BreakTime name
                 * @property {palexy.protobuf.BreakTimeType|null} [type] BreakTime type
                 * @property {string|null} [startTime] BreakTime startTime
                 * @property {number|null} [duration] BreakTime duration
                 * @property {number|null} [createTimeMs] BreakTime createTimeMs
                 * @property {number|null} [shiftTemplateId] BreakTime shiftTemplateId
                 * @property {number|null} [staffShiftId] BreakTime staffShiftId
                 */
    
                /**
                 * Constructs a new BreakTime.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a BreakTime.
                 * @implements IBreakTime
                 * @constructor
                 * @param {palexy.protobuf.IBreakTime=} [properties] Properties to set
                 */
                function BreakTime(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * BreakTime id.
                 * @member {number} id
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * BreakTime name.
                 * @member {string} name
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.name = "";
    
                /**
                 * BreakTime type.
                 * @member {palexy.protobuf.BreakTimeType} type
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.type = 0;
    
                /**
                 * BreakTime startTime.
                 * @member {string} startTime
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.startTime = "";
    
                /**
                 * BreakTime duration.
                 * @member {number} duration
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.duration = 0;
    
                /**
                 * BreakTime createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * BreakTime shiftTemplateId.
                 * @member {number} shiftTemplateId
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * BreakTime staffShiftId.
                 * @member {number} staffShiftId
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 */
                BreakTime.prototype.staffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new BreakTime instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {palexy.protobuf.IBreakTime=} [properties] Properties to set
                 * @returns {palexy.protobuf.BreakTime} BreakTime instance
                 */
                BreakTime.create = function create(properties) {
                    return new BreakTime(properties);
                };
    
                /**
                 * Encodes the specified BreakTime message. Does not implicitly {@link palexy.protobuf.BreakTime.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {palexy.protobuf.IBreakTime} message BreakTime message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BreakTime.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.startTime);
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.duration);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                    if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.shiftTemplateId);
                    if (message.staffShiftId != null && Object.hasOwnProperty.call(message, "staffShiftId"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.staffShiftId);
                    return writer;
                };
    
                /**
                 * Encodes the specified BreakTime message, length delimited. Does not implicitly {@link palexy.protobuf.BreakTime.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {palexy.protobuf.IBreakTime} message BreakTime message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BreakTime.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a BreakTime message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.BreakTime} BreakTime
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BreakTime.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.BreakTime();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.type = reader.int32();
                            break;
                        case 4:
                            message.startTime = reader.string();
                            break;
                        case 5:
                            message.duration = reader.int32();
                            break;
                        case 6:
                            message.createTimeMs = reader.int64();
                            break;
                        case 7:
                            message.shiftTemplateId = reader.int64();
                            break;
                        case 8:
                            message.staffShiftId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a BreakTime message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.BreakTime} BreakTime
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BreakTime.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a BreakTime message.
                 * @function verify
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BreakTime.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (!$util.isString(message.startTime))
                            return "startTime: string expected";
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        if (!$util.isInteger(message.duration))
                            return "duration: integer expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                            return "shiftTemplateId: integer|Long expected";
                    if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                        if (!$util.isInteger(message.staffShiftId) && !(message.staffShiftId && $util.isInteger(message.staffShiftId.low) && $util.isInteger(message.staffShiftId.high)))
                            return "staffShiftId: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a BreakTime message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.BreakTime} BreakTime
                 */
                BreakTime.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.BreakTime)
                        return object;
                    var message = new $root.palexy.protobuf.BreakTime();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.name != null)
                        message.name = String(object.name);
                    switch (object.type) {
                    case "UNKNOWN_BREAK_TIME_TYPE":
                    case 0:
                        message.type = 0;
                        break;
                    case "PAID":
                    case 1:
                        message.type = 1;
                        break;
                    case "UNPAID":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.startTime != null)
                        message.startTime = String(object.startTime);
                    if (object.duration != null)
                        message.duration = object.duration | 0;
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.shiftTemplateId != null)
                        if ($util.Long)
                            (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                        else if (typeof object.shiftTemplateId === "string")
                            message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                        else if (typeof object.shiftTemplateId === "number")
                            message.shiftTemplateId = object.shiftTemplateId;
                        else if (typeof object.shiftTemplateId === "object")
                            message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                    if (object.staffShiftId != null)
                        if ($util.Long)
                            (message.staffShiftId = $util.Long.fromValue(object.staffShiftId)).unsigned = false;
                        else if (typeof object.staffShiftId === "string")
                            message.staffShiftId = parseInt(object.staffShiftId, 10);
                        else if (typeof object.staffShiftId === "number")
                            message.staffShiftId = object.staffShiftId;
                        else if (typeof object.staffShiftId === "object")
                            message.staffShiftId = new $util.LongBits(object.staffShiftId.low >>> 0, object.staffShiftId.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a BreakTime message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.BreakTime
                 * @static
                 * @param {palexy.protobuf.BreakTime} message BreakTime
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BreakTime.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.name = "";
                        object.type = options.enums === String ? "UNKNOWN_BREAK_TIME_TYPE" : 0;
                        object.startTime = "";
                        object.duration = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffShiftId = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.palexy.protobuf.BreakTimeType[message.type] : message.type;
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        object.startTime = message.startTime;
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = message.duration;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (typeof message.shiftTemplateId === "number")
                            object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                        else
                            object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                    if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                        if (typeof message.staffShiftId === "number")
                            object.staffShiftId = options.longs === String ? String(message.staffShiftId) : message.staffShiftId;
                        else
                            object.staffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftId) : options.longs === Number ? new $util.LongBits(message.staffShiftId.low >>> 0, message.staffShiftId.high >>> 0).toNumber() : message.staffShiftId;
                    return object;
                };
    
                /**
                 * Converts this BreakTime to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.BreakTime
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BreakTime.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return BreakTime;
            })();
    
            protobuf.BreakTimeTemplate = (function() {
    
                /**
                 * Properties of a BreakTimeTemplate.
                 * @memberof palexy.protobuf
                 * @interface IBreakTimeTemplate
                 * @property {number|null} [id] BreakTimeTemplate id
                 * @property {string|null} [name] BreakTimeTemplate name
                 * @property {palexy.protobuf.BreakTimeType|null} [type] BreakTimeTemplate type
                 * @property {string|null} [startTime] BreakTimeTemplate startTime
                 * @property {number|null} [duration] BreakTimeTemplate duration
                 * @property {number|null} [companyId] BreakTimeTemplate companyId
                 * @property {number|null} [createTimeMs] BreakTimeTemplate createTimeMs
                 */
    
                /**
                 * Constructs a new BreakTimeTemplate.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a BreakTimeTemplate.
                 * @implements IBreakTimeTemplate
                 * @constructor
                 * @param {palexy.protobuf.IBreakTimeTemplate=} [properties] Properties to set
                 */
                function BreakTimeTemplate(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * BreakTimeTemplate id.
                 * @member {number} id
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * BreakTimeTemplate name.
                 * @member {string} name
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.name = "";
    
                /**
                 * BreakTimeTemplate type.
                 * @member {palexy.protobuf.BreakTimeType} type
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.type = 0;
    
                /**
                 * BreakTimeTemplate startTime.
                 * @member {string} startTime
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.startTime = "";
    
                /**
                 * BreakTimeTemplate duration.
                 * @member {number} duration
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.duration = 0;
    
                /**
                 * BreakTimeTemplate companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * BreakTimeTemplate createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 */
                BreakTimeTemplate.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new BreakTimeTemplate instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {palexy.protobuf.IBreakTimeTemplate=} [properties] Properties to set
                 * @returns {palexy.protobuf.BreakTimeTemplate} BreakTimeTemplate instance
                 */
                BreakTimeTemplate.create = function create(properties) {
                    return new BreakTimeTemplate(properties);
                };
    
                /**
                 * Encodes the specified BreakTimeTemplate message. Does not implicitly {@link palexy.protobuf.BreakTimeTemplate.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {palexy.protobuf.IBreakTimeTemplate} message BreakTimeTemplate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BreakTimeTemplate.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.type);
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.startTime);
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.duration);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.companyId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified BreakTimeTemplate message, length delimited. Does not implicitly {@link palexy.protobuf.BreakTimeTemplate.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {palexy.protobuf.IBreakTimeTemplate} message BreakTimeTemplate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BreakTimeTemplate.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a BreakTimeTemplate message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.BreakTimeTemplate} BreakTimeTemplate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BreakTimeTemplate.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.BreakTimeTemplate();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.type = reader.int32();
                            break;
                        case 4:
                            message.startTime = reader.string();
                            break;
                        case 5:
                            message.duration = reader.int32();
                            break;
                        case 6:
                            message.companyId = reader.int64();
                            break;
                        case 7:
                            message.createTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a BreakTimeTemplate message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.BreakTimeTemplate} BreakTimeTemplate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BreakTimeTemplate.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a BreakTimeTemplate message.
                 * @function verify
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BreakTimeTemplate.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (!$util.isString(message.startTime))
                            return "startTime: string expected";
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        if (!$util.isInteger(message.duration))
                            return "duration: integer expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a BreakTimeTemplate message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.BreakTimeTemplate} BreakTimeTemplate
                 */
                BreakTimeTemplate.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.BreakTimeTemplate)
                        return object;
                    var message = new $root.palexy.protobuf.BreakTimeTemplate();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.name != null)
                        message.name = String(object.name);
                    switch (object.type) {
                    case "UNKNOWN_BREAK_TIME_TYPE":
                    case 0:
                        message.type = 0;
                        break;
                    case "PAID":
                    case 1:
                        message.type = 1;
                        break;
                    case "UNPAID":
                    case 2:
                        message.type = 2;
                        break;
                    }
                    if (object.startTime != null)
                        message.startTime = String(object.startTime);
                    if (object.duration != null)
                        message.duration = object.duration | 0;
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a BreakTimeTemplate message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @static
                 * @param {palexy.protobuf.BreakTimeTemplate} message BreakTimeTemplate
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BreakTimeTemplate.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.name = "";
                        object.type = options.enums === String ? "UNKNOWN_BREAK_TIME_TYPE" : 0;
                        object.startTime = "";
                        object.duration = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.palexy.protobuf.BreakTimeType[message.type] : message.type;
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        object.startTime = message.startTime;
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = message.duration;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    return object;
                };
    
                /**
                 * Converts this BreakTimeTemplate to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.BreakTimeTemplate
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BreakTimeTemplate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return BreakTimeTemplate;
            })();
    
            /**
             * BreakTimeType enum.
             * @name palexy.protobuf.BreakTimeType
             * @enum {number}
             * @property {number} UNKNOWN_BREAK_TIME_TYPE=0 UNKNOWN_BREAK_TIME_TYPE value
             * @property {number} PAID=1 PAID value
             * @property {number} UNPAID=2 UNPAID value
             */
            protobuf.BreakTimeType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_BREAK_TIME_TYPE"] = 0;
                values[valuesById[1] = "PAID"] = 1;
                values[valuesById[2] = "UNPAID"] = 2;
                return values;
            })();
    
            /**
             * NonCoverageTimeType enum.
             * @name palexy.protobuf.NonCoverageTimeType
             * @enum {number}
             * @property {number} UNKNOWN_NON_COVERAGE_TIME_TYPE=0 UNKNOWN_NON_COVERAGE_TIME_TYPE value
             * @property {number} TRAINING_AND_MEETING=1 TRAINING_AND_MEETING value
             * @property {number} ADMIN=2 ADMIN value
             * @property {number} INVENTORY=3 INVENTORY value
             * @property {number} CLEANING=4 CLEANING value
             * @property {number} SECURITY=5 SECURITY value
             * @property {number} OTHERS=6 OTHERS value
             * @property {number} OPEN=7 OPEN value
             * @property {number} CLOSE=8 CLOSE value
             */
            protobuf.NonCoverageTimeType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_NON_COVERAGE_TIME_TYPE"] = 0;
                values[valuesById[1] = "TRAINING_AND_MEETING"] = 1;
                values[valuesById[2] = "ADMIN"] = 2;
                values[valuesById[3] = "INVENTORY"] = 3;
                values[valuesById[4] = "CLEANING"] = 4;
                values[valuesById[5] = "SECURITY"] = 5;
                values[valuesById[6] = "OTHERS"] = 6;
                values[valuesById[7] = "OPEN"] = 7;
                values[valuesById[8] = "CLOSE"] = 8;
                return values;
            })();
    
            protobuf.NonCoverageTime = (function() {
    
                /**
                 * Properties of a NonCoverageTime.
                 * @memberof palexy.protobuf
                 * @interface INonCoverageTime
                 * @property {number|null} [id] NonCoverageTime id
                 * @property {palexy.protobuf.NonCoverageTimeType|null} [type] NonCoverageTime type
                 * @property {string|null} [startTime] NonCoverageTime startTime
                 * @property {number|null} [duration] NonCoverageTime duration
                 * @property {number|null} [staffShiftId] NonCoverageTime staffShiftId
                 * @property {number|null} [createTimeMs] NonCoverageTime createTimeMs
                 */
    
                /**
                 * Constructs a new NonCoverageTime.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a NonCoverageTime.
                 * @implements INonCoverageTime
                 * @constructor
                 * @param {palexy.protobuf.INonCoverageTime=} [properties] Properties to set
                 */
                function NonCoverageTime(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * NonCoverageTime id.
                 * @member {number} id
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * NonCoverageTime type.
                 * @member {palexy.protobuf.NonCoverageTimeType} type
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.type = 0;
    
                /**
                 * NonCoverageTime startTime.
                 * @member {string} startTime
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.startTime = "";
    
                /**
                 * NonCoverageTime duration.
                 * @member {number} duration
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.duration = 0;
    
                /**
                 * NonCoverageTime staffShiftId.
                 * @member {number} staffShiftId
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.staffShiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * NonCoverageTime createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 */
                NonCoverageTime.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new NonCoverageTime instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {palexy.protobuf.INonCoverageTime=} [properties] Properties to set
                 * @returns {palexy.protobuf.NonCoverageTime} NonCoverageTime instance
                 */
                NonCoverageTime.create = function create(properties) {
                    return new NonCoverageTime(properties);
                };
    
                /**
                 * Encodes the specified NonCoverageTime message. Does not implicitly {@link palexy.protobuf.NonCoverageTime.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {palexy.protobuf.INonCoverageTime} message NonCoverageTime message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NonCoverageTime.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.type);
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.startTime);
                    if (message.duration != null && Object.hasOwnProperty.call(message, "duration"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.duration);
                    if (message.staffShiftId != null && Object.hasOwnProperty.call(message, "staffShiftId"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.staffShiftId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified NonCoverageTime message, length delimited. Does not implicitly {@link palexy.protobuf.NonCoverageTime.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {palexy.protobuf.INonCoverageTime} message NonCoverageTime message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NonCoverageTime.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a NonCoverageTime message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.NonCoverageTime} NonCoverageTime
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NonCoverageTime.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.NonCoverageTime();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.type = reader.int32();
                            break;
                        case 3:
                            message.startTime = reader.string();
                            break;
                        case 4:
                            message.duration = reader.int32();
                            break;
                        case 5:
                            message.staffShiftId = reader.int64();
                            break;
                        case 6:
                            message.createTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a NonCoverageTime message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.NonCoverageTime} NonCoverageTime
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NonCoverageTime.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a NonCoverageTime message.
                 * @function verify
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NonCoverageTime.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (!$util.isString(message.startTime))
                            return "startTime: string expected";
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        if (!$util.isInteger(message.duration))
                            return "duration: integer expected";
                    if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                        if (!$util.isInteger(message.staffShiftId) && !(message.staffShiftId && $util.isInteger(message.staffShiftId.low) && $util.isInteger(message.staffShiftId.high)))
                            return "staffShiftId: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a NonCoverageTime message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.NonCoverageTime} NonCoverageTime
                 */
                NonCoverageTime.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.NonCoverageTime)
                        return object;
                    var message = new $root.palexy.protobuf.NonCoverageTime();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    switch (object.type) {
                    case "UNKNOWN_NON_COVERAGE_TIME_TYPE":
                    case 0:
                        message.type = 0;
                        break;
                    case "TRAINING_AND_MEETING":
                    case 1:
                        message.type = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.type = 2;
                        break;
                    case "INVENTORY":
                    case 3:
                        message.type = 3;
                        break;
                    case "CLEANING":
                    case 4:
                        message.type = 4;
                        break;
                    case "SECURITY":
                    case 5:
                        message.type = 5;
                        break;
                    case "OTHERS":
                    case 6:
                        message.type = 6;
                        break;
                    case "OPEN":
                    case 7:
                        message.type = 7;
                        break;
                    case "CLOSE":
                    case 8:
                        message.type = 8;
                        break;
                    }
                    if (object.startTime != null)
                        message.startTime = String(object.startTime);
                    if (object.duration != null)
                        message.duration = object.duration | 0;
                    if (object.staffShiftId != null)
                        if ($util.Long)
                            (message.staffShiftId = $util.Long.fromValue(object.staffShiftId)).unsigned = false;
                        else if (typeof object.staffShiftId === "string")
                            message.staffShiftId = parseInt(object.staffShiftId, 10);
                        else if (typeof object.staffShiftId === "number")
                            message.staffShiftId = object.staffShiftId;
                        else if (typeof object.staffShiftId === "object")
                            message.staffShiftId = new $util.LongBits(object.staffShiftId.low >>> 0, object.staffShiftId.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a NonCoverageTime message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @static
                 * @param {palexy.protobuf.NonCoverageTime} message NonCoverageTime
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NonCoverageTime.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.type = options.enums === String ? "UNKNOWN_NON_COVERAGE_TIME_TYPE" : 0;
                        object.startTime = "";
                        object.duration = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffShiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffShiftId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.palexy.protobuf.NonCoverageTimeType[message.type] : message.type;
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        object.startTime = message.startTime;
                    if (message.duration != null && message.hasOwnProperty("duration"))
                        object.duration = message.duration;
                    if (message.staffShiftId != null && message.hasOwnProperty("staffShiftId"))
                        if (typeof message.staffShiftId === "number")
                            object.staffShiftId = options.longs === String ? String(message.staffShiftId) : message.staffShiftId;
                        else
                            object.staffShiftId = options.longs === String ? $util.Long.prototype.toString.call(message.staffShiftId) : options.longs === Number ? new $util.LongBits(message.staffShiftId.low >>> 0, message.staffShiftId.high >>> 0).toNumber() : message.staffShiftId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    return object;
                };
    
                /**
                 * Converts this NonCoverageTime to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.NonCoverageTime
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NonCoverageTime.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return NonCoverageTime;
            })();
    
            protobuf.NonCoveragePositionMapping = (function() {
    
                /**
                 * Properties of a NonCoveragePositionMapping.
                 * @memberof palexy.protobuf
                 * @interface INonCoveragePositionMapping
                 * @property {number|null} [positionId] NonCoveragePositionMapping positionId
                 * @property {palexy.protobuf.NonCoverageTimeType|null} [nonCoverageType] NonCoveragePositionMapping nonCoverageType
                 */
    
                /**
                 * Constructs a new NonCoveragePositionMapping.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a NonCoveragePositionMapping.
                 * @implements INonCoveragePositionMapping
                 * @constructor
                 * @param {palexy.protobuf.INonCoveragePositionMapping=} [properties] Properties to set
                 */
                function NonCoveragePositionMapping(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * NonCoveragePositionMapping positionId.
                 * @member {number} positionId
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @instance
                 */
                NonCoveragePositionMapping.prototype.positionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * NonCoveragePositionMapping nonCoverageType.
                 * @member {palexy.protobuf.NonCoverageTimeType} nonCoverageType
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @instance
                 */
                NonCoveragePositionMapping.prototype.nonCoverageType = 0;
    
                /**
                 * Creates a new NonCoveragePositionMapping instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {palexy.protobuf.INonCoveragePositionMapping=} [properties] Properties to set
                 * @returns {palexy.protobuf.NonCoveragePositionMapping} NonCoveragePositionMapping instance
                 */
                NonCoveragePositionMapping.create = function create(properties) {
                    return new NonCoveragePositionMapping(properties);
                };
    
                /**
                 * Encodes the specified NonCoveragePositionMapping message. Does not implicitly {@link palexy.protobuf.NonCoveragePositionMapping.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {palexy.protobuf.INonCoveragePositionMapping} message NonCoveragePositionMapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NonCoveragePositionMapping.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.positionId != null && Object.hasOwnProperty.call(message, "positionId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.positionId);
                    if (message.nonCoverageType != null && Object.hasOwnProperty.call(message, "nonCoverageType"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nonCoverageType);
                    return writer;
                };
    
                /**
                 * Encodes the specified NonCoveragePositionMapping message, length delimited. Does not implicitly {@link palexy.protobuf.NonCoveragePositionMapping.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {palexy.protobuf.INonCoveragePositionMapping} message NonCoveragePositionMapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                NonCoveragePositionMapping.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a NonCoveragePositionMapping message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.NonCoveragePositionMapping} NonCoveragePositionMapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NonCoveragePositionMapping.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.NonCoveragePositionMapping();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.positionId = reader.int64();
                            break;
                        case 2:
                            message.nonCoverageType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a NonCoveragePositionMapping message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.NonCoveragePositionMapping} NonCoveragePositionMapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                NonCoveragePositionMapping.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a NonCoveragePositionMapping message.
                 * @function verify
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                NonCoveragePositionMapping.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (!$util.isInteger(message.positionId) && !(message.positionId && $util.isInteger(message.positionId.low) && $util.isInteger(message.positionId.high)))
                            return "positionId: integer|Long expected";
                    if (message.nonCoverageType != null && message.hasOwnProperty("nonCoverageType"))
                        switch (message.nonCoverageType) {
                        default:
                            return "nonCoverageType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    return null;
                };
    
                /**
                 * Creates a NonCoveragePositionMapping message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.NonCoveragePositionMapping} NonCoveragePositionMapping
                 */
                NonCoveragePositionMapping.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.NonCoveragePositionMapping)
                        return object;
                    var message = new $root.palexy.protobuf.NonCoveragePositionMapping();
                    if (object.positionId != null)
                        if ($util.Long)
                            (message.positionId = $util.Long.fromValue(object.positionId)).unsigned = false;
                        else if (typeof object.positionId === "string")
                            message.positionId = parseInt(object.positionId, 10);
                        else if (typeof object.positionId === "number")
                            message.positionId = object.positionId;
                        else if (typeof object.positionId === "object")
                            message.positionId = new $util.LongBits(object.positionId.low >>> 0, object.positionId.high >>> 0).toNumber();
                    switch (object.nonCoverageType) {
                    case "UNKNOWN_NON_COVERAGE_TIME_TYPE":
                    case 0:
                        message.nonCoverageType = 0;
                        break;
                    case "TRAINING_AND_MEETING":
                    case 1:
                        message.nonCoverageType = 1;
                        break;
                    case "ADMIN":
                    case 2:
                        message.nonCoverageType = 2;
                        break;
                    case "INVENTORY":
                    case 3:
                        message.nonCoverageType = 3;
                        break;
                    case "CLEANING":
                    case 4:
                        message.nonCoverageType = 4;
                        break;
                    case "SECURITY":
                    case 5:
                        message.nonCoverageType = 5;
                        break;
                    case "OTHERS":
                    case 6:
                        message.nonCoverageType = 6;
                        break;
                    case "OPEN":
                    case 7:
                        message.nonCoverageType = 7;
                        break;
                    case "CLOSE":
                    case 8:
                        message.nonCoverageType = 8;
                        break;
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a NonCoveragePositionMapping message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @static
                 * @param {palexy.protobuf.NonCoveragePositionMapping} message NonCoveragePositionMapping
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                NonCoveragePositionMapping.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.positionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.positionId = options.longs === String ? "0" : 0;
                        object.nonCoverageType = options.enums === String ? "UNKNOWN_NON_COVERAGE_TIME_TYPE" : 0;
                    }
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (typeof message.positionId === "number")
                            object.positionId = options.longs === String ? String(message.positionId) : message.positionId;
                        else
                            object.positionId = options.longs === String ? $util.Long.prototype.toString.call(message.positionId) : options.longs === Number ? new $util.LongBits(message.positionId.low >>> 0, message.positionId.high >>> 0).toNumber() : message.positionId;
                    if (message.nonCoverageType != null && message.hasOwnProperty("nonCoverageType"))
                        object.nonCoverageType = options.enums === String ? $root.palexy.protobuf.NonCoverageTimeType[message.nonCoverageType] : message.nonCoverageType;
                    return object;
                };
    
                /**
                 * Converts this NonCoveragePositionMapping to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.NonCoveragePositionMapping
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                NonCoveragePositionMapping.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return NonCoveragePositionMapping;
            })();
    
            protobuf.ScheduleExportFormatConfigPb = (function() {
    
                /**
                 * Properties of a ScheduleExportFormatConfigPb.
                 * @memberof palexy.protobuf
                 * @interface IScheduleExportFormatConfigPb
                 * @property {number|null} [id] ScheduleExportFormatConfigPb id
                 * @property {number|null} [companyId] ScheduleExportFormatConfigPb companyId
                 * @property {string|null} [scheduleSheetName] ScheduleExportFormatConfigPb scheduleSheetName
                 * @property {string|null} [shiftDefinitionSheetName] ScheduleExportFormatConfigPb shiftDefinitionSheetName
                 * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat|null} [extraInfoFormat] ScheduleExportFormatConfigPb extraInfoFormat
                 * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat|null} [staffInfoFormat] ScheduleExportFormatConfigPb staffInfoFormat
                 * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat|null} [scheduleDetailsFormat] ScheduleExportFormatConfigPb scheduleDetailsFormat
                 * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat|null} [shiftDefinitionInfoFormat] ScheduleExportFormatConfigPb shiftDefinitionInfoFormat
                 */
    
                /**
                 * Constructs a new ScheduleExportFormatConfigPb.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleExportFormatConfigPb.
                 * @implements IScheduleExportFormatConfigPb
                 * @constructor
                 * @param {palexy.protobuf.IScheduleExportFormatConfigPb=} [properties] Properties to set
                 */
                function ScheduleExportFormatConfigPb(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleExportFormatConfigPb id.
                 * @member {number} id
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleExportFormatConfigPb companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleExportFormatConfigPb scheduleSheetName.
                 * @member {string} scheduleSheetName
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.scheduleSheetName = "";
    
                /**
                 * ScheduleExportFormatConfigPb shiftDefinitionSheetName.
                 * @member {string} shiftDefinitionSheetName
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.shiftDefinitionSheetName = "";
    
                /**
                 * ScheduleExportFormatConfigPb extraInfoFormat.
                 * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat|null|undefined} extraInfoFormat
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.extraInfoFormat = null;
    
                /**
                 * ScheduleExportFormatConfigPb staffInfoFormat.
                 * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat|null|undefined} staffInfoFormat
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.staffInfoFormat = null;
    
                /**
                 * ScheduleExportFormatConfigPb scheduleDetailsFormat.
                 * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat|null|undefined} scheduleDetailsFormat
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.scheduleDetailsFormat = null;
    
                /**
                 * ScheduleExportFormatConfigPb shiftDefinitionInfoFormat.
                 * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat|null|undefined} shiftDefinitionInfoFormat
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 */
                ScheduleExportFormatConfigPb.prototype.shiftDefinitionInfoFormat = null;
    
                /**
                 * Creates a new ScheduleExportFormatConfigPb instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {palexy.protobuf.IScheduleExportFormatConfigPb=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleExportFormatConfigPb} ScheduleExportFormatConfigPb instance
                 */
                ScheduleExportFormatConfigPb.create = function create(properties) {
                    return new ScheduleExportFormatConfigPb(properties);
                };
    
                /**
                 * Encodes the specified ScheduleExportFormatConfigPb message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {palexy.protobuf.IScheduleExportFormatConfigPb} message ScheduleExportFormatConfigPb message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleExportFormatConfigPb.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                    if (message.extraInfoFormat != null && Object.hasOwnProperty.call(message, "extraInfoFormat"))
                        $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.encode(message.extraInfoFormat, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.staffInfoFormat != null && Object.hasOwnProperty.call(message, "staffInfoFormat"))
                        $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.encode(message.staffInfoFormat, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.scheduleDetailsFormat != null && Object.hasOwnProperty.call(message, "scheduleDetailsFormat"))
                        $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.encode(message.scheduleDetailsFormat, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.shiftDefinitionInfoFormat != null && Object.hasOwnProperty.call(message, "shiftDefinitionInfoFormat"))
                        $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.encode(message.shiftDefinitionInfoFormat, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.scheduleSheetName != null && Object.hasOwnProperty.call(message, "scheduleSheetName"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.scheduleSheetName);
                    if (message.shiftDefinitionSheetName != null && Object.hasOwnProperty.call(message, "shiftDefinitionSheetName"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.shiftDefinitionSheetName);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleExportFormatConfigPb message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {palexy.protobuf.IScheduleExportFormatConfigPb} message ScheduleExportFormatConfigPb message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleExportFormatConfigPb.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleExportFormatConfigPb message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleExportFormatConfigPb} ScheduleExportFormatConfigPb
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleExportFormatConfigPb.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.companyId = reader.int64();
                            break;
                        case 7:
                            message.scheduleSheetName = reader.string();
                            break;
                        case 8:
                            message.shiftDefinitionSheetName = reader.string();
                            break;
                        case 3:
                            message.extraInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.decode(reader, reader.uint32());
                            break;
                        case 4:
                            message.staffInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.scheduleDetailsFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.shiftDefinitionInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleExportFormatConfigPb message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleExportFormatConfigPb} ScheduleExportFormatConfigPb
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleExportFormatConfigPb.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleExportFormatConfigPb message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleExportFormatConfigPb.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.scheduleSheetName != null && message.hasOwnProperty("scheduleSheetName"))
                        if (!$util.isString(message.scheduleSheetName))
                            return "scheduleSheetName: string expected";
                    if (message.shiftDefinitionSheetName != null && message.hasOwnProperty("shiftDefinitionSheetName"))
                        if (!$util.isString(message.shiftDefinitionSheetName))
                            return "shiftDefinitionSheetName: string expected";
                    if (message.extraInfoFormat != null && message.hasOwnProperty("extraInfoFormat")) {
                        var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.verify(message.extraInfoFormat);
                        if (error)
                            return "extraInfoFormat." + error;
                    }
                    if (message.staffInfoFormat != null && message.hasOwnProperty("staffInfoFormat")) {
                        var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.verify(message.staffInfoFormat);
                        if (error)
                            return "staffInfoFormat." + error;
                    }
                    if (message.scheduleDetailsFormat != null && message.hasOwnProperty("scheduleDetailsFormat")) {
                        var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.verify(message.scheduleDetailsFormat);
                        if (error)
                            return "scheduleDetailsFormat." + error;
                    }
                    if (message.shiftDefinitionInfoFormat != null && message.hasOwnProperty("shiftDefinitionInfoFormat")) {
                        var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.verify(message.shiftDefinitionInfoFormat);
                        if (error)
                            return "shiftDefinitionInfoFormat." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a ScheduleExportFormatConfigPb message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleExportFormatConfigPb} ScheduleExportFormatConfigPb
                 */
                ScheduleExportFormatConfigPb.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    if (object.scheduleSheetName != null)
                        message.scheduleSheetName = String(object.scheduleSheetName);
                    if (object.shiftDefinitionSheetName != null)
                        message.shiftDefinitionSheetName = String(object.shiftDefinitionSheetName);
                    if (object.extraInfoFormat != null) {
                        if (typeof object.extraInfoFormat !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.extraInfoFormat: object expected");
                        message.extraInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.fromObject(object.extraInfoFormat);
                    }
                    if (object.staffInfoFormat != null) {
                        if (typeof object.staffInfoFormat !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.staffInfoFormat: object expected");
                        message.staffInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.fromObject(object.staffInfoFormat);
                    }
                    if (object.scheduleDetailsFormat != null) {
                        if (typeof object.scheduleDetailsFormat !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.scheduleDetailsFormat: object expected");
                        message.scheduleDetailsFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.fromObject(object.scheduleDetailsFormat);
                    }
                    if (object.shiftDefinitionInfoFormat != null) {
                        if (typeof object.shiftDefinitionInfoFormat !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.shiftDefinitionInfoFormat: object expected");
                        message.shiftDefinitionInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.fromObject(object.shiftDefinitionInfoFormat);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleExportFormatConfigPb message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @static
                 * @param {palexy.protobuf.ScheduleExportFormatConfigPb} message ScheduleExportFormatConfigPb
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleExportFormatConfigPb.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        object.extraInfoFormat = null;
                        object.staffInfoFormat = null;
                        object.scheduleDetailsFormat = null;
                        object.shiftDefinitionInfoFormat = null;
                        object.scheduleSheetName = "";
                        object.shiftDefinitionSheetName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.extraInfoFormat != null && message.hasOwnProperty("extraInfoFormat"))
                        object.extraInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.toObject(message.extraInfoFormat, options);
                    if (message.staffInfoFormat != null && message.hasOwnProperty("staffInfoFormat"))
                        object.staffInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.toObject(message.staffInfoFormat, options);
                    if (message.scheduleDetailsFormat != null && message.hasOwnProperty("scheduleDetailsFormat"))
                        object.scheduleDetailsFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.toObject(message.scheduleDetailsFormat, options);
                    if (message.shiftDefinitionInfoFormat != null && message.hasOwnProperty("shiftDefinitionInfoFormat"))
                        object.shiftDefinitionInfoFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.toObject(message.shiftDefinitionInfoFormat, options);
                    if (message.scheduleSheetName != null && message.hasOwnProperty("scheduleSheetName"))
                        object.scheduleSheetName = message.scheduleSheetName;
                    if (message.shiftDefinitionSheetName != null && message.hasOwnProperty("shiftDefinitionSheetName"))
                        object.shiftDefinitionSheetName = message.shiftDefinitionSheetName;
                    return object;
                };
    
                /**
                 * Converts this ScheduleExportFormatConfigPb to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleExportFormatConfigPb.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                ScheduleExportFormatConfigPb.ExtraInfoFormat = (function() {
    
                    /**
                     * Properties of an ExtraInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IExtraInfoFormat
                     * @property {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo>|null} [extraInfos] ExtraInfoFormat extraInfos
                     */
    
                    /**
                     * Constructs a new ExtraInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents an ExtraInfoFormat.
                     * @implements IExtraInfoFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat=} [properties] Properties to set
                     */
                    function ExtraInfoFormat(properties) {
                        this.extraInfos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExtraInfoFormat extraInfos.
                     * @member {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo>} extraInfos
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @instance
                     */
                    ExtraInfoFormat.prototype.extraInfos = $util.emptyArray;
    
                    /**
                     * Creates a new ExtraInfoFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat} ExtraInfoFormat instance
                     */
                    ExtraInfoFormat.create = function create(properties) {
                        return new ExtraInfoFormat(properties);
                    };
    
                    /**
                     * Encodes the specified ExtraInfoFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat} message ExtraInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtraInfoFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.extraInfos != null && message.extraInfos.length)
                            for (var i = 0; i < message.extraInfos.length; ++i)
                                $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.encode(message.extraInfos[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExtraInfoFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfoFormat} message ExtraInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtraInfoFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExtraInfoFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat} ExtraInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtraInfoFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 2:
                                if (!(message.extraInfos && message.extraInfos.length))
                                    message.extraInfos = [];
                                message.extraInfos.push($root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExtraInfoFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat} ExtraInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtraInfoFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExtraInfoFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExtraInfoFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.extraInfos != null && message.hasOwnProperty("extraInfos")) {
                            if (!Array.isArray(message.extraInfos))
                                return "extraInfos: array expected";
                            for (var i = 0; i < message.extraInfos.length; ++i) {
                                var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.verify(message.extraInfos[i]);
                                if (error)
                                    return "extraInfos." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ExtraInfoFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat} ExtraInfoFormat
                     */
                    ExtraInfoFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat();
                        if (object.extraInfos) {
                            if (!Array.isArray(object.extraInfos))
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.extraInfos: array expected");
                            message.extraInfos = [];
                            for (var i = 0; i < object.extraInfos.length; ++i) {
                                if (typeof object.extraInfos[i] !== "object")
                                    throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat.extraInfos: object expected");
                                message.extraInfos[i] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.fromObject(object.extraInfos[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExtraInfoFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat} message ExtraInfoFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExtraInfoFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.extraInfos = [];
                        if (message.extraInfos && message.extraInfos.length) {
                            object.extraInfos = [];
                            for (var j = 0; j < message.extraInfos.length; ++j)
                                object.extraInfos[j] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.toObject(message.extraInfos[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ExtraInfoFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExtraInfoFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExtraInfoFormat;
                })();
    
                ScheduleExportFormatConfigPb.ExtraInfo = (function() {
    
                    /**
                     * Properties of an ExtraInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IExtraInfo
                     * @property {string|null} [startPosition] ExtraInfo startPosition
                     * @property {string|null} [endPosition] ExtraInfo endPosition
                     * @property {string|null} [customSyntax] ExtraInfo customSyntax
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoType|null} [extraInfoType] ExtraInfo extraInfoType
                     */
    
                    /**
                     * Constructs a new ExtraInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents an ExtraInfo.
                     * @implements IExtraInfo
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo=} [properties] Properties to set
                     */
                    function ExtraInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExtraInfo startPosition.
                     * @member {string} startPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @instance
                     */
                    ExtraInfo.prototype.startPosition = "";
    
                    /**
                     * ExtraInfo endPosition.
                     * @member {string} endPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @instance
                     */
                    ExtraInfo.prototype.endPosition = "";
    
                    /**
                     * ExtraInfo customSyntax.
                     * @member {string} customSyntax
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @instance
                     */
                    ExtraInfo.prototype.customSyntax = "";
    
                    /**
                     * ExtraInfo extraInfoType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoType} extraInfoType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @instance
                     */
                    ExtraInfo.prototype.extraInfoType = 0;
    
                    /**
                     * Creates a new ExtraInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo} ExtraInfo instance
                     */
                    ExtraInfo.create = function create(properties) {
                        return new ExtraInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ExtraInfo message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo} message ExtraInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtraInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startPosition != null && Object.hasOwnProperty.call(message, "startPosition"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startPosition);
                        if (message.endPosition != null && Object.hasOwnProperty.call(message, "endPosition"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endPosition);
                        if (message.customSyntax != null && Object.hasOwnProperty.call(message, "customSyntax"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.customSyntax);
                        if (message.extraInfoType != null && Object.hasOwnProperty.call(message, "extraInfoType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.extraInfoType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExtraInfo message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IExtraInfo} message ExtraInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtraInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExtraInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo} ExtraInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtraInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startPosition = reader.string();
                                break;
                            case 2:
                                message.endPosition = reader.string();
                                break;
                            case 3:
                                message.customSyntax = reader.string();
                                break;
                            case 4:
                                message.extraInfoType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExtraInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo} ExtraInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtraInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExtraInfo message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExtraInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            if (!$util.isString(message.startPosition))
                                return "startPosition: string expected";
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            if (!$util.isString(message.endPosition))
                                return "endPosition: string expected";
                        if (message.customSyntax != null && message.hasOwnProperty("customSyntax"))
                            if (!$util.isString(message.customSyntax))
                                return "customSyntax: string expected";
                        if (message.extraInfoType != null && message.hasOwnProperty("extraInfoType"))
                            switch (message.extraInfoType) {
                            default:
                                return "extraInfoType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates an ExtraInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo} ExtraInfo
                     */
                    ExtraInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo();
                        if (object.startPosition != null)
                            message.startPosition = String(object.startPosition);
                        if (object.endPosition != null)
                            message.endPosition = String(object.endPosition);
                        if (object.customSyntax != null)
                            message.customSyntax = String(object.customSyntax);
                        switch (object.extraInfoType) {
                        case "UNKNOWN_EXTRA_INFO_TYPE":
                        case 0:
                            message.extraInfoType = 0;
                            break;
                        case "CUSTOM_SYNTAX":
                        case 1:
                            message.extraInfoType = 1;
                            break;
                        case "STORE_NAME":
                        case 2:
                            message.extraInfoType = 2;
                            break;
                        case "STORE_CODE":
                        case 3:
                            message.extraInfoType = 3;
                            break;
                        case "MONTH_YEAR":
                        case 4:
                            message.extraInfoType = 4;
                            break;
                        case "THAI_MONTH_YEAR":
                        case 5:
                            message.extraInfoType = 5;
                            break;
                        case "START_DATE_DD_MM_YYYY":
                        case 6:
                            message.extraInfoType = 6;
                            break;
                        case "END_DATE_DD_MM_YYYY":
                        case 7:
                            message.extraInfoType = 7;
                            break;
                        case "START_DAY_OF_MONTH":
                        case 8:
                            message.extraInfoType = 8;
                            break;
                        case "START_MONTH":
                        case 9:
                            message.extraInfoType = 9;
                            break;
                        case "START_YEAR":
                        case 10:
                            message.extraInfoType = 10;
                            break;
                        case "END_DAY_OF_MONTH":
                        case 11:
                            message.extraInfoType = 11;
                            break;
                        case "END_MONTH":
                        case 12:
                            message.extraInfoType = 12;
                            break;
                        case "END_YEAR":
                        case 13:
                            message.extraInfoType = 13;
                            break;
                        case "START_DATE_DD_MM":
                        case 14:
                            message.extraInfoType = 14;
                            break;
                        case "END_DATE_DD_MM":
                        case 15:
                            message.extraInfoType = 15;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExtraInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo} message ExtraInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExtraInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startPosition = "";
                            object.endPosition = "";
                            object.customSyntax = "";
                            object.extraInfoType = options.enums === String ? "UNKNOWN_EXTRA_INFO_TYPE" : 0;
                        }
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            object.startPosition = message.startPosition;
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            object.endPosition = message.endPosition;
                        if (message.customSyntax != null && message.hasOwnProperty("customSyntax"))
                            object.customSyntax = message.customSyntax;
                        if (message.extraInfoType != null && message.hasOwnProperty("extraInfoType"))
                            object.extraInfoType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoType[message.extraInfoType] : message.extraInfoType;
                        return object;
                    };
    
                    /**
                     * Converts this ExtraInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExtraInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExtraInfo;
                })();
    
                /**
                 * ExtraInfoType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.ExtraInfoType
                 * @enum {number}
                 * @property {number} UNKNOWN_EXTRA_INFO_TYPE=0 UNKNOWN_EXTRA_INFO_TYPE value
                 * @property {number} CUSTOM_SYNTAX=1 CUSTOM_SYNTAX value
                 * @property {number} STORE_NAME=2 STORE_NAME value
                 * @property {number} STORE_CODE=3 STORE_CODE value
                 * @property {number} MONTH_YEAR=4 MONTH_YEAR value
                 * @property {number} THAI_MONTH_YEAR=5 THAI_MONTH_YEAR value
                 * @property {number} START_DATE_DD_MM_YYYY=6 START_DATE_DD_MM_YYYY value
                 * @property {number} END_DATE_DD_MM_YYYY=7 END_DATE_DD_MM_YYYY value
                 * @property {number} START_DAY_OF_MONTH=8 START_DAY_OF_MONTH value
                 * @property {number} START_MONTH=9 START_MONTH value
                 * @property {number} START_YEAR=10 START_YEAR value
                 * @property {number} END_DAY_OF_MONTH=11 END_DAY_OF_MONTH value
                 * @property {number} END_MONTH=12 END_MONTH value
                 * @property {number} END_YEAR=13 END_YEAR value
                 * @property {number} START_DATE_DD_MM=14 START_DATE_DD_MM value
                 * @property {number} END_DATE_DD_MM=15 END_DATE_DD_MM value
                 */
                ScheduleExportFormatConfigPb.ExtraInfoType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_EXTRA_INFO_TYPE"] = 0;
                    values[valuesById[1] = "CUSTOM_SYNTAX"] = 1;
                    values[valuesById[2] = "STORE_NAME"] = 2;
                    values[valuesById[3] = "STORE_CODE"] = 3;
                    values[valuesById[4] = "MONTH_YEAR"] = 4;
                    values[valuesById[5] = "THAI_MONTH_YEAR"] = 5;
                    values[valuesById[6] = "START_DATE_DD_MM_YYYY"] = 6;
                    values[valuesById[7] = "END_DATE_DD_MM_YYYY"] = 7;
                    values[valuesById[8] = "START_DAY_OF_MONTH"] = 8;
                    values[valuesById[9] = "START_MONTH"] = 9;
                    values[valuesById[10] = "START_YEAR"] = 10;
                    values[valuesById[11] = "END_DAY_OF_MONTH"] = 11;
                    values[valuesById[12] = "END_MONTH"] = 12;
                    values[valuesById[13] = "END_YEAR"] = 13;
                    values[valuesById[14] = "START_DATE_DD_MM"] = 14;
                    values[valuesById[15] = "END_DATE_DD_MM"] = 15;
                    return values;
                })();
    
                ScheduleExportFormatConfigPb.StaffInfoFormat = (function() {
    
                    /**
                     * Properties of a StaffInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IStaffInfoFormat
                     * @property {boolean|null} [addNumberRowBelowTableHeader] StaffInfoFormat addNumberRowBelowTableHeader
                     * @property {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo>|null} [staffInfos] StaffInfoFormat staffInfos
                     */
    
                    /**
                     * Constructs a new StaffInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a StaffInfoFormat.
                     * @implements IStaffInfoFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat=} [properties] Properties to set
                     */
                    function StaffInfoFormat(properties) {
                        this.staffInfos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffInfoFormat addNumberRowBelowTableHeader.
                     * @member {boolean} addNumberRowBelowTableHeader
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @instance
                     */
                    StaffInfoFormat.prototype.addNumberRowBelowTableHeader = false;
    
                    /**
                     * StaffInfoFormat staffInfos.
                     * @member {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo>} staffInfos
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @instance
                     */
                    StaffInfoFormat.prototype.staffInfos = $util.emptyArray;
    
                    /**
                     * Creates a new StaffInfoFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat} StaffInfoFormat instance
                     */
                    StaffInfoFormat.create = function create(properties) {
                        return new StaffInfoFormat(properties);
                    };
    
                    /**
                     * Encodes the specified StaffInfoFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat} message StaffInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInfoFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.addNumberRowBelowTableHeader != null && Object.hasOwnProperty.call(message, "addNumberRowBelowTableHeader"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.addNumberRowBelowTableHeader);
                        if (message.staffInfos != null && message.staffInfos.length)
                            for (var i = 0; i < message.staffInfos.length; ++i)
                                $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.encode(message.staffInfos[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffInfoFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfoFormat} message StaffInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInfoFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffInfoFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat} StaffInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInfoFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.addNumberRowBelowTableHeader = reader.bool();
                                break;
                            case 2:
                                if (!(message.staffInfos && message.staffInfos.length))
                                    message.staffInfos = [];
                                message.staffInfos.push($root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffInfoFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat} StaffInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInfoFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffInfoFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffInfoFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.addNumberRowBelowTableHeader != null && message.hasOwnProperty("addNumberRowBelowTableHeader"))
                            if (typeof message.addNumberRowBelowTableHeader !== "boolean")
                                return "addNumberRowBelowTableHeader: boolean expected";
                        if (message.staffInfos != null && message.hasOwnProperty("staffInfos")) {
                            if (!Array.isArray(message.staffInfos))
                                return "staffInfos: array expected";
                            for (var i = 0; i < message.staffInfos.length; ++i) {
                                var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.verify(message.staffInfos[i]);
                                if (error)
                                    return "staffInfos." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffInfoFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat} StaffInfoFormat
                     */
                    StaffInfoFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat();
                        if (object.addNumberRowBelowTableHeader != null)
                            message.addNumberRowBelowTableHeader = Boolean(object.addNumberRowBelowTableHeader);
                        if (object.staffInfos) {
                            if (!Array.isArray(object.staffInfos))
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.staffInfos: array expected");
                            message.staffInfos = [];
                            for (var i = 0; i < object.staffInfos.length; ++i) {
                                if (typeof object.staffInfos[i] !== "object")
                                    throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat.staffInfos: object expected");
                                message.staffInfos[i] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.fromObject(object.staffInfos[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffInfoFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat} message StaffInfoFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffInfoFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.staffInfos = [];
                        if (options.defaults)
                            object.addNumberRowBelowTableHeader = false;
                        if (message.addNumberRowBelowTableHeader != null && message.hasOwnProperty("addNumberRowBelowTableHeader"))
                            object.addNumberRowBelowTableHeader = message.addNumberRowBelowTableHeader;
                        if (message.staffInfos && message.staffInfos.length) {
                            object.staffInfos = [];
                            for (var j = 0; j < message.staffInfos.length; ++j)
                                object.staffInfos[j] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.toObject(message.staffInfos[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this StaffInfoFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffInfoFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffInfoFormat;
                })();
    
                ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig = (function() {
    
                    /**
                     * Properties of an EmploymentTypeDisplayConfig.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IEmploymentTypeDisplayConfig
                     * @property {string|null} [fullTimeText] EmploymentTypeDisplayConfig fullTimeText
                     * @property {string|null} [partTimeText] EmploymentTypeDisplayConfig partTimeText
                     */
    
                    /**
                     * Constructs a new EmploymentTypeDisplayConfig.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents an EmploymentTypeDisplayConfig.
                     * @implements IEmploymentTypeDisplayConfig
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig=} [properties] Properties to set
                     */
                    function EmploymentTypeDisplayConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EmploymentTypeDisplayConfig fullTimeText.
                     * @member {string} fullTimeText
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @instance
                     */
                    EmploymentTypeDisplayConfig.prototype.fullTimeText = "";
    
                    /**
                     * EmploymentTypeDisplayConfig partTimeText.
                     * @member {string} partTimeText
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @instance
                     */
                    EmploymentTypeDisplayConfig.prototype.partTimeText = "";
    
                    /**
                     * Creates a new EmploymentTypeDisplayConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig} EmploymentTypeDisplayConfig instance
                     */
                    EmploymentTypeDisplayConfig.create = function create(properties) {
                        return new EmploymentTypeDisplayConfig(properties);
                    };
    
                    /**
                     * Encodes the specified EmploymentTypeDisplayConfig message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig} message EmploymentTypeDisplayConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmploymentTypeDisplayConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fullTimeText != null && Object.hasOwnProperty.call(message, "fullTimeText"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.fullTimeText);
                        if (message.partTimeText != null && Object.hasOwnProperty.call(message, "partTimeText"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.partTimeText);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EmploymentTypeDisplayConfig message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig} message EmploymentTypeDisplayConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmploymentTypeDisplayConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EmploymentTypeDisplayConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig} EmploymentTypeDisplayConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmploymentTypeDisplayConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fullTimeText = reader.string();
                                break;
                            case 2:
                                message.partTimeText = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EmploymentTypeDisplayConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig} EmploymentTypeDisplayConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmploymentTypeDisplayConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EmploymentTypeDisplayConfig message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EmploymentTypeDisplayConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fullTimeText != null && message.hasOwnProperty("fullTimeText"))
                            if (!$util.isString(message.fullTimeText))
                                return "fullTimeText: string expected";
                        if (message.partTimeText != null && message.hasOwnProperty("partTimeText"))
                            if (!$util.isString(message.partTimeText))
                                return "partTimeText: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an EmploymentTypeDisplayConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig} EmploymentTypeDisplayConfig
                     */
                    EmploymentTypeDisplayConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig();
                        if (object.fullTimeText != null)
                            message.fullTimeText = String(object.fullTimeText);
                        if (object.partTimeText != null)
                            message.partTimeText = String(object.partTimeText);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EmploymentTypeDisplayConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig} message EmploymentTypeDisplayConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EmploymentTypeDisplayConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fullTimeText = "";
                            object.partTimeText = "";
                        }
                        if (message.fullTimeText != null && message.hasOwnProperty("fullTimeText"))
                            object.fullTimeText = message.fullTimeText;
                        if (message.partTimeText != null && message.hasOwnProperty("partTimeText"))
                            object.partTimeText = message.partTimeText;
                        return object;
                    };
    
                    /**
                     * Converts this EmploymentTypeDisplayConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EmploymentTypeDisplayConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EmploymentTypeDisplayConfig;
                })();
    
                ScheduleExportFormatConfigPb.StaffInfo = (function() {
    
                    /**
                     * Properties of a StaffInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IStaffInfo
                     * @property {string|null} [startPosition] StaffInfo startPosition
                     * @property {string|null} [endPosition] StaffInfo endPosition
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoType|null} [staffInfoType] StaffInfo staffInfoType
                     * @property {string|null} [exportName] StaffInfo exportName
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig|null} [employmentTypeDisplayConfig] StaffInfo employmentTypeDisplayConfig
                     */
    
                    /**
                     * Constructs a new StaffInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a StaffInfo.
                     * @implements IStaffInfo
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo=} [properties] Properties to set
                     */
                    function StaffInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffInfo startPosition.
                     * @member {string} startPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     */
                    StaffInfo.prototype.startPosition = "";
    
                    /**
                     * StaffInfo endPosition.
                     * @member {string} endPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     */
                    StaffInfo.prototype.endPosition = "";
    
                    /**
                     * StaffInfo staffInfoType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoType} staffInfoType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     */
                    StaffInfo.prototype.staffInfoType = 0;
    
                    /**
                     * StaffInfo exportName.
                     * @member {string} exportName
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     */
                    StaffInfo.prototype.exportName = "";
    
                    /**
                     * StaffInfo employmentTypeDisplayConfig.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IEmploymentTypeDisplayConfig|null|undefined} employmentTypeDisplayConfig
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     */
                    StaffInfo.prototype.employmentTypeDisplayConfig = null;
    
                    /**
                     * Creates a new StaffInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo} StaffInfo instance
                     */
                    StaffInfo.create = function create(properties) {
                        return new StaffInfo(properties);
                    };
    
                    /**
                     * Encodes the specified StaffInfo message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo} message StaffInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startPosition != null && Object.hasOwnProperty.call(message, "startPosition"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startPosition);
                        if (message.endPosition != null && Object.hasOwnProperty.call(message, "endPosition"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endPosition);
                        if (message.staffInfoType != null && Object.hasOwnProperty.call(message, "staffInfoType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.staffInfoType);
                        if (message.exportName != null && Object.hasOwnProperty.call(message, "exportName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.exportName);
                        if (message.employmentTypeDisplayConfig != null && Object.hasOwnProperty.call(message, "employmentTypeDisplayConfig"))
                            $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.encode(message.employmentTypeDisplayConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffInfo message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IStaffInfo} message StaffInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo} StaffInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startPosition = reader.string();
                                break;
                            case 2:
                                message.endPosition = reader.string();
                                break;
                            case 3:
                                message.staffInfoType = reader.int32();
                                break;
                            case 4:
                                message.exportName = reader.string();
                                break;
                            case 5:
                                message.employmentTypeDisplayConfig = $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo} StaffInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffInfo message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            if (!$util.isString(message.startPosition))
                                return "startPosition: string expected";
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            if (!$util.isString(message.endPosition))
                                return "endPosition: string expected";
                        if (message.staffInfoType != null && message.hasOwnProperty("staffInfoType"))
                            switch (message.staffInfoType) {
                            default:
                                return "staffInfoType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.exportName != null && message.hasOwnProperty("exportName"))
                            if (!$util.isString(message.exportName))
                                return "exportName: string expected";
                        if (message.employmentTypeDisplayConfig != null && message.hasOwnProperty("employmentTypeDisplayConfig")) {
                            var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.verify(message.employmentTypeDisplayConfig);
                            if (error)
                                return "employmentTypeDisplayConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a StaffInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo} StaffInfo
                     */
                    StaffInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo();
                        if (object.startPosition != null)
                            message.startPosition = String(object.startPosition);
                        if (object.endPosition != null)
                            message.endPosition = String(object.endPosition);
                        switch (object.staffInfoType) {
                        case "UNKNOWN_STAFF_INFO_TYPE":
                        case 0:
                            message.staffInfoType = 0;
                            break;
                        case "POS_ID":
                        case 1:
                            message.staffInfoType = 1;
                            break;
                        case "STAFFING_FILE_ID":
                        case 2:
                            message.staffInfoType = 2;
                            break;
                        case "STAFF_NAME":
                        case 3:
                            message.staffInfoType = 3;
                            break;
                        case "STAFF_STORE_CODE":
                        case 4:
                            message.staffInfoType = 4;
                            break;
                        case "STAFF_STORE_NAME":
                        case 5:
                            message.staffInfoType = 5;
                            break;
                        case "POSITION":
                        case 6:
                            message.staffInfoType = 6;
                            break;
                        case "SCHEDULE_START_MONTH":
                        case 7:
                            message.staffInfoType = 7;
                            break;
                        case "SCHEDULE_START_YEAR":
                        case 8:
                            message.staffInfoType = 8;
                            break;
                        case "TOTAL_WORKING_HOURS":
                        case 9:
                            message.staffInfoType = 9;
                            break;
                        case "EMPLOYMENT_TYPE":
                        case 10:
                            message.staffInfoType = 10;
                            break;
                        }
                        if (object.exportName != null)
                            message.exportName = String(object.exportName);
                        if (object.employmentTypeDisplayConfig != null) {
                            if (typeof object.employmentTypeDisplayConfig !== "object")
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo.employmentTypeDisplayConfig: object expected");
                            message.employmentTypeDisplayConfig = $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.fromObject(object.employmentTypeDisplayConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo} message StaffInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startPosition = "";
                            object.endPosition = "";
                            object.staffInfoType = options.enums === String ? "UNKNOWN_STAFF_INFO_TYPE" : 0;
                            object.exportName = "";
                            object.employmentTypeDisplayConfig = null;
                        }
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            object.startPosition = message.startPosition;
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            object.endPosition = message.endPosition;
                        if (message.staffInfoType != null && message.hasOwnProperty("staffInfoType"))
                            object.staffInfoType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoType[message.staffInfoType] : message.staffInfoType;
                        if (message.exportName != null && message.hasOwnProperty("exportName"))
                            object.exportName = message.exportName;
                        if (message.employmentTypeDisplayConfig != null && message.hasOwnProperty("employmentTypeDisplayConfig"))
                            object.employmentTypeDisplayConfig = $root.palexy.protobuf.ScheduleExportFormatConfigPb.EmploymentTypeDisplayConfig.toObject(message.employmentTypeDisplayConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this StaffInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffInfo;
                })();
    
                /**
                 * StaffInfoType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.StaffInfoType
                 * @enum {number}
                 * @property {number} UNKNOWN_STAFF_INFO_TYPE=0 UNKNOWN_STAFF_INFO_TYPE value
                 * @property {number} POS_ID=1 POS_ID value
                 * @property {number} STAFFING_FILE_ID=2 STAFFING_FILE_ID value
                 * @property {number} STAFF_NAME=3 STAFF_NAME value
                 * @property {number} STAFF_STORE_CODE=4 STAFF_STORE_CODE value
                 * @property {number} STAFF_STORE_NAME=5 STAFF_STORE_NAME value
                 * @property {number} POSITION=6 POSITION value
                 * @property {number} SCHEDULE_START_MONTH=7 SCHEDULE_START_MONTH value
                 * @property {number} SCHEDULE_START_YEAR=8 SCHEDULE_START_YEAR value
                 * @property {number} TOTAL_WORKING_HOURS=9 TOTAL_WORKING_HOURS value
                 * @property {number} EMPLOYMENT_TYPE=10 EMPLOYMENT_TYPE value
                 */
                ScheduleExportFormatConfigPb.StaffInfoType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_STAFF_INFO_TYPE"] = 0;
                    values[valuesById[1] = "POS_ID"] = 1;
                    values[valuesById[2] = "STAFFING_FILE_ID"] = 2;
                    values[valuesById[3] = "STAFF_NAME"] = 3;
                    values[valuesById[4] = "STAFF_STORE_CODE"] = 4;
                    values[valuesById[5] = "STAFF_STORE_NAME"] = 5;
                    values[valuesById[6] = "POSITION"] = 6;
                    values[valuesById[7] = "SCHEDULE_START_MONTH"] = 7;
                    values[valuesById[8] = "SCHEDULE_START_YEAR"] = 8;
                    values[valuesById[9] = "TOTAL_WORKING_HOURS"] = 9;
                    values[valuesById[10] = "EMPLOYMENT_TYPE"] = 10;
                    return values;
                })();
    
                ScheduleExportFormatConfigPb.ScheduleDetailsFormat = (function() {
    
                    /**
                     * Properties of a ScheduleDetailsFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IScheduleDetailsFormat
                     * @property {string|null} [startPosition] ScheduleDetailsFormat startPosition
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat|null} [shiftFormat] ScheduleDetailsFormat shiftFormat
                     * @property {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat>|null} [dateTimeFormats] ScheduleDetailsFormat dateTimeFormats
                     * @property {boolean|null} [exportAsDateAndDisplayWithChosenFormat] ScheduleDetailsFormat exportAsDateAndDisplayWithChosenFormat
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat|null} [partTimeShiftFormat] ScheduleDetailsFormat partTimeShiftFormat
                     */
    
                    /**
                     * Constructs a new ScheduleDetailsFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a ScheduleDetailsFormat.
                     * @implements IScheduleDetailsFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat=} [properties] Properties to set
                     */
                    function ScheduleDetailsFormat(properties) {
                        this.dateTimeFormats = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ScheduleDetailsFormat startPosition.
                     * @member {string} startPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     */
                    ScheduleDetailsFormat.prototype.startPosition = "";
    
                    /**
                     * ScheduleDetailsFormat shiftFormat.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat|null|undefined} shiftFormat
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     */
                    ScheduleDetailsFormat.prototype.shiftFormat = null;
    
                    /**
                     * ScheduleDetailsFormat dateTimeFormats.
                     * @member {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat>} dateTimeFormats
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     */
                    ScheduleDetailsFormat.prototype.dateTimeFormats = $util.emptyArray;
    
                    /**
                     * ScheduleDetailsFormat exportAsDateAndDisplayWithChosenFormat.
                     * @member {boolean} exportAsDateAndDisplayWithChosenFormat
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     */
                    ScheduleDetailsFormat.prototype.exportAsDateAndDisplayWithChosenFormat = false;
    
                    /**
                     * ScheduleDetailsFormat partTimeShiftFormat.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat|null|undefined} partTimeShiftFormat
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     */
                    ScheduleDetailsFormat.prototype.partTimeShiftFormat = null;
    
                    /**
                     * Creates a new ScheduleDetailsFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat} ScheduleDetailsFormat instance
                     */
                    ScheduleDetailsFormat.create = function create(properties) {
                        return new ScheduleDetailsFormat(properties);
                    };
    
                    /**
                     * Encodes the specified ScheduleDetailsFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat} message ScheduleDetailsFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleDetailsFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startPosition != null && Object.hasOwnProperty.call(message, "startPosition"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startPosition);
                        if (message.shiftFormat != null && Object.hasOwnProperty.call(message, "shiftFormat"))
                            $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.encode(message.shiftFormat, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.dateTimeFormats != null && message.dateTimeFormats.length)
                            for (var i = 0; i < message.dateTimeFormats.length; ++i)
                                $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.encode(message.dateTimeFormats[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.exportAsDateAndDisplayWithChosenFormat != null && Object.hasOwnProperty.call(message, "exportAsDateAndDisplayWithChosenFormat"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.exportAsDateAndDisplayWithChosenFormat);
                        if (message.partTimeShiftFormat != null && Object.hasOwnProperty.call(message, "partTimeShiftFormat"))
                            $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.encode(message.partTimeShiftFormat, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ScheduleDetailsFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IScheduleDetailsFormat} message ScheduleDetailsFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ScheduleDetailsFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ScheduleDetailsFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat} ScheduleDetailsFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleDetailsFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startPosition = reader.string();
                                break;
                            case 2:
                                message.shiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.decode(reader, reader.uint32());
                                break;
                            case 3:
                                if (!(message.dateTimeFormats && message.dateTimeFormats.length))
                                    message.dateTimeFormats = [];
                                message.dateTimeFormats.push($root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.exportAsDateAndDisplayWithChosenFormat = reader.bool();
                                break;
                            case 5:
                                message.partTimeShiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ScheduleDetailsFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat} ScheduleDetailsFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ScheduleDetailsFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ScheduleDetailsFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ScheduleDetailsFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            if (!$util.isString(message.startPosition))
                                return "startPosition: string expected";
                        if (message.shiftFormat != null && message.hasOwnProperty("shiftFormat")) {
                            var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.verify(message.shiftFormat);
                            if (error)
                                return "shiftFormat." + error;
                        }
                        if (message.dateTimeFormats != null && message.hasOwnProperty("dateTimeFormats")) {
                            if (!Array.isArray(message.dateTimeFormats))
                                return "dateTimeFormats: array expected";
                            for (var i = 0; i < message.dateTimeFormats.length; ++i) {
                                var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.verify(message.dateTimeFormats[i]);
                                if (error)
                                    return "dateTimeFormats." + error;
                            }
                        }
                        if (message.exportAsDateAndDisplayWithChosenFormat != null && message.hasOwnProperty("exportAsDateAndDisplayWithChosenFormat"))
                            if (typeof message.exportAsDateAndDisplayWithChosenFormat !== "boolean")
                                return "exportAsDateAndDisplayWithChosenFormat: boolean expected";
                        if (message.partTimeShiftFormat != null && message.hasOwnProperty("partTimeShiftFormat")) {
                            var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.verify(message.partTimeShiftFormat);
                            if (error)
                                return "partTimeShiftFormat." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ScheduleDetailsFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat} ScheduleDetailsFormat
                     */
                    ScheduleDetailsFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat();
                        if (object.startPosition != null)
                            message.startPosition = String(object.startPosition);
                        if (object.shiftFormat != null) {
                            if (typeof object.shiftFormat !== "object")
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.shiftFormat: object expected");
                            message.shiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.fromObject(object.shiftFormat);
                        }
                        if (object.dateTimeFormats) {
                            if (!Array.isArray(object.dateTimeFormats))
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.dateTimeFormats: array expected");
                            message.dateTimeFormats = [];
                            for (var i = 0; i < object.dateTimeFormats.length; ++i) {
                                if (typeof object.dateTimeFormats[i] !== "object")
                                    throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.dateTimeFormats: object expected");
                                message.dateTimeFormats[i] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.fromObject(object.dateTimeFormats[i]);
                            }
                        }
                        if (object.exportAsDateAndDisplayWithChosenFormat != null)
                            message.exportAsDateAndDisplayWithChosenFormat = Boolean(object.exportAsDateAndDisplayWithChosenFormat);
                        if (object.partTimeShiftFormat != null) {
                            if (typeof object.partTimeShiftFormat !== "object")
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat.partTimeShiftFormat: object expected");
                            message.partTimeShiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.fromObject(object.partTimeShiftFormat);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ScheduleDetailsFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat} message ScheduleDetailsFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ScheduleDetailsFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dateTimeFormats = [];
                        if (options.defaults) {
                            object.startPosition = "";
                            object.shiftFormat = null;
                            object.exportAsDateAndDisplayWithChosenFormat = false;
                            object.partTimeShiftFormat = null;
                        }
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            object.startPosition = message.startPosition;
                        if (message.shiftFormat != null && message.hasOwnProperty("shiftFormat"))
                            object.shiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.toObject(message.shiftFormat, options);
                        if (message.dateTimeFormats && message.dateTimeFormats.length) {
                            object.dateTimeFormats = [];
                            for (var j = 0; j < message.dateTimeFormats.length; ++j)
                                object.dateTimeFormats[j] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.toObject(message.dateTimeFormats[j], options);
                        }
                        if (message.exportAsDateAndDisplayWithChosenFormat != null && message.hasOwnProperty("exportAsDateAndDisplayWithChosenFormat"))
                            object.exportAsDateAndDisplayWithChosenFormat = message.exportAsDateAndDisplayWithChosenFormat;
                        if (message.partTimeShiftFormat != null && message.hasOwnProperty("partTimeShiftFormat"))
                            object.partTimeShiftFormat = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.toObject(message.partTimeShiftFormat, options);
                        return object;
                    };
    
                    /**
                     * Converts this ScheduleDetailsFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ScheduleDetailsFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ScheduleDetailsFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ScheduleDetailsFormat;
                })();
    
                ScheduleExportFormatConfigPb.ShiftFormat = (function() {
    
                    /**
                     * Properties of a ShiftFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IShiftFormat
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormatType|null} [shiftFormatType] ShiftFormat shiftFormatType
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.TimeOffFormatType|null} [timeOffFormatType] ShiftFormat timeOffFormatType
                     * @property {string|null} [delimiter] ShiftFormat delimiter
                     */
    
                    /**
                     * Constructs a new ShiftFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a ShiftFormat.
                     * @implements IShiftFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat=} [properties] Properties to set
                     */
                    function ShiftFormat(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftFormat shiftFormatType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormatType} shiftFormatType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @instance
                     */
                    ShiftFormat.prototype.shiftFormatType = 0;
    
                    /**
                     * ShiftFormat timeOffFormatType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.TimeOffFormatType} timeOffFormatType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @instance
                     */
                    ShiftFormat.prototype.timeOffFormatType = 0;
    
                    /**
                     * ShiftFormat delimiter.
                     * @member {string} delimiter
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @instance
                     */
                    ShiftFormat.prototype.delimiter = "";
    
                    /**
                     * Creates a new ShiftFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat} ShiftFormat instance
                     */
                    ShiftFormat.create = function create(properties) {
                        return new ShiftFormat(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat} message ShiftFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftFormatType != null && Object.hasOwnProperty.call(message, "shiftFormatType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.shiftFormatType);
                        if (message.timeOffFormatType != null && Object.hasOwnProperty.call(message, "timeOffFormatType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.timeOffFormatType);
                        if (message.delimiter != null && Object.hasOwnProperty.call(message, "delimiter"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.delimiter);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftFormat} message ShiftFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat} ShiftFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftFormatType = reader.int32();
                                break;
                            case 2:
                                message.timeOffFormatType = reader.int32();
                                break;
                            case 3:
                                message.delimiter = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat} ShiftFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftFormatType != null && message.hasOwnProperty("shiftFormatType"))
                            switch (message.shiftFormatType) {
                            default:
                                return "shiftFormatType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.timeOffFormatType != null && message.hasOwnProperty("timeOffFormatType"))
                            switch (message.timeOffFormatType) {
                            default:
                                return "timeOffFormatType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.delimiter != null && message.hasOwnProperty("delimiter"))
                            if (!$util.isString(message.delimiter))
                                return "delimiter: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat} ShiftFormat
                     */
                    ShiftFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat();
                        switch (object.shiftFormatType) {
                        case "UNKNOWN_SHIFT_FORMAT_TYPE":
                        case 0:
                            message.shiftFormatType = 0;
                            break;
                        case "SHIFT_NAME":
                        case 1:
                            message.shiftFormatType = 1;
                            break;
                        case "SHIFT_HOUR":
                        case 2:
                            message.shiftFormatType = 2;
                            break;
                        case "SPLIT_SHIFT_BY_BREAK_TIME":
                        case 3:
                            message.shiftFormatType = 3;
                            break;
                        }
                        switch (object.timeOffFormatType) {
                        case "UNKNOWN_TIME_OFF_FORMAT_TYPE":
                        case 0:
                            message.timeOffFormatType = 0;
                            break;
                        case "TIME_OFF_NAME":
                        case 1:
                            message.timeOffFormatType = 1;
                            break;
                        case "TIME_OFF_SHORT_NAME":
                        case 2:
                            message.timeOffFormatType = 2;
                            break;
                        case "OFF_TEXT":
                        case 3:
                            message.timeOffFormatType = 3;
                            break;
                        }
                        if (object.delimiter != null)
                            message.delimiter = String(object.delimiter);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat} message ShiftFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.shiftFormatType = options.enums === String ? "UNKNOWN_SHIFT_FORMAT_TYPE" : 0;
                            object.timeOffFormatType = options.enums === String ? "UNKNOWN_TIME_OFF_FORMAT_TYPE" : 0;
                            object.delimiter = "";
                        }
                        if (message.shiftFormatType != null && message.hasOwnProperty("shiftFormatType"))
                            object.shiftFormatType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormatType[message.shiftFormatType] : message.shiftFormatType;
                        if (message.timeOffFormatType != null && message.hasOwnProperty("timeOffFormatType"))
                            object.timeOffFormatType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.TimeOffFormatType[message.timeOffFormatType] : message.timeOffFormatType;
                        if (message.delimiter != null && message.hasOwnProperty("delimiter"))
                            object.delimiter = message.delimiter;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftFormat;
                })();
    
                ScheduleExportFormatConfigPb.DateTimeFormat = (function() {
    
                    /**
                     * Properties of a DateTimeFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IDateTimeFormat
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormatType|null} [dateTimeFormatType] DateTimeFormat dateTimeFormatType
                     */
    
                    /**
                     * Constructs a new DateTimeFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a DateTimeFormat.
                     * @implements IDateTimeFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat=} [properties] Properties to set
                     */
                    function DateTimeFormat(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DateTimeFormat dateTimeFormatType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormatType} dateTimeFormatType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @instance
                     */
                    DateTimeFormat.prototype.dateTimeFormatType = 0;
    
                    /**
                     * Creates a new DateTimeFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat} DateTimeFormat instance
                     */
                    DateTimeFormat.create = function create(properties) {
                        return new DateTimeFormat(properties);
                    };
    
                    /**
                     * Encodes the specified DateTimeFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat} message DateTimeFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateTimeFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dateTimeFormatType != null && Object.hasOwnProperty.call(message, "dateTimeFormatType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateTimeFormatType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DateTimeFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IDateTimeFormat} message DateTimeFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DateTimeFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DateTimeFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat} DateTimeFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateTimeFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dateTimeFormatType = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DateTimeFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat} DateTimeFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DateTimeFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DateTimeFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DateTimeFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dateTimeFormatType != null && message.hasOwnProperty("dateTimeFormatType"))
                            switch (message.dateTimeFormatType) {
                            default:
                                return "dateTimeFormatType: enum value expected";
                            case 0:
                            case 1:
                            case 7:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a DateTimeFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat} DateTimeFormat
                     */
                    DateTimeFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat();
                        switch (object.dateTimeFormatType) {
                        case "UNKNOWN_DATE_TIME_FORMAT_TYPE":
                        case 0:
                            message.dateTimeFormatType = 0;
                            break;
                        case "DAY_OF_WEEK":
                        case 1:
                            message.dateTimeFormatType = 1;
                            break;
                        case "DAY_OF_WEEK_VIETNAM":
                        case 7:
                            message.dateTimeFormatType = 7;
                            break;
                        case "FULL_DATE_DDMMYYYY":
                        case 2:
                            message.dateTimeFormatType = 2;
                            break;
                        case "FULL_DATE_YYYYMMDD":
                        case 3:
                            message.dateTimeFormatType = 3;
                            break;
                        case "DAY_OF_MONTH":
                        case 4:
                            message.dateTimeFormatType = 4;
                            break;
                        case "DAY_OF_MONTH_WITH_MONTH":
                        case 5:
                            message.dateTimeFormatType = 5;
                            break;
                        case "DAY_OF_MONTH_WITH_WEEKDAY":
                        case 6:
                            message.dateTimeFormatType = 6;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DateTimeFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat} message DateTimeFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DateTimeFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dateTimeFormatType = options.enums === String ? "UNKNOWN_DATE_TIME_FORMAT_TYPE" : 0;
                        if (message.dateTimeFormatType != null && message.hasOwnProperty("dateTimeFormatType"))
                            object.dateTimeFormatType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormatType[message.dateTimeFormatType] : message.dateTimeFormatType;
                        return object;
                    };
    
                    /**
                     * Converts this DateTimeFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DateTimeFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DateTimeFormat;
                })();
    
                /**
                 * ShiftFormatType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.ShiftFormatType
                 * @enum {number}
                 * @property {number} UNKNOWN_SHIFT_FORMAT_TYPE=0 UNKNOWN_SHIFT_FORMAT_TYPE value
                 * @property {number} SHIFT_NAME=1 SHIFT_NAME value
                 * @property {number} SHIFT_HOUR=2 SHIFT_HOUR value
                 * @property {number} SPLIT_SHIFT_BY_BREAK_TIME=3 SPLIT_SHIFT_BY_BREAK_TIME value
                 */
                ScheduleExportFormatConfigPb.ShiftFormatType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_SHIFT_FORMAT_TYPE"] = 0;
                    values[valuesById[1] = "SHIFT_NAME"] = 1;
                    values[valuesById[2] = "SHIFT_HOUR"] = 2;
                    values[valuesById[3] = "SPLIT_SHIFT_BY_BREAK_TIME"] = 3;
                    return values;
                })();
    
                /**
                 * TimeOffFormatType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.TimeOffFormatType
                 * @enum {number}
                 * @property {number} UNKNOWN_TIME_OFF_FORMAT_TYPE=0 UNKNOWN_TIME_OFF_FORMAT_TYPE value
                 * @property {number} TIME_OFF_NAME=1 TIME_OFF_NAME value
                 * @property {number} TIME_OFF_SHORT_NAME=2 TIME_OFF_SHORT_NAME value
                 * @property {number} OFF_TEXT=3 OFF_TEXT value
                 */
                ScheduleExportFormatConfigPb.TimeOffFormatType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_TIME_OFF_FORMAT_TYPE"] = 0;
                    values[valuesById[1] = "TIME_OFF_NAME"] = 1;
                    values[valuesById[2] = "TIME_OFF_SHORT_NAME"] = 2;
                    values[valuesById[3] = "OFF_TEXT"] = 3;
                    return values;
                })();
    
                /**
                 * DateTimeFormatType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.DateTimeFormatType
                 * @enum {number}
                 * @property {number} UNKNOWN_DATE_TIME_FORMAT_TYPE=0 UNKNOWN_DATE_TIME_FORMAT_TYPE value
                 * @property {number} DAY_OF_WEEK=1 DAY_OF_WEEK value
                 * @property {number} DAY_OF_WEEK_VIETNAM=7 DAY_OF_WEEK_VIETNAM value
                 * @property {number} FULL_DATE_DDMMYYYY=2 FULL_DATE_DDMMYYYY value
                 * @property {number} FULL_DATE_YYYYMMDD=3 FULL_DATE_YYYYMMDD value
                 * @property {number} DAY_OF_MONTH=4 DAY_OF_MONTH value
                 * @property {number} DAY_OF_MONTH_WITH_MONTH=5 DAY_OF_MONTH_WITH_MONTH value
                 * @property {number} DAY_OF_MONTH_WITH_WEEKDAY=6 DAY_OF_MONTH_WITH_WEEKDAY value
                 */
                ScheduleExportFormatConfigPb.DateTimeFormatType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_DATE_TIME_FORMAT_TYPE"] = 0;
                    values[valuesById[1] = "DAY_OF_WEEK"] = 1;
                    values[valuesById[7] = "DAY_OF_WEEK_VIETNAM"] = 7;
                    values[valuesById[2] = "FULL_DATE_DDMMYYYY"] = 2;
                    values[valuesById[3] = "FULL_DATE_YYYYMMDD"] = 3;
                    values[valuesById[4] = "DAY_OF_MONTH"] = 4;
                    values[valuesById[5] = "DAY_OF_MONTH_WITH_MONTH"] = 5;
                    values[valuesById[6] = "DAY_OF_MONTH_WITH_WEEKDAY"] = 6;
                    return values;
                })();
    
                ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat = (function() {
    
                    /**
                     * Properties of a ShiftDefinitionInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IShiftDefinitionInfoFormat
                     * @property {boolean|null} [useANewSheet] ShiftDefinitionInfoFormat useANewSheet
                     * @property {number|null} [minEmptyRowsGap] ShiftDefinitionInfoFormat minEmptyRowsGap
                     * @property {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo>|null} [shiftDefinitionInfos] ShiftDefinitionInfoFormat shiftDefinitionInfos
                     * @property {boolean|null} [doNotExportHeaders] ShiftDefinitionInfoFormat doNotExportHeaders
                     */
    
                    /**
                     * Constructs a new ShiftDefinitionInfoFormat.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a ShiftDefinitionInfoFormat.
                     * @implements IShiftDefinitionInfoFormat
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat=} [properties] Properties to set
                     */
                    function ShiftDefinitionInfoFormat(properties) {
                        this.shiftDefinitionInfos = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftDefinitionInfoFormat useANewSheet.
                     * @member {boolean} useANewSheet
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @instance
                     */
                    ShiftDefinitionInfoFormat.prototype.useANewSheet = false;
    
                    /**
                     * ShiftDefinitionInfoFormat minEmptyRowsGap.
                     * @member {number} minEmptyRowsGap
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @instance
                     */
                    ShiftDefinitionInfoFormat.prototype.minEmptyRowsGap = 0;
    
                    /**
                     * ShiftDefinitionInfoFormat shiftDefinitionInfos.
                     * @member {Array.<palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo>} shiftDefinitionInfos
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @instance
                     */
                    ShiftDefinitionInfoFormat.prototype.shiftDefinitionInfos = $util.emptyArray;
    
                    /**
                     * ShiftDefinitionInfoFormat doNotExportHeaders.
                     * @member {boolean} doNotExportHeaders
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @instance
                     */
                    ShiftDefinitionInfoFormat.prototype.doNotExportHeaders = false;
    
                    /**
                     * Creates a new ShiftDefinitionInfoFormat instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat} ShiftDefinitionInfoFormat instance
                     */
                    ShiftDefinitionInfoFormat.create = function create(properties) {
                        return new ShiftDefinitionInfoFormat(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftDefinitionInfoFormat message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat} message ShiftDefinitionInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftDefinitionInfoFormat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.useANewSheet != null && Object.hasOwnProperty.call(message, "useANewSheet"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.useANewSheet);
                        if (message.minEmptyRowsGap != null && Object.hasOwnProperty.call(message, "minEmptyRowsGap"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.minEmptyRowsGap);
                        if (message.shiftDefinitionInfos != null && message.shiftDefinitionInfos.length)
                            for (var i = 0; i < message.shiftDefinitionInfos.length; ++i)
                                $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.encode(message.shiftDefinitionInfos[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.doNotExportHeaders != null && Object.hasOwnProperty.call(message, "doNotExportHeaders"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.doNotExportHeaders);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftDefinitionInfoFormat message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfoFormat} message ShiftDefinitionInfoFormat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftDefinitionInfoFormat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftDefinitionInfoFormat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat} ShiftDefinitionInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftDefinitionInfoFormat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.useANewSheet = reader.bool();
                                break;
                            case 2:
                                message.minEmptyRowsGap = reader.int32();
                                break;
                            case 3:
                                if (!(message.shiftDefinitionInfos && message.shiftDefinitionInfos.length))
                                    message.shiftDefinitionInfos = [];
                                message.shiftDefinitionInfos.push($root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.doNotExportHeaders = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftDefinitionInfoFormat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat} ShiftDefinitionInfoFormat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftDefinitionInfoFormat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftDefinitionInfoFormat message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftDefinitionInfoFormat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.useANewSheet != null && message.hasOwnProperty("useANewSheet"))
                            if (typeof message.useANewSheet !== "boolean")
                                return "useANewSheet: boolean expected";
                        if (message.minEmptyRowsGap != null && message.hasOwnProperty("minEmptyRowsGap"))
                            if (!$util.isInteger(message.minEmptyRowsGap))
                                return "minEmptyRowsGap: integer expected";
                        if (message.shiftDefinitionInfos != null && message.hasOwnProperty("shiftDefinitionInfos")) {
                            if (!Array.isArray(message.shiftDefinitionInfos))
                                return "shiftDefinitionInfos: array expected";
                            for (var i = 0; i < message.shiftDefinitionInfos.length; ++i) {
                                var error = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.verify(message.shiftDefinitionInfos[i]);
                                if (error)
                                    return "shiftDefinitionInfos." + error;
                            }
                        }
                        if (message.doNotExportHeaders != null && message.hasOwnProperty("doNotExportHeaders"))
                            if (typeof message.doNotExportHeaders !== "boolean")
                                return "doNotExportHeaders: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftDefinitionInfoFormat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat} ShiftDefinitionInfoFormat
                     */
                    ShiftDefinitionInfoFormat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat();
                        if (object.useANewSheet != null)
                            message.useANewSheet = Boolean(object.useANewSheet);
                        if (object.minEmptyRowsGap != null)
                            message.minEmptyRowsGap = object.minEmptyRowsGap | 0;
                        if (object.shiftDefinitionInfos) {
                            if (!Array.isArray(object.shiftDefinitionInfos))
                                throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.shiftDefinitionInfos: array expected");
                            message.shiftDefinitionInfos = [];
                            for (var i = 0; i < object.shiftDefinitionInfos.length; ++i) {
                                if (typeof object.shiftDefinitionInfos[i] !== "object")
                                    throw TypeError(".palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat.shiftDefinitionInfos: object expected");
                                message.shiftDefinitionInfos[i] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.fromObject(object.shiftDefinitionInfos[i]);
                            }
                        }
                        if (object.doNotExportHeaders != null)
                            message.doNotExportHeaders = Boolean(object.doNotExportHeaders);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftDefinitionInfoFormat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat} message ShiftDefinitionInfoFormat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftDefinitionInfoFormat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.shiftDefinitionInfos = [];
                        if (options.defaults) {
                            object.useANewSheet = false;
                            object.minEmptyRowsGap = 0;
                            object.doNotExportHeaders = false;
                        }
                        if (message.useANewSheet != null && message.hasOwnProperty("useANewSheet"))
                            object.useANewSheet = message.useANewSheet;
                        if (message.minEmptyRowsGap != null && message.hasOwnProperty("minEmptyRowsGap"))
                            object.minEmptyRowsGap = message.minEmptyRowsGap;
                        if (message.shiftDefinitionInfos && message.shiftDefinitionInfos.length) {
                            object.shiftDefinitionInfos = [];
                            for (var j = 0; j < message.shiftDefinitionInfos.length; ++j)
                                object.shiftDefinitionInfos[j] = $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.toObject(message.shiftDefinitionInfos[j], options);
                        }
                        if (message.doNotExportHeaders != null && message.hasOwnProperty("doNotExportHeaders"))
                            object.doNotExportHeaders = message.doNotExportHeaders;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftDefinitionInfoFormat to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfoFormat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftDefinitionInfoFormat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftDefinitionInfoFormat;
                })();
    
                ScheduleExportFormatConfigPb.ShiftDefinitionInfo = (function() {
    
                    /**
                     * Properties of a ShiftDefinitionInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @interface IShiftDefinitionInfo
                     * @property {string|null} [startPosition] ShiftDefinitionInfo startPosition
                     * @property {string|null} [endPosition] ShiftDefinitionInfo endPosition
                     * @property {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionType|null} [shiftDefinitionType] ShiftDefinitionInfo shiftDefinitionType
                     * @property {string|null} [exportName] ShiftDefinitionInfo exportName
                     */
    
                    /**
                     * Constructs a new ShiftDefinitionInfo.
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb
                     * @classdesc Represents a ShiftDefinitionInfo.
                     * @implements IShiftDefinitionInfo
                     * @constructor
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo=} [properties] Properties to set
                     */
                    function ShiftDefinitionInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ShiftDefinitionInfo startPosition.
                     * @member {string} startPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @instance
                     */
                    ShiftDefinitionInfo.prototype.startPosition = "";
    
                    /**
                     * ShiftDefinitionInfo endPosition.
                     * @member {string} endPosition
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @instance
                     */
                    ShiftDefinitionInfo.prototype.endPosition = "";
    
                    /**
                     * ShiftDefinitionInfo shiftDefinitionType.
                     * @member {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionType} shiftDefinitionType
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @instance
                     */
                    ShiftDefinitionInfo.prototype.shiftDefinitionType = 0;
    
                    /**
                     * ShiftDefinitionInfo exportName.
                     * @member {string} exportName
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @instance
                     */
                    ShiftDefinitionInfo.prototype.exportName = "";
    
                    /**
                     * Creates a new ShiftDefinitionInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo} ShiftDefinitionInfo instance
                     */
                    ShiftDefinitionInfo.create = function create(properties) {
                        return new ShiftDefinitionInfo(properties);
                    };
    
                    /**
                     * Encodes the specified ShiftDefinitionInfo message. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo} message ShiftDefinitionInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftDefinitionInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startPosition != null && Object.hasOwnProperty.call(message, "startPosition"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startPosition);
                        if (message.endPosition != null && Object.hasOwnProperty.call(message, "endPosition"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endPosition);
                        if (message.shiftDefinitionType != null && Object.hasOwnProperty.call(message, "shiftDefinitionType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.shiftDefinitionType);
                        if (message.exportName != null && Object.hasOwnProperty.call(message, "exportName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.exportName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ShiftDefinitionInfo message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.IShiftDefinitionInfo} message ShiftDefinitionInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ShiftDefinitionInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ShiftDefinitionInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo} ShiftDefinitionInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftDefinitionInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startPosition = reader.string();
                                break;
                            case 2:
                                message.endPosition = reader.string();
                                break;
                            case 3:
                                message.shiftDefinitionType = reader.int32();
                                break;
                            case 4:
                                message.exportName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ShiftDefinitionInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo} ShiftDefinitionInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ShiftDefinitionInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ShiftDefinitionInfo message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ShiftDefinitionInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            if (!$util.isString(message.startPosition))
                                return "startPosition: string expected";
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            if (!$util.isString(message.endPosition))
                                return "endPosition: string expected";
                        if (message.shiftDefinitionType != null && message.hasOwnProperty("shiftDefinitionType"))
                            switch (message.shiftDefinitionType) {
                            default:
                                return "shiftDefinitionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                                break;
                            }
                        if (message.exportName != null && message.hasOwnProperty("exportName"))
                            if (!$util.isString(message.exportName))
                                return "exportName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ShiftDefinitionInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo} ShiftDefinitionInfo
                     */
                    ShiftDefinitionInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo();
                        if (object.startPosition != null)
                            message.startPosition = String(object.startPosition);
                        if (object.endPosition != null)
                            message.endPosition = String(object.endPosition);
                        switch (object.shiftDefinitionType) {
                        case "UNKNOWN_SHIFT_DEFINITION_TYPE":
                        case 0:
                            message.shiftDefinitionType = 0;
                            break;
                        case "NAME_OF_SHIFT":
                        case 1:
                            message.shiftDefinitionType = 1;
                            break;
                        case "SHIFT_NOTE":
                        case 2:
                            message.shiftDefinitionType = 2;
                            break;
                        case "SHIFT_START_TIME":
                        case 3:
                            message.shiftDefinitionType = 3;
                            break;
                        case "SHIFT_END_TIME":
                        case 4:
                            message.shiftDefinitionType = 4;
                            break;
                        case "BREAK_START_TIME_1":
                        case 5:
                            message.shiftDefinitionType = 5;
                            break;
                        case "BREAK_END_TIME_1":
                        case 6:
                            message.shiftDefinitionType = 6;
                            break;
                        case "BREAK_DURATION_1":
                        case 7:
                            message.shiftDefinitionType = 7;
                            break;
                        case "BREAK_START_TIME_2":
                        case 8:
                            message.shiftDefinitionType = 8;
                            break;
                        case "BREAK_END_TIME_2":
                        case 9:
                            message.shiftDefinitionType = 9;
                            break;
                        case "BREAK_DURATION_2":
                        case 10:
                            message.shiftDefinitionType = 10;
                            break;
                        case "BREAK_START_TIME_3":
                        case 11:
                            message.shiftDefinitionType = 11;
                            break;
                        case "BREAK_END_TIME_3":
                        case 12:
                            message.shiftDefinitionType = 12;
                            break;
                        case "BREAK_DURATION_3":
                        case 13:
                            message.shiftDefinitionType = 13;
                            break;
                        case "SHIFT_DURATION_HH_MM":
                        case 14:
                            message.shiftDefinitionType = 14;
                            break;
                        }
                        if (object.exportName != null)
                            message.exportName = String(object.exportName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ShiftDefinitionInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo} message ShiftDefinitionInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ShiftDefinitionInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startPosition = "";
                            object.endPosition = "";
                            object.shiftDefinitionType = options.enums === String ? "UNKNOWN_SHIFT_DEFINITION_TYPE" : 0;
                            object.exportName = "";
                        }
                        if (message.startPosition != null && message.hasOwnProperty("startPosition"))
                            object.startPosition = message.startPosition;
                        if (message.endPosition != null && message.hasOwnProperty("endPosition"))
                            object.endPosition = message.endPosition;
                        if (message.shiftDefinitionType != null && message.hasOwnProperty("shiftDefinitionType"))
                            object.shiftDefinitionType = options.enums === String ? $root.palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionType[message.shiftDefinitionType] : message.shiftDefinitionType;
                        if (message.exportName != null && message.hasOwnProperty("exportName"))
                            object.exportName = message.exportName;
                        return object;
                    };
    
                    /**
                     * Converts this ShiftDefinitionInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ShiftDefinitionInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ShiftDefinitionInfo;
                })();
    
                /**
                 * ShiftDefinitionType enum.
                 * @name palexy.protobuf.ScheduleExportFormatConfigPb.ShiftDefinitionType
                 * @enum {number}
                 * @property {number} UNKNOWN_SHIFT_DEFINITION_TYPE=0 UNKNOWN_SHIFT_DEFINITION_TYPE value
                 * @property {number} NAME_OF_SHIFT=1 NAME_OF_SHIFT value
                 * @property {number} SHIFT_NOTE=2 SHIFT_NOTE value
                 * @property {number} SHIFT_START_TIME=3 SHIFT_START_TIME value
                 * @property {number} SHIFT_END_TIME=4 SHIFT_END_TIME value
                 * @property {number} BREAK_START_TIME_1=5 BREAK_START_TIME_1 value
                 * @property {number} BREAK_END_TIME_1=6 BREAK_END_TIME_1 value
                 * @property {number} BREAK_DURATION_1=7 BREAK_DURATION_1 value
                 * @property {number} BREAK_START_TIME_2=8 BREAK_START_TIME_2 value
                 * @property {number} BREAK_END_TIME_2=9 BREAK_END_TIME_2 value
                 * @property {number} BREAK_DURATION_2=10 BREAK_DURATION_2 value
                 * @property {number} BREAK_START_TIME_3=11 BREAK_START_TIME_3 value
                 * @property {number} BREAK_END_TIME_3=12 BREAK_END_TIME_3 value
                 * @property {number} BREAK_DURATION_3=13 BREAK_DURATION_3 value
                 * @property {number} SHIFT_DURATION_HH_MM=14 SHIFT_DURATION_HH_MM value
                 */
                ScheduleExportFormatConfigPb.ShiftDefinitionType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "UNKNOWN_SHIFT_DEFINITION_TYPE"] = 0;
                    values[valuesById[1] = "NAME_OF_SHIFT"] = 1;
                    values[valuesById[2] = "SHIFT_NOTE"] = 2;
                    values[valuesById[3] = "SHIFT_START_TIME"] = 3;
                    values[valuesById[4] = "SHIFT_END_TIME"] = 4;
                    values[valuesById[5] = "BREAK_START_TIME_1"] = 5;
                    values[valuesById[6] = "BREAK_END_TIME_1"] = 6;
                    values[valuesById[7] = "BREAK_DURATION_1"] = 7;
                    values[valuesById[8] = "BREAK_START_TIME_2"] = 8;
                    values[valuesById[9] = "BREAK_END_TIME_2"] = 9;
                    values[valuesById[10] = "BREAK_DURATION_2"] = 10;
                    values[valuesById[11] = "BREAK_START_TIME_3"] = 11;
                    values[valuesById[12] = "BREAK_END_TIME_3"] = 12;
                    values[valuesById[13] = "BREAK_DURATION_3"] = 13;
                    values[valuesById[14] = "SHIFT_DURATION_HH_MM"] = 14;
                    return values;
                })();
    
                return ScheduleExportFormatConfigPb;
            })();
    
            protobuf.ScheduleNonCompliance = (function() {
    
                /**
                 * Properties of a ScheduleNonCompliance.
                 * @memberof palexy.protobuf
                 * @interface IScheduleNonCompliance
                 * @property {number|null} [dateId] ScheduleNonCompliance dateId
                 * @property {number|null} [staffId] ScheduleNonCompliance staffId
                 * @property {number|null} [storeId] ScheduleNonCompliance storeId
                 * @property {number|null} [shiftId] ScheduleNonCompliance shiftId
                 * @property {palexy.protobuf.ScheduleNonComplianceType|null} [type] ScheduleNonCompliance type
                 * @property {palexy.protobuf.IWorkHourNotCoveredDetails|null} [workHourNotCoveredDetails] ScheduleNonCompliance workHourNotCoveredDetails
                 * @property {palexy.protobuf.ILackOfStaffDetails|null} [lackOfStaffDetails] ScheduleNonCompliance lackOfStaffDetails
                 */
    
                /**
                 * Constructs a new ScheduleNonCompliance.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleNonCompliance.
                 * @implements IScheduleNonCompliance
                 * @constructor
                 * @param {palexy.protobuf.IScheduleNonCompliance=} [properties] Properties to set
                 */
                function ScheduleNonCompliance(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleNonCompliance dateId.
                 * @member {number} dateId
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.dateId = 0;
    
                /**
                 * ScheduleNonCompliance staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleNonCompliance storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleNonCompliance shiftId.
                 * @member {number} shiftId
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.shiftId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleNonCompliance type.
                 * @member {palexy.protobuf.ScheduleNonComplianceType} type
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.type = 0;
    
                /**
                 * ScheduleNonCompliance workHourNotCoveredDetails.
                 * @member {palexy.protobuf.IWorkHourNotCoveredDetails|null|undefined} workHourNotCoveredDetails
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.workHourNotCoveredDetails = null;
    
                /**
                 * ScheduleNonCompliance lackOfStaffDetails.
                 * @member {palexy.protobuf.ILackOfStaffDetails|null|undefined} lackOfStaffDetails
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                ScheduleNonCompliance.prototype.lackOfStaffDetails = null;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * ScheduleNonCompliance details.
                 * @member {"workHourNotCoveredDetails"|"lackOfStaffDetails"|undefined} details
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 */
                Object.defineProperty(ScheduleNonCompliance.prototype, "details", {
                    get: $util.oneOfGetter($oneOfFields = ["workHourNotCoveredDetails", "lackOfStaffDetails"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new ScheduleNonCompliance instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {palexy.protobuf.IScheduleNonCompliance=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleNonCompliance} ScheduleNonCompliance instance
                 */
                ScheduleNonCompliance.create = function create(properties) {
                    return new ScheduleNonCompliance(properties);
                };
    
                /**
                 * Encodes the specified ScheduleNonCompliance message. Does not implicitly {@link palexy.protobuf.ScheduleNonCompliance.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {palexy.protobuf.IScheduleNonCompliance} message ScheduleNonCompliance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleNonCompliance.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                    if (message.shiftId != null && Object.hasOwnProperty.call(message, "shiftId"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.shiftId);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                    if (message.workHourNotCoveredDetails != null && Object.hasOwnProperty.call(message, "workHourNotCoveredDetails"))
                        $root.palexy.protobuf.WorkHourNotCoveredDetails.encode(message.workHourNotCoveredDetails, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.lackOfStaffDetails != null && Object.hasOwnProperty.call(message, "lackOfStaffDetails"))
                        $root.palexy.protobuf.LackOfStaffDetails.encode(message.lackOfStaffDetails, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleNonCompliance message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleNonCompliance.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {palexy.protobuf.IScheduleNonCompliance} message ScheduleNonCompliance message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleNonCompliance.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleNonCompliance message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleNonCompliance} ScheduleNonCompliance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleNonCompliance.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleNonCompliance();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dateId = reader.int32();
                            break;
                        case 2:
                            message.staffId = reader.int64();
                            break;
                        case 3:
                            message.storeId = reader.int64();
                            break;
                        case 4:
                            message.shiftId = reader.int64();
                            break;
                        case 5:
                            message.type = reader.int32();
                            break;
                        case 6:
                            message.workHourNotCoveredDetails = $root.palexy.protobuf.WorkHourNotCoveredDetails.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.lackOfStaffDetails = $root.palexy.protobuf.LackOfStaffDetails.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleNonCompliance message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleNonCompliance} ScheduleNonCompliance
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleNonCompliance.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleNonCompliance message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleNonCompliance.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        if (!$util.isInteger(message.dateId))
                            return "dateId: integer expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.shiftId != null && message.hasOwnProperty("shiftId"))
                        if (!$util.isInteger(message.shiftId) && !(message.shiftId && $util.isInteger(message.shiftId.low) && $util.isInteger(message.shiftId.high)))
                            return "shiftId: integer|Long expected";
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                            break;
                        }
                    if (message.workHourNotCoveredDetails != null && message.hasOwnProperty("workHourNotCoveredDetails")) {
                        properties.details = 1;
                        {
                            var error = $root.palexy.protobuf.WorkHourNotCoveredDetails.verify(message.workHourNotCoveredDetails);
                            if (error)
                                return "workHourNotCoveredDetails." + error;
                        }
                    }
                    if (message.lackOfStaffDetails != null && message.hasOwnProperty("lackOfStaffDetails")) {
                        if (properties.details === 1)
                            return "details: multiple values";
                        properties.details = 1;
                        {
                            var error = $root.palexy.protobuf.LackOfStaffDetails.verify(message.lackOfStaffDetails);
                            if (error)
                                return "lackOfStaffDetails." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a ScheduleNonCompliance message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleNonCompliance} ScheduleNonCompliance
                 */
                ScheduleNonCompliance.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleNonCompliance)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleNonCompliance();
                    if (object.dateId != null)
                        message.dateId = object.dateId | 0;
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    if (object.shiftId != null)
                        if ($util.Long)
                            (message.shiftId = $util.Long.fromValue(object.shiftId)).unsigned = false;
                        else if (typeof object.shiftId === "string")
                            message.shiftId = parseInt(object.shiftId, 10);
                        else if (typeof object.shiftId === "number")
                            message.shiftId = object.shiftId;
                        else if (typeof object.shiftId === "object")
                            message.shiftId = new $util.LongBits(object.shiftId.low >>> 0, object.shiftId.high >>> 0).toNumber();
                    switch (object.type) {
                    case "UNKNOWN_SCHEDULE_COMPLIANCE_TYPE":
                    case 0:
                        message.type = 0;
                        break;
                    case "OVERWORKED_STAFF_ON_DAY":
                    case 1:
                        message.type = 1;
                        break;
                    case "OVERWORKED_STAFF_IN_WEEK":
                    case 2:
                        message.type = 2;
                        break;
                    case "LACK_OF_BREAK_TIME":
                    case 3:
                        message.type = 3;
                        break;
                    case "EXCESSIVE_BREAK_TIME":
                    case 4:
                        message.type = 4;
                        break;
                    case "UNAVAILABILITY_OVERLAP":
                    case 5:
                        message.type = 5;
                        break;
                    case "WORK_HOUR_NOT_COVERED":
                    case 6:
                        message.type = 6;
                        break;
                    case "LACK_OF_STAFF":
                    case 7:
                        message.type = 7;
                        break;
                    case "OVERWORKED_STAFF_IN_WEEK_INCLUDE_OT":
                    case 8:
                        message.type = 8;
                        break;
                    }
                    if (object.workHourNotCoveredDetails != null) {
                        if (typeof object.workHourNotCoveredDetails !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleNonCompliance.workHourNotCoveredDetails: object expected");
                        message.workHourNotCoveredDetails = $root.palexy.protobuf.WorkHourNotCoveredDetails.fromObject(object.workHourNotCoveredDetails);
                    }
                    if (object.lackOfStaffDetails != null) {
                        if (typeof object.lackOfStaffDetails !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleNonCompliance.lackOfStaffDetails: object expected");
                        message.lackOfStaffDetails = $root.palexy.protobuf.LackOfStaffDetails.fromObject(object.lackOfStaffDetails);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleNonCompliance message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @static
                 * @param {palexy.protobuf.ScheduleNonCompliance} message ScheduleNonCompliance
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleNonCompliance.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.dateId = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.shiftId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.shiftId = options.longs === String ? "0" : 0;
                        object.type = options.enums === String ? "UNKNOWN_SCHEDULE_COMPLIANCE_TYPE" : 0;
                    }
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        object.dateId = message.dateId;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.shiftId != null && message.hasOwnProperty("shiftId"))
                        if (typeof message.shiftId === "number")
                            object.shiftId = options.longs === String ? String(message.shiftId) : message.shiftId;
                        else
                            object.shiftId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftId) : options.longs === Number ? new $util.LongBits(message.shiftId.low >>> 0, message.shiftId.high >>> 0).toNumber() : message.shiftId;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.palexy.protobuf.ScheduleNonComplianceType[message.type] : message.type;
                    if (message.workHourNotCoveredDetails != null && message.hasOwnProperty("workHourNotCoveredDetails")) {
                        object.workHourNotCoveredDetails = $root.palexy.protobuf.WorkHourNotCoveredDetails.toObject(message.workHourNotCoveredDetails, options);
                        if (options.oneofs)
                            object.details = "workHourNotCoveredDetails";
                    }
                    if (message.lackOfStaffDetails != null && message.hasOwnProperty("lackOfStaffDetails")) {
                        object.lackOfStaffDetails = $root.palexy.protobuf.LackOfStaffDetails.toObject(message.lackOfStaffDetails, options);
                        if (options.oneofs)
                            object.details = "lackOfStaffDetails";
                    }
                    return object;
                };
    
                /**
                 * Converts this ScheduleNonCompliance to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleNonCompliance
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleNonCompliance.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ScheduleNonCompliance;
            })();
    
            /**
             * ScheduleNonComplianceType enum.
             * @name palexy.protobuf.ScheduleNonComplianceType
             * @enum {number}
             * @property {number} UNKNOWN_SCHEDULE_COMPLIANCE_TYPE=0 UNKNOWN_SCHEDULE_COMPLIANCE_TYPE value
             * @property {number} OVERWORKED_STAFF_ON_DAY=1 OVERWORKED_STAFF_ON_DAY value
             * @property {number} OVERWORKED_STAFF_IN_WEEK=2 OVERWORKED_STAFF_IN_WEEK value
             * @property {number} LACK_OF_BREAK_TIME=3 LACK_OF_BREAK_TIME value
             * @property {number} EXCESSIVE_BREAK_TIME=4 EXCESSIVE_BREAK_TIME value
             * @property {number} UNAVAILABILITY_OVERLAP=5 UNAVAILABILITY_OVERLAP value
             * @property {number} WORK_HOUR_NOT_COVERED=6 WORK_HOUR_NOT_COVERED value
             * @property {number} LACK_OF_STAFF=7 LACK_OF_STAFF value
             * @property {number} OVERWORKED_STAFF_IN_WEEK_INCLUDE_OT=8 OVERWORKED_STAFF_IN_WEEK_INCLUDE_OT value
             */
            protobuf.ScheduleNonComplianceType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_SCHEDULE_COMPLIANCE_TYPE"] = 0;
                values[valuesById[1] = "OVERWORKED_STAFF_ON_DAY"] = 1;
                values[valuesById[2] = "OVERWORKED_STAFF_IN_WEEK"] = 2;
                values[valuesById[3] = "LACK_OF_BREAK_TIME"] = 3;
                values[valuesById[4] = "EXCESSIVE_BREAK_TIME"] = 4;
                values[valuesById[5] = "UNAVAILABILITY_OVERLAP"] = 5;
                values[valuesById[6] = "WORK_HOUR_NOT_COVERED"] = 6;
                values[valuesById[7] = "LACK_OF_STAFF"] = 7;
                values[valuesById[8] = "OVERWORKED_STAFF_IN_WEEK_INCLUDE_OT"] = 8;
                return values;
            })();
    
            protobuf.WorkHourNotCoveredDetails = (function() {
    
                /**
                 * Properties of a WorkHourNotCoveredDetails.
                 * @memberof palexy.protobuf
                 * @interface IWorkHourNotCoveredDetails
                 * @property {Array.<palexy.protobuf.WorkHourNotCoveredDetails.IHourRange>|null} [ranges] WorkHourNotCoveredDetails ranges
                 */
    
                /**
                 * Constructs a new WorkHourNotCoveredDetails.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a WorkHourNotCoveredDetails.
                 * @implements IWorkHourNotCoveredDetails
                 * @constructor
                 * @param {palexy.protobuf.IWorkHourNotCoveredDetails=} [properties] Properties to set
                 */
                function WorkHourNotCoveredDetails(properties) {
                    this.ranges = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * WorkHourNotCoveredDetails ranges.
                 * @member {Array.<palexy.protobuf.WorkHourNotCoveredDetails.IHourRange>} ranges
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @instance
                 */
                WorkHourNotCoveredDetails.prototype.ranges = $util.emptyArray;
    
                /**
                 * Creates a new WorkHourNotCoveredDetails instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {palexy.protobuf.IWorkHourNotCoveredDetails=} [properties] Properties to set
                 * @returns {palexy.protobuf.WorkHourNotCoveredDetails} WorkHourNotCoveredDetails instance
                 */
                WorkHourNotCoveredDetails.create = function create(properties) {
                    return new WorkHourNotCoveredDetails(properties);
                };
    
                /**
                 * Encodes the specified WorkHourNotCoveredDetails message. Does not implicitly {@link palexy.protobuf.WorkHourNotCoveredDetails.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {palexy.protobuf.IWorkHourNotCoveredDetails} message WorkHourNotCoveredDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WorkHourNotCoveredDetails.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ranges != null && message.ranges.length)
                        for (var i = 0; i < message.ranges.length; ++i)
                            $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange.encode(message.ranges[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified WorkHourNotCoveredDetails message, length delimited. Does not implicitly {@link palexy.protobuf.WorkHourNotCoveredDetails.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {palexy.protobuf.IWorkHourNotCoveredDetails} message WorkHourNotCoveredDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                WorkHourNotCoveredDetails.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a WorkHourNotCoveredDetails message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.WorkHourNotCoveredDetails} WorkHourNotCoveredDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WorkHourNotCoveredDetails.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.WorkHourNotCoveredDetails();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.ranges && message.ranges.length))
                                message.ranges = [];
                            message.ranges.push($root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a WorkHourNotCoveredDetails message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.WorkHourNotCoveredDetails} WorkHourNotCoveredDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                WorkHourNotCoveredDetails.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a WorkHourNotCoveredDetails message.
                 * @function verify
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                WorkHourNotCoveredDetails.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ranges != null && message.hasOwnProperty("ranges")) {
                        if (!Array.isArray(message.ranges))
                            return "ranges: array expected";
                        for (var i = 0; i < message.ranges.length; ++i) {
                            var error = $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange.verify(message.ranges[i]);
                            if (error)
                                return "ranges." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a WorkHourNotCoveredDetails message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.WorkHourNotCoveredDetails} WorkHourNotCoveredDetails
                 */
                WorkHourNotCoveredDetails.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.WorkHourNotCoveredDetails)
                        return object;
                    var message = new $root.palexy.protobuf.WorkHourNotCoveredDetails();
                    if (object.ranges) {
                        if (!Array.isArray(object.ranges))
                            throw TypeError(".palexy.protobuf.WorkHourNotCoveredDetails.ranges: array expected");
                        message.ranges = [];
                        for (var i = 0; i < object.ranges.length; ++i) {
                            if (typeof object.ranges[i] !== "object")
                                throw TypeError(".palexy.protobuf.WorkHourNotCoveredDetails.ranges: object expected");
                            message.ranges[i] = $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange.fromObject(object.ranges[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a WorkHourNotCoveredDetails message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @static
                 * @param {palexy.protobuf.WorkHourNotCoveredDetails} message WorkHourNotCoveredDetails
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                WorkHourNotCoveredDetails.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ranges = [];
                    if (message.ranges && message.ranges.length) {
                        object.ranges = [];
                        for (var j = 0; j < message.ranges.length; ++j)
                            object.ranges[j] = $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange.toObject(message.ranges[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this WorkHourNotCoveredDetails to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                WorkHourNotCoveredDetails.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                WorkHourNotCoveredDetails.HourRange = (function() {
    
                    /**
                     * Properties of an HourRange.
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                     * @interface IHourRange
                     * @property {string|null} [start] HourRange start
                     * @property {string|null} [end] HourRange end
                     */
    
                    /**
                     * Constructs a new HourRange.
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails
                     * @classdesc Represents an HourRange.
                     * @implements IHourRange
                     * @constructor
                     * @param {palexy.protobuf.WorkHourNotCoveredDetails.IHourRange=} [properties] Properties to set
                     */
                    function HourRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * HourRange start.
                     * @member {string} start
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @instance
                     */
                    HourRange.prototype.start = "";
    
                    /**
                     * HourRange end.
                     * @member {string} end
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @instance
                     */
                    HourRange.prototype.end = "";
    
                    /**
                     * Creates a new HourRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {palexy.protobuf.WorkHourNotCoveredDetails.IHourRange=} [properties] Properties to set
                     * @returns {palexy.protobuf.WorkHourNotCoveredDetails.HourRange} HourRange instance
                     */
                    HourRange.create = function create(properties) {
                        return new HourRange(properties);
                    };
    
                    /**
                     * Encodes the specified HourRange message. Does not implicitly {@link palexy.protobuf.WorkHourNotCoveredDetails.HourRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {palexy.protobuf.WorkHourNotCoveredDetails.IHourRange} message HourRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HourRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified HourRange message, length delimited. Does not implicitly {@link palexy.protobuf.WorkHourNotCoveredDetails.HourRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {palexy.protobuf.WorkHourNotCoveredDetails.IHourRange} message HourRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    HourRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an HourRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.WorkHourNotCoveredDetails.HourRange} HourRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HourRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.string();
                                break;
                            case 2:
                                message.end = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an HourRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.WorkHourNotCoveredDetails.HourRange} HourRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    HourRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an HourRange message.
                     * @function verify
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    HourRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isString(message.start))
                                return "start: string expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isString(message.end))
                                return "end: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an HourRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.WorkHourNotCoveredDetails.HourRange} HourRange
                     */
                    HourRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange)
                            return object;
                        var message = new $root.palexy.protobuf.WorkHourNotCoveredDetails.HourRange();
                        if (object.start != null)
                            message.start = String(object.start);
                        if (object.end != null)
                            message.end = String(object.end);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an HourRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @static
                     * @param {palexy.protobuf.WorkHourNotCoveredDetails.HourRange} message HourRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    HourRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = "";
                            object.end = "";
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this HourRange to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.WorkHourNotCoveredDetails.HourRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    HourRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return HourRange;
                })();
    
                return WorkHourNotCoveredDetails;
            })();
    
            protobuf.LackOfStaffDetails = (function() {
    
                /**
                 * Properties of a LackOfStaffDetails.
                 * @memberof palexy.protobuf
                 * @interface ILackOfStaffDetails
                 * @property {Array.<palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange>|null} [ranges] LackOfStaffDetails ranges
                 */
    
                /**
                 * Constructs a new LackOfStaffDetails.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a LackOfStaffDetails.
                 * @implements ILackOfStaffDetails
                 * @constructor
                 * @param {palexy.protobuf.ILackOfStaffDetails=} [properties] Properties to set
                 */
                function LackOfStaffDetails(properties) {
                    this.ranges = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * LackOfStaffDetails ranges.
                 * @member {Array.<palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange>} ranges
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @instance
                 */
                LackOfStaffDetails.prototype.ranges = $util.emptyArray;
    
                /**
                 * Creates a new LackOfStaffDetails instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {palexy.protobuf.ILackOfStaffDetails=} [properties] Properties to set
                 * @returns {palexy.protobuf.LackOfStaffDetails} LackOfStaffDetails instance
                 */
                LackOfStaffDetails.create = function create(properties) {
                    return new LackOfStaffDetails(properties);
                };
    
                /**
                 * Encodes the specified LackOfStaffDetails message. Does not implicitly {@link palexy.protobuf.LackOfStaffDetails.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {palexy.protobuf.ILackOfStaffDetails} message LackOfStaffDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LackOfStaffDetails.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ranges != null && message.ranges.length)
                        for (var i = 0; i < message.ranges.length; ++i)
                            $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.encode(message.ranges[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified LackOfStaffDetails message, length delimited. Does not implicitly {@link palexy.protobuf.LackOfStaffDetails.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {palexy.protobuf.ILackOfStaffDetails} message LackOfStaffDetails message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                LackOfStaffDetails.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a LackOfStaffDetails message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.LackOfStaffDetails} LackOfStaffDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LackOfStaffDetails.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.LackOfStaffDetails();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.ranges && message.ranges.length))
                                message.ranges = [];
                            message.ranges.push($root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a LackOfStaffDetails message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.LackOfStaffDetails} LackOfStaffDetails
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                LackOfStaffDetails.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a LackOfStaffDetails message.
                 * @function verify
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                LackOfStaffDetails.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ranges != null && message.hasOwnProperty("ranges")) {
                        if (!Array.isArray(message.ranges))
                            return "ranges: array expected";
                        for (var i = 0; i < message.ranges.length; ++i) {
                            var error = $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.verify(message.ranges[i]);
                            if (error)
                                return "ranges." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a LackOfStaffDetails message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.LackOfStaffDetails} LackOfStaffDetails
                 */
                LackOfStaffDetails.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.LackOfStaffDetails)
                        return object;
                    var message = new $root.palexy.protobuf.LackOfStaffDetails();
                    if (object.ranges) {
                        if (!Array.isArray(object.ranges))
                            throw TypeError(".palexy.protobuf.LackOfStaffDetails.ranges: array expected");
                        message.ranges = [];
                        for (var i = 0; i < object.ranges.length; ++i) {
                            if (typeof object.ranges[i] !== "object")
                                throw TypeError(".palexy.protobuf.LackOfStaffDetails.ranges: object expected");
                            message.ranges[i] = $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.fromObject(object.ranges[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a LackOfStaffDetails message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @static
                 * @param {palexy.protobuf.LackOfStaffDetails} message LackOfStaffDetails
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                LackOfStaffDetails.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ranges = [];
                    if (message.ranges && message.ranges.length) {
                        object.ranges = [];
                        for (var j = 0; j < message.ranges.length; ++j)
                            object.ranges[j] = $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.toObject(message.ranges[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this LackOfStaffDetails to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.LackOfStaffDetails
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                LackOfStaffDetails.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                LackOfStaffDetails.LackOfStaffRange = (function() {
    
                    /**
                     * Properties of a LackOfStaffRange.
                     * @memberof palexy.protobuf.LackOfStaffDetails
                     * @interface ILackOfStaffRange
                     * @property {number|null} [eventId] LackOfStaffRange eventId
                     * @property {string|null} [start] LackOfStaffRange start
                     * @property {string|null} [end] LackOfStaffRange end
                     * @property {number|null} [requiredStaffCount] LackOfStaffRange requiredStaffCount
                     * @property {number|null} [availableStaffCount] LackOfStaffRange availableStaffCount
                     */
    
                    /**
                     * Constructs a new LackOfStaffRange.
                     * @memberof palexy.protobuf.LackOfStaffDetails
                     * @classdesc Represents a LackOfStaffRange.
                     * @implements ILackOfStaffRange
                     * @constructor
                     * @param {palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange=} [properties] Properties to set
                     */
                    function LackOfStaffRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * LackOfStaffRange eventId.
                     * @member {number} eventId
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     */
                    LackOfStaffRange.prototype.eventId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * LackOfStaffRange start.
                     * @member {string} start
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     */
                    LackOfStaffRange.prototype.start = "";
    
                    /**
                     * LackOfStaffRange end.
                     * @member {string} end
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     */
                    LackOfStaffRange.prototype.end = "";
    
                    /**
                     * LackOfStaffRange requiredStaffCount.
                     * @member {number} requiredStaffCount
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     */
                    LackOfStaffRange.prototype.requiredStaffCount = 0;
    
                    /**
                     * LackOfStaffRange availableStaffCount.
                     * @member {number} availableStaffCount
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     */
                    LackOfStaffRange.prototype.availableStaffCount = 0;
    
                    /**
                     * Creates a new LackOfStaffRange instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange=} [properties] Properties to set
                     * @returns {palexy.protobuf.LackOfStaffDetails.LackOfStaffRange} LackOfStaffRange instance
                     */
                    LackOfStaffRange.create = function create(properties) {
                        return new LackOfStaffRange(properties);
                    };
    
                    /**
                     * Encodes the specified LackOfStaffRange message. Does not implicitly {@link palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange} message LackOfStaffRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LackOfStaffRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.eventId != null && Object.hasOwnProperty.call(message, "eventId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.eventId);
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.end);
                        if (message.requiredStaffCount != null && Object.hasOwnProperty.call(message, "requiredStaffCount"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.requiredStaffCount);
                        if (message.availableStaffCount != null && Object.hasOwnProperty.call(message, "availableStaffCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.availableStaffCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified LackOfStaffRange message, length delimited. Does not implicitly {@link palexy.protobuf.LackOfStaffDetails.LackOfStaffRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {palexy.protobuf.LackOfStaffDetails.ILackOfStaffRange} message LackOfStaffRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LackOfStaffRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a LackOfStaffRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.LackOfStaffDetails.LackOfStaffRange} LackOfStaffRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LackOfStaffRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.eventId = reader.int64();
                                break;
                            case 2:
                                message.start = reader.string();
                                break;
                            case 3:
                                message.end = reader.string();
                                break;
                            case 4:
                                message.requiredStaffCount = reader.int32();
                                break;
                            case 5:
                                message.availableStaffCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a LackOfStaffRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.LackOfStaffDetails.LackOfStaffRange} LackOfStaffRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LackOfStaffRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a LackOfStaffRange message.
                     * @function verify
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LackOfStaffRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.eventId != null && message.hasOwnProperty("eventId"))
                            if (!$util.isInteger(message.eventId) && !(message.eventId && $util.isInteger(message.eventId.low) && $util.isInteger(message.eventId.high)))
                                return "eventId: integer|Long expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isString(message.start))
                                return "start: string expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isString(message.end))
                                return "end: string expected";
                        if (message.requiredStaffCount != null && message.hasOwnProperty("requiredStaffCount"))
                            if (!$util.isInteger(message.requiredStaffCount))
                                return "requiredStaffCount: integer expected";
                        if (message.availableStaffCount != null && message.hasOwnProperty("availableStaffCount"))
                            if (!$util.isInteger(message.availableStaffCount))
                                return "availableStaffCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a LackOfStaffRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.LackOfStaffDetails.LackOfStaffRange} LackOfStaffRange
                     */
                    LackOfStaffRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange)
                            return object;
                        var message = new $root.palexy.protobuf.LackOfStaffDetails.LackOfStaffRange();
                        if (object.eventId != null)
                            if ($util.Long)
                                (message.eventId = $util.Long.fromValue(object.eventId)).unsigned = false;
                            else if (typeof object.eventId === "string")
                                message.eventId = parseInt(object.eventId, 10);
                            else if (typeof object.eventId === "number")
                                message.eventId = object.eventId;
                            else if (typeof object.eventId === "object")
                                message.eventId = new $util.LongBits(object.eventId.low >>> 0, object.eventId.high >>> 0).toNumber();
                        if (object.start != null)
                            message.start = String(object.start);
                        if (object.end != null)
                            message.end = String(object.end);
                        if (object.requiredStaffCount != null)
                            message.requiredStaffCount = object.requiredStaffCount | 0;
                        if (object.availableStaffCount != null)
                            message.availableStaffCount = object.availableStaffCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a LackOfStaffRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @static
                     * @param {palexy.protobuf.LackOfStaffDetails.LackOfStaffRange} message LackOfStaffRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LackOfStaffRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.eventId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.eventId = options.longs === String ? "0" : 0;
                            object.start = "";
                            object.end = "";
                            object.requiredStaffCount = 0;
                            object.availableStaffCount = 0;
                        }
                        if (message.eventId != null && message.hasOwnProperty("eventId"))
                            if (typeof message.eventId === "number")
                                object.eventId = options.longs === String ? String(message.eventId) : message.eventId;
                            else
                                object.eventId = options.longs === String ? $util.Long.prototype.toString.call(message.eventId) : options.longs === Number ? new $util.LongBits(message.eventId.low >>> 0, message.eventId.high >>> 0).toNumber() : message.eventId;
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        if (message.requiredStaffCount != null && message.hasOwnProperty("requiredStaffCount"))
                            object.requiredStaffCount = message.requiredStaffCount;
                        if (message.availableStaffCount != null && message.hasOwnProperty("availableStaffCount"))
                            object.availableStaffCount = message.availableStaffCount;
                        return object;
                    };
    
                    /**
                     * Converts this LackOfStaffRange to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.LackOfStaffDetails.LackOfStaffRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LackOfStaffRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return LackOfStaffRange;
                })();
    
                return LackOfStaffDetails;
            })();
    
            protobuf.ScheduleDateInsight = (function() {
    
                /**
                 * Properties of a ScheduleDateInsight.
                 * @memberof palexy.protobuf
                 * @interface IScheduleDateInsight
                 * @property {number|null} [dateId] ScheduleDateInsight dateId
                 * @property {number|null} [totalPaidWorkingHours] ScheduleDateInsight totalPaidWorkingHours
                 * @property {number|null} [totalShifts] ScheduleDateInsight totalShifts
                 * @property {number|null} [laborCost] ScheduleDateInsight laborCost
                 */
    
                /**
                 * Constructs a new ScheduleDateInsight.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleDateInsight.
                 * @implements IScheduleDateInsight
                 * @constructor
                 * @param {palexy.protobuf.IScheduleDateInsight=} [properties] Properties to set
                 */
                function ScheduleDateInsight(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleDateInsight dateId.
                 * @member {number} dateId
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @instance
                 */
                ScheduleDateInsight.prototype.dateId = 0;
    
                /**
                 * ScheduleDateInsight totalPaidWorkingHours.
                 * @member {number} totalPaidWorkingHours
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @instance
                 */
                ScheduleDateInsight.prototype.totalPaidWorkingHours = 0;
    
                /**
                 * ScheduleDateInsight totalShifts.
                 * @member {number} totalShifts
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @instance
                 */
                ScheduleDateInsight.prototype.totalShifts = 0;
    
                /**
                 * ScheduleDateInsight laborCost.
                 * @member {number} laborCost
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @instance
                 */
                ScheduleDateInsight.prototype.laborCost = 0;
    
                /**
                 * Creates a new ScheduleDateInsight instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleDateInsight=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleDateInsight} ScheduleDateInsight instance
                 */
                ScheduleDateInsight.create = function create(properties) {
                    return new ScheduleDateInsight(properties);
                };
    
                /**
                 * Encodes the specified ScheduleDateInsight message. Does not implicitly {@link palexy.protobuf.ScheduleDateInsight.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleDateInsight} message ScheduleDateInsight message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleDateInsight.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.dateId);
                    if (message.totalPaidWorkingHours != null && Object.hasOwnProperty.call(message, "totalPaidWorkingHours"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.totalPaidWorkingHours);
                    if (message.totalShifts != null && Object.hasOwnProperty.call(message, "totalShifts"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalShifts);
                    if (message.laborCost != null && Object.hasOwnProperty.call(message, "laborCost"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.laborCost);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleDateInsight message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleDateInsight.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleDateInsight} message ScheduleDateInsight message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleDateInsight.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleDateInsight message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleDateInsight} ScheduleDateInsight
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleDateInsight.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleDateInsight();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.dateId = reader.int32();
                            break;
                        case 2:
                            message.totalPaidWorkingHours = reader.double();
                            break;
                        case 3:
                            message.totalShifts = reader.int32();
                            break;
                        case 4:
                            message.laborCost = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleDateInsight message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleDateInsight} ScheduleDateInsight
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleDateInsight.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleDateInsight message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleDateInsight.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        if (!$util.isInteger(message.dateId))
                            return "dateId: integer expected";
                    if (message.totalPaidWorkingHours != null && message.hasOwnProperty("totalPaidWorkingHours"))
                        if (typeof message.totalPaidWorkingHours !== "number")
                            return "totalPaidWorkingHours: number expected";
                    if (message.totalShifts != null && message.hasOwnProperty("totalShifts"))
                        if (!$util.isInteger(message.totalShifts))
                            return "totalShifts: integer expected";
                    if (message.laborCost != null && message.hasOwnProperty("laborCost"))
                        if (typeof message.laborCost !== "number")
                            return "laborCost: number expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleDateInsight message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleDateInsight} ScheduleDateInsight
                 */
                ScheduleDateInsight.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleDateInsight)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleDateInsight();
                    if (object.dateId != null)
                        message.dateId = object.dateId | 0;
                    if (object.totalPaidWorkingHours != null)
                        message.totalPaidWorkingHours = Number(object.totalPaidWorkingHours);
                    if (object.totalShifts != null)
                        message.totalShifts = object.totalShifts | 0;
                    if (object.laborCost != null)
                        message.laborCost = Number(object.laborCost);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleDateInsight message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @static
                 * @param {palexy.protobuf.ScheduleDateInsight} message ScheduleDateInsight
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleDateInsight.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.dateId = 0;
                        object.totalPaidWorkingHours = 0;
                        object.totalShifts = 0;
                        object.laborCost = 0;
                    }
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        object.dateId = message.dateId;
                    if (message.totalPaidWorkingHours != null && message.hasOwnProperty("totalPaidWorkingHours"))
                        object.totalPaidWorkingHours = options.json && !isFinite(message.totalPaidWorkingHours) ? String(message.totalPaidWorkingHours) : message.totalPaidWorkingHours;
                    if (message.totalShifts != null && message.hasOwnProperty("totalShifts"))
                        object.totalShifts = message.totalShifts;
                    if (message.laborCost != null && message.hasOwnProperty("laborCost"))
                        object.laborCost = options.json && !isFinite(message.laborCost) ? String(message.laborCost) : message.laborCost;
                    return object;
                };
    
                /**
                 * Converts this ScheduleDateInsight to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleDateInsight
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleDateInsight.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ScheduleDateInsight;
            })();
    
            protobuf.ScheduleStaffInsight = (function() {
    
                /**
                 * Properties of a ScheduleStaffInsight.
                 * @memberof palexy.protobuf
                 * @interface IScheduleStaffInsight
                 * @property {number|null} [staffId] ScheduleStaffInsight staffId
                 * @property {number|null} [totalPaidWorkingHours] ScheduleStaffInsight totalPaidWorkingHours
                 * @property {number|null} [totalPaidLeave] ScheduleStaffInsight totalPaidLeave
                 * @property {number|null} [totalUnpaidLeave] ScheduleStaffInsight totalUnpaidLeave
                 * @property {Array.<number>|null} [ptHighlightedShiftIds] ScheduleStaffInsight ptHighlightedShiftIds
                 */
    
                /**
                 * Constructs a new ScheduleStaffInsight.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleStaffInsight.
                 * @implements IScheduleStaffInsight
                 * @constructor
                 * @param {palexy.protobuf.IScheduleStaffInsight=} [properties] Properties to set
                 */
                function ScheduleStaffInsight(properties) {
                    this.ptHighlightedShiftIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleStaffInsight staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 */
                ScheduleStaffInsight.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleStaffInsight totalPaidWorkingHours.
                 * @member {number} totalPaidWorkingHours
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 */
                ScheduleStaffInsight.prototype.totalPaidWorkingHours = 0;
    
                /**
                 * ScheduleStaffInsight totalPaidLeave.
                 * @member {number} totalPaidLeave
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 */
                ScheduleStaffInsight.prototype.totalPaidLeave = 0;
    
                /**
                 * ScheduleStaffInsight totalUnpaidLeave.
                 * @member {number} totalUnpaidLeave
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 */
                ScheduleStaffInsight.prototype.totalUnpaidLeave = 0;
    
                /**
                 * ScheduleStaffInsight ptHighlightedShiftIds.
                 * @member {Array.<number>} ptHighlightedShiftIds
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 */
                ScheduleStaffInsight.prototype.ptHighlightedShiftIds = $util.emptyArray;
    
                /**
                 * Creates a new ScheduleStaffInsight instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleStaffInsight=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleStaffInsight} ScheduleStaffInsight instance
                 */
                ScheduleStaffInsight.create = function create(properties) {
                    return new ScheduleStaffInsight(properties);
                };
    
                /**
                 * Encodes the specified ScheduleStaffInsight message. Does not implicitly {@link palexy.protobuf.ScheduleStaffInsight.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleStaffInsight} message ScheduleStaffInsight message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStaffInsight.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffId);
                    if (message.totalPaidWorkingHours != null && Object.hasOwnProperty.call(message, "totalPaidWorkingHours"))
                        writer.uint32(/* id 2, wireType 1 =*/17).double(message.totalPaidWorkingHours);
                    if (message.totalPaidLeave != null && Object.hasOwnProperty.call(message, "totalPaidLeave"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.totalPaidLeave);
                    if (message.totalUnpaidLeave != null && Object.hasOwnProperty.call(message, "totalUnpaidLeave"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.totalUnpaidLeave);
                    if (message.ptHighlightedShiftIds != null && message.ptHighlightedShiftIds.length) {
                        writer.uint32(/* id 5, wireType 2 =*/42).fork();
                        for (var i = 0; i < message.ptHighlightedShiftIds.length; ++i)
                            writer.int64(message.ptHighlightedShiftIds[i]);
                        writer.ldelim();
                    }
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleStaffInsight message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleStaffInsight.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {palexy.protobuf.IScheduleStaffInsight} message ScheduleStaffInsight message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStaffInsight.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleStaffInsight message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleStaffInsight} ScheduleStaffInsight
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStaffInsight.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleStaffInsight();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.staffId = reader.int64();
                            break;
                        case 2:
                            message.totalPaidWorkingHours = reader.double();
                            break;
                        case 3:
                            message.totalPaidLeave = reader.double();
                            break;
                        case 4:
                            message.totalUnpaidLeave = reader.double();
                            break;
                        case 5:
                            if (!(message.ptHighlightedShiftIds && message.ptHighlightedShiftIds.length))
                                message.ptHighlightedShiftIds = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.ptHighlightedShiftIds.push(reader.int64());
                            } else
                                message.ptHighlightedShiftIds.push(reader.int64());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleStaffInsight message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleStaffInsight} ScheduleStaffInsight
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStaffInsight.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleStaffInsight message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleStaffInsight.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.totalPaidWorkingHours != null && message.hasOwnProperty("totalPaidWorkingHours"))
                        if (typeof message.totalPaidWorkingHours !== "number")
                            return "totalPaidWorkingHours: number expected";
                    if (message.totalPaidLeave != null && message.hasOwnProperty("totalPaidLeave"))
                        if (typeof message.totalPaidLeave !== "number")
                            return "totalPaidLeave: number expected";
                    if (message.totalUnpaidLeave != null && message.hasOwnProperty("totalUnpaidLeave"))
                        if (typeof message.totalUnpaidLeave !== "number")
                            return "totalUnpaidLeave: number expected";
                    if (message.ptHighlightedShiftIds != null && message.hasOwnProperty("ptHighlightedShiftIds")) {
                        if (!Array.isArray(message.ptHighlightedShiftIds))
                            return "ptHighlightedShiftIds: array expected";
                        for (var i = 0; i < message.ptHighlightedShiftIds.length; ++i)
                            if (!$util.isInteger(message.ptHighlightedShiftIds[i]) && !(message.ptHighlightedShiftIds[i] && $util.isInteger(message.ptHighlightedShiftIds[i].low) && $util.isInteger(message.ptHighlightedShiftIds[i].high)))
                                return "ptHighlightedShiftIds: integer|Long[] expected";
                    }
                    return null;
                };
    
                /**
                 * Creates a ScheduleStaffInsight message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleStaffInsight} ScheduleStaffInsight
                 */
                ScheduleStaffInsight.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleStaffInsight)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleStaffInsight();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.totalPaidWorkingHours != null)
                        message.totalPaidWorkingHours = Number(object.totalPaidWorkingHours);
                    if (object.totalPaidLeave != null)
                        message.totalPaidLeave = Number(object.totalPaidLeave);
                    if (object.totalUnpaidLeave != null)
                        message.totalUnpaidLeave = Number(object.totalUnpaidLeave);
                    if (object.ptHighlightedShiftIds) {
                        if (!Array.isArray(object.ptHighlightedShiftIds))
                            throw TypeError(".palexy.protobuf.ScheduleStaffInsight.ptHighlightedShiftIds: array expected");
                        message.ptHighlightedShiftIds = [];
                        for (var i = 0; i < object.ptHighlightedShiftIds.length; ++i)
                            if ($util.Long)
                                (message.ptHighlightedShiftIds[i] = $util.Long.fromValue(object.ptHighlightedShiftIds[i])).unsigned = false;
                            else if (typeof object.ptHighlightedShiftIds[i] === "string")
                                message.ptHighlightedShiftIds[i] = parseInt(object.ptHighlightedShiftIds[i], 10);
                            else if (typeof object.ptHighlightedShiftIds[i] === "number")
                                message.ptHighlightedShiftIds[i] = object.ptHighlightedShiftIds[i];
                            else if (typeof object.ptHighlightedShiftIds[i] === "object")
                                message.ptHighlightedShiftIds[i] = new $util.LongBits(object.ptHighlightedShiftIds[i].low >>> 0, object.ptHighlightedShiftIds[i].high >>> 0).toNumber();
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleStaffInsight message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @static
                 * @param {palexy.protobuf.ScheduleStaffInsight} message ScheduleStaffInsight
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleStaffInsight.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.ptHighlightedShiftIds = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        object.totalPaidWorkingHours = 0;
                        object.totalPaidLeave = 0;
                        object.totalUnpaidLeave = 0;
                    }
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.totalPaidWorkingHours != null && message.hasOwnProperty("totalPaidWorkingHours"))
                        object.totalPaidWorkingHours = options.json && !isFinite(message.totalPaidWorkingHours) ? String(message.totalPaidWorkingHours) : message.totalPaidWorkingHours;
                    if (message.totalPaidLeave != null && message.hasOwnProperty("totalPaidLeave"))
                        object.totalPaidLeave = options.json && !isFinite(message.totalPaidLeave) ? String(message.totalPaidLeave) : message.totalPaidLeave;
                    if (message.totalUnpaidLeave != null && message.hasOwnProperty("totalUnpaidLeave"))
                        object.totalUnpaidLeave = options.json && !isFinite(message.totalUnpaidLeave) ? String(message.totalUnpaidLeave) : message.totalUnpaidLeave;
                    if (message.ptHighlightedShiftIds && message.ptHighlightedShiftIds.length) {
                        object.ptHighlightedShiftIds = [];
                        for (var j = 0; j < message.ptHighlightedShiftIds.length; ++j)
                            if (typeof message.ptHighlightedShiftIds[j] === "number")
                                object.ptHighlightedShiftIds[j] = options.longs === String ? String(message.ptHighlightedShiftIds[j]) : message.ptHighlightedShiftIds[j];
                            else
                                object.ptHighlightedShiftIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.ptHighlightedShiftIds[j]) : options.longs === Number ? new $util.LongBits(message.ptHighlightedShiftIds[j].low >>> 0, message.ptHighlightedShiftIds[j].high >>> 0).toNumber() : message.ptHighlightedShiftIds[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this ScheduleStaffInsight to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleStaffInsight
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleStaffInsight.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ScheduleStaffInsight;
            })();
    
            protobuf.ProposedShift = (function() {
    
                /**
                 * Properties of a ProposedShift.
                 * @memberof palexy.protobuf
                 * @interface IProposedShift
                 * @property {number|null} [shiftTemplateId] ProposedShift shiftTemplateId
                 * @property {number|null} [staffId] ProposedShift staffId
                 * @property {number|null} [dateId] ProposedShift dateId
                 * @property {number|null} [scheduleAreaId] ProposedShift scheduleAreaId
                 * @property {number|null} [positionId] ProposedShift positionId
                 * @property {Object.<string,string>|null} [breakTimeStart] ProposedShift breakTimeStart
                 * @property {boolean|null} [isFromScheduleTemplate] ProposedShift isFromScheduleTemplate
                 * @property {number|null} [positionLevel] ProposedShift positionLevel
                 * @property {palexy.protobuf.StaffEmploymentType|null} [employmentType] ProposedShift employmentType
                 * @property {palexy.protobuf.Gender|null} [gender] ProposedShift gender
                 */
    
                /**
                 * Constructs a new ProposedShift.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ProposedShift.
                 * @implements IProposedShift
                 * @constructor
                 * @param {palexy.protobuf.IProposedShift=} [properties] Properties to set
                 */
                function ProposedShift(properties) {
                    this.breakTimeStart = {};
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ProposedShift shiftTemplateId.
                 * @member {number} shiftTemplateId
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ProposedShift staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ProposedShift dateId.
                 * @member {number} dateId
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.dateId = 0;
    
                /**
                 * ProposedShift scheduleAreaId.
                 * @member {number} scheduleAreaId
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ProposedShift positionId.
                 * @member {number} positionId
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.positionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ProposedShift breakTimeStart.
                 * @member {Object.<string,string>} breakTimeStart
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.breakTimeStart = $util.emptyObject;
    
                /**
                 * ProposedShift isFromScheduleTemplate.
                 * @member {boolean} isFromScheduleTemplate
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.isFromScheduleTemplate = false;
    
                /**
                 * ProposedShift positionLevel.
                 * @member {number} positionLevel
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.positionLevel = 0;
    
                /**
                 * ProposedShift employmentType.
                 * @member {palexy.protobuf.StaffEmploymentType} employmentType
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.employmentType = 0;
    
                /**
                 * ProposedShift gender.
                 * @member {palexy.protobuf.Gender} gender
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 */
                ProposedShift.prototype.gender = 0;
    
                /**
                 * Creates a new ProposedShift instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {palexy.protobuf.IProposedShift=} [properties] Properties to set
                 * @returns {palexy.protobuf.ProposedShift} ProposedShift instance
                 */
                ProposedShift.create = function create(properties) {
                    return new ProposedShift(properties);
                };
    
                /**
                 * Encodes the specified ProposedShift message. Does not implicitly {@link palexy.protobuf.ProposedShift.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {palexy.protobuf.IProposedShift} message ProposedShift message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProposedShift.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.shiftTemplateId);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                    if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                    if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.scheduleAreaId);
                    if (message.breakTimeStart != null && Object.hasOwnProperty.call(message, "breakTimeStart"))
                        for (var keys = Object.keys(message.breakTimeStart), i = 0; i < keys.length; ++i)
                            writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 0 =*/8).int64(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.breakTimeStart[keys[i]]).ldelim();
                    if (message.positionId != null && Object.hasOwnProperty.call(message, "positionId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.positionId);
                    if (message.isFromScheduleTemplate != null && Object.hasOwnProperty.call(message, "isFromScheduleTemplate"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isFromScheduleTemplate);
                    if (message.positionLevel != null && Object.hasOwnProperty.call(message, "positionLevel"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.positionLevel);
                    if (message.employmentType != null && Object.hasOwnProperty.call(message, "employmentType"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.employmentType);
                    if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.gender);
                    return writer;
                };
    
                /**
                 * Encodes the specified ProposedShift message, length delimited. Does not implicitly {@link palexy.protobuf.ProposedShift.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {palexy.protobuf.IProposedShift} message ProposedShift message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ProposedShift.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ProposedShift message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ProposedShift} ProposedShift
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProposedShift.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ProposedShift(), key, value;
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.shiftTemplateId = reader.int64();
                            break;
                        case 2:
                            message.staffId = reader.int64();
                            break;
                        case 3:
                            message.dateId = reader.int32();
                            break;
                        case 4:
                            message.scheduleAreaId = reader.int64();
                            break;
                        case 6:
                            message.positionId = reader.int64();
                            break;
                        case 5:
                            if (message.breakTimeStart === $util.emptyObject)
                                message.breakTimeStart = {};
                            var end2 = reader.uint32() + reader.pos;
                            key = 0;
                            value = "";
                            while (reader.pos < end2) {
                                var tag2 = reader.uint32();
                                switch (tag2 >>> 3) {
                                case 1:
                                    key = reader.int64();
                                    break;
                                case 2:
                                    value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag2 & 7);
                                    break;
                                }
                            }
                            message.breakTimeStart[typeof key === "object" ? $util.longToHash(key) : key] = value;
                            break;
                        case 7:
                            message.isFromScheduleTemplate = reader.bool();
                            break;
                        case 8:
                            message.positionLevel = reader.int32();
                            break;
                        case 9:
                            message.employmentType = reader.int32();
                            break;
                        case 10:
                            message.gender = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ProposedShift message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ProposedShift} ProposedShift
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ProposedShift.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ProposedShift message.
                 * @function verify
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ProposedShift.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                            return "shiftTemplateId: integer|Long expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        if (!$util.isInteger(message.dateId))
                            return "dateId: integer expected";
                    if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                        if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                            return "scheduleAreaId: integer|Long expected";
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (!$util.isInteger(message.positionId) && !(message.positionId && $util.isInteger(message.positionId.low) && $util.isInteger(message.positionId.high)))
                            return "positionId: integer|Long expected";
                    if (message.breakTimeStart != null && message.hasOwnProperty("breakTimeStart")) {
                        if (!$util.isObject(message.breakTimeStart))
                            return "breakTimeStart: object expected";
                        var key = Object.keys(message.breakTimeStart);
                        for (var i = 0; i < key.length; ++i) {
                            if (!$util.key64Re.test(key[i]))
                                return "breakTimeStart: integer|Long key{k:int64} expected";
                            if (!$util.isString(message.breakTimeStart[key[i]]))
                                return "breakTimeStart: string{k:int64} expected";
                        }
                    }
                    if (message.isFromScheduleTemplate != null && message.hasOwnProperty("isFromScheduleTemplate"))
                        if (typeof message.isFromScheduleTemplate !== "boolean")
                            return "isFromScheduleTemplate: boolean expected";
                    if (message.positionLevel != null && message.hasOwnProperty("positionLevel"))
                        if (!$util.isInteger(message.positionLevel))
                            return "positionLevel: integer expected";
                    if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                        switch (message.employmentType) {
                        default:
                            return "employmentType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.gender != null && message.hasOwnProperty("gender"))
                        switch (message.gender) {
                        default:
                            return "gender: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };
    
                /**
                 * Creates a ProposedShift message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ProposedShift} ProposedShift
                 */
                ProposedShift.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ProposedShift)
                        return object;
                    var message = new $root.palexy.protobuf.ProposedShift();
                    if (object.shiftTemplateId != null)
                        if ($util.Long)
                            (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                        else if (typeof object.shiftTemplateId === "string")
                            message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                        else if (typeof object.shiftTemplateId === "number")
                            message.shiftTemplateId = object.shiftTemplateId;
                        else if (typeof object.shiftTemplateId === "object")
                            message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.dateId != null)
                        message.dateId = object.dateId | 0;
                    if (object.scheduleAreaId != null)
                        if ($util.Long)
                            (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                        else if (typeof object.scheduleAreaId === "string")
                            message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                        else if (typeof object.scheduleAreaId === "number")
                            message.scheduleAreaId = object.scheduleAreaId;
                        else if (typeof object.scheduleAreaId === "object")
                            message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                    if (object.positionId != null)
                        if ($util.Long)
                            (message.positionId = $util.Long.fromValue(object.positionId)).unsigned = false;
                        else if (typeof object.positionId === "string")
                            message.positionId = parseInt(object.positionId, 10);
                        else if (typeof object.positionId === "number")
                            message.positionId = object.positionId;
                        else if (typeof object.positionId === "object")
                            message.positionId = new $util.LongBits(object.positionId.low >>> 0, object.positionId.high >>> 0).toNumber();
                    if (object.breakTimeStart) {
                        if (typeof object.breakTimeStart !== "object")
                            throw TypeError(".palexy.protobuf.ProposedShift.breakTimeStart: object expected");
                        message.breakTimeStart = {};
                        for (var keys = Object.keys(object.breakTimeStart), i = 0; i < keys.length; ++i)
                            message.breakTimeStart[keys[i]] = String(object.breakTimeStart[keys[i]]);
                    }
                    if (object.isFromScheduleTemplate != null)
                        message.isFromScheduleTemplate = Boolean(object.isFromScheduleTemplate);
                    if (object.positionLevel != null)
                        message.positionLevel = object.positionLevel | 0;
                    switch (object.employmentType) {
                    case "UNKNOWN_STAFF_EMPLOYMENT_TYPE":
                    case 0:
                        message.employmentType = 0;
                        break;
                    case "FULL_TIME":
                    case 1:
                        message.employmentType = 1;
                        break;
                    case "PART_TIME":
                    case 2:
                        message.employmentType = 2;
                        break;
                    case "EXTERNAL_STAFF":
                    case 3:
                        message.employmentType = 3;
                        break;
                    }
                    switch (object.gender) {
                    case "GENDER_UNSPECIFIED":
                    case 0:
                        message.gender = 0;
                        break;
                    case "MALE":
                    case 1:
                        message.gender = 1;
                        break;
                    case "FEMALE":
                    case 2:
                        message.gender = 2;
                        break;
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ProposedShift message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ProposedShift
                 * @static
                 * @param {palexy.protobuf.ProposedShift} message ProposedShift
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ProposedShift.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.objects || options.defaults)
                        object.breakTimeStart = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        object.dateId = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.scheduleAreaId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.positionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.positionId = options.longs === String ? "0" : 0;
                        object.isFromScheduleTemplate = false;
                        object.positionLevel = 0;
                        object.employmentType = options.enums === String ? "UNKNOWN_STAFF_EMPLOYMENT_TYPE" : 0;
                        object.gender = options.enums === String ? "GENDER_UNSPECIFIED" : 0;
                    }
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (typeof message.shiftTemplateId === "number")
                            object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                        else
                            object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        object.dateId = message.dateId;
                    if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                        if (typeof message.scheduleAreaId === "number")
                            object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                        else
                            object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                    var keys2;
                    if (message.breakTimeStart && (keys2 = Object.keys(message.breakTimeStart)).length) {
                        object.breakTimeStart = {};
                        for (var j = 0; j < keys2.length; ++j)
                            object.breakTimeStart[keys2[j]] = message.breakTimeStart[keys2[j]];
                    }
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (typeof message.positionId === "number")
                            object.positionId = options.longs === String ? String(message.positionId) : message.positionId;
                        else
                            object.positionId = options.longs === String ? $util.Long.prototype.toString.call(message.positionId) : options.longs === Number ? new $util.LongBits(message.positionId.low >>> 0, message.positionId.high >>> 0).toNumber() : message.positionId;
                    if (message.isFromScheduleTemplate != null && message.hasOwnProperty("isFromScheduleTemplate"))
                        object.isFromScheduleTemplate = message.isFromScheduleTemplate;
                    if (message.positionLevel != null && message.hasOwnProperty("positionLevel"))
                        object.positionLevel = message.positionLevel;
                    if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                        object.employmentType = options.enums === String ? $root.palexy.protobuf.StaffEmploymentType[message.employmentType] : message.employmentType;
                    if (message.gender != null && message.hasOwnProperty("gender"))
                        object.gender = options.enums === String ? $root.palexy.protobuf.Gender[message.gender] : message.gender;
                    return object;
                };
    
                /**
                 * Converts this ProposedShift to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ProposedShift
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ProposedShift.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ProposedShift;
            })();
    
            protobuf.ScheduleApprovalRequest = (function() {
    
                /**
                 * Properties of a ScheduleApprovalRequest.
                 * @memberof palexy.protobuf
                 * @interface IScheduleApprovalRequest
                 * @property {number|null} [id] ScheduleApprovalRequest id
                 * @property {number|null} [storeId] ScheduleApprovalRequest storeId
                 * @property {palexy.protobuf.ScheduleApprovalPeriod|null} [scheduleApprovalPeriod] ScheduleApprovalRequest scheduleApprovalPeriod
                 * @property {palexy.protobuf.ScheduleApprovalRequest.State|null} [state] ScheduleApprovalRequest state
                 * @property {number|null} [startDateId] ScheduleApprovalRequest startDateId
                 * @property {number|null} [endDateId] ScheduleApprovalRequest endDateId
                 * @property {number|null} [creatorId] ScheduleApprovalRequest creatorId
                 * @property {number|null} [createTimeMs] ScheduleApprovalRequest createTimeMs
                 * @property {number|null} [updateTimeMs] ScheduleApprovalRequest updateTimeMs
                 * @property {string|null} [approvalComment] ScheduleApprovalRequest approvalComment
                 * @property {number|null} [approverId] ScheduleApprovalRequest approverId
                 * @property {string|null} [approverName] ScheduleApprovalRequest approverName
                 */
    
                /**
                 * Constructs a new ScheduleApprovalRequest.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleApprovalRequest.
                 * @implements IScheduleApprovalRequest
                 * @constructor
                 * @param {palexy.protobuf.IScheduleApprovalRequest=} [properties] Properties to set
                 */
                function ScheduleApprovalRequest(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleApprovalRequest id.
                 * @member {number} id
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest scheduleApprovalPeriod.
                 * @member {palexy.protobuf.ScheduleApprovalPeriod} scheduleApprovalPeriod
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.scheduleApprovalPeriod = 0;
    
                /**
                 * ScheduleApprovalRequest state.
                 * @member {palexy.protobuf.ScheduleApprovalRequest.State} state
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.state = 0;
    
                /**
                 * ScheduleApprovalRequest startDateId.
                 * @member {number} startDateId
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.startDateId = 0;
    
                /**
                 * ScheduleApprovalRequest endDateId.
                 * @member {number} endDateId
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.endDateId = 0;
    
                /**
                 * ScheduleApprovalRequest creatorId.
                 * @member {number} creatorId
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest updateTimeMs.
                 * @member {number} updateTimeMs
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest approvalComment.
                 * @member {string} approvalComment
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.approvalComment = "";
    
                /**
                 * ScheduleApprovalRequest approverId.
                 * @member {number} approverId
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.approverId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleApprovalRequest approverName.
                 * @member {string} approverName
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 */
                ScheduleApprovalRequest.prototype.approverName = "";
    
                /**
                 * Creates a new ScheduleApprovalRequest instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {palexy.protobuf.IScheduleApprovalRequest=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleApprovalRequest} ScheduleApprovalRequest instance
                 */
                ScheduleApprovalRequest.create = function create(properties) {
                    return new ScheduleApprovalRequest(properties);
                };
    
                /**
                 * Encodes the specified ScheduleApprovalRequest message. Does not implicitly {@link palexy.protobuf.ScheduleApprovalRequest.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {palexy.protobuf.IScheduleApprovalRequest} message ScheduleApprovalRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleApprovalRequest.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.storeId);
                    if (message.scheduleApprovalPeriod != null && Object.hasOwnProperty.call(message, "scheduleApprovalPeriod"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.scheduleApprovalPeriod);
                    if (message.state != null && Object.hasOwnProperty.call(message, "state"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.state);
                    if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.startDateId);
                    if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.endDateId);
                    if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.creatorId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                    if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.updateTimeMs);
                    if (message.approvalComment != null && Object.hasOwnProperty.call(message, "approvalComment"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.approvalComment);
                    if (message.approverId != null && Object.hasOwnProperty.call(message, "approverId"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int64(message.approverId);
                    if (message.approverName != null && Object.hasOwnProperty.call(message, "approverName"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.approverName);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleApprovalRequest message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleApprovalRequest.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {palexy.protobuf.IScheduleApprovalRequest} message ScheduleApprovalRequest message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleApprovalRequest.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleApprovalRequest message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleApprovalRequest} ScheduleApprovalRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleApprovalRequest.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleApprovalRequest();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.storeId = reader.int64();
                            break;
                        case 3:
                            message.scheduleApprovalPeriod = reader.int32();
                            break;
                        case 4:
                            message.state = reader.int32();
                            break;
                        case 5:
                            message.startDateId = reader.int32();
                            break;
                        case 6:
                            message.endDateId = reader.int32();
                            break;
                        case 7:
                            message.creatorId = reader.int64();
                            break;
                        case 8:
                            message.createTimeMs = reader.int64();
                            break;
                        case 9:
                            message.updateTimeMs = reader.int64();
                            break;
                        case 10:
                            message.approvalComment = reader.string();
                            break;
                        case 11:
                            message.approverId = reader.int64();
                            break;
                        case 12:
                            message.approverName = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleApprovalRequest message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleApprovalRequest} ScheduleApprovalRequest
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleApprovalRequest.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleApprovalRequest message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleApprovalRequest.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.scheduleApprovalPeriod != null && message.hasOwnProperty("scheduleApprovalPeriod"))
                        switch (message.scheduleApprovalPeriod) {
                        default:
                            return "scheduleApprovalPeriod: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.state != null && message.hasOwnProperty("state"))
                        switch (message.state) {
                        default:
                            return "state: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        if (!$util.isInteger(message.startDateId))
                            return "startDateId: integer expected";
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        if (!$util.isInteger(message.endDateId))
                            return "endDateId: integer expected";
                    if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                        if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                            return "creatorId: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                            return "updateTimeMs: integer|Long expected";
                    if (message.approvalComment != null && message.hasOwnProperty("approvalComment"))
                        if (!$util.isString(message.approvalComment))
                            return "approvalComment: string expected";
                    if (message.approverId != null && message.hasOwnProperty("approverId"))
                        if (!$util.isInteger(message.approverId) && !(message.approverId && $util.isInteger(message.approverId.low) && $util.isInteger(message.approverId.high)))
                            return "approverId: integer|Long expected";
                    if (message.approverName != null && message.hasOwnProperty("approverName"))
                        if (!$util.isString(message.approverName))
                            return "approverName: string expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleApprovalRequest message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleApprovalRequest} ScheduleApprovalRequest
                 */
                ScheduleApprovalRequest.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleApprovalRequest)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleApprovalRequest();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    switch (object.scheduleApprovalPeriod) {
                    case "SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED":
                    case 0:
                        message.scheduleApprovalPeriod = 0;
                        break;
                    case "SCHEDULE_APPROVAL_PERIOD_WEEKLY":
                    case 1:
                        message.scheduleApprovalPeriod = 1;
                        break;
                    case "SCHEDULE_APPROVAL_PERIOD_MONTHLY":
                    case 2:
                        message.scheduleApprovalPeriod = 2;
                        break;
                    }
                    switch (object.state) {
                    case "STATE_UNSPECIFIED":
                    case 0:
                        message.state = 0;
                        break;
                    case "PENDING":
                    case 1:
                        message.state = 1;
                        break;
                    case "APPROVED":
                    case 2:
                        message.state = 2;
                        break;
                    }
                    if (object.startDateId != null)
                        message.startDateId = object.startDateId | 0;
                    if (object.endDateId != null)
                        message.endDateId = object.endDateId | 0;
                    if (object.creatorId != null)
                        if ($util.Long)
                            (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                        else if (typeof object.creatorId === "string")
                            message.creatorId = parseInt(object.creatorId, 10);
                        else if (typeof object.creatorId === "number")
                            message.creatorId = object.creatorId;
                        else if (typeof object.creatorId === "object")
                            message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.updateTimeMs != null)
                        if ($util.Long)
                            (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                        else if (typeof object.updateTimeMs === "string")
                            message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                        else if (typeof object.updateTimeMs === "number")
                            message.updateTimeMs = object.updateTimeMs;
                        else if (typeof object.updateTimeMs === "object")
                            message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                    if (object.approvalComment != null)
                        message.approvalComment = String(object.approvalComment);
                    if (object.approverId != null)
                        if ($util.Long)
                            (message.approverId = $util.Long.fromValue(object.approverId)).unsigned = false;
                        else if (typeof object.approverId === "string")
                            message.approverId = parseInt(object.approverId, 10);
                        else if (typeof object.approverId === "number")
                            message.approverId = object.approverId;
                        else if (typeof object.approverId === "object")
                            message.approverId = new $util.LongBits(object.approverId.low >>> 0, object.approverId.high >>> 0).toNumber();
                    if (object.approverName != null)
                        message.approverName = String(object.approverName);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleApprovalRequest message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @static
                 * @param {palexy.protobuf.ScheduleApprovalRequest} message ScheduleApprovalRequest
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleApprovalRequest.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        object.scheduleApprovalPeriod = options.enums === String ? "SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED" : 0;
                        object.state = options.enums === String ? "STATE_UNSPECIFIED" : 0;
                        object.startDateId = 0;
                        object.endDateId = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.creatorId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.updateTimeMs = options.longs === String ? "0" : 0;
                        object.approvalComment = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.approverId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.approverId = options.longs === String ? "0" : 0;
                        object.approverName = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.scheduleApprovalPeriod != null && message.hasOwnProperty("scheduleApprovalPeriod"))
                        object.scheduleApprovalPeriod = options.enums === String ? $root.palexy.protobuf.ScheduleApprovalPeriod[message.scheduleApprovalPeriod] : message.scheduleApprovalPeriod;
                    if (message.state != null && message.hasOwnProperty("state"))
                        object.state = options.enums === String ? $root.palexy.protobuf.ScheduleApprovalRequest.State[message.state] : message.state;
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        object.startDateId = message.startDateId;
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        object.endDateId = message.endDateId;
                    if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                        if (typeof message.creatorId === "number")
                            object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                        else
                            object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (typeof message.updateTimeMs === "number")
                            object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                        else
                            object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                    if (message.approvalComment != null && message.hasOwnProperty("approvalComment"))
                        object.approvalComment = message.approvalComment;
                    if (message.approverId != null && message.hasOwnProperty("approverId"))
                        if (typeof message.approverId === "number")
                            object.approverId = options.longs === String ? String(message.approverId) : message.approverId;
                        else
                            object.approverId = options.longs === String ? $util.Long.prototype.toString.call(message.approverId) : options.longs === Number ? new $util.LongBits(message.approverId.low >>> 0, message.approverId.high >>> 0).toNumber() : message.approverId;
                    if (message.approverName != null && message.hasOwnProperty("approverName"))
                        object.approverName = message.approverName;
                    return object;
                };
    
                /**
                 * Converts this ScheduleApprovalRequest to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleApprovalRequest
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleApprovalRequest.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * State enum.
                 * @name palexy.protobuf.ScheduleApprovalRequest.State
                 * @enum {number}
                 * @property {number} STATE_UNSPECIFIED=0 STATE_UNSPECIFIED value
                 * @property {number} PENDING=1 PENDING value
                 * @property {number} APPROVED=2 APPROVED value
                 */
                ScheduleApprovalRequest.State = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STATE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PENDING"] = 1;
                    values[valuesById[2] = "APPROVED"] = 2;
                    return values;
                })();
    
                return ScheduleApprovalRequest;
            })();
    
            /**
             * ScheduleApprovalPeriod enum.
             * @name palexy.protobuf.ScheduleApprovalPeriod
             * @enum {number}
             * @property {number} SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED=0 SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED value
             * @property {number} SCHEDULE_APPROVAL_PERIOD_WEEKLY=1 SCHEDULE_APPROVAL_PERIOD_WEEKLY value
             * @property {number} SCHEDULE_APPROVAL_PERIOD_MONTHLY=2 SCHEDULE_APPROVAL_PERIOD_MONTHLY value
             */
            protobuf.ScheduleApprovalPeriod = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "SCHEDULE_APPROVAL_PERIOD_UNSPECIFIED"] = 0;
                values[valuesById[1] = "SCHEDULE_APPROVAL_PERIOD_WEEKLY"] = 1;
                values[valuesById[2] = "SCHEDULE_APPROVAL_PERIOD_MONTHLY"] = 2;
                return values;
            })();
    
            protobuf.ScheduleStoreDailyBudget = (function() {
    
                /**
                 * Properties of a ScheduleStoreDailyBudget.
                 * @memberof palexy.protobuf
                 * @interface IScheduleStoreDailyBudget
                 * @property {number|null} [storeId] ScheduleStoreDailyBudget storeId
                 * @property {number|null} [dateId] ScheduleStoreDailyBudget dateId
                 * @property {number|null} [hoursBudget] ScheduleStoreDailyBudget hoursBudget
                 * @property {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo|null} [additionalInfo] ScheduleStoreDailyBudget additionalInfo
                 * @property {number|null} [createTimeMs] ScheduleStoreDailyBudget createTimeMs
                 * @property {number|null} [updateTimeMs] ScheduleStoreDailyBudget updateTimeMs
                 */
    
                /**
                 * Constructs a new ScheduleStoreDailyBudget.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleStoreDailyBudget.
                 * @implements IScheduleStoreDailyBudget
                 * @constructor
                 * @param {palexy.protobuf.IScheduleStoreDailyBudget=} [properties] Properties to set
                 */
                function ScheduleStoreDailyBudget(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleStoreDailyBudget storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleStoreDailyBudget dateId.
                 * @member {number} dateId
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.dateId = 0;
    
                /**
                 * ScheduleStoreDailyBudget hoursBudget.
                 * @member {number} hoursBudget
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.hoursBudget = 0;
    
                /**
                 * ScheduleStoreDailyBudget additionalInfo.
                 * @member {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo|null|undefined} additionalInfo
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.additionalInfo = null;
    
                /**
                 * ScheduleStoreDailyBudget createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleStoreDailyBudget updateTimeMs.
                 * @member {number} updateTimeMs
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 */
                ScheduleStoreDailyBudget.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new ScheduleStoreDailyBudget instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreDailyBudget=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleStoreDailyBudget} ScheduleStoreDailyBudget instance
                 */
                ScheduleStoreDailyBudget.create = function create(properties) {
                    return new ScheduleStoreDailyBudget(properties);
                };
    
                /**
                 * Encodes the specified ScheduleStoreDailyBudget message. Does not implicitly {@link palexy.protobuf.ScheduleStoreDailyBudget.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreDailyBudget} message ScheduleStoreDailyBudget message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStoreDailyBudget.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                    if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                    if (message.hoursBudget != null && Object.hasOwnProperty.call(message, "hoursBudget"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.hoursBudget);
                    if (message.additionalInfo != null && Object.hasOwnProperty.call(message, "additionalInfo"))
                        $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.encode(message.additionalInfo, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                    if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updateTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleStoreDailyBudget message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleStoreDailyBudget.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreDailyBudget} message ScheduleStoreDailyBudget message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStoreDailyBudget.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleStoreDailyBudget message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleStoreDailyBudget} ScheduleStoreDailyBudget
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStoreDailyBudget.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleStoreDailyBudget();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.storeId = reader.int64();
                            break;
                        case 2:
                            message.dateId = reader.int32();
                            break;
                        case 3:
                            message.hoursBudget = reader.double();
                            break;
                        case 4:
                            message.additionalInfo = $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.createTimeMs = reader.int64();
                            break;
                        case 6:
                            message.updateTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleStoreDailyBudget message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleStoreDailyBudget} ScheduleStoreDailyBudget
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStoreDailyBudget.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleStoreDailyBudget message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleStoreDailyBudget.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        if (!$util.isInteger(message.dateId))
                            return "dateId: integer expected";
                    if (message.hoursBudget != null && message.hasOwnProperty("hoursBudget"))
                        if (typeof message.hoursBudget !== "number")
                            return "hoursBudget: number expected";
                    if (message.additionalInfo != null && message.hasOwnProperty("additionalInfo")) {
                        var error = $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.verify(message.additionalInfo);
                        if (error)
                            return "additionalInfo." + error;
                    }
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                            return "updateTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleStoreDailyBudget message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleStoreDailyBudget} ScheduleStoreDailyBudget
                 */
                ScheduleStoreDailyBudget.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleStoreDailyBudget)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleStoreDailyBudget();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    if (object.dateId != null)
                        message.dateId = object.dateId | 0;
                    if (object.hoursBudget != null)
                        message.hoursBudget = Number(object.hoursBudget);
                    if (object.additionalInfo != null) {
                        if (typeof object.additionalInfo !== "object")
                            throw TypeError(".palexy.protobuf.ScheduleStoreDailyBudget.additionalInfo: object expected");
                        message.additionalInfo = $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.fromObject(object.additionalInfo);
                    }
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.updateTimeMs != null)
                        if ($util.Long)
                            (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                        else if (typeof object.updateTimeMs === "string")
                            message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                        else if (typeof object.updateTimeMs === "number")
                            message.updateTimeMs = object.updateTimeMs;
                        else if (typeof object.updateTimeMs === "object")
                            message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleStoreDailyBudget message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @static
                 * @param {palexy.protobuf.ScheduleStoreDailyBudget} message ScheduleStoreDailyBudget
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleStoreDailyBudget.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        object.dateId = 0;
                        object.hoursBudget = 0;
                        object.additionalInfo = null;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.updateTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        object.dateId = message.dateId;
                    if (message.hoursBudget != null && message.hasOwnProperty("hoursBudget"))
                        object.hoursBudget = options.json && !isFinite(message.hoursBudget) ? String(message.hoursBudget) : message.hoursBudget;
                    if (message.additionalInfo != null && message.hasOwnProperty("additionalInfo"))
                        object.additionalInfo = $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.toObject(message.additionalInfo, options);
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (typeof message.updateTimeMs === "number")
                            object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                        else
                            object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                    return object;
                };
    
                /**
                 * Converts this ScheduleStoreDailyBudget to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleStoreDailyBudget.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                ScheduleStoreDailyBudget.AdditionalInfo = (function() {
    
                    /**
                     * Properties of an AdditionalInfo.
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                     * @interface IAdditionalInfo
                     * @property {palexy.protobuf.ScheduleStoreDailyBudget.InferRangeType|null} [inferFromRange] AdditionalInfo inferFromRange
                     * @property {palexy.protobuf.ScheduleStoreDailyBudget.InferMetricType|null} [inferFromMetric] AdditionalInfo inferFromMetric
                     * @property {palexy.protobuf.ScheduleStoreDailyBudget.InferOrigin|null} [inferOrigin] AdditionalInfo inferOrigin
                     */
    
                    /**
                     * Constructs a new AdditionalInfo.
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget
                     * @classdesc Represents an AdditionalInfo.
                     * @implements IAdditionalInfo
                     * @constructor
                     * @param {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo=} [properties] Properties to set
                     */
                    function AdditionalInfo(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AdditionalInfo inferFromRange.
                     * @member {palexy.protobuf.ScheduleStoreDailyBudget.InferRangeType} inferFromRange
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @instance
                     */
                    AdditionalInfo.prototype.inferFromRange = 0;
    
                    /**
                     * AdditionalInfo inferFromMetric.
                     * @member {palexy.protobuf.ScheduleStoreDailyBudget.InferMetricType} inferFromMetric
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @instance
                     */
                    AdditionalInfo.prototype.inferFromMetric = 0;
    
                    /**
                     * AdditionalInfo inferOrigin.
                     * @member {palexy.protobuf.ScheduleStoreDailyBudget.InferOrigin} inferOrigin
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @instance
                     */
                    AdditionalInfo.prototype.inferOrigin = 0;
    
                    /**
                     * Creates a new AdditionalInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo=} [properties] Properties to set
                     * @returns {palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo} AdditionalInfo instance
                     */
                    AdditionalInfo.create = function create(properties) {
                        return new AdditionalInfo(properties);
                    };
    
                    /**
                     * Encodes the specified AdditionalInfo message. Does not implicitly {@link palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo} message AdditionalInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdditionalInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.inferFromRange != null && Object.hasOwnProperty.call(message, "inferFromRange"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.inferFromRange);
                        if (message.inferFromMetric != null && Object.hasOwnProperty.call(message, "inferFromMetric"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.inferFromMetric);
                        if (message.inferOrigin != null && Object.hasOwnProperty.call(message, "inferOrigin"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.inferOrigin);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AdditionalInfo message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleStoreDailyBudget.IAdditionalInfo} message AdditionalInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AdditionalInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AdditionalInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo} AdditionalInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdditionalInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.inferFromRange = reader.int32();
                                break;
                            case 2:
                                message.inferFromMetric = reader.int32();
                                break;
                            case 3:
                                message.inferOrigin = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AdditionalInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo} AdditionalInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AdditionalInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AdditionalInfo message.
                     * @function verify
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AdditionalInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.inferFromRange != null && message.hasOwnProperty("inferFromRange"))
                            switch (message.inferFromRange) {
                            default:
                                return "inferFromRange: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.inferFromMetric != null && message.hasOwnProperty("inferFromMetric"))
                            switch (message.inferFromMetric) {
                            default:
                                return "inferFromMetric: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.inferOrigin != null && message.hasOwnProperty("inferOrigin"))
                            switch (message.inferOrigin) {
                            default:
                                return "inferOrigin: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates an AdditionalInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo} AdditionalInfo
                     */
                    AdditionalInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo)
                            return object;
                        var message = new $root.palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo();
                        switch (object.inferFromRange) {
                        case "INFER_RANGE_TYPE_UNSPECIFIED":
                        case 0:
                            message.inferFromRange = 0;
                            break;
                        case "INFER_RANGE_TYPE_WEEK":
                        case 1:
                            message.inferFromRange = 1;
                            break;
                        case "INFER_RANGE_TYPE_MONTH":
                        case 2:
                            message.inferFromRange = 2;
                            break;
                        }
                        switch (object.inferFromMetric) {
                        case "INFER_METRIC_TYPE_UNSPECIFIED":
                        case 0:
                            message.inferFromMetric = 0;
                            break;
                        case "INFER_METRIC_TYPE_IPLH":
                        case 1:
                            message.inferFromMetric = 1;
                            break;
                        case "INFER_METRIC_TYPE_TPLH":
                        case 2:
                            message.inferFromMetric = 2;
                            break;
                        case "INFER_METRIC_TYPE_VPLH":
                        case 3:
                            message.inferFromMetric = 3;
                            break;
                        case "INFER_METRIC_TYPE_HOURS":
                        case 4:
                            message.inferFromMetric = 4;
                            break;
                        }
                        switch (object.inferOrigin) {
                        case "INFER_ORIGIN_UNSPECIFIED":
                        case 0:
                            message.inferOrigin = 0;
                            break;
                        case "INFER_BY_USER":
                        case 1:
                            message.inferOrigin = 1;
                            break;
                        case "INFER_BY_SYSTEM":
                        case 2:
                            message.inferOrigin = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AdditionalInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @static
                     * @param {palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo} message AdditionalInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AdditionalInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.inferFromRange = options.enums === String ? "INFER_RANGE_TYPE_UNSPECIFIED" : 0;
                            object.inferFromMetric = options.enums === String ? "INFER_METRIC_TYPE_UNSPECIFIED" : 0;
                            object.inferOrigin = options.enums === String ? "INFER_ORIGIN_UNSPECIFIED" : 0;
                        }
                        if (message.inferFromRange != null && message.hasOwnProperty("inferFromRange"))
                            object.inferFromRange = options.enums === String ? $root.palexy.protobuf.ScheduleStoreDailyBudget.InferRangeType[message.inferFromRange] : message.inferFromRange;
                        if (message.inferFromMetric != null && message.hasOwnProperty("inferFromMetric"))
                            object.inferFromMetric = options.enums === String ? $root.palexy.protobuf.ScheduleStoreDailyBudget.InferMetricType[message.inferFromMetric] : message.inferFromMetric;
                        if (message.inferOrigin != null && message.hasOwnProperty("inferOrigin"))
                            object.inferOrigin = options.enums === String ? $root.palexy.protobuf.ScheduleStoreDailyBudget.InferOrigin[message.inferOrigin] : message.inferOrigin;
                        return object;
                    };
    
                    /**
                     * Converts this AdditionalInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.ScheduleStoreDailyBudget.AdditionalInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AdditionalInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AdditionalInfo;
                })();
    
                /**
                 * InferRangeType enum.
                 * @name palexy.protobuf.ScheduleStoreDailyBudget.InferRangeType
                 * @enum {number}
                 * @property {number} INFER_RANGE_TYPE_UNSPECIFIED=0 INFER_RANGE_TYPE_UNSPECIFIED value
                 * @property {number} INFER_RANGE_TYPE_WEEK=1 INFER_RANGE_TYPE_WEEK value
                 * @property {number} INFER_RANGE_TYPE_MONTH=2 INFER_RANGE_TYPE_MONTH value
                 */
                ScheduleStoreDailyBudget.InferRangeType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "INFER_RANGE_TYPE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "INFER_RANGE_TYPE_WEEK"] = 1;
                    values[valuesById[2] = "INFER_RANGE_TYPE_MONTH"] = 2;
                    return values;
                })();
    
                /**
                 * InferMetricType enum.
                 * @name palexy.protobuf.ScheduleStoreDailyBudget.InferMetricType
                 * @enum {number}
                 * @property {number} INFER_METRIC_TYPE_UNSPECIFIED=0 INFER_METRIC_TYPE_UNSPECIFIED value
                 * @property {number} INFER_METRIC_TYPE_IPLH=1 INFER_METRIC_TYPE_IPLH value
                 * @property {number} INFER_METRIC_TYPE_TPLH=2 INFER_METRIC_TYPE_TPLH value
                 * @property {number} INFER_METRIC_TYPE_VPLH=3 INFER_METRIC_TYPE_VPLH value
                 * @property {number} INFER_METRIC_TYPE_HOURS=4 INFER_METRIC_TYPE_HOURS value
                 */
                ScheduleStoreDailyBudget.InferMetricType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "INFER_METRIC_TYPE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "INFER_METRIC_TYPE_IPLH"] = 1;
                    values[valuesById[2] = "INFER_METRIC_TYPE_TPLH"] = 2;
                    values[valuesById[3] = "INFER_METRIC_TYPE_VPLH"] = 3;
                    values[valuesById[4] = "INFER_METRIC_TYPE_HOURS"] = 4;
                    return values;
                })();
    
                /**
                 * InferOrigin enum.
                 * @name palexy.protobuf.ScheduleStoreDailyBudget.InferOrigin
                 * @enum {number}
                 * @property {number} INFER_ORIGIN_UNSPECIFIED=0 INFER_ORIGIN_UNSPECIFIED value
                 * @property {number} INFER_BY_USER=1 INFER_BY_USER value
                 * @property {number} INFER_BY_SYSTEM=2 INFER_BY_SYSTEM value
                 */
                ScheduleStoreDailyBudget.InferOrigin = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "INFER_ORIGIN_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "INFER_BY_USER"] = 1;
                    values[valuesById[2] = "INFER_BY_SYSTEM"] = 2;
                    return values;
                })();
    
                return ScheduleStoreDailyBudget;
            })();
    
            protobuf.ScheduleStoreMonthlyTarget = (function() {
    
                /**
                 * Properties of a ScheduleStoreMonthlyTarget.
                 * @memberof palexy.protobuf
                 * @interface IScheduleStoreMonthlyTarget
                 * @property {number|null} [storeId] ScheduleStoreMonthlyTarget storeId
                 * @property {number|null} [year] ScheduleStoreMonthlyTarget year
                 * @property {number|null} [month] ScheduleStoreMonthlyTarget month
                 * @property {number|null} [visitsPerLaborHour] ScheduleStoreMonthlyTarget visitsPerLaborHour
                 * @property {number|null} [itemsPerLaborHour] ScheduleStoreMonthlyTarget itemsPerLaborHour
                 * @property {number|null} [transactionsPerLaborHour] ScheduleStoreMonthlyTarget transactionsPerLaborHour
                 * @property {number|null} [createTimeMs] ScheduleStoreMonthlyTarget createTimeMs
                 * @property {number|null} [updateTimeMs] ScheduleStoreMonthlyTarget updateTimeMs
                 */
    
                /**
                 * Constructs a new ScheduleStoreMonthlyTarget.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleStoreMonthlyTarget.
                 * @implements IScheduleStoreMonthlyTarget
                 * @constructor
                 * @param {palexy.protobuf.IScheduleStoreMonthlyTarget=} [properties] Properties to set
                 */
                function ScheduleStoreMonthlyTarget(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleStoreMonthlyTarget storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleStoreMonthlyTarget year.
                 * @member {number} year
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.year = 0;
    
                /**
                 * ScheduleStoreMonthlyTarget month.
                 * @member {number} month
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.month = 0;
    
                /**
                 * ScheduleStoreMonthlyTarget visitsPerLaborHour.
                 * @member {number} visitsPerLaborHour
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.visitsPerLaborHour = 0;
    
                /**
                 * ScheduleStoreMonthlyTarget itemsPerLaborHour.
                 * @member {number} itemsPerLaborHour
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.itemsPerLaborHour = 0;
    
                /**
                 * ScheduleStoreMonthlyTarget transactionsPerLaborHour.
                 * @member {number} transactionsPerLaborHour
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.transactionsPerLaborHour = 0;
    
                /**
                 * ScheduleStoreMonthlyTarget createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleStoreMonthlyTarget updateTimeMs.
                 * @member {number} updateTimeMs
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 */
                ScheduleStoreMonthlyTarget.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new ScheduleStoreMonthlyTarget instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreMonthlyTarget=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleStoreMonthlyTarget} ScheduleStoreMonthlyTarget instance
                 */
                ScheduleStoreMonthlyTarget.create = function create(properties) {
                    return new ScheduleStoreMonthlyTarget(properties);
                };
    
                /**
                 * Encodes the specified ScheduleStoreMonthlyTarget message. Does not implicitly {@link palexy.protobuf.ScheduleStoreMonthlyTarget.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreMonthlyTarget} message ScheduleStoreMonthlyTarget message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStoreMonthlyTarget.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                    if (message.year != null && Object.hasOwnProperty.call(message, "year"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.year);
                    if (message.month != null && Object.hasOwnProperty.call(message, "month"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.month);
                    if (message.visitsPerLaborHour != null && Object.hasOwnProperty.call(message, "visitsPerLaborHour"))
                        writer.uint32(/* id 4, wireType 1 =*/33).double(message.visitsPerLaborHour);
                    if (message.itemsPerLaborHour != null && Object.hasOwnProperty.call(message, "itemsPerLaborHour"))
                        writer.uint32(/* id 5, wireType 1 =*/41).double(message.itemsPerLaborHour);
                    if (message.transactionsPerLaborHour != null && Object.hasOwnProperty.call(message, "transactionsPerLaborHour"))
                        writer.uint32(/* id 6, wireType 1 =*/49).double(message.transactionsPerLaborHour);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                    if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.updateTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleStoreMonthlyTarget message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleStoreMonthlyTarget.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {palexy.protobuf.IScheduleStoreMonthlyTarget} message ScheduleStoreMonthlyTarget message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleStoreMonthlyTarget.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleStoreMonthlyTarget message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleStoreMonthlyTarget} ScheduleStoreMonthlyTarget
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStoreMonthlyTarget.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleStoreMonthlyTarget();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.storeId = reader.int64();
                            break;
                        case 2:
                            message.year = reader.int32();
                            break;
                        case 3:
                            message.month = reader.int32();
                            break;
                        case 4:
                            message.visitsPerLaborHour = reader.double();
                            break;
                        case 5:
                            message.itemsPerLaborHour = reader.double();
                            break;
                        case 6:
                            message.transactionsPerLaborHour = reader.double();
                            break;
                        case 7:
                            message.createTimeMs = reader.int64();
                            break;
                        case 8:
                            message.updateTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleStoreMonthlyTarget message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleStoreMonthlyTarget} ScheduleStoreMonthlyTarget
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleStoreMonthlyTarget.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleStoreMonthlyTarget message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleStoreMonthlyTarget.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.year != null && message.hasOwnProperty("year"))
                        if (!$util.isInteger(message.year))
                            return "year: integer expected";
                    if (message.month != null && message.hasOwnProperty("month"))
                        if (!$util.isInteger(message.month))
                            return "month: integer expected";
                    if (message.visitsPerLaborHour != null && message.hasOwnProperty("visitsPerLaborHour"))
                        if (typeof message.visitsPerLaborHour !== "number")
                            return "visitsPerLaborHour: number expected";
                    if (message.itemsPerLaborHour != null && message.hasOwnProperty("itemsPerLaborHour"))
                        if (typeof message.itemsPerLaborHour !== "number")
                            return "itemsPerLaborHour: number expected";
                    if (message.transactionsPerLaborHour != null && message.hasOwnProperty("transactionsPerLaborHour"))
                        if (typeof message.transactionsPerLaborHour !== "number")
                            return "transactionsPerLaborHour: number expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                            return "updateTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleStoreMonthlyTarget message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleStoreMonthlyTarget} ScheduleStoreMonthlyTarget
                 */
                ScheduleStoreMonthlyTarget.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleStoreMonthlyTarget)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleStoreMonthlyTarget();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    if (object.year != null)
                        message.year = object.year | 0;
                    if (object.month != null)
                        message.month = object.month | 0;
                    if (object.visitsPerLaborHour != null)
                        message.visitsPerLaborHour = Number(object.visitsPerLaborHour);
                    if (object.itemsPerLaborHour != null)
                        message.itemsPerLaborHour = Number(object.itemsPerLaborHour);
                    if (object.transactionsPerLaborHour != null)
                        message.transactionsPerLaborHour = Number(object.transactionsPerLaborHour);
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.updateTimeMs != null)
                        if ($util.Long)
                            (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                        else if (typeof object.updateTimeMs === "string")
                            message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                        else if (typeof object.updateTimeMs === "number")
                            message.updateTimeMs = object.updateTimeMs;
                        else if (typeof object.updateTimeMs === "object")
                            message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleStoreMonthlyTarget message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @static
                 * @param {palexy.protobuf.ScheduleStoreMonthlyTarget} message ScheduleStoreMonthlyTarget
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleStoreMonthlyTarget.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        object.year = 0;
                        object.month = 0;
                        object.visitsPerLaborHour = 0;
                        object.itemsPerLaborHour = 0;
                        object.transactionsPerLaborHour = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.updateTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.year != null && message.hasOwnProperty("year"))
                        object.year = message.year;
                    if (message.month != null && message.hasOwnProperty("month"))
                        object.month = message.month;
                    if (message.visitsPerLaborHour != null && message.hasOwnProperty("visitsPerLaborHour"))
                        object.visitsPerLaborHour = options.json && !isFinite(message.visitsPerLaborHour) ? String(message.visitsPerLaborHour) : message.visitsPerLaborHour;
                    if (message.itemsPerLaborHour != null && message.hasOwnProperty("itemsPerLaborHour"))
                        object.itemsPerLaborHour = options.json && !isFinite(message.itemsPerLaborHour) ? String(message.itemsPerLaborHour) : message.itemsPerLaborHour;
                    if (message.transactionsPerLaborHour != null && message.hasOwnProperty("transactionsPerLaborHour"))
                        object.transactionsPerLaborHour = options.json && !isFinite(message.transactionsPerLaborHour) ? String(message.transactionsPerLaborHour) : message.transactionsPerLaborHour;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (typeof message.updateTimeMs === "number")
                            object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                        else
                            object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                    return object;
                };
    
                /**
                 * Converts this ScheduleStoreMonthlyTarget to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleStoreMonthlyTarget
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleStoreMonthlyTarget.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ScheduleStoreMonthlyTarget;
            })();
    
            protobuf.ScheduleTemplate = (function() {
    
                /**
                 * Properties of a ScheduleTemplate.
                 * @memberof palexy.protobuf
                 * @interface IScheduleTemplate
                 * @property {number|null} [id] ScheduleTemplate id
                 * @property {string|null} [title] ScheduleTemplate title
                 * @property {boolean|null} [isDefault] ScheduleTemplate isDefault
                 * @property {palexy.protobuf.ScheduleTemplate.Scope|null} [scope] ScheduleTemplate scope
                 * @property {number|null} [companyId] ScheduleTemplate companyId
                 * @property {number|null} [createTimeMs] ScheduleTemplate createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] ScheduleTemplate lastUpdateTimeMs
                 * @property {number|null} [storeId] ScheduleTemplate storeId
                 * @property {Array.<palexy.protobuf.IScheduleTemplateItem>|null} [items] ScheduleTemplate items
                 * @property {string|null} [createdBy] ScheduleTemplate createdBy
                 */
    
                /**
                 * Constructs a new ScheduleTemplate.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleTemplate.
                 * @implements IScheduleTemplate
                 * @constructor
                 * @param {palexy.protobuf.IScheduleTemplate=} [properties] Properties to set
                 */
                function ScheduleTemplate(properties) {
                    this.items = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleTemplate id.
                 * @member {number} id
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplate title.
                 * @member {string} title
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.title = "";
    
                /**
                 * ScheduleTemplate isDefault.
                 * @member {boolean} isDefault
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.isDefault = false;
    
                /**
                 * ScheduleTemplate scope.
                 * @member {palexy.protobuf.ScheduleTemplate.Scope} scope
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.scope = 0;
    
                /**
                 * ScheduleTemplate companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplate createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplate lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplate storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplate items.
                 * @member {Array.<palexy.protobuf.IScheduleTemplateItem>} items
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.items = $util.emptyArray;
    
                /**
                 * ScheduleTemplate createdBy.
                 * @member {string} createdBy
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 */
                ScheduleTemplate.prototype.createdBy = "";
    
                /**
                 * Creates a new ScheduleTemplate instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplate=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleTemplate} ScheduleTemplate instance
                 */
                ScheduleTemplate.create = function create(properties) {
                    return new ScheduleTemplate(properties);
                };
    
                /**
                 * Encodes the specified ScheduleTemplate message. Does not implicitly {@link palexy.protobuf.ScheduleTemplate.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplate} message ScheduleTemplate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleTemplate.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.title);
                    if (message.isDefault != null && Object.hasOwnProperty.call(message, "isDefault"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isDefault);
                    if (message.scope != null && Object.hasOwnProperty.call(message, "scope"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.scope);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.companyId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.storeId);
                    if (message.items != null && message.items.length)
                        for (var i = 0; i < message.items.length; ++i)
                            $root.palexy.protobuf.ScheduleTemplateItem.encode(message.items[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                    if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.createdBy);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleTemplate message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleTemplate.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplate} message ScheduleTemplate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleTemplate.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleTemplate message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleTemplate} ScheduleTemplate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleTemplate.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleTemplate();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.title = reader.string();
                            break;
                        case 3:
                            message.isDefault = reader.bool();
                            break;
                        case 4:
                            message.scope = reader.int32();
                            break;
                        case 6:
                            message.companyId = reader.int64();
                            break;
                        case 7:
                            message.createTimeMs = reader.int64();
                            break;
                        case 8:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        case 9:
                            message.storeId = reader.int64();
                            break;
                        case 10:
                            if (!(message.items && message.items.length))
                                message.items = [];
                            message.items.push($root.palexy.protobuf.ScheduleTemplateItem.decode(reader, reader.uint32()));
                            break;
                        case 11:
                            message.createdBy = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleTemplate message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleTemplate} ScheduleTemplate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleTemplate.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleTemplate message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleTemplate.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.title != null && message.hasOwnProperty("title"))
                        if (!$util.isString(message.title))
                            return "title: string expected";
                    if (message.isDefault != null && message.hasOwnProperty("isDefault"))
                        if (typeof message.isDefault !== "boolean")
                            return "isDefault: boolean expected";
                    if (message.scope != null && message.hasOwnProperty("scope"))
                        switch (message.scope) {
                        default:
                            return "scope: enum value expected";
                        case 0:
                        case 1:
                            break;
                        }
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.items != null && message.hasOwnProperty("items")) {
                        if (!Array.isArray(message.items))
                            return "items: array expected";
                        for (var i = 0; i < message.items.length; ++i) {
                            var error = $root.palexy.protobuf.ScheduleTemplateItem.verify(message.items[i]);
                            if (error)
                                return "items." + error;
                        }
                    }
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        if (!$util.isString(message.createdBy))
                            return "createdBy: string expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleTemplate message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleTemplate} ScheduleTemplate
                 */
                ScheduleTemplate.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleTemplate)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleTemplate();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.title != null)
                        message.title = String(object.title);
                    if (object.isDefault != null)
                        message.isDefault = Boolean(object.isDefault);
                    switch (object.scope) {
                    case "SCOPE_UNSPECIFIED":
                    case 0:
                        message.scope = 0;
                        break;
                    case "STORE":
                    case 1:
                        message.scope = 1;
                        break;
                    }
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    if (object.items) {
                        if (!Array.isArray(object.items))
                            throw TypeError(".palexy.protobuf.ScheduleTemplate.items: array expected");
                        message.items = [];
                        for (var i = 0; i < object.items.length; ++i) {
                            if (typeof object.items[i] !== "object")
                                throw TypeError(".palexy.protobuf.ScheduleTemplate.items: object expected");
                            message.items[i] = $root.palexy.protobuf.ScheduleTemplateItem.fromObject(object.items[i]);
                        }
                    }
                    if (object.createdBy != null)
                        message.createdBy = String(object.createdBy);
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleTemplate message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @static
                 * @param {palexy.protobuf.ScheduleTemplate} message ScheduleTemplate
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleTemplate.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.items = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.title = "";
                        object.isDefault = false;
                        object.scope = options.enums === String ? "SCOPE_UNSPECIFIED" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        object.createdBy = "";
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.title != null && message.hasOwnProperty("title"))
                        object.title = message.title;
                    if (message.isDefault != null && message.hasOwnProperty("isDefault"))
                        object.isDefault = message.isDefault;
                    if (message.scope != null && message.hasOwnProperty("scope"))
                        object.scope = options.enums === String ? $root.palexy.protobuf.ScheduleTemplate.Scope[message.scope] : message.scope;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.items && message.items.length) {
                        object.items = [];
                        for (var j = 0; j < message.items.length; ++j)
                            object.items[j] = $root.palexy.protobuf.ScheduleTemplateItem.toObject(message.items[j], options);
                    }
                    if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                        object.createdBy = message.createdBy;
                    return object;
                };
    
                /**
                 * Converts this ScheduleTemplate to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleTemplate
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleTemplate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * Scope enum.
                 * @name palexy.protobuf.ScheduleTemplate.Scope
                 * @enum {number}
                 * @property {number} SCOPE_UNSPECIFIED=0 SCOPE_UNSPECIFIED value
                 * @property {number} STORE=1 STORE value
                 */
                ScheduleTemplate.Scope = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "SCOPE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "STORE"] = 1;
                    return values;
                })();
    
                return ScheduleTemplate;
            })();
    
            protobuf.ScheduleTemplateItem = (function() {
    
                /**
                 * Properties of a ScheduleTemplateItem.
                 * @memberof palexy.protobuf
                 * @interface IScheduleTemplateItem
                 * @property {number|null} [id] ScheduleTemplateItem id
                 * @property {number|null} [scheduleTemplateId] ScheduleTemplateItem scheduleTemplateId
                 * @property {number|null} [shiftTemplateId] ScheduleTemplateItem shiftTemplateId
                 * @property {number|null} [positionId] ScheduleTemplateItem positionId
                 * @property {number|null} [level] ScheduleTemplateItem level
                 * @property {number|null} [dayOfWeek] ScheduleTemplateItem dayOfWeek
                 * @property {number|null} [createTimeMs] ScheduleTemplateItem createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] ScheduleTemplateItem lastUpdateTimeMs
                 * @property {palexy.protobuf.StaffEmploymentType|null} [employmentType] ScheduleTemplateItem employmentType
                 * @property {palexy.protobuf.Gender|null} [gender] ScheduleTemplateItem gender
                 * @property {number|null} [scheduleAreaId] ScheduleTemplateItem scheduleAreaId
                 */
    
                /**
                 * Constructs a new ScheduleTemplateItem.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a ScheduleTemplateItem.
                 * @implements IScheduleTemplateItem
                 * @constructor
                 * @param {palexy.protobuf.IScheduleTemplateItem=} [properties] Properties to set
                 */
                function ScheduleTemplateItem(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ScheduleTemplateItem id.
                 * @member {number} id
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem scheduleTemplateId.
                 * @member {number} scheduleTemplateId
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.scheduleTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem shiftTemplateId.
                 * @member {number} shiftTemplateId
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem positionId.
                 * @member {number} positionId
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.positionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem level.
                 * @member {number} level
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.level = 0;
    
                /**
                 * ScheduleTemplateItem dayOfWeek.
                 * @member {number} dayOfWeek
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.dayOfWeek = 0;
    
                /**
                 * ScheduleTemplateItem createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * ScheduleTemplateItem employmentType.
                 * @member {palexy.protobuf.StaffEmploymentType} employmentType
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.employmentType = 0;
    
                /**
                 * ScheduleTemplateItem gender.
                 * @member {palexy.protobuf.Gender} gender
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.gender = 0;
    
                /**
                 * ScheduleTemplateItem scheduleAreaId.
                 * @member {number} scheduleAreaId
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 */
                ScheduleTemplateItem.prototype.scheduleAreaId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new ScheduleTemplateItem instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplateItem=} [properties] Properties to set
                 * @returns {palexy.protobuf.ScheduleTemplateItem} ScheduleTemplateItem instance
                 */
                ScheduleTemplateItem.create = function create(properties) {
                    return new ScheduleTemplateItem(properties);
                };
    
                /**
                 * Encodes the specified ScheduleTemplateItem message. Does not implicitly {@link palexy.protobuf.ScheduleTemplateItem.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplateItem} message ScheduleTemplateItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleTemplateItem.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.scheduleTemplateId != null && Object.hasOwnProperty.call(message, "scheduleTemplateId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.scheduleTemplateId);
                    if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.shiftTemplateId);
                    if (message.positionId != null && Object.hasOwnProperty.call(message, "positionId"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.positionId);
                    if (message.level != null && Object.hasOwnProperty.call(message, "level"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.level);
                    if (message.dayOfWeek != null && Object.hasOwnProperty.call(message, "dayOfWeek"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.dayOfWeek);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                    if (message.employmentType != null && Object.hasOwnProperty.call(message, "employmentType"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.employmentType);
                    if (message.gender != null && Object.hasOwnProperty.call(message, "gender"))
                        writer.uint32(/* id 10, wireType 0 =*/80).int32(message.gender);
                    if (message.scheduleAreaId != null && Object.hasOwnProperty.call(message, "scheduleAreaId"))
                        writer.uint32(/* id 11, wireType 0 =*/88).int64(message.scheduleAreaId);
                    return writer;
                };
    
                /**
                 * Encodes the specified ScheduleTemplateItem message, length delimited. Does not implicitly {@link palexy.protobuf.ScheduleTemplateItem.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {palexy.protobuf.IScheduleTemplateItem} message ScheduleTemplateItem message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ScheduleTemplateItem.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ScheduleTemplateItem message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.ScheduleTemplateItem} ScheduleTemplateItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleTemplateItem.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.ScheduleTemplateItem();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.scheduleTemplateId = reader.int64();
                            break;
                        case 3:
                            message.shiftTemplateId = reader.int64();
                            break;
                        case 4:
                            message.positionId = reader.int64();
                            break;
                        case 5:
                            message.level = reader.int32();
                            break;
                        case 6:
                            message.dayOfWeek = reader.int32();
                            break;
                        case 7:
                            message.createTimeMs = reader.int64();
                            break;
                        case 8:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        case 9:
                            message.employmentType = reader.int32();
                            break;
                        case 10:
                            message.gender = reader.int32();
                            break;
                        case 11:
                            message.scheduleAreaId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ScheduleTemplateItem message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.ScheduleTemplateItem} ScheduleTemplateItem
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ScheduleTemplateItem.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ScheduleTemplateItem message.
                 * @function verify
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ScheduleTemplateItem.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.scheduleTemplateId != null && message.hasOwnProperty("scheduleTemplateId"))
                        if (!$util.isInteger(message.scheduleTemplateId) && !(message.scheduleTemplateId && $util.isInteger(message.scheduleTemplateId.low) && $util.isInteger(message.scheduleTemplateId.high)))
                            return "scheduleTemplateId: integer|Long expected";
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                            return "shiftTemplateId: integer|Long expected";
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (!$util.isInteger(message.positionId) && !(message.positionId && $util.isInteger(message.positionId.low) && $util.isInteger(message.positionId.high)))
                            return "positionId: integer|Long expected";
                    if (message.level != null && message.hasOwnProperty("level"))
                        if (!$util.isInteger(message.level))
                            return "level: integer expected";
                    if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                        if (!$util.isInteger(message.dayOfWeek))
                            return "dayOfWeek: integer expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                        switch (message.employmentType) {
                        default:
                            return "employmentType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.gender != null && message.hasOwnProperty("gender"))
                        switch (message.gender) {
                        default:
                            return "gender: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                        if (!$util.isInteger(message.scheduleAreaId) && !(message.scheduleAreaId && $util.isInteger(message.scheduleAreaId.low) && $util.isInteger(message.scheduleAreaId.high)))
                            return "scheduleAreaId: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a ScheduleTemplateItem message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.ScheduleTemplateItem} ScheduleTemplateItem
                 */
                ScheduleTemplateItem.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.ScheduleTemplateItem)
                        return object;
                    var message = new $root.palexy.protobuf.ScheduleTemplateItem();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.scheduleTemplateId != null)
                        if ($util.Long)
                            (message.scheduleTemplateId = $util.Long.fromValue(object.scheduleTemplateId)).unsigned = false;
                        else if (typeof object.scheduleTemplateId === "string")
                            message.scheduleTemplateId = parseInt(object.scheduleTemplateId, 10);
                        else if (typeof object.scheduleTemplateId === "number")
                            message.scheduleTemplateId = object.scheduleTemplateId;
                        else if (typeof object.scheduleTemplateId === "object")
                            message.scheduleTemplateId = new $util.LongBits(object.scheduleTemplateId.low >>> 0, object.scheduleTemplateId.high >>> 0).toNumber();
                    if (object.shiftTemplateId != null)
                        if ($util.Long)
                            (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                        else if (typeof object.shiftTemplateId === "string")
                            message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                        else if (typeof object.shiftTemplateId === "number")
                            message.shiftTemplateId = object.shiftTemplateId;
                        else if (typeof object.shiftTemplateId === "object")
                            message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                    if (object.positionId != null)
                        if ($util.Long)
                            (message.positionId = $util.Long.fromValue(object.positionId)).unsigned = false;
                        else if (typeof object.positionId === "string")
                            message.positionId = parseInt(object.positionId, 10);
                        else if (typeof object.positionId === "number")
                            message.positionId = object.positionId;
                        else if (typeof object.positionId === "object")
                            message.positionId = new $util.LongBits(object.positionId.low >>> 0, object.positionId.high >>> 0).toNumber();
                    if (object.level != null)
                        message.level = object.level | 0;
                    if (object.dayOfWeek != null)
                        message.dayOfWeek = object.dayOfWeek | 0;
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    switch (object.employmentType) {
                    case "UNKNOWN_STAFF_EMPLOYMENT_TYPE":
                    case 0:
                        message.employmentType = 0;
                        break;
                    case "FULL_TIME":
                    case 1:
                        message.employmentType = 1;
                        break;
                    case "PART_TIME":
                    case 2:
                        message.employmentType = 2;
                        break;
                    case "EXTERNAL_STAFF":
                    case 3:
                        message.employmentType = 3;
                        break;
                    }
                    switch (object.gender) {
                    case "GENDER_UNSPECIFIED":
                    case 0:
                        message.gender = 0;
                        break;
                    case "MALE":
                    case 1:
                        message.gender = 1;
                        break;
                    case "FEMALE":
                    case 2:
                        message.gender = 2;
                        break;
                    }
                    if (object.scheduleAreaId != null)
                        if ($util.Long)
                            (message.scheduleAreaId = $util.Long.fromValue(object.scheduleAreaId)).unsigned = false;
                        else if (typeof object.scheduleAreaId === "string")
                            message.scheduleAreaId = parseInt(object.scheduleAreaId, 10);
                        else if (typeof object.scheduleAreaId === "number")
                            message.scheduleAreaId = object.scheduleAreaId;
                        else if (typeof object.scheduleAreaId === "object")
                            message.scheduleAreaId = new $util.LongBits(object.scheduleAreaId.low >>> 0, object.scheduleAreaId.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a ScheduleTemplateItem message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @static
                 * @param {palexy.protobuf.ScheduleTemplateItem} message ScheduleTemplateItem
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ScheduleTemplateItem.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.scheduleTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.scheduleTemplateId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.positionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.positionId = options.longs === String ? "0" : 0;
                        object.level = 0;
                        object.dayOfWeek = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        object.employmentType = options.enums === String ? "UNKNOWN_STAFF_EMPLOYMENT_TYPE" : 0;
                        object.gender = options.enums === String ? "GENDER_UNSPECIFIED" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.scheduleAreaId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.scheduleAreaId = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.scheduleTemplateId != null && message.hasOwnProperty("scheduleTemplateId"))
                        if (typeof message.scheduleTemplateId === "number")
                            object.scheduleTemplateId = options.longs === String ? String(message.scheduleTemplateId) : message.scheduleTemplateId;
                        else
                            object.scheduleTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleTemplateId) : options.longs === Number ? new $util.LongBits(message.scheduleTemplateId.low >>> 0, message.scheduleTemplateId.high >>> 0).toNumber() : message.scheduleTemplateId;
                    if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                        if (typeof message.shiftTemplateId === "number")
                            object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                        else
                            object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                    if (message.positionId != null && message.hasOwnProperty("positionId"))
                        if (typeof message.positionId === "number")
                            object.positionId = options.longs === String ? String(message.positionId) : message.positionId;
                        else
                            object.positionId = options.longs === String ? $util.Long.prototype.toString.call(message.positionId) : options.longs === Number ? new $util.LongBits(message.positionId.low >>> 0, message.positionId.high >>> 0).toNumber() : message.positionId;
                    if (message.level != null && message.hasOwnProperty("level"))
                        object.level = message.level;
                    if (message.dayOfWeek != null && message.hasOwnProperty("dayOfWeek"))
                        object.dayOfWeek = message.dayOfWeek;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    if (message.employmentType != null && message.hasOwnProperty("employmentType"))
                        object.employmentType = options.enums === String ? $root.palexy.protobuf.StaffEmploymentType[message.employmentType] : message.employmentType;
                    if (message.gender != null && message.hasOwnProperty("gender"))
                        object.gender = options.enums === String ? $root.palexy.protobuf.Gender[message.gender] : message.gender;
                    if (message.scheduleAreaId != null && message.hasOwnProperty("scheduleAreaId"))
                        if (typeof message.scheduleAreaId === "number")
                            object.scheduleAreaId = options.longs === String ? String(message.scheduleAreaId) : message.scheduleAreaId;
                        else
                            object.scheduleAreaId = options.longs === String ? $util.Long.prototype.toString.call(message.scheduleAreaId) : options.longs === Number ? new $util.LongBits(message.scheduleAreaId.low >>> 0, message.scheduleAreaId.high >>> 0).toNumber() : message.scheduleAreaId;
                    return object;
                };
    
                /**
                 * Converts this ScheduleTemplateItem to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.ScheduleTemplateItem
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ScheduleTemplateItem.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ScheduleTemplateItem;
            })();
    
            protobuf.StaffWorkingSetting = (function() {
    
                /**
                 * Properties of a StaffWorkingSetting.
                 * @memberof palexy.protobuf
                 * @interface IStaffWorkingSetting
                 * @property {number|null} [id] StaffWorkingSetting id
                 * @property {number|null} [staffId] StaffWorkingSetting staffId
                 * @property {number|null} [maxHoursPerWeek] StaffWorkingSetting maxHoursPerWeek
                 * @property {number|null} [recommendedMaxHoursPerDay] StaffWorkingSetting recommendedMaxHoursPerDay
                 * @property {number|null} [createTimeMs] StaffWorkingSetting createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] StaffWorkingSetting lastUpdateTimeMs
                 */
    
                /**
                 * Constructs a new StaffWorkingSetting.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffWorkingSetting.
                 * @implements IStaffWorkingSetting
                 * @constructor
                 * @param {palexy.protobuf.IStaffWorkingSetting=} [properties] Properties to set
                 */
                function StaffWorkingSetting(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffWorkingSetting id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffWorkingSetting staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffWorkingSetting maxHoursPerWeek.
                 * @member {number} maxHoursPerWeek
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.maxHoursPerWeek = 0;
    
                /**
                 * StaffWorkingSetting recommendedMaxHoursPerDay.
                 * @member {number} recommendedMaxHoursPerDay
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.recommendedMaxHoursPerDay = 0;
    
                /**
                 * StaffWorkingSetting createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffWorkingSetting lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 */
                StaffWorkingSetting.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new StaffWorkingSetting instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {palexy.protobuf.IStaffWorkingSetting=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffWorkingSetting} StaffWorkingSetting instance
                 */
                StaffWorkingSetting.create = function create(properties) {
                    return new StaffWorkingSetting(properties);
                };
    
                /**
                 * Encodes the specified StaffWorkingSetting message. Does not implicitly {@link palexy.protobuf.StaffWorkingSetting.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {palexy.protobuf.IStaffWorkingSetting} message StaffWorkingSetting message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffWorkingSetting.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                    if (message.maxHoursPerWeek != null && Object.hasOwnProperty.call(message, "maxHoursPerWeek"))
                        writer.uint32(/* id 3, wireType 5 =*/29).float(message.maxHoursPerWeek);
                    if (message.recommendedMaxHoursPerDay != null && Object.hasOwnProperty.call(message, "recommendedMaxHoursPerDay"))
                        writer.uint32(/* id 4, wireType 5 =*/37).float(message.recommendedMaxHoursPerDay);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffWorkingSetting message, length delimited. Does not implicitly {@link palexy.protobuf.StaffWorkingSetting.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {palexy.protobuf.IStaffWorkingSetting} message StaffWorkingSetting message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffWorkingSetting.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffWorkingSetting message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffWorkingSetting} StaffWorkingSetting
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffWorkingSetting.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffWorkingSetting();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.staffId = reader.int64();
                            break;
                        case 3:
                            message.maxHoursPerWeek = reader.float();
                            break;
                        case 4:
                            message.recommendedMaxHoursPerDay = reader.float();
                            break;
                        case 5:
                            message.createTimeMs = reader.int64();
                            break;
                        case 6:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffWorkingSetting message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffWorkingSetting} StaffWorkingSetting
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffWorkingSetting.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffWorkingSetting message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffWorkingSetting.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.maxHoursPerWeek != null && message.hasOwnProperty("maxHoursPerWeek"))
                        if (typeof message.maxHoursPerWeek !== "number")
                            return "maxHoursPerWeek: number expected";
                    if (message.recommendedMaxHoursPerDay != null && message.hasOwnProperty("recommendedMaxHoursPerDay"))
                        if (typeof message.recommendedMaxHoursPerDay !== "number")
                            return "recommendedMaxHoursPerDay: number expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a StaffWorkingSetting message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffWorkingSetting} StaffWorkingSetting
                 */
                StaffWorkingSetting.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffWorkingSetting)
                        return object;
                    var message = new $root.palexy.protobuf.StaffWorkingSetting();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.maxHoursPerWeek != null)
                        message.maxHoursPerWeek = Number(object.maxHoursPerWeek);
                    if (object.recommendedMaxHoursPerDay != null)
                        message.recommendedMaxHoursPerDay = Number(object.recommendedMaxHoursPerDay);
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffWorkingSetting message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @static
                 * @param {palexy.protobuf.StaffWorkingSetting} message StaffWorkingSetting
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffWorkingSetting.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        object.maxHoursPerWeek = 0;
                        object.recommendedMaxHoursPerDay = 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.maxHoursPerWeek != null && message.hasOwnProperty("maxHoursPerWeek"))
                        object.maxHoursPerWeek = options.json && !isFinite(message.maxHoursPerWeek) ? String(message.maxHoursPerWeek) : message.maxHoursPerWeek;
                    if (message.recommendedMaxHoursPerDay != null && message.hasOwnProperty("recommendedMaxHoursPerDay"))
                        object.recommendedMaxHoursPerDay = options.json && !isFinite(message.recommendedMaxHoursPerDay) ? String(message.recommendedMaxHoursPerDay) : message.recommendedMaxHoursPerDay;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    return object;
                };
    
                /**
                 * Converts this StaffWorkingSetting to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffWorkingSetting
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffWorkingSetting.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffWorkingSetting;
            })();
    
            protobuf.StaffAvailability = (function() {
    
                /**
                 * Properties of a StaffAvailability.
                 * @memberof palexy.protobuf
                 * @interface IStaffAvailability
                 * @property {number|null} [id] StaffAvailability id
                 * @property {boolean|null} [available] StaffAvailability available
                 * @property {string|null} [startDateId] StaffAvailability startDateId
                 * @property {string|null} [endDateId] StaffAvailability endDateId
                 * @property {boolean|null} [isAllDay] StaffAvailability isAllDay
                 * @property {string|null} [startTime] StaffAvailability startTime
                 * @property {string|null} [endTime] StaffAvailability endTime
                 * @property {palexy.protobuf.AvailabilityRepeatType|null} [repeatType] StaffAvailability repeatType
                 * @property {Array.<palexy.streaming.v1.DayOfWeek>|null} [repeatDayOfWeek] StaffAvailability repeatDayOfWeek
                 * @property {string|null} [note] StaffAvailability note
                 * @property {Array.<string>|null} [appliedDateIds] StaffAvailability appliedDateIds
                 * @property {number|null} [staffId] StaffAvailability staffId
                 * @property {number|null} [createTimeMs] StaffAvailability createTimeMs
                 * @property {number|null} [updateTimeMs] StaffAvailability updateTimeMs
                 * @property {boolean|null} [isCrossDay] StaffAvailability isCrossDay
                 * @property {number|null} [groupId] StaffAvailability groupId
                 */
    
                /**
                 * Constructs a new StaffAvailability.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffAvailability.
                 * @implements IStaffAvailability
                 * @constructor
                 * @param {palexy.protobuf.IStaffAvailability=} [properties] Properties to set
                 */
                function StaffAvailability(properties) {
                    this.repeatDayOfWeek = [];
                    this.appliedDateIds = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffAvailability id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailability available.
                 * @member {boolean} available
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.available = false;
    
                /**
                 * StaffAvailability startDateId.
                 * @member {string} startDateId
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.startDateId = "";
    
                /**
                 * StaffAvailability endDateId.
                 * @member {string} endDateId
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.endDateId = "";
    
                /**
                 * StaffAvailability isAllDay.
                 * @member {boolean} isAllDay
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.isAllDay = false;
    
                /**
                 * StaffAvailability startTime.
                 * @member {string} startTime
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.startTime = "";
    
                /**
                 * StaffAvailability endTime.
                 * @member {string} endTime
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.endTime = "";
    
                /**
                 * StaffAvailability repeatType.
                 * @member {palexy.protobuf.AvailabilityRepeatType} repeatType
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.repeatType = 0;
    
                /**
                 * StaffAvailability repeatDayOfWeek.
                 * @member {Array.<palexy.streaming.v1.DayOfWeek>} repeatDayOfWeek
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.repeatDayOfWeek = $util.emptyArray;
    
                /**
                 * StaffAvailability note.
                 * @member {string} note
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.note = "";
    
                /**
                 * StaffAvailability appliedDateIds.
                 * @member {Array.<string>} appliedDateIds
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.appliedDateIds = $util.emptyArray;
    
                /**
                 * StaffAvailability staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailability createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailability updateTimeMs.
                 * @member {number} updateTimeMs
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailability isCrossDay.
                 * @member {boolean} isCrossDay
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.isCrossDay = false;
    
                /**
                 * StaffAvailability groupId.
                 * @member {number} groupId
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 */
                StaffAvailability.prototype.groupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new StaffAvailability instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {palexy.protobuf.IStaffAvailability=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffAvailability} StaffAvailability instance
                 */
                StaffAvailability.create = function create(properties) {
                    return new StaffAvailability(properties);
                };
    
                /**
                 * Encodes the specified StaffAvailability message. Does not implicitly {@link palexy.protobuf.StaffAvailability.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {palexy.protobuf.IStaffAvailability} message StaffAvailability message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailability.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.available != null && Object.hasOwnProperty.call(message, "available"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.available);
                    if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateId);
                    if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateId);
                    if (message.isAllDay != null && Object.hasOwnProperty.call(message, "isAllDay"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isAllDay);
                    if (message.startTime != null && Object.hasOwnProperty.call(message, "startTime"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.startTime);
                    if (message.endTime != null && Object.hasOwnProperty.call(message, "endTime"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.endTime);
                    if (message.repeatType != null && Object.hasOwnProperty.call(message, "repeatType"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int32(message.repeatType);
                    if (message.repeatDayOfWeek != null && message.repeatDayOfWeek.length) {
                        writer.uint32(/* id 9, wireType 2 =*/74).fork();
                        for (var i = 0; i < message.repeatDayOfWeek.length; ++i)
                            writer.int32(message.repeatDayOfWeek[i]);
                        writer.ldelim();
                    }
                    if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.note);
                    if (message.appliedDateIds != null && message.appliedDateIds.length)
                        for (var i = 0; i < message.appliedDateIds.length; ++i)
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.appliedDateIds[i]);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 12, wireType 0 =*/96).int64(message.staffId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int64(message.createTimeMs);
                    if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                        writer.uint32(/* id 14, wireType 0 =*/112).int64(message.updateTimeMs);
                    if (message.isCrossDay != null && Object.hasOwnProperty.call(message, "isCrossDay"))
                        writer.uint32(/* id 15, wireType 0 =*/120).bool(message.isCrossDay);
                    if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                        writer.uint32(/* id 16, wireType 0 =*/128).int64(message.groupId);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffAvailability message, length delimited. Does not implicitly {@link palexy.protobuf.StaffAvailability.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {palexy.protobuf.IStaffAvailability} message StaffAvailability message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailability.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffAvailability message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffAvailability} StaffAvailability
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailability.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffAvailability();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.available = reader.bool();
                            break;
                        case 3:
                            message.startDateId = reader.string();
                            break;
                        case 4:
                            message.endDateId = reader.string();
                            break;
                        case 5:
                            message.isAllDay = reader.bool();
                            break;
                        case 6:
                            message.startTime = reader.string();
                            break;
                        case 7:
                            message.endTime = reader.string();
                            break;
                        case 8:
                            message.repeatType = reader.int32();
                            break;
                        case 9:
                            if (!(message.repeatDayOfWeek && message.repeatDayOfWeek.length))
                                message.repeatDayOfWeek = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.repeatDayOfWeek.push(reader.int32());
                            } else
                                message.repeatDayOfWeek.push(reader.int32());
                            break;
                        case 10:
                            message.note = reader.string();
                            break;
                        case 11:
                            if (!(message.appliedDateIds && message.appliedDateIds.length))
                                message.appliedDateIds = [];
                            message.appliedDateIds.push(reader.string());
                            break;
                        case 12:
                            message.staffId = reader.int64();
                            break;
                        case 13:
                            message.createTimeMs = reader.int64();
                            break;
                        case 14:
                            message.updateTimeMs = reader.int64();
                            break;
                        case 15:
                            message.isCrossDay = reader.bool();
                            break;
                        case 16:
                            message.groupId = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffAvailability message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffAvailability} StaffAvailability
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailability.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffAvailability message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffAvailability.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.available != null && message.hasOwnProperty("available"))
                        if (typeof message.available !== "boolean")
                            return "available: boolean expected";
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        if (!$util.isString(message.startDateId))
                            return "startDateId: string expected";
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        if (!$util.isString(message.endDateId))
                            return "endDateId: string expected";
                    if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                        if (typeof message.isAllDay !== "boolean")
                            return "isAllDay: boolean expected";
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        if (!$util.isString(message.startTime))
                            return "startTime: string expected";
                    if (message.endTime != null && message.hasOwnProperty("endTime"))
                        if (!$util.isString(message.endTime))
                            return "endTime: string expected";
                    if (message.repeatType != null && message.hasOwnProperty("repeatType"))
                        switch (message.repeatType) {
                        default:
                            return "repeatType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.repeatDayOfWeek != null && message.hasOwnProperty("repeatDayOfWeek")) {
                        if (!Array.isArray(message.repeatDayOfWeek))
                            return "repeatDayOfWeek: array expected";
                        for (var i = 0; i < message.repeatDayOfWeek.length; ++i)
                            switch (message.repeatDayOfWeek[i]) {
                            default:
                                return "repeatDayOfWeek: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        if (!$util.isString(message.note))
                            return "note: string expected";
                    if (message.appliedDateIds != null && message.hasOwnProperty("appliedDateIds")) {
                        if (!Array.isArray(message.appliedDateIds))
                            return "appliedDateIds: array expected";
                        for (var i = 0; i < message.appliedDateIds.length; ++i)
                            if (!$util.isString(message.appliedDateIds[i]))
                                return "appliedDateIds: string[] expected";
                    }
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                            return "updateTimeMs: integer|Long expected";
                    if (message.isCrossDay != null && message.hasOwnProperty("isCrossDay"))
                        if (typeof message.isCrossDay !== "boolean")
                            return "isCrossDay: boolean expected";
                    if (message.groupId != null && message.hasOwnProperty("groupId"))
                        if (!$util.isInteger(message.groupId) && !(message.groupId && $util.isInteger(message.groupId.low) && $util.isInteger(message.groupId.high)))
                            return "groupId: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a StaffAvailability message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffAvailability} StaffAvailability
                 */
                StaffAvailability.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffAvailability)
                        return object;
                    var message = new $root.palexy.protobuf.StaffAvailability();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.available != null)
                        message.available = Boolean(object.available);
                    if (object.startDateId != null)
                        message.startDateId = String(object.startDateId);
                    if (object.endDateId != null)
                        message.endDateId = String(object.endDateId);
                    if (object.isAllDay != null)
                        message.isAllDay = Boolean(object.isAllDay);
                    if (object.startTime != null)
                        message.startTime = String(object.startTime);
                    if (object.endTime != null)
                        message.endTime = String(object.endTime);
                    switch (object.repeatType) {
                    case "UNKNOWN_REPEAT_TYPE":
                    case 0:
                        message.repeatType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.repeatType = 1;
                        break;
                    case "WEEKLY":
                    case 2:
                        message.repeatType = 2;
                        break;
                    }
                    if (object.repeatDayOfWeek) {
                        if (!Array.isArray(object.repeatDayOfWeek))
                            throw TypeError(".palexy.protobuf.StaffAvailability.repeatDayOfWeek: array expected");
                        message.repeatDayOfWeek = [];
                        for (var i = 0; i < object.repeatDayOfWeek.length; ++i)
                            switch (object.repeatDayOfWeek[i]) {
                            default:
                            case "DAY_OF_WEEK_UNSPECIFIED":
                            case 0:
                                message.repeatDayOfWeek[i] = 0;
                                break;
                            case "MONDAY":
                            case 1:
                                message.repeatDayOfWeek[i] = 1;
                                break;
                            case "TUESDAY":
                            case 2:
                                message.repeatDayOfWeek[i] = 2;
                                break;
                            case "WEDNESDAY":
                            case 3:
                                message.repeatDayOfWeek[i] = 3;
                                break;
                            case "THURSDAY":
                            case 4:
                                message.repeatDayOfWeek[i] = 4;
                                break;
                            case "FRIDAY":
                            case 5:
                                message.repeatDayOfWeek[i] = 5;
                                break;
                            case "SATURDAY":
                            case 6:
                                message.repeatDayOfWeek[i] = 6;
                                break;
                            case "SUNDAY":
                            case 7:
                                message.repeatDayOfWeek[i] = 7;
                                break;
                            }
                    }
                    if (object.note != null)
                        message.note = String(object.note);
                    if (object.appliedDateIds) {
                        if (!Array.isArray(object.appliedDateIds))
                            throw TypeError(".palexy.protobuf.StaffAvailability.appliedDateIds: array expected");
                        message.appliedDateIds = [];
                        for (var i = 0; i < object.appliedDateIds.length; ++i)
                            message.appliedDateIds[i] = String(object.appliedDateIds[i]);
                    }
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.updateTimeMs != null)
                        if ($util.Long)
                            (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                        else if (typeof object.updateTimeMs === "string")
                            message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                        else if (typeof object.updateTimeMs === "number")
                            message.updateTimeMs = object.updateTimeMs;
                        else if (typeof object.updateTimeMs === "object")
                            message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                    if (object.isCrossDay != null)
                        message.isCrossDay = Boolean(object.isCrossDay);
                    if (object.groupId != null)
                        if ($util.Long)
                            (message.groupId = $util.Long.fromValue(object.groupId)).unsigned = false;
                        else if (typeof object.groupId === "string")
                            message.groupId = parseInt(object.groupId, 10);
                        else if (typeof object.groupId === "number")
                            message.groupId = object.groupId;
                        else if (typeof object.groupId === "object")
                            message.groupId = new $util.LongBits(object.groupId.low >>> 0, object.groupId.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffAvailability message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffAvailability
                 * @static
                 * @param {palexy.protobuf.StaffAvailability} message StaffAvailability
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffAvailability.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.repeatDayOfWeek = [];
                        object.appliedDateIds = [];
                    }
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.available = false;
                        object.startDateId = "";
                        object.endDateId = "";
                        object.isAllDay = false;
                        object.startTime = "";
                        object.endTime = "";
                        object.repeatType = options.enums === String ? "UNKNOWN_REPEAT_TYPE" : 0;
                        object.note = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.updateTimeMs = options.longs === String ? "0" : 0;
                        object.isCrossDay = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.groupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.groupId = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.available != null && message.hasOwnProperty("available"))
                        object.available = message.available;
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        object.startDateId = message.startDateId;
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        object.endDateId = message.endDateId;
                    if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                        object.isAllDay = message.isAllDay;
                    if (message.startTime != null && message.hasOwnProperty("startTime"))
                        object.startTime = message.startTime;
                    if (message.endTime != null && message.hasOwnProperty("endTime"))
                        object.endTime = message.endTime;
                    if (message.repeatType != null && message.hasOwnProperty("repeatType"))
                        object.repeatType = options.enums === String ? $root.palexy.protobuf.AvailabilityRepeatType[message.repeatType] : message.repeatType;
                    if (message.repeatDayOfWeek && message.repeatDayOfWeek.length) {
                        object.repeatDayOfWeek = [];
                        for (var j = 0; j < message.repeatDayOfWeek.length; ++j)
                            object.repeatDayOfWeek[j] = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.repeatDayOfWeek[j]] : message.repeatDayOfWeek[j];
                    }
                    if (message.note != null && message.hasOwnProperty("note"))
                        object.note = message.note;
                    if (message.appliedDateIds && message.appliedDateIds.length) {
                        object.appliedDateIds = [];
                        for (var j = 0; j < message.appliedDateIds.length; ++j)
                            object.appliedDateIds[j] = message.appliedDateIds[j];
                    }
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                        if (typeof message.updateTimeMs === "number")
                            object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                        else
                            object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                    if (message.isCrossDay != null && message.hasOwnProperty("isCrossDay"))
                        object.isCrossDay = message.isCrossDay;
                    if (message.groupId != null && message.hasOwnProperty("groupId"))
                        if (typeof message.groupId === "number")
                            object.groupId = options.longs === String ? String(message.groupId) : message.groupId;
                        else
                            object.groupId = options.longs === String ? $util.Long.prototype.toString.call(message.groupId) : options.longs === Number ? new $util.LongBits(message.groupId.low >>> 0, message.groupId.high >>> 0).toNumber() : message.groupId;
                    return object;
                };
    
                /**
                 * Converts this StaffAvailability to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffAvailability
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffAvailability.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffAvailability;
            })();
    
            /**
             * AvailabilityRepeatType enum.
             * @name palexy.protobuf.AvailabilityRepeatType
             * @enum {number}
             * @property {number} UNKNOWN_REPEAT_TYPE=0 UNKNOWN_REPEAT_TYPE value
             * @property {number} SINGLE=1 SINGLE value
             * @property {number} WEEKLY=2 WEEKLY value
             */
            protobuf.AvailabilityRepeatType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_REPEAT_TYPE"] = 0;
                values[valuesById[1] = "SINGLE"] = 1;
                values[valuesById[2] = "WEEKLY"] = 2;
                return values;
            })();
    
            protobuf.StaffAvailabilityGroup = (function() {
    
                /**
                 * Properties of a StaffAvailabilityGroup.
                 * @memberof palexy.protobuf
                 * @interface IStaffAvailabilityGroup
                 * @property {number|null} [id] StaffAvailabilityGroup id
                 * @property {number|null} [staffId] StaffAvailabilityGroup staffId
                 * @property {Array.<palexy.streaming.v1.DayOfWeek>|null} [repeatDayOfWeek] StaffAvailabilityGroup repeatDayOfWeek
                 * @property {string|null} [startDateId] StaffAvailabilityGroup startDateId
                 * @property {string|null} [endDateId] StaffAvailabilityGroup endDateId
                 * @property {number|null} [createTimeMs] StaffAvailabilityGroup createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] StaffAvailabilityGroup lastUpdateTimeMs
                 * @property {palexy.protobuf.AvailabilityRepeatType|null} [repeatType] StaffAvailabilityGroup repeatType
                 */
    
                /**
                 * Constructs a new StaffAvailabilityGroup.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffAvailabilityGroup.
                 * @implements IStaffAvailabilityGroup
                 * @constructor
                 * @param {palexy.protobuf.IStaffAvailabilityGroup=} [properties] Properties to set
                 */
                function StaffAvailabilityGroup(properties) {
                    this.repeatDayOfWeek = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffAvailabilityGroup id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityGroup staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityGroup repeatDayOfWeek.
                 * @member {Array.<palexy.streaming.v1.DayOfWeek>} repeatDayOfWeek
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.repeatDayOfWeek = $util.emptyArray;
    
                /**
                 * StaffAvailabilityGroup startDateId.
                 * @member {string} startDateId
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.startDateId = "";
    
                /**
                 * StaffAvailabilityGroup endDateId.
                 * @member {string} endDateId
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.endDateId = "";
    
                /**
                 * StaffAvailabilityGroup createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityGroup lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityGroup repeatType.
                 * @member {palexy.protobuf.AvailabilityRepeatType} repeatType
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 */
                StaffAvailabilityGroup.prototype.repeatType = 0;
    
                /**
                 * Creates a new StaffAvailabilityGroup instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityGroup=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffAvailabilityGroup} StaffAvailabilityGroup instance
                 */
                StaffAvailabilityGroup.create = function create(properties) {
                    return new StaffAvailabilityGroup(properties);
                };
    
                /**
                 * Encodes the specified StaffAvailabilityGroup message. Does not implicitly {@link palexy.protobuf.StaffAvailabilityGroup.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityGroup} message StaffAvailabilityGroup message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailabilityGroup.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                    if (message.repeatDayOfWeek != null && message.repeatDayOfWeek.length) {
                        writer.uint32(/* id 9, wireType 2 =*/74).fork();
                        for (var i = 0; i < message.repeatDayOfWeek.length; ++i)
                            writer.int32(message.repeatDayOfWeek[i]);
                        writer.ldelim();
                    }
                    if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.startDateId);
                    if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.endDateId);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 13, wireType 0 =*/104).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 14, wireType 0 =*/112).int64(message.lastUpdateTimeMs);
                    if (message.repeatType != null && Object.hasOwnProperty.call(message, "repeatType"))
                        writer.uint32(/* id 15, wireType 0 =*/120).int32(message.repeatType);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffAvailabilityGroup message, length delimited. Does not implicitly {@link palexy.protobuf.StaffAvailabilityGroup.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityGroup} message StaffAvailabilityGroup message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailabilityGroup.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffAvailabilityGroup message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffAvailabilityGroup} StaffAvailabilityGroup
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailabilityGroup.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffAvailabilityGroup();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.staffId = reader.int64();
                            break;
                        case 9:
                            if (!(message.repeatDayOfWeek && message.repeatDayOfWeek.length))
                                message.repeatDayOfWeek = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.repeatDayOfWeek.push(reader.int32());
                            } else
                                message.repeatDayOfWeek.push(reader.int32());
                            break;
                        case 10:
                            message.startDateId = reader.string();
                            break;
                        case 11:
                            message.endDateId = reader.string();
                            break;
                        case 13:
                            message.createTimeMs = reader.int64();
                            break;
                        case 14:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        case 15:
                            message.repeatType = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffAvailabilityGroup message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffAvailabilityGroup} StaffAvailabilityGroup
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailabilityGroup.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffAvailabilityGroup message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffAvailabilityGroup.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.repeatDayOfWeek != null && message.hasOwnProperty("repeatDayOfWeek")) {
                        if (!Array.isArray(message.repeatDayOfWeek))
                            return "repeatDayOfWeek: array expected";
                        for (var i = 0; i < message.repeatDayOfWeek.length; ++i)
                            switch (message.repeatDayOfWeek[i]) {
                            default:
                                return "repeatDayOfWeek: enum value[] expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                    }
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        if (!$util.isString(message.startDateId))
                            return "startDateId: string expected";
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        if (!$util.isString(message.endDateId))
                            return "endDateId: string expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    if (message.repeatType != null && message.hasOwnProperty("repeatType"))
                        switch (message.repeatType) {
                        default:
                            return "repeatType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };
    
                /**
                 * Creates a StaffAvailabilityGroup message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffAvailabilityGroup} StaffAvailabilityGroup
                 */
                StaffAvailabilityGroup.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffAvailabilityGroup)
                        return object;
                    var message = new $root.palexy.protobuf.StaffAvailabilityGroup();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.repeatDayOfWeek) {
                        if (!Array.isArray(object.repeatDayOfWeek))
                            throw TypeError(".palexy.protobuf.StaffAvailabilityGroup.repeatDayOfWeek: array expected");
                        message.repeatDayOfWeek = [];
                        for (var i = 0; i < object.repeatDayOfWeek.length; ++i)
                            switch (object.repeatDayOfWeek[i]) {
                            default:
                            case "DAY_OF_WEEK_UNSPECIFIED":
                            case 0:
                                message.repeatDayOfWeek[i] = 0;
                                break;
                            case "MONDAY":
                            case 1:
                                message.repeatDayOfWeek[i] = 1;
                                break;
                            case "TUESDAY":
                            case 2:
                                message.repeatDayOfWeek[i] = 2;
                                break;
                            case "WEDNESDAY":
                            case 3:
                                message.repeatDayOfWeek[i] = 3;
                                break;
                            case "THURSDAY":
                            case 4:
                                message.repeatDayOfWeek[i] = 4;
                                break;
                            case "FRIDAY":
                            case 5:
                                message.repeatDayOfWeek[i] = 5;
                                break;
                            case "SATURDAY":
                            case 6:
                                message.repeatDayOfWeek[i] = 6;
                                break;
                            case "SUNDAY":
                            case 7:
                                message.repeatDayOfWeek[i] = 7;
                                break;
                            }
                    }
                    if (object.startDateId != null)
                        message.startDateId = String(object.startDateId);
                    if (object.endDateId != null)
                        message.endDateId = String(object.endDateId);
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    switch (object.repeatType) {
                    case "UNKNOWN_REPEAT_TYPE":
                    case 0:
                        message.repeatType = 0;
                        break;
                    case "SINGLE":
                    case 1:
                        message.repeatType = 1;
                        break;
                    case "WEEKLY":
                    case 2:
                        message.repeatType = 2;
                        break;
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffAvailabilityGroup message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @static
                 * @param {palexy.protobuf.StaffAvailabilityGroup} message StaffAvailabilityGroup
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffAvailabilityGroup.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.repeatDayOfWeek = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        object.startDateId = "";
                        object.endDateId = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        object.repeatType = options.enums === String ? "UNKNOWN_REPEAT_TYPE" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.repeatDayOfWeek && message.repeatDayOfWeek.length) {
                        object.repeatDayOfWeek = [];
                        for (var j = 0; j < message.repeatDayOfWeek.length; ++j)
                            object.repeatDayOfWeek[j] = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.repeatDayOfWeek[j]] : message.repeatDayOfWeek[j];
                    }
                    if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                        object.startDateId = message.startDateId;
                    if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                        object.endDateId = message.endDateId;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    if (message.repeatType != null && message.hasOwnProperty("repeatType"))
                        object.repeatType = options.enums === String ? $root.palexy.protobuf.AvailabilityRepeatType[message.repeatType] : message.repeatType;
                    return object;
                };
    
                /**
                 * Converts this StaffAvailabilityGroup to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffAvailabilityGroup
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffAvailabilityGroup.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffAvailabilityGroup;
            })();
    
            /**
             * StaffAvailabilityLockSource enum.
             * @name palexy.protobuf.StaffAvailabilityLockSource
             * @enum {number}
             * @property {number} STAFF_AVAILABILITY_LOCK_SOURCE_UNSPECIFIED=0 STAFF_AVAILABILITY_LOCK_SOURCE_UNSPECIFIED value
             * @property {number} STAFF_AVAILABILITY_LOCK_SOURCE_MANUAL=1 STAFF_AVAILABILITY_LOCK_SOURCE_MANUAL value
             * @property {number} STAFF_AVAILABILITY_LOCK_SOURCE_AUTO=2 STAFF_AVAILABILITY_LOCK_SOURCE_AUTO value
             */
            protobuf.StaffAvailabilityLockSource = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "STAFF_AVAILABILITY_LOCK_SOURCE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "STAFF_AVAILABILITY_LOCK_SOURCE_MANUAL"] = 1;
                values[valuesById[2] = "STAFF_AVAILABILITY_LOCK_SOURCE_AUTO"] = 2;
                return values;
            })();
    
            protobuf.StaffAvailabilityLock = (function() {
    
                /**
                 * Properties of a StaffAvailabilityLock.
                 * @memberof palexy.protobuf
                 * @interface IStaffAvailabilityLock
                 * @property {number|null} [id] StaffAvailabilityLock id
                 * @property {number|null} [companyId] StaffAvailabilityLock companyId
                 * @property {number|null} [storeId] StaffAvailabilityLock storeId
                 * @property {string|null} [dateId] StaffAvailabilityLock dateId
                 * @property {palexy.protobuf.StaffAvailabilityLockSource|null} [source] StaffAvailabilityLock source
                 */
    
                /**
                 * Constructs a new StaffAvailabilityLock.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffAvailabilityLock.
                 * @implements IStaffAvailabilityLock
                 * @constructor
                 * @param {palexy.protobuf.IStaffAvailabilityLock=} [properties] Properties to set
                 */
                function StaffAvailabilityLock(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffAvailabilityLock id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 */
                StaffAvailabilityLock.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityLock companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 */
                StaffAvailabilityLock.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityLock storeId.
                 * @member {number} storeId
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 */
                StaffAvailabilityLock.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffAvailabilityLock dateId.
                 * @member {string} dateId
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 */
                StaffAvailabilityLock.prototype.dateId = "";
    
                /**
                 * StaffAvailabilityLock source.
                 * @member {palexy.protobuf.StaffAvailabilityLockSource} source
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 */
                StaffAvailabilityLock.prototype.source = 0;
    
                /**
                 * Creates a new StaffAvailabilityLock instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityLock=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffAvailabilityLock} StaffAvailabilityLock instance
                 */
                StaffAvailabilityLock.create = function create(properties) {
                    return new StaffAvailabilityLock(properties);
                };
    
                /**
                 * Encodes the specified StaffAvailabilityLock message. Does not implicitly {@link palexy.protobuf.StaffAvailabilityLock.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityLock} message StaffAvailabilityLock message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailabilityLock.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                    if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                    if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.dateId);
                    if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.source);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffAvailabilityLock message, length delimited. Does not implicitly {@link palexy.protobuf.StaffAvailabilityLock.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {palexy.protobuf.IStaffAvailabilityLock} message StaffAvailabilityLock message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffAvailabilityLock.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffAvailabilityLock message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffAvailabilityLock} StaffAvailabilityLock
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailabilityLock.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffAvailabilityLock();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.companyId = reader.int64();
                            break;
                        case 3:
                            message.storeId = reader.int64();
                            break;
                        case 4:
                            message.dateId = reader.string();
                            break;
                        case 5:
                            message.source = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffAvailabilityLock message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffAvailabilityLock} StaffAvailabilityLock
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffAvailabilityLock.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffAvailabilityLock message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffAvailabilityLock.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                            return "storeId: integer|Long expected";
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        if (!$util.isString(message.dateId))
                            return "dateId: string expected";
                    if (message.source != null && message.hasOwnProperty("source"))
                        switch (message.source) {
                        default:
                            return "source: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    return null;
                };
    
                /**
                 * Creates a StaffAvailabilityLock message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffAvailabilityLock} StaffAvailabilityLock
                 */
                StaffAvailabilityLock.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffAvailabilityLock)
                        return object;
                    var message = new $root.palexy.protobuf.StaffAvailabilityLock();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    if (object.storeId != null)
                        if ($util.Long)
                            (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                        else if (typeof object.storeId === "string")
                            message.storeId = parseInt(object.storeId, 10);
                        else if (typeof object.storeId === "number")
                            message.storeId = object.storeId;
                        else if (typeof object.storeId === "object")
                            message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                    if (object.dateId != null)
                        message.dateId = String(object.dateId);
                    switch (object.source) {
                    case "STAFF_AVAILABILITY_LOCK_SOURCE_UNSPECIFIED":
                    case 0:
                        message.source = 0;
                        break;
                    case "STAFF_AVAILABILITY_LOCK_SOURCE_MANUAL":
                    case 1:
                        message.source = 1;
                        break;
                    case "STAFF_AVAILABILITY_LOCK_SOURCE_AUTO":
                    case 2:
                        message.source = 2;
                        break;
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffAvailabilityLock message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @static
                 * @param {palexy.protobuf.StaffAvailabilityLock} message StaffAvailabilityLock
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffAvailabilityLock.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.storeId = options.longs === String ? "0" : 0;
                        object.dateId = "";
                        object.source = options.enums === String ? "STAFF_AVAILABILITY_LOCK_SOURCE_UNSPECIFIED" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.storeId != null && message.hasOwnProperty("storeId"))
                        if (typeof message.storeId === "number")
                            object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                        else
                            object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                    if (message.dateId != null && message.hasOwnProperty("dateId"))
                        object.dateId = message.dateId;
                    if (message.source != null && message.hasOwnProperty("source"))
                        object.source = options.enums === String ? $root.palexy.protobuf.StaffAvailabilityLockSource[message.source] : message.source;
                    return object;
                };
    
                /**
                 * Converts this StaffAvailabilityLock to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffAvailabilityLock
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffAvailabilityLock.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffAvailabilityLock;
            })();
    
            protobuf.StaffHourRate = (function() {
    
                /**
                 * Properties of a StaffHourRate.
                 * @memberof palexy.protobuf
                 * @interface IStaffHourRate
                 * @property {number|null} [id] StaffHourRate id
                 * @property {number|null} [staffId] StaffHourRate staffId
                 * @property {number|null} [hourRate] StaffHourRate hourRate
                 */
    
                /**
                 * Constructs a new StaffHourRate.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffHourRate.
                 * @implements IStaffHourRate
                 * @constructor
                 * @param {palexy.protobuf.IStaffHourRate=} [properties] Properties to set
                 */
                function StaffHourRate(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffHourRate id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffHourRate
                 * @instance
                 */
                StaffHourRate.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffHourRate staffId.
                 * @member {number} staffId
                 * @memberof palexy.protobuf.StaffHourRate
                 * @instance
                 */
                StaffHourRate.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffHourRate hourRate.
                 * @member {number} hourRate
                 * @memberof palexy.protobuf.StaffHourRate
                 * @instance
                 */
                StaffHourRate.prototype.hourRate = 0;
    
                /**
                 * Creates a new StaffHourRate instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {palexy.protobuf.IStaffHourRate=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffHourRate} StaffHourRate instance
                 */
                StaffHourRate.create = function create(properties) {
                    return new StaffHourRate(properties);
                };
    
                /**
                 * Encodes the specified StaffHourRate message. Does not implicitly {@link palexy.protobuf.StaffHourRate.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {palexy.protobuf.IStaffHourRate} message StaffHourRate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffHourRate.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                    if (message.hourRate != null && Object.hasOwnProperty.call(message, "hourRate"))
                        writer.uint32(/* id 3, wireType 1 =*/25).double(message.hourRate);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffHourRate message, length delimited. Does not implicitly {@link palexy.protobuf.StaffHourRate.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {palexy.protobuf.IStaffHourRate} message StaffHourRate message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffHourRate.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffHourRate message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffHourRate} StaffHourRate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffHourRate.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffHourRate();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.staffId = reader.int64();
                            break;
                        case 3:
                            message.hourRate = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffHourRate message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffHourRate} StaffHourRate
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffHourRate.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffHourRate message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffHourRate.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                            return "staffId: integer|Long expected";
                    if (message.hourRate != null && message.hasOwnProperty("hourRate"))
                        if (typeof message.hourRate !== "number")
                            return "hourRate: number expected";
                    return null;
                };
    
                /**
                 * Creates a StaffHourRate message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffHourRate} StaffHourRate
                 */
                StaffHourRate.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffHourRate)
                        return object;
                    var message = new $root.palexy.protobuf.StaffHourRate();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.staffId != null)
                        if ($util.Long)
                            (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                        else if (typeof object.staffId === "string")
                            message.staffId = parseInt(object.staffId, 10);
                        else if (typeof object.staffId === "number")
                            message.staffId = object.staffId;
                        else if (typeof object.staffId === "object")
                            message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                    if (object.hourRate != null)
                        message.hourRate = Number(object.hourRate);
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffHourRate message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffHourRate
                 * @static
                 * @param {palexy.protobuf.StaffHourRate} message StaffHourRate
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffHourRate.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.staffId = options.longs === String ? "0" : 0;
                        object.hourRate = 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.staffId != null && message.hasOwnProperty("staffId"))
                        if (typeof message.staffId === "number")
                            object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                        else
                            object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                    if (message.hourRate != null && message.hasOwnProperty("hourRate"))
                        object.hourRate = options.json && !isFinite(message.hourRate) ? String(message.hourRate) : message.hourRate;
                    return object;
                };
    
                /**
                 * Converts this StaffHourRate to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffHourRate
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffHourRate.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffHourRate;
            })();
    
            /**
             * StaffEmploymentType enum.
             * @name palexy.protobuf.StaffEmploymentType
             * @enum {number}
             * @property {number} UNKNOWN_STAFF_EMPLOYMENT_TYPE=0 UNKNOWN_STAFF_EMPLOYMENT_TYPE value
             * @property {number} FULL_TIME=1 FULL_TIME value
             * @property {number} PART_TIME=2 PART_TIME value
             * @property {number} EXTERNAL_STAFF=3 EXTERNAL_STAFF value
             */
            protobuf.StaffEmploymentType = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "UNKNOWN_STAFF_EMPLOYMENT_TYPE"] = 0;
                values[valuesById[1] = "FULL_TIME"] = 1;
                values[valuesById[2] = "PART_TIME"] = 2;
                values[valuesById[3] = "EXTERNAL_STAFF"] = 3;
                return values;
            })();
    
            /**
             * Gender enum.
             * @name palexy.protobuf.Gender
             * @enum {number}
             * @property {number} GENDER_UNSPECIFIED=0 GENDER_UNSPECIFIED value
             * @property {number} MALE=1 MALE value
             * @property {number} FEMALE=2 FEMALE value
             */
            protobuf.Gender = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "GENDER_UNSPECIFIED"] = 0;
                values[valuesById[1] = "MALE"] = 1;
                values[valuesById[2] = "FEMALE"] = 2;
                return values;
            })();
    
            protobuf.StaffMetadata = (function() {
    
                /**
                 * Properties of a StaffMetadata.
                 * @memberof palexy.protobuf
                 * @interface IStaffMetadata
                 * @property {number|null} [id] StaffMetadata id
                 * @property {number|null} [companyId] StaffMetadata companyId
                 * @property {string|null} [name] StaffMetadata name
                 * @property {string|null} [description] StaffMetadata description
                 * @property {palexy.streaming.v1.DataType|null} [dataType] StaffMetadata dataType
                 * @property {Array.<palexy.protobuf.IStaffMetadataValue>|null} [allowedValues] StaffMetadata allowedValues
                 * @property {number|null} [createTimeMs] StaffMetadata createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] StaffMetadata lastUpdateTimeMs
                 * @property {boolean|null} [deleted] StaffMetadata deleted
                 */
    
                /**
                 * Constructs a new StaffMetadata.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffMetadata.
                 * @implements IStaffMetadata
                 * @constructor
                 * @param {palexy.protobuf.IStaffMetadata=} [properties] Properties to set
                 */
                function StaffMetadata(properties) {
                    this.allowedValues = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffMetadata id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadata companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadata name.
                 * @member {string} name
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.name = "";
    
                /**
                 * StaffMetadata description.
                 * @member {string} description
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.description = "";
    
                /**
                 * StaffMetadata dataType.
                 * @member {palexy.streaming.v1.DataType} dataType
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.dataType = 0;
    
                /**
                 * StaffMetadata allowedValues.
                 * @member {Array.<palexy.protobuf.IStaffMetadataValue>} allowedValues
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.allowedValues = $util.emptyArray;
    
                /**
                 * StaffMetadata createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadata lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadata deleted.
                 * @member {boolean} deleted
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 */
                StaffMetadata.prototype.deleted = false;
    
                /**
                 * Creates a new StaffMetadata instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {palexy.protobuf.IStaffMetadata=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffMetadata} StaffMetadata instance
                 */
                StaffMetadata.create = function create(properties) {
                    return new StaffMetadata(properties);
                };
    
                /**
                 * Encodes the specified StaffMetadata message. Does not implicitly {@link palexy.protobuf.StaffMetadata.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {palexy.protobuf.IStaffMetadata} message StaffMetadata message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadata.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                    if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                    if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.dataType);
                    if (message.allowedValues != null && message.allowedValues.length)
                        for (var i = 0; i < message.allowedValues.length; ++i)
                            $root.palexy.protobuf.StaffMetadataValue.encode(message.allowedValues[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                    if (message.deleted != null && Object.hasOwnProperty.call(message, "deleted"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.deleted);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffMetadata message, length delimited. Does not implicitly {@link palexy.protobuf.StaffMetadata.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {palexy.protobuf.IStaffMetadata} message StaffMetadata message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadata.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffMetadata message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffMetadata} StaffMetadata
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadata.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffMetadata();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.companyId = reader.int64();
                            break;
                        case 3:
                            message.name = reader.string();
                            break;
                        case 4:
                            message.description = reader.string();
                            break;
                        case 5:
                            message.dataType = reader.int32();
                            break;
                        case 6:
                            if (!(message.allowedValues && message.allowedValues.length))
                                message.allowedValues = [];
                            message.allowedValues.push($root.palexy.protobuf.StaffMetadataValue.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            message.createTimeMs = reader.int64();
                            break;
                        case 9:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        case 10:
                            message.deleted = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffMetadata message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffMetadata} StaffMetadata
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadata.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffMetadata message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffMetadata.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.description != null && message.hasOwnProperty("description"))
                        if (!$util.isString(message.description))
                            return "description: string expected";
                    if (message.dataType != null && message.hasOwnProperty("dataType"))
                        switch (message.dataType) {
                        default:
                            return "dataType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.allowedValues != null && message.hasOwnProperty("allowedValues")) {
                        if (!Array.isArray(message.allowedValues))
                            return "allowedValues: array expected";
                        for (var i = 0; i < message.allowedValues.length; ++i) {
                            var error = $root.palexy.protobuf.StaffMetadataValue.verify(message.allowedValues[i]);
                            if (error)
                                return "allowedValues." + error;
                        }
                    }
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    if (message.deleted != null && message.hasOwnProperty("deleted"))
                        if (typeof message.deleted !== "boolean")
                            return "deleted: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a StaffMetadata message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffMetadata} StaffMetadata
                 */
                StaffMetadata.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffMetadata)
                        return object;
                    var message = new $root.palexy.protobuf.StaffMetadata();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.description != null)
                        message.description = String(object.description);
                    switch (object.dataType) {
                    case "DATA_TYPE_UNKNOWN":
                    case 0:
                        message.dataType = 0;
                        break;
                    case "TEXT":
                    case 1:
                        message.dataType = 1;
                        break;
                    case "NUMERIC":
                    case 2:
                        message.dataType = 2;
                        break;
                    }
                    if (object.allowedValues) {
                        if (!Array.isArray(object.allowedValues))
                            throw TypeError(".palexy.protobuf.StaffMetadata.allowedValues: array expected");
                        message.allowedValues = [];
                        for (var i = 0; i < object.allowedValues.length; ++i) {
                            if (typeof object.allowedValues[i] !== "object")
                                throw TypeError(".palexy.protobuf.StaffMetadata.allowedValues: object expected");
                            message.allowedValues[i] = $root.palexy.protobuf.StaffMetadataValue.fromObject(object.allowedValues[i]);
                        }
                    }
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    if (object.deleted != null)
                        message.deleted = Boolean(object.deleted);
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffMetadata message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffMetadata
                 * @static
                 * @param {palexy.protobuf.StaffMetadata} message StaffMetadata
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffMetadata.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.allowedValues = [];
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        object.name = "";
                        object.description = "";
                        object.dataType = options.enums === String ? "DATA_TYPE_UNKNOWN" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        object.deleted = false;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.description != null && message.hasOwnProperty("description"))
                        object.description = message.description;
                    if (message.dataType != null && message.hasOwnProperty("dataType"))
                        object.dataType = options.enums === String ? $root.palexy.streaming.v1.DataType[message.dataType] : message.dataType;
                    if (message.allowedValues && message.allowedValues.length) {
                        object.allowedValues = [];
                        for (var j = 0; j < message.allowedValues.length; ++j)
                            object.allowedValues[j] = $root.palexy.protobuf.StaffMetadataValue.toObject(message.allowedValues[j], options);
                    }
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    if (message.deleted != null && message.hasOwnProperty("deleted"))
                        object.deleted = message.deleted;
                    return object;
                };
    
                /**
                 * Converts this StaffMetadata to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffMetadata
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffMetadata.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffMetadata;
            })();
    
            protobuf.StaffMetadataValue = (function() {
    
                /**
                 * Properties of a StaffMetadataValue.
                 * @memberof palexy.protobuf
                 * @interface IStaffMetadataValue
                 * @property {number|null} [id] StaffMetadataValue id
                 * @property {string|null} [value] StaffMetadataValue value
                 * @property {number|null} [orderIndex] StaffMetadataValue orderIndex
                 */
    
                /**
                 * Constructs a new StaffMetadataValue.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffMetadataValue.
                 * @implements IStaffMetadataValue
                 * @constructor
                 * @param {palexy.protobuf.IStaffMetadataValue=} [properties] Properties to set
                 */
                function StaffMetadataValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffMetadataValue id.
                 * @member {number} id
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @instance
                 */
                StaffMetadataValue.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadataValue value.
                 * @member {string} value
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @instance
                 */
                StaffMetadataValue.prototype.value = "";
    
                /**
                 * StaffMetadataValue orderIndex.
                 * @member {number} orderIndex
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @instance
                 */
                StaffMetadataValue.prototype.orderIndex = 0;
    
                /**
                 * Creates a new StaffMetadataValue instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValue=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffMetadataValue} StaffMetadataValue instance
                 */
                StaffMetadataValue.create = function create(properties) {
                    return new StaffMetadataValue(properties);
                };
    
                /**
                 * Encodes the specified StaffMetadataValue message. Does not implicitly {@link palexy.protobuf.StaffMetadataValue.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValue} message StaffMetadataValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadataValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                    if (message.orderIndex != null && Object.hasOwnProperty.call(message, "orderIndex"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.orderIndex);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffMetadataValue message, length delimited. Does not implicitly {@link palexy.protobuf.StaffMetadataValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValue} message StaffMetadataValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadataValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffMetadataValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffMetadataValue} StaffMetadataValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadataValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffMetadataValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.value = reader.string();
                            break;
                        case 3:
                            message.orderIndex = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffMetadataValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffMetadataValue} StaffMetadataValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadataValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffMetadataValue message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffMetadataValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isString(message.value))
                            return "value: string expected";
                    if (message.orderIndex != null && message.hasOwnProperty("orderIndex"))
                        if (!$util.isInteger(message.orderIndex))
                            return "orderIndex: integer expected";
                    return null;
                };
    
                /**
                 * Creates a StaffMetadataValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffMetadataValue} StaffMetadataValue
                 */
                StaffMetadataValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffMetadataValue)
                        return object;
                    var message = new $root.palexy.protobuf.StaffMetadataValue();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.value != null)
                        message.value = String(object.value);
                    if (object.orderIndex != null)
                        message.orderIndex = object.orderIndex | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffMetadataValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @static
                 * @param {palexy.protobuf.StaffMetadataValue} message StaffMetadataValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffMetadataValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        object.value = "";
                        object.orderIndex = 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    if (message.orderIndex != null && message.hasOwnProperty("orderIndex"))
                        object.orderIndex = message.orderIndex;
                    return object;
                };
    
                /**
                 * Converts this StaffMetadataValue to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffMetadataValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffMetadataValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffMetadataValue;
            })();
    
            protobuf.StaffMetadataValueMapping = (function() {
    
                /**
                 * Properties of a StaffMetadataValueMapping.
                 * @memberof palexy.protobuf
                 * @interface IStaffMetadataValueMapping
                 * @property {number|null} [metadataId] StaffMetadataValueMapping metadataId
                 * @property {string|null} [metadataName] StaffMetadataValueMapping metadataName
                 * @property {string|null} [value] StaffMetadataValueMapping value
                 */
    
                /**
                 * Constructs a new StaffMetadataValueMapping.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a StaffMetadataValueMapping.
                 * @implements IStaffMetadataValueMapping
                 * @constructor
                 * @param {palexy.protobuf.IStaffMetadataValueMapping=} [properties] Properties to set
                 */
                function StaffMetadataValueMapping(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StaffMetadataValueMapping metadataId.
                 * @member {number} metadataId
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @instance
                 */
                StaffMetadataValueMapping.prototype.metadataId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * StaffMetadataValueMapping metadataName.
                 * @member {string} metadataName
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @instance
                 */
                StaffMetadataValueMapping.prototype.metadataName = "";
    
                /**
                 * StaffMetadataValueMapping value.
                 * @member {string} value
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @instance
                 */
                StaffMetadataValueMapping.prototype.value = "";
    
                /**
                 * Creates a new StaffMetadataValueMapping instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValueMapping=} [properties] Properties to set
                 * @returns {palexy.protobuf.StaffMetadataValueMapping} StaffMetadataValueMapping instance
                 */
                StaffMetadataValueMapping.create = function create(properties) {
                    return new StaffMetadataValueMapping(properties);
                };
    
                /**
                 * Encodes the specified StaffMetadataValueMapping message. Does not implicitly {@link palexy.protobuf.StaffMetadataValueMapping.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValueMapping} message StaffMetadataValueMapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadataValueMapping.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.metadataId != null && Object.hasOwnProperty.call(message, "metadataId"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.metadataId);
                    if (message.metadataName != null && Object.hasOwnProperty.call(message, "metadataName"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.metadataName);
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified StaffMetadataValueMapping message, length delimited. Does not implicitly {@link palexy.protobuf.StaffMetadataValueMapping.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {palexy.protobuf.IStaffMetadataValueMapping} message StaffMetadataValueMapping message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StaffMetadataValueMapping.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StaffMetadataValueMapping message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.StaffMetadataValueMapping} StaffMetadataValueMapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadataValueMapping.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.StaffMetadataValueMapping();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.metadataId = reader.int64();
                            break;
                        case 2:
                            message.metadataName = reader.string();
                            break;
                        case 3:
                            message.value = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StaffMetadataValueMapping message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.StaffMetadataValueMapping} StaffMetadataValueMapping
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StaffMetadataValueMapping.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StaffMetadataValueMapping message.
                 * @function verify
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StaffMetadataValueMapping.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                        if (!$util.isInteger(message.metadataId) && !(message.metadataId && $util.isInteger(message.metadataId.low) && $util.isInteger(message.metadataId.high)))
                            return "metadataId: integer|Long expected";
                    if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                        if (!$util.isString(message.metadataName))
                            return "metadataName: string expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isString(message.value))
                            return "value: string expected";
                    return null;
                };
    
                /**
                 * Creates a StaffMetadataValueMapping message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.StaffMetadataValueMapping} StaffMetadataValueMapping
                 */
                StaffMetadataValueMapping.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.StaffMetadataValueMapping)
                        return object;
                    var message = new $root.palexy.protobuf.StaffMetadataValueMapping();
                    if (object.metadataId != null)
                        if ($util.Long)
                            (message.metadataId = $util.Long.fromValue(object.metadataId)).unsigned = false;
                        else if (typeof object.metadataId === "string")
                            message.metadataId = parseInt(object.metadataId, 10);
                        else if (typeof object.metadataId === "number")
                            message.metadataId = object.metadataId;
                        else if (typeof object.metadataId === "object")
                            message.metadataId = new $util.LongBits(object.metadataId.low >>> 0, object.metadataId.high >>> 0).toNumber();
                    if (object.metadataName != null)
                        message.metadataName = String(object.metadataName);
                    if (object.value != null)
                        message.value = String(object.value);
                    return message;
                };
    
                /**
                 * Creates a plain object from a StaffMetadataValueMapping message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @static
                 * @param {palexy.protobuf.StaffMetadataValueMapping} message StaffMetadataValueMapping
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StaffMetadataValueMapping.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.metadataId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.metadataId = options.longs === String ? "0" : 0;
                        object.metadataName = "";
                        object.value = "";
                    }
                    if (message.metadataId != null && message.hasOwnProperty("metadataId"))
                        if (typeof message.metadataId === "number")
                            object.metadataId = options.longs === String ? String(message.metadataId) : message.metadataId;
                        else
                            object.metadataId = options.longs === String ? $util.Long.prototype.toString.call(message.metadataId) : options.longs === Number ? new $util.LongBits(message.metadataId.low >>> 0, message.metadataId.high >>> 0).toNumber() : message.metadataId;
                    if (message.metadataName != null && message.hasOwnProperty("metadataName"))
                        object.metadataName = message.metadataName;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    return object;
                };
    
                /**
                 * Converts this StaffMetadataValueMapping to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.StaffMetadataValueMapping
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StaffMetadataValueMapping.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StaffMetadataValueMapping;
            })();
    
            protobuf.GroupSpecification = (function() {
    
                /**
                 * Properties of a GroupSpecification.
                 * @memberof palexy.protobuf
                 * @interface IGroupSpecification
                 * @property {palexy.protobuf.GroupSpecification.ISingleNode|null} [single] GroupSpecification single
                 * @property {palexy.protobuf.GroupSpecification.ICompositeNode|null} [composite] GroupSpecification composite
                 * @property {palexy.protobuf.GroupSpecification.IEmptyNode|null} [empty] GroupSpecification empty
                 */
    
                /**
                 * Constructs a new GroupSpecification.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a GroupSpecification.
                 * @implements IGroupSpecification
                 * @constructor
                 * @param {palexy.protobuf.IGroupSpecification=} [properties] Properties to set
                 */
                function GroupSpecification(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * GroupSpecification single.
                 * @member {palexy.protobuf.GroupSpecification.ISingleNode|null|undefined} single
                 * @memberof palexy.protobuf.GroupSpecification
                 * @instance
                 */
                GroupSpecification.prototype.single = null;
    
                /**
                 * GroupSpecification composite.
                 * @member {palexy.protobuf.GroupSpecification.ICompositeNode|null|undefined} composite
                 * @memberof palexy.protobuf.GroupSpecification
                 * @instance
                 */
                GroupSpecification.prototype.composite = null;
    
                /**
                 * GroupSpecification empty.
                 * @member {palexy.protobuf.GroupSpecification.IEmptyNode|null|undefined} empty
                 * @memberof palexy.protobuf.GroupSpecification
                 * @instance
                 */
                GroupSpecification.prototype.empty = null;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * GroupSpecification kind.
                 * @member {"single"|"composite"|"empty"|undefined} kind
                 * @memberof palexy.protobuf.GroupSpecification
                 * @instance
                 */
                Object.defineProperty(GroupSpecification.prototype, "kind", {
                    get: $util.oneOfGetter($oneOfFields = ["single", "composite", "empty"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new GroupSpecification instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {palexy.protobuf.IGroupSpecification=} [properties] Properties to set
                 * @returns {palexy.protobuf.GroupSpecification} GroupSpecification instance
                 */
                GroupSpecification.create = function create(properties) {
                    return new GroupSpecification(properties);
                };
    
                /**
                 * Encodes the specified GroupSpecification message. Does not implicitly {@link palexy.protobuf.GroupSpecification.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {palexy.protobuf.IGroupSpecification} message GroupSpecification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GroupSpecification.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.single != null && Object.hasOwnProperty.call(message, "single"))
                        $root.palexy.protobuf.GroupSpecification.SingleNode.encode(message.single, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.composite != null && Object.hasOwnProperty.call(message, "composite"))
                        $root.palexy.protobuf.GroupSpecification.CompositeNode.encode(message.composite, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.empty != null && Object.hasOwnProperty.call(message, "empty"))
                        $root.palexy.protobuf.GroupSpecification.EmptyNode.encode(message.empty, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified GroupSpecification message, length delimited. Does not implicitly {@link palexy.protobuf.GroupSpecification.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {palexy.protobuf.IGroupSpecification} message GroupSpecification message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GroupSpecification.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a GroupSpecification message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.GroupSpecification} GroupSpecification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GroupSpecification.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.GroupSpecification();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.single = $root.palexy.protobuf.GroupSpecification.SingleNode.decode(reader, reader.uint32());
                            break;
                        case 2:
                            message.composite = $root.palexy.protobuf.GroupSpecification.CompositeNode.decode(reader, reader.uint32());
                            break;
                        case 3:
                            message.empty = $root.palexy.protobuf.GroupSpecification.EmptyNode.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a GroupSpecification message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.GroupSpecification} GroupSpecification
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GroupSpecification.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a GroupSpecification message.
                 * @function verify
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GroupSpecification.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.single != null && message.hasOwnProperty("single")) {
                        properties.kind = 1;
                        {
                            var error = $root.palexy.protobuf.GroupSpecification.SingleNode.verify(message.single);
                            if (error)
                                return "single." + error;
                        }
                    }
                    if (message.composite != null && message.hasOwnProperty("composite")) {
                        if (properties.kind === 1)
                            return "kind: multiple values";
                        properties.kind = 1;
                        {
                            var error = $root.palexy.protobuf.GroupSpecification.CompositeNode.verify(message.composite);
                            if (error)
                                return "composite." + error;
                        }
                    }
                    if (message.empty != null && message.hasOwnProperty("empty")) {
                        if (properties.kind === 1)
                            return "kind: multiple values";
                        properties.kind = 1;
                        {
                            var error = $root.palexy.protobuf.GroupSpecification.EmptyNode.verify(message.empty);
                            if (error)
                                return "empty." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a GroupSpecification message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.GroupSpecification} GroupSpecification
                 */
                GroupSpecification.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.GroupSpecification)
                        return object;
                    var message = new $root.palexy.protobuf.GroupSpecification();
                    if (object.single != null) {
                        if (typeof object.single !== "object")
                            throw TypeError(".palexy.protobuf.GroupSpecification.single: object expected");
                        message.single = $root.palexy.protobuf.GroupSpecification.SingleNode.fromObject(object.single);
                    }
                    if (object.composite != null) {
                        if (typeof object.composite !== "object")
                            throw TypeError(".palexy.protobuf.GroupSpecification.composite: object expected");
                        message.composite = $root.palexy.protobuf.GroupSpecification.CompositeNode.fromObject(object.composite);
                    }
                    if (object.empty != null) {
                        if (typeof object.empty !== "object")
                            throw TypeError(".palexy.protobuf.GroupSpecification.empty: object expected");
                        message.empty = $root.palexy.protobuf.GroupSpecification.EmptyNode.fromObject(object.empty);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a GroupSpecification message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.GroupSpecification
                 * @static
                 * @param {palexy.protobuf.GroupSpecification} message GroupSpecification
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GroupSpecification.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (message.single != null && message.hasOwnProperty("single")) {
                        object.single = $root.palexy.protobuf.GroupSpecification.SingleNode.toObject(message.single, options);
                        if (options.oneofs)
                            object.kind = "single";
                    }
                    if (message.composite != null && message.hasOwnProperty("composite")) {
                        object.composite = $root.palexy.protobuf.GroupSpecification.CompositeNode.toObject(message.composite, options);
                        if (options.oneofs)
                            object.kind = "composite";
                    }
                    if (message.empty != null && message.hasOwnProperty("empty")) {
                        object.empty = $root.palexy.protobuf.GroupSpecification.EmptyNode.toObject(message.empty, options);
                        if (options.oneofs)
                            object.kind = "empty";
                    }
                    return object;
                };
    
                /**
                 * Converts this GroupSpecification to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.GroupSpecification
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GroupSpecification.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                GroupSpecification.EmptyNode = (function() {
    
                    /**
                     * Properties of an EmptyNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @interface IEmptyNode
                     * @property {boolean|null} [matchedNone] EmptyNode matchedNone
                     */
    
                    /**
                     * Constructs a new EmptyNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @classdesc Represents an EmptyNode.
                     * @implements IEmptyNode
                     * @constructor
                     * @param {palexy.protobuf.GroupSpecification.IEmptyNode=} [properties] Properties to set
                     */
                    function EmptyNode(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EmptyNode matchedNone.
                     * @member {boolean} matchedNone
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @instance
                     */
                    EmptyNode.prototype.matchedNone = false;
    
                    /**
                     * Creates a new EmptyNode instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.IEmptyNode=} [properties] Properties to set
                     * @returns {palexy.protobuf.GroupSpecification.EmptyNode} EmptyNode instance
                     */
                    EmptyNode.create = function create(properties) {
                        return new EmptyNode(properties);
                    };
    
                    /**
                     * Encodes the specified EmptyNode message. Does not implicitly {@link palexy.protobuf.GroupSpecification.EmptyNode.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.IEmptyNode} message EmptyNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmptyNode.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.matchedNone != null && Object.hasOwnProperty.call(message, "matchedNone"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.matchedNone);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EmptyNode message, length delimited. Does not implicitly {@link palexy.protobuf.GroupSpecification.EmptyNode.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.IEmptyNode} message EmptyNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EmptyNode.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EmptyNode message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.GroupSpecification.EmptyNode} EmptyNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmptyNode.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.GroupSpecification.EmptyNode();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.matchedNone = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EmptyNode message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.GroupSpecification.EmptyNode} EmptyNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EmptyNode.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EmptyNode message.
                     * @function verify
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EmptyNode.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.matchedNone != null && message.hasOwnProperty("matchedNone"))
                            if (typeof message.matchedNone !== "boolean")
                                return "matchedNone: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an EmptyNode message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.GroupSpecification.EmptyNode} EmptyNode
                     */
                    EmptyNode.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.GroupSpecification.EmptyNode)
                            return object;
                        var message = new $root.palexy.protobuf.GroupSpecification.EmptyNode();
                        if (object.matchedNone != null)
                            message.matchedNone = Boolean(object.matchedNone);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EmptyNode message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.EmptyNode} message EmptyNode
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EmptyNode.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.matchedNone = false;
                        if (message.matchedNone != null && message.hasOwnProperty("matchedNone"))
                            object.matchedNone = message.matchedNone;
                        return object;
                    };
    
                    /**
                     * Converts this EmptyNode to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.GroupSpecification.EmptyNode
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EmptyNode.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EmptyNode;
                })();
    
                GroupSpecification.SingleNode = (function() {
    
                    /**
                     * Properties of a SingleNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @interface ISingleNode
                     * @property {string|null} [field] SingleNode field
                     * @property {string|null} [operator] SingleNode operator
                     * @property {Array.<string>|null} [values] SingleNode values
                     * @property {boolean|null} [isNegation] SingleNode isNegation
                     * @property {Object.<string,string>|null} [params] SingleNode params
                     */
    
                    /**
                     * Constructs a new SingleNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @classdesc Represents a SingleNode.
                     * @implements ISingleNode
                     * @constructor
                     * @param {palexy.protobuf.GroupSpecification.ISingleNode=} [properties] Properties to set
                     */
                    function SingleNode(properties) {
                        this.values = [];
                        this.params = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SingleNode field.
                     * @member {string} field
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     */
                    SingleNode.prototype.field = "";
    
                    /**
                     * SingleNode operator.
                     * @member {string} operator
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     */
                    SingleNode.prototype.operator = "";
    
                    /**
                     * SingleNode values.
                     * @member {Array.<string>} values
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     */
                    SingleNode.prototype.values = $util.emptyArray;
    
                    /**
                     * SingleNode isNegation.
                     * @member {boolean} isNegation
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     */
                    SingleNode.prototype.isNegation = false;
    
                    /**
                     * SingleNode params.
                     * @member {Object.<string,string>} params
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     */
                    SingleNode.prototype.params = $util.emptyObject;
    
                    /**
                     * Creates a new SingleNode instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ISingleNode=} [properties] Properties to set
                     * @returns {palexy.protobuf.GroupSpecification.SingleNode} SingleNode instance
                     */
                    SingleNode.create = function create(properties) {
                        return new SingleNode(properties);
                    };
    
                    /**
                     * Encodes the specified SingleNode message. Does not implicitly {@link palexy.protobuf.GroupSpecification.SingleNode.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ISingleNode} message SingleNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SingleNode.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.field);
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.operator);
                        if (message.values != null && message.values.length)
                            for (var i = 0; i < message.values.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.values[i]);
                        if (message.isNegation != null && Object.hasOwnProperty.call(message, "isNegation"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isNegation);
                        if (message.params != null && Object.hasOwnProperty.call(message, "params"))
                            for (var keys = Object.keys(message.params), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.params[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SingleNode message, length delimited. Does not implicitly {@link palexy.protobuf.GroupSpecification.SingleNode.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ISingleNode} message SingleNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SingleNode.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SingleNode message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.GroupSpecification.SingleNode} SingleNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SingleNode.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.GroupSpecification.SingleNode(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.field = reader.string();
                                break;
                            case 2:
                                message.operator = reader.string();
                                break;
                            case 3:
                                if (!(message.values && message.values.length))
                                    message.values = [];
                                message.values.push(reader.string());
                                break;
                            case 4:
                                message.isNegation = reader.bool();
                                break;
                            case 5:
                                if (message.params === $util.emptyObject)
                                    message.params = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.params[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SingleNode message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.GroupSpecification.SingleNode} SingleNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SingleNode.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SingleNode message.
                     * @function verify
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SingleNode.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.field != null && message.hasOwnProperty("field"))
                            if (!$util.isString(message.field))
                                return "field: string expected";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            if (!$util.isString(message.operator))
                                return "operator: string expected";
                        if (message.values != null && message.hasOwnProperty("values")) {
                            if (!Array.isArray(message.values))
                                return "values: array expected";
                            for (var i = 0; i < message.values.length; ++i)
                                if (!$util.isString(message.values[i]))
                                    return "values: string[] expected";
                        }
                        if (message.isNegation != null && message.hasOwnProperty("isNegation"))
                            if (typeof message.isNegation !== "boolean")
                                return "isNegation: boolean expected";
                        if (message.params != null && message.hasOwnProperty("params")) {
                            if (!$util.isObject(message.params))
                                return "params: object expected";
                            var key = Object.keys(message.params);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.params[key[i]]))
                                    return "params: string{k:string} expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SingleNode message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.GroupSpecification.SingleNode} SingleNode
                     */
                    SingleNode.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.GroupSpecification.SingleNode)
                            return object;
                        var message = new $root.palexy.protobuf.GroupSpecification.SingleNode();
                        if (object.field != null)
                            message.field = String(object.field);
                        if (object.operator != null)
                            message.operator = String(object.operator);
                        if (object.values) {
                            if (!Array.isArray(object.values))
                                throw TypeError(".palexy.protobuf.GroupSpecification.SingleNode.values: array expected");
                            message.values = [];
                            for (var i = 0; i < object.values.length; ++i)
                                message.values[i] = String(object.values[i]);
                        }
                        if (object.isNegation != null)
                            message.isNegation = Boolean(object.isNegation);
                        if (object.params) {
                            if (typeof object.params !== "object")
                                throw TypeError(".palexy.protobuf.GroupSpecification.SingleNode.params: object expected");
                            message.params = {};
                            for (var keys = Object.keys(object.params), i = 0; i < keys.length; ++i)
                                message.params[keys[i]] = String(object.params[keys[i]]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SingleNode message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.SingleNode} message SingleNode
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SingleNode.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.values = [];
                        if (options.objects || options.defaults)
                            object.params = {};
                        if (options.defaults) {
                            object.field = "";
                            object.operator = "";
                            object.isNegation = false;
                        }
                        if (message.field != null && message.hasOwnProperty("field"))
                            object.field = message.field;
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = message.operator;
                        if (message.values && message.values.length) {
                            object.values = [];
                            for (var j = 0; j < message.values.length; ++j)
                                object.values[j] = message.values[j];
                        }
                        if (message.isNegation != null && message.hasOwnProperty("isNegation"))
                            object.isNegation = message.isNegation;
                        var keys2;
                        if (message.params && (keys2 = Object.keys(message.params)).length) {
                            object.params = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.params[keys2[j]] = message.params[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SingleNode to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.GroupSpecification.SingleNode
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SingleNode.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SingleNode;
                })();
    
                GroupSpecification.CompositeNode = (function() {
    
                    /**
                     * Properties of a CompositeNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @interface ICompositeNode
                     * @property {string|null} [operator] CompositeNode operator
                     * @property {Array.<palexy.protobuf.IGroupSpecification>|null} [children] CompositeNode children
                     */
    
                    /**
                     * Constructs a new CompositeNode.
                     * @memberof palexy.protobuf.GroupSpecification
                     * @classdesc Represents a CompositeNode.
                     * @implements ICompositeNode
                     * @constructor
                     * @param {palexy.protobuf.GroupSpecification.ICompositeNode=} [properties] Properties to set
                     */
                    function CompositeNode(properties) {
                        this.children = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompositeNode operator.
                     * @member {string} operator
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @instance
                     */
                    CompositeNode.prototype.operator = "";
    
                    /**
                     * CompositeNode children.
                     * @member {Array.<palexy.protobuf.IGroupSpecification>} children
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @instance
                     */
                    CompositeNode.prototype.children = $util.emptyArray;
    
                    /**
                     * Creates a new CompositeNode instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ICompositeNode=} [properties] Properties to set
                     * @returns {palexy.protobuf.GroupSpecification.CompositeNode} CompositeNode instance
                     */
                    CompositeNode.create = function create(properties) {
                        return new CompositeNode(properties);
                    };
    
                    /**
                     * Encodes the specified CompositeNode message. Does not implicitly {@link palexy.protobuf.GroupSpecification.CompositeNode.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ICompositeNode} message CompositeNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompositeNode.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.operator);
                        if (message.children != null && message.children.length)
                            for (var i = 0; i < message.children.length; ++i)
                                $root.palexy.protobuf.GroupSpecification.encode(message.children[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompositeNode message, length delimited. Does not implicitly {@link palexy.protobuf.GroupSpecification.CompositeNode.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.ICompositeNode} message CompositeNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompositeNode.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompositeNode message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.GroupSpecification.CompositeNode} CompositeNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompositeNode.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.GroupSpecification.CompositeNode();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.operator = reader.string();
                                break;
                            case 2:
                                if (!(message.children && message.children.length))
                                    message.children = [];
                                message.children.push($root.palexy.protobuf.GroupSpecification.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompositeNode message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.GroupSpecification.CompositeNode} CompositeNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompositeNode.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompositeNode message.
                     * @function verify
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompositeNode.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            if (!$util.isString(message.operator))
                                return "operator: string expected";
                        if (message.children != null && message.hasOwnProperty("children")) {
                            if (!Array.isArray(message.children))
                                return "children: array expected";
                            for (var i = 0; i < message.children.length; ++i) {
                                var error = $root.palexy.protobuf.GroupSpecification.verify(message.children[i]);
                                if (error)
                                    return "children." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CompositeNode message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.GroupSpecification.CompositeNode} CompositeNode
                     */
                    CompositeNode.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.GroupSpecification.CompositeNode)
                            return object;
                        var message = new $root.palexy.protobuf.GroupSpecification.CompositeNode();
                        if (object.operator != null)
                            message.operator = String(object.operator);
                        if (object.children) {
                            if (!Array.isArray(object.children))
                                throw TypeError(".palexy.protobuf.GroupSpecification.CompositeNode.children: array expected");
                            message.children = [];
                            for (var i = 0; i < object.children.length; ++i) {
                                if (typeof object.children[i] !== "object")
                                    throw TypeError(".palexy.protobuf.GroupSpecification.CompositeNode.children: object expected");
                                message.children[i] = $root.palexy.protobuf.GroupSpecification.fromObject(object.children[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompositeNode message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @static
                     * @param {palexy.protobuf.GroupSpecification.CompositeNode} message CompositeNode
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompositeNode.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.children = [];
                        if (options.defaults)
                            object.operator = "";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = message.operator;
                        if (message.children && message.children.length) {
                            object.children = [];
                            for (var j = 0; j < message.children.length; ++j)
                                object.children[j] = $root.palexy.protobuf.GroupSpecification.toObject(message.children[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CompositeNode to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.GroupSpecification.CompositeNode
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompositeNode.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompositeNode;
                })();
    
                return GroupSpecification;
            })();
    
            protobuf.MatchingGroup = (function() {
    
                /**
                 * Properties of a MatchingGroup.
                 * @memberof palexy.protobuf
                 * @interface IMatchingGroup
                 * @property {number|null} [id] MatchingGroup id
                 * @property {number|null} [companyId] MatchingGroup companyId
                 * @property {palexy.protobuf.MatchingGroup.GroupType|null} [groupType] MatchingGroup groupType
                 * @property {string|null} [name] MatchingGroup name
                 * @property {palexy.protobuf.IGroupSpecification|null} [specification] MatchingGroup specification
                 * @property {number|null} [memberCount] MatchingGroup memberCount
                 * @property {boolean|null} [isSyncing] MatchingGroup isSyncing
                 * @property {number|null} [createTimeMs] MatchingGroup createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] MatchingGroup lastUpdateTimeMs
                 */
    
                /**
                 * Constructs a new MatchingGroup.
                 * @memberof palexy.protobuf
                 * @classdesc Represents a MatchingGroup.
                 * @implements IMatchingGroup
                 * @constructor
                 * @param {palexy.protobuf.IMatchingGroup=} [properties] Properties to set
                 */
                function MatchingGroup(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MatchingGroup id.
                 * @member {number} id
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * MatchingGroup companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * MatchingGroup groupType.
                 * @member {palexy.protobuf.MatchingGroup.GroupType} groupType
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.groupType = 0;
    
                /**
                 * MatchingGroup name.
                 * @member {string} name
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.name = "";
    
                /**
                 * MatchingGroup specification.
                 * @member {palexy.protobuf.IGroupSpecification|null|undefined} specification
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.specification = null;
    
                /**
                 * MatchingGroup memberCount.
                 * @member {number} memberCount
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.memberCount = 0;
    
                /**
                 * MatchingGroup isSyncing.
                 * @member {boolean} isSyncing
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.isSyncing = false;
    
                /**
                 * MatchingGroup createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * MatchingGroup lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 */
                MatchingGroup.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new MatchingGroup instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {palexy.protobuf.IMatchingGroup=} [properties] Properties to set
                 * @returns {palexy.protobuf.MatchingGroup} MatchingGroup instance
                 */
                MatchingGroup.create = function create(properties) {
                    return new MatchingGroup(properties);
                };
    
                /**
                 * Encodes the specified MatchingGroup message. Does not implicitly {@link palexy.protobuf.MatchingGroup.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {palexy.protobuf.IMatchingGroup} message MatchingGroup message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MatchingGroup.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                    if (message.groupType != null && Object.hasOwnProperty.call(message, "groupType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.groupType);
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                    if (message.specification != null && Object.hasOwnProperty.call(message, "specification"))
                        $root.palexy.protobuf.GroupSpecification.encode(message.specification, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.memberCount != null && Object.hasOwnProperty.call(message, "memberCount"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.memberCount);
                    if (message.isSyncing != null && Object.hasOwnProperty.call(message, "isSyncing"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isSyncing);
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified MatchingGroup message, length delimited. Does not implicitly {@link palexy.protobuf.MatchingGroup.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {palexy.protobuf.IMatchingGroup} message MatchingGroup message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MatchingGroup.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MatchingGroup message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.MatchingGroup} MatchingGroup
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MatchingGroup.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.MatchingGroup();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.companyId = reader.int64();
                            break;
                        case 3:
                            message.groupType = reader.int32();
                            break;
                        case 4:
                            message.name = reader.string();
                            break;
                        case 5:
                            message.specification = $root.palexy.protobuf.GroupSpecification.decode(reader, reader.uint32());
                            break;
                        case 6:
                            message.memberCount = reader.int32();
                            break;
                        case 7:
                            message.isSyncing = reader.bool();
                            break;
                        case 8:
                            message.createTimeMs = reader.int64();
                            break;
                        case 9:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MatchingGroup message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.MatchingGroup} MatchingGroup
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MatchingGroup.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MatchingGroup message.
                 * @function verify
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MatchingGroup.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.groupType != null && message.hasOwnProperty("groupType"))
                        switch (message.groupType) {
                        default:
                            return "groupType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.specification != null && message.hasOwnProperty("specification")) {
                        var error = $root.palexy.protobuf.GroupSpecification.verify(message.specification);
                        if (error)
                            return "specification." + error;
                    }
                    if (message.memberCount != null && message.hasOwnProperty("memberCount"))
                        if (!$util.isInteger(message.memberCount))
                            return "memberCount: integer expected";
                    if (message.isSyncing != null && message.hasOwnProperty("isSyncing"))
                        if (typeof message.isSyncing !== "boolean")
                            return "isSyncing: boolean expected";
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a MatchingGroup message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.MatchingGroup} MatchingGroup
                 */
                MatchingGroup.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.MatchingGroup)
                        return object;
                    var message = new $root.palexy.protobuf.MatchingGroup();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    switch (object.groupType) {
                    case "GROUP_TYPE_UNKNOWN":
                    case 0:
                        message.groupType = 0;
                        break;
                    case "STATIC":
                    case 1:
                        message.groupType = 1;
                        break;
                    case "DYNAMIC":
                    case 2:
                        message.groupType = 2;
                        break;
                    }
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.specification != null) {
                        if (typeof object.specification !== "object")
                            throw TypeError(".palexy.protobuf.MatchingGroup.specification: object expected");
                        message.specification = $root.palexy.protobuf.GroupSpecification.fromObject(object.specification);
                    }
                    if (object.memberCount != null)
                        message.memberCount = object.memberCount | 0;
                    if (object.isSyncing != null)
                        message.isSyncing = Boolean(object.isSyncing);
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from a MatchingGroup message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.MatchingGroup
                 * @static
                 * @param {palexy.protobuf.MatchingGroup} message MatchingGroup
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MatchingGroup.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        object.groupType = options.enums === String ? "GROUP_TYPE_UNKNOWN" : 0;
                        object.name = "";
                        object.specification = null;
                        object.memberCount = 0;
                        object.isSyncing = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.groupType != null && message.hasOwnProperty("groupType"))
                        object.groupType = options.enums === String ? $root.palexy.protobuf.MatchingGroup.GroupType[message.groupType] : message.groupType;
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.specification != null && message.hasOwnProperty("specification"))
                        object.specification = $root.palexy.protobuf.GroupSpecification.toObject(message.specification, options);
                    if (message.memberCount != null && message.hasOwnProperty("memberCount"))
                        object.memberCount = message.memberCount;
                    if (message.isSyncing != null && message.hasOwnProperty("isSyncing"))
                        object.isSyncing = message.isSyncing;
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    return object;
                };
    
                /**
                 * Converts this MatchingGroup to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.MatchingGroup
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MatchingGroup.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * GroupType enum.
                 * @name palexy.protobuf.MatchingGroup.GroupType
                 * @enum {number}
                 * @property {number} GROUP_TYPE_UNKNOWN=0 GROUP_TYPE_UNKNOWN value
                 * @property {number} STATIC=1 STATIC value
                 * @property {number} DYNAMIC=2 DYNAMIC value
                 */
                MatchingGroup.GroupType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "GROUP_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "STATIC"] = 1;
                    values[valuesById[2] = "DYNAMIC"] = 2;
                    return values;
                })();
    
                return MatchingGroup;
            })();
    
            /**
             * AvailabilityScope enum.
             * @name palexy.protobuf.AvailabilityScope
             * @enum {number}
             * @property {number} AVAILABILITY_SCOPE_UNSPECIFIED=0 AVAILABILITY_SCOPE_UNSPECIFIED value
             * @property {number} THIS=1 THIS value
             * @property {number} THIS_AND_FOLLOWING=2 THIS_AND_FOLLOWING value
             * @property {number} ALL=3 ALL value
             */
            protobuf.AvailabilityScope = (function() {
                var valuesById = {}, values = Object.create(valuesById);
                values[valuesById[0] = "AVAILABILITY_SCOPE_UNSPECIFIED"] = 0;
                values[valuesById[1] = "THIS"] = 1;
                values[valuesById[2] = "THIS_AND_FOLLOWING"] = 2;
                values[valuesById[3] = "ALL"] = 3;
                return values;
            })();
    
            protobuf.timeoff = (function() {
    
                /**
                 * Namespace timeoff.
                 * @memberof palexy.protobuf
                 * @namespace
                 */
                var timeoff = {};
    
                timeoff.TimeOffType = (function() {
    
                    /**
                     * Properties of a TimeOffType.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffType
                     * @property {number|null} [id] TimeOffType id
                     * @property {number|null} [companyId] TimeOffType companyId
                     * @property {string|null} [name] TimeOffType name
                     * @property {string|null} [shortName] TimeOffType shortName
                     * @property {string|null} [description] TimeOffType description
                     * @property {boolean|null} [isAllDay] TimeOffType isAllDay
                     * @property {number|null} [totalHours] TimeOffType totalHours
                     * @property {boolean|null} [isDisabled] TimeOffType isDisabled
                     * @property {palexy.protobuf.timeoff.TimeOffType.PaidType|null} [paidType] TimeOffType paidType
                     * @property {number|null} [createTimeMs] TimeOffType createTimeMs
                     * @property {number|null} [updateTimeMs] TimeOffType updateTimeMs
                     * @property {palexy.protobuf.timeoff.TimeOffType.TrackingUnit|null} [trackingUnit] TimeOffType trackingUnit
                     * @property {palexy.protobuf.timeoff.ResetType|null} [resetType] TimeOffType resetType
                     * @property {string|null} [resetDate] TimeOffType resetDate
                     * @property {palexy.protobuf.timeoff.RolloverType|null} [rolloverType] TimeOffType rolloverType
                     * @property {string|null} [rolloverEndDate] TimeOffType rolloverEndDate
                     * @property {Array.<palexy.protobuf.timeoff.ITimeOffAccrualRule>|null} [accrualRules] TimeOffType accrualRules
                     * @property {Array.<palexy.protobuf.timeoff.ITimeOffFixedRule>|null} [fixedRules] TimeOffType fixedRules
                     * @property {boolean|null} [applyToAllStaff] TimeOffType applyToAllStaff
                     * @property {boolean|null} [cannotCreateRequest] TimeOffType cannotCreateRequest
                     * @property {Array.<number>|null} [appliedStaffIds] TimeOffType appliedStaffIds
                     * @property {boolean|null} [isPublicHolidayTimeOff] TimeOffType isPublicHolidayTimeOff
                     * @property {boolean|null} [noBalanceTracking] TimeOffType noBalanceTracking
                     * @property {number|null} [matchingGroupId] TimeOffType matchingGroupId
                     * @property {number|null} [minimumIncrementHours] TimeOffType minimumIncrementHours
                     * @property {boolean|null} [requireComment] TimeOffType requireComment
                     */
    
                    /**
                     * Constructs a new TimeOffType.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffType.
                     * @implements ITimeOffType
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffType=} [properties] Properties to set
                     */
                    function TimeOffType(properties) {
                        this.accrualRules = [];
                        this.fixedRules = [];
                        this.appliedStaffIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffType id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffType companyId.
                     * @member {number} companyId
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffType name.
                     * @member {string} name
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.name = "";
    
                    /**
                     * TimeOffType shortName.
                     * @member {string} shortName
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.shortName = "";
    
                    /**
                     * TimeOffType description.
                     * @member {string} description
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.description = "";
    
                    /**
                     * TimeOffType isAllDay.
                     * @member {boolean} isAllDay
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.isAllDay = false;
    
                    /**
                     * TimeOffType totalHours.
                     * @member {number} totalHours
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.totalHours = 0;
    
                    /**
                     * TimeOffType isDisabled.
                     * @member {boolean} isDisabled
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.isDisabled = false;
    
                    /**
                     * TimeOffType paidType.
                     * @member {palexy.protobuf.timeoff.TimeOffType.PaidType} paidType
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.paidType = 0;
    
                    /**
                     * TimeOffType createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffType updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffType trackingUnit.
                     * @member {palexy.protobuf.timeoff.TimeOffType.TrackingUnit} trackingUnit
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.trackingUnit = 0;
    
                    /**
                     * TimeOffType resetType.
                     * @member {palexy.protobuf.timeoff.ResetType} resetType
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.resetType = 0;
    
                    /**
                     * TimeOffType resetDate.
                     * @member {string} resetDate
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.resetDate = "";
    
                    /**
                     * TimeOffType rolloverType.
                     * @member {palexy.protobuf.timeoff.RolloverType} rolloverType
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.rolloverType = 0;
    
                    /**
                     * TimeOffType rolloverEndDate.
                     * @member {string} rolloverEndDate
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.rolloverEndDate = "";
    
                    /**
                     * TimeOffType accrualRules.
                     * @member {Array.<palexy.protobuf.timeoff.ITimeOffAccrualRule>} accrualRules
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.accrualRules = $util.emptyArray;
    
                    /**
                     * TimeOffType fixedRules.
                     * @member {Array.<palexy.protobuf.timeoff.ITimeOffFixedRule>} fixedRules
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.fixedRules = $util.emptyArray;
    
                    /**
                     * TimeOffType applyToAllStaff.
                     * @member {boolean} applyToAllStaff
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.applyToAllStaff = false;
    
                    /**
                     * TimeOffType cannotCreateRequest.
                     * @member {boolean} cannotCreateRequest
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.cannotCreateRequest = false;
    
                    /**
                     * TimeOffType appliedStaffIds.
                     * @member {Array.<number>} appliedStaffIds
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.appliedStaffIds = $util.emptyArray;
    
                    /**
                     * TimeOffType isPublicHolidayTimeOff.
                     * @member {boolean} isPublicHolidayTimeOff
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.isPublicHolidayTimeOff = false;
    
                    /**
                     * TimeOffType noBalanceTracking.
                     * @member {boolean} noBalanceTracking
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.noBalanceTracking = false;
    
                    /**
                     * TimeOffType matchingGroupId.
                     * @member {number} matchingGroupId
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffType minimumIncrementHours.
                     * @member {number} minimumIncrementHours
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.minimumIncrementHours = 0;
    
                    /**
                     * TimeOffType requireComment.
                     * @member {boolean} requireComment
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     */
                    TimeOffType.prototype.requireComment = false;
    
                    /**
                     * Creates a new TimeOffType instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffType=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffType} TimeOffType instance
                     */
                    TimeOffType.create = function create(properties) {
                        return new TimeOffType(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffType message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffType.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffType} message TimeOffType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffType.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.shortName != null && Object.hasOwnProperty.call(message, "shortName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.shortName);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
                        if (message.isAllDay != null && Object.hasOwnProperty.call(message, "isAllDay"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isAllDay);
                        if (message.totalHours != null && Object.hasOwnProperty.call(message, "totalHours"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.totalHours);
                        if (message.isDisabled != null && Object.hasOwnProperty.call(message, "isDisabled"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isDisabled);
                        if (message.paidType != null && Object.hasOwnProperty.call(message, "paidType"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.paidType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.updateTimeMs);
                        if (message.trackingUnit != null && Object.hasOwnProperty.call(message, "trackingUnit"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.trackingUnit);
                        if (message.resetType != null && Object.hasOwnProperty.call(message, "resetType"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.resetType);
                        if (message.resetDate != null && Object.hasOwnProperty.call(message, "resetDate"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.resetDate);
                        if (message.rolloverType != null && Object.hasOwnProperty.call(message, "rolloverType"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.rolloverType);
                        if (message.rolloverEndDate != null && Object.hasOwnProperty.call(message, "rolloverEndDate"))
                            writer.uint32(/* id 16, wireType 2 =*/130).string(message.rolloverEndDate);
                        if (message.accrualRules != null && message.accrualRules.length)
                            for (var i = 0; i < message.accrualRules.length; ++i)
                                $root.palexy.protobuf.timeoff.TimeOffAccrualRule.encode(message.accrualRules[i], writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
                        if (message.fixedRules != null && message.fixedRules.length)
                            for (var i = 0; i < message.fixedRules.length; ++i)
                                $root.palexy.protobuf.timeoff.TimeOffFixedRule.encode(message.fixedRules[i], writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.applyToAllStaff != null && Object.hasOwnProperty.call(message, "applyToAllStaff"))
                            writer.uint32(/* id 19, wireType 0 =*/152).bool(message.applyToAllStaff);
                        if (message.cannotCreateRequest != null && Object.hasOwnProperty.call(message, "cannotCreateRequest"))
                            writer.uint32(/* id 20, wireType 0 =*/160).bool(message.cannotCreateRequest);
                        if (message.appliedStaffIds != null && message.appliedStaffIds.length) {
                            writer.uint32(/* id 21, wireType 2 =*/170).fork();
                            for (var i = 0; i < message.appliedStaffIds.length; ++i)
                                writer.int64(message.appliedStaffIds[i]);
                            writer.ldelim();
                        }
                        if (message.isPublicHolidayTimeOff != null && Object.hasOwnProperty.call(message, "isPublicHolidayTimeOff"))
                            writer.uint32(/* id 22, wireType 0 =*/176).bool(message.isPublicHolidayTimeOff);
                        if (message.noBalanceTracking != null && Object.hasOwnProperty.call(message, "noBalanceTracking"))
                            writer.uint32(/* id 23, wireType 0 =*/184).bool(message.noBalanceTracking);
                        if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int64(message.matchingGroupId);
                        if (message.minimumIncrementHours != null && Object.hasOwnProperty.call(message, "minimumIncrementHours"))
                            writer.uint32(/* id 25, wireType 1 =*/201).double(message.minimumIncrementHours);
                        if (message.requireComment != null && Object.hasOwnProperty.call(message, "requireComment"))
                            writer.uint32(/* id 26, wireType 0 =*/208).bool(message.requireComment);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffType message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffType.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffType} message TimeOffType message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffType.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffType message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffType} TimeOffType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffType.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffType();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.shortName = reader.string();
                                break;
                            case 5:
                                message.description = reader.string();
                                break;
                            case 6:
                                message.isAllDay = reader.bool();
                                break;
                            case 7:
                                message.totalHours = reader.int32();
                                break;
                            case 8:
                                message.isDisabled = reader.bool();
                                break;
                            case 9:
                                message.paidType = reader.int32();
                                break;
                            case 10:
                                message.createTimeMs = reader.int64();
                                break;
                            case 11:
                                message.updateTimeMs = reader.int64();
                                break;
                            case 12:
                                message.trackingUnit = reader.int32();
                                break;
                            case 13:
                                message.resetType = reader.int32();
                                break;
                            case 14:
                                message.resetDate = reader.string();
                                break;
                            case 15:
                                message.rolloverType = reader.int32();
                                break;
                            case 16:
                                message.rolloverEndDate = reader.string();
                                break;
                            case 17:
                                if (!(message.accrualRules && message.accrualRules.length))
                                    message.accrualRules = [];
                                message.accrualRules.push($root.palexy.protobuf.timeoff.TimeOffAccrualRule.decode(reader, reader.uint32()));
                                break;
                            case 18:
                                if (!(message.fixedRules && message.fixedRules.length))
                                    message.fixedRules = [];
                                message.fixedRules.push($root.palexy.protobuf.timeoff.TimeOffFixedRule.decode(reader, reader.uint32()));
                                break;
                            case 19:
                                message.applyToAllStaff = reader.bool();
                                break;
                            case 20:
                                message.cannotCreateRequest = reader.bool();
                                break;
                            case 21:
                                if (!(message.appliedStaffIds && message.appliedStaffIds.length))
                                    message.appliedStaffIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.appliedStaffIds.push(reader.int64());
                                } else
                                    message.appliedStaffIds.push(reader.int64());
                                break;
                            case 22:
                                message.isPublicHolidayTimeOff = reader.bool();
                                break;
                            case 23:
                                message.noBalanceTracking = reader.bool();
                                break;
                            case 24:
                                message.matchingGroupId = reader.int64();
                                break;
                            case 25:
                                message.minimumIncrementHours = reader.double();
                                break;
                            case 26:
                                message.requireComment = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffType message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffType} TimeOffType
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffType.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffType message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffType.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.shortName != null && message.hasOwnProperty("shortName"))
                            if (!$util.isString(message.shortName))
                                return "shortName: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                            if (typeof message.isAllDay !== "boolean")
                                return "isAllDay: boolean expected";
                        if (message.totalHours != null && message.hasOwnProperty("totalHours"))
                            if (!$util.isInteger(message.totalHours))
                                return "totalHours: integer expected";
                        if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                            if (typeof message.isDisabled !== "boolean")
                                return "isDisabled: boolean expected";
                        if (message.paidType != null && message.hasOwnProperty("paidType"))
                            switch (message.paidType) {
                            default:
                                return "paidType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        if (message.trackingUnit != null && message.hasOwnProperty("trackingUnit"))
                            switch (message.trackingUnit) {
                            default:
                                return "trackingUnit: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.resetType != null && message.hasOwnProperty("resetType"))
                            switch (message.resetType) {
                            default:
                                return "resetType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.resetDate != null && message.hasOwnProperty("resetDate"))
                            if (!$util.isString(message.resetDate))
                                return "resetDate: string expected";
                        if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                            switch (message.rolloverType) {
                            default:
                                return "rolloverType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.rolloverEndDate != null && message.hasOwnProperty("rolloverEndDate"))
                            if (!$util.isString(message.rolloverEndDate))
                                return "rolloverEndDate: string expected";
                        if (message.accrualRules != null && message.hasOwnProperty("accrualRules")) {
                            if (!Array.isArray(message.accrualRules))
                                return "accrualRules: array expected";
                            for (var i = 0; i < message.accrualRules.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.verify(message.accrualRules[i]);
                                if (error)
                                    return "accrualRules." + error;
                            }
                        }
                        if (message.fixedRules != null && message.hasOwnProperty("fixedRules")) {
                            if (!Array.isArray(message.fixedRules))
                                return "fixedRules: array expected";
                            for (var i = 0; i < message.fixedRules.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.TimeOffFixedRule.verify(message.fixedRules[i]);
                                if (error)
                                    return "fixedRules." + error;
                            }
                        }
                        if (message.applyToAllStaff != null && message.hasOwnProperty("applyToAllStaff"))
                            if (typeof message.applyToAllStaff !== "boolean")
                                return "applyToAllStaff: boolean expected";
                        if (message.cannotCreateRequest != null && message.hasOwnProperty("cannotCreateRequest"))
                            if (typeof message.cannotCreateRequest !== "boolean")
                                return "cannotCreateRequest: boolean expected";
                        if (message.appliedStaffIds != null && message.hasOwnProperty("appliedStaffIds")) {
                            if (!Array.isArray(message.appliedStaffIds))
                                return "appliedStaffIds: array expected";
                            for (var i = 0; i < message.appliedStaffIds.length; ++i)
                                if (!$util.isInteger(message.appliedStaffIds[i]) && !(message.appliedStaffIds[i] && $util.isInteger(message.appliedStaffIds[i].low) && $util.isInteger(message.appliedStaffIds[i].high)))
                                    return "appliedStaffIds: integer|Long[] expected";
                        }
                        if (message.isPublicHolidayTimeOff != null && message.hasOwnProperty("isPublicHolidayTimeOff"))
                            if (typeof message.isPublicHolidayTimeOff !== "boolean")
                                return "isPublicHolidayTimeOff: boolean expected";
                        if (message.noBalanceTracking != null && message.hasOwnProperty("noBalanceTracking"))
                            if (typeof message.noBalanceTracking !== "boolean")
                                return "noBalanceTracking: boolean expected";
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                                return "matchingGroupId: integer|Long expected";
                        if (message.minimumIncrementHours != null && message.hasOwnProperty("minimumIncrementHours"))
                            if (typeof message.minimumIncrementHours !== "number")
                                return "minimumIncrementHours: number expected";
                        if (message.requireComment != null && message.hasOwnProperty("requireComment"))
                            if (typeof message.requireComment !== "boolean")
                                return "requireComment: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffType message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffType} TimeOffType
                     */
                    TimeOffType.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffType)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffType();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.shortName != null)
                            message.shortName = String(object.shortName);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.isAllDay != null)
                            message.isAllDay = Boolean(object.isAllDay);
                        if (object.totalHours != null)
                            message.totalHours = object.totalHours | 0;
                        if (object.isDisabled != null)
                            message.isDisabled = Boolean(object.isDisabled);
                        switch (object.paidType) {
                        case "PAID":
                        case 0:
                            message.paidType = 0;
                            break;
                        case "UNPAID":
                        case 1:
                            message.paidType = 1;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        switch (object.trackingUnit) {
                        case "DAY":
                        case 0:
                            message.trackingUnit = 0;
                            break;
                        case "HOUR":
                        case 1:
                            message.trackingUnit = 1;
                            break;
                        }
                        switch (object.resetType) {
                        case "NONE_RESET_TYPE":
                        case 0:
                            message.resetType = 0;
                            break;
                        case "RESET_TO_ZERO":
                        case 1:
                            message.resetType = 1;
                            break;
                        case "RESET_TO_ENTITLEMENT":
                        case 2:
                            message.resetType = 2;
                            break;
                        }
                        if (object.resetDate != null)
                            message.resetDate = String(object.resetDate);
                        switch (object.rolloverType) {
                        case "NONE_ROLLOVER_TYPE":
                        case 0:
                            message.rolloverType = 0;
                            break;
                        case "ROLLOVER_ALL_CURRENT_BALANCE":
                        case 1:
                            message.rolloverType = 1;
                            break;
                        }
                        if (object.rolloverEndDate != null)
                            message.rolloverEndDate = String(object.rolloverEndDate);
                        if (object.accrualRules) {
                            if (!Array.isArray(object.accrualRules))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffType.accrualRules: array expected");
                            message.accrualRules = [];
                            for (var i = 0; i < object.accrualRules.length; ++i) {
                                if (typeof object.accrualRules[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffType.accrualRules: object expected");
                                message.accrualRules[i] = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.fromObject(object.accrualRules[i]);
                            }
                        }
                        if (object.fixedRules) {
                            if (!Array.isArray(object.fixedRules))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffType.fixedRules: array expected");
                            message.fixedRules = [];
                            for (var i = 0; i < object.fixedRules.length; ++i) {
                                if (typeof object.fixedRules[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffType.fixedRules: object expected");
                                message.fixedRules[i] = $root.palexy.protobuf.timeoff.TimeOffFixedRule.fromObject(object.fixedRules[i]);
                            }
                        }
                        if (object.applyToAllStaff != null)
                            message.applyToAllStaff = Boolean(object.applyToAllStaff);
                        if (object.cannotCreateRequest != null)
                            message.cannotCreateRequest = Boolean(object.cannotCreateRequest);
                        if (object.appliedStaffIds) {
                            if (!Array.isArray(object.appliedStaffIds))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffType.appliedStaffIds: array expected");
                            message.appliedStaffIds = [];
                            for (var i = 0; i < object.appliedStaffIds.length; ++i)
                                if ($util.Long)
                                    (message.appliedStaffIds[i] = $util.Long.fromValue(object.appliedStaffIds[i])).unsigned = false;
                                else if (typeof object.appliedStaffIds[i] === "string")
                                    message.appliedStaffIds[i] = parseInt(object.appliedStaffIds[i], 10);
                                else if (typeof object.appliedStaffIds[i] === "number")
                                    message.appliedStaffIds[i] = object.appliedStaffIds[i];
                                else if (typeof object.appliedStaffIds[i] === "object")
                                    message.appliedStaffIds[i] = new $util.LongBits(object.appliedStaffIds[i].low >>> 0, object.appliedStaffIds[i].high >>> 0).toNumber();
                        }
                        if (object.isPublicHolidayTimeOff != null)
                            message.isPublicHolidayTimeOff = Boolean(object.isPublicHolidayTimeOff);
                        if (object.noBalanceTracking != null)
                            message.noBalanceTracking = Boolean(object.noBalanceTracking);
                        if (object.matchingGroupId != null)
                            if ($util.Long)
                                (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                            else if (typeof object.matchingGroupId === "string")
                                message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                            else if (typeof object.matchingGroupId === "number")
                                message.matchingGroupId = object.matchingGroupId;
                            else if (typeof object.matchingGroupId === "object")
                                message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                        if (object.minimumIncrementHours != null)
                            message.minimumIncrementHours = Number(object.minimumIncrementHours);
                        if (object.requireComment != null)
                            message.requireComment = Boolean(object.requireComment);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffType message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffType} message TimeOffType
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffType.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.accrualRules = [];
                            object.fixedRules = [];
                            object.appliedStaffIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.shortName = "";
                            object.description = "";
                            object.isAllDay = false;
                            object.totalHours = 0;
                            object.isDisabled = false;
                            object.paidType = options.enums === String ? "PAID" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                            object.trackingUnit = options.enums === String ? "DAY" : 0;
                            object.resetType = options.enums === String ? "NONE_RESET_TYPE" : 0;
                            object.resetDate = "";
                            object.rolloverType = options.enums === String ? "NONE_ROLLOVER_TYPE" : 0;
                            object.rolloverEndDate = "";
                            object.applyToAllStaff = false;
                            object.cannotCreateRequest = false;
                            object.isPublicHolidayTimeOff = false;
                            object.noBalanceTracking = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.matchingGroupId = options.longs === String ? "0" : 0;
                            object.minimumIncrementHours = 0;
                            object.requireComment = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.shortName != null && message.hasOwnProperty("shortName"))
                            object.shortName = message.shortName;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.isAllDay != null && message.hasOwnProperty("isAllDay"))
                            object.isAllDay = message.isAllDay;
                        if (message.totalHours != null && message.hasOwnProperty("totalHours"))
                            object.totalHours = message.totalHours;
                        if (message.isDisabled != null && message.hasOwnProperty("isDisabled"))
                            object.isDisabled = message.isDisabled;
                        if (message.paidType != null && message.hasOwnProperty("paidType"))
                            object.paidType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffType.PaidType[message.paidType] : message.paidType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        if (message.trackingUnit != null && message.hasOwnProperty("trackingUnit"))
                            object.trackingUnit = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffType.TrackingUnit[message.trackingUnit] : message.trackingUnit;
                        if (message.resetType != null && message.hasOwnProperty("resetType"))
                            object.resetType = options.enums === String ? $root.palexy.protobuf.timeoff.ResetType[message.resetType] : message.resetType;
                        if (message.resetDate != null && message.hasOwnProperty("resetDate"))
                            object.resetDate = message.resetDate;
                        if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                            object.rolloverType = options.enums === String ? $root.palexy.protobuf.timeoff.RolloverType[message.rolloverType] : message.rolloverType;
                        if (message.rolloverEndDate != null && message.hasOwnProperty("rolloverEndDate"))
                            object.rolloverEndDate = message.rolloverEndDate;
                        if (message.accrualRules && message.accrualRules.length) {
                            object.accrualRules = [];
                            for (var j = 0; j < message.accrualRules.length; ++j)
                                object.accrualRules[j] = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.toObject(message.accrualRules[j], options);
                        }
                        if (message.fixedRules && message.fixedRules.length) {
                            object.fixedRules = [];
                            for (var j = 0; j < message.fixedRules.length; ++j)
                                object.fixedRules[j] = $root.palexy.protobuf.timeoff.TimeOffFixedRule.toObject(message.fixedRules[j], options);
                        }
                        if (message.applyToAllStaff != null && message.hasOwnProperty("applyToAllStaff"))
                            object.applyToAllStaff = message.applyToAllStaff;
                        if (message.cannotCreateRequest != null && message.hasOwnProperty("cannotCreateRequest"))
                            object.cannotCreateRequest = message.cannotCreateRequest;
                        if (message.appliedStaffIds && message.appliedStaffIds.length) {
                            object.appliedStaffIds = [];
                            for (var j = 0; j < message.appliedStaffIds.length; ++j)
                                if (typeof message.appliedStaffIds[j] === "number")
                                    object.appliedStaffIds[j] = options.longs === String ? String(message.appliedStaffIds[j]) : message.appliedStaffIds[j];
                                else
                                    object.appliedStaffIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.appliedStaffIds[j]) : options.longs === Number ? new $util.LongBits(message.appliedStaffIds[j].low >>> 0, message.appliedStaffIds[j].high >>> 0).toNumber() : message.appliedStaffIds[j];
                        }
                        if (message.isPublicHolidayTimeOff != null && message.hasOwnProperty("isPublicHolidayTimeOff"))
                            object.isPublicHolidayTimeOff = message.isPublicHolidayTimeOff;
                        if (message.noBalanceTracking != null && message.hasOwnProperty("noBalanceTracking"))
                            object.noBalanceTracking = message.noBalanceTracking;
                        if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                            if (typeof message.matchingGroupId === "number")
                                object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                            else
                                object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                        if (message.minimumIncrementHours != null && message.hasOwnProperty("minimumIncrementHours"))
                            object.minimumIncrementHours = options.json && !isFinite(message.minimumIncrementHours) ? String(message.minimumIncrementHours) : message.minimumIncrementHours;
                        if (message.requireComment != null && message.hasOwnProperty("requireComment"))
                            object.requireComment = message.requireComment;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffType to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffType
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffType.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * PaidType enum.
                     * @name palexy.protobuf.timeoff.TimeOffType.PaidType
                     * @enum {number}
                     * @property {number} PAID=0 PAID value
                     * @property {number} UNPAID=1 UNPAID value
                     */
                    TimeOffType.PaidType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PAID"] = 0;
                        values[valuesById[1] = "UNPAID"] = 1;
                        return values;
                    })();
    
                    /**
                     * TrackingUnit enum.
                     * @name palexy.protobuf.timeoff.TimeOffType.TrackingUnit
                     * @enum {number}
                     * @property {number} DAY=0 DAY value
                     * @property {number} HOUR=1 HOUR value
                     */
                    TimeOffType.TrackingUnit = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DAY"] = 0;
                        values[valuesById[1] = "HOUR"] = 1;
                        return values;
                    })();
    
                    return TimeOffType;
                })();
    
                /**
                 * ResetType enum.
                 * @name palexy.protobuf.timeoff.ResetType
                 * @enum {number}
                 * @property {number} NONE_RESET_TYPE=0 NONE_RESET_TYPE value
                 * @property {number} RESET_TO_ZERO=1 RESET_TO_ZERO value
                 * @property {number} RESET_TO_ENTITLEMENT=2 RESET_TO_ENTITLEMENT value
                 */
                timeoff.ResetType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "NONE_RESET_TYPE"] = 0;
                    values[valuesById[1] = "RESET_TO_ZERO"] = 1;
                    values[valuesById[2] = "RESET_TO_ENTITLEMENT"] = 2;
                    return values;
                })();
    
                /**
                 * RolloverType enum.
                 * @name palexy.protobuf.timeoff.RolloverType
                 * @enum {number}
                 * @property {number} NONE_ROLLOVER_TYPE=0 NONE_ROLLOVER_TYPE value
                 * @property {number} ROLLOVER_ALL_CURRENT_BALANCE=1 ROLLOVER_ALL_CURRENT_BALANCE value
                 */
                timeoff.RolloverType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "NONE_ROLLOVER_TYPE"] = 0;
                    values[valuesById[1] = "ROLLOVER_ALL_CURRENT_BALANCE"] = 1;
                    return values;
                })();
    
                timeoff.TimeOffAccrualRule = (function() {
    
                    /**
                     * Properties of a TimeOffAccrualRule.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffAccrualRule
                     * @property {number|null} [id] TimeOffAccrualRule id
                     * @property {number|null} [increaseAmount] TimeOffAccrualRule increaseAmount
                     * @property {palexy.streaming.v1.IProtoPeriod|null} [accrualIntervalPeriod] TimeOffAccrualRule accrualIntervalPeriod
                     * @property {palexy.streaming.v1.IProtoPeriod|null} [accrualDelayPeriod] TimeOffAccrualRule accrualDelayPeriod
                     * @property {palexy.streaming.v1.IProtoPeriod|null} [accrualLimitPeriod] TimeOffAccrualRule accrualLimitPeriod
                     * @property {number|null} [timeOffTypeId] TimeOffAccrualRule timeOffTypeId
                     * @property {number|null} [createTimeMs] TimeOffAccrualRule createTimeMs
                     * @property {number|null} [updateTimeMs] TimeOffAccrualRule updateTimeMs
                     */
    
                    /**
                     * Constructs a new TimeOffAccrualRule.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffAccrualRule.
                     * @implements ITimeOffAccrualRule
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffAccrualRule=} [properties] Properties to set
                     */
                    function TimeOffAccrualRule(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffAccrualRule id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffAccrualRule increaseAmount.
                     * @member {number} increaseAmount
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.increaseAmount = 0;
    
                    /**
                     * TimeOffAccrualRule accrualIntervalPeriod.
                     * @member {palexy.streaming.v1.IProtoPeriod|null|undefined} accrualIntervalPeriod
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.accrualIntervalPeriod = null;
    
                    /**
                     * TimeOffAccrualRule accrualDelayPeriod.
                     * @member {palexy.streaming.v1.IProtoPeriod|null|undefined} accrualDelayPeriod
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.accrualDelayPeriod = null;
    
                    /**
                     * TimeOffAccrualRule accrualLimitPeriod.
                     * @member {palexy.streaming.v1.IProtoPeriod|null|undefined} accrualLimitPeriod
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.accrualLimitPeriod = null;
    
                    /**
                     * TimeOffAccrualRule timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffAccrualRule createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffAccrualRule updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     */
                    TimeOffAccrualRule.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TimeOffAccrualRule instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffAccrualRule=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffAccrualRule} TimeOffAccrualRule instance
                     */
                    TimeOffAccrualRule.create = function create(properties) {
                        return new TimeOffAccrualRule(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffAccrualRule message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffAccrualRule.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffAccrualRule} message TimeOffAccrualRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffAccrualRule.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.increaseAmount != null && Object.hasOwnProperty.call(message, "increaseAmount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.increaseAmount);
                        if (message.accrualIntervalPeriod != null && Object.hasOwnProperty.call(message, "accrualIntervalPeriod"))
                            $root.palexy.streaming.v1.ProtoPeriod.encode(message.accrualIntervalPeriod, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.accrualDelayPeriod != null && Object.hasOwnProperty.call(message, "accrualDelayPeriod"))
                            $root.palexy.streaming.v1.ProtoPeriod.encode(message.accrualDelayPeriod, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.accrualLimitPeriod != null && Object.hasOwnProperty.call(message, "accrualLimitPeriod"))
                            $root.palexy.streaming.v1.ProtoPeriod.encode(message.accrualLimitPeriod, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.timeOffTypeId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffAccrualRule message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffAccrualRule.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffAccrualRule} message TimeOffAccrualRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffAccrualRule.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffAccrualRule message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffAccrualRule} TimeOffAccrualRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffAccrualRule.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffAccrualRule();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.increaseAmount = reader.double();
                                break;
                            case 3:
                                message.accrualIntervalPeriod = $root.palexy.streaming.v1.ProtoPeriod.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.accrualDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.accrualLimitPeriod = $root.palexy.streaming.v1.ProtoPeriod.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffAccrualRule message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffAccrualRule} TimeOffAccrualRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffAccrualRule.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffAccrualRule message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffAccrualRule.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.increaseAmount != null && message.hasOwnProperty("increaseAmount"))
                            if (typeof message.increaseAmount !== "number")
                                return "increaseAmount: number expected";
                        if (message.accrualIntervalPeriod != null && message.hasOwnProperty("accrualIntervalPeriod")) {
                            var error = $root.palexy.streaming.v1.ProtoPeriod.verify(message.accrualIntervalPeriod);
                            if (error)
                                return "accrualIntervalPeriod." + error;
                        }
                        if (message.accrualDelayPeriod != null && message.hasOwnProperty("accrualDelayPeriod")) {
                            var error = $root.palexy.streaming.v1.ProtoPeriod.verify(message.accrualDelayPeriod);
                            if (error)
                                return "accrualDelayPeriod." + error;
                        }
                        if (message.accrualLimitPeriod != null && message.hasOwnProperty("accrualLimitPeriod")) {
                            var error = $root.palexy.streaming.v1.ProtoPeriod.verify(message.accrualLimitPeriod);
                            if (error)
                                return "accrualLimitPeriod." + error;
                        }
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffAccrualRule message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffAccrualRule} TimeOffAccrualRule
                     */
                    TimeOffAccrualRule.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffAccrualRule)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffAccrualRule();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.increaseAmount != null)
                            message.increaseAmount = Number(object.increaseAmount);
                        if (object.accrualIntervalPeriod != null) {
                            if (typeof object.accrualIntervalPeriod !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffAccrualRule.accrualIntervalPeriod: object expected");
                            message.accrualIntervalPeriod = $root.palexy.streaming.v1.ProtoPeriod.fromObject(object.accrualIntervalPeriod);
                        }
                        if (object.accrualDelayPeriod != null) {
                            if (typeof object.accrualDelayPeriod !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffAccrualRule.accrualDelayPeriod: object expected");
                            message.accrualDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.fromObject(object.accrualDelayPeriod);
                        }
                        if (object.accrualLimitPeriod != null) {
                            if (typeof object.accrualLimitPeriod !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffAccrualRule.accrualLimitPeriod: object expected");
                            message.accrualLimitPeriod = $root.palexy.streaming.v1.ProtoPeriod.fromObject(object.accrualLimitPeriod);
                        }
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffAccrualRule message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffAccrualRule} message TimeOffAccrualRule
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffAccrualRule.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.increaseAmount = 0;
                            object.accrualIntervalPeriod = null;
                            object.accrualDelayPeriod = null;
                            object.accrualLimitPeriod = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.increaseAmount != null && message.hasOwnProperty("increaseAmount"))
                            object.increaseAmount = options.json && !isFinite(message.increaseAmount) ? String(message.increaseAmount) : message.increaseAmount;
                        if (message.accrualIntervalPeriod != null && message.hasOwnProperty("accrualIntervalPeriod"))
                            object.accrualIntervalPeriod = $root.palexy.streaming.v1.ProtoPeriod.toObject(message.accrualIntervalPeriod, options);
                        if (message.accrualDelayPeriod != null && message.hasOwnProperty("accrualDelayPeriod"))
                            object.accrualDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.toObject(message.accrualDelayPeriod, options);
                        if (message.accrualLimitPeriod != null && message.hasOwnProperty("accrualLimitPeriod"))
                            object.accrualLimitPeriod = $root.palexy.streaming.v1.ProtoPeriod.toObject(message.accrualLimitPeriod, options);
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffAccrualRule to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffAccrualRule
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffAccrualRule.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeOffAccrualRule;
                })();
    
                timeoff.TimeOffFixedRule = (function() {
    
                    /**
                     * Properties of a TimeOffFixedRule.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffFixedRule
                     * @property {number|null} [id] TimeOffFixedRule id
                     * @property {number|null} [increaseAmount] TimeOffFixedRule increaseAmount
                     * @property {palexy.streaming.v1.IProtoPeriod|null} [releaseDelayPeriod] TimeOffFixedRule releaseDelayPeriod
                     * @property {number|null} [timeOffTypeId] TimeOffFixedRule timeOffTypeId
                     * @property {number|null} [createTimeMs] TimeOffFixedRule createTimeMs
                     * @property {number|null} [updateTimeMs] TimeOffFixedRule updateTimeMs
                     */
    
                    /**
                     * Constructs a new TimeOffFixedRule.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffFixedRule.
                     * @implements ITimeOffFixedRule
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffFixedRule=} [properties] Properties to set
                     */
                    function TimeOffFixedRule(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffFixedRule id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffFixedRule increaseAmount.
                     * @member {number} increaseAmount
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.increaseAmount = 0;
    
                    /**
                     * TimeOffFixedRule releaseDelayPeriod.
                     * @member {palexy.streaming.v1.IProtoPeriod|null|undefined} releaseDelayPeriod
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.releaseDelayPeriod = null;
    
                    /**
                     * TimeOffFixedRule timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffFixedRule createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffFixedRule updateTimeMs.
                     * @member {number} updateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     */
                    TimeOffFixedRule.prototype.updateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TimeOffFixedRule instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffFixedRule=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffFixedRule} TimeOffFixedRule instance
                     */
                    TimeOffFixedRule.create = function create(properties) {
                        return new TimeOffFixedRule(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffFixedRule message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffFixedRule.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffFixedRule} message TimeOffFixedRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffFixedRule.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.increaseAmount != null && Object.hasOwnProperty.call(message, "increaseAmount"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.increaseAmount);
                        if (message.releaseDelayPeriod != null && Object.hasOwnProperty.call(message, "releaseDelayPeriod"))
                            $root.palexy.streaming.v1.ProtoPeriod.encode(message.releaseDelayPeriod, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.timeOffTypeId);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.updateTimeMs != null && Object.hasOwnProperty.call(message, "updateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffFixedRule message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffFixedRule.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffFixedRule} message TimeOffFixedRule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffFixedRule.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffFixedRule message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffFixedRule} TimeOffFixedRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffFixedRule.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffFixedRule();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.increaseAmount = reader.double();
                                break;
                            case 3:
                                message.releaseDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.updateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffFixedRule message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffFixedRule} TimeOffFixedRule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffFixedRule.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffFixedRule message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffFixedRule.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.increaseAmount != null && message.hasOwnProperty("increaseAmount"))
                            if (typeof message.increaseAmount !== "number")
                                return "increaseAmount: number expected";
                        if (message.releaseDelayPeriod != null && message.hasOwnProperty("releaseDelayPeriod")) {
                            var error = $root.palexy.streaming.v1.ProtoPeriod.verify(message.releaseDelayPeriod);
                            if (error)
                                return "releaseDelayPeriod." + error;
                        }
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (!$util.isInteger(message.updateTimeMs) && !(message.updateTimeMs && $util.isInteger(message.updateTimeMs.low) && $util.isInteger(message.updateTimeMs.high)))
                                return "updateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffFixedRule message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffFixedRule} TimeOffFixedRule
                     */
                    TimeOffFixedRule.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffFixedRule)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffFixedRule();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.increaseAmount != null)
                            message.increaseAmount = Number(object.increaseAmount);
                        if (object.releaseDelayPeriod != null) {
                            if (typeof object.releaseDelayPeriod !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffFixedRule.releaseDelayPeriod: object expected");
                            message.releaseDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.fromObject(object.releaseDelayPeriod);
                        }
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.updateTimeMs != null)
                            if ($util.Long)
                                (message.updateTimeMs = $util.Long.fromValue(object.updateTimeMs)).unsigned = false;
                            else if (typeof object.updateTimeMs === "string")
                                message.updateTimeMs = parseInt(object.updateTimeMs, 10);
                            else if (typeof object.updateTimeMs === "number")
                                message.updateTimeMs = object.updateTimeMs;
                            else if (typeof object.updateTimeMs === "object")
                                message.updateTimeMs = new $util.LongBits(object.updateTimeMs.low >>> 0, object.updateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffFixedRule message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffFixedRule} message TimeOffFixedRule
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffFixedRule.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.increaseAmount = 0;
                            object.releaseDelayPeriod = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.increaseAmount != null && message.hasOwnProperty("increaseAmount"))
                            object.increaseAmount = options.json && !isFinite(message.increaseAmount) ? String(message.increaseAmount) : message.increaseAmount;
                        if (message.releaseDelayPeriod != null && message.hasOwnProperty("releaseDelayPeriod"))
                            object.releaseDelayPeriod = $root.palexy.streaming.v1.ProtoPeriod.toObject(message.releaseDelayPeriod, options);
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.updateTimeMs != null && message.hasOwnProperty("updateTimeMs"))
                            if (typeof message.updateTimeMs === "number")
                                object.updateTimeMs = options.longs === String ? String(message.updateTimeMs) : message.updateTimeMs;
                            else
                                object.updateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updateTimeMs) : options.longs === Number ? new $util.LongBits(message.updateTimeMs.low >>> 0, message.updateTimeMs.high >>> 0).toNumber() : message.updateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffFixedRule to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffFixedRule
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffFixedRule.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeOffFixedRule;
                })();
    
                timeoff.TimeOffTransaction = (function() {
    
                    /**
                     * Properties of a TimeOffTransaction.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffTransaction
                     * @property {number|null} [id] TimeOffTransaction id
                     * @property {palexy.protobuf.timeoff.TimeOffTransaction.TransactionType|null} [transactionType] TimeOffTransaction transactionType
                     * @property {palexy.protobuf.timeoff.TimeOffTransaction.BalanceType|null} [balanceType] TimeOffTransaction balanceType
                     * @property {number|null} [amountChange] TimeOffTransaction amountChange
                     * @property {number|null} [transactionDateTimeMs] TimeOffTransaction transactionDateTimeMs
                     * @property {number|null} [staffId] TimeOffTransaction staffId
                     * @property {number|null} [timeOffTypeId] TimeOffTransaction timeOffTypeId
                     */
    
                    /**
                     * Constructs a new TimeOffTransaction.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffTransaction.
                     * @implements ITimeOffTransaction
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffTransaction=} [properties] Properties to set
                     */
                    function TimeOffTransaction(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffTransaction id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffTransaction transactionType.
                     * @member {palexy.protobuf.timeoff.TimeOffTransaction.TransactionType} transactionType
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.transactionType = 0;
    
                    /**
                     * TimeOffTransaction balanceType.
                     * @member {palexy.protobuf.timeoff.TimeOffTransaction.BalanceType} balanceType
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.balanceType = 0;
    
                    /**
                     * TimeOffTransaction amountChange.
                     * @member {number} amountChange
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.amountChange = 0;
    
                    /**
                     * TimeOffTransaction transactionDateTimeMs.
                     * @member {number} transactionDateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.transactionDateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffTransaction staffId.
                     * @member {number} staffId
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffTransaction timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     */
                    TimeOffTransaction.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TimeOffTransaction instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffTransaction=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffTransaction} TimeOffTransaction instance
                     */
                    TimeOffTransaction.create = function create(properties) {
                        return new TimeOffTransaction(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffTransaction message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffTransaction.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffTransaction} message TimeOffTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffTransaction.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.transactionType != null && Object.hasOwnProperty.call(message, "transactionType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.transactionType);
                        if (message.balanceType != null && Object.hasOwnProperty.call(message, "balanceType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.balanceType);
                        if (message.amountChange != null && Object.hasOwnProperty.call(message, "amountChange"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.amountChange);
                        if (message.transactionDateTimeMs != null && Object.hasOwnProperty.call(message, "transactionDateTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.transactionDateTimeMs);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.staffId);
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.timeOffTypeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffTransaction message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffTransaction.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffTransaction} message TimeOffTransaction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffTransaction.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffTransaction message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffTransaction} TimeOffTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffTransaction.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffTransaction();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.transactionType = reader.int32();
                                break;
                            case 3:
                                message.balanceType = reader.int32();
                                break;
                            case 4:
                                message.amountChange = reader.double();
                                break;
                            case 5:
                                message.transactionDateTimeMs = reader.int64();
                                break;
                            case 6:
                                message.staffId = reader.int64();
                                break;
                            case 7:
                                message.timeOffTypeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffTransaction message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffTransaction} TimeOffTransaction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffTransaction.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffTransaction message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffTransaction.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                            switch (message.transactionType) {
                            default:
                                return "transactionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                            case 7:
                                break;
                            }
                        if (message.balanceType != null && message.hasOwnProperty("balanceType"))
                            switch (message.balanceType) {
                            default:
                                return "balanceType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.amountChange != null && message.hasOwnProperty("amountChange"))
                            if (typeof message.amountChange !== "number")
                                return "amountChange: number expected";
                        if (message.transactionDateTimeMs != null && message.hasOwnProperty("transactionDateTimeMs"))
                            if (!$util.isInteger(message.transactionDateTimeMs) && !(message.transactionDateTimeMs && $util.isInteger(message.transactionDateTimeMs.low) && $util.isInteger(message.transactionDateTimeMs.high)))
                                return "transactionDateTimeMs: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffTransaction message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffTransaction} TimeOffTransaction
                     */
                    TimeOffTransaction.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffTransaction)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffTransaction();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        switch (object.transactionType) {
                        case "TRANSACTION_TYPE_UNKNOWN":
                        case 0:
                            message.transactionType = 0;
                            break;
                        case "RESET":
                        case 1:
                            message.transactionType = 1;
                            break;
                        case "ROLLOVER":
                        case 2:
                            message.transactionType = 2;
                            break;
                        case "ACCRUAL":
                        case 3:
                            message.transactionType = 3;
                            break;
                        case "FIXED":
                        case 4:
                            message.transactionType = 4;
                            break;
                        case "MANUAL_ADJUSTMENT":
                        case 5:
                            message.transactionType = 5;
                            break;
                        case "ROLLOVER_END":
                        case 6:
                            message.transactionType = 6;
                            break;
                        case "USAGE":
                        case 7:
                            message.transactionType = 7;
                            break;
                        }
                        switch (object.balanceType) {
                        case "BALANCE_TYPE_UNKNOWN":
                        case 0:
                            message.balanceType = 0;
                            break;
                        case "ANNUAL_ENTITLEMENT_BALANCE":
                        case 1:
                            message.balanceType = 1;
                            break;
                        case "CURRENT_BALANCE":
                        case 2:
                            message.balanceType = 2;
                            break;
                        case "ROLLOVER_BALANCE":
                        case 3:
                            message.balanceType = 3;
                            break;
                        }
                        if (object.amountChange != null)
                            message.amountChange = Number(object.amountChange);
                        if (object.transactionDateTimeMs != null)
                            if ($util.Long)
                                (message.transactionDateTimeMs = $util.Long.fromValue(object.transactionDateTimeMs)).unsigned = false;
                            else if (typeof object.transactionDateTimeMs === "string")
                                message.transactionDateTimeMs = parseInt(object.transactionDateTimeMs, 10);
                            else if (typeof object.transactionDateTimeMs === "number")
                                message.transactionDateTimeMs = object.transactionDateTimeMs;
                            else if (typeof object.transactionDateTimeMs === "object")
                                message.transactionDateTimeMs = new $util.LongBits(object.transactionDateTimeMs.low >>> 0, object.transactionDateTimeMs.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffTransaction message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffTransaction} message TimeOffTransaction
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffTransaction.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.transactionType = options.enums === String ? "TRANSACTION_TYPE_UNKNOWN" : 0;
                            object.balanceType = options.enums === String ? "BALANCE_TYPE_UNKNOWN" : 0;
                            object.amountChange = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.transactionDateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.transactionDateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.transactionType != null && message.hasOwnProperty("transactionType"))
                            object.transactionType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffTransaction.TransactionType[message.transactionType] : message.transactionType;
                        if (message.balanceType != null && message.hasOwnProperty("balanceType"))
                            object.balanceType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffTransaction.BalanceType[message.balanceType] : message.balanceType;
                        if (message.amountChange != null && message.hasOwnProperty("amountChange"))
                            object.amountChange = options.json && !isFinite(message.amountChange) ? String(message.amountChange) : message.amountChange;
                        if (message.transactionDateTimeMs != null && message.hasOwnProperty("transactionDateTimeMs"))
                            if (typeof message.transactionDateTimeMs === "number")
                                object.transactionDateTimeMs = options.longs === String ? String(message.transactionDateTimeMs) : message.transactionDateTimeMs;
                            else
                                object.transactionDateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.transactionDateTimeMs) : options.longs === Number ? new $util.LongBits(message.transactionDateTimeMs.low >>> 0, message.transactionDateTimeMs.high >>> 0).toNumber() : message.transactionDateTimeMs;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffTransaction to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffTransaction
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffTransaction.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * BalanceType enum.
                     * @name palexy.protobuf.timeoff.TimeOffTransaction.BalanceType
                     * @enum {number}
                     * @property {number} BALANCE_TYPE_UNKNOWN=0 BALANCE_TYPE_UNKNOWN value
                     * @property {number} ANNUAL_ENTITLEMENT_BALANCE=1 ANNUAL_ENTITLEMENT_BALANCE value
                     * @property {number} CURRENT_BALANCE=2 CURRENT_BALANCE value
                     * @property {number} ROLLOVER_BALANCE=3 ROLLOVER_BALANCE value
                     */
                    TimeOffTransaction.BalanceType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "BALANCE_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "ANNUAL_ENTITLEMENT_BALANCE"] = 1;
                        values[valuesById[2] = "CURRENT_BALANCE"] = 2;
                        values[valuesById[3] = "ROLLOVER_BALANCE"] = 3;
                        return values;
                    })();
    
                    /**
                     * TransactionType enum.
                     * @name palexy.protobuf.timeoff.TimeOffTransaction.TransactionType
                     * @enum {number}
                     * @property {number} TRANSACTION_TYPE_UNKNOWN=0 TRANSACTION_TYPE_UNKNOWN value
                     * @property {number} RESET=1 RESET value
                     * @property {number} ROLLOVER=2 ROLLOVER value
                     * @property {number} ACCRUAL=3 ACCRUAL value
                     * @property {number} FIXED=4 FIXED value
                     * @property {number} MANUAL_ADJUSTMENT=5 MANUAL_ADJUSTMENT value
                     * @property {number} ROLLOVER_END=6 ROLLOVER_END value
                     * @property {number} USAGE=7 USAGE value
                     */
                    TimeOffTransaction.TransactionType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TRANSACTION_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "RESET"] = 1;
                        values[valuesById[2] = "ROLLOVER"] = 2;
                        values[valuesById[3] = "ACCRUAL"] = 3;
                        values[valuesById[4] = "FIXED"] = 4;
                        values[valuesById[5] = "MANUAL_ADJUSTMENT"] = 5;
                        values[valuesById[6] = "ROLLOVER_END"] = 6;
                        values[valuesById[7] = "USAGE"] = 7;
                        return values;
                    })();
    
                    return TimeOffTransaction;
                })();
    
                timeoff.TimeOffJournal = (function() {
    
                    /**
                     * Properties of a TimeOffJournal.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffJournal
                     * @property {number|null} [id] TimeOffJournal id
                     * @property {palexy.protobuf.timeoff.TimeOffJournal.JournalType|null} [journalType] TimeOffJournal journalType
                     * @property {string|null} [description] TimeOffJournal description
                     * @property {number|null} [staffId] TimeOffJournal staffId
                     * @property {number|null} [timeOffTypeId] TimeOffJournal timeOffTypeId
                     * @property {string|null} [username] TimeOffJournal username
                     * @property {number|null} [createTimeMs] TimeOffJournal createTimeMs
                     * @property {number|null} [journalDateTimeMs] TimeOffJournal journalDateTimeMs
                     * @property {boolean|null} [needAdjustment] TimeOffJournal needAdjustment
                     * @property {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail|null} [adjustmentDetail] TimeOffJournal adjustmentDetail
                     * @property {number|null} [timeOffItemId] TimeOffJournal timeOffItemId
                     */
    
                    /**
                     * Constructs a new TimeOffJournal.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffJournal.
                     * @implements ITimeOffJournal
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffJournal=} [properties] Properties to set
                     */
                    function TimeOffJournal(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffJournal id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffJournal journalType.
                     * @member {palexy.protobuf.timeoff.TimeOffJournal.JournalType} journalType
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.journalType = 0;
    
                    /**
                     * TimeOffJournal description.
                     * @member {string} description
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.description = "";
    
                    /**
                     * TimeOffJournal staffId.
                     * @member {number} staffId
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffJournal timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffJournal username.
                     * @member {string} username
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.username = "";
    
                    /**
                     * TimeOffJournal createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffJournal journalDateTimeMs.
                     * @member {number} journalDateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.journalDateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffJournal needAdjustment.
                     * @member {boolean} needAdjustment
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.needAdjustment = false;
    
                    /**
                     * TimeOffJournal adjustmentDetail.
                     * @member {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail|null|undefined} adjustmentDetail
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.adjustmentDetail = null;
    
                    /**
                     * TimeOffJournal timeOffItemId.
                     * @member {number} timeOffItemId
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     */
                    TimeOffJournal.prototype.timeOffItemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TimeOffJournal instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffJournal=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffJournal} TimeOffJournal instance
                     */
                    TimeOffJournal.create = function create(properties) {
                        return new TimeOffJournal(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffJournal message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffJournal.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffJournal} message TimeOffJournal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffJournal.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.journalType != null && Object.hasOwnProperty.call(message, "journalType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.journalType);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.staffId);
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.timeOffTypeId);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.username);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createTimeMs);
                        if (message.journalDateTimeMs != null && Object.hasOwnProperty.call(message, "journalDateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.journalDateTimeMs);
                        if (message.needAdjustment != null && Object.hasOwnProperty.call(message, "needAdjustment"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.needAdjustment);
                        if (message.adjustmentDetail != null && Object.hasOwnProperty.call(message, "adjustmentDetail"))
                            $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.encode(message.adjustmentDetail, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.timeOffItemId != null && Object.hasOwnProperty.call(message, "timeOffItemId"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.timeOffItemId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffJournal message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffJournal.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffJournal} message TimeOffJournal message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffJournal.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffJournal message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffJournal} TimeOffJournal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffJournal.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffJournal();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.journalType = reader.int32();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.staffId = reader.int64();
                                break;
                            case 5:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 6:
                                message.username = reader.string();
                                break;
                            case 7:
                                message.createTimeMs = reader.int64();
                                break;
                            case 8:
                                message.journalDateTimeMs = reader.int64();
                                break;
                            case 9:
                                message.needAdjustment = reader.bool();
                                break;
                            case 10:
                                message.adjustmentDetail = $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.timeOffItemId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffJournal message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffJournal} TimeOffJournal
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffJournal.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffJournal message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffJournal.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.journalType != null && message.hasOwnProperty("journalType"))
                            switch (message.journalType) {
                            default:
                                return "journalType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.journalDateTimeMs != null && message.hasOwnProperty("journalDateTimeMs"))
                            if (!$util.isInteger(message.journalDateTimeMs) && !(message.journalDateTimeMs && $util.isInteger(message.journalDateTimeMs.low) && $util.isInteger(message.journalDateTimeMs.high)))
                                return "journalDateTimeMs: integer|Long expected";
                        if (message.needAdjustment != null && message.hasOwnProperty("needAdjustment"))
                            if (typeof message.needAdjustment !== "boolean")
                                return "needAdjustment: boolean expected";
                        if (message.adjustmentDetail != null && message.hasOwnProperty("adjustmentDetail")) {
                            var error = $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.verify(message.adjustmentDetail);
                            if (error)
                                return "adjustmentDetail." + error;
                        }
                        if (message.timeOffItemId != null && message.hasOwnProperty("timeOffItemId"))
                            if (!$util.isInteger(message.timeOffItemId) && !(message.timeOffItemId && $util.isInteger(message.timeOffItemId.low) && $util.isInteger(message.timeOffItemId.high)))
                                return "timeOffItemId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffJournal message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffJournal} TimeOffJournal
                     */
                    TimeOffJournal.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffJournal)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffJournal();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        switch (object.journalType) {
                        case "JOURNAL_TYPE_UNKNOWN":
                        case 0:
                            message.journalType = 0;
                            break;
                        case "SYSTEM_BALANCE_GENERATION":
                        case 1:
                            message.journalType = 1;
                            break;
                        case "SYSTEM_BALANCE_DELETION":
                        case 2:
                            message.journalType = 2;
                            break;
                        case "MANUAL_BALANCE_EDITING":
                        case 3:
                            message.journalType = 3;
                            break;
                        case "BATCH_MANUAL_BALANCE_EDITING":
                        case 4:
                            message.journalType = 4;
                            break;
                        case "REQUEST_BALANCE_USAGE":
                        case 5:
                            message.journalType = 5;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.journalDateTimeMs != null)
                            if ($util.Long)
                                (message.journalDateTimeMs = $util.Long.fromValue(object.journalDateTimeMs)).unsigned = false;
                            else if (typeof object.journalDateTimeMs === "string")
                                message.journalDateTimeMs = parseInt(object.journalDateTimeMs, 10);
                            else if (typeof object.journalDateTimeMs === "number")
                                message.journalDateTimeMs = object.journalDateTimeMs;
                            else if (typeof object.journalDateTimeMs === "object")
                                message.journalDateTimeMs = new $util.LongBits(object.journalDateTimeMs.low >>> 0, object.journalDateTimeMs.high >>> 0).toNumber();
                        if (object.needAdjustment != null)
                            message.needAdjustment = Boolean(object.needAdjustment);
                        if (object.adjustmentDetail != null) {
                            if (typeof object.adjustmentDetail !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffJournal.adjustmentDetail: object expected");
                            message.adjustmentDetail = $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.fromObject(object.adjustmentDetail);
                        }
                        if (object.timeOffItemId != null)
                            if ($util.Long)
                                (message.timeOffItemId = $util.Long.fromValue(object.timeOffItemId)).unsigned = false;
                            else if (typeof object.timeOffItemId === "string")
                                message.timeOffItemId = parseInt(object.timeOffItemId, 10);
                            else if (typeof object.timeOffItemId === "number")
                                message.timeOffItemId = object.timeOffItemId;
                            else if (typeof object.timeOffItemId === "object")
                                message.timeOffItemId = new $util.LongBits(object.timeOffItemId.low >>> 0, object.timeOffItemId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffJournal message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffJournal} message TimeOffJournal
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffJournal.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.journalType = options.enums === String ? "JOURNAL_TYPE_UNKNOWN" : 0;
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            object.username = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.journalDateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.journalDateTimeMs = options.longs === String ? "0" : 0;
                            object.needAdjustment = false;
                            object.adjustmentDetail = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffItemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffItemId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.journalType != null && message.hasOwnProperty("journalType"))
                            object.journalType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffJournal.JournalType[message.journalType] : message.journalType;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.journalDateTimeMs != null && message.hasOwnProperty("journalDateTimeMs"))
                            if (typeof message.journalDateTimeMs === "number")
                                object.journalDateTimeMs = options.longs === String ? String(message.journalDateTimeMs) : message.journalDateTimeMs;
                            else
                                object.journalDateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.journalDateTimeMs) : options.longs === Number ? new $util.LongBits(message.journalDateTimeMs.low >>> 0, message.journalDateTimeMs.high >>> 0).toNumber() : message.journalDateTimeMs;
                        if (message.needAdjustment != null && message.hasOwnProperty("needAdjustment"))
                            object.needAdjustment = message.needAdjustment;
                        if (message.adjustmentDetail != null && message.hasOwnProperty("adjustmentDetail"))
                            object.adjustmentDetail = $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.toObject(message.adjustmentDetail, options);
                        if (message.timeOffItemId != null && message.hasOwnProperty("timeOffItemId"))
                            if (typeof message.timeOffItemId === "number")
                                object.timeOffItemId = options.longs === String ? String(message.timeOffItemId) : message.timeOffItemId;
                            else
                                object.timeOffItemId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffItemId) : options.longs === Number ? new $util.LongBits(message.timeOffItemId.low >>> 0, message.timeOffItemId.high >>> 0).toNumber() : message.timeOffItemId;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffJournal to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffJournal
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffJournal.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    TimeOffJournal.JournalAdjustmentDetail = (function() {
    
                        /**
                         * Properties of a JournalAdjustmentDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal
                         * @interface IJournalAdjustmentDetail
                         * @property {palexy.protobuf.timeoff.IStaffTimeOffBalance|null} [manualEditBalance] JournalAdjustmentDetail manualEditBalance
                         * @property {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule|null} [generationSchedule] JournalAdjustmentDetail generationSchedule
                         */
    
                        /**
                         * Constructs a new JournalAdjustmentDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal
                         * @classdesc Represents a JournalAdjustmentDetail.
                         * @implements IJournalAdjustmentDetail
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail=} [properties] Properties to set
                         */
                        function JournalAdjustmentDetail(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * JournalAdjustmentDetail manualEditBalance.
                         * @member {palexy.protobuf.timeoff.IStaffTimeOffBalance|null|undefined} manualEditBalance
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @instance
                         */
                        JournalAdjustmentDetail.prototype.manualEditBalance = null;
    
                        /**
                         * JournalAdjustmentDetail generationSchedule.
                         * @member {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule|null|undefined} generationSchedule
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @instance
                         */
                        JournalAdjustmentDetail.prototype.generationSchedule = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * JournalAdjustmentDetail adjustmentDetail.
                         * @member {"manualEditBalance"|"generationSchedule"|undefined} adjustmentDetail
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @instance
                         */
                        Object.defineProperty(JournalAdjustmentDetail.prototype, "adjustmentDetail", {
                            get: $util.oneOfGetter($oneOfFields = ["manualEditBalance", "generationSchedule"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new JournalAdjustmentDetail instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail} JournalAdjustmentDetail instance
                         */
                        JournalAdjustmentDetail.create = function create(properties) {
                            return new JournalAdjustmentDetail(properties);
                        };
    
                        /**
                         * Encodes the specified JournalAdjustmentDetail message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail} message JournalAdjustmentDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        JournalAdjustmentDetail.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.manualEditBalance != null && Object.hasOwnProperty.call(message, "manualEditBalance"))
                                $root.palexy.protobuf.timeoff.StaffTimeOffBalance.encode(message.manualEditBalance, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            if (message.generationSchedule != null && Object.hasOwnProperty.call(message, "generationSchedule"))
                                $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.encode(message.generationSchedule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified JournalAdjustmentDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffJournal.IJournalAdjustmentDetail} message JournalAdjustmentDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        JournalAdjustmentDetail.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a JournalAdjustmentDetail message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail} JournalAdjustmentDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        JournalAdjustmentDetail.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.manualEditBalance = $root.palexy.protobuf.timeoff.StaffTimeOffBalance.decode(reader, reader.uint32());
                                    break;
                                case 2:
                                    message.generationSchedule = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a JournalAdjustmentDetail message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail} JournalAdjustmentDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        JournalAdjustmentDetail.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a JournalAdjustmentDetail message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        JournalAdjustmentDetail.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.manualEditBalance != null && message.hasOwnProperty("manualEditBalance")) {
                                properties.adjustmentDetail = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.StaffTimeOffBalance.verify(message.manualEditBalance);
                                    if (error)
                                        return "manualEditBalance." + error;
                                }
                            }
                            if (message.generationSchedule != null && message.hasOwnProperty("generationSchedule")) {
                                if (properties.adjustmentDetail === 1)
                                    return "adjustmentDetail: multiple values";
                                properties.adjustmentDetail = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.verify(message.generationSchedule);
                                    if (error)
                                        return "generationSchedule." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a JournalAdjustmentDetail message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail} JournalAdjustmentDetail
                         */
                        JournalAdjustmentDetail.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail();
                            if (object.manualEditBalance != null) {
                                if (typeof object.manualEditBalance !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.manualEditBalance: object expected");
                                message.manualEditBalance = $root.palexy.protobuf.timeoff.StaffTimeOffBalance.fromObject(object.manualEditBalance);
                            }
                            if (object.generationSchedule != null) {
                                if (typeof object.generationSchedule !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail.generationSchedule: object expected");
                                message.generationSchedule = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.fromObject(object.generationSchedule);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a JournalAdjustmentDetail message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail} message JournalAdjustmentDetail
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        JournalAdjustmentDetail.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (message.manualEditBalance != null && message.hasOwnProperty("manualEditBalance")) {
                                object.manualEditBalance = $root.palexy.protobuf.timeoff.StaffTimeOffBalance.toObject(message.manualEditBalance, options);
                                if (options.oneofs)
                                    object.adjustmentDetail = "manualEditBalance";
                            }
                            if (message.generationSchedule != null && message.hasOwnProperty("generationSchedule")) {
                                object.generationSchedule = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.toObject(message.generationSchedule, options);
                                if (options.oneofs)
                                    object.adjustmentDetail = "generationSchedule";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this JournalAdjustmentDetail to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffJournal.JournalAdjustmentDetail
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        JournalAdjustmentDetail.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return JournalAdjustmentDetail;
                    })();
    
                    /**
                     * JournalType enum.
                     * @name palexy.protobuf.timeoff.TimeOffJournal.JournalType
                     * @enum {number}
                     * @property {number} JOURNAL_TYPE_UNKNOWN=0 JOURNAL_TYPE_UNKNOWN value
                     * @property {number} SYSTEM_BALANCE_GENERATION=1 SYSTEM_BALANCE_GENERATION value
                     * @property {number} SYSTEM_BALANCE_DELETION=2 SYSTEM_BALANCE_DELETION value
                     * @property {number} MANUAL_BALANCE_EDITING=3 MANUAL_BALANCE_EDITING value
                     * @property {number} BATCH_MANUAL_BALANCE_EDITING=4 BATCH_MANUAL_BALANCE_EDITING value
                     * @property {number} REQUEST_BALANCE_USAGE=5 REQUEST_BALANCE_USAGE value
                     */
                    TimeOffJournal.JournalType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "JOURNAL_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "SYSTEM_BALANCE_GENERATION"] = 1;
                        values[valuesById[2] = "SYSTEM_BALANCE_DELETION"] = 2;
                        values[valuesById[3] = "MANUAL_BALANCE_EDITING"] = 3;
                        values[valuesById[4] = "BATCH_MANUAL_BALANCE_EDITING"] = 4;
                        values[valuesById[5] = "REQUEST_BALANCE_USAGE"] = 5;
                        return values;
                    })();
    
                    return TimeOffJournal;
                })();
    
                timeoff.StaffTimeOffBalance = (function() {
    
                    /**
                     * Properties of a StaffTimeOffBalance.
                     * @memberof palexy.protobuf.timeoff
                     * @interface IStaffTimeOffBalance
                     * @property {number|null} [annualEntitlementBalance] StaffTimeOffBalance annualEntitlementBalance
                     * @property {number|null} [currentBalance] StaffTimeOffBalance currentBalance
                     * @property {number|null} [rolloverBalance] StaffTimeOffBalance rolloverBalance
                     */
    
                    /**
                     * Constructs a new StaffTimeOffBalance.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a StaffTimeOffBalance.
                     * @implements IStaffTimeOffBalance
                     * @constructor
                     * @param {palexy.protobuf.timeoff.IStaffTimeOffBalance=} [properties] Properties to set
                     */
                    function StaffTimeOffBalance(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StaffTimeOffBalance annualEntitlementBalance.
                     * @member {number} annualEntitlementBalance
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @instance
                     */
                    StaffTimeOffBalance.prototype.annualEntitlementBalance = 0;
    
                    /**
                     * StaffTimeOffBalance currentBalance.
                     * @member {number} currentBalance
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @instance
                     */
                    StaffTimeOffBalance.prototype.currentBalance = 0;
    
                    /**
                     * StaffTimeOffBalance rolloverBalance.
                     * @member {number} rolloverBalance
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @instance
                     */
                    StaffTimeOffBalance.prototype.rolloverBalance = 0;
    
                    /**
                     * Creates a new StaffTimeOffBalance instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {palexy.protobuf.timeoff.IStaffTimeOffBalance=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.StaffTimeOffBalance} StaffTimeOffBalance instance
                     */
                    StaffTimeOffBalance.create = function create(properties) {
                        return new StaffTimeOffBalance(properties);
                    };
    
                    /**
                     * Encodes the specified StaffTimeOffBalance message. Does not implicitly {@link palexy.protobuf.timeoff.StaffTimeOffBalance.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {palexy.protobuf.timeoff.IStaffTimeOffBalance} message StaffTimeOffBalance message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffTimeOffBalance.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.annualEntitlementBalance != null && Object.hasOwnProperty.call(message, "annualEntitlementBalance"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.annualEntitlementBalance);
                        if (message.currentBalance != null && Object.hasOwnProperty.call(message, "currentBalance"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.currentBalance);
                        if (message.rolloverBalance != null && Object.hasOwnProperty.call(message, "rolloverBalance"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.rolloverBalance);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StaffTimeOffBalance message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.StaffTimeOffBalance.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {palexy.protobuf.timeoff.IStaffTimeOffBalance} message StaffTimeOffBalance message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StaffTimeOffBalance.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StaffTimeOffBalance message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.StaffTimeOffBalance} StaffTimeOffBalance
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffTimeOffBalance.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.StaffTimeOffBalance();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.annualEntitlementBalance = reader.double();
                                break;
                            case 2:
                                message.currentBalance = reader.double();
                                break;
                            case 3:
                                message.rolloverBalance = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StaffTimeOffBalance message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.StaffTimeOffBalance} StaffTimeOffBalance
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StaffTimeOffBalance.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StaffTimeOffBalance message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StaffTimeOffBalance.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.annualEntitlementBalance != null && message.hasOwnProperty("annualEntitlementBalance"))
                            if (typeof message.annualEntitlementBalance !== "number")
                                return "annualEntitlementBalance: number expected";
                        if (message.currentBalance != null && message.hasOwnProperty("currentBalance"))
                            if (typeof message.currentBalance !== "number")
                                return "currentBalance: number expected";
                        if (message.rolloverBalance != null && message.hasOwnProperty("rolloverBalance"))
                            if (typeof message.rolloverBalance !== "number")
                                return "rolloverBalance: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a StaffTimeOffBalance message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.StaffTimeOffBalance} StaffTimeOffBalance
                     */
                    StaffTimeOffBalance.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.StaffTimeOffBalance)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.StaffTimeOffBalance();
                        if (object.annualEntitlementBalance != null)
                            message.annualEntitlementBalance = Number(object.annualEntitlementBalance);
                        if (object.currentBalance != null)
                            message.currentBalance = Number(object.currentBalance);
                        if (object.rolloverBalance != null)
                            message.rolloverBalance = Number(object.rolloverBalance);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StaffTimeOffBalance message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @static
                     * @param {palexy.protobuf.timeoff.StaffTimeOffBalance} message StaffTimeOffBalance
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StaffTimeOffBalance.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.annualEntitlementBalance = 0;
                            object.currentBalance = 0;
                            object.rolloverBalance = 0;
                        }
                        if (message.annualEntitlementBalance != null && message.hasOwnProperty("annualEntitlementBalance"))
                            object.annualEntitlementBalance = options.json && !isFinite(message.annualEntitlementBalance) ? String(message.annualEntitlementBalance) : message.annualEntitlementBalance;
                        if (message.currentBalance != null && message.hasOwnProperty("currentBalance"))
                            object.currentBalance = options.json && !isFinite(message.currentBalance) ? String(message.currentBalance) : message.currentBalance;
                        if (message.rolloverBalance != null && message.hasOwnProperty("rolloverBalance"))
                            object.rolloverBalance = options.json && !isFinite(message.rolloverBalance) ? String(message.rolloverBalance) : message.rolloverBalance;
                        return object;
                    };
    
                    /**
                     * Converts this StaffTimeOffBalance to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.StaffTimeOffBalance
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StaffTimeOffBalance.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StaffTimeOffBalance;
                })();
    
                timeoff.TimeOffBalanceGenerationSchedule = (function() {
    
                    /**
                     * Properties of a TimeOffBalanceGenerationSchedule.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffBalanceGenerationSchedule
                     * @property {number|null} [id] TimeOffBalanceGenerationSchedule id
                     * @property {number|null} [timeOffTypeId] TimeOffBalanceGenerationSchedule timeOffTypeId
                     * @property {number|null} [staffId] TimeOffBalanceGenerationSchedule staffId
                     * @property {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RuleType|null} [ruleType] TimeOffBalanceGenerationSchedule ruleType
                     * @property {number|null} [createTimeMs] TimeOffBalanceGenerationSchedule createTimeMs
                     * @property {number|null} [lastExecutionTime] TimeOffBalanceGenerationSchedule lastExecutionTime
                     * @property {number|null} [nextExecutionTime] TimeOffBalanceGenerationSchedule nextExecutionTime
                     * @property {number|null} [deleteTimeMs] TimeOffBalanceGenerationSchedule deleteTimeMs
                     * @property {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData|null} [additionalData] TimeOffBalanceGenerationSchedule additionalData
                     * @property {number|null} [companyId] TimeOffBalanceGenerationSchedule companyId
                     */
    
                    /**
                     * Constructs a new TimeOffBalanceGenerationSchedule.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffBalanceGenerationSchedule.
                     * @implements ITimeOffBalanceGenerationSchedule
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule=} [properties] Properties to set
                     */
                    function TimeOffBalanceGenerationSchedule(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffBalanceGenerationSchedule id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule staffId.
                     * @member {number} staffId
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule ruleType.
                     * @member {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RuleType} ruleType
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.ruleType = 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule lastExecutionTime.
                     * @member {number} lastExecutionTime
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.lastExecutionTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule nextExecutionTime.
                     * @member {number} nextExecutionTime
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.nextExecutionTime = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule deleteTimeMs.
                     * @member {number} deleteTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.deleteTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffBalanceGenerationSchedule additionalData.
                     * @member {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData|null|undefined} additionalData
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.additionalData = null;
    
                    /**
                     * TimeOffBalanceGenerationSchedule companyId.
                     * @member {number} companyId
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     */
                    TimeOffBalanceGenerationSchedule.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TimeOffBalanceGenerationSchedule instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule} TimeOffBalanceGenerationSchedule instance
                     */
                    TimeOffBalanceGenerationSchedule.create = function create(properties) {
                        return new TimeOffBalanceGenerationSchedule(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffBalanceGenerationSchedule message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule} message TimeOffBalanceGenerationSchedule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffBalanceGenerationSchedule.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.timeOffTypeId);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.staffId);
                        if (message.ruleType != null && Object.hasOwnProperty.call(message, "ruleType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.ruleType);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createTimeMs);
                        if (message.lastExecutionTime != null && Object.hasOwnProperty.call(message, "lastExecutionTime"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastExecutionTime);
                        if (message.nextExecutionTime != null && Object.hasOwnProperty.call(message, "nextExecutionTime"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.nextExecutionTime);
                        if (message.deleteTimeMs != null && Object.hasOwnProperty.call(message, "deleteTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.deleteTimeMs);
                        if (message.additionalData != null && Object.hasOwnProperty.call(message, "additionalData"))
                            $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.encode(message.additionalData, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffBalanceGenerationSchedule message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffBalanceGenerationSchedule} message TimeOffBalanceGenerationSchedule message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffBalanceGenerationSchedule.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffBalanceGenerationSchedule message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule} TimeOffBalanceGenerationSchedule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffBalanceGenerationSchedule.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 3:
                                message.staffId = reader.int64();
                                break;
                            case 4:
                                message.ruleType = reader.int32();
                                break;
                            case 5:
                                message.createTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastExecutionTime = reader.int64();
                                break;
                            case 7:
                                message.nextExecutionTime = reader.int64();
                                break;
                            case 8:
                                message.deleteTimeMs = reader.int64();
                                break;
                            case 9:
                                message.additionalData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffBalanceGenerationSchedule message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule} TimeOffBalanceGenerationSchedule
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffBalanceGenerationSchedule.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffBalanceGenerationSchedule message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffBalanceGenerationSchedule.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                            switch (message.ruleType) {
                            default:
                                return "ruleType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastExecutionTime != null && message.hasOwnProperty("lastExecutionTime"))
                            if (!$util.isInteger(message.lastExecutionTime) && !(message.lastExecutionTime && $util.isInteger(message.lastExecutionTime.low) && $util.isInteger(message.lastExecutionTime.high)))
                                return "lastExecutionTime: integer|Long expected";
                        if (message.nextExecutionTime != null && message.hasOwnProperty("nextExecutionTime"))
                            if (!$util.isInteger(message.nextExecutionTime) && !(message.nextExecutionTime && $util.isInteger(message.nextExecutionTime.low) && $util.isInteger(message.nextExecutionTime.high)))
                                return "nextExecutionTime: integer|Long expected";
                        if (message.deleteTimeMs != null && message.hasOwnProperty("deleteTimeMs"))
                            if (!$util.isInteger(message.deleteTimeMs) && !(message.deleteTimeMs && $util.isInteger(message.deleteTimeMs.low) && $util.isInteger(message.deleteTimeMs.high)))
                                return "deleteTimeMs: integer|Long expected";
                        if (message.additionalData != null && message.hasOwnProperty("additionalData")) {
                            var error = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.verify(message.additionalData);
                            if (error)
                                return "additionalData." + error;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffBalanceGenerationSchedule message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule} TimeOffBalanceGenerationSchedule
                     */
                    TimeOffBalanceGenerationSchedule.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        switch (object.ruleType) {
                        case "RULE_TYPE_UNKNOWN":
                        case 0:
                            message.ruleType = 0;
                            break;
                        case "ACCRUAL":
                        case 1:
                            message.ruleType = 1;
                            break;
                        case "FIXED":
                        case 2:
                            message.ruleType = 2;
                            break;
                        case "RESET":
                        case 3:
                            message.ruleType = 3;
                            break;
                        case "ROLLOVER_END":
                        case 4:
                            message.ruleType = 4;
                            break;
                        }
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastExecutionTime != null)
                            if ($util.Long)
                                (message.lastExecutionTime = $util.Long.fromValue(object.lastExecutionTime)).unsigned = false;
                            else if (typeof object.lastExecutionTime === "string")
                                message.lastExecutionTime = parseInt(object.lastExecutionTime, 10);
                            else if (typeof object.lastExecutionTime === "number")
                                message.lastExecutionTime = object.lastExecutionTime;
                            else if (typeof object.lastExecutionTime === "object")
                                message.lastExecutionTime = new $util.LongBits(object.lastExecutionTime.low >>> 0, object.lastExecutionTime.high >>> 0).toNumber();
                        if (object.nextExecutionTime != null)
                            if ($util.Long)
                                (message.nextExecutionTime = $util.Long.fromValue(object.nextExecutionTime)).unsigned = false;
                            else if (typeof object.nextExecutionTime === "string")
                                message.nextExecutionTime = parseInt(object.nextExecutionTime, 10);
                            else if (typeof object.nextExecutionTime === "number")
                                message.nextExecutionTime = object.nextExecutionTime;
                            else if (typeof object.nextExecutionTime === "object")
                                message.nextExecutionTime = new $util.LongBits(object.nextExecutionTime.low >>> 0, object.nextExecutionTime.high >>> 0).toNumber();
                        if (object.deleteTimeMs != null)
                            if ($util.Long)
                                (message.deleteTimeMs = $util.Long.fromValue(object.deleteTimeMs)).unsigned = false;
                            else if (typeof object.deleteTimeMs === "string")
                                message.deleteTimeMs = parseInt(object.deleteTimeMs, 10);
                            else if (typeof object.deleteTimeMs === "number")
                                message.deleteTimeMs = object.deleteTimeMs;
                            else if (typeof object.deleteTimeMs === "object")
                                message.deleteTimeMs = new $util.LongBits(object.deleteTimeMs.low >>> 0, object.deleteTimeMs.high >>> 0).toNumber();
                        if (object.additionalData != null) {
                            if (typeof object.additionalData !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.additionalData: object expected");
                            message.additionalData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.fromObject(object.additionalData);
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffBalanceGenerationSchedule message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule} message TimeOffBalanceGenerationSchedule
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffBalanceGenerationSchedule.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            object.ruleType = options.enums === String ? "RULE_TYPE_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastExecutionTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastExecutionTime = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.nextExecutionTime = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.nextExecutionTime = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.deleteTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.deleteTimeMs = options.longs === String ? "0" : 0;
                            object.additionalData = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                            object.ruleType = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RuleType[message.ruleType] : message.ruleType;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastExecutionTime != null && message.hasOwnProperty("lastExecutionTime"))
                            if (typeof message.lastExecutionTime === "number")
                                object.lastExecutionTime = options.longs === String ? String(message.lastExecutionTime) : message.lastExecutionTime;
                            else
                                object.lastExecutionTime = options.longs === String ? $util.Long.prototype.toString.call(message.lastExecutionTime) : options.longs === Number ? new $util.LongBits(message.lastExecutionTime.low >>> 0, message.lastExecutionTime.high >>> 0).toNumber() : message.lastExecutionTime;
                        if (message.nextExecutionTime != null && message.hasOwnProperty("nextExecutionTime"))
                            if (typeof message.nextExecutionTime === "number")
                                object.nextExecutionTime = options.longs === String ? String(message.nextExecutionTime) : message.nextExecutionTime;
                            else
                                object.nextExecutionTime = options.longs === String ? $util.Long.prototype.toString.call(message.nextExecutionTime) : options.longs === Number ? new $util.LongBits(message.nextExecutionTime.low >>> 0, message.nextExecutionTime.high >>> 0).toNumber() : message.nextExecutionTime;
                        if (message.deleteTimeMs != null && message.hasOwnProperty("deleteTimeMs"))
                            if (typeof message.deleteTimeMs === "number")
                                object.deleteTimeMs = options.longs === String ? String(message.deleteTimeMs) : message.deleteTimeMs;
                            else
                                object.deleteTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.deleteTimeMs) : options.longs === Number ? new $util.LongBits(message.deleteTimeMs.low >>> 0, message.deleteTimeMs.high >>> 0).toNumber() : message.deleteTimeMs;
                        if (message.additionalData != null && message.hasOwnProperty("additionalData"))
                            object.additionalData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.toObject(message.additionalData, options);
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffBalanceGenerationSchedule to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffBalanceGenerationSchedule.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData = (function() {
    
                        /**
                         * Properties of a GenerationScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @interface IGenerationScheduleAdditionalData
                         * @property {number|null} [staffStartDateMs] GenerationScheduleAdditionalData staffStartDateMs
                         * @property {palexy.protobuf.timeoff.ITimeOffAccrualRule|null} [accrualRule] GenerationScheduleAdditionalData accrualRule
                         * @property {palexy.protobuf.timeoff.ITimeOffFixedRule|null} [fixedRule] GenerationScheduleAdditionalData fixedRule
                         * @property {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData|null} [resetData] GenerationScheduleAdditionalData resetData
                         * @property {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData|null} [rolloverEndData] GenerationScheduleAdditionalData rolloverEndData
                         */
    
                        /**
                         * Constructs a new GenerationScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @classdesc Represents a GenerationScheduleAdditionalData.
                         * @implements IGenerationScheduleAdditionalData
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData=} [properties] Properties to set
                         */
                        function GenerationScheduleAdditionalData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * GenerationScheduleAdditionalData staffStartDateMs.
                         * @member {number} staffStartDateMs
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        GenerationScheduleAdditionalData.prototype.staffStartDateMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * GenerationScheduleAdditionalData accrualRule.
                         * @member {palexy.protobuf.timeoff.ITimeOffAccrualRule|null|undefined} accrualRule
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        GenerationScheduleAdditionalData.prototype.accrualRule = null;
    
                        /**
                         * GenerationScheduleAdditionalData fixedRule.
                         * @member {palexy.protobuf.timeoff.ITimeOffFixedRule|null|undefined} fixedRule
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        GenerationScheduleAdditionalData.prototype.fixedRule = null;
    
                        /**
                         * GenerationScheduleAdditionalData resetData.
                         * @member {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData|null|undefined} resetData
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        GenerationScheduleAdditionalData.prototype.resetData = null;
    
                        /**
                         * GenerationScheduleAdditionalData rolloverEndData.
                         * @member {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData|null|undefined} rolloverEndData
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        GenerationScheduleAdditionalData.prototype.rolloverEndData = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * GenerationScheduleAdditionalData ruleData.
                         * @member {"accrualRule"|"fixedRule"|"resetData"|"rolloverEndData"|undefined} ruleData
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         */
                        Object.defineProperty(GenerationScheduleAdditionalData.prototype, "ruleData", {
                            get: $util.oneOfGetter($oneOfFields = ["accrualRule", "fixedRule", "resetData", "rolloverEndData"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new GenerationScheduleAdditionalData instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData} GenerationScheduleAdditionalData instance
                         */
                        GenerationScheduleAdditionalData.create = function create(properties) {
                            return new GenerationScheduleAdditionalData(properties);
                        };
    
                        /**
                         * Encodes the specified GenerationScheduleAdditionalData message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData} message GenerationScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerationScheduleAdditionalData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.staffStartDateMs != null && Object.hasOwnProperty.call(message, "staffStartDateMs"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.staffStartDateMs);
                            if (message.accrualRule != null && Object.hasOwnProperty.call(message, "accrualRule"))
                                $root.palexy.protobuf.timeoff.TimeOffAccrualRule.encode(message.accrualRule, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                            if (message.fixedRule != null && Object.hasOwnProperty.call(message, "fixedRule"))
                                $root.palexy.protobuf.timeoff.TimeOffFixedRule.encode(message.fixedRule, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                            if (message.resetData != null && Object.hasOwnProperty.call(message, "resetData"))
                                $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.encode(message.resetData, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                            if (message.rolloverEndData != null && Object.hasOwnProperty.call(message, "rolloverEndData"))
                                $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.encode(message.rolloverEndData, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified GenerationScheduleAdditionalData message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IGenerationScheduleAdditionalData} message GenerationScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        GenerationScheduleAdditionalData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a GenerationScheduleAdditionalData message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData} GenerationScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerationScheduleAdditionalData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.staffStartDateMs = reader.int64();
                                    break;
                                case 2:
                                    message.accrualRule = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.decode(reader, reader.uint32());
                                    break;
                                case 3:
                                    message.fixedRule = $root.palexy.protobuf.timeoff.TimeOffFixedRule.decode(reader, reader.uint32());
                                    break;
                                case 4:
                                    message.resetData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.decode(reader, reader.uint32());
                                    break;
                                case 5:
                                    message.rolloverEndData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.decode(reader, reader.uint32());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a GenerationScheduleAdditionalData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData} GenerationScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        GenerationScheduleAdditionalData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a GenerationScheduleAdditionalData message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        GenerationScheduleAdditionalData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.staffStartDateMs != null && message.hasOwnProperty("staffStartDateMs"))
                                if (!$util.isInteger(message.staffStartDateMs) && !(message.staffStartDateMs && $util.isInteger(message.staffStartDateMs.low) && $util.isInteger(message.staffStartDateMs.high)))
                                    return "staffStartDateMs: integer|Long expected";
                            if (message.accrualRule != null && message.hasOwnProperty("accrualRule")) {
                                properties.ruleData = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.verify(message.accrualRule);
                                    if (error)
                                        return "accrualRule." + error;
                                }
                            }
                            if (message.fixedRule != null && message.hasOwnProperty("fixedRule")) {
                                if (properties.ruleData === 1)
                                    return "ruleData: multiple values";
                                properties.ruleData = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.TimeOffFixedRule.verify(message.fixedRule);
                                    if (error)
                                        return "fixedRule." + error;
                                }
                            }
                            if (message.resetData != null && message.hasOwnProperty("resetData")) {
                                if (properties.ruleData === 1)
                                    return "ruleData: multiple values";
                                properties.ruleData = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.verify(message.resetData);
                                    if (error)
                                        return "resetData." + error;
                                }
                            }
                            if (message.rolloverEndData != null && message.hasOwnProperty("rolloverEndData")) {
                                if (properties.ruleData === 1)
                                    return "ruleData: multiple values";
                                properties.ruleData = 1;
                                {
                                    var error = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.verify(message.rolloverEndData);
                                    if (error)
                                        return "rolloverEndData." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a GenerationScheduleAdditionalData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData} GenerationScheduleAdditionalData
                         */
                        GenerationScheduleAdditionalData.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData();
                            if (object.staffStartDateMs != null)
                                if ($util.Long)
                                    (message.staffStartDateMs = $util.Long.fromValue(object.staffStartDateMs)).unsigned = false;
                                else if (typeof object.staffStartDateMs === "string")
                                    message.staffStartDateMs = parseInt(object.staffStartDateMs, 10);
                                else if (typeof object.staffStartDateMs === "number")
                                    message.staffStartDateMs = object.staffStartDateMs;
                                else if (typeof object.staffStartDateMs === "object")
                                    message.staffStartDateMs = new $util.LongBits(object.staffStartDateMs.low >>> 0, object.staffStartDateMs.high >>> 0).toNumber();
                            if (object.accrualRule != null) {
                                if (typeof object.accrualRule !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.accrualRule: object expected");
                                message.accrualRule = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.fromObject(object.accrualRule);
                            }
                            if (object.fixedRule != null) {
                                if (typeof object.fixedRule !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.fixedRule: object expected");
                                message.fixedRule = $root.palexy.protobuf.timeoff.TimeOffFixedRule.fromObject(object.fixedRule);
                            }
                            if (object.resetData != null) {
                                if (typeof object.resetData !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.resetData: object expected");
                                message.resetData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.fromObject(object.resetData);
                            }
                            if (object.rolloverEndData != null) {
                                if (typeof object.rolloverEndData !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData.rolloverEndData: object expected");
                                message.rolloverEndData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.fromObject(object.rolloverEndData);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a GenerationScheduleAdditionalData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData} message GenerationScheduleAdditionalData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        GenerationScheduleAdditionalData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.staffStartDateMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.staffStartDateMs = options.longs === String ? "0" : 0;
                            if (message.staffStartDateMs != null && message.hasOwnProperty("staffStartDateMs"))
                                if (typeof message.staffStartDateMs === "number")
                                    object.staffStartDateMs = options.longs === String ? String(message.staffStartDateMs) : message.staffStartDateMs;
                                else
                                    object.staffStartDateMs = options.longs === String ? $util.Long.prototype.toString.call(message.staffStartDateMs) : options.longs === Number ? new $util.LongBits(message.staffStartDateMs.low >>> 0, message.staffStartDateMs.high >>> 0).toNumber() : message.staffStartDateMs;
                            if (message.accrualRule != null && message.hasOwnProperty("accrualRule")) {
                                object.accrualRule = $root.palexy.protobuf.timeoff.TimeOffAccrualRule.toObject(message.accrualRule, options);
                                if (options.oneofs)
                                    object.ruleData = "accrualRule";
                            }
                            if (message.fixedRule != null && message.hasOwnProperty("fixedRule")) {
                                object.fixedRule = $root.palexy.protobuf.timeoff.TimeOffFixedRule.toObject(message.fixedRule, options);
                                if (options.oneofs)
                                    object.ruleData = "fixedRule";
                            }
                            if (message.resetData != null && message.hasOwnProperty("resetData")) {
                                object.resetData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.toObject(message.resetData, options);
                                if (options.oneofs)
                                    object.ruleData = "resetData";
                            }
                            if (message.rolloverEndData != null && message.hasOwnProperty("rolloverEndData")) {
                                object.rolloverEndData = $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.toObject(message.rolloverEndData, options);
                                if (options.oneofs)
                                    object.ruleData = "rolloverEndData";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this GenerationScheduleAdditionalData to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.GenerationScheduleAdditionalData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        GenerationScheduleAdditionalData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return GenerationScheduleAdditionalData;
                    })();
    
                    TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData = (function() {
    
                        /**
                         * Properties of a ResetScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @interface IResetScheduleAdditionalData
                         * @property {palexy.protobuf.timeoff.ResetType|null} [resetType] ResetScheduleAdditionalData resetType
                         * @property {string|null} [resetDate] ResetScheduleAdditionalData resetDate
                         * @property {palexy.protobuf.timeoff.RolloverType|null} [rolloverType] ResetScheduleAdditionalData rolloverType
                         */
    
                        /**
                         * Constructs a new ResetScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @classdesc Represents a ResetScheduleAdditionalData.
                         * @implements IResetScheduleAdditionalData
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData=} [properties] Properties to set
                         */
                        function ResetScheduleAdditionalData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ResetScheduleAdditionalData resetType.
                         * @member {palexy.protobuf.timeoff.ResetType} resetType
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @instance
                         */
                        ResetScheduleAdditionalData.prototype.resetType = 0;
    
                        /**
                         * ResetScheduleAdditionalData resetDate.
                         * @member {string} resetDate
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @instance
                         */
                        ResetScheduleAdditionalData.prototype.resetDate = "";
    
                        /**
                         * ResetScheduleAdditionalData rolloverType.
                         * @member {palexy.protobuf.timeoff.RolloverType} rolloverType
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @instance
                         */
                        ResetScheduleAdditionalData.prototype.rolloverType = 0;
    
                        /**
                         * Creates a new ResetScheduleAdditionalData instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData} ResetScheduleAdditionalData instance
                         */
                        ResetScheduleAdditionalData.create = function create(properties) {
                            return new ResetScheduleAdditionalData(properties);
                        };
    
                        /**
                         * Encodes the specified ResetScheduleAdditionalData message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData} message ResetScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ResetScheduleAdditionalData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.resetType != null && Object.hasOwnProperty.call(message, "resetType"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.resetType);
                            if (message.resetDate != null && Object.hasOwnProperty.call(message, "resetDate"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.resetDate);
                            if (message.rolloverType != null && Object.hasOwnProperty.call(message, "rolloverType"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.rolloverType);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ResetScheduleAdditionalData message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IResetScheduleAdditionalData} message ResetScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ResetScheduleAdditionalData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ResetScheduleAdditionalData message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData} ResetScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ResetScheduleAdditionalData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.resetType = reader.int32();
                                    break;
                                case 2:
                                    message.resetDate = reader.string();
                                    break;
                                case 3:
                                    message.rolloverType = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ResetScheduleAdditionalData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData} ResetScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ResetScheduleAdditionalData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ResetScheduleAdditionalData message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ResetScheduleAdditionalData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.resetType != null && message.hasOwnProperty("resetType"))
                                switch (message.resetType) {
                                default:
                                    return "resetType: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.resetDate != null && message.hasOwnProperty("resetDate"))
                                if (!$util.isString(message.resetDate))
                                    return "resetDate: string expected";
                            if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                                switch (message.rolloverType) {
                                default:
                                    return "rolloverType: enum value expected";
                                case 0:
                                case 1:
                                    break;
                                }
                            return null;
                        };
    
                        /**
                         * Creates a ResetScheduleAdditionalData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData} ResetScheduleAdditionalData
                         */
                        ResetScheduleAdditionalData.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData();
                            switch (object.resetType) {
                            case "NONE_RESET_TYPE":
                            case 0:
                                message.resetType = 0;
                                break;
                            case "RESET_TO_ZERO":
                            case 1:
                                message.resetType = 1;
                                break;
                            case "RESET_TO_ENTITLEMENT":
                            case 2:
                                message.resetType = 2;
                                break;
                            }
                            if (object.resetDate != null)
                                message.resetDate = String(object.resetDate);
                            switch (object.rolloverType) {
                            case "NONE_ROLLOVER_TYPE":
                            case 0:
                                message.rolloverType = 0;
                                break;
                            case "ROLLOVER_ALL_CURRENT_BALANCE":
                            case 1:
                                message.rolloverType = 1;
                                break;
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ResetScheduleAdditionalData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData} message ResetScheduleAdditionalData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ResetScheduleAdditionalData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.resetType = options.enums === String ? "NONE_RESET_TYPE" : 0;
                                object.resetDate = "";
                                object.rolloverType = options.enums === String ? "NONE_ROLLOVER_TYPE" : 0;
                            }
                            if (message.resetType != null && message.hasOwnProperty("resetType"))
                                object.resetType = options.enums === String ? $root.palexy.protobuf.timeoff.ResetType[message.resetType] : message.resetType;
                            if (message.resetDate != null && message.hasOwnProperty("resetDate"))
                                object.resetDate = message.resetDate;
                            if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                                object.rolloverType = options.enums === String ? $root.palexy.protobuf.timeoff.RolloverType[message.rolloverType] : message.rolloverType;
                            return object;
                        };
    
                        /**
                         * Converts this ResetScheduleAdditionalData to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.ResetScheduleAdditionalData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ResetScheduleAdditionalData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ResetScheduleAdditionalData;
                    })();
    
                    TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData = (function() {
    
                        /**
                         * Properties of a RolloverEndScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @interface IRolloverEndScheduleAdditionalData
                         * @property {palexy.protobuf.timeoff.RolloverType|null} [rolloverType] RolloverEndScheduleAdditionalData rolloverType
                         * @property {string|null} [rolloverEndDate] RolloverEndScheduleAdditionalData rolloverEndDate
                         */
    
                        /**
                         * Constructs a new RolloverEndScheduleAdditionalData.
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule
                         * @classdesc Represents a RolloverEndScheduleAdditionalData.
                         * @implements IRolloverEndScheduleAdditionalData
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData=} [properties] Properties to set
                         */
                        function RolloverEndScheduleAdditionalData(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * RolloverEndScheduleAdditionalData rolloverType.
                         * @member {palexy.protobuf.timeoff.RolloverType} rolloverType
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @instance
                         */
                        RolloverEndScheduleAdditionalData.prototype.rolloverType = 0;
    
                        /**
                         * RolloverEndScheduleAdditionalData rolloverEndDate.
                         * @member {string} rolloverEndDate
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @instance
                         */
                        RolloverEndScheduleAdditionalData.prototype.rolloverEndDate = "";
    
                        /**
                         * Creates a new RolloverEndScheduleAdditionalData instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData} RolloverEndScheduleAdditionalData instance
                         */
                        RolloverEndScheduleAdditionalData.create = function create(properties) {
                            return new RolloverEndScheduleAdditionalData(properties);
                        };
    
                        /**
                         * Encodes the specified RolloverEndScheduleAdditionalData message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData} message RolloverEndScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        RolloverEndScheduleAdditionalData.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.rolloverType != null && Object.hasOwnProperty.call(message, "rolloverType"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.rolloverType);
                            if (message.rolloverEndDate != null && Object.hasOwnProperty.call(message, "rolloverEndDate"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.rolloverEndDate);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified RolloverEndScheduleAdditionalData message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.IRolloverEndScheduleAdditionalData} message RolloverEndScheduleAdditionalData message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        RolloverEndScheduleAdditionalData.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a RolloverEndScheduleAdditionalData message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData} RolloverEndScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        RolloverEndScheduleAdditionalData.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.rolloverType = reader.int32();
                                    break;
                                case 2:
                                    message.rolloverEndDate = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a RolloverEndScheduleAdditionalData message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData} RolloverEndScheduleAdditionalData
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        RolloverEndScheduleAdditionalData.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a RolloverEndScheduleAdditionalData message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        RolloverEndScheduleAdditionalData.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                                switch (message.rolloverType) {
                                default:
                                    return "rolloverType: enum value expected";
                                case 0:
                                case 1:
                                    break;
                                }
                            if (message.rolloverEndDate != null && message.hasOwnProperty("rolloverEndDate"))
                                if (!$util.isString(message.rolloverEndDate))
                                    return "rolloverEndDate: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a RolloverEndScheduleAdditionalData message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData} RolloverEndScheduleAdditionalData
                         */
                        RolloverEndScheduleAdditionalData.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData();
                            switch (object.rolloverType) {
                            case "NONE_ROLLOVER_TYPE":
                            case 0:
                                message.rolloverType = 0;
                                break;
                            case "ROLLOVER_ALL_CURRENT_BALANCE":
                            case 1:
                                message.rolloverType = 1;
                                break;
                            }
                            if (object.rolloverEndDate != null)
                                message.rolloverEndDate = String(object.rolloverEndDate);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a RolloverEndScheduleAdditionalData message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData} message RolloverEndScheduleAdditionalData
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        RolloverEndScheduleAdditionalData.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.rolloverType = options.enums === String ? "NONE_ROLLOVER_TYPE" : 0;
                                object.rolloverEndDate = "";
                            }
                            if (message.rolloverType != null && message.hasOwnProperty("rolloverType"))
                                object.rolloverType = options.enums === String ? $root.palexy.protobuf.timeoff.RolloverType[message.rolloverType] : message.rolloverType;
                            if (message.rolloverEndDate != null && message.hasOwnProperty("rolloverEndDate"))
                                object.rolloverEndDate = message.rolloverEndDate;
                            return object;
                        };
    
                        /**
                         * Converts this RolloverEndScheduleAdditionalData to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RolloverEndScheduleAdditionalData
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        RolloverEndScheduleAdditionalData.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return RolloverEndScheduleAdditionalData;
                    })();
    
                    /**
                     * RuleType enum.
                     * @name palexy.protobuf.timeoff.TimeOffBalanceGenerationSchedule.RuleType
                     * @enum {number}
                     * @property {number} RULE_TYPE_UNKNOWN=0 RULE_TYPE_UNKNOWN value
                     * @property {number} ACCRUAL=1 ACCRUAL value
                     * @property {number} FIXED=2 FIXED value
                     * @property {number} RESET=3 RESET value
                     * @property {number} ROLLOVER_END=4 ROLLOVER_END value
                     */
                    TimeOffBalanceGenerationSchedule.RuleType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "RULE_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "ACCRUAL"] = 1;
                        values[valuesById[2] = "FIXED"] = 2;
                        values[valuesById[3] = "RESET"] = 3;
                        values[valuesById[4] = "ROLLOVER_END"] = 4;
                        return values;
                    })();
    
                    return TimeOffBalanceGenerationSchedule;
                })();
    
                timeoff.TimeOffRequest = (function() {
    
                    /**
                     * Properties of a TimeOffRequest.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffRequest
                     * @property {number|null} [id] TimeOffRequest id
                     * @property {number|null} [staffId] TimeOffRequest staffId
                     * @property {number|null} [timeOffTypeId] TimeOffRequest timeOffTypeId
                     * @property {palexy.protobuf.timeoff.TimeOffRequest.RequestStatus|null} [status] TimeOffRequest status
                     * @property {string|null} [description] TimeOffRequest description
                     * @property {number|null} [createTimeMs] TimeOffRequest createTimeMs
                     * @property {number|null} [lastUpdateTimeMs] TimeOffRequest lastUpdateTimeMs
                     * @property {Array.<palexy.protobuf.timeoff.ITimeOffRequestItem>|null} [items] TimeOffRequest items
                     */
    
                    /**
                     * Constructs a new TimeOffRequest.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffRequest.
                     * @implements ITimeOffRequest
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffRequest=} [properties] Properties to set
                     */
                    function TimeOffRequest(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffRequest id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequest staffId.
                     * @member {number} staffId
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.staffId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequest timeOffTypeId.
                     * @member {number} timeOffTypeId
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.timeOffTypeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequest status.
                     * @member {palexy.protobuf.timeoff.TimeOffRequest.RequestStatus} status
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.status = 0;
    
                    /**
                     * TimeOffRequest description.
                     * @member {string} description
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.description = "";
    
                    /**
                     * TimeOffRequest createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequest lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequest items.
                     * @member {Array.<palexy.protobuf.timeoff.ITimeOffRequestItem>} items
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     */
                    TimeOffRequest.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new TimeOffRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequest=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffRequest} TimeOffRequest instance
                     */
                    TimeOffRequest.create = function create(properties) {
                        return new TimeOffRequest(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffRequest message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequest} message TimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.staffId != null && Object.hasOwnProperty.call(message, "staffId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.staffId);
                        if (message.timeOffTypeId != null && Object.hasOwnProperty.call(message, "timeOffTypeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.timeOffTypeId);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.status);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.description);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.protobuf.timeoff.TimeOffRequestItem.encode(message.items[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffRequest message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequest} message TimeOffRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffRequest} TimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.staffId = reader.int64();
                                break;
                            case 3:
                                message.timeOffTypeId = reader.int64();
                                break;
                            case 4:
                                message.status = reader.int32();
                                break;
                            case 5:
                                message.description = reader.string();
                                break;
                            case 6:
                                message.createTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.protobuf.timeoff.TimeOffRequestItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffRequest} TimeOffRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffRequest message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (!$util.isInteger(message.staffId) && !(message.staffId && $util.isInteger(message.staffId.low) && $util.isInteger(message.staffId.high)))
                                return "staffId: integer|Long expected";
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (!$util.isInteger(message.timeOffTypeId) && !(message.timeOffTypeId && $util.isInteger(message.timeOffTypeId.low) && $util.isInteger(message.timeOffTypeId.high)))
                                return "timeOffTypeId: integer|Long expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.TimeOffRequestItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffRequest} TimeOffRequest
                     */
                    TimeOffRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffRequest)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.staffId != null)
                            if ($util.Long)
                                (message.staffId = $util.Long.fromValue(object.staffId)).unsigned = false;
                            else if (typeof object.staffId === "string")
                                message.staffId = parseInt(object.staffId, 10);
                            else if (typeof object.staffId === "number")
                                message.staffId = object.staffId;
                            else if (typeof object.staffId === "object")
                                message.staffId = new $util.LongBits(object.staffId.low >>> 0, object.staffId.high >>> 0).toNumber();
                        if (object.timeOffTypeId != null)
                            if ($util.Long)
                                (message.timeOffTypeId = $util.Long.fromValue(object.timeOffTypeId)).unsigned = false;
                            else if (typeof object.timeOffTypeId === "string")
                                message.timeOffTypeId = parseInt(object.timeOffTypeId, 10);
                            else if (typeof object.timeOffTypeId === "number")
                                message.timeOffTypeId = object.timeOffTypeId;
                            else if (typeof object.timeOffTypeId === "object")
                                message.timeOffTypeId = new $util.LongBits(object.timeOffTypeId.low >>> 0, object.timeOffTypeId.high >>> 0).toNumber();
                        switch (object.status) {
                        case "REQUEST_STATUS_UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "PENDING":
                        case 1:
                            message.status = 1;
                            break;
                        case "APPROVED":
                        case 2:
                            message.status = 2;
                            break;
                        case "REJECTED":
                        case 3:
                            message.status = 3;
                            break;
                        case "CANCELLED":
                        case 4:
                            message.status = 4;
                            break;
                        }
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffRequest.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffRequest.items: object expected");
                                message.items[i] = $root.palexy.protobuf.timeoff.TimeOffRequestItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffRequest} message TimeOffRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.staffId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.staffId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.timeOffTypeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.timeOffTypeId = options.longs === String ? "0" : 0;
                            object.status = options.enums === String ? "REQUEST_STATUS_UNKNOWN" : 0;
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.staffId != null && message.hasOwnProperty("staffId"))
                            if (typeof message.staffId === "number")
                                object.staffId = options.longs === String ? String(message.staffId) : message.staffId;
                            else
                                object.staffId = options.longs === String ? $util.Long.prototype.toString.call(message.staffId) : options.longs === Number ? new $util.LongBits(message.staffId.low >>> 0, message.staffId.high >>> 0).toNumber() : message.staffId;
                        if (message.timeOffTypeId != null && message.hasOwnProperty("timeOffTypeId"))
                            if (typeof message.timeOffTypeId === "number")
                                object.timeOffTypeId = options.longs === String ? String(message.timeOffTypeId) : message.timeOffTypeId;
                            else
                                object.timeOffTypeId = options.longs === String ? $util.Long.prototype.toString.call(message.timeOffTypeId) : options.longs === Number ? new $util.LongBits(message.timeOffTypeId.low >>> 0, message.timeOffTypeId.high >>> 0).toNumber() : message.timeOffTypeId;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffRequest.RequestStatus[message.status] : message.status;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.protobuf.timeoff.TimeOffRequestItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * RequestStatus enum.
                     * @name palexy.protobuf.timeoff.TimeOffRequest.RequestStatus
                     * @enum {number}
                     * @property {number} REQUEST_STATUS_UNKNOWN=0 REQUEST_STATUS_UNKNOWN value
                     * @property {number} PENDING=1 PENDING value
                     * @property {number} APPROVED=2 APPROVED value
                     * @property {number} REJECTED=3 REJECTED value
                     * @property {number} CANCELLED=4 CANCELLED value
                     */
                    TimeOffRequest.RequestStatus = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "REQUEST_STATUS_UNKNOWN"] = 0;
                        values[valuesById[1] = "PENDING"] = 1;
                        values[valuesById[2] = "APPROVED"] = 2;
                        values[valuesById[3] = "REJECTED"] = 3;
                        values[valuesById[4] = "CANCELLED"] = 4;
                        return values;
                    })();
    
                    return TimeOffRequest;
                })();
    
                timeoff.TimeOffRequestItem = (function() {
    
                    /**
                     * Properties of a TimeOffRequestItem.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffRequestItem
                     * @property {number|null} [id] TimeOffRequestItem id
                     * @property {string|null} [startDateTime] TimeOffRequestItem startDateTime
                     * @property {string|null} [endDateTime] TimeOffRequestItem endDateTime
                     * @property {boolean|null} [isFullDay] TimeOffRequestItem isFullDay
                     * @property {boolean|null} [isNonWorkingDay] TimeOffRequestItem isNonWorkingDay
                     * @property {number|null} [amount] TimeOffRequestItem amount
                     * @property {number|null} [createTimeMs] TimeOffRequestItem createTimeMs
                     * @property {number|null} [amountInHours] TimeOffRequestItem amountInHours
                     */
    
                    /**
                     * Constructs a new TimeOffRequestItem.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffRequestItem.
                     * @implements ITimeOffRequestItem
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestItem=} [properties] Properties to set
                     */
                    function TimeOffRequestItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffRequestItem id.
                     * @member {number} id
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequestItem startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.startDateTime = "";
    
                    /**
                     * TimeOffRequestItem endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.endDateTime = "";
    
                    /**
                     * TimeOffRequestItem isFullDay.
                     * @member {boolean} isFullDay
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.isFullDay = false;
    
                    /**
                     * TimeOffRequestItem isNonWorkingDay.
                     * @member {boolean} isNonWorkingDay
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.isNonWorkingDay = false;
    
                    /**
                     * TimeOffRequestItem amount.
                     * @member {number} amount
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.amount = 0;
    
                    /**
                     * TimeOffRequestItem createTimeMs.
                     * @member {number} createTimeMs
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffRequestItem amountInHours.
                     * @member {number} amountInHours
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     */
                    TimeOffRequestItem.prototype.amountInHours = 0;
    
                    /**
                     * Creates a new TimeOffRequestItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestItem=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestItem} TimeOffRequestItem instance
                     */
                    TimeOffRequestItem.create = function create(properties) {
                        return new TimeOffRequestItem(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffRequestItem message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequestItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestItem} message TimeOffRequestItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequestItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateTime);
                        if (message.isFullDay != null && Object.hasOwnProperty.call(message, "isFullDay"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isFullDay);
                        if (message.isNonWorkingDay != null && Object.hasOwnProperty.call(message, "isNonWorkingDay"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isNonWorkingDay);
                        if (message.amount != null && Object.hasOwnProperty.call(message, "amount"))
                            writer.uint32(/* id 7, wireType 1 =*/57).double(message.amount);
                        if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                        if (message.amountInHours != null && Object.hasOwnProperty.call(message, "amountInHours"))
                            writer.uint32(/* id 9, wireType 1 =*/73).double(message.amountInHours);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffRequestItem message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequestItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestItem} message TimeOffRequestItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequestItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffRequestItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestItem} TimeOffRequestItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequestItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffRequestItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 3:
                                message.startDateTime = reader.string();
                                break;
                            case 4:
                                message.endDateTime = reader.string();
                                break;
                            case 5:
                                message.isFullDay = reader.bool();
                                break;
                            case 6:
                                message.isNonWorkingDay = reader.bool();
                                break;
                            case 7:
                                message.amount = reader.double();
                                break;
                            case 8:
                                message.createTimeMs = reader.int64();
                                break;
                            case 9:
                                message.amountInHours = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffRequestItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestItem} TimeOffRequestItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequestItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffRequestItem message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffRequestItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        if (message.isFullDay != null && message.hasOwnProperty("isFullDay"))
                            if (typeof message.isFullDay !== "boolean")
                                return "isFullDay: boolean expected";
                        if (message.isNonWorkingDay != null && message.hasOwnProperty("isNonWorkingDay"))
                            if (typeof message.isNonWorkingDay !== "boolean")
                                return "isNonWorkingDay: boolean expected";
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            if (typeof message.amount !== "number")
                                return "amount: number expected";
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                                return "createTimeMs: integer|Long expected";
                        if (message.amountInHours != null && message.hasOwnProperty("amountInHours"))
                            if (typeof message.amountInHours !== "number")
                                return "amountInHours: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffRequestItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestItem} TimeOffRequestItem
                     */
                    TimeOffRequestItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffRequestItem)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffRequestItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        if (object.isFullDay != null)
                            message.isFullDay = Boolean(object.isFullDay);
                        if (object.isNonWorkingDay != null)
                            message.isNonWorkingDay = Boolean(object.isNonWorkingDay);
                        if (object.amount != null)
                            message.amount = Number(object.amount);
                        if (object.createTimeMs != null)
                            if ($util.Long)
                                (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                            else if (typeof object.createTimeMs === "string")
                                message.createTimeMs = parseInt(object.createTimeMs, 10);
                            else if (typeof object.createTimeMs === "number")
                                message.createTimeMs = object.createTimeMs;
                            else if (typeof object.createTimeMs === "object")
                                message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                        if (object.amountInHours != null)
                            message.amountInHours = Number(object.amountInHours);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffRequestItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffRequestItem} message TimeOffRequestItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffRequestItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                            object.isFullDay = false;
                            object.isNonWorkingDay = false;
                            object.amount = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createTimeMs = options.longs === String ? "0" : 0;
                            object.amountInHours = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        if (message.isFullDay != null && message.hasOwnProperty("isFullDay"))
                            object.isFullDay = message.isFullDay;
                        if (message.isNonWorkingDay != null && message.hasOwnProperty("isNonWorkingDay"))
                            object.isNonWorkingDay = message.isNonWorkingDay;
                        if (message.amount != null && message.hasOwnProperty("amount"))
                            object.amount = options.json && !isFinite(message.amount) ? String(message.amount) : message.amount;
                        if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                            if (typeof message.createTimeMs === "number")
                                object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                            else
                                object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                        if (message.amountInHours != null && message.hasOwnProperty("amountInHours"))
                            object.amountInHours = options.json && !isFinite(message.amountInHours) ? String(message.amountInHours) : message.amountInHours;
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffRequestItem to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffRequestItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeOffRequestItem;
                })();
    
                timeoff.TimeOffRequestDetailInfo = (function() {
    
                    /**
                     * Properties of a TimeOffRequestDetailInfo.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffRequestDetailInfo
                     * @property {Array.<palexy.protobuf.timeoff.ITimeOffValidationError>|null} [errors] TimeOffRequestDetailInfo errors
                     * @property {Array.<palexy.protobuf.timeoff.ITimeOffValidationWarning>|null} [warnings] TimeOffRequestDetailInfo warnings
                     * @property {palexy.protobuf.timeoff.IRequestBalanceDetail|null} [requestBalanceDetail] TimeOffRequestDetailInfo requestBalanceDetail
                     * @property {Array.<palexy.protobuf.timeoff.IRequestItemBalanceDetail>|null} [itemBalanceDetails] TimeOffRequestDetailInfo itemBalanceDetails
                     */
    
                    /**
                     * Constructs a new TimeOffRequestDetailInfo.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffRequestDetailInfo.
                     * @implements ITimeOffRequestDetailInfo
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestDetailInfo=} [properties] Properties to set
                     */
                    function TimeOffRequestDetailInfo(properties) {
                        this.errors = [];
                        this.warnings = [];
                        this.itemBalanceDetails = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffRequestDetailInfo errors.
                     * @member {Array.<palexy.protobuf.timeoff.ITimeOffValidationError>} errors
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @instance
                     */
                    TimeOffRequestDetailInfo.prototype.errors = $util.emptyArray;
    
                    /**
                     * TimeOffRequestDetailInfo warnings.
                     * @member {Array.<palexy.protobuf.timeoff.ITimeOffValidationWarning>} warnings
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @instance
                     */
                    TimeOffRequestDetailInfo.prototype.warnings = $util.emptyArray;
    
                    /**
                     * TimeOffRequestDetailInfo requestBalanceDetail.
                     * @member {palexy.protobuf.timeoff.IRequestBalanceDetail|null|undefined} requestBalanceDetail
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @instance
                     */
                    TimeOffRequestDetailInfo.prototype.requestBalanceDetail = null;
    
                    /**
                     * TimeOffRequestDetailInfo itemBalanceDetails.
                     * @member {Array.<palexy.protobuf.timeoff.IRequestItemBalanceDetail>} itemBalanceDetails
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @instance
                     */
                    TimeOffRequestDetailInfo.prototype.itemBalanceDetails = $util.emptyArray;
    
                    /**
                     * Creates a new TimeOffRequestDetailInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestDetailInfo=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestDetailInfo} TimeOffRequestDetailInfo instance
                     */
                    TimeOffRequestDetailInfo.create = function create(properties) {
                        return new TimeOffRequestDetailInfo(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffRequestDetailInfo message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequestDetailInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestDetailInfo} message TimeOffRequestDetailInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequestDetailInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.errors != null && message.errors.length)
                            for (var i = 0; i < message.errors.length; ++i)
                                $root.palexy.protobuf.timeoff.TimeOffValidationError.encode(message.errors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.warnings != null && message.warnings.length)
                            for (var i = 0; i < message.warnings.length; ++i)
                                $root.palexy.protobuf.timeoff.TimeOffValidationWarning.encode(message.warnings[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.requestBalanceDetail != null && Object.hasOwnProperty.call(message, "requestBalanceDetail"))
                            $root.palexy.protobuf.timeoff.RequestBalanceDetail.encode(message.requestBalanceDetail, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.itemBalanceDetails != null && message.itemBalanceDetails.length)
                            for (var i = 0; i < message.itemBalanceDetails.length; ++i)
                                $root.palexy.protobuf.timeoff.RequestItemBalanceDetail.encode(message.itemBalanceDetails[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffRequestDetailInfo message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffRequestDetailInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffRequestDetailInfo} message TimeOffRequestDetailInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffRequestDetailInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffRequestDetailInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestDetailInfo} TimeOffRequestDetailInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequestDetailInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffRequestDetailInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.errors && message.errors.length))
                                    message.errors = [];
                                message.errors.push($root.palexy.protobuf.timeoff.TimeOffValidationError.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.warnings && message.warnings.length))
                                    message.warnings = [];
                                message.warnings.push($root.palexy.protobuf.timeoff.TimeOffValidationWarning.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.requestBalanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.decode(reader, reader.uint32());
                                break;
                            case 4:
                                if (!(message.itemBalanceDetails && message.itemBalanceDetails.length))
                                    message.itemBalanceDetails = [];
                                message.itemBalanceDetails.push($root.palexy.protobuf.timeoff.RequestItemBalanceDetail.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffRequestDetailInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestDetailInfo} TimeOffRequestDetailInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffRequestDetailInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffRequestDetailInfo message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffRequestDetailInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.errors != null && message.hasOwnProperty("errors")) {
                            if (!Array.isArray(message.errors))
                                return "errors: array expected";
                            for (var i = 0; i < message.errors.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.TimeOffValidationError.verify(message.errors[i]);
                                if (error)
                                    return "errors." + error;
                            }
                        }
                        if (message.warnings != null && message.hasOwnProperty("warnings")) {
                            if (!Array.isArray(message.warnings))
                                return "warnings: array expected";
                            for (var i = 0; i < message.warnings.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.verify(message.warnings[i]);
                                if (error)
                                    return "warnings." + error;
                            }
                        }
                        if (message.requestBalanceDetail != null && message.hasOwnProperty("requestBalanceDetail")) {
                            var error = $root.palexy.protobuf.timeoff.RequestBalanceDetail.verify(message.requestBalanceDetail);
                            if (error)
                                return "requestBalanceDetail." + error;
                        }
                        if (message.itemBalanceDetails != null && message.hasOwnProperty("itemBalanceDetails")) {
                            if (!Array.isArray(message.itemBalanceDetails))
                                return "itemBalanceDetails: array expected";
                            for (var i = 0; i < message.itemBalanceDetails.length; ++i) {
                                var error = $root.palexy.protobuf.timeoff.RequestItemBalanceDetail.verify(message.itemBalanceDetails[i]);
                                if (error)
                                    return "itemBalanceDetails." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffRequestDetailInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffRequestDetailInfo} TimeOffRequestDetailInfo
                     */
                    TimeOffRequestDetailInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffRequestDetailInfo)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffRequestDetailInfo();
                        if (object.errors) {
                            if (!Array.isArray(object.errors))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.errors: array expected");
                            message.errors = [];
                            for (var i = 0; i < object.errors.length; ++i) {
                                if (typeof object.errors[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.errors: object expected");
                                message.errors[i] = $root.palexy.protobuf.timeoff.TimeOffValidationError.fromObject(object.errors[i]);
                            }
                        }
                        if (object.warnings) {
                            if (!Array.isArray(object.warnings))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.warnings: array expected");
                            message.warnings = [];
                            for (var i = 0; i < object.warnings.length; ++i) {
                                if (typeof object.warnings[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.warnings: object expected");
                                message.warnings[i] = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.fromObject(object.warnings[i]);
                            }
                        }
                        if (object.requestBalanceDetail != null) {
                            if (typeof object.requestBalanceDetail !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.requestBalanceDetail: object expected");
                            message.requestBalanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.fromObject(object.requestBalanceDetail);
                        }
                        if (object.itemBalanceDetails) {
                            if (!Array.isArray(object.itemBalanceDetails))
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.itemBalanceDetails: array expected");
                            message.itemBalanceDetails = [];
                            for (var i = 0; i < object.itemBalanceDetails.length; ++i) {
                                if (typeof object.itemBalanceDetails[i] !== "object")
                                    throw TypeError(".palexy.protobuf.timeoff.TimeOffRequestDetailInfo.itemBalanceDetails: object expected");
                                message.itemBalanceDetails[i] = $root.palexy.protobuf.timeoff.RequestItemBalanceDetail.fromObject(object.itemBalanceDetails[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffRequestDetailInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffRequestDetailInfo} message TimeOffRequestDetailInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffRequestDetailInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.errors = [];
                            object.warnings = [];
                            object.itemBalanceDetails = [];
                        }
                        if (options.defaults)
                            object.requestBalanceDetail = null;
                        if (message.errors && message.errors.length) {
                            object.errors = [];
                            for (var j = 0; j < message.errors.length; ++j)
                                object.errors[j] = $root.palexy.protobuf.timeoff.TimeOffValidationError.toObject(message.errors[j], options);
                        }
                        if (message.warnings && message.warnings.length) {
                            object.warnings = [];
                            for (var j = 0; j < message.warnings.length; ++j)
                                object.warnings[j] = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.toObject(message.warnings[j], options);
                        }
                        if (message.requestBalanceDetail != null && message.hasOwnProperty("requestBalanceDetail"))
                            object.requestBalanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.toObject(message.requestBalanceDetail, options);
                        if (message.itemBalanceDetails && message.itemBalanceDetails.length) {
                            object.itemBalanceDetails = [];
                            for (var j = 0; j < message.itemBalanceDetails.length; ++j)
                                object.itemBalanceDetails[j] = $root.palexy.protobuf.timeoff.RequestItemBalanceDetail.toObject(message.itemBalanceDetails[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffRequestDetailInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffRequestDetailInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffRequestDetailInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TimeOffRequestDetailInfo;
                })();
    
                timeoff.TimeOffValidationError = (function() {
    
                    /**
                     * Properties of a TimeOffValidationError.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffValidationError
                     * @property {palexy.protobuf.timeoff.TimeOffValidationError.ErrorType|null} [type] TimeOffValidationError type
                     * @property {string|null} [message] TimeOffValidationError message
                     * @property {number|null} [itemId] TimeOffValidationError itemId
                     * @property {number|null} [dateId] TimeOffValidationError dateId
                     * @property {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail|null} [shiftConflict] TimeOffValidationError shiftConflict
                     * @property {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail|null} [timeOffConflict] TimeOffValidationError timeOffConflict
                     */
    
                    /**
                     * Constructs a new TimeOffValidationError.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffValidationError.
                     * @implements ITimeOffValidationError
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationError=} [properties] Properties to set
                     */
                    function TimeOffValidationError(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffValidationError type.
                     * @member {palexy.protobuf.timeoff.TimeOffValidationError.ErrorType} type
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.type = 0;
    
                    /**
                     * TimeOffValidationError message.
                     * @member {string} message
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.message = "";
    
                    /**
                     * TimeOffValidationError itemId.
                     * @member {number} itemId
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.itemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffValidationError dateId.
                     * @member {number} dateId
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.dateId = 0;
    
                    /**
                     * TimeOffValidationError shiftConflict.
                     * @member {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail|null|undefined} shiftConflict
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.shiftConflict = null;
    
                    /**
                     * TimeOffValidationError timeOffConflict.
                     * @member {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail|null|undefined} timeOffConflict
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    TimeOffValidationError.prototype.timeOffConflict = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * TimeOffValidationError details.
                     * @member {"shiftConflict"|"timeOffConflict"|undefined} details
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     */
                    Object.defineProperty(TimeOffValidationError.prototype, "details", {
                        get: $util.oneOfGetter($oneOfFields = ["shiftConflict", "timeOffConflict"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new TimeOffValidationError instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationError=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationError} TimeOffValidationError instance
                     */
                    TimeOffValidationError.create = function create(properties) {
                        return new TimeOffValidationError(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffValidationError message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationError} message TimeOffValidationError message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffValidationError.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.message != null && Object.hasOwnProperty.call(message, "message"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.message);
                        if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.itemId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.dateId);
                        if (message.shiftConflict != null && Object.hasOwnProperty.call(message, "shiftConflict"))
                            $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.encode(message.shiftConflict, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.timeOffConflict != null && Object.hasOwnProperty.call(message, "timeOffConflict"))
                            $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.encode(message.timeOffConflict, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffValidationError message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationError} message TimeOffValidationError message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffValidationError.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffValidationError message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationError} TimeOffValidationError
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffValidationError.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffValidationError();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.message = reader.string();
                                break;
                            case 3:
                                message.itemId = reader.int64();
                                break;
                            case 4:
                                message.dateId = reader.int32();
                                break;
                            case 5:
                                message.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.timeOffConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffValidationError message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationError} TimeOffValidationError
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffValidationError.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffValidationError message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffValidationError.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.message != null && message.hasOwnProperty("message"))
                            if (!$util.isString(message.message))
                                return "message: string expected";
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (!$util.isInteger(message.itemId) && !(message.itemId && $util.isInteger(message.itemId.low) && $util.isInteger(message.itemId.high)))
                                return "itemId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.shiftConflict != null && message.hasOwnProperty("shiftConflict")) {
                            properties.details = 1;
                            {
                                var error = $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.verify(message.shiftConflict);
                                if (error)
                                    return "shiftConflict." + error;
                            }
                        }
                        if (message.timeOffConflict != null && message.hasOwnProperty("timeOffConflict")) {
                            if (properties.details === 1)
                                return "details: multiple values";
                            properties.details = 1;
                            {
                                var error = $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.verify(message.timeOffConflict);
                                if (error)
                                    return "timeOffConflict." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffValidationError message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationError} TimeOffValidationError
                     */
                    TimeOffValidationError.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffValidationError)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffValidationError();
                        switch (object.type) {
                        case "UNSPECIFIED_ERROR_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "SHIFT_CONFLICT":
                        case 1:
                            message.type = 1;
                            break;
                        case "TIME_OFF_CONFLICT":
                        case 2:
                            message.type = 2;
                            break;
                        case "INSUFFICIENT_BALANCE":
                        case 3:
                            message.type = 3;
                            break;
                        case "SHIFT_HAS_PENDING_DRAFT":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.message != null)
                            message.message = String(object.message);
                        if (object.itemId != null)
                            if ($util.Long)
                                (message.itemId = $util.Long.fromValue(object.itemId)).unsigned = false;
                            else if (typeof object.itemId === "string")
                                message.itemId = parseInt(object.itemId, 10);
                            else if (typeof object.itemId === "number")
                                message.itemId = object.itemId;
                            else if (typeof object.itemId === "object")
                                message.itemId = new $util.LongBits(object.itemId.low >>> 0, object.itemId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.shiftConflict != null) {
                            if (typeof object.shiftConflict !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffValidationError.shiftConflict: object expected");
                            message.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.fromObject(object.shiftConflict);
                        }
                        if (object.timeOffConflict != null) {
                            if (typeof object.timeOffConflict !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffValidationError.timeOffConflict: object expected");
                            message.timeOffConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.fromObject(object.timeOffConflict);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffValidationError message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffValidationError} message TimeOffValidationError
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffValidationError.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNSPECIFIED_ERROR_TYPE" : 0;
                            object.message = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.itemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.itemId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffValidationError.ErrorType[message.type] : message.type;
                        if (message.message != null && message.hasOwnProperty("message"))
                            object.message = message.message;
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (typeof message.itemId === "number")
                                object.itemId = options.longs === String ? String(message.itemId) : message.itemId;
                            else
                                object.itemId = options.longs === String ? $util.Long.prototype.toString.call(message.itemId) : options.longs === Number ? new $util.LongBits(message.itemId.low >>> 0, message.itemId.high >>> 0).toNumber() : message.itemId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.shiftConflict != null && message.hasOwnProperty("shiftConflict")) {
                            object.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.toObject(message.shiftConflict, options);
                            if (options.oneofs)
                                object.details = "shiftConflict";
                        }
                        if (message.timeOffConflict != null && message.hasOwnProperty("timeOffConflict")) {
                            object.timeOffConflict = $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.toObject(message.timeOffConflict, options);
                            if (options.oneofs)
                                object.details = "timeOffConflict";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffValidationError to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffValidationError.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ErrorType enum.
                     * @name palexy.protobuf.timeoff.TimeOffValidationError.ErrorType
                     * @enum {number}
                     * @property {number} UNSPECIFIED_ERROR_TYPE=0 UNSPECIFIED_ERROR_TYPE value
                     * @property {number} SHIFT_CONFLICT=1 SHIFT_CONFLICT value
                     * @property {number} TIME_OFF_CONFLICT=2 TIME_OFF_CONFLICT value
                     * @property {number} INSUFFICIENT_BALANCE=3 INSUFFICIENT_BALANCE value
                     * @property {number} SHIFT_HAS_PENDING_DRAFT=4 SHIFT_HAS_PENDING_DRAFT value
                     */
                    TimeOffValidationError.ErrorType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED_ERROR_TYPE"] = 0;
                        values[valuesById[1] = "SHIFT_CONFLICT"] = 1;
                        values[valuesById[2] = "TIME_OFF_CONFLICT"] = 2;
                        values[valuesById[3] = "INSUFFICIENT_BALANCE"] = 3;
                        values[valuesById[4] = "SHIFT_HAS_PENDING_DRAFT"] = 4;
                        return values;
                    })();
    
                    TimeOffValidationError.ShiftConflictDetail = (function() {
    
                        /**
                         * Properties of a ShiftConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                         * @interface IShiftConflictDetail
                         * @property {string|null} [shiftStartTime] ShiftConflictDetail shiftStartTime
                         * @property {string|null} [shiftEndTime] ShiftConflictDetail shiftEndTime
                         */
    
                        /**
                         * Constructs a new ShiftConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                         * @classdesc Represents a ShiftConflictDetail.
                         * @implements IShiftConflictDetail
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail=} [properties] Properties to set
                         */
                        function ShiftConflictDetail(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ShiftConflictDetail shiftStartTime.
                         * @member {string} shiftStartTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @instance
                         */
                        ShiftConflictDetail.prototype.shiftStartTime = "";
    
                        /**
                         * ShiftConflictDetail shiftEndTime.
                         * @member {string} shiftEndTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @instance
                         */
                        ShiftConflictDetail.prototype.shiftEndTime = "";
    
                        /**
                         * Creates a new ShiftConflictDetail instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail} ShiftConflictDetail instance
                         */
                        ShiftConflictDetail.create = function create(properties) {
                            return new ShiftConflictDetail(properties);
                        };
    
                        /**
                         * Encodes the specified ShiftConflictDetail message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail} message ShiftConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftConflictDetail.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.shiftStartTime != null && Object.hasOwnProperty.call(message, "shiftStartTime"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.shiftStartTime);
                            if (message.shiftEndTime != null && Object.hasOwnProperty.call(message, "shiftEndTime"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shiftEndTime);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ShiftConflictDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.IShiftConflictDetail} message ShiftConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftConflictDetail.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ShiftConflictDetail message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail} ShiftConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftConflictDetail.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.shiftStartTime = reader.string();
                                    break;
                                case 2:
                                    message.shiftEndTime = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ShiftConflictDetail message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail} ShiftConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftConflictDetail.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ShiftConflictDetail message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ShiftConflictDetail.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                if (!$util.isString(message.shiftStartTime))
                                    return "shiftStartTime: string expected";
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                if (!$util.isString(message.shiftEndTime))
                                    return "shiftEndTime: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a ShiftConflictDetail message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail} ShiftConflictDetail
                         */
                        ShiftConflictDetail.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail();
                            if (object.shiftStartTime != null)
                                message.shiftStartTime = String(object.shiftStartTime);
                            if (object.shiftEndTime != null)
                                message.shiftEndTime = String(object.shiftEndTime);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ShiftConflictDetail message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail} message ShiftConflictDetail
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ShiftConflictDetail.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.shiftStartTime = "";
                                object.shiftEndTime = "";
                            }
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                object.shiftStartTime = message.shiftStartTime;
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                object.shiftEndTime = message.shiftEndTime;
                            return object;
                        };
    
                        /**
                         * Converts this ShiftConflictDetail to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.ShiftConflictDetail
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ShiftConflictDetail.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ShiftConflictDetail;
                    })();
    
                    TimeOffValidationError.TimeOffConflictDetail = (function() {
    
                        /**
                         * Properties of a TimeOffConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                         * @interface ITimeOffConflictDetail
                         * @property {string|null} [shiftStartTime] TimeOffConflictDetail shiftStartTime
                         * @property {string|null} [shiftEndTime] TimeOffConflictDetail shiftEndTime
                         */
    
                        /**
                         * Constructs a new TimeOffConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError
                         * @classdesc Represents a TimeOffConflictDetail.
                         * @implements ITimeOffConflictDetail
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail=} [properties] Properties to set
                         */
                        function TimeOffConflictDetail(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TimeOffConflictDetail shiftStartTime.
                         * @member {string} shiftStartTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @instance
                         */
                        TimeOffConflictDetail.prototype.shiftStartTime = "";
    
                        /**
                         * TimeOffConflictDetail shiftEndTime.
                         * @member {string} shiftEndTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @instance
                         */
                        TimeOffConflictDetail.prototype.shiftEndTime = "";
    
                        /**
                         * Creates a new TimeOffConflictDetail instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail} TimeOffConflictDetail instance
                         */
                        TimeOffConflictDetail.create = function create(properties) {
                            return new TimeOffConflictDetail(properties);
                        };
    
                        /**
                         * Encodes the specified TimeOffConflictDetail message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail} message TimeOffConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TimeOffConflictDetail.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.shiftStartTime != null && Object.hasOwnProperty.call(message, "shiftStartTime"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.shiftStartTime);
                            if (message.shiftEndTime != null && Object.hasOwnProperty.call(message, "shiftEndTime"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shiftEndTime);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TimeOffConflictDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.ITimeOffConflictDetail} message TimeOffConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TimeOffConflictDetail.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TimeOffConflictDetail message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail} TimeOffConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TimeOffConflictDetail.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.shiftStartTime = reader.string();
                                    break;
                                case 2:
                                    message.shiftEndTime = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TimeOffConflictDetail message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail} TimeOffConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TimeOffConflictDetail.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TimeOffConflictDetail message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TimeOffConflictDetail.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                if (!$util.isString(message.shiftStartTime))
                                    return "shiftStartTime: string expected";
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                if (!$util.isString(message.shiftEndTime))
                                    return "shiftEndTime: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a TimeOffConflictDetail message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail} TimeOffConflictDetail
                         */
                        TimeOffConflictDetail.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail();
                            if (object.shiftStartTime != null)
                                message.shiftStartTime = String(object.shiftStartTime);
                            if (object.shiftEndTime != null)
                                message.shiftEndTime = String(object.shiftEndTime);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TimeOffConflictDetail message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail} message TimeOffConflictDetail
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TimeOffConflictDetail.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.shiftStartTime = "";
                                object.shiftEndTime = "";
                            }
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                object.shiftStartTime = message.shiftStartTime;
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                object.shiftEndTime = message.shiftEndTime;
                            return object;
                        };
    
                        /**
                         * Converts this TimeOffConflictDetail to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationError.TimeOffConflictDetail
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TimeOffConflictDetail.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TimeOffConflictDetail;
                    })();
    
                    return TimeOffValidationError;
                })();
    
                timeoff.TimeOffValidationWarning = (function() {
    
                    /**
                     * Properties of a TimeOffValidationWarning.
                     * @memberof palexy.protobuf.timeoff
                     * @interface ITimeOffValidationWarning
                     * @property {palexy.protobuf.timeoff.TimeOffValidationWarning.WarningType|null} [type] TimeOffValidationWarning type
                     * @property {number|null} [itemId] TimeOffValidationWarning itemId
                     * @property {number|null} [dateId] TimeOffValidationWarning dateId
                     * @property {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail|null} [shiftConflict] TimeOffValidationWarning shiftConflict
                     */
    
                    /**
                     * Constructs a new TimeOffValidationWarning.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a TimeOffValidationWarning.
                     * @implements ITimeOffValidationWarning
                     * @constructor
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationWarning=} [properties] Properties to set
                     */
                    function TimeOffValidationWarning(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TimeOffValidationWarning type.
                     * @member {palexy.protobuf.timeoff.TimeOffValidationWarning.WarningType} type
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     */
                    TimeOffValidationWarning.prototype.type = 0;
    
                    /**
                     * TimeOffValidationWarning itemId.
                     * @member {number} itemId
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     */
                    TimeOffValidationWarning.prototype.itemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TimeOffValidationWarning dateId.
                     * @member {number} dateId
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     */
                    TimeOffValidationWarning.prototype.dateId = 0;
    
                    /**
                     * TimeOffValidationWarning shiftConflict.
                     * @member {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail|null|undefined} shiftConflict
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     */
                    TimeOffValidationWarning.prototype.shiftConflict = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * TimeOffValidationWarning details.
                     * @member {"shiftConflict"|undefined} details
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     */
                    Object.defineProperty(TimeOffValidationWarning.prototype, "details", {
                        get: $util.oneOfGetter($oneOfFields = ["shiftConflict"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new TimeOffValidationWarning instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationWarning=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning} TimeOffValidationWarning instance
                     */
                    TimeOffValidationWarning.create = function create(properties) {
                        return new TimeOffValidationWarning(properties);
                    };
    
                    /**
                     * Encodes the specified TimeOffValidationWarning message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationWarning.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationWarning} message TimeOffValidationWarning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffValidationWarning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.itemId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.dateId);
                        if (message.shiftConflict != null && Object.hasOwnProperty.call(message, "shiftConflict"))
                            $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.encode(message.shiftConflict, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TimeOffValidationWarning message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationWarning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {palexy.protobuf.timeoff.ITimeOffValidationWarning} message TimeOffValidationWarning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TimeOffValidationWarning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TimeOffValidationWarning message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning} TimeOffValidationWarning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffValidationWarning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffValidationWarning();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.itemId = reader.int64();
                                break;
                            case 3:
                                message.dateId = reader.int32();
                                break;
                            case 4:
                                message.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TimeOffValidationWarning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning} TimeOffValidationWarning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TimeOffValidationWarning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TimeOffValidationWarning message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TimeOffValidationWarning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (!$util.isInteger(message.itemId) && !(message.itemId && $util.isInteger(message.itemId.low) && $util.isInteger(message.itemId.high)))
                                return "itemId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.shiftConflict != null && message.hasOwnProperty("shiftConflict")) {
                            properties.details = 1;
                            {
                                var error = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.verify(message.shiftConflict);
                                if (error)
                                    return "shiftConflict." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TimeOffValidationWarning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning} TimeOffValidationWarning
                     */
                    TimeOffValidationWarning.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.TimeOffValidationWarning)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.TimeOffValidationWarning();
                        switch (object.type) {
                        case "UNSPECIFIED_INFO_TYPE":
                        case 0:
                            message.type = 0;
                            break;
                        case "RESET_HAPPENED":
                        case 1:
                            message.type = 1;
                            break;
                        case "ROLLOVER_HAPPENED":
                        case 2:
                            message.type = 2;
                            break;
                        case "ROLLOVER_END":
                        case 3:
                            message.type = 3;
                            break;
                        case "SHIFT_CONFLICT":
                        case 4:
                            message.type = 4;
                            break;
                        }
                        if (object.itemId != null)
                            if ($util.Long)
                                (message.itemId = $util.Long.fromValue(object.itemId)).unsigned = false;
                            else if (typeof object.itemId === "string")
                                message.itemId = parseInt(object.itemId, 10);
                            else if (typeof object.itemId === "number")
                                message.itemId = object.itemId;
                            else if (typeof object.itemId === "object")
                                message.itemId = new $util.LongBits(object.itemId.low >>> 0, object.itemId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.shiftConflict != null) {
                            if (typeof object.shiftConflict !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.TimeOffValidationWarning.shiftConflict: object expected");
                            message.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.fromObject(object.shiftConflict);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TimeOffValidationWarning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @static
                     * @param {palexy.protobuf.timeoff.TimeOffValidationWarning} message TimeOffValidationWarning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TimeOffValidationWarning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.type = options.enums === String ? "UNSPECIFIED_INFO_TYPE" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.itemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.itemId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.protobuf.timeoff.TimeOffValidationWarning.WarningType[message.type] : message.type;
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (typeof message.itemId === "number")
                                object.itemId = options.longs === String ? String(message.itemId) : message.itemId;
                            else
                                object.itemId = options.longs === String ? $util.Long.prototype.toString.call(message.itemId) : options.longs === Number ? new $util.LongBits(message.itemId.low >>> 0, message.itemId.high >>> 0).toNumber() : message.itemId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.shiftConflict != null && message.hasOwnProperty("shiftConflict")) {
                            object.shiftConflict = $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.toObject(message.shiftConflict, options);
                            if (options.oneofs)
                                object.details = "shiftConflict";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TimeOffValidationWarning to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TimeOffValidationWarning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * WarningType enum.
                     * @name palexy.protobuf.timeoff.TimeOffValidationWarning.WarningType
                     * @enum {number}
                     * @property {number} UNSPECIFIED_INFO_TYPE=0 UNSPECIFIED_INFO_TYPE value
                     * @property {number} RESET_HAPPENED=1 RESET_HAPPENED value
                     * @property {number} ROLLOVER_HAPPENED=2 ROLLOVER_HAPPENED value
                     * @property {number} ROLLOVER_END=3 ROLLOVER_END value
                     * @property {number} SHIFT_CONFLICT=4 SHIFT_CONFLICT value
                     */
                    TimeOffValidationWarning.WarningType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNSPECIFIED_INFO_TYPE"] = 0;
                        values[valuesById[1] = "RESET_HAPPENED"] = 1;
                        values[valuesById[2] = "ROLLOVER_HAPPENED"] = 2;
                        values[valuesById[3] = "ROLLOVER_END"] = 3;
                        values[valuesById[4] = "SHIFT_CONFLICT"] = 4;
                        return values;
                    })();
    
                    TimeOffValidationWarning.ShiftConflictDetail = (function() {
    
                        /**
                         * Properties of a ShiftConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                         * @interface IShiftConflictDetail
                         * @property {string|null} [shiftStartTime] ShiftConflictDetail shiftStartTime
                         * @property {string|null} [shiftEndTime] ShiftConflictDetail shiftEndTime
                         * @property {boolean|null} [linkedRecordAlreadyClockedIn] ShiftConflictDetail linkedRecordAlreadyClockedIn
                         */
    
                        /**
                         * Constructs a new ShiftConflictDetail.
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning
                         * @classdesc Represents a ShiftConflictDetail.
                         * @implements IShiftConflictDetail
                         * @constructor
                         * @param {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail=} [properties] Properties to set
                         */
                        function ShiftConflictDetail(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * ShiftConflictDetail shiftStartTime.
                         * @member {string} shiftStartTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @instance
                         */
                        ShiftConflictDetail.prototype.shiftStartTime = "";
    
                        /**
                         * ShiftConflictDetail shiftEndTime.
                         * @member {string} shiftEndTime
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @instance
                         */
                        ShiftConflictDetail.prototype.shiftEndTime = "";
    
                        /**
                         * ShiftConflictDetail linkedRecordAlreadyClockedIn.
                         * @member {boolean} linkedRecordAlreadyClockedIn
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @instance
                         */
                        ShiftConflictDetail.prototype.linkedRecordAlreadyClockedIn = false;
    
                        /**
                         * Creates a new ShiftConflictDetail instance using the specified properties.
                         * @function create
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail=} [properties] Properties to set
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail} ShiftConflictDetail instance
                         */
                        ShiftConflictDetail.create = function create(properties) {
                            return new ShiftConflictDetail(properties);
                        };
    
                        /**
                         * Encodes the specified ShiftConflictDetail message. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail} message ShiftConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftConflictDetail.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.shiftStartTime != null && Object.hasOwnProperty.call(message, "shiftStartTime"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.shiftStartTime);
                            if (message.shiftEndTime != null && Object.hasOwnProperty.call(message, "shiftEndTime"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.shiftEndTime);
                            if (message.linkedRecordAlreadyClockedIn != null && Object.hasOwnProperty.call(message, "linkedRecordAlreadyClockedIn"))
                                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.linkedRecordAlreadyClockedIn);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified ShiftConflictDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationWarning.IShiftConflictDetail} message ShiftConflictDetail message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        ShiftConflictDetail.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a ShiftConflictDetail message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail} ShiftConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftConflictDetail.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.shiftStartTime = reader.string();
                                    break;
                                case 2:
                                    message.shiftEndTime = reader.string();
                                    break;
                                case 3:
                                    message.linkedRecordAlreadyClockedIn = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a ShiftConflictDetail message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail} ShiftConflictDetail
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        ShiftConflictDetail.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a ShiftConflictDetail message.
                         * @function verify
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        ShiftConflictDetail.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                if (!$util.isString(message.shiftStartTime))
                                    return "shiftStartTime: string expected";
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                if (!$util.isString(message.shiftEndTime))
                                    return "shiftEndTime: string expected";
                            if (message.linkedRecordAlreadyClockedIn != null && message.hasOwnProperty("linkedRecordAlreadyClockedIn"))
                                if (typeof message.linkedRecordAlreadyClockedIn !== "boolean")
                                    return "linkedRecordAlreadyClockedIn: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a ShiftConflictDetail message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail} ShiftConflictDetail
                         */
                        ShiftConflictDetail.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail)
                                return object;
                            var message = new $root.palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail();
                            if (object.shiftStartTime != null)
                                message.shiftStartTime = String(object.shiftStartTime);
                            if (object.shiftEndTime != null)
                                message.shiftEndTime = String(object.shiftEndTime);
                            if (object.linkedRecordAlreadyClockedIn != null)
                                message.linkedRecordAlreadyClockedIn = Boolean(object.linkedRecordAlreadyClockedIn);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a ShiftConflictDetail message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @static
                         * @param {palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail} message ShiftConflictDetail
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        ShiftConflictDetail.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.shiftStartTime = "";
                                object.shiftEndTime = "";
                                object.linkedRecordAlreadyClockedIn = false;
                            }
                            if (message.shiftStartTime != null && message.hasOwnProperty("shiftStartTime"))
                                object.shiftStartTime = message.shiftStartTime;
                            if (message.shiftEndTime != null && message.hasOwnProperty("shiftEndTime"))
                                object.shiftEndTime = message.shiftEndTime;
                            if (message.linkedRecordAlreadyClockedIn != null && message.hasOwnProperty("linkedRecordAlreadyClockedIn"))
                                object.linkedRecordAlreadyClockedIn = message.linkedRecordAlreadyClockedIn;
                            return object;
                        };
    
                        /**
                         * Converts this ShiftConflictDetail to JSON.
                         * @function toJSON
                         * @memberof palexy.protobuf.timeoff.TimeOffValidationWarning.ShiftConflictDetail
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        ShiftConflictDetail.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return ShiftConflictDetail;
                    })();
    
                    return TimeOffValidationWarning;
                })();
    
                timeoff.RequestItemBalanceDetail = (function() {
    
                    /**
                     * Properties of a RequestItemBalanceDetail.
                     * @memberof palexy.protobuf.timeoff
                     * @interface IRequestItemBalanceDetail
                     * @property {number|null} [itemId] RequestItemBalanceDetail itemId
                     * @property {number|null} [dateId] RequestItemBalanceDetail dateId
                     * @property {palexy.protobuf.timeoff.IRequestBalanceDetail|null} [balanceDetail] RequestItemBalanceDetail balanceDetail
                     */
    
                    /**
                     * Constructs a new RequestItemBalanceDetail.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a RequestItemBalanceDetail.
                     * @implements IRequestItemBalanceDetail
                     * @constructor
                     * @param {palexy.protobuf.timeoff.IRequestItemBalanceDetail=} [properties] Properties to set
                     */
                    function RequestItemBalanceDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RequestItemBalanceDetail itemId.
                     * @member {number} itemId
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @instance
                     */
                    RequestItemBalanceDetail.prototype.itemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RequestItemBalanceDetail dateId.
                     * @member {number} dateId
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @instance
                     */
                    RequestItemBalanceDetail.prototype.dateId = 0;
    
                    /**
                     * RequestItemBalanceDetail balanceDetail.
                     * @member {palexy.protobuf.timeoff.IRequestBalanceDetail|null|undefined} balanceDetail
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @instance
                     */
                    RequestItemBalanceDetail.prototype.balanceDetail = null;
    
                    /**
                     * Creates a new RequestItemBalanceDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestItemBalanceDetail=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.RequestItemBalanceDetail} RequestItemBalanceDetail instance
                     */
                    RequestItemBalanceDetail.create = function create(properties) {
                        return new RequestItemBalanceDetail(properties);
                    };
    
                    /**
                     * Encodes the specified RequestItemBalanceDetail message. Does not implicitly {@link palexy.protobuf.timeoff.RequestItemBalanceDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestItemBalanceDetail} message RequestItemBalanceDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestItemBalanceDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.itemId);
                        if (message.dateId != null && Object.hasOwnProperty.call(message, "dateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.dateId);
                        if (message.balanceDetail != null && Object.hasOwnProperty.call(message, "balanceDetail"))
                            $root.palexy.protobuf.timeoff.RequestBalanceDetail.encode(message.balanceDetail, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RequestItemBalanceDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.RequestItemBalanceDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestItemBalanceDetail} message RequestItemBalanceDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestItemBalanceDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RequestItemBalanceDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.RequestItemBalanceDetail} RequestItemBalanceDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestItemBalanceDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.RequestItemBalanceDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.itemId = reader.int64();
                                break;
                            case 2:
                                message.dateId = reader.int32();
                                break;
                            case 3:
                                message.balanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RequestItemBalanceDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.RequestItemBalanceDetail} RequestItemBalanceDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestItemBalanceDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RequestItemBalanceDetail message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RequestItemBalanceDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (!$util.isInteger(message.itemId) && !(message.itemId && $util.isInteger(message.itemId.low) && $util.isInteger(message.itemId.high)))
                                return "itemId: integer|Long expected";
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            if (!$util.isInteger(message.dateId))
                                return "dateId: integer expected";
                        if (message.balanceDetail != null && message.hasOwnProperty("balanceDetail")) {
                            var error = $root.palexy.protobuf.timeoff.RequestBalanceDetail.verify(message.balanceDetail);
                            if (error)
                                return "balanceDetail." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RequestItemBalanceDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.RequestItemBalanceDetail} RequestItemBalanceDetail
                     */
                    RequestItemBalanceDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.RequestItemBalanceDetail)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.RequestItemBalanceDetail();
                        if (object.itemId != null)
                            if ($util.Long)
                                (message.itemId = $util.Long.fromValue(object.itemId)).unsigned = false;
                            else if (typeof object.itemId === "string")
                                message.itemId = parseInt(object.itemId, 10);
                            else if (typeof object.itemId === "number")
                                message.itemId = object.itemId;
                            else if (typeof object.itemId === "object")
                                message.itemId = new $util.LongBits(object.itemId.low >>> 0, object.itemId.high >>> 0).toNumber();
                        if (object.dateId != null)
                            message.dateId = object.dateId | 0;
                        if (object.balanceDetail != null) {
                            if (typeof object.balanceDetail !== "object")
                                throw TypeError(".palexy.protobuf.timeoff.RequestItemBalanceDetail.balanceDetail: object expected");
                            message.balanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.fromObject(object.balanceDetail);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RequestItemBalanceDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.RequestItemBalanceDetail} message RequestItemBalanceDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RequestItemBalanceDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.itemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.itemId = options.longs === String ? "0" : 0;
                            object.dateId = 0;
                            object.balanceDetail = null;
                        }
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (typeof message.itemId === "number")
                                object.itemId = options.longs === String ? String(message.itemId) : message.itemId;
                            else
                                object.itemId = options.longs === String ? $util.Long.prototype.toString.call(message.itemId) : options.longs === Number ? new $util.LongBits(message.itemId.low >>> 0, message.itemId.high >>> 0).toNumber() : message.itemId;
                        if (message.dateId != null && message.hasOwnProperty("dateId"))
                            object.dateId = message.dateId;
                        if (message.balanceDetail != null && message.hasOwnProperty("balanceDetail"))
                            object.balanceDetail = $root.palexy.protobuf.timeoff.RequestBalanceDetail.toObject(message.balanceDetail, options);
                        return object;
                    };
    
                    /**
                     * Converts this RequestItemBalanceDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.RequestItemBalanceDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RequestItemBalanceDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RequestItemBalanceDetail;
                })();
    
                timeoff.RequestBalanceDetail = (function() {
    
                    /**
                     * Properties of a RequestBalanceDetail.
                     * @memberof palexy.protobuf.timeoff
                     * @interface IRequestBalanceDetail
                     * @property {number|null} [beforeBalance] RequestBalanceDetail beforeBalance
                     * @property {number|null} [usageBalance] RequestBalanceDetail usageBalance
                     * @property {number|null} [afterBalance] RequestBalanceDetail afterBalance
                     * @property {number|null} [otherUsageBalance] RequestBalanceDetail otherUsageBalance
                     */
    
                    /**
                     * Constructs a new RequestBalanceDetail.
                     * @memberof palexy.protobuf.timeoff
                     * @classdesc Represents a RequestBalanceDetail.
                     * @implements IRequestBalanceDetail
                     * @constructor
                     * @param {palexy.protobuf.timeoff.IRequestBalanceDetail=} [properties] Properties to set
                     */
                    function RequestBalanceDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RequestBalanceDetail beforeBalance.
                     * @member {number} beforeBalance
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @instance
                     */
                    RequestBalanceDetail.prototype.beforeBalance = 0;
    
                    /**
                     * RequestBalanceDetail usageBalance.
                     * @member {number} usageBalance
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @instance
                     */
                    RequestBalanceDetail.prototype.usageBalance = 0;
    
                    /**
                     * RequestBalanceDetail afterBalance.
                     * @member {number} afterBalance
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @instance
                     */
                    RequestBalanceDetail.prototype.afterBalance = 0;
    
                    /**
                     * RequestBalanceDetail otherUsageBalance.
                     * @member {number} otherUsageBalance
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @instance
                     */
                    RequestBalanceDetail.prototype.otherUsageBalance = 0;
    
                    /**
                     * Creates a new RequestBalanceDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestBalanceDetail=} [properties] Properties to set
                     * @returns {palexy.protobuf.timeoff.RequestBalanceDetail} RequestBalanceDetail instance
                     */
                    RequestBalanceDetail.create = function create(properties) {
                        return new RequestBalanceDetail(properties);
                    };
    
                    /**
                     * Encodes the specified RequestBalanceDetail message. Does not implicitly {@link palexy.protobuf.timeoff.RequestBalanceDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestBalanceDetail} message RequestBalanceDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestBalanceDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.beforeBalance != null && Object.hasOwnProperty.call(message, "beforeBalance"))
                            writer.uint32(/* id 1, wireType 1 =*/9).double(message.beforeBalance);
                        if (message.usageBalance != null && Object.hasOwnProperty.call(message, "usageBalance"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.usageBalance);
                        if (message.afterBalance != null && Object.hasOwnProperty.call(message, "afterBalance"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.afterBalance);
                        if (message.otherUsageBalance != null && Object.hasOwnProperty.call(message, "otherUsageBalance"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.otherUsageBalance);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RequestBalanceDetail message, length delimited. Does not implicitly {@link palexy.protobuf.timeoff.RequestBalanceDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.IRequestBalanceDetail} message RequestBalanceDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RequestBalanceDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RequestBalanceDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.timeoff.RequestBalanceDetail} RequestBalanceDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestBalanceDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.timeoff.RequestBalanceDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.beforeBalance = reader.double();
                                break;
                            case 2:
                                message.usageBalance = reader.double();
                                break;
                            case 3:
                                message.afterBalance = reader.double();
                                break;
                            case 4:
                                message.otherUsageBalance = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RequestBalanceDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.timeoff.RequestBalanceDetail} RequestBalanceDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RequestBalanceDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RequestBalanceDetail message.
                     * @function verify
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RequestBalanceDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.beforeBalance != null && message.hasOwnProperty("beforeBalance"))
                            if (typeof message.beforeBalance !== "number")
                                return "beforeBalance: number expected";
                        if (message.usageBalance != null && message.hasOwnProperty("usageBalance"))
                            if (typeof message.usageBalance !== "number")
                                return "usageBalance: number expected";
                        if (message.afterBalance != null && message.hasOwnProperty("afterBalance"))
                            if (typeof message.afterBalance !== "number")
                                return "afterBalance: number expected";
                        if (message.otherUsageBalance != null && message.hasOwnProperty("otherUsageBalance"))
                            if (typeof message.otherUsageBalance !== "number")
                                return "otherUsageBalance: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a RequestBalanceDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.timeoff.RequestBalanceDetail} RequestBalanceDetail
                     */
                    RequestBalanceDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.timeoff.RequestBalanceDetail)
                            return object;
                        var message = new $root.palexy.protobuf.timeoff.RequestBalanceDetail();
                        if (object.beforeBalance != null)
                            message.beforeBalance = Number(object.beforeBalance);
                        if (object.usageBalance != null)
                            message.usageBalance = Number(object.usageBalance);
                        if (object.afterBalance != null)
                            message.afterBalance = Number(object.afterBalance);
                        if (object.otherUsageBalance != null)
                            message.otherUsageBalance = Number(object.otherUsageBalance);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RequestBalanceDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @static
                     * @param {palexy.protobuf.timeoff.RequestBalanceDetail} message RequestBalanceDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RequestBalanceDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.beforeBalance = 0;
                            object.usageBalance = 0;
                            object.afterBalance = 0;
                            object.otherUsageBalance = 0;
                        }
                        if (message.beforeBalance != null && message.hasOwnProperty("beforeBalance"))
                            object.beforeBalance = options.json && !isFinite(message.beforeBalance) ? String(message.beforeBalance) : message.beforeBalance;
                        if (message.usageBalance != null && message.hasOwnProperty("usageBalance"))
                            object.usageBalance = options.json && !isFinite(message.usageBalance) ? String(message.usageBalance) : message.usageBalance;
                        if (message.afterBalance != null && message.hasOwnProperty("afterBalance"))
                            object.afterBalance = options.json && !isFinite(message.afterBalance) ? String(message.afterBalance) : message.afterBalance;
                        if (message.otherUsageBalance != null && message.hasOwnProperty("otherUsageBalance"))
                            object.otherUsageBalance = options.json && !isFinite(message.otherUsageBalance) ? String(message.otherUsageBalance) : message.otherUsageBalance;
                        return object;
                    };
    
                    /**
                     * Converts this RequestBalanceDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.timeoff.RequestBalanceDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RequestBalanceDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RequestBalanceDetail;
                })();
    
                return timeoff;
            })();
    
            protobuf.EmployeePolicyRule = (function() {
    
                /**
                 * Properties of an EmployeePolicyRule.
                 * @memberof palexy.protobuf
                 * @interface IEmployeePolicyRule
                 * @property {number|null} [id] EmployeePolicyRule id
                 * @property {number|null} [companyId] EmployeePolicyRule companyId
                 * @property {palexy.protobuf.EmployeePolicyRule.RuleType|null} [ruleType] EmployeePolicyRule ruleType
                 * @property {number|null} [matchingGroupId] EmployeePolicyRule matchingGroupId
                 * @property {number|null} [orderIdx] EmployeePolicyRule orderIdx
                 * @property {boolean|null} [enabled] EmployeePolicyRule enabled
                 * @property {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData|null} [autoGenerateScheduleData] EmployeePolicyRule autoGenerateScheduleData
                 * @property {number|null} [createTimeMs] EmployeePolicyRule createTimeMs
                 * @property {number|null} [lastUpdateTimeMs] EmployeePolicyRule lastUpdateTimeMs
                 */
    
                /**
                 * Constructs a new EmployeePolicyRule.
                 * @memberof palexy.protobuf
                 * @classdesc Represents an EmployeePolicyRule.
                 * @implements IEmployeePolicyRule
                 * @constructor
                 * @param {palexy.protobuf.IEmployeePolicyRule=} [properties] Properties to set
                 */
                function EmployeePolicyRule(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EmployeePolicyRule id.
                 * @member {number} id
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmployeePolicyRule companyId.
                 * @member {number} companyId
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmployeePolicyRule ruleType.
                 * @member {palexy.protobuf.EmployeePolicyRule.RuleType} ruleType
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.ruleType = 0;
    
                /**
                 * EmployeePolicyRule matchingGroupId.
                 * @member {number} matchingGroupId
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.matchingGroupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmployeePolicyRule orderIdx.
                 * @member {number} orderIdx
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.orderIdx = 0;
    
                /**
                 * EmployeePolicyRule enabled.
                 * @member {boolean} enabled
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.enabled = false;
    
                /**
                 * EmployeePolicyRule autoGenerateScheduleData.
                 * @member {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData|null|undefined} autoGenerateScheduleData
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.autoGenerateScheduleData = null;
    
                /**
                 * EmployeePolicyRule createTimeMs.
                 * @member {number} createTimeMs
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.createTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * EmployeePolicyRule lastUpdateTimeMs.
                 * @member {number} lastUpdateTimeMs
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                EmployeePolicyRule.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * EmployeePolicyRule ruleData.
                 * @member {"autoGenerateScheduleData"|undefined} ruleData
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 */
                Object.defineProperty(EmployeePolicyRule.prototype, "ruleData", {
                    get: $util.oneOfGetter($oneOfFields = ["autoGenerateScheduleData"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new EmployeePolicyRule instance using the specified properties.
                 * @function create
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {palexy.protobuf.IEmployeePolicyRule=} [properties] Properties to set
                 * @returns {palexy.protobuf.EmployeePolicyRule} EmployeePolicyRule instance
                 */
                EmployeePolicyRule.create = function create(properties) {
                    return new EmployeePolicyRule(properties);
                };
    
                /**
                 * Encodes the specified EmployeePolicyRule message. Does not implicitly {@link palexy.protobuf.EmployeePolicyRule.verify|verify} messages.
                 * @function encode
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {palexy.protobuf.IEmployeePolicyRule} message EmployeePolicyRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmployeePolicyRule.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                    if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                    if (message.ruleType != null && Object.hasOwnProperty.call(message, "ruleType"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.ruleType);
                    if (message.matchingGroupId != null && Object.hasOwnProperty.call(message, "matchingGroupId"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int64(message.matchingGroupId);
                    if (message.orderIdx != null && Object.hasOwnProperty.call(message, "orderIdx"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.orderIdx);
                    if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.enabled);
                    if (message.autoGenerateScheduleData != null && Object.hasOwnProperty.call(message, "autoGenerateScheduleData"))
                        $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.encode(message.autoGenerateScheduleData, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.createTimeMs != null && Object.hasOwnProperty.call(message, "createTimeMs"))
                        writer.uint32(/* id 8, wireType 0 =*/64).int64(message.createTimeMs);
                    if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int64(message.lastUpdateTimeMs);
                    return writer;
                };
    
                /**
                 * Encodes the specified EmployeePolicyRule message, length delimited. Does not implicitly {@link palexy.protobuf.EmployeePolicyRule.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {palexy.protobuf.IEmployeePolicyRule} message EmployeePolicyRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EmployeePolicyRule.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EmployeePolicyRule message from the specified reader or buffer.
                 * @function decode
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {palexy.protobuf.EmployeePolicyRule} EmployeePolicyRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmployeePolicyRule.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.EmployeePolicyRule();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.id = reader.int64();
                            break;
                        case 2:
                            message.companyId = reader.int64();
                            break;
                        case 3:
                            message.ruleType = reader.int32();
                            break;
                        case 4:
                            message.matchingGroupId = reader.int64();
                            break;
                        case 5:
                            message.orderIdx = reader.int32();
                            break;
                        case 6:
                            message.enabled = reader.bool();
                            break;
                        case 7:
                            message.autoGenerateScheduleData = $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.decode(reader, reader.uint32());
                            break;
                        case 8:
                            message.createTimeMs = reader.int64();
                            break;
                        case 9:
                            message.lastUpdateTimeMs = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EmployeePolicyRule message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {palexy.protobuf.EmployeePolicyRule} EmployeePolicyRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EmployeePolicyRule.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EmployeePolicyRule message.
                 * @function verify
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EmployeePolicyRule.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                            return "id: integer|Long expected";
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                            return "companyId: integer|Long expected";
                    if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                        switch (message.ruleType) {
                        default:
                            return "ruleType: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                        if (!$util.isInteger(message.matchingGroupId) && !(message.matchingGroupId && $util.isInteger(message.matchingGroupId.low) && $util.isInteger(message.matchingGroupId.high)))
                            return "matchingGroupId: integer|Long expected";
                    if (message.orderIdx != null && message.hasOwnProperty("orderIdx"))
                        if (!$util.isInteger(message.orderIdx))
                            return "orderIdx: integer expected";
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        if (typeof message.enabled !== "boolean")
                            return "enabled: boolean expected";
                    if (message.autoGenerateScheduleData != null && message.hasOwnProperty("autoGenerateScheduleData")) {
                        properties.ruleData = 1;
                        {
                            var error = $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.verify(message.autoGenerateScheduleData);
                            if (error)
                                return "autoGenerateScheduleData." + error;
                        }
                    }
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (!$util.isInteger(message.createTimeMs) && !(message.createTimeMs && $util.isInteger(message.createTimeMs.low) && $util.isInteger(message.createTimeMs.high)))
                            return "createTimeMs: integer|Long expected";
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                            return "lastUpdateTimeMs: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates an EmployeePolicyRule message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {palexy.protobuf.EmployeePolicyRule} EmployeePolicyRule
                 */
                EmployeePolicyRule.fromObject = function fromObject(object) {
                    if (object instanceof $root.palexy.protobuf.EmployeePolicyRule)
                        return object;
                    var message = new $root.palexy.protobuf.EmployeePolicyRule();
                    if (object.id != null)
                        if ($util.Long)
                            (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                        else if (typeof object.id === "string")
                            message.id = parseInt(object.id, 10);
                        else if (typeof object.id === "number")
                            message.id = object.id;
                        else if (typeof object.id === "object")
                            message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                    if (object.companyId != null)
                        if ($util.Long)
                            (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                        else if (typeof object.companyId === "string")
                            message.companyId = parseInt(object.companyId, 10);
                        else if (typeof object.companyId === "number")
                            message.companyId = object.companyId;
                        else if (typeof object.companyId === "object")
                            message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                    switch (object.ruleType) {
                    case "RULE_TYPE_UNSPECIFIED":
                    case 0:
                        message.ruleType = 0;
                        break;
                    case "REQUIRE_CLOCKING":
                    case 1:
                        message.ruleType = 1;
                        break;
                    case "AUTO_GENERATE_SCHEDULE":
                    case 2:
                        message.ruleType = 2;
                        break;
                    }
                    if (object.matchingGroupId != null)
                        if ($util.Long)
                            (message.matchingGroupId = $util.Long.fromValue(object.matchingGroupId)).unsigned = false;
                        else if (typeof object.matchingGroupId === "string")
                            message.matchingGroupId = parseInt(object.matchingGroupId, 10);
                        else if (typeof object.matchingGroupId === "number")
                            message.matchingGroupId = object.matchingGroupId;
                        else if (typeof object.matchingGroupId === "object")
                            message.matchingGroupId = new $util.LongBits(object.matchingGroupId.low >>> 0, object.matchingGroupId.high >>> 0).toNumber();
                    if (object.orderIdx != null)
                        message.orderIdx = object.orderIdx | 0;
                    if (object.enabled != null)
                        message.enabled = Boolean(object.enabled);
                    if (object.autoGenerateScheduleData != null) {
                        if (typeof object.autoGenerateScheduleData !== "object")
                            throw TypeError(".palexy.protobuf.EmployeePolicyRule.autoGenerateScheduleData: object expected");
                        message.autoGenerateScheduleData = $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.fromObject(object.autoGenerateScheduleData);
                    }
                    if (object.createTimeMs != null)
                        if ($util.Long)
                            (message.createTimeMs = $util.Long.fromValue(object.createTimeMs)).unsigned = false;
                        else if (typeof object.createTimeMs === "string")
                            message.createTimeMs = parseInt(object.createTimeMs, 10);
                        else if (typeof object.createTimeMs === "number")
                            message.createTimeMs = object.createTimeMs;
                        else if (typeof object.createTimeMs === "object")
                            message.createTimeMs = new $util.LongBits(object.createTimeMs.low >>> 0, object.createTimeMs.high >>> 0).toNumber();
                    if (object.lastUpdateTimeMs != null)
                        if ($util.Long)
                            (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                        else if (typeof object.lastUpdateTimeMs === "string")
                            message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                        else if (typeof object.lastUpdateTimeMs === "number")
                            message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                        else if (typeof object.lastUpdateTimeMs === "object")
                            message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from an EmployeePolicyRule message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @static
                 * @param {palexy.protobuf.EmployeePolicyRule} message EmployeePolicyRule
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EmployeePolicyRule.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.id = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.companyId = options.longs === String ? "0" : 0;
                        object.ruleType = options.enums === String ? "RULE_TYPE_UNSPECIFIED" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.matchingGroupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.matchingGroupId = options.longs === String ? "0" : 0;
                        object.orderIdx = 0;
                        object.enabled = false;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.createTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.createTimeMs = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                    }
                    if (message.id != null && message.hasOwnProperty("id"))
                        if (typeof message.id === "number")
                            object.id = options.longs === String ? String(message.id) : message.id;
                        else
                            object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                    if (message.companyId != null && message.hasOwnProperty("companyId"))
                        if (typeof message.companyId === "number")
                            object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                        else
                            object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                    if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                        object.ruleType = options.enums === String ? $root.palexy.protobuf.EmployeePolicyRule.RuleType[message.ruleType] : message.ruleType;
                    if (message.matchingGroupId != null && message.hasOwnProperty("matchingGroupId"))
                        if (typeof message.matchingGroupId === "number")
                            object.matchingGroupId = options.longs === String ? String(message.matchingGroupId) : message.matchingGroupId;
                        else
                            object.matchingGroupId = options.longs === String ? $util.Long.prototype.toString.call(message.matchingGroupId) : options.longs === Number ? new $util.LongBits(message.matchingGroupId.low >>> 0, message.matchingGroupId.high >>> 0).toNumber() : message.matchingGroupId;
                    if (message.orderIdx != null && message.hasOwnProperty("orderIdx"))
                        object.orderIdx = message.orderIdx;
                    if (message.enabled != null && message.hasOwnProperty("enabled"))
                        object.enabled = message.enabled;
                    if (message.autoGenerateScheduleData != null && message.hasOwnProperty("autoGenerateScheduleData")) {
                        object.autoGenerateScheduleData = $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.toObject(message.autoGenerateScheduleData, options);
                        if (options.oneofs)
                            object.ruleData = "autoGenerateScheduleData";
                    }
                    if (message.createTimeMs != null && message.hasOwnProperty("createTimeMs"))
                        if (typeof message.createTimeMs === "number")
                            object.createTimeMs = options.longs === String ? String(message.createTimeMs) : message.createTimeMs;
                        else
                            object.createTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createTimeMs) : options.longs === Number ? new $util.LongBits(message.createTimeMs.low >>> 0, message.createTimeMs.high >>> 0).toNumber() : message.createTimeMs;
                    if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                        if (typeof message.lastUpdateTimeMs === "number")
                            object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                        else
                            object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                    return object;
                };
    
                /**
                 * Converts this EmployeePolicyRule to JSON.
                 * @function toJSON
                 * @memberof palexy.protobuf.EmployeePolicyRule
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EmployeePolicyRule.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * RuleType enum.
                 * @name palexy.protobuf.EmployeePolicyRule.RuleType
                 * @enum {number}
                 * @property {number} RULE_TYPE_UNSPECIFIED=0 RULE_TYPE_UNSPECIFIED value
                 * @property {number} REQUIRE_CLOCKING=1 REQUIRE_CLOCKING value
                 * @property {number} AUTO_GENERATE_SCHEDULE=2 AUTO_GENERATE_SCHEDULE value
                 */
                EmployeePolicyRule.RuleType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "RULE_TYPE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "REQUIRE_CLOCKING"] = 1;
                    values[valuesById[2] = "AUTO_GENERATE_SCHEDULE"] = 2;
                    return values;
                })();
    
                EmployeePolicyRule.AutoGenerateScheduleData = (function() {
    
                    /**
                     * Properties of an AutoGenerateScheduleData.
                     * @memberof palexy.protobuf.EmployeePolicyRule
                     * @interface IAutoGenerateScheduleData
                     * @property {number|null} [shiftTemplateId] AutoGenerateScheduleData shiftTemplateId
                     */
    
                    /**
                     * Constructs a new AutoGenerateScheduleData.
                     * @memberof palexy.protobuf.EmployeePolicyRule
                     * @classdesc Represents an AutoGenerateScheduleData.
                     * @implements IAutoGenerateScheduleData
                     * @constructor
                     * @param {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData=} [properties] Properties to set
                     */
                    function AutoGenerateScheduleData(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AutoGenerateScheduleData shiftTemplateId.
                     * @member {number} shiftTemplateId
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @instance
                     */
                    AutoGenerateScheduleData.prototype.shiftTemplateId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new AutoGenerateScheduleData instance using the specified properties.
                     * @function create
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData=} [properties] Properties to set
                     * @returns {palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData} AutoGenerateScheduleData instance
                     */
                    AutoGenerateScheduleData.create = function create(properties) {
                        return new AutoGenerateScheduleData(properties);
                    };
    
                    /**
                     * Encodes the specified AutoGenerateScheduleData message. Does not implicitly {@link palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData} message AutoGenerateScheduleData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoGenerateScheduleData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.shiftTemplateId != null && Object.hasOwnProperty.call(message, "shiftTemplateId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.shiftTemplateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AutoGenerateScheduleData message, length delimited. Does not implicitly {@link palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {palexy.protobuf.EmployeePolicyRule.IAutoGenerateScheduleData} message AutoGenerateScheduleData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AutoGenerateScheduleData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AutoGenerateScheduleData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData} AutoGenerateScheduleData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoGenerateScheduleData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.shiftTemplateId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AutoGenerateScheduleData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData} AutoGenerateScheduleData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AutoGenerateScheduleData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AutoGenerateScheduleData message.
                     * @function verify
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AutoGenerateScheduleData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (!$util.isInteger(message.shiftTemplateId) && !(message.shiftTemplateId && $util.isInteger(message.shiftTemplateId.low) && $util.isInteger(message.shiftTemplateId.high)))
                                return "shiftTemplateId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an AutoGenerateScheduleData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData} AutoGenerateScheduleData
                     */
                    AutoGenerateScheduleData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData)
                            return object;
                        var message = new $root.palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData();
                        if (object.shiftTemplateId != null)
                            if ($util.Long)
                                (message.shiftTemplateId = $util.Long.fromValue(object.shiftTemplateId)).unsigned = false;
                            else if (typeof object.shiftTemplateId === "string")
                                message.shiftTemplateId = parseInt(object.shiftTemplateId, 10);
                            else if (typeof object.shiftTemplateId === "number")
                                message.shiftTemplateId = object.shiftTemplateId;
                            else if (typeof object.shiftTemplateId === "object")
                                message.shiftTemplateId = new $util.LongBits(object.shiftTemplateId.low >>> 0, object.shiftTemplateId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AutoGenerateScheduleData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @static
                     * @param {palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData} message AutoGenerateScheduleData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AutoGenerateScheduleData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.shiftTemplateId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.shiftTemplateId = options.longs === String ? "0" : 0;
                        if (message.shiftTemplateId != null && message.hasOwnProperty("shiftTemplateId"))
                            if (typeof message.shiftTemplateId === "number")
                                object.shiftTemplateId = options.longs === String ? String(message.shiftTemplateId) : message.shiftTemplateId;
                            else
                                object.shiftTemplateId = options.longs === String ? $util.Long.prototype.toString.call(message.shiftTemplateId) : options.longs === Number ? new $util.LongBits(message.shiftTemplateId.low >>> 0, message.shiftTemplateId.high >>> 0).toNumber() : message.shiftTemplateId;
                        return object;
                    };
    
                    /**
                     * Converts this AutoGenerateScheduleData to JSON.
                     * @function toJSON
                     * @memberof palexy.protobuf.EmployeePolicyRule.AutoGenerateScheduleData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AutoGenerateScheduleData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AutoGenerateScheduleData;
                })();
    
                return EmployeePolicyRule;
            })();
    
            return protobuf;
        })();
    
        palexy.task_management = (function() {
    
            /**
             * Namespace task_management.
             * @memberof palexy
             * @namespace
             */
            var task_management = {};
    
            task_management.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.task_management
                 * @namespace
                 */
                var v1 = {};
    
                v1.User = (function() {
    
                    /**
                     * Properties of a User.
                     * @memberof palexy.task_management.v1
                     * @interface IUser
                     * @property {number|null} [id] User id
                     * @property {string|null} [username] User username
                     * @property {string|null} [email] User email
                     * @property {string|null} [fullName] User fullName
                     * @property {string|null} [profilePhotoUrl] User profilePhotoUrl
                     */
    
                    /**
                     * Constructs a new User.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a User.
                     * @implements IUser
                     * @constructor
                     * @param {palexy.task_management.v1.IUser=} [properties] Properties to set
                     */
                    function User(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * User id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     */
                    User.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * User username.
                     * @member {string} username
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     */
                    User.prototype.username = "";
    
                    /**
                     * User email.
                     * @member {string} email
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     */
                    User.prototype.email = "";
    
                    /**
                     * User fullName.
                     * @member {string} fullName
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     */
                    User.prototype.fullName = "";
    
                    /**
                     * User profilePhotoUrl.
                     * @member {string} profilePhotoUrl
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     */
                    User.prototype.profilePhotoUrl = "";
    
                    /**
                     * Creates a new User instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {palexy.task_management.v1.IUser=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.User} User instance
                     */
                    User.create = function create(properties) {
                        return new User(properties);
                    };
    
                    /**
                     * Encodes the specified User message. Does not implicitly {@link palexy.task_management.v1.User.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {palexy.task_management.v1.IUser} message User message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    User.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.fullName);
                        if (message.profilePhotoUrl != null && Object.hasOwnProperty.call(message, "profilePhotoUrl"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.profilePhotoUrl);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified User message, length delimited. Does not implicitly {@link palexy.task_management.v1.User.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {palexy.task_management.v1.IUser} message User message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    User.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a User message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.User} User
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    User.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.User();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.fullName = reader.string();
                                break;
                            case 5:
                                message.profilePhotoUrl = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a User message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.User} User
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    User.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a User message.
                     * @function verify
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    User.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        if (message.profilePhotoUrl != null && message.hasOwnProperty("profilePhotoUrl"))
                            if (!$util.isString(message.profilePhotoUrl))
                                return "profilePhotoUrl: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a User message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.User} User
                     */
                    User.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.User)
                            return object;
                        var message = new $root.palexy.task_management.v1.User();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        if (object.profilePhotoUrl != null)
                            message.profilePhotoUrl = String(object.profilePhotoUrl);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a User message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.User
                     * @static
                     * @param {palexy.task_management.v1.User} message User
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    User.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.username = "";
                            object.email = "";
                            object.fullName = "";
                            object.profilePhotoUrl = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        if (message.profilePhotoUrl != null && message.hasOwnProperty("profilePhotoUrl"))
                            object.profilePhotoUrl = message.profilePhotoUrl;
                        return object;
                    };
    
                    /**
                     * Converts this User to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.User
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    User.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return User;
                })();
    
                v1.Group = (function() {
    
                    /**
                     * Properties of a Group.
                     * @memberof palexy.task_management.v1
                     * @interface IGroup
                     * @property {number|null} [id] Group id
                     * @property {string|null} [name] Group name
                     */
    
                    /**
                     * Constructs a new Group.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Group.
                     * @implements IGroup
                     * @constructor
                     * @param {palexy.task_management.v1.IGroup=} [properties] Properties to set
                     */
                    function Group(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Group id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Group
                     * @instance
                     */
                    Group.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Group name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.Group
                     * @instance
                     */
                    Group.prototype.name = "";
    
                    /**
                     * Creates a new Group instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {palexy.task_management.v1.IGroup=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Group} Group instance
                     */
                    Group.create = function create(properties) {
                        return new Group(properties);
                    };
    
                    /**
                     * Encodes the specified Group message. Does not implicitly {@link palexy.task_management.v1.Group.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {palexy.task_management.v1.IGroup} message Group message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Group.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Group message, length delimited. Does not implicitly {@link palexy.task_management.v1.Group.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {palexy.task_management.v1.IGroup} message Group message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Group.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Group message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Group} Group
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Group.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Group();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Group message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Group} Group
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Group.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Group message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Group.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a Group message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Group} Group
                     */
                    Group.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Group)
                            return object;
                        var message = new $root.palexy.task_management.v1.Group();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Group message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Group
                     * @static
                     * @param {palexy.task_management.v1.Group} message Group
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Group.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this Group to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Group
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Group.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Group;
                })();
    
                v1.TaskStore = (function() {
    
                    /**
                     * Properties of a TaskStore.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskStore
                     * @property {number|null} [id] TaskStore id
                     * @property {string|null} [name] TaskStore name
                     * @property {number|null} [latitude] TaskStore latitude
                     * @property {number|null} [longitude] TaskStore longitude
                     */
    
                    /**
                     * Constructs a new TaskStore.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskStore.
                     * @implements ITaskStore
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskStore=} [properties] Properties to set
                     */
                    function TaskStore(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskStore id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.TaskStore
                     * @instance
                     */
                    TaskStore.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskStore name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.TaskStore
                     * @instance
                     */
                    TaskStore.prototype.name = "";
    
                    /**
                     * TaskStore latitude.
                     * @member {number} latitude
                     * @memberof palexy.task_management.v1.TaskStore
                     * @instance
                     */
                    TaskStore.prototype.latitude = 0;
    
                    /**
                     * TaskStore longitude.
                     * @member {number} longitude
                     * @memberof palexy.task_management.v1.TaskStore
                     * @instance
                     */
                    TaskStore.prototype.longitude = 0;
    
                    /**
                     * Creates a new TaskStore instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {palexy.task_management.v1.ITaskStore=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskStore} TaskStore instance
                     */
                    TaskStore.create = function create(properties) {
                        return new TaskStore(properties);
                    };
    
                    /**
                     * Encodes the specified TaskStore message. Does not implicitly {@link palexy.task_management.v1.TaskStore.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {palexy.task_management.v1.ITaskStore} message TaskStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskStore.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.latitude != null && Object.hasOwnProperty.call(message, "latitude"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.latitude);
                        if (message.longitude != null && Object.hasOwnProperty.call(message, "longitude"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.longitude);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskStore message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskStore.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {palexy.task_management.v1.ITaskStore} message TaskStore message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskStore.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskStore message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskStore} TaskStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskStore.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskStore();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.latitude = reader.double();
                                break;
                            case 4:
                                message.longitude = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskStore message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskStore} TaskStore
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskStore.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskStore message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskStore.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            if (typeof message.latitude !== "number")
                                return "latitude: number expected";
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            if (typeof message.longitude !== "number")
                                return "longitude: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a TaskStore message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskStore} TaskStore
                     */
                    TaskStore.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskStore)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskStore();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.latitude != null)
                            message.latitude = Number(object.latitude);
                        if (object.longitude != null)
                            message.longitude = Number(object.longitude);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskStore message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskStore
                     * @static
                     * @param {palexy.task_management.v1.TaskStore} message TaskStore
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskStore.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.latitude = 0;
                            object.longitude = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.latitude != null && message.hasOwnProperty("latitude"))
                            object.latitude = options.json && !isFinite(message.latitude) ? String(message.latitude) : message.latitude;
                        if (message.longitude != null && message.hasOwnProperty("longitude"))
                            object.longitude = options.json && !isFinite(message.longitude) ? String(message.longitude) : message.longitude;
                        return object;
                    };
    
                    /**
                     * Converts this TaskStore to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskStore
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskStore.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskStore;
                })();
    
                v1.Project = (function() {
    
                    /**
                     * Properties of a Project.
                     * @memberof palexy.task_management.v1
                     * @interface IProject
                     * @property {number|null} [id] Project id
                     * @property {number|null} [companyId] Project companyId
                     * @property {string|null} [projectName] Project projectName
                     * @property {palexy.task_management.v1.IUser|null} [ownerAccount] Project ownerAccount
                     * @property {number|null} [createdTimeMs] Project createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Project lastUpdateTimeMs
                     * @property {number|null} [creatorId] Project creatorId
                     * @property {palexy.task_management.v1.Project.ProjectType|null} [projectType] Project projectType
                     * @property {boolean|null} [allowAssignByLocation] Project allowAssignByLocation
                     * @property {string|null} [description] Project description
                     */
    
                    /**
                     * Constructs a new Project.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Project.
                     * @implements IProject
                     * @constructor
                     * @param {palexy.task_management.v1.IProject=} [properties] Properties to set
                     */
                    function Project(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Project id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Project companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Project projectName.
                     * @member {string} projectName
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.projectName = "";
    
                    /**
                     * Project ownerAccount.
                     * @member {palexy.task_management.v1.IUser|null|undefined} ownerAccount
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.ownerAccount = null;
    
                    /**
                     * Project createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Project lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Project creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Project projectType.
                     * @member {palexy.task_management.v1.Project.ProjectType} projectType
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.projectType = 0;
    
                    /**
                     * Project allowAssignByLocation.
                     * @member {boolean} allowAssignByLocation
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.allowAssignByLocation = false;
    
                    /**
                     * Project description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     */
                    Project.prototype.description = "";
    
                    /**
                     * Creates a new Project instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {palexy.task_management.v1.IProject=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Project} Project instance
                     */
                    Project.create = function create(properties) {
                        return new Project(properties);
                    };
    
                    /**
                     * Encodes the specified Project message. Does not implicitly {@link palexy.task_management.v1.Project.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {palexy.task_management.v1.IProject} message Project message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Project.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.projectName);
                        if (message.ownerAccount != null && Object.hasOwnProperty.call(message, "ownerAccount"))
                            $root.palexy.task_management.v1.User.encode(message.ownerAccount, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.creatorId);
                        if (message.projectType != null && Object.hasOwnProperty.call(message, "projectType"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.projectType);
                        if (message.allowAssignByLocation != null && Object.hasOwnProperty.call(message, "allowAssignByLocation"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.allowAssignByLocation);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.description);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Project message, length delimited. Does not implicitly {@link palexy.task_management.v1.Project.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {palexy.task_management.v1.IProject} message Project message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Project.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Project message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Project} Project
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Project.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Project();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.projectName = reader.string();
                                break;
                            case 4:
                                message.ownerAccount = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 7:
                                message.creatorId = reader.int64();
                                break;
                            case 8:
                                message.projectType = reader.int32();
                                break;
                            case 9:
                                message.allowAssignByLocation = reader.bool();
                                break;
                            case 10:
                                message.description = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Project message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Project} Project
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Project.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Project message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Project.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            if (!$util.isString(message.projectName))
                                return "projectName: string expected";
                        if (message.ownerAccount != null && message.hasOwnProperty("ownerAccount")) {
                            var error = $root.palexy.task_management.v1.User.verify(message.ownerAccount);
                            if (error)
                                return "ownerAccount." + error;
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.projectType != null && message.hasOwnProperty("projectType"))
                            switch (message.projectType) {
                            default:
                                return "projectType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.allowAssignByLocation != null && message.hasOwnProperty("allowAssignByLocation"))
                            if (typeof message.allowAssignByLocation !== "boolean")
                                return "allowAssignByLocation: boolean expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a Project message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Project} Project
                     */
                    Project.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Project)
                            return object;
                        var message = new $root.palexy.task_management.v1.Project();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.projectName != null)
                            message.projectName = String(object.projectName);
                        if (object.ownerAccount != null) {
                            if (typeof object.ownerAccount !== "object")
                                throw TypeError(".palexy.task_management.v1.Project.ownerAccount: object expected");
                            message.ownerAccount = $root.palexy.task_management.v1.User.fromObject(object.ownerAccount);
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        switch (object.projectType) {
                        case "PROJECT_TYPE_UNSPECIFIED":
                        case 0:
                            message.projectType = 0;
                            break;
                        case "SIMPLE":
                        case 1:
                            message.projectType = 1;
                            break;
                        case "COMPLEX_DEPLOYMENT":
                        case 2:
                            message.projectType = 2;
                            break;
                        case "RECURRING_CHECKLIST":
                        case 3:
                            message.projectType = 3;
                            break;
                        case "TICKET":
                        case 4:
                            message.projectType = 4;
                            break;
                        }
                        if (object.allowAssignByLocation != null)
                            message.allowAssignByLocation = Boolean(object.allowAssignByLocation);
                        if (object.description != null)
                            message.description = String(object.description);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Project message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Project
                     * @static
                     * @param {palexy.task_management.v1.Project} message Project
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Project.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.projectName = "";
                            object.ownerAccount = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            object.projectType = options.enums === String ? "PROJECT_TYPE_UNSPECIFIED" : 0;
                            object.allowAssignByLocation = false;
                            object.description = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            object.projectName = message.projectName;
                        if (message.ownerAccount != null && message.hasOwnProperty("ownerAccount"))
                            object.ownerAccount = $root.palexy.task_management.v1.User.toObject(message.ownerAccount, options);
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.projectType != null && message.hasOwnProperty("projectType"))
                            object.projectType = options.enums === String ? $root.palexy.task_management.v1.Project.ProjectType[message.projectType] : message.projectType;
                        if (message.allowAssignByLocation != null && message.hasOwnProperty("allowAssignByLocation"))
                            object.allowAssignByLocation = message.allowAssignByLocation;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        return object;
                    };
    
                    /**
                     * Converts this Project to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Project
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Project.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ProjectType enum.
                     * @name palexy.task_management.v1.Project.ProjectType
                     * @enum {number}
                     * @property {number} PROJECT_TYPE_UNSPECIFIED=0 PROJECT_TYPE_UNSPECIFIED value
                     * @property {number} SIMPLE=1 SIMPLE value
                     * @property {number} COMPLEX_DEPLOYMENT=2 COMPLEX_DEPLOYMENT value
                     * @property {number} RECURRING_CHECKLIST=3 RECURRING_CHECKLIST value
                     * @property {number} TICKET=4 TICKET value
                     */
                    Project.ProjectType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PROJECT_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SIMPLE"] = 1;
                        values[valuesById[2] = "COMPLEX_DEPLOYMENT"] = 2;
                        values[valuesById[3] = "RECURRING_CHECKLIST"] = 3;
                        values[valuesById[4] = "TICKET"] = 4;
                        return values;
                    })();
    
                    return Project;
                })();
    
                v1.ProjectDataView = (function() {
    
                    /**
                     * Properties of a ProjectDataView.
                     * @memberof palexy.task_management.v1
                     * @interface IProjectDataView
                     * @property {number|null} [id] ProjectDataView id
                     * @property {number|null} [projectId] ProjectDataView projectId
                     * @property {string|null} [viewName] ProjectDataView viewName
                     * @property {palexy.task_management.v1.ProjectDataView.ViewType|null} [viewType] ProjectDataView viewType
                     * @property {palexy.task_management.v1.IViewConfig|null} [viewConfig] ProjectDataView viewConfig
                     * @property {number|null} [userId] ProjectDataView userId
                     * @property {number|null} [displayOrder] ProjectDataView displayOrder
                     */
    
                    /**
                     * Constructs a new ProjectDataView.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ProjectDataView.
                     * @implements IProjectDataView
                     * @constructor
                     * @param {palexy.task_management.v1.IProjectDataView=} [properties] Properties to set
                     */
                    function ProjectDataView(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProjectDataView id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProjectDataView projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProjectDataView viewName.
                     * @member {string} viewName
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.viewName = "";
    
                    /**
                     * ProjectDataView viewType.
                     * @member {palexy.task_management.v1.ProjectDataView.ViewType} viewType
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.viewType = 0;
    
                    /**
                     * ProjectDataView viewConfig.
                     * @member {palexy.task_management.v1.IViewConfig|null|undefined} viewConfig
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.viewConfig = null;
    
                    /**
                     * ProjectDataView userId.
                     * @member {number} userId
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ProjectDataView displayOrder.
                     * @member {number} displayOrder
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     */
                    ProjectDataView.prototype.displayOrder = 0;
    
                    /**
                     * Creates a new ProjectDataView instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {palexy.task_management.v1.IProjectDataView=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ProjectDataView} ProjectDataView instance
                     */
                    ProjectDataView.create = function create(properties) {
                        return new ProjectDataView(properties);
                    };
    
                    /**
                     * Encodes the specified ProjectDataView message. Does not implicitly {@link palexy.task_management.v1.ProjectDataView.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {palexy.task_management.v1.IProjectDataView} message ProjectDataView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProjectDataView.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.viewName != null && Object.hasOwnProperty.call(message, "viewName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.viewName);
                        if (message.viewType != null && Object.hasOwnProperty.call(message, "viewType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.viewType);
                        if (message.viewConfig != null && Object.hasOwnProperty.call(message, "viewConfig"))
                            $root.palexy.task_management.v1.ViewConfig.encode(message.viewConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.userId);
                        if (message.displayOrder != null && Object.hasOwnProperty.call(message, "displayOrder"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.displayOrder);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProjectDataView message, length delimited. Does not implicitly {@link palexy.task_management.v1.ProjectDataView.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {palexy.task_management.v1.IProjectDataView} message ProjectDataView message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProjectDataView.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProjectDataView message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ProjectDataView} ProjectDataView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProjectDataView.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ProjectDataView();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.projectId = reader.int64();
                                break;
                            case 3:
                                message.viewName = reader.string();
                                break;
                            case 4:
                                message.viewType = reader.int32();
                                break;
                            case 5:
                                message.viewConfig = $root.palexy.task_management.v1.ViewConfig.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.userId = reader.int64();
                                break;
                            case 7:
                                message.displayOrder = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProjectDataView message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ProjectDataView} ProjectDataView
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProjectDataView.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProjectDataView message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProjectDataView.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.viewName != null && message.hasOwnProperty("viewName"))
                            if (!$util.isString(message.viewName))
                                return "viewName: string expected";
                        if (message.viewType != null && message.hasOwnProperty("viewType"))
                            switch (message.viewType) {
                            default:
                                return "viewType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.viewConfig != null && message.hasOwnProperty("viewConfig")) {
                            var error = $root.palexy.task_management.v1.ViewConfig.verify(message.viewConfig);
                            if (error)
                                return "viewConfig." + error;
                        }
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                            if (!$util.isInteger(message.displayOrder))
                                return "displayOrder: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProjectDataView message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ProjectDataView} ProjectDataView
                     */
                    ProjectDataView.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ProjectDataView)
                            return object;
                        var message = new $root.palexy.task_management.v1.ProjectDataView();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.viewName != null)
                            message.viewName = String(object.viewName);
                        switch (object.viewType) {
                        case "UNKNOWN":
                        case 0:
                            message.viewType = 0;
                            break;
                        case "TABLE":
                        case 1:
                            message.viewType = 1;
                            break;
                        case "BOARD":
                        case 2:
                            message.viewType = 2;
                            break;
                        }
                        if (object.viewConfig != null) {
                            if (typeof object.viewConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.ProjectDataView.viewConfig: object expected");
                            message.viewConfig = $root.palexy.task_management.v1.ViewConfig.fromObject(object.viewConfig);
                        }
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.displayOrder != null)
                            message.displayOrder = object.displayOrder | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProjectDataView message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @static
                     * @param {palexy.task_management.v1.ProjectDataView} message ProjectDataView
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProjectDataView.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.viewName = "";
                            object.viewType = options.enums === String ? "UNKNOWN" : 0;
                            object.viewConfig = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.displayOrder = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.viewName != null && message.hasOwnProperty("viewName"))
                            object.viewName = message.viewName;
                        if (message.viewType != null && message.hasOwnProperty("viewType"))
                            object.viewType = options.enums === String ? $root.palexy.task_management.v1.ProjectDataView.ViewType[message.viewType] : message.viewType;
                        if (message.viewConfig != null && message.hasOwnProperty("viewConfig"))
                            object.viewConfig = $root.palexy.task_management.v1.ViewConfig.toObject(message.viewConfig, options);
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.displayOrder != null && message.hasOwnProperty("displayOrder"))
                            object.displayOrder = message.displayOrder;
                        return object;
                    };
    
                    /**
                     * Converts this ProjectDataView to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ProjectDataView
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProjectDataView.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ViewType enum.
                     * @name palexy.task_management.v1.ProjectDataView.ViewType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} TABLE=1 TABLE value
                     * @property {number} BOARD=2 BOARD value
                     */
                    ProjectDataView.ViewType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "TABLE"] = 1;
                        values[valuesById[2] = "BOARD"] = 2;
                        return values;
                    })();
    
                    return ProjectDataView;
                })();
    
                v1.ViewConfig = (function() {
    
                    /**
                     * Properties of a ViewConfig.
                     * @memberof palexy.task_management.v1
                     * @interface IViewConfig
                     * @property {Array.<palexy.task_management.v1.ViewConfig.IDataFilter>|null} [filters] ViewConfig filters
                     * @property {Array.<palexy.task_management.v1.ViewConfig.IDataSort>|null} [sorts] ViewConfig sorts
                     * @property {Array.<palexy.task_management.v1.ViewConfig.IDataGroup>|null} [groups] ViewConfig groups
                     * @property {palexy.task_management.v1.ViewConfig.IBoardConfig|null} [boardConfig] ViewConfig boardConfig
                     * @property {palexy.task_management.v1.ViewConfig.ITableConfig|null} [tableConfig] ViewConfig tableConfig
                     */
    
                    /**
                     * Constructs a new ViewConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ViewConfig.
                     * @implements IViewConfig
                     * @constructor
                     * @param {palexy.task_management.v1.IViewConfig=} [properties] Properties to set
                     */
                    function ViewConfig(properties) {
                        this.filters = [];
                        this.sorts = [];
                        this.groups = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ViewConfig filters.
                     * @member {Array.<palexy.task_management.v1.ViewConfig.IDataFilter>} filters
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     */
                    ViewConfig.prototype.filters = $util.emptyArray;
    
                    /**
                     * ViewConfig sorts.
                     * @member {Array.<palexy.task_management.v1.ViewConfig.IDataSort>} sorts
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     */
                    ViewConfig.prototype.sorts = $util.emptyArray;
    
                    /**
                     * ViewConfig groups.
                     * @member {Array.<palexy.task_management.v1.ViewConfig.IDataGroup>} groups
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     */
                    ViewConfig.prototype.groups = $util.emptyArray;
    
                    /**
                     * ViewConfig boardConfig.
                     * @member {palexy.task_management.v1.ViewConfig.IBoardConfig|null|undefined} boardConfig
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     */
                    ViewConfig.prototype.boardConfig = null;
    
                    /**
                     * ViewConfig tableConfig.
                     * @member {palexy.task_management.v1.ViewConfig.ITableConfig|null|undefined} tableConfig
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     */
                    ViewConfig.prototype.tableConfig = null;
    
                    /**
                     * Creates a new ViewConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {palexy.task_management.v1.IViewConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ViewConfig} ViewConfig instance
                     */
                    ViewConfig.create = function create(properties) {
                        return new ViewConfig(properties);
                    };
    
                    /**
                     * Encodes the specified ViewConfig message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {palexy.task_management.v1.IViewConfig} message ViewConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ViewConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.filters != null && message.filters.length)
                            for (var i = 0; i < message.filters.length; ++i)
                                $root.palexy.task_management.v1.ViewConfig.DataFilter.encode(message.filters[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.sorts != null && message.sorts.length)
                            for (var i = 0; i < message.sorts.length; ++i)
                                $root.palexy.task_management.v1.ViewConfig.DataSort.encode(message.sorts[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.groups != null && message.groups.length)
                            for (var i = 0; i < message.groups.length; ++i)
                                $root.palexy.task_management.v1.ViewConfig.DataGroup.encode(message.groups[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.boardConfig != null && Object.hasOwnProperty.call(message, "boardConfig"))
                            $root.palexy.task_management.v1.ViewConfig.BoardConfig.encode(message.boardConfig, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.tableConfig != null && Object.hasOwnProperty.call(message, "tableConfig"))
                            $root.palexy.task_management.v1.ViewConfig.TableConfig.encode(message.tableConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ViewConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {palexy.task_management.v1.IViewConfig} message ViewConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ViewConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ViewConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ViewConfig} ViewConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ViewConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.filters && message.filters.length))
                                    message.filters = [];
                                message.filters.push($root.palexy.task_management.v1.ViewConfig.DataFilter.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.sorts && message.sorts.length))
                                    message.sorts = [];
                                message.sorts.push($root.palexy.task_management.v1.ViewConfig.DataSort.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.groups && message.groups.length))
                                    message.groups = [];
                                message.groups.push($root.palexy.task_management.v1.ViewConfig.DataGroup.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                message.boardConfig = $root.palexy.task_management.v1.ViewConfig.BoardConfig.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.tableConfig = $root.palexy.task_management.v1.ViewConfig.TableConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ViewConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ViewConfig} ViewConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ViewConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ViewConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ViewConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.filters != null && message.hasOwnProperty("filters")) {
                            if (!Array.isArray(message.filters))
                                return "filters: array expected";
                            for (var i = 0; i < message.filters.length; ++i) {
                                var error = $root.palexy.task_management.v1.ViewConfig.DataFilter.verify(message.filters[i]);
                                if (error)
                                    return "filters." + error;
                            }
                        }
                        if (message.sorts != null && message.hasOwnProperty("sorts")) {
                            if (!Array.isArray(message.sorts))
                                return "sorts: array expected";
                            for (var i = 0; i < message.sorts.length; ++i) {
                                var error = $root.palexy.task_management.v1.ViewConfig.DataSort.verify(message.sorts[i]);
                                if (error)
                                    return "sorts." + error;
                            }
                        }
                        if (message.groups != null && message.hasOwnProperty("groups")) {
                            if (!Array.isArray(message.groups))
                                return "groups: array expected";
                            for (var i = 0; i < message.groups.length; ++i) {
                                var error = $root.palexy.task_management.v1.ViewConfig.DataGroup.verify(message.groups[i]);
                                if (error)
                                    return "groups." + error;
                            }
                        }
                        if (message.boardConfig != null && message.hasOwnProperty("boardConfig")) {
                            var error = $root.palexy.task_management.v1.ViewConfig.BoardConfig.verify(message.boardConfig);
                            if (error)
                                return "boardConfig." + error;
                        }
                        if (message.tableConfig != null && message.hasOwnProperty("tableConfig")) {
                            var error = $root.palexy.task_management.v1.ViewConfig.TableConfig.verify(message.tableConfig);
                            if (error)
                                return "tableConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ViewConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ViewConfig} ViewConfig
                     */
                    ViewConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ViewConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.ViewConfig();
                        if (object.filters) {
                            if (!Array.isArray(object.filters))
                                throw TypeError(".palexy.task_management.v1.ViewConfig.filters: array expected");
                            message.filters = [];
                            for (var i = 0; i < object.filters.length; ++i) {
                                if (typeof object.filters[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ViewConfig.filters: object expected");
                                message.filters[i] = $root.palexy.task_management.v1.ViewConfig.DataFilter.fromObject(object.filters[i]);
                            }
                        }
                        if (object.sorts) {
                            if (!Array.isArray(object.sorts))
                                throw TypeError(".palexy.task_management.v1.ViewConfig.sorts: array expected");
                            message.sorts = [];
                            for (var i = 0; i < object.sorts.length; ++i) {
                                if (typeof object.sorts[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ViewConfig.sorts: object expected");
                                message.sorts[i] = $root.palexy.task_management.v1.ViewConfig.DataSort.fromObject(object.sorts[i]);
                            }
                        }
                        if (object.groups) {
                            if (!Array.isArray(object.groups))
                                throw TypeError(".palexy.task_management.v1.ViewConfig.groups: array expected");
                            message.groups = [];
                            for (var i = 0; i < object.groups.length; ++i) {
                                if (typeof object.groups[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ViewConfig.groups: object expected");
                                message.groups[i] = $root.palexy.task_management.v1.ViewConfig.DataGroup.fromObject(object.groups[i]);
                            }
                        }
                        if (object.boardConfig != null) {
                            if (typeof object.boardConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.ViewConfig.boardConfig: object expected");
                            message.boardConfig = $root.palexy.task_management.v1.ViewConfig.BoardConfig.fromObject(object.boardConfig);
                        }
                        if (object.tableConfig != null) {
                            if (typeof object.tableConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.ViewConfig.tableConfig: object expected");
                            message.tableConfig = $root.palexy.task_management.v1.ViewConfig.TableConfig.fromObject(object.tableConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ViewConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @static
                     * @param {palexy.task_management.v1.ViewConfig} message ViewConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ViewConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.filters = [];
                            object.sorts = [];
                            object.groups = [];
                        }
                        if (options.defaults) {
                            object.boardConfig = null;
                            object.tableConfig = null;
                        }
                        if (message.filters && message.filters.length) {
                            object.filters = [];
                            for (var j = 0; j < message.filters.length; ++j)
                                object.filters[j] = $root.palexy.task_management.v1.ViewConfig.DataFilter.toObject(message.filters[j], options);
                        }
                        if (message.sorts && message.sorts.length) {
                            object.sorts = [];
                            for (var j = 0; j < message.sorts.length; ++j)
                                object.sorts[j] = $root.palexy.task_management.v1.ViewConfig.DataSort.toObject(message.sorts[j], options);
                        }
                        if (message.groups && message.groups.length) {
                            object.groups = [];
                            for (var j = 0; j < message.groups.length; ++j)
                                object.groups[j] = $root.palexy.task_management.v1.ViewConfig.DataGroup.toObject(message.groups[j], options);
                        }
                        if (message.boardConfig != null && message.hasOwnProperty("boardConfig"))
                            object.boardConfig = $root.palexy.task_management.v1.ViewConfig.BoardConfig.toObject(message.boardConfig, options);
                        if (message.tableConfig != null && message.hasOwnProperty("tableConfig"))
                            object.tableConfig = $root.palexy.task_management.v1.ViewConfig.TableConfig.toObject(message.tableConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this ViewConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ViewConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ViewConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ViewConfig.DataFilter = (function() {
    
                        /**
                         * Properties of a DataFilter.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @interface IDataFilter
                         * @property {string|null} [propertyId] DataFilter propertyId
                         * @property {palexy.task_management.v1.ViewConfig.DataFilter.Operator|null} [op] DataFilter op
                         * @property {string|null} [value] DataFilter value
                         */
    
                        /**
                         * Constructs a new DataFilter.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @classdesc Represents a DataFilter.
                         * @implements IDataFilter
                         * @constructor
                         * @param {palexy.task_management.v1.ViewConfig.IDataFilter=} [properties] Properties to set
                         */
                        function DataFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DataFilter propertyId.
                         * @member {string} propertyId
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @instance
                         */
                        DataFilter.prototype.propertyId = "";
    
                        /**
                         * DataFilter op.
                         * @member {palexy.task_management.v1.ViewConfig.DataFilter.Operator} op
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @instance
                         */
                        DataFilter.prototype.op = 0;
    
                        /**
                         * DataFilter value.
                         * @member {string} value
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @instance
                         */
                        DataFilter.prototype.value = "";
    
                        /**
                         * Creates a new DataFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataFilter=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.ViewConfig.DataFilter} DataFilter instance
                         */
                        DataFilter.create = function create(properties) {
                            return new DataFilter(properties);
                        };
    
                        /**
                         * Encodes the specified DataFilter message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataFilter} message DataFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.propertyId != null && Object.hasOwnProperty.call(message, "propertyId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.propertyId);
                            if (message.op != null && Object.hasOwnProperty.call(message, "op"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.op);
                            if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.value);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DataFilter message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataFilter} message DataFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DataFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.ViewConfig.DataFilter} DataFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.DataFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.propertyId = reader.string();
                                    break;
                                case 2:
                                    message.op = reader.int32();
                                    break;
                                case 3:
                                    message.value = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DataFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.ViewConfig.DataFilter} DataFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DataFilter message.
                         * @function verify
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DataFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                if (!$util.isString(message.propertyId))
                                    return "propertyId: string expected";
                            if (message.op != null && message.hasOwnProperty("op"))
                                switch (message.op) {
                                default:
                                    return "op: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                            if (message.value != null && message.hasOwnProperty("value"))
                                if (!$util.isString(message.value))
                                    return "value: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DataFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.ViewConfig.DataFilter} DataFilter
                         */
                        DataFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.ViewConfig.DataFilter)
                                return object;
                            var message = new $root.palexy.task_management.v1.ViewConfig.DataFilter();
                            if (object.propertyId != null)
                                message.propertyId = String(object.propertyId);
                            switch (object.op) {
                            case "OPERATOR_UNSPECIFIED":
                            case 0:
                                message.op = 0;
                                break;
                            case "IS":
                            case 1:
                                message.op = 1;
                                break;
                            case "IS_NOT":
                            case 2:
                                message.op = 2;
                                break;
                            case "CONTAINS":
                            case 3:
                                message.op = 3;
                                break;
                            case "IS_AFTER":
                            case 4:
                                message.op = 4;
                                break;
                            case "IS_ON_OR_BEFORE":
                            case 5:
                                message.op = 5;
                                break;
                            }
                            if (object.value != null)
                                message.value = String(object.value);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DataFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.DataFilter} message DataFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DataFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.propertyId = "";
                                object.op = options.enums === String ? "OPERATOR_UNSPECIFIED" : 0;
                                object.value = "";
                            }
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                object.propertyId = message.propertyId;
                            if (message.op != null && message.hasOwnProperty("op"))
                                object.op = options.enums === String ? $root.palexy.task_management.v1.ViewConfig.DataFilter.Operator[message.op] : message.op;
                            if (message.value != null && message.hasOwnProperty("value"))
                                object.value = message.value;
                            return object;
                        };
    
                        /**
                         * Converts this DataFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.ViewConfig.DataFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DataFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * Operator enum.
                         * @name palexy.task_management.v1.ViewConfig.DataFilter.Operator
                         * @enum {number}
                         * @property {number} OPERATOR_UNSPECIFIED=0 OPERATOR_UNSPECIFIED value
                         * @property {number} IS=1 IS value
                         * @property {number} IS_NOT=2 IS_NOT value
                         * @property {number} CONTAINS=3 CONTAINS value
                         * @property {number} IS_AFTER=4 IS_AFTER value
                         * @property {number} IS_ON_OR_BEFORE=5 IS_ON_OR_BEFORE value
                         */
                        DataFilter.Operator = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "OPERATOR_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "IS"] = 1;
                            values[valuesById[2] = "IS_NOT"] = 2;
                            values[valuesById[3] = "CONTAINS"] = 3;
                            values[valuesById[4] = "IS_AFTER"] = 4;
                            values[valuesById[5] = "IS_ON_OR_BEFORE"] = 5;
                            return values;
                        })();
    
                        return DataFilter;
                    })();
    
                    ViewConfig.DataSort = (function() {
    
                        /**
                         * Properties of a DataSort.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @interface IDataSort
                         * @property {string|null} [propertyId] DataSort propertyId
                         * @property {palexy.task_management.v1.ViewConfig.DataSort.Order|null} [order] DataSort order
                         */
    
                        /**
                         * Constructs a new DataSort.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @classdesc Represents a DataSort.
                         * @implements IDataSort
                         * @constructor
                         * @param {palexy.task_management.v1.ViewConfig.IDataSort=} [properties] Properties to set
                         */
                        function DataSort(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DataSort propertyId.
                         * @member {string} propertyId
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @instance
                         */
                        DataSort.prototype.propertyId = "";
    
                        /**
                         * DataSort order.
                         * @member {palexy.task_management.v1.ViewConfig.DataSort.Order} order
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @instance
                         */
                        DataSort.prototype.order = 0;
    
                        /**
                         * Creates a new DataSort instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataSort=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.ViewConfig.DataSort} DataSort instance
                         */
                        DataSort.create = function create(properties) {
                            return new DataSort(properties);
                        };
    
                        /**
                         * Encodes the specified DataSort message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataSort.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataSort} message DataSort message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataSort.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.propertyId != null && Object.hasOwnProperty.call(message, "propertyId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.propertyId);
                            if (message.order != null && Object.hasOwnProperty.call(message, "order"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.order);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DataSort message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataSort.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataSort} message DataSort message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataSort.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DataSort message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.ViewConfig.DataSort} DataSort
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataSort.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.DataSort();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.propertyId = reader.string();
                                    break;
                                case 2:
                                    message.order = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DataSort message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.ViewConfig.DataSort} DataSort
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataSort.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DataSort message.
                         * @function verify
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DataSort.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                if (!$util.isString(message.propertyId))
                                    return "propertyId: string expected";
                            if (message.order != null && message.hasOwnProperty("order"))
                                switch (message.order) {
                                default:
                                    return "order: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            return null;
                        };
    
                        /**
                         * Creates a DataSort message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.ViewConfig.DataSort} DataSort
                         */
                        DataSort.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.ViewConfig.DataSort)
                                return object;
                            var message = new $root.palexy.task_management.v1.ViewConfig.DataSort();
                            if (object.propertyId != null)
                                message.propertyId = String(object.propertyId);
                            switch (object.order) {
                            case "ORDER_UNSPECIFIED":
                            case 0:
                                message.order = 0;
                                break;
                            case "ASC":
                            case 1:
                                message.order = 1;
                                break;
                            case "DESC":
                            case 2:
                                message.order = 2;
                                break;
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DataSort message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.DataSort} message DataSort
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DataSort.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.propertyId = "";
                                object.order = options.enums === String ? "ORDER_UNSPECIFIED" : 0;
                            }
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                object.propertyId = message.propertyId;
                            if (message.order != null && message.hasOwnProperty("order"))
                                object.order = options.enums === String ? $root.palexy.task_management.v1.ViewConfig.DataSort.Order[message.order] : message.order;
                            return object;
                        };
    
                        /**
                         * Converts this DataSort to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.ViewConfig.DataSort
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DataSort.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * Order enum.
                         * @name palexy.task_management.v1.ViewConfig.DataSort.Order
                         * @enum {number}
                         * @property {number} ORDER_UNSPECIFIED=0 ORDER_UNSPECIFIED value
                         * @property {number} ASC=1 ASC value
                         * @property {number} DESC=2 DESC value
                         */
                        DataSort.Order = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "ORDER_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "ASC"] = 1;
                            values[valuesById[2] = "DESC"] = 2;
                            return values;
                        })();
    
                        return DataSort;
                    })();
    
                    ViewConfig.DataGroup = (function() {
    
                        /**
                         * Properties of a DataGroup.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @interface IDataGroup
                         * @property {string|null} [propertyId] DataGroup propertyId
                         */
    
                        /**
                         * Constructs a new DataGroup.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @classdesc Represents a DataGroup.
                         * @implements IDataGroup
                         * @constructor
                         * @param {palexy.task_management.v1.ViewConfig.IDataGroup=} [properties] Properties to set
                         */
                        function DataGroup(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DataGroup propertyId.
                         * @member {string} propertyId
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @instance
                         */
                        DataGroup.prototype.propertyId = "";
    
                        /**
                         * Creates a new DataGroup instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataGroup=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.ViewConfig.DataGroup} DataGroup instance
                         */
                        DataGroup.create = function create(properties) {
                            return new DataGroup(properties);
                        };
    
                        /**
                         * Encodes the specified DataGroup message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataGroup.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataGroup} message DataGroup message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataGroup.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.propertyId != null && Object.hasOwnProperty.call(message, "propertyId"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.propertyId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DataGroup message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.DataGroup.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IDataGroup} message DataGroup message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DataGroup.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DataGroup message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.ViewConfig.DataGroup} DataGroup
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataGroup.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.DataGroup();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.propertyId = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DataGroup message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.ViewConfig.DataGroup} DataGroup
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DataGroup.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DataGroup message.
                         * @function verify
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DataGroup.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                if (!$util.isString(message.propertyId))
                                    return "propertyId: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a DataGroup message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.ViewConfig.DataGroup} DataGroup
                         */
                        DataGroup.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.ViewConfig.DataGroup)
                                return object;
                            var message = new $root.palexy.task_management.v1.ViewConfig.DataGroup();
                            if (object.propertyId != null)
                                message.propertyId = String(object.propertyId);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DataGroup message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.DataGroup} message DataGroup
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DataGroup.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                object.propertyId = "";
                            if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                object.propertyId = message.propertyId;
                            return object;
                        };
    
                        /**
                         * Converts this DataGroup to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.ViewConfig.DataGroup
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DataGroup.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DataGroup;
                    })();
    
                    ViewConfig.BoardConfig = (function() {
    
                        /**
                         * Properties of a BoardConfig.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @interface IBoardConfig
                         * @property {Array.<palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement>|null} [arrangements] BoardConfig arrangements
                         */
    
                        /**
                         * Constructs a new BoardConfig.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @classdesc Represents a BoardConfig.
                         * @implements IBoardConfig
                         * @constructor
                         * @param {palexy.task_management.v1.ViewConfig.IBoardConfig=} [properties] Properties to set
                         */
                        function BoardConfig(properties) {
                            this.arrangements = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * BoardConfig arrangements.
                         * @member {Array.<palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement>} arrangements
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @instance
                         */
                        BoardConfig.prototype.arrangements = $util.emptyArray;
    
                        /**
                         * Creates a new BoardConfig instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IBoardConfig=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.ViewConfig.BoardConfig} BoardConfig instance
                         */
                        BoardConfig.create = function create(properties) {
                            return new BoardConfig(properties);
                        };
    
                        /**
                         * Encodes the specified BoardConfig message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.BoardConfig.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IBoardConfig} message BoardConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoardConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.arrangements != null && message.arrangements.length)
                                for (var i = 0; i < message.arrangements.length; ++i)
                                    $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.encode(message.arrangements[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                            return writer;
                        };
    
                        /**
                         * Encodes the specified BoardConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.BoardConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.IBoardConfig} message BoardConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        BoardConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a BoardConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.ViewConfig.BoardConfig} BoardConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoardConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.BoardConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.arrangements && message.arrangements.length))
                                        message.arrangements = [];
                                    message.arrangements.push($root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.decode(reader, reader.uint32()));
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a BoardConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.ViewConfig.BoardConfig} BoardConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        BoardConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a BoardConfig message.
                         * @function verify
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        BoardConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.arrangements != null && message.hasOwnProperty("arrangements")) {
                                if (!Array.isArray(message.arrangements))
                                    return "arrangements: array expected";
                                for (var i = 0; i < message.arrangements.length; ++i) {
                                    var error = $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.verify(message.arrangements[i]);
                                    if (error)
                                        return "arrangements." + error;
                                }
                            }
                            return null;
                        };
    
                        /**
                         * Creates a BoardConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.ViewConfig.BoardConfig} BoardConfig
                         */
                        BoardConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.ViewConfig.BoardConfig)
                                return object;
                            var message = new $root.palexy.task_management.v1.ViewConfig.BoardConfig();
                            if (object.arrangements) {
                                if (!Array.isArray(object.arrangements))
                                    throw TypeError(".palexy.task_management.v1.ViewConfig.BoardConfig.arrangements: array expected");
                                message.arrangements = [];
                                for (var i = 0; i < object.arrangements.length; ++i) {
                                    if (typeof object.arrangements[i] !== "object")
                                        throw TypeError(".palexy.task_management.v1.ViewConfig.BoardConfig.arrangements: object expected");
                                    message.arrangements[i] = $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.fromObject(object.arrangements[i]);
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a BoardConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.BoardConfig} message BoardConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        BoardConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.arrangements = [];
                            if (message.arrangements && message.arrangements.length) {
                                object.arrangements = [];
                                for (var j = 0; j < message.arrangements.length; ++j)
                                    object.arrangements[j] = $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.toObject(message.arrangements[j], options);
                            }
                            return object;
                        };
    
                        /**
                         * Converts this BoardConfig to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        BoardConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        BoardConfig.ColumnArrangement = (function() {
    
                            /**
                             * Properties of a ColumnArrangement.
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                             * @interface IColumnArrangement
                             * @property {string|null} [propertyId] ColumnArrangement propertyId
                             * @property {Array.<string>|null} [columnKeys] ColumnArrangement columnKeys
                             * @property {Array.<string>|null} [hiddenKeys] ColumnArrangement hiddenKeys
                             * @property {Array.<string>|null} [visibleKeys] ColumnArrangement visibleKeys
                             */
    
                            /**
                             * Constructs a new ColumnArrangement.
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig
                             * @classdesc Represents a ColumnArrangement.
                             * @implements IColumnArrangement
                             * @constructor
                             * @param {palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement=} [properties] Properties to set
                             */
                            function ColumnArrangement(properties) {
                                this.columnKeys = [];
                                this.hiddenKeys = [];
                                this.visibleKeys = [];
                                if (properties)
                                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                        if (properties[keys[i]] != null)
                                            this[keys[i]] = properties[keys[i]];
                            }
    
                            /**
                             * ColumnArrangement propertyId.
                             * @member {string} propertyId
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @instance
                             */
                            ColumnArrangement.prototype.propertyId = "";
    
                            /**
                             * ColumnArrangement columnKeys.
                             * @member {Array.<string>} columnKeys
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @instance
                             */
                            ColumnArrangement.prototype.columnKeys = $util.emptyArray;
    
                            /**
                             * ColumnArrangement hiddenKeys.
                             * @member {Array.<string>} hiddenKeys
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @instance
                             */
                            ColumnArrangement.prototype.hiddenKeys = $util.emptyArray;
    
                            /**
                             * ColumnArrangement visibleKeys.
                             * @member {Array.<string>} visibleKeys
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @instance
                             */
                            ColumnArrangement.prototype.visibleKeys = $util.emptyArray;
    
                            /**
                             * Creates a new ColumnArrangement instance using the specified properties.
                             * @function create
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement=} [properties] Properties to set
                             * @returns {palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement} ColumnArrangement instance
                             */
                            ColumnArrangement.create = function create(properties) {
                                return new ColumnArrangement(properties);
                            };
    
                            /**
                             * Encodes the specified ColumnArrangement message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.verify|verify} messages.
                             * @function encode
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement} message ColumnArrangement message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ColumnArrangement.encode = function encode(message, writer) {
                                if (!writer)
                                    writer = $Writer.create();
                                if (message.propertyId != null && Object.hasOwnProperty.call(message, "propertyId"))
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.propertyId);
                                if (message.columnKeys != null && message.columnKeys.length)
                                    for (var i = 0; i < message.columnKeys.length; ++i)
                                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.columnKeys[i]);
                                if (message.hiddenKeys != null && message.hiddenKeys.length)
                                    for (var i = 0; i < message.hiddenKeys.length; ++i)
                                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.hiddenKeys[i]);
                                if (message.visibleKeys != null && message.visibleKeys.length)
                                    for (var i = 0; i < message.visibleKeys.length; ++i)
                                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.visibleKeys[i]);
                                return writer;
                            };
    
                            /**
                             * Encodes the specified ColumnArrangement message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.verify|verify} messages.
                             * @function encodeDelimited
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {palexy.task_management.v1.ViewConfig.BoardConfig.IColumnArrangement} message ColumnArrangement message or plain object to encode
                             * @param {$protobuf.Writer} [writer] Writer to encode to
                             * @returns {$protobuf.Writer} Writer
                             */
                            ColumnArrangement.encodeDelimited = function encodeDelimited(message, writer) {
                                return this.encode(message, writer).ldelim();
                            };
    
                            /**
                             * Decodes a ColumnArrangement message from the specified reader or buffer.
                             * @function decode
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @param {number} [length] Message length if known beforehand
                             * @returns {palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement} ColumnArrangement
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ColumnArrangement.decode = function decode(reader, length) {
                                if (!(reader instanceof $Reader))
                                    reader = $Reader.create(reader);
                                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement();
                                while (reader.pos < end) {
                                    var tag = reader.uint32();
                                    switch (tag >>> 3) {
                                    case 1:
                                        message.propertyId = reader.string();
                                        break;
                                    case 2:
                                        if (!(message.columnKeys && message.columnKeys.length))
                                            message.columnKeys = [];
                                        message.columnKeys.push(reader.string());
                                        break;
                                    case 3:
                                        if (!(message.hiddenKeys && message.hiddenKeys.length))
                                            message.hiddenKeys = [];
                                        message.hiddenKeys.push(reader.string());
                                        break;
                                    case 4:
                                        if (!(message.visibleKeys && message.visibleKeys.length))
                                            message.visibleKeys = [];
                                        message.visibleKeys.push(reader.string());
                                        break;
                                    default:
                                        reader.skipType(tag & 7);
                                        break;
                                    }
                                }
                                return message;
                            };
    
                            /**
                             * Decodes a ColumnArrangement message from the specified reader or buffer, length delimited.
                             * @function decodeDelimited
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                             * @returns {palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement} ColumnArrangement
                             * @throws {Error} If the payload is not a reader or valid buffer
                             * @throws {$protobuf.util.ProtocolError} If required fields are missing
                             */
                            ColumnArrangement.decodeDelimited = function decodeDelimited(reader) {
                                if (!(reader instanceof $Reader))
                                    reader = new $Reader(reader);
                                return this.decode(reader, reader.uint32());
                            };
    
                            /**
                             * Verifies a ColumnArrangement message.
                             * @function verify
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {Object.<string,*>} message Plain object to verify
                             * @returns {string|null} `null` if valid, otherwise the reason why it is not
                             */
                            ColumnArrangement.verify = function verify(message) {
                                if (typeof message !== "object" || message === null)
                                    return "object expected";
                                if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                    if (!$util.isString(message.propertyId))
                                        return "propertyId: string expected";
                                if (message.columnKeys != null && message.hasOwnProperty("columnKeys")) {
                                    if (!Array.isArray(message.columnKeys))
                                        return "columnKeys: array expected";
                                    for (var i = 0; i < message.columnKeys.length; ++i)
                                        if (!$util.isString(message.columnKeys[i]))
                                            return "columnKeys: string[] expected";
                                }
                                if (message.hiddenKeys != null && message.hasOwnProperty("hiddenKeys")) {
                                    if (!Array.isArray(message.hiddenKeys))
                                        return "hiddenKeys: array expected";
                                    for (var i = 0; i < message.hiddenKeys.length; ++i)
                                        if (!$util.isString(message.hiddenKeys[i]))
                                            return "hiddenKeys: string[] expected";
                                }
                                if (message.visibleKeys != null && message.hasOwnProperty("visibleKeys")) {
                                    if (!Array.isArray(message.visibleKeys))
                                        return "visibleKeys: array expected";
                                    for (var i = 0; i < message.visibleKeys.length; ++i)
                                        if (!$util.isString(message.visibleKeys[i]))
                                            return "visibleKeys: string[] expected";
                                }
                                return null;
                            };
    
                            /**
                             * Creates a ColumnArrangement message from a plain object. Also converts values to their respective internal types.
                             * @function fromObject
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {Object.<string,*>} object Plain object
                             * @returns {palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement} ColumnArrangement
                             */
                            ColumnArrangement.fromObject = function fromObject(object) {
                                if (object instanceof $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement)
                                    return object;
                                var message = new $root.palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement();
                                if (object.propertyId != null)
                                    message.propertyId = String(object.propertyId);
                                if (object.columnKeys) {
                                    if (!Array.isArray(object.columnKeys))
                                        throw TypeError(".palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.columnKeys: array expected");
                                    message.columnKeys = [];
                                    for (var i = 0; i < object.columnKeys.length; ++i)
                                        message.columnKeys[i] = String(object.columnKeys[i]);
                                }
                                if (object.hiddenKeys) {
                                    if (!Array.isArray(object.hiddenKeys))
                                        throw TypeError(".palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.hiddenKeys: array expected");
                                    message.hiddenKeys = [];
                                    for (var i = 0; i < object.hiddenKeys.length; ++i)
                                        message.hiddenKeys[i] = String(object.hiddenKeys[i]);
                                }
                                if (object.visibleKeys) {
                                    if (!Array.isArray(object.visibleKeys))
                                        throw TypeError(".palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement.visibleKeys: array expected");
                                    message.visibleKeys = [];
                                    for (var i = 0; i < object.visibleKeys.length; ++i)
                                        message.visibleKeys[i] = String(object.visibleKeys[i]);
                                }
                                return message;
                            };
    
                            /**
                             * Creates a plain object from a ColumnArrangement message. Also converts values to other types if specified.
                             * @function toObject
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @static
                             * @param {palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement} message ColumnArrangement
                             * @param {$protobuf.IConversionOptions} [options] Conversion options
                             * @returns {Object.<string,*>} Plain object
                             */
                            ColumnArrangement.toObject = function toObject(message, options) {
                                if (!options)
                                    options = {};
                                var object = {};
                                if (options.arrays || options.defaults) {
                                    object.columnKeys = [];
                                    object.hiddenKeys = [];
                                    object.visibleKeys = [];
                                }
                                if (options.defaults)
                                    object.propertyId = "";
                                if (message.propertyId != null && message.hasOwnProperty("propertyId"))
                                    object.propertyId = message.propertyId;
                                if (message.columnKeys && message.columnKeys.length) {
                                    object.columnKeys = [];
                                    for (var j = 0; j < message.columnKeys.length; ++j)
                                        object.columnKeys[j] = message.columnKeys[j];
                                }
                                if (message.hiddenKeys && message.hiddenKeys.length) {
                                    object.hiddenKeys = [];
                                    for (var j = 0; j < message.hiddenKeys.length; ++j)
                                        object.hiddenKeys[j] = message.hiddenKeys[j];
                                }
                                if (message.visibleKeys && message.visibleKeys.length) {
                                    object.visibleKeys = [];
                                    for (var j = 0; j < message.visibleKeys.length; ++j)
                                        object.visibleKeys[j] = message.visibleKeys[j];
                                }
                                return object;
                            };
    
                            /**
                             * Converts this ColumnArrangement to JSON.
                             * @function toJSON
                             * @memberof palexy.task_management.v1.ViewConfig.BoardConfig.ColumnArrangement
                             * @instance
                             * @returns {Object.<string,*>} JSON object
                             */
                            ColumnArrangement.prototype.toJSON = function toJSON() {
                                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                            };
    
                            return ColumnArrangement;
                        })();
    
                        return BoardConfig;
                    })();
    
                    ViewConfig.TableConfig = (function() {
    
                        /**
                         * Properties of a TableConfig.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @interface ITableConfig
                         * @property {Array.<string>|null} [visibleColumns] TableConfig visibleColumns
                         */
    
                        /**
                         * Constructs a new TableConfig.
                         * @memberof palexy.task_management.v1.ViewConfig
                         * @classdesc Represents a TableConfig.
                         * @implements ITableConfig
                         * @constructor
                         * @param {palexy.task_management.v1.ViewConfig.ITableConfig=} [properties] Properties to set
                         */
                        function TableConfig(properties) {
                            this.visibleColumns = [];
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TableConfig visibleColumns.
                         * @member {Array.<string>} visibleColumns
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @instance
                         */
                        TableConfig.prototype.visibleColumns = $util.emptyArray;
    
                        /**
                         * Creates a new TableConfig instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.ITableConfig=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.ViewConfig.TableConfig} TableConfig instance
                         */
                        TableConfig.create = function create(properties) {
                            return new TableConfig(properties);
                        };
    
                        /**
                         * Encodes the specified TableConfig message. Does not implicitly {@link palexy.task_management.v1.ViewConfig.TableConfig.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.ITableConfig} message TableConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TableConfig.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.visibleColumns != null && message.visibleColumns.length)
                                for (var i = 0; i < message.visibleColumns.length; ++i)
                                    writer.uint32(/* id 1, wireType 2 =*/10).string(message.visibleColumns[i]);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TableConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.ViewConfig.TableConfig.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.ITableConfig} message TableConfig message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TableConfig.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TableConfig message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.ViewConfig.TableConfig} TableConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TableConfig.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ViewConfig.TableConfig();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    if (!(message.visibleColumns && message.visibleColumns.length))
                                        message.visibleColumns = [];
                                    message.visibleColumns.push(reader.string());
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TableConfig message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.ViewConfig.TableConfig} TableConfig
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TableConfig.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TableConfig message.
                         * @function verify
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TableConfig.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.visibleColumns != null && message.hasOwnProperty("visibleColumns")) {
                                if (!Array.isArray(message.visibleColumns))
                                    return "visibleColumns: array expected";
                                for (var i = 0; i < message.visibleColumns.length; ++i)
                                    if (!$util.isString(message.visibleColumns[i]))
                                        return "visibleColumns: string[] expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a TableConfig message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.ViewConfig.TableConfig} TableConfig
                         */
                        TableConfig.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.ViewConfig.TableConfig)
                                return object;
                            var message = new $root.palexy.task_management.v1.ViewConfig.TableConfig();
                            if (object.visibleColumns) {
                                if (!Array.isArray(object.visibleColumns))
                                    throw TypeError(".palexy.task_management.v1.ViewConfig.TableConfig.visibleColumns: array expected");
                                message.visibleColumns = [];
                                for (var i = 0; i < object.visibleColumns.length; ++i)
                                    message.visibleColumns[i] = String(object.visibleColumns[i]);
                            }
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TableConfig message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @static
                         * @param {palexy.task_management.v1.ViewConfig.TableConfig} message TableConfig
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TableConfig.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.arrays || options.defaults)
                                object.visibleColumns = [];
                            if (message.visibleColumns && message.visibleColumns.length) {
                                object.visibleColumns = [];
                                for (var j = 0; j < message.visibleColumns.length; ++j)
                                    object.visibleColumns[j] = message.visibleColumns[j];
                            }
                            return object;
                        };
    
                        /**
                         * Converts this TableConfig to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.ViewConfig.TableConfig
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TableConfig.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TableConfig;
                    })();
    
                    return ViewConfig;
                })();
    
                v1.TaskGroup = (function() {
    
                    /**
                     * Properties of a TaskGroup.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskGroup
                     * @property {number|null} [id] TaskGroup id
                     * @property {number|null} [projectId] TaskGroup projectId
                     * @property {string|null} [groupName] TaskGroup groupName
                     * @property {number|null} [createdTimeMs] TaskGroup createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] TaskGroup lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new TaskGroup.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskGroup.
                     * @implements ITaskGroup
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskGroup=} [properties] Properties to set
                     */
                    function TaskGroup(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskGroup id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     */
                    TaskGroup.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskGroup projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     */
                    TaskGroup.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskGroup groupName.
                     * @member {string} groupName
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     */
                    TaskGroup.prototype.groupName = "";
    
                    /**
                     * TaskGroup createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     */
                    TaskGroup.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskGroup lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     */
                    TaskGroup.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TaskGroup instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {palexy.task_management.v1.ITaskGroup=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskGroup} TaskGroup instance
                     */
                    TaskGroup.create = function create(properties) {
                        return new TaskGroup(properties);
                    };
    
                    /**
                     * Encodes the specified TaskGroup message. Does not implicitly {@link palexy.task_management.v1.TaskGroup.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {palexy.task_management.v1.ITaskGroup} message TaskGroup message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskGroup.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.groupName != null && Object.hasOwnProperty.call(message, "groupName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.groupName);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskGroup message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskGroup.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {palexy.task_management.v1.ITaskGroup} message TaskGroup message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskGroup.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskGroup message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskGroup} TaskGroup
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskGroup.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskGroup();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.projectId = reader.int64();
                                break;
                            case 3:
                                message.groupName = reader.string();
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskGroup message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskGroup} TaskGroup
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskGroup.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskGroup message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskGroup.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.groupName != null && message.hasOwnProperty("groupName"))
                            if (!$util.isString(message.groupName))
                                return "groupName: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TaskGroup message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskGroup} TaskGroup
                     */
                    TaskGroup.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskGroup)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskGroup();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.groupName != null)
                            message.groupName = String(object.groupName);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskGroup message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @static
                     * @param {palexy.task_management.v1.TaskGroup} message TaskGroup
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskGroup.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.groupName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.groupName != null && message.hasOwnProperty("groupName"))
                            object.groupName = message.groupName;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this TaskGroup to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskGroup
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskGroup.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskGroup;
                })();
    
                v1.Task = (function() {
    
                    /**
                     * Properties of a Task.
                     * @memberof palexy.task_management.v1
                     * @interface ITask
                     * @property {number|null} [id] Task id
                     * @property {number|null} [projectId] Task projectId
                     * @property {number|null} [groupId] Task groupId
                     * @property {number|null} [parentTaskId] Task parentTaskId
                     * @property {string|null} [title] Task title
                     * @property {string|null} [description] Task description
                     * @property {palexy.task_management.v1.IUser|null} [creator] Task creator
                     * @property {palexy.streaming.v1.IDateTimeRange|null} [dateRange] Task dateRange
                     * @property {boolean|null} [isCompleted] Task isCompleted
                     * @property {Array.<palexy.task_management.v1.IAssignee>|null} [assignees] Task assignees
                     * @property {Array.<palexy.task_management.v1.ITag>|null} [tags] Task tags
                     * @property {number|null} [createdTimeMs] Task createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Task lastUpdateTimeMs
                     * @property {palexy.task_management.v1.Task.TaskType|null} [taskType] Task taskType
                     * @property {palexy.task_management.v1.Task.TaskState|null} [taskState] Task taskState
                     * @property {number|null} [masterTaskId] Task masterTaskId
                     * @property {palexy.task_management.v1.IRecurrence|null} [recurrence] Task recurrence
                     * @property {palexy.task_management.v1.ICompletionRequirements|null} [completionRequirements] Task completionRequirements
                     * @property {palexy.task_management.v1.IAssignment|null} [assignment] Task assignment
                     * @property {Array.<palexy.task_management.v1.ITaskAttachment>|null} [attachments] Task attachments
                     * @property {boolean|null} [archiveMissed] Task archiveMissed
                     * @property {string|null} [dueDateTime] Task dueDateTime
                     * @property {palexy.task_management.v1.Task.TaskSubType|null} [taskSubType] Task taskSubType
                     * @property {string|null} [startDateTime] Task startDateTime
                     * @property {string|null} [endDateTime] Task endDateTime
                     * @property {number|null} [formId] Task formId
                     * @property {number|null} [formSubmissionId] Task formSubmissionId
                     * @property {Array.<palexy.task_management.v1.ITask>|null} [subtasks] Task subtasks
                     * @property {string|null} [projectName] Task projectName
                     * @property {palexy.task_management.v1.IPresenceVerification|null} [presenceVerification] Task presenceVerification
                     * @property {string|null} [completedDateTime] Task completedDateTime
                     * @property {boolean|null} [presenceVerified] Task presenceVerified
                     * @property {palexy.task_management.v1.IUser|null} [completedBy] Task completedBy
                     * @property {boolean|null} [isAuditTask] Task isAuditTask
                     * @property {number|null} [auditingTaskId] Task auditingTaskId
                     * @property {number|null} [presenceLatitude] Task presenceLatitude
                     * @property {number|null} [presenceLongitude] Task presenceLongitude
                     * @property {number|null} [presenceGeofenceRadiusM] Task presenceGeofenceRadiusM
                     * @property {string|null} [presenceExceptionReason] Task presenceExceptionReason
                     * @property {palexy.task_management.v1.Task.TaskPermission|null} [callerPermission] Task callerPermission
                     * @property {boolean|null} [qrCodeVerified] Task qrCodeVerified
                     * @property {boolean|null} [wifiMatchVerified] Task wifiMatchVerified
                     * @property {boolean|null} [storePhotoVerified] Task storePhotoVerified
                     * @property {boolean|null} [gpsGeofenceVerified] Task gpsGeofenceVerified
                     * @property {number|null} [followUpTaskId] Task followUpTaskId
                     * @property {palexy.task_management.v1.Task.Priority|null} [priority] Task priority
                     * @property {palexy.task_management.v1.Task.TicketState|null} [ticketState] Task ticketState
                     * @property {palexy.task_management.v1.Project.ProjectType|null} [projectType] Task projectType
                     * @property {palexy.task_management.v1.ITaskStore|null} [ticketStore] Task ticketStore
                     * @property {string|null} [externalId] Task externalId
                     * @property {string|null} [externalUri] Task externalUri
                     * @property {Array.<palexy.task_management.v1.Task.ITicketSubmission>|null} [ticketSubmissions] Task ticketSubmissions
                     * @property {boolean|null} [autoCloseResolved] Task autoCloseResolved
                     * @property {Array.<palexy.task_management.v1.Task.TicketState>|null} [ticketNextStates] Task ticketNextStates
                     */
    
                    /**
                     * Constructs a new Task.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Task.
                     * @implements ITask
                     * @constructor
                     * @param {palexy.task_management.v1.ITask=} [properties] Properties to set
                     */
                    function Task(properties) {
                        this.assignees = [];
                        this.tags = [];
                        this.attachments = [];
                        this.subtasks = [];
                        this.ticketSubmissions = [];
                        this.ticketNextStates = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Task id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task groupId.
                     * @member {number} groupId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.groupId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task parentTaskId.
                     * @member {number} parentTaskId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.parentTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task title.
                     * @member {string} title
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.title = "";
    
                    /**
                     * Task description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.description = "";
    
                    /**
                     * Task creator.
                     * @member {palexy.task_management.v1.IUser|null|undefined} creator
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.creator = null;
    
                    /**
                     * Task dateRange.
                     * @member {palexy.streaming.v1.IDateTimeRange|null|undefined} dateRange
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.dateRange = null;
    
                    /**
                     * Task isCompleted.
                     * @member {boolean} isCompleted
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.isCompleted = false;
    
                    /**
                     * Task assignees.
                     * @member {Array.<palexy.task_management.v1.IAssignee>} assignees
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.assignees = $util.emptyArray;
    
                    /**
                     * Task tags.
                     * @member {Array.<palexy.task_management.v1.ITag>} tags
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.tags = $util.emptyArray;
    
                    /**
                     * Task createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task taskType.
                     * @member {palexy.task_management.v1.Task.TaskType} taskType
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.taskType = 0;
    
                    /**
                     * Task taskState.
                     * @member {palexy.task_management.v1.Task.TaskState} taskState
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.taskState = 0;
    
                    /**
                     * Task masterTaskId.
                     * @member {number} masterTaskId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.masterTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task recurrence.
                     * @member {palexy.task_management.v1.IRecurrence|null|undefined} recurrence
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.recurrence = null;
    
                    /**
                     * Task completionRequirements.
                     * @member {palexy.task_management.v1.ICompletionRequirements|null|undefined} completionRequirements
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.completionRequirements = null;
    
                    /**
                     * Task assignment.
                     * @member {palexy.task_management.v1.IAssignment|null|undefined} assignment
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.assignment = null;
    
                    /**
                     * Task attachments.
                     * @member {Array.<palexy.task_management.v1.ITaskAttachment>} attachments
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.attachments = $util.emptyArray;
    
                    /**
                     * Task archiveMissed.
                     * @member {boolean} archiveMissed
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.archiveMissed = false;
    
                    /**
                     * Task dueDateTime.
                     * @member {string} dueDateTime
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.dueDateTime = "";
    
                    /**
                     * Task taskSubType.
                     * @member {palexy.task_management.v1.Task.TaskSubType} taskSubType
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.taskSubType = 0;
    
                    /**
                     * Task startDateTime.
                     * @member {string} startDateTime
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.startDateTime = "";
    
                    /**
                     * Task endDateTime.
                     * @member {string} endDateTime
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.endDateTime = "";
    
                    /**
                     * Task formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task formSubmissionId.
                     * @member {number} formSubmissionId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.formSubmissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task subtasks.
                     * @member {Array.<palexy.task_management.v1.ITask>} subtasks
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.subtasks = $util.emptyArray;
    
                    /**
                     * Task projectName.
                     * @member {string} projectName
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.projectName = "";
    
                    /**
                     * Task presenceVerification.
                     * @member {palexy.task_management.v1.IPresenceVerification|null|undefined} presenceVerification
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceVerification = null;
    
                    /**
                     * Task completedDateTime.
                     * @member {string} completedDateTime
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.completedDateTime = "";
    
                    /**
                     * Task presenceVerified.
                     * @member {boolean} presenceVerified
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceVerified = false;
    
                    /**
                     * Task completedBy.
                     * @member {palexy.task_management.v1.IUser|null|undefined} completedBy
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.completedBy = null;
    
                    /**
                     * Task isAuditTask.
                     * @member {boolean} isAuditTask
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.isAuditTask = false;
    
                    /**
                     * Task auditingTaskId.
                     * @member {number} auditingTaskId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.auditingTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task presenceLatitude.
                     * @member {number} presenceLatitude
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceLatitude = 0;
    
                    /**
                     * Task presenceLongitude.
                     * @member {number} presenceLongitude
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceLongitude = 0;
    
                    /**
                     * Task presenceGeofenceRadiusM.
                     * @member {number} presenceGeofenceRadiusM
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceGeofenceRadiusM = 0;
    
                    /**
                     * Task presenceExceptionReason.
                     * @member {string} presenceExceptionReason
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.presenceExceptionReason = "";
    
                    /**
                     * Task callerPermission.
                     * @member {palexy.task_management.v1.Task.TaskPermission} callerPermission
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.callerPermission = 0;
    
                    /**
                     * Task qrCodeVerified.
                     * @member {boolean} qrCodeVerified
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.qrCodeVerified = false;
    
                    /**
                     * Task wifiMatchVerified.
                     * @member {boolean} wifiMatchVerified
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.wifiMatchVerified = false;
    
                    /**
                     * Task storePhotoVerified.
                     * @member {boolean} storePhotoVerified
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.storePhotoVerified = false;
    
                    /**
                     * Task gpsGeofenceVerified.
                     * @member {boolean} gpsGeofenceVerified
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.gpsGeofenceVerified = false;
    
                    /**
                     * Task followUpTaskId.
                     * @member {number} followUpTaskId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.followUpTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Task priority.
                     * @member {palexy.task_management.v1.Task.Priority} priority
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.priority = 0;
    
                    /**
                     * Task ticketState.
                     * @member {palexy.task_management.v1.Task.TicketState} ticketState
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.ticketState = 0;
    
                    /**
                     * Task projectType.
                     * @member {palexy.task_management.v1.Project.ProjectType} projectType
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.projectType = 0;
    
                    /**
                     * Task ticketStore.
                     * @member {palexy.task_management.v1.ITaskStore|null|undefined} ticketStore
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.ticketStore = null;
    
                    /**
                     * Task externalId.
                     * @member {string} externalId
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.externalId = "";
    
                    /**
                     * Task externalUri.
                     * @member {string} externalUri
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.externalUri = "";
    
                    /**
                     * Task ticketSubmissions.
                     * @member {Array.<palexy.task_management.v1.Task.ITicketSubmission>} ticketSubmissions
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.ticketSubmissions = $util.emptyArray;
    
                    /**
                     * Task autoCloseResolved.
                     * @member {boolean|null|undefined} autoCloseResolved
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.autoCloseResolved = null;
    
                    /**
                     * Task ticketNextStates.
                     * @member {Array.<palexy.task_management.v1.Task.TicketState>} ticketNextStates
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Task.prototype.ticketNextStates = $util.emptyArray;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * Task _autoCloseResolved.
                     * @member {"autoCloseResolved"|undefined} _autoCloseResolved
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     */
                    Object.defineProperty(Task.prototype, "_autoCloseResolved", {
                        get: $util.oneOfGetter($oneOfFields = ["autoCloseResolved"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new Task instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {palexy.task_management.v1.ITask=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Task} Task instance
                     */
                    Task.create = function create(properties) {
                        return new Task(properties);
                    };
    
                    /**
                     * Encodes the specified Task message. Does not implicitly {@link palexy.task_management.v1.Task.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {palexy.task_management.v1.ITask} message Task message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Task.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.projectId);
                        if (message.groupId != null && Object.hasOwnProperty.call(message, "groupId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.groupId);
                        if (message.parentTaskId != null && Object.hasOwnProperty.call(message, "parentTaskId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.parentTaskId);
                        if (message.title != null && Object.hasOwnProperty.call(message, "title"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.title);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.description);
                        if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                            $root.palexy.task_management.v1.User.encode(message.creator, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateTimeRange.encode(message.dateRange, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.isCompleted != null && Object.hasOwnProperty.call(message, "isCompleted"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isCompleted);
                        if (message.assignees != null && message.assignees.length)
                            for (var i = 0; i < message.assignees.length; ++i)
                                $root.palexy.task_management.v1.Assignee.encode(message.assignees[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.tags != null && message.tags.length)
                            for (var i = 0; i < message.tags.length; ++i)
                                $root.palexy.task_management.v1.Tag.encode(message.tags[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.lastUpdateTimeMs);
                        if (message.taskType != null && Object.hasOwnProperty.call(message, "taskType"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.taskType);
                        if (message.taskState != null && Object.hasOwnProperty.call(message, "taskState"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int32(message.taskState);
                        if (message.masterTaskId != null && Object.hasOwnProperty.call(message, "masterTaskId"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int64(message.masterTaskId);
                        if (message.recurrence != null && Object.hasOwnProperty.call(message, "recurrence"))
                            $root.palexy.task_management.v1.Recurrence.encode(message.recurrence, writer.uint32(/* id 18, wireType 2 =*/146).fork()).ldelim();
                        if (message.completionRequirements != null && Object.hasOwnProperty.call(message, "completionRequirements"))
                            $root.palexy.task_management.v1.CompletionRequirements.encode(message.completionRequirements, writer.uint32(/* id 19, wireType 2 =*/154).fork()).ldelim();
                        if (message.assignment != null && Object.hasOwnProperty.call(message, "assignment"))
                            $root.palexy.task_management.v1.Assignment.encode(message.assignment, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.attachments != null && message.attachments.length)
                            for (var i = 0; i < message.attachments.length; ++i)
                                $root.palexy.task_management.v1.TaskAttachment.encode(message.attachments[i], writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        if (message.archiveMissed != null && Object.hasOwnProperty.call(message, "archiveMissed"))
                            writer.uint32(/* id 22, wireType 0 =*/176).bool(message.archiveMissed);
                        if (message.dueDateTime != null && Object.hasOwnProperty.call(message, "dueDateTime"))
                            writer.uint32(/* id 23, wireType 2 =*/186).string(message.dueDateTime);
                        if (message.taskSubType != null && Object.hasOwnProperty.call(message, "taskSubType"))
                            writer.uint32(/* id 24, wireType 0 =*/192).int32(message.taskSubType);
                        if (message.startDateTime != null && Object.hasOwnProperty.call(message, "startDateTime"))
                            writer.uint32(/* id 25, wireType 2 =*/202).string(message.startDateTime);
                        if (message.endDateTime != null && Object.hasOwnProperty.call(message, "endDateTime"))
                            writer.uint32(/* id 26, wireType 2 =*/210).string(message.endDateTime);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 27, wireType 0 =*/216).int64(message.formId);
                        if (message.formSubmissionId != null && Object.hasOwnProperty.call(message, "formSubmissionId"))
                            writer.uint32(/* id 28, wireType 0 =*/224).int64(message.formSubmissionId);
                        if (message.subtasks != null && message.subtasks.length)
                            for (var i = 0; i < message.subtasks.length; ++i)
                                $root.palexy.task_management.v1.Task.encode(message.subtasks[i], writer.uint32(/* id 29, wireType 2 =*/234).fork()).ldelim();
                        if (message.projectName != null && Object.hasOwnProperty.call(message, "projectName"))
                            writer.uint32(/* id 30, wireType 2 =*/242).string(message.projectName);
                        if (message.presenceVerification != null && Object.hasOwnProperty.call(message, "presenceVerification"))
                            $root.palexy.task_management.v1.PresenceVerification.encode(message.presenceVerification, writer.uint32(/* id 31, wireType 2 =*/250).fork()).ldelim();
                        if (message.completedDateTime != null && Object.hasOwnProperty.call(message, "completedDateTime"))
                            writer.uint32(/* id 32, wireType 2 =*/258).string(message.completedDateTime);
                        if (message.presenceVerified != null && Object.hasOwnProperty.call(message, "presenceVerified"))
                            writer.uint32(/* id 33, wireType 0 =*/264).bool(message.presenceVerified);
                        if (message.completedBy != null && Object.hasOwnProperty.call(message, "completedBy"))
                            $root.palexy.task_management.v1.User.encode(message.completedBy, writer.uint32(/* id 34, wireType 2 =*/274).fork()).ldelim();
                        if (message.isAuditTask != null && Object.hasOwnProperty.call(message, "isAuditTask"))
                            writer.uint32(/* id 35, wireType 0 =*/280).bool(message.isAuditTask);
                        if (message.auditingTaskId != null && Object.hasOwnProperty.call(message, "auditingTaskId"))
                            writer.uint32(/* id 36, wireType 0 =*/288).int64(message.auditingTaskId);
                        if (message.presenceLatitude != null && Object.hasOwnProperty.call(message, "presenceLatitude"))
                            writer.uint32(/* id 37, wireType 1 =*/297).double(message.presenceLatitude);
                        if (message.presenceLongitude != null && Object.hasOwnProperty.call(message, "presenceLongitude"))
                            writer.uint32(/* id 38, wireType 1 =*/305).double(message.presenceLongitude);
                        if (message.presenceGeofenceRadiusM != null && Object.hasOwnProperty.call(message, "presenceGeofenceRadiusM"))
                            writer.uint32(/* id 39, wireType 0 =*/312).int32(message.presenceGeofenceRadiusM);
                        if (message.presenceExceptionReason != null && Object.hasOwnProperty.call(message, "presenceExceptionReason"))
                            writer.uint32(/* id 40, wireType 2 =*/322).string(message.presenceExceptionReason);
                        if (message.callerPermission != null && Object.hasOwnProperty.call(message, "callerPermission"))
                            writer.uint32(/* id 41, wireType 0 =*/328).int32(message.callerPermission);
                        if (message.qrCodeVerified != null && Object.hasOwnProperty.call(message, "qrCodeVerified"))
                            writer.uint32(/* id 42, wireType 0 =*/336).bool(message.qrCodeVerified);
                        if (message.wifiMatchVerified != null && Object.hasOwnProperty.call(message, "wifiMatchVerified"))
                            writer.uint32(/* id 43, wireType 0 =*/344).bool(message.wifiMatchVerified);
                        if (message.storePhotoVerified != null && Object.hasOwnProperty.call(message, "storePhotoVerified"))
                            writer.uint32(/* id 44, wireType 0 =*/352).bool(message.storePhotoVerified);
                        if (message.gpsGeofenceVerified != null && Object.hasOwnProperty.call(message, "gpsGeofenceVerified"))
                            writer.uint32(/* id 45, wireType 0 =*/360).bool(message.gpsGeofenceVerified);
                        if (message.followUpTaskId != null && Object.hasOwnProperty.call(message, "followUpTaskId"))
                            writer.uint32(/* id 46, wireType 0 =*/368).int64(message.followUpTaskId);
                        if (message.priority != null && Object.hasOwnProperty.call(message, "priority"))
                            writer.uint32(/* id 47, wireType 0 =*/376).int32(message.priority);
                        if (message.ticketState != null && Object.hasOwnProperty.call(message, "ticketState"))
                            writer.uint32(/* id 48, wireType 0 =*/384).int32(message.ticketState);
                        if (message.projectType != null && Object.hasOwnProperty.call(message, "projectType"))
                            writer.uint32(/* id 49, wireType 0 =*/392).int32(message.projectType);
                        if (message.ticketStore != null && Object.hasOwnProperty.call(message, "ticketStore"))
                            $root.palexy.task_management.v1.TaskStore.encode(message.ticketStore, writer.uint32(/* id 51, wireType 2 =*/410).fork()).ldelim();
                        if (message.externalId != null && Object.hasOwnProperty.call(message, "externalId"))
                            writer.uint32(/* id 52, wireType 2 =*/418).string(message.externalId);
                        if (message.externalUri != null && Object.hasOwnProperty.call(message, "externalUri"))
                            writer.uint32(/* id 53, wireType 2 =*/426).string(message.externalUri);
                        if (message.ticketSubmissions != null && message.ticketSubmissions.length)
                            for (var i = 0; i < message.ticketSubmissions.length; ++i)
                                $root.palexy.task_management.v1.Task.TicketSubmission.encode(message.ticketSubmissions[i], writer.uint32(/* id 54, wireType 2 =*/434).fork()).ldelim();
                        if (message.autoCloseResolved != null && Object.hasOwnProperty.call(message, "autoCloseResolved"))
                            writer.uint32(/* id 55, wireType 0 =*/440).bool(message.autoCloseResolved);
                        if (message.ticketNextStates != null && message.ticketNextStates.length) {
                            writer.uint32(/* id 56, wireType 2 =*/450).fork();
                            for (var i = 0; i < message.ticketNextStates.length; ++i)
                                writer.int32(message.ticketNextStates[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Task message, length delimited. Does not implicitly {@link palexy.task_management.v1.Task.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {palexy.task_management.v1.ITask} message Task message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Task.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Task message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Task} Task
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Task.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Task();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.projectId = reader.int64();
                                break;
                            case 3:
                                message.groupId = reader.int64();
                                break;
                            case 4:
                                message.parentTaskId = reader.int64();
                                break;
                            case 5:
                                message.title = reader.string();
                                break;
                            case 6:
                                message.description = reader.string();
                                break;
                            case 7:
                                message.creator = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.dateRange = $root.palexy.streaming.v1.DateTimeRange.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.isCompleted = reader.bool();
                                break;
                            case 10:
                                if (!(message.assignees && message.assignees.length))
                                    message.assignees = [];
                                message.assignees.push($root.palexy.task_management.v1.Assignee.decode(reader, reader.uint32()));
                                break;
                            case 11:
                                if (!(message.tags && message.tags.length))
                                    message.tags = [];
                                message.tags.push($root.palexy.task_management.v1.Tag.decode(reader, reader.uint32()));
                                break;
                            case 12:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 13:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 15:
                                message.taskType = reader.int32();
                                break;
                            case 16:
                                message.taskState = reader.int32();
                                break;
                            case 17:
                                message.masterTaskId = reader.int64();
                                break;
                            case 18:
                                message.recurrence = $root.palexy.task_management.v1.Recurrence.decode(reader, reader.uint32());
                                break;
                            case 19:
                                message.completionRequirements = $root.palexy.task_management.v1.CompletionRequirements.decode(reader, reader.uint32());
                                break;
                            case 20:
                                message.assignment = $root.palexy.task_management.v1.Assignment.decode(reader, reader.uint32());
                                break;
                            case 21:
                                if (!(message.attachments && message.attachments.length))
                                    message.attachments = [];
                                message.attachments.push($root.palexy.task_management.v1.TaskAttachment.decode(reader, reader.uint32()));
                                break;
                            case 22:
                                message.archiveMissed = reader.bool();
                                break;
                            case 23:
                                message.dueDateTime = reader.string();
                                break;
                            case 24:
                                message.taskSubType = reader.int32();
                                break;
                            case 25:
                                message.startDateTime = reader.string();
                                break;
                            case 26:
                                message.endDateTime = reader.string();
                                break;
                            case 27:
                                message.formId = reader.int64();
                                break;
                            case 28:
                                message.formSubmissionId = reader.int64();
                                break;
                            case 29:
                                if (!(message.subtasks && message.subtasks.length))
                                    message.subtasks = [];
                                message.subtasks.push($root.palexy.task_management.v1.Task.decode(reader, reader.uint32()));
                                break;
                            case 30:
                                message.projectName = reader.string();
                                break;
                            case 31:
                                message.presenceVerification = $root.palexy.task_management.v1.PresenceVerification.decode(reader, reader.uint32());
                                break;
                            case 32:
                                message.completedDateTime = reader.string();
                                break;
                            case 33:
                                message.presenceVerified = reader.bool();
                                break;
                            case 34:
                                message.completedBy = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 35:
                                message.isAuditTask = reader.bool();
                                break;
                            case 36:
                                message.auditingTaskId = reader.int64();
                                break;
                            case 37:
                                message.presenceLatitude = reader.double();
                                break;
                            case 38:
                                message.presenceLongitude = reader.double();
                                break;
                            case 39:
                                message.presenceGeofenceRadiusM = reader.int32();
                                break;
                            case 40:
                                message.presenceExceptionReason = reader.string();
                                break;
                            case 41:
                                message.callerPermission = reader.int32();
                                break;
                            case 42:
                                message.qrCodeVerified = reader.bool();
                                break;
                            case 43:
                                message.wifiMatchVerified = reader.bool();
                                break;
                            case 44:
                                message.storePhotoVerified = reader.bool();
                                break;
                            case 45:
                                message.gpsGeofenceVerified = reader.bool();
                                break;
                            case 46:
                                message.followUpTaskId = reader.int64();
                                break;
                            case 47:
                                message.priority = reader.int32();
                                break;
                            case 48:
                                message.ticketState = reader.int32();
                                break;
                            case 49:
                                message.projectType = reader.int32();
                                break;
                            case 51:
                                message.ticketStore = $root.palexy.task_management.v1.TaskStore.decode(reader, reader.uint32());
                                break;
                            case 52:
                                message.externalId = reader.string();
                                break;
                            case 53:
                                message.externalUri = reader.string();
                                break;
                            case 54:
                                if (!(message.ticketSubmissions && message.ticketSubmissions.length))
                                    message.ticketSubmissions = [];
                                message.ticketSubmissions.push($root.palexy.task_management.v1.Task.TicketSubmission.decode(reader, reader.uint32()));
                                break;
                            case 55:
                                message.autoCloseResolved = reader.bool();
                                break;
                            case 56:
                                if (!(message.ticketNextStates && message.ticketNextStates.length))
                                    message.ticketNextStates = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.ticketNextStates.push(reader.int32());
                                } else
                                    message.ticketNextStates.push(reader.int32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Task message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Task} Task
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Task.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Task message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Task.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            if (!$util.isInteger(message.groupId) && !(message.groupId && $util.isInteger(message.groupId.low) && $util.isInteger(message.groupId.high)))
                                return "groupId: integer|Long expected";
                        if (message.parentTaskId != null && message.hasOwnProperty("parentTaskId"))
                            if (!$util.isInteger(message.parentTaskId) && !(message.parentTaskId && $util.isInteger(message.parentTaskId.low) && $util.isInteger(message.parentTaskId.high)))
                                return "parentTaskId: integer|Long expected";
                        if (message.title != null && message.hasOwnProperty("title"))
                            if (!$util.isString(message.title))
                                return "title: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.creator != null && message.hasOwnProperty("creator")) {
                            var error = $root.palexy.task_management.v1.User.verify(message.creator);
                            if (error)
                                return "creator." + error;
                        }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateTimeRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.isCompleted != null && message.hasOwnProperty("isCompleted"))
                            if (typeof message.isCompleted !== "boolean")
                                return "isCompleted: boolean expected";
                        if (message.assignees != null && message.hasOwnProperty("assignees")) {
                            if (!Array.isArray(message.assignees))
                                return "assignees: array expected";
                            for (var i = 0; i < message.assignees.length; ++i) {
                                var error = $root.palexy.task_management.v1.Assignee.verify(message.assignees[i]);
                                if (error)
                                    return "assignees." + error;
                            }
                        }
                        if (message.tags != null && message.hasOwnProperty("tags")) {
                            if (!Array.isArray(message.tags))
                                return "tags: array expected";
                            for (var i = 0; i < message.tags.length; ++i) {
                                var error = $root.palexy.task_management.v1.Tag.verify(message.tags[i]);
                                if (error)
                                    return "tags." + error;
                            }
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            switch (message.taskType) {
                            default:
                                return "taskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.taskState != null && message.hasOwnProperty("taskState"))
                            switch (message.taskState) {
                            default:
                                return "taskState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (!$util.isInteger(message.masterTaskId) && !(message.masterTaskId && $util.isInteger(message.masterTaskId.low) && $util.isInteger(message.masterTaskId.high)))
                                return "masterTaskId: integer|Long expected";
                        if (message.recurrence != null && message.hasOwnProperty("recurrence")) {
                            var error = $root.palexy.task_management.v1.Recurrence.verify(message.recurrence);
                            if (error)
                                return "recurrence." + error;
                        }
                        if (message.completionRequirements != null && message.hasOwnProperty("completionRequirements")) {
                            var error = $root.palexy.task_management.v1.CompletionRequirements.verify(message.completionRequirements);
                            if (error)
                                return "completionRequirements." + error;
                        }
                        if (message.assignment != null && message.hasOwnProperty("assignment")) {
                            var error = $root.palexy.task_management.v1.Assignment.verify(message.assignment);
                            if (error)
                                return "assignment." + error;
                        }
                        if (message.attachments != null && message.hasOwnProperty("attachments")) {
                            if (!Array.isArray(message.attachments))
                                return "attachments: array expected";
                            for (var i = 0; i < message.attachments.length; ++i) {
                                var error = $root.palexy.task_management.v1.TaskAttachment.verify(message.attachments[i]);
                                if (error)
                                    return "attachments." + error;
                            }
                        }
                        if (message.archiveMissed != null && message.hasOwnProperty("archiveMissed"))
                            if (typeof message.archiveMissed !== "boolean")
                                return "archiveMissed: boolean expected";
                        if (message.dueDateTime != null && message.hasOwnProperty("dueDateTime"))
                            if (!$util.isString(message.dueDateTime))
                                return "dueDateTime: string expected";
                        if (message.taskSubType != null && message.hasOwnProperty("taskSubType"))
                            switch (message.taskSubType) {
                            default:
                                return "taskSubType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            if (!$util.isString(message.startDateTime))
                                return "startDateTime: string expected";
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            if (!$util.isString(message.endDateTime))
                                return "endDateTime: string expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formSubmissionId != null && message.hasOwnProperty("formSubmissionId"))
                            if (!$util.isInteger(message.formSubmissionId) && !(message.formSubmissionId && $util.isInteger(message.formSubmissionId.low) && $util.isInteger(message.formSubmissionId.high)))
                                return "formSubmissionId: integer|Long expected";
                        if (message.subtasks != null && message.hasOwnProperty("subtasks")) {
                            if (!Array.isArray(message.subtasks))
                                return "subtasks: array expected";
                            for (var i = 0; i < message.subtasks.length; ++i) {
                                var error = $root.palexy.task_management.v1.Task.verify(message.subtasks[i]);
                                if (error)
                                    return "subtasks." + error;
                            }
                        }
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            if (!$util.isString(message.projectName))
                                return "projectName: string expected";
                        if (message.presenceVerification != null && message.hasOwnProperty("presenceVerification")) {
                            var error = $root.palexy.task_management.v1.PresenceVerification.verify(message.presenceVerification);
                            if (error)
                                return "presenceVerification." + error;
                        }
                        if (message.completedDateTime != null && message.hasOwnProperty("completedDateTime"))
                            if (!$util.isString(message.completedDateTime))
                                return "completedDateTime: string expected";
                        if (message.presenceVerified != null && message.hasOwnProperty("presenceVerified"))
                            if (typeof message.presenceVerified !== "boolean")
                                return "presenceVerified: boolean expected";
                        if (message.completedBy != null && message.hasOwnProperty("completedBy")) {
                            var error = $root.palexy.task_management.v1.User.verify(message.completedBy);
                            if (error)
                                return "completedBy." + error;
                        }
                        if (message.isAuditTask != null && message.hasOwnProperty("isAuditTask"))
                            if (typeof message.isAuditTask !== "boolean")
                                return "isAuditTask: boolean expected";
                        if (message.auditingTaskId != null && message.hasOwnProperty("auditingTaskId"))
                            if (!$util.isInteger(message.auditingTaskId) && !(message.auditingTaskId && $util.isInteger(message.auditingTaskId.low) && $util.isInteger(message.auditingTaskId.high)))
                                return "auditingTaskId: integer|Long expected";
                        if (message.presenceLatitude != null && message.hasOwnProperty("presenceLatitude"))
                            if (typeof message.presenceLatitude !== "number")
                                return "presenceLatitude: number expected";
                        if (message.presenceLongitude != null && message.hasOwnProperty("presenceLongitude"))
                            if (typeof message.presenceLongitude !== "number")
                                return "presenceLongitude: number expected";
                        if (message.presenceGeofenceRadiusM != null && message.hasOwnProperty("presenceGeofenceRadiusM"))
                            if (!$util.isInteger(message.presenceGeofenceRadiusM))
                                return "presenceGeofenceRadiusM: integer expected";
                        if (message.presenceExceptionReason != null && message.hasOwnProperty("presenceExceptionReason"))
                            if (!$util.isString(message.presenceExceptionReason))
                                return "presenceExceptionReason: string expected";
                        if (message.callerPermission != null && message.hasOwnProperty("callerPermission"))
                            switch (message.callerPermission) {
                            default:
                                return "callerPermission: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.qrCodeVerified != null && message.hasOwnProperty("qrCodeVerified"))
                            if (typeof message.qrCodeVerified !== "boolean")
                                return "qrCodeVerified: boolean expected";
                        if (message.wifiMatchVerified != null && message.hasOwnProperty("wifiMatchVerified"))
                            if (typeof message.wifiMatchVerified !== "boolean")
                                return "wifiMatchVerified: boolean expected";
                        if (message.storePhotoVerified != null && message.hasOwnProperty("storePhotoVerified"))
                            if (typeof message.storePhotoVerified !== "boolean")
                                return "storePhotoVerified: boolean expected";
                        if (message.gpsGeofenceVerified != null && message.hasOwnProperty("gpsGeofenceVerified"))
                            if (typeof message.gpsGeofenceVerified !== "boolean")
                                return "gpsGeofenceVerified: boolean expected";
                        if (message.followUpTaskId != null && message.hasOwnProperty("followUpTaskId"))
                            if (!$util.isInteger(message.followUpTaskId) && !(message.followUpTaskId && $util.isInteger(message.followUpTaskId.low) && $util.isInteger(message.followUpTaskId.high)))
                                return "followUpTaskId: integer|Long expected";
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            switch (message.priority) {
                            default:
                                return "priority: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.ticketState != null && message.hasOwnProperty("ticketState"))
                            switch (message.ticketState) {
                            default:
                                return "ticketState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.projectType != null && message.hasOwnProperty("projectType"))
                            switch (message.projectType) {
                            default:
                                return "projectType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.ticketStore != null && message.hasOwnProperty("ticketStore")) {
                            var error = $root.palexy.task_management.v1.TaskStore.verify(message.ticketStore);
                            if (error)
                                return "ticketStore." + error;
                        }
                        if (message.externalId != null && message.hasOwnProperty("externalId"))
                            if (!$util.isString(message.externalId))
                                return "externalId: string expected";
                        if (message.externalUri != null && message.hasOwnProperty("externalUri"))
                            if (!$util.isString(message.externalUri))
                                return "externalUri: string expected";
                        if (message.ticketSubmissions != null && message.hasOwnProperty("ticketSubmissions")) {
                            if (!Array.isArray(message.ticketSubmissions))
                                return "ticketSubmissions: array expected";
                            for (var i = 0; i < message.ticketSubmissions.length; ++i) {
                                var error = $root.palexy.task_management.v1.Task.TicketSubmission.verify(message.ticketSubmissions[i]);
                                if (error)
                                    return "ticketSubmissions." + error;
                            }
                        }
                        if (message.autoCloseResolved != null && message.hasOwnProperty("autoCloseResolved")) {
                            properties._autoCloseResolved = 1;
                            if (typeof message.autoCloseResolved !== "boolean")
                                return "autoCloseResolved: boolean expected";
                        }
                        if (message.ticketNextStates != null && message.hasOwnProperty("ticketNextStates")) {
                            if (!Array.isArray(message.ticketNextStates))
                                return "ticketNextStates: array expected";
                            for (var i = 0; i < message.ticketNextStates.length; ++i)
                                switch (message.ticketNextStates[i]) {
                                default:
                                    return "ticketNextStates: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Task message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Task} Task
                     */
                    Task.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Task)
                            return object;
                        var message = new $root.palexy.task_management.v1.Task();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.groupId != null)
                            if ($util.Long)
                                (message.groupId = $util.Long.fromValue(object.groupId)).unsigned = false;
                            else if (typeof object.groupId === "string")
                                message.groupId = parseInt(object.groupId, 10);
                            else if (typeof object.groupId === "number")
                                message.groupId = object.groupId;
                            else if (typeof object.groupId === "object")
                                message.groupId = new $util.LongBits(object.groupId.low >>> 0, object.groupId.high >>> 0).toNumber();
                        if (object.parentTaskId != null)
                            if ($util.Long)
                                (message.parentTaskId = $util.Long.fromValue(object.parentTaskId)).unsigned = false;
                            else if (typeof object.parentTaskId === "string")
                                message.parentTaskId = parseInt(object.parentTaskId, 10);
                            else if (typeof object.parentTaskId === "number")
                                message.parentTaskId = object.parentTaskId;
                            else if (typeof object.parentTaskId === "object")
                                message.parentTaskId = new $util.LongBits(object.parentTaskId.low >>> 0, object.parentTaskId.high >>> 0).toNumber();
                        if (object.title != null)
                            message.title = String(object.title);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.creator != null) {
                            if (typeof object.creator !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.creator: object expected");
                            message.creator = $root.palexy.task_management.v1.User.fromObject(object.creator);
                        }
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateTimeRange.fromObject(object.dateRange);
                        }
                        if (object.isCompleted != null)
                            message.isCompleted = Boolean(object.isCompleted);
                        if (object.assignees) {
                            if (!Array.isArray(object.assignees))
                                throw TypeError(".palexy.task_management.v1.Task.assignees: array expected");
                            message.assignees = [];
                            for (var i = 0; i < object.assignees.length; ++i) {
                                if (typeof object.assignees[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Task.assignees: object expected");
                                message.assignees[i] = $root.palexy.task_management.v1.Assignee.fromObject(object.assignees[i]);
                            }
                        }
                        if (object.tags) {
                            if (!Array.isArray(object.tags))
                                throw TypeError(".palexy.task_management.v1.Task.tags: array expected");
                            message.tags = [];
                            for (var i = 0; i < object.tags.length; ++i) {
                                if (typeof object.tags[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Task.tags: object expected");
                                message.tags[i] = $root.palexy.task_management.v1.Tag.fromObject(object.tags[i]);
                            }
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        switch (object.taskType) {
                        case "TASK_TYPE_UNSPECIFIED":
                        case 0:
                            message.taskType = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.taskType = 1;
                            break;
                        case "MASTER":
                        case 2:
                            message.taskType = 2;
                            break;
                        }
                        switch (object.taskState) {
                        case "TASK_STATE_UNSPECIFIED":
                        case 0:
                            message.taskState = 0;
                            break;
                        case "DRAFT":
                        case 1:
                            message.taskState = 1;
                            break;
                        case "PUBLISHED":
                        case 2:
                            message.taskState = 2;
                            break;
                        case "ARCHIVED":
                        case 3:
                            message.taskState = 3;
                            break;
                        }
                        if (object.masterTaskId != null)
                            if ($util.Long)
                                (message.masterTaskId = $util.Long.fromValue(object.masterTaskId)).unsigned = false;
                            else if (typeof object.masterTaskId === "string")
                                message.masterTaskId = parseInt(object.masterTaskId, 10);
                            else if (typeof object.masterTaskId === "number")
                                message.masterTaskId = object.masterTaskId;
                            else if (typeof object.masterTaskId === "object")
                                message.masterTaskId = new $util.LongBits(object.masterTaskId.low >>> 0, object.masterTaskId.high >>> 0).toNumber();
                        if (object.recurrence != null) {
                            if (typeof object.recurrence !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.recurrence: object expected");
                            message.recurrence = $root.palexy.task_management.v1.Recurrence.fromObject(object.recurrence);
                        }
                        if (object.completionRequirements != null) {
                            if (typeof object.completionRequirements !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.completionRequirements: object expected");
                            message.completionRequirements = $root.palexy.task_management.v1.CompletionRequirements.fromObject(object.completionRequirements);
                        }
                        if (object.assignment != null) {
                            if (typeof object.assignment !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.assignment: object expected");
                            message.assignment = $root.palexy.task_management.v1.Assignment.fromObject(object.assignment);
                        }
                        if (object.attachments) {
                            if (!Array.isArray(object.attachments))
                                throw TypeError(".palexy.task_management.v1.Task.attachments: array expected");
                            message.attachments = [];
                            for (var i = 0; i < object.attachments.length; ++i) {
                                if (typeof object.attachments[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Task.attachments: object expected");
                                message.attachments[i] = $root.palexy.task_management.v1.TaskAttachment.fromObject(object.attachments[i]);
                            }
                        }
                        if (object.archiveMissed != null)
                            message.archiveMissed = Boolean(object.archiveMissed);
                        if (object.dueDateTime != null)
                            message.dueDateTime = String(object.dueDateTime);
                        switch (object.taskSubType) {
                        case "TASK_SUB_TYPE_UNSPECIFIED":
                        case 0:
                            message.taskSubType = 0;
                            break;
                        case "CHECKBOX":
                        case 1:
                            message.taskSubType = 1;
                            break;
                        case "FORM":
                        case 2:
                            message.taskSubType = 2;
                            break;
                        }
                        if (object.startDateTime != null)
                            message.startDateTime = String(object.startDateTime);
                        if (object.endDateTime != null)
                            message.endDateTime = String(object.endDateTime);
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formSubmissionId != null)
                            if ($util.Long)
                                (message.formSubmissionId = $util.Long.fromValue(object.formSubmissionId)).unsigned = false;
                            else if (typeof object.formSubmissionId === "string")
                                message.formSubmissionId = parseInt(object.formSubmissionId, 10);
                            else if (typeof object.formSubmissionId === "number")
                                message.formSubmissionId = object.formSubmissionId;
                            else if (typeof object.formSubmissionId === "object")
                                message.formSubmissionId = new $util.LongBits(object.formSubmissionId.low >>> 0, object.formSubmissionId.high >>> 0).toNumber();
                        if (object.subtasks) {
                            if (!Array.isArray(object.subtasks))
                                throw TypeError(".palexy.task_management.v1.Task.subtasks: array expected");
                            message.subtasks = [];
                            for (var i = 0; i < object.subtasks.length; ++i) {
                                if (typeof object.subtasks[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Task.subtasks: object expected");
                                message.subtasks[i] = $root.palexy.task_management.v1.Task.fromObject(object.subtasks[i]);
                            }
                        }
                        if (object.projectName != null)
                            message.projectName = String(object.projectName);
                        if (object.presenceVerification != null) {
                            if (typeof object.presenceVerification !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.presenceVerification: object expected");
                            message.presenceVerification = $root.palexy.task_management.v1.PresenceVerification.fromObject(object.presenceVerification);
                        }
                        if (object.completedDateTime != null)
                            message.completedDateTime = String(object.completedDateTime);
                        if (object.presenceVerified != null)
                            message.presenceVerified = Boolean(object.presenceVerified);
                        if (object.completedBy != null) {
                            if (typeof object.completedBy !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.completedBy: object expected");
                            message.completedBy = $root.palexy.task_management.v1.User.fromObject(object.completedBy);
                        }
                        if (object.isAuditTask != null)
                            message.isAuditTask = Boolean(object.isAuditTask);
                        if (object.auditingTaskId != null)
                            if ($util.Long)
                                (message.auditingTaskId = $util.Long.fromValue(object.auditingTaskId)).unsigned = false;
                            else if (typeof object.auditingTaskId === "string")
                                message.auditingTaskId = parseInt(object.auditingTaskId, 10);
                            else if (typeof object.auditingTaskId === "number")
                                message.auditingTaskId = object.auditingTaskId;
                            else if (typeof object.auditingTaskId === "object")
                                message.auditingTaskId = new $util.LongBits(object.auditingTaskId.low >>> 0, object.auditingTaskId.high >>> 0).toNumber();
                        if (object.presenceLatitude != null)
                            message.presenceLatitude = Number(object.presenceLatitude);
                        if (object.presenceLongitude != null)
                            message.presenceLongitude = Number(object.presenceLongitude);
                        if (object.presenceGeofenceRadiusM != null)
                            message.presenceGeofenceRadiusM = object.presenceGeofenceRadiusM | 0;
                        if (object.presenceExceptionReason != null)
                            message.presenceExceptionReason = String(object.presenceExceptionReason);
                        switch (object.callerPermission) {
                        case "TASK_PERMISSION_UNSPECIFIED":
                        case 0:
                            message.callerPermission = 0;
                            break;
                        case "READ":
                        case 1:
                            message.callerPermission = 1;
                            break;
                        case "EXECUTE":
                        case 2:
                            message.callerPermission = 2;
                            break;
                        case "WRITE":
                        case 3:
                            message.callerPermission = 3;
                            break;
                        }
                        if (object.qrCodeVerified != null)
                            message.qrCodeVerified = Boolean(object.qrCodeVerified);
                        if (object.wifiMatchVerified != null)
                            message.wifiMatchVerified = Boolean(object.wifiMatchVerified);
                        if (object.storePhotoVerified != null)
                            message.storePhotoVerified = Boolean(object.storePhotoVerified);
                        if (object.gpsGeofenceVerified != null)
                            message.gpsGeofenceVerified = Boolean(object.gpsGeofenceVerified);
                        if (object.followUpTaskId != null)
                            if ($util.Long)
                                (message.followUpTaskId = $util.Long.fromValue(object.followUpTaskId)).unsigned = false;
                            else if (typeof object.followUpTaskId === "string")
                                message.followUpTaskId = parseInt(object.followUpTaskId, 10);
                            else if (typeof object.followUpTaskId === "number")
                                message.followUpTaskId = object.followUpTaskId;
                            else if (typeof object.followUpTaskId === "object")
                                message.followUpTaskId = new $util.LongBits(object.followUpTaskId.low >>> 0, object.followUpTaskId.high >>> 0).toNumber();
                        switch (object.priority) {
                        case "PRIORITY_UNSPECIFIED":
                        case 0:
                            message.priority = 0;
                            break;
                        case "PRIORITY_LOW":
                        case 1:
                            message.priority = 1;
                            break;
                        case "PRIORITY_MEDIUM":
                        case 2:
                            message.priority = 2;
                            break;
                        case "PRIORITY_HIGH":
                        case 3:
                            message.priority = 3;
                            break;
                        }
                        switch (object.ticketState) {
                        case "TICKET_STATE_UNSPECIFIED":
                        case 0:
                            message.ticketState = 0;
                            break;
                        case "TICKET_STATE_OPEN":
                        case 1:
                            message.ticketState = 1;
                            break;
                        case "TICKET_STATE_IN_PROGRESS":
                        case 2:
                            message.ticketState = 2;
                            break;
                        case "TICKET_STATE_RESOLVED":
                        case 3:
                            message.ticketState = 3;
                            break;
                        case "TICKET_STATE_CLOSED":
                        case 4:
                            message.ticketState = 4;
                            break;
                        }
                        switch (object.projectType) {
                        case "PROJECT_TYPE_UNSPECIFIED":
                        case 0:
                            message.projectType = 0;
                            break;
                        case "SIMPLE":
                        case 1:
                            message.projectType = 1;
                            break;
                        case "COMPLEX_DEPLOYMENT":
                        case 2:
                            message.projectType = 2;
                            break;
                        case "RECURRING_CHECKLIST":
                        case 3:
                            message.projectType = 3;
                            break;
                        case "TICKET":
                        case 4:
                            message.projectType = 4;
                            break;
                        }
                        if (object.ticketStore != null) {
                            if (typeof object.ticketStore !== "object")
                                throw TypeError(".palexy.task_management.v1.Task.ticketStore: object expected");
                            message.ticketStore = $root.palexy.task_management.v1.TaskStore.fromObject(object.ticketStore);
                        }
                        if (object.externalId != null)
                            message.externalId = String(object.externalId);
                        if (object.externalUri != null)
                            message.externalUri = String(object.externalUri);
                        if (object.ticketSubmissions) {
                            if (!Array.isArray(object.ticketSubmissions))
                                throw TypeError(".palexy.task_management.v1.Task.ticketSubmissions: array expected");
                            message.ticketSubmissions = [];
                            for (var i = 0; i < object.ticketSubmissions.length; ++i) {
                                if (typeof object.ticketSubmissions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Task.ticketSubmissions: object expected");
                                message.ticketSubmissions[i] = $root.palexy.task_management.v1.Task.TicketSubmission.fromObject(object.ticketSubmissions[i]);
                            }
                        }
                        if (object.autoCloseResolved != null)
                            message.autoCloseResolved = Boolean(object.autoCloseResolved);
                        if (object.ticketNextStates) {
                            if (!Array.isArray(object.ticketNextStates))
                                throw TypeError(".palexy.task_management.v1.Task.ticketNextStates: array expected");
                            message.ticketNextStates = [];
                            for (var i = 0; i < object.ticketNextStates.length; ++i)
                                switch (object.ticketNextStates[i]) {
                                default:
                                case "TICKET_STATE_UNSPECIFIED":
                                case 0:
                                    message.ticketNextStates[i] = 0;
                                    break;
                                case "TICKET_STATE_OPEN":
                                case 1:
                                    message.ticketNextStates[i] = 1;
                                    break;
                                case "TICKET_STATE_IN_PROGRESS":
                                case 2:
                                    message.ticketNextStates[i] = 2;
                                    break;
                                case "TICKET_STATE_RESOLVED":
                                case 3:
                                    message.ticketNextStates[i] = 3;
                                    break;
                                case "TICKET_STATE_CLOSED":
                                case 4:
                                    message.ticketNextStates[i] = 4;
                                    break;
                                }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Task message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Task
                     * @static
                     * @param {palexy.task_management.v1.Task} message Task
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Task.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.assignees = [];
                            object.tags = [];
                            object.attachments = [];
                            object.subtasks = [];
                            object.ticketSubmissions = [];
                            object.ticketNextStates = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.groupId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.groupId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.parentTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.parentTaskId = options.longs === String ? "0" : 0;
                            object.title = "";
                            object.description = "";
                            object.creator = null;
                            object.dateRange = null;
                            object.isCompleted = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.taskType = options.enums === String ? "TASK_TYPE_UNSPECIFIED" : 0;
                            object.taskState = options.enums === String ? "TASK_STATE_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.masterTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.masterTaskId = options.longs === String ? "0" : 0;
                            object.recurrence = null;
                            object.completionRequirements = null;
                            object.assignment = null;
                            object.archiveMissed = false;
                            object.dueDateTime = "";
                            object.taskSubType = options.enums === String ? "TASK_SUB_TYPE_UNSPECIFIED" : 0;
                            object.startDateTime = "";
                            object.endDateTime = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formSubmissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formSubmissionId = options.longs === String ? "0" : 0;
                            object.projectName = "";
                            object.presenceVerification = null;
                            object.completedDateTime = "";
                            object.presenceVerified = false;
                            object.completedBy = null;
                            object.isAuditTask = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.auditingTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.auditingTaskId = options.longs === String ? "0" : 0;
                            object.presenceLatitude = 0;
                            object.presenceLongitude = 0;
                            object.presenceGeofenceRadiusM = 0;
                            object.presenceExceptionReason = "";
                            object.callerPermission = options.enums === String ? "TASK_PERMISSION_UNSPECIFIED" : 0;
                            object.qrCodeVerified = false;
                            object.wifiMatchVerified = false;
                            object.storePhotoVerified = false;
                            object.gpsGeofenceVerified = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.followUpTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.followUpTaskId = options.longs === String ? "0" : 0;
                            object.priority = options.enums === String ? "PRIORITY_UNSPECIFIED" : 0;
                            object.ticketState = options.enums === String ? "TICKET_STATE_UNSPECIFIED" : 0;
                            object.projectType = options.enums === String ? "PROJECT_TYPE_UNSPECIFIED" : 0;
                            object.ticketStore = null;
                            object.externalId = "";
                            object.externalUri = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.groupId != null && message.hasOwnProperty("groupId"))
                            if (typeof message.groupId === "number")
                                object.groupId = options.longs === String ? String(message.groupId) : message.groupId;
                            else
                                object.groupId = options.longs === String ? $util.Long.prototype.toString.call(message.groupId) : options.longs === Number ? new $util.LongBits(message.groupId.low >>> 0, message.groupId.high >>> 0).toNumber() : message.groupId;
                        if (message.parentTaskId != null && message.hasOwnProperty("parentTaskId"))
                            if (typeof message.parentTaskId === "number")
                                object.parentTaskId = options.longs === String ? String(message.parentTaskId) : message.parentTaskId;
                            else
                                object.parentTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.parentTaskId) : options.longs === Number ? new $util.LongBits(message.parentTaskId.low >>> 0, message.parentTaskId.high >>> 0).toNumber() : message.parentTaskId;
                        if (message.title != null && message.hasOwnProperty("title"))
                            object.title = message.title;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            object.creator = $root.palexy.task_management.v1.User.toObject(message.creator, options);
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateTimeRange.toObject(message.dateRange, options);
                        if (message.isCompleted != null && message.hasOwnProperty("isCompleted"))
                            object.isCompleted = message.isCompleted;
                        if (message.assignees && message.assignees.length) {
                            object.assignees = [];
                            for (var j = 0; j < message.assignees.length; ++j)
                                object.assignees[j] = $root.palexy.task_management.v1.Assignee.toObject(message.assignees[j], options);
                        }
                        if (message.tags && message.tags.length) {
                            object.tags = [];
                            for (var j = 0; j < message.tags.length; ++j)
                                object.tags[j] = $root.palexy.task_management.v1.Tag.toObject(message.tags[j], options);
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            object.taskType = options.enums === String ? $root.palexy.task_management.v1.Task.TaskType[message.taskType] : message.taskType;
                        if (message.taskState != null && message.hasOwnProperty("taskState"))
                            object.taskState = options.enums === String ? $root.palexy.task_management.v1.Task.TaskState[message.taskState] : message.taskState;
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (typeof message.masterTaskId === "number")
                                object.masterTaskId = options.longs === String ? String(message.masterTaskId) : message.masterTaskId;
                            else
                                object.masterTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.masterTaskId) : options.longs === Number ? new $util.LongBits(message.masterTaskId.low >>> 0, message.masterTaskId.high >>> 0).toNumber() : message.masterTaskId;
                        if (message.recurrence != null && message.hasOwnProperty("recurrence"))
                            object.recurrence = $root.palexy.task_management.v1.Recurrence.toObject(message.recurrence, options);
                        if (message.completionRequirements != null && message.hasOwnProperty("completionRequirements"))
                            object.completionRequirements = $root.palexy.task_management.v1.CompletionRequirements.toObject(message.completionRequirements, options);
                        if (message.assignment != null && message.hasOwnProperty("assignment"))
                            object.assignment = $root.palexy.task_management.v1.Assignment.toObject(message.assignment, options);
                        if (message.attachments && message.attachments.length) {
                            object.attachments = [];
                            for (var j = 0; j < message.attachments.length; ++j)
                                object.attachments[j] = $root.palexy.task_management.v1.TaskAttachment.toObject(message.attachments[j], options);
                        }
                        if (message.archiveMissed != null && message.hasOwnProperty("archiveMissed"))
                            object.archiveMissed = message.archiveMissed;
                        if (message.dueDateTime != null && message.hasOwnProperty("dueDateTime"))
                            object.dueDateTime = message.dueDateTime;
                        if (message.taskSubType != null && message.hasOwnProperty("taskSubType"))
                            object.taskSubType = options.enums === String ? $root.palexy.task_management.v1.Task.TaskSubType[message.taskSubType] : message.taskSubType;
                        if (message.startDateTime != null && message.hasOwnProperty("startDateTime"))
                            object.startDateTime = message.startDateTime;
                        if (message.endDateTime != null && message.hasOwnProperty("endDateTime"))
                            object.endDateTime = message.endDateTime;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formSubmissionId != null && message.hasOwnProperty("formSubmissionId"))
                            if (typeof message.formSubmissionId === "number")
                                object.formSubmissionId = options.longs === String ? String(message.formSubmissionId) : message.formSubmissionId;
                            else
                                object.formSubmissionId = options.longs === String ? $util.Long.prototype.toString.call(message.formSubmissionId) : options.longs === Number ? new $util.LongBits(message.formSubmissionId.low >>> 0, message.formSubmissionId.high >>> 0).toNumber() : message.formSubmissionId;
                        if (message.subtasks && message.subtasks.length) {
                            object.subtasks = [];
                            for (var j = 0; j < message.subtasks.length; ++j)
                                object.subtasks[j] = $root.palexy.task_management.v1.Task.toObject(message.subtasks[j], options);
                        }
                        if (message.projectName != null && message.hasOwnProperty("projectName"))
                            object.projectName = message.projectName;
                        if (message.presenceVerification != null && message.hasOwnProperty("presenceVerification"))
                            object.presenceVerification = $root.palexy.task_management.v1.PresenceVerification.toObject(message.presenceVerification, options);
                        if (message.completedDateTime != null && message.hasOwnProperty("completedDateTime"))
                            object.completedDateTime = message.completedDateTime;
                        if (message.presenceVerified != null && message.hasOwnProperty("presenceVerified"))
                            object.presenceVerified = message.presenceVerified;
                        if (message.completedBy != null && message.hasOwnProperty("completedBy"))
                            object.completedBy = $root.palexy.task_management.v1.User.toObject(message.completedBy, options);
                        if (message.isAuditTask != null && message.hasOwnProperty("isAuditTask"))
                            object.isAuditTask = message.isAuditTask;
                        if (message.auditingTaskId != null && message.hasOwnProperty("auditingTaskId"))
                            if (typeof message.auditingTaskId === "number")
                                object.auditingTaskId = options.longs === String ? String(message.auditingTaskId) : message.auditingTaskId;
                            else
                                object.auditingTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.auditingTaskId) : options.longs === Number ? new $util.LongBits(message.auditingTaskId.low >>> 0, message.auditingTaskId.high >>> 0).toNumber() : message.auditingTaskId;
                        if (message.presenceLatitude != null && message.hasOwnProperty("presenceLatitude"))
                            object.presenceLatitude = options.json && !isFinite(message.presenceLatitude) ? String(message.presenceLatitude) : message.presenceLatitude;
                        if (message.presenceLongitude != null && message.hasOwnProperty("presenceLongitude"))
                            object.presenceLongitude = options.json && !isFinite(message.presenceLongitude) ? String(message.presenceLongitude) : message.presenceLongitude;
                        if (message.presenceGeofenceRadiusM != null && message.hasOwnProperty("presenceGeofenceRadiusM"))
                            object.presenceGeofenceRadiusM = message.presenceGeofenceRadiusM;
                        if (message.presenceExceptionReason != null && message.hasOwnProperty("presenceExceptionReason"))
                            object.presenceExceptionReason = message.presenceExceptionReason;
                        if (message.callerPermission != null && message.hasOwnProperty("callerPermission"))
                            object.callerPermission = options.enums === String ? $root.palexy.task_management.v1.Task.TaskPermission[message.callerPermission] : message.callerPermission;
                        if (message.qrCodeVerified != null && message.hasOwnProperty("qrCodeVerified"))
                            object.qrCodeVerified = message.qrCodeVerified;
                        if (message.wifiMatchVerified != null && message.hasOwnProperty("wifiMatchVerified"))
                            object.wifiMatchVerified = message.wifiMatchVerified;
                        if (message.storePhotoVerified != null && message.hasOwnProperty("storePhotoVerified"))
                            object.storePhotoVerified = message.storePhotoVerified;
                        if (message.gpsGeofenceVerified != null && message.hasOwnProperty("gpsGeofenceVerified"))
                            object.gpsGeofenceVerified = message.gpsGeofenceVerified;
                        if (message.followUpTaskId != null && message.hasOwnProperty("followUpTaskId"))
                            if (typeof message.followUpTaskId === "number")
                                object.followUpTaskId = options.longs === String ? String(message.followUpTaskId) : message.followUpTaskId;
                            else
                                object.followUpTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.followUpTaskId) : options.longs === Number ? new $util.LongBits(message.followUpTaskId.low >>> 0, message.followUpTaskId.high >>> 0).toNumber() : message.followUpTaskId;
                        if (message.priority != null && message.hasOwnProperty("priority"))
                            object.priority = options.enums === String ? $root.palexy.task_management.v1.Task.Priority[message.priority] : message.priority;
                        if (message.ticketState != null && message.hasOwnProperty("ticketState"))
                            object.ticketState = options.enums === String ? $root.palexy.task_management.v1.Task.TicketState[message.ticketState] : message.ticketState;
                        if (message.projectType != null && message.hasOwnProperty("projectType"))
                            object.projectType = options.enums === String ? $root.palexy.task_management.v1.Project.ProjectType[message.projectType] : message.projectType;
                        if (message.ticketStore != null && message.hasOwnProperty("ticketStore"))
                            object.ticketStore = $root.palexy.task_management.v1.TaskStore.toObject(message.ticketStore, options);
                        if (message.externalId != null && message.hasOwnProperty("externalId"))
                            object.externalId = message.externalId;
                        if (message.externalUri != null && message.hasOwnProperty("externalUri"))
                            object.externalUri = message.externalUri;
                        if (message.ticketSubmissions && message.ticketSubmissions.length) {
                            object.ticketSubmissions = [];
                            for (var j = 0; j < message.ticketSubmissions.length; ++j)
                                object.ticketSubmissions[j] = $root.palexy.task_management.v1.Task.TicketSubmission.toObject(message.ticketSubmissions[j], options);
                        }
                        if (message.autoCloseResolved != null && message.hasOwnProperty("autoCloseResolved")) {
                            object.autoCloseResolved = message.autoCloseResolved;
                            if (options.oneofs)
                                object._autoCloseResolved = "autoCloseResolved";
                        }
                        if (message.ticketNextStates && message.ticketNextStates.length) {
                            object.ticketNextStates = [];
                            for (var j = 0; j < message.ticketNextStates.length; ++j)
                                object.ticketNextStates[j] = options.enums === String ? $root.palexy.task_management.v1.Task.TicketState[message.ticketNextStates[j]] : message.ticketNextStates[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Task to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Task
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Task.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Priority enum.
                     * @name palexy.task_management.v1.Task.Priority
                     * @enum {number}
                     * @property {number} PRIORITY_UNSPECIFIED=0 PRIORITY_UNSPECIFIED value
                     * @property {number} PRIORITY_LOW=1 PRIORITY_LOW value
                     * @property {number} PRIORITY_MEDIUM=2 PRIORITY_MEDIUM value
                     * @property {number} PRIORITY_HIGH=3 PRIORITY_HIGH value
                     */
                    Task.Priority = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "PRIORITY_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "PRIORITY_LOW"] = 1;
                        values[valuesById[2] = "PRIORITY_MEDIUM"] = 2;
                        values[valuesById[3] = "PRIORITY_HIGH"] = 3;
                        return values;
                    })();
    
                    Task.TicketSubmission = (function() {
    
                        /**
                         * Properties of a TicketSubmission.
                         * @memberof palexy.task_management.v1.Task
                         * @interface ITicketSubmission
                         * @property {number|null} [formId] TicketSubmission formId
                         * @property {number|null} [formSubmissionId] TicketSubmission formSubmissionId
                         * @property {string|null} [formName] TicketSubmission formName
                         */
    
                        /**
                         * Constructs a new TicketSubmission.
                         * @memberof palexy.task_management.v1.Task
                         * @classdesc Represents a TicketSubmission.
                         * @implements ITicketSubmission
                         * @constructor
                         * @param {palexy.task_management.v1.Task.ITicketSubmission=} [properties] Properties to set
                         */
                        function TicketSubmission(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * TicketSubmission formId.
                         * @member {number} formId
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @instance
                         */
                        TicketSubmission.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * TicketSubmission formSubmissionId.
                         * @member {number} formSubmissionId
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @instance
                         */
                        TicketSubmission.prototype.formSubmissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * TicketSubmission formName.
                         * @member {string} formName
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @instance
                         */
                        TicketSubmission.prototype.formName = "";
    
                        /**
                         * Creates a new TicketSubmission instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {palexy.task_management.v1.Task.ITicketSubmission=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.Task.TicketSubmission} TicketSubmission instance
                         */
                        TicketSubmission.create = function create(properties) {
                            return new TicketSubmission(properties);
                        };
    
                        /**
                         * Encodes the specified TicketSubmission message. Does not implicitly {@link palexy.task_management.v1.Task.TicketSubmission.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {palexy.task_management.v1.Task.ITicketSubmission} message TicketSubmission message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TicketSubmission.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                            if (message.formSubmissionId != null && Object.hasOwnProperty.call(message, "formSubmissionId"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formSubmissionId);
                            if (message.formName != null && Object.hasOwnProperty.call(message, "formName"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.formName);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified TicketSubmission message, length delimited. Does not implicitly {@link palexy.task_management.v1.Task.TicketSubmission.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {palexy.task_management.v1.Task.ITicketSubmission} message TicketSubmission message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        TicketSubmission.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a TicketSubmission message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.Task.TicketSubmission} TicketSubmission
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TicketSubmission.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Task.TicketSubmission();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.formId = reader.int64();
                                    break;
                                case 2:
                                    message.formSubmissionId = reader.int64();
                                    break;
                                case 3:
                                    message.formName = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a TicketSubmission message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.Task.TicketSubmission} TicketSubmission
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        TicketSubmission.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a TicketSubmission message.
                         * @function verify
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        TicketSubmission.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                    return "formId: integer|Long expected";
                            if (message.formSubmissionId != null && message.hasOwnProperty("formSubmissionId"))
                                if (!$util.isInteger(message.formSubmissionId) && !(message.formSubmissionId && $util.isInteger(message.formSubmissionId.low) && $util.isInteger(message.formSubmissionId.high)))
                                    return "formSubmissionId: integer|Long expected";
                            if (message.formName != null && message.hasOwnProperty("formName"))
                                if (!$util.isString(message.formName))
                                    return "formName: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a TicketSubmission message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.Task.TicketSubmission} TicketSubmission
                         */
                        TicketSubmission.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.Task.TicketSubmission)
                                return object;
                            var message = new $root.palexy.task_management.v1.Task.TicketSubmission();
                            if (object.formId != null)
                                if ($util.Long)
                                    (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                                else if (typeof object.formId === "string")
                                    message.formId = parseInt(object.formId, 10);
                                else if (typeof object.formId === "number")
                                    message.formId = object.formId;
                                else if (typeof object.formId === "object")
                                    message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                            if (object.formSubmissionId != null)
                                if ($util.Long)
                                    (message.formSubmissionId = $util.Long.fromValue(object.formSubmissionId)).unsigned = false;
                                else if (typeof object.formSubmissionId === "string")
                                    message.formSubmissionId = parseInt(object.formSubmissionId, 10);
                                else if (typeof object.formSubmissionId === "number")
                                    message.formSubmissionId = object.formSubmissionId;
                                else if (typeof object.formSubmissionId === "object")
                                    message.formSubmissionId = new $util.LongBits(object.formSubmissionId.low >>> 0, object.formSubmissionId.high >>> 0).toNumber();
                            if (object.formName != null)
                                message.formName = String(object.formName);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a TicketSubmission message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @static
                         * @param {palexy.task_management.v1.Task.TicketSubmission} message TicketSubmission
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        TicketSubmission.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formId = options.longs === String ? "0" : 0;
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formSubmissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formSubmissionId = options.longs === String ? "0" : 0;
                                object.formName = "";
                            }
                            if (message.formId != null && message.hasOwnProperty("formId"))
                                if (typeof message.formId === "number")
                                    object.formId = options.longs === String ? String(message.formId) : message.formId;
                                else
                                    object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                            if (message.formSubmissionId != null && message.hasOwnProperty("formSubmissionId"))
                                if (typeof message.formSubmissionId === "number")
                                    object.formSubmissionId = options.longs === String ? String(message.formSubmissionId) : message.formSubmissionId;
                                else
                                    object.formSubmissionId = options.longs === String ? $util.Long.prototype.toString.call(message.formSubmissionId) : options.longs === Number ? new $util.LongBits(message.formSubmissionId.low >>> 0, message.formSubmissionId.high >>> 0).toNumber() : message.formSubmissionId;
                            if (message.formName != null && message.hasOwnProperty("formName"))
                                object.formName = message.formName;
                            return object;
                        };
    
                        /**
                         * Converts this TicketSubmission to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.Task.TicketSubmission
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        TicketSubmission.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return TicketSubmission;
                    })();
    
                    /**
                     * TicketState enum.
                     * @name palexy.task_management.v1.Task.TicketState
                     * @enum {number}
                     * @property {number} TICKET_STATE_UNSPECIFIED=0 TICKET_STATE_UNSPECIFIED value
                     * @property {number} TICKET_STATE_OPEN=1 TICKET_STATE_OPEN value
                     * @property {number} TICKET_STATE_IN_PROGRESS=2 TICKET_STATE_IN_PROGRESS value
                     * @property {number} TICKET_STATE_RESOLVED=3 TICKET_STATE_RESOLVED value
                     * @property {number} TICKET_STATE_CLOSED=4 TICKET_STATE_CLOSED value
                     */
                    Task.TicketState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TICKET_STATE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "TICKET_STATE_OPEN"] = 1;
                        values[valuesById[2] = "TICKET_STATE_IN_PROGRESS"] = 2;
                        values[valuesById[3] = "TICKET_STATE_RESOLVED"] = 3;
                        values[valuesById[4] = "TICKET_STATE_CLOSED"] = 4;
                        return values;
                    })();
    
                    /**
                     * TaskPermission enum.
                     * @name palexy.task_management.v1.Task.TaskPermission
                     * @enum {number}
                     * @property {number} TASK_PERMISSION_UNSPECIFIED=0 TASK_PERMISSION_UNSPECIFIED value
                     * @property {number} READ=1 READ value
                     * @property {number} EXECUTE=2 EXECUTE value
                     * @property {number} WRITE=3 WRITE value
                     */
                    Task.TaskPermission = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TASK_PERMISSION_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "READ"] = 1;
                        values[valuesById[2] = "EXECUTE"] = 2;
                        values[valuesById[3] = "WRITE"] = 3;
                        return values;
                    })();
    
                    /**
                     * TaskType enum.
                     * @name palexy.task_management.v1.Task.TaskType
                     * @enum {number}
                     * @property {number} TASK_TYPE_UNSPECIFIED=0 TASK_TYPE_UNSPECIFIED value
                     * @property {number} NORMAL=1 NORMAL value
                     * @property {number} MASTER=2 MASTER value
                     */
                    Task.TaskType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TASK_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NORMAL"] = 1;
                        values[valuesById[2] = "MASTER"] = 2;
                        return values;
                    })();
    
                    /**
                     * TaskState enum.
                     * @name palexy.task_management.v1.Task.TaskState
                     * @enum {number}
                     * @property {number} TASK_STATE_UNSPECIFIED=0 TASK_STATE_UNSPECIFIED value
                     * @property {number} DRAFT=1 DRAFT value
                     * @property {number} PUBLISHED=2 PUBLISHED value
                     * @property {number} ARCHIVED=3 ARCHIVED value
                     */
                    Task.TaskState = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TASK_STATE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DRAFT"] = 1;
                        values[valuesById[2] = "PUBLISHED"] = 2;
                        values[valuesById[3] = "ARCHIVED"] = 3;
                        return values;
                    })();
    
                    /**
                     * TaskSubType enum.
                     * @name palexy.task_management.v1.Task.TaskSubType
                     * @enum {number}
                     * @property {number} TASK_SUB_TYPE_UNSPECIFIED=0 TASK_SUB_TYPE_UNSPECIFIED value
                     * @property {number} CHECKBOX=1 CHECKBOX value
                     * @property {number} FORM=2 FORM value
                     */
                    Task.TaskSubType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TASK_SUB_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "CHECKBOX"] = 1;
                        values[valuesById[2] = "FORM"] = 2;
                        return values;
                    })();
    
                    return Task;
                })();
    
                v1.Recurrence = (function() {
    
                    /**
                     * Properties of a Recurrence.
                     * @memberof palexy.task_management.v1
                     * @interface IRecurrence
                     * @property {palexy.task_management.v1.Recurrence.RecurrenceFrequency|null} [frequency] Recurrence frequency
                     * @property {Array.<palexy.streaming.v1.DayOfWeek>|null} [daysOfWeek] Recurrence daysOfWeek
                     * @property {string|null} [createTaskTime] Recurrence createTaskTime
                     * @property {palexy.task_management.v1.Recurrence.TimeMode|null} [createTaskTimeMode] Recurrence createTaskTimeMode
                     * @property {palexy.task_management.v1.Recurrence.TimeMode|null} [dueTimeMode] Recurrence dueTimeMode
                     * @property {string|null} [dueAtTime] Recurrence dueAtTime
                     * @property {palexy.task_management.v1.Recurrence.DueEventType|null} [dueEventType] Recurrence dueEventType
                     * @property {number|null} [dueEventOffsetMinutes] Recurrence dueEventOffsetMinutes
                     */
    
                    /**
                     * Constructs a new Recurrence.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Recurrence.
                     * @implements IRecurrence
                     * @constructor
                     * @param {palexy.task_management.v1.IRecurrence=} [properties] Properties to set
                     */
                    function Recurrence(properties) {
                        this.daysOfWeek = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Recurrence frequency.
                     * @member {palexy.task_management.v1.Recurrence.RecurrenceFrequency} frequency
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.frequency = 0;
    
                    /**
                     * Recurrence daysOfWeek.
                     * @member {Array.<palexy.streaming.v1.DayOfWeek>} daysOfWeek
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.daysOfWeek = $util.emptyArray;
    
                    /**
                     * Recurrence createTaskTime.
                     * @member {string} createTaskTime
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.createTaskTime = "";
    
                    /**
                     * Recurrence createTaskTimeMode.
                     * @member {palexy.task_management.v1.Recurrence.TimeMode} createTaskTimeMode
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.createTaskTimeMode = 0;
    
                    /**
                     * Recurrence dueTimeMode.
                     * @member {palexy.task_management.v1.Recurrence.TimeMode} dueTimeMode
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.dueTimeMode = 0;
    
                    /**
                     * Recurrence dueAtTime.
                     * @member {string} dueAtTime
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.dueAtTime = "";
    
                    /**
                     * Recurrence dueEventType.
                     * @member {palexy.task_management.v1.Recurrence.DueEventType} dueEventType
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.dueEventType = 0;
    
                    /**
                     * Recurrence dueEventOffsetMinutes.
                     * @member {number} dueEventOffsetMinutes
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     */
                    Recurrence.prototype.dueEventOffsetMinutes = 0;
    
                    /**
                     * Creates a new Recurrence instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {palexy.task_management.v1.IRecurrence=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Recurrence} Recurrence instance
                     */
                    Recurrence.create = function create(properties) {
                        return new Recurrence(properties);
                    };
    
                    /**
                     * Encodes the specified Recurrence message. Does not implicitly {@link palexy.task_management.v1.Recurrence.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {palexy.task_management.v1.IRecurrence} message Recurrence message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Recurrence.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.frequency != null && Object.hasOwnProperty.call(message, "frequency"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.frequency);
                        if (message.daysOfWeek != null && message.daysOfWeek.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.daysOfWeek.length; ++i)
                                writer.int32(message.daysOfWeek[i]);
                            writer.ldelim();
                        }
                        if (message.createTaskTime != null && Object.hasOwnProperty.call(message, "createTaskTime"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.createTaskTime);
                        if (message.createTaskTimeMode != null && Object.hasOwnProperty.call(message, "createTaskTimeMode"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.createTaskTimeMode);
                        if (message.dueTimeMode != null && Object.hasOwnProperty.call(message, "dueTimeMode"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.dueTimeMode);
                        if (message.dueAtTime != null && Object.hasOwnProperty.call(message, "dueAtTime"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.dueAtTime);
                        if (message.dueEventType != null && Object.hasOwnProperty.call(message, "dueEventType"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.dueEventType);
                        if (message.dueEventOffsetMinutes != null && Object.hasOwnProperty.call(message, "dueEventOffsetMinutes"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.dueEventOffsetMinutes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Recurrence message, length delimited. Does not implicitly {@link palexy.task_management.v1.Recurrence.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {palexy.task_management.v1.IRecurrence} message Recurrence message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Recurrence.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Recurrence message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Recurrence} Recurrence
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Recurrence.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Recurrence();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.frequency = reader.int32();
                                break;
                            case 4:
                                if (!(message.daysOfWeek && message.daysOfWeek.length))
                                    message.daysOfWeek = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.daysOfWeek.push(reader.int32());
                                } else
                                    message.daysOfWeek.push(reader.int32());
                                break;
                            case 5:
                                message.createTaskTime = reader.string();
                                break;
                            case 6:
                                message.createTaskTimeMode = reader.int32();
                                break;
                            case 7:
                                message.dueTimeMode = reader.int32();
                                break;
                            case 8:
                                message.dueAtTime = reader.string();
                                break;
                            case 9:
                                message.dueEventType = reader.int32();
                                break;
                            case 10:
                                message.dueEventOffsetMinutes = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Recurrence message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Recurrence} Recurrence
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Recurrence.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Recurrence message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Recurrence.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            switch (message.frequency) {
                            default:
                                return "frequency: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.daysOfWeek != null && message.hasOwnProperty("daysOfWeek")) {
                            if (!Array.isArray(message.daysOfWeek))
                                return "daysOfWeek: array expected";
                            for (var i = 0; i < message.daysOfWeek.length; ++i)
                                switch (message.daysOfWeek[i]) {
                                default:
                                    return "daysOfWeek: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                    break;
                                }
                        }
                        if (message.createTaskTime != null && message.hasOwnProperty("createTaskTime"))
                            if (!$util.isString(message.createTaskTime))
                                return "createTaskTime: string expected";
                        if (message.createTaskTimeMode != null && message.hasOwnProperty("createTaskTimeMode"))
                            switch (message.createTaskTimeMode) {
                            default:
                                return "createTaskTimeMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.dueTimeMode != null && message.hasOwnProperty("dueTimeMode"))
                            switch (message.dueTimeMode) {
                            default:
                                return "dueTimeMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.dueAtTime != null && message.hasOwnProperty("dueAtTime"))
                            if (!$util.isString(message.dueAtTime))
                                return "dueAtTime: string expected";
                        if (message.dueEventType != null && message.hasOwnProperty("dueEventType"))
                            switch (message.dueEventType) {
                            default:
                                return "dueEventType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.dueEventOffsetMinutes != null && message.hasOwnProperty("dueEventOffsetMinutes"))
                            if (!$util.isInteger(message.dueEventOffsetMinutes))
                                return "dueEventOffsetMinutes: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a Recurrence message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Recurrence} Recurrence
                     */
                    Recurrence.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Recurrence)
                            return object;
                        var message = new $root.palexy.task_management.v1.Recurrence();
                        switch (object.frequency) {
                        case "RECURRENCE_FREQUENCY_UNSPECIFIED":
                        case 0:
                            message.frequency = 0;
                            break;
                        case "DAILY":
                        case 1:
                            message.frequency = 1;
                            break;
                        case "WEEKLY":
                        case 2:
                            message.frequency = 2;
                            break;
                        case "ONE_TIME":
                        case 3:
                            message.frequency = 3;
                            break;
                        }
                        if (object.daysOfWeek) {
                            if (!Array.isArray(object.daysOfWeek))
                                throw TypeError(".palexy.task_management.v1.Recurrence.daysOfWeek: array expected");
                            message.daysOfWeek = [];
                            for (var i = 0; i < object.daysOfWeek.length; ++i)
                                switch (object.daysOfWeek[i]) {
                                default:
                                case "DAY_OF_WEEK_UNSPECIFIED":
                                case 0:
                                    message.daysOfWeek[i] = 0;
                                    break;
                                case "MONDAY":
                                case 1:
                                    message.daysOfWeek[i] = 1;
                                    break;
                                case "TUESDAY":
                                case 2:
                                    message.daysOfWeek[i] = 2;
                                    break;
                                case "WEDNESDAY":
                                case 3:
                                    message.daysOfWeek[i] = 3;
                                    break;
                                case "THURSDAY":
                                case 4:
                                    message.daysOfWeek[i] = 4;
                                    break;
                                case "FRIDAY":
                                case 5:
                                    message.daysOfWeek[i] = 5;
                                    break;
                                case "SATURDAY":
                                case 6:
                                    message.daysOfWeek[i] = 6;
                                    break;
                                case "SUNDAY":
                                case 7:
                                    message.daysOfWeek[i] = 7;
                                    break;
                                }
                        }
                        if (object.createTaskTime != null)
                            message.createTaskTime = String(object.createTaskTime);
                        switch (object.createTaskTimeMode) {
                        case "TIME_MODE_UNSPECIFIED":
                        case 0:
                            message.createTaskTimeMode = 0;
                            break;
                        case "FIXED":
                        case 1:
                            message.createTaskTimeMode = 1;
                            break;
                        case "EVENT_BASED":
                        case 2:
                            message.createTaskTimeMode = 2;
                            break;
                        }
                        switch (object.dueTimeMode) {
                        case "TIME_MODE_UNSPECIFIED":
                        case 0:
                            message.dueTimeMode = 0;
                            break;
                        case "FIXED":
                        case 1:
                            message.dueTimeMode = 1;
                            break;
                        case "EVENT_BASED":
                        case 2:
                            message.dueTimeMode = 2;
                            break;
                        }
                        if (object.dueAtTime != null)
                            message.dueAtTime = String(object.dueAtTime);
                        switch (object.dueEventType) {
                        case "DUE_EVENT_UNSPECIFIED":
                        case 0:
                            message.dueEventType = 0;
                            break;
                        case "STORE_OPEN":
                        case 1:
                            message.dueEventType = 1;
                            break;
                        case "STORE_CLOSE":
                        case 2:
                            message.dueEventType = 2;
                            break;
                        }
                        if (object.dueEventOffsetMinutes != null)
                            message.dueEventOffsetMinutes = object.dueEventOffsetMinutes | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Recurrence message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Recurrence
                     * @static
                     * @param {palexy.task_management.v1.Recurrence} message Recurrence
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Recurrence.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.daysOfWeek = [];
                        if (options.defaults) {
                            object.frequency = options.enums === String ? "RECURRENCE_FREQUENCY_UNSPECIFIED" : 0;
                            object.createTaskTime = "";
                            object.createTaskTimeMode = options.enums === String ? "TIME_MODE_UNSPECIFIED" : 0;
                            object.dueTimeMode = options.enums === String ? "TIME_MODE_UNSPECIFIED" : 0;
                            object.dueAtTime = "";
                            object.dueEventType = options.enums === String ? "DUE_EVENT_UNSPECIFIED" : 0;
                            object.dueEventOffsetMinutes = 0;
                        }
                        if (message.frequency != null && message.hasOwnProperty("frequency"))
                            object.frequency = options.enums === String ? $root.palexy.task_management.v1.Recurrence.RecurrenceFrequency[message.frequency] : message.frequency;
                        if (message.daysOfWeek && message.daysOfWeek.length) {
                            object.daysOfWeek = [];
                            for (var j = 0; j < message.daysOfWeek.length; ++j)
                                object.daysOfWeek[j] = options.enums === String ? $root.palexy.streaming.v1.DayOfWeek[message.daysOfWeek[j]] : message.daysOfWeek[j];
                        }
                        if (message.createTaskTime != null && message.hasOwnProperty("createTaskTime"))
                            object.createTaskTime = message.createTaskTime;
                        if (message.createTaskTimeMode != null && message.hasOwnProperty("createTaskTimeMode"))
                            object.createTaskTimeMode = options.enums === String ? $root.palexy.task_management.v1.Recurrence.TimeMode[message.createTaskTimeMode] : message.createTaskTimeMode;
                        if (message.dueTimeMode != null && message.hasOwnProperty("dueTimeMode"))
                            object.dueTimeMode = options.enums === String ? $root.palexy.task_management.v1.Recurrence.TimeMode[message.dueTimeMode] : message.dueTimeMode;
                        if (message.dueAtTime != null && message.hasOwnProperty("dueAtTime"))
                            object.dueAtTime = message.dueAtTime;
                        if (message.dueEventType != null && message.hasOwnProperty("dueEventType"))
                            object.dueEventType = options.enums === String ? $root.palexy.task_management.v1.Recurrence.DueEventType[message.dueEventType] : message.dueEventType;
                        if (message.dueEventOffsetMinutes != null && message.hasOwnProperty("dueEventOffsetMinutes"))
                            object.dueEventOffsetMinutes = message.dueEventOffsetMinutes;
                        return object;
                    };
    
                    /**
                     * Converts this Recurrence to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Recurrence
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Recurrence.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * RecurrenceFrequency enum.
                     * @name palexy.task_management.v1.Recurrence.RecurrenceFrequency
                     * @enum {number}
                     * @property {number} RECURRENCE_FREQUENCY_UNSPECIFIED=0 RECURRENCE_FREQUENCY_UNSPECIFIED value
                     * @property {number} DAILY=1 DAILY value
                     * @property {number} WEEKLY=2 WEEKLY value
                     * @property {number} ONE_TIME=3 ONE_TIME value
                     */
                    Recurrence.RecurrenceFrequency = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "RECURRENCE_FREQUENCY_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "DAILY"] = 1;
                        values[valuesById[2] = "WEEKLY"] = 2;
                        values[valuesById[3] = "ONE_TIME"] = 3;
                        return values;
                    })();
    
                    /**
                     * TimeMode enum.
                     * @name palexy.task_management.v1.Recurrence.TimeMode
                     * @enum {number}
                     * @property {number} TIME_MODE_UNSPECIFIED=0 TIME_MODE_UNSPECIFIED value
                     * @property {number} FIXED=1 FIXED value
                     * @property {number} EVENT_BASED=2 EVENT_BASED value
                     */
                    Recurrence.TimeMode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TIME_MODE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FIXED"] = 1;
                        values[valuesById[2] = "EVENT_BASED"] = 2;
                        return values;
                    })();
    
                    /**
                     * DueEventType enum.
                     * @name palexy.task_management.v1.Recurrence.DueEventType
                     * @enum {number}
                     * @property {number} DUE_EVENT_UNSPECIFIED=0 DUE_EVENT_UNSPECIFIED value
                     * @property {number} STORE_OPEN=1 STORE_OPEN value
                     * @property {number} STORE_CLOSE=2 STORE_CLOSE value
                     */
                    Recurrence.DueEventType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DUE_EVENT_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "STORE_OPEN"] = 1;
                        values[valuesById[2] = "STORE_CLOSE"] = 2;
                        return values;
                    })();
    
                    return Recurrence;
                })();
    
                v1.CompletionRequirements = (function() {
    
                    /**
                     * Properties of a CompletionRequirements.
                     * @memberof palexy.task_management.v1
                     * @interface ICompletionRequirements
                     * @property {boolean|null} [mustCompleteAllSubtasks] CompletionRequirements mustCompleteAllSubtasks
                     * @property {boolean|null} [autoCompleteParent] CompletionRequirements autoCompleteParent
                     */
    
                    /**
                     * Constructs a new CompletionRequirements.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompletionRequirements.
                     * @implements ICompletionRequirements
                     * @constructor
                     * @param {palexy.task_management.v1.ICompletionRequirements=} [properties] Properties to set
                     */
                    function CompletionRequirements(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompletionRequirements mustCompleteAllSubtasks.
                     * @member {boolean} mustCompleteAllSubtasks
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @instance
                     */
                    CompletionRequirements.prototype.mustCompleteAllSubtasks = false;
    
                    /**
                     * CompletionRequirements autoCompleteParent.
                     * @member {boolean} autoCompleteParent
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @instance
                     */
                    CompletionRequirements.prototype.autoCompleteParent = false;
    
                    /**
                     * Creates a new CompletionRequirements instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {palexy.task_management.v1.ICompletionRequirements=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CompletionRequirements} CompletionRequirements instance
                     */
                    CompletionRequirements.create = function create(properties) {
                        return new CompletionRequirements(properties);
                    };
    
                    /**
                     * Encodes the specified CompletionRequirements message. Does not implicitly {@link palexy.task_management.v1.CompletionRequirements.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {palexy.task_management.v1.ICompletionRequirements} message CompletionRequirements message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompletionRequirements.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mustCompleteAllSubtasks != null && Object.hasOwnProperty.call(message, "mustCompleteAllSubtasks"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.mustCompleteAllSubtasks);
                        if (message.autoCompleteParent != null && Object.hasOwnProperty.call(message, "autoCompleteParent"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.autoCompleteParent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompletionRequirements message, length delimited. Does not implicitly {@link palexy.task_management.v1.CompletionRequirements.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {palexy.task_management.v1.ICompletionRequirements} message CompletionRequirements message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompletionRequirements.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompletionRequirements message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CompletionRequirements} CompletionRequirements
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompletionRequirements.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CompletionRequirements();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mustCompleteAllSubtasks = reader.bool();
                                break;
                            case 2:
                                message.autoCompleteParent = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompletionRequirements message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CompletionRequirements} CompletionRequirements
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompletionRequirements.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompletionRequirements message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompletionRequirements.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mustCompleteAllSubtasks != null && message.hasOwnProperty("mustCompleteAllSubtasks"))
                            if (typeof message.mustCompleteAllSubtasks !== "boolean")
                                return "mustCompleteAllSubtasks: boolean expected";
                        if (message.autoCompleteParent != null && message.hasOwnProperty("autoCompleteParent"))
                            if (typeof message.autoCompleteParent !== "boolean")
                                return "autoCompleteParent: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompletionRequirements message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CompletionRequirements} CompletionRequirements
                     */
                    CompletionRequirements.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CompletionRequirements)
                            return object;
                        var message = new $root.palexy.task_management.v1.CompletionRequirements();
                        if (object.mustCompleteAllSubtasks != null)
                            message.mustCompleteAllSubtasks = Boolean(object.mustCompleteAllSubtasks);
                        if (object.autoCompleteParent != null)
                            message.autoCompleteParent = Boolean(object.autoCompleteParent);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompletionRequirements message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @static
                     * @param {palexy.task_management.v1.CompletionRequirements} message CompletionRequirements
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompletionRequirements.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.mustCompleteAllSubtasks = false;
                            object.autoCompleteParent = false;
                        }
                        if (message.mustCompleteAllSubtasks != null && message.hasOwnProperty("mustCompleteAllSubtasks"))
                            object.mustCompleteAllSubtasks = message.mustCompleteAllSubtasks;
                        if (message.autoCompleteParent != null && message.hasOwnProperty("autoCompleteParent"))
                            object.autoCompleteParent = message.autoCompleteParent;
                        return object;
                    };
    
                    /**
                     * Converts this CompletionRequirements to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CompletionRequirements
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompletionRequirements.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompletionRequirements;
                })();
    
                v1.PresenceVerification = (function() {
    
                    /**
                     * Properties of a PresenceVerification.
                     * @memberof palexy.task_management.v1
                     * @interface IPresenceVerification
                     * @property {palexy.task_management.v1.PresenceVerification.SignalRequirement|null} [gpsGeofence] PresenceVerification gpsGeofence
                     * @property {boolean|null} [allowProceedWithException] PresenceVerification allowProceedWithException
                     * @property {palexy.task_management.v1.PresenceVerification.SignalRequirement|null} [qrCodeScan] PresenceVerification qrCodeScan
                     * @property {palexy.task_management.v1.PresenceVerification.SignalRequirement|null} [wifiMatch] PresenceVerification wifiMatch
                     * @property {palexy.task_management.v1.PresenceVerification.SignalRequirement|null} [storePhoto] PresenceVerification storePhoto
                     */
    
                    /**
                     * Constructs a new PresenceVerification.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a PresenceVerification.
                     * @implements IPresenceVerification
                     * @constructor
                     * @param {palexy.task_management.v1.IPresenceVerification=} [properties] Properties to set
                     */
                    function PresenceVerification(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PresenceVerification gpsGeofence.
                     * @member {palexy.task_management.v1.PresenceVerification.SignalRequirement} gpsGeofence
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     */
                    PresenceVerification.prototype.gpsGeofence = 0;
    
                    /**
                     * PresenceVerification allowProceedWithException.
                     * @member {boolean} allowProceedWithException
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     */
                    PresenceVerification.prototype.allowProceedWithException = false;
    
                    /**
                     * PresenceVerification qrCodeScan.
                     * @member {palexy.task_management.v1.PresenceVerification.SignalRequirement} qrCodeScan
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     */
                    PresenceVerification.prototype.qrCodeScan = 0;
    
                    /**
                     * PresenceVerification wifiMatch.
                     * @member {palexy.task_management.v1.PresenceVerification.SignalRequirement} wifiMatch
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     */
                    PresenceVerification.prototype.wifiMatch = 0;
    
                    /**
                     * PresenceVerification storePhoto.
                     * @member {palexy.task_management.v1.PresenceVerification.SignalRequirement} storePhoto
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     */
                    PresenceVerification.prototype.storePhoto = 0;
    
                    /**
                     * Creates a new PresenceVerification instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {palexy.task_management.v1.IPresenceVerification=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.PresenceVerification} PresenceVerification instance
                     */
                    PresenceVerification.create = function create(properties) {
                        return new PresenceVerification(properties);
                    };
    
                    /**
                     * Encodes the specified PresenceVerification message. Does not implicitly {@link palexy.task_management.v1.PresenceVerification.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {palexy.task_management.v1.IPresenceVerification} message PresenceVerification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PresenceVerification.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.gpsGeofence != null && Object.hasOwnProperty.call(message, "gpsGeofence"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.gpsGeofence);
                        if (message.allowProceedWithException != null && Object.hasOwnProperty.call(message, "allowProceedWithException"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowProceedWithException);
                        if (message.qrCodeScan != null && Object.hasOwnProperty.call(message, "qrCodeScan"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.qrCodeScan);
                        if (message.wifiMatch != null && Object.hasOwnProperty.call(message, "wifiMatch"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.wifiMatch);
                        if (message.storePhoto != null && Object.hasOwnProperty.call(message, "storePhoto"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.storePhoto);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PresenceVerification message, length delimited. Does not implicitly {@link palexy.task_management.v1.PresenceVerification.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {palexy.task_management.v1.IPresenceVerification} message PresenceVerification message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PresenceVerification.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PresenceVerification message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.PresenceVerification} PresenceVerification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PresenceVerification.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.PresenceVerification();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.gpsGeofence = reader.int32();
                                break;
                            case 2:
                                message.allowProceedWithException = reader.bool();
                                break;
                            case 3:
                                message.qrCodeScan = reader.int32();
                                break;
                            case 4:
                                message.wifiMatch = reader.int32();
                                break;
                            case 5:
                                message.storePhoto = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PresenceVerification message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.PresenceVerification} PresenceVerification
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PresenceVerification.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PresenceVerification message.
                     * @function verify
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PresenceVerification.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.gpsGeofence != null && message.hasOwnProperty("gpsGeofence"))
                            switch (message.gpsGeofence) {
                            default:
                                return "gpsGeofence: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.allowProceedWithException != null && message.hasOwnProperty("allowProceedWithException"))
                            if (typeof message.allowProceedWithException !== "boolean")
                                return "allowProceedWithException: boolean expected";
                        if (message.qrCodeScan != null && message.hasOwnProperty("qrCodeScan"))
                            switch (message.qrCodeScan) {
                            default:
                                return "qrCodeScan: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.wifiMatch != null && message.hasOwnProperty("wifiMatch"))
                            switch (message.wifiMatch) {
                            default:
                                return "wifiMatch: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storePhoto != null && message.hasOwnProperty("storePhoto"))
                            switch (message.storePhoto) {
                            default:
                                return "storePhoto: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a PresenceVerification message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.PresenceVerification} PresenceVerification
                     */
                    PresenceVerification.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.PresenceVerification)
                            return object;
                        var message = new $root.palexy.task_management.v1.PresenceVerification();
                        switch (object.gpsGeofence) {
                        case "SIGNAL_REQUIREMENT_UNSPECIFIED":
                        case 0:
                            message.gpsGeofence = 0;
                            break;
                        case "REQUIRED":
                        case 1:
                            message.gpsGeofence = 1;
                            break;
                        case "OPTIONAL":
                        case 2:
                            message.gpsGeofence = 2;
                            break;
                        case "OFF":
                        case 3:
                            message.gpsGeofence = 3;
                            break;
                        }
                        if (object.allowProceedWithException != null)
                            message.allowProceedWithException = Boolean(object.allowProceedWithException);
                        switch (object.qrCodeScan) {
                        case "SIGNAL_REQUIREMENT_UNSPECIFIED":
                        case 0:
                            message.qrCodeScan = 0;
                            break;
                        case "REQUIRED":
                        case 1:
                            message.qrCodeScan = 1;
                            break;
                        case "OPTIONAL":
                        case 2:
                            message.qrCodeScan = 2;
                            break;
                        case "OFF":
                        case 3:
                            message.qrCodeScan = 3;
                            break;
                        }
                        switch (object.wifiMatch) {
                        case "SIGNAL_REQUIREMENT_UNSPECIFIED":
                        case 0:
                            message.wifiMatch = 0;
                            break;
                        case "REQUIRED":
                        case 1:
                            message.wifiMatch = 1;
                            break;
                        case "OPTIONAL":
                        case 2:
                            message.wifiMatch = 2;
                            break;
                        case "OFF":
                        case 3:
                            message.wifiMatch = 3;
                            break;
                        }
                        switch (object.storePhoto) {
                        case "SIGNAL_REQUIREMENT_UNSPECIFIED":
                        case 0:
                            message.storePhoto = 0;
                            break;
                        case "REQUIRED":
                        case 1:
                            message.storePhoto = 1;
                            break;
                        case "OPTIONAL":
                        case 2:
                            message.storePhoto = 2;
                            break;
                        case "OFF":
                        case 3:
                            message.storePhoto = 3;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PresenceVerification message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @static
                     * @param {palexy.task_management.v1.PresenceVerification} message PresenceVerification
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PresenceVerification.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.gpsGeofence = options.enums === String ? "SIGNAL_REQUIREMENT_UNSPECIFIED" : 0;
                            object.allowProceedWithException = false;
                            object.qrCodeScan = options.enums === String ? "SIGNAL_REQUIREMENT_UNSPECIFIED" : 0;
                            object.wifiMatch = options.enums === String ? "SIGNAL_REQUIREMENT_UNSPECIFIED" : 0;
                            object.storePhoto = options.enums === String ? "SIGNAL_REQUIREMENT_UNSPECIFIED" : 0;
                        }
                        if (message.gpsGeofence != null && message.hasOwnProperty("gpsGeofence"))
                            object.gpsGeofence = options.enums === String ? $root.palexy.task_management.v1.PresenceVerification.SignalRequirement[message.gpsGeofence] : message.gpsGeofence;
                        if (message.allowProceedWithException != null && message.hasOwnProperty("allowProceedWithException"))
                            object.allowProceedWithException = message.allowProceedWithException;
                        if (message.qrCodeScan != null && message.hasOwnProperty("qrCodeScan"))
                            object.qrCodeScan = options.enums === String ? $root.palexy.task_management.v1.PresenceVerification.SignalRequirement[message.qrCodeScan] : message.qrCodeScan;
                        if (message.wifiMatch != null && message.hasOwnProperty("wifiMatch"))
                            object.wifiMatch = options.enums === String ? $root.palexy.task_management.v1.PresenceVerification.SignalRequirement[message.wifiMatch] : message.wifiMatch;
                        if (message.storePhoto != null && message.hasOwnProperty("storePhoto"))
                            object.storePhoto = options.enums === String ? $root.palexy.task_management.v1.PresenceVerification.SignalRequirement[message.storePhoto] : message.storePhoto;
                        return object;
                    };
    
                    /**
                     * Converts this PresenceVerification to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.PresenceVerification
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PresenceVerification.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * SignalRequirement enum.
                     * @name palexy.task_management.v1.PresenceVerification.SignalRequirement
                     * @enum {number}
                     * @property {number} SIGNAL_REQUIREMENT_UNSPECIFIED=0 SIGNAL_REQUIREMENT_UNSPECIFIED value
                     * @property {number} REQUIRED=1 REQUIRED value
                     * @property {number} OPTIONAL=2 OPTIONAL value
                     * @property {number} OFF=3 OFF value
                     */
                    PresenceVerification.SignalRequirement = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SIGNAL_REQUIREMENT_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "REQUIRED"] = 1;
                        values[valuesById[2] = "OPTIONAL"] = 2;
                        values[valuesById[3] = "OFF"] = 3;
                        return values;
                    })();
    
                    return PresenceVerification;
                })();
    
                v1.Assignment = (function() {
    
                    /**
                     * Properties of an Assignment.
                     * @memberof palexy.task_management.v1
                     * @interface IAssignment
                     * @property {palexy.task_management.v1.Assignment.AssignmentMode|null} [mode] Assignment mode
                     * @property {Array.<number>|null} [userIds] Assignment userIds
                     * @property {Array.<palexy.task_management.v1.IUser>|null} [users] Assignment users
                     * @property {Array.<number>|null} [groupIds] Assignment groupIds
                     * @property {Array.<palexy.task_management.v1.IGroup>|null} [groups] Assignment groups
                     * @property {Array.<number>|null} [storeIds] Assignment storeIds
                     * @property {Array.<palexy.task_management.v1.ITaskStore>|null} [stores] Assignment stores
                     */
    
                    /**
                     * Constructs a new Assignment.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an Assignment.
                     * @implements IAssignment
                     * @constructor
                     * @param {palexy.task_management.v1.IAssignment=} [properties] Properties to set
                     */
                    function Assignment(properties) {
                        this.userIds = [];
                        this.users = [];
                        this.groupIds = [];
                        this.groups = [];
                        this.storeIds = [];
                        this.stores = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Assignment mode.
                     * @member {palexy.task_management.v1.Assignment.AssignmentMode} mode
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.mode = 0;
    
                    /**
                     * Assignment userIds.
                     * @member {Array.<number>} userIds
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.userIds = $util.emptyArray;
    
                    /**
                     * Assignment users.
                     * @member {Array.<palexy.task_management.v1.IUser>} users
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.users = $util.emptyArray;
    
                    /**
                     * Assignment groupIds.
                     * @member {Array.<number>} groupIds
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.groupIds = $util.emptyArray;
    
                    /**
                     * Assignment groups.
                     * @member {Array.<palexy.task_management.v1.IGroup>} groups
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.groups = $util.emptyArray;
    
                    /**
                     * Assignment storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * Assignment stores.
                     * @member {Array.<palexy.task_management.v1.ITaskStore>} stores
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     */
                    Assignment.prototype.stores = $util.emptyArray;
    
                    /**
                     * Creates a new Assignment instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {palexy.task_management.v1.IAssignment=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Assignment} Assignment instance
                     */
                    Assignment.create = function create(properties) {
                        return new Assignment(properties);
                    };
    
                    /**
                     * Encodes the specified Assignment message. Does not implicitly {@link palexy.task_management.v1.Assignment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {palexy.task_management.v1.IAssignment} message Assignment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Assignment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.mode != null && Object.hasOwnProperty.call(message, "mode"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.mode);
                        if (message.userIds != null && message.userIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.userIds.length; ++i)
                                writer.int64(message.userIds[i]);
                            writer.ldelim();
                        }
                        if (message.users != null && message.users.length)
                            for (var i = 0; i < message.users.length; ++i)
                                $root.palexy.task_management.v1.User.encode(message.users[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.groupIds != null && message.groupIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.groupIds.length; ++i)
                                writer.int64(message.groupIds[i]);
                            writer.ldelim();
                        }
                        if (message.groups != null && message.groups.length)
                            for (var i = 0; i < message.groups.length; ++i)
                                $root.palexy.task_management.v1.Group.encode(message.groups[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 6, wireType 2 =*/50).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.stores != null && message.stores.length)
                            for (var i = 0; i < message.stores.length; ++i)
                                $root.palexy.task_management.v1.TaskStore.encode(message.stores[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Assignment message, length delimited. Does not implicitly {@link palexy.task_management.v1.Assignment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {palexy.task_management.v1.IAssignment} message Assignment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Assignment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Assignment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Assignment} Assignment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Assignment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Assignment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.mode = reader.int32();
                                break;
                            case 2:
                                if (!(message.userIds && message.userIds.length))
                                    message.userIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.userIds.push(reader.int64());
                                } else
                                    message.userIds.push(reader.int64());
                                break;
                            case 3:
                                if (!(message.users && message.users.length))
                                    message.users = [];
                                message.users.push($root.palexy.task_management.v1.User.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                if (!(message.groupIds && message.groupIds.length))
                                    message.groupIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.groupIds.push(reader.int64());
                                } else
                                    message.groupIds.push(reader.int64());
                                break;
                            case 5:
                                if (!(message.groups && message.groups.length))
                                    message.groups = [];
                                message.groups.push($root.palexy.task_management.v1.Group.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 7:
                                if (!(message.stores && message.stores.length))
                                    message.stores = [];
                                message.stores.push($root.palexy.task_management.v1.TaskStore.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Assignment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Assignment} Assignment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Assignment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Assignment message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Assignment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            switch (message.mode) {
                            default:
                                return "mode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.userIds != null && message.hasOwnProperty("userIds")) {
                            if (!Array.isArray(message.userIds))
                                return "userIds: array expected";
                            for (var i = 0; i < message.userIds.length; ++i)
                                if (!$util.isInteger(message.userIds[i]) && !(message.userIds[i] && $util.isInteger(message.userIds[i].low) && $util.isInteger(message.userIds[i].high)))
                                    return "userIds: integer|Long[] expected";
                        }
                        if (message.users != null && message.hasOwnProperty("users")) {
                            if (!Array.isArray(message.users))
                                return "users: array expected";
                            for (var i = 0; i < message.users.length; ++i) {
                                var error = $root.palexy.task_management.v1.User.verify(message.users[i]);
                                if (error)
                                    return "users." + error;
                            }
                        }
                        if (message.groupIds != null && message.hasOwnProperty("groupIds")) {
                            if (!Array.isArray(message.groupIds))
                                return "groupIds: array expected";
                            for (var i = 0; i < message.groupIds.length; ++i)
                                if (!$util.isInteger(message.groupIds[i]) && !(message.groupIds[i] && $util.isInteger(message.groupIds[i].low) && $util.isInteger(message.groupIds[i].high)))
                                    return "groupIds: integer|Long[] expected";
                        }
                        if (message.groups != null && message.hasOwnProperty("groups")) {
                            if (!Array.isArray(message.groups))
                                return "groups: array expected";
                            for (var i = 0; i < message.groups.length; ++i) {
                                var error = $root.palexy.task_management.v1.Group.verify(message.groups[i]);
                                if (error)
                                    return "groups." + error;
                            }
                        }
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.stores != null && message.hasOwnProperty("stores")) {
                            if (!Array.isArray(message.stores))
                                return "stores: array expected";
                            for (var i = 0; i < message.stores.length; ++i) {
                                var error = $root.palexy.task_management.v1.TaskStore.verify(message.stores[i]);
                                if (error)
                                    return "stores." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an Assignment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Assignment} Assignment
                     */
                    Assignment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Assignment)
                            return object;
                        var message = new $root.palexy.task_management.v1.Assignment();
                        switch (object.mode) {
                        case "ASSIGNMENT_MODE_UNSPECIFIED":
                        case 0:
                            message.mode = 0;
                            break;
                        case "USER":
                        case 1:
                            message.mode = 1;
                            break;
                        case "GROUP":
                        case 2:
                            message.mode = 2;
                            break;
                        case "LOCATION":
                        case 3:
                            message.mode = 3;
                            break;
                        }
                        if (object.userIds) {
                            if (!Array.isArray(object.userIds))
                                throw TypeError(".palexy.task_management.v1.Assignment.userIds: array expected");
                            message.userIds = [];
                            for (var i = 0; i < object.userIds.length; ++i)
                                if ($util.Long)
                                    (message.userIds[i] = $util.Long.fromValue(object.userIds[i])).unsigned = false;
                                else if (typeof object.userIds[i] === "string")
                                    message.userIds[i] = parseInt(object.userIds[i], 10);
                                else if (typeof object.userIds[i] === "number")
                                    message.userIds[i] = object.userIds[i];
                                else if (typeof object.userIds[i] === "object")
                                    message.userIds[i] = new $util.LongBits(object.userIds[i].low >>> 0, object.userIds[i].high >>> 0).toNumber();
                        }
                        if (object.users) {
                            if (!Array.isArray(object.users))
                                throw TypeError(".palexy.task_management.v1.Assignment.users: array expected");
                            message.users = [];
                            for (var i = 0; i < object.users.length; ++i) {
                                if (typeof object.users[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Assignment.users: object expected");
                                message.users[i] = $root.palexy.task_management.v1.User.fromObject(object.users[i]);
                            }
                        }
                        if (object.groupIds) {
                            if (!Array.isArray(object.groupIds))
                                throw TypeError(".palexy.task_management.v1.Assignment.groupIds: array expected");
                            message.groupIds = [];
                            for (var i = 0; i < object.groupIds.length; ++i)
                                if ($util.Long)
                                    (message.groupIds[i] = $util.Long.fromValue(object.groupIds[i])).unsigned = false;
                                else if (typeof object.groupIds[i] === "string")
                                    message.groupIds[i] = parseInt(object.groupIds[i], 10);
                                else if (typeof object.groupIds[i] === "number")
                                    message.groupIds[i] = object.groupIds[i];
                                else if (typeof object.groupIds[i] === "object")
                                    message.groupIds[i] = new $util.LongBits(object.groupIds[i].low >>> 0, object.groupIds[i].high >>> 0).toNumber();
                        }
                        if (object.groups) {
                            if (!Array.isArray(object.groups))
                                throw TypeError(".palexy.task_management.v1.Assignment.groups: array expected");
                            message.groups = [];
                            for (var i = 0; i < object.groups.length; ++i) {
                                if (typeof object.groups[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Assignment.groups: object expected");
                                message.groups[i] = $root.palexy.task_management.v1.Group.fromObject(object.groups[i]);
                            }
                        }
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.task_management.v1.Assignment.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.stores) {
                            if (!Array.isArray(object.stores))
                                throw TypeError(".palexy.task_management.v1.Assignment.stores: array expected");
                            message.stores = [];
                            for (var i = 0; i < object.stores.length; ++i) {
                                if (typeof object.stores[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Assignment.stores: object expected");
                                message.stores[i] = $root.palexy.task_management.v1.TaskStore.fromObject(object.stores[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Assignment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Assignment
                     * @static
                     * @param {palexy.task_management.v1.Assignment} message Assignment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Assignment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.userIds = [];
                            object.users = [];
                            object.groupIds = [];
                            object.groups = [];
                            object.storeIds = [];
                            object.stores = [];
                        }
                        if (options.defaults)
                            object.mode = options.enums === String ? "ASSIGNMENT_MODE_UNSPECIFIED" : 0;
                        if (message.mode != null && message.hasOwnProperty("mode"))
                            object.mode = options.enums === String ? $root.palexy.task_management.v1.Assignment.AssignmentMode[message.mode] : message.mode;
                        if (message.userIds && message.userIds.length) {
                            object.userIds = [];
                            for (var j = 0; j < message.userIds.length; ++j)
                                if (typeof message.userIds[j] === "number")
                                    object.userIds[j] = options.longs === String ? String(message.userIds[j]) : message.userIds[j];
                                else
                                    object.userIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.userIds[j]) : options.longs === Number ? new $util.LongBits(message.userIds[j].low >>> 0, message.userIds[j].high >>> 0).toNumber() : message.userIds[j];
                        }
                        if (message.users && message.users.length) {
                            object.users = [];
                            for (var j = 0; j < message.users.length; ++j)
                                object.users[j] = $root.palexy.task_management.v1.User.toObject(message.users[j], options);
                        }
                        if (message.groupIds && message.groupIds.length) {
                            object.groupIds = [];
                            for (var j = 0; j < message.groupIds.length; ++j)
                                if (typeof message.groupIds[j] === "number")
                                    object.groupIds[j] = options.longs === String ? String(message.groupIds[j]) : message.groupIds[j];
                                else
                                    object.groupIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.groupIds[j]) : options.longs === Number ? new $util.LongBits(message.groupIds[j].low >>> 0, message.groupIds[j].high >>> 0).toNumber() : message.groupIds[j];
                        }
                        if (message.groups && message.groups.length) {
                            object.groups = [];
                            for (var j = 0; j < message.groups.length; ++j)
                                object.groups[j] = $root.palexy.task_management.v1.Group.toObject(message.groups[j], options);
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.stores && message.stores.length) {
                            object.stores = [];
                            for (var j = 0; j < message.stores.length; ++j)
                                object.stores[j] = $root.palexy.task_management.v1.TaskStore.toObject(message.stores[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Assignment to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Assignment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Assignment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * AssignmentMode enum.
                     * @name palexy.task_management.v1.Assignment.AssignmentMode
                     * @enum {number}
                     * @property {number} ASSIGNMENT_MODE_UNSPECIFIED=0 ASSIGNMENT_MODE_UNSPECIFIED value
                     * @property {number} USER=1 USER value
                     * @property {number} GROUP=2 GROUP value
                     * @property {number} LOCATION=3 LOCATION value
                     */
                    Assignment.AssignmentMode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ASSIGNMENT_MODE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "USER"] = 1;
                        values[valuesById[2] = "GROUP"] = 2;
                        values[valuesById[3] = "LOCATION"] = 3;
                        return values;
                    })();
    
                    return Assignment;
                })();
    
                v1.TaskAttachment = (function() {
    
                    /**
                     * Properties of a TaskAttachment.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskAttachment
                     * @property {palexy.streaming.v1.IArtifact|null} [file] TaskAttachment file
                     * @property {palexy.streaming.v1.IArtifact|null} [thumbnail] TaskAttachment thumbnail
                     */
    
                    /**
                     * Constructs a new TaskAttachment.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskAttachment.
                     * @implements ITaskAttachment
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskAttachment=} [properties] Properties to set
                     */
                    function TaskAttachment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskAttachment file.
                     * @member {palexy.streaming.v1.IArtifact|null|undefined} file
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @instance
                     */
                    TaskAttachment.prototype.file = null;
    
                    /**
                     * TaskAttachment thumbnail.
                     * @member {palexy.streaming.v1.IArtifact|null|undefined} thumbnail
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @instance
                     */
                    TaskAttachment.prototype.thumbnail = null;
    
                    /**
                     * Creates a new TaskAttachment instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {palexy.task_management.v1.ITaskAttachment=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskAttachment} TaskAttachment instance
                     */
                    TaskAttachment.create = function create(properties) {
                        return new TaskAttachment(properties);
                    };
    
                    /**
                     * Encodes the specified TaskAttachment message. Does not implicitly {@link palexy.task_management.v1.TaskAttachment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {palexy.task_management.v1.ITaskAttachment} message TaskAttachment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskAttachment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.file != null && Object.hasOwnProperty.call(message, "file"))
                            $root.palexy.streaming.v1.Artifact.encode(message.file, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.thumbnail != null && Object.hasOwnProperty.call(message, "thumbnail"))
                            $root.palexy.streaming.v1.Artifact.encode(message.thumbnail, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskAttachment message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskAttachment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {palexy.task_management.v1.ITaskAttachment} message TaskAttachment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskAttachment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskAttachment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskAttachment} TaskAttachment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskAttachment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskAttachment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.file = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.thumbnail = $root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskAttachment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskAttachment} TaskAttachment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskAttachment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskAttachment message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskAttachment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.file != null && message.hasOwnProperty("file")) {
                            var error = $root.palexy.streaming.v1.Artifact.verify(message.file);
                            if (error)
                                return "file." + error;
                        }
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail")) {
                            var error = $root.palexy.streaming.v1.Artifact.verify(message.thumbnail);
                            if (error)
                                return "thumbnail." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TaskAttachment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskAttachment} TaskAttachment
                     */
                    TaskAttachment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskAttachment)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskAttachment();
                        if (object.file != null) {
                            if (typeof object.file !== "object")
                                throw TypeError(".palexy.task_management.v1.TaskAttachment.file: object expected");
                            message.file = $root.palexy.streaming.v1.Artifact.fromObject(object.file);
                        }
                        if (object.thumbnail != null) {
                            if (typeof object.thumbnail !== "object")
                                throw TypeError(".palexy.task_management.v1.TaskAttachment.thumbnail: object expected");
                            message.thumbnail = $root.palexy.streaming.v1.Artifact.fromObject(object.thumbnail);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskAttachment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @static
                     * @param {palexy.task_management.v1.TaskAttachment} message TaskAttachment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskAttachment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.file = null;
                            object.thumbnail = null;
                        }
                        if (message.file != null && message.hasOwnProperty("file"))
                            object.file = $root.palexy.streaming.v1.Artifact.toObject(message.file, options);
                        if (message.thumbnail != null && message.hasOwnProperty("thumbnail"))
                            object.thumbnail = $root.palexy.streaming.v1.Artifact.toObject(message.thumbnail, options);
                        return object;
                    };
    
                    /**
                     * Converts this TaskAttachment to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskAttachment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskAttachment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskAttachment;
                })();
    
                v1.TaskComment = (function() {
    
                    /**
                     * Properties of a TaskComment.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskComment
                     * @property {number|null} [id] TaskComment id
                     * @property {number|null} [taskId] TaskComment taskId
                     * @property {palexy.task_management.v1.IUser|null} [creator] TaskComment creator
                     * @property {string|null} [content] TaskComment content
                     * @property {number|null} [createdTimeMs] TaskComment createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] TaskComment lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new TaskComment.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskComment.
                     * @implements ITaskComment
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskComment=} [properties] Properties to set
                     */
                    function TaskComment(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskComment id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskComment taskId.
                     * @member {number} taskId
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskComment creator.
                     * @member {palexy.task_management.v1.IUser|null|undefined} creator
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.creator = null;
    
                    /**
                     * TaskComment content.
                     * @member {string} content
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.content = "";
    
                    /**
                     * TaskComment createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskComment lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     */
                    TaskComment.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TaskComment instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {palexy.task_management.v1.ITaskComment=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskComment} TaskComment instance
                     */
                    TaskComment.create = function create(properties) {
                        return new TaskComment(properties);
                    };
    
                    /**
                     * Encodes the specified TaskComment message. Does not implicitly {@link palexy.task_management.v1.TaskComment.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {palexy.task_management.v1.ITaskComment} message TaskComment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskComment.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.taskId);
                        if (message.creator != null && Object.hasOwnProperty.call(message, "creator"))
                            $root.palexy.task_management.v1.User.encode(message.creator, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.content != null && Object.hasOwnProperty.call(message, "content"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.content);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskComment message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskComment.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {palexy.task_management.v1.ITaskComment} message TaskComment message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskComment.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskComment message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskComment} TaskComment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskComment.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskComment();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.taskId = reader.int64();
                                break;
                            case 3:
                                message.creator = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.content = reader.string();
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskComment message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskComment} TaskComment
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskComment.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskComment message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskComment.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        if (message.creator != null && message.hasOwnProperty("creator")) {
                            var error = $root.palexy.task_management.v1.User.verify(message.creator);
                            if (error)
                                return "creator." + error;
                        }
                        if (message.content != null && message.hasOwnProperty("content"))
                            if (!$util.isString(message.content))
                                return "content: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TaskComment message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskComment} TaskComment
                     */
                    TaskComment.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskComment)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskComment();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        if (object.creator != null) {
                            if (typeof object.creator !== "object")
                                throw TypeError(".palexy.task_management.v1.TaskComment.creator: object expected");
                            message.creator = $root.palexy.task_management.v1.User.fromObject(object.creator);
                        }
                        if (object.content != null)
                            message.content = String(object.content);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskComment message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskComment
                     * @static
                     * @param {palexy.task_management.v1.TaskComment} message TaskComment
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskComment.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                            object.creator = null;
                            object.content = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        if (message.creator != null && message.hasOwnProperty("creator"))
                            object.creator = $root.palexy.task_management.v1.User.toObject(message.creator, options);
                        if (message.content != null && message.hasOwnProperty("content"))
                            object.content = message.content;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this TaskComment to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskComment
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskComment.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskComment;
                })();
    
                v1.Assignee = (function() {
    
                    /**
                     * Properties of an Assignee.
                     * @memberof palexy.task_management.v1
                     * @interface IAssignee
                     * @property {palexy.task_management.v1.IUser|null} [user] Assignee user
                     * @property {palexy.task_management.v1.IGroup|null} [group] Assignee group
                     */
    
                    /**
                     * Constructs a new Assignee.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an Assignee.
                     * @implements IAssignee
                     * @constructor
                     * @param {palexy.task_management.v1.IAssignee=} [properties] Properties to set
                     */
                    function Assignee(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Assignee user.
                     * @member {palexy.task_management.v1.IUser|null|undefined} user
                     * @memberof palexy.task_management.v1.Assignee
                     * @instance
                     */
                    Assignee.prototype.user = null;
    
                    /**
                     * Assignee group.
                     * @member {palexy.task_management.v1.IGroup|null|undefined} group
                     * @memberof palexy.task_management.v1.Assignee
                     * @instance
                     */
                    Assignee.prototype.group = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * Assignee assigneeType.
                     * @member {"user"|"group"|undefined} assigneeType
                     * @memberof palexy.task_management.v1.Assignee
                     * @instance
                     */
                    Object.defineProperty(Assignee.prototype, "assigneeType", {
                        get: $util.oneOfGetter($oneOfFields = ["user", "group"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new Assignee instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {palexy.task_management.v1.IAssignee=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Assignee} Assignee instance
                     */
                    Assignee.create = function create(properties) {
                        return new Assignee(properties);
                    };
    
                    /**
                     * Encodes the specified Assignee message. Does not implicitly {@link palexy.task_management.v1.Assignee.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {palexy.task_management.v1.IAssignee} message Assignee message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Assignee.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.user != null && Object.hasOwnProperty.call(message, "user"))
                            $root.palexy.task_management.v1.User.encode(message.user, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                            $root.palexy.task_management.v1.Group.encode(message.group, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Assignee message, length delimited. Does not implicitly {@link palexy.task_management.v1.Assignee.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {palexy.task_management.v1.IAssignee} message Assignee message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Assignee.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Assignee message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Assignee} Assignee
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Assignee.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Assignee();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.user = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.group = $root.palexy.task_management.v1.Group.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Assignee message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Assignee} Assignee
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Assignee.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Assignee message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Assignee.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.user != null && message.hasOwnProperty("user")) {
                            properties.assigneeType = 1;
                            {
                                var error = $root.palexy.task_management.v1.User.verify(message.user);
                                if (error)
                                    return "user." + error;
                            }
                        }
                        if (message.group != null && message.hasOwnProperty("group")) {
                            if (properties.assigneeType === 1)
                                return "assigneeType: multiple values";
                            properties.assigneeType = 1;
                            {
                                var error = $root.palexy.task_management.v1.Group.verify(message.group);
                                if (error)
                                    return "group." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an Assignee message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Assignee} Assignee
                     */
                    Assignee.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Assignee)
                            return object;
                        var message = new $root.palexy.task_management.v1.Assignee();
                        if (object.user != null) {
                            if (typeof object.user !== "object")
                                throw TypeError(".palexy.task_management.v1.Assignee.user: object expected");
                            message.user = $root.palexy.task_management.v1.User.fromObject(object.user);
                        }
                        if (object.group != null) {
                            if (typeof object.group !== "object")
                                throw TypeError(".palexy.task_management.v1.Assignee.group: object expected");
                            message.group = $root.palexy.task_management.v1.Group.fromObject(object.group);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Assignee message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Assignee
                     * @static
                     * @param {palexy.task_management.v1.Assignee} message Assignee
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Assignee.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.user != null && message.hasOwnProperty("user")) {
                            object.user = $root.palexy.task_management.v1.User.toObject(message.user, options);
                            if (options.oneofs)
                                object.assigneeType = "user";
                        }
                        if (message.group != null && message.hasOwnProperty("group")) {
                            object.group = $root.palexy.task_management.v1.Group.toObject(message.group, options);
                            if (options.oneofs)
                                object.assigneeType = "group";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Assignee to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Assignee
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Assignee.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Assignee;
                })();
    
                v1.Tag = (function() {
    
                    /**
                     * Properties of a Tag.
                     * @memberof palexy.task_management.v1
                     * @interface ITag
                     * @property {number|null} [id] Tag id
                     * @property {string|null} [tagName] Tag tagName
                     * @property {string|null} [description] Tag description
                     * @property {palexy.task_management.v1.Tag.AppliedScope|null} [appliedScope] Tag appliedScope
                     * @property {number|null} [companyId] Tag companyId
                     * @property {number|null} [projectId] Tag projectId
                     * @property {number|null} [createdTimeMs] Tag createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Tag lastUpdateTimeMs
                     * @property {string|null} [color] Tag color
                     */
    
                    /**
                     * Constructs a new Tag.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Tag.
                     * @implements ITag
                     * @constructor
                     * @param {palexy.task_management.v1.ITag=} [properties] Properties to set
                     */
                    function Tag(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Tag id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Tag tagName.
                     * @member {string} tagName
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.tagName = "";
    
                    /**
                     * Tag description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.description = "";
    
                    /**
                     * Tag appliedScope.
                     * @member {palexy.task_management.v1.Tag.AppliedScope} appliedScope
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.appliedScope = 0;
    
                    /**
                     * Tag companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Tag projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Tag createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Tag lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Tag color.
                     * @member {string} color
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     */
                    Tag.prototype.color = "";
    
                    /**
                     * Creates a new Tag instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {palexy.task_management.v1.ITag=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Tag} Tag instance
                     */
                    Tag.create = function create(properties) {
                        return new Tag(properties);
                    };
    
                    /**
                     * Encodes the specified Tag message. Does not implicitly {@link palexy.task_management.v1.Tag.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {palexy.task_management.v1.ITag} message Tag message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Tag.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.tagName != null && Object.hasOwnProperty.call(message, "tagName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.tagName);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.appliedScope != null && Object.hasOwnProperty.call(message, "appliedScope"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.appliedScope);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.companyId);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.projectId);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.lastUpdateTimeMs);
                        if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.color);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Tag message, length delimited. Does not implicitly {@link palexy.task_management.v1.Tag.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {palexy.task_management.v1.ITag} message Tag message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Tag.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Tag message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Tag} Tag
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Tag.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Tag();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.tagName = reader.string();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.appliedScope = reader.int32();
                                break;
                            case 5:
                                message.companyId = reader.int64();
                                break;
                            case 6:
                                message.projectId = reader.int64();
                                break;
                            case 7:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 8:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 9:
                                message.color = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Tag message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Tag} Tag
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Tag.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Tag message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Tag.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.tagName != null && message.hasOwnProperty("tagName"))
                            if (!$util.isString(message.tagName))
                                return "tagName: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            switch (message.appliedScope) {
                            default:
                                return "appliedScope: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.color != null && message.hasOwnProperty("color"))
                            if (!$util.isString(message.color))
                                return "color: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a Tag message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Tag} Tag
                     */
                    Tag.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Tag)
                            return object;
                        var message = new $root.palexy.task_management.v1.Tag();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.tagName != null)
                            message.tagName = String(object.tagName);
                        if (object.description != null)
                            message.description = String(object.description);
                        switch (object.appliedScope) {
                        case "UNKNOWN":
                        case 0:
                            message.appliedScope = 0;
                            break;
                        case "PROJECT":
                        case 1:
                            message.appliedScope = 1;
                            break;
                        case "COMPANY":
                        case 2:
                            message.appliedScope = 2;
                            break;
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.color != null)
                            message.color = String(object.color);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Tag message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Tag
                     * @static
                     * @param {palexy.task_management.v1.Tag} message Tag
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Tag.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.tagName = "";
                            object.description = "";
                            object.appliedScope = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.color = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.tagName != null && message.hasOwnProperty("tagName"))
                            object.tagName = message.tagName;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            object.appliedScope = options.enums === String ? $root.palexy.task_management.v1.Tag.AppliedScope[message.appliedScope] : message.appliedScope;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.color != null && message.hasOwnProperty("color"))
                            object.color = message.color;
                        return object;
                    };
    
                    /**
                     * Converts this Tag to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Tag
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Tag.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * AppliedScope enum.
                     * @name palexy.task_management.v1.Tag.AppliedScope
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} PROJECT=1 PROJECT value
                     * @property {number} COMPANY=2 COMPANY value
                     */
                    Tag.AppliedScope = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "PROJECT"] = 1;
                        values[valuesById[2] = "COMPANY"] = 2;
                        return values;
                    })();
    
                    return Tag;
                })();
    
                v1.TaskManagementService = (function() {
    
                    /**
                     * Constructs a new TaskManagementService service.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskManagementService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function TaskManagementService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (TaskManagementService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = TaskManagementService;
    
                    /**
                     * Creates new TaskManagementService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {TaskManagementService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    TaskManagementService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listProjects}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListProjectsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListProjectsResponse} [response] ListProjectsResponse
                     */
    
                    /**
                     * Calls ListProjects.
                     * @function listProjects
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListProjectsRequest} request ListProjectsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListProjectsCallback} callback Node-style callback called with the error, if any, and ListProjectsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listProjects = function listProjects(request, callback) {
                        return this.rpcCall(listProjects, $root.palexy.task_management.v1.ListProjectsRequest, $root.palexy.task_management.v1.ListProjectsResponse, request, callback);
                    }, "name", { value: "ListProjects" });
    
                    /**
                     * Calls ListProjects.
                     * @function listProjects
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListProjectsRequest} request ListProjectsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListProjectsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getProject}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetProjectCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Project} [response] Project
                     */
    
                    /**
                     * Calls GetProject.
                     * @function getProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetProjectRequest} request GetProjectRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetProjectCallback} callback Node-style callback called with the error, if any, and Project
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getProject = function getProject(request, callback) {
                        return this.rpcCall(getProject, $root.palexy.task_management.v1.GetProjectRequest, $root.palexy.task_management.v1.Project, request, callback);
                    }, "name", { value: "GetProject" });
    
                    /**
                     * Calls GetProject.
                     * @function getProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetProjectRequest} request GetProjectRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Project>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createProject}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateProjectCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Project} [response] Project
                     */
    
                    /**
                     * Calls CreateProject.
                     * @function createProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateProjectRequest} request CreateProjectRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateProjectCallback} callback Node-style callback called with the error, if any, and Project
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createProject = function createProject(request, callback) {
                        return this.rpcCall(createProject, $root.palexy.task_management.v1.CreateProjectRequest, $root.palexy.task_management.v1.Project, request, callback);
                    }, "name", { value: "CreateProject" });
    
                    /**
                     * Calls CreateProject.
                     * @function createProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateProjectRequest} request CreateProjectRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Project>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateProject}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateProjectCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Project} [response] Project
                     */
    
                    /**
                     * Calls UpdateProject.
                     * @function updateProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateProjectRequest} request UpdateProjectRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateProjectCallback} callback Node-style callback called with the error, if any, and Project
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateProject = function updateProject(request, callback) {
                        return this.rpcCall(updateProject, $root.palexy.task_management.v1.UpdateProjectRequest, $root.palexy.task_management.v1.Project, request, callback);
                    }, "name", { value: "UpdateProject" });
    
                    /**
                     * Calls UpdateProject.
                     * @function updateProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateProjectRequest} request UpdateProjectRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Project>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteProject}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteProjectCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteProject.
                     * @function deleteProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteProjectRequest} request DeleteProjectRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteProjectCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteProject = function deleteProject(request, callback) {
                        return this.rpcCall(deleteProject, $root.palexy.task_management.v1.DeleteProjectRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteProject" });
    
                    /**
                     * Calls DeleteProject.
                     * @function deleteProject
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteProjectRequest} request DeleteProjectRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listProjectDataViews}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListProjectDataViewsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListProjectDataViewsResponse} [response] ListProjectDataViewsResponse
                     */
    
                    /**
                     * Calls ListProjectDataViews.
                     * @function listProjectDataViews
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest} request ListProjectDataViewsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListProjectDataViewsCallback} callback Node-style callback called with the error, if any, and ListProjectDataViewsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listProjectDataViews = function listProjectDataViews(request, callback) {
                        return this.rpcCall(listProjectDataViews, $root.palexy.task_management.v1.ListProjectDataViewsRequest, $root.palexy.task_management.v1.ListProjectDataViewsResponse, request, callback);
                    }, "name", { value: "ListProjectDataViews" });
    
                    /**
                     * Calls ListProjectDataViews.
                     * @function listProjectDataViews
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest} request ListProjectDataViewsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListProjectDataViewsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getProjectDataView}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetProjectDataViewCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ProjectDataView} [response] ProjectDataView
                     */
    
                    /**
                     * Calls GetProjectDataView.
                     * @function getProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest} request GetProjectDataViewRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetProjectDataViewCallback} callback Node-style callback called with the error, if any, and ProjectDataView
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getProjectDataView = function getProjectDataView(request, callback) {
                        return this.rpcCall(getProjectDataView, $root.palexy.task_management.v1.GetProjectDataViewRequest, $root.palexy.task_management.v1.ProjectDataView, request, callback);
                    }, "name", { value: "GetProjectDataView" });
    
                    /**
                     * Calls GetProjectDataView.
                     * @function getProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest} request GetProjectDataViewRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ProjectDataView>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createProjectDataView}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateProjectDataViewCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ProjectDataView} [response] ProjectDataView
                     */
    
                    /**
                     * Calls CreateProjectDataView.
                     * @function createProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest} request CreateProjectDataViewRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateProjectDataViewCallback} callback Node-style callback called with the error, if any, and ProjectDataView
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createProjectDataView = function createProjectDataView(request, callback) {
                        return this.rpcCall(createProjectDataView, $root.palexy.task_management.v1.CreateProjectDataViewRequest, $root.palexy.task_management.v1.ProjectDataView, request, callback);
                    }, "name", { value: "CreateProjectDataView" });
    
                    /**
                     * Calls CreateProjectDataView.
                     * @function createProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest} request CreateProjectDataViewRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ProjectDataView>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateProjectDataView}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateProjectDataViewCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ProjectDataView} [response] ProjectDataView
                     */
    
                    /**
                     * Calls UpdateProjectDataView.
                     * @function updateProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest} request UpdateProjectDataViewRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateProjectDataViewCallback} callback Node-style callback called with the error, if any, and ProjectDataView
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateProjectDataView = function updateProjectDataView(request, callback) {
                        return this.rpcCall(updateProjectDataView, $root.palexy.task_management.v1.UpdateProjectDataViewRequest, $root.palexy.task_management.v1.ProjectDataView, request, callback);
                    }, "name", { value: "UpdateProjectDataView" });
    
                    /**
                     * Calls UpdateProjectDataView.
                     * @function updateProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest} request UpdateProjectDataViewRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ProjectDataView>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteProjectDataView}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteProjectDataViewCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteProjectDataView.
                     * @function deleteProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest} request DeleteProjectDataViewRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteProjectDataViewCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteProjectDataView = function deleteProjectDataView(request, callback) {
                        return this.rpcCall(deleteProjectDataView, $root.palexy.task_management.v1.DeleteProjectDataViewRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteProjectDataView" });
    
                    /**
                     * Calls DeleteProjectDataView.
                     * @function deleteProjectDataView
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest} request DeleteProjectDataViewRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listTaskGroups}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListTaskGroupsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListTaskGroupsResponse} [response] ListTaskGroupsResponse
                     */
    
                    /**
                     * Calls ListTaskGroups.
                     * @function listTaskGroups
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest} request ListTaskGroupsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListTaskGroupsCallback} callback Node-style callback called with the error, if any, and ListTaskGroupsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listTaskGroups = function listTaskGroups(request, callback) {
                        return this.rpcCall(listTaskGroups, $root.palexy.task_management.v1.ListTaskGroupsRequest, $root.palexy.task_management.v1.ListTaskGroupsResponse, request, callback);
                    }, "name", { value: "ListTaskGroups" });
    
                    /**
                     * Calls ListTaskGroups.
                     * @function listTaskGroups
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest} request ListTaskGroupsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListTaskGroupsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getTaskGroup}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetTaskGroupCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.TaskGroup} [response] TaskGroup
                     */
    
                    /**
                     * Calls GetTaskGroup.
                     * @function getTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest} request GetTaskGroupRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetTaskGroupCallback} callback Node-style callback called with the error, if any, and TaskGroup
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getTaskGroup = function getTaskGroup(request, callback) {
                        return this.rpcCall(getTaskGroup, $root.palexy.task_management.v1.GetTaskGroupRequest, $root.palexy.task_management.v1.TaskGroup, request, callback);
                    }, "name", { value: "GetTaskGroup" });
    
                    /**
                     * Calls GetTaskGroup.
                     * @function getTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest} request GetTaskGroupRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.TaskGroup>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createTaskGroup}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateTaskGroupCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.TaskGroup} [response] TaskGroup
                     */
    
                    /**
                     * Calls CreateTaskGroup.
                     * @function createTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest} request CreateTaskGroupRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateTaskGroupCallback} callback Node-style callback called with the error, if any, and TaskGroup
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createTaskGroup = function createTaskGroup(request, callback) {
                        return this.rpcCall(createTaskGroup, $root.palexy.task_management.v1.CreateTaskGroupRequest, $root.palexy.task_management.v1.TaskGroup, request, callback);
                    }, "name", { value: "CreateTaskGroup" });
    
                    /**
                     * Calls CreateTaskGroup.
                     * @function createTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest} request CreateTaskGroupRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.TaskGroup>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateTaskGroup}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateTaskGroupCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.TaskGroup} [response] TaskGroup
                     */
    
                    /**
                     * Calls UpdateTaskGroup.
                     * @function updateTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest} request UpdateTaskGroupRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateTaskGroupCallback} callback Node-style callback called with the error, if any, and TaskGroup
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateTaskGroup = function updateTaskGroup(request, callback) {
                        return this.rpcCall(updateTaskGroup, $root.palexy.task_management.v1.UpdateTaskGroupRequest, $root.palexy.task_management.v1.TaskGroup, request, callback);
                    }, "name", { value: "UpdateTaskGroup" });
    
                    /**
                     * Calls UpdateTaskGroup.
                     * @function updateTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest} request UpdateTaskGroupRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.TaskGroup>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteTaskGroup}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteTaskGroupCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteTaskGroup.
                     * @function deleteTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest} request DeleteTaskGroupRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteTaskGroupCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteTaskGroup = function deleteTaskGroup(request, callback) {
                        return this.rpcCall(deleteTaskGroup, $root.palexy.task_management.v1.DeleteTaskGroupRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteTaskGroup" });
    
                    /**
                     * Calls DeleteTaskGroup.
                     * @function deleteTaskGroup
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest} request DeleteTaskGroupRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listTasks}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListTasksResponse} [response] ListTasksResponse
                     */
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTasksRequest} request ListTasksRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListTasksCallback} callback Node-style callback called with the error, if any, and ListTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listTasks = function listTasks(request, callback) {
                        return this.rpcCall(listTasks, $root.palexy.task_management.v1.ListTasksRequest, $root.palexy.task_management.v1.ListTasksResponse, request, callback);
                    }, "name", { value: "ListTasks" });
    
                    /**
                     * Calls ListTasks.
                     * @function listTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTasksRequest} request ListTasksRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getTask}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Task} [response] Task
                     */
    
                    /**
                     * Calls GetTask.
                     * @function getTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskRequest} request GetTaskRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetTaskCallback} callback Node-style callback called with the error, if any, and Task
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getTask = function getTask(request, callback) {
                        return this.rpcCall(getTask, $root.palexy.task_management.v1.GetTaskRequest, $root.palexy.task_management.v1.Task, request, callback);
                    }, "name", { value: "GetTask" });
    
                    /**
                     * Calls GetTask.
                     * @function getTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskRequest} request GetTaskRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Task>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createTask}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Task} [response] Task
                     */
    
                    /**
                     * Calls CreateTask.
                     * @function createTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskRequest} request CreateTaskRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateTaskCallback} callback Node-style callback called with the error, if any, and Task
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createTask = function createTask(request, callback) {
                        return this.rpcCall(createTask, $root.palexy.task_management.v1.CreateTaskRequest, $root.palexy.task_management.v1.Task, request, callback);
                    }, "name", { value: "CreateTask" });
    
                    /**
                     * Calls CreateTask.
                     * @function createTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskRequest} request CreateTaskRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Task>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateTask}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Task} [response] Task
                     */
    
                    /**
                     * Calls UpdateTask.
                     * @function updateTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskRequest} request UpdateTaskRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateTaskCallback} callback Node-style callback called with the error, if any, and Task
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateTask = function updateTask(request, callback) {
                        return this.rpcCall(updateTask, $root.palexy.task_management.v1.UpdateTaskRequest, $root.palexy.task_management.v1.Task, request, callback);
                    }, "name", { value: "UpdateTask" });
    
                    /**
                     * Calls UpdateTask.
                     * @function updateTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskRequest} request UpdateTaskRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Task>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteTask}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteTask.
                     * @function deleteTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskRequest} request DeleteTaskRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteTaskCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteTask = function deleteTask(request, callback) {
                        return this.rpcCall(deleteTask, $root.palexy.task_management.v1.DeleteTaskRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteTask" });
    
                    /**
                     * Calls DeleteTask.
                     * @function deleteTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskRequest} request DeleteTaskRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#publishTask}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef PublishTaskCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Task} [response] Task
                     */
    
                    /**
                     * Calls PublishTask.
                     * @function publishTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IPublishTaskRequest} request PublishTaskRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.PublishTaskCallback} callback Node-style callback called with the error, if any, and Task
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.publishTask = function publishTask(request, callback) {
                        return this.rpcCall(publishTask, $root.palexy.task_management.v1.PublishTaskRequest, $root.palexy.task_management.v1.Task, request, callback);
                    }, "name", { value: "PublishTask" });
    
                    /**
                     * Calls PublishTask.
                     * @function publishTask
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IPublishTaskRequest} request PublishTaskRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Task>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#generateTasks}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GenerateTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.GenerateTasksResponse} [response] GenerateTasksResponse
                     */
    
                    /**
                     * Calls GenerateTasks.
                     * @function generateTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGenerateTasksRequest} request GenerateTasksRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GenerateTasksCallback} callback Node-style callback called with the error, if any, and GenerateTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.generateTasks = function generateTasks(request, callback) {
                        return this.rpcCall(generateTasks, $root.palexy.task_management.v1.GenerateTasksRequest, $root.palexy.task_management.v1.GenerateTasksResponse, request, callback);
                    }, "name", { value: "GenerateTasks" });
    
                    /**
                     * Calls GenerateTasks.
                     * @function generateTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGenerateTasksRequest} request GenerateTasksRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.GenerateTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listDueMasterTasks}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListDueMasterTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListDueMasterTasksResponse} [response] ListDueMasterTasksResponse
                     */
    
                    /**
                     * Calls ListDueMasterTasks.
                     * @function listDueMasterTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest} request ListDueMasterTasksRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListDueMasterTasksCallback} callback Node-style callback called with the error, if any, and ListDueMasterTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listDueMasterTasks = function listDueMasterTasks(request, callback) {
                        return this.rpcCall(listDueMasterTasks, $root.palexy.task_management.v1.ListDueMasterTasksRequest, $root.palexy.task_management.v1.ListDueMasterTasksResponse, request, callback);
                    }, "name", { value: "ListDueMasterTasks" });
    
                    /**
                     * Calls ListDueMasterTasks.
                     * @function listDueMasterTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest} request ListDueMasterTasksRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListDueMasterTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#archiveMissedTasks}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ArchiveMissedTasksCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ArchiveMissedTasksResponse} [response] ArchiveMissedTasksResponse
                     */
    
                    /**
                     * Calls ArchiveMissedTasks.
                     * @function archiveMissedTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest} request ArchiveMissedTasksRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ArchiveMissedTasksCallback} callback Node-style callback called with the error, if any, and ArchiveMissedTasksResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.archiveMissedTasks = function archiveMissedTasks(request, callback) {
                        return this.rpcCall(archiveMissedTasks, $root.palexy.task_management.v1.ArchiveMissedTasksRequest, $root.palexy.task_management.v1.ArchiveMissedTasksResponse, request, callback);
                    }, "name", { value: "ArchiveMissedTasks" });
    
                    /**
                     * Calls ArchiveMissedTasks.
                     * @function archiveMissedTasks
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest} request ArchiveMissedTasksRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ArchiveMissedTasksResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#closeResolvedTickets}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CloseResolvedTicketsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CloseResolvedTicketsResponse} [response] CloseResolvedTicketsResponse
                     */
    
                    /**
                     * Calls CloseResolvedTickets.
                     * @function closeResolvedTickets
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest} request CloseResolvedTicketsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CloseResolvedTicketsCallback} callback Node-style callback called with the error, if any, and CloseResolvedTicketsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.closeResolvedTickets = function closeResolvedTickets(request, callback) {
                        return this.rpcCall(closeResolvedTickets, $root.palexy.task_management.v1.CloseResolvedTicketsRequest, $root.palexy.task_management.v1.CloseResolvedTicketsResponse, request, callback);
                    }, "name", { value: "CloseResolvedTickets" });
    
                    /**
                     * Calls CloseResolvedTickets.
                     * @function closeResolvedTickets
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest} request CloseResolvedTicketsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CloseResolvedTicketsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getTaskStatistics}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetTaskStatisticsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.GetTaskStatisticsResponse} [response] GetTaskStatisticsResponse
                     */
    
                    /**
                     * Calls GetTaskStatistics.
                     * @function getTaskStatistics
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest} request GetTaskStatisticsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetTaskStatisticsCallback} callback Node-style callback called with the error, if any, and GetTaskStatisticsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getTaskStatistics = function getTaskStatistics(request, callback) {
                        return this.rpcCall(getTaskStatistics, $root.palexy.task_management.v1.GetTaskStatisticsRequest, $root.palexy.task_management.v1.GetTaskStatisticsResponse, request, callback);
                    }, "name", { value: "GetTaskStatistics" });
    
                    /**
                     * Calls GetTaskStatistics.
                     * @function getTaskStatistics
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest} request GetTaskStatisticsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.GetTaskStatisticsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listTags}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListTagsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListTagsResponse} [response] ListTagsResponse
                     */
    
                    /**
                     * Calls ListTags.
                     * @function listTags
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTagsRequest} request ListTagsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListTagsCallback} callback Node-style callback called with the error, if any, and ListTagsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listTags = function listTags(request, callback) {
                        return this.rpcCall(listTags, $root.palexy.task_management.v1.ListTagsRequest, $root.palexy.task_management.v1.ListTagsResponse, request, callback);
                    }, "name", { value: "ListTags" });
    
                    /**
                     * Calls ListTags.
                     * @function listTags
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTagsRequest} request ListTagsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListTagsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#getTag}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef GetTagCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Tag} [response] Tag
                     */
    
                    /**
                     * Calls GetTag.
                     * @function getTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTagRequest} request GetTagRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.GetTagCallback} callback Node-style callback called with the error, if any, and Tag
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.getTag = function getTag(request, callback) {
                        return this.rpcCall(getTag, $root.palexy.task_management.v1.GetTagRequest, $root.palexy.task_management.v1.Tag, request, callback);
                    }, "name", { value: "GetTag" });
    
                    /**
                     * Calls GetTag.
                     * @function getTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IGetTagRequest} request GetTagRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Tag>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createTag}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateTagCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Tag} [response] Tag
                     */
    
                    /**
                     * Calls CreateTag.
                     * @function createTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTagRequest} request CreateTagRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateTagCallback} callback Node-style callback called with the error, if any, and Tag
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createTag = function createTag(request, callback) {
                        return this.rpcCall(createTag, $root.palexy.task_management.v1.CreateTagRequest, $root.palexy.task_management.v1.Tag, request, callback);
                    }, "name", { value: "CreateTag" });
    
                    /**
                     * Calls CreateTag.
                     * @function createTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTagRequest} request CreateTagRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Tag>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateTag}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateTagCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Tag} [response] Tag
                     */
    
                    /**
                     * Calls UpdateTag.
                     * @function updateTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTagRequest} request UpdateTagRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateTagCallback} callback Node-style callback called with the error, if any, and Tag
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateTag = function updateTag(request, callback) {
                        return this.rpcCall(updateTag, $root.palexy.task_management.v1.UpdateTagRequest, $root.palexy.task_management.v1.Tag, request, callback);
                    }, "name", { value: "UpdateTag" });
    
                    /**
                     * Calls UpdateTag.
                     * @function updateTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTagRequest} request UpdateTagRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Tag>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteTag}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteTagCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteTag.
                     * @function deleteTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTagRequest} request DeleteTagRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteTagCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteTag = function deleteTag(request, callback) {
                        return this.rpcCall(deleteTag, $root.palexy.task_management.v1.DeleteTagRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteTag" });
    
                    /**
                     * Calls DeleteTag.
                     * @function deleteTag
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTagRequest} request DeleteTagRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#listTaskComments}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef ListTaskCommentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListTaskCommentsResponse} [response] ListTaskCommentsResponse
                     */
    
                    /**
                     * Calls ListTaskComments.
                     * @function listTaskComments
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest} request ListTaskCommentsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.ListTaskCommentsCallback} callback Node-style callback called with the error, if any, and ListTaskCommentsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.listTaskComments = function listTaskComments(request, callback) {
                        return this.rpcCall(listTaskComments, $root.palexy.task_management.v1.ListTaskCommentsRequest, $root.palexy.task_management.v1.ListTaskCommentsResponse, request, callback);
                    }, "name", { value: "ListTaskComments" });
    
                    /**
                     * Calls ListTaskComments.
                     * @function listTaskComments
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest} request ListTaskCommentsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListTaskCommentsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#batchGetLatestTaskComments}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef BatchGetLatestTaskCommentsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} [response] BatchGetLatestTaskCommentsResponse
                     */
    
                    /**
                     * Calls BatchGetLatestTaskComments.
                     * @function batchGetLatestTaskComments
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest} request BatchGetLatestTaskCommentsRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.BatchGetLatestTaskCommentsCallback} callback Node-style callback called with the error, if any, and BatchGetLatestTaskCommentsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.batchGetLatestTaskComments = function batchGetLatestTaskComments(request, callback) {
                        return this.rpcCall(batchGetLatestTaskComments, $root.palexy.task_management.v1.BatchGetLatestTaskCommentsRequest, $root.palexy.task_management.v1.BatchGetLatestTaskCommentsResponse, request, callback);
                    }, "name", { value: "BatchGetLatestTaskComments" });
    
                    /**
                     * Calls BatchGetLatestTaskComments.
                     * @function batchGetLatestTaskComments
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest} request BatchGetLatestTaskCommentsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.BatchGetLatestTaskCommentsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#createTaskComment}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef CreateTaskCommentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.TaskComment} [response] TaskComment
                     */
    
                    /**
                     * Calls CreateTaskComment.
                     * @function createTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest} request CreateTaskCommentRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.CreateTaskCommentCallback} callback Node-style callback called with the error, if any, and TaskComment
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.createTaskComment = function createTaskComment(request, callback) {
                        return this.rpcCall(createTaskComment, $root.palexy.task_management.v1.CreateTaskCommentRequest, $root.palexy.task_management.v1.TaskComment, request, callback);
                    }, "name", { value: "CreateTaskComment" });
    
                    /**
                     * Calls CreateTaskComment.
                     * @function createTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest} request CreateTaskCommentRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.TaskComment>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#updateTaskComment}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef UpdateTaskCommentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.TaskComment} [response] TaskComment
                     */
    
                    /**
                     * Calls UpdateTaskComment.
                     * @function updateTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest} request UpdateTaskCommentRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.UpdateTaskCommentCallback} callback Node-style callback called with the error, if any, and TaskComment
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.updateTaskComment = function updateTaskComment(request, callback) {
                        return this.rpcCall(updateTaskComment, $root.palexy.task_management.v1.UpdateTaskCommentRequest, $root.palexy.task_management.v1.TaskComment, request, callback);
                    }, "name", { value: "UpdateTaskComment" });
    
                    /**
                     * Calls UpdateTaskComment.
                     * @function updateTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest} request UpdateTaskCommentRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.TaskComment>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.TaskManagementService#deleteTaskComment}.
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @typedef DeleteTaskCommentCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteTaskComment.
                     * @function deleteTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest} request DeleteTaskCommentRequest message or plain object
                     * @param {palexy.task_management.v1.TaskManagementService.DeleteTaskCommentCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(TaskManagementService.prototype.deleteTaskComment = function deleteTaskComment(request, callback) {
                        return this.rpcCall(deleteTaskComment, $root.palexy.task_management.v1.DeleteTaskCommentRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteTaskComment" });
    
                    /**
                     * Calls DeleteTaskComment.
                     * @function deleteTaskComment
                     * @memberof palexy.task_management.v1.TaskManagementService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest} request DeleteTaskCommentRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return TaskManagementService;
                })();
    
                v1.ListProjectsRequest = (function() {
    
                    /**
                     * Properties of a ListProjectsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListProjectsRequest
                     * @property {number|null} [pageSize] ListProjectsRequest pageSize
                     * @property {string|null} [pageToken] ListProjectsRequest pageToken
                     * @property {number|null} [userId] ListProjectsRequest userId
                     * @property {boolean|null} [includeSharedProjects] ListProjectsRequest includeSharedProjects
                     */
    
                    /**
                     * Constructs a new ListProjectsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListProjectsRequest.
                     * @implements IListProjectsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListProjectsRequest=} [properties] Properties to set
                     */
                    function ListProjectsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProjectsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @instance
                     */
                    ListProjectsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListProjectsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @instance
                     */
                    ListProjectsRequest.prototype.pageToken = "";
    
                    /**
                     * ListProjectsRequest userId.
                     * @member {number} userId
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @instance
                     */
                    ListProjectsRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListProjectsRequest includeSharedProjects.
                     * @member {boolean} includeSharedProjects
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @instance
                     */
                    ListProjectsRequest.prototype.includeSharedProjects = false;
    
                    /**
                     * Creates a new ListProjectsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListProjectsRequest} ListProjectsRequest instance
                     */
                    ListProjectsRequest.create = function create(properties) {
                        return new ListProjectsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListProjectsRequest message. Does not implicitly {@link palexy.task_management.v1.ListProjectsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsRequest} message ListProjectsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.userId);
                        if (message.includeSharedProjects != null && Object.hasOwnProperty.call(message, "includeSharedProjects"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeSharedProjects);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProjectsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListProjectsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsRequest} message ListProjectsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProjectsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListProjectsRequest} ListProjectsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListProjectsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.userId = reader.int64();
                                break;
                            case 4:
                                message.includeSharedProjects = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProjectsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListProjectsRequest} ListProjectsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProjectsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProjectsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        if (message.includeSharedProjects != null && message.hasOwnProperty("includeSharedProjects"))
                            if (typeof message.includeSharedProjects !== "boolean")
                                return "includeSharedProjects: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListProjectsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListProjectsRequest} ListProjectsRequest
                     */
                    ListProjectsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListProjectsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListProjectsRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        if (object.includeSharedProjects != null)
                            message.includeSharedProjects = Boolean(object.includeSharedProjects);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProjectsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListProjectsRequest} message ListProjectsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProjectsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                            object.includeSharedProjects = false;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        if (message.includeSharedProjects != null && message.hasOwnProperty("includeSharedProjects"))
                            object.includeSharedProjects = message.includeSharedProjects;
                        return object;
                    };
    
                    /**
                     * Converts this ListProjectsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListProjectsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProjectsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProjectsRequest;
                })();
    
                v1.ListProjectsResponse = (function() {
    
                    /**
                     * Properties of a ListProjectsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListProjectsResponse
                     * @property {Array.<palexy.task_management.v1.IProject>|null} [projects] ListProjectsResponse projects
                     * @property {string|null} [nextPageToken] ListProjectsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListProjectsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListProjectsResponse.
                     * @implements IListProjectsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListProjectsResponse=} [properties] Properties to set
                     */
                    function ListProjectsResponse(properties) {
                        this.projects = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProjectsResponse projects.
                     * @member {Array.<palexy.task_management.v1.IProject>} projects
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @instance
                     */
                    ListProjectsResponse.prototype.projects = $util.emptyArray;
    
                    /**
                     * ListProjectsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @instance
                     */
                    ListProjectsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListProjectsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListProjectsResponse} ListProjectsResponse instance
                     */
                    ListProjectsResponse.create = function create(properties) {
                        return new ListProjectsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListProjectsResponse message. Does not implicitly {@link palexy.task_management.v1.ListProjectsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsResponse} message ListProjectsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projects != null && message.projects.length)
                            for (var i = 0; i < message.projects.length; ++i)
                                $root.palexy.task_management.v1.Project.encode(message.projects[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProjectsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListProjectsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectsResponse} message ListProjectsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProjectsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListProjectsResponse} ListProjectsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListProjectsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.projects && message.projects.length))
                                    message.projects = [];
                                message.projects.push($root.palexy.task_management.v1.Project.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProjectsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListProjectsResponse} ListProjectsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProjectsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProjectsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projects != null && message.hasOwnProperty("projects")) {
                            if (!Array.isArray(message.projects))
                                return "projects: array expected";
                            for (var i = 0; i < message.projects.length; ++i) {
                                var error = $root.palexy.task_management.v1.Project.verify(message.projects[i]);
                                if (error)
                                    return "projects." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListProjectsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListProjectsResponse} ListProjectsResponse
                     */
                    ListProjectsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListProjectsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListProjectsResponse();
                        if (object.projects) {
                            if (!Array.isArray(object.projects))
                                throw TypeError(".palexy.task_management.v1.ListProjectsResponse.projects: array expected");
                            message.projects = [];
                            for (var i = 0; i < object.projects.length; ++i) {
                                if (typeof object.projects[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListProjectsResponse.projects: object expected");
                                message.projects[i] = $root.palexy.task_management.v1.Project.fromObject(object.projects[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProjectsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListProjectsResponse} message ListProjectsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProjectsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.projects = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.projects && message.projects.length) {
                            object.projects = [];
                            for (var j = 0; j < message.projects.length; ++j)
                                object.projects[j] = $root.palexy.task_management.v1.Project.toObject(message.projects[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListProjectsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListProjectsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProjectsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProjectsResponse;
                })();
    
                v1.GetProjectRequest = (function() {
    
                    /**
                     * Properties of a GetProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetProjectRequest
                     * @property {number|null} [id] GetProjectRequest id
                     */
    
                    /**
                     * Constructs a new GetProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetProjectRequest.
                     * @implements IGetProjectRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetProjectRequest=} [properties] Properties to set
                     */
                    function GetProjectRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetProjectRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @instance
                     */
                    GetProjectRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetProjectRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetProjectRequest} GetProjectRequest instance
                     */
                    GetProjectRequest.create = function create(properties) {
                        return new GetProjectRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetProjectRequest message. Does not implicitly {@link palexy.task_management.v1.GetProjectRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectRequest} message GetProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetProjectRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetProjectRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetProjectRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectRequest} message GetProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetProjectRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetProjectRequest} GetProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetProjectRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetProjectRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetProjectRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetProjectRequest} GetProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetProjectRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetProjectRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetProjectRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetProjectRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetProjectRequest} GetProjectRequest
                     */
                    GetProjectRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetProjectRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetProjectRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetProjectRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.GetProjectRequest} message GetProjectRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetProjectRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetProjectRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetProjectRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetProjectRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetProjectRequest;
                })();
    
                v1.CreateProjectRequest = (function() {
    
                    /**
                     * Properties of a CreateProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateProjectRequest
                     * @property {palexy.task_management.v1.IProject|null} [project] CreateProjectRequest project
                     */
    
                    /**
                     * Constructs a new CreateProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateProjectRequest.
                     * @implements ICreateProjectRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateProjectRequest=} [properties] Properties to set
                     */
                    function CreateProjectRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateProjectRequest project.
                     * @member {palexy.task_management.v1.IProject|null|undefined} project
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @instance
                     */
                    CreateProjectRequest.prototype.project = null;
    
                    /**
                     * Creates a new CreateProjectRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateProjectRequest} CreateProjectRequest instance
                     */
                    CreateProjectRequest.create = function create(properties) {
                        return new CreateProjectRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateProjectRequest message. Does not implicitly {@link palexy.task_management.v1.CreateProjectRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectRequest} message CreateProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateProjectRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.project != null && Object.hasOwnProperty.call(message, "project"))
                            $root.palexy.task_management.v1.Project.encode(message.project, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateProjectRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateProjectRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectRequest} message CreateProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateProjectRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateProjectRequest} CreateProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateProjectRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateProjectRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.project = $root.palexy.task_management.v1.Project.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateProjectRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateProjectRequest} CreateProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateProjectRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateProjectRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateProjectRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.project != null && message.hasOwnProperty("project")) {
                            var error = $root.palexy.task_management.v1.Project.verify(message.project);
                            if (error)
                                return "project." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateProjectRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateProjectRequest} CreateProjectRequest
                     */
                    CreateProjectRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateProjectRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateProjectRequest();
                        if (object.project != null) {
                            if (typeof object.project !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateProjectRequest.project: object expected");
                            message.project = $root.palexy.task_management.v1.Project.fromObject(object.project);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateProjectRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateProjectRequest} message CreateProjectRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateProjectRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.project = null;
                        if (message.project != null && message.hasOwnProperty("project"))
                            object.project = $root.palexy.task_management.v1.Project.toObject(message.project, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateProjectRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateProjectRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateProjectRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateProjectRequest;
                })();
    
                v1.UpdateProjectRequest = (function() {
    
                    /**
                     * Properties of an UpdateProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateProjectRequest
                     * @property {palexy.task_management.v1.IProject|null} [project] UpdateProjectRequest project
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateProjectRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateProjectRequest.
                     * @implements IUpdateProjectRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateProjectRequest=} [properties] Properties to set
                     */
                    function UpdateProjectRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateProjectRequest project.
                     * @member {palexy.task_management.v1.IProject|null|undefined} project
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @instance
                     */
                    UpdateProjectRequest.prototype.project = null;
    
                    /**
                     * UpdateProjectRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @instance
                     */
                    UpdateProjectRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateProjectRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateProjectRequest} UpdateProjectRequest instance
                     */
                    UpdateProjectRequest.create = function create(properties) {
                        return new UpdateProjectRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateProjectRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateProjectRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectRequest} message UpdateProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProjectRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.project != null && Object.hasOwnProperty.call(message, "project"))
                            $root.palexy.task_management.v1.Project.encode(message.project, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateProjectRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateProjectRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectRequest} message UpdateProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateProjectRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateProjectRequest} UpdateProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProjectRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateProjectRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.project = $root.palexy.task_management.v1.Project.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateProjectRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateProjectRequest} UpdateProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProjectRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateProjectRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateProjectRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.project != null && message.hasOwnProperty("project")) {
                            var error = $root.palexy.task_management.v1.Project.verify(message.project);
                            if (error)
                                return "project." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateProjectRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateProjectRequest} UpdateProjectRequest
                     */
                    UpdateProjectRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateProjectRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateProjectRequest();
                        if (object.project != null) {
                            if (typeof object.project !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateProjectRequest.project: object expected");
                            message.project = $root.palexy.task_management.v1.Project.fromObject(object.project);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateProjectRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateProjectRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateProjectRequest} message UpdateProjectRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateProjectRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.project = null;
                            object.updateMask = null;
                        }
                        if (message.project != null && message.hasOwnProperty("project"))
                            object.project = $root.palexy.task_management.v1.Project.toObject(message.project, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateProjectRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateProjectRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateProjectRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateProjectRequest;
                })();
    
                v1.DeleteProjectRequest = (function() {
    
                    /**
                     * Properties of a DeleteProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteProjectRequest
                     * @property {number|null} [id] DeleteProjectRequest id
                     */
    
                    /**
                     * Constructs a new DeleteProjectRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteProjectRequest.
                     * @implements IDeleteProjectRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteProjectRequest=} [properties] Properties to set
                     */
                    function DeleteProjectRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteProjectRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @instance
                     */
                    DeleteProjectRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteProjectRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteProjectRequest} DeleteProjectRequest instance
                     */
                    DeleteProjectRequest.create = function create(properties) {
                        return new DeleteProjectRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteProjectRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteProjectRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectRequest} message DeleteProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteProjectRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteProjectRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteProjectRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectRequest} message DeleteProjectRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteProjectRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteProjectRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteProjectRequest} DeleteProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteProjectRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteProjectRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteProjectRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteProjectRequest} DeleteProjectRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteProjectRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteProjectRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteProjectRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteProjectRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteProjectRequest} DeleteProjectRequest
                     */
                    DeleteProjectRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteProjectRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteProjectRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteProjectRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteProjectRequest} message DeleteProjectRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteProjectRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteProjectRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteProjectRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteProjectRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteProjectRequest;
                })();
    
                v1.ListProjectDataViewsRequest = (function() {
    
                    /**
                     * Properties of a ListProjectDataViewsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListProjectDataViewsRequest
                     * @property {number|null} [projectId] ListProjectDataViewsRequest projectId
                     * @property {number|null} [userId] ListProjectDataViewsRequest userId
                     */
    
                    /**
                     * Constructs a new ListProjectDataViewsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListProjectDataViewsRequest.
                     * @implements IListProjectDataViewsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest=} [properties] Properties to set
                     */
                    function ListProjectDataViewsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProjectDataViewsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @instance
                     */
                    ListProjectDataViewsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListProjectDataViewsRequest userId.
                     * @member {number} userId
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @instance
                     */
                    ListProjectDataViewsRequest.prototype.userId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListProjectDataViewsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListProjectDataViewsRequest} ListProjectDataViewsRequest instance
                     */
                    ListProjectDataViewsRequest.create = function create(properties) {
                        return new ListProjectDataViewsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListProjectDataViewsRequest message. Does not implicitly {@link palexy.task_management.v1.ListProjectDataViewsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest} message ListProjectDataViewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectDataViewsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.userId != null && Object.hasOwnProperty.call(message, "userId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.userId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProjectDataViewsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListProjectDataViewsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsRequest} message ListProjectDataViewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectDataViewsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProjectDataViewsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListProjectDataViewsRequest} ListProjectDataViewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectDataViewsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListProjectDataViewsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.userId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProjectDataViewsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListProjectDataViewsRequest} ListProjectDataViewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectDataViewsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProjectDataViewsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProjectDataViewsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (!$util.isInteger(message.userId) && !(message.userId && $util.isInteger(message.userId.low) && $util.isInteger(message.userId.high)))
                                return "userId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListProjectDataViewsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListProjectDataViewsRequest} ListProjectDataViewsRequest
                     */
                    ListProjectDataViewsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListProjectDataViewsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListProjectDataViewsRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.userId != null)
                            if ($util.Long)
                                (message.userId = $util.Long.fromValue(object.userId)).unsigned = false;
                            else if (typeof object.userId === "string")
                                message.userId = parseInt(object.userId, 10);
                            else if (typeof object.userId === "number")
                                message.userId = object.userId;
                            else if (typeof object.userId === "object")
                                message.userId = new $util.LongBits(object.userId.low >>> 0, object.userId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProjectDataViewsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListProjectDataViewsRequest} message ListProjectDataViewsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProjectDataViewsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.userId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.userId = options.longs === String ? "0" : 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.userId != null && message.hasOwnProperty("userId"))
                            if (typeof message.userId === "number")
                                object.userId = options.longs === String ? String(message.userId) : message.userId;
                            else
                                object.userId = options.longs === String ? $util.Long.prototype.toString.call(message.userId) : options.longs === Number ? new $util.LongBits(message.userId.low >>> 0, message.userId.high >>> 0).toNumber() : message.userId;
                        return object;
                    };
    
                    /**
                     * Converts this ListProjectDataViewsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListProjectDataViewsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProjectDataViewsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProjectDataViewsRequest;
                })();
    
                v1.ListProjectDataViewsResponse = (function() {
    
                    /**
                     * Properties of a ListProjectDataViewsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListProjectDataViewsResponse
                     * @property {number|null} [projectId] ListProjectDataViewsResponse projectId
                     * @property {Array.<palexy.task_management.v1.IProjectDataView>|null} [dataViews] ListProjectDataViewsResponse dataViews
                     */
    
                    /**
                     * Constructs a new ListProjectDataViewsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListProjectDataViewsResponse.
                     * @implements IListProjectDataViewsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListProjectDataViewsResponse=} [properties] Properties to set
                     */
                    function ListProjectDataViewsResponse(properties) {
                        this.dataViews = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListProjectDataViewsResponse projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @instance
                     */
                    ListProjectDataViewsResponse.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListProjectDataViewsResponse dataViews.
                     * @member {Array.<palexy.task_management.v1.IProjectDataView>} dataViews
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @instance
                     */
                    ListProjectDataViewsResponse.prototype.dataViews = $util.emptyArray;
    
                    /**
                     * Creates a new ListProjectDataViewsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListProjectDataViewsResponse} ListProjectDataViewsResponse instance
                     */
                    ListProjectDataViewsResponse.create = function create(properties) {
                        return new ListProjectDataViewsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListProjectDataViewsResponse message. Does not implicitly {@link palexy.task_management.v1.ListProjectDataViewsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsResponse} message ListProjectDataViewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectDataViewsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.dataViews != null && message.dataViews.length)
                            for (var i = 0; i < message.dataViews.length; ++i)
                                $root.palexy.task_management.v1.ProjectDataView.encode(message.dataViews[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListProjectDataViewsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListProjectDataViewsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListProjectDataViewsResponse} message ListProjectDataViewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListProjectDataViewsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListProjectDataViewsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListProjectDataViewsResponse} ListProjectDataViewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectDataViewsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListProjectDataViewsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                if (!(message.dataViews && message.dataViews.length))
                                    message.dataViews = [];
                                message.dataViews.push($root.palexy.task_management.v1.ProjectDataView.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListProjectDataViewsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListProjectDataViewsResponse} ListProjectDataViewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListProjectDataViewsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListProjectDataViewsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListProjectDataViewsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.dataViews != null && message.hasOwnProperty("dataViews")) {
                            if (!Array.isArray(message.dataViews))
                                return "dataViews: array expected";
                            for (var i = 0; i < message.dataViews.length; ++i) {
                                var error = $root.palexy.task_management.v1.ProjectDataView.verify(message.dataViews[i]);
                                if (error)
                                    return "dataViews." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListProjectDataViewsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListProjectDataViewsResponse} ListProjectDataViewsResponse
                     */
                    ListProjectDataViewsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListProjectDataViewsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListProjectDataViewsResponse();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.dataViews) {
                            if (!Array.isArray(object.dataViews))
                                throw TypeError(".palexy.task_management.v1.ListProjectDataViewsResponse.dataViews: array expected");
                            message.dataViews = [];
                            for (var i = 0; i < object.dataViews.length; ++i) {
                                if (typeof object.dataViews[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListProjectDataViewsResponse.dataViews: object expected");
                                message.dataViews[i] = $root.palexy.task_management.v1.ProjectDataView.fromObject(object.dataViews[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListProjectDataViewsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListProjectDataViewsResponse} message ListProjectDataViewsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListProjectDataViewsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dataViews = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.dataViews && message.dataViews.length) {
                            object.dataViews = [];
                            for (var j = 0; j < message.dataViews.length; ++j)
                                object.dataViews[j] = $root.palexy.task_management.v1.ProjectDataView.toObject(message.dataViews[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListProjectDataViewsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListProjectDataViewsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListProjectDataViewsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListProjectDataViewsResponse;
                })();
    
                v1.GetProjectDataViewRequest = (function() {
    
                    /**
                     * Properties of a GetProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetProjectDataViewRequest
                     * @property {number|null} [projectId] GetProjectDataViewRequest projectId
                     * @property {number|null} [id] GetProjectDataViewRequest id
                     */
    
                    /**
                     * Constructs a new GetProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetProjectDataViewRequest.
                     * @implements IGetProjectDataViewRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest=} [properties] Properties to set
                     */
                    function GetProjectDataViewRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetProjectDataViewRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @instance
                     */
                    GetProjectDataViewRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetProjectDataViewRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @instance
                     */
                    GetProjectDataViewRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetProjectDataViewRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetProjectDataViewRequest} GetProjectDataViewRequest instance
                     */
                    GetProjectDataViewRequest.create = function create(properties) {
                        return new GetProjectDataViewRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetProjectDataViewRequest message. Does not implicitly {@link palexy.task_management.v1.GetProjectDataViewRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest} message GetProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetProjectDataViewRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetProjectDataViewRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetProjectDataViewRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetProjectDataViewRequest} message GetProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetProjectDataViewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetProjectDataViewRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetProjectDataViewRequest} GetProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetProjectDataViewRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetProjectDataViewRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetProjectDataViewRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetProjectDataViewRequest} GetProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetProjectDataViewRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetProjectDataViewRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetProjectDataViewRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetProjectDataViewRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetProjectDataViewRequest} GetProjectDataViewRequest
                     */
                    GetProjectDataViewRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetProjectDataViewRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetProjectDataViewRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetProjectDataViewRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.GetProjectDataViewRequest} message GetProjectDataViewRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetProjectDataViewRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetProjectDataViewRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetProjectDataViewRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetProjectDataViewRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetProjectDataViewRequest;
                })();
    
                v1.CreateProjectDataViewRequest = (function() {
    
                    /**
                     * Properties of a CreateProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateProjectDataViewRequest
                     * @property {number|null} [projectId] CreateProjectDataViewRequest projectId
                     * @property {palexy.task_management.v1.IProjectDataView|null} [dataView] CreateProjectDataViewRequest dataView
                     */
    
                    /**
                     * Constructs a new CreateProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateProjectDataViewRequest.
                     * @implements ICreateProjectDataViewRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest=} [properties] Properties to set
                     */
                    function CreateProjectDataViewRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateProjectDataViewRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @instance
                     */
                    CreateProjectDataViewRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateProjectDataViewRequest dataView.
                     * @member {palexy.task_management.v1.IProjectDataView|null|undefined} dataView
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @instance
                     */
                    CreateProjectDataViewRequest.prototype.dataView = null;
    
                    /**
                     * Creates a new CreateProjectDataViewRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateProjectDataViewRequest} CreateProjectDataViewRequest instance
                     */
                    CreateProjectDataViewRequest.create = function create(properties) {
                        return new CreateProjectDataViewRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateProjectDataViewRequest message. Does not implicitly {@link palexy.task_management.v1.CreateProjectDataViewRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest} message CreateProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateProjectDataViewRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.dataView != null && Object.hasOwnProperty.call(message, "dataView"))
                            $root.palexy.task_management.v1.ProjectDataView.encode(message.dataView, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateProjectDataViewRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateProjectDataViewRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateProjectDataViewRequest} message CreateProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateProjectDataViewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateProjectDataViewRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateProjectDataViewRequest} CreateProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateProjectDataViewRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateProjectDataViewRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.dataView = $root.palexy.task_management.v1.ProjectDataView.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateProjectDataViewRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateProjectDataViewRequest} CreateProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateProjectDataViewRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateProjectDataViewRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateProjectDataViewRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.dataView != null && message.hasOwnProperty("dataView")) {
                            var error = $root.palexy.task_management.v1.ProjectDataView.verify(message.dataView);
                            if (error)
                                return "dataView." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateProjectDataViewRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateProjectDataViewRequest} CreateProjectDataViewRequest
                     */
                    CreateProjectDataViewRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateProjectDataViewRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateProjectDataViewRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.dataView != null) {
                            if (typeof object.dataView !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateProjectDataViewRequest.dataView: object expected");
                            message.dataView = $root.palexy.task_management.v1.ProjectDataView.fromObject(object.dataView);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateProjectDataViewRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateProjectDataViewRequest} message CreateProjectDataViewRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateProjectDataViewRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.dataView = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.dataView != null && message.hasOwnProperty("dataView"))
                            object.dataView = $root.palexy.task_management.v1.ProjectDataView.toObject(message.dataView, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateProjectDataViewRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateProjectDataViewRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateProjectDataViewRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateProjectDataViewRequest;
                })();
    
                v1.UpdateProjectDataViewRequest = (function() {
    
                    /**
                     * Properties of an UpdateProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateProjectDataViewRequest
                     * @property {number|null} [projectId] UpdateProjectDataViewRequest projectId
                     * @property {palexy.task_management.v1.IProjectDataView|null} [dataView] UpdateProjectDataViewRequest dataView
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateProjectDataViewRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateProjectDataViewRequest.
                     * @implements IUpdateProjectDataViewRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest=} [properties] Properties to set
                     */
                    function UpdateProjectDataViewRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateProjectDataViewRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @instance
                     */
                    UpdateProjectDataViewRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateProjectDataViewRequest dataView.
                     * @member {palexy.task_management.v1.IProjectDataView|null|undefined} dataView
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @instance
                     */
                    UpdateProjectDataViewRequest.prototype.dataView = null;
    
                    /**
                     * UpdateProjectDataViewRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @instance
                     */
                    UpdateProjectDataViewRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateProjectDataViewRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateProjectDataViewRequest} UpdateProjectDataViewRequest instance
                     */
                    UpdateProjectDataViewRequest.create = function create(properties) {
                        return new UpdateProjectDataViewRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateProjectDataViewRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateProjectDataViewRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest} message UpdateProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProjectDataViewRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.dataView != null && Object.hasOwnProperty.call(message, "dataView"))
                            $root.palexy.task_management.v1.ProjectDataView.encode(message.dataView, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateProjectDataViewRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateProjectDataViewRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateProjectDataViewRequest} message UpdateProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateProjectDataViewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateProjectDataViewRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateProjectDataViewRequest} UpdateProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProjectDataViewRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateProjectDataViewRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.dataView = $root.palexy.task_management.v1.ProjectDataView.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateProjectDataViewRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateProjectDataViewRequest} UpdateProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateProjectDataViewRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateProjectDataViewRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateProjectDataViewRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.dataView != null && message.hasOwnProperty("dataView")) {
                            var error = $root.palexy.task_management.v1.ProjectDataView.verify(message.dataView);
                            if (error)
                                return "dataView." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateProjectDataViewRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateProjectDataViewRequest} UpdateProjectDataViewRequest
                     */
                    UpdateProjectDataViewRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateProjectDataViewRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateProjectDataViewRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.dataView != null) {
                            if (typeof object.dataView !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateProjectDataViewRequest.dataView: object expected");
                            message.dataView = $root.palexy.task_management.v1.ProjectDataView.fromObject(object.dataView);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateProjectDataViewRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateProjectDataViewRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateProjectDataViewRequest} message UpdateProjectDataViewRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateProjectDataViewRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.dataView = null;
                            object.updateMask = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.dataView != null && message.hasOwnProperty("dataView"))
                            object.dataView = $root.palexy.task_management.v1.ProjectDataView.toObject(message.dataView, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateProjectDataViewRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateProjectDataViewRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateProjectDataViewRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateProjectDataViewRequest;
                })();
    
                v1.DeleteProjectDataViewRequest = (function() {
    
                    /**
                     * Properties of a DeleteProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteProjectDataViewRequest
                     * @property {number|null} [projectId] DeleteProjectDataViewRequest projectId
                     * @property {number|null} [id] DeleteProjectDataViewRequest id
                     */
    
                    /**
                     * Constructs a new DeleteProjectDataViewRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteProjectDataViewRequest.
                     * @implements IDeleteProjectDataViewRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest=} [properties] Properties to set
                     */
                    function DeleteProjectDataViewRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteProjectDataViewRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @instance
                     */
                    DeleteProjectDataViewRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteProjectDataViewRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @instance
                     */
                    DeleteProjectDataViewRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteProjectDataViewRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteProjectDataViewRequest} DeleteProjectDataViewRequest instance
                     */
                    DeleteProjectDataViewRequest.create = function create(properties) {
                        return new DeleteProjectDataViewRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteProjectDataViewRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteProjectDataViewRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest} message DeleteProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteProjectDataViewRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteProjectDataViewRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteProjectDataViewRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteProjectDataViewRequest} message DeleteProjectDataViewRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteProjectDataViewRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteProjectDataViewRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteProjectDataViewRequest} DeleteProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteProjectDataViewRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteProjectDataViewRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteProjectDataViewRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteProjectDataViewRequest} DeleteProjectDataViewRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteProjectDataViewRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteProjectDataViewRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteProjectDataViewRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteProjectDataViewRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteProjectDataViewRequest} DeleteProjectDataViewRequest
                     */
                    DeleteProjectDataViewRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteProjectDataViewRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteProjectDataViewRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteProjectDataViewRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteProjectDataViewRequest} message DeleteProjectDataViewRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteProjectDataViewRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteProjectDataViewRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteProjectDataViewRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteProjectDataViewRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteProjectDataViewRequest;
                })();
    
                v1.ListTaskGroupsRequest = (function() {
    
                    /**
                     * Properties of a ListTaskGroupsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListTaskGroupsRequest
                     * @property {number|null} [pageSize] ListTaskGroupsRequest pageSize
                     * @property {string|null} [pageToken] ListTaskGroupsRequest pageToken
                     * @property {number|null} [projectId] ListTaskGroupsRequest projectId
                     */
    
                    /**
                     * Constructs a new ListTaskGroupsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTaskGroupsRequest.
                     * @implements IListTaskGroupsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest=} [properties] Properties to set
                     */
                    function ListTaskGroupsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskGroupsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @instance
                     */
                    ListTaskGroupsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListTaskGroupsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @instance
                     */
                    ListTaskGroupsRequest.prototype.pageToken = "";
    
                    /**
                     * ListTaskGroupsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @instance
                     */
                    ListTaskGroupsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListTaskGroupsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTaskGroupsRequest} ListTaskGroupsRequest instance
                     */
                    ListTaskGroupsRequest.create = function create(properties) {
                        return new ListTaskGroupsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskGroupsRequest message. Does not implicitly {@link palexy.task_management.v1.ListTaskGroupsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest} message ListTaskGroupsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskGroupsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.projectId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskGroupsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTaskGroupsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsRequest} message ListTaskGroupsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskGroupsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskGroupsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTaskGroupsRequest} ListTaskGroupsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskGroupsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTaskGroupsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.projectId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskGroupsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTaskGroupsRequest} ListTaskGroupsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskGroupsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskGroupsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskGroupsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskGroupsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTaskGroupsRequest} ListTaskGroupsRequest
                     */
                    ListTaskGroupsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTaskGroupsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTaskGroupsRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskGroupsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListTaskGroupsRequest} message ListTaskGroupsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskGroupsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskGroupsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTaskGroupsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskGroupsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskGroupsRequest;
                })();
    
                v1.ListTaskGroupsResponse = (function() {
    
                    /**
                     * Properties of a ListTaskGroupsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListTaskGroupsResponse
                     * @property {Array.<palexy.task_management.v1.ITaskGroup>|null} [taskGroups] ListTaskGroupsResponse taskGroups
                     * @property {string|null} [nextPageToken] ListTaskGroupsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListTaskGroupsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTaskGroupsResponse.
                     * @implements IListTaskGroupsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListTaskGroupsResponse=} [properties] Properties to set
                     */
                    function ListTaskGroupsResponse(properties) {
                        this.taskGroups = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskGroupsResponse taskGroups.
                     * @member {Array.<palexy.task_management.v1.ITaskGroup>} taskGroups
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @instance
                     */
                    ListTaskGroupsResponse.prototype.taskGroups = $util.emptyArray;
    
                    /**
                     * ListTaskGroupsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @instance
                     */
                    ListTaskGroupsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListTaskGroupsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTaskGroupsResponse} ListTaskGroupsResponse instance
                     */
                    ListTaskGroupsResponse.create = function create(properties) {
                        return new ListTaskGroupsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskGroupsResponse message. Does not implicitly {@link palexy.task_management.v1.ListTaskGroupsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsResponse} message ListTaskGroupsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskGroupsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskGroups != null && message.taskGroups.length)
                            for (var i = 0; i < message.taskGroups.length; ++i)
                                $root.palexy.task_management.v1.TaskGroup.encode(message.taskGroups[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskGroupsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTaskGroupsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskGroupsResponse} message ListTaskGroupsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskGroupsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskGroupsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTaskGroupsResponse} ListTaskGroupsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskGroupsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTaskGroupsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.taskGroups && message.taskGroups.length))
                                    message.taskGroups = [];
                                message.taskGroups.push($root.palexy.task_management.v1.TaskGroup.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskGroupsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTaskGroupsResponse} ListTaskGroupsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskGroupsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskGroupsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskGroupsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskGroups != null && message.hasOwnProperty("taskGroups")) {
                            if (!Array.isArray(message.taskGroups))
                                return "taskGroups: array expected";
                            for (var i = 0; i < message.taskGroups.length; ++i) {
                                var error = $root.palexy.task_management.v1.TaskGroup.verify(message.taskGroups[i]);
                                if (error)
                                    return "taskGroups." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskGroupsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTaskGroupsResponse} ListTaskGroupsResponse
                     */
                    ListTaskGroupsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTaskGroupsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTaskGroupsResponse();
                        if (object.taskGroups) {
                            if (!Array.isArray(object.taskGroups))
                                throw TypeError(".palexy.task_management.v1.ListTaskGroupsResponse.taskGroups: array expected");
                            message.taskGroups = [];
                            for (var i = 0; i < object.taskGroups.length; ++i) {
                                if (typeof object.taskGroups[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListTaskGroupsResponse.taskGroups: object expected");
                                message.taskGroups[i] = $root.palexy.task_management.v1.TaskGroup.fromObject(object.taskGroups[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskGroupsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListTaskGroupsResponse} message ListTaskGroupsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskGroupsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskGroups = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.taskGroups && message.taskGroups.length) {
                            object.taskGroups = [];
                            for (var j = 0; j < message.taskGroups.length; ++j)
                                object.taskGroups[j] = $root.palexy.task_management.v1.TaskGroup.toObject(message.taskGroups[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskGroupsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTaskGroupsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskGroupsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskGroupsResponse;
                })();
    
                v1.CreateTaskGroupRequest = (function() {
    
                    /**
                     * Properties of a CreateTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateTaskGroupRequest
                     * @property {palexy.task_management.v1.ITaskGroup|null} [taskGroup] CreateTaskGroupRequest taskGroup
                     */
    
                    /**
                     * Constructs a new CreateTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateTaskGroupRequest.
                     * @implements ICreateTaskGroupRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest=} [properties] Properties to set
                     */
                    function CreateTaskGroupRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTaskGroupRequest taskGroup.
                     * @member {palexy.task_management.v1.ITaskGroup|null|undefined} taskGroup
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @instance
                     */
                    CreateTaskGroupRequest.prototype.taskGroup = null;
    
                    /**
                     * Creates a new CreateTaskGroupRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateTaskGroupRequest} CreateTaskGroupRequest instance
                     */
                    CreateTaskGroupRequest.create = function create(properties) {
                        return new CreateTaskGroupRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTaskGroupRequest message. Does not implicitly {@link palexy.task_management.v1.CreateTaskGroupRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest} message CreateTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskGroupRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskGroup != null && Object.hasOwnProperty.call(message, "taskGroup"))
                            $root.palexy.task_management.v1.TaskGroup.encode(message.taskGroup, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTaskGroupRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateTaskGroupRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskGroupRequest} message CreateTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskGroupRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTaskGroupRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateTaskGroupRequest} CreateTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskGroupRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateTaskGroupRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskGroup = $root.palexy.task_management.v1.TaskGroup.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTaskGroupRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateTaskGroupRequest} CreateTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskGroupRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTaskGroupRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTaskGroupRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskGroup != null && message.hasOwnProperty("taskGroup")) {
                            var error = $root.palexy.task_management.v1.TaskGroup.verify(message.taskGroup);
                            if (error)
                                return "taskGroup." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTaskGroupRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateTaskGroupRequest} CreateTaskGroupRequest
                     */
                    CreateTaskGroupRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateTaskGroupRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateTaskGroupRequest();
                        if (object.taskGroup != null) {
                            if (typeof object.taskGroup !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateTaskGroupRequest.taskGroup: object expected");
                            message.taskGroup = $root.palexy.task_management.v1.TaskGroup.fromObject(object.taskGroup);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTaskGroupRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateTaskGroupRequest} message CreateTaskGroupRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTaskGroupRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.taskGroup = null;
                        if (message.taskGroup != null && message.hasOwnProperty("taskGroup"))
                            object.taskGroup = $root.palexy.task_management.v1.TaskGroup.toObject(message.taskGroup, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTaskGroupRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateTaskGroupRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTaskGroupRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTaskGroupRequest;
                })();
    
                v1.UpdateTaskGroupRequest = (function() {
    
                    /**
                     * Properties of an UpdateTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateTaskGroupRequest
                     * @property {palexy.task_management.v1.ITaskGroup|null} [taskGroup] UpdateTaskGroupRequest taskGroup
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateTaskGroupRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateTaskGroupRequest.
                     * @implements IUpdateTaskGroupRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest=} [properties] Properties to set
                     */
                    function UpdateTaskGroupRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateTaskGroupRequest taskGroup.
                     * @member {palexy.task_management.v1.ITaskGroup|null|undefined} taskGroup
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @instance
                     */
                    UpdateTaskGroupRequest.prototype.taskGroup = null;
    
                    /**
                     * UpdateTaskGroupRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @instance
                     */
                    UpdateTaskGroupRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateTaskGroupRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateTaskGroupRequest} UpdateTaskGroupRequest instance
                     */
                    UpdateTaskGroupRequest.create = function create(properties) {
                        return new UpdateTaskGroupRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateTaskGroupRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateTaskGroupRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest} message UpdateTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskGroupRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskGroup != null && Object.hasOwnProperty.call(message, "taskGroup"))
                            $root.palexy.task_management.v1.TaskGroup.encode(message.taskGroup, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateTaskGroupRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateTaskGroupRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskGroupRequest} message UpdateTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskGroupRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateTaskGroupRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateTaskGroupRequest} UpdateTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskGroupRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateTaskGroupRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.taskGroup = $root.palexy.task_management.v1.TaskGroup.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateTaskGroupRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateTaskGroupRequest} UpdateTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskGroupRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateTaskGroupRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateTaskGroupRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskGroup != null && message.hasOwnProperty("taskGroup")) {
                            var error = $root.palexy.task_management.v1.TaskGroup.verify(message.taskGroup);
                            if (error)
                                return "taskGroup." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateTaskGroupRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateTaskGroupRequest} UpdateTaskGroupRequest
                     */
                    UpdateTaskGroupRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateTaskGroupRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateTaskGroupRequest();
                        if (object.taskGroup != null) {
                            if (typeof object.taskGroup !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTaskGroupRequest.taskGroup: object expected");
                            message.taskGroup = $root.palexy.task_management.v1.TaskGroup.fromObject(object.taskGroup);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTaskGroupRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateTaskGroupRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateTaskGroupRequest} message UpdateTaskGroupRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateTaskGroupRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.taskGroup = null;
                            object.updateMask = null;
                        }
                        if (message.taskGroup != null && message.hasOwnProperty("taskGroup"))
                            object.taskGroup = $root.palexy.task_management.v1.TaskGroup.toObject(message.taskGroup, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateTaskGroupRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateTaskGroupRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateTaskGroupRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateTaskGroupRequest;
                })();
    
                v1.DeleteTaskGroupRequest = (function() {
    
                    /**
                     * Properties of a DeleteTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteTaskGroupRequest
                     * @property {number|null} [id] DeleteTaskGroupRequest id
                     */
    
                    /**
                     * Constructs a new DeleteTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteTaskGroupRequest.
                     * @implements IDeleteTaskGroupRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest=} [properties] Properties to set
                     */
                    function DeleteTaskGroupRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTaskGroupRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @instance
                     */
                    DeleteTaskGroupRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteTaskGroupRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteTaskGroupRequest} DeleteTaskGroupRequest instance
                     */
                    DeleteTaskGroupRequest.create = function create(properties) {
                        return new DeleteTaskGroupRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTaskGroupRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteTaskGroupRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest} message DeleteTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskGroupRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTaskGroupRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteTaskGroupRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskGroupRequest} message DeleteTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskGroupRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTaskGroupRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteTaskGroupRequest} DeleteTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskGroupRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteTaskGroupRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTaskGroupRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteTaskGroupRequest} DeleteTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskGroupRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTaskGroupRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTaskGroupRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTaskGroupRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteTaskGroupRequest} DeleteTaskGroupRequest
                     */
                    DeleteTaskGroupRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteTaskGroupRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteTaskGroupRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTaskGroupRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteTaskGroupRequest} message DeleteTaskGroupRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTaskGroupRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTaskGroupRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteTaskGroupRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTaskGroupRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTaskGroupRequest;
                })();
    
                v1.GetTaskGroupRequest = (function() {
    
                    /**
                     * Properties of a GetTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetTaskGroupRequest
                     * @property {number|null} [id] GetTaskGroupRequest id
                     */
    
                    /**
                     * Constructs a new GetTaskGroupRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetTaskGroupRequest.
                     * @implements IGetTaskGroupRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest=} [properties] Properties to set
                     */
                    function GetTaskGroupRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTaskGroupRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @instance
                     */
                    GetTaskGroupRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetTaskGroupRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetTaskGroupRequest} GetTaskGroupRequest instance
                     */
                    GetTaskGroupRequest.create = function create(properties) {
                        return new GetTaskGroupRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetTaskGroupRequest message. Does not implicitly {@link palexy.task_management.v1.GetTaskGroupRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest} message GetTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskGroupRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTaskGroupRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetTaskGroupRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskGroupRequest} message GetTaskGroupRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskGroupRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTaskGroupRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetTaskGroupRequest} GetTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskGroupRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetTaskGroupRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTaskGroupRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetTaskGroupRequest} GetTaskGroupRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskGroupRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTaskGroupRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTaskGroupRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetTaskGroupRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetTaskGroupRequest} GetTaskGroupRequest
                     */
                    GetTaskGroupRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetTaskGroupRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetTaskGroupRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTaskGroupRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @static
                     * @param {palexy.task_management.v1.GetTaskGroupRequest} message GetTaskGroupRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTaskGroupRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetTaskGroupRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetTaskGroupRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTaskGroupRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTaskGroupRequest;
                })();
    
                v1.ListTagsRequest = (function() {
    
                    /**
                     * Properties of a ListTagsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListTagsRequest
                     * @property {number|null} [pageSize] ListTagsRequest pageSize
                     * @property {string|null} [pageToken] ListTagsRequest pageToken
                     * @property {palexy.task_management.v1.Tag.AppliedScope|null} [appliedScope] ListTagsRequest appliedScope
                     * @property {number|null} [companyId] ListTagsRequest companyId
                     * @property {number|null} [projectId] ListTagsRequest projectId
                     */
    
                    /**
                     * Constructs a new ListTagsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTagsRequest.
                     * @implements IListTagsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListTagsRequest=} [properties] Properties to set
                     */
                    function ListTagsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTagsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     */
                    ListTagsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListTagsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     */
                    ListTagsRequest.prototype.pageToken = "";
    
                    /**
                     * ListTagsRequest appliedScope.
                     * @member {palexy.task_management.v1.Tag.AppliedScope} appliedScope
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     */
                    ListTagsRequest.prototype.appliedScope = 0;
    
                    /**
                     * ListTagsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     */
                    ListTagsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListTagsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     */
                    ListTagsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListTagsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTagsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTagsRequest} ListTagsRequest instance
                     */
                    ListTagsRequest.create = function create(properties) {
                        return new ListTagsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTagsRequest message. Does not implicitly {@link palexy.task_management.v1.ListTagsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTagsRequest} message ListTagsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTagsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.appliedScope != null && Object.hasOwnProperty.call(message, "appliedScope"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.appliedScope);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.companyId);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.projectId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTagsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTagsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTagsRequest} message ListTagsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTagsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTagsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTagsRequest} ListTagsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTagsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTagsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.appliedScope = reader.int32();
                                break;
                            case 4:
                                message.companyId = reader.int64();
                                break;
                            case 5:
                                message.projectId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTagsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTagsRequest} ListTagsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTagsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTagsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTagsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            switch (message.appliedScope) {
                            default:
                                return "appliedScope: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTagsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTagsRequest} ListTagsRequest
                     */
                    ListTagsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTagsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTagsRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        switch (object.appliedScope) {
                        case "UNKNOWN":
                        case 0:
                            message.appliedScope = 0;
                            break;
                        case "PROJECT":
                        case 1:
                            message.appliedScope = 1;
                            break;
                        case "COMPANY":
                        case 2:
                            message.appliedScope = 2;
                            break;
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTagsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListTagsRequest} message ListTagsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTagsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.appliedScope = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.appliedScope != null && message.hasOwnProperty("appliedScope"))
                            object.appliedScope = options.enums === String ? $root.palexy.task_management.v1.Tag.AppliedScope[message.appliedScope] : message.appliedScope;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        return object;
                    };
    
                    /**
                     * Converts this ListTagsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTagsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTagsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTagsRequest;
                })();
    
                v1.ListTagsResponse = (function() {
    
                    /**
                     * Properties of a ListTagsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListTagsResponse
                     * @property {Array.<palexy.task_management.v1.ITag>|null} [tags] ListTagsResponse tags
                     * @property {string|null} [nextPageToken] ListTagsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListTagsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTagsResponse.
                     * @implements IListTagsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListTagsResponse=} [properties] Properties to set
                     */
                    function ListTagsResponse(properties) {
                        this.tags = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTagsResponse tags.
                     * @member {Array.<palexy.task_management.v1.ITag>} tags
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @instance
                     */
                    ListTagsResponse.prototype.tags = $util.emptyArray;
    
                    /**
                     * ListTagsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @instance
                     */
                    ListTagsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListTagsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTagsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTagsResponse} ListTagsResponse instance
                     */
                    ListTagsResponse.create = function create(properties) {
                        return new ListTagsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTagsResponse message. Does not implicitly {@link palexy.task_management.v1.ListTagsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTagsResponse} message ListTagsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTagsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tags != null && message.tags.length)
                            for (var i = 0; i < message.tags.length; ++i)
                                $root.palexy.task_management.v1.Tag.encode(message.tags[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTagsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTagsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTagsResponse} message ListTagsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTagsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTagsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTagsResponse} ListTagsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTagsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTagsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tags && message.tags.length))
                                    message.tags = [];
                                message.tags.push($root.palexy.task_management.v1.Tag.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTagsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTagsResponse} ListTagsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTagsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTagsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTagsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tags != null && message.hasOwnProperty("tags")) {
                            if (!Array.isArray(message.tags))
                                return "tags: array expected";
                            for (var i = 0; i < message.tags.length; ++i) {
                                var error = $root.palexy.task_management.v1.Tag.verify(message.tags[i]);
                                if (error)
                                    return "tags." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTagsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTagsResponse} ListTagsResponse
                     */
                    ListTagsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTagsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTagsResponse();
                        if (object.tags) {
                            if (!Array.isArray(object.tags))
                                throw TypeError(".palexy.task_management.v1.ListTagsResponse.tags: array expected");
                            message.tags = [];
                            for (var i = 0; i < object.tags.length; ++i) {
                                if (typeof object.tags[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListTagsResponse.tags: object expected");
                                message.tags[i] = $root.palexy.task_management.v1.Tag.fromObject(object.tags[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTagsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListTagsResponse} message ListTagsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTagsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tags = [];
                        if (options.defaults)
                            object.nextPageToken = "";
                        if (message.tags && message.tags.length) {
                            object.tags = [];
                            for (var j = 0; j < message.tags.length; ++j)
                                object.tags[j] = $root.palexy.task_management.v1.Tag.toObject(message.tags[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListTagsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTagsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTagsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTagsResponse;
                })();
    
                v1.CreateTagRequest = (function() {
    
                    /**
                     * Properties of a CreateTagRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateTagRequest
                     * @property {palexy.task_management.v1.ITag|null} [tag] CreateTagRequest tag
                     */
    
                    /**
                     * Constructs a new CreateTagRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateTagRequest.
                     * @implements ICreateTagRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateTagRequest=} [properties] Properties to set
                     */
                    function CreateTagRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTagRequest tag.
                     * @member {palexy.task_management.v1.ITag|null|undefined} tag
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @instance
                     */
                    CreateTagRequest.prototype.tag = null;
    
                    /**
                     * Creates a new CreateTagRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTagRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateTagRequest} CreateTagRequest instance
                     */
                    CreateTagRequest.create = function create(properties) {
                        return new CreateTagRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTagRequest message. Does not implicitly {@link palexy.task_management.v1.CreateTagRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTagRequest} message CreateTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTagRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
                            $root.palexy.task_management.v1.Tag.encode(message.tag, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTagRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateTagRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTagRequest} message CreateTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTagRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTagRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateTagRequest} CreateTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTagRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateTagRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.tag = $root.palexy.task_management.v1.Tag.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTagRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateTagRequest} CreateTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTagRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTagRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTagRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tag != null && message.hasOwnProperty("tag")) {
                            var error = $root.palexy.task_management.v1.Tag.verify(message.tag);
                            if (error)
                                return "tag." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTagRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateTagRequest} CreateTagRequest
                     */
                    CreateTagRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateTagRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateTagRequest();
                        if (object.tag != null) {
                            if (typeof object.tag !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateTagRequest.tag: object expected");
                            message.tag = $root.palexy.task_management.v1.Tag.fromObject(object.tag);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTagRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateTagRequest} message CreateTagRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTagRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.tag = null;
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            object.tag = $root.palexy.task_management.v1.Tag.toObject(message.tag, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTagRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateTagRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTagRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTagRequest;
                })();
    
                v1.UpdateTagRequest = (function() {
    
                    /**
                     * Properties of an UpdateTagRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateTagRequest
                     * @property {palexy.task_management.v1.ITag|null} [tag] UpdateTagRequest tag
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateTagRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateTagRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateTagRequest.
                     * @implements IUpdateTagRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateTagRequest=} [properties] Properties to set
                     */
                    function UpdateTagRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateTagRequest tag.
                     * @member {palexy.task_management.v1.ITag|null|undefined} tag
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @instance
                     */
                    UpdateTagRequest.prototype.tag = null;
    
                    /**
                     * UpdateTagRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @instance
                     */
                    UpdateTagRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateTagRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTagRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateTagRequest} UpdateTagRequest instance
                     */
                    UpdateTagRequest.create = function create(properties) {
                        return new UpdateTagRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateTagRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateTagRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTagRequest} message UpdateTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTagRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tag != null && Object.hasOwnProperty.call(message, "tag"))
                            $root.palexy.task_management.v1.Tag.encode(message.tag, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateTagRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateTagRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTagRequest} message UpdateTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTagRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateTagRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateTagRequest} UpdateTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTagRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateTagRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.tag = $root.palexy.task_management.v1.Tag.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateTagRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateTagRequest} UpdateTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTagRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateTagRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateTagRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tag != null && message.hasOwnProperty("tag")) {
                            var error = $root.palexy.task_management.v1.Tag.verify(message.tag);
                            if (error)
                                return "tag." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateTagRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateTagRequest} UpdateTagRequest
                     */
                    UpdateTagRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateTagRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateTagRequest();
                        if (object.tag != null) {
                            if (typeof object.tag !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTagRequest.tag: object expected");
                            message.tag = $root.palexy.task_management.v1.Tag.fromObject(object.tag);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTagRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateTagRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateTagRequest} message UpdateTagRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateTagRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.tag = null;
                            object.updateMask = null;
                        }
                        if (message.tag != null && message.hasOwnProperty("tag"))
                            object.tag = $root.palexy.task_management.v1.Tag.toObject(message.tag, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateTagRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateTagRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateTagRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateTagRequest;
                })();
    
                v1.DeleteTagRequest = (function() {
    
                    /**
                     * Properties of a DeleteTagRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteTagRequest
                     * @property {number|null} [id] DeleteTagRequest id
                     */
    
                    /**
                     * Constructs a new DeleteTagRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteTagRequest.
                     * @implements IDeleteTagRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteTagRequest=} [properties] Properties to set
                     */
                    function DeleteTagRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTagRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @instance
                     */
                    DeleteTagRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteTagRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTagRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteTagRequest} DeleteTagRequest instance
                     */
                    DeleteTagRequest.create = function create(properties) {
                        return new DeleteTagRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTagRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteTagRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTagRequest} message DeleteTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTagRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTagRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteTagRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTagRequest} message DeleteTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTagRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTagRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteTagRequest} DeleteTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTagRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteTagRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTagRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteTagRequest} DeleteTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTagRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTagRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTagRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTagRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteTagRequest} DeleteTagRequest
                     */
                    DeleteTagRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteTagRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteTagRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTagRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteTagRequest} message DeleteTagRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTagRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTagRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteTagRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTagRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTagRequest;
                })();
    
                v1.GetTagRequest = (function() {
    
                    /**
                     * Properties of a GetTagRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetTagRequest
                     * @property {number|null} [id] GetTagRequest id
                     */
    
                    /**
                     * Constructs a new GetTagRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetTagRequest.
                     * @implements IGetTagRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetTagRequest=} [properties] Properties to set
                     */
                    function GetTagRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTagRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @instance
                     */
                    GetTagRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetTagRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTagRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetTagRequest} GetTagRequest instance
                     */
                    GetTagRequest.create = function create(properties) {
                        return new GetTagRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetTagRequest message. Does not implicitly {@link palexy.task_management.v1.GetTagRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTagRequest} message GetTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTagRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTagRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetTagRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTagRequest} message GetTagRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTagRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTagRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetTagRequest} GetTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTagRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetTagRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTagRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetTagRequest} GetTagRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTagRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTagRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTagRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetTagRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetTagRequest} GetTagRequest
                     */
                    GetTagRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetTagRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetTagRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTagRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @static
                     * @param {palexy.task_management.v1.GetTagRequest} message GetTagRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTagRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetTagRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetTagRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTagRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTagRequest;
                })();
    
                v1.ListTasksRequest = (function() {
    
                    /**
                     * Properties of a ListTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListTasksRequest
                     * @property {number|null} [pageSize] ListTasksRequest pageSize
                     * @property {string|null} [pageToken] ListTasksRequest pageToken
                     * @property {palexy.task_management.v1.ITaskFilter|null} [taskFilter] ListTasksRequest taskFilter
                     * @property {boolean|null} [embedSubtasks] ListTasksRequest embedSubtasks
                     */
    
                    /**
                     * Constructs a new ListTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTasksRequest.
                     * @implements IListTasksRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListTasksRequest=} [properties] Properties to set
                     */
                    function ListTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTasksRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.pageSize = 0;
    
                    /**
                     * ListTasksRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.pageToken = "";
    
                    /**
                     * ListTasksRequest taskFilter.
                     * @member {palexy.task_management.v1.ITaskFilter|null|undefined} taskFilter
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.taskFilter = null;
    
                    /**
                     * ListTasksRequest embedSubtasks.
                     * @member {boolean} embedSubtasks
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @instance
                     */
                    ListTasksRequest.prototype.embedSubtasks = false;
    
                    /**
                     * Creates a new ListTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTasksRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTasksRequest} ListTasksRequest instance
                     */
                    ListTasksRequest.create = function create(properties) {
                        return new ListTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTasksRequest message. Does not implicitly {@link palexy.task_management.v1.ListTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTasksRequest} message ListTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.taskFilter != null && Object.hasOwnProperty.call(message, "taskFilter"))
                            $root.palexy.task_management.v1.TaskFilter.encode(message.taskFilter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.embedSubtasks != null && Object.hasOwnProperty.call(message, "embedSubtasks"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.embedSubtasks);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTasksRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTasksRequest} message ListTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTasksRequest} ListTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.taskFilter = $root.palexy.task_management.v1.TaskFilter.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.embedSubtasks = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTasksRequest} ListTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTasksRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.taskFilter != null && message.hasOwnProperty("taskFilter")) {
                            var error = $root.palexy.task_management.v1.TaskFilter.verify(message.taskFilter);
                            if (error)
                                return "taskFilter." + error;
                        }
                        if (message.embedSubtasks != null && message.hasOwnProperty("embedSubtasks"))
                            if (typeof message.embedSubtasks !== "boolean")
                                return "embedSubtasks: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTasksRequest} ListTasksRequest
                     */
                    ListTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTasksRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTasksRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.taskFilter != null) {
                            if (typeof object.taskFilter !== "object")
                                throw TypeError(".palexy.task_management.v1.ListTasksRequest.taskFilter: object expected");
                            message.taskFilter = $root.palexy.task_management.v1.TaskFilter.fromObject(object.taskFilter);
                        }
                        if (object.embedSubtasks != null)
                            message.embedSubtasks = Boolean(object.embedSubtasks);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.ListTasksRequest} message ListTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.taskFilter = null;
                            object.embedSubtasks = false;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.taskFilter != null && message.hasOwnProperty("taskFilter"))
                            object.taskFilter = $root.palexy.task_management.v1.TaskFilter.toObject(message.taskFilter, options);
                        if (message.embedSubtasks != null && message.hasOwnProperty("embedSubtasks"))
                            object.embedSubtasks = message.embedSubtasks;
                        return object;
                    };
    
                    /**
                     * Converts this ListTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTasksRequest;
                })();
    
                v1.TaskFilter = (function() {
    
                    /**
                     * Properties of a TaskFilter.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskFilter
                     * @property {number|null} [projectId] TaskFilter projectId
                     * @property {number|null} [masterTaskId] TaskFilter masterTaskId
                     * @property {number|null} [parentTaskId] TaskFilter parentTaskId
                     * @property {palexy.task_management.v1.Task.TaskState|null} [taskState] TaskFilter taskState
                     * @property {palexy.streaming.v1.IDateTimeRange|null} [dateRange] TaskFilter dateRange
                     * @property {boolean|null} [includeSubtasks] TaskFilter includeSubtasks
                     * @property {number|null} [assigneeUserId] TaskFilter assigneeUserId
                     * @property {number|null} [companyId] TaskFilter companyId
                     * @property {Array.<number>|null} [assigneeStoreIds] TaskFilter assigneeStoreIds
                     * @property {palexy.task_management.v1.Task.TaskType|null} [taskType] TaskFilter taskType
                     * @property {Array.<palexy.task_management.v1.Task.TaskState>|null} [taskStates] TaskFilter taskStates
                     * @property {google.protobuf.IBoolValue|null} [isCompleted] TaskFilter isCompleted
                     * @property {Array.<string>|null} [sortFieldPaths] TaskFilter sortFieldPaths
                     */
    
                    /**
                     * Constructs a new TaskFilter.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskFilter.
                     * @implements ITaskFilter
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskFilter=} [properties] Properties to set
                     */
                    function TaskFilter(properties) {
                        this.assigneeStoreIds = [];
                        this.taskStates = [];
                        this.sortFieldPaths = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskFilter projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter masterTaskId.
                     * @member {number} masterTaskId
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.masterTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter parentTaskId.
                     * @member {number} parentTaskId
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.parentTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter taskState.
                     * @member {palexy.task_management.v1.Task.TaskState} taskState
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.taskState = 0;
    
                    /**
                     * TaskFilter dateRange.
                     * @member {palexy.streaming.v1.IDateTimeRange|null|undefined} dateRange
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.dateRange = null;
    
                    /**
                     * TaskFilter includeSubtasks.
                     * @member {boolean} includeSubtasks
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.includeSubtasks = false;
    
                    /**
                     * TaskFilter assigneeUserId.
                     * @member {number} assigneeUserId
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.assigneeUserId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFilter assigneeStoreIds.
                     * @member {Array.<number>} assigneeStoreIds
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.assigneeStoreIds = $util.emptyArray;
    
                    /**
                     * TaskFilter taskType.
                     * @member {palexy.task_management.v1.Task.TaskType} taskType
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.taskType = 0;
    
                    /**
                     * TaskFilter taskStates.
                     * @member {Array.<palexy.task_management.v1.Task.TaskState>} taskStates
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.taskStates = $util.emptyArray;
    
                    /**
                     * TaskFilter isCompleted.
                     * @member {google.protobuf.IBoolValue|null|undefined} isCompleted
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.isCompleted = null;
    
                    /**
                     * TaskFilter sortFieldPaths.
                     * @member {Array.<string>} sortFieldPaths
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     */
                    TaskFilter.prototype.sortFieldPaths = $util.emptyArray;
    
                    /**
                     * Creates a new TaskFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {palexy.task_management.v1.ITaskFilter=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskFilter} TaskFilter instance
                     */
                    TaskFilter.create = function create(properties) {
                        return new TaskFilter(properties);
                    };
    
                    /**
                     * Encodes the specified TaskFilter message. Does not implicitly {@link palexy.task_management.v1.TaskFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {palexy.task_management.v1.ITaskFilter} message TaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.masterTaskId != null && Object.hasOwnProperty.call(message, "masterTaskId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.masterTaskId);
                        if (message.parentTaskId != null && Object.hasOwnProperty.call(message, "parentTaskId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.parentTaskId);
                        if (message.taskState != null && Object.hasOwnProperty.call(message, "taskState"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.taskState);
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateTimeRange.encode(message.dateRange, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.includeSubtasks != null && Object.hasOwnProperty.call(message, "includeSubtasks"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeSubtasks);
                        if (message.assigneeUserId != null && Object.hasOwnProperty.call(message, "assigneeUserId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.assigneeUserId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.companyId);
                        if (message.assigneeStoreIds != null && message.assigneeStoreIds.length) {
                            writer.uint32(/* id 9, wireType 2 =*/74).fork();
                            for (var i = 0; i < message.assigneeStoreIds.length; ++i)
                                writer.int64(message.assigneeStoreIds[i]);
                            writer.ldelim();
                        }
                        if (message.taskType != null && Object.hasOwnProperty.call(message, "taskType"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.taskType);
                        if (message.taskStates != null && message.taskStates.length) {
                            writer.uint32(/* id 11, wireType 2 =*/90).fork();
                            for (var i = 0; i < message.taskStates.length; ++i)
                                writer.int32(message.taskStates[i]);
                            writer.ldelim();
                        }
                        if (message.isCompleted != null && Object.hasOwnProperty.call(message, "isCompleted"))
                            $root.google.protobuf.BoolValue.encode(message.isCompleted, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.sortFieldPaths != null && message.sortFieldPaths.length)
                            for (var i = 0; i < message.sortFieldPaths.length; ++i)
                                writer.uint32(/* id 13, wireType 2 =*/106).string(message.sortFieldPaths[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskFilter message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {palexy.task_management.v1.ITaskFilter} message TaskFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskFilter} TaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.masterTaskId = reader.int64();
                                break;
                            case 3:
                                message.parentTaskId = reader.int64();
                                break;
                            case 4:
                                message.taskState = reader.int32();
                                break;
                            case 5:
                                message.dateRange = $root.palexy.streaming.v1.DateTimeRange.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.includeSubtasks = reader.bool();
                                break;
                            case 7:
                                message.assigneeUserId = reader.int64();
                                break;
                            case 8:
                                message.companyId = reader.int64();
                                break;
                            case 9:
                                if (!(message.assigneeStoreIds && message.assigneeStoreIds.length))
                                    message.assigneeStoreIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.assigneeStoreIds.push(reader.int64());
                                } else
                                    message.assigneeStoreIds.push(reader.int64());
                                break;
                            case 10:
                                message.taskType = reader.int32();
                                break;
                            case 11:
                                if (!(message.taskStates && message.taskStates.length))
                                    message.taskStates = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.taskStates.push(reader.int32());
                                } else
                                    message.taskStates.push(reader.int32());
                                break;
                            case 12:
                                message.isCompleted = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 13:
                                if (!(message.sortFieldPaths && message.sortFieldPaths.length))
                                    message.sortFieldPaths = [];
                                message.sortFieldPaths.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskFilter} TaskFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskFilter message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (!$util.isInteger(message.masterTaskId) && !(message.masterTaskId && $util.isInteger(message.masterTaskId.low) && $util.isInteger(message.masterTaskId.high)))
                                return "masterTaskId: integer|Long expected";
                        if (message.parentTaskId != null && message.hasOwnProperty("parentTaskId"))
                            if (!$util.isInteger(message.parentTaskId) && !(message.parentTaskId && $util.isInteger(message.parentTaskId.low) && $util.isInteger(message.parentTaskId.high)))
                                return "parentTaskId: integer|Long expected";
                        if (message.taskState != null && message.hasOwnProperty("taskState"))
                            switch (message.taskState) {
                            default:
                                return "taskState: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateTimeRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        if (message.includeSubtasks != null && message.hasOwnProperty("includeSubtasks"))
                            if (typeof message.includeSubtasks !== "boolean")
                                return "includeSubtasks: boolean expected";
                        if (message.assigneeUserId != null && message.hasOwnProperty("assigneeUserId"))
                            if (!$util.isInteger(message.assigneeUserId) && !(message.assigneeUserId && $util.isInteger(message.assigneeUserId.low) && $util.isInteger(message.assigneeUserId.high)))
                                return "assigneeUserId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.assigneeStoreIds != null && message.hasOwnProperty("assigneeStoreIds")) {
                            if (!Array.isArray(message.assigneeStoreIds))
                                return "assigneeStoreIds: array expected";
                            for (var i = 0; i < message.assigneeStoreIds.length; ++i)
                                if (!$util.isInteger(message.assigneeStoreIds[i]) && !(message.assigneeStoreIds[i] && $util.isInteger(message.assigneeStoreIds[i].low) && $util.isInteger(message.assigneeStoreIds[i].high)))
                                    return "assigneeStoreIds: integer|Long[] expected";
                        }
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            switch (message.taskType) {
                            default:
                                return "taskType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.taskStates != null && message.hasOwnProperty("taskStates")) {
                            if (!Array.isArray(message.taskStates))
                                return "taskStates: array expected";
                            for (var i = 0; i < message.taskStates.length; ++i)
                                switch (message.taskStates[i]) {
                                default:
                                    return "taskStates: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                        }
                        if (message.isCompleted != null && message.hasOwnProperty("isCompleted")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isCompleted);
                            if (error)
                                return "isCompleted." + error;
                        }
                        if (message.sortFieldPaths != null && message.hasOwnProperty("sortFieldPaths")) {
                            if (!Array.isArray(message.sortFieldPaths))
                                return "sortFieldPaths: array expected";
                            for (var i = 0; i < message.sortFieldPaths.length; ++i)
                                if (!$util.isString(message.sortFieldPaths[i]))
                                    return "sortFieldPaths: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TaskFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskFilter} TaskFilter
                     */
                    TaskFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskFilter)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskFilter();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.masterTaskId != null)
                            if ($util.Long)
                                (message.masterTaskId = $util.Long.fromValue(object.masterTaskId)).unsigned = false;
                            else if (typeof object.masterTaskId === "string")
                                message.masterTaskId = parseInt(object.masterTaskId, 10);
                            else if (typeof object.masterTaskId === "number")
                                message.masterTaskId = object.masterTaskId;
                            else if (typeof object.masterTaskId === "object")
                                message.masterTaskId = new $util.LongBits(object.masterTaskId.low >>> 0, object.masterTaskId.high >>> 0).toNumber();
                        if (object.parentTaskId != null)
                            if ($util.Long)
                                (message.parentTaskId = $util.Long.fromValue(object.parentTaskId)).unsigned = false;
                            else if (typeof object.parentTaskId === "string")
                                message.parentTaskId = parseInt(object.parentTaskId, 10);
                            else if (typeof object.parentTaskId === "number")
                                message.parentTaskId = object.parentTaskId;
                            else if (typeof object.parentTaskId === "object")
                                message.parentTaskId = new $util.LongBits(object.parentTaskId.low >>> 0, object.parentTaskId.high >>> 0).toNumber();
                        switch (object.taskState) {
                        case "TASK_STATE_UNSPECIFIED":
                        case 0:
                            message.taskState = 0;
                            break;
                        case "DRAFT":
                        case 1:
                            message.taskState = 1;
                            break;
                        case "PUBLISHED":
                        case 2:
                            message.taskState = 2;
                            break;
                        case "ARCHIVED":
                        case 3:
                            message.taskState = 3;
                            break;
                        }
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.task_management.v1.TaskFilter.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateTimeRange.fromObject(object.dateRange);
                        }
                        if (object.includeSubtasks != null)
                            message.includeSubtasks = Boolean(object.includeSubtasks);
                        if (object.assigneeUserId != null)
                            if ($util.Long)
                                (message.assigneeUserId = $util.Long.fromValue(object.assigneeUserId)).unsigned = false;
                            else if (typeof object.assigneeUserId === "string")
                                message.assigneeUserId = parseInt(object.assigneeUserId, 10);
                            else if (typeof object.assigneeUserId === "number")
                                message.assigneeUserId = object.assigneeUserId;
                            else if (typeof object.assigneeUserId === "object")
                                message.assigneeUserId = new $util.LongBits(object.assigneeUserId.low >>> 0, object.assigneeUserId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.assigneeStoreIds) {
                            if (!Array.isArray(object.assigneeStoreIds))
                                throw TypeError(".palexy.task_management.v1.TaskFilter.assigneeStoreIds: array expected");
                            message.assigneeStoreIds = [];
                            for (var i = 0; i < object.assigneeStoreIds.length; ++i)
                                if ($util.Long)
                                    (message.assigneeStoreIds[i] = $util.Long.fromValue(object.assigneeStoreIds[i])).unsigned = false;
                                else if (typeof object.assigneeStoreIds[i] === "string")
                                    message.assigneeStoreIds[i] = parseInt(object.assigneeStoreIds[i], 10);
                                else if (typeof object.assigneeStoreIds[i] === "number")
                                    message.assigneeStoreIds[i] = object.assigneeStoreIds[i];
                                else if (typeof object.assigneeStoreIds[i] === "object")
                                    message.assigneeStoreIds[i] = new $util.LongBits(object.assigneeStoreIds[i].low >>> 0, object.assigneeStoreIds[i].high >>> 0).toNumber();
                        }
                        switch (object.taskType) {
                        case "TASK_TYPE_UNSPECIFIED":
                        case 0:
                            message.taskType = 0;
                            break;
                        case "NORMAL":
                        case 1:
                            message.taskType = 1;
                            break;
                        case "MASTER":
                        case 2:
                            message.taskType = 2;
                            break;
                        }
                        if (object.taskStates) {
                            if (!Array.isArray(object.taskStates))
                                throw TypeError(".palexy.task_management.v1.TaskFilter.taskStates: array expected");
                            message.taskStates = [];
                            for (var i = 0; i < object.taskStates.length; ++i)
                                switch (object.taskStates[i]) {
                                default:
                                case "TASK_STATE_UNSPECIFIED":
                                case 0:
                                    message.taskStates[i] = 0;
                                    break;
                                case "DRAFT":
                                case 1:
                                    message.taskStates[i] = 1;
                                    break;
                                case "PUBLISHED":
                                case 2:
                                    message.taskStates[i] = 2;
                                    break;
                                case "ARCHIVED":
                                case 3:
                                    message.taskStates[i] = 3;
                                    break;
                                }
                        }
                        if (object.isCompleted != null) {
                            if (typeof object.isCompleted !== "object")
                                throw TypeError(".palexy.task_management.v1.TaskFilter.isCompleted: object expected");
                            message.isCompleted = $root.google.protobuf.BoolValue.fromObject(object.isCompleted);
                        }
                        if (object.sortFieldPaths) {
                            if (!Array.isArray(object.sortFieldPaths))
                                throw TypeError(".palexy.task_management.v1.TaskFilter.sortFieldPaths: array expected");
                            message.sortFieldPaths = [];
                            for (var i = 0; i < object.sortFieldPaths.length; ++i)
                                message.sortFieldPaths[i] = String(object.sortFieldPaths[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @static
                     * @param {palexy.task_management.v1.TaskFilter} message TaskFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.assigneeStoreIds = [];
                            object.taskStates = [];
                            object.sortFieldPaths = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.masterTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.masterTaskId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.parentTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.parentTaskId = options.longs === String ? "0" : 0;
                            object.taskState = options.enums === String ? "TASK_STATE_UNSPECIFIED" : 0;
                            object.dateRange = null;
                            object.includeSubtasks = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.assigneeUserId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.assigneeUserId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.taskType = options.enums === String ? "TASK_TYPE_UNSPECIFIED" : 0;
                            object.isCompleted = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (typeof message.masterTaskId === "number")
                                object.masterTaskId = options.longs === String ? String(message.masterTaskId) : message.masterTaskId;
                            else
                                object.masterTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.masterTaskId) : options.longs === Number ? new $util.LongBits(message.masterTaskId.low >>> 0, message.masterTaskId.high >>> 0).toNumber() : message.masterTaskId;
                        if (message.parentTaskId != null && message.hasOwnProperty("parentTaskId"))
                            if (typeof message.parentTaskId === "number")
                                object.parentTaskId = options.longs === String ? String(message.parentTaskId) : message.parentTaskId;
                            else
                                object.parentTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.parentTaskId) : options.longs === Number ? new $util.LongBits(message.parentTaskId.low >>> 0, message.parentTaskId.high >>> 0).toNumber() : message.parentTaskId;
                        if (message.taskState != null && message.hasOwnProperty("taskState"))
                            object.taskState = options.enums === String ? $root.palexy.task_management.v1.Task.TaskState[message.taskState] : message.taskState;
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateTimeRange.toObject(message.dateRange, options);
                        if (message.includeSubtasks != null && message.hasOwnProperty("includeSubtasks"))
                            object.includeSubtasks = message.includeSubtasks;
                        if (message.assigneeUserId != null && message.hasOwnProperty("assigneeUserId"))
                            if (typeof message.assigneeUserId === "number")
                                object.assigneeUserId = options.longs === String ? String(message.assigneeUserId) : message.assigneeUserId;
                            else
                                object.assigneeUserId = options.longs === String ? $util.Long.prototype.toString.call(message.assigneeUserId) : options.longs === Number ? new $util.LongBits(message.assigneeUserId.low >>> 0, message.assigneeUserId.high >>> 0).toNumber() : message.assigneeUserId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.assigneeStoreIds && message.assigneeStoreIds.length) {
                            object.assigneeStoreIds = [];
                            for (var j = 0; j < message.assigneeStoreIds.length; ++j)
                                if (typeof message.assigneeStoreIds[j] === "number")
                                    object.assigneeStoreIds[j] = options.longs === String ? String(message.assigneeStoreIds[j]) : message.assigneeStoreIds[j];
                                else
                                    object.assigneeStoreIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.assigneeStoreIds[j]) : options.longs === Number ? new $util.LongBits(message.assigneeStoreIds[j].low >>> 0, message.assigneeStoreIds[j].high >>> 0).toNumber() : message.assigneeStoreIds[j];
                        }
                        if (message.taskType != null && message.hasOwnProperty("taskType"))
                            object.taskType = options.enums === String ? $root.palexy.task_management.v1.Task.TaskType[message.taskType] : message.taskType;
                        if (message.taskStates && message.taskStates.length) {
                            object.taskStates = [];
                            for (var j = 0; j < message.taskStates.length; ++j)
                                object.taskStates[j] = options.enums === String ? $root.palexy.task_management.v1.Task.TaskState[message.taskStates[j]] : message.taskStates[j];
                        }
                        if (message.isCompleted != null && message.hasOwnProperty("isCompleted"))
                            object.isCompleted = $root.google.protobuf.BoolValue.toObject(message.isCompleted, options);
                        if (message.sortFieldPaths && message.sortFieldPaths.length) {
                            object.sortFieldPaths = [];
                            for (var j = 0; j < message.sortFieldPaths.length; ++j)
                                object.sortFieldPaths[j] = message.sortFieldPaths[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TaskFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskFilter;
                })();
    
                v1.ListTasksResponse = (function() {
    
                    /**
                     * Properties of a ListTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListTasksResponse
                     * @property {Array.<palexy.task_management.v1.ITask>|null} [tasks] ListTasksResponse tasks
                     * @property {string|null} [nextPageToken] ListTasksResponse nextPageToken
                     * @property {number|null} [totalElements] ListTasksResponse totalElements
                     */
    
                    /**
                     * Constructs a new ListTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTasksResponse.
                     * @implements IListTasksResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListTasksResponse=} [properties] Properties to set
                     */
                    function ListTasksResponse(properties) {
                        this.tasks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTasksResponse tasks.
                     * @member {Array.<palexy.task_management.v1.ITask>} tasks
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.tasks = $util.emptyArray;
    
                    /**
                     * ListTasksResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListTasksResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @instance
                     */
                    ListTasksResponse.prototype.totalElements = 0;
    
                    /**
                     * Creates a new ListTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTasksResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTasksResponse} ListTasksResponse instance
                     */
                    ListTasksResponse.create = function create(properties) {
                        return new ListTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTasksResponse message. Does not implicitly {@link palexy.task_management.v1.ListTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTasksResponse} message ListTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tasks != null && message.tasks.length)
                            for (var i = 0; i < message.tasks.length; ++i)
                                $root.palexy.task_management.v1.Task.encode(message.tasks[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalElements);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTasksResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTasksResponse} message ListTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTasksResponse} ListTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tasks && message.tasks.length))
                                    message.tasks = [];
                                message.tasks.push($root.palexy.task_management.v1.Task.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalElements = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTasksResponse} ListTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTasksResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tasks != null && message.hasOwnProperty("tasks")) {
                            if (!Array.isArray(message.tasks))
                                return "tasks: array expected";
                            for (var i = 0; i < message.tasks.length; ++i) {
                                var error = $root.palexy.task_management.v1.Task.verify(message.tasks[i]);
                                if (error)
                                    return "tasks." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTasksResponse} ListTasksResponse
                     */
                    ListTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTasksResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTasksResponse();
                        if (object.tasks) {
                            if (!Array.isArray(object.tasks))
                                throw TypeError(".palexy.task_management.v1.ListTasksResponse.tasks: array expected");
                            message.tasks = [];
                            for (var i = 0; i < object.tasks.length; ++i) {
                                if (typeof object.tasks[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListTasksResponse.tasks: object expected");
                                message.tasks[i] = $root.palexy.task_management.v1.Task.fromObject(object.tasks[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.ListTasksResponse} message ListTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tasks = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            object.totalElements = 0;
                        }
                        if (message.tasks && message.tasks.length) {
                            object.tasks = [];
                            for (var j = 0; j < message.tasks.length; ++j)
                                object.tasks[j] = $root.palexy.task_management.v1.Task.toObject(message.tasks[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        return object;
                    };
    
                    /**
                     * Converts this ListTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTasksResponse;
                })();
    
                v1.CreateTaskRequest = (function() {
    
                    /**
                     * Properties of a CreateTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateTaskRequest
                     * @property {palexy.task_management.v1.ITask|null} [task] CreateTaskRequest task
                     */
    
                    /**
                     * Constructs a new CreateTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateTaskRequest.
                     * @implements ICreateTaskRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateTaskRequest=} [properties] Properties to set
                     */
                    function CreateTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTaskRequest task.
                     * @member {palexy.task_management.v1.ITask|null|undefined} task
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @instance
                     */
                    CreateTaskRequest.prototype.task = null;
    
                    /**
                     * Creates a new CreateTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateTaskRequest} CreateTaskRequest instance
                     */
                    CreateTaskRequest.create = function create(properties) {
                        return new CreateTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTaskRequest message. Does not implicitly {@link palexy.task_management.v1.CreateTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskRequest} message CreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            $root.palexy.task_management.v1.Task.encode(message.task, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTaskRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskRequest} message CreateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateTaskRequest} CreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = $root.palexy.task_management.v1.Task.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateTaskRequest} CreateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTaskRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task")) {
                            var error = $root.palexy.task_management.v1.Task.verify(message.task);
                            if (error)
                                return "task." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateTaskRequest} CreateTaskRequest
                     */
                    CreateTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateTaskRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateTaskRequest();
                        if (object.task != null) {
                            if (typeof object.task !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateTaskRequest.task: object expected");
                            message.task = $root.palexy.task_management.v1.Task.fromObject(object.task);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateTaskRequest} message CreateTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.task = null;
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = $root.palexy.task_management.v1.Task.toObject(message.task, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTaskRequest;
                })();
    
                v1.UpdateTaskRequest = (function() {
    
                    /**
                     * Properties of an UpdateTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateTaskRequest
                     * @property {palexy.task_management.v1.ITask|null} [task] UpdateTaskRequest task
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateTaskRequest updateMask
                     * @property {number|null} [actingAccountId] UpdateTaskRequest actingAccountId
                     */
    
                    /**
                     * Constructs a new UpdateTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateTaskRequest.
                     * @implements IUpdateTaskRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateTaskRequest=} [properties] Properties to set
                     */
                    function UpdateTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateTaskRequest task.
                     * @member {palexy.task_management.v1.ITask|null|undefined} task
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @instance
                     */
                    UpdateTaskRequest.prototype.task = null;
    
                    /**
                     * UpdateTaskRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @instance
                     */
                    UpdateTaskRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateTaskRequest actingAccountId.
                     * @member {number} actingAccountId
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @instance
                     */
                    UpdateTaskRequest.prototype.actingAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new UpdateTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateTaskRequest} UpdateTaskRequest instance
                     */
                    UpdateTaskRequest.create = function create(properties) {
                        return new UpdateTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateTaskRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskRequest} message UpdateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.task != null && Object.hasOwnProperty.call(message, "task"))
                            $root.palexy.task_management.v1.Task.encode(message.task, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.actingAccountId != null && Object.hasOwnProperty.call(message, "actingAccountId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.actingAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateTaskRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskRequest} message UpdateTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateTaskRequest} UpdateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.task = $root.palexy.task_management.v1.Task.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.actingAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateTaskRequest} UpdateTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateTaskRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.task != null && message.hasOwnProperty("task")) {
                            var error = $root.palexy.task_management.v1.Task.verify(message.task);
                            if (error)
                                return "task." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (!$util.isInteger(message.actingAccountId) && !(message.actingAccountId && $util.isInteger(message.actingAccountId.low) && $util.isInteger(message.actingAccountId.high)))
                                return "actingAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateTaskRequest} UpdateTaskRequest
                     */
                    UpdateTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateTaskRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateTaskRequest();
                        if (object.task != null) {
                            if (typeof object.task !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTaskRequest.task: object expected");
                            message.task = $root.palexy.task_management.v1.Task.fromObject(object.task);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTaskRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.actingAccountId != null)
                            if ($util.Long)
                                (message.actingAccountId = $util.Long.fromValue(object.actingAccountId)).unsigned = false;
                            else if (typeof object.actingAccountId === "string")
                                message.actingAccountId = parseInt(object.actingAccountId, 10);
                            else if (typeof object.actingAccountId === "number")
                                message.actingAccountId = object.actingAccountId;
                            else if (typeof object.actingAccountId === "object")
                                message.actingAccountId = new $util.LongBits(object.actingAccountId.low >>> 0, object.actingAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateTaskRequest} message UpdateTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.task = null;
                            object.updateMask = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.actingAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.actingAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.task != null && message.hasOwnProperty("task"))
                            object.task = $root.palexy.task_management.v1.Task.toObject(message.task, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (typeof message.actingAccountId === "number")
                                object.actingAccountId = options.longs === String ? String(message.actingAccountId) : message.actingAccountId;
                            else
                                object.actingAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.actingAccountId) : options.longs === Number ? new $util.LongBits(message.actingAccountId.low >>> 0, message.actingAccountId.high >>> 0).toNumber() : message.actingAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateTaskRequest;
                })();
    
                v1.DeleteTaskRequest = (function() {
    
                    /**
                     * Properties of a DeleteTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteTaskRequest
                     * @property {number|null} [id] DeleteTaskRequest id
                     * @property {number|null} [actingAccountId] DeleteTaskRequest actingAccountId
                     */
    
                    /**
                     * Constructs a new DeleteTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteTaskRequest.
                     * @implements IDeleteTaskRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteTaskRequest=} [properties] Properties to set
                     */
                    function DeleteTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTaskRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @instance
                     */
                    DeleteTaskRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteTaskRequest actingAccountId.
                     * @member {number} actingAccountId
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @instance
                     */
                    DeleteTaskRequest.prototype.actingAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteTaskRequest} DeleteTaskRequest instance
                     */
                    DeleteTaskRequest.create = function create(properties) {
                        return new DeleteTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTaskRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskRequest} message DeleteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.actingAccountId != null && Object.hasOwnProperty.call(message, "actingAccountId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.actingAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTaskRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskRequest} message DeleteTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteTaskRequest} DeleteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.actingAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteTaskRequest} DeleteTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTaskRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (!$util.isInteger(message.actingAccountId) && !(message.actingAccountId && $util.isInteger(message.actingAccountId.low) && $util.isInteger(message.actingAccountId.high)))
                                return "actingAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteTaskRequest} DeleteTaskRequest
                     */
                    DeleteTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteTaskRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteTaskRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.actingAccountId != null)
                            if ($util.Long)
                                (message.actingAccountId = $util.Long.fromValue(object.actingAccountId)).unsigned = false;
                            else if (typeof object.actingAccountId === "string")
                                message.actingAccountId = parseInt(object.actingAccountId, 10);
                            else if (typeof object.actingAccountId === "number")
                                message.actingAccountId = object.actingAccountId;
                            else if (typeof object.actingAccountId === "object")
                                message.actingAccountId = new $util.LongBits(object.actingAccountId.low >>> 0, object.actingAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteTaskRequest} message DeleteTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.actingAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.actingAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (typeof message.actingAccountId === "number")
                                object.actingAccountId = options.longs === String ? String(message.actingAccountId) : message.actingAccountId;
                            else
                                object.actingAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.actingAccountId) : options.longs === Number ? new $util.LongBits(message.actingAccountId.low >>> 0, message.actingAccountId.high >>> 0).toNumber() : message.actingAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTaskRequest;
                })();
    
                v1.PublishTaskRequest = (function() {
    
                    /**
                     * Properties of a PublishTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IPublishTaskRequest
                     * @property {number|null} [id] PublishTaskRequest id
                     */
    
                    /**
                     * Constructs a new PublishTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a PublishTaskRequest.
                     * @implements IPublishTaskRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IPublishTaskRequest=} [properties] Properties to set
                     */
                    function PublishTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PublishTaskRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @instance
                     */
                    PublishTaskRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new PublishTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IPublishTaskRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.PublishTaskRequest} PublishTaskRequest instance
                     */
                    PublishTaskRequest.create = function create(properties) {
                        return new PublishTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified PublishTaskRequest message. Does not implicitly {@link palexy.task_management.v1.PublishTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IPublishTaskRequest} message PublishTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PublishTaskRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.PublishTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IPublishTaskRequest} message PublishTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PublishTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.PublishTaskRequest} PublishTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.PublishTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PublishTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.PublishTaskRequest} PublishTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PublishTaskRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PublishTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a PublishTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.PublishTaskRequest} PublishTaskRequest
                     */
                    PublishTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.PublishTaskRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.PublishTaskRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PublishTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.PublishTaskRequest} message PublishTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PublishTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this PublishTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.PublishTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PublishTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PublishTaskRequest;
                })();
    
                v1.GetTaskRequest = (function() {
    
                    /**
                     * Properties of a GetTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetTaskRequest
                     * @property {number|null} [id] GetTaskRequest id
                     */
    
                    /**
                     * Constructs a new GetTaskRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetTaskRequest.
                     * @implements IGetTaskRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetTaskRequest=} [properties] Properties to set
                     */
                    function GetTaskRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTaskRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @instance
                     */
                    GetTaskRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetTaskRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetTaskRequest} GetTaskRequest instance
                     */
                    GetTaskRequest.create = function create(properties) {
                        return new GetTaskRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetTaskRequest message. Does not implicitly {@link palexy.task_management.v1.GetTaskRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskRequest} message GetTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTaskRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetTaskRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskRequest} message GetTaskRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTaskRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetTaskRequest} GetTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetTaskRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTaskRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetTaskRequest} GetTaskRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTaskRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTaskRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetTaskRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetTaskRequest} GetTaskRequest
                     */
                    GetTaskRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetTaskRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetTaskRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTaskRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @static
                     * @param {palexy.task_management.v1.GetTaskRequest} message GetTaskRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTaskRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetTaskRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetTaskRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTaskRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTaskRequest;
                })();
    
                v1.GenerateTasksRequest = (function() {
    
                    /**
                     * Properties of a GenerateTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGenerateTasksRequest
                     * @property {number|null} [masterTaskId] GenerateTasksRequest masterTaskId
                     */
    
                    /**
                     * Constructs a new GenerateTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GenerateTasksRequest.
                     * @implements IGenerateTasksRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGenerateTasksRequest=} [properties] Properties to set
                     */
                    function GenerateTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateTasksRequest masterTaskId.
                     * @member {number} masterTaskId
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @instance
                     */
                    GenerateTasksRequest.prototype.masterTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GenerateTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GenerateTasksRequest} GenerateTasksRequest instance
                     */
                    GenerateTasksRequest.create = function create(properties) {
                        return new GenerateTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateTasksRequest message. Does not implicitly {@link palexy.task_management.v1.GenerateTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksRequest} message GenerateTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.masterTaskId != null && Object.hasOwnProperty.call(message, "masterTaskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.masterTaskId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateTasksRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GenerateTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksRequest} message GenerateTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GenerateTasksRequest} GenerateTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GenerateTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.masterTaskId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GenerateTasksRequest} GenerateTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateTasksRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (!$util.isInteger(message.masterTaskId) && !(message.masterTaskId && $util.isInteger(message.masterTaskId.low) && $util.isInteger(message.masterTaskId.high)))
                                return "masterTaskId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GenerateTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GenerateTasksRequest} GenerateTasksRequest
                     */
                    GenerateTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GenerateTasksRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GenerateTasksRequest();
                        if (object.masterTaskId != null)
                            if ($util.Long)
                                (message.masterTaskId = $util.Long.fromValue(object.masterTaskId)).unsigned = false;
                            else if (typeof object.masterTaskId === "string")
                                message.masterTaskId = parseInt(object.masterTaskId, 10);
                            else if (typeof object.masterTaskId === "number")
                                message.masterTaskId = object.masterTaskId;
                            else if (typeof object.masterTaskId === "object")
                                message.masterTaskId = new $util.LongBits(object.masterTaskId.low >>> 0, object.masterTaskId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.GenerateTasksRequest} message GenerateTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.masterTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.masterTaskId = options.longs === String ? "0" : 0;
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (typeof message.masterTaskId === "number")
                                object.masterTaskId = options.longs === String ? String(message.masterTaskId) : message.masterTaskId;
                            else
                                object.masterTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.masterTaskId) : options.longs === Number ? new $util.LongBits(message.masterTaskId.low >>> 0, message.masterTaskId.high >>> 0).toNumber() : message.masterTaskId;
                        return object;
                    };
    
                    /**
                     * Converts this GenerateTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GenerateTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateTasksRequest;
                })();
    
                v1.GenerateTasksResponse = (function() {
    
                    /**
                     * Properties of a GenerateTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IGenerateTasksResponse
                     * @property {Array.<number>|null} [createdTaskIds] GenerateTasksResponse createdTaskIds
                     * @property {number|null} [createdCount] GenerateTasksResponse createdCount
                     * @property {number|null} [skippedCount] GenerateTasksResponse skippedCount
                     * @property {string|null} [summary] GenerateTasksResponse summary
                     */
    
                    /**
                     * Constructs a new GenerateTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GenerateTasksResponse.
                     * @implements IGenerateTasksResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IGenerateTasksResponse=} [properties] Properties to set
                     */
                    function GenerateTasksResponse(properties) {
                        this.createdTaskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateTasksResponse createdTaskIds.
                     * @member {Array.<number>} createdTaskIds
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @instance
                     */
                    GenerateTasksResponse.prototype.createdTaskIds = $util.emptyArray;
    
                    /**
                     * GenerateTasksResponse createdCount.
                     * @member {number} createdCount
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @instance
                     */
                    GenerateTasksResponse.prototype.createdCount = 0;
    
                    /**
                     * GenerateTasksResponse skippedCount.
                     * @member {number} skippedCount
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @instance
                     */
                    GenerateTasksResponse.prototype.skippedCount = 0;
    
                    /**
                     * GenerateTasksResponse summary.
                     * @member {string} summary
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @instance
                     */
                    GenerateTasksResponse.prototype.summary = "";
    
                    /**
                     * Creates a new GenerateTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GenerateTasksResponse} GenerateTasksResponse instance
                     */
                    GenerateTasksResponse.create = function create(properties) {
                        return new GenerateTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateTasksResponse message. Does not implicitly {@link palexy.task_management.v1.GenerateTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksResponse} message GenerateTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.createdTaskIds != null && message.createdTaskIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.createdTaskIds.length; ++i)
                                writer.int64(message.createdTaskIds[i]);
                            writer.ldelim();
                        }
                        if (message.createdCount != null && Object.hasOwnProperty.call(message, "createdCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.createdCount);
                        if (message.skippedCount != null && Object.hasOwnProperty.call(message, "skippedCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.skippedCount);
                        if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.summary);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateTasksResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.GenerateTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateTasksResponse} message GenerateTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GenerateTasksResponse} GenerateTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GenerateTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.createdTaskIds && message.createdTaskIds.length))
                                    message.createdTaskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.createdTaskIds.push(reader.int64());
                                } else
                                    message.createdTaskIds.push(reader.int64());
                                break;
                            case 2:
                                message.createdCount = reader.int32();
                                break;
                            case 3:
                                message.skippedCount = reader.int32();
                                break;
                            case 4:
                                message.summary = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GenerateTasksResponse} GenerateTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateTasksResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.createdTaskIds != null && message.hasOwnProperty("createdTaskIds")) {
                            if (!Array.isArray(message.createdTaskIds))
                                return "createdTaskIds: array expected";
                            for (var i = 0; i < message.createdTaskIds.length; ++i)
                                if (!$util.isInteger(message.createdTaskIds[i]) && !(message.createdTaskIds[i] && $util.isInteger(message.createdTaskIds[i].low) && $util.isInteger(message.createdTaskIds[i].high)))
                                    return "createdTaskIds: integer|Long[] expected";
                        }
                        if (message.createdCount != null && message.hasOwnProperty("createdCount"))
                            if (!$util.isInteger(message.createdCount))
                                return "createdCount: integer expected";
                        if (message.skippedCount != null && message.hasOwnProperty("skippedCount"))
                            if (!$util.isInteger(message.skippedCount))
                                return "skippedCount: integer expected";
                        if (message.summary != null && message.hasOwnProperty("summary"))
                            if (!$util.isString(message.summary))
                                return "summary: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GenerateTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GenerateTasksResponse} GenerateTasksResponse
                     */
                    GenerateTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GenerateTasksResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.GenerateTasksResponse();
                        if (object.createdTaskIds) {
                            if (!Array.isArray(object.createdTaskIds))
                                throw TypeError(".palexy.task_management.v1.GenerateTasksResponse.createdTaskIds: array expected");
                            message.createdTaskIds = [];
                            for (var i = 0; i < object.createdTaskIds.length; ++i)
                                if ($util.Long)
                                    (message.createdTaskIds[i] = $util.Long.fromValue(object.createdTaskIds[i])).unsigned = false;
                                else if (typeof object.createdTaskIds[i] === "string")
                                    message.createdTaskIds[i] = parseInt(object.createdTaskIds[i], 10);
                                else if (typeof object.createdTaskIds[i] === "number")
                                    message.createdTaskIds[i] = object.createdTaskIds[i];
                                else if (typeof object.createdTaskIds[i] === "object")
                                    message.createdTaskIds[i] = new $util.LongBits(object.createdTaskIds[i].low >>> 0, object.createdTaskIds[i].high >>> 0).toNumber();
                        }
                        if (object.createdCount != null)
                            message.createdCount = object.createdCount | 0;
                        if (object.skippedCount != null)
                            message.skippedCount = object.skippedCount | 0;
                        if (object.summary != null)
                            message.summary = String(object.summary);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.GenerateTasksResponse} message GenerateTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.createdTaskIds = [];
                        if (options.defaults) {
                            object.createdCount = 0;
                            object.skippedCount = 0;
                            object.summary = "";
                        }
                        if (message.createdTaskIds && message.createdTaskIds.length) {
                            object.createdTaskIds = [];
                            for (var j = 0; j < message.createdTaskIds.length; ++j)
                                if (typeof message.createdTaskIds[j] === "number")
                                    object.createdTaskIds[j] = options.longs === String ? String(message.createdTaskIds[j]) : message.createdTaskIds[j];
                                else
                                    object.createdTaskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.createdTaskIds[j]) : options.longs === Number ? new $util.LongBits(message.createdTaskIds[j].low >>> 0, message.createdTaskIds[j].high >>> 0).toNumber() : message.createdTaskIds[j];
                        }
                        if (message.createdCount != null && message.hasOwnProperty("createdCount"))
                            object.createdCount = message.createdCount;
                        if (message.skippedCount != null && message.hasOwnProperty("skippedCount"))
                            object.skippedCount = message.skippedCount;
                        if (message.summary != null && message.hasOwnProperty("summary"))
                            object.summary = message.summary;
                        return object;
                    };
    
                    /**
                     * Converts this GenerateTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GenerateTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateTasksResponse;
                })();
    
                v1.ListDueMasterTasksRequest = (function() {
    
                    /**
                     * Properties of a ListDueMasterTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListDueMasterTasksRequest
                     * @property {number|null} [companyId] ListDueMasterTasksRequest companyId
                     */
    
                    /**
                     * Constructs a new ListDueMasterTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListDueMasterTasksRequest.
                     * @implements IListDueMasterTasksRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest=} [properties] Properties to set
                     */
                    function ListDueMasterTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDueMasterTasksRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @instance
                     */
                    ListDueMasterTasksRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListDueMasterTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListDueMasterTasksRequest} ListDueMasterTasksRequest instance
                     */
                    ListDueMasterTasksRequest.create = function create(properties) {
                        return new ListDueMasterTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListDueMasterTasksRequest message. Does not implicitly {@link palexy.task_management.v1.ListDueMasterTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest} message ListDueMasterTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDueMasterTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDueMasterTasksRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListDueMasterTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksRequest} message ListDueMasterTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDueMasterTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDueMasterTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListDueMasterTasksRequest} ListDueMasterTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDueMasterTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListDueMasterTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDueMasterTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListDueMasterTasksRequest} ListDueMasterTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDueMasterTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDueMasterTasksRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDueMasterTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListDueMasterTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListDueMasterTasksRequest} ListDueMasterTasksRequest
                     */
                    ListDueMasterTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListDueMasterTasksRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListDueMasterTasksRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDueMasterTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.ListDueMasterTasksRequest} message ListDueMasterTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDueMasterTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListDueMasterTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListDueMasterTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDueMasterTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDueMasterTasksRequest;
                })();
    
                v1.ListDueMasterTasksResponse = (function() {
    
                    /**
                     * Properties of a ListDueMasterTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListDueMasterTasksResponse
                     * @property {Array.<number>|null} [masterTaskIds] ListDueMasterTasksResponse masterTaskIds
                     */
    
                    /**
                     * Constructs a new ListDueMasterTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListDueMasterTasksResponse.
                     * @implements IListDueMasterTasksResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListDueMasterTasksResponse=} [properties] Properties to set
                     */
                    function ListDueMasterTasksResponse(properties) {
                        this.masterTaskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDueMasterTasksResponse masterTaskIds.
                     * @member {Array.<number>} masterTaskIds
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @instance
                     */
                    ListDueMasterTasksResponse.prototype.masterTaskIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListDueMasterTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListDueMasterTasksResponse} ListDueMasterTasksResponse instance
                     */
                    ListDueMasterTasksResponse.create = function create(properties) {
                        return new ListDueMasterTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListDueMasterTasksResponse message. Does not implicitly {@link palexy.task_management.v1.ListDueMasterTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksResponse} message ListDueMasterTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDueMasterTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.masterTaskIds != null && message.masterTaskIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.masterTaskIds.length; ++i)
                                writer.int64(message.masterTaskIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDueMasterTasksResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListDueMasterTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IListDueMasterTasksResponse} message ListDueMasterTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDueMasterTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDueMasterTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListDueMasterTasksResponse} ListDueMasterTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDueMasterTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListDueMasterTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.masterTaskIds && message.masterTaskIds.length))
                                    message.masterTaskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.masterTaskIds.push(reader.int64());
                                } else
                                    message.masterTaskIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDueMasterTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListDueMasterTasksResponse} ListDueMasterTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDueMasterTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDueMasterTasksResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDueMasterTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.masterTaskIds != null && message.hasOwnProperty("masterTaskIds")) {
                            if (!Array.isArray(message.masterTaskIds))
                                return "masterTaskIds: array expected";
                            for (var i = 0; i < message.masterTaskIds.length; ++i)
                                if (!$util.isInteger(message.masterTaskIds[i]) && !(message.masterTaskIds[i] && $util.isInteger(message.masterTaskIds[i].low) && $util.isInteger(message.masterTaskIds[i].high)))
                                    return "masterTaskIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListDueMasterTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListDueMasterTasksResponse} ListDueMasterTasksResponse
                     */
                    ListDueMasterTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListDueMasterTasksResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListDueMasterTasksResponse();
                        if (object.masterTaskIds) {
                            if (!Array.isArray(object.masterTaskIds))
                                throw TypeError(".palexy.task_management.v1.ListDueMasterTasksResponse.masterTaskIds: array expected");
                            message.masterTaskIds = [];
                            for (var i = 0; i < object.masterTaskIds.length; ++i)
                                if ($util.Long)
                                    (message.masterTaskIds[i] = $util.Long.fromValue(object.masterTaskIds[i])).unsigned = false;
                                else if (typeof object.masterTaskIds[i] === "string")
                                    message.masterTaskIds[i] = parseInt(object.masterTaskIds[i], 10);
                                else if (typeof object.masterTaskIds[i] === "number")
                                    message.masterTaskIds[i] = object.masterTaskIds[i];
                                else if (typeof object.masterTaskIds[i] === "object")
                                    message.masterTaskIds[i] = new $util.LongBits(object.masterTaskIds[i].low >>> 0, object.masterTaskIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDueMasterTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.ListDueMasterTasksResponse} message ListDueMasterTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDueMasterTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.masterTaskIds = [];
                        if (message.masterTaskIds && message.masterTaskIds.length) {
                            object.masterTaskIds = [];
                            for (var j = 0; j < message.masterTaskIds.length; ++j)
                                if (typeof message.masterTaskIds[j] === "number")
                                    object.masterTaskIds[j] = options.longs === String ? String(message.masterTaskIds[j]) : message.masterTaskIds[j];
                                else
                                    object.masterTaskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.masterTaskIds[j]) : options.longs === Number ? new $util.LongBits(message.masterTaskIds[j].low >>> 0, message.masterTaskIds[j].high >>> 0).toNumber() : message.masterTaskIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListDueMasterTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListDueMasterTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDueMasterTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDueMasterTasksResponse;
                })();
    
                v1.ArchiveMissedTasksRequest = (function() {
    
                    /**
                     * Properties of an ArchiveMissedTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IArchiveMissedTasksRequest
                     * @property {number|null} [companyId] ArchiveMissedTasksRequest companyId
                     */
    
                    /**
                     * Constructs a new ArchiveMissedTasksRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an ArchiveMissedTasksRequest.
                     * @implements IArchiveMissedTasksRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest=} [properties] Properties to set
                     */
                    function ArchiveMissedTasksRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ArchiveMissedTasksRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @instance
                     */
                    ArchiveMissedTasksRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ArchiveMissedTasksRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksRequest} ArchiveMissedTasksRequest instance
                     */
                    ArchiveMissedTasksRequest.create = function create(properties) {
                        return new ArchiveMissedTasksRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ArchiveMissedTasksRequest message. Does not implicitly {@link palexy.task_management.v1.ArchiveMissedTasksRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest} message ArchiveMissedTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ArchiveMissedTasksRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ArchiveMissedTasksRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ArchiveMissedTasksRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksRequest} message ArchiveMissedTasksRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ArchiveMissedTasksRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ArchiveMissedTasksRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksRequest} ArchiveMissedTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ArchiveMissedTasksRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ArchiveMissedTasksRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ArchiveMissedTasksRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksRequest} ArchiveMissedTasksRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ArchiveMissedTasksRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ArchiveMissedTasksRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ArchiveMissedTasksRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an ArchiveMissedTasksRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksRequest} ArchiveMissedTasksRequest
                     */
                    ArchiveMissedTasksRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ArchiveMissedTasksRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ArchiveMissedTasksRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ArchiveMissedTasksRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @static
                     * @param {palexy.task_management.v1.ArchiveMissedTasksRequest} message ArchiveMissedTasksRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ArchiveMissedTasksRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ArchiveMissedTasksRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ArchiveMissedTasksRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ArchiveMissedTasksRequest;
                })();
    
                v1.ArchiveMissedTasksResponse = (function() {
    
                    /**
                     * Properties of an ArchiveMissedTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IArchiveMissedTasksResponse
                     * @property {number|null} [archivedCount] ArchiveMissedTasksResponse archivedCount
                     * @property {string|null} [summary] ArchiveMissedTasksResponse summary
                     */
    
                    /**
                     * Constructs a new ArchiveMissedTasksResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an ArchiveMissedTasksResponse.
                     * @implements IArchiveMissedTasksResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IArchiveMissedTasksResponse=} [properties] Properties to set
                     */
                    function ArchiveMissedTasksResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ArchiveMissedTasksResponse archivedCount.
                     * @member {number} archivedCount
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @instance
                     */
                    ArchiveMissedTasksResponse.prototype.archivedCount = 0;
    
                    /**
                     * ArchiveMissedTasksResponse summary.
                     * @member {string} summary
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @instance
                     */
                    ArchiveMissedTasksResponse.prototype.summary = "";
    
                    /**
                     * Creates a new ArchiveMissedTasksResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksResponse} ArchiveMissedTasksResponse instance
                     */
                    ArchiveMissedTasksResponse.create = function create(properties) {
                        return new ArchiveMissedTasksResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ArchiveMissedTasksResponse message. Does not implicitly {@link palexy.task_management.v1.ArchiveMissedTasksResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksResponse} message ArchiveMissedTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ArchiveMissedTasksResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.archivedCount != null && Object.hasOwnProperty.call(message, "archivedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.archivedCount);
                        if (message.summary != null && Object.hasOwnProperty.call(message, "summary"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.summary);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ArchiveMissedTasksResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ArchiveMissedTasksResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.IArchiveMissedTasksResponse} message ArchiveMissedTasksResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ArchiveMissedTasksResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ArchiveMissedTasksResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksResponse} ArchiveMissedTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ArchiveMissedTasksResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ArchiveMissedTasksResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.archivedCount = reader.int32();
                                break;
                            case 2:
                                message.summary = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ArchiveMissedTasksResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksResponse} ArchiveMissedTasksResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ArchiveMissedTasksResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ArchiveMissedTasksResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ArchiveMissedTasksResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.archivedCount != null && message.hasOwnProperty("archivedCount"))
                            if (!$util.isInteger(message.archivedCount))
                                return "archivedCount: integer expected";
                        if (message.summary != null && message.hasOwnProperty("summary"))
                            if (!$util.isString(message.summary))
                                return "summary: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ArchiveMissedTasksResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ArchiveMissedTasksResponse} ArchiveMissedTasksResponse
                     */
                    ArchiveMissedTasksResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ArchiveMissedTasksResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ArchiveMissedTasksResponse();
                        if (object.archivedCount != null)
                            message.archivedCount = object.archivedCount | 0;
                        if (object.summary != null)
                            message.summary = String(object.summary);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ArchiveMissedTasksResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @static
                     * @param {palexy.task_management.v1.ArchiveMissedTasksResponse} message ArchiveMissedTasksResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ArchiveMissedTasksResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.archivedCount = 0;
                            object.summary = "";
                        }
                        if (message.archivedCount != null && message.hasOwnProperty("archivedCount"))
                            object.archivedCount = message.archivedCount;
                        if (message.summary != null && message.hasOwnProperty("summary"))
                            object.summary = message.summary;
                        return object;
                    };
    
                    /**
                     * Converts this ArchiveMissedTasksResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ArchiveMissedTasksResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ArchiveMissedTasksResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ArchiveMissedTasksResponse;
                })();
    
                v1.CloseResolvedTicketsRequest = (function() {
    
                    /**
                     * Properties of a CloseResolvedTicketsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICloseResolvedTicketsRequest
                     */
    
                    /**
                     * Constructs a new CloseResolvedTicketsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CloseResolvedTicketsRequest.
                     * @implements ICloseResolvedTicketsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest=} [properties] Properties to set
                     */
                    function CloseResolvedTicketsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new CloseResolvedTicketsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsRequest} CloseResolvedTicketsRequest instance
                     */
                    CloseResolvedTicketsRequest.create = function create(properties) {
                        return new CloseResolvedTicketsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CloseResolvedTicketsRequest message. Does not implicitly {@link palexy.task_management.v1.CloseResolvedTicketsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest} message CloseResolvedTicketsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloseResolvedTicketsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CloseResolvedTicketsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CloseResolvedTicketsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsRequest} message CloseResolvedTicketsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloseResolvedTicketsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CloseResolvedTicketsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsRequest} CloseResolvedTicketsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloseResolvedTicketsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CloseResolvedTicketsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CloseResolvedTicketsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsRequest} CloseResolvedTicketsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloseResolvedTicketsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CloseResolvedTicketsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CloseResolvedTicketsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a CloseResolvedTicketsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsRequest} CloseResolvedTicketsRequest
                     */
                    CloseResolvedTicketsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CloseResolvedTicketsRequest)
                            return object;
                        return new $root.palexy.task_management.v1.CloseResolvedTicketsRequest();
                    };
    
                    /**
                     * Creates a plain object from a CloseResolvedTicketsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @static
                     * @param {palexy.task_management.v1.CloseResolvedTicketsRequest} message CloseResolvedTicketsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CloseResolvedTicketsRequest.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this CloseResolvedTicketsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CloseResolvedTicketsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CloseResolvedTicketsRequest;
                })();
    
                v1.CloseResolvedTicketsResponse = (function() {
    
                    /**
                     * Properties of a CloseResolvedTicketsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface ICloseResolvedTicketsResponse
                     * @property {number|null} [closedCount] CloseResolvedTicketsResponse closedCount
                     */
    
                    /**
                     * Constructs a new CloseResolvedTicketsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CloseResolvedTicketsResponse.
                     * @implements ICloseResolvedTicketsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsResponse=} [properties] Properties to set
                     */
                    function CloseResolvedTicketsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CloseResolvedTicketsResponse closedCount.
                     * @member {number} closedCount
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @instance
                     */
                    CloseResolvedTicketsResponse.prototype.closedCount = 0;
    
                    /**
                     * Creates a new CloseResolvedTicketsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsResponse} CloseResolvedTicketsResponse instance
                     */
                    CloseResolvedTicketsResponse.create = function create(properties) {
                        return new CloseResolvedTicketsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified CloseResolvedTicketsResponse message. Does not implicitly {@link palexy.task_management.v1.CloseResolvedTicketsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsResponse} message CloseResolvedTicketsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloseResolvedTicketsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.closedCount != null && Object.hasOwnProperty.call(message, "closedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.closedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CloseResolvedTicketsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.CloseResolvedTicketsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {palexy.task_management.v1.ICloseResolvedTicketsResponse} message CloseResolvedTicketsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CloseResolvedTicketsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CloseResolvedTicketsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsResponse} CloseResolvedTicketsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloseResolvedTicketsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CloseResolvedTicketsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.closedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CloseResolvedTicketsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsResponse} CloseResolvedTicketsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CloseResolvedTicketsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CloseResolvedTicketsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CloseResolvedTicketsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.closedCount != null && message.hasOwnProperty("closedCount"))
                            if (!$util.isInteger(message.closedCount))
                                return "closedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CloseResolvedTicketsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CloseResolvedTicketsResponse} CloseResolvedTicketsResponse
                     */
                    CloseResolvedTicketsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CloseResolvedTicketsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.CloseResolvedTicketsResponse();
                        if (object.closedCount != null)
                            message.closedCount = object.closedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CloseResolvedTicketsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @static
                     * @param {palexy.task_management.v1.CloseResolvedTicketsResponse} message CloseResolvedTicketsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CloseResolvedTicketsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.closedCount = 0;
                        if (message.closedCount != null && message.hasOwnProperty("closedCount"))
                            object.closedCount = message.closedCount;
                        return object;
                    };
    
                    /**
                     * Converts this CloseResolvedTicketsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CloseResolvedTicketsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CloseResolvedTicketsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CloseResolvedTicketsResponse;
                })();
    
                v1.GetTaskStatisticsRequest = (function() {
    
                    /**
                     * Properties of a GetTaskStatisticsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetTaskStatisticsRequest
                     * @property {number|null} [projectId] GetTaskStatisticsRequest projectId
                     * @property {palexy.streaming.v1.IDateTimeRange|null} [dateRange] GetTaskStatisticsRequest dateRange
                     */
    
                    /**
                     * Constructs a new GetTaskStatisticsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetTaskStatisticsRequest.
                     * @implements IGetTaskStatisticsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest=} [properties] Properties to set
                     */
                    function GetTaskStatisticsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTaskStatisticsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @instance
                     */
                    GetTaskStatisticsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetTaskStatisticsRequest dateRange.
                     * @member {palexy.streaming.v1.IDateTimeRange|null|undefined} dateRange
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @instance
                     */
                    GetTaskStatisticsRequest.prototype.dateRange = null;
    
                    /**
                     * Creates a new GetTaskStatisticsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetTaskStatisticsRequest} GetTaskStatisticsRequest instance
                     */
                    GetTaskStatisticsRequest.create = function create(properties) {
                        return new GetTaskStatisticsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetTaskStatisticsRequest message. Does not implicitly {@link palexy.task_management.v1.GetTaskStatisticsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest} message GetTaskStatisticsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskStatisticsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.dateRange != null && Object.hasOwnProperty.call(message, "dateRange"))
                            $root.palexy.streaming.v1.DateTimeRange.encode(message.dateRange, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTaskStatisticsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetTaskStatisticsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsRequest} message GetTaskStatisticsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskStatisticsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTaskStatisticsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetTaskStatisticsRequest} GetTaskStatisticsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskStatisticsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetTaskStatisticsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.dateRange = $root.palexy.streaming.v1.DateTimeRange.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTaskStatisticsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetTaskStatisticsRequest} GetTaskStatisticsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskStatisticsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTaskStatisticsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTaskStatisticsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.dateRange != null && message.hasOwnProperty("dateRange")) {
                            var error = $root.palexy.streaming.v1.DateTimeRange.verify(message.dateRange);
                            if (error)
                                return "dateRange." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetTaskStatisticsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetTaskStatisticsRequest} GetTaskStatisticsRequest
                     */
                    GetTaskStatisticsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetTaskStatisticsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetTaskStatisticsRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.dateRange != null) {
                            if (typeof object.dateRange !== "object")
                                throw TypeError(".palexy.task_management.v1.GetTaskStatisticsRequest.dateRange: object expected");
                            message.dateRange = $root.palexy.streaming.v1.DateTimeRange.fromObject(object.dateRange);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTaskStatisticsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.GetTaskStatisticsRequest} message GetTaskStatisticsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTaskStatisticsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.dateRange = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.dateRange != null && message.hasOwnProperty("dateRange"))
                            object.dateRange = $root.palexy.streaming.v1.DateTimeRange.toObject(message.dateRange, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetTaskStatisticsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetTaskStatisticsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTaskStatisticsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTaskStatisticsRequest;
                })();
    
                v1.GetTaskStatisticsResponse = (function() {
    
                    /**
                     * Properties of a GetTaskStatisticsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IGetTaskStatisticsResponse
                     * @property {Array.<palexy.task_management.v1.ITaskStatistic>|null} [taskStatistics] GetTaskStatisticsResponse taskStatistics
                     */
    
                    /**
                     * Constructs a new GetTaskStatisticsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetTaskStatisticsResponse.
                     * @implements IGetTaskStatisticsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IGetTaskStatisticsResponse=} [properties] Properties to set
                     */
                    function GetTaskStatisticsResponse(properties) {
                        this.taskStatistics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetTaskStatisticsResponse taskStatistics.
                     * @member {Array.<palexy.task_management.v1.ITaskStatistic>} taskStatistics
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @instance
                     */
                    GetTaskStatisticsResponse.prototype.taskStatistics = $util.emptyArray;
    
                    /**
                     * Creates a new GetTaskStatisticsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetTaskStatisticsResponse} GetTaskStatisticsResponse instance
                     */
                    GetTaskStatisticsResponse.create = function create(properties) {
                        return new GetTaskStatisticsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetTaskStatisticsResponse message. Does not implicitly {@link palexy.task_management.v1.GetTaskStatisticsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsResponse} message GetTaskStatisticsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskStatisticsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.taskStatistics != null && message.taskStatistics.length)
                            for (var i = 0; i < message.taskStatistics.length; ++i)
                                $root.palexy.task_management.v1.TaskStatistic.encode(message.taskStatistics[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetTaskStatisticsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetTaskStatisticsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetTaskStatisticsResponse} message GetTaskStatisticsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetTaskStatisticsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetTaskStatisticsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetTaskStatisticsResponse} GetTaskStatisticsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskStatisticsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetTaskStatisticsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.taskStatistics && message.taskStatistics.length))
                                    message.taskStatistics = [];
                                message.taskStatistics.push($root.palexy.task_management.v1.TaskStatistic.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetTaskStatisticsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetTaskStatisticsResponse} GetTaskStatisticsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetTaskStatisticsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetTaskStatisticsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetTaskStatisticsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.taskStatistics != null && message.hasOwnProperty("taskStatistics")) {
                            if (!Array.isArray(message.taskStatistics))
                                return "taskStatistics: array expected";
                            for (var i = 0; i < message.taskStatistics.length; ++i) {
                                var error = $root.palexy.task_management.v1.TaskStatistic.verify(message.taskStatistics[i]);
                                if (error)
                                    return "taskStatistics." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetTaskStatisticsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetTaskStatisticsResponse} GetTaskStatisticsResponse
                     */
                    GetTaskStatisticsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetTaskStatisticsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetTaskStatisticsResponse();
                        if (object.taskStatistics) {
                            if (!Array.isArray(object.taskStatistics))
                                throw TypeError(".palexy.task_management.v1.GetTaskStatisticsResponse.taskStatistics: array expected");
                            message.taskStatistics = [];
                            for (var i = 0; i < object.taskStatistics.length; ++i) {
                                if (typeof object.taskStatistics[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.GetTaskStatisticsResponse.taskStatistics: object expected");
                                message.taskStatistics[i] = $root.palexy.task_management.v1.TaskStatistic.fromObject(object.taskStatistics[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetTaskStatisticsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @static
                     * @param {palexy.task_management.v1.GetTaskStatisticsResponse} message GetTaskStatisticsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetTaskStatisticsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskStatistics = [];
                        if (message.taskStatistics && message.taskStatistics.length) {
                            object.taskStatistics = [];
                            for (var j = 0; j < message.taskStatistics.length; ++j)
                                object.taskStatistics[j] = $root.palexy.task_management.v1.TaskStatistic.toObject(message.taskStatistics[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetTaskStatisticsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetTaskStatisticsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetTaskStatisticsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetTaskStatisticsResponse;
                })();
    
                v1.TaskStatistic = (function() {
    
                    /**
                     * Properties of a TaskStatistic.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskStatistic
                     * @property {number|null} [masterTaskId] TaskStatistic masterTaskId
                     * @property {number|null} [totalChildCount] TaskStatistic totalChildCount
                     * @property {number|null} [completedChildCount] TaskStatistic completedChildCount
                     */
    
                    /**
                     * Constructs a new TaskStatistic.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskStatistic.
                     * @implements ITaskStatistic
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskStatistic=} [properties] Properties to set
                     */
                    function TaskStatistic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskStatistic masterTaskId.
                     * @member {number} masterTaskId
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @instance
                     */
                    TaskStatistic.prototype.masterTaskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskStatistic totalChildCount.
                     * @member {number} totalChildCount
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @instance
                     */
                    TaskStatistic.prototype.totalChildCount = 0;
    
                    /**
                     * TaskStatistic completedChildCount.
                     * @member {number} completedChildCount
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @instance
                     */
                    TaskStatistic.prototype.completedChildCount = 0;
    
                    /**
                     * Creates a new TaskStatistic instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {palexy.task_management.v1.ITaskStatistic=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskStatistic} TaskStatistic instance
                     */
                    TaskStatistic.create = function create(properties) {
                        return new TaskStatistic(properties);
                    };
    
                    /**
                     * Encodes the specified TaskStatistic message. Does not implicitly {@link palexy.task_management.v1.TaskStatistic.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {palexy.task_management.v1.ITaskStatistic} message TaskStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskStatistic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.masterTaskId != null && Object.hasOwnProperty.call(message, "masterTaskId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.masterTaskId);
                        if (message.totalChildCount != null && Object.hasOwnProperty.call(message, "totalChildCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalChildCount);
                        if (message.completedChildCount != null && Object.hasOwnProperty.call(message, "completedChildCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.completedChildCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskStatistic message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskStatistic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {palexy.task_management.v1.ITaskStatistic} message TaskStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskStatistic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskStatistic message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskStatistic} TaskStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskStatistic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskStatistic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.masterTaskId = reader.int64();
                                break;
                            case 2:
                                message.totalChildCount = reader.int32();
                                break;
                            case 3:
                                message.completedChildCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskStatistic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskStatistic} TaskStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskStatistic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskStatistic message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskStatistic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (!$util.isInteger(message.masterTaskId) && !(message.masterTaskId && $util.isInteger(message.masterTaskId.low) && $util.isInteger(message.masterTaskId.high)))
                                return "masterTaskId: integer|Long expected";
                        if (message.totalChildCount != null && message.hasOwnProperty("totalChildCount"))
                            if (!$util.isInteger(message.totalChildCount))
                                return "totalChildCount: integer expected";
                        if (message.completedChildCount != null && message.hasOwnProperty("completedChildCount"))
                            if (!$util.isInteger(message.completedChildCount))
                                return "completedChildCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a TaskStatistic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskStatistic} TaskStatistic
                     */
                    TaskStatistic.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskStatistic)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskStatistic();
                        if (object.masterTaskId != null)
                            if ($util.Long)
                                (message.masterTaskId = $util.Long.fromValue(object.masterTaskId)).unsigned = false;
                            else if (typeof object.masterTaskId === "string")
                                message.masterTaskId = parseInt(object.masterTaskId, 10);
                            else if (typeof object.masterTaskId === "number")
                                message.masterTaskId = object.masterTaskId;
                            else if (typeof object.masterTaskId === "object")
                                message.masterTaskId = new $util.LongBits(object.masterTaskId.low >>> 0, object.masterTaskId.high >>> 0).toNumber();
                        if (object.totalChildCount != null)
                            message.totalChildCount = object.totalChildCount | 0;
                        if (object.completedChildCount != null)
                            message.completedChildCount = object.completedChildCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskStatistic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @static
                     * @param {palexy.task_management.v1.TaskStatistic} message TaskStatistic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskStatistic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.masterTaskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.masterTaskId = options.longs === String ? "0" : 0;
                            object.totalChildCount = 0;
                            object.completedChildCount = 0;
                        }
                        if (message.masterTaskId != null && message.hasOwnProperty("masterTaskId"))
                            if (typeof message.masterTaskId === "number")
                                object.masterTaskId = options.longs === String ? String(message.masterTaskId) : message.masterTaskId;
                            else
                                object.masterTaskId = options.longs === String ? $util.Long.prototype.toString.call(message.masterTaskId) : options.longs === Number ? new $util.LongBits(message.masterTaskId.low >>> 0, message.masterTaskId.high >>> 0).toNumber() : message.masterTaskId;
                        if (message.totalChildCount != null && message.hasOwnProperty("totalChildCount"))
                            object.totalChildCount = message.totalChildCount;
                        if (message.completedChildCount != null && message.hasOwnProperty("completedChildCount"))
                            object.completedChildCount = message.completedChildCount;
                        return object;
                    };
    
                    /**
                     * Converts this TaskStatistic to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskStatistic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskStatistic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskStatistic;
                })();
    
                v1.CreateTaskCommentRequest = (function() {
    
                    /**
                     * Properties of a CreateTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateTaskCommentRequest
                     * @property {number|null} [projectId] CreateTaskCommentRequest projectId
                     * @property {palexy.task_management.v1.ITaskComment|null} [comment] CreateTaskCommentRequest comment
                     */
    
                    /**
                     * Constructs a new CreateTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateTaskCommentRequest.
                     * @implements ICreateTaskCommentRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest=} [properties] Properties to set
                     */
                    function CreateTaskCommentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateTaskCommentRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @instance
                     */
                    CreateTaskCommentRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateTaskCommentRequest comment.
                     * @member {palexy.task_management.v1.ITaskComment|null|undefined} comment
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @instance
                     */
                    CreateTaskCommentRequest.prototype.comment = null;
    
                    /**
                     * Creates a new CreateTaskCommentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateTaskCommentRequest} CreateTaskCommentRequest instance
                     */
                    CreateTaskCommentRequest.create = function create(properties) {
                        return new CreateTaskCommentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateTaskCommentRequest message. Does not implicitly {@link palexy.task_management.v1.CreateTaskCommentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest} message CreateTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskCommentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
                            $root.palexy.task_management.v1.TaskComment.encode(message.comment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateTaskCommentRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateTaskCommentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateTaskCommentRequest} message CreateTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateTaskCommentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateTaskCommentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateTaskCommentRequest} CreateTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskCommentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateTaskCommentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.comment = $root.palexy.task_management.v1.TaskComment.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateTaskCommentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateTaskCommentRequest} CreateTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateTaskCommentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateTaskCommentRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateTaskCommentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.comment != null && message.hasOwnProperty("comment")) {
                            var error = $root.palexy.task_management.v1.TaskComment.verify(message.comment);
                            if (error)
                                return "comment." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateTaskCommentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateTaskCommentRequest} CreateTaskCommentRequest
                     */
                    CreateTaskCommentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateTaskCommentRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateTaskCommentRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.comment != null) {
                            if (typeof object.comment !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateTaskCommentRequest.comment: object expected");
                            message.comment = $root.palexy.task_management.v1.TaskComment.fromObject(object.comment);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateTaskCommentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateTaskCommentRequest} message CreateTaskCommentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateTaskCommentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.comment = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.comment != null && message.hasOwnProperty("comment"))
                            object.comment = $root.palexy.task_management.v1.TaskComment.toObject(message.comment, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateTaskCommentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateTaskCommentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateTaskCommentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateTaskCommentRequest;
                })();
    
                v1.ListTaskCommentsRequest = (function() {
    
                    /**
                     * Properties of a ListTaskCommentsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListTaskCommentsRequest
                     * @property {number|null} [projectId] ListTaskCommentsRequest projectId
                     * @property {number|null} [taskId] ListTaskCommentsRequest taskId
                     */
    
                    /**
                     * Constructs a new ListTaskCommentsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTaskCommentsRequest.
                     * @implements IListTaskCommentsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest=} [properties] Properties to set
                     */
                    function ListTaskCommentsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskCommentsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @instance
                     */
                    ListTaskCommentsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListTaskCommentsRequest taskId.
                     * @member {number} taskId
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @instance
                     */
                    ListTaskCommentsRequest.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListTaskCommentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTaskCommentsRequest} ListTaskCommentsRequest instance
                     */
                    ListTaskCommentsRequest.create = function create(properties) {
                        return new ListTaskCommentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskCommentsRequest message. Does not implicitly {@link palexy.task_management.v1.ListTaskCommentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest} message ListTaskCommentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskCommentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.taskId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskCommentsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTaskCommentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsRequest} message ListTaskCommentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskCommentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskCommentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTaskCommentsRequest} ListTaskCommentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskCommentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTaskCommentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.taskId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskCommentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTaskCommentsRequest} ListTaskCommentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskCommentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskCommentsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskCommentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskCommentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTaskCommentsRequest} ListTaskCommentsRequest
                     */
                    ListTaskCommentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTaskCommentsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTaskCommentsRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskCommentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListTaskCommentsRequest} message ListTaskCommentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskCommentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskCommentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTaskCommentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskCommentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskCommentsRequest;
                })();
    
                v1.ListTaskCommentsResponse = (function() {
    
                    /**
                     * Properties of a ListTaskCommentsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListTaskCommentsResponse
                     * @property {Array.<palexy.task_management.v1.ITaskComment>|null} [comments] ListTaskCommentsResponse comments
                     */
    
                    /**
                     * Constructs a new ListTaskCommentsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListTaskCommentsResponse.
                     * @implements IListTaskCommentsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListTaskCommentsResponse=} [properties] Properties to set
                     */
                    function ListTaskCommentsResponse(properties) {
                        this.comments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListTaskCommentsResponse comments.
                     * @member {Array.<palexy.task_management.v1.ITaskComment>} comments
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @instance
                     */
                    ListTaskCommentsResponse.prototype.comments = $util.emptyArray;
    
                    /**
                     * Creates a new ListTaskCommentsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListTaskCommentsResponse} ListTaskCommentsResponse instance
                     */
                    ListTaskCommentsResponse.create = function create(properties) {
                        return new ListTaskCommentsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListTaskCommentsResponse message. Does not implicitly {@link palexy.task_management.v1.ListTaskCommentsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsResponse} message ListTaskCommentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskCommentsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.comments != null && message.comments.length)
                            for (var i = 0; i < message.comments.length; ++i)
                                $root.palexy.task_management.v1.TaskComment.encode(message.comments[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListTaskCommentsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListTaskCommentsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListTaskCommentsResponse} message ListTaskCommentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListTaskCommentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListTaskCommentsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListTaskCommentsResponse} ListTaskCommentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskCommentsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListTaskCommentsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.comments && message.comments.length))
                                    message.comments = [];
                                message.comments.push($root.palexy.task_management.v1.TaskComment.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListTaskCommentsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListTaskCommentsResponse} ListTaskCommentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListTaskCommentsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListTaskCommentsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListTaskCommentsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.comments != null && message.hasOwnProperty("comments")) {
                            if (!Array.isArray(message.comments))
                                return "comments: array expected";
                            for (var i = 0; i < message.comments.length; ++i) {
                                var error = $root.palexy.task_management.v1.TaskComment.verify(message.comments[i]);
                                if (error)
                                    return "comments." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListTaskCommentsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListTaskCommentsResponse} ListTaskCommentsResponse
                     */
                    ListTaskCommentsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListTaskCommentsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListTaskCommentsResponse();
                        if (object.comments) {
                            if (!Array.isArray(object.comments))
                                throw TypeError(".palexy.task_management.v1.ListTaskCommentsResponse.comments: array expected");
                            message.comments = [];
                            for (var i = 0; i < object.comments.length; ++i) {
                                if (typeof object.comments[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListTaskCommentsResponse.comments: object expected");
                                message.comments[i] = $root.palexy.task_management.v1.TaskComment.fromObject(object.comments[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListTaskCommentsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListTaskCommentsResponse} message ListTaskCommentsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListTaskCommentsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.comments = [];
                        if (message.comments && message.comments.length) {
                            object.comments = [];
                            for (var j = 0; j < message.comments.length; ++j)
                                object.comments[j] = $root.palexy.task_management.v1.TaskComment.toObject(message.comments[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListTaskCommentsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListTaskCommentsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListTaskCommentsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListTaskCommentsResponse;
                })();
    
                v1.BatchGetLatestTaskCommentsRequest = (function() {
    
                    /**
                     * Properties of a BatchGetLatestTaskCommentsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IBatchGetLatestTaskCommentsRequest
                     * @property {number|null} [projectId] BatchGetLatestTaskCommentsRequest projectId
                     * @property {Array.<number>|null} [taskIds] BatchGetLatestTaskCommentsRequest taskIds
                     */
    
                    /**
                     * Constructs a new BatchGetLatestTaskCommentsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a BatchGetLatestTaskCommentsRequest.
                     * @implements IBatchGetLatestTaskCommentsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest=} [properties] Properties to set
                     */
                    function BatchGetLatestTaskCommentsRequest(properties) {
                        this.taskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchGetLatestTaskCommentsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @instance
                     */
                    BatchGetLatestTaskCommentsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BatchGetLatestTaskCommentsRequest taskIds.
                     * @member {Array.<number>} taskIds
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @instance
                     */
                    BatchGetLatestTaskCommentsRequest.prototype.taskIds = $util.emptyArray;
    
                    /**
                     * Creates a new BatchGetLatestTaskCommentsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsRequest} BatchGetLatestTaskCommentsRequest instance
                     */
                    BatchGetLatestTaskCommentsRequest.create = function create(properties) {
                        return new BatchGetLatestTaskCommentsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified BatchGetLatestTaskCommentsRequest message. Does not implicitly {@link palexy.task_management.v1.BatchGetLatestTaskCommentsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest} message BatchGetLatestTaskCommentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetLatestTaskCommentsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.taskIds != null && message.taskIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.taskIds.length; ++i)
                                writer.int64(message.taskIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchGetLatestTaskCommentsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.BatchGetLatestTaskCommentsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsRequest} message BatchGetLatestTaskCommentsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetLatestTaskCommentsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchGetLatestTaskCommentsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsRequest} BatchGetLatestTaskCommentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetLatestTaskCommentsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.BatchGetLatestTaskCommentsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                if (!(message.taskIds && message.taskIds.length))
                                    message.taskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.taskIds.push(reader.int64());
                                } else
                                    message.taskIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchGetLatestTaskCommentsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsRequest} BatchGetLatestTaskCommentsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetLatestTaskCommentsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchGetLatestTaskCommentsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchGetLatestTaskCommentsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.taskIds != null && message.hasOwnProperty("taskIds")) {
                            if (!Array.isArray(message.taskIds))
                                return "taskIds: array expected";
                            for (var i = 0; i < message.taskIds.length; ++i)
                                if (!$util.isInteger(message.taskIds[i]) && !(message.taskIds[i] && $util.isInteger(message.taskIds[i].low) && $util.isInteger(message.taskIds[i].high)))
                                    return "taskIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchGetLatestTaskCommentsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsRequest} BatchGetLatestTaskCommentsRequest
                     */
                    BatchGetLatestTaskCommentsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.BatchGetLatestTaskCommentsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.BatchGetLatestTaskCommentsRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.taskIds) {
                            if (!Array.isArray(object.taskIds))
                                throw TypeError(".palexy.task_management.v1.BatchGetLatestTaskCommentsRequest.taskIds: array expected");
                            message.taskIds = [];
                            for (var i = 0; i < object.taskIds.length; ++i)
                                if ($util.Long)
                                    (message.taskIds[i] = $util.Long.fromValue(object.taskIds[i])).unsigned = false;
                                else if (typeof object.taskIds[i] === "string")
                                    message.taskIds[i] = parseInt(object.taskIds[i], 10);
                                else if (typeof object.taskIds[i] === "number")
                                    message.taskIds[i] = object.taskIds[i];
                                else if (typeof object.taskIds[i] === "object")
                                    message.taskIds[i] = new $util.LongBits(object.taskIds[i].low >>> 0, object.taskIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchGetLatestTaskCommentsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @static
                     * @param {palexy.task_management.v1.BatchGetLatestTaskCommentsRequest} message BatchGetLatestTaskCommentsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchGetLatestTaskCommentsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.taskIds = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.taskIds && message.taskIds.length) {
                            object.taskIds = [];
                            for (var j = 0; j < message.taskIds.length; ++j)
                                if (typeof message.taskIds[j] === "number")
                                    object.taskIds[j] = options.longs === String ? String(message.taskIds[j]) : message.taskIds[j];
                                else
                                    object.taskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.taskIds[j]) : options.longs === Number ? new $util.LongBits(message.taskIds[j].low >>> 0, message.taskIds[j].high >>> 0).toNumber() : message.taskIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchGetLatestTaskCommentsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchGetLatestTaskCommentsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchGetLatestTaskCommentsRequest;
                })();
    
                v1.BatchGetLatestTaskCommentsResponse = (function() {
    
                    /**
                     * Properties of a BatchGetLatestTaskCommentsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IBatchGetLatestTaskCommentsResponse
                     * @property {Object.<string,palexy.task_management.v1.ITaskComment>|null} [latestComments] BatchGetLatestTaskCommentsResponse latestComments
                     */
    
                    /**
                     * Constructs a new BatchGetLatestTaskCommentsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a BatchGetLatestTaskCommentsResponse.
                     * @implements IBatchGetLatestTaskCommentsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsResponse=} [properties] Properties to set
                     */
                    function BatchGetLatestTaskCommentsResponse(properties) {
                        this.latestComments = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BatchGetLatestTaskCommentsResponse latestComments.
                     * @member {Object.<string,palexy.task_management.v1.ITaskComment>} latestComments
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @instance
                     */
                    BatchGetLatestTaskCommentsResponse.prototype.latestComments = $util.emptyObject;
    
                    /**
                     * Creates a new BatchGetLatestTaskCommentsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} BatchGetLatestTaskCommentsResponse instance
                     */
                    BatchGetLatestTaskCommentsResponse.create = function create(properties) {
                        return new BatchGetLatestTaskCommentsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified BatchGetLatestTaskCommentsResponse message. Does not implicitly {@link palexy.task_management.v1.BatchGetLatestTaskCommentsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsResponse} message BatchGetLatestTaskCommentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetLatestTaskCommentsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.latestComments != null && Object.hasOwnProperty.call(message, "latestComments"))
                            for (var keys = Object.keys(message.latestComments), i = 0; i < keys.length; ++i) {
                                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 0 =*/8).int64(keys[i]);
                                $root.palexy.task_management.v1.TaskComment.encode(message.latestComments[keys[i]], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim().ldelim();
                            }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BatchGetLatestTaskCommentsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.BatchGetLatestTaskCommentsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.IBatchGetLatestTaskCommentsResponse} message BatchGetLatestTaskCommentsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BatchGetLatestTaskCommentsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BatchGetLatestTaskCommentsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} BatchGetLatestTaskCommentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetLatestTaskCommentsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.BatchGetLatestTaskCommentsResponse(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (message.latestComments === $util.emptyObject)
                                    message.latestComments = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = 0;
                                value = null;
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.int64();
                                        break;
                                    case 2:
                                        value = $root.palexy.task_management.v1.TaskComment.decode(reader, reader.uint32());
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.latestComments[typeof key === "object" ? $util.longToHash(key) : key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BatchGetLatestTaskCommentsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} BatchGetLatestTaskCommentsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BatchGetLatestTaskCommentsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BatchGetLatestTaskCommentsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BatchGetLatestTaskCommentsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.latestComments != null && message.hasOwnProperty("latestComments")) {
                            if (!$util.isObject(message.latestComments))
                                return "latestComments: object expected";
                            var key = Object.keys(message.latestComments);
                            for (var i = 0; i < key.length; ++i) {
                                if (!$util.key64Re.test(key[i]))
                                    return "latestComments: integer|Long key{k:int64} expected";
                                {
                                    var error = $root.palexy.task_management.v1.TaskComment.verify(message.latestComments[key[i]]);
                                    if (error)
                                        return "latestComments." + error;
                                }
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a BatchGetLatestTaskCommentsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} BatchGetLatestTaskCommentsResponse
                     */
                    BatchGetLatestTaskCommentsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.BatchGetLatestTaskCommentsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.BatchGetLatestTaskCommentsResponse();
                        if (object.latestComments) {
                            if (typeof object.latestComments !== "object")
                                throw TypeError(".palexy.task_management.v1.BatchGetLatestTaskCommentsResponse.latestComments: object expected");
                            message.latestComments = {};
                            for (var keys = Object.keys(object.latestComments), i = 0; i < keys.length; ++i) {
                                if (typeof object.latestComments[keys[i]] !== "object")
                                    throw TypeError(".palexy.task_management.v1.BatchGetLatestTaskCommentsResponse.latestComments: object expected");
                                message.latestComments[keys[i]] = $root.palexy.task_management.v1.TaskComment.fromObject(object.latestComments[keys[i]]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BatchGetLatestTaskCommentsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @static
                     * @param {palexy.task_management.v1.BatchGetLatestTaskCommentsResponse} message BatchGetLatestTaskCommentsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BatchGetLatestTaskCommentsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.latestComments = {};
                        var keys2;
                        if (message.latestComments && (keys2 = Object.keys(message.latestComments)).length) {
                            object.latestComments = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.latestComments[keys2[j]] = $root.palexy.task_management.v1.TaskComment.toObject(message.latestComments[keys2[j]], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this BatchGetLatestTaskCommentsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.BatchGetLatestTaskCommentsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BatchGetLatestTaskCommentsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BatchGetLatestTaskCommentsResponse;
                })();
    
                v1.UpdateTaskCommentRequest = (function() {
    
                    /**
                     * Properties of an UpdateTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateTaskCommentRequest
                     * @property {number|null} [projectId] UpdateTaskCommentRequest projectId
                     * @property {palexy.task_management.v1.ITaskComment|null} [comment] UpdateTaskCommentRequest comment
                     */
    
                    /**
                     * Constructs a new UpdateTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateTaskCommentRequest.
                     * @implements IUpdateTaskCommentRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest=} [properties] Properties to set
                     */
                    function UpdateTaskCommentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateTaskCommentRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @instance
                     */
                    UpdateTaskCommentRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateTaskCommentRequest comment.
                     * @member {palexy.task_management.v1.ITaskComment|null|undefined} comment
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @instance
                     */
                    UpdateTaskCommentRequest.prototype.comment = null;
    
                    /**
                     * Creates a new UpdateTaskCommentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateTaskCommentRequest} UpdateTaskCommentRequest instance
                     */
                    UpdateTaskCommentRequest.create = function create(properties) {
                        return new UpdateTaskCommentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateTaskCommentRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateTaskCommentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest} message UpdateTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskCommentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.comment != null && Object.hasOwnProperty.call(message, "comment"))
                            $root.palexy.task_management.v1.TaskComment.encode(message.comment, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateTaskCommentRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateTaskCommentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateTaskCommentRequest} message UpdateTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateTaskCommentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateTaskCommentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateTaskCommentRequest} UpdateTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskCommentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateTaskCommentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.comment = $root.palexy.task_management.v1.TaskComment.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateTaskCommentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateTaskCommentRequest} UpdateTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateTaskCommentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateTaskCommentRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateTaskCommentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.comment != null && message.hasOwnProperty("comment")) {
                            var error = $root.palexy.task_management.v1.TaskComment.verify(message.comment);
                            if (error)
                                return "comment." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateTaskCommentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateTaskCommentRequest} UpdateTaskCommentRequest
                     */
                    UpdateTaskCommentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateTaskCommentRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateTaskCommentRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.comment != null) {
                            if (typeof object.comment !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateTaskCommentRequest.comment: object expected");
                            message.comment = $root.palexy.task_management.v1.TaskComment.fromObject(object.comment);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateTaskCommentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateTaskCommentRequest} message UpdateTaskCommentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateTaskCommentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.comment = null;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.comment != null && message.hasOwnProperty("comment"))
                            object.comment = $root.palexy.task_management.v1.TaskComment.toObject(message.comment, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateTaskCommentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateTaskCommentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateTaskCommentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateTaskCommentRequest;
                })();
    
                v1.DeleteTaskCommentRequest = (function() {
    
                    /**
                     * Properties of a DeleteTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteTaskCommentRequest
                     * @property {number|null} [projectId] DeleteTaskCommentRequest projectId
                     * @property {number|null} [taskId] DeleteTaskCommentRequest taskId
                     * @property {number|null} [id] DeleteTaskCommentRequest id
                     * @property {number|null} [actingAccountId] DeleteTaskCommentRequest actingAccountId
                     */
    
                    /**
                     * Constructs a new DeleteTaskCommentRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteTaskCommentRequest.
                     * @implements IDeleteTaskCommentRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest=} [properties] Properties to set
                     */
                    function DeleteTaskCommentRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteTaskCommentRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @instance
                     */
                    DeleteTaskCommentRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteTaskCommentRequest taskId.
                     * @member {number} taskId
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @instance
                     */
                    DeleteTaskCommentRequest.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteTaskCommentRequest id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @instance
                     */
                    DeleteTaskCommentRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteTaskCommentRequest actingAccountId.
                     * @member {number} actingAccountId
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @instance
                     */
                    DeleteTaskCommentRequest.prototype.actingAccountId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteTaskCommentRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteTaskCommentRequest} DeleteTaskCommentRequest instance
                     */
                    DeleteTaskCommentRequest.create = function create(properties) {
                        return new DeleteTaskCommentRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteTaskCommentRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteTaskCommentRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest} message DeleteTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskCommentRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.projectId);
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.taskId);
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.id);
                        if (message.actingAccountId != null && Object.hasOwnProperty.call(message, "actingAccountId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.actingAccountId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteTaskCommentRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteTaskCommentRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteTaskCommentRequest} message DeleteTaskCommentRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteTaskCommentRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteTaskCommentRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteTaskCommentRequest} DeleteTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskCommentRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteTaskCommentRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.projectId = reader.int64();
                                break;
                            case 2:
                                message.taskId = reader.int64();
                                break;
                            case 3:
                                message.id = reader.int64();
                                break;
                            case 4:
                                message.actingAccountId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteTaskCommentRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteTaskCommentRequest} DeleteTaskCommentRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteTaskCommentRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteTaskCommentRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteTaskCommentRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (!$util.isInteger(message.actingAccountId) && !(message.actingAccountId && $util.isInteger(message.actingAccountId.low) && $util.isInteger(message.actingAccountId.high)))
                                return "actingAccountId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteTaskCommentRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteTaskCommentRequest} DeleteTaskCommentRequest
                     */
                    DeleteTaskCommentRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteTaskCommentRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteTaskCommentRequest();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.actingAccountId != null)
                            if ($util.Long)
                                (message.actingAccountId = $util.Long.fromValue(object.actingAccountId)).unsigned = false;
                            else if (typeof object.actingAccountId === "string")
                                message.actingAccountId = parseInt(object.actingAccountId, 10);
                            else if (typeof object.actingAccountId === "number")
                                message.actingAccountId = object.actingAccountId;
                            else if (typeof object.actingAccountId === "object")
                                message.actingAccountId = new $util.LongBits(object.actingAccountId.low >>> 0, object.actingAccountId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteTaskCommentRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteTaskCommentRequest} message DeleteTaskCommentRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteTaskCommentRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.actingAccountId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.actingAccountId = options.longs === String ? "0" : 0;
                        }
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.actingAccountId != null && message.hasOwnProperty("actingAccountId"))
                            if (typeof message.actingAccountId === "number")
                                object.actingAccountId = options.longs === String ? String(message.actingAccountId) : message.actingAccountId;
                            else
                                object.actingAccountId = options.longs === String ? $util.Long.prototype.toString.call(message.actingAccountId) : options.longs === Number ? new $util.LongBits(message.actingAccountId.low >>> 0, message.actingAccountId.high >>> 0).toNumber() : message.actingAccountId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteTaskCommentRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteTaskCommentRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteTaskCommentRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteTaskCommentRequest;
                })();
    
                v1.FormService = (function() {
    
                    /**
                     * Constructs a new FormService service.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function FormService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (FormService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = FormService;
    
                    /**
                     * Creates new FormService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.task_management.v1.FormService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {FormService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    FormService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createForm}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Form} [response] Form
                     */
    
                    /**
                     * Calls CreateForm.
                     * @function createForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormRequest} request CreateFormRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormCallback} callback Node-style callback called with the error, if any, and Form
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createForm = function createForm(request, callback) {
                        return this.rpcCall(createForm, $root.palexy.task_management.v1.CreateFormRequest, $root.palexy.task_management.v1.Form, request, callback);
                    }, "name", { value: "CreateForm" });
    
                    /**
                     * Calls CreateForm.
                     * @function createForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormRequest} request CreateFormRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Form>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listForms}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormsResponse} [response] ListFormsResponse
                     */
    
                    /**
                     * Calls ListForms.
                     * @function listForms
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormsRequest} request ListFormsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormsCallback} callback Node-style callback called with the error, if any, and ListFormsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listForms = function listForms(request, callback) {
                        return this.rpcCall(listForms, $root.palexy.task_management.v1.ListFormsRequest, $root.palexy.task_management.v1.ListFormsResponse, request, callback);
                    }, "name", { value: "ListForms" });
    
                    /**
                     * Calls ListForms.
                     * @function listForms
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormsRequest} request ListFormsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getForm}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Form} [response] Form
                     */
    
                    /**
                     * Calls GetForm.
                     * @function getForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormRequest} request GetFormRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormCallback} callback Node-style callback called with the error, if any, and Form
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getForm = function getForm(request, callback) {
                        return this.rpcCall(getForm, $root.palexy.task_management.v1.GetFormRequest, $root.palexy.task_management.v1.Form, request, callback);
                    }, "name", { value: "GetForm" });
    
                    /**
                     * Calls GetForm.
                     * @function getForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormRequest} request GetFormRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Form>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateForm}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Form} [response] Form
                     */
    
                    /**
                     * Calls UpdateForm.
                     * @function updateForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormRequest} request UpdateFormRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormCallback} callback Node-style callback called with the error, if any, and Form
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateForm = function updateForm(request, callback) {
                        return this.rpcCall(updateForm, $root.palexy.task_management.v1.UpdateFormRequest, $root.palexy.task_management.v1.Form, request, callback);
                    }, "name", { value: "UpdateForm" });
    
                    /**
                     * Calls UpdateForm.
                     * @function updateForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormRequest} request UpdateFormRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Form>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteForm}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteForm.
                     * @function deleteForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormRequest} request DeleteFormRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteForm = function deleteForm(request, callback) {
                        return this.rpcCall(deleteForm, $root.palexy.task_management.v1.DeleteFormRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteForm" });
    
                    /**
                     * Calls DeleteForm.
                     * @function deleteForm
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormRequest} request DeleteFormRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormVersions}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormVersionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormVersionsResponse} [response] ListFormVersionsResponse
                     */
    
                    /**
                     * Calls ListFormVersions.
                     * @function listFormVersions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormVersionsRequest} request ListFormVersionsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormVersionsCallback} callback Node-style callback called with the error, if any, and ListFormVersionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormVersions = function listFormVersions(request, callback) {
                        return this.rpcCall(listFormVersions, $root.palexy.task_management.v1.ListFormVersionsRequest, $root.palexy.task_management.v1.ListFormVersionsResponse, request, callback);
                    }, "name", { value: "ListFormVersions" });
    
                    /**
                     * Calls ListFormVersions.
                     * @function listFormVersions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormVersionsRequest} request ListFormVersionsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormVersionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormVersion}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormVersion} [response] FormVersion
                     */
    
                    /**
                     * Calls GetFormVersion.
                     * @function getFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormVersionRequest} request GetFormVersionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormVersionCallback} callback Node-style callback called with the error, if any, and FormVersion
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormVersion = function getFormVersion(request, callback) {
                        return this.rpcCall(getFormVersion, $root.palexy.task_management.v1.GetFormVersionRequest, $root.palexy.task_management.v1.FormVersion, request, callback);
                    }, "name", { value: "GetFormVersion" });
    
                    /**
                     * Calls GetFormVersion.
                     * @function getFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormVersionRequest} request GetFormVersionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormVersion>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormVersion}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormVersion} [response] FormVersion
                     */
    
                    /**
                     * Calls CreateFormVersion.
                     * @function createFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest} request CreateFormVersionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormVersionCallback} callback Node-style callback called with the error, if any, and FormVersion
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormVersion = function createFormVersion(request, callback) {
                        return this.rpcCall(createFormVersion, $root.palexy.task_management.v1.CreateFormVersionRequest, $root.palexy.task_management.v1.FormVersion, request, callback);
                    }, "name", { value: "CreateFormVersion" });
    
                    /**
                     * Calls CreateFormVersion.
                     * @function createFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest} request CreateFormVersionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormVersion>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#restoreFormVersion}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef RestoreFormVersionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Form} [response] Form
                     */
    
                    /**
                     * Calls RestoreFormVersion.
                     * @function restoreFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest} request RestoreFormVersionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.RestoreFormVersionCallback} callback Node-style callback called with the error, if any, and Form
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.restoreFormVersion = function restoreFormVersion(request, callback) {
                        return this.rpcCall(restoreFormVersion, $root.palexy.task_management.v1.RestoreFormVersionRequest, $root.palexy.task_management.v1.Form, request, callback);
                    }, "name", { value: "RestoreFormVersion" });
    
                    /**
                     * Calls RestoreFormVersion.
                     * @function restoreFormVersion
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest} request RestoreFormVersionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Form>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormReportQuestions}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormReportQuestionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormReportQuestionsResponse} [response] ListFormReportQuestionsResponse
                     */
    
                    /**
                     * Calls ListFormReportQuestions.
                     * @function listFormReportQuestions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest} request ListFormReportQuestionsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormReportQuestionsCallback} callback Node-style callback called with the error, if any, and ListFormReportQuestionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormReportQuestions = function listFormReportQuestions(request, callback) {
                        return this.rpcCall(listFormReportQuestions, $root.palexy.task_management.v1.ListFormReportQuestionsRequest, $root.palexy.task_management.v1.ListFormReportQuestionsResponse, request, callback);
                    }, "name", { value: "ListFormReportQuestions" });
    
                    /**
                     * Calls ListFormReportQuestions.
                     * @function listFormReportQuestions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest} request ListFormReportQuestionsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormReportQuestionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormField}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormFieldCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormField} [response] FormField
                     */
    
                    /**
                     * Calls CreateFormField.
                     * @function createFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest} request CreateFormFieldRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormFieldCallback} callback Node-style callback called with the error, if any, and FormField
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormField = function createFormField(request, callback) {
                        return this.rpcCall(createFormField, $root.palexy.task_management.v1.CreateFormFieldRequest, $root.palexy.task_management.v1.FormField, request, callback);
                    }, "name", { value: "CreateFormField" });
    
                    /**
                     * Calls CreateFormField.
                     * @function createFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest} request CreateFormFieldRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormField>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormBlock}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormBlockCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Block} [response] Block
                     */
    
                    /**
                     * Calls CreateFormBlock.
                     * @function createFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest} request CreateFormBlockRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormBlockCallback} callback Node-style callback called with the error, if any, and Block
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormBlock = function createFormBlock(request, callback) {
                        return this.rpcCall(createFormBlock, $root.palexy.task_management.v1.CreateFormBlockRequest, $root.palexy.task_management.v1.Block, request, callback);
                    }, "name", { value: "CreateFormBlock" });
    
                    /**
                     * Calls CreateFormBlock.
                     * @function createFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest} request CreateFormBlockRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Block>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormBlock}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormBlockCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Block} [response] Block
                     */
    
                    /**
                     * Calls UpdateFormBlock.
                     * @function updateFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest} request UpdateFormBlockRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormBlockCallback} callback Node-style callback called with the error, if any, and Block
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormBlock = function updateFormBlock(request, callback) {
                        return this.rpcCall(updateFormBlock, $root.palexy.task_management.v1.UpdateFormBlockRequest, $root.palexy.task_management.v1.Block, request, callback);
                    }, "name", { value: "UpdateFormBlock" });
    
                    /**
                     * Calls UpdateFormBlock.
                     * @function updateFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest} request UpdateFormBlockRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Block>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormBlock}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormBlockCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormBlock.
                     * @function deleteFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest} request DeleteFormBlockRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormBlockCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormBlock = function deleteFormBlock(request, callback) {
                        return this.rpcCall(deleteFormBlock, $root.palexy.task_management.v1.DeleteFormBlockRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormBlock" });
    
                    /**
                     * Calls DeleteFormBlock.
                     * @function deleteFormBlock
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest} request DeleteFormBlockRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormFields}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormFieldsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormFieldsResponse} [response] ListFormFieldsResponse
                     */
    
                    /**
                     * Calls ListFormFields.
                     * @function listFormFields
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormFieldsRequest} request ListFormFieldsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormFieldsCallback} callback Node-style callback called with the error, if any, and ListFormFieldsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormFields = function listFormFields(request, callback) {
                        return this.rpcCall(listFormFields, $root.palexy.task_management.v1.ListFormFieldsRequest, $root.palexy.task_management.v1.ListFormFieldsResponse, request, callback);
                    }, "name", { value: "ListFormFields" });
    
                    /**
                     * Calls ListFormFields.
                     * @function listFormFields
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormFieldsRequest} request ListFormFieldsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormFieldsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormField}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormFieldCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormField} [response] FormField
                     */
    
                    /**
                     * Calls GetFormField.
                     * @function getFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormFieldRequest} request GetFormFieldRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormFieldCallback} callback Node-style callback called with the error, if any, and FormField
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormField = function getFormField(request, callback) {
                        return this.rpcCall(getFormField, $root.palexy.task_management.v1.GetFormFieldRequest, $root.palexy.task_management.v1.FormField, request, callback);
                    }, "name", { value: "GetFormField" });
    
                    /**
                     * Calls GetFormField.
                     * @function getFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormFieldRequest} request GetFormFieldRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormField>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormField}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormFieldCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormField} [response] FormField
                     */
    
                    /**
                     * Calls UpdateFormField.
                     * @function updateFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest} request UpdateFormFieldRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormFieldCallback} callback Node-style callback called with the error, if any, and FormField
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormField = function updateFormField(request, callback) {
                        return this.rpcCall(updateFormField, $root.palexy.task_management.v1.UpdateFormFieldRequest, $root.palexy.task_management.v1.FormField, request, callback);
                    }, "name", { value: "UpdateFormField" });
    
                    /**
                     * Calls UpdateFormField.
                     * @function updateFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest} request UpdateFormFieldRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormField>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormField}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormFieldCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormField.
                     * @function deleteFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest} request DeleteFormFieldRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormFieldCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormField = function deleteFormField(request, callback) {
                        return this.rpcCall(deleteFormField, $root.palexy.task_management.v1.DeleteFormFieldRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormField" });
    
                    /**
                     * Calls DeleteFormField.
                     * @function deleteFormField
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest} request DeleteFormFieldRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormTranslations}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormTranslationsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormTranslationsResponse} [response] ListFormTranslationsResponse
                     */
    
                    /**
                     * Calls ListFormTranslations.
                     * @function listFormTranslations
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest} request ListFormTranslationsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormTranslationsCallback} callback Node-style callback called with the error, if any, and ListFormTranslationsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormTranslations = function listFormTranslations(request, callback) {
                        return this.rpcCall(listFormTranslations, $root.palexy.task_management.v1.ListFormTranslationsRequest, $root.palexy.task_management.v1.ListFormTranslationsResponse, request, callback);
                    }, "name", { value: "ListFormTranslations" });
    
                    /**
                     * Calls ListFormTranslations.
                     * @function listFormTranslations
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest} request ListFormTranslationsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormTranslationsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormTranslation}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormTranslationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormTranslation} [response] FormTranslation
                     */
    
                    /**
                     * Calls CreateFormTranslation.
                     * @function createFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest} request CreateFormTranslationRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormTranslationCallback} callback Node-style callback called with the error, if any, and FormTranslation
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormTranslation = function createFormTranslation(request, callback) {
                        return this.rpcCall(createFormTranslation, $root.palexy.task_management.v1.CreateFormTranslationRequest, $root.palexy.task_management.v1.FormTranslation, request, callback);
                    }, "name", { value: "CreateFormTranslation" });
    
                    /**
                     * Calls CreateFormTranslation.
                     * @function createFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest} request CreateFormTranslationRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormTranslation>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormTranslation}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormTranslationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormTranslation} [response] FormTranslation
                     */
    
                    /**
                     * Calls UpdateFormTranslation.
                     * @function updateFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest} request UpdateFormTranslationRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormTranslationCallback} callback Node-style callback called with the error, if any, and FormTranslation
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormTranslation = function updateFormTranslation(request, callback) {
                        return this.rpcCall(updateFormTranslation, $root.palexy.task_management.v1.UpdateFormTranslationRequest, $root.palexy.task_management.v1.FormTranslation, request, callback);
                    }, "name", { value: "UpdateFormTranslation" });
    
                    /**
                     * Calls UpdateFormTranslation.
                     * @function updateFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest} request UpdateFormTranslationRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormTranslation>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormTranslation}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormTranslationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormTranslation.
                     * @function deleteFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest} request DeleteFormTranslationRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormTranslationCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormTranslation = function deleteFormTranslation(request, callback) {
                        return this.rpcCall(deleteFormTranslation, $root.palexy.task_management.v1.DeleteFormTranslationRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormTranslation" });
    
                    /**
                     * Calls DeleteFormTranslation.
                     * @function deleteFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest} request DeleteFormTranslationRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormTranslationItems}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormTranslationItemsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormTranslationItemsResponse} [response] ListFormTranslationItemsResponse
                     */
    
                    /**
                     * Calls ListFormTranslationItems.
                     * @function listFormTranslationItems
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest} request ListFormTranslationItemsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormTranslationItemsCallback} callback Node-style callback called with the error, if any, and ListFormTranslationItemsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormTranslationItems = function listFormTranslationItems(request, callback) {
                        return this.rpcCall(listFormTranslationItems, $root.palexy.task_management.v1.ListFormTranslationItemsRequest, $root.palexy.task_management.v1.ListFormTranslationItemsResponse, request, callback);
                    }, "name", { value: "ListFormTranslationItems" });
    
                    /**
                     * Calls ListFormTranslationItems.
                     * @function listFormTranslationItems
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest} request ListFormTranslationItemsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormTranslationItemsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormTranslationItem}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormTranslationItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormTranslationItem} [response] FormTranslationItem
                     */
    
                    /**
                     * Calls UpdateFormTranslationItem.
                     * @function updateFormTranslationItem
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest} request UpdateFormTranslationItemRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormTranslationItemCallback} callback Node-style callback called with the error, if any, and FormTranslationItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormTranslationItem = function updateFormTranslationItem(request, callback) {
                        return this.rpcCall(updateFormTranslationItem, $root.palexy.task_management.v1.UpdateFormTranslationItemRequest, $root.palexy.task_management.v1.FormTranslationItem, request, callback);
                    }, "name", { value: "UpdateFormTranslationItem" });
    
                    /**
                     * Calls UpdateFormTranslationItem.
                     * @function updateFormTranslationItem
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest} request UpdateFormTranslationItemRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormTranslationItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#writeFormTranslationItem}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef WriteFormTranslationItemCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormTranslationItem} [response] FormTranslationItem
                     */
    
                    /**
                     * Calls WriteFormTranslationItem.
                     * @function writeFormTranslationItem
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest} request WriteFormTranslationItemRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.WriteFormTranslationItemCallback} callback Node-style callback called with the error, if any, and FormTranslationItem
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.writeFormTranslationItem = function writeFormTranslationItem(request, callback) {
                        return this.rpcCall(writeFormTranslationItem, $root.palexy.task_management.v1.WriteFormTranslationItemRequest, $root.palexy.task_management.v1.FormTranslationItem, request, callback);
                    }, "name", { value: "WriteFormTranslationItem" });
    
                    /**
                     * Calls WriteFormTranslationItem.
                     * @function writeFormTranslationItem
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest} request WriteFormTranslationItemRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormTranslationItem>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#generateFormTranslation}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GenerateFormTranslationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.GenerateFormTranslationResponse} [response] GenerateFormTranslationResponse
                     */
    
                    /**
                     * Calls GenerateFormTranslation.
                     * @function generateFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest} request GenerateFormTranslationRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GenerateFormTranslationCallback} callback Node-style callback called with the error, if any, and GenerateFormTranslationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.generateFormTranslation = function generateFormTranslation(request, callback) {
                        return this.rpcCall(generateFormTranslation, $root.palexy.task_management.v1.GenerateFormTranslationRequest, $root.palexy.task_management.v1.GenerateFormTranslationResponse, request, callback);
                    }, "name", { value: "GenerateFormTranslation" });
    
                    /**
                     * Calls GenerateFormTranslation.
                     * @function generateFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest} request GenerateFormTranslationRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.GenerateFormTranslationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#markFormTranslationItemsUpToDate}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef MarkFormTranslationItemsUpToDateCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} [response] MarkFormTranslationItemsUpToDateResponse
                     */
    
                    /**
                     * Calls MarkFormTranslationItemsUpToDate.
                     * @function markFormTranslationItemsUpToDate
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest} request MarkFormTranslationItemsUpToDateRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.MarkFormTranslationItemsUpToDateCallback} callback Node-style callback called with the error, if any, and MarkFormTranslationItemsUpToDateResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.markFormTranslationItemsUpToDate = function markFormTranslationItemsUpToDate(request, callback) {
                        return this.rpcCall(markFormTranslationItemsUpToDate, $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest, $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse, request, callback);
                    }, "name", { value: "MarkFormTranslationItemsUpToDate" });
    
                    /**
                     * Calls MarkFormTranslationItemsUpToDate.
                     * @function markFormTranslationItemsUpToDate
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest} request MarkFormTranslationItemsUpToDateRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#importFormTranslation}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ImportFormTranslationCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ImportFormTranslationResponse} [response] ImportFormTranslationResponse
                     */
    
                    /**
                     * Calls ImportFormTranslation.
                     * @function importFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest} request ImportFormTranslationRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ImportFormTranslationCallback} callback Node-style callback called with the error, if any, and ImportFormTranslationResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.importFormTranslation = function importFormTranslation(request, callback) {
                        return this.rpcCall(importFormTranslation, $root.palexy.task_management.v1.ImportFormTranslationRequest, $root.palexy.task_management.v1.ImportFormTranslationResponse, request, callback);
                    }, "name", { value: "ImportFormTranslation" });
    
                    /**
                     * Calls ImportFormTranslation.
                     * @function importFormTranslation
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest} request ImportFormTranslationRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ImportFormTranslationResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormSubmission}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormSubmissionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormSubmission} [response] FormSubmission
                     */
    
                    /**
                     * Calls CreateFormSubmission.
                     * @function createFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest} request CreateFormSubmissionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormSubmissionCallback} callback Node-style callback called with the error, if any, and FormSubmission
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormSubmission = function createFormSubmission(request, callback) {
                        return this.rpcCall(createFormSubmission, $root.palexy.task_management.v1.CreateFormSubmissionRequest, $root.palexy.task_management.v1.FormSubmission, request, callback);
                    }, "name", { value: "CreateFormSubmission" });
    
                    /**
                     * Calls CreateFormSubmission.
                     * @function createFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest} request CreateFormSubmissionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormSubmission>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#validateRecipientAccess}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ValidateRecipientAccessCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls ValidateRecipientAccess.
                     * @function validateRecipientAccess
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest} request ValidateRecipientAccessRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ValidateRecipientAccessCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.validateRecipientAccess = function validateRecipientAccess(request, callback) {
                        return this.rpcCall(validateRecipientAccess, $root.palexy.task_management.v1.ValidateRecipientAccessRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "ValidateRecipientAccess" });
    
                    /**
                     * Calls ValidateRecipientAccess.
                     * @function validateRecipientAccess
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest} request ValidateRecipientAccessRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormSubmissions}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormSubmissionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormSubmissionsResponse} [response] ListFormSubmissionsResponse
                     */
    
                    /**
                     * Calls ListFormSubmissions.
                     * @function listFormSubmissions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest} request ListFormSubmissionsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormSubmissionsCallback} callback Node-style callback called with the error, if any, and ListFormSubmissionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormSubmissions = function listFormSubmissions(request, callback) {
                        return this.rpcCall(listFormSubmissions, $root.palexy.task_management.v1.ListFormSubmissionsRequest, $root.palexy.task_management.v1.ListFormSubmissionsResponse, request, callback);
                    }, "name", { value: "ListFormSubmissions" });
    
                    /**
                     * Calls ListFormSubmissions.
                     * @function listFormSubmissions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest} request ListFormSubmissionsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormSubmissionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormSubmission}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormSubmissionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormSubmission} [response] FormSubmission
                     */
    
                    /**
                     * Calls GetFormSubmission.
                     * @function getFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest} request GetFormSubmissionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormSubmissionCallback} callback Node-style callback called with the error, if any, and FormSubmission
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormSubmission = function getFormSubmission(request, callback) {
                        return this.rpcCall(getFormSubmission, $root.palexy.task_management.v1.GetFormSubmissionRequest, $root.palexy.task_management.v1.FormSubmission, request, callback);
                    }, "name", { value: "GetFormSubmission" });
    
                    /**
                     * Calls GetFormSubmission.
                     * @function getFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest} request GetFormSubmissionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormSubmission>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormSubmission}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormSubmissionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormSubmission} [response] FormSubmission
                     */
    
                    /**
                     * Calls UpdateFormSubmission.
                     * @function updateFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest} request UpdateFormSubmissionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormSubmissionCallback} callback Node-style callback called with the error, if any, and FormSubmission
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormSubmission = function updateFormSubmission(request, callback) {
                        return this.rpcCall(updateFormSubmission, $root.palexy.task_management.v1.UpdateFormSubmissionRequest, $root.palexy.task_management.v1.FormSubmission, request, callback);
                    }, "name", { value: "UpdateFormSubmission" });
    
                    /**
                     * Calls UpdateFormSubmission.
                     * @function updateFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest} request UpdateFormSubmissionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormSubmission>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormSubmission}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormSubmissionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormSubmission.
                     * @function deleteFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest} request DeleteFormSubmissionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormSubmissionCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormSubmission = function deleteFormSubmission(request, callback) {
                        return this.rpcCall(deleteFormSubmission, $root.palexy.task_management.v1.DeleteFormSubmissionRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormSubmission" });
    
                    /**
                     * Calls DeleteFormSubmission.
                     * @function deleteFormSubmission
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest} request DeleteFormSubmissionRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormDistribution}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormDistributionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormDistribution} [response] FormDistribution
                     */
    
                    /**
                     * Calls CreateFormDistribution.
                     * @function createFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest} request CreateFormDistributionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormDistributionCallback} callback Node-style callback called with the error, if any, and FormDistribution
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormDistribution = function createFormDistribution(request, callback) {
                        return this.rpcCall(createFormDistribution, $root.palexy.task_management.v1.CreateFormDistributionRequest, $root.palexy.task_management.v1.FormDistribution, request, callback);
                    }, "name", { value: "CreateFormDistribution" });
    
                    /**
                     * Calls CreateFormDistribution.
                     * @function createFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest} request CreateFormDistributionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormDistribution>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormContactList}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormContactList} [response] FormContactList
                     */
    
                    /**
                     * Calls CreateFormContactList.
                     * @function createFormContactList
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest} request CreateFormContactListRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormContactListCallback} callback Node-style callback called with the error, if any, and FormContactList
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormContactList = function createFormContactList(request, callback) {
                        return this.rpcCall(createFormContactList, $root.palexy.task_management.v1.CreateFormContactListRequest, $root.palexy.task_management.v1.FormContactList, request, callback);
                    }, "name", { value: "CreateFormContactList" });
    
                    /**
                     * Calls CreateFormContactList.
                     * @function createFormContactList
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest} request CreateFormContactListRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormContactList>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormContactLists}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormContactListsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormContactListsResponse} [response] ListFormContactListsResponse
                     */
    
                    /**
                     * Calls ListFormContactLists.
                     * @function listFormContactLists
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormContactListsRequest} request ListFormContactListsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormContactListsCallback} callback Node-style callback called with the error, if any, and ListFormContactListsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormContactLists = function listFormContactLists(request, callback) {
                        return this.rpcCall(listFormContactLists, $root.palexy.task_management.v1.ListFormContactListsRequest, $root.palexy.task_management.v1.ListFormContactListsResponse, request, callback);
                    }, "name", { value: "ListFormContactLists" });
    
                    /**
                     * Calls ListFormContactLists.
                     * @function listFormContactLists
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormContactListsRequest} request ListFormContactListsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormContactListsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormContactListRecipients}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormContactListRecipientsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormContactListRecipientsResponse} [response] ListFormContactListRecipientsResponse
                     */
    
                    /**
                     * Calls ListFormContactListRecipients.
                     * @function listFormContactListRecipients
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest} request ListFormContactListRecipientsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormContactListRecipientsCallback} callback Node-style callback called with the error, if any, and ListFormContactListRecipientsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormContactListRecipients = function listFormContactListRecipients(request, callback) {
                        return this.rpcCall(listFormContactListRecipients, $root.palexy.task_management.v1.ListFormContactListRecipientsRequest, $root.palexy.task_management.v1.ListFormContactListRecipientsResponse, request, callback);
                    }, "name", { value: "ListFormContactListRecipients" });
    
                    /**
                     * Calls ListFormContactListRecipients.
                     * @function listFormContactListRecipients
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest} request ListFormContactListRecipientsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormContactListRecipientsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormContactList}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormContactList.
                     * @function deleteFormContactList
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest} request DeleteFormContactListRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormContactListCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormContactList = function deleteFormContactList(request, callback) {
                        return this.rpcCall(deleteFormContactList, $root.palexy.task_management.v1.DeleteFormContactListRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormContactList" });
    
                    /**
                     * Calls DeleteFormContactList.
                     * @function deleteFormContactList
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest} request DeleteFormContactListRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormDistribution}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormDistributionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormDistribution} [response] FormDistribution
                     */
    
                    /**
                     * Calls UpdateFormDistribution.
                     * @function updateFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest} request UpdateFormDistributionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormDistributionCallback} callback Node-style callback called with the error, if any, and FormDistribution
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormDistribution = function updateFormDistribution(request, callback) {
                        return this.rpcCall(updateFormDistribution, $root.palexy.task_management.v1.UpdateFormDistributionRequest, $root.palexy.task_management.v1.FormDistribution, request, callback);
                    }, "name", { value: "UpdateFormDistribution" });
    
                    /**
                     * Calls UpdateFormDistribution.
                     * @function updateFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest} request UpdateFormDistributionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormDistribution>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormDistribution}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormDistributionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormDistribution.
                     * @function deleteFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest} request DeleteFormDistributionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormDistributionCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormDistribution = function deleteFormDistribution(request, callback) {
                        return this.rpcCall(deleteFormDistribution, $root.palexy.task_management.v1.DeleteFormDistributionRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormDistribution" });
    
                    /**
                     * Calls DeleteFormDistribution.
                     * @function deleteFormDistribution
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest} request DeleteFormDistributionRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormDistributions}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormDistributionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormDistributionsResponse} [response] ListFormDistributionsResponse
                     */
    
                    /**
                     * Calls ListFormDistributions.
                     * @function listFormDistributions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest} request ListFormDistributionsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormDistributionsCallback} callback Node-style callback called with the error, if any, and ListFormDistributionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormDistributions = function listFormDistributions(request, callback) {
                        return this.rpcCall(listFormDistributions, $root.palexy.task_management.v1.ListFormDistributionsRequest, $root.palexy.task_management.v1.ListFormDistributionsResponse, request, callback);
                    }, "name", { value: "ListFormDistributions" });
    
                    /**
                     * Calls ListFormDistributions.
                     * @function listFormDistributions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest} request ListFormDistributionsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormDistributionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#findPublishingForms}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef FindPublishingFormsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FindPublishingFormsResponse} [response] FindPublishingFormsResponse
                     */
    
                    /**
                     * Calls FindPublishingForms.
                     * @function findPublishingForms
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest} request FindPublishingFormsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.FindPublishingFormsCallback} callback Node-style callback called with the error, if any, and FindPublishingFormsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.findPublishingForms = function findPublishingForms(request, callback) {
                        return this.rpcCall(findPublishingForms, $root.palexy.task_management.v1.FindPublishingFormsRequest, $root.palexy.task_management.v1.FindPublishingFormsResponse, request, callback);
                    }, "name", { value: "FindPublishingForms" });
    
                    /**
                     * Calls FindPublishingForms.
                     * @function findPublishingForms
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest} request FindPublishingFormsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FindPublishingFormsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getSubmissionStatistics}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetSubmissionStatisticsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.SubmissionStatistics} [response] SubmissionStatistics
                     */
    
                    /**
                     * Calls GetSubmissionStatistics.
                     * @function getSubmissionStatistics
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest} request GetSubmissionStatisticsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetSubmissionStatisticsCallback} callback Node-style callback called with the error, if any, and SubmissionStatistics
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getSubmissionStatistics = function getSubmissionStatistics(request, callback) {
                        return this.rpcCall(getSubmissionStatistics, $root.palexy.task_management.v1.GetSubmissionStatisticsRequest, $root.palexy.task_management.v1.SubmissionStatistics, request, callback);
                    }, "name", { value: "GetSubmissionStatistics" });
    
                    /**
                     * Calls GetSubmissionStatistics.
                     * @function getSubmissionStatistics
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest} request GetSubmissionStatisticsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.SubmissionStatistics>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listOtherTextResponses}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListOtherTextResponsesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListOtherTextResponsesResponse} [response] ListOtherTextResponsesResponse
                     */
    
                    /**
                     * Calls ListOtherTextResponses.
                     * @function listOtherTextResponses
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest} request ListOtherTextResponsesRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListOtherTextResponsesCallback} callback Node-style callback called with the error, if any, and ListOtherTextResponsesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listOtherTextResponses = function listOtherTextResponses(request, callback) {
                        return this.rpcCall(listOtherTextResponses, $root.palexy.task_management.v1.ListOtherTextResponsesRequest, $root.palexy.task_management.v1.ListOtherTextResponsesResponse, request, callback);
                    }, "name", { value: "ListOtherTextResponses" });
    
                    /**
                     * Calls ListOtherTextResponses.
                     * @function listOtherTextResponses
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest} request ListOtherTextResponsesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListOtherTextResponsesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormSubmissionValues}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormSubmissionValuesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormSubmissionValuesResponse} [response] ListFormSubmissionValuesResponse
                     */
    
                    /**
                     * Calls ListFormSubmissionValues.
                     * @function listFormSubmissionValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest} request ListFormSubmissionValuesRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormSubmissionValuesCallback} callback Node-style callback called with the error, if any, and ListFormSubmissionValuesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormSubmissionValues = function listFormSubmissionValues(request, callback) {
                        return this.rpcCall(listFormSubmissionValues, $root.palexy.task_management.v1.ListFormSubmissionValuesRequest, $root.palexy.task_management.v1.ListFormSubmissionValuesResponse, request, callback);
                    }, "name", { value: "ListFormSubmissionValues" });
    
                    /**
                     * Calls ListFormSubmissionValues.
                     * @function listFormSubmissionValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest} request ListFormSubmissionValuesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormSubmissionValuesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormCustomAttribute}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormCustomAttributeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormCustomAttribute} [response] FormCustomAttribute
                     */
    
                    /**
                     * Calls CreateFormCustomAttribute.
                     * @function createFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest} request CreateFormCustomAttributeRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormCustomAttributeCallback} callback Node-style callback called with the error, if any, and FormCustomAttribute
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormCustomAttribute = function createFormCustomAttribute(request, callback) {
                        return this.rpcCall(createFormCustomAttribute, $root.palexy.task_management.v1.CreateFormCustomAttributeRequest, $root.palexy.task_management.v1.FormCustomAttribute, request, callback);
                    }, "name", { value: "CreateFormCustomAttribute" });
    
                    /**
                     * Calls CreateFormCustomAttribute.
                     * @function createFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest} request CreateFormCustomAttributeRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormCustomAttribute>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormCustomAttributes}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormCustomAttributesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormCustomAttributesResponse} [response] ListFormCustomAttributesResponse
                     */
    
                    /**
                     * Calls ListFormCustomAttributes.
                     * @function listFormCustomAttributes
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest} request ListFormCustomAttributesRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormCustomAttributesCallback} callback Node-style callback called with the error, if any, and ListFormCustomAttributesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormCustomAttributes = function listFormCustomAttributes(request, callback) {
                        return this.rpcCall(listFormCustomAttributes, $root.palexy.task_management.v1.ListFormCustomAttributesRequest, $root.palexy.task_management.v1.ListFormCustomAttributesResponse, request, callback);
                    }, "name", { value: "ListFormCustomAttributes" });
    
                    /**
                     * Calls ListFormCustomAttributes.
                     * @function listFormCustomAttributes
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest} request ListFormCustomAttributesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormCustomAttributesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormCustomAttribute}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormCustomAttributeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormCustomAttribute} [response] FormCustomAttribute
                     */
    
                    /**
                     * Calls GetFormCustomAttribute.
                     * @function getFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest} request GetFormCustomAttributeRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormCustomAttributeCallback} callback Node-style callback called with the error, if any, and FormCustomAttribute
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormCustomAttribute = function getFormCustomAttribute(request, callback) {
                        return this.rpcCall(getFormCustomAttribute, $root.palexy.task_management.v1.GetFormCustomAttributeRequest, $root.palexy.task_management.v1.FormCustomAttribute, request, callback);
                    }, "name", { value: "GetFormCustomAttribute" });
    
                    /**
                     * Calls GetFormCustomAttribute.
                     * @function getFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest} request GetFormCustomAttributeRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormCustomAttribute>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormCustomAttribute}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormCustomAttributeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormCustomAttribute} [response] FormCustomAttribute
                     */
    
                    /**
                     * Calls UpdateFormCustomAttribute.
                     * @function updateFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest} request UpdateFormCustomAttributeRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormCustomAttributeCallback} callback Node-style callback called with the error, if any, and FormCustomAttribute
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormCustomAttribute = function updateFormCustomAttribute(request, callback) {
                        return this.rpcCall(updateFormCustomAttribute, $root.palexy.task_management.v1.UpdateFormCustomAttributeRequest, $root.palexy.task_management.v1.FormCustomAttribute, request, callback);
                    }, "name", { value: "UpdateFormCustomAttribute" });
    
                    /**
                     * Calls UpdateFormCustomAttribute.
                     * @function updateFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest} request UpdateFormCustomAttributeRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormCustomAttribute>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormCustomAttribute}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormCustomAttributeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormCustomAttribute.
                     * @function deleteFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest} request DeleteFormCustomAttributeRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormCustomAttributeCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormCustomAttribute = function deleteFormCustomAttribute(request, callback) {
                        return this.rpcCall(deleteFormCustomAttribute, $root.palexy.task_management.v1.DeleteFormCustomAttributeRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormCustomAttribute" });
    
                    /**
                     * Calls DeleteFormCustomAttribute.
                     * @function deleteFormCustomAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest} request DeleteFormCustomAttributeRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#resolveFormLinkAttributeValues}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ResolveFormLinkAttributeValuesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} [response] ResolveFormLinkAttributeValuesResponse
                     */
    
                    /**
                     * Calls ResolveFormLinkAttributeValues.
                     * @function resolveFormLinkAttributeValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest} request ResolveFormLinkAttributeValuesRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ResolveFormLinkAttributeValuesCallback} callback Node-style callback called with the error, if any, and ResolveFormLinkAttributeValuesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.resolveFormLinkAttributeValues = function resolveFormLinkAttributeValues(request, callback) {
                        return this.rpcCall(resolveFormLinkAttributeValues, $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest, $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse, request, callback);
                    }, "name", { value: "ResolveFormLinkAttributeValues" });
    
                    /**
                     * Calls ResolveFormLinkAttributeValues.
                     * @function resolveFormLinkAttributeValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest} request ResolveFormLinkAttributeValuesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormCustomAction}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormCustomActionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormCustomAction} [response] FormCustomAction
                     */
    
                    /**
                     * Calls CreateFormCustomAction.
                     * @function createFormCustomAction
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest} request CreateFormCustomActionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormCustomActionCallback} callback Node-style callback called with the error, if any, and FormCustomAction
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormCustomAction = function createFormCustomAction(request, callback) {
                        return this.rpcCall(createFormCustomAction, $root.palexy.task_management.v1.CreateFormCustomActionRequest, $root.palexy.task_management.v1.FormCustomAction, request, callback);
                    }, "name", { value: "CreateFormCustomAction" });
    
                    /**
                     * Calls CreateFormCustomAction.
                     * @function createFormCustomAction
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest} request CreateFormCustomActionRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormCustomAction>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormCustomActions}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormCustomActionsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormCustomActionsResponse} [response] ListFormCustomActionsResponse
                     */
    
                    /**
                     * Calls ListFormCustomActions.
                     * @function listFormCustomActions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest} request ListFormCustomActionsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormCustomActionsCallback} callback Node-style callback called with the error, if any, and ListFormCustomActionsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormCustomActions = function listFormCustomActions(request, callback) {
                        return this.rpcCall(listFormCustomActions, $root.palexy.task_management.v1.ListFormCustomActionsRequest, $root.palexy.task_management.v1.ListFormCustomActionsResponse, request, callback);
                    }, "name", { value: "ListFormCustomActions" });
    
                    /**
                     * Calls ListFormCustomActions.
                     * @function listFormCustomActions
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest} request ListFormCustomActionsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormCustomActionsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormCustomAction}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormCustomActionCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormCustomAction.
                     * @function deleteFormCustomAction
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest} request DeleteFormCustomActionRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormCustomActionCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormCustomAction = function deleteFormCustomAction(request, callback) {
                        return this.rpcCall(deleteFormCustomAction, $root.palexy.task_management.v1.DeleteFormCustomActionRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormCustomAction" });
    
                    /**
                     * Calls DeleteFormCustomAction.
                     * @function deleteFormCustomAction
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest} request DeleteFormCustomActionRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormSubmissionCustomAttributeValues}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormSubmissionCustomAttributeValuesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} [response] ListFormSubmissionCustomAttributeValuesResponse
                     */
    
                    /**
                     * Calls ListFormSubmissionCustomAttributeValues.
                     * @function listFormSubmissionCustomAttributeValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest} request ListFormSubmissionCustomAttributeValuesRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormSubmissionCustomAttributeValuesCallback} callback Node-style callback called with the error, if any, and ListFormSubmissionCustomAttributeValuesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormSubmissionCustomAttributeValues = function listFormSubmissionCustomAttributeValues(request, callback) {
                        return this.rpcCall(listFormSubmissionCustomAttributeValues, $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest, $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse, request, callback);
                    }, "name", { value: "ListFormSubmissionCustomAttributeValues" });
    
                    /**
                     * Calls ListFormSubmissionCustomAttributeValues.
                     * @function listFormSubmissionCustomAttributeValues
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest} request ListFormSubmissionCustomAttributeValuesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormPassFailSummary}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormPassFailSummaryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormPassFailSummary} [response] FormPassFailSummary
                     */
    
                    /**
                     * Calls GetFormPassFailSummary.
                     * @function getFormPassFailSummary
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest} request GetFormPassFailSummaryRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormPassFailSummaryCallback} callback Node-style callback called with the error, if any, and FormPassFailSummary
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormPassFailSummary = function getFormPassFailSummary(request, callback) {
                        return this.rpcCall(getFormPassFailSummary, $root.palexy.task_management.v1.GetFormPassFailSummaryRequest, $root.palexy.task_management.v1.FormPassFailSummary, request, callback);
                    }, "name", { value: "GetFormPassFailSummary" });
    
                    /**
                     * Calls GetFormPassFailSummary.
                     * @function getFormPassFailSummary
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest} request GetFormPassFailSummaryRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormPassFailSummary>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#getFormSentimentSummary}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef GetFormSentimentSummaryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormSentimentSummary} [response] FormSentimentSummary
                     */
    
                    /**
                     * Calls GetFormSentimentSummary.
                     * @function getFormSentimentSummary
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest} request GetFormSentimentSummaryRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.GetFormSentimentSummaryCallback} callback Node-style callback called with the error, if any, and FormSentimentSummary
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.getFormSentimentSummary = function getFormSentimentSummary(request, callback) {
                        return this.rpcCall(getFormSentimentSummary, $root.palexy.task_management.v1.GetFormSentimentSummaryRequest, $root.palexy.task_management.v1.FormSentimentSummary, request, callback);
                    }, "name", { value: "GetFormSentimentSummary" });
    
                    /**
                     * Calls GetFormSentimentSummary.
                     * @function getFormSentimentSummary
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest} request GetFormSentimentSummaryRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormSentimentSummary>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#evaluateFormSubmissionAttribute}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef EvaluateFormSubmissionAttributeCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} [response] EvaluateFormSubmissionAttributeResponse
                     */
    
                    /**
                     * Calls EvaluateFormSubmissionAttribute.
                     * @function evaluateFormSubmissionAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest} request EvaluateFormSubmissionAttributeRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.EvaluateFormSubmissionAttributeCallback} callback Node-style callback called with the error, if any, and EvaluateFormSubmissionAttributeResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.evaluateFormSubmissionAttribute = function evaluateFormSubmissionAttribute(request, callback) {
                        return this.rpcCall(evaluateFormSubmissionAttribute, $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest, $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse, request, callback);
                    }, "name", { value: "EvaluateFormSubmissionAttribute" });
    
                    /**
                     * Calls EvaluateFormSubmissionAttribute.
                     * @function evaluateFormSubmissionAttribute
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest} request EvaluateFormSubmissionAttributeRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#upsertFormSubmissionAttributeValue}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpsertFormSubmissionAttributeValueCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} [response] UpsertFormSubmissionAttributeValueResponse
                     */
    
                    /**
                     * Calls UpsertFormSubmissionAttributeValue.
                     * @function upsertFormSubmissionAttributeValue
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest} request UpsertFormSubmissionAttributeValueRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpsertFormSubmissionAttributeValueCallback} callback Node-style callback called with the error, if any, and UpsertFormSubmissionAttributeValueResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.upsertFormSubmissionAttributeValue = function upsertFormSubmissionAttributeValue(request, callback) {
                        return this.rpcCall(upsertFormSubmissionAttributeValue, $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest, $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse, request, callback);
                    }, "name", { value: "UpsertFormSubmissionAttributeValue" });
    
                    /**
                     * Calls UpsertFormSubmissionAttributeValue.
                     * @function upsertFormSubmissionAttributeValue
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest} request UpsertFormSubmissionAttributeValueRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#syncReviews}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef SyncReviewsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.SyncReviewsResponse} [response] SyncReviewsResponse
                     */
    
                    /**
                     * Calls SyncReviews.
                     * @function syncReviews
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ISyncReviewsRequest} request SyncReviewsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.SyncReviewsCallback} callback Node-style callback called with the error, if any, and SyncReviewsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.syncReviews = function syncReviews(request, callback) {
                        return this.rpcCall(syncReviews, $root.palexy.task_management.v1.SyncReviewsRequest, $root.palexy.task_management.v1.SyncReviewsResponse, request, callback);
                    }, "name", { value: "SyncReviews" });
    
                    /**
                     * Calls SyncReviews.
                     * @function syncReviews
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ISyncReviewsRequest} request SyncReviewsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.SyncReviewsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#processReviewSyncJob}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ProcessReviewSyncJobCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ProcessReviewSyncJobResponse} [response] ProcessReviewSyncJobResponse
                     */
    
                    /**
                     * Calls ProcessReviewSyncJob.
                     * @function processReviewSyncJob
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest} request ProcessReviewSyncJobRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ProcessReviewSyncJobCallback} callback Node-style callback called with the error, if any, and ProcessReviewSyncJobResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.processReviewSyncJob = function processReviewSyncJob(request, callback) {
                        return this.rpcCall(processReviewSyncJob, $root.palexy.task_management.v1.ProcessReviewSyncJobRequest, $root.palexy.task_management.v1.ProcessReviewSyncJobResponse, request, callback);
                    }, "name", { value: "ProcessReviewSyncJob" });
    
                    /**
                     * Calls ProcessReviewSyncJob.
                     * @function processReviewSyncJob
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest} request ProcessReviewSyncJobRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ProcessReviewSyncJobResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listFormThemePresets}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListFormThemePresetsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListFormThemePresetsResponse} [response] ListFormThemePresetsResponse
                     */
    
                    /**
                     * Calls ListFormThemePresets.
                     * @function listFormThemePresets
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest} request ListFormThemePresetsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListFormThemePresetsCallback} callback Node-style callback called with the error, if any, and ListFormThemePresetsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listFormThemePresets = function listFormThemePresets(request, callback) {
                        return this.rpcCall(listFormThemePresets, $root.palexy.task_management.v1.ListFormThemePresetsRequest, $root.palexy.task_management.v1.ListFormThemePresetsResponse, request, callback);
                    }, "name", { value: "ListFormThemePresets" });
    
                    /**
                     * Calls ListFormThemePresets.
                     * @function listFormThemePresets
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest} request ListFormThemePresetsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListFormThemePresetsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#updateFormThemePreset}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef UpdateFormThemePresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormThemePreset} [response] FormThemePreset
                     */
    
                    /**
                     * Calls UpdateFormThemePreset.
                     * @function updateFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest} request UpdateFormThemePresetRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.UpdateFormThemePresetCallback} callback Node-style callback called with the error, if any, and FormThemePreset
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.updateFormThemePreset = function updateFormThemePreset(request, callback) {
                        return this.rpcCall(updateFormThemePreset, $root.palexy.task_management.v1.UpdateFormThemePresetRequest, $root.palexy.task_management.v1.FormThemePreset, request, callback);
                    }, "name", { value: "UpdateFormThemePreset" });
    
                    /**
                     * Calls UpdateFormThemePreset.
                     * @function updateFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest} request UpdateFormThemePresetRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormThemePreset>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#createFormThemePreset}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef CreateFormThemePresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.FormThemePreset} [response] FormThemePreset
                     */
    
                    /**
                     * Calls CreateFormThemePreset.
                     * @function createFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest} request CreateFormThemePresetRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.CreateFormThemePresetCallback} callback Node-style callback called with the error, if any, and FormThemePreset
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.createFormThemePreset = function createFormThemePreset(request, callback) {
                        return this.rpcCall(createFormThemePreset, $root.palexy.task_management.v1.CreateFormThemePresetRequest, $root.palexy.task_management.v1.FormThemePreset, request, callback);
                    }, "name", { value: "CreateFormThemePreset" });
    
                    /**
                     * Calls CreateFormThemePreset.
                     * @function createFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest} request CreateFormThemePresetRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.FormThemePreset>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#deleteFormThemePreset}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef DeleteFormThemePresetCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteFormThemePreset.
                     * @function deleteFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest} request DeleteFormThemePresetRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.DeleteFormThemePresetCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.deleteFormThemePreset = function deleteFormThemePreset(request, callback) {
                        return this.rpcCall(deleteFormThemePreset, $root.palexy.task_management.v1.DeleteFormThemePresetRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteFormThemePreset" });
    
                    /**
                     * Calls DeleteFormThemePreset.
                     * @function deleteFormThemePreset
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest} request DeleteFormThemePresetRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#aggregateReputationData}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef AggregateReputationDataCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.AggregateReputationDataResponse} [response] AggregateReputationDataResponse
                     */
    
                    /**
                     * Calls AggregateReputationData.
                     * @function aggregateReputationData
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest} request AggregateReputationDataRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.AggregateReputationDataCallback} callback Node-style callback called with the error, if any, and AggregateReputationDataResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.aggregateReputationData = function aggregateReputationData(request, callback) {
                        return this.rpcCall(aggregateReputationData, $root.palexy.task_management.v1.AggregateReputationDataRequest, $root.palexy.task_management.v1.AggregateReputationDataResponse, request, callback);
                    }, "name", { value: "AggregateReputationData" });
    
                    /**
                     * Calls AggregateReputationData.
                     * @function aggregateReputationData
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest} request AggregateReputationDataRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.AggregateReputationDataResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.FormService#listReputationReviews}.
                     * @memberof palexy.task_management.v1.FormService
                     * @typedef ListReputationReviewsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListReputationReviewsResponse} [response] ListReputationReviewsResponse
                     */
    
                    /**
                     * Calls ListReputationReviews.
                     * @function listReputationReviews
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest} request ListReputationReviewsRequest message or plain object
                     * @param {palexy.task_management.v1.FormService.ListReputationReviewsCallback} callback Node-style callback called with the error, if any, and ListReputationReviewsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(FormService.prototype.listReputationReviews = function listReputationReviews(request, callback) {
                        return this.rpcCall(listReputationReviews, $root.palexy.task_management.v1.ListReputationReviewsRequest, $root.palexy.task_management.v1.ListReputationReviewsResponse, request, callback);
                    }, "name", { value: "ListReputationReviews" });
    
                    /**
                     * Calls ListReputationReviews.
                     * @function listReputationReviews
                     * @memberof palexy.task_management.v1.FormService
                     * @instance
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest} request ListReputationReviewsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListReputationReviewsResponse>} Promise
                     * @variation 2
                     */
    
                    return FormService;
                })();
    
                v1.TaskFormSubmission = (function() {
    
                    /**
                     * Properties of a TaskFormSubmission.
                     * @memberof palexy.task_management.v1
                     * @interface ITaskFormSubmission
                     * @property {number|null} [id] TaskFormSubmission id
                     * @property {number|null} [taskId] TaskFormSubmission taskId
                     * @property {number|null} [formId] TaskFormSubmission formId
                     * @property {number|null} [submissionId] TaskFormSubmission submissionId
                     */
    
                    /**
                     * Constructs a new TaskFormSubmission.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TaskFormSubmission.
                     * @implements ITaskFormSubmission
                     * @constructor
                     * @param {palexy.task_management.v1.ITaskFormSubmission=} [properties] Properties to set
                     */
                    function TaskFormSubmission(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TaskFormSubmission id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @instance
                     */
                    TaskFormSubmission.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFormSubmission taskId.
                     * @member {number} taskId
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @instance
                     */
                    TaskFormSubmission.prototype.taskId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFormSubmission formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @instance
                     */
                    TaskFormSubmission.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TaskFormSubmission submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @instance
                     */
                    TaskFormSubmission.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new TaskFormSubmission instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {palexy.task_management.v1.ITaskFormSubmission=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TaskFormSubmission} TaskFormSubmission instance
                     */
                    TaskFormSubmission.create = function create(properties) {
                        return new TaskFormSubmission(properties);
                    };
    
                    /**
                     * Encodes the specified TaskFormSubmission message. Does not implicitly {@link palexy.task_management.v1.TaskFormSubmission.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {palexy.task_management.v1.ITaskFormSubmission} message TaskFormSubmission message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFormSubmission.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.taskId != null && Object.hasOwnProperty.call(message, "taskId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.taskId);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.submissionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TaskFormSubmission message, length delimited. Does not implicitly {@link palexy.task_management.v1.TaskFormSubmission.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {palexy.task_management.v1.ITaskFormSubmission} message TaskFormSubmission message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TaskFormSubmission.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TaskFormSubmission message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TaskFormSubmission} TaskFormSubmission
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFormSubmission.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TaskFormSubmission();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.taskId = reader.int64();
                                break;
                            case 3:
                                message.formId = reader.int64();
                                break;
                            case 4:
                                message.submissionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TaskFormSubmission message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TaskFormSubmission} TaskFormSubmission
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TaskFormSubmission.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TaskFormSubmission message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TaskFormSubmission.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (!$util.isInteger(message.taskId) && !(message.taskId && $util.isInteger(message.taskId.low) && $util.isInteger(message.taskId.high)))
                                return "taskId: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a TaskFormSubmission message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TaskFormSubmission} TaskFormSubmission
                     */
                    TaskFormSubmission.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TaskFormSubmission)
                            return object;
                        var message = new $root.palexy.task_management.v1.TaskFormSubmission();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.taskId != null)
                            if ($util.Long)
                                (message.taskId = $util.Long.fromValue(object.taskId)).unsigned = false;
                            else if (typeof object.taskId === "string")
                                message.taskId = parseInt(object.taskId, 10);
                            else if (typeof object.taskId === "number")
                                message.taskId = object.taskId;
                            else if (typeof object.taskId === "object")
                                message.taskId = new $util.LongBits(object.taskId.low >>> 0, object.taskId.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TaskFormSubmission message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @static
                     * @param {palexy.task_management.v1.TaskFormSubmission} message TaskFormSubmission
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TaskFormSubmission.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.taskId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.taskId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.taskId != null && message.hasOwnProperty("taskId"))
                            if (typeof message.taskId === "number")
                                object.taskId = options.longs === String ? String(message.taskId) : message.taskId;
                            else
                                object.taskId = options.longs === String ? $util.Long.prototype.toString.call(message.taskId) : options.longs === Number ? new $util.LongBits(message.taskId.low >>> 0, message.taskId.high >>> 0).toNumber() : message.taskId;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        return object;
                    };
    
                    /**
                     * Converts this TaskFormSubmission to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TaskFormSubmission
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TaskFormSubmission.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TaskFormSubmission;
                })();
    
                v1.Form = (function() {
    
                    /**
                     * Properties of a Form.
                     * @memberof palexy.task_management.v1
                     * @interface IForm
                     * @property {number|null} [id] Form id
                     * @property {number|null} [companyId] Form companyId
                     * @property {number|null} [projectId] Form projectId
                     * @property {number|null} [creatorId] Form creatorId
                     * @property {string|null} [name] Form name
                     * @property {string|null} [description] Form description
                     * @property {Array.<palexy.task_management.v1.IFormField>|null} [formFields] Form formFields
                     * @property {Array.<number>|null} [orderedFieldIds] Form orderedFieldIds
                     * @property {palexy.task_management.v1.Form.Status|null} [status] Form status
                     * @property {Array.<palexy.task_management.v1.IBlock>|null} [blocks] Form blocks
                     * @property {Array.<number>|null} [orderedBlockIds] Form orderedBlockIds
                     * @property {number|null} [createdTimeMs] Form createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Form lastUpdateTimeMs
                     * @property {boolean|null} [isDeleted] Form isDeleted
                     * @property {palexy.task_management.v1.Form.NavigationMode|null} [navigationMode] Form navigationMode
                     * @property {number|null} [publishedVersionId] Form publishedVersionId
                     * @property {palexy.task_management.v1.Form.FormType|null} [formType] Form formType
                     * @property {Array.<string>|null} [customReportIds] Form customReportIds
                     * @property {string|null} [baseLanguageCode] Form baseLanguageCode
                     * @property {Array.<palexy.task_management.v1.IFormLanguage>|null} [supportedLanguages] Form supportedLanguages
                     * @property {palexy.task_management.v1.IFormTheme|null} [theme] Form theme
                     */
    
                    /**
                     * Constructs a new Form.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Form.
                     * @implements IForm
                     * @constructor
                     * @param {palexy.task_management.v1.IForm=} [properties] Properties to set
                     */
                    function Form(properties) {
                        this.formFields = [];
                        this.orderedFieldIds = [];
                        this.blocks = [];
                        this.orderedBlockIds = [];
                        this.customReportIds = [];
                        this.supportedLanguages = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Form id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form creatorId.
                     * @member {number} creatorId
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.creatorId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.name = "";
    
                    /**
                     * Form description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.description = "";
    
                    /**
                     * Form formFields.
                     * @member {Array.<palexy.task_management.v1.IFormField>} formFields
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.formFields = $util.emptyArray;
    
                    /**
                     * Form orderedFieldIds.
                     * @member {Array.<number>} orderedFieldIds
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.orderedFieldIds = $util.emptyArray;
    
                    /**
                     * Form status.
                     * @member {palexy.task_management.v1.Form.Status} status
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.status = 0;
    
                    /**
                     * Form blocks.
                     * @member {Array.<palexy.task_management.v1.IBlock>} blocks
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.blocks = $util.emptyArray;
    
                    /**
                     * Form orderedBlockIds.
                     * @member {Array.<number>} orderedBlockIds
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.orderedBlockIds = $util.emptyArray;
    
                    /**
                     * Form createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form isDeleted.
                     * @member {boolean} isDeleted
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.isDeleted = false;
    
                    /**
                     * Form navigationMode.
                     * @member {palexy.task_management.v1.Form.NavigationMode} navigationMode
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.navigationMode = 0;
    
                    /**
                     * Form publishedVersionId.
                     * @member {number} publishedVersionId
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.publishedVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Form formType.
                     * @member {palexy.task_management.v1.Form.FormType} formType
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.formType = 0;
    
                    /**
                     * Form customReportIds.
                     * @member {Array.<string>} customReportIds
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.customReportIds = $util.emptyArray;
    
                    /**
                     * Form baseLanguageCode.
                     * @member {string} baseLanguageCode
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.baseLanguageCode = "";
    
                    /**
                     * Form supportedLanguages.
                     * @member {Array.<palexy.task_management.v1.IFormLanguage>} supportedLanguages
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.supportedLanguages = $util.emptyArray;
    
                    /**
                     * Form theme.
                     * @member {palexy.task_management.v1.IFormTheme|null|undefined} theme
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     */
                    Form.prototype.theme = null;
    
                    /**
                     * Creates a new Form instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {palexy.task_management.v1.IForm=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Form} Form instance
                     */
                    Form.create = function create(properties) {
                        return new Form(properties);
                    };
    
                    /**
                     * Encodes the specified Form message. Does not implicitly {@link palexy.task_management.v1.Form.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {palexy.task_management.v1.IForm} message Form message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Form.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.projectId);
                        if (message.creatorId != null && Object.hasOwnProperty.call(message, "creatorId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.creatorId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.description);
                        if (message.formFields != null && message.formFields.length)
                            for (var i = 0; i < message.formFields.length; ++i)
                                $root.palexy.task_management.v1.FormField.encode(message.formFields[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.orderedFieldIds != null && message.orderedFieldIds.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.orderedFieldIds.length; ++i)
                                writer.int64(message.orderedFieldIds[i]);
                            writer.ldelim();
                        }
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.status);
                        if (message.blocks != null && message.blocks.length)
                            for (var i = 0; i < message.blocks.length; ++i)
                                $root.palexy.task_management.v1.Block.encode(message.blocks[i], writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.orderedBlockIds != null && message.orderedBlockIds.length) {
                            writer.uint32(/* id 11, wireType 2 =*/90).fork();
                            for (var i = 0; i < message.orderedBlockIds.length; ++i)
                                writer.int64(message.orderedBlockIds[i]);
                            writer.ldelim();
                        }
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.lastUpdateTimeMs);
                        if (message.isDeleted != null && Object.hasOwnProperty.call(message, "isDeleted"))
                            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.isDeleted);
                        if (message.navigationMode != null && Object.hasOwnProperty.call(message, "navigationMode"))
                            writer.uint32(/* id 15, wireType 0 =*/120).int32(message.navigationMode);
                        if (message.publishedVersionId != null && Object.hasOwnProperty.call(message, "publishedVersionId"))
                            writer.uint32(/* id 16, wireType 0 =*/128).int64(message.publishedVersionId);
                        if (message.formType != null && Object.hasOwnProperty.call(message, "formType"))
                            writer.uint32(/* id 17, wireType 0 =*/136).int32(message.formType);
                        if (message.customReportIds != null && message.customReportIds.length)
                            for (var i = 0; i < message.customReportIds.length; ++i)
                                writer.uint32(/* id 18, wireType 2 =*/146).string(message.customReportIds[i]);
                        if (message.baseLanguageCode != null && Object.hasOwnProperty.call(message, "baseLanguageCode"))
                            writer.uint32(/* id 19, wireType 2 =*/154).string(message.baseLanguageCode);
                        if (message.supportedLanguages != null && message.supportedLanguages.length)
                            for (var i = 0; i < message.supportedLanguages.length; ++i)
                                $root.palexy.task_management.v1.FormLanguage.encode(message.supportedLanguages[i], writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            $root.palexy.task_management.v1.FormTheme.encode(message.theme, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Form message, length delimited. Does not implicitly {@link palexy.task_management.v1.Form.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {palexy.task_management.v1.IForm} message Form message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Form.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Form message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Form} Form
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Form.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Form();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.projectId = reader.int64();
                                break;
                            case 4:
                                message.creatorId = reader.int64();
                                break;
                            case 5:
                                message.name = reader.string();
                                break;
                            case 6:
                                message.description = reader.string();
                                break;
                            case 7:
                                if (!(message.formFields && message.formFields.length))
                                    message.formFields = [];
                                message.formFields.push($root.palexy.task_management.v1.FormField.decode(reader, reader.uint32()));
                                break;
                            case 8:
                                if (!(message.orderedFieldIds && message.orderedFieldIds.length))
                                    message.orderedFieldIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.orderedFieldIds.push(reader.int64());
                                } else
                                    message.orderedFieldIds.push(reader.int64());
                                break;
                            case 9:
                                message.status = reader.int32();
                                break;
                            case 10:
                                if (!(message.blocks && message.blocks.length))
                                    message.blocks = [];
                                message.blocks.push($root.palexy.task_management.v1.Block.decode(reader, reader.uint32()));
                                break;
                            case 11:
                                if (!(message.orderedBlockIds && message.orderedBlockIds.length))
                                    message.orderedBlockIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.orderedBlockIds.push(reader.int64());
                                } else
                                    message.orderedBlockIds.push(reader.int64());
                                break;
                            case 12:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 13:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 14:
                                message.isDeleted = reader.bool();
                                break;
                            case 15:
                                message.navigationMode = reader.int32();
                                break;
                            case 16:
                                message.publishedVersionId = reader.int64();
                                break;
                            case 17:
                                message.formType = reader.int32();
                                break;
                            case 18:
                                if (!(message.customReportIds && message.customReportIds.length))
                                    message.customReportIds = [];
                                message.customReportIds.push(reader.string());
                                break;
                            case 19:
                                message.baseLanguageCode = reader.string();
                                break;
                            case 20:
                                if (!(message.supportedLanguages && message.supportedLanguages.length))
                                    message.supportedLanguages = [];
                                message.supportedLanguages.push($root.palexy.task_management.v1.FormLanguage.decode(reader, reader.uint32()));
                                break;
                            case 21:
                                message.theme = $root.palexy.task_management.v1.FormTheme.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Form message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Form} Form
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Form.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Form message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Form.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (!$util.isInteger(message.creatorId) && !(message.creatorId && $util.isInteger(message.creatorId.low) && $util.isInteger(message.creatorId.high)))
                                return "creatorId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.formFields != null && message.hasOwnProperty("formFields")) {
                            if (!Array.isArray(message.formFields))
                                return "formFields: array expected";
                            for (var i = 0; i < message.formFields.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormField.verify(message.formFields[i]);
                                if (error)
                                    return "formFields." + error;
                            }
                        }
                        if (message.orderedFieldIds != null && message.hasOwnProperty("orderedFieldIds")) {
                            if (!Array.isArray(message.orderedFieldIds))
                                return "orderedFieldIds: array expected";
                            for (var i = 0; i < message.orderedFieldIds.length; ++i)
                                if (!$util.isInteger(message.orderedFieldIds[i]) && !(message.orderedFieldIds[i] && $util.isInteger(message.orderedFieldIds[i].low) && $util.isInteger(message.orderedFieldIds[i].high)))
                                    return "orderedFieldIds: integer|Long[] expected";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.blocks != null && message.hasOwnProperty("blocks")) {
                            if (!Array.isArray(message.blocks))
                                return "blocks: array expected";
                            for (var i = 0; i < message.blocks.length; ++i) {
                                var error = $root.palexy.task_management.v1.Block.verify(message.blocks[i]);
                                if (error)
                                    return "blocks." + error;
                            }
                        }
                        if (message.orderedBlockIds != null && message.hasOwnProperty("orderedBlockIds")) {
                            if (!Array.isArray(message.orderedBlockIds))
                                return "orderedBlockIds: array expected";
                            for (var i = 0; i < message.orderedBlockIds.length; ++i)
                                if (!$util.isInteger(message.orderedBlockIds[i]) && !(message.orderedBlockIds[i] && $util.isInteger(message.orderedBlockIds[i].low) && $util.isInteger(message.orderedBlockIds[i].high)))
                                    return "orderedBlockIds: integer|Long[] expected";
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            if (typeof message.isDeleted !== "boolean")
                                return "isDeleted: boolean expected";
                        if (message.navigationMode != null && message.hasOwnProperty("navigationMode"))
                            switch (message.navigationMode) {
                            default:
                                return "navigationMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.publishedVersionId != null && message.hasOwnProperty("publishedVersionId"))
                            if (!$util.isInteger(message.publishedVersionId) && !(message.publishedVersionId && $util.isInteger(message.publishedVersionId.low) && $util.isInteger(message.publishedVersionId.high)))
                                return "publishedVersionId: integer|Long expected";
                        if (message.formType != null && message.hasOwnProperty("formType"))
                            switch (message.formType) {
                            default:
                                return "formType: enum value expected";
                            case 0:
                            case 1:
                                break;
                            }
                        if (message.customReportIds != null && message.hasOwnProperty("customReportIds")) {
                            if (!Array.isArray(message.customReportIds))
                                return "customReportIds: array expected";
                            for (var i = 0; i < message.customReportIds.length; ++i)
                                if (!$util.isString(message.customReportIds[i]))
                                    return "customReportIds: string[] expected";
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            if (!$util.isString(message.baseLanguageCode))
                                return "baseLanguageCode: string expected";
                        if (message.supportedLanguages != null && message.hasOwnProperty("supportedLanguages")) {
                            if (!Array.isArray(message.supportedLanguages))
                                return "supportedLanguages: array expected";
                            for (var i = 0; i < message.supportedLanguages.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormLanguage.verify(message.supportedLanguages[i]);
                                if (error)
                                    return "supportedLanguages." + error;
                            }
                        }
                        if (message.theme != null && message.hasOwnProperty("theme")) {
                            var error = $root.palexy.task_management.v1.FormTheme.verify(message.theme);
                            if (error)
                                return "theme." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Form message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Form} Form
                     */
                    Form.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Form)
                            return object;
                        var message = new $root.palexy.task_management.v1.Form();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.creatorId != null)
                            if ($util.Long)
                                (message.creatorId = $util.Long.fromValue(object.creatorId)).unsigned = false;
                            else if (typeof object.creatorId === "string")
                                message.creatorId = parseInt(object.creatorId, 10);
                            else if (typeof object.creatorId === "number")
                                message.creatorId = object.creatorId;
                            else if (typeof object.creatorId === "object")
                                message.creatorId = new $util.LongBits(object.creatorId.low >>> 0, object.creatorId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.formFields) {
                            if (!Array.isArray(object.formFields))
                                throw TypeError(".palexy.task_management.v1.Form.formFields: array expected");
                            message.formFields = [];
                            for (var i = 0; i < object.formFields.length; ++i) {
                                if (typeof object.formFields[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Form.formFields: object expected");
                                message.formFields[i] = $root.palexy.task_management.v1.FormField.fromObject(object.formFields[i]);
                            }
                        }
                        if (object.orderedFieldIds) {
                            if (!Array.isArray(object.orderedFieldIds))
                                throw TypeError(".palexy.task_management.v1.Form.orderedFieldIds: array expected");
                            message.orderedFieldIds = [];
                            for (var i = 0; i < object.orderedFieldIds.length; ++i)
                                if ($util.Long)
                                    (message.orderedFieldIds[i] = $util.Long.fromValue(object.orderedFieldIds[i])).unsigned = false;
                                else if (typeof object.orderedFieldIds[i] === "string")
                                    message.orderedFieldIds[i] = parseInt(object.orderedFieldIds[i], 10);
                                else if (typeof object.orderedFieldIds[i] === "number")
                                    message.orderedFieldIds[i] = object.orderedFieldIds[i];
                                else if (typeof object.orderedFieldIds[i] === "object")
                                    message.orderedFieldIds[i] = new $util.LongBits(object.orderedFieldIds[i].low >>> 0, object.orderedFieldIds[i].high >>> 0).toNumber();
                        }
                        switch (object.status) {
                        case "UNKNOWN":
                        case 0:
                            message.status = 0;
                            break;
                        case "DRAFT":
                        case 1:
                            message.status = 1;
                            break;
                        case "PUBLISHED":
                        case 2:
                            message.status = 2;
                            break;
                        case "ARCHIVED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.blocks) {
                            if (!Array.isArray(object.blocks))
                                throw TypeError(".palexy.task_management.v1.Form.blocks: array expected");
                            message.blocks = [];
                            for (var i = 0; i < object.blocks.length; ++i) {
                                if (typeof object.blocks[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Form.blocks: object expected");
                                message.blocks[i] = $root.palexy.task_management.v1.Block.fromObject(object.blocks[i]);
                            }
                        }
                        if (object.orderedBlockIds) {
                            if (!Array.isArray(object.orderedBlockIds))
                                throw TypeError(".palexy.task_management.v1.Form.orderedBlockIds: array expected");
                            message.orderedBlockIds = [];
                            for (var i = 0; i < object.orderedBlockIds.length; ++i)
                                if ($util.Long)
                                    (message.orderedBlockIds[i] = $util.Long.fromValue(object.orderedBlockIds[i])).unsigned = false;
                                else if (typeof object.orderedBlockIds[i] === "string")
                                    message.orderedBlockIds[i] = parseInt(object.orderedBlockIds[i], 10);
                                else if (typeof object.orderedBlockIds[i] === "number")
                                    message.orderedBlockIds[i] = object.orderedBlockIds[i];
                                else if (typeof object.orderedBlockIds[i] === "object")
                                    message.orderedBlockIds[i] = new $util.LongBits(object.orderedBlockIds[i].low >>> 0, object.orderedBlockIds[i].high >>> 0).toNumber();
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.isDeleted != null)
                            message.isDeleted = Boolean(object.isDeleted);
                        switch (object.navigationMode) {
                        case "NAVIGATION_MODE_UNSPECIFIED":
                        case 0:
                            message.navigationMode = 0;
                            break;
                        case "LINEAR":
                        case 1:
                            message.navigationMode = 1;
                            break;
                        case "NON_LINEAR":
                        case 2:
                            message.navigationMode = 2;
                            break;
                        }
                        if (object.publishedVersionId != null)
                            if ($util.Long)
                                (message.publishedVersionId = $util.Long.fromValue(object.publishedVersionId)).unsigned = false;
                            else if (typeof object.publishedVersionId === "string")
                                message.publishedVersionId = parseInt(object.publishedVersionId, 10);
                            else if (typeof object.publishedVersionId === "number")
                                message.publishedVersionId = object.publishedVersionId;
                            else if (typeof object.publishedVersionId === "object")
                                message.publishedVersionId = new $util.LongBits(object.publishedVersionId.low >>> 0, object.publishedVersionId.high >>> 0).toNumber();
                        switch (object.formType) {
                        case "REGULAR":
                        case 0:
                            message.formType = 0;
                            break;
                        case "REPUTATION":
                        case 1:
                            message.formType = 1;
                            break;
                        }
                        if (object.customReportIds) {
                            if (!Array.isArray(object.customReportIds))
                                throw TypeError(".palexy.task_management.v1.Form.customReportIds: array expected");
                            message.customReportIds = [];
                            for (var i = 0; i < object.customReportIds.length; ++i)
                                message.customReportIds[i] = String(object.customReportIds[i]);
                        }
                        if (object.baseLanguageCode != null)
                            message.baseLanguageCode = String(object.baseLanguageCode);
                        if (object.supportedLanguages) {
                            if (!Array.isArray(object.supportedLanguages))
                                throw TypeError(".palexy.task_management.v1.Form.supportedLanguages: array expected");
                            message.supportedLanguages = [];
                            for (var i = 0; i < object.supportedLanguages.length; ++i) {
                                if (typeof object.supportedLanguages[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Form.supportedLanguages: object expected");
                                message.supportedLanguages[i] = $root.palexy.task_management.v1.FormLanguage.fromObject(object.supportedLanguages[i]);
                            }
                        }
                        if (object.theme != null) {
                            if (typeof object.theme !== "object")
                                throw TypeError(".palexy.task_management.v1.Form.theme: object expected");
                            message.theme = $root.palexy.task_management.v1.FormTheme.fromObject(object.theme);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Form message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Form
                     * @static
                     * @param {palexy.task_management.v1.Form} message Form
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Form.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.formFields = [];
                            object.orderedFieldIds = [];
                            object.blocks = [];
                            object.orderedBlockIds = [];
                            object.customReportIds = [];
                            object.supportedLanguages = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.creatorId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.creatorId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            object.status = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.isDeleted = false;
                            object.navigationMode = options.enums === String ? "NAVIGATION_MODE_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.publishedVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.publishedVersionId = options.longs === String ? "0" : 0;
                            object.formType = options.enums === String ? "REGULAR" : 0;
                            object.baseLanguageCode = "";
                            object.theme = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.creatorId != null && message.hasOwnProperty("creatorId"))
                            if (typeof message.creatorId === "number")
                                object.creatorId = options.longs === String ? String(message.creatorId) : message.creatorId;
                            else
                                object.creatorId = options.longs === String ? $util.Long.prototype.toString.call(message.creatorId) : options.longs === Number ? new $util.LongBits(message.creatorId.low >>> 0, message.creatorId.high >>> 0).toNumber() : message.creatorId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.formFields && message.formFields.length) {
                            object.formFields = [];
                            for (var j = 0; j < message.formFields.length; ++j)
                                object.formFields[j] = $root.palexy.task_management.v1.FormField.toObject(message.formFields[j], options);
                        }
                        if (message.orderedFieldIds && message.orderedFieldIds.length) {
                            object.orderedFieldIds = [];
                            for (var j = 0; j < message.orderedFieldIds.length; ++j)
                                if (typeof message.orderedFieldIds[j] === "number")
                                    object.orderedFieldIds[j] = options.longs === String ? String(message.orderedFieldIds[j]) : message.orderedFieldIds[j];
                                else
                                    object.orderedFieldIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.orderedFieldIds[j]) : options.longs === Number ? new $util.LongBits(message.orderedFieldIds[j].low >>> 0, message.orderedFieldIds[j].high >>> 0).toNumber() : message.orderedFieldIds[j];
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.task_management.v1.Form.Status[message.status] : message.status;
                        if (message.blocks && message.blocks.length) {
                            object.blocks = [];
                            for (var j = 0; j < message.blocks.length; ++j)
                                object.blocks[j] = $root.palexy.task_management.v1.Block.toObject(message.blocks[j], options);
                        }
                        if (message.orderedBlockIds && message.orderedBlockIds.length) {
                            object.orderedBlockIds = [];
                            for (var j = 0; j < message.orderedBlockIds.length; ++j)
                                if (typeof message.orderedBlockIds[j] === "number")
                                    object.orderedBlockIds[j] = options.longs === String ? String(message.orderedBlockIds[j]) : message.orderedBlockIds[j];
                                else
                                    object.orderedBlockIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.orderedBlockIds[j]) : options.longs === Number ? new $util.LongBits(message.orderedBlockIds[j].low >>> 0, message.orderedBlockIds[j].high >>> 0).toNumber() : message.orderedBlockIds[j];
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            object.isDeleted = message.isDeleted;
                        if (message.navigationMode != null && message.hasOwnProperty("navigationMode"))
                            object.navigationMode = options.enums === String ? $root.palexy.task_management.v1.Form.NavigationMode[message.navigationMode] : message.navigationMode;
                        if (message.publishedVersionId != null && message.hasOwnProperty("publishedVersionId"))
                            if (typeof message.publishedVersionId === "number")
                                object.publishedVersionId = options.longs === String ? String(message.publishedVersionId) : message.publishedVersionId;
                            else
                                object.publishedVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.publishedVersionId) : options.longs === Number ? new $util.LongBits(message.publishedVersionId.low >>> 0, message.publishedVersionId.high >>> 0).toNumber() : message.publishedVersionId;
                        if (message.formType != null && message.hasOwnProperty("formType"))
                            object.formType = options.enums === String ? $root.palexy.task_management.v1.Form.FormType[message.formType] : message.formType;
                        if (message.customReportIds && message.customReportIds.length) {
                            object.customReportIds = [];
                            for (var j = 0; j < message.customReportIds.length; ++j)
                                object.customReportIds[j] = message.customReportIds[j];
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            object.baseLanguageCode = message.baseLanguageCode;
                        if (message.supportedLanguages && message.supportedLanguages.length) {
                            object.supportedLanguages = [];
                            for (var j = 0; j < message.supportedLanguages.length; ++j)
                                object.supportedLanguages[j] = $root.palexy.task_management.v1.FormLanguage.toObject(message.supportedLanguages[j], options);
                        }
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = $root.palexy.task_management.v1.FormTheme.toObject(message.theme, options);
                        return object;
                    };
    
                    /**
                     * Converts this Form to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Form
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Form.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Status enum.
                     * @name palexy.task_management.v1.Form.Status
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} DRAFT=1 DRAFT value
                     * @property {number} PUBLISHED=2 PUBLISHED value
                     * @property {number} ARCHIVED=3 ARCHIVED value
                     */
                    Form.Status = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "DRAFT"] = 1;
                        values[valuesById[2] = "PUBLISHED"] = 2;
                        values[valuesById[3] = "ARCHIVED"] = 3;
                        return values;
                    })();
    
                    /**
                     * NavigationMode enum.
                     * @name palexy.task_management.v1.Form.NavigationMode
                     * @enum {number}
                     * @property {number} NAVIGATION_MODE_UNSPECIFIED=0 NAVIGATION_MODE_UNSPECIFIED value
                     * @property {number} LINEAR=1 LINEAR value
                     * @property {number} NON_LINEAR=2 NON_LINEAR value
                     */
                    Form.NavigationMode = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "NAVIGATION_MODE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "LINEAR"] = 1;
                        values[valuesById[2] = "NON_LINEAR"] = 2;
                        return values;
                    })();
    
                    /**
                     * FormType enum.
                     * @name palexy.task_management.v1.Form.FormType
                     * @enum {number}
                     * @property {number} REGULAR=0 REGULAR value
                     * @property {number} REPUTATION=1 REPUTATION value
                     */
                    Form.FormType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "REGULAR"] = 0;
                        values[valuesById[1] = "REPUTATION"] = 1;
                        return values;
                    })();
    
                    return Form;
                })();
    
                v1.Block = (function() {
    
                    /**
                     * Properties of a Block.
                     * @memberof palexy.task_management.v1
                     * @interface IBlock
                     * @property {number|null} [id] Block id
                     * @property {number|null} [formId] Block formId
                     * @property {string|null} [name] Block name
                     * @property {Array.<number>|null} [orderedFieldIds] Block orderedFieldIds
                     * @property {Array.<palexy.task_management.v1.IFormField>|null} [formFields] Block formFields
                     * @property {boolean|null} [randomizeQuestionOrder] Block randomizeQuestionOrder
                     * @property {string|null} [internalBlockId] Block internalBlockId
                     */
    
                    /**
                     * Constructs a new Block.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Block.
                     * @implements IBlock
                     * @constructor
                     * @param {palexy.task_management.v1.IBlock=} [properties] Properties to set
                     */
                    function Block(properties) {
                        this.orderedFieldIds = [];
                        this.formFields = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Block id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Block formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Block name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.name = "";
    
                    /**
                     * Block orderedFieldIds.
                     * @member {Array.<number>} orderedFieldIds
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.orderedFieldIds = $util.emptyArray;
    
                    /**
                     * Block formFields.
                     * @member {Array.<palexy.task_management.v1.IFormField>} formFields
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.formFields = $util.emptyArray;
    
                    /**
                     * Block randomizeQuestionOrder.
                     * @member {boolean} randomizeQuestionOrder
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.randomizeQuestionOrder = false;
    
                    /**
                     * Block internalBlockId.
                     * @member {string} internalBlockId
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     */
                    Block.prototype.internalBlockId = "";
    
                    /**
                     * Creates a new Block instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {palexy.task_management.v1.IBlock=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Block} Block instance
                     */
                    Block.create = function create(properties) {
                        return new Block(properties);
                    };
    
                    /**
                     * Encodes the specified Block message. Does not implicitly {@link palexy.task_management.v1.Block.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {palexy.task_management.v1.IBlock} message Block message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Block.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.orderedFieldIds != null && message.orderedFieldIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.orderedFieldIds.length; ++i)
                                writer.int64(message.orderedFieldIds[i]);
                            writer.ldelim();
                        }
                        if (message.formFields != null && message.formFields.length)
                            for (var i = 0; i < message.formFields.length; ++i)
                                $root.palexy.task_management.v1.FormField.encode(message.formFields[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.randomizeQuestionOrder != null && Object.hasOwnProperty.call(message, "randomizeQuestionOrder"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.randomizeQuestionOrder);
                        if (message.internalBlockId != null && Object.hasOwnProperty.call(message, "internalBlockId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.internalBlockId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Block message, length delimited. Does not implicitly {@link palexy.task_management.v1.Block.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {palexy.task_management.v1.IBlock} message Block message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Block.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Block message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Block} Block
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Block.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Block();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                if (!(message.orderedFieldIds && message.orderedFieldIds.length))
                                    message.orderedFieldIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.orderedFieldIds.push(reader.int64());
                                } else
                                    message.orderedFieldIds.push(reader.int64());
                                break;
                            case 5:
                                if (!(message.formFields && message.formFields.length))
                                    message.formFields = [];
                                message.formFields.push($root.palexy.task_management.v1.FormField.decode(reader, reader.uint32()));
                                break;
                            case 6:
                                message.randomizeQuestionOrder = reader.bool();
                                break;
                            case 7:
                                message.internalBlockId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Block message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Block} Block
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Block.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Block message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Block.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.orderedFieldIds != null && message.hasOwnProperty("orderedFieldIds")) {
                            if (!Array.isArray(message.orderedFieldIds))
                                return "orderedFieldIds: array expected";
                            for (var i = 0; i < message.orderedFieldIds.length; ++i)
                                if (!$util.isInteger(message.orderedFieldIds[i]) && !(message.orderedFieldIds[i] && $util.isInteger(message.orderedFieldIds[i].low) && $util.isInteger(message.orderedFieldIds[i].high)))
                                    return "orderedFieldIds: integer|Long[] expected";
                        }
                        if (message.formFields != null && message.hasOwnProperty("formFields")) {
                            if (!Array.isArray(message.formFields))
                                return "formFields: array expected";
                            for (var i = 0; i < message.formFields.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormField.verify(message.formFields[i]);
                                if (error)
                                    return "formFields." + error;
                            }
                        }
                        if (message.randomizeQuestionOrder != null && message.hasOwnProperty("randomizeQuestionOrder"))
                            if (typeof message.randomizeQuestionOrder !== "boolean")
                                return "randomizeQuestionOrder: boolean expected";
                        if (message.internalBlockId != null && message.hasOwnProperty("internalBlockId"))
                            if (!$util.isString(message.internalBlockId))
                                return "internalBlockId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a Block message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Block} Block
                     */
                    Block.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Block)
                            return object;
                        var message = new $root.palexy.task_management.v1.Block();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.orderedFieldIds) {
                            if (!Array.isArray(object.orderedFieldIds))
                                throw TypeError(".palexy.task_management.v1.Block.orderedFieldIds: array expected");
                            message.orderedFieldIds = [];
                            for (var i = 0; i < object.orderedFieldIds.length; ++i)
                                if ($util.Long)
                                    (message.orderedFieldIds[i] = $util.Long.fromValue(object.orderedFieldIds[i])).unsigned = false;
                                else if (typeof object.orderedFieldIds[i] === "string")
                                    message.orderedFieldIds[i] = parseInt(object.orderedFieldIds[i], 10);
                                else if (typeof object.orderedFieldIds[i] === "number")
                                    message.orderedFieldIds[i] = object.orderedFieldIds[i];
                                else if (typeof object.orderedFieldIds[i] === "object")
                                    message.orderedFieldIds[i] = new $util.LongBits(object.orderedFieldIds[i].low >>> 0, object.orderedFieldIds[i].high >>> 0).toNumber();
                        }
                        if (object.formFields) {
                            if (!Array.isArray(object.formFields))
                                throw TypeError(".palexy.task_management.v1.Block.formFields: array expected");
                            message.formFields = [];
                            for (var i = 0; i < object.formFields.length; ++i) {
                                if (typeof object.formFields[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.Block.formFields: object expected");
                                message.formFields[i] = $root.palexy.task_management.v1.FormField.fromObject(object.formFields[i]);
                            }
                        }
                        if (object.randomizeQuestionOrder != null)
                            message.randomizeQuestionOrder = Boolean(object.randomizeQuestionOrder);
                        if (object.internalBlockId != null)
                            message.internalBlockId = String(object.internalBlockId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Block message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Block
                     * @static
                     * @param {palexy.task_management.v1.Block} message Block
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Block.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.orderedFieldIds = [];
                            object.formFields = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.randomizeQuestionOrder = false;
                            object.internalBlockId = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.orderedFieldIds && message.orderedFieldIds.length) {
                            object.orderedFieldIds = [];
                            for (var j = 0; j < message.orderedFieldIds.length; ++j)
                                if (typeof message.orderedFieldIds[j] === "number")
                                    object.orderedFieldIds[j] = options.longs === String ? String(message.orderedFieldIds[j]) : message.orderedFieldIds[j];
                                else
                                    object.orderedFieldIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.orderedFieldIds[j]) : options.longs === Number ? new $util.LongBits(message.orderedFieldIds[j].low >>> 0, message.orderedFieldIds[j].high >>> 0).toNumber() : message.orderedFieldIds[j];
                        }
                        if (message.formFields && message.formFields.length) {
                            object.formFields = [];
                            for (var j = 0; j < message.formFields.length; ++j)
                                object.formFields[j] = $root.palexy.task_management.v1.FormField.toObject(message.formFields[j], options);
                        }
                        if (message.randomizeQuestionOrder != null && message.hasOwnProperty("randomizeQuestionOrder"))
                            object.randomizeQuestionOrder = message.randomizeQuestionOrder;
                        if (message.internalBlockId != null && message.hasOwnProperty("internalBlockId"))
                            object.internalBlockId = message.internalBlockId;
                        return object;
                    };
    
                    /**
                     * Converts this Block to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Block
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Block.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Block;
                })();
    
                v1.FormVersion = (function() {
    
                    /**
                     * Properties of a FormVersion.
                     * @memberof palexy.task_management.v1
                     * @interface IFormVersion
                     * @property {number|null} [id] FormVersion id
                     * @property {number|null} [formId] FormVersion formId
                     * @property {string|null} [name] FormVersion name
                     * @property {string|null} [description] FormVersion description
                     * @property {number|null} [publishedAtMs] FormVersion publishedAtMs
                     * @property {number|null} [createdBy] FormVersion createdBy
                     * @property {Array.<number>|null} [orderedBlockIds] FormVersion orderedBlockIds
                     * @property {palexy.task_management.v1.Form.NavigationMode|null} [navigationMode] FormVersion navigationMode
                     * @property {number|null} [createdTimeMs] FormVersion createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] FormVersion lastUpdateTimeMs
                     * @property {Array.<palexy.task_management.v1.IBlock>|null} [blocks] FormVersion blocks
                     * @property {string|null} [baseLanguageCode] FormVersion baseLanguageCode
                     * @property {palexy.task_management.v1.IFormTheme|null} [theme] FormVersion theme
                     */
    
                    /**
                     * Constructs a new FormVersion.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormVersion.
                     * @implements IFormVersion
                     * @constructor
                     * @param {palexy.task_management.v1.IFormVersion=} [properties] Properties to set
                     */
                    function FormVersion(properties) {
                        this.orderedBlockIds = [];
                        this.blocks = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormVersion id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.name = "";
    
                    /**
                     * FormVersion description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.description = "";
    
                    /**
                     * FormVersion publishedAtMs.
                     * @member {number} publishedAtMs
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.publishedAtMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion createdBy.
                     * @member {number} createdBy
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.createdBy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion orderedBlockIds.
                     * @member {Array.<number>} orderedBlockIds
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.orderedBlockIds = $util.emptyArray;
    
                    /**
                     * FormVersion navigationMode.
                     * @member {palexy.task_management.v1.Form.NavigationMode} navigationMode
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.navigationMode = 0;
    
                    /**
                     * FormVersion createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormVersion blocks.
                     * @member {Array.<palexy.task_management.v1.IBlock>} blocks
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.blocks = $util.emptyArray;
    
                    /**
                     * FormVersion baseLanguageCode.
                     * @member {string} baseLanguageCode
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.baseLanguageCode = "";
    
                    /**
                     * FormVersion theme.
                     * @member {palexy.task_management.v1.IFormTheme|null|undefined} theme
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     */
                    FormVersion.prototype.theme = null;
    
                    /**
                     * Creates a new FormVersion instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {palexy.task_management.v1.IFormVersion=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormVersion} FormVersion instance
                     */
                    FormVersion.create = function create(properties) {
                        return new FormVersion(properties);
                    };
    
                    /**
                     * Encodes the specified FormVersion message. Does not implicitly {@link palexy.task_management.v1.FormVersion.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {palexy.task_management.v1.IFormVersion} message FormVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormVersion.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.description);
                        if (message.publishedAtMs != null && Object.hasOwnProperty.call(message, "publishedAtMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.publishedAtMs);
                        if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createdBy);
                        if (message.orderedBlockIds != null && message.orderedBlockIds.length) {
                            writer.uint32(/* id 8, wireType 2 =*/66).fork();
                            for (var i = 0; i < message.orderedBlockIds.length; ++i)
                                writer.int64(message.orderedBlockIds[i]);
                            writer.ldelim();
                        }
                        if (message.navigationMode != null && Object.hasOwnProperty.call(message, "navigationMode"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.navigationMode);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int64(message.lastUpdateTimeMs);
                        if (message.blocks != null && message.blocks.length)
                            for (var i = 0; i < message.blocks.length; ++i)
                                $root.palexy.task_management.v1.Block.encode(message.blocks[i], writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        if (message.baseLanguageCode != null && Object.hasOwnProperty.call(message, "baseLanguageCode"))
                            writer.uint32(/* id 13, wireType 2 =*/106).string(message.baseLanguageCode);
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            $root.palexy.task_management.v1.FormTheme.encode(message.theme, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormVersion message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormVersion.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {palexy.task_management.v1.IFormVersion} message FormVersion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormVersion.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormVersion message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormVersion} FormVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormVersion.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormVersion();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.description = reader.string();
                                break;
                            case 6:
                                message.publishedAtMs = reader.int64();
                                break;
                            case 7:
                                message.createdBy = reader.int64();
                                break;
                            case 8:
                                if (!(message.orderedBlockIds && message.orderedBlockIds.length))
                                    message.orderedBlockIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.orderedBlockIds.push(reader.int64());
                                } else
                                    message.orderedBlockIds.push(reader.int64());
                                break;
                            case 9:
                                message.navigationMode = reader.int32();
                                break;
                            case 10:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 11:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 12:
                                if (!(message.blocks && message.blocks.length))
                                    message.blocks = [];
                                message.blocks.push($root.palexy.task_management.v1.Block.decode(reader, reader.uint32()));
                                break;
                            case 13:
                                message.baseLanguageCode = reader.string();
                                break;
                            case 14:
                                message.theme = $root.palexy.task_management.v1.FormTheme.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormVersion message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormVersion} FormVersion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormVersion.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormVersion message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormVersion.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.publishedAtMs != null && message.hasOwnProperty("publishedAtMs"))
                            if (!$util.isInteger(message.publishedAtMs) && !(message.publishedAtMs && $util.isInteger(message.publishedAtMs.low) && $util.isInteger(message.publishedAtMs.high)))
                                return "publishedAtMs: integer|Long expected";
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (!$util.isInteger(message.createdBy) && !(message.createdBy && $util.isInteger(message.createdBy.low) && $util.isInteger(message.createdBy.high)))
                                return "createdBy: integer|Long expected";
                        if (message.orderedBlockIds != null && message.hasOwnProperty("orderedBlockIds")) {
                            if (!Array.isArray(message.orderedBlockIds))
                                return "orderedBlockIds: array expected";
                            for (var i = 0; i < message.orderedBlockIds.length; ++i)
                                if (!$util.isInteger(message.orderedBlockIds[i]) && !(message.orderedBlockIds[i] && $util.isInteger(message.orderedBlockIds[i].low) && $util.isInteger(message.orderedBlockIds[i].high)))
                                    return "orderedBlockIds: integer|Long[] expected";
                        }
                        if (message.navigationMode != null && message.hasOwnProperty("navigationMode"))
                            switch (message.navigationMode) {
                            default:
                                return "navigationMode: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.blocks != null && message.hasOwnProperty("blocks")) {
                            if (!Array.isArray(message.blocks))
                                return "blocks: array expected";
                            for (var i = 0; i < message.blocks.length; ++i) {
                                var error = $root.palexy.task_management.v1.Block.verify(message.blocks[i]);
                                if (error)
                                    return "blocks." + error;
                            }
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            if (!$util.isString(message.baseLanguageCode))
                                return "baseLanguageCode: string expected";
                        if (message.theme != null && message.hasOwnProperty("theme")) {
                            var error = $root.palexy.task_management.v1.FormTheme.verify(message.theme);
                            if (error)
                                return "theme." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormVersion message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormVersion} FormVersion
                     */
                    FormVersion.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormVersion)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormVersion();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.publishedAtMs != null)
                            if ($util.Long)
                                (message.publishedAtMs = $util.Long.fromValue(object.publishedAtMs)).unsigned = false;
                            else if (typeof object.publishedAtMs === "string")
                                message.publishedAtMs = parseInt(object.publishedAtMs, 10);
                            else if (typeof object.publishedAtMs === "number")
                                message.publishedAtMs = object.publishedAtMs;
                            else if (typeof object.publishedAtMs === "object")
                                message.publishedAtMs = new $util.LongBits(object.publishedAtMs.low >>> 0, object.publishedAtMs.high >>> 0).toNumber();
                        if (object.createdBy != null)
                            if ($util.Long)
                                (message.createdBy = $util.Long.fromValue(object.createdBy)).unsigned = false;
                            else if (typeof object.createdBy === "string")
                                message.createdBy = parseInt(object.createdBy, 10);
                            else if (typeof object.createdBy === "number")
                                message.createdBy = object.createdBy;
                            else if (typeof object.createdBy === "object")
                                message.createdBy = new $util.LongBits(object.createdBy.low >>> 0, object.createdBy.high >>> 0).toNumber();
                        if (object.orderedBlockIds) {
                            if (!Array.isArray(object.orderedBlockIds))
                                throw TypeError(".palexy.task_management.v1.FormVersion.orderedBlockIds: array expected");
                            message.orderedBlockIds = [];
                            for (var i = 0; i < object.orderedBlockIds.length; ++i)
                                if ($util.Long)
                                    (message.orderedBlockIds[i] = $util.Long.fromValue(object.orderedBlockIds[i])).unsigned = false;
                                else if (typeof object.orderedBlockIds[i] === "string")
                                    message.orderedBlockIds[i] = parseInt(object.orderedBlockIds[i], 10);
                                else if (typeof object.orderedBlockIds[i] === "number")
                                    message.orderedBlockIds[i] = object.orderedBlockIds[i];
                                else if (typeof object.orderedBlockIds[i] === "object")
                                    message.orderedBlockIds[i] = new $util.LongBits(object.orderedBlockIds[i].low >>> 0, object.orderedBlockIds[i].high >>> 0).toNumber();
                        }
                        switch (object.navigationMode) {
                        case "NAVIGATION_MODE_UNSPECIFIED":
                        case 0:
                            message.navigationMode = 0;
                            break;
                        case "LINEAR":
                        case 1:
                            message.navigationMode = 1;
                            break;
                        case "NON_LINEAR":
                        case 2:
                            message.navigationMode = 2;
                            break;
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.blocks) {
                            if (!Array.isArray(object.blocks))
                                throw TypeError(".palexy.task_management.v1.FormVersion.blocks: array expected");
                            message.blocks = [];
                            for (var i = 0; i < object.blocks.length; ++i) {
                                if (typeof object.blocks[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormVersion.blocks: object expected");
                                message.blocks[i] = $root.palexy.task_management.v1.Block.fromObject(object.blocks[i]);
                            }
                        }
                        if (object.baseLanguageCode != null)
                            message.baseLanguageCode = String(object.baseLanguageCode);
                        if (object.theme != null) {
                            if (typeof object.theme !== "object")
                                throw TypeError(".palexy.task_management.v1.FormVersion.theme: object expected");
                            message.theme = $root.palexy.task_management.v1.FormTheme.fromObject(object.theme);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormVersion message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormVersion
                     * @static
                     * @param {palexy.task_management.v1.FormVersion} message FormVersion
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormVersion.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.orderedBlockIds = [];
                            object.blocks = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.publishedAtMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.publishedAtMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdBy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdBy = options.longs === String ? "0" : 0;
                            object.navigationMode = options.enums === String ? "NAVIGATION_MODE_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.baseLanguageCode = "";
                            object.theme = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.publishedAtMs != null && message.hasOwnProperty("publishedAtMs"))
                            if (typeof message.publishedAtMs === "number")
                                object.publishedAtMs = options.longs === String ? String(message.publishedAtMs) : message.publishedAtMs;
                            else
                                object.publishedAtMs = options.longs === String ? $util.Long.prototype.toString.call(message.publishedAtMs) : options.longs === Number ? new $util.LongBits(message.publishedAtMs.low >>> 0, message.publishedAtMs.high >>> 0).toNumber() : message.publishedAtMs;
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (typeof message.createdBy === "number")
                                object.createdBy = options.longs === String ? String(message.createdBy) : message.createdBy;
                            else
                                object.createdBy = options.longs === String ? $util.Long.prototype.toString.call(message.createdBy) : options.longs === Number ? new $util.LongBits(message.createdBy.low >>> 0, message.createdBy.high >>> 0).toNumber() : message.createdBy;
                        if (message.orderedBlockIds && message.orderedBlockIds.length) {
                            object.orderedBlockIds = [];
                            for (var j = 0; j < message.orderedBlockIds.length; ++j)
                                if (typeof message.orderedBlockIds[j] === "number")
                                    object.orderedBlockIds[j] = options.longs === String ? String(message.orderedBlockIds[j]) : message.orderedBlockIds[j];
                                else
                                    object.orderedBlockIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.orderedBlockIds[j]) : options.longs === Number ? new $util.LongBits(message.orderedBlockIds[j].low >>> 0, message.orderedBlockIds[j].high >>> 0).toNumber() : message.orderedBlockIds[j];
                        }
                        if (message.navigationMode != null && message.hasOwnProperty("navigationMode"))
                            object.navigationMode = options.enums === String ? $root.palexy.task_management.v1.Form.NavigationMode[message.navigationMode] : message.navigationMode;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.blocks && message.blocks.length) {
                            object.blocks = [];
                            for (var j = 0; j < message.blocks.length; ++j)
                                object.blocks[j] = $root.palexy.task_management.v1.Block.toObject(message.blocks[j], options);
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            object.baseLanguageCode = message.baseLanguageCode;
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = $root.palexy.task_management.v1.FormTheme.toObject(message.theme, options);
                        return object;
                    };
    
                    /**
                     * Converts this FormVersion to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormVersion
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormVersion.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormVersion;
                })();
    
                v1.FormTheme = (function() {
    
                    /**
                     * Properties of a FormTheme.
                     * @memberof palexy.task_management.v1
                     * @interface IFormTheme
                     * @property {palexy.task_management.v1.FormTheme.ILogo|null} [logo] FormTheme logo
                     * @property {palexy.task_management.v1.FormTheme.IBackground|null} [background] FormTheme background
                     * @property {palexy.task_management.v1.FormTheme.IColors|null} [colors] FormTheme colors
                     * @property {palexy.task_management.v1.FormTheme.IButtons|null} [buttons] FormTheme buttons
                     * @property {Array.<palexy.task_management.v1.FormTheme.IMediaItem>|null} [media] FormTheme media
                     */
    
                    /**
                     * Constructs a new FormTheme.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormTheme.
                     * @implements IFormTheme
                     * @constructor
                     * @param {palexy.task_management.v1.IFormTheme=} [properties] Properties to set
                     */
                    function FormTheme(properties) {
                        this.media = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormTheme logo.
                     * @member {palexy.task_management.v1.FormTheme.ILogo|null|undefined} logo
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     */
                    FormTheme.prototype.logo = null;
    
                    /**
                     * FormTheme background.
                     * @member {palexy.task_management.v1.FormTheme.IBackground|null|undefined} background
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     */
                    FormTheme.prototype.background = null;
    
                    /**
                     * FormTheme colors.
                     * @member {palexy.task_management.v1.FormTheme.IColors|null|undefined} colors
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     */
                    FormTheme.prototype.colors = null;
    
                    /**
                     * FormTheme buttons.
                     * @member {palexy.task_management.v1.FormTheme.IButtons|null|undefined} buttons
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     */
                    FormTheme.prototype.buttons = null;
    
                    /**
                     * FormTheme media.
                     * @member {Array.<palexy.task_management.v1.FormTheme.IMediaItem>} media
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     */
                    FormTheme.prototype.media = $util.emptyArray;
    
                    /**
                     * Creates a new FormTheme instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {palexy.task_management.v1.IFormTheme=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormTheme} FormTheme instance
                     */
                    FormTheme.create = function create(properties) {
                        return new FormTheme(properties);
                    };
    
                    /**
                     * Encodes the specified FormTheme message. Does not implicitly {@link palexy.task_management.v1.FormTheme.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {palexy.task_management.v1.IFormTheme} message FormTheme message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTheme.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.logo != null && Object.hasOwnProperty.call(message, "logo"))
                            $root.palexy.task_management.v1.FormTheme.Logo.encode(message.logo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.background != null && Object.hasOwnProperty.call(message, "background"))
                            $root.palexy.task_management.v1.FormTheme.Background.encode(message.background, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.colors != null && Object.hasOwnProperty.call(message, "colors"))
                            $root.palexy.task_management.v1.FormTheme.Colors.encode(message.colors, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.buttons != null && Object.hasOwnProperty.call(message, "buttons"))
                            $root.palexy.task_management.v1.FormTheme.Buttons.encode(message.buttons, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.media != null && message.media.length)
                            for (var i = 0; i < message.media.length; ++i)
                                $root.palexy.task_management.v1.FormTheme.MediaItem.encode(message.media[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormTheme message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {palexy.task_management.v1.IFormTheme} message FormTheme message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTheme.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormTheme message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormTheme} FormTheme
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTheme.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.logo = $root.palexy.task_management.v1.FormTheme.Logo.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.background = $root.palexy.task_management.v1.FormTheme.Background.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.colors = $root.palexy.task_management.v1.FormTheme.Colors.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.buttons = $root.palexy.task_management.v1.FormTheme.Buttons.decode(reader, reader.uint32());
                                break;
                            case 5:
                                if (!(message.media && message.media.length))
                                    message.media = [];
                                message.media.push($root.palexy.task_management.v1.FormTheme.MediaItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormTheme message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormTheme} FormTheme
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTheme.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormTheme message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormTheme.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.logo != null && message.hasOwnProperty("logo")) {
                            var error = $root.palexy.task_management.v1.FormTheme.Logo.verify(message.logo);
                            if (error)
                                return "logo." + error;
                        }
                        if (message.background != null && message.hasOwnProperty("background")) {
                            var error = $root.palexy.task_management.v1.FormTheme.Background.verify(message.background);
                            if (error)
                                return "background." + error;
                        }
                        if (message.colors != null && message.hasOwnProperty("colors")) {
                            var error = $root.palexy.task_management.v1.FormTheme.Colors.verify(message.colors);
                            if (error)
                                return "colors." + error;
                        }
                        if (message.buttons != null && message.hasOwnProperty("buttons")) {
                            var error = $root.palexy.task_management.v1.FormTheme.Buttons.verify(message.buttons);
                            if (error)
                                return "buttons." + error;
                        }
                        if (message.media != null && message.hasOwnProperty("media")) {
                            if (!Array.isArray(message.media))
                                return "media: array expected";
                            for (var i = 0; i < message.media.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTheme.MediaItem.verify(message.media[i]);
                                if (error)
                                    return "media." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormTheme message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormTheme} FormTheme
                     */
                    FormTheme.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormTheme)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormTheme();
                        if (object.logo != null) {
                            if (typeof object.logo !== "object")
                                throw TypeError(".palexy.task_management.v1.FormTheme.logo: object expected");
                            message.logo = $root.palexy.task_management.v1.FormTheme.Logo.fromObject(object.logo);
                        }
                        if (object.background != null) {
                            if (typeof object.background !== "object")
                                throw TypeError(".palexy.task_management.v1.FormTheme.background: object expected");
                            message.background = $root.palexy.task_management.v1.FormTheme.Background.fromObject(object.background);
                        }
                        if (object.colors != null) {
                            if (typeof object.colors !== "object")
                                throw TypeError(".palexy.task_management.v1.FormTheme.colors: object expected");
                            message.colors = $root.palexy.task_management.v1.FormTheme.Colors.fromObject(object.colors);
                        }
                        if (object.buttons != null) {
                            if (typeof object.buttons !== "object")
                                throw TypeError(".palexy.task_management.v1.FormTheme.buttons: object expected");
                            message.buttons = $root.palexy.task_management.v1.FormTheme.Buttons.fromObject(object.buttons);
                        }
                        if (object.media) {
                            if (!Array.isArray(object.media))
                                throw TypeError(".palexy.task_management.v1.FormTheme.media: array expected");
                            message.media = [];
                            for (var i = 0; i < object.media.length; ++i) {
                                if (typeof object.media[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormTheme.media: object expected");
                                message.media[i] = $root.palexy.task_management.v1.FormTheme.MediaItem.fromObject(object.media[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormTheme message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormTheme
                     * @static
                     * @param {palexy.task_management.v1.FormTheme} message FormTheme
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormTheme.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.media = [];
                        if (options.defaults) {
                            object.logo = null;
                            object.background = null;
                            object.colors = null;
                            object.buttons = null;
                        }
                        if (message.logo != null && message.hasOwnProperty("logo"))
                            object.logo = $root.palexy.task_management.v1.FormTheme.Logo.toObject(message.logo, options);
                        if (message.background != null && message.hasOwnProperty("background"))
                            object.background = $root.palexy.task_management.v1.FormTheme.Background.toObject(message.background, options);
                        if (message.colors != null && message.hasOwnProperty("colors"))
                            object.colors = $root.palexy.task_management.v1.FormTheme.Colors.toObject(message.colors, options);
                        if (message.buttons != null && message.hasOwnProperty("buttons"))
                            object.buttons = $root.palexy.task_management.v1.FormTheme.Buttons.toObject(message.buttons, options);
                        if (message.media && message.media.length) {
                            object.media = [];
                            for (var j = 0; j < message.media.length; ++j)
                                object.media[j] = $root.palexy.task_management.v1.FormTheme.MediaItem.toObject(message.media[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FormTheme to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormTheme
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormTheme.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    FormTheme.Logo = (function() {
    
                        /**
                         * Properties of a Logo.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @interface ILogo
                         * @property {string|null} [imageUrl] Logo imageUrl
                         * @property {palexy.task_management.v1.FormTheme.Logo.LogoStyle|null} [style] Logo style
                         * @property {palexy.task_management.v1.FormTheme.Logo.Placement|null} [placement] Logo placement
                         * @property {number|null} [maxHeightPx] Logo maxHeightPx
                         * @property {number|null} [mobileScalePercent] Logo mobileScalePercent
                         */
    
                        /**
                         * Constructs a new Logo.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @classdesc Represents a Logo.
                         * @implements ILogo
                         * @constructor
                         * @param {palexy.task_management.v1.FormTheme.ILogo=} [properties] Properties to set
                         */
                        function Logo(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Logo imageUrl.
                         * @member {string} imageUrl
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         */
                        Logo.prototype.imageUrl = "";
    
                        /**
                         * Logo style.
                         * @member {palexy.task_management.v1.FormTheme.Logo.LogoStyle} style
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         */
                        Logo.prototype.style = 0;
    
                        /**
                         * Logo placement.
                         * @member {palexy.task_management.v1.FormTheme.Logo.Placement} placement
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         */
                        Logo.prototype.placement = 0;
    
                        /**
                         * Logo maxHeightPx.
                         * @member {number} maxHeightPx
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         */
                        Logo.prototype.maxHeightPx = 0;
    
                        /**
                         * Logo mobileScalePercent.
                         * @member {number} mobileScalePercent
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         */
                        Logo.prototype.mobileScalePercent = 0;
    
                        /**
                         * Creates a new Logo instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.ILogo=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.FormTheme.Logo} Logo instance
                         */
                        Logo.create = function create(properties) {
                            return new Logo(properties);
                        };
    
                        /**
                         * Encodes the specified Logo message. Does not implicitly {@link palexy.task_management.v1.FormTheme.Logo.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.ILogo} message Logo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Logo.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.imageUrl);
                            if (message.style != null && Object.hasOwnProperty.call(message, "style"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.style);
                            if (message.placement != null && Object.hasOwnProperty.call(message, "placement"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.placement);
                            if (message.maxHeightPx != null && Object.hasOwnProperty.call(message, "maxHeightPx"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.maxHeightPx);
                            if (message.mobileScalePercent != null && Object.hasOwnProperty.call(message, "mobileScalePercent"))
                                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.mobileScalePercent);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Logo message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.Logo.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.ILogo} message Logo message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Logo.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Logo message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.FormTheme.Logo} Logo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Logo.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme.Logo();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.imageUrl = reader.string();
                                    break;
                                case 2:
                                    message.style = reader.int32();
                                    break;
                                case 3:
                                    message.placement = reader.int32();
                                    break;
                                case 4:
                                    message.maxHeightPx = reader.int32();
                                    break;
                                case 5:
                                    message.mobileScalePercent = reader.int32();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Logo message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.FormTheme.Logo} Logo
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Logo.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Logo message.
                         * @function verify
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Logo.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                                if (!$util.isString(message.imageUrl))
                                    return "imageUrl: string expected";
                            if (message.style != null && message.hasOwnProperty("style"))
                                switch (message.style) {
                                default:
                                    return "style: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.placement != null && message.hasOwnProperty("placement"))
                                switch (message.placement) {
                                default:
                                    return "placement: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                            if (message.maxHeightPx != null && message.hasOwnProperty("maxHeightPx"))
                                if (!$util.isInteger(message.maxHeightPx))
                                    return "maxHeightPx: integer expected";
                            if (message.mobileScalePercent != null && message.hasOwnProperty("mobileScalePercent"))
                                if (!$util.isInteger(message.mobileScalePercent))
                                    return "mobileScalePercent: integer expected";
                            return null;
                        };
    
                        /**
                         * Creates a Logo message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.FormTheme.Logo} Logo
                         */
                        Logo.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.FormTheme.Logo)
                                return object;
                            var message = new $root.palexy.task_management.v1.FormTheme.Logo();
                            if (object.imageUrl != null)
                                message.imageUrl = String(object.imageUrl);
                            switch (object.style) {
                            case "LOGO_STYLE_UNSPECIFIED":
                            case 0:
                                message.style = 0;
                                break;
                            case "FLOATING":
                            case 1:
                                message.style = 1;
                                break;
                            case "BANNER":
                            case 2:
                                message.style = 2;
                                break;
                            }
                            switch (object.placement) {
                            case "PLACEMENT_UNSPECIFIED":
                            case 0:
                                message.placement = 0;
                                break;
                            case "LEFT":
                            case 1:
                                message.placement = 1;
                                break;
                            case "CENTER":
                            case 2:
                                message.placement = 2;
                                break;
                            case "RIGHT":
                            case 3:
                                message.placement = 3;
                                break;
                            }
                            if (object.maxHeightPx != null)
                                message.maxHeightPx = object.maxHeightPx | 0;
                            if (object.mobileScalePercent != null)
                                message.mobileScalePercent = object.mobileScalePercent | 0;
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Logo message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.Logo} message Logo
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Logo.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.imageUrl = "";
                                object.style = options.enums === String ? "LOGO_STYLE_UNSPECIFIED" : 0;
                                object.placement = options.enums === String ? "PLACEMENT_UNSPECIFIED" : 0;
                                object.maxHeightPx = 0;
                                object.mobileScalePercent = 0;
                            }
                            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                                object.imageUrl = message.imageUrl;
                            if (message.style != null && message.hasOwnProperty("style"))
                                object.style = options.enums === String ? $root.palexy.task_management.v1.FormTheme.Logo.LogoStyle[message.style] : message.style;
                            if (message.placement != null && message.hasOwnProperty("placement"))
                                object.placement = options.enums === String ? $root.palexy.task_management.v1.FormTheme.Logo.Placement[message.placement] : message.placement;
                            if (message.maxHeightPx != null && message.hasOwnProperty("maxHeightPx"))
                                object.maxHeightPx = message.maxHeightPx;
                            if (message.mobileScalePercent != null && message.hasOwnProperty("mobileScalePercent"))
                                object.mobileScalePercent = message.mobileScalePercent;
                            return object;
                        };
    
                        /**
                         * Converts this Logo to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.FormTheme.Logo
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Logo.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * LogoStyle enum.
                         * @name palexy.task_management.v1.FormTheme.Logo.LogoStyle
                         * @enum {number}
                         * @property {number} LOGO_STYLE_UNSPECIFIED=0 LOGO_STYLE_UNSPECIFIED value
                         * @property {number} FLOATING=1 FLOATING value
                         * @property {number} BANNER=2 BANNER value
                         */
                        Logo.LogoStyle = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "LOGO_STYLE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "FLOATING"] = 1;
                            values[valuesById[2] = "BANNER"] = 2;
                            return values;
                        })();
    
                        /**
                         * Placement enum.
                         * @name palexy.task_management.v1.FormTheme.Logo.Placement
                         * @enum {number}
                         * @property {number} PLACEMENT_UNSPECIFIED=0 PLACEMENT_UNSPECIFIED value
                         * @property {number} LEFT=1 LEFT value
                         * @property {number} CENTER=2 CENTER value
                         * @property {number} RIGHT=3 RIGHT value
                         */
                        Logo.Placement = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "PLACEMENT_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "LEFT"] = 1;
                            values[valuesById[2] = "CENTER"] = 2;
                            values[valuesById[3] = "RIGHT"] = 3;
                            return values;
                        })();
    
                        return Logo;
                    })();
    
                    FormTheme.Background = (function() {
    
                        /**
                         * Properties of a Background.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @interface IBackground
                         * @property {palexy.task_management.v1.FormTheme.Background.BackgroundType|null} [type] Background type
                         * @property {string|null} [color] Background color
                         * @property {string|null} [imageUrl] Background imageUrl
                         * @property {palexy.task_management.v1.FormTheme.Background.Overlay|null} [overlay] Background overlay
                         * @property {number|null} [overlayOpacity] Background overlayOpacity
                         */
    
                        /**
                         * Constructs a new Background.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @classdesc Represents a Background.
                         * @implements IBackground
                         * @constructor
                         * @param {palexy.task_management.v1.FormTheme.IBackground=} [properties] Properties to set
                         */
                        function Background(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Background type.
                         * @member {palexy.task_management.v1.FormTheme.Background.BackgroundType} type
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Background.prototype.type = 0;
    
                        /**
                         * Background color.
                         * @member {string} color
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Background.prototype.color = "";
    
                        /**
                         * Background imageUrl.
                         * @member {string} imageUrl
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Background.prototype.imageUrl = "";
    
                        /**
                         * Background overlay.
                         * @member {palexy.task_management.v1.FormTheme.Background.Overlay} overlay
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Background.prototype.overlay = 0;
    
                        /**
                         * Background overlayOpacity.
                         * @member {number|null|undefined} overlayOpacity
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Background.prototype.overlayOpacity = null;
    
                        // OneOf field names bound to virtual getters and setters
                        var $oneOfFields;
    
                        /**
                         * Background _overlayOpacity.
                         * @member {"overlayOpacity"|undefined} _overlayOpacity
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         */
                        Object.defineProperty(Background.prototype, "_overlayOpacity", {
                            get: $util.oneOfGetter($oneOfFields = ["overlayOpacity"]),
                            set: $util.oneOfSetter($oneOfFields)
                        });
    
                        /**
                         * Creates a new Background instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IBackground=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.FormTheme.Background} Background instance
                         */
                        Background.create = function create(properties) {
                            return new Background(properties);
                        };
    
                        /**
                         * Encodes the specified Background message. Does not implicitly {@link palexy.task_management.v1.FormTheme.Background.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IBackground} message Background message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Background.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.color != null && Object.hasOwnProperty.call(message, "color"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.color);
                            if (message.imageUrl != null && Object.hasOwnProperty.call(message, "imageUrl"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.imageUrl);
                            if (message.overlay != null && Object.hasOwnProperty.call(message, "overlay"))
                                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.overlay);
                            if (message.overlayOpacity != null && Object.hasOwnProperty.call(message, "overlayOpacity"))
                                writer.uint32(/* id 5, wireType 5 =*/45).float(message.overlayOpacity);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Background message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.Background.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IBackground} message Background message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Background.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Background message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.FormTheme.Background} Background
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Background.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme.Background();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.type = reader.int32();
                                    break;
                                case 2:
                                    message.color = reader.string();
                                    break;
                                case 3:
                                    message.imageUrl = reader.string();
                                    break;
                                case 4:
                                    message.overlay = reader.int32();
                                    break;
                                case 5:
                                    message.overlayOpacity = reader.float();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Background message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.FormTheme.Background} Background
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Background.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Background message.
                         * @function verify
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Background.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            var properties = {};
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.color != null && message.hasOwnProperty("color"))
                                if (!$util.isString(message.color))
                                    return "color: string expected";
                            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                                if (!$util.isString(message.imageUrl))
                                    return "imageUrl: string expected";
                            if (message.overlay != null && message.hasOwnProperty("overlay"))
                                switch (message.overlay) {
                                default:
                                    return "overlay: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                            if (message.overlayOpacity != null && message.hasOwnProperty("overlayOpacity")) {
                                properties._overlayOpacity = 1;
                                if (typeof message.overlayOpacity !== "number")
                                    return "overlayOpacity: number expected";
                            }
                            return null;
                        };
    
                        /**
                         * Creates a Background message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.FormTheme.Background} Background
                         */
                        Background.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.FormTheme.Background)
                                return object;
                            var message = new $root.palexy.task_management.v1.FormTheme.Background();
                            switch (object.type) {
                            case "BACKGROUND_TYPE_UNSPECIFIED":
                            case 0:
                                message.type = 0;
                                break;
                            case "COLOR":
                            case 1:
                                message.type = 1;
                                break;
                            case "IMAGE":
                            case 2:
                                message.type = 2;
                                break;
                            }
                            if (object.color != null)
                                message.color = String(object.color);
                            if (object.imageUrl != null)
                                message.imageUrl = String(object.imageUrl);
                            switch (object.overlay) {
                            case "OVERLAY_UNSPECIFIED":
                            case 0:
                                message.overlay = 0;
                                break;
                            case "NONE":
                            case 1:
                                message.overlay = 1;
                                break;
                            case "DARK":
                            case 2:
                                message.overlay = 2;
                                break;
                            case "LIGHT":
                            case 3:
                                message.overlay = 3;
                                break;
                            }
                            if (object.overlayOpacity != null)
                                message.overlayOpacity = Number(object.overlayOpacity);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Background message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.Background} message Background
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Background.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.type = options.enums === String ? "BACKGROUND_TYPE_UNSPECIFIED" : 0;
                                object.color = "";
                                object.imageUrl = "";
                                object.overlay = options.enums === String ? "OVERLAY_UNSPECIFIED" : 0;
                            }
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.palexy.task_management.v1.FormTheme.Background.BackgroundType[message.type] : message.type;
                            if (message.color != null && message.hasOwnProperty("color"))
                                object.color = message.color;
                            if (message.imageUrl != null && message.hasOwnProperty("imageUrl"))
                                object.imageUrl = message.imageUrl;
                            if (message.overlay != null && message.hasOwnProperty("overlay"))
                                object.overlay = options.enums === String ? $root.palexy.task_management.v1.FormTheme.Background.Overlay[message.overlay] : message.overlay;
                            if (message.overlayOpacity != null && message.hasOwnProperty("overlayOpacity")) {
                                object.overlayOpacity = options.json && !isFinite(message.overlayOpacity) ? String(message.overlayOpacity) : message.overlayOpacity;
                                if (options.oneofs)
                                    object._overlayOpacity = "overlayOpacity";
                            }
                            return object;
                        };
    
                        /**
                         * Converts this Background to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.FormTheme.Background
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Background.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * BackgroundType enum.
                         * @name palexy.task_management.v1.FormTheme.Background.BackgroundType
                         * @enum {number}
                         * @property {number} BACKGROUND_TYPE_UNSPECIFIED=0 BACKGROUND_TYPE_UNSPECIFIED value
                         * @property {number} COLOR=1 COLOR value
                         * @property {number} IMAGE=2 IMAGE value
                         */
                        Background.BackgroundType = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "BACKGROUND_TYPE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "COLOR"] = 1;
                            values[valuesById[2] = "IMAGE"] = 2;
                            return values;
                        })();
    
                        /**
                         * Overlay enum.
                         * @name palexy.task_management.v1.FormTheme.Background.Overlay
                         * @enum {number}
                         * @property {number} OVERLAY_UNSPECIFIED=0 OVERLAY_UNSPECIFIED value
                         * @property {number} NONE=1 NONE value
                         * @property {number} DARK=2 DARK value
                         * @property {number} LIGHT=3 LIGHT value
                         */
                        Background.Overlay = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "OVERLAY_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "NONE"] = 1;
                            values[valuesById[2] = "DARK"] = 2;
                            values[valuesById[3] = "LIGHT"] = 3;
                            return values;
                        })();
    
                        return Background;
                    })();
    
                    FormTheme.Colors = (function() {
    
                        /**
                         * Properties of a Colors.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @interface IColors
                         * @property {string|null} [primary] Colors primary
                         * @property {string|null} [questionText] Colors questionText
                         * @property {string|null} [answerText] Colors answerText
                         * @property {string|null} [container] Colors container
                         */
    
                        /**
                         * Constructs a new Colors.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @classdesc Represents a Colors.
                         * @implements IColors
                         * @constructor
                         * @param {palexy.task_management.v1.FormTheme.IColors=} [properties] Properties to set
                         */
                        function Colors(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Colors primary.
                         * @member {string} primary
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @instance
                         */
                        Colors.prototype.primary = "";
    
                        /**
                         * Colors questionText.
                         * @member {string} questionText
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @instance
                         */
                        Colors.prototype.questionText = "";
    
                        /**
                         * Colors answerText.
                         * @member {string} answerText
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @instance
                         */
                        Colors.prototype.answerText = "";
    
                        /**
                         * Colors container.
                         * @member {string} container
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @instance
                         */
                        Colors.prototype.container = "";
    
                        /**
                         * Creates a new Colors instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IColors=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.FormTheme.Colors} Colors instance
                         */
                        Colors.create = function create(properties) {
                            return new Colors(properties);
                        };
    
                        /**
                         * Encodes the specified Colors message. Does not implicitly {@link palexy.task_management.v1.FormTheme.Colors.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IColors} message Colors message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Colors.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.primary != null && Object.hasOwnProperty.call(message, "primary"))
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.primary);
                            if (message.questionText != null && Object.hasOwnProperty.call(message, "questionText"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.questionText);
                            if (message.answerText != null && Object.hasOwnProperty.call(message, "answerText"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.answerText);
                            if (message.container != null && Object.hasOwnProperty.call(message, "container"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.container);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Colors message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.Colors.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IColors} message Colors message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Colors.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Colors message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.FormTheme.Colors} Colors
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Colors.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme.Colors();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.primary = reader.string();
                                    break;
                                case 2:
                                    message.questionText = reader.string();
                                    break;
                                case 3:
                                    message.answerText = reader.string();
                                    break;
                                case 4:
                                    message.container = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Colors message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.FormTheme.Colors} Colors
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Colors.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Colors message.
                         * @function verify
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Colors.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.primary != null && message.hasOwnProperty("primary"))
                                if (!$util.isString(message.primary))
                                    return "primary: string expected";
                            if (message.questionText != null && message.hasOwnProperty("questionText"))
                                if (!$util.isString(message.questionText))
                                    return "questionText: string expected";
                            if (message.answerText != null && message.hasOwnProperty("answerText"))
                                if (!$util.isString(message.answerText))
                                    return "answerText: string expected";
                            if (message.container != null && message.hasOwnProperty("container"))
                                if (!$util.isString(message.container))
                                    return "container: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a Colors message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.FormTheme.Colors} Colors
                         */
                        Colors.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.FormTheme.Colors)
                                return object;
                            var message = new $root.palexy.task_management.v1.FormTheme.Colors();
                            if (object.primary != null)
                                message.primary = String(object.primary);
                            if (object.questionText != null)
                                message.questionText = String(object.questionText);
                            if (object.answerText != null)
                                message.answerText = String(object.answerText);
                            if (object.container != null)
                                message.container = String(object.container);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Colors message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.Colors} message Colors
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Colors.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.primary = "";
                                object.questionText = "";
                                object.answerText = "";
                                object.container = "";
                            }
                            if (message.primary != null && message.hasOwnProperty("primary"))
                                object.primary = message.primary;
                            if (message.questionText != null && message.hasOwnProperty("questionText"))
                                object.questionText = message.questionText;
                            if (message.answerText != null && message.hasOwnProperty("answerText"))
                                object.answerText = message.answerText;
                            if (message.container != null && message.hasOwnProperty("container"))
                                object.container = message.container;
                            return object;
                        };
    
                        /**
                         * Converts this Colors to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.FormTheme.Colors
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Colors.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return Colors;
                    })();
    
                    FormTheme.Buttons = (function() {
    
                        /**
                         * Properties of a Buttons.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @interface IButtons
                         * @property {palexy.task_management.v1.FormTheme.Buttons.ButtonStyle|null} [style] Buttons style
                         * @property {string|null} [nextText] Buttons nextText
                         * @property {string|null} [backText] Buttons backText
                         * @property {string|null} [submitText] Buttons submitText
                         */
    
                        /**
                         * Constructs a new Buttons.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @classdesc Represents a Buttons.
                         * @implements IButtons
                         * @constructor
                         * @param {palexy.task_management.v1.FormTheme.IButtons=} [properties] Properties to set
                         */
                        function Buttons(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * Buttons style.
                         * @member {palexy.task_management.v1.FormTheme.Buttons.ButtonStyle} style
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @instance
                         */
                        Buttons.prototype.style = 0;
    
                        /**
                         * Buttons nextText.
                         * @member {string} nextText
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @instance
                         */
                        Buttons.prototype.nextText = "";
    
                        /**
                         * Buttons backText.
                         * @member {string} backText
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @instance
                         */
                        Buttons.prototype.backText = "";
    
                        /**
                         * Buttons submitText.
                         * @member {string} submitText
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @instance
                         */
                        Buttons.prototype.submitText = "";
    
                        /**
                         * Creates a new Buttons instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IButtons=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.FormTheme.Buttons} Buttons instance
                         */
                        Buttons.create = function create(properties) {
                            return new Buttons(properties);
                        };
    
                        /**
                         * Encodes the specified Buttons message. Does not implicitly {@link palexy.task_management.v1.FormTheme.Buttons.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IButtons} message Buttons message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Buttons.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.style != null && Object.hasOwnProperty.call(message, "style"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.style);
                            if (message.nextText != null && Object.hasOwnProperty.call(message, "nextText"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextText);
                            if (message.backText != null && Object.hasOwnProperty.call(message, "backText"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.backText);
                            if (message.submitText != null && Object.hasOwnProperty.call(message, "submitText"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.submitText);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified Buttons message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.Buttons.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IButtons} message Buttons message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        Buttons.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a Buttons message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.FormTheme.Buttons} Buttons
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Buttons.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme.Buttons();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.style = reader.int32();
                                    break;
                                case 2:
                                    message.nextText = reader.string();
                                    break;
                                case 3:
                                    message.backText = reader.string();
                                    break;
                                case 4:
                                    message.submitText = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a Buttons message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.FormTheme.Buttons} Buttons
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        Buttons.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a Buttons message.
                         * @function verify
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        Buttons.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.style != null && message.hasOwnProperty("style"))
                                switch (message.style) {
                                default:
                                    return "style: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    break;
                                }
                            if (message.nextText != null && message.hasOwnProperty("nextText"))
                                if (!$util.isString(message.nextText))
                                    return "nextText: string expected";
                            if (message.backText != null && message.hasOwnProperty("backText"))
                                if (!$util.isString(message.backText))
                                    return "backText: string expected";
                            if (message.submitText != null && message.hasOwnProperty("submitText"))
                                if (!$util.isString(message.submitText))
                                    return "submitText: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a Buttons message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.FormTheme.Buttons} Buttons
                         */
                        Buttons.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.FormTheme.Buttons)
                                return object;
                            var message = new $root.palexy.task_management.v1.FormTheme.Buttons();
                            switch (object.style) {
                            case "BUTTON_STYLE_UNSPECIFIED":
                            case 0:
                                message.style = 0;
                                break;
                            case "FILLED":
                            case 1:
                                message.style = 1;
                                break;
                            case "OUTLINED":
                            case 2:
                                message.style = 2;
                                break;
                            case "FLAT":
                            case 3:
                                message.style = 3;
                                break;
                            }
                            if (object.nextText != null)
                                message.nextText = String(object.nextText);
                            if (object.backText != null)
                                message.backText = String(object.backText);
                            if (object.submitText != null)
                                message.submitText = String(object.submitText);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a Buttons message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.Buttons} message Buttons
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        Buttons.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.style = options.enums === String ? "BUTTON_STYLE_UNSPECIFIED" : 0;
                                object.nextText = "";
                                object.backText = "";
                                object.submitText = "";
                            }
                            if (message.style != null && message.hasOwnProperty("style"))
                                object.style = options.enums === String ? $root.palexy.task_management.v1.FormTheme.Buttons.ButtonStyle[message.style] : message.style;
                            if (message.nextText != null && message.hasOwnProperty("nextText"))
                                object.nextText = message.nextText;
                            if (message.backText != null && message.hasOwnProperty("backText"))
                                object.backText = message.backText;
                            if (message.submitText != null && message.hasOwnProperty("submitText"))
                                object.submitText = message.submitText;
                            return object;
                        };
    
                        /**
                         * Converts this Buttons to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.FormTheme.Buttons
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        Buttons.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * ButtonStyle enum.
                         * @name palexy.task_management.v1.FormTheme.Buttons.ButtonStyle
                         * @enum {number}
                         * @property {number} BUTTON_STYLE_UNSPECIFIED=0 BUTTON_STYLE_UNSPECIFIED value
                         * @property {number} FILLED=1 FILLED value
                         * @property {number} OUTLINED=2 OUTLINED value
                         * @property {number} FLAT=3 FLAT value
                         */
                        Buttons.ButtonStyle = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "BUTTON_STYLE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "FILLED"] = 1;
                            values[valuesById[2] = "OUTLINED"] = 2;
                            values[valuesById[3] = "FLAT"] = 3;
                            return values;
                        })();
    
                        return Buttons;
                    })();
    
                    FormTheme.MediaItem = (function() {
    
                        /**
                         * Properties of a MediaItem.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @interface IMediaItem
                         * @property {palexy.task_management.v1.FormTheme.MediaItem.MediaType|null} [type] MediaItem type
                         * @property {string|null} [source] MediaItem source
                         * @property {palexy.task_management.v1.FormTheme.MediaItem.Placement|null} [placement] MediaItem placement
                         * @property {string|null} [altText] MediaItem altText
                         */
    
                        /**
                         * Constructs a new MediaItem.
                         * @memberof palexy.task_management.v1.FormTheme
                         * @classdesc Represents a MediaItem.
                         * @implements IMediaItem
                         * @constructor
                         * @param {palexy.task_management.v1.FormTheme.IMediaItem=} [properties] Properties to set
                         */
                        function MediaItem(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * MediaItem type.
                         * @member {palexy.task_management.v1.FormTheme.MediaItem.MediaType} type
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @instance
                         */
                        MediaItem.prototype.type = 0;
    
                        /**
                         * MediaItem source.
                         * @member {string} source
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @instance
                         */
                        MediaItem.prototype.source = "";
    
                        /**
                         * MediaItem placement.
                         * @member {palexy.task_management.v1.FormTheme.MediaItem.Placement} placement
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @instance
                         */
                        MediaItem.prototype.placement = 0;
    
                        /**
                         * MediaItem altText.
                         * @member {string} altText
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @instance
                         */
                        MediaItem.prototype.altText = "";
    
                        /**
                         * Creates a new MediaItem instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IMediaItem=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.FormTheme.MediaItem} MediaItem instance
                         */
                        MediaItem.create = function create(properties) {
                            return new MediaItem(properties);
                        };
    
                        /**
                         * Encodes the specified MediaItem message. Does not implicitly {@link palexy.task_management.v1.FormTheme.MediaItem.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IMediaItem} message MediaItem message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MediaItem.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                            if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                                writer.uint32(/* id 2, wireType 2 =*/18).string(message.source);
                            if (message.placement != null && Object.hasOwnProperty.call(message, "placement"))
                                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.placement);
                            if (message.altText != null && Object.hasOwnProperty.call(message, "altText"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.altText);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified MediaItem message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTheme.MediaItem.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.IMediaItem} message MediaItem message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        MediaItem.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a MediaItem message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.FormTheme.MediaItem} MediaItem
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MediaItem.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTheme.MediaItem();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.type = reader.int32();
                                    break;
                                case 2:
                                    message.source = reader.string();
                                    break;
                                case 3:
                                    message.placement = reader.int32();
                                    break;
                                case 4:
                                    message.altText = reader.string();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a MediaItem message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.FormTheme.MediaItem} MediaItem
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        MediaItem.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a MediaItem message.
                         * @function verify
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        MediaItem.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.type != null && message.hasOwnProperty("type"))
                                switch (message.type) {
                                default:
                                    return "type: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.source != null && message.hasOwnProperty("source"))
                                if (!$util.isString(message.source))
                                    return "source: string expected";
                            if (message.placement != null && message.hasOwnProperty("placement"))
                                switch (message.placement) {
                                default:
                                    return "placement: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                    break;
                                }
                            if (message.altText != null && message.hasOwnProperty("altText"))
                                if (!$util.isString(message.altText))
                                    return "altText: string expected";
                            return null;
                        };
    
                        /**
                         * Creates a MediaItem message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.FormTheme.MediaItem} MediaItem
                         */
                        MediaItem.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.FormTheme.MediaItem)
                                return object;
                            var message = new $root.palexy.task_management.v1.FormTheme.MediaItem();
                            switch (object.type) {
                            case "MEDIA_TYPE_UNSPECIFIED":
                            case 0:
                                message.type = 0;
                                break;
                            case "IMAGE":
                            case 1:
                                message.type = 1;
                                break;
                            case "VIDEO":
                            case 2:
                                message.type = 2;
                                break;
                            }
                            if (object.source != null)
                                message.source = String(object.source);
                            switch (object.placement) {
                            case "PLACEMENT_UNSPECIFIED":
                            case 0:
                                message.placement = 0;
                                break;
                            case "HEADER":
                            case 1:
                                message.placement = 1;
                                break;
                            case "FOOTER":
                            case 2:
                                message.placement = 2;
                                break;
                            }
                            if (object.altText != null)
                                message.altText = String(object.altText);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a MediaItem message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @static
                         * @param {palexy.task_management.v1.FormTheme.MediaItem} message MediaItem
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        MediaItem.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                object.type = options.enums === String ? "MEDIA_TYPE_UNSPECIFIED" : 0;
                                object.source = "";
                                object.placement = options.enums === String ? "PLACEMENT_UNSPECIFIED" : 0;
                                object.altText = "";
                            }
                            if (message.type != null && message.hasOwnProperty("type"))
                                object.type = options.enums === String ? $root.palexy.task_management.v1.FormTheme.MediaItem.MediaType[message.type] : message.type;
                            if (message.source != null && message.hasOwnProperty("source"))
                                object.source = message.source;
                            if (message.placement != null && message.hasOwnProperty("placement"))
                                object.placement = options.enums === String ? $root.palexy.task_management.v1.FormTheme.MediaItem.Placement[message.placement] : message.placement;
                            if (message.altText != null && message.hasOwnProperty("altText"))
                                object.altText = message.altText;
                            return object;
                        };
    
                        /**
                         * Converts this MediaItem to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.FormTheme.MediaItem
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        MediaItem.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        /**
                         * MediaType enum.
                         * @name palexy.task_management.v1.FormTheme.MediaItem.MediaType
                         * @enum {number}
                         * @property {number} MEDIA_TYPE_UNSPECIFIED=0 MEDIA_TYPE_UNSPECIFIED value
                         * @property {number} IMAGE=1 IMAGE value
                         * @property {number} VIDEO=2 VIDEO value
                         */
                        MediaItem.MediaType = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "MEDIA_TYPE_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "IMAGE"] = 1;
                            values[valuesById[2] = "VIDEO"] = 2;
                            return values;
                        })();
    
                        /**
                         * Placement enum.
                         * @name palexy.task_management.v1.FormTheme.MediaItem.Placement
                         * @enum {number}
                         * @property {number} PLACEMENT_UNSPECIFIED=0 PLACEMENT_UNSPECIFIED value
                         * @property {number} HEADER=1 HEADER value
                         * @property {number} FOOTER=2 FOOTER value
                         */
                        MediaItem.Placement = (function() {
                            var valuesById = {}, values = Object.create(valuesById);
                            values[valuesById[0] = "PLACEMENT_UNSPECIFIED"] = 0;
                            values[valuesById[1] = "HEADER"] = 1;
                            values[valuesById[2] = "FOOTER"] = 2;
                            return values;
                        })();
    
                        return MediaItem;
                    })();
    
                    return FormTheme;
                })();
    
                v1.FormThemePreset = (function() {
    
                    /**
                     * Properties of a FormThemePreset.
                     * @memberof palexy.task_management.v1
                     * @interface IFormThemePreset
                     * @property {number|null} [id] FormThemePreset id
                     * @property {number|null} [formId] FormThemePreset formId
                     * @property {string|null} [name] FormThemePreset name
                     * @property {palexy.task_management.v1.IFormTheme|null} [theme] FormThemePreset theme
                     */
    
                    /**
                     * Constructs a new FormThemePreset.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormThemePreset.
                     * @implements IFormThemePreset
                     * @constructor
                     * @param {palexy.task_management.v1.IFormThemePreset=} [properties] Properties to set
                     */
                    function FormThemePreset(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormThemePreset id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @instance
                     */
                    FormThemePreset.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormThemePreset formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @instance
                     */
                    FormThemePreset.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormThemePreset name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @instance
                     */
                    FormThemePreset.prototype.name = "";
    
                    /**
                     * FormThemePreset theme.
                     * @member {palexy.task_management.v1.IFormTheme|null|undefined} theme
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @instance
                     */
                    FormThemePreset.prototype.theme = null;
    
                    /**
                     * Creates a new FormThemePreset instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {palexy.task_management.v1.IFormThemePreset=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormThemePreset} FormThemePreset instance
                     */
                    FormThemePreset.create = function create(properties) {
                        return new FormThemePreset(properties);
                    };
    
                    /**
                     * Encodes the specified FormThemePreset message. Does not implicitly {@link palexy.task_management.v1.FormThemePreset.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {palexy.task_management.v1.IFormThemePreset} message FormThemePreset message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormThemePreset.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            $root.palexy.task_management.v1.FormTheme.encode(message.theme, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormThemePreset message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormThemePreset.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {palexy.task_management.v1.IFormThemePreset} message FormThemePreset message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormThemePreset.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormThemePreset message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormThemePreset} FormThemePreset
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormThemePreset.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormThemePreset();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.theme = $root.palexy.task_management.v1.FormTheme.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormThemePreset message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormThemePreset} FormThemePreset
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormThemePreset.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormThemePreset message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormThemePreset.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.theme != null && message.hasOwnProperty("theme")) {
                            var error = $root.palexy.task_management.v1.FormTheme.verify(message.theme);
                            if (error)
                                return "theme." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormThemePreset message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormThemePreset} FormThemePreset
                     */
                    FormThemePreset.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormThemePreset)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormThemePreset();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.theme != null) {
                            if (typeof object.theme !== "object")
                                throw TypeError(".palexy.task_management.v1.FormThemePreset.theme: object expected");
                            message.theme = $root.palexy.task_management.v1.FormTheme.fromObject(object.theme);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormThemePreset message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @static
                     * @param {palexy.task_management.v1.FormThemePreset} message FormThemePreset
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormThemePreset.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.theme = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = $root.palexy.task_management.v1.FormTheme.toObject(message.theme, options);
                        return object;
                    };
    
                    /**
                     * Converts this FormThemePreset to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormThemePreset
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormThemePreset.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormThemePreset;
                })();
    
                v1.ListFormThemePresetsRequest = (function() {
    
                    /**
                     * Properties of a ListFormThemePresetsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormThemePresetsRequest
                     * @property {number|null} [formId] ListFormThemePresetsRequest formId
                     */
    
                    /**
                     * Constructs a new ListFormThemePresetsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormThemePresetsRequest.
                     * @implements IListFormThemePresetsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest=} [properties] Properties to set
                     */
                    function ListFormThemePresetsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormThemePresetsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @instance
                     */
                    ListFormThemePresetsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormThemePresetsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormThemePresetsRequest} ListFormThemePresetsRequest instance
                     */
                    ListFormThemePresetsRequest.create = function create(properties) {
                        return new ListFormThemePresetsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormThemePresetsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormThemePresetsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest} message ListFormThemePresetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormThemePresetsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormThemePresetsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormThemePresetsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsRequest} message ListFormThemePresetsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormThemePresetsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormThemePresetsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormThemePresetsRequest} ListFormThemePresetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormThemePresetsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormThemePresetsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormThemePresetsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormThemePresetsRequest} ListFormThemePresetsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormThemePresetsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormThemePresetsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormThemePresetsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormThemePresetsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormThemePresetsRequest} ListFormThemePresetsRequest
                     */
                    ListFormThemePresetsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormThemePresetsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormThemePresetsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormThemePresetsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormThemePresetsRequest} message ListFormThemePresetsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormThemePresetsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormThemePresetsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormThemePresetsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormThemePresetsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormThemePresetsRequest;
                })();
    
                v1.ListFormThemePresetsResponse = (function() {
    
                    /**
                     * Properties of a ListFormThemePresetsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormThemePresetsResponse
                     * @property {Array.<palexy.task_management.v1.IFormThemePreset>|null} [presets] ListFormThemePresetsResponse presets
                     */
    
                    /**
                     * Constructs a new ListFormThemePresetsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormThemePresetsResponse.
                     * @implements IListFormThemePresetsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormThemePresetsResponse=} [properties] Properties to set
                     */
                    function ListFormThemePresetsResponse(properties) {
                        this.presets = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormThemePresetsResponse presets.
                     * @member {Array.<palexy.task_management.v1.IFormThemePreset>} presets
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @instance
                     */
                    ListFormThemePresetsResponse.prototype.presets = $util.emptyArray;
    
                    /**
                     * Creates a new ListFormThemePresetsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormThemePresetsResponse} ListFormThemePresetsResponse instance
                     */
                    ListFormThemePresetsResponse.create = function create(properties) {
                        return new ListFormThemePresetsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormThemePresetsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormThemePresetsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsResponse} message ListFormThemePresetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormThemePresetsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.presets != null && message.presets.length)
                            for (var i = 0; i < message.presets.length; ++i)
                                $root.palexy.task_management.v1.FormThemePreset.encode(message.presets[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormThemePresetsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormThemePresetsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormThemePresetsResponse} message ListFormThemePresetsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormThemePresetsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormThemePresetsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormThemePresetsResponse} ListFormThemePresetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormThemePresetsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormThemePresetsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.presets && message.presets.length))
                                    message.presets = [];
                                message.presets.push($root.palexy.task_management.v1.FormThemePreset.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormThemePresetsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormThemePresetsResponse} ListFormThemePresetsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormThemePresetsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormThemePresetsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormThemePresetsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.presets != null && message.hasOwnProperty("presets")) {
                            if (!Array.isArray(message.presets))
                                return "presets: array expected";
                            for (var i = 0; i < message.presets.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormThemePreset.verify(message.presets[i]);
                                if (error)
                                    return "presets." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFormThemePresetsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormThemePresetsResponse} ListFormThemePresetsResponse
                     */
                    ListFormThemePresetsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormThemePresetsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormThemePresetsResponse();
                        if (object.presets) {
                            if (!Array.isArray(object.presets))
                                throw TypeError(".palexy.task_management.v1.ListFormThemePresetsResponse.presets: array expected");
                            message.presets = [];
                            for (var i = 0; i < object.presets.length; ++i) {
                                if (typeof object.presets[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormThemePresetsResponse.presets: object expected");
                                message.presets[i] = $root.palexy.task_management.v1.FormThemePreset.fromObject(object.presets[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormThemePresetsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormThemePresetsResponse} message ListFormThemePresetsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormThemePresetsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.presets = [];
                        if (message.presets && message.presets.length) {
                            object.presets = [];
                            for (var j = 0; j < message.presets.length; ++j)
                                object.presets[j] = $root.palexy.task_management.v1.FormThemePreset.toObject(message.presets[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFormThemePresetsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormThemePresetsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormThemePresetsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormThemePresetsResponse;
                })();
    
                v1.UpdateFormThemePresetRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormThemePresetRequest
                     * @property {number|null} [formId] UpdateFormThemePresetRequest formId
                     * @property {number|null} [formThemePresetId] UpdateFormThemePresetRequest formThemePresetId
                     * @property {palexy.task_management.v1.IFormTheme|null} [theme] UpdateFormThemePresetRequest theme
                     * @property {string|null} [name] UpdateFormThemePresetRequest name
                     */
    
                    /**
                     * Constructs a new UpdateFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormThemePresetRequest.
                     * @implements IUpdateFormThemePresetRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest=} [properties] Properties to set
                     */
                    function UpdateFormThemePresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormThemePresetRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @instance
                     */
                    UpdateFormThemePresetRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormThemePresetRequest formThemePresetId.
                     * @member {number} formThemePresetId
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @instance
                     */
                    UpdateFormThemePresetRequest.prototype.formThemePresetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormThemePresetRequest theme.
                     * @member {palexy.task_management.v1.IFormTheme|null|undefined} theme
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @instance
                     */
                    UpdateFormThemePresetRequest.prototype.theme = null;
    
                    /**
                     * UpdateFormThemePresetRequest name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @instance
                     */
                    UpdateFormThemePresetRequest.prototype.name = "";
    
                    /**
                     * Creates a new UpdateFormThemePresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormThemePresetRequest} UpdateFormThemePresetRequest instance
                     */
                    UpdateFormThemePresetRequest.create = function create(properties) {
                        return new UpdateFormThemePresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormThemePresetRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormThemePresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest} message UpdateFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormThemePresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formThemePresetId != null && Object.hasOwnProperty.call(message, "formThemePresetId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formThemePresetId);
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            $root.palexy.task_management.v1.FormTheme.encode(message.theme, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormThemePresetRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormThemePresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormThemePresetRequest} message UpdateFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormThemePresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormThemePresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormThemePresetRequest} UpdateFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormThemePresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormThemePresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formThemePresetId = reader.int64();
                                break;
                            case 3:
                                message.theme = $root.palexy.task_management.v1.FormTheme.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormThemePresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormThemePresetRequest} UpdateFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormThemePresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormThemePresetRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormThemePresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formThemePresetId != null && message.hasOwnProperty("formThemePresetId"))
                            if (!$util.isInteger(message.formThemePresetId) && !(message.formThemePresetId && $util.isInteger(message.formThemePresetId.low) && $util.isInteger(message.formThemePresetId.high)))
                                return "formThemePresetId: integer|Long expected";
                        if (message.theme != null && message.hasOwnProperty("theme")) {
                            var error = $root.palexy.task_management.v1.FormTheme.verify(message.theme);
                            if (error)
                                return "theme." + error;
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormThemePresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormThemePresetRequest} UpdateFormThemePresetRequest
                     */
                    UpdateFormThemePresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormThemePresetRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormThemePresetRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formThemePresetId != null)
                            if ($util.Long)
                                (message.formThemePresetId = $util.Long.fromValue(object.formThemePresetId)).unsigned = false;
                            else if (typeof object.formThemePresetId === "string")
                                message.formThemePresetId = parseInt(object.formThemePresetId, 10);
                            else if (typeof object.formThemePresetId === "number")
                                message.formThemePresetId = object.formThemePresetId;
                            else if (typeof object.formThemePresetId === "object")
                                message.formThemePresetId = new $util.LongBits(object.formThemePresetId.low >>> 0, object.formThemePresetId.high >>> 0).toNumber();
                        if (object.theme != null) {
                            if (typeof object.theme !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormThemePresetRequest.theme: object expected");
                            message.theme = $root.palexy.task_management.v1.FormTheme.fromObject(object.theme);
                        }
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormThemePresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormThemePresetRequest} message UpdateFormThemePresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormThemePresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formThemePresetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formThemePresetId = options.longs === String ? "0" : 0;
                            object.theme = null;
                            object.name = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formThemePresetId != null && message.hasOwnProperty("formThemePresetId"))
                            if (typeof message.formThemePresetId === "number")
                                object.formThemePresetId = options.longs === String ? String(message.formThemePresetId) : message.formThemePresetId;
                            else
                                object.formThemePresetId = options.longs === String ? $util.Long.prototype.toString.call(message.formThemePresetId) : options.longs === Number ? new $util.LongBits(message.formThemePresetId.low >>> 0, message.formThemePresetId.high >>> 0).toNumber() : message.formThemePresetId;
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = $root.palexy.task_management.v1.FormTheme.toObject(message.theme, options);
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormThemePresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormThemePresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormThemePresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormThemePresetRequest;
                })();
    
                v1.CreateFormThemePresetRequest = (function() {
    
                    /**
                     * Properties of a CreateFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormThemePresetRequest
                     * @property {number|null} [formId] CreateFormThemePresetRequest formId
                     * @property {string|null} [name] CreateFormThemePresetRequest name
                     * @property {palexy.task_management.v1.IFormTheme|null} [theme] CreateFormThemePresetRequest theme
                     */
    
                    /**
                     * Constructs a new CreateFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormThemePresetRequest.
                     * @implements ICreateFormThemePresetRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest=} [properties] Properties to set
                     */
                    function CreateFormThemePresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormThemePresetRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @instance
                     */
                    CreateFormThemePresetRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormThemePresetRequest name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @instance
                     */
                    CreateFormThemePresetRequest.prototype.name = "";
    
                    /**
                     * CreateFormThemePresetRequest theme.
                     * @member {palexy.task_management.v1.IFormTheme|null|undefined} theme
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @instance
                     */
                    CreateFormThemePresetRequest.prototype.theme = null;
    
                    /**
                     * Creates a new CreateFormThemePresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormThemePresetRequest} CreateFormThemePresetRequest instance
                     */
                    CreateFormThemePresetRequest.create = function create(properties) {
                        return new CreateFormThemePresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormThemePresetRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormThemePresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest} message CreateFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormThemePresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.theme != null && Object.hasOwnProperty.call(message, "theme"))
                            $root.palexy.task_management.v1.FormTheme.encode(message.theme, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormThemePresetRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormThemePresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormThemePresetRequest} message CreateFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormThemePresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormThemePresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormThemePresetRequest} CreateFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormThemePresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormThemePresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.theme = $root.palexy.task_management.v1.FormTheme.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormThemePresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormThemePresetRequest} CreateFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormThemePresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormThemePresetRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormThemePresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.theme != null && message.hasOwnProperty("theme")) {
                            var error = $root.palexy.task_management.v1.FormTheme.verify(message.theme);
                            if (error)
                                return "theme." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormThemePresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormThemePresetRequest} CreateFormThemePresetRequest
                     */
                    CreateFormThemePresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormThemePresetRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormThemePresetRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.theme != null) {
                            if (typeof object.theme !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormThemePresetRequest.theme: object expected");
                            message.theme = $root.palexy.task_management.v1.FormTheme.fromObject(object.theme);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormThemePresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormThemePresetRequest} message CreateFormThemePresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormThemePresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.theme = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.theme != null && message.hasOwnProperty("theme"))
                            object.theme = $root.palexy.task_management.v1.FormTheme.toObject(message.theme, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormThemePresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormThemePresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormThemePresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormThemePresetRequest;
                })();
    
                v1.DeleteFormThemePresetRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormThemePresetRequest
                     * @property {number|null} [formId] DeleteFormThemePresetRequest formId
                     * @property {number|null} [formThemePresetId] DeleteFormThemePresetRequest formThemePresetId
                     */
    
                    /**
                     * Constructs a new DeleteFormThemePresetRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormThemePresetRequest.
                     * @implements IDeleteFormThemePresetRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest=} [properties] Properties to set
                     */
                    function DeleteFormThemePresetRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormThemePresetRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @instance
                     */
                    DeleteFormThemePresetRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormThemePresetRequest formThemePresetId.
                     * @member {number} formThemePresetId
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @instance
                     */
                    DeleteFormThemePresetRequest.prototype.formThemePresetId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormThemePresetRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormThemePresetRequest} DeleteFormThemePresetRequest instance
                     */
                    DeleteFormThemePresetRequest.create = function create(properties) {
                        return new DeleteFormThemePresetRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormThemePresetRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormThemePresetRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest} message DeleteFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormThemePresetRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formThemePresetId != null && Object.hasOwnProperty.call(message, "formThemePresetId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formThemePresetId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormThemePresetRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormThemePresetRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormThemePresetRequest} message DeleteFormThemePresetRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormThemePresetRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormThemePresetRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormThemePresetRequest} DeleteFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormThemePresetRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormThemePresetRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formThemePresetId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormThemePresetRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormThemePresetRequest} DeleteFormThemePresetRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormThemePresetRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormThemePresetRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormThemePresetRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formThemePresetId != null && message.hasOwnProperty("formThemePresetId"))
                            if (!$util.isInteger(message.formThemePresetId) && !(message.formThemePresetId && $util.isInteger(message.formThemePresetId.low) && $util.isInteger(message.formThemePresetId.high)))
                                return "formThemePresetId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormThemePresetRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormThemePresetRequest} DeleteFormThemePresetRequest
                     */
                    DeleteFormThemePresetRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormThemePresetRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormThemePresetRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formThemePresetId != null)
                            if ($util.Long)
                                (message.formThemePresetId = $util.Long.fromValue(object.formThemePresetId)).unsigned = false;
                            else if (typeof object.formThemePresetId === "string")
                                message.formThemePresetId = parseInt(object.formThemePresetId, 10);
                            else if (typeof object.formThemePresetId === "number")
                                message.formThemePresetId = object.formThemePresetId;
                            else if (typeof object.formThemePresetId === "object")
                                message.formThemePresetId = new $util.LongBits(object.formThemePresetId.low >>> 0, object.formThemePresetId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormThemePresetRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormThemePresetRequest} message DeleteFormThemePresetRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormThemePresetRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formThemePresetId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formThemePresetId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formThemePresetId != null && message.hasOwnProperty("formThemePresetId"))
                            if (typeof message.formThemePresetId === "number")
                                object.formThemePresetId = options.longs === String ? String(message.formThemePresetId) : message.formThemePresetId;
                            else
                                object.formThemePresetId = options.longs === String ? $util.Long.prototype.toString.call(message.formThemePresetId) : options.longs === Number ? new $util.LongBits(message.formThemePresetId.low >>> 0, message.formThemePresetId.high >>> 0).toNumber() : message.formThemePresetId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormThemePresetRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormThemePresetRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormThemePresetRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormThemePresetRequest;
                })();
    
                v1.FormField = (function() {
    
                    /**
                     * Properties of a FormField.
                     * @memberof palexy.task_management.v1
                     * @interface IFormField
                     * @property {number|null} [id] FormField id
                     * @property {number|null} [formId] FormField formId
                     * @property {string|null} [question] FormField question
                     * @property {palexy.task_management.v1.FormField.FieldType|null} [fieldType] FormField fieldType
                     * @property {palexy.task_management.v1.IFieldConfig|null} [fieldConfig] FormField fieldConfig
                     * @property {boolean|null} [isRequired] FormField isRequired
                     * @property {number|null} [blockId] FormField blockId
                     * @property {string|null} [description] FormField description
                     * @property {string|null} [internalQuestionId] FormField internalQuestionId
                     * @property {palexy.task_management.v1.IDisplayLogic|null} [displayLogic] FormField displayLogic
                     */
    
                    /**
                     * Constructs a new FormField.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormField.
                     * @implements IFormField
                     * @constructor
                     * @param {palexy.task_management.v1.IFormField=} [properties] Properties to set
                     */
                    function FormField(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormField id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormField formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormField question.
                     * @member {string} question
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.question = "";
    
                    /**
                     * FormField fieldType.
                     * @member {palexy.task_management.v1.FormField.FieldType} fieldType
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.fieldType = 0;
    
                    /**
                     * FormField fieldConfig.
                     * @member {palexy.task_management.v1.IFieldConfig|null|undefined} fieldConfig
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.fieldConfig = null;
    
                    /**
                     * FormField isRequired.
                     * @member {boolean} isRequired
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.isRequired = false;
    
                    /**
                     * FormField blockId.
                     * @member {number} blockId
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.blockId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormField description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.description = "";
    
                    /**
                     * FormField internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.internalQuestionId = "";
    
                    /**
                     * FormField displayLogic.
                     * @member {palexy.task_management.v1.IDisplayLogic|null|undefined} displayLogic
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     */
                    FormField.prototype.displayLogic = null;
    
                    /**
                     * Creates a new FormField instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {palexy.task_management.v1.IFormField=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormField} FormField instance
                     */
                    FormField.create = function create(properties) {
                        return new FormField(properties);
                    };
    
                    /**
                     * Encodes the specified FormField message. Does not implicitly {@link palexy.task_management.v1.FormField.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {palexy.task_management.v1.IFormField} message FormField message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormField.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.question != null && Object.hasOwnProperty.call(message, "question"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.question);
                        if (message.fieldType != null && Object.hasOwnProperty.call(message, "fieldType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.fieldType);
                        if (message.fieldConfig != null && Object.hasOwnProperty.call(message, "fieldConfig"))
                            $root.palexy.task_management.v1.FieldConfig.encode(message.fieldConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.isRequired != null && Object.hasOwnProperty.call(message, "isRequired"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isRequired);
                        if (message.blockId != null && Object.hasOwnProperty.call(message, "blockId"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.blockId);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.description);
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.internalQuestionId);
                        if (message.displayLogic != null && Object.hasOwnProperty.call(message, "displayLogic"))
                            $root.palexy.task_management.v1.DisplayLogic.encode(message.displayLogic, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormField message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormField.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {palexy.task_management.v1.IFormField} message FormField message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormField.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormField message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormField} FormField
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormField.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormField();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.question = reader.string();
                                break;
                            case 4:
                                message.fieldType = reader.int32();
                                break;
                            case 5:
                                message.fieldConfig = $root.palexy.task_management.v1.FieldConfig.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.isRequired = reader.bool();
                                break;
                            case 7:
                                message.blockId = reader.int64();
                                break;
                            case 8:
                                message.description = reader.string();
                                break;
                            case 9:
                                message.internalQuestionId = reader.string();
                                break;
                            case 10:
                                message.displayLogic = $root.palexy.task_management.v1.DisplayLogic.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormField message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormField} FormField
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormField.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormField message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormField.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.question != null && message.hasOwnProperty("question"))
                            if (!$util.isString(message.question))
                                return "question: string expected";
                        if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                            switch (message.fieldType) {
                            default:
                                return "fieldType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                                break;
                            }
                        if (message.fieldConfig != null && message.hasOwnProperty("fieldConfig")) {
                            var error = $root.palexy.task_management.v1.FieldConfig.verify(message.fieldConfig);
                            if (error)
                                return "fieldConfig." + error;
                        }
                        if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                            if (typeof message.isRequired !== "boolean")
                                return "isRequired: boolean expected";
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (!$util.isInteger(message.blockId) && !(message.blockId && $util.isInteger(message.blockId.low) && $util.isInteger(message.blockId.high)))
                                return "blockId: integer|Long expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        if (message.displayLogic != null && message.hasOwnProperty("displayLogic")) {
                            var error = $root.palexy.task_management.v1.DisplayLogic.verify(message.displayLogic);
                            if (error)
                                return "displayLogic." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormField message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormField} FormField
                     */
                    FormField.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormField)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormField();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.question != null)
                            message.question = String(object.question);
                        switch (object.fieldType) {
                        case "UNKNOWN":
                        case 0:
                            message.fieldType = 0;
                            break;
                        case "TEXT":
                        case 1:
                            message.fieldType = 1;
                            break;
                        case "CHECKBOXES":
                        case 2:
                            message.fieldType = 2;
                            break;
                        case "DROPDOWN":
                        case 3:
                            message.fieldType = 3;
                            break;
                        case "MULTIPLE_CHOICE":
                        case 4:
                            message.fieldType = 4;
                            break;
                        case "FILE":
                        case 5:
                            message.fieldType = 5;
                            break;
                        case "TAKE_PHOTO":
                        case 7:
                            message.fieldType = 7;
                            break;
                        case "SELECTION":
                        case 8:
                            message.fieldType = 8;
                            break;
                        case "NPS":
                        case 9:
                            message.fieldType = 9;
                            break;
                        case "DATE":
                        case 10:
                            message.fieldType = 10;
                            break;
                        }
                        if (object.fieldConfig != null) {
                            if (typeof object.fieldConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FormField.fieldConfig: object expected");
                            message.fieldConfig = $root.palexy.task_management.v1.FieldConfig.fromObject(object.fieldConfig);
                        }
                        if (object.isRequired != null)
                            message.isRequired = Boolean(object.isRequired);
                        if (object.blockId != null)
                            if ($util.Long)
                                (message.blockId = $util.Long.fromValue(object.blockId)).unsigned = false;
                            else if (typeof object.blockId === "string")
                                message.blockId = parseInt(object.blockId, 10);
                            else if (typeof object.blockId === "number")
                                message.blockId = object.blockId;
                            else if (typeof object.blockId === "object")
                                message.blockId = new $util.LongBits(object.blockId.low >>> 0, object.blockId.high >>> 0).toNumber();
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        if (object.displayLogic != null) {
                            if (typeof object.displayLogic !== "object")
                                throw TypeError(".palexy.task_management.v1.FormField.displayLogic: object expected");
                            message.displayLogic = $root.palexy.task_management.v1.DisplayLogic.fromObject(object.displayLogic);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormField message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormField
                     * @static
                     * @param {palexy.task_management.v1.FormField} message FormField
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormField.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.question = "";
                            object.fieldType = options.enums === String ? "UNKNOWN" : 0;
                            object.fieldConfig = null;
                            object.isRequired = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.blockId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.blockId = options.longs === String ? "0" : 0;
                            object.description = "";
                            object.internalQuestionId = "";
                            object.displayLogic = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.question != null && message.hasOwnProperty("question"))
                            object.question = message.question;
                        if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                            object.fieldType = options.enums === String ? $root.palexy.task_management.v1.FormField.FieldType[message.fieldType] : message.fieldType;
                        if (message.fieldConfig != null && message.hasOwnProperty("fieldConfig"))
                            object.fieldConfig = $root.palexy.task_management.v1.FieldConfig.toObject(message.fieldConfig, options);
                        if (message.isRequired != null && message.hasOwnProperty("isRequired"))
                            object.isRequired = message.isRequired;
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (typeof message.blockId === "number")
                                object.blockId = options.longs === String ? String(message.blockId) : message.blockId;
                            else
                                object.blockId = options.longs === String ? $util.Long.prototype.toString.call(message.blockId) : options.longs === Number ? new $util.LongBits(message.blockId.low >>> 0, message.blockId.high >>> 0).toNumber() : message.blockId;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        if (message.displayLogic != null && message.hasOwnProperty("displayLogic"))
                            object.displayLogic = $root.palexy.task_management.v1.DisplayLogic.toObject(message.displayLogic, options);
                        return object;
                    };
    
                    /**
                     * Converts this FormField to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormField
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormField.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FieldType enum.
                     * @name palexy.task_management.v1.FormField.FieldType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} TEXT=1 TEXT value
                     * @property {number} CHECKBOXES=2 CHECKBOXES value
                     * @property {number} DROPDOWN=3 DROPDOWN value
                     * @property {number} MULTIPLE_CHOICE=4 MULTIPLE_CHOICE value
                     * @property {number} FILE=5 FILE value
                     * @property {number} TAKE_PHOTO=7 TAKE_PHOTO value
                     * @property {number} SELECTION=8 SELECTION value
                     * @property {number} NPS=9 NPS value
                     * @property {number} DATE=10 DATE value
                     */
                    FormField.FieldType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "TEXT"] = 1;
                        values[valuesById[2] = "CHECKBOXES"] = 2;
                        values[valuesById[3] = "DROPDOWN"] = 3;
                        values[valuesById[4] = "MULTIPLE_CHOICE"] = 4;
                        values[valuesById[5] = "FILE"] = 5;
                        values[valuesById[7] = "TAKE_PHOTO"] = 7;
                        values[valuesById[8] = "SELECTION"] = 8;
                        values[valuesById[9] = "NPS"] = 9;
                        values[valuesById[10] = "DATE"] = 10;
                        return values;
                    })();
    
                    return FormField;
                })();
    
                v1.FieldConfig = (function() {
    
                    /**
                     * Properties of a FieldConfig.
                     * @memberof palexy.task_management.v1
                     * @interface IFieldConfig
                     * @property {palexy.task_management.v1.IOptionList|null} [optionsConfig] FieldConfig optionsConfig
                     * @property {palexy.task_management.v1.IFileConfig|null} [fileConfig] FieldConfig fileConfig
                     * @property {palexy.task_management.v1.ITextEntryConfig|null} [textEntryConfig] FieldConfig textEntryConfig
                     * @property {palexy.task_management.v1.ITakePhotoConfig|null} [takePhotoConfig] FieldConfig takePhotoConfig
                     * @property {palexy.task_management.v1.ISelectionConfig|null} [selectionConfig] FieldConfig selectionConfig
                     * @property {palexy.task_management.v1.INpsConfig|null} [npsConfig] FieldConfig npsConfig
                     */
    
                    /**
                     * Constructs a new FieldConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FieldConfig.
                     * @implements IFieldConfig
                     * @constructor
                     * @param {palexy.task_management.v1.IFieldConfig=} [properties] Properties to set
                     */
                    function FieldConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FieldConfig optionsConfig.
                     * @member {palexy.task_management.v1.IOptionList|null|undefined} optionsConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.optionsConfig = null;
    
                    /**
                     * FieldConfig fileConfig.
                     * @member {palexy.task_management.v1.IFileConfig|null|undefined} fileConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.fileConfig = null;
    
                    /**
                     * FieldConfig textEntryConfig.
                     * @member {palexy.task_management.v1.ITextEntryConfig|null|undefined} textEntryConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.textEntryConfig = null;
    
                    /**
                     * FieldConfig takePhotoConfig.
                     * @member {palexy.task_management.v1.ITakePhotoConfig|null|undefined} takePhotoConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.takePhotoConfig = null;
    
                    /**
                     * FieldConfig selectionConfig.
                     * @member {palexy.task_management.v1.ISelectionConfig|null|undefined} selectionConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.selectionConfig = null;
    
                    /**
                     * FieldConfig npsConfig.
                     * @member {palexy.task_management.v1.INpsConfig|null|undefined} npsConfig
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    FieldConfig.prototype.npsConfig = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * FieldConfig config.
                     * @member {"optionsConfig"|"fileConfig"|"textEntryConfig"|"takePhotoConfig"|"selectionConfig"|"npsConfig"|undefined} config
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     */
                    Object.defineProperty(FieldConfig.prototype, "config", {
                        get: $util.oneOfGetter($oneOfFields = ["optionsConfig", "fileConfig", "textEntryConfig", "takePhotoConfig", "selectionConfig", "npsConfig"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new FieldConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {palexy.task_management.v1.IFieldConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FieldConfig} FieldConfig instance
                     */
                    FieldConfig.create = function create(properties) {
                        return new FieldConfig(properties);
                    };
    
                    /**
                     * Encodes the specified FieldConfig message. Does not implicitly {@link palexy.task_management.v1.FieldConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {palexy.task_management.v1.IFieldConfig} message FieldConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FieldConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.optionsConfig != null && Object.hasOwnProperty.call(message, "optionsConfig"))
                            $root.palexy.task_management.v1.OptionList.encode(message.optionsConfig, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.fileConfig != null && Object.hasOwnProperty.call(message, "fileConfig"))
                            $root.palexy.task_management.v1.FileConfig.encode(message.fileConfig, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.textEntryConfig != null && Object.hasOwnProperty.call(message, "textEntryConfig"))
                            $root.palexy.task_management.v1.TextEntryConfig.encode(message.textEntryConfig, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.takePhotoConfig != null && Object.hasOwnProperty.call(message, "takePhotoConfig"))
                            $root.palexy.task_management.v1.TakePhotoConfig.encode(message.takePhotoConfig, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.selectionConfig != null && Object.hasOwnProperty.call(message, "selectionConfig"))
                            $root.palexy.task_management.v1.SelectionConfig.encode(message.selectionConfig, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.npsConfig != null && Object.hasOwnProperty.call(message, "npsConfig"))
                            $root.palexy.task_management.v1.NpsConfig.encode(message.npsConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FieldConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.FieldConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {palexy.task_management.v1.IFieldConfig} message FieldConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FieldConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FieldConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FieldConfig} FieldConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FieldConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FieldConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.optionsConfig = $root.palexy.task_management.v1.OptionList.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.fileConfig = $root.palexy.task_management.v1.FileConfig.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.textEntryConfig = $root.palexy.task_management.v1.TextEntryConfig.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.takePhotoConfig = $root.palexy.task_management.v1.TakePhotoConfig.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.selectionConfig = $root.palexy.task_management.v1.SelectionConfig.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.npsConfig = $root.palexy.task_management.v1.NpsConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FieldConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FieldConfig} FieldConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FieldConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FieldConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FieldConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.optionsConfig != null && message.hasOwnProperty("optionsConfig")) {
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.OptionList.verify(message.optionsConfig);
                                if (error)
                                    return "optionsConfig." + error;
                            }
                        }
                        if (message.fileConfig != null && message.hasOwnProperty("fileConfig")) {
                            if (properties.config === 1)
                                return "config: multiple values";
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.FileConfig.verify(message.fileConfig);
                                if (error)
                                    return "fileConfig." + error;
                            }
                        }
                        if (message.textEntryConfig != null && message.hasOwnProperty("textEntryConfig")) {
                            if (properties.config === 1)
                                return "config: multiple values";
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.TextEntryConfig.verify(message.textEntryConfig);
                                if (error)
                                    return "textEntryConfig." + error;
                            }
                        }
                        if (message.takePhotoConfig != null && message.hasOwnProperty("takePhotoConfig")) {
                            if (properties.config === 1)
                                return "config: multiple values";
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.TakePhotoConfig.verify(message.takePhotoConfig);
                                if (error)
                                    return "takePhotoConfig." + error;
                            }
                        }
                        if (message.selectionConfig != null && message.hasOwnProperty("selectionConfig")) {
                            if (properties.config === 1)
                                return "config: multiple values";
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.SelectionConfig.verify(message.selectionConfig);
                                if (error)
                                    return "selectionConfig." + error;
                            }
                        }
                        if (message.npsConfig != null && message.hasOwnProperty("npsConfig")) {
                            if (properties.config === 1)
                                return "config: multiple values";
                            properties.config = 1;
                            {
                                var error = $root.palexy.task_management.v1.NpsConfig.verify(message.npsConfig);
                                if (error)
                                    return "npsConfig." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FieldConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FieldConfig} FieldConfig
                     */
                    FieldConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FieldConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.FieldConfig();
                        if (object.optionsConfig != null) {
                            if (typeof object.optionsConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.optionsConfig: object expected");
                            message.optionsConfig = $root.palexy.task_management.v1.OptionList.fromObject(object.optionsConfig);
                        }
                        if (object.fileConfig != null) {
                            if (typeof object.fileConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.fileConfig: object expected");
                            message.fileConfig = $root.palexy.task_management.v1.FileConfig.fromObject(object.fileConfig);
                        }
                        if (object.textEntryConfig != null) {
                            if (typeof object.textEntryConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.textEntryConfig: object expected");
                            message.textEntryConfig = $root.palexy.task_management.v1.TextEntryConfig.fromObject(object.textEntryConfig);
                        }
                        if (object.takePhotoConfig != null) {
                            if (typeof object.takePhotoConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.takePhotoConfig: object expected");
                            message.takePhotoConfig = $root.palexy.task_management.v1.TakePhotoConfig.fromObject(object.takePhotoConfig);
                        }
                        if (object.selectionConfig != null) {
                            if (typeof object.selectionConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.selectionConfig: object expected");
                            message.selectionConfig = $root.palexy.task_management.v1.SelectionConfig.fromObject(object.selectionConfig);
                        }
                        if (object.npsConfig != null) {
                            if (typeof object.npsConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FieldConfig.npsConfig: object expected");
                            message.npsConfig = $root.palexy.task_management.v1.NpsConfig.fromObject(object.npsConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FieldConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @static
                     * @param {palexy.task_management.v1.FieldConfig} message FieldConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FieldConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (message.optionsConfig != null && message.hasOwnProperty("optionsConfig")) {
                            object.optionsConfig = $root.palexy.task_management.v1.OptionList.toObject(message.optionsConfig, options);
                            if (options.oneofs)
                                object.config = "optionsConfig";
                        }
                        if (message.fileConfig != null && message.hasOwnProperty("fileConfig")) {
                            object.fileConfig = $root.palexy.task_management.v1.FileConfig.toObject(message.fileConfig, options);
                            if (options.oneofs)
                                object.config = "fileConfig";
                        }
                        if (message.textEntryConfig != null && message.hasOwnProperty("textEntryConfig")) {
                            object.textEntryConfig = $root.palexy.task_management.v1.TextEntryConfig.toObject(message.textEntryConfig, options);
                            if (options.oneofs)
                                object.config = "textEntryConfig";
                        }
                        if (message.takePhotoConfig != null && message.hasOwnProperty("takePhotoConfig")) {
                            object.takePhotoConfig = $root.palexy.task_management.v1.TakePhotoConfig.toObject(message.takePhotoConfig, options);
                            if (options.oneofs)
                                object.config = "takePhotoConfig";
                        }
                        if (message.selectionConfig != null && message.hasOwnProperty("selectionConfig")) {
                            object.selectionConfig = $root.palexy.task_management.v1.SelectionConfig.toObject(message.selectionConfig, options);
                            if (options.oneofs)
                                object.config = "selectionConfig";
                        }
                        if (message.npsConfig != null && message.hasOwnProperty("npsConfig")) {
                            object.npsConfig = $root.palexy.task_management.v1.NpsConfig.toObject(message.npsConfig, options);
                            if (options.oneofs)
                                object.config = "npsConfig";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FieldConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FieldConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FieldConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FieldConfig;
                })();
    
                v1.TextEntryConfig = (function() {
    
                    /**
                     * Properties of a TextEntryConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ITextEntryConfig
                     * @property {palexy.task_management.v1.TextEntryConfig.TextType|null} [textType] TextEntryConfig textType
                     * @property {number|null} [maxChars] TextEntryConfig maxChars
                     * @property {number|null} [min] TextEntryConfig min
                     * @property {number|null} [max] TextEntryConfig max
                     * @property {boolean|null} [hasMin] TextEntryConfig hasMin
                     * @property {boolean|null} [hasMax] TextEntryConfig hasMax
                     * @property {palexy.task_management.v1.ISentimentConfig|null} [sentimentConfig] TextEntryConfig sentimentConfig
                     */
    
                    /**
                     * Constructs a new TextEntryConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TextEntryConfig.
                     * @implements ITextEntryConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ITextEntryConfig=} [properties] Properties to set
                     */
                    function TextEntryConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TextEntryConfig textType.
                     * @member {palexy.task_management.v1.TextEntryConfig.TextType} textType
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.textType = 0;
    
                    /**
                     * TextEntryConfig maxChars.
                     * @member {number} maxChars
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.maxChars = 0;
    
                    /**
                     * TextEntryConfig min.
                     * @member {number} min
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.min = 0;
    
                    /**
                     * TextEntryConfig max.
                     * @member {number} max
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.max = 0;
    
                    /**
                     * TextEntryConfig hasMin.
                     * @member {boolean} hasMin
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.hasMin = false;
    
                    /**
                     * TextEntryConfig hasMax.
                     * @member {boolean} hasMax
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.hasMax = false;
    
                    /**
                     * TextEntryConfig sentimentConfig.
                     * @member {palexy.task_management.v1.ISentimentConfig|null|undefined} sentimentConfig
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     */
                    TextEntryConfig.prototype.sentimentConfig = null;
    
                    /**
                     * Creates a new TextEntryConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {palexy.task_management.v1.ITextEntryConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TextEntryConfig} TextEntryConfig instance
                     */
                    TextEntryConfig.create = function create(properties) {
                        return new TextEntryConfig(properties);
                    };
    
                    /**
                     * Encodes the specified TextEntryConfig message. Does not implicitly {@link palexy.task_management.v1.TextEntryConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {palexy.task_management.v1.ITextEntryConfig} message TextEntryConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TextEntryConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.textType != null && Object.hasOwnProperty.call(message, "textType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.textType);
                        if (message.maxChars != null && Object.hasOwnProperty.call(message, "maxChars"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxChars);
                        if (message.min != null && Object.hasOwnProperty.call(message, "min"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.min);
                        if (message.max != null && Object.hasOwnProperty.call(message, "max"))
                            writer.uint32(/* id 4, wireType 1 =*/33).double(message.max);
                        if (message.hasMin != null && Object.hasOwnProperty.call(message, "hasMin"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hasMin);
                        if (message.hasMax != null && Object.hasOwnProperty.call(message, "hasMax"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.hasMax);
                        if (message.sentimentConfig != null && Object.hasOwnProperty.call(message, "sentimentConfig"))
                            $root.palexy.task_management.v1.SentimentConfig.encode(message.sentimentConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TextEntryConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.TextEntryConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {palexy.task_management.v1.ITextEntryConfig} message TextEntryConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TextEntryConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TextEntryConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TextEntryConfig} TextEntryConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TextEntryConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TextEntryConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.textType = reader.int32();
                                break;
                            case 2:
                                message.maxChars = reader.int32();
                                break;
                            case 3:
                                message.min = reader.double();
                                break;
                            case 4:
                                message.max = reader.double();
                                break;
                            case 5:
                                message.hasMin = reader.bool();
                                break;
                            case 6:
                                message.hasMax = reader.bool();
                                break;
                            case 7:
                                message.sentimentConfig = $root.palexy.task_management.v1.SentimentConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TextEntryConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TextEntryConfig} TextEntryConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TextEntryConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TextEntryConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TextEntryConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.textType != null && message.hasOwnProperty("textType"))
                            switch (message.textType) {
                            default:
                                return "textType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.maxChars != null && message.hasOwnProperty("maxChars"))
                            if (!$util.isInteger(message.maxChars))
                                return "maxChars: integer expected";
                        if (message.min != null && message.hasOwnProperty("min"))
                            if (typeof message.min !== "number")
                                return "min: number expected";
                        if (message.max != null && message.hasOwnProperty("max"))
                            if (typeof message.max !== "number")
                                return "max: number expected";
                        if (message.hasMin != null && message.hasOwnProperty("hasMin"))
                            if (typeof message.hasMin !== "boolean")
                                return "hasMin: boolean expected";
                        if (message.hasMax != null && message.hasOwnProperty("hasMax"))
                            if (typeof message.hasMax !== "boolean")
                                return "hasMax: boolean expected";
                        if (message.sentimentConfig != null && message.hasOwnProperty("sentimentConfig")) {
                            var error = $root.palexy.task_management.v1.SentimentConfig.verify(message.sentimentConfig);
                            if (error)
                                return "sentimentConfig." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TextEntryConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TextEntryConfig} TextEntryConfig
                     */
                    TextEntryConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TextEntryConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.TextEntryConfig();
                        switch (object.textType) {
                        case "TEXT_TYPE_UNKNOWN":
                        case 0:
                            message.textType = 0;
                            break;
                        case "MULTILINE":
                        case 1:
                            message.textType = 1;
                            break;
                        case "NUMBER":
                        case 2:
                            message.textType = 2;
                            break;
                        }
                        if (object.maxChars != null)
                            message.maxChars = object.maxChars | 0;
                        if (object.min != null)
                            message.min = Number(object.min);
                        if (object.max != null)
                            message.max = Number(object.max);
                        if (object.hasMin != null)
                            message.hasMin = Boolean(object.hasMin);
                        if (object.hasMax != null)
                            message.hasMax = Boolean(object.hasMax);
                        if (object.sentimentConfig != null) {
                            if (typeof object.sentimentConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.TextEntryConfig.sentimentConfig: object expected");
                            message.sentimentConfig = $root.palexy.task_management.v1.SentimentConfig.fromObject(object.sentimentConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TextEntryConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @static
                     * @param {palexy.task_management.v1.TextEntryConfig} message TextEntryConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TextEntryConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.textType = options.enums === String ? "TEXT_TYPE_UNKNOWN" : 0;
                            object.maxChars = 0;
                            object.min = 0;
                            object.max = 0;
                            object.hasMin = false;
                            object.hasMax = false;
                            object.sentimentConfig = null;
                        }
                        if (message.textType != null && message.hasOwnProperty("textType"))
                            object.textType = options.enums === String ? $root.palexy.task_management.v1.TextEntryConfig.TextType[message.textType] : message.textType;
                        if (message.maxChars != null && message.hasOwnProperty("maxChars"))
                            object.maxChars = message.maxChars;
                        if (message.min != null && message.hasOwnProperty("min"))
                            object.min = options.json && !isFinite(message.min) ? String(message.min) : message.min;
                        if (message.max != null && message.hasOwnProperty("max"))
                            object.max = options.json && !isFinite(message.max) ? String(message.max) : message.max;
                        if (message.hasMin != null && message.hasOwnProperty("hasMin"))
                            object.hasMin = message.hasMin;
                        if (message.hasMax != null && message.hasOwnProperty("hasMax"))
                            object.hasMax = message.hasMax;
                        if (message.sentimentConfig != null && message.hasOwnProperty("sentimentConfig"))
                            object.sentimentConfig = $root.palexy.task_management.v1.SentimentConfig.toObject(message.sentimentConfig, options);
                        return object;
                    };
    
                    /**
                     * Converts this TextEntryConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TextEntryConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TextEntryConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * TextType enum.
                     * @name palexy.task_management.v1.TextEntryConfig.TextType
                     * @enum {number}
                     * @property {number} TEXT_TYPE_UNKNOWN=0 TEXT_TYPE_UNKNOWN value
                     * @property {number} MULTILINE=1 MULTILINE value
                     * @property {number} NUMBER=2 NUMBER value
                     */
                    TextEntryConfig.TextType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "TEXT_TYPE_UNKNOWN"] = 0;
                        values[valuesById[1] = "MULTILINE"] = 1;
                        values[valuesById[2] = "NUMBER"] = 2;
                        return values;
                    })();
    
                    return TextEntryConfig;
                })();
    
                v1.SentimentConfig = (function() {
    
                    /**
                     * Properties of a SentimentConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ISentimentConfig
                     * @property {boolean|null} [enabled] SentimentConfig enabled
                     * @property {Array.<palexy.task_management.v1.ISentimentTopic>|null} [topics] SentimentConfig topics
                     */
    
                    /**
                     * Constructs a new SentimentConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SentimentConfig.
                     * @implements ISentimentConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ISentimentConfig=} [properties] Properties to set
                     */
                    function SentimentConfig(properties) {
                        this.topics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SentimentConfig enabled.
                     * @member {boolean} enabled
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @instance
                     */
                    SentimentConfig.prototype.enabled = false;
    
                    /**
                     * SentimentConfig topics.
                     * @member {Array.<palexy.task_management.v1.ISentimentTopic>} topics
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @instance
                     */
                    SentimentConfig.prototype.topics = $util.emptyArray;
    
                    /**
                     * Creates a new SentimentConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {palexy.task_management.v1.ISentimentConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SentimentConfig} SentimentConfig instance
                     */
                    SentimentConfig.create = function create(properties) {
                        return new SentimentConfig(properties);
                    };
    
                    /**
                     * Encodes the specified SentimentConfig message. Does not implicitly {@link palexy.task_management.v1.SentimentConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {palexy.task_management.v1.ISentimentConfig} message SentimentConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
                        if (message.topics != null && message.topics.length)
                            for (var i = 0; i < message.topics.length; ++i)
                                $root.palexy.task_management.v1.SentimentTopic.encode(message.topics[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SentimentConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.SentimentConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {palexy.task_management.v1.ISentimentConfig} message SentimentConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SentimentConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SentimentConfig} SentimentConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SentimentConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.enabled = reader.bool();
                                break;
                            case 2:
                                if (!(message.topics && message.topics.length))
                                    message.topics = [];
                                message.topics.push($root.palexy.task_management.v1.SentimentTopic.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SentimentConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SentimentConfig} SentimentConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SentimentConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SentimentConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            if (typeof message.enabled !== "boolean")
                                return "enabled: boolean expected";
                        if (message.topics != null && message.hasOwnProperty("topics")) {
                            if (!Array.isArray(message.topics))
                                return "topics: array expected";
                            for (var i = 0; i < message.topics.length; ++i) {
                                var error = $root.palexy.task_management.v1.SentimentTopic.verify(message.topics[i]);
                                if (error)
                                    return "topics." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SentimentConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SentimentConfig} SentimentConfig
                     */
                    SentimentConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SentimentConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.SentimentConfig();
                        if (object.enabled != null)
                            message.enabled = Boolean(object.enabled);
                        if (object.topics) {
                            if (!Array.isArray(object.topics))
                                throw TypeError(".palexy.task_management.v1.SentimentConfig.topics: array expected");
                            message.topics = [];
                            for (var i = 0; i < object.topics.length; ++i) {
                                if (typeof object.topics[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.SentimentConfig.topics: object expected");
                                message.topics[i] = $root.palexy.task_management.v1.SentimentTopic.fromObject(object.topics[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SentimentConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @static
                     * @param {palexy.task_management.v1.SentimentConfig} message SentimentConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SentimentConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.topics = [];
                        if (options.defaults)
                            object.enabled = false;
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            object.enabled = message.enabled;
                        if (message.topics && message.topics.length) {
                            object.topics = [];
                            for (var j = 0; j < message.topics.length; ++j)
                                object.topics[j] = $root.palexy.task_management.v1.SentimentTopic.toObject(message.topics[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SentimentConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SentimentConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SentimentConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SentimentConfig;
                })();
    
                v1.SentimentTopic = (function() {
    
                    /**
                     * Properties of a SentimentTopic.
                     * @memberof palexy.task_management.v1
                     * @interface ISentimentTopic
                     * @property {string|null} [id] SentimentTopic id
                     * @property {string|null} [name] SentimentTopic name
                     */
    
                    /**
                     * Constructs a new SentimentTopic.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SentimentTopic.
                     * @implements ISentimentTopic
                     * @constructor
                     * @param {palexy.task_management.v1.ISentimentTopic=} [properties] Properties to set
                     */
                    function SentimentTopic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SentimentTopic id.
                     * @member {string} id
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @instance
                     */
                    SentimentTopic.prototype.id = "";
    
                    /**
                     * SentimentTopic name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @instance
                     */
                    SentimentTopic.prototype.name = "";
    
                    /**
                     * Creates a new SentimentTopic instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentTopic=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SentimentTopic} SentimentTopic instance
                     */
                    SentimentTopic.create = function create(properties) {
                        return new SentimentTopic(properties);
                    };
    
                    /**
                     * Encodes the specified SentimentTopic message. Does not implicitly {@link palexy.task_management.v1.SentimentTopic.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentTopic} message SentimentTopic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentTopic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SentimentTopic message, length delimited. Does not implicitly {@link palexy.task_management.v1.SentimentTopic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentTopic} message SentimentTopic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentTopic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SentimentTopic message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SentimentTopic} SentimentTopic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentTopic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SentimentTopic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SentimentTopic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SentimentTopic} SentimentTopic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentTopic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SentimentTopic message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SentimentTopic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SentimentTopic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SentimentTopic} SentimentTopic
                     */
                    SentimentTopic.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SentimentTopic)
                            return object;
                        var message = new $root.palexy.task_management.v1.SentimentTopic();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.name != null)
                            message.name = String(object.name);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SentimentTopic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @static
                     * @param {palexy.task_management.v1.SentimentTopic} message SentimentTopic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SentimentTopic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.id = "";
                            object.name = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        return object;
                    };
    
                    /**
                     * Converts this SentimentTopic to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SentimentTopic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SentimentTopic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SentimentTopic;
                })();
    
                v1.SelectionConfig = (function() {
    
                    /**
                     * Properties of a SelectionConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ISelectionConfig
                     * @property {palexy.task_management.v1.SelectionConfig.AnswerType|null} [answerType] SelectionConfig answerType
                     * @property {palexy.task_management.v1.SelectionConfig.Format|null} [format] SelectionConfig format
                     * @property {palexy.task_management.v1.IOptionList|null} [options] SelectionConfig options
                     * @property {boolean|null} [randomizeOptions] SelectionConfig randomizeOptions
                     */
    
                    /**
                     * Constructs a new SelectionConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SelectionConfig.
                     * @implements ISelectionConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ISelectionConfig=} [properties] Properties to set
                     */
                    function SelectionConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SelectionConfig answerType.
                     * @member {palexy.task_management.v1.SelectionConfig.AnswerType} answerType
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @instance
                     */
                    SelectionConfig.prototype.answerType = 0;
    
                    /**
                     * SelectionConfig format.
                     * @member {palexy.task_management.v1.SelectionConfig.Format} format
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @instance
                     */
                    SelectionConfig.prototype.format = 0;
    
                    /**
                     * SelectionConfig options.
                     * @member {palexy.task_management.v1.IOptionList|null|undefined} options
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @instance
                     */
                    SelectionConfig.prototype.options = null;
    
                    /**
                     * SelectionConfig randomizeOptions.
                     * @member {boolean} randomizeOptions
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @instance
                     */
                    SelectionConfig.prototype.randomizeOptions = false;
    
                    /**
                     * Creates a new SelectionConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {palexy.task_management.v1.ISelectionConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SelectionConfig} SelectionConfig instance
                     */
                    SelectionConfig.create = function create(properties) {
                        return new SelectionConfig(properties);
                    };
    
                    /**
                     * Encodes the specified SelectionConfig message. Does not implicitly {@link palexy.task_management.v1.SelectionConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {palexy.task_management.v1.ISelectionConfig} message SelectionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SelectionConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.answerType != null && Object.hasOwnProperty.call(message, "answerType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.answerType);
                        if (message.format != null && Object.hasOwnProperty.call(message, "format"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.format);
                        if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                            $root.palexy.task_management.v1.OptionList.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.randomizeOptions != null && Object.hasOwnProperty.call(message, "randomizeOptions"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.randomizeOptions);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SelectionConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.SelectionConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {palexy.task_management.v1.ISelectionConfig} message SelectionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SelectionConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SelectionConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SelectionConfig} SelectionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SelectionConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SelectionConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.answerType = reader.int32();
                                break;
                            case 2:
                                message.format = reader.int32();
                                break;
                            case 3:
                                message.options = $root.palexy.task_management.v1.OptionList.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.randomizeOptions = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SelectionConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SelectionConfig} SelectionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SelectionConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SelectionConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SelectionConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.answerType != null && message.hasOwnProperty("answerType"))
                            switch (message.answerType) {
                            default:
                                return "answerType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.format != null && message.hasOwnProperty("format"))
                            switch (message.format) {
                            default:
                                return "format: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.options != null && message.hasOwnProperty("options")) {
                            var error = $root.palexy.task_management.v1.OptionList.verify(message.options);
                            if (error)
                                return "options." + error;
                        }
                        if (message.randomizeOptions != null && message.hasOwnProperty("randomizeOptions"))
                            if (typeof message.randomizeOptions !== "boolean")
                                return "randomizeOptions: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a SelectionConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SelectionConfig} SelectionConfig
                     */
                    SelectionConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SelectionConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.SelectionConfig();
                        switch (object.answerType) {
                        case "ANSWER_UNKNOWN":
                        case 0:
                            message.answerType = 0;
                            break;
                        case "SINGLE":
                        case 1:
                            message.answerType = 1;
                            break;
                        case "MULTIPLE":
                        case 2:
                            message.answerType = 2;
                            break;
                        }
                        switch (object.format) {
                        case "FORMAT_UNKNOWN":
                        case 0:
                            message.format = 0;
                            break;
                        case "LIST":
                        case 1:
                            message.format = 1;
                            break;
                        case "DROPDOWN":
                        case 2:
                            message.format = 2;
                            break;
                        }
                        if (object.options != null) {
                            if (typeof object.options !== "object")
                                throw TypeError(".palexy.task_management.v1.SelectionConfig.options: object expected");
                            message.options = $root.palexy.task_management.v1.OptionList.fromObject(object.options);
                        }
                        if (object.randomizeOptions != null)
                            message.randomizeOptions = Boolean(object.randomizeOptions);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SelectionConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @static
                     * @param {palexy.task_management.v1.SelectionConfig} message SelectionConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SelectionConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.answerType = options.enums === String ? "ANSWER_UNKNOWN" : 0;
                            object.format = options.enums === String ? "FORMAT_UNKNOWN" : 0;
                            object.options = null;
                            object.randomizeOptions = false;
                        }
                        if (message.answerType != null && message.hasOwnProperty("answerType"))
                            object.answerType = options.enums === String ? $root.palexy.task_management.v1.SelectionConfig.AnswerType[message.answerType] : message.answerType;
                        if (message.format != null && message.hasOwnProperty("format"))
                            object.format = options.enums === String ? $root.palexy.task_management.v1.SelectionConfig.Format[message.format] : message.format;
                        if (message.options != null && message.hasOwnProperty("options"))
                            object.options = $root.palexy.task_management.v1.OptionList.toObject(message.options, options);
                        if (message.randomizeOptions != null && message.hasOwnProperty("randomizeOptions"))
                            object.randomizeOptions = message.randomizeOptions;
                        return object;
                    };
    
                    /**
                     * Converts this SelectionConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SelectionConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SelectionConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * AnswerType enum.
                     * @name palexy.task_management.v1.SelectionConfig.AnswerType
                     * @enum {number}
                     * @property {number} ANSWER_UNKNOWN=0 ANSWER_UNKNOWN value
                     * @property {number} SINGLE=1 SINGLE value
                     * @property {number} MULTIPLE=2 MULTIPLE value
                     */
                    SelectionConfig.AnswerType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "ANSWER_UNKNOWN"] = 0;
                        values[valuesById[1] = "SINGLE"] = 1;
                        values[valuesById[2] = "MULTIPLE"] = 2;
                        return values;
                    })();
    
                    /**
                     * Format enum.
                     * @name palexy.task_management.v1.SelectionConfig.Format
                     * @enum {number}
                     * @property {number} FORMAT_UNKNOWN=0 FORMAT_UNKNOWN value
                     * @property {number} LIST=1 LIST value
                     * @property {number} DROPDOWN=2 DROPDOWN value
                     */
                    SelectionConfig.Format = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "FORMAT_UNKNOWN"] = 0;
                        values[valuesById[1] = "LIST"] = 1;
                        values[valuesById[2] = "DROPDOWN"] = 2;
                        return values;
                    })();
    
                    return SelectionConfig;
                })();
    
                v1.TakePhotoConfig = (function() {
    
                    /**
                     * Properties of a TakePhotoConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ITakePhotoConfig
                     */
    
                    /**
                     * Constructs a new TakePhotoConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TakePhotoConfig.
                     * @implements ITakePhotoConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ITakePhotoConfig=} [properties] Properties to set
                     */
                    function TakePhotoConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new TakePhotoConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {palexy.task_management.v1.ITakePhotoConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TakePhotoConfig} TakePhotoConfig instance
                     */
                    TakePhotoConfig.create = function create(properties) {
                        return new TakePhotoConfig(properties);
                    };
    
                    /**
                     * Encodes the specified TakePhotoConfig message. Does not implicitly {@link palexy.task_management.v1.TakePhotoConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {palexy.task_management.v1.ITakePhotoConfig} message TakePhotoConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakePhotoConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TakePhotoConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.TakePhotoConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {palexy.task_management.v1.ITakePhotoConfig} message TakePhotoConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TakePhotoConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TakePhotoConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TakePhotoConfig} TakePhotoConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakePhotoConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TakePhotoConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TakePhotoConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TakePhotoConfig} TakePhotoConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TakePhotoConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TakePhotoConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TakePhotoConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a TakePhotoConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TakePhotoConfig} TakePhotoConfig
                     */
                    TakePhotoConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TakePhotoConfig)
                            return object;
                        return new $root.palexy.task_management.v1.TakePhotoConfig();
                    };
    
                    /**
                     * Creates a plain object from a TakePhotoConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @static
                     * @param {palexy.task_management.v1.TakePhotoConfig} message TakePhotoConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TakePhotoConfig.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this TakePhotoConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TakePhotoConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TakePhotoConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TakePhotoConfig;
                })();
    
                v1.NpsConfig = (function() {
    
                    /**
                     * Properties of a NpsConfig.
                     * @memberof palexy.task_management.v1
                     * @interface INpsConfig
                     * @property {boolean|null} [showLabels] NpsConfig showLabels
                     * @property {Array.<palexy.task_management.v1.INpsLabel>|null} [labels] NpsConfig labels
                     * @property {palexy.task_management.v1.NpsScale|null} [scale] NpsConfig scale
                     */
    
                    /**
                     * Constructs a new NpsConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a NpsConfig.
                     * @implements INpsConfig
                     * @constructor
                     * @param {palexy.task_management.v1.INpsConfig=} [properties] Properties to set
                     */
                    function NpsConfig(properties) {
                        this.labels = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NpsConfig showLabels.
                     * @member {boolean} showLabels
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @instance
                     */
                    NpsConfig.prototype.showLabels = false;
    
                    /**
                     * NpsConfig labels.
                     * @member {Array.<palexy.task_management.v1.INpsLabel>} labels
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @instance
                     */
                    NpsConfig.prototype.labels = $util.emptyArray;
    
                    /**
                     * NpsConfig scale.
                     * @member {palexy.task_management.v1.NpsScale} scale
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @instance
                     */
                    NpsConfig.prototype.scale = 0;
    
                    /**
                     * Creates a new NpsConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {palexy.task_management.v1.INpsConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.NpsConfig} NpsConfig instance
                     */
                    NpsConfig.create = function create(properties) {
                        return new NpsConfig(properties);
                    };
    
                    /**
                     * Encodes the specified NpsConfig message. Does not implicitly {@link palexy.task_management.v1.NpsConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {palexy.task_management.v1.INpsConfig} message NpsConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.showLabels != null && Object.hasOwnProperty.call(message, "showLabels"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.showLabels);
                        if (message.labels != null && message.labels.length)
                            for (var i = 0; i < message.labels.length; ++i)
                                $root.palexy.task_management.v1.NpsLabel.encode(message.labels[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.scale != null && Object.hasOwnProperty.call(message, "scale"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.scale);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NpsConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.NpsConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {palexy.task_management.v1.INpsConfig} message NpsConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NpsConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.NpsConfig} NpsConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.NpsConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.showLabels = reader.bool();
                                break;
                            case 2:
                                if (!(message.labels && message.labels.length))
                                    message.labels = [];
                                message.labels.push($root.palexy.task_management.v1.NpsLabel.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.scale = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a NpsConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.NpsConfig} NpsConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NpsConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NpsConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.showLabels != null && message.hasOwnProperty("showLabels"))
                            if (typeof message.showLabels !== "boolean")
                                return "showLabels: boolean expected";
                        if (message.labels != null && message.hasOwnProperty("labels")) {
                            if (!Array.isArray(message.labels))
                                return "labels: array expected";
                            for (var i = 0; i < message.labels.length; ++i) {
                                var error = $root.palexy.task_management.v1.NpsLabel.verify(message.labels[i]);
                                if (error)
                                    return "labels." + error;
                            }
                        }
                        if (message.scale != null && message.hasOwnProperty("scale"))
                            switch (message.scale) {
                            default:
                                return "scale: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a NpsConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.NpsConfig} NpsConfig
                     */
                    NpsConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.NpsConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.NpsConfig();
                        if (object.showLabels != null)
                            message.showLabels = Boolean(object.showLabels);
                        if (object.labels) {
                            if (!Array.isArray(object.labels))
                                throw TypeError(".palexy.task_management.v1.NpsConfig.labels: array expected");
                            message.labels = [];
                            for (var i = 0; i < object.labels.length; ++i) {
                                if (typeof object.labels[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.NpsConfig.labels: object expected");
                                message.labels[i] = $root.palexy.task_management.v1.NpsLabel.fromObject(object.labels[i]);
                            }
                        }
                        switch (object.scale) {
                        case "NPS_SCALE_UNSPECIFIED":
                        case 0:
                            message.scale = 0;
                            break;
                        case "ZERO_TO_TEN":
                        case 1:
                            message.scale = 1;
                            break;
                        case "ONE_TO_FIVE":
                        case 2:
                            message.scale = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NpsConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @static
                     * @param {palexy.task_management.v1.NpsConfig} message NpsConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NpsConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.labels = [];
                        if (options.defaults) {
                            object.showLabels = false;
                            object.scale = options.enums === String ? "NPS_SCALE_UNSPECIFIED" : 0;
                        }
                        if (message.showLabels != null && message.hasOwnProperty("showLabels"))
                            object.showLabels = message.showLabels;
                        if (message.labels && message.labels.length) {
                            object.labels = [];
                            for (var j = 0; j < message.labels.length; ++j)
                                object.labels[j] = $root.palexy.task_management.v1.NpsLabel.toObject(message.labels[j], options);
                        }
                        if (message.scale != null && message.hasOwnProperty("scale"))
                            object.scale = options.enums === String ? $root.palexy.task_management.v1.NpsScale[message.scale] : message.scale;
                        return object;
                    };
    
                    /**
                     * Converts this NpsConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.NpsConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NpsConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NpsConfig;
                })();
    
                v1.NpsLabel = (function() {
    
                    /**
                     * Properties of a NpsLabel.
                     * @memberof palexy.task_management.v1
                     * @interface INpsLabel
                     * @property {number|null} [score] NpsLabel score
                     * @property {string|null} [label] NpsLabel label
                     */
    
                    /**
                     * Constructs a new NpsLabel.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a NpsLabel.
                     * @implements INpsLabel
                     * @constructor
                     * @param {palexy.task_management.v1.INpsLabel=} [properties] Properties to set
                     */
                    function NpsLabel(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NpsLabel score.
                     * @member {number} score
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @instance
                     */
                    NpsLabel.prototype.score = 0;
    
                    /**
                     * NpsLabel label.
                     * @member {string} label
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @instance
                     */
                    NpsLabel.prototype.label = "";
    
                    /**
                     * Creates a new NpsLabel instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {palexy.task_management.v1.INpsLabel=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.NpsLabel} NpsLabel instance
                     */
                    NpsLabel.create = function create(properties) {
                        return new NpsLabel(properties);
                    };
    
                    /**
                     * Encodes the specified NpsLabel message. Does not implicitly {@link palexy.task_management.v1.NpsLabel.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {palexy.task_management.v1.INpsLabel} message NpsLabel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsLabel.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.score != null && Object.hasOwnProperty.call(message, "score"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.score);
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NpsLabel message, length delimited. Does not implicitly {@link palexy.task_management.v1.NpsLabel.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {palexy.task_management.v1.INpsLabel} message NpsLabel message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NpsLabel.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NpsLabel message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.NpsLabel} NpsLabel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsLabel.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.NpsLabel();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.score = reader.int32();
                                break;
                            case 2:
                                message.label = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a NpsLabel message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.NpsLabel} NpsLabel
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NpsLabel.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NpsLabel message.
                     * @function verify
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NpsLabel.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.score != null && message.hasOwnProperty("score"))
                            if (!$util.isInteger(message.score))
                                return "score: integer expected";
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a NpsLabel message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.NpsLabel} NpsLabel
                     */
                    NpsLabel.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.NpsLabel)
                            return object;
                        var message = new $root.palexy.task_management.v1.NpsLabel();
                        if (object.score != null)
                            message.score = object.score | 0;
                        if (object.label != null)
                            message.label = String(object.label);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NpsLabel message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @static
                     * @param {palexy.task_management.v1.NpsLabel} message NpsLabel
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NpsLabel.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.score = 0;
                            object.label = "";
                        }
                        if (message.score != null && message.hasOwnProperty("score"))
                            object.score = message.score;
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        return object;
                    };
    
                    /**
                     * Converts this NpsLabel to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.NpsLabel
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NpsLabel.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NpsLabel;
                })();
    
                v1.FileConfig = (function() {
    
                    /**
                     * Properties of a FileConfig.
                     * @memberof palexy.task_management.v1
                     * @interface IFileConfig
                     * @property {palexy.task_management.v1.FileConfig.FileType|null} [fileType] FileConfig fileType
                     * @property {number|null} [maxNumberOfFiles] FileConfig maxNumberOfFiles
                     * @property {number|null} [maxFileSizeInBytes] FileConfig maxFileSizeInBytes
                     */
    
                    /**
                     * Constructs a new FileConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FileConfig.
                     * @implements IFileConfig
                     * @constructor
                     * @param {palexy.task_management.v1.IFileConfig=} [properties] Properties to set
                     */
                    function FileConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FileConfig fileType.
                     * @member {palexy.task_management.v1.FileConfig.FileType} fileType
                     * @memberof palexy.task_management.v1.FileConfig
                     * @instance
                     */
                    FileConfig.prototype.fileType = 0;
    
                    /**
                     * FileConfig maxNumberOfFiles.
                     * @member {number} maxNumberOfFiles
                     * @memberof palexy.task_management.v1.FileConfig
                     * @instance
                     */
                    FileConfig.prototype.maxNumberOfFiles = 0;
    
                    /**
                     * FileConfig maxFileSizeInBytes.
                     * @member {number} maxFileSizeInBytes
                     * @memberof palexy.task_management.v1.FileConfig
                     * @instance
                     */
                    FileConfig.prototype.maxFileSizeInBytes = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FileConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {palexy.task_management.v1.IFileConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FileConfig} FileConfig instance
                     */
                    FileConfig.create = function create(properties) {
                        return new FileConfig(properties);
                    };
    
                    /**
                     * Encodes the specified FileConfig message. Does not implicitly {@link palexy.task_management.v1.FileConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {palexy.task_management.v1.IFileConfig} message FileConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.fileType != null && Object.hasOwnProperty.call(message, "fileType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.fileType);
                        if (message.maxNumberOfFiles != null && Object.hasOwnProperty.call(message, "maxNumberOfFiles"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.maxNumberOfFiles);
                        if (message.maxFileSizeInBytes != null && Object.hasOwnProperty.call(message, "maxFileSizeInBytes"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.maxFileSizeInBytes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FileConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.FileConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {palexy.task_management.v1.IFileConfig} message FileConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FileConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FileConfig} FileConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FileConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.fileType = reader.int32();
                                break;
                            case 2:
                                message.maxNumberOfFiles = reader.int32();
                                break;
                            case 3:
                                message.maxFileSizeInBytes = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FileConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FileConfig} FileConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FileConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FileConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.fileType != null && message.hasOwnProperty("fileType"))
                            switch (message.fileType) {
                            default:
                                return "fileType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.maxNumberOfFiles != null && message.hasOwnProperty("maxNumberOfFiles"))
                            if (!$util.isInteger(message.maxNumberOfFiles))
                                return "maxNumberOfFiles: integer expected";
                        if (message.maxFileSizeInBytes != null && message.hasOwnProperty("maxFileSizeInBytes"))
                            if (!$util.isInteger(message.maxFileSizeInBytes) && !(message.maxFileSizeInBytes && $util.isInteger(message.maxFileSizeInBytes.low) && $util.isInteger(message.maxFileSizeInBytes.high)))
                                return "maxFileSizeInBytes: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FileConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FileConfig} FileConfig
                     */
                    FileConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FileConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.FileConfig();
                        switch (object.fileType) {
                        case "UNKNOWN":
                        case 0:
                            message.fileType = 0;
                            break;
                        case "IMAGE":
                        case 1:
                            message.fileType = 1;
                            break;
                        case "VIDEO":
                        case 2:
                            message.fileType = 2;
                            break;
                        }
                        if (object.maxNumberOfFiles != null)
                            message.maxNumberOfFiles = object.maxNumberOfFiles | 0;
                        if (object.maxFileSizeInBytes != null)
                            if ($util.Long)
                                (message.maxFileSizeInBytes = $util.Long.fromValue(object.maxFileSizeInBytes)).unsigned = false;
                            else if (typeof object.maxFileSizeInBytes === "string")
                                message.maxFileSizeInBytes = parseInt(object.maxFileSizeInBytes, 10);
                            else if (typeof object.maxFileSizeInBytes === "number")
                                message.maxFileSizeInBytes = object.maxFileSizeInBytes;
                            else if (typeof object.maxFileSizeInBytes === "object")
                                message.maxFileSizeInBytes = new $util.LongBits(object.maxFileSizeInBytes.low >>> 0, object.maxFileSizeInBytes.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FileConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FileConfig
                     * @static
                     * @param {palexy.task_management.v1.FileConfig} message FileConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FileConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.fileType = options.enums === String ? "UNKNOWN" : 0;
                            object.maxNumberOfFiles = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.maxFileSizeInBytes = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.maxFileSizeInBytes = options.longs === String ? "0" : 0;
                        }
                        if (message.fileType != null && message.hasOwnProperty("fileType"))
                            object.fileType = options.enums === String ? $root.palexy.task_management.v1.FileConfig.FileType[message.fileType] : message.fileType;
                        if (message.maxNumberOfFiles != null && message.hasOwnProperty("maxNumberOfFiles"))
                            object.maxNumberOfFiles = message.maxNumberOfFiles;
                        if (message.maxFileSizeInBytes != null && message.hasOwnProperty("maxFileSizeInBytes"))
                            if (typeof message.maxFileSizeInBytes === "number")
                                object.maxFileSizeInBytes = options.longs === String ? String(message.maxFileSizeInBytes) : message.maxFileSizeInBytes;
                            else
                                object.maxFileSizeInBytes = options.longs === String ? $util.Long.prototype.toString.call(message.maxFileSizeInBytes) : options.longs === Number ? new $util.LongBits(message.maxFileSizeInBytes.low >>> 0, message.maxFileSizeInBytes.high >>> 0).toNumber() : message.maxFileSizeInBytes;
                        return object;
                    };
    
                    /**
                     * Converts this FileConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FileConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FileConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * FileType enum.
                     * @name palexy.task_management.v1.FileConfig.FileType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} IMAGE=1 IMAGE value
                     * @property {number} VIDEO=2 VIDEO value
                     */
                    FileConfig.FileType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "IMAGE"] = 1;
                        values[valuesById[2] = "VIDEO"] = 2;
                        return values;
                    })();
    
                    return FileConfig;
                })();
    
                v1.Option = (function() {
    
                    /**
                     * Properties of an Option.
                     * @memberof palexy.task_management.v1
                     * @interface IOption
                     * @property {string|null} [id] Option id
                     * @property {string|null} [label] Option label
                     * @property {boolean|null} [isOther] Option isOther
                     * @property {string|null} [otherText] Option otherText
                     */
    
                    /**
                     * Constructs a new Option.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an Option.
                     * @implements IOption
                     * @constructor
                     * @param {palexy.task_management.v1.IOption=} [properties] Properties to set
                     */
                    function Option(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Option id.
                     * @member {string} id
                     * @memberof palexy.task_management.v1.Option
                     * @instance
                     */
                    Option.prototype.id = "";
    
                    /**
                     * Option label.
                     * @member {string} label
                     * @memberof palexy.task_management.v1.Option
                     * @instance
                     */
                    Option.prototype.label = "";
    
                    /**
                     * Option isOther.
                     * @member {boolean} isOther
                     * @memberof palexy.task_management.v1.Option
                     * @instance
                     */
                    Option.prototype.isOther = false;
    
                    /**
                     * Option otherText.
                     * @member {string} otherText
                     * @memberof palexy.task_management.v1.Option
                     * @instance
                     */
                    Option.prototype.otherText = "";
    
                    /**
                     * Creates a new Option instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {palexy.task_management.v1.IOption=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Option} Option instance
                     */
                    Option.create = function create(properties) {
                        return new Option(properties);
                    };
    
                    /**
                     * Encodes the specified Option message. Does not implicitly {@link palexy.task_management.v1.Option.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {palexy.task_management.v1.IOption} message Option message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Option.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.id);
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
                        if (message.isOther != null && Object.hasOwnProperty.call(message, "isOther"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isOther);
                        if (message.otherText != null && Object.hasOwnProperty.call(message, "otherText"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.otherText);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Option message, length delimited. Does not implicitly {@link palexy.task_management.v1.Option.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {palexy.task_management.v1.IOption} message Option message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Option.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Option message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Option} Option
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Option.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Option();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.string();
                                break;
                            case 2:
                                message.label = reader.string();
                                break;
                            case 3:
                                message.isOther = reader.bool();
                                break;
                            case 4:
                                message.otherText = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Option message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Option} Option
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Option.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Option message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Option.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isString(message.id))
                                return "id: string expected";
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        if (message.isOther != null && message.hasOwnProperty("isOther"))
                            if (typeof message.isOther !== "boolean")
                                return "isOther: boolean expected";
                        if (message.otherText != null && message.hasOwnProperty("otherText"))
                            if (!$util.isString(message.otherText))
                                return "otherText: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an Option message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Option} Option
                     */
                    Option.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Option)
                            return object;
                        var message = new $root.palexy.task_management.v1.Option();
                        if (object.id != null)
                            message.id = String(object.id);
                        if (object.label != null)
                            message.label = String(object.label);
                        if (object.isOther != null)
                            message.isOther = Boolean(object.isOther);
                        if (object.otherText != null)
                            message.otherText = String(object.otherText);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Option message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Option
                     * @static
                     * @param {palexy.task_management.v1.Option} message Option
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Option.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.id = "";
                            object.label = "";
                            object.isOther = false;
                            object.otherText = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            object.id = message.id;
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        if (message.isOther != null && message.hasOwnProperty("isOther"))
                            object.isOther = message.isOther;
                        if (message.otherText != null && message.hasOwnProperty("otherText"))
                            object.otherText = message.otherText;
                        return object;
                    };
    
                    /**
                     * Converts this Option to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Option
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Option.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Option;
                })();
    
                v1.OptionList = (function() {
    
                    /**
                     * Properties of an OptionList.
                     * @memberof palexy.task_management.v1
                     * @interface IOptionList
                     * @property {Array.<palexy.task_management.v1.IOption>|null} [options] OptionList options
                     */
    
                    /**
                     * Constructs a new OptionList.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an OptionList.
                     * @implements IOptionList
                     * @constructor
                     * @param {palexy.task_management.v1.IOptionList=} [properties] Properties to set
                     */
                    function OptionList(properties) {
                        this.options = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * OptionList options.
                     * @member {Array.<palexy.task_management.v1.IOption>} options
                     * @memberof palexy.task_management.v1.OptionList
                     * @instance
                     */
                    OptionList.prototype.options = $util.emptyArray;
    
                    /**
                     * Creates a new OptionList instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {palexy.task_management.v1.IOptionList=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.OptionList} OptionList instance
                     */
                    OptionList.create = function create(properties) {
                        return new OptionList(properties);
                    };
    
                    /**
                     * Encodes the specified OptionList message. Does not implicitly {@link palexy.task_management.v1.OptionList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {palexy.task_management.v1.IOptionList} message OptionList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OptionList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.options != null && message.options.length)
                            for (var i = 0; i < message.options.length; ++i)
                                $root.palexy.task_management.v1.Option.encode(message.options[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified OptionList message, length delimited. Does not implicitly {@link palexy.task_management.v1.OptionList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {palexy.task_management.v1.IOptionList} message OptionList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OptionList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an OptionList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.OptionList} OptionList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OptionList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.OptionList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.options && message.options.length))
                                    message.options = [];
                                message.options.push($root.palexy.task_management.v1.Option.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an OptionList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.OptionList} OptionList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OptionList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an OptionList message.
                     * @function verify
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    OptionList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.options != null && message.hasOwnProperty("options")) {
                            if (!Array.isArray(message.options))
                                return "options: array expected";
                            for (var i = 0; i < message.options.length; ++i) {
                                var error = $root.palexy.task_management.v1.Option.verify(message.options[i]);
                                if (error)
                                    return "options." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an OptionList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.OptionList} OptionList
                     */
                    OptionList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.OptionList)
                            return object;
                        var message = new $root.palexy.task_management.v1.OptionList();
                        if (object.options) {
                            if (!Array.isArray(object.options))
                                throw TypeError(".palexy.task_management.v1.OptionList.options: array expected");
                            message.options = [];
                            for (var i = 0; i < object.options.length; ++i) {
                                if (typeof object.options[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.OptionList.options: object expected");
                                message.options[i] = $root.palexy.task_management.v1.Option.fromObject(object.options[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an OptionList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.OptionList
                     * @static
                     * @param {palexy.task_management.v1.OptionList} message OptionList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    OptionList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.options = [];
                        if (message.options && message.options.length) {
                            object.options = [];
                            for (var j = 0; j < message.options.length; ++j)
                                object.options[j] = $root.palexy.task_management.v1.Option.toObject(message.options[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this OptionList to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.OptionList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    OptionList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return OptionList;
                })();
    
                v1.DisplayLogic = (function() {
    
                    /**
                     * Properties of a DisplayLogic.
                     * @memberof palexy.task_management.v1
                     * @interface IDisplayLogic
                     * @property {palexy.task_management.v1.IDisplayLogicNode|null} [root] DisplayLogic root
                     * @property {boolean|null} [ignoreUnresolvableAttributes] DisplayLogic ignoreUnresolvableAttributes
                     */
    
                    /**
                     * Constructs a new DisplayLogic.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DisplayLogic.
                     * @implements IDisplayLogic
                     * @constructor
                     * @param {palexy.task_management.v1.IDisplayLogic=} [properties] Properties to set
                     */
                    function DisplayLogic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DisplayLogic root.
                     * @member {palexy.task_management.v1.IDisplayLogicNode|null|undefined} root
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @instance
                     */
                    DisplayLogic.prototype.root = null;
    
                    /**
                     * DisplayLogic ignoreUnresolvableAttributes.
                     * @member {boolean} ignoreUnresolvableAttributes
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @instance
                     */
                    DisplayLogic.prototype.ignoreUnresolvableAttributes = false;
    
                    /**
                     * Creates a new DisplayLogic instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogic=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DisplayLogic} DisplayLogic instance
                     */
                    DisplayLogic.create = function create(properties) {
                        return new DisplayLogic(properties);
                    };
    
                    /**
                     * Encodes the specified DisplayLogic message. Does not implicitly {@link palexy.task_management.v1.DisplayLogic.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogic} message DisplayLogic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayLogic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.root != null && Object.hasOwnProperty.call(message, "root"))
                            $root.palexy.task_management.v1.DisplayLogicNode.encode(message.root, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.ignoreUnresolvableAttributes != null && Object.hasOwnProperty.call(message, "ignoreUnresolvableAttributes"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.ignoreUnresolvableAttributes);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DisplayLogic message, length delimited. Does not implicitly {@link palexy.task_management.v1.DisplayLogic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogic} message DisplayLogic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayLogic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DisplayLogic message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DisplayLogic} DisplayLogic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayLogic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DisplayLogic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.root = $root.palexy.task_management.v1.DisplayLogicNode.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.ignoreUnresolvableAttributes = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DisplayLogic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DisplayLogic} DisplayLogic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayLogic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DisplayLogic message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DisplayLogic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.root != null && message.hasOwnProperty("root")) {
                            var error = $root.palexy.task_management.v1.DisplayLogicNode.verify(message.root);
                            if (error)
                                return "root." + error;
                        }
                        if (message.ignoreUnresolvableAttributes != null && message.hasOwnProperty("ignoreUnresolvableAttributes"))
                            if (typeof message.ignoreUnresolvableAttributes !== "boolean")
                                return "ignoreUnresolvableAttributes: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a DisplayLogic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DisplayLogic} DisplayLogic
                     */
                    DisplayLogic.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DisplayLogic)
                            return object;
                        var message = new $root.palexy.task_management.v1.DisplayLogic();
                        if (object.root != null) {
                            if (typeof object.root !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayLogic.root: object expected");
                            message.root = $root.palexy.task_management.v1.DisplayLogicNode.fromObject(object.root);
                        }
                        if (object.ignoreUnresolvableAttributes != null)
                            message.ignoreUnresolvableAttributes = Boolean(object.ignoreUnresolvableAttributes);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DisplayLogic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @static
                     * @param {palexy.task_management.v1.DisplayLogic} message DisplayLogic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DisplayLogic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.root = null;
                            object.ignoreUnresolvableAttributes = false;
                        }
                        if (message.root != null && message.hasOwnProperty("root"))
                            object.root = $root.palexy.task_management.v1.DisplayLogicNode.toObject(message.root, options);
                        if (message.ignoreUnresolvableAttributes != null && message.hasOwnProperty("ignoreUnresolvableAttributes"))
                            object.ignoreUnresolvableAttributes = message.ignoreUnresolvableAttributes;
                        return object;
                    };
    
                    /**
                     * Converts this DisplayLogic to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DisplayLogic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DisplayLogic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DisplayLogic;
                })();
    
                v1.DisplayLogicNode = (function() {
    
                    /**
                     * Properties of a DisplayLogicNode.
                     * @memberof palexy.task_management.v1
                     * @interface IDisplayLogicNode
                     * @property {palexy.task_management.v1.DisplayLogicNode.Combinator|null} [combinator] DisplayLogicNode combinator
                     * @property {palexy.task_management.v1.IDisplayConditionGroup|null} [group] DisplayLogicNode group
                     * @property {palexy.task_management.v1.IDisplayCondition|null} [condition] DisplayLogicNode condition
                     */
    
                    /**
                     * Constructs a new DisplayLogicNode.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DisplayLogicNode.
                     * @implements IDisplayLogicNode
                     * @constructor
                     * @param {palexy.task_management.v1.IDisplayLogicNode=} [properties] Properties to set
                     */
                    function DisplayLogicNode(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DisplayLogicNode combinator.
                     * @member {palexy.task_management.v1.DisplayLogicNode.Combinator} combinator
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @instance
                     */
                    DisplayLogicNode.prototype.combinator = 0;
    
                    /**
                     * DisplayLogicNode group.
                     * @member {palexy.task_management.v1.IDisplayConditionGroup|null|undefined} group
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @instance
                     */
                    DisplayLogicNode.prototype.group = null;
    
                    /**
                     * DisplayLogicNode condition.
                     * @member {palexy.task_management.v1.IDisplayCondition|null|undefined} condition
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @instance
                     */
                    DisplayLogicNode.prototype.condition = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * DisplayLogicNode node.
                     * @member {"group"|"condition"|undefined} node
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @instance
                     */
                    Object.defineProperty(DisplayLogicNode.prototype, "node", {
                        get: $util.oneOfGetter($oneOfFields = ["group", "condition"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new DisplayLogicNode instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogicNode=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DisplayLogicNode} DisplayLogicNode instance
                     */
                    DisplayLogicNode.create = function create(properties) {
                        return new DisplayLogicNode(properties);
                    };
    
                    /**
                     * Encodes the specified DisplayLogicNode message. Does not implicitly {@link palexy.task_management.v1.DisplayLogicNode.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogicNode} message DisplayLogicNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayLogicNode.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.combinator != null && Object.hasOwnProperty.call(message, "combinator"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.combinator);
                        if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                            $root.palexy.task_management.v1.DisplayConditionGroup.encode(message.group, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.condition != null && Object.hasOwnProperty.call(message, "condition"))
                            $root.palexy.task_management.v1.DisplayCondition.encode(message.condition, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DisplayLogicNode message, length delimited. Does not implicitly {@link palexy.task_management.v1.DisplayLogicNode.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {palexy.task_management.v1.IDisplayLogicNode} message DisplayLogicNode message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayLogicNode.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DisplayLogicNode message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DisplayLogicNode} DisplayLogicNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayLogicNode.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DisplayLogicNode();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.combinator = reader.int32();
                                break;
                            case 2:
                                message.group = $root.palexy.task_management.v1.DisplayConditionGroup.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.condition = $root.palexy.task_management.v1.DisplayCondition.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DisplayLogicNode message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DisplayLogicNode} DisplayLogicNode
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayLogicNode.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DisplayLogicNode message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DisplayLogicNode.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.combinator != null && message.hasOwnProperty("combinator"))
                            switch (message.combinator) {
                            default:
                                return "combinator: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.group != null && message.hasOwnProperty("group")) {
                            properties.node = 1;
                            {
                                var error = $root.palexy.task_management.v1.DisplayConditionGroup.verify(message.group);
                                if (error)
                                    return "group." + error;
                            }
                        }
                        if (message.condition != null && message.hasOwnProperty("condition")) {
                            if (properties.node === 1)
                                return "node: multiple values";
                            properties.node = 1;
                            {
                                var error = $root.palexy.task_management.v1.DisplayCondition.verify(message.condition);
                                if (error)
                                    return "condition." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DisplayLogicNode message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DisplayLogicNode} DisplayLogicNode
                     */
                    DisplayLogicNode.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DisplayLogicNode)
                            return object;
                        var message = new $root.palexy.task_management.v1.DisplayLogicNode();
                        switch (object.combinator) {
                        case "COMBINATOR_UNSPECIFIED":
                        case 0:
                            message.combinator = 0;
                            break;
                        case "AND":
                        case 1:
                            message.combinator = 1;
                            break;
                        case "OR":
                        case 2:
                            message.combinator = 2;
                            break;
                        }
                        if (object.group != null) {
                            if (typeof object.group !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayLogicNode.group: object expected");
                            message.group = $root.palexy.task_management.v1.DisplayConditionGroup.fromObject(object.group);
                        }
                        if (object.condition != null) {
                            if (typeof object.condition !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayLogicNode.condition: object expected");
                            message.condition = $root.palexy.task_management.v1.DisplayCondition.fromObject(object.condition);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DisplayLogicNode message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @static
                     * @param {palexy.task_management.v1.DisplayLogicNode} message DisplayLogicNode
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DisplayLogicNode.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.combinator = options.enums === String ? "COMBINATOR_UNSPECIFIED" : 0;
                        if (message.combinator != null && message.hasOwnProperty("combinator"))
                            object.combinator = options.enums === String ? $root.palexy.task_management.v1.DisplayLogicNode.Combinator[message.combinator] : message.combinator;
                        if (message.group != null && message.hasOwnProperty("group")) {
                            object.group = $root.palexy.task_management.v1.DisplayConditionGroup.toObject(message.group, options);
                            if (options.oneofs)
                                object.node = "group";
                        }
                        if (message.condition != null && message.hasOwnProperty("condition")) {
                            object.condition = $root.palexy.task_management.v1.DisplayCondition.toObject(message.condition, options);
                            if (options.oneofs)
                                object.node = "condition";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this DisplayLogicNode to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DisplayLogicNode
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DisplayLogicNode.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Combinator enum.
                     * @name palexy.task_management.v1.DisplayLogicNode.Combinator
                     * @enum {number}
                     * @property {number} COMBINATOR_UNSPECIFIED=0 COMBINATOR_UNSPECIFIED value
                     * @property {number} AND=1 AND value
                     * @property {number} OR=2 OR value
                     */
                    DisplayLogicNode.Combinator = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "COMBINATOR_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "AND"] = 1;
                        values[valuesById[2] = "OR"] = 2;
                        return values;
                    })();
    
                    return DisplayLogicNode;
                })();
    
                v1.DisplayConditionGroup = (function() {
    
                    /**
                     * Properties of a DisplayConditionGroup.
                     * @memberof palexy.task_management.v1
                     * @interface IDisplayConditionGroup
                     * @property {Array.<palexy.task_management.v1.IDisplayLogicNode>|null} [children] DisplayConditionGroup children
                     */
    
                    /**
                     * Constructs a new DisplayConditionGroup.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DisplayConditionGroup.
                     * @implements IDisplayConditionGroup
                     * @constructor
                     * @param {palexy.task_management.v1.IDisplayConditionGroup=} [properties] Properties to set
                     */
                    function DisplayConditionGroup(properties) {
                        this.children = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DisplayConditionGroup children.
                     * @member {Array.<palexy.task_management.v1.IDisplayLogicNode>} children
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @instance
                     */
                    DisplayConditionGroup.prototype.children = $util.emptyArray;
    
                    /**
                     * Creates a new DisplayConditionGroup instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {palexy.task_management.v1.IDisplayConditionGroup=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DisplayConditionGroup} DisplayConditionGroup instance
                     */
                    DisplayConditionGroup.create = function create(properties) {
                        return new DisplayConditionGroup(properties);
                    };
    
                    /**
                     * Encodes the specified DisplayConditionGroup message. Does not implicitly {@link palexy.task_management.v1.DisplayConditionGroup.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {palexy.task_management.v1.IDisplayConditionGroup} message DisplayConditionGroup message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayConditionGroup.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.children != null && message.children.length)
                            for (var i = 0; i < message.children.length; ++i)
                                $root.palexy.task_management.v1.DisplayLogicNode.encode(message.children[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DisplayConditionGroup message, length delimited. Does not implicitly {@link palexy.task_management.v1.DisplayConditionGroup.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {palexy.task_management.v1.IDisplayConditionGroup} message DisplayConditionGroup message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayConditionGroup.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DisplayConditionGroup message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DisplayConditionGroup} DisplayConditionGroup
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayConditionGroup.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DisplayConditionGroup();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.children && message.children.length))
                                    message.children = [];
                                message.children.push($root.palexy.task_management.v1.DisplayLogicNode.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DisplayConditionGroup message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DisplayConditionGroup} DisplayConditionGroup
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayConditionGroup.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DisplayConditionGroup message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DisplayConditionGroup.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.children != null && message.hasOwnProperty("children")) {
                            if (!Array.isArray(message.children))
                                return "children: array expected";
                            for (var i = 0; i < message.children.length; ++i) {
                                var error = $root.palexy.task_management.v1.DisplayLogicNode.verify(message.children[i]);
                                if (error)
                                    return "children." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DisplayConditionGroup message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DisplayConditionGroup} DisplayConditionGroup
                     */
                    DisplayConditionGroup.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DisplayConditionGroup)
                            return object;
                        var message = new $root.palexy.task_management.v1.DisplayConditionGroup();
                        if (object.children) {
                            if (!Array.isArray(object.children))
                                throw TypeError(".palexy.task_management.v1.DisplayConditionGroup.children: array expected");
                            message.children = [];
                            for (var i = 0; i < object.children.length; ++i) {
                                if (typeof object.children[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.DisplayConditionGroup.children: object expected");
                                message.children[i] = $root.palexy.task_management.v1.DisplayLogicNode.fromObject(object.children[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DisplayConditionGroup message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @static
                     * @param {palexy.task_management.v1.DisplayConditionGroup} message DisplayConditionGroup
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DisplayConditionGroup.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.children = [];
                        if (message.children && message.children.length) {
                            object.children = [];
                            for (var j = 0; j < message.children.length; ++j)
                                object.children[j] = $root.palexy.task_management.v1.DisplayLogicNode.toObject(message.children[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this DisplayConditionGroup to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DisplayConditionGroup
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DisplayConditionGroup.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DisplayConditionGroup;
                })();
    
                v1.DisplayCondition = (function() {
    
                    /**
                     * Properties of a DisplayCondition.
                     * @memberof palexy.task_management.v1
                     * @interface IDisplayCondition
                     * @property {palexy.task_management.v1.DisplayCondition.SourceType|null} [sourceType] DisplayCondition sourceType
                     * @property {palexy.task_management.v1.IQuestionDetail|null} [question] DisplayCondition question
                     * @property {palexy.task_management.v1.ICustomAttributeDetail|null} [customAttribute] DisplayCondition customAttribute
                     * @property {palexy.task_management.v1.IChoicePredicate|null} [choice] DisplayCondition choice
                     * @property {palexy.task_management.v1.ITextPredicate|null} [text] DisplayCondition text
                     * @property {palexy.task_management.v1.INumericPredicate|null} [numeric] DisplayCondition numeric
                     */
    
                    /**
                     * Constructs a new DisplayCondition.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DisplayCondition.
                     * @implements IDisplayCondition
                     * @constructor
                     * @param {palexy.task_management.v1.IDisplayCondition=} [properties] Properties to set
                     */
                    function DisplayCondition(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DisplayCondition sourceType.
                     * @member {palexy.task_management.v1.DisplayCondition.SourceType} sourceType
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.sourceType = 0;
    
                    /**
                     * DisplayCondition question.
                     * @member {palexy.task_management.v1.IQuestionDetail|null|undefined} question
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.question = null;
    
                    /**
                     * DisplayCondition customAttribute.
                     * @member {palexy.task_management.v1.ICustomAttributeDetail|null|undefined} customAttribute
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.customAttribute = null;
    
                    /**
                     * DisplayCondition choice.
                     * @member {palexy.task_management.v1.IChoicePredicate|null|undefined} choice
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.choice = null;
    
                    /**
                     * DisplayCondition text.
                     * @member {palexy.task_management.v1.ITextPredicate|null|undefined} text
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.text = null;
    
                    /**
                     * DisplayCondition numeric.
                     * @member {palexy.task_management.v1.INumericPredicate|null|undefined} numeric
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    DisplayCondition.prototype.numeric = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * DisplayCondition sourceDetail.
                     * @member {"question"|"customAttribute"|undefined} sourceDetail
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    Object.defineProperty(DisplayCondition.prototype, "sourceDetail", {
                        get: $util.oneOfGetter($oneOfFields = ["question", "customAttribute"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * DisplayCondition predicate.
                     * @member {"choice"|"text"|"numeric"|undefined} predicate
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     */
                    Object.defineProperty(DisplayCondition.prototype, "predicate", {
                        get: $util.oneOfGetter($oneOfFields = ["choice", "text", "numeric"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new DisplayCondition instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {palexy.task_management.v1.IDisplayCondition=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DisplayCondition} DisplayCondition instance
                     */
                    DisplayCondition.create = function create(properties) {
                        return new DisplayCondition(properties);
                    };
    
                    /**
                     * Encodes the specified DisplayCondition message. Does not implicitly {@link palexy.task_management.v1.DisplayCondition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {palexy.task_management.v1.IDisplayCondition} message DisplayCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayCondition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sourceType != null && Object.hasOwnProperty.call(message, "sourceType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.sourceType);
                        if (message.question != null && Object.hasOwnProperty.call(message, "question"))
                            $root.palexy.task_management.v1.QuestionDetail.encode(message.question, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.customAttribute != null && Object.hasOwnProperty.call(message, "customAttribute"))
                            $root.palexy.task_management.v1.CustomAttributeDetail.encode(message.customAttribute, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.choice != null && Object.hasOwnProperty.call(message, "choice"))
                            $root.palexy.task_management.v1.ChoicePredicate.encode(message.choice, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                            $root.palexy.task_management.v1.TextPredicate.encode(message.text, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        if (message.numeric != null && Object.hasOwnProperty.call(message, "numeric"))
                            $root.palexy.task_management.v1.NumericPredicate.encode(message.numeric, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DisplayCondition message, length delimited. Does not implicitly {@link palexy.task_management.v1.DisplayCondition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {palexy.task_management.v1.IDisplayCondition} message DisplayCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DisplayCondition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DisplayCondition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DisplayCondition} DisplayCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayCondition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DisplayCondition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sourceType = reader.int32();
                                break;
                            case 2:
                                message.question = $root.palexy.task_management.v1.QuestionDetail.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.customAttribute = $root.palexy.task_management.v1.CustomAttributeDetail.decode(reader, reader.uint32());
                                break;
                            case 10:
                                message.choice = $root.palexy.task_management.v1.ChoicePredicate.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.text = $root.palexy.task_management.v1.TextPredicate.decode(reader, reader.uint32());
                                break;
                            case 12:
                                message.numeric = $root.palexy.task_management.v1.NumericPredicate.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DisplayCondition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DisplayCondition} DisplayCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DisplayCondition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DisplayCondition message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DisplayCondition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                            switch (message.sourceType) {
                            default:
                                return "sourceType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.question != null && message.hasOwnProperty("question")) {
                            properties.sourceDetail = 1;
                            {
                                var error = $root.palexy.task_management.v1.QuestionDetail.verify(message.question);
                                if (error)
                                    return "question." + error;
                            }
                        }
                        if (message.customAttribute != null && message.hasOwnProperty("customAttribute")) {
                            if (properties.sourceDetail === 1)
                                return "sourceDetail: multiple values";
                            properties.sourceDetail = 1;
                            {
                                var error = $root.palexy.task_management.v1.CustomAttributeDetail.verify(message.customAttribute);
                                if (error)
                                    return "customAttribute." + error;
                            }
                        }
                        if (message.choice != null && message.hasOwnProperty("choice")) {
                            properties.predicate = 1;
                            {
                                var error = $root.palexy.task_management.v1.ChoicePredicate.verify(message.choice);
                                if (error)
                                    return "choice." + error;
                            }
                        }
                        if (message.text != null && message.hasOwnProperty("text")) {
                            if (properties.predicate === 1)
                                return "predicate: multiple values";
                            properties.predicate = 1;
                            {
                                var error = $root.palexy.task_management.v1.TextPredicate.verify(message.text);
                                if (error)
                                    return "text." + error;
                            }
                        }
                        if (message.numeric != null && message.hasOwnProperty("numeric")) {
                            if (properties.predicate === 1)
                                return "predicate: multiple values";
                            properties.predicate = 1;
                            {
                                var error = $root.palexy.task_management.v1.NumericPredicate.verify(message.numeric);
                                if (error)
                                    return "numeric." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DisplayCondition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DisplayCondition} DisplayCondition
                     */
                    DisplayCondition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DisplayCondition)
                            return object;
                        var message = new $root.palexy.task_management.v1.DisplayCondition();
                        switch (object.sourceType) {
                        case "SOURCE_TYPE_UNSPECIFIED":
                        case 0:
                            message.sourceType = 0;
                            break;
                        case "QUESTION":
                        case 1:
                            message.sourceType = 1;
                            break;
                        case "CUSTOM_ATTRIBUTE":
                        case 2:
                            message.sourceType = 2;
                            break;
                        }
                        if (object.question != null) {
                            if (typeof object.question !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayCondition.question: object expected");
                            message.question = $root.palexy.task_management.v1.QuestionDetail.fromObject(object.question);
                        }
                        if (object.customAttribute != null) {
                            if (typeof object.customAttribute !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayCondition.customAttribute: object expected");
                            message.customAttribute = $root.palexy.task_management.v1.CustomAttributeDetail.fromObject(object.customAttribute);
                        }
                        if (object.choice != null) {
                            if (typeof object.choice !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayCondition.choice: object expected");
                            message.choice = $root.palexy.task_management.v1.ChoicePredicate.fromObject(object.choice);
                        }
                        if (object.text != null) {
                            if (typeof object.text !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayCondition.text: object expected");
                            message.text = $root.palexy.task_management.v1.TextPredicate.fromObject(object.text);
                        }
                        if (object.numeric != null) {
                            if (typeof object.numeric !== "object")
                                throw TypeError(".palexy.task_management.v1.DisplayCondition.numeric: object expected");
                            message.numeric = $root.palexy.task_management.v1.NumericPredicate.fromObject(object.numeric);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DisplayCondition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @static
                     * @param {palexy.task_management.v1.DisplayCondition} message DisplayCondition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DisplayCondition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.sourceType = options.enums === String ? "SOURCE_TYPE_UNSPECIFIED" : 0;
                        if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                            object.sourceType = options.enums === String ? $root.palexy.task_management.v1.DisplayCondition.SourceType[message.sourceType] : message.sourceType;
                        if (message.question != null && message.hasOwnProperty("question")) {
                            object.question = $root.palexy.task_management.v1.QuestionDetail.toObject(message.question, options);
                            if (options.oneofs)
                                object.sourceDetail = "question";
                        }
                        if (message.customAttribute != null && message.hasOwnProperty("customAttribute")) {
                            object.customAttribute = $root.palexy.task_management.v1.CustomAttributeDetail.toObject(message.customAttribute, options);
                            if (options.oneofs)
                                object.sourceDetail = "customAttribute";
                        }
                        if (message.choice != null && message.hasOwnProperty("choice")) {
                            object.choice = $root.palexy.task_management.v1.ChoicePredicate.toObject(message.choice, options);
                            if (options.oneofs)
                                object.predicate = "choice";
                        }
                        if (message.text != null && message.hasOwnProperty("text")) {
                            object.text = $root.palexy.task_management.v1.TextPredicate.toObject(message.text, options);
                            if (options.oneofs)
                                object.predicate = "text";
                        }
                        if (message.numeric != null && message.hasOwnProperty("numeric")) {
                            object.numeric = $root.palexy.task_management.v1.NumericPredicate.toObject(message.numeric, options);
                            if (options.oneofs)
                                object.predicate = "numeric";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this DisplayCondition to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DisplayCondition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DisplayCondition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * SourceType enum.
                     * @name palexy.task_management.v1.DisplayCondition.SourceType
                     * @enum {number}
                     * @property {number} SOURCE_TYPE_UNSPECIFIED=0 SOURCE_TYPE_UNSPECIFIED value
                     * @property {number} QUESTION=1 QUESTION value
                     * @property {number} CUSTOM_ATTRIBUTE=2 CUSTOM_ATTRIBUTE value
                     */
                    DisplayCondition.SourceType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SOURCE_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "QUESTION"] = 1;
                        values[valuesById[2] = "CUSTOM_ATTRIBUTE"] = 2;
                        return values;
                    })();
    
                    return DisplayCondition;
                })();
    
                v1.QuestionDetail = (function() {
    
                    /**
                     * Properties of a QuestionDetail.
                     * @memberof palexy.task_management.v1
                     * @interface IQuestionDetail
                     * @property {string|null} [internalQuestionId] QuestionDetail internalQuestionId
                     */
    
                    /**
                     * Constructs a new QuestionDetail.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a QuestionDetail.
                     * @implements IQuestionDetail
                     * @constructor
                     * @param {palexy.task_management.v1.IQuestionDetail=} [properties] Properties to set
                     */
                    function QuestionDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * QuestionDetail internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @instance
                     */
                    QuestionDetail.prototype.internalQuestionId = "";
    
                    /**
                     * Creates a new QuestionDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {palexy.task_management.v1.IQuestionDetail=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.QuestionDetail} QuestionDetail instance
                     */
                    QuestionDetail.create = function create(properties) {
                        return new QuestionDetail(properties);
                    };
    
                    /**
                     * Encodes the specified QuestionDetail message. Does not implicitly {@link palexy.task_management.v1.QuestionDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {palexy.task_management.v1.IQuestionDetail} message QuestionDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuestionDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.internalQuestionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified QuestionDetail message, length delimited. Does not implicitly {@link palexy.task_management.v1.QuestionDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {palexy.task_management.v1.IQuestionDetail} message QuestionDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    QuestionDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a QuestionDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.QuestionDetail} QuestionDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuestionDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.QuestionDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.internalQuestionId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a QuestionDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.QuestionDetail} QuestionDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    QuestionDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a QuestionDetail message.
                     * @function verify
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    QuestionDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a QuestionDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.QuestionDetail} QuestionDetail
                     */
                    QuestionDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.QuestionDetail)
                            return object;
                        var message = new $root.palexy.task_management.v1.QuestionDetail();
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a QuestionDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @static
                     * @param {palexy.task_management.v1.QuestionDetail} message QuestionDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    QuestionDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.internalQuestionId = "";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        return object;
                    };
    
                    /**
                     * Converts this QuestionDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.QuestionDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    QuestionDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return QuestionDetail;
                })();
    
                v1.CustomAttributeDetail = (function() {
    
                    /**
                     * Properties of a CustomAttributeDetail.
                     * @memberof palexy.task_management.v1
                     * @interface ICustomAttributeDetail
                     * @property {string|null} [attributeCode] CustomAttributeDetail attributeCode
                     */
    
                    /**
                     * Constructs a new CustomAttributeDetail.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CustomAttributeDetail.
                     * @implements ICustomAttributeDetail
                     * @constructor
                     * @param {palexy.task_management.v1.ICustomAttributeDetail=} [properties] Properties to set
                     */
                    function CustomAttributeDetail(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CustomAttributeDetail attributeCode.
                     * @member {string} attributeCode
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @instance
                     */
                    CustomAttributeDetail.prototype.attributeCode = "";
    
                    /**
                     * Creates a new CustomAttributeDetail instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {palexy.task_management.v1.ICustomAttributeDetail=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CustomAttributeDetail} CustomAttributeDetail instance
                     */
                    CustomAttributeDetail.create = function create(properties) {
                        return new CustomAttributeDetail(properties);
                    };
    
                    /**
                     * Encodes the specified CustomAttributeDetail message. Does not implicitly {@link palexy.task_management.v1.CustomAttributeDetail.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {palexy.task_management.v1.ICustomAttributeDetail} message CustomAttributeDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomAttributeDetail.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributeCode != null && Object.hasOwnProperty.call(message, "attributeCode"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.attributeCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CustomAttributeDetail message, length delimited. Does not implicitly {@link palexy.task_management.v1.CustomAttributeDetail.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {palexy.task_management.v1.ICustomAttributeDetail} message CustomAttributeDetail message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CustomAttributeDetail.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CustomAttributeDetail message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CustomAttributeDetail} CustomAttributeDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomAttributeDetail.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CustomAttributeDetail();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.attributeCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CustomAttributeDetail message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CustomAttributeDetail} CustomAttributeDetail
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CustomAttributeDetail.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CustomAttributeDetail message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CustomAttributeDetail.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributeCode != null && message.hasOwnProperty("attributeCode"))
                            if (!$util.isString(message.attributeCode))
                                return "attributeCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CustomAttributeDetail message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CustomAttributeDetail} CustomAttributeDetail
                     */
                    CustomAttributeDetail.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CustomAttributeDetail)
                            return object;
                        var message = new $root.palexy.task_management.v1.CustomAttributeDetail();
                        if (object.attributeCode != null)
                            message.attributeCode = String(object.attributeCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CustomAttributeDetail message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @static
                     * @param {palexy.task_management.v1.CustomAttributeDetail} message CustomAttributeDetail
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CustomAttributeDetail.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.attributeCode = "";
                        if (message.attributeCode != null && message.hasOwnProperty("attributeCode"))
                            object.attributeCode = message.attributeCode;
                        return object;
                    };
    
                    /**
                     * Converts this CustomAttributeDetail to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CustomAttributeDetail
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CustomAttributeDetail.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CustomAttributeDetail;
                })();
    
                v1.ChoicePredicate = (function() {
    
                    /**
                     * Properties of a ChoicePredicate.
                     * @memberof palexy.task_management.v1
                     * @interface IChoicePredicate
                     * @property {string|null} [optionId] ChoicePredicate optionId
                     * @property {palexy.task_management.v1.ChoicePredicate.Operator|null} [operator] ChoicePredicate operator
                     */
    
                    /**
                     * Constructs a new ChoicePredicate.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ChoicePredicate.
                     * @implements IChoicePredicate
                     * @constructor
                     * @param {palexy.task_management.v1.IChoicePredicate=} [properties] Properties to set
                     */
                    function ChoicePredicate(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ChoicePredicate optionId.
                     * @member {string} optionId
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @instance
                     */
                    ChoicePredicate.prototype.optionId = "";
    
                    /**
                     * ChoicePredicate operator.
                     * @member {palexy.task_management.v1.ChoicePredicate.Operator} operator
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @instance
                     */
                    ChoicePredicate.prototype.operator = 0;
    
                    /**
                     * Creates a new ChoicePredicate instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {palexy.task_management.v1.IChoicePredicate=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ChoicePredicate} ChoicePredicate instance
                     */
                    ChoicePredicate.create = function create(properties) {
                        return new ChoicePredicate(properties);
                    };
    
                    /**
                     * Encodes the specified ChoicePredicate message. Does not implicitly {@link palexy.task_management.v1.ChoicePredicate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {palexy.task_management.v1.IChoicePredicate} message ChoicePredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChoicePredicate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.optionId);
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.operator);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ChoicePredicate message, length delimited. Does not implicitly {@link palexy.task_management.v1.ChoicePredicate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {palexy.task_management.v1.IChoicePredicate} message ChoicePredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChoicePredicate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ChoicePredicate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ChoicePredicate} ChoicePredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChoicePredicate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ChoicePredicate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.optionId = reader.string();
                                break;
                            case 2:
                                message.operator = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ChoicePredicate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ChoicePredicate} ChoicePredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChoicePredicate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ChoicePredicate message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ChoicePredicate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.optionId != null && message.hasOwnProperty("optionId"))
                            if (!$util.isString(message.optionId))
                                return "optionId: string expected";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            switch (message.operator) {
                            default:
                                return "operator: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a ChoicePredicate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ChoicePredicate} ChoicePredicate
                     */
                    ChoicePredicate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ChoicePredicate)
                            return object;
                        var message = new $root.palexy.task_management.v1.ChoicePredicate();
                        if (object.optionId != null)
                            message.optionId = String(object.optionId);
                        switch (object.operator) {
                        case "OPERATOR_UNSPECIFIED":
                        case 0:
                            message.operator = 0;
                            break;
                        case "IS_SELECTED":
                        case 1:
                            message.operator = 1;
                            break;
                        case "IS_NOT_SELECTED":
                        case 2:
                            message.operator = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ChoicePredicate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @static
                     * @param {palexy.task_management.v1.ChoicePredicate} message ChoicePredicate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ChoicePredicate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.optionId = "";
                            object.operator = options.enums === String ? "OPERATOR_UNSPECIFIED" : 0;
                        }
                        if (message.optionId != null && message.hasOwnProperty("optionId"))
                            object.optionId = message.optionId;
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = options.enums === String ? $root.palexy.task_management.v1.ChoicePredicate.Operator[message.operator] : message.operator;
                        return object;
                    };
    
                    /**
                     * Converts this ChoicePredicate to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ChoicePredicate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ChoicePredicate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Operator enum.
                     * @name palexy.task_management.v1.ChoicePredicate.Operator
                     * @enum {number}
                     * @property {number} OPERATOR_UNSPECIFIED=0 OPERATOR_UNSPECIFIED value
                     * @property {number} IS_SELECTED=1 IS_SELECTED value
                     * @property {number} IS_NOT_SELECTED=2 IS_NOT_SELECTED value
                     */
                    ChoicePredicate.Operator = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "OPERATOR_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "IS_SELECTED"] = 1;
                        values[valuesById[2] = "IS_NOT_SELECTED"] = 2;
                        return values;
                    })();
    
                    return ChoicePredicate;
                })();
    
                v1.TextPredicate = (function() {
    
                    /**
                     * Properties of a TextPredicate.
                     * @memberof palexy.task_management.v1
                     * @interface ITextPredicate
                     * @property {palexy.task_management.v1.TextPredicate.Operator|null} [operator] TextPredicate operator
                     * @property {string|null} [value] TextPredicate value
                     */
    
                    /**
                     * Constructs a new TextPredicate.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TextPredicate.
                     * @implements ITextPredicate
                     * @constructor
                     * @param {palexy.task_management.v1.ITextPredicate=} [properties] Properties to set
                     */
                    function TextPredicate(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TextPredicate operator.
                     * @member {palexy.task_management.v1.TextPredicate.Operator} operator
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @instance
                     */
                    TextPredicate.prototype.operator = 0;
    
                    /**
                     * TextPredicate value.
                     * @member {string} value
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @instance
                     */
                    TextPredicate.prototype.value = "";
    
                    /**
                     * Creates a new TextPredicate instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {palexy.task_management.v1.ITextPredicate=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TextPredicate} TextPredicate instance
                     */
                    TextPredicate.create = function create(properties) {
                        return new TextPredicate(properties);
                    };
    
                    /**
                     * Encodes the specified TextPredicate message. Does not implicitly {@link palexy.task_management.v1.TextPredicate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {palexy.task_management.v1.ITextPredicate} message TextPredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TextPredicate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.operator);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TextPredicate message, length delimited. Does not implicitly {@link palexy.task_management.v1.TextPredicate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {palexy.task_management.v1.ITextPredicate} message TextPredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TextPredicate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TextPredicate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TextPredicate} TextPredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TextPredicate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TextPredicate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.operator = reader.int32();
                                break;
                            case 2:
                                message.value = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TextPredicate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TextPredicate} TextPredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TextPredicate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TextPredicate message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TextPredicate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            switch (message.operator) {
                            default:
                                return "operator: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a TextPredicate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TextPredicate} TextPredicate
                     */
                    TextPredicate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TextPredicate)
                            return object;
                        var message = new $root.palexy.task_management.v1.TextPredicate();
                        switch (object.operator) {
                        case "OPERATOR_UNSPECIFIED":
                        case 0:
                            message.operator = 0;
                            break;
                        case "EQUAL_TO":
                        case 1:
                            message.operator = 1;
                            break;
                        case "NOT_EQUAL_TO":
                        case 2:
                            message.operator = 2;
                            break;
                        case "CONTAINS":
                        case 3:
                            message.operator = 3;
                            break;
                        case "NOT_CONTAINS":
                        case 4:
                            message.operator = 4;
                            break;
                        case "IS_EMPTY":
                        case 5:
                            message.operator = 5;
                            break;
                        case "IS_NOT_EMPTY":
                        case 6:
                            message.operator = 6;
                            break;
                        }
                        if (object.value != null)
                            message.value = String(object.value);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TextPredicate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @static
                     * @param {palexy.task_management.v1.TextPredicate} message TextPredicate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TextPredicate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.operator = options.enums === String ? "OPERATOR_UNSPECIFIED" : 0;
                            object.value = "";
                        }
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = options.enums === String ? $root.palexy.task_management.v1.TextPredicate.Operator[message.operator] : message.operator;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        return object;
                    };
    
                    /**
                     * Converts this TextPredicate to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TextPredicate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TextPredicate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Operator enum.
                     * @name palexy.task_management.v1.TextPredicate.Operator
                     * @enum {number}
                     * @property {number} OPERATOR_UNSPECIFIED=0 OPERATOR_UNSPECIFIED value
                     * @property {number} EQUAL_TO=1 EQUAL_TO value
                     * @property {number} NOT_EQUAL_TO=2 NOT_EQUAL_TO value
                     * @property {number} CONTAINS=3 CONTAINS value
                     * @property {number} NOT_CONTAINS=4 NOT_CONTAINS value
                     * @property {number} IS_EMPTY=5 IS_EMPTY value
                     * @property {number} IS_NOT_EMPTY=6 IS_NOT_EMPTY value
                     */
                    TextPredicate.Operator = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "OPERATOR_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "EQUAL_TO"] = 1;
                        values[valuesById[2] = "NOT_EQUAL_TO"] = 2;
                        values[valuesById[3] = "CONTAINS"] = 3;
                        values[valuesById[4] = "NOT_CONTAINS"] = 4;
                        values[valuesById[5] = "IS_EMPTY"] = 5;
                        values[valuesById[6] = "IS_NOT_EMPTY"] = 6;
                        return values;
                    })();
    
                    return TextPredicate;
                })();
    
                v1.NumericPredicate = (function() {
    
                    /**
                     * Properties of a NumericPredicate.
                     * @memberof palexy.task_management.v1
                     * @interface INumericPredicate
                     * @property {palexy.task_management.v1.NumericPredicate.Operator|null} [operator] NumericPredicate operator
                     * @property {number|null} [value] NumericPredicate value
                     */
    
                    /**
                     * Constructs a new NumericPredicate.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a NumericPredicate.
                     * @implements INumericPredicate
                     * @constructor
                     * @param {palexy.task_management.v1.INumericPredicate=} [properties] Properties to set
                     */
                    function NumericPredicate(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NumericPredicate operator.
                     * @member {palexy.task_management.v1.NumericPredicate.Operator} operator
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @instance
                     */
                    NumericPredicate.prototype.operator = 0;
    
                    /**
                     * NumericPredicate value.
                     * @member {number} value
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @instance
                     */
                    NumericPredicate.prototype.value = 0;
    
                    /**
                     * Creates a new NumericPredicate instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {palexy.task_management.v1.INumericPredicate=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.NumericPredicate} NumericPredicate instance
                     */
                    NumericPredicate.create = function create(properties) {
                        return new NumericPredicate(properties);
                    };
    
                    /**
                     * Encodes the specified NumericPredicate message. Does not implicitly {@link palexy.task_management.v1.NumericPredicate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {palexy.task_management.v1.INumericPredicate} message NumericPredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NumericPredicate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.operator != null && Object.hasOwnProperty.call(message, "operator"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.operator);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.value);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NumericPredicate message, length delimited. Does not implicitly {@link palexy.task_management.v1.NumericPredicate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {palexy.task_management.v1.INumericPredicate} message NumericPredicate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NumericPredicate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NumericPredicate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.NumericPredicate} NumericPredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NumericPredicate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.NumericPredicate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.operator = reader.int32();
                                break;
                            case 2:
                                message.value = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a NumericPredicate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.NumericPredicate} NumericPredicate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NumericPredicate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NumericPredicate message.
                     * @function verify
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NumericPredicate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            switch (message.operator) {
                            default:
                                return "operator: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (typeof message.value !== "number")
                                return "value: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a NumericPredicate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.NumericPredicate} NumericPredicate
                     */
                    NumericPredicate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.NumericPredicate)
                            return object;
                        var message = new $root.palexy.task_management.v1.NumericPredicate();
                        switch (object.operator) {
                        case "OPERATOR_UNSPECIFIED":
                        case 0:
                            message.operator = 0;
                            break;
                        case "EQUAL":
                        case 1:
                            message.operator = 1;
                            break;
                        case "NOT_EQUAL":
                        case 2:
                            message.operator = 2;
                            break;
                        case "GREATER_THAN":
                        case 3:
                            message.operator = 3;
                            break;
                        case "GREATER_OR_EQUAL":
                        case 4:
                            message.operator = 4;
                            break;
                        case "LESS_THAN":
                        case 5:
                            message.operator = 5;
                            break;
                        case "LESS_OR_EQUAL":
                        case 6:
                            message.operator = 6;
                            break;
                        }
                        if (object.value != null)
                            message.value = Number(object.value);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NumericPredicate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @static
                     * @param {palexy.task_management.v1.NumericPredicate} message NumericPredicate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NumericPredicate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.operator = options.enums === String ? "OPERATOR_UNSPECIFIED" : 0;
                            object.value = 0;
                        }
                        if (message.operator != null && message.hasOwnProperty("operator"))
                            object.operator = options.enums === String ? $root.palexy.task_management.v1.NumericPredicate.Operator[message.operator] : message.operator;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                        return object;
                    };
    
                    /**
                     * Converts this NumericPredicate to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.NumericPredicate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NumericPredicate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Operator enum.
                     * @name palexy.task_management.v1.NumericPredicate.Operator
                     * @enum {number}
                     * @property {number} OPERATOR_UNSPECIFIED=0 OPERATOR_UNSPECIFIED value
                     * @property {number} EQUAL=1 EQUAL value
                     * @property {number} NOT_EQUAL=2 NOT_EQUAL value
                     * @property {number} GREATER_THAN=3 GREATER_THAN value
                     * @property {number} GREATER_OR_EQUAL=4 GREATER_OR_EQUAL value
                     * @property {number} LESS_THAN=5 LESS_THAN value
                     * @property {number} LESS_OR_EQUAL=6 LESS_OR_EQUAL value
                     */
                    NumericPredicate.Operator = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "OPERATOR_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "EQUAL"] = 1;
                        values[valuesById[2] = "NOT_EQUAL"] = 2;
                        values[valuesById[3] = "GREATER_THAN"] = 3;
                        values[valuesById[4] = "GREATER_OR_EQUAL"] = 4;
                        values[valuesById[5] = "LESS_THAN"] = 5;
                        values[valuesById[6] = "LESS_OR_EQUAL"] = 6;
                        return values;
                    })();
    
                    return NumericPredicate;
                })();
    
                v1.FileList = (function() {
    
                    /**
                     * Properties of a FileList.
                     * @memberof palexy.task_management.v1
                     * @interface IFileList
                     * @property {Array.<palexy.streaming.v1.IArtifact>|null} [files] FileList files
                     */
    
                    /**
                     * Constructs a new FileList.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FileList.
                     * @implements IFileList
                     * @constructor
                     * @param {palexy.task_management.v1.IFileList=} [properties] Properties to set
                     */
                    function FileList(properties) {
                        this.files = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FileList files.
                     * @member {Array.<palexy.streaming.v1.IArtifact>} files
                     * @memberof palexy.task_management.v1.FileList
                     * @instance
                     */
                    FileList.prototype.files = $util.emptyArray;
    
                    /**
                     * Creates a new FileList instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {palexy.task_management.v1.IFileList=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FileList} FileList instance
                     */
                    FileList.create = function create(properties) {
                        return new FileList(properties);
                    };
    
                    /**
                     * Encodes the specified FileList message. Does not implicitly {@link palexy.task_management.v1.FileList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {palexy.task_management.v1.IFileList} message FileList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.files != null && message.files.length)
                            for (var i = 0; i < message.files.length; ++i)
                                $root.palexy.streaming.v1.Artifact.encode(message.files[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FileList message, length delimited. Does not implicitly {@link palexy.task_management.v1.FileList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {palexy.task_management.v1.IFileList} message FileList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FileList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FileList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FileList} FileList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FileList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 7:
                                if (!(message.files && message.files.length))
                                    message.files = [];
                                message.files.push($root.palexy.streaming.v1.Artifact.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FileList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FileList} FileList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FileList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FileList message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FileList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.files != null && message.hasOwnProperty("files")) {
                            if (!Array.isArray(message.files))
                                return "files: array expected";
                            for (var i = 0; i < message.files.length; ++i) {
                                var error = $root.palexy.streaming.v1.Artifact.verify(message.files[i]);
                                if (error)
                                    return "files." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FileList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FileList} FileList
                     */
                    FileList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FileList)
                            return object;
                        var message = new $root.palexy.task_management.v1.FileList();
                        if (object.files) {
                            if (!Array.isArray(object.files))
                                throw TypeError(".palexy.task_management.v1.FileList.files: array expected");
                            message.files = [];
                            for (var i = 0; i < object.files.length; ++i) {
                                if (typeof object.files[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FileList.files: object expected");
                                message.files[i] = $root.palexy.streaming.v1.Artifact.fromObject(object.files[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FileList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FileList
                     * @static
                     * @param {palexy.task_management.v1.FileList} message FileList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FileList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.files = [];
                        if (message.files && message.files.length) {
                            object.files = [];
                            for (var j = 0; j < message.files.length; ++j)
                                object.files[j] = $root.palexy.streaming.v1.Artifact.toObject(message.files[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FileList to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FileList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FileList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FileList;
                })();
    
                v1.FormSubmission = (function() {
    
                    /**
                     * Properties of a FormSubmission.
                     * @memberof palexy.task_management.v1
                     * @interface IFormSubmission
                     * @property {number|null} [id] FormSubmission id
                     * @property {number|null} [formId] FormSubmission formId
                     * @property {palexy.task_management.v1.IUser|null} [submitter] FormSubmission submitter
                     * @property {Array.<palexy.task_management.v1.IFormSubmissionValue>|null} [values] FormSubmission values
                     * @property {number|null} [createdTimeMs] FormSubmission createdTimeMs
                     * @property {number|null} [updatedTimeMs] FormSubmission updatedTimeMs
                     * @property {palexy.task_management.v1.FormDistribution.DistributionType|null} [distributionType] FormSubmission distributionType
                     * @property {Object.<string,string>|null} [contextProperties] FormSubmission contextProperties
                     * @property {string|null} [ipAddress] FormSubmission ipAddress
                     * @property {number|null} [formVersionId] FormSubmission formVersionId
                     * @property {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>|null} [attributeValues] FormSubmission attributeValues
                     */
    
                    /**
                     * Constructs a new FormSubmission.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormSubmission.
                     * @implements IFormSubmission
                     * @constructor
                     * @param {palexy.task_management.v1.IFormSubmission=} [properties] Properties to set
                     */
                    function FormSubmission(properties) {
                        this.values = [];
                        this.contextProperties = {};
                        this.attributeValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormSubmission id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmission formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmission submitter.
                     * @member {palexy.task_management.v1.IUser|null|undefined} submitter
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.submitter = null;
    
                    /**
                     * FormSubmission values.
                     * @member {Array.<palexy.task_management.v1.IFormSubmissionValue>} values
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.values = $util.emptyArray;
    
                    /**
                     * FormSubmission createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmission updatedTimeMs.
                     * @member {number} updatedTimeMs
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.updatedTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmission distributionType.
                     * @member {palexy.task_management.v1.FormDistribution.DistributionType} distributionType
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.distributionType = 0;
    
                    /**
                     * FormSubmission contextProperties.
                     * @member {Object.<string,string>} contextProperties
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.contextProperties = $util.emptyObject;
    
                    /**
                     * FormSubmission ipAddress.
                     * @member {string} ipAddress
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.ipAddress = "";
    
                    /**
                     * FormSubmission formVersionId.
                     * @member {number} formVersionId
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.formVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmission attributeValues.
                     * @member {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>} attributeValues
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     */
                    FormSubmission.prototype.attributeValues = $util.emptyArray;
    
                    /**
                     * Creates a new FormSubmission instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmission=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormSubmission} FormSubmission instance
                     */
                    FormSubmission.create = function create(properties) {
                        return new FormSubmission(properties);
                    };
    
                    /**
                     * Encodes the specified FormSubmission message. Does not implicitly {@link palexy.task_management.v1.FormSubmission.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmission} message FormSubmission message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmission.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.submitter != null && Object.hasOwnProperty.call(message, "submitter"))
                            $root.palexy.task_management.v1.User.encode(message.submitter, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.values != null && message.values.length)
                            for (var i = 0; i < message.values.length; ++i)
                                $root.palexy.task_management.v1.FormSubmissionValue.encode(message.values[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.updatedTimeMs != null && Object.hasOwnProperty.call(message, "updatedTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.updatedTimeMs);
                        if (message.distributionType != null && Object.hasOwnProperty.call(message, "distributionType"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.distributionType);
                        if (message.contextProperties != null && Object.hasOwnProperty.call(message, "contextProperties"))
                            for (var keys = Object.keys(message.contextProperties), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 8, wireType 2 =*/66).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.contextProperties[keys[i]]).ldelim();
                        if (message.ipAddress != null && Object.hasOwnProperty.call(message, "ipAddress"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.ipAddress);
                        if (message.formVersionId != null && Object.hasOwnProperty.call(message, "formVersionId"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.formVersionId);
                        if (message.attributeValues != null && message.attributeValues.length)
                            for (var i = 0; i < message.attributeValues.length; ++i)
                                $root.palexy.task_management.v1.FormSubmissionAttributeValue.encode(message.attributeValues[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormSubmission message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormSubmission.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmission} message FormSubmission message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmission.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormSubmission message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormSubmission} FormSubmission
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmission.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormSubmission(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.submitter = $root.palexy.task_management.v1.User.decode(reader, reader.uint32());
                                break;
                            case 4:
                                if (!(message.values && message.values.length))
                                    message.values = [];
                                message.values.push($root.palexy.task_management.v1.FormSubmissionValue.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.updatedTimeMs = reader.int64();
                                break;
                            case 7:
                                message.distributionType = reader.int32();
                                break;
                            case 8:
                                if (message.contextProperties === $util.emptyObject)
                                    message.contextProperties = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.contextProperties[key] = value;
                                break;
                            case 9:
                                message.ipAddress = reader.string();
                                break;
                            case 10:
                                message.formVersionId = reader.int64();
                                break;
                            case 11:
                                if (!(message.attributeValues && message.attributeValues.length))
                                    message.attributeValues = [];
                                message.attributeValues.push($root.palexy.task_management.v1.FormSubmissionAttributeValue.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormSubmission message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormSubmission} FormSubmission
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmission.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormSubmission message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormSubmission.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submitter != null && message.hasOwnProperty("submitter")) {
                            var error = $root.palexy.task_management.v1.User.verify(message.submitter);
                            if (error)
                                return "submitter." + error;
                        }
                        if (message.values != null && message.hasOwnProperty("values")) {
                            if (!Array.isArray(message.values))
                                return "values: array expected";
                            for (var i = 0; i < message.values.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmissionValue.verify(message.values[i]);
                                if (error)
                                    return "values." + error;
                            }
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.updatedTimeMs != null && message.hasOwnProperty("updatedTimeMs"))
                            if (!$util.isInteger(message.updatedTimeMs) && !(message.updatedTimeMs && $util.isInteger(message.updatedTimeMs.low) && $util.isInteger(message.updatedTimeMs.high)))
                                return "updatedTimeMs: integer|Long expected";
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            switch (message.distributionType) {
                            default:
                                return "distributionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.contextProperties != null && message.hasOwnProperty("contextProperties")) {
                            if (!$util.isObject(message.contextProperties))
                                return "contextProperties: object expected";
                            var key = Object.keys(message.contextProperties);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.contextProperties[key[i]]))
                                    return "contextProperties: string{k:string} expected";
                        }
                        if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                            if (!$util.isString(message.ipAddress))
                                return "ipAddress: string expected";
                        if (message.formVersionId != null && message.hasOwnProperty("formVersionId"))
                            if (!$util.isInteger(message.formVersionId) && !(message.formVersionId && $util.isInteger(message.formVersionId.low) && $util.isInteger(message.formVersionId.high)))
                                return "formVersionId: integer|Long expected";
                        if (message.attributeValues != null && message.hasOwnProperty("attributeValues")) {
                            if (!Array.isArray(message.attributeValues))
                                return "attributeValues: array expected";
                            for (var i = 0; i < message.attributeValues.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmissionAttributeValue.verify(message.attributeValues[i]);
                                if (error)
                                    return "attributeValues." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormSubmission message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormSubmission} FormSubmission
                     */
                    FormSubmission.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormSubmission)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormSubmission();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submitter != null) {
                            if (typeof object.submitter !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmission.submitter: object expected");
                            message.submitter = $root.palexy.task_management.v1.User.fromObject(object.submitter);
                        }
                        if (object.values) {
                            if (!Array.isArray(object.values))
                                throw TypeError(".palexy.task_management.v1.FormSubmission.values: array expected");
                            message.values = [];
                            for (var i = 0; i < object.values.length; ++i) {
                                if (typeof object.values[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormSubmission.values: object expected");
                                message.values[i] = $root.palexy.task_management.v1.FormSubmissionValue.fromObject(object.values[i]);
                            }
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.updatedTimeMs != null)
                            if ($util.Long)
                                (message.updatedTimeMs = $util.Long.fromValue(object.updatedTimeMs)).unsigned = false;
                            else if (typeof object.updatedTimeMs === "string")
                                message.updatedTimeMs = parseInt(object.updatedTimeMs, 10);
                            else if (typeof object.updatedTimeMs === "number")
                                message.updatedTimeMs = object.updatedTimeMs;
                            else if (typeof object.updatedTimeMs === "object")
                                message.updatedTimeMs = new $util.LongBits(object.updatedTimeMs.low >>> 0, object.updatedTimeMs.high >>> 0).toNumber();
                        switch (object.distributionType) {
                        case "UNKNOWN":
                        case 0:
                            message.distributionType = 0;
                            break;
                        case "LINK":
                        case 1:
                            message.distributionType = 1;
                            break;
                        case "STORE_EVENT":
                        case 2:
                            message.distributionType = 2;
                            break;
                        case "CONTACT_LIST":
                        case 3:
                            message.distributionType = 3;
                            break;
                        }
                        if (object.contextProperties) {
                            if (typeof object.contextProperties !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmission.contextProperties: object expected");
                            message.contextProperties = {};
                            for (var keys = Object.keys(object.contextProperties), i = 0; i < keys.length; ++i)
                                message.contextProperties[keys[i]] = String(object.contextProperties[keys[i]]);
                        }
                        if (object.ipAddress != null)
                            message.ipAddress = String(object.ipAddress);
                        if (object.formVersionId != null)
                            if ($util.Long)
                                (message.formVersionId = $util.Long.fromValue(object.formVersionId)).unsigned = false;
                            else if (typeof object.formVersionId === "string")
                                message.formVersionId = parseInt(object.formVersionId, 10);
                            else if (typeof object.formVersionId === "number")
                                message.formVersionId = object.formVersionId;
                            else if (typeof object.formVersionId === "object")
                                message.formVersionId = new $util.LongBits(object.formVersionId.low >>> 0, object.formVersionId.high >>> 0).toNumber();
                        if (object.attributeValues) {
                            if (!Array.isArray(object.attributeValues))
                                throw TypeError(".palexy.task_management.v1.FormSubmission.attributeValues: array expected");
                            message.attributeValues = [];
                            for (var i = 0; i < object.attributeValues.length; ++i) {
                                if (typeof object.attributeValues[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormSubmission.attributeValues: object expected");
                                message.attributeValues[i] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.fromObject(object.attributeValues[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormSubmission message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @static
                     * @param {palexy.task_management.v1.FormSubmission} message FormSubmission
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormSubmission.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.values = [];
                            object.attributeValues = [];
                        }
                        if (options.objects || options.defaults)
                            object.contextProperties = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.submitter = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.updatedTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.updatedTimeMs = options.longs === String ? "0" : 0;
                            object.distributionType = options.enums === String ? "UNKNOWN" : 0;
                            object.ipAddress = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formVersionId = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submitter != null && message.hasOwnProperty("submitter"))
                            object.submitter = $root.palexy.task_management.v1.User.toObject(message.submitter, options);
                        if (message.values && message.values.length) {
                            object.values = [];
                            for (var j = 0; j < message.values.length; ++j)
                                object.values[j] = $root.palexy.task_management.v1.FormSubmissionValue.toObject(message.values[j], options);
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.updatedTimeMs != null && message.hasOwnProperty("updatedTimeMs"))
                            if (typeof message.updatedTimeMs === "number")
                                object.updatedTimeMs = options.longs === String ? String(message.updatedTimeMs) : message.updatedTimeMs;
                            else
                                object.updatedTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.updatedTimeMs) : options.longs === Number ? new $util.LongBits(message.updatedTimeMs.low >>> 0, message.updatedTimeMs.high >>> 0).toNumber() : message.updatedTimeMs;
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            object.distributionType = options.enums === String ? $root.palexy.task_management.v1.FormDistribution.DistributionType[message.distributionType] : message.distributionType;
                        var keys2;
                        if (message.contextProperties && (keys2 = Object.keys(message.contextProperties)).length) {
                            object.contextProperties = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.contextProperties[keys2[j]] = message.contextProperties[keys2[j]];
                        }
                        if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                            object.ipAddress = message.ipAddress;
                        if (message.formVersionId != null && message.hasOwnProperty("formVersionId"))
                            if (typeof message.formVersionId === "number")
                                object.formVersionId = options.longs === String ? String(message.formVersionId) : message.formVersionId;
                            else
                                object.formVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.formVersionId) : options.longs === Number ? new $util.LongBits(message.formVersionId.low >>> 0, message.formVersionId.high >>> 0).toNumber() : message.formVersionId;
                        if (message.attributeValues && message.attributeValues.length) {
                            object.attributeValues = [];
                            for (var j = 0; j < message.attributeValues.length; ++j)
                                object.attributeValues[j] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.toObject(message.attributeValues[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FormSubmission to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormSubmission
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormSubmission.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormSubmission;
                })();
    
                v1.FormSubmissionValue = (function() {
    
                    /**
                     * Properties of a FormSubmissionValue.
                     * @memberof palexy.task_management.v1
                     * @interface IFormSubmissionValue
                     * @property {number|null} [id] FormSubmissionValue id
                     * @property {number|null} [submissionId] FormSubmissionValue submissionId
                     * @property {number|null} [formFieldId] FormSubmissionValue formFieldId
                     * @property {string|null} [valueText] FormSubmissionValue valueText
                     * @property {palexy.task_management.v1.IOption|null} [valueOption] FormSubmissionValue valueOption
                     * @property {palexy.task_management.v1.IOptionList|null} [valueOptionList] FormSubmissionValue valueOptionList
                     * @property {palexy.task_management.v1.IFileList|null} [valueFileList] FormSubmissionValue valueFileList
                     * @property {string|null} [internalQuestionId] FormSubmissionValue internalQuestionId
                     */
    
                    /**
                     * Constructs a new FormSubmissionValue.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormSubmissionValue.
                     * @implements IFormSubmissionValue
                     * @constructor
                     * @param {palexy.task_management.v1.IFormSubmissionValue=} [properties] Properties to set
                     */
                    function FormSubmissionValue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormSubmissionValue id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionValue submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionValue formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionValue valueText.
                     * @member {string|null|undefined} valueText
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.valueText = null;
    
                    /**
                     * FormSubmissionValue valueOption.
                     * @member {palexy.task_management.v1.IOption|null|undefined} valueOption
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.valueOption = null;
    
                    /**
                     * FormSubmissionValue valueOptionList.
                     * @member {palexy.task_management.v1.IOptionList|null|undefined} valueOptionList
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.valueOptionList = null;
    
                    /**
                     * FormSubmissionValue valueFileList.
                     * @member {palexy.task_management.v1.IFileList|null|undefined} valueFileList
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.valueFileList = null;
    
                    /**
                     * FormSubmissionValue internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    FormSubmissionValue.prototype.internalQuestionId = "";
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * FormSubmissionValue value.
                     * @member {"valueText"|"valueOption"|"valueOptionList"|"valueFileList"|undefined} value
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     */
                    Object.defineProperty(FormSubmissionValue.prototype, "value", {
                        get: $util.oneOfGetter($oneOfFields = ["valueText", "valueOption", "valueOptionList", "valueFileList"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new FormSubmissionValue instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionValue=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormSubmissionValue} FormSubmissionValue instance
                     */
                    FormSubmissionValue.create = function create(properties) {
                        return new FormSubmissionValue(properties);
                    };
    
                    /**
                     * Encodes the specified FormSubmissionValue message. Does not implicitly {@link palexy.task_management.v1.FormSubmissionValue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionValue} message FormSubmissionValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.formFieldId);
                        if (message.valueText != null && Object.hasOwnProperty.call(message, "valueText"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.valueText);
                        if (message.valueOption != null && Object.hasOwnProperty.call(message, "valueOption"))
                            $root.palexy.task_management.v1.Option.encode(message.valueOption, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.valueOptionList != null && Object.hasOwnProperty.call(message, "valueOptionList"))
                            $root.palexy.task_management.v1.OptionList.encode(message.valueOptionList, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.valueFileList != null && Object.hasOwnProperty.call(message, "valueFileList"))
                            $root.palexy.task_management.v1.FileList.encode(message.valueFileList, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.internalQuestionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormSubmissionValue message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormSubmissionValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionValue} message FormSubmissionValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormSubmissionValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormSubmissionValue} FormSubmissionValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormSubmissionValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.formFieldId = reader.int64();
                                break;
                            case 4:
                                message.valueText = reader.string();
                                break;
                            case 5:
                                message.valueOption = $root.palexy.task_management.v1.Option.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.valueOptionList = $root.palexy.task_management.v1.OptionList.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.valueFileList = $root.palexy.task_management.v1.FileList.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.internalQuestionId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormSubmissionValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormSubmissionValue} FormSubmissionValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormSubmissionValue message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormSubmissionValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        if (message.valueText != null && message.hasOwnProperty("valueText")) {
                            properties.value = 1;
                            if (!$util.isString(message.valueText))
                                return "valueText: string expected";
                        }
                        if (message.valueOption != null && message.hasOwnProperty("valueOption")) {
                            if (properties.value === 1)
                                return "value: multiple values";
                            properties.value = 1;
                            {
                                var error = $root.palexy.task_management.v1.Option.verify(message.valueOption);
                                if (error)
                                    return "valueOption." + error;
                            }
                        }
                        if (message.valueOptionList != null && message.hasOwnProperty("valueOptionList")) {
                            if (properties.value === 1)
                                return "value: multiple values";
                            properties.value = 1;
                            {
                                var error = $root.palexy.task_management.v1.OptionList.verify(message.valueOptionList);
                                if (error)
                                    return "valueOptionList." + error;
                            }
                        }
                        if (message.valueFileList != null && message.hasOwnProperty("valueFileList")) {
                            if (properties.value === 1)
                                return "value: multiple values";
                            properties.value = 1;
                            {
                                var error = $root.palexy.task_management.v1.FileList.verify(message.valueFileList);
                                if (error)
                                    return "valueFileList." + error;
                            }
                        }
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormSubmissionValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormSubmissionValue} FormSubmissionValue
                     */
                    FormSubmissionValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormSubmissionValue)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormSubmissionValue();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        if (object.valueText != null)
                            message.valueText = String(object.valueText);
                        if (object.valueOption != null) {
                            if (typeof object.valueOption !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionValue.valueOption: object expected");
                            message.valueOption = $root.palexy.task_management.v1.Option.fromObject(object.valueOption);
                        }
                        if (object.valueOptionList != null) {
                            if (typeof object.valueOptionList !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionValue.valueOptionList: object expected");
                            message.valueOptionList = $root.palexy.task_management.v1.OptionList.fromObject(object.valueOptionList);
                        }
                        if (object.valueFileList != null) {
                            if (typeof object.valueFileList !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionValue.valueFileList: object expected");
                            message.valueFileList = $root.palexy.task_management.v1.FileList.fromObject(object.valueFileList);
                        }
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormSubmissionValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @static
                     * @param {palexy.task_management.v1.FormSubmissionValue} message FormSubmissionValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormSubmissionValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                            object.internalQuestionId = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        if (message.valueText != null && message.hasOwnProperty("valueText")) {
                            object.valueText = message.valueText;
                            if (options.oneofs)
                                object.value = "valueText";
                        }
                        if (message.valueOption != null && message.hasOwnProperty("valueOption")) {
                            object.valueOption = $root.palexy.task_management.v1.Option.toObject(message.valueOption, options);
                            if (options.oneofs)
                                object.value = "valueOption";
                        }
                        if (message.valueOptionList != null && message.hasOwnProperty("valueOptionList")) {
                            object.valueOptionList = $root.palexy.task_management.v1.OptionList.toObject(message.valueOptionList, options);
                            if (options.oneofs)
                                object.value = "valueOptionList";
                        }
                        if (message.valueFileList != null && message.hasOwnProperty("valueFileList")) {
                            object.valueFileList = $root.palexy.task_management.v1.FileList.toObject(message.valueFileList, options);
                            if (options.oneofs)
                                object.value = "valueFileList";
                        }
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        return object;
                    };
    
                    /**
                     * Converts this FormSubmissionValue to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormSubmissionValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormSubmissionValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormSubmissionValue;
                })();
    
                v1.CreateFormRequest = (function() {
    
                    /**
                     * Properties of a CreateFormRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormRequest
                     * @property {palexy.task_management.v1.IForm|null} [form] CreateFormRequest form
                     */
    
                    /**
                     * Constructs a new CreateFormRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormRequest.
                     * @implements ICreateFormRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormRequest=} [properties] Properties to set
                     */
                    function CreateFormRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormRequest form.
                     * @member {palexy.task_management.v1.IForm|null|undefined} form
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @instance
                     */
                    CreateFormRequest.prototype.form = null;
    
                    /**
                     * Creates a new CreateFormRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormRequest} CreateFormRequest instance
                     */
                    CreateFormRequest.create = function create(properties) {
                        return new CreateFormRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormRequest} message CreateFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.form != null && Object.hasOwnProperty.call(message, "form"))
                            $root.palexy.task_management.v1.Form.encode(message.form, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormRequest} message CreateFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormRequest} CreateFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.form = $root.palexy.task_management.v1.Form.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormRequest} CreateFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.form != null && message.hasOwnProperty("form")) {
                            var error = $root.palexy.task_management.v1.Form.verify(message.form);
                            if (error)
                                return "form." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormRequest} CreateFormRequest
                     */
                    CreateFormRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormRequest();
                        if (object.form != null) {
                            if (typeof object.form !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormRequest.form: object expected");
                            message.form = $root.palexy.task_management.v1.Form.fromObject(object.form);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormRequest} message CreateFormRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.form = null;
                        if (message.form != null && message.hasOwnProperty("form"))
                            object.form = $root.palexy.task_management.v1.Form.toObject(message.form, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormRequest;
                })();
    
                v1.ListFormsRequest = (function() {
    
                    /**
                     * Properties of a ListFormsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormsRequest
                     * @property {number|null} [pageSize] ListFormsRequest pageSize
                     * @property {string|null} [pageToken] ListFormsRequest pageToken
                     * @property {number|null} [companyId] ListFormsRequest companyId
                     * @property {number|null} [projectId] ListFormsRequest projectId
                     * @property {google.protobuf.IBoolValue|null} [isDeleted] ListFormsRequest isDeleted
                     * @property {boolean|null} [includeDetailData] ListFormsRequest includeDetailData
                     */
    
                    /**
                     * Constructs a new ListFormsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormsRequest.
                     * @implements IListFormsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormsRequest=} [properties] Properties to set
                     */
                    function ListFormsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormsRequest projectId.
                     * @member {number} projectId
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.projectId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormsRequest isDeleted.
                     * @member {google.protobuf.IBoolValue|null|undefined} isDeleted
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.isDeleted = null;
    
                    /**
                     * ListFormsRequest includeDetailData.
                     * @member {boolean} includeDetailData
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     */
                    ListFormsRequest.prototype.includeDetailData = false;
    
                    /**
                     * Creates a new ListFormsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormsRequest} ListFormsRequest instance
                     */
                    ListFormsRequest.create = function create(properties) {
                        return new ListFormsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormsRequest} message ListFormsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.pageToken);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.companyId);
                        if (message.projectId != null && Object.hasOwnProperty.call(message, "projectId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.projectId);
                        if (message.isDeleted != null && Object.hasOwnProperty.call(message, "isDeleted"))
                            $root.google.protobuf.BoolValue.encode(message.isDeleted, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.includeDetailData != null && Object.hasOwnProperty.call(message, "includeDetailData"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeDetailData);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormsRequest} message ListFormsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormsRequest} ListFormsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.pageSize = reader.int32();
                                break;
                            case 2:
                                message.pageToken = reader.string();
                                break;
                            case 3:
                                message.companyId = reader.int64();
                                break;
                            case 4:
                                message.projectId = reader.int64();
                                break;
                            case 5:
                                message.isDeleted = $root.google.protobuf.BoolValue.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.includeDetailData = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormsRequest} ListFormsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (!$util.isInteger(message.projectId) && !(message.projectId && $util.isInteger(message.projectId.low) && $util.isInteger(message.projectId.high)))
                                return "projectId: integer|Long expected";
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted")) {
                            var error = $root.google.protobuf.BoolValue.verify(message.isDeleted);
                            if (error)
                                return "isDeleted." + error;
                        }
                        if (message.includeDetailData != null && message.hasOwnProperty("includeDetailData"))
                            if (typeof message.includeDetailData !== "boolean")
                                return "includeDetailData: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormsRequest} ListFormsRequest
                     */
                    ListFormsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormsRequest();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.projectId != null)
                            if ($util.Long)
                                (message.projectId = $util.Long.fromValue(object.projectId)).unsigned = false;
                            else if (typeof object.projectId === "string")
                                message.projectId = parseInt(object.projectId, 10);
                            else if (typeof object.projectId === "number")
                                message.projectId = object.projectId;
                            else if (typeof object.projectId === "object")
                                message.projectId = new $util.LongBits(object.projectId.low >>> 0, object.projectId.high >>> 0).toNumber();
                        if (object.isDeleted != null) {
                            if (typeof object.isDeleted !== "object")
                                throw TypeError(".palexy.task_management.v1.ListFormsRequest.isDeleted: object expected");
                            message.isDeleted = $root.google.protobuf.BoolValue.fromObject(object.isDeleted);
                        }
                        if (object.includeDetailData != null)
                            message.includeDetailData = Boolean(object.includeDetailData);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormsRequest} message ListFormsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.projectId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.projectId = options.longs === String ? "0" : 0;
                            object.isDeleted = null;
                            object.includeDetailData = false;
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.projectId != null && message.hasOwnProperty("projectId"))
                            if (typeof message.projectId === "number")
                                object.projectId = options.longs === String ? String(message.projectId) : message.projectId;
                            else
                                object.projectId = options.longs === String ? $util.Long.prototype.toString.call(message.projectId) : options.longs === Number ? new $util.LongBits(message.projectId.low >>> 0, message.projectId.high >>> 0).toNumber() : message.projectId;
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            object.isDeleted = $root.google.protobuf.BoolValue.toObject(message.isDeleted, options);
                        if (message.includeDetailData != null && message.hasOwnProperty("includeDetailData"))
                            object.includeDetailData = message.includeDetailData;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormsRequest;
                })();
    
                v1.ListFormsResponse = (function() {
    
                    /**
                     * Properties of a ListFormsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormsResponse
                     * @property {Array.<palexy.task_management.v1.IForm>|null} [forms] ListFormsResponse forms
                     * @property {number|null} [totalElements] ListFormsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormsResponse.
                     * @implements IListFormsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormsResponse=} [properties] Properties to set
                     */
                    function ListFormsResponse(properties) {
                        this.forms = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormsResponse forms.
                     * @member {Array.<palexy.task_management.v1.IForm>} forms
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @instance
                     */
                    ListFormsResponse.prototype.forms = $util.emptyArray;
    
                    /**
                     * ListFormsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @instance
                     */
                    ListFormsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @instance
                     */
                    ListFormsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormsResponse} ListFormsResponse instance
                     */
                    ListFormsResponse.create = function create(properties) {
                        return new ListFormsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormsResponse} message ListFormsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.forms != null && message.forms.length)
                            for (var i = 0; i < message.forms.length; ++i)
                                $root.palexy.task_management.v1.Form.encode(message.forms[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormsResponse} message ListFormsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormsResponse} ListFormsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.forms && message.forms.length))
                                    message.forms = [];
                                message.forms.push($root.palexy.task_management.v1.Form.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormsResponse} ListFormsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.forms != null && message.hasOwnProperty("forms")) {
                            if (!Array.isArray(message.forms))
                                return "forms: array expected";
                            for (var i = 0; i < message.forms.length; ++i) {
                                var error = $root.palexy.task_management.v1.Form.verify(message.forms[i]);
                                if (error)
                                    return "forms." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormsResponse} ListFormsResponse
                     */
                    ListFormsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormsResponse();
                        if (object.forms) {
                            if (!Array.isArray(object.forms))
                                throw TypeError(".palexy.task_management.v1.ListFormsResponse.forms: array expected");
                            message.forms = [];
                            for (var i = 0; i < object.forms.length; ++i) {
                                if (typeof object.forms[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormsResponse.forms: object expected");
                                message.forms[i] = $root.palexy.task_management.v1.Form.fromObject(object.forms[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormsResponse} message ListFormsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.forms = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.forms && message.forms.length) {
                            object.forms = [];
                            for (var j = 0; j < message.forms.length; ++j)
                                object.forms[j] = $root.palexy.task_management.v1.Form.toObject(message.forms[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormsResponse;
                })();
    
                v1.GetFormRequest = (function() {
    
                    /**
                     * Properties of a GetFormRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormRequest
                     * @property {number|null} [formId] GetFormRequest formId
                     * @property {boolean|null} [published] GetFormRequest published
                     * @property {string|null} [languageCode] GetFormRequest languageCode
                     */
    
                    /**
                     * Constructs a new GetFormRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormRequest.
                     * @implements IGetFormRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormRequest=} [properties] Properties to set
                     */
                    function GetFormRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @instance
                     */
                    GetFormRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormRequest published.
                     * @member {boolean} published
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @instance
                     */
                    GetFormRequest.prototype.published = false;
    
                    /**
                     * GetFormRequest languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @instance
                     */
                    GetFormRequest.prototype.languageCode = "";
    
                    /**
                     * Creates a new GetFormRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormRequest} GetFormRequest instance
                     */
                    GetFormRequest.create = function create(properties) {
                        return new GetFormRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormRequest} message GetFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.published != null && Object.hasOwnProperty.call(message, "published"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.published);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormRequest} message GetFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormRequest} GetFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.published = reader.bool();
                                break;
                            case 3:
                                message.languageCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormRequest} GetFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.published != null && message.hasOwnProperty("published"))
                            if (typeof message.published !== "boolean")
                                return "published: boolean expected";
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormRequest} GetFormRequest
                     */
                    GetFormRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.published != null)
                            message.published = Boolean(object.published);
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormRequest} message GetFormRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.published = false;
                            object.languageCode = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.published != null && message.hasOwnProperty("published"))
                            object.published = message.published;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormRequest;
                })();
    
                v1.UpdateFormRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormRequest
                     * @property {number|null} [formId] UpdateFormRequest formId
                     * @property {palexy.task_management.v1.IForm|null} [form] UpdateFormRequest form
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateFormRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormRequest.
                     * @implements IUpdateFormRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormRequest=} [properties] Properties to set
                     */
                    function UpdateFormRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @instance
                     */
                    UpdateFormRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormRequest form.
                     * @member {palexy.task_management.v1.IForm|null|undefined} form
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @instance
                     */
                    UpdateFormRequest.prototype.form = null;
    
                    /**
                     * UpdateFormRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @instance
                     */
                    UpdateFormRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateFormRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormRequest} UpdateFormRequest instance
                     */
                    UpdateFormRequest.create = function create(properties) {
                        return new UpdateFormRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormRequest} message UpdateFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.form != null && Object.hasOwnProperty.call(message, "form"))
                            $root.palexy.task_management.v1.Form.encode(message.form, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormRequest} message UpdateFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormRequest} UpdateFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.form = $root.palexy.task_management.v1.Form.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormRequest} UpdateFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.form != null && message.hasOwnProperty("form")) {
                            var error = $root.palexy.task_management.v1.Form.verify(message.form);
                            if (error)
                                return "form." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormRequest} UpdateFormRequest
                     */
                    UpdateFormRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.form != null) {
                            if (typeof object.form !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormRequest.form: object expected");
                            message.form = $root.palexy.task_management.v1.Form.fromObject(object.form);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormRequest} message UpdateFormRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.form = null;
                            object.updateMask = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.form != null && message.hasOwnProperty("form"))
                            object.form = $root.palexy.task_management.v1.Form.toObject(message.form, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormRequest;
                })();
    
                v1.DeleteFormRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormRequest
                     * @property {number|null} [formId] DeleteFormRequest formId
                     */
    
                    /**
                     * Constructs a new DeleteFormRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormRequest.
                     * @implements IDeleteFormRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormRequest=} [properties] Properties to set
                     */
                    function DeleteFormRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @instance
                     */
                    DeleteFormRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormRequest} DeleteFormRequest instance
                     */
                    DeleteFormRequest.create = function create(properties) {
                        return new DeleteFormRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormRequest} message DeleteFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormRequest} message DeleteFormRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormRequest} DeleteFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormRequest} DeleteFormRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormRequest} DeleteFormRequest
                     */
                    DeleteFormRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormRequest} message DeleteFormRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormRequest;
                })();
    
                v1.ListFormVersionsRequest = (function() {
    
                    /**
                     * Properties of a ListFormVersionsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormVersionsRequest
                     * @property {number|null} [formId] ListFormVersionsRequest formId
                     */
    
                    /**
                     * Constructs a new ListFormVersionsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormVersionsRequest.
                     * @implements IListFormVersionsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormVersionsRequest=} [properties] Properties to set
                     */
                    function ListFormVersionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormVersionsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @instance
                     */
                    ListFormVersionsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormVersionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormVersionsRequest} ListFormVersionsRequest instance
                     */
                    ListFormVersionsRequest.create = function create(properties) {
                        return new ListFormVersionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormVersionsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormVersionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsRequest} message ListFormVersionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormVersionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormVersionsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormVersionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsRequest} message ListFormVersionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormVersionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormVersionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormVersionsRequest} ListFormVersionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormVersionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormVersionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormVersionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormVersionsRequest} ListFormVersionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormVersionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormVersionsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormVersionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormVersionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormVersionsRequest} ListFormVersionsRequest
                     */
                    ListFormVersionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormVersionsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormVersionsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormVersionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormVersionsRequest} message ListFormVersionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormVersionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormVersionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormVersionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormVersionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormVersionsRequest;
                })();
    
                v1.ListFormVersionsResponse = (function() {
    
                    /**
                     * Properties of a ListFormVersionsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormVersionsResponse
                     * @property {Array.<palexy.task_management.v1.IFormVersion>|null} [versions] ListFormVersionsResponse versions
                     */
    
                    /**
                     * Constructs a new ListFormVersionsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormVersionsResponse.
                     * @implements IListFormVersionsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormVersionsResponse=} [properties] Properties to set
                     */
                    function ListFormVersionsResponse(properties) {
                        this.versions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormVersionsResponse versions.
                     * @member {Array.<palexy.task_management.v1.IFormVersion>} versions
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @instance
                     */
                    ListFormVersionsResponse.prototype.versions = $util.emptyArray;
    
                    /**
                     * Creates a new ListFormVersionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormVersionsResponse} ListFormVersionsResponse instance
                     */
                    ListFormVersionsResponse.create = function create(properties) {
                        return new ListFormVersionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormVersionsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormVersionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsResponse} message ListFormVersionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormVersionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.versions != null && message.versions.length)
                            for (var i = 0; i < message.versions.length; ++i)
                                $root.palexy.task_management.v1.FormVersion.encode(message.versions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormVersionsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormVersionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormVersionsResponse} message ListFormVersionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormVersionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormVersionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormVersionsResponse} ListFormVersionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormVersionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormVersionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.versions && message.versions.length))
                                    message.versions = [];
                                message.versions.push($root.palexy.task_management.v1.FormVersion.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormVersionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormVersionsResponse} ListFormVersionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormVersionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormVersionsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormVersionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.versions != null && message.hasOwnProperty("versions")) {
                            if (!Array.isArray(message.versions))
                                return "versions: array expected";
                            for (var i = 0; i < message.versions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormVersion.verify(message.versions[i]);
                                if (error)
                                    return "versions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFormVersionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormVersionsResponse} ListFormVersionsResponse
                     */
                    ListFormVersionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormVersionsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormVersionsResponse();
                        if (object.versions) {
                            if (!Array.isArray(object.versions))
                                throw TypeError(".palexy.task_management.v1.ListFormVersionsResponse.versions: array expected");
                            message.versions = [];
                            for (var i = 0; i < object.versions.length; ++i) {
                                if (typeof object.versions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormVersionsResponse.versions: object expected");
                                message.versions[i] = $root.palexy.task_management.v1.FormVersion.fromObject(object.versions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormVersionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormVersionsResponse} message ListFormVersionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormVersionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.versions = [];
                        if (message.versions && message.versions.length) {
                            object.versions = [];
                            for (var j = 0; j < message.versions.length; ++j)
                                object.versions[j] = $root.palexy.task_management.v1.FormVersion.toObject(message.versions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFormVersionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormVersionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormVersionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormVersionsResponse;
                })();
    
                v1.GetFormVersionRequest = (function() {
    
                    /**
                     * Properties of a GetFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormVersionRequest
                     * @property {number|null} [formId] GetFormVersionRequest formId
                     * @property {number|null} [versionId] GetFormVersionRequest versionId
                     * @property {string|null} [languageCode] GetFormVersionRequest languageCode
                     */
    
                    /**
                     * Constructs a new GetFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormVersionRequest.
                     * @implements IGetFormVersionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormVersionRequest=} [properties] Properties to set
                     */
                    function GetFormVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormVersionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @instance
                     */
                    GetFormVersionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormVersionRequest versionId.
                     * @member {number} versionId
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @instance
                     */
                    GetFormVersionRequest.prototype.versionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormVersionRequest languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @instance
                     */
                    GetFormVersionRequest.prototype.languageCode = "";
    
                    /**
                     * Creates a new GetFormVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormVersionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormVersionRequest} GetFormVersionRequest instance
                     */
                    GetFormVersionRequest.create = function create(properties) {
                        return new GetFormVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormVersionRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormVersionRequest} message GetFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.versionId);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormVersionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormVersionRequest} message GetFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormVersionRequest} GetFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.versionId = reader.int64();
                                break;
                            case 3:
                                message.languageCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormVersionRequest} GetFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormVersionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (!$util.isInteger(message.versionId) && !(message.versionId && $util.isInteger(message.versionId.low) && $util.isInteger(message.versionId.high)))
                                return "versionId: integer|Long expected";
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormVersionRequest} GetFormVersionRequest
                     */
                    GetFormVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormVersionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormVersionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.versionId != null)
                            if ($util.Long)
                                (message.versionId = $util.Long.fromValue(object.versionId)).unsigned = false;
                            else if (typeof object.versionId === "string")
                                message.versionId = parseInt(object.versionId, 10);
                            else if (typeof object.versionId === "number")
                                message.versionId = object.versionId;
                            else if (typeof object.versionId === "object")
                                message.versionId = new $util.LongBits(object.versionId.low >>> 0, object.versionId.high >>> 0).toNumber();
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormVersionRequest} message GetFormVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.versionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.versionId = options.longs === String ? "0" : 0;
                            object.languageCode = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (typeof message.versionId === "number")
                                object.versionId = options.longs === String ? String(message.versionId) : message.versionId;
                            else
                                object.versionId = options.longs === String ? $util.Long.prototype.toString.call(message.versionId) : options.longs === Number ? new $util.LongBits(message.versionId.low >>> 0, message.versionId.high >>> 0).toNumber() : message.versionId;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormVersionRequest;
                })();
    
                v1.CreateFormVersionRequest = (function() {
    
                    /**
                     * Properties of a CreateFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormVersionRequest
                     * @property {number|null} [formId] CreateFormVersionRequest formId
                     * @property {string|null} [name] CreateFormVersionRequest name
                     * @property {string|null} [description] CreateFormVersionRequest description
                     * @property {number|null} [createdBy] CreateFormVersionRequest createdBy
                     */
    
                    /**
                     * Constructs a new CreateFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormVersionRequest.
                     * @implements ICreateFormVersionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest=} [properties] Properties to set
                     */
                    function CreateFormVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormVersionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @instance
                     */
                    CreateFormVersionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormVersionRequest name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @instance
                     */
                    CreateFormVersionRequest.prototype.name = "";
    
                    /**
                     * CreateFormVersionRequest description.
                     * @member {string} description
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @instance
                     */
                    CreateFormVersionRequest.prototype.description = "";
    
                    /**
                     * CreateFormVersionRequest createdBy.
                     * @member {number} createdBy
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @instance
                     */
                    CreateFormVersionRequest.prototype.createdBy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CreateFormVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormVersionRequest} CreateFormVersionRequest instance
                     */
                    CreateFormVersionRequest.create = function create(properties) {
                        return new CreateFormVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormVersionRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest} message CreateFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.description != null && Object.hasOwnProperty.call(message, "description"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.description);
                        if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createdBy);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormVersionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormVersionRequest} message CreateFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormVersionRequest} CreateFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.description = reader.string();
                                break;
                            case 4:
                                message.createdBy = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormVersionRequest} CreateFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormVersionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.description != null && message.hasOwnProperty("description"))
                            if (!$util.isString(message.description))
                                return "description: string expected";
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (!$util.isInteger(message.createdBy) && !(message.createdBy && $util.isInteger(message.createdBy.low) && $util.isInteger(message.createdBy.high)))
                                return "createdBy: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormVersionRequest} CreateFormVersionRequest
                     */
                    CreateFormVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormVersionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormVersionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.description != null)
                            message.description = String(object.description);
                        if (object.createdBy != null)
                            if ($util.Long)
                                (message.createdBy = $util.Long.fromValue(object.createdBy)).unsigned = false;
                            else if (typeof object.createdBy === "string")
                                message.createdBy = parseInt(object.createdBy, 10);
                            else if (typeof object.createdBy === "number")
                                message.createdBy = object.createdBy;
                            else if (typeof object.createdBy === "object")
                                message.createdBy = new $util.LongBits(object.createdBy.low >>> 0, object.createdBy.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormVersionRequest} message CreateFormVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.description = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdBy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdBy = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.description != null && message.hasOwnProperty("description"))
                            object.description = message.description;
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (typeof message.createdBy === "number")
                                object.createdBy = options.longs === String ? String(message.createdBy) : message.createdBy;
                            else
                                object.createdBy = options.longs === String ? $util.Long.prototype.toString.call(message.createdBy) : options.longs === Number ? new $util.LongBits(message.createdBy.low >>> 0, message.createdBy.high >>> 0).toNumber() : message.createdBy;
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormVersionRequest;
                })();
    
                v1.RestoreFormVersionRequest = (function() {
    
                    /**
                     * Properties of a RestoreFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IRestoreFormVersionRequest
                     * @property {number|null} [formId] RestoreFormVersionRequest formId
                     * @property {number|null} [versionId] RestoreFormVersionRequest versionId
                     * @property {number|null} [createdBy] RestoreFormVersionRequest createdBy
                     */
    
                    /**
                     * Constructs a new RestoreFormVersionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a RestoreFormVersionRequest.
                     * @implements IRestoreFormVersionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest=} [properties] Properties to set
                     */
                    function RestoreFormVersionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RestoreFormVersionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @instance
                     */
                    RestoreFormVersionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RestoreFormVersionRequest versionId.
                     * @member {number} versionId
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @instance
                     */
                    RestoreFormVersionRequest.prototype.versionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RestoreFormVersionRequest createdBy.
                     * @member {number} createdBy
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @instance
                     */
                    RestoreFormVersionRequest.prototype.createdBy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new RestoreFormVersionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.RestoreFormVersionRequest} RestoreFormVersionRequest instance
                     */
                    RestoreFormVersionRequest.create = function create(properties) {
                        return new RestoreFormVersionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RestoreFormVersionRequest message. Does not implicitly {@link palexy.task_management.v1.RestoreFormVersionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest} message RestoreFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RestoreFormVersionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.versionId != null && Object.hasOwnProperty.call(message, "versionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.versionId);
                        if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdBy);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RestoreFormVersionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.RestoreFormVersionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.IRestoreFormVersionRequest} message RestoreFormVersionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RestoreFormVersionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RestoreFormVersionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.RestoreFormVersionRequest} RestoreFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RestoreFormVersionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.RestoreFormVersionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.versionId = reader.int64();
                                break;
                            case 3:
                                message.createdBy = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RestoreFormVersionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.RestoreFormVersionRequest} RestoreFormVersionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RestoreFormVersionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RestoreFormVersionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RestoreFormVersionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (!$util.isInteger(message.versionId) && !(message.versionId && $util.isInteger(message.versionId.low) && $util.isInteger(message.versionId.high)))
                                return "versionId: integer|Long expected";
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (!$util.isInteger(message.createdBy) && !(message.createdBy && $util.isInteger(message.createdBy.low) && $util.isInteger(message.createdBy.high)))
                                return "createdBy: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a RestoreFormVersionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.RestoreFormVersionRequest} RestoreFormVersionRequest
                     */
                    RestoreFormVersionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.RestoreFormVersionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.RestoreFormVersionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.versionId != null)
                            if ($util.Long)
                                (message.versionId = $util.Long.fromValue(object.versionId)).unsigned = false;
                            else if (typeof object.versionId === "string")
                                message.versionId = parseInt(object.versionId, 10);
                            else if (typeof object.versionId === "number")
                                message.versionId = object.versionId;
                            else if (typeof object.versionId === "object")
                                message.versionId = new $util.LongBits(object.versionId.low >>> 0, object.versionId.high >>> 0).toNumber();
                        if (object.createdBy != null)
                            if ($util.Long)
                                (message.createdBy = $util.Long.fromValue(object.createdBy)).unsigned = false;
                            else if (typeof object.createdBy === "string")
                                message.createdBy = parseInt(object.createdBy, 10);
                            else if (typeof object.createdBy === "number")
                                message.createdBy = object.createdBy;
                            else if (typeof object.createdBy === "object")
                                message.createdBy = new $util.LongBits(object.createdBy.low >>> 0, object.createdBy.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RestoreFormVersionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @static
                     * @param {palexy.task_management.v1.RestoreFormVersionRequest} message RestoreFormVersionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RestoreFormVersionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.versionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.versionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdBy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdBy = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.versionId != null && message.hasOwnProperty("versionId"))
                            if (typeof message.versionId === "number")
                                object.versionId = options.longs === String ? String(message.versionId) : message.versionId;
                            else
                                object.versionId = options.longs === String ? $util.Long.prototype.toString.call(message.versionId) : options.longs === Number ? new $util.LongBits(message.versionId.low >>> 0, message.versionId.high >>> 0).toNumber() : message.versionId;
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (typeof message.createdBy === "number")
                                object.createdBy = options.longs === String ? String(message.createdBy) : message.createdBy;
                            else
                                object.createdBy = options.longs === String ? $util.Long.prototype.toString.call(message.createdBy) : options.longs === Number ? new $util.LongBits(message.createdBy.low >>> 0, message.createdBy.high >>> 0).toNumber() : message.createdBy;
                        return object;
                    };
    
                    /**
                     * Converts this RestoreFormVersionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.RestoreFormVersionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RestoreFormVersionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RestoreFormVersionRequest;
                })();
    
                v1.ListFormReportQuestionsRequest = (function() {
    
                    /**
                     * Properties of a ListFormReportQuestionsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormReportQuestionsRequest
                     * @property {number|null} [formId] ListFormReportQuestionsRequest formId
                     */
    
                    /**
                     * Constructs a new ListFormReportQuestionsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormReportQuestionsRequest.
                     * @implements IListFormReportQuestionsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest=} [properties] Properties to set
                     */
                    function ListFormReportQuestionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormReportQuestionsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @instance
                     */
                    ListFormReportQuestionsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormReportQuestionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsRequest} ListFormReportQuestionsRequest instance
                     */
                    ListFormReportQuestionsRequest.create = function create(properties) {
                        return new ListFormReportQuestionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormReportQuestionsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormReportQuestionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest} message ListFormReportQuestionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormReportQuestionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormReportQuestionsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormReportQuestionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsRequest} message ListFormReportQuestionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormReportQuestionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormReportQuestionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsRequest} ListFormReportQuestionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormReportQuestionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormReportQuestionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormReportQuestionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsRequest} ListFormReportQuestionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormReportQuestionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormReportQuestionsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormReportQuestionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormReportQuestionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsRequest} ListFormReportQuestionsRequest
                     */
                    ListFormReportQuestionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormReportQuestionsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormReportQuestionsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormReportQuestionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormReportQuestionsRequest} message ListFormReportQuestionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormReportQuestionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormReportQuestionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormReportQuestionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormReportQuestionsRequest;
                })();
    
                v1.FormReportQuestion = (function() {
    
                    /**
                     * Properties of a FormReportQuestion.
                     * @memberof palexy.task_management.v1
                     * @interface IFormReportQuestion
                     * @property {palexy.task_management.v1.IFormField|null} [field] FormReportQuestion field
                     * @property {number|null} [qOrder] FormReportQuestion qOrder
                     * @property {boolean|null} [isActive] FormReportQuestion isActive
                     */
    
                    /**
                     * Constructs a new FormReportQuestion.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormReportQuestion.
                     * @implements IFormReportQuestion
                     * @constructor
                     * @param {palexy.task_management.v1.IFormReportQuestion=} [properties] Properties to set
                     */
                    function FormReportQuestion(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormReportQuestion field.
                     * @member {palexy.task_management.v1.IFormField|null|undefined} field
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @instance
                     */
                    FormReportQuestion.prototype.field = null;
    
                    /**
                     * FormReportQuestion qOrder.
                     * @member {number} qOrder
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @instance
                     */
                    FormReportQuestion.prototype.qOrder = 0;
    
                    /**
                     * FormReportQuestion isActive.
                     * @member {boolean} isActive
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @instance
                     */
                    FormReportQuestion.prototype.isActive = false;
    
                    /**
                     * Creates a new FormReportQuestion instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {palexy.task_management.v1.IFormReportQuestion=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormReportQuestion} FormReportQuestion instance
                     */
                    FormReportQuestion.create = function create(properties) {
                        return new FormReportQuestion(properties);
                    };
    
                    /**
                     * Encodes the specified FormReportQuestion message. Does not implicitly {@link palexy.task_management.v1.FormReportQuestion.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {palexy.task_management.v1.IFormReportQuestion} message FormReportQuestion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormReportQuestion.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.field != null && Object.hasOwnProperty.call(message, "field"))
                            $root.palexy.task_management.v1.FormField.encode(message.field, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.qOrder != null && Object.hasOwnProperty.call(message, "qOrder"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.qOrder);
                        if (message.isActive != null && Object.hasOwnProperty.call(message, "isActive"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isActive);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormReportQuestion message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormReportQuestion.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {palexy.task_management.v1.IFormReportQuestion} message FormReportQuestion message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormReportQuestion.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormReportQuestion message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormReportQuestion} FormReportQuestion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormReportQuestion.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormReportQuestion();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.field = $root.palexy.task_management.v1.FormField.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.qOrder = reader.int32();
                                break;
                            case 3:
                                message.isActive = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormReportQuestion message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormReportQuestion} FormReportQuestion
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormReportQuestion.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormReportQuestion message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormReportQuestion.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.field != null && message.hasOwnProperty("field")) {
                            var error = $root.palexy.task_management.v1.FormField.verify(message.field);
                            if (error)
                                return "field." + error;
                        }
                        if (message.qOrder != null && message.hasOwnProperty("qOrder"))
                            if (!$util.isInteger(message.qOrder))
                                return "qOrder: integer expected";
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            if (typeof message.isActive !== "boolean")
                                return "isActive: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormReportQuestion message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormReportQuestion} FormReportQuestion
                     */
                    FormReportQuestion.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormReportQuestion)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormReportQuestion();
                        if (object.field != null) {
                            if (typeof object.field !== "object")
                                throw TypeError(".palexy.task_management.v1.FormReportQuestion.field: object expected");
                            message.field = $root.palexy.task_management.v1.FormField.fromObject(object.field);
                        }
                        if (object.qOrder != null)
                            message.qOrder = object.qOrder | 0;
                        if (object.isActive != null)
                            message.isActive = Boolean(object.isActive);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormReportQuestion message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @static
                     * @param {palexy.task_management.v1.FormReportQuestion} message FormReportQuestion
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormReportQuestion.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.field = null;
                            object.qOrder = 0;
                            object.isActive = false;
                        }
                        if (message.field != null && message.hasOwnProperty("field"))
                            object.field = $root.palexy.task_management.v1.FormField.toObject(message.field, options);
                        if (message.qOrder != null && message.hasOwnProperty("qOrder"))
                            object.qOrder = message.qOrder;
                        if (message.isActive != null && message.hasOwnProperty("isActive"))
                            object.isActive = message.isActive;
                        return object;
                    };
    
                    /**
                     * Converts this FormReportQuestion to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormReportQuestion
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormReportQuestion.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormReportQuestion;
                })();
    
                v1.ListFormReportQuestionsResponse = (function() {
    
                    /**
                     * Properties of a ListFormReportQuestionsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormReportQuestionsResponse
                     * @property {Array.<palexy.task_management.v1.IFormReportQuestion>|null} [questions] ListFormReportQuestionsResponse questions
                     */
    
                    /**
                     * Constructs a new ListFormReportQuestionsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormReportQuestionsResponse.
                     * @implements IListFormReportQuestionsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormReportQuestionsResponse=} [properties] Properties to set
                     */
                    function ListFormReportQuestionsResponse(properties) {
                        this.questions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormReportQuestionsResponse questions.
                     * @member {Array.<palexy.task_management.v1.IFormReportQuestion>} questions
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @instance
                     */
                    ListFormReportQuestionsResponse.prototype.questions = $util.emptyArray;
    
                    /**
                     * Creates a new ListFormReportQuestionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsResponse} ListFormReportQuestionsResponse instance
                     */
                    ListFormReportQuestionsResponse.create = function create(properties) {
                        return new ListFormReportQuestionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormReportQuestionsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormReportQuestionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsResponse} message ListFormReportQuestionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormReportQuestionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.questions != null && message.questions.length)
                            for (var i = 0; i < message.questions.length; ++i)
                                $root.palexy.task_management.v1.FormReportQuestion.encode(message.questions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormReportQuestionsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormReportQuestionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormReportQuestionsResponse} message ListFormReportQuestionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormReportQuestionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormReportQuestionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsResponse} ListFormReportQuestionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormReportQuestionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormReportQuestionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.questions && message.questions.length))
                                    message.questions = [];
                                message.questions.push($root.palexy.task_management.v1.FormReportQuestion.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormReportQuestionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsResponse} ListFormReportQuestionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormReportQuestionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormReportQuestionsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormReportQuestionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.questions != null && message.hasOwnProperty("questions")) {
                            if (!Array.isArray(message.questions))
                                return "questions: array expected";
                            for (var i = 0; i < message.questions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormReportQuestion.verify(message.questions[i]);
                                if (error)
                                    return "questions." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFormReportQuestionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormReportQuestionsResponse} ListFormReportQuestionsResponse
                     */
                    ListFormReportQuestionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormReportQuestionsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormReportQuestionsResponse();
                        if (object.questions) {
                            if (!Array.isArray(object.questions))
                                throw TypeError(".palexy.task_management.v1.ListFormReportQuestionsResponse.questions: array expected");
                            message.questions = [];
                            for (var i = 0; i < object.questions.length; ++i) {
                                if (typeof object.questions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormReportQuestionsResponse.questions: object expected");
                                message.questions[i] = $root.palexy.task_management.v1.FormReportQuestion.fromObject(object.questions[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormReportQuestionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormReportQuestionsResponse} message ListFormReportQuestionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormReportQuestionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.questions = [];
                        if (message.questions && message.questions.length) {
                            object.questions = [];
                            for (var j = 0; j < message.questions.length; ++j)
                                object.questions[j] = $root.palexy.task_management.v1.FormReportQuestion.toObject(message.questions[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFormReportQuestionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormReportQuestionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormReportQuestionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormReportQuestionsResponse;
                })();
    
                v1.CreateFormFieldRequest = (function() {
    
                    /**
                     * Properties of a CreateFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormFieldRequest
                     * @property {number|null} [formId] CreateFormFieldRequest formId
                     * @property {palexy.task_management.v1.IFormField|null} [formField] CreateFormFieldRequest formField
                     * @property {number|null} [fieldIndex] CreateFormFieldRequest fieldIndex
                     */
    
                    /**
                     * Constructs a new CreateFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormFieldRequest.
                     * @implements ICreateFormFieldRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest=} [properties] Properties to set
                     */
                    function CreateFormFieldRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormFieldRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @instance
                     */
                    CreateFormFieldRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormFieldRequest formField.
                     * @member {palexy.task_management.v1.IFormField|null|undefined} formField
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @instance
                     */
                    CreateFormFieldRequest.prototype.formField = null;
    
                    /**
                     * CreateFormFieldRequest fieldIndex.
                     * @member {number} fieldIndex
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @instance
                     */
                    CreateFormFieldRequest.prototype.fieldIndex = 0;
    
                    /**
                     * Creates a new CreateFormFieldRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormFieldRequest} CreateFormFieldRequest instance
                     */
                    CreateFormFieldRequest.create = function create(properties) {
                        return new CreateFormFieldRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormFieldRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormFieldRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest} message CreateFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormFieldRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formField != null && Object.hasOwnProperty.call(message, "formField"))
                            $root.palexy.task_management.v1.FormField.encode(message.formField, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.fieldIndex != null && Object.hasOwnProperty.call(message, "fieldIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.fieldIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormFieldRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormFieldRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormFieldRequest} message CreateFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormFieldRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormFieldRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormFieldRequest} CreateFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormFieldRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormFieldRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formField = $root.palexy.task_management.v1.FormField.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.fieldIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormFieldRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormFieldRequest} CreateFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormFieldRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormFieldRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormFieldRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formField != null && message.hasOwnProperty("formField")) {
                            var error = $root.palexy.task_management.v1.FormField.verify(message.formField);
                            if (error)
                                return "formField." + error;
                        }
                        if (message.fieldIndex != null && message.hasOwnProperty("fieldIndex"))
                            if (!$util.isInteger(message.fieldIndex))
                                return "fieldIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormFieldRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormFieldRequest} CreateFormFieldRequest
                     */
                    CreateFormFieldRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormFieldRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormFieldRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formField != null) {
                            if (typeof object.formField !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormFieldRequest.formField: object expected");
                            message.formField = $root.palexy.task_management.v1.FormField.fromObject(object.formField);
                        }
                        if (object.fieldIndex != null)
                            message.fieldIndex = object.fieldIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormFieldRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormFieldRequest} message CreateFormFieldRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormFieldRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.formField = null;
                            object.fieldIndex = 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formField != null && message.hasOwnProperty("formField"))
                            object.formField = $root.palexy.task_management.v1.FormField.toObject(message.formField, options);
                        if (message.fieldIndex != null && message.hasOwnProperty("fieldIndex"))
                            object.fieldIndex = message.fieldIndex;
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormFieldRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormFieldRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormFieldRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormFieldRequest;
                })();
    
                v1.CreateFormBlockRequest = (function() {
    
                    /**
                     * Properties of a CreateFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormBlockRequest
                     * @property {number|null} [formId] CreateFormBlockRequest formId
                     * @property {palexy.task_management.v1.IBlock|null} [block] CreateFormBlockRequest block
                     * @property {number|null} [blockIndex] CreateFormBlockRequest blockIndex
                     */
    
                    /**
                     * Constructs a new CreateFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormBlockRequest.
                     * @implements ICreateFormBlockRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest=} [properties] Properties to set
                     */
                    function CreateFormBlockRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormBlockRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @instance
                     */
                    CreateFormBlockRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormBlockRequest block.
                     * @member {palexy.task_management.v1.IBlock|null|undefined} block
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @instance
                     */
                    CreateFormBlockRequest.prototype.block = null;
    
                    /**
                     * CreateFormBlockRequest blockIndex.
                     * @member {number} blockIndex
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @instance
                     */
                    CreateFormBlockRequest.prototype.blockIndex = 0;
    
                    /**
                     * Creates a new CreateFormBlockRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormBlockRequest} CreateFormBlockRequest instance
                     */
                    CreateFormBlockRequest.create = function create(properties) {
                        return new CreateFormBlockRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormBlockRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormBlockRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest} message CreateFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormBlockRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.block != null && Object.hasOwnProperty.call(message, "block"))
                            $root.palexy.task_management.v1.Block.encode(message.block, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.blockIndex != null && Object.hasOwnProperty.call(message, "blockIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.blockIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormBlockRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormBlockRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormBlockRequest} message CreateFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormBlockRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormBlockRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormBlockRequest} CreateFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormBlockRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormBlockRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.block = $root.palexy.task_management.v1.Block.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.blockIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormBlockRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormBlockRequest} CreateFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormBlockRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormBlockRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormBlockRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.block != null && message.hasOwnProperty("block")) {
                            var error = $root.palexy.task_management.v1.Block.verify(message.block);
                            if (error)
                                return "block." + error;
                        }
                        if (message.blockIndex != null && message.hasOwnProperty("blockIndex"))
                            if (!$util.isInteger(message.blockIndex))
                                return "blockIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormBlockRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormBlockRequest} CreateFormBlockRequest
                     */
                    CreateFormBlockRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormBlockRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormBlockRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.block != null) {
                            if (typeof object.block !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormBlockRequest.block: object expected");
                            message.block = $root.palexy.task_management.v1.Block.fromObject(object.block);
                        }
                        if (object.blockIndex != null)
                            message.blockIndex = object.blockIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormBlockRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormBlockRequest} message CreateFormBlockRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormBlockRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.block = null;
                            object.blockIndex = 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.block != null && message.hasOwnProperty("block"))
                            object.block = $root.palexy.task_management.v1.Block.toObject(message.block, options);
                        if (message.blockIndex != null && message.hasOwnProperty("blockIndex"))
                            object.blockIndex = message.blockIndex;
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormBlockRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormBlockRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormBlockRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormBlockRequest;
                })();
    
                v1.ListFormFieldsRequest = (function() {
    
                    /**
                     * Properties of a ListFormFieldsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormFieldsRequest
                     * @property {number|null} [formId] ListFormFieldsRequest formId
                     * @property {number|null} [pageSize] ListFormFieldsRequest pageSize
                     * @property {string|null} [pageToken] ListFormFieldsRequest pageToken
                     * @property {number|null} [formVersionId] ListFormFieldsRequest formVersionId
                     */
    
                    /**
                     * Constructs a new ListFormFieldsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormFieldsRequest.
                     * @implements IListFormFieldsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormFieldsRequest=} [properties] Properties to set
                     */
                    function ListFormFieldsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormFieldsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @instance
                     */
                    ListFormFieldsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormFieldsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @instance
                     */
                    ListFormFieldsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormFieldsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @instance
                     */
                    ListFormFieldsRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormFieldsRequest formVersionId.
                     * @member {number} formVersionId
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @instance
                     */
                    ListFormFieldsRequest.prototype.formVersionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormFieldsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormFieldsRequest} ListFormFieldsRequest instance
                     */
                    ListFormFieldsRequest.create = function create(properties) {
                        return new ListFormFieldsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormFieldsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormFieldsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsRequest} message ListFormFieldsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormFieldsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        if (message.formVersionId != null && Object.hasOwnProperty.call(message, "formVersionId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.formVersionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormFieldsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormFieldsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsRequest} message ListFormFieldsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormFieldsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormFieldsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormFieldsRequest} ListFormFieldsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormFieldsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormFieldsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            case 4:
                                message.formVersionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormFieldsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormFieldsRequest} ListFormFieldsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormFieldsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormFieldsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormFieldsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.formVersionId != null && message.hasOwnProperty("formVersionId"))
                            if (!$util.isInteger(message.formVersionId) && !(message.formVersionId && $util.isInteger(message.formVersionId.low) && $util.isInteger(message.formVersionId.high)))
                                return "formVersionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormFieldsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormFieldsRequest} ListFormFieldsRequest
                     */
                    ListFormFieldsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormFieldsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormFieldsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.formVersionId != null)
                            if ($util.Long)
                                (message.formVersionId = $util.Long.fromValue(object.formVersionId)).unsigned = false;
                            else if (typeof object.formVersionId === "string")
                                message.formVersionId = parseInt(object.formVersionId, 10);
                            else if (typeof object.formVersionId === "number")
                                message.formVersionId = object.formVersionId;
                            else if (typeof object.formVersionId === "object")
                                message.formVersionId = new $util.LongBits(object.formVersionId.low >>> 0, object.formVersionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormFieldsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormFieldsRequest} message ListFormFieldsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormFieldsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formVersionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formVersionId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.formVersionId != null && message.hasOwnProperty("formVersionId"))
                            if (typeof message.formVersionId === "number")
                                object.formVersionId = options.longs === String ? String(message.formVersionId) : message.formVersionId;
                            else
                                object.formVersionId = options.longs === String ? $util.Long.prototype.toString.call(message.formVersionId) : options.longs === Number ? new $util.LongBits(message.formVersionId.low >>> 0, message.formVersionId.high >>> 0).toNumber() : message.formVersionId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormFieldsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormFieldsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormFieldsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormFieldsRequest;
                })();
    
                v1.ListFormFieldsResponse = (function() {
    
                    /**
                     * Properties of a ListFormFieldsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormFieldsResponse
                     * @property {Array.<palexy.task_management.v1.IFormField>|null} [formFields] ListFormFieldsResponse formFields
                     * @property {number|null} [totalElements] ListFormFieldsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormFieldsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormFieldsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormFieldsResponse.
                     * @implements IListFormFieldsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormFieldsResponse=} [properties] Properties to set
                     */
                    function ListFormFieldsResponse(properties) {
                        this.formFields = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormFieldsResponse formFields.
                     * @member {Array.<palexy.task_management.v1.IFormField>} formFields
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @instance
                     */
                    ListFormFieldsResponse.prototype.formFields = $util.emptyArray;
    
                    /**
                     * ListFormFieldsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @instance
                     */
                    ListFormFieldsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormFieldsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @instance
                     */
                    ListFormFieldsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormFieldsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormFieldsResponse} ListFormFieldsResponse instance
                     */
                    ListFormFieldsResponse.create = function create(properties) {
                        return new ListFormFieldsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormFieldsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormFieldsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsResponse} message ListFormFieldsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormFieldsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formFields != null && message.formFields.length)
                            for (var i = 0; i < message.formFields.length; ++i)
                                $root.palexy.task_management.v1.FormField.encode(message.formFields[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormFieldsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormFieldsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormFieldsResponse} message ListFormFieldsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormFieldsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormFieldsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormFieldsResponse} ListFormFieldsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormFieldsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormFieldsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.formFields && message.formFields.length))
                                    message.formFields = [];
                                message.formFields.push($root.palexy.task_management.v1.FormField.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormFieldsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormFieldsResponse} ListFormFieldsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormFieldsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormFieldsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormFieldsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formFields != null && message.hasOwnProperty("formFields")) {
                            if (!Array.isArray(message.formFields))
                                return "formFields: array expected";
                            for (var i = 0; i < message.formFields.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormField.verify(message.formFields[i]);
                                if (error)
                                    return "formFields." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormFieldsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormFieldsResponse} ListFormFieldsResponse
                     */
                    ListFormFieldsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormFieldsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormFieldsResponse();
                        if (object.formFields) {
                            if (!Array.isArray(object.formFields))
                                throw TypeError(".palexy.task_management.v1.ListFormFieldsResponse.formFields: array expected");
                            message.formFields = [];
                            for (var i = 0; i < object.formFields.length; ++i) {
                                if (typeof object.formFields[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormFieldsResponse.formFields: object expected");
                                message.formFields[i] = $root.palexy.task_management.v1.FormField.fromObject(object.formFields[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormFieldsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormFieldsResponse} message ListFormFieldsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormFieldsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.formFields = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.formFields && message.formFields.length) {
                            object.formFields = [];
                            for (var j = 0; j < message.formFields.length; ++j)
                                object.formFields[j] = $root.palexy.task_management.v1.FormField.toObject(message.formFields[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormFieldsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormFieldsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormFieldsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormFieldsResponse;
                })();
    
                v1.GetFormFieldRequest = (function() {
    
                    /**
                     * Properties of a GetFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormFieldRequest
                     * @property {number|null} [formId] GetFormFieldRequest formId
                     * @property {number|null} [formFieldId] GetFormFieldRequest formFieldId
                     */
    
                    /**
                     * Constructs a new GetFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormFieldRequest.
                     * @implements IGetFormFieldRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormFieldRequest=} [properties] Properties to set
                     */
                    function GetFormFieldRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormFieldRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @instance
                     */
                    GetFormFieldRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormFieldRequest formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @instance
                     */
                    GetFormFieldRequest.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetFormFieldRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormFieldRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormFieldRequest} GetFormFieldRequest instance
                     */
                    GetFormFieldRequest.create = function create(properties) {
                        return new GetFormFieldRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormFieldRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormFieldRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormFieldRequest} message GetFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormFieldRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormFieldRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormFieldRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormFieldRequest} message GetFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormFieldRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormFieldRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormFieldRequest} GetFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormFieldRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormFieldRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formFieldId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormFieldRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormFieldRequest} GetFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormFieldRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormFieldRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormFieldRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormFieldRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormFieldRequest} GetFormFieldRequest
                     */
                    GetFormFieldRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormFieldRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormFieldRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormFieldRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormFieldRequest} message GetFormFieldRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormFieldRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormFieldRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormFieldRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormFieldRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormFieldRequest;
                })();
    
                v1.UpdateFormFieldRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormFieldRequest
                     * @property {number|null} [formId] UpdateFormFieldRequest formId
                     * @property {number|null} [formFieldId] UpdateFormFieldRequest formFieldId
                     * @property {palexy.task_management.v1.IFormField|null} [formField] UpdateFormFieldRequest formField
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormFieldRequest updateMask
                     * @property {google.protobuf.IInt32Value|null} [fieldIndex] UpdateFormFieldRequest fieldIndex
                     */
    
                    /**
                     * Constructs a new UpdateFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormFieldRequest.
                     * @implements IUpdateFormFieldRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest=} [properties] Properties to set
                     */
                    function UpdateFormFieldRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormFieldRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     */
                    UpdateFormFieldRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormFieldRequest formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     */
                    UpdateFormFieldRequest.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormFieldRequest formField.
                     * @member {palexy.task_management.v1.IFormField|null|undefined} formField
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     */
                    UpdateFormFieldRequest.prototype.formField = null;
    
                    /**
                     * UpdateFormFieldRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     */
                    UpdateFormFieldRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateFormFieldRequest fieldIndex.
                     * @member {google.protobuf.IInt32Value|null|undefined} fieldIndex
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     */
                    UpdateFormFieldRequest.prototype.fieldIndex = null;
    
                    /**
                     * Creates a new UpdateFormFieldRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormFieldRequest} UpdateFormFieldRequest instance
                     */
                    UpdateFormFieldRequest.create = function create(properties) {
                        return new UpdateFormFieldRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormFieldRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormFieldRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest} message UpdateFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormFieldRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                        if (message.formField != null && Object.hasOwnProperty.call(message, "formField"))
                            $root.palexy.task_management.v1.FormField.encode(message.formField, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.fieldIndex != null && Object.hasOwnProperty.call(message, "fieldIndex"))
                            $root.google.protobuf.Int32Value.encode(message.fieldIndex, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormFieldRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormFieldRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormFieldRequest} message UpdateFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormFieldRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormFieldRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormFieldRequest} UpdateFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormFieldRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormFieldRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formFieldId = reader.int64();
                                break;
                            case 3:
                                message.formField = $root.palexy.task_management.v1.FormField.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.fieldIndex = $root.google.protobuf.Int32Value.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormFieldRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormFieldRequest} UpdateFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormFieldRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormFieldRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormFieldRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        if (message.formField != null && message.hasOwnProperty("formField")) {
                            var error = $root.palexy.task_management.v1.FormField.verify(message.formField);
                            if (error)
                                return "formField." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.fieldIndex != null && message.hasOwnProperty("fieldIndex")) {
                            var error = $root.google.protobuf.Int32Value.verify(message.fieldIndex);
                            if (error)
                                return "fieldIndex." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormFieldRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormFieldRequest} UpdateFormFieldRequest
                     */
                    UpdateFormFieldRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormFieldRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormFieldRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        if (object.formField != null) {
                            if (typeof object.formField !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormFieldRequest.formField: object expected");
                            message.formField = $root.palexy.task_management.v1.FormField.fromObject(object.formField);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormFieldRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.fieldIndex != null) {
                            if (typeof object.fieldIndex !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormFieldRequest.fieldIndex: object expected");
                            message.fieldIndex = $root.google.protobuf.Int32Value.fromObject(object.fieldIndex);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormFieldRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormFieldRequest} message UpdateFormFieldRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormFieldRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                            object.formField = null;
                            object.updateMask = null;
                            object.fieldIndex = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        if (message.formField != null && message.hasOwnProperty("formField"))
                            object.formField = $root.palexy.task_management.v1.FormField.toObject(message.formField, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.fieldIndex != null && message.hasOwnProperty("fieldIndex"))
                            object.fieldIndex = $root.google.protobuf.Int32Value.toObject(message.fieldIndex, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormFieldRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormFieldRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormFieldRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormFieldRequest;
                })();
    
                v1.UpdateFormBlockRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormBlockRequest
                     * @property {number|null} [formId] UpdateFormBlockRequest formId
                     * @property {number|null} [blockId] UpdateFormBlockRequest blockId
                     * @property {palexy.task_management.v1.IBlock|null} [block] UpdateFormBlockRequest block
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormBlockRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormBlockRequest.
                     * @implements IUpdateFormBlockRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest=} [properties] Properties to set
                     */
                    function UpdateFormBlockRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormBlockRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @instance
                     */
                    UpdateFormBlockRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormBlockRequest blockId.
                     * @member {number} blockId
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @instance
                     */
                    UpdateFormBlockRequest.prototype.blockId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormBlockRequest block.
                     * @member {palexy.task_management.v1.IBlock|null|undefined} block
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @instance
                     */
                    UpdateFormBlockRequest.prototype.block = null;
    
                    /**
                     * UpdateFormBlockRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @instance
                     */
                    UpdateFormBlockRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateFormBlockRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormBlockRequest} UpdateFormBlockRequest instance
                     */
                    UpdateFormBlockRequest.create = function create(properties) {
                        return new UpdateFormBlockRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormBlockRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormBlockRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest} message UpdateFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormBlockRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.blockId != null && Object.hasOwnProperty.call(message, "blockId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.blockId);
                        if (message.block != null && Object.hasOwnProperty.call(message, "block"))
                            $root.palexy.task_management.v1.Block.encode(message.block, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormBlockRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormBlockRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormBlockRequest} message UpdateFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormBlockRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormBlockRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormBlockRequest} UpdateFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormBlockRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormBlockRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.blockId = reader.int64();
                                break;
                            case 3:
                                message.block = $root.palexy.task_management.v1.Block.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormBlockRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormBlockRequest} UpdateFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormBlockRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormBlockRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormBlockRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (!$util.isInteger(message.blockId) && !(message.blockId && $util.isInteger(message.blockId.low) && $util.isInteger(message.blockId.high)))
                                return "blockId: integer|Long expected";
                        if (message.block != null && message.hasOwnProperty("block")) {
                            var error = $root.palexy.task_management.v1.Block.verify(message.block);
                            if (error)
                                return "block." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormBlockRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormBlockRequest} UpdateFormBlockRequest
                     */
                    UpdateFormBlockRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormBlockRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormBlockRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.blockId != null)
                            if ($util.Long)
                                (message.blockId = $util.Long.fromValue(object.blockId)).unsigned = false;
                            else if (typeof object.blockId === "string")
                                message.blockId = parseInt(object.blockId, 10);
                            else if (typeof object.blockId === "number")
                                message.blockId = object.blockId;
                            else if (typeof object.blockId === "object")
                                message.blockId = new $util.LongBits(object.blockId.low >>> 0, object.blockId.high >>> 0).toNumber();
                        if (object.block != null) {
                            if (typeof object.block !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormBlockRequest.block: object expected");
                            message.block = $root.palexy.task_management.v1.Block.fromObject(object.block);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormBlockRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormBlockRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormBlockRequest} message UpdateFormBlockRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormBlockRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.blockId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.blockId = options.longs === String ? "0" : 0;
                            object.block = null;
                            object.updateMask = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (typeof message.blockId === "number")
                                object.blockId = options.longs === String ? String(message.blockId) : message.blockId;
                            else
                                object.blockId = options.longs === String ? $util.Long.prototype.toString.call(message.blockId) : options.longs === Number ? new $util.LongBits(message.blockId.low >>> 0, message.blockId.high >>> 0).toNumber() : message.blockId;
                        if (message.block != null && message.hasOwnProperty("block"))
                            object.block = $root.palexy.task_management.v1.Block.toObject(message.block, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormBlockRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormBlockRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormBlockRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormBlockRequest;
                })();
    
                v1.DeleteFormBlockRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormBlockRequest
                     * @property {number|null} [formId] DeleteFormBlockRequest formId
                     * @property {number|null} [blockId] DeleteFormBlockRequest blockId
                     */
    
                    /**
                     * Constructs a new DeleteFormBlockRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormBlockRequest.
                     * @implements IDeleteFormBlockRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest=} [properties] Properties to set
                     */
                    function DeleteFormBlockRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormBlockRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @instance
                     */
                    DeleteFormBlockRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormBlockRequest blockId.
                     * @member {number} blockId
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @instance
                     */
                    DeleteFormBlockRequest.prototype.blockId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormBlockRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormBlockRequest} DeleteFormBlockRequest instance
                     */
                    DeleteFormBlockRequest.create = function create(properties) {
                        return new DeleteFormBlockRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormBlockRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormBlockRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest} message DeleteFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormBlockRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.blockId != null && Object.hasOwnProperty.call(message, "blockId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.blockId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormBlockRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormBlockRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormBlockRequest} message DeleteFormBlockRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormBlockRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormBlockRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormBlockRequest} DeleteFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormBlockRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormBlockRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.blockId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormBlockRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormBlockRequest} DeleteFormBlockRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormBlockRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormBlockRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormBlockRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (!$util.isInteger(message.blockId) && !(message.blockId && $util.isInteger(message.blockId.low) && $util.isInteger(message.blockId.high)))
                                return "blockId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormBlockRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormBlockRequest} DeleteFormBlockRequest
                     */
                    DeleteFormBlockRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormBlockRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormBlockRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.blockId != null)
                            if ($util.Long)
                                (message.blockId = $util.Long.fromValue(object.blockId)).unsigned = false;
                            else if (typeof object.blockId === "string")
                                message.blockId = parseInt(object.blockId, 10);
                            else if (typeof object.blockId === "number")
                                message.blockId = object.blockId;
                            else if (typeof object.blockId === "object")
                                message.blockId = new $util.LongBits(object.blockId.low >>> 0, object.blockId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormBlockRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormBlockRequest} message DeleteFormBlockRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormBlockRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.blockId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.blockId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.blockId != null && message.hasOwnProperty("blockId"))
                            if (typeof message.blockId === "number")
                                object.blockId = options.longs === String ? String(message.blockId) : message.blockId;
                            else
                                object.blockId = options.longs === String ? $util.Long.prototype.toString.call(message.blockId) : options.longs === Number ? new $util.LongBits(message.blockId.low >>> 0, message.blockId.high >>> 0).toNumber() : message.blockId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormBlockRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormBlockRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormBlockRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormBlockRequest;
                })();
    
                v1.DeleteFormFieldRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormFieldRequest
                     * @property {number|null} [formId] DeleteFormFieldRequest formId
                     * @property {number|null} [formFieldId] DeleteFormFieldRequest formFieldId
                     */
    
                    /**
                     * Constructs a new DeleteFormFieldRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormFieldRequest.
                     * @implements IDeleteFormFieldRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest=} [properties] Properties to set
                     */
                    function DeleteFormFieldRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormFieldRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @instance
                     */
                    DeleteFormFieldRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormFieldRequest formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @instance
                     */
                    DeleteFormFieldRequest.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormFieldRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormFieldRequest} DeleteFormFieldRequest instance
                     */
                    DeleteFormFieldRequest.create = function create(properties) {
                        return new DeleteFormFieldRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormFieldRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormFieldRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest} message DeleteFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormFieldRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormFieldRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormFieldRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormFieldRequest} message DeleteFormFieldRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormFieldRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormFieldRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormFieldRequest} DeleteFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormFieldRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormFieldRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formFieldId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormFieldRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormFieldRequest} DeleteFormFieldRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormFieldRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormFieldRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormFieldRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormFieldRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormFieldRequest} DeleteFormFieldRequest
                     */
                    DeleteFormFieldRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormFieldRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormFieldRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormFieldRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormFieldRequest} message DeleteFormFieldRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormFieldRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormFieldRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormFieldRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormFieldRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormFieldRequest;
                })();
    
                v1.FormLanguage = (function() {
    
                    /**
                     * Properties of a FormLanguage.
                     * @memberof palexy.task_management.v1
                     * @interface IFormLanguage
                     * @property {number|null} [id] FormLanguage id
                     * @property {string|null} [languageCode] FormLanguage languageCode
                     * @property {string|null} [languageName] FormLanguage languageName
                     * @property {boolean|null} [isVisibleToRespondents] FormLanguage isVisibleToRespondents
                     */
    
                    /**
                     * Constructs a new FormLanguage.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormLanguage.
                     * @implements IFormLanguage
                     * @constructor
                     * @param {palexy.task_management.v1.IFormLanguage=} [properties] Properties to set
                     */
                    function FormLanguage(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormLanguage id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @instance
                     */
                    FormLanguage.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormLanguage languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @instance
                     */
                    FormLanguage.prototype.languageCode = "";
    
                    /**
                     * FormLanguage languageName.
                     * @member {string} languageName
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @instance
                     */
                    FormLanguage.prototype.languageName = "";
    
                    /**
                     * FormLanguage isVisibleToRespondents.
                     * @member {boolean} isVisibleToRespondents
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @instance
                     */
                    FormLanguage.prototype.isVisibleToRespondents = false;
    
                    /**
                     * Creates a new FormLanguage instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {palexy.task_management.v1.IFormLanguage=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormLanguage} FormLanguage instance
                     */
                    FormLanguage.create = function create(properties) {
                        return new FormLanguage(properties);
                    };
    
                    /**
                     * Encodes the specified FormLanguage message. Does not implicitly {@link palexy.task_management.v1.FormLanguage.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {palexy.task_management.v1.IFormLanguage} message FormLanguage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormLanguage.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.languageCode);
                        if (message.languageName != null && Object.hasOwnProperty.call(message, "languageName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageName);
                        if (message.isVisibleToRespondents != null && Object.hasOwnProperty.call(message, "isVisibleToRespondents"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.isVisibleToRespondents);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormLanguage message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormLanguage.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {palexy.task_management.v1.IFormLanguage} message FormLanguage message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormLanguage.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormLanguage message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormLanguage} FormLanguage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormLanguage.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormLanguage();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.languageCode = reader.string();
                                break;
                            case 3:
                                message.languageName = reader.string();
                                break;
                            case 4:
                                message.isVisibleToRespondents = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormLanguage message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormLanguage} FormLanguage
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormLanguage.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormLanguage message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormLanguage.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            if (!$util.isString(message.languageName))
                                return "languageName: string expected";
                        if (message.isVisibleToRespondents != null && message.hasOwnProperty("isVisibleToRespondents"))
                            if (typeof message.isVisibleToRespondents !== "boolean")
                                return "isVisibleToRespondents: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormLanguage message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormLanguage} FormLanguage
                     */
                    FormLanguage.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormLanguage)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormLanguage();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        if (object.languageName != null)
                            message.languageName = String(object.languageName);
                        if (object.isVisibleToRespondents != null)
                            message.isVisibleToRespondents = Boolean(object.isVisibleToRespondents);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormLanguage message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @static
                     * @param {palexy.task_management.v1.FormLanguage} message FormLanguage
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormLanguage.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.languageCode = "";
                            object.languageName = "";
                            object.isVisibleToRespondents = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            object.languageName = message.languageName;
                        if (message.isVisibleToRespondents != null && message.hasOwnProperty("isVisibleToRespondents"))
                            object.isVisibleToRespondents = message.isVisibleToRespondents;
                        return object;
                    };
    
                    /**
                     * Converts this FormLanguage to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormLanguage
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormLanguage.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormLanguage;
                })();
    
                v1.FormTranslation = (function() {
    
                    /**
                     * Properties of a FormTranslation.
                     * @memberof palexy.task_management.v1
                     * @interface IFormTranslation
                     * @property {number|null} [id] FormTranslation id
                     * @property {number|null} [formId] FormTranslation formId
                     * @property {string|null} [languageCode] FormTranslation languageCode
                     * @property {string|null} [languageName] FormTranslation languageName
                     * @property {boolean|null} [isVisibleToRespondents] FormTranslation isVisibleToRespondents
                     * @property {number|null} [totalUnitCount] FormTranslation totalUnitCount
                     * @property {number|null} [translatedUnitCount] FormTranslation translatedUnitCount
                     * @property {palexy.task_management.v1.FormTranslation.Status|null} [status] FormTranslation status
                     * @property {number|null} [outdatedUnitCount] FormTranslation outdatedUnitCount
                     */
    
                    /**
                     * Constructs a new FormTranslation.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormTranslation.
                     * @implements IFormTranslation
                     * @constructor
                     * @param {palexy.task_management.v1.IFormTranslation=} [properties] Properties to set
                     */
                    function FormTranslation(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormTranslation id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormTranslation formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormTranslation languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.languageCode = "";
    
                    /**
                     * FormTranslation languageName.
                     * @member {string} languageName
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.languageName = "";
    
                    /**
                     * FormTranslation isVisibleToRespondents.
                     * @member {boolean} isVisibleToRespondents
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.isVisibleToRespondents = false;
    
                    /**
                     * FormTranslation totalUnitCount.
                     * @member {number} totalUnitCount
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.totalUnitCount = 0;
    
                    /**
                     * FormTranslation translatedUnitCount.
                     * @member {number} translatedUnitCount
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.translatedUnitCount = 0;
    
                    /**
                     * FormTranslation status.
                     * @member {palexy.task_management.v1.FormTranslation.Status} status
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.status = 0;
    
                    /**
                     * FormTranslation outdatedUnitCount.
                     * @member {number} outdatedUnitCount
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     */
                    FormTranslation.prototype.outdatedUnitCount = 0;
    
                    /**
                     * Creates a new FormTranslation instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslation=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormTranslation} FormTranslation instance
                     */
                    FormTranslation.create = function create(properties) {
                        return new FormTranslation(properties);
                    };
    
                    /**
                     * Encodes the specified FormTranslation message. Does not implicitly {@link palexy.task_management.v1.FormTranslation.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslation} message FormTranslation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTranslation.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageCode);
                        if (message.languageName != null && Object.hasOwnProperty.call(message, "languageName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.languageName);
                        if (message.isVisibleToRespondents != null && Object.hasOwnProperty.call(message, "isVisibleToRespondents"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isVisibleToRespondents);
                        if (message.totalUnitCount != null && Object.hasOwnProperty.call(message, "totalUnitCount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.totalUnitCount);
                        if (message.translatedUnitCount != null && Object.hasOwnProperty.call(message, "translatedUnitCount"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.translatedUnitCount);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
                        if (message.outdatedUnitCount != null && Object.hasOwnProperty.call(message, "outdatedUnitCount"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.outdatedUnitCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormTranslation message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTranslation.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslation} message FormTranslation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTranslation.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormTranslation message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormTranslation} FormTranslation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTranslation.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTranslation();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.languageCode = reader.string();
                                break;
                            case 4:
                                message.languageName = reader.string();
                                break;
                            case 5:
                                message.isVisibleToRespondents = reader.bool();
                                break;
                            case 6:
                                message.totalUnitCount = reader.int32();
                                break;
                            case 7:
                                message.translatedUnitCount = reader.int32();
                                break;
                            case 8:
                                message.status = reader.int32();
                                break;
                            case 9:
                                message.outdatedUnitCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormTranslation message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormTranslation} FormTranslation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTranslation.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormTranslation message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormTranslation.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            if (!$util.isString(message.languageName))
                                return "languageName: string expected";
                        if (message.isVisibleToRespondents != null && message.hasOwnProperty("isVisibleToRespondents"))
                            if (typeof message.isVisibleToRespondents !== "boolean")
                                return "isVisibleToRespondents: boolean expected";
                        if (message.totalUnitCount != null && message.hasOwnProperty("totalUnitCount"))
                            if (!$util.isInteger(message.totalUnitCount))
                                return "totalUnitCount: integer expected";
                        if (message.translatedUnitCount != null && message.hasOwnProperty("translatedUnitCount"))
                            if (!$util.isInteger(message.translatedUnitCount))
                                return "translatedUnitCount: integer expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.outdatedUnitCount != null && message.hasOwnProperty("outdatedUnitCount"))
                            if (!$util.isInteger(message.outdatedUnitCount))
                                return "outdatedUnitCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormTranslation message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormTranslation} FormTranslation
                     */
                    FormTranslation.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormTranslation)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormTranslation();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        if (object.languageName != null)
                            message.languageName = String(object.languageName);
                        if (object.isVisibleToRespondents != null)
                            message.isVisibleToRespondents = Boolean(object.isVisibleToRespondents);
                        if (object.totalUnitCount != null)
                            message.totalUnitCount = object.totalUnitCount | 0;
                        if (object.translatedUnitCount != null)
                            message.translatedUnitCount = object.translatedUnitCount | 0;
                        switch (object.status) {
                        case "STATUS_UNSPECIFIED":
                        case 0:
                            message.status = 0;
                            break;
                        case "NOT_TRANSLATED":
                        case 1:
                            message.status = 1;
                            break;
                        case "IN_PROGRESS":
                        case 2:
                            message.status = 2;
                            break;
                        case "COMPLETED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.outdatedUnitCount != null)
                            message.outdatedUnitCount = object.outdatedUnitCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormTranslation message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @static
                     * @param {palexy.task_management.v1.FormTranslation} message FormTranslation
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormTranslation.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.languageCode = "";
                            object.languageName = "";
                            object.isVisibleToRespondents = false;
                            object.totalUnitCount = 0;
                            object.translatedUnitCount = 0;
                            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                            object.outdatedUnitCount = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            object.languageName = message.languageName;
                        if (message.isVisibleToRespondents != null && message.hasOwnProperty("isVisibleToRespondents"))
                            object.isVisibleToRespondents = message.isVisibleToRespondents;
                        if (message.totalUnitCount != null && message.hasOwnProperty("totalUnitCount"))
                            object.totalUnitCount = message.totalUnitCount;
                        if (message.translatedUnitCount != null && message.hasOwnProperty("translatedUnitCount"))
                            object.translatedUnitCount = message.translatedUnitCount;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.task_management.v1.FormTranslation.Status[message.status] : message.status;
                        if (message.outdatedUnitCount != null && message.hasOwnProperty("outdatedUnitCount"))
                            object.outdatedUnitCount = message.outdatedUnitCount;
                        return object;
                    };
    
                    /**
                     * Converts this FormTranslation to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormTranslation
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormTranslation.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Status enum.
                     * @name palexy.task_management.v1.FormTranslation.Status
                     * @enum {number}
                     * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
                     * @property {number} NOT_TRANSLATED=1 NOT_TRANSLATED value
                     * @property {number} IN_PROGRESS=2 IN_PROGRESS value
                     * @property {number} COMPLETED=3 COMPLETED value
                     */
                    FormTranslation.Status = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_TRANSLATED"] = 1;
                        values[valuesById[2] = "IN_PROGRESS"] = 2;
                        values[valuesById[3] = "COMPLETED"] = 3;
                        return values;
                    })();
    
                    return FormTranslation;
                })();
    
                v1.FormTranslationItem = (function() {
    
                    /**
                     * Properties of a FormTranslationItem.
                     * @memberof palexy.task_management.v1
                     * @interface IFormTranslationItem
                     * @property {number|null} [id] FormTranslationItem id
                     * @property {number|null} [formTranslationId] FormTranslationItem formTranslationId
                     * @property {string|null} [translationKey] FormTranslationItem translationKey
                     * @property {string|null} [text] FormTranslationItem text
                     * @property {string|null} [translatedText] FormTranslationItem translatedText
                     * @property {string|null} [targetPath] FormTranslationItem targetPath
                     * @property {string|null} [translatedFromText] FormTranslationItem translatedFromText
                     * @property {palexy.task_management.v1.FormTranslationItem.Status|null} [status] FormTranslationItem status
                     * @property {string|null} [targetLabel] FormTranslationItem targetLabel
                     */
    
                    /**
                     * Constructs a new FormTranslationItem.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormTranslationItem.
                     * @implements IFormTranslationItem
                     * @constructor
                     * @param {palexy.task_management.v1.IFormTranslationItem=} [properties] Properties to set
                     */
                    function FormTranslationItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormTranslationItem id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormTranslationItem formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormTranslationItem translationKey.
                     * @member {string} translationKey
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.translationKey = "";
    
                    /**
                     * FormTranslationItem text.
                     * @member {string} text
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.text = "";
    
                    /**
                     * FormTranslationItem translatedText.
                     * @member {string} translatedText
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.translatedText = "";
    
                    /**
                     * FormTranslationItem targetPath.
                     * @member {string} targetPath
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.targetPath = "";
    
                    /**
                     * FormTranslationItem translatedFromText.
                     * @member {string} translatedFromText
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.translatedFromText = "";
    
                    /**
                     * FormTranslationItem status.
                     * @member {palexy.task_management.v1.FormTranslationItem.Status} status
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.status = 0;
    
                    /**
                     * FormTranslationItem targetLabel.
                     * @member {string} targetLabel
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     */
                    FormTranslationItem.prototype.targetLabel = "";
    
                    /**
                     * Creates a new FormTranslationItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslationItem=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormTranslationItem} FormTranslationItem instance
                     */
                    FormTranslationItem.create = function create(properties) {
                        return new FormTranslationItem(properties);
                    };
    
                    /**
                     * Encodes the specified FormTranslationItem message. Does not implicitly {@link palexy.task_management.v1.FormTranslationItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslationItem} message FormTranslationItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTranslationItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.translationKey != null && Object.hasOwnProperty.call(message, "translationKey"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.translationKey);
                        if (message.text != null && Object.hasOwnProperty.call(message, "text"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.text);
                        if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.translatedText);
                        if (message.targetPath != null && Object.hasOwnProperty.call(message, "targetPath"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.targetPath);
                        if (message.translatedFromText != null && Object.hasOwnProperty.call(message, "translatedFromText"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.translatedFromText);
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.status);
                        if (message.targetLabel != null && Object.hasOwnProperty.call(message, "targetLabel"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.targetLabel);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormTranslationItem message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormTranslationItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IFormTranslationItem} message FormTranslationItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormTranslationItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormTranslationItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormTranslationItem} FormTranslationItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTranslationItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormTranslationItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                message.translationKey = reader.string();
                                break;
                            case 4:
                                message.text = reader.string();
                                break;
                            case 5:
                                message.translatedText = reader.string();
                                break;
                            case 6:
                                message.targetPath = reader.string();
                                break;
                            case 7:
                                message.translatedFromText = reader.string();
                                break;
                            case 8:
                                message.status = reader.int32();
                                break;
                            case 9:
                                message.targetLabel = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormTranslationItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormTranslationItem} FormTranslationItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormTranslationItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormTranslationItem message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormTranslationItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            if (!$util.isString(message.translationKey))
                                return "translationKey: string expected";
                        if (message.text != null && message.hasOwnProperty("text"))
                            if (!$util.isString(message.text))
                                return "text: string expected";
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            if (!$util.isString(message.translatedText))
                                return "translatedText: string expected";
                        if (message.targetPath != null && message.hasOwnProperty("targetPath"))
                            if (!$util.isString(message.targetPath))
                                return "targetPath: string expected";
                        if (message.translatedFromText != null && message.hasOwnProperty("translatedFromText"))
                            if (!$util.isString(message.translatedFromText))
                                return "translatedFromText: string expected";
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.targetLabel != null && message.hasOwnProperty("targetLabel"))
                            if (!$util.isString(message.targetLabel))
                                return "targetLabel: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormTranslationItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormTranslationItem} FormTranslationItem
                     */
                    FormTranslationItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormTranslationItem)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormTranslationItem();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.translationKey != null)
                            message.translationKey = String(object.translationKey);
                        if (object.text != null)
                            message.text = String(object.text);
                        if (object.translatedText != null)
                            message.translatedText = String(object.translatedText);
                        if (object.targetPath != null)
                            message.targetPath = String(object.targetPath);
                        if (object.translatedFromText != null)
                            message.translatedFromText = String(object.translatedFromText);
                        switch (object.status) {
                        case "STATUS_UNSPECIFIED":
                        case 0:
                            message.status = 0;
                            break;
                        case "NOT_TRANSLATED":
                        case 1:
                            message.status = 1;
                            break;
                        case "TRANSLATED":
                        case 2:
                            message.status = 2;
                            break;
                        case "OUTDATED":
                        case 3:
                            message.status = 3;
                            break;
                        }
                        if (object.targetLabel != null)
                            message.targetLabel = String(object.targetLabel);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormTranslationItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.FormTranslationItem} message FormTranslationItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormTranslationItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                            object.translationKey = "";
                            object.text = "";
                            object.translatedText = "";
                            object.targetPath = "";
                            object.translatedFromText = "";
                            object.status = options.enums === String ? "STATUS_UNSPECIFIED" : 0;
                            object.targetLabel = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            object.translationKey = message.translationKey;
                        if (message.text != null && message.hasOwnProperty("text"))
                            object.text = message.text;
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            object.translatedText = message.translatedText;
                        if (message.targetPath != null && message.hasOwnProperty("targetPath"))
                            object.targetPath = message.targetPath;
                        if (message.translatedFromText != null && message.hasOwnProperty("translatedFromText"))
                            object.translatedFromText = message.translatedFromText;
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.task_management.v1.FormTranslationItem.Status[message.status] : message.status;
                        if (message.targetLabel != null && message.hasOwnProperty("targetLabel"))
                            object.targetLabel = message.targetLabel;
                        return object;
                    };
    
                    /**
                     * Converts this FormTranslationItem to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormTranslationItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormTranslationItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Status enum.
                     * @name palexy.task_management.v1.FormTranslationItem.Status
                     * @enum {number}
                     * @property {number} STATUS_UNSPECIFIED=0 STATUS_UNSPECIFIED value
                     * @property {number} NOT_TRANSLATED=1 NOT_TRANSLATED value
                     * @property {number} TRANSLATED=2 TRANSLATED value
                     * @property {number} OUTDATED=3 OUTDATED value
                     */
                    FormTranslationItem.Status = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "STATUS_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "NOT_TRANSLATED"] = 1;
                        values[valuesById[2] = "TRANSLATED"] = 2;
                        values[valuesById[3] = "OUTDATED"] = 3;
                        return values;
                    })();
    
                    return FormTranslationItem;
                })();
    
                v1.ListFormTranslationsRequest = (function() {
    
                    /**
                     * Properties of a ListFormTranslationsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormTranslationsRequest
                     * @property {number|null} [formId] ListFormTranslationsRequest formId
                     */
    
                    /**
                     * Constructs a new ListFormTranslationsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormTranslationsRequest.
                     * @implements IListFormTranslationsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest=} [properties] Properties to set
                     */
                    function ListFormTranslationsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormTranslationsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @instance
                     */
                    ListFormTranslationsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormTranslationsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormTranslationsRequest} ListFormTranslationsRequest instance
                     */
                    ListFormTranslationsRequest.create = function create(properties) {
                        return new ListFormTranslationsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest} message ListFormTranslationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsRequest} message ListFormTranslationsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormTranslationsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormTranslationsRequest} ListFormTranslationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormTranslationsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormTranslationsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormTranslationsRequest} ListFormTranslationsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormTranslationsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormTranslationsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormTranslationsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormTranslationsRequest} ListFormTranslationsRequest
                     */
                    ListFormTranslationsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormTranslationsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormTranslationsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormTranslationsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormTranslationsRequest} message ListFormTranslationsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormTranslationsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormTranslationsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormTranslationsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormTranslationsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormTranslationsRequest;
                })();
    
                v1.ListFormTranslationsResponse = (function() {
    
                    /**
                     * Properties of a ListFormTranslationsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormTranslationsResponse
                     * @property {Array.<palexy.task_management.v1.IFormTranslation>|null} [translations] ListFormTranslationsResponse translations
                     * @property {string|null} [baseLanguageCode] ListFormTranslationsResponse baseLanguageCode
                     */
    
                    /**
                     * Constructs a new ListFormTranslationsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormTranslationsResponse.
                     * @implements IListFormTranslationsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormTranslationsResponse=} [properties] Properties to set
                     */
                    function ListFormTranslationsResponse(properties) {
                        this.translations = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormTranslationsResponse translations.
                     * @member {Array.<palexy.task_management.v1.IFormTranslation>} translations
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @instance
                     */
                    ListFormTranslationsResponse.prototype.translations = $util.emptyArray;
    
                    /**
                     * ListFormTranslationsResponse baseLanguageCode.
                     * @member {string} baseLanguageCode
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @instance
                     */
                    ListFormTranslationsResponse.prototype.baseLanguageCode = "";
    
                    /**
                     * Creates a new ListFormTranslationsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormTranslationsResponse} ListFormTranslationsResponse instance
                     */
                    ListFormTranslationsResponse.create = function create(properties) {
                        return new ListFormTranslationsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsResponse} message ListFormTranslationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.translations != null && message.translations.length)
                            for (var i = 0; i < message.translations.length; ++i)
                                $root.palexy.task_management.v1.FormTranslation.encode(message.translations[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.baseLanguageCode != null && Object.hasOwnProperty.call(message, "baseLanguageCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.baseLanguageCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationsResponse} message ListFormTranslationsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormTranslationsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormTranslationsResponse} ListFormTranslationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormTranslationsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.translations && message.translations.length))
                                    message.translations = [];
                                message.translations.push($root.palexy.task_management.v1.FormTranslation.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.baseLanguageCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormTranslationsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormTranslationsResponse} ListFormTranslationsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormTranslationsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormTranslationsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.translations != null && message.hasOwnProperty("translations")) {
                            if (!Array.isArray(message.translations))
                                return "translations: array expected";
                            for (var i = 0; i < message.translations.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTranslation.verify(message.translations[i]);
                                if (error)
                                    return "translations." + error;
                            }
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            if (!$util.isString(message.baseLanguageCode))
                                return "baseLanguageCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormTranslationsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormTranslationsResponse} ListFormTranslationsResponse
                     */
                    ListFormTranslationsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormTranslationsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormTranslationsResponse();
                        if (object.translations) {
                            if (!Array.isArray(object.translations))
                                throw TypeError(".palexy.task_management.v1.ListFormTranslationsResponse.translations: array expected");
                            message.translations = [];
                            for (var i = 0; i < object.translations.length; ++i) {
                                if (typeof object.translations[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormTranslationsResponse.translations: object expected");
                                message.translations[i] = $root.palexy.task_management.v1.FormTranslation.fromObject(object.translations[i]);
                            }
                        }
                        if (object.baseLanguageCode != null)
                            message.baseLanguageCode = String(object.baseLanguageCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormTranslationsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormTranslationsResponse} message ListFormTranslationsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormTranslationsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.translations = [];
                        if (options.defaults)
                            object.baseLanguageCode = "";
                        if (message.translations && message.translations.length) {
                            object.translations = [];
                            for (var j = 0; j < message.translations.length; ++j)
                                object.translations[j] = $root.palexy.task_management.v1.FormTranslation.toObject(message.translations[j], options);
                        }
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            object.baseLanguageCode = message.baseLanguageCode;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormTranslationsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormTranslationsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormTranslationsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormTranslationsResponse;
                })();
    
                v1.CreateFormTranslationRequest = (function() {
    
                    /**
                     * Properties of a CreateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormTranslationRequest
                     * @property {number|null} [formId] CreateFormTranslationRequest formId
                     * @property {string|null} [languageCode] CreateFormTranslationRequest languageCode
                     * @property {string|null} [languageName] CreateFormTranslationRequest languageName
                     */
    
                    /**
                     * Constructs a new CreateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormTranslationRequest.
                     * @implements ICreateFormTranslationRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest=} [properties] Properties to set
                     */
                    function CreateFormTranslationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormTranslationRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @instance
                     */
                    CreateFormTranslationRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormTranslationRequest languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @instance
                     */
                    CreateFormTranslationRequest.prototype.languageCode = "";
    
                    /**
                     * CreateFormTranslationRequest languageName.
                     * @member {string} languageName
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @instance
                     */
                    CreateFormTranslationRequest.prototype.languageName = "";
    
                    /**
                     * Creates a new CreateFormTranslationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormTranslationRequest} CreateFormTranslationRequest instance
                     */
                    CreateFormTranslationRequest.create = function create(properties) {
                        return new CreateFormTranslationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormTranslationRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormTranslationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest} message CreateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormTranslationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.languageCode);
                        if (message.languageName != null && Object.hasOwnProperty.call(message, "languageName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormTranslationRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormTranslationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormTranslationRequest} message CreateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormTranslationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormTranslationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormTranslationRequest} CreateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormTranslationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormTranslationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.languageCode = reader.string();
                                break;
                            case 3:
                                message.languageName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormTranslationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormTranslationRequest} CreateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormTranslationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormTranslationRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormTranslationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            if (!$util.isString(message.languageName))
                                return "languageName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormTranslationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormTranslationRequest} CreateFormTranslationRequest
                     */
                    CreateFormTranslationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormTranslationRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormTranslationRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        if (object.languageName != null)
                            message.languageName = String(object.languageName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormTranslationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormTranslationRequest} message CreateFormTranslationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormTranslationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.languageCode = "";
                            object.languageName = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            object.languageName = message.languageName;
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormTranslationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormTranslationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormTranslationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormTranslationRequest;
                })();
    
                v1.UpdateFormTranslationRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormTranslationRequest
                     * @property {number|null} [formId] UpdateFormTranslationRequest formId
                     * @property {number|null} [formTranslationId] UpdateFormTranslationRequest formTranslationId
                     * @property {palexy.task_management.v1.IFormTranslation|null} [translation] UpdateFormTranslationRequest translation
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormTranslationRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormTranslationRequest.
                     * @implements IUpdateFormTranslationRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest=} [properties] Properties to set
                     */
                    function UpdateFormTranslationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormTranslationRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @instance
                     */
                    UpdateFormTranslationRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormTranslationRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @instance
                     */
                    UpdateFormTranslationRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormTranslationRequest translation.
                     * @member {palexy.task_management.v1.IFormTranslation|null|undefined} translation
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @instance
                     */
                    UpdateFormTranslationRequest.prototype.translation = null;
    
                    /**
                     * UpdateFormTranslationRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @instance
                     */
                    UpdateFormTranslationRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateFormTranslationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormTranslationRequest} UpdateFormTranslationRequest instance
                     */
                    UpdateFormTranslationRequest.create = function create(properties) {
                        return new UpdateFormTranslationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormTranslationRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormTranslationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest} message UpdateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormTranslationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.translation != null && Object.hasOwnProperty.call(message, "translation"))
                            $root.palexy.task_management.v1.FormTranslation.encode(message.translation, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormTranslationRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormTranslationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationRequest} message UpdateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormTranslationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormTranslationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormTranslationRequest} UpdateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormTranslationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormTranslationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                message.translation = $root.palexy.task_management.v1.FormTranslation.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormTranslationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormTranslationRequest} UpdateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormTranslationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormTranslationRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormTranslationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.translation != null && message.hasOwnProperty("translation")) {
                            var error = $root.palexy.task_management.v1.FormTranslation.verify(message.translation);
                            if (error)
                                return "translation." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormTranslationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormTranslationRequest} UpdateFormTranslationRequest
                     */
                    UpdateFormTranslationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormTranslationRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormTranslationRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.translation != null) {
                            if (typeof object.translation !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormTranslationRequest.translation: object expected");
                            message.translation = $root.palexy.task_management.v1.FormTranslation.fromObject(object.translation);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormTranslationRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormTranslationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormTranslationRequest} message UpdateFormTranslationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormTranslationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                            object.translation = null;
                            object.updateMask = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.translation != null && message.hasOwnProperty("translation"))
                            object.translation = $root.palexy.task_management.v1.FormTranslation.toObject(message.translation, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormTranslationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormTranslationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormTranslationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormTranslationRequest;
                })();
    
                v1.DeleteFormTranslationRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormTranslationRequest
                     * @property {number|null} [formId] DeleteFormTranslationRequest formId
                     * @property {number|null} [formTranslationId] DeleteFormTranslationRequest formTranslationId
                     */
    
                    /**
                     * Constructs a new DeleteFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormTranslationRequest.
                     * @implements IDeleteFormTranslationRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest=} [properties] Properties to set
                     */
                    function DeleteFormTranslationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormTranslationRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @instance
                     */
                    DeleteFormTranslationRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormTranslationRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @instance
                     */
                    DeleteFormTranslationRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormTranslationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormTranslationRequest} DeleteFormTranslationRequest instance
                     */
                    DeleteFormTranslationRequest.create = function create(properties) {
                        return new DeleteFormTranslationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormTranslationRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormTranslationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest} message DeleteFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormTranslationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormTranslationRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormTranslationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormTranslationRequest} message DeleteFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormTranslationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormTranslationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormTranslationRequest} DeleteFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormTranslationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormTranslationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormTranslationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormTranslationRequest} DeleteFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormTranslationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormTranslationRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormTranslationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormTranslationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormTranslationRequest} DeleteFormTranslationRequest
                     */
                    DeleteFormTranslationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormTranslationRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormTranslationRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormTranslationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormTranslationRequest} message DeleteFormTranslationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormTranslationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormTranslationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormTranslationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormTranslationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormTranslationRequest;
                })();
    
                v1.ListFormTranslationItemsRequest = (function() {
    
                    /**
                     * Properties of a ListFormTranslationItemsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormTranslationItemsRequest
                     * @property {number|null} [formId] ListFormTranslationItemsRequest formId
                     * @property {number|null} [formTranslationId] ListFormTranslationItemsRequest formTranslationId
                     */
    
                    /**
                     * Constructs a new ListFormTranslationItemsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormTranslationItemsRequest.
                     * @implements IListFormTranslationItemsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest=} [properties] Properties to set
                     */
                    function ListFormTranslationItemsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormTranslationItemsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @instance
                     */
                    ListFormTranslationItemsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormTranslationItemsRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @instance
                     */
                    ListFormTranslationItemsRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormTranslationItemsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsRequest} ListFormTranslationItemsRequest instance
                     */
                    ListFormTranslationItemsRequest.create = function create(properties) {
                        return new ListFormTranslationItemsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationItemsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationItemsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest} message ListFormTranslationItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationItemsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationItemsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationItemsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsRequest} message ListFormTranslationItemsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationItemsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormTranslationItemsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsRequest} ListFormTranslationItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationItemsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormTranslationItemsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormTranslationItemsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsRequest} ListFormTranslationItemsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationItemsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormTranslationItemsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormTranslationItemsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormTranslationItemsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsRequest} ListFormTranslationItemsRequest
                     */
                    ListFormTranslationItemsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormTranslationItemsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormTranslationItemsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormTranslationItemsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormTranslationItemsRequest} message ListFormTranslationItemsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormTranslationItemsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormTranslationItemsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormTranslationItemsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormTranslationItemsRequest;
                })();
    
                v1.ListFormTranslationItemsResponse = (function() {
    
                    /**
                     * Properties of a ListFormTranslationItemsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormTranslationItemsResponse
                     * @property {Array.<palexy.task_management.v1.IFormTranslationItem>|null} [items] ListFormTranslationItemsResponse items
                     * @property {string|null} [languageCode] ListFormTranslationItemsResponse languageCode
                     * @property {string|null} [languageName] ListFormTranslationItemsResponse languageName
                     * @property {string|null} [baseLanguageCode] ListFormTranslationItemsResponse baseLanguageCode
                     * @property {string|null} [baseLanguageName] ListFormTranslationItemsResponse baseLanguageName
                     */
    
                    /**
                     * Constructs a new ListFormTranslationItemsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormTranslationItemsResponse.
                     * @implements IListFormTranslationItemsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormTranslationItemsResponse=} [properties] Properties to set
                     */
                    function ListFormTranslationItemsResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormTranslationItemsResponse items.
                     * @member {Array.<palexy.task_management.v1.IFormTranslationItem>} items
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     */
                    ListFormTranslationItemsResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * ListFormTranslationItemsResponse languageCode.
                     * @member {string} languageCode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     */
                    ListFormTranslationItemsResponse.prototype.languageCode = "";
    
                    /**
                     * ListFormTranslationItemsResponse languageName.
                     * @member {string} languageName
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     */
                    ListFormTranslationItemsResponse.prototype.languageName = "";
    
                    /**
                     * ListFormTranslationItemsResponse baseLanguageCode.
                     * @member {string} baseLanguageCode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     */
                    ListFormTranslationItemsResponse.prototype.baseLanguageCode = "";
    
                    /**
                     * ListFormTranslationItemsResponse baseLanguageName.
                     * @member {string} baseLanguageName
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     */
                    ListFormTranslationItemsResponse.prototype.baseLanguageName = "";
    
                    /**
                     * Creates a new ListFormTranslationItemsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsResponse} ListFormTranslationItemsResponse instance
                     */
                    ListFormTranslationItemsResponse.create = function create(properties) {
                        return new ListFormTranslationItemsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationItemsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationItemsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsResponse} message ListFormTranslationItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationItemsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.task_management.v1.FormTranslationItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.languageCode != null && Object.hasOwnProperty.call(message, "languageCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.languageCode);
                        if (message.languageName != null && Object.hasOwnProperty.call(message, "languageName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.languageName);
                        if (message.baseLanguageCode != null && Object.hasOwnProperty.call(message, "baseLanguageCode"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.baseLanguageCode);
                        if (message.baseLanguageName != null && Object.hasOwnProperty.call(message, "baseLanguageName"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.baseLanguageName);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormTranslationItemsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormTranslationItemsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormTranslationItemsResponse} message ListFormTranslationItemsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormTranslationItemsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormTranslationItemsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsResponse} ListFormTranslationItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationItemsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormTranslationItemsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.task_management.v1.FormTranslationItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.languageCode = reader.string();
                                break;
                            case 3:
                                message.languageName = reader.string();
                                break;
                            case 4:
                                message.baseLanguageCode = reader.string();
                                break;
                            case 5:
                                message.baseLanguageName = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormTranslationItemsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsResponse} ListFormTranslationItemsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormTranslationItemsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormTranslationItemsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormTranslationItemsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTranslationItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            if (!$util.isString(message.languageCode))
                                return "languageCode: string expected";
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            if (!$util.isString(message.languageName))
                                return "languageName: string expected";
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            if (!$util.isString(message.baseLanguageCode))
                                return "baseLanguageCode: string expected";
                        if (message.baseLanguageName != null && message.hasOwnProperty("baseLanguageName"))
                            if (!$util.isString(message.baseLanguageName))
                                return "baseLanguageName: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormTranslationItemsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormTranslationItemsResponse} ListFormTranslationItemsResponse
                     */
                    ListFormTranslationItemsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormTranslationItemsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormTranslationItemsResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.task_management.v1.ListFormTranslationItemsResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormTranslationItemsResponse.items: object expected");
                                message.items[i] = $root.palexy.task_management.v1.FormTranslationItem.fromObject(object.items[i]);
                            }
                        }
                        if (object.languageCode != null)
                            message.languageCode = String(object.languageCode);
                        if (object.languageName != null)
                            message.languageName = String(object.languageName);
                        if (object.baseLanguageCode != null)
                            message.baseLanguageCode = String(object.baseLanguageCode);
                        if (object.baseLanguageName != null)
                            message.baseLanguageName = String(object.baseLanguageName);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormTranslationItemsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormTranslationItemsResponse} message ListFormTranslationItemsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormTranslationItemsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            object.languageCode = "";
                            object.languageName = "";
                            object.baseLanguageCode = "";
                            object.baseLanguageName = "";
                        }
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.task_management.v1.FormTranslationItem.toObject(message.items[j], options);
                        }
                        if (message.languageCode != null && message.hasOwnProperty("languageCode"))
                            object.languageCode = message.languageCode;
                        if (message.languageName != null && message.hasOwnProperty("languageName"))
                            object.languageName = message.languageName;
                        if (message.baseLanguageCode != null && message.hasOwnProperty("baseLanguageCode"))
                            object.baseLanguageCode = message.baseLanguageCode;
                        if (message.baseLanguageName != null && message.hasOwnProperty("baseLanguageName"))
                            object.baseLanguageName = message.baseLanguageName;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormTranslationItemsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormTranslationItemsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormTranslationItemsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormTranslationItemsResponse;
                })();
    
                v1.UpdateFormTranslationItemRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormTranslationItemRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormTranslationItemRequest
                     * @property {number|null} [formId] UpdateFormTranslationItemRequest formId
                     * @property {number|null} [formTranslationId] UpdateFormTranslationItemRequest formTranslationId
                     * @property {number|null} [itemId] UpdateFormTranslationItemRequest itemId
                     * @property {string|null} [translatedText] UpdateFormTranslationItemRequest translatedText
                     */
    
                    /**
                     * Constructs a new UpdateFormTranslationItemRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormTranslationItemRequest.
                     * @implements IUpdateFormTranslationItemRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest=} [properties] Properties to set
                     */
                    function UpdateFormTranslationItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormTranslationItemRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @instance
                     */
                    UpdateFormTranslationItemRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormTranslationItemRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @instance
                     */
                    UpdateFormTranslationItemRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormTranslationItemRequest itemId.
                     * @member {number} itemId
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @instance
                     */
                    UpdateFormTranslationItemRequest.prototype.itemId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormTranslationItemRequest translatedText.
                     * @member {string} translatedText
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @instance
                     */
                    UpdateFormTranslationItemRequest.prototype.translatedText = "";
    
                    /**
                     * Creates a new UpdateFormTranslationItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormTranslationItemRequest} UpdateFormTranslationItemRequest instance
                     */
                    UpdateFormTranslationItemRequest.create = function create(properties) {
                        return new UpdateFormTranslationItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormTranslationItemRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormTranslationItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest} message UpdateFormTranslationItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormTranslationItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.itemId != null && Object.hasOwnProperty.call(message, "itemId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.itemId);
                        if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.translatedText);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormTranslationItemRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormTranslationItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormTranslationItemRequest} message UpdateFormTranslationItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormTranslationItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormTranslationItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormTranslationItemRequest} UpdateFormTranslationItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormTranslationItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormTranslationItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                message.itemId = reader.int64();
                                break;
                            case 4:
                                message.translatedText = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormTranslationItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormTranslationItemRequest} UpdateFormTranslationItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormTranslationItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormTranslationItemRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormTranslationItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (!$util.isInteger(message.itemId) && !(message.itemId && $util.isInteger(message.itemId.low) && $util.isInteger(message.itemId.high)))
                                return "itemId: integer|Long expected";
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            if (!$util.isString(message.translatedText))
                                return "translatedText: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormTranslationItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormTranslationItemRequest} UpdateFormTranslationItemRequest
                     */
                    UpdateFormTranslationItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormTranslationItemRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormTranslationItemRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.itemId != null)
                            if ($util.Long)
                                (message.itemId = $util.Long.fromValue(object.itemId)).unsigned = false;
                            else if (typeof object.itemId === "string")
                                message.itemId = parseInt(object.itemId, 10);
                            else if (typeof object.itemId === "number")
                                message.itemId = object.itemId;
                            else if (typeof object.itemId === "object")
                                message.itemId = new $util.LongBits(object.itemId.low >>> 0, object.itemId.high >>> 0).toNumber();
                        if (object.translatedText != null)
                            message.translatedText = String(object.translatedText);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormTranslationItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormTranslationItemRequest} message UpdateFormTranslationItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormTranslationItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.itemId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.itemId = options.longs === String ? "0" : 0;
                            object.translatedText = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.itemId != null && message.hasOwnProperty("itemId"))
                            if (typeof message.itemId === "number")
                                object.itemId = options.longs === String ? String(message.itemId) : message.itemId;
                            else
                                object.itemId = options.longs === String ? $util.Long.prototype.toString.call(message.itemId) : options.longs === Number ? new $util.LongBits(message.itemId.low >>> 0, message.itemId.high >>> 0).toNumber() : message.itemId;
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            object.translatedText = message.translatedText;
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormTranslationItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormTranslationItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormTranslationItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormTranslationItemRequest;
                })();
    
                v1.WriteFormTranslationItemRequest = (function() {
    
                    /**
                     * Properties of a WriteFormTranslationItemRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IWriteFormTranslationItemRequest
                     * @property {number|null} [formId] WriteFormTranslationItemRequest formId
                     * @property {number|null} [formTranslationId] WriteFormTranslationItemRequest formTranslationId
                     * @property {string|null} [translationKey] WriteFormTranslationItemRequest translationKey
                     * @property {string|null} [translatedText] WriteFormTranslationItemRequest translatedText
                     */
    
                    /**
                     * Constructs a new WriteFormTranslationItemRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a WriteFormTranslationItemRequest.
                     * @implements IWriteFormTranslationItemRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest=} [properties] Properties to set
                     */
                    function WriteFormTranslationItemRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * WriteFormTranslationItemRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @instance
                     */
                    WriteFormTranslationItemRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * WriteFormTranslationItemRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @instance
                     */
                    WriteFormTranslationItemRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * WriteFormTranslationItemRequest translationKey.
                     * @member {string} translationKey
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @instance
                     */
                    WriteFormTranslationItemRequest.prototype.translationKey = "";
    
                    /**
                     * WriteFormTranslationItemRequest translatedText.
                     * @member {string} translatedText
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @instance
                     */
                    WriteFormTranslationItemRequest.prototype.translatedText = "";
    
                    /**
                     * Creates a new WriteFormTranslationItemRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.WriteFormTranslationItemRequest} WriteFormTranslationItemRequest instance
                     */
                    WriteFormTranslationItemRequest.create = function create(properties) {
                        return new WriteFormTranslationItemRequest(properties);
                    };
    
                    /**
                     * Encodes the specified WriteFormTranslationItemRequest message. Does not implicitly {@link palexy.task_management.v1.WriteFormTranslationItemRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest} message WriteFormTranslationItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WriteFormTranslationItemRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.translationKey != null && Object.hasOwnProperty.call(message, "translationKey"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.translationKey);
                        if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.translatedText);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified WriteFormTranslationItemRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.WriteFormTranslationItemRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.IWriteFormTranslationItemRequest} message WriteFormTranslationItemRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    WriteFormTranslationItemRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a WriteFormTranslationItemRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.WriteFormTranslationItemRequest} WriteFormTranslationItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WriteFormTranslationItemRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.WriteFormTranslationItemRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                message.translationKey = reader.string();
                                break;
                            case 4:
                                message.translatedText = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a WriteFormTranslationItemRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.WriteFormTranslationItemRequest} WriteFormTranslationItemRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    WriteFormTranslationItemRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a WriteFormTranslationItemRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    WriteFormTranslationItemRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            if (!$util.isString(message.translationKey))
                                return "translationKey: string expected";
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            if (!$util.isString(message.translatedText))
                                return "translatedText: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a WriteFormTranslationItemRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.WriteFormTranslationItemRequest} WriteFormTranslationItemRequest
                     */
                    WriteFormTranslationItemRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.WriteFormTranslationItemRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.WriteFormTranslationItemRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.translationKey != null)
                            message.translationKey = String(object.translationKey);
                        if (object.translatedText != null)
                            message.translatedText = String(object.translatedText);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a WriteFormTranslationItemRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @static
                     * @param {palexy.task_management.v1.WriteFormTranslationItemRequest} message WriteFormTranslationItemRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    WriteFormTranslationItemRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                            object.translationKey = "";
                            object.translatedText = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            object.translationKey = message.translationKey;
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            object.translatedText = message.translatedText;
                        return object;
                    };
    
                    /**
                     * Converts this WriteFormTranslationItemRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.WriteFormTranslationItemRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    WriteFormTranslationItemRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return WriteFormTranslationItemRequest;
                })();
    
                v1.GenerateFormTranslationRequest = (function() {
    
                    /**
                     * Properties of a GenerateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGenerateFormTranslationRequest
                     * @property {number|null} [formId] GenerateFormTranslationRequest formId
                     * @property {number|null} [formTranslationId] GenerateFormTranslationRequest formTranslationId
                     */
    
                    /**
                     * Constructs a new GenerateFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GenerateFormTranslationRequest.
                     * @implements IGenerateFormTranslationRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest=} [properties] Properties to set
                     */
                    function GenerateFormTranslationRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateFormTranslationRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @instance
                     */
                    GenerateFormTranslationRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GenerateFormTranslationRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @instance
                     */
                    GenerateFormTranslationRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GenerateFormTranslationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GenerateFormTranslationRequest} GenerateFormTranslationRequest instance
                     */
                    GenerateFormTranslationRequest.create = function create(properties) {
                        return new GenerateFormTranslationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateFormTranslationRequest message. Does not implicitly {@link palexy.task_management.v1.GenerateFormTranslationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest} message GenerateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateFormTranslationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateFormTranslationRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GenerateFormTranslationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationRequest} message GenerateFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateFormTranslationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateFormTranslationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GenerateFormTranslationRequest} GenerateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateFormTranslationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GenerateFormTranslationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateFormTranslationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GenerateFormTranslationRequest} GenerateFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateFormTranslationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateFormTranslationRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateFormTranslationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GenerateFormTranslationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GenerateFormTranslationRequest} GenerateFormTranslationRequest
                     */
                    GenerateFormTranslationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GenerateFormTranslationRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GenerateFormTranslationRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateFormTranslationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.GenerateFormTranslationRequest} message GenerateFormTranslationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateFormTranslationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        return object;
                    };
    
                    /**
                     * Converts this GenerateFormTranslationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GenerateFormTranslationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateFormTranslationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateFormTranslationRequest;
                })();
    
                v1.GenerateFormTranslationResponse = (function() {
    
                    /**
                     * Properties of a GenerateFormTranslationResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IGenerateFormTranslationResponse
                     * @property {Array.<palexy.task_management.v1.IFormTranslationItem>|null} [items] GenerateFormTranslationResponse items
                     */
    
                    /**
                     * Constructs a new GenerateFormTranslationResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GenerateFormTranslationResponse.
                     * @implements IGenerateFormTranslationResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IGenerateFormTranslationResponse=} [properties] Properties to set
                     */
                    function GenerateFormTranslationResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GenerateFormTranslationResponse items.
                     * @member {Array.<palexy.task_management.v1.IFormTranslationItem>} items
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @instance
                     */
                    GenerateFormTranslationResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new GenerateFormTranslationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GenerateFormTranslationResponse} GenerateFormTranslationResponse instance
                     */
                    GenerateFormTranslationResponse.create = function create(properties) {
                        return new GenerateFormTranslationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GenerateFormTranslationResponse message. Does not implicitly {@link palexy.task_management.v1.GenerateFormTranslationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationResponse} message GenerateFormTranslationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateFormTranslationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.task_management.v1.FormTranslationItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GenerateFormTranslationResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.GenerateFormTranslationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IGenerateFormTranslationResponse} message GenerateFormTranslationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GenerateFormTranslationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GenerateFormTranslationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GenerateFormTranslationResponse} GenerateFormTranslationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateFormTranslationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GenerateFormTranslationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.task_management.v1.FormTranslationItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GenerateFormTranslationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GenerateFormTranslationResponse} GenerateFormTranslationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GenerateFormTranslationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GenerateFormTranslationResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GenerateFormTranslationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTranslationItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GenerateFormTranslationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GenerateFormTranslationResponse} GenerateFormTranslationResponse
                     */
                    GenerateFormTranslationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GenerateFormTranslationResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.GenerateFormTranslationResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.task_management.v1.GenerateFormTranslationResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.GenerateFormTranslationResponse.items: object expected");
                                message.items[i] = $root.palexy.task_management.v1.FormTranslationItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GenerateFormTranslationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.GenerateFormTranslationResponse} message GenerateFormTranslationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GenerateFormTranslationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.task_management.v1.FormTranslationItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GenerateFormTranslationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GenerateFormTranslationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GenerateFormTranslationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GenerateFormTranslationResponse;
                })();
    
                v1.MarkFormTranslationItemsUpToDateRequest = (function() {
    
                    /**
                     * Properties of a MarkFormTranslationItemsUpToDateRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IMarkFormTranslationItemsUpToDateRequest
                     * @property {number|null} [formId] MarkFormTranslationItemsUpToDateRequest formId
                     * @property {number|null} [formTranslationId] MarkFormTranslationItemsUpToDateRequest formTranslationId
                     * @property {Array.<string>|null} [translationKeys] MarkFormTranslationItemsUpToDateRequest translationKeys
                     */
    
                    /**
                     * Constructs a new MarkFormTranslationItemsUpToDateRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a MarkFormTranslationItemsUpToDateRequest.
                     * @implements IMarkFormTranslationItemsUpToDateRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest=} [properties] Properties to set
                     */
                    function MarkFormTranslationItemsUpToDateRequest(properties) {
                        this.translationKeys = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MarkFormTranslationItemsUpToDateRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @instance
                     */
                    MarkFormTranslationItemsUpToDateRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MarkFormTranslationItemsUpToDateRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @instance
                     */
                    MarkFormTranslationItemsUpToDateRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * MarkFormTranslationItemsUpToDateRequest translationKeys.
                     * @member {Array.<string>} translationKeys
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @instance
                     */
                    MarkFormTranslationItemsUpToDateRequest.prototype.translationKeys = $util.emptyArray;
    
                    /**
                     * Creates a new MarkFormTranslationItemsUpToDateRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest} MarkFormTranslationItemsUpToDateRequest instance
                     */
                    MarkFormTranslationItemsUpToDateRequest.create = function create(properties) {
                        return new MarkFormTranslationItemsUpToDateRequest(properties);
                    };
    
                    /**
                     * Encodes the specified MarkFormTranslationItemsUpToDateRequest message. Does not implicitly {@link palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest} message MarkFormTranslationItemsUpToDateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkFormTranslationItemsUpToDateRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.translationKeys != null && message.translationKeys.length)
                            for (var i = 0; i < message.translationKeys.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.translationKeys[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MarkFormTranslationItemsUpToDateRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateRequest} message MarkFormTranslationItemsUpToDateRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkFormTranslationItemsUpToDateRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MarkFormTranslationItemsUpToDateRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest} MarkFormTranslationItemsUpToDateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkFormTranslationItemsUpToDateRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                if (!(message.translationKeys && message.translationKeys.length))
                                    message.translationKeys = [];
                                message.translationKeys.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MarkFormTranslationItemsUpToDateRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest} MarkFormTranslationItemsUpToDateRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkFormTranslationItemsUpToDateRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MarkFormTranslationItemsUpToDateRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MarkFormTranslationItemsUpToDateRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.translationKeys != null && message.hasOwnProperty("translationKeys")) {
                            if (!Array.isArray(message.translationKeys))
                                return "translationKeys: array expected";
                            for (var i = 0; i < message.translationKeys.length; ++i)
                                if (!$util.isString(message.translationKeys[i]))
                                    return "translationKeys: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a MarkFormTranslationItemsUpToDateRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest} MarkFormTranslationItemsUpToDateRequest
                     */
                    MarkFormTranslationItemsUpToDateRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.translationKeys) {
                            if (!Array.isArray(object.translationKeys))
                                throw TypeError(".palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest.translationKeys: array expected");
                            message.translationKeys = [];
                            for (var i = 0; i < object.translationKeys.length; ++i)
                                message.translationKeys[i] = String(object.translationKeys[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MarkFormTranslationItemsUpToDateRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @static
                     * @param {palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest} message MarkFormTranslationItemsUpToDateRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MarkFormTranslationItemsUpToDateRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.translationKeys = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.translationKeys && message.translationKeys.length) {
                            object.translationKeys = [];
                            for (var j = 0; j < message.translationKeys.length; ++j)
                                object.translationKeys[j] = message.translationKeys[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this MarkFormTranslationItemsUpToDateRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MarkFormTranslationItemsUpToDateRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MarkFormTranslationItemsUpToDateRequest;
                })();
    
                v1.MarkFormTranslationItemsUpToDateResponse = (function() {
    
                    /**
                     * Properties of a MarkFormTranslationItemsUpToDateResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IMarkFormTranslationItemsUpToDateResponse
                     * @property {Array.<palexy.task_management.v1.IFormTranslationItem>|null} [items] MarkFormTranslationItemsUpToDateResponse items
                     * @property {number|null} [updatedCount] MarkFormTranslationItemsUpToDateResponse updatedCount
                     */
    
                    /**
                     * Constructs a new MarkFormTranslationItemsUpToDateResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a MarkFormTranslationItemsUpToDateResponse.
                     * @implements IMarkFormTranslationItemsUpToDateResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateResponse=} [properties] Properties to set
                     */
                    function MarkFormTranslationItemsUpToDateResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * MarkFormTranslationItemsUpToDateResponse items.
                     * @member {Array.<palexy.task_management.v1.IFormTranslationItem>} items
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @instance
                     */
                    MarkFormTranslationItemsUpToDateResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * MarkFormTranslationItemsUpToDateResponse updatedCount.
                     * @member {number} updatedCount
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @instance
                     */
                    MarkFormTranslationItemsUpToDateResponse.prototype.updatedCount = 0;
    
                    /**
                     * Creates a new MarkFormTranslationItemsUpToDateResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} MarkFormTranslationItemsUpToDateResponse instance
                     */
                    MarkFormTranslationItemsUpToDateResponse.create = function create(properties) {
                        return new MarkFormTranslationItemsUpToDateResponse(properties);
                    };
    
                    /**
                     * Encodes the specified MarkFormTranslationItemsUpToDateResponse message. Does not implicitly {@link palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateResponse} message MarkFormTranslationItemsUpToDateResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkFormTranslationItemsUpToDateResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.task_management.v1.FormTranslationItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updatedCount != null && Object.hasOwnProperty.call(message, "updatedCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.updatedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified MarkFormTranslationItemsUpToDateResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {palexy.task_management.v1.IMarkFormTranslationItemsUpToDateResponse} message MarkFormTranslationItemsUpToDateResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    MarkFormTranslationItemsUpToDateResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a MarkFormTranslationItemsUpToDateResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} MarkFormTranslationItemsUpToDateResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkFormTranslationItemsUpToDateResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.task_management.v1.FormTranslationItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.updatedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a MarkFormTranslationItemsUpToDateResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} MarkFormTranslationItemsUpToDateResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    MarkFormTranslationItemsUpToDateResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a MarkFormTranslationItemsUpToDateResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    MarkFormTranslationItemsUpToDateResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTranslationItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        if (message.updatedCount != null && message.hasOwnProperty("updatedCount"))
                            if (!$util.isInteger(message.updatedCount))
                                return "updatedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a MarkFormTranslationItemsUpToDateResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} MarkFormTranslationItemsUpToDateResponse
                     */
                    MarkFormTranslationItemsUpToDateResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse.items: object expected");
                                message.items[i] = $root.palexy.task_management.v1.FormTranslationItem.fromObject(object.items[i]);
                            }
                        }
                        if (object.updatedCount != null)
                            message.updatedCount = object.updatedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a MarkFormTranslationItemsUpToDateResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @static
                     * @param {palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse} message MarkFormTranslationItemsUpToDateResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    MarkFormTranslationItemsUpToDateResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults)
                            object.updatedCount = 0;
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.task_management.v1.FormTranslationItem.toObject(message.items[j], options);
                        }
                        if (message.updatedCount != null && message.hasOwnProperty("updatedCount"))
                            object.updatedCount = message.updatedCount;
                        return object;
                    };
    
                    /**
                     * Converts this MarkFormTranslationItemsUpToDateResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.MarkFormTranslationItemsUpToDateResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    MarkFormTranslationItemsUpToDateResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return MarkFormTranslationItemsUpToDateResponse;
                })();
    
                v1.ImportFormTranslationItem = (function() {
    
                    /**
                     * Properties of an ImportFormTranslationItem.
                     * @memberof palexy.task_management.v1
                     * @interface IImportFormTranslationItem
                     * @property {string|null} [translationKey] ImportFormTranslationItem translationKey
                     * @property {string|null} [translatedText] ImportFormTranslationItem translatedText
                     */
    
                    /**
                     * Constructs a new ImportFormTranslationItem.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an ImportFormTranslationItem.
                     * @implements IImportFormTranslationItem
                     * @constructor
                     * @param {palexy.task_management.v1.IImportFormTranslationItem=} [properties] Properties to set
                     */
                    function ImportFormTranslationItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportFormTranslationItem translationKey.
                     * @member {string} translationKey
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @instance
                     */
                    ImportFormTranslationItem.prototype.translationKey = "";
    
                    /**
                     * ImportFormTranslationItem translatedText.
                     * @member {string} translatedText
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @instance
                     */
                    ImportFormTranslationItem.prototype.translatedText = "";
    
                    /**
                     * Creates a new ImportFormTranslationItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationItem=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ImportFormTranslationItem} ImportFormTranslationItem instance
                     */
                    ImportFormTranslationItem.create = function create(properties) {
                        return new ImportFormTranslationItem(properties);
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationItem message. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationItem} message ImportFormTranslationItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.translationKey != null && Object.hasOwnProperty.call(message, "translationKey"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.translationKey);
                        if (message.translatedText != null && Object.hasOwnProperty.call(message, "translatedText"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.translatedText);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationItem message, length delimited. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationItem} message ImportFormTranslationItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportFormTranslationItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ImportFormTranslationItem} ImportFormTranslationItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ImportFormTranslationItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.translationKey = reader.string();
                                break;
                            case 2:
                                message.translatedText = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportFormTranslationItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ImportFormTranslationItem} ImportFormTranslationItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportFormTranslationItem message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportFormTranslationItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            if (!$util.isString(message.translationKey))
                                return "translationKey: string expected";
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            if (!$util.isString(message.translatedText))
                                return "translatedText: string expected";
                        return null;
                    };
    
                    /**
                     * Creates an ImportFormTranslationItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ImportFormTranslationItem} ImportFormTranslationItem
                     */
                    ImportFormTranslationItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ImportFormTranslationItem)
                            return object;
                        var message = new $root.palexy.task_management.v1.ImportFormTranslationItem();
                        if (object.translationKey != null)
                            message.translationKey = String(object.translationKey);
                        if (object.translatedText != null)
                            message.translatedText = String(object.translatedText);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportFormTranslationItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @static
                     * @param {palexy.task_management.v1.ImportFormTranslationItem} message ImportFormTranslationItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportFormTranslationItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.translationKey = "";
                            object.translatedText = "";
                        }
                        if (message.translationKey != null && message.hasOwnProperty("translationKey"))
                            object.translationKey = message.translationKey;
                        if (message.translatedText != null && message.hasOwnProperty("translatedText"))
                            object.translatedText = message.translatedText;
                        return object;
                    };
    
                    /**
                     * Converts this ImportFormTranslationItem to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ImportFormTranslationItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportFormTranslationItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportFormTranslationItem;
                })();
    
                v1.ImportFormTranslationRequest = (function() {
    
                    /**
                     * Properties of an ImportFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IImportFormTranslationRequest
                     * @property {number|null} [formId] ImportFormTranslationRequest formId
                     * @property {number|null} [formTranslationId] ImportFormTranslationRequest formTranslationId
                     * @property {Array.<palexy.task_management.v1.IImportFormTranslationItem>|null} [items] ImportFormTranslationRequest items
                     */
    
                    /**
                     * Constructs a new ImportFormTranslationRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an ImportFormTranslationRequest.
                     * @implements IImportFormTranslationRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest=} [properties] Properties to set
                     */
                    function ImportFormTranslationRequest(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportFormTranslationRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @instance
                     */
                    ImportFormTranslationRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportFormTranslationRequest formTranslationId.
                     * @member {number} formTranslationId
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @instance
                     */
                    ImportFormTranslationRequest.prototype.formTranslationId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ImportFormTranslationRequest items.
                     * @member {Array.<palexy.task_management.v1.IImportFormTranslationItem>} items
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @instance
                     */
                    ImportFormTranslationRequest.prototype.items = $util.emptyArray;
    
                    /**
                     * Creates a new ImportFormTranslationRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ImportFormTranslationRequest} ImportFormTranslationRequest instance
                     */
                    ImportFormTranslationRequest.create = function create(properties) {
                        return new ImportFormTranslationRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationRequest message. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest} message ImportFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formTranslationId != null && Object.hasOwnProperty.call(message, "formTranslationId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formTranslationId);
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.task_management.v1.ImportFormTranslationItem.encode(message.items[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationRequest} message ImportFormTranslationRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportFormTranslationRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ImportFormTranslationRequest} ImportFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ImportFormTranslationRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formTranslationId = reader.int64();
                                break;
                            case 3:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.task_management.v1.ImportFormTranslationItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportFormTranslationRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ImportFormTranslationRequest} ImportFormTranslationRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportFormTranslationRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportFormTranslationRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (!$util.isInteger(message.formTranslationId) && !(message.formTranslationId && $util.isInteger(message.formTranslationId.low) && $util.isInteger(message.formTranslationId.high)))
                                return "formTranslationId: integer|Long expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.task_management.v1.ImportFormTranslationItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an ImportFormTranslationRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ImportFormTranslationRequest} ImportFormTranslationRequest
                     */
                    ImportFormTranslationRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ImportFormTranslationRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ImportFormTranslationRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formTranslationId != null)
                            if ($util.Long)
                                (message.formTranslationId = $util.Long.fromValue(object.formTranslationId)).unsigned = false;
                            else if (typeof object.formTranslationId === "string")
                                message.formTranslationId = parseInt(object.formTranslationId, 10);
                            else if (typeof object.formTranslationId === "number")
                                message.formTranslationId = object.formTranslationId;
                            else if (typeof object.formTranslationId === "object")
                                message.formTranslationId = new $util.LongBits(object.formTranslationId.low >>> 0, object.formTranslationId.high >>> 0).toNumber();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.task_management.v1.ImportFormTranslationRequest.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ImportFormTranslationRequest.items: object expected");
                                message.items[i] = $root.palexy.task_management.v1.ImportFormTranslationItem.fromObject(object.items[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportFormTranslationRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @static
                     * @param {palexy.task_management.v1.ImportFormTranslationRequest} message ImportFormTranslationRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportFormTranslationRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formTranslationId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formTranslationId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formTranslationId != null && message.hasOwnProperty("formTranslationId"))
                            if (typeof message.formTranslationId === "number")
                                object.formTranslationId = options.longs === String ? String(message.formTranslationId) : message.formTranslationId;
                            else
                                object.formTranslationId = options.longs === String ? $util.Long.prototype.toString.call(message.formTranslationId) : options.longs === Number ? new $util.LongBits(message.formTranslationId.low >>> 0, message.formTranslationId.high >>> 0).toNumber() : message.formTranslationId;
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.task_management.v1.ImportFormTranslationItem.toObject(message.items[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ImportFormTranslationRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ImportFormTranslationRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportFormTranslationRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportFormTranslationRequest;
                })();
    
                v1.ImportFormTranslationResponse = (function() {
    
                    /**
                     * Properties of an ImportFormTranslationResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IImportFormTranslationResponse
                     * @property {Array.<palexy.task_management.v1.IFormTranslationItem>|null} [items] ImportFormTranslationResponse items
                     * @property {number|null} [updatedCount] ImportFormTranslationResponse updatedCount
                     * @property {number|null} [unmatchedCount] ImportFormTranslationResponse unmatchedCount
                     */
    
                    /**
                     * Constructs a new ImportFormTranslationResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an ImportFormTranslationResponse.
                     * @implements IImportFormTranslationResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IImportFormTranslationResponse=} [properties] Properties to set
                     */
                    function ImportFormTranslationResponse(properties) {
                        this.items = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ImportFormTranslationResponse items.
                     * @member {Array.<palexy.task_management.v1.IFormTranslationItem>} items
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @instance
                     */
                    ImportFormTranslationResponse.prototype.items = $util.emptyArray;
    
                    /**
                     * ImportFormTranslationResponse updatedCount.
                     * @member {number} updatedCount
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @instance
                     */
                    ImportFormTranslationResponse.prototype.updatedCount = 0;
    
                    /**
                     * ImportFormTranslationResponse unmatchedCount.
                     * @member {number} unmatchedCount
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @instance
                     */
                    ImportFormTranslationResponse.prototype.unmatchedCount = 0;
    
                    /**
                     * Creates a new ImportFormTranslationResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ImportFormTranslationResponse} ImportFormTranslationResponse instance
                     */
                    ImportFormTranslationResponse.create = function create(properties) {
                        return new ImportFormTranslationResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationResponse message. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationResponse} message ImportFormTranslationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.items != null && message.items.length)
                            for (var i = 0; i < message.items.length; ++i)
                                $root.palexy.task_management.v1.FormTranslationItem.encode(message.items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updatedCount != null && Object.hasOwnProperty.call(message, "updatedCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.updatedCount);
                        if (message.unmatchedCount != null && Object.hasOwnProperty.call(message, "unmatchedCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.unmatchedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ImportFormTranslationResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ImportFormTranslationResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.IImportFormTranslationResponse} message ImportFormTranslationResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ImportFormTranslationResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ImportFormTranslationResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ImportFormTranslationResponse} ImportFormTranslationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ImportFormTranslationResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.items && message.items.length))
                                    message.items = [];
                                message.items.push($root.palexy.task_management.v1.FormTranslationItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.updatedCount = reader.int32();
                                break;
                            case 3:
                                message.unmatchedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ImportFormTranslationResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ImportFormTranslationResponse} ImportFormTranslationResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ImportFormTranslationResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ImportFormTranslationResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ImportFormTranslationResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.items != null && message.hasOwnProperty("items")) {
                            if (!Array.isArray(message.items))
                                return "items: array expected";
                            for (var i = 0; i < message.items.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormTranslationItem.verify(message.items[i]);
                                if (error)
                                    return "items." + error;
                            }
                        }
                        if (message.updatedCount != null && message.hasOwnProperty("updatedCount"))
                            if (!$util.isInteger(message.updatedCount))
                                return "updatedCount: integer expected";
                        if (message.unmatchedCount != null && message.hasOwnProperty("unmatchedCount"))
                            if (!$util.isInteger(message.unmatchedCount))
                                return "unmatchedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ImportFormTranslationResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ImportFormTranslationResponse} ImportFormTranslationResponse
                     */
                    ImportFormTranslationResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ImportFormTranslationResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ImportFormTranslationResponse();
                        if (object.items) {
                            if (!Array.isArray(object.items))
                                throw TypeError(".palexy.task_management.v1.ImportFormTranslationResponse.items: array expected");
                            message.items = [];
                            for (var i = 0; i < object.items.length; ++i) {
                                if (typeof object.items[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ImportFormTranslationResponse.items: object expected");
                                message.items[i] = $root.palexy.task_management.v1.FormTranslationItem.fromObject(object.items[i]);
                            }
                        }
                        if (object.updatedCount != null)
                            message.updatedCount = object.updatedCount | 0;
                        if (object.unmatchedCount != null)
                            message.unmatchedCount = object.unmatchedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ImportFormTranslationResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @static
                     * @param {palexy.task_management.v1.ImportFormTranslationResponse} message ImportFormTranslationResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ImportFormTranslationResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.items = [];
                        if (options.defaults) {
                            object.updatedCount = 0;
                            object.unmatchedCount = 0;
                        }
                        if (message.items && message.items.length) {
                            object.items = [];
                            for (var j = 0; j < message.items.length; ++j)
                                object.items[j] = $root.palexy.task_management.v1.FormTranslationItem.toObject(message.items[j], options);
                        }
                        if (message.updatedCount != null && message.hasOwnProperty("updatedCount"))
                            object.updatedCount = message.updatedCount;
                        if (message.unmatchedCount != null && message.hasOwnProperty("unmatchedCount"))
                            object.unmatchedCount = message.unmatchedCount;
                        return object;
                    };
    
                    /**
                     * Converts this ImportFormTranslationResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ImportFormTranslationResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ImportFormTranslationResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ImportFormTranslationResponse;
                })();
    
                v1.CreateFormSubmissionRequest = (function() {
    
                    /**
                     * Properties of a CreateFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormSubmissionRequest
                     * @property {number|null} [formId] CreateFormSubmissionRequest formId
                     * @property {palexy.task_management.v1.IFormSubmission|null} [submission] CreateFormSubmissionRequest submission
                     * @property {boolean|null} [anonymous] CreateFormSubmissionRequest anonymous
                     * @property {number|null} [distributionContactListId] CreateFormSubmissionRequest distributionContactListId
                     * @property {number|null} [recipientId] CreateFormSubmissionRequest recipientId
                     * @property {string|null} [distributionLinkId] CreateFormSubmissionRequest distributionLinkId
                     * @property {Object.<string,string>|null} [linkParameters] CreateFormSubmissionRequest linkParameters
                     */
    
                    /**
                     * Constructs a new CreateFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormSubmissionRequest.
                     * @implements ICreateFormSubmissionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest=} [properties] Properties to set
                     */
                    function CreateFormSubmissionRequest(properties) {
                        this.linkParameters = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormSubmissionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormSubmissionRequest submission.
                     * @member {palexy.task_management.v1.IFormSubmission|null|undefined} submission
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.submission = null;
    
                    /**
                     * CreateFormSubmissionRequest anonymous.
                     * @member {boolean} anonymous
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.anonymous = false;
    
                    /**
                     * CreateFormSubmissionRequest distributionContactListId.
                     * @member {number} distributionContactListId
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.distributionContactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormSubmissionRequest recipientId.
                     * @member {number} recipientId
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.recipientId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormSubmissionRequest distributionLinkId.
                     * @member {string} distributionLinkId
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.distributionLinkId = "";
    
                    /**
                     * CreateFormSubmissionRequest linkParameters.
                     * @member {Object.<string,string>} linkParameters
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     */
                    CreateFormSubmissionRequest.prototype.linkParameters = $util.emptyObject;
    
                    /**
                     * Creates a new CreateFormSubmissionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormSubmissionRequest} CreateFormSubmissionRequest instance
                     */
                    CreateFormSubmissionRequest.create = function create(properties) {
                        return new CreateFormSubmissionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormSubmissionRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormSubmissionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest} message CreateFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormSubmissionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submission != null && Object.hasOwnProperty.call(message, "submission"))
                            $root.palexy.task_management.v1.FormSubmission.encode(message.submission, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.anonymous != null && Object.hasOwnProperty.call(message, "anonymous"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.anonymous);
                        if (message.distributionContactListId != null && Object.hasOwnProperty.call(message, "distributionContactListId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.distributionContactListId);
                        if (message.recipientId != null && Object.hasOwnProperty.call(message, "recipientId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.recipientId);
                        if (message.distributionLinkId != null && Object.hasOwnProperty.call(message, "distributionLinkId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.distributionLinkId);
                        if (message.linkParameters != null && Object.hasOwnProperty.call(message, "linkParameters"))
                            for (var keys = Object.keys(message.linkParameters), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 7, wireType 2 =*/58).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.linkParameters[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormSubmissionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormSubmissionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormSubmissionRequest} message CreateFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormSubmissionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormSubmissionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormSubmissionRequest} CreateFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormSubmissionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormSubmissionRequest(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submission = $root.palexy.task_management.v1.FormSubmission.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.anonymous = reader.bool();
                                break;
                            case 4:
                                message.distributionContactListId = reader.int64();
                                break;
                            case 5:
                                message.recipientId = reader.int64();
                                break;
                            case 6:
                                message.distributionLinkId = reader.string();
                                break;
                            case 7:
                                if (message.linkParameters === $util.emptyObject)
                                    message.linkParameters = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.linkParameters[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormSubmissionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormSubmissionRequest} CreateFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormSubmissionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormSubmissionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormSubmissionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submission != null && message.hasOwnProperty("submission")) {
                            var error = $root.palexy.task_management.v1.FormSubmission.verify(message.submission);
                            if (error)
                                return "submission." + error;
                        }
                        if (message.anonymous != null && message.hasOwnProperty("anonymous"))
                            if (typeof message.anonymous !== "boolean")
                                return "anonymous: boolean expected";
                        if (message.distributionContactListId != null && message.hasOwnProperty("distributionContactListId"))
                            if (!$util.isInteger(message.distributionContactListId) && !(message.distributionContactListId && $util.isInteger(message.distributionContactListId.low) && $util.isInteger(message.distributionContactListId.high)))
                                return "distributionContactListId: integer|Long expected";
                        if (message.recipientId != null && message.hasOwnProperty("recipientId"))
                            if (!$util.isInteger(message.recipientId) && !(message.recipientId && $util.isInteger(message.recipientId.low) && $util.isInteger(message.recipientId.high)))
                                return "recipientId: integer|Long expected";
                        if (message.distributionLinkId != null && message.hasOwnProperty("distributionLinkId"))
                            if (!$util.isString(message.distributionLinkId))
                                return "distributionLinkId: string expected";
                        if (message.linkParameters != null && message.hasOwnProperty("linkParameters")) {
                            if (!$util.isObject(message.linkParameters))
                                return "linkParameters: object expected";
                            var key = Object.keys(message.linkParameters);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.linkParameters[key[i]]))
                                    return "linkParameters: string{k:string} expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormSubmissionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormSubmissionRequest} CreateFormSubmissionRequest
                     */
                    CreateFormSubmissionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormSubmissionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormSubmissionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submission != null) {
                            if (typeof object.submission !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormSubmissionRequest.submission: object expected");
                            message.submission = $root.palexy.task_management.v1.FormSubmission.fromObject(object.submission);
                        }
                        if (object.anonymous != null)
                            message.anonymous = Boolean(object.anonymous);
                        if (object.distributionContactListId != null)
                            if ($util.Long)
                                (message.distributionContactListId = $util.Long.fromValue(object.distributionContactListId)).unsigned = false;
                            else if (typeof object.distributionContactListId === "string")
                                message.distributionContactListId = parseInt(object.distributionContactListId, 10);
                            else if (typeof object.distributionContactListId === "number")
                                message.distributionContactListId = object.distributionContactListId;
                            else if (typeof object.distributionContactListId === "object")
                                message.distributionContactListId = new $util.LongBits(object.distributionContactListId.low >>> 0, object.distributionContactListId.high >>> 0).toNumber();
                        if (object.recipientId != null)
                            if ($util.Long)
                                (message.recipientId = $util.Long.fromValue(object.recipientId)).unsigned = false;
                            else if (typeof object.recipientId === "string")
                                message.recipientId = parseInt(object.recipientId, 10);
                            else if (typeof object.recipientId === "number")
                                message.recipientId = object.recipientId;
                            else if (typeof object.recipientId === "object")
                                message.recipientId = new $util.LongBits(object.recipientId.low >>> 0, object.recipientId.high >>> 0).toNumber();
                        if (object.distributionLinkId != null)
                            message.distributionLinkId = String(object.distributionLinkId);
                        if (object.linkParameters) {
                            if (typeof object.linkParameters !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormSubmissionRequest.linkParameters: object expected");
                            message.linkParameters = {};
                            for (var keys = Object.keys(object.linkParameters), i = 0; i < keys.length; ++i)
                                message.linkParameters[keys[i]] = String(object.linkParameters[keys[i]]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormSubmissionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormSubmissionRequest} message CreateFormSubmissionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormSubmissionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.linkParameters = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.submission = null;
                            object.anonymous = false;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.distributionContactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.distributionContactListId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.recipientId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.recipientId = options.longs === String ? "0" : 0;
                            object.distributionLinkId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submission != null && message.hasOwnProperty("submission"))
                            object.submission = $root.palexy.task_management.v1.FormSubmission.toObject(message.submission, options);
                        if (message.anonymous != null && message.hasOwnProperty("anonymous"))
                            object.anonymous = message.anonymous;
                        if (message.distributionContactListId != null && message.hasOwnProperty("distributionContactListId"))
                            if (typeof message.distributionContactListId === "number")
                                object.distributionContactListId = options.longs === String ? String(message.distributionContactListId) : message.distributionContactListId;
                            else
                                object.distributionContactListId = options.longs === String ? $util.Long.prototype.toString.call(message.distributionContactListId) : options.longs === Number ? new $util.LongBits(message.distributionContactListId.low >>> 0, message.distributionContactListId.high >>> 0).toNumber() : message.distributionContactListId;
                        if (message.recipientId != null && message.hasOwnProperty("recipientId"))
                            if (typeof message.recipientId === "number")
                                object.recipientId = options.longs === String ? String(message.recipientId) : message.recipientId;
                            else
                                object.recipientId = options.longs === String ? $util.Long.prototype.toString.call(message.recipientId) : options.longs === Number ? new $util.LongBits(message.recipientId.low >>> 0, message.recipientId.high >>> 0).toNumber() : message.recipientId;
                        if (message.distributionLinkId != null && message.hasOwnProperty("distributionLinkId"))
                            object.distributionLinkId = message.distributionLinkId;
                        var keys2;
                        if (message.linkParameters && (keys2 = Object.keys(message.linkParameters)).length) {
                            object.linkParameters = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.linkParameters[keys2[j]] = message.linkParameters[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormSubmissionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormSubmissionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormSubmissionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormSubmissionRequest;
                })();
    
                v1.ValidateRecipientAccessRequest = (function() {
    
                    /**
                     * Properties of a ValidateRecipientAccessRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IValidateRecipientAccessRequest
                     * @property {number|null} [formId] ValidateRecipientAccessRequest formId
                     * @property {number|null} [distributionContactListId] ValidateRecipientAccessRequest distributionContactListId
                     * @property {number|null} [recipientId] ValidateRecipientAccessRequest recipientId
                     * @property {string|null} [distributionLinkId] ValidateRecipientAccessRequest distributionLinkId
                     */
    
                    /**
                     * Constructs a new ValidateRecipientAccessRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ValidateRecipientAccessRequest.
                     * @implements IValidateRecipientAccessRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest=} [properties] Properties to set
                     */
                    function ValidateRecipientAccessRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ValidateRecipientAccessRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @instance
                     */
                    ValidateRecipientAccessRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ValidateRecipientAccessRequest distributionContactListId.
                     * @member {number} distributionContactListId
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @instance
                     */
                    ValidateRecipientAccessRequest.prototype.distributionContactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ValidateRecipientAccessRequest recipientId.
                     * @member {number} recipientId
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @instance
                     */
                    ValidateRecipientAccessRequest.prototype.recipientId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ValidateRecipientAccessRequest distributionLinkId.
                     * @member {string} distributionLinkId
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @instance
                     */
                    ValidateRecipientAccessRequest.prototype.distributionLinkId = "";
    
                    /**
                     * Creates a new ValidateRecipientAccessRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ValidateRecipientAccessRequest} ValidateRecipientAccessRequest instance
                     */
                    ValidateRecipientAccessRequest.create = function create(properties) {
                        return new ValidateRecipientAccessRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ValidateRecipientAccessRequest message. Does not implicitly {@link palexy.task_management.v1.ValidateRecipientAccessRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest} message ValidateRecipientAccessRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateRecipientAccessRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.distributionContactListId != null && Object.hasOwnProperty.call(message, "distributionContactListId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.distributionContactListId);
                        if (message.recipientId != null && Object.hasOwnProperty.call(message, "recipientId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.recipientId);
                        if (message.distributionLinkId != null && Object.hasOwnProperty.call(message, "distributionLinkId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.distributionLinkId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ValidateRecipientAccessRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ValidateRecipientAccessRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {palexy.task_management.v1.IValidateRecipientAccessRequest} message ValidateRecipientAccessRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValidateRecipientAccessRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ValidateRecipientAccessRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ValidateRecipientAccessRequest} ValidateRecipientAccessRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateRecipientAccessRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ValidateRecipientAccessRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.distributionContactListId = reader.int64();
                                break;
                            case 3:
                                message.recipientId = reader.int64();
                                break;
                            case 4:
                                message.distributionLinkId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ValidateRecipientAccessRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ValidateRecipientAccessRequest} ValidateRecipientAccessRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValidateRecipientAccessRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ValidateRecipientAccessRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ValidateRecipientAccessRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.distributionContactListId != null && message.hasOwnProperty("distributionContactListId"))
                            if (!$util.isInteger(message.distributionContactListId) && !(message.distributionContactListId && $util.isInteger(message.distributionContactListId.low) && $util.isInteger(message.distributionContactListId.high)))
                                return "distributionContactListId: integer|Long expected";
                        if (message.recipientId != null && message.hasOwnProperty("recipientId"))
                            if (!$util.isInteger(message.recipientId) && !(message.recipientId && $util.isInteger(message.recipientId.low) && $util.isInteger(message.recipientId.high)))
                                return "recipientId: integer|Long expected";
                        if (message.distributionLinkId != null && message.hasOwnProperty("distributionLinkId"))
                            if (!$util.isString(message.distributionLinkId))
                                return "distributionLinkId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ValidateRecipientAccessRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ValidateRecipientAccessRequest} ValidateRecipientAccessRequest
                     */
                    ValidateRecipientAccessRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ValidateRecipientAccessRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ValidateRecipientAccessRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.distributionContactListId != null)
                            if ($util.Long)
                                (message.distributionContactListId = $util.Long.fromValue(object.distributionContactListId)).unsigned = false;
                            else if (typeof object.distributionContactListId === "string")
                                message.distributionContactListId = parseInt(object.distributionContactListId, 10);
                            else if (typeof object.distributionContactListId === "number")
                                message.distributionContactListId = object.distributionContactListId;
                            else if (typeof object.distributionContactListId === "object")
                                message.distributionContactListId = new $util.LongBits(object.distributionContactListId.low >>> 0, object.distributionContactListId.high >>> 0).toNumber();
                        if (object.recipientId != null)
                            if ($util.Long)
                                (message.recipientId = $util.Long.fromValue(object.recipientId)).unsigned = false;
                            else if (typeof object.recipientId === "string")
                                message.recipientId = parseInt(object.recipientId, 10);
                            else if (typeof object.recipientId === "number")
                                message.recipientId = object.recipientId;
                            else if (typeof object.recipientId === "object")
                                message.recipientId = new $util.LongBits(object.recipientId.low >>> 0, object.recipientId.high >>> 0).toNumber();
                        if (object.distributionLinkId != null)
                            message.distributionLinkId = String(object.distributionLinkId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ValidateRecipientAccessRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @static
                     * @param {palexy.task_management.v1.ValidateRecipientAccessRequest} message ValidateRecipientAccessRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ValidateRecipientAccessRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.distributionContactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.distributionContactListId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.recipientId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.recipientId = options.longs === String ? "0" : 0;
                            object.distributionLinkId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.distributionContactListId != null && message.hasOwnProperty("distributionContactListId"))
                            if (typeof message.distributionContactListId === "number")
                                object.distributionContactListId = options.longs === String ? String(message.distributionContactListId) : message.distributionContactListId;
                            else
                                object.distributionContactListId = options.longs === String ? $util.Long.prototype.toString.call(message.distributionContactListId) : options.longs === Number ? new $util.LongBits(message.distributionContactListId.low >>> 0, message.distributionContactListId.high >>> 0).toNumber() : message.distributionContactListId;
                        if (message.recipientId != null && message.hasOwnProperty("recipientId"))
                            if (typeof message.recipientId === "number")
                                object.recipientId = options.longs === String ? String(message.recipientId) : message.recipientId;
                            else
                                object.recipientId = options.longs === String ? $util.Long.prototype.toString.call(message.recipientId) : options.longs === Number ? new $util.LongBits(message.recipientId.low >>> 0, message.recipientId.high >>> 0).toNumber() : message.recipientId;
                        if (message.distributionLinkId != null && message.hasOwnProperty("distributionLinkId"))
                            object.distributionLinkId = message.distributionLinkId;
                        return object;
                    };
    
                    /**
                     * Converts this ValidateRecipientAccessRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ValidateRecipientAccessRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ValidateRecipientAccessRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ValidateRecipientAccessRequest;
                })();
    
                v1.FormSubmissionFilter = (function() {
    
                    /**
                     * Properties of a FormSubmissionFilter.
                     * @memberof palexy.task_management.v1
                     * @interface IFormSubmissionFilter
                     * @property {string|null} [startCreatedDateId] FormSubmissionFilter startCreatedDateId
                     * @property {string|null} [endCreatedDateId] FormSubmissionFilter endCreatedDateId
                     */
    
                    /**
                     * Constructs a new FormSubmissionFilter.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormSubmissionFilter.
                     * @implements IFormSubmissionFilter
                     * @constructor
                     * @param {palexy.task_management.v1.IFormSubmissionFilter=} [properties] Properties to set
                     */
                    function FormSubmissionFilter(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormSubmissionFilter startCreatedDateId.
                     * @member {string} startCreatedDateId
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @instance
                     */
                    FormSubmissionFilter.prototype.startCreatedDateId = "";
    
                    /**
                     * FormSubmissionFilter endCreatedDateId.
                     * @member {string} endCreatedDateId
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @instance
                     */
                    FormSubmissionFilter.prototype.endCreatedDateId = "";
    
                    /**
                     * Creates a new FormSubmissionFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionFilter=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormSubmissionFilter} FormSubmissionFilter instance
                     */
                    FormSubmissionFilter.create = function create(properties) {
                        return new FormSubmissionFilter(properties);
                    };
    
                    /**
                     * Encodes the specified FormSubmissionFilter message. Does not implicitly {@link palexy.task_management.v1.FormSubmissionFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionFilter} message FormSubmissionFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.startCreatedDateId != null && Object.hasOwnProperty.call(message, "startCreatedDateId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.startCreatedDateId);
                        if (message.endCreatedDateId != null && Object.hasOwnProperty.call(message, "endCreatedDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.endCreatedDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormSubmissionFilter message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormSubmissionFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionFilter} message FormSubmissionFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormSubmissionFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormSubmissionFilter} FormSubmissionFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormSubmissionFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.startCreatedDateId = reader.string();
                                break;
                            case 2:
                                message.endCreatedDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormSubmissionFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormSubmissionFilter} FormSubmissionFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormSubmissionFilter message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormSubmissionFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.startCreatedDateId != null && message.hasOwnProperty("startCreatedDateId"))
                            if (!$util.isString(message.startCreatedDateId))
                                return "startCreatedDateId: string expected";
                        if (message.endCreatedDateId != null && message.hasOwnProperty("endCreatedDateId"))
                            if (!$util.isString(message.endCreatedDateId))
                                return "endCreatedDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormSubmissionFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormSubmissionFilter} FormSubmissionFilter
                     */
                    FormSubmissionFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormSubmissionFilter)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormSubmissionFilter();
                        if (object.startCreatedDateId != null)
                            message.startCreatedDateId = String(object.startCreatedDateId);
                        if (object.endCreatedDateId != null)
                            message.endCreatedDateId = String(object.endCreatedDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormSubmissionFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @static
                     * @param {palexy.task_management.v1.FormSubmissionFilter} message FormSubmissionFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormSubmissionFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.startCreatedDateId = "";
                            object.endCreatedDateId = "";
                        }
                        if (message.startCreatedDateId != null && message.hasOwnProperty("startCreatedDateId"))
                            object.startCreatedDateId = message.startCreatedDateId;
                        if (message.endCreatedDateId != null && message.hasOwnProperty("endCreatedDateId"))
                            object.endCreatedDateId = message.endCreatedDateId;
                        return object;
                    };
    
                    /**
                     * Converts this FormSubmissionFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormSubmissionFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormSubmissionFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormSubmissionFilter;
                })();
    
                v1.ListFormSubmissionsRequest = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionsRequest
                     * @property {number|null} [formId] ListFormSubmissionsRequest formId
                     * @property {number|null} [pageSize] ListFormSubmissionsRequest pageSize
                     * @property {string|null} [pageToken] ListFormSubmissionsRequest pageToken
                     * @property {boolean|null} [includeValues] ListFormSubmissionsRequest includeValues
                     * @property {palexy.task_management.v1.IFormSubmissionFilter|null} [filter] ListFormSubmissionsRequest filter
                     * @property {boolean|null} [includeAttributeValues] ListFormSubmissionsRequest includeAttributeValues
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionsRequest.
                     * @implements IListFormSubmissionsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest=} [properties] Properties to set
                     */
                    function ListFormSubmissionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormSubmissionsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormSubmissionsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormSubmissionsRequest includeValues.
                     * @member {boolean} includeValues
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.includeValues = false;
    
                    /**
                     * ListFormSubmissionsRequest filter.
                     * @member {palexy.task_management.v1.IFormSubmissionFilter|null|undefined} filter
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.filter = null;
    
                    /**
                     * ListFormSubmissionsRequest includeAttributeValues.
                     * @member {boolean} includeAttributeValues
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     */
                    ListFormSubmissionsRequest.prototype.includeAttributeValues = false;
    
                    /**
                     * Creates a new ListFormSubmissionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionsRequest} ListFormSubmissionsRequest instance
                     */
                    ListFormSubmissionsRequest.create = function create(properties) {
                        return new ListFormSubmissionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest} message ListFormSubmissionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        if (message.includeValues != null && Object.hasOwnProperty.call(message, "includeValues"))
                            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.includeValues);
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.task_management.v1.FormSubmissionFilter.encode(message.filter, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.includeAttributeValues != null && Object.hasOwnProperty.call(message, "includeAttributeValues"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.includeAttributeValues);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsRequest} message ListFormSubmissionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionsRequest} ListFormSubmissionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            case 4:
                                message.includeValues = reader.bool();
                                break;
                            case 5:
                                message.filter = $root.palexy.task_management.v1.FormSubmissionFilter.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.includeAttributeValues = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionsRequest} ListFormSubmissionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.includeValues != null && message.hasOwnProperty("includeValues"))
                            if (typeof message.includeValues !== "boolean")
                                return "includeValues: boolean expected";
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.task_management.v1.FormSubmissionFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.includeAttributeValues != null && message.hasOwnProperty("includeAttributeValues"))
                            if (typeof message.includeAttributeValues !== "boolean")
                                return "includeAttributeValues: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionsRequest} ListFormSubmissionsRequest
                     */
                    ListFormSubmissionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.includeValues != null)
                            message.includeValues = Boolean(object.includeValues);
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionsRequest.filter: object expected");
                            message.filter = $root.palexy.task_management.v1.FormSubmissionFilter.fromObject(object.filter);
                        }
                        if (object.includeAttributeValues != null)
                            message.includeAttributeValues = Boolean(object.includeAttributeValues);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionsRequest} message ListFormSubmissionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeValues = false;
                            object.filter = null;
                            object.includeAttributeValues = false;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.includeValues != null && message.hasOwnProperty("includeValues"))
                            object.includeValues = message.includeValues;
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.task_management.v1.FormSubmissionFilter.toObject(message.filter, options);
                        if (message.includeAttributeValues != null && message.hasOwnProperty("includeAttributeValues"))
                            object.includeAttributeValues = message.includeAttributeValues;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionsRequest;
                })();
    
                v1.ListFormSubmissionValuesRequest = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionValuesRequest
                     * @property {number|null} [formId] ListFormSubmissionValuesRequest formId
                     * @property {Array.<number>|null} [formFieldIds] ListFormSubmissionValuesRequest formFieldIds
                     * @property {number|null} [pageSize] ListFormSubmissionValuesRequest pageSize
                     * @property {string|null} [pageToken] ListFormSubmissionValuesRequest pageToken
                     * @property {Array.<string>|null} [internalQuestionIds] ListFormSubmissionValuesRequest internalQuestionIds
                     * @property {string|null} [startDateId] ListFormSubmissionValuesRequest startDateId
                     * @property {string|null} [endDateId] ListFormSubmissionValuesRequest endDateId
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionValuesRequest.
                     * @implements IListFormSubmissionValuesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest=} [properties] Properties to set
                     */
                    function ListFormSubmissionValuesRequest(properties) {
                        this.formFieldIds = [];
                        this.internalQuestionIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionValuesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormSubmissionValuesRequest formFieldIds.
                     * @member {Array.<number>} formFieldIds
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.formFieldIds = $util.emptyArray;
    
                    /**
                     * ListFormSubmissionValuesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormSubmissionValuesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormSubmissionValuesRequest internalQuestionIds.
                     * @member {Array.<string>} internalQuestionIds
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.internalQuestionIds = $util.emptyArray;
    
                    /**
                     * ListFormSubmissionValuesRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.startDateId = "";
    
                    /**
                     * ListFormSubmissionValuesRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     */
                    ListFormSubmissionValuesRequest.prototype.endDateId = "";
    
                    /**
                     * Creates a new ListFormSubmissionValuesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesRequest} ListFormSubmissionValuesRequest instance
                     */
                    ListFormSubmissionValuesRequest.create = function create(properties) {
                        return new ListFormSubmissionValuesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionValuesRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionValuesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest} message ListFormSubmissionValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionValuesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formFieldIds != null && message.formFieldIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.formFieldIds.length; ++i)
                                writer.int64(message.formFieldIds[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.internalQuestionIds != null && message.internalQuestionIds.length)
                            for (var i = 0; i < message.internalQuestionIds.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.internalQuestionIds[i]);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionValuesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionValuesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesRequest} message ListFormSubmissionValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionValuesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionValuesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesRequest} ListFormSubmissionValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionValuesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionValuesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                if (!(message.formFieldIds && message.formFieldIds.length))
                                    message.formFieldIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.formFieldIds.push(reader.int64());
                                } else
                                    message.formFieldIds.push(reader.int64());
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 5:
                                if (!(message.internalQuestionIds && message.internalQuestionIds.length))
                                    message.internalQuestionIds = [];
                                message.internalQuestionIds.push(reader.string());
                                break;
                            case 6:
                                message.startDateId = reader.string();
                                break;
                            case 7:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionValuesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesRequest} ListFormSubmissionValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionValuesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionValuesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionValuesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formFieldIds != null && message.hasOwnProperty("formFieldIds")) {
                            if (!Array.isArray(message.formFieldIds))
                                return "formFieldIds: array expected";
                            for (var i = 0; i < message.formFieldIds.length; ++i)
                                if (!$util.isInteger(message.formFieldIds[i]) && !(message.formFieldIds[i] && $util.isInteger(message.formFieldIds[i].low) && $util.isInteger(message.formFieldIds[i].high)))
                                    return "formFieldIds: integer|Long[] expected";
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.internalQuestionIds != null && message.hasOwnProperty("internalQuestionIds")) {
                            if (!Array.isArray(message.internalQuestionIds))
                                return "internalQuestionIds: array expected";
                            for (var i = 0; i < message.internalQuestionIds.length; ++i)
                                if (!$util.isString(message.internalQuestionIds[i]))
                                    return "internalQuestionIds: string[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionValuesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesRequest} ListFormSubmissionValuesRequest
                     */
                    ListFormSubmissionValuesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionValuesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionValuesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formFieldIds) {
                            if (!Array.isArray(object.formFieldIds))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionValuesRequest.formFieldIds: array expected");
                            message.formFieldIds = [];
                            for (var i = 0; i < object.formFieldIds.length; ++i)
                                if ($util.Long)
                                    (message.formFieldIds[i] = $util.Long.fromValue(object.formFieldIds[i])).unsigned = false;
                                else if (typeof object.formFieldIds[i] === "string")
                                    message.formFieldIds[i] = parseInt(object.formFieldIds[i], 10);
                                else if (typeof object.formFieldIds[i] === "number")
                                    message.formFieldIds[i] = object.formFieldIds[i];
                                else if (typeof object.formFieldIds[i] === "object")
                                    message.formFieldIds[i] = new $util.LongBits(object.formFieldIds[i].low >>> 0, object.formFieldIds[i].high >>> 0).toNumber();
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.internalQuestionIds) {
                            if (!Array.isArray(object.internalQuestionIds))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionValuesRequest.internalQuestionIds: array expected");
                            message.internalQuestionIds = [];
                            for (var i = 0; i < object.internalQuestionIds.length; ++i)
                                message.internalQuestionIds[i] = String(object.internalQuestionIds[i]);
                        }
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionValuesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionValuesRequest} message ListFormSubmissionValuesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionValuesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.formFieldIds = [];
                            object.internalQuestionIds = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formFieldIds && message.formFieldIds.length) {
                            object.formFieldIds = [];
                            for (var j = 0; j < message.formFieldIds.length; ++j)
                                if (typeof message.formFieldIds[j] === "number")
                                    object.formFieldIds[j] = options.longs === String ? String(message.formFieldIds[j]) : message.formFieldIds[j];
                                else
                                    object.formFieldIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldIds[j]) : options.longs === Number ? new $util.LongBits(message.formFieldIds[j].low >>> 0, message.formFieldIds[j].high >>> 0).toNumber() : message.formFieldIds[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.internalQuestionIds && message.internalQuestionIds.length) {
                            object.internalQuestionIds = [];
                            for (var j = 0; j < message.internalQuestionIds.length; ++j)
                                object.internalQuestionIds[j] = message.internalQuestionIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionValuesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionValuesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionValuesRequest;
                })();
    
                v1.ListFormSubmissionValuesResponse = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionValuesResponse
                     * @property {Array.<palexy.task_management.v1.IFormSubmissionValue>|null} [formSubmissionValues] ListFormSubmissionValuesResponse formSubmissionValues
                     * @property {number|null} [totalElements] ListFormSubmissionValuesResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormSubmissionValuesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionValuesResponse.
                     * @implements IListFormSubmissionValuesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesResponse=} [properties] Properties to set
                     */
                    function ListFormSubmissionValuesResponse(properties) {
                        this.formSubmissionValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionValuesResponse formSubmissionValues.
                     * @member {Array.<palexy.task_management.v1.IFormSubmissionValue>} formSubmissionValues
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @instance
                     */
                    ListFormSubmissionValuesResponse.prototype.formSubmissionValues = $util.emptyArray;
    
                    /**
                     * ListFormSubmissionValuesResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @instance
                     */
                    ListFormSubmissionValuesResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormSubmissionValuesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @instance
                     */
                    ListFormSubmissionValuesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormSubmissionValuesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesResponse} ListFormSubmissionValuesResponse instance
                     */
                    ListFormSubmissionValuesResponse.create = function create(properties) {
                        return new ListFormSubmissionValuesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionValuesResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionValuesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesResponse} message ListFormSubmissionValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionValuesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formSubmissionValues != null && message.formSubmissionValues.length)
                            for (var i = 0; i < message.formSubmissionValues.length; ++i)
                                $root.palexy.task_management.v1.FormSubmissionValue.encode(message.formSubmissionValues[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionValuesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionValuesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionValuesResponse} message ListFormSubmissionValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionValuesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionValuesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesResponse} ListFormSubmissionValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionValuesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionValuesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.formSubmissionValues && message.formSubmissionValues.length))
                                    message.formSubmissionValues = [];
                                message.formSubmissionValues.push($root.palexy.task_management.v1.FormSubmissionValue.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionValuesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesResponse} ListFormSubmissionValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionValuesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionValuesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionValuesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formSubmissionValues != null && message.hasOwnProperty("formSubmissionValues")) {
                            if (!Array.isArray(message.formSubmissionValues))
                                return "formSubmissionValues: array expected";
                            for (var i = 0; i < message.formSubmissionValues.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmissionValue.verify(message.formSubmissionValues[i]);
                                if (error)
                                    return "formSubmissionValues." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionValuesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionValuesResponse} ListFormSubmissionValuesResponse
                     */
                    ListFormSubmissionValuesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionValuesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionValuesResponse();
                        if (object.formSubmissionValues) {
                            if (!Array.isArray(object.formSubmissionValues))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionValuesResponse.formSubmissionValues: array expected");
                            message.formSubmissionValues = [];
                            for (var i = 0; i < object.formSubmissionValues.length; ++i) {
                                if (typeof object.formSubmissionValues[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormSubmissionValuesResponse.formSubmissionValues: object expected");
                                message.formSubmissionValues[i] = $root.palexy.task_management.v1.FormSubmissionValue.fromObject(object.formSubmissionValues[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionValuesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionValuesResponse} message ListFormSubmissionValuesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionValuesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.formSubmissionValues = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.formSubmissionValues && message.formSubmissionValues.length) {
                            object.formSubmissionValues = [];
                            for (var j = 0; j < message.formSubmissionValues.length; ++j)
                                object.formSubmissionValues[j] = $root.palexy.task_management.v1.FormSubmissionValue.toObject(message.formSubmissionValues[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionValuesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionValuesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionValuesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionValuesResponse;
                })();
    
                v1.ListFormSubmissionsResponse = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionsResponse
                     * @property {Array.<palexy.task_management.v1.IFormSubmission>|null} [submissions] ListFormSubmissionsResponse submissions
                     * @property {number|null} [totalElements] ListFormSubmissionsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormSubmissionsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionsResponse.
                     * @implements IListFormSubmissionsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionsResponse=} [properties] Properties to set
                     */
                    function ListFormSubmissionsResponse(properties) {
                        this.submissions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionsResponse submissions.
                     * @member {Array.<palexy.task_management.v1.IFormSubmission>} submissions
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @instance
                     */
                    ListFormSubmissionsResponse.prototype.submissions = $util.emptyArray;
    
                    /**
                     * ListFormSubmissionsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @instance
                     */
                    ListFormSubmissionsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormSubmissionsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @instance
                     */
                    ListFormSubmissionsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormSubmissionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionsResponse} ListFormSubmissionsResponse instance
                     */
                    ListFormSubmissionsResponse.create = function create(properties) {
                        return new ListFormSubmissionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsResponse} message ListFormSubmissionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.submissions != null && message.submissions.length)
                            for (var i = 0; i < message.submissions.length; ++i)
                                $root.palexy.task_management.v1.FormSubmission.encode(message.submissions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionsResponse} message ListFormSubmissionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionsResponse} ListFormSubmissionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.submissions && message.submissions.length))
                                    message.submissions = [];
                                message.submissions.push($root.palexy.task_management.v1.FormSubmission.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionsResponse} ListFormSubmissionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.submissions != null && message.hasOwnProperty("submissions")) {
                            if (!Array.isArray(message.submissions))
                                return "submissions: array expected";
                            for (var i = 0; i < message.submissions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmission.verify(message.submissions[i]);
                                if (error)
                                    return "submissions." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionsResponse} ListFormSubmissionsResponse
                     */
                    ListFormSubmissionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionsResponse();
                        if (object.submissions) {
                            if (!Array.isArray(object.submissions))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionsResponse.submissions: array expected");
                            message.submissions = [];
                            for (var i = 0; i < object.submissions.length; ++i) {
                                if (typeof object.submissions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormSubmissionsResponse.submissions: object expected");
                                message.submissions[i] = $root.palexy.task_management.v1.FormSubmission.fromObject(object.submissions[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionsResponse} message ListFormSubmissionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.submissions = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.submissions && message.submissions.length) {
                            object.submissions = [];
                            for (var j = 0; j < message.submissions.length; ++j)
                                object.submissions[j] = $root.palexy.task_management.v1.FormSubmission.toObject(message.submissions[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionsResponse;
                })();
    
                v1.GetFormSubmissionRequest = (function() {
    
                    /**
                     * Properties of a GetFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormSubmissionRequest
                     * @property {number|null} [formId] GetFormSubmissionRequest formId
                     * @property {number|null} [submissionId] GetFormSubmissionRequest submissionId
                     */
    
                    /**
                     * Constructs a new GetFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormSubmissionRequest.
                     * @implements IGetFormSubmissionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest=} [properties] Properties to set
                     */
                    function GetFormSubmissionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormSubmissionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @instance
                     */
                    GetFormSubmissionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormSubmissionRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @instance
                     */
                    GetFormSubmissionRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetFormSubmissionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormSubmissionRequest} GetFormSubmissionRequest instance
                     */
                    GetFormSubmissionRequest.create = function create(properties) {
                        return new GetFormSubmissionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormSubmissionRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormSubmissionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest} message GetFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormSubmissionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormSubmissionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormSubmissionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSubmissionRequest} message GetFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormSubmissionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormSubmissionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormSubmissionRequest} GetFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormSubmissionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormSubmissionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormSubmissionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormSubmissionRequest} GetFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormSubmissionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormSubmissionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormSubmissionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormSubmissionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormSubmissionRequest} GetFormSubmissionRequest
                     */
                    GetFormSubmissionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormSubmissionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormSubmissionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormSubmissionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormSubmissionRequest} message GetFormSubmissionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormSubmissionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormSubmissionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormSubmissionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormSubmissionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormSubmissionRequest;
                })();
    
                v1.UpdateFormSubmissionRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormSubmissionRequest
                     * @property {number|null} [formId] UpdateFormSubmissionRequest formId
                     * @property {number|null} [submissionId] UpdateFormSubmissionRequest submissionId
                     * @property {palexy.task_management.v1.IFormSubmission|null} [submission] UpdateFormSubmissionRequest submission
                     */
    
                    /**
                     * Constructs a new UpdateFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormSubmissionRequest.
                     * @implements IUpdateFormSubmissionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest=} [properties] Properties to set
                     */
                    function UpdateFormSubmissionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormSubmissionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @instance
                     */
                    UpdateFormSubmissionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormSubmissionRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @instance
                     */
                    UpdateFormSubmissionRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormSubmissionRequest submission.
                     * @member {palexy.task_management.v1.IFormSubmission|null|undefined} submission
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @instance
                     */
                    UpdateFormSubmissionRequest.prototype.submission = null;
    
                    /**
                     * Creates a new UpdateFormSubmissionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormSubmissionRequest} UpdateFormSubmissionRequest instance
                     */
                    UpdateFormSubmissionRequest.create = function create(properties) {
                        return new UpdateFormSubmissionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormSubmissionRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormSubmissionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest} message UpdateFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormSubmissionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.submission != null && Object.hasOwnProperty.call(message, "submission"))
                            $root.palexy.task_management.v1.FormSubmission.encode(message.submission, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormSubmissionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormSubmissionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormSubmissionRequest} message UpdateFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormSubmissionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormSubmissionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormSubmissionRequest} UpdateFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormSubmissionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormSubmissionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.submission = $root.palexy.task_management.v1.FormSubmission.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormSubmissionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormSubmissionRequest} UpdateFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormSubmissionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormSubmissionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormSubmissionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.submission != null && message.hasOwnProperty("submission")) {
                            var error = $root.palexy.task_management.v1.FormSubmission.verify(message.submission);
                            if (error)
                                return "submission." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormSubmissionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormSubmissionRequest} UpdateFormSubmissionRequest
                     */
                    UpdateFormSubmissionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormSubmissionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormSubmissionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.submission != null) {
                            if (typeof object.submission !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormSubmissionRequest.submission: object expected");
                            message.submission = $root.palexy.task_management.v1.FormSubmission.fromObject(object.submission);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormSubmissionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormSubmissionRequest} message UpdateFormSubmissionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormSubmissionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            object.submission = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.submission != null && message.hasOwnProperty("submission"))
                            object.submission = $root.palexy.task_management.v1.FormSubmission.toObject(message.submission, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormSubmissionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormSubmissionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormSubmissionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormSubmissionRequest;
                })();
    
                v1.DeleteFormSubmissionRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormSubmissionRequest
                     * @property {number|null} [formId] DeleteFormSubmissionRequest formId
                     * @property {number|null} [submissionId] DeleteFormSubmissionRequest submissionId
                     */
    
                    /**
                     * Constructs a new DeleteFormSubmissionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormSubmissionRequest.
                     * @implements IDeleteFormSubmissionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest=} [properties] Properties to set
                     */
                    function DeleteFormSubmissionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormSubmissionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @instance
                     */
                    DeleteFormSubmissionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormSubmissionRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @instance
                     */
                    DeleteFormSubmissionRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormSubmissionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormSubmissionRequest} DeleteFormSubmissionRequest instance
                     */
                    DeleteFormSubmissionRequest.create = function create(properties) {
                        return new DeleteFormSubmissionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormSubmissionRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormSubmissionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest} message DeleteFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormSubmissionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormSubmissionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormSubmissionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormSubmissionRequest} message DeleteFormSubmissionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormSubmissionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormSubmissionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormSubmissionRequest} DeleteFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormSubmissionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormSubmissionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormSubmissionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormSubmissionRequest} DeleteFormSubmissionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormSubmissionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormSubmissionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormSubmissionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormSubmissionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormSubmissionRequest} DeleteFormSubmissionRequest
                     */
                    DeleteFormSubmissionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormSubmissionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormSubmissionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormSubmissionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormSubmissionRequest} message DeleteFormSubmissionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormSubmissionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormSubmissionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormSubmissionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormSubmissionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormSubmissionRequest;
                })();
    
                v1.FormDistribution = (function() {
    
                    /**
                     * Properties of a FormDistribution.
                     * @memberof palexy.task_management.v1
                     * @interface IFormDistribution
                     * @property {number|null} [id] FormDistribution id
                     * @property {number|null} [formId] FormDistribution formId
                     * @property {number|null} [companyId] FormDistribution companyId
                     * @property {number|null} [createdTimeMs] FormDistribution createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] FormDistribution lastUpdateTimeMs
                     * @property {palexy.task_management.v1.FormDistribution.DistributionType|null} [distributionType] FormDistribution distributionType
                     * @property {palexy.task_management.v1.ILinkDistributionConfig|null} [linkDistributionConfig] FormDistribution linkDistributionConfig
                     * @property {palexy.task_management.v1.IStoreEventDistributionConfig|null} [storeEventDistributionConfig] FormDistribution storeEventDistributionConfig
                     * @property {palexy.task_management.v1.IContactListDistributionConfig|null} [contactListDistributionConfig] FormDistribution contactListDistributionConfig
                     */
    
                    /**
                     * Constructs a new FormDistribution.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormDistribution.
                     * @implements IFormDistribution
                     * @constructor
                     * @param {palexy.task_management.v1.IFormDistribution=} [properties] Properties to set
                     */
                    function FormDistribution(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormDistribution id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormDistribution formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormDistribution companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormDistribution createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormDistribution lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormDistribution distributionType.
                     * @member {palexy.task_management.v1.FormDistribution.DistributionType} distributionType
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.distributionType = 0;
    
                    /**
                     * FormDistribution linkDistributionConfig.
                     * @member {palexy.task_management.v1.ILinkDistributionConfig|null|undefined} linkDistributionConfig
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.linkDistributionConfig = null;
    
                    /**
                     * FormDistribution storeEventDistributionConfig.
                     * @member {palexy.task_management.v1.IStoreEventDistributionConfig|null|undefined} storeEventDistributionConfig
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.storeEventDistributionConfig = null;
    
                    /**
                     * FormDistribution contactListDistributionConfig.
                     * @member {palexy.task_management.v1.IContactListDistributionConfig|null|undefined} contactListDistributionConfig
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    FormDistribution.prototype.contactListDistributionConfig = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * FormDistribution distributionConfig.
                     * @member {"linkDistributionConfig"|"storeEventDistributionConfig"|"contactListDistributionConfig"|undefined} distributionConfig
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     */
                    Object.defineProperty(FormDistribution.prototype, "distributionConfig", {
                        get: $util.oneOfGetter($oneOfFields = ["linkDistributionConfig", "storeEventDistributionConfig", "contactListDistributionConfig"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new FormDistribution instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {palexy.task_management.v1.IFormDistribution=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormDistribution} FormDistribution instance
                     */
                    FormDistribution.create = function create(properties) {
                        return new FormDistribution(properties);
                    };
    
                    /**
                     * Encodes the specified FormDistribution message. Does not implicitly {@link palexy.task_management.v1.FormDistribution.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {palexy.task_management.v1.IFormDistribution} message FormDistribution message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormDistribution.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.companyId);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.lastUpdateTimeMs);
                        if (message.distributionType != null && Object.hasOwnProperty.call(message, "distributionType"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.distributionType);
                        if (message.linkDistributionConfig != null && Object.hasOwnProperty.call(message, "linkDistributionConfig"))
                            $root.palexy.task_management.v1.LinkDistributionConfig.encode(message.linkDistributionConfig, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.storeEventDistributionConfig != null && Object.hasOwnProperty.call(message, "storeEventDistributionConfig"))
                            $root.palexy.task_management.v1.StoreEventDistributionConfig.encode(message.storeEventDistributionConfig, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.contactListDistributionConfig != null && Object.hasOwnProperty.call(message, "contactListDistributionConfig"))
                            $root.palexy.task_management.v1.ContactListDistributionConfig.encode(message.contactListDistributionConfig, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormDistribution message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormDistribution.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {palexy.task_management.v1.IFormDistribution} message FormDistribution message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormDistribution.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormDistribution message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormDistribution} FormDistribution
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormDistribution.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormDistribution();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.companyId = reader.int64();
                                break;
                            case 4:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 5:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 6:
                                message.distributionType = reader.int32();
                                break;
                            case 7:
                                message.linkDistributionConfig = $root.palexy.task_management.v1.LinkDistributionConfig.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.storeEventDistributionConfig = $root.palexy.task_management.v1.StoreEventDistributionConfig.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.contactListDistributionConfig = $root.palexy.task_management.v1.ContactListDistributionConfig.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormDistribution message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormDistribution} FormDistribution
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormDistribution.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormDistribution message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormDistribution.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            switch (message.distributionType) {
                            default:
                                return "distributionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.linkDistributionConfig != null && message.hasOwnProperty("linkDistributionConfig")) {
                            properties.distributionConfig = 1;
                            {
                                var error = $root.palexy.task_management.v1.LinkDistributionConfig.verify(message.linkDistributionConfig);
                                if (error)
                                    return "linkDistributionConfig." + error;
                            }
                        }
                        if (message.storeEventDistributionConfig != null && message.hasOwnProperty("storeEventDistributionConfig")) {
                            if (properties.distributionConfig === 1)
                                return "distributionConfig: multiple values";
                            properties.distributionConfig = 1;
                            {
                                var error = $root.palexy.task_management.v1.StoreEventDistributionConfig.verify(message.storeEventDistributionConfig);
                                if (error)
                                    return "storeEventDistributionConfig." + error;
                            }
                        }
                        if (message.contactListDistributionConfig != null && message.hasOwnProperty("contactListDistributionConfig")) {
                            if (properties.distributionConfig === 1)
                                return "distributionConfig: multiple values";
                            properties.distributionConfig = 1;
                            {
                                var error = $root.palexy.task_management.v1.ContactListDistributionConfig.verify(message.contactListDistributionConfig);
                                if (error)
                                    return "contactListDistributionConfig." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormDistribution message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormDistribution} FormDistribution
                     */
                    FormDistribution.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormDistribution)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormDistribution();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        switch (object.distributionType) {
                        case "UNKNOWN":
                        case 0:
                            message.distributionType = 0;
                            break;
                        case "LINK":
                        case 1:
                            message.distributionType = 1;
                            break;
                        case "STORE_EVENT":
                        case 2:
                            message.distributionType = 2;
                            break;
                        case "CONTACT_LIST":
                        case 3:
                            message.distributionType = 3;
                            break;
                        }
                        if (object.linkDistributionConfig != null) {
                            if (typeof object.linkDistributionConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FormDistribution.linkDistributionConfig: object expected");
                            message.linkDistributionConfig = $root.palexy.task_management.v1.LinkDistributionConfig.fromObject(object.linkDistributionConfig);
                        }
                        if (object.storeEventDistributionConfig != null) {
                            if (typeof object.storeEventDistributionConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FormDistribution.storeEventDistributionConfig: object expected");
                            message.storeEventDistributionConfig = $root.palexy.task_management.v1.StoreEventDistributionConfig.fromObject(object.storeEventDistributionConfig);
                        }
                        if (object.contactListDistributionConfig != null) {
                            if (typeof object.contactListDistributionConfig !== "object")
                                throw TypeError(".palexy.task_management.v1.FormDistribution.contactListDistributionConfig: object expected");
                            message.contactListDistributionConfig = $root.palexy.task_management.v1.ContactListDistributionConfig.fromObject(object.contactListDistributionConfig);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormDistribution message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @static
                     * @param {palexy.task_management.v1.FormDistribution} message FormDistribution
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormDistribution.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.distributionType = options.enums === String ? "UNKNOWN" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            object.distributionType = options.enums === String ? $root.palexy.task_management.v1.FormDistribution.DistributionType[message.distributionType] : message.distributionType;
                        if (message.linkDistributionConfig != null && message.hasOwnProperty("linkDistributionConfig")) {
                            object.linkDistributionConfig = $root.palexy.task_management.v1.LinkDistributionConfig.toObject(message.linkDistributionConfig, options);
                            if (options.oneofs)
                                object.distributionConfig = "linkDistributionConfig";
                        }
                        if (message.storeEventDistributionConfig != null && message.hasOwnProperty("storeEventDistributionConfig")) {
                            object.storeEventDistributionConfig = $root.palexy.task_management.v1.StoreEventDistributionConfig.toObject(message.storeEventDistributionConfig, options);
                            if (options.oneofs)
                                object.distributionConfig = "storeEventDistributionConfig";
                        }
                        if (message.contactListDistributionConfig != null && message.hasOwnProperty("contactListDistributionConfig")) {
                            object.contactListDistributionConfig = $root.palexy.task_management.v1.ContactListDistributionConfig.toObject(message.contactListDistributionConfig, options);
                            if (options.oneofs)
                                object.distributionConfig = "contactListDistributionConfig";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FormDistribution to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormDistribution
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormDistribution.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * DistributionType enum.
                     * @name palexy.task_management.v1.FormDistribution.DistributionType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} LINK=1 LINK value
                     * @property {number} STORE_EVENT=2 STORE_EVENT value
                     * @property {number} CONTACT_LIST=3 CONTACT_LIST value
                     */
                    FormDistribution.DistributionType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "LINK"] = 1;
                        values[valuesById[2] = "STORE_EVENT"] = 2;
                        values[valuesById[3] = "CONTACT_LIST"] = 3;
                        return values;
                    })();
    
                    return FormDistribution;
                })();
    
                v1.LinkDistributionConfig = (function() {
    
                    /**
                     * Properties of a LinkDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ILinkDistributionConfig
                     * @property {string|null} [linkId] LinkDistributionConfig linkId
                     * @property {number|null} [expirationTimeMs] LinkDistributionConfig expirationTimeMs
                     */
    
                    /**
                     * Constructs a new LinkDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a LinkDistributionConfig.
                     * @implements ILinkDistributionConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ILinkDistributionConfig=} [properties] Properties to set
                     */
                    function LinkDistributionConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * LinkDistributionConfig linkId.
                     * @member {string} linkId
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @instance
                     */
                    LinkDistributionConfig.prototype.linkId = "";
    
                    /**
                     * LinkDistributionConfig expirationTimeMs.
                     * @member {number} expirationTimeMs
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @instance
                     */
                    LinkDistributionConfig.prototype.expirationTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new LinkDistributionConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.ILinkDistributionConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.LinkDistributionConfig} LinkDistributionConfig instance
                     */
                    LinkDistributionConfig.create = function create(properties) {
                        return new LinkDistributionConfig(properties);
                    };
    
                    /**
                     * Encodes the specified LinkDistributionConfig message. Does not implicitly {@link palexy.task_management.v1.LinkDistributionConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.ILinkDistributionConfig} message LinkDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LinkDistributionConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.linkId != null && Object.hasOwnProperty.call(message, "linkId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.linkId);
                        if (message.expirationTimeMs != null && Object.hasOwnProperty.call(message, "expirationTimeMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.expirationTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified LinkDistributionConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.LinkDistributionConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.ILinkDistributionConfig} message LinkDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    LinkDistributionConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a LinkDistributionConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.LinkDistributionConfig} LinkDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LinkDistributionConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.LinkDistributionConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.linkId = reader.string();
                                break;
                            case 2:
                                message.expirationTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a LinkDistributionConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.LinkDistributionConfig} LinkDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    LinkDistributionConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a LinkDistributionConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    LinkDistributionConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            if (!$util.isString(message.linkId))
                                return "linkId: string expected";
                        if (message.expirationTimeMs != null && message.hasOwnProperty("expirationTimeMs"))
                            if (!$util.isInteger(message.expirationTimeMs) && !(message.expirationTimeMs && $util.isInteger(message.expirationTimeMs.low) && $util.isInteger(message.expirationTimeMs.high)))
                                return "expirationTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a LinkDistributionConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.LinkDistributionConfig} LinkDistributionConfig
                     */
                    LinkDistributionConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.LinkDistributionConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.LinkDistributionConfig();
                        if (object.linkId != null)
                            message.linkId = String(object.linkId);
                        if (object.expirationTimeMs != null)
                            if ($util.Long)
                                (message.expirationTimeMs = $util.Long.fromValue(object.expirationTimeMs)).unsigned = false;
                            else if (typeof object.expirationTimeMs === "string")
                                message.expirationTimeMs = parseInt(object.expirationTimeMs, 10);
                            else if (typeof object.expirationTimeMs === "number")
                                message.expirationTimeMs = object.expirationTimeMs;
                            else if (typeof object.expirationTimeMs === "object")
                                message.expirationTimeMs = new $util.LongBits(object.expirationTimeMs.low >>> 0, object.expirationTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a LinkDistributionConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.LinkDistributionConfig} message LinkDistributionConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    LinkDistributionConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.linkId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.expirationTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.expirationTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            object.linkId = message.linkId;
                        if (message.expirationTimeMs != null && message.hasOwnProperty("expirationTimeMs"))
                            if (typeof message.expirationTimeMs === "number")
                                object.expirationTimeMs = options.longs === String ? String(message.expirationTimeMs) : message.expirationTimeMs;
                            else
                                object.expirationTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.expirationTimeMs) : options.longs === Number ? new $util.LongBits(message.expirationTimeMs.low >>> 0, message.expirationTimeMs.high >>> 0).toNumber() : message.expirationTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this LinkDistributionConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.LinkDistributionConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    LinkDistributionConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return LinkDistributionConfig;
                })();
    
                v1.StoreEventDistributionConfig = (function() {
    
                    /**
                     * Properties of a StoreEventDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @interface IStoreEventDistributionConfig
                     * @property {string|null} [storeEventType] StoreEventDistributionConfig storeEventType
                     * @property {boolean|null} [isEnabled] StoreEventDistributionConfig isEnabled
                     */
    
                    /**
                     * Constructs a new StoreEventDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a StoreEventDistributionConfig.
                     * @implements IStoreEventDistributionConfig
                     * @constructor
                     * @param {palexy.task_management.v1.IStoreEventDistributionConfig=} [properties] Properties to set
                     */
                    function StoreEventDistributionConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * StoreEventDistributionConfig storeEventType.
                     * @member {string} storeEventType
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @instance
                     */
                    StoreEventDistributionConfig.prototype.storeEventType = "";
    
                    /**
                     * StoreEventDistributionConfig isEnabled.
                     * @member {boolean} isEnabled
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @instance
                     */
                    StoreEventDistributionConfig.prototype.isEnabled = false;
    
                    /**
                     * Creates a new StoreEventDistributionConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IStoreEventDistributionConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.StoreEventDistributionConfig} StoreEventDistributionConfig instance
                     */
                    StoreEventDistributionConfig.create = function create(properties) {
                        return new StoreEventDistributionConfig(properties);
                    };
    
                    /**
                     * Encodes the specified StoreEventDistributionConfig message. Does not implicitly {@link palexy.task_management.v1.StoreEventDistributionConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IStoreEventDistributionConfig} message StoreEventDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventDistributionConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeEventType != null && Object.hasOwnProperty.call(message, "storeEventType"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.storeEventType);
                        if (message.isEnabled != null && Object.hasOwnProperty.call(message, "isEnabled"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isEnabled);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified StoreEventDistributionConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.StoreEventDistributionConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IStoreEventDistributionConfig} message StoreEventDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    StoreEventDistributionConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a StoreEventDistributionConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.StoreEventDistributionConfig} StoreEventDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventDistributionConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.StoreEventDistributionConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeEventType = reader.string();
                                break;
                            case 2:
                                message.isEnabled = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a StoreEventDistributionConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.StoreEventDistributionConfig} StoreEventDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    StoreEventDistributionConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a StoreEventDistributionConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    StoreEventDistributionConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            if (!$util.isString(message.storeEventType))
                                return "storeEventType: string expected";
                        if (message.isEnabled != null && message.hasOwnProperty("isEnabled"))
                            if (typeof message.isEnabled !== "boolean")
                                return "isEnabled: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a StoreEventDistributionConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.StoreEventDistributionConfig} StoreEventDistributionConfig
                     */
                    StoreEventDistributionConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.StoreEventDistributionConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.StoreEventDistributionConfig();
                        if (object.storeEventType != null)
                            message.storeEventType = String(object.storeEventType);
                        if (object.isEnabled != null)
                            message.isEnabled = Boolean(object.isEnabled);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a StoreEventDistributionConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.StoreEventDistributionConfig} message StoreEventDistributionConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    StoreEventDistributionConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.storeEventType = "";
                            object.isEnabled = false;
                        }
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            object.storeEventType = message.storeEventType;
                        if (message.isEnabled != null && message.hasOwnProperty("isEnabled"))
                            object.isEnabled = message.isEnabled;
                        return object;
                    };
    
                    /**
                     * Converts this StoreEventDistributionConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.StoreEventDistributionConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    StoreEventDistributionConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return StoreEventDistributionConfig;
                })();
    
                v1.ContactListDistributionConfig = (function() {
    
                    /**
                     * Properties of a ContactListDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @interface IContactListDistributionConfig
                     * @property {number|null} [contactListId] ContactListDistributionConfig contactListId
                     * @property {string|null} [linkId] ContactListDistributionConfig linkId
                     * @property {number|null} [expirationTimeMs] ContactListDistributionConfig expirationTimeMs
                     */
    
                    /**
                     * Constructs a new ContactListDistributionConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ContactListDistributionConfig.
                     * @implements IContactListDistributionConfig
                     * @constructor
                     * @param {palexy.task_management.v1.IContactListDistributionConfig=} [properties] Properties to set
                     */
                    function ContactListDistributionConfig(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ContactListDistributionConfig contactListId.
                     * @member {number} contactListId
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @instance
                     */
                    ContactListDistributionConfig.prototype.contactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ContactListDistributionConfig linkId.
                     * @member {string} linkId
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @instance
                     */
                    ContactListDistributionConfig.prototype.linkId = "";
    
                    /**
                     * ContactListDistributionConfig expirationTimeMs.
                     * @member {number} expirationTimeMs
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @instance
                     */
                    ContactListDistributionConfig.prototype.expirationTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ContactListDistributionConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IContactListDistributionConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ContactListDistributionConfig} ContactListDistributionConfig instance
                     */
                    ContactListDistributionConfig.create = function create(properties) {
                        return new ContactListDistributionConfig(properties);
                    };
    
                    /**
                     * Encodes the specified ContactListDistributionConfig message. Does not implicitly {@link palexy.task_management.v1.ContactListDistributionConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IContactListDistributionConfig} message ContactListDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactListDistributionConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contactListId != null && Object.hasOwnProperty.call(message, "contactListId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.contactListId);
                        if (message.linkId != null && Object.hasOwnProperty.call(message, "linkId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.linkId);
                        if (message.expirationTimeMs != null && Object.hasOwnProperty.call(message, "expirationTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.expirationTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ContactListDistributionConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.ContactListDistributionConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.IContactListDistributionConfig} message ContactListDistributionConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactListDistributionConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ContactListDistributionConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ContactListDistributionConfig} ContactListDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactListDistributionConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ContactListDistributionConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.contactListId = reader.int64();
                                break;
                            case 2:
                                message.linkId = reader.string();
                                break;
                            case 3:
                                message.expirationTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ContactListDistributionConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ContactListDistributionConfig} ContactListDistributionConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactListDistributionConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ContactListDistributionConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ContactListDistributionConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (!$util.isInteger(message.contactListId) && !(message.contactListId && $util.isInteger(message.contactListId.low) && $util.isInteger(message.contactListId.high)))
                                return "contactListId: integer|Long expected";
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            if (!$util.isString(message.linkId))
                                return "linkId: string expected";
                        if (message.expirationTimeMs != null && message.hasOwnProperty("expirationTimeMs"))
                            if (!$util.isInteger(message.expirationTimeMs) && !(message.expirationTimeMs && $util.isInteger(message.expirationTimeMs.low) && $util.isInteger(message.expirationTimeMs.high)))
                                return "expirationTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ContactListDistributionConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ContactListDistributionConfig} ContactListDistributionConfig
                     */
                    ContactListDistributionConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ContactListDistributionConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.ContactListDistributionConfig();
                        if (object.contactListId != null)
                            if ($util.Long)
                                (message.contactListId = $util.Long.fromValue(object.contactListId)).unsigned = false;
                            else if (typeof object.contactListId === "string")
                                message.contactListId = parseInt(object.contactListId, 10);
                            else if (typeof object.contactListId === "number")
                                message.contactListId = object.contactListId;
                            else if (typeof object.contactListId === "object")
                                message.contactListId = new $util.LongBits(object.contactListId.low >>> 0, object.contactListId.high >>> 0).toNumber();
                        if (object.linkId != null)
                            message.linkId = String(object.linkId);
                        if (object.expirationTimeMs != null)
                            if ($util.Long)
                                (message.expirationTimeMs = $util.Long.fromValue(object.expirationTimeMs)).unsigned = false;
                            else if (typeof object.expirationTimeMs === "string")
                                message.expirationTimeMs = parseInt(object.expirationTimeMs, 10);
                            else if (typeof object.expirationTimeMs === "number")
                                message.expirationTimeMs = object.expirationTimeMs;
                            else if (typeof object.expirationTimeMs === "object")
                                message.expirationTimeMs = new $util.LongBits(object.expirationTimeMs.low >>> 0, object.expirationTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ContactListDistributionConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @static
                     * @param {palexy.task_management.v1.ContactListDistributionConfig} message ContactListDistributionConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ContactListDistributionConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactListId = options.longs === String ? "0" : 0;
                            object.linkId = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.expirationTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.expirationTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (typeof message.contactListId === "number")
                                object.contactListId = options.longs === String ? String(message.contactListId) : message.contactListId;
                            else
                                object.contactListId = options.longs === String ? $util.Long.prototype.toString.call(message.contactListId) : options.longs === Number ? new $util.LongBits(message.contactListId.low >>> 0, message.contactListId.high >>> 0).toNumber() : message.contactListId;
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            object.linkId = message.linkId;
                        if (message.expirationTimeMs != null && message.hasOwnProperty("expirationTimeMs"))
                            if (typeof message.expirationTimeMs === "number")
                                object.expirationTimeMs = options.longs === String ? String(message.expirationTimeMs) : message.expirationTimeMs;
                            else
                                object.expirationTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.expirationTimeMs) : options.longs === Number ? new $util.LongBits(message.expirationTimeMs.low >>> 0, message.expirationTimeMs.high >>> 0).toNumber() : message.expirationTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ContactListDistributionConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ContactListDistributionConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ContactListDistributionConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ContactListDistributionConfig;
                })();
    
                v1.CreateFormDistributionRequest = (function() {
    
                    /**
                     * Properties of a CreateFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormDistributionRequest
                     * @property {palexy.task_management.v1.IFormDistribution|null} [distribution] CreateFormDistributionRequest distribution
                     */
    
                    /**
                     * Constructs a new CreateFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormDistributionRequest.
                     * @implements ICreateFormDistributionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest=} [properties] Properties to set
                     */
                    function CreateFormDistributionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormDistributionRequest distribution.
                     * @member {palexy.task_management.v1.IFormDistribution|null|undefined} distribution
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @instance
                     */
                    CreateFormDistributionRequest.prototype.distribution = null;
    
                    /**
                     * Creates a new CreateFormDistributionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormDistributionRequest} CreateFormDistributionRequest instance
                     */
                    CreateFormDistributionRequest.create = function create(properties) {
                        return new CreateFormDistributionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormDistributionRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormDistributionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest} message CreateFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormDistributionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.distribution != null && Object.hasOwnProperty.call(message, "distribution"))
                            $root.palexy.task_management.v1.FormDistribution.encode(message.distribution, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormDistributionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormDistributionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormDistributionRequest} message CreateFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormDistributionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormDistributionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormDistributionRequest} CreateFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormDistributionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormDistributionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.distribution = $root.palexy.task_management.v1.FormDistribution.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormDistributionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormDistributionRequest} CreateFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormDistributionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormDistributionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormDistributionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.distribution != null && message.hasOwnProperty("distribution")) {
                            var error = $root.palexy.task_management.v1.FormDistribution.verify(message.distribution);
                            if (error)
                                return "distribution." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormDistributionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormDistributionRequest} CreateFormDistributionRequest
                     */
                    CreateFormDistributionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormDistributionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormDistributionRequest();
                        if (object.distribution != null) {
                            if (typeof object.distribution !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormDistributionRequest.distribution: object expected");
                            message.distribution = $root.palexy.task_management.v1.FormDistribution.fromObject(object.distribution);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormDistributionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormDistributionRequest} message CreateFormDistributionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormDistributionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.distribution = null;
                        if (message.distribution != null && message.hasOwnProperty("distribution"))
                            object.distribution = $root.palexy.task_management.v1.FormDistribution.toObject(message.distribution, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormDistributionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormDistributionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormDistributionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormDistributionRequest;
                })();
    
                v1.UpdateFormDistributionRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormDistributionRequest
                     * @property {palexy.task_management.v1.IFormDistribution|null} [distribution] UpdateFormDistributionRequest distribution
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormDistributionRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormDistributionRequest.
                     * @implements IUpdateFormDistributionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest=} [properties] Properties to set
                     */
                    function UpdateFormDistributionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormDistributionRequest distribution.
                     * @member {palexy.task_management.v1.IFormDistribution|null|undefined} distribution
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @instance
                     */
                    UpdateFormDistributionRequest.prototype.distribution = null;
    
                    /**
                     * UpdateFormDistributionRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @instance
                     */
                    UpdateFormDistributionRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateFormDistributionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormDistributionRequest} UpdateFormDistributionRequest instance
                     */
                    UpdateFormDistributionRequest.create = function create(properties) {
                        return new UpdateFormDistributionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormDistributionRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormDistributionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest} message UpdateFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormDistributionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.distribution != null && Object.hasOwnProperty.call(message, "distribution"))
                            $root.palexy.task_management.v1.FormDistribution.encode(message.distribution, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormDistributionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormDistributionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormDistributionRequest} message UpdateFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormDistributionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormDistributionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormDistributionRequest} UpdateFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormDistributionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormDistributionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.distribution = $root.palexy.task_management.v1.FormDistribution.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormDistributionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormDistributionRequest} UpdateFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormDistributionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormDistributionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormDistributionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.distribution != null && message.hasOwnProperty("distribution")) {
                            var error = $root.palexy.task_management.v1.FormDistribution.verify(message.distribution);
                            if (error)
                                return "distribution." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormDistributionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormDistributionRequest} UpdateFormDistributionRequest
                     */
                    UpdateFormDistributionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormDistributionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormDistributionRequest();
                        if (object.distribution != null) {
                            if (typeof object.distribution !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormDistributionRequest.distribution: object expected");
                            message.distribution = $root.palexy.task_management.v1.FormDistribution.fromObject(object.distribution);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormDistributionRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormDistributionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormDistributionRequest} message UpdateFormDistributionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormDistributionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.distribution = null;
                            object.updateMask = null;
                        }
                        if (message.distribution != null && message.hasOwnProperty("distribution"))
                            object.distribution = $root.palexy.task_management.v1.FormDistribution.toObject(message.distribution, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormDistributionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormDistributionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormDistributionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormDistributionRequest;
                })();
    
                v1.DeleteFormDistributionRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormDistributionRequest
                     * @property {number|null} [formId] DeleteFormDistributionRequest formId
                     * @property {number|null} [distributionId] DeleteFormDistributionRequest distributionId
                     */
    
                    /**
                     * Constructs a new DeleteFormDistributionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormDistributionRequest.
                     * @implements IDeleteFormDistributionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest=} [properties] Properties to set
                     */
                    function DeleteFormDistributionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormDistributionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @instance
                     */
                    DeleteFormDistributionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormDistributionRequest distributionId.
                     * @member {number} distributionId
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @instance
                     */
                    DeleteFormDistributionRequest.prototype.distributionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormDistributionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormDistributionRequest} DeleteFormDistributionRequest instance
                     */
                    DeleteFormDistributionRequest.create = function create(properties) {
                        return new DeleteFormDistributionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormDistributionRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormDistributionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest} message DeleteFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormDistributionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.distributionId != null && Object.hasOwnProperty.call(message, "distributionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.distributionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormDistributionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormDistributionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormDistributionRequest} message DeleteFormDistributionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormDistributionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormDistributionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormDistributionRequest} DeleteFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormDistributionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormDistributionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.distributionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormDistributionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormDistributionRequest} DeleteFormDistributionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormDistributionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormDistributionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormDistributionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.distributionId != null && message.hasOwnProperty("distributionId"))
                            if (!$util.isInteger(message.distributionId) && !(message.distributionId && $util.isInteger(message.distributionId.low) && $util.isInteger(message.distributionId.high)))
                                return "distributionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormDistributionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormDistributionRequest} DeleteFormDistributionRequest
                     */
                    DeleteFormDistributionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormDistributionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormDistributionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.distributionId != null)
                            if ($util.Long)
                                (message.distributionId = $util.Long.fromValue(object.distributionId)).unsigned = false;
                            else if (typeof object.distributionId === "string")
                                message.distributionId = parseInt(object.distributionId, 10);
                            else if (typeof object.distributionId === "number")
                                message.distributionId = object.distributionId;
                            else if (typeof object.distributionId === "object")
                                message.distributionId = new $util.LongBits(object.distributionId.low >>> 0, object.distributionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormDistributionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormDistributionRequest} message DeleteFormDistributionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormDistributionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.distributionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.distributionId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.distributionId != null && message.hasOwnProperty("distributionId"))
                            if (typeof message.distributionId === "number")
                                object.distributionId = options.longs === String ? String(message.distributionId) : message.distributionId;
                            else
                                object.distributionId = options.longs === String ? $util.Long.prototype.toString.call(message.distributionId) : options.longs === Number ? new $util.LongBits(message.distributionId.low >>> 0, message.distributionId.high >>> 0).toNumber() : message.distributionId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormDistributionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormDistributionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormDistributionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormDistributionRequest;
                })();
    
                v1.ListFormDistributionsRequest = (function() {
    
                    /**
                     * Properties of a ListFormDistributionsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormDistributionsRequest
                     * @property {number|null} [formId] ListFormDistributionsRequest formId
                     * @property {number|null} [pageSize] ListFormDistributionsRequest pageSize
                     * @property {string|null} [pageToken] ListFormDistributionsRequest pageToken
                     * @property {palexy.task_management.v1.FormDistribution.DistributionType|null} [distributionType] ListFormDistributionsRequest distributionType
                     * @property {number|null} [companyId] ListFormDistributionsRequest companyId
                     */
    
                    /**
                     * Constructs a new ListFormDistributionsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormDistributionsRequest.
                     * @implements IListFormDistributionsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest=} [properties] Properties to set
                     */
                    function ListFormDistributionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormDistributionsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     */
                    ListFormDistributionsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormDistributionsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     */
                    ListFormDistributionsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormDistributionsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     */
                    ListFormDistributionsRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormDistributionsRequest distributionType.
                     * @member {palexy.task_management.v1.FormDistribution.DistributionType} distributionType
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     */
                    ListFormDistributionsRequest.prototype.distributionType = 0;
    
                    /**
                     * ListFormDistributionsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     */
                    ListFormDistributionsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormDistributionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormDistributionsRequest} ListFormDistributionsRequest instance
                     */
                    ListFormDistributionsRequest.create = function create(properties) {
                        return new ListFormDistributionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormDistributionsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormDistributionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest} message ListFormDistributionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormDistributionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        if (message.distributionType != null && Object.hasOwnProperty.call(message, "distributionType"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.distributionType);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormDistributionsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormDistributionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsRequest} message ListFormDistributionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormDistributionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormDistributionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormDistributionsRequest} ListFormDistributionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormDistributionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormDistributionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            case 4:
                                message.distributionType = reader.int32();
                                break;
                            case 5:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormDistributionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormDistributionsRequest} ListFormDistributionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormDistributionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormDistributionsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormDistributionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            switch (message.distributionType) {
                            default:
                                return "distributionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormDistributionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormDistributionsRequest} ListFormDistributionsRequest
                     */
                    ListFormDistributionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormDistributionsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormDistributionsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        switch (object.distributionType) {
                        case "UNKNOWN":
                        case 0:
                            message.distributionType = 0;
                            break;
                        case "LINK":
                        case 1:
                            message.distributionType = 1;
                            break;
                        case "STORE_EVENT":
                        case 2:
                            message.distributionType = 2;
                            break;
                        case "CONTACT_LIST":
                        case 3:
                            message.distributionType = 3;
                            break;
                        }
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormDistributionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormDistributionsRequest} message ListFormDistributionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormDistributionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.distributionType = options.enums === String ? "UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            object.distributionType = options.enums === String ? $root.palexy.task_management.v1.FormDistribution.DistributionType[message.distributionType] : message.distributionType;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormDistributionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormDistributionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormDistributionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormDistributionsRequest;
                })();
    
                v1.ListFormDistributionsResponse = (function() {
    
                    /**
                     * Properties of a ListFormDistributionsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormDistributionsResponse
                     * @property {Array.<palexy.task_management.v1.IFormDistribution>|null} [distributions] ListFormDistributionsResponse distributions
                     * @property {number|null} [totalElements] ListFormDistributionsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormDistributionsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormDistributionsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormDistributionsResponse.
                     * @implements IListFormDistributionsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormDistributionsResponse=} [properties] Properties to set
                     */
                    function ListFormDistributionsResponse(properties) {
                        this.distributions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormDistributionsResponse distributions.
                     * @member {Array.<palexy.task_management.v1.IFormDistribution>} distributions
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @instance
                     */
                    ListFormDistributionsResponse.prototype.distributions = $util.emptyArray;
    
                    /**
                     * ListFormDistributionsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @instance
                     */
                    ListFormDistributionsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormDistributionsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @instance
                     */
                    ListFormDistributionsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormDistributionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormDistributionsResponse} ListFormDistributionsResponse instance
                     */
                    ListFormDistributionsResponse.create = function create(properties) {
                        return new ListFormDistributionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormDistributionsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormDistributionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsResponse} message ListFormDistributionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormDistributionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.distributions != null && message.distributions.length)
                            for (var i = 0; i < message.distributions.length; ++i)
                                $root.palexy.task_management.v1.FormDistribution.encode(message.distributions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormDistributionsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormDistributionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormDistributionsResponse} message ListFormDistributionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormDistributionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormDistributionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormDistributionsResponse} ListFormDistributionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormDistributionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormDistributionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.distributions && message.distributions.length))
                                    message.distributions = [];
                                message.distributions.push($root.palexy.task_management.v1.FormDistribution.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormDistributionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormDistributionsResponse} ListFormDistributionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormDistributionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormDistributionsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormDistributionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.distributions != null && message.hasOwnProperty("distributions")) {
                            if (!Array.isArray(message.distributions))
                                return "distributions: array expected";
                            for (var i = 0; i < message.distributions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormDistribution.verify(message.distributions[i]);
                                if (error)
                                    return "distributions." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormDistributionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormDistributionsResponse} ListFormDistributionsResponse
                     */
                    ListFormDistributionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormDistributionsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormDistributionsResponse();
                        if (object.distributions) {
                            if (!Array.isArray(object.distributions))
                                throw TypeError(".palexy.task_management.v1.ListFormDistributionsResponse.distributions: array expected");
                            message.distributions = [];
                            for (var i = 0; i < object.distributions.length; ++i) {
                                if (typeof object.distributions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormDistributionsResponse.distributions: object expected");
                                message.distributions[i] = $root.palexy.task_management.v1.FormDistribution.fromObject(object.distributions[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormDistributionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormDistributionsResponse} message ListFormDistributionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormDistributionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.distributions = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.distributions && message.distributions.length) {
                            object.distributions = [];
                            for (var j = 0; j < message.distributions.length; ++j)
                                object.distributions[j] = $root.palexy.task_management.v1.FormDistribution.toObject(message.distributions[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormDistributionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormDistributionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormDistributionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormDistributionsResponse;
                })();
    
                v1.FindPublishingFormsRequest = (function() {
    
                    /**
                     * Properties of a FindPublishingFormsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IFindPublishingFormsRequest
                     * @property {number|null} [companyId] FindPublishingFormsRequest companyId
                     * @property {palexy.task_management.v1.FormDistribution.DistributionType|null} [distributionType] FindPublishingFormsRequest distributionType
                     * @property {string|null} [storeEventType] FindPublishingFormsRequest storeEventType
                     */
    
                    /**
                     * Constructs a new FindPublishingFormsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FindPublishingFormsRequest.
                     * @implements IFindPublishingFormsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest=} [properties] Properties to set
                     */
                    function FindPublishingFormsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindPublishingFormsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @instance
                     */
                    FindPublishingFormsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FindPublishingFormsRequest distributionType.
                     * @member {palexy.task_management.v1.FormDistribution.DistributionType} distributionType
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @instance
                     */
                    FindPublishingFormsRequest.prototype.distributionType = 0;
    
                    /**
                     * FindPublishingFormsRequest storeEventType.
                     * @member {string} storeEventType
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @instance
                     */
                    FindPublishingFormsRequest.prototype.storeEventType = "";
    
                    /**
                     * Creates a new FindPublishingFormsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FindPublishingFormsRequest} FindPublishingFormsRequest instance
                     */
                    FindPublishingFormsRequest.create = function create(properties) {
                        return new FindPublishingFormsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified FindPublishingFormsRequest message. Does not implicitly {@link palexy.task_management.v1.FindPublishingFormsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest} message FindPublishingFormsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPublishingFormsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.distributionType != null && Object.hasOwnProperty.call(message, "distributionType"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.distributionType);
                        if (message.storeEventType != null && Object.hasOwnProperty.call(message, "storeEventType"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.storeEventType);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindPublishingFormsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.FindPublishingFormsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsRequest} message FindPublishingFormsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPublishingFormsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindPublishingFormsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FindPublishingFormsRequest} FindPublishingFormsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPublishingFormsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FindPublishingFormsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.distributionType = reader.int32();
                                break;
                            case 3:
                                message.storeEventType = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindPublishingFormsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FindPublishingFormsRequest} FindPublishingFormsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPublishingFormsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindPublishingFormsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindPublishingFormsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            switch (message.distributionType) {
                            default:
                                return "distributionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            if (!$util.isString(message.storeEventType))
                                return "storeEventType: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FindPublishingFormsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FindPublishingFormsRequest} FindPublishingFormsRequest
                     */
                    FindPublishingFormsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FindPublishingFormsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.FindPublishingFormsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        switch (object.distributionType) {
                        case "UNKNOWN":
                        case 0:
                            message.distributionType = 0;
                            break;
                        case "LINK":
                        case 1:
                            message.distributionType = 1;
                            break;
                        case "STORE_EVENT":
                        case 2:
                            message.distributionType = 2;
                            break;
                        case "CONTACT_LIST":
                        case 3:
                            message.distributionType = 3;
                            break;
                        }
                        if (object.storeEventType != null)
                            message.storeEventType = String(object.storeEventType);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindPublishingFormsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @static
                     * @param {palexy.task_management.v1.FindPublishingFormsRequest} message FindPublishingFormsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindPublishingFormsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.distributionType = options.enums === String ? "UNKNOWN" : 0;
                            object.storeEventType = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.distributionType != null && message.hasOwnProperty("distributionType"))
                            object.distributionType = options.enums === String ? $root.palexy.task_management.v1.FormDistribution.DistributionType[message.distributionType] : message.distributionType;
                        if (message.storeEventType != null && message.hasOwnProperty("storeEventType"))
                            object.storeEventType = message.storeEventType;
                        return object;
                    };
    
                    /**
                     * Converts this FindPublishingFormsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FindPublishingFormsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindPublishingFormsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindPublishingFormsRequest;
                })();
    
                v1.PublishingForm = (function() {
    
                    /**
                     * Properties of a PublishingForm.
                     * @memberof palexy.task_management.v1
                     * @interface IPublishingForm
                     * @property {palexy.task_management.v1.IForm|null} [form] PublishingForm form
                     * @property {palexy.task_management.v1.IFormDistribution|null} [distribution] PublishingForm distribution
                     */
    
                    /**
                     * Constructs a new PublishingForm.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a PublishingForm.
                     * @implements IPublishingForm
                     * @constructor
                     * @param {palexy.task_management.v1.IPublishingForm=} [properties] Properties to set
                     */
                    function PublishingForm(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * PublishingForm form.
                     * @member {palexy.task_management.v1.IForm|null|undefined} form
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @instance
                     */
                    PublishingForm.prototype.form = null;
    
                    /**
                     * PublishingForm distribution.
                     * @member {palexy.task_management.v1.IFormDistribution|null|undefined} distribution
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @instance
                     */
                    PublishingForm.prototype.distribution = null;
    
                    /**
                     * Creates a new PublishingForm instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {palexy.task_management.v1.IPublishingForm=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.PublishingForm} PublishingForm instance
                     */
                    PublishingForm.create = function create(properties) {
                        return new PublishingForm(properties);
                    };
    
                    /**
                     * Encodes the specified PublishingForm message. Does not implicitly {@link palexy.task_management.v1.PublishingForm.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {palexy.task_management.v1.IPublishingForm} message PublishingForm message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishingForm.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.form != null && Object.hasOwnProperty.call(message, "form"))
                            $root.palexy.task_management.v1.Form.encode(message.form, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.distribution != null && Object.hasOwnProperty.call(message, "distribution"))
                            $root.palexy.task_management.v1.FormDistribution.encode(message.distribution, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified PublishingForm message, length delimited. Does not implicitly {@link palexy.task_management.v1.PublishingForm.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {palexy.task_management.v1.IPublishingForm} message PublishingForm message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    PublishingForm.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a PublishingForm message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.PublishingForm} PublishingForm
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishingForm.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.PublishingForm();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.form = $root.palexy.task_management.v1.Form.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.distribution = $root.palexy.task_management.v1.FormDistribution.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a PublishingForm message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.PublishingForm} PublishingForm
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    PublishingForm.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a PublishingForm message.
                     * @function verify
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    PublishingForm.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.form != null && message.hasOwnProperty("form")) {
                            var error = $root.palexy.task_management.v1.Form.verify(message.form);
                            if (error)
                                return "form." + error;
                        }
                        if (message.distribution != null && message.hasOwnProperty("distribution")) {
                            var error = $root.palexy.task_management.v1.FormDistribution.verify(message.distribution);
                            if (error)
                                return "distribution." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a PublishingForm message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.PublishingForm} PublishingForm
                     */
                    PublishingForm.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.PublishingForm)
                            return object;
                        var message = new $root.palexy.task_management.v1.PublishingForm();
                        if (object.form != null) {
                            if (typeof object.form !== "object")
                                throw TypeError(".palexy.task_management.v1.PublishingForm.form: object expected");
                            message.form = $root.palexy.task_management.v1.Form.fromObject(object.form);
                        }
                        if (object.distribution != null) {
                            if (typeof object.distribution !== "object")
                                throw TypeError(".palexy.task_management.v1.PublishingForm.distribution: object expected");
                            message.distribution = $root.palexy.task_management.v1.FormDistribution.fromObject(object.distribution);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a PublishingForm message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @static
                     * @param {palexy.task_management.v1.PublishingForm} message PublishingForm
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    PublishingForm.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.form = null;
                            object.distribution = null;
                        }
                        if (message.form != null && message.hasOwnProperty("form"))
                            object.form = $root.palexy.task_management.v1.Form.toObject(message.form, options);
                        if (message.distribution != null && message.hasOwnProperty("distribution"))
                            object.distribution = $root.palexy.task_management.v1.FormDistribution.toObject(message.distribution, options);
                        return object;
                    };
    
                    /**
                     * Converts this PublishingForm to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.PublishingForm
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    PublishingForm.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return PublishingForm;
                })();
    
                v1.FindPublishingFormsResponse = (function() {
    
                    /**
                     * Properties of a FindPublishingFormsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IFindPublishingFormsResponse
                     * @property {Array.<palexy.task_management.v1.IPublishingForm>|null} [publishingForms] FindPublishingFormsResponse publishingForms
                     */
    
                    /**
                     * Constructs a new FindPublishingFormsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FindPublishingFormsResponse.
                     * @implements IFindPublishingFormsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IFindPublishingFormsResponse=} [properties] Properties to set
                     */
                    function FindPublishingFormsResponse(properties) {
                        this.publishingForms = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FindPublishingFormsResponse publishingForms.
                     * @member {Array.<palexy.task_management.v1.IPublishingForm>} publishingForms
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @instance
                     */
                    FindPublishingFormsResponse.prototype.publishingForms = $util.emptyArray;
    
                    /**
                     * Creates a new FindPublishingFormsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FindPublishingFormsResponse} FindPublishingFormsResponse instance
                     */
                    FindPublishingFormsResponse.create = function create(properties) {
                        return new FindPublishingFormsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified FindPublishingFormsResponse message. Does not implicitly {@link palexy.task_management.v1.FindPublishingFormsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsResponse} message FindPublishingFormsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPublishingFormsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.publishingForms != null && message.publishingForms.length)
                            for (var i = 0; i < message.publishingForms.length; ++i)
                                $root.palexy.task_management.v1.PublishingForm.encode(message.publishingForms[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FindPublishingFormsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.FindPublishingFormsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.IFindPublishingFormsResponse} message FindPublishingFormsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FindPublishingFormsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FindPublishingFormsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FindPublishingFormsResponse} FindPublishingFormsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPublishingFormsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FindPublishingFormsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.publishingForms && message.publishingForms.length))
                                    message.publishingForms = [];
                                message.publishingForms.push($root.palexy.task_management.v1.PublishingForm.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FindPublishingFormsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FindPublishingFormsResponse} FindPublishingFormsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FindPublishingFormsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FindPublishingFormsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FindPublishingFormsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.publishingForms != null && message.hasOwnProperty("publishingForms")) {
                            if (!Array.isArray(message.publishingForms))
                                return "publishingForms: array expected";
                            for (var i = 0; i < message.publishingForms.length; ++i) {
                                var error = $root.palexy.task_management.v1.PublishingForm.verify(message.publishingForms[i]);
                                if (error)
                                    return "publishingForms." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FindPublishingFormsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FindPublishingFormsResponse} FindPublishingFormsResponse
                     */
                    FindPublishingFormsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FindPublishingFormsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.FindPublishingFormsResponse();
                        if (object.publishingForms) {
                            if (!Array.isArray(object.publishingForms))
                                throw TypeError(".palexy.task_management.v1.FindPublishingFormsResponse.publishingForms: array expected");
                            message.publishingForms = [];
                            for (var i = 0; i < object.publishingForms.length; ++i) {
                                if (typeof object.publishingForms[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FindPublishingFormsResponse.publishingForms: object expected");
                                message.publishingForms[i] = $root.palexy.task_management.v1.PublishingForm.fromObject(object.publishingForms[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FindPublishingFormsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @static
                     * @param {palexy.task_management.v1.FindPublishingFormsResponse} message FindPublishingFormsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FindPublishingFormsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.publishingForms = [];
                        if (message.publishingForms && message.publishingForms.length) {
                            object.publishingForms = [];
                            for (var j = 0; j < message.publishingForms.length; ++j)
                                object.publishingForms[j] = $root.palexy.task_management.v1.PublishingForm.toObject(message.publishingForms[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FindPublishingFormsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FindPublishingFormsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FindPublishingFormsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FindPublishingFormsResponse;
                })();
    
                v1.FormContactList = (function() {
    
                    /**
                     * Properties of a FormContactList.
                     * @memberof palexy.task_management.v1
                     * @interface IFormContactList
                     * @property {number|null} [contactListId] FormContactList contactListId
                     * @property {number|null} [formId] FormContactList formId
                     * @property {number|null} [createdTimeMs] FormContactList createdTimeMs
                     * @property {number|null} [linkExpireTimeMs] FormContactList linkExpireTimeMs
                     * @property {boolean|null} [isDeleted] FormContactList isDeleted
                     * @property {string|null} [linkId] FormContactList linkId
                     * @property {string|null} [name] FormContactList name
                     * @property {number|null} [maxSubmissions] FormContactList maxSubmissions
                     * @property {palexy.task_management.v1.IContactListMappingData|null} [mappingData] FormContactList mappingData
                     * @property {palexy.task_management.v1.FormContactListSource|null} [source] FormContactList source
                     * @property {number|null} [recipientCount] FormContactList recipientCount
                     */
    
                    /**
                     * Constructs a new FormContactList.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormContactList.
                     * @implements IFormContactList
                     * @constructor
                     * @param {palexy.task_management.v1.IFormContactList=} [properties] Properties to set
                     */
                    function FormContactList(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormContactList contactListId.
                     * @member {number} contactListId
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.contactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormContactList formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormContactList createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormContactList linkExpireTimeMs.
                     * @member {number} linkExpireTimeMs
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.linkExpireTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormContactList isDeleted.
                     * @member {boolean} isDeleted
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.isDeleted = false;
    
                    /**
                     * FormContactList linkId.
                     * @member {string} linkId
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.linkId = "";
    
                    /**
                     * FormContactList name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.name = "";
    
                    /**
                     * FormContactList maxSubmissions.
                     * @member {number} maxSubmissions
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.maxSubmissions = 0;
    
                    /**
                     * FormContactList mappingData.
                     * @member {palexy.task_management.v1.IContactListMappingData|null|undefined} mappingData
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.mappingData = null;
    
                    /**
                     * FormContactList source.
                     * @member {palexy.task_management.v1.FormContactListSource} source
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.source = 0;
    
                    /**
                     * FormContactList recipientCount.
                     * @member {number} recipientCount
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     */
                    FormContactList.prototype.recipientCount = 0;
    
                    /**
                     * Creates a new FormContactList instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {palexy.task_management.v1.IFormContactList=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormContactList} FormContactList instance
                     */
                    FormContactList.create = function create(properties) {
                        return new FormContactList(properties);
                    };
    
                    /**
                     * Encodes the specified FormContactList message. Does not implicitly {@link palexy.task_management.v1.FormContactList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {palexy.task_management.v1.IFormContactList} message FormContactList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contactListId != null && Object.hasOwnProperty.call(message, "contactListId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.contactListId);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdTimeMs);
                        if (message.linkExpireTimeMs != null && Object.hasOwnProperty.call(message, "linkExpireTimeMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.linkExpireTimeMs);
                        if (message.isDeleted != null && Object.hasOwnProperty.call(message, "isDeleted"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isDeleted);
                        if (message.linkId != null && Object.hasOwnProperty.call(message, "linkId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.linkId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.name);
                        if (message.maxSubmissions != null && Object.hasOwnProperty.call(message, "maxSubmissions"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.maxSubmissions);
                        if (message.mappingData != null && Object.hasOwnProperty.call(message, "mappingData"))
                            $root.palexy.task_management.v1.ContactListMappingData.encode(message.mappingData, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.source);
                        if (message.recipientCount != null && Object.hasOwnProperty.call(message, "recipientCount"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.recipientCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormContactList message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormContactList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {palexy.task_management.v1.IFormContactList} message FormContactList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormContactList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormContactList} FormContactList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormContactList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.contactListId = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 4:
                                message.linkExpireTimeMs = reader.int64();
                                break;
                            case 6:
                                message.isDeleted = reader.bool();
                                break;
                            case 7:
                                message.linkId = reader.string();
                                break;
                            case 8:
                                message.name = reader.string();
                                break;
                            case 9:
                                message.maxSubmissions = reader.int32();
                                break;
                            case 10:
                                message.mappingData = $root.palexy.task_management.v1.ContactListMappingData.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.source = reader.int32();
                                break;
                            case 12:
                                message.recipientCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormContactList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormContactList} FormContactList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormContactList message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormContactList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (!$util.isInteger(message.contactListId) && !(message.contactListId && $util.isInteger(message.contactListId.low) && $util.isInteger(message.contactListId.high)))
                                return "contactListId: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.linkExpireTimeMs != null && message.hasOwnProperty("linkExpireTimeMs"))
                            if (!$util.isInteger(message.linkExpireTimeMs) && !(message.linkExpireTimeMs && $util.isInteger(message.linkExpireTimeMs.low) && $util.isInteger(message.linkExpireTimeMs.high)))
                                return "linkExpireTimeMs: integer|Long expected";
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            if (typeof message.isDeleted !== "boolean")
                                return "isDeleted: boolean expected";
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            if (!$util.isString(message.linkId))
                                return "linkId: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.maxSubmissions != null && message.hasOwnProperty("maxSubmissions"))
                            if (!$util.isInteger(message.maxSubmissions))
                                return "maxSubmissions: integer expected";
                        if (message.mappingData != null && message.hasOwnProperty("mappingData")) {
                            var error = $root.palexy.task_management.v1.ContactListMappingData.verify(message.mappingData);
                            if (error)
                                return "mappingData." + error;
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            switch (message.source) {
                            default:
                                return "source: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.recipientCount != null && message.hasOwnProperty("recipientCount"))
                            if (!$util.isInteger(message.recipientCount))
                                return "recipientCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormContactList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormContactList} FormContactList
                     */
                    FormContactList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormContactList)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormContactList();
                        if (object.contactListId != null)
                            if ($util.Long)
                                (message.contactListId = $util.Long.fromValue(object.contactListId)).unsigned = false;
                            else if (typeof object.contactListId === "string")
                                message.contactListId = parseInt(object.contactListId, 10);
                            else if (typeof object.contactListId === "number")
                                message.contactListId = object.contactListId;
                            else if (typeof object.contactListId === "object")
                                message.contactListId = new $util.LongBits(object.contactListId.low >>> 0, object.contactListId.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.linkExpireTimeMs != null)
                            if ($util.Long)
                                (message.linkExpireTimeMs = $util.Long.fromValue(object.linkExpireTimeMs)).unsigned = false;
                            else if (typeof object.linkExpireTimeMs === "string")
                                message.linkExpireTimeMs = parseInt(object.linkExpireTimeMs, 10);
                            else if (typeof object.linkExpireTimeMs === "number")
                                message.linkExpireTimeMs = object.linkExpireTimeMs;
                            else if (typeof object.linkExpireTimeMs === "object")
                                message.linkExpireTimeMs = new $util.LongBits(object.linkExpireTimeMs.low >>> 0, object.linkExpireTimeMs.high >>> 0).toNumber();
                        if (object.isDeleted != null)
                            message.isDeleted = Boolean(object.isDeleted);
                        if (object.linkId != null)
                            message.linkId = String(object.linkId);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.maxSubmissions != null)
                            message.maxSubmissions = object.maxSubmissions | 0;
                        if (object.mappingData != null) {
                            if (typeof object.mappingData !== "object")
                                throw TypeError(".palexy.task_management.v1.FormContactList.mappingData: object expected");
                            message.mappingData = $root.palexy.task_management.v1.ContactListMappingData.fromObject(object.mappingData);
                        }
                        switch (object.source) {
                        case "FORM_CONTACT_LIST_SOURCE_UNSPECIFIED":
                        case 0:
                            message.source = 0;
                            break;
                        case "FILE_UPLOAD":
                        case 1:
                            message.source = 1;
                            break;
                        case "API":
                        case 2:
                            message.source = 2;
                            break;
                        }
                        if (object.recipientCount != null)
                            message.recipientCount = object.recipientCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormContactList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormContactList
                     * @static
                     * @param {palexy.task_management.v1.FormContactList} message FormContactList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormContactList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactListId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.linkExpireTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.linkExpireTimeMs = options.longs === String ? "0" : 0;
                            object.isDeleted = false;
                            object.linkId = "";
                            object.name = "";
                            object.maxSubmissions = 0;
                            object.mappingData = null;
                            object.source = options.enums === String ? "FORM_CONTACT_LIST_SOURCE_UNSPECIFIED" : 0;
                            object.recipientCount = 0;
                        }
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (typeof message.contactListId === "number")
                                object.contactListId = options.longs === String ? String(message.contactListId) : message.contactListId;
                            else
                                object.contactListId = options.longs === String ? $util.Long.prototype.toString.call(message.contactListId) : options.longs === Number ? new $util.LongBits(message.contactListId.low >>> 0, message.contactListId.high >>> 0).toNumber() : message.contactListId;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.linkExpireTimeMs != null && message.hasOwnProperty("linkExpireTimeMs"))
                            if (typeof message.linkExpireTimeMs === "number")
                                object.linkExpireTimeMs = options.longs === String ? String(message.linkExpireTimeMs) : message.linkExpireTimeMs;
                            else
                                object.linkExpireTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.linkExpireTimeMs) : options.longs === Number ? new $util.LongBits(message.linkExpireTimeMs.low >>> 0, message.linkExpireTimeMs.high >>> 0).toNumber() : message.linkExpireTimeMs;
                        if (message.isDeleted != null && message.hasOwnProperty("isDeleted"))
                            object.isDeleted = message.isDeleted;
                        if (message.linkId != null && message.hasOwnProperty("linkId"))
                            object.linkId = message.linkId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.maxSubmissions != null && message.hasOwnProperty("maxSubmissions"))
                            object.maxSubmissions = message.maxSubmissions;
                        if (message.mappingData != null && message.hasOwnProperty("mappingData"))
                            object.mappingData = $root.palexy.task_management.v1.ContactListMappingData.toObject(message.mappingData, options);
                        if (message.source != null && message.hasOwnProperty("source"))
                            object.source = options.enums === String ? $root.palexy.task_management.v1.FormContactListSource[message.source] : message.source;
                        if (message.recipientCount != null && message.hasOwnProperty("recipientCount"))
                            object.recipientCount = message.recipientCount;
                        return object;
                    };
    
                    /**
                     * Converts this FormContactList to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormContactList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormContactList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormContactList;
                })();
    
                v1.ContactListMappingData = (function() {
    
                    /**
                     * Properties of a ContactListMappingData.
                     * @memberof palexy.task_management.v1
                     * @interface IContactListMappingData
                     * @property {Array.<palexy.task_management.v1.IFormContactListColumnMapping>|null} [attrMapping] ContactListMappingData attrMapping
                     */
    
                    /**
                     * Constructs a new ContactListMappingData.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ContactListMappingData.
                     * @implements IContactListMappingData
                     * @constructor
                     * @param {palexy.task_management.v1.IContactListMappingData=} [properties] Properties to set
                     */
                    function ContactListMappingData(properties) {
                        this.attrMapping = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ContactListMappingData attrMapping.
                     * @member {Array.<palexy.task_management.v1.IFormContactListColumnMapping>} attrMapping
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @instance
                     */
                    ContactListMappingData.prototype.attrMapping = $util.emptyArray;
    
                    /**
                     * Creates a new ContactListMappingData instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {palexy.task_management.v1.IContactListMappingData=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ContactListMappingData} ContactListMappingData instance
                     */
                    ContactListMappingData.create = function create(properties) {
                        return new ContactListMappingData(properties);
                    };
    
                    /**
                     * Encodes the specified ContactListMappingData message. Does not implicitly {@link palexy.task_management.v1.ContactListMappingData.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {palexy.task_management.v1.IContactListMappingData} message ContactListMappingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactListMappingData.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attrMapping != null && message.attrMapping.length)
                            for (var i = 0; i < message.attrMapping.length; ++i)
                                $root.palexy.task_management.v1.FormContactListColumnMapping.encode(message.attrMapping[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ContactListMappingData message, length delimited. Does not implicitly {@link palexy.task_management.v1.ContactListMappingData.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {palexy.task_management.v1.IContactListMappingData} message ContactListMappingData message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactListMappingData.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ContactListMappingData message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ContactListMappingData} ContactListMappingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactListMappingData.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ContactListMappingData();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.attrMapping && message.attrMapping.length))
                                    message.attrMapping = [];
                                message.attrMapping.push($root.palexy.task_management.v1.FormContactListColumnMapping.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ContactListMappingData message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ContactListMappingData} ContactListMappingData
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactListMappingData.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ContactListMappingData message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ContactListMappingData.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attrMapping != null && message.hasOwnProperty("attrMapping")) {
                            if (!Array.isArray(message.attrMapping))
                                return "attrMapping: array expected";
                            for (var i = 0; i < message.attrMapping.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormContactListColumnMapping.verify(message.attrMapping[i]);
                                if (error)
                                    return "attrMapping." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ContactListMappingData message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ContactListMappingData} ContactListMappingData
                     */
                    ContactListMappingData.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ContactListMappingData)
                            return object;
                        var message = new $root.palexy.task_management.v1.ContactListMappingData();
                        if (object.attrMapping) {
                            if (!Array.isArray(object.attrMapping))
                                throw TypeError(".palexy.task_management.v1.ContactListMappingData.attrMapping: array expected");
                            message.attrMapping = [];
                            for (var i = 0; i < object.attrMapping.length; ++i) {
                                if (typeof object.attrMapping[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ContactListMappingData.attrMapping: object expected");
                                message.attrMapping[i] = $root.palexy.task_management.v1.FormContactListColumnMapping.fromObject(object.attrMapping[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ContactListMappingData message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @static
                     * @param {palexy.task_management.v1.ContactListMappingData} message ContactListMappingData
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ContactListMappingData.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.attrMapping = [];
                        if (message.attrMapping && message.attrMapping.length) {
                            object.attrMapping = [];
                            for (var j = 0; j < message.attrMapping.length; ++j)
                                object.attrMapping[j] = $root.palexy.task_management.v1.FormContactListColumnMapping.toObject(message.attrMapping[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ContactListMappingData to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ContactListMappingData
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ContactListMappingData.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ContactListMappingData;
                })();
    
                v1.FormContactListColumnMapping = (function() {
    
                    /**
                     * Properties of a FormContactListColumnMapping.
                     * @memberof palexy.task_management.v1
                     * @interface IFormContactListColumnMapping
                     * @property {string|null} [header] FormContactListColumnMapping header
                     * @property {string|null} [matchedAttributeCode] FormContactListColumnMapping matchedAttributeCode
                     */
    
                    /**
                     * Constructs a new FormContactListColumnMapping.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormContactListColumnMapping.
                     * @implements IFormContactListColumnMapping
                     * @constructor
                     * @param {palexy.task_management.v1.IFormContactListColumnMapping=} [properties] Properties to set
                     */
                    function FormContactListColumnMapping(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormContactListColumnMapping header.
                     * @member {string} header
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @instance
                     */
                    FormContactListColumnMapping.prototype.header = "";
    
                    /**
                     * FormContactListColumnMapping matchedAttributeCode.
                     * @member {string} matchedAttributeCode
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @instance
                     */
                    FormContactListColumnMapping.prototype.matchedAttributeCode = "";
    
                    /**
                     * Creates a new FormContactListColumnMapping instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListColumnMapping=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormContactListColumnMapping} FormContactListColumnMapping instance
                     */
                    FormContactListColumnMapping.create = function create(properties) {
                        return new FormContactListColumnMapping(properties);
                    };
    
                    /**
                     * Encodes the specified FormContactListColumnMapping message. Does not implicitly {@link palexy.task_management.v1.FormContactListColumnMapping.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListColumnMapping} message FormContactListColumnMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactListColumnMapping.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.header != null && Object.hasOwnProperty.call(message, "header"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.header);
                        if (message.matchedAttributeCode != null && Object.hasOwnProperty.call(message, "matchedAttributeCode"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.matchedAttributeCode);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormContactListColumnMapping message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormContactListColumnMapping.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListColumnMapping} message FormContactListColumnMapping message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactListColumnMapping.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormContactListColumnMapping message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormContactListColumnMapping} FormContactListColumnMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactListColumnMapping.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormContactListColumnMapping();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.header = reader.string();
                                break;
                            case 2:
                                message.matchedAttributeCode = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormContactListColumnMapping message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormContactListColumnMapping} FormContactListColumnMapping
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactListColumnMapping.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormContactListColumnMapping message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormContactListColumnMapping.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.header != null && message.hasOwnProperty("header"))
                            if (!$util.isString(message.header))
                                return "header: string expected";
                        if (message.matchedAttributeCode != null && message.hasOwnProperty("matchedAttributeCode"))
                            if (!$util.isString(message.matchedAttributeCode))
                                return "matchedAttributeCode: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormContactListColumnMapping message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormContactListColumnMapping} FormContactListColumnMapping
                     */
                    FormContactListColumnMapping.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormContactListColumnMapping)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormContactListColumnMapping();
                        if (object.header != null)
                            message.header = String(object.header);
                        if (object.matchedAttributeCode != null)
                            message.matchedAttributeCode = String(object.matchedAttributeCode);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormContactListColumnMapping message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @static
                     * @param {palexy.task_management.v1.FormContactListColumnMapping} message FormContactListColumnMapping
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormContactListColumnMapping.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.header = "";
                            object.matchedAttributeCode = "";
                        }
                        if (message.header != null && message.hasOwnProperty("header"))
                            object.header = message.header;
                        if (message.matchedAttributeCode != null && message.hasOwnProperty("matchedAttributeCode"))
                            object.matchedAttributeCode = message.matchedAttributeCode;
                        return object;
                    };
    
                    /**
                     * Converts this FormContactListColumnMapping to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormContactListColumnMapping
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormContactListColumnMapping.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormContactListColumnMapping;
                })();
    
                v1.FormContactListRecipientItem = (function() {
    
                    /**
                     * Properties of a FormContactListRecipientItem.
                     * @memberof palexy.task_management.v1
                     * @interface IFormContactListRecipientItem
                     * @property {string|null} [linkToken] FormContactListRecipientItem linkToken
                     * @property {string|null} [embeddedValue] FormContactListRecipientItem embeddedValue
                     */
    
                    /**
                     * Constructs a new FormContactListRecipientItem.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormContactListRecipientItem.
                     * @implements IFormContactListRecipientItem
                     * @constructor
                     * @param {palexy.task_management.v1.IFormContactListRecipientItem=} [properties] Properties to set
                     */
                    function FormContactListRecipientItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormContactListRecipientItem linkToken.
                     * @member {string} linkToken
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @instance
                     */
                    FormContactListRecipientItem.prototype.linkToken = "";
    
                    /**
                     * FormContactListRecipientItem embeddedValue.
                     * @member {string} embeddedValue
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @instance
                     */
                    FormContactListRecipientItem.prototype.embeddedValue = "";
    
                    /**
                     * Creates a new FormContactListRecipientItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListRecipientItem=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormContactListRecipientItem} FormContactListRecipientItem instance
                     */
                    FormContactListRecipientItem.create = function create(properties) {
                        return new FormContactListRecipientItem(properties);
                    };
    
                    /**
                     * Encodes the specified FormContactListRecipientItem message. Does not implicitly {@link palexy.task_management.v1.FormContactListRecipientItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListRecipientItem} message FormContactListRecipientItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactListRecipientItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.linkToken != null && Object.hasOwnProperty.call(message, "linkToken"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.linkToken);
                        if (message.embeddedValue != null && Object.hasOwnProperty.call(message, "embeddedValue"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.embeddedValue);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormContactListRecipientItem message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormContactListRecipientItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {palexy.task_management.v1.IFormContactListRecipientItem} message FormContactListRecipientItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormContactListRecipientItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormContactListRecipientItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormContactListRecipientItem} FormContactListRecipientItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactListRecipientItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormContactListRecipientItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.linkToken = reader.string();
                                break;
                            case 2:
                                message.embeddedValue = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormContactListRecipientItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormContactListRecipientItem} FormContactListRecipientItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormContactListRecipientItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormContactListRecipientItem message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormContactListRecipientItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.linkToken != null && message.hasOwnProperty("linkToken"))
                            if (!$util.isString(message.linkToken))
                                return "linkToken: string expected";
                        if (message.embeddedValue != null && message.hasOwnProperty("embeddedValue"))
                            if (!$util.isString(message.embeddedValue))
                                return "embeddedValue: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormContactListRecipientItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormContactListRecipientItem} FormContactListRecipientItem
                     */
                    FormContactListRecipientItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormContactListRecipientItem)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormContactListRecipientItem();
                        if (object.linkToken != null)
                            message.linkToken = String(object.linkToken);
                        if (object.embeddedValue != null)
                            message.embeddedValue = String(object.embeddedValue);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormContactListRecipientItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @static
                     * @param {palexy.task_management.v1.FormContactListRecipientItem} message FormContactListRecipientItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormContactListRecipientItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.linkToken = "";
                            object.embeddedValue = "";
                        }
                        if (message.linkToken != null && message.hasOwnProperty("linkToken"))
                            object.linkToken = message.linkToken;
                        if (message.embeddedValue != null && message.hasOwnProperty("embeddedValue"))
                            object.embeddedValue = message.embeddedValue;
                        return object;
                    };
    
                    /**
                     * Converts this FormContactListRecipientItem to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormContactListRecipientItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormContactListRecipientItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormContactListRecipientItem;
                })();
    
                v1.ListFormContactListRecipientsRequest = (function() {
    
                    /**
                     * Properties of a ListFormContactListRecipientsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormContactListRecipientsRequest
                     * @property {number|null} [formId] ListFormContactListRecipientsRequest formId
                     * @property {number|null} [contactListId] ListFormContactListRecipientsRequest contactListId
                     */
    
                    /**
                     * Constructs a new ListFormContactListRecipientsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormContactListRecipientsRequest.
                     * @implements IListFormContactListRecipientsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest=} [properties] Properties to set
                     */
                    function ListFormContactListRecipientsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormContactListRecipientsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @instance
                     */
                    ListFormContactListRecipientsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormContactListRecipientsRequest contactListId.
                     * @member {number} contactListId
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @instance
                     */
                    ListFormContactListRecipientsRequest.prototype.contactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListFormContactListRecipientsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsRequest} ListFormContactListRecipientsRequest instance
                     */
                    ListFormContactListRecipientsRequest.create = function create(properties) {
                        return new ListFormContactListRecipientsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormContactListRecipientsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormContactListRecipientsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest} message ListFormContactListRecipientsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListRecipientsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.contactListId != null && Object.hasOwnProperty.call(message, "contactListId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.contactListId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormContactListRecipientsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormContactListRecipientsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsRequest} message ListFormContactListRecipientsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListRecipientsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormContactListRecipientsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsRequest} ListFormContactListRecipientsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListRecipientsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormContactListRecipientsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.contactListId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormContactListRecipientsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsRequest} ListFormContactListRecipientsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListRecipientsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormContactListRecipientsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormContactListRecipientsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (!$util.isInteger(message.contactListId) && !(message.contactListId && $util.isInteger(message.contactListId.low) && $util.isInteger(message.contactListId.high)))
                                return "contactListId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormContactListRecipientsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsRequest} ListFormContactListRecipientsRequest
                     */
                    ListFormContactListRecipientsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormContactListRecipientsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormContactListRecipientsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.contactListId != null)
                            if ($util.Long)
                                (message.contactListId = $util.Long.fromValue(object.contactListId)).unsigned = false;
                            else if (typeof object.contactListId === "string")
                                message.contactListId = parseInt(object.contactListId, 10);
                            else if (typeof object.contactListId === "number")
                                message.contactListId = object.contactListId;
                            else if (typeof object.contactListId === "object")
                                message.contactListId = new $util.LongBits(object.contactListId.low >>> 0, object.contactListId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormContactListRecipientsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormContactListRecipientsRequest} message ListFormContactListRecipientsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormContactListRecipientsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactListId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (typeof message.contactListId === "number")
                                object.contactListId = options.longs === String ? String(message.contactListId) : message.contactListId;
                            else
                                object.contactListId = options.longs === String ? $util.Long.prototype.toString.call(message.contactListId) : options.longs === Number ? new $util.LongBits(message.contactListId.low >>> 0, message.contactListId.high >>> 0).toNumber() : message.contactListId;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormContactListRecipientsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormContactListRecipientsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormContactListRecipientsRequest;
                })();
    
                v1.ListFormContactListRecipientsResponse = (function() {
    
                    /**
                     * Properties of a ListFormContactListRecipientsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormContactListRecipientsResponse
                     * @property {palexy.task_management.v1.IFormContactList|null} [contactList] ListFormContactListRecipientsResponse contactList
                     * @property {Array.<palexy.task_management.v1.IFormContactListRecipientItem>|null} [recipients] ListFormContactListRecipientsResponse recipients
                     */
    
                    /**
                     * Constructs a new ListFormContactListRecipientsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormContactListRecipientsResponse.
                     * @implements IListFormContactListRecipientsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsResponse=} [properties] Properties to set
                     */
                    function ListFormContactListRecipientsResponse(properties) {
                        this.recipients = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormContactListRecipientsResponse contactList.
                     * @member {palexy.task_management.v1.IFormContactList|null|undefined} contactList
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @instance
                     */
                    ListFormContactListRecipientsResponse.prototype.contactList = null;
    
                    /**
                     * ListFormContactListRecipientsResponse recipients.
                     * @member {Array.<palexy.task_management.v1.IFormContactListRecipientItem>} recipients
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @instance
                     */
                    ListFormContactListRecipientsResponse.prototype.recipients = $util.emptyArray;
    
                    /**
                     * Creates a new ListFormContactListRecipientsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsResponse} ListFormContactListRecipientsResponse instance
                     */
                    ListFormContactListRecipientsResponse.create = function create(properties) {
                        return new ListFormContactListRecipientsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormContactListRecipientsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormContactListRecipientsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsResponse} message ListFormContactListRecipientsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListRecipientsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contactList != null && Object.hasOwnProperty.call(message, "contactList"))
                            $root.palexy.task_management.v1.FormContactList.encode(message.contactList, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.recipients != null && message.recipients.length)
                            for (var i = 0; i < message.recipients.length; ++i)
                                $root.palexy.task_management.v1.FormContactListRecipientItem.encode(message.recipients[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormContactListRecipientsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormContactListRecipientsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListRecipientsResponse} message ListFormContactListRecipientsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListRecipientsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormContactListRecipientsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsResponse} ListFormContactListRecipientsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListRecipientsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormContactListRecipientsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.contactList = $root.palexy.task_management.v1.FormContactList.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.recipients && message.recipients.length))
                                    message.recipients = [];
                                message.recipients.push($root.palexy.task_management.v1.FormContactListRecipientItem.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormContactListRecipientsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsResponse} ListFormContactListRecipientsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListRecipientsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormContactListRecipientsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormContactListRecipientsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contactList != null && message.hasOwnProperty("contactList")) {
                            var error = $root.palexy.task_management.v1.FormContactList.verify(message.contactList);
                            if (error)
                                return "contactList." + error;
                        }
                        if (message.recipients != null && message.hasOwnProperty("recipients")) {
                            if (!Array.isArray(message.recipients))
                                return "recipients: array expected";
                            for (var i = 0; i < message.recipients.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormContactListRecipientItem.verify(message.recipients[i]);
                                if (error)
                                    return "recipients." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFormContactListRecipientsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormContactListRecipientsResponse} ListFormContactListRecipientsResponse
                     */
                    ListFormContactListRecipientsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormContactListRecipientsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormContactListRecipientsResponse();
                        if (object.contactList != null) {
                            if (typeof object.contactList !== "object")
                                throw TypeError(".palexy.task_management.v1.ListFormContactListRecipientsResponse.contactList: object expected");
                            message.contactList = $root.palexy.task_management.v1.FormContactList.fromObject(object.contactList);
                        }
                        if (object.recipients) {
                            if (!Array.isArray(object.recipients))
                                throw TypeError(".palexy.task_management.v1.ListFormContactListRecipientsResponse.recipients: array expected");
                            message.recipients = [];
                            for (var i = 0; i < object.recipients.length; ++i) {
                                if (typeof object.recipients[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormContactListRecipientsResponse.recipients: object expected");
                                message.recipients[i] = $root.palexy.task_management.v1.FormContactListRecipientItem.fromObject(object.recipients[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormContactListRecipientsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormContactListRecipientsResponse} message ListFormContactListRecipientsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormContactListRecipientsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.recipients = [];
                        if (options.defaults)
                            object.contactList = null;
                        if (message.contactList != null && message.hasOwnProperty("contactList"))
                            object.contactList = $root.palexy.task_management.v1.FormContactList.toObject(message.contactList, options);
                        if (message.recipients && message.recipients.length) {
                            object.recipients = [];
                            for (var j = 0; j < message.recipients.length; ++j)
                                object.recipients[j] = $root.palexy.task_management.v1.FormContactListRecipientItem.toObject(message.recipients[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFormContactListRecipientsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormContactListRecipientsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormContactListRecipientsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormContactListRecipientsResponse;
                })();
    
                v1.FormDistributionRecipientInput = (function() {
    
                    /**
                     * Properties of a FormDistributionRecipientInput.
                     * @memberof palexy.task_management.v1
                     * @interface IFormDistributionRecipientInput
                     * @property {Array.<string>|null} [embeddedValues] FormDistributionRecipientInput embeddedValues
                     * @property {string|null} [embeddedValue] FormDistributionRecipientInput embeddedValue
                     */
    
                    /**
                     * Constructs a new FormDistributionRecipientInput.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormDistributionRecipientInput.
                     * @implements IFormDistributionRecipientInput
                     * @constructor
                     * @param {palexy.task_management.v1.IFormDistributionRecipientInput=} [properties] Properties to set
                     */
                    function FormDistributionRecipientInput(properties) {
                        this.embeddedValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormDistributionRecipientInput embeddedValues.
                     * @member {Array.<string>} embeddedValues
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @instance
                     */
                    FormDistributionRecipientInput.prototype.embeddedValues = $util.emptyArray;
    
                    /**
                     * FormDistributionRecipientInput embeddedValue.
                     * @member {string} embeddedValue
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @instance
                     */
                    FormDistributionRecipientInput.prototype.embeddedValue = "";
    
                    /**
                     * Creates a new FormDistributionRecipientInput instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {palexy.task_management.v1.IFormDistributionRecipientInput=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormDistributionRecipientInput} FormDistributionRecipientInput instance
                     */
                    FormDistributionRecipientInput.create = function create(properties) {
                        return new FormDistributionRecipientInput(properties);
                    };
    
                    /**
                     * Encodes the specified FormDistributionRecipientInput message. Does not implicitly {@link palexy.task_management.v1.FormDistributionRecipientInput.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {palexy.task_management.v1.IFormDistributionRecipientInput} message FormDistributionRecipientInput message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormDistributionRecipientInput.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.embeddedValues != null && message.embeddedValues.length)
                            for (var i = 0; i < message.embeddedValues.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.embeddedValues[i]);
                        if (message.embeddedValue != null && Object.hasOwnProperty.call(message, "embeddedValue"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.embeddedValue);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormDistributionRecipientInput message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormDistributionRecipientInput.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {palexy.task_management.v1.IFormDistributionRecipientInput} message FormDistributionRecipientInput message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormDistributionRecipientInput.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormDistributionRecipientInput message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormDistributionRecipientInput} FormDistributionRecipientInput
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormDistributionRecipientInput.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormDistributionRecipientInput();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 3:
                                if (!(message.embeddedValues && message.embeddedValues.length))
                                    message.embeddedValues = [];
                                message.embeddedValues.push(reader.string());
                                break;
                            case 4:
                                message.embeddedValue = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormDistributionRecipientInput message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormDistributionRecipientInput} FormDistributionRecipientInput
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormDistributionRecipientInput.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormDistributionRecipientInput message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormDistributionRecipientInput.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.embeddedValues != null && message.hasOwnProperty("embeddedValues")) {
                            if (!Array.isArray(message.embeddedValues))
                                return "embeddedValues: array expected";
                            for (var i = 0; i < message.embeddedValues.length; ++i)
                                if (!$util.isString(message.embeddedValues[i]))
                                    return "embeddedValues: string[] expected";
                        }
                        if (message.embeddedValue != null && message.hasOwnProperty("embeddedValue"))
                            if (!$util.isString(message.embeddedValue))
                                return "embeddedValue: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormDistributionRecipientInput message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormDistributionRecipientInput} FormDistributionRecipientInput
                     */
                    FormDistributionRecipientInput.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormDistributionRecipientInput)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormDistributionRecipientInput();
                        if (object.embeddedValues) {
                            if (!Array.isArray(object.embeddedValues))
                                throw TypeError(".palexy.task_management.v1.FormDistributionRecipientInput.embeddedValues: array expected");
                            message.embeddedValues = [];
                            for (var i = 0; i < object.embeddedValues.length; ++i)
                                message.embeddedValues[i] = String(object.embeddedValues[i]);
                        }
                        if (object.embeddedValue != null)
                            message.embeddedValue = String(object.embeddedValue);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormDistributionRecipientInput message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @static
                     * @param {palexy.task_management.v1.FormDistributionRecipientInput} message FormDistributionRecipientInput
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormDistributionRecipientInput.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.embeddedValues = [];
                        if (options.defaults)
                            object.embeddedValue = "";
                        if (message.embeddedValues && message.embeddedValues.length) {
                            object.embeddedValues = [];
                            for (var j = 0; j < message.embeddedValues.length; ++j)
                                object.embeddedValues[j] = message.embeddedValues[j];
                        }
                        if (message.embeddedValue != null && message.hasOwnProperty("embeddedValue"))
                            object.embeddedValue = message.embeddedValue;
                        return object;
                    };
    
                    /**
                     * Converts this FormDistributionRecipientInput to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormDistributionRecipientInput
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormDistributionRecipientInput.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormDistributionRecipientInput;
                })();
    
                v1.CreateFormContactListRequest = (function() {
    
                    /**
                     * Properties of a CreateFormContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormContactListRequest
                     * @property {number|null} [formId] CreateFormContactListRequest formId
                     * @property {number|null} [linkExpireTimeMs] CreateFormContactListRequest linkExpireTimeMs
                     * @property {Array.<string>|null} [headers] CreateFormContactListRequest headers
                     * @property {string|null} [name] CreateFormContactListRequest name
                     * @property {number|null} [maxSubmissions] CreateFormContactListRequest maxSubmissions
                     * @property {Array.<palexy.task_management.v1.IFormDistributionRecipientInput>|null} [recipients] CreateFormContactListRequest recipients
                     * @property {palexy.task_management.v1.FormContactListSource|null} [source] CreateFormContactListRequest source
                     */
    
                    /**
                     * Constructs a new CreateFormContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormContactListRequest.
                     * @implements ICreateFormContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest=} [properties] Properties to set
                     */
                    function CreateFormContactListRequest(properties) {
                        this.headers = [];
                        this.recipients = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormContactListRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormContactListRequest linkExpireTimeMs.
                     * @member {number} linkExpireTimeMs
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.linkExpireTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormContactListRequest headers.
                     * @member {Array.<string>} headers
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.headers = $util.emptyArray;
    
                    /**
                     * CreateFormContactListRequest name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.name = "";
    
                    /**
                     * CreateFormContactListRequest maxSubmissions.
                     * @member {number} maxSubmissions
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.maxSubmissions = 0;
    
                    /**
                     * CreateFormContactListRequest recipients.
                     * @member {Array.<palexy.task_management.v1.IFormDistributionRecipientInput>} recipients
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.recipients = $util.emptyArray;
    
                    /**
                     * CreateFormContactListRequest source.
                     * @member {palexy.task_management.v1.FormContactListSource} source
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     */
                    CreateFormContactListRequest.prototype.source = 0;
    
                    /**
                     * Creates a new CreateFormContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormContactListRequest} CreateFormContactListRequest instance
                     */
                    CreateFormContactListRequest.create = function create(properties) {
                        return new CreateFormContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormContactListRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest} message CreateFormContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.linkExpireTimeMs != null && Object.hasOwnProperty.call(message, "linkExpireTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.linkExpireTimeMs);
                        if (message.headers != null && message.headers.length)
                            for (var i = 0; i < message.headers.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.headers[i]);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.name);
                        if (message.maxSubmissions != null && Object.hasOwnProperty.call(message, "maxSubmissions"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.maxSubmissions);
                        if (message.recipients != null && message.recipients.length)
                            for (var i = 0; i < message.recipients.length; ++i)
                                $root.palexy.task_management.v1.FormDistributionRecipientInput.encode(message.recipients[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.source);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormContactListRequest} message CreateFormContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormContactListRequest} CreateFormContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.linkExpireTimeMs = reader.int64();
                                break;
                            case 5:
                                if (!(message.headers && message.headers.length))
                                    message.headers = [];
                                message.headers.push(reader.string());
                                break;
                            case 6:
                                message.name = reader.string();
                                break;
                            case 7:
                                message.maxSubmissions = reader.int32();
                                break;
                            case 8:
                                if (!(message.recipients && message.recipients.length))
                                    message.recipients = [];
                                message.recipients.push($root.palexy.task_management.v1.FormDistributionRecipientInput.decode(reader, reader.uint32()));
                                break;
                            case 9:
                                message.source = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormContactListRequest} CreateFormContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.linkExpireTimeMs != null && message.hasOwnProperty("linkExpireTimeMs"))
                            if (!$util.isInteger(message.linkExpireTimeMs) && !(message.linkExpireTimeMs && $util.isInteger(message.linkExpireTimeMs.low) && $util.isInteger(message.linkExpireTimeMs.high)))
                                return "linkExpireTimeMs: integer|Long expected";
                        if (message.headers != null && message.hasOwnProperty("headers")) {
                            if (!Array.isArray(message.headers))
                                return "headers: array expected";
                            for (var i = 0; i < message.headers.length; ++i)
                                if (!$util.isString(message.headers[i]))
                                    return "headers: string[] expected";
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.maxSubmissions != null && message.hasOwnProperty("maxSubmissions"))
                            if (!$util.isInteger(message.maxSubmissions))
                                return "maxSubmissions: integer expected";
                        if (message.recipients != null && message.hasOwnProperty("recipients")) {
                            if (!Array.isArray(message.recipients))
                                return "recipients: array expected";
                            for (var i = 0; i < message.recipients.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormDistributionRecipientInput.verify(message.recipients[i]);
                                if (error)
                                    return "recipients." + error;
                            }
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            switch (message.source) {
                            default:
                                return "source: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormContactListRequest} CreateFormContactListRequest
                     */
                    CreateFormContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormContactListRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.linkExpireTimeMs != null)
                            if ($util.Long)
                                (message.linkExpireTimeMs = $util.Long.fromValue(object.linkExpireTimeMs)).unsigned = false;
                            else if (typeof object.linkExpireTimeMs === "string")
                                message.linkExpireTimeMs = parseInt(object.linkExpireTimeMs, 10);
                            else if (typeof object.linkExpireTimeMs === "number")
                                message.linkExpireTimeMs = object.linkExpireTimeMs;
                            else if (typeof object.linkExpireTimeMs === "object")
                                message.linkExpireTimeMs = new $util.LongBits(object.linkExpireTimeMs.low >>> 0, object.linkExpireTimeMs.high >>> 0).toNumber();
                        if (object.headers) {
                            if (!Array.isArray(object.headers))
                                throw TypeError(".palexy.task_management.v1.CreateFormContactListRequest.headers: array expected");
                            message.headers = [];
                            for (var i = 0; i < object.headers.length; ++i)
                                message.headers[i] = String(object.headers[i]);
                        }
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.maxSubmissions != null)
                            message.maxSubmissions = object.maxSubmissions | 0;
                        if (object.recipients) {
                            if (!Array.isArray(object.recipients))
                                throw TypeError(".palexy.task_management.v1.CreateFormContactListRequest.recipients: array expected");
                            message.recipients = [];
                            for (var i = 0; i < object.recipients.length; ++i) {
                                if (typeof object.recipients[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CreateFormContactListRequest.recipients: object expected");
                                message.recipients[i] = $root.palexy.task_management.v1.FormDistributionRecipientInput.fromObject(object.recipients[i]);
                            }
                        }
                        switch (object.source) {
                        case "FORM_CONTACT_LIST_SOURCE_UNSPECIFIED":
                        case 0:
                            message.source = 0;
                            break;
                        case "FILE_UPLOAD":
                        case 1:
                            message.source = 1;
                            break;
                        case "API":
                        case 2:
                            message.source = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormContactListRequest} message CreateFormContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.headers = [];
                            object.recipients = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.linkExpireTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.linkExpireTimeMs = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.maxSubmissions = 0;
                            object.source = options.enums === String ? "FORM_CONTACT_LIST_SOURCE_UNSPECIFIED" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.linkExpireTimeMs != null && message.hasOwnProperty("linkExpireTimeMs"))
                            if (typeof message.linkExpireTimeMs === "number")
                                object.linkExpireTimeMs = options.longs === String ? String(message.linkExpireTimeMs) : message.linkExpireTimeMs;
                            else
                                object.linkExpireTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.linkExpireTimeMs) : options.longs === Number ? new $util.LongBits(message.linkExpireTimeMs.low >>> 0, message.linkExpireTimeMs.high >>> 0).toNumber() : message.linkExpireTimeMs;
                        if (message.headers && message.headers.length) {
                            object.headers = [];
                            for (var j = 0; j < message.headers.length; ++j)
                                object.headers[j] = message.headers[j];
                        }
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.maxSubmissions != null && message.hasOwnProperty("maxSubmissions"))
                            object.maxSubmissions = message.maxSubmissions;
                        if (message.recipients && message.recipients.length) {
                            object.recipients = [];
                            for (var j = 0; j < message.recipients.length; ++j)
                                object.recipients[j] = $root.palexy.task_management.v1.FormDistributionRecipientInput.toObject(message.recipients[j], options);
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            object.source = options.enums === String ? $root.palexy.task_management.v1.FormContactListSource[message.source] : message.source;
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormContactListRequest;
                })();
    
                v1.ListFormContactListsRequest = (function() {
    
                    /**
                     * Properties of a ListFormContactListsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormContactListsRequest
                     * @property {number|null} [formId] ListFormContactListsRequest formId
                     * @property {number|null} [pageSize] ListFormContactListsRequest pageSize
                     * @property {string|null} [pageToken] ListFormContactListsRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListFormContactListsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormContactListsRequest.
                     * @implements IListFormContactListsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormContactListsRequest=} [properties] Properties to set
                     */
                    function ListFormContactListsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormContactListsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @instance
                     */
                    ListFormContactListsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormContactListsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @instance
                     */
                    ListFormContactListsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormContactListsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @instance
                     */
                    ListFormContactListsRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListFormContactListsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormContactListsRequest} ListFormContactListsRequest instance
                     */
                    ListFormContactListsRequest.create = function create(properties) {
                        return new ListFormContactListsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormContactListsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormContactListsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsRequest} message ListFormContactListsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormContactListsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormContactListsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsRequest} message ListFormContactListsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormContactListsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormContactListsRequest} ListFormContactListsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormContactListsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormContactListsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormContactListsRequest} ListFormContactListsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormContactListsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormContactListsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormContactListsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormContactListsRequest} ListFormContactListsRequest
                     */
                    ListFormContactListsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormContactListsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormContactListsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormContactListsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormContactListsRequest} message ListFormContactListsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormContactListsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormContactListsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormContactListsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormContactListsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormContactListsRequest;
                })();
    
                v1.ListFormContactListsResponse = (function() {
    
                    /**
                     * Properties of a ListFormContactListsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormContactListsResponse
                     * @property {Array.<palexy.task_management.v1.IFormContactList>|null} [contactLists] ListFormContactListsResponse contactLists
                     * @property {number|null} [totalElements] ListFormContactListsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormContactListsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormContactListsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormContactListsResponse.
                     * @implements IListFormContactListsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormContactListsResponse=} [properties] Properties to set
                     */
                    function ListFormContactListsResponse(properties) {
                        this.contactLists = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormContactListsResponse contactLists.
                     * @member {Array.<palexy.task_management.v1.IFormContactList>} contactLists
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @instance
                     */
                    ListFormContactListsResponse.prototype.contactLists = $util.emptyArray;
    
                    /**
                     * ListFormContactListsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @instance
                     */
                    ListFormContactListsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormContactListsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @instance
                     */
                    ListFormContactListsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormContactListsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormContactListsResponse} ListFormContactListsResponse instance
                     */
                    ListFormContactListsResponse.create = function create(properties) {
                        return new ListFormContactListsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormContactListsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormContactListsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsResponse} message ListFormContactListsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contactLists != null && message.contactLists.length)
                            for (var i = 0; i < message.contactLists.length; ++i)
                                $root.palexy.task_management.v1.FormContactList.encode(message.contactLists[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormContactListsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormContactListsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormContactListsResponse} message ListFormContactListsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormContactListsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormContactListsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormContactListsResponse} ListFormContactListsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormContactListsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.contactLists && message.contactLists.length))
                                    message.contactLists = [];
                                message.contactLists.push($root.palexy.task_management.v1.FormContactList.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormContactListsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormContactListsResponse} ListFormContactListsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormContactListsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormContactListsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormContactListsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contactLists != null && message.hasOwnProperty("contactLists")) {
                            if (!Array.isArray(message.contactLists))
                                return "contactLists: array expected";
                            for (var i = 0; i < message.contactLists.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormContactList.verify(message.contactLists[i]);
                                if (error)
                                    return "contactLists." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormContactListsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormContactListsResponse} ListFormContactListsResponse
                     */
                    ListFormContactListsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormContactListsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormContactListsResponse();
                        if (object.contactLists) {
                            if (!Array.isArray(object.contactLists))
                                throw TypeError(".palexy.task_management.v1.ListFormContactListsResponse.contactLists: array expected");
                            message.contactLists = [];
                            for (var i = 0; i < object.contactLists.length; ++i) {
                                if (typeof object.contactLists[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormContactListsResponse.contactLists: object expected");
                                message.contactLists[i] = $root.palexy.task_management.v1.FormContactList.fromObject(object.contactLists[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormContactListsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormContactListsResponse} message ListFormContactListsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormContactListsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.contactLists = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.contactLists && message.contactLists.length) {
                            object.contactLists = [];
                            for (var j = 0; j < message.contactLists.length; ++j)
                                object.contactLists[j] = $root.palexy.task_management.v1.FormContactList.toObject(message.contactLists[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormContactListsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormContactListsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormContactListsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormContactListsResponse;
                })();
    
                v1.DeleteFormContactListRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormContactListRequest
                     * @property {number|null} [formId] DeleteFormContactListRequest formId
                     * @property {number|null} [contactListId] DeleteFormContactListRequest contactListId
                     */
    
                    /**
                     * Constructs a new DeleteFormContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormContactListRequest.
                     * @implements IDeleteFormContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest=} [properties] Properties to set
                     */
                    function DeleteFormContactListRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormContactListRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @instance
                     */
                    DeleteFormContactListRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormContactListRequest contactListId.
                     * @member {number} contactListId
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @instance
                     */
                    DeleteFormContactListRequest.prototype.contactListId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormContactListRequest} DeleteFormContactListRequest instance
                     */
                    DeleteFormContactListRequest.create = function create(properties) {
                        return new DeleteFormContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormContactListRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest} message DeleteFormContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.contactListId != null && Object.hasOwnProperty.call(message, "contactListId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.contactListId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormContactListRequest} message DeleteFormContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormContactListRequest} DeleteFormContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.contactListId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormContactListRequest} DeleteFormContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (!$util.isInteger(message.contactListId) && !(message.contactListId && $util.isInteger(message.contactListId.low) && $util.isInteger(message.contactListId.high)))
                                return "contactListId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormContactListRequest} DeleteFormContactListRequest
                     */
                    DeleteFormContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormContactListRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.contactListId != null)
                            if ($util.Long)
                                (message.contactListId = $util.Long.fromValue(object.contactListId)).unsigned = false;
                            else if (typeof object.contactListId === "string")
                                message.contactListId = parseInt(object.contactListId, 10);
                            else if (typeof object.contactListId === "number")
                                message.contactListId = object.contactListId;
                            else if (typeof object.contactListId === "object")
                                message.contactListId = new $util.LongBits(object.contactListId.low >>> 0, object.contactListId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormContactListRequest} message DeleteFormContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactListId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactListId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.contactListId != null && message.hasOwnProperty("contactListId"))
                            if (typeof message.contactListId === "number")
                                object.contactListId = options.longs === String ? String(message.contactListId) : message.contactListId;
                            else
                                object.contactListId = options.longs === String ? $util.Long.prototype.toString.call(message.contactListId) : options.longs === Number ? new $util.LongBits(message.contactListId.low >>> 0, message.contactListId.high >>> 0).toNumber() : message.contactListId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormContactListRequest;
                })();
    
                v1.GetSubmissionStatisticsRequest = (function() {
    
                    /**
                     * Properties of a GetSubmissionStatisticsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetSubmissionStatisticsRequest
                     * @property {number|null} [formId] GetSubmissionStatisticsRequest formId
                     * @property {number|null} [formFieldId] GetSubmissionStatisticsRequest formFieldId
                     * @property {string|null} [startDateId] GetSubmissionStatisticsRequest startDateId
                     * @property {string|null} [endDateId] GetSubmissionStatisticsRequest endDateId
                     * @property {Array.<number>|null} [submissionIds] GetSubmissionStatisticsRequest submissionIds
                     */
    
                    /**
                     * Constructs a new GetSubmissionStatisticsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetSubmissionStatisticsRequest.
                     * @implements IGetSubmissionStatisticsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest=} [properties] Properties to set
                     */
                    function GetSubmissionStatisticsRequest(properties) {
                        this.submissionIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetSubmissionStatisticsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     */
                    GetSubmissionStatisticsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetSubmissionStatisticsRequest formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     */
                    GetSubmissionStatisticsRequest.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetSubmissionStatisticsRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     */
                    GetSubmissionStatisticsRequest.prototype.startDateId = "";
    
                    /**
                     * GetSubmissionStatisticsRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     */
                    GetSubmissionStatisticsRequest.prototype.endDateId = "";
    
                    /**
                     * GetSubmissionStatisticsRequest submissionIds.
                     * @member {Array.<number>} submissionIds
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     */
                    GetSubmissionStatisticsRequest.prototype.submissionIds = $util.emptyArray;
    
                    /**
                     * Creates a new GetSubmissionStatisticsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetSubmissionStatisticsRequest} GetSubmissionStatisticsRequest instance
                     */
                    GetSubmissionStatisticsRequest.create = function create(properties) {
                        return new GetSubmissionStatisticsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetSubmissionStatisticsRequest message. Does not implicitly {@link palexy.task_management.v1.GetSubmissionStatisticsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest} message GetSubmissionStatisticsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSubmissionStatisticsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formFieldId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateId);
                        if (message.submissionIds != null && message.submissionIds.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.submissionIds.length; ++i)
                                writer.int64(message.submissionIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetSubmissionStatisticsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetSubmissionStatisticsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetSubmissionStatisticsRequest} message GetSubmissionStatisticsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSubmissionStatisticsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetSubmissionStatisticsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetSubmissionStatisticsRequest} GetSubmissionStatisticsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSubmissionStatisticsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetSubmissionStatisticsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.formFieldId = reader.int64();
                                break;
                            case 3:
                                message.startDateId = reader.string();
                                break;
                            case 4:
                                message.endDateId = reader.string();
                                break;
                            case 5:
                                if (!(message.submissionIds && message.submissionIds.length))
                                    message.submissionIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.submissionIds.push(reader.int64());
                                } else
                                    message.submissionIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetSubmissionStatisticsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetSubmissionStatisticsRequest} GetSubmissionStatisticsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSubmissionStatisticsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetSubmissionStatisticsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetSubmissionStatisticsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        if (message.submissionIds != null && message.hasOwnProperty("submissionIds")) {
                            if (!Array.isArray(message.submissionIds))
                                return "submissionIds: array expected";
                            for (var i = 0; i < message.submissionIds.length; ++i)
                                if (!$util.isInteger(message.submissionIds[i]) && !(message.submissionIds[i] && $util.isInteger(message.submissionIds[i].low) && $util.isInteger(message.submissionIds[i].high)))
                                    return "submissionIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetSubmissionStatisticsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetSubmissionStatisticsRequest} GetSubmissionStatisticsRequest
                     */
                    GetSubmissionStatisticsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetSubmissionStatisticsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetSubmissionStatisticsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        if (object.submissionIds) {
                            if (!Array.isArray(object.submissionIds))
                                throw TypeError(".palexy.task_management.v1.GetSubmissionStatisticsRequest.submissionIds: array expected");
                            message.submissionIds = [];
                            for (var i = 0; i < object.submissionIds.length; ++i)
                                if ($util.Long)
                                    (message.submissionIds[i] = $util.Long.fromValue(object.submissionIds[i])).unsigned = false;
                                else if (typeof object.submissionIds[i] === "string")
                                    message.submissionIds[i] = parseInt(object.submissionIds[i], 10);
                                else if (typeof object.submissionIds[i] === "number")
                                    message.submissionIds[i] = object.submissionIds[i];
                                else if (typeof object.submissionIds[i] === "object")
                                    message.submissionIds[i] = new $util.LongBits(object.submissionIds[i].low >>> 0, object.submissionIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetSubmissionStatisticsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @static
                     * @param {palexy.task_management.v1.GetSubmissionStatisticsRequest} message GetSubmissionStatisticsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetSubmissionStatisticsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.submissionIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.submissionIds && message.submissionIds.length) {
                            object.submissionIds = [];
                            for (var j = 0; j < message.submissionIds.length; ++j)
                                if (typeof message.submissionIds[j] === "number")
                                    object.submissionIds[j] = options.longs === String ? String(message.submissionIds[j]) : message.submissionIds[j];
                                else
                                    object.submissionIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.submissionIds[j]) : options.longs === Number ? new $util.LongBits(message.submissionIds[j].low >>> 0, message.submissionIds[j].high >>> 0).toNumber() : message.submissionIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetSubmissionStatisticsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetSubmissionStatisticsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetSubmissionStatisticsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetSubmissionStatisticsRequest;
                })();
    
                v1.SubmissionStatistics = (function() {
    
                    /**
                     * Properties of a SubmissionStatistics.
                     * @memberof palexy.task_management.v1
                     * @interface ISubmissionStatistics
                     * @property {Array.<palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic>|null} [formFieldStatistics] SubmissionStatistics formFieldStatistics
                     * @property {number|null} [totalSubmissions] SubmissionStatistics totalSubmissions
                     * @property {number|null} [formId] SubmissionStatistics formId
                     * @property {Array.<palexy.task_management.v1.ISentimentFieldStatistic>|null} [sentimentStatistics] SubmissionStatistics sentimentStatistics
                     */
    
                    /**
                     * Constructs a new SubmissionStatistics.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SubmissionStatistics.
                     * @implements ISubmissionStatistics
                     * @constructor
                     * @param {palexy.task_management.v1.ISubmissionStatistics=} [properties] Properties to set
                     */
                    function SubmissionStatistics(properties) {
                        this.formFieldStatistics = [];
                        this.sentimentStatistics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SubmissionStatistics formFieldStatistics.
                     * @member {Array.<palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic>} formFieldStatistics
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @instance
                     */
                    SubmissionStatistics.prototype.formFieldStatistics = $util.emptyArray;
    
                    /**
                     * SubmissionStatistics totalSubmissions.
                     * @member {number} totalSubmissions
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @instance
                     */
                    SubmissionStatistics.prototype.totalSubmissions = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SubmissionStatistics formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @instance
                     */
                    SubmissionStatistics.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SubmissionStatistics sentimentStatistics.
                     * @member {Array.<palexy.task_management.v1.ISentimentFieldStatistic>} sentimentStatistics
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @instance
                     */
                    SubmissionStatistics.prototype.sentimentStatistics = $util.emptyArray;
    
                    /**
                     * Creates a new SubmissionStatistics instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {palexy.task_management.v1.ISubmissionStatistics=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SubmissionStatistics} SubmissionStatistics instance
                     */
                    SubmissionStatistics.create = function create(properties) {
                        return new SubmissionStatistics(properties);
                    };
    
                    /**
                     * Encodes the specified SubmissionStatistics message. Does not implicitly {@link palexy.task_management.v1.SubmissionStatistics.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {palexy.task_management.v1.ISubmissionStatistics} message SubmissionStatistics message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SubmissionStatistics.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formFieldStatistics != null && message.formFieldStatistics.length)
                            for (var i = 0; i < message.formFieldStatistics.length; ++i)
                                $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.encode(message.formFieldStatistics[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalSubmissions != null && Object.hasOwnProperty.call(message, "totalSubmissions"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalSubmissions);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.formId);
                        if (message.sentimentStatistics != null && message.sentimentStatistics.length)
                            for (var i = 0; i < message.sentimentStatistics.length; ++i)
                                $root.palexy.task_management.v1.SentimentFieldStatistic.encode(message.sentimentStatistics[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SubmissionStatistics message, length delimited. Does not implicitly {@link palexy.task_management.v1.SubmissionStatistics.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {palexy.task_management.v1.ISubmissionStatistics} message SubmissionStatistics message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SubmissionStatistics.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SubmissionStatistics message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SubmissionStatistics} SubmissionStatistics
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SubmissionStatistics.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SubmissionStatistics();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.formFieldStatistics && message.formFieldStatistics.length))
                                    message.formFieldStatistics = [];
                                message.formFieldStatistics.push($root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalSubmissions = reader.int64();
                                break;
                            case 3:
                                message.formId = reader.int64();
                                break;
                            case 4:
                                if (!(message.sentimentStatistics && message.sentimentStatistics.length))
                                    message.sentimentStatistics = [];
                                message.sentimentStatistics.push($root.palexy.task_management.v1.SentimentFieldStatistic.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SubmissionStatistics message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SubmissionStatistics} SubmissionStatistics
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SubmissionStatistics.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SubmissionStatistics message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SubmissionStatistics.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formFieldStatistics != null && message.hasOwnProperty("formFieldStatistics")) {
                            if (!Array.isArray(message.formFieldStatistics))
                                return "formFieldStatistics: array expected";
                            for (var i = 0; i < message.formFieldStatistics.length; ++i) {
                                var error = $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.verify(message.formFieldStatistics[i]);
                                if (error)
                                    return "formFieldStatistics." + error;
                            }
                        }
                        if (message.totalSubmissions != null && message.hasOwnProperty("totalSubmissions"))
                            if (!$util.isInteger(message.totalSubmissions) && !(message.totalSubmissions && $util.isInteger(message.totalSubmissions.low) && $util.isInteger(message.totalSubmissions.high)))
                                return "totalSubmissions: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.sentimentStatistics != null && message.hasOwnProperty("sentimentStatistics")) {
                            if (!Array.isArray(message.sentimentStatistics))
                                return "sentimentStatistics: array expected";
                            for (var i = 0; i < message.sentimentStatistics.length; ++i) {
                                var error = $root.palexy.task_management.v1.SentimentFieldStatistic.verify(message.sentimentStatistics[i]);
                                if (error)
                                    return "sentimentStatistics." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SubmissionStatistics message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SubmissionStatistics} SubmissionStatistics
                     */
                    SubmissionStatistics.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SubmissionStatistics)
                            return object;
                        var message = new $root.palexy.task_management.v1.SubmissionStatistics();
                        if (object.formFieldStatistics) {
                            if (!Array.isArray(object.formFieldStatistics))
                                throw TypeError(".palexy.task_management.v1.SubmissionStatistics.formFieldStatistics: array expected");
                            message.formFieldStatistics = [];
                            for (var i = 0; i < object.formFieldStatistics.length; ++i) {
                                if (typeof object.formFieldStatistics[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.SubmissionStatistics.formFieldStatistics: object expected");
                                message.formFieldStatistics[i] = $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.fromObject(object.formFieldStatistics[i]);
                            }
                        }
                        if (object.totalSubmissions != null)
                            if ($util.Long)
                                (message.totalSubmissions = $util.Long.fromValue(object.totalSubmissions)).unsigned = false;
                            else if (typeof object.totalSubmissions === "string")
                                message.totalSubmissions = parseInt(object.totalSubmissions, 10);
                            else if (typeof object.totalSubmissions === "number")
                                message.totalSubmissions = object.totalSubmissions;
                            else if (typeof object.totalSubmissions === "object")
                                message.totalSubmissions = new $util.LongBits(object.totalSubmissions.low >>> 0, object.totalSubmissions.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.sentimentStatistics) {
                            if (!Array.isArray(object.sentimentStatistics))
                                throw TypeError(".palexy.task_management.v1.SubmissionStatistics.sentimentStatistics: array expected");
                            message.sentimentStatistics = [];
                            for (var i = 0; i < object.sentimentStatistics.length; ++i) {
                                if (typeof object.sentimentStatistics[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.SubmissionStatistics.sentimentStatistics: object expected");
                                message.sentimentStatistics[i] = $root.palexy.task_management.v1.SentimentFieldStatistic.fromObject(object.sentimentStatistics[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SubmissionStatistics message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @static
                     * @param {palexy.task_management.v1.SubmissionStatistics} message SubmissionStatistics
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SubmissionStatistics.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.formFieldStatistics = [];
                            object.sentimentStatistics = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalSubmissions = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalSubmissions = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        }
                        if (message.formFieldStatistics && message.formFieldStatistics.length) {
                            object.formFieldStatistics = [];
                            for (var j = 0; j < message.formFieldStatistics.length; ++j)
                                object.formFieldStatistics[j] = $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.toObject(message.formFieldStatistics[j], options);
                        }
                        if (message.totalSubmissions != null && message.hasOwnProperty("totalSubmissions"))
                            if (typeof message.totalSubmissions === "number")
                                object.totalSubmissions = options.longs === String ? String(message.totalSubmissions) : message.totalSubmissions;
                            else
                                object.totalSubmissions = options.longs === String ? $util.Long.prototype.toString.call(message.totalSubmissions) : options.longs === Number ? new $util.LongBits(message.totalSubmissions.low >>> 0, message.totalSubmissions.high >>> 0).toNumber() : message.totalSubmissions;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.sentimentStatistics && message.sentimentStatistics.length) {
                            object.sentimentStatistics = [];
                            for (var j = 0; j < message.sentimentStatistics.length; ++j)
                                object.sentimentStatistics[j] = $root.palexy.task_management.v1.SentimentFieldStatistic.toObject(message.sentimentStatistics[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SubmissionStatistics to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SubmissionStatistics
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SubmissionStatistics.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    SubmissionStatistics.FormFieldStatistic = (function() {
    
                        /**
                         * Properties of a FormFieldStatistic.
                         * @memberof palexy.task_management.v1.SubmissionStatistics
                         * @interface IFormFieldStatistic
                         * @property {number|null} [formFieldId] FormFieldStatistic formFieldId
                         * @property {palexy.task_management.v1.FormField.FieldType|null} [fieldType] FormFieldStatistic fieldType
                         * @property {string|null} [question] FormFieldStatistic question
                         * @property {string|null} [optionId] FormFieldStatistic optionId
                         * @property {string|null} [optionLabel] FormFieldStatistic optionLabel
                         * @property {string|null} [valueText] FormFieldStatistic valueText
                         * @property {number|null} [submissionCount] FormFieldStatistic submissionCount
                         * @property {string|null} [internalQuestionId] FormFieldStatistic internalQuestionId
                         * @property {boolean|null} [isOther] FormFieldStatistic isOther
                         */
    
                        /**
                         * Constructs a new FormFieldStatistic.
                         * @memberof palexy.task_management.v1.SubmissionStatistics
                         * @classdesc Represents a FormFieldStatistic.
                         * @implements IFormFieldStatistic
                         * @constructor
                         * @param {palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic=} [properties] Properties to set
                         */
                        function FormFieldStatistic(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * FormFieldStatistic formFieldId.
                         * @member {number} formFieldId
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormFieldStatistic fieldType.
                         * @member {palexy.task_management.v1.FormField.FieldType} fieldType
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.fieldType = 0;
    
                        /**
                         * FormFieldStatistic question.
                         * @member {string} question
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.question = "";
    
                        /**
                         * FormFieldStatistic optionId.
                         * @member {string} optionId
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.optionId = "";
    
                        /**
                         * FormFieldStatistic optionLabel.
                         * @member {string} optionLabel
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.optionLabel = "";
    
                        /**
                         * FormFieldStatistic valueText.
                         * @member {string} valueText
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.valueText = "";
    
                        /**
                         * FormFieldStatistic submissionCount.
                         * @member {number} submissionCount
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.submissionCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * FormFieldStatistic internalQuestionId.
                         * @member {string} internalQuestionId
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.internalQuestionId = "";
    
                        /**
                         * FormFieldStatistic isOther.
                         * @member {boolean} isOther
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         */
                        FormFieldStatistic.prototype.isOther = false;
    
                        /**
                         * Creates a new FormFieldStatistic instance using the specified properties.
                         * @function create
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic=} [properties] Properties to set
                         * @returns {palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic} FormFieldStatistic instance
                         */
                        FormFieldStatistic.create = function create(properties) {
                            return new FormFieldStatistic(properties);
                        };
    
                        /**
                         * Encodes the specified FormFieldStatistic message. Does not implicitly {@link palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic} message FormFieldStatistic message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormFieldStatistic.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formFieldId);
                            if (message.fieldType != null && Object.hasOwnProperty.call(message, "fieldType"))
                                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.fieldType);
                            if (message.question != null && Object.hasOwnProperty.call(message, "question"))
                                writer.uint32(/* id 3, wireType 2 =*/26).string(message.question);
                            if (message.optionId != null && Object.hasOwnProperty.call(message, "optionId"))
                                writer.uint32(/* id 4, wireType 2 =*/34).string(message.optionId);
                            if (message.optionLabel != null && Object.hasOwnProperty.call(message, "optionLabel"))
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.optionLabel);
                            if (message.valueText != null && Object.hasOwnProperty.call(message, "valueText"))
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.valueText);
                            if (message.submissionCount != null && Object.hasOwnProperty.call(message, "submissionCount"))
                                writer.uint32(/* id 7, wireType 0 =*/56).int64(message.submissionCount);
                            if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                                writer.uint32(/* id 8, wireType 2 =*/66).string(message.internalQuestionId);
                            if (message.isOther != null && Object.hasOwnProperty.call(message, "isOther"))
                                writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isOther);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified FormFieldStatistic message, length delimited. Does not implicitly {@link palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {palexy.task_management.v1.SubmissionStatistics.IFormFieldStatistic} message FormFieldStatistic message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        FormFieldStatistic.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a FormFieldStatistic message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic} FormFieldStatistic
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormFieldStatistic.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.formFieldId = reader.int64();
                                    break;
                                case 2:
                                    message.fieldType = reader.int32();
                                    break;
                                case 3:
                                    message.question = reader.string();
                                    break;
                                case 4:
                                    message.optionId = reader.string();
                                    break;
                                case 5:
                                    message.optionLabel = reader.string();
                                    break;
                                case 6:
                                    message.valueText = reader.string();
                                    break;
                                case 7:
                                    message.submissionCount = reader.int64();
                                    break;
                                case 8:
                                    message.internalQuestionId = reader.string();
                                    break;
                                case 9:
                                    message.isOther = reader.bool();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a FormFieldStatistic message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic} FormFieldStatistic
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        FormFieldStatistic.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a FormFieldStatistic message.
                         * @function verify
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        FormFieldStatistic.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                    return "formFieldId: integer|Long expected";
                            if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                                switch (message.fieldType) {
                                default:
                                    return "fieldType: enum value expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 7:
                                case 8:
                                case 9:
                                case 10:
                                    break;
                                }
                            if (message.question != null && message.hasOwnProperty("question"))
                                if (!$util.isString(message.question))
                                    return "question: string expected";
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                if (!$util.isString(message.optionId))
                                    return "optionId: string expected";
                            if (message.optionLabel != null && message.hasOwnProperty("optionLabel"))
                                if (!$util.isString(message.optionLabel))
                                    return "optionLabel: string expected";
                            if (message.valueText != null && message.hasOwnProperty("valueText"))
                                if (!$util.isString(message.valueText))
                                    return "valueText: string expected";
                            if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                                if (!$util.isInteger(message.submissionCount) && !(message.submissionCount && $util.isInteger(message.submissionCount.low) && $util.isInteger(message.submissionCount.high)))
                                    return "submissionCount: integer|Long expected";
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                if (!$util.isString(message.internalQuestionId))
                                    return "internalQuestionId: string expected";
                            if (message.isOther != null && message.hasOwnProperty("isOther"))
                                if (typeof message.isOther !== "boolean")
                                    return "isOther: boolean expected";
                            return null;
                        };
    
                        /**
                         * Creates a FormFieldStatistic message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic} FormFieldStatistic
                         */
                        FormFieldStatistic.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic)
                                return object;
                            var message = new $root.palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic();
                            if (object.formFieldId != null)
                                if ($util.Long)
                                    (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                                else if (typeof object.formFieldId === "string")
                                    message.formFieldId = parseInt(object.formFieldId, 10);
                                else if (typeof object.formFieldId === "number")
                                    message.formFieldId = object.formFieldId;
                                else if (typeof object.formFieldId === "object")
                                    message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                            switch (object.fieldType) {
                            case "UNKNOWN":
                            case 0:
                                message.fieldType = 0;
                                break;
                            case "TEXT":
                            case 1:
                                message.fieldType = 1;
                                break;
                            case "CHECKBOXES":
                            case 2:
                                message.fieldType = 2;
                                break;
                            case "DROPDOWN":
                            case 3:
                                message.fieldType = 3;
                                break;
                            case "MULTIPLE_CHOICE":
                            case 4:
                                message.fieldType = 4;
                                break;
                            case "FILE":
                            case 5:
                                message.fieldType = 5;
                                break;
                            case "TAKE_PHOTO":
                            case 7:
                                message.fieldType = 7;
                                break;
                            case "SELECTION":
                            case 8:
                                message.fieldType = 8;
                                break;
                            case "NPS":
                            case 9:
                                message.fieldType = 9;
                                break;
                            case "DATE":
                            case 10:
                                message.fieldType = 10;
                                break;
                            }
                            if (object.question != null)
                                message.question = String(object.question);
                            if (object.optionId != null)
                                message.optionId = String(object.optionId);
                            if (object.optionLabel != null)
                                message.optionLabel = String(object.optionLabel);
                            if (object.valueText != null)
                                message.valueText = String(object.valueText);
                            if (object.submissionCount != null)
                                if ($util.Long)
                                    (message.submissionCount = $util.Long.fromValue(object.submissionCount)).unsigned = false;
                                else if (typeof object.submissionCount === "string")
                                    message.submissionCount = parseInt(object.submissionCount, 10);
                                else if (typeof object.submissionCount === "number")
                                    message.submissionCount = object.submissionCount;
                                else if (typeof object.submissionCount === "object")
                                    message.submissionCount = new $util.LongBits(object.submissionCount.low >>> 0, object.submissionCount.high >>> 0).toNumber();
                            if (object.internalQuestionId != null)
                                message.internalQuestionId = String(object.internalQuestionId);
                            if (object.isOther != null)
                                message.isOther = Boolean(object.isOther);
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a FormFieldStatistic message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @static
                         * @param {palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic} message FormFieldStatistic
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        FormFieldStatistic.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults) {
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.formFieldId = options.longs === String ? "0" : 0;
                                object.fieldType = options.enums === String ? "UNKNOWN" : 0;
                                object.question = "";
                                object.optionId = "";
                                object.optionLabel = "";
                                object.valueText = "";
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.submissionCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.submissionCount = options.longs === String ? "0" : 0;
                                object.internalQuestionId = "";
                                object.isOther = false;
                            }
                            if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                                if (typeof message.formFieldId === "number")
                                    object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                                else
                                    object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                            if (message.fieldType != null && message.hasOwnProperty("fieldType"))
                                object.fieldType = options.enums === String ? $root.palexy.task_management.v1.FormField.FieldType[message.fieldType] : message.fieldType;
                            if (message.question != null && message.hasOwnProperty("question"))
                                object.question = message.question;
                            if (message.optionId != null && message.hasOwnProperty("optionId"))
                                object.optionId = message.optionId;
                            if (message.optionLabel != null && message.hasOwnProperty("optionLabel"))
                                object.optionLabel = message.optionLabel;
                            if (message.valueText != null && message.hasOwnProperty("valueText"))
                                object.valueText = message.valueText;
                            if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                                if (typeof message.submissionCount === "number")
                                    object.submissionCount = options.longs === String ? String(message.submissionCount) : message.submissionCount;
                                else
                                    object.submissionCount = options.longs === String ? $util.Long.prototype.toString.call(message.submissionCount) : options.longs === Number ? new $util.LongBits(message.submissionCount.low >>> 0, message.submissionCount.high >>> 0).toNumber() : message.submissionCount;
                            if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                                object.internalQuestionId = message.internalQuestionId;
                            if (message.isOther != null && message.hasOwnProperty("isOther"))
                                object.isOther = message.isOther;
                            return object;
                        };
    
                        /**
                         * Converts this FormFieldStatistic to JSON.
                         * @function toJSON
                         * @memberof palexy.task_management.v1.SubmissionStatistics.FormFieldStatistic
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        FormFieldStatistic.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return FormFieldStatistic;
                    })();
    
                    return SubmissionStatistics;
                })();
    
                v1.SentimentFieldStatistic = (function() {
    
                    /**
                     * Properties of a SentimentFieldStatistic.
                     * @memberof palexy.task_management.v1
                     * @interface ISentimentFieldStatistic
                     * @property {string|null} [internalQuestionId] SentimentFieldStatistic internalQuestionId
                     * @property {number|null} [averageScore] SentimentFieldStatistic averageScore
                     * @property {number|null} [veryNegativeCount] SentimentFieldStatistic veryNegativeCount
                     * @property {number|null} [negativeCount] SentimentFieldStatistic negativeCount
                     * @property {number|null} [neutralCount] SentimentFieldStatistic neutralCount
                     * @property {number|null} [positiveCount] SentimentFieldStatistic positiveCount
                     * @property {number|null} [veryPositiveCount] SentimentFieldStatistic veryPositiveCount
                     * @property {number|null} [naCount] SentimentFieldStatistic naCount
                     */
    
                    /**
                     * Constructs a new SentimentFieldStatistic.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SentimentFieldStatistic.
                     * @implements ISentimentFieldStatistic
                     * @constructor
                     * @param {palexy.task_management.v1.ISentimentFieldStatistic=} [properties] Properties to set
                     */
                    function SentimentFieldStatistic(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SentimentFieldStatistic internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.internalQuestionId = "";
    
                    /**
                     * SentimentFieldStatistic averageScore.
                     * @member {number} averageScore
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.averageScore = 0;
    
                    /**
                     * SentimentFieldStatistic veryNegativeCount.
                     * @member {number} veryNegativeCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.veryNegativeCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SentimentFieldStatistic negativeCount.
                     * @member {number} negativeCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.negativeCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SentimentFieldStatistic neutralCount.
                     * @member {number} neutralCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.neutralCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SentimentFieldStatistic positiveCount.
                     * @member {number} positiveCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.positiveCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SentimentFieldStatistic veryPositiveCount.
                     * @member {number} veryPositiveCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.veryPositiveCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SentimentFieldStatistic naCount.
                     * @member {number} naCount
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     */
                    SentimentFieldStatistic.prototype.naCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new SentimentFieldStatistic instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentFieldStatistic=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SentimentFieldStatistic} SentimentFieldStatistic instance
                     */
                    SentimentFieldStatistic.create = function create(properties) {
                        return new SentimentFieldStatistic(properties);
                    };
    
                    /**
                     * Encodes the specified SentimentFieldStatistic message. Does not implicitly {@link palexy.task_management.v1.SentimentFieldStatistic.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentFieldStatistic} message SentimentFieldStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentFieldStatistic.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.internalQuestionId);
                        if (message.averageScore != null && Object.hasOwnProperty.call(message, "averageScore"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.averageScore);
                        if (message.veryNegativeCount != null && Object.hasOwnProperty.call(message, "veryNegativeCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.veryNegativeCount);
                        if (message.negativeCount != null && Object.hasOwnProperty.call(message, "negativeCount"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.negativeCount);
                        if (message.neutralCount != null && Object.hasOwnProperty.call(message, "neutralCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.neutralCount);
                        if (message.positiveCount != null && Object.hasOwnProperty.call(message, "positiveCount"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.positiveCount);
                        if (message.veryPositiveCount != null && Object.hasOwnProperty.call(message, "veryPositiveCount"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.veryPositiveCount);
                        if (message.naCount != null && Object.hasOwnProperty.call(message, "naCount"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.naCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SentimentFieldStatistic message, length delimited. Does not implicitly {@link palexy.task_management.v1.SentimentFieldStatistic.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {palexy.task_management.v1.ISentimentFieldStatistic} message SentimentFieldStatistic message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SentimentFieldStatistic.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SentimentFieldStatistic message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SentimentFieldStatistic} SentimentFieldStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentFieldStatistic.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SentimentFieldStatistic();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.internalQuestionId = reader.string();
                                break;
                            case 2:
                                message.averageScore = reader.int32();
                                break;
                            case 3:
                                message.veryNegativeCount = reader.int64();
                                break;
                            case 4:
                                message.negativeCount = reader.int64();
                                break;
                            case 5:
                                message.neutralCount = reader.int64();
                                break;
                            case 6:
                                message.positiveCount = reader.int64();
                                break;
                            case 7:
                                message.veryPositiveCount = reader.int64();
                                break;
                            case 8:
                                message.naCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SentimentFieldStatistic message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SentimentFieldStatistic} SentimentFieldStatistic
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SentimentFieldStatistic.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SentimentFieldStatistic message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SentimentFieldStatistic.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        if (message.averageScore != null && message.hasOwnProperty("averageScore"))
                            if (!$util.isInteger(message.averageScore))
                                return "averageScore: integer expected";
                        if (message.veryNegativeCount != null && message.hasOwnProperty("veryNegativeCount"))
                            if (!$util.isInteger(message.veryNegativeCount) && !(message.veryNegativeCount && $util.isInteger(message.veryNegativeCount.low) && $util.isInteger(message.veryNegativeCount.high)))
                                return "veryNegativeCount: integer|Long expected";
                        if (message.negativeCount != null && message.hasOwnProperty("negativeCount"))
                            if (!$util.isInteger(message.negativeCount) && !(message.negativeCount && $util.isInteger(message.negativeCount.low) && $util.isInteger(message.negativeCount.high)))
                                return "negativeCount: integer|Long expected";
                        if (message.neutralCount != null && message.hasOwnProperty("neutralCount"))
                            if (!$util.isInteger(message.neutralCount) && !(message.neutralCount && $util.isInteger(message.neutralCount.low) && $util.isInteger(message.neutralCount.high)))
                                return "neutralCount: integer|Long expected";
                        if (message.positiveCount != null && message.hasOwnProperty("positiveCount"))
                            if (!$util.isInteger(message.positiveCount) && !(message.positiveCount && $util.isInteger(message.positiveCount.low) && $util.isInteger(message.positiveCount.high)))
                                return "positiveCount: integer|Long expected";
                        if (message.veryPositiveCount != null && message.hasOwnProperty("veryPositiveCount"))
                            if (!$util.isInteger(message.veryPositiveCount) && !(message.veryPositiveCount && $util.isInteger(message.veryPositiveCount.low) && $util.isInteger(message.veryPositiveCount.high)))
                                return "veryPositiveCount: integer|Long expected";
                        if (message.naCount != null && message.hasOwnProperty("naCount"))
                            if (!$util.isInteger(message.naCount) && !(message.naCount && $util.isInteger(message.naCount.low) && $util.isInteger(message.naCount.high)))
                                return "naCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a SentimentFieldStatistic message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SentimentFieldStatistic} SentimentFieldStatistic
                     */
                    SentimentFieldStatistic.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SentimentFieldStatistic)
                            return object;
                        var message = new $root.palexy.task_management.v1.SentimentFieldStatistic();
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        if (object.averageScore != null)
                            message.averageScore = object.averageScore | 0;
                        if (object.veryNegativeCount != null)
                            if ($util.Long)
                                (message.veryNegativeCount = $util.Long.fromValue(object.veryNegativeCount)).unsigned = false;
                            else if (typeof object.veryNegativeCount === "string")
                                message.veryNegativeCount = parseInt(object.veryNegativeCount, 10);
                            else if (typeof object.veryNegativeCount === "number")
                                message.veryNegativeCount = object.veryNegativeCount;
                            else if (typeof object.veryNegativeCount === "object")
                                message.veryNegativeCount = new $util.LongBits(object.veryNegativeCount.low >>> 0, object.veryNegativeCount.high >>> 0).toNumber();
                        if (object.negativeCount != null)
                            if ($util.Long)
                                (message.negativeCount = $util.Long.fromValue(object.negativeCount)).unsigned = false;
                            else if (typeof object.negativeCount === "string")
                                message.negativeCount = parseInt(object.negativeCount, 10);
                            else if (typeof object.negativeCount === "number")
                                message.negativeCount = object.negativeCount;
                            else if (typeof object.negativeCount === "object")
                                message.negativeCount = new $util.LongBits(object.negativeCount.low >>> 0, object.negativeCount.high >>> 0).toNumber();
                        if (object.neutralCount != null)
                            if ($util.Long)
                                (message.neutralCount = $util.Long.fromValue(object.neutralCount)).unsigned = false;
                            else if (typeof object.neutralCount === "string")
                                message.neutralCount = parseInt(object.neutralCount, 10);
                            else if (typeof object.neutralCount === "number")
                                message.neutralCount = object.neutralCount;
                            else if (typeof object.neutralCount === "object")
                                message.neutralCount = new $util.LongBits(object.neutralCount.low >>> 0, object.neutralCount.high >>> 0).toNumber();
                        if (object.positiveCount != null)
                            if ($util.Long)
                                (message.positiveCount = $util.Long.fromValue(object.positiveCount)).unsigned = false;
                            else if (typeof object.positiveCount === "string")
                                message.positiveCount = parseInt(object.positiveCount, 10);
                            else if (typeof object.positiveCount === "number")
                                message.positiveCount = object.positiveCount;
                            else if (typeof object.positiveCount === "object")
                                message.positiveCount = new $util.LongBits(object.positiveCount.low >>> 0, object.positiveCount.high >>> 0).toNumber();
                        if (object.veryPositiveCount != null)
                            if ($util.Long)
                                (message.veryPositiveCount = $util.Long.fromValue(object.veryPositiveCount)).unsigned = false;
                            else if (typeof object.veryPositiveCount === "string")
                                message.veryPositiveCount = parseInt(object.veryPositiveCount, 10);
                            else if (typeof object.veryPositiveCount === "number")
                                message.veryPositiveCount = object.veryPositiveCount;
                            else if (typeof object.veryPositiveCount === "object")
                                message.veryPositiveCount = new $util.LongBits(object.veryPositiveCount.low >>> 0, object.veryPositiveCount.high >>> 0).toNumber();
                        if (object.naCount != null)
                            if ($util.Long)
                                (message.naCount = $util.Long.fromValue(object.naCount)).unsigned = false;
                            else if (typeof object.naCount === "string")
                                message.naCount = parseInt(object.naCount, 10);
                            else if (typeof object.naCount === "number")
                                message.naCount = object.naCount;
                            else if (typeof object.naCount === "object")
                                message.naCount = new $util.LongBits(object.naCount.low >>> 0, object.naCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SentimentFieldStatistic message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @static
                     * @param {palexy.task_management.v1.SentimentFieldStatistic} message SentimentFieldStatistic
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SentimentFieldStatistic.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.internalQuestionId = "";
                            object.averageScore = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.veryNegativeCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.veryNegativeCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.negativeCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.negativeCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.neutralCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.neutralCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.positiveCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.positiveCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.veryPositiveCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.veryPositiveCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.naCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.naCount = options.longs === String ? "0" : 0;
                        }
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        if (message.averageScore != null && message.hasOwnProperty("averageScore"))
                            object.averageScore = message.averageScore;
                        if (message.veryNegativeCount != null && message.hasOwnProperty("veryNegativeCount"))
                            if (typeof message.veryNegativeCount === "number")
                                object.veryNegativeCount = options.longs === String ? String(message.veryNegativeCount) : message.veryNegativeCount;
                            else
                                object.veryNegativeCount = options.longs === String ? $util.Long.prototype.toString.call(message.veryNegativeCount) : options.longs === Number ? new $util.LongBits(message.veryNegativeCount.low >>> 0, message.veryNegativeCount.high >>> 0).toNumber() : message.veryNegativeCount;
                        if (message.negativeCount != null && message.hasOwnProperty("negativeCount"))
                            if (typeof message.negativeCount === "number")
                                object.negativeCount = options.longs === String ? String(message.negativeCount) : message.negativeCount;
                            else
                                object.negativeCount = options.longs === String ? $util.Long.prototype.toString.call(message.negativeCount) : options.longs === Number ? new $util.LongBits(message.negativeCount.low >>> 0, message.negativeCount.high >>> 0).toNumber() : message.negativeCount;
                        if (message.neutralCount != null && message.hasOwnProperty("neutralCount"))
                            if (typeof message.neutralCount === "number")
                                object.neutralCount = options.longs === String ? String(message.neutralCount) : message.neutralCount;
                            else
                                object.neutralCount = options.longs === String ? $util.Long.prototype.toString.call(message.neutralCount) : options.longs === Number ? new $util.LongBits(message.neutralCount.low >>> 0, message.neutralCount.high >>> 0).toNumber() : message.neutralCount;
                        if (message.positiveCount != null && message.hasOwnProperty("positiveCount"))
                            if (typeof message.positiveCount === "number")
                                object.positiveCount = options.longs === String ? String(message.positiveCount) : message.positiveCount;
                            else
                                object.positiveCount = options.longs === String ? $util.Long.prototype.toString.call(message.positiveCount) : options.longs === Number ? new $util.LongBits(message.positiveCount.low >>> 0, message.positiveCount.high >>> 0).toNumber() : message.positiveCount;
                        if (message.veryPositiveCount != null && message.hasOwnProperty("veryPositiveCount"))
                            if (typeof message.veryPositiveCount === "number")
                                object.veryPositiveCount = options.longs === String ? String(message.veryPositiveCount) : message.veryPositiveCount;
                            else
                                object.veryPositiveCount = options.longs === String ? $util.Long.prototype.toString.call(message.veryPositiveCount) : options.longs === Number ? new $util.LongBits(message.veryPositiveCount.low >>> 0, message.veryPositiveCount.high >>> 0).toNumber() : message.veryPositiveCount;
                        if (message.naCount != null && message.hasOwnProperty("naCount"))
                            if (typeof message.naCount === "number")
                                object.naCount = options.longs === String ? String(message.naCount) : message.naCount;
                            else
                                object.naCount = options.longs === String ? $util.Long.prototype.toString.call(message.naCount) : options.longs === Number ? new $util.LongBits(message.naCount.low >>> 0, message.naCount.high >>> 0).toNumber() : message.naCount;
                        return object;
                    };
    
                    /**
                     * Converts this SentimentFieldStatistic to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SentimentFieldStatistic
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SentimentFieldStatistic.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SentimentFieldStatistic;
                })();
    
                v1.ListOtherTextResponsesRequest = (function() {
    
                    /**
                     * Properties of a ListOtherTextResponsesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListOtherTextResponsesRequest
                     * @property {number|null} [formId] ListOtherTextResponsesRequest formId
                     * @property {string|null} [internalQuestionId] ListOtherTextResponsesRequest internalQuestionId
                     * @property {number|null} [pageSize] ListOtherTextResponsesRequest pageSize
                     * @property {string|null} [pageToken] ListOtherTextResponsesRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListOtherTextResponsesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListOtherTextResponsesRequest.
                     * @implements IListOtherTextResponsesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest=} [properties] Properties to set
                     */
                    function ListOtherTextResponsesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListOtherTextResponsesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @instance
                     */
                    ListOtherTextResponsesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListOtherTextResponsesRequest internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @instance
                     */
                    ListOtherTextResponsesRequest.prototype.internalQuestionId = "";
    
                    /**
                     * ListOtherTextResponsesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @instance
                     */
                    ListOtherTextResponsesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListOtherTextResponsesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @instance
                     */
                    ListOtherTextResponsesRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListOtherTextResponsesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesRequest} ListOtherTextResponsesRequest instance
                     */
                    ListOtherTextResponsesRequest.create = function create(properties) {
                        return new ListOtherTextResponsesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListOtherTextResponsesRequest message. Does not implicitly {@link palexy.task_management.v1.ListOtherTextResponsesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest} message ListOtherTextResponsesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListOtherTextResponsesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.internalQuestionId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListOtherTextResponsesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListOtherTextResponsesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesRequest} message ListOtherTextResponsesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListOtherTextResponsesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListOtherTextResponsesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesRequest} ListOtherTextResponsesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListOtherTextResponsesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListOtherTextResponsesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.internalQuestionId = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListOtherTextResponsesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesRequest} ListOtherTextResponsesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListOtherTextResponsesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListOtherTextResponsesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListOtherTextResponsesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListOtherTextResponsesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesRequest} ListOtherTextResponsesRequest
                     */
                    ListOtherTextResponsesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListOtherTextResponsesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListOtherTextResponsesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListOtherTextResponsesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListOtherTextResponsesRequest} message ListOtherTextResponsesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListOtherTextResponsesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.internalQuestionId = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListOtherTextResponsesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListOtherTextResponsesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListOtherTextResponsesRequest;
                })();
    
                v1.ListOtherTextResponsesResponse = (function() {
    
                    /**
                     * Properties of a ListOtherTextResponsesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListOtherTextResponsesResponse
                     * @property {Array.<palexy.task_management.v1.IOtherTextResponse>|null} [responses] ListOtherTextResponsesResponse responses
                     * @property {string|null} [nextPageToken] ListOtherTextResponsesResponse nextPageToken
                     * @property {number|null} [totalCount] ListOtherTextResponsesResponse totalCount
                     */
    
                    /**
                     * Constructs a new ListOtherTextResponsesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListOtherTextResponsesResponse.
                     * @implements IListOtherTextResponsesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListOtherTextResponsesResponse=} [properties] Properties to set
                     */
                    function ListOtherTextResponsesResponse(properties) {
                        this.responses = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListOtherTextResponsesResponse responses.
                     * @member {Array.<palexy.task_management.v1.IOtherTextResponse>} responses
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @instance
                     */
                    ListOtherTextResponsesResponse.prototype.responses = $util.emptyArray;
    
                    /**
                     * ListOtherTextResponsesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @instance
                     */
                    ListOtherTextResponsesResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListOtherTextResponsesResponse totalCount.
                     * @member {number} totalCount
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @instance
                     */
                    ListOtherTextResponsesResponse.prototype.totalCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListOtherTextResponsesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesResponse} ListOtherTextResponsesResponse instance
                     */
                    ListOtherTextResponsesResponse.create = function create(properties) {
                        return new ListOtherTextResponsesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListOtherTextResponsesResponse message. Does not implicitly {@link palexy.task_management.v1.ListOtherTextResponsesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesResponse} message ListOtherTextResponsesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListOtherTextResponsesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.responses != null && message.responses.length)
                            for (var i = 0; i < message.responses.length; ++i)
                                $root.palexy.task_management.v1.OtherTextResponse.encode(message.responses[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.nextPageToken);
                        if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.totalCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListOtherTextResponsesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListOtherTextResponsesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListOtherTextResponsesResponse} message ListOtherTextResponsesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListOtherTextResponsesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListOtherTextResponsesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesResponse} ListOtherTextResponsesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListOtherTextResponsesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListOtherTextResponsesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.responses && message.responses.length))
                                    message.responses = [];
                                message.responses.push($root.palexy.task_management.v1.OtherTextResponse.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.nextPageToken = reader.string();
                                break;
                            case 3:
                                message.totalCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListOtherTextResponsesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesResponse} ListOtherTextResponsesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListOtherTextResponsesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListOtherTextResponsesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListOtherTextResponsesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.responses != null && message.hasOwnProperty("responses")) {
                            if (!Array.isArray(message.responses))
                                return "responses: array expected";
                            for (var i = 0; i < message.responses.length; ++i) {
                                var error = $root.palexy.task_management.v1.OtherTextResponse.verify(message.responses[i]);
                                if (error)
                                    return "responses." + error;
                            }
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            if (!$util.isInteger(message.totalCount) && !(message.totalCount && $util.isInteger(message.totalCount.low) && $util.isInteger(message.totalCount.high)))
                                return "totalCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListOtherTextResponsesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListOtherTextResponsesResponse} ListOtherTextResponsesResponse
                     */
                    ListOtherTextResponsesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListOtherTextResponsesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListOtherTextResponsesResponse();
                        if (object.responses) {
                            if (!Array.isArray(object.responses))
                                throw TypeError(".palexy.task_management.v1.ListOtherTextResponsesResponse.responses: array expected");
                            message.responses = [];
                            for (var i = 0; i < object.responses.length; ++i) {
                                if (typeof object.responses[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListOtherTextResponsesResponse.responses: object expected");
                                message.responses[i] = $root.palexy.task_management.v1.OtherTextResponse.fromObject(object.responses[i]);
                            }
                        }
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.totalCount != null)
                            if ($util.Long)
                                (message.totalCount = $util.Long.fromValue(object.totalCount)).unsigned = false;
                            else if (typeof object.totalCount === "string")
                                message.totalCount = parseInt(object.totalCount, 10);
                            else if (typeof object.totalCount === "number")
                                message.totalCount = object.totalCount;
                            else if (typeof object.totalCount === "object")
                                message.totalCount = new $util.LongBits(object.totalCount.low >>> 0, object.totalCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListOtherTextResponsesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListOtherTextResponsesResponse} message ListOtherTextResponsesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListOtherTextResponsesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.responses = [];
                        if (options.defaults) {
                            object.nextPageToken = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalCount = options.longs === String ? "0" : 0;
                        }
                        if (message.responses && message.responses.length) {
                            object.responses = [];
                            for (var j = 0; j < message.responses.length; ++j)
                                object.responses[j] = $root.palexy.task_management.v1.OtherTextResponse.toObject(message.responses[j], options);
                        }
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            if (typeof message.totalCount === "number")
                                object.totalCount = options.longs === String ? String(message.totalCount) : message.totalCount;
                            else
                                object.totalCount = options.longs === String ? $util.Long.prototype.toString.call(message.totalCount) : options.longs === Number ? new $util.LongBits(message.totalCount.low >>> 0, message.totalCount.high >>> 0).toNumber() : message.totalCount;
                        return object;
                    };
    
                    /**
                     * Converts this ListOtherTextResponsesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListOtherTextResponsesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListOtherTextResponsesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListOtherTextResponsesResponse;
                })();
    
                v1.OtherTextResponse = (function() {
    
                    /**
                     * Properties of an OtherTextResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IOtherTextResponse
                     * @property {string|null} [valueText] OtherTextResponse valueText
                     * @property {number|null} [submissionCount] OtherTextResponse submissionCount
                     */
    
                    /**
                     * Constructs a new OtherTextResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an OtherTextResponse.
                     * @implements IOtherTextResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IOtherTextResponse=} [properties] Properties to set
                     */
                    function OtherTextResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * OtherTextResponse valueText.
                     * @member {string} valueText
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @instance
                     */
                    OtherTextResponse.prototype.valueText = "";
    
                    /**
                     * OtherTextResponse submissionCount.
                     * @member {number} submissionCount
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @instance
                     */
                    OtherTextResponse.prototype.submissionCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new OtherTextResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {palexy.task_management.v1.IOtherTextResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.OtherTextResponse} OtherTextResponse instance
                     */
                    OtherTextResponse.create = function create(properties) {
                        return new OtherTextResponse(properties);
                    };
    
                    /**
                     * Encodes the specified OtherTextResponse message. Does not implicitly {@link palexy.task_management.v1.OtherTextResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {palexy.task_management.v1.IOtherTextResponse} message OtherTextResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OtherTextResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.valueText != null && Object.hasOwnProperty.call(message, "valueText"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.valueText);
                        if (message.submissionCount != null && Object.hasOwnProperty.call(message, "submissionCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified OtherTextResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.OtherTextResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {palexy.task_management.v1.IOtherTextResponse} message OtherTextResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    OtherTextResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an OtherTextResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.OtherTextResponse} OtherTextResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OtherTextResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.OtherTextResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.valueText = reader.string();
                                break;
                            case 2:
                                message.submissionCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an OtherTextResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.OtherTextResponse} OtherTextResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    OtherTextResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an OtherTextResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    OtherTextResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.valueText != null && message.hasOwnProperty("valueText"))
                            if (!$util.isString(message.valueText))
                                return "valueText: string expected";
                        if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                            if (!$util.isInteger(message.submissionCount) && !(message.submissionCount && $util.isInteger(message.submissionCount.low) && $util.isInteger(message.submissionCount.high)))
                                return "submissionCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates an OtherTextResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.OtherTextResponse} OtherTextResponse
                     */
                    OtherTextResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.OtherTextResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.OtherTextResponse();
                        if (object.valueText != null)
                            message.valueText = String(object.valueText);
                        if (object.submissionCount != null)
                            if ($util.Long)
                                (message.submissionCount = $util.Long.fromValue(object.submissionCount)).unsigned = false;
                            else if (typeof object.submissionCount === "string")
                                message.submissionCount = parseInt(object.submissionCount, 10);
                            else if (typeof object.submissionCount === "number")
                                message.submissionCount = object.submissionCount;
                            else if (typeof object.submissionCount === "object")
                                message.submissionCount = new $util.LongBits(object.submissionCount.low >>> 0, object.submissionCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an OtherTextResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @static
                     * @param {palexy.task_management.v1.OtherTextResponse} message OtherTextResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    OtherTextResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.valueText = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionCount = options.longs === String ? "0" : 0;
                        }
                        if (message.valueText != null && message.hasOwnProperty("valueText"))
                            object.valueText = message.valueText;
                        if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                            if (typeof message.submissionCount === "number")
                                object.submissionCount = options.longs === String ? String(message.submissionCount) : message.submissionCount;
                            else
                                object.submissionCount = options.longs === String ? $util.Long.prototype.toString.call(message.submissionCount) : options.longs === Number ? new $util.LongBits(message.submissionCount.low >>> 0, message.submissionCount.high >>> 0).toNumber() : message.submissionCount;
                        return object;
                    };
    
                    /**
                     * Converts this OtherTextResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.OtherTextResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    OtherTextResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return OtherTextResponse;
                })();
    
                v1.FormCustomAttribute = (function() {
    
                    /**
                     * Properties of a FormCustomAttribute.
                     * @memberof palexy.task_management.v1
                     * @interface IFormCustomAttribute
                     * @property {number|null} [id] FormCustomAttribute id
                     * @property {number|null} [formId] FormCustomAttribute formId
                     * @property {string|null} [name] FormCustomAttribute name
                     * @property {string|null} [code] FormCustomAttribute code
                     * @property {palexy.task_management.v1.FormAttributeDataType|null} [dataType] FormCustomAttribute dataType
                     * @property {number|null} [createdTimeMs] FormCustomAttribute createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] FormCustomAttribute lastUpdateTimeMs
                     * @property {string|null} [sentimentInternalQuestionId] FormCustomAttribute sentimentInternalQuestionId
                     * @property {boolean|null} [isUrlParam] FormCustomAttribute isUrlParam
                     */
    
                    /**
                     * Constructs a new FormCustomAttribute.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormCustomAttribute.
                     * @implements IFormCustomAttribute
                     * @constructor
                     * @param {palexy.task_management.v1.IFormCustomAttribute=} [properties] Properties to set
                     */
                    function FormCustomAttribute(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormCustomAttribute id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAttribute formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAttribute name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.name = "";
    
                    /**
                     * FormCustomAttribute code.
                     * @member {string} code
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.code = "";
    
                    /**
                     * FormCustomAttribute dataType.
                     * @member {palexy.task_management.v1.FormAttributeDataType} dataType
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.dataType = 0;
    
                    /**
                     * FormCustomAttribute createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAttribute lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAttribute sentimentInternalQuestionId.
                     * @member {string} sentimentInternalQuestionId
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.sentimentInternalQuestionId = "";
    
                    /**
                     * FormCustomAttribute isUrlParam.
                     * @member {boolean} isUrlParam
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     */
                    FormCustomAttribute.prototype.isUrlParam = false;
    
                    /**
                     * Creates a new FormCustomAttribute instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAttribute=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormCustomAttribute} FormCustomAttribute instance
                     */
                    FormCustomAttribute.create = function create(properties) {
                        return new FormCustomAttribute(properties);
                    };
    
                    /**
                     * Encodes the specified FormCustomAttribute message. Does not implicitly {@link palexy.task_management.v1.FormCustomAttribute.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAttribute} message FormCustomAttribute message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormCustomAttribute.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.code != null && Object.hasOwnProperty.call(message, "code"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.code);
                        if (message.dataType != null && Object.hasOwnProperty.call(message, "dataType"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.dataType);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.lastUpdateTimeMs);
                        if (message.sentimentInternalQuestionId != null && Object.hasOwnProperty.call(message, "sentimentInternalQuestionId"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.sentimentInternalQuestionId);
                        if (message.isUrlParam != null && Object.hasOwnProperty.call(message, "isUrlParam"))
                            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.isUrlParam);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormCustomAttribute message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormCustomAttribute.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAttribute} message FormCustomAttribute message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormCustomAttribute.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormCustomAttribute message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormCustomAttribute} FormCustomAttribute
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormCustomAttribute.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormCustomAttribute();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.code = reader.string();
                                break;
                            case 5:
                                message.dataType = reader.int32();
                                break;
                            case 6:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 7:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 8:
                                message.sentimentInternalQuestionId = reader.string();
                                break;
                            case 9:
                                message.isUrlParam = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormCustomAttribute message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormCustomAttribute} FormCustomAttribute
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormCustomAttribute.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormCustomAttribute message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormCustomAttribute.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.code != null && message.hasOwnProperty("code"))
                            if (!$util.isString(message.code))
                                return "code: string expected";
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            switch (message.dataType) {
                            default:
                                return "dataType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.sentimentInternalQuestionId != null && message.hasOwnProperty("sentimentInternalQuestionId"))
                            if (!$util.isString(message.sentimentInternalQuestionId))
                                return "sentimentInternalQuestionId: string expected";
                        if (message.isUrlParam != null && message.hasOwnProperty("isUrlParam"))
                            if (typeof message.isUrlParam !== "boolean")
                                return "isUrlParam: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormCustomAttribute message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormCustomAttribute} FormCustomAttribute
                     */
                    FormCustomAttribute.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormCustomAttribute)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormCustomAttribute();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.code != null)
                            message.code = String(object.code);
                        switch (object.dataType) {
                        case "FORM_ATTRIBUTE_DATA_TYPE_UNKNOWN":
                        case 0:
                            message.dataType = 0;
                            break;
                        case "FORM_ATTRIBUTE_DATA_TYPE_TEXT":
                        case 1:
                            message.dataType = 1;
                            break;
                        case "FORM_ATTRIBUTE_DATA_TYPE_NUMBER":
                        case 2:
                            message.dataType = 2;
                            break;
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.sentimentInternalQuestionId != null)
                            message.sentimentInternalQuestionId = String(object.sentimentInternalQuestionId);
                        if (object.isUrlParam != null)
                            message.isUrlParam = Boolean(object.isUrlParam);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormCustomAttribute message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @static
                     * @param {palexy.task_management.v1.FormCustomAttribute} message FormCustomAttribute
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormCustomAttribute.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.code = "";
                            object.dataType = options.enums === String ? "FORM_ATTRIBUTE_DATA_TYPE_UNKNOWN" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.sentimentInternalQuestionId = "";
                            object.isUrlParam = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.code != null && message.hasOwnProperty("code"))
                            object.code = message.code;
                        if (message.dataType != null && message.hasOwnProperty("dataType"))
                            object.dataType = options.enums === String ? $root.palexy.task_management.v1.FormAttributeDataType[message.dataType] : message.dataType;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.sentimentInternalQuestionId != null && message.hasOwnProperty("sentimentInternalQuestionId"))
                            object.sentimentInternalQuestionId = message.sentimentInternalQuestionId;
                        if (message.isUrlParam != null && message.hasOwnProperty("isUrlParam"))
                            object.isUrlParam = message.isUrlParam;
                        return object;
                    };
    
                    /**
                     * Converts this FormCustomAttribute to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormCustomAttribute
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormCustomAttribute.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormCustomAttribute;
                })();
    
                /**
                 * FormAttributeDataType enum.
                 * @name palexy.task_management.v1.FormAttributeDataType
                 * @enum {number}
                 * @property {number} FORM_ATTRIBUTE_DATA_TYPE_UNKNOWN=0 FORM_ATTRIBUTE_DATA_TYPE_UNKNOWN value
                 * @property {number} FORM_ATTRIBUTE_DATA_TYPE_TEXT=1 FORM_ATTRIBUTE_DATA_TYPE_TEXT value
                 * @property {number} FORM_ATTRIBUTE_DATA_TYPE_NUMBER=2 FORM_ATTRIBUTE_DATA_TYPE_NUMBER value
                 */
                v1.FormAttributeDataType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FORM_ATTRIBUTE_DATA_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "FORM_ATTRIBUTE_DATA_TYPE_TEXT"] = 1;
                    values[valuesById[2] = "FORM_ATTRIBUTE_DATA_TYPE_NUMBER"] = 2;
                    return values;
                })();
    
                v1.CreateFormCustomAttributeRequest = (function() {
    
                    /**
                     * Properties of a CreateFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormCustomAttributeRequest
                     * @property {number|null} [formId] CreateFormCustomAttributeRequest formId
                     * @property {palexy.task_management.v1.IFormCustomAttribute|null} [attribute] CreateFormCustomAttributeRequest attribute
                     */
    
                    /**
                     * Constructs a new CreateFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormCustomAttributeRequest.
                     * @implements ICreateFormCustomAttributeRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest=} [properties] Properties to set
                     */
                    function CreateFormCustomAttributeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormCustomAttributeRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @instance
                     */
                    CreateFormCustomAttributeRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormCustomAttributeRequest attribute.
                     * @member {palexy.task_management.v1.IFormCustomAttribute|null|undefined} attribute
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @instance
                     */
                    CreateFormCustomAttributeRequest.prototype.attribute = null;
    
                    /**
                     * Creates a new CreateFormCustomAttributeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormCustomAttributeRequest} CreateFormCustomAttributeRequest instance
                     */
                    CreateFormCustomAttributeRequest.create = function create(properties) {
                        return new CreateFormCustomAttributeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormCustomAttributeRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormCustomAttributeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest} message CreateFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormCustomAttributeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.attribute != null && Object.hasOwnProperty.call(message, "attribute"))
                            $root.palexy.task_management.v1.FormCustomAttribute.encode(message.attribute, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormCustomAttributeRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormCustomAttributeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomAttributeRequest} message CreateFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormCustomAttributeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormCustomAttributeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormCustomAttributeRequest} CreateFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormCustomAttributeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormCustomAttributeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormCustomAttributeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormCustomAttributeRequest} CreateFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormCustomAttributeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormCustomAttributeRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormCustomAttributeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.attribute != null && message.hasOwnProperty("attribute")) {
                            var error = $root.palexy.task_management.v1.FormCustomAttribute.verify(message.attribute);
                            if (error)
                                return "attribute." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormCustomAttributeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormCustomAttributeRequest} CreateFormCustomAttributeRequest
                     */
                    CreateFormCustomAttributeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormCustomAttributeRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormCustomAttributeRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.attribute != null) {
                            if (typeof object.attribute !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormCustomAttributeRequest.attribute: object expected");
                            message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.fromObject(object.attribute);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormCustomAttributeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormCustomAttributeRequest} message CreateFormCustomAttributeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormCustomAttributeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.attribute = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.attribute != null && message.hasOwnProperty("attribute"))
                            object.attribute = $root.palexy.task_management.v1.FormCustomAttribute.toObject(message.attribute, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormCustomAttributeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormCustomAttributeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormCustomAttributeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormCustomAttributeRequest;
                })();
    
                v1.ListFormCustomAttributesRequest = (function() {
    
                    /**
                     * Properties of a ListFormCustomAttributesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormCustomAttributesRequest
                     * @property {number|null} [formId] ListFormCustomAttributesRequest formId
                     * @property {number|null} [pageSize] ListFormCustomAttributesRequest pageSize
                     * @property {string|null} [pageToken] ListFormCustomAttributesRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListFormCustomAttributesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormCustomAttributesRequest.
                     * @implements IListFormCustomAttributesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest=} [properties] Properties to set
                     */
                    function ListFormCustomAttributesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormCustomAttributesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @instance
                     */
                    ListFormCustomAttributesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormCustomAttributesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @instance
                     */
                    ListFormCustomAttributesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormCustomAttributesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @instance
                     */
                    ListFormCustomAttributesRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListFormCustomAttributesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesRequest} ListFormCustomAttributesRequest instance
                     */
                    ListFormCustomAttributesRequest.create = function create(properties) {
                        return new ListFormCustomAttributesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormCustomAttributesRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormCustomAttributesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest} message ListFormCustomAttributesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomAttributesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormCustomAttributesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormCustomAttributesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesRequest} message ListFormCustomAttributesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomAttributesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormCustomAttributesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesRequest} ListFormCustomAttributesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomAttributesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormCustomAttributesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormCustomAttributesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesRequest} ListFormCustomAttributesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomAttributesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormCustomAttributesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormCustomAttributesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormCustomAttributesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesRequest} ListFormCustomAttributesRequest
                     */
                    ListFormCustomAttributesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormCustomAttributesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormCustomAttributesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormCustomAttributesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormCustomAttributesRequest} message ListFormCustomAttributesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormCustomAttributesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormCustomAttributesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormCustomAttributesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormCustomAttributesRequest;
                })();
    
                v1.ListFormCustomAttributesResponse = (function() {
    
                    /**
                     * Properties of a ListFormCustomAttributesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormCustomAttributesResponse
                     * @property {Array.<palexy.task_management.v1.IFormCustomAttribute>|null} [attributes] ListFormCustomAttributesResponse attributes
                     * @property {number|null} [totalElements] ListFormCustomAttributesResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormCustomAttributesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormCustomAttributesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormCustomAttributesResponse.
                     * @implements IListFormCustomAttributesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormCustomAttributesResponse=} [properties] Properties to set
                     */
                    function ListFormCustomAttributesResponse(properties) {
                        this.attributes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormCustomAttributesResponse attributes.
                     * @member {Array.<palexy.task_management.v1.IFormCustomAttribute>} attributes
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @instance
                     */
                    ListFormCustomAttributesResponse.prototype.attributes = $util.emptyArray;
    
                    /**
                     * ListFormCustomAttributesResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @instance
                     */
                    ListFormCustomAttributesResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormCustomAttributesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @instance
                     */
                    ListFormCustomAttributesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormCustomAttributesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesResponse} ListFormCustomAttributesResponse instance
                     */
                    ListFormCustomAttributesResponse.create = function create(properties) {
                        return new ListFormCustomAttributesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormCustomAttributesResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormCustomAttributesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesResponse} message ListFormCustomAttributesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomAttributesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributes != null && message.attributes.length)
                            for (var i = 0; i < message.attributes.length; ++i)
                                $root.palexy.task_management.v1.FormCustomAttribute.encode(message.attributes[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormCustomAttributesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormCustomAttributesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomAttributesResponse} message ListFormCustomAttributesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomAttributesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormCustomAttributesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesResponse} ListFormCustomAttributesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomAttributesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormCustomAttributesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.attributes && message.attributes.length))
                                    message.attributes = [];
                                message.attributes.push($root.palexy.task_management.v1.FormCustomAttribute.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormCustomAttributesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesResponse} ListFormCustomAttributesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomAttributesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormCustomAttributesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormCustomAttributesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributes != null && message.hasOwnProperty("attributes")) {
                            if (!Array.isArray(message.attributes))
                                return "attributes: array expected";
                            for (var i = 0; i < message.attributes.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormCustomAttribute.verify(message.attributes[i]);
                                if (error)
                                    return "attributes." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormCustomAttributesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormCustomAttributesResponse} ListFormCustomAttributesResponse
                     */
                    ListFormCustomAttributesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormCustomAttributesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormCustomAttributesResponse();
                        if (object.attributes) {
                            if (!Array.isArray(object.attributes))
                                throw TypeError(".palexy.task_management.v1.ListFormCustomAttributesResponse.attributes: array expected");
                            message.attributes = [];
                            for (var i = 0; i < object.attributes.length; ++i) {
                                if (typeof object.attributes[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormCustomAttributesResponse.attributes: object expected");
                                message.attributes[i] = $root.palexy.task_management.v1.FormCustomAttribute.fromObject(object.attributes[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormCustomAttributesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormCustomAttributesResponse} message ListFormCustomAttributesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormCustomAttributesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.attributes = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.attributes && message.attributes.length) {
                            object.attributes = [];
                            for (var j = 0; j < message.attributes.length; ++j)
                                object.attributes[j] = $root.palexy.task_management.v1.FormCustomAttribute.toObject(message.attributes[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormCustomAttributesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormCustomAttributesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormCustomAttributesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormCustomAttributesResponse;
                })();
    
                v1.GetFormCustomAttributeRequest = (function() {
    
                    /**
                     * Properties of a GetFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormCustomAttributeRequest
                     * @property {number|null} [formId] GetFormCustomAttributeRequest formId
                     * @property {number|null} [attributeId] GetFormCustomAttributeRequest attributeId
                     */
    
                    /**
                     * Constructs a new GetFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormCustomAttributeRequest.
                     * @implements IGetFormCustomAttributeRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest=} [properties] Properties to set
                     */
                    function GetFormCustomAttributeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormCustomAttributeRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @instance
                     */
                    GetFormCustomAttributeRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormCustomAttributeRequest attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @instance
                     */
                    GetFormCustomAttributeRequest.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetFormCustomAttributeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormCustomAttributeRequest} GetFormCustomAttributeRequest instance
                     */
                    GetFormCustomAttributeRequest.create = function create(properties) {
                        return new GetFormCustomAttributeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormCustomAttributeRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormCustomAttributeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest} message GetFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormCustomAttributeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.attributeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormCustomAttributeRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormCustomAttributeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormCustomAttributeRequest} message GetFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormCustomAttributeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormCustomAttributeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormCustomAttributeRequest} GetFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormCustomAttributeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormCustomAttributeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.attributeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormCustomAttributeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormCustomAttributeRequest} GetFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormCustomAttributeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormCustomAttributeRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormCustomAttributeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormCustomAttributeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormCustomAttributeRequest} GetFormCustomAttributeRequest
                     */
                    GetFormCustomAttributeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormCustomAttributeRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormCustomAttributeRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormCustomAttributeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormCustomAttributeRequest} message GetFormCustomAttributeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormCustomAttributeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormCustomAttributeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormCustomAttributeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormCustomAttributeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormCustomAttributeRequest;
                })();
    
                v1.UpdateFormCustomAttributeRequest = (function() {
    
                    /**
                     * Properties of an UpdateFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateFormCustomAttributeRequest
                     * @property {number|null} [formId] UpdateFormCustomAttributeRequest formId
                     * @property {number|null} [attributeId] UpdateFormCustomAttributeRequest attributeId
                     * @property {palexy.task_management.v1.IFormCustomAttribute|null} [attribute] UpdateFormCustomAttributeRequest attribute
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateFormCustomAttributeRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateFormCustomAttributeRequest.
                     * @implements IUpdateFormCustomAttributeRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest=} [properties] Properties to set
                     */
                    function UpdateFormCustomAttributeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateFormCustomAttributeRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @instance
                     */
                    UpdateFormCustomAttributeRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormCustomAttributeRequest attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @instance
                     */
                    UpdateFormCustomAttributeRequest.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateFormCustomAttributeRequest attribute.
                     * @member {palexy.task_management.v1.IFormCustomAttribute|null|undefined} attribute
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @instance
                     */
                    UpdateFormCustomAttributeRequest.prototype.attribute = null;
    
                    /**
                     * UpdateFormCustomAttributeRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @instance
                     */
                    UpdateFormCustomAttributeRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateFormCustomAttributeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateFormCustomAttributeRequest} UpdateFormCustomAttributeRequest instance
                     */
                    UpdateFormCustomAttributeRequest.create = function create(properties) {
                        return new UpdateFormCustomAttributeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateFormCustomAttributeRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateFormCustomAttributeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest} message UpdateFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormCustomAttributeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.attributeId);
                        if (message.attribute != null && Object.hasOwnProperty.call(message, "attribute"))
                            $root.palexy.task_management.v1.FormCustomAttribute.encode(message.attribute, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateFormCustomAttributeRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateFormCustomAttributeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateFormCustomAttributeRequest} message UpdateFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateFormCustomAttributeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateFormCustomAttributeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateFormCustomAttributeRequest} UpdateFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormCustomAttributeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateFormCustomAttributeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.attributeId = reader.int64();
                                break;
                            case 3:
                                message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateFormCustomAttributeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateFormCustomAttributeRequest} UpdateFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateFormCustomAttributeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateFormCustomAttributeRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateFormCustomAttributeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.attribute != null && message.hasOwnProperty("attribute")) {
                            var error = $root.palexy.task_management.v1.FormCustomAttribute.verify(message.attribute);
                            if (error)
                                return "attribute." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateFormCustomAttributeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateFormCustomAttributeRequest} UpdateFormCustomAttributeRequest
                     */
                    UpdateFormCustomAttributeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateFormCustomAttributeRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateFormCustomAttributeRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.attribute != null) {
                            if (typeof object.attribute !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormCustomAttributeRequest.attribute: object expected");
                            message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.fromObject(object.attribute);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateFormCustomAttributeRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateFormCustomAttributeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateFormCustomAttributeRequest} message UpdateFormCustomAttributeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateFormCustomAttributeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.attribute = null;
                            object.updateMask = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.attribute != null && message.hasOwnProperty("attribute"))
                            object.attribute = $root.palexy.task_management.v1.FormCustomAttribute.toObject(message.attribute, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateFormCustomAttributeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateFormCustomAttributeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateFormCustomAttributeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateFormCustomAttributeRequest;
                })();
    
                v1.ResolveFormLinkAttributeValuesRequest = (function() {
    
                    /**
                     * Properties of a ResolveFormLinkAttributeValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IResolveFormLinkAttributeValuesRequest
                     * @property {number|null} [formId] ResolveFormLinkAttributeValuesRequest formId
                     * @property {Object.<string,string>|null} [linkParameters] ResolveFormLinkAttributeValuesRequest linkParameters
                     */
    
                    /**
                     * Constructs a new ResolveFormLinkAttributeValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ResolveFormLinkAttributeValuesRequest.
                     * @implements IResolveFormLinkAttributeValuesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest=} [properties] Properties to set
                     */
                    function ResolveFormLinkAttributeValuesRequest(properties) {
                        this.linkParameters = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ResolveFormLinkAttributeValuesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @instance
                     */
                    ResolveFormLinkAttributeValuesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ResolveFormLinkAttributeValuesRequest linkParameters.
                     * @member {Object.<string,string>} linkParameters
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @instance
                     */
                    ResolveFormLinkAttributeValuesRequest.prototype.linkParameters = $util.emptyObject;
    
                    /**
                     * Creates a new ResolveFormLinkAttributeValuesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest} ResolveFormLinkAttributeValuesRequest instance
                     */
                    ResolveFormLinkAttributeValuesRequest.create = function create(properties) {
                        return new ResolveFormLinkAttributeValuesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ResolveFormLinkAttributeValuesRequest message. Does not implicitly {@link palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest} message ResolveFormLinkAttributeValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveFormLinkAttributeValuesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.linkParameters != null && Object.hasOwnProperty.call(message, "linkParameters"))
                            for (var keys = Object.keys(message.linkParameters), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 2, wireType 2 =*/18).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.linkParameters[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ResolveFormLinkAttributeValuesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesRequest} message ResolveFormLinkAttributeValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveFormLinkAttributeValuesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ResolveFormLinkAttributeValuesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest} ResolveFormLinkAttributeValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveFormLinkAttributeValuesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                if (message.linkParameters === $util.emptyObject)
                                    message.linkParameters = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.linkParameters[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ResolveFormLinkAttributeValuesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest} ResolveFormLinkAttributeValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveFormLinkAttributeValuesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ResolveFormLinkAttributeValuesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ResolveFormLinkAttributeValuesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.linkParameters != null && message.hasOwnProperty("linkParameters")) {
                            if (!$util.isObject(message.linkParameters))
                                return "linkParameters: object expected";
                            var key = Object.keys(message.linkParameters);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.linkParameters[key[i]]))
                                    return "linkParameters: string{k:string} expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ResolveFormLinkAttributeValuesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest} ResolveFormLinkAttributeValuesRequest
                     */
                    ResolveFormLinkAttributeValuesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.linkParameters) {
                            if (typeof object.linkParameters !== "object")
                                throw TypeError(".palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest.linkParameters: object expected");
                            message.linkParameters = {};
                            for (var keys = Object.keys(object.linkParameters), i = 0; i < keys.length; ++i)
                                message.linkParameters[keys[i]] = String(object.linkParameters[keys[i]]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ResolveFormLinkAttributeValuesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest} message ResolveFormLinkAttributeValuesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ResolveFormLinkAttributeValuesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.linkParameters = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        var keys2;
                        if (message.linkParameters && (keys2 = Object.keys(message.linkParameters)).length) {
                            object.linkParameters = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.linkParameters[keys2[j]] = message.linkParameters[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ResolveFormLinkAttributeValuesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ResolveFormLinkAttributeValuesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ResolveFormLinkAttributeValuesRequest;
                })();
    
                v1.ResolveFormLinkAttributeValuesResponse = (function() {
    
                    /**
                     * Properties of a ResolveFormLinkAttributeValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IResolveFormLinkAttributeValuesResponse
                     * @property {Object.<string,string>|null} [valuesByAttributeCode] ResolveFormLinkAttributeValuesResponse valuesByAttributeCode
                     */
    
                    /**
                     * Constructs a new ResolveFormLinkAttributeValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ResolveFormLinkAttributeValuesResponse.
                     * @implements IResolveFormLinkAttributeValuesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesResponse=} [properties] Properties to set
                     */
                    function ResolveFormLinkAttributeValuesResponse(properties) {
                        this.valuesByAttributeCode = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ResolveFormLinkAttributeValuesResponse valuesByAttributeCode.
                     * @member {Object.<string,string>} valuesByAttributeCode
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @instance
                     */
                    ResolveFormLinkAttributeValuesResponse.prototype.valuesByAttributeCode = $util.emptyObject;
    
                    /**
                     * Creates a new ResolveFormLinkAttributeValuesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} ResolveFormLinkAttributeValuesResponse instance
                     */
                    ResolveFormLinkAttributeValuesResponse.create = function create(properties) {
                        return new ResolveFormLinkAttributeValuesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ResolveFormLinkAttributeValuesResponse message. Does not implicitly {@link palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesResponse} message ResolveFormLinkAttributeValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveFormLinkAttributeValuesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.valuesByAttributeCode != null && Object.hasOwnProperty.call(message, "valuesByAttributeCode"))
                            for (var keys = Object.keys(message.valuesByAttributeCode), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.valuesByAttributeCode[keys[i]]).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ResolveFormLinkAttributeValuesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IResolveFormLinkAttributeValuesResponse} message ResolveFormLinkAttributeValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ResolveFormLinkAttributeValuesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ResolveFormLinkAttributeValuesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} ResolveFormLinkAttributeValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveFormLinkAttributeValuesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (message.valuesByAttributeCode === $util.emptyObject)
                                    message.valuesByAttributeCode = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.valuesByAttributeCode[key] = value;
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ResolveFormLinkAttributeValuesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} ResolveFormLinkAttributeValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ResolveFormLinkAttributeValuesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ResolveFormLinkAttributeValuesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ResolveFormLinkAttributeValuesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.valuesByAttributeCode != null && message.hasOwnProperty("valuesByAttributeCode")) {
                            if (!$util.isObject(message.valuesByAttributeCode))
                                return "valuesByAttributeCode: object expected";
                            var key = Object.keys(message.valuesByAttributeCode);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.valuesByAttributeCode[key[i]]))
                                    return "valuesByAttributeCode: string{k:string} expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ResolveFormLinkAttributeValuesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} ResolveFormLinkAttributeValuesResponse
                     */
                    ResolveFormLinkAttributeValuesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse();
                        if (object.valuesByAttributeCode) {
                            if (typeof object.valuesByAttributeCode !== "object")
                                throw TypeError(".palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse.valuesByAttributeCode: object expected");
                            message.valuesByAttributeCode = {};
                            for (var keys = Object.keys(object.valuesByAttributeCode), i = 0; i < keys.length; ++i)
                                message.valuesByAttributeCode[keys[i]] = String(object.valuesByAttributeCode[keys[i]]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ResolveFormLinkAttributeValuesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse} message ResolveFormLinkAttributeValuesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ResolveFormLinkAttributeValuesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.valuesByAttributeCode = {};
                        var keys2;
                        if (message.valuesByAttributeCode && (keys2 = Object.keys(message.valuesByAttributeCode)).length) {
                            object.valuesByAttributeCode = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.valuesByAttributeCode[keys2[j]] = message.valuesByAttributeCode[keys2[j]];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ResolveFormLinkAttributeValuesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ResolveFormLinkAttributeValuesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ResolveFormLinkAttributeValuesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ResolveFormLinkAttributeValuesResponse;
                })();
    
                v1.DeleteFormCustomAttributeRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormCustomAttributeRequest
                     * @property {number|null} [formId] DeleteFormCustomAttributeRequest formId
                     * @property {number|null} [attributeId] DeleteFormCustomAttributeRequest attributeId
                     */
    
                    /**
                     * Constructs a new DeleteFormCustomAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormCustomAttributeRequest.
                     * @implements IDeleteFormCustomAttributeRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest=} [properties] Properties to set
                     */
                    function DeleteFormCustomAttributeRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormCustomAttributeRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @instance
                     */
                    DeleteFormCustomAttributeRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormCustomAttributeRequest attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @instance
                     */
                    DeleteFormCustomAttributeRequest.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormCustomAttributeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormCustomAttributeRequest} DeleteFormCustomAttributeRequest instance
                     */
                    DeleteFormCustomAttributeRequest.create = function create(properties) {
                        return new DeleteFormCustomAttributeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormCustomAttributeRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormCustomAttributeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest} message DeleteFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormCustomAttributeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.attributeId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormCustomAttributeRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormCustomAttributeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomAttributeRequest} message DeleteFormCustomAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormCustomAttributeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormCustomAttributeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormCustomAttributeRequest} DeleteFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormCustomAttributeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormCustomAttributeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.attributeId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormCustomAttributeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormCustomAttributeRequest} DeleteFormCustomAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormCustomAttributeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormCustomAttributeRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormCustomAttributeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormCustomAttributeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormCustomAttributeRequest} DeleteFormCustomAttributeRequest
                     */
                    DeleteFormCustomAttributeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormCustomAttributeRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormCustomAttributeRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormCustomAttributeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormCustomAttributeRequest} message DeleteFormCustomAttributeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormCustomAttributeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormCustomAttributeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormCustomAttributeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormCustomAttributeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormCustomAttributeRequest;
                })();
    
                v1.FormCustomAction = (function() {
    
                    /**
                     * Properties of a FormCustomAction.
                     * @memberof palexy.task_management.v1
                     * @interface IFormCustomAction
                     * @property {number|null} [id] FormCustomAction id
                     * @property {number|null} [formId] FormCustomAction formId
                     * @property {palexy.task_management.v1.FormCustomActionType|null} [actionType] FormCustomAction actionType
                     * @property {palexy.task_management.v1.IFormActionInputSource|null} [inputSource] FormCustomAction inputSource
                     * @property {number|null} [outputAttributeId] FormCustomAction outputAttributeId
                     * @property {palexy.task_management.v1.IFormPassCondition|null} [passCondition] FormCustomAction passCondition
                     * @property {number|null} [createdTimeMs] FormCustomAction createdTimeMs
                     */
    
                    /**
                     * Constructs a new FormCustomAction.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormCustomAction.
                     * @implements IFormCustomAction
                     * @constructor
                     * @param {palexy.task_management.v1.IFormCustomAction=} [properties] Properties to set
                     */
                    function FormCustomAction(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormCustomAction id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAction formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAction actionType.
                     * @member {palexy.task_management.v1.FormCustomActionType} actionType
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.actionType = 0;
    
                    /**
                     * FormCustomAction inputSource.
                     * @member {palexy.task_management.v1.IFormActionInputSource|null|undefined} inputSource
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.inputSource = null;
    
                    /**
                     * FormCustomAction outputAttributeId.
                     * @member {number} outputAttributeId
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.outputAttributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormCustomAction passCondition.
                     * @member {palexy.task_management.v1.IFormPassCondition|null|undefined} passCondition
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.passCondition = null;
    
                    /**
                     * FormCustomAction createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     */
                    FormCustomAction.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FormCustomAction instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAction=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormCustomAction} FormCustomAction instance
                     */
                    FormCustomAction.create = function create(properties) {
                        return new FormCustomAction(properties);
                    };
    
                    /**
                     * Encodes the specified FormCustomAction message. Does not implicitly {@link palexy.task_management.v1.FormCustomAction.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAction} message FormCustomAction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormCustomAction.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.actionType != null && Object.hasOwnProperty.call(message, "actionType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.actionType);
                        if (message.inputSource != null && Object.hasOwnProperty.call(message, "inputSource"))
                            $root.palexy.task_management.v1.FormActionInputSource.encode(message.inputSource, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.outputAttributeId != null && Object.hasOwnProperty.call(message, "outputAttributeId"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.outputAttributeId);
                        if (message.passCondition != null && Object.hasOwnProperty.call(message, "passCondition"))
                            $root.palexy.task_management.v1.FormPassCondition.encode(message.passCondition, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createdTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormCustomAction message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormCustomAction.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {palexy.task_management.v1.IFormCustomAction} message FormCustomAction message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormCustomAction.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormCustomAction message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormCustomAction} FormCustomAction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormCustomAction.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormCustomAction();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.actionType = reader.int32();
                                break;
                            case 4:
                                message.inputSource = $root.palexy.task_management.v1.FormActionInputSource.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.outputAttributeId = reader.int64();
                                break;
                            case 6:
                                message.passCondition = $root.palexy.task_management.v1.FormPassCondition.decode(reader, reader.uint32());
                                break;
                            case 7:
                                message.createdTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormCustomAction message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormCustomAction} FormCustomAction
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormCustomAction.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormCustomAction message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormCustomAction.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            switch (message.actionType) {
                            default:
                                return "actionType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.inputSource != null && message.hasOwnProperty("inputSource")) {
                            var error = $root.palexy.task_management.v1.FormActionInputSource.verify(message.inputSource);
                            if (error)
                                return "inputSource." + error;
                        }
                        if (message.outputAttributeId != null && message.hasOwnProperty("outputAttributeId"))
                            if (!$util.isInteger(message.outputAttributeId) && !(message.outputAttributeId && $util.isInteger(message.outputAttributeId.low) && $util.isInteger(message.outputAttributeId.high)))
                                return "outputAttributeId: integer|Long expected";
                        if (message.passCondition != null && message.hasOwnProperty("passCondition")) {
                            var error = $root.palexy.task_management.v1.FormPassCondition.verify(message.passCondition);
                            if (error)
                                return "passCondition." + error;
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormCustomAction message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormCustomAction} FormCustomAction
                     */
                    FormCustomAction.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormCustomAction)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormCustomAction();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        switch (object.actionType) {
                        case "FORM_CUSTOM_ACTION_TYPE_UNKNOWN":
                        case 0:
                            message.actionType = 0;
                            break;
                        case "FORM_CUSTOM_ACTION_TYPE_PASS_FAIL_LABEL":
                        case 1:
                            message.actionType = 1;
                            break;
                        case "FORM_CUSTOM_ACTION_TYPE_AI_READ_TEMPERATURE":
                        case 2:
                            message.actionType = 2;
                            break;
                        case "FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_SCORE":
                        case 3:
                            message.actionType = 3;
                            break;
                        case "FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_TOPICS":
                        case 4:
                            message.actionType = 4;
                            break;
                        }
                        if (object.inputSource != null) {
                            if (typeof object.inputSource !== "object")
                                throw TypeError(".palexy.task_management.v1.FormCustomAction.inputSource: object expected");
                            message.inputSource = $root.palexy.task_management.v1.FormActionInputSource.fromObject(object.inputSource);
                        }
                        if (object.outputAttributeId != null)
                            if ($util.Long)
                                (message.outputAttributeId = $util.Long.fromValue(object.outputAttributeId)).unsigned = false;
                            else if (typeof object.outputAttributeId === "string")
                                message.outputAttributeId = parseInt(object.outputAttributeId, 10);
                            else if (typeof object.outputAttributeId === "number")
                                message.outputAttributeId = object.outputAttributeId;
                            else if (typeof object.outputAttributeId === "object")
                                message.outputAttributeId = new $util.LongBits(object.outputAttributeId.low >>> 0, object.outputAttributeId.high >>> 0).toNumber();
                        if (object.passCondition != null) {
                            if (typeof object.passCondition !== "object")
                                throw TypeError(".palexy.task_management.v1.FormCustomAction.passCondition: object expected");
                            message.passCondition = $root.palexy.task_management.v1.FormPassCondition.fromObject(object.passCondition);
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormCustomAction message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @static
                     * @param {palexy.task_management.v1.FormCustomAction} message FormCustomAction
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormCustomAction.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.actionType = options.enums === String ? "FORM_CUSTOM_ACTION_TYPE_UNKNOWN" : 0;
                            object.inputSource = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.outputAttributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.outputAttributeId = options.longs === String ? "0" : 0;
                            object.passCondition = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.actionType != null && message.hasOwnProperty("actionType"))
                            object.actionType = options.enums === String ? $root.palexy.task_management.v1.FormCustomActionType[message.actionType] : message.actionType;
                        if (message.inputSource != null && message.hasOwnProperty("inputSource"))
                            object.inputSource = $root.palexy.task_management.v1.FormActionInputSource.toObject(message.inputSource, options);
                        if (message.outputAttributeId != null && message.hasOwnProperty("outputAttributeId"))
                            if (typeof message.outputAttributeId === "number")
                                object.outputAttributeId = options.longs === String ? String(message.outputAttributeId) : message.outputAttributeId;
                            else
                                object.outputAttributeId = options.longs === String ? $util.Long.prototype.toString.call(message.outputAttributeId) : options.longs === Number ? new $util.LongBits(message.outputAttributeId.low >>> 0, message.outputAttributeId.high >>> 0).toNumber() : message.outputAttributeId;
                        if (message.passCondition != null && message.hasOwnProperty("passCondition"))
                            object.passCondition = $root.palexy.task_management.v1.FormPassCondition.toObject(message.passCondition, options);
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this FormCustomAction to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormCustomAction
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormCustomAction.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormCustomAction;
                })();
    
                /**
                 * FormCustomActionType enum.
                 * @name palexy.task_management.v1.FormCustomActionType
                 * @enum {number}
                 * @property {number} FORM_CUSTOM_ACTION_TYPE_UNKNOWN=0 FORM_CUSTOM_ACTION_TYPE_UNKNOWN value
                 * @property {number} FORM_CUSTOM_ACTION_TYPE_PASS_FAIL_LABEL=1 FORM_CUSTOM_ACTION_TYPE_PASS_FAIL_LABEL value
                 * @property {number} FORM_CUSTOM_ACTION_TYPE_AI_READ_TEMPERATURE=2 FORM_CUSTOM_ACTION_TYPE_AI_READ_TEMPERATURE value
                 * @property {number} FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_SCORE=3 FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_SCORE value
                 * @property {number} FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_TOPICS=4 FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_TOPICS value
                 */
                v1.FormCustomActionType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FORM_CUSTOM_ACTION_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "FORM_CUSTOM_ACTION_TYPE_PASS_FAIL_LABEL"] = 1;
                    values[valuesById[2] = "FORM_CUSTOM_ACTION_TYPE_AI_READ_TEMPERATURE"] = 2;
                    values[valuesById[3] = "FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_SCORE"] = 3;
                    values[valuesById[4] = "FORM_CUSTOM_ACTION_TYPE_AI_SENTIMENT_TOPICS"] = 4;
                    return values;
                })();
    
                v1.FormActionInputSource = (function() {
    
                    /**
                     * Properties of a FormActionInputSource.
                     * @memberof palexy.task_management.v1
                     * @interface IFormActionInputSource
                     * @property {number|null} [formFieldId] FormActionInputSource formFieldId
                     * @property {number|null} [attributeId] FormActionInputSource attributeId
                     * @property {palexy.task_management.v1.IFormField|null} [formField] FormActionInputSource formField
                     * @property {palexy.task_management.v1.IFormCustomAttribute|null} [attribute] FormActionInputSource attribute
                     * @property {string|null} [internalQuestionId] FormActionInputSource internalQuestionId
                     */
    
                    /**
                     * Constructs a new FormActionInputSource.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormActionInputSource.
                     * @implements IFormActionInputSource
                     * @constructor
                     * @param {palexy.task_management.v1.IFormActionInputSource=} [properties] Properties to set
                     */
                    function FormActionInputSource(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormActionInputSource formFieldId.
                     * @member {number} formFieldId
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     */
                    FormActionInputSource.prototype.formFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormActionInputSource attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     */
                    FormActionInputSource.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormActionInputSource formField.
                     * @member {palexy.task_management.v1.IFormField|null|undefined} formField
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     */
                    FormActionInputSource.prototype.formField = null;
    
                    /**
                     * FormActionInputSource attribute.
                     * @member {palexy.task_management.v1.IFormCustomAttribute|null|undefined} attribute
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     */
                    FormActionInputSource.prototype.attribute = null;
    
                    /**
                     * FormActionInputSource internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     */
                    FormActionInputSource.prototype.internalQuestionId = "";
    
                    /**
                     * Creates a new FormActionInputSource instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {palexy.task_management.v1.IFormActionInputSource=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormActionInputSource} FormActionInputSource instance
                     */
                    FormActionInputSource.create = function create(properties) {
                        return new FormActionInputSource(properties);
                    };
    
                    /**
                     * Encodes the specified FormActionInputSource message. Does not implicitly {@link palexy.task_management.v1.FormActionInputSource.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {palexy.task_management.v1.IFormActionInputSource} message FormActionInputSource message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormActionInputSource.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formFieldId != null && Object.hasOwnProperty.call(message, "formFieldId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formFieldId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.attributeId);
                        if (message.formField != null && Object.hasOwnProperty.call(message, "formField"))
                            $root.palexy.task_management.v1.FormField.encode(message.formField, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.attribute != null && Object.hasOwnProperty.call(message, "attribute"))
                            $root.palexy.task_management.v1.FormCustomAttribute.encode(message.attribute, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.internalQuestionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormActionInputSource message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormActionInputSource.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {palexy.task_management.v1.IFormActionInputSource} message FormActionInputSource message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormActionInputSource.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormActionInputSource message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormActionInputSource} FormActionInputSource
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormActionInputSource.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormActionInputSource();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formFieldId = reader.int64();
                                break;
                            case 2:
                                message.attributeId = reader.int64();
                                break;
                            case 3:
                                message.formField = $root.palexy.task_management.v1.FormField.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.internalQuestionId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormActionInputSource message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormActionInputSource} FormActionInputSource
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormActionInputSource.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormActionInputSource message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormActionInputSource.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (!$util.isInteger(message.formFieldId) && !(message.formFieldId && $util.isInteger(message.formFieldId.low) && $util.isInteger(message.formFieldId.high)))
                                return "formFieldId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.formField != null && message.hasOwnProperty("formField")) {
                            var error = $root.palexy.task_management.v1.FormField.verify(message.formField);
                            if (error)
                                return "formField." + error;
                        }
                        if (message.attribute != null && message.hasOwnProperty("attribute")) {
                            var error = $root.palexy.task_management.v1.FormCustomAttribute.verify(message.attribute);
                            if (error)
                                return "attribute." + error;
                        }
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormActionInputSource message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormActionInputSource} FormActionInputSource
                     */
                    FormActionInputSource.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormActionInputSource)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormActionInputSource();
                        if (object.formFieldId != null)
                            if ($util.Long)
                                (message.formFieldId = $util.Long.fromValue(object.formFieldId)).unsigned = false;
                            else if (typeof object.formFieldId === "string")
                                message.formFieldId = parseInt(object.formFieldId, 10);
                            else if (typeof object.formFieldId === "number")
                                message.formFieldId = object.formFieldId;
                            else if (typeof object.formFieldId === "object")
                                message.formFieldId = new $util.LongBits(object.formFieldId.low >>> 0, object.formFieldId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.formField != null) {
                            if (typeof object.formField !== "object")
                                throw TypeError(".palexy.task_management.v1.FormActionInputSource.formField: object expected");
                            message.formField = $root.palexy.task_management.v1.FormField.fromObject(object.formField);
                        }
                        if (object.attribute != null) {
                            if (typeof object.attribute !== "object")
                                throw TypeError(".palexy.task_management.v1.FormActionInputSource.attribute: object expected");
                            message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.fromObject(object.attribute);
                        }
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormActionInputSource message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @static
                     * @param {palexy.task_management.v1.FormActionInputSource} message FormActionInputSource
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormActionInputSource.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formFieldId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.formField = null;
                            object.attribute = null;
                            object.internalQuestionId = "";
                        }
                        if (message.formFieldId != null && message.hasOwnProperty("formFieldId"))
                            if (typeof message.formFieldId === "number")
                                object.formFieldId = options.longs === String ? String(message.formFieldId) : message.formFieldId;
                            else
                                object.formFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.formFieldId) : options.longs === Number ? new $util.LongBits(message.formFieldId.low >>> 0, message.formFieldId.high >>> 0).toNumber() : message.formFieldId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.formField != null && message.hasOwnProperty("formField"))
                            object.formField = $root.palexy.task_management.v1.FormField.toObject(message.formField, options);
                        if (message.attribute != null && message.hasOwnProperty("attribute"))
                            object.attribute = $root.palexy.task_management.v1.FormCustomAttribute.toObject(message.attribute, options);
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        return object;
                    };
    
                    /**
                     * Converts this FormActionInputSource to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormActionInputSource
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormActionInputSource.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormActionInputSource;
                })();
    
                /**
                 * FormPassConditionType enum.
                 * @name palexy.task_management.v1.FormPassConditionType
                 * @enum {number}
                 * @property {number} FORM_PASS_CONDITION_TYPE_UNKNOWN=0 FORM_PASS_CONDITION_TYPE_UNKNOWN value
                 * @property {number} EQUAL_TO_VALUE=1 EQUAL_TO_VALUE value
                 * @property {number} EQUAL_TO_VALUES=2 EQUAL_TO_VALUES value
                 * @property {number} NUMBER_EQUAL=3 NUMBER_EQUAL value
                 * @property {number} NUMBER_LESS_THAN_OR_EQUAL=4 NUMBER_LESS_THAN_OR_EQUAL value
                 * @property {number} NUMBER_GREATER_THAN_OR_EQUAL=5 NUMBER_GREATER_THAN_OR_EQUAL value
                 */
                v1.FormPassConditionType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FORM_PASS_CONDITION_TYPE_UNKNOWN"] = 0;
                    values[valuesById[1] = "EQUAL_TO_VALUE"] = 1;
                    values[valuesById[2] = "EQUAL_TO_VALUES"] = 2;
                    values[valuesById[3] = "NUMBER_EQUAL"] = 3;
                    values[valuesById[4] = "NUMBER_LESS_THAN_OR_EQUAL"] = 4;
                    values[valuesById[5] = "NUMBER_GREATER_THAN_OR_EQUAL"] = 5;
                    return values;
                })();
    
                v1.FormPassCondition = (function() {
    
                    /**
                     * Properties of a FormPassCondition.
                     * @memberof palexy.task_management.v1
                     * @interface IFormPassCondition
                     * @property {palexy.task_management.v1.FormPassConditionType|null} [type] FormPassCondition type
                     * @property {string|null} [expectedValue] FormPassCondition expectedValue
                     * @property {Array.<palexy.task_management.v1.IOption>|null} [expectedOptions] FormPassCondition expectedOptions
                     * @property {number|null} [numberValue] FormPassCondition numberValue
                     * @property {number|null} [compareAttributeId] FormPassCondition compareAttributeId
                     * @property {number|null} [compareFormFieldId] FormPassCondition compareFormFieldId
                     * @property {string|null} [compareInternalQuestionId] FormPassCondition compareInternalQuestionId
                     */
    
                    /**
                     * Constructs a new FormPassCondition.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormPassCondition.
                     * @implements IFormPassCondition
                     * @constructor
                     * @param {palexy.task_management.v1.IFormPassCondition=} [properties] Properties to set
                     */
                    function FormPassCondition(properties) {
                        this.expectedOptions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormPassCondition type.
                     * @member {palexy.task_management.v1.FormPassConditionType} type
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.type = 0;
    
                    /**
                     * FormPassCondition expectedValue.
                     * @member {string} expectedValue
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.expectedValue = "";
    
                    /**
                     * FormPassCondition expectedOptions.
                     * @member {Array.<palexy.task_management.v1.IOption>} expectedOptions
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.expectedOptions = $util.emptyArray;
    
                    /**
                     * FormPassCondition numberValue.
                     * @member {number} numberValue
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.numberValue = 0;
    
                    /**
                     * FormPassCondition compareAttributeId.
                     * @member {number} compareAttributeId
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.compareAttributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormPassCondition compareFormFieldId.
                     * @member {number} compareFormFieldId
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.compareFormFieldId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormPassCondition compareInternalQuestionId.
                     * @member {string} compareInternalQuestionId
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     */
                    FormPassCondition.prototype.compareInternalQuestionId = "";
    
                    /**
                     * Creates a new FormPassCondition instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {palexy.task_management.v1.IFormPassCondition=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormPassCondition} FormPassCondition instance
                     */
                    FormPassCondition.create = function create(properties) {
                        return new FormPassCondition(properties);
                    };
    
                    /**
                     * Encodes the specified FormPassCondition message. Does not implicitly {@link palexy.task_management.v1.FormPassCondition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {palexy.task_management.v1.IFormPassCondition} message FormPassCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormPassCondition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.expectedValue != null && Object.hasOwnProperty.call(message, "expectedValue"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.expectedValue);
                        if (message.compareAttributeId != null && Object.hasOwnProperty.call(message, "compareAttributeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.compareAttributeId);
                        if (message.expectedOptions != null && message.expectedOptions.length)
                            for (var i = 0; i < message.expectedOptions.length; ++i)
                                $root.palexy.task_management.v1.Option.encode(message.expectedOptions[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.numberValue != null && Object.hasOwnProperty.call(message, "numberValue"))
                            writer.uint32(/* id 5, wireType 1 =*/41).double(message.numberValue);
                        if (message.compareFormFieldId != null && Object.hasOwnProperty.call(message, "compareFormFieldId"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.compareFormFieldId);
                        if (message.compareInternalQuestionId != null && Object.hasOwnProperty.call(message, "compareInternalQuestionId"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.compareInternalQuestionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormPassCondition message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormPassCondition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {palexy.task_management.v1.IFormPassCondition} message FormPassCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormPassCondition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormPassCondition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormPassCondition} FormPassCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormPassCondition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormPassCondition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 2:
                                message.expectedValue = reader.string();
                                break;
                            case 4:
                                if (!(message.expectedOptions && message.expectedOptions.length))
                                    message.expectedOptions = [];
                                message.expectedOptions.push($root.palexy.task_management.v1.Option.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.numberValue = reader.double();
                                break;
                            case 3:
                                message.compareAttributeId = reader.int64();
                                break;
                            case 6:
                                message.compareFormFieldId = reader.int64();
                                break;
                            case 7:
                                message.compareInternalQuestionId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormPassCondition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormPassCondition} FormPassCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormPassCondition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormPassCondition message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormPassCondition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.expectedValue != null && message.hasOwnProperty("expectedValue"))
                            if (!$util.isString(message.expectedValue))
                                return "expectedValue: string expected";
                        if (message.expectedOptions != null && message.hasOwnProperty("expectedOptions")) {
                            if (!Array.isArray(message.expectedOptions))
                                return "expectedOptions: array expected";
                            for (var i = 0; i < message.expectedOptions.length; ++i) {
                                var error = $root.palexy.task_management.v1.Option.verify(message.expectedOptions[i]);
                                if (error)
                                    return "expectedOptions." + error;
                            }
                        }
                        if (message.numberValue != null && message.hasOwnProperty("numberValue"))
                            if (typeof message.numberValue !== "number")
                                return "numberValue: number expected";
                        if (message.compareAttributeId != null && message.hasOwnProperty("compareAttributeId"))
                            if (!$util.isInteger(message.compareAttributeId) && !(message.compareAttributeId && $util.isInteger(message.compareAttributeId.low) && $util.isInteger(message.compareAttributeId.high)))
                                return "compareAttributeId: integer|Long expected";
                        if (message.compareFormFieldId != null && message.hasOwnProperty("compareFormFieldId"))
                            if (!$util.isInteger(message.compareFormFieldId) && !(message.compareFormFieldId && $util.isInteger(message.compareFormFieldId.low) && $util.isInteger(message.compareFormFieldId.high)))
                                return "compareFormFieldId: integer|Long expected";
                        if (message.compareInternalQuestionId != null && message.hasOwnProperty("compareInternalQuestionId"))
                            if (!$util.isString(message.compareInternalQuestionId))
                                return "compareInternalQuestionId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormPassCondition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormPassCondition} FormPassCondition
                     */
                    FormPassCondition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormPassCondition)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormPassCondition();
                        switch (object.type) {
                        case "FORM_PASS_CONDITION_TYPE_UNKNOWN":
                        case 0:
                            message.type = 0;
                            break;
                        case "EQUAL_TO_VALUE":
                        case 1:
                            message.type = 1;
                            break;
                        case "EQUAL_TO_VALUES":
                        case 2:
                            message.type = 2;
                            break;
                        case "NUMBER_EQUAL":
                        case 3:
                            message.type = 3;
                            break;
                        case "NUMBER_LESS_THAN_OR_EQUAL":
                        case 4:
                            message.type = 4;
                            break;
                        case "NUMBER_GREATER_THAN_OR_EQUAL":
                        case 5:
                            message.type = 5;
                            break;
                        }
                        if (object.expectedValue != null)
                            message.expectedValue = String(object.expectedValue);
                        if (object.expectedOptions) {
                            if (!Array.isArray(object.expectedOptions))
                                throw TypeError(".palexy.task_management.v1.FormPassCondition.expectedOptions: array expected");
                            message.expectedOptions = [];
                            for (var i = 0; i < object.expectedOptions.length; ++i) {
                                if (typeof object.expectedOptions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormPassCondition.expectedOptions: object expected");
                                message.expectedOptions[i] = $root.palexy.task_management.v1.Option.fromObject(object.expectedOptions[i]);
                            }
                        }
                        if (object.numberValue != null)
                            message.numberValue = Number(object.numberValue);
                        if (object.compareAttributeId != null)
                            if ($util.Long)
                                (message.compareAttributeId = $util.Long.fromValue(object.compareAttributeId)).unsigned = false;
                            else if (typeof object.compareAttributeId === "string")
                                message.compareAttributeId = parseInt(object.compareAttributeId, 10);
                            else if (typeof object.compareAttributeId === "number")
                                message.compareAttributeId = object.compareAttributeId;
                            else if (typeof object.compareAttributeId === "object")
                                message.compareAttributeId = new $util.LongBits(object.compareAttributeId.low >>> 0, object.compareAttributeId.high >>> 0).toNumber();
                        if (object.compareFormFieldId != null)
                            if ($util.Long)
                                (message.compareFormFieldId = $util.Long.fromValue(object.compareFormFieldId)).unsigned = false;
                            else if (typeof object.compareFormFieldId === "string")
                                message.compareFormFieldId = parseInt(object.compareFormFieldId, 10);
                            else if (typeof object.compareFormFieldId === "number")
                                message.compareFormFieldId = object.compareFormFieldId;
                            else if (typeof object.compareFormFieldId === "object")
                                message.compareFormFieldId = new $util.LongBits(object.compareFormFieldId.low >>> 0, object.compareFormFieldId.high >>> 0).toNumber();
                        if (object.compareInternalQuestionId != null)
                            message.compareInternalQuestionId = String(object.compareInternalQuestionId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormPassCondition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @static
                     * @param {palexy.task_management.v1.FormPassCondition} message FormPassCondition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormPassCondition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.expectedOptions = [];
                        if (options.defaults) {
                            object.type = options.enums === String ? "FORM_PASS_CONDITION_TYPE_UNKNOWN" : 0;
                            object.expectedValue = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.compareAttributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.compareAttributeId = options.longs === String ? "0" : 0;
                            object.numberValue = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.compareFormFieldId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.compareFormFieldId = options.longs === String ? "0" : 0;
                            object.compareInternalQuestionId = "";
                        }
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.task_management.v1.FormPassConditionType[message.type] : message.type;
                        if (message.expectedValue != null && message.hasOwnProperty("expectedValue"))
                            object.expectedValue = message.expectedValue;
                        if (message.compareAttributeId != null && message.hasOwnProperty("compareAttributeId"))
                            if (typeof message.compareAttributeId === "number")
                                object.compareAttributeId = options.longs === String ? String(message.compareAttributeId) : message.compareAttributeId;
                            else
                                object.compareAttributeId = options.longs === String ? $util.Long.prototype.toString.call(message.compareAttributeId) : options.longs === Number ? new $util.LongBits(message.compareAttributeId.low >>> 0, message.compareAttributeId.high >>> 0).toNumber() : message.compareAttributeId;
                        if (message.expectedOptions && message.expectedOptions.length) {
                            object.expectedOptions = [];
                            for (var j = 0; j < message.expectedOptions.length; ++j)
                                object.expectedOptions[j] = $root.palexy.task_management.v1.Option.toObject(message.expectedOptions[j], options);
                        }
                        if (message.numberValue != null && message.hasOwnProperty("numberValue"))
                            object.numberValue = options.json && !isFinite(message.numberValue) ? String(message.numberValue) : message.numberValue;
                        if (message.compareFormFieldId != null && message.hasOwnProperty("compareFormFieldId"))
                            if (typeof message.compareFormFieldId === "number")
                                object.compareFormFieldId = options.longs === String ? String(message.compareFormFieldId) : message.compareFormFieldId;
                            else
                                object.compareFormFieldId = options.longs === String ? $util.Long.prototype.toString.call(message.compareFormFieldId) : options.longs === Number ? new $util.LongBits(message.compareFormFieldId.low >>> 0, message.compareFormFieldId.high >>> 0).toNumber() : message.compareFormFieldId;
                        if (message.compareInternalQuestionId != null && message.hasOwnProperty("compareInternalQuestionId"))
                            object.compareInternalQuestionId = message.compareInternalQuestionId;
                        return object;
                    };
    
                    /**
                     * Converts this FormPassCondition to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormPassCondition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormPassCondition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormPassCondition;
                })();
    
                v1.CreateFormCustomActionRequest = (function() {
    
                    /**
                     * Properties of a CreateFormCustomActionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateFormCustomActionRequest
                     * @property {number|null} [formId] CreateFormCustomActionRequest formId
                     * @property {palexy.task_management.v1.IFormCustomAction|null} [action] CreateFormCustomActionRequest action
                     */
    
                    /**
                     * Constructs a new CreateFormCustomActionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateFormCustomActionRequest.
                     * @implements ICreateFormCustomActionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest=} [properties] Properties to set
                     */
                    function CreateFormCustomActionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateFormCustomActionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @instance
                     */
                    CreateFormCustomActionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateFormCustomActionRequest action.
                     * @member {palexy.task_management.v1.IFormCustomAction|null|undefined} action
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @instance
                     */
                    CreateFormCustomActionRequest.prototype.action = null;
    
                    /**
                     * Creates a new CreateFormCustomActionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateFormCustomActionRequest} CreateFormCustomActionRequest instance
                     */
                    CreateFormCustomActionRequest.create = function create(properties) {
                        return new CreateFormCustomActionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateFormCustomActionRequest message. Does not implicitly {@link palexy.task_management.v1.CreateFormCustomActionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest} message CreateFormCustomActionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormCustomActionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.action != null && Object.hasOwnProperty.call(message, "action"))
                            $root.palexy.task_management.v1.FormCustomAction.encode(message.action, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateFormCustomActionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateFormCustomActionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateFormCustomActionRequest} message CreateFormCustomActionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateFormCustomActionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateFormCustomActionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateFormCustomActionRequest} CreateFormCustomActionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormCustomActionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateFormCustomActionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.action = $root.palexy.task_management.v1.FormCustomAction.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateFormCustomActionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateFormCustomActionRequest} CreateFormCustomActionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateFormCustomActionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateFormCustomActionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateFormCustomActionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.action != null && message.hasOwnProperty("action")) {
                            var error = $root.palexy.task_management.v1.FormCustomAction.verify(message.action);
                            if (error)
                                return "action." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateFormCustomActionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateFormCustomActionRequest} CreateFormCustomActionRequest
                     */
                    CreateFormCustomActionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateFormCustomActionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateFormCustomActionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.action != null) {
                            if (typeof object.action !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateFormCustomActionRequest.action: object expected");
                            message.action = $root.palexy.task_management.v1.FormCustomAction.fromObject(object.action);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateFormCustomActionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateFormCustomActionRequest} message CreateFormCustomActionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateFormCustomActionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.action = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.action != null && message.hasOwnProperty("action"))
                            object.action = $root.palexy.task_management.v1.FormCustomAction.toObject(message.action, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateFormCustomActionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateFormCustomActionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateFormCustomActionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateFormCustomActionRequest;
                })();
    
                v1.ListFormCustomActionsRequest = (function() {
    
                    /**
                     * Properties of a ListFormCustomActionsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormCustomActionsRequest
                     * @property {number|null} [formId] ListFormCustomActionsRequest formId
                     * @property {number|null} [pageSize] ListFormCustomActionsRequest pageSize
                     * @property {string|null} [pageToken] ListFormCustomActionsRequest pageToken
                     */
    
                    /**
                     * Constructs a new ListFormCustomActionsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormCustomActionsRequest.
                     * @implements IListFormCustomActionsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest=} [properties] Properties to set
                     */
                    function ListFormCustomActionsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormCustomActionsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @instance
                     */
                    ListFormCustomActionsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormCustomActionsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @instance
                     */
                    ListFormCustomActionsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormCustomActionsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @instance
                     */
                    ListFormCustomActionsRequest.prototype.pageToken = "";
    
                    /**
                     * Creates a new ListFormCustomActionsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormCustomActionsRequest} ListFormCustomActionsRequest instance
                     */
                    ListFormCustomActionsRequest.create = function create(properties) {
                        return new ListFormCustomActionsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormCustomActionsRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormCustomActionsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest} message ListFormCustomActionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomActionsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.pageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormCustomActionsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormCustomActionsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsRequest} message ListFormCustomActionsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomActionsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormCustomActionsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormCustomActionsRequest} ListFormCustomActionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomActionsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormCustomActionsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.pageSize = reader.int32();
                                break;
                            case 3:
                                message.pageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormCustomActionsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormCustomActionsRequest} ListFormCustomActionsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomActionsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormCustomActionsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormCustomActionsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormCustomActionsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormCustomActionsRequest} ListFormCustomActionsRequest
                     */
                    ListFormCustomActionsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormCustomActionsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormCustomActionsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormCustomActionsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormCustomActionsRequest} message ListFormCustomActionsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormCustomActionsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormCustomActionsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormCustomActionsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormCustomActionsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormCustomActionsRequest;
                })();
    
                v1.ListFormCustomActionsResponse = (function() {
    
                    /**
                     * Properties of a ListFormCustomActionsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormCustomActionsResponse
                     * @property {Array.<palexy.task_management.v1.IFormCustomAction>|null} [actions] ListFormCustomActionsResponse actions
                     * @property {number|null} [totalElements] ListFormCustomActionsResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormCustomActionsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormCustomActionsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormCustomActionsResponse.
                     * @implements IListFormCustomActionsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormCustomActionsResponse=} [properties] Properties to set
                     */
                    function ListFormCustomActionsResponse(properties) {
                        this.actions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormCustomActionsResponse actions.
                     * @member {Array.<palexy.task_management.v1.IFormCustomAction>} actions
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @instance
                     */
                    ListFormCustomActionsResponse.prototype.actions = $util.emptyArray;
    
                    /**
                     * ListFormCustomActionsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @instance
                     */
                    ListFormCustomActionsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormCustomActionsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @instance
                     */
                    ListFormCustomActionsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormCustomActionsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormCustomActionsResponse} ListFormCustomActionsResponse instance
                     */
                    ListFormCustomActionsResponse.create = function create(properties) {
                        return new ListFormCustomActionsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormCustomActionsResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormCustomActionsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsResponse} message ListFormCustomActionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomActionsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.actions != null && message.actions.length)
                            for (var i = 0; i < message.actions.length; ++i)
                                $root.palexy.task_management.v1.FormCustomAction.encode(message.actions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormCustomActionsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormCustomActionsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormCustomActionsResponse} message ListFormCustomActionsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormCustomActionsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormCustomActionsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormCustomActionsResponse} ListFormCustomActionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomActionsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormCustomActionsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.actions && message.actions.length))
                                    message.actions = [];
                                message.actions.push($root.palexy.task_management.v1.FormCustomAction.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormCustomActionsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormCustomActionsResponse} ListFormCustomActionsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormCustomActionsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormCustomActionsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormCustomActionsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.actions != null && message.hasOwnProperty("actions")) {
                            if (!Array.isArray(message.actions))
                                return "actions: array expected";
                            for (var i = 0; i < message.actions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormCustomAction.verify(message.actions[i]);
                                if (error)
                                    return "actions." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormCustomActionsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormCustomActionsResponse} ListFormCustomActionsResponse
                     */
                    ListFormCustomActionsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormCustomActionsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormCustomActionsResponse();
                        if (object.actions) {
                            if (!Array.isArray(object.actions))
                                throw TypeError(".palexy.task_management.v1.ListFormCustomActionsResponse.actions: array expected");
                            message.actions = [];
                            for (var i = 0; i < object.actions.length; ++i) {
                                if (typeof object.actions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormCustomActionsResponse.actions: object expected");
                                message.actions[i] = $root.palexy.task_management.v1.FormCustomAction.fromObject(object.actions[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormCustomActionsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormCustomActionsResponse} message ListFormCustomActionsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormCustomActionsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.actions = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.actions && message.actions.length) {
                            object.actions = [];
                            for (var j = 0; j < message.actions.length; ++j)
                                object.actions[j] = $root.palexy.task_management.v1.FormCustomAction.toObject(message.actions[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormCustomActionsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormCustomActionsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormCustomActionsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormCustomActionsResponse;
                })();
    
                v1.DeleteFormCustomActionRequest = (function() {
    
                    /**
                     * Properties of a DeleteFormCustomActionRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteFormCustomActionRequest
                     * @property {number|null} [formId] DeleteFormCustomActionRequest formId
                     * @property {number|null} [actionId] DeleteFormCustomActionRequest actionId
                     */
    
                    /**
                     * Constructs a new DeleteFormCustomActionRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteFormCustomActionRequest.
                     * @implements IDeleteFormCustomActionRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest=} [properties] Properties to set
                     */
                    function DeleteFormCustomActionRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteFormCustomActionRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @instance
                     */
                    DeleteFormCustomActionRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteFormCustomActionRequest actionId.
                     * @member {number} actionId
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @instance
                     */
                    DeleteFormCustomActionRequest.prototype.actionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteFormCustomActionRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteFormCustomActionRequest} DeleteFormCustomActionRequest instance
                     */
                    DeleteFormCustomActionRequest.create = function create(properties) {
                        return new DeleteFormCustomActionRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteFormCustomActionRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteFormCustomActionRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest} message DeleteFormCustomActionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormCustomActionRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.actionId != null && Object.hasOwnProperty.call(message, "actionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.actionId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteFormCustomActionRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteFormCustomActionRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteFormCustomActionRequest} message DeleteFormCustomActionRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteFormCustomActionRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteFormCustomActionRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteFormCustomActionRequest} DeleteFormCustomActionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormCustomActionRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteFormCustomActionRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.actionId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteFormCustomActionRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteFormCustomActionRequest} DeleteFormCustomActionRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteFormCustomActionRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteFormCustomActionRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteFormCustomActionRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.actionId != null && message.hasOwnProperty("actionId"))
                            if (!$util.isInteger(message.actionId) && !(message.actionId && $util.isInteger(message.actionId.low) && $util.isInteger(message.actionId.high)))
                                return "actionId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteFormCustomActionRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteFormCustomActionRequest} DeleteFormCustomActionRequest
                     */
                    DeleteFormCustomActionRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteFormCustomActionRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteFormCustomActionRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.actionId != null)
                            if ($util.Long)
                                (message.actionId = $util.Long.fromValue(object.actionId)).unsigned = false;
                            else if (typeof object.actionId === "string")
                                message.actionId = parseInt(object.actionId, 10);
                            else if (typeof object.actionId === "number")
                                message.actionId = object.actionId;
                            else if (typeof object.actionId === "object")
                                message.actionId = new $util.LongBits(object.actionId.low >>> 0, object.actionId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteFormCustomActionRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteFormCustomActionRequest} message DeleteFormCustomActionRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteFormCustomActionRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.actionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.actionId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.actionId != null && message.hasOwnProperty("actionId"))
                            if (typeof message.actionId === "number")
                                object.actionId = options.longs === String ? String(message.actionId) : message.actionId;
                            else
                                object.actionId = options.longs === String ? $util.Long.prototype.toString.call(message.actionId) : options.longs === Number ? new $util.LongBits(message.actionId.low >>> 0, message.actionId.high >>> 0).toNumber() : message.actionId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteFormCustomActionRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteFormCustomActionRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteFormCustomActionRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteFormCustomActionRequest;
                })();
    
                v1.FormSubmissionAttributeValue = (function() {
    
                    /**
                     * Properties of a FormSubmissionAttributeValue.
                     * @memberof palexy.task_management.v1
                     * @interface IFormSubmissionAttributeValue
                     * @property {number|null} [id] FormSubmissionAttributeValue id
                     * @property {number|null} [submissionId] FormSubmissionAttributeValue submissionId
                     * @property {number|null} [attributeId] FormSubmissionAttributeValue attributeId
                     * @property {string|null} [value] FormSubmissionAttributeValue value
                     * @property {number|null} [createdTimeMs] FormSubmissionAttributeValue createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] FormSubmissionAttributeValue lastUpdateTimeMs
                     * @property {palexy.task_management.v1.IFormSubmission|null} [submission] FormSubmissionAttributeValue submission
                     * @property {palexy.task_management.v1.IFormCustomAttribute|null} [attribute] FormSubmissionAttributeValue attribute
                     * @property {palexy.task_management.v1.IFormSubmissionValue|null} [inputSubmissionValue] FormSubmissionAttributeValue inputSubmissionValue
                     */
    
                    /**
                     * Constructs a new FormSubmissionAttributeValue.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormSubmissionAttributeValue.
                     * @implements IFormSubmissionAttributeValue
                     * @constructor
                     * @param {palexy.task_management.v1.IFormSubmissionAttributeValue=} [properties] Properties to set
                     */
                    function FormSubmissionAttributeValue(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormSubmissionAttributeValue id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionAttributeValue submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionAttributeValue attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionAttributeValue value.
                     * @member {string} value
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.value = "";
    
                    /**
                     * FormSubmissionAttributeValue createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionAttributeValue lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormSubmissionAttributeValue submission.
                     * @member {palexy.task_management.v1.IFormSubmission|null|undefined} submission
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.submission = null;
    
                    /**
                     * FormSubmissionAttributeValue attribute.
                     * @member {palexy.task_management.v1.IFormCustomAttribute|null|undefined} attribute
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.attribute = null;
    
                    /**
                     * FormSubmissionAttributeValue inputSubmissionValue.
                     * @member {palexy.task_management.v1.IFormSubmissionValue|null|undefined} inputSubmissionValue
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     */
                    FormSubmissionAttributeValue.prototype.inputSubmissionValue = null;
    
                    /**
                     * Creates a new FormSubmissionAttributeValue instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionAttributeValue=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormSubmissionAttributeValue} FormSubmissionAttributeValue instance
                     */
                    FormSubmissionAttributeValue.create = function create(properties) {
                        return new FormSubmissionAttributeValue(properties);
                    };
    
                    /**
                     * Encodes the specified FormSubmissionAttributeValue message. Does not implicitly {@link palexy.task_management.v1.FormSubmissionAttributeValue.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionAttributeValue} message FormSubmissionAttributeValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionAttributeValue.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.attributeId);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.value);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        if (message.submission != null && Object.hasOwnProperty.call(message, "submission"))
                            $root.palexy.task_management.v1.FormSubmission.encode(message.submission, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                        if (message.attribute != null && Object.hasOwnProperty.call(message, "attribute"))
                            $root.palexy.task_management.v1.FormCustomAttribute.encode(message.attribute, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.inputSubmissionValue != null && Object.hasOwnProperty.call(message, "inputSubmissionValue"))
                            $root.palexy.task_management.v1.FormSubmissionValue.encode(message.inputSubmissionValue, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormSubmissionAttributeValue message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormSubmissionAttributeValue.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {palexy.task_management.v1.IFormSubmissionAttributeValue} message FormSubmissionAttributeValue message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSubmissionAttributeValue.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormSubmissionAttributeValue message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormSubmissionAttributeValue} FormSubmissionAttributeValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionAttributeValue.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormSubmissionAttributeValue();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.attributeId = reader.int64();
                                break;
                            case 4:
                                message.value = reader.string();
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            case 7:
                                message.submission = $root.palexy.task_management.v1.FormSubmission.decode(reader, reader.uint32());
                                break;
                            case 8:
                                message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.decode(reader, reader.uint32());
                                break;
                            case 9:
                                message.inputSubmissionValue = $root.palexy.task_management.v1.FormSubmissionValue.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormSubmissionAttributeValue message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormSubmissionAttributeValue} FormSubmissionAttributeValue
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSubmissionAttributeValue.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormSubmissionAttributeValue message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormSubmissionAttributeValue.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        if (message.submission != null && message.hasOwnProperty("submission")) {
                            var error = $root.palexy.task_management.v1.FormSubmission.verify(message.submission);
                            if (error)
                                return "submission." + error;
                        }
                        if (message.attribute != null && message.hasOwnProperty("attribute")) {
                            var error = $root.palexy.task_management.v1.FormCustomAttribute.verify(message.attribute);
                            if (error)
                                return "attribute." + error;
                        }
                        if (message.inputSubmissionValue != null && message.hasOwnProperty("inputSubmissionValue")) {
                            var error = $root.palexy.task_management.v1.FormSubmissionValue.verify(message.inputSubmissionValue);
                            if (error)
                                return "inputSubmissionValue." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormSubmissionAttributeValue message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormSubmissionAttributeValue} FormSubmissionAttributeValue
                     */
                    FormSubmissionAttributeValue.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormSubmissionAttributeValue)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormSubmissionAttributeValue();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.value != null)
                            message.value = String(object.value);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        if (object.submission != null) {
                            if (typeof object.submission !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionAttributeValue.submission: object expected");
                            message.submission = $root.palexy.task_management.v1.FormSubmission.fromObject(object.submission);
                        }
                        if (object.attribute != null) {
                            if (typeof object.attribute !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionAttributeValue.attribute: object expected");
                            message.attribute = $root.palexy.task_management.v1.FormCustomAttribute.fromObject(object.attribute);
                        }
                        if (object.inputSubmissionValue != null) {
                            if (typeof object.inputSubmissionValue !== "object")
                                throw TypeError(".palexy.task_management.v1.FormSubmissionAttributeValue.inputSubmissionValue: object expected");
                            message.inputSubmissionValue = $root.palexy.task_management.v1.FormSubmissionValue.fromObject(object.inputSubmissionValue);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormSubmissionAttributeValue message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @static
                     * @param {palexy.task_management.v1.FormSubmissionAttributeValue} message FormSubmissionAttributeValue
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormSubmissionAttributeValue.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.value = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                            object.submission = null;
                            object.attribute = null;
                            object.inputSubmissionValue = null;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        if (message.submission != null && message.hasOwnProperty("submission"))
                            object.submission = $root.palexy.task_management.v1.FormSubmission.toObject(message.submission, options);
                        if (message.attribute != null && message.hasOwnProperty("attribute"))
                            object.attribute = $root.palexy.task_management.v1.FormCustomAttribute.toObject(message.attribute, options);
                        if (message.inputSubmissionValue != null && message.hasOwnProperty("inputSubmissionValue"))
                            object.inputSubmissionValue = $root.palexy.task_management.v1.FormSubmissionValue.toObject(message.inputSubmissionValue, options);
                        return object;
                    };
    
                    /**
                     * Converts this FormSubmissionAttributeValue to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormSubmissionAttributeValue
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormSubmissionAttributeValue.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormSubmissionAttributeValue;
                })();
    
                /**
                 * FormPassFailOutcome enum.
                 * @name palexy.task_management.v1.FormPassFailOutcome
                 * @enum {number}
                 * @property {number} FORM_PASS_FAIL_OUTCOME_UNSPECIFIED=0 FORM_PASS_FAIL_OUTCOME_UNSPECIFIED value
                 * @property {number} PASS=1 PASS value
                 * @property {number} FAIL=2 FAIL value
                 */
                v1.FormPassFailOutcome = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FORM_PASS_FAIL_OUTCOME_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "PASS"] = 1;
                    values[valuesById[2] = "FAIL"] = 2;
                    return values;
                })();
    
                v1.ListFormSubmissionCustomAttributeValuesRequest = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionCustomAttributeValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionCustomAttributeValuesRequest
                     * @property {number|null} [formId] ListFormSubmissionCustomAttributeValuesRequest formId
                     * @property {number|null} [submissionId] ListFormSubmissionCustomAttributeValuesRequest submissionId
                     * @property {number|null} [pageSize] ListFormSubmissionCustomAttributeValuesRequest pageSize
                     * @property {string|null} [pageToken] ListFormSubmissionCustomAttributeValuesRequest pageToken
                     * @property {boolean|null} [includeSubmission] ListFormSubmissionCustomAttributeValuesRequest includeSubmission
                     * @property {string|null} [valueFilter] ListFormSubmissionCustomAttributeValuesRequest valueFilter
                     * @property {Array.<number>|null} [attributeIds] ListFormSubmissionCustomAttributeValuesRequest attributeIds
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionCustomAttributeValuesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionCustomAttributeValuesRequest.
                     * @implements IListFormSubmissionCustomAttributeValuesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest=} [properties] Properties to set
                     */
                    function ListFormSubmissionCustomAttributeValuesRequest(properties) {
                        this.attributeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.pageSize = 0;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.pageToken = "";
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest includeSubmission.
                     * @member {boolean} includeSubmission
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.includeSubmission = false;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest valueFilter.
                     * @member {string} valueFilter
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.valueFilter = "";
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesRequest attributeIds.
                     * @member {Array.<number>} attributeIds
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.attributeIds = $util.emptyArray;
    
                    /**
                     * Creates a new ListFormSubmissionCustomAttributeValuesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest} ListFormSubmissionCustomAttributeValuesRequest instance
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.create = function create(properties) {
                        return new ListFormSubmissionCustomAttributeValuesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionCustomAttributeValuesRequest message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest} message ListFormSubmissionCustomAttributeValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.includeSubmission != null && Object.hasOwnProperty.call(message, "includeSubmission"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeSubmission);
                        if (message.valueFilter != null && Object.hasOwnProperty.call(message, "valueFilter"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.valueFilter);
                        if (message.attributeIds != null && message.attributeIds.length) {
                            writer.uint32(/* id 7, wireType 2 =*/58).fork();
                            for (var i = 0; i < message.attributeIds.length; ++i)
                                writer.int64(message.attributeIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionCustomAttributeValuesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesRequest} message ListFormSubmissionCustomAttributeValuesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionCustomAttributeValuesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest} ListFormSubmissionCustomAttributeValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 5:
                                message.includeSubmission = reader.bool();
                                break;
                            case 6:
                                message.valueFilter = reader.string();
                                break;
                            case 7:
                                if (!(message.attributeIds && message.attributeIds.length))
                                    message.attributeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.attributeIds.push(reader.int64());
                                } else
                                    message.attributeIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionCustomAttributeValuesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest} ListFormSubmissionCustomAttributeValuesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionCustomAttributeValuesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.includeSubmission != null && message.hasOwnProperty("includeSubmission"))
                            if (typeof message.includeSubmission !== "boolean")
                                return "includeSubmission: boolean expected";
                        if (message.valueFilter != null && message.hasOwnProperty("valueFilter"))
                            if (!$util.isString(message.valueFilter))
                                return "valueFilter: string expected";
                        if (message.attributeIds != null && message.hasOwnProperty("attributeIds")) {
                            if (!Array.isArray(message.attributeIds))
                                return "attributeIds: array expected";
                            for (var i = 0; i < message.attributeIds.length; ++i)
                                if (!$util.isInteger(message.attributeIds[i]) && !(message.attributeIds[i] && $util.isInteger(message.attributeIds[i].low) && $util.isInteger(message.attributeIds[i].high)))
                                    return "attributeIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionCustomAttributeValuesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest} ListFormSubmissionCustomAttributeValuesRequest
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.includeSubmission != null)
                            message.includeSubmission = Boolean(object.includeSubmission);
                        if (object.valueFilter != null)
                            message.valueFilter = String(object.valueFilter);
                        if (object.attributeIds) {
                            if (!Array.isArray(object.attributeIds))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest.attributeIds: array expected");
                            message.attributeIds = [];
                            for (var i = 0; i < object.attributeIds.length; ++i)
                                if ($util.Long)
                                    (message.attributeIds[i] = $util.Long.fromValue(object.attributeIds[i])).unsigned = false;
                                else if (typeof object.attributeIds[i] === "string")
                                    message.attributeIds[i] = parseInt(object.attributeIds[i], 10);
                                else if (typeof object.attributeIds[i] === "number")
                                    message.attributeIds[i] = object.attributeIds[i];
                                else if (typeof object.attributeIds[i] === "object")
                                    message.attributeIds[i] = new $util.LongBits(object.attributeIds[i].low >>> 0, object.attributeIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionCustomAttributeValuesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest} message ListFormSubmissionCustomAttributeValuesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.attributeIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeSubmission = false;
                            object.valueFilter = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.includeSubmission != null && message.hasOwnProperty("includeSubmission"))
                            object.includeSubmission = message.includeSubmission;
                        if (message.valueFilter != null && message.hasOwnProperty("valueFilter"))
                            object.valueFilter = message.valueFilter;
                        if (message.attributeIds && message.attributeIds.length) {
                            object.attributeIds = [];
                            for (var j = 0; j < message.attributeIds.length; ++j)
                                if (typeof message.attributeIds[j] === "number")
                                    object.attributeIds[j] = options.longs === String ? String(message.attributeIds[j]) : message.attributeIds[j];
                                else
                                    object.attributeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.attributeIds[j]) : options.longs === Number ? new $util.LongBits(message.attributeIds[j].low >>> 0, message.attributeIds[j].high >>> 0).toNumber() : message.attributeIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionCustomAttributeValuesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionCustomAttributeValuesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionCustomAttributeValuesRequest;
                })();
    
                v1.ListFormSubmissionCustomAttributeValuesResponse = (function() {
    
                    /**
                     * Properties of a ListFormSubmissionCustomAttributeValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListFormSubmissionCustomAttributeValuesResponse
                     * @property {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>|null} [attributeValues] ListFormSubmissionCustomAttributeValuesResponse attributeValues
                     * @property {number|null} [totalElements] ListFormSubmissionCustomAttributeValuesResponse totalElements
                     * @property {string|null} [nextPageToken] ListFormSubmissionCustomAttributeValuesResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListFormSubmissionCustomAttributeValuesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListFormSubmissionCustomAttributeValuesResponse.
                     * @implements IListFormSubmissionCustomAttributeValuesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesResponse=} [properties] Properties to set
                     */
                    function ListFormSubmissionCustomAttributeValuesResponse(properties) {
                        this.attributeValues = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesResponse attributeValues.
                     * @member {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>} attributeValues
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.prototype.attributeValues = $util.emptyArray;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.prototype.totalElements = 0;
    
                    /**
                     * ListFormSubmissionCustomAttributeValuesResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @instance
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListFormSubmissionCustomAttributeValuesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} ListFormSubmissionCustomAttributeValuesResponse instance
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.create = function create(properties) {
                        return new ListFormSubmissionCustomAttributeValuesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionCustomAttributeValuesResponse message. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesResponse} message ListFormSubmissionCustomAttributeValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributeValues != null && message.attributeValues.length)
                            for (var i = 0; i < message.attributeValues.length; ++i)
                                $root.palexy.task_management.v1.FormSubmissionAttributeValue.encode(message.attributeValues[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListFormSubmissionCustomAttributeValuesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListFormSubmissionCustomAttributeValuesResponse} message ListFormSubmissionCustomAttributeValuesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListFormSubmissionCustomAttributeValuesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} ListFormSubmissionCustomAttributeValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.attributeValues && message.attributeValues.length))
                                    message.attributeValues = [];
                                message.attributeValues.push($root.palexy.task_management.v1.FormSubmissionAttributeValue.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListFormSubmissionCustomAttributeValuesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} ListFormSubmissionCustomAttributeValuesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListFormSubmissionCustomAttributeValuesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributeValues != null && message.hasOwnProperty("attributeValues")) {
                            if (!Array.isArray(message.attributeValues))
                                return "attributeValues: array expected";
                            for (var i = 0; i < message.attributeValues.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmissionAttributeValue.verify(message.attributeValues[i]);
                                if (error)
                                    return "attributeValues." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListFormSubmissionCustomAttributeValuesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} ListFormSubmissionCustomAttributeValuesResponse
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse();
                        if (object.attributeValues) {
                            if (!Array.isArray(object.attributeValues))
                                throw TypeError(".palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse.attributeValues: array expected");
                            message.attributeValues = [];
                            for (var i = 0; i < object.attributeValues.length; ++i) {
                                if (typeof object.attributeValues[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse.attributeValues: object expected");
                                message.attributeValues[i] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.fromObject(object.attributeValues[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListFormSubmissionCustomAttributeValuesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse} message ListFormSubmissionCustomAttributeValuesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.attributeValues = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.attributeValues && message.attributeValues.length) {
                            object.attributeValues = [];
                            for (var j = 0; j < message.attributeValues.length; ++j)
                                object.attributeValues[j] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.toObject(message.attributeValues[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListFormSubmissionCustomAttributeValuesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListFormSubmissionCustomAttributeValuesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListFormSubmissionCustomAttributeValuesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListFormSubmissionCustomAttributeValuesResponse;
                })();
    
                v1.GetFormPassFailSummaryRequest = (function() {
    
                    /**
                     * Properties of a GetFormPassFailSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormPassFailSummaryRequest
                     * @property {number|null} [formId] GetFormPassFailSummaryRequest formId
                     * @property {string|null} [startDateId] GetFormPassFailSummaryRequest startDateId
                     * @property {string|null} [endDateId] GetFormPassFailSummaryRequest endDateId
                     */
    
                    /**
                     * Constructs a new GetFormPassFailSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormPassFailSummaryRequest.
                     * @implements IGetFormPassFailSummaryRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest=} [properties] Properties to set
                     */
                    function GetFormPassFailSummaryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormPassFailSummaryRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @instance
                     */
                    GetFormPassFailSummaryRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormPassFailSummaryRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @instance
                     */
                    GetFormPassFailSummaryRequest.prototype.startDateId = "";
    
                    /**
                     * GetFormPassFailSummaryRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @instance
                     */
                    GetFormPassFailSummaryRequest.prototype.endDateId = "";
    
                    /**
                     * Creates a new GetFormPassFailSummaryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormPassFailSummaryRequest} GetFormPassFailSummaryRequest instance
                     */
                    GetFormPassFailSummaryRequest.create = function create(properties) {
                        return new GetFormPassFailSummaryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormPassFailSummaryRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormPassFailSummaryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest} message GetFormPassFailSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormPassFailSummaryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormPassFailSummaryRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormPassFailSummaryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormPassFailSummaryRequest} message GetFormPassFailSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormPassFailSummaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormPassFailSummaryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormPassFailSummaryRequest} GetFormPassFailSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormPassFailSummaryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormPassFailSummaryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.string();
                                break;
                            case 3:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormPassFailSummaryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormPassFailSummaryRequest} GetFormPassFailSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormPassFailSummaryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormPassFailSummaryRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormPassFailSummaryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormPassFailSummaryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormPassFailSummaryRequest} GetFormPassFailSummaryRequest
                     */
                    GetFormPassFailSummaryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormPassFailSummaryRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormPassFailSummaryRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormPassFailSummaryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormPassFailSummaryRequest} message GetFormPassFailSummaryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormPassFailSummaryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormPassFailSummaryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormPassFailSummaryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormPassFailSummaryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormPassFailSummaryRequest;
                })();
    
                v1.FormPassFailSummary = (function() {
    
                    /**
                     * Properties of a FormPassFailSummary.
                     * @memberof palexy.task_management.v1
                     * @interface IFormPassFailSummary
                     * @property {Array.<palexy.task_management.v1.IFormAttributePassRate>|null} [attributePassRates] FormPassFailSummary attributePassRates
                     * @property {number|null} [totalSubmissions] FormPassFailSummary totalSubmissions
                     */
    
                    /**
                     * Constructs a new FormPassFailSummary.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormPassFailSummary.
                     * @implements IFormPassFailSummary
                     * @constructor
                     * @param {palexy.task_management.v1.IFormPassFailSummary=} [properties] Properties to set
                     */
                    function FormPassFailSummary(properties) {
                        this.attributePassRates = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormPassFailSummary attributePassRates.
                     * @member {Array.<palexy.task_management.v1.IFormAttributePassRate>} attributePassRates
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @instance
                     */
                    FormPassFailSummary.prototype.attributePassRates = $util.emptyArray;
    
                    /**
                     * FormPassFailSummary totalSubmissions.
                     * @member {number} totalSubmissions
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @instance
                     */
                    FormPassFailSummary.prototype.totalSubmissions = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new FormPassFailSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormPassFailSummary=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormPassFailSummary} FormPassFailSummary instance
                     */
                    FormPassFailSummary.create = function create(properties) {
                        return new FormPassFailSummary(properties);
                    };
    
                    /**
                     * Encodes the specified FormPassFailSummary message. Does not implicitly {@link palexy.task_management.v1.FormPassFailSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormPassFailSummary} message FormPassFailSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormPassFailSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributePassRates != null && message.attributePassRates.length)
                            for (var i = 0; i < message.attributePassRates.length; ++i)
                                $root.palexy.task_management.v1.FormAttributePassRate.encode(message.attributePassRates[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalSubmissions != null && Object.hasOwnProperty.call(message, "totalSubmissions"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.totalSubmissions);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormPassFailSummary message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormPassFailSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormPassFailSummary} message FormPassFailSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormPassFailSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormPassFailSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormPassFailSummary} FormPassFailSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormPassFailSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormPassFailSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.attributePassRates && message.attributePassRates.length))
                                    message.attributePassRates = [];
                                message.attributePassRates.push($root.palexy.task_management.v1.FormAttributePassRate.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalSubmissions = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormPassFailSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormPassFailSummary} FormPassFailSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormPassFailSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormPassFailSummary message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormPassFailSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributePassRates != null && message.hasOwnProperty("attributePassRates")) {
                            if (!Array.isArray(message.attributePassRates))
                                return "attributePassRates: array expected";
                            for (var i = 0; i < message.attributePassRates.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormAttributePassRate.verify(message.attributePassRates[i]);
                                if (error)
                                    return "attributePassRates." + error;
                            }
                        }
                        if (message.totalSubmissions != null && message.hasOwnProperty("totalSubmissions"))
                            if (!$util.isInteger(message.totalSubmissions) && !(message.totalSubmissions && $util.isInteger(message.totalSubmissions.low) && $util.isInteger(message.totalSubmissions.high)))
                                return "totalSubmissions: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a FormPassFailSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormPassFailSummary} FormPassFailSummary
                     */
                    FormPassFailSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormPassFailSummary)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormPassFailSummary();
                        if (object.attributePassRates) {
                            if (!Array.isArray(object.attributePassRates))
                                throw TypeError(".palexy.task_management.v1.FormPassFailSummary.attributePassRates: array expected");
                            message.attributePassRates = [];
                            for (var i = 0; i < object.attributePassRates.length; ++i) {
                                if (typeof object.attributePassRates[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormPassFailSummary.attributePassRates: object expected");
                                message.attributePassRates[i] = $root.palexy.task_management.v1.FormAttributePassRate.fromObject(object.attributePassRates[i]);
                            }
                        }
                        if (object.totalSubmissions != null)
                            if ($util.Long)
                                (message.totalSubmissions = $util.Long.fromValue(object.totalSubmissions)).unsigned = false;
                            else if (typeof object.totalSubmissions === "string")
                                message.totalSubmissions = parseInt(object.totalSubmissions, 10);
                            else if (typeof object.totalSubmissions === "number")
                                message.totalSubmissions = object.totalSubmissions;
                            else if (typeof object.totalSubmissions === "object")
                                message.totalSubmissions = new $util.LongBits(object.totalSubmissions.low >>> 0, object.totalSubmissions.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormPassFailSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @static
                     * @param {palexy.task_management.v1.FormPassFailSummary} message FormPassFailSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormPassFailSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.attributePassRates = [];
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalSubmissions = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalSubmissions = options.longs === String ? "0" : 0;
                        if (message.attributePassRates && message.attributePassRates.length) {
                            object.attributePassRates = [];
                            for (var j = 0; j < message.attributePassRates.length; ++j)
                                object.attributePassRates[j] = $root.palexy.task_management.v1.FormAttributePassRate.toObject(message.attributePassRates[j], options);
                        }
                        if (message.totalSubmissions != null && message.hasOwnProperty("totalSubmissions"))
                            if (typeof message.totalSubmissions === "number")
                                object.totalSubmissions = options.longs === String ? String(message.totalSubmissions) : message.totalSubmissions;
                            else
                                object.totalSubmissions = options.longs === String ? $util.Long.prototype.toString.call(message.totalSubmissions) : options.longs === Number ? new $util.LongBits(message.totalSubmissions.low >>> 0, message.totalSubmissions.high >>> 0).toNumber() : message.totalSubmissions;
                        return object;
                    };
    
                    /**
                     * Converts this FormPassFailSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormPassFailSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormPassFailSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormPassFailSummary;
                })();
    
                v1.FormAttributePassRate = (function() {
    
                    /**
                     * Properties of a FormAttributePassRate.
                     * @memberof palexy.task_management.v1
                     * @interface IFormAttributePassRate
                     * @property {number|null} [attributeId] FormAttributePassRate attributeId
                     * @property {string|null} [attributeName] FormAttributePassRate attributeName
                     * @property {number|null} [passCount] FormAttributePassRate passCount
                     * @property {number|null} [totalCount] FormAttributePassRate totalCount
                     * @property {palexy.task_management.v1.IFormCustomAction|null} [relatedAction] FormAttributePassRate relatedAction
                     */
    
                    /**
                     * Constructs a new FormAttributePassRate.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormAttributePassRate.
                     * @implements IFormAttributePassRate
                     * @constructor
                     * @param {palexy.task_management.v1.IFormAttributePassRate=} [properties] Properties to set
                     */
                    function FormAttributePassRate(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormAttributePassRate attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     */
                    FormAttributePassRate.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormAttributePassRate attributeName.
                     * @member {string} attributeName
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     */
                    FormAttributePassRate.prototype.attributeName = "";
    
                    /**
                     * FormAttributePassRate passCount.
                     * @member {number} passCount
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     */
                    FormAttributePassRate.prototype.passCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormAttributePassRate totalCount.
                     * @member {number} totalCount
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     */
                    FormAttributePassRate.prototype.totalCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * FormAttributePassRate relatedAction.
                     * @member {palexy.task_management.v1.IFormCustomAction|null|undefined} relatedAction
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     */
                    FormAttributePassRate.prototype.relatedAction = null;
    
                    /**
                     * Creates a new FormAttributePassRate instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {palexy.task_management.v1.IFormAttributePassRate=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormAttributePassRate} FormAttributePassRate instance
                     */
                    FormAttributePassRate.create = function create(properties) {
                        return new FormAttributePassRate(properties);
                    };
    
                    /**
                     * Encodes the specified FormAttributePassRate message. Does not implicitly {@link palexy.task_management.v1.FormAttributePassRate.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {palexy.task_management.v1.IFormAttributePassRate} message FormAttributePassRate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormAttributePassRate.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.attributeId);
                        if (message.attributeName != null && Object.hasOwnProperty.call(message, "attributeName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.attributeName);
                        if (message.passCount != null && Object.hasOwnProperty.call(message, "passCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.passCount);
                        if (message.totalCount != null && Object.hasOwnProperty.call(message, "totalCount"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.totalCount);
                        if (message.relatedAction != null && Object.hasOwnProperty.call(message, "relatedAction"))
                            $root.palexy.task_management.v1.FormCustomAction.encode(message.relatedAction, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormAttributePassRate message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormAttributePassRate.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {palexy.task_management.v1.IFormAttributePassRate} message FormAttributePassRate message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormAttributePassRate.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormAttributePassRate message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormAttributePassRate} FormAttributePassRate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormAttributePassRate.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormAttributePassRate();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.attributeId = reader.int64();
                                break;
                            case 2:
                                message.attributeName = reader.string();
                                break;
                            case 3:
                                message.passCount = reader.int64();
                                break;
                            case 4:
                                message.totalCount = reader.int64();
                                break;
                            case 5:
                                message.relatedAction = $root.palexy.task_management.v1.FormCustomAction.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormAttributePassRate message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormAttributePassRate} FormAttributePassRate
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormAttributePassRate.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormAttributePassRate message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormAttributePassRate.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.attributeName != null && message.hasOwnProperty("attributeName"))
                            if (!$util.isString(message.attributeName))
                                return "attributeName: string expected";
                        if (message.passCount != null && message.hasOwnProperty("passCount"))
                            if (!$util.isInteger(message.passCount) && !(message.passCount && $util.isInteger(message.passCount.low) && $util.isInteger(message.passCount.high)))
                                return "passCount: integer|Long expected";
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            if (!$util.isInteger(message.totalCount) && !(message.totalCount && $util.isInteger(message.totalCount.low) && $util.isInteger(message.totalCount.high)))
                                return "totalCount: integer|Long expected";
                        if (message.relatedAction != null && message.hasOwnProperty("relatedAction")) {
                            var error = $root.palexy.task_management.v1.FormCustomAction.verify(message.relatedAction);
                            if (error)
                                return "relatedAction." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormAttributePassRate message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormAttributePassRate} FormAttributePassRate
                     */
                    FormAttributePassRate.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormAttributePassRate)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormAttributePassRate();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.attributeName != null)
                            message.attributeName = String(object.attributeName);
                        if (object.passCount != null)
                            if ($util.Long)
                                (message.passCount = $util.Long.fromValue(object.passCount)).unsigned = false;
                            else if (typeof object.passCount === "string")
                                message.passCount = parseInt(object.passCount, 10);
                            else if (typeof object.passCount === "number")
                                message.passCount = object.passCount;
                            else if (typeof object.passCount === "object")
                                message.passCount = new $util.LongBits(object.passCount.low >>> 0, object.passCount.high >>> 0).toNumber();
                        if (object.totalCount != null)
                            if ($util.Long)
                                (message.totalCount = $util.Long.fromValue(object.totalCount)).unsigned = false;
                            else if (typeof object.totalCount === "string")
                                message.totalCount = parseInt(object.totalCount, 10);
                            else if (typeof object.totalCount === "number")
                                message.totalCount = object.totalCount;
                            else if (typeof object.totalCount === "object")
                                message.totalCount = new $util.LongBits(object.totalCount.low >>> 0, object.totalCount.high >>> 0).toNumber();
                        if (object.relatedAction != null) {
                            if (typeof object.relatedAction !== "object")
                                throw TypeError(".palexy.task_management.v1.FormAttributePassRate.relatedAction: object expected");
                            message.relatedAction = $root.palexy.task_management.v1.FormCustomAction.fromObject(object.relatedAction);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormAttributePassRate message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @static
                     * @param {palexy.task_management.v1.FormAttributePassRate} message FormAttributePassRate
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormAttributePassRate.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.attributeName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.passCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.passCount = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.totalCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.totalCount = options.longs === String ? "0" : 0;
                            object.relatedAction = null;
                        }
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.attributeName != null && message.hasOwnProperty("attributeName"))
                            object.attributeName = message.attributeName;
                        if (message.passCount != null && message.hasOwnProperty("passCount"))
                            if (typeof message.passCount === "number")
                                object.passCount = options.longs === String ? String(message.passCount) : message.passCount;
                            else
                                object.passCount = options.longs === String ? $util.Long.prototype.toString.call(message.passCount) : options.longs === Number ? new $util.LongBits(message.passCount.low >>> 0, message.passCount.high >>> 0).toNumber() : message.passCount;
                        if (message.totalCount != null && message.hasOwnProperty("totalCount"))
                            if (typeof message.totalCount === "number")
                                object.totalCount = options.longs === String ? String(message.totalCount) : message.totalCount;
                            else
                                object.totalCount = options.longs === String ? $util.Long.prototype.toString.call(message.totalCount) : options.longs === Number ? new $util.LongBits(message.totalCount.low >>> 0, message.totalCount.high >>> 0).toNumber() : message.totalCount;
                        if (message.relatedAction != null && message.hasOwnProperty("relatedAction"))
                            object.relatedAction = $root.palexy.task_management.v1.FormCustomAction.toObject(message.relatedAction, options);
                        return object;
                    };
    
                    /**
                     * Converts this FormAttributePassRate to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormAttributePassRate
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormAttributePassRate.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormAttributePassRate;
                })();
    
                v1.GetFormSentimentSummaryRequest = (function() {
    
                    /**
                     * Properties of a GetFormSentimentSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetFormSentimentSummaryRequest
                     * @property {number|null} [formId] GetFormSentimentSummaryRequest formId
                     * @property {string|null} [internalQuestionId] GetFormSentimentSummaryRequest internalQuestionId
                     * @property {string|null} [startDateId] GetFormSentimentSummaryRequest startDateId
                     * @property {string|null} [endDateId] GetFormSentimentSummaryRequest endDateId
                     */
    
                    /**
                     * Constructs a new GetFormSentimentSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetFormSentimentSummaryRequest.
                     * @implements IGetFormSentimentSummaryRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest=} [properties] Properties to set
                     */
                    function GetFormSentimentSummaryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetFormSentimentSummaryRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @instance
                     */
                    GetFormSentimentSummaryRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetFormSentimentSummaryRequest internalQuestionId.
                     * @member {string} internalQuestionId
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @instance
                     */
                    GetFormSentimentSummaryRequest.prototype.internalQuestionId = "";
    
                    /**
                     * GetFormSentimentSummaryRequest startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @instance
                     */
                    GetFormSentimentSummaryRequest.prototype.startDateId = "";
    
                    /**
                     * GetFormSentimentSummaryRequest endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @instance
                     */
                    GetFormSentimentSummaryRequest.prototype.endDateId = "";
    
                    /**
                     * Creates a new GetFormSentimentSummaryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetFormSentimentSummaryRequest} GetFormSentimentSummaryRequest instance
                     */
                    GetFormSentimentSummaryRequest.create = function create(properties) {
                        return new GetFormSentimentSummaryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetFormSentimentSummaryRequest message. Does not implicitly {@link palexy.task_management.v1.GetFormSentimentSummaryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest} message GetFormSentimentSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormSentimentSummaryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.internalQuestionId != null && Object.hasOwnProperty.call(message, "internalQuestionId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.internalQuestionId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetFormSentimentSummaryRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetFormSentimentSummaryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetFormSentimentSummaryRequest} message GetFormSentimentSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetFormSentimentSummaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetFormSentimentSummaryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetFormSentimentSummaryRequest} GetFormSentimentSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormSentimentSummaryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetFormSentimentSummaryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.internalQuestionId = reader.string();
                                break;
                            case 3:
                                message.startDateId = reader.string();
                                break;
                            case 4:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetFormSentimentSummaryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetFormSentimentSummaryRequest} GetFormSentimentSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetFormSentimentSummaryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetFormSentimentSummaryRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetFormSentimentSummaryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            if (!$util.isString(message.internalQuestionId))
                                return "internalQuestionId: string expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetFormSentimentSummaryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetFormSentimentSummaryRequest} GetFormSentimentSummaryRequest
                     */
                    GetFormSentimentSummaryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetFormSentimentSummaryRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetFormSentimentSummaryRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.internalQuestionId != null)
                            message.internalQuestionId = String(object.internalQuestionId);
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetFormSentimentSummaryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.GetFormSentimentSummaryRequest} message GetFormSentimentSummaryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetFormSentimentSummaryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.internalQuestionId = "";
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.internalQuestionId != null && message.hasOwnProperty("internalQuestionId"))
                            object.internalQuestionId = message.internalQuestionId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this GetFormSentimentSummaryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetFormSentimentSummaryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetFormSentimentSummaryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetFormSentimentSummaryRequest;
                })();
    
                v1.FormSentimentSummary = (function() {
    
                    /**
                     * Properties of a FormSentimentSummary.
                     * @memberof palexy.task_management.v1
                     * @interface IFormSentimentSummary
                     * @property {Array.<palexy.task_management.v1.ITopicSentimentStat>|null} [topicStats] FormSentimentSummary topicStats
                     */
    
                    /**
                     * Constructs a new FormSentimentSummary.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FormSentimentSummary.
                     * @implements IFormSentimentSummary
                     * @constructor
                     * @param {palexy.task_management.v1.IFormSentimentSummary=} [properties] Properties to set
                     */
                    function FormSentimentSummary(properties) {
                        this.topicStats = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FormSentimentSummary topicStats.
                     * @member {Array.<palexy.task_management.v1.ITopicSentimentStat>} topicStats
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @instance
                     */
                    FormSentimentSummary.prototype.topicStats = $util.emptyArray;
    
                    /**
                     * Creates a new FormSentimentSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormSentimentSummary=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FormSentimentSummary} FormSentimentSummary instance
                     */
                    FormSentimentSummary.create = function create(properties) {
                        return new FormSentimentSummary(properties);
                    };
    
                    /**
                     * Encodes the specified FormSentimentSummary message. Does not implicitly {@link palexy.task_management.v1.FormSentimentSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormSentimentSummary} message FormSentimentSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSentimentSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.topicStats != null && message.topicStats.length)
                            for (var i = 0; i < message.topicStats.length; ++i)
                                $root.palexy.task_management.v1.TopicSentimentStat.encode(message.topicStats[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FormSentimentSummary message, length delimited. Does not implicitly {@link palexy.task_management.v1.FormSentimentSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {palexy.task_management.v1.IFormSentimentSummary} message FormSentimentSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FormSentimentSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FormSentimentSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FormSentimentSummary} FormSentimentSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSentimentSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FormSentimentSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.topicStats && message.topicStats.length))
                                    message.topicStats = [];
                                message.topicStats.push($root.palexy.task_management.v1.TopicSentimentStat.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FormSentimentSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FormSentimentSummary} FormSentimentSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FormSentimentSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FormSentimentSummary message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FormSentimentSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.topicStats != null && message.hasOwnProperty("topicStats")) {
                            if (!Array.isArray(message.topicStats))
                                return "topicStats: array expected";
                            for (var i = 0; i < message.topicStats.length; ++i) {
                                var error = $root.palexy.task_management.v1.TopicSentimentStat.verify(message.topicStats[i]);
                                if (error)
                                    return "topicStats." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FormSentimentSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FormSentimentSummary} FormSentimentSummary
                     */
                    FormSentimentSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FormSentimentSummary)
                            return object;
                        var message = new $root.palexy.task_management.v1.FormSentimentSummary();
                        if (object.topicStats) {
                            if (!Array.isArray(object.topicStats))
                                throw TypeError(".palexy.task_management.v1.FormSentimentSummary.topicStats: array expected");
                            message.topicStats = [];
                            for (var i = 0; i < object.topicStats.length; ++i) {
                                if (typeof object.topicStats[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.FormSentimentSummary.topicStats: object expected");
                                message.topicStats[i] = $root.palexy.task_management.v1.TopicSentimentStat.fromObject(object.topicStats[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FormSentimentSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @static
                     * @param {palexy.task_management.v1.FormSentimentSummary} message FormSentimentSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FormSentimentSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.topicStats = [];
                        if (message.topicStats && message.topicStats.length) {
                            object.topicStats = [];
                            for (var j = 0; j < message.topicStats.length; ++j)
                                object.topicStats[j] = $root.palexy.task_management.v1.TopicSentimentStat.toObject(message.topicStats[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FormSentimentSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FormSentimentSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FormSentimentSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FormSentimentSummary;
                })();
    
                v1.TopicSentimentStat = (function() {
    
                    /**
                     * Properties of a TopicSentimentStat.
                     * @memberof palexy.task_management.v1
                     * @interface ITopicSentimentStat
                     * @property {string|null} [topicId] TopicSentimentStat topicId
                     * @property {string|null} [topicName] TopicSentimentStat topicName
                     * @property {number|null} [submissionCount] TopicSentimentStat submissionCount
                     * @property {number|null} [averageTopicScore] TopicSentimentStat averageTopicScore
                     */
    
                    /**
                     * Constructs a new TopicSentimentStat.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TopicSentimentStat.
                     * @implements ITopicSentimentStat
                     * @constructor
                     * @param {palexy.task_management.v1.ITopicSentimentStat=} [properties] Properties to set
                     */
                    function TopicSentimentStat(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TopicSentimentStat topicId.
                     * @member {string} topicId
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @instance
                     */
                    TopicSentimentStat.prototype.topicId = "";
    
                    /**
                     * TopicSentimentStat topicName.
                     * @member {string} topicName
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @instance
                     */
                    TopicSentimentStat.prototype.topicName = "";
    
                    /**
                     * TopicSentimentStat submissionCount.
                     * @member {number} submissionCount
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @instance
                     */
                    TopicSentimentStat.prototype.submissionCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * TopicSentimentStat averageTopicScore.
                     * @member {number} averageTopicScore
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @instance
                     */
                    TopicSentimentStat.prototype.averageTopicScore = 0;
    
                    /**
                     * Creates a new TopicSentimentStat instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {palexy.task_management.v1.ITopicSentimentStat=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TopicSentimentStat} TopicSentimentStat instance
                     */
                    TopicSentimentStat.create = function create(properties) {
                        return new TopicSentimentStat(properties);
                    };
    
                    /**
                     * Encodes the specified TopicSentimentStat message. Does not implicitly {@link palexy.task_management.v1.TopicSentimentStat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {palexy.task_management.v1.ITopicSentimentStat} message TopicSentimentStat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TopicSentimentStat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.topicId != null && Object.hasOwnProperty.call(message, "topicId"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.topicId);
                        if (message.topicName != null && Object.hasOwnProperty.call(message, "topicName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.topicName);
                        if (message.submissionCount != null && Object.hasOwnProperty.call(message, "submissionCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.submissionCount);
                        if (message.averageTopicScore != null && Object.hasOwnProperty.call(message, "averageTopicScore"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.averageTopicScore);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TopicSentimentStat message, length delimited. Does not implicitly {@link palexy.task_management.v1.TopicSentimentStat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {palexy.task_management.v1.ITopicSentimentStat} message TopicSentimentStat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TopicSentimentStat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TopicSentimentStat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TopicSentimentStat} TopicSentimentStat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TopicSentimentStat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TopicSentimentStat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.topicId = reader.string();
                                break;
                            case 2:
                                message.topicName = reader.string();
                                break;
                            case 3:
                                message.submissionCount = reader.int64();
                                break;
                            case 4:
                                message.averageTopicScore = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TopicSentimentStat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TopicSentimentStat} TopicSentimentStat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TopicSentimentStat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TopicSentimentStat message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TopicSentimentStat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.topicId != null && message.hasOwnProperty("topicId"))
                            if (!$util.isString(message.topicId))
                                return "topicId: string expected";
                        if (message.topicName != null && message.hasOwnProperty("topicName"))
                            if (!$util.isString(message.topicName))
                                return "topicName: string expected";
                        if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                            if (!$util.isInteger(message.submissionCount) && !(message.submissionCount && $util.isInteger(message.submissionCount.low) && $util.isInteger(message.submissionCount.high)))
                                return "submissionCount: integer|Long expected";
                        if (message.averageTopicScore != null && message.hasOwnProperty("averageTopicScore"))
                            if (!$util.isInteger(message.averageTopicScore))
                                return "averageTopicScore: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a TopicSentimentStat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TopicSentimentStat} TopicSentimentStat
                     */
                    TopicSentimentStat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TopicSentimentStat)
                            return object;
                        var message = new $root.palexy.task_management.v1.TopicSentimentStat();
                        if (object.topicId != null)
                            message.topicId = String(object.topicId);
                        if (object.topicName != null)
                            message.topicName = String(object.topicName);
                        if (object.submissionCount != null)
                            if ($util.Long)
                                (message.submissionCount = $util.Long.fromValue(object.submissionCount)).unsigned = false;
                            else if (typeof object.submissionCount === "string")
                                message.submissionCount = parseInt(object.submissionCount, 10);
                            else if (typeof object.submissionCount === "number")
                                message.submissionCount = object.submissionCount;
                            else if (typeof object.submissionCount === "object")
                                message.submissionCount = new $util.LongBits(object.submissionCount.low >>> 0, object.submissionCount.high >>> 0).toNumber();
                        if (object.averageTopicScore != null)
                            message.averageTopicScore = object.averageTopicScore | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TopicSentimentStat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @static
                     * @param {palexy.task_management.v1.TopicSentimentStat} message TopicSentimentStat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TopicSentimentStat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.topicId = "";
                            object.topicName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionCount = options.longs === String ? "0" : 0;
                            object.averageTopicScore = 0;
                        }
                        if (message.topicId != null && message.hasOwnProperty("topicId"))
                            object.topicId = message.topicId;
                        if (message.topicName != null && message.hasOwnProperty("topicName"))
                            object.topicName = message.topicName;
                        if (message.submissionCount != null && message.hasOwnProperty("submissionCount"))
                            if (typeof message.submissionCount === "number")
                                object.submissionCount = options.longs === String ? String(message.submissionCount) : message.submissionCount;
                            else
                                object.submissionCount = options.longs === String ? $util.Long.prototype.toString.call(message.submissionCount) : options.longs === Number ? new $util.LongBits(message.submissionCount.low >>> 0, message.submissionCount.high >>> 0).toNumber() : message.submissionCount;
                        if (message.averageTopicScore != null && message.hasOwnProperty("averageTopicScore"))
                            object.averageTopicScore = message.averageTopicScore;
                        return object;
                    };
    
                    /**
                     * Converts this TopicSentimentStat to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TopicSentimentStat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TopicSentimentStat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return TopicSentimentStat;
                })();
    
                v1.EvaluateFormSubmissionAttributeRequest = (function() {
    
                    /**
                     * Properties of an EvaluateFormSubmissionAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IEvaluateFormSubmissionAttributeRequest
                     * @property {number|null} [formId] EvaluateFormSubmissionAttributeRequest formId
                     * @property {number|null} [submissionId] EvaluateFormSubmissionAttributeRequest submissionId
                     * @property {Array.<number>|null} [changedFormFieldIds] EvaluateFormSubmissionAttributeRequest changedFormFieldIds
                     * @property {Array.<number>|null} [changedAttributeIds] EvaluateFormSubmissionAttributeRequest changedAttributeIds
                     * @property {boolean|null} [dryRun] EvaluateFormSubmissionAttributeRequest dryRun
                     * @property {Array.<palexy.task_management.v1.IAttributeValueOverride>|null} [valueOverrides] EvaluateFormSubmissionAttributeRequest valueOverrides
                     */
    
                    /**
                     * Constructs a new EvaluateFormSubmissionAttributeRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an EvaluateFormSubmissionAttributeRequest.
                     * @implements IEvaluateFormSubmissionAttributeRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest=} [properties] Properties to set
                     */
                    function EvaluateFormSubmissionAttributeRequest(properties) {
                        this.changedFormFieldIds = [];
                        this.changedAttributeIds = [];
                        this.valueOverrides = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest changedFormFieldIds.
                     * @member {Array.<number>} changedFormFieldIds
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.changedFormFieldIds = $util.emptyArray;
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest changedAttributeIds.
                     * @member {Array.<number>} changedAttributeIds
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.changedAttributeIds = $util.emptyArray;
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest dryRun.
                     * @member {boolean} dryRun
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.dryRun = false;
    
                    /**
                     * EvaluateFormSubmissionAttributeRequest valueOverrides.
                     * @member {Array.<palexy.task_management.v1.IAttributeValueOverride>} valueOverrides
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.valueOverrides = $util.emptyArray;
    
                    /**
                     * Creates a new EvaluateFormSubmissionAttributeRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest} EvaluateFormSubmissionAttributeRequest instance
                     */
                    EvaluateFormSubmissionAttributeRequest.create = function create(properties) {
                        return new EvaluateFormSubmissionAttributeRequest(properties);
                    };
    
                    /**
                     * Encodes the specified EvaluateFormSubmissionAttributeRequest message. Does not implicitly {@link palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest} message EvaluateFormSubmissionAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EvaluateFormSubmissionAttributeRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.changedFormFieldIds != null && message.changedFormFieldIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.changedFormFieldIds.length; ++i)
                                writer.int64(message.changedFormFieldIds[i]);
                            writer.ldelim();
                        }
                        if (message.changedAttributeIds != null && message.changedAttributeIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.changedAttributeIds.length; ++i)
                                writer.int64(message.changedAttributeIds[i]);
                            writer.ldelim();
                        }
                        if (message.dryRun != null && Object.hasOwnProperty.call(message, "dryRun"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.dryRun);
                        if (message.valueOverrides != null && message.valueOverrides.length)
                            for (var i = 0; i < message.valueOverrides.length; ++i)
                                $root.palexy.task_management.v1.AttributeValueOverride.encode(message.valueOverrides[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EvaluateFormSubmissionAttributeRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeRequest} message EvaluateFormSubmissionAttributeRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EvaluateFormSubmissionAttributeRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EvaluateFormSubmissionAttributeRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest} EvaluateFormSubmissionAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EvaluateFormSubmissionAttributeRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                if (!(message.changedFormFieldIds && message.changedFormFieldIds.length))
                                    message.changedFormFieldIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.changedFormFieldIds.push(reader.int64());
                                } else
                                    message.changedFormFieldIds.push(reader.int64());
                                break;
                            case 4:
                                if (!(message.changedAttributeIds && message.changedAttributeIds.length))
                                    message.changedAttributeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.changedAttributeIds.push(reader.int64());
                                } else
                                    message.changedAttributeIds.push(reader.int64());
                                break;
                            case 5:
                                message.dryRun = reader.bool();
                                break;
                            case 6:
                                if (!(message.valueOverrides && message.valueOverrides.length))
                                    message.valueOverrides = [];
                                message.valueOverrides.push($root.palexy.task_management.v1.AttributeValueOverride.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EvaluateFormSubmissionAttributeRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest} EvaluateFormSubmissionAttributeRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EvaluateFormSubmissionAttributeRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EvaluateFormSubmissionAttributeRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EvaluateFormSubmissionAttributeRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.changedFormFieldIds != null && message.hasOwnProperty("changedFormFieldIds")) {
                            if (!Array.isArray(message.changedFormFieldIds))
                                return "changedFormFieldIds: array expected";
                            for (var i = 0; i < message.changedFormFieldIds.length; ++i)
                                if (!$util.isInteger(message.changedFormFieldIds[i]) && !(message.changedFormFieldIds[i] && $util.isInteger(message.changedFormFieldIds[i].low) && $util.isInteger(message.changedFormFieldIds[i].high)))
                                    return "changedFormFieldIds: integer|Long[] expected";
                        }
                        if (message.changedAttributeIds != null && message.hasOwnProperty("changedAttributeIds")) {
                            if (!Array.isArray(message.changedAttributeIds))
                                return "changedAttributeIds: array expected";
                            for (var i = 0; i < message.changedAttributeIds.length; ++i)
                                if (!$util.isInteger(message.changedAttributeIds[i]) && !(message.changedAttributeIds[i] && $util.isInteger(message.changedAttributeIds[i].low) && $util.isInteger(message.changedAttributeIds[i].high)))
                                    return "changedAttributeIds: integer|Long[] expected";
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            if (typeof message.dryRun !== "boolean")
                                return "dryRun: boolean expected";
                        if (message.valueOverrides != null && message.hasOwnProperty("valueOverrides")) {
                            if (!Array.isArray(message.valueOverrides))
                                return "valueOverrides: array expected";
                            for (var i = 0; i < message.valueOverrides.length; ++i) {
                                var error = $root.palexy.task_management.v1.AttributeValueOverride.verify(message.valueOverrides[i]);
                                if (error)
                                    return "valueOverrides." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an EvaluateFormSubmissionAttributeRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest} EvaluateFormSubmissionAttributeRequest
                     */
                    EvaluateFormSubmissionAttributeRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.changedFormFieldIds) {
                            if (!Array.isArray(object.changedFormFieldIds))
                                throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.changedFormFieldIds: array expected");
                            message.changedFormFieldIds = [];
                            for (var i = 0; i < object.changedFormFieldIds.length; ++i)
                                if ($util.Long)
                                    (message.changedFormFieldIds[i] = $util.Long.fromValue(object.changedFormFieldIds[i])).unsigned = false;
                                else if (typeof object.changedFormFieldIds[i] === "string")
                                    message.changedFormFieldIds[i] = parseInt(object.changedFormFieldIds[i], 10);
                                else if (typeof object.changedFormFieldIds[i] === "number")
                                    message.changedFormFieldIds[i] = object.changedFormFieldIds[i];
                                else if (typeof object.changedFormFieldIds[i] === "object")
                                    message.changedFormFieldIds[i] = new $util.LongBits(object.changedFormFieldIds[i].low >>> 0, object.changedFormFieldIds[i].high >>> 0).toNumber();
                        }
                        if (object.changedAttributeIds) {
                            if (!Array.isArray(object.changedAttributeIds))
                                throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.changedAttributeIds: array expected");
                            message.changedAttributeIds = [];
                            for (var i = 0; i < object.changedAttributeIds.length; ++i)
                                if ($util.Long)
                                    (message.changedAttributeIds[i] = $util.Long.fromValue(object.changedAttributeIds[i])).unsigned = false;
                                else if (typeof object.changedAttributeIds[i] === "string")
                                    message.changedAttributeIds[i] = parseInt(object.changedAttributeIds[i], 10);
                                else if (typeof object.changedAttributeIds[i] === "number")
                                    message.changedAttributeIds[i] = object.changedAttributeIds[i];
                                else if (typeof object.changedAttributeIds[i] === "object")
                                    message.changedAttributeIds[i] = new $util.LongBits(object.changedAttributeIds[i].low >>> 0, object.changedAttributeIds[i].high >>> 0).toNumber();
                        }
                        if (object.dryRun != null)
                            message.dryRun = Boolean(object.dryRun);
                        if (object.valueOverrides) {
                            if (!Array.isArray(object.valueOverrides))
                                throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.valueOverrides: array expected");
                            message.valueOverrides = [];
                            for (var i = 0; i < object.valueOverrides.length; ++i) {
                                if (typeof object.valueOverrides[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest.valueOverrides: object expected");
                                message.valueOverrides[i] = $root.palexy.task_management.v1.AttributeValueOverride.fromObject(object.valueOverrides[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EvaluateFormSubmissionAttributeRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @static
                     * @param {palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest} message EvaluateFormSubmissionAttributeRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EvaluateFormSubmissionAttributeRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.changedFormFieldIds = [];
                            object.changedAttributeIds = [];
                            object.valueOverrides = [];
                        }
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            object.dryRun = false;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.changedFormFieldIds && message.changedFormFieldIds.length) {
                            object.changedFormFieldIds = [];
                            for (var j = 0; j < message.changedFormFieldIds.length; ++j)
                                if (typeof message.changedFormFieldIds[j] === "number")
                                    object.changedFormFieldIds[j] = options.longs === String ? String(message.changedFormFieldIds[j]) : message.changedFormFieldIds[j];
                                else
                                    object.changedFormFieldIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.changedFormFieldIds[j]) : options.longs === Number ? new $util.LongBits(message.changedFormFieldIds[j].low >>> 0, message.changedFormFieldIds[j].high >>> 0).toNumber() : message.changedFormFieldIds[j];
                        }
                        if (message.changedAttributeIds && message.changedAttributeIds.length) {
                            object.changedAttributeIds = [];
                            for (var j = 0; j < message.changedAttributeIds.length; ++j)
                                if (typeof message.changedAttributeIds[j] === "number")
                                    object.changedAttributeIds[j] = options.longs === String ? String(message.changedAttributeIds[j]) : message.changedAttributeIds[j];
                                else
                                    object.changedAttributeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.changedAttributeIds[j]) : options.longs === Number ? new $util.LongBits(message.changedAttributeIds[j].low >>> 0, message.changedAttributeIds[j].high >>> 0).toNumber() : message.changedAttributeIds[j];
                        }
                        if (message.dryRun != null && message.hasOwnProperty("dryRun"))
                            object.dryRun = message.dryRun;
                        if (message.valueOverrides && message.valueOverrides.length) {
                            object.valueOverrides = [];
                            for (var j = 0; j < message.valueOverrides.length; ++j)
                                object.valueOverrides[j] = $root.palexy.task_management.v1.AttributeValueOverride.toObject(message.valueOverrides[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this EvaluateFormSubmissionAttributeRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EvaluateFormSubmissionAttributeRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EvaluateFormSubmissionAttributeRequest;
                })();
    
                v1.AttributeValueOverride = (function() {
    
                    /**
                     * Properties of an AttributeValueOverride.
                     * @memberof palexy.task_management.v1
                     * @interface IAttributeValueOverride
                     * @property {number|null} [attributeId] AttributeValueOverride attributeId
                     * @property {string|null} [value] AttributeValueOverride value
                     * @property {boolean|null} [isUsableValue] AttributeValueOverride isUsableValue
                     */
    
                    /**
                     * Constructs a new AttributeValueOverride.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AttributeValueOverride.
                     * @implements IAttributeValueOverride
                     * @constructor
                     * @param {palexy.task_management.v1.IAttributeValueOverride=} [properties] Properties to set
                     */
                    function AttributeValueOverride(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AttributeValueOverride attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @instance
                     */
                    AttributeValueOverride.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AttributeValueOverride value.
                     * @member {string} value
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @instance
                     */
                    AttributeValueOverride.prototype.value = "";
    
                    /**
                     * AttributeValueOverride isUsableValue.
                     * @member {boolean} isUsableValue
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @instance
                     */
                    AttributeValueOverride.prototype.isUsableValue = false;
    
                    /**
                     * Creates a new AttributeValueOverride instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {palexy.task_management.v1.IAttributeValueOverride=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AttributeValueOverride} AttributeValueOverride instance
                     */
                    AttributeValueOverride.create = function create(properties) {
                        return new AttributeValueOverride(properties);
                    };
    
                    /**
                     * Encodes the specified AttributeValueOverride message. Does not implicitly {@link palexy.task_management.v1.AttributeValueOverride.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {palexy.task_management.v1.IAttributeValueOverride} message AttributeValueOverride message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AttributeValueOverride.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.attributeId);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.value);
                        if (message.isUsableValue != null && Object.hasOwnProperty.call(message, "isUsableValue"))
                            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.isUsableValue);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AttributeValueOverride message, length delimited. Does not implicitly {@link palexy.task_management.v1.AttributeValueOverride.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {palexy.task_management.v1.IAttributeValueOverride} message AttributeValueOverride message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AttributeValueOverride.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AttributeValueOverride message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AttributeValueOverride} AttributeValueOverride
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AttributeValueOverride.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AttributeValueOverride();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.attributeId = reader.int64();
                                break;
                            case 2:
                                message.value = reader.string();
                                break;
                            case 3:
                                message.isUsableValue = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AttributeValueOverride message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AttributeValueOverride} AttributeValueOverride
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AttributeValueOverride.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AttributeValueOverride message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AttributeValueOverride.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        if (message.isUsableValue != null && message.hasOwnProperty("isUsableValue"))
                            if (typeof message.isUsableValue !== "boolean")
                                return "isUsableValue: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an AttributeValueOverride message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AttributeValueOverride} AttributeValueOverride
                     */
                    AttributeValueOverride.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AttributeValueOverride)
                            return object;
                        var message = new $root.palexy.task_management.v1.AttributeValueOverride();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.value != null)
                            message.value = String(object.value);
                        if (object.isUsableValue != null)
                            message.isUsableValue = Boolean(object.isUsableValue);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AttributeValueOverride message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @static
                     * @param {palexy.task_management.v1.AttributeValueOverride} message AttributeValueOverride
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AttributeValueOverride.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.value = "";
                            object.isUsableValue = false;
                        }
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        if (message.isUsableValue != null && message.hasOwnProperty("isUsableValue"))
                            object.isUsableValue = message.isUsableValue;
                        return object;
                    };
    
                    /**
                     * Converts this AttributeValueOverride to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AttributeValueOverride
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AttributeValueOverride.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AttributeValueOverride;
                })();
    
                v1.EvaluateFormSubmissionAttributeResponse = (function() {
    
                    /**
                     * Properties of an EvaluateFormSubmissionAttributeResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IEvaluateFormSubmissionAttributeResponse
                     * @property {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>|null} [results] EvaluateFormSubmissionAttributeResponse results
                     * @property {Array.<number>|null} [triggeredHsTaskIds] EvaluateFormSubmissionAttributeResponse triggeredHsTaskIds
                     */
    
                    /**
                     * Constructs a new EvaluateFormSubmissionAttributeResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an EvaluateFormSubmissionAttributeResponse.
                     * @implements IEvaluateFormSubmissionAttributeResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeResponse=} [properties] Properties to set
                     */
                    function EvaluateFormSubmissionAttributeResponse(properties) {
                        this.results = [];
                        this.triggeredHsTaskIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * EvaluateFormSubmissionAttributeResponse results.
                     * @member {Array.<palexy.task_management.v1.IFormSubmissionAttributeValue>} results
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeResponse.prototype.results = $util.emptyArray;
    
                    /**
                     * EvaluateFormSubmissionAttributeResponse triggeredHsTaskIds.
                     * @member {Array.<number>} triggeredHsTaskIds
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @instance
                     */
                    EvaluateFormSubmissionAttributeResponse.prototype.triggeredHsTaskIds = $util.emptyArray;
    
                    /**
                     * Creates a new EvaluateFormSubmissionAttributeResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} EvaluateFormSubmissionAttributeResponse instance
                     */
                    EvaluateFormSubmissionAttributeResponse.create = function create(properties) {
                        return new EvaluateFormSubmissionAttributeResponse(properties);
                    };
    
                    /**
                     * Encodes the specified EvaluateFormSubmissionAttributeResponse message. Does not implicitly {@link palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeResponse} message EvaluateFormSubmissionAttributeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EvaluateFormSubmissionAttributeResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.results != null && message.results.length)
                            for (var i = 0; i < message.results.length; ++i)
                                $root.palexy.task_management.v1.FormSubmissionAttributeValue.encode(message.results[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.triggeredHsTaskIds != null && message.triggeredHsTaskIds.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.triggeredHsTaskIds.length; ++i)
                                writer.int64(message.triggeredHsTaskIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified EvaluateFormSubmissionAttributeResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {palexy.task_management.v1.IEvaluateFormSubmissionAttributeResponse} message EvaluateFormSubmissionAttributeResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    EvaluateFormSubmissionAttributeResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an EvaluateFormSubmissionAttributeResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} EvaluateFormSubmissionAttributeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EvaluateFormSubmissionAttributeResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.results && message.results.length))
                                    message.results = [];
                                message.results.push($root.palexy.task_management.v1.FormSubmissionAttributeValue.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.triggeredHsTaskIds && message.triggeredHsTaskIds.length))
                                    message.triggeredHsTaskIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.triggeredHsTaskIds.push(reader.int64());
                                } else
                                    message.triggeredHsTaskIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an EvaluateFormSubmissionAttributeResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} EvaluateFormSubmissionAttributeResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    EvaluateFormSubmissionAttributeResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an EvaluateFormSubmissionAttributeResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    EvaluateFormSubmissionAttributeResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.results != null && message.hasOwnProperty("results")) {
                            if (!Array.isArray(message.results))
                                return "results: array expected";
                            for (var i = 0; i < message.results.length; ++i) {
                                var error = $root.palexy.task_management.v1.FormSubmissionAttributeValue.verify(message.results[i]);
                                if (error)
                                    return "results." + error;
                            }
                        }
                        if (message.triggeredHsTaskIds != null && message.hasOwnProperty("triggeredHsTaskIds")) {
                            if (!Array.isArray(message.triggeredHsTaskIds))
                                return "triggeredHsTaskIds: array expected";
                            for (var i = 0; i < message.triggeredHsTaskIds.length; ++i)
                                if (!$util.isInteger(message.triggeredHsTaskIds[i]) && !(message.triggeredHsTaskIds[i] && $util.isInteger(message.triggeredHsTaskIds[i].low) && $util.isInteger(message.triggeredHsTaskIds[i].high)))
                                    return "triggeredHsTaskIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an EvaluateFormSubmissionAttributeResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} EvaluateFormSubmissionAttributeResponse
                     */
                    EvaluateFormSubmissionAttributeResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse();
                        if (object.results) {
                            if (!Array.isArray(object.results))
                                throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse.results: array expected");
                            message.results = [];
                            for (var i = 0; i < object.results.length; ++i) {
                                if (typeof object.results[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse.results: object expected");
                                message.results[i] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.fromObject(object.results[i]);
                            }
                        }
                        if (object.triggeredHsTaskIds) {
                            if (!Array.isArray(object.triggeredHsTaskIds))
                                throw TypeError(".palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse.triggeredHsTaskIds: array expected");
                            message.triggeredHsTaskIds = [];
                            for (var i = 0; i < object.triggeredHsTaskIds.length; ++i)
                                if ($util.Long)
                                    (message.triggeredHsTaskIds[i] = $util.Long.fromValue(object.triggeredHsTaskIds[i])).unsigned = false;
                                else if (typeof object.triggeredHsTaskIds[i] === "string")
                                    message.triggeredHsTaskIds[i] = parseInt(object.triggeredHsTaskIds[i], 10);
                                else if (typeof object.triggeredHsTaskIds[i] === "number")
                                    message.triggeredHsTaskIds[i] = object.triggeredHsTaskIds[i];
                                else if (typeof object.triggeredHsTaskIds[i] === "object")
                                    message.triggeredHsTaskIds[i] = new $util.LongBits(object.triggeredHsTaskIds[i].low >>> 0, object.triggeredHsTaskIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an EvaluateFormSubmissionAttributeResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @static
                     * @param {palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse} message EvaluateFormSubmissionAttributeResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    EvaluateFormSubmissionAttributeResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.results = [];
                            object.triggeredHsTaskIds = [];
                        }
                        if (message.results && message.results.length) {
                            object.results = [];
                            for (var j = 0; j < message.results.length; ++j)
                                object.results[j] = $root.palexy.task_management.v1.FormSubmissionAttributeValue.toObject(message.results[j], options);
                        }
                        if (message.triggeredHsTaskIds && message.triggeredHsTaskIds.length) {
                            object.triggeredHsTaskIds = [];
                            for (var j = 0; j < message.triggeredHsTaskIds.length; ++j)
                                if (typeof message.triggeredHsTaskIds[j] === "number")
                                    object.triggeredHsTaskIds[j] = options.longs === String ? String(message.triggeredHsTaskIds[j]) : message.triggeredHsTaskIds[j];
                                else
                                    object.triggeredHsTaskIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.triggeredHsTaskIds[j]) : options.longs === Number ? new $util.LongBits(message.triggeredHsTaskIds[j].low >>> 0, message.triggeredHsTaskIds[j].high >>> 0).toNumber() : message.triggeredHsTaskIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this EvaluateFormSubmissionAttributeResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.EvaluateFormSubmissionAttributeResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    EvaluateFormSubmissionAttributeResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return EvaluateFormSubmissionAttributeResponse;
                })();
    
                v1.UpsertFormSubmissionAttributeValueRequest = (function() {
    
                    /**
                     * Properties of an UpsertFormSubmissionAttributeValueRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpsertFormSubmissionAttributeValueRequest
                     * @property {number|null} [formId] UpsertFormSubmissionAttributeValueRequest formId
                     * @property {number|null} [submissionId] UpsertFormSubmissionAttributeValueRequest submissionId
                     * @property {number|null} [attributeId] UpsertFormSubmissionAttributeValueRequest attributeId
                     * @property {string|null} [value] UpsertFormSubmissionAttributeValueRequest value
                     * @property {boolean|null} [isUsableValue] UpsertFormSubmissionAttributeValueRequest isUsableValue
                     */
    
                    /**
                     * Constructs a new UpsertFormSubmissionAttributeValueRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpsertFormSubmissionAttributeValueRequest.
                     * @implements IUpsertFormSubmissionAttributeValueRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest=} [properties] Properties to set
                     */
                    function UpsertFormSubmissionAttributeValueRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpsertFormSubmissionAttributeValueRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpsertFormSubmissionAttributeValueRequest submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpsertFormSubmissionAttributeValueRequest attributeId.
                     * @member {number} attributeId
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.attributeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpsertFormSubmissionAttributeValueRequest value.
                     * @member {string} value
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.value = "";
    
                    /**
                     * UpsertFormSubmissionAttributeValueRequest isUsableValue.
                     * @member {boolean} isUsableValue
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.isUsableValue = false;
    
                    /**
                     * Creates a new UpsertFormSubmissionAttributeValueRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest} UpsertFormSubmissionAttributeValueRequest instance
                     */
                    UpsertFormSubmissionAttributeValueRequest.create = function create(properties) {
                        return new UpsertFormSubmissionAttributeValueRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpsertFormSubmissionAttributeValueRequest message. Does not implicitly {@link palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest} message UpsertFormSubmissionAttributeValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpsertFormSubmissionAttributeValueRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.attributeId != null && Object.hasOwnProperty.call(message, "attributeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.attributeId);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.value);
                        if (message.isUsableValue != null && Object.hasOwnProperty.call(message, "isUsableValue"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.isUsableValue);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpsertFormSubmissionAttributeValueRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueRequest} message UpsertFormSubmissionAttributeValueRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpsertFormSubmissionAttributeValueRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpsertFormSubmissionAttributeValueRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest} UpsertFormSubmissionAttributeValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpsertFormSubmissionAttributeValueRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.attributeId = reader.int64();
                                break;
                            case 4:
                                message.value = reader.string();
                                break;
                            case 5:
                                message.isUsableValue = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpsertFormSubmissionAttributeValueRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest} UpsertFormSubmissionAttributeValueRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpsertFormSubmissionAttributeValueRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpsertFormSubmissionAttributeValueRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpsertFormSubmissionAttributeValueRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (!$util.isInteger(message.attributeId) && !(message.attributeId && $util.isInteger(message.attributeId.low) && $util.isInteger(message.attributeId.high)))
                                return "attributeId: integer|Long expected";
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (!$util.isString(message.value))
                                return "value: string expected";
                        if (message.isUsableValue != null && message.hasOwnProperty("isUsableValue"))
                            if (typeof message.isUsableValue !== "boolean")
                                return "isUsableValue: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpsertFormSubmissionAttributeValueRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest} UpsertFormSubmissionAttributeValueRequest
                     */
                    UpsertFormSubmissionAttributeValueRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.attributeId != null)
                            if ($util.Long)
                                (message.attributeId = $util.Long.fromValue(object.attributeId)).unsigned = false;
                            else if (typeof object.attributeId === "string")
                                message.attributeId = parseInt(object.attributeId, 10);
                            else if (typeof object.attributeId === "number")
                                message.attributeId = object.attributeId;
                            else if (typeof object.attributeId === "object")
                                message.attributeId = new $util.LongBits(object.attributeId.low >>> 0, object.attributeId.high >>> 0).toNumber();
                        if (object.value != null)
                            message.value = String(object.value);
                        if (object.isUsableValue != null)
                            message.isUsableValue = Boolean(object.isUsableValue);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpsertFormSubmissionAttributeValueRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @static
                     * @param {palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest} message UpsertFormSubmissionAttributeValueRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpsertFormSubmissionAttributeValueRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.attributeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.attributeId = options.longs === String ? "0" : 0;
                            object.value = "";
                            object.isUsableValue = false;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.attributeId != null && message.hasOwnProperty("attributeId"))
                            if (typeof message.attributeId === "number")
                                object.attributeId = options.longs === String ? String(message.attributeId) : message.attributeId;
                            else
                                object.attributeId = options.longs === String ? $util.Long.prototype.toString.call(message.attributeId) : options.longs === Number ? new $util.LongBits(message.attributeId.low >>> 0, message.attributeId.high >>> 0).toNumber() : message.attributeId;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = message.value;
                        if (message.isUsableValue != null && message.hasOwnProperty("isUsableValue"))
                            object.isUsableValue = message.isUsableValue;
                        return object;
                    };
    
                    /**
                     * Converts this UpsertFormSubmissionAttributeValueRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpsertFormSubmissionAttributeValueRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpsertFormSubmissionAttributeValueRequest;
                })();
    
                v1.UpsertFormSubmissionAttributeValueResponse = (function() {
    
                    /**
                     * Properties of an UpsertFormSubmissionAttributeValueResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IUpsertFormSubmissionAttributeValueResponse
                     */
    
                    /**
                     * Constructs a new UpsertFormSubmissionAttributeValueResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpsertFormSubmissionAttributeValueResponse.
                     * @implements IUpsertFormSubmissionAttributeValueResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueResponse=} [properties] Properties to set
                     */
                    function UpsertFormSubmissionAttributeValueResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new UpsertFormSubmissionAttributeValueResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} UpsertFormSubmissionAttributeValueResponse instance
                     */
                    UpsertFormSubmissionAttributeValueResponse.create = function create(properties) {
                        return new UpsertFormSubmissionAttributeValueResponse(properties);
                    };
    
                    /**
                     * Encodes the specified UpsertFormSubmissionAttributeValueResponse message. Does not implicitly {@link palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueResponse} message UpsertFormSubmissionAttributeValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpsertFormSubmissionAttributeValueResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpsertFormSubmissionAttributeValueResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {palexy.task_management.v1.IUpsertFormSubmissionAttributeValueResponse} message UpsertFormSubmissionAttributeValueResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpsertFormSubmissionAttributeValueResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpsertFormSubmissionAttributeValueResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} UpsertFormSubmissionAttributeValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpsertFormSubmissionAttributeValueResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpsertFormSubmissionAttributeValueResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} UpsertFormSubmissionAttributeValueResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpsertFormSubmissionAttributeValueResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpsertFormSubmissionAttributeValueResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpsertFormSubmissionAttributeValueResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an UpsertFormSubmissionAttributeValueResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} UpsertFormSubmissionAttributeValueResponse
                     */
                    UpsertFormSubmissionAttributeValueResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse)
                            return object;
                        return new $root.palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse();
                    };
    
                    /**
                     * Creates a plain object from an UpsertFormSubmissionAttributeValueResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @static
                     * @param {palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse} message UpsertFormSubmissionAttributeValueResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpsertFormSubmissionAttributeValueResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this UpsertFormSubmissionAttributeValueResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpsertFormSubmissionAttributeValueResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpsertFormSubmissionAttributeValueResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpsertFormSubmissionAttributeValueResponse;
                })();
    
                v1.SyncReviewsRequest = (function() {
    
                    /**
                     * Properties of a SyncReviewsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ISyncReviewsRequest
                     * @property {number|null} [formId] SyncReviewsRequest formId
                     * @property {number|null} [startDateMs] SyncReviewsRequest startDateMs
                     * @property {number|null} [endDateMs] SyncReviewsRequest endDateMs
                     * @property {number|null} [submitterId] SyncReviewsRequest submitterId
                     * @property {Array.<number>|null} [storeIds] SyncReviewsRequest storeIds
                     */
    
                    /**
                     * Constructs a new SyncReviewsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SyncReviewsRequest.
                     * @implements ISyncReviewsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ISyncReviewsRequest=} [properties] Properties to set
                     */
                    function SyncReviewsRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SyncReviewsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     */
                    SyncReviewsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SyncReviewsRequest startDateMs.
                     * @member {number} startDateMs
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     */
                    SyncReviewsRequest.prototype.startDateMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SyncReviewsRequest endDateMs.
                     * @member {number} endDateMs
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     */
                    SyncReviewsRequest.prototype.endDateMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SyncReviewsRequest submitterId.
                     * @member {number} submitterId
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     */
                    SyncReviewsRequest.prototype.submitterId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SyncReviewsRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     */
                    SyncReviewsRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * Creates a new SyncReviewsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SyncReviewsRequest} SyncReviewsRequest instance
                     */
                    SyncReviewsRequest.create = function create(properties) {
                        return new SyncReviewsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SyncReviewsRequest message. Does not implicitly {@link palexy.task_management.v1.SyncReviewsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsRequest} message SyncReviewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SyncReviewsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.startDateMs != null && Object.hasOwnProperty.call(message, "startDateMs"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.startDateMs);
                        if (message.endDateMs != null && Object.hasOwnProperty.call(message, "endDateMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.endDateMs);
                        if (message.submitterId != null && Object.hasOwnProperty.call(message, "submitterId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.submitterId);
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 5, wireType 2 =*/42).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SyncReviewsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.SyncReviewsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsRequest} message SyncReviewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SyncReviewsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SyncReviewsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SyncReviewsRequest} SyncReviewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SyncReviewsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SyncReviewsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.startDateMs = reader.int64();
                                break;
                            case 3:
                                message.endDateMs = reader.int64();
                                break;
                            case 4:
                                message.submitterId = reader.int64();
                                break;
                            case 5:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SyncReviewsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SyncReviewsRequest} SyncReviewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SyncReviewsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SyncReviewsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SyncReviewsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.startDateMs != null && message.hasOwnProperty("startDateMs"))
                            if (!$util.isInteger(message.startDateMs) && !(message.startDateMs && $util.isInteger(message.startDateMs.low) && $util.isInteger(message.startDateMs.high)))
                                return "startDateMs: integer|Long expected";
                        if (message.endDateMs != null && message.hasOwnProperty("endDateMs"))
                            if (!$util.isInteger(message.endDateMs) && !(message.endDateMs && $util.isInteger(message.endDateMs.low) && $util.isInteger(message.endDateMs.high)))
                                return "endDateMs: integer|Long expected";
                        if (message.submitterId != null && message.hasOwnProperty("submitterId"))
                            if (!$util.isInteger(message.submitterId) && !(message.submitterId && $util.isInteger(message.submitterId.low) && $util.isInteger(message.submitterId.high)))
                                return "submitterId: integer|Long expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a SyncReviewsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SyncReviewsRequest} SyncReviewsRequest
                     */
                    SyncReviewsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SyncReviewsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.SyncReviewsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.startDateMs != null)
                            if ($util.Long)
                                (message.startDateMs = $util.Long.fromValue(object.startDateMs)).unsigned = false;
                            else if (typeof object.startDateMs === "string")
                                message.startDateMs = parseInt(object.startDateMs, 10);
                            else if (typeof object.startDateMs === "number")
                                message.startDateMs = object.startDateMs;
                            else if (typeof object.startDateMs === "object")
                                message.startDateMs = new $util.LongBits(object.startDateMs.low >>> 0, object.startDateMs.high >>> 0).toNumber();
                        if (object.endDateMs != null)
                            if ($util.Long)
                                (message.endDateMs = $util.Long.fromValue(object.endDateMs)).unsigned = false;
                            else if (typeof object.endDateMs === "string")
                                message.endDateMs = parseInt(object.endDateMs, 10);
                            else if (typeof object.endDateMs === "number")
                                message.endDateMs = object.endDateMs;
                            else if (typeof object.endDateMs === "object")
                                message.endDateMs = new $util.LongBits(object.endDateMs.low >>> 0, object.endDateMs.high >>> 0).toNumber();
                        if (object.submitterId != null)
                            if ($util.Long)
                                (message.submitterId = $util.Long.fromValue(object.submitterId)).unsigned = false;
                            else if (typeof object.submitterId === "string")
                                message.submitterId = parseInt(object.submitterId, 10);
                            else if (typeof object.submitterId === "number")
                                message.submitterId = object.submitterId;
                            else if (typeof object.submitterId === "object")
                                message.submitterId = new $util.LongBits(object.submitterId.low >>> 0, object.submitterId.high >>> 0).toNumber();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.task_management.v1.SyncReviewsRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SyncReviewsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.SyncReviewsRequest} message SyncReviewsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SyncReviewsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.startDateMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.startDateMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.endDateMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.endDateMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submitterId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submitterId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.startDateMs != null && message.hasOwnProperty("startDateMs"))
                            if (typeof message.startDateMs === "number")
                                object.startDateMs = options.longs === String ? String(message.startDateMs) : message.startDateMs;
                            else
                                object.startDateMs = options.longs === String ? $util.Long.prototype.toString.call(message.startDateMs) : options.longs === Number ? new $util.LongBits(message.startDateMs.low >>> 0, message.startDateMs.high >>> 0).toNumber() : message.startDateMs;
                        if (message.endDateMs != null && message.hasOwnProperty("endDateMs"))
                            if (typeof message.endDateMs === "number")
                                object.endDateMs = options.longs === String ? String(message.endDateMs) : message.endDateMs;
                            else
                                object.endDateMs = options.longs === String ? $util.Long.prototype.toString.call(message.endDateMs) : options.longs === Number ? new $util.LongBits(message.endDateMs.low >>> 0, message.endDateMs.high >>> 0).toNumber() : message.endDateMs;
                        if (message.submitterId != null && message.hasOwnProperty("submitterId"))
                            if (typeof message.submitterId === "number")
                                object.submitterId = options.longs === String ? String(message.submitterId) : message.submitterId;
                            else
                                object.submitterId = options.longs === String ? $util.Long.prototype.toString.call(message.submitterId) : options.longs === Number ? new $util.LongBits(message.submitterId.low >>> 0, message.submitterId.high >>> 0).toNumber() : message.submitterId;
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this SyncReviewsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SyncReviewsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SyncReviewsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SyncReviewsRequest;
                })();
    
                v1.SyncReviewsResponse = (function() {
    
                    /**
                     * Properties of a SyncReviewsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface ISyncReviewsResponse
                     */
    
                    /**
                     * Constructs a new SyncReviewsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SyncReviewsResponse.
                     * @implements ISyncReviewsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.ISyncReviewsResponse=} [properties] Properties to set
                     */
                    function SyncReviewsResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new SyncReviewsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SyncReviewsResponse} SyncReviewsResponse instance
                     */
                    SyncReviewsResponse.create = function create(properties) {
                        return new SyncReviewsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SyncReviewsResponse message. Does not implicitly {@link palexy.task_management.v1.SyncReviewsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsResponse} message SyncReviewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SyncReviewsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SyncReviewsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.SyncReviewsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISyncReviewsResponse} message SyncReviewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SyncReviewsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SyncReviewsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SyncReviewsResponse} SyncReviewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SyncReviewsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SyncReviewsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SyncReviewsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SyncReviewsResponse} SyncReviewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SyncReviewsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SyncReviewsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SyncReviewsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a SyncReviewsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SyncReviewsResponse} SyncReviewsResponse
                     */
                    SyncReviewsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SyncReviewsResponse)
                            return object;
                        return new $root.palexy.task_management.v1.SyncReviewsResponse();
                    };
    
                    /**
                     * Creates a plain object from a SyncReviewsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.SyncReviewsResponse} message SyncReviewsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SyncReviewsResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this SyncReviewsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SyncReviewsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SyncReviewsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SyncReviewsResponse;
                })();
    
                v1.ProcessReviewSyncJobRequest = (function() {
    
                    /**
                     * Properties of a ProcessReviewSyncJobRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IProcessReviewSyncJobRequest
                     * @property {number|null} [jobId] ProcessReviewSyncJobRequest jobId
                     */
    
                    /**
                     * Constructs a new ProcessReviewSyncJobRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ProcessReviewSyncJobRequest.
                     * @implements IProcessReviewSyncJobRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest=} [properties] Properties to set
                     */
                    function ProcessReviewSyncJobRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ProcessReviewSyncJobRequest jobId.
                     * @member {number} jobId
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @instance
                     */
                    ProcessReviewSyncJobRequest.prototype.jobId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ProcessReviewSyncJobRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobRequest} ProcessReviewSyncJobRequest instance
                     */
                    ProcessReviewSyncJobRequest.create = function create(properties) {
                        return new ProcessReviewSyncJobRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessReviewSyncJobRequest message. Does not implicitly {@link palexy.task_management.v1.ProcessReviewSyncJobRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest} message ProcessReviewSyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessReviewSyncJobRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.jobId != null && Object.hasOwnProperty.call(message, "jobId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.jobId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessReviewSyncJobRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ProcessReviewSyncJobRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobRequest} message ProcessReviewSyncJobRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessReviewSyncJobRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessReviewSyncJobRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobRequest} ProcessReviewSyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessReviewSyncJobRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ProcessReviewSyncJobRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.jobId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessReviewSyncJobRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobRequest} ProcessReviewSyncJobRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessReviewSyncJobRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessReviewSyncJobRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessReviewSyncJobRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.jobId != null && message.hasOwnProperty("jobId"))
                            if (!$util.isInteger(message.jobId) && !(message.jobId && $util.isInteger(message.jobId.low) && $util.isInteger(message.jobId.high)))
                                return "jobId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessReviewSyncJobRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobRequest} ProcessReviewSyncJobRequest
                     */
                    ProcessReviewSyncJobRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ProcessReviewSyncJobRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ProcessReviewSyncJobRequest();
                        if (object.jobId != null)
                            if ($util.Long)
                                (message.jobId = $util.Long.fromValue(object.jobId)).unsigned = false;
                            else if (typeof object.jobId === "string")
                                message.jobId = parseInt(object.jobId, 10);
                            else if (typeof object.jobId === "number")
                                message.jobId = object.jobId;
                            else if (typeof object.jobId === "object")
                                message.jobId = new $util.LongBits(object.jobId.low >>> 0, object.jobId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ProcessReviewSyncJobRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @static
                     * @param {palexy.task_management.v1.ProcessReviewSyncJobRequest} message ProcessReviewSyncJobRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessReviewSyncJobRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.jobId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.jobId = options.longs === String ? "0" : 0;
                        if (message.jobId != null && message.hasOwnProperty("jobId"))
                            if (typeof message.jobId === "number")
                                object.jobId = options.longs === String ? String(message.jobId) : message.jobId;
                            else
                                object.jobId = options.longs === String ? $util.Long.prototype.toString.call(message.jobId) : options.longs === Number ? new $util.LongBits(message.jobId.low >>> 0, message.jobId.high >>> 0).toNumber() : message.jobId;
                        return object;
                    };
    
                    /**
                     * Converts this ProcessReviewSyncJobRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessReviewSyncJobRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessReviewSyncJobRequest;
                })();
    
                v1.AggregateReputationDataRequest = (function() {
    
                    /**
                     * Properties of an AggregateReputationDataRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IAggregateReputationDataRequest
                     * @property {number|null} [storeId] AggregateReputationDataRequest storeId
                     * @property {number|null} [startDateId] AggregateReputationDataRequest startDateId
                     * @property {number|null} [endDateId] AggregateReputationDataRequest endDateId
                     */
    
                    /**
                     * Constructs a new AggregateReputationDataRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AggregateReputationDataRequest.
                     * @implements IAggregateReputationDataRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest=} [properties] Properties to set
                     */
                    function AggregateReputationDataRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AggregateReputationDataRequest storeId.
                     * @member {number} storeId
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @instance
                     */
                    AggregateReputationDataRequest.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AggregateReputationDataRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @instance
                     */
                    AggregateReputationDataRequest.prototype.startDateId = 0;
    
                    /**
                     * AggregateReputationDataRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @instance
                     */
                    AggregateReputationDataRequest.prototype.endDateId = 0;
    
                    /**
                     * Creates a new AggregateReputationDataRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AggregateReputationDataRequest} AggregateReputationDataRequest instance
                     */
                    AggregateReputationDataRequest.create = function create(properties) {
                        return new AggregateReputationDataRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateReputationDataRequest message. Does not implicitly {@link palexy.task_management.v1.AggregateReputationDataRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest} message AggregateReputationDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateReputationDataRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateReputationDataRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.AggregateReputationDataRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataRequest} message AggregateReputationDataRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateReputationDataRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateReputationDataRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AggregateReputationDataRequest} AggregateReputationDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateReputationDataRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AggregateReputationDataRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.storeId = reader.int64();
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateReputationDataRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AggregateReputationDataRequest} AggregateReputationDataRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateReputationDataRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateReputationDataRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateReputationDataRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateReputationDataRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AggregateReputationDataRequest} AggregateReputationDataRequest
                     */
                    AggregateReputationDataRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AggregateReputationDataRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.AggregateReputationDataRequest();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AggregateReputationDataRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @static
                     * @param {palexy.task_management.v1.AggregateReputationDataRequest} message AggregateReputationDataRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateReputationDataRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.startDateId = 0;
                            object.endDateId = 0;
                        }
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this AggregateReputationDataRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AggregateReputationDataRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateReputationDataRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateReputationDataRequest;
                })();
    
                v1.AggregateReputationDataResponse = (function() {
    
                    /**
                     * Properties of an AggregateReputationDataResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IAggregateReputationDataResponse
                     */
    
                    /**
                     * Constructs a new AggregateReputationDataResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AggregateReputationDataResponse.
                     * @implements IAggregateReputationDataResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IAggregateReputationDataResponse=} [properties] Properties to set
                     */
                    function AggregateReputationDataResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new AggregateReputationDataResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AggregateReputationDataResponse} AggregateReputationDataResponse instance
                     */
                    AggregateReputationDataResponse.create = function create(properties) {
                        return new AggregateReputationDataResponse(properties);
                    };
    
                    /**
                     * Encodes the specified AggregateReputationDataResponse message. Does not implicitly {@link palexy.task_management.v1.AggregateReputationDataResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataResponse} message AggregateReputationDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateReputationDataResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AggregateReputationDataResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.AggregateReputationDataResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {palexy.task_management.v1.IAggregateReputationDataResponse} message AggregateReputationDataResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AggregateReputationDataResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AggregateReputationDataResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AggregateReputationDataResponse} AggregateReputationDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateReputationDataResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AggregateReputationDataResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AggregateReputationDataResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AggregateReputationDataResponse} AggregateReputationDataResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AggregateReputationDataResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AggregateReputationDataResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AggregateReputationDataResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates an AggregateReputationDataResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AggregateReputationDataResponse} AggregateReputationDataResponse
                     */
                    AggregateReputationDataResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AggregateReputationDataResponse)
                            return object;
                        return new $root.palexy.task_management.v1.AggregateReputationDataResponse();
                    };
    
                    /**
                     * Creates a plain object from an AggregateReputationDataResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @static
                     * @param {palexy.task_management.v1.AggregateReputationDataResponse} message AggregateReputationDataResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AggregateReputationDataResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this AggregateReputationDataResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AggregateReputationDataResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AggregateReputationDataResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AggregateReputationDataResponse;
                })();
    
                v1.ListReputationReviewsRequest = (function() {
    
                    /**
                     * Properties of a ListReputationReviewsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListReputationReviewsRequest
                     * @property {Array.<number>|null} [storeIds] ListReputationReviewsRequest storeIds
                     * @property {number|null} [startDateId] ListReputationReviewsRequest startDateId
                     * @property {number|null} [endDateId] ListReputationReviewsRequest endDateId
                     * @property {palexy.task_management.v1.ListReputationReviewsRequest.SortOrder|null} [sortOrder] ListReputationReviewsRequest sortOrder
                     * @property {number|null} [pageSize] ListReputationReviewsRequest pageSize
                     * @property {string|null} [pageToken] ListReputationReviewsRequest pageToken
                     * @property {number|null} [complaintMinRating] ListReputationReviewsRequest complaintMinRating
                     * @property {number|null} [complaintMaxRating] ListReputationReviewsRequest complaintMaxRating
                     * @property {number|null} [companyId] ListReputationReviewsRequest companyId
                     */
    
                    /**
                     * Constructs a new ListReputationReviewsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListReputationReviewsRequest.
                     * @implements IListReputationReviewsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest=} [properties] Properties to set
                     */
                    function ListReputationReviewsRequest(properties) {
                        this.storeIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReputationReviewsRequest storeIds.
                     * @member {Array.<number>} storeIds
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.storeIds = $util.emptyArray;
    
                    /**
                     * ListReputationReviewsRequest startDateId.
                     * @member {number} startDateId
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.startDateId = 0;
    
                    /**
                     * ListReputationReviewsRequest endDateId.
                     * @member {number} endDateId
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.endDateId = 0;
    
                    /**
                     * ListReputationReviewsRequest sortOrder.
                     * @member {palexy.task_management.v1.ListReputationReviewsRequest.SortOrder} sortOrder
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.sortOrder = 0;
    
                    /**
                     * ListReputationReviewsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListReputationReviewsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.pageToken = "";
    
                    /**
                     * ListReputationReviewsRequest complaintMinRating.
                     * @member {number} complaintMinRating
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.complaintMinRating = 0;
    
                    /**
                     * ListReputationReviewsRequest complaintMaxRating.
                     * @member {number} complaintMaxRating
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.complaintMaxRating = 0;
    
                    /**
                     * ListReputationReviewsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     */
                    ListReputationReviewsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListReputationReviewsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListReputationReviewsRequest} ListReputationReviewsRequest instance
                     */
                    ListReputationReviewsRequest.create = function create(properties) {
                        return new ListReputationReviewsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListReputationReviewsRequest message. Does not implicitly {@link palexy.task_management.v1.ListReputationReviewsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest} message ListReputationReviewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReputationReviewsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.storeIds != null && message.storeIds.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.storeIds.length; ++i)
                                writer.int64(message.storeIds[i]);
                            writer.ldelim();
                        }
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.endDateId);
                        if (message.sortOrder != null && Object.hasOwnProperty.call(message, "sortOrder"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.sortOrder);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.complaintMinRating != null && Object.hasOwnProperty.call(message, "complaintMinRating"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.complaintMinRating);
                        if (message.complaintMaxRating != null && Object.hasOwnProperty.call(message, "complaintMaxRating"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.complaintMaxRating);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReputationReviewsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListReputationReviewsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsRequest} message ListReputationReviewsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReputationReviewsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReputationReviewsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListReputationReviewsRequest} ListReputationReviewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReputationReviewsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListReputationReviewsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.storeIds && message.storeIds.length))
                                    message.storeIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.storeIds.push(reader.int64());
                                } else
                                    message.storeIds.push(reader.int64());
                                break;
                            case 2:
                                message.startDateId = reader.int32();
                                break;
                            case 3:
                                message.endDateId = reader.int32();
                                break;
                            case 4:
                                message.sortOrder = reader.int32();
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 7:
                                message.complaintMinRating = reader.int32();
                                break;
                            case 8:
                                message.complaintMaxRating = reader.int32();
                                break;
                            case 9:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReputationReviewsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListReputationReviewsRequest} ListReputationReviewsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReputationReviewsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReputationReviewsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReputationReviewsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.storeIds != null && message.hasOwnProperty("storeIds")) {
                            if (!Array.isArray(message.storeIds))
                                return "storeIds: array expected";
                            for (var i = 0; i < message.storeIds.length; ++i)
                                if (!$util.isInteger(message.storeIds[i]) && !(message.storeIds[i] && $util.isInteger(message.storeIds[i].low) && $util.isInteger(message.storeIds[i].high)))
                                    return "storeIds: integer|Long[] expected";
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isInteger(message.startDateId))
                                return "startDateId: integer expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isInteger(message.endDateId))
                                return "endDateId: integer expected";
                        if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                            switch (message.sortOrder) {
                            default:
                                return "sortOrder: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.complaintMinRating != null && message.hasOwnProperty("complaintMinRating"))
                            if (!$util.isInteger(message.complaintMinRating))
                                return "complaintMinRating: integer expected";
                        if (message.complaintMaxRating != null && message.hasOwnProperty("complaintMaxRating"))
                            if (!$util.isInteger(message.complaintMaxRating))
                                return "complaintMaxRating: integer expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReputationReviewsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListReputationReviewsRequest} ListReputationReviewsRequest
                     */
                    ListReputationReviewsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListReputationReviewsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListReputationReviewsRequest();
                        if (object.storeIds) {
                            if (!Array.isArray(object.storeIds))
                                throw TypeError(".palexy.task_management.v1.ListReputationReviewsRequest.storeIds: array expected");
                            message.storeIds = [];
                            for (var i = 0; i < object.storeIds.length; ++i)
                                if ($util.Long)
                                    (message.storeIds[i] = $util.Long.fromValue(object.storeIds[i])).unsigned = false;
                                else if (typeof object.storeIds[i] === "string")
                                    message.storeIds[i] = parseInt(object.storeIds[i], 10);
                                else if (typeof object.storeIds[i] === "number")
                                    message.storeIds[i] = object.storeIds[i];
                                else if (typeof object.storeIds[i] === "object")
                                    message.storeIds[i] = new $util.LongBits(object.storeIds[i].low >>> 0, object.storeIds[i].high >>> 0).toNumber();
                        }
                        if (object.startDateId != null)
                            message.startDateId = object.startDateId | 0;
                        if (object.endDateId != null)
                            message.endDateId = object.endDateId | 0;
                        switch (object.sortOrder) {
                        case "SORT_ORDER_UNSPECIFIED":
                        case 0:
                            message.sortOrder = 0;
                            break;
                        case "LOWEST_RATING_FIRST":
                        case 1:
                            message.sortOrder = 1;
                            break;
                        case "NEWEST_FIRST":
                        case 2:
                            message.sortOrder = 2;
                            break;
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.complaintMinRating != null)
                            message.complaintMinRating = object.complaintMinRating | 0;
                        if (object.complaintMaxRating != null)
                            message.complaintMaxRating = object.complaintMaxRating | 0;
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReputationReviewsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListReputationReviewsRequest} message ListReputationReviewsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReputationReviewsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.storeIds = [];
                        if (options.defaults) {
                            object.startDateId = 0;
                            object.endDateId = 0;
                            object.sortOrder = options.enums === String ? "SORT_ORDER_UNSPECIFIED" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.complaintMinRating = 0;
                            object.complaintMaxRating = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        }
                        if (message.storeIds && message.storeIds.length) {
                            object.storeIds = [];
                            for (var j = 0; j < message.storeIds.length; ++j)
                                if (typeof message.storeIds[j] === "number")
                                    object.storeIds[j] = options.longs === String ? String(message.storeIds[j]) : message.storeIds[j];
                                else
                                    object.storeIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.storeIds[j]) : options.longs === Number ? new $util.LongBits(message.storeIds[j].low >>> 0, message.storeIds[j].high >>> 0).toNumber() : message.storeIds[j];
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        if (message.sortOrder != null && message.hasOwnProperty("sortOrder"))
                            object.sortOrder = options.enums === String ? $root.palexy.task_management.v1.ListReputationReviewsRequest.SortOrder[message.sortOrder] : message.sortOrder;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.complaintMinRating != null && message.hasOwnProperty("complaintMinRating"))
                            object.complaintMinRating = message.complaintMinRating;
                        if (message.complaintMaxRating != null && message.hasOwnProperty("complaintMaxRating"))
                            object.complaintMaxRating = message.complaintMaxRating;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListReputationReviewsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListReputationReviewsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReputationReviewsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * SortOrder enum.
                     * @name palexy.task_management.v1.ListReputationReviewsRequest.SortOrder
                     * @enum {number}
                     * @property {number} SORT_ORDER_UNSPECIFIED=0 SORT_ORDER_UNSPECIFIED value
                     * @property {number} LOWEST_RATING_FIRST=1 LOWEST_RATING_FIRST value
                     * @property {number} NEWEST_FIRST=2 NEWEST_FIRST value
                     */
                    ListReputationReviewsRequest.SortOrder = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "SORT_ORDER_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "LOWEST_RATING_FIRST"] = 1;
                        values[valuesById[2] = "NEWEST_FIRST"] = 2;
                        return values;
                    })();
    
                    return ListReputationReviewsRequest;
                })();
    
                v1.ReputationReviewItem = (function() {
    
                    /**
                     * Properties of a ReputationReviewItem.
                     * @memberof palexy.task_management.v1
                     * @interface IReputationReviewItem
                     * @property {number|null} [formId] ReputationReviewItem formId
                     * @property {number|null} [submissionId] ReputationReviewItem submissionId
                     * @property {number|null} [storeId] ReputationReviewItem storeId
                     * @property {string|null} [storeName] ReputationReviewItem storeName
                     * @property {boolean|null} [hasRating] ReputationReviewItem hasRating
                     * @property {number|null} [rating] ReputationReviewItem rating
                     * @property {string|null} [reviewText] ReputationReviewItem reviewText
                     * @property {boolean|null} [hasReply] ReputationReviewItem hasReply
                     * @property {string|null} [linkReview] ReputationReviewItem linkReview
                     * @property {number|null} [createdTimeMs] ReputationReviewItem createdTimeMs
                     */
    
                    /**
                     * Constructs a new ReputationReviewItem.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ReputationReviewItem.
                     * @implements IReputationReviewItem
                     * @constructor
                     * @param {palexy.task_management.v1.IReputationReviewItem=} [properties] Properties to set
                     */
                    function ReputationReviewItem(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReputationReviewItem formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReputationReviewItem submissionId.
                     * @member {number} submissionId
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.submissionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReputationReviewItem storeId.
                     * @member {number} storeId
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ReputationReviewItem storeName.
                     * @member {string} storeName
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.storeName = "";
    
                    /**
                     * ReputationReviewItem hasRating.
                     * @member {boolean} hasRating
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.hasRating = false;
    
                    /**
                     * ReputationReviewItem rating.
                     * @member {number} rating
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.rating = 0;
    
                    /**
                     * ReputationReviewItem reviewText.
                     * @member {string} reviewText
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.reviewText = "";
    
                    /**
                     * ReputationReviewItem hasReply.
                     * @member {boolean} hasReply
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.hasReply = false;
    
                    /**
                     * ReputationReviewItem linkReview.
                     * @member {string} linkReview
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.linkReview = "";
    
                    /**
                     * ReputationReviewItem createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     */
                    ReputationReviewItem.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ReputationReviewItem instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {palexy.task_management.v1.IReputationReviewItem=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ReputationReviewItem} ReputationReviewItem instance
                     */
                    ReputationReviewItem.create = function create(properties) {
                        return new ReputationReviewItem(properties);
                    };
    
                    /**
                     * Encodes the specified ReputationReviewItem message. Does not implicitly {@link palexy.task_management.v1.ReputationReviewItem.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {palexy.task_management.v1.IReputationReviewItem} message ReputationReviewItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReputationReviewItem.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.submissionId != null && Object.hasOwnProperty.call(message, "submissionId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.submissionId);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.storeName != null && Object.hasOwnProperty.call(message, "storeName"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.storeName);
                        if (message.hasRating != null && Object.hasOwnProperty.call(message, "hasRating"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.hasRating);
                        if (message.rating != null && Object.hasOwnProperty.call(message, "rating"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.rating);
                        if (message.reviewText != null && Object.hasOwnProperty.call(message, "reviewText"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.reviewText);
                        if (message.hasReply != null && Object.hasOwnProperty.call(message, "hasReply"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.hasReply);
                        if (message.linkReview != null && Object.hasOwnProperty.call(message, "linkReview"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.linkReview);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.createdTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReputationReviewItem message, length delimited. Does not implicitly {@link palexy.task_management.v1.ReputationReviewItem.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {palexy.task_management.v1.IReputationReviewItem} message ReputationReviewItem message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReputationReviewItem.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReputationReviewItem message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ReputationReviewItem} ReputationReviewItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReputationReviewItem.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ReputationReviewItem();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.submissionId = reader.int64();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                message.storeName = reader.string();
                                break;
                            case 5:
                                message.hasRating = reader.bool();
                                break;
                            case 6:
                                message.rating = reader.int32();
                                break;
                            case 7:
                                message.reviewText = reader.string();
                                break;
                            case 8:
                                message.hasReply = reader.bool();
                                break;
                            case 9:
                                message.linkReview = reader.string();
                                break;
                            case 10:
                                message.createdTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReputationReviewItem message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ReputationReviewItem} ReputationReviewItem
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReputationReviewItem.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReputationReviewItem message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReputationReviewItem.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (!$util.isInteger(message.submissionId) && !(message.submissionId && $util.isInteger(message.submissionId.low) && $util.isInteger(message.submissionId.high)))
                                return "submissionId: integer|Long expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            if (!$util.isString(message.storeName))
                                return "storeName: string expected";
                        if (message.hasRating != null && message.hasOwnProperty("hasRating"))
                            if (typeof message.hasRating !== "boolean")
                                return "hasRating: boolean expected";
                        if (message.rating != null && message.hasOwnProperty("rating"))
                            if (!$util.isInteger(message.rating))
                                return "rating: integer expected";
                        if (message.reviewText != null && message.hasOwnProperty("reviewText"))
                            if (!$util.isString(message.reviewText))
                                return "reviewText: string expected";
                        if (message.hasReply != null && message.hasOwnProperty("hasReply"))
                            if (typeof message.hasReply !== "boolean")
                                return "hasReply: boolean expected";
                        if (message.linkReview != null && message.hasOwnProperty("linkReview"))
                            if (!$util.isString(message.linkReview))
                                return "linkReview: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReputationReviewItem message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ReputationReviewItem} ReputationReviewItem
                     */
                    ReputationReviewItem.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ReputationReviewItem)
                            return object;
                        var message = new $root.palexy.task_management.v1.ReputationReviewItem();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.submissionId != null)
                            if ($util.Long)
                                (message.submissionId = $util.Long.fromValue(object.submissionId)).unsigned = false;
                            else if (typeof object.submissionId === "string")
                                message.submissionId = parseInt(object.submissionId, 10);
                            else if (typeof object.submissionId === "number")
                                message.submissionId = object.submissionId;
                            else if (typeof object.submissionId === "object")
                                message.submissionId = new $util.LongBits(object.submissionId.low >>> 0, object.submissionId.high >>> 0).toNumber();
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.storeName != null)
                            message.storeName = String(object.storeName);
                        if (object.hasRating != null)
                            message.hasRating = Boolean(object.hasRating);
                        if (object.rating != null)
                            message.rating = object.rating | 0;
                        if (object.reviewText != null)
                            message.reviewText = String(object.reviewText);
                        if (object.hasReply != null)
                            message.hasReply = Boolean(object.hasReply);
                        if (object.linkReview != null)
                            message.linkReview = String(object.linkReview);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReputationReviewItem message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @static
                     * @param {palexy.task_management.v1.ReputationReviewItem} message ReputationReviewItem
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReputationReviewItem.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.submissionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.submissionId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.storeName = "";
                            object.hasRating = false;
                            object.rating = 0;
                            object.reviewText = "";
                            object.hasReply = false;
                            object.linkReview = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.submissionId != null && message.hasOwnProperty("submissionId"))
                            if (typeof message.submissionId === "number")
                                object.submissionId = options.longs === String ? String(message.submissionId) : message.submissionId;
                            else
                                object.submissionId = options.longs === String ? $util.Long.prototype.toString.call(message.submissionId) : options.longs === Number ? new $util.LongBits(message.submissionId.low >>> 0, message.submissionId.high >>> 0).toNumber() : message.submissionId;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.storeName != null && message.hasOwnProperty("storeName"))
                            object.storeName = message.storeName;
                        if (message.hasRating != null && message.hasOwnProperty("hasRating"))
                            object.hasRating = message.hasRating;
                        if (message.rating != null && message.hasOwnProperty("rating"))
                            object.rating = message.rating;
                        if (message.reviewText != null && message.hasOwnProperty("reviewText"))
                            object.reviewText = message.reviewText;
                        if (message.hasReply != null && message.hasOwnProperty("hasReply"))
                            object.hasReply = message.hasReply;
                        if (message.linkReview != null && message.hasOwnProperty("linkReview"))
                            object.linkReview = message.linkReview;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this ReputationReviewItem to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ReputationReviewItem
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReputationReviewItem.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReputationReviewItem;
                })();
    
                v1.ReputationComplaintTopicStat = (function() {
    
                    /**
                     * Properties of a ReputationComplaintTopicStat.
                     * @memberof palexy.task_management.v1
                     * @interface IReputationComplaintTopicStat
                     * @property {string|null} [topic] ReputationComplaintTopicStat topic
                     * @property {number|null} [reviewCount] ReputationComplaintTopicStat reviewCount
                     */
    
                    /**
                     * Constructs a new ReputationComplaintTopicStat.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ReputationComplaintTopicStat.
                     * @implements IReputationComplaintTopicStat
                     * @constructor
                     * @param {palexy.task_management.v1.IReputationComplaintTopicStat=} [properties] Properties to set
                     */
                    function ReputationComplaintTopicStat(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReputationComplaintTopicStat topic.
                     * @member {string} topic
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @instance
                     */
                    ReputationComplaintTopicStat.prototype.topic = "";
    
                    /**
                     * ReputationComplaintTopicStat reviewCount.
                     * @member {number} reviewCount
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @instance
                     */
                    ReputationComplaintTopicStat.prototype.reviewCount = 0;
    
                    /**
                     * Creates a new ReputationComplaintTopicStat instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {palexy.task_management.v1.IReputationComplaintTopicStat=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ReputationComplaintTopicStat} ReputationComplaintTopicStat instance
                     */
                    ReputationComplaintTopicStat.create = function create(properties) {
                        return new ReputationComplaintTopicStat(properties);
                    };
    
                    /**
                     * Encodes the specified ReputationComplaintTopicStat message. Does not implicitly {@link palexy.task_management.v1.ReputationComplaintTopicStat.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {palexy.task_management.v1.IReputationComplaintTopicStat} message ReputationComplaintTopicStat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReputationComplaintTopicStat.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.topic != null && Object.hasOwnProperty.call(message, "topic"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.topic);
                        if (message.reviewCount != null && Object.hasOwnProperty.call(message, "reviewCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.reviewCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReputationComplaintTopicStat message, length delimited. Does not implicitly {@link palexy.task_management.v1.ReputationComplaintTopicStat.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {palexy.task_management.v1.IReputationComplaintTopicStat} message ReputationComplaintTopicStat message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReputationComplaintTopicStat.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReputationComplaintTopicStat message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ReputationComplaintTopicStat} ReputationComplaintTopicStat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReputationComplaintTopicStat.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ReputationComplaintTopicStat();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.topic = reader.string();
                                break;
                            case 2:
                                message.reviewCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReputationComplaintTopicStat message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ReputationComplaintTopicStat} ReputationComplaintTopicStat
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReputationComplaintTopicStat.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReputationComplaintTopicStat message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReputationComplaintTopicStat.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            if (!$util.isString(message.topic))
                                return "topic: string expected";
                        if (message.reviewCount != null && message.hasOwnProperty("reviewCount"))
                            if (!$util.isInteger(message.reviewCount))
                                return "reviewCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReputationComplaintTopicStat message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ReputationComplaintTopicStat} ReputationComplaintTopicStat
                     */
                    ReputationComplaintTopicStat.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ReputationComplaintTopicStat)
                            return object;
                        var message = new $root.palexy.task_management.v1.ReputationComplaintTopicStat();
                        if (object.topic != null)
                            message.topic = String(object.topic);
                        if (object.reviewCount != null)
                            message.reviewCount = object.reviewCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReputationComplaintTopicStat message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @static
                     * @param {palexy.task_management.v1.ReputationComplaintTopicStat} message ReputationComplaintTopicStat
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReputationComplaintTopicStat.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.topic = "";
                            object.reviewCount = 0;
                        }
                        if (message.topic != null && message.hasOwnProperty("topic"))
                            object.topic = message.topic;
                        if (message.reviewCount != null && message.hasOwnProperty("reviewCount"))
                            object.reviewCount = message.reviewCount;
                        return object;
                    };
    
                    /**
                     * Converts this ReputationComplaintTopicStat to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ReputationComplaintTopicStat
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReputationComplaintTopicStat.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReputationComplaintTopicStat;
                })();
    
                v1.ListReputationReviewsResponse = (function() {
    
                    /**
                     * Properties of a ListReputationReviewsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListReputationReviewsResponse
                     * @property {Array.<palexy.task_management.v1.IReputationReviewItem>|null} [reviews] ListReputationReviewsResponse reviews
                     * @property {number|null} [totalElements] ListReputationReviewsResponse totalElements
                     * @property {string|null} [nextPageToken] ListReputationReviewsResponse nextPageToken
                     * @property {Array.<palexy.task_management.v1.IReputationComplaintTopicStat>|null} [complaintTopics] ListReputationReviewsResponse complaintTopics
                     * @property {number|null} [classifiedReviewCount] ListReputationReviewsResponse classifiedReviewCount
                     */
    
                    /**
                     * Constructs a new ListReputationReviewsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListReputationReviewsResponse.
                     * @implements IListReputationReviewsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListReputationReviewsResponse=} [properties] Properties to set
                     */
                    function ListReputationReviewsResponse(properties) {
                        this.reviews = [];
                        this.complaintTopics = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListReputationReviewsResponse reviews.
                     * @member {Array.<palexy.task_management.v1.IReputationReviewItem>} reviews
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     */
                    ListReputationReviewsResponse.prototype.reviews = $util.emptyArray;
    
                    /**
                     * ListReputationReviewsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     */
                    ListReputationReviewsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListReputationReviewsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     */
                    ListReputationReviewsResponse.prototype.nextPageToken = "";
    
                    /**
                     * ListReputationReviewsResponse complaintTopics.
                     * @member {Array.<palexy.task_management.v1.IReputationComplaintTopicStat>} complaintTopics
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     */
                    ListReputationReviewsResponse.prototype.complaintTopics = $util.emptyArray;
    
                    /**
                     * ListReputationReviewsResponse classifiedReviewCount.
                     * @member {number} classifiedReviewCount
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     */
                    ListReputationReviewsResponse.prototype.classifiedReviewCount = 0;
    
                    /**
                     * Creates a new ListReputationReviewsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListReputationReviewsResponse} ListReputationReviewsResponse instance
                     */
                    ListReputationReviewsResponse.create = function create(properties) {
                        return new ListReputationReviewsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListReputationReviewsResponse message. Does not implicitly {@link palexy.task_management.v1.ListReputationReviewsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsResponse} message ListReputationReviewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReputationReviewsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.reviews != null && message.reviews.length)
                            for (var i = 0; i < message.reviews.length; ++i)
                                $root.palexy.task_management.v1.ReputationReviewItem.encode(message.reviews[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        if (message.complaintTopics != null && message.complaintTopics.length)
                            for (var i = 0; i < message.complaintTopics.length; ++i)
                                $root.palexy.task_management.v1.ReputationComplaintTopicStat.encode(message.complaintTopics[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.classifiedReviewCount != null && Object.hasOwnProperty.call(message, "classifiedReviewCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.classifiedReviewCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListReputationReviewsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListReputationReviewsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListReputationReviewsResponse} message ListReputationReviewsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListReputationReviewsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListReputationReviewsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListReputationReviewsResponse} ListReputationReviewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReputationReviewsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListReputationReviewsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.reviews && message.reviews.length))
                                    message.reviews = [];
                                message.reviews.push($root.palexy.task_management.v1.ReputationReviewItem.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            case 4:
                                if (!(message.complaintTopics && message.complaintTopics.length))
                                    message.complaintTopics = [];
                                message.complaintTopics.push($root.palexy.task_management.v1.ReputationComplaintTopicStat.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.classifiedReviewCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListReputationReviewsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListReputationReviewsResponse} ListReputationReviewsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListReputationReviewsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListReputationReviewsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListReputationReviewsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.reviews != null && message.hasOwnProperty("reviews")) {
                            if (!Array.isArray(message.reviews))
                                return "reviews: array expected";
                            for (var i = 0; i < message.reviews.length; ++i) {
                                var error = $root.palexy.task_management.v1.ReputationReviewItem.verify(message.reviews[i]);
                                if (error)
                                    return "reviews." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        if (message.complaintTopics != null && message.hasOwnProperty("complaintTopics")) {
                            if (!Array.isArray(message.complaintTopics))
                                return "complaintTopics: array expected";
                            for (var i = 0; i < message.complaintTopics.length; ++i) {
                                var error = $root.palexy.task_management.v1.ReputationComplaintTopicStat.verify(message.complaintTopics[i]);
                                if (error)
                                    return "complaintTopics." + error;
                            }
                        }
                        if (message.classifiedReviewCount != null && message.hasOwnProperty("classifiedReviewCount"))
                            if (!$util.isInteger(message.classifiedReviewCount))
                                return "classifiedReviewCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListReputationReviewsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListReputationReviewsResponse} ListReputationReviewsResponse
                     */
                    ListReputationReviewsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListReputationReviewsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListReputationReviewsResponse();
                        if (object.reviews) {
                            if (!Array.isArray(object.reviews))
                                throw TypeError(".palexy.task_management.v1.ListReputationReviewsResponse.reviews: array expected");
                            message.reviews = [];
                            for (var i = 0; i < object.reviews.length; ++i) {
                                if (typeof object.reviews[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListReputationReviewsResponse.reviews: object expected");
                                message.reviews[i] = $root.palexy.task_management.v1.ReputationReviewItem.fromObject(object.reviews[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        if (object.complaintTopics) {
                            if (!Array.isArray(object.complaintTopics))
                                throw TypeError(".palexy.task_management.v1.ListReputationReviewsResponse.complaintTopics: array expected");
                            message.complaintTopics = [];
                            for (var i = 0; i < object.complaintTopics.length; ++i) {
                                if (typeof object.complaintTopics[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListReputationReviewsResponse.complaintTopics: object expected");
                                message.complaintTopics[i] = $root.palexy.task_management.v1.ReputationComplaintTopicStat.fromObject(object.complaintTopics[i]);
                            }
                        }
                        if (object.classifiedReviewCount != null)
                            message.classifiedReviewCount = object.classifiedReviewCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListReputationReviewsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListReputationReviewsResponse} message ListReputationReviewsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListReputationReviewsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.reviews = [];
                            object.complaintTopics = [];
                        }
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                            object.classifiedReviewCount = 0;
                        }
                        if (message.reviews && message.reviews.length) {
                            object.reviews = [];
                            for (var j = 0; j < message.reviews.length; ++j)
                                object.reviews[j] = $root.palexy.task_management.v1.ReputationReviewItem.toObject(message.reviews[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        if (message.complaintTopics && message.complaintTopics.length) {
                            object.complaintTopics = [];
                            for (var j = 0; j < message.complaintTopics.length; ++j)
                                object.complaintTopics[j] = $root.palexy.task_management.v1.ReputationComplaintTopicStat.toObject(message.complaintTopics[j], options);
                        }
                        if (message.classifiedReviewCount != null && message.hasOwnProperty("classifiedReviewCount"))
                            object.classifiedReviewCount = message.classifiedReviewCount;
                        return object;
                    };
    
                    /**
                     * Converts this ListReputationReviewsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListReputationReviewsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListReputationReviewsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListReputationReviewsResponse;
                })();
    
                v1.ProcessReviewSyncJobResponse = (function() {
    
                    /**
                     * Properties of a ProcessReviewSyncJobResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IProcessReviewSyncJobResponse
                     */
    
                    /**
                     * Constructs a new ProcessReviewSyncJobResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ProcessReviewSyncJobResponse.
                     * @implements IProcessReviewSyncJobResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobResponse=} [properties] Properties to set
                     */
                    function ProcessReviewSyncJobResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Creates a new ProcessReviewSyncJobResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobResponse} ProcessReviewSyncJobResponse instance
                     */
                    ProcessReviewSyncJobResponse.create = function create(properties) {
                        return new ProcessReviewSyncJobResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ProcessReviewSyncJobResponse message. Does not implicitly {@link palexy.task_management.v1.ProcessReviewSyncJobResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobResponse} message ProcessReviewSyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessReviewSyncJobResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ProcessReviewSyncJobResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ProcessReviewSyncJobResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {palexy.task_management.v1.IProcessReviewSyncJobResponse} message ProcessReviewSyncJobResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ProcessReviewSyncJobResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ProcessReviewSyncJobResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobResponse} ProcessReviewSyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessReviewSyncJobResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ProcessReviewSyncJobResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ProcessReviewSyncJobResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobResponse} ProcessReviewSyncJobResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ProcessReviewSyncJobResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ProcessReviewSyncJobResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ProcessReviewSyncJobResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        return null;
                    };
    
                    /**
                     * Creates a ProcessReviewSyncJobResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ProcessReviewSyncJobResponse} ProcessReviewSyncJobResponse
                     */
                    ProcessReviewSyncJobResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ProcessReviewSyncJobResponse)
                            return object;
                        return new $root.palexy.task_management.v1.ProcessReviewSyncJobResponse();
                    };
    
                    /**
                     * Creates a plain object from a ProcessReviewSyncJobResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @static
                     * @param {palexy.task_management.v1.ProcessReviewSyncJobResponse} message ProcessReviewSyncJobResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ProcessReviewSyncJobResponse.toObject = function toObject() {
                        return {};
                    };
    
                    /**
                     * Converts this ProcessReviewSyncJobResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ProcessReviewSyncJobResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ProcessReviewSyncJobResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ProcessReviewSyncJobResponse;
                })();
    
                /**
                 * FormContactListSource enum.
                 * @name palexy.task_management.v1.FormContactListSource
                 * @enum {number}
                 * @property {number} FORM_CONTACT_LIST_SOURCE_UNSPECIFIED=0 FORM_CONTACT_LIST_SOURCE_UNSPECIFIED value
                 * @property {number} FILE_UPLOAD=1 FILE_UPLOAD value
                 * @property {number} API=2 API value
                 */
                v1.FormContactListSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "FORM_CONTACT_LIST_SOURCE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "FILE_UPLOAD"] = 1;
                    values[valuesById[2] = "API"] = 2;
                    return values;
                })();
    
                /**
                 * NpsScale enum.
                 * @name palexy.task_management.v1.NpsScale
                 * @enum {number}
                 * @property {number} NPS_SCALE_UNSPECIFIED=0 NPS_SCALE_UNSPECIFIED value
                 * @property {number} ZERO_TO_TEN=1 ZERO_TO_TEN value
                 * @property {number} ONE_TO_FIVE=2 ONE_TO_FIVE value
                 */
                v1.NpsScale = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "NPS_SCALE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "ZERO_TO_TEN"] = 1;
                    values[valuesById[2] = "ONE_TO_FIVE"] = 2;
                    return values;
                })();
    
                v1.CrosstabService = (function() {
    
                    /**
                     * Constructs a new CrosstabService service.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CrosstabService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CrosstabService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CrosstabService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CrosstabService;
    
                    /**
                     * Creates new CrosstabService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CrosstabService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CrosstabService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#listCrosstabs}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef ListCrosstabsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListCrosstabsResponse} [response] ListCrosstabsResponse
                     */
    
                    /**
                     * Calls ListCrosstabs.
                     * @function listCrosstabs
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IListCrosstabsRequest} request ListCrosstabsRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.ListCrosstabsCallback} callback Node-style callback called with the error, if any, and ListCrosstabsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.listCrosstabs = function listCrosstabs(request, callback) {
                        return this.rpcCall(listCrosstabs, $root.palexy.task_management.v1.ListCrosstabsRequest, $root.palexy.task_management.v1.ListCrosstabsResponse, request, callback);
                    }, "name", { value: "ListCrosstabs" });
    
                    /**
                     * Calls ListCrosstabs.
                     * @function listCrosstabs
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IListCrosstabsRequest} request ListCrosstabsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListCrosstabsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#createCrosstab}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef CreateCrosstabCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Crosstab} [response] Crosstab
                     */
    
                    /**
                     * Calls CreateCrosstab.
                     * @function createCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest} request CreateCrosstabRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.CreateCrosstabCallback} callback Node-style callback called with the error, if any, and Crosstab
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.createCrosstab = function createCrosstab(request, callback) {
                        return this.rpcCall(createCrosstab, $root.palexy.task_management.v1.CreateCrosstabRequest, $root.palexy.task_management.v1.Crosstab, request, callback);
                    }, "name", { value: "CreateCrosstab" });
    
                    /**
                     * Calls CreateCrosstab.
                     * @function createCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest} request CreateCrosstabRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Crosstab>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#getCrosstab}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef GetCrosstabCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Crosstab} [response] Crosstab
                     */
    
                    /**
                     * Calls GetCrosstab.
                     * @function getCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCrosstabRequest} request GetCrosstabRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.GetCrosstabCallback} callback Node-style callback called with the error, if any, and Crosstab
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.getCrosstab = function getCrosstab(request, callback) {
                        return this.rpcCall(getCrosstab, $root.palexy.task_management.v1.GetCrosstabRequest, $root.palexy.task_management.v1.Crosstab, request, callback);
                    }, "name", { value: "GetCrosstab" });
    
                    /**
                     * Calls GetCrosstab.
                     * @function getCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCrosstabRequest} request GetCrosstabRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Crosstab>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#updateCrosstab}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef UpdateCrosstabCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.Crosstab} [response] Crosstab
                     */
    
                    /**
                     * Calls UpdateCrosstab.
                     * @function updateCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest} request UpdateCrosstabRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.UpdateCrosstabCallback} callback Node-style callback called with the error, if any, and Crosstab
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.updateCrosstab = function updateCrosstab(request, callback) {
                        return this.rpcCall(updateCrosstab, $root.palexy.task_management.v1.UpdateCrosstabRequest, $root.palexy.task_management.v1.Crosstab, request, callback);
                    }, "name", { value: "UpdateCrosstab" });
    
                    /**
                     * Calls UpdateCrosstab.
                     * @function updateCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest} request UpdateCrosstabRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.Crosstab>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#deleteCrosstab}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef DeleteCrosstabCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteCrosstab.
                     * @function deleteCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest} request DeleteCrosstabRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.DeleteCrosstabCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.deleteCrosstab = function deleteCrosstab(request, callback) {
                        return this.rpcCall(deleteCrosstab, $root.palexy.task_management.v1.DeleteCrosstabRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteCrosstab" });
    
                    /**
                     * Calls DeleteCrosstab.
                     * @function deleteCrosstab
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest} request DeleteCrosstabRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#getCrosstabTables}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef GetCrosstabTablesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.GetCrosstabTablesResponse} [response] GetCrosstabTablesResponse
                     */
    
                    /**
                     * Calls GetCrosstabTables.
                     * @function getCrosstabTables
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest} request GetCrosstabTablesRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.GetCrosstabTablesCallback} callback Node-style callback called with the error, if any, and GetCrosstabTablesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.getCrosstabTables = function getCrosstabTables(request, callback) {
                        return this.rpcCall(getCrosstabTables, $root.palexy.task_management.v1.GetCrosstabTablesRequest, $root.palexy.task_management.v1.GetCrosstabTablesResponse, request, callback);
                    }, "name", { value: "GetCrosstabTables" });
    
                    /**
                     * Calls GetCrosstabTables.
                     * @function getCrosstabTables
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest} request GetCrosstabTablesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.GetCrosstabTablesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CrosstabService#listAnalysisVariables}.
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @typedef ListAnalysisVariablesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListAnalysisVariablesResponse} [response] ListAnalysisVariablesResponse
                     */
    
                    /**
                     * Calls ListAnalysisVariables.
                     * @function listAnalysisVariables
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest} request ListAnalysisVariablesRequest message or plain object
                     * @param {palexy.task_management.v1.CrosstabService.ListAnalysisVariablesCallback} callback Node-style callback called with the error, if any, and ListAnalysisVariablesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CrosstabService.prototype.listAnalysisVariables = function listAnalysisVariables(request, callback) {
                        return this.rpcCall(listAnalysisVariables, $root.palexy.task_management.v1.ListAnalysisVariablesRequest, $root.palexy.task_management.v1.ListAnalysisVariablesResponse, request, callback);
                    }, "name", { value: "ListAnalysisVariables" });
    
                    /**
                     * Calls ListAnalysisVariables.
                     * @function listAnalysisVariables
                     * @memberof palexy.task_management.v1.CrosstabService
                     * @instance
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest} request ListAnalysisVariablesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListAnalysisVariablesResponse>} Promise
                     * @variation 2
                     */
    
                    return CrosstabService;
                })();
    
                v1.Crosstab = (function() {
    
                    /**
                     * Properties of a Crosstab.
                     * @memberof palexy.task_management.v1
                     * @interface ICrosstab
                     * @property {number|null} [id] Crosstab id
                     * @property {number|null} [formId] Crosstab formId
                     * @property {string|null} [name] Crosstab name
                     * @property {palexy.task_management.v1.ICrosstabConfig|null} [config] Crosstab config
                     * @property {number|null} [createdTimeMs] Crosstab createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] Crosstab lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new Crosstab.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a Crosstab.
                     * @implements ICrosstab
                     * @constructor
                     * @param {palexy.task_management.v1.ICrosstab=} [properties] Properties to set
                     */
                    function Crosstab(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Crosstab id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Crosstab formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Crosstab name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.name = "";
    
                    /**
                     * Crosstab config.
                     * @member {palexy.task_management.v1.ICrosstabConfig|null|undefined} config
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.config = null;
    
                    /**
                     * Crosstab createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Crosstab lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     */
                    Crosstab.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new Crosstab instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {palexy.task_management.v1.ICrosstab=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.Crosstab} Crosstab instance
                     */
                    Crosstab.create = function create(properties) {
                        return new Crosstab(properties);
                    };
    
                    /**
                     * Encodes the specified Crosstab message. Does not implicitly {@link palexy.task_management.v1.Crosstab.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {palexy.task_management.v1.ICrosstab} message Crosstab message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Crosstab.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.formId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.config != null && Object.hasOwnProperty.call(message, "config"))
                            $root.palexy.task_management.v1.CrosstabConfig.encode(message.config, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Crosstab message, length delimited. Does not implicitly {@link palexy.task_management.v1.Crosstab.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {palexy.task_management.v1.ICrosstab} message Crosstab message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Crosstab.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Crosstab message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.Crosstab} Crosstab
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Crosstab.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.Crosstab();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.formId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.config = $root.palexy.task_management.v1.CrosstabConfig.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 6:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Crosstab message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.Crosstab} Crosstab
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Crosstab.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Crosstab message.
                     * @function verify
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Crosstab.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.config != null && message.hasOwnProperty("config")) {
                            var error = $root.palexy.task_management.v1.CrosstabConfig.verify(message.config);
                            if (error)
                                return "config." + error;
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a Crosstab message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.Crosstab} Crosstab
                     */
                    Crosstab.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.Crosstab)
                            return object;
                        var message = new $root.palexy.task_management.v1.Crosstab();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.config != null) {
                            if (typeof object.config !== "object")
                                throw TypeError(".palexy.task_management.v1.Crosstab.config: object expected");
                            message.config = $root.palexy.task_management.v1.CrosstabConfig.fromObject(object.config);
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Crosstab message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.Crosstab
                     * @static
                     * @param {palexy.task_management.v1.Crosstab} message Crosstab
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Crosstab.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.config = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.config != null && message.hasOwnProperty("config"))
                            object.config = $root.palexy.task_management.v1.CrosstabConfig.toObject(message.config, options);
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this Crosstab to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.Crosstab
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Crosstab.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Crosstab;
                })();
    
                v1.VariableRef = (function() {
    
                    /**
                     * Properties of a VariableRef.
                     * @memberof palexy.task_management.v1
                     * @interface IVariableRef
                     * @property {palexy.task_management.v1.VariableRef.VariableSourceType|null} [sourceType] VariableRef sourceType
                     * @property {string|null} [variableKey] VariableRef variableKey
                     */
    
                    /**
                     * Constructs a new VariableRef.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a VariableRef.
                     * @implements IVariableRef
                     * @constructor
                     * @param {palexy.task_management.v1.IVariableRef=} [properties] Properties to set
                     */
                    function VariableRef(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * VariableRef sourceType.
                     * @member {palexy.task_management.v1.VariableRef.VariableSourceType} sourceType
                     * @memberof palexy.task_management.v1.VariableRef
                     * @instance
                     */
                    VariableRef.prototype.sourceType = 0;
    
                    /**
                     * VariableRef variableKey.
                     * @member {string} variableKey
                     * @memberof palexy.task_management.v1.VariableRef
                     * @instance
                     */
                    VariableRef.prototype.variableKey = "";
    
                    /**
                     * Creates a new VariableRef instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {palexy.task_management.v1.IVariableRef=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.VariableRef} VariableRef instance
                     */
                    VariableRef.create = function create(properties) {
                        return new VariableRef(properties);
                    };
    
                    /**
                     * Encodes the specified VariableRef message. Does not implicitly {@link palexy.task_management.v1.VariableRef.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {palexy.task_management.v1.IVariableRef} message VariableRef message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VariableRef.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.sourceType != null && Object.hasOwnProperty.call(message, "sourceType"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.sourceType);
                        if (message.variableKey != null && Object.hasOwnProperty.call(message, "variableKey"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.variableKey);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified VariableRef message, length delimited. Does not implicitly {@link palexy.task_management.v1.VariableRef.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {palexy.task_management.v1.IVariableRef} message VariableRef message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    VariableRef.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a VariableRef message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.VariableRef} VariableRef
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VariableRef.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.VariableRef();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.sourceType = reader.int32();
                                break;
                            case 2:
                                message.variableKey = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a VariableRef message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.VariableRef} VariableRef
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    VariableRef.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a VariableRef message.
                     * @function verify
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    VariableRef.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                            switch (message.sourceType) {
                            default:
                                return "sourceType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.variableKey != null && message.hasOwnProperty("variableKey"))
                            if (!$util.isString(message.variableKey))
                                return "variableKey: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a VariableRef message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.VariableRef} VariableRef
                     */
                    VariableRef.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.VariableRef)
                            return object;
                        var message = new $root.palexy.task_management.v1.VariableRef();
                        switch (object.sourceType) {
                        case "VARIABLE_SOURCE_TYPE_UNSPECIFIED":
                        case 0:
                            message.sourceType = 0;
                            break;
                        case "QUESTION":
                        case 1:
                            message.sourceType = 1;
                            break;
                        case "CUSTOM_ATTRIBUTE":
                        case 2:
                            message.sourceType = 2;
                            break;
                        case "NPS":
                        case 3:
                            message.sourceType = 3;
                            break;
                        }
                        if (object.variableKey != null)
                            message.variableKey = String(object.variableKey);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a VariableRef message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.VariableRef
                     * @static
                     * @param {palexy.task_management.v1.VariableRef} message VariableRef
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    VariableRef.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.sourceType = options.enums === String ? "VARIABLE_SOURCE_TYPE_UNSPECIFIED" : 0;
                            object.variableKey = "";
                        }
                        if (message.sourceType != null && message.hasOwnProperty("sourceType"))
                            object.sourceType = options.enums === String ? $root.palexy.task_management.v1.VariableRef.VariableSourceType[message.sourceType] : message.sourceType;
                        if (message.variableKey != null && message.hasOwnProperty("variableKey"))
                            object.variableKey = message.variableKey;
                        return object;
                    };
    
                    /**
                     * Converts this VariableRef to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.VariableRef
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    VariableRef.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * VariableSourceType enum.
                     * @name palexy.task_management.v1.VariableRef.VariableSourceType
                     * @enum {number}
                     * @property {number} VARIABLE_SOURCE_TYPE_UNSPECIFIED=0 VARIABLE_SOURCE_TYPE_UNSPECIFIED value
                     * @property {number} QUESTION=1 QUESTION value
                     * @property {number} CUSTOM_ATTRIBUTE=2 CUSTOM_ATTRIBUTE value
                     * @property {number} NPS=3 NPS value
                     */
                    VariableRef.VariableSourceType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "VARIABLE_SOURCE_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "QUESTION"] = 1;
                        values[valuesById[2] = "CUSTOM_ATTRIBUTE"] = 2;
                        values[valuesById[3] = "NPS"] = 3;
                        return values;
                    })();
    
                    return VariableRef;
                })();
    
                v1.ValueTypeSelection = (function() {
    
                    /**
                     * Properties of a ValueTypeSelection.
                     * @memberof palexy.task_management.v1
                     * @interface IValueTypeSelection
                     * @property {Array.<palexy.task_management.v1.ValueTypeSelection.ValueType>|null} [types] ValueTypeSelection types
                     * @property {palexy.task_management.v1.ISignificanceSettings|null} [significance] ValueTypeSelection significance
                     */
    
                    /**
                     * Constructs a new ValueTypeSelection.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ValueTypeSelection.
                     * @implements IValueTypeSelection
                     * @constructor
                     * @param {palexy.task_management.v1.IValueTypeSelection=} [properties] Properties to set
                     */
                    function ValueTypeSelection(properties) {
                        this.types = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ValueTypeSelection types.
                     * @member {Array.<palexy.task_management.v1.ValueTypeSelection.ValueType>} types
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @instance
                     */
                    ValueTypeSelection.prototype.types = $util.emptyArray;
    
                    /**
                     * ValueTypeSelection significance.
                     * @member {palexy.task_management.v1.ISignificanceSettings|null|undefined} significance
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @instance
                     */
                    ValueTypeSelection.prototype.significance = null;
    
                    /**
                     * Creates a new ValueTypeSelection instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {palexy.task_management.v1.IValueTypeSelection=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ValueTypeSelection} ValueTypeSelection instance
                     */
                    ValueTypeSelection.create = function create(properties) {
                        return new ValueTypeSelection(properties);
                    };
    
                    /**
                     * Encodes the specified ValueTypeSelection message. Does not implicitly {@link palexy.task_management.v1.ValueTypeSelection.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {palexy.task_management.v1.IValueTypeSelection} message ValueTypeSelection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValueTypeSelection.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.types != null && message.types.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.types.length; ++i)
                                writer.int32(message.types[i]);
                            writer.ldelim();
                        }
                        if (message.significance != null && Object.hasOwnProperty.call(message, "significance"))
                            $root.palexy.task_management.v1.SignificanceSettings.encode(message.significance, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ValueTypeSelection message, length delimited. Does not implicitly {@link palexy.task_management.v1.ValueTypeSelection.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {palexy.task_management.v1.IValueTypeSelection} message ValueTypeSelection message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ValueTypeSelection.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ValueTypeSelection message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ValueTypeSelection} ValueTypeSelection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValueTypeSelection.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ValueTypeSelection();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.types && message.types.length))
                                    message.types = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.types.push(reader.int32());
                                } else
                                    message.types.push(reader.int32());
                                break;
                            case 2:
                                message.significance = $root.palexy.task_management.v1.SignificanceSettings.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ValueTypeSelection message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ValueTypeSelection} ValueTypeSelection
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ValueTypeSelection.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ValueTypeSelection message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ValueTypeSelection.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.types != null && message.hasOwnProperty("types")) {
                            if (!Array.isArray(message.types))
                                return "types: array expected";
                            for (var i = 0; i < message.types.length; ++i)
                                switch (message.types[i]) {
                                default:
                                    return "types: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        if (message.significance != null && message.hasOwnProperty("significance")) {
                            var error = $root.palexy.task_management.v1.SignificanceSettings.verify(message.significance);
                            if (error)
                                return "significance." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ValueTypeSelection message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ValueTypeSelection} ValueTypeSelection
                     */
                    ValueTypeSelection.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ValueTypeSelection)
                            return object;
                        var message = new $root.palexy.task_management.v1.ValueTypeSelection();
                        if (object.types) {
                            if (!Array.isArray(object.types))
                                throw TypeError(".palexy.task_management.v1.ValueTypeSelection.types: array expected");
                            message.types = [];
                            for (var i = 0; i < object.types.length; ++i)
                                switch (object.types[i]) {
                                default:
                                case "VALUE_TYPE_UNSPECIFIED":
                                case 0:
                                    message.types[i] = 0;
                                    break;
                                case "TOTAL_COUNT":
                                case 1:
                                    message.types[i] = 1;
                                    break;
                                case "COUNT":
                                case 2:
                                    message.types[i] = 2;
                                    break;
                                case "COLUMN_PERCENT_ALL":
                                case 3:
                                    message.types[i] = 3;
                                    break;
                                case "COLUMN_PERCENT_ANSWERING":
                                case 4:
                                    message.types[i] = 4;
                                    break;
                                }
                        }
                        if (object.significance != null) {
                            if (typeof object.significance !== "object")
                                throw TypeError(".palexy.task_management.v1.ValueTypeSelection.significance: object expected");
                            message.significance = $root.palexy.task_management.v1.SignificanceSettings.fromObject(object.significance);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ValueTypeSelection message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @static
                     * @param {palexy.task_management.v1.ValueTypeSelection} message ValueTypeSelection
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ValueTypeSelection.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.types = [];
                        if (options.defaults)
                            object.significance = null;
                        if (message.types && message.types.length) {
                            object.types = [];
                            for (var j = 0; j < message.types.length; ++j)
                                object.types[j] = options.enums === String ? $root.palexy.task_management.v1.ValueTypeSelection.ValueType[message.types[j]] : message.types[j];
                        }
                        if (message.significance != null && message.hasOwnProperty("significance"))
                            object.significance = $root.palexy.task_management.v1.SignificanceSettings.toObject(message.significance, options);
                        return object;
                    };
    
                    /**
                     * Converts this ValueTypeSelection to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ValueTypeSelection
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ValueTypeSelection.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * ValueType enum.
                     * @name palexy.task_management.v1.ValueTypeSelection.ValueType
                     * @enum {number}
                     * @property {number} VALUE_TYPE_UNSPECIFIED=0 VALUE_TYPE_UNSPECIFIED value
                     * @property {number} TOTAL_COUNT=1 TOTAL_COUNT value
                     * @property {number} COUNT=2 COUNT value
                     * @property {number} COLUMN_PERCENT_ALL=3 COLUMN_PERCENT_ALL value
                     * @property {number} COLUMN_PERCENT_ANSWERING=4 COLUMN_PERCENT_ANSWERING value
                     */
                    ValueTypeSelection.ValueType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "VALUE_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "TOTAL_COUNT"] = 1;
                        values[valuesById[2] = "COUNT"] = 2;
                        values[valuesById[3] = "COLUMN_PERCENT_ALL"] = 3;
                        values[valuesById[4] = "COLUMN_PERCENT_ANSWERING"] = 4;
                        return values;
                    })();
    
                    return ValueTypeSelection;
                })();
    
                v1.SignificanceSettings = (function() {
    
                    /**
                     * Properties of a SignificanceSettings.
                     * @memberof palexy.task_management.v1
                     * @interface ISignificanceSettings
                     * @property {boolean|null} [enabled] SignificanceSettings enabled
                     * @property {Array.<palexy.task_management.v1.ValueTypeSelection.ValueType>|null} [appliesTo] SignificanceSettings appliesTo
                     * @property {number|null} [confidenceLevelPercent] SignificanceSettings confidenceLevelPercent
                     */
    
                    /**
                     * Constructs a new SignificanceSettings.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SignificanceSettings.
                     * @implements ISignificanceSettings
                     * @constructor
                     * @param {palexy.task_management.v1.ISignificanceSettings=} [properties] Properties to set
                     */
                    function SignificanceSettings(properties) {
                        this.appliesTo = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SignificanceSettings enabled.
                     * @member {boolean} enabled
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @instance
                     */
                    SignificanceSettings.prototype.enabled = false;
    
                    /**
                     * SignificanceSettings appliesTo.
                     * @member {Array.<palexy.task_management.v1.ValueTypeSelection.ValueType>} appliesTo
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @instance
                     */
                    SignificanceSettings.prototype.appliesTo = $util.emptyArray;
    
                    /**
                     * SignificanceSettings confidenceLevelPercent.
                     * @member {number} confidenceLevelPercent
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @instance
                     */
                    SignificanceSettings.prototype.confidenceLevelPercent = 0;
    
                    /**
                     * Creates a new SignificanceSettings instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {palexy.task_management.v1.ISignificanceSettings=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SignificanceSettings} SignificanceSettings instance
                     */
                    SignificanceSettings.create = function create(properties) {
                        return new SignificanceSettings(properties);
                    };
    
                    /**
                     * Encodes the specified SignificanceSettings message. Does not implicitly {@link palexy.task_management.v1.SignificanceSettings.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {palexy.task_management.v1.ISignificanceSettings} message SignificanceSettings message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SignificanceSettings.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.enabled != null && Object.hasOwnProperty.call(message, "enabled"))
                            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.enabled);
                        if (message.appliesTo != null && message.appliesTo.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.appliesTo.length; ++i)
                                writer.int32(message.appliesTo[i]);
                            writer.ldelim();
                        }
                        if (message.confidenceLevelPercent != null && Object.hasOwnProperty.call(message, "confidenceLevelPercent"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.confidenceLevelPercent);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SignificanceSettings message, length delimited. Does not implicitly {@link palexy.task_management.v1.SignificanceSettings.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {palexy.task_management.v1.ISignificanceSettings} message SignificanceSettings message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SignificanceSettings.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SignificanceSettings message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SignificanceSettings} SignificanceSettings
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SignificanceSettings.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SignificanceSettings();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.enabled = reader.bool();
                                break;
                            case 2:
                                if (!(message.appliesTo && message.appliesTo.length))
                                    message.appliesTo = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.appliesTo.push(reader.int32());
                                } else
                                    message.appliesTo.push(reader.int32());
                                break;
                            case 3:
                                message.confidenceLevelPercent = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SignificanceSettings message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SignificanceSettings} SignificanceSettings
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SignificanceSettings.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SignificanceSettings message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SignificanceSettings.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            if (typeof message.enabled !== "boolean")
                                return "enabled: boolean expected";
                        if (message.appliesTo != null && message.hasOwnProperty("appliesTo")) {
                            if (!Array.isArray(message.appliesTo))
                                return "appliesTo: array expected";
                            for (var i = 0; i < message.appliesTo.length; ++i)
                                switch (message.appliesTo[i]) {
                                default:
                                    return "appliesTo: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                    break;
                                }
                        }
                        if (message.confidenceLevelPercent != null && message.hasOwnProperty("confidenceLevelPercent"))
                            if (!$util.isInteger(message.confidenceLevelPercent))
                                return "confidenceLevelPercent: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a SignificanceSettings message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SignificanceSettings} SignificanceSettings
                     */
                    SignificanceSettings.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SignificanceSettings)
                            return object;
                        var message = new $root.palexy.task_management.v1.SignificanceSettings();
                        if (object.enabled != null)
                            message.enabled = Boolean(object.enabled);
                        if (object.appliesTo) {
                            if (!Array.isArray(object.appliesTo))
                                throw TypeError(".palexy.task_management.v1.SignificanceSettings.appliesTo: array expected");
                            message.appliesTo = [];
                            for (var i = 0; i < object.appliesTo.length; ++i)
                                switch (object.appliesTo[i]) {
                                default:
                                case "VALUE_TYPE_UNSPECIFIED":
                                case 0:
                                    message.appliesTo[i] = 0;
                                    break;
                                case "TOTAL_COUNT":
                                case 1:
                                    message.appliesTo[i] = 1;
                                    break;
                                case "COUNT":
                                case 2:
                                    message.appliesTo[i] = 2;
                                    break;
                                case "COLUMN_PERCENT_ALL":
                                case 3:
                                    message.appliesTo[i] = 3;
                                    break;
                                case "COLUMN_PERCENT_ANSWERING":
                                case 4:
                                    message.appliesTo[i] = 4;
                                    break;
                                }
                        }
                        if (object.confidenceLevelPercent != null)
                            message.confidenceLevelPercent = object.confidenceLevelPercent | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SignificanceSettings message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @static
                     * @param {palexy.task_management.v1.SignificanceSettings} message SignificanceSettings
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SignificanceSettings.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.appliesTo = [];
                        if (options.defaults) {
                            object.enabled = false;
                            object.confidenceLevelPercent = 0;
                        }
                        if (message.enabled != null && message.hasOwnProperty("enabled"))
                            object.enabled = message.enabled;
                        if (message.appliesTo && message.appliesTo.length) {
                            object.appliesTo = [];
                            for (var j = 0; j < message.appliesTo.length; ++j)
                                object.appliesTo[j] = options.enums === String ? $root.palexy.task_management.v1.ValueTypeSelection.ValueType[message.appliesTo[j]] : message.appliesTo[j];
                        }
                        if (message.confidenceLevelPercent != null && message.hasOwnProperty("confidenceLevelPercent"))
                            object.confidenceLevelPercent = message.confidenceLevelPercent;
                        return object;
                    };
    
                    /**
                     * Converts this SignificanceSettings to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SignificanceSettings
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SignificanceSettings.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SignificanceSettings;
                })();
    
                v1.CrosstabFilter = (function() {
    
                    /**
                     * Properties of a CrosstabFilter.
                     * @memberof palexy.task_management.v1
                     * @interface ICrosstabFilter
                     * @property {Array.<palexy.task_management.v1.IFilterCondition>|null} [conditions] CrosstabFilter conditions
                     * @property {string|null} [startDateId] CrosstabFilter startDateId
                     * @property {string|null} [endDateId] CrosstabFilter endDateId
                     */
    
                    /**
                     * Constructs a new CrosstabFilter.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CrosstabFilter.
                     * @implements ICrosstabFilter
                     * @constructor
                     * @param {palexy.task_management.v1.ICrosstabFilter=} [properties] Properties to set
                     */
                    function CrosstabFilter(properties) {
                        this.conditions = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrosstabFilter conditions.
                     * @member {Array.<palexy.task_management.v1.IFilterCondition>} conditions
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @instance
                     */
                    CrosstabFilter.prototype.conditions = $util.emptyArray;
    
                    /**
                     * CrosstabFilter startDateId.
                     * @member {string} startDateId
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @instance
                     */
                    CrosstabFilter.prototype.startDateId = "";
    
                    /**
                     * CrosstabFilter endDateId.
                     * @member {string} endDateId
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @instance
                     */
                    CrosstabFilter.prototype.endDateId = "";
    
                    /**
                     * Creates a new CrosstabFilter instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabFilter=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CrosstabFilter} CrosstabFilter instance
                     */
                    CrosstabFilter.create = function create(properties) {
                        return new CrosstabFilter(properties);
                    };
    
                    /**
                     * Encodes the specified CrosstabFilter message. Does not implicitly {@link palexy.task_management.v1.CrosstabFilter.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabFilter} message CrosstabFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabFilter.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.conditions != null && message.conditions.length)
                            for (var i = 0; i < message.conditions.length; ++i)
                                $root.palexy.task_management.v1.FilterCondition.encode(message.conditions[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.startDateId != null && Object.hasOwnProperty.call(message, "startDateId"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.startDateId);
                        if (message.endDateId != null && Object.hasOwnProperty.call(message, "endDateId"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.endDateId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrosstabFilter message, length delimited. Does not implicitly {@link palexy.task_management.v1.CrosstabFilter.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabFilter} message CrosstabFilter message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabFilter.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrosstabFilter message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CrosstabFilter} CrosstabFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabFilter.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CrosstabFilter();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.conditions && message.conditions.length))
                                    message.conditions = [];
                                message.conditions.push($root.palexy.task_management.v1.FilterCondition.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.startDateId = reader.string();
                                break;
                            case 3:
                                message.endDateId = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrosstabFilter message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CrosstabFilter} CrosstabFilter
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabFilter.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrosstabFilter message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrosstabFilter.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.conditions != null && message.hasOwnProperty("conditions")) {
                            if (!Array.isArray(message.conditions))
                                return "conditions: array expected";
                            for (var i = 0; i < message.conditions.length; ++i) {
                                var error = $root.palexy.task_management.v1.FilterCondition.verify(message.conditions[i]);
                                if (error)
                                    return "conditions." + error;
                            }
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            if (!$util.isString(message.startDateId))
                                return "startDateId: string expected";
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            if (!$util.isString(message.endDateId))
                                return "endDateId: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrosstabFilter message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CrosstabFilter} CrosstabFilter
                     */
                    CrosstabFilter.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CrosstabFilter)
                            return object;
                        var message = new $root.palexy.task_management.v1.CrosstabFilter();
                        if (object.conditions) {
                            if (!Array.isArray(object.conditions))
                                throw TypeError(".palexy.task_management.v1.CrosstabFilter.conditions: array expected");
                            message.conditions = [];
                            for (var i = 0; i < object.conditions.length; ++i) {
                                if (typeof object.conditions[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabFilter.conditions: object expected");
                                message.conditions[i] = $root.palexy.task_management.v1.FilterCondition.fromObject(object.conditions[i]);
                            }
                        }
                        if (object.startDateId != null)
                            message.startDateId = String(object.startDateId);
                        if (object.endDateId != null)
                            message.endDateId = String(object.endDateId);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrosstabFilter message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @static
                     * @param {palexy.task_management.v1.CrosstabFilter} message CrosstabFilter
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrosstabFilter.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.conditions = [];
                        if (options.defaults) {
                            object.startDateId = "";
                            object.endDateId = "";
                        }
                        if (message.conditions && message.conditions.length) {
                            object.conditions = [];
                            for (var j = 0; j < message.conditions.length; ++j)
                                object.conditions[j] = $root.palexy.task_management.v1.FilterCondition.toObject(message.conditions[j], options);
                        }
                        if (message.startDateId != null && message.hasOwnProperty("startDateId"))
                            object.startDateId = message.startDateId;
                        if (message.endDateId != null && message.hasOwnProperty("endDateId"))
                            object.endDateId = message.endDateId;
                        return object;
                    };
    
                    /**
                     * Converts this CrosstabFilter to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CrosstabFilter
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrosstabFilter.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrosstabFilter;
                })();
    
                v1.FilterCondition = (function() {
    
                    /**
                     * Properties of a FilterCondition.
                     * @memberof palexy.task_management.v1
                     * @interface IFilterCondition
                     * @property {palexy.task_management.v1.IVariableRef|null} [variable] FilterCondition variable
                     * @property {palexy.task_management.v1.IChoicePredicate|null} [choice] FilterCondition choice
                     * @property {palexy.task_management.v1.INumericPredicate|null} [numeric] FilterCondition numeric
                     */
    
                    /**
                     * Constructs a new FilterCondition.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a FilterCondition.
                     * @implements IFilterCondition
                     * @constructor
                     * @param {palexy.task_management.v1.IFilterCondition=} [properties] Properties to set
                     */
                    function FilterCondition(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * FilterCondition variable.
                     * @member {palexy.task_management.v1.IVariableRef|null|undefined} variable
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @instance
                     */
                    FilterCondition.prototype.variable = null;
    
                    /**
                     * FilterCondition choice.
                     * @member {palexy.task_management.v1.IChoicePredicate|null|undefined} choice
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @instance
                     */
                    FilterCondition.prototype.choice = null;
    
                    /**
                     * FilterCondition numeric.
                     * @member {palexy.task_management.v1.INumericPredicate|null|undefined} numeric
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @instance
                     */
                    FilterCondition.prototype.numeric = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * FilterCondition predicate.
                     * @member {"choice"|"numeric"|undefined} predicate
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @instance
                     */
                    Object.defineProperty(FilterCondition.prototype, "predicate", {
                        get: $util.oneOfGetter($oneOfFields = ["choice", "numeric"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new FilterCondition instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {palexy.task_management.v1.IFilterCondition=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.FilterCondition} FilterCondition instance
                     */
                    FilterCondition.create = function create(properties) {
                        return new FilterCondition(properties);
                    };
    
                    /**
                     * Encodes the specified FilterCondition message. Does not implicitly {@link palexy.task_management.v1.FilterCondition.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {palexy.task_management.v1.IFilterCondition} message FilterCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FilterCondition.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.variable != null && Object.hasOwnProperty.call(message, "variable"))
                            $root.palexy.task_management.v1.VariableRef.encode(message.variable, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.choice != null && Object.hasOwnProperty.call(message, "choice"))
                            $root.palexy.task_management.v1.ChoicePredicate.encode(message.choice, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.numeric != null && Object.hasOwnProperty.call(message, "numeric"))
                            $root.palexy.task_management.v1.NumericPredicate.encode(message.numeric, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified FilterCondition message, length delimited. Does not implicitly {@link palexy.task_management.v1.FilterCondition.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {palexy.task_management.v1.IFilterCondition} message FilterCondition message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    FilterCondition.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a FilterCondition message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.FilterCondition} FilterCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FilterCondition.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.FilterCondition();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.variable = $root.palexy.task_management.v1.VariableRef.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.choice = $root.palexy.task_management.v1.ChoicePredicate.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.numeric = $root.palexy.task_management.v1.NumericPredicate.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a FilterCondition message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.FilterCondition} FilterCondition
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    FilterCondition.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a FilterCondition message.
                     * @function verify
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    FilterCondition.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.variable != null && message.hasOwnProperty("variable")) {
                            var error = $root.palexy.task_management.v1.VariableRef.verify(message.variable);
                            if (error)
                                return "variable." + error;
                        }
                        if (message.choice != null && message.hasOwnProperty("choice")) {
                            properties.predicate = 1;
                            {
                                var error = $root.palexy.task_management.v1.ChoicePredicate.verify(message.choice);
                                if (error)
                                    return "choice." + error;
                            }
                        }
                        if (message.numeric != null && message.hasOwnProperty("numeric")) {
                            if (properties.predicate === 1)
                                return "predicate: multiple values";
                            properties.predicate = 1;
                            {
                                var error = $root.palexy.task_management.v1.NumericPredicate.verify(message.numeric);
                                if (error)
                                    return "numeric." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a FilterCondition message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.FilterCondition} FilterCondition
                     */
                    FilterCondition.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.FilterCondition)
                            return object;
                        var message = new $root.palexy.task_management.v1.FilterCondition();
                        if (object.variable != null) {
                            if (typeof object.variable !== "object")
                                throw TypeError(".palexy.task_management.v1.FilterCondition.variable: object expected");
                            message.variable = $root.palexy.task_management.v1.VariableRef.fromObject(object.variable);
                        }
                        if (object.choice != null) {
                            if (typeof object.choice !== "object")
                                throw TypeError(".palexy.task_management.v1.FilterCondition.choice: object expected");
                            message.choice = $root.palexy.task_management.v1.ChoicePredicate.fromObject(object.choice);
                        }
                        if (object.numeric != null) {
                            if (typeof object.numeric !== "object")
                                throw TypeError(".palexy.task_management.v1.FilterCondition.numeric: object expected");
                            message.numeric = $root.palexy.task_management.v1.NumericPredicate.fromObject(object.numeric);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a FilterCondition message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @static
                     * @param {palexy.task_management.v1.FilterCondition} message FilterCondition
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    FilterCondition.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.variable = null;
                        if (message.variable != null && message.hasOwnProperty("variable"))
                            object.variable = $root.palexy.task_management.v1.VariableRef.toObject(message.variable, options);
                        if (message.choice != null && message.hasOwnProperty("choice")) {
                            object.choice = $root.palexy.task_management.v1.ChoicePredicate.toObject(message.choice, options);
                            if (options.oneofs)
                                object.predicate = "choice";
                        }
                        if (message.numeric != null && message.hasOwnProperty("numeric")) {
                            object.numeric = $root.palexy.task_management.v1.NumericPredicate.toObject(message.numeric, options);
                            if (options.oneofs)
                                object.predicate = "numeric";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this FilterCondition to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.FilterCondition
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    FilterCondition.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return FilterCondition;
                })();
    
                v1.CrosstabConfig = (function() {
    
                    /**
                     * Properties of a CrosstabConfig.
                     * @memberof palexy.task_management.v1
                     * @interface ICrosstabConfig
                     * @property {Array.<palexy.task_management.v1.IVariableRef>|null} [rows] CrosstabConfig rows
                     * @property {Array.<palexy.task_management.v1.IVariableRef>|null} [columns] CrosstabConfig columns
                     * @property {palexy.task_management.v1.IValueTypeSelection|null} [valueTypes] CrosstabConfig valueTypes
                     * @property {palexy.task_management.v1.ICrosstabFilter|null} [filter] CrosstabConfig filter
                     * @property {palexy.task_management.v1.IAnalysisSettings|null} [analysisSettings] CrosstabConfig analysisSettings
                     * @property {number|null} [activeRowTableIndex] CrosstabConfig activeRowTableIndex
                     */
    
                    /**
                     * Constructs a new CrosstabConfig.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CrosstabConfig.
                     * @implements ICrosstabConfig
                     * @constructor
                     * @param {palexy.task_management.v1.ICrosstabConfig=} [properties] Properties to set
                     */
                    function CrosstabConfig(properties) {
                        this.rows = [];
                        this.columns = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrosstabConfig rows.
                     * @member {Array.<palexy.task_management.v1.IVariableRef>} rows
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.rows = $util.emptyArray;
    
                    /**
                     * CrosstabConfig columns.
                     * @member {Array.<palexy.task_management.v1.IVariableRef>} columns
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.columns = $util.emptyArray;
    
                    /**
                     * CrosstabConfig valueTypes.
                     * @member {palexy.task_management.v1.IValueTypeSelection|null|undefined} valueTypes
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.valueTypes = null;
    
                    /**
                     * CrosstabConfig filter.
                     * @member {palexy.task_management.v1.ICrosstabFilter|null|undefined} filter
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.filter = null;
    
                    /**
                     * CrosstabConfig analysisSettings.
                     * @member {palexy.task_management.v1.IAnalysisSettings|null|undefined} analysisSettings
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.analysisSettings = null;
    
                    /**
                     * CrosstabConfig activeRowTableIndex.
                     * @member {number} activeRowTableIndex
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     */
                    CrosstabConfig.prototype.activeRowTableIndex = 0;
    
                    /**
                     * Creates a new CrosstabConfig instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabConfig=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CrosstabConfig} CrosstabConfig instance
                     */
                    CrosstabConfig.create = function create(properties) {
                        return new CrosstabConfig(properties);
                    };
    
                    /**
                     * Encodes the specified CrosstabConfig message. Does not implicitly {@link palexy.task_management.v1.CrosstabConfig.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabConfig} message CrosstabConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabConfig.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rows != null && message.rows.length)
                            for (var i = 0; i < message.rows.length; ++i)
                                $root.palexy.task_management.v1.VariableRef.encode(message.rows[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.columns != null && message.columns.length)
                            for (var i = 0; i < message.columns.length; ++i)
                                $root.palexy.task_management.v1.VariableRef.encode(message.columns[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.valueTypes != null && Object.hasOwnProperty.call(message, "valueTypes"))
                            $root.palexy.task_management.v1.ValueTypeSelection.encode(message.valueTypes, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.filter != null && Object.hasOwnProperty.call(message, "filter"))
                            $root.palexy.task_management.v1.CrosstabFilter.encode(message.filter, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.analysisSettings != null && Object.hasOwnProperty.call(message, "analysisSettings"))
                            $root.palexy.task_management.v1.AnalysisSettings.encode(message.analysisSettings, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                        if (message.activeRowTableIndex != null && Object.hasOwnProperty.call(message, "activeRowTableIndex"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.activeRowTableIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrosstabConfig message, length delimited. Does not implicitly {@link palexy.task_management.v1.CrosstabConfig.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabConfig} message CrosstabConfig message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabConfig.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrosstabConfig message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CrosstabConfig} CrosstabConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabConfig.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CrosstabConfig();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.rows && message.rows.length))
                                    message.rows = [];
                                message.rows.push($root.palexy.task_management.v1.VariableRef.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                if (!(message.columns && message.columns.length))
                                    message.columns = [];
                                message.columns.push($root.palexy.task_management.v1.VariableRef.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                message.valueTypes = $root.palexy.task_management.v1.ValueTypeSelection.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.filter = $root.palexy.task_management.v1.CrosstabFilter.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.analysisSettings = $root.palexy.task_management.v1.AnalysisSettings.decode(reader, reader.uint32());
                                break;
                            case 6:
                                message.activeRowTableIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrosstabConfig message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CrosstabConfig} CrosstabConfig
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabConfig.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrosstabConfig message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrosstabConfig.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rows != null && message.hasOwnProperty("rows")) {
                            if (!Array.isArray(message.rows))
                                return "rows: array expected";
                            for (var i = 0; i < message.rows.length; ++i) {
                                var error = $root.palexy.task_management.v1.VariableRef.verify(message.rows[i]);
                                if (error)
                                    return "rows." + error;
                            }
                        }
                        if (message.columns != null && message.hasOwnProperty("columns")) {
                            if (!Array.isArray(message.columns))
                                return "columns: array expected";
                            for (var i = 0; i < message.columns.length; ++i) {
                                var error = $root.palexy.task_management.v1.VariableRef.verify(message.columns[i]);
                                if (error)
                                    return "columns." + error;
                            }
                        }
                        if (message.valueTypes != null && message.hasOwnProperty("valueTypes")) {
                            var error = $root.palexy.task_management.v1.ValueTypeSelection.verify(message.valueTypes);
                            if (error)
                                return "valueTypes." + error;
                        }
                        if (message.filter != null && message.hasOwnProperty("filter")) {
                            var error = $root.palexy.task_management.v1.CrosstabFilter.verify(message.filter);
                            if (error)
                                return "filter." + error;
                        }
                        if (message.analysisSettings != null && message.hasOwnProperty("analysisSettings")) {
                            var error = $root.palexy.task_management.v1.AnalysisSettings.verify(message.analysisSettings);
                            if (error)
                                return "analysisSettings." + error;
                        }
                        if (message.activeRowTableIndex != null && message.hasOwnProperty("activeRowTableIndex"))
                            if (!$util.isInteger(message.activeRowTableIndex))
                                return "activeRowTableIndex: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrosstabConfig message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CrosstabConfig} CrosstabConfig
                     */
                    CrosstabConfig.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CrosstabConfig)
                            return object;
                        var message = new $root.palexy.task_management.v1.CrosstabConfig();
                        if (object.rows) {
                            if (!Array.isArray(object.rows))
                                throw TypeError(".palexy.task_management.v1.CrosstabConfig.rows: array expected");
                            message.rows = [];
                            for (var i = 0; i < object.rows.length; ++i) {
                                if (typeof object.rows[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabConfig.rows: object expected");
                                message.rows[i] = $root.palexy.task_management.v1.VariableRef.fromObject(object.rows[i]);
                            }
                        }
                        if (object.columns) {
                            if (!Array.isArray(object.columns))
                                throw TypeError(".palexy.task_management.v1.CrosstabConfig.columns: array expected");
                            message.columns = [];
                            for (var i = 0; i < object.columns.length; ++i) {
                                if (typeof object.columns[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabConfig.columns: object expected");
                                message.columns[i] = $root.palexy.task_management.v1.VariableRef.fromObject(object.columns[i]);
                            }
                        }
                        if (object.valueTypes != null) {
                            if (typeof object.valueTypes !== "object")
                                throw TypeError(".palexy.task_management.v1.CrosstabConfig.valueTypes: object expected");
                            message.valueTypes = $root.palexy.task_management.v1.ValueTypeSelection.fromObject(object.valueTypes);
                        }
                        if (object.filter != null) {
                            if (typeof object.filter !== "object")
                                throw TypeError(".palexy.task_management.v1.CrosstabConfig.filter: object expected");
                            message.filter = $root.palexy.task_management.v1.CrosstabFilter.fromObject(object.filter);
                        }
                        if (object.analysisSettings != null) {
                            if (typeof object.analysisSettings !== "object")
                                throw TypeError(".palexy.task_management.v1.CrosstabConfig.analysisSettings: object expected");
                            message.analysisSettings = $root.palexy.task_management.v1.AnalysisSettings.fromObject(object.analysisSettings);
                        }
                        if (object.activeRowTableIndex != null)
                            message.activeRowTableIndex = object.activeRowTableIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrosstabConfig message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @static
                     * @param {palexy.task_management.v1.CrosstabConfig} message CrosstabConfig
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrosstabConfig.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.rows = [];
                            object.columns = [];
                        }
                        if (options.defaults) {
                            object.valueTypes = null;
                            object.filter = null;
                            object.analysisSettings = null;
                            object.activeRowTableIndex = 0;
                        }
                        if (message.rows && message.rows.length) {
                            object.rows = [];
                            for (var j = 0; j < message.rows.length; ++j)
                                object.rows[j] = $root.palexy.task_management.v1.VariableRef.toObject(message.rows[j], options);
                        }
                        if (message.columns && message.columns.length) {
                            object.columns = [];
                            for (var j = 0; j < message.columns.length; ++j)
                                object.columns[j] = $root.palexy.task_management.v1.VariableRef.toObject(message.columns[j], options);
                        }
                        if (message.valueTypes != null && message.hasOwnProperty("valueTypes"))
                            object.valueTypes = $root.palexy.task_management.v1.ValueTypeSelection.toObject(message.valueTypes, options);
                        if (message.filter != null && message.hasOwnProperty("filter"))
                            object.filter = $root.palexy.task_management.v1.CrosstabFilter.toObject(message.filter, options);
                        if (message.analysisSettings != null && message.hasOwnProperty("analysisSettings"))
                            object.analysisSettings = $root.palexy.task_management.v1.AnalysisSettings.toObject(message.analysisSettings, options);
                        if (message.activeRowTableIndex != null && message.hasOwnProperty("activeRowTableIndex"))
                            object.activeRowTableIndex = message.activeRowTableIndex;
                        return object;
                    };
    
                    /**
                     * Converts this CrosstabConfig to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CrosstabConfig
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrosstabConfig.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrosstabConfig;
                })();
    
                v1.AnalysisSettings = (function() {
    
                    /**
                     * Properties of an AnalysisSettings.
                     * @memberof palexy.task_management.v1
                     * @interface IAnalysisSettings
                     * @property {number|null} [decimalPlaces] AnalysisSettings decimalPlaces
                     * @property {boolean|null} [splitCountsAndPercentages] AnalysisSettings splitCountsAndPercentages
                     */
    
                    /**
                     * Constructs a new AnalysisSettings.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AnalysisSettings.
                     * @implements IAnalysisSettings
                     * @constructor
                     * @param {palexy.task_management.v1.IAnalysisSettings=} [properties] Properties to set
                     */
                    function AnalysisSettings(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AnalysisSettings decimalPlaces.
                     * @member {number} decimalPlaces
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @instance
                     */
                    AnalysisSettings.prototype.decimalPlaces = 0;
    
                    /**
                     * AnalysisSettings splitCountsAndPercentages.
                     * @member {boolean} splitCountsAndPercentages
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @instance
                     */
                    AnalysisSettings.prototype.splitCountsAndPercentages = false;
    
                    /**
                     * Creates a new AnalysisSettings instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisSettings=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AnalysisSettings} AnalysisSettings instance
                     */
                    AnalysisSettings.create = function create(properties) {
                        return new AnalysisSettings(properties);
                    };
    
                    /**
                     * Encodes the specified AnalysisSettings message. Does not implicitly {@link palexy.task_management.v1.AnalysisSettings.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisSettings} message AnalysisSettings message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnalysisSettings.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.decimalPlaces != null && Object.hasOwnProperty.call(message, "decimalPlaces"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.decimalPlaces);
                        if (message.splitCountsAndPercentages != null && Object.hasOwnProperty.call(message, "splitCountsAndPercentages"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.splitCountsAndPercentages);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AnalysisSettings message, length delimited. Does not implicitly {@link palexy.task_management.v1.AnalysisSettings.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisSettings} message AnalysisSettings message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnalysisSettings.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AnalysisSettings message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AnalysisSettings} AnalysisSettings
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnalysisSettings.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AnalysisSettings();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.decimalPlaces = reader.int32();
                                break;
                            case 2:
                                message.splitCountsAndPercentages = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AnalysisSettings message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AnalysisSettings} AnalysisSettings
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnalysisSettings.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AnalysisSettings message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AnalysisSettings.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.decimalPlaces != null && message.hasOwnProperty("decimalPlaces"))
                            if (!$util.isInteger(message.decimalPlaces))
                                return "decimalPlaces: integer expected";
                        if (message.splitCountsAndPercentages != null && message.hasOwnProperty("splitCountsAndPercentages"))
                            if (typeof message.splitCountsAndPercentages !== "boolean")
                                return "splitCountsAndPercentages: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates an AnalysisSettings message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AnalysisSettings} AnalysisSettings
                     */
                    AnalysisSettings.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AnalysisSettings)
                            return object;
                        var message = new $root.palexy.task_management.v1.AnalysisSettings();
                        if (object.decimalPlaces != null)
                            message.decimalPlaces = object.decimalPlaces | 0;
                        if (object.splitCountsAndPercentages != null)
                            message.splitCountsAndPercentages = Boolean(object.splitCountsAndPercentages);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AnalysisSettings message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @static
                     * @param {palexy.task_management.v1.AnalysisSettings} message AnalysisSettings
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AnalysisSettings.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.decimalPlaces = 0;
                            object.splitCountsAndPercentages = false;
                        }
                        if (message.decimalPlaces != null && message.hasOwnProperty("decimalPlaces"))
                            object.decimalPlaces = message.decimalPlaces;
                        if (message.splitCountsAndPercentages != null && message.hasOwnProperty("splitCountsAndPercentages"))
                            object.splitCountsAndPercentages = message.splitCountsAndPercentages;
                        return object;
                    };
    
                    /**
                     * Converts this AnalysisSettings to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AnalysisSettings
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AnalysisSettings.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AnalysisSettings;
                })();
    
                v1.ListCrosstabsRequest = (function() {
    
                    /**
                     * Properties of a ListCrosstabsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListCrosstabsRequest
                     * @property {number|null} [formId] ListCrosstabsRequest formId
                     */
    
                    /**
                     * Constructs a new ListCrosstabsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCrosstabsRequest.
                     * @implements IListCrosstabsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListCrosstabsRequest=} [properties] Properties to set
                     */
                    function ListCrosstabsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCrosstabsRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @instance
                     */
                    ListCrosstabsRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListCrosstabsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCrosstabsRequest} ListCrosstabsRequest instance
                     */
                    ListCrosstabsRequest.create = function create(properties) {
                        return new ListCrosstabsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCrosstabsRequest message. Does not implicitly {@link palexy.task_management.v1.ListCrosstabsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsRequest} message ListCrosstabsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCrosstabsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCrosstabsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCrosstabsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsRequest} message ListCrosstabsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCrosstabsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCrosstabsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCrosstabsRequest} ListCrosstabsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCrosstabsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCrosstabsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCrosstabsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCrosstabsRequest} ListCrosstabsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCrosstabsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCrosstabsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCrosstabsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCrosstabsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCrosstabsRequest} ListCrosstabsRequest
                     */
                    ListCrosstabsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCrosstabsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCrosstabsRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCrosstabsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListCrosstabsRequest} message ListCrosstabsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCrosstabsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListCrosstabsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCrosstabsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCrosstabsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCrosstabsRequest;
                })();
    
                v1.ListCrosstabsResponse = (function() {
    
                    /**
                     * Properties of a ListCrosstabsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListCrosstabsResponse
                     * @property {Array.<palexy.task_management.v1.ICrosstabSummary>|null} [crosstabs] ListCrosstabsResponse crosstabs
                     */
    
                    /**
                     * Constructs a new ListCrosstabsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCrosstabsResponse.
                     * @implements IListCrosstabsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListCrosstabsResponse=} [properties] Properties to set
                     */
                    function ListCrosstabsResponse(properties) {
                        this.crosstabs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCrosstabsResponse crosstabs.
                     * @member {Array.<palexy.task_management.v1.ICrosstabSummary>} crosstabs
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @instance
                     */
                    ListCrosstabsResponse.prototype.crosstabs = $util.emptyArray;
    
                    /**
                     * Creates a new ListCrosstabsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCrosstabsResponse} ListCrosstabsResponse instance
                     */
                    ListCrosstabsResponse.create = function create(properties) {
                        return new ListCrosstabsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCrosstabsResponse message. Does not implicitly {@link palexy.task_management.v1.ListCrosstabsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsResponse} message ListCrosstabsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCrosstabsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.crosstabs != null && message.crosstabs.length)
                            for (var i = 0; i < message.crosstabs.length; ++i)
                                $root.palexy.task_management.v1.CrosstabSummary.encode(message.crosstabs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCrosstabsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCrosstabsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCrosstabsResponse} message ListCrosstabsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCrosstabsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCrosstabsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCrosstabsResponse} ListCrosstabsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCrosstabsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCrosstabsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.crosstabs && message.crosstabs.length))
                                    message.crosstabs = [];
                                message.crosstabs.push($root.palexy.task_management.v1.CrosstabSummary.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCrosstabsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCrosstabsResponse} ListCrosstabsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCrosstabsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCrosstabsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCrosstabsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.crosstabs != null && message.hasOwnProperty("crosstabs")) {
                            if (!Array.isArray(message.crosstabs))
                                return "crosstabs: array expected";
                            for (var i = 0; i < message.crosstabs.length; ++i) {
                                var error = $root.palexy.task_management.v1.CrosstabSummary.verify(message.crosstabs[i]);
                                if (error)
                                    return "crosstabs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCrosstabsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCrosstabsResponse} ListCrosstabsResponse
                     */
                    ListCrosstabsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCrosstabsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCrosstabsResponse();
                        if (object.crosstabs) {
                            if (!Array.isArray(object.crosstabs))
                                throw TypeError(".palexy.task_management.v1.ListCrosstabsResponse.crosstabs: array expected");
                            message.crosstabs = [];
                            for (var i = 0; i < object.crosstabs.length; ++i) {
                                if (typeof object.crosstabs[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListCrosstabsResponse.crosstabs: object expected");
                                message.crosstabs[i] = $root.palexy.task_management.v1.CrosstabSummary.fromObject(object.crosstabs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCrosstabsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListCrosstabsResponse} message ListCrosstabsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCrosstabsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.crosstabs = [];
                        if (message.crosstabs && message.crosstabs.length) {
                            object.crosstabs = [];
                            for (var j = 0; j < message.crosstabs.length; ++j)
                                object.crosstabs[j] = $root.palexy.task_management.v1.CrosstabSummary.toObject(message.crosstabs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCrosstabsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCrosstabsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCrosstabsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCrosstabsResponse;
                })();
    
                v1.CrosstabSummary = (function() {
    
                    /**
                     * Properties of a CrosstabSummary.
                     * @memberof palexy.task_management.v1
                     * @interface ICrosstabSummary
                     * @property {number|null} [id] CrosstabSummary id
                     * @property {string|null} [name] CrosstabSummary name
                     * @property {number|null} [createdTimeMs] CrosstabSummary createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] CrosstabSummary lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new CrosstabSummary.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CrosstabSummary.
                     * @implements ICrosstabSummary
                     * @constructor
                     * @param {palexy.task_management.v1.ICrosstabSummary=} [properties] Properties to set
                     */
                    function CrosstabSummary(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrosstabSummary id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @instance
                     */
                    CrosstabSummary.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CrosstabSummary name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @instance
                     */
                    CrosstabSummary.prototype.name = "";
    
                    /**
                     * CrosstabSummary createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @instance
                     */
                    CrosstabSummary.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CrosstabSummary lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @instance
                     */
                    CrosstabSummary.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CrosstabSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabSummary=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CrosstabSummary} CrosstabSummary instance
                     */
                    CrosstabSummary.create = function create(properties) {
                        return new CrosstabSummary(properties);
                    };
    
                    /**
                     * Encodes the specified CrosstabSummary message. Does not implicitly {@link palexy.task_management.v1.CrosstabSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabSummary} message CrosstabSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrosstabSummary message, length delimited. Does not implicitly {@link palexy.task_management.v1.CrosstabSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabSummary} message CrosstabSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrosstabSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CrosstabSummary} CrosstabSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CrosstabSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 4:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrosstabSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CrosstabSummary} CrosstabSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrosstabSummary message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrosstabSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrosstabSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CrosstabSummary} CrosstabSummary
                     */
                    CrosstabSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CrosstabSummary)
                            return object;
                        var message = new $root.palexy.task_management.v1.CrosstabSummary();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrosstabSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @static
                     * @param {palexy.task_management.v1.CrosstabSummary} message CrosstabSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrosstabSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this CrosstabSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CrosstabSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrosstabSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrosstabSummary;
                })();
    
                v1.CreateCrosstabRequest = (function() {
    
                    /**
                     * Properties of a CreateCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateCrosstabRequest
                     * @property {number|null} [formId] CreateCrosstabRequest formId
                     */
    
                    /**
                     * Constructs a new CreateCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateCrosstabRequest.
                     * @implements ICreateCrosstabRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest=} [properties] Properties to set
                     */
                    function CreateCrosstabRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateCrosstabRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @instance
                     */
                    CreateCrosstabRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CreateCrosstabRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateCrosstabRequest} CreateCrosstabRequest instance
                     */
                    CreateCrosstabRequest.create = function create(properties) {
                        return new CreateCrosstabRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateCrosstabRequest message. Does not implicitly {@link palexy.task_management.v1.CreateCrosstabRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest} message CreateCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCrosstabRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateCrosstabRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateCrosstabRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCrosstabRequest} message CreateCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCrosstabRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateCrosstabRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateCrosstabRequest} CreateCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCrosstabRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateCrosstabRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateCrosstabRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateCrosstabRequest} CreateCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCrosstabRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateCrosstabRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateCrosstabRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateCrosstabRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateCrosstabRequest} CreateCrosstabRequest
                     */
                    CreateCrosstabRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateCrosstabRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateCrosstabRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateCrosstabRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateCrosstabRequest} message CreateCrosstabRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateCrosstabRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this CreateCrosstabRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateCrosstabRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateCrosstabRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateCrosstabRequest;
                })();
    
                v1.GetCrosstabRequest = (function() {
    
                    /**
                     * Properties of a GetCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCrosstabRequest
                     * @property {number|null} [formId] GetCrosstabRequest formId
                     * @property {number|null} [crosstabId] GetCrosstabRequest crosstabId
                     */
    
                    /**
                     * Constructs a new GetCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCrosstabRequest.
                     * @implements IGetCrosstabRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCrosstabRequest=} [properties] Properties to set
                     */
                    function GetCrosstabRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCrosstabRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @instance
                     */
                    GetCrosstabRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCrosstabRequest crosstabId.
                     * @member {number} crosstabId
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @instance
                     */
                    GetCrosstabRequest.prototype.crosstabId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCrosstabRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCrosstabRequest} GetCrosstabRequest instance
                     */
                    GetCrosstabRequest.create = function create(properties) {
                        return new GetCrosstabRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCrosstabRequest message. Does not implicitly {@link palexy.task_management.v1.GetCrosstabRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabRequest} message GetCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.crosstabId != null && Object.hasOwnProperty.call(message, "crosstabId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crosstabId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCrosstabRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCrosstabRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabRequest} message GetCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCrosstabRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCrosstabRequest} GetCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCrosstabRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.crosstabId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCrosstabRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCrosstabRequest} GetCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCrosstabRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCrosstabRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (!$util.isInteger(message.crosstabId) && !(message.crosstabId && $util.isInteger(message.crosstabId.low) && $util.isInteger(message.crosstabId.high)))
                                return "crosstabId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCrosstabRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCrosstabRequest} GetCrosstabRequest
                     */
                    GetCrosstabRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCrosstabRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCrosstabRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.crosstabId != null)
                            if ($util.Long)
                                (message.crosstabId = $util.Long.fromValue(object.crosstabId)).unsigned = false;
                            else if (typeof object.crosstabId === "string")
                                message.crosstabId = parseInt(object.crosstabId, 10);
                            else if (typeof object.crosstabId === "number")
                                message.crosstabId = object.crosstabId;
                            else if (typeof object.crosstabId === "object")
                                message.crosstabId = new $util.LongBits(object.crosstabId.low >>> 0, object.crosstabId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCrosstabRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.GetCrosstabRequest} message GetCrosstabRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCrosstabRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.crosstabId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.crosstabId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (typeof message.crosstabId === "number")
                                object.crosstabId = options.longs === String ? String(message.crosstabId) : message.crosstabId;
                            else
                                object.crosstabId = options.longs === String ? $util.Long.prototype.toString.call(message.crosstabId) : options.longs === Number ? new $util.LongBits(message.crosstabId.low >>> 0, message.crosstabId.high >>> 0).toNumber() : message.crosstabId;
                        return object;
                    };
    
                    /**
                     * Converts this GetCrosstabRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCrosstabRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCrosstabRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCrosstabRequest;
                })();
    
                v1.UpdateCrosstabRequest = (function() {
    
                    /**
                     * Properties of an UpdateCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateCrosstabRequest
                     * @property {number|null} [formId] UpdateCrosstabRequest formId
                     * @property {number|null} [crosstabId] UpdateCrosstabRequest crosstabId
                     * @property {palexy.task_management.v1.ICrosstab|null} [crosstab] UpdateCrosstabRequest crosstab
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateCrosstabRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateCrosstabRequest.
                     * @implements IUpdateCrosstabRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest=} [properties] Properties to set
                     */
                    function UpdateCrosstabRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateCrosstabRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @instance
                     */
                    UpdateCrosstabRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateCrosstabRequest crosstabId.
                     * @member {number} crosstabId
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @instance
                     */
                    UpdateCrosstabRequest.prototype.crosstabId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateCrosstabRequest crosstab.
                     * @member {palexy.task_management.v1.ICrosstab|null|undefined} crosstab
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @instance
                     */
                    UpdateCrosstabRequest.prototype.crosstab = null;
    
                    /**
                     * UpdateCrosstabRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @instance
                     */
                    UpdateCrosstabRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateCrosstabRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateCrosstabRequest} UpdateCrosstabRequest instance
                     */
                    UpdateCrosstabRequest.create = function create(properties) {
                        return new UpdateCrosstabRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateCrosstabRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateCrosstabRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest} message UpdateCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCrosstabRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.crosstabId != null && Object.hasOwnProperty.call(message, "crosstabId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crosstabId);
                        if (message.crosstab != null && Object.hasOwnProperty.call(message, "crosstab"))
                            $root.palexy.task_management.v1.Crosstab.encode(message.crosstab, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateCrosstabRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateCrosstabRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCrosstabRequest} message UpdateCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCrosstabRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateCrosstabRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateCrosstabRequest} UpdateCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCrosstabRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateCrosstabRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.crosstabId = reader.int64();
                                break;
                            case 3:
                                message.crosstab = $root.palexy.task_management.v1.Crosstab.decode(reader, reader.uint32());
                                break;
                            case 4:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateCrosstabRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateCrosstabRequest} UpdateCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCrosstabRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateCrosstabRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateCrosstabRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (!$util.isInteger(message.crosstabId) && !(message.crosstabId && $util.isInteger(message.crosstabId.low) && $util.isInteger(message.crosstabId.high)))
                                return "crosstabId: integer|Long expected";
                        if (message.crosstab != null && message.hasOwnProperty("crosstab")) {
                            var error = $root.palexy.task_management.v1.Crosstab.verify(message.crosstab);
                            if (error)
                                return "crosstab." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateCrosstabRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateCrosstabRequest} UpdateCrosstabRequest
                     */
                    UpdateCrosstabRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateCrosstabRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateCrosstabRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.crosstabId != null)
                            if ($util.Long)
                                (message.crosstabId = $util.Long.fromValue(object.crosstabId)).unsigned = false;
                            else if (typeof object.crosstabId === "string")
                                message.crosstabId = parseInt(object.crosstabId, 10);
                            else if (typeof object.crosstabId === "number")
                                message.crosstabId = object.crosstabId;
                            else if (typeof object.crosstabId === "object")
                                message.crosstabId = new $util.LongBits(object.crosstabId.low >>> 0, object.crosstabId.high >>> 0).toNumber();
                        if (object.crosstab != null) {
                            if (typeof object.crosstab !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCrosstabRequest.crosstab: object expected");
                            message.crosstab = $root.palexy.task_management.v1.Crosstab.fromObject(object.crosstab);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCrosstabRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateCrosstabRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateCrosstabRequest} message UpdateCrosstabRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateCrosstabRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.crosstabId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.crosstabId = options.longs === String ? "0" : 0;
                            object.crosstab = null;
                            object.updateMask = null;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (typeof message.crosstabId === "number")
                                object.crosstabId = options.longs === String ? String(message.crosstabId) : message.crosstabId;
                            else
                                object.crosstabId = options.longs === String ? $util.Long.prototype.toString.call(message.crosstabId) : options.longs === Number ? new $util.LongBits(message.crosstabId.low >>> 0, message.crosstabId.high >>> 0).toNumber() : message.crosstabId;
                        if (message.crosstab != null && message.hasOwnProperty("crosstab"))
                            object.crosstab = $root.palexy.task_management.v1.Crosstab.toObject(message.crosstab, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateCrosstabRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateCrosstabRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateCrosstabRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateCrosstabRequest;
                })();
    
                v1.DeleteCrosstabRequest = (function() {
    
                    /**
                     * Properties of a DeleteCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteCrosstabRequest
                     * @property {number|null} [formId] DeleteCrosstabRequest formId
                     * @property {number|null} [crosstabId] DeleteCrosstabRequest crosstabId
                     */
    
                    /**
                     * Constructs a new DeleteCrosstabRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteCrosstabRequest.
                     * @implements IDeleteCrosstabRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest=} [properties] Properties to set
                     */
                    function DeleteCrosstabRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteCrosstabRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @instance
                     */
                    DeleteCrosstabRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteCrosstabRequest crosstabId.
                     * @member {number} crosstabId
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @instance
                     */
                    DeleteCrosstabRequest.prototype.crosstabId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteCrosstabRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteCrosstabRequest} DeleteCrosstabRequest instance
                     */
                    DeleteCrosstabRequest.create = function create(properties) {
                        return new DeleteCrosstabRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteCrosstabRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteCrosstabRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest} message DeleteCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCrosstabRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.crosstabId != null && Object.hasOwnProperty.call(message, "crosstabId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crosstabId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteCrosstabRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteCrosstabRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCrosstabRequest} message DeleteCrosstabRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCrosstabRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteCrosstabRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteCrosstabRequest} DeleteCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCrosstabRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteCrosstabRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.crosstabId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteCrosstabRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteCrosstabRequest} DeleteCrosstabRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCrosstabRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteCrosstabRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteCrosstabRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (!$util.isInteger(message.crosstabId) && !(message.crosstabId && $util.isInteger(message.crosstabId.low) && $util.isInteger(message.crosstabId.high)))
                                return "crosstabId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteCrosstabRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteCrosstabRequest} DeleteCrosstabRequest
                     */
                    DeleteCrosstabRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteCrosstabRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteCrosstabRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.crosstabId != null)
                            if ($util.Long)
                                (message.crosstabId = $util.Long.fromValue(object.crosstabId)).unsigned = false;
                            else if (typeof object.crosstabId === "string")
                                message.crosstabId = parseInt(object.crosstabId, 10);
                            else if (typeof object.crosstabId === "number")
                                message.crosstabId = object.crosstabId;
                            else if (typeof object.crosstabId === "object")
                                message.crosstabId = new $util.LongBits(object.crosstabId.low >>> 0, object.crosstabId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteCrosstabRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteCrosstabRequest} message DeleteCrosstabRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteCrosstabRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.crosstabId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.crosstabId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (typeof message.crosstabId === "number")
                                object.crosstabId = options.longs === String ? String(message.crosstabId) : message.crosstabId;
                            else
                                object.crosstabId = options.longs === String ? $util.Long.prototype.toString.call(message.crosstabId) : options.longs === Number ? new $util.LongBits(message.crosstabId.low >>> 0, message.crosstabId.high >>> 0).toNumber() : message.crosstabId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteCrosstabRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteCrosstabRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteCrosstabRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteCrosstabRequest;
                })();
    
                v1.GetCrosstabTablesRequest = (function() {
    
                    /**
                     * Properties of a GetCrosstabTablesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCrosstabTablesRequest
                     * @property {number|null} [formId] GetCrosstabTablesRequest formId
                     * @property {number|null} [crosstabId] GetCrosstabTablesRequest crosstabId
                     */
    
                    /**
                     * Constructs a new GetCrosstabTablesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCrosstabTablesRequest.
                     * @implements IGetCrosstabTablesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest=} [properties] Properties to set
                     */
                    function GetCrosstabTablesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCrosstabTablesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @instance
                     */
                    GetCrosstabTablesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCrosstabTablesRequest crosstabId.
                     * @member {number} crosstabId
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @instance
                     */
                    GetCrosstabTablesRequest.prototype.crosstabId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCrosstabTablesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCrosstabTablesRequest} GetCrosstabTablesRequest instance
                     */
                    GetCrosstabTablesRequest.create = function create(properties) {
                        return new GetCrosstabTablesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCrosstabTablesRequest message. Does not implicitly {@link palexy.task_management.v1.GetCrosstabTablesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest} message GetCrosstabTablesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabTablesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        if (message.crosstabId != null && Object.hasOwnProperty.call(message, "crosstabId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.crosstabId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCrosstabTablesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCrosstabTablesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesRequest} message GetCrosstabTablesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabTablesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCrosstabTablesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCrosstabTablesRequest} GetCrosstabTablesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabTablesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCrosstabTablesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            case 2:
                                message.crosstabId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCrosstabTablesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCrosstabTablesRequest} GetCrosstabTablesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabTablesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCrosstabTablesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCrosstabTablesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (!$util.isInteger(message.crosstabId) && !(message.crosstabId && $util.isInteger(message.crosstabId.low) && $util.isInteger(message.crosstabId.high)))
                                return "crosstabId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCrosstabTablesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCrosstabTablesRequest} GetCrosstabTablesRequest
                     */
                    GetCrosstabTablesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCrosstabTablesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCrosstabTablesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        if (object.crosstabId != null)
                            if ($util.Long)
                                (message.crosstabId = $util.Long.fromValue(object.crosstabId)).unsigned = false;
                            else if (typeof object.crosstabId === "string")
                                message.crosstabId = parseInt(object.crosstabId, 10);
                            else if (typeof object.crosstabId === "number")
                                message.crosstabId = object.crosstabId;
                            else if (typeof object.crosstabId === "object")
                                message.crosstabId = new $util.LongBits(object.crosstabId.low >>> 0, object.crosstabId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCrosstabTablesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @static
                     * @param {palexy.task_management.v1.GetCrosstabTablesRequest} message GetCrosstabTablesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCrosstabTablesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.crosstabId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.crosstabId = options.longs === String ? "0" : 0;
                        }
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        if (message.crosstabId != null && message.hasOwnProperty("crosstabId"))
                            if (typeof message.crosstabId === "number")
                                object.crosstabId = options.longs === String ? String(message.crosstabId) : message.crosstabId;
                            else
                                object.crosstabId = options.longs === String ? $util.Long.prototype.toString.call(message.crosstabId) : options.longs === Number ? new $util.LongBits(message.crosstabId.low >>> 0, message.crosstabId.high >>> 0).toNumber() : message.crosstabId;
                        return object;
                    };
    
                    /**
                     * Converts this GetCrosstabTablesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCrosstabTablesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCrosstabTablesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCrosstabTablesRequest;
                })();
    
                v1.GetCrosstabTablesResponse = (function() {
    
                    /**
                     * Properties of a GetCrosstabTablesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCrosstabTablesResponse
                     * @property {Array.<palexy.task_management.v1.ICrosstabTable>|null} [tables] GetCrosstabTablesResponse tables
                     */
    
                    /**
                     * Constructs a new GetCrosstabTablesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCrosstabTablesResponse.
                     * @implements IGetCrosstabTablesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCrosstabTablesResponse=} [properties] Properties to set
                     */
                    function GetCrosstabTablesResponse(properties) {
                        this.tables = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCrosstabTablesResponse tables.
                     * @member {Array.<palexy.task_management.v1.ICrosstabTable>} tables
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @instance
                     */
                    GetCrosstabTablesResponse.prototype.tables = $util.emptyArray;
    
                    /**
                     * Creates a new GetCrosstabTablesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCrosstabTablesResponse} GetCrosstabTablesResponse instance
                     */
                    GetCrosstabTablesResponse.create = function create(properties) {
                        return new GetCrosstabTablesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetCrosstabTablesResponse message. Does not implicitly {@link palexy.task_management.v1.GetCrosstabTablesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesResponse} message GetCrosstabTablesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabTablesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.tables != null && message.tables.length)
                            for (var i = 0; i < message.tables.length; ++i)
                                $root.palexy.task_management.v1.CrosstabTable.encode(message.tables[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCrosstabTablesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCrosstabTablesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IGetCrosstabTablesResponse} message GetCrosstabTablesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCrosstabTablesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCrosstabTablesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCrosstabTablesResponse} GetCrosstabTablesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabTablesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCrosstabTablesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.tables && message.tables.length))
                                    message.tables = [];
                                message.tables.push($root.palexy.task_management.v1.CrosstabTable.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCrosstabTablesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCrosstabTablesResponse} GetCrosstabTablesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCrosstabTablesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCrosstabTablesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCrosstabTablesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.tables != null && message.hasOwnProperty("tables")) {
                            if (!Array.isArray(message.tables))
                                return "tables: array expected";
                            for (var i = 0; i < message.tables.length; ++i) {
                                var error = $root.palexy.task_management.v1.CrosstabTable.verify(message.tables[i]);
                                if (error)
                                    return "tables." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetCrosstabTablesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCrosstabTablesResponse} GetCrosstabTablesResponse
                     */
                    GetCrosstabTablesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCrosstabTablesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCrosstabTablesResponse();
                        if (object.tables) {
                            if (!Array.isArray(object.tables))
                                throw TypeError(".palexy.task_management.v1.GetCrosstabTablesResponse.tables: array expected");
                            message.tables = [];
                            for (var i = 0; i < object.tables.length; ++i) {
                                if (typeof object.tables[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.GetCrosstabTablesResponse.tables: object expected");
                                message.tables[i] = $root.palexy.task_management.v1.CrosstabTable.fromObject(object.tables[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCrosstabTablesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @static
                     * @param {palexy.task_management.v1.GetCrosstabTablesResponse} message GetCrosstabTablesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCrosstabTablesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.tables = [];
                        if (message.tables && message.tables.length) {
                            object.tables = [];
                            for (var j = 0; j < message.tables.length; ++j)
                                object.tables[j] = $root.palexy.task_management.v1.CrosstabTable.toObject(message.tables[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetCrosstabTablesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCrosstabTablesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCrosstabTablesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCrosstabTablesResponse;
                })();
    
                v1.CrosstabTable = (function() {
    
                    /**
                     * Properties of a CrosstabTable.
                     * @memberof palexy.task_management.v1
                     * @interface ICrosstabTable
                     * @property {palexy.task_management.v1.IVariableRef|null} [rowVariable] CrosstabTable rowVariable
                     * @property {Array.<palexy.task_management.v1.IBannerColumn>|null} [columns] CrosstabTable columns
                     * @property {Array.<palexy.task_management.v1.IRowCategoryResult>|null} [rowCategories] CrosstabTable rowCategories
                     * @property {Array.<palexy.task_management.v1.ITableWarning>|null} [warnings] CrosstabTable warnings
                     * @property {number|null} [respondentCount] CrosstabTable respondentCount
                     */
    
                    /**
                     * Constructs a new CrosstabTable.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CrosstabTable.
                     * @implements ICrosstabTable
                     * @constructor
                     * @param {palexy.task_management.v1.ICrosstabTable=} [properties] Properties to set
                     */
                    function CrosstabTable(properties) {
                        this.columns = [];
                        this.rowCategories = [];
                        this.warnings = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CrosstabTable rowVariable.
                     * @member {palexy.task_management.v1.IVariableRef|null|undefined} rowVariable
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     */
                    CrosstabTable.prototype.rowVariable = null;
    
                    /**
                     * CrosstabTable columns.
                     * @member {Array.<palexy.task_management.v1.IBannerColumn>} columns
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     */
                    CrosstabTable.prototype.columns = $util.emptyArray;
    
                    /**
                     * CrosstabTable rowCategories.
                     * @member {Array.<palexy.task_management.v1.IRowCategoryResult>} rowCategories
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     */
                    CrosstabTable.prototype.rowCategories = $util.emptyArray;
    
                    /**
                     * CrosstabTable warnings.
                     * @member {Array.<palexy.task_management.v1.ITableWarning>} warnings
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     */
                    CrosstabTable.prototype.warnings = $util.emptyArray;
    
                    /**
                     * CrosstabTable respondentCount.
                     * @member {number} respondentCount
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     */
                    CrosstabTable.prototype.respondentCount = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CrosstabTable instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabTable=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CrosstabTable} CrosstabTable instance
                     */
                    CrosstabTable.create = function create(properties) {
                        return new CrosstabTable(properties);
                    };
    
                    /**
                     * Encodes the specified CrosstabTable message. Does not implicitly {@link palexy.task_management.v1.CrosstabTable.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabTable} message CrosstabTable message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabTable.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.rowVariable != null && Object.hasOwnProperty.call(message, "rowVariable"))
                            $root.palexy.task_management.v1.VariableRef.encode(message.rowVariable, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.columns != null && message.columns.length)
                            for (var i = 0; i < message.columns.length; ++i)
                                $root.palexy.task_management.v1.BannerColumn.encode(message.columns[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.rowCategories != null && message.rowCategories.length)
                            for (var i = 0; i < message.rowCategories.length; ++i)
                                $root.palexy.task_management.v1.RowCategoryResult.encode(message.rowCategories[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.warnings != null && message.warnings.length)
                            for (var i = 0; i < message.warnings.length; ++i)
                                $root.palexy.task_management.v1.TableWarning.encode(message.warnings[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.respondentCount != null && Object.hasOwnProperty.call(message, "respondentCount"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.respondentCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CrosstabTable message, length delimited. Does not implicitly {@link palexy.task_management.v1.CrosstabTable.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {palexy.task_management.v1.ICrosstabTable} message CrosstabTable message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CrosstabTable.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CrosstabTable message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CrosstabTable} CrosstabTable
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabTable.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CrosstabTable();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.rowVariable = $root.palexy.task_management.v1.VariableRef.decode(reader, reader.uint32());
                                break;
                            case 2:
                                if (!(message.columns && message.columns.length))
                                    message.columns = [];
                                message.columns.push($root.palexy.task_management.v1.BannerColumn.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.rowCategories && message.rowCategories.length))
                                    message.rowCategories = [];
                                message.rowCategories.push($root.palexy.task_management.v1.RowCategoryResult.decode(reader, reader.uint32()));
                                break;
                            case 4:
                                if (!(message.warnings && message.warnings.length))
                                    message.warnings = [];
                                message.warnings.push($root.palexy.task_management.v1.TableWarning.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.respondentCount = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CrosstabTable message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CrosstabTable} CrosstabTable
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CrosstabTable.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CrosstabTable message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CrosstabTable.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.rowVariable != null && message.hasOwnProperty("rowVariable")) {
                            var error = $root.palexy.task_management.v1.VariableRef.verify(message.rowVariable);
                            if (error)
                                return "rowVariable." + error;
                        }
                        if (message.columns != null && message.hasOwnProperty("columns")) {
                            if (!Array.isArray(message.columns))
                                return "columns: array expected";
                            for (var i = 0; i < message.columns.length; ++i) {
                                var error = $root.palexy.task_management.v1.BannerColumn.verify(message.columns[i]);
                                if (error)
                                    return "columns." + error;
                            }
                        }
                        if (message.rowCategories != null && message.hasOwnProperty("rowCategories")) {
                            if (!Array.isArray(message.rowCategories))
                                return "rowCategories: array expected";
                            for (var i = 0; i < message.rowCategories.length; ++i) {
                                var error = $root.palexy.task_management.v1.RowCategoryResult.verify(message.rowCategories[i]);
                                if (error)
                                    return "rowCategories." + error;
                            }
                        }
                        if (message.warnings != null && message.hasOwnProperty("warnings")) {
                            if (!Array.isArray(message.warnings))
                                return "warnings: array expected";
                            for (var i = 0; i < message.warnings.length; ++i) {
                                var error = $root.palexy.task_management.v1.TableWarning.verify(message.warnings[i]);
                                if (error)
                                    return "warnings." + error;
                            }
                        }
                        if (message.respondentCount != null && message.hasOwnProperty("respondentCount"))
                            if (!$util.isInteger(message.respondentCount) && !(message.respondentCount && $util.isInteger(message.respondentCount.low) && $util.isInteger(message.respondentCount.high)))
                                return "respondentCount: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CrosstabTable message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CrosstabTable} CrosstabTable
                     */
                    CrosstabTable.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CrosstabTable)
                            return object;
                        var message = new $root.palexy.task_management.v1.CrosstabTable();
                        if (object.rowVariable != null) {
                            if (typeof object.rowVariable !== "object")
                                throw TypeError(".palexy.task_management.v1.CrosstabTable.rowVariable: object expected");
                            message.rowVariable = $root.palexy.task_management.v1.VariableRef.fromObject(object.rowVariable);
                        }
                        if (object.columns) {
                            if (!Array.isArray(object.columns))
                                throw TypeError(".palexy.task_management.v1.CrosstabTable.columns: array expected");
                            message.columns = [];
                            for (var i = 0; i < object.columns.length; ++i) {
                                if (typeof object.columns[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabTable.columns: object expected");
                                message.columns[i] = $root.palexy.task_management.v1.BannerColumn.fromObject(object.columns[i]);
                            }
                        }
                        if (object.rowCategories) {
                            if (!Array.isArray(object.rowCategories))
                                throw TypeError(".palexy.task_management.v1.CrosstabTable.rowCategories: array expected");
                            message.rowCategories = [];
                            for (var i = 0; i < object.rowCategories.length; ++i) {
                                if (typeof object.rowCategories[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabTable.rowCategories: object expected");
                                message.rowCategories[i] = $root.palexy.task_management.v1.RowCategoryResult.fromObject(object.rowCategories[i]);
                            }
                        }
                        if (object.warnings) {
                            if (!Array.isArray(object.warnings))
                                throw TypeError(".palexy.task_management.v1.CrosstabTable.warnings: array expected");
                            message.warnings = [];
                            for (var i = 0; i < object.warnings.length; ++i) {
                                if (typeof object.warnings[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CrosstabTable.warnings: object expected");
                                message.warnings[i] = $root.palexy.task_management.v1.TableWarning.fromObject(object.warnings[i]);
                            }
                        }
                        if (object.respondentCount != null)
                            if ($util.Long)
                                (message.respondentCount = $util.Long.fromValue(object.respondentCount)).unsigned = false;
                            else if (typeof object.respondentCount === "string")
                                message.respondentCount = parseInt(object.respondentCount, 10);
                            else if (typeof object.respondentCount === "number")
                                message.respondentCount = object.respondentCount;
                            else if (typeof object.respondentCount === "object")
                                message.respondentCount = new $util.LongBits(object.respondentCount.low >>> 0, object.respondentCount.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CrosstabTable message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @static
                     * @param {palexy.task_management.v1.CrosstabTable} message CrosstabTable
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CrosstabTable.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.columns = [];
                            object.rowCategories = [];
                            object.warnings = [];
                        }
                        if (options.defaults) {
                            object.rowVariable = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.respondentCount = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.respondentCount = options.longs === String ? "0" : 0;
                        }
                        if (message.rowVariable != null && message.hasOwnProperty("rowVariable"))
                            object.rowVariable = $root.palexy.task_management.v1.VariableRef.toObject(message.rowVariable, options);
                        if (message.columns && message.columns.length) {
                            object.columns = [];
                            for (var j = 0; j < message.columns.length; ++j)
                                object.columns[j] = $root.palexy.task_management.v1.BannerColumn.toObject(message.columns[j], options);
                        }
                        if (message.rowCategories && message.rowCategories.length) {
                            object.rowCategories = [];
                            for (var j = 0; j < message.rowCategories.length; ++j)
                                object.rowCategories[j] = $root.palexy.task_management.v1.RowCategoryResult.toObject(message.rowCategories[j], options);
                        }
                        if (message.warnings && message.warnings.length) {
                            object.warnings = [];
                            for (var j = 0; j < message.warnings.length; ++j)
                                object.warnings[j] = $root.palexy.task_management.v1.TableWarning.toObject(message.warnings[j], options);
                        }
                        if (message.respondentCount != null && message.hasOwnProperty("respondentCount"))
                            if (typeof message.respondentCount === "number")
                                object.respondentCount = options.longs === String ? String(message.respondentCount) : message.respondentCount;
                            else
                                object.respondentCount = options.longs === String ? $util.Long.prototype.toString.call(message.respondentCount) : options.longs === Number ? new $util.LongBits(message.respondentCount.low >>> 0, message.respondentCount.high >>> 0).toNumber() : message.respondentCount;
                        return object;
                    };
    
                    /**
                     * Converts this CrosstabTable to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CrosstabTable
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CrosstabTable.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CrosstabTable;
                })();
    
                v1.BannerColumn = (function() {
    
                    /**
                     * Properties of a BannerColumn.
                     * @memberof palexy.task_management.v1
                     * @interface IBannerColumn
                     * @property {string|null} [label] BannerColumn label
                     * @property {string|null} [columnLetter] BannerColumn columnLetter
                     * @property {number|null} [bannerGroupIndex] BannerColumn bannerGroupIndex
                     * @property {number|null} [baseAll] BannerColumn baseAll
                     * @property {number|null} [baseAnswering] BannerColumn baseAnswering
                     * @property {boolean|null} [isTotal] BannerColumn isTotal
                     * @property {boolean|null} [isSmallBase] BannerColumn isSmallBase
                     */
    
                    /**
                     * Constructs a new BannerColumn.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a BannerColumn.
                     * @implements IBannerColumn
                     * @constructor
                     * @param {palexy.task_management.v1.IBannerColumn=} [properties] Properties to set
                     */
                    function BannerColumn(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * BannerColumn label.
                     * @member {string} label
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.label = "";
    
                    /**
                     * BannerColumn columnLetter.
                     * @member {string} columnLetter
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.columnLetter = "";
    
                    /**
                     * BannerColumn bannerGroupIndex.
                     * @member {number} bannerGroupIndex
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.bannerGroupIndex = 0;
    
                    /**
                     * BannerColumn baseAll.
                     * @member {number} baseAll
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.baseAll = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BannerColumn baseAnswering.
                     * @member {number} baseAnswering
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.baseAnswering = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * BannerColumn isTotal.
                     * @member {boolean} isTotal
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.isTotal = false;
    
                    /**
                     * BannerColumn isSmallBase.
                     * @member {boolean} isSmallBase
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     */
                    BannerColumn.prototype.isSmallBase = false;
    
                    /**
                     * Creates a new BannerColumn instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {palexy.task_management.v1.IBannerColumn=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.BannerColumn} BannerColumn instance
                     */
                    BannerColumn.create = function create(properties) {
                        return new BannerColumn(properties);
                    };
    
                    /**
                     * Encodes the specified BannerColumn message. Does not implicitly {@link palexy.task_management.v1.BannerColumn.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {palexy.task_management.v1.IBannerColumn} message BannerColumn message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerColumn.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.label);
                        if (message.columnLetter != null && Object.hasOwnProperty.call(message, "columnLetter"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.columnLetter);
                        if (message.bannerGroupIndex != null && Object.hasOwnProperty.call(message, "bannerGroupIndex"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.bannerGroupIndex);
                        if (message.baseAll != null && Object.hasOwnProperty.call(message, "baseAll"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.baseAll);
                        if (message.baseAnswering != null && Object.hasOwnProperty.call(message, "baseAnswering"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.baseAnswering);
                        if (message.isTotal != null && Object.hasOwnProperty.call(message, "isTotal"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isTotal);
                        if (message.isSmallBase != null && Object.hasOwnProperty.call(message, "isSmallBase"))
                            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.isSmallBase);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified BannerColumn message, length delimited. Does not implicitly {@link palexy.task_management.v1.BannerColumn.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {palexy.task_management.v1.IBannerColumn} message BannerColumn message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    BannerColumn.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a BannerColumn message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.BannerColumn} BannerColumn
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerColumn.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.BannerColumn();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.label = reader.string();
                                break;
                            case 2:
                                message.columnLetter = reader.string();
                                break;
                            case 3:
                                message.bannerGroupIndex = reader.int32();
                                break;
                            case 4:
                                message.baseAll = reader.int64();
                                break;
                            case 5:
                                message.baseAnswering = reader.int64();
                                break;
                            case 7:
                                message.isTotal = reader.bool();
                                break;
                            case 8:
                                message.isSmallBase = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a BannerColumn message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.BannerColumn} BannerColumn
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    BannerColumn.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a BannerColumn message.
                     * @function verify
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    BannerColumn.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        if (message.columnLetter != null && message.hasOwnProperty("columnLetter"))
                            if (!$util.isString(message.columnLetter))
                                return "columnLetter: string expected";
                        if (message.bannerGroupIndex != null && message.hasOwnProperty("bannerGroupIndex"))
                            if (!$util.isInteger(message.bannerGroupIndex))
                                return "bannerGroupIndex: integer expected";
                        if (message.baseAll != null && message.hasOwnProperty("baseAll"))
                            if (!$util.isInteger(message.baseAll) && !(message.baseAll && $util.isInteger(message.baseAll.low) && $util.isInteger(message.baseAll.high)))
                                return "baseAll: integer|Long expected";
                        if (message.baseAnswering != null && message.hasOwnProperty("baseAnswering"))
                            if (!$util.isInteger(message.baseAnswering) && !(message.baseAnswering && $util.isInteger(message.baseAnswering.low) && $util.isInteger(message.baseAnswering.high)))
                                return "baseAnswering: integer|Long expected";
                        if (message.isTotal != null && message.hasOwnProperty("isTotal"))
                            if (typeof message.isTotal !== "boolean")
                                return "isTotal: boolean expected";
                        if (message.isSmallBase != null && message.hasOwnProperty("isSmallBase"))
                            if (typeof message.isSmallBase !== "boolean")
                                return "isSmallBase: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a BannerColumn message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.BannerColumn} BannerColumn
                     */
                    BannerColumn.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.BannerColumn)
                            return object;
                        var message = new $root.palexy.task_management.v1.BannerColumn();
                        if (object.label != null)
                            message.label = String(object.label);
                        if (object.columnLetter != null)
                            message.columnLetter = String(object.columnLetter);
                        if (object.bannerGroupIndex != null)
                            message.bannerGroupIndex = object.bannerGroupIndex | 0;
                        if (object.baseAll != null)
                            if ($util.Long)
                                (message.baseAll = $util.Long.fromValue(object.baseAll)).unsigned = false;
                            else if (typeof object.baseAll === "string")
                                message.baseAll = parseInt(object.baseAll, 10);
                            else if (typeof object.baseAll === "number")
                                message.baseAll = object.baseAll;
                            else if (typeof object.baseAll === "object")
                                message.baseAll = new $util.LongBits(object.baseAll.low >>> 0, object.baseAll.high >>> 0).toNumber();
                        if (object.baseAnswering != null)
                            if ($util.Long)
                                (message.baseAnswering = $util.Long.fromValue(object.baseAnswering)).unsigned = false;
                            else if (typeof object.baseAnswering === "string")
                                message.baseAnswering = parseInt(object.baseAnswering, 10);
                            else if (typeof object.baseAnswering === "number")
                                message.baseAnswering = object.baseAnswering;
                            else if (typeof object.baseAnswering === "object")
                                message.baseAnswering = new $util.LongBits(object.baseAnswering.low >>> 0, object.baseAnswering.high >>> 0).toNumber();
                        if (object.isTotal != null)
                            message.isTotal = Boolean(object.isTotal);
                        if (object.isSmallBase != null)
                            message.isSmallBase = Boolean(object.isSmallBase);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a BannerColumn message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @static
                     * @param {palexy.task_management.v1.BannerColumn} message BannerColumn
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    BannerColumn.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.label = "";
                            object.columnLetter = "";
                            object.bannerGroupIndex = 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.baseAll = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.baseAll = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.baseAnswering = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.baseAnswering = options.longs === String ? "0" : 0;
                            object.isTotal = false;
                            object.isSmallBase = false;
                        }
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        if (message.columnLetter != null && message.hasOwnProperty("columnLetter"))
                            object.columnLetter = message.columnLetter;
                        if (message.bannerGroupIndex != null && message.hasOwnProperty("bannerGroupIndex"))
                            object.bannerGroupIndex = message.bannerGroupIndex;
                        if (message.baseAll != null && message.hasOwnProperty("baseAll"))
                            if (typeof message.baseAll === "number")
                                object.baseAll = options.longs === String ? String(message.baseAll) : message.baseAll;
                            else
                                object.baseAll = options.longs === String ? $util.Long.prototype.toString.call(message.baseAll) : options.longs === Number ? new $util.LongBits(message.baseAll.low >>> 0, message.baseAll.high >>> 0).toNumber() : message.baseAll;
                        if (message.baseAnswering != null && message.hasOwnProperty("baseAnswering"))
                            if (typeof message.baseAnswering === "number")
                                object.baseAnswering = options.longs === String ? String(message.baseAnswering) : message.baseAnswering;
                            else
                                object.baseAnswering = options.longs === String ? $util.Long.prototype.toString.call(message.baseAnswering) : options.longs === Number ? new $util.LongBits(message.baseAnswering.low >>> 0, message.baseAnswering.high >>> 0).toNumber() : message.baseAnswering;
                        if (message.isTotal != null && message.hasOwnProperty("isTotal"))
                            object.isTotal = message.isTotal;
                        if (message.isSmallBase != null && message.hasOwnProperty("isSmallBase"))
                            object.isSmallBase = message.isSmallBase;
                        return object;
                    };
    
                    /**
                     * Converts this BannerColumn to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.BannerColumn
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    BannerColumn.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return BannerColumn;
                })();
    
                v1.RowCategoryResult = (function() {
    
                    /**
                     * Properties of a RowCategoryResult.
                     * @memberof palexy.task_management.v1
                     * @interface IRowCategoryResult
                     * @property {string|null} [categoryKey] RowCategoryResult categoryKey
                     * @property {string|null} [categoryLabel] RowCategoryResult categoryLabel
                     * @property {Array.<palexy.task_management.v1.ICellResult>|null} [cells] RowCategoryResult cells
                     */
    
                    /**
                     * Constructs a new RowCategoryResult.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a RowCategoryResult.
                     * @implements IRowCategoryResult
                     * @constructor
                     * @param {palexy.task_management.v1.IRowCategoryResult=} [properties] Properties to set
                     */
                    function RowCategoryResult(properties) {
                        this.cells = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RowCategoryResult categoryKey.
                     * @member {string} categoryKey
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @instance
                     */
                    RowCategoryResult.prototype.categoryKey = "";
    
                    /**
                     * RowCategoryResult categoryLabel.
                     * @member {string} categoryLabel
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @instance
                     */
                    RowCategoryResult.prototype.categoryLabel = "";
    
                    /**
                     * RowCategoryResult cells.
                     * @member {Array.<palexy.task_management.v1.ICellResult>} cells
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @instance
                     */
                    RowCategoryResult.prototype.cells = $util.emptyArray;
    
                    /**
                     * Creates a new RowCategoryResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {palexy.task_management.v1.IRowCategoryResult=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.RowCategoryResult} RowCategoryResult instance
                     */
                    RowCategoryResult.create = function create(properties) {
                        return new RowCategoryResult(properties);
                    };
    
                    /**
                     * Encodes the specified RowCategoryResult message. Does not implicitly {@link palexy.task_management.v1.RowCategoryResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {palexy.task_management.v1.IRowCategoryResult} message RowCategoryResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RowCategoryResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.categoryKey != null && Object.hasOwnProperty.call(message, "categoryKey"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.categoryKey);
                        if (message.categoryLabel != null && Object.hasOwnProperty.call(message, "categoryLabel"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.categoryLabel);
                        if (message.cells != null && message.cells.length)
                            for (var i = 0; i < message.cells.length; ++i)
                                $root.palexy.task_management.v1.CellResult.encode(message.cells[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RowCategoryResult message, length delimited. Does not implicitly {@link palexy.task_management.v1.RowCategoryResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {palexy.task_management.v1.IRowCategoryResult} message RowCategoryResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RowCategoryResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RowCategoryResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.RowCategoryResult} RowCategoryResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RowCategoryResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.RowCategoryResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.categoryKey = reader.string();
                                break;
                            case 2:
                                message.categoryLabel = reader.string();
                                break;
                            case 3:
                                if (!(message.cells && message.cells.length))
                                    message.cells = [];
                                message.cells.push($root.palexy.task_management.v1.CellResult.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RowCategoryResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.RowCategoryResult} RowCategoryResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RowCategoryResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RowCategoryResult message.
                     * @function verify
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RowCategoryResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.categoryKey != null && message.hasOwnProperty("categoryKey"))
                            if (!$util.isString(message.categoryKey))
                                return "categoryKey: string expected";
                        if (message.categoryLabel != null && message.hasOwnProperty("categoryLabel"))
                            if (!$util.isString(message.categoryLabel))
                                return "categoryLabel: string expected";
                        if (message.cells != null && message.hasOwnProperty("cells")) {
                            if (!Array.isArray(message.cells))
                                return "cells: array expected";
                            for (var i = 0; i < message.cells.length; ++i) {
                                var error = $root.palexy.task_management.v1.CellResult.verify(message.cells[i]);
                                if (error)
                                    return "cells." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RowCategoryResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.RowCategoryResult} RowCategoryResult
                     */
                    RowCategoryResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.RowCategoryResult)
                            return object;
                        var message = new $root.palexy.task_management.v1.RowCategoryResult();
                        if (object.categoryKey != null)
                            message.categoryKey = String(object.categoryKey);
                        if (object.categoryLabel != null)
                            message.categoryLabel = String(object.categoryLabel);
                        if (object.cells) {
                            if (!Array.isArray(object.cells))
                                throw TypeError(".palexy.task_management.v1.RowCategoryResult.cells: array expected");
                            message.cells = [];
                            for (var i = 0; i < object.cells.length; ++i) {
                                if (typeof object.cells[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.RowCategoryResult.cells: object expected");
                                message.cells[i] = $root.palexy.task_management.v1.CellResult.fromObject(object.cells[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RowCategoryResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @static
                     * @param {palexy.task_management.v1.RowCategoryResult} message RowCategoryResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RowCategoryResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.cells = [];
                        if (options.defaults) {
                            object.categoryKey = "";
                            object.categoryLabel = "";
                        }
                        if (message.categoryKey != null && message.hasOwnProperty("categoryKey"))
                            object.categoryKey = message.categoryKey;
                        if (message.categoryLabel != null && message.hasOwnProperty("categoryLabel"))
                            object.categoryLabel = message.categoryLabel;
                        if (message.cells && message.cells.length) {
                            object.cells = [];
                            for (var j = 0; j < message.cells.length; ++j)
                                object.cells[j] = $root.palexy.task_management.v1.CellResult.toObject(message.cells[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RowCategoryResult to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.RowCategoryResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RowCategoryResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RowCategoryResult;
                })();
    
                v1.CellResult = (function() {
    
                    /**
                     * Properties of a CellResult.
                     * @memberof palexy.task_management.v1
                     * @interface ICellResult
                     * @property {number|null} [count] CellResult count
                     * @property {Array.<palexy.task_management.v1.ICellPercent>|null} [percents] CellResult percents
                     * @property {Array.<palexy.task_management.v1.ICellComparison>|null} [comparisons] CellResult comparisons
                     */
    
                    /**
                     * Constructs a new CellResult.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CellResult.
                     * @implements ICellResult
                     * @constructor
                     * @param {palexy.task_management.v1.ICellResult=} [properties] Properties to set
                     */
                    function CellResult(properties) {
                        this.percents = [];
                        this.comparisons = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CellResult count.
                     * @member {number} count
                     * @memberof palexy.task_management.v1.CellResult
                     * @instance
                     */
                    CellResult.prototype.count = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CellResult percents.
                     * @member {Array.<palexy.task_management.v1.ICellPercent>} percents
                     * @memberof palexy.task_management.v1.CellResult
                     * @instance
                     */
                    CellResult.prototype.percents = $util.emptyArray;
    
                    /**
                     * CellResult comparisons.
                     * @member {Array.<palexy.task_management.v1.ICellComparison>} comparisons
                     * @memberof palexy.task_management.v1.CellResult
                     * @instance
                     */
                    CellResult.prototype.comparisons = $util.emptyArray;
    
                    /**
                     * Creates a new CellResult instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {palexy.task_management.v1.ICellResult=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CellResult} CellResult instance
                     */
                    CellResult.create = function create(properties) {
                        return new CellResult(properties);
                    };
    
                    /**
                     * Encodes the specified CellResult message. Does not implicitly {@link palexy.task_management.v1.CellResult.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {palexy.task_management.v1.ICellResult} message CellResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellResult.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.count != null && Object.hasOwnProperty.call(message, "count"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.count);
                        if (message.percents != null && message.percents.length)
                            for (var i = 0; i < message.percents.length; ++i)
                                $root.palexy.task_management.v1.CellPercent.encode(message.percents[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.comparisons != null && message.comparisons.length)
                            for (var i = 0; i < message.comparisons.length; ++i)
                                $root.palexy.task_management.v1.CellComparison.encode(message.comparisons[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CellResult message, length delimited. Does not implicitly {@link palexy.task_management.v1.CellResult.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {palexy.task_management.v1.ICellResult} message CellResult message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellResult.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CellResult message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CellResult} CellResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellResult.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CellResult();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.count = reader.int64();
                                break;
                            case 2:
                                if (!(message.percents && message.percents.length))
                                    message.percents = [];
                                message.percents.push($root.palexy.task_management.v1.CellPercent.decode(reader, reader.uint32()));
                                break;
                            case 3:
                                if (!(message.comparisons && message.comparisons.length))
                                    message.comparisons = [];
                                message.comparisons.push($root.palexy.task_management.v1.CellComparison.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CellResult message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CellResult} CellResult
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellResult.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CellResult message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CellResult.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (!$util.isInteger(message.count) && !(message.count && $util.isInteger(message.count.low) && $util.isInteger(message.count.high)))
                                return "count: integer|Long expected";
                        if (message.percents != null && message.hasOwnProperty("percents")) {
                            if (!Array.isArray(message.percents))
                                return "percents: array expected";
                            for (var i = 0; i < message.percents.length; ++i) {
                                var error = $root.palexy.task_management.v1.CellPercent.verify(message.percents[i]);
                                if (error)
                                    return "percents." + error;
                            }
                        }
                        if (message.comparisons != null && message.hasOwnProperty("comparisons")) {
                            if (!Array.isArray(message.comparisons))
                                return "comparisons: array expected";
                            for (var i = 0; i < message.comparisons.length; ++i) {
                                var error = $root.palexy.task_management.v1.CellComparison.verify(message.comparisons[i]);
                                if (error)
                                    return "comparisons." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CellResult message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CellResult} CellResult
                     */
                    CellResult.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CellResult)
                            return object;
                        var message = new $root.palexy.task_management.v1.CellResult();
                        if (object.count != null)
                            if ($util.Long)
                                (message.count = $util.Long.fromValue(object.count)).unsigned = false;
                            else if (typeof object.count === "string")
                                message.count = parseInt(object.count, 10);
                            else if (typeof object.count === "number")
                                message.count = object.count;
                            else if (typeof object.count === "object")
                                message.count = new $util.LongBits(object.count.low >>> 0, object.count.high >>> 0).toNumber();
                        if (object.percents) {
                            if (!Array.isArray(object.percents))
                                throw TypeError(".palexy.task_management.v1.CellResult.percents: array expected");
                            message.percents = [];
                            for (var i = 0; i < object.percents.length; ++i) {
                                if (typeof object.percents[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CellResult.percents: object expected");
                                message.percents[i] = $root.palexy.task_management.v1.CellPercent.fromObject(object.percents[i]);
                            }
                        }
                        if (object.comparisons) {
                            if (!Array.isArray(object.comparisons))
                                throw TypeError(".palexy.task_management.v1.CellResult.comparisons: array expected");
                            message.comparisons = [];
                            for (var i = 0; i < object.comparisons.length; ++i) {
                                if (typeof object.comparisons[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CellResult.comparisons: object expected");
                                message.comparisons[i] = $root.palexy.task_management.v1.CellComparison.fromObject(object.comparisons[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CellResult message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CellResult
                     * @static
                     * @param {palexy.task_management.v1.CellResult} message CellResult
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CellResult.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.percents = [];
                            object.comparisons = [];
                        }
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.count = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.count = options.longs === String ? "0" : 0;
                        if (message.count != null && message.hasOwnProperty("count"))
                            if (typeof message.count === "number")
                                object.count = options.longs === String ? String(message.count) : message.count;
                            else
                                object.count = options.longs === String ? $util.Long.prototype.toString.call(message.count) : options.longs === Number ? new $util.LongBits(message.count.low >>> 0, message.count.high >>> 0).toNumber() : message.count;
                        if (message.percents && message.percents.length) {
                            object.percents = [];
                            for (var j = 0; j < message.percents.length; ++j)
                                object.percents[j] = $root.palexy.task_management.v1.CellPercent.toObject(message.percents[j], options);
                        }
                        if (message.comparisons && message.comparisons.length) {
                            object.comparisons = [];
                            for (var j = 0; j < message.comparisons.length; ++j)
                                object.comparisons[j] = $root.palexy.task_management.v1.CellComparison.toObject(message.comparisons[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CellResult to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CellResult
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CellResult.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CellResult;
                })();
    
                v1.CellPercent = (function() {
    
                    /**
                     * Properties of a CellPercent.
                     * @memberof palexy.task_management.v1
                     * @interface ICellPercent
                     * @property {palexy.task_management.v1.ValueTypeSelection.ValueType|null} [basis] CellPercent basis
                     * @property {number|null} [value] CellPercent value
                     */
    
                    /**
                     * Constructs a new CellPercent.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CellPercent.
                     * @implements ICellPercent
                     * @constructor
                     * @param {palexy.task_management.v1.ICellPercent=} [properties] Properties to set
                     */
                    function CellPercent(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CellPercent basis.
                     * @member {palexy.task_management.v1.ValueTypeSelection.ValueType} basis
                     * @memberof palexy.task_management.v1.CellPercent
                     * @instance
                     */
                    CellPercent.prototype.basis = 0;
    
                    /**
                     * CellPercent value.
                     * @member {number} value
                     * @memberof palexy.task_management.v1.CellPercent
                     * @instance
                     */
                    CellPercent.prototype.value = 0;
    
                    /**
                     * Creates a new CellPercent instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {palexy.task_management.v1.ICellPercent=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CellPercent} CellPercent instance
                     */
                    CellPercent.create = function create(properties) {
                        return new CellPercent(properties);
                    };
    
                    /**
                     * Encodes the specified CellPercent message. Does not implicitly {@link palexy.task_management.v1.CellPercent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {palexy.task_management.v1.ICellPercent} message CellPercent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellPercent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.basis != null && Object.hasOwnProperty.call(message, "basis"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.basis);
                        if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                            writer.uint32(/* id 2, wireType 1 =*/17).double(message.value);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CellPercent message, length delimited. Does not implicitly {@link palexy.task_management.v1.CellPercent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {palexy.task_management.v1.ICellPercent} message CellPercent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellPercent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CellPercent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CellPercent} CellPercent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellPercent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CellPercent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.basis = reader.int32();
                                break;
                            case 2:
                                message.value = reader.double();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CellPercent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CellPercent} CellPercent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellPercent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CellPercent message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CellPercent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.basis != null && message.hasOwnProperty("basis"))
                            switch (message.basis) {
                            default:
                                return "basis: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.value != null && message.hasOwnProperty("value"))
                            if (typeof message.value !== "number")
                                return "value: number expected";
                        return null;
                    };
    
                    /**
                     * Creates a CellPercent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CellPercent} CellPercent
                     */
                    CellPercent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CellPercent)
                            return object;
                        var message = new $root.palexy.task_management.v1.CellPercent();
                        switch (object.basis) {
                        case "VALUE_TYPE_UNSPECIFIED":
                        case 0:
                            message.basis = 0;
                            break;
                        case "TOTAL_COUNT":
                        case 1:
                            message.basis = 1;
                            break;
                        case "COUNT":
                        case 2:
                            message.basis = 2;
                            break;
                        case "COLUMN_PERCENT_ALL":
                        case 3:
                            message.basis = 3;
                            break;
                        case "COLUMN_PERCENT_ANSWERING":
                        case 4:
                            message.basis = 4;
                            break;
                        }
                        if (object.value != null)
                            message.value = Number(object.value);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CellPercent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CellPercent
                     * @static
                     * @param {palexy.task_management.v1.CellPercent} message CellPercent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CellPercent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.basis = options.enums === String ? "VALUE_TYPE_UNSPECIFIED" : 0;
                            object.value = 0;
                        }
                        if (message.basis != null && message.hasOwnProperty("basis"))
                            object.basis = options.enums === String ? $root.palexy.task_management.v1.ValueTypeSelection.ValueType[message.basis] : message.basis;
                        if (message.value != null && message.hasOwnProperty("value"))
                            object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                        return object;
                    };
    
                    /**
                     * Converts this CellPercent to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CellPercent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CellPercent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CellPercent;
                })();
    
                v1.CellComparison = (function() {
    
                    /**
                     * Properties of a CellComparison.
                     * @memberof palexy.task_management.v1
                     * @interface ICellComparison
                     * @property {palexy.task_management.v1.ValueTypeSelection.ValueType|null} [basis] CellComparison basis
                     * @property {string|null} [columnLetter] CellComparison columnLetter
                     * @property {number|null} [pValue] CellComparison pValue
                     * @property {palexy.task_management.v1.CellComparison.Direction|null} [direction] CellComparison direction
                     */
    
                    /**
                     * Constructs a new CellComparison.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CellComparison.
                     * @implements ICellComparison
                     * @constructor
                     * @param {palexy.task_management.v1.ICellComparison=} [properties] Properties to set
                     */
                    function CellComparison(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CellComparison basis.
                     * @member {palexy.task_management.v1.ValueTypeSelection.ValueType} basis
                     * @memberof palexy.task_management.v1.CellComparison
                     * @instance
                     */
                    CellComparison.prototype.basis = 0;
    
                    /**
                     * CellComparison columnLetter.
                     * @member {string} columnLetter
                     * @memberof palexy.task_management.v1.CellComparison
                     * @instance
                     */
                    CellComparison.prototype.columnLetter = "";
    
                    /**
                     * CellComparison pValue.
                     * @member {number} pValue
                     * @memberof palexy.task_management.v1.CellComparison
                     * @instance
                     */
                    CellComparison.prototype.pValue = 0;
    
                    /**
                     * CellComparison direction.
                     * @member {palexy.task_management.v1.CellComparison.Direction} direction
                     * @memberof palexy.task_management.v1.CellComparison
                     * @instance
                     */
                    CellComparison.prototype.direction = 0;
    
                    /**
                     * Creates a new CellComparison instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {palexy.task_management.v1.ICellComparison=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CellComparison} CellComparison instance
                     */
                    CellComparison.create = function create(properties) {
                        return new CellComparison(properties);
                    };
    
                    /**
                     * Encodes the specified CellComparison message. Does not implicitly {@link palexy.task_management.v1.CellComparison.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {palexy.task_management.v1.ICellComparison} message CellComparison message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellComparison.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.basis != null && Object.hasOwnProperty.call(message, "basis"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.basis);
                        if (message.columnLetter != null && Object.hasOwnProperty.call(message, "columnLetter"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.columnLetter);
                        if (message.pValue != null && Object.hasOwnProperty.call(message, "pValue"))
                            writer.uint32(/* id 3, wireType 1 =*/25).double(message.pValue);
                        if (message.direction != null && Object.hasOwnProperty.call(message, "direction"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.direction);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CellComparison message, length delimited. Does not implicitly {@link palexy.task_management.v1.CellComparison.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {palexy.task_management.v1.ICellComparison} message CellComparison message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CellComparison.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CellComparison message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CellComparison} CellComparison
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellComparison.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CellComparison();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.basis = reader.int32();
                                break;
                            case 2:
                                message.columnLetter = reader.string();
                                break;
                            case 3:
                                message.pValue = reader.double();
                                break;
                            case 4:
                                message.direction = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CellComparison message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CellComparison} CellComparison
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CellComparison.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CellComparison message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CellComparison.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.basis != null && message.hasOwnProperty("basis"))
                            switch (message.basis) {
                            default:
                                return "basis: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                break;
                            }
                        if (message.columnLetter != null && message.hasOwnProperty("columnLetter"))
                            if (!$util.isString(message.columnLetter))
                                return "columnLetter: string expected";
                        if (message.pValue != null && message.hasOwnProperty("pValue"))
                            if (typeof message.pValue !== "number")
                                return "pValue: number expected";
                        if (message.direction != null && message.hasOwnProperty("direction"))
                            switch (message.direction) {
                            default:
                                return "direction: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        return null;
                    };
    
                    /**
                     * Creates a CellComparison message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CellComparison} CellComparison
                     */
                    CellComparison.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CellComparison)
                            return object;
                        var message = new $root.palexy.task_management.v1.CellComparison();
                        switch (object.basis) {
                        case "VALUE_TYPE_UNSPECIFIED":
                        case 0:
                            message.basis = 0;
                            break;
                        case "TOTAL_COUNT":
                        case 1:
                            message.basis = 1;
                            break;
                        case "COUNT":
                        case 2:
                            message.basis = 2;
                            break;
                        case "COLUMN_PERCENT_ALL":
                        case 3:
                            message.basis = 3;
                            break;
                        case "COLUMN_PERCENT_ANSWERING":
                        case 4:
                            message.basis = 4;
                            break;
                        }
                        if (object.columnLetter != null)
                            message.columnLetter = String(object.columnLetter);
                        if (object.pValue != null)
                            message.pValue = Number(object.pValue);
                        switch (object.direction) {
                        case "DIRECTION_UNSPECIFIED":
                        case 0:
                            message.direction = 0;
                            break;
                        case "HIGHER":
                        case 1:
                            message.direction = 1;
                            break;
                        case "LOWER":
                        case 2:
                            message.direction = 2;
                            break;
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CellComparison message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CellComparison
                     * @static
                     * @param {palexy.task_management.v1.CellComparison} message CellComparison
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CellComparison.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.basis = options.enums === String ? "VALUE_TYPE_UNSPECIFIED" : 0;
                            object.columnLetter = "";
                            object.pValue = 0;
                            object.direction = options.enums === String ? "DIRECTION_UNSPECIFIED" : 0;
                        }
                        if (message.basis != null && message.hasOwnProperty("basis"))
                            object.basis = options.enums === String ? $root.palexy.task_management.v1.ValueTypeSelection.ValueType[message.basis] : message.basis;
                        if (message.columnLetter != null && message.hasOwnProperty("columnLetter"))
                            object.columnLetter = message.columnLetter;
                        if (message.pValue != null && message.hasOwnProperty("pValue"))
                            object.pValue = options.json && !isFinite(message.pValue) ? String(message.pValue) : message.pValue;
                        if (message.direction != null && message.hasOwnProperty("direction"))
                            object.direction = options.enums === String ? $root.palexy.task_management.v1.CellComparison.Direction[message.direction] : message.direction;
                        return object;
                    };
    
                    /**
                     * Converts this CellComparison to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CellComparison
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CellComparison.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Direction enum.
                     * @name palexy.task_management.v1.CellComparison.Direction
                     * @enum {number}
                     * @property {number} DIRECTION_UNSPECIFIED=0 DIRECTION_UNSPECIFIED value
                     * @property {number} HIGHER=1 HIGHER value
                     * @property {number} LOWER=2 LOWER value
                     */
                    CellComparison.Direction = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "DIRECTION_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "HIGHER"] = 1;
                        values[valuesById[2] = "LOWER"] = 2;
                        return values;
                    })();
    
                    return CellComparison;
                })();
    
                v1.TableWarning = (function() {
    
                    /**
                     * Properties of a TableWarning.
                     * @memberof palexy.task_management.v1
                     * @interface ITableWarning
                     * @property {palexy.task_management.v1.TableWarning.WarningType|null} [type] TableWarning type
                     * @property {Object.<string,string>|null} [params] TableWarning params
                     * @property {number|null} [bannerGroupIndex] TableWarning bannerGroupIndex
                     */
    
                    /**
                     * Constructs a new TableWarning.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a TableWarning.
                     * @implements ITableWarning
                     * @constructor
                     * @param {palexy.task_management.v1.ITableWarning=} [properties] Properties to set
                     */
                    function TableWarning(properties) {
                        this.params = {};
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * TableWarning type.
                     * @member {palexy.task_management.v1.TableWarning.WarningType} type
                     * @memberof palexy.task_management.v1.TableWarning
                     * @instance
                     */
                    TableWarning.prototype.type = 0;
    
                    /**
                     * TableWarning params.
                     * @member {Object.<string,string>} params
                     * @memberof palexy.task_management.v1.TableWarning
                     * @instance
                     */
                    TableWarning.prototype.params = $util.emptyObject;
    
                    /**
                     * TableWarning bannerGroupIndex.
                     * @member {number|null|undefined} bannerGroupIndex
                     * @memberof palexy.task_management.v1.TableWarning
                     * @instance
                     */
                    TableWarning.prototype.bannerGroupIndex = null;
    
                    // OneOf field names bound to virtual getters and setters
                    var $oneOfFields;
    
                    /**
                     * TableWarning _bannerGroupIndex.
                     * @member {"bannerGroupIndex"|undefined} _bannerGroupIndex
                     * @memberof palexy.task_management.v1.TableWarning
                     * @instance
                     */
                    Object.defineProperty(TableWarning.prototype, "_bannerGroupIndex", {
                        get: $util.oneOfGetter($oneOfFields = ["bannerGroupIndex"]),
                        set: $util.oneOfSetter($oneOfFields)
                    });
    
                    /**
                     * Creates a new TableWarning instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {palexy.task_management.v1.ITableWarning=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.TableWarning} TableWarning instance
                     */
                    TableWarning.create = function create(properties) {
                        return new TableWarning(properties);
                    };
    
                    /**
                     * Encodes the specified TableWarning message. Does not implicitly {@link palexy.task_management.v1.TableWarning.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {palexy.task_management.v1.ITableWarning} message TableWarning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TableWarning.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.type);
                        if (message.params != null && Object.hasOwnProperty.call(message, "params"))
                            for (var keys = Object.keys(message.params), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 3, wireType 2 =*/26).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.params[keys[i]]).ldelim();
                        if (message.bannerGroupIndex != null && Object.hasOwnProperty.call(message, "bannerGroupIndex"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.bannerGroupIndex);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified TableWarning message, length delimited. Does not implicitly {@link palexy.task_management.v1.TableWarning.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {palexy.task_management.v1.ITableWarning} message TableWarning message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    TableWarning.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a TableWarning message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.TableWarning} TableWarning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TableWarning.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.TableWarning(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.type = reader.int32();
                                break;
                            case 3:
                                if (message.params === $util.emptyObject)
                                    message.params = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.params[key] = value;
                                break;
                            case 5:
                                message.bannerGroupIndex = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a TableWarning message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.TableWarning} TableWarning
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    TableWarning.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a TableWarning message.
                     * @function verify
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    TableWarning.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        var properties = {};
                        if (message.type != null && message.hasOwnProperty("type"))
                            switch (message.type) {
                            default:
                                return "type: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                            case 6:
                                break;
                            }
                        if (message.params != null && message.hasOwnProperty("params")) {
                            if (!$util.isObject(message.params))
                                return "params: object expected";
                            var key = Object.keys(message.params);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.params[key[i]]))
                                    return "params: string{k:string} expected";
                        }
                        if (message.bannerGroupIndex != null && message.hasOwnProperty("bannerGroupIndex")) {
                            properties._bannerGroupIndex = 1;
                            if (!$util.isInteger(message.bannerGroupIndex))
                                return "bannerGroupIndex: integer expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a TableWarning message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.TableWarning} TableWarning
                     */
                    TableWarning.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.TableWarning)
                            return object;
                        var message = new $root.palexy.task_management.v1.TableWarning();
                        switch (object.type) {
                        case "WARNING_TYPE_UNSPECIFIED":
                        case 0:
                            message.type = 0;
                            break;
                        case "SMALL_BASE":
                        case 1:
                            message.type = 1;
                            break;
                        case "MULTI_VALUE_PERCENT_MAY_EXCEED_100":
                        case 2:
                            message.type = 2;
                            break;
                        case "VARIABLE_NO_LONGER_AVAILABLE":
                        case 3:
                            message.type = 3;
                            break;
                        case "CATEGORY_COUNT_TRUNCATED":
                        case 4:
                            message.type = 4;
                            break;
                        case "MULTI_VALUE_BOTH_AXES_BLOCKED":
                        case 5:
                            message.type = 5;
                            break;
                        case "NO_DATA_FOR_COLUMN_VARIABLE":
                        case 6:
                            message.type = 6;
                            break;
                        }
                        if (object.params) {
                            if (typeof object.params !== "object")
                                throw TypeError(".palexy.task_management.v1.TableWarning.params: object expected");
                            message.params = {};
                            for (var keys = Object.keys(object.params), i = 0; i < keys.length; ++i)
                                message.params[keys[i]] = String(object.params[keys[i]]);
                        }
                        if (object.bannerGroupIndex != null)
                            message.bannerGroupIndex = object.bannerGroupIndex | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a TableWarning message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.TableWarning
                     * @static
                     * @param {palexy.task_management.v1.TableWarning} message TableWarning
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    TableWarning.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.objects || options.defaults)
                            object.params = {};
                        if (options.defaults)
                            object.type = options.enums === String ? "WARNING_TYPE_UNSPECIFIED" : 0;
                        if (message.type != null && message.hasOwnProperty("type"))
                            object.type = options.enums === String ? $root.palexy.task_management.v1.TableWarning.WarningType[message.type] : message.type;
                        var keys2;
                        if (message.params && (keys2 = Object.keys(message.params)).length) {
                            object.params = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.params[keys2[j]] = message.params[keys2[j]];
                        }
                        if (message.bannerGroupIndex != null && message.hasOwnProperty("bannerGroupIndex")) {
                            object.bannerGroupIndex = message.bannerGroupIndex;
                            if (options.oneofs)
                                object._bannerGroupIndex = "bannerGroupIndex";
                        }
                        return object;
                    };
    
                    /**
                     * Converts this TableWarning to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.TableWarning
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    TableWarning.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * WarningType enum.
                     * @name palexy.task_management.v1.TableWarning.WarningType
                     * @enum {number}
                     * @property {number} WARNING_TYPE_UNSPECIFIED=0 WARNING_TYPE_UNSPECIFIED value
                     * @property {number} SMALL_BASE=1 SMALL_BASE value
                     * @property {number} MULTI_VALUE_PERCENT_MAY_EXCEED_100=2 MULTI_VALUE_PERCENT_MAY_EXCEED_100 value
                     * @property {number} VARIABLE_NO_LONGER_AVAILABLE=3 VARIABLE_NO_LONGER_AVAILABLE value
                     * @property {number} CATEGORY_COUNT_TRUNCATED=4 CATEGORY_COUNT_TRUNCATED value
                     * @property {number} MULTI_VALUE_BOTH_AXES_BLOCKED=5 MULTI_VALUE_BOTH_AXES_BLOCKED value
                     * @property {number} NO_DATA_FOR_COLUMN_VARIABLE=6 NO_DATA_FOR_COLUMN_VARIABLE value
                     */
                    TableWarning.WarningType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "WARNING_TYPE_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "SMALL_BASE"] = 1;
                        values[valuesById[2] = "MULTI_VALUE_PERCENT_MAY_EXCEED_100"] = 2;
                        values[valuesById[3] = "VARIABLE_NO_LONGER_AVAILABLE"] = 3;
                        values[valuesById[4] = "CATEGORY_COUNT_TRUNCATED"] = 4;
                        values[valuesById[5] = "MULTI_VALUE_BOTH_AXES_BLOCKED"] = 5;
                        values[valuesById[6] = "NO_DATA_FOR_COLUMN_VARIABLE"] = 6;
                        return values;
                    })();
    
                    return TableWarning;
                })();
    
                v1.ListAnalysisVariablesRequest = (function() {
    
                    /**
                     * Properties of a ListAnalysisVariablesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListAnalysisVariablesRequest
                     * @property {number|null} [formId] ListAnalysisVariablesRequest formId
                     */
    
                    /**
                     * Constructs a new ListAnalysisVariablesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListAnalysisVariablesRequest.
                     * @implements IListAnalysisVariablesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest=} [properties] Properties to set
                     */
                    function ListAnalysisVariablesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAnalysisVariablesRequest formId.
                     * @member {number} formId
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @instance
                     */
                    ListAnalysisVariablesRequest.prototype.formId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListAnalysisVariablesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesRequest} ListAnalysisVariablesRequest instance
                     */
                    ListAnalysisVariablesRequest.create = function create(properties) {
                        return new ListAnalysisVariablesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListAnalysisVariablesRequest message. Does not implicitly {@link palexy.task_management.v1.ListAnalysisVariablesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest} message ListAnalysisVariablesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAnalysisVariablesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.formId != null && Object.hasOwnProperty.call(message, "formId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.formId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAnalysisVariablesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListAnalysisVariablesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesRequest} message ListAnalysisVariablesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAnalysisVariablesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAnalysisVariablesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesRequest} ListAnalysisVariablesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAnalysisVariablesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListAnalysisVariablesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.formId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAnalysisVariablesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesRequest} ListAnalysisVariablesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAnalysisVariablesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAnalysisVariablesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAnalysisVariablesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (!$util.isInteger(message.formId) && !(message.formId && $util.isInteger(message.formId.low) && $util.isInteger(message.formId.high)))
                                return "formId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListAnalysisVariablesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesRequest} ListAnalysisVariablesRequest
                     */
                    ListAnalysisVariablesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListAnalysisVariablesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListAnalysisVariablesRequest();
                        if (object.formId != null)
                            if ($util.Long)
                                (message.formId = $util.Long.fromValue(object.formId)).unsigned = false;
                            else if (typeof object.formId === "string")
                                message.formId = parseInt(object.formId, 10);
                            else if (typeof object.formId === "number")
                                message.formId = object.formId;
                            else if (typeof object.formId === "object")
                                message.formId = new $util.LongBits(object.formId.low >>> 0, object.formId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAnalysisVariablesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListAnalysisVariablesRequest} message ListAnalysisVariablesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAnalysisVariablesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.formId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.formId = options.longs === String ? "0" : 0;
                        if (message.formId != null && message.hasOwnProperty("formId"))
                            if (typeof message.formId === "number")
                                object.formId = options.longs === String ? String(message.formId) : message.formId;
                            else
                                object.formId = options.longs === String ? $util.Long.prototype.toString.call(message.formId) : options.longs === Number ? new $util.LongBits(message.formId.low >>> 0, message.formId.high >>> 0).toNumber() : message.formId;
                        return object;
                    };
    
                    /**
                     * Converts this ListAnalysisVariablesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAnalysisVariablesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAnalysisVariablesRequest;
                })();
    
                v1.ListAnalysisVariablesResponse = (function() {
    
                    /**
                     * Properties of a ListAnalysisVariablesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListAnalysisVariablesResponse
                     * @property {Array.<palexy.task_management.v1.IAnalysisVariableInfo>|null} [variables] ListAnalysisVariablesResponse variables
                     */
    
                    /**
                     * Constructs a new ListAnalysisVariablesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListAnalysisVariablesResponse.
                     * @implements IListAnalysisVariablesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListAnalysisVariablesResponse=} [properties] Properties to set
                     */
                    function ListAnalysisVariablesResponse(properties) {
                        this.variables = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListAnalysisVariablesResponse variables.
                     * @member {Array.<palexy.task_management.v1.IAnalysisVariableInfo>} variables
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @instance
                     */
                    ListAnalysisVariablesResponse.prototype.variables = $util.emptyArray;
    
                    /**
                     * Creates a new ListAnalysisVariablesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesResponse} ListAnalysisVariablesResponse instance
                     */
                    ListAnalysisVariablesResponse.create = function create(properties) {
                        return new ListAnalysisVariablesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListAnalysisVariablesResponse message. Does not implicitly {@link palexy.task_management.v1.ListAnalysisVariablesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesResponse} message ListAnalysisVariablesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAnalysisVariablesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.variables != null && message.variables.length)
                            for (var i = 0; i < message.variables.length; ++i)
                                $root.palexy.task_management.v1.AnalysisVariableInfo.encode(message.variables[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListAnalysisVariablesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListAnalysisVariablesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListAnalysisVariablesResponse} message ListAnalysisVariablesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListAnalysisVariablesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListAnalysisVariablesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesResponse} ListAnalysisVariablesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAnalysisVariablesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListAnalysisVariablesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.variables && message.variables.length))
                                    message.variables = [];
                                message.variables.push($root.palexy.task_management.v1.AnalysisVariableInfo.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListAnalysisVariablesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesResponse} ListAnalysisVariablesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListAnalysisVariablesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListAnalysisVariablesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListAnalysisVariablesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.variables != null && message.hasOwnProperty("variables")) {
                            if (!Array.isArray(message.variables))
                                return "variables: array expected";
                            for (var i = 0; i < message.variables.length; ++i) {
                                var error = $root.palexy.task_management.v1.AnalysisVariableInfo.verify(message.variables[i]);
                                if (error)
                                    return "variables." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListAnalysisVariablesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListAnalysisVariablesResponse} ListAnalysisVariablesResponse
                     */
                    ListAnalysisVariablesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListAnalysisVariablesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListAnalysisVariablesResponse();
                        if (object.variables) {
                            if (!Array.isArray(object.variables))
                                throw TypeError(".palexy.task_management.v1.ListAnalysisVariablesResponse.variables: array expected");
                            message.variables = [];
                            for (var i = 0; i < object.variables.length; ++i) {
                                if (typeof object.variables[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListAnalysisVariablesResponse.variables: object expected");
                                message.variables[i] = $root.palexy.task_management.v1.AnalysisVariableInfo.fromObject(object.variables[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListAnalysisVariablesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListAnalysisVariablesResponse} message ListAnalysisVariablesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListAnalysisVariablesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.variables = [];
                        if (message.variables && message.variables.length) {
                            object.variables = [];
                            for (var j = 0; j < message.variables.length; ++j)
                                object.variables[j] = $root.palexy.task_management.v1.AnalysisVariableInfo.toObject(message.variables[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListAnalysisVariablesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListAnalysisVariablesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListAnalysisVariablesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListAnalysisVariablesResponse;
                })();
    
                v1.AnalysisVariableInfo = (function() {
    
                    /**
                     * Properties of an AnalysisVariableInfo.
                     * @memberof palexy.task_management.v1
                     * @interface IAnalysisVariableInfo
                     * @property {palexy.task_management.v1.IVariableRef|null} [ref] AnalysisVariableInfo ref
                     * @property {string|null} [label] AnalysisVariableInfo label
                     * @property {palexy.task_management.v1.AnalysisVariableInfo.VariableGroup|null} [group] AnalysisVariableInfo group
                     * @property {palexy.task_management.v1.AnalysisVariableInfo.Usability|null} [usability] AnalysisVariableInfo usability
                     * @property {palexy.task_management.v1.AnalysisVariableInfo.UnusableReason|null} [unusableReason] AnalysisVariableInfo unusableReason
                     * @property {boolean|null} [isMultiValue] AnalysisVariableInfo isMultiValue
                     * @property {Array.<palexy.task_management.v1.IOption>|null} [options] AnalysisVariableInfo options
                     */
    
                    /**
                     * Constructs a new AnalysisVariableInfo.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AnalysisVariableInfo.
                     * @implements IAnalysisVariableInfo
                     * @constructor
                     * @param {palexy.task_management.v1.IAnalysisVariableInfo=} [properties] Properties to set
                     */
                    function AnalysisVariableInfo(properties) {
                        this.options = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AnalysisVariableInfo ref.
                     * @member {palexy.task_management.v1.IVariableRef|null|undefined} ref
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.ref = null;
    
                    /**
                     * AnalysisVariableInfo label.
                     * @member {string} label
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.label = "";
    
                    /**
                     * AnalysisVariableInfo group.
                     * @member {palexy.task_management.v1.AnalysisVariableInfo.VariableGroup} group
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.group = 0;
    
                    /**
                     * AnalysisVariableInfo usability.
                     * @member {palexy.task_management.v1.AnalysisVariableInfo.Usability} usability
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.usability = 0;
    
                    /**
                     * AnalysisVariableInfo unusableReason.
                     * @member {palexy.task_management.v1.AnalysisVariableInfo.UnusableReason} unusableReason
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.unusableReason = 0;
    
                    /**
                     * AnalysisVariableInfo isMultiValue.
                     * @member {boolean} isMultiValue
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.isMultiValue = false;
    
                    /**
                     * AnalysisVariableInfo options.
                     * @member {Array.<palexy.task_management.v1.IOption>} options
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     */
                    AnalysisVariableInfo.prototype.options = $util.emptyArray;
    
                    /**
                     * Creates a new AnalysisVariableInfo instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisVariableInfo=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AnalysisVariableInfo} AnalysisVariableInfo instance
                     */
                    AnalysisVariableInfo.create = function create(properties) {
                        return new AnalysisVariableInfo(properties);
                    };
    
                    /**
                     * Encodes the specified AnalysisVariableInfo message. Does not implicitly {@link palexy.task_management.v1.AnalysisVariableInfo.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisVariableInfo} message AnalysisVariableInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnalysisVariableInfo.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ref != null && Object.hasOwnProperty.call(message, "ref"))
                            $root.palexy.task_management.v1.VariableRef.encode(message.ref, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.label);
                        if (message.group != null && Object.hasOwnProperty.call(message, "group"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.group);
                        if (message.usability != null && Object.hasOwnProperty.call(message, "usability"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.usability);
                        if (message.unusableReason != null && Object.hasOwnProperty.call(message, "unusableReason"))
                            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.unusableReason);
                        if (message.isMultiValue != null && Object.hasOwnProperty.call(message, "isMultiValue"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isMultiValue);
                        if (message.options != null && message.options.length)
                            for (var i = 0; i < message.options.length; ++i)
                                $root.palexy.task_management.v1.Option.encode(message.options[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AnalysisVariableInfo message, length delimited. Does not implicitly {@link palexy.task_management.v1.AnalysisVariableInfo.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {palexy.task_management.v1.IAnalysisVariableInfo} message AnalysisVariableInfo message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AnalysisVariableInfo.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AnalysisVariableInfo message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AnalysisVariableInfo} AnalysisVariableInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnalysisVariableInfo.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AnalysisVariableInfo();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.ref = $root.palexy.task_management.v1.VariableRef.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.label = reader.string();
                                break;
                            case 3:
                                message.group = reader.int32();
                                break;
                            case 4:
                                message.usability = reader.int32();
                                break;
                            case 6:
                                message.unusableReason = reader.int32();
                                break;
                            case 7:
                                message.isMultiValue = reader.bool();
                                break;
                            case 8:
                                if (!(message.options && message.options.length))
                                    message.options = [];
                                message.options.push($root.palexy.task_management.v1.Option.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AnalysisVariableInfo message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AnalysisVariableInfo} AnalysisVariableInfo
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AnalysisVariableInfo.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AnalysisVariableInfo message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AnalysisVariableInfo.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ref != null && message.hasOwnProperty("ref")) {
                            var error = $root.palexy.task_management.v1.VariableRef.verify(message.ref);
                            if (error)
                                return "ref." + error;
                        }
                        if (message.label != null && message.hasOwnProperty("label"))
                            if (!$util.isString(message.label))
                                return "label: string expected";
                        if (message.group != null && message.hasOwnProperty("group"))
                            switch (message.group) {
                            default:
                                return "group: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.usability != null && message.hasOwnProperty("usability"))
                            switch (message.usability) {
                            default:
                                return "usability: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                                break;
                            }
                        if (message.unusableReason != null && message.hasOwnProperty("unusableReason"))
                            switch (message.unusableReason) {
                            default:
                                return "unusableReason: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.isMultiValue != null && message.hasOwnProperty("isMultiValue"))
                            if (typeof message.isMultiValue !== "boolean")
                                return "isMultiValue: boolean expected";
                        if (message.options != null && message.hasOwnProperty("options")) {
                            if (!Array.isArray(message.options))
                                return "options: array expected";
                            for (var i = 0; i < message.options.length; ++i) {
                                var error = $root.palexy.task_management.v1.Option.verify(message.options[i]);
                                if (error)
                                    return "options." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AnalysisVariableInfo message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AnalysisVariableInfo} AnalysisVariableInfo
                     */
                    AnalysisVariableInfo.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AnalysisVariableInfo)
                            return object;
                        var message = new $root.palexy.task_management.v1.AnalysisVariableInfo();
                        if (object.ref != null) {
                            if (typeof object.ref !== "object")
                                throw TypeError(".palexy.task_management.v1.AnalysisVariableInfo.ref: object expected");
                            message.ref = $root.palexy.task_management.v1.VariableRef.fromObject(object.ref);
                        }
                        if (object.label != null)
                            message.label = String(object.label);
                        switch (object.group) {
                        case "VARIABLE_GROUP_UNSPECIFIED":
                        case 0:
                            message.group = 0;
                            break;
                        case "QUESTIONS":
                        case 1:
                            message.group = 1;
                            break;
                        case "CUSTOM_ATTRIBUTES":
                        case 2:
                            message.group = 2;
                            break;
                        }
                        switch (object.usability) {
                        case "USABILITY_UNSPECIFIED":
                        case 0:
                            message.usability = 0;
                            break;
                        case "USABLE":
                        case 1:
                            message.usability = 1;
                            break;
                        case "UNUSABLE_PERMANENT":
                        case 2:
                            message.usability = 2;
                            break;
                        case "UNUSABLE_NOT_YET":
                        case 3:
                            message.usability = 3;
                            break;
                        }
                        switch (object.unusableReason) {
                        case "UNUSABLE_REASON_UNSPECIFIED":
                        case 0:
                            message.unusableReason = 0;
                            break;
                        case "FREE_TEXT_NOT_CATEGORICAL":
                        case 1:
                            message.unusableReason = 1;
                            break;
                        case "FILE_OR_PHOTO_NOT_ANALYSABLE":
                        case 2:
                            message.unusableReason = 2;
                            break;
                        case "DATE_NEEDS_BUCKETING":
                        case 3:
                            message.unusableReason = 3;
                            break;
                        case "NUMERIC_NEEDS_BUCKETING":
                        case 4:
                            message.unusableReason = 4;
                            break;
                        case "UNSUPPORTED_QUESTION_TYPE":
                        case 5:
                            message.unusableReason = 5;
                            break;
                        }
                        if (object.isMultiValue != null)
                            message.isMultiValue = Boolean(object.isMultiValue);
                        if (object.options) {
                            if (!Array.isArray(object.options))
                                throw TypeError(".palexy.task_management.v1.AnalysisVariableInfo.options: array expected");
                            message.options = [];
                            for (var i = 0; i < object.options.length; ++i) {
                                if (typeof object.options[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.AnalysisVariableInfo.options: object expected");
                                message.options[i] = $root.palexy.task_management.v1.Option.fromObject(object.options[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AnalysisVariableInfo message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @static
                     * @param {palexy.task_management.v1.AnalysisVariableInfo} message AnalysisVariableInfo
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AnalysisVariableInfo.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.options = [];
                        if (options.defaults) {
                            object.ref = null;
                            object.label = "";
                            object.group = options.enums === String ? "VARIABLE_GROUP_UNSPECIFIED" : 0;
                            object.usability = options.enums === String ? "USABILITY_UNSPECIFIED" : 0;
                            object.unusableReason = options.enums === String ? "UNUSABLE_REASON_UNSPECIFIED" : 0;
                            object.isMultiValue = false;
                        }
                        if (message.ref != null && message.hasOwnProperty("ref"))
                            object.ref = $root.palexy.task_management.v1.VariableRef.toObject(message.ref, options);
                        if (message.label != null && message.hasOwnProperty("label"))
                            object.label = message.label;
                        if (message.group != null && message.hasOwnProperty("group"))
                            object.group = options.enums === String ? $root.palexy.task_management.v1.AnalysisVariableInfo.VariableGroup[message.group] : message.group;
                        if (message.usability != null && message.hasOwnProperty("usability"))
                            object.usability = options.enums === String ? $root.palexy.task_management.v1.AnalysisVariableInfo.Usability[message.usability] : message.usability;
                        if (message.unusableReason != null && message.hasOwnProperty("unusableReason"))
                            object.unusableReason = options.enums === String ? $root.palexy.task_management.v1.AnalysisVariableInfo.UnusableReason[message.unusableReason] : message.unusableReason;
                        if (message.isMultiValue != null && message.hasOwnProperty("isMultiValue"))
                            object.isMultiValue = message.isMultiValue;
                        if (message.options && message.options.length) {
                            object.options = [];
                            for (var j = 0; j < message.options.length; ++j)
                                object.options[j] = $root.palexy.task_management.v1.Option.toObject(message.options[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AnalysisVariableInfo to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AnalysisVariableInfo
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AnalysisVariableInfo.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * VariableGroup enum.
                     * @name palexy.task_management.v1.AnalysisVariableInfo.VariableGroup
                     * @enum {number}
                     * @property {number} VARIABLE_GROUP_UNSPECIFIED=0 VARIABLE_GROUP_UNSPECIFIED value
                     * @property {number} QUESTIONS=1 QUESTIONS value
                     * @property {number} CUSTOM_ATTRIBUTES=2 CUSTOM_ATTRIBUTES value
                     */
                    AnalysisVariableInfo.VariableGroup = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "VARIABLE_GROUP_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "QUESTIONS"] = 1;
                        values[valuesById[2] = "CUSTOM_ATTRIBUTES"] = 2;
                        return values;
                    })();
    
                    /**
                     * Usability enum.
                     * @name palexy.task_management.v1.AnalysisVariableInfo.Usability
                     * @enum {number}
                     * @property {number} USABILITY_UNSPECIFIED=0 USABILITY_UNSPECIFIED value
                     * @property {number} USABLE=1 USABLE value
                     * @property {number} UNUSABLE_PERMANENT=2 UNUSABLE_PERMANENT value
                     * @property {number} UNUSABLE_NOT_YET=3 UNUSABLE_NOT_YET value
                     */
                    AnalysisVariableInfo.Usability = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "USABILITY_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "USABLE"] = 1;
                        values[valuesById[2] = "UNUSABLE_PERMANENT"] = 2;
                        values[valuesById[3] = "UNUSABLE_NOT_YET"] = 3;
                        return values;
                    })();
    
                    /**
                     * UnusableReason enum.
                     * @name palexy.task_management.v1.AnalysisVariableInfo.UnusableReason
                     * @enum {number}
                     * @property {number} UNUSABLE_REASON_UNSPECIFIED=0 UNUSABLE_REASON_UNSPECIFIED value
                     * @property {number} FREE_TEXT_NOT_CATEGORICAL=1 FREE_TEXT_NOT_CATEGORICAL value
                     * @property {number} FILE_OR_PHOTO_NOT_ANALYSABLE=2 FILE_OR_PHOTO_NOT_ANALYSABLE value
                     * @property {number} DATE_NEEDS_BUCKETING=3 DATE_NEEDS_BUCKETING value
                     * @property {number} NUMERIC_NEEDS_BUCKETING=4 NUMERIC_NEEDS_BUCKETING value
                     * @property {number} UNSUPPORTED_QUESTION_TYPE=5 UNSUPPORTED_QUESTION_TYPE value
                     */
                    AnalysisVariableInfo.UnusableReason = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNUSABLE_REASON_UNSPECIFIED"] = 0;
                        values[valuesById[1] = "FREE_TEXT_NOT_CATEGORICAL"] = 1;
                        values[valuesById[2] = "FILE_OR_PHOTO_NOT_ANALYSABLE"] = 2;
                        values[valuesById[3] = "DATE_NEEDS_BUCKETING"] = 3;
                        values[valuesById[4] = "NUMERIC_NEEDS_BUCKETING"] = 4;
                        values[valuesById[5] = "UNSUPPORTED_QUESTION_TYPE"] = 5;
                        return values;
                    })();
    
                    return AnalysisVariableInfo;
                })();
    
                v1.CompanyContactService = (function() {
    
                    /**
                     * Constructs a new CompanyContactService service.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompanyContactService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function CompanyContactService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (CompanyContactService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = CompanyContactService;
    
                    /**
                     * Creates new CompanyContactService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {CompanyContactService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    CompanyContactService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#getCompanyContactsSummary}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef GetCompanyContactsSummaryCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContactsSummary} [response] CompanyContactsSummary
                     */
    
                    /**
                     * Calls GetCompanyContactsSummary.
                     * @function getCompanyContactsSummary
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest} request GetCompanyContactsSummaryRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.GetCompanyContactsSummaryCallback} callback Node-style callback called with the error, if any, and CompanyContactsSummary
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.getCompanyContactsSummary = function getCompanyContactsSummary(request, callback) {
                        return this.rpcCall(getCompanyContactsSummary, $root.palexy.task_management.v1.GetCompanyContactsSummaryRequest, $root.palexy.task_management.v1.CompanyContactsSummary, request, callback);
                    }, "name", { value: "GetCompanyContactsSummary" });
    
                    /**
                     * Calls GetCompanyContactsSummary.
                     * @function getCompanyContactsSummary
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest} request GetCompanyContactsSummaryRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContactsSummary>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#searchCompanyContacts}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef SearchCompanyContactsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.SearchCompanyContactsResponse} [response] SearchCompanyContactsResponse
                     */
    
                    /**
                     * Calls SearchCompanyContacts.
                     * @function searchCompanyContacts
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest} request SearchCompanyContactsRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.SearchCompanyContactsCallback} callback Node-style callback called with the error, if any, and SearchCompanyContactsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.searchCompanyContacts = function searchCompanyContacts(request, callback) {
                        return this.rpcCall(searchCompanyContacts, $root.palexy.task_management.v1.SearchCompanyContactsRequest, $root.palexy.task_management.v1.SearchCompanyContactsResponse, request, callback);
                    }, "name", { value: "SearchCompanyContacts" });
    
                    /**
                     * Calls SearchCompanyContacts.
                     * @function searchCompanyContacts
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest} request SearchCompanyContactsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.SearchCompanyContactsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#getCompanyContact}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef GetCompanyContactCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContact} [response] CompanyContact
                     */
    
                    /**
                     * Calls GetCompanyContact.
                     * @function getCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest} request GetCompanyContactRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.GetCompanyContactCallback} callback Node-style callback called with the error, if any, and CompanyContact
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.getCompanyContact = function getCompanyContact(request, callback) {
                        return this.rpcCall(getCompanyContact, $root.palexy.task_management.v1.GetCompanyContactRequest, $root.palexy.task_management.v1.CompanyContact, request, callback);
                    }, "name", { value: "GetCompanyContact" });
    
                    /**
                     * Calls GetCompanyContact.
                     * @function getCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest} request GetCompanyContactRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContact>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#createCompanyContact}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef CreateCompanyContactCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContact} [response] CompanyContact
                     */
    
                    /**
                     * Calls CreateCompanyContact.
                     * @function createCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest} request CreateCompanyContactRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.CreateCompanyContactCallback} callback Node-style callback called with the error, if any, and CompanyContact
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.createCompanyContact = function createCompanyContact(request, callback) {
                        return this.rpcCall(createCompanyContact, $root.palexy.task_management.v1.CreateCompanyContactRequest, $root.palexy.task_management.v1.CompanyContact, request, callback);
                    }, "name", { value: "CreateCompanyContact" });
    
                    /**
                     * Calls CreateCompanyContact.
                     * @function createCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest} request CreateCompanyContactRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContact>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#updateCompanyContact}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef UpdateCompanyContactCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContact} [response] CompanyContact
                     */
    
                    /**
                     * Calls UpdateCompanyContact.
                     * @function updateCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest} request UpdateCompanyContactRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.UpdateCompanyContactCallback} callback Node-style callback called with the error, if any, and CompanyContact
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.updateCompanyContact = function updateCompanyContact(request, callback) {
                        return this.rpcCall(updateCompanyContact, $root.palexy.task_management.v1.UpdateCompanyContactRequest, $root.palexy.task_management.v1.CompanyContact, request, callback);
                    }, "name", { value: "UpdateCompanyContact" });
    
                    /**
                     * Calls UpdateCompanyContact.
                     * @function updateCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest} request UpdateCompanyContactRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContact>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#deleteCompanyContact}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef DeleteCompanyContactCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteCompanyContact.
                     * @function deleteCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest} request DeleteCompanyContactRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.DeleteCompanyContactCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.deleteCompanyContact = function deleteCompanyContact(request, callback) {
                        return this.rpcCall(deleteCompanyContact, $root.palexy.task_management.v1.DeleteCompanyContactRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteCompanyContact" });
    
                    /**
                     * Calls DeleteCompanyContact.
                     * @function deleteCompanyContact
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest} request DeleteCompanyContactRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#listCompanyContactPropertyCodes}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef ListCompanyContactPropertyCodesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} [response] ListCompanyContactPropertyCodesResponse
                     */
    
                    /**
                     * Calls ListCompanyContactPropertyCodes.
                     * @function listCompanyContactPropertyCodes
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest} request ListCompanyContactPropertyCodesRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.ListCompanyContactPropertyCodesCallback} callback Node-style callback called with the error, if any, and ListCompanyContactPropertyCodesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.listCompanyContactPropertyCodes = function listCompanyContactPropertyCodes(request, callback) {
                        return this.rpcCall(listCompanyContactPropertyCodes, $root.palexy.task_management.v1.ListCompanyContactPropertyCodesRequest, $root.palexy.task_management.v1.ListCompanyContactPropertyCodesResponse, request, callback);
                    }, "name", { value: "ListCompanyContactPropertyCodes" });
    
                    /**
                     * Calls ListCompanyContactPropertyCodes.
                     * @function listCompanyContactPropertyCodes
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest} request ListCompanyContactPropertyCodesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListCompanyContactPropertyCodesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#listCompanyContactListPropertyCodes}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef ListCompanyContactListPropertyCodesCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} [response] ListCompanyContactListPropertyCodesResponse
                     */
    
                    /**
                     * Calls ListCompanyContactListPropertyCodes.
                     * @function listCompanyContactListPropertyCodes
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest} request ListCompanyContactListPropertyCodesRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.ListCompanyContactListPropertyCodesCallback} callback Node-style callback called with the error, if any, and ListCompanyContactListPropertyCodesResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.listCompanyContactListPropertyCodes = function listCompanyContactListPropertyCodes(request, callback) {
                        return this.rpcCall(listCompanyContactListPropertyCodes, $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest, $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse, request, callback);
                    }, "name", { value: "ListCompanyContactListPropertyCodes" });
    
                    /**
                     * Calls ListCompanyContactListPropertyCodes.
                     * @function listCompanyContactListPropertyCodes
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest} request ListCompanyContactListPropertyCodesRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#listCompanyContactLists}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef ListCompanyContactListsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ListCompanyContactListsResponse} [response] ListCompanyContactListsResponse
                     */
    
                    /**
                     * Calls ListCompanyContactLists.
                     * @function listCompanyContactLists
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest} request ListCompanyContactListsRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.ListCompanyContactListsCallback} callback Node-style callback called with the error, if any, and ListCompanyContactListsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.listCompanyContactLists = function listCompanyContactLists(request, callback) {
                        return this.rpcCall(listCompanyContactLists, $root.palexy.task_management.v1.ListCompanyContactListsRequest, $root.palexy.task_management.v1.ListCompanyContactListsResponse, request, callback);
                    }, "name", { value: "ListCompanyContactLists" });
    
                    /**
                     * Calls ListCompanyContactLists.
                     * @function listCompanyContactLists
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest} request ListCompanyContactListsRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ListCompanyContactListsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#createCompanyContactList}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef CreateCompanyContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContactList} [response] CompanyContactList
                     */
    
                    /**
                     * Calls CreateCompanyContactList.
                     * @function createCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest} request CreateCompanyContactListRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.CreateCompanyContactListCallback} callback Node-style callback called with the error, if any, and CompanyContactList
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.createCompanyContactList = function createCompanyContactList(request, callback) {
                        return this.rpcCall(createCompanyContactList, $root.palexy.task_management.v1.CreateCompanyContactListRequest, $root.palexy.task_management.v1.CompanyContactList, request, callback);
                    }, "name", { value: "CreateCompanyContactList" });
    
                    /**
                     * Calls CreateCompanyContactList.
                     * @function createCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest} request CreateCompanyContactListRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContactList>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#getCompanyContactList}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef GetCompanyContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContactList} [response] CompanyContactList
                     */
    
                    /**
                     * Calls GetCompanyContactList.
                     * @function getCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest} request GetCompanyContactListRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.GetCompanyContactListCallback} callback Node-style callback called with the error, if any, and CompanyContactList
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.getCompanyContactList = function getCompanyContactList(request, callback) {
                        return this.rpcCall(getCompanyContactList, $root.palexy.task_management.v1.GetCompanyContactListRequest, $root.palexy.task_management.v1.CompanyContactList, request, callback);
                    }, "name", { value: "GetCompanyContactList" });
    
                    /**
                     * Calls GetCompanyContactList.
                     * @function getCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest} request GetCompanyContactListRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContactList>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#updateCompanyContactList}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef UpdateCompanyContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.CompanyContactList} [response] CompanyContactList
                     */
    
                    /**
                     * Calls UpdateCompanyContactList.
                     * @function updateCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest} request UpdateCompanyContactListRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.UpdateCompanyContactListCallback} callback Node-style callback called with the error, if any, and CompanyContactList
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.updateCompanyContactList = function updateCompanyContactList(request, callback) {
                        return this.rpcCall(updateCompanyContactList, $root.palexy.task_management.v1.UpdateCompanyContactListRequest, $root.palexy.task_management.v1.CompanyContactList, request, callback);
                    }, "name", { value: "UpdateCompanyContactList" });
    
                    /**
                     * Calls UpdateCompanyContactList.
                     * @function updateCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest} request UpdateCompanyContactListRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.CompanyContactList>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#deleteCompanyContactList}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef DeleteCompanyContactListCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteCompanyContactList.
                     * @function deleteCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest} request DeleteCompanyContactListRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.DeleteCompanyContactListCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.deleteCompanyContactList = function deleteCompanyContactList(request, callback) {
                        return this.rpcCall(deleteCompanyContactList, $root.palexy.task_management.v1.DeleteCompanyContactListRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteCompanyContactList" });
    
                    /**
                     * Calls DeleteCompanyContactList.
                     * @function deleteCompanyContactList
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest} request DeleteCompanyContactListRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#addCompanyContactListMembers}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef AddCompanyContactListMembersCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} [response] ChangeCompanyContactListMembersResponse
                     */
    
                    /**
                     * Calls AddCompanyContactListMembers.
                     * @function addCompanyContactListMembers
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest} request AddCompanyContactListMembersRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.AddCompanyContactListMembersCallback} callback Node-style callback called with the error, if any, and ChangeCompanyContactListMembersResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.addCompanyContactListMembers = function addCompanyContactListMembers(request, callback) {
                        return this.rpcCall(addCompanyContactListMembers, $root.palexy.task_management.v1.AddCompanyContactListMembersRequest, $root.palexy.task_management.v1.ChangeCompanyContactListMembersResponse, request, callback);
                    }, "name", { value: "AddCompanyContactListMembers" });
    
                    /**
                     * Calls AddCompanyContactListMembers.
                     * @function addCompanyContactListMembers
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest} request AddCompanyContactListMembersRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ChangeCompanyContactListMembersResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.task_management.v1.CompanyContactService#removeCompanyContactListMembers}.
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @typedef RemoveCompanyContactListMembersCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} [response] ChangeCompanyContactListMembersResponse
                     */
    
                    /**
                     * Calls RemoveCompanyContactListMembers.
                     * @function removeCompanyContactListMembers
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest} request RemoveCompanyContactListMembersRequest message or plain object
                     * @param {palexy.task_management.v1.CompanyContactService.RemoveCompanyContactListMembersCallback} callback Node-style callback called with the error, if any, and ChangeCompanyContactListMembersResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(CompanyContactService.prototype.removeCompanyContactListMembers = function removeCompanyContactListMembers(request, callback) {
                        return this.rpcCall(removeCompanyContactListMembers, $root.palexy.task_management.v1.RemoveCompanyContactListMembersRequest, $root.palexy.task_management.v1.ChangeCompanyContactListMembersResponse, request, callback);
                    }, "name", { value: "RemoveCompanyContactListMembers" });
    
                    /**
                     * Calls RemoveCompanyContactListMembers.
                     * @function removeCompanyContactListMembers
                     * @memberof palexy.task_management.v1.CompanyContactService
                     * @instance
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest} request RemoveCompanyContactListMembersRequest message or plain object
                     * @returns {Promise<palexy.task_management.v1.ChangeCompanyContactListMembersResponse>} Promise
                     * @variation 2
                     */
    
                    return CompanyContactService;
                })();
    
                /**
                 * ContactConsentSource enum.
                 * @name palexy.task_management.v1.ContactConsentSource
                 * @enum {number}
                 * @property {number} CONTACT_CONSENT_SOURCE_UNSPECIFIED=0 CONTACT_CONSENT_SOURCE_UNSPECIFIED value
                 * @property {number} CONTACT_CONSENT_SOURCE_SIGNUP_FORM=1 CONTACT_CONSENT_SOURCE_SIGNUP_FORM value
                 * @property {number} CONTACT_CONSENT_SOURCE_IN_STORE_POS=2 CONTACT_CONSENT_SOURCE_IN_STORE_POS value
                 * @property {number} CONTACT_CONSENT_SOURCE_LOYALTY_PROGRAM=3 CONTACT_CONSENT_SOURCE_LOYALTY_PROGRAM value
                 * @property {number} CONTACT_CONSENT_SOURCE_WEBSITE=4 CONTACT_CONSENT_SOURCE_WEBSITE value
                 * @property {number} CONTACT_CONSENT_SOURCE_OTHER=5 CONTACT_CONSENT_SOURCE_OTHER value
                 */
                v1.ContactConsentSource = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "CONTACT_CONSENT_SOURCE_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "CONTACT_CONSENT_SOURCE_SIGNUP_FORM"] = 1;
                    values[valuesById[2] = "CONTACT_CONSENT_SOURCE_IN_STORE_POS"] = 2;
                    values[valuesById[3] = "CONTACT_CONSENT_SOURCE_LOYALTY_PROGRAM"] = 3;
                    values[valuesById[4] = "CONTACT_CONSENT_SOURCE_WEBSITE"] = 4;
                    values[valuesById[5] = "CONTACT_CONSENT_SOURCE_OTHER"] = 5;
                    return values;
                })();
    
                /**
                 * ContactStatus enum.
                 * @name palexy.task_management.v1.ContactStatus
                 * @enum {number}
                 * @property {number} CONTACT_STATUS_UNSPECIFIED=0 CONTACT_STATUS_UNSPECIFIED value
                 * @property {number} CONTACT_STATUS_SUBSCRIBED=1 CONTACT_STATUS_SUBSCRIBED value
                 * @property {number} CONTACT_STATUS_NO_EMAIL=2 CONTACT_STATUS_NO_EMAIL value
                 * @property {number} CONTACT_STATUS_UNSUBSCRIBED=3 CONTACT_STATUS_UNSUBSCRIBED value
                 * @property {number} CONTACT_STATUS_BOUNCED=4 CONTACT_STATUS_BOUNCED value
                 * @property {number} CONTACT_STATUS_SPAM_REPORTED=5 CONTACT_STATUS_SPAM_REPORTED value
                 */
                v1.ContactStatus = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "CONTACT_STATUS_UNSPECIFIED"] = 0;
                    values[valuesById[1] = "CONTACT_STATUS_SUBSCRIBED"] = 1;
                    values[valuesById[2] = "CONTACT_STATUS_NO_EMAIL"] = 2;
                    values[valuesById[3] = "CONTACT_STATUS_UNSUBSCRIBED"] = 3;
                    values[valuesById[4] = "CONTACT_STATUS_BOUNCED"] = 4;
                    values[valuesById[5] = "CONTACT_STATUS_SPAM_REPORTED"] = 5;
                    return values;
                })();
    
                v1.CompanyContact = (function() {
    
                    /**
                     * Properties of a CompanyContact.
                     * @memberof palexy.task_management.v1
                     * @interface ICompanyContact
                     * @property {number|null} [id] CompanyContact id
                     * @property {number|null} [companyId] CompanyContact companyId
                     * @property {string|null} [email] CompanyContact email
                     * @property {string|null} [name] CompanyContact name
                     * @property {string|null} [phone] CompanyContact phone
                     * @property {Object.<string,string>|null} [properties] CompanyContact properties
                     * @property {palexy.task_management.v1.ContactStatus|null} [status] CompanyContact status
                     * @property {Array.<palexy.task_management.v1.ICompanyContactListRef>|null} [lists] CompanyContact lists
                     * @property {number|null} [createdTimeMs] CompanyContact createdTimeMs
                     * @property {number|null} [lastUpdateTimeMs] CompanyContact lastUpdateTimeMs
                     */
    
                    /**
                     * Constructs a new CompanyContact.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompanyContact.
                     * @implements ICompanyContact
                     * @constructor
                     * @param {palexy.task_management.v1.ICompanyContact=} [properties] Properties to set
                     */
                    function CompanyContact(properties) {
                        this.properties = {};
                        this.lists = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyContact id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContact companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContact email.
                     * @member {string} email
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.email = "";
    
                    /**
                     * CompanyContact name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.name = "";
    
                    /**
                     * CompanyContact phone.
                     * @member {string} phone
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.phone = "";
    
                    /**
                     * CompanyContact properties.
                     * @member {Object.<string,string>} properties
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.properties = $util.emptyObject;
    
                    /**
                     * CompanyContact status.
                     * @member {palexy.task_management.v1.ContactStatus} status
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.status = 0;
    
                    /**
                     * CompanyContact lists.
                     * @member {Array.<palexy.task_management.v1.ICompanyContactListRef>} lists
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.lists = $util.emptyArray;
    
                    /**
                     * CompanyContact createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContact lastUpdateTimeMs.
                     * @member {number} lastUpdateTimeMs
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     */
                    CompanyContact.prototype.lastUpdateTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CompanyContact instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContact=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CompanyContact} CompanyContact instance
                     */
                    CompanyContact.create = function create(properties) {
                        return new CompanyContact(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyContact message. Does not implicitly {@link palexy.task_management.v1.CompanyContact.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContact} message CompanyContact message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContact.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.email);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.name);
                        if (message.phone != null && Object.hasOwnProperty.call(message, "phone"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.phone);
                        if (message.properties != null && Object.hasOwnProperty.call(message, "properties"))
                            for (var keys = Object.keys(message.properties), i = 0; i < keys.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).fork().uint32(/* id 1, wireType 2 =*/10).string(keys[i]).uint32(/* id 2, wireType 2 =*/18).string(message.properties[keys[i]]).ldelim();
                        if (message.status != null && Object.hasOwnProperty.call(message, "status"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.status);
                        if (message.lists != null && message.lists.length)
                            for (var i = 0; i < message.lists.length; ++i)
                                $root.palexy.task_management.v1.CompanyContactListRef.encode(message.lists[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int64(message.createdTimeMs);
                        if (message.lastUpdateTimeMs != null && Object.hasOwnProperty.call(message, "lastUpdateTimeMs"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int64(message.lastUpdateTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyContact message, length delimited. Does not implicitly {@link palexy.task_management.v1.CompanyContact.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContact} message CompanyContact message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContact.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyContact message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CompanyContact} CompanyContact
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContact.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CompanyContact(), key, value;
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.email = reader.string();
                                break;
                            case 4:
                                message.name = reader.string();
                                break;
                            case 5:
                                message.phone = reader.string();
                                break;
                            case 6:
                                if (message.properties === $util.emptyObject)
                                    message.properties = {};
                                var end2 = reader.uint32() + reader.pos;
                                key = "";
                                value = "";
                                while (reader.pos < end2) {
                                    var tag2 = reader.uint32();
                                    switch (tag2 >>> 3) {
                                    case 1:
                                        key = reader.string();
                                        break;
                                    case 2:
                                        value = reader.string();
                                        break;
                                    default:
                                        reader.skipType(tag2 & 7);
                                        break;
                                    }
                                }
                                message.properties[key] = value;
                                break;
                            case 7:
                                message.status = reader.int32();
                                break;
                            case 8:
                                if (!(message.lists && message.lists.length))
                                    message.lists = [];
                                message.lists.push($root.palexy.task_management.v1.CompanyContactListRef.decode(reader, reader.uint32()));
                                break;
                            case 9:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 10:
                                message.lastUpdateTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyContact message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CompanyContact} CompanyContact
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContact.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyContact message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyContact.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.phone != null && message.hasOwnProperty("phone"))
                            if (!$util.isString(message.phone))
                                return "phone: string expected";
                        if (message.properties != null && message.hasOwnProperty("properties")) {
                            if (!$util.isObject(message.properties))
                                return "properties: object expected";
                            var key = Object.keys(message.properties);
                            for (var i = 0; i < key.length; ++i)
                                if (!$util.isString(message.properties[key[i]]))
                                    return "properties: string{k:string} expected";
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            switch (message.status) {
                            default:
                                return "status: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.lists != null && message.hasOwnProperty("lists")) {
                            if (!Array.isArray(message.lists))
                                return "lists: array expected";
                            for (var i = 0; i < message.lists.length; ++i) {
                                var error = $root.palexy.task_management.v1.CompanyContactListRef.verify(message.lists[i]);
                                if (error)
                                    return "lists." + error;
                            }
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (!$util.isInteger(message.lastUpdateTimeMs) && !(message.lastUpdateTimeMs && $util.isInteger(message.lastUpdateTimeMs.low) && $util.isInteger(message.lastUpdateTimeMs.high)))
                                return "lastUpdateTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyContact message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CompanyContact} CompanyContact
                     */
                    CompanyContact.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CompanyContact)
                            return object;
                        var message = new $root.palexy.task_management.v1.CompanyContact();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.phone != null)
                            message.phone = String(object.phone);
                        if (object.properties) {
                            if (typeof object.properties !== "object")
                                throw TypeError(".palexy.task_management.v1.CompanyContact.properties: object expected");
                            message.properties = {};
                            for (var keys = Object.keys(object.properties), i = 0; i < keys.length; ++i)
                                message.properties[keys[i]] = String(object.properties[keys[i]]);
                        }
                        switch (object.status) {
                        case "CONTACT_STATUS_UNSPECIFIED":
                        case 0:
                            message.status = 0;
                            break;
                        case "CONTACT_STATUS_SUBSCRIBED":
                        case 1:
                            message.status = 1;
                            break;
                        case "CONTACT_STATUS_NO_EMAIL":
                        case 2:
                            message.status = 2;
                            break;
                        case "CONTACT_STATUS_UNSUBSCRIBED":
                        case 3:
                            message.status = 3;
                            break;
                        case "CONTACT_STATUS_BOUNCED":
                        case 4:
                            message.status = 4;
                            break;
                        case "CONTACT_STATUS_SPAM_REPORTED":
                        case 5:
                            message.status = 5;
                            break;
                        }
                        if (object.lists) {
                            if (!Array.isArray(object.lists))
                                throw TypeError(".palexy.task_management.v1.CompanyContact.lists: array expected");
                            message.lists = [];
                            for (var i = 0; i < object.lists.length; ++i) {
                                if (typeof object.lists[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.CompanyContact.lists: object expected");
                                message.lists[i] = $root.palexy.task_management.v1.CompanyContactListRef.fromObject(object.lists[i]);
                            }
                        }
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.lastUpdateTimeMs != null)
                            if ($util.Long)
                                (message.lastUpdateTimeMs = $util.Long.fromValue(object.lastUpdateTimeMs)).unsigned = false;
                            else if (typeof object.lastUpdateTimeMs === "string")
                                message.lastUpdateTimeMs = parseInt(object.lastUpdateTimeMs, 10);
                            else if (typeof object.lastUpdateTimeMs === "number")
                                message.lastUpdateTimeMs = object.lastUpdateTimeMs;
                            else if (typeof object.lastUpdateTimeMs === "object")
                                message.lastUpdateTimeMs = new $util.LongBits(object.lastUpdateTimeMs.low >>> 0, object.lastUpdateTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyContact message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @static
                     * @param {palexy.task_management.v1.CompanyContact} message CompanyContact
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyContact.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.lists = [];
                        if (options.objects || options.defaults)
                            object.properties = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.email = "";
                            object.name = "";
                            object.phone = "";
                            object.status = options.enums === String ? "CONTACT_STATUS_UNSPECIFIED" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.lastUpdateTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.lastUpdateTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.phone != null && message.hasOwnProperty("phone"))
                            object.phone = message.phone;
                        var keys2;
                        if (message.properties && (keys2 = Object.keys(message.properties)).length) {
                            object.properties = {};
                            for (var j = 0; j < keys2.length; ++j)
                                object.properties[keys2[j]] = message.properties[keys2[j]];
                        }
                        if (message.status != null && message.hasOwnProperty("status"))
                            object.status = options.enums === String ? $root.palexy.task_management.v1.ContactStatus[message.status] : message.status;
                        if (message.lists && message.lists.length) {
                            object.lists = [];
                            for (var j = 0; j < message.lists.length; ++j)
                                object.lists[j] = $root.palexy.task_management.v1.CompanyContactListRef.toObject(message.lists[j], options);
                        }
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.lastUpdateTimeMs != null && message.hasOwnProperty("lastUpdateTimeMs"))
                            if (typeof message.lastUpdateTimeMs === "number")
                                object.lastUpdateTimeMs = options.longs === String ? String(message.lastUpdateTimeMs) : message.lastUpdateTimeMs;
                            else
                                object.lastUpdateTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.lastUpdateTimeMs) : options.longs === Number ? new $util.LongBits(message.lastUpdateTimeMs.low >>> 0, message.lastUpdateTimeMs.high >>> 0).toNumber() : message.lastUpdateTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyContact to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CompanyContact
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyContact.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyContact;
                })();
    
                v1.CompanyContactListRef = (function() {
    
                    /**
                     * Properties of a CompanyContactListRef.
                     * @memberof palexy.task_management.v1
                     * @interface ICompanyContactListRef
                     * @property {number|null} [id] CompanyContactListRef id
                     * @property {string|null} [name] CompanyContactListRef name
                     * @property {number|null} [createdTimeMs] CompanyContactListRef createdTimeMs
                     */
    
                    /**
                     * Constructs a new CompanyContactListRef.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompanyContactListRef.
                     * @implements ICompanyContactListRef
                     * @constructor
                     * @param {palexy.task_management.v1.ICompanyContactListRef=} [properties] Properties to set
                     */
                    function CompanyContactListRef(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyContactListRef id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @instance
                     */
                    CompanyContactListRef.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContactListRef name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @instance
                     */
                    CompanyContactListRef.prototype.name = "";
    
                    /**
                     * CompanyContactListRef createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @instance
                     */
                    CompanyContactListRef.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CompanyContactListRef instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactListRef=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CompanyContactListRef} CompanyContactListRef instance
                     */
                    CompanyContactListRef.create = function create(properties) {
                        return new CompanyContactListRef(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyContactListRef message. Does not implicitly {@link palexy.task_management.v1.CompanyContactListRef.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactListRef} message CompanyContactListRef message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactListRef.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdTimeMs);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyContactListRef message, length delimited. Does not implicitly {@link palexy.task_management.v1.CompanyContactListRef.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactListRef} message CompanyContactListRef message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactListRef.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyContactListRef message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CompanyContactListRef} CompanyContactListRef
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactListRef.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CompanyContactListRef();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.createdTimeMs = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyContactListRef message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CompanyContactListRef} CompanyContactListRef
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactListRef.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyContactListRef message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyContactListRef.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyContactListRef message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CompanyContactListRef} CompanyContactListRef
                     */
                    CompanyContactListRef.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CompanyContactListRef)
                            return object;
                        var message = new $root.palexy.task_management.v1.CompanyContactListRef();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyContactListRef message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @static
                     * @param {palexy.task_management.v1.CompanyContactListRef} message CompanyContactListRef
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyContactListRef.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyContactListRef to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CompanyContactListRef
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyContactListRef.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyContactListRef;
                })();
    
                v1.ContactConsent = (function() {
    
                    /**
                     * Properties of a ContactConsent.
                     * @memberof palexy.task_management.v1
                     * @interface IContactConsent
                     * @property {palexy.task_management.v1.ContactConsentSource|null} [source] ContactConsent source
                     * @property {string|null} [note] ContactConsent note
                     * @property {string|null} [date] ContactConsent date
                     */
    
                    /**
                     * Constructs a new ContactConsent.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ContactConsent.
                     * @implements IContactConsent
                     * @constructor
                     * @param {palexy.task_management.v1.IContactConsent=} [properties] Properties to set
                     */
                    function ContactConsent(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ContactConsent source.
                     * @member {palexy.task_management.v1.ContactConsentSource} source
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @instance
                     */
                    ContactConsent.prototype.source = 0;
    
                    /**
                     * ContactConsent note.
                     * @member {string} note
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @instance
                     */
                    ContactConsent.prototype.note = "";
    
                    /**
                     * ContactConsent date.
                     * @member {string} date
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @instance
                     */
                    ContactConsent.prototype.date = "";
    
                    /**
                     * Creates a new ContactConsent instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {palexy.task_management.v1.IContactConsent=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ContactConsent} ContactConsent instance
                     */
                    ContactConsent.create = function create(properties) {
                        return new ContactConsent(properties);
                    };
    
                    /**
                     * Encodes the specified ContactConsent message. Does not implicitly {@link palexy.task_management.v1.ContactConsent.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {palexy.task_management.v1.IContactConsent} message ContactConsent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactConsent.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.source != null && Object.hasOwnProperty.call(message, "source"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.source);
                        if (message.note != null && Object.hasOwnProperty.call(message, "note"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.note);
                        if (message.date != null && Object.hasOwnProperty.call(message, "date"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.date);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ContactConsent message, length delimited. Does not implicitly {@link palexy.task_management.v1.ContactConsent.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {palexy.task_management.v1.IContactConsent} message ContactConsent message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ContactConsent.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ContactConsent message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ContactConsent} ContactConsent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactConsent.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ContactConsent();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.source = reader.int32();
                                break;
                            case 2:
                                message.note = reader.string();
                                break;
                            case 3:
                                message.date = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ContactConsent message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ContactConsent} ContactConsent
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ContactConsent.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ContactConsent message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ContactConsent.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.source != null && message.hasOwnProperty("source"))
                            switch (message.source) {
                            default:
                                return "source: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                            case 5:
                                break;
                            }
                        if (message.note != null && message.hasOwnProperty("note"))
                            if (!$util.isString(message.note))
                                return "note: string expected";
                        if (message.date != null && message.hasOwnProperty("date"))
                            if (!$util.isString(message.date))
                                return "date: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ContactConsent message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ContactConsent} ContactConsent
                     */
                    ContactConsent.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ContactConsent)
                            return object;
                        var message = new $root.palexy.task_management.v1.ContactConsent();
                        switch (object.source) {
                        case "CONTACT_CONSENT_SOURCE_UNSPECIFIED":
                        case 0:
                            message.source = 0;
                            break;
                        case "CONTACT_CONSENT_SOURCE_SIGNUP_FORM":
                        case 1:
                            message.source = 1;
                            break;
                        case "CONTACT_CONSENT_SOURCE_IN_STORE_POS":
                        case 2:
                            message.source = 2;
                            break;
                        case "CONTACT_CONSENT_SOURCE_LOYALTY_PROGRAM":
                        case 3:
                            message.source = 3;
                            break;
                        case "CONTACT_CONSENT_SOURCE_WEBSITE":
                        case 4:
                            message.source = 4;
                            break;
                        case "CONTACT_CONSENT_SOURCE_OTHER":
                        case 5:
                            message.source = 5;
                            break;
                        }
                        if (object.note != null)
                            message.note = String(object.note);
                        if (object.date != null)
                            message.date = String(object.date);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ContactConsent message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @static
                     * @param {palexy.task_management.v1.ContactConsent} message ContactConsent
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ContactConsent.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.source = options.enums === String ? "CONTACT_CONSENT_SOURCE_UNSPECIFIED" : 0;
                            object.note = "";
                            object.date = "";
                        }
                        if (message.source != null && message.hasOwnProperty("source"))
                            object.source = options.enums === String ? $root.palexy.task_management.v1.ContactConsentSource[message.source] : message.source;
                        if (message.note != null && message.hasOwnProperty("note"))
                            object.note = message.note;
                        if (message.date != null && message.hasOwnProperty("date"))
                            object.date = message.date;
                        return object;
                    };
    
                    /**
                     * Converts this ContactConsent to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ContactConsent
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ContactConsent.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ContactConsent;
                })();
    
                v1.CompanyContactList = (function() {
    
                    /**
                     * Properties of a CompanyContactList.
                     * @memberof palexy.task_management.v1
                     * @interface ICompanyContactList
                     * @property {number|null} [id] CompanyContactList id
                     * @property {number|null} [companyId] CompanyContactList companyId
                     * @property {string|null} [name] CompanyContactList name
                     * @property {palexy.task_management.v1.IContactConsent|null} [consent] CompanyContactList consent
                     * @property {number|null} [createdBy] CompanyContactList createdBy
                     * @property {string|null} [creatorName] CompanyContactList creatorName
                     * @property {number|null} [createdTimeMs] CompanyContactList createdTimeMs
                     * @property {number|null} [contactCount] CompanyContactList contactCount
                     * @property {number|null} [sendableCount] CompanyContactList sendableCount
                     * @property {number|null} [noEmailCount] CompanyContactList noEmailCount
                     * @property {number|null} [unsubscribedCount] CompanyContactList unsubscribedCount
                     * @property {number|null} [bouncedCount] CompanyContactList bouncedCount
                     * @property {number|null} [spamReportedCount] CompanyContactList spamReportedCount
                     */
    
                    /**
                     * Constructs a new CompanyContactList.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompanyContactList.
                     * @implements ICompanyContactList
                     * @constructor
                     * @param {palexy.task_management.v1.ICompanyContactList=} [properties] Properties to set
                     */
                    function CompanyContactList(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyContactList id.
                     * @member {number} id
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContactList companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContactList name.
                     * @member {string} name
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.name = "";
    
                    /**
                     * CompanyContactList consent.
                     * @member {palexy.task_management.v1.IContactConsent|null|undefined} consent
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.consent = null;
    
                    /**
                     * CompanyContactList createdBy.
                     * @member {number} createdBy
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.createdBy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContactList creatorName.
                     * @member {string} creatorName
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.creatorName = "";
    
                    /**
                     * CompanyContactList createdTimeMs.
                     * @member {number} createdTimeMs
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.createdTimeMs = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CompanyContactList contactCount.
                     * @member {number} contactCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.contactCount = 0;
    
                    /**
                     * CompanyContactList sendableCount.
                     * @member {number} sendableCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.sendableCount = 0;
    
                    /**
                     * CompanyContactList noEmailCount.
                     * @member {number} noEmailCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.noEmailCount = 0;
    
                    /**
                     * CompanyContactList unsubscribedCount.
                     * @member {number} unsubscribedCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.unsubscribedCount = 0;
    
                    /**
                     * CompanyContactList bouncedCount.
                     * @member {number} bouncedCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.bouncedCount = 0;
    
                    /**
                     * CompanyContactList spamReportedCount.
                     * @member {number} spamReportedCount
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     */
                    CompanyContactList.prototype.spamReportedCount = 0;
    
                    /**
                     * Creates a new CompanyContactList instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactList=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CompanyContactList} CompanyContactList instance
                     */
                    CompanyContactList.create = function create(properties) {
                        return new CompanyContactList(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyContactList message. Does not implicitly {@link palexy.task_management.v1.CompanyContactList.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactList} message CompanyContactList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactList.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.companyId);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.name);
                        if (message.consent != null && Object.hasOwnProperty.call(message, "consent"))
                            $root.palexy.task_management.v1.ContactConsent.encode(message.consent, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.createdBy);
                        if (message.creatorName != null && Object.hasOwnProperty.call(message, "creatorName"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.creatorName);
                        if (message.createdTimeMs != null && Object.hasOwnProperty.call(message, "createdTimeMs"))
                            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.createdTimeMs);
                        if (message.contactCount != null && Object.hasOwnProperty.call(message, "contactCount"))
                            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.contactCount);
                        if (message.sendableCount != null && Object.hasOwnProperty.call(message, "sendableCount"))
                            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.sendableCount);
                        if (message.noEmailCount != null && Object.hasOwnProperty.call(message, "noEmailCount"))
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.noEmailCount);
                        if (message.unsubscribedCount != null && Object.hasOwnProperty.call(message, "unsubscribedCount"))
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.unsubscribedCount);
                        if (message.bouncedCount != null && Object.hasOwnProperty.call(message, "bouncedCount"))
                            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.bouncedCount);
                        if (message.spamReportedCount != null && Object.hasOwnProperty.call(message, "spamReportedCount"))
                            writer.uint32(/* id 13, wireType 0 =*/104).int32(message.spamReportedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyContactList message, length delimited. Does not implicitly {@link palexy.task_management.v1.CompanyContactList.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactList} message CompanyContactList message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactList.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyContactList message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CompanyContactList} CompanyContactList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactList.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CompanyContactList();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.companyId = reader.int64();
                                break;
                            case 3:
                                message.name = reader.string();
                                break;
                            case 4:
                                message.consent = $root.palexy.task_management.v1.ContactConsent.decode(reader, reader.uint32());
                                break;
                            case 5:
                                message.createdBy = reader.int64();
                                break;
                            case 6:
                                message.creatorName = reader.string();
                                break;
                            case 7:
                                message.createdTimeMs = reader.int64();
                                break;
                            case 8:
                                message.contactCount = reader.int32();
                                break;
                            case 9:
                                message.sendableCount = reader.int32();
                                break;
                            case 10:
                                message.noEmailCount = reader.int32();
                                break;
                            case 11:
                                message.unsubscribedCount = reader.int32();
                                break;
                            case 12:
                                message.bouncedCount = reader.int32();
                                break;
                            case 13:
                                message.spamReportedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyContactList message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CompanyContactList} CompanyContactList
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactList.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyContactList message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyContactList.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.consent != null && message.hasOwnProperty("consent")) {
                            var error = $root.palexy.task_management.v1.ContactConsent.verify(message.consent);
                            if (error)
                                return "consent." + error;
                        }
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (!$util.isInteger(message.createdBy) && !(message.createdBy && $util.isInteger(message.createdBy.low) && $util.isInteger(message.createdBy.high)))
                                return "createdBy: integer|Long expected";
                        if (message.creatorName != null && message.hasOwnProperty("creatorName"))
                            if (!$util.isString(message.creatorName))
                                return "creatorName: string expected";
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (!$util.isInteger(message.createdTimeMs) && !(message.createdTimeMs && $util.isInteger(message.createdTimeMs.low) && $util.isInteger(message.createdTimeMs.high)))
                                return "createdTimeMs: integer|Long expected";
                        if (message.contactCount != null && message.hasOwnProperty("contactCount"))
                            if (!$util.isInteger(message.contactCount))
                                return "contactCount: integer expected";
                        if (message.sendableCount != null && message.hasOwnProperty("sendableCount"))
                            if (!$util.isInteger(message.sendableCount))
                                return "sendableCount: integer expected";
                        if (message.noEmailCount != null && message.hasOwnProperty("noEmailCount"))
                            if (!$util.isInteger(message.noEmailCount))
                                return "noEmailCount: integer expected";
                        if (message.unsubscribedCount != null && message.hasOwnProperty("unsubscribedCount"))
                            if (!$util.isInteger(message.unsubscribedCount))
                                return "unsubscribedCount: integer expected";
                        if (message.bouncedCount != null && message.hasOwnProperty("bouncedCount"))
                            if (!$util.isInteger(message.bouncedCount))
                                return "bouncedCount: integer expected";
                        if (message.spamReportedCount != null && message.hasOwnProperty("spamReportedCount"))
                            if (!$util.isInteger(message.spamReportedCount))
                                return "spamReportedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyContactList message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CompanyContactList} CompanyContactList
                     */
                    CompanyContactList.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CompanyContactList)
                            return object;
                        var message = new $root.palexy.task_management.v1.CompanyContactList();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.consent != null) {
                            if (typeof object.consent !== "object")
                                throw TypeError(".palexy.task_management.v1.CompanyContactList.consent: object expected");
                            message.consent = $root.palexy.task_management.v1.ContactConsent.fromObject(object.consent);
                        }
                        if (object.createdBy != null)
                            if ($util.Long)
                                (message.createdBy = $util.Long.fromValue(object.createdBy)).unsigned = false;
                            else if (typeof object.createdBy === "string")
                                message.createdBy = parseInt(object.createdBy, 10);
                            else if (typeof object.createdBy === "number")
                                message.createdBy = object.createdBy;
                            else if (typeof object.createdBy === "object")
                                message.createdBy = new $util.LongBits(object.createdBy.low >>> 0, object.createdBy.high >>> 0).toNumber();
                        if (object.creatorName != null)
                            message.creatorName = String(object.creatorName);
                        if (object.createdTimeMs != null)
                            if ($util.Long)
                                (message.createdTimeMs = $util.Long.fromValue(object.createdTimeMs)).unsigned = false;
                            else if (typeof object.createdTimeMs === "string")
                                message.createdTimeMs = parseInt(object.createdTimeMs, 10);
                            else if (typeof object.createdTimeMs === "number")
                                message.createdTimeMs = object.createdTimeMs;
                            else if (typeof object.createdTimeMs === "object")
                                message.createdTimeMs = new $util.LongBits(object.createdTimeMs.low >>> 0, object.createdTimeMs.high >>> 0).toNumber();
                        if (object.contactCount != null)
                            message.contactCount = object.contactCount | 0;
                        if (object.sendableCount != null)
                            message.sendableCount = object.sendableCount | 0;
                        if (object.noEmailCount != null)
                            message.noEmailCount = object.noEmailCount | 0;
                        if (object.unsubscribedCount != null)
                            message.unsubscribedCount = object.unsubscribedCount | 0;
                        if (object.bouncedCount != null)
                            message.bouncedCount = object.bouncedCount | 0;
                        if (object.spamReportedCount != null)
                            message.spamReportedCount = object.spamReportedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyContactList message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @static
                     * @param {palexy.task_management.v1.CompanyContactList} message CompanyContactList
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyContactList.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.name = "";
                            object.consent = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdBy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdBy = options.longs === String ? "0" : 0;
                            object.creatorName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdTimeMs = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdTimeMs = options.longs === String ? "0" : 0;
                            object.contactCount = 0;
                            object.sendableCount = 0;
                            object.noEmailCount = 0;
                            object.unsubscribedCount = 0;
                            object.bouncedCount = 0;
                            object.spamReportedCount = 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.consent != null && message.hasOwnProperty("consent"))
                            object.consent = $root.palexy.task_management.v1.ContactConsent.toObject(message.consent, options);
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (typeof message.createdBy === "number")
                                object.createdBy = options.longs === String ? String(message.createdBy) : message.createdBy;
                            else
                                object.createdBy = options.longs === String ? $util.Long.prototype.toString.call(message.createdBy) : options.longs === Number ? new $util.LongBits(message.createdBy.low >>> 0, message.createdBy.high >>> 0).toNumber() : message.createdBy;
                        if (message.creatorName != null && message.hasOwnProperty("creatorName"))
                            object.creatorName = message.creatorName;
                        if (message.createdTimeMs != null && message.hasOwnProperty("createdTimeMs"))
                            if (typeof message.createdTimeMs === "number")
                                object.createdTimeMs = options.longs === String ? String(message.createdTimeMs) : message.createdTimeMs;
                            else
                                object.createdTimeMs = options.longs === String ? $util.Long.prototype.toString.call(message.createdTimeMs) : options.longs === Number ? new $util.LongBits(message.createdTimeMs.low >>> 0, message.createdTimeMs.high >>> 0).toNumber() : message.createdTimeMs;
                        if (message.contactCount != null && message.hasOwnProperty("contactCount"))
                            object.contactCount = message.contactCount;
                        if (message.sendableCount != null && message.hasOwnProperty("sendableCount"))
                            object.sendableCount = message.sendableCount;
                        if (message.noEmailCount != null && message.hasOwnProperty("noEmailCount"))
                            object.noEmailCount = message.noEmailCount;
                        if (message.unsubscribedCount != null && message.hasOwnProperty("unsubscribedCount"))
                            object.unsubscribedCount = message.unsubscribedCount;
                        if (message.bouncedCount != null && message.hasOwnProperty("bouncedCount"))
                            object.bouncedCount = message.bouncedCount;
                        if (message.spamReportedCount != null && message.hasOwnProperty("spamReportedCount"))
                            object.spamReportedCount = message.spamReportedCount;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyContactList to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CompanyContactList
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyContactList.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyContactList;
                })();
    
                v1.GetCompanyContactsSummaryRequest = (function() {
    
                    /**
                     * Properties of a GetCompanyContactsSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCompanyContactsSummaryRequest
                     * @property {number|null} [companyId] GetCompanyContactsSummaryRequest companyId
                     */
    
                    /**
                     * Constructs a new GetCompanyContactsSummaryRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCompanyContactsSummaryRequest.
                     * @implements IGetCompanyContactsSummaryRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest=} [properties] Properties to set
                     */
                    function GetCompanyContactsSummaryRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyContactsSummaryRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @instance
                     */
                    GetCompanyContactsSummaryRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCompanyContactsSummaryRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCompanyContactsSummaryRequest} GetCompanyContactsSummaryRequest instance
                     */
                    GetCompanyContactsSummaryRequest.create = function create(properties) {
                        return new GetCompanyContactsSummaryRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactsSummaryRequest message. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactsSummaryRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest} message GetCompanyContactsSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactsSummaryRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactsSummaryRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactsSummaryRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactsSummaryRequest} message GetCompanyContactsSummaryRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactsSummaryRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyContactsSummaryRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCompanyContactsSummaryRequest} GetCompanyContactsSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactsSummaryRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCompanyContactsSummaryRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyContactsSummaryRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCompanyContactsSummaryRequest} GetCompanyContactsSummaryRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactsSummaryRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyContactsSummaryRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyContactsSummaryRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyContactsSummaryRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCompanyContactsSummaryRequest} GetCompanyContactsSummaryRequest
                     */
                    GetCompanyContactsSummaryRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCompanyContactsSummaryRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCompanyContactsSummaryRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyContactsSummaryRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @static
                     * @param {palexy.task_management.v1.GetCompanyContactsSummaryRequest} message GetCompanyContactsSummaryRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyContactsSummaryRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyContactsSummaryRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCompanyContactsSummaryRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyContactsSummaryRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyContactsSummaryRequest;
                })();
    
                v1.CompanyContactsSummary = (function() {
    
                    /**
                     * Properties of a CompanyContactsSummary.
                     * @memberof palexy.task_management.v1
                     * @interface ICompanyContactsSummary
                     * @property {number|null} [contactCount] CompanyContactsSummary contactCount
                     * @property {number|null} [subscribedCount] CompanyContactsSummary subscribedCount
                     * @property {number|null} [listCount] CompanyContactsSummary listCount
                     */
    
                    /**
                     * Constructs a new CompanyContactsSummary.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CompanyContactsSummary.
                     * @implements ICompanyContactsSummary
                     * @constructor
                     * @param {palexy.task_management.v1.ICompanyContactsSummary=} [properties] Properties to set
                     */
                    function CompanyContactsSummary(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CompanyContactsSummary contactCount.
                     * @member {number} contactCount
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @instance
                     */
                    CompanyContactsSummary.prototype.contactCount = 0;
    
                    /**
                     * CompanyContactsSummary subscribedCount.
                     * @member {number} subscribedCount
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @instance
                     */
                    CompanyContactsSummary.prototype.subscribedCount = 0;
    
                    /**
                     * CompanyContactsSummary listCount.
                     * @member {number} listCount
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @instance
                     */
                    CompanyContactsSummary.prototype.listCount = 0;
    
                    /**
                     * Creates a new CompanyContactsSummary instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactsSummary=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CompanyContactsSummary} CompanyContactsSummary instance
                     */
                    CompanyContactsSummary.create = function create(properties) {
                        return new CompanyContactsSummary(properties);
                    };
    
                    /**
                     * Encodes the specified CompanyContactsSummary message. Does not implicitly {@link palexy.task_management.v1.CompanyContactsSummary.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactsSummary} message CompanyContactsSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactsSummary.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contactCount != null && Object.hasOwnProperty.call(message, "contactCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.contactCount);
                        if (message.subscribedCount != null && Object.hasOwnProperty.call(message, "subscribedCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.subscribedCount);
                        if (message.listCount != null && Object.hasOwnProperty.call(message, "listCount"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.listCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CompanyContactsSummary message, length delimited. Does not implicitly {@link palexy.task_management.v1.CompanyContactsSummary.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {palexy.task_management.v1.ICompanyContactsSummary} message CompanyContactsSummary message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CompanyContactsSummary.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CompanyContactsSummary message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CompanyContactsSummary} CompanyContactsSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactsSummary.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CompanyContactsSummary();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.contactCount = reader.int32();
                                break;
                            case 2:
                                message.subscribedCount = reader.int32();
                                break;
                            case 3:
                                message.listCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CompanyContactsSummary message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CompanyContactsSummary} CompanyContactsSummary
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CompanyContactsSummary.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CompanyContactsSummary message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CompanyContactsSummary.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contactCount != null && message.hasOwnProperty("contactCount"))
                            if (!$util.isInteger(message.contactCount))
                                return "contactCount: integer expected";
                        if (message.subscribedCount != null && message.hasOwnProperty("subscribedCount"))
                            if (!$util.isInteger(message.subscribedCount))
                                return "subscribedCount: integer expected";
                        if (message.listCount != null && message.hasOwnProperty("listCount"))
                            if (!$util.isInteger(message.listCount))
                                return "listCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a CompanyContactsSummary message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CompanyContactsSummary} CompanyContactsSummary
                     */
                    CompanyContactsSummary.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CompanyContactsSummary)
                            return object;
                        var message = new $root.palexy.task_management.v1.CompanyContactsSummary();
                        if (object.contactCount != null)
                            message.contactCount = object.contactCount | 0;
                        if (object.subscribedCount != null)
                            message.subscribedCount = object.subscribedCount | 0;
                        if (object.listCount != null)
                            message.listCount = object.listCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CompanyContactsSummary message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @static
                     * @param {palexy.task_management.v1.CompanyContactsSummary} message CompanyContactsSummary
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CompanyContactsSummary.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.contactCount = 0;
                            object.subscribedCount = 0;
                            object.listCount = 0;
                        }
                        if (message.contactCount != null && message.hasOwnProperty("contactCount"))
                            object.contactCount = message.contactCount;
                        if (message.subscribedCount != null && message.hasOwnProperty("subscribedCount"))
                            object.subscribedCount = message.subscribedCount;
                        if (message.listCount != null && message.hasOwnProperty("listCount"))
                            object.listCount = message.listCount;
                        return object;
                    };
    
                    /**
                     * Converts this CompanyContactsSummary to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CompanyContactsSummary
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CompanyContactsSummary.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CompanyContactsSummary;
                })();
    
                v1.SearchCompanyContactsRequest = (function() {
    
                    /**
                     * Properties of a SearchCompanyContactsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ISearchCompanyContactsRequest
                     * @property {number|null} [companyId] SearchCompanyContactsRequest companyId
                     * @property {string|null} [query] SearchCompanyContactsRequest query
                     * @property {number|null} [listId] SearchCompanyContactsRequest listId
                     * @property {Array.<palexy.task_management.v1.ContactStatus>|null} [statuses] SearchCompanyContactsRequest statuses
                     * @property {number|null} [pageSize] SearchCompanyContactsRequest pageSize
                     * @property {string|null} [pageToken] SearchCompanyContactsRequest pageToken
                     * @property {string|null} [orderBy] SearchCompanyContactsRequest orderBy
                     */
    
                    /**
                     * Constructs a new SearchCompanyContactsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SearchCompanyContactsRequest.
                     * @implements ISearchCompanyContactsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest=} [properties] Properties to set
                     */
                    function SearchCompanyContactsRequest(properties) {
                        this.statuses = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SearchCompanyContactsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SearchCompanyContactsRequest query.
                     * @member {string} query
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.query = "";
    
                    /**
                     * SearchCompanyContactsRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * SearchCompanyContactsRequest statuses.
                     * @member {Array.<palexy.task_management.v1.ContactStatus>} statuses
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.statuses = $util.emptyArray;
    
                    /**
                     * SearchCompanyContactsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.pageSize = 0;
    
                    /**
                     * SearchCompanyContactsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.pageToken = "";
    
                    /**
                     * SearchCompanyContactsRequest orderBy.
                     * @member {string} orderBy
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     */
                    SearchCompanyContactsRequest.prototype.orderBy = "";
    
                    /**
                     * Creates a new SearchCompanyContactsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SearchCompanyContactsRequest} SearchCompanyContactsRequest instance
                     */
                    SearchCompanyContactsRequest.create = function create(properties) {
                        return new SearchCompanyContactsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified SearchCompanyContactsRequest message. Does not implicitly {@link palexy.task_management.v1.SearchCompanyContactsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest} message SearchCompanyContactsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SearchCompanyContactsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.query);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.listId);
                        if (message.statuses != null && message.statuses.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.statuses.length; ++i)
                                writer.int32(message.statuses[i]);
                            writer.ldelim();
                        }
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 6, wireType 2 =*/50).string(message.pageToken);
                        if (message.orderBy != null && Object.hasOwnProperty.call(message, "orderBy"))
                            writer.uint32(/* id 7, wireType 2 =*/58).string(message.orderBy);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SearchCompanyContactsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.SearchCompanyContactsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsRequest} message SearchCompanyContactsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SearchCompanyContactsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SearchCompanyContactsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SearchCompanyContactsRequest} SearchCompanyContactsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SearchCompanyContactsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SearchCompanyContactsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.query = reader.string();
                                break;
                            case 3:
                                message.listId = reader.int64();
                                break;
                            case 4:
                                if (!(message.statuses && message.statuses.length))
                                    message.statuses = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.statuses.push(reader.int32());
                                } else
                                    message.statuses.push(reader.int32());
                                break;
                            case 5:
                                message.pageSize = reader.int32();
                                break;
                            case 6:
                                message.pageToken = reader.string();
                                break;
                            case 7:
                                message.orderBy = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SearchCompanyContactsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SearchCompanyContactsRequest} SearchCompanyContactsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SearchCompanyContactsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SearchCompanyContactsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SearchCompanyContactsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.query != null && message.hasOwnProperty("query"))
                            if (!$util.isString(message.query))
                                return "query: string expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        if (message.statuses != null && message.hasOwnProperty("statuses")) {
                            if (!Array.isArray(message.statuses))
                                return "statuses: array expected";
                            for (var i = 0; i < message.statuses.length; ++i)
                                switch (message.statuses[i]) {
                                default:
                                    return "statuses: enum value[] expected";
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                    break;
                                }
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.orderBy != null && message.hasOwnProperty("orderBy"))
                            if (!$util.isString(message.orderBy))
                                return "orderBy: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SearchCompanyContactsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SearchCompanyContactsRequest} SearchCompanyContactsRequest
                     */
                    SearchCompanyContactsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SearchCompanyContactsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.SearchCompanyContactsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.query != null)
                            message.query = String(object.query);
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        if (object.statuses) {
                            if (!Array.isArray(object.statuses))
                                throw TypeError(".palexy.task_management.v1.SearchCompanyContactsRequest.statuses: array expected");
                            message.statuses = [];
                            for (var i = 0; i < object.statuses.length; ++i)
                                switch (object.statuses[i]) {
                                default:
                                case "CONTACT_STATUS_UNSPECIFIED":
                                case 0:
                                    message.statuses[i] = 0;
                                    break;
                                case "CONTACT_STATUS_SUBSCRIBED":
                                case 1:
                                    message.statuses[i] = 1;
                                    break;
                                case "CONTACT_STATUS_NO_EMAIL":
                                case 2:
                                    message.statuses[i] = 2;
                                    break;
                                case "CONTACT_STATUS_UNSUBSCRIBED":
                                case 3:
                                    message.statuses[i] = 3;
                                    break;
                                case "CONTACT_STATUS_BOUNCED":
                                case 4:
                                    message.statuses[i] = 4;
                                    break;
                                case "CONTACT_STATUS_SPAM_REPORTED":
                                case 5:
                                    message.statuses[i] = 5;
                                    break;
                                }
                        }
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.orderBy != null)
                            message.orderBy = String(object.orderBy);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SearchCompanyContactsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @static
                     * @param {palexy.task_management.v1.SearchCompanyContactsRequest} message SearchCompanyContactsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SearchCompanyContactsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.statuses = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.query = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.orderBy = "";
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.query != null && message.hasOwnProperty("query"))
                            object.query = message.query;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        if (message.statuses && message.statuses.length) {
                            object.statuses = [];
                            for (var j = 0; j < message.statuses.length; ++j)
                                object.statuses[j] = options.enums === String ? $root.palexy.task_management.v1.ContactStatus[message.statuses[j]] : message.statuses[j];
                        }
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.orderBy != null && message.hasOwnProperty("orderBy"))
                            object.orderBy = message.orderBy;
                        return object;
                    };
    
                    /**
                     * Converts this SearchCompanyContactsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SearchCompanyContactsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SearchCompanyContactsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SearchCompanyContactsRequest;
                })();
    
                v1.SearchCompanyContactsResponse = (function() {
    
                    /**
                     * Properties of a SearchCompanyContactsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface ISearchCompanyContactsResponse
                     * @property {Array.<palexy.task_management.v1.ICompanyContact>|null} [contacts] SearchCompanyContactsResponse contacts
                     * @property {number|null} [totalElements] SearchCompanyContactsResponse totalElements
                     * @property {string|null} [nextPageToken] SearchCompanyContactsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new SearchCompanyContactsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a SearchCompanyContactsResponse.
                     * @implements ISearchCompanyContactsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.ISearchCompanyContactsResponse=} [properties] Properties to set
                     */
                    function SearchCompanyContactsResponse(properties) {
                        this.contacts = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * SearchCompanyContactsResponse contacts.
                     * @member {Array.<palexy.task_management.v1.ICompanyContact>} contacts
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @instance
                     */
                    SearchCompanyContactsResponse.prototype.contacts = $util.emptyArray;
    
                    /**
                     * SearchCompanyContactsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @instance
                     */
                    SearchCompanyContactsResponse.prototype.totalElements = 0;
    
                    /**
                     * SearchCompanyContactsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @instance
                     */
                    SearchCompanyContactsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new SearchCompanyContactsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.SearchCompanyContactsResponse} SearchCompanyContactsResponse instance
                     */
                    SearchCompanyContactsResponse.create = function create(properties) {
                        return new SearchCompanyContactsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified SearchCompanyContactsResponse message. Does not implicitly {@link palexy.task_management.v1.SearchCompanyContactsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsResponse} message SearchCompanyContactsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SearchCompanyContactsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.contacts != null && message.contacts.length)
                            for (var i = 0; i < message.contacts.length; ++i)
                                $root.palexy.task_management.v1.CompanyContact.encode(message.contacts[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified SearchCompanyContactsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.SearchCompanyContactsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {palexy.task_management.v1.ISearchCompanyContactsResponse} message SearchCompanyContactsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    SearchCompanyContactsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a SearchCompanyContactsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.SearchCompanyContactsResponse} SearchCompanyContactsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SearchCompanyContactsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.SearchCompanyContactsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.contacts && message.contacts.length))
                                    message.contacts = [];
                                message.contacts.push($root.palexy.task_management.v1.CompanyContact.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a SearchCompanyContactsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.SearchCompanyContactsResponse} SearchCompanyContactsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    SearchCompanyContactsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a SearchCompanyContactsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    SearchCompanyContactsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.contacts != null && message.hasOwnProperty("contacts")) {
                            if (!Array.isArray(message.contacts))
                                return "contacts: array expected";
                            for (var i = 0; i < message.contacts.length; ++i) {
                                var error = $root.palexy.task_management.v1.CompanyContact.verify(message.contacts[i]);
                                if (error)
                                    return "contacts." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a SearchCompanyContactsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.SearchCompanyContactsResponse} SearchCompanyContactsResponse
                     */
                    SearchCompanyContactsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.SearchCompanyContactsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.SearchCompanyContactsResponse();
                        if (object.contacts) {
                            if (!Array.isArray(object.contacts))
                                throw TypeError(".palexy.task_management.v1.SearchCompanyContactsResponse.contacts: array expected");
                            message.contacts = [];
                            for (var i = 0; i < object.contacts.length; ++i) {
                                if (typeof object.contacts[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.SearchCompanyContactsResponse.contacts: object expected");
                                message.contacts[i] = $root.palexy.task_management.v1.CompanyContact.fromObject(object.contacts[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a SearchCompanyContactsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @static
                     * @param {palexy.task_management.v1.SearchCompanyContactsResponse} message SearchCompanyContactsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    SearchCompanyContactsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.contacts = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.contacts && message.contacts.length) {
                            object.contacts = [];
                            for (var j = 0; j < message.contacts.length; ++j)
                                object.contacts[j] = $root.palexy.task_management.v1.CompanyContact.toObject(message.contacts[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this SearchCompanyContactsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.SearchCompanyContactsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    SearchCompanyContactsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return SearchCompanyContactsResponse;
                })();
    
                v1.GetCompanyContactRequest = (function() {
    
                    /**
                     * Properties of a GetCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCompanyContactRequest
                     * @property {number|null} [companyId] GetCompanyContactRequest companyId
                     * @property {number|null} [contactId] GetCompanyContactRequest contactId
                     */
    
                    /**
                     * Constructs a new GetCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCompanyContactRequest.
                     * @implements IGetCompanyContactRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest=} [properties] Properties to set
                     */
                    function GetCompanyContactRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyContactRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @instance
                     */
                    GetCompanyContactRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCompanyContactRequest contactId.
                     * @member {number} contactId
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @instance
                     */
                    GetCompanyContactRequest.prototype.contactId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCompanyContactRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCompanyContactRequest} GetCompanyContactRequest instance
                     */
                    GetCompanyContactRequest.create = function create(properties) {
                        return new GetCompanyContactRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactRequest message. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest} message GetCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.contactId != null && Object.hasOwnProperty.call(message, "contactId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.contactId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactRequest} message GetCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyContactRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCompanyContactRequest} GetCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCompanyContactRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.contactId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyContactRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCompanyContactRequest} GetCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyContactRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyContactRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.contactId != null && message.hasOwnProperty("contactId"))
                            if (!$util.isInteger(message.contactId) && !(message.contactId && $util.isInteger(message.contactId.low) && $util.isInteger(message.contactId.high)))
                                return "contactId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyContactRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCompanyContactRequest} GetCompanyContactRequest
                     */
                    GetCompanyContactRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCompanyContactRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCompanyContactRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.contactId != null)
                            if ($util.Long)
                                (message.contactId = $util.Long.fromValue(object.contactId)).unsigned = false;
                            else if (typeof object.contactId === "string")
                                message.contactId = parseInt(object.contactId, 10);
                            else if (typeof object.contactId === "number")
                                message.contactId = object.contactId;
                            else if (typeof object.contactId === "object")
                                message.contactId = new $util.LongBits(object.contactId.low >>> 0, object.contactId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyContactRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.GetCompanyContactRequest} message GetCompanyContactRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyContactRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.contactId != null && message.hasOwnProperty("contactId"))
                            if (typeof message.contactId === "number")
                                object.contactId = options.longs === String ? String(message.contactId) : message.contactId;
                            else
                                object.contactId = options.longs === String ? $util.Long.prototype.toString.call(message.contactId) : options.longs === Number ? new $util.LongBits(message.contactId.low >>> 0, message.contactId.high >>> 0).toNumber() : message.contactId;
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyContactRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCompanyContactRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyContactRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyContactRequest;
                })();
    
                v1.CreateCompanyContactRequest = (function() {
    
                    /**
                     * Properties of a CreateCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateCompanyContactRequest
                     * @property {number|null} [companyId] CreateCompanyContactRequest companyId
                     * @property {palexy.task_management.v1.ICompanyContact|null} [companyContact] CreateCompanyContactRequest companyContact
                     * @property {Array.<number>|null} [listIds] CreateCompanyContactRequest listIds
                     */
    
                    /**
                     * Constructs a new CreateCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateCompanyContactRequest.
                     * @implements ICreateCompanyContactRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest=} [properties] Properties to set
                     */
                    function CreateCompanyContactRequest(properties) {
                        this.listIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateCompanyContactRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @instance
                     */
                    CreateCompanyContactRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateCompanyContactRequest companyContact.
                     * @member {palexy.task_management.v1.ICompanyContact|null|undefined} companyContact
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @instance
                     */
                    CreateCompanyContactRequest.prototype.companyContact = null;
    
                    /**
                     * CreateCompanyContactRequest listIds.
                     * @member {Array.<number>} listIds
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @instance
                     */
                    CreateCompanyContactRequest.prototype.listIds = $util.emptyArray;
    
                    /**
                     * Creates a new CreateCompanyContactRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateCompanyContactRequest} CreateCompanyContactRequest instance
                     */
                    CreateCompanyContactRequest.create = function create(properties) {
                        return new CreateCompanyContactRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateCompanyContactRequest message. Does not implicitly {@link palexy.task_management.v1.CreateCompanyContactRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest} message CreateCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCompanyContactRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.companyContact != null && Object.hasOwnProperty.call(message, "companyContact"))
                            $root.palexy.task_management.v1.CompanyContact.encode(message.companyContact, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.listIds != null && message.listIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.listIds.length; ++i)
                                writer.int64(message.listIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateCompanyContactRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateCompanyContactRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactRequest} message CreateCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCompanyContactRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateCompanyContactRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateCompanyContactRequest} CreateCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCompanyContactRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateCompanyContactRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.companyContact = $root.palexy.task_management.v1.CompanyContact.decode(reader, reader.uint32());
                                break;
                            case 3:
                                if (!(message.listIds && message.listIds.length))
                                    message.listIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.listIds.push(reader.int64());
                                } else
                                    message.listIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateCompanyContactRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateCompanyContactRequest} CreateCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCompanyContactRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateCompanyContactRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateCompanyContactRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.companyContact != null && message.hasOwnProperty("companyContact")) {
                            var error = $root.palexy.task_management.v1.CompanyContact.verify(message.companyContact);
                            if (error)
                                return "companyContact." + error;
                        }
                        if (message.listIds != null && message.hasOwnProperty("listIds")) {
                            if (!Array.isArray(message.listIds))
                                return "listIds: array expected";
                            for (var i = 0; i < message.listIds.length; ++i)
                                if (!$util.isInteger(message.listIds[i]) && !(message.listIds[i] && $util.isInteger(message.listIds[i].low) && $util.isInteger(message.listIds[i].high)))
                                    return "listIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateCompanyContactRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateCompanyContactRequest} CreateCompanyContactRequest
                     */
                    CreateCompanyContactRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateCompanyContactRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateCompanyContactRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.companyContact != null) {
                            if (typeof object.companyContact !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateCompanyContactRequest.companyContact: object expected");
                            message.companyContact = $root.palexy.task_management.v1.CompanyContact.fromObject(object.companyContact);
                        }
                        if (object.listIds) {
                            if (!Array.isArray(object.listIds))
                                throw TypeError(".palexy.task_management.v1.CreateCompanyContactRequest.listIds: array expected");
                            message.listIds = [];
                            for (var i = 0; i < object.listIds.length; ++i)
                                if ($util.Long)
                                    (message.listIds[i] = $util.Long.fromValue(object.listIds[i])).unsigned = false;
                                else if (typeof object.listIds[i] === "string")
                                    message.listIds[i] = parseInt(object.listIds[i], 10);
                                else if (typeof object.listIds[i] === "number")
                                    message.listIds[i] = object.listIds[i];
                                else if (typeof object.listIds[i] === "object")
                                    message.listIds[i] = new $util.LongBits(object.listIds[i].low >>> 0, object.listIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateCompanyContactRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateCompanyContactRequest} message CreateCompanyContactRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateCompanyContactRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.listIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.companyContact = null;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.companyContact != null && message.hasOwnProperty("companyContact"))
                            object.companyContact = $root.palexy.task_management.v1.CompanyContact.toObject(message.companyContact, options);
                        if (message.listIds && message.listIds.length) {
                            object.listIds = [];
                            for (var j = 0; j < message.listIds.length; ++j)
                                if (typeof message.listIds[j] === "number")
                                    object.listIds[j] = options.longs === String ? String(message.listIds[j]) : message.listIds[j];
                                else
                                    object.listIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.listIds[j]) : options.longs === Number ? new $util.LongBits(message.listIds[j].low >>> 0, message.listIds[j].high >>> 0).toNumber() : message.listIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this CreateCompanyContactRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateCompanyContactRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateCompanyContactRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateCompanyContactRequest;
                })();
    
                v1.UpdateCompanyContactRequest = (function() {
    
                    /**
                     * Properties of an UpdateCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateCompanyContactRequest
                     * @property {number|null} [companyId] UpdateCompanyContactRequest companyId
                     * @property {palexy.task_management.v1.ICompanyContact|null} [companyContact] UpdateCompanyContactRequest companyContact
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateCompanyContactRequest updateMask
                     * @property {Array.<number>|null} [listIds] UpdateCompanyContactRequest listIds
                     */
    
                    /**
                     * Constructs a new UpdateCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateCompanyContactRequest.
                     * @implements IUpdateCompanyContactRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest=} [properties] Properties to set
                     */
                    function UpdateCompanyContactRequest(properties) {
                        this.listIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateCompanyContactRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @instance
                     */
                    UpdateCompanyContactRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateCompanyContactRequest companyContact.
                     * @member {palexy.task_management.v1.ICompanyContact|null|undefined} companyContact
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @instance
                     */
                    UpdateCompanyContactRequest.prototype.companyContact = null;
    
                    /**
                     * UpdateCompanyContactRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @instance
                     */
                    UpdateCompanyContactRequest.prototype.updateMask = null;
    
                    /**
                     * UpdateCompanyContactRequest listIds.
                     * @member {Array.<number>} listIds
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @instance
                     */
                    UpdateCompanyContactRequest.prototype.listIds = $util.emptyArray;
    
                    /**
                     * Creates a new UpdateCompanyContactRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateCompanyContactRequest} UpdateCompanyContactRequest instance
                     */
                    UpdateCompanyContactRequest.create = function create(properties) {
                        return new UpdateCompanyContactRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateCompanyContactRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateCompanyContactRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest} message UpdateCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCompanyContactRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.companyContact != null && Object.hasOwnProperty.call(message, "companyContact"))
                            $root.palexy.task_management.v1.CompanyContact.encode(message.companyContact, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        if (message.listIds != null && message.listIds.length) {
                            writer.uint32(/* id 4, wireType 2 =*/34).fork();
                            for (var i = 0; i < message.listIds.length; ++i)
                                writer.int64(message.listIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateCompanyContactRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateCompanyContactRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactRequest} message UpdateCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCompanyContactRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateCompanyContactRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateCompanyContactRequest} UpdateCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCompanyContactRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateCompanyContactRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.companyContact = $root.palexy.task_management.v1.CompanyContact.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            case 4:
                                if (!(message.listIds && message.listIds.length))
                                    message.listIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.listIds.push(reader.int64());
                                } else
                                    message.listIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateCompanyContactRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateCompanyContactRequest} UpdateCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCompanyContactRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateCompanyContactRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateCompanyContactRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.companyContact != null && message.hasOwnProperty("companyContact")) {
                            var error = $root.palexy.task_management.v1.CompanyContact.verify(message.companyContact);
                            if (error)
                                return "companyContact." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        if (message.listIds != null && message.hasOwnProperty("listIds")) {
                            if (!Array.isArray(message.listIds))
                                return "listIds: array expected";
                            for (var i = 0; i < message.listIds.length; ++i)
                                if (!$util.isInteger(message.listIds[i]) && !(message.listIds[i] && $util.isInteger(message.listIds[i].low) && $util.isInteger(message.listIds[i].high)))
                                    return "listIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateCompanyContactRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateCompanyContactRequest} UpdateCompanyContactRequest
                     */
                    UpdateCompanyContactRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateCompanyContactRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateCompanyContactRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.companyContact != null) {
                            if (typeof object.companyContact !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCompanyContactRequest.companyContact: object expected");
                            message.companyContact = $root.palexy.task_management.v1.CompanyContact.fromObject(object.companyContact);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCompanyContactRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        if (object.listIds) {
                            if (!Array.isArray(object.listIds))
                                throw TypeError(".palexy.task_management.v1.UpdateCompanyContactRequest.listIds: array expected");
                            message.listIds = [];
                            for (var i = 0; i < object.listIds.length; ++i)
                                if ($util.Long)
                                    (message.listIds[i] = $util.Long.fromValue(object.listIds[i])).unsigned = false;
                                else if (typeof object.listIds[i] === "string")
                                    message.listIds[i] = parseInt(object.listIds[i], 10);
                                else if (typeof object.listIds[i] === "number")
                                    message.listIds[i] = object.listIds[i];
                                else if (typeof object.listIds[i] === "object")
                                    message.listIds[i] = new $util.LongBits(object.listIds[i].low >>> 0, object.listIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateCompanyContactRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateCompanyContactRequest} message UpdateCompanyContactRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateCompanyContactRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.listIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.companyContact = null;
                            object.updateMask = null;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.companyContact != null && message.hasOwnProperty("companyContact"))
                            object.companyContact = $root.palexy.task_management.v1.CompanyContact.toObject(message.companyContact, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        if (message.listIds && message.listIds.length) {
                            object.listIds = [];
                            for (var j = 0; j < message.listIds.length; ++j)
                                if (typeof message.listIds[j] === "number")
                                    object.listIds[j] = options.longs === String ? String(message.listIds[j]) : message.listIds[j];
                                else
                                    object.listIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.listIds[j]) : options.longs === Number ? new $util.LongBits(message.listIds[j].low >>> 0, message.listIds[j].high >>> 0).toNumber() : message.listIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this UpdateCompanyContactRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateCompanyContactRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateCompanyContactRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateCompanyContactRequest;
                })();
    
                v1.DeleteCompanyContactRequest = (function() {
    
                    /**
                     * Properties of a DeleteCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteCompanyContactRequest
                     * @property {number|null} [companyId] DeleteCompanyContactRequest companyId
                     * @property {number|null} [contactId] DeleteCompanyContactRequest contactId
                     */
    
                    /**
                     * Constructs a new DeleteCompanyContactRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteCompanyContactRequest.
                     * @implements IDeleteCompanyContactRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest=} [properties] Properties to set
                     */
                    function DeleteCompanyContactRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteCompanyContactRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @instance
                     */
                    DeleteCompanyContactRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteCompanyContactRequest contactId.
                     * @member {number} contactId
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @instance
                     */
                    DeleteCompanyContactRequest.prototype.contactId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteCompanyContactRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteCompanyContactRequest} DeleteCompanyContactRequest instance
                     */
                    DeleteCompanyContactRequest.create = function create(properties) {
                        return new DeleteCompanyContactRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteCompanyContactRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteCompanyContactRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest} message DeleteCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCompanyContactRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.contactId != null && Object.hasOwnProperty.call(message, "contactId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.contactId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteCompanyContactRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteCompanyContactRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactRequest} message DeleteCompanyContactRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCompanyContactRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteCompanyContactRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteCompanyContactRequest} DeleteCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCompanyContactRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteCompanyContactRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.contactId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteCompanyContactRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteCompanyContactRequest} DeleteCompanyContactRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCompanyContactRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteCompanyContactRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteCompanyContactRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.contactId != null && message.hasOwnProperty("contactId"))
                            if (!$util.isInteger(message.contactId) && !(message.contactId && $util.isInteger(message.contactId.low) && $util.isInteger(message.contactId.high)))
                                return "contactId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteCompanyContactRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteCompanyContactRequest} DeleteCompanyContactRequest
                     */
                    DeleteCompanyContactRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteCompanyContactRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteCompanyContactRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.contactId != null)
                            if ($util.Long)
                                (message.contactId = $util.Long.fromValue(object.contactId)).unsigned = false;
                            else if (typeof object.contactId === "string")
                                message.contactId = parseInt(object.contactId, 10);
                            else if (typeof object.contactId === "number")
                                message.contactId = object.contactId;
                            else if (typeof object.contactId === "object")
                                message.contactId = new $util.LongBits(object.contactId.low >>> 0, object.contactId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteCompanyContactRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteCompanyContactRequest} message DeleteCompanyContactRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteCompanyContactRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.contactId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.contactId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.contactId != null && message.hasOwnProperty("contactId"))
                            if (typeof message.contactId === "number")
                                object.contactId = options.longs === String ? String(message.contactId) : message.contactId;
                            else
                                object.contactId = options.longs === String ? $util.Long.prototype.toString.call(message.contactId) : options.longs === Number ? new $util.LongBits(message.contactId.low >>> 0, message.contactId.high >>> 0).toNumber() : message.contactId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteCompanyContactRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteCompanyContactRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteCompanyContactRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteCompanyContactRequest;
                })();
    
                v1.ListCompanyContactPropertyCodesRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyContactPropertyCodesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactPropertyCodesRequest
                     * @property {number|null} [companyId] ListCompanyContactPropertyCodesRequest companyId
                     */
    
                    /**
                     * Constructs a new ListCompanyContactPropertyCodesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactPropertyCodesRequest.
                     * @implements IListCompanyContactPropertyCodesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest=} [properties] Properties to set
                     */
                    function ListCompanyContactPropertyCodesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactPropertyCodesRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @instance
                     */
                    ListCompanyContactPropertyCodesRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListCompanyContactPropertyCodesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesRequest} ListCompanyContactPropertyCodesRequest instance
                     */
                    ListCompanyContactPropertyCodesRequest.create = function create(properties) {
                        return new ListCompanyContactPropertyCodesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactPropertyCodesRequest message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactPropertyCodesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest} message ListCompanyContactPropertyCodesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactPropertyCodesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactPropertyCodesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactPropertyCodesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesRequest} message ListCompanyContactPropertyCodesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactPropertyCodesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactPropertyCodesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesRequest} ListCompanyContactPropertyCodesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactPropertyCodesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactPropertyCodesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactPropertyCodesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesRequest} ListCompanyContactPropertyCodesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactPropertyCodesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactPropertyCodesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactPropertyCodesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactPropertyCodesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesRequest} ListCompanyContactPropertyCodesRequest
                     */
                    ListCompanyContactPropertyCodesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactPropertyCodesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactPropertyCodesRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactPropertyCodesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactPropertyCodesRequest} message ListCompanyContactPropertyCodesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactPropertyCodesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactPropertyCodesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactPropertyCodesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactPropertyCodesRequest;
                })();
    
                v1.ListCompanyContactPropertyCodesResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyContactPropertyCodesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactPropertyCodesResponse
                     * @property {Array.<string>|null} [codes] ListCompanyContactPropertyCodesResponse codes
                     */
    
                    /**
                     * Constructs a new ListCompanyContactPropertyCodesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactPropertyCodesResponse.
                     * @implements IListCompanyContactPropertyCodesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesResponse=} [properties] Properties to set
                     */
                    function ListCompanyContactPropertyCodesResponse(properties) {
                        this.codes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactPropertyCodesResponse codes.
                     * @member {Array.<string>} codes
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @instance
                     */
                    ListCompanyContactPropertyCodesResponse.prototype.codes = $util.emptyArray;
    
                    /**
                     * Creates a new ListCompanyContactPropertyCodesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} ListCompanyContactPropertyCodesResponse instance
                     */
                    ListCompanyContactPropertyCodesResponse.create = function create(properties) {
                        return new ListCompanyContactPropertyCodesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactPropertyCodesResponse message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactPropertyCodesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesResponse} message ListCompanyContactPropertyCodesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactPropertyCodesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.codes != null && message.codes.length)
                            for (var i = 0; i < message.codes.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.codes[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactPropertyCodesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactPropertyCodesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactPropertyCodesResponse} message ListCompanyContactPropertyCodesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactPropertyCodesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactPropertyCodesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} ListCompanyContactPropertyCodesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactPropertyCodesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactPropertyCodesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.codes && message.codes.length))
                                    message.codes = [];
                                message.codes.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactPropertyCodesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} ListCompanyContactPropertyCodesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactPropertyCodesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactPropertyCodesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactPropertyCodesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.codes != null && message.hasOwnProperty("codes")) {
                            if (!Array.isArray(message.codes))
                                return "codes: array expected";
                            for (var i = 0; i < message.codes.length; ++i)
                                if (!$util.isString(message.codes[i]))
                                    return "codes: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactPropertyCodesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} ListCompanyContactPropertyCodesResponse
                     */
                    ListCompanyContactPropertyCodesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactPropertyCodesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactPropertyCodesResponse();
                        if (object.codes) {
                            if (!Array.isArray(object.codes))
                                throw TypeError(".palexy.task_management.v1.ListCompanyContactPropertyCodesResponse.codes: array expected");
                            message.codes = [];
                            for (var i = 0; i < object.codes.length; ++i)
                                message.codes[i] = String(object.codes[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactPropertyCodesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactPropertyCodesResponse} message ListCompanyContactPropertyCodesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactPropertyCodesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.codes = [];
                        if (message.codes && message.codes.length) {
                            object.codes = [];
                            for (var j = 0; j < message.codes.length; ++j)
                                object.codes[j] = message.codes[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactPropertyCodesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactPropertyCodesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactPropertyCodesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactPropertyCodesResponse;
                })();
    
                v1.ListCompanyContactListPropertyCodesRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyContactListPropertyCodesRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactListPropertyCodesRequest
                     * @property {number|null} [companyId] ListCompanyContactListPropertyCodesRequest companyId
                     * @property {number|null} [listId] ListCompanyContactListPropertyCodesRequest listId
                     */
    
                    /**
                     * Constructs a new ListCompanyContactListPropertyCodesRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactListPropertyCodesRequest.
                     * @implements IListCompanyContactListPropertyCodesRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest=} [properties] Properties to set
                     */
                    function ListCompanyContactListPropertyCodesRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactListPropertyCodesRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @instance
                     */
                    ListCompanyContactListPropertyCodesRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListCompanyContactListPropertyCodesRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @instance
                     */
                    ListCompanyContactListPropertyCodesRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new ListCompanyContactListPropertyCodesRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest} ListCompanyContactListPropertyCodesRequest instance
                     */
                    ListCompanyContactListPropertyCodesRequest.create = function create(properties) {
                        return new ListCompanyContactListPropertyCodesRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListPropertyCodesRequest message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest} message ListCompanyContactListPropertyCodesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListPropertyCodesRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.listId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListPropertyCodesRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesRequest} message ListCompanyContactListPropertyCodesRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListPropertyCodesRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactListPropertyCodesRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest} ListCompanyContactListPropertyCodesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListPropertyCodesRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.listId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactListPropertyCodesRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest} ListCompanyContactListPropertyCodesRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListPropertyCodesRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactListPropertyCodesRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactListPropertyCodesRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactListPropertyCodesRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest} ListCompanyContactListPropertyCodesRequest
                     */
                    ListCompanyContactListPropertyCodesRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactListPropertyCodesRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest} message ListCompanyContactListPropertyCodesRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactListPropertyCodesRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactListPropertyCodesRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactListPropertyCodesRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactListPropertyCodesRequest;
                })();
    
                v1.ListCompanyContactListPropertyCodesResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyContactListPropertyCodesResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactListPropertyCodesResponse
                     * @property {Array.<string>|null} [codes] ListCompanyContactListPropertyCodesResponse codes
                     */
    
                    /**
                     * Constructs a new ListCompanyContactListPropertyCodesResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactListPropertyCodesResponse.
                     * @implements IListCompanyContactListPropertyCodesResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesResponse=} [properties] Properties to set
                     */
                    function ListCompanyContactListPropertyCodesResponse(properties) {
                        this.codes = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactListPropertyCodesResponse codes.
                     * @member {Array.<string>} codes
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @instance
                     */
                    ListCompanyContactListPropertyCodesResponse.prototype.codes = $util.emptyArray;
    
                    /**
                     * Creates a new ListCompanyContactListPropertyCodesResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} ListCompanyContactListPropertyCodesResponse instance
                     */
                    ListCompanyContactListPropertyCodesResponse.create = function create(properties) {
                        return new ListCompanyContactListPropertyCodesResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListPropertyCodesResponse message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesResponse} message ListCompanyContactListPropertyCodesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListPropertyCodesResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.codes != null && message.codes.length)
                            for (var i = 0; i < message.codes.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.codes[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListPropertyCodesResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListPropertyCodesResponse} message ListCompanyContactListPropertyCodesResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListPropertyCodesResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactListPropertyCodesResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} ListCompanyContactListPropertyCodesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListPropertyCodesResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.codes && message.codes.length))
                                    message.codes = [];
                                message.codes.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactListPropertyCodesResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} ListCompanyContactListPropertyCodesResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListPropertyCodesResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactListPropertyCodesResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactListPropertyCodesResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.codes != null && message.hasOwnProperty("codes")) {
                            if (!Array.isArray(message.codes))
                                return "codes: array expected";
                            for (var i = 0; i < message.codes.length; ++i)
                                if (!$util.isString(message.codes[i]))
                                    return "codes: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactListPropertyCodesResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} ListCompanyContactListPropertyCodesResponse
                     */
                    ListCompanyContactListPropertyCodesResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse();
                        if (object.codes) {
                            if (!Array.isArray(object.codes))
                                throw TypeError(".palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse.codes: array expected");
                            message.codes = [];
                            for (var i = 0; i < object.codes.length; ++i)
                                message.codes[i] = String(object.codes[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactListPropertyCodesResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse} message ListCompanyContactListPropertyCodesResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactListPropertyCodesResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.codes = [];
                        if (message.codes && message.codes.length) {
                            object.codes = [];
                            for (var j = 0; j < message.codes.length; ++j)
                                object.codes[j] = message.codes[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactListPropertyCodesResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactListPropertyCodesResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactListPropertyCodesResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactListPropertyCodesResponse;
                })();
    
                v1.ListCompanyContactListsRequest = (function() {
    
                    /**
                     * Properties of a ListCompanyContactListsRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactListsRequest
                     * @property {number|null} [companyId] ListCompanyContactListsRequest companyId
                     * @property {string|null} [query] ListCompanyContactListsRequest query
                     * @property {number|null} [pageSize] ListCompanyContactListsRequest pageSize
                     * @property {string|null} [pageToken] ListCompanyContactListsRequest pageToken
                     * @property {boolean|null} [includeDetails] ListCompanyContactListsRequest includeDetails
                     */
    
                    /**
                     * Constructs a new ListCompanyContactListsRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactListsRequest.
                     * @implements IListCompanyContactListsRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest=} [properties] Properties to set
                     */
                    function ListCompanyContactListsRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactListsRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     */
                    ListCompanyContactListsRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * ListCompanyContactListsRequest query.
                     * @member {string} query
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     */
                    ListCompanyContactListsRequest.prototype.query = "";
    
                    /**
                     * ListCompanyContactListsRequest pageSize.
                     * @member {number} pageSize
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     */
                    ListCompanyContactListsRequest.prototype.pageSize = 0;
    
                    /**
                     * ListCompanyContactListsRequest pageToken.
                     * @member {string} pageToken
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     */
                    ListCompanyContactListsRequest.prototype.pageToken = "";
    
                    /**
                     * ListCompanyContactListsRequest includeDetails.
                     * @member {boolean} includeDetails
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     */
                    ListCompanyContactListsRequest.prototype.includeDetails = false;
    
                    /**
                     * Creates a new ListCompanyContactListsRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactListsRequest} ListCompanyContactListsRequest instance
                     */
                    ListCompanyContactListsRequest.create = function create(properties) {
                        return new ListCompanyContactListsRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListsRequest message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListsRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest} message ListCompanyContactListsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListsRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.query != null && Object.hasOwnProperty.call(message, "query"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.query);
                        if (message.pageSize != null && Object.hasOwnProperty.call(message, "pageSize"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.pageSize);
                        if (message.pageToken != null && Object.hasOwnProperty.call(message, "pageToken"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.pageToken);
                        if (message.includeDetails != null && Object.hasOwnProperty.call(message, "includeDetails"))
                            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.includeDetails);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListsRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListsRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsRequest} message ListCompanyContactListsRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListsRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactListsRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactListsRequest} ListCompanyContactListsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListsRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactListsRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.query = reader.string();
                                break;
                            case 3:
                                message.pageSize = reader.int32();
                                break;
                            case 4:
                                message.pageToken = reader.string();
                                break;
                            case 5:
                                message.includeDetails = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactListsRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactListsRequest} ListCompanyContactListsRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListsRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactListsRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactListsRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.query != null && message.hasOwnProperty("query"))
                            if (!$util.isString(message.query))
                                return "query: string expected";
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            if (!$util.isInteger(message.pageSize))
                                return "pageSize: integer expected";
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            if (!$util.isString(message.pageToken))
                                return "pageToken: string expected";
                        if (message.includeDetails != null && message.hasOwnProperty("includeDetails"))
                            if (typeof message.includeDetails !== "boolean")
                                return "includeDetails: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactListsRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactListsRequest} ListCompanyContactListsRequest
                     */
                    ListCompanyContactListsRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactListsRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactListsRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.query != null)
                            message.query = String(object.query);
                        if (object.pageSize != null)
                            message.pageSize = object.pageSize | 0;
                        if (object.pageToken != null)
                            message.pageToken = String(object.pageToken);
                        if (object.includeDetails != null)
                            message.includeDetails = Boolean(object.includeDetails);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactListsRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactListsRequest} message ListCompanyContactListsRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactListsRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.query = "";
                            object.pageSize = 0;
                            object.pageToken = "";
                            object.includeDetails = false;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.query != null && message.hasOwnProperty("query"))
                            object.query = message.query;
                        if (message.pageSize != null && message.hasOwnProperty("pageSize"))
                            object.pageSize = message.pageSize;
                        if (message.pageToken != null && message.hasOwnProperty("pageToken"))
                            object.pageToken = message.pageToken;
                        if (message.includeDetails != null && message.hasOwnProperty("includeDetails"))
                            object.includeDetails = message.includeDetails;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactListsRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactListsRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactListsRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactListsRequest;
                })();
    
                v1.ListCompanyContactListsResponse = (function() {
    
                    /**
                     * Properties of a ListCompanyContactListsResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IListCompanyContactListsResponse
                     * @property {Array.<palexy.task_management.v1.ICompanyContactList>|null} [companyContactLists] ListCompanyContactListsResponse companyContactLists
                     * @property {number|null} [totalElements] ListCompanyContactListsResponse totalElements
                     * @property {string|null} [nextPageToken] ListCompanyContactListsResponse nextPageToken
                     */
    
                    /**
                     * Constructs a new ListCompanyContactListsResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ListCompanyContactListsResponse.
                     * @implements IListCompanyContactListsResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IListCompanyContactListsResponse=} [properties] Properties to set
                     */
                    function ListCompanyContactListsResponse(properties) {
                        this.companyContactLists = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListCompanyContactListsResponse companyContactLists.
                     * @member {Array.<palexy.task_management.v1.ICompanyContactList>} companyContactLists
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @instance
                     */
                    ListCompanyContactListsResponse.prototype.companyContactLists = $util.emptyArray;
    
                    /**
                     * ListCompanyContactListsResponse totalElements.
                     * @member {number} totalElements
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @instance
                     */
                    ListCompanyContactListsResponse.prototype.totalElements = 0;
    
                    /**
                     * ListCompanyContactListsResponse nextPageToken.
                     * @member {string} nextPageToken
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @instance
                     */
                    ListCompanyContactListsResponse.prototype.nextPageToken = "";
    
                    /**
                     * Creates a new ListCompanyContactListsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ListCompanyContactListsResponse} ListCompanyContactListsResponse instance
                     */
                    ListCompanyContactListsResponse.create = function create(properties) {
                        return new ListCompanyContactListsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListsResponse message. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsResponse} message ListCompanyContactListsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyContactLists != null && message.companyContactLists.length)
                            for (var i = 0; i < message.companyContactLists.length; ++i)
                                $root.palexy.task_management.v1.CompanyContactList.encode(message.companyContactLists[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.totalElements != null && Object.hasOwnProperty.call(message, "totalElements"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.totalElements);
                        if (message.nextPageToken != null && Object.hasOwnProperty.call(message, "nextPageToken"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.nextPageToken);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListCompanyContactListsResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ListCompanyContactListsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.IListCompanyContactListsResponse} message ListCompanyContactListsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListCompanyContactListsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListCompanyContactListsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ListCompanyContactListsResponse} ListCompanyContactListsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ListCompanyContactListsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.companyContactLists && message.companyContactLists.length))
                                    message.companyContactLists = [];
                                message.companyContactLists.push($root.palexy.task_management.v1.CompanyContactList.decode(reader, reader.uint32()));
                                break;
                            case 2:
                                message.totalElements = reader.int32();
                                break;
                            case 3:
                                message.nextPageToken = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListCompanyContactListsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ListCompanyContactListsResponse} ListCompanyContactListsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListCompanyContactListsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListCompanyContactListsResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListCompanyContactListsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyContactLists != null && message.hasOwnProperty("companyContactLists")) {
                            if (!Array.isArray(message.companyContactLists))
                                return "companyContactLists: array expected";
                            for (var i = 0; i < message.companyContactLists.length; ++i) {
                                var error = $root.palexy.task_management.v1.CompanyContactList.verify(message.companyContactLists[i]);
                                if (error)
                                    return "companyContactLists." + error;
                            }
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            if (!$util.isInteger(message.totalElements))
                                return "totalElements: integer expected";
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            if (!$util.isString(message.nextPageToken))
                                return "nextPageToken: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListCompanyContactListsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ListCompanyContactListsResponse} ListCompanyContactListsResponse
                     */
                    ListCompanyContactListsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ListCompanyContactListsResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ListCompanyContactListsResponse();
                        if (object.companyContactLists) {
                            if (!Array.isArray(object.companyContactLists))
                                throw TypeError(".palexy.task_management.v1.ListCompanyContactListsResponse.companyContactLists: array expected");
                            message.companyContactLists = [];
                            for (var i = 0; i < object.companyContactLists.length; ++i) {
                                if (typeof object.companyContactLists[i] !== "object")
                                    throw TypeError(".palexy.task_management.v1.ListCompanyContactListsResponse.companyContactLists: object expected");
                                message.companyContactLists[i] = $root.palexy.task_management.v1.CompanyContactList.fromObject(object.companyContactLists[i]);
                            }
                        }
                        if (object.totalElements != null)
                            message.totalElements = object.totalElements | 0;
                        if (object.nextPageToken != null)
                            message.nextPageToken = String(object.nextPageToken);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListCompanyContactListsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @static
                     * @param {palexy.task_management.v1.ListCompanyContactListsResponse} message ListCompanyContactListsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListCompanyContactListsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.companyContactLists = [];
                        if (options.defaults) {
                            object.totalElements = 0;
                            object.nextPageToken = "";
                        }
                        if (message.companyContactLists && message.companyContactLists.length) {
                            object.companyContactLists = [];
                            for (var j = 0; j < message.companyContactLists.length; ++j)
                                object.companyContactLists[j] = $root.palexy.task_management.v1.CompanyContactList.toObject(message.companyContactLists[j], options);
                        }
                        if (message.totalElements != null && message.hasOwnProperty("totalElements"))
                            object.totalElements = message.totalElements;
                        if (message.nextPageToken != null && message.hasOwnProperty("nextPageToken"))
                            object.nextPageToken = message.nextPageToken;
                        return object;
                    };
    
                    /**
                     * Converts this ListCompanyContactListsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ListCompanyContactListsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListCompanyContactListsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListCompanyContactListsResponse;
                })();
    
                v1.CreateCompanyContactListRequest = (function() {
    
                    /**
                     * Properties of a CreateCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface ICreateCompanyContactListRequest
                     * @property {number|null} [companyId] CreateCompanyContactListRequest companyId
                     * @property {palexy.task_management.v1.ICompanyContactList|null} [companyContactList] CreateCompanyContactListRequest companyContactList
                     * @property {number|null} [createdBy] CreateCompanyContactListRequest createdBy
                     */
    
                    /**
                     * Constructs a new CreateCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a CreateCompanyContactListRequest.
                     * @implements ICreateCompanyContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest=} [properties] Properties to set
                     */
                    function CreateCompanyContactListRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateCompanyContactListRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @instance
                     */
                    CreateCompanyContactListRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * CreateCompanyContactListRequest companyContactList.
                     * @member {palexy.task_management.v1.ICompanyContactList|null|undefined} companyContactList
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @instance
                     */
                    CreateCompanyContactListRequest.prototype.companyContactList = null;
    
                    /**
                     * CreateCompanyContactListRequest createdBy.
                     * @member {number} createdBy
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @instance
                     */
                    CreateCompanyContactListRequest.prototype.createdBy = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new CreateCompanyContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.CreateCompanyContactListRequest} CreateCompanyContactListRequest instance
                     */
                    CreateCompanyContactListRequest.create = function create(properties) {
                        return new CreateCompanyContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateCompanyContactListRequest message. Does not implicitly {@link palexy.task_management.v1.CreateCompanyContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest} message CreateCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCompanyContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.companyContactList != null && Object.hasOwnProperty.call(message, "companyContactList"))
                            $root.palexy.task_management.v1.CompanyContactList.encode(message.companyContactList, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.createdBy != null && Object.hasOwnProperty.call(message, "createdBy"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.createdBy);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateCompanyContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.CreateCompanyContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.ICreateCompanyContactListRequest} message CreateCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateCompanyContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateCompanyContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.CreateCompanyContactListRequest} CreateCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCompanyContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.CreateCompanyContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.companyContactList = $root.palexy.task_management.v1.CompanyContactList.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.createdBy = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateCompanyContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.CreateCompanyContactListRequest} CreateCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateCompanyContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateCompanyContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateCompanyContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.companyContactList != null && message.hasOwnProperty("companyContactList")) {
                            var error = $root.palexy.task_management.v1.CompanyContactList.verify(message.companyContactList);
                            if (error)
                                return "companyContactList." + error;
                        }
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (!$util.isInteger(message.createdBy) && !(message.createdBy && $util.isInteger(message.createdBy.low) && $util.isInteger(message.createdBy.high)))
                                return "createdBy: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a CreateCompanyContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.CreateCompanyContactListRequest} CreateCompanyContactListRequest
                     */
                    CreateCompanyContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.CreateCompanyContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.CreateCompanyContactListRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.companyContactList != null) {
                            if (typeof object.companyContactList !== "object")
                                throw TypeError(".palexy.task_management.v1.CreateCompanyContactListRequest.companyContactList: object expected");
                            message.companyContactList = $root.palexy.task_management.v1.CompanyContactList.fromObject(object.companyContactList);
                        }
                        if (object.createdBy != null)
                            if ($util.Long)
                                (message.createdBy = $util.Long.fromValue(object.createdBy)).unsigned = false;
                            else if (typeof object.createdBy === "string")
                                message.createdBy = parseInt(object.createdBy, 10);
                            else if (typeof object.createdBy === "number")
                                message.createdBy = object.createdBy;
                            else if (typeof object.createdBy === "object")
                                message.createdBy = new $util.LongBits(object.createdBy.low >>> 0, object.createdBy.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateCompanyContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.CreateCompanyContactListRequest} message CreateCompanyContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateCompanyContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.companyContactList = null;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.createdBy = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.createdBy = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.companyContactList != null && message.hasOwnProperty("companyContactList"))
                            object.companyContactList = $root.palexy.task_management.v1.CompanyContactList.toObject(message.companyContactList, options);
                        if (message.createdBy != null && message.hasOwnProperty("createdBy"))
                            if (typeof message.createdBy === "number")
                                object.createdBy = options.longs === String ? String(message.createdBy) : message.createdBy;
                            else
                                object.createdBy = options.longs === String ? $util.Long.prototype.toString.call(message.createdBy) : options.longs === Number ? new $util.LongBits(message.createdBy.low >>> 0, message.createdBy.high >>> 0).toNumber() : message.createdBy;
                        return object;
                    };
    
                    /**
                     * Converts this CreateCompanyContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.CreateCompanyContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateCompanyContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateCompanyContactListRequest;
                })();
    
                v1.GetCompanyContactListRequest = (function() {
    
                    /**
                     * Properties of a GetCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IGetCompanyContactListRequest
                     * @property {number|null} [companyId] GetCompanyContactListRequest companyId
                     * @property {number|null} [listId] GetCompanyContactListRequest listId
                     */
    
                    /**
                     * Constructs a new GetCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a GetCompanyContactListRequest.
                     * @implements IGetCompanyContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest=} [properties] Properties to set
                     */
                    function GetCompanyContactListRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetCompanyContactListRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @instance
                     */
                    GetCompanyContactListRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetCompanyContactListRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @instance
                     */
                    GetCompanyContactListRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetCompanyContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.GetCompanyContactListRequest} GetCompanyContactListRequest instance
                     */
                    GetCompanyContactListRequest.create = function create(properties) {
                        return new GetCompanyContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactListRequest message. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest} message GetCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.listId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetCompanyContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.GetCompanyContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IGetCompanyContactListRequest} message GetCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetCompanyContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetCompanyContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.GetCompanyContactListRequest} GetCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.GetCompanyContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.listId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetCompanyContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.GetCompanyContactListRequest} GetCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetCompanyContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetCompanyContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetCompanyContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetCompanyContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.GetCompanyContactListRequest} GetCompanyContactListRequest
                     */
                    GetCompanyContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.GetCompanyContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.GetCompanyContactListRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetCompanyContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.GetCompanyContactListRequest} message GetCompanyContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetCompanyContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        return object;
                    };
    
                    /**
                     * Converts this GetCompanyContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.GetCompanyContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetCompanyContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetCompanyContactListRequest;
                })();
    
                v1.UpdateCompanyContactListRequest = (function() {
    
                    /**
                     * Properties of an UpdateCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IUpdateCompanyContactListRequest
                     * @property {number|null} [companyId] UpdateCompanyContactListRequest companyId
                     * @property {palexy.task_management.v1.ICompanyContactList|null} [companyContactList] UpdateCompanyContactListRequest companyContactList
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateCompanyContactListRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an UpdateCompanyContactListRequest.
                     * @implements IUpdateCompanyContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest=} [properties] Properties to set
                     */
                    function UpdateCompanyContactListRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateCompanyContactListRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @instance
                     */
                    UpdateCompanyContactListRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * UpdateCompanyContactListRequest companyContactList.
                     * @member {palexy.task_management.v1.ICompanyContactList|null|undefined} companyContactList
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @instance
                     */
                    UpdateCompanyContactListRequest.prototype.companyContactList = null;
    
                    /**
                     * UpdateCompanyContactListRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @instance
                     */
                    UpdateCompanyContactListRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateCompanyContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.UpdateCompanyContactListRequest} UpdateCompanyContactListRequest instance
                     */
                    UpdateCompanyContactListRequest.create = function create(properties) {
                        return new UpdateCompanyContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateCompanyContactListRequest message. Does not implicitly {@link palexy.task_management.v1.UpdateCompanyContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest} message UpdateCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCompanyContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.companyContactList != null && Object.hasOwnProperty.call(message, "companyContactList"))
                            $root.palexy.task_management.v1.CompanyContactList.encode(message.companyContactList, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateCompanyContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.UpdateCompanyContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IUpdateCompanyContactListRequest} message UpdateCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateCompanyContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateCompanyContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.UpdateCompanyContactListRequest} UpdateCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCompanyContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.UpdateCompanyContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.companyContactList = $root.palexy.task_management.v1.CompanyContactList.decode(reader, reader.uint32());
                                break;
                            case 3:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateCompanyContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.UpdateCompanyContactListRequest} UpdateCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateCompanyContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateCompanyContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateCompanyContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.companyContactList != null && message.hasOwnProperty("companyContactList")) {
                            var error = $root.palexy.task_management.v1.CompanyContactList.verify(message.companyContactList);
                            if (error)
                                return "companyContactList." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateCompanyContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.UpdateCompanyContactListRequest} UpdateCompanyContactListRequest
                     */
                    UpdateCompanyContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.UpdateCompanyContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.UpdateCompanyContactListRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.companyContactList != null) {
                            if (typeof object.companyContactList !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCompanyContactListRequest.companyContactList: object expected");
                            message.companyContactList = $root.palexy.task_management.v1.CompanyContactList.fromObject(object.companyContactList);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.task_management.v1.UpdateCompanyContactListRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateCompanyContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.UpdateCompanyContactListRequest} message UpdateCompanyContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateCompanyContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            object.companyContactList = null;
                            object.updateMask = null;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.companyContactList != null && message.hasOwnProperty("companyContactList"))
                            object.companyContactList = $root.palexy.task_management.v1.CompanyContactList.toObject(message.companyContactList, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateCompanyContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.UpdateCompanyContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateCompanyContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateCompanyContactListRequest;
                })();
    
                v1.DeleteCompanyContactListRequest = (function() {
    
                    /**
                     * Properties of a DeleteCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IDeleteCompanyContactListRequest
                     * @property {number|null} [companyId] DeleteCompanyContactListRequest companyId
                     * @property {number|null} [listId] DeleteCompanyContactListRequest listId
                     */
    
                    /**
                     * Constructs a new DeleteCompanyContactListRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a DeleteCompanyContactListRequest.
                     * @implements IDeleteCompanyContactListRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest=} [properties] Properties to set
                     */
                    function DeleteCompanyContactListRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteCompanyContactListRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @instance
                     */
                    DeleteCompanyContactListRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DeleteCompanyContactListRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @instance
                     */
                    DeleteCompanyContactListRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteCompanyContactListRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.DeleteCompanyContactListRequest} DeleteCompanyContactListRequest instance
                     */
                    DeleteCompanyContactListRequest.create = function create(properties) {
                        return new DeleteCompanyContactListRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteCompanyContactListRequest message. Does not implicitly {@link palexy.task_management.v1.DeleteCompanyContactListRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest} message DeleteCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCompanyContactListRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.listId);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteCompanyContactListRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.DeleteCompanyContactListRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.IDeleteCompanyContactListRequest} message DeleteCompanyContactListRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteCompanyContactListRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteCompanyContactListRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.DeleteCompanyContactListRequest} DeleteCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCompanyContactListRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.DeleteCompanyContactListRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.listId = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteCompanyContactListRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.DeleteCompanyContactListRequest} DeleteCompanyContactListRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteCompanyContactListRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteCompanyContactListRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteCompanyContactListRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteCompanyContactListRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.DeleteCompanyContactListRequest} DeleteCompanyContactListRequest
                     */
                    DeleteCompanyContactListRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.DeleteCompanyContactListRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.DeleteCompanyContactListRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteCompanyContactListRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @static
                     * @param {palexy.task_management.v1.DeleteCompanyContactListRequest} message DeleteCompanyContactListRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteCompanyContactListRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteCompanyContactListRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.DeleteCompanyContactListRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteCompanyContactListRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteCompanyContactListRequest;
                })();
    
                v1.AddCompanyContactListMembersRequest = (function() {
    
                    /**
                     * Properties of an AddCompanyContactListMembersRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IAddCompanyContactListMembersRequest
                     * @property {number|null} [companyId] AddCompanyContactListMembersRequest companyId
                     * @property {number|null} [listId] AddCompanyContactListMembersRequest listId
                     * @property {Array.<number>|null} [contactIds] AddCompanyContactListMembersRequest contactIds
                     */
    
                    /**
                     * Constructs a new AddCompanyContactListMembersRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents an AddCompanyContactListMembersRequest.
                     * @implements IAddCompanyContactListMembersRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest=} [properties] Properties to set
                     */
                    function AddCompanyContactListMembersRequest(properties) {
                        this.contactIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * AddCompanyContactListMembersRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @instance
                     */
                    AddCompanyContactListMembersRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AddCompanyContactListMembersRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @instance
                     */
                    AddCompanyContactListMembersRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * AddCompanyContactListMembersRequest contactIds.
                     * @member {Array.<number>} contactIds
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @instance
                     */
                    AddCompanyContactListMembersRequest.prototype.contactIds = $util.emptyArray;
    
                    /**
                     * Creates a new AddCompanyContactListMembersRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.AddCompanyContactListMembersRequest} AddCompanyContactListMembersRequest instance
                     */
                    AddCompanyContactListMembersRequest.create = function create(properties) {
                        return new AddCompanyContactListMembersRequest(properties);
                    };
    
                    /**
                     * Encodes the specified AddCompanyContactListMembersRequest message. Does not implicitly {@link palexy.task_management.v1.AddCompanyContactListMembersRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest} message AddCompanyContactListMembersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCompanyContactListMembersRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.listId);
                        if (message.contactIds != null && message.contactIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.contactIds.length; ++i)
                                writer.int64(message.contactIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified AddCompanyContactListMembersRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.AddCompanyContactListMembersRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IAddCompanyContactListMembersRequest} message AddCompanyContactListMembersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    AddCompanyContactListMembersRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an AddCompanyContactListMembersRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.AddCompanyContactListMembersRequest} AddCompanyContactListMembersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCompanyContactListMembersRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.AddCompanyContactListMembersRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.listId = reader.int64();
                                break;
                            case 3:
                                if (!(message.contactIds && message.contactIds.length))
                                    message.contactIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.contactIds.push(reader.int64());
                                } else
                                    message.contactIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an AddCompanyContactListMembersRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.AddCompanyContactListMembersRequest} AddCompanyContactListMembersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    AddCompanyContactListMembersRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an AddCompanyContactListMembersRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    AddCompanyContactListMembersRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        if (message.contactIds != null && message.hasOwnProperty("contactIds")) {
                            if (!Array.isArray(message.contactIds))
                                return "contactIds: array expected";
                            for (var i = 0; i < message.contactIds.length; ++i)
                                if (!$util.isInteger(message.contactIds[i]) && !(message.contactIds[i] && $util.isInteger(message.contactIds[i].low) && $util.isInteger(message.contactIds[i].high)))
                                    return "contactIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an AddCompanyContactListMembersRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.AddCompanyContactListMembersRequest} AddCompanyContactListMembersRequest
                     */
                    AddCompanyContactListMembersRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.AddCompanyContactListMembersRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.AddCompanyContactListMembersRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        if (object.contactIds) {
                            if (!Array.isArray(object.contactIds))
                                throw TypeError(".palexy.task_management.v1.AddCompanyContactListMembersRequest.contactIds: array expected");
                            message.contactIds = [];
                            for (var i = 0; i < object.contactIds.length; ++i)
                                if ($util.Long)
                                    (message.contactIds[i] = $util.Long.fromValue(object.contactIds[i])).unsigned = false;
                                else if (typeof object.contactIds[i] === "string")
                                    message.contactIds[i] = parseInt(object.contactIds[i], 10);
                                else if (typeof object.contactIds[i] === "number")
                                    message.contactIds[i] = object.contactIds[i];
                                else if (typeof object.contactIds[i] === "object")
                                    message.contactIds[i] = new $util.LongBits(object.contactIds[i].low >>> 0, object.contactIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an AddCompanyContactListMembersRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.AddCompanyContactListMembersRequest} message AddCompanyContactListMembersRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    AddCompanyContactListMembersRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.contactIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        if (message.contactIds && message.contactIds.length) {
                            object.contactIds = [];
                            for (var j = 0; j < message.contactIds.length; ++j)
                                if (typeof message.contactIds[j] === "number")
                                    object.contactIds[j] = options.longs === String ? String(message.contactIds[j]) : message.contactIds[j];
                                else
                                    object.contactIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.contactIds[j]) : options.longs === Number ? new $util.LongBits(message.contactIds[j].low >>> 0, message.contactIds[j].high >>> 0).toNumber() : message.contactIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this AddCompanyContactListMembersRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.AddCompanyContactListMembersRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    AddCompanyContactListMembersRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return AddCompanyContactListMembersRequest;
                })();
    
                v1.RemoveCompanyContactListMembersRequest = (function() {
    
                    /**
                     * Properties of a RemoveCompanyContactListMembersRequest.
                     * @memberof palexy.task_management.v1
                     * @interface IRemoveCompanyContactListMembersRequest
                     * @property {number|null} [companyId] RemoveCompanyContactListMembersRequest companyId
                     * @property {number|null} [listId] RemoveCompanyContactListMembersRequest listId
                     * @property {Array.<number>|null} [contactIds] RemoveCompanyContactListMembersRequest contactIds
                     */
    
                    /**
                     * Constructs a new RemoveCompanyContactListMembersRequest.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a RemoveCompanyContactListMembersRequest.
                     * @implements IRemoveCompanyContactListMembersRequest
                     * @constructor
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest=} [properties] Properties to set
                     */
                    function RemoveCompanyContactListMembersRequest(properties) {
                        this.contactIds = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RemoveCompanyContactListMembersRequest companyId.
                     * @member {number} companyId
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @instance
                     */
                    RemoveCompanyContactListMembersRequest.prototype.companyId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RemoveCompanyContactListMembersRequest listId.
                     * @member {number} listId
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @instance
                     */
                    RemoveCompanyContactListMembersRequest.prototype.listId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * RemoveCompanyContactListMembersRequest contactIds.
                     * @member {Array.<number>} contactIds
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @instance
                     */
                    RemoveCompanyContactListMembersRequest.prototype.contactIds = $util.emptyArray;
    
                    /**
                     * Creates a new RemoveCompanyContactListMembersRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.RemoveCompanyContactListMembersRequest} RemoveCompanyContactListMembersRequest instance
                     */
                    RemoveCompanyContactListMembersRequest.create = function create(properties) {
                        return new RemoveCompanyContactListMembersRequest(properties);
                    };
    
                    /**
                     * Encodes the specified RemoveCompanyContactListMembersRequest message. Does not implicitly {@link palexy.task_management.v1.RemoveCompanyContactListMembersRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest} message RemoveCompanyContactListMembersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveCompanyContactListMembersRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.companyId != null && Object.hasOwnProperty.call(message, "companyId"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.companyId);
                        if (message.listId != null && Object.hasOwnProperty.call(message, "listId"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.listId);
                        if (message.contactIds != null && message.contactIds.length) {
                            writer.uint32(/* id 3, wireType 2 =*/26).fork();
                            for (var i = 0; i < message.contactIds.length; ++i)
                                writer.int64(message.contactIds[i]);
                            writer.ldelim();
                        }
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RemoveCompanyContactListMembersRequest message, length delimited. Does not implicitly {@link palexy.task_management.v1.RemoveCompanyContactListMembersRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.IRemoveCompanyContactListMembersRequest} message RemoveCompanyContactListMembersRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RemoveCompanyContactListMembersRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RemoveCompanyContactListMembersRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.RemoveCompanyContactListMembersRequest} RemoveCompanyContactListMembersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveCompanyContactListMembersRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.RemoveCompanyContactListMembersRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.companyId = reader.int64();
                                break;
                            case 2:
                                message.listId = reader.int64();
                                break;
                            case 3:
                                if (!(message.contactIds && message.contactIds.length))
                                    message.contactIds = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.contactIds.push(reader.int64());
                                } else
                                    message.contactIds.push(reader.int64());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RemoveCompanyContactListMembersRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.RemoveCompanyContactListMembersRequest} RemoveCompanyContactListMembersRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RemoveCompanyContactListMembersRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RemoveCompanyContactListMembersRequest message.
                     * @function verify
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RemoveCompanyContactListMembersRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (!$util.isInteger(message.companyId) && !(message.companyId && $util.isInteger(message.companyId.low) && $util.isInteger(message.companyId.high)))
                                return "companyId: integer|Long expected";
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (!$util.isInteger(message.listId) && !(message.listId && $util.isInteger(message.listId.low) && $util.isInteger(message.listId.high)))
                                return "listId: integer|Long expected";
                        if (message.contactIds != null && message.hasOwnProperty("contactIds")) {
                            if (!Array.isArray(message.contactIds))
                                return "contactIds: array expected";
                            for (var i = 0; i < message.contactIds.length; ++i)
                                if (!$util.isInteger(message.contactIds[i]) && !(message.contactIds[i] && $util.isInteger(message.contactIds[i].low) && $util.isInteger(message.contactIds[i].high)))
                                    return "contactIds: integer|Long[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a RemoveCompanyContactListMembersRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.RemoveCompanyContactListMembersRequest} RemoveCompanyContactListMembersRequest
                     */
                    RemoveCompanyContactListMembersRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.RemoveCompanyContactListMembersRequest)
                            return object;
                        var message = new $root.palexy.task_management.v1.RemoveCompanyContactListMembersRequest();
                        if (object.companyId != null)
                            if ($util.Long)
                                (message.companyId = $util.Long.fromValue(object.companyId)).unsigned = false;
                            else if (typeof object.companyId === "string")
                                message.companyId = parseInt(object.companyId, 10);
                            else if (typeof object.companyId === "number")
                                message.companyId = object.companyId;
                            else if (typeof object.companyId === "object")
                                message.companyId = new $util.LongBits(object.companyId.low >>> 0, object.companyId.high >>> 0).toNumber();
                        if (object.listId != null)
                            if ($util.Long)
                                (message.listId = $util.Long.fromValue(object.listId)).unsigned = false;
                            else if (typeof object.listId === "string")
                                message.listId = parseInt(object.listId, 10);
                            else if (typeof object.listId === "number")
                                message.listId = object.listId;
                            else if (typeof object.listId === "object")
                                message.listId = new $util.LongBits(object.listId.low >>> 0, object.listId.high >>> 0).toNumber();
                        if (object.contactIds) {
                            if (!Array.isArray(object.contactIds))
                                throw TypeError(".palexy.task_management.v1.RemoveCompanyContactListMembersRequest.contactIds: array expected");
                            message.contactIds = [];
                            for (var i = 0; i < object.contactIds.length; ++i)
                                if ($util.Long)
                                    (message.contactIds[i] = $util.Long.fromValue(object.contactIds[i])).unsigned = false;
                                else if (typeof object.contactIds[i] === "string")
                                    message.contactIds[i] = parseInt(object.contactIds[i], 10);
                                else if (typeof object.contactIds[i] === "number")
                                    message.contactIds[i] = object.contactIds[i];
                                else if (typeof object.contactIds[i] === "object")
                                    message.contactIds[i] = new $util.LongBits(object.contactIds[i].low >>> 0, object.contactIds[i].high >>> 0).toNumber();
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RemoveCompanyContactListMembersRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @static
                     * @param {palexy.task_management.v1.RemoveCompanyContactListMembersRequest} message RemoveCompanyContactListMembersRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RemoveCompanyContactListMembersRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.contactIds = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.companyId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.companyId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.listId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.listId = options.longs === String ? "0" : 0;
                        }
                        if (message.companyId != null && message.hasOwnProperty("companyId"))
                            if (typeof message.companyId === "number")
                                object.companyId = options.longs === String ? String(message.companyId) : message.companyId;
                            else
                                object.companyId = options.longs === String ? $util.Long.prototype.toString.call(message.companyId) : options.longs === Number ? new $util.LongBits(message.companyId.low >>> 0, message.companyId.high >>> 0).toNumber() : message.companyId;
                        if (message.listId != null && message.hasOwnProperty("listId"))
                            if (typeof message.listId === "number")
                                object.listId = options.longs === String ? String(message.listId) : message.listId;
                            else
                                object.listId = options.longs === String ? $util.Long.prototype.toString.call(message.listId) : options.longs === Number ? new $util.LongBits(message.listId.low >>> 0, message.listId.high >>> 0).toNumber() : message.listId;
                        if (message.contactIds && message.contactIds.length) {
                            object.contactIds = [];
                            for (var j = 0; j < message.contactIds.length; ++j)
                                if (typeof message.contactIds[j] === "number")
                                    object.contactIds[j] = options.longs === String ? String(message.contactIds[j]) : message.contactIds[j];
                                else
                                    object.contactIds[j] = options.longs === String ? $util.Long.prototype.toString.call(message.contactIds[j]) : options.longs === Number ? new $util.LongBits(message.contactIds[j].low >>> 0, message.contactIds[j].high >>> 0).toNumber() : message.contactIds[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this RemoveCompanyContactListMembersRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.RemoveCompanyContactListMembersRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RemoveCompanyContactListMembersRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return RemoveCompanyContactListMembersRequest;
                })();
    
                v1.ChangeCompanyContactListMembersResponse = (function() {
    
                    /**
                     * Properties of a ChangeCompanyContactListMembersResponse.
                     * @memberof palexy.task_management.v1
                     * @interface IChangeCompanyContactListMembersResponse
                     * @property {number|null} [changedCount] ChangeCompanyContactListMembersResponse changedCount
                     * @property {number|null} [skippedCount] ChangeCompanyContactListMembersResponse skippedCount
                     */
    
                    /**
                     * Constructs a new ChangeCompanyContactListMembersResponse.
                     * @memberof palexy.task_management.v1
                     * @classdesc Represents a ChangeCompanyContactListMembersResponse.
                     * @implements IChangeCompanyContactListMembersResponse
                     * @constructor
                     * @param {palexy.task_management.v1.IChangeCompanyContactListMembersResponse=} [properties] Properties to set
                     */
                    function ChangeCompanyContactListMembersResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ChangeCompanyContactListMembersResponse changedCount.
                     * @member {number} changedCount
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @instance
                     */
                    ChangeCompanyContactListMembersResponse.prototype.changedCount = 0;
    
                    /**
                     * ChangeCompanyContactListMembersResponse skippedCount.
                     * @member {number} skippedCount
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @instance
                     */
                    ChangeCompanyContactListMembersResponse.prototype.skippedCount = 0;
    
                    /**
                     * Creates a new ChangeCompanyContactListMembersResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {palexy.task_management.v1.IChangeCompanyContactListMembersResponse=} [properties] Properties to set
                     * @returns {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} ChangeCompanyContactListMembersResponse instance
                     */
                    ChangeCompanyContactListMembersResponse.create = function create(properties) {
                        return new ChangeCompanyContactListMembersResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ChangeCompanyContactListMembersResponse message. Does not implicitly {@link palexy.task_management.v1.ChangeCompanyContactListMembersResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {palexy.task_management.v1.IChangeCompanyContactListMembersResponse} message ChangeCompanyContactListMembersResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChangeCompanyContactListMembersResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.changedCount != null && Object.hasOwnProperty.call(message, "changedCount"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.changedCount);
                        if (message.skippedCount != null && Object.hasOwnProperty.call(message, "skippedCount"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.skippedCount);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ChangeCompanyContactListMembersResponse message, length delimited. Does not implicitly {@link palexy.task_management.v1.ChangeCompanyContactListMembersResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {palexy.task_management.v1.IChangeCompanyContactListMembersResponse} message ChangeCompanyContactListMembersResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ChangeCompanyContactListMembersResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ChangeCompanyContactListMembersResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} ChangeCompanyContactListMembersResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChangeCompanyContactListMembersResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.task_management.v1.ChangeCompanyContactListMembersResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.changedCount = reader.int32();
                                break;
                            case 2:
                                message.skippedCount = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ChangeCompanyContactListMembersResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} ChangeCompanyContactListMembersResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ChangeCompanyContactListMembersResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ChangeCompanyContactListMembersResponse message.
                     * @function verify
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ChangeCompanyContactListMembersResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.changedCount != null && message.hasOwnProperty("changedCount"))
                            if (!$util.isInteger(message.changedCount))
                                return "changedCount: integer expected";
                        if (message.skippedCount != null && message.hasOwnProperty("skippedCount"))
                            if (!$util.isInteger(message.skippedCount))
                                return "skippedCount: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ChangeCompanyContactListMembersResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} ChangeCompanyContactListMembersResponse
                     */
                    ChangeCompanyContactListMembersResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.task_management.v1.ChangeCompanyContactListMembersResponse)
                            return object;
                        var message = new $root.palexy.task_management.v1.ChangeCompanyContactListMembersResponse();
                        if (object.changedCount != null)
                            message.changedCount = object.changedCount | 0;
                        if (object.skippedCount != null)
                            message.skippedCount = object.skippedCount | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ChangeCompanyContactListMembersResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @static
                     * @param {palexy.task_management.v1.ChangeCompanyContactListMembersResponse} message ChangeCompanyContactListMembersResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ChangeCompanyContactListMembersResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.changedCount = 0;
                            object.skippedCount = 0;
                        }
                        if (message.changedCount != null && message.hasOwnProperty("changedCount"))
                            object.changedCount = message.changedCount;
                        if (message.skippedCount != null && message.hasOwnProperty("skippedCount"))
                            object.skippedCount = message.skippedCount;
                        return object;
                    };
    
                    /**
                     * Converts this ChangeCompanyContactListMembersResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.task_management.v1.ChangeCompanyContactListMembersResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ChangeCompanyContactListMembersResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ChangeCompanyContactListMembersResponse;
                })();
    
                return v1;
            })();
    
            return task_management;
        })();
    
        palexy.dvr = (function() {
    
            /**
             * Namespace dvr.
             * @memberof palexy
             * @namespace
             */
            var dvr = {};
    
            dvr.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.dvr
                 * @namespace
                 */
                var v1 = {};
    
                v1.DVRService = (function() {
    
                    /**
                     * Constructs a new DVRService service.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DVRService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function DVRService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (DVRService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DVRService;
    
                    /**
                     * Creates new DVRService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.dvr.v1.DVRService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {DVRService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    DVRService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#listDVR}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef ListDVRCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.ListDVRResponse} [response] ListDVRResponse
                     */
    
                    /**
                     * Calls ListDVR.
                     * @function listDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IListDVRRequest} request ListDVRRequest message or plain object
                     * @param {palexy.dvr.v1.DVRService.ListDVRCallback} callback Node-style callback called with the error, if any, and ListDVRResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.listDVR = function listDVR(request, callback) {
                        return this.rpcCall(listDVR, $root.palexy.dvr.v1.ListDVRRequest, $root.palexy.dvr.v1.ListDVRResponse, request, callback);
                    }, "name", { value: "ListDVR" });
    
                    /**
                     * Calls ListDVR.
                     * @function listDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IListDVRRequest} request ListDVRRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.ListDVRResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#createDVR}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef CreateDVRCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVR} [response] DVR
                     */
    
                    /**
                     * Calls CreateDVR.
                     * @function createDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.ICreateDVRRequest} request CreateDVRRequest message or plain object
                     * @param {palexy.dvr.v1.DVRService.CreateDVRCallback} callback Node-style callback called with the error, if any, and DVR
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.createDVR = function createDVR(request, callback) {
                        return this.rpcCall(createDVR, $root.palexy.dvr.v1.CreateDVRRequest, $root.palexy.dvr.v1.DVR, request, callback);
                    }, "name", { value: "CreateDVR" });
    
                    /**
                     * Calls CreateDVR.
                     * @function createDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.ICreateDVRRequest} request CreateDVRRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVR>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#getSupportedModels}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef GetSupportedModelsCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.GetSupportedModelsResponse} [response] GetSupportedModelsResponse
                     */
    
                    /**
                     * Calls GetSupportedModels.
                     * @function getSupportedModels
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @param {palexy.dvr.v1.DVRService.GetSupportedModelsCallback} callback Node-style callback called with the error, if any, and GetSupportedModelsResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.getSupportedModels = function getSupportedModels(request, callback) {
                        return this.rpcCall(getSupportedModels, $root.google.protobuf.Empty, $root.palexy.dvr.v1.GetSupportedModelsResponse, request, callback);
                    }, "name", { value: "GetSupportedModels" });
    
                    /**
                     * Calls GetSupportedModels.
                     * @function getSupportedModels
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @returns {Promise<palexy.dvr.v1.GetSupportedModelsResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#getDVR}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef GetDVRCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVR} [response] DVR
                     */
    
                    /**
                     * Calls GetDVR.
                     * @function getDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IGetDVRRequest} request GetDVRRequest message or plain object
                     * @param {palexy.dvr.v1.DVRService.GetDVRCallback} callback Node-style callback called with the error, if any, and DVR
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.getDVR = function getDVR(request, callback) {
                        return this.rpcCall(getDVR, $root.palexy.dvr.v1.GetDVRRequest, $root.palexy.dvr.v1.DVR, request, callback);
                    }, "name", { value: "GetDVR" });
    
                    /**
                     * Calls GetDVR.
                     * @function getDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IGetDVRRequest} request GetDVRRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVR>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#updateDVR}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef UpdateDVRCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVR} [response] DVR
                     */
    
                    /**
                     * Calls UpdateDVR.
                     * @function updateDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IUpdateDVRRequest} request UpdateDVRRequest message or plain object
                     * @param {palexy.dvr.v1.DVRService.UpdateDVRCallback} callback Node-style callback called with the error, if any, and DVR
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.updateDVR = function updateDVR(request, callback) {
                        return this.rpcCall(updateDVR, $root.palexy.dvr.v1.UpdateDVRRequest, $root.palexy.dvr.v1.DVR, request, callback);
                    }, "name", { value: "UpdateDVR" });
    
                    /**
                     * Calls UpdateDVR.
                     * @function updateDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IUpdateDVRRequest} request UpdateDVRRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVR>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRService#deleteDVR}.
                     * @memberof palexy.dvr.v1.DVRService
                     * @typedef DeleteDVRCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteDVR.
                     * @function deleteDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IDeleteDVRRequest} request DeleteDVRRequest message or plain object
                     * @param {palexy.dvr.v1.DVRService.DeleteDVRCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRService.prototype.deleteDVR = function deleteDVR(request, callback) {
                        return this.rpcCall(deleteDVR, $root.palexy.dvr.v1.DeleteDVRRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteDVR" });
    
                    /**
                     * Calls DeleteDVR.
                     * @function deleteDVR
                     * @memberof palexy.dvr.v1.DVRService
                     * @instance
                     * @param {palexy.dvr.v1.IDeleteDVRRequest} request DeleteDVRRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return DVRService;
                })();
    
                v1.DVRCameraService = (function() {
    
                    /**
                     * Constructs a new DVRCameraService service.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DVRCameraService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function DVRCameraService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (DVRCameraService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = DVRCameraService;
    
                    /**
                     * Creates new DVRCameraService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {DVRCameraService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    DVRCameraService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRCameraService#listDVRCamera}.
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @typedef ListDVRCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.ListDVRCameraResponse} [response] ListDVRCameraResponse
                     */
    
                    /**
                     * Calls ListDVRCamera.
                     * @function listDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IListDVRCameraRequest} request ListDVRCameraRequest message or plain object
                     * @param {palexy.dvr.v1.DVRCameraService.ListDVRCameraCallback} callback Node-style callback called with the error, if any, and ListDVRCameraResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRCameraService.prototype.listDVRCamera = function listDVRCamera(request, callback) {
                        return this.rpcCall(listDVRCamera, $root.palexy.dvr.v1.ListDVRCameraRequest, $root.palexy.dvr.v1.ListDVRCameraResponse, request, callback);
                    }, "name", { value: "ListDVRCamera" });
    
                    /**
                     * Calls ListDVRCamera.
                     * @function listDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IListDVRCameraRequest} request ListDVRCameraRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.ListDVRCameraResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRCameraService#createDVRCamera}.
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @typedef CreateDVRCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVRCamera} [response] DVRCamera
                     */
    
                    /**
                     * Calls CreateDVRCamera.
                     * @function createDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest} request CreateDVRCameraRequest message or plain object
                     * @param {palexy.dvr.v1.DVRCameraService.CreateDVRCameraCallback} callback Node-style callback called with the error, if any, and DVRCamera
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRCameraService.prototype.createDVRCamera = function createDVRCamera(request, callback) {
                        return this.rpcCall(createDVRCamera, $root.palexy.dvr.v1.CreateDVRCameraRequest, $root.palexy.dvr.v1.DVRCamera, request, callback);
                    }, "name", { value: "CreateDVRCamera" });
    
                    /**
                     * Calls CreateDVRCamera.
                     * @function createDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest} request CreateDVRCameraRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVRCamera>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRCameraService#getDVRCamera}.
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @typedef GetDVRCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVRCamera} [response] DVRCamera
                     */
    
                    /**
                     * Calls GetDVRCamera.
                     * @function getDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest} request GetDVRCameraRequest message or plain object
                     * @param {palexy.dvr.v1.DVRCameraService.GetDVRCameraCallback} callback Node-style callback called with the error, if any, and DVRCamera
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRCameraService.prototype.getDVRCamera = function getDVRCamera(request, callback) {
                        return this.rpcCall(getDVRCamera, $root.palexy.dvr.v1.GetDVRCameraRequest, $root.palexy.dvr.v1.DVRCamera, request, callback);
                    }, "name", { value: "GetDVRCamera" });
    
                    /**
                     * Calls GetDVRCamera.
                     * @function getDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest} request GetDVRCameraRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVRCamera>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRCameraService#updateDVRCamera}.
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @typedef UpdateDVRCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.dvr.v1.DVRCamera} [response] DVRCamera
                     */
    
                    /**
                     * Calls UpdateDVRCamera.
                     * @function updateDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest} request UpdateDVRCameraRequest message or plain object
                     * @param {palexy.dvr.v1.DVRCameraService.UpdateDVRCameraCallback} callback Node-style callback called with the error, if any, and DVRCamera
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRCameraService.prototype.updateDVRCamera = function updateDVRCamera(request, callback) {
                        return this.rpcCall(updateDVRCamera, $root.palexy.dvr.v1.UpdateDVRCameraRequest, $root.palexy.dvr.v1.DVRCamera, request, callback);
                    }, "name", { value: "UpdateDVRCamera" });
    
                    /**
                     * Calls UpdateDVRCamera.
                     * @function updateDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest} request UpdateDVRCameraRequest message or plain object
                     * @returns {Promise<palexy.dvr.v1.DVRCamera>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.dvr.v1.DVRCameraService#deleteDVRCamera}.
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @typedef DeleteDVRCameraCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls DeleteDVRCamera.
                     * @function deleteDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest} request DeleteDVRCameraRequest message or plain object
                     * @param {palexy.dvr.v1.DVRCameraService.DeleteDVRCameraCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(DVRCameraService.prototype.deleteDVRCamera = function deleteDVRCamera(request, callback) {
                        return this.rpcCall(deleteDVRCamera, $root.palexy.dvr.v1.DeleteDVRCameraRequest, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "DeleteDVRCamera" });
    
                    /**
                     * Calls DeleteDVRCamera.
                     * @function deleteDVRCamera
                     * @memberof palexy.dvr.v1.DVRCameraService
                     * @instance
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest} request DeleteDVRCameraRequest message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return DVRCameraService;
                })();
    
                v1.DVR = (function() {
    
                    /**
                     * Properties of a DVR.
                     * @memberof palexy.dvr.v1
                     * @interface IDVR
                     * @property {number|null} [id] DVR id
                     * @property {string|null} [name] DVR name
                     * @property {number|null} [storeId] DVR storeId
                     * @property {Array.<palexy.dvr.v1.IDVRCamera>|null} [dvrCameras] DVR dvrCameras
                     * @property {string|null} [model] DVR model
                     * @property {boolean|null} [isTimeSynchronized] DVR isTimeSynchronized
                     * @property {boolean|null} [isMotionStoringDisabled] DVR isMotionStoringDisabled
                     * @property {string|null} [userName] DVR userName
                     * @property {string|null} [password] DVR password
                     * @property {string|null} [localIp] DVR localIp
                     * @property {google.protobuf.ITimestamp|null} [authenticationLastUpdated] DVR authenticationLastUpdated
                     * @property {string|null} [authenticationInstructionMarkdown] DVR authenticationInstructionMarkdown
                     * @property {string|null} [expectedFileNamePattern] DVR expectedFileNamePattern
                     * @property {palexy.dvr.v1.IRecorderIntegration|null} [recorderIntegration] DVR recorderIntegration
                     */
    
                    /**
                     * Constructs a new DVR.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DVR.
                     * @implements IDVR
                     * @constructor
                     * @param {palexy.dvr.v1.IDVR=} [properties] Properties to set
                     */
                    function DVR(properties) {
                        this.dvrCameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DVR id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DVR name.
                     * @member {string} name
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.name = "";
    
                    /**
                     * DVR storeId.
                     * @member {number} storeId
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DVR dvrCameras.
                     * @member {Array.<palexy.dvr.v1.IDVRCamera>} dvrCameras
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.dvrCameras = $util.emptyArray;
    
                    /**
                     * DVR model.
                     * @member {string} model
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.model = "";
    
                    /**
                     * DVR isTimeSynchronized.
                     * @member {boolean} isTimeSynchronized
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.isTimeSynchronized = false;
    
                    /**
                     * DVR isMotionStoringDisabled.
                     * @member {boolean} isMotionStoringDisabled
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.isMotionStoringDisabled = false;
    
                    /**
                     * DVR userName.
                     * @member {string} userName
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.userName = "";
    
                    /**
                     * DVR password.
                     * @member {string} password
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.password = "";
    
                    /**
                     * DVR localIp.
                     * @member {string} localIp
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.localIp = "";
    
                    /**
                     * DVR authenticationLastUpdated.
                     * @member {google.protobuf.ITimestamp|null|undefined} authenticationLastUpdated
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.authenticationLastUpdated = null;
    
                    /**
                     * DVR authenticationInstructionMarkdown.
                     * @member {string} authenticationInstructionMarkdown
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.authenticationInstructionMarkdown = "";
    
                    /**
                     * DVR expectedFileNamePattern.
                     * @member {string} expectedFileNamePattern
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.expectedFileNamePattern = "";
    
                    /**
                     * DVR recorderIntegration.
                     * @member {palexy.dvr.v1.IRecorderIntegration|null|undefined} recorderIntegration
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     */
                    DVR.prototype.recorderIntegration = null;
    
                    /**
                     * Creates a new DVR instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {palexy.dvr.v1.IDVR=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.DVR} DVR instance
                     */
                    DVR.create = function create(properties) {
                        return new DVR(properties);
                    };
    
                    /**
                     * Encodes the specified DVR message. Does not implicitly {@link palexy.dvr.v1.DVR.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {palexy.dvr.v1.IDVR} message DVR message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DVR.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.name);
                        if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.storeId);
                        if (message.dvrCameras != null && message.dvrCameras.length)
                            for (var i = 0; i < message.dvrCameras.length; ++i)
                                $root.palexy.dvr.v1.DVRCamera.encode(message.dvrCameras[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                        if (message.model != null && Object.hasOwnProperty.call(message, "model"))
                            writer.uint32(/* id 5, wireType 2 =*/42).string(message.model);
                        if (message.isTimeSynchronized != null && Object.hasOwnProperty.call(message, "isTimeSynchronized"))
                            writer.uint32(/* id 6, wireType 0 =*/48).bool(message.isTimeSynchronized);
                        if (message.isMotionStoringDisabled != null && Object.hasOwnProperty.call(message, "isMotionStoringDisabled"))
                            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.isMotionStoringDisabled);
                        if (message.userName != null && Object.hasOwnProperty.call(message, "userName"))
                            writer.uint32(/* id 8, wireType 2 =*/66).string(message.userName);
                        if (message.password != null && Object.hasOwnProperty.call(message, "password"))
                            writer.uint32(/* id 9, wireType 2 =*/74).string(message.password);
                        if (message.authenticationLastUpdated != null && Object.hasOwnProperty.call(message, "authenticationLastUpdated"))
                            $root.google.protobuf.Timestamp.encode(message.authenticationLastUpdated, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
                        if (message.authenticationInstructionMarkdown != null && Object.hasOwnProperty.call(message, "authenticationInstructionMarkdown"))
                            writer.uint32(/* id 11, wireType 2 =*/90).string(message.authenticationInstructionMarkdown);
                        if (message.expectedFileNamePattern != null && Object.hasOwnProperty.call(message, "expectedFileNamePattern"))
                            writer.uint32(/* id 12, wireType 2 =*/98).string(message.expectedFileNamePattern);
                        if (message.recorderIntegration != null && Object.hasOwnProperty.call(message, "recorderIntegration"))
                            $root.palexy.dvr.v1.RecorderIntegration.encode(message.recorderIntegration, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
                        if (message.localIp != null && Object.hasOwnProperty.call(message, "localIp"))
                            writer.uint32(/* id 14, wireType 2 =*/114).string(message.localIp);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DVR message, length delimited. Does not implicitly {@link palexy.dvr.v1.DVR.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {palexy.dvr.v1.IDVR} message DVR message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DVR.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DVR message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.DVR} DVR
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DVR.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.DVR();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.name = reader.string();
                                break;
                            case 3:
                                message.storeId = reader.int64();
                                break;
                            case 4:
                                if (!(message.dvrCameras && message.dvrCameras.length))
                                    message.dvrCameras = [];
                                message.dvrCameras.push($root.palexy.dvr.v1.DVRCamera.decode(reader, reader.uint32()));
                                break;
                            case 5:
                                message.model = reader.string();
                                break;
                            case 6:
                                message.isTimeSynchronized = reader.bool();
                                break;
                            case 7:
                                message.isMotionStoringDisabled = reader.bool();
                                break;
                            case 8:
                                message.userName = reader.string();
                                break;
                            case 9:
                                message.password = reader.string();
                                break;
                            case 14:
                                message.localIp = reader.string();
                                break;
                            case 10:
                                message.authenticationLastUpdated = $root.google.protobuf.Timestamp.decode(reader, reader.uint32());
                                break;
                            case 11:
                                message.authenticationInstructionMarkdown = reader.string();
                                break;
                            case 12:
                                message.expectedFileNamePattern = reader.string();
                                break;
                            case 13:
                                message.recorderIntegration = $root.palexy.dvr.v1.RecorderIntegration.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DVR message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.DVR} DVR
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DVR.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DVR message.
                     * @function verify
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DVR.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.name != null && message.hasOwnProperty("name"))
                            if (!$util.isString(message.name))
                                return "name: string expected";
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                return "storeId: integer|Long expected";
                        if (message.dvrCameras != null && message.hasOwnProperty("dvrCameras")) {
                            if (!Array.isArray(message.dvrCameras))
                                return "dvrCameras: array expected";
                            for (var i = 0; i < message.dvrCameras.length; ++i) {
                                var error = $root.palexy.dvr.v1.DVRCamera.verify(message.dvrCameras[i]);
                                if (error)
                                    return "dvrCameras." + error;
                            }
                        }
                        if (message.model != null && message.hasOwnProperty("model"))
                            if (!$util.isString(message.model))
                                return "model: string expected";
                        if (message.isTimeSynchronized != null && message.hasOwnProperty("isTimeSynchronized"))
                            if (typeof message.isTimeSynchronized !== "boolean")
                                return "isTimeSynchronized: boolean expected";
                        if (message.isMotionStoringDisabled != null && message.hasOwnProperty("isMotionStoringDisabled"))
                            if (typeof message.isMotionStoringDisabled !== "boolean")
                                return "isMotionStoringDisabled: boolean expected";
                        if (message.userName != null && message.hasOwnProperty("userName"))
                            if (!$util.isString(message.userName))
                                return "userName: string expected";
                        if (message.password != null && message.hasOwnProperty("password"))
                            if (!$util.isString(message.password))
                                return "password: string expected";
                        if (message.localIp != null && message.hasOwnProperty("localIp"))
                            if (!$util.isString(message.localIp))
                                return "localIp: string expected";
                        if (message.authenticationLastUpdated != null && message.hasOwnProperty("authenticationLastUpdated")) {
                            var error = $root.google.protobuf.Timestamp.verify(message.authenticationLastUpdated);
                            if (error)
                                return "authenticationLastUpdated." + error;
                        }
                        if (message.authenticationInstructionMarkdown != null && message.hasOwnProperty("authenticationInstructionMarkdown"))
                            if (!$util.isString(message.authenticationInstructionMarkdown))
                                return "authenticationInstructionMarkdown: string expected";
                        if (message.expectedFileNamePattern != null && message.hasOwnProperty("expectedFileNamePattern"))
                            if (!$util.isString(message.expectedFileNamePattern))
                                return "expectedFileNamePattern: string expected";
                        if (message.recorderIntegration != null && message.hasOwnProperty("recorderIntegration")) {
                            var error = $root.palexy.dvr.v1.RecorderIntegration.verify(message.recorderIntegration);
                            if (error)
                                return "recorderIntegration." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a DVR message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.DVR} DVR
                     */
                    DVR.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.DVR)
                            return object;
                        var message = new $root.palexy.dvr.v1.DVR();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.name != null)
                            message.name = String(object.name);
                        if (object.storeId != null)
                            if ($util.Long)
                                (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                            else if (typeof object.storeId === "string")
                                message.storeId = parseInt(object.storeId, 10);
                            else if (typeof object.storeId === "number")
                                message.storeId = object.storeId;
                            else if (typeof object.storeId === "object")
                                message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                        if (object.dvrCameras) {
                            if (!Array.isArray(object.dvrCameras))
                                throw TypeError(".palexy.dvr.v1.DVR.dvrCameras: array expected");
                            message.dvrCameras = [];
                            for (var i = 0; i < object.dvrCameras.length; ++i) {
                                if (typeof object.dvrCameras[i] !== "object")
                                    throw TypeError(".palexy.dvr.v1.DVR.dvrCameras: object expected");
                                message.dvrCameras[i] = $root.palexy.dvr.v1.DVRCamera.fromObject(object.dvrCameras[i]);
                            }
                        }
                        if (object.model != null)
                            message.model = String(object.model);
                        if (object.isTimeSynchronized != null)
                            message.isTimeSynchronized = Boolean(object.isTimeSynchronized);
                        if (object.isMotionStoringDisabled != null)
                            message.isMotionStoringDisabled = Boolean(object.isMotionStoringDisabled);
                        if (object.userName != null)
                            message.userName = String(object.userName);
                        if (object.password != null)
                            message.password = String(object.password);
                        if (object.localIp != null)
                            message.localIp = String(object.localIp);
                        if (object.authenticationLastUpdated != null) {
                            if (typeof object.authenticationLastUpdated !== "object")
                                throw TypeError(".palexy.dvr.v1.DVR.authenticationLastUpdated: object expected");
                            message.authenticationLastUpdated = $root.google.protobuf.Timestamp.fromObject(object.authenticationLastUpdated);
                        }
                        if (object.authenticationInstructionMarkdown != null)
                            message.authenticationInstructionMarkdown = String(object.authenticationInstructionMarkdown);
                        if (object.expectedFileNamePattern != null)
                            message.expectedFileNamePattern = String(object.expectedFileNamePattern);
                        if (object.recorderIntegration != null) {
                            if (typeof object.recorderIntegration !== "object")
                                throw TypeError(".palexy.dvr.v1.DVR.recorderIntegration: object expected");
                            message.recorderIntegration = $root.palexy.dvr.v1.RecorderIntegration.fromObject(object.recorderIntegration);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DVR message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.DVR
                     * @static
                     * @param {palexy.dvr.v1.DVR} message DVR
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DVR.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dvrCameras = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.name = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.storeId = options.longs === String ? "0" : 0;
                            object.model = "";
                            object.isTimeSynchronized = false;
                            object.isMotionStoringDisabled = false;
                            object.userName = "";
                            object.password = "";
                            object.authenticationLastUpdated = null;
                            object.authenticationInstructionMarkdown = "";
                            object.expectedFileNamePattern = "";
                            object.recorderIntegration = null;
                            object.localIp = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.name != null && message.hasOwnProperty("name"))
                            object.name = message.name;
                        if (message.storeId != null && message.hasOwnProperty("storeId"))
                            if (typeof message.storeId === "number")
                                object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                            else
                                object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                        if (message.dvrCameras && message.dvrCameras.length) {
                            object.dvrCameras = [];
                            for (var j = 0; j < message.dvrCameras.length; ++j)
                                object.dvrCameras[j] = $root.palexy.dvr.v1.DVRCamera.toObject(message.dvrCameras[j], options);
                        }
                        if (message.model != null && message.hasOwnProperty("model"))
                            object.model = message.model;
                        if (message.isTimeSynchronized != null && message.hasOwnProperty("isTimeSynchronized"))
                            object.isTimeSynchronized = message.isTimeSynchronized;
                        if (message.isMotionStoringDisabled != null && message.hasOwnProperty("isMotionStoringDisabled"))
                            object.isMotionStoringDisabled = message.isMotionStoringDisabled;
                        if (message.userName != null && message.hasOwnProperty("userName"))
                            object.userName = message.userName;
                        if (message.password != null && message.hasOwnProperty("password"))
                            object.password = message.password;
                        if (message.authenticationLastUpdated != null && message.hasOwnProperty("authenticationLastUpdated"))
                            object.authenticationLastUpdated = $root.google.protobuf.Timestamp.toObject(message.authenticationLastUpdated, options);
                        if (message.authenticationInstructionMarkdown != null && message.hasOwnProperty("authenticationInstructionMarkdown"))
                            object.authenticationInstructionMarkdown = message.authenticationInstructionMarkdown;
                        if (message.expectedFileNamePattern != null && message.hasOwnProperty("expectedFileNamePattern"))
                            object.expectedFileNamePattern = message.expectedFileNamePattern;
                        if (message.recorderIntegration != null && message.hasOwnProperty("recorderIntegration"))
                            object.recorderIntegration = $root.palexy.dvr.v1.RecorderIntegration.toObject(message.recorderIntegration, options);
                        if (message.localIp != null && message.hasOwnProperty("localIp"))
                            object.localIp = message.localIp;
                        return object;
                    };
    
                    /**
                     * Converts this DVR to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.DVR
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DVR.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * Manufacturer enum.
                     * @name palexy.dvr.v1.DVR.Manufacturer
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} DAHUA=1 DAHUA value
                     * @property {number} HIKVISION=2 HIKVISION value
                     * @property {number} KBVISION=3 KBVISION value
                     * @property {number} VNG_CLOUD_CAM=4 VNG_CLOUD_CAM value
                     * @property {number} SAFIE=5 SAFIE value
                     */
                    DVR.Manufacturer = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "DAHUA"] = 1;
                        values[valuesById[2] = "HIKVISION"] = 2;
                        values[valuesById[3] = "KBVISION"] = 3;
                        values[valuesById[4] = "VNG_CLOUD_CAM"] = 4;
                        values[valuesById[5] = "SAFIE"] = 5;
                        return values;
                    })();
    
                    return DVR;
                })();
    
                v1.RecorderIntegration = (function() {
    
                    /**
                     * Properties of a RecorderIntegration.
                     * @memberof palexy.dvr.v1
                     * @interface IRecorderIntegration
                     * @property {string|null} [ipAddress] RecorderIntegration ipAddress
                     * @property {number|null} [port] RecorderIntegration port
                     * @property {palexy.dvr.v1.RecorderIntegration.IntegrationType|null} [integrationType] RecorderIntegration integrationType
                     * @property {string|null} [apiKey] RecorderIntegration apiKey
                     */
    
                    /**
                     * Constructs a new RecorderIntegration.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a RecorderIntegration.
                     * @implements IRecorderIntegration
                     * @constructor
                     * @param {palexy.dvr.v1.IRecorderIntegration=} [properties] Properties to set
                     */
                    function RecorderIntegration(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * RecorderIntegration ipAddress.
                     * @member {string} ipAddress
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @instance
                     */
                    RecorderIntegration.prototype.ipAddress = "";
    
                    /**
                     * RecorderIntegration port.
                     * @member {number} port
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @instance
                     */
                    RecorderIntegration.prototype.port = 0;
    
                    /**
                     * RecorderIntegration integrationType.
                     * @member {palexy.dvr.v1.RecorderIntegration.IntegrationType} integrationType
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @instance
                     */
                    RecorderIntegration.prototype.integrationType = 0;
    
                    /**
                     * RecorderIntegration apiKey.
                     * @member {string} apiKey
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @instance
                     */
                    RecorderIntegration.prototype.apiKey = "";
    
                    /**
                     * Creates a new RecorderIntegration instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {palexy.dvr.v1.IRecorderIntegration=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.RecorderIntegration} RecorderIntegration instance
                     */
                    RecorderIntegration.create = function create(properties) {
                        return new RecorderIntegration(properties);
                    };
    
                    /**
                     * Encodes the specified RecorderIntegration message. Does not implicitly {@link palexy.dvr.v1.RecorderIntegration.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {palexy.dvr.v1.IRecorderIntegration} message RecorderIntegration message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RecorderIntegration.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.ipAddress != null && Object.hasOwnProperty.call(message, "ipAddress"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ipAddress);
                        if (message.port != null && Object.hasOwnProperty.call(message, "port"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.port);
                        if (message.integrationType != null && Object.hasOwnProperty.call(message, "integrationType"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.integrationType);
                        if (message.apiKey != null && Object.hasOwnProperty.call(message, "apiKey"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.apiKey);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified RecorderIntegration message, length delimited. Does not implicitly {@link palexy.dvr.v1.RecorderIntegration.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {palexy.dvr.v1.IRecorderIntegration} message RecorderIntegration message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    RecorderIntegration.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a RecorderIntegration message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.RecorderIntegration} RecorderIntegration
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RecorderIntegration.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.RecorderIntegration();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.ipAddress = reader.string();
                                break;
                            case 2:
                                message.port = reader.int32();
                                break;
                            case 3:
                                message.integrationType = reader.int32();
                                break;
                            case 4:
                                message.apiKey = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a RecorderIntegration message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.RecorderIntegration} RecorderIntegration
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    RecorderIntegration.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a RecorderIntegration message.
                     * @function verify
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    RecorderIntegration.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                            if (!$util.isString(message.ipAddress))
                                return "ipAddress: string expected";
                        if (message.port != null && message.hasOwnProperty("port"))
                            if (!$util.isInteger(message.port))
                                return "port: integer expected";
                        if (message.integrationType != null && message.hasOwnProperty("integrationType"))
                            switch (message.integrationType) {
                            default:
                                return "integrationType: enum value expected";
                            case 0:
                            case 1:
                            case 2:
                                break;
                            }
                        if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                            if (!$util.isString(message.apiKey))
                                return "apiKey: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a RecorderIntegration message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.RecorderIntegration} RecorderIntegration
                     */
                    RecorderIntegration.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.RecorderIntegration)
                            return object;
                        var message = new $root.palexy.dvr.v1.RecorderIntegration();
                        if (object.ipAddress != null)
                            message.ipAddress = String(object.ipAddress);
                        if (object.port != null)
                            message.port = object.port | 0;
                        switch (object.integrationType) {
                        case "UNKNOWN":
                        case 0:
                            message.integrationType = 0;
                            break;
                        case "SDK":
                        case 1:
                            message.integrationType = 1;
                            break;
                        case "API":
                        case 2:
                            message.integrationType = 2;
                            break;
                        }
                        if (object.apiKey != null)
                            message.apiKey = String(object.apiKey);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a RecorderIntegration message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @static
                     * @param {palexy.dvr.v1.RecorderIntegration} message RecorderIntegration
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    RecorderIntegration.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.ipAddress = "";
                            object.port = 0;
                            object.integrationType = options.enums === String ? "UNKNOWN" : 0;
                            object.apiKey = "";
                        }
                        if (message.ipAddress != null && message.hasOwnProperty("ipAddress"))
                            object.ipAddress = message.ipAddress;
                        if (message.port != null && message.hasOwnProperty("port"))
                            object.port = message.port;
                        if (message.integrationType != null && message.hasOwnProperty("integrationType"))
                            object.integrationType = options.enums === String ? $root.palexy.dvr.v1.RecorderIntegration.IntegrationType[message.integrationType] : message.integrationType;
                        if (message.apiKey != null && message.hasOwnProperty("apiKey"))
                            object.apiKey = message.apiKey;
                        return object;
                    };
    
                    /**
                     * Converts this RecorderIntegration to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.RecorderIntegration
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    RecorderIntegration.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    /**
                     * IntegrationType enum.
                     * @name palexy.dvr.v1.RecorderIntegration.IntegrationType
                     * @enum {number}
                     * @property {number} UNKNOWN=0 UNKNOWN value
                     * @property {number} SDK=1 SDK value
                     * @property {number} API=2 API value
                     */
                    RecorderIntegration.IntegrationType = (function() {
                        var valuesById = {}, values = Object.create(valuesById);
                        values[valuesById[0] = "UNKNOWN"] = 0;
                        values[valuesById[1] = "SDK"] = 1;
                        values[valuesById[2] = "API"] = 2;
                        return values;
                    })();
    
                    return RecorderIntegration;
                })();
    
                v1.DVRCamera = (function() {
    
                    /**
                     * Properties of a DVRCamera.
                     * @memberof palexy.dvr.v1
                     * @interface IDVRCamera
                     * @property {number|null} [id] DVRCamera id
                     * @property {string|null} [dvrCameraName] DVRCamera dvrCameraName
                     * @property {number|null} [dvrTimeDeltaSec] DVRCamera dvrTimeDeltaSec
                     * @property {number|null} [dvrId] DVRCamera dvrId
                     * @property {number|null} [channel] DVRCamera channel
                     */
    
                    /**
                     * Constructs a new DVRCamera.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DVRCamera.
                     * @implements IDVRCamera
                     * @constructor
                     * @param {palexy.dvr.v1.IDVRCamera=} [properties] Properties to set
                     */
                    function DVRCamera(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DVRCamera id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     */
                    DVRCamera.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DVRCamera dvrCameraName.
                     * @member {string} dvrCameraName
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     */
                    DVRCamera.prototype.dvrCameraName = "";
    
                    /**
                     * DVRCamera dvrTimeDeltaSec.
                     * @member {number} dvrTimeDeltaSec
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     */
                    DVRCamera.prototype.dvrTimeDeltaSec = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DVRCamera dvrId.
                     * @member {number} dvrId
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     */
                    DVRCamera.prototype.dvrId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * DVRCamera channel.
                     * @member {number} channel
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     */
                    DVRCamera.prototype.channel = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DVRCamera instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {palexy.dvr.v1.IDVRCamera=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.DVRCamera} DVRCamera instance
                     */
                    DVRCamera.create = function create(properties) {
                        return new DVRCamera(properties);
                    };
    
                    /**
                     * Encodes the specified DVRCamera message. Does not implicitly {@link palexy.dvr.v1.DVRCamera.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {palexy.dvr.v1.IDVRCamera} message DVRCamera message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DVRCamera.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.dvrCameraName != null && Object.hasOwnProperty.call(message, "dvrCameraName"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.dvrCameraName);
                        if (message.dvrTimeDeltaSec != null && Object.hasOwnProperty.call(message, "dvrTimeDeltaSec"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.dvrTimeDeltaSec);
                        if (message.dvrId != null && Object.hasOwnProperty.call(message, "dvrId"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.dvrId);
                        if (message.channel != null && Object.hasOwnProperty.call(message, "channel"))
                            writer.uint32(/* id 5, wireType 0 =*/40).int64(message.channel);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DVRCamera message, length delimited. Does not implicitly {@link palexy.dvr.v1.DVRCamera.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {palexy.dvr.v1.IDVRCamera} message DVRCamera message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DVRCamera.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DVRCamera message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.DVRCamera} DVRCamera
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DVRCamera.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.DVRCamera();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.dvrCameraName = reader.string();
                                break;
                            case 3:
                                message.dvrTimeDeltaSec = reader.int64();
                                break;
                            case 4:
                                message.dvrId = reader.int64();
                                break;
                            case 5:
                                message.channel = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DVRCamera message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.DVRCamera} DVRCamera
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DVRCamera.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DVRCamera message.
                     * @function verify
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DVRCamera.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.dvrCameraName != null && message.hasOwnProperty("dvrCameraName"))
                            if (!$util.isString(message.dvrCameraName))
                                return "dvrCameraName: string expected";
                        if (message.dvrTimeDeltaSec != null && message.hasOwnProperty("dvrTimeDeltaSec"))
                            if (!$util.isInteger(message.dvrTimeDeltaSec) && !(message.dvrTimeDeltaSec && $util.isInteger(message.dvrTimeDeltaSec.low) && $util.isInteger(message.dvrTimeDeltaSec.high)))
                                return "dvrTimeDeltaSec: integer|Long expected";
                        if (message.dvrId != null && message.hasOwnProperty("dvrId"))
                            if (!$util.isInteger(message.dvrId) && !(message.dvrId && $util.isInteger(message.dvrId.low) && $util.isInteger(message.dvrId.high)))
                                return "dvrId: integer|Long expected";
                        if (message.channel != null && message.hasOwnProperty("channel"))
                            if (!$util.isInteger(message.channel) && !(message.channel && $util.isInteger(message.channel.low) && $util.isInteger(message.channel.high)))
                                return "channel: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DVRCamera message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.DVRCamera} DVRCamera
                     */
                    DVRCamera.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.DVRCamera)
                            return object;
                        var message = new $root.palexy.dvr.v1.DVRCamera();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.dvrCameraName != null)
                            message.dvrCameraName = String(object.dvrCameraName);
                        if (object.dvrTimeDeltaSec != null)
                            if ($util.Long)
                                (message.dvrTimeDeltaSec = $util.Long.fromValue(object.dvrTimeDeltaSec)).unsigned = false;
                            else if (typeof object.dvrTimeDeltaSec === "string")
                                message.dvrTimeDeltaSec = parseInt(object.dvrTimeDeltaSec, 10);
                            else if (typeof object.dvrTimeDeltaSec === "number")
                                message.dvrTimeDeltaSec = object.dvrTimeDeltaSec;
                            else if (typeof object.dvrTimeDeltaSec === "object")
                                message.dvrTimeDeltaSec = new $util.LongBits(object.dvrTimeDeltaSec.low >>> 0, object.dvrTimeDeltaSec.high >>> 0).toNumber();
                        if (object.dvrId != null)
                            if ($util.Long)
                                (message.dvrId = $util.Long.fromValue(object.dvrId)).unsigned = false;
                            else if (typeof object.dvrId === "string")
                                message.dvrId = parseInt(object.dvrId, 10);
                            else if (typeof object.dvrId === "number")
                                message.dvrId = object.dvrId;
                            else if (typeof object.dvrId === "object")
                                message.dvrId = new $util.LongBits(object.dvrId.low >>> 0, object.dvrId.high >>> 0).toNumber();
                        if (object.channel != null)
                            if ($util.Long)
                                (message.channel = $util.Long.fromValue(object.channel)).unsigned = false;
                            else if (typeof object.channel === "string")
                                message.channel = parseInt(object.channel, 10);
                            else if (typeof object.channel === "number")
                                message.channel = object.channel;
                            else if (typeof object.channel === "object")
                                message.channel = new $util.LongBits(object.channel.low >>> 0, object.channel.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DVRCamera message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @static
                     * @param {palexy.dvr.v1.DVRCamera} message DVRCamera
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DVRCamera.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.dvrCameraName = "";
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.dvrTimeDeltaSec = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.dvrTimeDeltaSec = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.dvrId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.dvrId = options.longs === String ? "0" : 0;
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.channel = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.channel = options.longs === String ? "0" : 0;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.dvrCameraName != null && message.hasOwnProperty("dvrCameraName"))
                            object.dvrCameraName = message.dvrCameraName;
                        if (message.dvrTimeDeltaSec != null && message.hasOwnProperty("dvrTimeDeltaSec"))
                            if (typeof message.dvrTimeDeltaSec === "number")
                                object.dvrTimeDeltaSec = options.longs === String ? String(message.dvrTimeDeltaSec) : message.dvrTimeDeltaSec;
                            else
                                object.dvrTimeDeltaSec = options.longs === String ? $util.Long.prototype.toString.call(message.dvrTimeDeltaSec) : options.longs === Number ? new $util.LongBits(message.dvrTimeDeltaSec.low >>> 0, message.dvrTimeDeltaSec.high >>> 0).toNumber() : message.dvrTimeDeltaSec;
                        if (message.dvrId != null && message.hasOwnProperty("dvrId"))
                            if (typeof message.dvrId === "number")
                                object.dvrId = options.longs === String ? String(message.dvrId) : message.dvrId;
                            else
                                object.dvrId = options.longs === String ? $util.Long.prototype.toString.call(message.dvrId) : options.longs === Number ? new $util.LongBits(message.dvrId.low >>> 0, message.dvrId.high >>> 0).toNumber() : message.dvrId;
                        if (message.channel != null && message.hasOwnProperty("channel"))
                            if (typeof message.channel === "number")
                                object.channel = options.longs === String ? String(message.channel) : message.channel;
                            else
                                object.channel = options.longs === String ? $util.Long.prototype.toString.call(message.channel) : options.longs === Number ? new $util.LongBits(message.channel.low >>> 0, message.channel.high >>> 0).toNumber() : message.channel;
                        return object;
                    };
    
                    /**
                     * Converts this DVRCamera to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.DVRCamera
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DVRCamera.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DVRCamera;
                })();
    
                v1.ListDVRRequest = (function() {
    
                    /**
                     * Properties of a ListDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IListDVRRequest
                     * @property {palexy.dvr.v1.ListDVRRequest.IDVRFilter|null} [dvrFilter] ListDVRRequest dvrFilter
                     * @property {boolean|null} [includeDvrCamera] ListDVRRequest includeDvrCamera
                     */
    
                    /**
                     * Constructs a new ListDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a ListDVRRequest.
                     * @implements IListDVRRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IListDVRRequest=} [properties] Properties to set
                     */
                    function ListDVRRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDVRRequest dvrFilter.
                     * @member {palexy.dvr.v1.ListDVRRequest.IDVRFilter|null|undefined} dvrFilter
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @instance
                     */
                    ListDVRRequest.prototype.dvrFilter = null;
    
                    /**
                     * ListDVRRequest includeDvrCamera.
                     * @member {boolean} includeDvrCamera
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @instance
                     */
                    ListDVRRequest.prototype.includeDvrCamera = false;
    
                    /**
                     * Creates a new ListDVRRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.ListDVRRequest} ListDVRRequest instance
                     */
                    ListDVRRequest.create = function create(properties) {
                        return new ListDVRRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListDVRRequest message. Does not implicitly {@link palexy.dvr.v1.ListDVRRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRRequest} message ListDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrFilter != null && Object.hasOwnProperty.call(message, "dvrFilter"))
                            $root.palexy.dvr.v1.ListDVRRequest.DVRFilter.encode(message.dvrFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.includeDvrCamera != null && Object.hasOwnProperty.call(message, "includeDvrCamera"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeDvrCamera);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDVRRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRRequest} message ListDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDVRRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.ListDVRRequest} ListDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvrFilter = $root.palexy.dvr.v1.ListDVRRequest.DVRFilter.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.includeDvrCamera = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDVRRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.ListDVRRequest} ListDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDVRRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDVRRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrFilter != null && message.hasOwnProperty("dvrFilter")) {
                            var error = $root.palexy.dvr.v1.ListDVRRequest.DVRFilter.verify(message.dvrFilter);
                            if (error)
                                return "dvrFilter." + error;
                        }
                        if (message.includeDvrCamera != null && message.hasOwnProperty("includeDvrCamera"))
                            if (typeof message.includeDvrCamera !== "boolean")
                                return "includeDvrCamera: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a ListDVRRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.ListDVRRequest} ListDVRRequest
                     */
                    ListDVRRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.ListDVRRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.ListDVRRequest();
                        if (object.dvrFilter != null) {
                            if (typeof object.dvrFilter !== "object")
                                throw TypeError(".palexy.dvr.v1.ListDVRRequest.dvrFilter: object expected");
                            message.dvrFilter = $root.palexy.dvr.v1.ListDVRRequest.DVRFilter.fromObject(object.dvrFilter);
                        }
                        if (object.includeDvrCamera != null)
                            message.includeDvrCamera = Boolean(object.includeDvrCamera);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDVRRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.ListDVRRequest} message ListDVRRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDVRRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dvrFilter = null;
                            object.includeDvrCamera = false;
                        }
                        if (message.dvrFilter != null && message.hasOwnProperty("dvrFilter"))
                            object.dvrFilter = $root.palexy.dvr.v1.ListDVRRequest.DVRFilter.toObject(message.dvrFilter, options);
                        if (message.includeDvrCamera != null && message.hasOwnProperty("includeDvrCamera"))
                            object.includeDvrCamera = message.includeDvrCamera;
                        return object;
                    };
    
                    /**
                     * Converts this ListDVRRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.ListDVRRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDVRRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListDVRRequest.DVRFilter = (function() {
    
                        /**
                         * Properties of a DVRFilter.
                         * @memberof palexy.dvr.v1.ListDVRRequest
                         * @interface IDVRFilter
                         * @property {number|null} [storeId] DVRFilter storeId
                         */
    
                        /**
                         * Constructs a new DVRFilter.
                         * @memberof palexy.dvr.v1.ListDVRRequest
                         * @classdesc Represents a DVRFilter.
                         * @implements IDVRFilter
                         * @constructor
                         * @param {palexy.dvr.v1.ListDVRRequest.IDVRFilter=} [properties] Properties to set
                         */
                        function DVRFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DVRFilter storeId.
                         * @member {number} storeId
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @instance
                         */
                        DVRFilter.prototype.storeId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new DVRFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRRequest.IDVRFilter=} [properties] Properties to set
                         * @returns {palexy.dvr.v1.ListDVRRequest.DVRFilter} DVRFilter instance
                         */
                        DVRFilter.create = function create(properties) {
                            return new DVRFilter(properties);
                        };
    
                        /**
                         * Encodes the specified DVRFilter message. Does not implicitly {@link palexy.dvr.v1.ListDVRRequest.DVRFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRRequest.IDVRFilter} message DVRFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DVRFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.storeId != null && Object.hasOwnProperty.call(message, "storeId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.storeId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DVRFilter message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRRequest.DVRFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRRequest.IDVRFilter} message DVRFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DVRFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DVRFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.dvr.v1.ListDVRRequest.DVRFilter} DVRFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DVRFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRRequest.DVRFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.storeId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DVRFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.dvr.v1.ListDVRRequest.DVRFilter} DVRFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DVRFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DVRFilter message.
                         * @function verify
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DVRFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (!$util.isInteger(message.storeId) && !(message.storeId && $util.isInteger(message.storeId.low) && $util.isInteger(message.storeId.high)))
                                    return "storeId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates a DVRFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.dvr.v1.ListDVRRequest.DVRFilter} DVRFilter
                         */
                        DVRFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.dvr.v1.ListDVRRequest.DVRFilter)
                                return object;
                            var message = new $root.palexy.dvr.v1.ListDVRRequest.DVRFilter();
                            if (object.storeId != null)
                                if ($util.Long)
                                    (message.storeId = $util.Long.fromValue(object.storeId)).unsigned = false;
                                else if (typeof object.storeId === "string")
                                    message.storeId = parseInt(object.storeId, 10);
                                else if (typeof object.storeId === "number")
                                    message.storeId = object.storeId;
                                else if (typeof object.storeId === "object")
                                    message.storeId = new $util.LongBits(object.storeId.low >>> 0, object.storeId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DVRFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRRequest.DVRFilter} message DVRFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DVRFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.storeId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.storeId = options.longs === String ? "0" : 0;
                            if (message.storeId != null && message.hasOwnProperty("storeId"))
                                if (typeof message.storeId === "number")
                                    object.storeId = options.longs === String ? String(message.storeId) : message.storeId;
                                else
                                    object.storeId = options.longs === String ? $util.Long.prototype.toString.call(message.storeId) : options.longs === Number ? new $util.LongBits(message.storeId.low >>> 0, message.storeId.high >>> 0).toNumber() : message.storeId;
                            return object;
                        };
    
                        /**
                         * Converts this DVRFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.dvr.v1.ListDVRRequest.DVRFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DVRFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DVRFilter;
                    })();
    
                    return ListDVRRequest;
                })();
    
                v1.ListDVRResponse = (function() {
    
                    /**
                     * Properties of a ListDVRResponse.
                     * @memberof palexy.dvr.v1
                     * @interface IListDVRResponse
                     * @property {Array.<palexy.dvr.v1.IDVR>|null} [dvrs] ListDVRResponse dvrs
                     */
    
                    /**
                     * Constructs a new ListDVRResponse.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a ListDVRResponse.
                     * @implements IListDVRResponse
                     * @constructor
                     * @param {palexy.dvr.v1.IListDVRResponse=} [properties] Properties to set
                     */
                    function ListDVRResponse(properties) {
                        this.dvrs = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDVRResponse dvrs.
                     * @member {Array.<palexy.dvr.v1.IDVR>} dvrs
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @instance
                     */
                    ListDVRResponse.prototype.dvrs = $util.emptyArray;
    
                    /**
                     * Creates a new ListDVRResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRResponse=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.ListDVRResponse} ListDVRResponse instance
                     */
                    ListDVRResponse.create = function create(properties) {
                        return new ListDVRResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListDVRResponse message. Does not implicitly {@link palexy.dvr.v1.ListDVRResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRResponse} message ListDVRResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrs != null && message.dvrs.length)
                            for (var i = 0; i < message.dvrs.length; ++i)
                                $root.palexy.dvr.v1.DVR.encode(message.dvrs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDVRResponse message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRResponse} message ListDVRResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDVRResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.ListDVRResponse} ListDVRResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dvrs && message.dvrs.length))
                                    message.dvrs = [];
                                message.dvrs.push($root.palexy.dvr.v1.DVR.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDVRResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.ListDVRResponse} ListDVRResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDVRResponse message.
                     * @function verify
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDVRResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrs != null && message.hasOwnProperty("dvrs")) {
                            if (!Array.isArray(message.dvrs))
                                return "dvrs: array expected";
                            for (var i = 0; i < message.dvrs.length; ++i) {
                                var error = $root.palexy.dvr.v1.DVR.verify(message.dvrs[i]);
                                if (error)
                                    return "dvrs." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListDVRResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.ListDVRResponse} ListDVRResponse
                     */
                    ListDVRResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.ListDVRResponse)
                            return object;
                        var message = new $root.palexy.dvr.v1.ListDVRResponse();
                        if (object.dvrs) {
                            if (!Array.isArray(object.dvrs))
                                throw TypeError(".palexy.dvr.v1.ListDVRResponse.dvrs: array expected");
                            message.dvrs = [];
                            for (var i = 0; i < object.dvrs.length; ++i) {
                                if (typeof object.dvrs[i] !== "object")
                                    throw TypeError(".palexy.dvr.v1.ListDVRResponse.dvrs: object expected");
                                message.dvrs[i] = $root.palexy.dvr.v1.DVR.fromObject(object.dvrs[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDVRResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @static
                     * @param {palexy.dvr.v1.ListDVRResponse} message ListDVRResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDVRResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dvrs = [];
                        if (message.dvrs && message.dvrs.length) {
                            object.dvrs = [];
                            for (var j = 0; j < message.dvrs.length; ++j)
                                object.dvrs[j] = $root.palexy.dvr.v1.DVR.toObject(message.dvrs[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListDVRResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.ListDVRResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDVRResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDVRResponse;
                })();
    
                v1.CreateDVRRequest = (function() {
    
                    /**
                     * Properties of a CreateDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @interface ICreateDVRRequest
                     * @property {palexy.dvr.v1.IDVR|null} [dvr] CreateDVRRequest dvr
                     */
    
                    /**
                     * Constructs a new CreateDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a CreateDVRRequest.
                     * @implements ICreateDVRRequest
                     * @constructor
                     * @param {palexy.dvr.v1.ICreateDVRRequest=} [properties] Properties to set
                     */
                    function CreateDVRRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDVRRequest dvr.
                     * @member {palexy.dvr.v1.IDVR|null|undefined} dvr
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @instance
                     */
                    CreateDVRRequest.prototype.dvr = null;
    
                    /**
                     * Creates a new CreateDVRRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.CreateDVRRequest} CreateDVRRequest instance
                     */
                    CreateDVRRequest.create = function create(properties) {
                        return new CreateDVRRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDVRRequest message. Does not implicitly {@link palexy.dvr.v1.CreateDVRRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRRequest} message CreateDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDVRRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvr != null && Object.hasOwnProperty.call(message, "dvr"))
                            $root.palexy.dvr.v1.DVR.encode(message.dvr, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDVRRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.CreateDVRRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRRequest} message CreateDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDVRRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDVRRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.CreateDVRRequest} CreateDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDVRRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.CreateDVRRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvr = $root.palexy.dvr.v1.DVR.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDVRRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.CreateDVRRequest} CreateDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDVRRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDVRRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDVRRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvr != null && message.hasOwnProperty("dvr")) {
                            var error = $root.palexy.dvr.v1.DVR.verify(message.dvr);
                            if (error)
                                return "dvr." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateDVRRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.CreateDVRRequest} CreateDVRRequest
                     */
                    CreateDVRRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.CreateDVRRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.CreateDVRRequest();
                        if (object.dvr != null) {
                            if (typeof object.dvr !== "object")
                                throw TypeError(".palexy.dvr.v1.CreateDVRRequest.dvr: object expected");
                            message.dvr = $root.palexy.dvr.v1.DVR.fromObject(object.dvr);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDVRRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.CreateDVRRequest} message CreateDVRRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDVRRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dvr = null;
                        if (message.dvr != null && message.hasOwnProperty("dvr"))
                            object.dvr = $root.palexy.dvr.v1.DVR.toObject(message.dvr, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateDVRRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.CreateDVRRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDVRRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDVRRequest;
                })();
    
                v1.GetSupportedModelsResponse = (function() {
    
                    /**
                     * Properties of a GetSupportedModelsResponse.
                     * @memberof palexy.dvr.v1
                     * @interface IGetSupportedModelsResponse
                     * @property {Array.<string>|null} [models] GetSupportedModelsResponse models
                     */
    
                    /**
                     * Constructs a new GetSupportedModelsResponse.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a GetSupportedModelsResponse.
                     * @implements IGetSupportedModelsResponse
                     * @constructor
                     * @param {palexy.dvr.v1.IGetSupportedModelsResponse=} [properties] Properties to set
                     */
                    function GetSupportedModelsResponse(properties) {
                        this.models = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetSupportedModelsResponse models.
                     * @member {Array.<string>} models
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @instance
                     */
                    GetSupportedModelsResponse.prototype.models = $util.emptyArray;
    
                    /**
                     * Creates a new GetSupportedModelsResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {palexy.dvr.v1.IGetSupportedModelsResponse=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.GetSupportedModelsResponse} GetSupportedModelsResponse instance
                     */
                    GetSupportedModelsResponse.create = function create(properties) {
                        return new GetSupportedModelsResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetSupportedModelsResponse message. Does not implicitly {@link palexy.dvr.v1.GetSupportedModelsResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {palexy.dvr.v1.IGetSupportedModelsResponse} message GetSupportedModelsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSupportedModelsResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.models != null && message.models.length)
                            for (var i = 0; i < message.models.length; ++i)
                                writer.uint32(/* id 1, wireType 2 =*/10).string(message.models[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetSupportedModelsResponse message, length delimited. Does not implicitly {@link palexy.dvr.v1.GetSupportedModelsResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {palexy.dvr.v1.IGetSupportedModelsResponse} message GetSupportedModelsResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetSupportedModelsResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetSupportedModelsResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.GetSupportedModelsResponse} GetSupportedModelsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSupportedModelsResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.GetSupportedModelsResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.models && message.models.length))
                                    message.models = [];
                                message.models.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetSupportedModelsResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.GetSupportedModelsResponse} GetSupportedModelsResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetSupportedModelsResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetSupportedModelsResponse message.
                     * @function verify
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetSupportedModelsResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.models != null && message.hasOwnProperty("models")) {
                            if (!Array.isArray(message.models))
                                return "models: array expected";
                            for (var i = 0; i < message.models.length; ++i)
                                if (!$util.isString(message.models[i]))
                                    return "models: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetSupportedModelsResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.GetSupportedModelsResponse} GetSupportedModelsResponse
                     */
                    GetSupportedModelsResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.GetSupportedModelsResponse)
                            return object;
                        var message = new $root.palexy.dvr.v1.GetSupportedModelsResponse();
                        if (object.models) {
                            if (!Array.isArray(object.models))
                                throw TypeError(".palexy.dvr.v1.GetSupportedModelsResponse.models: array expected");
                            message.models = [];
                            for (var i = 0; i < object.models.length; ++i)
                                message.models[i] = String(object.models[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetSupportedModelsResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @static
                     * @param {palexy.dvr.v1.GetSupportedModelsResponse} message GetSupportedModelsResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetSupportedModelsResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.models = [];
                        if (message.models && message.models.length) {
                            object.models = [];
                            for (var j = 0; j < message.models.length; ++j)
                                object.models[j] = message.models[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this GetSupportedModelsResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.GetSupportedModelsResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetSupportedModelsResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetSupportedModelsResponse;
                })();
    
                v1.GetDVRRequest = (function() {
    
                    /**
                     * Properties of a GetDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IGetDVRRequest
                     * @property {number|null} [id] GetDVRRequest id
                     * @property {boolean|null} [includeDvrCamera] GetDVRRequest includeDvrCamera
                     */
    
                    /**
                     * Constructs a new GetDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a GetDVRRequest.
                     * @implements IGetDVRRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IGetDVRRequest=} [properties] Properties to set
                     */
                    function GetDVRRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetDVRRequest id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @instance
                     */
                    GetDVRRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * GetDVRRequest includeDvrCamera.
                     * @member {boolean} includeDvrCamera
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @instance
                     */
                    GetDVRRequest.prototype.includeDvrCamera = false;
    
                    /**
                     * Creates a new GetDVRRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.GetDVRRequest} GetDVRRequest instance
                     */
                    GetDVRRequest.create = function create(properties) {
                        return new GetDVRRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetDVRRequest message. Does not implicitly {@link palexy.dvr.v1.GetDVRRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRRequest} message GetDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetDVRRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.includeDvrCamera != null && Object.hasOwnProperty.call(message, "includeDvrCamera"))
                            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.includeDvrCamera);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetDVRRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.GetDVRRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRRequest} message GetDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetDVRRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetDVRRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.GetDVRRequest} GetDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetDVRRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.GetDVRRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.includeDvrCamera = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetDVRRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.GetDVRRequest} GetDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetDVRRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetDVRRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetDVRRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.includeDvrCamera != null && message.hasOwnProperty("includeDvrCamera"))
                            if (typeof message.includeDvrCamera !== "boolean")
                                return "includeDvrCamera: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetDVRRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.GetDVRRequest} GetDVRRequest
                     */
                    GetDVRRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.GetDVRRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.GetDVRRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.includeDvrCamera != null)
                            message.includeDvrCamera = Boolean(object.includeDvrCamera);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetDVRRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.GetDVRRequest} message GetDVRRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetDVRRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.includeDvrCamera = false;
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.includeDvrCamera != null && message.hasOwnProperty("includeDvrCamera"))
                            object.includeDvrCamera = message.includeDvrCamera;
                        return object;
                    };
    
                    /**
                     * Converts this GetDVRRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.GetDVRRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetDVRRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetDVRRequest;
                })();
    
                v1.UpdateDVRRequest = (function() {
    
                    /**
                     * Properties of an UpdateDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IUpdateDVRRequest
                     * @property {palexy.dvr.v1.IDVR|null} [dvr] UpdateDVRRequest dvr
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateDVRRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents an UpdateDVRRequest.
                     * @implements IUpdateDVRRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IUpdateDVRRequest=} [properties] Properties to set
                     */
                    function UpdateDVRRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateDVRRequest dvr.
                     * @member {palexy.dvr.v1.IDVR|null|undefined} dvr
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @instance
                     */
                    UpdateDVRRequest.prototype.dvr = null;
    
                    /**
                     * UpdateDVRRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @instance
                     */
                    UpdateDVRRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateDVRRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.UpdateDVRRequest} UpdateDVRRequest instance
                     */
                    UpdateDVRRequest.create = function create(properties) {
                        return new UpdateDVRRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateDVRRequest message. Does not implicitly {@link palexy.dvr.v1.UpdateDVRRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRRequest} message UpdateDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateDVRRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvr != null && Object.hasOwnProperty.call(message, "dvr"))
                            $root.palexy.dvr.v1.DVR.encode(message.dvr, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateDVRRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.UpdateDVRRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRRequest} message UpdateDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateDVRRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateDVRRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.UpdateDVRRequest} UpdateDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateDVRRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.UpdateDVRRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvr = $root.palexy.dvr.v1.DVR.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateDVRRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.UpdateDVRRequest} UpdateDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateDVRRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateDVRRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateDVRRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvr != null && message.hasOwnProperty("dvr")) {
                            var error = $root.palexy.dvr.v1.DVR.verify(message.dvr);
                            if (error)
                                return "dvr." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateDVRRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.UpdateDVRRequest} UpdateDVRRequest
                     */
                    UpdateDVRRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.UpdateDVRRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.UpdateDVRRequest();
                        if (object.dvr != null) {
                            if (typeof object.dvr !== "object")
                                throw TypeError(".palexy.dvr.v1.UpdateDVRRequest.dvr: object expected");
                            message.dvr = $root.palexy.dvr.v1.DVR.fromObject(object.dvr);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.dvr.v1.UpdateDVRRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateDVRRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.UpdateDVRRequest} message UpdateDVRRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateDVRRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dvr = null;
                            object.updateMask = null;
                        }
                        if (message.dvr != null && message.hasOwnProperty("dvr"))
                            object.dvr = $root.palexy.dvr.v1.DVR.toObject(message.dvr, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateDVRRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.UpdateDVRRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateDVRRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateDVRRequest;
                })();
    
                v1.DeleteDVRRequest = (function() {
    
                    /**
                     * Properties of a DeleteDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IDeleteDVRRequest
                     * @property {number|null} [id] DeleteDVRRequest id
                     */
    
                    /**
                     * Constructs a new DeleteDVRRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DeleteDVRRequest.
                     * @implements IDeleteDVRRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IDeleteDVRRequest=} [properties] Properties to set
                     */
                    function DeleteDVRRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteDVRRequest id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @instance
                     */
                    DeleteDVRRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteDVRRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.DeleteDVRRequest} DeleteDVRRequest instance
                     */
                    DeleteDVRRequest.create = function create(properties) {
                        return new DeleteDVRRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteDVRRequest message. Does not implicitly {@link palexy.dvr.v1.DeleteDVRRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRRequest} message DeleteDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteDVRRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteDVRRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.DeleteDVRRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRRequest} message DeleteDVRRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteDVRRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteDVRRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.DeleteDVRRequest} DeleteDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteDVRRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.DeleteDVRRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteDVRRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.DeleteDVRRequest} DeleteDVRRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteDVRRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteDVRRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteDVRRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteDVRRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.DeleteDVRRequest} DeleteDVRRequest
                     */
                    DeleteDVRRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.DeleteDVRRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.DeleteDVRRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteDVRRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @static
                     * @param {palexy.dvr.v1.DeleteDVRRequest} message DeleteDVRRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteDVRRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteDVRRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.DeleteDVRRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteDVRRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteDVRRequest;
                })();
    
                v1.ListDVRCameraRequest = (function() {
    
                    /**
                     * Properties of a ListDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IListDVRCameraRequest
                     * @property {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter|null} [dvrCameraFilter] ListDVRCameraRequest dvrCameraFilter
                     */
    
                    /**
                     * Constructs a new ListDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a ListDVRCameraRequest.
                     * @implements IListDVRCameraRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IListDVRCameraRequest=} [properties] Properties to set
                     */
                    function ListDVRCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDVRCameraRequest dvrCameraFilter.
                     * @member {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter|null|undefined} dvrCameraFilter
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @instance
                     */
                    ListDVRCameraRequest.prototype.dvrCameraFilter = null;
    
                    /**
                     * Creates a new ListDVRCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.ListDVRCameraRequest} ListDVRCameraRequest instance
                     */
                    ListDVRCameraRequest.create = function create(properties) {
                        return new ListDVRCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified ListDVRCameraRequest message. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraRequest} message ListDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrCameraFilter != null && Object.hasOwnProperty.call(message, "dvrCameraFilter"))
                            $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.encode(message.dvrCameraFilter, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDVRCameraRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraRequest} message ListDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDVRCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.ListDVRCameraRequest} ListDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvrCameraFilter = $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDVRCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.ListDVRCameraRequest} ListDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDVRCameraRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDVRCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrCameraFilter != null && message.hasOwnProperty("dvrCameraFilter")) {
                            var error = $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.verify(message.dvrCameraFilter);
                            if (error)
                                return "dvrCameraFilter." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListDVRCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.ListDVRCameraRequest} ListDVRCameraRequest
                     */
                    ListDVRCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.ListDVRCameraRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.ListDVRCameraRequest();
                        if (object.dvrCameraFilter != null) {
                            if (typeof object.dvrCameraFilter !== "object")
                                throw TypeError(".palexy.dvr.v1.ListDVRCameraRequest.dvrCameraFilter: object expected");
                            message.dvrCameraFilter = $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.fromObject(object.dvrCameraFilter);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDVRCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.ListDVRCameraRequest} message ListDVRCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDVRCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dvrCameraFilter = null;
                        if (message.dvrCameraFilter != null && message.hasOwnProperty("dvrCameraFilter"))
                            object.dvrCameraFilter = $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.toObject(message.dvrCameraFilter, options);
                        return object;
                    };
    
                    /**
                     * Converts this ListDVRCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.ListDVRCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDVRCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    ListDVRCameraRequest.DVRCameraFilter = (function() {
    
                        /**
                         * Properties of a DVRCameraFilter.
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest
                         * @interface IDVRCameraFilter
                         * @property {number|null} [dvrId] DVRCameraFilter dvrId
                         */
    
                        /**
                         * Constructs a new DVRCameraFilter.
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest
                         * @classdesc Represents a DVRCameraFilter.
                         * @implements IDVRCameraFilter
                         * @constructor
                         * @param {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter=} [properties] Properties to set
                         */
                        function DVRCameraFilter(properties) {
                            if (properties)
                                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                    if (properties[keys[i]] != null)
                                        this[keys[i]] = properties[keys[i]];
                        }
    
                        /**
                         * DVRCameraFilter dvrId.
                         * @member {number} dvrId
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @instance
                         */
                        DVRCameraFilter.prototype.dvrId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                        /**
                         * Creates a new DVRCameraFilter instance using the specified properties.
                         * @function create
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter=} [properties] Properties to set
                         * @returns {palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter} DVRCameraFilter instance
                         */
                        DVRCameraFilter.create = function create(properties) {
                            return new DVRCameraFilter(properties);
                        };
    
                        /**
                         * Encodes the specified DVRCameraFilter message. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.verify|verify} messages.
                         * @function encode
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter} message DVRCameraFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DVRCameraFilter.encode = function encode(message, writer) {
                            if (!writer)
                                writer = $Writer.create();
                            if (message.dvrId != null && Object.hasOwnProperty.call(message, "dvrId"))
                                writer.uint32(/* id 1, wireType 0 =*/8).int64(message.dvrId);
                            return writer;
                        };
    
                        /**
                         * Encodes the specified DVRCameraFilter message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter.verify|verify} messages.
                         * @function encodeDelimited
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRCameraRequest.IDVRCameraFilter} message DVRCameraFilter message or plain object to encode
                         * @param {$protobuf.Writer} [writer] Writer to encode to
                         * @returns {$protobuf.Writer} Writer
                         */
                        DVRCameraFilter.encodeDelimited = function encodeDelimited(message, writer) {
                            return this.encode(message, writer).ldelim();
                        };
    
                        /**
                         * Decodes a DVRCameraFilter message from the specified reader or buffer.
                         * @function decode
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @param {number} [length] Message length if known beforehand
                         * @returns {palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter} DVRCameraFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DVRCameraFilter.decode = function decode(reader, length) {
                            if (!(reader instanceof $Reader))
                                reader = $Reader.create(reader);
                            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter();
                            while (reader.pos < end) {
                                var tag = reader.uint32();
                                switch (tag >>> 3) {
                                case 1:
                                    message.dvrId = reader.int64();
                                    break;
                                default:
                                    reader.skipType(tag & 7);
                                    break;
                                }
                            }
                            return message;
                        };
    
                        /**
                         * Decodes a DVRCameraFilter message from the specified reader or buffer, length delimited.
                         * @function decodeDelimited
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                         * @returns {palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter} DVRCameraFilter
                         * @throws {Error} If the payload is not a reader or valid buffer
                         * @throws {$protobuf.util.ProtocolError} If required fields are missing
                         */
                        DVRCameraFilter.decodeDelimited = function decodeDelimited(reader) {
                            if (!(reader instanceof $Reader))
                                reader = new $Reader(reader);
                            return this.decode(reader, reader.uint32());
                        };
    
                        /**
                         * Verifies a DVRCameraFilter message.
                         * @function verify
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {Object.<string,*>} message Plain object to verify
                         * @returns {string|null} `null` if valid, otherwise the reason why it is not
                         */
                        DVRCameraFilter.verify = function verify(message) {
                            if (typeof message !== "object" || message === null)
                                return "object expected";
                            if (message.dvrId != null && message.hasOwnProperty("dvrId"))
                                if (!$util.isInteger(message.dvrId) && !(message.dvrId && $util.isInteger(message.dvrId.low) && $util.isInteger(message.dvrId.high)))
                                    return "dvrId: integer|Long expected";
                            return null;
                        };
    
                        /**
                         * Creates a DVRCameraFilter message from a plain object. Also converts values to their respective internal types.
                         * @function fromObject
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {Object.<string,*>} object Plain object
                         * @returns {palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter} DVRCameraFilter
                         */
                        DVRCameraFilter.fromObject = function fromObject(object) {
                            if (object instanceof $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter)
                                return object;
                            var message = new $root.palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter();
                            if (object.dvrId != null)
                                if ($util.Long)
                                    (message.dvrId = $util.Long.fromValue(object.dvrId)).unsigned = false;
                                else if (typeof object.dvrId === "string")
                                    message.dvrId = parseInt(object.dvrId, 10);
                                else if (typeof object.dvrId === "number")
                                    message.dvrId = object.dvrId;
                                else if (typeof object.dvrId === "object")
                                    message.dvrId = new $util.LongBits(object.dvrId.low >>> 0, object.dvrId.high >>> 0).toNumber();
                            return message;
                        };
    
                        /**
                         * Creates a plain object from a DVRCameraFilter message. Also converts values to other types if specified.
                         * @function toObject
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @static
                         * @param {palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter} message DVRCameraFilter
                         * @param {$protobuf.IConversionOptions} [options] Conversion options
                         * @returns {Object.<string,*>} Plain object
                         */
                        DVRCameraFilter.toObject = function toObject(message, options) {
                            if (!options)
                                options = {};
                            var object = {};
                            if (options.defaults)
                                if ($util.Long) {
                                    var long = new $util.Long(0, 0, false);
                                    object.dvrId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                                } else
                                    object.dvrId = options.longs === String ? "0" : 0;
                            if (message.dvrId != null && message.hasOwnProperty("dvrId"))
                                if (typeof message.dvrId === "number")
                                    object.dvrId = options.longs === String ? String(message.dvrId) : message.dvrId;
                                else
                                    object.dvrId = options.longs === String ? $util.Long.prototype.toString.call(message.dvrId) : options.longs === Number ? new $util.LongBits(message.dvrId.low >>> 0, message.dvrId.high >>> 0).toNumber() : message.dvrId;
                            return object;
                        };
    
                        /**
                         * Converts this DVRCameraFilter to JSON.
                         * @function toJSON
                         * @memberof palexy.dvr.v1.ListDVRCameraRequest.DVRCameraFilter
                         * @instance
                         * @returns {Object.<string,*>} JSON object
                         */
                        DVRCameraFilter.prototype.toJSON = function toJSON() {
                            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                        };
    
                        return DVRCameraFilter;
                    })();
    
                    return ListDVRCameraRequest;
                })();
    
                v1.ListDVRCameraResponse = (function() {
    
                    /**
                     * Properties of a ListDVRCameraResponse.
                     * @memberof palexy.dvr.v1
                     * @interface IListDVRCameraResponse
                     * @property {Array.<palexy.dvr.v1.IDVRCamera>|null} [dvrCameras] ListDVRCameraResponse dvrCameras
                     */
    
                    /**
                     * Constructs a new ListDVRCameraResponse.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a ListDVRCameraResponse.
                     * @implements IListDVRCameraResponse
                     * @constructor
                     * @param {palexy.dvr.v1.IListDVRCameraResponse=} [properties] Properties to set
                     */
                    function ListDVRCameraResponse(properties) {
                        this.dvrCameras = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ListDVRCameraResponse dvrCameras.
                     * @member {Array.<palexy.dvr.v1.IDVRCamera>} dvrCameras
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @instance
                     */
                    ListDVRCameraResponse.prototype.dvrCameras = $util.emptyArray;
    
                    /**
                     * Creates a new ListDVRCameraResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraResponse=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.ListDVRCameraResponse} ListDVRCameraResponse instance
                     */
                    ListDVRCameraResponse.create = function create(properties) {
                        return new ListDVRCameraResponse(properties);
                    };
    
                    /**
                     * Encodes the specified ListDVRCameraResponse message. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraResponse} message ListDVRCameraResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRCameraResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrCameras != null && message.dvrCameras.length)
                            for (var i = 0; i < message.dvrCameras.length; ++i)
                                $root.palexy.dvr.v1.DVRCamera.encode(message.dvrCameras[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ListDVRCameraResponse message, length delimited. Does not implicitly {@link palexy.dvr.v1.ListDVRCameraResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {palexy.dvr.v1.IListDVRCameraResponse} message ListDVRCameraResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ListDVRCameraResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ListDVRCameraResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.ListDVRCameraResponse} ListDVRCameraResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRCameraResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.ListDVRCameraResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.dvrCameras && message.dvrCameras.length))
                                    message.dvrCameras = [];
                                message.dvrCameras.push($root.palexy.dvr.v1.DVRCamera.decode(reader, reader.uint32()));
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ListDVRCameraResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.ListDVRCameraResponse} ListDVRCameraResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ListDVRCameraResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ListDVRCameraResponse message.
                     * @function verify
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ListDVRCameraResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrCameras != null && message.hasOwnProperty("dvrCameras")) {
                            if (!Array.isArray(message.dvrCameras))
                                return "dvrCameras: array expected";
                            for (var i = 0; i < message.dvrCameras.length; ++i) {
                                var error = $root.palexy.dvr.v1.DVRCamera.verify(message.dvrCameras[i]);
                                if (error)
                                    return "dvrCameras." + error;
                            }
                        }
                        return null;
                    };
    
                    /**
                     * Creates a ListDVRCameraResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.ListDVRCameraResponse} ListDVRCameraResponse
                     */
                    ListDVRCameraResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.ListDVRCameraResponse)
                            return object;
                        var message = new $root.palexy.dvr.v1.ListDVRCameraResponse();
                        if (object.dvrCameras) {
                            if (!Array.isArray(object.dvrCameras))
                                throw TypeError(".palexy.dvr.v1.ListDVRCameraResponse.dvrCameras: array expected");
                            message.dvrCameras = [];
                            for (var i = 0; i < object.dvrCameras.length; ++i) {
                                if (typeof object.dvrCameras[i] !== "object")
                                    throw TypeError(".palexy.dvr.v1.ListDVRCameraResponse.dvrCameras: object expected");
                                message.dvrCameras[i] = $root.palexy.dvr.v1.DVRCamera.fromObject(object.dvrCameras[i]);
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ListDVRCameraResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @static
                     * @param {palexy.dvr.v1.ListDVRCameraResponse} message ListDVRCameraResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ListDVRCameraResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.dvrCameras = [];
                        if (message.dvrCameras && message.dvrCameras.length) {
                            object.dvrCameras = [];
                            for (var j = 0; j < message.dvrCameras.length; ++j)
                                object.dvrCameras[j] = $root.palexy.dvr.v1.DVRCamera.toObject(message.dvrCameras[j], options);
                        }
                        return object;
                    };
    
                    /**
                     * Converts this ListDVRCameraResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.ListDVRCameraResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ListDVRCameraResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ListDVRCameraResponse;
                })();
    
                v1.CreateDVRCameraRequest = (function() {
    
                    /**
                     * Properties of a CreateDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @interface ICreateDVRCameraRequest
                     * @property {palexy.dvr.v1.IDVRCamera|null} [dvrCamera] CreateDVRCameraRequest dvrCamera
                     */
    
                    /**
                     * Constructs a new CreateDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a CreateDVRCameraRequest.
                     * @implements ICreateDVRCameraRequest
                     * @constructor
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest=} [properties] Properties to set
                     */
                    function CreateDVRCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * CreateDVRCameraRequest dvrCamera.
                     * @member {palexy.dvr.v1.IDVRCamera|null|undefined} dvrCamera
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @instance
                     */
                    CreateDVRCameraRequest.prototype.dvrCamera = null;
    
                    /**
                     * Creates a new CreateDVRCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.CreateDVRCameraRequest} CreateDVRCameraRequest instance
                     */
                    CreateDVRCameraRequest.create = function create(properties) {
                        return new CreateDVRCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified CreateDVRCameraRequest message. Does not implicitly {@link palexy.dvr.v1.CreateDVRCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest} message CreateDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDVRCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrCamera != null && Object.hasOwnProperty.call(message, "dvrCamera"))
                            $root.palexy.dvr.v1.DVRCamera.encode(message.dvrCamera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified CreateDVRCameraRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.CreateDVRCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.ICreateDVRCameraRequest} message CreateDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    CreateDVRCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a CreateDVRCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.CreateDVRCameraRequest} CreateDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDVRCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.CreateDVRCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a CreateDVRCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.CreateDVRCameraRequest} CreateDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    CreateDVRCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a CreateDVRCameraRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    CreateDVRCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera")) {
                            var error = $root.palexy.dvr.v1.DVRCamera.verify(message.dvrCamera);
                            if (error)
                                return "dvrCamera." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a CreateDVRCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.CreateDVRCameraRequest} CreateDVRCameraRequest
                     */
                    CreateDVRCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.CreateDVRCameraRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.CreateDVRCameraRequest();
                        if (object.dvrCamera != null) {
                            if (typeof object.dvrCamera !== "object")
                                throw TypeError(".palexy.dvr.v1.CreateDVRCameraRequest.dvrCamera: object expected");
                            message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.fromObject(object.dvrCamera);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a CreateDVRCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.CreateDVRCameraRequest} message CreateDVRCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    CreateDVRCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.dvrCamera = null;
                        if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera"))
                            object.dvrCamera = $root.palexy.dvr.v1.DVRCamera.toObject(message.dvrCamera, options);
                        return object;
                    };
    
                    /**
                     * Converts this CreateDVRCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.CreateDVRCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    CreateDVRCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return CreateDVRCameraRequest;
                })();
    
                v1.GetDVRCameraRequest = (function() {
    
                    /**
                     * Properties of a GetDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IGetDVRCameraRequest
                     * @property {number|null} [id] GetDVRCameraRequest id
                     */
    
                    /**
                     * Constructs a new GetDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a GetDVRCameraRequest.
                     * @implements IGetDVRCameraRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest=} [properties] Properties to set
                     */
                    function GetDVRCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetDVRCameraRequest id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @instance
                     */
                    GetDVRCameraRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new GetDVRCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.GetDVRCameraRequest} GetDVRCameraRequest instance
                     */
                    GetDVRCameraRequest.create = function create(properties) {
                        return new GetDVRCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetDVRCameraRequest message. Does not implicitly {@link palexy.dvr.v1.GetDVRCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest} message GetDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetDVRCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetDVRCameraRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.GetDVRCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IGetDVRCameraRequest} message GetDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetDVRCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetDVRCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.GetDVRCameraRequest} GetDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetDVRCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.GetDVRCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetDVRCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.GetDVRCameraRequest} GetDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetDVRCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetDVRCameraRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetDVRCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetDVRCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.GetDVRCameraRequest} GetDVRCameraRequest
                     */
                    GetDVRCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.GetDVRCameraRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.GetDVRCameraRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetDVRCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.GetDVRCameraRequest} message GetDVRCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetDVRCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this GetDVRCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.GetDVRCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetDVRCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetDVRCameraRequest;
                })();
    
                v1.UpdateDVRCameraRequest = (function() {
    
                    /**
                     * Properties of an UpdateDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IUpdateDVRCameraRequest
                     * @property {palexy.dvr.v1.IDVRCamera|null} [dvrCamera] UpdateDVRCameraRequest dvrCamera
                     * @property {google.protobuf.IFieldMask|null} [updateMask] UpdateDVRCameraRequest updateMask
                     */
    
                    /**
                     * Constructs a new UpdateDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents an UpdateDVRCameraRequest.
                     * @implements IUpdateDVRCameraRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest=} [properties] Properties to set
                     */
                    function UpdateDVRCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * UpdateDVRCameraRequest dvrCamera.
                     * @member {palexy.dvr.v1.IDVRCamera|null|undefined} dvrCamera
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @instance
                     */
                    UpdateDVRCameraRequest.prototype.dvrCamera = null;
    
                    /**
                     * UpdateDVRCameraRequest updateMask.
                     * @member {google.protobuf.IFieldMask|null|undefined} updateMask
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @instance
                     */
                    UpdateDVRCameraRequest.prototype.updateMask = null;
    
                    /**
                     * Creates a new UpdateDVRCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.UpdateDVRCameraRequest} UpdateDVRCameraRequest instance
                     */
                    UpdateDVRCameraRequest.create = function create(properties) {
                        return new UpdateDVRCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified UpdateDVRCameraRequest message. Does not implicitly {@link palexy.dvr.v1.UpdateDVRCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest} message UpdateDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateDVRCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.dvrCamera != null && Object.hasOwnProperty.call(message, "dvrCamera"))
                            $root.palexy.dvr.v1.DVRCamera.encode(message.dvrCamera, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        if (message.updateMask != null && Object.hasOwnProperty.call(message, "updateMask"))
                            $root.google.protobuf.FieldMask.encode(message.updateMask, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified UpdateDVRCameraRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.UpdateDVRCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IUpdateDVRCameraRequest} message UpdateDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    UpdateDVRCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an UpdateDVRCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.UpdateDVRCameraRequest} UpdateDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateDVRCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.UpdateDVRCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.decode(reader, reader.uint32());
                                break;
                            case 2:
                                message.updateMask = $root.google.protobuf.FieldMask.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an UpdateDVRCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.UpdateDVRCameraRequest} UpdateDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    UpdateDVRCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an UpdateDVRCameraRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    UpdateDVRCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera")) {
                            var error = $root.palexy.dvr.v1.DVRCamera.verify(message.dvrCamera);
                            if (error)
                                return "dvrCamera." + error;
                        }
                        if (message.updateMask != null && message.hasOwnProperty("updateMask")) {
                            var error = $root.google.protobuf.FieldMask.verify(message.updateMask);
                            if (error)
                                return "updateMask." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates an UpdateDVRCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.UpdateDVRCameraRequest} UpdateDVRCameraRequest
                     */
                    UpdateDVRCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.UpdateDVRCameraRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.UpdateDVRCameraRequest();
                        if (object.dvrCamera != null) {
                            if (typeof object.dvrCamera !== "object")
                                throw TypeError(".palexy.dvr.v1.UpdateDVRCameraRequest.dvrCamera: object expected");
                            message.dvrCamera = $root.palexy.dvr.v1.DVRCamera.fromObject(object.dvrCamera);
                        }
                        if (object.updateMask != null) {
                            if (typeof object.updateMask !== "object")
                                throw TypeError(".palexy.dvr.v1.UpdateDVRCameraRequest.updateMask: object expected");
                            message.updateMask = $root.google.protobuf.FieldMask.fromObject(object.updateMask);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an UpdateDVRCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.UpdateDVRCameraRequest} message UpdateDVRCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    UpdateDVRCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.dvrCamera = null;
                            object.updateMask = null;
                        }
                        if (message.dvrCamera != null && message.hasOwnProperty("dvrCamera"))
                            object.dvrCamera = $root.palexy.dvr.v1.DVRCamera.toObject(message.dvrCamera, options);
                        if (message.updateMask != null && message.hasOwnProperty("updateMask"))
                            object.updateMask = $root.google.protobuf.FieldMask.toObject(message.updateMask, options);
                        return object;
                    };
    
                    /**
                     * Converts this UpdateDVRCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.UpdateDVRCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    UpdateDVRCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return UpdateDVRCameraRequest;
                })();
    
                v1.DeleteDVRCameraRequest = (function() {
    
                    /**
                     * Properties of a DeleteDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @interface IDeleteDVRCameraRequest
                     * @property {number|null} [id] DeleteDVRCameraRequest id
                     */
    
                    /**
                     * Constructs a new DeleteDVRCameraRequest.
                     * @memberof palexy.dvr.v1
                     * @classdesc Represents a DeleteDVRCameraRequest.
                     * @implements IDeleteDVRCameraRequest
                     * @constructor
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest=} [properties] Properties to set
                     */
                    function DeleteDVRCameraRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * DeleteDVRCameraRequest id.
                     * @member {number} id
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @instance
                     */
                    DeleteDVRCameraRequest.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Creates a new DeleteDVRCameraRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest=} [properties] Properties to set
                     * @returns {palexy.dvr.v1.DeleteDVRCameraRequest} DeleteDVRCameraRequest instance
                     */
                    DeleteDVRCameraRequest.create = function create(properties) {
                        return new DeleteDVRCameraRequest(properties);
                    };
    
                    /**
                     * Encodes the specified DeleteDVRCameraRequest message. Does not implicitly {@link palexy.dvr.v1.DeleteDVRCameraRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest} message DeleteDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteDVRCameraRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified DeleteDVRCameraRequest message, length delimited. Does not implicitly {@link palexy.dvr.v1.DeleteDVRCameraRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.IDeleteDVRCameraRequest} message DeleteDVRCameraRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    DeleteDVRCameraRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a DeleteDVRCameraRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.dvr.v1.DeleteDVRCameraRequest} DeleteDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteDVRCameraRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.dvr.v1.DeleteDVRCameraRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a DeleteDVRCameraRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.dvr.v1.DeleteDVRCameraRequest} DeleteDVRCameraRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    DeleteDVRCameraRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a DeleteDVRCameraRequest message.
                     * @function verify
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    DeleteDVRCameraRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        return null;
                    };
    
                    /**
                     * Creates a DeleteDVRCameraRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.dvr.v1.DeleteDVRCameraRequest} DeleteDVRCameraRequest
                     */
                    DeleteDVRCameraRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.dvr.v1.DeleteDVRCameraRequest)
                            return object;
                        var message = new $root.palexy.dvr.v1.DeleteDVRCameraRequest();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a DeleteDVRCameraRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @static
                     * @param {palexy.dvr.v1.DeleteDVRCameraRequest} message DeleteDVRCameraRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    DeleteDVRCameraRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        return object;
                    };
    
                    /**
                     * Converts this DeleteDVRCameraRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.dvr.v1.DeleteDVRCameraRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    DeleteDVRCameraRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return DeleteDVRCameraRequest;
                })();
    
                return v1;
            })();
    
            return dvr;
        })();
    
        palexy.janus = (function() {
    
            /**
             * Namespace janus.
             * @memberof palexy
             * @namespace
             */
            var janus = {};
    
            janus.v1 = (function() {
    
                /**
                 * Namespace v1.
                 * @memberof palexy.janus
                 * @namespace
                 */
                var v1 = {};
    
                v1.ApiKeyService = (function() {
    
                    /**
                     * Constructs a new ApiKeyService service.
                     * @memberof palexy.janus.v1
                     * @classdesc Represents an ApiKeyService
                     * @extends $protobuf.rpc.Service
                     * @constructor
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     */
                    function ApiKeyService(rpcImpl, requestDelimited, responseDelimited) {
                        $protobuf.rpc.Service.call(this, rpcImpl, requestDelimited, responseDelimited);
                    }
    
                    (ApiKeyService.prototype = Object.create($protobuf.rpc.Service.prototype)).constructor = ApiKeyService;
    
                    /**
                     * Creates new ApiKeyService service using the specified rpc implementation.
                     * @function create
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @static
                     * @param {$protobuf.RPCImpl} rpcImpl RPC implementation
                     * @param {boolean} [requestDelimited=false] Whether requests are length-delimited
                     * @param {boolean} [responseDelimited=false] Whether responses are length-delimited
                     * @returns {ApiKeyService} RPC service. Useful where requests and/or responses are streamed.
                     */
                    ApiKeyService.create = function create(rpcImpl, requestDelimited, responseDelimited) {
                        return new this(rpcImpl, requestDelimited, responseDelimited);
                    };
    
                    /**
                     * Callback as used by {@link palexy.janus.v1.ApiKeyService#getAccountInfoByToken}.
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @typedef GetAccountInfoByTokenCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {palexy.janus.v1.GetAccountInfoByTokenResponse} [response] GetAccountInfoByTokenResponse
                     */
    
                    /**
                     * Calls GetAccountInfoByToken.
                     * @function getAccountInfoByToken
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @instance
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest} request GetAccountInfoByTokenRequest message or plain object
                     * @param {palexy.janus.v1.ApiKeyService.GetAccountInfoByTokenCallback} callback Node-style callback called with the error, if any, and GetAccountInfoByTokenResponse
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ApiKeyService.prototype.getAccountInfoByToken = function getAccountInfoByToken(request, callback) {
                        return this.rpcCall(getAccountInfoByToken, $root.palexy.janus.v1.GetAccountInfoByTokenRequest, $root.palexy.janus.v1.GetAccountInfoByTokenResponse, request, callback);
                    }, "name", { value: "GetAccountInfoByToken" });
    
                    /**
                     * Calls GetAccountInfoByToken.
                     * @function getAccountInfoByToken
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @instance
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest} request GetAccountInfoByTokenRequest message or plain object
                     * @returns {Promise<palexy.janus.v1.GetAccountInfoByTokenResponse>} Promise
                     * @variation 2
                     */
    
                    /**
                     * Callback as used by {@link palexy.janus.v1.ApiKeyService#check}.
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @typedef CheckCallback
                     * @type {function}
                     * @param {Error|null} error Error, if any
                     * @param {google.protobuf.Empty} [response] Empty
                     */
    
                    /**
                     * Calls Check.
                     * @function check
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @param {palexy.janus.v1.ApiKeyService.CheckCallback} callback Node-style callback called with the error, if any, and Empty
                     * @returns {undefined}
                     * @variation 1
                     */
                    Object.defineProperty(ApiKeyService.prototype.check = function check(request, callback) {
                        return this.rpcCall(check, $root.google.protobuf.Empty, $root.google.protobuf.Empty, request, callback);
                    }, "name", { value: "Check" });
    
                    /**
                     * Calls Check.
                     * @function check
                     * @memberof palexy.janus.v1.ApiKeyService
                     * @instance
                     * @param {google.protobuf.IEmpty} request Empty message or plain object
                     * @returns {Promise<google.protobuf.Empty>} Promise
                     * @variation 2
                     */
    
                    return ApiKeyService;
                })();
    
                v1.GetAccountInfoByTokenRequest = (function() {
    
                    /**
                     * Properties of a GetAccountInfoByTokenRequest.
                     * @memberof palexy.janus.v1
                     * @interface IGetAccountInfoByTokenRequest
                     * @property {string|null} [token] GetAccountInfoByTokenRequest token
                     */
    
                    /**
                     * Constructs a new GetAccountInfoByTokenRequest.
                     * @memberof palexy.janus.v1
                     * @classdesc Represents a GetAccountInfoByTokenRequest.
                     * @implements IGetAccountInfoByTokenRequest
                     * @constructor
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest=} [properties] Properties to set
                     */
                    function GetAccountInfoByTokenRequest(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAccountInfoByTokenRequest token.
                     * @member {string} token
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @instance
                     */
                    GetAccountInfoByTokenRequest.prototype.token = "";
    
                    /**
                     * Creates a new GetAccountInfoByTokenRequest instance using the specified properties.
                     * @function create
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest=} [properties] Properties to set
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenRequest} GetAccountInfoByTokenRequest instance
                     */
                    GetAccountInfoByTokenRequest.create = function create(properties) {
                        return new GetAccountInfoByTokenRequest(properties);
                    };
    
                    /**
                     * Encodes the specified GetAccountInfoByTokenRequest message. Does not implicitly {@link palexy.janus.v1.GetAccountInfoByTokenRequest.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest} message GetAccountInfoByTokenRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountInfoByTokenRequest.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.token != null && Object.hasOwnProperty.call(message, "token"))
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.token);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAccountInfoByTokenRequest message, length delimited. Does not implicitly {@link palexy.janus.v1.GetAccountInfoByTokenRequest.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenRequest} message GetAccountInfoByTokenRequest message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountInfoByTokenRequest.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAccountInfoByTokenRequest message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenRequest} GetAccountInfoByTokenRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountInfoByTokenRequest.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.janus.v1.GetAccountInfoByTokenRequest();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.token = reader.string();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAccountInfoByTokenRequest message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenRequest} GetAccountInfoByTokenRequest
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountInfoByTokenRequest.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAccountInfoByTokenRequest message.
                     * @function verify
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAccountInfoByTokenRequest.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.token != null && message.hasOwnProperty("token"))
                            if (!$util.isString(message.token))
                                return "token: string expected";
                        return null;
                    };
    
                    /**
                     * Creates a GetAccountInfoByTokenRequest message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenRequest} GetAccountInfoByTokenRequest
                     */
                    GetAccountInfoByTokenRequest.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.janus.v1.GetAccountInfoByTokenRequest)
                            return object;
                        var message = new $root.palexy.janus.v1.GetAccountInfoByTokenRequest();
                        if (object.token != null)
                            message.token = String(object.token);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAccountInfoByTokenRequest message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @static
                     * @param {palexy.janus.v1.GetAccountInfoByTokenRequest} message GetAccountInfoByTokenRequest
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAccountInfoByTokenRequest.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.token = "";
                        if (message.token != null && message.hasOwnProperty("token"))
                            object.token = message.token;
                        return object;
                    };
    
                    /**
                     * Converts this GetAccountInfoByTokenRequest to JSON.
                     * @function toJSON
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenRequest
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAccountInfoByTokenRequest.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAccountInfoByTokenRequest;
                })();
    
                v1.GetAccountInfoByTokenResponse = (function() {
    
                    /**
                     * Properties of a GetAccountInfoByTokenResponse.
                     * @memberof palexy.janus.v1
                     * @interface IGetAccountInfoByTokenResponse
                     * @property {palexy.janus.v1.IAccount|null} [account] GetAccountInfoByTokenResponse account
                     */
    
                    /**
                     * Constructs a new GetAccountInfoByTokenResponse.
                     * @memberof palexy.janus.v1
                     * @classdesc Represents a GetAccountInfoByTokenResponse.
                     * @implements IGetAccountInfoByTokenResponse
                     * @constructor
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenResponse=} [properties] Properties to set
                     */
                    function GetAccountInfoByTokenResponse(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * GetAccountInfoByTokenResponse account.
                     * @member {palexy.janus.v1.IAccount|null|undefined} account
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @instance
                     */
                    GetAccountInfoByTokenResponse.prototype.account = null;
    
                    /**
                     * Creates a new GetAccountInfoByTokenResponse instance using the specified properties.
                     * @function create
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenResponse=} [properties] Properties to set
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenResponse} GetAccountInfoByTokenResponse instance
                     */
                    GetAccountInfoByTokenResponse.create = function create(properties) {
                        return new GetAccountInfoByTokenResponse(properties);
                    };
    
                    /**
                     * Encodes the specified GetAccountInfoByTokenResponse message. Does not implicitly {@link palexy.janus.v1.GetAccountInfoByTokenResponse.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenResponse} message GetAccountInfoByTokenResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountInfoByTokenResponse.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.account != null && Object.hasOwnProperty.call(message, "account"))
                            $root.palexy.janus.v1.Account.encode(message.account, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                        return writer;
                    };
    
                    /**
                     * Encodes the specified GetAccountInfoByTokenResponse message, length delimited. Does not implicitly {@link palexy.janus.v1.GetAccountInfoByTokenResponse.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {palexy.janus.v1.IGetAccountInfoByTokenResponse} message GetAccountInfoByTokenResponse message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    GetAccountInfoByTokenResponse.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a GetAccountInfoByTokenResponse message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenResponse} GetAccountInfoByTokenResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountInfoByTokenResponse.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.janus.v1.GetAccountInfoByTokenResponse();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.account = $root.palexy.janus.v1.Account.decode(reader, reader.uint32());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a GetAccountInfoByTokenResponse message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenResponse} GetAccountInfoByTokenResponse
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    GetAccountInfoByTokenResponse.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a GetAccountInfoByTokenResponse message.
                     * @function verify
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    GetAccountInfoByTokenResponse.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.account != null && message.hasOwnProperty("account")) {
                            var error = $root.palexy.janus.v1.Account.verify(message.account);
                            if (error)
                                return "account." + error;
                        }
                        return null;
                    };
    
                    /**
                     * Creates a GetAccountInfoByTokenResponse message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.janus.v1.GetAccountInfoByTokenResponse} GetAccountInfoByTokenResponse
                     */
                    GetAccountInfoByTokenResponse.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.janus.v1.GetAccountInfoByTokenResponse)
                            return object;
                        var message = new $root.palexy.janus.v1.GetAccountInfoByTokenResponse();
                        if (object.account != null) {
                            if (typeof object.account !== "object")
                                throw TypeError(".palexy.janus.v1.GetAccountInfoByTokenResponse.account: object expected");
                            message.account = $root.palexy.janus.v1.Account.fromObject(object.account);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a GetAccountInfoByTokenResponse message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @static
                     * @param {palexy.janus.v1.GetAccountInfoByTokenResponse} message GetAccountInfoByTokenResponse
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    GetAccountInfoByTokenResponse.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults)
                            object.account = null;
                        if (message.account != null && message.hasOwnProperty("account"))
                            object.account = $root.palexy.janus.v1.Account.toObject(message.account, options);
                        return object;
                    };
    
                    /**
                     * Converts this GetAccountInfoByTokenResponse to JSON.
                     * @function toJSON
                     * @memberof palexy.janus.v1.GetAccountInfoByTokenResponse
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    GetAccountInfoByTokenResponse.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return GetAccountInfoByTokenResponse;
                })();
    
                v1.Account = (function() {
    
                    /**
                     * Properties of an Account.
                     * @memberof palexy.janus.v1
                     * @interface IAccount
                     * @property {number|null} [id] Account id
                     * @property {string|null} [username] Account username
                     * @property {string|null} [fullName] Account fullName
                     * @property {string|null} [email] Account email
                     * @property {Array.<string>|null} [roles] Account roles
                     */
    
                    /**
                     * Constructs a new Account.
                     * @memberof palexy.janus.v1
                     * @classdesc Represents an Account.
                     * @implements IAccount
                     * @constructor
                     * @param {palexy.janus.v1.IAccount=} [properties] Properties to set
                     */
                    function Account(properties) {
                        this.roles = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Account id.
                     * @member {number} id
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     */
                    Account.prototype.id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                    /**
                     * Account username.
                     * @member {string} username
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     */
                    Account.prototype.username = "";
    
                    /**
                     * Account fullName.
                     * @member {string} fullName
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     */
                    Account.prototype.fullName = "";
    
                    /**
                     * Account email.
                     * @member {string} email
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     */
                    Account.prototype.email = "";
    
                    /**
                     * Account roles.
                     * @member {Array.<string>} roles
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     */
                    Account.prototype.roles = $util.emptyArray;
    
                    /**
                     * Creates a new Account instance using the specified properties.
                     * @function create
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {palexy.janus.v1.IAccount=} [properties] Properties to set
                     * @returns {palexy.janus.v1.Account} Account instance
                     */
                    Account.create = function create(properties) {
                        return new Account(properties);
                    };
    
                    /**
                     * Encodes the specified Account message. Does not implicitly {@link palexy.janus.v1.Account.verify|verify} messages.
                     * @function encode
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {palexy.janus.v1.IAccount} message Account message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Account.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.id != null && Object.hasOwnProperty.call(message, "id"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.id);
                        if (message.username != null && Object.hasOwnProperty.call(message, "username"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.username);
                        if (message.fullName != null && Object.hasOwnProperty.call(message, "fullName"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.fullName);
                        if (message.email != null && Object.hasOwnProperty.call(message, "email"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.email);
                        if (message.roles != null && message.roles.length)
                            for (var i = 0; i < message.roles.length; ++i)
                                writer.uint32(/* id 5, wireType 2 =*/42).string(message.roles[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Account message, length delimited. Does not implicitly {@link palexy.janus.v1.Account.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {palexy.janus.v1.IAccount} message Account message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Account.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Account message from the specified reader or buffer.
                     * @function decode
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {palexy.janus.v1.Account} Account
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Account.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.palexy.janus.v1.Account();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.id = reader.int64();
                                break;
                            case 2:
                                message.username = reader.string();
                                break;
                            case 3:
                                message.fullName = reader.string();
                                break;
                            case 4:
                                message.email = reader.string();
                                break;
                            case 5:
                                if (!(message.roles && message.roles.length))
                                    message.roles = [];
                                message.roles.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Account message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {palexy.janus.v1.Account} Account
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Account.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Account message.
                     * @function verify
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Account.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (!$util.isInteger(message.id) && !(message.id && $util.isInteger(message.id.low) && $util.isInteger(message.id.high)))
                                return "id: integer|Long expected";
                        if (message.username != null && message.hasOwnProperty("username"))
                            if (!$util.isString(message.username))
                                return "username: string expected";
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            if (!$util.isString(message.fullName))
                                return "fullName: string expected";
                        if (message.email != null && message.hasOwnProperty("email"))
                            if (!$util.isString(message.email))
                                return "email: string expected";
                        if (message.roles != null && message.hasOwnProperty("roles")) {
                            if (!Array.isArray(message.roles))
                                return "roles: array expected";
                            for (var i = 0; i < message.roles.length; ++i)
                                if (!$util.isString(message.roles[i]))
                                    return "roles: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates an Account message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {palexy.janus.v1.Account} Account
                     */
                    Account.fromObject = function fromObject(object) {
                        if (object instanceof $root.palexy.janus.v1.Account)
                            return object;
                        var message = new $root.palexy.janus.v1.Account();
                        if (object.id != null)
                            if ($util.Long)
                                (message.id = $util.Long.fromValue(object.id)).unsigned = false;
                            else if (typeof object.id === "string")
                                message.id = parseInt(object.id, 10);
                            else if (typeof object.id === "number")
                                message.id = object.id;
                            else if (typeof object.id === "object")
                                message.id = new $util.LongBits(object.id.low >>> 0, object.id.high >>> 0).toNumber();
                        if (object.username != null)
                            message.username = String(object.username);
                        if (object.fullName != null)
                            message.fullName = String(object.fullName);
                        if (object.email != null)
                            message.email = String(object.email);
                        if (object.roles) {
                            if (!Array.isArray(object.roles))
                                throw TypeError(".palexy.janus.v1.Account.roles: array expected");
                            message.roles = [];
                            for (var i = 0; i < object.roles.length; ++i)
                                message.roles[i] = String(object.roles[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Account message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof palexy.janus.v1.Account
                     * @static
                     * @param {palexy.janus.v1.Account} message Account
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Account.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.roles = [];
                        if (options.defaults) {
                            if ($util.Long) {
                                var long = new $util.Long(0, 0, false);
                                object.id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                            } else
                                object.id = options.longs === String ? "0" : 0;
                            object.username = "";
                            object.fullName = "";
                            object.email = "";
                        }
                        if (message.id != null && message.hasOwnProperty("id"))
                            if (typeof message.id === "number")
                                object.id = options.longs === String ? String(message.id) : message.id;
                            else
                                object.id = options.longs === String ? $util.Long.prototype.toString.call(message.id) : options.longs === Number ? new $util.LongBits(message.id.low >>> 0, message.id.high >>> 0).toNumber() : message.id;
                        if (message.username != null && message.hasOwnProperty("username"))
                            object.username = message.username;
                        if (message.fullName != null && message.hasOwnProperty("fullName"))
                            object.fullName = message.fullName;
                        if (message.email != null && message.hasOwnProperty("email"))
                            object.email = message.email;
                        if (message.roles && message.roles.length) {
                            object.roles = [];
                            for (var j = 0; j < message.roles.length; ++j)
                                object.roles[j] = message.roles[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Account to JSON.
                     * @function toJSON
                     * @memberof palexy.janus.v1.Account
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Account.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Account;
                })();
    
                return v1;
            })();
    
            return janus;
        })();
    
        return palexy;
    })();
    
    $root.google = (function() {
    
        /**
         * Namespace google.
         * @exports google
         * @namespace
         */
        var google = {};
    
        google.api = (function() {
    
            /**
             * Namespace api.
             * @memberof google
             * @namespace
             */
            var api = {};
    
            api.Http = (function() {
    
                /**
                 * Properties of a Http.
                 * @memberof google.api
                 * @interface IHttp
                 * @property {Array.<google.api.IHttpRule>|null} [rules] Http rules
                 * @property {boolean|null} [fullyDecodeReservedExpansion] Http fullyDecodeReservedExpansion
                 */
    
                /**
                 * Constructs a new Http.
                 * @memberof google.api
                 * @classdesc Represents a Http.
                 * @implements IHttp
                 * @constructor
                 * @param {google.api.IHttp=} [properties] Properties to set
                 */
                function Http(properties) {
                    this.rules = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Http rules.
                 * @member {Array.<google.api.IHttpRule>} rules
                 * @memberof google.api.Http
                 * @instance
                 */
                Http.prototype.rules = $util.emptyArray;
    
                /**
                 * Http fullyDecodeReservedExpansion.
                 * @member {boolean} fullyDecodeReservedExpansion
                 * @memberof google.api.Http
                 * @instance
                 */
                Http.prototype.fullyDecodeReservedExpansion = false;
    
                /**
                 * Creates a new Http instance using the specified properties.
                 * @function create
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp=} [properties] Properties to set
                 * @returns {google.api.Http} Http instance
                 */
                Http.create = function create(properties) {
                    return new Http(properties);
                };
    
                /**
                 * Encodes the specified Http message. Does not implicitly {@link google.api.Http.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp} message Http message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Http.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.rules != null && message.rules.length)
                        for (var i = 0; i < message.rules.length; ++i)
                            $root.google.api.HttpRule.encode(message.rules[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    if (message.fullyDecodeReservedExpansion != null && Object.hasOwnProperty.call(message, "fullyDecodeReservedExpansion"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.fullyDecodeReservedExpansion);
                    return writer;
                };
    
                /**
                 * Encodes the specified Http message, length delimited. Does not implicitly {@link google.api.Http.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.IHttp} message Http message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Http.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Http message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.Http
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.Http} Http
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Http.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.Http();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.rules && message.rules.length))
                                message.rules = [];
                            message.rules.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                            break;
                        case 2:
                            message.fullyDecodeReservedExpansion = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Http message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.Http
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.Http} Http
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Http.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Http message.
                 * @function verify
                 * @memberof google.api.Http
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Http.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.rules != null && message.hasOwnProperty("rules")) {
                        if (!Array.isArray(message.rules))
                            return "rules: array expected";
                        for (var i = 0; i < message.rules.length; ++i) {
                            var error = $root.google.api.HttpRule.verify(message.rules[i]);
                            if (error)
                                return "rules." + error;
                        }
                    }
                    if (message.fullyDecodeReservedExpansion != null && message.hasOwnProperty("fullyDecodeReservedExpansion"))
                        if (typeof message.fullyDecodeReservedExpansion !== "boolean")
                            return "fullyDecodeReservedExpansion: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a Http message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.Http
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.Http} Http
                 */
                Http.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.Http)
                        return object;
                    var message = new $root.google.api.Http();
                    if (object.rules) {
                        if (!Array.isArray(object.rules))
                            throw TypeError(".google.api.Http.rules: array expected");
                        message.rules = [];
                        for (var i = 0; i < object.rules.length; ++i) {
                            if (typeof object.rules[i] !== "object")
                                throw TypeError(".google.api.Http.rules: object expected");
                            message.rules[i] = $root.google.api.HttpRule.fromObject(object.rules[i]);
                        }
                    }
                    if (object.fullyDecodeReservedExpansion != null)
                        message.fullyDecodeReservedExpansion = Boolean(object.fullyDecodeReservedExpansion);
                    return message;
                };
    
                /**
                 * Creates a plain object from a Http message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.Http
                 * @static
                 * @param {google.api.Http} message Http
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Http.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.rules = [];
                    if (options.defaults)
                        object.fullyDecodeReservedExpansion = false;
                    if (message.rules && message.rules.length) {
                        object.rules = [];
                        for (var j = 0; j < message.rules.length; ++j)
                            object.rules[j] = $root.google.api.HttpRule.toObject(message.rules[j], options);
                    }
                    if (message.fullyDecodeReservedExpansion != null && message.hasOwnProperty("fullyDecodeReservedExpansion"))
                        object.fullyDecodeReservedExpansion = message.fullyDecodeReservedExpansion;
                    return object;
                };
    
                /**
                 * Converts this Http to JSON.
                 * @function toJSON
                 * @memberof google.api.Http
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Http.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Http;
            })();
    
            api.HttpRule = (function() {
    
                /**
                 * Properties of a HttpRule.
                 * @memberof google.api
                 * @interface IHttpRule
                 * @property {string|null} [selector] HttpRule selector
                 * @property {string|null} [get] HttpRule get
                 * @property {string|null} [put] HttpRule put
                 * @property {string|null} [post] HttpRule post
                 * @property {string|null} ["delete"] HttpRule delete
                 * @property {string|null} [patch] HttpRule patch
                 * @property {google.api.ICustomHttpPattern|null} [custom] HttpRule custom
                 * @property {string|null} [body] HttpRule body
                 * @property {string|null} [responseBody] HttpRule responseBody
                 * @property {Array.<google.api.IHttpRule>|null} [additionalBindings] HttpRule additionalBindings
                 */
    
                /**
                 * Constructs a new HttpRule.
                 * @memberof google.api
                 * @classdesc Represents a HttpRule.
                 * @implements IHttpRule
                 * @constructor
                 * @param {google.api.IHttpRule=} [properties] Properties to set
                 */
                function HttpRule(properties) {
                    this.additionalBindings = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * HttpRule selector.
                 * @member {string} selector
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.selector = "";
    
                /**
                 * HttpRule get.
                 * @member {string|null|undefined} get
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.get = null;
    
                /**
                 * HttpRule put.
                 * @member {string|null|undefined} put
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.put = null;
    
                /**
                 * HttpRule post.
                 * @member {string|null|undefined} post
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.post = null;
    
                /**
                 * HttpRule delete.
                 * @member {string|null|undefined} delete
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype["delete"] = null;
    
                /**
                 * HttpRule patch.
                 * @member {string|null|undefined} patch
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.patch = null;
    
                /**
                 * HttpRule custom.
                 * @member {google.api.ICustomHttpPattern|null|undefined} custom
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.custom = null;
    
                /**
                 * HttpRule body.
                 * @member {string} body
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.body = "";
    
                /**
                 * HttpRule responseBody.
                 * @member {string} responseBody
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.responseBody = "";
    
                /**
                 * HttpRule additionalBindings.
                 * @member {Array.<google.api.IHttpRule>} additionalBindings
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                HttpRule.prototype.additionalBindings = $util.emptyArray;
    
                // OneOf field names bound to virtual getters and setters
                var $oneOfFields;
    
                /**
                 * HttpRule pattern.
                 * @member {"get"|"put"|"post"|"delete"|"patch"|"custom"|undefined} pattern
                 * @memberof google.api.HttpRule
                 * @instance
                 */
                Object.defineProperty(HttpRule.prototype, "pattern", {
                    get: $util.oneOfGetter($oneOfFields = ["get", "put", "post", "delete", "patch", "custom"]),
                    set: $util.oneOfSetter($oneOfFields)
                });
    
                /**
                 * Creates a new HttpRule instance using the specified properties.
                 * @function create
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule=} [properties] Properties to set
                 * @returns {google.api.HttpRule} HttpRule instance
                 */
                HttpRule.create = function create(properties) {
                    return new HttpRule(properties);
                };
    
                /**
                 * Encodes the specified HttpRule message. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HttpRule.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.selector != null && Object.hasOwnProperty.call(message, "selector"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.selector);
                    if (message.get != null && Object.hasOwnProperty.call(message, "get"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.get);
                    if (message.put != null && Object.hasOwnProperty.call(message, "put"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.put);
                    if (message.post != null && Object.hasOwnProperty.call(message, "post"))
                        writer.uint32(/* id 4, wireType 2 =*/34).string(message.post);
                    if (message["delete"] != null && Object.hasOwnProperty.call(message, "delete"))
                        writer.uint32(/* id 5, wireType 2 =*/42).string(message["delete"]);
                    if (message.patch != null && Object.hasOwnProperty.call(message, "patch"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.patch);
                    if (message.body != null && Object.hasOwnProperty.call(message, "body"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.body);
                    if (message.custom != null && Object.hasOwnProperty.call(message, "custom"))
                        $root.google.api.CustomHttpPattern.encode(message.custom, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.additionalBindings != null && message.additionalBindings.length)
                        for (var i = 0; i < message.additionalBindings.length; ++i)
                            $root.google.api.HttpRule.encode(message.additionalBindings[i], writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
                    if (message.responseBody != null && Object.hasOwnProperty.call(message, "responseBody"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.responseBody);
                    return writer;
                };
    
                /**
                 * Encodes the specified HttpRule message, length delimited. Does not implicitly {@link google.api.HttpRule.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.IHttpRule} message HttpRule message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                HttpRule.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a HttpRule message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.HttpRule} HttpRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HttpRule.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.HttpRule();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.selector = reader.string();
                            break;
                        case 2:
                            message.get = reader.string();
                            break;
                        case 3:
                            message.put = reader.string();
                            break;
                        case 4:
                            message.post = reader.string();
                            break;
                        case 5:
                            message["delete"] = reader.string();
                            break;
                        case 6:
                            message.patch = reader.string();
                            break;
                        case 8:
                            message.custom = $root.google.api.CustomHttpPattern.decode(reader, reader.uint32());
                            break;
                        case 7:
                            message.body = reader.string();
                            break;
                        case 12:
                            message.responseBody = reader.string();
                            break;
                        case 11:
                            if (!(message.additionalBindings && message.additionalBindings.length))
                                message.additionalBindings = [];
                            message.additionalBindings.push($root.google.api.HttpRule.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a HttpRule message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.HttpRule} HttpRule
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                HttpRule.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a HttpRule message.
                 * @function verify
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                HttpRule.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    var properties = {};
                    if (message.selector != null && message.hasOwnProperty("selector"))
                        if (!$util.isString(message.selector))
                            return "selector: string expected";
                    if (message.get != null && message.hasOwnProperty("get")) {
                        properties.pattern = 1;
                        if (!$util.isString(message.get))
                            return "get: string expected";
                    }
                    if (message.put != null && message.hasOwnProperty("put")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.put))
                            return "put: string expected";
                    }
                    if (message.post != null && message.hasOwnProperty("post")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.post))
                            return "post: string expected";
                    }
                    if (message["delete"] != null && message.hasOwnProperty("delete")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message["delete"]))
                            return "delete: string expected";
                    }
                    if (message.patch != null && message.hasOwnProperty("patch")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        if (!$util.isString(message.patch))
                            return "patch: string expected";
                    }
                    if (message.custom != null && message.hasOwnProperty("custom")) {
                        if (properties.pattern === 1)
                            return "pattern: multiple values";
                        properties.pattern = 1;
                        {
                            var error = $root.google.api.CustomHttpPattern.verify(message.custom);
                            if (error)
                                return "custom." + error;
                        }
                    }
                    if (message.body != null && message.hasOwnProperty("body"))
                        if (!$util.isString(message.body))
                            return "body: string expected";
                    if (message.responseBody != null && message.hasOwnProperty("responseBody"))
                        if (!$util.isString(message.responseBody))
                            return "responseBody: string expected";
                    if (message.additionalBindings != null && message.hasOwnProperty("additionalBindings")) {
                        if (!Array.isArray(message.additionalBindings))
                            return "additionalBindings: array expected";
                        for (var i = 0; i < message.additionalBindings.length; ++i) {
                            var error = $root.google.api.HttpRule.verify(message.additionalBindings[i]);
                            if (error)
                                return "additionalBindings." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a HttpRule message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.HttpRule} HttpRule
                 */
                HttpRule.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.HttpRule)
                        return object;
                    var message = new $root.google.api.HttpRule();
                    if (object.selector != null)
                        message.selector = String(object.selector);
                    if (object.get != null)
                        message.get = String(object.get);
                    if (object.put != null)
                        message.put = String(object.put);
                    if (object.post != null)
                        message.post = String(object.post);
                    if (object["delete"] != null)
                        message["delete"] = String(object["delete"]);
                    if (object.patch != null)
                        message.patch = String(object.patch);
                    if (object.custom != null) {
                        if (typeof object.custom !== "object")
                            throw TypeError(".google.api.HttpRule.custom: object expected");
                        message.custom = $root.google.api.CustomHttpPattern.fromObject(object.custom);
                    }
                    if (object.body != null)
                        message.body = String(object.body);
                    if (object.responseBody != null)
                        message.responseBody = String(object.responseBody);
                    if (object.additionalBindings) {
                        if (!Array.isArray(object.additionalBindings))
                            throw TypeError(".google.api.HttpRule.additionalBindings: array expected");
                        message.additionalBindings = [];
                        for (var i = 0; i < object.additionalBindings.length; ++i) {
                            if (typeof object.additionalBindings[i] !== "object")
                                throw TypeError(".google.api.HttpRule.additionalBindings: object expected");
                            message.additionalBindings[i] = $root.google.api.HttpRule.fromObject(object.additionalBindings[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a HttpRule message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.HttpRule
                 * @static
                 * @param {google.api.HttpRule} message HttpRule
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                HttpRule.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.additionalBindings = [];
                    if (options.defaults) {
                        object.selector = "";
                        object.body = "";
                        object.responseBody = "";
                    }
                    if (message.selector != null && message.hasOwnProperty("selector"))
                        object.selector = message.selector;
                    if (message.get != null && message.hasOwnProperty("get")) {
                        object.get = message.get;
                        if (options.oneofs)
                            object.pattern = "get";
                    }
                    if (message.put != null && message.hasOwnProperty("put")) {
                        object.put = message.put;
                        if (options.oneofs)
                            object.pattern = "put";
                    }
                    if (message.post != null && message.hasOwnProperty("post")) {
                        object.post = message.post;
                        if (options.oneofs)
                            object.pattern = "post";
                    }
                    if (message["delete"] != null && message.hasOwnProperty("delete")) {
                        object["delete"] = message["delete"];
                        if (options.oneofs)
                            object.pattern = "delete";
                    }
                    if (message.patch != null && message.hasOwnProperty("patch")) {
                        object.patch = message.patch;
                        if (options.oneofs)
                            object.pattern = "patch";
                    }
                    if (message.body != null && message.hasOwnProperty("body"))
                        object.body = message.body;
                    if (message.custom != null && message.hasOwnProperty("custom")) {
                        object.custom = $root.google.api.CustomHttpPattern.toObject(message.custom, options);
                        if (options.oneofs)
                            object.pattern = "custom";
                    }
                    if (message.additionalBindings && message.additionalBindings.length) {
                        object.additionalBindings = [];
                        for (var j = 0; j < message.additionalBindings.length; ++j)
                            object.additionalBindings[j] = $root.google.api.HttpRule.toObject(message.additionalBindings[j], options);
                    }
                    if (message.responseBody != null && message.hasOwnProperty("responseBody"))
                        object.responseBody = message.responseBody;
                    return object;
                };
    
                /**
                 * Converts this HttpRule to JSON.
                 * @function toJSON
                 * @memberof google.api.HttpRule
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                HttpRule.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return HttpRule;
            })();
    
            api.CustomHttpPattern = (function() {
    
                /**
                 * Properties of a CustomHttpPattern.
                 * @memberof google.api
                 * @interface ICustomHttpPattern
                 * @property {string|null} [kind] CustomHttpPattern kind
                 * @property {string|null} [path] CustomHttpPattern path
                 */
    
                /**
                 * Constructs a new CustomHttpPattern.
                 * @memberof google.api
                 * @classdesc Represents a CustomHttpPattern.
                 * @implements ICustomHttpPattern
                 * @constructor
                 * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
                 */
                function CustomHttpPattern(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * CustomHttpPattern kind.
                 * @member {string} kind
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 */
                CustomHttpPattern.prototype.kind = "";
    
                /**
                 * CustomHttpPattern path.
                 * @member {string} path
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 */
                CustomHttpPattern.prototype.path = "";
    
                /**
                 * Creates a new CustomHttpPattern instance using the specified properties.
                 * @function create
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern=} [properties] Properties to set
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern instance
                 */
                CustomHttpPattern.create = function create(properties) {
                    return new CustomHttpPattern(properties);
                };
    
                /**
                 * Encodes the specified CustomHttpPattern message. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
                 * @function encode
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CustomHttpPattern.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.kind != null && Object.hasOwnProperty.call(message, "kind"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.kind);
                    if (message.path != null && Object.hasOwnProperty.call(message, "path"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.path);
                    return writer;
                };
    
                /**
                 * Encodes the specified CustomHttpPattern message, length delimited. Does not implicitly {@link google.api.CustomHttpPattern.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.ICustomHttpPattern} message CustomHttpPattern message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                CustomHttpPattern.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a CustomHttpPattern message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CustomHttpPattern.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.api.CustomHttpPattern();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.kind = reader.string();
                            break;
                        case 2:
                            message.path = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a CustomHttpPattern message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                CustomHttpPattern.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a CustomHttpPattern message.
                 * @function verify
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                CustomHttpPattern.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.kind != null && message.hasOwnProperty("kind"))
                        if (!$util.isString(message.kind))
                            return "kind: string expected";
                    if (message.path != null && message.hasOwnProperty("path"))
                        if (!$util.isString(message.path))
                            return "path: string expected";
                    return null;
                };
    
                /**
                 * Creates a CustomHttpPattern message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.api.CustomHttpPattern} CustomHttpPattern
                 */
                CustomHttpPattern.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.api.CustomHttpPattern)
                        return object;
                    var message = new $root.google.api.CustomHttpPattern();
                    if (object.kind != null)
                        message.kind = String(object.kind);
                    if (object.path != null)
                        message.path = String(object.path);
                    return message;
                };
    
                /**
                 * Creates a plain object from a CustomHttpPattern message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.api.CustomHttpPattern
                 * @static
                 * @param {google.api.CustomHttpPattern} message CustomHttpPattern
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                CustomHttpPattern.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.kind = "";
                        object.path = "";
                    }
                    if (message.kind != null && message.hasOwnProperty("kind"))
                        object.kind = message.kind;
                    if (message.path != null && message.hasOwnProperty("path"))
                        object.path = message.path;
                    return object;
                };
    
                /**
                 * Converts this CustomHttpPattern to JSON.
                 * @function toJSON
                 * @memberof google.api.CustomHttpPattern
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                CustomHttpPattern.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return CustomHttpPattern;
            })();
    
            return api;
        })();
    
        google.protobuf = (function() {
    
            /**
             * Namespace protobuf.
             * @memberof google
             * @namespace
             */
            var protobuf = {};
    
            protobuf.FileDescriptorSet = (function() {
    
                /**
                 * Properties of a FileDescriptorSet.
                 * @memberof google.protobuf
                 * @interface IFileDescriptorSet
                 * @property {Array.<google.protobuf.IFileDescriptorProto>|null} [file] FileDescriptorSet file
                 */
    
                /**
                 * Constructs a new FileDescriptorSet.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileDescriptorSet.
                 * @implements IFileDescriptorSet
                 * @constructor
                 * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
                 */
                function FileDescriptorSet(properties) {
                    this.file = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileDescriptorSet file.
                 * @member {Array.<google.protobuf.IFileDescriptorProto>} file
                 * @memberof google.protobuf.FileDescriptorSet
                 * @instance
                 */
                FileDescriptorSet.prototype.file = $util.emptyArray;
    
                /**
                 * Creates a new FileDescriptorSet instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet=} [properties] Properties to set
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet instance
                 */
                FileDescriptorSet.create = function create(properties) {
                    return new FileDescriptorSet(properties);
                };
    
                /**
                 * Encodes the specified FileDescriptorSet message. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorSet.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.file != null && message.file.length)
                        for (var i = 0; i < message.file.length; ++i)
                            $root.google.protobuf.FileDescriptorProto.encode(message.file[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FileDescriptorSet message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorSet.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.IFileDescriptorSet} message FileDescriptorSet message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorSet.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileDescriptorSet message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorSet.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorSet();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.file && message.file.length))
                                message.file = [];
                            message.file.push($root.google.protobuf.FileDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileDescriptorSet message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorSet.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileDescriptorSet message.
                 * @function verify
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileDescriptorSet.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.file != null && message.hasOwnProperty("file")) {
                        if (!Array.isArray(message.file))
                            return "file: array expected";
                        for (var i = 0; i < message.file.length; ++i) {
                            var error = $root.google.protobuf.FileDescriptorProto.verify(message.file[i]);
                            if (error)
                                return "file." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a FileDescriptorSet message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileDescriptorSet} FileDescriptorSet
                 */
                FileDescriptorSet.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileDescriptorSet)
                        return object;
                    var message = new $root.google.protobuf.FileDescriptorSet();
                    if (object.file) {
                        if (!Array.isArray(object.file))
                            throw TypeError(".google.protobuf.FileDescriptorSet.file: array expected");
                        message.file = [];
                        for (var i = 0; i < object.file.length; ++i) {
                            if (typeof object.file[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorSet.file: object expected");
                            message.file[i] = $root.google.protobuf.FileDescriptorProto.fromObject(object.file[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileDescriptorSet message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileDescriptorSet
                 * @static
                 * @param {google.protobuf.FileDescriptorSet} message FileDescriptorSet
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileDescriptorSet.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.file = [];
                    if (message.file && message.file.length) {
                        object.file = [];
                        for (var j = 0; j < message.file.length; ++j)
                            object.file[j] = $root.google.protobuf.FileDescriptorProto.toObject(message.file[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this FileDescriptorSet to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileDescriptorSet
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileDescriptorSet.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FileDescriptorSet;
            })();
    
            protobuf.FileDescriptorProto = (function() {
    
                /**
                 * Properties of a FileDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IFileDescriptorProto
                 * @property {string|null} [name] FileDescriptorProto name
                 * @property {string|null} ["package"] FileDescriptorProto package
                 * @property {Array.<string>|null} [dependency] FileDescriptorProto dependency
                 * @property {Array.<number>|null} [publicDependency] FileDescriptorProto publicDependency
                 * @property {Array.<number>|null} [weakDependency] FileDescriptorProto weakDependency
                 * @property {Array.<google.protobuf.IDescriptorProto>|null} [messageType] FileDescriptorProto messageType
                 * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] FileDescriptorProto enumType
                 * @property {Array.<google.protobuf.IServiceDescriptorProto>|null} [service] FileDescriptorProto service
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] FileDescriptorProto extension
                 * @property {google.protobuf.IFileOptions|null} [options] FileDescriptorProto options
                 * @property {google.protobuf.ISourceCodeInfo|null} [sourceCodeInfo] FileDescriptorProto sourceCodeInfo
                 * @property {string|null} [syntax] FileDescriptorProto syntax
                 */
    
                /**
                 * Constructs a new FileDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileDescriptorProto.
                 * @implements IFileDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
                 */
                function FileDescriptorProto(properties) {
                    this.dependency = [];
                    this.publicDependency = [];
                    this.weakDependency = [];
                    this.messageType = [];
                    this.enumType = [];
                    this.service = [];
                    this.extension = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.name = "";
    
                /**
                 * FileDescriptorProto package.
                 * @member {string} package
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype["package"] = "";
    
                /**
                 * FileDescriptorProto dependency.
                 * @member {Array.<string>} dependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.dependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto publicDependency.
                 * @member {Array.<number>} publicDependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.publicDependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto weakDependency.
                 * @member {Array.<number>} weakDependency
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.weakDependency = $util.emptyArray;
    
                /**
                 * FileDescriptorProto messageType.
                 * @member {Array.<google.protobuf.IDescriptorProto>} messageType
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.messageType = $util.emptyArray;
    
                /**
                 * FileDescriptorProto enumType.
                 * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.enumType = $util.emptyArray;
    
                /**
                 * FileDescriptorProto service.
                 * @member {Array.<google.protobuf.IServiceDescriptorProto>} service
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.service = $util.emptyArray;
    
                /**
                 * FileDescriptorProto extension.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.extension = $util.emptyArray;
    
                /**
                 * FileDescriptorProto options.
                 * @member {google.protobuf.IFileOptions|null|undefined} options
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.options = null;
    
                /**
                 * FileDescriptorProto sourceCodeInfo.
                 * @member {google.protobuf.ISourceCodeInfo|null|undefined} sourceCodeInfo
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.sourceCodeInfo = null;
    
                /**
                 * FileDescriptorProto syntax.
                 * @member {string} syntax
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 */
                FileDescriptorProto.prototype.syntax = "";
    
                /**
                 * Creates a new FileDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto instance
                 */
                FileDescriptorProto.create = function create(properties) {
                    return new FileDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified FileDescriptorProto message. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message["package"] != null && Object.hasOwnProperty.call(message, "package"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message["package"]);
                    if (message.dependency != null && message.dependency.length)
                        for (var i = 0; i < message.dependency.length; ++i)
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.dependency[i]);
                    if (message.messageType != null && message.messageType.length)
                        for (var i = 0; i < message.messageType.length; ++i)
                            $root.google.protobuf.DescriptorProto.encode(message.messageType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.enumType != null && message.enumType.length)
                        for (var i = 0; i < message.enumType.length; ++i)
                            $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.service != null && message.service.length)
                        for (var i = 0; i < message.service.length; ++i)
                            $root.google.protobuf.ServiceDescriptorProto.encode(message.service[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.extension != null && message.extension.length)
                        for (var i = 0; i < message.extension.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.FileOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.sourceCodeInfo != null && Object.hasOwnProperty.call(message, "sourceCodeInfo"))
                        $root.google.protobuf.SourceCodeInfo.encode(message.sourceCodeInfo, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.publicDependency != null && message.publicDependency.length)
                        for (var i = 0; i < message.publicDependency.length; ++i)
                            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.publicDependency[i]);
                    if (message.weakDependency != null && message.weakDependency.length)
                        for (var i = 0; i < message.weakDependency.length; ++i)
                            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.weakDependency[i]);
                    if (message.syntax != null && Object.hasOwnProperty.call(message, "syntax"))
                        writer.uint32(/* id 12, wireType 2 =*/98).string(message.syntax);
                    return writer;
                };
    
                /**
                 * Encodes the specified FileDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FileDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.IFileDescriptorProto} message FileDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message["package"] = reader.string();
                            break;
                        case 3:
                            if (!(message.dependency && message.dependency.length))
                                message.dependency = [];
                            message.dependency.push(reader.string());
                            break;
                        case 10:
                            if (!(message.publicDependency && message.publicDependency.length))
                                message.publicDependency = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.publicDependency.push(reader.int32());
                            } else
                                message.publicDependency.push(reader.int32());
                            break;
                        case 11:
                            if (!(message.weakDependency && message.weakDependency.length))
                                message.weakDependency = [];
                            if ((tag & 7) === 2) {
                                var end2 = reader.uint32() + reader.pos;
                                while (reader.pos < end2)
                                    message.weakDependency.push(reader.int32());
                            } else
                                message.weakDependency.push(reader.int32());
                            break;
                        case 4:
                            if (!(message.messageType && message.messageType.length))
                                message.messageType = [];
                            message.messageType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.enumType && message.enumType.length))
                                message.enumType = [];
                            message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            if (!(message.service && message.service.length))
                                message.service = [];
                            message.service.push($root.google.protobuf.ServiceDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            if (!(message.extension && message.extension.length))
                                message.extension = [];
                            message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            message.options = $root.google.protobuf.FileOptions.decode(reader, reader.uint32());
                            break;
                        case 9:
                            message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.decode(reader, reader.uint32());
                            break;
                        case 12:
                            message.syntax = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message["package"] != null && message.hasOwnProperty("package"))
                        if (!$util.isString(message["package"]))
                            return "package: string expected";
                    if (message.dependency != null && message.hasOwnProperty("dependency")) {
                        if (!Array.isArray(message.dependency))
                            return "dependency: array expected";
                        for (var i = 0; i < message.dependency.length; ++i)
                            if (!$util.isString(message.dependency[i]))
                                return "dependency: string[] expected";
                    }
                    if (message.publicDependency != null && message.hasOwnProperty("publicDependency")) {
                        if (!Array.isArray(message.publicDependency))
                            return "publicDependency: array expected";
                        for (var i = 0; i < message.publicDependency.length; ++i)
                            if (!$util.isInteger(message.publicDependency[i]))
                                return "publicDependency: integer[] expected";
                    }
                    if (message.weakDependency != null && message.hasOwnProperty("weakDependency")) {
                        if (!Array.isArray(message.weakDependency))
                            return "weakDependency: array expected";
                        for (var i = 0; i < message.weakDependency.length; ++i)
                            if (!$util.isInteger(message.weakDependency[i]))
                                return "weakDependency: integer[] expected";
                    }
                    if (message.messageType != null && message.hasOwnProperty("messageType")) {
                        if (!Array.isArray(message.messageType))
                            return "messageType: array expected";
                        for (var i = 0; i < message.messageType.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.verify(message.messageType[i]);
                            if (error)
                                return "messageType." + error;
                        }
                    }
                    if (message.enumType != null && message.hasOwnProperty("enumType")) {
                        if (!Array.isArray(message.enumType))
                            return "enumType: array expected";
                        for (var i = 0; i < message.enumType.length; ++i) {
                            var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                            if (error)
                                return "enumType." + error;
                        }
                    }
                    if (message.service != null && message.hasOwnProperty("service")) {
                        if (!Array.isArray(message.service))
                            return "service: array expected";
                        for (var i = 0; i < message.service.length; ++i) {
                            var error = $root.google.protobuf.ServiceDescriptorProto.verify(message.service[i]);
                            if (error)
                                return "service." + error;
                        }
                    }
                    if (message.extension != null && message.hasOwnProperty("extension")) {
                        if (!Array.isArray(message.extension))
                            return "extension: array expected";
                        for (var i = 0; i < message.extension.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                            if (error)
                                return "extension." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.FileOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo")) {
                        var error = $root.google.protobuf.SourceCodeInfo.verify(message.sourceCodeInfo);
                        if (error)
                            return "sourceCodeInfo." + error;
                    }
                    if (message.syntax != null && message.hasOwnProperty("syntax"))
                        if (!$util.isString(message.syntax))
                            return "syntax: string expected";
                    return null;
                };
    
                /**
                 * Creates a FileDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileDescriptorProto} FileDescriptorProto
                 */
                FileDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.FileDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object["package"] != null)
                        message["package"] = String(object["package"]);
                    if (object.dependency) {
                        if (!Array.isArray(object.dependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.dependency: array expected");
                        message.dependency = [];
                        for (var i = 0; i < object.dependency.length; ++i)
                            message.dependency[i] = String(object.dependency[i]);
                    }
                    if (object.publicDependency) {
                        if (!Array.isArray(object.publicDependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.publicDependency: array expected");
                        message.publicDependency = [];
                        for (var i = 0; i < object.publicDependency.length; ++i)
                            message.publicDependency[i] = object.publicDependency[i] | 0;
                    }
                    if (object.weakDependency) {
                        if (!Array.isArray(object.weakDependency))
                            throw TypeError(".google.protobuf.FileDescriptorProto.weakDependency: array expected");
                        message.weakDependency = [];
                        for (var i = 0; i < object.weakDependency.length; ++i)
                            message.weakDependency[i] = object.weakDependency[i] | 0;
                    }
                    if (object.messageType) {
                        if (!Array.isArray(object.messageType))
                            throw TypeError(".google.protobuf.FileDescriptorProto.messageType: array expected");
                        message.messageType = [];
                        for (var i = 0; i < object.messageType.length; ++i) {
                            if (typeof object.messageType[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.messageType: object expected");
                            message.messageType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.messageType[i]);
                        }
                    }
                    if (object.enumType) {
                        if (!Array.isArray(object.enumType))
                            throw TypeError(".google.protobuf.FileDescriptorProto.enumType: array expected");
                        message.enumType = [];
                        for (var i = 0; i < object.enumType.length; ++i) {
                            if (typeof object.enumType[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.enumType: object expected");
                            message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                        }
                    }
                    if (object.service) {
                        if (!Array.isArray(object.service))
                            throw TypeError(".google.protobuf.FileDescriptorProto.service: array expected");
                        message.service = [];
                        for (var i = 0; i < object.service.length; ++i) {
                            if (typeof object.service[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.service: object expected");
                            message.service[i] = $root.google.protobuf.ServiceDescriptorProto.fromObject(object.service[i]);
                        }
                    }
                    if (object.extension) {
                        if (!Array.isArray(object.extension))
                            throw TypeError(".google.protobuf.FileDescriptorProto.extension: array expected");
                        message.extension = [];
                        for (var i = 0; i < object.extension.length; ++i) {
                            if (typeof object.extension[i] !== "object")
                                throw TypeError(".google.protobuf.FileDescriptorProto.extension: object expected");
                            message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.FileOptions.fromObject(object.options);
                    }
                    if (object.sourceCodeInfo != null) {
                        if (typeof object.sourceCodeInfo !== "object")
                            throw TypeError(".google.protobuf.FileDescriptorProto.sourceCodeInfo: object expected");
                        message.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.fromObject(object.sourceCodeInfo);
                    }
                    if (object.syntax != null)
                        message.syntax = String(object.syntax);
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileDescriptorProto
                 * @static
                 * @param {google.protobuf.FileDescriptorProto} message FileDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.dependency = [];
                        object.messageType = [];
                        object.enumType = [];
                        object.service = [];
                        object.extension = [];
                        object.publicDependency = [];
                        object.weakDependency = [];
                    }
                    if (options.defaults) {
                        object.name = "";
                        object["package"] = "";
                        object.options = null;
                        object.sourceCodeInfo = null;
                        object.syntax = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message["package"] != null && message.hasOwnProperty("package"))
                        object["package"] = message["package"];
                    if (message.dependency && message.dependency.length) {
                        object.dependency = [];
                        for (var j = 0; j < message.dependency.length; ++j)
                            object.dependency[j] = message.dependency[j];
                    }
                    if (message.messageType && message.messageType.length) {
                        object.messageType = [];
                        for (var j = 0; j < message.messageType.length; ++j)
                            object.messageType[j] = $root.google.protobuf.DescriptorProto.toObject(message.messageType[j], options);
                    }
                    if (message.enumType && message.enumType.length) {
                        object.enumType = [];
                        for (var j = 0; j < message.enumType.length; ++j)
                            object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                    }
                    if (message.service && message.service.length) {
                        object.service = [];
                        for (var j = 0; j < message.service.length; ++j)
                            object.service[j] = $root.google.protobuf.ServiceDescriptorProto.toObject(message.service[j], options);
                    }
                    if (message.extension && message.extension.length) {
                        object.extension = [];
                        for (var j = 0; j < message.extension.length; ++j)
                            object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.FileOptions.toObject(message.options, options);
                    if (message.sourceCodeInfo != null && message.hasOwnProperty("sourceCodeInfo"))
                        object.sourceCodeInfo = $root.google.protobuf.SourceCodeInfo.toObject(message.sourceCodeInfo, options);
                    if (message.publicDependency && message.publicDependency.length) {
                        object.publicDependency = [];
                        for (var j = 0; j < message.publicDependency.length; ++j)
                            object.publicDependency[j] = message.publicDependency[j];
                    }
                    if (message.weakDependency && message.weakDependency.length) {
                        object.weakDependency = [];
                        for (var j = 0; j < message.weakDependency.length; ++j)
                            object.weakDependency[j] = message.weakDependency[j];
                    }
                    if (message.syntax != null && message.hasOwnProperty("syntax"))
                        object.syntax = message.syntax;
                    return object;
                };
    
                /**
                 * Converts this FileDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FileDescriptorProto;
            })();
    
            protobuf.DescriptorProto = (function() {
    
                /**
                 * Properties of a DescriptorProto.
                 * @memberof google.protobuf
                 * @interface IDescriptorProto
                 * @property {string|null} [name] DescriptorProto name
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [field] DescriptorProto field
                 * @property {Array.<google.protobuf.IFieldDescriptorProto>|null} [extension] DescriptorProto extension
                 * @property {Array.<google.protobuf.IDescriptorProto>|null} [nestedType] DescriptorProto nestedType
                 * @property {Array.<google.protobuf.IEnumDescriptorProto>|null} [enumType] DescriptorProto enumType
                 * @property {Array.<google.protobuf.DescriptorProto.IExtensionRange>|null} [extensionRange] DescriptorProto extensionRange
                 * @property {Array.<google.protobuf.IOneofDescriptorProto>|null} [oneofDecl] DescriptorProto oneofDecl
                 * @property {google.protobuf.IMessageOptions|null} [options] DescriptorProto options
                 * @property {Array.<google.protobuf.DescriptorProto.IReservedRange>|null} [reservedRange] DescriptorProto reservedRange
                 * @property {Array.<string>|null} [reservedName] DescriptorProto reservedName
                 */
    
                /**
                 * Constructs a new DescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a DescriptorProto.
                 * @implements IDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
                 */
                function DescriptorProto(properties) {
                    this.field = [];
                    this.extension = [];
                    this.nestedType = [];
                    this.enumType = [];
                    this.extensionRange = [];
                    this.oneofDecl = [];
                    this.reservedRange = [];
                    this.reservedName = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * DescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.name = "";
    
                /**
                 * DescriptorProto field.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} field
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.field = $util.emptyArray;
    
                /**
                 * DescriptorProto extension.
                 * @member {Array.<google.protobuf.IFieldDescriptorProto>} extension
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.extension = $util.emptyArray;
    
                /**
                 * DescriptorProto nestedType.
                 * @member {Array.<google.protobuf.IDescriptorProto>} nestedType
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.nestedType = $util.emptyArray;
    
                /**
                 * DescriptorProto enumType.
                 * @member {Array.<google.protobuf.IEnumDescriptorProto>} enumType
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.enumType = $util.emptyArray;
    
                /**
                 * DescriptorProto extensionRange.
                 * @member {Array.<google.protobuf.DescriptorProto.IExtensionRange>} extensionRange
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.extensionRange = $util.emptyArray;
    
                /**
                 * DescriptorProto oneofDecl.
                 * @member {Array.<google.protobuf.IOneofDescriptorProto>} oneofDecl
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.oneofDecl = $util.emptyArray;
    
                /**
                 * DescriptorProto options.
                 * @member {google.protobuf.IMessageOptions|null|undefined} options
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.options = null;
    
                /**
                 * DescriptorProto reservedRange.
                 * @member {Array.<google.protobuf.DescriptorProto.IReservedRange>} reservedRange
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.reservedRange = $util.emptyArray;
    
                /**
                 * DescriptorProto reservedName.
                 * @member {Array.<string>} reservedName
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 */
                DescriptorProto.prototype.reservedName = $util.emptyArray;
    
                /**
                 * Creates a new DescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto instance
                 */
                DescriptorProto.create = function create(properties) {
                    return new DescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified DescriptorProto message. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.field != null && message.field.length)
                        for (var i = 0; i < message.field.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.field[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.nestedType != null && message.nestedType.length)
                        for (var i = 0; i < message.nestedType.length; ++i)
                            $root.google.protobuf.DescriptorProto.encode(message.nestedType[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    if (message.enumType != null && message.enumType.length)
                        for (var i = 0; i < message.enumType.length; ++i)
                            $root.google.protobuf.EnumDescriptorProto.encode(message.enumType[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.extensionRange != null && message.extensionRange.length)
                        for (var i = 0; i < message.extensionRange.length; ++i)
                            $root.google.protobuf.DescriptorProto.ExtensionRange.encode(message.extensionRange[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
                    if (message.extension != null && message.extension.length)
                        for (var i = 0; i < message.extension.length; ++i)
                            $root.google.protobuf.FieldDescriptorProto.encode(message.extension[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.MessageOptions.encode(message.options, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
                    if (message.oneofDecl != null && message.oneofDecl.length)
                        for (var i = 0; i < message.oneofDecl.length; ++i)
                            $root.google.protobuf.OneofDescriptorProto.encode(message.oneofDecl[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.reservedRange != null && message.reservedRange.length)
                        for (var i = 0; i < message.reservedRange.length; ++i)
                            $root.google.protobuf.DescriptorProto.ReservedRange.encode(message.reservedRange[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
                    if (message.reservedName != null && message.reservedName.length)
                        for (var i = 0; i < message.reservedName.length; ++i)
                            writer.uint32(/* id 10, wireType 2 =*/82).string(message.reservedName[i]);
                    return writer;
                };
    
                /**
                 * Encodes the specified DescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.IDescriptorProto} message DescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a DescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.field && message.field.length))
                                message.field = [];
                            message.field.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 6:
                            if (!(message.extension && message.extension.length))
                                message.extension = [];
                            message.extension.push($root.google.protobuf.FieldDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            if (!(message.nestedType && message.nestedType.length))
                                message.nestedType = [];
                            message.nestedType.push($root.google.protobuf.DescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 4:
                            if (!(message.enumType && message.enumType.length))
                                message.enumType = [];
                            message.enumType.push($root.google.protobuf.EnumDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 5:
                            if (!(message.extensionRange && message.extensionRange.length))
                                message.extensionRange = [];
                            message.extensionRange.push($root.google.protobuf.DescriptorProto.ExtensionRange.decode(reader, reader.uint32()));
                            break;
                        case 8:
                            if (!(message.oneofDecl && message.oneofDecl.length))
                                message.oneofDecl = [];
                            message.oneofDecl.push($root.google.protobuf.OneofDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 7:
                            message.options = $root.google.protobuf.MessageOptions.decode(reader, reader.uint32());
                            break;
                        case 9:
                            if (!(message.reservedRange && message.reservedRange.length))
                                message.reservedRange = [];
                            message.reservedRange.push($root.google.protobuf.DescriptorProto.ReservedRange.decode(reader, reader.uint32()));
                            break;
                        case 10:
                            if (!(message.reservedName && message.reservedName.length))
                                message.reservedName = [];
                            message.reservedName.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a DescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a DescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.field != null && message.hasOwnProperty("field")) {
                        if (!Array.isArray(message.field))
                            return "field: array expected";
                        for (var i = 0; i < message.field.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.field[i]);
                            if (error)
                                return "field." + error;
                        }
                    }
                    if (message.extension != null && message.hasOwnProperty("extension")) {
                        if (!Array.isArray(message.extension))
                            return "extension: array expected";
                        for (var i = 0; i < message.extension.length; ++i) {
                            var error = $root.google.protobuf.FieldDescriptorProto.verify(message.extension[i]);
                            if (error)
                                return "extension." + error;
                        }
                    }
                    if (message.nestedType != null && message.hasOwnProperty("nestedType")) {
                        if (!Array.isArray(message.nestedType))
                            return "nestedType: array expected";
                        for (var i = 0; i < message.nestedType.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.verify(message.nestedType[i]);
                            if (error)
                                return "nestedType." + error;
                        }
                    }
                    if (message.enumType != null && message.hasOwnProperty("enumType")) {
                        if (!Array.isArray(message.enumType))
                            return "enumType: array expected";
                        for (var i = 0; i < message.enumType.length; ++i) {
                            var error = $root.google.protobuf.EnumDescriptorProto.verify(message.enumType[i]);
                            if (error)
                                return "enumType." + error;
                        }
                    }
                    if (message.extensionRange != null && message.hasOwnProperty("extensionRange")) {
                        if (!Array.isArray(message.extensionRange))
                            return "extensionRange: array expected";
                        for (var i = 0; i < message.extensionRange.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.ExtensionRange.verify(message.extensionRange[i]);
                            if (error)
                                return "extensionRange." + error;
                        }
                    }
                    if (message.oneofDecl != null && message.hasOwnProperty("oneofDecl")) {
                        if (!Array.isArray(message.oneofDecl))
                            return "oneofDecl: array expected";
                        for (var i = 0; i < message.oneofDecl.length; ++i) {
                            var error = $root.google.protobuf.OneofDescriptorProto.verify(message.oneofDecl[i]);
                            if (error)
                                return "oneofDecl." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.MessageOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.reservedRange != null && message.hasOwnProperty("reservedRange")) {
                        if (!Array.isArray(message.reservedRange))
                            return "reservedRange: array expected";
                        for (var i = 0; i < message.reservedRange.length; ++i) {
                            var error = $root.google.protobuf.DescriptorProto.ReservedRange.verify(message.reservedRange[i]);
                            if (error)
                                return "reservedRange." + error;
                        }
                    }
                    if (message.reservedName != null && message.hasOwnProperty("reservedName")) {
                        if (!Array.isArray(message.reservedName))
                            return "reservedName: array expected";
                        for (var i = 0; i < message.reservedName.length; ++i)
                            if (!$util.isString(message.reservedName[i]))
                                return "reservedName: string[] expected";
                    }
                    return null;
                };
    
                /**
                 * Creates a DescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.DescriptorProto} DescriptorProto
                 */
                DescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.DescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.field) {
                        if (!Array.isArray(object.field))
                            throw TypeError(".google.protobuf.DescriptorProto.field: array expected");
                        message.field = [];
                        for (var i = 0; i < object.field.length; ++i) {
                            if (typeof object.field[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.field: object expected");
                            message.field[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.field[i]);
                        }
                    }
                    if (object.extension) {
                        if (!Array.isArray(object.extension))
                            throw TypeError(".google.protobuf.DescriptorProto.extension: array expected");
                        message.extension = [];
                        for (var i = 0; i < object.extension.length; ++i) {
                            if (typeof object.extension[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.extension: object expected");
                            message.extension[i] = $root.google.protobuf.FieldDescriptorProto.fromObject(object.extension[i]);
                        }
                    }
                    if (object.nestedType) {
                        if (!Array.isArray(object.nestedType))
                            throw TypeError(".google.protobuf.DescriptorProto.nestedType: array expected");
                        message.nestedType = [];
                        for (var i = 0; i < object.nestedType.length; ++i) {
                            if (typeof object.nestedType[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.nestedType: object expected");
                            message.nestedType[i] = $root.google.protobuf.DescriptorProto.fromObject(object.nestedType[i]);
                        }
                    }
                    if (object.enumType) {
                        if (!Array.isArray(object.enumType))
                            throw TypeError(".google.protobuf.DescriptorProto.enumType: array expected");
                        message.enumType = [];
                        for (var i = 0; i < object.enumType.length; ++i) {
                            if (typeof object.enumType[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.enumType: object expected");
                            message.enumType[i] = $root.google.protobuf.EnumDescriptorProto.fromObject(object.enumType[i]);
                        }
                    }
                    if (object.extensionRange) {
                        if (!Array.isArray(object.extensionRange))
                            throw TypeError(".google.protobuf.DescriptorProto.extensionRange: array expected");
                        message.extensionRange = [];
                        for (var i = 0; i < object.extensionRange.length; ++i) {
                            if (typeof object.extensionRange[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.extensionRange: object expected");
                            message.extensionRange[i] = $root.google.protobuf.DescriptorProto.ExtensionRange.fromObject(object.extensionRange[i]);
                        }
                    }
                    if (object.oneofDecl) {
                        if (!Array.isArray(object.oneofDecl))
                            throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: array expected");
                        message.oneofDecl = [];
                        for (var i = 0; i < object.oneofDecl.length; ++i) {
                            if (typeof object.oneofDecl[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.oneofDecl: object expected");
                            message.oneofDecl[i] = $root.google.protobuf.OneofDescriptorProto.fromObject(object.oneofDecl[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.DescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.MessageOptions.fromObject(object.options);
                    }
                    if (object.reservedRange) {
                        if (!Array.isArray(object.reservedRange))
                            throw TypeError(".google.protobuf.DescriptorProto.reservedRange: array expected");
                        message.reservedRange = [];
                        for (var i = 0; i < object.reservedRange.length; ++i) {
                            if (typeof object.reservedRange[i] !== "object")
                                throw TypeError(".google.protobuf.DescriptorProto.reservedRange: object expected");
                            message.reservedRange[i] = $root.google.protobuf.DescriptorProto.ReservedRange.fromObject(object.reservedRange[i]);
                        }
                    }
                    if (object.reservedName) {
                        if (!Array.isArray(object.reservedName))
                            throw TypeError(".google.protobuf.DescriptorProto.reservedName: array expected");
                        message.reservedName = [];
                        for (var i = 0; i < object.reservedName.length; ++i)
                            message.reservedName[i] = String(object.reservedName[i]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a DescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.DescriptorProto
                 * @static
                 * @param {google.protobuf.DescriptorProto} message DescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults) {
                        object.field = [];
                        object.nestedType = [];
                        object.enumType = [];
                        object.extensionRange = [];
                        object.extension = [];
                        object.oneofDecl = [];
                        object.reservedRange = [];
                        object.reservedName = [];
                    }
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.field && message.field.length) {
                        object.field = [];
                        for (var j = 0; j < message.field.length; ++j)
                            object.field[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.field[j], options);
                    }
                    if (message.nestedType && message.nestedType.length) {
                        object.nestedType = [];
                        for (var j = 0; j < message.nestedType.length; ++j)
                            object.nestedType[j] = $root.google.protobuf.DescriptorProto.toObject(message.nestedType[j], options);
                    }
                    if (message.enumType && message.enumType.length) {
                        object.enumType = [];
                        for (var j = 0; j < message.enumType.length; ++j)
                            object.enumType[j] = $root.google.protobuf.EnumDescriptorProto.toObject(message.enumType[j], options);
                    }
                    if (message.extensionRange && message.extensionRange.length) {
                        object.extensionRange = [];
                        for (var j = 0; j < message.extensionRange.length; ++j)
                            object.extensionRange[j] = $root.google.protobuf.DescriptorProto.ExtensionRange.toObject(message.extensionRange[j], options);
                    }
                    if (message.extension && message.extension.length) {
                        object.extension = [];
                        for (var j = 0; j < message.extension.length; ++j)
                            object.extension[j] = $root.google.protobuf.FieldDescriptorProto.toObject(message.extension[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.MessageOptions.toObject(message.options, options);
                    if (message.oneofDecl && message.oneofDecl.length) {
                        object.oneofDecl = [];
                        for (var j = 0; j < message.oneofDecl.length; ++j)
                            object.oneofDecl[j] = $root.google.protobuf.OneofDescriptorProto.toObject(message.oneofDecl[j], options);
                    }
                    if (message.reservedRange && message.reservedRange.length) {
                        object.reservedRange = [];
                        for (var j = 0; j < message.reservedRange.length; ++j)
                            object.reservedRange[j] = $root.google.protobuf.DescriptorProto.ReservedRange.toObject(message.reservedRange[j], options);
                    }
                    if (message.reservedName && message.reservedName.length) {
                        object.reservedName = [];
                        for (var j = 0; j < message.reservedName.length; ++j)
                            object.reservedName[j] = message.reservedName[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this DescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.DescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                DescriptorProto.ExtensionRange = (function() {
    
                    /**
                     * Properties of an ExtensionRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @interface IExtensionRange
                     * @property {number|null} [start] ExtensionRange start
                     * @property {number|null} [end] ExtensionRange end
                     */
    
                    /**
                     * Constructs a new ExtensionRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @classdesc Represents an ExtensionRange.
                     * @implements IExtensionRange
                     * @constructor
                     * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                     */
                    function ExtensionRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ExtensionRange start.
                     * @member {number} start
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     */
                    ExtensionRange.prototype.start = 0;
    
                    /**
                     * ExtensionRange end.
                     * @member {number} end
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     */
                    ExtensionRange.prototype.end = 0;
    
                    /**
                     * Creates a new ExtensionRange instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange=} [properties] Properties to set
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange instance
                     */
                    ExtensionRange.create = function create(properties) {
                        return new ExtensionRange(properties);
                    };
    
                    /**
                     * Encodes the specified ExtensionRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtensionRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ExtensionRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ExtensionRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IExtensionRange} message ExtensionRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ExtensionRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an ExtensionRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtensionRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.int32();
                                break;
                            case 2:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an ExtensionRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ExtensionRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an ExtensionRange message.
                     * @function verify
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ExtensionRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isInteger(message.start))
                                return "start: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an ExtensionRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.DescriptorProto.ExtensionRange} ExtensionRange
                     */
                    ExtensionRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.DescriptorProto.ExtensionRange)
                            return object;
                        var message = new $root.google.protobuf.DescriptorProto.ExtensionRange();
                        if (object.start != null)
                            message.start = object.start | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an ExtensionRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.ExtensionRange} message ExtensionRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ExtensionRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = 0;
                            object.end = 0;
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this ExtensionRange to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.DescriptorProto.ExtensionRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ExtensionRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ExtensionRange;
                })();
    
                DescriptorProto.ReservedRange = (function() {
    
                    /**
                     * Properties of a ReservedRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @interface IReservedRange
                     * @property {number|null} [start] ReservedRange start
                     * @property {number|null} [end] ReservedRange end
                     */
    
                    /**
                     * Constructs a new ReservedRange.
                     * @memberof google.protobuf.DescriptorProto
                     * @classdesc Represents a ReservedRange.
                     * @implements IReservedRange
                     * @constructor
                     * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                     */
                    function ReservedRange(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * ReservedRange start.
                     * @member {number} start
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     */
                    ReservedRange.prototype.start = 0;
    
                    /**
                     * ReservedRange end.
                     * @member {number} end
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     */
                    ReservedRange.prototype.end = 0;
    
                    /**
                     * Creates a new ReservedRange instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange=} [properties] Properties to set
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange instance
                     */
                    ReservedRange.create = function create(properties) {
                        return new ReservedRange(properties);
                    };
    
                    /**
                     * Encodes the specified ReservedRange message. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReservedRange.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.start != null && Object.hasOwnProperty.call(message, "start"))
                            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.start);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified ReservedRange message, length delimited. Does not implicitly {@link google.protobuf.DescriptorProto.ReservedRange.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.IReservedRange} message ReservedRange message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    ReservedRange.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a ReservedRange message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReservedRange.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.start = reader.int32();
                                break;
                            case 2:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a ReservedRange message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    ReservedRange.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a ReservedRange message.
                     * @function verify
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    ReservedRange.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.start != null && message.hasOwnProperty("start"))
                            if (!$util.isInteger(message.start))
                                return "start: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates a ReservedRange message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.DescriptorProto.ReservedRange} ReservedRange
                     */
                    ReservedRange.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.DescriptorProto.ReservedRange)
                            return object;
                        var message = new $root.google.protobuf.DescriptorProto.ReservedRange();
                        if (object.start != null)
                            message.start = object.start | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a ReservedRange message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @static
                     * @param {google.protobuf.DescriptorProto.ReservedRange} message ReservedRange
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    ReservedRange.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.start = 0;
                            object.end = 0;
                        }
                        if (message.start != null && message.hasOwnProperty("start"))
                            object.start = message.start;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this ReservedRange to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.DescriptorProto.ReservedRange
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    ReservedRange.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return ReservedRange;
                })();
    
                return DescriptorProto;
            })();
    
            protobuf.FieldDescriptorProto = (function() {
    
                /**
                 * Properties of a FieldDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IFieldDescriptorProto
                 * @property {string|null} [name] FieldDescriptorProto name
                 * @property {number|null} [number] FieldDescriptorProto number
                 * @property {google.protobuf.FieldDescriptorProto.Label|null} [label] FieldDescriptorProto label
                 * @property {google.protobuf.FieldDescriptorProto.Type|null} [type] FieldDescriptorProto type
                 * @property {string|null} [typeName] FieldDescriptorProto typeName
                 * @property {string|null} [extendee] FieldDescriptorProto extendee
                 * @property {string|null} [defaultValue] FieldDescriptorProto defaultValue
                 * @property {number|null} [oneofIndex] FieldDescriptorProto oneofIndex
                 * @property {string|null} [jsonName] FieldDescriptorProto jsonName
                 * @property {google.protobuf.IFieldOptions|null} [options] FieldDescriptorProto options
                 */
    
                /**
                 * Constructs a new FieldDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a FieldDescriptorProto.
                 * @implements IFieldDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
                 */
                function FieldDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FieldDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.name = "";
    
                /**
                 * FieldDescriptorProto number.
                 * @member {number} number
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.number = 0;
    
                /**
                 * FieldDescriptorProto label.
                 * @member {google.protobuf.FieldDescriptorProto.Label} label
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.label = 1;
    
                /**
                 * FieldDescriptorProto type.
                 * @member {google.protobuf.FieldDescriptorProto.Type} type
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.type = 1;
    
                /**
                 * FieldDescriptorProto typeName.
                 * @member {string} typeName
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.typeName = "";
    
                /**
                 * FieldDescriptorProto extendee.
                 * @member {string} extendee
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.extendee = "";
    
                /**
                 * FieldDescriptorProto defaultValue.
                 * @member {string} defaultValue
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.defaultValue = "";
    
                /**
                 * FieldDescriptorProto oneofIndex.
                 * @member {number} oneofIndex
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.oneofIndex = 0;
    
                /**
                 * FieldDescriptorProto jsonName.
                 * @member {string} jsonName
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.jsonName = "";
    
                /**
                 * FieldDescriptorProto options.
                 * @member {google.protobuf.IFieldOptions|null|undefined} options
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 */
                FieldDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new FieldDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto instance
                 */
                FieldDescriptorProto.create = function create(properties) {
                    return new FieldDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified FieldDescriptorProto message. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.extendee != null && Object.hasOwnProperty.call(message, "extendee"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.extendee);
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 3, wireType 0 =*/24).int32(message.number);
                    if (message.label != null && Object.hasOwnProperty.call(message, "label"))
                        writer.uint32(/* id 4, wireType 0 =*/32).int32(message.label);
                    if (message.type != null && Object.hasOwnProperty.call(message, "type"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int32(message.type);
                    if (message.typeName != null && Object.hasOwnProperty.call(message, "typeName"))
                        writer.uint32(/* id 6, wireType 2 =*/50).string(message.typeName);
                    if (message.defaultValue != null && Object.hasOwnProperty.call(message, "defaultValue"))
                        writer.uint32(/* id 7, wireType 2 =*/58).string(message.defaultValue);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.FieldOptions.encode(message.options, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
                    if (message.oneofIndex != null && Object.hasOwnProperty.call(message, "oneofIndex"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.oneofIndex);
                    if (message.jsonName != null && Object.hasOwnProperty.call(message, "jsonName"))
                        writer.uint32(/* id 10, wireType 2 =*/82).string(message.jsonName);
                    return writer;
                };
    
                /**
                 * Encodes the specified FieldDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.FieldDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.IFieldDescriptorProto} message FieldDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FieldDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 3:
                            message.number = reader.int32();
                            break;
                        case 4:
                            message.label = reader.int32();
                            break;
                        case 5:
                            message.type = reader.int32();
                            break;
                        case 6:
                            message.typeName = reader.string();
                            break;
                        case 2:
                            message.extendee = reader.string();
                            break;
                        case 7:
                            message.defaultValue = reader.string();
                            break;
                        case 9:
                            message.oneofIndex = reader.int32();
                            break;
                        case 10:
                            message.jsonName = reader.string();
                            break;
                        case 8:
                            message.options = $root.google.protobuf.FieldOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FieldDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FieldDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isInteger(message.number))
                            return "number: integer expected";
                    if (message.label != null && message.hasOwnProperty("label"))
                        switch (message.label) {
                        default:
                            return "label: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.type != null && message.hasOwnProperty("type"))
                        switch (message.type) {
                        default:
                            return "type: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                        case 4:
                        case 5:
                        case 6:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                        case 17:
                        case 18:
                            break;
                        }
                    if (message.typeName != null && message.hasOwnProperty("typeName"))
                        if (!$util.isString(message.typeName))
                            return "typeName: string expected";
                    if (message.extendee != null && message.hasOwnProperty("extendee"))
                        if (!$util.isString(message.extendee))
                            return "extendee: string expected";
                    if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                        if (!$util.isString(message.defaultValue))
                            return "defaultValue: string expected";
                    if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                        if (!$util.isInteger(message.oneofIndex))
                            return "oneofIndex: integer expected";
                    if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                        if (!$util.isString(message.jsonName))
                            return "jsonName: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.FieldOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a FieldDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FieldDescriptorProto} FieldDescriptorProto
                 */
                FieldDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FieldDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.FieldDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.number != null)
                        message.number = object.number | 0;
                    switch (object.label) {
                    case "LABEL_OPTIONAL":
                    case 1:
                        message.label = 1;
                        break;
                    case "LABEL_REQUIRED":
                    case 2:
                        message.label = 2;
                        break;
                    case "LABEL_REPEATED":
                    case 3:
                        message.label = 3;
                        break;
                    }
                    switch (object.type) {
                    case "TYPE_DOUBLE":
                    case 1:
                        message.type = 1;
                        break;
                    case "TYPE_FLOAT":
                    case 2:
                        message.type = 2;
                        break;
                    case "TYPE_INT64":
                    case 3:
                        message.type = 3;
                        break;
                    case "TYPE_UINT64":
                    case 4:
                        message.type = 4;
                        break;
                    case "TYPE_INT32":
                    case 5:
                        message.type = 5;
                        break;
                    case "TYPE_FIXED64":
                    case 6:
                        message.type = 6;
                        break;
                    case "TYPE_FIXED32":
                    case 7:
                        message.type = 7;
                        break;
                    case "TYPE_BOOL":
                    case 8:
                        message.type = 8;
                        break;
                    case "TYPE_STRING":
                    case 9:
                        message.type = 9;
                        break;
                    case "TYPE_GROUP":
                    case 10:
                        message.type = 10;
                        break;
                    case "TYPE_MESSAGE":
                    case 11:
                        message.type = 11;
                        break;
                    case "TYPE_BYTES":
                    case 12:
                        message.type = 12;
                        break;
                    case "TYPE_UINT32":
                    case 13:
                        message.type = 13;
                        break;
                    case "TYPE_ENUM":
                    case 14:
                        message.type = 14;
                        break;
                    case "TYPE_SFIXED32":
                    case 15:
                        message.type = 15;
                        break;
                    case "TYPE_SFIXED64":
                    case 16:
                        message.type = 16;
                        break;
                    case "TYPE_SINT32":
                    case 17:
                        message.type = 17;
                        break;
                    case "TYPE_SINT64":
                    case 18:
                        message.type = 18;
                        break;
                    }
                    if (object.typeName != null)
                        message.typeName = String(object.typeName);
                    if (object.extendee != null)
                        message.extendee = String(object.extendee);
                    if (object.defaultValue != null)
                        message.defaultValue = String(object.defaultValue);
                    if (object.oneofIndex != null)
                        message.oneofIndex = object.oneofIndex | 0;
                    if (object.jsonName != null)
                        message.jsonName = String(object.jsonName);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.FieldDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.FieldOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FieldDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @static
                 * @param {google.protobuf.FieldDescriptorProto} message FieldDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.extendee = "";
                        object.number = 0;
                        object.label = options.enums === String ? "LABEL_OPTIONAL" : 1;
                        object.type = options.enums === String ? "TYPE_DOUBLE" : 1;
                        object.typeName = "";
                        object.defaultValue = "";
                        object.options = null;
                        object.oneofIndex = 0;
                        object.jsonName = "";
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.extendee != null && message.hasOwnProperty("extendee"))
                        object.extendee = message.extendee;
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.label != null && message.hasOwnProperty("label"))
                        object.label = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Label[message.label] : message.label;
                    if (message.type != null && message.hasOwnProperty("type"))
                        object.type = options.enums === String ? $root.google.protobuf.FieldDescriptorProto.Type[message.type] : message.type;
                    if (message.typeName != null && message.hasOwnProperty("typeName"))
                        object.typeName = message.typeName;
                    if (message.defaultValue != null && message.hasOwnProperty("defaultValue"))
                        object.defaultValue = message.defaultValue;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.FieldOptions.toObject(message.options, options);
                    if (message.oneofIndex != null && message.hasOwnProperty("oneofIndex"))
                        object.oneofIndex = message.oneofIndex;
                    if (message.jsonName != null && message.hasOwnProperty("jsonName"))
                        object.jsonName = message.jsonName;
                    return object;
                };
    
                /**
                 * Converts this FieldDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FieldDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * Type enum.
                 * @name google.protobuf.FieldDescriptorProto.Type
                 * @enum {number}
                 * @property {number} TYPE_DOUBLE=1 TYPE_DOUBLE value
                 * @property {number} TYPE_FLOAT=2 TYPE_FLOAT value
                 * @property {number} TYPE_INT64=3 TYPE_INT64 value
                 * @property {number} TYPE_UINT64=4 TYPE_UINT64 value
                 * @property {number} TYPE_INT32=5 TYPE_INT32 value
                 * @property {number} TYPE_FIXED64=6 TYPE_FIXED64 value
                 * @property {number} TYPE_FIXED32=7 TYPE_FIXED32 value
                 * @property {number} TYPE_BOOL=8 TYPE_BOOL value
                 * @property {number} TYPE_STRING=9 TYPE_STRING value
                 * @property {number} TYPE_GROUP=10 TYPE_GROUP value
                 * @property {number} TYPE_MESSAGE=11 TYPE_MESSAGE value
                 * @property {number} TYPE_BYTES=12 TYPE_BYTES value
                 * @property {number} TYPE_UINT32=13 TYPE_UINT32 value
                 * @property {number} TYPE_ENUM=14 TYPE_ENUM value
                 * @property {number} TYPE_SFIXED32=15 TYPE_SFIXED32 value
                 * @property {number} TYPE_SFIXED64=16 TYPE_SFIXED64 value
                 * @property {number} TYPE_SINT32=17 TYPE_SINT32 value
                 * @property {number} TYPE_SINT64=18 TYPE_SINT64 value
                 */
                FieldDescriptorProto.Type = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "TYPE_DOUBLE"] = 1;
                    values[valuesById[2] = "TYPE_FLOAT"] = 2;
                    values[valuesById[3] = "TYPE_INT64"] = 3;
                    values[valuesById[4] = "TYPE_UINT64"] = 4;
                    values[valuesById[5] = "TYPE_INT32"] = 5;
                    values[valuesById[6] = "TYPE_FIXED64"] = 6;
                    values[valuesById[7] = "TYPE_FIXED32"] = 7;
                    values[valuesById[8] = "TYPE_BOOL"] = 8;
                    values[valuesById[9] = "TYPE_STRING"] = 9;
                    values[valuesById[10] = "TYPE_GROUP"] = 10;
                    values[valuesById[11] = "TYPE_MESSAGE"] = 11;
                    values[valuesById[12] = "TYPE_BYTES"] = 12;
                    values[valuesById[13] = "TYPE_UINT32"] = 13;
                    values[valuesById[14] = "TYPE_ENUM"] = 14;
                    values[valuesById[15] = "TYPE_SFIXED32"] = 15;
                    values[valuesById[16] = "TYPE_SFIXED64"] = 16;
                    values[valuesById[17] = "TYPE_SINT32"] = 17;
                    values[valuesById[18] = "TYPE_SINT64"] = 18;
                    return values;
                })();
    
                /**
                 * Label enum.
                 * @name google.protobuf.FieldDescriptorProto.Label
                 * @enum {number}
                 * @property {number} LABEL_OPTIONAL=1 LABEL_OPTIONAL value
                 * @property {number} LABEL_REQUIRED=2 LABEL_REQUIRED value
                 * @property {number} LABEL_REPEATED=3 LABEL_REPEATED value
                 */
                FieldDescriptorProto.Label = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "LABEL_OPTIONAL"] = 1;
                    values[valuesById[2] = "LABEL_REQUIRED"] = 2;
                    values[valuesById[3] = "LABEL_REPEATED"] = 3;
                    return values;
                })();
    
                return FieldDescriptorProto;
            })();
    
            protobuf.OneofDescriptorProto = (function() {
    
                /**
                 * Properties of an OneofDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IOneofDescriptorProto
                 * @property {string|null} [name] OneofDescriptorProto name
                 * @property {google.protobuf.IOneofOptions|null} [options] OneofDescriptorProto options
                 */
    
                /**
                 * Constructs a new OneofDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an OneofDescriptorProto.
                 * @implements IOneofDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
                 */
                function OneofDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * OneofDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 */
                OneofDescriptorProto.prototype.name = "";
    
                /**
                 * OneofDescriptorProto options.
                 * @member {google.protobuf.IOneofOptions|null|undefined} options
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 */
                OneofDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new OneofDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto instance
                 */
                OneofDescriptorProto.create = function create(properties) {
                    return new OneofDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified OneofDescriptorProto message. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.OneofOptions.encode(message.options, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified OneofDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.OneofDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.IOneofDescriptorProto} message OneofDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an OneofDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.options = $root.google.protobuf.OneofOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an OneofDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an OneofDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OneofDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.OneofOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates an OneofDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.OneofDescriptorProto} OneofDescriptorProto
                 */
                OneofDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.OneofDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.OneofDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.OneofDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.OneofOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an OneofDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @static
                 * @param {google.protobuf.OneofDescriptorProto} message OneofDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OneofDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.OneofOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this OneofDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.OneofDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OneofDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return OneofDescriptorProto;
            })();
    
            protobuf.EnumDescriptorProto = (function() {
    
                /**
                 * Properties of an EnumDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IEnumDescriptorProto
                 * @property {string|null} [name] EnumDescriptorProto name
                 * @property {Array.<google.protobuf.IEnumValueDescriptorProto>|null} [value] EnumDescriptorProto value
                 * @property {google.protobuf.IEnumOptions|null} [options] EnumDescriptorProto options
                 */
    
                /**
                 * Constructs a new EnumDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumDescriptorProto.
                 * @implements IEnumDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
                 */
                function EnumDescriptorProto(properties) {
                    this.value = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.name = "";
    
                /**
                 * EnumDescriptorProto value.
                 * @member {Array.<google.protobuf.IEnumValueDescriptorProto>} value
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.value = $util.emptyArray;
    
                /**
                 * EnumDescriptorProto options.
                 * @member {google.protobuf.IEnumOptions|null|undefined} options
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 */
                EnumDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new EnumDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto instance
                 */
                EnumDescriptorProto.create = function create(properties) {
                    return new EnumDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified EnumDescriptorProto message. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.value != null && message.value.length)
                        for (var i = 0; i < message.value.length; ++i)
                            $root.google.protobuf.EnumValueDescriptorProto.encode(message.value[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.EnumOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumDescriptorProto} message EnumDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.value && message.value.length))
                                message.value = [];
                            message.value.push($root.google.protobuf.EnumValueDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.options = $root.google.protobuf.EnumOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.value != null && message.hasOwnProperty("value")) {
                        if (!Array.isArray(message.value))
                            return "value: array expected";
                        for (var i = 0; i < message.value.length; ++i) {
                            var error = $root.google.protobuf.EnumValueDescriptorProto.verify(message.value[i]);
                            if (error)
                                return "value." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.EnumOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumDescriptorProto} EnumDescriptorProto
                 */
                EnumDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.EnumDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.value) {
                        if (!Array.isArray(object.value))
                            throw TypeError(".google.protobuf.EnumDescriptorProto.value: array expected");
                        message.value = [];
                        for (var i = 0; i < object.value.length; ++i) {
                            if (typeof object.value[i] !== "object")
                                throw TypeError(".google.protobuf.EnumDescriptorProto.value: object expected");
                            message.value[i] = $root.google.protobuf.EnumValueDescriptorProto.fromObject(object.value[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.EnumDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.EnumOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @static
                 * @param {google.protobuf.EnumDescriptorProto} message EnumDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.value = [];
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.value && message.value.length) {
                        object.value = [];
                        for (var j = 0; j < message.value.length; ++j)
                            object.value[j] = $root.google.protobuf.EnumValueDescriptorProto.toObject(message.value[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.EnumOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this EnumDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumDescriptorProto;
            })();
    
            protobuf.EnumValueDescriptorProto = (function() {
    
                /**
                 * Properties of an EnumValueDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IEnumValueDescriptorProto
                 * @property {string|null} [name] EnumValueDescriptorProto name
                 * @property {number|null} [number] EnumValueDescriptorProto number
                 * @property {google.protobuf.IEnumValueOptions|null} [options] EnumValueDescriptorProto options
                 */
    
                /**
                 * Constructs a new EnumValueDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumValueDescriptorProto.
                 * @implements IEnumValueDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
                 */
                function EnumValueDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumValueDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.name = "";
    
                /**
                 * EnumValueDescriptorProto number.
                 * @member {number} number
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.number = 0;
    
                /**
                 * EnumValueDescriptorProto options.
                 * @member {google.protobuf.IEnumValueOptions|null|undefined} options
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 */
                EnumValueDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new EnumValueDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto instance
                 */
                EnumValueDescriptorProto.create = function create(properties) {
                    return new EnumValueDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified EnumValueDescriptorProto message. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.number != null && Object.hasOwnProperty.call(message, "number"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.number);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.EnumValueOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumValueDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.EnumValueDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.IEnumValueDescriptorProto} message EnumValueDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumValueDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.number = reader.int32();
                            break;
                        case 3:
                            message.options = $root.google.protobuf.EnumValueOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumValueDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumValueDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumValueDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.number != null && message.hasOwnProperty("number"))
                        if (!$util.isInteger(message.number))
                            return "number: integer expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.EnumValueOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumValueDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumValueDescriptorProto} EnumValueDescriptorProto
                 */
                EnumValueDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumValueDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.EnumValueDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.number != null)
                        message.number = object.number | 0;
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.EnumValueDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.EnumValueOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumValueDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @static
                 * @param {google.protobuf.EnumValueDescriptorProto} message EnumValueDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumValueDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.number = 0;
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.number != null && message.hasOwnProperty("number"))
                        object.number = message.number;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.EnumValueOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this EnumValueDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumValueDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumValueDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumValueDescriptorProto;
            })();
    
            protobuf.ServiceDescriptorProto = (function() {
    
                /**
                 * Properties of a ServiceDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IServiceDescriptorProto
                 * @property {string|null} [name] ServiceDescriptorProto name
                 * @property {Array.<google.protobuf.IMethodDescriptorProto>|null} [method] ServiceDescriptorProto method
                 * @property {google.protobuf.IServiceOptions|null} [options] ServiceDescriptorProto options
                 */
    
                /**
                 * Constructs a new ServiceDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a ServiceDescriptorProto.
                 * @implements IServiceDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
                 */
                function ServiceDescriptorProto(properties) {
                    this.method = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ServiceDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.name = "";
    
                /**
                 * ServiceDescriptorProto method.
                 * @member {Array.<google.protobuf.IMethodDescriptorProto>} method
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.method = $util.emptyArray;
    
                /**
                 * ServiceDescriptorProto options.
                 * @member {google.protobuf.IServiceOptions|null|undefined} options
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 */
                ServiceDescriptorProto.prototype.options = null;
    
                /**
                 * Creates a new ServiceDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto instance
                 */
                ServiceDescriptorProto.create = function create(properties) {
                    return new ServiceDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified ServiceDescriptorProto message. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.method != null && message.method.length)
                        for (var i = 0; i < message.method.length; ++i)
                            $root.google.protobuf.MethodDescriptorProto.encode(message.method[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.ServiceOptions.encode(message.options, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified ServiceDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.ServiceDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.IServiceDescriptorProto} message ServiceDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ServiceDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            if (!(message.method && message.method.length))
                                message.method = [];
                            message.method.push($root.google.protobuf.MethodDescriptorProto.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.options = $root.google.protobuf.ServiceOptions.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ServiceDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ServiceDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.method != null && message.hasOwnProperty("method")) {
                        if (!Array.isArray(message.method))
                            return "method: array expected";
                        for (var i = 0; i < message.method.length; ++i) {
                            var error = $root.google.protobuf.MethodDescriptorProto.verify(message.method[i]);
                            if (error)
                                return "method." + error;
                        }
                    }
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.ServiceOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a ServiceDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.ServiceDescriptorProto} ServiceDescriptorProto
                 */
                ServiceDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.ServiceDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.ServiceDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.method) {
                        if (!Array.isArray(object.method))
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.method: array expected");
                        message.method = [];
                        for (var i = 0; i < object.method.length; ++i) {
                            if (typeof object.method[i] !== "object")
                                throw TypeError(".google.protobuf.ServiceDescriptorProto.method: object expected");
                            message.method[i] = $root.google.protobuf.MethodDescriptorProto.fromObject(object.method[i]);
                        }
                    }
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.ServiceDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.ServiceOptions.fromObject(object.options);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ServiceDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @static
                 * @param {google.protobuf.ServiceDescriptorProto} message ServiceDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.method = [];
                    if (options.defaults) {
                        object.name = "";
                        object.options = null;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.method && message.method.length) {
                        object.method = [];
                        for (var j = 0; j < message.method.length; ++j)
                            object.method[j] = $root.google.protobuf.MethodDescriptorProto.toObject(message.method[j], options);
                    }
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.ServiceOptions.toObject(message.options, options);
                    return object;
                };
    
                /**
                 * Converts this ServiceDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.ServiceDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ServiceDescriptorProto;
            })();
    
            protobuf.MethodDescriptorProto = (function() {
    
                /**
                 * Properties of a MethodDescriptorProto.
                 * @memberof google.protobuf
                 * @interface IMethodDescriptorProto
                 * @property {string|null} [name] MethodDescriptorProto name
                 * @property {string|null} [inputType] MethodDescriptorProto inputType
                 * @property {string|null} [outputType] MethodDescriptorProto outputType
                 * @property {google.protobuf.IMethodOptions|null} [options] MethodDescriptorProto options
                 * @property {boolean|null} [clientStreaming] MethodDescriptorProto clientStreaming
                 * @property {boolean|null} [serverStreaming] MethodDescriptorProto serverStreaming
                 */
    
                /**
                 * Constructs a new MethodDescriptorProto.
                 * @memberof google.protobuf
                 * @classdesc Represents a MethodDescriptorProto.
                 * @implements IMethodDescriptorProto
                 * @constructor
                 * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
                 */
                function MethodDescriptorProto(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MethodDescriptorProto name.
                 * @member {string} name
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.name = "";
    
                /**
                 * MethodDescriptorProto inputType.
                 * @member {string} inputType
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.inputType = "";
    
                /**
                 * MethodDescriptorProto outputType.
                 * @member {string} outputType
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.outputType = "";
    
                /**
                 * MethodDescriptorProto options.
                 * @member {google.protobuf.IMethodOptions|null|undefined} options
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.options = null;
    
                /**
                 * MethodDescriptorProto clientStreaming.
                 * @member {boolean} clientStreaming
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.clientStreaming = false;
    
                /**
                 * MethodDescriptorProto serverStreaming.
                 * @member {boolean} serverStreaming
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 */
                MethodDescriptorProto.prototype.serverStreaming = false;
    
                /**
                 * Creates a new MethodDescriptorProto instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto=} [properties] Properties to set
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto instance
                 */
                MethodDescriptorProto.create = function create(properties) {
                    return new MethodDescriptorProto(properties);
                };
    
                /**
                 * Encodes the specified MethodDescriptorProto message. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodDescriptorProto.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && Object.hasOwnProperty.call(message, "name"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.name);
                    if (message.inputType != null && Object.hasOwnProperty.call(message, "inputType"))
                        writer.uint32(/* id 2, wireType 2 =*/18).string(message.inputType);
                    if (message.outputType != null && Object.hasOwnProperty.call(message, "outputType"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.outputType);
                    if (message.options != null && Object.hasOwnProperty.call(message, "options"))
                        $root.google.protobuf.MethodOptions.encode(message.options, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
                    if (message.clientStreaming != null && Object.hasOwnProperty.call(message, "clientStreaming"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.clientStreaming);
                    if (message.serverStreaming != null && Object.hasOwnProperty.call(message, "serverStreaming"))
                        writer.uint32(/* id 6, wireType 0 =*/48).bool(message.serverStreaming);
                    return writer;
                };
    
                /**
                 * Encodes the specified MethodDescriptorProto message, length delimited. Does not implicitly {@link google.protobuf.MethodDescriptorProto.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.IMethodDescriptorProto} message MethodDescriptorProto message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodDescriptorProto.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MethodDescriptorProto message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodDescriptorProto.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodDescriptorProto();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.name = reader.string();
                            break;
                        case 2:
                            message.inputType = reader.string();
                            break;
                        case 3:
                            message.outputType = reader.string();
                            break;
                        case 4:
                            message.options = $root.google.protobuf.MethodOptions.decode(reader, reader.uint32());
                            break;
                        case 5:
                            message.clientStreaming = reader.bool();
                            break;
                        case 6:
                            message.serverStreaming = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MethodDescriptorProto message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodDescriptorProto.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MethodDescriptorProto message.
                 * @function verify
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MethodDescriptorProto.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name"))
                        if (!$util.isString(message.name))
                            return "name: string expected";
                    if (message.inputType != null && message.hasOwnProperty("inputType"))
                        if (!$util.isString(message.inputType))
                            return "inputType: string expected";
                    if (message.outputType != null && message.hasOwnProperty("outputType"))
                        if (!$util.isString(message.outputType))
                            return "outputType: string expected";
                    if (message.options != null && message.hasOwnProperty("options")) {
                        var error = $root.google.protobuf.MethodOptions.verify(message.options);
                        if (error)
                            return "options." + error;
                    }
                    if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                        if (typeof message.clientStreaming !== "boolean")
                            return "clientStreaming: boolean expected";
                    if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                        if (typeof message.serverStreaming !== "boolean")
                            return "serverStreaming: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a MethodDescriptorProto message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MethodDescriptorProto} MethodDescriptorProto
                 */
                MethodDescriptorProto.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MethodDescriptorProto)
                        return object;
                    var message = new $root.google.protobuf.MethodDescriptorProto();
                    if (object.name != null)
                        message.name = String(object.name);
                    if (object.inputType != null)
                        message.inputType = String(object.inputType);
                    if (object.outputType != null)
                        message.outputType = String(object.outputType);
                    if (object.options != null) {
                        if (typeof object.options !== "object")
                            throw TypeError(".google.protobuf.MethodDescriptorProto.options: object expected");
                        message.options = $root.google.protobuf.MethodOptions.fromObject(object.options);
                    }
                    if (object.clientStreaming != null)
                        message.clientStreaming = Boolean(object.clientStreaming);
                    if (object.serverStreaming != null)
                        message.serverStreaming = Boolean(object.serverStreaming);
                    return message;
                };
    
                /**
                 * Creates a plain object from a MethodDescriptorProto message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @static
                 * @param {google.protobuf.MethodDescriptorProto} message MethodDescriptorProto
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MethodDescriptorProto.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        object.name = "";
                        object.inputType = "";
                        object.outputType = "";
                        object.options = null;
                        object.clientStreaming = false;
                        object.serverStreaming = false;
                    }
                    if (message.name != null && message.hasOwnProperty("name"))
                        object.name = message.name;
                    if (message.inputType != null && message.hasOwnProperty("inputType"))
                        object.inputType = message.inputType;
                    if (message.outputType != null && message.hasOwnProperty("outputType"))
                        object.outputType = message.outputType;
                    if (message.options != null && message.hasOwnProperty("options"))
                        object.options = $root.google.protobuf.MethodOptions.toObject(message.options, options);
                    if (message.clientStreaming != null && message.hasOwnProperty("clientStreaming"))
                        object.clientStreaming = message.clientStreaming;
                    if (message.serverStreaming != null && message.hasOwnProperty("serverStreaming"))
                        object.serverStreaming = message.serverStreaming;
                    return object;
                };
    
                /**
                 * Converts this MethodDescriptorProto to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MethodDescriptorProto
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MethodDescriptorProto.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return MethodDescriptorProto;
            })();
    
            protobuf.FileOptions = (function() {
    
                /**
                 * Properties of a FileOptions.
                 * @memberof google.protobuf
                 * @interface IFileOptions
                 * @property {string|null} [javaPackage] FileOptions javaPackage
                 * @property {string|null} [javaOuterClassname] FileOptions javaOuterClassname
                 * @property {boolean|null} [javaMultipleFiles] FileOptions javaMultipleFiles
                 * @property {boolean|null} [javaGenerateEqualsAndHash] FileOptions javaGenerateEqualsAndHash
                 * @property {boolean|null} [javaStringCheckUtf8] FileOptions javaStringCheckUtf8
                 * @property {google.protobuf.FileOptions.OptimizeMode|null} [optimizeFor] FileOptions optimizeFor
                 * @property {string|null} [goPackage] FileOptions goPackage
                 * @property {boolean|null} [ccGenericServices] FileOptions ccGenericServices
                 * @property {boolean|null} [javaGenericServices] FileOptions javaGenericServices
                 * @property {boolean|null} [pyGenericServices] FileOptions pyGenericServices
                 * @property {boolean|null} [deprecated] FileOptions deprecated
                 * @property {boolean|null} [ccEnableArenas] FileOptions ccEnableArenas
                 * @property {string|null} [objcClassPrefix] FileOptions objcClassPrefix
                 * @property {string|null} [csharpNamespace] FileOptions csharpNamespace
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FileOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new FileOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a FileOptions.
                 * @implements IFileOptions
                 * @constructor
                 * @param {google.protobuf.IFileOptions=} [properties] Properties to set
                 */
                function FileOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FileOptions javaPackage.
                 * @member {string} javaPackage
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaPackage = "";
    
                /**
                 * FileOptions javaOuterClassname.
                 * @member {string} javaOuterClassname
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaOuterClassname = "";
    
                /**
                 * FileOptions javaMultipleFiles.
                 * @member {boolean} javaMultipleFiles
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaMultipleFiles = false;
    
                /**
                 * FileOptions javaGenerateEqualsAndHash.
                 * @member {boolean} javaGenerateEqualsAndHash
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaGenerateEqualsAndHash = false;
    
                /**
                 * FileOptions javaStringCheckUtf8.
                 * @member {boolean} javaStringCheckUtf8
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaStringCheckUtf8 = false;
    
                /**
                 * FileOptions optimizeFor.
                 * @member {google.protobuf.FileOptions.OptimizeMode} optimizeFor
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.optimizeFor = 1;
    
                /**
                 * FileOptions goPackage.
                 * @member {string} goPackage
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.goPackage = "";
    
                /**
                 * FileOptions ccGenericServices.
                 * @member {boolean} ccGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.ccGenericServices = false;
    
                /**
                 * FileOptions javaGenericServices.
                 * @member {boolean} javaGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.javaGenericServices = false;
    
                /**
                 * FileOptions pyGenericServices.
                 * @member {boolean} pyGenericServices
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.pyGenericServices = false;
    
                /**
                 * FileOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.deprecated = false;
    
                /**
                 * FileOptions ccEnableArenas.
                 * @member {boolean} ccEnableArenas
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.ccEnableArenas = false;
    
                /**
                 * FileOptions objcClassPrefix.
                 * @member {string} objcClassPrefix
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.objcClassPrefix = "";
    
                /**
                 * FileOptions csharpNamespace.
                 * @member {string} csharpNamespace
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.csharpNamespace = "";
    
                /**
                 * FileOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 */
                FileOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new FileOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions=} [properties] Properties to set
                 * @returns {google.protobuf.FileOptions} FileOptions instance
                 */
                FileOptions.create = function create(properties) {
                    return new FileOptions(properties);
                };
    
                /**
                 * Encodes the specified FileOptions message. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.javaPackage != null && Object.hasOwnProperty.call(message, "javaPackage"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.javaPackage);
                    if (message.javaOuterClassname != null && Object.hasOwnProperty.call(message, "javaOuterClassname"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.javaOuterClassname);
                    if (message.optimizeFor != null && Object.hasOwnProperty.call(message, "optimizeFor"))
                        writer.uint32(/* id 9, wireType 0 =*/72).int32(message.optimizeFor);
                    if (message.javaMultipleFiles != null && Object.hasOwnProperty.call(message, "javaMultipleFiles"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.javaMultipleFiles);
                    if (message.goPackage != null && Object.hasOwnProperty.call(message, "goPackage"))
                        writer.uint32(/* id 11, wireType 2 =*/90).string(message.goPackage);
                    if (message.ccGenericServices != null && Object.hasOwnProperty.call(message, "ccGenericServices"))
                        writer.uint32(/* id 16, wireType 0 =*/128).bool(message.ccGenericServices);
                    if (message.javaGenericServices != null && Object.hasOwnProperty.call(message, "javaGenericServices"))
                        writer.uint32(/* id 17, wireType 0 =*/136).bool(message.javaGenericServices);
                    if (message.pyGenericServices != null && Object.hasOwnProperty.call(message, "pyGenericServices"))
                        writer.uint32(/* id 18, wireType 0 =*/144).bool(message.pyGenericServices);
                    if (message.javaGenerateEqualsAndHash != null && Object.hasOwnProperty.call(message, "javaGenerateEqualsAndHash"))
                        writer.uint32(/* id 20, wireType 0 =*/160).bool(message.javaGenerateEqualsAndHash);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 23, wireType 0 =*/184).bool(message.deprecated);
                    if (message.javaStringCheckUtf8 != null && Object.hasOwnProperty.call(message, "javaStringCheckUtf8"))
                        writer.uint32(/* id 27, wireType 0 =*/216).bool(message.javaStringCheckUtf8);
                    if (message.ccEnableArenas != null && Object.hasOwnProperty.call(message, "ccEnableArenas"))
                        writer.uint32(/* id 31, wireType 0 =*/248).bool(message.ccEnableArenas);
                    if (message.objcClassPrefix != null && Object.hasOwnProperty.call(message, "objcClassPrefix"))
                        writer.uint32(/* id 36, wireType 2 =*/290).string(message.objcClassPrefix);
                    if (message.csharpNamespace != null && Object.hasOwnProperty.call(message, "csharpNamespace"))
                        writer.uint32(/* id 37, wireType 2 =*/298).string(message.csharpNamespace);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FileOptions message, length delimited. Does not implicitly {@link google.protobuf.FileOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.IFileOptions} message FileOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FileOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FileOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FileOptions} FileOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FileOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.javaPackage = reader.string();
                            break;
                        case 8:
                            message.javaOuterClassname = reader.string();
                            break;
                        case 10:
                            message.javaMultipleFiles = reader.bool();
                            break;
                        case 20:
                            message.javaGenerateEqualsAndHash = reader.bool();
                            break;
                        case 27:
                            message.javaStringCheckUtf8 = reader.bool();
                            break;
                        case 9:
                            message.optimizeFor = reader.int32();
                            break;
                        case 11:
                            message.goPackage = reader.string();
                            break;
                        case 16:
                            message.ccGenericServices = reader.bool();
                            break;
                        case 17:
                            message.javaGenericServices = reader.bool();
                            break;
                        case 18:
                            message.pyGenericServices = reader.bool();
                            break;
                        case 23:
                            message.deprecated = reader.bool();
                            break;
                        case 31:
                            message.ccEnableArenas = reader.bool();
                            break;
                        case 36:
                            message.objcClassPrefix = reader.string();
                            break;
                        case 37:
                            message.csharpNamespace = reader.string();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FileOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FileOptions} FileOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FileOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FileOptions message.
                 * @function verify
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FileOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                        if (!$util.isString(message.javaPackage))
                            return "javaPackage: string expected";
                    if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                        if (!$util.isString(message.javaOuterClassname))
                            return "javaOuterClassname: string expected";
                    if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                        if (typeof message.javaMultipleFiles !== "boolean")
                            return "javaMultipleFiles: boolean expected";
                    if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                        if (typeof message.javaGenerateEqualsAndHash !== "boolean")
                            return "javaGenerateEqualsAndHash: boolean expected";
                    if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                        if (typeof message.javaStringCheckUtf8 !== "boolean")
                            return "javaStringCheckUtf8: boolean expected";
                    if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                        switch (message.optimizeFor) {
                        default:
                            return "optimizeFor: enum value expected";
                        case 1:
                        case 2:
                        case 3:
                            break;
                        }
                    if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                        if (!$util.isString(message.goPackage))
                            return "goPackage: string expected";
                    if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                        if (typeof message.ccGenericServices !== "boolean")
                            return "ccGenericServices: boolean expected";
                    if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                        if (typeof message.javaGenericServices !== "boolean")
                            return "javaGenericServices: boolean expected";
                    if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                        if (typeof message.pyGenericServices !== "boolean")
                            return "pyGenericServices: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                        if (typeof message.ccEnableArenas !== "boolean")
                            return "ccEnableArenas: boolean expected";
                    if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                        if (!$util.isString(message.objcClassPrefix))
                            return "objcClassPrefix: string expected";
                    if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                        if (!$util.isString(message.csharpNamespace))
                            return "csharpNamespace: string expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a FileOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FileOptions} FileOptions
                 */
                FileOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FileOptions)
                        return object;
                    var message = new $root.google.protobuf.FileOptions();
                    if (object.javaPackage != null)
                        message.javaPackage = String(object.javaPackage);
                    if (object.javaOuterClassname != null)
                        message.javaOuterClassname = String(object.javaOuterClassname);
                    if (object.javaMultipleFiles != null)
                        message.javaMultipleFiles = Boolean(object.javaMultipleFiles);
                    if (object.javaGenerateEqualsAndHash != null)
                        message.javaGenerateEqualsAndHash = Boolean(object.javaGenerateEqualsAndHash);
                    if (object.javaStringCheckUtf8 != null)
                        message.javaStringCheckUtf8 = Boolean(object.javaStringCheckUtf8);
                    switch (object.optimizeFor) {
                    case "SPEED":
                    case 1:
                        message.optimizeFor = 1;
                        break;
                    case "CODE_SIZE":
                    case 2:
                        message.optimizeFor = 2;
                        break;
                    case "LITE_RUNTIME":
                    case 3:
                        message.optimizeFor = 3;
                        break;
                    }
                    if (object.goPackage != null)
                        message.goPackage = String(object.goPackage);
                    if (object.ccGenericServices != null)
                        message.ccGenericServices = Boolean(object.ccGenericServices);
                    if (object.javaGenericServices != null)
                        message.javaGenericServices = Boolean(object.javaGenericServices);
                    if (object.pyGenericServices != null)
                        message.pyGenericServices = Boolean(object.pyGenericServices);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.ccEnableArenas != null)
                        message.ccEnableArenas = Boolean(object.ccEnableArenas);
                    if (object.objcClassPrefix != null)
                        message.objcClassPrefix = String(object.objcClassPrefix);
                    if (object.csharpNamespace != null)
                        message.csharpNamespace = String(object.csharpNamespace);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.FileOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FileOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FileOptions
                 * @static
                 * @param {google.protobuf.FileOptions} message FileOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FileOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.javaPackage = "";
                        object.javaOuterClassname = "";
                        object.optimizeFor = options.enums === String ? "SPEED" : 1;
                        object.javaMultipleFiles = false;
                        object.goPackage = "";
                        object.ccGenericServices = false;
                        object.javaGenericServices = false;
                        object.pyGenericServices = false;
                        object.javaGenerateEqualsAndHash = false;
                        object.deprecated = false;
                        object.javaStringCheckUtf8 = false;
                        object.ccEnableArenas = false;
                        object.objcClassPrefix = "";
                        object.csharpNamespace = "";
                    }
                    if (message.javaPackage != null && message.hasOwnProperty("javaPackage"))
                        object.javaPackage = message.javaPackage;
                    if (message.javaOuterClassname != null && message.hasOwnProperty("javaOuterClassname"))
                        object.javaOuterClassname = message.javaOuterClassname;
                    if (message.optimizeFor != null && message.hasOwnProperty("optimizeFor"))
                        object.optimizeFor = options.enums === String ? $root.google.protobuf.FileOptions.OptimizeMode[message.optimizeFor] : message.optimizeFor;
                    if (message.javaMultipleFiles != null && message.hasOwnProperty("javaMultipleFiles"))
                        object.javaMultipleFiles = message.javaMultipleFiles;
                    if (message.goPackage != null && message.hasOwnProperty("goPackage"))
                        object.goPackage = message.goPackage;
                    if (message.ccGenericServices != null && message.hasOwnProperty("ccGenericServices"))
                        object.ccGenericServices = message.ccGenericServices;
                    if (message.javaGenericServices != null && message.hasOwnProperty("javaGenericServices"))
                        object.javaGenericServices = message.javaGenericServices;
                    if (message.pyGenericServices != null && message.hasOwnProperty("pyGenericServices"))
                        object.pyGenericServices = message.pyGenericServices;
                    if (message.javaGenerateEqualsAndHash != null && message.hasOwnProperty("javaGenerateEqualsAndHash"))
                        object.javaGenerateEqualsAndHash = message.javaGenerateEqualsAndHash;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.javaStringCheckUtf8 != null && message.hasOwnProperty("javaStringCheckUtf8"))
                        object.javaStringCheckUtf8 = message.javaStringCheckUtf8;
                    if (message.ccEnableArenas != null && message.hasOwnProperty("ccEnableArenas"))
                        object.ccEnableArenas = message.ccEnableArenas;
                    if (message.objcClassPrefix != null && message.hasOwnProperty("objcClassPrefix"))
                        object.objcClassPrefix = message.objcClassPrefix;
                    if (message.csharpNamespace != null && message.hasOwnProperty("csharpNamespace"))
                        object.csharpNamespace = message.csharpNamespace;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this FileOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FileOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FileOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * OptimizeMode enum.
                 * @name google.protobuf.FileOptions.OptimizeMode
                 * @enum {number}
                 * @property {number} SPEED=1 SPEED value
                 * @property {number} CODE_SIZE=2 CODE_SIZE value
                 * @property {number} LITE_RUNTIME=3 LITE_RUNTIME value
                 */
                FileOptions.OptimizeMode = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[1] = "SPEED"] = 1;
                    values[valuesById[2] = "CODE_SIZE"] = 2;
                    values[valuesById[3] = "LITE_RUNTIME"] = 3;
                    return values;
                })();
    
                return FileOptions;
            })();
    
            protobuf.MessageOptions = (function() {
    
                /**
                 * Properties of a MessageOptions.
                 * @memberof google.protobuf
                 * @interface IMessageOptions
                 * @property {boolean|null} [messageSetWireFormat] MessageOptions messageSetWireFormat
                 * @property {boolean|null} [noStandardDescriptorAccessor] MessageOptions noStandardDescriptorAccessor
                 * @property {boolean|null} [deprecated] MessageOptions deprecated
                 * @property {boolean|null} [mapEntry] MessageOptions mapEntry
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MessageOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new MessageOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a MessageOptions.
                 * @implements IMessageOptions
                 * @constructor
                 * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
                 */
                function MessageOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MessageOptions messageSetWireFormat.
                 * @member {boolean} messageSetWireFormat
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.messageSetWireFormat = false;
    
                /**
                 * MessageOptions noStandardDescriptorAccessor.
                 * @member {boolean} noStandardDescriptorAccessor
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.noStandardDescriptorAccessor = false;
    
                /**
                 * MessageOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.deprecated = false;
    
                /**
                 * MessageOptions mapEntry.
                 * @member {boolean} mapEntry
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.mapEntry = false;
    
                /**
                 * MessageOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 */
                MessageOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new MessageOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions=} [properties] Properties to set
                 * @returns {google.protobuf.MessageOptions} MessageOptions instance
                 */
                MessageOptions.create = function create(properties) {
                    return new MessageOptions(properties);
                };
    
                /**
                 * Encodes the specified MessageOptions message. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MessageOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.messageSetWireFormat != null && Object.hasOwnProperty.call(message, "messageSetWireFormat"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.messageSetWireFormat);
                    if (message.noStandardDescriptorAccessor != null && Object.hasOwnProperty.call(message, "noStandardDescriptorAccessor"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.noStandardDescriptorAccessor);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.mapEntry != null && Object.hasOwnProperty.call(message, "mapEntry"))
                        writer.uint32(/* id 7, wireType 0 =*/56).bool(message.mapEntry);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified MessageOptions message, length delimited. Does not implicitly {@link google.protobuf.MessageOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.IMessageOptions} message MessageOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MessageOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MessageOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MessageOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MessageOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.messageSetWireFormat = reader.bool();
                            break;
                        case 2:
                            message.noStandardDescriptorAccessor = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 7:
                            message.mapEntry = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MessageOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MessageOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MessageOptions message.
                 * @function verify
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MessageOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                        if (typeof message.messageSetWireFormat !== "boolean")
                            return "messageSetWireFormat: boolean expected";
                    if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                        if (typeof message.noStandardDescriptorAccessor !== "boolean")
                            return "noStandardDescriptorAccessor: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                        if (typeof message.mapEntry !== "boolean")
                            return "mapEntry: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a MessageOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MessageOptions} MessageOptions
                 */
                MessageOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MessageOptions)
                        return object;
                    var message = new $root.google.protobuf.MessageOptions();
                    if (object.messageSetWireFormat != null)
                        message.messageSetWireFormat = Boolean(object.messageSetWireFormat);
                    if (object.noStandardDescriptorAccessor != null)
                        message.noStandardDescriptorAccessor = Boolean(object.noStandardDescriptorAccessor);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.mapEntry != null)
                        message.mapEntry = Boolean(object.mapEntry);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.MessageOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a MessageOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MessageOptions
                 * @static
                 * @param {google.protobuf.MessageOptions} message MessageOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MessageOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.messageSetWireFormat = false;
                        object.noStandardDescriptorAccessor = false;
                        object.deprecated = false;
                        object.mapEntry = false;
                    }
                    if (message.messageSetWireFormat != null && message.hasOwnProperty("messageSetWireFormat"))
                        object.messageSetWireFormat = message.messageSetWireFormat;
                    if (message.noStandardDescriptorAccessor != null && message.hasOwnProperty("noStandardDescriptorAccessor"))
                        object.noStandardDescriptorAccessor = message.noStandardDescriptorAccessor;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.mapEntry != null && message.hasOwnProperty("mapEntry"))
                        object.mapEntry = message.mapEntry;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this MessageOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MessageOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MessageOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return MessageOptions;
            })();
    
            protobuf.FieldOptions = (function() {
    
                /**
                 * Properties of a FieldOptions.
                 * @memberof google.protobuf
                 * @interface IFieldOptions
                 * @property {google.protobuf.FieldOptions.CType|null} [ctype] FieldOptions ctype
                 * @property {boolean|null} [packed] FieldOptions packed
                 * @property {google.protobuf.FieldOptions.JSType|null} [jstype] FieldOptions jstype
                 * @property {boolean|null} [lazy] FieldOptions lazy
                 * @property {boolean|null} [deprecated] FieldOptions deprecated
                 * @property {boolean|null} [weak] FieldOptions weak
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] FieldOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new FieldOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a FieldOptions.
                 * @implements IFieldOptions
                 * @constructor
                 * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
                 */
                function FieldOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FieldOptions ctype.
                 * @member {google.protobuf.FieldOptions.CType} ctype
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.ctype = 0;
    
                /**
                 * FieldOptions packed.
                 * @member {boolean} packed
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.packed = false;
    
                /**
                 * FieldOptions jstype.
                 * @member {google.protobuf.FieldOptions.JSType} jstype
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.jstype = 0;
    
                /**
                 * FieldOptions lazy.
                 * @member {boolean} lazy
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.lazy = false;
    
                /**
                 * FieldOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.deprecated = false;
    
                /**
                 * FieldOptions weak.
                 * @member {boolean} weak
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.weak = false;
    
                /**
                 * FieldOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 */
                FieldOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new FieldOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions=} [properties] Properties to set
                 * @returns {google.protobuf.FieldOptions} FieldOptions instance
                 */
                FieldOptions.create = function create(properties) {
                    return new FieldOptions(properties);
                };
    
                /**
                 * Encodes the specified FieldOptions message. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.ctype != null && Object.hasOwnProperty.call(message, "ctype"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ctype);
                    if (message.packed != null && Object.hasOwnProperty.call(message, "packed"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.packed);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.lazy != null && Object.hasOwnProperty.call(message, "lazy"))
                        writer.uint32(/* id 5, wireType 0 =*/40).bool(message.lazy);
                    if (message.jstype != null && Object.hasOwnProperty.call(message, "jstype"))
                        writer.uint32(/* id 6, wireType 0 =*/48).int32(message.jstype);
                    if (message.weak != null && Object.hasOwnProperty.call(message, "weak"))
                        writer.uint32(/* id 10, wireType 0 =*/80).bool(message.weak);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified FieldOptions message, length delimited. Does not implicitly {@link google.protobuf.FieldOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.IFieldOptions} message FieldOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FieldOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.ctype = reader.int32();
                            break;
                        case 2:
                            message.packed = reader.bool();
                            break;
                        case 6:
                            message.jstype = reader.int32();
                            break;
                        case 5:
                            message.lazy = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 10:
                            message.weak = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FieldOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FieldOptions message.
                 * @function verify
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.ctype != null && message.hasOwnProperty("ctype"))
                        switch (message.ctype) {
                        default:
                            return "ctype: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.packed != null && message.hasOwnProperty("packed"))
                        if (typeof message.packed !== "boolean")
                            return "packed: boolean expected";
                    if (message.jstype != null && message.hasOwnProperty("jstype"))
                        switch (message.jstype) {
                        default:
                            return "jstype: enum value expected";
                        case 0:
                        case 1:
                        case 2:
                            break;
                        }
                    if (message.lazy != null && message.hasOwnProperty("lazy"))
                        if (typeof message.lazy !== "boolean")
                            return "lazy: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.weak != null && message.hasOwnProperty("weak"))
                        if (typeof message.weak !== "boolean")
                            return "weak: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a FieldOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FieldOptions} FieldOptions
                 */
                FieldOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FieldOptions)
                        return object;
                    var message = new $root.google.protobuf.FieldOptions();
                    switch (object.ctype) {
                    case "STRING":
                    case 0:
                        message.ctype = 0;
                        break;
                    case "CORD":
                    case 1:
                        message.ctype = 1;
                        break;
                    case "STRING_PIECE":
                    case 2:
                        message.ctype = 2;
                        break;
                    }
                    if (object.packed != null)
                        message.packed = Boolean(object.packed);
                    switch (object.jstype) {
                    case "JS_NORMAL":
                    case 0:
                        message.jstype = 0;
                        break;
                    case "JS_STRING":
                    case 1:
                        message.jstype = 1;
                        break;
                    case "JS_NUMBER":
                    case 2:
                        message.jstype = 2;
                        break;
                    }
                    if (object.lazy != null)
                        message.lazy = Boolean(object.lazy);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.weak != null)
                        message.weak = Boolean(object.weak);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.FieldOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FieldOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FieldOptions
                 * @static
                 * @param {google.protobuf.FieldOptions} message FieldOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.ctype = options.enums === String ? "STRING" : 0;
                        object.packed = false;
                        object.deprecated = false;
                        object.lazy = false;
                        object.jstype = options.enums === String ? "JS_NORMAL" : 0;
                        object.weak = false;
                    }
                    if (message.ctype != null && message.hasOwnProperty("ctype"))
                        object.ctype = options.enums === String ? $root.google.protobuf.FieldOptions.CType[message.ctype] : message.ctype;
                    if (message.packed != null && message.hasOwnProperty("packed"))
                        object.packed = message.packed;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.lazy != null && message.hasOwnProperty("lazy"))
                        object.lazy = message.lazy;
                    if (message.jstype != null && message.hasOwnProperty("jstype"))
                        object.jstype = options.enums === String ? $root.google.protobuf.FieldOptions.JSType[message.jstype] : message.jstype;
                    if (message.weak != null && message.hasOwnProperty("weak"))
                        object.weak = message.weak;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this FieldOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FieldOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                /**
                 * CType enum.
                 * @name google.protobuf.FieldOptions.CType
                 * @enum {number}
                 * @property {number} STRING=0 STRING value
                 * @property {number} CORD=1 CORD value
                 * @property {number} STRING_PIECE=2 STRING_PIECE value
                 */
                FieldOptions.CType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "STRING"] = 0;
                    values[valuesById[1] = "CORD"] = 1;
                    values[valuesById[2] = "STRING_PIECE"] = 2;
                    return values;
                })();
    
                /**
                 * JSType enum.
                 * @name google.protobuf.FieldOptions.JSType
                 * @enum {number}
                 * @property {number} JS_NORMAL=0 JS_NORMAL value
                 * @property {number} JS_STRING=1 JS_STRING value
                 * @property {number} JS_NUMBER=2 JS_NUMBER value
                 */
                FieldOptions.JSType = (function() {
                    var valuesById = {}, values = Object.create(valuesById);
                    values[valuesById[0] = "JS_NORMAL"] = 0;
                    values[valuesById[1] = "JS_STRING"] = 1;
                    values[valuesById[2] = "JS_NUMBER"] = 2;
                    return values;
                })();
    
                return FieldOptions;
            })();
    
            protobuf.OneofOptions = (function() {
    
                /**
                 * Properties of an OneofOptions.
                 * @memberof google.protobuf
                 * @interface IOneofOptions
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] OneofOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new OneofOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an OneofOptions.
                 * @implements IOneofOptions
                 * @constructor
                 * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
                 */
                function OneofOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * OneofOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.OneofOptions
                 * @instance
                 */
                OneofOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new OneofOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions=} [properties] Properties to set
                 * @returns {google.protobuf.OneofOptions} OneofOptions instance
                 */
                OneofOptions.create = function create(properties) {
                    return new OneofOptions(properties);
                };
    
                /**
                 * Encodes the specified OneofOptions message. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified OneofOptions message, length delimited. Does not implicitly {@link google.protobuf.OneofOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.IOneofOptions} message OneofOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                OneofOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an OneofOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.OneofOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an OneofOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                OneofOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an OneofOptions message.
                 * @function verify
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                OneofOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an OneofOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.OneofOptions} OneofOptions
                 */
                OneofOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.OneofOptions)
                        return object;
                    var message = new $root.google.protobuf.OneofOptions();
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.OneofOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an OneofOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.OneofOptions
                 * @static
                 * @param {google.protobuf.OneofOptions} message OneofOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                OneofOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this OneofOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.OneofOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                OneofOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return OneofOptions;
            })();
    
            protobuf.EnumOptions = (function() {
    
                /**
                 * Properties of an EnumOptions.
                 * @memberof google.protobuf
                 * @interface IEnumOptions
                 * @property {boolean|null} [allowAlias] EnumOptions allowAlias
                 * @property {boolean|null} [deprecated] EnumOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new EnumOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumOptions.
                 * @implements IEnumOptions
                 * @constructor
                 * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
                 */
                function EnumOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumOptions allowAlias.
                 * @member {boolean} allowAlias
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.allowAlias = false;
    
                /**
                 * EnumOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.deprecated = false;
    
                /**
                 * EnumOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 */
                EnumOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new EnumOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions=} [properties] Properties to set
                 * @returns {google.protobuf.EnumOptions} EnumOptions instance
                 */
                EnumOptions.create = function create(properties) {
                    return new EnumOptions(properties);
                };
    
                /**
                 * Encodes the specified EnumOptions message. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.allowAlias != null && Object.hasOwnProperty.call(message, "allowAlias"))
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.allowAlias);
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 3, wireType 0 =*/24).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.IEnumOptions} message EnumOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            message.allowAlias = reader.bool();
                            break;
                        case 3:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumOptions message.
                 * @function verify
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                        if (typeof message.allowAlias !== "boolean")
                            return "allowAlias: boolean expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates an EnumOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumOptions} EnumOptions
                 */
                EnumOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumOptions)
                        return object;
                    var message = new $root.google.protobuf.EnumOptions();
                    if (object.allowAlias != null)
                        message.allowAlias = Boolean(object.allowAlias);
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.EnumOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumOptions
                 * @static
                 * @param {google.protobuf.EnumOptions} message EnumOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.allowAlias = false;
                        object.deprecated = false;
                    }
                    if (message.allowAlias != null && message.hasOwnProperty("allowAlias"))
                        object.allowAlias = message.allowAlias;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this EnumOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumOptions;
            })();
    
            protobuf.EnumValueOptions = (function() {
    
                /**
                 * Properties of an EnumValueOptions.
                 * @memberof google.protobuf
                 * @interface IEnumValueOptions
                 * @property {boolean|null} [deprecated] EnumValueOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] EnumValueOptions uninterpretedOption
                 * @property {string|null} [".palexy.streaming.v1.key"] EnumValueOptions .palexy.streaming.v1.key
                 */
    
                /**
                 * Constructs a new EnumValueOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents an EnumValueOptions.
                 * @implements IEnumValueOptions
                 * @constructor
                 * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
                 */
                function EnumValueOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * EnumValueOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 */
                EnumValueOptions.prototype.deprecated = false;
    
                /**
                 * EnumValueOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 */
                EnumValueOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * EnumValueOptions .palexy.streaming.v1.key.
                 * @member {string} .palexy.streaming.v1.key
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 */
                EnumValueOptions.prototype[".palexy.streaming.v1.key"] = "";
    
                /**
                 * Creates a new EnumValueOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions=} [properties] Properties to set
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions instance
                 */
                EnumValueOptions.create = function create(properties) {
                    return new EnumValueOptions(properties);
                };
    
                /**
                 * Encodes the specified EnumValueOptions message. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".palexy.streaming.v1.key"] != null && Object.hasOwnProperty.call(message, ".palexy.streaming.v1.key"))
                        writer.uint32(/* id 1001, wireType 2 =*/8010).string(message[".palexy.streaming.v1.key"]);
                    return writer;
                };
    
                /**
                 * Encodes the specified EnumValueOptions message, length delimited. Does not implicitly {@link google.protobuf.EnumValueOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.IEnumValueOptions} message EnumValueOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                EnumValueOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an EnumValueOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.EnumValueOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 1001:
                            message[".palexy.streaming.v1.key"] = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an EnumValueOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                EnumValueOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an EnumValueOptions message.
                 * @function verify
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                EnumValueOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".palexy.streaming.v1.key"] != null && message.hasOwnProperty(".palexy.streaming.v1.key"))
                        if (!$util.isString(message[".palexy.streaming.v1.key"]))
                            return ".palexy.streaming.v1.key: string expected";
                    return null;
                };
    
                /**
                 * Creates an EnumValueOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.EnumValueOptions} EnumValueOptions
                 */
                EnumValueOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.EnumValueOptions)
                        return object;
                    var message = new $root.google.protobuf.EnumValueOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.EnumValueOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".palexy.streaming.v1.key"] != null)
                        message[".palexy.streaming.v1.key"] = String(object[".palexy.streaming.v1.key"]);
                    return message;
                };
    
                /**
                 * Creates a plain object from an EnumValueOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.EnumValueOptions
                 * @static
                 * @param {google.protobuf.EnumValueOptions} message EnumValueOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                EnumValueOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.deprecated = false;
                        object[".palexy.streaming.v1.key"] = "";
                    }
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".palexy.streaming.v1.key"] != null && message.hasOwnProperty(".palexy.streaming.v1.key"))
                        object[".palexy.streaming.v1.key"] = message[".palexy.streaming.v1.key"];
                    return object;
                };
    
                /**
                 * Converts this EnumValueOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.EnumValueOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                EnumValueOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return EnumValueOptions;
            })();
    
            protobuf.ServiceOptions = (function() {
    
                /**
                 * Properties of a ServiceOptions.
                 * @memberof google.protobuf
                 * @interface IServiceOptions
                 * @property {boolean|null} [deprecated] ServiceOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] ServiceOptions uninterpretedOption
                 */
    
                /**
                 * Constructs a new ServiceOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a ServiceOptions.
                 * @implements IServiceOptions
                 * @constructor
                 * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
                 */
                function ServiceOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * ServiceOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype.deprecated = false;
    
                /**
                 * ServiceOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 */
                ServiceOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * Creates a new ServiceOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions=} [properties] Properties to set
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions instance
                 */
                ServiceOptions.create = function create(properties) {
                    return new ServiceOptions(properties);
                };
    
                /**
                 * Encodes the specified ServiceOptions message. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified ServiceOptions message, length delimited. Does not implicitly {@link google.protobuf.ServiceOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.IServiceOptions} message ServiceOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                ServiceOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a ServiceOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.ServiceOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 33:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a ServiceOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                ServiceOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a ServiceOptions message.
                 * @function verify
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                ServiceOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a ServiceOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.ServiceOptions} ServiceOptions
                 */
                ServiceOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.ServiceOptions)
                        return object;
                    var message = new $root.google.protobuf.ServiceOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.ServiceOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a ServiceOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.ServiceOptions
                 * @static
                 * @param {google.protobuf.ServiceOptions} message ServiceOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                ServiceOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults)
                        object.deprecated = false;
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this ServiceOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.ServiceOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                ServiceOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return ServiceOptions;
            })();
    
            protobuf.MethodOptions = (function() {
    
                /**
                 * Properties of a MethodOptions.
                 * @memberof google.protobuf
                 * @interface IMethodOptions
                 * @property {boolean|null} [deprecated] MethodOptions deprecated
                 * @property {Array.<google.protobuf.IUninterpretedOption>|null} [uninterpretedOption] MethodOptions uninterpretedOption
                 * @property {google.api.IHttpRule|null} [".google.api.http"] MethodOptions .google.api.http
                 */
    
                /**
                 * Constructs a new MethodOptions.
                 * @memberof google.protobuf
                 * @classdesc Represents a MethodOptions.
                 * @implements IMethodOptions
                 * @constructor
                 * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
                 */
                function MethodOptions(properties) {
                    this.uninterpretedOption = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * MethodOptions deprecated.
                 * @member {boolean} deprecated
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype.deprecated = false;
    
                /**
                 * MethodOptions uninterpretedOption.
                 * @member {Array.<google.protobuf.IUninterpretedOption>} uninterpretedOption
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype.uninterpretedOption = $util.emptyArray;
    
                /**
                 * MethodOptions .google.api.http.
                 * @member {google.api.IHttpRule|null|undefined} .google.api.http
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 */
                MethodOptions.prototype[".google.api.http"] = null;
    
                /**
                 * Creates a new MethodOptions instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions=} [properties] Properties to set
                 * @returns {google.protobuf.MethodOptions} MethodOptions instance
                 */
                MethodOptions.create = function create(properties) {
                    return new MethodOptions(properties);
                };
    
                /**
                 * Encodes the specified MethodOptions message. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodOptions.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.deprecated != null && Object.hasOwnProperty.call(message, "deprecated"))
                        writer.uint32(/* id 33, wireType 0 =*/264).bool(message.deprecated);
                    if (message.uninterpretedOption != null && message.uninterpretedOption.length)
                        for (var i = 0; i < message.uninterpretedOption.length; ++i)
                            $root.google.protobuf.UninterpretedOption.encode(message.uninterpretedOption[i], writer.uint32(/* id 999, wireType 2 =*/7994).fork()).ldelim();
                    if (message[".google.api.http"] != null && Object.hasOwnProperty.call(message, ".google.api.http"))
                        $root.google.api.HttpRule.encode(message[".google.api.http"], writer.uint32(/* id 72295728, wireType 2 =*/578365826).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified MethodOptions message, length delimited. Does not implicitly {@link google.protobuf.MethodOptions.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.IMethodOptions} message MethodOptions message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                MethodOptions.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a MethodOptions message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodOptions.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.MethodOptions();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 33:
                            message.deprecated = reader.bool();
                            break;
                        case 999:
                            if (!(message.uninterpretedOption && message.uninterpretedOption.length))
                                message.uninterpretedOption = [];
                            message.uninterpretedOption.push($root.google.protobuf.UninterpretedOption.decode(reader, reader.uint32()));
                            break;
                        case 72295728:
                            message[".google.api.http"] = $root.google.api.HttpRule.decode(reader, reader.uint32());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a MethodOptions message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                MethodOptions.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a MethodOptions message.
                 * @function verify
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                MethodOptions.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        if (typeof message.deprecated !== "boolean")
                            return "deprecated: boolean expected";
                    if (message.uninterpretedOption != null && message.hasOwnProperty("uninterpretedOption")) {
                        if (!Array.isArray(message.uninterpretedOption))
                            return "uninterpretedOption: array expected";
                        for (var i = 0; i < message.uninterpretedOption.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.verify(message.uninterpretedOption[i]);
                            if (error)
                                return "uninterpretedOption." + error;
                        }
                    }
                    if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http")) {
                        var error = $root.google.api.HttpRule.verify(message[".google.api.http"]);
                        if (error)
                            return ".google.api.http." + error;
                    }
                    return null;
                };
    
                /**
                 * Creates a MethodOptions message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.MethodOptions} MethodOptions
                 */
                MethodOptions.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.MethodOptions)
                        return object;
                    var message = new $root.google.protobuf.MethodOptions();
                    if (object.deprecated != null)
                        message.deprecated = Boolean(object.deprecated);
                    if (object.uninterpretedOption) {
                        if (!Array.isArray(object.uninterpretedOption))
                            throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: array expected");
                        message.uninterpretedOption = [];
                        for (var i = 0; i < object.uninterpretedOption.length; ++i) {
                            if (typeof object.uninterpretedOption[i] !== "object")
                                throw TypeError(".google.protobuf.MethodOptions.uninterpretedOption: object expected");
                            message.uninterpretedOption[i] = $root.google.protobuf.UninterpretedOption.fromObject(object.uninterpretedOption[i]);
                        }
                    }
                    if (object[".google.api.http"] != null) {
                        if (typeof object[".google.api.http"] !== "object")
                            throw TypeError(".google.protobuf.MethodOptions..google.api.http: object expected");
                        message[".google.api.http"] = $root.google.api.HttpRule.fromObject(object[".google.api.http"]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a MethodOptions message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.MethodOptions
                 * @static
                 * @param {google.protobuf.MethodOptions} message MethodOptions
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                MethodOptions.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.uninterpretedOption = [];
                    if (options.defaults) {
                        object.deprecated = false;
                        object[".google.api.http"] = null;
                    }
                    if (message.deprecated != null && message.hasOwnProperty("deprecated"))
                        object.deprecated = message.deprecated;
                    if (message.uninterpretedOption && message.uninterpretedOption.length) {
                        object.uninterpretedOption = [];
                        for (var j = 0; j < message.uninterpretedOption.length; ++j)
                            object.uninterpretedOption[j] = $root.google.protobuf.UninterpretedOption.toObject(message.uninterpretedOption[j], options);
                    }
                    if (message[".google.api.http"] != null && message.hasOwnProperty(".google.api.http"))
                        object[".google.api.http"] = $root.google.api.HttpRule.toObject(message[".google.api.http"], options);
                    return object;
                };
    
                /**
                 * Converts this MethodOptions to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.MethodOptions
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                MethodOptions.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return MethodOptions;
            })();
    
            protobuf.UninterpretedOption = (function() {
    
                /**
                 * Properties of an UninterpretedOption.
                 * @memberof google.protobuf
                 * @interface IUninterpretedOption
                 * @property {Array.<google.protobuf.UninterpretedOption.INamePart>|null} [name] UninterpretedOption name
                 * @property {string|null} [identifierValue] UninterpretedOption identifierValue
                 * @property {number|null} [positiveIntValue] UninterpretedOption positiveIntValue
                 * @property {number|null} [negativeIntValue] UninterpretedOption negativeIntValue
                 * @property {number|null} [doubleValue] UninterpretedOption doubleValue
                 * @property {Uint8Array|null} [stringValue] UninterpretedOption stringValue
                 * @property {string|null} [aggregateValue] UninterpretedOption aggregateValue
                 */
    
                /**
                 * Constructs a new UninterpretedOption.
                 * @memberof google.protobuf
                 * @classdesc Represents an UninterpretedOption.
                 * @implements IUninterpretedOption
                 * @constructor
                 * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
                 */
                function UninterpretedOption(properties) {
                    this.name = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * UninterpretedOption name.
                 * @member {Array.<google.protobuf.UninterpretedOption.INamePart>} name
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.name = $util.emptyArray;
    
                /**
                 * UninterpretedOption identifierValue.
                 * @member {string} identifierValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.identifierValue = "";
    
                /**
                 * UninterpretedOption positiveIntValue.
                 * @member {number} positiveIntValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.positiveIntValue = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    
                /**
                 * UninterpretedOption negativeIntValue.
                 * @member {number} negativeIntValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.negativeIntValue = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * UninterpretedOption doubleValue.
                 * @member {number} doubleValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.doubleValue = 0;
    
                /**
                 * UninterpretedOption stringValue.
                 * @member {Uint8Array} stringValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.stringValue = $util.newBuffer([]);
    
                /**
                 * UninterpretedOption aggregateValue.
                 * @member {string} aggregateValue
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 */
                UninterpretedOption.prototype.aggregateValue = "";
    
                /**
                 * Creates a new UninterpretedOption instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption=} [properties] Properties to set
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption instance
                 */
                UninterpretedOption.create = function create(properties) {
                    return new UninterpretedOption(properties);
                };
    
                /**
                 * Encodes the specified UninterpretedOption message. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UninterpretedOption.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.name != null && message.name.length)
                        for (var i = 0; i < message.name.length; ++i)
                            $root.google.protobuf.UninterpretedOption.NamePart.encode(message.name[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                    if (message.identifierValue != null && Object.hasOwnProperty.call(message, "identifierValue"))
                        writer.uint32(/* id 3, wireType 2 =*/26).string(message.identifierValue);
                    if (message.positiveIntValue != null && Object.hasOwnProperty.call(message, "positiveIntValue"))
                        writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.positiveIntValue);
                    if (message.negativeIntValue != null && Object.hasOwnProperty.call(message, "negativeIntValue"))
                        writer.uint32(/* id 5, wireType 0 =*/40).int64(message.negativeIntValue);
                    if (message.doubleValue != null && Object.hasOwnProperty.call(message, "doubleValue"))
                        writer.uint32(/* id 6, wireType 1 =*/49).double(message.doubleValue);
                    if (message.stringValue != null && Object.hasOwnProperty.call(message, "stringValue"))
                        writer.uint32(/* id 7, wireType 2 =*/58).bytes(message.stringValue);
                    if (message.aggregateValue != null && Object.hasOwnProperty.call(message, "aggregateValue"))
                        writer.uint32(/* id 8, wireType 2 =*/66).string(message.aggregateValue);
                    return writer;
                };
    
                /**
                 * Encodes the specified UninterpretedOption message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.IUninterpretedOption} message UninterpretedOption message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UninterpretedOption.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an UninterpretedOption message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UninterpretedOption.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 2:
                            if (!(message.name && message.name.length))
                                message.name = [];
                            message.name.push($root.google.protobuf.UninterpretedOption.NamePart.decode(reader, reader.uint32()));
                            break;
                        case 3:
                            message.identifierValue = reader.string();
                            break;
                        case 4:
                            message.positiveIntValue = reader.uint64();
                            break;
                        case 5:
                            message.negativeIntValue = reader.int64();
                            break;
                        case 6:
                            message.doubleValue = reader.double();
                            break;
                        case 7:
                            message.stringValue = reader.bytes();
                            break;
                        case 8:
                            message.aggregateValue = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an UninterpretedOption message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UninterpretedOption.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an UninterpretedOption message.
                 * @function verify
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UninterpretedOption.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.name != null && message.hasOwnProperty("name")) {
                        if (!Array.isArray(message.name))
                            return "name: array expected";
                        for (var i = 0; i < message.name.length; ++i) {
                            var error = $root.google.protobuf.UninterpretedOption.NamePart.verify(message.name[i]);
                            if (error)
                                return "name." + error;
                        }
                    }
                    if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                        if (!$util.isString(message.identifierValue))
                            return "identifierValue: string expected";
                    if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                        if (!$util.isInteger(message.positiveIntValue) && !(message.positiveIntValue && $util.isInteger(message.positiveIntValue.low) && $util.isInteger(message.positiveIntValue.high)))
                            return "positiveIntValue: integer|Long expected";
                    if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                        if (!$util.isInteger(message.negativeIntValue) && !(message.negativeIntValue && $util.isInteger(message.negativeIntValue.low) && $util.isInteger(message.negativeIntValue.high)))
                            return "negativeIntValue: integer|Long expected";
                    if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                        if (typeof message.doubleValue !== "number")
                            return "doubleValue: number expected";
                    if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                        if (!(message.stringValue && typeof message.stringValue.length === "number" || $util.isString(message.stringValue)))
                            return "stringValue: buffer expected";
                    if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                        if (!$util.isString(message.aggregateValue))
                            return "aggregateValue: string expected";
                    return null;
                };
    
                /**
                 * Creates an UninterpretedOption message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.UninterpretedOption} UninterpretedOption
                 */
                UninterpretedOption.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UninterpretedOption)
                        return object;
                    var message = new $root.google.protobuf.UninterpretedOption();
                    if (object.name) {
                        if (!Array.isArray(object.name))
                            throw TypeError(".google.protobuf.UninterpretedOption.name: array expected");
                        message.name = [];
                        for (var i = 0; i < object.name.length; ++i) {
                            if (typeof object.name[i] !== "object")
                                throw TypeError(".google.protobuf.UninterpretedOption.name: object expected");
                            message.name[i] = $root.google.protobuf.UninterpretedOption.NamePart.fromObject(object.name[i]);
                        }
                    }
                    if (object.identifierValue != null)
                        message.identifierValue = String(object.identifierValue);
                    if (object.positiveIntValue != null)
                        if ($util.Long)
                            (message.positiveIntValue = $util.Long.fromValue(object.positiveIntValue)).unsigned = true;
                        else if (typeof object.positiveIntValue === "string")
                            message.positiveIntValue = parseInt(object.positiveIntValue, 10);
                        else if (typeof object.positiveIntValue === "number")
                            message.positiveIntValue = object.positiveIntValue;
                        else if (typeof object.positiveIntValue === "object")
                            message.positiveIntValue = new $util.LongBits(object.positiveIntValue.low >>> 0, object.positiveIntValue.high >>> 0).toNumber(true);
                    if (object.negativeIntValue != null)
                        if ($util.Long)
                            (message.negativeIntValue = $util.Long.fromValue(object.negativeIntValue)).unsigned = false;
                        else if (typeof object.negativeIntValue === "string")
                            message.negativeIntValue = parseInt(object.negativeIntValue, 10);
                        else if (typeof object.negativeIntValue === "number")
                            message.negativeIntValue = object.negativeIntValue;
                        else if (typeof object.negativeIntValue === "object")
                            message.negativeIntValue = new $util.LongBits(object.negativeIntValue.low >>> 0, object.negativeIntValue.high >>> 0).toNumber();
                    if (object.doubleValue != null)
                        message.doubleValue = Number(object.doubleValue);
                    if (object.stringValue != null)
                        if (typeof object.stringValue === "string")
                            $util.base64.decode(object.stringValue, message.stringValue = $util.newBuffer($util.base64.length(object.stringValue)), 0);
                        else if (object.stringValue.length)
                            message.stringValue = object.stringValue;
                    if (object.aggregateValue != null)
                        message.aggregateValue = String(object.aggregateValue);
                    return message;
                };
    
                /**
                 * Creates a plain object from an UninterpretedOption message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.UninterpretedOption
                 * @static
                 * @param {google.protobuf.UninterpretedOption} message UninterpretedOption
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UninterpretedOption.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.name = [];
                    if (options.defaults) {
                        object.identifierValue = "";
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.positiveIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.positiveIntValue = options.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.negativeIntValue = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.negativeIntValue = options.longs === String ? "0" : 0;
                        object.doubleValue = 0;
                        if (options.bytes === String)
                            object.stringValue = "";
                        else {
                            object.stringValue = [];
                            if (options.bytes !== Array)
                                object.stringValue = $util.newBuffer(object.stringValue);
                        }
                        object.aggregateValue = "";
                    }
                    if (message.name && message.name.length) {
                        object.name = [];
                        for (var j = 0; j < message.name.length; ++j)
                            object.name[j] = $root.google.protobuf.UninterpretedOption.NamePart.toObject(message.name[j], options);
                    }
                    if (message.identifierValue != null && message.hasOwnProperty("identifierValue"))
                        object.identifierValue = message.identifierValue;
                    if (message.positiveIntValue != null && message.hasOwnProperty("positiveIntValue"))
                        if (typeof message.positiveIntValue === "number")
                            object.positiveIntValue = options.longs === String ? String(message.positiveIntValue) : message.positiveIntValue;
                        else
                            object.positiveIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.positiveIntValue) : options.longs === Number ? new $util.LongBits(message.positiveIntValue.low >>> 0, message.positiveIntValue.high >>> 0).toNumber(true) : message.positiveIntValue;
                    if (message.negativeIntValue != null && message.hasOwnProperty("negativeIntValue"))
                        if (typeof message.negativeIntValue === "number")
                            object.negativeIntValue = options.longs === String ? String(message.negativeIntValue) : message.negativeIntValue;
                        else
                            object.negativeIntValue = options.longs === String ? $util.Long.prototype.toString.call(message.negativeIntValue) : options.longs === Number ? new $util.LongBits(message.negativeIntValue.low >>> 0, message.negativeIntValue.high >>> 0).toNumber() : message.negativeIntValue;
                    if (message.doubleValue != null && message.hasOwnProperty("doubleValue"))
                        object.doubleValue = options.json && !isFinite(message.doubleValue) ? String(message.doubleValue) : message.doubleValue;
                    if (message.stringValue != null && message.hasOwnProperty("stringValue"))
                        object.stringValue = options.bytes === String ? $util.base64.encode(message.stringValue, 0, message.stringValue.length) : options.bytes === Array ? Array.prototype.slice.call(message.stringValue) : message.stringValue;
                    if (message.aggregateValue != null && message.hasOwnProperty("aggregateValue"))
                        object.aggregateValue = message.aggregateValue;
                    return object;
                };
    
                /**
                 * Converts this UninterpretedOption to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.UninterpretedOption
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UninterpretedOption.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                UninterpretedOption.NamePart = (function() {
    
                    /**
                     * Properties of a NamePart.
                     * @memberof google.protobuf.UninterpretedOption
                     * @interface INamePart
                     * @property {string} namePart NamePart namePart
                     * @property {boolean} isExtension NamePart isExtension
                     */
    
                    /**
                     * Constructs a new NamePart.
                     * @memberof google.protobuf.UninterpretedOption
                     * @classdesc Represents a NamePart.
                     * @implements INamePart
                     * @constructor
                     * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                     */
                    function NamePart(properties) {
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * NamePart namePart.
                     * @member {string} namePart
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     */
                    NamePart.prototype.namePart = "";
    
                    /**
                     * NamePart isExtension.
                     * @member {boolean} isExtension
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     */
                    NamePart.prototype.isExtension = false;
    
                    /**
                     * Creates a new NamePart instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart=} [properties] Properties to set
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart instance
                     */
                    NamePart.create = function create(properties) {
                        return new NamePart(properties);
                    };
    
                    /**
                     * Encodes the specified NamePart message. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NamePart.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.namePart);
                        writer.uint32(/* id 2, wireType 0 =*/16).bool(message.isExtension);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified NamePart message, length delimited. Does not implicitly {@link google.protobuf.UninterpretedOption.NamePart.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.INamePart} message NamePart message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    NamePart.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a NamePart message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NamePart.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UninterpretedOption.NamePart();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                message.namePart = reader.string();
                                break;
                            case 2:
                                message.isExtension = reader.bool();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        if (!message.hasOwnProperty("namePart"))
                            throw $util.ProtocolError("missing required 'namePart'", { instance: message });
                        if (!message.hasOwnProperty("isExtension"))
                            throw $util.ProtocolError("missing required 'isExtension'", { instance: message });
                        return message;
                    };
    
                    /**
                     * Decodes a NamePart message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    NamePart.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a NamePart message.
                     * @function verify
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    NamePart.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (!$util.isString(message.namePart))
                            return "namePart: string expected";
                        if (typeof message.isExtension !== "boolean")
                            return "isExtension: boolean expected";
                        return null;
                    };
    
                    /**
                     * Creates a NamePart message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.UninterpretedOption.NamePart} NamePart
                     */
                    NamePart.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.UninterpretedOption.NamePart)
                            return object;
                        var message = new $root.google.protobuf.UninterpretedOption.NamePart();
                        if (object.namePart != null)
                            message.namePart = String(object.namePart);
                        if (object.isExtension != null)
                            message.isExtension = Boolean(object.isExtension);
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a NamePart message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @static
                     * @param {google.protobuf.UninterpretedOption.NamePart} message NamePart
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    NamePart.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.defaults) {
                            object.namePart = "";
                            object.isExtension = false;
                        }
                        if (message.namePart != null && message.hasOwnProperty("namePart"))
                            object.namePart = message.namePart;
                        if (message.isExtension != null && message.hasOwnProperty("isExtension"))
                            object.isExtension = message.isExtension;
                        return object;
                    };
    
                    /**
                     * Converts this NamePart to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.UninterpretedOption.NamePart
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    NamePart.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return NamePart;
                })();
    
                return UninterpretedOption;
            })();
    
            protobuf.SourceCodeInfo = (function() {
    
                /**
                 * Properties of a SourceCodeInfo.
                 * @memberof google.protobuf
                 * @interface ISourceCodeInfo
                 * @property {Array.<google.protobuf.SourceCodeInfo.ILocation>|null} [location] SourceCodeInfo location
                 */
    
                /**
                 * Constructs a new SourceCodeInfo.
                 * @memberof google.protobuf
                 * @classdesc Represents a SourceCodeInfo.
                 * @implements ISourceCodeInfo
                 * @constructor
                 * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
                 */
                function SourceCodeInfo(properties) {
                    this.location = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * SourceCodeInfo location.
                 * @member {Array.<google.protobuf.SourceCodeInfo.ILocation>} location
                 * @memberof google.protobuf.SourceCodeInfo
                 * @instance
                 */
                SourceCodeInfo.prototype.location = $util.emptyArray;
    
                /**
                 * Creates a new SourceCodeInfo instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo=} [properties] Properties to set
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo instance
                 */
                SourceCodeInfo.create = function create(properties) {
                    return new SourceCodeInfo(properties);
                };
    
                /**
                 * Encodes the specified SourceCodeInfo message. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceCodeInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.location != null && message.location.length)
                        for (var i = 0; i < message.location.length; ++i)
                            $root.google.protobuf.SourceCodeInfo.Location.encode(message.location[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified SourceCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.ISourceCodeInfo} message SourceCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                SourceCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a SourceCodeInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceCodeInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.location && message.location.length))
                                message.location = [];
                            message.location.push($root.google.protobuf.SourceCodeInfo.Location.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a SourceCodeInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                SourceCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a SourceCodeInfo message.
                 * @function verify
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                SourceCodeInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.location != null && message.hasOwnProperty("location")) {
                        if (!Array.isArray(message.location))
                            return "location: array expected";
                        for (var i = 0; i < message.location.length; ++i) {
                            var error = $root.google.protobuf.SourceCodeInfo.Location.verify(message.location[i]);
                            if (error)
                                return "location." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a SourceCodeInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.SourceCodeInfo} SourceCodeInfo
                 */
                SourceCodeInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.SourceCodeInfo)
                        return object;
                    var message = new $root.google.protobuf.SourceCodeInfo();
                    if (object.location) {
                        if (!Array.isArray(object.location))
                            throw TypeError(".google.protobuf.SourceCodeInfo.location: array expected");
                        message.location = [];
                        for (var i = 0; i < object.location.length; ++i) {
                            if (typeof object.location[i] !== "object")
                                throw TypeError(".google.protobuf.SourceCodeInfo.location: object expected");
                            message.location[i] = $root.google.protobuf.SourceCodeInfo.Location.fromObject(object.location[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a SourceCodeInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.SourceCodeInfo
                 * @static
                 * @param {google.protobuf.SourceCodeInfo} message SourceCodeInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                SourceCodeInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.location = [];
                    if (message.location && message.location.length) {
                        object.location = [];
                        for (var j = 0; j < message.location.length; ++j)
                            object.location[j] = $root.google.protobuf.SourceCodeInfo.Location.toObject(message.location[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this SourceCodeInfo to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.SourceCodeInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                SourceCodeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                SourceCodeInfo.Location = (function() {
    
                    /**
                     * Properties of a Location.
                     * @memberof google.protobuf.SourceCodeInfo
                     * @interface ILocation
                     * @property {Array.<number>|null} [path] Location path
                     * @property {Array.<number>|null} [span] Location span
                     * @property {string|null} [leadingComments] Location leadingComments
                     * @property {string|null} [trailingComments] Location trailingComments
                     * @property {Array.<string>|null} [leadingDetachedComments] Location leadingDetachedComments
                     */
    
                    /**
                     * Constructs a new Location.
                     * @memberof google.protobuf.SourceCodeInfo
                     * @classdesc Represents a Location.
                     * @implements ILocation
                     * @constructor
                     * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                     */
                    function Location(properties) {
                        this.path = [];
                        this.span = [];
                        this.leadingDetachedComments = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Location path.
                     * @member {Array.<number>} path
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.path = $util.emptyArray;
    
                    /**
                     * Location span.
                     * @member {Array.<number>} span
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.span = $util.emptyArray;
    
                    /**
                     * Location leadingComments.
                     * @member {string} leadingComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.leadingComments = "";
    
                    /**
                     * Location trailingComments.
                     * @member {string} trailingComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.trailingComments = "";
    
                    /**
                     * Location leadingDetachedComments.
                     * @member {Array.<string>} leadingDetachedComments
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     */
                    Location.prototype.leadingDetachedComments = $util.emptyArray;
    
                    /**
                     * Creates a new Location instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation=} [properties] Properties to set
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location instance
                     */
                    Location.create = function create(properties) {
                        return new Location(properties);
                    };
    
                    /**
                     * Encodes the specified Location message. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Location.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.path != null && message.path.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.path.length; ++i)
                                writer.int32(message.path[i]);
                            writer.ldelim();
                        }
                        if (message.span != null && message.span.length) {
                            writer.uint32(/* id 2, wireType 2 =*/18).fork();
                            for (var i = 0; i < message.span.length; ++i)
                                writer.int32(message.span[i]);
                            writer.ldelim();
                        }
                        if (message.leadingComments != null && Object.hasOwnProperty.call(message, "leadingComments"))
                            writer.uint32(/* id 3, wireType 2 =*/26).string(message.leadingComments);
                        if (message.trailingComments != null && Object.hasOwnProperty.call(message, "trailingComments"))
                            writer.uint32(/* id 4, wireType 2 =*/34).string(message.trailingComments);
                        if (message.leadingDetachedComments != null && message.leadingDetachedComments.length)
                            for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                                writer.uint32(/* id 6, wireType 2 =*/50).string(message.leadingDetachedComments[i]);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Location message, length delimited. Does not implicitly {@link google.protobuf.SourceCodeInfo.Location.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.ILocation} message Location message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Location.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes a Location message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Location.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.SourceCodeInfo.Location();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.path && message.path.length))
                                    message.path = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.path.push(reader.int32());
                                } else
                                    message.path.push(reader.int32());
                                break;
                            case 2:
                                if (!(message.span && message.span.length))
                                    message.span = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.span.push(reader.int32());
                                } else
                                    message.span.push(reader.int32());
                                break;
                            case 3:
                                message.leadingComments = reader.string();
                                break;
                            case 4:
                                message.trailingComments = reader.string();
                                break;
                            case 6:
                                if (!(message.leadingDetachedComments && message.leadingDetachedComments.length))
                                    message.leadingDetachedComments = [];
                                message.leadingDetachedComments.push(reader.string());
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes a Location message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Location.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies a Location message.
                     * @function verify
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Location.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.path != null && message.hasOwnProperty("path")) {
                            if (!Array.isArray(message.path))
                                return "path: array expected";
                            for (var i = 0; i < message.path.length; ++i)
                                if (!$util.isInteger(message.path[i]))
                                    return "path: integer[] expected";
                        }
                        if (message.span != null && message.hasOwnProperty("span")) {
                            if (!Array.isArray(message.span))
                                return "span: array expected";
                            for (var i = 0; i < message.span.length; ++i)
                                if (!$util.isInteger(message.span[i]))
                                    return "span: integer[] expected";
                        }
                        if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                            if (!$util.isString(message.leadingComments))
                                return "leadingComments: string expected";
                        if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                            if (!$util.isString(message.trailingComments))
                                return "trailingComments: string expected";
                        if (message.leadingDetachedComments != null && message.hasOwnProperty("leadingDetachedComments")) {
                            if (!Array.isArray(message.leadingDetachedComments))
                                return "leadingDetachedComments: array expected";
                            for (var i = 0; i < message.leadingDetachedComments.length; ++i)
                                if (!$util.isString(message.leadingDetachedComments[i]))
                                    return "leadingDetachedComments: string[] expected";
                        }
                        return null;
                    };
    
                    /**
                     * Creates a Location message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.SourceCodeInfo.Location} Location
                     */
                    Location.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.SourceCodeInfo.Location)
                            return object;
                        var message = new $root.google.protobuf.SourceCodeInfo.Location();
                        if (object.path) {
                            if (!Array.isArray(object.path))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.path: array expected");
                            message.path = [];
                            for (var i = 0; i < object.path.length; ++i)
                                message.path[i] = object.path[i] | 0;
                        }
                        if (object.span) {
                            if (!Array.isArray(object.span))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.span: array expected");
                            message.span = [];
                            for (var i = 0; i < object.span.length; ++i)
                                message.span[i] = object.span[i] | 0;
                        }
                        if (object.leadingComments != null)
                            message.leadingComments = String(object.leadingComments);
                        if (object.trailingComments != null)
                            message.trailingComments = String(object.trailingComments);
                        if (object.leadingDetachedComments) {
                            if (!Array.isArray(object.leadingDetachedComments))
                                throw TypeError(".google.protobuf.SourceCodeInfo.Location.leadingDetachedComments: array expected");
                            message.leadingDetachedComments = [];
                            for (var i = 0; i < object.leadingDetachedComments.length; ++i)
                                message.leadingDetachedComments[i] = String(object.leadingDetachedComments[i]);
                        }
                        return message;
                    };
    
                    /**
                     * Creates a plain object from a Location message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @static
                     * @param {google.protobuf.SourceCodeInfo.Location} message Location
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Location.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults) {
                            object.path = [];
                            object.span = [];
                            object.leadingDetachedComments = [];
                        }
                        if (options.defaults) {
                            object.leadingComments = "";
                            object.trailingComments = "";
                        }
                        if (message.path && message.path.length) {
                            object.path = [];
                            for (var j = 0; j < message.path.length; ++j)
                                object.path[j] = message.path[j];
                        }
                        if (message.span && message.span.length) {
                            object.span = [];
                            for (var j = 0; j < message.span.length; ++j)
                                object.span[j] = message.span[j];
                        }
                        if (message.leadingComments != null && message.hasOwnProperty("leadingComments"))
                            object.leadingComments = message.leadingComments;
                        if (message.trailingComments != null && message.hasOwnProperty("trailingComments"))
                            object.trailingComments = message.trailingComments;
                        if (message.leadingDetachedComments && message.leadingDetachedComments.length) {
                            object.leadingDetachedComments = [];
                            for (var j = 0; j < message.leadingDetachedComments.length; ++j)
                                object.leadingDetachedComments[j] = message.leadingDetachedComments[j];
                        }
                        return object;
                    };
    
                    /**
                     * Converts this Location to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.SourceCodeInfo.Location
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Location.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Location;
                })();
    
                return SourceCodeInfo;
            })();
    
            protobuf.GeneratedCodeInfo = (function() {
    
                /**
                 * Properties of a GeneratedCodeInfo.
                 * @memberof google.protobuf
                 * @interface IGeneratedCodeInfo
                 * @property {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>|null} [annotation] GeneratedCodeInfo annotation
                 */
    
                /**
                 * Constructs a new GeneratedCodeInfo.
                 * @memberof google.protobuf
                 * @classdesc Represents a GeneratedCodeInfo.
                 * @implements IGeneratedCodeInfo
                 * @constructor
                 * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
                 */
                function GeneratedCodeInfo(properties) {
                    this.annotation = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * GeneratedCodeInfo annotation.
                 * @member {Array.<google.protobuf.GeneratedCodeInfo.IAnnotation>} annotation
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @instance
                 */
                GeneratedCodeInfo.prototype.annotation = $util.emptyArray;
    
                /**
                 * Creates a new GeneratedCodeInfo instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo=} [properties] Properties to set
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo instance
                 */
                GeneratedCodeInfo.create = function create(properties) {
                    return new GeneratedCodeInfo(properties);
                };
    
                /**
                 * Encodes the specified GeneratedCodeInfo message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneratedCodeInfo.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.annotation != null && message.annotation.length)
                        for (var i = 0; i < message.annotation.length; ++i)
                            $root.google.protobuf.GeneratedCodeInfo.Annotation.encode(message.annotation[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
                    return writer;
                };
    
                /**
                 * Encodes the specified GeneratedCodeInfo message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.IGeneratedCodeInfo} message GeneratedCodeInfo message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                GeneratedCodeInfo.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a GeneratedCodeInfo message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneratedCodeInfo.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.annotation && message.annotation.length))
                                message.annotation = [];
                            message.annotation.push($root.google.protobuf.GeneratedCodeInfo.Annotation.decode(reader, reader.uint32()));
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a GeneratedCodeInfo message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                GeneratedCodeInfo.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a GeneratedCodeInfo message.
                 * @function verify
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                GeneratedCodeInfo.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.annotation != null && message.hasOwnProperty("annotation")) {
                        if (!Array.isArray(message.annotation))
                            return "annotation: array expected";
                        for (var i = 0; i < message.annotation.length; ++i) {
                            var error = $root.google.protobuf.GeneratedCodeInfo.Annotation.verify(message.annotation[i]);
                            if (error)
                                return "annotation." + error;
                        }
                    }
                    return null;
                };
    
                /**
                 * Creates a GeneratedCodeInfo message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.GeneratedCodeInfo} GeneratedCodeInfo
                 */
                GeneratedCodeInfo.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.GeneratedCodeInfo)
                        return object;
                    var message = new $root.google.protobuf.GeneratedCodeInfo();
                    if (object.annotation) {
                        if (!Array.isArray(object.annotation))
                            throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: array expected");
                        message.annotation = [];
                        for (var i = 0; i < object.annotation.length; ++i) {
                            if (typeof object.annotation[i] !== "object")
                                throw TypeError(".google.protobuf.GeneratedCodeInfo.annotation: object expected");
                            message.annotation[i] = $root.google.protobuf.GeneratedCodeInfo.Annotation.fromObject(object.annotation[i]);
                        }
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a GeneratedCodeInfo message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @static
                 * @param {google.protobuf.GeneratedCodeInfo} message GeneratedCodeInfo
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                GeneratedCodeInfo.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.annotation = [];
                    if (message.annotation && message.annotation.length) {
                        object.annotation = [];
                        for (var j = 0; j < message.annotation.length; ++j)
                            object.annotation[j] = $root.google.protobuf.GeneratedCodeInfo.Annotation.toObject(message.annotation[j], options);
                    }
                    return object;
                };
    
                /**
                 * Converts this GeneratedCodeInfo to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.GeneratedCodeInfo
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                GeneratedCodeInfo.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                GeneratedCodeInfo.Annotation = (function() {
    
                    /**
                     * Properties of an Annotation.
                     * @memberof google.protobuf.GeneratedCodeInfo
                     * @interface IAnnotation
                     * @property {Array.<number>|null} [path] Annotation path
                     * @property {string|null} [sourceFile] Annotation sourceFile
                     * @property {number|null} [begin] Annotation begin
                     * @property {number|null} [end] Annotation end
                     */
    
                    /**
                     * Constructs a new Annotation.
                     * @memberof google.protobuf.GeneratedCodeInfo
                     * @classdesc Represents an Annotation.
                     * @implements IAnnotation
                     * @constructor
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                     */
                    function Annotation(properties) {
                        this.path = [];
                        if (properties)
                            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                                if (properties[keys[i]] != null)
                                    this[keys[i]] = properties[keys[i]];
                    }
    
                    /**
                     * Annotation path.
                     * @member {Array.<number>} path
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.path = $util.emptyArray;
    
                    /**
                     * Annotation sourceFile.
                     * @member {string} sourceFile
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.sourceFile = "";
    
                    /**
                     * Annotation begin.
                     * @member {number} begin
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.begin = 0;
    
                    /**
                     * Annotation end.
                     * @member {number} end
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     */
                    Annotation.prototype.end = 0;
    
                    /**
                     * Creates a new Annotation instance using the specified properties.
                     * @function create
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation=} [properties] Properties to set
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation instance
                     */
                    Annotation.create = function create(properties) {
                        return new Annotation(properties);
                    };
    
                    /**
                     * Encodes the specified Annotation message. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                     * @function encode
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Annotation.encode = function encode(message, writer) {
                        if (!writer)
                            writer = $Writer.create();
                        if (message.path != null && message.path.length) {
                            writer.uint32(/* id 1, wireType 2 =*/10).fork();
                            for (var i = 0; i < message.path.length; ++i)
                                writer.int32(message.path[i]);
                            writer.ldelim();
                        }
                        if (message.sourceFile != null && Object.hasOwnProperty.call(message, "sourceFile"))
                            writer.uint32(/* id 2, wireType 2 =*/18).string(message.sourceFile);
                        if (message.begin != null && Object.hasOwnProperty.call(message, "begin"))
                            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.begin);
                        if (message.end != null && Object.hasOwnProperty.call(message, "end"))
                            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.end);
                        return writer;
                    };
    
                    /**
                     * Encodes the specified Annotation message, length delimited. Does not implicitly {@link google.protobuf.GeneratedCodeInfo.Annotation.verify|verify} messages.
                     * @function encodeDelimited
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.IAnnotation} message Annotation message or plain object to encode
                     * @param {$protobuf.Writer} [writer] Writer to encode to
                     * @returns {$protobuf.Writer} Writer
                     */
                    Annotation.encodeDelimited = function encodeDelimited(message, writer) {
                        return this.encode(message, writer).ldelim();
                    };
    
                    /**
                     * Decodes an Annotation message from the specified reader or buffer.
                     * @function decode
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @param {number} [length] Message length if known beforehand
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Annotation.decode = function decode(reader, length) {
                        if (!(reader instanceof $Reader))
                            reader = $Reader.create(reader);
                        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                        while (reader.pos < end) {
                            var tag = reader.uint32();
                            switch (tag >>> 3) {
                            case 1:
                                if (!(message.path && message.path.length))
                                    message.path = [];
                                if ((tag & 7) === 2) {
                                    var end2 = reader.uint32() + reader.pos;
                                    while (reader.pos < end2)
                                        message.path.push(reader.int32());
                                } else
                                    message.path.push(reader.int32());
                                break;
                            case 2:
                                message.sourceFile = reader.string();
                                break;
                            case 3:
                                message.begin = reader.int32();
                                break;
                            case 4:
                                message.end = reader.int32();
                                break;
                            default:
                                reader.skipType(tag & 7);
                                break;
                            }
                        }
                        return message;
                    };
    
                    /**
                     * Decodes an Annotation message from the specified reader or buffer, length delimited.
                     * @function decodeDelimited
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     * @throws {Error} If the payload is not a reader or valid buffer
                     * @throws {$protobuf.util.ProtocolError} If required fields are missing
                     */
                    Annotation.decodeDelimited = function decodeDelimited(reader) {
                        if (!(reader instanceof $Reader))
                            reader = new $Reader(reader);
                        return this.decode(reader, reader.uint32());
                    };
    
                    /**
                     * Verifies an Annotation message.
                     * @function verify
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {Object.<string,*>} message Plain object to verify
                     * @returns {string|null} `null` if valid, otherwise the reason why it is not
                     */
                    Annotation.verify = function verify(message) {
                        if (typeof message !== "object" || message === null)
                            return "object expected";
                        if (message.path != null && message.hasOwnProperty("path")) {
                            if (!Array.isArray(message.path))
                                return "path: array expected";
                            for (var i = 0; i < message.path.length; ++i)
                                if (!$util.isInteger(message.path[i]))
                                    return "path: integer[] expected";
                        }
                        if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                            if (!$util.isString(message.sourceFile))
                                return "sourceFile: string expected";
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            if (!$util.isInteger(message.begin))
                                return "begin: integer expected";
                        if (message.end != null && message.hasOwnProperty("end"))
                            if (!$util.isInteger(message.end))
                                return "end: integer expected";
                        return null;
                    };
    
                    /**
                     * Creates an Annotation message from a plain object. Also converts values to their respective internal types.
                     * @function fromObject
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {Object.<string,*>} object Plain object
                     * @returns {google.protobuf.GeneratedCodeInfo.Annotation} Annotation
                     */
                    Annotation.fromObject = function fromObject(object) {
                        if (object instanceof $root.google.protobuf.GeneratedCodeInfo.Annotation)
                            return object;
                        var message = new $root.google.protobuf.GeneratedCodeInfo.Annotation();
                        if (object.path) {
                            if (!Array.isArray(object.path))
                                throw TypeError(".google.protobuf.GeneratedCodeInfo.Annotation.path: array expected");
                            message.path = [];
                            for (var i = 0; i < object.path.length; ++i)
                                message.path[i] = object.path[i] | 0;
                        }
                        if (object.sourceFile != null)
                            message.sourceFile = String(object.sourceFile);
                        if (object.begin != null)
                            message.begin = object.begin | 0;
                        if (object.end != null)
                            message.end = object.end | 0;
                        return message;
                    };
    
                    /**
                     * Creates a plain object from an Annotation message. Also converts values to other types if specified.
                     * @function toObject
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @static
                     * @param {google.protobuf.GeneratedCodeInfo.Annotation} message Annotation
                     * @param {$protobuf.IConversionOptions} [options] Conversion options
                     * @returns {Object.<string,*>} Plain object
                     */
                    Annotation.toObject = function toObject(message, options) {
                        if (!options)
                            options = {};
                        var object = {};
                        if (options.arrays || options.defaults)
                            object.path = [];
                        if (options.defaults) {
                            object.sourceFile = "";
                            object.begin = 0;
                            object.end = 0;
                        }
                        if (message.path && message.path.length) {
                            object.path = [];
                            for (var j = 0; j < message.path.length; ++j)
                                object.path[j] = message.path[j];
                        }
                        if (message.sourceFile != null && message.hasOwnProperty("sourceFile"))
                            object.sourceFile = message.sourceFile;
                        if (message.begin != null && message.hasOwnProperty("begin"))
                            object.begin = message.begin;
                        if (message.end != null && message.hasOwnProperty("end"))
                            object.end = message.end;
                        return object;
                    };
    
                    /**
                     * Converts this Annotation to JSON.
                     * @function toJSON
                     * @memberof google.protobuf.GeneratedCodeInfo.Annotation
                     * @instance
                     * @returns {Object.<string,*>} JSON object
                     */
                    Annotation.prototype.toJSON = function toJSON() {
                        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                    };
    
                    return Annotation;
                })();
    
                return GeneratedCodeInfo;
            })();
    
            protobuf.Timestamp = (function() {
    
                /**
                 * Properties of a Timestamp.
                 * @memberof google.protobuf
                 * @interface ITimestamp
                 * @property {number|null} [seconds] Timestamp seconds
                 * @property {number|null} [nanos] Timestamp nanos
                 */
    
                /**
                 * Constructs a new Timestamp.
                 * @memberof google.protobuf
                 * @classdesc Represents a Timestamp.
                 * @implements ITimestamp
                 * @constructor
                 * @param {google.protobuf.ITimestamp=} [properties] Properties to set
                 */
                function Timestamp(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Timestamp seconds.
                 * @member {number} seconds
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 */
                Timestamp.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Timestamp nanos.
                 * @member {number} nanos
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 */
                Timestamp.prototype.nanos = 0;
    
                /**
                 * Creates a new Timestamp instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp=} [properties] Properties to set
                 * @returns {google.protobuf.Timestamp} Timestamp instance
                 */
                Timestamp.create = function create(properties) {
                    return new Timestamp(properties);
                };
    
                /**
                 * Encodes the specified Timestamp message. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Timestamp.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                    if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                    return writer;
                };
    
                /**
                 * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link google.protobuf.Timestamp.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.ITimestamp} message Timestamp message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Timestamp message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Timestamp} Timestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Timestamp.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Timestamp();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.seconds = reader.int64();
                            break;
                        case 2:
                            message.nanos = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Timestamp message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Timestamp} Timestamp
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Timestamp.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Timestamp message.
                 * @function verify
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Timestamp.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                            return "seconds: integer|Long expected";
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        if (!$util.isInteger(message.nanos))
                            return "nanos: integer expected";
                    return null;
                };
    
                /**
                 * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Timestamp} Timestamp
                 */
                Timestamp.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Timestamp)
                        return object;
                    var message = new $root.google.protobuf.Timestamp();
                    if (object.seconds != null)
                        if ($util.Long)
                            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                        else if (typeof object.seconds === "string")
                            message.seconds = parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                    if (object.nanos != null)
                        message.nanos = object.nanos | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Timestamp
                 * @static
                 * @param {google.protobuf.Timestamp} message Timestamp
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Timestamp.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.seconds = options.longs === String ? "0" : 0;
                        object.nanos = 0;
                    }
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (typeof message.seconds === "number")
                            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                        else
                            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        object.nanos = message.nanos;
                    return object;
                };
    
                /**
                 * Converts this Timestamp to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Timestamp
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Timestamp.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Timestamp;
            })();
    
            protobuf.Empty = (function() {
    
                /**
                 * Properties of an Empty.
                 * @memberof google.protobuf
                 * @interface IEmpty
                 */
    
                /**
                 * Constructs a new Empty.
                 * @memberof google.protobuf
                 * @classdesc Represents an Empty.
                 * @implements IEmpty
                 * @constructor
                 * @param {google.protobuf.IEmpty=} [properties] Properties to set
                 */
                function Empty(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Creates a new Empty instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty=} [properties] Properties to set
                 * @returns {google.protobuf.Empty} Empty instance
                 */
                Empty.create = function create(properties) {
                    return new Empty(properties);
                };
    
                /**
                 * Encodes the specified Empty message. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Empty.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    return writer;
                };
    
                /**
                 * Encodes the specified Empty message, length delimited. Does not implicitly {@link google.protobuf.Empty.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.IEmpty} message Empty message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Empty.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Empty message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Empty} Empty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Empty.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Empty();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Empty message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Empty} Empty
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Empty.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Empty message.
                 * @function verify
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Empty.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    return null;
                };
    
                /**
                 * Creates an Empty message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Empty} Empty
                 */
                Empty.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Empty)
                        return object;
                    return new $root.google.protobuf.Empty();
                };
    
                /**
                 * Creates a plain object from an Empty message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Empty
                 * @static
                 * @param {google.protobuf.Empty} message Empty
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Empty.toObject = function toObject() {
                    return {};
                };
    
                /**
                 * Converts this Empty to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Empty
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Empty.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Empty;
            })();
    
            protobuf.FieldMask = (function() {
    
                /**
                 * Properties of a FieldMask.
                 * @memberof google.protobuf
                 * @interface IFieldMask
                 * @property {Array.<string>|null} [paths] FieldMask paths
                 */
    
                /**
                 * Constructs a new FieldMask.
                 * @memberof google.protobuf
                 * @classdesc Represents a FieldMask.
                 * @implements IFieldMask
                 * @constructor
                 * @param {google.protobuf.IFieldMask=} [properties] Properties to set
                 */
                function FieldMask(properties) {
                    this.paths = [];
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FieldMask paths.
                 * @member {Array.<string>} paths
                 * @memberof google.protobuf.FieldMask
                 * @instance
                 */
                FieldMask.prototype.paths = $util.emptyArray;
    
                /**
                 * Creates a new FieldMask instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {google.protobuf.IFieldMask=} [properties] Properties to set
                 * @returns {google.protobuf.FieldMask} FieldMask instance
                 */
                FieldMask.create = function create(properties) {
                    return new FieldMask(properties);
                };
    
                /**
                 * Encodes the specified FieldMask message. Does not implicitly {@link google.protobuf.FieldMask.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {google.protobuf.IFieldMask} message FieldMask message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldMask.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.paths != null && message.paths.length)
                        for (var i = 0; i < message.paths.length; ++i)
                            writer.uint32(/* id 1, wireType 2 =*/10).string(message.paths[i]);
                    return writer;
                };
    
                /**
                 * Encodes the specified FieldMask message, length delimited. Does not implicitly {@link google.protobuf.FieldMask.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {google.protobuf.IFieldMask} message FieldMask message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FieldMask.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FieldMask message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FieldMask} FieldMask
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldMask.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FieldMask();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            if (!(message.paths && message.paths.length))
                                message.paths = [];
                            message.paths.push(reader.string());
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FieldMask message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FieldMask} FieldMask
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FieldMask.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FieldMask message.
                 * @function verify
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FieldMask.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.paths != null && message.hasOwnProperty("paths")) {
                        if (!Array.isArray(message.paths))
                            return "paths: array expected";
                        for (var i = 0; i < message.paths.length; ++i)
                            if (!$util.isString(message.paths[i]))
                                return "paths: string[] expected";
                    }
                    return null;
                };
    
                /**
                 * Creates a FieldMask message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FieldMask} FieldMask
                 */
                FieldMask.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FieldMask)
                        return object;
                    var message = new $root.google.protobuf.FieldMask();
                    if (object.paths) {
                        if (!Array.isArray(object.paths))
                            throw TypeError(".google.protobuf.FieldMask.paths: array expected");
                        message.paths = [];
                        for (var i = 0; i < object.paths.length; ++i)
                            message.paths[i] = String(object.paths[i]);
                    }
                    return message;
                };
    
                /**
                 * Creates a plain object from a FieldMask message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FieldMask
                 * @static
                 * @param {google.protobuf.FieldMask} message FieldMask
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FieldMask.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.arrays || options.defaults)
                        object.paths = [];
                    if (message.paths && message.paths.length) {
                        object.paths = [];
                        for (var j = 0; j < message.paths.length; ++j)
                            object.paths[j] = message.paths[j];
                    }
                    return object;
                };
    
                /**
                 * Converts this FieldMask to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FieldMask
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FieldMask.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FieldMask;
            })();
    
            protobuf.Duration = (function() {
    
                /**
                 * Properties of a Duration.
                 * @memberof google.protobuf
                 * @interface IDuration
                 * @property {number|null} [seconds] Duration seconds
                 * @property {number|null} [nanos] Duration nanos
                 */
    
                /**
                 * Constructs a new Duration.
                 * @memberof google.protobuf
                 * @classdesc Represents a Duration.
                 * @implements IDuration
                 * @constructor
                 * @param {google.protobuf.IDuration=} [properties] Properties to set
                 */
                function Duration(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Duration seconds.
                 * @member {number} seconds
                 * @memberof google.protobuf.Duration
                 * @instance
                 */
                Duration.prototype.seconds = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Duration nanos.
                 * @member {number} nanos
                 * @memberof google.protobuf.Duration
                 * @instance
                 */
                Duration.prototype.nanos = 0;
    
                /**
                 * Creates a new Duration instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration=} [properties] Properties to set
                 * @returns {google.protobuf.Duration} Duration instance
                 */
                Duration.create = function create(properties) {
                    return new Duration(properties);
                };
    
                /**
                 * Encodes the specified Duration message. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration} message Duration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Duration.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.seconds != null && Object.hasOwnProperty.call(message, "seconds"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.seconds);
                    if (message.nanos != null && Object.hasOwnProperty.call(message, "nanos"))
                        writer.uint32(/* id 2, wireType 0 =*/16).int32(message.nanos);
                    return writer;
                };
    
                /**
                 * Encodes the specified Duration message, length delimited. Does not implicitly {@link google.protobuf.Duration.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.IDuration} message Duration message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Duration.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a Duration message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Duration} Duration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Duration.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Duration();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.seconds = reader.int64();
                            break;
                        case 2:
                            message.nanos = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a Duration message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Duration} Duration
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Duration.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a Duration message.
                 * @function verify
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Duration.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (!$util.isInteger(message.seconds) && !(message.seconds && $util.isInteger(message.seconds.low) && $util.isInteger(message.seconds.high)))
                            return "seconds: integer|Long expected";
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        if (!$util.isInteger(message.nanos))
                            return "nanos: integer expected";
                    return null;
                };
    
                /**
                 * Creates a Duration message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Duration} Duration
                 */
                Duration.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Duration)
                        return object;
                    var message = new $root.google.protobuf.Duration();
                    if (object.seconds != null)
                        if ($util.Long)
                            (message.seconds = $util.Long.fromValue(object.seconds)).unsigned = false;
                        else if (typeof object.seconds === "string")
                            message.seconds = parseInt(object.seconds, 10);
                        else if (typeof object.seconds === "number")
                            message.seconds = object.seconds;
                        else if (typeof object.seconds === "object")
                            message.seconds = new $util.LongBits(object.seconds.low >>> 0, object.seconds.high >>> 0).toNumber();
                    if (object.nanos != null)
                        message.nanos = object.nanos | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a Duration message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Duration
                 * @static
                 * @param {google.protobuf.Duration} message Duration
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Duration.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults) {
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.seconds = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.seconds = options.longs === String ? "0" : 0;
                        object.nanos = 0;
                    }
                    if (message.seconds != null && message.hasOwnProperty("seconds"))
                        if (typeof message.seconds === "number")
                            object.seconds = options.longs === String ? String(message.seconds) : message.seconds;
                        else
                            object.seconds = options.longs === String ? $util.Long.prototype.toString.call(message.seconds) : options.longs === Number ? new $util.LongBits(message.seconds.low >>> 0, message.seconds.high >>> 0).toNumber() : message.seconds;
                    if (message.nanos != null && message.hasOwnProperty("nanos"))
                        object.nanos = message.nanos;
                    return object;
                };
    
                /**
                 * Converts this Duration to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Duration
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Duration.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Duration;
            })();
    
            protobuf.DoubleValue = (function() {
    
                /**
                 * Properties of a DoubleValue.
                 * @memberof google.protobuf
                 * @interface IDoubleValue
                 * @property {number|null} [value] DoubleValue value
                 */
    
                /**
                 * Constructs a new DoubleValue.
                 * @memberof google.protobuf
                 * @classdesc Represents a DoubleValue.
                 * @implements IDoubleValue
                 * @constructor
                 * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
                 */
                function DoubleValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * DoubleValue value.
                 * @member {number} value
                 * @memberof google.protobuf.DoubleValue
                 * @instance
                 */
                DoubleValue.prototype.value = 0;
    
                /**
                 * Creates a new DoubleValue instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {google.protobuf.IDoubleValue=} [properties] Properties to set
                 * @returns {google.protobuf.DoubleValue} DoubleValue instance
                 */
                DoubleValue.create = function create(properties) {
                    return new DoubleValue(properties);
                };
    
                /**
                 * Encodes the specified DoubleValue message. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DoubleValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 1 =*/9).double(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified DoubleValue message, length delimited. Does not implicitly {@link google.protobuf.DoubleValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {google.protobuf.IDoubleValue} message DoubleValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                DoubleValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a DoubleValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.DoubleValue} DoubleValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DoubleValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.DoubleValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.double();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a DoubleValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.DoubleValue} DoubleValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                DoubleValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a DoubleValue message.
                 * @function verify
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                DoubleValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (typeof message.value !== "number")
                            return "value: number expected";
                    return null;
                };
    
                /**
                 * Creates a DoubleValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.DoubleValue} DoubleValue
                 */
                DoubleValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.DoubleValue)
                        return object;
                    var message = new $root.google.protobuf.DoubleValue();
                    if (object.value != null)
                        message.value = Number(object.value);
                    return message;
                };
    
                /**
                 * Creates a plain object from a DoubleValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.DoubleValue
                 * @static
                 * @param {google.protobuf.DoubleValue} message DoubleValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                DoubleValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                    return object;
                };
    
                /**
                 * Converts this DoubleValue to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.DoubleValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                DoubleValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return DoubleValue;
            })();
    
            protobuf.FloatValue = (function() {
    
                /**
                 * Properties of a FloatValue.
                 * @memberof google.protobuf
                 * @interface IFloatValue
                 * @property {number|null} [value] FloatValue value
                 */
    
                /**
                 * Constructs a new FloatValue.
                 * @memberof google.protobuf
                 * @classdesc Represents a FloatValue.
                 * @implements IFloatValue
                 * @constructor
                 * @param {google.protobuf.IFloatValue=} [properties] Properties to set
                 */
                function FloatValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * FloatValue value.
                 * @member {number} value
                 * @memberof google.protobuf.FloatValue
                 * @instance
                 */
                FloatValue.prototype.value = 0;
    
                /**
                 * Creates a new FloatValue instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {google.protobuf.IFloatValue=} [properties] Properties to set
                 * @returns {google.protobuf.FloatValue} FloatValue instance
                 */
                FloatValue.create = function create(properties) {
                    return new FloatValue(properties);
                };
    
                /**
                 * Encodes the specified FloatValue message. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FloatValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 5 =*/13).float(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified FloatValue message, length delimited. Does not implicitly {@link google.protobuf.FloatValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {google.protobuf.IFloatValue} message FloatValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                FloatValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a FloatValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.FloatValue} FloatValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FloatValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.FloatValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.float();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a FloatValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.FloatValue} FloatValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                FloatValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a FloatValue message.
                 * @function verify
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                FloatValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (typeof message.value !== "number")
                            return "value: number expected";
                    return null;
                };
    
                /**
                 * Creates a FloatValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.FloatValue} FloatValue
                 */
                FloatValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.FloatValue)
                        return object;
                    var message = new $root.google.protobuf.FloatValue();
                    if (object.value != null)
                        message.value = Number(object.value);
                    return message;
                };
    
                /**
                 * Creates a plain object from a FloatValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.FloatValue
                 * @static
                 * @param {google.protobuf.FloatValue} message FloatValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                FloatValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = options.json && !isFinite(message.value) ? String(message.value) : message.value;
                    return object;
                };
    
                /**
                 * Converts this FloatValue to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.FloatValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                FloatValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return FloatValue;
            })();
    
            protobuf.Int64Value = (function() {
    
                /**
                 * Properties of an Int64Value.
                 * @memberof google.protobuf
                 * @interface IInt64Value
                 * @property {number|null} [value] Int64Value value
                 */
    
                /**
                 * Constructs a new Int64Value.
                 * @memberof google.protobuf
                 * @classdesc Represents an Int64Value.
                 * @implements IInt64Value
                 * @constructor
                 * @param {google.protobuf.IInt64Value=} [properties] Properties to set
                 */
                function Int64Value(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Int64Value value.
                 * @member {number} value
                 * @memberof google.protobuf.Int64Value
                 * @instance
                 */
                Int64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;
    
                /**
                 * Creates a new Int64Value instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {google.protobuf.IInt64Value=} [properties] Properties to set
                 * @returns {google.protobuf.Int64Value} Int64Value instance
                 */
                Int64Value.create = function create(properties) {
                    return new Int64Value(properties);
                };
    
                /**
                 * Encodes the specified Int64Value message. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Int64Value.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int64(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified Int64Value message, length delimited. Does not implicitly {@link google.protobuf.Int64Value.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {google.protobuf.IInt64Value} message Int64Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Int64Value.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Int64Value message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Int64Value} Int64Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Int64Value.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int64Value();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.int64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Int64Value message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Int64Value} Int64Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Int64Value.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Int64Value message.
                 * @function verify
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Int64Value.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                            return "value: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates an Int64Value message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Int64Value} Int64Value
                 */
                Int64Value.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Int64Value)
                        return object;
                    var message = new $root.google.protobuf.Int64Value();
                    if (object.value != null)
                        if ($util.Long)
                            (message.value = $util.Long.fromValue(object.value)).unsigned = false;
                        else if (typeof object.value === "string")
                            message.value = parseInt(object.value, 10);
                        else if (typeof object.value === "number")
                            message.value = object.value;
                        else if (typeof object.value === "object")
                            message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber();
                    return message;
                };
    
                /**
                 * Creates a plain object from an Int64Value message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Int64Value
                 * @static
                 * @param {google.protobuf.Int64Value} message Int64Value
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Int64Value.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, false);
                            object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.value = options.longs === String ? "0" : 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (typeof message.value === "number")
                            object.value = options.longs === String ? String(message.value) : message.value;
                        else
                            object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber() : message.value;
                    return object;
                };
    
                /**
                 * Converts this Int64Value to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Int64Value
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Int64Value.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Int64Value;
            })();
    
            protobuf.UInt64Value = (function() {
    
                /**
                 * Properties of a UInt64Value.
                 * @memberof google.protobuf
                 * @interface IUInt64Value
                 * @property {number|null} [value] UInt64Value value
                 */
    
                /**
                 * Constructs a new UInt64Value.
                 * @memberof google.protobuf
                 * @classdesc Represents a UInt64Value.
                 * @implements IUInt64Value
                 * @constructor
                 * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
                 */
                function UInt64Value(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * UInt64Value value.
                 * @member {number} value
                 * @memberof google.protobuf.UInt64Value
                 * @instance
                 */
                UInt64Value.prototype.value = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
    
                /**
                 * Creates a new UInt64Value instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {google.protobuf.IUInt64Value=} [properties] Properties to set
                 * @returns {google.protobuf.UInt64Value} UInt64Value instance
                 */
                UInt64Value.create = function create(properties) {
                    return new UInt64Value(properties);
                };
    
                /**
                 * Encodes the specified UInt64Value message. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UInt64Value.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified UInt64Value message, length delimited. Does not implicitly {@link google.protobuf.UInt64Value.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {google.protobuf.IUInt64Value} message UInt64Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UInt64Value.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a UInt64Value message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.UInt64Value} UInt64Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UInt64Value.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt64Value();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.uint64();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a UInt64Value message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.UInt64Value} UInt64Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UInt64Value.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a UInt64Value message.
                 * @function verify
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UInt64Value.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isInteger(message.value) && !(message.value && $util.isInteger(message.value.low) && $util.isInteger(message.value.high)))
                            return "value: integer|Long expected";
                    return null;
                };
    
                /**
                 * Creates a UInt64Value message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.UInt64Value} UInt64Value
                 */
                UInt64Value.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UInt64Value)
                        return object;
                    var message = new $root.google.protobuf.UInt64Value();
                    if (object.value != null)
                        if ($util.Long)
                            (message.value = $util.Long.fromValue(object.value)).unsigned = true;
                        else if (typeof object.value === "string")
                            message.value = parseInt(object.value, 10);
                        else if (typeof object.value === "number")
                            message.value = object.value;
                        else if (typeof object.value === "object")
                            message.value = new $util.LongBits(object.value.low >>> 0, object.value.high >>> 0).toNumber(true);
                    return message;
                };
    
                /**
                 * Creates a plain object from a UInt64Value message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.UInt64Value
                 * @static
                 * @param {google.protobuf.UInt64Value} message UInt64Value
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UInt64Value.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        if ($util.Long) {
                            var long = new $util.Long(0, 0, true);
                            object.value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                        } else
                            object.value = options.longs === String ? "0" : 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (typeof message.value === "number")
                            object.value = options.longs === String ? String(message.value) : message.value;
                        else
                            object.value = options.longs === String ? $util.Long.prototype.toString.call(message.value) : options.longs === Number ? new $util.LongBits(message.value.low >>> 0, message.value.high >>> 0).toNumber(true) : message.value;
                    return object;
                };
    
                /**
                 * Converts this UInt64Value to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.UInt64Value
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UInt64Value.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return UInt64Value;
            })();
    
            protobuf.Int32Value = (function() {
    
                /**
                 * Properties of an Int32Value.
                 * @memberof google.protobuf
                 * @interface IInt32Value
                 * @property {number|null} [value] Int32Value value
                 */
    
                /**
                 * Constructs a new Int32Value.
                 * @memberof google.protobuf
                 * @classdesc Represents an Int32Value.
                 * @implements IInt32Value
                 * @constructor
                 * @param {google.protobuf.IInt32Value=} [properties] Properties to set
                 */
                function Int32Value(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * Int32Value value.
                 * @member {number} value
                 * @memberof google.protobuf.Int32Value
                 * @instance
                 */
                Int32Value.prototype.value = 0;
    
                /**
                 * Creates a new Int32Value instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {google.protobuf.IInt32Value=} [properties] Properties to set
                 * @returns {google.protobuf.Int32Value} Int32Value instance
                 */
                Int32Value.create = function create(properties) {
                    return new Int32Value(properties);
                };
    
                /**
                 * Encodes the specified Int32Value message. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Int32Value.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 0 =*/8).int32(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified Int32Value message, length delimited. Does not implicitly {@link google.protobuf.Int32Value.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {google.protobuf.IInt32Value} message Int32Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                Int32Value.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes an Int32Value message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.Int32Value} Int32Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Int32Value.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.Int32Value();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.int32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes an Int32Value message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.Int32Value} Int32Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                Int32Value.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies an Int32Value message.
                 * @function verify
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                Int32Value.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isInteger(message.value))
                            return "value: integer expected";
                    return null;
                };
    
                /**
                 * Creates an Int32Value message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.Int32Value} Int32Value
                 */
                Int32Value.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.Int32Value)
                        return object;
                    var message = new $root.google.protobuf.Int32Value();
                    if (object.value != null)
                        message.value = object.value | 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from an Int32Value message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.Int32Value
                 * @static
                 * @param {google.protobuf.Int32Value} message Int32Value
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                Int32Value.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    return object;
                };
    
                /**
                 * Converts this Int32Value to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.Int32Value
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                Int32Value.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return Int32Value;
            })();
    
            protobuf.UInt32Value = (function() {
    
                /**
                 * Properties of a UInt32Value.
                 * @memberof google.protobuf
                 * @interface IUInt32Value
                 * @property {number|null} [value] UInt32Value value
                 */
    
                /**
                 * Constructs a new UInt32Value.
                 * @memberof google.protobuf
                 * @classdesc Represents a UInt32Value.
                 * @implements IUInt32Value
                 * @constructor
                 * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
                 */
                function UInt32Value(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * UInt32Value value.
                 * @member {number} value
                 * @memberof google.protobuf.UInt32Value
                 * @instance
                 */
                UInt32Value.prototype.value = 0;
    
                /**
                 * Creates a new UInt32Value instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {google.protobuf.IUInt32Value=} [properties] Properties to set
                 * @returns {google.protobuf.UInt32Value} UInt32Value instance
                 */
                UInt32Value.create = function create(properties) {
                    return new UInt32Value(properties);
                };
    
                /**
                 * Encodes the specified UInt32Value message. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UInt32Value.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 0 =*/8).uint32(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified UInt32Value message, length delimited. Does not implicitly {@link google.protobuf.UInt32Value.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {google.protobuf.IUInt32Value} message UInt32Value message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                UInt32Value.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a UInt32Value message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.UInt32Value} UInt32Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UInt32Value.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.UInt32Value();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.uint32();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a UInt32Value message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.UInt32Value} UInt32Value
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                UInt32Value.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a UInt32Value message.
                 * @function verify
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                UInt32Value.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isInteger(message.value))
                            return "value: integer expected";
                    return null;
                };
    
                /**
                 * Creates a UInt32Value message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.UInt32Value} UInt32Value
                 */
                UInt32Value.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.UInt32Value)
                        return object;
                    var message = new $root.google.protobuf.UInt32Value();
                    if (object.value != null)
                        message.value = object.value >>> 0;
                    return message;
                };
    
                /**
                 * Creates a plain object from a UInt32Value message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.UInt32Value
                 * @static
                 * @param {google.protobuf.UInt32Value} message UInt32Value
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                UInt32Value.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = 0;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    return object;
                };
    
                /**
                 * Converts this UInt32Value to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.UInt32Value
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                UInt32Value.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return UInt32Value;
            })();
    
            protobuf.BoolValue = (function() {
    
                /**
                 * Properties of a BoolValue.
                 * @memberof google.protobuf
                 * @interface IBoolValue
                 * @property {boolean|null} [value] BoolValue value
                 */
    
                /**
                 * Constructs a new BoolValue.
                 * @memberof google.protobuf
                 * @classdesc Represents a BoolValue.
                 * @implements IBoolValue
                 * @constructor
                 * @param {google.protobuf.IBoolValue=} [properties] Properties to set
                 */
                function BoolValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * BoolValue value.
                 * @member {boolean} value
                 * @memberof google.protobuf.BoolValue
                 * @instance
                 */
                BoolValue.prototype.value = false;
    
                /**
                 * Creates a new BoolValue instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {google.protobuf.IBoolValue=} [properties] Properties to set
                 * @returns {google.protobuf.BoolValue} BoolValue instance
                 */
                BoolValue.create = function create(properties) {
                    return new BoolValue(properties);
                };
    
                /**
                 * Encodes the specified BoolValue message. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BoolValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 0 =*/8).bool(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified BoolValue message, length delimited. Does not implicitly {@link google.protobuf.BoolValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {google.protobuf.IBoolValue} message BoolValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BoolValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a BoolValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.BoolValue} BoolValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BoolValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BoolValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.bool();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a BoolValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.BoolValue} BoolValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BoolValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a BoolValue message.
                 * @function verify
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BoolValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (typeof message.value !== "boolean")
                            return "value: boolean expected";
                    return null;
                };
    
                /**
                 * Creates a BoolValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.BoolValue} BoolValue
                 */
                BoolValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.BoolValue)
                        return object;
                    var message = new $root.google.protobuf.BoolValue();
                    if (object.value != null)
                        message.value = Boolean(object.value);
                    return message;
                };
    
                /**
                 * Creates a plain object from a BoolValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.BoolValue
                 * @static
                 * @param {google.protobuf.BoolValue} message BoolValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BoolValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = false;
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    return object;
                };
    
                /**
                 * Converts this BoolValue to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.BoolValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BoolValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return BoolValue;
            })();
    
            protobuf.StringValue = (function() {
    
                /**
                 * Properties of a StringValue.
                 * @memberof google.protobuf
                 * @interface IStringValue
                 * @property {string|null} [value] StringValue value
                 */
    
                /**
                 * Constructs a new StringValue.
                 * @memberof google.protobuf
                 * @classdesc Represents a StringValue.
                 * @implements IStringValue
                 * @constructor
                 * @param {google.protobuf.IStringValue=} [properties] Properties to set
                 */
                function StringValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * StringValue value.
                 * @member {string} value
                 * @memberof google.protobuf.StringValue
                 * @instance
                 */
                StringValue.prototype.value = "";
    
                /**
                 * Creates a new StringValue instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {google.protobuf.IStringValue=} [properties] Properties to set
                 * @returns {google.protobuf.StringValue} StringValue instance
                 */
                StringValue.create = function create(properties) {
                    return new StringValue(properties);
                };
    
                /**
                 * Encodes the specified StringValue message. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StringValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 2 =*/10).string(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified StringValue message, length delimited. Does not implicitly {@link google.protobuf.StringValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {google.protobuf.IStringValue} message StringValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                StringValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a StringValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.StringValue} StringValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StringValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.StringValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.string();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a StringValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.StringValue} StringValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                StringValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a StringValue message.
                 * @function verify
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                StringValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!$util.isString(message.value))
                            return "value: string expected";
                    return null;
                };
    
                /**
                 * Creates a StringValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.StringValue} StringValue
                 */
                StringValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.StringValue)
                        return object;
                    var message = new $root.google.protobuf.StringValue();
                    if (object.value != null)
                        message.value = String(object.value);
                    return message;
                };
    
                /**
                 * Creates a plain object from a StringValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.StringValue
                 * @static
                 * @param {google.protobuf.StringValue} message StringValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                StringValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        object.value = "";
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = message.value;
                    return object;
                };
    
                /**
                 * Converts this StringValue to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.StringValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                StringValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return StringValue;
            })();
    
            protobuf.BytesValue = (function() {
    
                /**
                 * Properties of a BytesValue.
                 * @memberof google.protobuf
                 * @interface IBytesValue
                 * @property {Uint8Array|null} [value] BytesValue value
                 */
    
                /**
                 * Constructs a new BytesValue.
                 * @memberof google.protobuf
                 * @classdesc Represents a BytesValue.
                 * @implements IBytesValue
                 * @constructor
                 * @param {google.protobuf.IBytesValue=} [properties] Properties to set
                 */
                function BytesValue(properties) {
                    if (properties)
                        for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                            if (properties[keys[i]] != null)
                                this[keys[i]] = properties[keys[i]];
                }
    
                /**
                 * BytesValue value.
                 * @member {Uint8Array} value
                 * @memberof google.protobuf.BytesValue
                 * @instance
                 */
                BytesValue.prototype.value = $util.newBuffer([]);
    
                /**
                 * Creates a new BytesValue instance using the specified properties.
                 * @function create
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {google.protobuf.IBytesValue=} [properties] Properties to set
                 * @returns {google.protobuf.BytesValue} BytesValue instance
                 */
                BytesValue.create = function create(properties) {
                    return new BytesValue(properties);
                };
    
                /**
                 * Encodes the specified BytesValue message. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
                 * @function encode
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BytesValue.encode = function encode(message, writer) {
                    if (!writer)
                        writer = $Writer.create();
                    if (message.value != null && Object.hasOwnProperty.call(message, "value"))
                        writer.uint32(/* id 1, wireType 2 =*/10).bytes(message.value);
                    return writer;
                };
    
                /**
                 * Encodes the specified BytesValue message, length delimited. Does not implicitly {@link google.protobuf.BytesValue.verify|verify} messages.
                 * @function encodeDelimited
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {google.protobuf.IBytesValue} message BytesValue message or plain object to encode
                 * @param {$protobuf.Writer} [writer] Writer to encode to
                 * @returns {$protobuf.Writer} Writer
                 */
                BytesValue.encodeDelimited = function encodeDelimited(message, writer) {
                    return this.encode(message, writer).ldelim();
                };
    
                /**
                 * Decodes a BytesValue message from the specified reader or buffer.
                 * @function decode
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @param {number} [length] Message length if known beforehand
                 * @returns {google.protobuf.BytesValue} BytesValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BytesValue.decode = function decode(reader, length) {
                    if (!(reader instanceof $Reader))
                        reader = $Reader.create(reader);
                    var end = length === undefined ? reader.len : reader.pos + length, message = new $root.google.protobuf.BytesValue();
                    while (reader.pos < end) {
                        var tag = reader.uint32();
                        switch (tag >>> 3) {
                        case 1:
                            message.value = reader.bytes();
                            break;
                        default:
                            reader.skipType(tag & 7);
                            break;
                        }
                    }
                    return message;
                };
    
                /**
                 * Decodes a BytesValue message from the specified reader or buffer, length delimited.
                 * @function decodeDelimited
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
                 * @returns {google.protobuf.BytesValue} BytesValue
                 * @throws {Error} If the payload is not a reader or valid buffer
                 * @throws {$protobuf.util.ProtocolError} If required fields are missing
                 */
                BytesValue.decodeDelimited = function decodeDelimited(reader) {
                    if (!(reader instanceof $Reader))
                        reader = new $Reader(reader);
                    return this.decode(reader, reader.uint32());
                };
    
                /**
                 * Verifies a BytesValue message.
                 * @function verify
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {Object.<string,*>} message Plain object to verify
                 * @returns {string|null} `null` if valid, otherwise the reason why it is not
                 */
                BytesValue.verify = function verify(message) {
                    if (typeof message !== "object" || message === null)
                        return "object expected";
                    if (message.value != null && message.hasOwnProperty("value"))
                        if (!(message.value && typeof message.value.length === "number" || $util.isString(message.value)))
                            return "value: buffer expected";
                    return null;
                };
    
                /**
                 * Creates a BytesValue message from a plain object. Also converts values to their respective internal types.
                 * @function fromObject
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {Object.<string,*>} object Plain object
                 * @returns {google.protobuf.BytesValue} BytesValue
                 */
                BytesValue.fromObject = function fromObject(object) {
                    if (object instanceof $root.google.protobuf.BytesValue)
                        return object;
                    var message = new $root.google.protobuf.BytesValue();
                    if (object.value != null)
                        if (typeof object.value === "string")
                            $util.base64.decode(object.value, message.value = $util.newBuffer($util.base64.length(object.value)), 0);
                        else if (object.value.length)
                            message.value = object.value;
                    return message;
                };
    
                /**
                 * Creates a plain object from a BytesValue message. Also converts values to other types if specified.
                 * @function toObject
                 * @memberof google.protobuf.BytesValue
                 * @static
                 * @param {google.protobuf.BytesValue} message BytesValue
                 * @param {$protobuf.IConversionOptions} [options] Conversion options
                 * @returns {Object.<string,*>} Plain object
                 */
                BytesValue.toObject = function toObject(message, options) {
                    if (!options)
                        options = {};
                    var object = {};
                    if (options.defaults)
                        if (options.bytes === String)
                            object.value = "";
                        else {
                            object.value = [];
                            if (options.bytes !== Array)
                                object.value = $util.newBuffer(object.value);
                        }
                    if (message.value != null && message.hasOwnProperty("value"))
                        object.value = options.bytes === String ? $util.base64.encode(message.value, 0, message.value.length) : options.bytes === Array ? Array.prototype.slice.call(message.value) : message.value;
                    return object;
                };
    
                /**
                 * Converts this BytesValue to JSON.
                 * @function toJSON
                 * @memberof google.protobuf.BytesValue
                 * @instance
                 * @returns {Object.<string,*>} JSON object
                 */
                BytesValue.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };
    
                return BytesValue;
            })();
    
            return protobuf;
        })();
    
        return google;
    })();

    return $root;
});
